
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc28"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc28"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("juFEH", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $92209f148b99825a$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $92209f148b99825a$export$d8f52e8f804021e8);
$parcel$export(module.exports, "segmentUnmountCache", () => $92209f148b99825a$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $92209f148b99825a$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $92209f148b99825a$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $92209f148b99825a$export$e4380431c2bdabee);
$parcel$export(module.exports, "addExcluded3pSegment", () => $92209f148b99825a$export$9bfdf89f35702b2e);
$parcel$export(module.exports, "addSegmentExtraData", () => $92209f148b99825a$export$35723c3772fda7dd);
$parcel$export(module.exports, "addIframeSegmentData", () => $92209f148b99825a$export$c227d812a1e08d80);
$parcel$export(module.exports, "addCustomTiming", () => $92209f148b99825a$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $92209f148b99825a$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $92209f148b99825a$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $92209f148b99825a$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $92209f148b99825a$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $92209f148b99825a$export$10582acd678c213);
$parcel$export(module.exports, "addCompletedHold", () => $92209f148b99825a$export$d6cf9650acfb0dab);
$parcel$export(module.exports, "removeHoldByID", () => $92209f148b99825a$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "addError", () => $92209f148b99825a$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $92209f148b99825a$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $92209f148b99825a$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $92209f148b99825a$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $92209f148b99825a$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $92209f148b99825a$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $92209f148b99825a$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $92209f148b99825a$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $92209f148b99825a$export$614a7af2affc5dff);
$parcel$export(module.exports, "addNewInteraction", () => $92209f148b99825a$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $92209f148b99825a$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $92209f148b99825a$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $92209f148b99825a$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $92209f148b99825a$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $92209f148b99825a$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $92209f148b99825a$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $92209f148b99825a$export$5342dcad19138a1c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $7RHfd = parcelRequire("7RHfd");

var $gdUUy = parcelRequire("gdUUy");

var $actRr = parcelRequire("actRr");

var $6WHXQ = parcelRequire("6WHXQ");

var $aae7p = parcelRequire("aae7p");

var $eUjaZ = parcelRequire("eUjaZ");

var $b6J8s = parcelRequire("b6J8s");

var $gwyU1 = parcelRequire("gwyU1");

var $aY4cu = parcelRequire("aY4cu");

var $i2aoZ = parcelRequire("i2aoZ");

var $fwg5v = parcelRequire("fwg5v");

var $aTUiL = parcelRequire("aTUiL");

var $01S3s = parcelRequire("01S3s");

var $eWbVM = parcelRequire("eWbVM");

var $hUhqG = parcelRequire("hUhqG");

var $5vKXo = parcelRequire("5vKXo");
const $92209f148b99825a$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $92209f148b99825a$export$d8f52e8f804021e8 = new (0, $5vKXo.default)();
const $92209f148b99825a$var$interactionQueue = [];
const $92209f148b99825a$var$segmentCache = new Map();
const $92209f148b99825a$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $92209f148b99825a$var$segmentObservers = [];
function $92209f148b99825a$export$2b3954d2e8509985() {
    const interactionId = (0, $fwg5v.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $hUhqG.interactions).get(interactionId.current);
}
function $92209f148b99825a$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $aae7p.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $92209f148b99825a$var$performanceEventObserver;
const $92209f148b99825a$export$17afbba0f16b4b19 = ()=>{
    $92209f148b99825a$var$performanceEventObserver = $92209f148b99825a$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $92209f148b99825a$export$e6be05b411ce21a6(entry);
    });
    return $92209f148b99825a$var$performanceEventObserver;
};
const $92209f148b99825a$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $92209f148b99825a$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $92209f148b99825a$var$labelStackToString(labelStack, name) {
    var _stack$map;
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map((l)=>l.name)) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $92209f148b99825a$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $92209f148b99825a$var$addSegmentObserver(observer) {
    $92209f148b99825a$var$segmentObservers.push(observer);
    for (const segmentInfo of $92209f148b99825a$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $92209f148b99825a$var$removeSegmentObserver(observer) {
    const index = $92209f148b99825a$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $92209f148b99825a$var$segmentObservers.splice(index, 1);
}
function $92209f148b99825a$export$cd7f480d6b8286c3(interactionId) {
    (0, $hUhqG.interactions).delete(interactionId);
}
function $92209f148b99825a$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $92209f148b99825a$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $92209f148b99825a$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $92209f148b99825a$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $92209f148b99825a$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    var _interaction;
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) ((_interaction = interaction).excluded3pSegmentData ?? (_interaction.excluded3pSegmentData = {}))[segmentId] = {
        segmentId: segmentId,
        ...interaction.excluded3pSegmentData[segmentId],
        ...data
    };
}
function $92209f148b99825a$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $92209f148b99825a$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $aTUiL.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $92209f148b99825a$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $92209f148b99825a$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $92209f148b99825a$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $92209f148b99825a$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $6WHXQ.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($92209f148b99825a$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $92209f148b99825a$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($92209f148b99825a$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $92209f148b99825a$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $92209f148b99825a$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $hUhqG.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($92209f148b99825a$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $92209f148b99825a$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($92209f148b99825a$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $92209f148b99825a$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $hUhqG.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($92209f148b99825a$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $92209f148b99825a$export$9e04fe1a58571ec(moduleId, timestamp) {
    $92209f148b99825a$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $92209f148b99825a$export$6f228d1fdc911d7(identifier, start, end) {
    $92209f148b99825a$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $92209f148b99825a$var$moduleLoadingRequests = {};
function $92209f148b99825a$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $92209f148b99825a$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $92209f148b99825a$var$labelStackToString(labelStack), name, startTime);
}
function $92209f148b99825a$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $92209f148b99825a$export$7606887303596f82(interactionId, labelStack, name, _experimental, holdStartedAt) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $7RHfd.default)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $92209f148b99825a$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, holdStartedAt ?? performance.now());
    if (interaction != null) {
        const start = holdStartedAt ?? performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($92209f148b99825a$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $92209f148b99825a$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $92209f148b99825a$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($92209f148b99825a$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $92209f148b99825a$var$removeHoldCriterion(id);
            const currentInteraction = (0, $hUhqG.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $92209f148b99825a$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $92209f148b99825a$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($92209f148b99825a$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $92209f148b99825a$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $92209f148b99825a$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $92209f148b99825a$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $92209f148b99825a$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $92209f148b99825a$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $92209f148b99825a$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $hUhqG.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($92209f148b99825a$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $92209f148b99825a$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $92209f148b99825a$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $92209f148b99825a$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $92209f148b99825a$export$2df109852219d16e(interactionId) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
function $92209f148b99825a$export$b1ce94abc72c69d7(interactionId, info) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction == null) return ()=>{};
    const preloadRow = {
        source: info.source,
        preloadStartedAt: info.preloadStartedAt,
        adoptedAt: info.adoptedAt
    };
    interaction.preloadInfo.push(preloadRow);
    const releaseHold = $92209f148b99825a$export$7606887303596f82(interactionId, [], `preload:${info.source}`, false, interaction.start);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        preloadRow.settledAt = performance.now();
        releaseHold();
    };
}
function $92209f148b99825a$export$43f87b52eb8fc449(args) {
    const interaction = $92209f148b99825a$export$2b3954d2e8509985();
    if (interaction == null || interaction.ufoName !== args.experienceKey || args.preloadKey !== undefined && interaction.preloadKey !== undefined && interaction.preloadKey !== args.preloadKey) return null;
    return $92209f148b99825a$export$b1ce94abc72c69d7(interaction.id, {
        source: args.source,
        preloadStartedAt: args.preloadStartedAt,
        adoptedAt: args.adoptedAt
    });
}
let $92209f148b99825a$var$onInteractionStartForPreloadHolds = null;
function $92209f148b99825a$export$e96f751b1e82abda(hook) {
    $92209f148b99825a$var$onInteractionStartForPreloadHolds = hook;
}
const $92209f148b99825a$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $92209f148b99825a$export$9e04fe1a58571ec($92209f148b99825a$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $92209f148b99825a$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $92209f148b99825a$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $92209f148b99825a$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $92209f148b99825a$var$moduleLoadingRequests[info.identifier];
            $92209f148b99825a$export$6f228d1fdc911d7($92209f148b99825a$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $fwg5v.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $92209f148b99825a$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $fwg5v.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $92209f148b99825a$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $92209f148b99825a$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $92209f148b99825a$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $hUhqG.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $92209f148b99825a$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($92209f148b99825a$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $aae7p.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $92209f148b99825a$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $92209f148b99825a$var$pushToQueue(id, data) {
    $92209f148b99825a$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $92209f148b99825a$var$handleInteraction = $92209f148b99825a$var$pushToQueue;
const $92209f148b99825a$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $92209f148b99825a$var$hasMetricVariantCategory = (labelStack, category)=>(labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && label.type === category)) ?? false;
const $92209f148b99825a$var$hasAnyMetricVariantCategory = (labelStack)=>(labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && $92209f148b99825a$var$isKnownMetricVariantCategory(label.type))) ?? false;
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ const $92209f148b99825a$var$isExcludedThirdPartyHold = (labelStack)=>(labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true)) ?? false;
const $92209f148b99825a$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack === null || labelStack === void 0 || labelStack.forEach((label)=>{
        if ('type' in label && $92209f148b99825a$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $92209f148b99825a$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>{
    var _interaction$hold3pAc;
    return interaction.holdInfo.some((hold)=>$92209f148b99825a$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$92209f148b99825a$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$92209f148b99825a$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.values()) ?? []
    ].some((hold)=>$92209f148b99825a$var$hasMetricVariantCategory(hold.labelStack, category));
};
const $92209f148b99825a$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($92209f148b99825a$var$isExcludedThirdPartyHold(labelStack)) return;
    const categories = $92209f148b99825a$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $92209f148b99825a$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    var _interaction$hold3pAc2;
    (_interaction$hold3pAc2 = interaction.hold3pActive) === null || _interaction$hold3pAc2 === void 0 || _interaction$hold3pAc2.forEach((hold)=>{
        $92209f148b99825a$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $92209f148b99825a$var$hasActiveMetricVariantCategory = (interaction, category)=>{
    var _interaction$hold3pAc3;
    return [
        ...((_interaction$hold3pAc3 = interaction.hold3pActive) === null || _interaction$hold3pAc3 === void 0 ? void 0 : _interaction$hold3pAc3.values()) ?? []
    ].some((hold)=>$92209f148b99825a$var$hasMetricVariantCategory(hold.labelStack, category));
};
function $92209f148b99825a$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $92209f148b99825a$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ const $92209f148b99825a$var$getNonExcludedThirdPartyEnd = (interaction, currentTime, interactionEnd)=>{
    var _interaction$hold3pAc4;
    const activeHolds = [
        ...((_interaction$hold3pAc4 = interaction.hold3pActive) === null || _interaction$hold3pAc4 === void 0 ? void 0 : _interaction$hold3pAc4.values()) ?? []
    ];
    const releasedHolds = interaction.hold3pInfo ?? [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    const hasAnyExcludedThirdParty = activeHolds.some((hold)=>$92209f148b99825a$var$isExcludedThirdPartyHold(hold.labelStack)) || releasedHolds.some((hold)=>$92209f148b99825a$var$isExcludedThirdPartyHold(hold.labelStack));
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    const hasActiveNonExcludedThirdParty = activeHolds.some((hold)=>!$92209f148b99825a$var$isExcludedThirdPartyHold(hold.labelStack));
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max(interactionEnd, ...releasedHolds.filter((hold)=>!$92209f148b99825a$var$isExcludedThirdPartyHold(hold.labelStack)).map((hold)=>hold.end));
};
function $92209f148b99825a$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $92209f148b99825a$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $92209f148b99825a$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$92209f148b99825a$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $92209f148b99825a$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $92209f148b99825a$var$ensureMetricWindows(interaction) {
    var _interaction$metricCa, _interaction$metricCa2;
    if (interaction.end === 0) return;
    const hasGenAI = $92209f148b99825a$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $92209f148b99825a$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = ((_interaction$metricCa = interaction.metricCategoryEnds) === null || _interaction$metricCa === void 0 ? void 0 : _interaction$metricCa['third-party']) !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = ((_interaction$metricCa2 = interaction.metricCategoryEnds) === null || _interaction$metricCa2 === void 0 ? void 0 : _interaction$metricCa2['gen-ai']) !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $92209f148b99825a$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $92209f148b99825a$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $92209f148b99825a$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $92209f148b99825a$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $i2aoZ.currentFeatureFlagsAccessed));
    (0, $aY4cu.clearActiveTrace)();
    $92209f148b99825a$var$callCleanUpCallbacks(data);
    (0, $01S3s.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $aae7p.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $actRr.default)((0, $aae7p.getPostInteractionRate)((0, $b6J8s.sanitizeUfoName)(data.ufoName), data.type))) $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
    $92209f148b99825a$export$cd7f480d6b8286c3(id);
    $92209f148b99825a$export$dbba6cdedab4e68b.id = data.id;
    $92209f148b99825a$export$dbba6cdedab4e68b.type = data.type;
    $92209f148b99825a$export$dbba6cdedab4e68b.timestamp = data.end;
    $92209f148b99825a$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $92209f148b99825a$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $92209f148b99825a$var$handleInteraction(id, data);
    if ($92209f148b99825a$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $92209f148b99825a$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$92209f148b99825a$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $92209f148b99825a$export$9e614a29a1ac213e(sinkFn) {
    if ($92209f148b99825a$var$handleInteraction === $92209f148b99825a$var$pushToQueue) {
        $92209f148b99825a$var$handleInteraction = sinkFn;
        $92209f148b99825a$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $92209f148b99825a$var$interactionQueue.length = 0;
    }
}
function $92209f148b99825a$export$8a1ba7bef607358a(sinkFn) {
    $92209f148b99825a$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $92209f148b99825a$var$activeSubmitted = false;
function $92209f148b99825a$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc5;
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $aae7p.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            var _getConfig3;
            if ((_getConfig3 = (0, $aae7p.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $92209f148b99825a$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $92209f148b99825a$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = ((_interaction$hold3pAc5 = interaction.hold3pActive) === null || _interaction$hold3pAc5 === void 0 ? void 0 : _interaction$hold3pAc5.size) === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $92209f148b99825a$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $92209f148b99825a$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $92209f148b99825a$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$92209f148b99825a$var$activeSubmitted) {
                    var _getConfig4, _getConfig5;
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = $92209f148b99825a$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $92209f148b99825a$var$ensureMetricWindows(interaction);
                    $92209f148b99825a$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig4 = (0, $aae7p.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.extraSearchPageInteraction) !== null && _getConfig4 !== void 0 && _getConfig4.enabled && interaction.ufoName === ((_getConfig5 = (0, $aae7p.getConfig)()) === null || _getConfig5 === void 0 || (_getConfig5 = _getConfig5.extraSearchPageInteraction) === null || _getConfig5 === void 0 ? void 0 : _getConfig5.searchPageMetricName)) (0, $eUjaZ.onSearchPageInteractionComplete)(interactionId, interaction);
                    $92209f148b99825a$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$92209f148b99825a$var$activeSubmitted) {
                var _getConfig6, _getConfig7;
                $92209f148b99825a$var$finishInteraction(interactionId, interaction, endTime);
                if ((_getConfig6 = (0, $aae7p.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.extraSearchPageInteraction) !== null && _getConfig6 !== void 0 && _getConfig6.enabled && interaction.ufoName === ((_getConfig7 = (0, $aae7p.getConfig)()) === null || _getConfig7 === void 0 || (_getConfig7 = _getConfig7.extraSearchPageInteraction) === null || _getConfig7 === void 0 ? void 0 : _getConfig7.searchPageMetricName)) (0, $eUjaZ.onSearchPageInteractionComplete)(interactionId, interaction);
                $92209f148b99825a$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $92209f148b99825a$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $92209f148b99825a$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc7;
        const shouldUseRawDataThirdParty = (0, $aae7p.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $92209f148b99825a$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction$hold3pAc6;
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $92209f148b99825a$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $92209f148b99825a$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $92209f148b99825a$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: ((_interaction$hold3pAc6 = interaction.hold3pActive) === null || _interaction$hold3pAc6 === void 0 ? void 0 : _interaction$hold3pAc6.size) ?? 0
            });
            $92209f148b99825a$var$ensureMetricWindows(interaction);
            $92209f148b99825a$var$finishInteraction(interactionId, interaction, endTime);
            $92209f148b99825a$export$d8f52e8f804021e8.reset();
            $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $92209f148b99825a$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $92209f148b99825a$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (((_interaction$hold3pAc7 = interaction.hold3pActive) === null || _interaction$hold3pAc7 === void 0 ? void 0 : _interaction$hold3pAc7.size) ?? 0)
        });
        $92209f148b99825a$var$finishInteraction(interactionId, interaction);
        $92209f148b99825a$export$d8f52e8f804021e8.reset();
        $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $92209f148b99825a$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $aae7p.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $92209f148b99825a$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $92209f148b99825a$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $92209f148b99825a$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $92209f148b99825a$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $92209f148b99825a$var$ensureMetricWindows(interaction);
            $92209f148b99825a$var$finishInteraction(interactionId, interaction, endTime);
            $92209f148b99825a$export$d8f52e8f804021e8.reset();
            $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $92209f148b99825a$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $92209f148b99825a$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $92209f148b99825a$var$finishInteraction(interactionId, interaction);
        $92209f148b99825a$export$d8f52e8f804021e8.reset();
        $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $92209f148b99825a$export$d8f52e8f804021e8.reset();
        $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $92209f148b99825a$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $92209f148b99825a$export$2b3954d2e8509985();
    const finishInteractions = (0, $aae7p.getFinishInteractionOnTransition)();
    (0, $hUhqG.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $aae7p.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $92209f148b99825a$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $92209f148b99825a$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $92209f148b99825a$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $92209f148b99825a$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $92209f148b99825a$var$ensureMetricWindows(interaction);
            $92209f148b99825a$var$finishInteraction(interactionId, interaction, endTime);
            $92209f148b99825a$export$d8f52e8f804021e8.reset();
            $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $92209f148b99825a$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $92209f148b99825a$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $92209f148b99825a$var$finishInteraction(interactionId, interaction);
        $92209f148b99825a$export$d8f52e8f804021e8.reset();
        $92209f148b99825a$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $92209f148b99825a$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $hUhqG.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $92209f148b99825a$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null, preloadKey) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    $92209f148b99825a$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $aae7p.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $92209f148b99825a$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $92209f148b99825a$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $actRr.default)((0, $aae7p.getCapabilityRate)('feature_flag_access'));
    const config = (0, $aae7p.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $aae7p.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $eWbVM.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $i2aoZ.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        preloadKey: preloadKey,
        type: type,
        previousInteractionName: $92209f148b99825a$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $92209f148b99825a$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        preloadInfo: [],
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $i2aoZ.currentFeatureFlagsAccessed).clear();
    (0, $hUhqG.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $92209f148b99825a$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $92209f148b99825a$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $aae7p.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $92209f148b99825a$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig8;
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig8 = (0, $aae7p.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.postInteractionLog) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $92209f148b99825a$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
    if ($92209f148b99825a$var$onInteractionStartForPreloadHolds) try {
        $92209f148b99825a$var$onInteractionStartForPreloadHolds(interactionId, ufoName, preloadKey);
    } catch  {
    // Preload instrumentation must not break interaction creation.
    }
}
function $92209f148b99825a$export$4a759336b50e86e3(event) {
    const interaction = $92209f148b99825a$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $92209f148b99825a$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $92209f148b99825a$export$ad216cc25852d44b(apdex) {
    (0, $hUhqG.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $92209f148b99825a$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $92209f148b99825a$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $92209f148b99825a$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $92209f148b99825a$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $92209f148b99825a$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $92209f148b99825a$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($92209f148b99825a$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $92209f148b99825a$export$1c43f9ac826b6462(labelStack) {
    const key = $92209f148b99825a$var$getSegmentCacheKey(labelStack);
    const existingSegment = $92209f148b99825a$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $92209f148b99825a$var$segmentCache.set(key, segmentInfo);
        $92209f148b99825a$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $92209f148b99825a$export$d0365e48b58231c3(labelStack) {
    const key = $92209f148b99825a$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $92209f148b99825a$var$segmentCache.get(key);
    if (segmentInfo) {
        if ((0, $gdUUy.fg)('platform_ufo_fix_stale_segment_cache')) $92209f148b99825a$var$segmentCache.delete(key);
        else $92209f148b99825a$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $gwyU1.stringifyLabelStackFully)(labelStack);
        $92209f148b99825a$export$a2b14406ded37d60.set(cacheKey, ($92209f148b99825a$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $92209f148b99825a$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $92209f148b99825a$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $hUhqG.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($92209f148b99825a$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: (prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $92209f148b99825a$export$6ce04c7ca6810a7e = [];
const $92209f148b99825a$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $92209f148b99825a$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $92209f148b99825a$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $92209f148b99825a$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("7RHfd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b9f070fe1fde6a4$export$2e2bcd8739ae039);

var $hAyb4 = parcelRequire("hAyb4");

var $i1eBd = parcelRequire("i1eBd");

var $dABtk = parcelRequire("dABtk");
function $5b9f070fe1fde6a4$var$v4(options, buf, offset) {
    if ((0, $hAyb4.default).randomUUID && !buf && !options) return (0, $hAyb4.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $i1eBd.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $dABtk.unsafeStringify)(rnds);
}
var $5b9f070fe1fde6a4$export$2e2bcd8739ae039 = $5b9f070fe1fde6a4$var$v4;

});
parcelRegister("hAyb4", function(module, exports) {
$parcel$export(module.exports, "default", () => $cce04f6cb1ff0003$export$2e2bcd8739ae039);
const $cce04f6cb1ff0003$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cce04f6cb1ff0003$export$2e2bcd8739ae039 = {
    randomUUID: $cce04f6cb1ff0003$var$randomUUID
};

});

parcelRegister("i1eBd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e3a51694ef59f3$export$2e2bcd8739ae039);
let $d1e3a51694ef59f3$var$getRandomValues;
const $d1e3a51694ef59f3$var$rnds8 = new Uint8Array(16);
function $d1e3a51694ef59f3$export$2e2bcd8739ae039() {
    if (!$d1e3a51694ef59f3$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $d1e3a51694ef59f3$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $d1e3a51694ef59f3$var$getRandomValues($d1e3a51694ef59f3$var$rnds8);
}

});

parcelRegister("dABtk", function(module, exports) {
$parcel$export(module.exports, "unsafeStringify", () => $9e4bb4556604db58$export$8fb373d660548968);

var $ez5Fv = parcelRequire("ez5Fv");
const $9e4bb4556604db58$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$9e4bb4556604db58$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $9e4bb4556604db58$export$8fb373d660548968(arr, offset = 0) {
    return ($9e4bb4556604db58$var$byteToHex[arr[offset + 0]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 1]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 2]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 3]] + '-' + $9e4bb4556604db58$var$byteToHex[arr[offset + 4]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 5]] + '-' + $9e4bb4556604db58$var$byteToHex[arr[offset + 6]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 7]] + '-' + $9e4bb4556604db58$var$byteToHex[arr[offset + 8]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 9]] + '-' + $9e4bb4556604db58$var$byteToHex[arr[offset + 10]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 11]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 12]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 13]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 14]] + $9e4bb4556604db58$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $9e4bb4556604db58$var$stringify(arr, offset = 0) {
    const uuid = $9e4bb4556604db58$export$8fb373d660548968(arr, offset);
    if (!(0, $ez5Fv.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $9e4bb4556604db58$export$2e2bcd8739ae039 = $9e4bb4556604db58$var$stringify;

});
parcelRegister("ez5Fv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9a8bb37628dbcd9$export$2e2bcd8739ae039);

var $6rIO9 = parcelRequire("6rIO9");
function $a9a8bb37628dbcd9$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $6rIO9.default).test(uuid);
}
var $a9a8bb37628dbcd9$export$2e2bcd8739ae039 = $a9a8bb37628dbcd9$var$validate;

});
parcelRegister("6rIO9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b180596a3c38548$export$2e2bcd8739ae039);
var $4b180596a3c38548$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("gdUUy", function(module, exports) {
$parcel$export(module.exports, "fg", () => $c554840c61954098$export$b40ec24ac8275656);

var $4hsUA = parcelRequire("4hsUA");
function $c554840c61954098$export$b40ec24ac8275656(name) {
    return (0, $4hsUA.resolveBooleanFlag)(name);
}

});
parcelRegister("4hsUA", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $2afa10d04f8d1ce8$export$6333b6aff9fc6275);

var $87QgR = parcelRequire("87QgR");

var $6c82q = parcelRequire("6c82q");

var $Q0gX6 = parcelRequire("Q0gX6");

var $wVKBq = parcelRequire("wVKBq");

var $ieD62 = parcelRequire("ieD62");

var $lAT6B = parcelRequire("lAT6B");
const $2afa10d04f8d1ce8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $Q0gX6.ENV_ENABLE_PLATFORM_FF) || (0, $wVKBq.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $2afa10d04f8d1ce8$export$6333b6aff9fc6275(flagKey) {
    if ($2afa10d04f8d1ce8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6c82q.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $lAT6B.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $ieD62.globalVar)[0, $lAT6B.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $ieD62.globalVar)[0, $lAT6B.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $87QgR.default).checkGate(flagKey);
        const result = (_globalVar$PFF_GLOBAL3 = (0, $ieD62.globalVar)[0, $lAT6B.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("87QgR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f051288d859a90eb$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dAYyp = parcelRequire("dAYyp");

var $7wpKS = parcelRequire("7wpKS");

var $9kwjL = parcelRequire("9kwjL");

var $a345n = parcelRequire("a345n");

var $kScVw = parcelRequire("kScVw");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $f051288d859a90eb$var$FeatureGates {
    static #_ = this.client = new (0, $dAYyp.Client)();
    static #_2 = this.hasCheckGateErrorOccurred = false;
    static #_3 = this.hasGetExperimentValueErrorOccurred = false;
    static #_4 = this.checkGate = (gateName, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                // Attempt to retrieve an override value for the feature gate
                const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                // If an override value is found, return it immediately
                if (overrideValue !== undefined) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$f051288d859a90eb$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $f051288d859a90eb$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
        }
        // Proceed with the main logic if no override is found
        return this.client.checkGate(gateName, options);
    };
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static #_5 = this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$f051288d859a90eb$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
        // Proceed with the main logic if no override is found
        return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
    };
    static #_6 = this.initializeCalled = this.client.initializeCalled.bind(this.client);
    static #_7 = this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    static #_8 = this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    static #_9 = this.initialize = this.client.initialize.bind(this.client);
    static #_10 = this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    static #_11 = this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    static #_12 = this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    static #_13 = this.getExperiment = this.client.getExperiment.bind(this.client);
    static #_14 = this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    static #_15 = this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    static #_16 = this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    static #_17 = this.overrideGate = this.client.overrideGate.bind(this.client);
    static #_18 = this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    static #_19 = this.overrideConfig = this.client.overrideConfig.bind(this.client);
    static #_20 = this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    static #_21 = this.setOverrides = this.client.setOverrides.bind(this.client);
    static #_22 = this.getOverrides = this.client.getOverrides.bind(this.client);
    static #_23 = this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    static #_24 = this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    static #_25 = this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    static #_26 = this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    static #_27 = this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    static #_28 = this.updateUser = this.client.updateUser.bind(this.client);
    static #_29 = this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    static #_30 = this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    static #_31 = this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    static #_32 = this.getTargetApp = this.client.getTargetApp.bind(this.client);
    static #_33 = this.getLayer = this.client.getLayer.bind(this.client);
    static #_34 = this.getLayerValue = this.client.getLayerValue.bind(this.client);
}
let $f051288d859a90eb$var$boundFGJS = $f051288d859a90eb$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $f051288d859a90eb$var$FeatureGates;
    else {
        var $f051288d859a90eb$var$_boundFGJS, $f051288d859a90eb$var$_boundFGJS$getPackage;
        $f051288d859a90eb$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (($f051288d859a90eb$var$_boundFGJS = $f051288d859a90eb$var$boundFGJS) === null || $f051288d859a90eb$var$_boundFGJS === void 0 || ($f051288d859a90eb$var$_boundFGJS$getPackage = $f051288d859a90eb$var$_boundFGJS.getPackageVersion) === null || $f051288d859a90eb$var$_boundFGJS$getPackage === void 0 ? void 0 : $f051288d859a90eb$var$_boundFGJS$getPackage.call($f051288d859a90eb$var$_boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, $7wpKS.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $7wpKS.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $f051288d859a90eb$export$2e2bcd8739ae039 = $f051288d859a90eb$var$boundFGJS;

});
parcelRegister("dAYyp", function(module, exports) {
$parcel$export(module.exports, "Client", () => $f96fb71ecaf759a5$export$1f2bb630327ac4b6);

var $hawTU = parcelRequire("hawTU");

var $2NkRz = parcelRequire("2NkRz");

var $a345n = parcelRequire("a345n");

var $3izyf = parcelRequire("3izyf");

var $9kwjL = parcelRequire("9kwjL");

var $c4GSy = parcelRequire("c4GSy");

var $ajaeo = parcelRequire("ajaeo");

var $7mYO3 = parcelRequire("7mYO3");

var $2pyIT = parcelRequire("2pyIT");

var $1qP4M = parcelRequire("1qP4M");

var $7vKTo = parcelRequire("7vKTo");

var $hCrrx = parcelRequire("hCrrx");

var $hZ1FQ = parcelRequire("hZ1FQ");

var $kScVw = parcelRequire("kScVw");

var $7wpKS = parcelRequire("7wpKS");
const $f96fb71ecaf759a5$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $f96fb71ecaf759a5$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $f96fb71ecaf759a5$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $7vKTo.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $2NkRz.default)();
        this.dataAdapter = new (0, $1qP4M.NoFetchDataAdapter)();
        /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $7vKTo.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $7mYO3.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $hCrrx.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $7mYO3.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $hCrrx.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $7wpKS.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _analyticsWebClient;
        (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $7wpKS.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $kScVw.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $7mYO3.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $hCrrx.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $7mYO3.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $ajaeo.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $a345n.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $a345n.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $9kwjL.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        var _this$statsigClient$g;
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) {
            var _this$statsigClient;
            (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
        }
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $hCrrx.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $hCrrx.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $ajaeo.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $ajaeo.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        var _newClientOptions$net;
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $2pyIT.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $f96fb71ecaf759a5$var$DEFAULT_CLIENT_KEY;
        if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $f96fb71ecaf759a5$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $kScVw.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $hZ1FQ.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $c4GSy.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $hawTU.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $hawTU.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $hawTU.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $hawTU.StatsigClient)($f96fb71ecaf759a5$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        var _this$initOptions, _this$initOptions$upd;
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $hZ1FQ.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $c4GSy.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            var _updateUserCompletion, _ref;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_updateUserCompletion = (_ref = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref, false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $7wpKS.CLIENT_VERSION;
    }
    /**
   * Returns the `targetApp` value that was provided during client initialization.
   * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
   *
   * Returns `undefined` if `initialize` has never been called.
   *
   * @returns The targetApp string, or undefined if initialize has never been called.
   */ getTargetApp() {
        var _this$initOptions2;
        return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $3izyf.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $3izyf.Layer).fromLayer((0, $hawTU._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("hawTU", function(module, exports) {
"use strict";
var $0339c19ddc1bf238$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0339c19ddc1bf238$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0339c19ddc1bf238$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $2kCZ9 = parcelRequire("2kCZ9");
module.exports.StatsigClient = $2kCZ9.default;

$0339c19ddc1bf238$var$__exportStar((parcelRequire("d462y")), module.exports);
const $0339c19ddc1bf238$var$__STATSIG__ = Object.assign((0, (parcelRequire("d462y"))._getStatsigGlobal)(), {
    StatsigClient: $2kCZ9.default
});
module.exports.default = $0339c19ddc1bf238$var$__STATSIG__;

});
parcelRegister("d462y", function(module, exports) {
"use strict";
var $9830558fe0395ea8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9830558fe0395ea8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9830558fe0395ea8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("iI65A")).Diagnostics;
    }
});

var $9eNVQ = parcelRequire("9eNVQ");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $9eNVQ.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1h5PR")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hbZwU")).Storage;
    }
});

$9830558fe0395ea8$var$__exportStar((parcelRequire("2Hh0N")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("lnSb5")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("lX0zi")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("lgcfb")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("iI65A")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("gNbbm")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("l2MHM")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("85Aoq")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("fMQ3y")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("g9aIk")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("DnYFc")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("1h5PR")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("9bGSs")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("eLloc")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("l2btr")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("4Vl08")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("leCKz")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("hS003")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("kVsqQ")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("2GvH6")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("1rThw")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("4nbRD")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("iVPs6")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("48DBK")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("a0sEw")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("61zVN")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("aN3uI")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("GWIwJ")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("gBltX")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("acEYd")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("lzIAB")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("8OjH2")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("hbZwU")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("kzPIm")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("dF6Y8")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("exbyn")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("b3sg7")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("6YfKH")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("7dwEi")), module.exports);

$9830558fe0395ea8$var$__exportStar((parcelRequire("bzEPW")), module.exports);
Object.assign((0, (parcelRequire("2Hh0N"))._getStatsigGlobal)(), {
    Log: (parcelRequire("1h5PR")).Log,
    SDK_VERSION: (parcelRequire("aN3uI")).SDK_VERSION
});

});
parcelRegister("2Hh0N", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $1f6ccb21aa024162$var$_a, $1f6ccb21aa024162$var$_b, $1f6ccb21aa024162$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $1h5PR = parcelRequire("1h5PR");
const $1f6ccb21aa024162$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $1f6ccb21aa024162$var$statsigGlobal;
    } catch (e) {
        return $1f6ccb21aa024162$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $1f6ccb21aa024162$var$_getStatsigGlobal;
const $1f6ccb21aa024162$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $1f6ccb21aa024162$var$_getStatsigGlobalFlag;
const $1f6ccb21aa024162$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $1h5PR.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $1f6ccb21aa024162$var$_getInstance;
const $1f6ccb21aa024162$var$GLOBAL_KEY = '__STATSIG__';
const $1f6ccb21aa024162$var$_window = typeof window !== 'undefined' ? window : {};
const $1f6ccb21aa024162$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $1f6ccb21aa024162$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $1f6ccb21aa024162$var$statsigGlobal = ($1f6ccb21aa024162$var$_c = ($1f6ccb21aa024162$var$_b = ($1f6ccb21aa024162$var$_a = $1f6ccb21aa024162$var$_window[$1f6ccb21aa024162$var$GLOBAL_KEY]) !== null && $1f6ccb21aa024162$var$_a !== void 0 ? $1f6ccb21aa024162$var$_a : $1f6ccb21aa024162$var$_global[$1f6ccb21aa024162$var$GLOBAL_KEY]) !== null && $1f6ccb21aa024162$var$_b !== void 0 ? $1f6ccb21aa024162$var$_b : $1f6ccb21aa024162$var$_globalThis[$1f6ccb21aa024162$var$GLOBAL_KEY]) !== null && $1f6ccb21aa024162$var$_c !== void 0 ? $1f6ccb21aa024162$var$_c : {
    instance: module.exports._getInstance
};
$1f6ccb21aa024162$var$_window[$1f6ccb21aa024162$var$GLOBAL_KEY] = $1f6ccb21aa024162$var$statsigGlobal;
$1f6ccb21aa024162$var$_global[$1f6ccb21aa024162$var$GLOBAL_KEY] = $1f6ccb21aa024162$var$statsigGlobal;
$1f6ccb21aa024162$var$_globalThis[$1f6ccb21aa024162$var$GLOBAL_KEY] = $1f6ccb21aa024162$var$statsigGlobal;

});
parcelRegister("1h5PR", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $0edbe7c6d985784f$var$DEBUG = ' DEBUG ';
const $0edbe7c6d985784f$var$_INFO = '  INFO ';
const $0edbe7c6d985784f$var$_WARN = '  WARN ';
const $0edbe7c6d985784f$var$ERROR = ' ERROR ';
function $0edbe7c6d985784f$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $0edbe7c6d985784f$var$Log {
    static info(...args) {
        if ($0edbe7c6d985784f$var$Log.level >= module.exports.LogLevel.Info) console.info($0edbe7c6d985784f$var$_INFO, ...$0edbe7c6d985784f$var$addTag(args));
    }
    static debug(...args) {
        if ($0edbe7c6d985784f$var$Log.level >= module.exports.LogLevel.Debug) console.debug($0edbe7c6d985784f$var$DEBUG, ...$0edbe7c6d985784f$var$addTag(args));
    }
    static warn(...args) {
        if ($0edbe7c6d985784f$var$Log.level >= module.exports.LogLevel.Warn) console.warn($0edbe7c6d985784f$var$_WARN, ...$0edbe7c6d985784f$var$addTag(args));
    }
    static error(...args) {
        if ($0edbe7c6d985784f$var$Log.level >= module.exports.LogLevel.Error) console.error($0edbe7c6d985784f$var$ERROR, ...$0edbe7c6d985784f$var$addTag(args));
    }
}
module.exports.Log = $0edbe7c6d985784f$var$Log;
$0edbe7c6d985784f$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("iI65A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $d9f10f35988117d5$var$MARKER_MAP = new Map();
const $d9f10f35988117d5$var$ACT_START = 'start';
const $d9f10f35988117d5$var$ACT_END = 'end';
const $d9f10f35988117d5$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $d9f10f35988117d5$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $d9f10f35988117d5$var$_addMarker(sdkKey, $d9f10f35988117d5$var$_createMarker({}, $d9f10f35988117d5$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $d9f10f35988117d5$var$_addMarker(sdkKey, $d9f10f35988117d5$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $d9f10f35988117d5$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $d9f10f35988117d5$var$_addMarker(sdkKey, $d9f10f35988117d5$var$_createMarker(data, $d9f10f35988117d5$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $d9f10f35988117d5$var$_addMarker(sdkKey, $d9f10f35988117d5$var$_createMarker(data, $d9f10f35988117d5$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $d9f10f35988117d5$var$_addMarker(sdkKey, $d9f10f35988117d5$var$_createMarker({}, $d9f10f35988117d5$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $d9f10f35988117d5$var$_addMarker(sdkKey, $d9f10f35988117d5$var$_createMarker(data, $d9f10f35988117d5$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $d9f10f35988117d5$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $d9f10f35988117d5$var$_safeGetField(e, 'code'),
            name: $d9f10f35988117d5$var$_safeGetField(e, 'name'),
            message: $d9f10f35988117d5$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $d9f10f35988117d5$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $d9f10f35988117d5$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $d9f10f35988117d5$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $d9f10f35988117d5$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $d9f10f35988117d5$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $d9f10f35988117d5$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $d9f10f35988117d5$var$MARKER_MAP.set(sdkKey, markers);
}
function $d9f10f35988117d5$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("9eNVQ", function(module, exports) {
"use strict";
var $6b9c275203bca0d6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $lnSb5 = parcelRequire("lnSb5");

var $g9aIk = parcelRequire("g9aIk");

var $1h5PR = parcelRequire("1h5PR");

var $eLloc = parcelRequire("eLloc");

var $hS003 = parcelRequire("hS003");

var $61zVN = parcelRequire("61zVN");

var $GWIwJ = parcelRequire("GWIwJ");

var $hbZwU = parcelRequire("hbZwU");

var $exbyn = parcelRequire("exbyn");

var $6YfKH = parcelRequire("6YfKH");
const $6b9c275203bca0d6$var$DEFAULT_QUEUE_SIZE = 100;
const $6b9c275203bca0d6$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $6b9c275203bca0d6$var$MAX_DEDUPER_KEYS = 1000;
const $6b9c275203bca0d6$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $6b9c275203bca0d6$var$MAX_FAILED_LOGS = 500;
const $6b9c275203bca0d6$var$QUICK_FLUSH_WINDOW_MS = 200;
const $6b9c275203bca0d6$var$EVENT_LOGGER_MAP = {};
class $6b9c275203bca0d6$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $6b9c275203bca0d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $6b9c275203bca0d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $GWIwJ.LoggingEnabledOption.disabled : $GWIwJ.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $1h5PR.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $6b9c275203bca0d6$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $exbyn.UrlConfiguration($eLloc.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $hbZwU._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $hbZwU.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $6b9c275203bca0d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $hS003._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $6b9c275203bca0d6$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $6YfKH._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $6b9c275203bca0d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $6b9c275203bca0d6$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $6b9c275203bca0d6$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $6b9c275203bca0d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $6b9c275203bca0d6$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $6b9c275203bca0d6$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$6b9c275203bca0d6$var$EventLogger._safeFlushAndForget(this._sdkKey), $6b9c275203bca0d6$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $hS003._isServerEnv)()) return false;
        if (!(0, $61zVN._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $lnSb5._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $6b9c275203bca0d6$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $6b9c275203bca0d6$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $6b9c275203bca0d6$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $6YfKH._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $1h5PR.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $1h5PR.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $6b9c275203bca0d6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$eLloc.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        // Products opt into this patch through their own rollout controls.
        const boundFailedLogs = typeof window !== 'undefined' && window.__USE_STATSIG_PATCH__ === true;
        if (!boundFailedLogs) while(events.length > $6b9c275203bca0d6$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            // Bound the total retry queue only when the product opts in.
            // https://github.com/statsig-io/js-client-monorepo/issues/39
            const combined = [
                ...savedEvents,
                ...events
            ];
            if (boundFailedLogs && combined.length > 100) combined.splice(0, combined.length - 100);
            (0, $hbZwU._setObjectInStorage)(storageKey, combined);
        } catch (_a) {
            $1h5PR.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $hbZwU._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$6b9c275203bca0d6$var$__awaiter(this, void 0, void 0, function*() {
                if (!$hbZwU.Storage.isReady()) yield $hbZwU.Storage.isReadyResolver();
                const events = (0, $hbZwU._getObjectFromStorage)(storageKey);
                if (!events) return;
                $hbZwU.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $1h5PR.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $g9aIk._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $1h5PR.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $hS003._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $6b9c275203bca0d6$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $6b9c275203bca0d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $6b9c275203bca0d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $6b9c275203bca0d6$var$EventLogger;

});
parcelRegister("lnSb5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $g9aIk = parcelRequire("g9aIk");
function $f915c589de21908d$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $g9aIk._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $f915c589de21908d$var$_getUserStorageKey;
function $f915c589de21908d$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $f915c589de21908d$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $g9aIk._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $f915c589de21908d$var$_getStorageKey;

});
parcelRegister("g9aIk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $dF6Y8 = parcelRequire("dF6Y8");
const $bc15cc32ed13925b$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $bc15cc32ed13925b$var$_DJB2;
const $bc15cc32ed13925b$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $bc15cc32ed13925b$var$_DJB2Object;
const $bc15cc32ed13925b$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $dF6Y8._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $bc15cc32ed13925b$var$_getSortedObject;

});
parcelRegister("dF6Y8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $9f24828deeec8c7d$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $9f24828deeec8c7d$var$_typeOf;
function $9f24828deeec8c7d$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $9f24828deeec8c7d$var$_isTypeMatch;

});



parcelRegister("eLloc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("hS003", function(module, exports) {

var $4eGW1 = parcelRequire("4eGW1");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $d0277ac77c851b02$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $d0277ac77c851b02$var$_getWindowSafe;
const $d0277ac77c851b02$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $d0277ac77c851b02$var$_getDocumentSafe;
const $d0277ac77c851b02$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $4eGW1 !== 'undefined' && $4eGW1.versions != null && $4eGW1.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $d0277ac77c851b02$var$_isServerEnv;
const $d0277ac77c851b02$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $d0277ac77c851b02$var$_addWindowEventListenerSafe;
const $d0277ac77c851b02$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $d0277ac77c851b02$var$_addDocumentEventListenerSafe;
const $d0277ac77c851b02$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $d0277ac77c851b02$var$_getCurrentPageUrlSafe;
const $d0277ac77c851b02$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $d0277ac77c851b02$var$_getUnloadEvent;

});
parcelRegister("4eGW1", function(module, exports) {
// shim for using process in browser
var $3159c62c656c5db3$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3159c62c656c5db3$var$cachedSetTimeout;
var $3159c62c656c5db3$var$cachedClearTimeout;
function $3159c62c656c5db3$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3159c62c656c5db3$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3159c62c656c5db3$var$cachedSetTimeout = setTimeout;
        else $3159c62c656c5db3$var$cachedSetTimeout = $3159c62c656c5db3$var$defaultSetTimout;
    } catch (e) {
        $3159c62c656c5db3$var$cachedSetTimeout = $3159c62c656c5db3$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3159c62c656c5db3$var$cachedClearTimeout = clearTimeout;
        else $3159c62c656c5db3$var$cachedClearTimeout = $3159c62c656c5db3$var$defaultClearTimeout;
    } catch (e) {
        $3159c62c656c5db3$var$cachedClearTimeout = $3159c62c656c5db3$var$defaultClearTimeout;
    }
})();
function $3159c62c656c5db3$var$runTimeout(fun) {
    if ($3159c62c656c5db3$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3159c62c656c5db3$var$cachedSetTimeout === $3159c62c656c5db3$var$defaultSetTimout || !$3159c62c656c5db3$var$cachedSetTimeout) && setTimeout) {
        $3159c62c656c5db3$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3159c62c656c5db3$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3159c62c656c5db3$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3159c62c656c5db3$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3159c62c656c5db3$var$runClearTimeout(marker) {
    if ($3159c62c656c5db3$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3159c62c656c5db3$var$cachedClearTimeout === $3159c62c656c5db3$var$defaultClearTimeout || !$3159c62c656c5db3$var$cachedClearTimeout) && clearTimeout) {
        $3159c62c656c5db3$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3159c62c656c5db3$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3159c62c656c5db3$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3159c62c656c5db3$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3159c62c656c5db3$var$queue = [];
var $3159c62c656c5db3$var$draining = false;
var $3159c62c656c5db3$var$currentQueue;
var $3159c62c656c5db3$var$queueIndex = -1;
function $3159c62c656c5db3$var$cleanUpNextTick() {
    if (!$3159c62c656c5db3$var$draining || !$3159c62c656c5db3$var$currentQueue) return;
    $3159c62c656c5db3$var$draining = false;
    if ($3159c62c656c5db3$var$currentQueue.length) $3159c62c656c5db3$var$queue = $3159c62c656c5db3$var$currentQueue.concat($3159c62c656c5db3$var$queue);
    else $3159c62c656c5db3$var$queueIndex = -1;
    if ($3159c62c656c5db3$var$queue.length) $3159c62c656c5db3$var$drainQueue();
}
function $3159c62c656c5db3$var$drainQueue() {
    if ($3159c62c656c5db3$var$draining) return;
    var timeout = $3159c62c656c5db3$var$runTimeout($3159c62c656c5db3$var$cleanUpNextTick);
    $3159c62c656c5db3$var$draining = true;
    var len = $3159c62c656c5db3$var$queue.length;
    while(len){
        $3159c62c656c5db3$var$currentQueue = $3159c62c656c5db3$var$queue;
        $3159c62c656c5db3$var$queue = [];
        while(++$3159c62c656c5db3$var$queueIndex < len)if ($3159c62c656c5db3$var$currentQueue) $3159c62c656c5db3$var$currentQueue[$3159c62c656c5db3$var$queueIndex].run();
        $3159c62c656c5db3$var$queueIndex = -1;
        len = $3159c62c656c5db3$var$queue.length;
    }
    $3159c62c656c5db3$var$currentQueue = null;
    $3159c62c656c5db3$var$draining = false;
    $3159c62c656c5db3$var$runClearTimeout(timeout);
}
$3159c62c656c5db3$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3159c62c656c5db3$var$queue.push(new $3159c62c656c5db3$var$Item(fun, args));
    if ($3159c62c656c5db3$var$queue.length === 1 && !$3159c62c656c5db3$var$draining) $3159c62c656c5db3$var$runTimeout($3159c62c656c5db3$var$drainQueue);
};
// v8 likes predictible objects
function $3159c62c656c5db3$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3159c62c656c5db3$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3159c62c656c5db3$var$process.title = 'browser';
$3159c62c656c5db3$var$process.browser = true;
$3159c62c656c5db3$var$process.env = {};
$3159c62c656c5db3$var$process.argv = [];
$3159c62c656c5db3$var$process.version = ''; // empty string to avoid regexp issues
$3159c62c656c5db3$var$process.versions = {};
function $3159c62c656c5db3$var$noop() {}
$3159c62c656c5db3$var$process.on = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.addListener = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.once = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.off = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.removeListener = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.removeAllListeners = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.emit = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.prependListener = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.prependOnceListener = $3159c62c656c5db3$var$noop;
$3159c62c656c5db3$var$process.listeners = function(name) {
    return [];
};
$3159c62c656c5db3$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3159c62c656c5db3$var$process.cwd = function() {
    return '/';
};
$3159c62c656c5db3$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3159c62c656c5db3$var$process.umask = function() {
    return 0;
};

});


parcelRegister("61zVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $462eb53d070cccc8$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $462eb53d070cccc8$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $462eb53d070cccc8$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $462eb53d070cccc8$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $462eb53d070cccc8$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $462eb53d070cccc8$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $462eb53d070cccc8$var$GATE_EXPOSURE_NAME || eventName === $462eb53d070cccc8$var$CONFIG_EXPOSURE_NAME || eventName === $462eb53d070cccc8$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $462eb53d070cccc8$var$_isExposureEvent;
const $462eb53d070cccc8$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $462eb53d070cccc8$var$_createExposure($462eb53d070cccc8$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $462eb53d070cccc8$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $462eb53d070cccc8$var$_createGateExposure;
function $462eb53d070cccc8$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $462eb53d070cccc8$var$_mapExposures;
const $462eb53d070cccc8$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $462eb53d070cccc8$var$_createExposure($462eb53d070cccc8$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $462eb53d070cccc8$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $462eb53d070cccc8$var$_createConfigExposure;
const $462eb53d070cccc8$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $462eb53d070cccc8$var$_createExposure($462eb53d070cccc8$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $462eb53d070cccc8$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $462eb53d070cccc8$var$_createLayerParameterExposure;
const $462eb53d070cccc8$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("GWIwJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("hbZwU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $1h5PR = parcelRequire("1h5PR");

var $hS003 = parcelRequire("hS003");
const $c84331490be1f7ac$var$inMemoryStore = {};
const $c84331490be1f7ac$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$c84331490be1f7ac$var$inMemoryStore[key] ? $c84331490be1f7ac$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $c84331490be1f7ac$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $c84331490be1f7ac$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($c84331490be1f7ac$var$inMemoryStore)
};
let $c84331490be1f7ac$var$_localStorageProvider = null;
try {
    const win = (0, $hS003._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $c84331490be1f7ac$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $1h5PR.Log.warn('Failed to setup localStorageProvider.');
}
let $c84331490be1f7ac$var$_main = $c84331490be1f7ac$var$_localStorageProvider !== null && $c84331490be1f7ac$var$_localStorageProvider !== void 0 ? $c84331490be1f7ac$var$_localStorageProvider : $c84331490be1f7ac$var$_inMemoryProvider;
let $c84331490be1f7ac$var$_current = $c84331490be1f7ac$var$_main;
function $c84331490be1f7ac$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($c84331490be1f7ac$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$c84331490be1f7ac$var$_current.isReady(),
    isReadyResolver: ()=>$c84331490be1f7ac$var$_current.isReadyResolver(),
    getProviderName: ()=>$c84331490be1f7ac$var$_current.getProviderName(),
    getItem: (key)=>$c84331490be1f7ac$var$_inMemoryBreaker(()=>$c84331490be1f7ac$var$_current.getItem(key)),
    setItem: (key, value)=>$c84331490be1f7ac$var$_inMemoryBreaker(()=>$c84331490be1f7ac$var$_current.setItem(key, value)),
    removeItem: (key)=>$c84331490be1f7ac$var$_current.removeItem(key),
    getAllKeys: ()=>$c84331490be1f7ac$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $c84331490be1f7ac$var$_main = newProvider;
        $c84331490be1f7ac$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $c84331490be1f7ac$var$_current = $c84331490be1f7ac$var$_inMemoryProvider;
        else $c84331490be1f7ac$var$_current = $c84331490be1f7ac$var$_main;
    }
};
function $c84331490be1f7ac$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $1h5PR.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $c84331490be1f7ac$var$_getObjectFromStorage;
function $c84331490be1f7ac$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $c84331490be1f7ac$var$_setObjectInStorage;

});

parcelRegister("exbyn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $g9aIk = parcelRequire("g9aIk");

var $eLloc = parcelRequire("eLloc");
const $a94d1c0cec8fea2a$var$ENDPOINT_DNS_KEY_MAP = {
    [$eLloc.Endpoint._initialize]: 'i',
    [$eLloc.Endpoint._rgstr]: 'e',
    [$eLloc.Endpoint._download_config_specs]: 'd'
};
class $a94d1c0cec8fea2a$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $a94d1c0cec8fea2a$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $eLloc.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $g9aIk._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $a94d1c0cec8fea2a$var$UrlConfiguration;

});

parcelRegister("6YfKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $hS003 = parcelRequire("hS003");
const $513490bd446d0d56$var$FOREGROUND = 'foreground';
const $513490bd446d0d56$var$BACKGROUND = 'background';
const $513490bd446d0d56$var$LISTENERS = [];
let $513490bd446d0d56$var$current = $513490bd446d0d56$var$FOREGROUND;
let $513490bd446d0d56$var$isUnloading = false;
const $513490bd446d0d56$var$_isCurrentlyVisible = ()=>{
    return $513490bd446d0d56$var$current === $513490bd446d0d56$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $513490bd446d0d56$var$_isCurrentlyVisible;
const $513490bd446d0d56$var$_isUnloading = ()=>$513490bd446d0d56$var$isUnloading;
module.exports._isUnloading = $513490bd446d0d56$var$_isUnloading;
const $513490bd446d0d56$var$_subscribeToVisiblityChanged = (listener)=>{
    $513490bd446d0d56$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $513490bd446d0d56$var$_subscribeToVisiblityChanged;
const $513490bd446d0d56$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $513490bd446d0d56$var$current) return;
    $513490bd446d0d56$var$current = visibility;
    $513490bd446d0d56$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $513490bd446d0d56$var$_notifyVisibilityChanged;
(0, $hS003._addWindowEventListenerSafe)('focus', ()=>{
    $513490bd446d0d56$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($513490bd446d0d56$var$FOREGROUND);
});
(0, $hS003._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($513490bd446d0d56$var$BACKGROUND));
(0, $hS003._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $513490bd446d0d56$var$FOREGROUND : $513490bd446d0d56$var$BACKGROUND);
});
(0, $hS003._addWindowEventListenerSafe)((0, $hS003._getUnloadEvent)(), ()=>{
    $513490bd446d0d56$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($513490bd446d0d56$var$BACKGROUND);
});

});


parcelRegister("aN3uI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $7db130e2f2fbf80d$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$7db130e2f2fbf80d$var$metadata,
    add: (additions)=>{
        $7db130e2f2fbf80d$var$metadata = Object.assign(Object.assign({}, $7db130e2f2fbf80d$var$metadata), additions);
    }
};

});

parcelRegister("lX0zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lgcfb", function(module, exports) {
"use strict";
var $f7a496f8b4937bb7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $1h5PR = parcelRequire("1h5PR");

var $4nbRD = parcelRequire("4nbRD");

var $8OjH2 = parcelRequire("8OjH2");

var $hbZwU = parcelRequire("hbZwU");

var $kzPIm = parcelRequire("kzPIm");
const $f7a496f8b4937bb7$var$CACHE_LIMIT = 10;
const $f7a496f8b4937bb7$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $f7a496f8b4937bb7$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $f7a496f8b4937bb7$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $f7a496f8b4937bb7$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $8OjH2._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $8OjH2._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $f7a496f8b4937bb7$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $4nbRD.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $f7a496f8b4937bb7$var$__awaiter(this, void 0, void 0, function*() {
            if (!$hbZwU.Storage.isReady()) yield $hbZwU.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $1h5PR.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $f7a496f8b4937bb7$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $8OjH2._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $f7a496f8b4937bb7$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $1h5PR.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $kzPIm._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $4nbRD.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $f7a496f8b4937bb7$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $f7a496f8b4937bb7$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $1h5PR.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $hbZwU.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($hbZwU.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $kzPIm._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $f7a496f8b4937bb7$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $hbZwU.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $hbZwU._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $f7a496f8b4937bb7$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $hbZwU.Storage.removeItem(evictable);
        }
        (0, $hbZwU._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $f7a496f8b4937bb7$var$DataAdapterCore;
function $f7a496f8b4937bb7$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $8OjH2._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $f7a496f8b4937bb7$var$_makeDataAdapterResult;
class $f7a496f8b4937bb7$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $1h5PR.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $f7a496f8b4937bb7$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $f7a496f8b4937bb7$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("4nbRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $lnSb5 = parcelRequire("lnSb5");

var $1h5PR = parcelRequire("1h5PR");

var $hS003 = parcelRequire("hS003");

var $hbZwU = parcelRequire("hbZwU");

var $b3sg7 = parcelRequire("b3sg7");
const $32f2835e2c2a3c55$var$PROMISE_MAP = {};
const $32f2835e2c2a3c55$var$COOKIE_ENABLED_MAP = {};
const $32f2835e2c2a3c55$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($32f2835e2c2a3c55$var$DISABLED_MAP[sdkKey]) return null;
        if ($32f2835e2c2a3c55$var$PROMISE_MAP[sdkKey] != null) return $32f2835e2c2a3c55$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $32f2835e2c2a3c55$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $32f2835e2c2a3c55$var$PROMISE_MAP[sdkKey] = stableID;
            $32f2835e2c2a3c55$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $32f2835e2c2a3c55$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $b3sg7.getUUID)();
        $32f2835e2c2a3c55$var$_persistToStorage(stableID, sdkKey);
        $32f2835e2c2a3c55$var$_persistToCookie(stableID, sdkKey);
        $32f2835e2c2a3c55$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $32f2835e2c2a3c55$var$PROMISE_MAP[sdkKey] = override;
        $32f2835e2c2a3c55$var$_persistToStorage(override, sdkKey);
        $32f2835e2c2a3c55$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $32f2835e2c2a3c55$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $32f2835e2c2a3c55$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $32f2835e2c2a3c55$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $lnSb5._getStorageKey)(sdkKey)}`;
}
function $32f2835e2c2a3c55$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $32f2835e2c2a3c55$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $hbZwU._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $1h5PR.Log.warn('Failed to save StableID to storage');
    }
}
function $32f2835e2c2a3c55$var$_loadFromStorage(sdkKey) {
    const storageKey = $32f2835e2c2a3c55$var$_getStableIDStorageKey(sdkKey);
    return (0, $hbZwU._getObjectFromStorage)(storageKey);
}
function $32f2835e2c2a3c55$var$_loadFromCookie(sdkKey) {
    if (!$32f2835e2c2a3c55$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hS003._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $32f2835e2c2a3c55$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $32f2835e2c2a3c55$var$_persistToCookie(stableID, sdkKey) {
    if (!$32f2835e2c2a3c55$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hS003._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$32f2835e2c2a3c55$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $32f2835e2c2a3c55$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $lnSb5._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $32f2835e2c2a3c55$var$getCookieName;

});
parcelRegister("b3sg7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $80c5e5306dc8fa16$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $80c5e5306dc8fa16$var$getUUID;

});


parcelRegister("8OjH2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $g9aIk = parcelRequire("g9aIk");

var $1h5PR = parcelRequire("1h5PR");
function $66a244e24a4f5448$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $1h5PR.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $66a244e24a4f5448$var$_normalizeUser;
function $66a244e24a4f5448$var$_getFullUserHash(user) {
    return user ? (0, $g9aIk._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $66a244e24a4f5448$var$_getFullUserHash;

});

parcelRegister("kzPIm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $1h5PR = parcelRequire("1h5PR");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $efaf30f20947da24$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $1h5PR.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $efaf30f20947da24$var$_typedJsonParse;

});


parcelRegister("gNbbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l2MHM", function(module, exports) {
"use strict";
var $f51f90b8f8ce4348$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $1h5PR = parcelRequire("1h5PR");

var $kVsqQ = parcelRequire("kVsqQ");

var $aN3uI = parcelRequire("aN3uI");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $f51f90b8f8ce4348$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $f51f90b8f8ce4348$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $f51f90b8f8ce4348$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $f51f90b8f8ce4348$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $1h5PR.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$f51f90b8f8ce4348$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($f51f90b8f8ce4348$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $f51f90b8f8ce4348$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $kVsqQ.SDKType._get(this._sdkKey);
                    const statsigMetadata = $aN3uI.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $f51f90b8f8ce4348$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $f51f90b8f8ce4348$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $f51f90b8f8ce4348$var$ErrorBoundary;
function $f51f90b8f8ce4348$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $f51f90b8f8ce4348$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $f51f90b8f8ce4348$var$UNKNOWN_ERROR;
    }
}
function $f51f90b8f8ce4348$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $f51f90b8f8ce4348$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("kVsqQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $f3bf2f7edf690e53$var$SDK_CLIENT = {};
let $f3bf2f7edf690e53$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $f3bf2f7edf690e53$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($f3bf2f7edf690e53$var$suffix !== null && $f3bf2f7edf690e53$var$suffix !== void 0 ? $f3bf2f7edf690e53$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $f3bf2f7edf690e53$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$f3bf2f7edf690e53$var$suffix || $f3bf2f7edf690e53$var$suffix === '-react') $f3bf2f7edf690e53$var$suffix = '-' + binding;
    }
};

});


parcelRegister("85Aoq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fMQ3y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("DnYFc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9bGSs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $6b0666a9342a5f94$var$EXIST_KEYS = new Set([]);
const $6b0666a9342a5f94$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $6b0666a9342a5f94$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($6b0666a9342a5f94$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($6b0666a9342a5f94$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $6b0666a9342a5f94$var$createMemoKey;

});

parcelRegister("l2btr", function(module, exports) {
"use strict";
var $f502af59f5a35520$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $2Hh0N = parcelRequire("2Hh0N");

var $2Hh0N = parcelRequire("2Hh0N");

var $iI65A = parcelRequire("iI65A");

var $1h5PR = parcelRequire("1h5PR");

var $eLloc = parcelRequire("eLloc");

var $dYGOG = parcelRequire("dYGOG");

var $bzEPW = parcelRequire("bzEPW");

var $kVsqQ = parcelRequire("kVsqQ");

var $hS003 = parcelRequire("hS003");

var $2GvH6 = parcelRequire("2GvH6");

var $4nbRD = parcelRequire("4nbRD");

var $48DBK = parcelRequire("48DBK");

var $aN3uI = parcelRequire("aN3uI");

var $GWIwJ = parcelRequire("GWIwJ");

var $6YfKH = parcelRequire("6YfKH");
const $f502af59f5a35520$var$DEFAULT_TIMEOUT_MS = 10000;
const $f502af59f5a35520$var$BACKOFF_BASE_MS = 500;
const $f502af59f5a35520$var$BACKOFF_MAX_MS = 30000;
const $f502af59f5a35520$var$RATE_LIMIT_WINDOW_MS = 1000;
const $f502af59f5a35520$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $f502af59f5a35520$var$LEAK_RATE = $f502af59f5a35520$var$RATE_LIMIT_MAX_REQ_COUNT / $f502af59f5a35520$var$RATE_LIMIT_WINDOW_MS;
const $f502af59f5a35520$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $f502af59f5a35520$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $f502af59f5a35520$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $dYGOG.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$f502af59f5a35520$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $f502af59f5a35520$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $f502af59f5a35520$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$f502af59f5a35520$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $1h5PR.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $6YfKH._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $f502af59f5a35520$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $f502af59f5a35520$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $f502af59f5a35520$var$_getErrorMessage(error);
                const timedOut = $f502af59f5a35520$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $f502af59f5a35520$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$f502af59f5a35520$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $48DBK.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $1h5PR.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $f502af59f5a35520$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $GWIwJ.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $GWIwJ.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $f502af59f5a35520$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $f502af59f5a35520$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $eLloc.Endpoint._initialize || args.urlConfig.endpoint === $eLloc.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$eLloc.NetworkParam.SdkKey]: args.sdkKey,
            [$eLloc.NetworkParam.SdkType]: $kVsqQ.SDKType._get(args.sdkKey),
            [$eLloc.NetworkParam.SdkVersion]: $aN3uI.SDK_VERSION,
            [$eLloc.NetworkParam.Time]: String(Date.now()),
            [$eLloc.NetworkParam.SessionID]: $2GvH6.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $hS003._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $2Hh0N._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$eLloc.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $1h5PR.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $f502af59f5a35520$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$f502af59f5a35520$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($1h5PR.Log.error);
                writer.close().catch($1h5PR.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$eLloc.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $1h5PR.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $f502af59f5a35520$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $f502af59f5a35520$var$NetworkCore;
const $f502af59f5a35520$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $1h5PR.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $f502af59f5a35520$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $4nbRD.StableID.get(sdkKey);
    const sessionID = $2GvH6.SessionID.get(sdkKey);
    const sdkType = $kVsqQ.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $aN3uI.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $f502af59f5a35520$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $2Hh0N._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $bzEPW.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $GWIwJ.LogEventCompressionMode.Disabled:
            return false;
        case $GWIwJ.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $GWIwJ.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $f502af59f5a35520$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $f502af59f5a35520$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $f502af59f5a35520$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $eLloc.Endpoint._initialize) return;
    $iI65A.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $f502af59f5a35520$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $eLloc.Endpoint._initialize) return;
    $iI65A.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $iI65A.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $f502af59f5a35520$var$_exponentialBackoff(attempt) {
    return $f502af59f5a35520$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($f502af59f5a35520$var$BACKOFF_BASE_MS * (attempt * attempt), $f502af59f5a35520$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("dYGOG", function(module, exports) {
"use strict";
var $a2d2176fa3827d1a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $03Efq = parcelRequire("03Efq");

var $g9aIk = parcelRequire("g9aIk");

var $1h5PR = parcelRequire("1h5PR");

var $hbZwU = parcelRequire("hbZwU");
const $a2d2176fa3827d1a$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $a2d2176fa3827d1a$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $a2d2176fa3827d1a$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $a2d2176fa3827d1a$var$DEFAULT_TTL_MS;
        $a2d2176fa3827d1a$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $a2d2176fa3827d1a$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $a2d2176fa3827d1a$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $a2d2176fa3827d1a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$a2d2176fa3827d1a$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $a2d2176fa3827d1a$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $a2d2176fa3827d1a$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $a2d2176fa3827d1a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $a2d2176fa3827d1a$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $03Efq._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $a2d2176fa3827d1a$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $a2d2176fa3827d1a$var$NetworkFallbackResolver;
function $a2d2176fa3827d1a$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $a2d2176fa3827d1a$var$_isDomainFailure;
function $a2d2176fa3827d1a$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $g9aIk._DJB2)(sdkKey)}`;
}
function $a2d2176fa3827d1a$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $a2d2176fa3827d1a$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $hbZwU.Storage.removeItem(hashKey);
        return;
    }
    $hbZwU.Storage.setItem(hashKey, JSON.stringify(info));
}
function $a2d2176fa3827d1a$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $a2d2176fa3827d1a$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $hbZwU.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $1h5PR.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $a2d2176fa3827d1a$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("03Efq", function(module, exports) {
"use strict";
var $00af80539684371e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $00af80539684371e$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $00af80539684371e$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $00af80539684371e$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $00af80539684371e$var$MAX_START_LOOKUP = 200;
function $00af80539684371e$var$_fetchTxtRecords(networkFunc) {
    return $00af80539684371e$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($00af80539684371e$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $00af80539684371e$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $00af80539684371e$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $00af80539684371e$var$_fetchTxtRecords;
function $00af80539684371e$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $00af80539684371e$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $00af80539684371e$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("bzEPW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $86d2a3eb482f582b$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $86d2a3eb482f582b$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $86d2a3eb482f582b$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("2GvH6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $2Hh0N = parcelRequire("2Hh0N");

var $lnSb5 = parcelRequire("lnSb5");

var $1h5PR = parcelRequire("1h5PR");

var $hbZwU = parcelRequire("hbZwU");

var $b3sg7 = parcelRequire("b3sg7");
const $1f4816cf0906f319$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $1f4816cf0906f319$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $1f4816cf0906f319$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($1f4816cf0906f319$var$PROMISE_MAP[sdkKey] == null) $1f4816cf0906f319$var$PROMISE_MAP[sdkKey] = $1f4816cf0906f319$var$_loadSession(sdkKey);
        const session = $1f4816cf0906f319$var$PROMISE_MAP[sdkKey];
        return $1f4816cf0906f319$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $1f4816cf0906f319$var$PROMISE_MAP[sdkKey] = $1f4816cf0906f319$var$_overrideSessionId(override, sdkKey);
    }
};
function $1f4816cf0906f319$var$_loadSession(sdkKey) {
    let data = $1f4816cf0906f319$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $b3sg7.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $1f4816cf0906f319$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $1f4816cf0906f319$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($1f4816cf0906f319$var$_isIdle(data) || $1f4816cf0906f319$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $b3sg7.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $1f4816cf0906f319$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $1f4816cf0906f319$var$_createSessionTimeout(sdkKey, $1f4816cf0906f319$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $1f4816cf0906f319$var$_createSessionTimeout(sdkKey, $1f4816cf0906f319$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $1f4816cf0906f319$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $2Hh0N._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $1f4816cf0906f319$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $1f4816cf0906f319$var$MAX_SESSION_IDLE_TIME;
}
function $1f4816cf0906f319$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $1f4816cf0906f319$var$MAX_SESSION_AGE;
}
function $1f4816cf0906f319$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $lnSb5._getStorageKey)(sdkKey)}`;
}
function $1f4816cf0906f319$var$_persistToStorage(session, sdkKey) {
    const storageKey = $1f4816cf0906f319$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $hbZwU._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $1h5PR.Log.warn('Failed to save SessionID');
    }
}
function $1f4816cf0906f319$var$_loadFromStorage(sdkKey) {
    const storageKey = $1f4816cf0906f319$var$_getSessionIDStorageKey(sdkKey);
    return (0, $hbZwU._getObjectFromStorage)(storageKey);
}

});

parcelRegister("48DBK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("4Vl08", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("leCKz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1rThw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $10e331d184e9d064$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $10e331d184e9d064$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $10e331d184e9d064$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $10e331d184e9d064$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $10e331d184e9d064$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $10e331d184e9d064$var$_fastApproxSizeOf;

});

parcelRegister("iVPs6", function(module, exports) {
"use strict";
var $dc85763ba944ee98$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $2Hh0N = parcelRequire("2Hh0N");

var $2Hh0N = parcelRequire("2Hh0N");

var $l2MHM = parcelRequire("l2MHM");

var $9eNVQ = parcelRequire("9eNVQ");

var $1h5PR = parcelRequire("1h5PR");

var $9bGSs = parcelRequire("9bGSs");

var $hS003 = parcelRequire("hS003");

var $2GvH6 = parcelRequire("2GvH6");

var $4nbRD = parcelRequire("4nbRD");

var $GWIwJ = parcelRequire("GWIwJ");

var $hbZwU = parcelRequire("hbZwU");
const $dc85763ba944ee98$var$MAX_MEMO_CACHE_SIZE = 3000;
class $dc85763ba944ee98$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($1h5PR.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $hbZwU.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $2GvH6.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $hbZwU.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $4nbRD.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $4nbRD.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $9eNVQ.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $l2MHM.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $hbZwU.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $dc85763ba944ee98$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $hbZwU.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $4nbRD.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($GWIwJ.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $dc85763ba944ee98$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $1h5PR.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $9bGSs.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $dc85763ba944ee98$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $dc85763ba944ee98$var$StatsigClientBase;
function $dc85763ba944ee98$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $hS003._isServerEnv)()) return;
    const statsigGlobal = (0, $2Hh0N._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $1h5PR.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("a0sEw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("gBltX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("acEYd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $1h5PR = parcelRequire("1h5PR");

var $dF6Y8 = parcelRequire("dF6Y8");
function $76dace2ef03c4d4d$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $76dace2ef03c4d4d$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $76dace2ef03c4d4d$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $76dace2ef03c4d4d$var$_makeFeatureGate;
function $76dace2ef03c4d4d$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $76dace2ef03c4d4d$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $76dace2ef03c4d4d$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $76dace2ef03c4d4d$var$_makeDynamicConfig;
function $76dace2ef03c4d4d$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $76dace2ef03c4d4d$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $76dace2ef03c4d4d$var$_makeExperiment;
function $76dace2ef03c4d4d$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $76dace2ef03c4d4d$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $76dace2ef03c4d4d$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $76dace2ef03c4d4d$var$_makeLayer;
function $76dace2ef03c4d4d$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $76dace2ef03c4d4d$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $76dace2ef03c4d4d$var$_mergeOverride;
function $76dace2ef03c4d4d$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $dF6Y8._isTypeMatch)(found, fallback)) {
            $1h5PR.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $76dace2ef03c4d4d$var$_makeTypedGet;

});

parcelRegister("lzIAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7dwEi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $541312b7f4526d94$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $541312b7f4526d94$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("2kCZ9", function(module, exports) {
"use strict";
var $1b2bb0b26d31d942$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d462y = parcelRequire("d462y");

var $3gjNT = parcelRequire("3gjNT");

var $farLf = parcelRequire("farLf");

var $1ZRh8 = parcelRequire("1ZRh8");

var $bAcuW = parcelRequire("bAcuW");
class $1b2bb0b26d31d942$var$StatsigClient extends $d462y.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $d462y._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $1b2bb0b26d31d942$var$StatsigClient) return instance;
        $d462y.Log.warn((0, $d462y._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $1b2bb0b26d31d942$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $d462y.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $farLf.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $bAcuW.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($d462y.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($d462y.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($d462y.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($d462y.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($d462y.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($d462y.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $3gjNT.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $d462y.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $d462y.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $1b2bb0b26d31d942$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $d462y.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $d462y.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $1b2bb0b26d31d942$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $1b2bb0b26d31d942$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $d462y.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $d462y.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $d462y.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $d462y.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($d462y.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $d462y.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $d462y.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $d462y.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $d462y.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $d462y.StatsigSession.get(this._sdkKey),
            stableID: $d462y.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $1b2bb0b26d31d942$var$__awaiter(this, void 0, void 0, function*() {
            if (!$d462y.Storage.isReady()) yield $d462y.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $d462y.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $d462y.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $d462y._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$d462y.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$d462y.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $d462y.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $d462y._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $d462y._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $d462y._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $d462y._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $d462y._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $d462y._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $d462y._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $d462y._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $d462y._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $d462y._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $1ZRh8._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $1ZRh8._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $1b2bb0b26d31d942$var$StatsigClient;

});
parcelRegister("3gjNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d462y = parcelRequire("d462y");

var $jMnkI = parcelRequire("jMnkI");

var $8DDgM = parcelRequire("8DDgM");
class $26023a581a714793$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $d462y._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $d462y._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $8DDgM.V2InitializeContainer(values);
        else this._values = new $jMnkI.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $d462y.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $d462y.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $d462y._getFullUserHash)(userForComparison) !== (0, $d462y._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $26023a581a714793$var$EvaluationStore;

});
parcelRegister("jMnkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $d462y = parcelRequire("d462y");
class $e66499814b5686ce$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $d462y._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $e66499814b5686ce$var$V1InitializeContainer;

});

parcelRegister("8DDgM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $d462y = parcelRequire("d462y");
class $64a06d60a44e38ef$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $d462y._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $64a06d60a44e38ef$var$V2InitializeContainer;

});


parcelRegister("farLf", function(module, exports) {
"use strict";
var $b0ad52f56e269190$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d462y = parcelRequire("d462y");

var $kS1AN = parcelRequire("kS1AN");
class $b0ad52f56e269190$var$StatsigNetwork extends $d462y.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $d462y.UrlConfiguration($d462y.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $b0ad52f56e269190$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $d462y._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $b0ad52f56e269190$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $kS1AN._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $b0ad52f56e269190$var$StatsigNetwork;

});
parcelRegister("kS1AN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $d462y = parcelRequire("d462y");
const $f31a160b71f9edf2$var$MAX_DELTAS_SORT_DEPTH = 2;
function $f31a160b71f9edf2$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $d462y._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $f31a160b71f9edf2$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $f31a160b71f9edf2$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $d462y._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $f31a160b71f9edf2$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $f31a160b71f9edf2$var$_resolveDeltasResponse;
function $f31a160b71f9edf2$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $f31a160b71f9edf2$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $f31a160b71f9edf2$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $f31a160b71f9edf2$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $f31a160b71f9edf2$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $f31a160b71f9edf2$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("1ZRh8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $d462y = parcelRequire("d462y");
const $1744d05875d0eb54$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $1744d05875d0eb54$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $1744d05875d0eb54$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $d462y._isTypeMatch)(value, fallback);
}
function $1744d05875d0eb54$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $1744d05875d0eb54$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $1744d05875d0eb54$var$_shouldLogExposure(options) ? undefined : $1744d05875d0eb54$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $1744d05875d0eb54$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $1744d05875d0eb54$var$_shouldLogExposure(options) ? undefined : $1744d05875d0eb54$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($1744d05875d0eb54$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1744d05875d0eb54$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $1744d05875d0eb54$var$_shouldLogExposure(options) ? undefined : $1744d05875d0eb54$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($1744d05875d0eb54$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1744d05875d0eb54$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $1744d05875d0eb54$var$_shouldLogExposure(options) ? undefined : $1744d05875d0eb54$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($1744d05875d0eb54$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1744d05875d0eb54$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $d462y._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $1744d05875d0eb54$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $1744d05875d0eb54$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $1744d05875d0eb54$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $1744d05875d0eb54$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $1744d05875d0eb54$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $1744d05875d0eb54$var$_makeParamStoreGetter;

});

parcelRegister("bAcuW", function(module, exports) {
"use strict";
var $86ecc05e5b149b48$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $d462y = parcelRequire("d462y");

var $farLf = parcelRequire("farLf");
class $86ecc05e5b149b48$var$StatsigEvaluationsDataAdapter extends $d462y.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $farLf.default) this._network = network;
        else this._network = new $farLf.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $d462y._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $d462y._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $d462y.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $86ecc05e5b149b48$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $d462y._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$d462y.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $d462y._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $86ecc05e5b149b48$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("2NkRz", function(module, exports) {
$parcel$export(module.exports, "default", () => $48959f9a5add5eb4$export$2e2bcd8739ae039);

var $hAOKp = parcelRequire("hAOKp");
const $48959f9a5add5eb4$export$a66cbd9b2289cd78 = '@all-features';
class $48959f9a5add5eb4$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hAOKp)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($48959f9a5add5eb4$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($48959f9a5add5eb4$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($48959f9a5add5eb4$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $48959f9a5add5eb4$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});
parcelRegister("hAOKp", function(module, exports) {
'use strict';
var $cced29d879f755ea$var$has = Object.prototype.hasOwnProperty, $cced29d879f755ea$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $cced29d879f755ea$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $cced29d879f755ea$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $cced29d879f755ea$var$Events().__proto__) $cced29d879f755ea$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $cced29d879f755ea$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $cced29d879f755ea$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $cced29d879f755ea$var$EE(fn, context || emitter, once), evt = $cced29d879f755ea$var$prefix ? $cced29d879f755ea$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $cced29d879f755ea$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $cced29d879f755ea$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $cced29d879f755ea$var$EventEmitter() {
    this._events = new $cced29d879f755ea$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($cced29d879f755ea$var$has.call(events, name)) names.push($cced29d879f755ea$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $cced29d879f755ea$var$prefix ? $cced29d879f755ea$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $cced29d879f755ea$var$prefix ? $cced29d879f755ea$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $cced29d879f755ea$var$prefix ? $cced29d879f755ea$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $cced29d879f755ea$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $cced29d879f755ea$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $cced29d879f755ea$var$prefix ? $cced29d879f755ea$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $cced29d879f755ea$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $cced29d879f755ea$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $cced29d879f755ea$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cced29d879f755ea$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $cced29d879f755ea$var$prefix ? $cced29d879f755ea$var$prefix + event : event;
        if (this._events[evt]) $cced29d879f755ea$var$clearEvent(this, evt);
    } else {
        this._events = new $cced29d879f755ea$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$cced29d879f755ea$var$EventEmitter.prototype.off = $cced29d879f755ea$var$EventEmitter.prototype.removeListener;
$cced29d879f755ea$var$EventEmitter.prototype.addListener = $cced29d879f755ea$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$cced29d879f755ea$var$EventEmitter.prefixed = $cced29d879f755ea$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$cced29d879f755ea$var$EventEmitter.EventEmitter = $cced29d879f755ea$var$EventEmitter;
module.exports = $cced29d879f755ea$var$EventEmitter;

});


parcelRegister("a345n", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $7c811dd114a6d517$export$6dc24881a3d96325);

var $eln0K = parcelRequire("eln0K");

var $hROh8 = parcelRequire("hROh8");
class $7c811dd114a6d517$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        var _experiment$__evaluat;
        const config = new $7c811dd114a6d517$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $eln0K.migrateEvaluationDetails)(experiment.details), (0, $hROh8.migrateSecondaryExposures)(((_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures) ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        var _this$_onDefaultValue2;
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            var _this$_onDefaultValue;
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("eln0K", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $c0208cf69ce24bed$export$18ad168d3dbac899);

var $9kwjL = parcelRequire("9kwjL");
const $c0208cf69ce24bed$var$evaluationReasonMappings = Object.entries((0, $9kwjL.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $c0208cf69ce24bed$export$18ad168d3dbac899 = (details)=>{
    var _evaluationReasonMapp;
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: ((_evaluationReasonMapp = $c0208cf69ce24bed$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))) === null || _evaluationReasonMapp === void 0 ? void 0 : _evaluationReasonMapp[1]) ?? (0, $9kwjL.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("9kwjL", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $ca42724e7d844b24$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $ca42724e7d844b24$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});


parcelRegister("hROh8", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $9dc10e973edf6fc9$export$55fd683752d01e67);
const $9dc10e973edf6fc9$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("3izyf", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $542fde2a486364cf$export$936d0764594b6eb3);

var $eln0K = parcelRequire("eln0K");

var $hROh8 = parcelRequire("hROh8");
class $542fde2a486364cf$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
        const value = new $542fde2a486364cf$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $eln0K.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $hROh8.migrateSecondaryExposures)(((_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) ?? []), (0, $hROh8.migrateSecondaryExposures)(((_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) ?? []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        var _this$_logParameterFu;
        (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
    }
}

});

parcelRegister("c4GSy", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $032ce1111d617af5$export$1148cb79ceecd5fa);
/**
 * Deeply merges source objects into the target object.
 * Handles nested objects, but arrays are not handled (replaced).
 */ function $032ce1111d617af5$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $032ce1111d617af5$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $032ce1111d617af5$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $032ce1111d617af5$export$1148cb79ceecd5fa(target, ...sources);
}

});

parcelRegister("ajaeo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0147d4f03b655fe$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kScVw = parcelRequire("kScVw");

var $7wpKS = parcelRequire("7wpKS");

var $4IeGB = parcelRequire("4IeGB");
const $d0147d4f03b655fe$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $d0147d4f03b655fe$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $d0147d4f03b655fe$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $d0147d4f03b655fe$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $d0147d4f03b655fe$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $d0147d4f03b655fe$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $d0147d4f03b655fe$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $d0147d4f03b655fe$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $d0147d4f03b655fe$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $d0147d4f03b655fe$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $d0147d4f03b655fe$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4IeGB.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4IeGB.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $d0147d4f03b655fe$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $kScVw.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $kScVw.FeatureGateEnvironment).Production:
                return $d0147d4f03b655fe$export$18c93900db9358a4;
            case (0, $kScVw.FeatureGateEnvironment).Staging:
                return $d0147d4f03b655fe$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $kScVw.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $kScVw.FeatureGateEnvironment).Development:
                return $d0147d4f03b655fe$export$f058dbf75c3bc647;
            case (0, $kScVw.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $d0147d4f03b655fe$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $d0147d4f03b655fe$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $d0147d4f03b655fe$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $d0147d4f03b655fe$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $7wpKS.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $d0147d4f03b655fe$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$d0147d4f03b655fe$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$d0147d4f03b655fe$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("kScVw", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $454e334cbab2b6f8$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $454e334cbab2b6f8$export$c42b7bbc5e7ba555);
const $454e334cbab2b6f8$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $454e334cbab2b6f8$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $454e334cbab2b6f8$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("7wpKS", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $4c2a3197b3372191$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $4c2a3197b3372191$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("4IeGB", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $71c8e3fd3e7cce4c$export$286baf652d0b1206);
class $71c8e3fd3e7cce4c$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("7mYO3", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $e6aeca1ca813ea84$export$d119b37e5f788b43);

var $9hihM = parcelRequire("9hihM");

var $kScVw = parcelRequire("kScVw");
const $e6aeca1ca813ea84$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $9hihM.isFedRamp)() ? (0, $kScVw.PerimeterType).FEDRAMP_MODERATE : (0, $kScVw.PerimeterType).COMMERCIAL,
        ...options
    });

});
parcelRegister("9hihM", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $6b982a3403b025b8$export$64d6499adf9b2e51);

var $72VHd = parcelRequire("72VHd");
function $6b982a3403b025b8$export$64d6499adf9b2e51() {
    var _global$location;
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $72VHd.FEDRAMP_MODERATE);
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("72VHd", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $1f02e431d2838a35$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $1f02e431d2838a35$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $1f02e431d2838a35$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $1f02e431d2838a35$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $1f02e431d2838a35$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $1f02e431d2838a35$export$404582bc18fe4d9e);
const $1f02e431d2838a35$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $1f02e431d2838a35$export$f005e2e9f707cb5f = 'commercial';
const $1f02e431d2838a35$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $1f02e431d2838a35$export$a739cd5aac835909 = 'stg';
const $1f02e431d2838a35$export$42dd0cdd351a4a9 = 'prod';
const $1f02e431d2838a35$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("2pyIT", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $a06359d1b8f302a3$export$202946b690d26d22);
const $a06359d1b8f302a3$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};

});

parcelRegister("1qP4M", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $ee39eda4fe3ca2c6$export$55fffef3474104af);

var $hawTU = parcelRequire("hawTU");
class $ee39eda4fe3ca2c6$export$55fffef3474104af extends (0, $hawTU.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $hawTU.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $hawTU._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $hawTU._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $hawTU._getStorageKey)(this._getSdkKey(), user);
        return `${0, $hawTU.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("7vKTo", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $930fce006caa2dd2$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $930fce006caa2dd2$export$bcb28fbac1def494);

var $d462y = parcelRequire("d462y");
const $930fce006caa2dd2$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $930fce006caa2dd2$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $930fce006caa2dd2$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $930fce006caa2dd2$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $930fce006caa2dd2$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $930fce006caa2dd2$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $930fce006caa2dd2$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $930fce006caa2dd2$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $930fce006caa2dd2$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $930fce006caa2dd2$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($930fce006caa2dd2$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem($930fce006caa2dd2$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $d462y._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$930fce006caa2dd2$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($930fce006caa2dd2$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $930fce006caa2dd2$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($930fce006caa2dd2$var$djb2MapKey((0, $d462y._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $930fce006caa2dd2$var$makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($930fce006caa2dd2$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $d462y._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $930fce006caa2dd2$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($930fce006caa2dd2$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $d462y._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $930fce006caa2dd2$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});

parcelRegister("hCrrx", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $5e67e924084c94bb$export$fa1c2bbf4100b8bc);
const $5e67e924084c94bb$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("hZ1FQ", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $3ac22071f7985c24$export$3dad1db244472f32);
const $3ac22071f7985c24$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("6c82q", function(module, exports) {
$parcel$export(module.exports, "debug", () => $eebfe99fa7f4aca2$export$1c9f709888824e05);
var $eebfe99fa7f4aca2$var$_process, $eebfe99fa7f4aca2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $eebfe99fa7f4aca2$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($eebfe99fa7f4aca2$var$_process = globalThis.process) === null || $eebfe99fa7f4aca2$var$_process === void 0 || ($eebfe99fa7f4aca2$var$_process = $eebfe99fa7f4aca2$var$_process.env) === null || $eebfe99fa7f4aca2$var$_process === void 0 ? void 0 : $eebfe99fa7f4aca2$var$_process.JEST_WORKER_ID) !== undefined;
const $eebfe99fa7f4aca2$var$DEBUG_MODE = !$eebfe99fa7f4aca2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($eebfe99fa7f4aca2$var$_process2 = globalThis.process) === null || $eebfe99fa7f4aca2$var$_process2 === void 0 || ($eebfe99fa7f4aca2$var$_process2 = $eebfe99fa7f4aca2$var$_process2.env) === null || $eebfe99fa7f4aca2$var$_process2 === void 0 ? void 0 : $eebfe99fa7f4aca2$var$_process2.NODE_ENV) !== 'production';
const $eebfe99fa7f4aca2$export$1c9f709888824e05 = (...args)=>{
    if (!$eebfe99fa7f4aca2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("Q0gX6", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $1e595eb53f4aa448$export$b574c24e1e6490f5);

var $lAT6B = parcelRequire("lAT6B");
const $1e595eb53f4aa448$export$b574c24e1e6490f5 = (0, $lAT6B.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("lAT6B", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $b297f182bfe23c51$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $b297f182bfe23c51$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $b297f182bfe23c51$export$75f4a1454eff2805);

var $4eGW1 = parcelRequire("4eGW1");
const $b297f182bfe23c51$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $b297f182bfe23c51$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $b297f182bfe23c51$export$75f4a1454eff2805 = typeof $4eGW1 !== 'undefined' && typeof $4eGW1.env !== 'undefined';

});


parcelRegister("wVKBq", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $8833fe5a3f1297c4$export$92f8b531feaeb23d);

var $lAT6B = parcelRequire("lAT6B");
const $8833fe5a3f1297c4$export$92f8b531feaeb23d = (0, $lAT6B.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("ieD62", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $9c50704412cb5da3$export$54ea85357b4e0159);

var $lAT6B = parcelRequire("lAT6B");
const $9c50704412cb5da3$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $9c50704412cb5da3$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$9c50704412cb5da3$export$54ea85357b4e0159[0, $lAT6B.PFF_GLOBAL_KEY] = $9c50704412cb5da3$export$54ea85357b4e0159[0, $lAT6B.PFF_GLOBAL_KEY] || $9c50704412cb5da3$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("actRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2f7ab5ba78fae7e$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $b2f7ab5ba78fae7e$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $b2f7ab5ba78fae7e$export$2e2bcd8739ae039 = $b2f7ab5ba78fae7e$var$coinflip;

});

parcelRegister("6WHXQ", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $b185837b9d3dbfc5$export$23e69abaca7d0236);
const $b185837b9d3dbfc5$export$4c07c8a3507ce307 = 255;
const $b185837b9d3dbfc5$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $b185837b9d3dbfc5$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $b185837b9d3dbfc5$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(param)));
    } catch  {
        return false;
    }
}
function $b185837b9d3dbfc5$export$23e69abaca7d0236(name) {
    if (name.length <= $b185837b9d3dbfc5$export$4c07c8a3507ce307) return name;
    if ($b185837b9d3dbfc5$var$isGqlUrl(name)) return name;
    return name.slice(0, $b185837b9d3dbfc5$export$4c07c8a3507ce307);
}

});

parcelRegister("aae7p", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $becd1a3f22d5a5ce$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $becd1a3f22d5a5ce$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $becd1a3f22d5a5ce$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $becd1a3f22d5a5ce$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $becd1a3f22d5a5ce$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $becd1a3f22d5a5ce$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $becd1a3f22d5a5ce$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $becd1a3f22d5a5ce$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $becd1a3f22d5a5ce$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $becd1a3f22d5a5ce$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $becd1a3f22d5a5ce$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $becd1a3f22d5a5ce$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $becd1a3f22d5a5ce$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $becd1a3f22d5a5ce$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $becd1a3f22d5a5ce$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $becd1a3f22d5a5ce$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $becd1a3f22d5a5ce$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $becd1a3f22d5a5ce$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $becd1a3f22d5a5ce$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $becd1a3f22d5a5ce$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2wgiL = parcelRequire("2wgiL");

var $gdUUy = parcelRequire("gdUUy");
let $becd1a3f22d5a5ce$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $becd1a3f22d5a5ce$var$cachedIsFedrampModerate;
function $becd1a3f22d5a5ce$var$detectIsFedrampModerate() {
    if ($becd1a3f22d5a5ce$var$cachedIsFedrampModerate !== undefined) return $becd1a3f22d5a5ce$var$cachedIsFedrampModerate;
    try {
        $becd1a3f22d5a5ce$var$cachedIsFedrampModerate = (0, $2wgiL.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $becd1a3f22d5a5ce$var$cachedIsFedrampModerate = false;
    }
    return $becd1a3f22d5a5ce$var$cachedIsFedrampModerate;
}
function $becd1a3f22d5a5ce$export$89dc2b6be8cc261() {
    $becd1a3f22d5a5ce$var$cachedIsFedrampModerate = undefined;
}
function $becd1a3f22d5a5ce$export$1133b5e2873baa7a() {
    try {
        return $becd1a3f22d5a5ce$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $becd1a3f22d5a5ce$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $becd1a3f22d5a5ce$export$f9bb3bb330fb9609 = 'fy26.04';
function $becd1a3f22d5a5ce$export$2182e73d31080cbc() {
    return $becd1a3f22d5a5ce$export$f9bb3bb330fb9609;
}
const $becd1a3f22d5a5ce$export$d50dacda7fe6392b = 1000;
function $becd1a3f22d5a5ce$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = (newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof (enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) ?? [],
            ...Object.values(byExperience).flat()
        ];
        $becd1a3f22d5a5ce$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $becd1a3f22d5a5ce$var$config = newConfig;
}
function $becd1a3f22d5a5ce$export$44487a86467333c3() {
    return $becd1a3f22d5a5ce$var$config;
}
function $becd1a3f22d5a5ce$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    var _config;
    // 1. FedRAMP override always wins.
    if ($becd1a3f22d5a5ce$var$detectIsFedrampModerate()) return $becd1a3f22d5a5ce$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? ((_config = $becd1a3f22d5a5ce$var$config) === null || _config === void 0 || (_config = _config.vc) === null || _config === void 0 ? void 0 : _config.selectorConfig) ?? defaultConfig;
}
function $becd1a3f22d5a5ce$export$74bdb753f1cf4860() {
    var _config2;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config2 = $becd1a3f22d5a5ce$var$config) === null || _config2 === void 0 ? void 0 : _config2.enabled) !== false;
}
const $becd1a3f22d5a5ce$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $becd1a3f22d5a5ce$export$87fbc8e01b137811(experienceKey = '') {
    try {
        var _config$vc;
        if (!$becd1a3f22d5a5ce$var$config) return [];
        if ((_config$vc = $becd1a3f22d5a5ce$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _enabledVCRevisions$b;
            const { enabledVCRevisions: enabledVCRevisions } = $becd1a3f22d5a5ce$var$config.vc ?? {};
            if ($becd1a3f22d5a5ce$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $gdUUy.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($becd1a3f22d5a5ce$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $becd1a3f22d5a5ce$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $becd1a3f22d5a5ce$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $becd1a3f22d5a5ce$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $becd1a3f22d5a5ce$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $becd1a3f22d5a5ce$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $becd1a3f22d5a5ce$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $becd1a3f22d5a5ce$export$2d8f8d64dc343d7b() {
    if (!$becd1a3f22d5a5ce$var$config) return undefined;
    try {
        var _config3, _config3$getReactHydr;
        const stats = (_config3 = $becd1a3f22d5a5ce$var$config) === null || _config3 === void 0 || (_config3$getReactHydr = _config3.getReactHydrationStats) === null || _config3$getReactHydr === void 0 ? void 0 : _config3$getReactHydr.call(_config3);
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $becd1a3f22d5a5ce$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $becd1a3f22d5a5ce$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $becd1a3f22d5a5ce$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $becd1a3f22d5a5ce$export$48f4e0d964030a96(name, interactionType) {
    return $becd1a3f22d5a5ce$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $becd1a3f22d5a5ce$export$9c69f5a724f05f38(name, interactionType) {
    return $becd1a3f22d5a5ce$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $becd1a3f22d5a5ce$export$1d459f020c06ae34(name, interactionType) {
    return $becd1a3f22d5a5ce$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $becd1a3f22d5a5ce$export$29b9ffb14861a1d(capability) {
    if ((0, $gdUUy.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$becd1a3f22d5a5ce$var$config) return 0;
        const { capability: capabilityRate } = $becd1a3f22d5a5ce$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $becd1a3f22d5a5ce$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return 0;
        const gotConfig = $becd1a3f22d5a5ce$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $becd1a3f22d5a5ce$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $becd1a3f22d5a5ce$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$becd1a3f22d5a5ce$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $becd1a3f22d5a5ce$var$config;
        if (typingMethod != null && $becd1a3f22d5a5ce$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $becd1a3f22d5a5ce$export$2d311b3fd18dcab1() {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $becd1a3f22d5a5ce$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $becd1a3f22d5a5ce$export$4f4649ef27b6f5d6() {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $becd1a3f22d5a5ce$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $becd1a3f22d5a5ce$export$b150ddad71c80d77() {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $becd1a3f22d5a5ce$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $becd1a3f22d5a5ce$export$3c170167645a0eff() {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $becd1a3f22d5a5ce$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $becd1a3f22d5a5ce$export$d6dc9444bd15f70f() {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $becd1a3f22d5a5ce$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $becd1a3f22d5a5ce$export$20e8108b8ccdd0bd() {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $becd1a3f22d5a5ce$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $becd1a3f22d5a5ce$export$2a8604960d7d23d9 = 60000;
function $becd1a3f22d5a5ce$export$c681731847989445(ufoName) {
    try {
        if (!$becd1a3f22d5a5ce$var$config) return $becd1a3f22d5a5ce$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $becd1a3f22d5a5ce$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $becd1a3f22d5a5ce$export$2a8604960d7d23d9;
    } catch  {
        return $becd1a3f22d5a5ce$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("2wgiL", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $c270f848a4cf2e48$export$104cb891a6e90b3a);

var $1GOV7 = parcelRequire("1GOV7");

var $5GrQ1 = parcelRequire("5GrQ1");
function $c270f848a4cf2e48$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInFedramp) ?? false;
    }
    const atlCtxCookieValues = (0, $5GrQ1.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $1GOV7.FEDRAMP_MODERATE);
}

});
parcelRegister("1GOV7", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $7ffc39ad640f8c48$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $7ffc39ad640f8c48$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $7ffc39ad640f8c48$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $7ffc39ad640f8c48$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $7ffc39ad640f8c48$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $7ffc39ad640f8c48$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $7ffc39ad640f8c48$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $7ffc39ad640f8c48$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $7ffc39ad640f8c48$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $7ffc39ad640f8c48$export$b61e047ddcc35726);
const $7ffc39ad640f8c48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $7ffc39ad640f8c48$export$f005e2e9f707cb5f = 'commercial';
const $7ffc39ad640f8c48$export$17b81a3d6c98013c = 'isolated-cloud';
const $7ffc39ad640f8c48$export$a739cd5aac835909 = 'staging';
const $7ffc39ad640f8c48$export$42dd0cdd351a4a9 = 'prod';
const $7ffc39ad640f8c48$export$404582bc18fe4d9e = 'dev';
const $7ffc39ad640f8c48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $7ffc39ad640f8c48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $7ffc39ad640f8c48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $7ffc39ad640f8c48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $7ffc39ad640f8c48$export$b61e047ddcc35726 = 'GCP';
const $7ffc39ad640f8c48$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("5GrQ1", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $d520c6154bed6db1$export$3fa7b7af96286cc9);

var $1GOV7 = parcelRequire("1GOV7");

var $a3GZj = parcelRequire("a3GZj");
function $d520c6154bed6db1$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $a3GZj.getRawCookieValue)((0, $1GOV7.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $a3GZj.getRawCookieValue)((0, $1GOV7.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $a3GZj.getRawCookieValue)((0, $1GOV7.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("a3GZj", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $2c4cb1657f384bcd$export$aa09aab30a92256c);
function $2c4cb1657f384bcd$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});




parcelRegister("eUjaZ", function(module, exports) {
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $2fe21a748fcc0054$export$74b9ce7e9d206a8);

var $1N4QS = parcelRequire("1N4QS");
function $2fe21a748fcc0054$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        (0, $1N4QS.interactionBufferState).bufferInteractionData(interactionId, data);
        (0, $1N4QS.interactionBufferState).interactionBuffer.length = 0;
    }
}

});
parcelRegister("1N4QS", function(module, exports) {
$parcel$export(module.exports, "interactionBufferState", () => $20e07283cdeb1bba$export$af15cc1c63c2807a);
const $20e07283cdeb1bba$var$interactionBuffer = [];
const $20e07283cdeb1bba$export$af15cc1c63c2807a = {
    interactionBuffer: $20e07283cdeb1bba$var$interactionBuffer,
    bufferInteractionData: (interactionId, data)=>{
        $20e07283cdeb1bba$var$interactionBuffer.push({
            interactionId: interactionId,
            data: data
        });
    }
};

});


parcelRegister("b6J8s", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $4d86b4126aa2063f$export$e08487ea3ae92adb);
function $4d86b4126aa2063f$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}

});

parcelRegister("gwyU1", function(module, exports) {
$parcel$export(module.exports, "stringifyLabelStackFully", () => $06464ae61fa6b489$export$caeee352b541de1f);

var $2yL4e = parcelRequire("2yL4e");

var $ecrda = parcelRequire("ecrda");
function $06464ae61fa6b489$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = (0, $ecrda.sanitizeLabelStackName)(l.name);
        if ((0, $2yL4e.isSegmentLabel)(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}

});
parcelRegister("2yL4e", function(module, exports) {
$parcel$export(module.exports, "isSegmentLabel", () => $6f67516048c5b543$export$1adbaf5c2363e4ae);
function $6f67516048c5b543$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

});

parcelRegister("ecrda", function(module, exports) {
$parcel$export(module.exports, "sanitizeLabelStackName", () => $bed9d071612a615d$export$3535cd9da4961282);
function $bed9d071612a615d$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}

});


parcelRegister("aY4cu", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $fc246359a7099f79$export$17ab21d7be720b);

var $j3jZT = parcelRequire("j3jZT");

var $gdUUy = parcelRequire("gdUUy");

var $kGyQS = parcelRequire("kGyQS");

var $cGQlM = parcelRequire("cGQlM");
function $fc246359a7099f79$export$17ab21d7be720b() {
    if ((0, $gdUUy.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $kGyQS.getContextManager)() instanceof (0, $kGyQS.UFOContextManager)) {
            let contextManager = (0, $kGyQS.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $j3jZT.ROOT_CONTEXT));
        }
    } else (0, $cGQlM.state).context = null;
}

});
parcelRegister("j3jZT", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $ddedcf2d51a1a98e$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $ddedcf2d51a1a98e$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Get a key to uniquely identify a context value
 *
 * @since 1.0.0
 */ function $ddedcf2d51a1a98e$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
class $ddedcf2d51a1a98e$var$BaseContext {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ constructor(parentContext){
        // for minification
        const self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = (key)=>self._currentContext.get(key);
        self.setValue = (key, value)=>{
            const context = new $ddedcf2d51a1a98e$var$BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = (key)=>{
            const context = new $ddedcf2d51a1a98e$var$BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
}
const $ddedcf2d51a1a98e$export$78df28f9b2f9a7dc = new $ddedcf2d51a1a98e$var$BaseContext();

});

parcelRegister("kGyQS", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $93cd89af70cf27d9$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $93cd89af70cf27d9$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $93cd89af70cf27d9$export$dd301b96c16f583d);

var $j3jZT = parcelRequire("j3jZT");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $93cd89af70cf27d9$var$contextManager;
function $93cd89af70cf27d9$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $93cd89af70cf27d9$var$contextManager = ctxMgr;
}
function $93cd89af70cf27d9$export$831109c9f7727010() {
    return $93cd89af70cf27d9$var$contextManager;
}
class $93cd89af70cf27d9$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $j3jZT.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $j3jZT.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $j3jZT.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $j3jZT.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
   * whether the context manager is enabled or not
   */ this._enabled = false;
        /**
   * Keeps the reference to current context
   */ this._currentContext = (0, $j3jZT.ROOT_CONTEXT);
    }
}

});

parcelRegister("cGQlM", function(module, exports) {
$parcel$export(module.exports, "state", () => $fbb128934007c910$export$ca000e230c0caa3e);
const $fbb128934007c910$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("i2aoZ", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $73c836c47fcd5b9f$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $73c836c47fcd5b9f$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $73c836c47fcd5b9f$export$47fade9662f71000);

var $7yN2s = parcelRequire("7yN2s");
const $73c836c47fcd5b9f$export$5b78c989c8db2561 = new Map();
const $73c836c47fcd5b9f$export$2a5c8df26bb89760 = new Map();
function $73c836c47fcd5b9f$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $7yN2s.redactValue)(featureFlagValue);
    $73c836c47fcd5b9f$export$5b78c989c8db2561.set(featureFlagName, value);
    $73c836c47fcd5b9f$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("7yN2s", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $c492f656fdf5dfe8$export$fcc03ee4c944962f);

var $7uTBw = parcelRequire("7uTBw");

var $dh58I = parcelRequire("dh58I");
function $c492f656fdf5dfe8$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $dh58I.shouldRedactValue)(featureFlagValue) ? (0, $7uTBw.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("7uTBw", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $77f26f4069df0fee$export$42f4885608027d0c);
const $77f26f4069df0fee$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("dh58I", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $1048c174765f7307$export$7b4abba432e57989);
function $1048c174765f7307$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $1048c174765f7307$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $1048c174765f7307$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $1048c174765f7307$export$7b4abba432e57989(value) {
    return $1048c174765f7307$var$isString(value) && $1048c174765f7307$var$startsAsObject(value) || $1048c174765f7307$var$isObject(value);
}

});



parcelRegister("fwg5v", function(module, exports) {
$parcel$export(module.exports, "getInteractionId", () => $b01253f2f1e16b32$export$37bca3107733ac1e);

var $3GoE4 = parcelRequire("3GoE4");
const $b01253f2f1e16b32$export$37bca3107733ac1e = ()=>(0, $3GoE4.default);

});
parcelRegister("3GoE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $11131316e38bd2de$export$2e2bcd8739ae039);

var $fANwq = parcelRequire("fANwq");
class $11131316e38bd2de$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        if (oldId !== newId) (0, $fANwq.listeners).forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
const $11131316e38bd2de$var$initializeGlobalDefaultInteractionID = ()=>{
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    const instance = new $11131316e38bd2de$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $11131316e38bd2de$var$DefaultInteractionID = $11131316e38bd2de$var$initializeGlobalDefaultInteractionID();
var $11131316e38bd2de$export$2e2bcd8739ae039 = $11131316e38bd2de$var$DefaultInteractionID;

});
parcelRegister("fANwq", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $07fa07389a517443$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $07fa07389a517443$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
const $07fa07389a517443$export$58bed631278dbc67 = new Set();
const $07fa07389a517443$export$3e0c3023952f6774 = (listener)=>{
    $07fa07389a517443$export$58bed631278dbc67.add(listener);
    return ()=>{
        $07fa07389a517443$export$58bed631278dbc67.delete(listener);
    };
};

});



parcelRegister("aTUiL", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $faef417d3ffb62af$export$c3b002e13fbb9ef2);
const $faef417d3ffb62af$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("01S3s", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $c3fe322177ae9aba$export$c8760e11c713fafc);

var $khqjG = parcelRequire("khqjG");
const $c3fe322177ae9aba$export$c8760e11c713fafc = ()=>{
    (0, $khqjG.default).spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    (0, $khqjG.default).spanStates.clear();
};

});
parcelRegister("khqjG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f9a1f43dc202ee2$export$2e2bcd8739ae039);
// Shared across profiler renders and the public reset/flush entry points. Keep this
// outside React context so Suspense restarts cannot discard the initial render.
const $0f9a1f43dc202ee2$var$state = {
    startTimes: new Map(),
    spanStates: new Map(),
    lastActiveInteraction: undefined
};
var $0f9a1f43dc202ee2$export$2e2bcd8739ae039 = $0f9a1f43dc202ee2$var$state;

});


parcelRegister("eWbVM", function(module, exports) {
$parcel$export(module.exports, "newVCObserver", () => $934600a9ed80c0c7$export$c69731bddfc24d85);

var $aBymI = parcelRequire("aBymI");

var $j9CMq = parcelRequire("j9CMq");

var $fPuAr = parcelRequire("fPuAr");
function $934600a9ed80c0c7$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !(0, $aBymI.isEnvironmentSupported)();
    const observer = shouldMockVCObserver ? new (0, $j9CMq.VCObserverNOOP)() : new (0, $fPuAr.VCObserverWrapper)(opts);
    return observer;
}

});
parcelRegister("aBymI", function(module, exports) {
$parcel$export(module.exports, "isEnvironmentSupported", () => $e41b9b4f5c9181c1$export$68d57b133e88584d);

var $4eGW1 = parcelRequire("4eGW1");
var $e41b9b4f5c9181c1$var$_process;
// Some products set this variable to indicate it is running in SSR
let $e41b9b4f5c9181c1$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $e41b9b4f5c9181c1$var$isReactSSR = typeof $4eGW1 !== 'undefined' && Boolean((($e41b9b4f5c9181c1$var$_process = $4eGW1) === null || $e41b9b4f5c9181c1$var$_process === void 0 || ($e41b9b4f5c9181c1$var$_process = $e41b9b4f5c9181c1$var$_process.env) === null || $e41b9b4f5c9181c1$var$_process === void 0 ? void 0 : $e41b9b4f5c9181c1$var$_process.REACT_SSR) || false);
function $e41b9b4f5c9181c1$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($e41b9b4f5c9181c1$var$isReactSSR || $e41b9b4f5c9181c1$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}

});

parcelRegister("j9CMq", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $e9010fe983416d69$export$24d07287b49da906);
class $e9010fe983416d69$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("fPuAr", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $b551ec369785ace7$export$4a1fe1ab3c13bbf5);

var $aae7p = parcelRequire("aae7p");

var $iyEe7 = parcelRequire("iyEe7");

var $f73z5 = parcelRequire("f73z5");

var $iUSc2 = parcelRequire("iUSc2");

var $aBcsd = parcelRequire("aBcsd");
class $b551ec369785ace7$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $aBcsd.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $f73z5.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $aae7p.isVCRevisionEnabled)('fy25.01') || (0, $aae7p.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $iyEe7.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        var _window;
        // Process any SSR abort listeners that remain
        if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        var _this$newVCObserver;
        if ((0, $aae7p.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $aae7p.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver;
            (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                startTime: startTime
            });
        }
        (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        var _this$newVCObserver2;
        if ((0, $aae7p.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $aae7p.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver2;
            (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
        }
        (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
        (0, $iUSc2.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        var _this$oldVCObserver3;
        return ((_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) ?? null;
    }
    async getVCResult(param) {
        var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$;
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $aae7p.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $aae7p.isVCRevisionEnabled)('fy25.02', experienceKey) ? await ((_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param)) : {};
        const v3v4Result = await ((_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        }));
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...(v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        var _this$oldVCObserver5, _this$newVCObserver4;
        (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
        (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        var _this$oldVCObserver6, _this$newVCObserver5;
        (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
        (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        var _this$oldVCObserver7, _this$newVCObserver6;
        (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
        (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}

});
parcelRegister("iyEe7", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $7ac50015ef586f3c$export$1f70d263701b1d01);

var $gdUUy = parcelRequire("gdUUy");

var $aae7p = parcelRequire("aae7p");

var $juFEH = parcelRequire("juFEH");

var $iE9HG = parcelRequire("iE9HG");

var $5pXwG = parcelRequire("5pXwG");

var $hyW2l = parcelRequire("hyW2l");

var $dRrQW = parcelRequire("dRrQW");

var $1aMoJ = parcelRequire("1aMoJ");

var $4cQUY = parcelRequire("4cQUY");
const $7ac50015ef586f3c$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $7ac50015ef586f3c$var$UNUSED_SECTOR = 0;
function $7ac50015ef586f3c$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $7ac50015ef586f3c$export$1f70d263701b1d01 {
    static #_ = /** config * */ this.VCParts = [
        '25',
        '50',
        '75',
        '80',
        '85',
        '90',
        '95',
        '98',
        '99'
    ];
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $aae7p.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $7ac50015ef586f3c$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $7ac50015ef586f3c$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $7ac50015ef586f3c$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $5pXwG.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $5pXwG.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            var _window$__ufo_devtool2, _window2;
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) {
                                var _window$__ufo_devtool, _window;
                                (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                            }
                            // Handle v2
                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            var _window$__on_ufo_vc_d2, _window4;
                            if (!isTTVCv1Disabled) {
                                var _window$__on_ufo_vc_d, _window3;
                                (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                            }
                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $hyW2l.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $7ac50015ef586f3c$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $7ac50015ef586f3c$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $aae7p.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $juFEH.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $aae7p.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($7ac50015ef586f3c$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $gdUUy.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $juFEH.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    this.setAbortReason($7ac50015ef586f3c$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($7ac50015ef586f3c$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            var _window5;
            this.detachAbortListeners();
            let unbinds = (0, $iE9HG.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $4cQUY.Observers)({
            selectorConfig: (0, $aae7p.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $aae7p.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $7ac50015ef586f3c$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $7ac50015ef586f3c$var$UNUSED_SECTOR) {
            var _window$document;
            const element = {
                __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $7ac50015ef586f3c$var$UNUSED_SECTOR && ssrTime !== $7ac50015ef586f3c$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $7ac50015ef586f3c$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $7ac50015ef586f3c$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $7ac50015ef586f3c$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $7ac50015ef586f3c$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $7ac50015ef586f3c$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    var _componentsLog$time;
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            var _acc$abs, _componentsLog$timest, _acc$rel;
            const currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (((_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $7ac50015ef586f3c$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $aae7p.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($7ac50015ef586f3c$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $1aMoJ.getViewportWidth)();
        this.viewport.h = (0, $dRrQW.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($7ac50015ef586f3c$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($7ac50015ef586f3c$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $7ac50015ef586f3c$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("iE9HG", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $d91e35e666528782$export$9010aa71841a6887);

var $bAB3U = parcelRequire("bAB3U");

var $15Wm0 = parcelRequire("15Wm0");

var $dRrQW = parcelRequire("dRrQW");

var $1aMoJ = parcelRequire("1aMoJ");
function $d91e35e666528782$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $bAB3U.bind)(window, {
        type: (0, $15Wm0.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $15Wm0.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $bAB3U.bind)(window, {
        type: (0, $15Wm0.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $15Wm0.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $bAB3U.bind)(window, {
        type: (0, $15Wm0.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $1aMoJ.getViewportWidth)() !== initialViewPort.w || (0, $dRrQW.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $15Wm0.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("bAB3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $2Pa73 = parcelRequire("2Pa73");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $2Pa73.bind;
    }
});

var $fhGK3 = parcelRequire("fhGK3");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $fhGK3.bindAll;
    }
});

});
parcelRegister("2Pa73", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $20e8305e95dbcc5c$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $20e8305e95dbcc5c$var$bind;

});

parcelRegister("fhGK3", function(module, exports) {
"use strict";
var $b209992b9e886665$var$__assign = module.exports && module.exports.__assign || function() {
    $b209992b9e886665$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b209992b9e886665$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $2Pa73 = parcelRequire("2Pa73");
function $b209992b9e886665$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $b209992b9e886665$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $b209992b9e886665$var$__assign($b209992b9e886665$var$__assign({}, original), {
        options: $b209992b9e886665$var$__assign($b209992b9e886665$var$__assign({}, $b209992b9e886665$var$toOptions(sharedOptions)), $b209992b9e886665$var$toOptions(original.options))
    });
    return binding;
}
function $b209992b9e886665$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $b209992b9e886665$var$getBinding(original, sharedOptions);
        return (0, $2Pa73.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $b209992b9e886665$var$bindAll;

});


parcelRegister("15Wm0", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $7ac4ad2d901a1cca$export$199edc0307b5587f);
const $7ac4ad2d901a1cca$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("dRrQW", function(module, exports) {
$parcel$export(module.exports, "getViewportHeight", () => $7134b98f40d60786$export$4f01c15d21ef9cc6);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $7134b98f40d60786$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("1aMoJ", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $840b35e17c970ada$export$a497a1dcb4408212);
function $840b35e17c970ada$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});


parcelRegister("5pXwG", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $d8b6e32b587a8ba4$export$72e6dda9d5859230);
function $d8b6e32b587a8ba4$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                    rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                    visible: true,
                    attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                    oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                    newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                    ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("hyW2l", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $00a50223aa0856d1$export$5c86a34c9becd6d0);

var $aae7p = parcelRequire("aae7p");

var $2oIl7 = parcelRequire("2oIl7");
const $00a50223aa0856d1$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $00a50223aa0856d1$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $00a50223aa0856d1$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $00a50223aa0856d1$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $00a50223aa0856d1$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $00a50223aa0856d1$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $2oIl7.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $aae7p.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $00a50223aa0856d1$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $aae7p.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $00a50223aa0856d1$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});
parcelRegister("2oIl7", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $0c0739725ad3d2df$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $0c0739725ad3d2df$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $0c0739725ad3d2df$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $0c0739725ad3d2df$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $0c0739725ad3d2df$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $0c0739725ad3d2df$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $0c0739725ad3d2df$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $0c0739725ad3d2df$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $bAB3U = parcelRequire("bAB3U");

var $gdUUy = parcelRequire("gdUUy");
const $0c0739725ad3d2df$var$timings = [];
let $0c0739725ad3d2df$var$wasHiddenFlag;
let $0c0739725ad3d2df$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $0c0739725ad3d2df$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $0c0739725ad3d2df$var$openedInBackground = null;
function $0c0739725ad3d2df$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $0c0739725ad3d2df$var$SIZE = 50;
let $0c0739725ad3d2df$var$insertIndex = 0;
function $0c0739725ad3d2df$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    const earliestHiddenTiming = (_timings$find = $0c0739725ad3d2df$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $0c0739725ad3d2df$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $0c0739725ad3d2df$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $0c0739725ad3d2df$var$openedInBackground === true;
}
function $0c0739725ad3d2df$var$pushHidden(isPageHiddenFlag, time) {
    $0c0739725ad3d2df$var$timings[$0c0739725ad3d2df$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $0c0739725ad3d2df$var$insertIndex = ($0c0739725ad3d2df$var$insertIndex + 1) % $0c0739725ad3d2df$var$SIZE;
    $0c0739725ad3d2df$var$wasHiddenFlag = isPageHiddenFlag;
}
function $0c0739725ad3d2df$var$handleChange() {
    const isPageHiddenFlag = $0c0739725ad3d2df$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$0c0739725ad3d2df$var$wasHiddenFlag) $0c0739725ad3d2df$var$pushHidden(isPageHiddenFlag);
        $0c0739725ad3d2df$var$wasHiddenFlag = true;
    } else {
        if ($0c0739725ad3d2df$var$wasHiddenFlag) $0c0739725ad3d2df$var$pushHidden(isPageHiddenFlag);
        $0c0739725ad3d2df$var$wasHiddenFlag = false;
    }
}
let $0c0739725ad3d2df$var$hasHiddenTimingBeforeSetup = false;
function $0c0739725ad3d2df$export$95f048bd8bcdda23() {
    return $0c0739725ad3d2df$var$hasHiddenTimingBeforeSetup;
}
function $0c0739725ad3d2df$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach((result)=>{
            if ((0, $gdUUy.fg)('platform_ufo_use_native_page_visibility_api')) $0c0739725ad3d2df$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $0c0739725ad3d2df$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $bAB3U.bind)(window, {
        type: 'pageshow',
        listener: $0c0739725ad3d2df$var$handleChange
    });
    (0, $bAB3U.bind)(window, {
        type: 'pagehide',
        listener: $0c0739725ad3d2df$var$handleChange
    });
    (0, $bAB3U.bind)(document, {
        type: 'visibilitychange',
        listener: $0c0739725ad3d2df$var$handleChange
    });
}
function $0c0739725ad3d2df$export$554cefe0f0373da4() {
    if (!$0c0739725ad3d2df$var$setupFlag) {
        const isPageHiddenFlag = $0c0739725ad3d2df$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($0c0739725ad3d2df$var$openedInBackground === null) $0c0739725ad3d2df$var$openedInBackground = isPageHiddenFlag && setupTime < $0c0739725ad3d2df$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $0c0739725ad3d2df$var$pushHidden(isPageHiddenFlag, 0);
        $0c0739725ad3d2df$var$setup();
        $0c0739725ad3d2df$var$setupFlag = true;
    }
}
function $0c0739725ad3d2df$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($0c0739725ad3d2df$var$timings.length === 0) return 'visible';
    const currentSize = $0c0739725ad3d2df$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $0c0739725ad3d2df$var$insertIndex;
    let endIdx = $0c0739725ad3d2df$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($0c0739725ad3d2df$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($0c0739725ad3d2df$var$timings[tmpIdx] && $0c0739725ad3d2df$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($0c0739725ad3d2df$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $0c0739725ad3d2df$var$timings[startIdx]) hiddenState = $0c0739725ad3d2df$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $0c0739725ad3d2df$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $0c0739725ad3d2df$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $0c0739725ad3d2df$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $0c0739725ad3d2df$var$throttleMeasurements = [];
let $0c0739725ad3d2df$var$throttleInsertIndex = 0;
let $0c0739725ad3d2df$var$throttleIntervalId = null;
let $0c0739725ad3d2df$var$lastThrottleCheckTime = null;
let $0c0739725ad3d2df$var$throttleSetupDone = false;
function $0c0739725ad3d2df$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $0c0739725ad3d2df$var$THROTTLE_DRIFT_THRESHOLD;
    $0c0739725ad3d2df$var$throttleMeasurements[$0c0739725ad3d2df$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $0c0739725ad3d2df$var$throttleInsertIndex = ($0c0739725ad3d2df$var$throttleInsertIndex + 1) % $0c0739725ad3d2df$var$THROTTLE_BUFFER_SIZE;
}
function $0c0739725ad3d2df$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($0c0739725ad3d2df$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $0c0739725ad3d2df$var$lastThrottleCheckTime;
        $0c0739725ad3d2df$var$recordThrottleMeasurement($0c0739725ad3d2df$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $0c0739725ad3d2df$var$lastThrottleCheckTime = currentTime;
}
function $0c0739725ad3d2df$export$fa0d29a9c87052da() {
    if ($0c0739725ad3d2df$var$throttleSetupDone) return;
    $0c0739725ad3d2df$var$throttleSetupDone = true;
    // Record the initial timestamp
    $0c0739725ad3d2df$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $0c0739725ad3d2df$var$throttleIntervalId = setInterval($0c0739725ad3d2df$var$throttleCheckCallback, $0c0739725ad3d2df$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $0c0739725ad3d2df$export$3279694d66e4a1() {
    if ($0c0739725ad3d2df$var$throttleIntervalId !== null) {
        clearInterval($0c0739725ad3d2df$var$throttleIntervalId);
        $0c0739725ad3d2df$var$throttleIntervalId = null;
    }
    $0c0739725ad3d2df$var$lastThrottleCheckTime = null;
    $0c0739725ad3d2df$var$throttleSetupDone = false;
    $0c0739725ad3d2df$var$throttleMeasurements.length = 0;
    $0c0739725ad3d2df$var$throttleInsertIndex = 0;
}
function $0c0739725ad3d2df$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($0c0739725ad3d2df$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $0c0739725ad3d2df$var$throttleMeasurements.length; i++){
        const measurement = $0c0739725ad3d2df$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $0c0739725ad3d2df$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $0c0739725ad3d2df$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $0c0739725ad3d2df$export$9332de935653b687(measurement) {
    $0c0739725ad3d2df$var$throttleMeasurements[$0c0739725ad3d2df$var$throttleInsertIndex] = measurement;
    $0c0739725ad3d2df$var$throttleInsertIndex = ($0c0739725ad3d2df$var$throttleInsertIndex + 1) % $0c0739725ad3d2df$var$THROTTLE_BUFFER_SIZE;
}
function $0c0739725ad3d2df$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($0c0739725ad3d2df$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $0c0739725ad3d2df$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($0c0739725ad3d2df$var$insertIndex + i) % currentSize;
        const entry = $0c0739725ad3d2df$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($0c0739725ad3d2df$var$insertIndex + i) % currentSize;
        const entry = $0c0739725ad3d2df$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $0c0739725ad3d2df$export$9332de935653b687
};

});


parcelRegister("4cQUY", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $f08413ba689927d6$export$b65d046240060e78);

var $aae7p = parcelRequire("aae7p");

var $jbnwL = parcelRequire("jbnwL");

var $04W4t = parcelRequire("04W4t");

var $iUSc2 = parcelRequire("iUSc2");

var $aBcsd = parcelRequire("aBcsd");
const $f08413ba689927d6$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $f08413ba689927d6$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $f08413ba689927d6$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $f08413ba689927d6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $aae7p.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $aBcsd.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        var _this$mutationObserve;
        this.totalTime = 0;
        this.ssr = {
            state: $f08413ba689927d6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        var _this$mutationObserve2, _this$intersectionObs;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $f08413ba689927d6$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $f08413ba689927d6$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $f08413ba689927d6$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $f08413ba689927d6$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $f08413ba689927d6$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $jbnwL.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            var _this$intersectionObs3;
                            this.elementsInView.delete(node);
                            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $04W4t.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $jbnwL.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                    return;
                    if (!$f08413ba689927d6$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $iUSc2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("jbnwL", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $8c8c56eb0bcbbd48$export$f61fbc3b9c4a9019);

var $dMuAK = parcelRequire("dMuAK");
function $8c8c56eb0bcbbd48$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $dMuAK.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("dMuAK", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $fd7c44161c17e298$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $fd7c44161c17e298$export$7028e9efe569888c);

var $bSJIT = parcelRequire("bSJIT");
const $fd7c44161c17e298$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $fd7c44161c17e298$export$7028e9efe569888c = {
    [$fd7c44161c17e298$export$7674290405cc25b0]: true
};
function $fd7c44161c17e298$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", $fd7c44161c17e298$export$7028e9efe569888c, children);
}

});
parcelRegister("bSJIT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("81tP6"));

});
parcelRegister("81tP6", function(module, exports) {
$parcel$export(module.exports, "Children", () => $5d758d00e5cd7dcc$export$dca3b0875bd9a954, (v) => $5d758d00e5cd7dcc$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $5d758d00e5cd7dcc$export$16fa2f45be04daa8, (v) => $5d758d00e5cd7dcc$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $5d758d00e5cd7dcc$export$ffb0004e005737fa, (v) => $5d758d00e5cd7dcc$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $5d758d00e5cd7dcc$export$e2c29f18771995cb, (v) => $5d758d00e5cd7dcc$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $5d758d00e5cd7dcc$export$221d75b3f55bb0bd, (v) => $5d758d00e5cd7dcc$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $5d758d00e5cd7dcc$export$5f8d39834fd61797, (v) => $5d758d00e5cd7dcc$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $5d758d00e5cd7dcc$export$74bf444e3cd11ea5, (v) => $5d758d00e5cd7dcc$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $5d758d00e5cd7dcc$export$ae55be85d98224ed, (v) => $5d758d00e5cd7dcc$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $5d758d00e5cd7dcc$export$3ba232387fd5d6dd, (v) => $5d758d00e5cd7dcc$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $5d758d00e5cd7dcc$export$e530037191fcd5d7, (v) => $5d758d00e5cd7dcc$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $5d758d00e5cd7dcc$export$fd42f52fd3ae1109, (v) => $5d758d00e5cd7dcc$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $5d758d00e5cd7dcc$export$c8a8987d4410bf2d, (v) => $5d758d00e5cd7dcc$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $5d758d00e5cd7dcc$export$d38cd72104c1f0e9, (v) => $5d758d00e5cd7dcc$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $5d758d00e5cd7dcc$export$7d1e3a5e95ceca43, (v) => $5d758d00e5cd7dcc$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $5d758d00e5cd7dcc$export$257a8862b851cb5b, (v) => $5d758d00e5cd7dcc$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $5d758d00e5cd7dcc$export$a8257692ac88316c, (v) => $5d758d00e5cd7dcc$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $5d758d00e5cd7dcc$export$488013bae63b21da, (v) => $5d758d00e5cd7dcc$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $5d758d00e5cd7dcc$export$7c73462e0d25e514, (v) => $5d758d00e5cd7dcc$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $5d758d00e5cd7dcc$export$7568632d0d33d16d, (v) => $5d758d00e5cd7dcc$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $5d758d00e5cd7dcc$export$88948ce120ea2619, (v) => $5d758d00e5cd7dcc$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $5d758d00e5cd7dcc$export$35808ee640e87ca7, (v) => $5d758d00e5cd7dcc$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $5d758d00e5cd7dcc$export$fae74005e78b1a27, (v) => $5d758d00e5cd7dcc$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $5d758d00e5cd7dcc$export$dc8fbce3eb94dc1e, (v) => $5d758d00e5cd7dcc$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $5d758d00e5cd7dcc$export$6a7bc4e911dc01cf, (v) => $5d758d00e5cd7dcc$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $5d758d00e5cd7dcc$export$6d9c69b0de29b591, (v) => $5d758d00e5cd7dcc$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $5d758d00e5cd7dcc$export$f680877a34711e37, (v) => $5d758d00e5cd7dcc$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $5d758d00e5cd7dcc$export$d5a552a76deda3c2, (v) => $5d758d00e5cd7dcc$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $5d758d00e5cd7dcc$export$aaabe4eda9ed9969, (v) => $5d758d00e5cd7dcc$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $5d758d00e5cd7dcc$export$e5c5a5f917a5871c, (v) => $5d758d00e5cd7dcc$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $5d758d00e5cd7dcc$export$1538c33de8887b59, (v) => $5d758d00e5cd7dcc$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $5d758d00e5cd7dcc$export$13e3392192263954, (v) => $5d758d00e5cd7dcc$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $5d758d00e5cd7dcc$export$b8f5890fc79d6aca, (v) => $5d758d00e5cd7dcc$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $5d758d00e5cd7dcc$export$60241385465d0a34, (v) => $5d758d00e5cd7dcc$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $5d758d00e5cd7dcc$export$306c0aa65ff9ec16, (v) => $5d758d00e5cd7dcc$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $5d758d00e5cd7dcc$export$7b286972b8d8ccbf, (v) => $5d758d00e5cd7dcc$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $5d758d00e5cd7dcc$export$83d89fbfd8236492, (v) => $5d758d00e5cd7dcc$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d758d00e5cd7dcc$export$dca3b0875bd9a954;
var $5d758d00e5cd7dcc$export$16fa2f45be04daa8;
var $5d758d00e5cd7dcc$export$ffb0004e005737fa;
var $5d758d00e5cd7dcc$export$e2c29f18771995cb;
var $5d758d00e5cd7dcc$export$221d75b3f55bb0bd;
var $5d758d00e5cd7dcc$export$5f8d39834fd61797;
var $5d758d00e5cd7dcc$export$74bf444e3cd11ea5;
var $5d758d00e5cd7dcc$export$ae55be85d98224ed;
var $5d758d00e5cd7dcc$export$3ba232387fd5d6dd;
var $5d758d00e5cd7dcc$export$e530037191fcd5d7;
var $5d758d00e5cd7dcc$export$fd42f52fd3ae1109;
var $5d758d00e5cd7dcc$export$c8a8987d4410bf2d;
var $5d758d00e5cd7dcc$export$d38cd72104c1f0e9;
var $5d758d00e5cd7dcc$export$7d1e3a5e95ceca43;
var $5d758d00e5cd7dcc$export$257a8862b851cb5b;
var $5d758d00e5cd7dcc$export$a8257692ac88316c;
var $5d758d00e5cd7dcc$export$488013bae63b21da;
var $5d758d00e5cd7dcc$export$7c73462e0d25e514;
var $5d758d00e5cd7dcc$export$7568632d0d33d16d;
var $5d758d00e5cd7dcc$export$88948ce120ea2619;
var $5d758d00e5cd7dcc$export$35808ee640e87ca7;
var $5d758d00e5cd7dcc$export$fae74005e78b1a27;
var $5d758d00e5cd7dcc$export$dc8fbce3eb94dc1e;
var $5d758d00e5cd7dcc$export$6a7bc4e911dc01cf;
var $5d758d00e5cd7dcc$export$6d9c69b0de29b591;
var $5d758d00e5cd7dcc$export$f680877a34711e37;
var $5d758d00e5cd7dcc$export$d5a552a76deda3c2;
var $5d758d00e5cd7dcc$export$aaabe4eda9ed9969;
var $5d758d00e5cd7dcc$export$e5c5a5f917a5871c;
var $5d758d00e5cd7dcc$export$1538c33de8887b59;
var $5d758d00e5cd7dcc$export$13e3392192263954;
var $5d758d00e5cd7dcc$export$b8f5890fc79d6aca;
var $5d758d00e5cd7dcc$export$60241385465d0a34;
var $5d758d00e5cd7dcc$export$306c0aa65ff9ec16;
var $5d758d00e5cd7dcc$export$7b286972b8d8ccbf;
var $5d758d00e5cd7dcc$export$83d89fbfd8236492;
'use strict';
var $5d758d00e5cd7dcc$var$l = Symbol.for("react.element"), $5d758d00e5cd7dcc$var$n = Symbol.for("react.portal"), $5d758d00e5cd7dcc$var$p = Symbol.for("react.fragment"), $5d758d00e5cd7dcc$var$q = Symbol.for("react.strict_mode"), $5d758d00e5cd7dcc$var$r = Symbol.for("react.profiler"), $5d758d00e5cd7dcc$var$t = Symbol.for("react.provider"), $5d758d00e5cd7dcc$var$u = Symbol.for("react.context"), $5d758d00e5cd7dcc$var$v = Symbol.for("react.forward_ref"), $5d758d00e5cd7dcc$var$w = Symbol.for("react.suspense"), $5d758d00e5cd7dcc$var$x = Symbol.for("react.memo"), $5d758d00e5cd7dcc$var$y = Symbol.for("react.lazy"), $5d758d00e5cd7dcc$var$z = Symbol.iterator;
function $5d758d00e5cd7dcc$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5d758d00e5cd7dcc$var$z && a[$5d758d00e5cd7dcc$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5d758d00e5cd7dcc$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5d758d00e5cd7dcc$var$C = Object.assign, $5d758d00e5cd7dcc$var$D = {};
function $5d758d00e5cd7dcc$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5d758d00e5cd7dcc$var$D;
    this.updater = e || $5d758d00e5cd7dcc$var$B;
}
$5d758d00e5cd7dcc$var$E.prototype.isReactComponent = {};
$5d758d00e5cd7dcc$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5d758d00e5cd7dcc$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5d758d00e5cd7dcc$var$F() {}
$5d758d00e5cd7dcc$var$F.prototype = $5d758d00e5cd7dcc$var$E.prototype;
function $5d758d00e5cd7dcc$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5d758d00e5cd7dcc$var$D;
    this.updater = e || $5d758d00e5cd7dcc$var$B;
}
var $5d758d00e5cd7dcc$var$H = $5d758d00e5cd7dcc$var$G.prototype = new $5d758d00e5cd7dcc$var$F;
$5d758d00e5cd7dcc$var$H.constructor = $5d758d00e5cd7dcc$var$G;
$5d758d00e5cd7dcc$var$C($5d758d00e5cd7dcc$var$H, $5d758d00e5cd7dcc$var$E.prototype);
$5d758d00e5cd7dcc$var$H.isPureReactComponent = !0;
var $5d758d00e5cd7dcc$var$I = Array.isArray, $5d758d00e5cd7dcc$var$J = Object.prototype.hasOwnProperty, $5d758d00e5cd7dcc$var$K = {
    current: null
}, $5d758d00e5cd7dcc$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5d758d00e5cd7dcc$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5d758d00e5cd7dcc$var$J.call(b, d) && !$5d758d00e5cd7dcc$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5d758d00e5cd7dcc$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5d758d00e5cd7dcc$var$K.current
    };
}
function $5d758d00e5cd7dcc$var$N(a, b) {
    return {
        $$typeof: $5d758d00e5cd7dcc$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5d758d00e5cd7dcc$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5d758d00e5cd7dcc$var$l;
}
function $5d758d00e5cd7dcc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5d758d00e5cd7dcc$var$P = /\/+/g;
function $5d758d00e5cd7dcc$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5d758d00e5cd7dcc$var$escape("" + a.key) : b.toString(36);
}
function $5d758d00e5cd7dcc$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5d758d00e5cd7dcc$var$l:
                case $5d758d00e5cd7dcc$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5d758d00e5cd7dcc$var$Q(h, 0) : d, $5d758d00e5cd7dcc$var$I(c) ? (e = "", null != a && (e = a.replace($5d758d00e5cd7dcc$var$P, "$&/") + "/"), $5d758d00e5cd7dcc$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5d758d00e5cd7dcc$var$O(c) && (c = $5d758d00e5cd7dcc$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5d758d00e5cd7dcc$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5d758d00e5cd7dcc$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5d758d00e5cd7dcc$var$Q(k, g);
        h += $5d758d00e5cd7dcc$var$R(k, b, e, f, c);
    }
    else if (f = $5d758d00e5cd7dcc$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5d758d00e5cd7dcc$var$Q(k, g++), h += $5d758d00e5cd7dcc$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5d758d00e5cd7dcc$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5d758d00e5cd7dcc$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5d758d00e5cd7dcc$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5d758d00e5cd7dcc$var$U = {
    current: null
}, $5d758d00e5cd7dcc$var$V = {
    transition: null
}, $5d758d00e5cd7dcc$var$W = {
    ReactCurrentDispatcher: $5d758d00e5cd7dcc$var$U,
    ReactCurrentBatchConfig: $5d758d00e5cd7dcc$var$V,
    ReactCurrentOwner: $5d758d00e5cd7dcc$var$K
};
function $5d758d00e5cd7dcc$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$5d758d00e5cd7dcc$export$dca3b0875bd9a954 = {
    map: $5d758d00e5cd7dcc$var$S,
    forEach: function(a, b, e) {
        $5d758d00e5cd7dcc$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $5d758d00e5cd7dcc$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5d758d00e5cd7dcc$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5d758d00e5cd7dcc$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5d758d00e5cd7dcc$export$16fa2f45be04daa8 = $5d758d00e5cd7dcc$var$E;
$5d758d00e5cd7dcc$export$ffb0004e005737fa = $5d758d00e5cd7dcc$var$p;
$5d758d00e5cd7dcc$export$e2c29f18771995cb = $5d758d00e5cd7dcc$var$r;
$5d758d00e5cd7dcc$export$221d75b3f55bb0bd = $5d758d00e5cd7dcc$var$G;
$5d758d00e5cd7dcc$export$5f8d39834fd61797 = $5d758d00e5cd7dcc$var$q;
$5d758d00e5cd7dcc$export$74bf444e3cd11ea5 = $5d758d00e5cd7dcc$var$w;
$5d758d00e5cd7dcc$export$ae55be85d98224ed = $5d758d00e5cd7dcc$var$W;
$5d758d00e5cd7dcc$export$3ba232387fd5d6dd = $5d758d00e5cd7dcc$var$X;
$5d758d00e5cd7dcc$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5d758d00e5cd7dcc$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5d758d00e5cd7dcc$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5d758d00e5cd7dcc$var$J.call(b, f) && !$5d758d00e5cd7dcc$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5d758d00e5cd7dcc$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5d758d00e5cd7dcc$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5d758d00e5cd7dcc$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5d758d00e5cd7dcc$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5d758d00e5cd7dcc$export$c8a8987d4410bf2d = $5d758d00e5cd7dcc$var$M;
$5d758d00e5cd7dcc$export$d38cd72104c1f0e9 = function(a) {
    var b = $5d758d00e5cd7dcc$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5d758d00e5cd7dcc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5d758d00e5cd7dcc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5d758d00e5cd7dcc$var$v,
        render: a
    };
};
$5d758d00e5cd7dcc$export$a8257692ac88316c = $5d758d00e5cd7dcc$var$O;
$5d758d00e5cd7dcc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5d758d00e5cd7dcc$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5d758d00e5cd7dcc$var$T
    };
};
$5d758d00e5cd7dcc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5d758d00e5cd7dcc$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5d758d00e5cd7dcc$export$7568632d0d33d16d = function(a) {
    var b = $5d758d00e5cd7dcc$var$V.transition;
    $5d758d00e5cd7dcc$var$V.transition = {};
    try {
        a();
    } finally{
        $5d758d00e5cd7dcc$var$V.transition = b;
    }
};
$5d758d00e5cd7dcc$export$88948ce120ea2619 = $5d758d00e5cd7dcc$var$X;
$5d758d00e5cd7dcc$export$35808ee640e87ca7 = function(a, b) {
    return $5d758d00e5cd7dcc$var$U.current.useCallback(a, b);
};
$5d758d00e5cd7dcc$export$fae74005e78b1a27 = function(a) {
    return $5d758d00e5cd7dcc$var$U.current.useContext(a);
};
$5d758d00e5cd7dcc$export$dc8fbce3eb94dc1e = function() {};
$5d758d00e5cd7dcc$export$6a7bc4e911dc01cf = function(a) {
    return $5d758d00e5cd7dcc$var$U.current.useDeferredValue(a);
};
$5d758d00e5cd7dcc$export$6d9c69b0de29b591 = function(a, b) {
    return $5d758d00e5cd7dcc$var$U.current.useEffect(a, b);
};
$5d758d00e5cd7dcc$export$f680877a34711e37 = function() {
    return $5d758d00e5cd7dcc$var$U.current.useId();
};
$5d758d00e5cd7dcc$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5d758d00e5cd7dcc$var$U.current.useImperativeHandle(a, b, e);
};
$5d758d00e5cd7dcc$export$aaabe4eda9ed9969 = function(a, b) {
    return $5d758d00e5cd7dcc$var$U.current.useInsertionEffect(a, b);
};
$5d758d00e5cd7dcc$export$e5c5a5f917a5871c = function(a, b) {
    return $5d758d00e5cd7dcc$var$U.current.useLayoutEffect(a, b);
};
$5d758d00e5cd7dcc$export$1538c33de8887b59 = function(a, b) {
    return $5d758d00e5cd7dcc$var$U.current.useMemo(a, b);
};
$5d758d00e5cd7dcc$export$13e3392192263954 = function(a, b, e) {
    return $5d758d00e5cd7dcc$var$U.current.useReducer(a, b, e);
};
$5d758d00e5cd7dcc$export$b8f5890fc79d6aca = function(a) {
    return $5d758d00e5cd7dcc$var$U.current.useRef(a);
};
$5d758d00e5cd7dcc$export$60241385465d0a34 = function(a) {
    return $5d758d00e5cd7dcc$var$U.current.useState(a);
};
$5d758d00e5cd7dcc$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5d758d00e5cd7dcc$var$U.current.useSyncExternalStore(a, b, e);
};
$5d758d00e5cd7dcc$export$7b286972b8d8ccbf = function() {
    return $5d758d00e5cd7dcc$var$U.current.useTransition();
};
$5d758d00e5cd7dcc$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("04W4t", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a32729faa82f9cb$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $4a32729faa82f9cb$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $4a32729faa82f9cb$export$2e2bcd8739ae039 = $4a32729faa82f9cb$var$isNonVisualStyleMutation;

});

parcelRegister("iUSc2", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $50f73fa020f0e1f1$export$166779fc0f49d4df);
const $50f73fa020f0e1f1$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $50f73fa020f0e1f1$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$50f73fa020f0e1f1$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$50f73fa020f0e1f1$var$GLOBAL_RLL_HANDLERS_KEY] = new $50f73fa020f0e1f1$export$166779fc0f49d4df();
            return globalThis[$50f73fa020f0e1f1$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $50f73fa020f0e1f1$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            var _el$dataset;
            if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("aBcsd", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $be93dcf00a629558$export$c0102f1a1198d10f);
const $be93dcf00a629558$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $be93dcf00a629558$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $be93dcf00a629558$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            var _el$dataset;
            const ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $be93dcf00a629558$var$PAGE_LAYOUT_ID) return $be93dcf00a629558$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            var _el$dataset2;
            const ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $be93dcf00a629558$var$PAGE_LAYOUT_ID) return $be93dcf00a629558$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            var _this$intersectionObs5;
            (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch  {}
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                var _window$__SSR_PLACEHO, _this$intersectionObs;
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $be93dcf00a629558$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $be93dcf00a629558$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $be93dcf00a629558$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $be93dcf00a629558$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs2;
                this.callbacks.set(id, resolve);
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            var _this$intersectionObs3;
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs4;
                this.reactValidateCallbacks.set(id, resolve);
                (_this$intersectionObs4 = this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});



parcelRegister("f73z5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3bf8907bede1ebe$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $aae7p = parcelRequire("aae7p");

var $ecrda = parcelRequire("ecrda");

var $juFEH = parcelRequire("juFEH");

var $aBcsd = parcelRequire("aBcsd");

var $bsxhn = parcelRequire("bsxhn");

var $8fkbN = parcelRequire("8fkbN");

var $cCzCj = parcelRequire("cCzCj");

var $iBo2p = parcelRequire("iBo2p");

var $bZYeN = parcelRequire("bZYeN");

var $hA7wP = parcelRequire("hA7wP");

var $2u3XA = parcelRequire("2u3XA");

var $689FD = parcelRequire("689FD");

var $eW9mr = parcelRequire("eW9mr");

var $eAXYh = parcelRequire("eAXYh");
const $f3bf8907bede1ebe$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $f3bf8907bede1ebe$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $f3bf8907bede1ebe$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $f3bf8907bede1ebe$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $bsxhn.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $aae7p.getSelectorConfig)(config.selectorConfig, $f3bf8907bede1ebe$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $f3bf8907bede1ebe$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $aBcsd.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: ((_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) ?? false
            });
        }
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $eW9mr.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    const labelStacks = $f3bf8907bede1ebe$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $eAXYh.default)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $gdUUy.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $juFEH.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                const abortEventTargetElement = $f3bf8907bede1ebe$var$isAbortEventTargetSupported(type) && event ? $f3bf8907bede1ebe$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
    start(_) {
        var _this$viewportObserve, _window, _this$windowEventObse;
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $f3bf8907bede1ebe$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
        this.entriesTimeline.clear();
        if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
    }
    stop() {
        var _this$viewportObserve2, _this$windowEventObse2;
        (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
        (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $f3bf8907bede1ebe$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $bZYeN.default)(),
                    width: (0, $hA7wP.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $bZYeN.default)(),
                    right: (0, $hA7wP.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $cCzCj.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $aae7p.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $iBo2p.default)();
        const calculator_next = new (0, $2u3XA.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $aae7p.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $aae7p.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $689FD.default)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $8fkbN.default)(this.selectorConfig, element);
    }
}
function $f3bf8907bede1ebe$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    const value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $f3bf8907bede1ebe$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $ecrda.sanitizeLabelStackName)(label.name)).join('/');
}
function $f3bf8907bede1ebe$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $ecrda.sanitizeLabelStackName)(label.name)).join('/');
}
function $f3bf8907bede1ebe$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $f3bf8907bede1ebe$var$labelStackFromFiber(currentFiber);
                labelStackString = $f3bf8907bede1ebe$var$labelStackToString(labelStack) || 'unknown';
                segment = $f3bf8907bede1ebe$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $f3bf8907bede1ebe$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $f3bf8907bede1ebe$var$traverseFiber(fiber) : null;
}
const $f3bf8907bede1ebe$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $f3bf8907bede1ebe$var$isAbortEventTargetSupported(type) {
    return $f3bf8907bede1ebe$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $f3bf8907bede1ebe$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("bsxhn", function(module, exports) {
$parcel$export(module.exports, "default", () => $753871a32ba21af9$export$2e2bcd8739ae039);
class $753871a32ba21af9$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        var _this$sortedEntriesCa;
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("8fkbN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9404552e8284157d$export$2e2bcd8739ae039);
const $9404552e8284157d$var$nameCache = new WeakMap();
function $9404552e8284157d$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $9404552e8284157d$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $9404552e8284157d$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $9404552e8284157d$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $9404552e8284157d$var$nameCache.set(element, name);
    return name;
}
var $9404552e8284157d$export$2e2bcd8739ae039 = $9404552e8284157d$var$getElementName;

});

parcelRegister("cCzCj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b639431733bc13d1$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $8T9n1 = parcelRequire("8T9n1");

var $5ntIg = parcelRequire("5ntIg");

var $eXpwR = parcelRequire("eXpwR");

var $g2drA = parcelRequire("g2drA");

var $2tUWV = parcelRequire("2tUWV");
const $b639431733bc13d1$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $b639431733bc13d1$var$REVISION_NO = 'fy25.03';
const $b639431733bc13d1$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $b639431733bc13d1$export$2e2bcd8739ae039 extends (0, $eXpwR.default) {
    constructor(revisionNo){
        super(revisionNo ?? $b639431733bc13d1$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$b639431733bc13d1$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $gdUUy.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $8T9n1.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $8T9n1.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $5ntIg.containsAnchorNameMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $g2drA.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $g2drA.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $g2drA.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) || (0, $g2drA.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName)) return false;
            return true;
        }
        if ((0, $2tUWV.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($b639431733bc13d1$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("8T9n1", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $182daeb0b5d4c43c$export$9db1624a8af791a4);

var $87QgR = parcelRequire("87QgR");

var $i2aoZ = parcelRequire("i2aoZ");
const $182daeb0b5d4c43c$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $87QgR.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $87QgR.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $i2aoZ.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("5ntIg", function(module, exports) {
$parcel$export(module.exports, "containsAnchorNameMutationInStyle", () => $55c71cd81e648447$export$f83f33200c1a234e);
$parcel$export(module.exports, "default", () => $55c71cd81e648447$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");
/**
 * Matches only the editor drag and drop anchors. This is the pre-gate behaviour.
 */ const $55c71cd81e648447$var$isDnDAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name: --node-anchor');
};
/**
 * Matches any `anchor-name` declaration.
 *
 * `anchor-name` (CSS Anchor Positioning) only names an element so that _other_
 * elements can position themselves against it. It never changes how the named
 * element itself renders, so adding or removing it is never a visual change.
 *
 * `@atlaskit/top-layer` writes `anchor-name` onto a popover's trigger as soon as
 * the popover host element exists, which for `Popover`-based consumers is first
 * open (for example, hovering an `@atlaskit/tooltip` trigger). Without this
 * exclusion that write is recorded as a repaint of the trigger at hover time,
 * which shifts TTVC in sessions where a user hovers a trigger before the page
 * has settled. See COPPER-1736.
 */ const $55c71cd81e648447$var$isAnyAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name:');
};
const $55c71cd81e648447$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a `style` change that consists only
 * of `anchor-name` declarations being added or removed.
 *
 * Without `platform_ufo_exclude_anchor_name_from_ttvc` this is limited to the
 * editor's drag and drop anchors (`--node-anchor…`), which is where the check
 * originated. With the gate on, every `anchor-name` is treated as non-visual,
 * because the property never affects the rendering of the element it is set on.
 *
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is an anchor-name-only style mutation
 */ function $55c71cd81e648447$export$7a0b59cebcbf44ec({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $55c71cd81e648447$export$f83f33200c1a234e({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $55c71cd81e648447$export$f83f33200c1a234e({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    // Resolved once per mutation rather than once per declaration: this runs
    // inside the MutationObserver callback.
    const isIgnoredDeclaration = (0, $gdUUy.fg)('platform_ufo_exclude_anchor_name_from_ttvc') ? $55c71cd81e648447$var$isAnyAnchorNameDeclaration : $55c71cd81e648447$var$isDnDAnchorNameDeclaration;
    const oldStyles = $55c71cd81e648447$var$parseStyleSet(oldValue);
    const newStyles = $55c71cd81e648447$var$parseStyleSet(newValue);
    let isAnchorNameMutation = false;
    for (const s of oldStyles ?? [])if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    for (const s of newStyles ?? [])if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(s))) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    return isAnchorNameMutation;
}
var $55c71cd81e648447$export$2e2bcd8739ae039 = $55c71cd81e648447$export$7a0b59cebcbf44ec;

});

parcelRegister("eXpwR", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd2e0e450d1f7630$export$2e2bcd8739ae039);

var $jS0uZ = parcelRequire("jS0uZ");

var $9Hdqj = parcelRequire("9Hdqj");

var $bZYeN = parcelRequire("bZYeN");

var $hA7wP = parcelRequire("hA7wP");

var $2tUWV = parcelRequire("2tUWV");
// Helper function for reporting ratios
function $dd2e0e450d1f7630$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $dd2e0e450d1f7630$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $hA7wP.default)();
        const viewportHeight = (0, $bZYeN.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $dd2e0e450d1f7630$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $2tUWV.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        var _window, _window2, _window3, _window4, _window6;
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $jS0uZ.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $hA7wP.default)(),
                height: (0, $bZYeN.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $9Hdqj.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>{
                    var _entry$rect, _entry$previousRect;
                    return {
                        ...entry,
                        rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                        previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                    };
                }),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                var _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou;
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push({
                    ...viewportData,
                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
            var _window5, _window5$__ufo_devtoo;
            (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
            var _window7, _window7$__on_ufo_vc_;
            (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        var _vcDetails$;
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) ?? false,
                    dist: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) ?? false
                },
                total_mut: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) ?? 0,
                mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': (vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("jS0uZ", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $b0bc1825fb03c726$export$96ea73435089b05a);

var $gdUUy = parcelRequire("gdUUy");

var $dAX2v = parcelRequire("dAX2v");

var $8LYXt = parcelRequire("8LYXt");

var $2JKmJ = parcelRequire("2JKmJ");
async function $b0bc1825fb03c726$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $2JKmJ.ViewportCanvas)(viewport, (0, $gdUUy.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return (0, $dAX2v.calculatePercentiles)(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $b0bc1825fb03c726$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $2JKmJ.ViewportCanvas)(viewport, (0, $gdUUy.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return (0, $8LYXt.calculatePercentilesWithDebugInfo)(timePixelCounts, elementMap, totalPixels, startTime);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b0bc1825fb03c726$export$2e2bcd8739ae039 = $b0bc1825fb03c726$var$calculateTTVCPercentiles;

});
parcelRegister("dAX2v", function(module, exports) {
$parcel$export(module.exports, "calculatePercentiles", () => $733a6d485190aad7$export$89c8da9b65eff678);
function $733a6d485190aad7$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}

});

parcelRegister("8LYXt", function(module, exports) {
$parcel$export(module.exports, "calculatePercentilesWithDebugInfo", () => $cd3d3dfa9ae289e5$export$a532ce01ea38d882);
function $cd3d3dfa9ae289e5$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});

parcelRegister("2JKmJ", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $6d19cb950863be13$export$3e59ac9de7402fb1);

var $lPpYI = parcelRequire("lPpYI");

var $dF69t = parcelRequire("dF69t");
class $6d19cb950863be13$export$3e59ac9de7402fb1 {
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return (0, $dF69t.getRGBComponents)(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await (0, $lPpYI.calculateDrawnPixelsRaw)(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = (0, $dF69t.getRGBComponents)(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}

});
parcelRegister("lPpYI", function(module, exports) {
$parcel$export(module.exports, "calculateDrawnPixelsRaw", () => $b720acb7cff5336f$export$fafc9be44839f9c8);

var $ceasY = parcelRequire("ceasY");
async function $b720acb7cff5336f$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $ceasY.default)();
    }
    return arr;
}

});
parcelRegister("ceasY", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e0a30a7e5c1aed8$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $5e0a30a7e5c1aed8$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $5e0a30a7e5c1aed8$export$2e2bcd8739ae039 = $5e0a30a7e5c1aed8$var$taskYield;

});


parcelRegister("dF69t", function(module, exports) {
$parcel$export(module.exports, "getRGBComponents", () => $667f23cbb38c4bab$export$54591583ed0b20ce);
function $667f23cbb38c4bab$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}

});



parcelRegister("9Hdqj", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $24edfa5471511913$export$93ce39b765ea2cd3);
const $24edfa5471511913$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $24edfa5471511913$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $24edfa5471511913$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $24edfa5471511913$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $24edfa5471511913$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $24edfa5471511913$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $24edfa5471511913$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $24edfa5471511913$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $24edfa5471511913$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("bZYeN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f7d09882db43b20$export$2e2bcd8739ae039);
function $6f7d09882db43b20$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $6f7d09882db43b20$export$2e2bcd8739ae039 = $6f7d09882db43b20$var$getViewportHeight;

});

parcelRegister("hA7wP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee78607af0a77d3e$export$2e2bcd8739ae039);
function $ee78607af0a77d3e$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $ee78607af0a77d3e$export$2e2bcd8739ae039 = $ee78607af0a77d3e$var$getViewportWidth;

});

parcelRegister("2tUWV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a51a92491c3b3790$export$2e2bcd8739ae039);
function $a51a92491c3b3790$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $a51a92491c3b3790$export$2e2bcd8739ae039 = $a51a92491c3b3790$var$isViewportEntryData;

});


parcelRegister("g2drA", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $1b306e62ad982c22$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $1b306e62ad982c22$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $1b306e62ad982c22$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $1b306e62ad982c22$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $1b306e62ad982c22$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $1b306e62ad982c22$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $1b306e62ad982c22$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $1b306e62ad982c22$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $1b306e62ad982c22$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $1b306e62ad982c22$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("iBo2p", function(module, exports) {
$parcel$export(module.exports, "default", () => $87bc34b51269a85d$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $cCzCj = parcelRequire("cCzCj");

var $g2drA = parcelRequire("g2drA");
const $87bc34b51269a85d$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $87bc34b51269a85d$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $87bc34b51269a85d$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $87bc34b51269a85d$export$2e2bcd8739ae039 extends (0, $cCzCj.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$87bc34b51269a85d$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $87bc34b51269a85d$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $gdUUy.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $g2drA.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $g2drA.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $g2drA.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES)
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $g2drA.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $g2drA.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $87bc34b51269a85d$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("2u3XA", function(module, exports) {
$parcel$export(module.exports, "default", () => $0037f3cd7173b1a1$export$2e2bcd8739ae039);

var $iBo2p = parcelRequire("iBo2p");
const $0037f3cd7173b1a1$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $0037f3cd7173b1a1$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $0037f3cd7173b1a1$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $0037f3cd7173b1a1$export$2e2bcd8739ae039 extends (0, $iBo2p.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$0037f3cd7173b1a1$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $0037f3cd7173b1a1$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($0037f3cd7173b1a1$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("689FD", function(module, exports) {
$parcel$export(module.exports, "default", () => $899d91f7d301ed08$export$2e2bcd8739ae039);

var $aae7p = parcelRequire("aae7p");

var $2oIl7 = parcelRequire("2oIl7");

var $bZYeN = parcelRequire("bZYeN");

var $hA7wP = parcelRequire("hA7wP");
const $899d91f7d301ed08$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $899d91f7d301ed08$var$MAX_OBSERVATIONS = 200;
const $899d91f7d301ed08$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $899d91f7d301ed08$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $899d91f7d301ed08$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $899d91f7d301ed08$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($899d91f7d301ed08$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $2oIl7.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $hA7wP.default)(),
                h: (0, $bZYeN.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $899d91f7d301ed08$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $899d91f7d301ed08$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $899d91f7d301ed08$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$899d91f7d301ed08$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $899d91f7d301ed08$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $899d91f7d301ed08$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$899d91f7d301ed08$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$899d91f7d301ed08$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $aae7p.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $hA7wP.default)(),
                h: (0, $bZYeN.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("eW9mr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccfb0dc97816545b$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $jbnwL = parcelRequire("jbnwL");

var $5ntIg = parcelRequire("5ntIg");

var $04W4t = parcelRequire("04W4t");

var $2JA3O = parcelRequire("2JA3O");

var $iUSc2 = parcelRequire("iUSc2");

var $5aGEh = parcelRequire("5aGEh");

var $9wHdJ = parcelRequire("9wHdJ");

var $2Trvi = parcelRequire("2Trvi");

var $boOFv = parcelRequire("boOFv");

var $i9uW9 = parcelRequire("i9uW9");

var $9WtxZ = parcelRequire("9WtxZ");

var $jhIQt = parcelRequire("jhIQt");

var $36aVG = parcelRequire("36aVG");

var $cDMOM = parcelRequire("cDMOM");

var $5Bo9P = parcelRequire("5Bo9P");

var $dmifM = parcelRequire("dmifM");
const $ccfb0dc97816545b$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $36aVG.default)(target)) return 'mutation:remount';
        if ((0, $jbnwL.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $36aVG.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $iUSc2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $5Bo9P.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $ccfb0dc97816545b$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $36aVG.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $jbnwL.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $36aVG.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $iUSc2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $5Bo9P.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $ccfb0dc97816545b$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $jhIQt.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                var _this$getSSRState, _this$intersectionObs;
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $boOFv.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $boOFv.default)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $9WtxZ.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === ((_this$getSSRState = this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $ccfb0dc97816545b$var$createElementMutationsWatcherNew : $ccfb0dc97816545b$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $jbnwL.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $boOFv.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $boOFv.default)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $9WtxZ.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $5ntIg.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $04W4t.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $2JA3O.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $gdUUy.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $cDMOM.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $iUSc2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $dmifM.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $5Bo9P.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $5aGEh.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $9wHdJ.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $2Trvi.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        var _this$mutationObserve, _this$performanceObse;
        if (this.isStarted) return;
        this.initializeObservers();
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
        if (!this.isStarted) return;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
        (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $i9uW9.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("2JA3O", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba64c85847e33793$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $ba64c85847e33793$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $ba64c85847e33793$export$846396c2d8be3710 = 'data-drop-target-for-';
function $ba64c85847e33793$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($ba64c85847e33793$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($ba64c85847e33793$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("5aGEh", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $15bb7acc0457fe55$export$c3799d33e0ae80a5);

var $lVaCo = parcelRequire("lVaCo");
function $15bb7acc0457fe55$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $15bb7acc0457fe55$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $lVaCo.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$15bb7acc0457fe55$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("lVaCo", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $17680b453d0aa4c4$export$80d6b07c2266a1c6);
function $17680b453d0aa4c4$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("9wHdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8877e4a90040979e$export$2e2bcd8739ae039);

var $8T9n1 = parcelRequire("8T9n1");
function $8877e4a90040979e$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $8T9n1.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $8877e4a90040979e$export$2e2bcd8739ae039 = $8877e4a90040979e$var$createMutationObserver;

});

parcelRegister("2Trvi", function(module, exports) {
$parcel$export(module.exports, "default", () => $25fccfcdb08c329a$export$2e2bcd8739ae039);

var $dUd56 = parcelRequire("dUd56");
function $25fccfcdb08c329a$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: (0, $dUd56.convertPhysicalToLogicalResolution)(attr.currentRect),
                    previousRect: (0, $dUd56.convertPhysicalToLogicalResolution)(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$25fccfcdb08c329a$export$2e2bcd8739ae039 = $25fccfcdb08c329a$var$createPerformanceObserver;

});
parcelRegister("dUd56", function(module, exports) {
$parcel$export(module.exports, "convertPhysicalToLogicalResolution", () => $6f3b73713103f884$export$5e3f54cad8cb65e2);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $6f3b73713103f884$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}

});


parcelRegister("boOFv", function(module, exports) {
$parcel$export(module.exports, "default", () => $13cc330b85b7dbfa$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $actRr = parcelRequire("actRr");

var $23YLU = parcelRequire("23YLU");

var $6D8qr = parcelRequire("6D8qr");

var $i9uW9 = parcelRequire("i9uW9");

var $kEDSE = parcelRequire("kEDSE");
const $13cc330b85b7dbfa$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $13cc330b85b7dbfa$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $13cc330b85b7dbfa$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $13cc330b85b7dbfa$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
const $13cc330b85b7dbfa$var$CLEANUP_THRESHOLD = 50;
function $13cc330b85b7dbfa$var$maybeCleanup(resultCache) {
    (0, $23YLU.cacheCleanupState).callCount++;
    if ((0, $23YLU.cacheCleanupState).callCount >= $13cc330b85b7dbfa$var$CLEANUP_THRESHOLD && (0, $actRr.default)(0.3)) (0, $i9uW9.cleanupCaches)(resultCache);
}
function $13cc330b85b7dbfa$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $13cc330b85b7dbfa$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $gdUUy.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $13cc330b85b7dbfa$var$NEW_DOM_WALK_MAX_LEVEL : $13cc330b85b7dbfa$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $13cc330b85b7dbfa$var$NEW_FIBER_WALK_MAX_LEVEL : $13cc330b85b7dbfa$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $kEDSE.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $6D8qr.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("23YLU", function(module, exports) {
$parcel$export(module.exports, "cacheCleanupState", () => $b298976356144779$export$2d67c094e7802413);
const $b298976356144779$export$2d67c094e7802413 = {
    callCount: 0
};

});

parcelRegister("6D8qr", function(module, exports) {
$parcel$export(module.exports, "default", () => $638684f31ca0bbad$export$2e2bcd8739ae039);

var $68SFF = parcelRequire("68SFF");
function $638684f31ca0bbad$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $68SFF.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $638684f31ca0bbad$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("68SFF", function(module, exports) {
$parcel$export(module.exports, "default", () => $aff8ae6863f8a30e$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $aff8ae6863f8a30e$export$2e2bcd8739ae039(fiber) {
    const type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("i9uW9", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $d7800e8fd95f9e7a$export$6a35c3789c327630);

var $23YLU = parcelRequire("23YLU");
function $d7800e8fd95f9e7a$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    (0, $23YLU.cacheCleanupState).callCount = 0;
    return resultCache;
}

});

parcelRegister("kEDSE", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f34ce37862ce842$export$2e2bcd8739ae039);

var $fLG6m = parcelRequire("fLG6m");
function $4f34ce37862ce842$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $fLG6m.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("fLG6m", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdc1ac54ca1f542d$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $cdc1ac54ca1f542d$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("9WtxZ", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $708923fabf190be3$export$16c2770458939f21);

var $c9wRy = parcelRequire("c9wRy");
function $708923fabf190be3$export$16c2770458939f21(node) {
    const doc = (0, $c9wRy.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("c9wRy", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $865636c0cba24458$export$f65ca476c09acec0);
const $865636c0cba24458$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("jhIQt", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $1b247bdf3d17ece8$export$e989c0fffaa6b27a);
function $1b247bdf3d17ece8$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("36aVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a004b6926d7561$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $17a004b6926d7561$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $17a004b6926d7561$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("cDMOM", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $1fa54b70353f7d29$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $1fa54b70353f7d29$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("5Bo9P", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $ef21745768618efe$export$fde63bc968551821);
const $ef21745768618efe$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $ef21745768618efe$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $ef21745768618efe$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $ef21745768618efe$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $ef21745768618efe$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $ef21745768618efe$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("dmifM", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $321719a160063214$export$597b41700f7dcd36);
const $321719a160063214$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $321719a160063214$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $321719a160063214$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $321719a160063214$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("eAXYh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef054abd3786256f$export$2e2bcd8739ae039);

var $bAB3U = parcelRequire("bAB3U");
class $ef054abd3786256f$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $bAB3U.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $bAB3U.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});




parcelRegister("hUhqG", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $5e6ef83858c9085e$export$cc97b17ef9aeb088);
const $5e6ef83858c9085e$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("5vKXo", function(module, exports) {
$parcel$export(module.exports, "default", () => $825d86f0954227cc$export$2e2bcd8739ae039);

var $aae7p = parcelRequire("aae7p");

var $2oIl7 = parcelRequire("2oIl7");

var $fPuAr = parcelRequire("fPuAr");
const $825d86f0954227cc$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $825d86f0954227cc$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $fPuAr.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        var _this$vcObserver;
        (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        var _this$vcObserver2;
        (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        var _this$reactProfilerTi;
        return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            var _this$vcObserver3;
            this.reset();
            (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
            return;
        }
        const pageVisibilityState = (0, $2oIl7.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $aae7p.getConfig)();
        const postInteractionFinishVCResult = await ((_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
            includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        }));
        (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        var _getConfig;
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = ((_getConfig = (0, $aae7p.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $825d86f0954227cc$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
   * Basic info about interaction that has just finished
   */ this.lastInteractionFinish = null;
        /**
   * Array of observed react render timings
   */ this.reactProfilerTimings = [];
        /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
   * Handler function to process / send the observation data
   */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("fuVmc", function(module, exports) {
$parcel$export(module.exports, "getMetaData", () => $395e3778f5e4be16$export$929b5cc2a4ac0922);
$parcel$export(module.exports, "getMeta", () => $395e3778f5e4be16$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getMetaFromHTML", () => $395e3778f5e4be16$export$5a64793485e318f6);
$parcel$export(module.exports, "setHTMLMeta", () => $395e3778f5e4be16$export$11f8d00783d7fcf3);
$parcel$export(module.exports, "getCloudId", () => $395e3778f5e4be16$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getActivationId", () => $395e3778f5e4be16$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getHelpCenterAri", () => $395e3778f5e4be16$export$5b6c1ffe6316b179);
$parcel$export(module.exports, "getWorkspaceAri", () => $395e3778f5e4be16$export$8e2de40963827c80);
$parcel$export(module.exports, "getLayoutAri", () => $395e3778f5e4be16$export$b6b5277467022679);
$parcel$export(module.exports, "isValidLayoutAriPresent", () => $395e3778f5e4be16$export$7a9c037572667aa1);
$parcel$export(module.exports, "addMetaToHead", () => $395e3778f5e4be16$export$9e7e16a3dbced495);

var $4U3zK = parcelRequire("4U3zK");
// oxlint-disable-next-line no-shadow
var $395e3778f5e4be16$var$EnvType = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}($395e3778f5e4be16$var$EnvType || {});
const $395e3778f5e4be16$var$requiredMetaTags = {
    'account-id': 'accountId',
    'ajs-user-locale': 'userLocale',
    'ajs-account-type': 'accountType',
    'ajs-sdPluginVersion': 'sdPluginVersion',
    'ajs-context-path': 'contextPath',
    environment: 'environment',
    'tenant-id': 'tenantId',
    'activation-id': 'activationId',
    'help-center-ari': 'helpCenterARI',
    'home-page-layout-ari': 'homePageLayoutARI'
};
const $395e3778f5e4be16$export$929b5cc2a4ac0922 = ()=>{
    const metaData = {};
    Object.entries($395e3778f5e4be16$var$requiredMetaTags).forEach(([key, name])=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        metaData[name] = $395e3778f5e4be16$export$c47913ca32a5c6f7(key);
    });
    return Object.freeze(metaData);
};
function $395e3778f5e4be16$export$5a64793485e318f6(name) {
    const metaElement = (0, $4U3zK.default).querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}
function $395e3778f5e4be16$export$c47913ca32a5c6f7(name) {
    return $395e3778f5e4be16$export$5a64793485e318f6(name);
}
const $395e3778f5e4be16$export$11f8d00783d7fcf3 = (name, value)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let node = document.querySelector(`meta[name="${name}"]`);
    if (!node) {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        node = document.createElement('meta');
        node.setAttribute('name', name);
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.head.appendChild(node);
    }
    node.setAttribute('content', value);
};
const $395e3778f5e4be16$export$fdd2c0ba94025c3c = ()=>{
    return $395e3778f5e4be16$export$c47913ca32a5c6f7('tenant-id') || '';
};
const $395e3778f5e4be16$export$3ad4bb31a1816ff6 = ()=>$395e3778f5e4be16$export$c47913ca32a5c6f7('activation-id') ?? '';
const $395e3778f5e4be16$export$5b6c1ffe6316b179 = ()=>{
    return $395e3778f5e4be16$export$c47913ca32a5c6f7('help-center-ari') || '';
};
const $395e3778f5e4be16$export$8e2de40963827c80 = ()=>{
    return $395e3778f5e4be16$export$c47913ca32a5c6f7('jira-workspace-ari') || '';
};
const $395e3778f5e4be16$export$b6b5277467022679 = ()=>{
    return $395e3778f5e4be16$export$c47913ca32a5c6f7('home-page-layout-ari') || '';
};
const $395e3778f5e4be16$export$7a9c037572667aa1 = ()=>{
    const layoutAri = $395e3778f5e4be16$export$b6b5277467022679();
    return layoutAri !== '' && layoutAri !== 'null';
};
const $395e3778f5e4be16$export$9e7e16a3dbced495 = (name, value)=>{
    var _document$head;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const existingMetaTag = document.querySelector(`meta[name="${name}"]`);
    if ((existingMetaTag === null || existingMetaTag === void 0 ? void 0 : existingMetaTag.getAttribute('content')) === value) return;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const metaTag = existingMetaTag || document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', value);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (_document$head = document.head) === null || _document$head === void 0 || _document$head.insertBefore(metaTag, document.head.childNodes[0]);
};

});
parcelRegister("4U3zK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c56a9a1f2d51f0f5$export$2e2bcd8739ae039);
class $c56a9a1f2d51f0f5$export$6e283cdda5461374 {
    constructor(){
        this.store = {
            elements: {}
        };
        this.parsedHTML = null;
    }
    startup(parsedHTML) {
        this.parsedHTML = parsedHTML;
    }
    isRunningInSnapvmRuntime() {
        return typeof window === 'undefined';
    }
    getDataRef() {
        if (this.isRunningInSnapvmRuntime()) return this.parsedHTML;
        // Set to document when not in SnapVM runtime (Classic and Client side render cases)
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        return document;
    }
    getElementById(elementId) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementById(elementId);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementById');
        return null;
    }
    querySelector(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelector(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelector');
        return null;
    }
    querySelectorAll(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelectorAll(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelectorAll');
        return [];
    }
    getElementsByTagName(tagName) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementsByTagName(tagName);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementsByTagName');
        return [];
    }
    addClassName(elementName, className) {
        if (this.isRunningInSnapvmRuntime()) {
            if (!this.store.elements[elementName]) this.store.elements[elementName] = {
                classList: []
            };
            this.store.elements[elementName].classList.push(className);
            return;
        }
        if (elementName === 'body') {
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.body.classList.add(className);
            return;
        }
        // oxlint-disable-next-line no-console
        console.warn('invalid elementName sent to addClassName. elementName: ', elementName);
    }
    getStore() {
        return this.store;
    }
}
const $c56a9a1f2d51f0f5$var$clientServerBridge = new $c56a9a1f2d51f0f5$export$6e283cdda5461374();
var $c56a9a1f2d51f0f5$export$2e2bcd8739ae039 = $c56a9a1f2d51f0f5$var$clientServerBridge;

});


parcelRegister("90WXu", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $b9ea08b7947dca1f$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $b9ea08b7947dca1f$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $b9ea08b7947dca1f$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $b9ea08b7947dca1f$export$a3271f53e91faab7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $b9ea08b7947dca1f$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $b9ea08b7947dca1f$var$pressureRecordBuffer = [];
let $b9ea08b7947dca1f$var$pressureObserver = null;
let $b9ea08b7947dca1f$var$memoryRecordBuffer = [];
let $b9ea08b7947dca1f$var$memoryInterval;
function $b9ea08b7947dca1f$export$6c1060bed5fea050() {
    $b9ea08b7947dca1f$var$pressureRecordBuffer.length = 0;
}
function $b9ea08b7947dca1f$export$aa672c7221b183b0() {
    $b9ea08b7947dca1f$var$memoryRecordBuffer.length = 0;
}
function $b9ea08b7947dca1f$export$ec86686c1d2e65bc(filter) {
    $b9ea08b7947dca1f$var$pressureRecordBuffer = $b9ea08b7947dca1f$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $b9ea08b7947dca1f$export$c0142ac82f5d0c28(filter) {
    $b9ea08b7947dca1f$var$memoryRecordBuffer = $b9ea08b7947dca1f$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $b9ea08b7947dca1f$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $b9ea08b7947dca1f$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $b9ea08b7947dca1f$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $b9ea08b7947dca1f$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $b9ea08b7947dca1f$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $b9ea08b7947dca1f$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $b9ea08b7947dca1f$var$convertBytesToMegabytes($b9ea08b7947dca1f$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $b9ea08b7947dca1f$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $b9ea08b7947dca1f$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $b9ea08b7947dca1f$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $b9ea08b7947dca1f$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $b9ea08b7947dca1f$var$pressureObserver = new PressureObserver((records)=>{
                if ($b9ea08b7947dca1f$var$pressureRecordBuffer.length + records.length <= $b9ea08b7947dca1f$var$BUFFER_MAX_LENGTH) $b9ea08b7947dca1f$var$pressureRecordBuffer.push(...records);
            });
            $b9ea08b7947dca1f$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $b9ea08b7947dca1f$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $b9ea08b7947dca1f$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($b9ea08b7947dca1f$var$memoryRecordBuffer.length <= $b9ea08b7947dca1f$var$BUFFER_MAX_LENGTH) $b9ea08b7947dca1f$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $b9ea08b7947dca1f$export$10899ada382f2ae3() {
    clearInterval($b9ea08b7947dca1f$var$memoryInterval);
}
function $b9ea08b7947dca1f$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $b9ea08b7947dca1f$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("dH1v3", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $9a70cc0d369c0e7e$export$b6ac780db3a3cc77);
parcelRequire("9l0QE");
var $8JMls = parcelRequire("8JMls");

var $gdUUy = parcelRequire("gdUUy");

var $c0tNN = parcelRequire("c0tNN");

var $a2arA = parcelRequire("a2arA");

var $cGQlM = parcelRequire("cGQlM");

var $4VOnD = parcelRequire("4VOnD");
function $9a70cc0d369c0e7e$export$b6ac780db3a3cc77() {
    if ((0, $gdUUy.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $8JMls.context).active().getValue((0, $4VOnD.traceIdKey))),
            spanId: String((0, $8JMls.context).active().getValue((0, $a2arA.spanIdKey))),
            type: String((0, $8JMls.context).active().getValue((0, $c0tNN.experienceTypeKey)))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return (0, $cGQlM.state).context || undefined;
}

});
parcelRegister("9l0QE", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("8JMls")).context);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $j3jZT = parcelRequire("j3jZT");















var $8JMls = parcelRequire("8JMls");

var $5vZ2n = parcelRequire("5vZ2n");

var $gKF5M = parcelRequire("gKF5M");

var $l1J7m = parcelRequire("l1J7m");

var $e7yN4 = parcelRequire("e7yN4");
var // Default export.
$6cc6bba46a80fee4$export$2e2bcd8739ae039 = {
    context: $8JMls.context,
    diag: $5vZ2n.diag,
    metrics: $gKF5M.metrics,
    propagation: $l1J7m.propagation,
    trace: $e7yN4.trace
};

});
parcelRegister("8JMls", function(module, exports) {
$parcel$export(module.exports, "context", () => $65c8070b4ea012c2$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $4SGtC = parcelRequire("4SGtC");
const $65c8070b4ea012c2$export$a078c61943f9dbbe = (0, $4SGtC.ContextAPI).getInstance();

});
parcelRegister("4SGtC", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $38dd2793bbbc43fe$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $7pgzw = parcelRequire("7pgzw");

var $frED9 = parcelRequire("frED9");

var $iTANK = parcelRequire("iTANK");
const $38dd2793bbbc43fe$var$API_NAME = 'context';
const $38dd2793bbbc43fe$var$NOOP_CONTEXT_MANAGER = new (0, $7pgzw.NoopContextManager)();
class $38dd2793bbbc43fe$export$4148866f0a453927 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Context API */ static getInstance() {
        if (!this._instance) this._instance = new $38dd2793bbbc43fe$export$4148866f0a453927();
        return this._instance;
    }
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ setGlobalContextManager(contextManager) {
        return (0, $frED9.registerGlobal)($38dd2793bbbc43fe$var$API_NAME, contextManager, (0, $iTANK.DiagAPI).instance());
    }
    /**
     * Get the currently active context
     */ active() {
        return this._getContextManager().active();
    }
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        return this._getContextManager().with(context, fn, thisArg, ...args);
    }
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ bind(context, target) {
        return this._getContextManager().bind(context, target);
    }
    _getContextManager() {
        return (0, $frED9.getGlobal)($38dd2793bbbc43fe$var$API_NAME) || $38dd2793bbbc43fe$var$NOOP_CONTEXT_MANAGER;
    }
    /** Disable and remove the global context manager */ disable() {
        this._getContextManager().disable();
        (0, $frED9.unregisterGlobal)($38dd2793bbbc43fe$var$API_NAME, (0, $iTANK.DiagAPI).instance());
    }
}

});
parcelRegister("7pgzw", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $5647b90bfe494a3e$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $j3jZT = parcelRequire("j3jZT");
class $5647b90bfe494a3e$export$a27e5df35d1539a6 {
    active() {
        return 0, $j3jZT.ROOT_CONTEXT;
    }
    with(_context, fn, thisArg, ...args) {
        return fn.call(thisArg, ...args);
    }
    bind(_context, target) {
        return target;
    }
    enable() {
        return this;
    }
    disable() {
        return this;
    }
}

});

parcelRegister("frED9", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $b3e8e5016224e033$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $b3e8e5016224e033$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $b3e8e5016224e033$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $cettR = parcelRequire("cettR");

var $gIkG5 = parcelRequire("gIkG5");
const $b3e8e5016224e033$var$major = (0, $cettR.VERSION).split('.')[0];
const $b3e8e5016224e033$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for(`opentelemetry.js.api.${$b3e8e5016224e033$var$major}`);
const $b3e8e5016224e033$var$_global = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};
function $b3e8e5016224e033$export$d586ae880b433238(type, instance, diag, allowOverride = false) {
    var _a;
    const api = $b3e8e5016224e033$var$_global[$b3e8e5016224e033$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $b3e8e5016224e033$var$_global[$b3e8e5016224e033$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $cettR.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        const err = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $cettR.VERSION)) {
        // All registered APIs must be of the same version exactly
        const err = new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${(0, $cettR.VERSION)}`);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug(`@opentelemetry/api: Registered a global for ${type} v${(0, $cettR.VERSION)}.`);
    return true;
}
function $b3e8e5016224e033$export$a4e55266d2135a7f(type) {
    var _a, _b;
    const globalVersion = (_a = $b3e8e5016224e033$var$_global[$b3e8e5016224e033$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $gIkG5.isCompatible)(globalVersion)) return;
    return (_b = $b3e8e5016224e033$var$_global[$b3e8e5016224e033$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $b3e8e5016224e033$export$d42ac835f38d1fb2(type, diag) {
    diag.debug(`@opentelemetry/api: Unregistering a global for ${type} v${(0, $cettR.VERSION)}.`);
    const api = $b3e8e5016224e033$var$_global[$b3e8e5016224e033$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("cettR", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $8e7da912a3bfcd0b$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $8e7da912a3bfcd0b$export$a4ad2735b021c132 = '1.9.1';

});

parcelRegister("gIkG5", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $c2b0cb9c0dfdb40e$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $cettR = parcelRequire("cettR");
const $c2b0cb9c0dfdb40e$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $c2b0cb9c0dfdb40e$export$a5733a4d26a1ec61(ownVersion) {
    const acceptedVersions = new Set([
        ownVersion
    ]);
    const rejectedVersions = new Set();
    const myVersionMatch = ownVersion.match($c2b0cb9c0dfdb40e$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return ()=>false;
    const ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        const globalVersionMatch = globalVersion.match($c2b0cb9c0dfdb40e$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        const globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
const $c2b0cb9c0dfdb40e$export$7fc0d8c3ab188c4c = $c2b0cb9c0dfdb40e$export$a5733a4d26a1ec61((0, $cettR.VERSION));

});


parcelRegister("iTANK", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $dc19e908bc0cfda5$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $kew8s = parcelRequire("kew8s");

var $1xcvg = parcelRequire("1xcvg");

var $7MpLY = parcelRequire("7MpLY");

var $frED9 = parcelRequire("frED9");
const $dc19e908bc0cfda5$var$API_NAME = 'diag';
class $dc19e908bc0cfda5$export$5c8937ffc688cfd3 {
    /** Get the singleton instance of the DiagAPI API */ static instance() {
        if (!this._instance) this._instance = new $dc19e908bc0cfda5$export$5c8937ffc688cfd3();
        return this._instance;
    }
    /**
     * Private internal constructor
     * @private
     */ constructor(){
        function _logProxy(funcName) {
            return function(...args) {
                const logger = (0, $frED9.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName](...args);
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        const self = this;
        // DiagAPI specific functions
        const setLogger = (logger, optionsOrLogLevel = {
            logLevel: (0, $7MpLY.DiagLogLevel).INFO
        })=>{
            var _a, _b, _c;
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                const err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            const oldLogger = (0, $frED9.getGlobal)('diag');
            const newLogger = (0, $1xcvg.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $7MpLY.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                const stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn(`Current logger will be overwritten from ${stack}`);
                newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
            }
            return (0, $frED9.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = ()=>{
            (0, $frED9.unregisterGlobal)($dc19e908bc0cfda5$var$API_NAME, self);
        };
        self.createComponentLogger = (options)=>{
            return new (0, $kew8s.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
}

});
parcelRegister("kew8s", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $ebae0ae2bb5c9ae1$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $frED9 = parcelRequire("frED9");
class $ebae0ae2bb5c9ae1$export$b4bccc12f5b13129 {
    constructor(props){
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    debug(...args) {
        return $ebae0ae2bb5c9ae1$var$logProxy('debug', this._namespace, args);
    }
    error(...args) {
        return $ebae0ae2bb5c9ae1$var$logProxy('error', this._namespace, args);
    }
    info(...args) {
        return $ebae0ae2bb5c9ae1$var$logProxy('info', this._namespace, args);
    }
    warn(...args) {
        return $ebae0ae2bb5c9ae1$var$logProxy('warn', this._namespace, args);
    }
    verbose(...args) {
        return $ebae0ae2bb5c9ae1$var$logProxy('verbose', this._namespace, args);
    }
}
function $ebae0ae2bb5c9ae1$var$logProxy(funcName, namespace, args) {
    const logger = (0, $frED9.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    return logger[funcName](namespace, ...args);
}

});

parcelRegister("1xcvg", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $11e29260de82100f$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $7MpLY = parcelRequire("7MpLY");
function $11e29260de82100f$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $7MpLY.DiagLogLevel).NONE) maxLevel = (0, $7MpLY.DiagLogLevel).NONE;
    else if (maxLevel > (0, $7MpLY.DiagLogLevel).ALL) maxLevel = (0, $7MpLY.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        const theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $7MpLY.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $7MpLY.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $7MpLY.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $7MpLY.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $7MpLY.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("7MpLY", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $5aa1020775159796$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $5aa1020775159796$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($5aa1020775159796$export$b7d7b4c0f3c95263 || ($5aa1020775159796$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("5vZ2n", function(module, exports) {
$parcel$export(module.exports, "diag", () => $403f31bef79fb001$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $iTANK = parcelRequire("iTANK");
const $403f31bef79fb001$export$c042e7c2f59bc046 = (0, $iTANK.DiagAPI).instance();

});

parcelRegister("gKF5M", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $c320d14360b59bb7$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $7xG3C = parcelRequire("7xG3C");
const $c320d14360b59bb7$export$b0c5c2fac8144e54 = (0, $7xG3C.MetricsAPI).getInstance();

});
parcelRegister("7xG3C", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $57dc3d359092c877$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $ezmLI = parcelRequire("ezmLI");

var $frED9 = parcelRequire("frED9");

var $iTANK = parcelRequire("iTANK");
const $57dc3d359092c877$var$API_NAME = 'metrics';
class $57dc3d359092c877$export$1339f6eb6111c638 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Metrics API */ static getInstance() {
        if (!this._instance) this._instance = new $57dc3d359092c877$export$1339f6eb6111c638();
        return this._instance;
    }
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ setGlobalMeterProvider(provider) {
        return (0, $frED9.registerGlobal)($57dc3d359092c877$var$API_NAME, provider, (0, $iTANK.DiagAPI).instance());
    }
    /**
     * Returns the global meter provider.
     */ getMeterProvider() {
        return (0, $frED9.getGlobal)($57dc3d359092c877$var$API_NAME) || (0, $ezmLI.NOOP_METER_PROVIDER);
    }
    /**
     * Returns a meter from the global meter provider.
     */ getMeter(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    }
    /** Remove the global meter provider */ disable() {
        (0, $frED9.unregisterGlobal)($57dc3d359092c877$var$API_NAME, (0, $iTANK.DiagAPI).instance());
    }
}

});
parcelRegister("ezmLI", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $a9b5fef628ce2bb0$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $aqrP3 = parcelRequire("aqrP3");
class $a9b5fef628ce2bb0$export$51c513ea08316108 {
    getMeter(_name, _version, _options) {
        return 0, $aqrP3.NOOP_METER;
    }
}
const $a9b5fef628ce2bb0$export$d21fe83355c56e18 = new $a9b5fef628ce2bb0$export$51c513ea08316108();

});
parcelRegister("aqrP3", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $7971ea12dada194c$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ class $7971ea12dada194c$export$c23c6f85dd4fc1e9 {
    constructor(){}
    /**
     * @see {@link Meter.createGauge}
     */ createGauge(_name, _options) {
        return $7971ea12dada194c$export$dd01300aacbcec1c;
    }
    /**
     * @see {@link Meter.createHistogram}
     */ createHistogram(_name, _options) {
        return $7971ea12dada194c$export$689c32a6a552e1a6;
    }
    /**
     * @see {@link Meter.createCounter}
     */ createCounter(_name, _options) {
        return $7971ea12dada194c$export$e6d19fe5233efc54;
    }
    /**
     * @see {@link Meter.createUpDownCounter}
     */ createUpDownCounter(_name, _options) {
        return $7971ea12dada194c$export$2f189cd99d2b7429;
    }
    /**
     * @see {@link Meter.createObservableGauge}
     */ createObservableGauge(_name, _options) {
        return $7971ea12dada194c$export$ea67e3c6ff624776;
    }
    /**
     * @see {@link Meter.createObservableCounter}
     */ createObservableCounter(_name, _options) {
        return $7971ea12dada194c$export$163422b94c3edbcb;
    }
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ createObservableUpDownCounter(_name, _options) {
        return $7971ea12dada194c$export$5b8be9ab17b673b3;
    }
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ addBatchObservableCallback(_callback, _observables) {}
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ removeBatchObservableCallback(_callback) {}
}
class $7971ea12dada194c$export$834a616d1cf278b {
}
class $7971ea12dada194c$export$b556ba0f560c45b extends $7971ea12dada194c$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $7971ea12dada194c$export$df09a35db160df98 extends $7971ea12dada194c$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $7971ea12dada194c$export$b7f4a3c7ea16c24 extends $7971ea12dada194c$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $7971ea12dada194c$export$ef064c3e0426c607 extends $7971ea12dada194c$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $7971ea12dada194c$export$a5a3e7829c289482 {
    addCallback(_callback) {}
    removeCallback(_callback) {}
}
class $7971ea12dada194c$export$7a7e4b169d5c93a8 extends $7971ea12dada194c$export$a5a3e7829c289482 {
}
class $7971ea12dada194c$export$6990a2f90809ffc1 extends $7971ea12dada194c$export$a5a3e7829c289482 {
}
class $7971ea12dada194c$export$3ec3555bc6f693a4 extends $7971ea12dada194c$export$a5a3e7829c289482 {
}
const $7971ea12dada194c$export$65e277d35235a01f = new $7971ea12dada194c$export$c23c6f85dd4fc1e9();
const $7971ea12dada194c$export$e6d19fe5233efc54 = new $7971ea12dada194c$export$b556ba0f560c45b();
const $7971ea12dada194c$export$dd01300aacbcec1c = new $7971ea12dada194c$export$b7f4a3c7ea16c24();
const $7971ea12dada194c$export$689c32a6a552e1a6 = new $7971ea12dada194c$export$ef064c3e0426c607();
const $7971ea12dada194c$export$2f189cd99d2b7429 = new $7971ea12dada194c$export$df09a35db160df98();
const $7971ea12dada194c$export$163422b94c3edbcb = new $7971ea12dada194c$export$7a7e4b169d5c93a8();
const $7971ea12dada194c$export$ea67e3c6ff624776 = new $7971ea12dada194c$export$6990a2f90809ffc1();
const $7971ea12dada194c$export$5b8be9ab17b673b3 = new $7971ea12dada194c$export$3ec3555bc6f693a4();
function $7971ea12dada194c$export$bc3a498ccbb5c2b5() {
    return $7971ea12dada194c$export$65e277d35235a01f;
}

});




parcelRegister("l1J7m", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $f4ecb06f534c40b3$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $fEbf7 = parcelRequire("fEbf7");
const $f4ecb06f534c40b3$export$3e49040daa9dba20 = (0, $fEbf7.PropagationAPI).getInstance();

});
parcelRegister("fEbf7", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $b64350075979a797$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $frED9 = parcelRequire("frED9");

var $fBsFD = parcelRequire("fBsFD");

var $iXdYU = parcelRequire("iXdYU");

var $fjlsm = parcelRequire("fjlsm");

var $6qGvL = parcelRequire("6qGvL");

var $iTANK = parcelRequire("iTANK");
const $b64350075979a797$var$API_NAME = 'propagation';
const $b64350075979a797$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $fBsFD.NoopTextMapPropagator)();
class $b64350075979a797$export$471eda0a6213cac9 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this.createBaggage = (0, $6qGvL.createBaggage);
        this.getBaggage = (0, $fjlsm.getBaggage);
        this.getActiveBaggage = (0, $fjlsm.getActiveBaggage);
        this.setBaggage = (0, $fjlsm.setBaggage);
        this.deleteBaggage = (0, $fjlsm.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ static getInstance() {
        if (!this._instance) this._instance = new $b64350075979a797$export$471eda0a6213cac9();
        return this._instance;
    }
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ setGlobalPropagator(propagator) {
        return (0, $frED9.registerGlobal)($b64350075979a797$var$API_NAME, propagator, (0, $iTANK.DiagAPI).instance());
    }
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ inject(context, carrier, setter = (0, $iXdYU.defaultTextMapSetter)) {
        return this._getGlobalPropagator().inject(context, carrier, setter);
    }
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ extract(context, carrier, getter = (0, $iXdYU.defaultTextMapGetter)) {
        return this._getGlobalPropagator().extract(context, carrier, getter);
    }
    /**
     * Return a list of all fields which may be used by the propagator.
     */ fields() {
        return this._getGlobalPropagator().fields();
    }
    /** Remove the global propagator */ disable() {
        (0, $frED9.unregisterGlobal)($b64350075979a797$var$API_NAME, (0, $iTANK.DiagAPI).instance());
    }
    _getGlobalPropagator() {
        return (0, $frED9.getGlobal)($b64350075979a797$var$API_NAME) || $b64350075979a797$var$NOOP_TEXT_MAP_PROPAGATOR;
    }
}

});
parcelRegister("fBsFD", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $b5c08d1393f360cc$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ class $b5c08d1393f360cc$export$8356c7eb3af7963b {
    /** Noop inject function does nothing */ inject(_context, _carrier) {}
    /** Noop extract function does nothing and returns the input context */ extract(context, _carrier) {
        return context;
    }
    fields() {
        return [];
    }
}

});

parcelRegister("iXdYU", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $dcc8951473a3d79f$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $dcc8951473a3d79f$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ const $dcc8951473a3d79f$export$a0f575f55f38720a = {
    get (carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys (carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
const $dcc8951473a3d79f$export$f70f1d111fccf1c1 = {
    set (carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("fjlsm", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $b2594630010e8aed$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $b2594630010e8aed$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $b2594630010e8aed$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $b2594630010e8aed$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4SGtC = parcelRequire("4SGtC");

var $j3jZT = parcelRequire("j3jZT");
/**
 * Baggage key
 */ const $b2594630010e8aed$var$BAGGAGE_KEY = (0, $j3jZT.createContextKey)('OpenTelemetry Baggage Key');
function $b2594630010e8aed$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($b2594630010e8aed$var$BAGGAGE_KEY) || undefined;
}
function $b2594630010e8aed$export$120a1756099436ee() {
    return $b2594630010e8aed$export$f3bffa0b5dd10d1e((0, $4SGtC.ContextAPI).getInstance().active());
}
function $b2594630010e8aed$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($b2594630010e8aed$var$BAGGAGE_KEY, baggage);
}
function $b2594630010e8aed$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($b2594630010e8aed$var$BAGGAGE_KEY);
}

});

parcelRegister("6qGvL", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $4ae625a727179b3e$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $iTANK = parcelRequire("iTANK");

var $btcFu = parcelRequire("btcFu");

var $lHSop = parcelRequire("lHSop");
const $4ae625a727179b3e$var$diag = (0, $iTANK.DiagAPI).instance();
function $4ae625a727179b3e$export$1034a425c7384452(entries = {}) {
    return new (0, $btcFu.BaggageImpl)(new Map(Object.entries(entries)));
}
function $4ae625a727179b3e$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $4ae625a727179b3e$var$diag.error(`Cannot create baggage metadata from unknown type: ${typeof str}`);
        str = '';
    }
    return {
        __TYPE__: (0, $lHSop.baggageEntryMetadataSymbol),
        toString () {
            return str;
        }
    };
}

});
parcelRegister("btcFu", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $859c3ac6cf58fd01$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ class $859c3ac6cf58fd01$export$b8c511fa1a5f4987 {
    constructor(entries){
        this._entries = entries ? new Map(entries) : new Map();
    }
    getEntry(key) {
        const entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    }
    getAllEntries() {
        return Array.from(this._entries.entries());
    }
    setEntry(key, entry) {
        const newBaggage = new $859c3ac6cf58fd01$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    }
    removeEntry(key) {
        const newBaggage = new $859c3ac6cf58fd01$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    }
    removeEntries(...keys) {
        const newBaggage = new $859c3ac6cf58fd01$export$b8c511fa1a5f4987(this._entries);
        for (const key of keys)newBaggage._entries.delete(key);
        return newBaggage;
    }
    clear() {
        return new $859c3ac6cf58fd01$export$b8c511fa1a5f4987();
    }
}

});

parcelRegister("lHSop", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $fcd7ce65ecf374f1$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ const $fcd7ce65ecf374f1$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("e7yN4", function(module, exports) {
$parcel$export(module.exports, "trace", () => $a47cb4c6f2e1310b$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $ieyLT = parcelRequire("ieyLT");
const $a47cb4c6f2e1310b$export$357889f174732d38 = (0, $ieyLT.TraceAPI).getInstance();

});
parcelRegister("ieyLT", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $d46481b32d51eb7f$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $frED9 = parcelRequire("frED9");

var $fDqSM = parcelRequire("fDqSM");

var $8h70w = parcelRequire("8h70w");

var $4DmHO = parcelRequire("4DmHO");

var $iTANK = parcelRequire("iTANK");
const $d46481b32d51eb7f$var$API_NAME = 'trace';
class $d46481b32d51eb7f$export$2cccde6fcc7b568a {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this._proxyTracerProvider = new (0, $fDqSM.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $8h70w.wrapSpanContext);
        this.isSpanContextValid = (0, $8h70w.isSpanContextValid);
        this.deleteSpan = (0, $4DmHO.deleteSpan);
        this.getSpan = (0, $4DmHO.getSpan);
        this.getActiveSpan = (0, $4DmHO.getActiveSpan);
        this.getSpanContext = (0, $4DmHO.getSpanContext);
        this.setSpan = (0, $4DmHO.setSpan);
        this.setSpanContext = (0, $4DmHO.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ static getInstance() {
        if (!this._instance) this._instance = new $d46481b32d51eb7f$export$2cccde6fcc7b568a();
        return this._instance;
    }
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ setGlobalTracerProvider(provider) {
        const success = (0, $frED9.registerGlobal)($d46481b32d51eb7f$var$API_NAME, this._proxyTracerProvider, (0, $iTANK.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    }
    /**
     * Returns the global tracer provider.
     */ getTracerProvider() {
        return (0, $frED9.getGlobal)($d46481b32d51eb7f$var$API_NAME) || this._proxyTracerProvider;
    }
    /**
     * Returns a tracer from the global tracer provider.
     */ getTracer(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    }
    /** Remove the global tracer provider */ disable() {
        (0, $frED9.unregisterGlobal)($d46481b32d51eb7f$var$API_NAME, (0, $iTANK.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $fDqSM.ProxyTracerProvider)();
    }
}

});
parcelRegister("fDqSM", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $b61f59df8a6f14fc$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $2AuAQ = parcelRequire("2AuAQ");

var $5Y0su = parcelRequire("5Y0su");
const $b61f59df8a6f14fc$var$NOOP_TRACER_PROVIDER = new (0, $5Y0su.NoopTracerProvider)();
class $b61f59df8a6f14fc$export$4137aabcb4254962 {
    /**
     * Get a {@link ProxyTracer}
     */ getTracer(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $2AuAQ.ProxyTracer)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $b61f59df8a6f14fc$var$NOOP_TRACER_PROVIDER;
    }
    /**
     * Set the delegate tracer provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateTracer(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    }
}

});
parcelRegister("2AuAQ", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $1e26acc430d48230$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $iGMGg = parcelRequire("iGMGg");
const $1e26acc430d48230$var$NOOP_TRACER = new (0, $iGMGg.NoopTracer)();
class $1e26acc430d48230$export$df2c38268c6bb6b3 {
    constructor(provider, name, version, options){
        this._provider = provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    startSpan(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    }
    startActiveSpan(_name, _options, _context, _fn) {
        const tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    }
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ _getTracer() {
        if (this._delegate) return this._delegate;
        const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $1e26acc430d48230$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    }
}

});
parcelRegister("iGMGg", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $d9b1e938b67a833a$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4SGtC = parcelRequire("4SGtC");

var $4DmHO = parcelRequire("4DmHO");

var $lQGVM = parcelRequire("lQGVM");

var $8h70w = parcelRequire("8h70w");
const $d9b1e938b67a833a$var$contextApi = (0, $4SGtC.ContextAPI).getInstance();
class $d9b1e938b67a833a$export$714c1036cabcd223 {
    // startSpan starts a noop span.
    startSpan(name, options, context = $d9b1e938b67a833a$var$contextApi.active()) {
        const root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $lQGVM.NonRecordingSpan)();
        const parentFromContext = context && (0, $4DmHO.getSpanContext)(context);
        if ($d9b1e938b67a833a$var$isSpanContext(parentFromContext) && (0, $8h70w.isSpanContextValid)(parentFromContext)) return new (0, $lQGVM.NonRecordingSpan)(parentFromContext);
        else return new (0, $lQGVM.NonRecordingSpan)();
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx !== null && ctx !== void 0 ? ctx : $d9b1e938b67a833a$var$contextApi.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = (0, $4DmHO.setSpan)(parentContext, span);
        return $d9b1e938b67a833a$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    }
}
function $d9b1e938b67a833a$var$isSpanContext(spanContext) {
    return spanContext !== null && typeof spanContext === 'object' && 'spanId' in spanContext && typeof spanContext['spanId'] === 'string' && 'traceId' in spanContext && typeof spanContext['traceId'] === 'string' && 'traceFlags' in spanContext && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("4DmHO", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $35fc6ad6027cb9d0$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $35fc6ad6027cb9d0$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $35fc6ad6027cb9d0$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $35fc6ad6027cb9d0$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $35fc6ad6027cb9d0$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $35fc6ad6027cb9d0$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $j3jZT = parcelRequire("j3jZT");

var $lQGVM = parcelRequire("lQGVM");

var $4SGtC = parcelRequire("4SGtC");
/**
 * span key
 */ const $35fc6ad6027cb9d0$var$SPAN_KEY = (0, $j3jZT.createContextKey)('OpenTelemetry Context Key SPAN');
function $35fc6ad6027cb9d0$export$246e04ba06066af1(context) {
    return context.getValue($35fc6ad6027cb9d0$var$SPAN_KEY) || undefined;
}
function $35fc6ad6027cb9d0$export$1be426a8e585c83e() {
    return $35fc6ad6027cb9d0$export$246e04ba06066af1((0, $4SGtC.ContextAPI).getInstance().active());
}
function $35fc6ad6027cb9d0$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($35fc6ad6027cb9d0$var$SPAN_KEY, span);
}
function $35fc6ad6027cb9d0$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($35fc6ad6027cb9d0$var$SPAN_KEY);
}
function $35fc6ad6027cb9d0$export$c90bf5428c14cdb1(context, spanContext) {
    return $35fc6ad6027cb9d0$export$8ab2f2e6ee8ed0a8(context, new (0, $lQGVM.NonRecordingSpan)(spanContext));
}
function $35fc6ad6027cb9d0$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $35fc6ad6027cb9d0$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("lQGVM", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $fe7fc1781e7ce045$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jDXJY = parcelRequire("jDXJY");
class $fe7fc1781e7ce045$export$972d28f7c6a8c6c7 {
    constructor(spanContext = (0, $jDXJY.INVALID_SPAN_CONTEXT)){
        this._spanContext = spanContext;
    }
    // Returns a SpanContext.
    spanContext() {
        return this._spanContext;
    }
    // By default does nothing
    setAttribute(_key, _value) {
        return this;
    }
    // By default does nothing
    setAttributes(_attributes) {
        return this;
    }
    // By default does nothing
    addEvent(_name, _attributes) {
        return this;
    }
    addLink(_link) {
        return this;
    }
    addLinks(_links) {
        return this;
    }
    // By default does nothing
    setStatus(_status) {
        return this;
    }
    // By default does nothing
    updateName(_name) {
        return this;
    }
    // By default does nothing
    end(_endTime) {}
    // isRecording always returns false for NonRecordingSpan.
    isRecording() {
        return false;
    }
    // By default does nothing
    recordException(_exception, _time) {}
}

});
parcelRegister("jDXJY", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $e4d00012a7bbcb4b$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $e4d00012a7bbcb4b$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $e4d00012a7bbcb4b$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $8gxdI = parcelRequire("8gxdI");
const $e4d00012a7bbcb4b$export$55cc39fb0d4bb4c0 = '0000000000000000';
const $e4d00012a7bbcb4b$export$22be96e88d95e128 = '00000000000000000000000000000000';
const $e4d00012a7bbcb4b$export$8591e4c852b66703 = {
    traceId: $e4d00012a7bbcb4b$export$22be96e88d95e128,
    spanId: $e4d00012a7bbcb4b$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $8gxdI.TraceFlags).NONE
};

});
parcelRegister("8gxdI", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $60499635a2bd5b23$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ var $60499635a2bd5b23$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($60499635a2bd5b23$export$bf9049ad2b0883ff || ($60499635a2bd5b23$export$bf9049ad2b0883ff = {}));

});




parcelRegister("8h70w", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $606558cf766ad3f9$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $606558cf766ad3f9$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jDXJY = parcelRequire("jDXJY");

var $lQGVM = parcelRequire("lQGVM");
// Valid characters (0-9, a-f, A-F) are marked as 1.
const $606558cf766ad3f9$var$isHex = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1
]);
function $606558cf766ad3f9$var$isValidHex(id, length) {
    // As of 1.9.0 the id was allowed to be a non-string value,
    // even though it was not possible in the types.
    if (typeof id !== 'string' || id.length !== length) return false;
    let r = 0;
    for(let i = 0; i < id.length; i += 4)r += ($606558cf766ad3f9$var$isHex[id.charCodeAt(i)] | 0) + ($606558cf766ad3f9$var$isHex[id.charCodeAt(i + 1)] | 0) + ($606558cf766ad3f9$var$isHex[id.charCodeAt(i + 2)] | 0) + ($606558cf766ad3f9$var$isHex[id.charCodeAt(i + 3)] | 0);
    return r === length;
}
function $606558cf766ad3f9$export$29dd34cf1269f6da(traceId) {
    return $606558cf766ad3f9$var$isValidHex(traceId, 32) && traceId !== (0, $jDXJY.INVALID_TRACEID);
}
function $606558cf766ad3f9$export$8e51c6d8f0586aff(spanId) {
    return $606558cf766ad3f9$var$isValidHex(spanId, 16) && spanId !== (0, $jDXJY.INVALID_SPANID);
}
function $606558cf766ad3f9$export$e4373b9a2c09216c(spanContext) {
    return $606558cf766ad3f9$export$29dd34cf1269f6da(spanContext.traceId) && $606558cf766ad3f9$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $606558cf766ad3f9$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $lQGVM.NonRecordingSpan)(spanContext);
}

});



parcelRegister("5Y0su", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $4582e96ac672f85b$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $iGMGg = parcelRequire("iGMGg");
class $4582e96ac672f85b$export$87d8e93756f9e86e {
    getTracer(_name, _version, _options) {
        return new (0, $iGMGg.NoopTracer)();
    }
}

});





parcelRegister("c0tNN", function(module, exports) {
$parcel$export(module.exports, "experienceTypeKey", () => $417c6c47b57f9b09$export$1069c2293742749e);

var $j3jZT = parcelRequire("j3jZT");
const $417c6c47b57f9b09$export$1069c2293742749e = (0, $j3jZT.createContextKey)('type');

});

parcelRegister("a2arA", function(module, exports) {
$parcel$export(module.exports, "spanIdKey", () => $af12ac5d7288d8fe$export$ccdc89d1d45284c2);

var $j3jZT = parcelRequire("j3jZT");
const $af12ac5d7288d8fe$export$ccdc89d1d45284c2 = (0, $j3jZT.createContextKey)('spanId');

});

parcelRegister("4VOnD", function(module, exports) {
$parcel$export(module.exports, "traceIdKey", () => $56558679e7b668fe$export$65f3d43d675bb81b);

var $j3jZT = parcelRequire("j3jZT");
const $56558679e7b668fe$export$65f3d43d675bb81b = (0, $j3jZT.createContextKey)('traceId');

});


parcelRegister("83k1Z", function(module, exports) {
$parcel$export(module.exports, "useInteractionContext", () => $a352d0816818719a$export$11bcb6e9af2aca35);

var $bSJIT = parcelRequire("bSJIT");

var $cyIUy = parcelRequire("cyIUy");
function $a352d0816818719a$export$11bcb6e9af2aca35() {
    return (0, $bSJIT.useContext)((0, $cyIUy.default));
}

});
parcelRegister("cyIUy", function(module, exports) {
$parcel$export(module.exports, "default", () => $91176013b2d6c297$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $91176013b2d6c297$var$interactionContext = (0, $bSJIT.createContext)(null);
var $91176013b2d6c297$export$2e2bcd8739ae039 = $91176013b2d6c297$var$interactionContext;

});


parcelRegister("lIf8L", function(module, exports) {
$parcel$export(module.exports, "default", () => $2438d08882a376e6$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $2438d08882a376e6$var$UFORouteName = {
    current: null
};
var $2438d08882a376e6$export$2e2bcd8739ae039 = $2438d08882a376e6$var$UFORouteName;

});

parcelRegister("aLWdb", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $7d7b72cafd4152a0$export$c4744153514ff05d, (v) => $7d7b72cafd4152a0$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $7d7b72cafd4152a0$export$3e506c1ccc9cc1a7, (v) => $7d7b72cafd4152a0$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $7d7b72cafd4152a0$export$e26fe2ed2fa76875, (v) => $7d7b72cafd4152a0$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $7d7b72cafd4152a0$export$502329bbf4b505b1, (v) => $7d7b72cafd4152a0$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $7d7b72cafd4152a0$export$6e3807111c4874c4, (v) => $7d7b72cafd4152a0$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $7d7b72cafd4152a0$export$c27134553091fb3a, (v) => $7d7b72cafd4152a0$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $7d7b72cafd4152a0$export$33ee1acdc04fd2a2, (v) => $7d7b72cafd4152a0$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $7d7b72cafd4152a0$export$b00a404bbd5edef2, (v) => $7d7b72cafd4152a0$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $7d7b72cafd4152a0$export$8352ce38b91d0c62, (v) => $7d7b72cafd4152a0$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $7d7b72cafd4152a0$export$d66a1c1c77bd778b, (v) => $7d7b72cafd4152a0$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $7d7b72cafd4152a0$export$d3dfb8e4810cb555, (v) => $7d7b72cafd4152a0$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $7d7b72cafd4152a0$export$839f9183b0465a69, (v) => $7d7b72cafd4152a0$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $7d7b72cafd4152a0$export$72fdf0e06517287b, (v) => $7d7b72cafd4152a0$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $7d7b72cafd4152a0$export$4b844e58a3e414b4, (v) => $7d7b72cafd4152a0$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $7d7b72cafd4152a0$export$816d2913ae6b83b1, (v) => $7d7b72cafd4152a0$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $7d7b72cafd4152a0$export$61bcfe829111a1d0, (v) => $7d7b72cafd4152a0$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $7d7b72cafd4152a0$export$7ee8c9beb337bc3f, (v) => $7d7b72cafd4152a0$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $7d7b72cafd4152a0$export$b5836b71941fa3ed, (v) => $7d7b72cafd4152a0$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $7d7b72cafd4152a0$export$cf845f2c119da08a, (v) => $7d7b72cafd4152a0$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7d7b72cafd4152a0$export$c4744153514ff05d;
var $7d7b72cafd4152a0$export$3e506c1ccc9cc1a7;
var $7d7b72cafd4152a0$export$e26fe2ed2fa76875;
var $7d7b72cafd4152a0$export$502329bbf4b505b1;
var $7d7b72cafd4152a0$export$6e3807111c4874c4;
var $7d7b72cafd4152a0$export$c27134553091fb3a;
var $7d7b72cafd4152a0$export$33ee1acdc04fd2a2;
var $7d7b72cafd4152a0$export$b00a404bbd5edef2;
var $7d7b72cafd4152a0$export$8352ce38b91d0c62;
var $7d7b72cafd4152a0$export$d66a1c1c77bd778b;
var $7d7b72cafd4152a0$export$d3dfb8e4810cb555;
var $7d7b72cafd4152a0$export$839f9183b0465a69;
var $7d7b72cafd4152a0$export$72fdf0e06517287b;
var $7d7b72cafd4152a0$export$4b844e58a3e414b4;
var $7d7b72cafd4152a0$export$816d2913ae6b83b1;
var $7d7b72cafd4152a0$export$61bcfe829111a1d0;
var $7d7b72cafd4152a0$export$7ee8c9beb337bc3f;
var $7d7b72cafd4152a0$export$b5836b71941fa3ed;
var $7d7b72cafd4152a0$export$cf845f2c119da08a;
'use strict';
function $7d7b72cafd4152a0$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $7d7b72cafd4152a0$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $7d7b72cafd4152a0$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $7d7b72cafd4152a0$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $7d7b72cafd4152a0$var$g(C, c)) n < e && 0 > $7d7b72cafd4152a0$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $7d7b72cafd4152a0$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $7d7b72cafd4152a0$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7d7b72cafd4152a0$var$l = performance;
    $7d7b72cafd4152a0$export$c4744153514ff05d = function() {
        return $7d7b72cafd4152a0$var$l.now();
    };
} else {
    var $7d7b72cafd4152a0$var$p = Date, $7d7b72cafd4152a0$var$q = $7d7b72cafd4152a0$var$p.now();
    $7d7b72cafd4152a0$export$c4744153514ff05d = function() {
        return $7d7b72cafd4152a0$var$p.now() - $7d7b72cafd4152a0$var$q;
    };
}
var $7d7b72cafd4152a0$var$r = [], $7d7b72cafd4152a0$var$t = [], $7d7b72cafd4152a0$var$u = 1, $7d7b72cafd4152a0$var$v = null, $7d7b72cafd4152a0$var$y = 3, $7d7b72cafd4152a0$var$z = !1, $7d7b72cafd4152a0$var$A = !1, $7d7b72cafd4152a0$var$B = !1, $7d7b72cafd4152a0$var$D = "function" === typeof setTimeout ? setTimeout : null, $7d7b72cafd4152a0$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $7d7b72cafd4152a0$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $7d7b72cafd4152a0$var$G(a) {
    for(var b = $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$t); null !== b;){
        if (null === b.callback) $7d7b72cafd4152a0$var$k($7d7b72cafd4152a0$var$t);
        else if (b.startTime <= a) $7d7b72cafd4152a0$var$k($7d7b72cafd4152a0$var$t), b.sortIndex = b.expirationTime, $7d7b72cafd4152a0$var$f($7d7b72cafd4152a0$var$r, b);
        else break;
        b = $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$t);
    }
}
function $7d7b72cafd4152a0$var$H(a) {
    $7d7b72cafd4152a0$var$B = !1;
    $7d7b72cafd4152a0$var$G(a);
    if (!$7d7b72cafd4152a0$var$A) {
        if (null !== $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$r)) $7d7b72cafd4152a0$var$A = !0, $7d7b72cafd4152a0$var$I($7d7b72cafd4152a0$var$J);
        else {
            var b = $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$t);
            null !== b && $7d7b72cafd4152a0$var$K($7d7b72cafd4152a0$var$H, b.startTime - a);
        }
    }
}
function $7d7b72cafd4152a0$var$J(a, b) {
    $7d7b72cafd4152a0$var$A = !1;
    $7d7b72cafd4152a0$var$B && ($7d7b72cafd4152a0$var$B = !1, $7d7b72cafd4152a0$var$E($7d7b72cafd4152a0$var$L), $7d7b72cafd4152a0$var$L = -1);
    $7d7b72cafd4152a0$var$z = !0;
    var c = $7d7b72cafd4152a0$var$y;
    try {
        $7d7b72cafd4152a0$var$G(b);
        for($7d7b72cafd4152a0$var$v = $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$r); null !== $7d7b72cafd4152a0$var$v && (!($7d7b72cafd4152a0$var$v.expirationTime > b) || a && !$7d7b72cafd4152a0$var$M());){
            var d = $7d7b72cafd4152a0$var$v.callback;
            if ("function" === typeof d) {
                $7d7b72cafd4152a0$var$v.callback = null;
                $7d7b72cafd4152a0$var$y = $7d7b72cafd4152a0$var$v.priorityLevel;
                var e = d($7d7b72cafd4152a0$var$v.expirationTime <= b);
                b = $7d7b72cafd4152a0$export$c4744153514ff05d();
                "function" === typeof e ? $7d7b72cafd4152a0$var$v.callback = e : $7d7b72cafd4152a0$var$v === $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$r) && $7d7b72cafd4152a0$var$k($7d7b72cafd4152a0$var$r);
                $7d7b72cafd4152a0$var$G(b);
            } else $7d7b72cafd4152a0$var$k($7d7b72cafd4152a0$var$r);
            $7d7b72cafd4152a0$var$v = $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$r);
        }
        if (null !== $7d7b72cafd4152a0$var$v) var w = !0;
        else {
            var m = $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$t);
            null !== m && $7d7b72cafd4152a0$var$K($7d7b72cafd4152a0$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $7d7b72cafd4152a0$var$v = null, $7d7b72cafd4152a0$var$y = c, $7d7b72cafd4152a0$var$z = !1;
    }
}
var $7d7b72cafd4152a0$var$N = !1, $7d7b72cafd4152a0$var$O = null, $7d7b72cafd4152a0$var$L = -1, $7d7b72cafd4152a0$var$P = 5, $7d7b72cafd4152a0$var$Q = -1;
function $7d7b72cafd4152a0$var$M() {
    return $7d7b72cafd4152a0$export$c4744153514ff05d() - $7d7b72cafd4152a0$var$Q < $7d7b72cafd4152a0$var$P ? !1 : !0;
}
function $7d7b72cafd4152a0$var$R() {
    if (null !== $7d7b72cafd4152a0$var$O) {
        var a = $7d7b72cafd4152a0$export$c4744153514ff05d();
        $7d7b72cafd4152a0$var$Q = a;
        var b = !0;
        try {
            b = $7d7b72cafd4152a0$var$O(!0, a);
        } finally{
            b ? $7d7b72cafd4152a0$var$S() : ($7d7b72cafd4152a0$var$N = !1, $7d7b72cafd4152a0$var$O = null);
        }
    } else $7d7b72cafd4152a0$var$N = !1;
}
var $7d7b72cafd4152a0$var$S;
if ("function" === typeof $7d7b72cafd4152a0$var$F) $7d7b72cafd4152a0$var$S = function() {
    $7d7b72cafd4152a0$var$F($7d7b72cafd4152a0$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $7d7b72cafd4152a0$var$T = new MessageChannel, $7d7b72cafd4152a0$var$U = $7d7b72cafd4152a0$var$T.port2;
    $7d7b72cafd4152a0$var$T.port1.onmessage = $7d7b72cafd4152a0$var$R;
    $7d7b72cafd4152a0$var$S = function() {
        $7d7b72cafd4152a0$var$U.postMessage(null);
    };
} else $7d7b72cafd4152a0$var$S = function() {
    $7d7b72cafd4152a0$var$D($7d7b72cafd4152a0$var$R, 0);
};
function $7d7b72cafd4152a0$var$I(a) {
    $7d7b72cafd4152a0$var$O = a;
    $7d7b72cafd4152a0$var$N || ($7d7b72cafd4152a0$var$N = !0, $7d7b72cafd4152a0$var$S());
}
function $7d7b72cafd4152a0$var$K(a, b) {
    $7d7b72cafd4152a0$var$L = $7d7b72cafd4152a0$var$D(function() {
        a($7d7b72cafd4152a0$export$c4744153514ff05d());
    }, b);
}
$7d7b72cafd4152a0$export$3e506c1ccc9cc1a7 = 5;
$7d7b72cafd4152a0$export$e26fe2ed2fa76875 = 1;
$7d7b72cafd4152a0$export$502329bbf4b505b1 = 4;
$7d7b72cafd4152a0$export$6e3807111c4874c4 = 3;
$7d7b72cafd4152a0$export$c27134553091fb3a = null;
$7d7b72cafd4152a0$export$33ee1acdc04fd2a2 = 2;
$7d7b72cafd4152a0$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$7d7b72cafd4152a0$export$8352ce38b91d0c62 = function() {
    $7d7b72cafd4152a0$var$A || $7d7b72cafd4152a0$var$z || ($7d7b72cafd4152a0$var$A = !0, $7d7b72cafd4152a0$var$I($7d7b72cafd4152a0$var$J));
};
$7d7b72cafd4152a0$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7d7b72cafd4152a0$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$7d7b72cafd4152a0$export$d3dfb8e4810cb555 = function() {
    return $7d7b72cafd4152a0$var$y;
};
$7d7b72cafd4152a0$export$839f9183b0465a69 = function() {
    return $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$r);
};
$7d7b72cafd4152a0$export$72fdf0e06517287b = function(a) {
    switch($7d7b72cafd4152a0$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $7d7b72cafd4152a0$var$y;
    }
    var c = $7d7b72cafd4152a0$var$y;
    $7d7b72cafd4152a0$var$y = b;
    try {
        return a();
    } finally{
        $7d7b72cafd4152a0$var$y = c;
    }
};
$7d7b72cafd4152a0$export$4b844e58a3e414b4 = function() {};
$7d7b72cafd4152a0$export$816d2913ae6b83b1 = function() {};
$7d7b72cafd4152a0$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $7d7b72cafd4152a0$var$y;
    $7d7b72cafd4152a0$var$y = a;
    try {
        return b();
    } finally{
        $7d7b72cafd4152a0$var$y = c;
    }
};
$7d7b72cafd4152a0$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $7d7b72cafd4152a0$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $7d7b72cafd4152a0$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $7d7b72cafd4152a0$var$f($7d7b72cafd4152a0$var$t, a), null === $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$r) && a === $7d7b72cafd4152a0$var$h($7d7b72cafd4152a0$var$t) && ($7d7b72cafd4152a0$var$B ? ($7d7b72cafd4152a0$var$E($7d7b72cafd4152a0$var$L), $7d7b72cafd4152a0$var$L = -1) : $7d7b72cafd4152a0$var$B = !0, $7d7b72cafd4152a0$var$K($7d7b72cafd4152a0$var$H, c - d))) : (a.sortIndex = e, $7d7b72cafd4152a0$var$f($7d7b72cafd4152a0$var$r, a), $7d7b72cafd4152a0$var$A || $7d7b72cafd4152a0$var$z || ($7d7b72cafd4152a0$var$A = !0, $7d7b72cafd4152a0$var$I($7d7b72cafd4152a0$var$J)));
    return a;
};
$7d7b72cafd4152a0$export$b5836b71941fa3ed = $7d7b72cafd4152a0$var$M;
$7d7b72cafd4152a0$export$cf845f2c119da08a = function(a) {
    var b = $7d7b72cafd4152a0$var$y;
    return function() {
        var c = $7d7b72cafd4152a0$var$y;
        $7d7b72cafd4152a0$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $7d7b72cafd4152a0$var$y = c;
        }
    };
};

});

parcelRegister("fv4Dh", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("lEOYp"),
    $kOunM("hovo3")
]).then(()=>parcelRequire('87oOR'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("2X4Mn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("lEOYp"),
    $kOunM("ggonY")
]).then(()=>parcelRequire('bj0Gs'));

});

parcelRegister("63eex", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("SX3Qp").then(()=>parcelRequire('7PAsy'));

});

parcelRegister("h3RVQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("pIeyL").then(()=>parcelRequire('1iow2'));

});

parcelRegister("1bKYo", function(module, exports) {
$parcel$export(module.exports, "configure", () => $b89ac483f5edc714$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $b89ac483f5edc714$export$44487a86467333c3);

var $aae7p = parcelRequire("aae7p");
const $b89ac483f5edc714$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $b89ac483f5edc714$var$getAllowedParams() {
    const config = (0, $aae7p.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $b89ac483f5edc714$var$defaultAllowedParams;
}
function $b89ac483f5edc714$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $b89ac483f5edc714$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $b89ac483f5edc714$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $b89ac483f5edc714$var$handleQueryParams(url);
    }
};
function $b89ac483f5edc714$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $b89ac483f5edc714$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $b89ac483f5edc714$var$config = newConfig;
}
function $b89ac483f5edc714$export$44487a86467333c3() {
    return $b89ac483f5edc714$var$config;
}

});

parcelRegister("65irk", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $e024ff7e3568d61e$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $e024ff7e3568d61e$export$4138a729ef1db028);

var $1bM4Q = parcelRequire("1bM4Q");
const $e024ff7e3568d61e$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $e024ff7e3568d61e$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $e024ff7e3568d61e$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        const duration = (0, $1bM4Q.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find((timing)=>timing.name === 'atl-edge')) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi'));
        const serverTime = totalBackendTimeEntry ? (0, $1bM4Q.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $1bM4Q.roundEpsilon)(entry.startTime),
            duration: (0, $1bM4Q.roundEpsilon)(entry.duration),
            fetchStart: (0, $1bM4Q.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $1bM4Q.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $1bM4Q.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $1bM4Q.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $1bM4Q.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $1bM4Q.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        var _performance$getEntri;
        const performance = $e024ff7e3568d61e$var$getPerformanceObject();
        const PerformanceObserver = $e024ff7e3568d61e$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($e024ff7e3568d61e$export$bea963256235a63e.observer) return;
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $e024ff7e3568d61e$export$bea963256235a63e.timings = resources.map((resource)=>$e024ff7e3568d61e$export$bea963256235a63e.transformResource(resource));
        $e024ff7e3568d61e$export$bea963256235a63e.observer = new PerformanceObserver($e024ff7e3568d61e$export$bea963256235a63e.addTimings);
        $e024ff7e3568d61e$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($e024ff7e3568d61e$export$bea963256235a63e.observer) {
            $e024ff7e3568d61e$export$bea963256235a63e.observer.disconnect();
            $e024ff7e3568d61e$export$bea963256235a63e.observer = null;
        }
        $e024ff7e3568d61e$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$e024ff7e3568d61e$export$bea963256235a63e.transformResource(entry));
        const overflow = $e024ff7e3568d61e$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $e024ff7e3568d61e$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $e024ff7e3568d61e$export$bea963256235a63e.maxSize;
            $e024ff7e3568d61e$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $e024ff7e3568d61e$export$bea963256235a63e.timings.push(...entries);
    }
};
function $e024ff7e3568d61e$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $e024ff7e3568d61e$export$4138a729ef1db028(startTime, endTime) {
    const performance = $e024ff7e3568d61e$var$getPerformanceObject();
    const PerformanceObserver = $e024ff7e3568d61e$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$e024ff7e3568d61e$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$e024ff7e3568d61e$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $e024ff7e3568d61e$export$bea963256235a63e.timings.filter((timing)=>$e024ff7e3568d61e$var$isValidTiming(timing, startTime, endTime));
}

});
parcelRegister("1bM4Q", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", () => $c4ba0ff146fd6d55$export$56014375de40214b);
function $c4ba0ff146fd6d55$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("19KC3", function(module, exports) {
$parcel$export(module.exports, "configure", () => $523004e3bf416e71$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $523004e3bf416e71$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $523004e3bf416e71$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $523004e3bf416e71$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $523004e3bf416e71$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $523004e3bf416e71$export$1c4a9b5e6e22393d);
$parcel$export(module.exports, "getSSRSuccessBreakdown", () => $523004e3bf416e71$export$eb7c400973493903);
const $523004e3bf416e71$var$NESTED_METRIC_SEPARATOR = '/';
function $523004e3bf416e71$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $523004e3bf416e71$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $523004e3bf416e71$var$SSR_PREFIX = 'ssr';
function $523004e3bf416e71$var$mapKey(key) {
    if (key === 'total') return $523004e3bf416e71$var$SSR_PREFIX;
    return `${$523004e3bf416e71$var$SSR_PREFIX}${$523004e3bf416e71$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $523004e3bf416e71$var$config;
function $523004e3bf416e71$export$8d21e34596265fa2(ssrConfig) {
    $523004e3bf416e71$var$config = ssrConfig;
}
function $523004e3bf416e71$var$getPerformanceNavigationTiming() {
    var _performance$getEntri;
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (_performance$getEntri = performance.getEntriesByType('navigation')) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri[0];
}
function $523004e3bf416e71$var$getServerTimingsByName() {
    var _getPerformanceNaviga;
    const serverTimingsByName = Object.fromEntries(((_getPerformanceNaviga = $523004e3bf416e71$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga === void 0 || (_getPerformanceNaviga = _getPerformanceNaviga.serverTiming) === null || _getPerformanceNaviga === void 0 ? void 0 : _getPerformanceNaviga.map((timing)=>[
            timing.name,
            timing
        ])) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $523004e3bf416e71$var$getEdgeOffset(edgeTtfb) {
    var _getPerformanceNaviga2;
    const clientTtfb = (_getPerformanceNaviga2 = $523004e3bf416e71$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga2 === void 0 ? void 0 : _getPerformanceNaviga2.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $523004e3bf416e71$export$5300d1b82e594615() {
    var _serverTimingsByName$, _serverTimingsByName$2, _serverTimingsByName$3, _serverTimingsByName$4, _serverTimingsByName$5, _serverTimingsByName$6, _serverTimingsByName$7, _serverTimingsByName$8;
    const serverTimingsByName = $523004e3bf416e71$var$getServerTimingsByName();
    const edgeTotalDuration = ((_serverTimingsByName$ = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$ === void 0 ? void 0 : _serverTimingsByName$.duration) ?? ((_serverTimingsByName$2 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$2 === void 0 ? void 0 : _serverTimingsByName$2.duration);
    if (!edgeTotalDuration) return null;
    const edgeOffset = $523004e3bf416e71$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (((_serverTimingsByName$3 = serverTimingsByName['cdn-upstream-dns']) === null || _serverTimingsByName$3 === void 0 ? void 0 : _serverTimingsByName$3.duration) || 0) + (((_serverTimingsByName$4 = serverTimingsByName['cdn-upstream-connect']) === null || _serverTimingsByName$4 === void 0 ? void 0 : _serverTimingsByName$4.duration) || 0);
    const cfUpstreamDuration = (((_serverTimingsByName$5 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$5 === void 0 ? void 0 : _serverTimingsByName$5.duration) || 0) - cfInternalDuration;
    const cfDownstreamDuration = (((_serverTimingsByName$6 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$6 === void 0 ? void 0 : _serverTimingsByName$6.duration) || 0) - (((_serverTimingsByName$7 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$7 === void 0 ? void 0 : _serverTimingsByName$7.duration) || 0);
    const atlEdgeDuration = (_serverTimingsByName$8 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$8 === void 0 ? void 0 : _serverTimingsByName$8.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        var _serverTimingsByName$9;
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: (_serverTimingsByName$9 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$9 === void 0 ? void 0 : _serverTimingsByName$9.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        var _serverTimingsByName$0;
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: (_serverTimingsByName$0 = serverTimingsByName['atl-edge-internal']) === null || _serverTimingsByName$0 === void 0 ? void 0 : _serverTimingsByName$0.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    (edgeTimings === null || edgeTimings === void 0 ? void 0 : edgeTimings.edge) && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $523004e3bf416e71$export$bf7408e83532dcd0() {
    var _config;
    const defaultSSRTimings = $523004e3bf416e71$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof ((_config = $523004e3bf416e71$var$config) === null || _config === void 0 ? void 0 : _config.getTimings) === 'function') configTimings = $523004e3bf416e71$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($523004e3bf416e71$var$filterEntry(entry[1])) acc[$523004e3bf416e71$var$mapKey(entry[0])] = $523004e3bf416e71$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $523004e3bf416e71$export$c7ad864055e75537() {
    var _config2;
    return !!((_config2 = $523004e3bf416e71$var$config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
function $523004e3bf416e71$export$5eade9354185583d() {
    var _config3, _config3$getSsrPhaseS;
    return (_config3 = $523004e3bf416e71$var$config) === null || _config3 === void 0 || (_config3$getSsrPhaseS = _config3.getSsrPhaseSuccess) === null || _config3$getSsrPhaseS === void 0 ? void 0 : _config3$getSsrPhaseS.call(_config3);
}
function $523004e3bf416e71$export$3def7672244bab0c() {
    var _config4;
    return ((_config4 = $523004e3bf416e71$var$config) === null || _config4 === void 0 ? void 0 : _config4.getDoneMark()) ?? undefined;
}
function $523004e3bf416e71$export$1c4a9b5e6e22393d() {
    var _config5;
    if (!((_config5 = $523004e3bf416e71$var$config) !== null && _config5 !== void 0 && _config5.getFeatureFlags)) return undefined;
    try {
        return $523004e3bf416e71$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
function $523004e3bf416e71$export$eb7c400973493903() {
    var _config6;
    if (!((_config6 = $523004e3bf416e71$var$config) !== null && _config6 !== void 0 && _config6.getSsrSuccessBreakdown)) return undefined;
    try {
        return $523004e3bf416e71$var$config.getSsrSuccessBreakdown() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}

});

parcelRegister("iW3CQ", function(module, exports) {
$parcel$export(module.exports, "EnvType", () => $9e3a68dc13fe35af$export$76f4b1ef26f59baf);
$parcel$export(module.exports, "getEnv", () => $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e);
$parcel$export(module.exports, "getIsPageServerSideRendered", () => $9e3a68dc13fe35af$export$11bdeb36ea0511ca);
$parcel$export(module.exports, "getIsMultiHCEnabled", () => $9e3a68dc13fe35af$export$ae0e930c2df55631);
$parcel$export(module.exports, "getIsHCCustomizationEnabled", () => $9e3a68dc13fe35af$export$efe1682951193de4);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $9e3a68dc13fe35af$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $9e3a68dc13fe35af$export$9679fa5312e1354b);
$parcel$export(module.exports, "getHoistedProjectKey", () => $9e3a68dc13fe35af$export$3b0fd0e16a94f75);

var $4U3zK = parcelRequire("4U3zK");

var $fuVmc = parcelRequire("fuVmc");
var $9e3a68dc13fe35af$export$76f4b1ef26f59baf = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}({});
function $9e3a68dc13fe35af$var$parseEnvironment() {
    const env = (0, $fuVmc.getMeta)('environment');
    if (env === 'prod') return "prod";
    if (env === 'staging') return "staging";
    return "dev";
}
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const $9e3a68dc13fe35af$var$parseJson = (content)=>content ? JSON.parse(content) : {};
const $9e3a68dc13fe35af$var$envElement = (0, $4U3zK.default).getElementById('envJson');
let $9e3a68dc13fe35af$var$envData;
const $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e = ()=>{
    if ($9e3a68dc13fe35af$var$envData) return $9e3a68dc13fe35af$var$envData;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $9e3a68dc13fe35af$var$envData = Object.freeze({
        ...$9e3a68dc13fe35af$var$parseJson($9e3a68dc13fe35af$var$envElement && $9e3a68dc13fe35af$var$envElement.textContent),
        environment: $9e3a68dc13fe35af$var$parseEnvironment()
    });
    return $9e3a68dc13fe35af$var$envData;
};
const $9e3a68dc13fe35af$export$11bdeb36ea0511ca = ()=>{
    // @ts-ignore - TS2339: Property '__IS_PAGE_SERVER_SIDE_RENDERED__' does not exist on type 'Window & typeof globalThis'.
    // This was added when adding project references to help center.
    return window.__IS_PAGE_SERVER_SIDE_RENDERED__;
};
const $9e3a68dc13fe35af$export$ae0e930c2df55631 = ()=>{
    var _getEnv$featuredValue;
    return (_getEnv$featuredValue = $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue === void 0 ? void 0 : _getEnv$featuredValue.multiHelpCenterEnabled;
};
const $9e3a68dc13fe35af$export$efe1682951193de4 = ()=>{
    var _getEnv$featuredValue2;
    return (_getEnv$featuredValue2 = $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue2 === void 0 ? void 0 : _getEnv$featuredValue2.helpCenterCustomizationEnabled;
};
const $9e3a68dc13fe35af$export$a90992f5204fc247 = ()=>{
    var _getEnv$featuredValue3;
    return ((_getEnv$featuredValue3 = $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue3 === void 0 ? void 0 : _getEnv$featuredValue3.jsmAiConfigEnabled) ?? false;
};
const $9e3a68dc13fe35af$export$9679fa5312e1354b = ()=>{
    return $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e().jiraDisplayUrl;
};
const $9e3a68dc13fe35af$export$3b0fd0e16a94f75 = ()=>{
    return $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e().hoistedProjectKey;
};
const $9e3a68dc13fe35af$export$e567920edc63a849 = ()=>{
    return $9e3a68dc13fe35af$export$4bd44a2aa29d3d6e().relativeBaseUrl;
};

});

parcelRegister("7faDj", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $c3075f06ab10de1f$export$b46cecdf698e4bb5);

var $6umVX = parcelRequire("6umVX");

var $3QBIh = parcelRequire("3QBIh");

var $hdskT = parcelRequire("hdskT");

var $eYGka = parcelRequire("eYGka");
function $c3075f06ab10de1f$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $hdskT.getTBT)(start, stop, (0, $eYGka.EntriesBuffer)[(0, $3QBIh.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $6umVX.getCLS)(start, stop, (0, $eYGka.EntriesBuffer)[(0, $3QBIh.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("6umVX", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $aa601a3cbf14cd2b$export$fc6227831ee7c7);
function $aa601a3cbf14cd2b$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $aa601a3cbf14cd2b$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        var _entry$sources;
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(({ previousRect: previousRect, currentRect: currentRect })=>$aa601a3cbf14cd2b$var$isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("3QBIh", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $cdb6938865d7989b$export$a4def92db6fc8e17);
// oxlint-disable-next-line eslint/no-redeclare
const $cdb6938865d7989b$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("hdskT", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $40ad40da97489552$export$2d6e933b35bd3407);
const $40ad40da97489552$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $40ad40da97489552$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $40ad40da97489552$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $40ad40da97489552$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $40ad40da97489552$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("eYGka", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $2f0ab4823e9f1322$export$f7dc16cbd16f7bbe);

var $3QBIh = parcelRequire("3QBIh");
class $2f0ab4823e9f1322$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $2f0ab4823e9f1322$export$f7dc16cbd16f7bbe = {
    [(0, $3QBIh.PerformanceObserverEntryTypes).LongTask]: new $2f0ab4823e9f1322$export$2c6e86519c9e8188(),
    [(0, $3QBIh.PerformanceObserverEntryTypes).LayoutShift]: new $2f0ab4823e9f1322$export$2c6e86519c9e8188()
};

});


parcelRegister("iRD29", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $fb0d8b32ce05faf6$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "updateUserInfo", () => $fb0d8b32ce05faf6$export$c305be0ec5c00f16);
$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $fb0d8b32ce05faf6$export$799525ac94ca811d);

var $f2Pmd = parcelRequire("f2Pmd");

var $gNwHK = parcelRequire("gNwHK");

var $fuVmc = parcelRequire("fuVmc");

var $4ZMmh = parcelRequire("4ZMmh");

var $clpci = parcelRequire("clpci");

var $ezwN8 = parcelRequire("ezwN8");

var $haAAx = parcelRequire("haAAx");

var $7190A = parcelRequire("7190A");
var $3hnsi = parcelRequire("3hnsi");

var $hCnLH = parcelRequire("hCnLH");

var $6JJ8C = parcelRequire("6JJ8C");

var $iW3CQ = parcelRequire("iW3CQ");

var $eKcQp = parcelRequire("eKcQp");

var $5B7Ib = parcelRequire("5B7Ib");

const $fb0d8b32ce05faf6$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
class $fb0d8b32ce05faf6$export$208d0eb1d9fc833e {
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, product: product, environment: environment, locale: locale, callback: callback, version: version, shouldTriggerUIViewed: shouldTriggerUIViewed = true }) {
        this.analyticsClient = new (0, $f2Pmd.default)({
            product: product,
            locale: locale,
            env: environment,
            version: version || '1.0.0',
            origin: (0, $gNwHK.originType).WEB,
            ...(0, $7190A.isIsolatedCloud)() ? {
                ic: (0, $3hnsi.isolationContextId)()
            } : undefined
        }, {
            disableCookiePersistence: true,
            isSynthetic: (0, $fuVmc.getMeta)('ajs-is-synthetic') === 'true',
            ...(0, $7190A.isIsolatedCloud)() ? {
                apiHost: `${window.location.hostname}/${$fb0d8b32ce05faf6$var$GAS_V3_ROUTE}`
            } : undefined
        });
        this.bootstrapEventPayloadOverride();
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $gNwHK.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $gNwHK.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, $4ZMmh.noop);
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        return true;
    }
    addCommonHelpCenterData(event) {
        if (typeof event === 'object') event.attributes = {
            ...event.attributes,
            ...(0, $5B7Ib.getHelpCenterAnalyticsData)(),
            ...(0, $eKcQp.getApplicationType)()
        };
        return event;
    }
    bootstrapEventPayloadOverride() {
        const sendUIEvent = this.analyticsClient.sendUIEvent;
        const sendTrackEvent = this.analyticsClient.sendTrackEvent;
        const sendOperationalEvent = this.analyticsClient.sendOperationalEvent;
        const sendScreenEvent = this.analyticsClient.sendScreenEvent;
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendUIEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendUIEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendTrackEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendTrackEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendOperationalEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendOperationalEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendScreenEvent = (event, callback, attributes)=>{
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const existingAttrs = typeof attributes === 'object' ? attributes : {
                //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value: attributes // non object vales are directly assigned as attributes accept `any`
            };
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const updatedAttrs = {
                ...existingAttrs,
                ...(0, $5B7Ib.getHelpCenterAnalyticsData)(),
                ...(0, $eKcQp.getApplicationType)()
            };
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendScreenEvent.call(this.analyticsClient, event, callback, updatedAttrs);
        };
    }
    getDataFromEvent(event, channel) {
        if (channel === (0, $clpci.ANALYTICS_BRIDGE_CHANNEL)) return (0, $ezwN8.extractAWCDataFromEvent)(event);
        return (0, $haAAx.getEvent)(event);
    }
    sendEvent(event, channel) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { type: type, payload: payload } = this.getDataFromEvent(event, channel);
        try {
            switch(type){
                case 0, $haAAx.UI_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $haAAx.TRACK_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $haAAx.OPERATIONAL_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $haAAx.SCREEN_EVENT_TYPE:
                    // Disabling existing violations, should be fixed when revisited.
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                    break;
                default:
                    (0, $6JJ8C.devLog)(`An event was blackholed because it was of an invalid analyticsType: ${// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    event.payload.analyticsType}.\nMake sure analyticsType is specified in the event's payload and is one of ${[
                        (0, $haAAx.UI_EVENT_TYPE),
                        (0, $haAAx.TRACK_EVENT_TYPE),
                        (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                        (0, $haAAx.SCREEN_EVENT_TYPE)
                    ].join(', ')}.`);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('Failed to send analytic data. It may be malformed, or sessionStorage may be disabled.', err);
        }
    }
    getInstance() {
        return this.analyticsClient;
    }
    updateUserInfo(accountId) {
        this.analyticsClient.setUserInfo((0, $gNwHK.userType).ATLASSIAN_ACCOUNT, accountId);
    }
}
let $fb0d8b32ce05faf6$var$analyticsWebClient;
const $fb0d8b32ce05faf6$export$e9ba7ef9458d1a4a = ()=>{
    if ($fb0d8b32ce05faf6$var$analyticsWebClient) return $fb0d8b32ce05faf6$var$analyticsWebClient;
    const locale = (0, $fuVmc.getMeta)('ajs-user-locale') || (0, $fuVmc.getMeta)('user-locale') || '';
    const tenantId = (0, $fuVmc.getMeta)('tenant-id') || '';
    const accountId = (0, $fuVmc.getMeta)('account-id') || '';
    const version = window.BUILD_KEY;
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const environment = (0, $iW3CQ.getEnv)().environment;
    $fb0d8b32ce05faf6$var$analyticsWebClient = new $fb0d8b32ce05faf6$export$208d0eb1d9fc833e();
    $fb0d8b32ce05faf6$var$analyticsWebClient.init({
        tenantId: tenantId,
        environment: environment,
        locale: locale,
        version: version,
        subProduct: isCSM ? 'customer-service' : 'serviceDesk',
        userId: accountId,
        product: 'jira',
        shouldTriggerUIViewed: false
    });
    return $fb0d8b32ce05faf6$var$analyticsWebClient;
};
const $fb0d8b32ce05faf6$export$c305be0ec5c00f16 = (accountId)=>{
    $fb0d8b32ce05faf6$var$analyticsWebClient.updateUserInfo(accountId);
};
const $fb0d8b32ce05faf6$export$799525ac94ca811d = ()=>Promise.resolve($fb0d8b32ce05faf6$export$e9ba7ef9458d1a4a());
const $fb0d8b32ce05faf6$export$474e180ec53844ef = ()=>{
    $fb0d8b32ce05faf6$var$analyticsWebClient = undefined;
};

});
parcelRegister("f2Pmd", function(module, exports) {
$parcel$export(module.exports, "default", () => $73309366eacdf2e0$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $2wgiL = parcelRequire("2wgiL");

var $3hnsi = parcelRequire("3hnsi");

var $gNwHK = parcelRequire("gNwHK");

var $3Ty0k = parcelRequire("3Ty0k");

var $1L73j = parcelRequire("1L73j");

var $3UwYd = parcelRequire("3UwYd");

var $4kI5B = parcelRequire("4kI5B");

var $5knMb = parcelRequire("5knMb");

var $bw8NJ = parcelRequire("bw8NJ");

var $76Ily = parcelRequire("76Ily");

var $7eusY = parcelRequire("7eusY");

var $jx7m9 = parcelRequire("jx7m9");

var $23EuR = parcelRequire("23EuR");

var $j3SXL = parcelRequire("j3SXL");

var $39ppA = parcelRequire("39ppA");

var $fIgkL = parcelRequire("fIgkL");

var $2Evq4 = parcelRequire("2Evq4");

var $7MiVX = parcelRequire("7MiVX");

var $4NcCK = parcelRequire("4NcCK");

var $agtVz = parcelRequire("agtVz");

var $5dgdV = parcelRequire("5dgdV");

var $bcKhw = parcelRequire("bcKhw");

var $2nczX = parcelRequire("2nczX");

var $l0dXm = parcelRequire("l0dXm");

var $1IhVl = parcelRequire("1IhVl");

var $3Vjuw = parcelRequire("3Vjuw");

var $blU4A = parcelRequire("blU4A");

var $5661s = parcelRequire("5661s");

var $gnFLN = parcelRequire("gnFLN");

var $8XLye = parcelRequire("8XLye");

var $8mUkO = parcelRequire("8mUkO");

var $5mcge = parcelRequire("5mcge");

var $2WbPB = parcelRequire("2WbPB");

var $ljUpE = parcelRequire("ljUpE");

var $1dzRQ = parcelRequire("1dzRQ");

var $kXTrw = parcelRequire("kXTrw");

var $g342h = parcelRequire("g342h");

var $ep1I0 = parcelRequire("ep1I0");

var $cmgc5 = parcelRequire("cmgc5");
const $73309366eacdf2e0$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $73309366eacdf2e0$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $bw8NJ.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $bw8NJ.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($73309366eacdf2e0$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($73309366eacdf2e0$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($73309366eacdf2e0$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $gNwHK.eventType).UI:
                case (0, $gNwHK.eventType).OPERATIONAL:
                case (0, $gNwHK.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $gNwHK.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $gNwHK.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $gNwHK.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $2Evq4.isType)((0, $gNwHK.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $4NcCK.objectValues)((0, $gNwHK.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $5mcge.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $2Evq4.isType)((0, $gNwHK.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $4NcCK.objectValues)((0, $gNwHK.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $2Evq4.isType)((0, $gNwHK.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $4NcCK.objectValues)((0, $gNwHK.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $gNwHK.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $1dzRQ.validateScreenEvent)(screenName);
            (0, $8mUkO.validateContainers)(screenContainers);
            const builtEvent = (0, $5knMb.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $ep1I0.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $kXTrw.validateTrackEvent)(event);
            const builtEvent = (0, $1L73j.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $gNwHK.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $3UwYd.buildActionName)(event), builtEvent, this._context, (0, $ep1I0.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $g342h.validateUIEvent)(event);
            const builtEvent = (0, $1L73j.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $gNwHK.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $3UwYd.buildActionName)(event), builtEvent, this._context, (0, $ep1I0.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $2WbPB.validateOperationalEvent)(event);
            const builtEvent = (0, $1L73j.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $gNwHK.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $3UwYd.buildActionName)(event), builtEvent, this._context, (0, $ep1I0.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $5661s.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $gNwHK.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $gNwHK.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $gNwHK.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $gNwHK.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $gNwHK.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $4NcCK.objectValues)((0, $gNwHK.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $2Evq4.isType)((0, $gNwHK.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $4NcCK.objectValues)((0, $gNwHK.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $gNwHK.originType).WEB;
        else if (!(0, $2Evq4.isType)((0, $gNwHK.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $4NcCK.objectValues)((0, $gNwHK.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $gNwHK.originType).WEB ? (0, $gNwHK.platformType).WEB : (0, $gNwHK.platformType).DESKTOP;
        else (0, $ljUpE.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $2wgiL.isFedrampModerate)()) productInfo.perimeter = (0, $gNwHK.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $gNwHK.perimeterType).COMMERCIAL;
        if (!(0, $2Evq4.isType)((0, $gNwHK.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $4NcCK.objectValues)((0, $gNwHK.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $3hnsi.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $39ppA.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $fIgkL.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $4kI5B.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $l0dXm.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $bcKhw.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $cmgc5.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $j3SXL.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $23EuR.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $7MiVX.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $5dgdV.default)();
        this._tabTracking = new (0, $1IhVl.default)();
        this._sessionTracking = new (0, $2nczX.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $3Vjuw.default)();
        this._originTracing = new (0, $agtVz.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $3Ty0k.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $7eusY.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $jx7m9.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $blU4A.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $8XLye.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $76Ily.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $gnFLN.TestSupport).isGeminiVREnvironment() && !(0, $gnFLN.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $gnFLN.TestSupport).isGeminiVREnvironment() && !(0, $gnFLN.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("3hnsi", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $78e1eba20626b917$export$839b022803d38d4d);

var $5GrQ1 = parcelRequire("5GrQ1");

var $7190A = parcelRequire("7190A");
function $78e1eba20626b917$export$839b022803d38d4d() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return (0, $7190A.isIsolatedCloud)() ? (_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.icName : undefined;
    }
    const atlCtxCookieValues = (0, $5GrQ1.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("7190A", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $d2e6e89b68ec4f8c$export$9186ccba8effc5de);

var $8HGg3 = parcelRequire("8HGg3");

var $5GrQ1 = parcelRequire("5GrQ1");
function $d2e6e89b68ec4f8c$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInIC) ?? false;
    }
    const atlCtxCookieValues = (0, $5GrQ1.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $8HGg3.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("8HGg3", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $4828572a13c9622b$export$d8347b4aae768c2d);

var $1GOV7 = parcelRequire("1GOV7");
const $4828572a13c9622b$export$d8347b4aae768c2d = [
    (0, $1GOV7.COMMERCIAL)
];

});



parcelRegister("gNwHK", function(module, exports) {
$parcel$export(module.exports, "envType", () => $f03c386ae2a7506d$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $f03c386ae2a7506d$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $f03c386ae2a7506d$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $f03c386ae2a7506d$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $f03c386ae2a7506d$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $f03c386ae2a7506d$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $f03c386ae2a7506d$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $f03c386ae2a7506d$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $f03c386ae2a7506d$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $f03c386ae2a7506d$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $f03c386ae2a7506d$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $f03c386ae2a7506d$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $f03c386ae2a7506d$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $f03c386ae2a7506d$export$e73680b18d9b7c6e);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $f03c386ae2a7506d$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $f03c386ae2a7506d$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $f03c386ae2a7506d$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $f03c386ae2a7506d$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $f03c386ae2a7506d$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $f03c386ae2a7506d$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $f03c386ae2a7506d$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $f03c386ae2a7506d$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $f03c386ae2a7506d$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $f03c386ae2a7506d$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $f03c386ae2a7506d$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $f03c386ae2a7506d$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $f03c386ae2a7506d$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $f03c386ae2a7506d$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $f03c386ae2a7506d$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("3Ty0k", function(module, exports) {
$parcel$export(module.exports, "default", () => $71b41ee144d365ba$export$2e2bcd8739ae039);

var $gNwHK = parcelRequire("gNwHK");

var $2Evq4 = parcelRequire("2Evq4");

var $5dgdV = parcelRequire("5dgdV");

var $3JuO5 = parcelRequire("3JuO5");
class $71b41ee144d365ba$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $gNwHK.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $gNwHK.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $gNwHK.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $2Evq4.isType)((0, $gNwHK.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $gNwHK.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $5dgdV.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $3JuO5.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("2Evq4", function(module, exports) {
$parcel$export(module.exports, "isType", () => $9c8cee4e4841b8bb$export$26b9f946b448f23e);
function $9c8cee4e4841b8bb$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("5dgdV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f8db083776d3cd6$export$2e2bcd8739ae039);
class $7f8db083776d3cd6$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("3JuO5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d82632c321cb718$export$2e2bcd8739ae039);
class $5d82632c321cb718$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("1L73j", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $354c65a07d060e65$export$7bf451af4a8e3dd9);

var $dWrhK = parcelRequire("dWrhK");

var $lz8x8 = parcelRequire("lz8x8");

var $izaUD = parcelRequire("izaUD");

var $6CkyC = parcelRequire("6CkyC");

var $laq3y = parcelRequire("laq3y");

var $aiYBo = parcelRequire("aiYBo");

var $k1N1E = parcelRequire("k1N1E");

var $lsVii = parcelRequire("lsVii");

var $45xB7 = parcelRequire("45xB7");

var $Yr1m0 = parcelRequire("Yr1m0");

var $MlhBJ = parcelRequire("MlhBJ");
function $354c65a07d060e65$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $k1N1E.buildProductFields)(productInfo, (0, $MlhBJ.extractProductOverrides)(event));
    const tenantFields = (0, $lsVii.buildTenantFields)(tenantInfo);
    const orgFields = (0, $aiYBo.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $Yr1m0.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $izaUD.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $45xB7.buildUserFields)(userInfo);
    const actionFields = (0, $dWrhK.buildActionFields)(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...(0, $6CkyC.buildEventOverrides)(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $lz8x8.buildAliases)(aliases),
        ...(0, $laq3y.buildGroups)(groups)
    };
}

});
parcelRegister("dWrhK", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $57de041204d29d58$export$655ecf7241feac42);

var $bUUEi = parcelRequire("bUUEi");
function $57de041204d29d58$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...(0, $bUUEi.buildContainersWithName)(event.containers)
    };
}

});
parcelRegister("bUUEi", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $5b7954ac551ac953$export$f045f238d77c002a);

var $j7Rjm = parcelRequire("j7Rjm");

var $8tts2 = parcelRequire("8tts2");

var $doJLi = parcelRequire("doJLi");
function $5b7954ac551ac953$export$f045f238d77c002a(containers) {
    if ((0, $doJLi.isNotEmptyObject)(containers)) {
        const validContainers = (0, $8tts2.filterAndBuildContainers)(containers);
        return (0, $j7Rjm.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("j7Rjm", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $7273e44dbec41c54$export$55b70947967d0b50);

var $doJLi = parcelRequire("doJLi");
function $7273e44dbec41c54$export$55b70947967d0b50(name, attrObject) {
    return (0, $doJLi.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("doJLi", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $458cea3c2c7b5f52$export$e0287cc73292b477);

var $bWIzZ = parcelRequire("bWIzZ");
function $458cea3c2c7b5f52$export$e0287cc73292b477(obj) {
    return (0, $bWIzZ.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("bWIzZ", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $fae9d2c94c671432$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $fae9d2c94c671432$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $fae9d2c94c671432$var$isObjectObject(o) {
    return $fae9d2c94c671432$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $fae9d2c94c671432$export$53b83ca8eaab0383(o) {
    if ($fae9d2c94c671432$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($fae9d2c94c671432$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("8tts2", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $a0cec0391f803c1c$export$3f5115a568819c1a);
function $a0cec0391f803c1c$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("lz8x8", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $777de7958f6e1ab5$export$2c4ef8ee173bbcaa);

var $doJLi = parcelRequire("doJLi");
function $777de7958f6e1ab5$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $doJLi.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("izaUD", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $f39ce6118d2ce006$export$d138783ff9effae1);
function $f39ce6118d2ce006$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("6CkyC", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $4a4b3c2acd27cdcf$export$469803cc371327c2);
function $4a4b3c2acd27cdcf$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("laq3y", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $86a61736b266936e$export$680f59e10d3eb269);

var $doJLi = parcelRequire("doJLi");
function $86a61736b266936e$export$680f59e10d3eb269(groups) {
    if ((0, $doJLi.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("aiYBo", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $77a2b56e465e0b82$export$19ccbe55c9aa75d5);
function $77a2b56e465e0b82$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("k1N1E", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $4dde5d103b236ba2$export$bd1896e45d2ef8e8);

var $b6M4u = parcelRequire("b6M4u");
function $4dde5d103b236ba2$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $b6M4u.getProductField)(productInfo.env, overrides.env);
    const product = (0, $b6M4u.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $b6M4u.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $b6M4u.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $b6M4u.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $b6M4u.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("b6M4u", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $fa8256a4b3530f86$export$690c718dc8037b2e);
function $fa8256a4b3530f86$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("lsVii", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $437bc4b70e26cf7d$export$ab02ab56ae59d840);
function $437bc4b70e26cf7d$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("45xB7", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $6850c505ce537b3d$export$4557a3fdd8921d68);
function $6850c505ce537b3d$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("Yr1m0", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $e0325da8f4701f76$export$73c41604cd4b31da);
function $e0325da8f4701f76$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("MlhBJ", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $41a3d9370adab7c6$export$e3d99b4bfec06f6e);
function $41a3d9370adab7c6$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("3UwYd", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $5f454a8a57b12cac$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $5f454a8a57b12cac$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("4kI5B", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $72656f83a1e5a72b$export$3a7fe28f9bf4f3d9);

var $d3MmT = parcelRequire("d3MmT");
const $72656f83a1e5a72b$var$libraryVersion = undefined;
function $72656f83a1e5a72b$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $d3MmT.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $d3MmT.validationMode).QUIET;
    return (0, $d3MmT.validationMode).COMPLETE;
}
function $72656f83a1e5a72b$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $72656f83a1e5a72b$var$libraryVersion
            },
            validationMode: $72656f83a1e5a72b$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("d3MmT", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $5185e094aa7b308e$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $5185e094aa7b308e$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("5knMb", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $ab14799044842380$export$c7d9a5f56acc4b19);

var $gNwHK = parcelRequire("gNwHK");

var $lz8x8 = parcelRequire("lz8x8");

var $j7Rjm = parcelRequire("j7Rjm");

var $izaUD = parcelRequire("izaUD");

var $bUUEi = parcelRequire("bUUEi");

var $6CkyC = parcelRequire("6CkyC");

var $laq3y = parcelRequire("laq3y");

var $eNyLT = parcelRequire("eNyLT");

var $aiYBo = parcelRequire("aiYBo");

var $k1N1E = parcelRequire("k1N1E");

var $lsVii = parcelRequire("lsVii");

var $45xB7 = parcelRequire("45xB7");

var $Yr1m0 = parcelRequire("Yr1m0");
function $ab14799044842380$var$buildAttributes(attributes) {
    return (0, $j7Rjm.buildAttributesWithName)('attributes', attributes);
}
function $ab14799044842380$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $j7Rjm.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $ab14799044842380$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $k1N1E.buildProductFields)(productInfo);
    const tenantFields = (0, $lsVii.buildTenantFields)(tenantInfo);
    const userFields = (0, $45xB7.buildUserFields)(userInfo);
    const orgFields = (0, $aiYBo.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $Yr1m0.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $izaUD.buildCollaborationContextFields)(collaborationContextInfo);
    return {
        eventType: (0, $gNwHK.eventType).SCREEN,
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...(0, $eNyLT.buildLocationFields)(event),
        ...$ab14799044842380$var$buildAttributes(attributes),
        ...$ab14799044842380$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...(0, $bUUEi.buildContainersWithName)(containers),
        ...(0, $6CkyC.buildEventOverrides)(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $lz8x8.buildAliases)(aliases),
        ...(0, $laq3y.buildGroups)(groups)
    };
}

});
parcelRegister("eNyLT", function(module, exports) {
$parcel$export(module.exports, "buildLocationFields", () => $0454a17e590e22a8$export$6dfd201add24e54d);
function $0454a17e590e22a8$export$6dfd201add24e54d(event) {
    const payload = typeof event === 'object' ? event : undefined;
    return {
        title: '',
        path: typeof (payload === null || payload === void 0 ? void 0 : payload.path) === 'string' ? payload.path : '',
        url: typeof (payload === null || payload === void 0 ? void 0 : payload.url) === 'string' ? payload.url : '',
        referrer: '',
        search: ''
    };
}

});


parcelRegister("bw8NJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee7ab25015d751a1$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $ee7ab25015d751a1$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $ee7ab25015d751a1$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($ee7ab25015d751a1$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("76Ily", function(module, exports) {
$parcel$export(module.exports, "default", () => $88fc78221dd2913c$export$2e2bcd8739ae039);

var $4e63B = parcelRequire("4e63B");

var $5iqil = parcelRequire("5iqil");

var $5ZXi6 = parcelRequire("5ZXi6");

var $gNwHK = parcelRequire("gNwHK");

var $50VhI = parcelRequire("50VhI");
const $88fc78221dd2913c$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $5iqil.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $88fc78221dd2913c$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $gNwHK.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $5ZXi6.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $50VhI.default)($88fc78221dd2913c$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $5iqil.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $5iqil.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $4e63B.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("4e63B", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dc6e3258e315812$export$2e2bcd8739ae039);

var $7j7Eh = parcelRequire("7j7Eh");

var $2wgiL = parcelRequire("2wgiL");

var $gdUUy = parcelRequire("gdUUy");

var $1uFqF = parcelRequire("1uFqF");

var $fC4Cz = parcelRequire("fC4Cz");
const $6dc6e3258e315812$export$b9dd752fb13352ce = 'interactionSession.source';
const $6dc6e3258e315812$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $6dc6e3258e315812$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($6dc6e3258e315812$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($6dc6e3258e315812$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $gdUUy.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $7j7Eh.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $2wgiL.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $1uFqF.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $fC4Cz.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($6dc6e3258e315812$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($6dc6e3258e315812$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("7j7Eh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $TxoUH = parcelRequire("TxoUH");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $TxoUH.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $TxoUH.isFeatureEnabled;
    }
});

});
parcelRegister("TxoUH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $2wgiL = parcelRequire("2wgiL");
var $7190A = parcelRequire("7190A");
var $3hnsi = parcelRequire("3hnsi");

var $hzYXZ = parcelRequire("hzYXZ");

var $LE5ZJ = parcelRequire("LE5ZJ");

var $jMUXC = parcelRequire("jMUXC");

var $40VYQ = parcelRequire("40VYQ");
const $0a6f0be0cb6ff7da$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $0a6f0be0cb6ff7da$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $0a6f0be0cb6ff7da$var$getBoundaryKey();
    return (0, $LE5ZJ.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $0a6f0be0cb6ff7da$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $0a6f0be0cb6ff7da$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $jMUXC.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $0a6f0be0cb6ff7da$var$getBoundaryKey();
    const aemResult = (0, $LE5ZJ.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $LE5ZJ.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($0a6f0be0cb6ff7da$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $40VYQ.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $0a6f0be0cb6ff7da$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $0a6f0be0cb6ff7da$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $0a6f0be0cb6ff7da$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $LE5ZJ.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $3hnsi.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $0a6f0be0cb6ff7da$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $40VYQ.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $LE5ZJ.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $40VYQ.isSSR)() && localStorage.getItem(`${$0a6f0be0cb6ff7da$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $0a6f0be0cb6ff7da$var$shouldEnableForAudit;
function $0a6f0be0cb6ff7da$var$getBoundaryKey() {
    if ((0, $2wgiL.isFedrampModerate)()) return $LE5ZJ.FED_MOD_KEY;
    if ((0, $7190A.isIsolatedCloud)()) return $LE5ZJ.ISOLATED_CLOUD_COMMERCIAL_KEY;
    if ((0, $hzYXZ.isGoogleCloudPlatform)()) return $LE5ZJ.GOOGLE_CLOUD_PLATFORM_KEY;
    return $LE5ZJ.COMMERCIAL_KEY;
}
function $0a6f0be0cb6ff7da$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$0a6f0be0cb6ff7da$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $0a6f0be0cb6ff7da$var$configureAuditState;
function $0a6f0be0cb6ff7da$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$0a6f0be0cb6ff7da$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $0a6f0be0cb6ff7da$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $0a6f0be0cb6ff7da$var$isFeatureEnabled,
    overrideFeature: $jMUXC.overrideFeature,
    clearFeatureOverride: $jMUXC.clearFeatureOverride,
    clearAllOverrides: $jMUXC.clearAllOverrides,
    configureAuditState: $0a6f0be0cb6ff7da$var$configureAuditState,
    clearAuditState: $0a6f0be0cb6ff7da$var$clearAuditState
};

});
parcelRegister("hzYXZ", function(module, exports) {
$parcel$export(module.exports, "isGoogleCloudPlatform", () => $355ba95438a27ca0$export$d62bd105df52518a);

var $1GOV7 = parcelRequire("1GOV7");

var $a3GZj = parcelRequire("a3GZj");
function $355ba95438a27ca0$export$d62bd105df52518a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInGCP) ?? false;
    }
    try {
        const cookies = globalThis.document.cookie;
        const cloudServiceProvider = (0, $a3GZj.getRawCookieValue)((0, $1GOV7.BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER), cookies);
        return cloudServiceProvider === (0, $1GOV7.CLOUD_SERVICE_PROVIDER_GCP);
    } catch (e) {
        return false;
    }
}

});

parcelRegister("LE5ZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $elTDl = parcelRequire("elTDl");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $elTDl.isEnvironmentBlockEnabledForBoundary;
    }
});

var $elTDl = parcelRequire("elTDl");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $elTDl.isFeatureEnabledForBoundary;
    }
});

var $elTDl = parcelRequire("elTDl");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $elTDl.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $BLeTX = parcelRequire("BLeTX");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $BLeTX.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $BLeTX.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $BLeTX.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $BLeTX.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $BLeTX.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "GOOGLE_CLOUD_PLATFORM_KEY", {
    enumerable: true,
    get: function() {
        return $BLeTX.GOOGLE_CLOUD_PLATFORM_KEY;
    }
});

});
parcelRegister("elTDl", function(module, exports) {
"use strict";
var $a72e2e8480003f22$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $a72e2e8480003f22$var$sdk_data_json_1 = $a72e2e8480003f22$var$__importDefault((parcelRequire("bWmms")));
const $a72e2e8480003f22$var$aemEnvironmentBlockData = $a72e2e8480003f22$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $a72e2e8480003f22$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($a72e2e8480003f22$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $a72e2e8480003f22$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $a72e2e8480003f22$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $a72e2e8480003f22$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $a72e2e8480003f22$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $a72e2e8480003f22$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $a72e2e8480003f22$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($a72e2e8480003f22$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $a72e2e8480003f22$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$a72e2e8480003f22$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $a72e2e8480003f22$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $a72e2e8480003f22$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $a72e2e8480003f22$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$a72e2e8480003f22$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $a72e2e8480003f22$var$getFeatureAvailabilityMetadataForBoundary;
function $a72e2e8480003f22$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $a72e2e8480003f22$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$a72e2e8480003f22$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("bWmms", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"gcp\":\"google-cloud-platform\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-findings\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-local-transcript-upload\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"assets-iris\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-service-registry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"assets-software-catalog\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards-browser-network-compatibility-check\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"home\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-lead-time-for-changes-dxe\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-space-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-deprecated-incident-timeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-sign-up\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-project-creation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-request-type-template\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sidebar-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-solution-composer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-agent-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-browser-extension-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-chat-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-send-message\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"org-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"ui-extensibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"export-control-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"c2c-middleware-assistant\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"file-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-cloud-offering-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"smartlinks-datasource-ari-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"smartlinks-support-portal-fedramp\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"streamhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"cryptor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"customer-data-plane-pc-archetypes\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"kitt-fleet-platform-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cell-routing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-governance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"tcs-control\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("BLeTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = "google-cloud-platform";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY,
    module.exports.GOOGLE_CLOUD_PLATFORM_KEY
];
var $0718199105251bd7$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($0718199105251bd7$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $0718199105251bd7$var$UnderAuditPhase = {}));

});


parcelRegister("jMUXC", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $e67eaf384ac0c786$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $e67eaf384ac0c786$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $e67eaf384ac0c786$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $e67eaf384ac0c786$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $e67eaf384ac0c786$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$e67eaf384ac0c786$var$isBrowserEnvironment()) return null;
    const map = $e67eaf384ac0c786$var$getOverridesMap();
    const key = $e67eaf384ac0c786$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $e67eaf384ac0c786$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $e67eaf384ac0c786$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$e67eaf384ac0c786$var$isBrowserEnvironment()) return;
    const map = $e67eaf384ac0c786$var$getOverridesMap();
    map[$e67eaf384ac0c786$var$buildKey(environmentBlockName, featureName)] = value;
    $e67eaf384ac0c786$var$setOverridesMap(map);
}
module.exports.overrideFeature = $e67eaf384ac0c786$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $e67eaf384ac0c786$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$e67eaf384ac0c786$var$isBrowserEnvironment()) return;
    const map = $e67eaf384ac0c786$var$getOverridesMap();
    delete map[$e67eaf384ac0c786$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $e67eaf384ac0c786$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $e67eaf384ac0c786$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $e67eaf384ac0c786$var$clearAllOverrides() {
    if (!$e67eaf384ac0c786$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $e67eaf384ac0c786$var$clearAllOverrides;

});

parcelRegister("40VYQ", function(module, exports) {

var $4eGW1 = parcelRequire("4eGW1");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $2ec4232fc6b71966$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $4eGW1 !== "undefined" && $4eGW1 && $4eGW1.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $2ec4232fc6b71966$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $2ec4232fc6b71966$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $2ec4232fc6b71966$var$getEnvironmentType;

});



parcelRegister("1uFqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $869ed07a40a25781$export$2e2bcd8739ae039);

var $eALPw = parcelRequire("eALPw");
const $869ed07a40a25781$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $869ed07a40a25781$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($869ed07a40a25781$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$869ed07a40a25781$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$869ed07a40a25781$export$7bc189309d2ad463] = new (0, $eALPw.default)();
                interactionSessionTracking = window[$869ed07a40a25781$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("eALPw", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $da5477cc18b9cff2$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $da5477cc18b9cff2$export$2e2bcd8739ae039);

var $fC4Cz = parcelRequire("fC4Cz");
const $da5477cc18b9cff2$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $da5477cc18b9cff2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $da5477cc18b9cff2$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $da5477cc18b9cff2$export$285f6bddd927a06d = 1800000; // 30 minutes
const $da5477cc18b9cff2$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $da5477cc18b9cff2$export$a92e915d70316eb2 = 5000; // 5 seconds
const $da5477cc18b9cff2$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $da5477cc18b9cff2$var$INTEGER_REGEX = /^\d+$/;
const $da5477cc18b9cff2$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $da5477cc18b9cff2$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($da5477cc18b9cff2$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($da5477cc18b9cff2$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $da5477cc18b9cff2$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $da5477cc18b9cff2$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $da5477cc18b9cff2$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $fC4Cz.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($da5477cc18b9cff2$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $da5477cc18b9cff2$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $da5477cc18b9cff2$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($da5477cc18b9cff2$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($da5477cc18b9cff2$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("fC4Cz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cd599d3b4ff2435$export$2e2bcd8739ae039);

var $95Xi9 = parcelRequire("95Xi9");

var $bLQv0 = parcelRequire("bLQv0");
class $1cd599d3b4ff2435$export$2e2bcd8739ae039 extends (0, $bLQv0.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $95Xi9.default);
        } catch (err) {
            storageToUse = (0, $95Xi9.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("95Xi9", function(module, exports) {
$parcel$export(module.exports, "default", () => $034294e5e18c8985$export$2e2bcd8739ae039);

var $lKnvj = parcelRequire("lKnvj");
// eslint-disable-next-line import/no-anonymous-default-export
const $034294e5e18c8985$var$inmemorystorage = new (0, $lKnvj.InMemoryStore)();
var $034294e5e18c8985$export$2e2bcd8739ae039 = $034294e5e18c8985$var$inmemorystorage;

});
parcelRegister("lKnvj", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $c51fe8132d33640e$export$90e3e001bcac59c7);
class $c51fe8132d33640e$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}

});


parcelRegister("bLQv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $65959f64ab2afe10$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $2ua1I = parcelRequire("2ua1I");

var $95Xi9 = parcelRequire("95Xi9");

var $cAnF9 = parcelRequire("cAnF9");
const $65959f64ab2afe10$export$41c06fdd37b7e9a5 = 'awc';
const $65959f64ab2afe10$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $65959f64ab2afe10$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $95Xi9.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ((0, $cAnF9.isSupported)(window[$65959f64ab2afe10$export$770aa8bc07b3de03])) inMemoryStorage = window[$65959f64ab2afe10$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $95Xi9.default);
                if (!window[$65959f64ab2afe10$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$65959f64ab2afe10$export$770aa8bc07b3de03] = (0, $95Xi9.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($65959f64ab2afe10$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $2ua1I.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, $cAnF9.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("2ua1I", function(module, exports) {
$parcel$export(module.exports, "envType", () => $332cae8d9ed6e861$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $332cae8d9ed6e861$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("cAnF9", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $b87c5757125c7b1c$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $b87c5757125c7b1c$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("5iqil", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $7193f0e76e457e21$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $7193f0e76e457e21$export$2e3999ec51334ffe);
const $7193f0e76e457e21$export$81d16f1428ce0486 = 'xpis';
const $7193f0e76e457e21$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($7193f0e76e457e21$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("5ZXi6", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $9fef76bb62a5203a$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $9fef76bb62a5203a$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'talent',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("50VhI", function(module, exports) {
$parcel$export(module.exports, "default", () => $261fd8bf05008f84$export$2e2bcd8739ae039);

var $fRh8v = parcelRequire("fRh8v");

var $7eusY = parcelRequire("7eusY");

var $bd0vV = parcelRequire("bd0vV");
const $261fd8bf05008f84$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $7eusY.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $fRh8v.parseUrl)(removedFragmentURL);
    const captureParams = (0, $bd0vV.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $bd0vV.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $fRh8v.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$261fd8bf05008f84$export$2e2bcd8739ae039 = $261fd8bf05008f84$var$urlParamExtractor;

});
parcelRegister("fRh8v", function(module, exports) {
$parcel$export(module.exports, "extract", () => $b8b919201f0e003c$export$f9380c9a627682d3, (v) => $b8b919201f0e003c$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $b8b919201f0e003c$export$98e6a39c04603d36, (v) => $b8b919201f0e003c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $b8b919201f0e003c$export$fac44ee5b035f737, (v) => $b8b919201f0e003c$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $b8b919201f0e003c$export$7a5253c0f62e0150, (v) => $b8b919201f0e003c$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $b8b919201f0e003c$export$a8c1621ea79325d3, (v) => $b8b919201f0e003c$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $b8b919201f0e003c$export$357523c63a2253b9, (v) => $b8b919201f0e003c$export$357523c63a2253b9 = v);
var $b8b919201f0e003c$export$f9380c9a627682d3;
var $b8b919201f0e003c$export$98e6a39c04603d36;
var $b8b919201f0e003c$export$fac44ee5b035f737;
var $b8b919201f0e003c$export$7a5253c0f62e0150;
var $b8b919201f0e003c$export$a8c1621ea79325d3;
var $b8b919201f0e003c$export$357523c63a2253b9;
var $b8b919201f0e003c$export$44c361b8ec72ef7f;
'use strict';

var $n5U80 = parcelRequire("n5U80");

var $9MaaA = parcelRequire("9MaaA");

var $1gDOl = parcelRequire("1gDOl");

var $hqMEw = parcelRequire("hqMEw");
const $b8b919201f0e003c$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $b8b919201f0e003c$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $b8b919201f0e003c$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            '[',
                            $b8b919201f0e003c$var$encode(index, options),
                            ']=',
                            $b8b919201f0e003c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            '[]=',
                            $b8b919201f0e003c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            ':list=',
                            $b8b919201f0e003c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $b8b919201f0e003c$var$encode(key, options),
                                keyValueSep,
                                $b8b919201f0e003c$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $b8b919201f0e003c$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $b8b919201f0e003c$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $b8b919201f0e003c$var$encode(key, options),
                            '=',
                            $b8b919201f0e003c$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $b8b919201f0e003c$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $b8b919201f0e003c$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $b8b919201f0e003c$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$b8b919201f0e003c$var$decode(item, options)) : value === null ? value : $b8b919201f0e003c$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $b8b919201f0e003c$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$b8b919201f0e003c$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $b8b919201f0e003c$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $b8b919201f0e003c$var$encode(value, options) {
    if (options.encode) return options.strict ? $n5U80(value) : encodeURIComponent(value);
    return value;
}
function $b8b919201f0e003c$var$decode(value, options) {
    if (options.decode) return $9MaaA(value);
    return value;
}
function $b8b919201f0e003c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $b8b919201f0e003c$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $b8b919201f0e003c$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $b8b919201f0e003c$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $b8b919201f0e003c$var$extract(input) {
    input = $b8b919201f0e003c$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $b8b919201f0e003c$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $b8b919201f0e003c$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $b8b919201f0e003c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $b8b919201f0e003c$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $1gDOl(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $b8b919201f0e003c$var$decode(value, options);
        formatter($b8b919201f0e003c$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $b8b919201f0e003c$var$parseValue(value[k], options);
        else ret[key] = $b8b919201f0e003c$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $b8b919201f0e003c$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$b8b919201f0e003c$export$f9380c9a627682d3 = $b8b919201f0e003c$var$extract;
$b8b919201f0e003c$export$98e6a39c04603d36 = $b8b919201f0e003c$var$parse;
$b8b919201f0e003c$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $b8b919201f0e003c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $b8b919201f0e003c$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $b8b919201f0e003c$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $b8b919201f0e003c$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $b8b919201f0e003c$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $b8b919201f0e003c$var$encode(key, options) + '=' + $b8b919201f0e003c$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$b8b919201f0e003c$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $1gDOl(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $b8b919201f0e003c$var$parse($b8b919201f0e003c$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $b8b919201f0e003c$var$decode(hash, options)
    } : {});
};
$b8b919201f0e003c$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$b8b919201f0e003c$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $b8b919201f0e003c$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $b8b919201f0e003c$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $b8b919201f0e003c$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $b8b919201f0e003c$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $b8b919201f0e003c$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$b8b919201f0e003c$var$encodeFragmentIdentifier] ? $b8b919201f0e003c$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$b8b919201f0e003c$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$b8b919201f0e003c$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $b8b919201f0e003c$export$7a5253c0f62e0150(input, options);
    return $b8b919201f0e003c$export$a8c1621ea79325d3({
        url: url,
        query: $hqMEw(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$b8b919201f0e003c$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $b8b919201f0e003c$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("n5U80", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("9MaaA", function(module, exports) {
'use strict';
var $71e07c44143acd3e$var$token = '%[a-f0-9]{2}';
var $71e07c44143acd3e$var$singleMatcher = new RegExp('(' + $71e07c44143acd3e$var$token + ')|([^%]+?)', 'gi');
var $71e07c44143acd3e$var$multiMatcher = new RegExp('(' + $71e07c44143acd3e$var$token + ')+', 'gi');
function $71e07c44143acd3e$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $71e07c44143acd3e$var$decodeComponents(left), $71e07c44143acd3e$var$decodeComponents(right));
}
function $71e07c44143acd3e$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($71e07c44143acd3e$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $71e07c44143acd3e$var$decodeComponents(tokens, i).join('');
            tokens = input.match($71e07c44143acd3e$var$singleMatcher) || [];
        }
        return input;
    }
}
function $71e07c44143acd3e$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $71e07c44143acd3e$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $71e07c44143acd3e$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $71e07c44143acd3e$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $71e07c44143acd3e$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("1gDOl", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("hqMEw", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("7eusY", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $7670738d22044044$export$600dd5bf1b049f11);
const $7670738d22044044$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("bd0vV", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $71f87b037822fa8b$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $71f87b037822fa8b$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $71f87b037822fa8b$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $71f87b037822fa8b$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $71f87b037822fa8b$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $71f87b037822fa8b$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $71f87b037822fa8b$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $71f87b037822fa8b$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $71f87b037822fa8b$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $71f87b037822fa8b$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $71f87b037822fa8b$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $71f87b037822fa8b$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $71f87b037822fa8b$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$71f87b037822fa8b$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $71f87b037822fa8b$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("jx7m9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f49d3747910b9f2$export$2e2bcd8739ae039);

var $2RtmS = parcelRequire("2RtmS");

var $e4GAn = parcelRequire("e4GAn");

var $9s9o1 = parcelRequire("9s9o1");
class $5f49d3747910b9f2$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $2RtmS.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $2RtmS.MAX_DELAY_TIMEOUT)) : (0, $2RtmS.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $9s9o1.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $9s9o1.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $e4GAn.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("2RtmS", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $29988281006fa34e$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $29988281006fa34e$export$8575e30be0feb909);
const $29988281006fa34e$export$cf090d5281b5ae06 = 10000;
const $29988281006fa34e$export$8575e30be0feb909 = 30000;

});

parcelRegister("e4GAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a23219487807473d$export$2e2bcd8739ae039);

var $3UwYd = parcelRequire("3UwYd");

var $bd0vV = parcelRequire("bd0vV");

var $643dg = parcelRequire("643dg");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $a23219487807473d$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $a23219487807473d$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $a23219487807473d$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $a23219487807473d$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $a23219487807473d$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $bd0vV.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $bd0vV.equals)(group.userInfo, args.userInfo) && (0, $bd0vV.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $3UwYd.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $643dg.default)(compressionRules);
    }
}

});
parcelRegister("643dg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ac416896a4eea24$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $dWrhK = parcelRequire("dWrhK");

var $bd0vV = parcelRequire("bd0vV");

var $aENR6 = parcelRequire("aENR6");
class $9ac416896a4eea24$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $dWrhK.buildActionFields)(event, event.eventType);
                    contextFields = (0, $bd0vV.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $bd0vV.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $aENR6.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("aENR6", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $5c721e38add98afd$export$89b3253ddfd2e6e8);

var $fZOMv = parcelRequire("fZOMv");

var $bd0vV = parcelRequire("bd0vV");

var $5MEoI = parcelRequire("5MEoI");

var $cHGgo = parcelRequire("cHGgo");
class $5c721e38add98afd$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ this.canCompress = (event)=>{
            try {
                return event && (0, $fZOMv.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $bd0vV.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $cHGgo.validateActionEventType)(event.eventType);
                (0, $5MEoI.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("fZOMv", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $fd2769e27245d258$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gNwHK = parcelRequire("gNwHK");
function $fd2769e27245d258$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $gNwHK.eventType).OPERATIONAL:
        case (0, $gNwHK.eventType).TRACK:
        case (0, $gNwHK.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("5MEoI", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $53557949af6e839d$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8mUkO = parcelRequire("8mUkO");
function $53557949af6e839d$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $8mUkO.validateContainers)(event.containers);
}

});
parcelRegister("8mUkO", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $923ac4c53e2a093a$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $jRuQB = parcelRequire("jRuQB");
function $923ac4c53e2a093a$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $jRuQB.validateContainersObject)(container));
}

});
parcelRegister("jRuQB", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $69c9da9865c89fe3$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $bWIzZ = parcelRequire("bWIzZ");
function $69c9da9865c89fe3$export$df8ff30e3c960006(container) {
    if (!(0, $bWIzZ.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("cHGgo", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $c7925bdaa3fdb349$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gNwHK = parcelRequire("gNwHK");

var $fZOMv = parcelRequire("fZOMv");
const $c7925bdaa3fdb349$var$actionEventTypes = Object.freeze([
    (0, $gNwHK.eventType).OPERATIONAL,
    (0, $gNwHK.eventType).TRACK,
    (0, $gNwHK.eventType).UI
]);
function $c7925bdaa3fdb349$export$4a8d7476662aebcc(type) {
    if (!(0, $fZOMv.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$c7925bdaa3fdb349$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("9s9o1", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $eb904255d1654d3b$export$fa6e3729c21cb8f);
var $eb904255d1654d3b$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("23EuR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec0dcecbfef4b58b$export$2e2bcd8739ae039);

var $lLvX1 = parcelRequire("lLvX1");

var $bQq48 = parcelRequire("bQq48");

var $8XLye = parcelRequire("8XLye");

var $8Qczz = parcelRequire("8Qczz");

var $h8VVs = parcelRequire("h8VVs");

var $7r5fN = parcelRequire("7r5fN");

var $5Lk2z = parcelRequire("5Lk2z");

var $2oIss = parcelRequire("2oIss");

var $b6935 = parcelRequire("b6935");

var $8I18e = parcelRequire("8I18e");

var $3Nbsr = parcelRequire("3Nbsr");

var $9wYlJ = parcelRequire("9wYlJ");

var $7vohr = parcelRequire("7vohr");

var $cqBIF = parcelRequire("cqBIF");

var $lMKzV = parcelRequire("lMKzV");

var $9tvdQ = parcelRequire("9tvdQ");
class $ec0dcecbfef4b58b$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $ec0dcecbfef4b58b$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $ec0dcecbfef4b58b$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $ec0dcecbfef4b58b$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                var _this$originTracingCl;
                const response = await (0, $cqBIF.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this$originTracingCl = this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $b6935.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $3Nbsr.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $lMKzV.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $3Nbsr.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        var _this$options;
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $5Lk2z.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $9tvdQ.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $bQq48.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $lLvX1.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $lMKzV.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $lMKzV.SegmentEventTypes).TRACK,
            properties: (0, $7vohr.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $lMKzV.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $lMKzV.SegmentEventTypes).PAGE,
            properties: (0, $7vohr.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $lMKzV.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $lMKzV.SegmentEventTypes).IDENTIFY,
            traits: (0, $7vohr.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $9wYlJ.prepareEventContext)(context);
        const segmentContext = (0, $7r5fN.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $8XLye.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $ec0dcecbfef4b58b$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $ec0dcecbfef4b58b$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $ec0dcecbfef4b58b$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $8Qczz.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $ec0dcecbfef4b58b$var$BatchInterceptor {
    static #_ = this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $2oIss.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $h8VVs.AnalyticsResponse)(success, statusCode, (0, $8I18e.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $8I18e.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $8I18e.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $8I18e.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $2oIss.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $h8VVs.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($ec0dcecbfef4b58b$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $2oIss.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $h8VVs.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $2oIss.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $h8VVs.AnalyticsResponse)(false, -1, (0, $8I18e.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("lLvX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $47065aeff5fc84de$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $jjQOa = parcelRequire("jjQOa");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$47065aeff5fc84de$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $jjQOa.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("jjQOa", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $52f1f9d88831aa98$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $52f1f9d88831aa98$export$2e2bcd8739ae039);

var $HLGc8 = parcelRequire("HLGc8");

var $7EWBq = parcelRequire("7EWBq");

var $dpvxY = parcelRequire("dpvxY");

var $7WwCY = parcelRequire("7WwCY");

var $lp5Vt = parcelRequire("lp5Vt");

var $bQq48 = parcelRequire("bQq48");

var $5LChb = parcelRequire("5LChb");

var $7Amhq = parcelRequire("7Amhq");

var $hJeXm = parcelRequire("hJeXm");

var $kV782 = parcelRequire("kV782");
const $52f1f9d88831aa98$var$ONE_MINUTE = 60000;
const $52f1f9d88831aa98$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $52f1f9d88831aa98$var$ONE_MINUTE,
    minRetryDelay: $52f1f9d88831aa98$var$ONE_MINUTE,
    maxRetryDelay: $52f1f9d88831aa98$var$ONE_MINUTE
};
const $52f1f9d88831aa98$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $52f1f9d88831aa98$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $dpvxY.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $52f1f9d88831aa98$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $7Amhq.default)({
            ...this.options,
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $7Amhq.default)({
            ...$52f1f9d88831aa98$var$LONG_POLLING_OPTIONS,
            waitInterval: $52f1f9d88831aa98$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $bQq48.default)();
        this.networkStatus = new (0, $5LChb.default)((status)=>{
            if (status === (0, $kV782.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $7WwCY.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $kV782.NetworkStatusEnum).OFFLINE) {
            done((0, $hJeXm.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $lp5Vt.CallbackProcessingErrorName)) {
                done((0, $hJeXm.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $HLGc8.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $7EWBq.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $7WwCY.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $hJeXm.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $hJeXm.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $hJeXm.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $52f1f9d88831aa98$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $52f1f9d88831aa98$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $52f1f9d88831aa98$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $52f1f9d88831aa98$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $52f1f9d88831aa98$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $52f1f9d88831aa98$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $52f1f9d88831aa98$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $52f1f9d88831aa98$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $52f1f9d88831aa98$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("HLGc8", function(module, exports) {
$parcel$export(module.exports, "default", () => $540fef3652bd40db$export$2e2bcd8739ae039);

var $2NKHr = parcelRequire("2NKHr");

var $ev8v6 = parcelRequire("ev8v6");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $540fef3652bd40db$var$validSuffixs = Object.values((0, $2NKHr.LocalStorageKeySuffix));
var $540fef3652bd40db$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $540fef3652bd40db$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $2NKHr.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $ev8v6.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("2NKHr", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $f442a75e32551dcb$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $f442a75e32551dcb$export$8bb2c1fb2b1765a9);
var $f442a75e32551dcb$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $f442a75e32551dcb$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("ev8v6", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $e08961255f56f69d$export$8433d54f767cbec5);

var $2NKHr = parcelRequire("2NKHr");
const $e08961255f56f69d$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $2NKHr.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $2NKHr.LocalStorageKeySuffix).ACK}`,
        [(0, $2NKHr.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $2NKHr.LocalStorageKeySuffix).QUEUE}`,
        [(0, $2NKHr.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $2NKHr.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $2NKHr.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $2NKHr.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $2NKHr.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $2NKHr.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("7EWBq", function(module, exports) {
$parcel$export(module.exports, "default", () => $09c7ec2c2d8f13f2$export$2e2bcd8739ae039);

var $8XLye = parcelRequire("8XLye");

var $2NKHr = parcelRequire("2NKHr");

var $ev8v6 = parcelRequire("ev8v6");
const $09c7ec2c2d8f13f2$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $09c7ec2c2d8f13f2$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2NKHr.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2NKHr.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $09c7ec2c2d8f13f2$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $09c7ec2c2d8f13f2$var$promisedSetTimeout((0, $2NKHr.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2NKHr.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $09c7ec2c2d8f13f2$var$promisedSetTimeout((0, $2NKHr.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2NKHr.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $09c7ec2c2d8f13f2$var$reclaim(options, callback);
};
const $09c7ec2c2d8f13f2$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $09c7ec2c2d8f13f2$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $09c7ec2c2d8f13f2$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $09c7ec2c2d8f13f2$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $09c7ec2c2d8f13f2$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $8XLye.default)();
    const queuesToReclaim = $09c7ec2c2d8f13f2$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$09c7ec2c2d8f13f2$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $ev8v6.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("8XLye", function(module, exports) {
$parcel$export(module.exports, "default", () => $a22fa130f04f485e$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $a22fa130f04f485e$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("dpvxY", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f045325a5ed02de$export$2e2bcd8739ae039);

var $llHme = parcelRequire("llHme");
var $5f045325a5ed02de$export$2e2bcd8739ae039 = (0, $llHme.default);

});
parcelRegister("llHme", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e0ddbc844dccb9c$export$2e2bcd8739ae039);

var $7WwCY = parcelRequire("7WwCY");

var $1KJkn = parcelRequire("1KJkn");

var $duOvT = parcelRequire("duOvT");

var $77TlS = parcelRequire("77TlS");

var $csuXz = parcelRequire("csuXz");

var $NnDqB = parcelRequire("NnDqB");
class $3e0ddbc844dccb9c$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $1KJkn.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $csuXz.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $duOvT.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $NnDqB.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $7WwCY.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $7WwCY.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $77TlS.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $7WwCY.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $NnDqB.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $7WwCY.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("7WwCY", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $92cae29503c4895b$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $92cae29503c4895b$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $92cae29503c4895b$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $92cae29503c4895b$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $92cae29503c4895b$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $92cae29503c4895b$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $92cae29503c4895b$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $92cae29503c4895b$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $92cae29503c4895b$export$7710d69e6f450f20);
const $92cae29503c4895b$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $92cae29503c4895b$export$8cad224051643259 = 'analytics-web-client';
const $92cae29503c4895b$export$3d8420be07b276ab = 'analytics-resilience';
const $92cae29503c4895b$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $92cae29503c4895b$export$89d9c1ff8ac91862 = 'timeAdded';
const $92cae29503c4895b$export$a37d385bcd713809 = 'retryAttempts';
const $92cae29503c4895b$export$6d8635fed0e4b14d = 15000;
var $92cae29503c4895b$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $92cae29503c4895b$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("1KJkn", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $3635b9868f5d89a6$export$ddc6718318090f71);

var $eXBOk = parcelRequire("eXBOk");
const $3635b9868f5d89a6$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $eXBOk.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $eXBOk.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("eXBOk", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $1db16e20fc13e79a$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $1db16e20fc13e79a$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $1db16e20fc13e79a$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $1db16e20fc13e79a$export$1188664dfff364c8);
const $1db16e20fc13e79a$export$b6df3d334cec060f = 7;
const $1db16e20fc13e79a$export$14ef152a03a4b6ee = 60000;
const $1db16e20fc13e79a$export$da9ab7b2fd5998e8 = 10;
const $1db16e20fc13e79a$export$1188664dfff364c8 = 8000;

});


parcelRegister("duOvT", function(module, exports) {
$parcel$export(module.exports, "default", () => $84990a9788faf8aa$export$2e2bcd8739ae039);
const $84990a9788faf8aa$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $84990a9788faf8aa$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $84990a9788faf8aa$export$2e2bcd8739ae039.prototype);
        this.name = $84990a9788faf8aa$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("77TlS", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $b439fecbf2ec9dec$export$74101021e0969375);

var $8zkyr = parcelRequire("8zkyr");

var $lp5Vt = parcelRequire("lp5Vt");

var $iCobW = parcelRequire("iCobW");
const $b439fecbf2ec9dec$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $8zkyr.AbandonWriteErrorName) || errorWithName.name === (0, $lp5Vt.CallbackProcessingErrorName) || errorWithName.name === (0, $iCobW.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("8zkyr", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $ac3ffff6fe8eb5a5$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $ac3ffff6fe8eb5a5$export$2e2bcd8739ae039);
const $ac3ffff6fe8eb5a5$export$ba95206613c96b28 = 'AbandonWriteError';
class $ac3ffff6fe8eb5a5$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ac3ffff6fe8eb5a5$export$2e2bcd8739ae039.prototype);
        this.name = $ac3ffff6fe8eb5a5$export$ba95206613c96b28;
    }
}

});

parcelRegister("lp5Vt", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $ca43470547e20b75$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $ca43470547e20b75$export$2e2bcd8739ae039);
const $ca43470547e20b75$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $ca43470547e20b75$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ca43470547e20b75$export$2e2bcd8739ae039.prototype);
        this.name = $ca43470547e20b75$export$a409c8de90e11e14;
    }
}

});

parcelRegister("iCobW", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $41c3740b5371da32$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $41c3740b5371da32$export$2e2bcd8739ae039);
const $41c3740b5371da32$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $41c3740b5371da32$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $41c3740b5371da32$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("csuXz", function(module, exports) {
$parcel$export(module.exports, "default", () => $18e035b65ee6e940$export$2e2bcd8739ae039);

var $9pnjU = parcelRequire("9pnjU");

var $7WwCY = parcelRequire("7WwCY");

var $8LnsI = parcelRequire("8LnsI");

var $1KJkn = parcelRequire("1KJkn");

var $eXBOk = parcelRequire("eXBOk");

var $lp5Vt = parcelRequire("lp5Vt");

var $iCobW = parcelRequire("iCobW");

var $duOvT = parcelRequire("duOvT");

var $77TlS = parcelRequire("77TlS");

var $7Iyc8 = parcelRequire("7Iyc8");

var $lK59n = parcelRequire("lK59n");

var $75lHu = parcelRequire("75lHu");
class $18e035b65ee6e940$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $duOvT.default)());
                    }, (0, $7WwCY.INDEXEDDB_TIMEOUT));
                    /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $7WwCY.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $7WwCY.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $7WwCY.TIME_TO_PROCESS_AFTER_INDEX), (0, $7WwCY.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $7WwCY.RETRY_INDEX), (0, $7WwCY.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $7WwCY.TIME_ADDED_INDEX), (0, $7WwCY.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $7WwCY.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $duOvT.default)());
                    };
                    try {
                        await (0, $75lHu.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $duOvT.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $duOvT.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $7WwCY.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $8LnsI.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $7WwCY.GuardPolicy).IGNORE) throw new (0, $iCobW.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $77TlS.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $7WwCY.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $8LnsI.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $77TlS.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $eXBOk.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $eXBOk.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $7WwCY.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $eXBOk.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $lK59n.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $lK59n.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $9pnjU.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $9pnjU.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $7WwCY.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $75lHu.requestToPromise)(request);
            await (0, $9pnjU.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $eXBOk.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $lp5Vt.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $75lHu.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $7WwCY.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $7WwCY.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $1KJkn.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $duOvT.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $7Iyc8.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $7WwCY.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("9pnjU", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $e1f7e4f11ca48718$export$feab8418f018df89);

var $OakOV = parcelRequire("OakOV");
const $e1f7e4f11ca48718$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $OakOV.transactionToPromise)(transaction);
};

});
parcelRegister("OakOV", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $9f62219e684f7d89$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $9f62219e684f7d89$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("8LnsI", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $fe0579794c8a1a76$export$aec476f33d77be11);

var $8XLye = parcelRequire("8XLye");
const $fe0579794c8a1a76$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $8XLye.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("7Iyc8", function(module, exports) {
$parcel$export(module.exports, "default", () => $88ac936054448679$export$2e2bcd8739ae039);

var $9pnjU = parcelRequire("9pnjU");

var $7WwCY = parcelRequire("7WwCY");

var $8zkyr = parcelRequire("8zkyr");

var $75lHu = parcelRequire("75lHu");
class $88ac936054448679$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ this.deleteOldestNEvents = async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $7WwCY.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $75lHu.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $7WwCY.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $7WwCY.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $7WwCY.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $7WwCY.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $75lHu.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $9pnjU.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $8zkyr.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $7WwCY.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $75lHu.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("75lHu", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $eedfce4415f2e5df$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $eedfce4415f2e5df$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("lK59n", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $068d1dd3427ed480$export$342d941b6f724995);
const $068d1dd3427ed480$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("NnDqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb2400d130484472$export$2e2bcd8739ae039);

var $7WwCY = parcelRequire("7WwCY");

var $8LnsI = parcelRequire("8LnsI");

var $1KJkn = parcelRequire("1KJkn");

var $eXBOk = parcelRequire("eXBOk");

var $lp5Vt = parcelRequire("lp5Vt");

var $iCobW = parcelRequire("iCobW");

var $39wdX = parcelRequire("39wdX");
class $eb2400d130484472$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $1KJkn.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $39wdX.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $7WwCY.GuardPolicy).ABANDON) {
        if (policy === (0, $7WwCY.GuardPolicy).IGNORE) throw new (0, $iCobW.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $8LnsI.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $7WwCY.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $8LnsI.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $7WwCY.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $eXBOk.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $eXBOk.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $eXBOk.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $eXBOk.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $lp5Vt.default)(error);
        }
    }
    storeType() {
        return (0, $7WwCY.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("39wdX", function(module, exports) {
$parcel$export(module.exports, "default", () => $18ca5bb7d0ddcc10$export$2e2bcd8739ae039);

var $7WwCY = parcelRequire("7WwCY");

var $8zkyr = parcelRequire("8zkyr");
class $18ca5bb7d0ddcc10$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $7WwCY.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $7WwCY.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $7WwCY.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $8zkyr.default)((0, $7WwCY.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("bQq48", function(module, exports) {
$parcel$export(module.exports, "default", () => $23d77a304126fa88$export$2e2bcd8739ae039);

var $hFrYW = parcelRequire("hFrYW");
let $23d77a304126fa88$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$23d77a304126fa88$export$2e2bcd8739ae039 = ()=>{
    if (!$23d77a304126fa88$var$cachedMetricsClient) $23d77a304126fa88$var$cachedMetricsClient = new (0, $hFrYW.MetricsCollector)();
    return $23d77a304126fa88$var$cachedMetricsClient;
};

});
parcelRegister("hFrYW", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $c77e681e1b214fec$export$4b62ee5120ab50a8);

var $kV782 = parcelRequire("kV782");
class $c77e681e1b214fec$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $kV782.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}

});
parcelRegister("kV782", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $e66c921ca766835f$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $e66c921ca766835f$export$ee138fa712d11b84);
var $e66c921ca766835f$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $e66c921ca766835f$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("5LChb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0d75822bca01c20$export$2e2bcd8739ae039);

var $kV782 = parcelRequire("kV782");
class $b0d75822bca01c20$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $kV782.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $kV782.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $kV782.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $kV782.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $kV782.NetworkStatusEnum).ONLINE;
        return (0, $kV782.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("7Amhq", function(module, exports) {
$parcel$export(module.exports, "default", () => $29d33745f4d81e91$export$2e2bcd8739ae039);

var $1QkZX = parcelRequire("1QkZX");

var $hJeXm = parcelRequire("hJeXm");
const $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $29d33745f4d81e91$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $29d33745f4d81e91$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $hJeXm.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $hJeXm.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $1QkZX.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $hJeXm.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $29d33745f4d81e91$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $1QkZX.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("1QkZX", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $135c6bee1d807150$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $135c6bee1d807150$export$590a718599f8f8b3);
var $135c6bee1d807150$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $135c6bee1d807150$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $135c6bee1d807150$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("hJeXm", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $839449d3928673b7$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $839449d3928673b7$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("8Qczz", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $e6bbfab72f295378$export$c21270cab66ab290);

var $cC9UC = parcelRequire("cC9UC");
async function $e6bbfab72f295378$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $cC9UC.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("cC9UC", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $26544a4d0765a7a7$export$c9c3aaf655d6f275);

var $lMKzV = parcelRequire("lMKzV");
function $26544a4d0765a7a7$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $lMKzV.SegmentEventTypes).PAGE || item.msg.type === (0, $lMKzV.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $lMKzV.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}

});
parcelRegister("lMKzV", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $1d09628a987ba937$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $1d09628a987ba937$export$96f086dcf574a9e2);
var $1d09628a987ba937$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $1d09628a987ba937$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $1d09628a987ba937$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $1d09628a987ba937$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("h8VVs", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $228fdeb42fe6626b$export$133650fcdde1b226);
class $228fdeb42fe6626b$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("7r5fN", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $2d671997587f69eb$export$3a7fe28f9bf4f3d9);

var $iDxNg = parcelRequire("iDxNg");
// Shallow removal of all falsey properties from an object, returning a new object.
const $2d671997587f69eb$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $2d671997587f69eb$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...(0, $iDxNg.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = {
        ...result.userConsents,
        ...(0, $iDxNg.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $2d671997587f69eb$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("iDxNg", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $a9ca24d87018fd25$export$2250ccecd1e040fd);
// This function will essentially deepClone as well
const $a9ca24d87018fd25$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("5Lk2z", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $4f91d59fd95be976$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $4f91d59fd95be976$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $4f91d59fd95be976$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $4f91d59fd95be976$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $4f91d59fd95be976$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $4f91d59fd95be976$export$6f1c008dd0c3b67e);
const $4f91d59fd95be976$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $4f91d59fd95be976$export$8fddcd1eff390364 = 60000; // 60 seconds
const $4f91d59fd95be976$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $4f91d59fd95be976$export$6649d5c857717efe = 5000; // 5 seconds
const $4f91d59fd95be976$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $4f91d59fd95be976$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("2oIss", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $29f3c76cb605952a$export$51e0b986fdbf3840);
class $29f3c76cb605952a$export$51e0b986fdbf3840 {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("b6935", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $fa037a49b9330b67$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $fa037a49b9330b67$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("8I18e", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $21a9ef3732a69eaa$export$ba118f9de1e5ac63);
const $21a9ef3732a69eaa$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("3Nbsr", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $f13bc298d54c5e7f$export$a63e16b3351b8c36);

var $b6935 = parcelRequire("b6935");
class $f13bc298d54c5e7f$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $b6935.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("9wYlJ", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $ac00e826fb43c5fa$export$6b26e26d40264200);
// @ts-ignore

var $4cJQo = parcelRequire("4cJQo");

var $iDxNg = parcelRequire("iDxNg");
const $ac00e826fb43c5fa$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $iDxNg.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($4cJQo)))(propertiesWithoutUndefined);
};

});
parcelRegister("4cJQo", function(module, exports) {
'use strict';

var $6uXX7 = parcelRequire("6uXX7");
/**
 * Expose `traverse`.
 */ module.exports = $30fbd81592bf2e2f$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $30fbd81592bf2e2f$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $30fbd81592bf2e2f$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $30fbd81592bf2e2f$var$traverseArray(input, strict);
    else if ($6uXX7.is(input, strict)) return $6uXX7.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $30fbd81592bf2e2f$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $30fbd81592bf2e2f$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $30fbd81592bf2e2f$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $30fbd81592bf2e2f$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("6uXX7", function(module, exports) {
$parcel$export(module.exports, "parse", () => $4bb40cb98275d628$export$98e6a39c04603d36, (v) => $4bb40cb98275d628$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $4bb40cb98275d628$export$226b3eccf92c9ed9, (v) => $4bb40cb98275d628$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $4bb40cb98275d628$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $4bb40cb98275d628$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $4bb40cb98275d628$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$4bb40cb98275d628$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $4bb40cb98275d628$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$4bb40cb98275d628$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $4bb40cb98275d628$var$matcher.test(string);
};

});



parcelRegister("7vohr", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $06215f25c5daec78$export$44d22e5fb02cc68e);
// @ts-ignore

var $4cJQo = parcelRequire("4cJQo");

var $iDxNg = parcelRequire("iDxNg");
const $06215f25c5daec78$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $iDxNg.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4cJQo)))(propertiesWithoutUndefined);
};

});

parcelRegister("cqBIF", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $1f59e18a1be43d74$export$8e8f0180c1b41fad);

var $57l7A = parcelRequire("57l7A");

var $b6935 = parcelRequire("b6935");
const $1f59e18a1be43d74$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $1f59e18a1be43d74$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $1f59e18a1be43d74$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $b6935.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $b6935.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $1f59e18a1be43d74$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $1f59e18a1be43d74$var$getCorsForUrl = (0, $57l7A.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("57l7A", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b9dfd771d20b2d0$export$2e2bcd8739ae039);
var $3b9dfd771d20b2d0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $3b9dfd771d20b2d0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($3b9dfd771d20b2d0$var$safeIsNaN(first) && $3b9dfd771d20b2d0$var$safeIsNaN(second)) return true;
    return false;
}
function $3b9dfd771d20b2d0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$3b9dfd771d20b2d0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $3b9dfd771d20b2d0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $3b9dfd771d20b2d0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("9tvdQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22a6708a3419430$export$2e2bcd8739ae039);

var $felpn = parcelRequire("felpn");

var $kdkod = parcelRequire("kdkod");

var $gk8yl = parcelRequire("gk8yl");

var $7gTLI = parcelRequire("7gTLI");

var $8XLye = parcelRequire("8XLye");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $f22a6708a3419430$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $f22a6708a3419430$var$SAFE = 'SAFE';
const $f22a6708a3419430$var$UNSAFE = 'UNSAFE';
const $f22a6708a3419430$var$NOT_FOUND = 'NOT_FOUND';
const $f22a6708a3419430$var$COOKIE = 'COOKIE';
const $f22a6708a3419430$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $f22a6708a3419430$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $7gTLI.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $gk8yl.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $kdkod.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $kdkod.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $f22a6708a3419430$var$LOCAL_STORAGE ? this.store.getItem((0, $kdkod.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $kdkod.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $f22a6708a3419430$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $f22a6708a3419430$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $f22a6708a3419430$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($f22a6708a3419430$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $felpn.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $f22a6708a3419430$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $f22a6708a3419430$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $f22a6708a3419430$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $f22a6708a3419430$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($f22a6708a3419430$var$COOKIE);
        switch(cookieValue.type){
            case $f22a6708a3419430$var$SAFE:
            case $f22a6708a3419430$var$UNSAFE:
                this.store.setItem((0, $kdkod.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $f22a6708a3419430$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $8XLye.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("felpn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b168c51450f394e9$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $bAER0 = parcelRequire("bAER0");

var $OPOsJ = parcelRequire("OPOsJ");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $b168c51450f394e9$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $b168c51450f394e9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $OPOsJ.default)(2, arguments);
    var dateLeft = (0, $897M5.default)(dirtyDateLeft);
    var dateRight = (0, $897M5.default)(dirtyDateRight);
    var sign = $b168c51450f394e9$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $bAER0.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($b168c51450f394e9$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("897M5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ee531e2d1d9e65f$export$2e2bcd8739ae039);

var $2JMbT = parcelRequire("2JMbT");

var $OPOsJ = parcelRequire("OPOsJ");
function $5ee531e2d1d9e65f$export$2e2bcd8739ae039(argument) {
    (0, $OPOsJ.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $2JMbT.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("2JMbT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe52a6e06417f16$export$2e2bcd8739ae039);
function $1fe52a6e06417f16$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1fe52a6e06417f16$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1fe52a6e06417f16$export$2e2bcd8739ae039(o);
}

});

parcelRegister("OPOsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $098cdc974ab8ffbd$export$2e2bcd8739ae039);
function $098cdc974ab8ffbd$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("bAER0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8702bf3a72f7ab72$export$2e2bcd8739ae039);

var $6nu0h = parcelRequire("6nu0h");

var $4R2QU = parcelRequire("4R2QU");

var $OPOsJ = parcelRequire("OPOsJ");
var $8702bf3a72f7ab72$var$MILLISECONDS_IN_DAY = 86400000;
function $8702bf3a72f7ab72$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $OPOsJ.default)(2, arguments);
    var startOfDayLeft = (0, $4R2QU.default)(dirtyDateLeft);
    var startOfDayRight = (0, $4R2QU.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $6nu0h.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $6nu0h.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $8702bf3a72f7ab72$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("6nu0h", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a4c2a1b82175aba$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $4a4c2a1b82175aba$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("4R2QU", function(module, exports) {
$parcel$export(module.exports, "default", () => $388e53151218ab73$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $388e53151218ab73$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("kdkod", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $2c0288b1727a3bd9$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $2c0288b1727a3bd9$export$d4cb17942ea57c95);
var $2c0288b1727a3bd9$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $2c0288b1727a3bd9$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $2c0288b1727a3bd9$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $2c0288b1727a3bd9$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $2c0288b1727a3bd9$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $2c0288b1727a3bd9$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $2c0288b1727a3bd9$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $2c0288b1727a3bd9$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $2c0288b1727a3bd9$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $2c0288b1727a3bd9$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("gk8yl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7ca4d2a850e5a24$export$2e2bcd8739ae039);

var $cG0CM = parcelRequire("cG0CM");

var $kdkod = parcelRequire("kdkod");

var $i6HTn = parcelRequire("i6HTn");

var $8BBxV = parcelRequire("8BBxV");
class $d7ca4d2a850e5a24$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $8BBxV.canUseCookie)(disableCookiePersistence) ? (0, $cG0CM.default) : new (0, $i6HTn.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $kdkod.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $kdkod.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $kdkod.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $8BBxV.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $kdkod.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $kdkod.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $kdkod.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $kdkod.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("cG0CM", function(module, exports) {
$parcel$export(module.exports, "default", () => $93a9e44bf03f8035$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $93a9e44bf03f8035$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $93a9e44bf03f8035$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $93a9e44bf03f8035$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $93a9e44bf03f8035$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $93a9e44bf03f8035$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $93a9e44bf03f8035$var$init(this.converter, $93a9e44bf03f8035$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $93a9e44bf03f8035$var$init($93a9e44bf03f8035$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $93a9e44bf03f8035$export$2e2bcd8739ae039 = $93a9e44bf03f8035$var$init($93a9e44bf03f8035$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("i6HTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $995011cfca035ee4$export$2e2bcd8739ae039);

var $7gTLI = parcelRequire("7gTLI");
class $995011cfca035ee4$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $7gTLI.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("7gTLI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8ee90943c52d078$export$2e2bcd8739ae039);

var $d9m0t = parcelRequire("d9m0t");

var $ipQQj = parcelRequire("ipQQj");
class $d8ee90943c52d078$export$2e2bcd8739ae039 extends (0, $ipQQj.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $d9m0t.default);
        } catch (err) {
            storageToUse = (0, $d9m0t.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("d9m0t", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e57099cbee188a0$export$2e2bcd8739ae039);

var $55faM = parcelRequire("55faM");
// eslint-disable-next-line import/no-anonymous-default-export
const $1e57099cbee188a0$var$inmemorystorage = new (0, $55faM.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1e57099cbee188a0$export$2e2bcd8739ae039 = $1e57099cbee188a0$var$inmemorystorage;

});
parcelRegister("55faM", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $2413e4c2d9cc5a53$export$90e3e001bcac59c7);
class $2413e4c2d9cc5a53$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}

});


parcelRegister("ipQQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d67980983f5c26a$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $gNwHK = parcelRequire("gNwHK");

var $d9m0t = parcelRequire("d9m0t");

var $eZUit = parcelRequire("eZUit");
const $1d67980983f5c26a$export$41c06fdd37b7e9a5 = 'awc';
const $1d67980983f5c26a$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $1d67980983f5c26a$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $d9m0t.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $eZUit.isSupported)(globalThis[$1d67980983f5c26a$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$1d67980983f5c26a$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $d9m0t.default);
                if (!globalThis[$1d67980983f5c26a$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$1d67980983f5c26a$export$770aa8bc07b3de03] = (0, $d9m0t.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($1d67980983f5c26a$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $gNwHK.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $eZUit.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("eZUit", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $18bcae1b9ad9353c$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $18bcae1b9ad9353c$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("8BBxV", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $1fd238ebb4226355$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $1fd238ebb4226355$export$de6821eed3d5f32d);

var $cG0CM = parcelRequire("cG0CM");

var $57l7A = parcelRequire("57l7A");

var $kdkod = parcelRequire("kdkod");
const $1fd238ebb4226355$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $1fd238ebb4226355$export$eb80e1beaa8dacf8 = (0, $kdkod.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $1fd238ebb4226355$export$19164982d36535d8 = 'tld_test';
const $1fd238ebb4226355$export$de6821eed3d5f32d = (0, $57l7A.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $cG0CM.default).set($1fd238ebb4226355$export$eb80e1beaa8dacf8, $1fd238ebb4226355$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $cG0CM.default).get($1fd238ebb4226355$export$eb80e1beaa8dacf8) === $1fd238ebb4226355$export$19164982d36535d8) {
            (0, $cG0CM.default).remove($1fd238ebb4226355$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("j3SXL", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $1f2ffe39f5a5c48d$export$1ac223ae496131c9);

var $fehQc = parcelRequire("fehQc");

var $5LChb = parcelRequire("5LChb");

var $jjQOa = parcelRequire("jjQOa");

var $7Amhq = parcelRequire("7Amhq");

var $hJeXm = parcelRequire("hJeXm");

var $kV782 = parcelRequire("kV782");

var $gnFLN = parcelRequire("gnFLN");

var $5Lk2z = parcelRequire("5Lk2z");

var $b6935 = parcelRequire("b6935");

var $6dN3e = parcelRequire("6dN3e");

var $ajcF7 = parcelRequire("ajcF7");

var $lMKzV = parcelRequire("lMKzV");
class $1f2ffe39f5a5c48d$export$1ac223ae496131c9 {
    static #_ = this.INITIAL_REFRESH_DELAY = 1;
    static #_2 = this.Factory = (apiHostProtocol, apiHost, product)=>{
        return new $1f2ffe39f5a5c48d$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
    };
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $fehQc.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $5Lk2z.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $5Lk2z.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $7Amhq.default)({
            ...this._options,
            waitInterval: (0, $5Lk2z.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $1f2ffe39f5a5c48d$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $5LChb.default)((status)=>{
            if (status === (0, $kV782.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $gnFLN.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $6dN3e.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $5Lk2z.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $ajcF7.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $b6935.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $lMKzV.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $kV782.NetworkStatusEnum).OFFLINE) {
            done((0, $hJeXm.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $hJeXm.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $hJeXm.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $5Lk2z.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $jjQOa.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $jjQOa.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $jjQOa.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $jjQOa.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("fehQc", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $0b64b653269f1a0e$export$83a9dd8d74be72c);

var $bcKhw = parcelRequire("bcKhw");
function $0b64b653269f1a0e$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $bcKhw.stargateProxyUrl)();
}

});
parcelRegister("bcKhw", function(module, exports) {
$parcel$export(module.exports, "stargateProxyUrl", () => $9bdc663ad3c9570f$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $9bdc663ad3c9570f$export$18c0b81944902eae);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $gNwHK = parcelRequire("gNwHK");

const $9bdc663ad3c9570f$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $9bdc663ad3c9570f$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $9bdc663ad3c9570f$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $9bdc663ad3c9570f$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $9bdc663ad3c9570f$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $9bdc663ad3c9570f$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $9bdc663ad3c9570f$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $9bdc663ad3c9570f$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $9bdc663ad3c9570f$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $9bdc663ad3c9570f$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $9bdc663ad3c9570f$export$5df9262e102d0c32;
}
const $9bdc663ad3c9570f$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $gNwHK.envType).LOCAL || env === (0, $gNwHK.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $gNwHK.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $gNwHK.envType).PROD ? $9bdc663ad3c9570f$var$FEDRAMP_PROD_HOST : $9bdc663ad3c9570f$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $gNwHK.envType).PROD ? $9bdc663ad3c9570f$var$STARGATE_FEDRAMP_PROD_HOST : $9bdc663ad3c9570f$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $9bdc663ad3c9570f$export$78e02cfb66671ad0();
};
const $9bdc663ad3c9570f$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $gNwHK.envType).PROD ? $9bdc663ad3c9570f$var$PROD_HOST : $9bdc663ad3c9570f$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $gNwHK.envType).PROD ? $9bdc663ad3c9570f$var$STARGATE_PROD_HOST : $9bdc663ad3c9570f$var$STARGATE_STAGING_HOST;
    return $9bdc663ad3c9570f$export$78e02cfb66671ad0();
};
function $9bdc663ad3c9570f$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $9bdc663ad3c9570f$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $gNwHK.perimeterType).FEDRAMP_MODERATE) return $9bdc663ad3c9570f$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $9bdc663ad3c9570f$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("gnFLN", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $1caa6426a628f8c8$export$44b578549c42d779);
class $1caa6426a628f8c8$export$44b578549c42d779 {
    static #_ = this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    static #_2 = this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    static #_3 = this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    static #_4 = this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($1caa6426a628f8c8$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($1caa6426a628f8c8$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($1caa6426a628f8c8$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($1caa6426a628f8c8$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("6dN3e", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $7297440c7da60d3e$export$55b0d0261469055);

var $57l7A = parcelRequire("57l7A");

var $b6935 = parcelRequire("b6935");
const $7297440c7da60d3e$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $7297440c7da60d3e$var$createRequestAbortController(timeout, signal);
    const corsOptions = $7297440c7da60d3e$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $b6935.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $7297440c7da60d3e$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $7297440c7da60d3e$var$getCorsForUrl = (0, $57l7A.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("ajcF7", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $485f6f498d6b5551$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $485f6f498d6b5551$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $485f6f498d6b5551$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}

});


parcelRegister("39ppA", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $903c1df1bc8a6a40$export$f56713ced121eb91);

var $gNwHK = parcelRequire("gNwHK");
const $903c1df1bc8a6a40$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $gNwHK.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("fIgkL", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $f9ab9b416c293479$export$ab34f90cc32c8960);

var $gNwHK = parcelRequire("gNwHK");
const $f9ab9b416c293479$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $gNwHK.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("7MiVX", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $1f69bf4a5d66db77$export$48361b6ed38f1b0);
class $1f69bf4a5d66db77$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $1f69bf4a5d66db77$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("4NcCK", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $6d21d65aedc4d841$export$ad1854f4a08c15f8);
function $6d21d65aedc4d841$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("agtVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2a0ae67fc4e99eb$export$2e2bcd8739ae039);

var $gNwHK = parcelRequire("gNwHK");

var $50VhI = parcelRequire("50VhI");
class $f2a0ae67fc4e99eb$export$2e2bcd8739ae039 {
    static #_ = this.messageEvent = 'origin landed';
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $gNwHK.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $50VhI.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $50VhI.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $f2a0ae67fc4e99eb$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("2nczX", function(module, exports) {
$parcel$export(module.exports, "default", () => $54153f4030963c36$export$2e2bcd8739ae039);

var $9vB61 = parcelRequire("9vB61");

var $7gTLI = parcelRequire("7gTLI");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $54153f4030963c36$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $54153f4030963c36$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $54153f4030963c36$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $54153f4030963c36$export$285f6bddd927a06d = 1800000;
const $54153f4030963c36$export$a92e915d70316eb2 = 5000;
const $54153f4030963c36$export$de43760b2dc10c19 = 0.9;
class $54153f4030963c36$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($54153f4030963c36$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // If session is not valid at this point, something has gone wrong with Local Storage access
            // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
            // gating roll-out of this early exit condition
            const { isValidSession: isValidSession } = this._getCurrentSessionParams();
            if (!isValidSession) return '';
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($54153f4030963c36$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $54153f4030963c36$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $54153f4030963c36$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $54153f4030963c36$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $9vB61.NOOP);
        this._safeLocalStorage = new (0, $7gTLI.default)();
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($54153f4030963c36$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($54153f4030963c36$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $54153f4030963c36$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
   * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
   * read a null value from storage, in which case we will return empty String
   */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
}

});
parcelRegister("9vB61", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $51b589115419a60e$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $51b589115419a60e$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("l0dXm", function(module, exports) {
$parcel$export(module.exports, "default", () => $09bd65dfb6135599$export$2e2bcd8739ae039);

var $d9m0t = parcelRequire("d9m0t");

var $ipQQj = parcelRequire("ipQQj");
class $09bd65dfb6135599$export$2e2bcd8739ae039 extends (0, $ipQQj.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $d9m0t.default);
        } catch (err) {
            storageToUse = (0, $d9m0t.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("1IhVl", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a9bb4a197b261d4$export$2e2bcd8739ae039);

var $l0dXm = parcelRequire("l0dXm");

var $8XLye = parcelRequire("8XLye");
const $7a9bb4a197b261d4$var$STORAGE_KEY = 'tab.id';
class $7a9bb4a197b261d4$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $8XLye.default)();
            this._safeSessionStorage.setItem($7a9bb4a197b261d4$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $l0dXm.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($7a9bb4a197b261d4$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("3Vjuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1dabf3ea3968de6$export$2e2bcd8739ae039);

var $fRh8v = parcelRequire("fRh8v");

var $gNwHK = parcelRequire("gNwHK");

var $bd0vV = parcelRequire("bd0vV");

var $l0dXm = parcelRequire("l0dXm");

var $50VhI = parcelRequire("50VhI");

var $8XLye = parcelRequire("8XLye");
const $e1dabf3ea3968de6$var$STORAGE_KEY = 'taskSessions';
const $e1dabf3ea3968de6$var$INIT_KEY = 'taskSessionsInit';
const $e1dabf3ea3968de6$var$AWC_PARAM_PREFIX = 'awc.';
const $e1dabf3ea3968de6$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e1dabf3ea3968de6$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e1dabf3ea3968de6$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e1dabf3ea3968de6$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e1dabf3ea3968de6$var$INIT_KEY) || '0', 10) < currentTimestamp - $e1dabf3ea3968de6$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e1dabf3ea3968de6$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e1dabf3ea3968de6$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e1dabf3ea3968de6$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e1dabf3ea3968de6$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $8XLye.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $fRh8v.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $bd0vV.pick)(currentState, includedTaskSessions) : (0, $bd0vV.omit)(currentState, Object.values((0, $gNwHK.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $bd0vV.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e1dabf3ea3968de6$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $fRh8v.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $bd0vV.mapKeys)((0, $50VhI.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $l0dXm.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e1dabf3ea3968de6$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("blU4A", function(module, exports) {
$parcel$export(module.exports, "default", () => $a301333898108f87$export$2e2bcd8739ae039);

var $cG0CM = parcelRequire("cG0CM");

var $kdkod = parcelRequire("kdkod");

var $gnFLN = parcelRequire("gnFLN");
const $a301333898108f87$var$MAX_CACHE_SIZE = 100;
const $a301333898108f87$var$COOKIE_NAME = (0, $kdkod.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $a301333898108f87$var$DEBUG_TAG = 'synthetic';
class $a301333898108f87$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $a301333898108f87$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $a301333898108f87$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($a301333898108f87$var$DEBUG_TAG)) event.tags.push($a301333898108f87$var$DEBUG_TAG);
        } else event.tags = [
            $a301333898108f87$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $gnFLN.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $cG0CM.default).get($a301333898108f87$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, $cG0CM.default).remove($a301333898108f87$var$COOKIE_NAME);
        }
        return false;
    }
}
var $a301333898108f87$export$2e2bcd8739ae039 = $a301333898108f87$var$TestingCache;

});

parcelRegister("5661s", function(module, exports) {
$parcel$export(module.exports, "default", () => $b461f270a09fef2f$export$2e2bcd8739ae039);

var $gNwHK = parcelRequire("gNwHK");

var $k6MUC = parcelRequire("k6MUC");

var $7gTLI = parcelRequire("7gTLI");
const $b461f270a09fef2f$var$DEFAULT_DELAY = 2000; // 2 seconds
const $b461f270a09fef2f$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $b461f270a09fef2f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $b461f270a09fef2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $b461f270a09fef2f$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($b461f270a09fef2f$var$SendEventDecision || {});
class $b461f270a09fef2f$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $k6MUC.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $gNwHK.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $b461f270a09fef2f$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $b461f270a09fef2f$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $b461f270a09fef2f$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $b461f270a09fef2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $7gTLI.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("k6MUC", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $0e8874a19522014f$export$f65ca476c09acec0);
const $0e8874a19522014f$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("5mcge", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $dd0ebdcbbd81b9fb$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gNwHK = parcelRequire("gNwHK");

var $2Evq4 = parcelRequire("2Evq4");

var $4NcCK = parcelRequire("4NcCK");
function $dd0ebdcbbd81b9fb$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $2Evq4.isType)((0, $gNwHK.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $4NcCK.objectValues)((0, $gNwHK.userType))}]`);
}

});

parcelRegister("2WbPB", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $ce9a3e65eff5ccd2$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5MEoI = parcelRequire("5MEoI");
function $ce9a3e65eff5ccd2$export$1e561554275607ef(event) {
    (0, $5MEoI.validateActionEvent)(event);
}

});

parcelRegister("ljUpE", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $c21ada3e248e2c09$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gNwHK = parcelRequire("gNwHK");

var $2Evq4 = parcelRequire("2Evq4");

var $4NcCK = parcelRequire("4NcCK");
function $c21ada3e248e2c09$export$801b46c35394d316(productInfo) {
    if (!(0, $2Evq4.isType)((0, $gNwHK.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $4NcCK.objectValues)((0, $gNwHK.platformType))}]`);
    if (productInfo.origin === (0, $gNwHK.originType).DESKTOP && !(0, $2Evq4.isType)((0, $gNwHK.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $gNwHK.originType).WEB && !(0, $2Evq4.isType)((0, $gNwHK.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("1dzRQ", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $626faf0d60977e12$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $626faf0d60977e12$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("kXTrw", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $a4956ab4f28ce3b0$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5MEoI = parcelRequire("5MEoI");
function $a4956ab4f28ce3b0$export$8c014fd74b0c8b99(event) {
    (0, $5MEoI.validateActionEvent)(event);
}

});

parcelRegister("g342h", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $6489e6bdb8f6eb51$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5MEoI = parcelRequire("5MEoI");
function $6489e6bdb8f6eb51$export$e5bac0930c812e90(event) {
    (0, $5MEoI.validateActionEvent)(event);
}

});

parcelRegister("ep1I0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8206989f4606ff8b$export$2e2bcd8739ae039);
function $8206989f4606ff8b$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("cmgc5", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $69ce73a84a0c4039$export$fbe53bbbe682bcdd);

var $bMI5L = parcelRequire("bMI5L");
const $69ce73a84a0c4039$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $bMI5L.createTimeoutXid)()), (0, $bMI5L.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $bMI5L.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("bMI5L", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $311b34da0280c0e8$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $311b34da0280c0e8$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $311b34da0280c0e8$export$fa341d0c750d705b);

var $kaTjx = parcelRequire("kaTjx");
const $311b34da0280c0e8$export$545bcbd53afabfa3 = 5000;
const $311b34da0280c0e8$export$af4087e36d63846 = ()=>[
        {
            type: (0, $kaTjx.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $kaTjx.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $311b34da0280c0e8$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $kaTjx.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $kaTjx.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("kaTjx", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $b51c359aae6befe7$export$92ca0438bcb0d396);
var $b51c359aae6befe7$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $b51c359aae6befe7$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("4ZMmh", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("clpci", function(module, exports) {
$parcel$export(module.exports, "SCREEN", () => $bf63183117ce9a13$export$f636b5b56f1d624a);
$parcel$export(module.exports, "MODAL", () => $bf63183117ce9a13$export$1171103ea9083ffa);
$parcel$export(module.exports, "INLINE_DIALOG", () => $bf63183117ce9a13$export$cae2783c9279926);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $bf63183117ce9a13$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $bf63183117ce9a13$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $bf63183117ce9a13$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $bf63183117ce9a13$export$12346a674644c156);
$parcel$export(module.exports, "ANALYTICS_BRIDGE_CHANNEL", () => $bf63183117ce9a13$export$2ceccf177fae277c);
const $bf63183117ce9a13$export$f636b5b56f1d624a = 'Screen';
const $bf63183117ce9a13$export$9d2de6eebf7462b5 = 'Drawer';
const $bf63183117ce9a13$export$1171103ea9083ffa = 'Modal';
const $bf63183117ce9a13$export$cae2783c9279926 = 'InlineDialog';
const $bf63183117ce9a13$export$d1123261ca8831d2 = 'Dropdown';
const $bf63183117ce9a13$export$a1562d08625f5d7e = 'UI';
const $bf63183117ce9a13$export$947dac6c72b26f81 = 'TRACK';
const $bf63183117ce9a13$export$f1d537d508d2945a = 'SCREEN';
const $bf63183117ce9a13$export$12346a674644c156 = 'OPERATIONAL';
const $bf63183117ce9a13$export$2ceccf177fae277c = 'analyticsBridge';

});

parcelRegister("ezwN8", function(module, exports) {
$parcel$export(module.exports, "extractAWCDataFromEvent", () => $52e78592423aeda5$export$1c850cf68c053906);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $lgNi9 = parcelRequire("lgNi9");

var $eu1ij = parcelRequire("eu1ij");

var $clpci = parcelRequire("clpci");

var $kl3KV = parcelRequire("kl3KV");
const $52e78592423aeda5$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $kl3KV.getAnalyticsType)(castedEvent);
    const attributes = (0, $kl3KV.getAttributes)(castedEvent);
    const source = (0, $kl3KV.getSource)(castedEvent);
    const actionSubject = (0, $kl3KV.getActionSubject)(castedEvent);
    if (analyticsType === (0, $clpci.SCREEN_EVENT_TYPE)) return {
        type: (0, $clpci.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $clpci.UI_EVENT_TYPE:
        case 0, $clpci.TRACK_EVENT_TYPE:
        case 0, $clpci.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $kl3KV.getAction)(castedEvent);
                const actionSubjectId = (0, $kl3KV.getActionSubjectId)(castedEvent);
                const containerId = (0, $kl3KV.getContainerId)(castedEvent);
                const containerType = (0, $kl3KV.getContainerType)(castedEvent);
                const objectId = (0, $kl3KV.getObjectId)(castedEvent);
                const objectType = (0, $kl3KV.getObjectType)(castedEvent);
                const tags = (0, $kl3KV.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($eu1ij)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($lgNi9))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("lgNi9", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $03fefd39863e1e18$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $03fefd39863e1e18$var$isUndefined;

});

parcelRegister("eu1ij", function(module, exports) {

var $3iACh = parcelRequire("3iACh");

var $fct8J = parcelRequire("fct8J");

var $lzTOS = parcelRequire("lzTOS");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $a8b4df1232ce65db$var$omitBy(object, predicate) {
    return $lzTOS(object, $fct8J($3iACh(predicate)));
}
module.exports = $a8b4df1232ce65db$var$omitBy;

});
parcelRegister("3iACh", function(module, exports) {

var $lF8Bs = parcelRequire("lF8Bs");

var $5jBqZ = parcelRequire("5jBqZ");

var $iaKuz = parcelRequire("iaKuz");

var $lVkdr = parcelRequire("lVkdr");

var $eP5pW = parcelRequire("eP5pW");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $266f74ca6cc83ebd$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $iaKuz;
    if (typeof value == 'object') return $lVkdr(value) ? $5jBqZ(value[0], value[1]) : $lF8Bs(value);
    return $eP5pW(value);
}
module.exports = $266f74ca6cc83ebd$var$baseIteratee;

});
parcelRegister("lF8Bs", function(module, exports) {

var $8nOke = parcelRequire("8nOke");

var $kIhPT = parcelRequire("kIhPT");

var $docJm = parcelRequire("docJm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $fc5419b95c37ac96$var$baseMatches(source) {
    var matchData = $kIhPT(source);
    if (matchData.length == 1 && matchData[0][2]) return $docJm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $8nOke(object, source, matchData);
    };
}
module.exports = $fc5419b95c37ac96$var$baseMatches;

});
parcelRegister("8nOke", function(module, exports) {

var $423Gf = parcelRequire("423Gf");

var $2Fr8f = parcelRequire("2Fr8f");
/** Used to compose bitmasks for value comparisons. */ var $61a7824164c6b40c$var$COMPARE_PARTIAL_FLAG = 1, $61a7824164c6b40c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $61a7824164c6b40c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $423Gf;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $2Fr8f(srcValue, objValue, $61a7824164c6b40c$var$COMPARE_PARTIAL_FLAG | $61a7824164c6b40c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $61a7824164c6b40c$var$baseIsMatch;

});
parcelRegister("423Gf", function(module, exports) {

var $2p90r = parcelRequire("2p90r");

var $9xPuB = parcelRequire("9xPuB");

var $gKzlA = parcelRequire("gKzlA");

var $gJ3Bw = parcelRequire("gJ3Bw");

var $3YpR7 = parcelRequire("3YpR7");

var $1EIW8 = parcelRequire("1EIW8");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2efa342e3651f446$var$Stack(entries) {
    var data = this.__data__ = new $2p90r(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$2efa342e3651f446$var$Stack.prototype.clear = $9xPuB;
$2efa342e3651f446$var$Stack.prototype['delete'] = $gKzlA;
$2efa342e3651f446$var$Stack.prototype.get = $gJ3Bw;
$2efa342e3651f446$var$Stack.prototype.has = $3YpR7;
$2efa342e3651f446$var$Stack.prototype.set = $1EIW8;
module.exports = $2efa342e3651f446$var$Stack;

});
parcelRegister("2p90r", function(module, exports) {

var $l0BLo = parcelRequire("l0BLo");

var $gi36T = parcelRequire("gi36T");

var $l8GWc = parcelRequire("l8GWc");

var $62mEG = parcelRequire("62mEG");

var $lmqYD = parcelRequire("lmqYD");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1c04e6f93029e2db$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$1c04e6f93029e2db$var$ListCache.prototype.clear = $l0BLo;
$1c04e6f93029e2db$var$ListCache.prototype['delete'] = $gi36T;
$1c04e6f93029e2db$var$ListCache.prototype.get = $l8GWc;
$1c04e6f93029e2db$var$ListCache.prototype.has = $62mEG;
$1c04e6f93029e2db$var$ListCache.prototype.set = $lmqYD;
module.exports = $1c04e6f93029e2db$var$ListCache;

});
parcelRegister("l0BLo", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f4b6e41c2fbef35e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $f4b6e41c2fbef35e$var$listCacheClear;

});

parcelRegister("gi36T", function(module, exports) {

var $8YnSV = parcelRequire("8YnSV");
/** Used for built-in method references. */ var $bdc0bd620c7245de$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $bdc0bd620c7245de$var$splice = $bdc0bd620c7245de$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bdc0bd620c7245de$var$listCacheDelete(key) {
    var data = this.__data__, index = $8YnSV(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $bdc0bd620c7245de$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $bdc0bd620c7245de$var$listCacheDelete;

});
parcelRegister("8YnSV", function(module, exports) {

var $9agBK = parcelRequire("9agBK");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6886745b3307d55f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($9agBK(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $6886745b3307d55f$var$assocIndexOf;

});
parcelRegister("9agBK", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6ac1ee325344a0d8$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $6ac1ee325344a0d8$var$eq;

});



parcelRegister("l8GWc", function(module, exports) {

var $8YnSV = parcelRequire("8YnSV");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f63ba6e17929dc57$var$listCacheGet(key) {
    var data = this.__data__, index = $8YnSV(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $f63ba6e17929dc57$var$listCacheGet;

});

parcelRegister("62mEG", function(module, exports) {

var $8YnSV = parcelRequire("8YnSV");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $465480d3a8509daf$var$listCacheHas(key) {
    return $8YnSV(this.__data__, key) > -1;
}
module.exports = $465480d3a8509daf$var$listCacheHas;

});

parcelRegister("lmqYD", function(module, exports) {

var $8YnSV = parcelRequire("8YnSV");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $f8d09423990aa264$var$listCacheSet(key, value) {
    var data = this.__data__, index = $8YnSV(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $f8d09423990aa264$var$listCacheSet;

});


parcelRegister("9xPuB", function(module, exports) {

var $2p90r = parcelRequire("2p90r");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6f2f237e5e8b5cf9$var$stackClear() {
    this.__data__ = new $2p90r;
    this.size = 0;
}
module.exports = $6f2f237e5e8b5cf9$var$stackClear;

});

parcelRegister("gKzlA", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c31c5c694d3362d0$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $c31c5c694d3362d0$var$stackDelete;

});

parcelRegister("gJ3Bw", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c2d3a50885cf7997$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $c2d3a50885cf7997$var$stackGet;

});

parcelRegister("3YpR7", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2e4b081553a7fe07$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $2e4b081553a7fe07$var$stackHas;

});

parcelRegister("1EIW8", function(module, exports) {

var $2p90r = parcelRequire("2p90r");

var $3AtHE = parcelRequire("3AtHE");

var $zpcSP = parcelRequire("zpcSP");
/** Used as the size to enable large array optimizations. */ var $134c62551017db53$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $134c62551017db53$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $2p90r) {
        var pairs = data.__data__;
        if (!$3AtHE || pairs.length < $134c62551017db53$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $zpcSP(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $134c62551017db53$var$stackSet;

});
parcelRegister("3AtHE", function(module, exports) {

var $baxPM = parcelRequire("baxPM");

var $6Ymo5 = parcelRequire("6Ymo5");
/* Built-in method references that are verified to be native. */ var $29cbc646b5af1613$var$Map = $baxPM($6Ymo5, 'Map');
module.exports = $29cbc646b5af1613$var$Map;

});
parcelRegister("baxPM", function(module, exports) {

var $ibDzj = parcelRequire("ibDzj");

var $iTFbg = parcelRequire("iTFbg");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $821adfaab3087d4b$var$getNative(object, key) {
    var value = $iTFbg(object, key);
    return $ibDzj(value) ? value : undefined;
}
module.exports = $821adfaab3087d4b$var$getNative;

});
parcelRegister("ibDzj", function(module, exports) {

var $lOj5y = parcelRequire("lOj5y");

var $bZIUn = parcelRequire("bZIUn");

var $awGqx = parcelRequire("awGqx");

var $Jqx8z = parcelRequire("Jqx8z");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d3d7f2930a17e00c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d3d7f2930a17e00c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d3d7f2930a17e00c$var$funcProto = Function.prototype, $d3d7f2930a17e00c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d3d7f2930a17e00c$var$funcToString = $d3d7f2930a17e00c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d3d7f2930a17e00c$var$hasOwnProperty = $d3d7f2930a17e00c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d3d7f2930a17e00c$var$reIsNative = RegExp('^' + $d3d7f2930a17e00c$var$funcToString.call($d3d7f2930a17e00c$var$hasOwnProperty).replace($d3d7f2930a17e00c$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d3d7f2930a17e00c$var$baseIsNative(value) {
    if (!$awGqx(value) || $bZIUn(value)) return false;
    var pattern = $lOj5y(value) ? $d3d7f2930a17e00c$var$reIsNative : $d3d7f2930a17e00c$var$reIsHostCtor;
    return pattern.test($Jqx8z(value));
}
module.exports = $d3d7f2930a17e00c$var$baseIsNative;

});
parcelRegister("lOj5y", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $awGqx = parcelRequire("awGqx");
/** `Object#toString` result references. */ var $fe0d1310701236b3$var$asyncTag = '[object AsyncFunction]', $fe0d1310701236b3$var$funcTag = '[object Function]', $fe0d1310701236b3$var$genTag = '[object GeneratorFunction]', $fe0d1310701236b3$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $fe0d1310701236b3$var$isFunction(value) {
    if (!$awGqx(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $1XSz3(value);
    return tag == $fe0d1310701236b3$var$funcTag || tag == $fe0d1310701236b3$var$genTag || tag == $fe0d1310701236b3$var$asyncTag || tag == $fe0d1310701236b3$var$proxyTag;
}
module.exports = $fe0d1310701236b3$var$isFunction;

});
parcelRegister("1XSz3", function(module, exports) {

var $hS0KO = parcelRequire("hS0KO");

var $18U5Z = parcelRequire("18U5Z");

var $2BtpS = parcelRequire("2BtpS");
/** `Object#toString` result references. */ var $16e5a07c1765d107$var$nullTag = '[object Null]', $16e5a07c1765d107$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $16e5a07c1765d107$var$symToStringTag = $hS0KO ? $hS0KO.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $16e5a07c1765d107$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $16e5a07c1765d107$var$undefinedTag : $16e5a07c1765d107$var$nullTag;
    return $16e5a07c1765d107$var$symToStringTag && $16e5a07c1765d107$var$symToStringTag in Object(value) ? $18U5Z(value) : $2BtpS(value);
}
module.exports = $16e5a07c1765d107$var$baseGetTag;

});
parcelRegister("hS0KO", function(module, exports) {

var $6Ymo5 = parcelRequire("6Ymo5");
/** Built-in value references. */ var $d028108f00493d67$var$Symbol = $6Ymo5.Symbol;
module.exports = $d028108f00493d67$var$Symbol;

});
parcelRegister("6Ymo5", function(module, exports) {

var $8mdfk = parcelRequire("8mdfk");
/** Detect free variable `self`. */ var $5139b660c07dd040$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5139b660c07dd040$var$root = $8mdfk || $5139b660c07dd040$var$freeSelf || Function('return this')();
module.exports = $5139b660c07dd040$var$root;

});
parcelRegister("8mdfk", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $615aa73b286bbb54$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $615aa73b286bbb54$var$freeGlobal;

});



parcelRegister("18U5Z", function(module, exports) {

var $hS0KO = parcelRequire("hS0KO");
/** Used for built-in method references. */ var $0d520d3c64ebb37b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d520d3c64ebb37b$var$hasOwnProperty = $0d520d3c64ebb37b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0d520d3c64ebb37b$var$nativeObjectToString = $0d520d3c64ebb37b$var$objectProto.toString;
/** Built-in value references. */ var $0d520d3c64ebb37b$var$symToStringTag = $hS0KO ? $hS0KO.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0d520d3c64ebb37b$var$getRawTag(value) {
    var isOwn = $0d520d3c64ebb37b$var$hasOwnProperty.call(value, $0d520d3c64ebb37b$var$symToStringTag), tag = value[$0d520d3c64ebb37b$var$symToStringTag];
    try {
        value[$0d520d3c64ebb37b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $0d520d3c64ebb37b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0d520d3c64ebb37b$var$symToStringTag] = tag;
        else delete value[$0d520d3c64ebb37b$var$symToStringTag];
    }
    return result;
}
module.exports = $0d520d3c64ebb37b$var$getRawTag;

});

parcelRegister("2BtpS", function(module, exports) {
/** Used for built-in method references. */ var $1e55daf41df3e06a$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1e55daf41df3e06a$var$nativeObjectToString = $1e55daf41df3e06a$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1e55daf41df3e06a$var$objectToString(value) {
    return $1e55daf41df3e06a$var$nativeObjectToString.call(value);
}
module.exports = $1e55daf41df3e06a$var$objectToString;

});


parcelRegister("awGqx", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7a9dcda6934d15a5$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $7a9dcda6934d15a5$var$isObject;

});


parcelRegister("bZIUn", function(module, exports) {

var $l887P = parcelRequire("l887P");
/** Used to detect methods masquerading as native. */ var $8bb83a1581e955d1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($l887P && $l887P.keys && $l887P.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8bb83a1581e955d1$var$isMasked(func) {
    return !!$8bb83a1581e955d1$var$maskSrcKey && $8bb83a1581e955d1$var$maskSrcKey in func;
}
module.exports = $8bb83a1581e955d1$var$isMasked;

});
parcelRegister("l887P", function(module, exports) {

var $6Ymo5 = parcelRequire("6Ymo5");
/** Used to detect overreaching core-js shims. */ var $f620a5d38e8b301c$var$coreJsData = $6Ymo5["__core-js_shared__"];
module.exports = $f620a5d38e8b301c$var$coreJsData;

});


parcelRegister("Jqx8z", function(module, exports) {
/** Used for built-in method references. */ var $0888c91424011a35$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0888c91424011a35$var$funcToString = $0888c91424011a35$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0888c91424011a35$var$toSource(func) {
    if (func != null) {
        try {
            return $0888c91424011a35$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $0888c91424011a35$var$toSource;

});


parcelRegister("iTFbg", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $dc1d4eb19b9d5e87$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $dc1d4eb19b9d5e87$var$getValue;

});



parcelRegister("zpcSP", function(module, exports) {

var $lHWHO = parcelRequire("lHWHO");

var $drlsR = parcelRequire("drlsR");

var $lg9Ey = parcelRequire("lg9Ey");

var $k1Bwe = parcelRequire("k1Bwe");

var $9D1wp = parcelRequire("9D1wp");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $06a6d28b3e0e3951$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$06a6d28b3e0e3951$var$MapCache.prototype.clear = $lHWHO;
$06a6d28b3e0e3951$var$MapCache.prototype['delete'] = $drlsR;
$06a6d28b3e0e3951$var$MapCache.prototype.get = $lg9Ey;
$06a6d28b3e0e3951$var$MapCache.prototype.has = $k1Bwe;
$06a6d28b3e0e3951$var$MapCache.prototype.set = $9D1wp;
module.exports = $06a6d28b3e0e3951$var$MapCache;

});
parcelRegister("lHWHO", function(module, exports) {

var $hznYr = parcelRequire("hznYr");

var $2p90r = parcelRequire("2p90r");

var $3AtHE = parcelRequire("3AtHE");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $fcdb26d8b4dc7772$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $hznYr,
        'map': new ($3AtHE || $2p90r),
        'string': new $hznYr
    };
}
module.exports = $fcdb26d8b4dc7772$var$mapCacheClear;

});
parcelRegister("hznYr", function(module, exports) {

var $2Wu6R = parcelRequire("2Wu6R");

var $1wCCY = parcelRequire("1wCCY");

var $26sdU = parcelRequire("26sdU");

var $aIBCU = parcelRequire("aIBCU");

var $1pJS4 = parcelRequire("1pJS4");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cca84d43f238fa0f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cca84d43f238fa0f$var$Hash.prototype.clear = $2Wu6R;
$cca84d43f238fa0f$var$Hash.prototype['delete'] = $1wCCY;
$cca84d43f238fa0f$var$Hash.prototype.get = $26sdU;
$cca84d43f238fa0f$var$Hash.prototype.has = $aIBCU;
$cca84d43f238fa0f$var$Hash.prototype.set = $1pJS4;
module.exports = $cca84d43f238fa0f$var$Hash;

});
parcelRegister("2Wu6R", function(module, exports) {

var $9imKT = parcelRequire("9imKT");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $22485ab15802a022$var$hashClear() {
    this.__data__ = $9imKT ? $9imKT(null) : {};
    this.size = 0;
}
module.exports = $22485ab15802a022$var$hashClear;

});
parcelRegister("9imKT", function(module, exports) {

var $baxPM = parcelRequire("baxPM");
/* Built-in method references that are verified to be native. */ var $6c477237cb4c2be6$var$nativeCreate = $baxPM(Object, 'create');
module.exports = $6c477237cb4c2be6$var$nativeCreate;

});


parcelRegister("1wCCY", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $11c6be3c181a05de$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $11c6be3c181a05de$var$hashDelete;

});

parcelRegister("26sdU", function(module, exports) {

var $9imKT = parcelRequire("9imKT");
/** Used to stand-in for `undefined` hash values. */ var $188208e63b0d27f1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $188208e63b0d27f1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $188208e63b0d27f1$var$hasOwnProperty = $188208e63b0d27f1$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $188208e63b0d27f1$var$hashGet(key) {
    var data = this.__data__;
    if ($9imKT) {
        var result = data[key];
        return result === $188208e63b0d27f1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $188208e63b0d27f1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $188208e63b0d27f1$var$hashGet;

});

parcelRegister("aIBCU", function(module, exports) {

var $9imKT = parcelRequire("9imKT");
/** Used for built-in method references. */ var $7cdb3346ad80c3d8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7cdb3346ad80c3d8$var$hasOwnProperty = $7cdb3346ad80c3d8$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7cdb3346ad80c3d8$var$hashHas(key) {
    var data = this.__data__;
    return $9imKT ? data[key] !== undefined : $7cdb3346ad80c3d8$var$hasOwnProperty.call(data, key);
}
module.exports = $7cdb3346ad80c3d8$var$hashHas;

});

parcelRegister("1pJS4", function(module, exports) {

var $9imKT = parcelRequire("9imKT");
/** Used to stand-in for `undefined` hash values. */ var $107bb546cbe69dc1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $107bb546cbe69dc1$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $9imKT && value === undefined ? $107bb546cbe69dc1$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $107bb546cbe69dc1$var$hashSet;

});



parcelRegister("drlsR", function(module, exports) {

var $lOzfR = parcelRequire("lOzfR");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9c8e725cd9d7b4c9$var$mapCacheDelete(key) {
    var result = $lOzfR(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9c8e725cd9d7b4c9$var$mapCacheDelete;

});
parcelRegister("lOzfR", function(module, exports) {

var $050fV = parcelRequire("050fV");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $fe199d5eb913157d$var$getMapData(map, key) {
    var data = map.__data__;
    return $050fV(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $fe199d5eb913157d$var$getMapData;

});
parcelRegister("050fV", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $00f0aa8b232b3be7$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $00f0aa8b232b3be7$var$isKeyable;

});



parcelRegister("lg9Ey", function(module, exports) {

var $lOzfR = parcelRequire("lOzfR");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f7a294807940cf5c$var$mapCacheGet(key) {
    return $lOzfR(this, key).get(key);
}
module.exports = $f7a294807940cf5c$var$mapCacheGet;

});

parcelRegister("k1Bwe", function(module, exports) {

var $lOzfR = parcelRequire("lOzfR");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e941011946c9ca1a$var$mapCacheHas(key) {
    return $lOzfR(this, key).has(key);
}
module.exports = $e941011946c9ca1a$var$mapCacheHas;

});

parcelRegister("9D1wp", function(module, exports) {

var $lOzfR = parcelRequire("lOzfR");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7028efc1b2c31f34$var$mapCacheSet(key, value) {
    var data = $lOzfR(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $7028efc1b2c31f34$var$mapCacheSet;

});




parcelRegister("2Fr8f", function(module, exports) {

var $8Xy73 = parcelRequire("8Xy73");

var $3T67E = parcelRequire("3T67E");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $1f1474fcd3e8e266$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$3T67E(value) && !$3T67E(other)) return value !== value && other !== other;
    return $8Xy73(value, other, bitmask, customizer, $1f1474fcd3e8e266$var$baseIsEqual, stack);
}
module.exports = $1f1474fcd3e8e266$var$baseIsEqual;

});
parcelRegister("8Xy73", function(module, exports) {

var $423Gf = parcelRequire("423Gf");

var $fW7w8 = parcelRequire("fW7w8");

var $5LHkN = parcelRequire("5LHkN");

var $b8Rxr = parcelRequire("b8Rxr");

var $4J8KV = parcelRequire("4J8KV");

var $lVkdr = parcelRequire("lVkdr");

var $1TItY = parcelRequire("1TItY");

var $abOQN = parcelRequire("abOQN");
/** Used to compose bitmasks for value comparisons. */ var $685e4b8289181d06$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $685e4b8289181d06$var$argsTag = '[object Arguments]', $685e4b8289181d06$var$arrayTag = '[object Array]', $685e4b8289181d06$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $685e4b8289181d06$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $685e4b8289181d06$var$hasOwnProperty = $685e4b8289181d06$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $685e4b8289181d06$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $lVkdr(object), othIsArr = $lVkdr(other), objTag = objIsArr ? $685e4b8289181d06$var$arrayTag : $4J8KV(object), othTag = othIsArr ? $685e4b8289181d06$var$arrayTag : $4J8KV(other);
    objTag = objTag == $685e4b8289181d06$var$argsTag ? $685e4b8289181d06$var$objectTag : objTag;
    othTag = othTag == $685e4b8289181d06$var$argsTag ? $685e4b8289181d06$var$objectTag : othTag;
    var objIsObj = objTag == $685e4b8289181d06$var$objectTag, othIsObj = othTag == $685e4b8289181d06$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $1TItY(object)) {
        if (!$1TItY(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $423Gf);
        return objIsArr || $abOQN(object) ? $fW7w8(object, other, bitmask, customizer, equalFunc, stack) : $5LHkN(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $685e4b8289181d06$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $685e4b8289181d06$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $685e4b8289181d06$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $423Gf);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $423Gf);
    return $b8Rxr(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $685e4b8289181d06$var$baseIsEqualDeep;

});
parcelRegister("fW7w8", function(module, exports) {

var $4ZLTW = parcelRequire("4ZLTW");

var $kqqf7 = parcelRequire("kqqf7");

var $1C2YK = parcelRequire("1C2YK");
/** Used to compose bitmasks for value comparisons. */ var $b9a21a9307425b1f$var$COMPARE_PARTIAL_FLAG = 1, $b9a21a9307425b1f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $b9a21a9307425b1f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b9a21a9307425b1f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $b9a21a9307425b1f$var$COMPARE_UNORDERED_FLAG ? new $4ZLTW : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$kqqf7(other, function(othValue, othIndex) {
                if (!$1C2YK(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $b9a21a9307425b1f$var$equalArrays;

});
parcelRegister("4ZLTW", function(module, exports) {

var $zpcSP = parcelRequire("zpcSP");

var $hgPSt = parcelRequire("hgPSt");

var $3bRJT = parcelRequire("3bRJT");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $3a320426bd4e3b7b$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $zpcSP;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$3a320426bd4e3b7b$var$SetCache.prototype.add = $3a320426bd4e3b7b$var$SetCache.prototype.push = $hgPSt;
$3a320426bd4e3b7b$var$SetCache.prototype.has = $3bRJT;
module.exports = $3a320426bd4e3b7b$var$SetCache;

});
parcelRegister("hgPSt", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $c92c2c178dec5ff9$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $c92c2c178dec5ff9$var$setCacheAdd(value) {
    this.__data__.set(value, $c92c2c178dec5ff9$var$HASH_UNDEFINED);
    return this;
}
module.exports = $c92c2c178dec5ff9$var$setCacheAdd;

});

parcelRegister("3bRJT", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $252c15adb42fa80a$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $252c15adb42fa80a$var$setCacheHas;

});


parcelRegister("kqqf7", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $edea97a0b301dd12$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $edea97a0b301dd12$var$arraySome;

});

parcelRegister("1C2YK", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $12cba69523dbe945$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $12cba69523dbe945$var$cacheHas;

});


parcelRegister("5LHkN", function(module, exports) {

var $hS0KO = parcelRequire("hS0KO");

var $YBIv2 = parcelRequire("YBIv2");

var $9agBK = parcelRequire("9agBK");

var $fW7w8 = parcelRequire("fW7w8");

var $9jLXS = parcelRequire("9jLXS");

var $hqHbJ = parcelRequire("hqHbJ");
/** Used to compose bitmasks for value comparisons. */ var $0115778fcb56f61a$var$COMPARE_PARTIAL_FLAG = 1, $0115778fcb56f61a$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $0115778fcb56f61a$var$boolTag = '[object Boolean]', $0115778fcb56f61a$var$dateTag = '[object Date]', $0115778fcb56f61a$var$errorTag = '[object Error]', $0115778fcb56f61a$var$mapTag = '[object Map]', $0115778fcb56f61a$var$numberTag = '[object Number]', $0115778fcb56f61a$var$regexpTag = '[object RegExp]', $0115778fcb56f61a$var$setTag = '[object Set]', $0115778fcb56f61a$var$stringTag = '[object String]', $0115778fcb56f61a$var$symbolTag = '[object Symbol]';
var $0115778fcb56f61a$var$arrayBufferTag = '[object ArrayBuffer]', $0115778fcb56f61a$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $0115778fcb56f61a$var$symbolProto = $hS0KO ? $hS0KO.prototype : undefined, $0115778fcb56f61a$var$symbolValueOf = $0115778fcb56f61a$var$symbolProto ? $0115778fcb56f61a$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $0115778fcb56f61a$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $0115778fcb56f61a$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $0115778fcb56f61a$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $YBIv2(object), new $YBIv2(other))) return false;
            return true;
        case $0115778fcb56f61a$var$boolTag:
        case $0115778fcb56f61a$var$dateTag:
        case $0115778fcb56f61a$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $9agBK(+object, +other);
        case $0115778fcb56f61a$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $0115778fcb56f61a$var$regexpTag:
        case $0115778fcb56f61a$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $0115778fcb56f61a$var$mapTag:
            var convert = $9jLXS;
        case $0115778fcb56f61a$var$setTag:
            var isPartial = bitmask & $0115778fcb56f61a$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $hqHbJ);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $0115778fcb56f61a$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $fW7w8(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $0115778fcb56f61a$var$symbolTag:
            if ($0115778fcb56f61a$var$symbolValueOf) return $0115778fcb56f61a$var$symbolValueOf.call(object) == $0115778fcb56f61a$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $0115778fcb56f61a$var$equalByTag;

});
parcelRegister("YBIv2", function(module, exports) {

var $6Ymo5 = parcelRequire("6Ymo5");
/** Built-in value references. */ var $0b62dc7835ea2de6$var$Uint8Array = $6Ymo5.Uint8Array;
module.exports = $0b62dc7835ea2de6$var$Uint8Array;

});

parcelRegister("9jLXS", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $6c8b183b2378d97f$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $6c8b183b2378d97f$var$mapToArray;

});

parcelRegister("hqHbJ", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $cb065da86df16dbe$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $cb065da86df16dbe$var$setToArray;

});


parcelRegister("b8Rxr", function(module, exports) {

var $l7PnJ = parcelRequire("l7PnJ");
/** Used to compose bitmasks for value comparisons. */ var $81c9f8ad4d028e41$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $81c9f8ad4d028e41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $81c9f8ad4d028e41$var$hasOwnProperty = $81c9f8ad4d028e41$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $81c9f8ad4d028e41$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $81c9f8ad4d028e41$var$COMPARE_PARTIAL_FLAG, objProps = $l7PnJ(object), objLength = objProps.length, othProps = $l7PnJ(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $81c9f8ad4d028e41$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $81c9f8ad4d028e41$var$equalObjects;

});
parcelRegister("l7PnJ", function(module, exports) {

var $g9msS = parcelRequire("g9msS");

var $1sma7 = parcelRequire("1sma7");

var $7yuIC = parcelRequire("7yuIC");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f6121bc31f2354ba$var$getAllKeys(object) {
    return $g9msS(object, $7yuIC, $1sma7);
}
module.exports = $f6121bc31f2354ba$var$getAllKeys;

});
parcelRegister("g9msS", function(module, exports) {

var $eQjy5 = parcelRequire("eQjy5");

var $lVkdr = parcelRequire("lVkdr");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bc1ee9a5fcdab10b$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $lVkdr(object) ? result : $eQjy5(result, symbolsFunc(object));
}
module.exports = $bc1ee9a5fcdab10b$var$baseGetAllKeys;

});
parcelRegister("eQjy5", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ace515f9c50cca6e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $ace515f9c50cca6e$var$arrayPush;

});

parcelRegister("lVkdr", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $ff5e9a428fdb5669$var$isArray = Array.isArray;
module.exports = $ff5e9a428fdb5669$var$isArray;

});


parcelRegister("1sma7", function(module, exports) {

var $74xUE = parcelRequire("74xUE");

var $5ACVB = parcelRequire("5ACVB");
/** Used for built-in method references. */ var $10f998ea1460ec3b$var$objectProto = Object.prototype;
/** Built-in value references. */ var $10f998ea1460ec3b$var$propertyIsEnumerable = $10f998ea1460ec3b$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $10f998ea1460ec3b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $10f998ea1460ec3b$var$getSymbols = !$10f998ea1460ec3b$var$nativeGetSymbols ? $5ACVB : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $74xUE($10f998ea1460ec3b$var$nativeGetSymbols(object), function(symbol) {
        return $10f998ea1460ec3b$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $10f998ea1460ec3b$var$getSymbols;

});
parcelRegister("74xUE", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $52633677e24fce02$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $52633677e24fce02$var$arrayFilter;

});

parcelRegister("5ACVB", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $411e82da84f095d9$var$stubArray() {
    return [];
}
module.exports = $411e82da84f095d9$var$stubArray;

});


parcelRegister("7yuIC", function(module, exports) {

var $36D8s = parcelRequire("36D8s");

var $7MNHj = parcelRequire("7MNHj");

var $d5SgW = parcelRequire("d5SgW");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $5803897294a81bfb$var$keys(object) {
    return $d5SgW(object) ? $36D8s(object) : $7MNHj(object);
}
module.exports = $5803897294a81bfb$var$keys;

});
parcelRegister("36D8s", function(module, exports) {

var $7BWpO = parcelRequire("7BWpO");

var $aSgk4 = parcelRequire("aSgk4");

var $lVkdr = parcelRequire("lVkdr");

var $1TItY = parcelRequire("1TItY");

var $csxP9 = parcelRequire("csxP9");

var $abOQN = parcelRequire("abOQN");
/** Used for built-in method references. */ var $24304a1c8ed5a3df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $24304a1c8ed5a3df$var$hasOwnProperty = $24304a1c8ed5a3df$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $24304a1c8ed5a3df$var$arrayLikeKeys(value, inherited) {
    var isArr = $lVkdr(value), isArg = !isArr && $aSgk4(value), isBuff = !isArr && !isArg && $1TItY(value), isType = !isArr && !isArg && !isBuff && $abOQN(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7BWpO(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $24304a1c8ed5a3df$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $csxP9(key, length)))) result.push(key);
    return result;
}
module.exports = $24304a1c8ed5a3df$var$arrayLikeKeys;

});
parcelRegister("7BWpO", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $58a94d298213afef$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $58a94d298213afef$var$baseTimes;

});

parcelRegister("aSgk4", function(module, exports) {

var $dcLmJ = parcelRequire("dcLmJ");

var $3T67E = parcelRequire("3T67E");
/** Used for built-in method references. */ var $7eab9be1142acfe4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7eab9be1142acfe4$var$hasOwnProperty = $7eab9be1142acfe4$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7eab9be1142acfe4$var$propertyIsEnumerable = $7eab9be1142acfe4$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7eab9be1142acfe4$var$isArguments = $dcLmJ(function() {
    return arguments;
}()) ? $dcLmJ : function(value) {
    return $3T67E(value) && $7eab9be1142acfe4$var$hasOwnProperty.call(value, 'callee') && !$7eab9be1142acfe4$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7eab9be1142acfe4$var$isArguments;

});
parcelRegister("dcLmJ", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $99d1232dfc56e791$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $99d1232dfc56e791$var$baseIsArguments(value) {
    return $3T67E(value) && $1XSz3(value) == $99d1232dfc56e791$var$argsTag;
}
module.exports = $99d1232dfc56e791$var$baseIsArguments;

});
parcelRegister("3T67E", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2d4b41ec2aaf5988$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $2d4b41ec2aaf5988$var$isObjectLike;

});



parcelRegister("1TItY", function(module, exports) {

var $6Ymo5 = parcelRequire("6Ymo5");

var $aR6L2 = parcelRequire("aR6L2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $6Ymo5.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $aR6L2;
module.exports = isBuffer;

});
parcelRegister("aR6L2", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $7e74188bcbe03491$var$stubFalse() {
    return false;
}
module.exports = $7e74188bcbe03491$var$stubFalse;

});


parcelRegister("csxP9", function(module, exports) {
/** Used as references for various `Number` constants. */ var $9122564a4e7b6d93$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9122564a4e7b6d93$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9122564a4e7b6d93$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9122564a4e7b6d93$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9122564a4e7b6d93$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $9122564a4e7b6d93$var$isIndex;

});

parcelRegister("abOQN", function(module, exports) {

var $3z0a6 = parcelRequire("3z0a6");

var $69sKP = parcelRequire("69sKP");

var $j3YM5 = parcelRequire("j3YM5");
/* Node.js helper references. */ var $76b2604f0aac99a2$var$nodeIsTypedArray = $j3YM5 && $j3YM5.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $76b2604f0aac99a2$var$isTypedArray = $76b2604f0aac99a2$var$nodeIsTypedArray ? $69sKP($76b2604f0aac99a2$var$nodeIsTypedArray) : $3z0a6;
module.exports = $76b2604f0aac99a2$var$isTypedArray;

});
parcelRegister("3z0a6", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $d2yQq = parcelRequire("d2yQq");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $2984c42a34dc01d5$var$argsTag = '[object Arguments]', $2984c42a34dc01d5$var$arrayTag = '[object Array]', $2984c42a34dc01d5$var$boolTag = '[object Boolean]', $2984c42a34dc01d5$var$dateTag = '[object Date]', $2984c42a34dc01d5$var$errorTag = '[object Error]', $2984c42a34dc01d5$var$funcTag = '[object Function]', $2984c42a34dc01d5$var$mapTag = '[object Map]', $2984c42a34dc01d5$var$numberTag = '[object Number]', $2984c42a34dc01d5$var$objectTag = '[object Object]', $2984c42a34dc01d5$var$regexpTag = '[object RegExp]', $2984c42a34dc01d5$var$setTag = '[object Set]', $2984c42a34dc01d5$var$stringTag = '[object String]', $2984c42a34dc01d5$var$weakMapTag = '[object WeakMap]';
var $2984c42a34dc01d5$var$arrayBufferTag = '[object ArrayBuffer]', $2984c42a34dc01d5$var$dataViewTag = '[object DataView]', $2984c42a34dc01d5$var$float32Tag = '[object Float32Array]', $2984c42a34dc01d5$var$float64Tag = '[object Float64Array]', $2984c42a34dc01d5$var$int8Tag = '[object Int8Array]', $2984c42a34dc01d5$var$int16Tag = '[object Int16Array]', $2984c42a34dc01d5$var$int32Tag = '[object Int32Array]', $2984c42a34dc01d5$var$uint8Tag = '[object Uint8Array]', $2984c42a34dc01d5$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2984c42a34dc01d5$var$uint16Tag = '[object Uint16Array]', $2984c42a34dc01d5$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $2984c42a34dc01d5$var$typedArrayTags = {};
$2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$float32Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$float64Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$int8Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$int16Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$int32Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$uint8Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$uint8ClampedTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$uint16Tag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$uint32Tag] = true;
$2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$argsTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$arrayTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$arrayBufferTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$boolTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$dataViewTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$dateTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$errorTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$funcTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$mapTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$numberTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$objectTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$regexpTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$setTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$stringTag] = $2984c42a34dc01d5$var$typedArrayTags[$2984c42a34dc01d5$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $2984c42a34dc01d5$var$baseIsTypedArray(value) {
    return $3T67E(value) && $d2yQq(value.length) && !!$2984c42a34dc01d5$var$typedArrayTags[$1XSz3(value)];
}
module.exports = $2984c42a34dc01d5$var$baseIsTypedArray;

});
parcelRegister("d2yQq", function(module, exports) {
/** Used as references for various `Number` constants. */ var $97e67dac88424f9f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $97e67dac88424f9f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $97e67dac88424f9f$var$MAX_SAFE_INTEGER;
}
module.exports = $97e67dac88424f9f$var$isLength;

});


parcelRegister("69sKP", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $47a9e358f9ae73d6$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $47a9e358f9ae73d6$var$baseUnary;

});

parcelRegister("j3YM5", function(module, exports) {

var $8mdfk = parcelRequire("8mdfk");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8mdfk.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("7MNHj", function(module, exports) {

var $6hADJ = parcelRequire("6hADJ");

var $dnDWZ = parcelRequire("dnDWZ");
/** Used for built-in method references. */ var $5ab39105072d0852$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5ab39105072d0852$var$hasOwnProperty = $5ab39105072d0852$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5ab39105072d0852$var$baseKeys(object) {
    if (!$6hADJ(object)) return $dnDWZ(object);
    var result = [];
    for(var key in Object(object))if ($5ab39105072d0852$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $5ab39105072d0852$var$baseKeys;

});
parcelRegister("6hADJ", function(module, exports) {
/** Used for built-in method references. */ var $4930c0804d4c6efb$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $4930c0804d4c6efb$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $4930c0804d4c6efb$var$objectProto;
    return value === proto;
}
module.exports = $4930c0804d4c6efb$var$isPrototype;

});

parcelRegister("dnDWZ", function(module, exports) {

var $1E9vp = parcelRequire("1E9vp");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9bdc69aa485341d3$var$nativeKeys = $1E9vp(Object.keys, Object);
module.exports = $9bdc69aa485341d3$var$nativeKeys;

});
parcelRegister("1E9vp", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $1330e67fa01241df$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $1330e67fa01241df$var$overArg;

});



parcelRegister("d5SgW", function(module, exports) {

var $lOj5y = parcelRequire("lOj5y");

var $d2yQq = parcelRequire("d2yQq");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $9885d759ecf1b19d$var$isArrayLike(value) {
    return value != null && $d2yQq(value.length) && !$lOj5y(value);
}
module.exports = $9885d759ecf1b19d$var$isArrayLike;

});




parcelRegister("4J8KV", function(module, exports) {

var $7nwJU = parcelRequire("7nwJU");

var $3AtHE = parcelRequire("3AtHE");

var $2OSLH = parcelRequire("2OSLH");

var $31PMc = parcelRequire("31PMc");

var $9h1pQ = parcelRequire("9h1pQ");

var $1XSz3 = parcelRequire("1XSz3");

var $Jqx8z = parcelRequire("Jqx8z");
/** `Object#toString` result references. */ var $37122824bf2c8a09$var$mapTag = '[object Map]', $37122824bf2c8a09$var$objectTag = '[object Object]', $37122824bf2c8a09$var$promiseTag = '[object Promise]', $37122824bf2c8a09$var$setTag = '[object Set]', $37122824bf2c8a09$var$weakMapTag = '[object WeakMap]';
var $37122824bf2c8a09$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $37122824bf2c8a09$var$dataViewCtorString = $Jqx8z($7nwJU), $37122824bf2c8a09$var$mapCtorString = $Jqx8z($3AtHE), $37122824bf2c8a09$var$promiseCtorString = $Jqx8z($2OSLH), $37122824bf2c8a09$var$setCtorString = $Jqx8z($31PMc), $37122824bf2c8a09$var$weakMapCtorString = $Jqx8z($9h1pQ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $37122824bf2c8a09$var$getTag = $1XSz3;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($7nwJU && $37122824bf2c8a09$var$getTag(new $7nwJU(new ArrayBuffer(1))) != $37122824bf2c8a09$var$dataViewTag || $3AtHE && $37122824bf2c8a09$var$getTag(new $3AtHE) != $37122824bf2c8a09$var$mapTag || $2OSLH && $37122824bf2c8a09$var$getTag($2OSLH.resolve()) != $37122824bf2c8a09$var$promiseTag || $31PMc && $37122824bf2c8a09$var$getTag(new $31PMc) != $37122824bf2c8a09$var$setTag || $9h1pQ && $37122824bf2c8a09$var$getTag(new $9h1pQ) != $37122824bf2c8a09$var$weakMapTag) $37122824bf2c8a09$var$getTag = function(value) {
    var result = $1XSz3(value), Ctor = result == $37122824bf2c8a09$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $Jqx8z(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $37122824bf2c8a09$var$dataViewCtorString:
            return $37122824bf2c8a09$var$dataViewTag;
        case $37122824bf2c8a09$var$mapCtorString:
            return $37122824bf2c8a09$var$mapTag;
        case $37122824bf2c8a09$var$promiseCtorString:
            return $37122824bf2c8a09$var$promiseTag;
        case $37122824bf2c8a09$var$setCtorString:
            return $37122824bf2c8a09$var$setTag;
        case $37122824bf2c8a09$var$weakMapCtorString:
            return $37122824bf2c8a09$var$weakMapTag;
    }
    return result;
};
module.exports = $37122824bf2c8a09$var$getTag;

});
parcelRegister("7nwJU", function(module, exports) {

var $baxPM = parcelRequire("baxPM");

var $6Ymo5 = parcelRequire("6Ymo5");
/* Built-in method references that are verified to be native. */ var $55f413c203e2f11e$var$DataView = $baxPM($6Ymo5, 'DataView');
module.exports = $55f413c203e2f11e$var$DataView;

});

parcelRegister("2OSLH", function(module, exports) {

var $baxPM = parcelRequire("baxPM");

var $6Ymo5 = parcelRequire("6Ymo5");
/* Built-in method references that are verified to be native. */ var $20dabc1d11f3c158$var$Promise = $baxPM($6Ymo5, 'Promise');
module.exports = $20dabc1d11f3c158$var$Promise;

});

parcelRegister("31PMc", function(module, exports) {

var $baxPM = parcelRequire("baxPM");

var $6Ymo5 = parcelRequire("6Ymo5");
/* Built-in method references that are verified to be native. */ var $2349a0d43e930ace$var$Set = $baxPM($6Ymo5, 'Set');
module.exports = $2349a0d43e930ace$var$Set;

});

parcelRegister("9h1pQ", function(module, exports) {

var $baxPM = parcelRequire("baxPM");

var $6Ymo5 = parcelRequire("6Ymo5");
/* Built-in method references that are verified to be native. */ var $6c06ccbeb2037fe5$var$WeakMap = $baxPM($6Ymo5, 'WeakMap');
module.exports = $6c06ccbeb2037fe5$var$WeakMap;

});





parcelRegister("kIhPT", function(module, exports) {

var $58rIL = parcelRequire("58rIL");

var $7yuIC = parcelRequire("7yuIC");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $f145c08c1cef119d$var$getMatchData(object) {
    var result = $7yuIC(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $58rIL(value)
        ];
    }
    return result;
}
module.exports = $f145c08c1cef119d$var$getMatchData;

});
parcelRegister("58rIL", function(module, exports) {

var $awGqx = parcelRequire("awGqx");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3bd333e80b066080$var$isStrictComparable(value) {
    return value === value && !$awGqx(value);
}
module.exports = $3bd333e80b066080$var$isStrictComparable;

});


parcelRegister("docJm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9bf7644a1bbd2db9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $9bf7644a1bbd2db9$var$matchesStrictComparable;

});


parcelRegister("5jBqZ", function(module, exports) {

var $2Fr8f = parcelRequire("2Fr8f");

var $2BKOF = parcelRequire("2BKOF");

var $BaER2 = parcelRequire("BaER2");

var $eZJM5 = parcelRequire("eZJM5");

var $58rIL = parcelRequire("58rIL");

var $docJm = parcelRequire("docJm");

var $2QKMi = parcelRequire("2QKMi");
/** Used to compose bitmasks for value comparisons. */ var $3debc3c2c19e7f84$var$COMPARE_PARTIAL_FLAG = 1, $3debc3c2c19e7f84$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $3debc3c2c19e7f84$var$baseMatchesProperty(path, srcValue) {
    if ($eZJM5(path) && $58rIL(srcValue)) return $docJm($2QKMi(path), srcValue);
    return function(object) {
        var objValue = $2BKOF(object, path);
        return objValue === undefined && objValue === srcValue ? $BaER2(object, path) : $2Fr8f(srcValue, objValue, $3debc3c2c19e7f84$var$COMPARE_PARTIAL_FLAG | $3debc3c2c19e7f84$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $3debc3c2c19e7f84$var$baseMatchesProperty;

});
parcelRegister("2BKOF", function(module, exports) {

var $kPcq7 = parcelRequire("kPcq7");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $1e635a383599a301$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $kPcq7(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $1e635a383599a301$var$get;

});
parcelRegister("kPcq7", function(module, exports) {

var $8x5Xw = parcelRequire("8x5Xw");

var $2QKMi = parcelRequire("2QKMi");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f292347f638de169$var$baseGet(object, path) {
    path = $8x5Xw(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$2QKMi(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $f292347f638de169$var$baseGet;

});
parcelRegister("8x5Xw", function(module, exports) {

var $lVkdr = parcelRequire("lVkdr");

var $eZJM5 = parcelRequire("eZJM5");

var $c399J = parcelRequire("c399J");

var $cObST = parcelRequire("cObST");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $636607279abddec8$var$castPath(value, object) {
    if ($lVkdr(value)) return value;
    return $eZJM5(value, object) ? [
        value
    ] : $c399J($cObST(value));
}
module.exports = $636607279abddec8$var$castPath;

});
parcelRegister("eZJM5", function(module, exports) {

var $lVkdr = parcelRequire("lVkdr");

var $h7fLv = parcelRequire("h7fLv");
/** Used to match property names within property paths. */ var $aeaa450f41b40aee$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $aeaa450f41b40aee$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $aeaa450f41b40aee$var$isKey(value, object) {
    if ($lVkdr(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $h7fLv(value)) return true;
    return $aeaa450f41b40aee$var$reIsPlainProp.test(value) || !$aeaa450f41b40aee$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $aeaa450f41b40aee$var$isKey;

});
parcelRegister("h7fLv", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $c75f51bc25c5d613$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c75f51bc25c5d613$var$isSymbol(value) {
    return typeof value == 'symbol' || $3T67E(value) && $1XSz3(value) == $c75f51bc25c5d613$var$symbolTag;
}
module.exports = $c75f51bc25c5d613$var$isSymbol;

});


parcelRegister("c399J", function(module, exports) {

var $g5EXa = parcelRequire("g5EXa");
/** Used to match property names within property paths. */ var $8c5cde06640cb6f6$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8c5cde06640cb6f6$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8c5cde06640cb6f6$var$stringToPath = $g5EXa(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($8c5cde06640cb6f6$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8c5cde06640cb6f6$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $8c5cde06640cb6f6$var$stringToPath;

});
parcelRegister("g5EXa", function(module, exports) {

var $8XNPf = parcelRequire("8XNPf");
/** Used as the maximum memoize cache size. */ var $bb6ce17252488324$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $bb6ce17252488324$var$memoizeCapped(func) {
    var result = $8XNPf(func, function(key) {
        if (cache.size === $bb6ce17252488324$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $bb6ce17252488324$var$memoizeCapped;

});
parcelRegister("8XNPf", function(module, exports) {

var $zpcSP = parcelRequire("zpcSP");
/** Error message constants. */ var $686a7bb91044fa40$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $686a7bb91044fa40$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($686a7bb91044fa40$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($686a7bb91044fa40$var$memoize.Cache || $zpcSP);
    return memoized;
}
// Expose `MapCache`.
$686a7bb91044fa40$var$memoize.Cache = $zpcSP;
module.exports = $686a7bb91044fa40$var$memoize;

});



parcelRegister("cObST", function(module, exports) {

var $jiA4I = parcelRequire("jiA4I");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $95335f83526d0159$var$toString(value) {
    return value == null ? '' : $jiA4I(value);
}
module.exports = $95335f83526d0159$var$toString;

});
parcelRegister("jiA4I", function(module, exports) {

var $hS0KO = parcelRequire("hS0KO");

var $2aKdk = parcelRequire("2aKdk");

var $lVkdr = parcelRequire("lVkdr");

var $h7fLv = parcelRequire("h7fLv");
/** Used as references for various `Number` constants. */ var $e0cbae7fd9a7d6f3$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e0cbae7fd9a7d6f3$var$symbolProto = $hS0KO ? $hS0KO.prototype : undefined, $e0cbae7fd9a7d6f3$var$symbolToString = $e0cbae7fd9a7d6f3$var$symbolProto ? $e0cbae7fd9a7d6f3$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e0cbae7fd9a7d6f3$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($lVkdr(value)) // Recursively convert values (susceptible to call stack limits).
    return $2aKdk(value, $e0cbae7fd9a7d6f3$var$baseToString) + '';
    if ($h7fLv(value)) return $e0cbae7fd9a7d6f3$var$symbolToString ? $e0cbae7fd9a7d6f3$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e0cbae7fd9a7d6f3$var$INFINITY ? '-0' : result;
}
module.exports = $e0cbae7fd9a7d6f3$var$baseToString;

});
parcelRegister("2aKdk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $19505d105d18a5ff$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $19505d105d18a5ff$var$arrayMap;

});




parcelRegister("2QKMi", function(module, exports) {

var $h7fLv = parcelRequire("h7fLv");
/** Used as references for various `Number` constants. */ var $2134b936f9f4d6ad$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $2134b936f9f4d6ad$var$toKey(value) {
    if (typeof value == 'string' || $h7fLv(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$2134b936f9f4d6ad$var$INFINITY ? '-0' : result;
}
module.exports = $2134b936f9f4d6ad$var$toKey;

});



parcelRegister("BaER2", function(module, exports) {

var $HfENw = parcelRequire("HfENw");

var $l0irv = parcelRequire("l0irv");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $06fbb942f0a9c08b$var$hasIn(object, path) {
    return object != null && $l0irv(object, path, $HfENw);
}
module.exports = $06fbb942f0a9c08b$var$hasIn;

});
parcelRegister("HfENw", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $0820296d25c0f74a$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $0820296d25c0f74a$var$baseHasIn;

});

parcelRegister("l0irv", function(module, exports) {

var $8x5Xw = parcelRequire("8x5Xw");

var $aSgk4 = parcelRequire("aSgk4");

var $lVkdr = parcelRequire("lVkdr");

var $csxP9 = parcelRequire("csxP9");

var $d2yQq = parcelRequire("d2yQq");

var $2QKMi = parcelRequire("2QKMi");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $f4a7e761b10fb3b4$var$hasPath(object, path, hasFunc) {
    path = $8x5Xw(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $2QKMi(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $d2yQq(length) && $csxP9(key, length) && ($lVkdr(object) || $aSgk4(object));
}
module.exports = $f4a7e761b10fb3b4$var$hasPath;

});



parcelRegister("iaKuz", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d3ad3982f9fb8287$var$identity(value) {
    return value;
}
module.exports = $d3ad3982f9fb8287$var$identity;

});

parcelRegister("eP5pW", function(module, exports) {

var $1YcpG = parcelRequire("1YcpG");

var $2hhQk = parcelRequire("2hhQk");

var $eZJM5 = parcelRequire("eZJM5");

var $2QKMi = parcelRequire("2QKMi");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $acaa07e857824161$var$property(path) {
    return $eZJM5(path) ? $1YcpG($2QKMi(path)) : $2hhQk(path);
}
module.exports = $acaa07e857824161$var$property;

});
parcelRegister("1YcpG", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $16f506082d7c89b8$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $16f506082d7c89b8$var$baseProperty;

});

parcelRegister("2hhQk", function(module, exports) {

var $kPcq7 = parcelRequire("kPcq7");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1a8b028e0902d5d0$var$basePropertyDeep(path) {
    return function(object) {
        return $kPcq7(object, path);
    };
}
module.exports = $1a8b028e0902d5d0$var$basePropertyDeep;

});



parcelRegister("fct8J", function(module, exports) {
/** Error message constants. */ var $b10e948b1eb05c2f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $b10e948b1eb05c2f$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($b10e948b1eb05c2f$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $b10e948b1eb05c2f$var$negate;

});

parcelRegister("lzTOS", function(module, exports) {

var $2aKdk = parcelRequire("2aKdk");

var $3iACh = parcelRequire("3iACh");

var $kImqW = parcelRequire("kImqW");

var $iD6eu = parcelRequire("iD6eu");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $fb582a732652a297$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $2aKdk($iD6eu(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $3iACh(predicate);
    return $kImqW(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $fb582a732652a297$var$pickBy;

});
parcelRegister("kImqW", function(module, exports) {

var $kPcq7 = parcelRequire("kPcq7");

var $g1scD = parcelRequire("g1scD");

var $8x5Xw = parcelRequire("8x5Xw");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $f149518bc01899d5$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $kPcq7(object, path);
        if (predicate(value, path)) $g1scD(result, $8x5Xw(path, object), value);
    }
    return result;
}
module.exports = $f149518bc01899d5$var$basePickBy;

});
parcelRegister("g1scD", function(module, exports) {

var $9UsAL = parcelRequire("9UsAL");

var $8x5Xw = parcelRequire("8x5Xw");

var $csxP9 = parcelRequire("csxP9");

var $awGqx = parcelRequire("awGqx");

var $2QKMi = parcelRequire("2QKMi");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $baa29dce37724763$var$baseSet(object, path, value, customizer) {
    if (!$awGqx(object)) return object;
    path = $8x5Xw(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $2QKMi(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $awGqx(objValue) ? objValue : $csxP9(path[index + 1]) ? [] : {};
        }
        $9UsAL(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $baa29dce37724763$var$baseSet;

});
parcelRegister("9UsAL", function(module, exports) {

var $kbph2 = parcelRequire("kbph2");

var $9agBK = parcelRequire("9agBK");
/** Used for built-in method references. */ var $736f85ceb7dd0cab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $736f85ceb7dd0cab$var$hasOwnProperty = $736f85ceb7dd0cab$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $736f85ceb7dd0cab$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($736f85ceb7dd0cab$var$hasOwnProperty.call(object, key) && $9agBK(objValue, value)) || value === undefined && !(key in object)) $kbph2(object, key, value);
}
module.exports = $736f85ceb7dd0cab$var$assignValue;

});
parcelRegister("kbph2", function(module, exports) {

var $d1Dwn = parcelRequire("d1Dwn");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $eb1870996e079a0f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $d1Dwn) $d1Dwn(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $eb1870996e079a0f$var$baseAssignValue;

});
parcelRegister("d1Dwn", function(module, exports) {

var $baxPM = parcelRequire("baxPM");
var $97ba06738bf76dba$var$defineProperty = function() {
    try {
        var func = $baxPM(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $97ba06738bf76dba$var$defineProperty;

});





parcelRegister("iD6eu", function(module, exports) {

var $g9msS = parcelRequire("g9msS");

var $jfvnD = parcelRequire("jfvnD");

var $jYsOT = parcelRequire("jYsOT");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d900b431f1a99a6d$var$getAllKeysIn(object) {
    return $g9msS(object, $jYsOT, $jfvnD);
}
module.exports = $d900b431f1a99a6d$var$getAllKeysIn;

});
parcelRegister("jfvnD", function(module, exports) {

var $eQjy5 = parcelRequire("eQjy5");

var $18p4I = parcelRequire("18p4I");

var $1sma7 = parcelRequire("1sma7");

var $5ACVB = parcelRequire("5ACVB");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e037c2809659eb06$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e037c2809659eb06$var$getSymbolsIn = !$e037c2809659eb06$var$nativeGetSymbols ? $5ACVB : function(object) {
    var result = [];
    while(object){
        $eQjy5(result, $1sma7(object));
        object = $18p4I(object);
    }
    return result;
};
module.exports = $e037c2809659eb06$var$getSymbolsIn;

});
parcelRegister("18p4I", function(module, exports) {

var $1E9vp = parcelRequire("1E9vp");
/** Built-in value references. */ var $0d39fd2c0a5d94a3$var$getPrototype = $1E9vp(Object.getPrototypeOf, Object);
module.exports = $0d39fd2c0a5d94a3$var$getPrototype;

});


parcelRegister("jYsOT", function(module, exports) {

var $36D8s = parcelRequire("36D8s");

var $fYYJI = parcelRequire("fYYJI");

var $d5SgW = parcelRequire("d5SgW");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e8a9f9f4a8db8bd6$var$keysIn(object) {
    return $d5SgW(object) ? $36D8s(object, true) : $fYYJI(object);
}
module.exports = $e8a9f9f4a8db8bd6$var$keysIn;

});
parcelRegister("fYYJI", function(module, exports) {

var $awGqx = parcelRequire("awGqx");

var $6hADJ = parcelRequire("6hADJ");

var $gKm7v = parcelRequire("gKm7v");
/** Used for built-in method references. */ var $ba2b9297ff993149$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ba2b9297ff993149$var$hasOwnProperty = $ba2b9297ff993149$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ba2b9297ff993149$var$baseKeysIn(object) {
    if (!$awGqx(object)) return $gKm7v(object);
    var isProto = $6hADJ(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$ba2b9297ff993149$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $ba2b9297ff993149$var$baseKeysIn;

});
parcelRegister("gKm7v", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c31219d02397ded7$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $c31219d02397ded7$var$nativeKeysIn;

});






parcelRegister("kl3KV", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsType", () => $cf324d59a40b34fe$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $cf324d59a40b34fe$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $cf324d59a40b34fe$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $cf324d59a40b34fe$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $cf324d59a40b34fe$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $cf324d59a40b34fe$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $cf324d59a40b34fe$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $cf324d59a40b34fe$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $cf324d59a40b34fe$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $cf324d59a40b34fe$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $cf324d59a40b34fe$export$af63d7414243dad3);

var $1LF1E = parcelRequire("1LF1E");

var $lgNi9 = parcelRequire("lgNi9");

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $eu1ij = parcelRequire("eu1ij");

var $eZ8ws = parcelRequire("eZ8ws");
const $cf324d59a40b34fe$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $cf324d59a40b34fe$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $cf324d59a40b34fe$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $cf324d59a40b34fe$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $cf324d59a40b34fe$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($eu1ij)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lgNi9))));
};
const $cf324d59a40b34fe$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'source').filter(Boolean));
const $cf324d59a40b34fe$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $cf324d59a40b34fe$export$6ca3170acb89054 = (event)=>event.payload.action;
const $cf324d59a40b34fe$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $cf324d59a40b34fe$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'containerId').filter(Boolean));
const $cf324d59a40b34fe$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'containerType').filter(Boolean));
const $cf324d59a40b34fe$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'objectId').filter(Boolean));
const $cf324d59a40b34fe$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))($cf324d59a40b34fe$var$extractFromContext(event, 'objectType').filter(Boolean));
const $cf324d59a40b34fe$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))((0, (/*@__PURE__*/$parcel$interopDefault($1LF1E)))($cf324d59a40b34fe$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});
parcelRegister("1LF1E", function(module, exports) {

var $b6Bmc = parcelRequire("b6Bmc");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $149a0111a6cfc1f2$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $b6Bmc(array, 1) : [];
}
module.exports = $149a0111a6cfc1f2$var$flatten;

});
parcelRegister("b6Bmc", function(module, exports) {

var $eQjy5 = parcelRequire("eQjy5");

var $3UtV2 = parcelRequire("3UtV2");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $815d3b9776ea39f9$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $3UtV2);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $815d3b9776ea39f9$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $eQjy5(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $815d3b9776ea39f9$var$baseFlatten;

});
parcelRegister("3UtV2", function(module, exports) {

var $hS0KO = parcelRequire("hS0KO");

var $aSgk4 = parcelRequire("aSgk4");

var $lVkdr = parcelRequire("lVkdr");
/** Built-in value references. */ var $2d8dcf54c6deb70d$var$spreadableSymbol = $hS0KO ? $hS0KO.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $2d8dcf54c6deb70d$var$isFlattenable(value) {
    return $lVkdr(value) || $aSgk4(value) || !!($2d8dcf54c6deb70d$var$spreadableSymbol && value && value[$2d8dcf54c6deb70d$var$spreadableSymbol]);
}
module.exports = $2d8dcf54c6deb70d$var$isFlattenable;

});



parcelRegister("fbpGW", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $b0dbcfeee22379bf$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $b0dbcfeee22379bf$var$last;

});

parcelRegister("euGak", function(module, exports) {

var $l2B1Z = parcelRequire("l2B1Z");

var $b6WiL = parcelRequire("b6WiL");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $a8d4933fcb8feb43$var$merge = $b6WiL(function(object, source, srcIndex) {
    $l2B1Z(object, source, srcIndex);
});
module.exports = $a8d4933fcb8feb43$var$merge;

});
parcelRegister("l2B1Z", function(module, exports) {

var $423Gf = parcelRequire("423Gf");

var $8kgg1 = parcelRequire("8kgg1");

var $fUAkh = parcelRequire("fUAkh");

var $NjEwG = parcelRequire("NjEwG");

var $awGqx = parcelRequire("awGqx");

var $jYsOT = parcelRequire("jYsOT");

var $am5cb = parcelRequire("am5cb");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $03f3f9d8cb32a0ac$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $fUAkh(source, function(srcValue, key) {
        stack || (stack = new $423Gf);
        if ($awGqx(srcValue)) $NjEwG(object, source, key, srcIndex, $03f3f9d8cb32a0ac$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($am5cb(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $8kgg1(object, key, newValue);
        }
    }, $jYsOT);
}
module.exports = $03f3f9d8cb32a0ac$var$baseMerge;

});
parcelRegister("8kgg1", function(module, exports) {

var $kbph2 = parcelRequire("kbph2");

var $9agBK = parcelRequire("9agBK");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $60fccd5ee405951b$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$9agBK(object[key], value) || value === undefined && !(key in object)) $kbph2(object, key, value);
}
module.exports = $60fccd5ee405951b$var$assignMergeValue;

});

parcelRegister("fUAkh", function(module, exports) {

var $9EW5E = parcelRequire("9EW5E");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $b9584391eda24a42$var$baseFor = $9EW5E();
module.exports = $b9584391eda24a42$var$baseFor;

});
parcelRegister("9EW5E", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7084e8fbde617de6$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $7084e8fbde617de6$var$createBaseFor;

});


parcelRegister("NjEwG", function(module, exports) {

var $8kgg1 = parcelRequire("8kgg1");

var $iIWZ6 = parcelRequire("iIWZ6");

var $1iXcA = parcelRequire("1iXcA");

var $gyIaM = parcelRequire("gyIaM");

var $lcEzd = parcelRequire("lcEzd");

var $aSgk4 = parcelRequire("aSgk4");

var $lVkdr = parcelRequire("lVkdr");

var $cqPYt = parcelRequire("cqPYt");

var $1TItY = parcelRequire("1TItY");

var $lOj5y = parcelRequire("lOj5y");

var $awGqx = parcelRequire("awGqx");

var $A2yBp = parcelRequire("A2yBp");

var $abOQN = parcelRequire("abOQN");

var $am5cb = parcelRequire("am5cb");

var $8M4ff = parcelRequire("8M4ff");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $0943d252fbfbcaf6$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $am5cb(object, key), srcValue = $am5cb(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $8kgg1(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $lVkdr(srcValue), isBuff = !isArr && $1TItY(srcValue), isTyped = !isArr && !isBuff && $abOQN(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($lVkdr(objValue)) newValue = objValue;
            else if ($cqPYt(objValue)) newValue = $gyIaM(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $iIWZ6(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $1iXcA(srcValue, true);
            } else newValue = [];
        } else if ($A2yBp(srcValue) || $aSgk4(srcValue)) {
            newValue = objValue;
            if ($aSgk4(objValue)) newValue = $8M4ff(objValue);
            else if (!$awGqx(objValue) || $lOj5y(objValue)) newValue = $lcEzd(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $8kgg1(object, key, newValue);
}
module.exports = $0943d252fbfbcaf6$var$baseMergeDeep;

});
parcelRegister("iIWZ6", function(module, exports) {

var $6Ymo5 = parcelRequire("6Ymo5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $6Ymo5.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("1iXcA", function(module, exports) {

var $kERHM = parcelRequire("kERHM");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $0f35652b214a04df$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $kERHM(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $0f35652b214a04df$var$cloneTypedArray;

});
parcelRegister("kERHM", function(module, exports) {

var $YBIv2 = parcelRequire("YBIv2");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $f0a133cc0bb08d8a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $YBIv2(result).set(new $YBIv2(arrayBuffer));
    return result;
}
module.exports = $f0a133cc0bb08d8a$var$cloneArrayBuffer;

});


parcelRegister("gyIaM", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $c0e2161eb7315d13$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $c0e2161eb7315d13$var$copyArray;

});

parcelRegister("lcEzd", function(module, exports) {

var $krm5d = parcelRequire("krm5d");

var $18p4I = parcelRequire("18p4I");

var $6hADJ = parcelRequire("6hADJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f6fa2fbc7646f43c$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$6hADJ(object) ? $krm5d($18p4I(object)) : {};
}
module.exports = $f6fa2fbc7646f43c$var$initCloneObject;

});
parcelRegister("krm5d", function(module, exports) {

var $awGqx = parcelRequire("awGqx");
/** Built-in value references. */ var $ee17758150bc8251$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ee17758150bc8251$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$awGqx(proto)) return {};
        if ($ee17758150bc8251$var$objectCreate) return $ee17758150bc8251$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $ee17758150bc8251$var$baseCreate;

});


parcelRegister("cqPYt", function(module, exports) {

var $d5SgW = parcelRequire("d5SgW");

var $3T67E = parcelRequire("3T67E");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $90d03acb06568a41$var$isArrayLikeObject(value) {
    return $3T67E(value) && $d5SgW(value);
}
module.exports = $90d03acb06568a41$var$isArrayLikeObject;

});

parcelRegister("A2yBp", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $18p4I = parcelRequire("18p4I");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $06c558b1f0d8892d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $06c558b1f0d8892d$var$funcProto = Function.prototype, $06c558b1f0d8892d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $06c558b1f0d8892d$var$funcToString = $06c558b1f0d8892d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $06c558b1f0d8892d$var$hasOwnProperty = $06c558b1f0d8892d$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $06c558b1f0d8892d$var$objectCtorString = $06c558b1f0d8892d$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $06c558b1f0d8892d$var$isPlainObject(value) {
    if (!$3T67E(value) || $1XSz3(value) != $06c558b1f0d8892d$var$objectTag) return false;
    var proto = $18p4I(value);
    if (proto === null) return true;
    var Ctor = $06c558b1f0d8892d$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $06c558b1f0d8892d$var$funcToString.call(Ctor) == $06c558b1f0d8892d$var$objectCtorString;
}
module.exports = $06c558b1f0d8892d$var$isPlainObject;

});

parcelRegister("am5cb", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $789ffd27f02b4c29$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $789ffd27f02b4c29$var$safeGet;

});

parcelRegister("8M4ff", function(module, exports) {

var $dSpzt = parcelRequire("dSpzt");

var $jYsOT = parcelRequire("jYsOT");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $66361964366e525e$var$toPlainObject(value) {
    return $dSpzt(value, $jYsOT(value));
}
module.exports = $66361964366e525e$var$toPlainObject;

});
parcelRegister("dSpzt", function(module, exports) {

var $9UsAL = parcelRequire("9UsAL");

var $kbph2 = parcelRequire("kbph2");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $a1a42764f674e614$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $kbph2(object, key, newValue);
        else $9UsAL(object, key, newValue);
    }
    return object;
}
module.exports = $a1a42764f674e614$var$copyObject;

});




parcelRegister("b6WiL", function(module, exports) {

var $Hbxkm = parcelRequire("Hbxkm");

var $jIpbb = parcelRequire("jIpbb");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $816d7abbd0a23185$var$createAssigner(assigner) {
    return $Hbxkm(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $jIpbb(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $816d7abbd0a23185$var$createAssigner;

});
parcelRegister("Hbxkm", function(module, exports) {

var $iaKuz = parcelRequire("iaKuz");

var $f1mpg = parcelRequire("f1mpg");

var $jCUSj = parcelRequire("jCUSj");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $081cf72ed968a3d9$var$baseRest(func, start) {
    return $jCUSj($f1mpg(func, start, $iaKuz), func + '');
}
module.exports = $081cf72ed968a3d9$var$baseRest;

});
parcelRegister("f1mpg", function(module, exports) {

var $6JMW5 = parcelRequire("6JMW5");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $aef854788ae0c340$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $aef854788ae0c340$var$overRest(func, start, transform) {
    start = $aef854788ae0c340$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $aef854788ae0c340$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $6JMW5(func, this, otherArgs);
    };
}
module.exports = $aef854788ae0c340$var$overRest;

});
parcelRegister("6JMW5", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $4e7ce7ac4ba18d50$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $4e7ce7ac4ba18d50$var$apply;

});


parcelRegister("jCUSj", function(module, exports) {

var $g1w4I = parcelRequire("g1w4I");

var $1XT0M = parcelRequire("1XT0M");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e49daf191754cc0d$var$setToString = $1XT0M($g1w4I);
module.exports = $e49daf191754cc0d$var$setToString;

});
parcelRegister("g1w4I", function(module, exports) {

var $bcmro = parcelRequire("bcmro");

var $d1Dwn = parcelRequire("d1Dwn");

var $iaKuz = parcelRequire("iaKuz");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $baa59ec3a3f68ae1$var$baseSetToString = !$d1Dwn ? $iaKuz : function(func, string) {
    return $d1Dwn(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $bcmro(string),
        'writable': true
    });
};
module.exports = $baa59ec3a3f68ae1$var$baseSetToString;

});
parcelRegister("bcmro", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $827238f6b0ba78c2$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $827238f6b0ba78c2$var$constant;

});


parcelRegister("1XT0M", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $16e5f9436577886f$var$HOT_COUNT = 800, $16e5f9436577886f$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $16e5f9436577886f$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $16e5f9436577886f$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $16e5f9436577886f$var$nativeNow(), remaining = $16e5f9436577886f$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $16e5f9436577886f$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $16e5f9436577886f$var$shortOut;

});



parcelRegister("jIpbb", function(module, exports) {

var $9agBK = parcelRequire("9agBK");

var $d5SgW = parcelRequire("d5SgW");

var $csxP9 = parcelRequire("csxP9");

var $awGqx = parcelRequire("awGqx");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $e5a5a87e3325caf9$var$isIterateeCall(value, index, object) {
    if (!$awGqx(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $d5SgW(object) && $csxP9(index, object.length) : type == 'string' && index in object) return $9agBK(object[index], value);
    return false;
}
module.exports = $e5a5a87e3325caf9$var$isIterateeCall;

});



parcelRegister("eZ8ws", function(module, exports) {

var $6WohZ = parcelRequire("6WohZ");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $ae8d5f9965c092f1$var$uniq(array) {
    return array && array.length ? $6WohZ(array) : [];
}
module.exports = $ae8d5f9965c092f1$var$uniq;

});
parcelRegister("6WohZ", function(module, exports) {

var $4ZLTW = parcelRequire("4ZLTW");

var $jOuEU = parcelRequire("jOuEU");

var $drjad = parcelRequire("drjad");

var $1C2YK = parcelRequire("1C2YK");

var $5rmp0 = parcelRequire("5rmp0");

var $hqHbJ = parcelRequire("hqHbJ");
/** Used as the size to enable large array optimizations. */ var $50db002a5d998a80$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $50db002a5d998a80$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $jOuEU, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $drjad;
    } else if (length >= $50db002a5d998a80$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5rmp0(array);
        if (set) return $hqHbJ(set);
        isCommon = false;
        includes = $1C2YK;
        seen = new $4ZLTW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $50db002a5d998a80$var$baseUniq;

});
parcelRegister("jOuEU", function(module, exports) {

var $kpKwN = parcelRequire("kpKwN");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e6ca7808e0a345ff$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $kpKwN(array, value, 0) > -1;
}
module.exports = $e6ca7808e0a345ff$var$arrayIncludes;

});
parcelRegister("kpKwN", function(module, exports) {

var $czhsm = parcelRequire("czhsm");

var $gGez1 = parcelRequire("gGez1");

var $ciMVn = parcelRequire("ciMVn");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $edca3beea0ed2ffd$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $ciMVn(array, value, fromIndex) : $czhsm(array, $gGez1, fromIndex);
}
module.exports = $edca3beea0ed2ffd$var$baseIndexOf;

});
parcelRegister("czhsm", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $92664b6ce2140b84$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $92664b6ce2140b84$var$baseFindIndex;

});

parcelRegister("gGez1", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c24bddae78214525$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c24bddae78214525$var$baseIsNaN;

});

parcelRegister("ciMVn", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8f4d1dd9c5fa9026$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $8f4d1dd9c5fa9026$var$strictIndexOf;

});



parcelRegister("drjad", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $9c8ca985951042dc$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $9c8ca985951042dc$var$arrayIncludesWith;

});

parcelRegister("5rmp0", function(module, exports) {

var $31PMc = parcelRequire("31PMc");

var $fI1BQ = parcelRequire("fI1BQ");

var $hqHbJ = parcelRequire("hqHbJ");
/** Used as references for various `Number` constants. */ var $3f60da02ef7c3100$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3f60da02ef7c3100$var$createSet = !($31PMc && 1 / $hqHbJ(new $31PMc([
    ,
    -0
]))[1] == $3f60da02ef7c3100$var$INFINITY) ? $fI1BQ : function(values) {
    return new $31PMc(values);
};
module.exports = $3f60da02ef7c3100$var$createSet;

});
parcelRegister("fI1BQ", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $b6fc36a56f9905a0$var$noop() {
// No operation performed.
}
module.exports = $b6fc36a56f9905a0$var$noop;

});






parcelRegister("haAAx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = module.exports.OPERATIONAL_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = module.exports.UI_EVENT_TYPE = module.exports.getEvent = module.exports.MountEvent = module.exports.fireAnalyticsEvent = module.exports.withAnalyticsContext = module.exports.AnalyticsContext = module.exports.EventTypes = module.exports.ScreenTypes = undefined;

var $9JXaU = parcelRequire("9JXaU");
Object.defineProperty(module.exports, 'ScreenTypes', {
    enumerable: true,
    get: function get() {
        return $9JXaU.ScreenTypes;
    }
});
Object.defineProperty(module.exports, 'EventTypes', {
    enumerable: true,
    get: function get() {
        return $9JXaU.EventTypes;
    }
});
Object.defineProperty(module.exports, 'UI_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9JXaU.UI_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'TRACK_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9JXaU.TRACK_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'SCREEN_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9JXaU.SCREEN_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'OPERATIONAL_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9JXaU.OPERATIONAL_EVENT_TYPE;
    }
});

var $daph8 = parcelRequire("daph8");
Object.defineProperty(module.exports, 'createTestEvent', {
    enumerable: true,
    get: function get() {
        return $daph8.createTestEvent;
    }
});

var $8vCJI = parcelRequire("8vCJI");
var $c7ffc08a2888d986$var$_analyticsContext2 = $c7ffc08a2888d986$var$_interopRequireDefault($8vCJI);

var $1oSqe = parcelRequire("1oSqe");
var $c7ffc08a2888d986$var$_mountEvent2 = $c7ffc08a2888d986$var$_interopRequireDefault($1oSqe);

var $2bDgh = parcelRequire("2bDgh");
var $c7ffc08a2888d986$var$_withAnalyticsContext2 = $c7ffc08a2888d986$var$_interopRequireDefault($2bDgh);

var $gkrv1 = parcelRequire("gkrv1");
var $c7ffc08a2888d986$var$_fireAnalyticsEvent2 = $c7ffc08a2888d986$var$_interopRequireDefault($gkrv1);

var $iTeBn = parcelRequire("iTeBn");
var $c7ffc08a2888d986$var$_getEventForWebClient2 = $c7ffc08a2888d986$var$_interopRequireDefault($iTeBn);
function $c7ffc08a2888d986$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.AnalyticsContext = $c7ffc08a2888d986$var$_analyticsContext2.default;
module.exports.withAnalyticsContext = $c7ffc08a2888d986$var$_withAnalyticsContext2.default;
module.exports.fireAnalyticsEvent = $c7ffc08a2888d986$var$_fireAnalyticsEvent2.default;
module.exports.MountEvent = $c7ffc08a2888d986$var$_mountEvent2.default;
module.exports.getEvent = $c7ffc08a2888d986$var$_getEventForWebClient2.default;

});
parcelRegister("9JXaU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ var $717637ec4587eaba$var$UI_EVENT_TYPE = module.exports.UI_EVENT_TYPE = 'UI';
var $717637ec4587eaba$var$TRACK_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = 'TRACK';
var $717637ec4587eaba$var$SCREEN_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = 'SCREEN';
var $717637ec4587eaba$var$OPERATIONAL_EVENT_TYPE = module.exports.OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';
/**
 * END ANALYTICS WEB CLIENT EVENTS
 */ var $717637ec4587eaba$var$PAGE_EVENT_ACTION = module.exports.PAGE_EVENT_ACTION = 'page-view';
var $717637ec4587eaba$var$SCREEN = module.exports.SCREEN = 'Screen';
var $717637ec4587eaba$var$DRAWER = module.exports.DRAWER = 'Drawer';
var $717637ec4587eaba$var$MODAL = module.exports.MODAL = 'Modal';
var $717637ec4587eaba$var$INLINE_DIALOG = module.exports.INLINE_DIALOG = 'InlineDialog';
var $717637ec4587eaba$var$DROPDOWN = module.exports.DROPDOWN = 'Dropdown';
var $717637ec4587eaba$var$ScreenTypes = module.exports.ScreenTypes = {
    SCREEN: $717637ec4587eaba$var$SCREEN,
    MODAL: $717637ec4587eaba$var$MODAL,
    DRAWER: $717637ec4587eaba$var$DRAWER,
    INLINE_DIALOG: $717637ec4587eaba$var$INLINE_DIALOG,
    DROPDOWN: $717637ec4587eaba$var$DROPDOWN
};
var $717637ec4587eaba$var$EventTypes = module.exports.EventTypes = {
    UI: $717637ec4587eaba$var$UI_EVENT_TYPE,
    TRACK: $717637ec4587eaba$var$TRACK_EVENT_TYPE,
    SCREEN: $717637ec4587eaba$var$SCREEN_EVENT_TYPE,
    OPERATIONAL: $717637ec4587eaba$var$OPERATIONAL_EVENT_TYPE
};

});

parcelRegister("daph8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = undefined;

var $hCYNe = parcelRequire("hCYNe");
var $995fd0b1800398d5$var$createTestEvent = module.exports.createTestEvent = function createTestEvent() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        payload: {
            action: 'thisIsADumyAction'
        }
    };
    return new $hCYNe.default(payload);
};

});
parcelRegister("hCYNe", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b04fb9fbd823d83$export$2e2bcd8739ae039);
/// <reference types="node" />

var $ddgXE = parcelRequire("ddgXE");
class $3b04fb9fbd823d83$export$2e2bcd8739ae039 extends (0, $ddgXE.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $3b04fb9fbd823d83$var$clonePayload(this.payload);
            return new $3b04fb9fbd823d83$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $3b04fb9fbd823d83$var$clonePayload = (payload)=>{
    try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
};

});
parcelRegister("ddgXE", function(module, exports) {
$parcel$export(module.exports, "default", () => $58353e21587817e3$export$2e2bcd8739ae039);
class $58353e21587817e3$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $58353e21587817e3$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});



parcelRegister("8vCJI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7cqhy = parcelRequire("7cqhy");
var $631f4434a2898e04$var$_getPrototypeOf2 = $631f4434a2898e04$var$_interopRequireDefault($7cqhy);

var $ixHVX = parcelRequire("ixHVX");
var $631f4434a2898e04$var$_classCallCheck3 = $631f4434a2898e04$var$_interopRequireDefault($ixHVX);

var $egcHh = parcelRequire("egcHh");
var $631f4434a2898e04$var$_createClass3 = $631f4434a2898e04$var$_interopRequireDefault($egcHh);

var $lMtgs = parcelRequire("lMtgs");
var $631f4434a2898e04$var$_possibleConstructorReturn3 = $631f4434a2898e04$var$_interopRequireDefault($lMtgs);

var $4BCLx = parcelRequire("4BCLx");
var $631f4434a2898e04$var$_inherits3 = $631f4434a2898e04$var$_interopRequireDefault($4BCLx);

var $bSJIT = parcelRequire("bSJIT");
var $631f4434a2898e04$var$_react2 = $631f4434a2898e04$var$_interopRequireDefault($bSJIT);

var $dwOcU = parcelRequire("dwOcU");

var $l24PT = parcelRequire("l24PT");
var $631f4434a2898e04$var$_createContextData2 = $631f4434a2898e04$var$_interopRequireDefault($l24PT);
function $631f4434a2898e04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $631f4434a2898e04$var$AnalyticsContextWrapper = function(_Component) {
    (0, $631f4434a2898e04$var$_inherits3.default)(AnalyticsContextWrapper, _Component);
    function AnalyticsContextWrapper() {
        (0, $631f4434a2898e04$var$_classCallCheck3.default)(this, AnalyticsContextWrapper);
        return (0, $631f4434a2898e04$var$_possibleConstructorReturn3.default)(this, (AnalyticsContextWrapper.__proto__ || (0, $631f4434a2898e04$var$_getPrototypeOf2.default)(AnalyticsContextWrapper)).apply(this, arguments));
    }
    (0, $631f4434a2898e04$var$_createClass3.default)(AnalyticsContextWrapper, [
        {
            key: 'render',
            value: function render() {
                var data = (0, $631f4434a2898e04$var$_createContextData2.default)(this.props);
                return $631f4434a2898e04$var$_react2.default.createElement($dwOcU.default, {
                    data: data
                }, this.props.children);
            }
        }
    ]);
    return AnalyticsContextWrapper;
}($bSJIT.Component);
module.exports.default = $631f4434a2898e04$var$AnalyticsContextWrapper;

});
parcelRegister("7cqhy", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bphly")),
    __esModule: true
};

});
parcelRegister("bphly", function(module, exports) {
parcelRequire("MeMko");

module.exports = (parcelRequire("1HZ59")).Object.getPrototypeOf;

});
parcelRegister("MeMko", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $e2Lb8 = parcelRequire("e2Lb8");

var $gcjmE = parcelRequire("gcjmE");

(parcelRequire("tqMnf"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $gcjmE($e2Lb8(it));
    };
});

});
parcelRegister("e2Lb8", function(module, exports) {
// 7.1.13 ToObject(argument)

var $5a32e = parcelRequire("5a32e");
module.exports = function(it) {
    return Object($5a32e(it));
};

});
parcelRegister("5a32e", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("gcjmE", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $8loko = parcelRequire("8loko");

var $e2Lb8 = parcelRequire("e2Lb8");

var $bcacc9b1512fcdc0$var$IE_PROTO = (parcelRequire("70XNy"))('IE_PROTO');
var $bcacc9b1512fcdc0$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $e2Lb8(O);
    if ($8loko(O, $bcacc9b1512fcdc0$var$IE_PROTO)) return O[$bcacc9b1512fcdc0$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $bcacc9b1512fcdc0$var$ObjectProto : null;
};

});
parcelRegister("8loko", function(module, exports) {
var $613327eded31f5c2$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $613327eded31f5c2$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("70XNy", function(module, exports) {

var $51b6eb28fb07fdd7$var$shared = (parcelRequire("8xrTN"))('keys');

var $fuRIv = parcelRequire("fuRIv");
module.exports = function(key) {
    return $51b6eb28fb07fdd7$var$shared[key] || ($51b6eb28fb07fdd7$var$shared[key] = $fuRIv(key));
};

});
parcelRegister("8xrTN", function(module, exports) {

var $1HZ59 = parcelRequire("1HZ59");

var $esmOq = parcelRequire("esmOq");
var $63770bf35cf2b8ed$var$SHARED = '__core-js_shared__';
var $63770bf35cf2b8ed$var$store = $esmOq[$63770bf35cf2b8ed$var$SHARED] || ($esmOq[$63770bf35cf2b8ed$var$SHARED] = {});

(module.exports = function(key, value) {
    return $63770bf35cf2b8ed$var$store[key] || ($63770bf35cf2b8ed$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $1HZ59.version,
    mode: (parcelRequire("la1Rh")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("1HZ59", function(module, exports) {
var $13e9303d1150570f$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $13e9303d1150570f$var$core; // eslint-disable-line no-undef

});

parcelRegister("esmOq", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $a86560416fac591c$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $a86560416fac591c$var$global; // eslint-disable-line no-undef

});

parcelRegister("la1Rh", function(module, exports) {
module.exports = true;

});


parcelRegister("fuRIv", function(module, exports) {
var $b4835367807b62f7$var$id = 0;
var $b4835367807b62f7$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$b4835367807b62f7$var$id + $b4835367807b62f7$var$px).toString(36));
};

});



parcelRegister("tqMnf", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $8Npjj = parcelRequire("8Npjj");

var $1HZ59 = parcelRequire("1HZ59");

var $guisY = parcelRequire("guisY");
module.exports = function(KEY, exec) {
    var fn = ($1HZ59.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $8Npjj($8Npjj.S + $8Npjj.F * $guisY(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("8Npjj", function(module, exports) {

var $esmOq = parcelRequire("esmOq");

var $1HZ59 = parcelRequire("1HZ59");

var $2csxj = parcelRequire("2csxj");

var $go7wy = parcelRequire("go7wy");

var $8loko = parcelRequire("8loko");
var $667688786cb745c2$var$PROTOTYPE = 'prototype';
var $667688786cb745c2$var$$export = function(type, name, source) {
    var IS_FORCED = type & $667688786cb745c2$var$$export.F;
    var IS_GLOBAL = type & $667688786cb745c2$var$$export.G;
    var IS_STATIC = type & $667688786cb745c2$var$$export.S;
    var IS_PROTO = type & $667688786cb745c2$var$$export.P;
    var IS_BIND = type & $667688786cb745c2$var$$export.B;
    var IS_WRAP = type & $667688786cb745c2$var$$export.W;
    var exports = IS_GLOBAL ? $1HZ59 : $1HZ59[name] || ($1HZ59[name] = {});
    var expProto = exports[$667688786cb745c2$var$PROTOTYPE];
    var target = IS_GLOBAL ? $esmOq : IS_STATIC ? $esmOq[name] : ($esmOq[name] || {})[$667688786cb745c2$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8loko(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $2csxj(out, $esmOq) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$667688786cb745c2$var$PROTOTYPE] = C[$667688786cb745c2$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $2csxj(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $667688786cb745c2$var$$export.R && expProto && !expProto[key]) $go7wy(expProto, key, out);
        }
    }
};
// type bitmap
$667688786cb745c2$var$$export.F = 1; // forced
$667688786cb745c2$var$$export.G = 2; // global
$667688786cb745c2$var$$export.S = 4; // static
$667688786cb745c2$var$$export.P = 8; // proto
$667688786cb745c2$var$$export.B = 16; // bind
$667688786cb745c2$var$$export.W = 32; // wrap
$667688786cb745c2$var$$export.U = 64; // safe
$667688786cb745c2$var$$export.R = 128; // real proto method for `library`
module.exports = $667688786cb745c2$var$$export;

});
parcelRegister("2csxj", function(module, exports) {
// optional / simple context binding

var $5buu8 = parcelRequire("5buu8");
module.exports = function(fn, that, length) {
    $5buu8(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("5buu8", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("go7wy", function(module, exports) {

var $cFBNB = parcelRequire("cFBNB");

var $2PkKJ = parcelRequire("2PkKJ");

module.exports = (parcelRequire("hnpt5")) ? function(object, key, value) {
    return $cFBNB.f(object, key, $2PkKJ(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("cFBNB", function(module, exports) {
$parcel$export(module.exports, "f", () => $9396a27d3ea21f59$export$2d1720544b23b823, (v) => $9396a27d3ea21f59$export$2d1720544b23b823 = v);
var $9396a27d3ea21f59$export$2d1720544b23b823;

var $kjl0L = parcelRequire("kjl0L");

var $4rUDE = parcelRequire("4rUDE");

var $hbeKd = parcelRequire("hbeKd");
var $9396a27d3ea21f59$var$dP = Object.defineProperty;

$9396a27d3ea21f59$export$2d1720544b23b823 = (parcelRequire("hnpt5")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $kjl0L(O);
    P = $hbeKd(P, true);
    $kjl0L(Attributes);
    if ($4rUDE) try {
        return $9396a27d3ea21f59$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("kjl0L", function(module, exports) {

var $gImMz = parcelRequire("gImMz");
module.exports = function(it) {
    if (!$gImMz(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("gImMz", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("4rUDE", function(module, exports) {



module.exports = !(parcelRequire("hnpt5")) && !(parcelRequire("guisY"))(function() {
    return Object.defineProperty((parcelRequire("dhnAG"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("hnpt5", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("guisY"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("guisY", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("dhnAG", function(module, exports) {

var $gImMz = parcelRequire("gImMz");

var $esmOq = parcelRequire("esmOq");
var $9aaf29854d4996aa$require$document = $esmOq.document;
// typeof document.createElement is 'object' in old IE
var $9aaf29854d4996aa$var$is = $gImMz($9aaf29854d4996aa$require$document) && $gImMz($9aaf29854d4996aa$require$document.createElement);
module.exports = function(it) {
    return $9aaf29854d4996aa$var$is ? $9aaf29854d4996aa$require$document.createElement(it) : {};
};

});


parcelRegister("hbeKd", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $gImMz = parcelRequire("gImMz");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$gImMz(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$gImMz(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$gImMz(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$gImMz(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("2PkKJ", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("ixHVX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $d7fd636c6bfbc937$export$1e511d4a378977f5, (v) => $d7fd636c6bfbc937$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d7fd636c6bfbc937$export$2e2bcd8739ae039, (v) => $d7fd636c6bfbc937$export$2e2bcd8739ae039 = v);
var $d7fd636c6bfbc937$export$1e511d4a378977f5;
var $d7fd636c6bfbc937$export$2e2bcd8739ae039;
"use strict";
$d7fd636c6bfbc937$export$1e511d4a378977f5 = true;
$d7fd636c6bfbc937$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("egcHh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $a61c68a9b205602b$export$1e511d4a378977f5, (v) => $a61c68a9b205602b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $a61c68a9b205602b$export$2e2bcd8739ae039, (v) => $a61c68a9b205602b$export$2e2bcd8739ae039 = v);
var $a61c68a9b205602b$export$1e511d4a378977f5;
var $a61c68a9b205602b$export$2e2bcd8739ae039;
"use strict";
$a61c68a9b205602b$export$1e511d4a378977f5 = true;

var $6D6Ja = parcelRequire("6D6Ja");
var $a61c68a9b205602b$var$_defineProperty2 = $a61c68a9b205602b$var$_interopRequireDefault($6D6Ja);
function $a61c68a9b205602b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a61c68a9b205602b$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $a61c68a9b205602b$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("6D6Ja", function(module, exports) {

module.exports = {
    "default": (parcelRequire("j2krv")),
    __esModule: true
};

});
parcelRegister("j2krv", function(module, exports) {
parcelRequire("dZGEQ");

var $1HZ59 = parcelRequire("1HZ59");
var $ddbe0fb1d11f2565$require$$Object = $1HZ59.Object;
module.exports = function defineProperty(it, key, desc) {
    return $ddbe0fb1d11f2565$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("dZGEQ", function(module, exports) {

var $8Npjj = parcelRequire("8Npjj");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$8Npjj($8Npjj.S + $8Npjj.F * !(parcelRequire("hnpt5")), 'Object', {
    defineProperty: (parcelRequire("cFBNB")).f
});

});




parcelRegister("lMtgs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $fdb4c8000526d9c1$export$1e511d4a378977f5, (v) => $fdb4c8000526d9c1$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $fdb4c8000526d9c1$export$2e2bcd8739ae039, (v) => $fdb4c8000526d9c1$export$2e2bcd8739ae039 = v);
var $fdb4c8000526d9c1$export$1e511d4a378977f5;
var $fdb4c8000526d9c1$export$2e2bcd8739ae039;
"use strict";
$fdb4c8000526d9c1$export$1e511d4a378977f5 = true;

var $jc9BX = parcelRequire("jc9BX");
var $fdb4c8000526d9c1$var$_typeof3 = $fdb4c8000526d9c1$var$_interopRequireDefault($jc9BX);
function $fdb4c8000526d9c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$fdb4c8000526d9c1$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $fdb4c8000526d9c1$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("jc9BX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $df9697e028e7ec5a$export$1e511d4a378977f5, (v) => $df9697e028e7ec5a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $df9697e028e7ec5a$export$2e2bcd8739ae039, (v) => $df9697e028e7ec5a$export$2e2bcd8739ae039 = v);
var $df9697e028e7ec5a$export$1e511d4a378977f5;
var $df9697e028e7ec5a$export$2e2bcd8739ae039;
"use strict";
$df9697e028e7ec5a$export$1e511d4a378977f5 = true;

var $h3pIh = parcelRequire("h3pIh");
var $df9697e028e7ec5a$var$_iterator2 = $df9697e028e7ec5a$var$_interopRequireDefault($h3pIh);

var $7763p = parcelRequire("7763p");
var $df9697e028e7ec5a$var$_symbol2 = $df9697e028e7ec5a$var$_interopRequireDefault($7763p);
var $df9697e028e7ec5a$var$_typeof = typeof $df9697e028e7ec5a$var$_symbol2.default === "function" && typeof $df9697e028e7ec5a$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $df9697e028e7ec5a$var$_symbol2.default === "function" && obj.constructor === $df9697e028e7ec5a$var$_symbol2.default && obj !== $df9697e028e7ec5a$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $df9697e028e7ec5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$df9697e028e7ec5a$export$2e2bcd8739ae039 = typeof $df9697e028e7ec5a$var$_symbol2.default === "function" && $df9697e028e7ec5a$var$_typeof($df9697e028e7ec5a$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $df9697e028e7ec5a$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $df9697e028e7ec5a$var$_symbol2.default === "function" && obj.constructor === $df9697e028e7ec5a$var$_symbol2.default && obj !== $df9697e028e7ec5a$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $df9697e028e7ec5a$var$_typeof(obj);
};

});
parcelRegister("h3pIh", function(module, exports) {

module.exports = {
    "default": (parcelRequire("lnLFJ")),
    __esModule: true
};

});
parcelRegister("lnLFJ", function(module, exports) {
parcelRequire("hZFTI");
parcelRequire("bwy2O");

module.exports = (parcelRequire("jlEg5")).f('iterator');

});
parcelRegister("hZFTI", function(module, exports) {
'use strict';

var $d198a2317e3d2ddd$var$$at = (parcelRequire("PqW4h"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("gP3iI"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $d198a2317e3d2ddd$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("PqW4h", function(module, exports) {

var $5oGDw = parcelRequire("5oGDw");

var $5a32e = parcelRequire("5a32e");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($5a32e(that));
        var i = $5oGDw(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("5oGDw", function(module, exports) {
// 7.1.4 ToInteger
var $3ee04459c9ef35c3$var$ceil = Math.ceil;
var $3ee04459c9ef35c3$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $3ee04459c9ef35c3$var$floor : $3ee04459c9ef35c3$var$ceil)(it);
};

});


parcelRegister("gP3iI", function(module, exports) {
'use strict';

var $la1Rh = parcelRequire("la1Rh");

var $8Npjj = parcelRequire("8Npjj");

var $dW8L7 = parcelRequire("dW8L7");

var $go7wy = parcelRequire("go7wy");

var $hPYrH = parcelRequire("hPYrH");

var $l3i4Z = parcelRequire("l3i4Z");

var $57sRH = parcelRequire("57sRH");

var $gcjmE = parcelRequire("gcjmE");

var $c3f3f83a333f6b8b$var$ITERATOR = (parcelRequire("jZpTE"))('iterator');
var $c3f3f83a333f6b8b$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $c3f3f83a333f6b8b$var$FF_ITERATOR = '@@iterator';
var $c3f3f83a333f6b8b$var$KEYS = 'keys';
var $c3f3f83a333f6b8b$var$VALUES = 'values';
var $c3f3f83a333f6b8b$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $l3i4Z(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$c3f3f83a333f6b8b$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $c3f3f83a333f6b8b$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $c3f3f83a333f6b8b$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $c3f3f83a333f6b8b$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$c3f3f83a333f6b8b$var$ITERATOR] || proto[$c3f3f83a333f6b8b$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $gcjmE($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $57sRH(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$la1Rh && typeof IteratorPrototype[$c3f3f83a333f6b8b$var$ITERATOR] != 'function') $go7wy(IteratorPrototype, $c3f3f83a333f6b8b$var$ITERATOR, $c3f3f83a333f6b8b$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $c3f3f83a333f6b8b$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$la1Rh || FORCED) && ($c3f3f83a333f6b8b$var$BUGGY || VALUES_BUG || !proto[$c3f3f83a333f6b8b$var$ITERATOR])) $go7wy(proto, $c3f3f83a333f6b8b$var$ITERATOR, $default);
    // Plug for library
    $hPYrH[NAME] = $default;
    $hPYrH[TAG] = $c3f3f83a333f6b8b$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($c3f3f83a333f6b8b$var$VALUES),
            keys: IS_SET ? $default : getMethod($c3f3f83a333f6b8b$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $dW8L7(proto, key, methods[key]);
        } else $8Npjj($8Npjj.P + $8Npjj.F * ($c3f3f83a333f6b8b$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("dW8L7", function(module, exports) {

module.exports = (parcelRequire("go7wy"));

});

parcelRegister("hPYrH", function(module, exports) {
module.exports = {};

});

parcelRegister("l3i4Z", function(module, exports) {
'use strict';

var $k9rWp = parcelRequire("k9rWp");

var $2PkKJ = parcelRequire("2PkKJ");

var $57sRH = parcelRequire("57sRH");
var $f537e6f93c064d6e$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("go7wy"))($f537e6f93c064d6e$var$IteratorPrototype, (parcelRequire("jZpTE"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $k9rWp($f537e6f93c064d6e$var$IteratorPrototype, {
        next: $2PkKJ(1, next)
    });
    $57sRH(Constructor, NAME + ' Iterator');
};

});
parcelRegister("k9rWp", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $kjl0L = parcelRequire("kjl0L");

var $dtj15 = parcelRequire("dtj15");

var $1C8sU = parcelRequire("1C8sU");

var $eaba5269630bb834$var$IE_PROTO = (parcelRequire("70XNy"))('IE_PROTO');
var $eaba5269630bb834$var$Empty = function() {};
var $eaba5269630bb834$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $eaba5269630bb834$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("dhnAG"))('iframe');
    var i = $1C8sU.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("exEx3")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $eaba5269630bb834$var$createDict = iframeDocument.F;
    while(i--)delete $eaba5269630bb834$var$createDict[$eaba5269630bb834$var$PROTOTYPE][$1C8sU[i]];
    return $eaba5269630bb834$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $eaba5269630bb834$var$Empty[$eaba5269630bb834$var$PROTOTYPE] = $kjl0L(O);
        result = new $eaba5269630bb834$var$Empty();
        $eaba5269630bb834$var$Empty[$eaba5269630bb834$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$eaba5269630bb834$var$IE_PROTO] = O;
    } else result = $eaba5269630bb834$var$createDict();
    return Properties === undefined ? result : $dtj15(result, Properties);
};

});
parcelRegister("dtj15", function(module, exports) {

var $cFBNB = parcelRequire("cFBNB");

var $kjl0L = parcelRequire("kjl0L");

var $bVTIN = parcelRequire("bVTIN");

module.exports = (parcelRequire("hnpt5")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $kjl0L(O);
    var keys = $bVTIN(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$cFBNB.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("bVTIN", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $jCdrk = parcelRequire("jCdrk");

var $1C8sU = parcelRequire("1C8sU");
module.exports = Object.keys || function keys(O) {
    return $jCdrk(O, $1C8sU);
};

});
parcelRegister("jCdrk", function(module, exports) {

var $8loko = parcelRequire("8loko");

var $3OiO0 = parcelRequire("3OiO0");

var $e47bfdd0333b1b55$var$arrayIndexOf = (parcelRequire("4bUo7"))(false);

var $e47bfdd0333b1b55$var$IE_PROTO = (parcelRequire("70XNy"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $3OiO0(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $e47bfdd0333b1b55$var$IE_PROTO) $8loko(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8loko(O, key = names[i++])) ~$e47bfdd0333b1b55$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("3OiO0", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $1Rf8W = parcelRequire("1Rf8W");

var $5a32e = parcelRequire("5a32e");
module.exports = function(it) {
    return $1Rf8W($5a32e(it));
};

});
parcelRegister("1Rf8W", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $3iOEJ = parcelRequire("3iOEJ");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $3iOEJ(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("3iOEJ", function(module, exports) {
var $267a58bbaec96dd3$var$toString = {}.toString;
module.exports = function(it) {
    return $267a58bbaec96dd3$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("4bUo7", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $3OiO0 = parcelRequire("3OiO0");

var $ksHXG = parcelRequire("ksHXG");

var $3Yot1 = parcelRequire("3Yot1");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $3OiO0($this);
        var length = $ksHXG(O.length);
        var index = $3Yot1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("ksHXG", function(module, exports) {
// 7.1.15 ToLength

var $5oGDw = parcelRequire("5oGDw");
var $ee58860ae860b026$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $ee58860ae860b026$var$min($5oGDw(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("3Yot1", function(module, exports) {

var $5oGDw = parcelRequire("5oGDw");
var $2e49f45e126e919b$var$max = Math.max;
var $2e49f45e126e919b$var$min = Math.min;
module.exports = function(index, length) {
    index = $5oGDw(index);
    return index < 0 ? $2e49f45e126e919b$var$max(index + length, 0) : $2e49f45e126e919b$var$min(index, length);
};

});



parcelRegister("1C8sU", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("exEx3", function(module, exports) {

var $esmOq = parcelRequire("esmOq");
var $a963969bca81d07a$require$document = $esmOq.document;
module.exports = $a963969bca81d07a$require$document && $a963969bca81d07a$require$document.documentElement;

});


parcelRegister("57sRH", function(module, exports) {

var $cFBNB = parcelRequire("cFBNB");
var $3ba3ff39b18417ca$require$def = $cFBNB.f;

var $8loko = parcelRequire("8loko");

var $3ba3ff39b18417ca$var$TAG = (parcelRequire("jZpTE"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$8loko(it = stat ? it : it.prototype, $3ba3ff39b18417ca$var$TAG)) $3ba3ff39b18417ca$require$def(it, $3ba3ff39b18417ca$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("jZpTE", function(module, exports) {

var $e8d7cd5db3700106$var$store = (parcelRequire("8xrTN"))('wks');

var $fuRIv = parcelRequire("fuRIv");

var $esmOq = parcelRequire("esmOq");
var $e8d7cd5db3700106$require$Symbol = $esmOq.Symbol;
var $e8d7cd5db3700106$var$USE_SYMBOL = typeof $e8d7cd5db3700106$require$Symbol == 'function';
var $e8d7cd5db3700106$var$$exports = module.exports = function(name) {
    return $e8d7cd5db3700106$var$store[name] || ($e8d7cd5db3700106$var$store[name] = $e8d7cd5db3700106$var$USE_SYMBOL && $e8d7cd5db3700106$require$Symbol[name] || ($e8d7cd5db3700106$var$USE_SYMBOL ? $e8d7cd5db3700106$require$Symbol : $fuRIv)('Symbol.' + name));
};
$e8d7cd5db3700106$var$$exports.store = $e8d7cd5db3700106$var$store;

});





parcelRegister("bwy2O", function(module, exports) {
parcelRequire("dwMWE");

var $esmOq = parcelRequire("esmOq");

var $go7wy = parcelRequire("go7wy");

var $hPYrH = parcelRequire("hPYrH");

var $863d17648ef329b4$var$TO_STRING_TAG = (parcelRequire("jZpTE"))('toStringTag');
var $863d17648ef329b4$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $863d17648ef329b4$var$i = 0; $863d17648ef329b4$var$i < $863d17648ef329b4$var$DOMIterables.length; $863d17648ef329b4$var$i++){
    var $863d17648ef329b4$var$NAME = $863d17648ef329b4$var$DOMIterables[$863d17648ef329b4$var$i];
    var $863d17648ef329b4$var$Collection = $esmOq[$863d17648ef329b4$var$NAME];
    var $863d17648ef329b4$var$proto = $863d17648ef329b4$var$Collection && $863d17648ef329b4$var$Collection.prototype;
    if ($863d17648ef329b4$var$proto && !$863d17648ef329b4$var$proto[$863d17648ef329b4$var$TO_STRING_TAG]) $go7wy($863d17648ef329b4$var$proto, $863d17648ef329b4$var$TO_STRING_TAG, $863d17648ef329b4$var$NAME);
    $hPYrH[$863d17648ef329b4$var$NAME] = $hPYrH.Array;
}

});
parcelRegister("dwMWE", function(module, exports) {
'use strict';

var $g3cLa = parcelRequire("g3cLa");

var $3YGCc = parcelRequire("3YGCc");

var $hPYrH = parcelRequire("hPYrH");

var $3OiO0 = parcelRequire("3OiO0");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("gP3iI"))(Array, 'Array', function(iterated, kind) {
    this._t = $3OiO0(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $3YGCc(1);
    }
    if (kind == 'keys') return $3YGCc(0, index);
    if (kind == 'values') return $3YGCc(0, O[index]);
    return $3YGCc(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$hPYrH.Arguments = $hPYrH.Array;
$g3cLa('keys');
$g3cLa('values');
$g3cLa('entries');

});
parcelRegister("g3cLa", function(module, exports) {
module.exports = function() {};

});

parcelRegister("3YGCc", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("jlEg5", function(module, exports) {
$parcel$export(module.exports, "f", () => $e15f34f46f30f807$export$2d1720544b23b823, (v) => $e15f34f46f30f807$export$2d1720544b23b823 = v);
var $e15f34f46f30f807$export$2d1720544b23b823;

$e15f34f46f30f807$export$2d1720544b23b823 = (parcelRequire("jZpTE"));

});



parcelRegister("7763p", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bVEx7")),
    __esModule: true
};

});
parcelRegister("bVEx7", function(module, exports) {
parcelRequire("2NUzP");
parcelRequire("48vYb");
parcelRequire("iUooa");
parcelRequire("friIQ");

module.exports = (parcelRequire("1HZ59")).Symbol;

});
parcelRegister("2NUzP", function(module, exports) {
'use strict';

var $esmOq = parcelRequire("esmOq");

var $8loko = parcelRequire("8loko");

var $hnpt5 = parcelRequire("hnpt5");

var $8Npjj = parcelRequire("8Npjj");

var $dW8L7 = parcelRequire("dW8L7");

var $bhPWQ = parcelRequire("bhPWQ");
var $20ac0b5753fd81b8$require$META = $bhPWQ.KEY;

var $guisY = parcelRequire("guisY");

var $8xrTN = parcelRequire("8xrTN");

var $57sRH = parcelRequire("57sRH");

var $fuRIv = parcelRequire("fuRIv");

var $jZpTE = parcelRequire("jZpTE");

var $jlEg5 = parcelRequire("jlEg5");

var $d56s8 = parcelRequire("d56s8");

var $jfCXa = parcelRequire("jfCXa");

var $i2sDq = parcelRequire("i2sDq");

var $kjl0L = parcelRequire("kjl0L");

var $gImMz = parcelRequire("gImMz");

var $e2Lb8 = parcelRequire("e2Lb8");

var $3OiO0 = parcelRequire("3OiO0");

var $hbeKd = parcelRequire("hbeKd");

var $2PkKJ = parcelRequire("2PkKJ");

var $k9rWp = parcelRequire("k9rWp");

var $jplkK = parcelRequire("jplkK");

var $bDoRL = parcelRequire("bDoRL");

var $fdXoO = parcelRequire("fdXoO");

var $cFBNB = parcelRequire("cFBNB");

var $bVTIN = parcelRequire("bVTIN");
var $20ac0b5753fd81b8$var$gOPD = $bDoRL.f;
var $20ac0b5753fd81b8$var$dP = $cFBNB.f;
var $20ac0b5753fd81b8$var$gOPN = $jplkK.f;
var $20ac0b5753fd81b8$var$$Symbol = $esmOq.Symbol;
var $20ac0b5753fd81b8$var$$JSON = $esmOq.JSON;
var $20ac0b5753fd81b8$var$_stringify = $20ac0b5753fd81b8$var$$JSON && $20ac0b5753fd81b8$var$$JSON.stringify;
var $20ac0b5753fd81b8$var$PROTOTYPE = 'prototype';
var $20ac0b5753fd81b8$var$HIDDEN = $jZpTE('_hidden');
var $20ac0b5753fd81b8$var$TO_PRIMITIVE = $jZpTE('toPrimitive');
var $20ac0b5753fd81b8$var$isEnum = {}.propertyIsEnumerable;
var $20ac0b5753fd81b8$var$SymbolRegistry = $8xrTN('symbol-registry');
var $20ac0b5753fd81b8$var$AllSymbols = $8xrTN('symbols');
var $20ac0b5753fd81b8$var$OPSymbols = $8xrTN('op-symbols');
var $20ac0b5753fd81b8$var$ObjectProto = Object[$20ac0b5753fd81b8$var$PROTOTYPE];
var $20ac0b5753fd81b8$var$USE_NATIVE = typeof $20ac0b5753fd81b8$var$$Symbol == 'function' && !!$fdXoO.f;
var $20ac0b5753fd81b8$var$QObject = $esmOq.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $20ac0b5753fd81b8$var$setter = !$20ac0b5753fd81b8$var$QObject || !$20ac0b5753fd81b8$var$QObject[$20ac0b5753fd81b8$var$PROTOTYPE] || !$20ac0b5753fd81b8$var$QObject[$20ac0b5753fd81b8$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $20ac0b5753fd81b8$var$setSymbolDesc = $hnpt5 && $guisY(function() {
    return $k9rWp($20ac0b5753fd81b8$var$dP({}, 'a', {
        get: function() {
            return $20ac0b5753fd81b8$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $20ac0b5753fd81b8$var$gOPD($20ac0b5753fd81b8$var$ObjectProto, key);
    if (protoDesc) delete $20ac0b5753fd81b8$var$ObjectProto[key];
    $20ac0b5753fd81b8$var$dP(it, key, D);
    if (protoDesc && it !== $20ac0b5753fd81b8$var$ObjectProto) $20ac0b5753fd81b8$var$dP($20ac0b5753fd81b8$var$ObjectProto, key, protoDesc);
} : $20ac0b5753fd81b8$var$dP;
var $20ac0b5753fd81b8$var$wrap = function(tag) {
    var sym = $20ac0b5753fd81b8$var$AllSymbols[tag] = $k9rWp($20ac0b5753fd81b8$var$$Symbol[$20ac0b5753fd81b8$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $20ac0b5753fd81b8$var$isSymbol = $20ac0b5753fd81b8$var$USE_NATIVE && typeof $20ac0b5753fd81b8$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $20ac0b5753fd81b8$var$$Symbol;
};
var $20ac0b5753fd81b8$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $20ac0b5753fd81b8$var$ObjectProto) $20ac0b5753fd81b8$var$$defineProperty($20ac0b5753fd81b8$var$OPSymbols, key, D);
    $kjl0L(it);
    key = $hbeKd(key, true);
    $kjl0L(D);
    if ($8loko($20ac0b5753fd81b8$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$8loko(it, $20ac0b5753fd81b8$var$HIDDEN)) $20ac0b5753fd81b8$var$dP(it, $20ac0b5753fd81b8$var$HIDDEN, $2PkKJ(1, {}));
            it[$20ac0b5753fd81b8$var$HIDDEN][key] = true;
        } else {
            if ($8loko(it, $20ac0b5753fd81b8$var$HIDDEN) && it[$20ac0b5753fd81b8$var$HIDDEN][key]) it[$20ac0b5753fd81b8$var$HIDDEN][key] = false;
            D = $k9rWp(D, {
                enumerable: $2PkKJ(0, false)
            });
        }
        return $20ac0b5753fd81b8$var$setSymbolDesc(it, key, D);
    }
    return $20ac0b5753fd81b8$var$dP(it, key, D);
};
var $20ac0b5753fd81b8$var$$defineProperties = function defineProperties(it, P) {
    $kjl0L(it);
    var keys = $jfCXa(P = $3OiO0(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$20ac0b5753fd81b8$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $20ac0b5753fd81b8$var$$create = function create(it, P) {
    return P === undefined ? $k9rWp(it) : $20ac0b5753fd81b8$var$$defineProperties($k9rWp(it), P);
};
var $20ac0b5753fd81b8$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $20ac0b5753fd81b8$var$isEnum.call(this, key = $hbeKd(key, true));
    if (this === $20ac0b5753fd81b8$var$ObjectProto && $8loko($20ac0b5753fd81b8$var$AllSymbols, key) && !$8loko($20ac0b5753fd81b8$var$OPSymbols, key)) return false;
    return E || !$8loko(this, key) || !$8loko($20ac0b5753fd81b8$var$AllSymbols, key) || $8loko(this, $20ac0b5753fd81b8$var$HIDDEN) && this[$20ac0b5753fd81b8$var$HIDDEN][key] ? E : true;
};
var $20ac0b5753fd81b8$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $3OiO0(it);
    key = $hbeKd(key, true);
    if (it === $20ac0b5753fd81b8$var$ObjectProto && $8loko($20ac0b5753fd81b8$var$AllSymbols, key) && !$8loko($20ac0b5753fd81b8$var$OPSymbols, key)) return;
    var D = $20ac0b5753fd81b8$var$gOPD(it, key);
    if (D && $8loko($20ac0b5753fd81b8$var$AllSymbols, key) && !($8loko(it, $20ac0b5753fd81b8$var$HIDDEN) && it[$20ac0b5753fd81b8$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $20ac0b5753fd81b8$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $20ac0b5753fd81b8$var$gOPN($3OiO0(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$8loko($20ac0b5753fd81b8$var$AllSymbols, key = names[i++]) && key != $20ac0b5753fd81b8$var$HIDDEN && key != $20ac0b5753fd81b8$require$META) result.push(key);
    return result;
};
var $20ac0b5753fd81b8$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $20ac0b5753fd81b8$var$ObjectProto;
    var names = $20ac0b5753fd81b8$var$gOPN(IS_OP ? $20ac0b5753fd81b8$var$OPSymbols : $3OiO0(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($8loko($20ac0b5753fd81b8$var$AllSymbols, key = names[i++]) && (IS_OP ? $8loko($20ac0b5753fd81b8$var$ObjectProto, key) : true)) result.push($20ac0b5753fd81b8$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$20ac0b5753fd81b8$var$USE_NATIVE) {
    $20ac0b5753fd81b8$var$$Symbol = function Symbol() {
        if (this instanceof $20ac0b5753fd81b8$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $fuRIv(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $20ac0b5753fd81b8$var$ObjectProto) $set.call($20ac0b5753fd81b8$var$OPSymbols, value);
            if ($8loko(this, $20ac0b5753fd81b8$var$HIDDEN) && $8loko(this[$20ac0b5753fd81b8$var$HIDDEN], tag)) this[$20ac0b5753fd81b8$var$HIDDEN][tag] = false;
            $20ac0b5753fd81b8$var$setSymbolDesc(this, tag, $2PkKJ(1, value));
        };
        if ($hnpt5 && $20ac0b5753fd81b8$var$setter) $20ac0b5753fd81b8$var$setSymbolDesc($20ac0b5753fd81b8$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $20ac0b5753fd81b8$var$wrap(tag);
    };
    $dW8L7($20ac0b5753fd81b8$var$$Symbol[$20ac0b5753fd81b8$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $bDoRL.f = $20ac0b5753fd81b8$var$$getOwnPropertyDescriptor;
    $cFBNB.f = $20ac0b5753fd81b8$var$$defineProperty;
    (parcelRequire("j2g7L")).f = $jplkK.f = $20ac0b5753fd81b8$var$$getOwnPropertyNames;
    (parcelRequire("6TDVw")).f = $20ac0b5753fd81b8$var$$propertyIsEnumerable;
    $fdXoO.f = $20ac0b5753fd81b8$var$$getOwnPropertySymbols;
    if ($hnpt5 && !(parcelRequire("la1Rh"))) $dW8L7($20ac0b5753fd81b8$var$ObjectProto, 'propertyIsEnumerable', $20ac0b5753fd81b8$var$$propertyIsEnumerable, true);
    $jlEg5.f = function(name) {
        return $20ac0b5753fd81b8$var$wrap($jZpTE(name));
    };
}
$8Npjj($8Npjj.G + $8Npjj.W + $8Npjj.F * !$20ac0b5753fd81b8$var$USE_NATIVE, {
    Symbol: $20ac0b5753fd81b8$var$$Symbol
});
for(var $20ac0b5753fd81b8$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $20ac0b5753fd81b8$var$j = 0; $20ac0b5753fd81b8$var$es6Symbols.length > $20ac0b5753fd81b8$var$j;)$jZpTE($20ac0b5753fd81b8$var$es6Symbols[$20ac0b5753fd81b8$var$j++]);
for(var $20ac0b5753fd81b8$var$wellKnownSymbols = $bVTIN($jZpTE.store), $20ac0b5753fd81b8$var$k = 0; $20ac0b5753fd81b8$var$wellKnownSymbols.length > $20ac0b5753fd81b8$var$k;)$d56s8($20ac0b5753fd81b8$var$wellKnownSymbols[$20ac0b5753fd81b8$var$k++]);
$8Npjj($8Npjj.S + $8Npjj.F * !$20ac0b5753fd81b8$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $8loko($20ac0b5753fd81b8$var$SymbolRegistry, key += '') ? $20ac0b5753fd81b8$var$SymbolRegistry[key] : $20ac0b5753fd81b8$var$SymbolRegistry[key] = $20ac0b5753fd81b8$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$20ac0b5753fd81b8$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $20ac0b5753fd81b8$var$SymbolRegistry)if ($20ac0b5753fd81b8$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $20ac0b5753fd81b8$var$setter = true;
    },
    useSimple: function() {
        $20ac0b5753fd81b8$var$setter = false;
    }
});
$8Npjj($8Npjj.S + $8Npjj.F * !$20ac0b5753fd81b8$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $20ac0b5753fd81b8$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $20ac0b5753fd81b8$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $20ac0b5753fd81b8$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $20ac0b5753fd81b8$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $20ac0b5753fd81b8$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $20ac0b5753fd81b8$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $20ac0b5753fd81b8$var$FAILS_ON_PRIMITIVES = $guisY(function() {
    $fdXoO.f(1);
});
$8Npjj($8Npjj.S + $8Npjj.F * $20ac0b5753fd81b8$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $fdXoO.f($e2Lb8(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$20ac0b5753fd81b8$var$$JSON && $8Npjj($8Npjj.S + $8Npjj.F * (!$20ac0b5753fd81b8$var$USE_NATIVE || $guisY(function() {
    var S = $20ac0b5753fd81b8$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $20ac0b5753fd81b8$var$_stringify([
        S
    ]) != '[null]' || $20ac0b5753fd81b8$var$_stringify({
        a: S
    }) != '{}' || $20ac0b5753fd81b8$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$gImMz(replacer) && it === undefined || $20ac0b5753fd81b8$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$i2sDq(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$20ac0b5753fd81b8$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $20ac0b5753fd81b8$var$_stringify.apply($20ac0b5753fd81b8$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$20ac0b5753fd81b8$var$$Symbol[$20ac0b5753fd81b8$var$PROTOTYPE][$20ac0b5753fd81b8$var$TO_PRIMITIVE] || (parcelRequire("go7wy"))($20ac0b5753fd81b8$var$$Symbol[$20ac0b5753fd81b8$var$PROTOTYPE], $20ac0b5753fd81b8$var$TO_PRIMITIVE, $20ac0b5753fd81b8$var$$Symbol[$20ac0b5753fd81b8$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$57sRH($20ac0b5753fd81b8$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$57sRH(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$57sRH($esmOq.JSON, 'JSON', true);

});
parcelRegister("bhPWQ", function(module, exports) {

var $83799409be4fb52c$var$META = (parcelRequire("fuRIv"))('meta');

var $gImMz = parcelRequire("gImMz");

var $8loko = parcelRequire("8loko");

var $cFBNB = parcelRequire("cFBNB");
var $83799409be4fb52c$require$setDesc = $cFBNB.f;
var $83799409be4fb52c$var$id = 0;
var $83799409be4fb52c$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $83799409be4fb52c$var$FREEZE = !(parcelRequire("guisY"))(function() {
    return $83799409be4fb52c$var$isExtensible(Object.preventExtensions({}));
});
var $83799409be4fb52c$var$setMeta = function(it) {
    $83799409be4fb52c$require$setDesc(it, $83799409be4fb52c$var$META, {
        value: {
            i: 'O' + ++$83799409be4fb52c$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $83799409be4fb52c$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$gImMz(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$8loko(it, $83799409be4fb52c$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$83799409be4fb52c$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $83799409be4fb52c$var$setMeta(it);
    // return object ID
    }
    return it[$83799409be4fb52c$var$META].i;
};
var $83799409be4fb52c$var$getWeak = function(it, create) {
    if (!$8loko(it, $83799409be4fb52c$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$83799409be4fb52c$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $83799409be4fb52c$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$83799409be4fb52c$var$META].w;
};
// add metadata on freeze-family methods calling
var $83799409be4fb52c$var$onFreeze = function(it) {
    if ($83799409be4fb52c$var$FREEZE && $83799409be4fb52c$var$meta.NEED && $83799409be4fb52c$var$isExtensible(it) && !$8loko(it, $83799409be4fb52c$var$META)) $83799409be4fb52c$var$setMeta(it);
    return it;
};
var $83799409be4fb52c$var$meta = module.exports = {
    KEY: $83799409be4fb52c$var$META,
    NEED: false,
    fastKey: $83799409be4fb52c$var$fastKey,
    getWeak: $83799409be4fb52c$var$getWeak,
    onFreeze: $83799409be4fb52c$var$onFreeze
};

});

parcelRegister("d56s8", function(module, exports) {

var $esmOq = parcelRequire("esmOq");

var $1HZ59 = parcelRequire("1HZ59");

var $la1Rh = parcelRequire("la1Rh");

var $jlEg5 = parcelRequire("jlEg5");

var $cFBNB = parcelRequire("cFBNB");
var $9860bf5cfe219aaa$require$defineProperty = $cFBNB.f;
module.exports = function(name) {
    var $Symbol = $1HZ59.Symbol || ($1HZ59.Symbol = $la1Rh ? {} : $esmOq.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $9860bf5cfe219aaa$require$defineProperty($Symbol, name, {
        value: $jlEg5.f(name)
    });
};

});

parcelRegister("jfCXa", function(module, exports) {
// all enumerable object keys, includes symbols

var $bVTIN = parcelRequire("bVTIN");

var $fdXoO = parcelRequire("fdXoO");

var $6TDVw = parcelRequire("6TDVw");
module.exports = function(it) {
    var result = $bVTIN(it);
    var getSymbols = $fdXoO.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $6TDVw.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("fdXoO", function(module, exports) {
$parcel$export(module.exports, "f", () => $b156255ba19a5025$export$2d1720544b23b823, (v) => $b156255ba19a5025$export$2d1720544b23b823 = v);
var $b156255ba19a5025$export$2d1720544b23b823;
$b156255ba19a5025$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("6TDVw", function(module, exports) {
$parcel$export(module.exports, "f", () => $5056d9bde8b777db$export$2d1720544b23b823, (v) => $5056d9bde8b777db$export$2d1720544b23b823 = v);
var $5056d9bde8b777db$export$2d1720544b23b823;
$5056d9bde8b777db$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("i2sDq", function(module, exports) {
// 7.2.2 IsArray(argument)

var $3iOEJ = parcelRequire("3iOEJ");
module.exports = Array.isArray || function isArray(arg) {
    return $3iOEJ(arg) == 'Array';
};

});

parcelRegister("jplkK", function(module, exports) {
$parcel$export(module.exports, "f", () => $e210e6879e1b9ab3$export$2d1720544b23b823, (v) => $e210e6879e1b9ab3$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $e210e6879e1b9ab3$export$2d1720544b23b823;

var $3OiO0 = parcelRequire("3OiO0");

var $j2g7L = parcelRequire("j2g7L");
var $e210e6879e1b9ab3$require$gOPN = $j2g7L.f;
var $e210e6879e1b9ab3$var$toString = {}.toString;
var $e210e6879e1b9ab3$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $e210e6879e1b9ab3$var$getWindowNames = function(it) {
    try {
        return $e210e6879e1b9ab3$require$gOPN(it);
    } catch (e) {
        return $e210e6879e1b9ab3$var$windowNames.slice();
    }
};
$e210e6879e1b9ab3$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $e210e6879e1b9ab3$var$windowNames && $e210e6879e1b9ab3$var$toString.call(it) == '[object Window]' ? $e210e6879e1b9ab3$var$getWindowNames(it) : $e210e6879e1b9ab3$require$gOPN($3OiO0(it));
};

});
parcelRegister("j2g7L", function(module, exports) {
$parcel$export(module.exports, "f", () => $ddbab6228a8b53d0$export$2d1720544b23b823, (v) => $ddbab6228a8b53d0$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $ddbab6228a8b53d0$export$2d1720544b23b823;

var $jCdrk = parcelRequire("jCdrk");

var $ddbab6228a8b53d0$var$hiddenKeys = (parcelRequire("1C8sU")).concat('length', 'prototype');
$ddbab6228a8b53d0$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $jCdrk(O, $ddbab6228a8b53d0$var$hiddenKeys);
};

});


parcelRegister("bDoRL", function(module, exports) {
$parcel$export(module.exports, "f", () => $8786a01aeb553911$export$2d1720544b23b823, (v) => $8786a01aeb553911$export$2d1720544b23b823 = v);
var $8786a01aeb553911$export$2d1720544b23b823;

var $6TDVw = parcelRequire("6TDVw");

var $2PkKJ = parcelRequire("2PkKJ");

var $3OiO0 = parcelRequire("3OiO0");

var $hbeKd = parcelRequire("hbeKd");

var $8loko = parcelRequire("8loko");

var $4rUDE = parcelRequire("4rUDE");
var $8786a01aeb553911$var$gOPD = Object.getOwnPropertyDescriptor;

$8786a01aeb553911$export$2d1720544b23b823 = (parcelRequire("hnpt5")) ? $8786a01aeb553911$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $3OiO0(O);
    P = $hbeKd(P, true);
    if ($4rUDE) try {
        return $8786a01aeb553911$var$gOPD(O, P);
    } catch (e) {}
    if ($8loko(O, P)) return $2PkKJ(!$6TDVw.f.call(O, P), O[P]);
};

});


parcelRegister("48vYb", function(module, exports) {

});

parcelRegister("iUooa", function(module, exports) {

(parcelRequire("d56s8"))('asyncIterator');

});

parcelRegister("friIQ", function(module, exports) {

(parcelRequire("d56s8"))('observable');

});





parcelRegister("4BCLx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $35a8b033e76d17aa$export$1e511d4a378977f5, (v) => $35a8b033e76d17aa$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $35a8b033e76d17aa$export$2e2bcd8739ae039, (v) => $35a8b033e76d17aa$export$2e2bcd8739ae039 = v);
var $35a8b033e76d17aa$export$1e511d4a378977f5;
var $35a8b033e76d17aa$export$2e2bcd8739ae039;
"use strict";
$35a8b033e76d17aa$export$1e511d4a378977f5 = true;

var $dr6uu = parcelRequire("dr6uu");
var $35a8b033e76d17aa$var$_setPrototypeOf2 = $35a8b033e76d17aa$var$_interopRequireDefault($dr6uu);

var $izzXC = parcelRequire("izzXC");
var $35a8b033e76d17aa$var$_create2 = $35a8b033e76d17aa$var$_interopRequireDefault($izzXC);

var $jc9BX = parcelRequire("jc9BX");
var $35a8b033e76d17aa$var$_typeof3 = $35a8b033e76d17aa$var$_interopRequireDefault($jc9BX);
function $35a8b033e76d17aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$35a8b033e76d17aa$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $35a8b033e76d17aa$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $35a8b033e76d17aa$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $35a8b033e76d17aa$var$_setPrototypeOf2.default ? (0, $35a8b033e76d17aa$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("dr6uu", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cpgGZ")),
    __esModule: true
};

});
parcelRegister("cpgGZ", function(module, exports) {
parcelRequire("g9DO4");

module.exports = (parcelRequire("1HZ59")).Object.setPrototypeOf;

});
parcelRegister("g9DO4", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $8Npjj = parcelRequire("8Npjj");

$8Npjj($8Npjj.S, 'Object', {
    setPrototypeOf: (parcelRequire("8Ifqj")).set
});

});
parcelRegister("8Ifqj", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $gImMz = parcelRequire("gImMz");

var $kjl0L = parcelRequire("kjl0L");
var $657e658b6776a5ee$var$check = function(O, proto) {
    $kjl0L(O);
    if (!$gImMz(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("2csxj"))(Function.call, (parcelRequire("bDoRL")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $657e658b6776a5ee$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $657e658b6776a5ee$var$check
};

});




parcelRegister("izzXC", function(module, exports) {

module.exports = {
    "default": (parcelRequire("16Oeh")),
    __esModule: true
};

});
parcelRegister("16Oeh", function(module, exports) {
parcelRequire("gqLav");

var $1HZ59 = parcelRequire("1HZ59");
var $0ced507c84663cb9$require$$Object = $1HZ59.Object;
module.exports = function create(P, D) {
    return $0ced507c84663cb9$require$$Object.create(P, D);
};

});
parcelRegister("gqLav", function(module, exports) {

var $8Npjj = parcelRequire("8Npjj");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$8Npjj($8Npjj.S, 'Object', {
    create: (parcelRequire("k9rWp"))
});

});




parcelRegister("dwOcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f12deb3eab5204bb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $gExTV = parcelRequire("gExTV");

var $gMKKR = parcelRequire("gMKKR");

var $iXdQj = parcelRequire("iXdQj");
const $f12deb3eab5204bb$var$AnalyticsContext = (props)=>{
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this provider.
    const [isModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(()=>(0, $gExTV.default) || (0, $gdUUy.fg)('analytics-next-use-legacy-context') === false || (0, $gdUUy.fg)('adminhub-analytics-next-use-modern-context') || (0, $gdUUy.fg)('bitbucket-analytics-next-use-modern-context'));
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iXdQj.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gMKKR.default), props);
};
var $f12deb3eab5204bb$export$2e2bcd8739ae039 = $f12deb3eab5204bb$var$AnalyticsContext;

});
parcelRegister("gExTV", function(module, exports) {
$parcel$export(module.exports, "default", () => $db8e66fbcdc77c45$export$2e2bcd8739ae039);

var $4eGW1 = parcelRequire("4eGW1");
var $db8e66fbcdc77c45$var$_process$env;
/// <reference types="node" />
const $db8e66fbcdc77c45$var$_default_1 = typeof $4eGW1 !== 'undefined' && $4eGW1 !== null && (($db8e66fbcdc77c45$var$_process$env = {}, $db8e66fbcdc77c45$var$_process$env === void 0) ? void 0 : $db8e66fbcdc77c45$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $db8e66fbcdc77c45$export$2e2bcd8739ae039 = $db8e66fbcdc77c45$var$_default_1;

});

parcelRegister("gMKKR", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f824c6e50006bcc$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $euFUz = parcelRequire("euFUz");
const $1f824c6e50006bcc$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
};
const $1f824c6e50006bcc$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1f824c6e50006bcc$var$AnalyticsContext extends (0, $bSJIT.Component) {
    static #_ = this.contextTypes = $1f824c6e50006bcc$var$ContextTypes;
    static #_2 = this.childContextTypes = $1f824c6e50006bcc$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $1f824c6e50006bcc$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $1f824c6e50006bcc$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $euFUz.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $1f824c6e50006bcc$export$2e2bcd8739ae039 = $1f824c6e50006bcc$var$AnalyticsContext;

});
parcelRegister("4yQYd", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35236d2b4357d001$var$ReactIs, $35236d2b4357d001$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("87K3H"))();

});
parcelRegister("87K3H", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $hPYq7 = parcelRequire("hPYq7");
function $5ea2b47b2ff70046$var$emptyFunction() {}
function $5ea2b47b2ff70046$var$emptyFunctionWithReset() {}
$5ea2b47b2ff70046$var$emptyFunctionWithReset.resetWarningCache = $5ea2b47b2ff70046$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hPYq7) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $5ea2b47b2ff70046$var$emptyFunctionWithReset,
        resetWarningCache: $5ea2b47b2ff70046$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hPYq7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $cfc611519cbf12c5$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $cfc611519cbf12c5$var$ReactPropTypesSecret;

});



parcelRegister("euFUz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a8d460c5de35af13$export$2e2bcd8739ae039);

var $9nXfc = parcelRequire("9nXfc");
var $a8d460c5de35af13$export$2e2bcd8739ae039 = (0, $9nXfc.default);

});
parcelRegister("9nXfc", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d5437b65f88f7d6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
var $6d5437b65f88f7d6$var$AnalyticsNextContext = (0, $bSJIT.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $6d5437b65f88f7d6$export$2e2bcd8739ae039 = $6d5437b65f88f7d6$var$AnalyticsNextContext;

});



parcelRegister("iXdQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cd301c478125389$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $euFUz = parcelRequire("euFUz");

var $6ZxMT = parcelRequire("6ZxMT");

var $lE3PD = parcelRequire("lE3PD");
const $7cd301c478125389$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $lE3PD.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $6ZxMT.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $bSJIT.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $bSJIT.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $euFUz.default).Provider, {
        value: value
    }, children);
};
var $7cd301c478125389$export$2e2bcd8739ae039 = $7cd301c478125389$var$AnalyticsContext;

});
parcelRegister("6ZxMT", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $4000cc2d3088abf8$export$d1f587f82ad51c4);

var $bSJIT = parcelRequire("bSJIT");

var $euFUz = parcelRequire("euFUz");
const $4000cc2d3088abf8$export$d1f587f82ad51c4 = ()=>{
    return (0, $bSJIT.useContext)((0, $euFUz.default));
};

});

parcelRegister("lE3PD", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $c51def3eacd34372$export$1d27a74659855e44);

var $bSJIT = parcelRequire("bSJIT");
const $c51def3eacd34372$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $bSJIT.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("l24PT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kUw6v = parcelRequire("kUw6v");
var $f4fd89390e03ec23$var$_extends3 = $f4fd89390e03ec23$var$_interopRequireDefault($kUw6v);

var $hObjF = parcelRequire("hObjF");
var $f4fd89390e03ec23$var$_objectWithoutProperties3 = $f4fd89390e03ec23$var$_interopRequireDefault($hObjF);

var $lgNi9 = parcelRequire("lgNi9");
var $f4fd89390e03ec23$var$_isUndefined2 = $f4fd89390e03ec23$var$_interopRequireDefault($lgNi9);

var $eu1ij = parcelRequire("eu1ij");
var $f4fd89390e03ec23$var$_omitBy2 = $f4fd89390e03ec23$var$_interopRequireDefault($eu1ij);

var $kyRrk = parcelRequire("kyRrk");
var $f4fd89390e03ec23$var$_mapDataPayloadToContextPayload2 = $f4fd89390e03ec23$var$_interopRequireDefault($kyRrk);
function $f4fd89390e03ec23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(props) {
    var sourceName = props.sourceName, sourceType = props.sourceType, componentName = props.componentName, other = (0, $f4fd89390e03ec23$var$_objectWithoutProperties3.default)(props, [
        'sourceName',
        'sourceType',
        'componentName'
    ]);
    var validProps = (0, $f4fd89390e03ec23$var$_mapDataPayloadToContextPayload2.default)(other);
    var source = sourceName && sourceType ? '' + sourceName + sourceType : undefined;
    return (0, $f4fd89390e03ec23$var$_omitBy2.default)((0, $f4fd89390e03ec23$var$_extends3.default)({
        componentName: componentName,
        source: source
    }, validProps), $f4fd89390e03ec23$var$_isUndefined2.default);
};

});
parcelRegister("kUw6v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $f391f0c8cf1c9832$export$1e511d4a378977f5, (v) => $f391f0c8cf1c9832$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $f391f0c8cf1c9832$export$2e2bcd8739ae039, (v) => $f391f0c8cf1c9832$export$2e2bcd8739ae039 = v);
var $f391f0c8cf1c9832$export$1e511d4a378977f5;
var $f391f0c8cf1c9832$export$2e2bcd8739ae039;
"use strict";
$f391f0c8cf1c9832$export$1e511d4a378977f5 = true;

var $hhXEP = parcelRequire("hhXEP");
var $f391f0c8cf1c9832$var$_assign2 = $f391f0c8cf1c9832$var$_interopRequireDefault($hhXEP);
function $f391f0c8cf1c9832$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$f391f0c8cf1c9832$export$2e2bcd8739ae039 = $f391f0c8cf1c9832$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("hhXEP", function(module, exports) {

module.exports = {
    "default": (parcelRequire("ffsrY")),
    __esModule: true
};

});
parcelRegister("ffsrY", function(module, exports) {
parcelRequire("6RNiQ");

module.exports = (parcelRequire("1HZ59")).Object.assign;

});
parcelRegister("6RNiQ", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $8Npjj = parcelRequire("8Npjj");

$8Npjj($8Npjj.S + $8Npjj.F, 'Object', {
    assign: (parcelRequire("kF4sT"))
});

});
parcelRegister("kF4sT", function(module, exports) {
'use strict';

var $hnpt5 = parcelRequire("hnpt5");

var $bVTIN = parcelRequire("bVTIN");

var $fdXoO = parcelRequire("fdXoO");

var $6TDVw = parcelRequire("6TDVw");

var $e2Lb8 = parcelRequire("e2Lb8");

var $1Rf8W = parcelRequire("1Rf8W");
var $03e1ba3847598b01$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$03e1ba3847598b01$var$$assign || (parcelRequire("guisY"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $03e1ba3847598b01$var$$assign({}, A)[S] != 7 || Object.keys($03e1ba3847598b01$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $e2Lb8(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $fdXoO.f;
    var isEnum = $6TDVw.f;
    while(aLen > index){
        var S = $1Rf8W(arguments[index++]);
        var keys = getSymbols ? $bVTIN(S).concat(getSymbols(S)) : $bVTIN(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$hnpt5 || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $03e1ba3847598b01$var$$assign;

});





parcelRegister("hObjF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $cf6fe255f2b4c582$export$1e511d4a378977f5, (v) => $cf6fe255f2b4c582$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $cf6fe255f2b4c582$export$2e2bcd8739ae039, (v) => $cf6fe255f2b4c582$export$2e2bcd8739ae039 = v);
var $cf6fe255f2b4c582$export$1e511d4a378977f5;
var $cf6fe255f2b4c582$export$2e2bcd8739ae039;
"use strict";
$cf6fe255f2b4c582$export$1e511d4a378977f5 = true;
$cf6fe255f2b4c582$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("kyRrk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(payload) {
    var tags = payload.tags, containerId = payload.containerId, containerType = payload.containerType, objectId = payload.objectId, objectType = payload.objectType, attributes = payload.attributes;
    return {
        tags: tags,
        containerId: containerId,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    };
};

});



parcelRegister("1oSqe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7cqhy = parcelRequire("7cqhy");
var $10523f6983b6386c$var$_getPrototypeOf2 = $10523f6983b6386c$var$_interopRequireDefault($7cqhy);

var $ixHVX = parcelRequire("ixHVX");
var $10523f6983b6386c$var$_classCallCheck3 = $10523f6983b6386c$var$_interopRequireDefault($ixHVX);

var $egcHh = parcelRequire("egcHh");
var $10523f6983b6386c$var$_createClass3 = $10523f6983b6386c$var$_interopRequireDefault($egcHh);

var $lMtgs = parcelRequire("lMtgs");
var $10523f6983b6386c$var$_possibleConstructorReturn3 = $10523f6983b6386c$var$_interopRequireDefault($lMtgs);

var $4BCLx = parcelRequire("4BCLx");
var $10523f6983b6386c$var$_inherits3 = $10523f6983b6386c$var$_interopRequireDefault($4BCLx);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");
function $10523f6983b6386c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $10523f6983b6386c$var$MountTracker = function(_Component) {
    (0, $10523f6983b6386c$var$_inherits3.default)(MountTracker, _Component);
    function MountTracker() {
        (0, $10523f6983b6386c$var$_classCallCheck3.default)(this, MountTracker);
        return (0, $10523f6983b6386c$var$_possibleConstructorReturn3.default)(this, (MountTracker.__proto__ || (0, $10523f6983b6386c$var$_getPrototypeOf2.default)(MountTracker)).apply(this, arguments));
    }
    (0, $10523f6983b6386c$var$_createClass3.default)(MountTracker, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                // $FlowFixMe
                this.props.onMount();
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return MountTracker;
}($bSJIT.Component);
module.exports.default = (0, $kIbto.default)({
    onMount: {
        action: 'viewed'
    }
})($10523f6983b6386c$var$MountTracker);

});
parcelRegister("kIbto", function(module, exports) {
$parcel$export(module.exports, "default", () => $b812d7979ff14dc9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $6ph1S = parcelRequire("6ph1S");
const $b812d7979ff14dc9$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $6ph1S.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $b812d7979ff14dc9$export$2e2bcd8739ae039 = $b812d7979ff14dc9$var$withAnalyticsEvents;

});
parcelRegister("6WltM", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $53fa062986543f64$export$5bf35293e545f20c);

var $et3Hh = parcelRequire("et3Hh");

var $hCYNe = parcelRequire("hCYNe");

var $6ZxMT = parcelRequire("6ZxMT");
function $53fa062986543f64$export$5bf35293e545f20c() {
    const analyticsContext = (0, $6ZxMT.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $et3Hh.useCallbackOne)((payload)=>{
        return new (0, $hCYNe.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("et3Hh", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $a886a44cf1a0c025$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $a886a44cf1a0c025$export$33752cf3ee811995);

var $bSJIT = parcelRequire("bSJIT");
function $a886a44cf1a0c025$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a886a44cf1a0c025$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $bSJIT.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $bSJIT.useRef)(true);
    var committed = (0, $bSJIT.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $a886a44cf1a0c025$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $bSJIT.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $a886a44cf1a0c025$export$33752cf3ee811995(callback, inputs) {
    return $a886a44cf1a0c025$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $a886a44cf1a0c025$export$1538c33de8887b59 = $a886a44cf1a0c025$export$b6feb8998cd9b342;
var $a886a44cf1a0c025$export$35808ee640e87ca7 = $a886a44cf1a0c025$export$33752cf3ee811995;

});


parcelRegister("6ph1S", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $2a153d36c1afd769$export$9ebb5a84d17e5d18);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");
function $2a153d36c1afd769$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const handlerCache = (0, $bSJIT.useRef)({});
    const patchedProps = (0, $bSJIT.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("2bDgh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7cqhy = parcelRequire("7cqhy");
var $197b105d4b715750$var$_getPrototypeOf2 = $197b105d4b715750$var$_interopRequireDefault($7cqhy);

var $ixHVX = parcelRequire("ixHVX");
var $197b105d4b715750$var$_classCallCheck3 = $197b105d4b715750$var$_interopRequireDefault($ixHVX);

var $egcHh = parcelRequire("egcHh");
var $197b105d4b715750$var$_createClass3 = $197b105d4b715750$var$_interopRequireDefault($egcHh);

var $lMtgs = parcelRequire("lMtgs");
var $197b105d4b715750$var$_possibleConstructorReturn3 = $197b105d4b715750$var$_interopRequireDefault($lMtgs);

var $4BCLx = parcelRequire("4BCLx");
var $197b105d4b715750$var$_inherits3 = $197b105d4b715750$var$_interopRequireDefault($4BCLx);

var $bSJIT = parcelRequire("bSJIT");
var $197b105d4b715750$var$_react2 = $197b105d4b715750$var$_interopRequireDefault($bSJIT);

var $8vCJI = parcelRequire("8vCJI");
var $197b105d4b715750$var$_analyticsContext2 = $197b105d4b715750$var$_interopRequireDefault($8vCJI);
function $197b105d4b715750$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Props) {
    return function(WrappedComponent) {
        return function(_Component) {
            (0, $197b105d4b715750$var$_inherits3.default)(WithAnalyticsContext, _Component);
            function WithAnalyticsContext() {
                (0, $197b105d4b715750$var$_classCallCheck3.default)(this, WithAnalyticsContext);
                return (0, $197b105d4b715750$var$_possibleConstructorReturn3.default)(this, (WithAnalyticsContext.__proto__ || (0, $197b105d4b715750$var$_getPrototypeOf2.default)(WithAnalyticsContext)).apply(this, arguments));
            }
            (0, $197b105d4b715750$var$_createClass3.default)(WithAnalyticsContext, [
                {
                    key: 'render',
                    value: function render() {
                        return $197b105d4b715750$var$_react2.default.createElement($197b105d4b715750$var$_analyticsContext2.default, Props, $197b105d4b715750$var$_react2.default.createElement(WrappedComponent, this.props));
                    }
                }
            ]);
            return WithAnalyticsContext;
        }($bSJIT.Component);
    };
};

});

parcelRegister("gkrv1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9JXaU = parcelRequire("9JXaU");

var $hR81l = parcelRequire("hR81l");

var $iLHzy = parcelRequire("iLHzy");

var $cxbU2 = parcelRequire("cxbU2");

var $gbMev = parcelRequire("gbMev");
// data.type necessary cause of flow
module.exports.default = function(data) {
    if (!data) throw new Error('No event data passed in');
    if (data.client && data.type !== $9JXaU.OPERATIONAL_EVENT_TYPE) throw new Error('Sending events via client is not supported in non Operational events');
    if (data.type === $9JXaU.UI_EVENT_TYPE) (0, $gbMev.fireAnalyticsUiEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $9JXaU.TRACK_EVENT_TYPE) (0, $cxbU2.fireAnalyticsTrackEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $9JXaU.OPERATIONAL_EVENT_TYPE) (0, $hR81l.fireAnalyticsOperationalEvent)(data);
    else if (data.type === $9JXaU.SCREEN_EVENT_TYPE) (0, $iLHzy.fireAnalyticsScreenEvent)(data.analyticsEvent, data.payload);
    else throw new Error('Event type not supported: ' + data.type);
};

});
parcelRegister("hR81l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationEventWithEvent = undefined;

var $kUw6v = parcelRequire("kUw6v");
var $cffd9ba5a0018841$var$_extends3 = $cffd9ba5a0018841$var$_interopRequireDefault($kUw6v);

var $lgNi9 = parcelRequire("lgNi9");
var $cffd9ba5a0018841$var$_isUndefined2 = $cffd9ba5a0018841$var$_interopRequireDefault($lgNi9);

var $lzTOS = parcelRequire("lzTOS");
var $cffd9ba5a0018841$var$_pickBy2 = $cffd9ba5a0018841$var$_interopRequireDefault($lzTOS);

var $9JXaU = parcelRequire("9JXaU");

var $kyRrk = parcelRequire("kyRrk");
var $cffd9ba5a0018841$var$_mapDataPayloadToContextPayload2 = $cffd9ba5a0018841$var$_interopRequireDefault($kyRrk);
function $cffd9ba5a0018841$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cffd9ba5a0018841$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $cffd9ba5a0018841$var$_isUndefined2.default)(a);
};
var $cffd9ba5a0018841$var$mapOperationalPayload = function mapOperationalPayload(payload) {
    var context = (0, $cffd9ba5a0018841$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $cffd9ba5a0018841$var$_pickBy2.default)((0, $cffd9ba5a0018841$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $cffd9ba5a0018841$var$isNotUndefined);
};
var $cffd9ba5a0018841$var$mapOperationalPayloadToClient = function mapOperationalPayloadToClient(payload) {
    var context = (0, $cffd9ba5a0018841$var$_mapDataPayloadToContextPayload2.default)(payload);
    var sourceName = payload.sourceName, sourceType = payload.sourceType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    if (!action || !actionSubject || !sourceName || !sourceType) return false;
    var source = sourceName + sourceType;
    return (0, $cffd9ba5a0018841$var$_pickBy2.default)((0, $cffd9ba5a0018841$var$_extends3.default)({}, context, {
        source: source,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $cffd9ba5a0018841$var$isNotUndefined);
};
var $cffd9ba5a0018841$var$fireAnalyticsOperationEventWithEvent = module.exports.fireAnalyticsOperationEventWithEvent = function fireAnalyticsOperationEventWithEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $cffd9ba5a0018841$var$_extends3.default)({}, $cffd9ba5a0018841$var$mapOperationalPayload(payload), {
        analyticsType: $9JXaU.OPERATIONAL_EVENT_TYPE
    })).fire();
};
var $cffd9ba5a0018841$var$fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationalEventWithClient = function fireAnalyticsOperationalEventWithClient(client, payload) {
    if (!client.sendOperationalEvent) throw new Error('No Operational event fired, sendOperationEvent doesnt exist');
    if (!(typeof client.sendOperationalEvent === 'function')) throw new Error('No Operational event fired, sendOperationEvent is not a function');
    var mappedPayload = $cffd9ba5a0018841$var$mapOperationalPayloadToClient(payload);
    if (!mappedPayload) throw new Error('No Operational event fired, missing payload attributes. Operational events require an action, actionSubject, sourceName and sourceType');
    return client.sendOperationalEvent(mappedPayload);
};
var $cffd9ba5a0018841$var$fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEvent = function fireAnalyticsOperationalEvent(data) {
    if (data.client) return $cffd9ba5a0018841$var$fireAnalyticsOperationalEventWithClient(data.client, data.payload);
    return $cffd9ba5a0018841$var$fireAnalyticsOperationEventWithEvent(data.analyticsEvent, data.payload);
};

});

parcelRegister("iLHzy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsScreenEvent = undefined;

var $kUw6v = parcelRequire("kUw6v");
var $da9e6a616a996623$var$_extends3 = $da9e6a616a996623$var$_interopRequireDefault($kUw6v);

var $lgNi9 = parcelRequire("lgNi9");
var $da9e6a616a996623$var$_isUndefined2 = $da9e6a616a996623$var$_interopRequireDefault($lgNi9);

var $lzTOS = parcelRequire("lzTOS");
var $da9e6a616a996623$var$_pickBy2 = $da9e6a616a996623$var$_interopRequireDefault($lzTOS);

var $9JXaU = parcelRequire("9JXaU");
function $da9e6a616a996623$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $da9e6a616a996623$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $da9e6a616a996623$var$_isUndefined2.default)(a);
};
var $da9e6a616a996623$var$mapPayload = function mapPayload(payload) {
    return (0, $da9e6a616a996623$var$_pickBy2.default)((0, $da9e6a616a996623$var$_extends3.default)({}, payload, payload.attributes, {
        attributes: undefined
    }), $da9e6a616a996623$var$isNotUndefined);
};
var $da9e6a616a996623$var$fireAnalyticsScreenEvent = module.exports.fireAnalyticsScreenEvent = function fireAnalyticsScreenEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $da9e6a616a996623$var$_extends3.default)({}, $da9e6a616a996623$var$mapPayload(payload || {}), {
        analyticsType: $9JXaU.SCREEN_EVENT_TYPE
    })).fire();
};

});

parcelRegister("cxbU2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsTrackEvent = undefined;

var $kUw6v = parcelRequire("kUw6v");
var $9201ccbd75c34550$var$_extends3 = $9201ccbd75c34550$var$_interopRequireDefault($kUw6v);

var $lgNi9 = parcelRequire("lgNi9");
var $9201ccbd75c34550$var$_isUndefined2 = $9201ccbd75c34550$var$_interopRequireDefault($lgNi9);

var $lzTOS = parcelRequire("lzTOS");
var $9201ccbd75c34550$var$_pickBy2 = $9201ccbd75c34550$var$_interopRequireDefault($lzTOS);

var $9JXaU = parcelRequire("9JXaU");

var $kyRrk = parcelRequire("kyRrk");
var $9201ccbd75c34550$var$_mapDataPayloadToContextPayload2 = $9201ccbd75c34550$var$_interopRequireDefault($kyRrk);
function $9201ccbd75c34550$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9201ccbd75c34550$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $9201ccbd75c34550$var$_isUndefined2.default)(a);
};
var $9201ccbd75c34550$var$mapPayload = function mapPayload(payload) {
    var context = (0, $9201ccbd75c34550$var$_mapDataPayloadToContextPayload2.default)(payload);
    var action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    return (0, $9201ccbd75c34550$var$_pickBy2.default)((0, $9201ccbd75c34550$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $9201ccbd75c34550$var$isNotUndefined);
};
var $9201ccbd75c34550$var$fireAnalyticsTrackEvent = module.exports.fireAnalyticsTrackEvent = function fireAnalyticsTrackEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $9201ccbd75c34550$var$_extends3.default)({}, $9201ccbd75c34550$var$mapPayload(payload), {
        analyticsType: $9JXaU.TRACK_EVENT_TYPE
    })).fire();
};

});

parcelRegister("gbMev", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsUiEvent = undefined;

var $kUw6v = parcelRequire("kUw6v");
var $bc931677bf28b2e1$var$_extends3 = $bc931677bf28b2e1$var$_interopRequireDefault($kUw6v);

var $lgNi9 = parcelRequire("lgNi9");
var $bc931677bf28b2e1$var$_isUndefined2 = $bc931677bf28b2e1$var$_interopRequireDefault($lgNi9);

var $lzTOS = parcelRequire("lzTOS");
var $bc931677bf28b2e1$var$_pickBy2 = $bc931677bf28b2e1$var$_interopRequireDefault($lzTOS);

var $9JXaU = parcelRequire("9JXaU");

var $kyRrk = parcelRequire("kyRrk");
var $bc931677bf28b2e1$var$_mapDataPayloadToContextPayload2 = $bc931677bf28b2e1$var$_interopRequireDefault($kyRrk);
function $bc931677bf28b2e1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bc931677bf28b2e1$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $bc931677bf28b2e1$var$_isUndefined2.default)(a);
};
/**
 * Analytics web react 2.0
 */ var $bc931677bf28b2e1$var$mapUiPayload = function mapUiPayload(payload) {
    var context = (0, $bc931677bf28b2e1$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $bc931677bf28b2e1$var$_pickBy2.default)((0, $bc931677bf28b2e1$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $bc931677bf28b2e1$var$isNotUndefined);
};
var $bc931677bf28b2e1$var$fireAnalyticsUiEvent = module.exports.fireAnalyticsUiEvent = function fireAnalyticsUiEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $bc931677bf28b2e1$var$_extends3.default)({}, $bc931677bf28b2e1$var$mapUiPayload(payload), {
        analyticsType: $9JXaU.UI_EVENT_TYPE
    })).fire();
};

});


parcelRegister("iTeBn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kUw6v = parcelRequire("kUw6v");
var $dc08b0ae0a8ff181$var$_extends3 = $dc08b0ae0a8ff181$var$_interopRequireDefault($kUw6v);

var $lgNi9 = parcelRequire("lgNi9");
var $dc08b0ae0a8ff181$var$_isUndefined2 = $dc08b0ae0a8ff181$var$_interopRequireDefault($lgNi9);

var $fbpGW = parcelRequire("fbpGW");
var $dc08b0ae0a8ff181$var$_last2 = $dc08b0ae0a8ff181$var$_interopRequireDefault($fbpGW);

var $eu1ij = parcelRequire("eu1ij");
var $dc08b0ae0a8ff181$var$_omitBy2 = $dc08b0ae0a8ff181$var$_interopRequireDefault($eu1ij);

var $9JXaU = parcelRequire("9JXaU");

var $al47U = parcelRequire("al47U");
function $dc08b0ae0a8ff181$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dc08b0ae0a8ff181$var$getActionSubjectForEventType = function getActionSubjectForEventType(event, analyticsType) {
    if (analyticsType === $9JXaU.TRACK_EVENT_TYPE) return (0, $al47U.getActionSubject)(event);
    return (0, $dc08b0ae0a8ff181$var$_last2.default)((0, $al47U.getComponents)(event));
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * AtlasKit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ module.exports.default = function(event) {
    var sources = (0, $al47U.getSources)(event);
    var analyticsType = (0, $al47U.getAnalyticsType)(event);
    var actionSubject = $dc08b0ae0a8ff181$var$getActionSubjectForEventType(event, analyticsType);
    var source = (0, $dc08b0ae0a8ff181$var$_last2.default)(sources);
    var action = (0, $al47U.getAction)(event);
    var attributes = (0, $dc08b0ae0a8ff181$var$_extends3.default)({}, (0, $al47U.getAttributes)(event), {
        namespaces: sources.join('.')
    });
    if (action === $9JXaU.PAGE_EVENT_ACTION || analyticsType === $9JXaU.SCREEN_EVENT_TYPE) return {
        type: $9JXaU.SCREEN_EVENT_TYPE,
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case $9JXaU.UI_EVENT_TYPE:
        case $9JXaU.TRACK_EVENT_TYPE:
        case $9JXaU.OPERATIONAL_EVENT_TYPE:
            var actionSubjectId = (0, $al47U.getActionSubjectId)(event);
            var containerId = (0, $dc08b0ae0a8ff181$var$_last2.default)((0, $al47U.getContainerIds)(event));
            var containerType = (0, $dc08b0ae0a8ff181$var$_last2.default)((0, $al47U.getContainerTypes)(event));
            var objectId = (0, $dc08b0ae0a8ff181$var$_last2.default)((0, $al47U.getObjectIds)(event));
            var objectType = (0, $dc08b0ae0a8ff181$var$_last2.default)((0, $al47U.getObjectTypes)(event));
            var tags = (0, $al47U.getTags)(event);
            return {
                type: analyticsType,
                payload: (0, $dc08b0ae0a8ff181$var$_omitBy2.default)({
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: source,
                    tags: tags,
                    containerType: containerType,
                    containerId: containerId,
                    objectType: objectType,
                    objectId: objectId,
                    attributes: attributes
                }, $dc08b0ae0a8ff181$var$_isUndefined2.default)
            };
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("al47U", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAction = module.exports.getAnalyticsType = module.exports.getActionSubjectId = module.exports.getObjectIds = module.exports.getObjectTypes = module.exports.getContainerIds = module.exports.getContainerTypes = module.exports.getTags = module.exports.getAttributes = module.exports.getSources = module.exports.getActionSubject = module.exports.getComponents = undefined;

var $hObjF = parcelRequire("hObjF");
var $786f110561048c6a$var$_objectWithoutProperties3 = $786f110561048c6a$var$_interopRequireDefault($hObjF);

var $euGak = parcelRequire("euGak");
var $786f110561048c6a$var$_merge2 = $786f110561048c6a$var$_interopRequireDefault($euGak);

var $eZ8ws = parcelRequire("eZ8ws");
var $786f110561048c6a$var$_uniq2 = $786f110561048c6a$var$_interopRequireDefault($eZ8ws);
function $786f110561048c6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $786f110561048c6a$var$extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $786f110561048c6a$var$extractFromEventPayload = function extractFromEventPayload(propertyName, event) {
    return event.payload[propertyName];
};
var $786f110561048c6a$var$extractFromPayloadOrContext = function extractFromPayloadOrContext(propertyName, event) {
    var payloadProp = $786f110561048c6a$var$extractFromEventPayload(propertyName, event);
    var contextProps = $786f110561048c6a$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
var $786f110561048c6a$var$extractPayloadAttributes = function extractPayloadAttributes(event) {
    var _event$payload = event.payload, tags = _event$payload.tags, actionSubjectId = _event$payload.actionSubjectId, containerType = _event$payload.containerType, containerId = _event$payload.containerId, objectType = _event$payload.objectType, objectId = _event$payload.objectId, analyticsType = _event$payload.analyticsType, name = _event$payload.name, action = _event$payload.action, actionSubject = _event$payload.actionSubject, attributes = (0, $786f110561048c6a$var$_objectWithoutProperties3.default)(_event$payload, [
        'tags',
        'actionSubjectId',
        'containerType',
        'containerId',
        'objectType',
        'objectId',
        'analyticsType',
        'name',
        'action',
        'actionSubject'
    ]);
    return attributes;
};
var $786f110561048c6a$var$getComponents = module.exports.getComponents = function getComponents(event) {
    return $786f110561048c6a$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
};
var $786f110561048c6a$var$getActionSubject = module.exports.getActionSubject = function getActionSubject(event) {
    return $786f110561048c6a$var$extractFromEventPayload('actionSubject', event);
};
var $786f110561048c6a$var$getSources = module.exports.getSources = function getSources(event) {
    return $786f110561048c6a$var$extractFromEventContext([
        'source'
    ], event);
};
var $786f110561048c6a$var$getAttributes = module.exports.getAttributes = function getAttributes(event) {
    return (0, $786f110561048c6a$var$_merge2.default)($786f110561048c6a$var$extractFromEventContext([
        'attributes'
    ], event).reduce(function(result, extraAttributes) {
        return (0, $786f110561048c6a$var$_merge2.default)(result, extraAttributes);
    }, {}), $786f110561048c6a$var$extractPayloadAttributes(event));
};
var $786f110561048c6a$var$getTags = module.exports.getTags = function getTags(event) {
    var tags = (0, $786f110561048c6a$var$_uniq2.default)($786f110561048c6a$var$extractFromEventContext([
        'tags'
    ], event).reduce(function(result, extraTags) {
        return result.concat(extraTags);
    }, []).concat($786f110561048c6a$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
var $786f110561048c6a$var$getContainerTypes = module.exports.getContainerTypes = function getContainerTypes(event) {
    return $786f110561048c6a$var$extractFromPayloadOrContext('containerType', event);
};
var $786f110561048c6a$var$getContainerIds = module.exports.getContainerIds = function getContainerIds(event) {
    return $786f110561048c6a$var$extractFromPayloadOrContext('containerId', event);
};
var $786f110561048c6a$var$getObjectTypes = module.exports.getObjectTypes = function getObjectTypes(event) {
    return $786f110561048c6a$var$extractFromPayloadOrContext('objectType', event);
};
var $786f110561048c6a$var$getObjectIds = module.exports.getObjectIds = function getObjectIds(event) {
    return $786f110561048c6a$var$extractFromPayloadOrContext('objectId', event);
};
// singluar extractors
var $786f110561048c6a$var$getActionSubjectId = module.exports.getActionSubjectId = function getActionSubjectId(event) {
    return $786f110561048c6a$var$extractFromEventPayload('actionSubjectId', event);
};
var $786f110561048c6a$var$getAnalyticsType = module.exports.getAnalyticsType = function getAnalyticsType(event) {
    return $786f110561048c6a$var$extractFromEventPayload('analyticsType', event);
};
var $786f110561048c6a$var$getAction = module.exports.getAction = function getAction(event) {
    return $786f110561048c6a$var$extractFromEventPayload('action', event);
};

});



parcelRegister("hCnLH", function(module, exports) {
$parcel$export(module.exports, "isAdvancedHelpCenter", () => $d36c218ba6d69218$export$a8032b4abe96a350);
$parcel$export(module.exports, "isUnifiedHelpHelpCenter", () => $d36c218ba6d69218$export$35fba107189c9761);
$parcel$export(module.exports, "isFlexiHCEnabledInDefaultHC", () => $d36c218ba6d69218$export$64db2d25a762d602);
$parcel$export(module.exports, "isDefaultHelpCenter", () => $d36c218ba6d69218$export$6770869865ec8ff4);
$parcel$export(module.exports, "isKoshEnabledForDefaultHelpCenter", () => $d36c218ba6d69218$export$f8bf208a2ec06357);
$parcel$export(module.exports, "isHelpCentersManagement", () => $d36c218ba6d69218$export$f20af57447c92bed);
$parcel$export(module.exports, "isCSMHelpCenter", () => $d36c218ba6d69218$export$3eacdddcf63bcdf9);
$parcel$export(module.exports, "getIsHelpHub", () => $d36c218ba6d69218$export$b4319ea987d17576);
$parcel$export(module.exports, "isJcsOnlyRestrictedRoute", () => $d36c218ba6d69218$export$ab40e3484f545b4f);
$parcel$export(module.exports, "getSlugForAdvancedHCFromArticleView", () => $d36c218ba6d69218$export$6287fcdbdaf12366);
$parcel$export(module.exports, "getSlugForHelpCenter", () => $d36c218ba6d69218$export$1487e10d6956fe03);

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $eDcdn = parcelRequire("eDcdn");

var $iW3CQ = parcelRequire("iW3CQ");
const $d36c218ba6d69218$export$a8032b4abe96a350 = ()=>{
    return (0, $eDcdn.getRelativeBasePath)().startsWith('/helpcenter') && !$d36c218ba6d69218$export$35fba107189c9761();
};
const $d36c218ba6d69218$export$64db2d25a762d602 = ()=>{
    return $d36c218ba6d69218$export$6770869865ec8ff4();
};
const $d36c218ba6d69218$export$6770869865ec8ff4 = ()=>{
    return (0, $eDcdn.getRelativeBasePath)().startsWith('/servicedesk/customer');
};
const $d36c218ba6d69218$export$f8bf208a2ec06357 = ()=>{
    return !$d36c218ba6d69218$export$6770869865ec8ff4();
};
const $d36c218ba6d69218$export$35fba107189c9761 = ()=>{
    return (0, $eDcdn.getRelativeBasePath)() === (0, $jcRK7.UNIFIED_HELP_CENTER_BASE_PATH);
};
const $d36c218ba6d69218$export$f20af57447c92bed = ()=>{
    return (0, $eDcdn.getRelativeBasePath)() === (0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH);
};
const $d36c218ba6d69218$export$3eacdddcf63bcdf9 = (helpCenterType)=>{
    return helpCenterType === 'CUSTOMER_SERVICE';
};
const $d36c218ba6d69218$export$b4319ea987d17576 = ()=>{
    return (0, $iW3CQ.getEnv)().helpCenterType === 'HELP_HUB';
};
const $d36c218ba6d69218$export$ab40e3484f545b4f = (customerAccountAvailability)=>{
    return $d36c218ba6d69218$export$6770869865ec8ff4() && customerAccountAvailability === 'JCS_ONLY' && (0, $lFpPv.isCsmAccessControlSplitEnabled)();
};
const $d36c218ba6d69218$export$6287fcdbdaf12366 = (url)=>{
    const pattern = $d36c218ba6d69218$export$3eacdddcf63bcdf9((0, $iW3CQ.getEnv)().helpCenterType) ? /https:\/\/.*?\/helpcenter\/([^/]+)\// : /https:\/\/.*?\/helpcenter\/([^/]+)\/portal\//;
    const match = url.match(pattern);
    return match && match[1] ? match[1] : undefined;
};
const $d36c218ba6d69218$export$1487e10d6956fe03 = ()=>{
    const pattern = /\/helpcenter\/([^/?]*)/;
    const match = (0, $eDcdn.getRelativeBasePath)().match(pattern);
    return match && match[1] ? match[1] : undefined;
};

});
parcelRegister("jcRK7", function(module, exports) {
$parcel$export(module.exports, "USER_TYPING_DEBOUNCE_TIME", () => $8aa3bfc1d48e4e0c$export$c5b77883736a2a29);
$parcel$export(module.exports, "SELECTED_SECTION_BORDER_WIDTH", () => $8aa3bfc1d48e4e0c$export$57e6e5c7bcaced24);
$parcel$export(module.exports, "HTTP", () => $8aa3bfc1d48e4e0c$export$ee9d07cf1658f1a7);
$parcel$export(module.exports, "SPINNER_DELAY", () => $8aa3bfc1d48e4e0c$export$fb1d6648e4d00b79);
$parcel$export(module.exports, "ScreenName", () => $8aa3bfc1d48e4e0c$export$acfa120f168ab3f8);
$parcel$export(module.exports, "RouteName", () => $8aa3bfc1d48e4e0c$export$bfbea4d618559e4a);
$parcel$export(module.exports, "RoutePath", () => $8aa3bfc1d48e4e0c$export$1b64c75ea7ed0865);
$parcel$export(module.exports, "ExperienceName", () => $8aa3bfc1d48e4e0c$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "BrowserMetricViewName", () => $8aa3bfc1d48e4e0c$export$d28ca3cbca982562);
$parcel$export(module.exports, "EngagementMessages", () => $8aa3bfc1d48e4e0c$export$a0841dbe900de5cb);
$parcel$export(module.exports, "EngagementMessagesTarget", () => $8aa3bfc1d48e4e0c$export$e396ee6d05cbdca4);
$parcel$export(module.exports, "PORTAL_PARENT_PRODUCT", () => $8aa3bfc1d48e4e0c$export$218d9cffbbd32919);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SHIM_URL", () => $8aa3bfc1d48e4e0c$export$4ef7b134a809306c);
$parcel$export(module.exports, "UNIFIED_HELP_CENTER_BASE_PATH", () => $8aa3bfc1d48e4e0c$export$edfbc36787ce1acb);
$parcel$export(module.exports, "HELP_CENTERS_MANAGEMENT_BASE_PATH", () => $8aa3bfc1d48e4e0c$export$f9a9f80d0023ea53);
$parcel$export(module.exports, "VA_ON_HC_CONVERSATION_PATH", () => $8aa3bfc1d48e4e0c$export$640d6db9adfb1ee9);
$parcel$export(module.exports, "VA_ON_PORTAL_CONVERSATION_PATH", () => $8aa3bfc1d48e4e0c$export$ea450ea04b439b84);
$parcel$export(module.exports, "DEFAULT_HELP_CENTER_TYPE", () => $8aa3bfc1d48e4e0c$export$e2ce1da1cf52c1f4);
$parcel$export(module.exports, "DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY", () => $8aa3bfc1d48e4e0c$export$c7ac69203430ee56);
// This file contains re-used UI view related constants
/* The amount of time to wait before doing some work that is triggered by user typing */ const $8aa3bfc1d48e4e0c$export$c5b77883736a2a29 = 500;
const $8aa3bfc1d48e4e0c$export$57e6e5c7bcaced24 = 1.5;
const $8aa3bfc1d48e4e0c$export$ee9d07cf1658f1a7 = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    OFFLINE: 0,
    SERVER: 500,
    UNAUTHORIZED: 401
};
const $8aa3bfc1d48e4e0c$export$fb1d6648e4d00b79 = 300;
var $8aa3bfc1d48e4e0c$export$acfa120f168ab3f8 = /*#__PURE__*/ function(ScreenName) {
    ScreenName["HELP_CENTER"] = "portalHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_SIDEBAR"] = "portalCustomizeHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeHelpCenterAnnouncement";
    ScreenName["HELP_CENTER_VSA_CHAT_SIDEBAR"] = "portalCustomizeHelpCenterVsaChatSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOOK_AND_FEEL_SIDEBAR"] = "portalCustomizeLookAndFeelSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOGIN_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeLoginAnnouncementSidebar";
    ScreenName["HELP_CENTERS_MANAGEMENT"] = "helpCentersManagement";
    ScreenName["HELP_HUBS_MANAGEMENT"] = "helpHubsManagement";
    ScreenName["HELP_CENTER_MIGRATION_WIZARD_SELECT"] = "helpCenterMigrationWizardSelect";
    ScreenName["HELP_CENTER_MIGRATION_WIZARD_REVIEW"] = "helpCenterMigrationWizardReview";
    ScreenName["HELP_CENTER_MIGRATION_WIZARD_UPDATE"] = "helpCenterMigrationWizardUpdate";
    ScreenName["EDIT_HELP_CENTER"] = "helpCenterEditDetails";
    ScreenName["MANAGE_PROJECTS"] = "helpCenterManageProjects";
    ScreenName["MANAGE_PAGES"] = "helpCenterManagePages";
    ScreenName["FEEDBACK"] = "portalRequestFeedback";
    ScreenName["FEEDBACK_SUBMITTED"] = "portalRequestFeedbackCommentSubmitted";
    ScreenName["LOGIN"] = "portalLogin";
    ScreenName["LOGIN_PASSWORD"] = "portalLoginPassword";
    ScreenName["LOGIN_FORGOT_PASSWORD_CONFIRMATION"] = "portalLoginForgotPasswordConfirmation";
    ScreenName["LOGIN_SINGLE_SIGN_ON"] = "portalLoginSingleSignOn";
    ScreenName["LOGIN_SINGLE_SIGN_ON_CUSTOMER"] = "portalLoginSingleSignOnCustomer";
    ScreenName["LOGIN_ACTION"] = "portalLoginAction";
    ScreenName["LOGIN_ANNOUNCEMENT_CARD"] = "portalLoginAnnouncementCard";
    ScreenName["LOGIN_SSO_TEST_MODE_ERROR"] = "portalLoginSsoTestModeError";
    ScreenName["RESET_PASSWORD"] = "portalResetPassword";
    ScreenName["UNSUBSCRIBE"] = "portalUnsubscribeConfirmation";
    ScreenName["REQUEST_CREATE"] = "portalRequestCreate";
    ScreenName["REQUEST_DETAILS"] = "portalRequestDetails";
    ScreenName["REQUEST_LIST"] = "portalRequests";
    ScreenName["APPROVAL_LIST"] = "portalApprovals";
    ScreenName["KNOWLEDGE_CATEGORY"] = "categoryPage";
    ScreenName["REQUEST_CREATE_ANONYMOUS_SUCCESS"] = "requestCreateAnonymousSuccess";
    ScreenName["PORTAL_HOME"] = "singlePortal";
    ScreenName["REQUEST_GROUP_LIST"] = "requestGroupList";
    ScreenName["REQUEST_GROUP"] = "requestGroup";
    ScreenName["SIGNUP"] = "portalSignup";
    ScreenName["INVITED_SIGNUP"] = "portalAcceptInvite";
    ScreenName["COMPLETE_SIGNUP"] = "portalCompleteSignup";
    ScreenName["VERIFY_EMAIL"] = "portalVerifyEmail";
    ScreenName["COMPLETE_SIGNUP_TOKEN_EXPIRED"] = "portalCompleteSignupTokenExpired";
    ScreenName["COMPLETE_SIGNUP_TOKEN_INVALID"] = "portalCompleteSignupTokenInvalid";
    ScreenName["CHECK_EMAIL"] = "portalValidateEmail";
    ScreenName["KNOWLEDGE_ARTICLE"] = "knowledgeArticle";
    ScreenName["KNOWLEDGE_ALL_SEARCH_RESULTS"] = "knowledgeAllSearchResults";
    ScreenName["USER_PROFILE"] = "portalProfile";
    ScreenName["ADD_ANNOUNCEMENT_SIDEBAR"] = "addAnnouncementSidebar";
    ScreenName["REQUEST_LIST_CUSTOMIZE_SIDEBAR"] = "requestListCustomizeSidebar";
    ScreenName["REQUEST_APPROVAL"] = "requestApproval";
    ScreenName["PORTAL_REORDER_SETTINGS"] = "portalReorderSettings";
    ScreenName["ERROR_NOT_FOUND"] = "errorNotFound";
    ScreenName["PORTAL_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeAnnouncementSidebar";
    ScreenName["VIEW_TOPIC"] = "viewTopic";
    ScreenName["VIEW_CUSTOM_PAGE"] = "viewCustomPage";
    ScreenName["EDIT_CUSTOM_PAGE"] = "editCustomPage";
    ScreenName["EDIT_TOPICS_LAYOUT"] = "editTopicsLayout";
    ScreenName["EDIT_TOPIC"] = "editTopic";
    ScreenName["PORTAL_ACCESS_FORBIDDEN"] = "PortalAccessForbidden";
    ScreenName["EMBED_REQUEST_CREATE"] = "embedRequestCreate";
    ScreenName["EMBED_LOGIN_SUCCESS"] = "embedLoginSuccess";
    ScreenName["EMBED_SINGLE_PORTAL"] = "embedSinglePortal";
    ScreenName["EMBED_KB_ARTICLE"] = "embedKBArticle";
    ScreenName["VIEW_HOMEPAGE"] = "portalHelpCenter";
    ScreenName["EDIT_HOMEPAGE"] = "editHomepage";
    ScreenName["EDIT_NEW_HELP_CENTER"] = "editNewHelpCenter";
    ScreenName["HELP_DESK_REPORTING"] = "helpDeskReporting";
    ScreenName["UNIFIED_HELP_HOME_PAGE"] = "unifiedHelpHomePage";
    ScreenName["UNIFIED_HELP_TEST_HARNESS"] = "unifiedHelpTestHarness";
    ScreenName["ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES"] = "addHelpContentKnowledgeResources";
    ScreenName["ADD_HELP_CONTENT_EXTERNAL_LINKS"] = "addHelpContentExternalLinks";
    ScreenName["HELP_CENTER_SEARCH"] = "PortalSearch";
    ScreenName["CONVERSATION_PAGE"] = "conversationPage";
    ScreenName["CONSENT_FORM_PAGE"] = "consentFormPage";
    ScreenName["AI_ANSWER"] = "aiAnswer";
    ScreenName["CSM_CONTACT_US"] = "csmContactUs";
    ScreenName["CSM_FOLDER"] = "csmFolder";
    ScreenName["CSM_REQUESTS_LIST"] = "csmRequestsList";
    ScreenName["CSM_REQUEST_DETAILS"] = "csmRequestDetails";
    ScreenName["CSM_VIEW_HOMEPAGE"] = "csmViewHomepage";
    ScreenName["EMBED_FEATURED_PORTALS"] = "embedFeaturedPortals";
    ScreenName["VIRTUAL_SERVICE_AGENT_HEADER"] = "virtualServiceAgentHeader";
    ScreenName["TOPIC_ITEM_HOMEPAGE"] = "topicItemHomepage";
    ScreenName["TOPIC_ITEM"] = "topicItem";
    ScreenName["OMNICHANNEL_CONVERSATION_SOURCES"] = "omnichannelConversationSources";
    ScreenName["SURVEY"] = "survey";
    return ScreenName;
}({});
var $8aa3bfc1d48e4e0c$export$bfbea4d618559e4a = /*#__PURE__*/ function(RouteName) {
    RouteName["VIEW_CUSTOM_PAGE"] = "view-custom-page";
    RouteName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    RouteName["CSM_CONTACT_US_PAGE"] = "contact-us";
    RouteName["CSM_FOLDER_PAGE"] = "csm-folder";
    RouteName["CSM_REQUESTS_LIST_PAGE"] = "csm-requests-list";
    RouteName["CSM_REQUEST_DETAILS_PAGE"] = "csm-request-details";
    return RouteName;
}({});
var $8aa3bfc1d48e4e0c$export$1b64c75ea7ed0865 = /*#__PURE__*/ function(RoutePath) {
    RoutePath["VIEW_CUSTOM_PAGE"] = "/page/:id/:title?";
    RoutePath["EDIT_CUSTOM_PAGE"] = "/page/edit/:id/:title?";
    RoutePath["CSM_CONTACT_US_PATH"] = "/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?";
    RoutePath["CSM_FOLDER_PATH"] = "/folder/:folderId";
    RoutePath["CSM_REQUESTS_LIST_PATH"] = "/user/requests";
    RoutePath["CSM_REQUEST_DETAILS_PATH"] = "/user/requests/:requestKey";
    return RoutePath;
}({});
var $8aa3bfc1d48e4e0c$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REQUEST_CREATE"] = "request-create";
    ExperienceName["HELP_CENTER"] = "view-help-center";
    ExperienceName["CUSTOM_PAGE"] = "view-custom-page";
    ExperienceName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    ExperienceName["FEATURED_AND_SORTED_PORTALS"] = "featured-and-sorted-portals";
    return ExperienceName;
}({});
var $8aa3bfc1d48e4e0c$export$d28ca3cbca982562 = /*#__PURE__*/ function(BrowserMetricViewName) {
    BrowserMetricViewName["REQUEST_DETAIL_VIEW"] = "request-detail";
    BrowserMetricViewName["COMMENT_EDITOR_VIEW"] = "comment-editor";
    return BrowserMetricViewName;
}({});
var $8aa3bfc1d48e4e0c$export$a0841dbe900de5cb = /*#__PURE__*/ function(EngagementMessages) {
    EngagementMessages["SIDEBAR_REFACTOR"] = "jsm-portal-sidebar-refactor";
    EngagementMessages["PORTAL_REORDER_EXPERIENCE"] = "jsm-portal-reordering-change-boarding";
    EngagementMessages["TOPICS"] = "jsm-customer-portal-topics";
    EngagementMessages["EXTERNAL_RESOURCES_IN_TOPICS"] = "external-resources-in-topics-pill";
    EngagementMessages["TOPICS_FOR_ALL"] = "topics-for-all-customisation";
    EngagementMessages["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "jsm_admins_help_center_settings_button";
    EngagementMessages["CHANGE_BOARD_ADMINS_FREE_AND_STANDARD_EDITION"] = "changeboarding_jsm_admins_home_free_std";
    EngagementMessages["CHANGE_BOARD_ADMINS_SINGLE_PORTAL_SCREEN"] = "changeboarding_jsm_admins_singleportal";
    EngagementMessages["CHANGE_BOARD_ADMINS_PREMIUM_ENTERPRISE"] = "changeboarding_jsm_admins_premium_entr";
    EngagementMessages["ONBOARD_VA_REPORTING"] = "va-reporting-changeboarding-message";
    EngagementMessages["ONBOARD_VA_ON_HC"] = "va-on-hc-onboarding-message";
    EngagementMessages["CHANGE_BOARD_VISUAL_REFRESH"] = "jsm-visual-refresh-changeboarding";
    EngagementMessages["INCREASED_FLEXIBILITY_CHANGEBOARDING"] = "jsm-increased-flexibility-changeboarding";
    return EngagementMessages;
}({});
var $8aa3bfc1d48e4e0c$export$e396ee6d05cbdca4 = /*#__PURE__*/ function(EngagementMessagesTarget) {
    EngagementMessagesTarget["CHANGE_BOARDING_SPOTLIGHT"] = "changeBoardingSpotLight";
    EngagementMessagesTarget["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "changeBoardHelpCenterSettingsButton";
    EngagementMessagesTarget["MUTLI_HC_CHANGE_BOARDING_SPOTLIGHT"] = "multihcDropdownChangeBoardingSpotlight";
    EngagementMessagesTarget["REPORTING_ONBOARDING_SPOTLIGHT"] = "reportingOnboardingSpotlight";
    EngagementMessagesTarget["VISUAL_REFRESH_CHANGEBOARDING_SPOTLIGHT"] = "visualRefreshChangeboardingSpotlight";
    return EngagementMessagesTarget;
}({});
const $8aa3bfc1d48e4e0c$export$218d9cffbbd32919 = 'JSM-Portal';
const $8aa3bfc1d48e4e0c$export$4ef7b134a809306c = '/plugins/servlet/servicedesk/customer/confluence/shim/';
const $8aa3bfc1d48e4e0c$export$edfbc36787ce1acb = '/helpcenter/unified';
const $8aa3bfc1d48e4e0c$export$f9a9f80d0023ea53 = '/helpcenter-management';
const $8aa3bfc1d48e4e0c$export$640d6db9adfb1ee9 = '/conversation';
const $8aa3bfc1d48e4e0c$export$ea450ea04b439b84 = '/portal/:portalId/conversation';
const $8aa3bfc1d48e4e0c$export$e2ce1da1cf52c1f4 = 'BASIC';
const $8aa3bfc1d48e4e0c$export$c7ac69203430ee56 = 'JSM_AND_JCS';

});

parcelRegister("lFpPv", function(module, exports) {
$parcel$export(module.exports, "RICH_TEXT_AREA_FIELD", () => $f12eb80ec5c8a47b$export$706f525b497c4077);
$parcel$export(module.exports, "UNIFIED_HELP_ADD_FILTER_FOR_CUSTOMER_ACCOUNTS", () => $f12eb80ec5c8a47b$export$a1c6198e9bfea49a);
$parcel$export(module.exports, "JSM_VIRTUAL_AGENT_ANONYMOUS_ACCESS", () => $f12eb80ec5c8a47b$export$56132373c73141db);
$parcel$export(module.exports, "JSM_SCALE_60K_AGG_BRANCH_OVERRIDE_IN_HELP_CENTER", () => $f12eb80ec5c8a47b$export$5681240cc1c04856);
$parcel$export(module.exports, "HELP_CENTER_REFRESH_FLAG", () => $f12eb80ec5c8a47b$export$cb73a351cc03929f);
$parcel$export(module.exports, "EMAIL_VERIFIED_SIGNAL_ON_CUSTOMERS_PAGE", () => $f12eb80ec5c8a47b$export$660d24662c32371a);
$parcel$export(module.exports, "ENABLE_INCREASED_FLEXIBILITY", () => $f12eb80ec5c8a47b$export$13d57865c16811e5);
$parcel$export(module.exports, "ENABLE_FOLLOWUP_QUESTIONS_ON_PORTAL", () => $f12eb80ec5c8a47b$export$40e944519b773806);
$parcel$export(module.exports, "HELP_CENTER_REQUEST_FORM_CANCEL_GO_BACK", () => $f12eb80ec5c8a47b$export$e874e1f01d2682ad);
$parcel$export(module.exports, "isEmailVerifiedSignalEnabled", () => $f12eb80ec5c8a47b$export$d418c5a93f5a612e);
$parcel$export(module.exports, "isWrmOptimizationsEnabled", () => $f12eb80ec5c8a47b$export$9d40c615991b681d);
$parcel$export(module.exports, "isRichTextAreaEnabled", () => $f12eb80ec5c8a47b$export$ed104cfad45df81c);
$parcel$export(module.exports, "islooselyLazyJsErrorsToSentryEnabled", () => $f12eb80ec5c8a47b$export$bf2b9f47d2bc9d17);
$parcel$export(module.exports, "isCustomThemingEnabled", () => $f12eb80ec5c8a47b$export$dbb8ae3ec0512e12);
$parcel$export(module.exports, "isUnifiedHelpAddFilterForCustomerAccounts", () => $f12eb80ec5c8a47b$export$4fd1074ca1df827a);
$parcel$export(module.exports, "isFixRelayIdConflictInHelpCenter", () => $f12eb80ec5c8a47b$export$65c1b2a8a68046aa);
$parcel$export(module.exports, "isFixRelayIdConflictForHelpObjectStoreEnabled", () => $f12eb80ec5c8a47b$export$73a498f76aad8d2);
$parcel$export(module.exports, "isJsmScale60KAggBranchOverrideInHelpCenterEnabled", () => $f12eb80ec5c8a47b$export$56a24c7fc09b6e91);
$parcel$export(module.exports, "isSendRawHelpCenterTypeInAnalyticsEnabled", () => $f12eb80ec5c8a47b$export$5dccb020251579a1);
$parcel$export(module.exports, "isCsmAccessControlSplitEnabled", () => $f12eb80ec5c8a47b$export$27c460ed295f06bd);
$parcel$export(module.exports, "isAiWidgetTeam25Enabled", () => $f12eb80ec5c8a47b$export$4b18120aa62097f1);
$parcel$export(module.exports, "isUpdateArticlesLinkCsmEnabled", () => $f12eb80ec5c8a47b$export$19229ae1da4441b0);
$parcel$export(module.exports, "isCsmAppification", () => $f12eb80ec5c8a47b$export$24a6eb68da6f8093);
$parcel$export(module.exports, "isCsmForgeCustomFieldJsmContextTokenEnabled", () => $f12eb80ec5c8a47b$export$e14aa568fba1011a);
$parcel$export(module.exports, "isCrossSiteConnieConnectionEnabled", () => $f12eb80ec5c8a47b$export$8cfd0c7691c6e406);
$parcel$export(module.exports, "isKbArticlesSameTabRedirectionEnabled", () => $f12eb80ec5c8a47b$export$6bf26299f5ce3574);
$parcel$export(module.exports, "isKbArticleLinkNavigationAnalyticsEnabled", () => $f12eb80ec5c8a47b$export$f2a655096a17a876);
$parcel$export(module.exports, "isVirtualAgentHeaderButtonEnabled", () => $f12eb80ec5c8a47b$export$ae66df261c55d7b5);
$parcel$export(module.exports, "isRetryMechanismTuningEnabled", () => $f12eb80ec5c8a47b$export$484a220addce746c);
$parcel$export(module.exports, "isProformaTTVCUpdateMeasureEnabled", () => $f12eb80ec5c8a47b$export$f1047a0c2946b9);
$parcel$export(module.exports, "isVAOnHelpCenterGAEnabled", () => $f12eb80ec5c8a47b$export$34d4b53afdfa223d);
$parcel$export(module.exports, "isConsumeLooselyLazyManifestInSSREnabled", () => $f12eb80ec5c8a47b$export$a9795343511ea5c1);
$parcel$export(module.exports, "isMigrateToAnalyticsBridgeEnabled", () => $f12eb80ec5c8a47b$export$6ef513d6f7be5888);
$parcel$export(module.exports, "isDefaultHCUsingGqlBrandingCalls", () => $f12eb80ec5c8a47b$export$d10ba47ac271b5fb);
$parcel$export(module.exports, "isUseHelpCenterRefresh", () => $f12eb80ec5c8a47b$export$6c961d647d8a8d16);
$parcel$export(module.exports, "isDraftArticleSuggestionsEnabled", () => $f12eb80ec5c8a47b$export$edadb203ac2a6c5c);
$parcel$export(module.exports, "isForgeCustomFieldsOnPortalViewEnabled", () => $f12eb80ec5c8a47b$export$5998e12cd61e03e4);
$parcel$export(module.exports, "isUiModificationsSupportEnabled", () => $f12eb80ec5c8a47b$export$2b4c3a76f069fbf5);
$parcel$export(module.exports, "isTextFieldSupportEnabled", () => $f12eb80ec5c8a47b$export$97cf619b5c503901);
$parcel$export(module.exports, "isNumberFieldSupportEnabled", () => $f12eb80ec5c8a47b$export$5377338157c93a4a);
$parcel$export(module.exports, "isMultiCheckboxSupportEnabled", () => $f12eb80ec5c8a47b$export$d5cbe93dd4c558ea);
$parcel$export(module.exports, "isRadioButtonsSupportEnabled", () => $f12eb80ec5c8a47b$export$82589d303153590);
$parcel$export(module.exports, "isUserPickerEmailSupportEnabled", () => $f12eb80ec5c8a47b$export$2e53bb8a2a18dff0);
$parcel$export(module.exports, "isDateTimeSupportEnabled", () => $f12eb80ec5c8a47b$export$a3127feadc5f63ef);
$parcel$export(module.exports, "isDueDateSupportEnabled", () => $f12eb80ec5c8a47b$export$ca4e8050793caa6);
$parcel$export(module.exports, "isCascadingSelectSupportEnabled", () => $f12eb80ec5c8a47b$export$b738c6acf33d051a);
$parcel$export(module.exports, "isUserPickerSupportEnabled", () => $f12eb80ec5c8a47b$export$d16c700a701ab994);
$parcel$export(module.exports, "cascadingSelectDefaultValueSupportEnabled", () => $f12eb80ec5c8a47b$export$5621e5c6b3b162df);
$parcel$export(module.exports, "isFollowupEnabledForPortal", () => $f12eb80ec5c8a47b$export$cd1b5399e7ea70f2);
$parcel$export(module.exports, "isAiAnswer24HourTimeoutEnabled", () => $f12eb80ec5c8a47b$export$6d74bd5fbad4512e);
$parcel$export(module.exports, "isIncreasedFlexibilityEnabled", () => $f12eb80ec5c8a47b$export$81ac031d5c9eadb5);
$parcel$export(module.exports, "isElementRendererSplitEnabled", () => $f12eb80ec5c8a47b$export$6a665c3fef32cc75);
$parcel$export(module.exports, "isOmnichannelEnabledForHC", () => $f12eb80ec5c8a47b$export$c008df611f489124);
$parcel$export(module.exports, "isItsmIssueRenamingEnabled", () => $f12eb80ec5c8a47b$export$54d7baed1ffc6f83);
$parcel$export(module.exports, "isItsmProjectRenamingEnabled", () => $f12eb80ec5c8a47b$export$bd371ef032bb50b4);
$parcel$export(module.exports, "isOmnichannelGreetingAPIEnabled", () => $f12eb80ec5c8a47b$export$59c4c8d95bf1eefc);
$parcel$export(module.exports, "isOmnichannelSubscriptionErrorpageEnabled", () => $f12eb80ec5c8a47b$export$492c9921026864bb);
$parcel$export(module.exports, "isRequestCreateSkipDropdownInitialOptionsCallEnabled", () => $f12eb80ec5c8a47b$export$4c0bb2a2e82edb28);
$parcel$export(module.exports, "isRequestFormCancelGoBackEnabled", () => $f12eb80ec5c8a47b$export$f8fd975718cb2aa1);
$parcel$export(module.exports, "isHideKbColumnEnabled", () => $f12eb80ec5c8a47b$export$787e10895d9b5b56);
$parcel$export(module.exports, "isVsaSettingsPerformanceImprovementsEnabled", () => $f12eb80ec5c8a47b$export$2803857b1fa00ccb);
$parcel$export(module.exports, "isTotalArticleCountEnabled", () => $f12eb80ec5c8a47b$export$dbf6a8ec8de99792);
$parcel$export(module.exports, "isHideVsaEndpointsEnabled", () => $f12eb80ec5c8a47b$export$5ee14c6848af11b8);
$parcel$export(module.exports, "isVsaAdoptionPortalChatSideBarEnabled", () => $f12eb80ec5c8a47b$export$4e32738a2a810c82);
$parcel$export(module.exports, "isHubsEnabledInHelpCenter", () => $f12eb80ec5c8a47b$export$b03e57f56b691f9d);
$parcel$export(module.exports, "isMultiSelectEnabled", () => $f12eb80ec5c8a47b$export$3d9060e51ab7079e);
$parcel$export(module.exports, "isJsmSurveysCoreFeatureEnabled", () => $f12eb80ec5c8a47b$export$a953b7b444ffe51e);
$parcel$export(module.exports, "isJsmSurveysValidationErrorPayloadEnabled", () => $f12eb80ec5c8a47b$export$329f9fca12e617c6);
$parcel$export(module.exports, "isJsmSurveysGraphqlApiEnabled", () => $f12eb80ec5c8a47b$export$eed81849decd0ba1);
$parcel$export(module.exports, "isSurveysWorkItemSupportEnabled", () => $f12eb80ec5c8a47b$export$e405833c44e0e395);
$parcel$export(module.exports, "isSendWorkItemIdInPortalSurveyEnabled", () => $f12eb80ec5c8a47b$export$4e0d6992fd0d9087);
$parcel$export(module.exports, "isSurveyLandingAnalyticsEnabled", () => $f12eb80ec5c8a47b$export$5bc9fb66c3587063);
$parcel$export(module.exports, "isJsmPortalRovoIntegrationEnabled", () => $f12eb80ec5c8a47b$export$c2b1b7c65c5a4a75);
$parcel$export(module.exports, "isDatePickerSupportEnabled", () => $f12eb80ec5c8a47b$export$1df7079ae40c80e4);
$parcel$export(module.exports, "isRovoAgentsToolsConfigM2Enabled", () => $f12eb80ec5c8a47b$export$ea979393725a029);
$parcel$export(module.exports, "ROVO_SERVICE_AGENT_PUBLISH_ON_CREATE", () => $f12eb80ec5c8a47b$export$139a8bd6c6c64097);
$parcel$export(module.exports, "isRovoServiceAgentPublishOnCreateEnabled", () => $f12eb80ec5c8a47b$export$1106ac1af51b69ff);
$parcel$export(module.exports, "isStudioGsnAndScenarioRefreshEnabled", () => $f12eb80ec5c8a47b$export$a111e2ff03776b7c);
$parcel$export(module.exports, "isSkipProjectSectionInInstructionsEnabled", () => $f12eb80ec5c8a47b$export$feff9c08935da719);
$parcel$export(module.exports, "isRequestListInfiniteScrollEnabled", () => $f12eb80ec5c8a47b$export$46753c7d3f251473);
$parcel$export(module.exports, "isApprovalListInfiniteScrollEnabled", () => $f12eb80ec5c8a47b$export$e86f67505602f2f);
$parcel$export(module.exports, "isFooterCookiePreferencesEnabled", () => $f12eb80ec5c8a47b$export$c9ad679d2c6cf61d);
$parcel$export(module.exports, "isDateSelectionFixForOmnichannelEnabled", () => $f12eb80ec5c8a47b$export$ece9dbae592cbfe0);
/**
 * Define feature flag here as constants.
 *
 * export const KB_ENHANCEMENTS = 'jsd.px.kb-enhancements';
 *
 * Use them in react components.
 * import { KB_ENHANCEMENTS } from '@helpcenter/feature-flags';
 * import { FeatureFlag } from 'view/common/feature-flag';
 *
 * <FeatureFlag name={KB_ENHANCEMENTS}>
 *  I will be shown in true :-)
 * </FeatureFlag>
 *
 * ========== NOTE ===================
 * BE CAREFUL ADDING FEATURE FLAGS, IF YOU RENAME THEM IT WILL CHANGE THE ANALYTIC CONTEXT
 * NAME AND NO LONGER SEND THE SAME CONTEXT ATTRIBUTE NAME.
 * ===================================
 */ 
var $87QgR = parcelRequire("87QgR");
const $f12eb80ec5c8a47b$export$706f525b497c4077 = 'jsd-use-adf-default-value-for-textarea';
const $f12eb80ec5c8a47b$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB = 'make-kb-articles-open-in-same-tab';
const $f12eb80ec5c8a47b$var$KB_ARTICLE_LINK_NAVIGATION_ANALYTICS = 'kb_article_link_navigation_analytics';
const $f12eb80ec5c8a47b$export$a1c6198e9bfea49a = 'unified-help-add-filter-for-customer-accounts';
const $f12eb80ec5c8a47b$var$CSM_ACCESS_CONTROL_SPLIT = 'csm_access_control_split_take2';
const $f12eb80ec5c8a47b$var$AI_WIDGET_TEAM25 = 'berry-5094-ai-widget-support-website-team25';
const $f12eb80ec5c8a47b$var$CSM_ENABLE_FORGE_CUSTOM_FIELD_JSM_CONTEXT_TOKEN = 'csm_enable_forge_custom_field_jsm_context_token';
const $f12eb80ec5c8a47b$var$SEND_RAW_HELP_CENTER_TYPE_IN_ANALYTICS = 'help-center-fix-type-in-analytics';
const $f12eb80ec5c8a47b$export$56132373c73141db = 'anonymous_virtual_agent_access';
const $f12eb80ec5c8a47b$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER = 'fix_relay_id_conflict_in_help_center';
const $f12eb80ec5c8a47b$var$FIX_RELAY_ID_CONFLICT_FOR_HELP_OBJECT_STORE = 'fix_relay_id_conflict_for_help_object_store';
const $f12eb80ec5c8a47b$export$5681240cc1c04856 = 'jsm_scale_60k_agg_branch_override_in_help_center';
const $f12eb80ec5c8a47b$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT = 'tuning_model_retries';
const $f12eb80ec5c8a47b$var$ENABLE_CROSS_SITE_CONFLUENCE = 'enable-cross-site-confluence';
const $f12eb80ec5c8a47b$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED = 'measure_proforma_ttvc_impact';
const $f12eb80ec5c8a47b$var$CONSUME_LOOSELY_LAZY_MANIFEST_IN_SSR = 'consume_loosely_lazy_manifest_in_ssr';
const $f12eb80ec5c8a47b$var$DEFAULT_HC_USING_GQL_BRANDING = 'default_hc_using_gql_branding';
const $f12eb80ec5c8a47b$export$cb73a351cc03929f = 'enable_increased_flexibility'; // TODO: using same key as increased flexibility for bundle release
const $f12eb80ec5c8a47b$export$660d24662c32371a = 'sptn-1697-email-verified-signal-on-customers-page';
const $f12eb80ec5c8a47b$export$13d57865c16811e5 = 'enable_increased_flexibility';
const $f12eb80ec5c8a47b$export$40e944519b773806 = 'enable_followup_questions_on_omni_channel_portal';
const $f12eb80ec5c8a47b$export$e874e1f01d2682ad = 'help_center_request_form_cancel_go_back';
const $f12eb80ec5c8a47b$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL = 'request_create_dropdown_initial_options_call';
const $f12eb80ec5c8a47b$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN = 'hc_vsa_settings_hide_kb_article_column';
const $f12eb80ec5c8a47b$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS = 'hc_vsa_settings_performance_improvements';
const $f12eb80ec5c8a47b$var$TOTAL_ARTICLE_COUNT = 'hc_show_kb_total_article_count';
const $f12eb80ec5c8a47b$var$VSA_ADOPTION_TOUCHPOINT_HELP_CENTER = 'vsa-adoption-touchpoint-help-center';
const $f12eb80ec5c8a47b$var$HIDE_VSA_ENDPOINTS = 'hide_vsa_endpoints';
const $f12eb80ec5c8a47b$var$VSA_ADOPTION_CHAT_SIDE_BAR = 'vsa-adoption-portal-chat-side-bar';
const $f12eb80ec5c8a47b$var$ENABLE_HUBS_IN_HELP_CENTER = 'enable-hubs-in-help-center';
const $f12eb80ec5c8a47b$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT = 'ditto_uim_jsm_multi_select_support';
const $f12eb80ec5c8a47b$var$JSM_PORTAL_ROVO_INTEGRATION = 'jsm_portal_rovo_integration';
const $f12eb80ec5c8a47b$var$JSM_DATEPICKER_FIELD_SUPPORT = 'ditto_uim_jsm_datepicker_field_support';
const $f12eb80ec5c8a47b$var$JSM_SURVEYS_CORE_FEATURE = 'jsm_surveys_core_feature';
const $f12eb80ec5c8a47b$var$JSM_SURVEYS_GRAPHQL_API = 'jsm_surveys_graphql_api';
const $f12eb80ec5c8a47b$var$JSM_SURVEYS_VALIDATION_ERROR_PAYLOAD = 'jsm_surveys_validation_error_payload';
// Shared with the Jira side, which gates survey link enrichment on the same gate.
const $f12eb80ec5c8a47b$var$JSM_SURVEYS_WORK_ITEM_SUPPORT = 'enable-surveys-work-item-support';
// Portal-only (jsm-portal_web) counterpart of JSM_SURVEYS_WORK_ITEM_SUPPORT, which is not
// registered for the portal target app.
const $f12eb80ec5c8a47b$var$SEND_WORK_ITEM_ID_IN_PORTAL_SURVEY = 'send_workitem_id_in_portal_survey';
const $f12eb80ec5c8a47b$var$SURVEY_LANDING_ANALYTICS = 'add_analytics_for_survey_visited_with_work_item_';
const $f12eb80ec5c8a47b$var$ROVO_AGENTS_TOOLS_CONFIG_M2 = 'rovo_agents_tools_config_m2';
const $f12eb80ec5c8a47b$var$REQUEST_LIST_INFINITE_SCROLL = 'portal-6922-request-list-jsis-pagination';
const $f12eb80ec5c8a47b$var$APPROVAL_LIST_INFINITE_SCROLL = 'portal-approval-list-jsis-pagination';
const $f12eb80ec5c8a47b$export$d418c5a93f5a612e = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$660d24662c32371a);
};
const $f12eb80ec5c8a47b$export$9d40c615991b681d = ()=>true;
const $f12eb80ec5c8a47b$export$ed104cfad45df81c = ()=>(0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$706f525b497c4077);
const $f12eb80ec5c8a47b$export$bf2b9f47d2bc9d17 = ()=>(0, $87QgR.default).checkGate('throw_lazy_error_boundary_js_errors_to_sentry');
const $f12eb80ec5c8a47b$export$dbb8ae3ec0512e12 = ()=>false;
const $f12eb80ec5c8a47b$export$4fd1074ca1df827a = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$a1c6198e9bfea49a);
};
const $f12eb80ec5c8a47b$export$65c1b2a8a68046aa = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER);
};
const $f12eb80ec5c8a47b$export$73a498f76aad8d2 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$FIX_RELAY_ID_CONFLICT_FOR_HELP_OBJECT_STORE);
};
const $f12eb80ec5c8a47b$export$56a24c7fc09b6e91 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$5681240cc1c04856);
};
const $f12eb80ec5c8a47b$export$5dccb020251579a1 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$SEND_RAW_HELP_CENTER_TYPE_IN_ANALYTICS);
};
const $f12eb80ec5c8a47b$export$27c460ed295f06bd = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$CSM_ACCESS_CONTROL_SPLIT);
};
const $f12eb80ec5c8a47b$export$4b18120aa62097f1 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$AI_WIDGET_TEAM25);
};
const $f12eb80ec5c8a47b$export$19229ae1da4441b0 = ()=>{
    return (0, $87QgR.default).checkGate('update_articles_links_csm');
};
const $f12eb80ec5c8a47b$export$24a6eb68da6f8093 = ()=>{
    return (0, $87QgR.default).checkGate('csm_appification_standalone_navigation');
};
const $f12eb80ec5c8a47b$export$e14aa568fba1011a = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$CSM_ENABLE_FORGE_CUSTOM_FIELD_JSM_CONTEXT_TOKEN);
};
const $f12eb80ec5c8a47b$export$8cfd0c7691c6e406 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$ENABLE_CROSS_SITE_CONFLUENCE);
};
const $f12eb80ec5c8a47b$export$6bf26299f5ce3574 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB);
};
const $f12eb80ec5c8a47b$export$f2a655096a17a876 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$KB_ARTICLE_LINK_NAVIGATION_ANALYTICS);
};
const $f12eb80ec5c8a47b$export$ae66df261c55d7b5 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$VSA_ADOPTION_TOUCHPOINT_HELP_CENTER);
};
const $f12eb80ec5c8a47b$export$484a220addce746c = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT);
};
const $f12eb80ec5c8a47b$export$f1047a0c2946b9 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED);
};
const $f12eb80ec5c8a47b$export$34d4b53afdfa223d = ()=>{
    return (0, $87QgR.default).checkGate('va_on_help_center_ga');
};
const $f12eb80ec5c8a47b$export$a9795343511ea5c1 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$CONSUME_LOOSELY_LAZY_MANIFEST_IN_SSR);
};
const $f12eb80ec5c8a47b$export$6ef513d6f7be5888 = ()=>{
    return (0, $87QgR.default).checkGate('jsm-portal-migrate-to-analytics-bridge');
};
const $f12eb80ec5c8a47b$export$d10ba47ac271b5fb = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$DEFAULT_HC_USING_GQL_BRANDING);
};
const $f12eb80ec5c8a47b$export$6c961d647d8a8d16 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$cb73a351cc03929f);
};
const $f12eb80ec5c8a47b$export$edadb203ac2a6c5c = ()=>{
    return (0, $87QgR.default).checkGate('ai-answer-using-draft-article');
};
const $f12eb80ec5c8a47b$export$5998e12cd61e03e4 = ()=>(0, $87QgR.default).checkGate('forge_custom_fields_on_jsm_portal_view');
const $f12eb80ec5c8a47b$export$2b4c3a76f069fbf5 = ()=>(0, $87QgR.default).checkGate('ditto_uim_-_jsm_support_main');
const $f12eb80ec5c8a47b$export$97cf619b5c503901 = ()=>{
    return (0, $87QgR.default).checkGate('uim_jsm_textfield_support');
};
const $f12eb80ec5c8a47b$export$5377338157c93a4a = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_number_field_support');
};
const $f12eb80ec5c8a47b$export$d5cbe93dd4c558ea = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_multi_checkbox_support');
};
const $f12eb80ec5c8a47b$export$82589d303153590 = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_radio_buttons_support');
};
const $f12eb80ec5c8a47b$export$2e53bb8a2a18dff0 = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_user_picker_email');
};
const $f12eb80ec5c8a47b$export$a3127feadc5f63ef = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_datetime_field_support');
};
const $f12eb80ec5c8a47b$export$ca4e8050793caa6 = ()=>{
    return (0, $87QgR.default).checkGate('uim_jsm_duedate_support');
};
const $f12eb80ec5c8a47b$export$b738c6acf33d051a = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_cascading_select_support');
};
const $f12eb80ec5c8a47b$export$d16c700a701ab994 = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_user_picker_support');
};
const $f12eb80ec5c8a47b$export$5621e5c6b3b162df = ()=>{
    return (0, $87QgR.default).checkGate('ditto_uim_jsm_cascading_default_value_support');
};
const $f12eb80ec5c8a47b$export$cd1b5399e7ea70f2 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$40e944519b773806);
};
const $f12eb80ec5c8a47b$export$6d74bd5fbad4512e = ()=>{
    return (0, $87QgR.default).checkGate('ai_answer_default_timeout_to_24_hours');
};
const $f12eb80ec5c8a47b$export$81ac031d5c9eadb5 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$13d57865c16811e5);
};
const $f12eb80ec5c8a47b$export$6a665c3fef32cc75 = ()=>{
    return (0, $87QgR.default).checkGate('enable_element_renderer_split');
};
const $f12eb80ec5c8a47b$export$c008df611f489124 = ()=>{
    return (0, $87QgR.default).checkGate('enable_omni_channel_for_helpcenter');
};
const $f12eb80ec5c8a47b$export$54d7baed1ffc6f83 = ()=>{
    return (0, $87QgR.default).checkGate('itsm-issue-renaming');
};
const $f12eb80ec5c8a47b$export$bd371ef032bb50b4 = ()=>{
    return (0, $87QgR.default).checkGate('itsm-project-renaming');
};
const $f12eb80ec5c8a47b$export$59c4c8d95bf1eefc = ()=>{
    return (0, $87QgR.default).checkGate('jsm_chat_orchestrator_greeting_api_enabled');
};
const $f12eb80ec5c8a47b$export$492c9921026864bb = ()=>{
    return (0, $87QgR.default).checkGate('enable_omnichannel_subscription_error_page');
};
const $f12eb80ec5c8a47b$export$4c0bb2a2e82edb28 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL);
};
const $f12eb80ec5c8a47b$export$f8fd975718cb2aa1 = ()=>(0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$e874e1f01d2682ad);
const $f12eb80ec5c8a47b$export$787e10895d9b5b56 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN);
};
const $f12eb80ec5c8a47b$export$2803857b1fa00ccb = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS);
};
const $f12eb80ec5c8a47b$export$dbf6a8ec8de99792 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$TOTAL_ARTICLE_COUNT);
};
const $f12eb80ec5c8a47b$export$5ee14c6848af11b8 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$HIDE_VSA_ENDPOINTS);
};
const $f12eb80ec5c8a47b$export$4e32738a2a810c82 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$VSA_ADOPTION_CHAT_SIDE_BAR);
};
const $f12eb80ec5c8a47b$export$b03e57f56b691f9d = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$ENABLE_HUBS_IN_HELP_CENTER);
};
const $f12eb80ec5c8a47b$export$3d9060e51ab7079e = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT);
};
const $f12eb80ec5c8a47b$export$a953b7b444ffe51e = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$JSM_SURVEYS_CORE_FEATURE);
};
const $f12eb80ec5c8a47b$export$329f9fca12e617c6 = ()=>(0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$JSM_SURVEYS_VALIDATION_ERROR_PAYLOAD);
const $f12eb80ec5c8a47b$export$eed81849decd0ba1 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$JSM_SURVEYS_GRAPHQL_API);
};
const $f12eb80ec5c8a47b$export$e405833c44e0e395 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$JSM_SURVEYS_WORK_ITEM_SUPPORT);
};
const $f12eb80ec5c8a47b$export$4e0d6992fd0d9087 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$SEND_WORK_ITEM_ID_IN_PORTAL_SURVEY);
};
const $f12eb80ec5c8a47b$export$5bc9fb66c3587063 = ()=>(0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$SURVEY_LANDING_ANALYTICS);
const $f12eb80ec5c8a47b$export$c2b1b7c65c5a4a75 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$JSM_PORTAL_ROVO_INTEGRATION);
};
const $f12eb80ec5c8a47b$export$1df7079ae40c80e4 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$JSM_DATEPICKER_FIELD_SUPPORT);
};
const $f12eb80ec5c8a47b$export$ea979393725a029 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$ROVO_AGENTS_TOOLS_CONFIG_M2);
};
const $f12eb80ec5c8a47b$export$139a8bd6c6c64097 = 'rovo-service-agent-publish-on-create';
const $f12eb80ec5c8a47b$export$1106ac1af51b69ff = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$export$139a8bd6c6c64097);
};
const $f12eb80ec5c8a47b$export$a111e2ff03776b7c = ()=>{
    return (0, $87QgR.default).checkGate('studio-gsn-and-scenario-refresh');
};
const $f12eb80ec5c8a47b$export$feff9c08935da719 = ()=>{
    return (0, $87QgR.default).checkGate('rsa-skip-project-section-in-instructions');
};
const $f12eb80ec5c8a47b$export$46753c7d3f251473 = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$REQUEST_LIST_INFINITE_SCROLL);
};
const $f12eb80ec5c8a47b$export$e86f67505602f2f = ()=>{
    return (0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$APPROVAL_LIST_INFINITE_SCROLL);
};
/**
 * Gates the cookie-preferences button in the help center footer.
 *
 * @rollout In progress
 * @owner Dropbears
 * @ticket BEARS-3044
 */ const $f12eb80ec5c8a47b$var$FOOTER_COOKIE_PREFERENCES = 'service-collection-customers-cookie-preferences';
const $f12eb80ec5c8a47b$export$c9ad679d2c6cf61d = ()=>(0, $87QgR.default).checkGate($f12eb80ec5c8a47b$var$FOOTER_COOKIE_PREFERENCES);
const $f12eb80ec5c8a47b$export$ece9dbae592cbfe0 = ()=>(0, $87QgR.default).checkGate('fix_date_selection_for_omnichannel');

});

parcelRegister("eDcdn", function(module, exports) {
$parcel$export(module.exports, "contextPath", () => $66f7eb44851f9f6d$export$bcb673b8a0b7ff6e);
$parcel$export(module.exports, "getRelativeBasePath", () => $66f7eb44851f9f6d$export$8bbd42317ee66540);
$parcel$export(module.exports, "getBasePath", () => $66f7eb44851f9f6d$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getBaseName", () => $66f7eb44851f9f6d$export$a8b0425edf52c70e);
$parcel$export(module.exports, "historyObservable", () => $66f7eb44851f9f6d$export$a43a1132874d88e3);
$parcel$export(module.exports, "default", () => $66f7eb44851f9f6d$export$2e2bcd8739ae039);

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("5lPCP");
var $kHwwG = parcelRequire("kHwwG");

var $53hm0 = parcelRequire("53hm0");

var $4U3zK = parcelRequire("4U3zK");

var $iW3CQ = parcelRequire("iW3CQ");
const $66f7eb44851f9f6d$export$bcb673b8a0b7ff6e = $53hm0.getMeta('context-path') || '';
const $66f7eb44851f9f6d$export$8bbd42317ee66540 = ()=>{
    if ((0, $iW3CQ.getEnv)().hasOwnProperty('relativeBaseUrl')) return (0, $iW3CQ.getEnv)().relativeBaseUrl;
    return '/servicedesk/customer';
};
const $66f7eb44851f9f6d$export$9099264ed9b1c55a = ()=>{
    if ((0, $iW3CQ.getEnv)().hasOwnProperty('baseUrl')) return (0, $iW3CQ.getEnv)().baseUrl;
    return `${$66f7eb44851f9f6d$export$bcb673b8a0b7ff6e}${$66f7eb44851f9f6d$export$8bbd42317ee66540()}`;
};
const $66f7eb44851f9f6d$export$e75259171a9ba0d5 = (url)=>{
    return url.replace('/servicedesk/customer', (0, $iW3CQ.getEnv)().relativeBaseUrl);
};
const $66f7eb44851f9f6d$export$c4e6c35f2dffd087 = (url)=>{
    return url.replace((0, $iW3CQ.getEnv)().relativeBaseUrl, '/servicedesk/customer');
};
const $66f7eb44851f9f6d$export$a8b0425edf52c70e = ()=>`${$66f7eb44851f9f6d$export$bcb673b8a0b7ff6e}${$66f7eb44851f9f6d$export$8bbd42317ee66540()}`;
const $66f7eb44851f9f6d$var$history = (0, $4U3zK.default).isRunningInSnapvmRuntime() ? (0, $kHwwG.createMemoryHistory)({
    initialEntries: [
        $66f7eb44851f9f6d$export$a8b0425edf52c70e()
    ]
}) : (0, $kHwwG.createBrowserHistory)({
    basename: $66f7eb44851f9f6d$export$a8b0425edf52c70e()
});
const $66f7eb44851f9f6d$export$a43a1132874d88e3 = (0, $8jOUp.Observable).create((observer)=>{
    $66f7eb44851f9f6d$var$history.listen((location, action)=>observer.next({
            location: location,
            action: action
        }));
});
var $66f7eb44851f9f6d$export$2e2bcd8739ae039 = $66f7eb44851f9f6d$var$history;

});
parcelRegister("8jOUp", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $60e7968522acf29d$export$77cea355fa80b5f4, (v) => $60e7968522acf29d$export$77cea355fa80b5f4 = v);
var $60e7968522acf29d$export$77cea355fa80b5f4;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");

var $kevZu = parcelRequire("kevZu");

var $8omzy = parcelRequire("8omzy");

var $2b9KJ = parcelRequire("2b9KJ");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $60e7968522acf29d$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $kevZu.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($a5Mzo.root.Rx && $a5Mzo.root.Rx.config && $a5Mzo.root.Rx.config.Promise) PromiseCtor = $a5Mzo.root.Rx.config.Promise;
            else if ($a5Mzo.root.Promise) PromiseCtor = $a5Mzo.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$8omzy.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $2b9KJ.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($a5Mzo.root.Rx && $a5Mzo.root.Rx.config && $a5Mzo.root.Rx.config.Promise) PromiseCtor = $a5Mzo.root.Rx.config.Promise;
            else if ($a5Mzo.root.Promise) PromiseCtor = $a5Mzo.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$60e7968522acf29d$export$77cea355fa80b5f4 = $60e7968522acf29d$var$Observable;

});
parcelRegister("a5Mzo", function(module, exports) {
$parcel$export(module.exports, "root", () => $75900bf39ed6397a$export$e8e78c978b129247, (v) => $75900bf39ed6397a$export$e8e78c978b129247 = v);
var $75900bf39ed6397a$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $75900bf39ed6397a$var$__window = typeof window !== 'undefined' && window;
var $75900bf39ed6397a$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $75900bf39ed6397a$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $75900bf39ed6397a$var$_root = $75900bf39ed6397a$var$__window || $75900bf39ed6397a$var$__global || $75900bf39ed6397a$var$__self;
$75900bf39ed6397a$export$e8e78c978b129247 = $75900bf39ed6397a$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$75900bf39ed6397a$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});

parcelRegister("kevZu", function(module, exports) {
$parcel$export(module.exports, "toSubscriber", () => $ebadee242774afad$export$2a12c2cebbfd1087, (v) => $ebadee242774afad$export$2a12c2cebbfd1087 = v);
var $ebadee242774afad$export$2a12c2cebbfd1087;
"use strict";

var $66gCN = parcelRequire("66gCN");

var $1HBFJ = parcelRequire("1HBFJ");

var $rxeKe = parcelRequire("rxeKe");
function $ebadee242774afad$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $66gCN.Subscriber) return nextOrObserver;
        if (nextOrObserver[$1HBFJ.rxSubscriber]) return nextOrObserver[$1HBFJ.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $66gCN.Subscriber($rxeKe.empty);
    return new $66gCN.Subscriber(nextOrObserver, error, complete);
}
$ebadee242774afad$export$2a12c2cebbfd1087 = $ebadee242774afad$var$toSubscriber;

});
parcelRegister("66gCN", function(module, exports) {
"use strict";
var $471032f28e8c9352$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dZ9NH = parcelRequire("dZ9NH");

var $aAAtt = parcelRequire("aAAtt");

var $rxeKe = parcelRequire("rxeKe");

var $1HBFJ = parcelRequire("1HBFJ");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $471032f28e8c9352$var$Subscriber = function(_super) {
    $471032f28e8c9352$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $rxeKe.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $rxeKe.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($471032f28e8c9352$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$1HBFJ.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $471032f28e8c9352$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $471032f28e8c9352$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$1HBFJ.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($aAAtt.Subscription);
module.exports.Subscriber = $471032f28e8c9352$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $471032f28e8c9352$var$SafeSubscriber = function(_super) {
    $471032f28e8c9352$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($dZ9NH.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $rxeKe.empty) {
                context = Object.create(observerOrNext);
                if ($dZ9NH.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($471032f28e8c9352$var$Subscriber);
function $471032f28e8c9352$var$isTrustedSubscriber(obj) {
    return obj instanceof $471032f28e8c9352$var$Subscriber || 'syncErrorThrowable' in obj && obj[$1HBFJ.rxSubscriber];
}

});
parcelRegister("dZ9NH", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $a2e89311fc9fdd5e$export$f6e2535fb5126e54, (v) => $a2e89311fc9fdd5e$export$f6e2535fb5126e54 = v);
var $a2e89311fc9fdd5e$export$f6e2535fb5126e54;
"use strict";
function $a2e89311fc9fdd5e$var$isFunction(x) {
    return typeof x === 'function';
}
$a2e89311fc9fdd5e$export$f6e2535fb5126e54 = $a2e89311fc9fdd5e$var$isFunction;

});

parcelRegister("aAAtt", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $7b598f34e1d11e2e$export$f55210826850c514, (v) => $7b598f34e1d11e2e$export$f55210826850c514 = v);
var $7b598f34e1d11e2e$export$f55210826850c514;
"use strict";

var $gWadc = parcelRequire("gWadc");

var $50N0M = parcelRequire("50N0M");

var $dZ9NH = parcelRequire("dZ9NH");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $g0zKH = parcelRequire("g0zKH");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $7b598f34e1d11e2e$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($dZ9NH.isFunction(_unsubscribe)) {
            var trial = $cxrX4.tryCatch(_unsubscribe).call(this);
            if (trial === $2afHm.errorObject) {
                hasErrors = true;
                errors = errors || ($2afHm.errorObject.e instanceof $g0zKH.UnsubscriptionError ? $7b598f34e1d11e2e$var$flattenUnsubscriptionErrors($2afHm.errorObject.e.errors) : [
                    $2afHm.errorObject.e
                ]);
            }
        }
        if ($gWadc.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($50N0M.isObject(sub)) {
                    var trial = $cxrX4.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $2afHm.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $2afHm.errorObject.e;
                        if (err instanceof $g0zKH.UnsubscriptionError) errors = errors.concat($7b598f34e1d11e2e$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $g0zKH.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$7b598f34e1d11e2e$export$f55210826850c514 = $7b598f34e1d11e2e$var$Subscription;
function $7b598f34e1d11e2e$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $g0zKH.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("gWadc", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $c549fbfbe8e4b72c$export$43bee75e5e14138e, (v) => $c549fbfbe8e4b72c$export$43bee75e5e14138e = v);
var $c549fbfbe8e4b72c$export$43bee75e5e14138e;
"use strict";
$c549fbfbe8e4b72c$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("50N0M", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $3a62f889ba9296fe$export$a6cdc56e425d0d0a, (v) => $3a62f889ba9296fe$export$a6cdc56e425d0d0a = v);
var $3a62f889ba9296fe$export$a6cdc56e425d0d0a;
"use strict";
function $3a62f889ba9296fe$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$3a62f889ba9296fe$export$a6cdc56e425d0d0a = $3a62f889ba9296fe$var$isObject;

});

parcelRegister("cxrX4", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $025b118b648d9acf$export$d234c058d1d4e435, (v) => $025b118b648d9acf$export$d234c058d1d4e435 = v);
var $025b118b648d9acf$export$d234c058d1d4e435;
"use strict";

var $2afHm = parcelRequire("2afHm");
var $025b118b648d9acf$var$tryCatchTarget;
function $025b118b648d9acf$var$tryCatcher() {
    try {
        return $025b118b648d9acf$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $2afHm.errorObject.e = e;
        return $2afHm.errorObject;
    }
}
function $025b118b648d9acf$var$tryCatch(fn) {
    $025b118b648d9acf$var$tryCatchTarget = fn;
    return $025b118b648d9acf$var$tryCatcher;
}
$025b118b648d9acf$export$d234c058d1d4e435 = $025b118b648d9acf$var$tryCatch;

});
parcelRegister("2afHm", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $1938b14d7206190b$export$fc504b39d7c1176, (v) => $1938b14d7206190b$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $1938b14d7206190b$export$fc504b39d7c1176;
"use strict";
$1938b14d7206190b$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("g0zKH", function(module, exports) {
"use strict";
var $ba78610d7592b2f3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $ba78610d7592b2f3$var$UnsubscriptionError = function(_super) {
    $ba78610d7592b2f3$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $ba78610d7592b2f3$var$UnsubscriptionError;

});


parcelRegister("rxeKe", function(module, exports) {
$parcel$export(module.exports, "empty", () => $052c4ddefbc93b08$export$6e22c362a0406a2c, (v) => $052c4ddefbc93b08$export$6e22c362a0406a2c = v);
var $052c4ddefbc93b08$export$6e22c362a0406a2c;
"use strict";
$052c4ddefbc93b08$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("1HBFJ", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $13d70782ee496177$export$77f77496d7cade10, (v) => $13d70782ee496177$export$77f77496d7cade10 = v);
var $13d70782ee496177$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $13d70782ee496177$export$4a2e07ff24d010f0;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
var $13d70782ee496177$var$Symbol = $a5Mzo.root.Symbol;
$13d70782ee496177$export$77f77496d7cade10 = typeof $13d70782ee496177$var$Symbol === 'function' && typeof $13d70782ee496177$var$Symbol.for === 'function' ? $13d70782ee496177$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$13d70782ee496177$export$4a2e07ff24d010f0 = $13d70782ee496177$export$77f77496d7cade10;

});



parcelRegister("8omzy", function(module, exports) {
$parcel$export(module.exports, "observable", () => $61c2131022a6df67$export$5ab46cbf6120b33a, (v) => $61c2131022a6df67$export$5ab46cbf6120b33a = v);
var $61c2131022a6df67$export$7e68bb2e8ecea8fe;
var $61c2131022a6df67$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $61c2131022a6df67$export$a7c40509ff863847;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
function $61c2131022a6df67$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$61c2131022a6df67$export$7e68bb2e8ecea8fe = $61c2131022a6df67$var$getSymbolObservable;
$61c2131022a6df67$export$5ab46cbf6120b33a = $61c2131022a6df67$var$getSymbolObservable($a5Mzo.root);
$61c2131022a6df67$export$a7c40509ff863847 = $61c2131022a6df67$export$5ab46cbf6120b33a;

});

parcelRegister("2b9KJ", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $19642c8e2e46cb8c$export$a4627e546088548d, (v) => $19642c8e2e46cb8c$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $19642c8e2e46cb8c$export$71f88a61afaa14d7, (v) => $19642c8e2e46cb8c$export$71f88a61afaa14d7 = v);
var $19642c8e2e46cb8c$export$a4627e546088548d;
var $19642c8e2e46cb8c$export$71f88a61afaa14d7;
"use strict";

var $chmr4 = parcelRequire("chmr4");
/* tslint:enable:max-line-length */ function $19642c8e2e46cb8c$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $19642c8e2e46cb8c$var$pipeFromArray(fns);
}
$19642c8e2e46cb8c$export$a4627e546088548d = $19642c8e2e46cb8c$var$pipe;
/* @internal */ function $19642c8e2e46cb8c$var$pipeFromArray(fns) {
    if (!fns) return $chmr4.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$19642c8e2e46cb8c$export$71f88a61afaa14d7 = $19642c8e2e46cb8c$var$pipeFromArray;

});
parcelRegister("chmr4", function(module, exports) {
$parcel$export(module.exports, "noop", () => $8f0879cba6d4bb43$export$8793edee2d425525, (v) => $8f0879cba6d4bb43$export$8793edee2d425525 = v);
var $8f0879cba6d4bb43$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $8f0879cba6d4bb43$var$noop() {}
$8f0879cba6d4bb43$export$8793edee2d425525 = $8f0879cba6d4bb43$var$noop;

});



parcelRegister("5lPCP", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => (parcelRequire("kHwwG")).createBrowserHistory);
$parcel$export(module.exports, "createMemoryHistory", () => (parcelRequire("kHwwG")).createMemoryHistory);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("it2qY")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("2a9Vu")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("a6Y7T")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("3Gmp6")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("liXIH")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("h1bGI")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("3DuDW")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("hbIgt")).withRouter);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("7t0F6")).RouteComponent);
$parcel$export(module.exports, "Link", () => (parcelRequire("3rmIb")).default);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("dQg9I")).generatePath);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("giOHo")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("giOHo")).useRouterStoreActions);
$parcel$export(module.exports, "createResource", () => (parcelRequire("iXC0o")).createResource);
$parcel$export(module.exports, "useResource", () => (parcelRequire("hMsRa")).useResource);

var $kHwwG = parcelRequire("kHwwG");
parcelRequire("fBrkg");
var $it2qY = parcelRequire("it2qY");
var $2a9Vu = parcelRequire("2a9Vu");
var $a6Y7T = parcelRequire("a6Y7T");
var $3Gmp6 = parcelRequire("3Gmp6");
var $liXIH = parcelRequire("liXIH");
var $h1bGI = parcelRequire("h1bGI");
var $3DuDW = parcelRequire("3DuDW");
var $hbIgt = parcelRequire("hbIgt");
parcelRequire("9nn9c");
var $3rmIb = parcelRequire("3rmIb");
var $7t0F6 = parcelRequire("7t0F6");
parcelRequire("4bmA3");
var $dQg9I = parcelRequire("dQg9I");

var $hjbmn = parcelRequire("hjbmn");

var $giOHo = parcelRequire("giOHo");

var $9Bssj = parcelRequire("9Bssj");
parcelRequire("iZLh2");
var $iXC0o = parcelRequire("iXC0o");
var $hMsRa = parcelRequire("hMsRa");

});
parcelRegister("kHwwG", function(module, exports) {
$parcel$export(module.exports, "parsePath", () => $f1210dcbb23ecec4$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createPath", () => $f1210dcbb23ecec4$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $f1210dcbb23ecec4$export$90c043f1c57770b8);
$parcel$export(module.exports, "createBrowserHistory", () => $f1210dcbb23ecec4$export$719fc203c4e16dee);
$parcel$export(module.exports, "createMemoryHistory", () => $f1210dcbb23ecec4$export$2b76ad033c6e6d08);

var $g8vBZ = parcelRequire("g8vBZ");

var $ljpBE = parcelRequire("ljpBE");

var $jGeF7 = parcelRequire("jGeF7");


var $jCkxO = parcelRequire("jCkxO");
function $f1210dcbb23ecec4$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $f1210dcbb23ecec4$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $f1210dcbb23ecec4$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $f1210dcbb23ecec4$var$stripBasename(path, prefix) {
    return $f1210dcbb23ecec4$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $f1210dcbb23ecec4$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $f1210dcbb23ecec4$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $f1210dcbb23ecec4$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $f1210dcbb23ecec4$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $f1210dcbb23ecec4$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $g8vBZ.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $ljpBE.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $f1210dcbb23ecec4$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $jGeF7.default)(a.state, b.state);
}
function $f1210dcbb23ecec4$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $f1210dcbb23ecec4$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $f1210dcbb23ecec4$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $f1210dcbb23ecec4$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $f1210dcbb23ecec4$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $f1210dcbb23ecec4$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $f1210dcbb23ecec4$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $f1210dcbb23ecec4$var$PopStateEvent = 'popstate';
var $f1210dcbb23ecec4$var$HashChangeEvent = 'hashchange';
function $f1210dcbb23ecec4$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $f1210dcbb23ecec4$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$f1210dcbb23ecec4$var$canUseDOM && (0, $jCkxO.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $f1210dcbb23ecec4$var$supportsHistory();
    var needsHashChangeListener = !$f1210dcbb23ecec4$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $f1210dcbb23ecec4$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $f1210dcbb23ecec4$var$stripTrailingSlash($f1210dcbb23ecec4$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $f1210dcbb23ecec4$var$stripBasename(path, basename);
        return $f1210dcbb23ecec4$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $f1210dcbb23ecec4$var$createTransitionManager();
    function setState(nextState) {
        (0, $g8vBZ.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($f1210dcbb23ecec4$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($f1210dcbb23ecec4$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($f1210dcbb23ecec4$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $f1210dcbb23ecec4$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $f1210dcbb23ecec4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $f1210dcbb23ecec4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($f1210dcbb23ecec4$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($f1210dcbb23ecec4$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($f1210dcbb23ecec4$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($f1210dcbb23ecec4$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $f1210dcbb23ecec4$var$HashChangeEvent$1 = 'hashchange';
var $f1210dcbb23ecec4$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $f1210dcbb23ecec4$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $f1210dcbb23ecec4$var$stripLeadingSlash,
        decodePath: $f1210dcbb23ecec4$var$addLeadingSlash
    },
    slash: {
        encodePath: $f1210dcbb23ecec4$var$addLeadingSlash,
        decodePath: $f1210dcbb23ecec4$var$addLeadingSlash
    }
};
function $f1210dcbb23ecec4$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $f1210dcbb23ecec4$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $f1210dcbb23ecec4$var$pushHashPath(path) {
    window.location.hash = path;
}
function $f1210dcbb23ecec4$var$replaceHashPath(path) {
    window.location.replace($f1210dcbb23ecec4$var$stripHash(window.location.href) + '#' + path);
}
function $f1210dcbb23ecec4$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$f1210dcbb23ecec4$var$canUseDOM && (0, $jCkxO.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $f1210dcbb23ecec4$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $f1210dcbb23ecec4$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $f1210dcbb23ecec4$var$stripTrailingSlash($f1210dcbb23ecec4$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $f1210dcbb23ecec4$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($f1210dcbb23ecec4$var$getHashPath());
        if (basename) path = $f1210dcbb23ecec4$var$stripBasename(path, basename);
        return $f1210dcbb23ecec4$export$90c043f1c57770b8(path);
    }
    var transitionManager = $f1210dcbb23ecec4$var$createTransitionManager();
    function setState(nextState) {
        (0, $g8vBZ.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $f1210dcbb23ecec4$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $f1210dcbb23ecec4$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $f1210dcbb23ecec4$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($f1210dcbb23ecec4$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($f1210dcbb23ecec4$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $f1210dcbb23ecec4$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $f1210dcbb23ecec4$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $f1210dcbb23ecec4$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $f1210dcbb23ecec4$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $f1210dcbb23ecec4$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $f1210dcbb23ecec4$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $f1210dcbb23ecec4$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $f1210dcbb23ecec4$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $f1210dcbb23ecec4$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($f1210dcbb23ecec4$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $f1210dcbb23ecec4$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $f1210dcbb23ecec4$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $f1210dcbb23ecec4$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $f1210dcbb23ecec4$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($f1210dcbb23ecec4$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($f1210dcbb23ecec4$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($f1210dcbb23ecec4$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $f1210dcbb23ecec4$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $f1210dcbb23ecec4$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $f1210dcbb23ecec4$var$createTransitionManager();
    function setState(nextState) {
        (0, $g8vBZ.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $f1210dcbb23ecec4$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $f1210dcbb23ecec4$export$90c043f1c57770b8(entry, undefined, createKey()) : $f1210dcbb23ecec4$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $f1210dcbb23ecec4$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $f1210dcbb23ecec4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $f1210dcbb23ecec4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $f1210dcbb23ecec4$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("g8vBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbf5ea23da546b49$export$2e2bcd8739ae039);
function $bbf5ea23da546b49$export$2e2bcd8739ae039() {
    return $bbf5ea23da546b49$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bbf5ea23da546b49$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("ljpBE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f83f3c2f9dd18c0e$export$2e2bcd8739ae039);
function $f83f3c2f9dd18c0e$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $f83f3c2f9dd18c0e$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $f83f3c2f9dd18c0e$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $f83f3c2f9dd18c0e$var$isAbsolute(to);
    var isFromAbs = from && $f83f3c2f9dd18c0e$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $f83f3c2f9dd18c0e$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $f83f3c2f9dd18c0e$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $f83f3c2f9dd18c0e$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $f83f3c2f9dd18c0e$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$f83f3c2f9dd18c0e$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $f83f3c2f9dd18c0e$export$2e2bcd8739ae039 = $f83f3c2f9dd18c0e$var$resolvePathname;

});

parcelRegister("jGeF7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e53d502d9524a847$export$2e2bcd8739ae039);
function $e53d502d9524a847$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $e53d502d9524a847$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $e53d502d9524a847$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $e53d502d9524a847$var$valueOf(a);
        var bValue = $e53d502d9524a847$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $e53d502d9524a847$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $e53d502d9524a847$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $e53d502d9524a847$export$2e2bcd8739ae039 = $e53d502d9524a847$var$valueEqual;

});

parcelRegister("jCkxO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e48180a19f9c59e9$export$2e2bcd8739ae039);
var $e48180a19f9c59e9$var$isProduction = true;
var $e48180a19f9c59e9$var$prefix = 'Invariant failed';
function $e48180a19f9c59e9$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($e48180a19f9c59e9$var$isProduction) throw new Error($e48180a19f9c59e9$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($e48180a19f9c59e9$var$prefix, ": ").concat(provided) : $e48180a19f9c59e9$var$prefix;
    throw new Error(value);
}

});


parcelRegister("fBrkg", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => (parcelRequire("it2qY")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("2a9Vu")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("a6Y7T")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("3Gmp6")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("liXIH")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("h1bGI")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("3DuDW")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("hbIgt")).withRouter);

var $it2qY = parcelRequire("it2qY");

var $2a9Vu = parcelRequire("2a9Vu");

var $eRf9Q = parcelRequire("eRf9Q");

var $a6Y7T = parcelRequire("a6Y7T");

var $giOHo = parcelRequire("giOHo");

var $3Gmp6 = parcelRequire("3Gmp6");

var $liXIH = parcelRequire("liXIH");

var $h1bGI = parcelRequire("h1bGI");

var $3DuDW = parcelRequire("3DuDW");

var $hbIgt = parcelRequire("hbIgt");

});
parcelRegister("it2qY", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $d71cd2c66968ac8c$export$2d8d895a0a0f636e);

var $g8vBZ = parcelRequire("g8vBZ");

var $98nNe = parcelRequire("98nNe");

var $kHwwG = parcelRequire("kHwwG");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("4bmA3");
var $3bxzQ = parcelRequire("3bxzQ");

var $h1bGI = parcelRequire("h1bGI");
class $d71cd2c66968ac8c$var$Redirector extends (0, $bSJIT.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $kHwwG.createPath)((0, $3bxzQ.generateLocationFromPath)(to.path, routeAttributes)) : (0, $kHwwG.createPath)(to) : to;
        const currentPath = (0, $kHwwG.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $98nNe.default)($d71cd2c66968ac8c$var$Redirector, "defaultProps", {
    push: false
});
const $d71cd2c66968ac8c$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $h1bGI.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d71cd2c66968ac8c$var$Redirector, (0, $g8vBZ.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("98nNe", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a675137e01510a4$export$2e2bcd8739ae039);

var $jq0BN = parcelRequire("jq0BN");
function $6a675137e01510a4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jq0BN.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jq0BN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e230eae406cc2f32$export$2e2bcd8739ae039);

var $2JMbT = parcelRequire("2JMbT");

var $5h6Kp = parcelRequire("5h6Kp");
function $e230eae406cc2f32$export$2e2bcd8739ae039(t) {
    var i = (0, $5h6Kp.default)(t, "string");
    return "symbol" == (0, $2JMbT.default)(i) ? i : i + "";
}

});
parcelRegister("5h6Kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d73c6378f05ce1a$export$2e2bcd8739ae039);

var $2JMbT = parcelRequire("2JMbT");
function $3d73c6378f05ce1a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2JMbT.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2JMbT.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("4bmA3", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("3bxzQ")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("dQg9I")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("Nt5no")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("eWW7v")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("67m70")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("67m70")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("2JZPC")).isSameRouteMatch);

var $aVniS = parcelRequire("aVniS");

var $3bxzQ = parcelRequire("3bxzQ");

var $dQg9I = parcelRequire("dQg9I");

var $Nt5no = parcelRequire("Nt5no");

var $eWW7v = parcelRequire("eWW7v");

var $67m70 = parcelRequire("67m70");

var $2JZPC = parcelRequire("2JZPC");

});
parcelRegister("aVniS", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $7f414dd80c4c5273$export$883c3f3b6c000133);

var $g8vBZ = parcelRequire("g8vBZ");

var $kHwwG = parcelRequire("kHwwG");

var $4kwMw = parcelRequire("4kwMw");

var $cBGms = parcelRequire("cBGms");
const $7f414dd80c4c5273$var$hasWindow = ()=>typeof window !== 'undefined';
const $7f414dd80c4c5273$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cBGms)))
};
const $7f414dd80c4c5273$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $7f414dd80c4c5273$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $7f414dd80c4c5273$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($4kwMw)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $7f414dd80c4c5273$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $7f414dd80c4c5273$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $7f414dd80c4c5273$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $g8vBZ.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $7f414dd80c4c5273$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $7f414dd80c4c5273$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $kHwwG.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $kHwwG.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $7f414dd80c4c5273$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
        createHref: (location)=>(0, $kHwwG.createPath)(location)
    } : $7f414dd80c4c5273$var$methodsPlaceholders);
};

});
parcelRegister("4kwMw", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $32727567fbef1eb5$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $32727567fbef1eb5$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $32727567fbef1eb5$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $32727567fbef1eb5$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $32727567fbef1eb5$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $32727567fbef1eb5$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $32727567fbef1eb5$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $32727567fbef1eb5$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $32727567fbef1eb5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $32727567fbef1eb5$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $32727567fbef1eb5$var$root = $32727567fbef1eb5$var$freeGlobal || $32727567fbef1eb5$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $32727567fbef1eb5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $32727567fbef1eb5$var$objectToString = $32727567fbef1eb5$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $32727567fbef1eb5$var$nativeMax = Math.max, $32727567fbef1eb5$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $32727567fbef1eb5$var$now = function() {
    return $32727567fbef1eb5$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $32727567fbef1eb5$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($32727567fbef1eb5$var$FUNC_ERROR_TEXT);
    wait = $32727567fbef1eb5$var$toNumber(wait) || 0;
    if ($32727567fbef1eb5$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $32727567fbef1eb5$var$nativeMax($32727567fbef1eb5$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $32727567fbef1eb5$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $32727567fbef1eb5$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($32727567fbef1eb5$var$now());
    }
    function debounced() {
        var time = $32727567fbef1eb5$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $32727567fbef1eb5$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $32727567fbef1eb5$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $32727567fbef1eb5$var$isSymbol(value) {
    return typeof value == 'symbol' || $32727567fbef1eb5$var$isObjectLike(value) && $32727567fbef1eb5$var$objectToString.call(value) == $32727567fbef1eb5$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $32727567fbef1eb5$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($32727567fbef1eb5$var$isSymbol(value)) return $32727567fbef1eb5$var$NAN;
    if ($32727567fbef1eb5$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $32727567fbef1eb5$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($32727567fbef1eb5$var$reTrim, '');
    var isBinary = $32727567fbef1eb5$var$reIsBinary.test(value);
    return isBinary || $32727567fbef1eb5$var$reIsOctal.test(value) ? $32727567fbef1eb5$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $32727567fbef1eb5$var$reIsBadHex.test(value) ? $32727567fbef1eb5$var$NAN : +value;
}
module.exports = $32727567fbef1eb5$var$debounce;

});

parcelRegister("cBGms", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $92d9ccc97d6e94cd$var$noop() {
// No operation performed.
}
module.exports = $92d9ccc97d6e94cd$var$noop;

});


parcelRegister("3bxzQ", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $251c71e50f7831d2$export$37e0729cc751960b);

var $1U98Q = parcelRequire("1U98Q");

var $cd8bt = parcelRequire("cd8bt");
function $251c71e50f7831d2$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $cd8bt.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $1U98Q.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("1U98Q", function(module, exports) {
$parcel$export(module.exports, "compile", () => $16321cb9c4946880$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $16321cb9c4946880$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $16321cb9c4946880$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $16321cb9c4946880$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $16321cb9c4946880$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($16321cb9c4946880$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($16321cb9c4946880$var$escapeString(prevText), ")[^").concat($16321cb9c4946880$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $16321cb9c4946880$export$ef7acd7185315e22(str, options) {
    return $16321cb9c4946880$export$5b9bad9e403cf3d9($16321cb9c4946880$export$98e6a39c04603d36(str, options), options);
}
function $16321cb9c4946880$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $16321cb9c4946880$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $16321cb9c4946880$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $16321cb9c4946880$export$71304158c7e35877(str, keys, options);
    return $16321cb9c4946880$export$968e97c88708237a(re, keys, options);
}
function $16321cb9c4946880$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $16321cb9c4946880$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $16321cb9c4946880$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $16321cb9c4946880$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $16321cb9c4946880$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $16321cb9c4946880$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $16321cb9c4946880$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $16321cb9c4946880$var$stringToRegexp(path, keys, options) {
    return $16321cb9c4946880$export$9a9303716def6456($16321cb9c4946880$export$98e6a39c04603d36(path, options), keys, options);
}
function $16321cb9c4946880$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($16321cb9c4946880$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($16321cb9c4946880$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $16321cb9c4946880$var$escapeString(encode(token));
        else {
            var prefix = $16321cb9c4946880$var$escapeString(encode(token.prefix));
            var suffix = $16321cb9c4946880$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $16321cb9c4946880$var$flags(options));
}
function $16321cb9c4946880$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $16321cb9c4946880$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $16321cb9c4946880$var$arrayToRegexp(path, keys, options);
    return $16321cb9c4946880$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("cd8bt", function(module, exports) {
'use strict';

var $HpdBk = parcelRequire("HpdBk");

var $dpd7M = parcelRequire("dpd7M");
var $8e3d0c1dc975c358$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $8e3d0c1dc975c358$var$CRHTLF = /[\n\r\t]/g, $8e3d0c1dc975c358$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $8e3d0c1dc975c358$var$port = /:\d+$/, $8e3d0c1dc975c358$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $8e3d0c1dc975c358$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $8e3d0c1dc975c358$var$trimLeft(str) {
    return (str ? str : '').toString().replace($8e3d0c1dc975c358$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $8e3d0c1dc975c358$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $8e3d0c1dc975c358$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $8e3d0c1dc975c358$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $8e3d0c1dc975c358$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $8e3d0c1dc975c358$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $8e3d0c1dc975c358$var$Url(loc, {});
        for(key in $8e3d0c1dc975c358$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $8e3d0c1dc975c358$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $8e3d0c1dc975c358$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $8e3d0c1dc975c358$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $8e3d0c1dc975c358$var$extractProtocol(address, location) {
    address = $8e3d0c1dc975c358$var$trimLeft(address);
    address = address.replace($8e3d0c1dc975c358$var$CRHTLF, '');
    location = location || {};
    var match = $8e3d0c1dc975c358$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($8e3d0c1dc975c358$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $8e3d0c1dc975c358$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $8e3d0c1dc975c358$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $8e3d0c1dc975c358$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $8e3d0c1dc975c358$var$Url(address, location, parser) {
    address = $8e3d0c1dc975c358$var$trimLeft(address);
    address = address.replace($8e3d0c1dc975c358$var$CRHTLF, '');
    if (!(this instanceof $8e3d0c1dc975c358$var$Url)) return new $8e3d0c1dc975c358$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $8e3d0c1dc975c358$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $dpd7M.parse;
    location = $8e3d0c1dc975c358$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $8e3d0c1dc975c358$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $8e3d0c1dc975c358$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$8e3d0c1dc975c358$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $8e3d0c1dc975c358$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $8e3d0c1dc975c358$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$HpdBk(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $8e3d0c1dc975c358$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $8e3d0c1dc975c358$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $dpd7M.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$HpdBk(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($8e3d0c1dc975c358$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $8e3d0c1dc975c358$var$rules.length; i++){
        var ins = $8e3d0c1dc975c358$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $8e3d0c1dc975c358$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $8e3d0c1dc975c358$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $dpd7M.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $8e3d0c1dc975c358$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $8e3d0c1dc975c358$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $8e3d0c1dc975c358$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$8e3d0c1dc975c358$var$Url.prototype = {
    set: $8e3d0c1dc975c358$var$set,
    toString: $8e3d0c1dc975c358$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$8e3d0c1dc975c358$var$Url.extractProtocol = $8e3d0c1dc975c358$var$extractProtocol;
$8e3d0c1dc975c358$var$Url.location = $8e3d0c1dc975c358$var$lolcation;
$8e3d0c1dc975c358$var$Url.trimLeft = $8e3d0c1dc975c358$var$trimLeft;
$8e3d0c1dc975c358$var$Url.qs = $dpd7M;
module.exports = $8e3d0c1dc975c358$var$Url;

});
parcelRegister("HpdBk", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("dpd7M", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $9c27ca63c1f52555$export$fac44ee5b035f737, (v) => $9c27ca63c1f52555$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $9c27ca63c1f52555$export$98e6a39c04603d36, (v) => $9c27ca63c1f52555$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $9c27ca63c1f52555$export$fac44ee5b035f737;
var $9c27ca63c1f52555$export$98e6a39c04603d36;
'use strict';
var $9c27ca63c1f52555$var$has = Object.prototype.hasOwnProperty, $9c27ca63c1f52555$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $9c27ca63c1f52555$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $9c27ca63c1f52555$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $9c27ca63c1f52555$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $9c27ca63c1f52555$var$decode(part[1]), value = $9c27ca63c1f52555$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $9c27ca63c1f52555$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($9c27ca63c1f52555$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $9c27ca63c1f52555$var$undef || isNaN(value))) value = '';
        key = $9c27ca63c1f52555$var$encode(key);
        value = $9c27ca63c1f52555$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$9c27ca63c1f52555$export$fac44ee5b035f737 = $9c27ca63c1f52555$var$querystringify;
$9c27ca63c1f52555$export$98e6a39c04603d36 = $9c27ca63c1f52555$var$querystring;

});



parcelRegister("dQg9I", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $a13ca9db462f7962$export$82476f982757e71e);

var $1U98Q = parcelRequire("1U98Q");
const $a13ca9db462f7962$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $1U98Q.compile)(pattern)(params);

});

parcelRegister("Nt5no", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $094b2388f064c35e$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $4eGW1 = parcelRequire("4eGW1");
const $094b2388f064c35e$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $094b2388f064c35e$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $4eGW1 !== 'undefined' && $4eGW1.versions != null && $4eGW1.versions.node != null) return true;
    if ($094b2388f064c35e$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("eWW7v", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $ae2390e26099def1$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $ae2390e26099def1$export$2e2bcd8739ae039);

var $cd8bt = parcelRequire("cd8bt");

var $jHXGp = parcelRequire("jHXGp");

var $751AF = parcelRequire("751AF");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $ae2390e26099def1$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $cd8bt.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $751AF.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $jHXGp.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $751AF.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $ae2390e26099def1$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$ae2390e26099def1$var$matchRoute(routes, pathname, queryParams, basePath);
const $ae2390e26099def1$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $ae2390e26099def1$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $ae2390e26099def1$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$ae2390e26099def1$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("jHXGp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e590544a374fa753$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");

var $ef6K8 = parcelRequire("ef6K8");

var $QqC9n = parcelRequire("QqC9n");
/* This should match what react-router does to compute a root match. */ const $e590544a374fa753$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $e590544a374fa753$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $ef6K8.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $e590544a374fa753$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $QqC9n.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $g8vBZ.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $e590544a374fa753$export$2e2bcd8739ae039 = $e590544a374fa753$var$execRouteMatching;

});
parcelRegister("ef6K8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5e7b27084aa1273$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $1U98Q = parcelRequire("1U98Q");
const $a5e7b27084aa1273$var$cache = {};
const $a5e7b27084aa1273$var$cacheLimit = 10000;
let $a5e7b27084aa1273$var$cacheCount = 0;
function $a5e7b27084aa1273$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $a5e7b27084aa1273$var$cache[cacheKey] || ($a5e7b27084aa1273$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $1U98Q.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($a5e7b27084aa1273$var$cacheCount < $a5e7b27084aa1273$var$cacheLimit) {
        pathCache[path] = result;
        $a5e7b27084aa1273$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $a5e7b27084aa1273$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $a5e7b27084aa1273$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $a5e7b27084aa1273$export$2e2bcd8739ae039 = $a5e7b27084aa1273$var$matchPath;

});

parcelRegister("QqC9n", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d9807e917c96fc$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $09d9807e917c96fc$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $g8vBZ.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $09d9807e917c96fc$export$2e2bcd8739ae039 = $09d9807e917c96fc$var$matchQuery;

});


parcelRegister("751AF", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $527a3bd4aa83fb7a$export$f594abf16a5ad948);
const $527a3bd4aa83fb7a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $527a3bd4aa83fb7a$var$MAX_CACHE_SIZE = 1000;
function $527a3bd4aa83fb7a$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$527a3bd4aa83fb7a$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $527a3bd4aa83fb7a$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($527a3bd4aa83fb7a$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $527a3bd4aa83fb7a$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $527a3bd4aa83fb7a$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("67m70", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $47448c80709ac957$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $47448c80709ac957$export$a0bd0313cbeabd49);

var $cd8bt = parcelRequire("cd8bt");

var $9Bssj = parcelRequire("9Bssj");

var $dQg9I = parcelRequire("dQg9I");

var $eWW7v = parcelRequire("eWW7v");
const $47448c80709ac957$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $dQg9I.generatePath)(route.path, params);
    const matchedRoute = (0, $eWW7v.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $9Bssj.DEFAULT_MATCH),
        query: query
    };
};
const $47448c80709ac957$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $cd8bt.qs).parse(search);
    const matchedRoute = (0, $eWW7v.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $9Bssj.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $9Bssj.DEFAULT_MATCH)
    };
};

});
parcelRegister("9Bssj", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $6fdda471cf3c8029$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $6fdda471cf3c8029$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $6fdda471cf3c8029$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $6fdda471cf3c8029$export$fa440ddf675c8a93);

var $cBGms = parcelRequire("cBGms");

var $aVniS = parcelRequire("aVniS");
const $6fdda471cf3c8029$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $6fdda471cf3c8029$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $6fdda471cf3c8029$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $6fdda471cf3c8029$export$39607c9878cf5148 = (0, $aVniS.createLegacyHistory)();
const $6fdda471cf3c8029$export$1515254c8c90bebb = {
    location: $6fdda471cf3c8029$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms)))
};
const $6fdda471cf3c8029$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("2JZPC", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $1fefbf39b3730cb2$export$5997e70fc4543270);
const $1fefbf39b3730cb2$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $1fefbf39b3730cb2$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $1fefbf39b3730cb2$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $1fefbf39b3730cb2$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("h1bGI", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $c63b98a94ab99057$export$9a302a45f65d0572);

var $giOHo = parcelRequire("giOHo");
const $c63b98a94ab99057$export$9a302a45f65d0572 = (0, $giOHo.useRouterStore);

});
parcelRegister("giOHo", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $bde5a78b990a812a$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $bde5a78b990a812a$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $bde5a78b990a812a$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $bde5a78b990a812a$export$ada49399abf7a3a1);

var $g8vBZ = parcelRequire("g8vBZ");

var $kHwwG = parcelRequire("kHwwG");

var $bQodR = parcelRequire("bQodR");
var $gfNVK = parcelRequire("gfNVK");
var $adFyB = parcelRequire("adFyB");
var $7CE69 = parcelRequire("7CE69");
var $jhZn5 = parcelRequire("jhZn5");

var $9Bssj = parcelRequire("9Bssj");
parcelRequire("4bmA3");
var $67m70 = parcelRequire("67m70");
var $3bxzQ = parcelRequire("3bxzQ");
var $dQg9I = parcelRequire("dQg9I");
var $Nt5no = parcelRequire("Nt5no");
var $eWW7v = parcelRequire("eWW7v");

var $lFj9V = parcelRequire("lFj9V");
const $bde5a78b990a812a$export$36d128238e6b60f5 = {
    action: (0, $9Bssj.DEFAULT_ACTION),
    basePath: '',
    location: (0, $9Bssj.DEFAULT_HISTORY).location,
    history: (0, $9Bssj.DEFAULT_HISTORY),
    match: (0, $9Bssj.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $9Bssj.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $bde5a78b990a812a$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $67m70.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $g8vBZ.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $Nt5no.isServerEnvironment)()) dispatch($bde5a78b990a812a$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $67m70.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $lFj9V.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $bQodR.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $g8vBZ.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $lFj9V.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $lFj9V.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $3bxzQ.generateLocationFromPath)(route.path, (0, $g8vBZ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $eWW7v.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $lFj9V.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $lFj9V.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $3bxzQ.generateLocationFromPath)(route.path, (0, $g8vBZ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $eWW7v.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $g8vBZ.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $lFj9V.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $lFj9V.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $g8vBZ.default)({}, existingPathParams, params);
            const updatedPath = (0, $dQg9I.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $g8vBZ.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $lFj9V.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $lFj9V.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $bde5a78b990a812a$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $lFj9V.isExternalAbsolutePath)(path)) {
                const location = (0, $kHwwG.parsePath)((0, $lFj9V.getRelativePath)(path, basePath));
                nextContext = (0, $67m70.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $bQodR.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $bde5a78b990a812a$export$1cf0ecab63b1963c = (0, $7CE69.createStore)({
    initialState: $bde5a78b990a812a$export$36d128238e6b60f5,
    actions: $bde5a78b990a812a$var$actions,
    name: 'router'
});
const $bde5a78b990a812a$export$d6b817abe7a77ea5 = (0, $adFyB.createContainer)($bde5a78b990a812a$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($bde5a78b990a812a$var$actions.bootstrapStore(props));
            !(0, $Nt5no.isServerEnvironment)() && dispatch($bde5a78b990a812a$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $Nt5no.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $bde5a78b990a812a$export$9569010eab09ae9e = (0, $gfNVK.createHook)($bde5a78b990a812a$export$1cf0ecab63b1963c);
const $bde5a78b990a812a$export$ada49399abf7a3a1 = (0, $gfNVK.createActionsHook)($bde5a78b990a812a$export$1cf0ecab63b1963c);
function $bde5a78b990a812a$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $gfNVK.createHook)($bde5a78b990a812a$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $bde5a78b990a812a$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $jhZn5.defaultRegistry).getStore($bde5a78b990a812a$export$1cf0ecab63b1963c);
const $bde5a78b990a812a$export$ebf37f7e180b13a9 = ()=>$bde5a78b990a812a$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("bQodR", function(module, exports) {
$parcel$export(module.exports, "batch", () => $89f75725aca65c10$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $4Sf72 = parcelRequire("4Sf72");

var $40GmU = parcelRequire("40GmU");

var $7IywQ = parcelRequire("7IywQ");

var $5riux = parcelRequire("5riux");
let $89f75725aca65c10$var$isInsideBatchedSchedule = false;
function $89f75725aca65c10$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $7IywQ.default).batchUpdates || !(0, $5riux.default).scheduling() || $89f75725aca65c10$var$isInsideBatchedSchedule) return (0, $4Sf72.unstable_batchedUpdates)(fn);
    $89f75725aca65c10$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $40GmU.unstable_scheduleCallback)((0, $40GmU.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $4Sf72.unstable_batchedUpdates)(fn);
        $89f75725aca65c10$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("4Sf72", function(module, exports) {
'use strict';
function $38c7ed981ca514ef$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($38c7ed981ca514ef$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$38c7ed981ca514ef$var$checkDCE();

module.exports = (parcelRequire("gIpfc"));

});
parcelRegister("gIpfc", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $c2b45657dc5a240d$export$ae55be85d98224ed, (v) => $c2b45657dc5a240d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $c2b45657dc5a240d$export$d39a5bbd09211389, (v) => $c2b45657dc5a240d$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $c2b45657dc5a240d$export$882461b6382ed46c, (v) => $c2b45657dc5a240d$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $c2b45657dc5a240d$export$466bfc07425424d5, (v) => $c2b45657dc5a240d$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $c2b45657dc5a240d$export$cd75ccfd720a3cd4, (v) => $c2b45657dc5a240d$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $c2b45657dc5a240d$export$fa8d919ba61d84db, (v) => $c2b45657dc5a240d$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $c2b45657dc5a240d$export$757ceba2d55c277e, (v) => $c2b45657dc5a240d$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $c2b45657dc5a240d$export$b3890eb0ae9dca99, (v) => $c2b45657dc5a240d$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $c2b45657dc5a240d$export$502457920280e6be, (v) => $c2b45657dc5a240d$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $c2b45657dc5a240d$export$c78a37762a8d58e1, (v) => $c2b45657dc5a240d$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $c2b45657dc5a240d$export$dc54d992c10e8a18, (v) => $c2b45657dc5a240d$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $c2b45657dc5a240d$export$83d89fbfd8236492, (v) => $c2b45657dc5a240d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c2b45657dc5a240d$export$ae55be85d98224ed;
var $c2b45657dc5a240d$export$d39a5bbd09211389;
var $c2b45657dc5a240d$export$882461b6382ed46c;
var $c2b45657dc5a240d$export$466bfc07425424d5;
var $c2b45657dc5a240d$export$cd75ccfd720a3cd4;
var $c2b45657dc5a240d$export$fa8d919ba61d84db;
var $c2b45657dc5a240d$export$757ceba2d55c277e;
var $c2b45657dc5a240d$export$b3890eb0ae9dca99;
var $c2b45657dc5a240d$export$502457920280e6be;
var $c2b45657dc5a240d$export$c78a37762a8d58e1;
var $c2b45657dc5a240d$export$dc54d992c10e8a18;
var $c2b45657dc5a240d$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $bSJIT = parcelRequire("bSJIT");

var $40GmU = parcelRequire("40GmU");
function $c2b45657dc5a240d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c2b45657dc5a240d$var$da = new Set, $c2b45657dc5a240d$var$ea = {};
function $c2b45657dc5a240d$var$fa(a, b) {
    $c2b45657dc5a240d$var$ha(a, b);
    $c2b45657dc5a240d$var$ha(a + "Capture", b);
}
function $c2b45657dc5a240d$var$ha(a, b) {
    $c2b45657dc5a240d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c2b45657dc5a240d$var$da.add(b[a]);
}
var $c2b45657dc5a240d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c2b45657dc5a240d$var$ja = Object.prototype.hasOwnProperty, $c2b45657dc5a240d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c2b45657dc5a240d$var$la = {}, $c2b45657dc5a240d$var$ma = {};
function $c2b45657dc5a240d$var$na(a) {
    if ($c2b45657dc5a240d$var$ja.call($c2b45657dc5a240d$var$ma, a)) return !0;
    if ($c2b45657dc5a240d$var$ja.call($c2b45657dc5a240d$var$la, a)) return !1;
    if ($c2b45657dc5a240d$var$ka.test(a)) return $c2b45657dc5a240d$var$ma[a] = !0;
    $c2b45657dc5a240d$var$la[a] = !0;
    return !1;
}
function $c2b45657dc5a240d$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c2b45657dc5a240d$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c2b45657dc5a240d$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c2b45657dc5a240d$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c2b45657dc5a240d$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c2b45657dc5a240d$var$t[b] = new $c2b45657dc5a240d$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c2b45657dc5a240d$var$ra = /[\-:]([a-z])/g;
function $c2b45657dc5a240d$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c2b45657dc5a240d$var$ra, $c2b45657dc5a240d$var$ta);
    $c2b45657dc5a240d$var$t[b] = new $c2b45657dc5a240d$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c2b45657dc5a240d$var$ra, $c2b45657dc5a240d$var$ta);
    $c2b45657dc5a240d$var$t[b] = new $c2b45657dc5a240d$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c2b45657dc5a240d$var$ra, $c2b45657dc5a240d$var$ta);
    $c2b45657dc5a240d$var$t[b] = new $c2b45657dc5a240d$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c2b45657dc5a240d$var$t.xlinkHref = new $c2b45657dc5a240d$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c2b45657dc5a240d$var$t[a] = new $c2b45657dc5a240d$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c2b45657dc5a240d$var$ua(a, b, c, d) {
    var e = $c2b45657dc5a240d$var$t.hasOwnProperty(b) ? $c2b45657dc5a240d$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c2b45657dc5a240d$var$pa(b, c, e, d) && (c = null), d || null === e ? $c2b45657dc5a240d$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c2b45657dc5a240d$var$va = $bSJIT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c2b45657dc5a240d$var$wa = Symbol.for("react.element"), $c2b45657dc5a240d$var$xa = Symbol.for("react.portal"), $c2b45657dc5a240d$var$ya = Symbol.for("react.fragment"), $c2b45657dc5a240d$var$za = Symbol.for("react.strict_mode"), $c2b45657dc5a240d$var$Aa = Symbol.for("react.profiler"), $c2b45657dc5a240d$var$Ba = Symbol.for("react.provider"), $c2b45657dc5a240d$var$Ca = Symbol.for("react.context"), $c2b45657dc5a240d$var$Da = Symbol.for("react.forward_ref"), $c2b45657dc5a240d$var$Ea = Symbol.for("react.suspense"), $c2b45657dc5a240d$var$Fa = Symbol.for("react.suspense_list"), $c2b45657dc5a240d$var$Ga = Symbol.for("react.memo"), $c2b45657dc5a240d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c2b45657dc5a240d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c2b45657dc5a240d$var$Ja = Symbol.iterator;
function $c2b45657dc5a240d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c2b45657dc5a240d$var$Ja && a[$c2b45657dc5a240d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c2b45657dc5a240d$var$u = Object.assign, $c2b45657dc5a240d$var$La;
function $c2b45657dc5a240d$var$Ma(a) {
    if (void 0 === $c2b45657dc5a240d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c2b45657dc5a240d$var$La = b && b[1] || "";
    }
    return "\n" + $c2b45657dc5a240d$var$La + a;
}
var $c2b45657dc5a240d$var$Na = !1;
function $c2b45657dc5a240d$var$Oa(a, b) {
    if (!a || $c2b45657dc5a240d$var$Na) return "";
    $c2b45657dc5a240d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c2b45657dc5a240d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c2b45657dc5a240d$var$Ma(a) : "";
}
function $c2b45657dc5a240d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c2b45657dc5a240d$var$Ma(a.type);
        case 16:
            return $c2b45657dc5a240d$var$Ma("Lazy");
        case 13:
            return $c2b45657dc5a240d$var$Ma("Suspense");
        case 19:
            return $c2b45657dc5a240d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c2b45657dc5a240d$var$Oa(a.type, !1), a;
        case 11:
            return a = $c2b45657dc5a240d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c2b45657dc5a240d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c2b45657dc5a240d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c2b45657dc5a240d$var$ya:
            return "Fragment";
        case $c2b45657dc5a240d$var$xa:
            return "Portal";
        case $c2b45657dc5a240d$var$Aa:
            return "Profiler";
        case $c2b45657dc5a240d$var$za:
            return "StrictMode";
        case $c2b45657dc5a240d$var$Ea:
            return "Suspense";
        case $c2b45657dc5a240d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c2b45657dc5a240d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c2b45657dc5a240d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c2b45657dc5a240d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c2b45657dc5a240d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c2b45657dc5a240d$var$Qa(a.type) || "Memo";
        case $c2b45657dc5a240d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c2b45657dc5a240d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c2b45657dc5a240d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c2b45657dc5a240d$var$Qa(b);
        case 8:
            return b === $c2b45657dc5a240d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c2b45657dc5a240d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c2b45657dc5a240d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c2b45657dc5a240d$var$Ua(a) {
    var b = $c2b45657dc5a240d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c2b45657dc5a240d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c2b45657dc5a240d$var$Ua(a));
}
function $c2b45657dc5a240d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c2b45657dc5a240d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c2b45657dc5a240d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c2b45657dc5a240d$var$Ya(a, b) {
    var c = b.checked;
    return $c2b45657dc5a240d$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c2b45657dc5a240d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c2b45657dc5a240d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c2b45657dc5a240d$var$$a(a, b) {
    b = b.checked;
    null != b && $c2b45657dc5a240d$var$ua(a, "checked", b, !1);
}
function $c2b45657dc5a240d$var$ab(a, b) {
    $c2b45657dc5a240d$var$$a(a, b);
    var c = $c2b45657dc5a240d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c2b45657dc5a240d$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c2b45657dc5a240d$var$bb(a, b.type, $c2b45657dc5a240d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c2b45657dc5a240d$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c2b45657dc5a240d$var$bb(a, b, c) {
    if ("number" !== b || $c2b45657dc5a240d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c2b45657dc5a240d$var$db = Array.isArray;
function $c2b45657dc5a240d$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c2b45657dc5a240d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c2b45657dc5a240d$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c2b45657dc5a240d$var$p(91));
    return $c2b45657dc5a240d$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c2b45657dc5a240d$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c2b45657dc5a240d$var$p(92));
            if ($c2b45657dc5a240d$var$db(c)) {
                if (1 < c.length) throw Error($c2b45657dc5a240d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c2b45657dc5a240d$var$Sa(c)
    };
}
function $c2b45657dc5a240d$var$hb(a, b) {
    var c = $c2b45657dc5a240d$var$Sa(b.value), d = $c2b45657dc5a240d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c2b45657dc5a240d$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c2b45657dc5a240d$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c2b45657dc5a240d$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c2b45657dc5a240d$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c2b45657dc5a240d$var$mb, $c2b45657dc5a240d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c2b45657dc5a240d$var$mb = $c2b45657dc5a240d$var$mb || document.createElement("div");
        $c2b45657dc5a240d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c2b45657dc5a240d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c2b45657dc5a240d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c2b45657dc5a240d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c2b45657dc5a240d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c2b45657dc5a240d$var$pb).forEach(function(a) {
    $c2b45657dc5a240d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c2b45657dc5a240d$var$pb[b] = $c2b45657dc5a240d$var$pb[a];
    });
});
function $c2b45657dc5a240d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c2b45657dc5a240d$var$pb.hasOwnProperty(a) && $c2b45657dc5a240d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c2b45657dc5a240d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c2b45657dc5a240d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c2b45657dc5a240d$var$tb = $c2b45657dc5a240d$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c2b45657dc5a240d$var$ub(a, b) {
    if (b) {
        if ($c2b45657dc5a240d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c2b45657dc5a240d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c2b45657dc5a240d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c2b45657dc5a240d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c2b45657dc5a240d$var$p(62));
    }
}
function $c2b45657dc5a240d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c2b45657dc5a240d$var$wb = null;
function $c2b45657dc5a240d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c2b45657dc5a240d$var$yb = null, $c2b45657dc5a240d$var$zb = null, $c2b45657dc5a240d$var$Ab = null;
function $c2b45657dc5a240d$var$Bb(a) {
    if (a = $c2b45657dc5a240d$var$Cb(a)) {
        if ("function" !== typeof $c2b45657dc5a240d$var$yb) throw Error($c2b45657dc5a240d$var$p(280));
        var b = a.stateNode;
        b && (b = $c2b45657dc5a240d$var$Db(b), $c2b45657dc5a240d$var$yb(a.stateNode, a.type, b));
    }
}
function $c2b45657dc5a240d$var$Eb(a) {
    $c2b45657dc5a240d$var$zb ? $c2b45657dc5a240d$var$Ab ? $c2b45657dc5a240d$var$Ab.push(a) : $c2b45657dc5a240d$var$Ab = [
        a
    ] : $c2b45657dc5a240d$var$zb = a;
}
function $c2b45657dc5a240d$var$Fb() {
    if ($c2b45657dc5a240d$var$zb) {
        var a = $c2b45657dc5a240d$var$zb, b = $c2b45657dc5a240d$var$Ab;
        $c2b45657dc5a240d$var$Ab = $c2b45657dc5a240d$var$zb = null;
        $c2b45657dc5a240d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c2b45657dc5a240d$var$Bb(b[a]);
    }
}
function $c2b45657dc5a240d$var$Gb(a, b) {
    return a(b);
}
function $c2b45657dc5a240d$var$Hb() {}
var $c2b45657dc5a240d$var$Ib = !1;
function $c2b45657dc5a240d$var$Jb(a, b, c) {
    if ($c2b45657dc5a240d$var$Ib) return a(b, c);
    $c2b45657dc5a240d$var$Ib = !0;
    try {
        return $c2b45657dc5a240d$var$Gb(a, b, c);
    } finally{
        if ($c2b45657dc5a240d$var$Ib = !1, null !== $c2b45657dc5a240d$var$zb || null !== $c2b45657dc5a240d$var$Ab) $c2b45657dc5a240d$var$Hb(), $c2b45657dc5a240d$var$Fb();
    }
}
function $c2b45657dc5a240d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c2b45657dc5a240d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c2b45657dc5a240d$var$p(231, b, typeof c));
    return c;
}
var $c2b45657dc5a240d$var$Lb = !1;
if ($c2b45657dc5a240d$var$ia) try {
    var $c2b45657dc5a240d$var$Mb = {};
    Object.defineProperty($c2b45657dc5a240d$var$Mb, "passive", {
        get: function() {
            $c2b45657dc5a240d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c2b45657dc5a240d$var$Mb, $c2b45657dc5a240d$var$Mb);
    window.removeEventListener("test", $c2b45657dc5a240d$var$Mb, $c2b45657dc5a240d$var$Mb);
} catch (a) {
    $c2b45657dc5a240d$var$Lb = !1;
}
function $c2b45657dc5a240d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $c2b45657dc5a240d$var$Ob = !1, $c2b45657dc5a240d$var$Pb = null, $c2b45657dc5a240d$var$Qb = !1, $c2b45657dc5a240d$var$Rb = null, $c2b45657dc5a240d$var$Sb = {
    onError: function(a) {
        $c2b45657dc5a240d$var$Ob = !0;
        $c2b45657dc5a240d$var$Pb = a;
    }
};
function $c2b45657dc5a240d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c2b45657dc5a240d$var$Ob = !1;
    $c2b45657dc5a240d$var$Pb = null;
    $c2b45657dc5a240d$var$Nb.apply($c2b45657dc5a240d$var$Sb, arguments);
}
function $c2b45657dc5a240d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c2b45657dc5a240d$var$Tb.apply(this, arguments);
    if ($c2b45657dc5a240d$var$Ob) {
        if ($c2b45657dc5a240d$var$Ob) {
            var l = $c2b45657dc5a240d$var$Pb;
            $c2b45657dc5a240d$var$Ob = !1;
            $c2b45657dc5a240d$var$Pb = null;
        } else throw Error($c2b45657dc5a240d$var$p(198));
        $c2b45657dc5a240d$var$Qb || ($c2b45657dc5a240d$var$Qb = !0, $c2b45657dc5a240d$var$Rb = l);
    }
}
function $c2b45657dc5a240d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c2b45657dc5a240d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c2b45657dc5a240d$var$Xb(a) {
    if ($c2b45657dc5a240d$var$Vb(a) !== a) throw Error($c2b45657dc5a240d$var$p(188));
}
function $c2b45657dc5a240d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c2b45657dc5a240d$var$Vb(a);
        if (null === b) throw Error($c2b45657dc5a240d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c2b45657dc5a240d$var$Xb(e), a;
                if (f === d) return $c2b45657dc5a240d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c2b45657dc5a240d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c2b45657dc5a240d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c2b45657dc5a240d$var$p(190));
    }
    if (3 !== c.tag) throw Error($c2b45657dc5a240d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c2b45657dc5a240d$var$Zb(a) {
    a = $c2b45657dc5a240d$var$Yb(a);
    return null !== a ? $c2b45657dc5a240d$var$$b(a) : null;
}
function $c2b45657dc5a240d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c2b45657dc5a240d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c2b45657dc5a240d$var$ac = $40GmU.unstable_scheduleCallback, $c2b45657dc5a240d$var$bc = $40GmU.unstable_cancelCallback, $c2b45657dc5a240d$var$cc = $40GmU.unstable_shouldYield, $c2b45657dc5a240d$var$dc = $40GmU.unstable_requestPaint, $c2b45657dc5a240d$var$A = $40GmU.unstable_now, $c2b45657dc5a240d$var$ec = $40GmU.unstable_getCurrentPriorityLevel, $c2b45657dc5a240d$var$fc = $40GmU.unstable_ImmediatePriority, $c2b45657dc5a240d$var$gc = $40GmU.unstable_UserBlockingPriority, $c2b45657dc5a240d$var$hc = $40GmU.unstable_NormalPriority, $c2b45657dc5a240d$var$ic = $40GmU.unstable_LowPriority, $c2b45657dc5a240d$var$jc = $40GmU.unstable_IdlePriority, $c2b45657dc5a240d$var$kc = null, $c2b45657dc5a240d$var$lc = null, $c2b45657dc5a240d$var$B = null, $c2b45657dc5a240d$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $c2b45657dc5a240d$var$nc(a, b) {
    if ($c2b45657dc5a240d$var$lc && "function" === typeof $c2b45657dc5a240d$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $c2b45657dc5a240d$var$fc;
                break;
            case 4:
                d = $c2b45657dc5a240d$var$gc;
                break;
            case 16:
                d = $c2b45657dc5a240d$var$hc;
                break;
            case 536870912:
                d = $c2b45657dc5a240d$var$jc;
                break;
            default:
                d = $c2b45657dc5a240d$var$hc;
        }
        $c2b45657dc5a240d$var$lc.onCommitFiberRoot($c2b45657dc5a240d$var$kc, a, d, c);
    } catch (e) {}
}
function $c2b45657dc5a240d$var$oc(a) {
    $c2b45657dc5a240d$var$B = a;
}
function $c2b45657dc5a240d$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $c2b45657dc5a240d$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $c2b45657dc5a240d$var$rc() {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markCommitStopped && $c2b45657dc5a240d$var$B.markCommitStopped();
}
function $c2b45657dc5a240d$var$sc(a) {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentRenderStarted && $c2b45657dc5a240d$var$B.markComponentRenderStarted(a);
}
function $c2b45657dc5a240d$var$tc() {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentRenderStopped && $c2b45657dc5a240d$var$B.markComponentRenderStopped();
}
function $c2b45657dc5a240d$var$uc(a) {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentLayoutEffectUnmountStarted && $c2b45657dc5a240d$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $c2b45657dc5a240d$var$vc() {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentLayoutEffectUnmountStopped && $c2b45657dc5a240d$var$B.markComponentLayoutEffectUnmountStopped();
}
function $c2b45657dc5a240d$var$wc(a) {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markRenderStarted && $c2b45657dc5a240d$var$B.markRenderStarted(a);
}
function $c2b45657dc5a240d$var$xc() {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markRenderStopped && $c2b45657dc5a240d$var$B.markRenderStopped();
}
function $c2b45657dc5a240d$var$yc(a, b) {
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markStateUpdateScheduled && $c2b45657dc5a240d$var$B.markStateUpdateScheduled(a, b);
}
var $c2b45657dc5a240d$var$Ac = Math.clz32 ? Math.clz32 : $c2b45657dc5a240d$var$zc, $c2b45657dc5a240d$var$Bc = Math.log, $c2b45657dc5a240d$var$Cc = Math.LN2;
function $c2b45657dc5a240d$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c2b45657dc5a240d$var$Bc(a) / $c2b45657dc5a240d$var$Cc | 0) | 0;
}
function $c2b45657dc5a240d$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $c2b45657dc5a240d$var$Dc = 64, $c2b45657dc5a240d$var$Ec = 4194304;
function $c2b45657dc5a240d$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c2b45657dc5a240d$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c2b45657dc5a240d$var$Fc(h) : (f &= g, 0 !== f && (d = $c2b45657dc5a240d$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $c2b45657dc5a240d$var$Fc(g) : 0 !== f && (d = $c2b45657dc5a240d$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c2b45657dc5a240d$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c2b45657dc5a240d$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c2b45657dc5a240d$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c2b45657dc5a240d$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c2b45657dc5a240d$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c2b45657dc5a240d$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c2b45657dc5a240d$var$Kc() {
    var a = $c2b45657dc5a240d$var$Dc;
    $c2b45657dc5a240d$var$Dc <<= 1;
    0 === ($c2b45657dc5a240d$var$Dc & 4194240) && ($c2b45657dc5a240d$var$Dc = 64);
    return a;
}
function $c2b45657dc5a240d$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c2b45657dc5a240d$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c2b45657dc5a240d$var$Ac(b);
    a[b] = c;
}
function $c2b45657dc5a240d$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c2b45657dc5a240d$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c2b45657dc5a240d$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c2b45657dc5a240d$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $c2b45657dc5a240d$var$Pc(a, b, c) {
    if ($c2b45657dc5a240d$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $c2b45657dc5a240d$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $c2b45657dc5a240d$var$Qc(a, b) {
    if ($c2b45657dc5a240d$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $c2b45657dc5a240d$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $c2b45657dc5a240d$var$E = 0;
function $c2b45657dc5a240d$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c2b45657dc5a240d$var$Sc, $c2b45657dc5a240d$var$Tc, $c2b45657dc5a240d$var$Uc, $c2b45657dc5a240d$var$Vc, $c2b45657dc5a240d$var$Wc, $c2b45657dc5a240d$var$Xc = !1, $c2b45657dc5a240d$var$Yc = [], $c2b45657dc5a240d$var$Zc = null, $c2b45657dc5a240d$var$$c = null, $c2b45657dc5a240d$var$ad = null, $c2b45657dc5a240d$var$bd = new Map, $c2b45657dc5a240d$var$cd = new Map, $c2b45657dc5a240d$var$dd = [], $c2b45657dc5a240d$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c2b45657dc5a240d$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c2b45657dc5a240d$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c2b45657dc5a240d$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $c2b45657dc5a240d$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $c2b45657dc5a240d$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c2b45657dc5a240d$var$cd.delete(b.pointerId);
    }
}
function $c2b45657dc5a240d$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c2b45657dc5a240d$var$Cb(b), null !== b && $c2b45657dc5a240d$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c2b45657dc5a240d$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c2b45657dc5a240d$var$Zc = $c2b45657dc5a240d$var$gd($c2b45657dc5a240d$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $c2b45657dc5a240d$var$$c = $c2b45657dc5a240d$var$gd($c2b45657dc5a240d$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $c2b45657dc5a240d$var$ad = $c2b45657dc5a240d$var$gd($c2b45657dc5a240d$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c2b45657dc5a240d$var$bd.set(f, $c2b45657dc5a240d$var$gd($c2b45657dc5a240d$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c2b45657dc5a240d$var$cd.set(f, $c2b45657dc5a240d$var$gd($c2b45657dc5a240d$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c2b45657dc5a240d$var$id(a) {
    var b = $c2b45657dc5a240d$var$jd(a.target);
    if (null !== b) {
        var c = $c2b45657dc5a240d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c2b45657dc5a240d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c2b45657dc5a240d$var$Wc(a.priority, function() {
                        $c2b45657dc5a240d$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c2b45657dc5a240d$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c2b45657dc5a240d$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c2b45657dc5a240d$var$wb = d;
            c.target.dispatchEvent(d);
            $c2b45657dc5a240d$var$wb = null;
        } else return b = $c2b45657dc5a240d$var$Cb(c), null !== b && $c2b45657dc5a240d$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c2b45657dc5a240d$var$md(a, b, c) {
    $c2b45657dc5a240d$var$kd(a) && c.delete(b);
}
function $c2b45657dc5a240d$var$nd() {
    $c2b45657dc5a240d$var$Xc = !1;
    null !== $c2b45657dc5a240d$var$Zc && $c2b45657dc5a240d$var$kd($c2b45657dc5a240d$var$Zc) && ($c2b45657dc5a240d$var$Zc = null);
    null !== $c2b45657dc5a240d$var$$c && $c2b45657dc5a240d$var$kd($c2b45657dc5a240d$var$$c) && ($c2b45657dc5a240d$var$$c = null);
    null !== $c2b45657dc5a240d$var$ad && $c2b45657dc5a240d$var$kd($c2b45657dc5a240d$var$ad) && ($c2b45657dc5a240d$var$ad = null);
    $c2b45657dc5a240d$var$bd.forEach($c2b45657dc5a240d$var$md);
    $c2b45657dc5a240d$var$cd.forEach($c2b45657dc5a240d$var$md);
}
function $c2b45657dc5a240d$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c2b45657dc5a240d$var$Xc || ($c2b45657dc5a240d$var$Xc = !0, $40GmU.unstable_scheduleCallback($40GmU.unstable_NormalPriority, $c2b45657dc5a240d$var$nd)));
}
function $c2b45657dc5a240d$var$pd(a) {
    function b(b) {
        return $c2b45657dc5a240d$var$od(b, a);
    }
    if (0 < $c2b45657dc5a240d$var$Yc.length) {
        $c2b45657dc5a240d$var$od($c2b45657dc5a240d$var$Yc[0], a);
        for(var c = 1; c < $c2b45657dc5a240d$var$Yc.length; c++){
            var d = $c2b45657dc5a240d$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c2b45657dc5a240d$var$Zc && $c2b45657dc5a240d$var$od($c2b45657dc5a240d$var$Zc, a);
    null !== $c2b45657dc5a240d$var$$c && $c2b45657dc5a240d$var$od($c2b45657dc5a240d$var$$c, a);
    null !== $c2b45657dc5a240d$var$ad && $c2b45657dc5a240d$var$od($c2b45657dc5a240d$var$ad, a);
    $c2b45657dc5a240d$var$bd.forEach(b);
    $c2b45657dc5a240d$var$cd.forEach(b);
    for(c = 0; c < $c2b45657dc5a240d$var$dd.length; c++)d = $c2b45657dc5a240d$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c2b45657dc5a240d$var$dd.length && (c = $c2b45657dc5a240d$var$dd[0], null === c.blockedOn);)$c2b45657dc5a240d$var$id(c), null === c.blockedOn && $c2b45657dc5a240d$var$dd.shift();
}
var $c2b45657dc5a240d$var$qd = $c2b45657dc5a240d$var$va.ReactCurrentBatchConfig, $c2b45657dc5a240d$var$rd = !0;
function $c2b45657dc5a240d$var$sd(a, b, c, d) {
    var e = $c2b45657dc5a240d$var$E, f = $c2b45657dc5a240d$var$qd.transition;
    $c2b45657dc5a240d$var$qd.transition = null;
    try {
        $c2b45657dc5a240d$var$E = 1, $c2b45657dc5a240d$var$td(a, b, c, d);
    } finally{
        $c2b45657dc5a240d$var$E = e, $c2b45657dc5a240d$var$qd.transition = f;
    }
}
function $c2b45657dc5a240d$var$ud(a, b, c, d) {
    var e = $c2b45657dc5a240d$var$E, f = $c2b45657dc5a240d$var$qd.transition;
    $c2b45657dc5a240d$var$qd.transition = null;
    try {
        $c2b45657dc5a240d$var$E = 4, $c2b45657dc5a240d$var$td(a, b, c, d);
    } finally{
        $c2b45657dc5a240d$var$E = e, $c2b45657dc5a240d$var$qd.transition = f;
    }
}
function $c2b45657dc5a240d$var$td(a, b, c, d) {
    if ($c2b45657dc5a240d$var$rd) {
        var e = $c2b45657dc5a240d$var$ld(a, b, c, d);
        if (null === e) $c2b45657dc5a240d$var$vd(a, b, d, $c2b45657dc5a240d$var$wd, c), $c2b45657dc5a240d$var$fd(a, d);
        else if ($c2b45657dc5a240d$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($c2b45657dc5a240d$var$fd(a, d), b & 4 && -1 < $c2b45657dc5a240d$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $c2b45657dc5a240d$var$Cb(e);
                null !== f && $c2b45657dc5a240d$var$Sc(f);
                f = $c2b45657dc5a240d$var$ld(a, b, c, d);
                null === f && $c2b45657dc5a240d$var$vd(a, b, d, $c2b45657dc5a240d$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c2b45657dc5a240d$var$vd(a, b, d, null, c);
    }
}
var $c2b45657dc5a240d$var$wd = null;
function $c2b45657dc5a240d$var$ld(a, b, c, d) {
    $c2b45657dc5a240d$var$wd = null;
    a = $c2b45657dc5a240d$var$xb(d);
    a = $c2b45657dc5a240d$var$jd(a);
    if (null !== a) {
        if (b = $c2b45657dc5a240d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c2b45657dc5a240d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c2b45657dc5a240d$var$wd = a;
    return null;
}
function $c2b45657dc5a240d$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c2b45657dc5a240d$var$ec()){
                case $c2b45657dc5a240d$var$fc:
                    return 1;
                case $c2b45657dc5a240d$var$gc:
                    return 4;
                case $c2b45657dc5a240d$var$hc:
                case $c2b45657dc5a240d$var$ic:
                    return 16;
                case $c2b45657dc5a240d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c2b45657dc5a240d$var$yd = null, $c2b45657dc5a240d$var$zd = null, $c2b45657dc5a240d$var$Ad = null;
function $c2b45657dc5a240d$var$Bd() {
    if ($c2b45657dc5a240d$var$Ad) return $c2b45657dc5a240d$var$Ad;
    var a, b = $c2b45657dc5a240d$var$zd, c = b.length, d, e = "value" in $c2b45657dc5a240d$var$yd ? $c2b45657dc5a240d$var$yd.value : $c2b45657dc5a240d$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c2b45657dc5a240d$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c2b45657dc5a240d$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c2b45657dc5a240d$var$Dd() {
    return !0;
}
function $c2b45657dc5a240d$var$Ed() {
    return !1;
}
function $c2b45657dc5a240d$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c2b45657dc5a240d$var$Dd : $c2b45657dc5a240d$var$Ed;
        this.isPropagationStopped = $c2b45657dc5a240d$var$Ed;
        return this;
    }
    $c2b45657dc5a240d$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c2b45657dc5a240d$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c2b45657dc5a240d$var$Dd);
        },
        persist: function() {},
        isPersistent: $c2b45657dc5a240d$var$Dd
    });
    return b;
}
var $c2b45657dc5a240d$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c2b45657dc5a240d$var$Hd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Gd), $c2b45657dc5a240d$var$Id = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Gd, {
    view: 0,
    detail: 0
}), $c2b45657dc5a240d$var$Jd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Id), $c2b45657dc5a240d$var$Kd, $c2b45657dc5a240d$var$Ld, $c2b45657dc5a240d$var$Md, $c2b45657dc5a240d$var$Od = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c2b45657dc5a240d$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c2b45657dc5a240d$var$Md && ($c2b45657dc5a240d$var$Md && "mousemove" === a.type ? ($c2b45657dc5a240d$var$Kd = a.screenX - $c2b45657dc5a240d$var$Md.screenX, $c2b45657dc5a240d$var$Ld = a.screenY - $c2b45657dc5a240d$var$Md.screenY) : $c2b45657dc5a240d$var$Ld = $c2b45657dc5a240d$var$Kd = 0, $c2b45657dc5a240d$var$Md = a);
        return $c2b45657dc5a240d$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c2b45657dc5a240d$var$Ld;
    }
}), $c2b45657dc5a240d$var$Pd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Od), $c2b45657dc5a240d$var$Qd = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Od, {
    dataTransfer: 0
}), $c2b45657dc5a240d$var$Rd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Qd), $c2b45657dc5a240d$var$Sd = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Id, {
    relatedTarget: 0
}), $c2b45657dc5a240d$var$Td = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Sd), $c2b45657dc5a240d$var$Ud = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2b45657dc5a240d$var$Vd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Ud), $c2b45657dc5a240d$var$Wd = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c2b45657dc5a240d$var$Xd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Wd), $c2b45657dc5a240d$var$Yd = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Gd, {
    data: 0
}), $c2b45657dc5a240d$var$Zd = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$Yd), $c2b45657dc5a240d$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c2b45657dc5a240d$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c2b45657dc5a240d$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c2b45657dc5a240d$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c2b45657dc5a240d$var$be[a]) ? !!b[a] : !1;
}
function $c2b45657dc5a240d$var$Nd() {
    return $c2b45657dc5a240d$var$ce;
}
var $c2b45657dc5a240d$var$de = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $c2b45657dc5a240d$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c2b45657dc5a240d$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c2b45657dc5a240d$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c2b45657dc5a240d$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $c2b45657dc5a240d$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c2b45657dc5a240d$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c2b45657dc5a240d$var$ee = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$de), $c2b45657dc5a240d$var$fe = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c2b45657dc5a240d$var$ge = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$fe), $c2b45657dc5a240d$var$he = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c2b45657dc5a240d$var$Nd
}), $c2b45657dc5a240d$var$ie = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$he), $c2b45657dc5a240d$var$je = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2b45657dc5a240d$var$ke = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$je), $c2b45657dc5a240d$var$le = $c2b45657dc5a240d$var$u({}, $c2b45657dc5a240d$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c2b45657dc5a240d$var$me = $c2b45657dc5a240d$var$Fd($c2b45657dc5a240d$var$le), $c2b45657dc5a240d$var$ne = [
    9,
    13,
    27,
    32
], $c2b45657dc5a240d$var$oe = $c2b45657dc5a240d$var$ia && "CompositionEvent" in window, $c2b45657dc5a240d$var$pe = null;
$c2b45657dc5a240d$var$ia && "documentMode" in document && ($c2b45657dc5a240d$var$pe = document.documentMode);
var $c2b45657dc5a240d$var$qe = $c2b45657dc5a240d$var$ia && "TextEvent" in window && !$c2b45657dc5a240d$var$pe, $c2b45657dc5a240d$var$re = $c2b45657dc5a240d$var$ia && (!$c2b45657dc5a240d$var$oe || $c2b45657dc5a240d$var$pe && 8 < $c2b45657dc5a240d$var$pe && 11 >= $c2b45657dc5a240d$var$pe), $c2b45657dc5a240d$var$se = String.fromCharCode(32), $c2b45657dc5a240d$var$te = !1;
function $c2b45657dc5a240d$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c2b45657dc5a240d$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c2b45657dc5a240d$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c2b45657dc5a240d$var$we = !1;
function $c2b45657dc5a240d$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $c2b45657dc5a240d$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c2b45657dc5a240d$var$te = !0;
            return $c2b45657dc5a240d$var$se;
        case "textInput":
            return a = b.data, a === $c2b45657dc5a240d$var$se && $c2b45657dc5a240d$var$te ? null : a;
        default:
            return null;
    }
}
function $c2b45657dc5a240d$var$ye(a, b) {
    if ($c2b45657dc5a240d$var$we) return "compositionend" === a || !$c2b45657dc5a240d$var$oe && $c2b45657dc5a240d$var$ue(a, b) ? (a = $c2b45657dc5a240d$var$Bd(), $c2b45657dc5a240d$var$Ad = $c2b45657dc5a240d$var$zd = $c2b45657dc5a240d$var$yd = null, $c2b45657dc5a240d$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c2b45657dc5a240d$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c2b45657dc5a240d$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c2b45657dc5a240d$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c2b45657dc5a240d$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $c2b45657dc5a240d$var$Be(a, b, c, d) {
    $c2b45657dc5a240d$var$Eb(d);
    b = $c2b45657dc5a240d$var$Ce(b, "onChange");
    0 < b.length && (c = new $c2b45657dc5a240d$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c2b45657dc5a240d$var$De = null, $c2b45657dc5a240d$var$Ee = null;
function $c2b45657dc5a240d$var$Fe(a) {
    $c2b45657dc5a240d$var$Ge(a, 0);
}
function $c2b45657dc5a240d$var$He(a) {
    var b = $c2b45657dc5a240d$var$Ie(a);
    if ($c2b45657dc5a240d$var$Wa(b)) return a;
}
function $c2b45657dc5a240d$var$Je(a, b) {
    if ("change" === a) return b;
}
var $c2b45657dc5a240d$var$Ke = !1;
if ($c2b45657dc5a240d$var$ia) {
    var $c2b45657dc5a240d$var$Le;
    if ($c2b45657dc5a240d$var$ia) {
        var $c2b45657dc5a240d$var$Me = "oninput" in document;
        if (!$c2b45657dc5a240d$var$Me) {
            var $c2b45657dc5a240d$var$Ne = document.createElement("div");
            $c2b45657dc5a240d$var$Ne.setAttribute("oninput", "return;");
            $c2b45657dc5a240d$var$Me = "function" === typeof $c2b45657dc5a240d$var$Ne.oninput;
        }
        $c2b45657dc5a240d$var$Le = $c2b45657dc5a240d$var$Me;
    } else $c2b45657dc5a240d$var$Le = !1;
    $c2b45657dc5a240d$var$Ke = $c2b45657dc5a240d$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $c2b45657dc5a240d$var$Oe() {
    $c2b45657dc5a240d$var$De && ($c2b45657dc5a240d$var$De.detachEvent("onpropertychange", $c2b45657dc5a240d$var$Pe), $c2b45657dc5a240d$var$Ee = $c2b45657dc5a240d$var$De = null);
}
function $c2b45657dc5a240d$var$Pe(a) {
    if ("value" === a.propertyName && $c2b45657dc5a240d$var$He($c2b45657dc5a240d$var$Ee)) {
        var b = [];
        $c2b45657dc5a240d$var$Be(b, $c2b45657dc5a240d$var$Ee, a, $c2b45657dc5a240d$var$xb(a));
        $c2b45657dc5a240d$var$Jb($c2b45657dc5a240d$var$Fe, b);
    }
}
function $c2b45657dc5a240d$var$Qe(a, b, c) {
    "focusin" === a ? ($c2b45657dc5a240d$var$Oe(), $c2b45657dc5a240d$var$De = b, $c2b45657dc5a240d$var$Ee = c, $c2b45657dc5a240d$var$De.attachEvent("onpropertychange", $c2b45657dc5a240d$var$Pe)) : "focusout" === a && $c2b45657dc5a240d$var$Oe();
}
function $c2b45657dc5a240d$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c2b45657dc5a240d$var$He($c2b45657dc5a240d$var$Ee);
}
function $c2b45657dc5a240d$var$Se(a, b) {
    if ("click" === a) return $c2b45657dc5a240d$var$He(b);
}
function $c2b45657dc5a240d$var$Te(a, b) {
    if ("input" === a || "change" === a) return $c2b45657dc5a240d$var$He(b);
}
function $c2b45657dc5a240d$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c2b45657dc5a240d$var$Ve = "function" === typeof Object.is ? Object.is : $c2b45657dc5a240d$var$Ue;
function $c2b45657dc5a240d$var$We(a, b) {
    if ($c2b45657dc5a240d$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c2b45657dc5a240d$var$ja.call(b, e) || !$c2b45657dc5a240d$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $c2b45657dc5a240d$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c2b45657dc5a240d$var$Ye(a, b) {
    var c = $c2b45657dc5a240d$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c2b45657dc5a240d$var$Xe(c);
    }
}
function $c2b45657dc5a240d$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c2b45657dc5a240d$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c2b45657dc5a240d$var$$e() {
    for(var a = window, b = $c2b45657dc5a240d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c2b45657dc5a240d$var$Xa(a.document);
    }
    return b;
}
function $c2b45657dc5a240d$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c2b45657dc5a240d$var$bf(a) {
    var b = $c2b45657dc5a240d$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c2b45657dc5a240d$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c2b45657dc5a240d$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c2b45657dc5a240d$var$Ye(c, f);
                var g = $c2b45657dc5a240d$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c2b45657dc5a240d$var$cf = $c2b45657dc5a240d$var$ia && "documentMode" in document && 11 >= document.documentMode, $c2b45657dc5a240d$var$df = null, $c2b45657dc5a240d$var$ef = null, $c2b45657dc5a240d$var$ff = null, $c2b45657dc5a240d$var$gf = !1;
function $c2b45657dc5a240d$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c2b45657dc5a240d$var$gf || null == $c2b45657dc5a240d$var$df || $c2b45657dc5a240d$var$df !== $c2b45657dc5a240d$var$Xa(d) || (d = $c2b45657dc5a240d$var$df, "selectionStart" in d && $c2b45657dc5a240d$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c2b45657dc5a240d$var$ff && $c2b45657dc5a240d$var$We($c2b45657dc5a240d$var$ff, d) || ($c2b45657dc5a240d$var$ff = d, d = $c2b45657dc5a240d$var$Ce($c2b45657dc5a240d$var$ef, "onSelect"), 0 < d.length && (b = new $c2b45657dc5a240d$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c2b45657dc5a240d$var$df)));
}
function $c2b45657dc5a240d$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c2b45657dc5a240d$var$kf = {
    animationend: $c2b45657dc5a240d$var$jf("Animation", "AnimationEnd"),
    animationiteration: $c2b45657dc5a240d$var$jf("Animation", "AnimationIteration"),
    animationstart: $c2b45657dc5a240d$var$jf("Animation", "AnimationStart"),
    transitionend: $c2b45657dc5a240d$var$jf("Transition", "TransitionEnd")
}, $c2b45657dc5a240d$var$lf = {}, $c2b45657dc5a240d$var$mf = {};
$c2b45657dc5a240d$var$ia && ($c2b45657dc5a240d$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $c2b45657dc5a240d$var$kf.animationend.animation, delete $c2b45657dc5a240d$var$kf.animationiteration.animation, delete $c2b45657dc5a240d$var$kf.animationstart.animation), "TransitionEvent" in window || delete $c2b45657dc5a240d$var$kf.transitionend.transition);
function $c2b45657dc5a240d$var$nf(a) {
    if ($c2b45657dc5a240d$var$lf[a]) return $c2b45657dc5a240d$var$lf[a];
    if (!$c2b45657dc5a240d$var$kf[a]) return a;
    var b = $c2b45657dc5a240d$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c2b45657dc5a240d$var$mf) return $c2b45657dc5a240d$var$lf[a] = b[c];
    return a;
}
var $c2b45657dc5a240d$var$of = $c2b45657dc5a240d$var$nf("animationend"), $c2b45657dc5a240d$var$pf = $c2b45657dc5a240d$var$nf("animationiteration"), $c2b45657dc5a240d$var$qf = $c2b45657dc5a240d$var$nf("animationstart"), $c2b45657dc5a240d$var$rf = $c2b45657dc5a240d$var$nf("transitionend"), $c2b45657dc5a240d$var$sf = new Map, $c2b45657dc5a240d$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c2b45657dc5a240d$var$uf(a, b) {
    $c2b45657dc5a240d$var$sf.set(a, b);
    $c2b45657dc5a240d$var$fa(b, [
        a
    ]);
}
for(var $c2b45657dc5a240d$var$vf = 0; $c2b45657dc5a240d$var$vf < $c2b45657dc5a240d$var$tf.length; $c2b45657dc5a240d$var$vf++){
    var $c2b45657dc5a240d$var$wf = $c2b45657dc5a240d$var$tf[$c2b45657dc5a240d$var$vf], $c2b45657dc5a240d$var$xf = $c2b45657dc5a240d$var$wf.toLowerCase(), $c2b45657dc5a240d$var$yf = $c2b45657dc5a240d$var$wf[0].toUpperCase() + $c2b45657dc5a240d$var$wf.slice(1);
    $c2b45657dc5a240d$var$uf($c2b45657dc5a240d$var$xf, "on" + $c2b45657dc5a240d$var$yf);
}
$c2b45657dc5a240d$var$uf($c2b45657dc5a240d$var$of, "onAnimationEnd");
$c2b45657dc5a240d$var$uf($c2b45657dc5a240d$var$pf, "onAnimationIteration");
$c2b45657dc5a240d$var$uf($c2b45657dc5a240d$var$qf, "onAnimationStart");
$c2b45657dc5a240d$var$uf("dblclick", "onDoubleClick");
$c2b45657dc5a240d$var$uf("focusin", "onFocus");
$c2b45657dc5a240d$var$uf("focusout", "onBlur");
$c2b45657dc5a240d$var$uf($c2b45657dc5a240d$var$rf, "onTransitionEnd");
$c2b45657dc5a240d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c2b45657dc5a240d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c2b45657dc5a240d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c2b45657dc5a240d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c2b45657dc5a240d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c2b45657dc5a240d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c2b45657dc5a240d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c2b45657dc5a240d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c2b45657dc5a240d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c2b45657dc5a240d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c2b45657dc5a240d$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c2b45657dc5a240d$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($c2b45657dc5a240d$var$zf));
function $c2b45657dc5a240d$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c2b45657dc5a240d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c2b45657dc5a240d$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c2b45657dc5a240d$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c2b45657dc5a240d$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($c2b45657dc5a240d$var$Qb) throw a = $c2b45657dc5a240d$var$Rb, $c2b45657dc5a240d$var$Qb = !1, $c2b45657dc5a240d$var$Rb = null, a;
}
function $c2b45657dc5a240d$var$F(a, b) {
    var c = b[$c2b45657dc5a240d$var$Cf];
    void 0 === c && (c = b[$c2b45657dc5a240d$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c2b45657dc5a240d$var$Df(b, a, 2, !1), c.add(d));
}
function $c2b45657dc5a240d$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c2b45657dc5a240d$var$Df(c, a, d, b);
}
var $c2b45657dc5a240d$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $c2b45657dc5a240d$var$Gf(a) {
    if (!a[$c2b45657dc5a240d$var$Ff]) {
        a[$c2b45657dc5a240d$var$Ff] = !0;
        $c2b45657dc5a240d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c2b45657dc5a240d$var$Af.has(b) || $c2b45657dc5a240d$var$Ef(b, !1, a), $c2b45657dc5a240d$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c2b45657dc5a240d$var$Ff] || (b[$c2b45657dc5a240d$var$Ff] = !0, $c2b45657dc5a240d$var$Ef("selectionchange", !1, b));
    }
}
function $c2b45657dc5a240d$var$Df(a, b, c, d) {
    switch($c2b45657dc5a240d$var$xd(b)){
        case 1:
            var e = $c2b45657dc5a240d$var$sd;
            break;
        case 4:
            e = $c2b45657dc5a240d$var$ud;
            break;
        default:
            e = $c2b45657dc5a240d$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c2b45657dc5a240d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c2b45657dc5a240d$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c2b45657dc5a240d$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c2b45657dc5a240d$var$Jb(function() {
        var d = f, e = $c2b45657dc5a240d$var$xb(c), g = [];
        a: {
            var h = $c2b45657dc5a240d$var$sf.get(a);
            if (void 0 !== h) {
                var k = $c2b45657dc5a240d$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $c2b45657dc5a240d$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c2b45657dc5a240d$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $c2b45657dc5a240d$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $c2b45657dc5a240d$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c2b45657dc5a240d$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c2b45657dc5a240d$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c2b45657dc5a240d$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c2b45657dc5a240d$var$ie;
                        break;
                    case $c2b45657dc5a240d$var$of:
                    case $c2b45657dc5a240d$var$pf:
                    case $c2b45657dc5a240d$var$qf:
                        k = $c2b45657dc5a240d$var$Vd;
                        break;
                    case $c2b45657dc5a240d$var$rf:
                        k = $c2b45657dc5a240d$var$ke;
                        break;
                    case "scroll":
                        k = $c2b45657dc5a240d$var$Jd;
                        break;
                    case "wheel":
                        k = $c2b45657dc5a240d$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c2b45657dc5a240d$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c2b45657dc5a240d$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $c2b45657dc5a240d$var$Kb(y, x), null != D && w.push($c2b45657dc5a240d$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c2b45657dc5a240d$var$wb && (m = c.relatedTarget || c.fromElement) && ($c2b45657dc5a240d$var$jd(m) || m[$c2b45657dc5a240d$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $c2b45657dc5a240d$var$jd(m) : null, null !== m && (C = $c2b45657dc5a240d$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $c2b45657dc5a240d$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $c2b45657dc5a240d$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $c2b45657dc5a240d$var$Ie(k);
                        v = null == m ? h : $c2b45657dc5a240d$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $c2b45657dc5a240d$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $c2b45657dc5a240d$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $c2b45657dc5a240d$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $c2b45657dc5a240d$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $c2b45657dc5a240d$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $c2b45657dc5a240d$var$Jf(w);
                                x = $c2b45657dc5a240d$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $c2b45657dc5a240d$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $c2b45657dc5a240d$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $c2b45657dc5a240d$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $c2b45657dc5a240d$var$Je;
                else if ($c2b45657dc5a240d$var$Ae(h)) {
                    if ($c2b45657dc5a240d$var$Ke) ca = $c2b45657dc5a240d$var$Te;
                    else {
                        ca = $c2b45657dc5a240d$var$Re;
                        var R = $c2b45657dc5a240d$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $c2b45657dc5a240d$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $c2b45657dc5a240d$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $c2b45657dc5a240d$var$bb(h, "number", h.value);
            }
            R = d ? $c2b45657dc5a240d$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($c2b45657dc5a240d$var$Ae(R) || "true" === R.contentEditable) $c2b45657dc5a240d$var$df = R, $c2b45657dc5a240d$var$ef = d, $c2b45657dc5a240d$var$ff = null;
                    break;
                case "focusout":
                    $c2b45657dc5a240d$var$ff = $c2b45657dc5a240d$var$ef = $c2b45657dc5a240d$var$df = null;
                    break;
                case "mousedown":
                    $c2b45657dc5a240d$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c2b45657dc5a240d$var$gf = !1;
                    $c2b45657dc5a240d$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($c2b45657dc5a240d$var$cf) break;
                case "keydown":
                case "keyup":
                    $c2b45657dc5a240d$var$hf(g, c, e);
            }
            var sa;
            if ($c2b45657dc5a240d$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $c2b45657dc5a240d$var$we ? $c2b45657dc5a240d$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($c2b45657dc5a240d$var$re && "ko" !== c.locale && ($c2b45657dc5a240d$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $c2b45657dc5a240d$var$we && (sa = $c2b45657dc5a240d$var$Bd()) : ($c2b45657dc5a240d$var$yd = e, $c2b45657dc5a240d$var$zd = "value" in $c2b45657dc5a240d$var$yd ? $c2b45657dc5a240d$var$yd.value : $c2b45657dc5a240d$var$yd.textContent, $c2b45657dc5a240d$var$we = !0)), R = $c2b45657dc5a240d$var$Ce(d, V), 0 < R.length && (V = new $c2b45657dc5a240d$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $c2b45657dc5a240d$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $c2b45657dc5a240d$var$qe ? $c2b45657dc5a240d$var$xe(a, c) : $c2b45657dc5a240d$var$ye(a, c)) d = $c2b45657dc5a240d$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $c2b45657dc5a240d$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $c2b45657dc5a240d$var$Ge(g, b);
    });
}
function $c2b45657dc5a240d$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c2b45657dc5a240d$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c2b45657dc5a240d$var$Kb(a, c), null != f && d.unshift($c2b45657dc5a240d$var$Hf(a, f, e)), f = $c2b45657dc5a240d$var$Kb(a, b), null != f && d.push($c2b45657dc5a240d$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c2b45657dc5a240d$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c2b45657dc5a240d$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c2b45657dc5a240d$var$Kb(c, f), null != k && g.unshift($c2b45657dc5a240d$var$Hf(c, k, h))) : e || (k = $c2b45657dc5a240d$var$Kb(c, f), null != k && g.push($c2b45657dc5a240d$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c2b45657dc5a240d$var$Lf = /\r\n?/g, $c2b45657dc5a240d$var$Mf = /\u0000|\uFFFD/g;
function $c2b45657dc5a240d$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c2b45657dc5a240d$var$Lf, "\n").replace($c2b45657dc5a240d$var$Mf, "");
}
function $c2b45657dc5a240d$var$Of(a, b, c) {
    b = $c2b45657dc5a240d$var$Nf(b);
    if ($c2b45657dc5a240d$var$Nf(a) !== b && c) throw Error($c2b45657dc5a240d$var$p(425));
}
function $c2b45657dc5a240d$var$Pf() {}
var $c2b45657dc5a240d$var$Qf = null, $c2b45657dc5a240d$var$Rf = null;
function $c2b45657dc5a240d$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c2b45657dc5a240d$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $c2b45657dc5a240d$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c2b45657dc5a240d$var$Vf = "function" === typeof Promise ? Promise : void 0, $c2b45657dc5a240d$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c2b45657dc5a240d$var$Vf ? function(a) {
    return $c2b45657dc5a240d$var$Vf.resolve(null).then(a).catch($c2b45657dc5a240d$var$Wf);
} : $c2b45657dc5a240d$var$Tf;
function $c2b45657dc5a240d$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c2b45657dc5a240d$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c2b45657dc5a240d$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c2b45657dc5a240d$var$pd(b);
}
function $c2b45657dc5a240d$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c2b45657dc5a240d$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c2b45657dc5a240d$var$ag = Math.random().toString(36).slice(2), $c2b45657dc5a240d$var$bg = "__reactFiber$" + $c2b45657dc5a240d$var$ag, $c2b45657dc5a240d$var$cg = "__reactProps$" + $c2b45657dc5a240d$var$ag, $c2b45657dc5a240d$var$If = "__reactContainer$" + $c2b45657dc5a240d$var$ag, $c2b45657dc5a240d$var$Cf = "__reactEvents$" + $c2b45657dc5a240d$var$ag, $c2b45657dc5a240d$var$dg = "__reactListeners$" + $c2b45657dc5a240d$var$ag, $c2b45657dc5a240d$var$eg = "__reactHandles$" + $c2b45657dc5a240d$var$ag;
function $c2b45657dc5a240d$var$jd(a) {
    var b = a[$c2b45657dc5a240d$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c2b45657dc5a240d$var$If] || c[$c2b45657dc5a240d$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c2b45657dc5a240d$var$$f(a); null !== a;){
                if (c = a[$c2b45657dc5a240d$var$bg]) return c;
                a = $c2b45657dc5a240d$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c2b45657dc5a240d$var$Cb(a) {
    a = a[$c2b45657dc5a240d$var$bg] || a[$c2b45657dc5a240d$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c2b45657dc5a240d$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c2b45657dc5a240d$var$p(33));
}
function $c2b45657dc5a240d$var$Db(a) {
    return a[$c2b45657dc5a240d$var$cg] || null;
}
var $c2b45657dc5a240d$var$fg = [], $c2b45657dc5a240d$var$gg = -1;
function $c2b45657dc5a240d$var$hg(a) {
    return {
        current: a
    };
}
function $c2b45657dc5a240d$var$G(a) {
    0 > $c2b45657dc5a240d$var$gg || (a.current = $c2b45657dc5a240d$var$fg[$c2b45657dc5a240d$var$gg], $c2b45657dc5a240d$var$fg[$c2b45657dc5a240d$var$gg] = null, $c2b45657dc5a240d$var$gg--);
}
function $c2b45657dc5a240d$var$H(a, b) {
    $c2b45657dc5a240d$var$gg++;
    $c2b45657dc5a240d$var$fg[$c2b45657dc5a240d$var$gg] = a.current;
    a.current = b;
}
var $c2b45657dc5a240d$var$ig = {}, $c2b45657dc5a240d$var$I = $c2b45657dc5a240d$var$hg($c2b45657dc5a240d$var$ig), $c2b45657dc5a240d$var$jg = $c2b45657dc5a240d$var$hg(!1), $c2b45657dc5a240d$var$kg = $c2b45657dc5a240d$var$ig;
function $c2b45657dc5a240d$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c2b45657dc5a240d$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c2b45657dc5a240d$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c2b45657dc5a240d$var$ng() {
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jg);
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$I);
}
function $c2b45657dc5a240d$var$og(a, b, c) {
    if ($c2b45657dc5a240d$var$I.current !== $c2b45657dc5a240d$var$ig) throw Error($c2b45657dc5a240d$var$p(168));
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$I, b);
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$jg, c);
}
function $c2b45657dc5a240d$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c2b45657dc5a240d$var$p(108, $c2b45657dc5a240d$var$Ra(a) || "Unknown", e));
    return $c2b45657dc5a240d$var$u({}, c, d);
}
function $c2b45657dc5a240d$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c2b45657dc5a240d$var$ig;
    $c2b45657dc5a240d$var$kg = $c2b45657dc5a240d$var$I.current;
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$I, a);
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$jg, $c2b45657dc5a240d$var$jg.current);
    return !0;
}
function $c2b45657dc5a240d$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c2b45657dc5a240d$var$p(169));
    c ? (a = $c2b45657dc5a240d$var$pg(a, b, $c2b45657dc5a240d$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jg), $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$I), $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$I, a)) : $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jg);
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$jg, c);
}
var $c2b45657dc5a240d$var$sg = null, $c2b45657dc5a240d$var$tg = !1, $c2b45657dc5a240d$var$ug = !1;
function $c2b45657dc5a240d$var$vg(a) {
    null === $c2b45657dc5a240d$var$sg ? $c2b45657dc5a240d$var$sg = [
        a
    ] : $c2b45657dc5a240d$var$sg.push(a);
}
function $c2b45657dc5a240d$var$wg(a) {
    $c2b45657dc5a240d$var$tg = !0;
    $c2b45657dc5a240d$var$vg(a);
}
function $c2b45657dc5a240d$var$xg() {
    if (!$c2b45657dc5a240d$var$ug && null !== $c2b45657dc5a240d$var$sg) {
        $c2b45657dc5a240d$var$ug = !0;
        var a = 0, b = $c2b45657dc5a240d$var$E;
        try {
            var c = $c2b45657dc5a240d$var$sg;
            for($c2b45657dc5a240d$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c2b45657dc5a240d$var$sg = null;
            $c2b45657dc5a240d$var$tg = !1;
        } catch (e) {
            throw null !== $c2b45657dc5a240d$var$sg && ($c2b45657dc5a240d$var$sg = $c2b45657dc5a240d$var$sg.slice(a + 1)), $c2b45657dc5a240d$var$ac($c2b45657dc5a240d$var$fc, $c2b45657dc5a240d$var$xg), e;
        } finally{
            $c2b45657dc5a240d$var$E = b, $c2b45657dc5a240d$var$ug = !1;
        }
    }
    return null;
}
var $c2b45657dc5a240d$var$yg = [], $c2b45657dc5a240d$var$zg = 0, $c2b45657dc5a240d$var$Ag = null, $c2b45657dc5a240d$var$Bg = 0, $c2b45657dc5a240d$var$Cg = [], $c2b45657dc5a240d$var$Dg = 0, $c2b45657dc5a240d$var$Eg = null, $c2b45657dc5a240d$var$Fg = 1, $c2b45657dc5a240d$var$Gg = "";
function $c2b45657dc5a240d$var$Hg(a, b) {
    $c2b45657dc5a240d$var$yg[$c2b45657dc5a240d$var$zg++] = $c2b45657dc5a240d$var$Bg;
    $c2b45657dc5a240d$var$yg[$c2b45657dc5a240d$var$zg++] = $c2b45657dc5a240d$var$Ag;
    $c2b45657dc5a240d$var$Ag = a;
    $c2b45657dc5a240d$var$Bg = b;
}
function $c2b45657dc5a240d$var$Ig(a, b, c) {
    $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg++] = $c2b45657dc5a240d$var$Fg;
    $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg++] = $c2b45657dc5a240d$var$Gg;
    $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg++] = $c2b45657dc5a240d$var$Eg;
    $c2b45657dc5a240d$var$Eg = a;
    var d = $c2b45657dc5a240d$var$Fg;
    a = $c2b45657dc5a240d$var$Gg;
    var e = 32 - $c2b45657dc5a240d$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c2b45657dc5a240d$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c2b45657dc5a240d$var$Fg = 1 << 32 - $c2b45657dc5a240d$var$Ac(b) + e | c << e | d;
        $c2b45657dc5a240d$var$Gg = f + a;
    } else $c2b45657dc5a240d$var$Fg = 1 << f | c << e | d, $c2b45657dc5a240d$var$Gg = a;
}
function $c2b45657dc5a240d$var$Jg(a) {
    null !== a.return && ($c2b45657dc5a240d$var$Hg(a, 1), $c2b45657dc5a240d$var$Ig(a, 1, 0));
}
function $c2b45657dc5a240d$var$Kg(a) {
    for(; a === $c2b45657dc5a240d$var$Ag;)$c2b45657dc5a240d$var$Ag = $c2b45657dc5a240d$var$yg[--$c2b45657dc5a240d$var$zg], $c2b45657dc5a240d$var$yg[$c2b45657dc5a240d$var$zg] = null, $c2b45657dc5a240d$var$Bg = $c2b45657dc5a240d$var$yg[--$c2b45657dc5a240d$var$zg], $c2b45657dc5a240d$var$yg[$c2b45657dc5a240d$var$zg] = null;
    for(; a === $c2b45657dc5a240d$var$Eg;)$c2b45657dc5a240d$var$Eg = $c2b45657dc5a240d$var$Cg[--$c2b45657dc5a240d$var$Dg], $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg] = null, $c2b45657dc5a240d$var$Gg = $c2b45657dc5a240d$var$Cg[--$c2b45657dc5a240d$var$Dg], $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg] = null, $c2b45657dc5a240d$var$Fg = $c2b45657dc5a240d$var$Cg[--$c2b45657dc5a240d$var$Dg], $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg] = null;
}
var $c2b45657dc5a240d$var$Lg = null, $c2b45657dc5a240d$var$Mg = null, $c2b45657dc5a240d$var$J = !1, $c2b45657dc5a240d$var$Ng = null;
function $c2b45657dc5a240d$var$Og(a, b) {
    var c = $c2b45657dc5a240d$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c2b45657dc5a240d$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c2b45657dc5a240d$var$Lg = a, $c2b45657dc5a240d$var$Mg = $c2b45657dc5a240d$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c2b45657dc5a240d$var$Lg = a, $c2b45657dc5a240d$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c2b45657dc5a240d$var$Eg ? {
                id: $c2b45657dc5a240d$var$Fg,
                overflow: $c2b45657dc5a240d$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c2b45657dc5a240d$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c2b45657dc5a240d$var$Lg = a, $c2b45657dc5a240d$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c2b45657dc5a240d$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c2b45657dc5a240d$var$Sg(a) {
    if ($c2b45657dc5a240d$var$J) {
        var b = $c2b45657dc5a240d$var$Mg;
        if (b) {
            var c = b;
            if (!$c2b45657dc5a240d$var$Qg(a, b)) {
                if ($c2b45657dc5a240d$var$Rg(a)) throw Error($c2b45657dc5a240d$var$p(418));
                b = $c2b45657dc5a240d$var$Zf(c.nextSibling);
                var d = $c2b45657dc5a240d$var$Lg;
                b && $c2b45657dc5a240d$var$Qg(a, b) ? $c2b45657dc5a240d$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $c2b45657dc5a240d$var$J = !1, $c2b45657dc5a240d$var$Lg = a);
            }
        } else {
            if ($c2b45657dc5a240d$var$Rg(a)) throw Error($c2b45657dc5a240d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c2b45657dc5a240d$var$J = !1;
            $c2b45657dc5a240d$var$Lg = a;
        }
    }
}
function $c2b45657dc5a240d$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c2b45657dc5a240d$var$Lg = a;
}
function $c2b45657dc5a240d$var$Ug(a) {
    if (a !== $c2b45657dc5a240d$var$Lg) return !1;
    if (!$c2b45657dc5a240d$var$J) return $c2b45657dc5a240d$var$Tg(a), $c2b45657dc5a240d$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c2b45657dc5a240d$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $c2b45657dc5a240d$var$Mg)) {
        if ($c2b45657dc5a240d$var$Rg(a)) throw $c2b45657dc5a240d$var$Vg(), Error($c2b45657dc5a240d$var$p(418));
        for(; b;)$c2b45657dc5a240d$var$Og(a, b), b = $c2b45657dc5a240d$var$Zf(b.nextSibling);
    }
    $c2b45657dc5a240d$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c2b45657dc5a240d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c2b45657dc5a240d$var$Mg = $c2b45657dc5a240d$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c2b45657dc5a240d$var$Mg = null;
        }
    } else $c2b45657dc5a240d$var$Mg = $c2b45657dc5a240d$var$Lg ? $c2b45657dc5a240d$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c2b45657dc5a240d$var$Vg() {
    for(var a = $c2b45657dc5a240d$var$Mg; a;)a = $c2b45657dc5a240d$var$Zf(a.nextSibling);
}
function $c2b45657dc5a240d$var$Wg() {
    $c2b45657dc5a240d$var$Mg = $c2b45657dc5a240d$var$Lg = null;
    $c2b45657dc5a240d$var$J = !1;
}
function $c2b45657dc5a240d$var$Xg(a) {
    null === $c2b45657dc5a240d$var$Ng ? $c2b45657dc5a240d$var$Ng = [
        a
    ] : $c2b45657dc5a240d$var$Ng.push(a);
}
var $c2b45657dc5a240d$var$Yg = $c2b45657dc5a240d$var$va.ReactCurrentBatchConfig;
function $c2b45657dc5a240d$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c2b45657dc5a240d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c2b45657dc5a240d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c2b45657dc5a240d$var$p(284));
        if (!c._owner) throw Error($c2b45657dc5a240d$var$p(290, a));
    }
    return a;
}
function $c2b45657dc5a240d$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c2b45657dc5a240d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c2b45657dc5a240d$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $c2b45657dc5a240d$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c2b45657dc5a240d$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c2b45657dc5a240d$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c2b45657dc5a240d$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c2b45657dc5a240d$var$Ha && $c2b45657dc5a240d$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $c2b45657dc5a240d$var$Zg(a, b, c), d.return = a, d;
        d = $c2b45657dc5a240d$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c2b45657dc5a240d$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c2b45657dc5a240d$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c2b45657dc5a240d$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c2b45657dc5a240d$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c2b45657dc5a240d$var$wa:
                    return c = $c2b45657dc5a240d$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c2b45657dc5a240d$var$Zg(a, null, b), c.return = a, c;
                case $c2b45657dc5a240d$var$xa:
                    return b = $c2b45657dc5a240d$var$fh(b, a.mode, c), b.return = a, b;
                case $c2b45657dc5a240d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c2b45657dc5a240d$var$db(b) || $c2b45657dc5a240d$var$Ka(b)) return b = $c2b45657dc5a240d$var$gh(b, a.mode, c, null), b.return = a, b;
            $c2b45657dc5a240d$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c2b45657dc5a240d$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c2b45657dc5a240d$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c2b45657dc5a240d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c2b45657dc5a240d$var$db(c) || $c2b45657dc5a240d$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $c2b45657dc5a240d$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c2b45657dc5a240d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c2b45657dc5a240d$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c2b45657dc5a240d$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($c2b45657dc5a240d$var$db(d) || $c2b45657dc5a240d$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $c2b45657dc5a240d$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $c2b45657dc5a240d$var$J && $c2b45657dc5a240d$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $c2b45657dc5a240d$var$J && $c2b45657dc5a240d$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $c2b45657dc5a240d$var$J && $c2b45657dc5a240d$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $c2b45657dc5a240d$var$Ka(h);
        if ("function" !== typeof l) throw Error($c2b45657dc5a240d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c2b45657dc5a240d$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $c2b45657dc5a240d$var$J && $c2b45657dc5a240d$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $c2b45657dc5a240d$var$J && $c2b45657dc5a240d$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c2b45657dc5a240d$var$J && $c2b45657dc5a240d$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c2b45657dc5a240d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c2b45657dc5a240d$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c2b45657dc5a240d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c2b45657dc5a240d$var$Ha && $c2b45657dc5a240d$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c2b45657dc5a240d$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c2b45657dc5a240d$var$ya ? (d = $c2b45657dc5a240d$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c2b45657dc5a240d$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c2b45657dc5a240d$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c2b45657dc5a240d$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c2b45657dc5a240d$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c2b45657dc5a240d$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($c2b45657dc5a240d$var$db(f)) return m(a, d, f, h);
            if ($c2b45657dc5a240d$var$Ka(f)) return w(a, d, f, h);
            $c2b45657dc5a240d$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c2b45657dc5a240d$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $c2b45657dc5a240d$var$hh = $c2b45657dc5a240d$var$bh(!0), $c2b45657dc5a240d$var$ih = $c2b45657dc5a240d$var$bh(!1), $c2b45657dc5a240d$var$jh = $c2b45657dc5a240d$var$hg(null), $c2b45657dc5a240d$var$kh = null, $c2b45657dc5a240d$var$lh = null, $c2b45657dc5a240d$var$mh = null;
function $c2b45657dc5a240d$var$nh() {
    $c2b45657dc5a240d$var$mh = $c2b45657dc5a240d$var$lh = $c2b45657dc5a240d$var$kh = null;
}
function $c2b45657dc5a240d$var$oh(a) {
    var b = $c2b45657dc5a240d$var$jh.current;
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jh);
    a._currentValue = b;
}
function $c2b45657dc5a240d$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c2b45657dc5a240d$var$qh(a, b) {
    $c2b45657dc5a240d$var$kh = a;
    $c2b45657dc5a240d$var$mh = $c2b45657dc5a240d$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c2b45657dc5a240d$var$rh = !0), a.firstContext = null);
}
function $c2b45657dc5a240d$var$sh(a) {
    var b = a._currentValue;
    if ($c2b45657dc5a240d$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c2b45657dc5a240d$var$lh) {
            if (null === $c2b45657dc5a240d$var$kh) throw Error($c2b45657dc5a240d$var$p(308));
            $c2b45657dc5a240d$var$lh = a;
            $c2b45657dc5a240d$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c2b45657dc5a240d$var$lh = $c2b45657dc5a240d$var$lh.next = a;
    }
    return b;
}
var $c2b45657dc5a240d$var$th = null;
function $c2b45657dc5a240d$var$uh(a) {
    null === $c2b45657dc5a240d$var$th ? $c2b45657dc5a240d$var$th = [
        a
    ] : $c2b45657dc5a240d$var$th.push(a);
}
function $c2b45657dc5a240d$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c2b45657dc5a240d$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c2b45657dc5a240d$var$wh(a, d);
}
function $c2b45657dc5a240d$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c2b45657dc5a240d$var$xh = !1;
function $c2b45657dc5a240d$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c2b45657dc5a240d$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c2b45657dc5a240d$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c2b45657dc5a240d$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c2b45657dc5a240d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c2b45657dc5a240d$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c2b45657dc5a240d$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c2b45657dc5a240d$var$wh(a, c);
}
function $c2b45657dc5a240d$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c2b45657dc5a240d$var$Oc(a, c);
    }
}
function $c2b45657dc5a240d$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c2b45657dc5a240d$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $c2b45657dc5a240d$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $c2b45657dc5a240d$var$u({}, q, r);
                            break a;
                        case 2:
                            $c2b45657dc5a240d$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c2b45657dc5a240d$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c2b45657dc5a240d$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c2b45657dc5a240d$var$p(191, e));
            e.call(d);
        }
    }
}
var $c2b45657dc5a240d$var$Hh = {}, $c2b45657dc5a240d$var$Ih = $c2b45657dc5a240d$var$hg($c2b45657dc5a240d$var$Hh), $c2b45657dc5a240d$var$Jh = $c2b45657dc5a240d$var$hg($c2b45657dc5a240d$var$Hh), $c2b45657dc5a240d$var$Kh = $c2b45657dc5a240d$var$hg($c2b45657dc5a240d$var$Hh);
function $c2b45657dc5a240d$var$Lh(a) {
    if (a === $c2b45657dc5a240d$var$Hh) throw Error($c2b45657dc5a240d$var$p(174));
    return a;
}
function $c2b45657dc5a240d$var$Mh(a, b) {
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Kh, b);
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Jh, a);
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ih, $c2b45657dc5a240d$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c2b45657dc5a240d$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c2b45657dc5a240d$var$kb(b, a);
    }
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Ih);
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ih, b);
}
function $c2b45657dc5a240d$var$Nh() {
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Ih);
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Jh);
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Kh);
}
function $c2b45657dc5a240d$var$Oh(a) {
    $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Kh.current);
    var b = $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Ih.current);
    var c = $c2b45657dc5a240d$var$kb(b, a.type);
    b !== c && ($c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Jh, a), $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ih, c));
}
function $c2b45657dc5a240d$var$Ph(a) {
    $c2b45657dc5a240d$var$Jh.current === a && ($c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Ih), $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Jh));
}
var $c2b45657dc5a240d$var$L = $c2b45657dc5a240d$var$hg(0);
function $c2b45657dc5a240d$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c2b45657dc5a240d$var$Rh = [];
function $c2b45657dc5a240d$var$Sh() {
    for(var a = 0; a < $c2b45657dc5a240d$var$Rh.length; a++)$c2b45657dc5a240d$var$Rh[a]._workInProgressVersionPrimary = null;
    $c2b45657dc5a240d$var$Rh.length = 0;
}
var $c2b45657dc5a240d$var$Th = $c2b45657dc5a240d$var$va.ReactCurrentDispatcher, $c2b45657dc5a240d$var$Uh = $c2b45657dc5a240d$var$va.ReactCurrentBatchConfig, $c2b45657dc5a240d$var$Vh = 0, $c2b45657dc5a240d$var$M = null, $c2b45657dc5a240d$var$N = null, $c2b45657dc5a240d$var$O = null, $c2b45657dc5a240d$var$Wh = !1, $c2b45657dc5a240d$var$Xh = !1, $c2b45657dc5a240d$var$Yh = 0, $c2b45657dc5a240d$var$Zh = 0;
function $c2b45657dc5a240d$var$P() {
    throw Error($c2b45657dc5a240d$var$p(321));
}
function $c2b45657dc5a240d$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c2b45657dc5a240d$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $c2b45657dc5a240d$var$ai(a, b, c, d, e, f) {
    $c2b45657dc5a240d$var$Vh = f;
    $c2b45657dc5a240d$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c2b45657dc5a240d$var$Th.current = null === a || null === a.memoizedState ? $c2b45657dc5a240d$var$bi : $c2b45657dc5a240d$var$ci;
    a = c(d, e);
    if ($c2b45657dc5a240d$var$Xh) {
        f = 0;
        do {
            $c2b45657dc5a240d$var$Xh = !1;
            $c2b45657dc5a240d$var$Yh = 0;
            if (25 <= f) throw Error($c2b45657dc5a240d$var$p(301));
            f += 1;
            $c2b45657dc5a240d$var$O = $c2b45657dc5a240d$var$N = null;
            b.updateQueue = null;
            $c2b45657dc5a240d$var$Th.current = $c2b45657dc5a240d$var$di;
            a = c(d, e);
        }while ($c2b45657dc5a240d$var$Xh);
    }
    $c2b45657dc5a240d$var$Th.current = $c2b45657dc5a240d$var$ei;
    b = null !== $c2b45657dc5a240d$var$N && null !== $c2b45657dc5a240d$var$N.next;
    $c2b45657dc5a240d$var$Vh = 0;
    $c2b45657dc5a240d$var$O = $c2b45657dc5a240d$var$N = $c2b45657dc5a240d$var$M = null;
    $c2b45657dc5a240d$var$Wh = !1;
    if (b) throw Error($c2b45657dc5a240d$var$p(300));
    return a;
}
function $c2b45657dc5a240d$var$fi() {
    var a = 0 !== $c2b45657dc5a240d$var$Yh;
    $c2b45657dc5a240d$var$Yh = 0;
    return a;
}
function $c2b45657dc5a240d$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c2b45657dc5a240d$var$O ? $c2b45657dc5a240d$var$M.memoizedState = $c2b45657dc5a240d$var$O = a : $c2b45657dc5a240d$var$O = $c2b45657dc5a240d$var$O.next = a;
    return $c2b45657dc5a240d$var$O;
}
function $c2b45657dc5a240d$var$hi() {
    if (null === $c2b45657dc5a240d$var$N) {
        var a = $c2b45657dc5a240d$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c2b45657dc5a240d$var$N.next;
    var b = null === $c2b45657dc5a240d$var$O ? $c2b45657dc5a240d$var$M.memoizedState : $c2b45657dc5a240d$var$O.next;
    if (null !== b) $c2b45657dc5a240d$var$O = b, $c2b45657dc5a240d$var$N = a;
    else {
        if (null === a) throw Error($c2b45657dc5a240d$var$p(310));
        $c2b45657dc5a240d$var$N = a;
        a = {
            memoizedState: $c2b45657dc5a240d$var$N.memoizedState,
            baseState: $c2b45657dc5a240d$var$N.baseState,
            baseQueue: $c2b45657dc5a240d$var$N.baseQueue,
            queue: $c2b45657dc5a240d$var$N.queue,
            next: null
        };
        null === $c2b45657dc5a240d$var$O ? $c2b45657dc5a240d$var$M.memoizedState = $c2b45657dc5a240d$var$O = a : $c2b45657dc5a240d$var$O = $c2b45657dc5a240d$var$O.next = a;
    }
    return $c2b45657dc5a240d$var$O;
}
function $c2b45657dc5a240d$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c2b45657dc5a240d$var$ji(a) {
    var b = $c2b45657dc5a240d$var$hi(), c = b.queue;
    if (null === c) throw Error($c2b45657dc5a240d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c2b45657dc5a240d$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($c2b45657dc5a240d$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c2b45657dc5a240d$var$M.lanes |= n;
                $c2b45657dc5a240d$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c2b45657dc5a240d$var$Ve(d, b.memoizedState) || ($c2b45657dc5a240d$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c2b45657dc5a240d$var$M.lanes |= f, $c2b45657dc5a240d$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c2b45657dc5a240d$var$ki(a) {
    var b = $c2b45657dc5a240d$var$hi(), c = b.queue;
    if (null === c) throw Error($c2b45657dc5a240d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c2b45657dc5a240d$var$Ve(f, b.memoizedState) || ($c2b45657dc5a240d$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c2b45657dc5a240d$var$li() {}
function $c2b45657dc5a240d$var$mi(a, b) {
    var c = $c2b45657dc5a240d$var$M, d = $c2b45657dc5a240d$var$hi(), e = b(), f = !$c2b45657dc5a240d$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $c2b45657dc5a240d$var$rh = !0);
    d = d.queue;
    $c2b45657dc5a240d$var$ni($c2b45657dc5a240d$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c2b45657dc5a240d$var$O && $c2b45657dc5a240d$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c2b45657dc5a240d$var$pi(9, $c2b45657dc5a240d$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $c2b45657dc5a240d$var$Q) throw Error($c2b45657dc5a240d$var$p(349));
        0 !== ($c2b45657dc5a240d$var$Vh & 30) || $c2b45657dc5a240d$var$ri(c, b, e);
    }
    return e;
}
function $c2b45657dc5a240d$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c2b45657dc5a240d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c2b45657dc5a240d$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c2b45657dc5a240d$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c2b45657dc5a240d$var$si(b) && $c2b45657dc5a240d$var$ti(a);
}
function $c2b45657dc5a240d$var$oi(a, b, c) {
    return c(function() {
        $c2b45657dc5a240d$var$si(b) && $c2b45657dc5a240d$var$ti(a);
    });
}
function $c2b45657dc5a240d$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c2b45657dc5a240d$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $c2b45657dc5a240d$var$ti(a) {
    var b = $c2b45657dc5a240d$var$wh(a, 1);
    null !== b && $c2b45657dc5a240d$var$ui(b, a, 1, -1);
}
function $c2b45657dc5a240d$var$vi(a) {
    var b = $c2b45657dc5a240d$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2b45657dc5a240d$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c2b45657dc5a240d$var$wi.bind(null, $c2b45657dc5a240d$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c2b45657dc5a240d$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c2b45657dc5a240d$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c2b45657dc5a240d$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c2b45657dc5a240d$var$xi() {
    return $c2b45657dc5a240d$var$hi().memoizedState;
}
function $c2b45657dc5a240d$var$Ai(a, b, c, d) {
    var e = $c2b45657dc5a240d$var$gi();
    $c2b45657dc5a240d$var$M.flags |= a;
    e.memoizedState = $c2b45657dc5a240d$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c2b45657dc5a240d$var$Bi(a, b, c, d) {
    var e = $c2b45657dc5a240d$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c2b45657dc5a240d$var$N) {
        var g = $c2b45657dc5a240d$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c2b45657dc5a240d$var$$h(d, g.deps)) {
            e.memoizedState = $c2b45657dc5a240d$var$pi(b, c, f, d);
            return;
        }
    }
    $c2b45657dc5a240d$var$M.flags |= a;
    e.memoizedState = $c2b45657dc5a240d$var$pi(1 | b, c, f, d);
}
function $c2b45657dc5a240d$var$Ci(a, b) {
    return $c2b45657dc5a240d$var$Ai(8390656, 8, a, b);
}
function $c2b45657dc5a240d$var$ni(a, b) {
    return $c2b45657dc5a240d$var$Bi(2048, 8, a, b);
}
function $c2b45657dc5a240d$var$Di(a, b) {
    return $c2b45657dc5a240d$var$Bi(4, 2, a, b);
}
function $c2b45657dc5a240d$var$Ei(a, b) {
    return $c2b45657dc5a240d$var$Bi(4, 4, a, b);
}
function $c2b45657dc5a240d$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c2b45657dc5a240d$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c2b45657dc5a240d$var$Bi(4, 4, $c2b45657dc5a240d$var$Fi.bind(null, b, a), c);
}
function $c2b45657dc5a240d$var$Hi() {}
function $c2b45657dc5a240d$var$Ii(a, b) {
    var c = $c2b45657dc5a240d$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c2b45657dc5a240d$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c2b45657dc5a240d$var$Ji(a, b) {
    var c = $c2b45657dc5a240d$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c2b45657dc5a240d$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c2b45657dc5a240d$var$Ki(a, b, c) {
    if (0 === ($c2b45657dc5a240d$var$Vh & 21)) return a.baseState && (a.baseState = !1, $c2b45657dc5a240d$var$rh = !0), a.memoizedState = c;
    $c2b45657dc5a240d$var$Ve(c, b) || (c = $c2b45657dc5a240d$var$Kc(), $c2b45657dc5a240d$var$M.lanes |= c, $c2b45657dc5a240d$var$Fh |= c, a.baseState = !0);
    return b;
}
function $c2b45657dc5a240d$var$Li(a, b) {
    var c = $c2b45657dc5a240d$var$E;
    $c2b45657dc5a240d$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c2b45657dc5a240d$var$Uh.transition;
    $c2b45657dc5a240d$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c2b45657dc5a240d$var$E = c, $c2b45657dc5a240d$var$Uh.transition = d;
    }
}
function $c2b45657dc5a240d$var$Mi() {
    return $c2b45657dc5a240d$var$hi().memoizedState;
}
function $c2b45657dc5a240d$var$Ni(a, b, c) {
    var d = $c2b45657dc5a240d$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2b45657dc5a240d$var$Pi(a)) $c2b45657dc5a240d$var$Qi(b, c);
    else if (c = $c2b45657dc5a240d$var$vh(a, b, c, d), null !== c) {
        var e = $c2b45657dc5a240d$var$Ri();
        $c2b45657dc5a240d$var$ui(c, a, d, e);
        $c2b45657dc5a240d$var$Si(c, b, d);
    }
    $c2b45657dc5a240d$var$yc(a, d);
}
function $c2b45657dc5a240d$var$wi(a, b, c) {
    var d = $c2b45657dc5a240d$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2b45657dc5a240d$var$Pi(a)) $c2b45657dc5a240d$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c2b45657dc5a240d$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c2b45657dc5a240d$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c2b45657dc5a240d$var$vh(a, b, e, d);
        null !== c && (e = $c2b45657dc5a240d$var$Ri(), $c2b45657dc5a240d$var$ui(c, a, d, e), $c2b45657dc5a240d$var$Si(c, b, d));
    }
    $c2b45657dc5a240d$var$yc(a, d);
}
function $c2b45657dc5a240d$var$Pi(a) {
    var b = a.alternate;
    return a === $c2b45657dc5a240d$var$M || null !== b && b === $c2b45657dc5a240d$var$M;
}
function $c2b45657dc5a240d$var$Qi(a, b) {
    $c2b45657dc5a240d$var$Xh = $c2b45657dc5a240d$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c2b45657dc5a240d$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c2b45657dc5a240d$var$Oc(a, c);
    }
}
var $c2b45657dc5a240d$var$ei = {
    readContext: $c2b45657dc5a240d$var$sh,
    useCallback: $c2b45657dc5a240d$var$P,
    useContext: $c2b45657dc5a240d$var$P,
    useEffect: $c2b45657dc5a240d$var$P,
    useImperativeHandle: $c2b45657dc5a240d$var$P,
    useInsertionEffect: $c2b45657dc5a240d$var$P,
    useLayoutEffect: $c2b45657dc5a240d$var$P,
    useMemo: $c2b45657dc5a240d$var$P,
    useReducer: $c2b45657dc5a240d$var$P,
    useRef: $c2b45657dc5a240d$var$P,
    useState: $c2b45657dc5a240d$var$P,
    useDebugValue: $c2b45657dc5a240d$var$P,
    useDeferredValue: $c2b45657dc5a240d$var$P,
    useTransition: $c2b45657dc5a240d$var$P,
    useMutableSource: $c2b45657dc5a240d$var$P,
    useSyncExternalStore: $c2b45657dc5a240d$var$P,
    useId: $c2b45657dc5a240d$var$P,
    unstable_isNewReconciler: !1
}, $c2b45657dc5a240d$var$bi = {
    readContext: $c2b45657dc5a240d$var$sh,
    useCallback: function(a, b) {
        $c2b45657dc5a240d$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c2b45657dc5a240d$var$sh,
    useEffect: $c2b45657dc5a240d$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c2b45657dc5a240d$var$Ai(4194308, 4, $c2b45657dc5a240d$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c2b45657dc5a240d$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c2b45657dc5a240d$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c2b45657dc5a240d$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c2b45657dc5a240d$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c2b45657dc5a240d$var$Ni.bind(null, $c2b45657dc5a240d$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c2b45657dc5a240d$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c2b45657dc5a240d$var$vi,
    useDebugValue: $c2b45657dc5a240d$var$Hi,
    useDeferredValue: function(a) {
        return $c2b45657dc5a240d$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $c2b45657dc5a240d$var$vi(!1), b = a[0];
        a = $c2b45657dc5a240d$var$Li.bind(null, a[1]);
        $c2b45657dc5a240d$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c2b45657dc5a240d$var$M, e = $c2b45657dc5a240d$var$gi();
        if ($c2b45657dc5a240d$var$J) {
            if (void 0 === c) throw Error($c2b45657dc5a240d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c2b45657dc5a240d$var$Q) throw Error($c2b45657dc5a240d$var$p(349));
            0 !== ($c2b45657dc5a240d$var$Vh & 30) || $c2b45657dc5a240d$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c2b45657dc5a240d$var$Ci($c2b45657dc5a240d$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c2b45657dc5a240d$var$pi(9, $c2b45657dc5a240d$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c2b45657dc5a240d$var$gi(), b = $c2b45657dc5a240d$var$Q.identifierPrefix;
        if ($c2b45657dc5a240d$var$J) {
            var c = $c2b45657dc5a240d$var$Gg;
            var d = $c2b45657dc5a240d$var$Fg;
            c = (d & ~(1 << 32 - $c2b45657dc5a240d$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c2b45657dc5a240d$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c2b45657dc5a240d$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c2b45657dc5a240d$var$ci = {
    readContext: $c2b45657dc5a240d$var$sh,
    useCallback: $c2b45657dc5a240d$var$Ii,
    useContext: $c2b45657dc5a240d$var$sh,
    useEffect: $c2b45657dc5a240d$var$ni,
    useImperativeHandle: $c2b45657dc5a240d$var$Gi,
    useInsertionEffect: $c2b45657dc5a240d$var$Di,
    useLayoutEffect: $c2b45657dc5a240d$var$Ei,
    useMemo: $c2b45657dc5a240d$var$Ji,
    useReducer: $c2b45657dc5a240d$var$ji,
    useRef: $c2b45657dc5a240d$var$xi,
    useState: function() {
        return $c2b45657dc5a240d$var$ji($c2b45657dc5a240d$var$ii);
    },
    useDebugValue: $c2b45657dc5a240d$var$Hi,
    useDeferredValue: function(a) {
        var b = $c2b45657dc5a240d$var$hi();
        return $c2b45657dc5a240d$var$Ki(b, $c2b45657dc5a240d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c2b45657dc5a240d$var$ji($c2b45657dc5a240d$var$ii)[0], b = $c2b45657dc5a240d$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c2b45657dc5a240d$var$li,
    useSyncExternalStore: $c2b45657dc5a240d$var$mi,
    useId: $c2b45657dc5a240d$var$Mi,
    unstable_isNewReconciler: !1
}, $c2b45657dc5a240d$var$di = {
    readContext: $c2b45657dc5a240d$var$sh,
    useCallback: $c2b45657dc5a240d$var$Ii,
    useContext: $c2b45657dc5a240d$var$sh,
    useEffect: $c2b45657dc5a240d$var$ni,
    useImperativeHandle: $c2b45657dc5a240d$var$Gi,
    useInsertionEffect: $c2b45657dc5a240d$var$Di,
    useLayoutEffect: $c2b45657dc5a240d$var$Ei,
    useMemo: $c2b45657dc5a240d$var$Ji,
    useReducer: $c2b45657dc5a240d$var$ki,
    useRef: $c2b45657dc5a240d$var$xi,
    useState: function() {
        return $c2b45657dc5a240d$var$ki($c2b45657dc5a240d$var$ii);
    },
    useDebugValue: $c2b45657dc5a240d$var$Hi,
    useDeferredValue: function(a) {
        var b = $c2b45657dc5a240d$var$hi();
        return null === $c2b45657dc5a240d$var$N ? b.memoizedState = a : $c2b45657dc5a240d$var$Ki(b, $c2b45657dc5a240d$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c2b45657dc5a240d$var$ki($c2b45657dc5a240d$var$ii)[0], b = $c2b45657dc5a240d$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c2b45657dc5a240d$var$li,
    useSyncExternalStore: $c2b45657dc5a240d$var$mi,
    useId: $c2b45657dc5a240d$var$Mi,
    unstable_isNewReconciler: !1
}, $c2b45657dc5a240d$var$Ti = $40GmU.unstable_now, $c2b45657dc5a240d$var$Ui = 0, $c2b45657dc5a240d$var$Vi = -1, $c2b45657dc5a240d$var$Wi = -1, $c2b45657dc5a240d$var$Xi = -1, $c2b45657dc5a240d$var$Yi = !1, $c2b45657dc5a240d$var$Zi = !1;
function $c2b45657dc5a240d$var$$i(a, b) {
    if (0 <= $c2b45657dc5a240d$var$Wi) {
        var c = $c2b45657dc5a240d$var$Ti() - $c2b45657dc5a240d$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $c2b45657dc5a240d$var$Wi = -1;
    }
}
function $c2b45657dc5a240d$var$aj(a) {
    if (0 <= $c2b45657dc5a240d$var$Vi) {
        var b = $c2b45657dc5a240d$var$Ti() - $c2b45657dc5a240d$var$Vi;
        $c2b45657dc5a240d$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $c2b45657dc5a240d$var$bj(a) {
    if (0 <= $c2b45657dc5a240d$var$Xi) {
        var b = $c2b45657dc5a240d$var$Ti() - $c2b45657dc5a240d$var$Xi;
        $c2b45657dc5a240d$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $c2b45657dc5a240d$var$cj() {
    $c2b45657dc5a240d$var$Vi = $c2b45657dc5a240d$var$Ti();
}
function $c2b45657dc5a240d$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $c2b45657dc5a240d$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $c2b45657dc5a240d$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c2b45657dc5a240d$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c2b45657dc5a240d$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c2b45657dc5a240d$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c2b45657dc5a240d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c2b45657dc5a240d$var$Ri(), e = $c2b45657dc5a240d$var$Oi(a), f = $c2b45657dc5a240d$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c2b45657dc5a240d$var$Bh(a, f, e);
        null !== b && ($c2b45657dc5a240d$var$ui(b, a, e, d), $c2b45657dc5a240d$var$Ch(b, a, e));
        $c2b45657dc5a240d$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c2b45657dc5a240d$var$Ri(), e = $c2b45657dc5a240d$var$Oi(a), f = $c2b45657dc5a240d$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c2b45657dc5a240d$var$Bh(a, f, e);
        null !== b && ($c2b45657dc5a240d$var$ui(b, a, e, d), $c2b45657dc5a240d$var$Ch(b, a, e));
        $c2b45657dc5a240d$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c2b45657dc5a240d$var$Ri(), d = $c2b45657dc5a240d$var$Oi(a), e = $c2b45657dc5a240d$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c2b45657dc5a240d$var$Bh(a, e, d);
        null !== b && ($c2b45657dc5a240d$var$ui(b, a, d, c), $c2b45657dc5a240d$var$Ch(b, a, d));
        null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markForceUpdateScheduled && $c2b45657dc5a240d$var$B.markForceUpdateScheduled(a, d);
    }
};
function $c2b45657dc5a240d$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c2b45657dc5a240d$var$We(c, d) || !$c2b45657dc5a240d$var$We(e, f) : !0;
}
function $c2b45657dc5a240d$var$ij(a, b, c) {
    var d = !1, e = $c2b45657dc5a240d$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c2b45657dc5a240d$var$sh(f) : (e = $c2b45657dc5a240d$var$mg(b) ? $c2b45657dc5a240d$var$kg : $c2b45657dc5a240d$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c2b45657dc5a240d$var$lg(a, e) : $c2b45657dc5a240d$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c2b45657dc5a240d$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c2b45657dc5a240d$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c2b45657dc5a240d$var$gj.enqueueReplaceState(b, b.state, null);
}
function $c2b45657dc5a240d$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c2b45657dc5a240d$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c2b45657dc5a240d$var$sh(f) : (f = $c2b45657dc5a240d$var$mg(b) ? $c2b45657dc5a240d$var$kg : $c2b45657dc5a240d$var$I.current, e.context = $c2b45657dc5a240d$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c2b45657dc5a240d$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c2b45657dc5a240d$var$gj.enqueueReplaceState(e, e.state, null), $c2b45657dc5a240d$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c2b45657dc5a240d$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $c2b45657dc5a240d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c2b45657dc5a240d$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c2b45657dc5a240d$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c2b45657dc5a240d$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $c2b45657dc5a240d$var$pj(a, b, c) {
    c = $c2b45657dc5a240d$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c2b45657dc5a240d$var$qj || ($c2b45657dc5a240d$var$qj = !0, $c2b45657dc5a240d$var$rj = d);
        $c2b45657dc5a240d$var$nj(a, b);
    };
    return c;
}
function $c2b45657dc5a240d$var$sj(a, b, c) {
    c = $c2b45657dc5a240d$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c2b45657dc5a240d$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c2b45657dc5a240d$var$nj(a, b);
        "function" !== typeof d && (null === $c2b45657dc5a240d$var$tj ? $c2b45657dc5a240d$var$tj = new Set([
            this
        ]) : $c2b45657dc5a240d$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c2b45657dc5a240d$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c2b45657dc5a240d$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $c2b45657dc5a240d$var$vj.bind(null, a, b, c), $c2b45657dc5a240d$var$mc && $c2b45657dc5a240d$var$wj(a, c), b.then(d, d));
}
function $c2b45657dc5a240d$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c2b45657dc5a240d$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c2b45657dc5a240d$var$Ah(-1, 1), b.tag = 2, $c2b45657dc5a240d$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c2b45657dc5a240d$var$zj = $c2b45657dc5a240d$var$va.ReactCurrentOwner, $c2b45657dc5a240d$var$rh = !1;
function $c2b45657dc5a240d$var$Aj(a, b, c, d) {
    b.child = null === a ? $c2b45657dc5a240d$var$ih(b, null, c, d) : $c2b45657dc5a240d$var$hh(b, a.child, c, d);
}
function $c2b45657dc5a240d$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c2b45657dc5a240d$var$qh(b, e);
    $c2b45657dc5a240d$var$sc(b);
    d = $c2b45657dc5a240d$var$ai(a, b, c, d, f, e);
    c = $c2b45657dc5a240d$var$fi();
    $c2b45657dc5a240d$var$tc();
    if (null !== a && !$c2b45657dc5a240d$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c2b45657dc5a240d$var$Cj(a, b, e);
    $c2b45657dc5a240d$var$J && c && $c2b45657dc5a240d$var$Jg(b);
    b.flags |= 1;
    $c2b45657dc5a240d$var$Aj(a, b, d, e);
    return b.child;
}
function $c2b45657dc5a240d$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c2b45657dc5a240d$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c2b45657dc5a240d$var$Fj(a, b, f, d, e);
        a = $c2b45657dc5a240d$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c2b45657dc5a240d$var$We;
        if (c(g, d) && a.ref === b.ref) return $c2b45657dc5a240d$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $c2b45657dc5a240d$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c2b45657dc5a240d$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c2b45657dc5a240d$var$We(f, d) && a.ref === b.ref) {
            if ($c2b45657dc5a240d$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c2b45657dc5a240d$var$rh = !0);
            else return b.lanes = a.lanes, $c2b45657dc5a240d$var$Cj(a, b, e);
        }
    }
    return $c2b45657dc5a240d$var$Gj(a, b, c, d, e);
}
function $c2b45657dc5a240d$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ij, $c2b45657dc5a240d$var$Jj), $c2b45657dc5a240d$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ij, $c2b45657dc5a240d$var$Jj), $c2b45657dc5a240d$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ij, $c2b45657dc5a240d$var$Jj);
            $c2b45657dc5a240d$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$Ij, $c2b45657dc5a240d$var$Jj), $c2b45657dc5a240d$var$Jj |= d;
    $c2b45657dc5a240d$var$Aj(a, b, e, c);
    return b.child;
}
function $c2b45657dc5a240d$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c2b45657dc5a240d$var$Gj(a, b, c, d, e) {
    var f = $c2b45657dc5a240d$var$mg(c) ? $c2b45657dc5a240d$var$kg : $c2b45657dc5a240d$var$I.current;
    f = $c2b45657dc5a240d$var$lg(b, f);
    $c2b45657dc5a240d$var$qh(b, e);
    $c2b45657dc5a240d$var$sc(b);
    c = $c2b45657dc5a240d$var$ai(a, b, c, d, f, e);
    d = $c2b45657dc5a240d$var$fi();
    $c2b45657dc5a240d$var$tc();
    if (null !== a && !$c2b45657dc5a240d$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c2b45657dc5a240d$var$Cj(a, b, e);
    $c2b45657dc5a240d$var$J && d && $c2b45657dc5a240d$var$Jg(b);
    b.flags |= 1;
    $c2b45657dc5a240d$var$Aj(a, b, c, e);
    return b.child;
}
function $c2b45657dc5a240d$var$Lj(a, b, c, d, e) {
    if ($c2b45657dc5a240d$var$mg(c)) {
        var f = !0;
        $c2b45657dc5a240d$var$qg(b);
    } else f = !1;
    $c2b45657dc5a240d$var$qh(b, e);
    if (null === b.stateNode) $c2b45657dc5a240d$var$Mj(a, b), $c2b45657dc5a240d$var$ij(b, c, d), $c2b45657dc5a240d$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c2b45657dc5a240d$var$sh(l) : (l = $c2b45657dc5a240d$var$mg(c) ? $c2b45657dc5a240d$var$kg : $c2b45657dc5a240d$var$I.current, l = $c2b45657dc5a240d$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c2b45657dc5a240d$var$jj(b, g, d, l);
        $c2b45657dc5a240d$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c2b45657dc5a240d$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c2b45657dc5a240d$var$jg.current || $c2b45657dc5a240d$var$xh ? ("function" === typeof n && ($c2b45657dc5a240d$var$fj(b, c, n, d), k = b.memoizedState), (h = $c2b45657dc5a240d$var$xh || $c2b45657dc5a240d$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c2b45657dc5a240d$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c2b45657dc5a240d$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c2b45657dc5a240d$var$sh(k) : (k = $c2b45657dc5a240d$var$mg(c) ? $c2b45657dc5a240d$var$kg : $c2b45657dc5a240d$var$I.current, k = $c2b45657dc5a240d$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c2b45657dc5a240d$var$jj(b, g, d, k);
        $c2b45657dc5a240d$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $c2b45657dc5a240d$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $c2b45657dc5a240d$var$jg.current || $c2b45657dc5a240d$var$xh ? ("function" === typeof z && ($c2b45657dc5a240d$var$fj(b, c, z, d), m = b.memoizedState), (l = $c2b45657dc5a240d$var$xh || $c2b45657dc5a240d$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c2b45657dc5a240d$var$Nj(a, b, c, d, f, e);
}
function $c2b45657dc5a240d$var$Nj(a, b, c, d, e, f) {
    $c2b45657dc5a240d$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c2b45657dc5a240d$var$rg(b, c, !1), $c2b45657dc5a240d$var$Cj(a, b, f);
    d = b.stateNode;
    $c2b45657dc5a240d$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $c2b45657dc5a240d$var$Wi = -1;
    } else $c2b45657dc5a240d$var$sc(b), h = d.render(), $c2b45657dc5a240d$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $c2b45657dc5a240d$var$hh(b, a.child, null, f), b.child = $c2b45657dc5a240d$var$hh(b, null, g, f)) : $c2b45657dc5a240d$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $c2b45657dc5a240d$var$rg(b, c, !0);
    return b.child;
}
function $c2b45657dc5a240d$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c2b45657dc5a240d$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c2b45657dc5a240d$var$og(a, b.context, !1);
    $c2b45657dc5a240d$var$Mh(a, b.containerInfo);
}
function $c2b45657dc5a240d$var$Rj(a, b, c, d, e) {
    $c2b45657dc5a240d$var$Wg();
    $c2b45657dc5a240d$var$Xg(e);
    b.flags |= 256;
    $c2b45657dc5a240d$var$Aj(a, b, c, d);
    return b.child;
}
var $c2b45657dc5a240d$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c2b45657dc5a240d$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c2b45657dc5a240d$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $c2b45657dc5a240d$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, e & 1);
    if (null === a) {
        $c2b45657dc5a240d$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $c2b45657dc5a240d$var$Vj(g, d, 0, null), a = $c2b45657dc5a240d$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c2b45657dc5a240d$var$Tj(c), b.memoizedState = $c2b45657dc5a240d$var$Sj, a) : $c2b45657dc5a240d$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c2b45657dc5a240d$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $c2b45657dc5a240d$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c2b45657dc5a240d$var$ch(h, f) : (f = $c2b45657dc5a240d$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c2b45657dc5a240d$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c2b45657dc5a240d$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c2b45657dc5a240d$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c2b45657dc5a240d$var$Wj(a, b) {
    b = $c2b45657dc5a240d$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c2b45657dc5a240d$var$Yj(a, b, c, d) {
    null !== d && $c2b45657dc5a240d$var$Xg(d);
    $c2b45657dc5a240d$var$hh(b, a.child, null, c);
    a = $c2b45657dc5a240d$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c2b45657dc5a240d$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c2b45657dc5a240d$var$mj(Error($c2b45657dc5a240d$var$p(422))), $c2b45657dc5a240d$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c2b45657dc5a240d$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c2b45657dc5a240d$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c2b45657dc5a240d$var$hh(b, a.child, null, g);
        b.child.memoizedState = $c2b45657dc5a240d$var$Tj(g);
        b.memoizedState = $c2b45657dc5a240d$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c2b45657dc5a240d$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c2b45657dc5a240d$var$p(419));
        d = $c2b45657dc5a240d$var$mj(f, d, void 0);
        return $c2b45657dc5a240d$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c2b45657dc5a240d$var$rh || h) {
        d = $c2b45657dc5a240d$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c2b45657dc5a240d$var$wh(a, e), $c2b45657dc5a240d$var$ui(d, a, e, -1));
        }
        $c2b45657dc5a240d$var$Zj();
        d = $c2b45657dc5a240d$var$mj(Error($c2b45657dc5a240d$var$p(421)));
        return $c2b45657dc5a240d$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c2b45657dc5a240d$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c2b45657dc5a240d$var$Mg = $c2b45657dc5a240d$var$Zf(e.nextSibling);
    $c2b45657dc5a240d$var$Lg = b;
    $c2b45657dc5a240d$var$J = !0;
    $c2b45657dc5a240d$var$Ng = null;
    null !== a && ($c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg++] = $c2b45657dc5a240d$var$Fg, $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg++] = $c2b45657dc5a240d$var$Gg, $c2b45657dc5a240d$var$Cg[$c2b45657dc5a240d$var$Dg++] = $c2b45657dc5a240d$var$Eg, $c2b45657dc5a240d$var$Fg = a.id, $c2b45657dc5a240d$var$Gg = a.overflow, $c2b45657dc5a240d$var$Eg = b);
    b = $c2b45657dc5a240d$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c2b45657dc5a240d$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c2b45657dc5a240d$var$ph(a.return, b, c);
}
function $c2b45657dc5a240d$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c2b45657dc5a240d$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c2b45657dc5a240d$var$Aj(a, b, d.children, c);
    d = $c2b45657dc5a240d$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c2b45657dc5a240d$var$bk(a, c, b);
            else if (19 === a.tag) $c2b45657dc5a240d$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c2b45657dc5a240d$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c2b45657dc5a240d$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c2b45657dc5a240d$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c2b45657dc5a240d$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $c2b45657dc5a240d$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c2b45657dc5a240d$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c2b45657dc5a240d$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c2b45657dc5a240d$var$Wi = -1;
    $c2b45657dc5a240d$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c2b45657dc5a240d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c2b45657dc5a240d$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c2b45657dc5a240d$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c2b45657dc5a240d$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $c2b45657dc5a240d$var$Oj(b);
            $c2b45657dc5a240d$var$Wg();
            break;
        case 5:
            $c2b45657dc5a240d$var$Oh(b);
            break;
        case 1:
            $c2b45657dc5a240d$var$mg(b.type) && $c2b45657dc5a240d$var$qg(b);
            break;
        case 4:
            $c2b45657dc5a240d$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, $c2b45657dc5a240d$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c2b45657dc5a240d$var$Uj(a, b, c);
                $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, $c2b45657dc5a240d$var$L.current & 1);
                a = $c2b45657dc5a240d$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, $c2b45657dc5a240d$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c2b45657dc5a240d$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, $c2b45657dc5a240d$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c2b45657dc5a240d$var$Hj(a, b, c);
    }
    return $c2b45657dc5a240d$var$Cj(a, b, c);
}
var $c2b45657dc5a240d$var$fk, $c2b45657dc5a240d$var$gk, $c2b45657dc5a240d$var$hk, $c2b45657dc5a240d$var$ik;
$c2b45657dc5a240d$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c2b45657dc5a240d$var$gk = function() {};
$c2b45657dc5a240d$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $c2b45657dc5a240d$var$Ya(a, e);
                d = $c2b45657dc5a240d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c2b45657dc5a240d$var$u({}, e, {
                    value: void 0
                });
                d = $c2b45657dc5a240d$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c2b45657dc5a240d$var$fb(a, e);
                d = $c2b45657dc5a240d$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c2b45657dc5a240d$var$Pf);
        }
        $c2b45657dc5a240d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c2b45657dc5a240d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c2b45657dc5a240d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c2b45657dc5a240d$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c2b45657dc5a240d$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c2b45657dc5a240d$var$jk(a, b) {
    if (!$c2b45657dc5a240d$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c2b45657dc5a240d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c2b45657dc5a240d$var$kk(a, b, c) {
    var d = b.pendingProps;
    $c2b45657dc5a240d$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c2b45657dc5a240d$var$S(b), null;
        case 1:
            return $c2b45657dc5a240d$var$mg(b.type) && $c2b45657dc5a240d$var$ng(), $c2b45657dc5a240d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c2b45657dc5a240d$var$Nh();
            $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jg);
            $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$I);
            $c2b45657dc5a240d$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c2b45657dc5a240d$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c2b45657dc5a240d$var$Ng && ($c2b45657dc5a240d$var$lk($c2b45657dc5a240d$var$Ng), $c2b45657dc5a240d$var$Ng = null));
            $c2b45657dc5a240d$var$gk(a, b);
            $c2b45657dc5a240d$var$S(b);
            return null;
        case 5:
            $c2b45657dc5a240d$var$Ph(b);
            var e = $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c2b45657dc5a240d$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c2b45657dc5a240d$var$p(166));
                    $c2b45657dc5a240d$var$S(b);
                    return null;
                }
                a = $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Ih.current);
                if ($c2b45657dc5a240d$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$c2b45657dc5a240d$var$bg] = b;
                    d[$c2b45657dc5a240d$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $c2b45657dc5a240d$var$F("cancel", d);
                            $c2b45657dc5a240d$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c2b45657dc5a240d$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c2b45657dc5a240d$var$zf.length; e++)$c2b45657dc5a240d$var$F($c2b45657dc5a240d$var$zf[e], d);
                            break;
                        case "source":
                            $c2b45657dc5a240d$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c2b45657dc5a240d$var$F("error", d);
                            $c2b45657dc5a240d$var$F("load", d);
                            break;
                        case "details":
                            $c2b45657dc5a240d$var$F("toggle", d);
                            break;
                        case "input":
                            $c2b45657dc5a240d$var$Za(d, c);
                            $c2b45657dc5a240d$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $c2b45657dc5a240d$var$F("invalid", d);
                            break;
                        case "textarea":
                            $c2b45657dc5a240d$var$gb(d, c), $c2b45657dc5a240d$var$F("invalid", d);
                    }
                    $c2b45657dc5a240d$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $c2b45657dc5a240d$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $c2b45657dc5a240d$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $c2b45657dc5a240d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c2b45657dc5a240d$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $c2b45657dc5a240d$var$Va(d);
                            $c2b45657dc5a240d$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $c2b45657dc5a240d$var$Va(d);
                            $c2b45657dc5a240d$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $c2b45657dc5a240d$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c2b45657dc5a240d$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c2b45657dc5a240d$var$bg] = b;
                    a[$c2b45657dc5a240d$var$cg] = d;
                    $c2b45657dc5a240d$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c2b45657dc5a240d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c2b45657dc5a240d$var$F("cancel", a);
                                $c2b45657dc5a240d$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c2b45657dc5a240d$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c2b45657dc5a240d$var$zf.length; e++)$c2b45657dc5a240d$var$F($c2b45657dc5a240d$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c2b45657dc5a240d$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c2b45657dc5a240d$var$F("error", a);
                                $c2b45657dc5a240d$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $c2b45657dc5a240d$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c2b45657dc5a240d$var$Za(a, d);
                                e = $c2b45657dc5a240d$var$Ya(a, d);
                                $c2b45657dc5a240d$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c2b45657dc5a240d$var$u({}, d, {
                                    value: void 0
                                });
                                $c2b45657dc5a240d$var$F("invalid", a);
                                break;
                            case "textarea":
                                $c2b45657dc5a240d$var$gb(a, d);
                                e = $c2b45657dc5a240d$var$fb(a, d);
                                $c2b45657dc5a240d$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c2b45657dc5a240d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c2b45657dc5a240d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c2b45657dc5a240d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c2b45657dc5a240d$var$ob(a, k) : "number" === typeof k && $c2b45657dc5a240d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c2b45657dc5a240d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c2b45657dc5a240d$var$F("scroll", a) : null != k && $c2b45657dc5a240d$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c2b45657dc5a240d$var$Va(a);
                                $c2b45657dc5a240d$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $c2b45657dc5a240d$var$Va(a);
                                $c2b45657dc5a240d$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c2b45657dc5a240d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c2b45657dc5a240d$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c2b45657dc5a240d$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c2b45657dc5a240d$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c2b45657dc5a240d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c2b45657dc5a240d$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c2b45657dc5a240d$var$p(166));
                a = $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Kh.current);
                $c2b45657dc5a240d$var$Lh($c2b45657dc5a240d$var$Ih.current);
                if ($c2b45657dc5a240d$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$c2b45657dc5a240d$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $c2b45657dc5a240d$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $c2b45657dc5a240d$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $c2b45657dc5a240d$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$c2b45657dc5a240d$var$bg] = b, b.stateNode = d;
            }
            $c2b45657dc5a240d$var$S(b);
            return null;
        case 13:
            $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c2b45657dc5a240d$var$J && null !== $c2b45657dc5a240d$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c2b45657dc5a240d$var$Vg(), $c2b45657dc5a240d$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $c2b45657dc5a240d$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c2b45657dc5a240d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c2b45657dc5a240d$var$p(317));
                        f[$c2b45657dc5a240d$var$bg] = b;
                        $c2b45657dc5a240d$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $c2b45657dc5a240d$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $c2b45657dc5a240d$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $c2b45657dc5a240d$var$Ng && ($c2b45657dc5a240d$var$lk($c2b45657dc5a240d$var$Ng), $c2b45657dc5a240d$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $c2b45657dc5a240d$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c2b45657dc5a240d$var$L.current & 1) ? 0 === $c2b45657dc5a240d$var$T && ($c2b45657dc5a240d$var$T = 3) : $c2b45657dc5a240d$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c2b45657dc5a240d$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $c2b45657dc5a240d$var$Nh(), $c2b45657dc5a240d$var$gk(a, b), null === a && $c2b45657dc5a240d$var$Gf(b.stateNode.containerInfo), $c2b45657dc5a240d$var$S(b), null;
        case 10:
            return $c2b45657dc5a240d$var$oh(b.type._context), $c2b45657dc5a240d$var$S(b), null;
        case 17:
            return $c2b45657dc5a240d$var$mg(b.type) && $c2b45657dc5a240d$var$ng(), $c2b45657dc5a240d$var$S(b), null;
        case 19:
            $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$L);
            f = b.memoizedState;
            if (null === f) return $c2b45657dc5a240d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c2b45657dc5a240d$var$jk(f, !1);
                else {
                    if (0 !== $c2b45657dc5a240d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c2b45657dc5a240d$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c2b45657dc5a240d$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, $c2b45657dc5a240d$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c2b45657dc5a240d$var$A() > $c2b45657dc5a240d$var$mk && (b.flags |= 128, d = !0, $c2b45657dc5a240d$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c2b45657dc5a240d$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $c2b45657dc5a240d$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c2b45657dc5a240d$var$J) return $c2b45657dc5a240d$var$S(b), null;
                    } else 2 * $c2b45657dc5a240d$var$A() - f.renderingStartTime > $c2b45657dc5a240d$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $c2b45657dc5a240d$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c2b45657dc5a240d$var$A(), b.sibling = null, a = $c2b45657dc5a240d$var$L.current, $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$L, d ? a & 1 | 2 : a & 1), b;
            $c2b45657dc5a240d$var$S(b);
            return null;
        case 22:
        case 23:
            return $c2b45657dc5a240d$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c2b45657dc5a240d$var$Jj & 1073741824) && ($c2b45657dc5a240d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c2b45657dc5a240d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c2b45657dc5a240d$var$p(156, b.tag));
}
function $c2b45657dc5a240d$var$ok(a, b) {
    $c2b45657dc5a240d$var$Kg(b);
    switch(b.tag){
        case 1:
            return $c2b45657dc5a240d$var$mg(b.type) && $c2b45657dc5a240d$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $c2b45657dc5a240d$var$dj(b), b) : null;
        case 3:
            return $c2b45657dc5a240d$var$Nh(), $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jg), $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$I), $c2b45657dc5a240d$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c2b45657dc5a240d$var$Ph(b), null;
        case 13:
            $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c2b45657dc5a240d$var$p(340));
                $c2b45657dc5a240d$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $c2b45657dc5a240d$var$dj(b), b) : null;
        case 19:
            return $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$L), null;
        case 4:
            return $c2b45657dc5a240d$var$Nh(), null;
        case 10:
            return $c2b45657dc5a240d$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $c2b45657dc5a240d$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c2b45657dc5a240d$var$pk = !1, $c2b45657dc5a240d$var$qk = !1, $c2b45657dc5a240d$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $c2b45657dc5a240d$var$U = null, $c2b45657dc5a240d$var$sk = null, $c2b45657dc5a240d$var$tk = null;
function $c2b45657dc5a240d$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $c2b45657dc5a240d$var$cj(), b.componentWillUnmount();
    } finally{
        $c2b45657dc5a240d$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $c2b45657dc5a240d$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $c2b45657dc5a240d$var$cj(), c(null);
            } finally{
                $c2b45657dc5a240d$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $c2b45657dc5a240d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c2b45657dc5a240d$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $c2b45657dc5a240d$var$W(a, b, d);
    }
}
var $c2b45657dc5a240d$var$xk = !1;
function $c2b45657dc5a240d$var$yk(a, b) {
    $c2b45657dc5a240d$var$Qf = $c2b45657dc5a240d$var$rd;
    a = $c2b45657dc5a240d$var$$e();
    if ($c2b45657dc5a240d$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c2b45657dc5a240d$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $c2b45657dc5a240d$var$rd = !1;
    for($c2b45657dc5a240d$var$U = b; null !== $c2b45657dc5a240d$var$U;)if (b = $c2b45657dc5a240d$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c2b45657dc5a240d$var$U = a;
    else for(; null !== $c2b45657dc5a240d$var$U;){
        b = $c2b45657dc5a240d$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $c2b45657dc5a240d$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c2b45657dc5a240d$var$p(163));
            }
        } catch (D) {
            $c2b45657dc5a240d$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c2b45657dc5a240d$var$U = a;
            break;
        }
        $c2b45657dc5a240d$var$U = b.return;
    }
    m = $c2b45657dc5a240d$var$xk;
    $c2b45657dc5a240d$var$xk = !1;
    return m;
}
function $c2b45657dc5a240d$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentPassiveEffectUnmountStarted && $c2b45657dc5a240d$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $c2b45657dc5a240d$var$uc(b), $c2b45657dc5a240d$var$wk(b, c, f), 0 !== (a & 8) ? null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentPassiveEffectUnmountStopped && $c2b45657dc5a240d$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $c2b45657dc5a240d$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c2b45657dc5a240d$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentPassiveEffectMountStarted && $c2b45657dc5a240d$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentLayoutEffectMountStarted && $c2b45657dc5a240d$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentPassiveEffectMountStopped && $c2b45657dc5a240d$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentLayoutEffectMountStopped && $c2b45657dc5a240d$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $c2b45657dc5a240d$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $c2b45657dc5a240d$var$cj(), b(c);
            } finally{
                $c2b45657dc5a240d$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $c2b45657dc5a240d$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c2b45657dc5a240d$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c2b45657dc5a240d$var$bg], delete b[$c2b45657dc5a240d$var$cg], delete b[$c2b45657dc5a240d$var$Cf], delete b[$c2b45657dc5a240d$var$dg], delete b[$c2b45657dc5a240d$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c2b45657dc5a240d$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c2b45657dc5a240d$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c2b45657dc5a240d$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c2b45657dc5a240d$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c2b45657dc5a240d$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($c2b45657dc5a240d$var$Fk(a, b, c), a = a.sibling; null !== a;)$c2b45657dc5a240d$var$Fk(a, b, c), a = a.sibling;
}
function $c2b45657dc5a240d$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c2b45657dc5a240d$var$Gk(a, b, c), a = a.sibling; null !== a;)$c2b45657dc5a240d$var$Gk(a, b, c), a = a.sibling;
}
var $c2b45657dc5a240d$var$X = null, $c2b45657dc5a240d$var$Hk = !1;
function $c2b45657dc5a240d$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$c2b45657dc5a240d$var$Jk(a, b, c), c = c.sibling;
}
function $c2b45657dc5a240d$var$Jk(a, b, c) {
    if ($c2b45657dc5a240d$var$lc && "function" === typeof $c2b45657dc5a240d$var$lc.onCommitFiberUnmount) try {
        $c2b45657dc5a240d$var$lc.onCommitFiberUnmount($c2b45657dc5a240d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c2b45657dc5a240d$var$qk || $c2b45657dc5a240d$var$vk(c, b);
        case 6:
            var d = $c2b45657dc5a240d$var$X, e = $c2b45657dc5a240d$var$Hk;
            $c2b45657dc5a240d$var$X = null;
            $c2b45657dc5a240d$var$Ik(a, b, c);
            $c2b45657dc5a240d$var$X = d;
            $c2b45657dc5a240d$var$Hk = e;
            null !== $c2b45657dc5a240d$var$X && ($c2b45657dc5a240d$var$Hk ? (a = $c2b45657dc5a240d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c2b45657dc5a240d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c2b45657dc5a240d$var$X && ($c2b45657dc5a240d$var$Hk ? (a = $c2b45657dc5a240d$var$X, c = c.stateNode, 8 === a.nodeType ? $c2b45657dc5a240d$var$Yf(a.parentNode, c) : 1 === a.nodeType && $c2b45657dc5a240d$var$Yf(a, c), $c2b45657dc5a240d$var$pd(a)) : $c2b45657dc5a240d$var$Yf($c2b45657dc5a240d$var$X, c.stateNode));
            break;
        case 4:
            d = $c2b45657dc5a240d$var$X;
            e = $c2b45657dc5a240d$var$Hk;
            $c2b45657dc5a240d$var$X = c.stateNode.containerInfo;
            $c2b45657dc5a240d$var$Hk = !0;
            $c2b45657dc5a240d$var$Ik(a, b, c);
            $c2b45657dc5a240d$var$X = d;
            $c2b45657dc5a240d$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c2b45657dc5a240d$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c2b45657dc5a240d$var$wk(c, b, g) : 0 !== (f & 4) && ($c2b45657dc5a240d$var$uc(c), c.mode & 2 ? ($c2b45657dc5a240d$var$cj(), $c2b45657dc5a240d$var$wk(c, b, g), $c2b45657dc5a240d$var$aj(c)) : $c2b45657dc5a240d$var$wk(c, b, g), $c2b45657dc5a240d$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $c2b45657dc5a240d$var$Ik(a, b, c);
            break;
        case 1:
            if (!$c2b45657dc5a240d$var$qk && ($c2b45657dc5a240d$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $c2b45657dc5a240d$var$uk(c, d);
            } catch (h) {
                $c2b45657dc5a240d$var$W(c, b, h);
            }
            $c2b45657dc5a240d$var$Ik(a, b, c);
            break;
        case 21:
            $c2b45657dc5a240d$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c2b45657dc5a240d$var$qk = (d = $c2b45657dc5a240d$var$qk) || null !== c.memoizedState, $c2b45657dc5a240d$var$Ik(a, b, c), $c2b45657dc5a240d$var$qk = d) : $c2b45657dc5a240d$var$Ik(a, b, c);
            break;
        default:
            $c2b45657dc5a240d$var$Ik(a, b, c);
    }
}
function $c2b45657dc5a240d$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c2b45657dc5a240d$var$rk);
        b.forEach(function(b) {
            var d = $c2b45657dc5a240d$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($c2b45657dc5a240d$var$mc) {
                    if (null !== $c2b45657dc5a240d$var$sk && null !== $c2b45657dc5a240d$var$tk) $c2b45657dc5a240d$var$wj($c2b45657dc5a240d$var$tk, $c2b45657dc5a240d$var$sk);
                    else throw Error($c2b45657dc5a240d$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $c2b45657dc5a240d$var$Mk(a, b, c) {
    $c2b45657dc5a240d$var$sk = c;
    $c2b45657dc5a240d$var$tk = a;
    $c2b45657dc5a240d$var$Nk(b, a);
    $c2b45657dc5a240d$var$tk = $c2b45657dc5a240d$var$sk = null;
}
function $c2b45657dc5a240d$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c2b45657dc5a240d$var$X = h.stateNode;
                        $c2b45657dc5a240d$var$Hk = !1;
                        break a;
                    case 3:
                        $c2b45657dc5a240d$var$X = h.stateNode.containerInfo;
                        $c2b45657dc5a240d$var$Hk = !0;
                        break a;
                    case 4:
                        $c2b45657dc5a240d$var$X = h.stateNode.containerInfo;
                        $c2b45657dc5a240d$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c2b45657dc5a240d$var$X) throw Error($c2b45657dc5a240d$var$p(160));
            $c2b45657dc5a240d$var$Jk(f, g, e);
            $c2b45657dc5a240d$var$X = null;
            $c2b45657dc5a240d$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c2b45657dc5a240d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c2b45657dc5a240d$var$Nk(b, a), b = b.sibling;
}
function $c2b45657dc5a240d$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            if (d & 4) {
                try {
                    $c2b45657dc5a240d$var$zk(3, a, a.return), $c2b45657dc5a240d$var$Ak(3, a);
                } catch (m) {
                    $c2b45657dc5a240d$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $c2b45657dc5a240d$var$cj(), $c2b45657dc5a240d$var$zk(5, a, a.return);
                    } catch (m) {
                        $c2b45657dc5a240d$var$W(a, a.return, m);
                    }
                    $c2b45657dc5a240d$var$aj(a);
                } else try {
                    $c2b45657dc5a240d$var$zk(5, a, a.return);
                } catch (m) {
                    $c2b45657dc5a240d$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            d & 512 && null !== c && $c2b45657dc5a240d$var$vk(c, c.return);
            break;
        case 5:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            d & 512 && null !== c && $c2b45657dc5a240d$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c2b45657dc5a240d$var$ob(e, "");
                } catch (m) {
                    $c2b45657dc5a240d$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c2b45657dc5a240d$var$$a(e, f);
                    $c2b45657dc5a240d$var$vb(h, g);
                    var l = $c2b45657dc5a240d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $c2b45657dc5a240d$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $c2b45657dc5a240d$var$nb(e, q) : "children" === n ? $c2b45657dc5a240d$var$ob(e, q) : $c2b45657dc5a240d$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $c2b45657dc5a240d$var$ab(e, f);
                            break;
                        case "textarea":
                            $c2b45657dc5a240d$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $c2b45657dc5a240d$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c2b45657dc5a240d$var$eb(e, !!f.multiple, f.defaultValue, !0) : $c2b45657dc5a240d$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c2b45657dc5a240d$var$cg] = f;
                } catch (m) {
                    $c2b45657dc5a240d$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c2b45657dc5a240d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $c2b45657dc5a240d$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c2b45657dc5a240d$var$pd(b.containerInfo);
            } catch (m) {
                $c2b45657dc5a240d$var$W(a, a.return, m);
            }
            break;
        case 4:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            break;
        case 13:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c2b45657dc5a240d$var$Qk = $c2b45657dc5a240d$var$A()));
            d & 4 && $c2b45657dc5a240d$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c2b45657dc5a240d$var$qk = (l = $c2b45657dc5a240d$var$qk) || n, $c2b45657dc5a240d$var$Ok(b, a), $c2b45657dc5a240d$var$qk = l) : $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($c2b45657dc5a240d$var$U = a, n = a.child; null !== n;){
                    for(q = $c2b45657dc5a240d$var$U = n; null !== $c2b45657dc5a240d$var$U;){
                        r = $c2b45657dc5a240d$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $c2b45657dc5a240d$var$cj(), $c2b45657dc5a240d$var$zk(4, r, r.return);
                                } finally{
                                    $c2b45657dc5a240d$var$aj(r);
                                }
                                else $c2b45657dc5a240d$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $c2b45657dc5a240d$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $c2b45657dc5a240d$var$uk(c, d);
                                    } catch (m) {
                                        $c2b45657dc5a240d$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $c2b45657dc5a240d$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c2b45657dc5a240d$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $c2b45657dc5a240d$var$U = z) : $c2b45657dc5a240d$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c2b45657dc5a240d$var$rb("display", g));
                            } catch (m) {
                                $c2b45657dc5a240d$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $c2b45657dc5a240d$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c2b45657dc5a240d$var$Ok(b, a);
            $c2b45657dc5a240d$var$Pk(a);
            d & 4 && $c2b45657dc5a240d$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $c2b45657dc5a240d$var$Ok(b, a), $c2b45657dc5a240d$var$Pk(a);
    }
}
function $c2b45657dc5a240d$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c2b45657dc5a240d$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c2b45657dc5a240d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c2b45657dc5a240d$var$ob(e, ""), d.flags &= -33);
                    var f = $c2b45657dc5a240d$var$Ek(a);
                    $c2b45657dc5a240d$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c2b45657dc5a240d$var$Ek(a);
                    $c2b45657dc5a240d$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($c2b45657dc5a240d$var$p(161));
            }
        } catch (k) {
            $c2b45657dc5a240d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c2b45657dc5a240d$var$Sk(a, b, c) {
    $c2b45657dc5a240d$var$sk = c;
    $c2b45657dc5a240d$var$tk = b;
    $c2b45657dc5a240d$var$U = a;
    $c2b45657dc5a240d$var$Tk(a, b, c);
    $c2b45657dc5a240d$var$tk = $c2b45657dc5a240d$var$sk = null;
}
function $c2b45657dc5a240d$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c2b45657dc5a240d$var$U;){
        var e = $c2b45657dc5a240d$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c2b45657dc5a240d$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c2b45657dc5a240d$var$qk;
                h = $c2b45657dc5a240d$var$pk;
                var l = $c2b45657dc5a240d$var$qk;
                $c2b45657dc5a240d$var$pk = g;
                if (($c2b45657dc5a240d$var$qk = k) && !l) for($c2b45657dc5a240d$var$U = e; null !== $c2b45657dc5a240d$var$U;)g = $c2b45657dc5a240d$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c2b45657dc5a240d$var$Uk(e) : null !== k ? (k.return = g, $c2b45657dc5a240d$var$U = k) : $c2b45657dc5a240d$var$Uk(e);
                for(; null !== f;)$c2b45657dc5a240d$var$U = f, $c2b45657dc5a240d$var$Tk(f, b, c), f = f.sibling;
                $c2b45657dc5a240d$var$U = e;
                $c2b45657dc5a240d$var$pk = h;
                $c2b45657dc5a240d$var$qk = l;
            }
            $c2b45657dc5a240d$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c2b45657dc5a240d$var$U = f) : $c2b45657dc5a240d$var$Vk(a, b, c);
    }
}
function $c2b45657dc5a240d$var$Vk(a) {
    for(; null !== $c2b45657dc5a240d$var$U;){
        var b = $c2b45657dc5a240d$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$c2b45657dc5a240d$var$qk) {
                            if (b.mode & 2) try {
                                $c2b45657dc5a240d$var$cj(), $c2b45657dc5a240d$var$Ak(5, b);
                            } finally{
                                $c2b45657dc5a240d$var$aj(b);
                            }
                            else $c2b45657dc5a240d$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c2b45657dc5a240d$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $c2b45657dc5a240d$var$cj(), d.componentDidMount();
                                } finally{
                                    $c2b45657dc5a240d$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c2b45657dc5a240d$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $c2b45657dc5a240d$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $c2b45657dc5a240d$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $c2b45657dc5a240d$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $c2b45657dc5a240d$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $c2b45657dc5a240d$var$Ui;
                        c = null === c ? "mount" : "update";
                        $c2b45657dc5a240d$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $c2b45657dc5a240d$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $c2b45657dc5a240d$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c2b45657dc5a240d$var$p(163));
                }
                $c2b45657dc5a240d$var$qk || b.flags & 512 && $c2b45657dc5a240d$var$Bk(b);
            } catch (v) {
                $c2b45657dc5a240d$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $c2b45657dc5a240d$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $c2b45657dc5a240d$var$U = k;
            break;
        }
        $c2b45657dc5a240d$var$U = b.return;
    }
}
function $c2b45657dc5a240d$var$Rk(a) {
    for(; null !== $c2b45657dc5a240d$var$U;){
        var b = $c2b45657dc5a240d$var$U;
        if (b === a) {
            $c2b45657dc5a240d$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c2b45657dc5a240d$var$U = c;
            break;
        }
        $c2b45657dc5a240d$var$U = b.return;
    }
}
function $c2b45657dc5a240d$var$Uk(a) {
    for(; null !== $c2b45657dc5a240d$var$U;){
        var b = $c2b45657dc5a240d$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $c2b45657dc5a240d$var$cj();
                        var c = b.return;
                        try {
                            $c2b45657dc5a240d$var$Ak(4, b);
                        } catch (l) {
                            $c2b45657dc5a240d$var$W(b, c, l);
                        }
                    } finally{
                        $c2b45657dc5a240d$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $c2b45657dc5a240d$var$Ak(4, b);
                        } catch (l) {
                            $c2b45657dc5a240d$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $c2b45657dc5a240d$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $c2b45657dc5a240d$var$Bk(b);
                    } catch (l) {
                        $c2b45657dc5a240d$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $c2b45657dc5a240d$var$Bk(b);
                    } catch (l) {
                        $c2b45657dc5a240d$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $c2b45657dc5a240d$var$W(b, b.return, l);
        }
        if (b === a) {
            $c2b45657dc5a240d$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $c2b45657dc5a240d$var$U = k;
            break;
        }
        $c2b45657dc5a240d$var$U = b.return;
    }
}
var $c2b45657dc5a240d$var$Xk = Math.ceil, $c2b45657dc5a240d$var$Yk = $c2b45657dc5a240d$var$va.ReactCurrentDispatcher, $c2b45657dc5a240d$var$Zk = $c2b45657dc5a240d$var$va.ReactCurrentOwner, $c2b45657dc5a240d$var$$k = $c2b45657dc5a240d$var$va.ReactCurrentBatchConfig, $c2b45657dc5a240d$var$K = 0, $c2b45657dc5a240d$var$Q = null, $c2b45657dc5a240d$var$Y = null, $c2b45657dc5a240d$var$Z = 0, $c2b45657dc5a240d$var$Jj = 0, $c2b45657dc5a240d$var$Ij = $c2b45657dc5a240d$var$hg(0), $c2b45657dc5a240d$var$T = 0, $c2b45657dc5a240d$var$al = null, $c2b45657dc5a240d$var$Fh = 0, $c2b45657dc5a240d$var$bl = 0, $c2b45657dc5a240d$var$cl = 0, $c2b45657dc5a240d$var$dl = null, $c2b45657dc5a240d$var$el = null, $c2b45657dc5a240d$var$Qk = 0, $c2b45657dc5a240d$var$mk = Infinity, $c2b45657dc5a240d$var$fl = null, $c2b45657dc5a240d$var$qj = !1, $c2b45657dc5a240d$var$rj = null, $c2b45657dc5a240d$var$tj = null, $c2b45657dc5a240d$var$gl = !1, $c2b45657dc5a240d$var$hl = null, $c2b45657dc5a240d$var$il = 0, $c2b45657dc5a240d$var$jl = [], $c2b45657dc5a240d$var$kl = 0, $c2b45657dc5a240d$var$ll = null, $c2b45657dc5a240d$var$ml = -1, $c2b45657dc5a240d$var$nl = 0;
function $c2b45657dc5a240d$var$Ri() {
    return 0 !== ($c2b45657dc5a240d$var$K & 6) ? $c2b45657dc5a240d$var$A() : -1 !== $c2b45657dc5a240d$var$ml ? $c2b45657dc5a240d$var$ml : $c2b45657dc5a240d$var$ml = $c2b45657dc5a240d$var$A();
}
function $c2b45657dc5a240d$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c2b45657dc5a240d$var$K & 2) && 0 !== $c2b45657dc5a240d$var$Z) return $c2b45657dc5a240d$var$Z & -$c2b45657dc5a240d$var$Z;
    if (null !== $c2b45657dc5a240d$var$Yg.transition) return 0 === $c2b45657dc5a240d$var$nl && ($c2b45657dc5a240d$var$nl = $c2b45657dc5a240d$var$Kc()), $c2b45657dc5a240d$var$nl;
    a = $c2b45657dc5a240d$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c2b45657dc5a240d$var$xd(a.type);
    return a;
}
function $c2b45657dc5a240d$var$ui(a, b, c, d) {
    if (50 < $c2b45657dc5a240d$var$kl) throw $c2b45657dc5a240d$var$kl = 0, $c2b45657dc5a240d$var$ll = null, Error($c2b45657dc5a240d$var$p(185));
    $c2b45657dc5a240d$var$Mc(a, c, d);
    if (0 === ($c2b45657dc5a240d$var$K & 2) || a !== $c2b45657dc5a240d$var$Q) $c2b45657dc5a240d$var$mc && $c2b45657dc5a240d$var$Pc(a, b, c), a === $c2b45657dc5a240d$var$Q && (0 === ($c2b45657dc5a240d$var$K & 2) && ($c2b45657dc5a240d$var$bl |= c), 4 === $c2b45657dc5a240d$var$T && $c2b45657dc5a240d$var$ol(a, $c2b45657dc5a240d$var$Z)), $c2b45657dc5a240d$var$pl(a, d), 1 === c && 0 === $c2b45657dc5a240d$var$K && 0 === (b.mode & 1) && ($c2b45657dc5a240d$var$mk = $c2b45657dc5a240d$var$A() + 500, $c2b45657dc5a240d$var$tg && $c2b45657dc5a240d$var$xg());
}
function $c2b45657dc5a240d$var$pl(a, b) {
    var c = a.callbackNode;
    $c2b45657dc5a240d$var$Ic(a, b);
    var d = $c2b45657dc5a240d$var$Gc(a, a === $c2b45657dc5a240d$var$Q ? $c2b45657dc5a240d$var$Z : 0);
    if (0 === d) null !== c && $c2b45657dc5a240d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c2b45657dc5a240d$var$bc(c);
        if (1 === b) 0 === a.tag ? $c2b45657dc5a240d$var$wg($c2b45657dc5a240d$var$ql.bind(null, a)) : $c2b45657dc5a240d$var$vg($c2b45657dc5a240d$var$ql.bind(null, a)), $c2b45657dc5a240d$var$Xf(function() {
            0 === ($c2b45657dc5a240d$var$K & 6) && $c2b45657dc5a240d$var$xg();
        }), c = null;
        else {
            switch($c2b45657dc5a240d$var$Rc(d)){
                case 1:
                    c = $c2b45657dc5a240d$var$fc;
                    break;
                case 4:
                    c = $c2b45657dc5a240d$var$gc;
                    break;
                case 16:
                    c = $c2b45657dc5a240d$var$hc;
                    break;
                case 536870912:
                    c = $c2b45657dc5a240d$var$jc;
                    break;
                default:
                    c = $c2b45657dc5a240d$var$hc;
            }
            c = $c2b45657dc5a240d$var$rl(c, $c2b45657dc5a240d$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c2b45657dc5a240d$var$sl(a, b) {
    $c2b45657dc5a240d$var$Zi = $c2b45657dc5a240d$var$Yi = !1;
    $c2b45657dc5a240d$var$ml = -1;
    $c2b45657dc5a240d$var$nl = 0;
    if (0 !== ($c2b45657dc5a240d$var$K & 6)) throw Error($c2b45657dc5a240d$var$p(327));
    var c = a.callbackNode;
    if ($c2b45657dc5a240d$var$tl() && a.callbackNode !== c) return null;
    var d = $c2b45657dc5a240d$var$Gc(a, a === $c2b45657dc5a240d$var$Q ? $c2b45657dc5a240d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c2b45657dc5a240d$var$ul(a, d);
    else {
        b = d;
        var e = $c2b45657dc5a240d$var$K;
        $c2b45657dc5a240d$var$K |= 2;
        var f = $c2b45657dc5a240d$var$vl();
        if ($c2b45657dc5a240d$var$Q !== a || $c2b45657dc5a240d$var$Z !== b) {
            if ($c2b45657dc5a240d$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($c2b45657dc5a240d$var$wj(a, $c2b45657dc5a240d$var$Z), g.clear());
                $c2b45657dc5a240d$var$Qc(a, b);
            }
            $c2b45657dc5a240d$var$fl = null;
            $c2b45657dc5a240d$var$mk = $c2b45657dc5a240d$var$A() + 500;
            $c2b45657dc5a240d$var$wl(a, b);
        }
        $c2b45657dc5a240d$var$wc(b);
        for(;;)try {
            $c2b45657dc5a240d$var$xl();
            break;
        } catch (h) {
            $c2b45657dc5a240d$var$yl(a, h);
        }
        $c2b45657dc5a240d$var$nh();
        $c2b45657dc5a240d$var$Yk.current = f;
        $c2b45657dc5a240d$var$K = e;
        null !== $c2b45657dc5a240d$var$Y ? (null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markRenderYielded && $c2b45657dc5a240d$var$B.markRenderYielded(), b = 0) : ($c2b45657dc5a240d$var$xc(), $c2b45657dc5a240d$var$Q = null, $c2b45657dc5a240d$var$Z = 0, b = $c2b45657dc5a240d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c2b45657dc5a240d$var$Jc(a), 0 !== e && (d = e, b = $c2b45657dc5a240d$var$zl(a, e)));
        if (1 === b) throw c = $c2b45657dc5a240d$var$al, $c2b45657dc5a240d$var$wl(a, 0), $c2b45657dc5a240d$var$ol(a, d), $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A()), c;
        if (6 === b) $c2b45657dc5a240d$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c2b45657dc5a240d$var$Al(e) && (b = $c2b45657dc5a240d$var$ul(a, d), 2 === b && (f = $c2b45657dc5a240d$var$Jc(a), 0 !== f && (d = f, b = $c2b45657dc5a240d$var$zl(a, f))), 1 === b)) throw c = $c2b45657dc5a240d$var$al, $c2b45657dc5a240d$var$wl(a, 0), $c2b45657dc5a240d$var$ol(a, d), $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c2b45657dc5a240d$var$p(345));
                case 2:
                    $c2b45657dc5a240d$var$Cl(a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl);
                    break;
                case 3:
                    $c2b45657dc5a240d$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $c2b45657dc5a240d$var$Qk + 500 - $c2b45657dc5a240d$var$A(), 10 < b)) {
                        if (0 !== $c2b45657dc5a240d$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c2b45657dc5a240d$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c2b45657dc5a240d$var$Tf($c2b45657dc5a240d$var$Cl.bind(null, a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl), b);
                        break;
                    }
                    $c2b45657dc5a240d$var$Cl(a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl);
                    break;
                case 4:
                    $c2b45657dc5a240d$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $c2b45657dc5a240d$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $c2b45657dc5a240d$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c2b45657dc5a240d$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c2b45657dc5a240d$var$Tf($c2b45657dc5a240d$var$Cl.bind(null, a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl), d);
                        break;
                    }
                    $c2b45657dc5a240d$var$Cl(a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl);
                    break;
                case 5:
                    $c2b45657dc5a240d$var$Cl(a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl);
                    break;
                default:
                    throw Error($c2b45657dc5a240d$var$p(329));
            }
        }
    }
    $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A());
    return a.callbackNode === c ? $c2b45657dc5a240d$var$sl.bind(null, a) : null;
}
function $c2b45657dc5a240d$var$zl(a, b) {
    var c = $c2b45657dc5a240d$var$dl;
    a.current.memoizedState.isDehydrated && ($c2b45657dc5a240d$var$wl(a, b).flags |= 256);
    a = $c2b45657dc5a240d$var$ul(a, b);
    2 !== a && (b = $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$el = c, null !== b && $c2b45657dc5a240d$var$lk(b));
    return a;
}
function $c2b45657dc5a240d$var$lk(a) {
    null === $c2b45657dc5a240d$var$el ? $c2b45657dc5a240d$var$el = a : $c2b45657dc5a240d$var$el.push.apply($c2b45657dc5a240d$var$el, a);
}
function $c2b45657dc5a240d$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c2b45657dc5a240d$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c2b45657dc5a240d$var$ol(a, b) {
    b &= ~$c2b45657dc5a240d$var$cl;
    b &= ~$c2b45657dc5a240d$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c2b45657dc5a240d$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c2b45657dc5a240d$var$ql(a) {
    $c2b45657dc5a240d$var$Yi = $c2b45657dc5a240d$var$Zi;
    $c2b45657dc5a240d$var$Zi = !1;
    if (0 !== ($c2b45657dc5a240d$var$K & 6)) throw Error($c2b45657dc5a240d$var$p(327));
    $c2b45657dc5a240d$var$tl();
    var b = $c2b45657dc5a240d$var$Gc(a, 0);
    if (0 === (b & 1)) return $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A()), null;
    var c = $c2b45657dc5a240d$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c2b45657dc5a240d$var$Jc(a);
        0 !== d && (b = d, c = $c2b45657dc5a240d$var$zl(a, d));
    }
    if (1 === c) throw c = $c2b45657dc5a240d$var$al, $c2b45657dc5a240d$var$wl(a, 0), $c2b45657dc5a240d$var$ol(a, b), $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A()), c;
    if (6 === c) throw Error($c2b45657dc5a240d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c2b45657dc5a240d$var$Cl(a, $c2b45657dc5a240d$var$el, $c2b45657dc5a240d$var$fl);
    $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A());
    return null;
}
function $c2b45657dc5a240d$var$Dl(a, b) {
    var c = $c2b45657dc5a240d$var$K;
    $c2b45657dc5a240d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c2b45657dc5a240d$var$K = c, 0 === $c2b45657dc5a240d$var$K && ($c2b45657dc5a240d$var$mk = $c2b45657dc5a240d$var$A() + 500, $c2b45657dc5a240d$var$tg && $c2b45657dc5a240d$var$xg());
    }
}
function $c2b45657dc5a240d$var$El(a) {
    null !== $c2b45657dc5a240d$var$hl && 0 === $c2b45657dc5a240d$var$hl.tag && 0 === ($c2b45657dc5a240d$var$K & 6) && $c2b45657dc5a240d$var$tl();
    var b = $c2b45657dc5a240d$var$K;
    $c2b45657dc5a240d$var$K |= 1;
    var c = $c2b45657dc5a240d$var$$k.transition, d = $c2b45657dc5a240d$var$E;
    try {
        if ($c2b45657dc5a240d$var$$k.transition = null, $c2b45657dc5a240d$var$E = 1, a) return a();
    } finally{
        $c2b45657dc5a240d$var$E = d, $c2b45657dc5a240d$var$$k.transition = c, $c2b45657dc5a240d$var$K = b, 0 === ($c2b45657dc5a240d$var$K & 6) && $c2b45657dc5a240d$var$xg();
    }
}
function $c2b45657dc5a240d$var$nk() {
    $c2b45657dc5a240d$var$Jj = $c2b45657dc5a240d$var$Ij.current;
    $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$Ij);
}
function $c2b45657dc5a240d$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c2b45657dc5a240d$var$Uf(c));
    if (null !== $c2b45657dc5a240d$var$Y) for(c = $c2b45657dc5a240d$var$Y.return; null !== c;){
        var d = c;
        $c2b45657dc5a240d$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c2b45657dc5a240d$var$ng();
                break;
            case 3:
                $c2b45657dc5a240d$var$Nh();
                $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$jg);
                $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$I);
                $c2b45657dc5a240d$var$Sh();
                break;
            case 5:
                $c2b45657dc5a240d$var$Ph(d);
                break;
            case 4:
                $c2b45657dc5a240d$var$Nh();
                break;
            case 13:
                $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$L);
                break;
            case 19:
                $c2b45657dc5a240d$var$G($c2b45657dc5a240d$var$L);
                break;
            case 10:
                $c2b45657dc5a240d$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $c2b45657dc5a240d$var$nk();
        }
        c = c.return;
    }
    $c2b45657dc5a240d$var$Q = a;
    $c2b45657dc5a240d$var$Y = a = $c2b45657dc5a240d$var$ch(a.current, null);
    $c2b45657dc5a240d$var$Z = $c2b45657dc5a240d$var$Jj = b;
    $c2b45657dc5a240d$var$T = 0;
    $c2b45657dc5a240d$var$al = null;
    $c2b45657dc5a240d$var$cl = $c2b45657dc5a240d$var$bl = $c2b45657dc5a240d$var$Fh = 0;
    $c2b45657dc5a240d$var$el = $c2b45657dc5a240d$var$dl = null;
    if (null !== $c2b45657dc5a240d$var$th) {
        for(b = 0; b < $c2b45657dc5a240d$var$th.length; b++)if (c = $c2b45657dc5a240d$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c2b45657dc5a240d$var$th = null;
    }
    return a;
}
function $c2b45657dc5a240d$var$yl(a, b) {
    do {
        var c = $c2b45657dc5a240d$var$Y;
        try {
            $c2b45657dc5a240d$var$nh();
            $c2b45657dc5a240d$var$Th.current = $c2b45657dc5a240d$var$ei;
            if ($c2b45657dc5a240d$var$Wh) {
                for(var d = $c2b45657dc5a240d$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c2b45657dc5a240d$var$Wh = !1;
            }
            $c2b45657dc5a240d$var$Vh = 0;
            $c2b45657dc5a240d$var$O = $c2b45657dc5a240d$var$N = $c2b45657dc5a240d$var$M = null;
            $c2b45657dc5a240d$var$Xh = !1;
            $c2b45657dc5a240d$var$Yh = 0;
            $c2b45657dc5a240d$var$Zk.current = null;
            if (null === c || null === c.return) {
                $c2b45657dc5a240d$var$T = 1;
                $c2b45657dc5a240d$var$al = b;
                $c2b45657dc5a240d$var$Y = null;
                break;
            }
            c.mode & 2 && $c2b45657dc5a240d$var$$i(c, !0);
            $c2b45657dc5a240d$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentSuspended && $c2b45657dc5a240d$var$B.markComponentSuspended(c, f, $c2b45657dc5a240d$var$Z);
            } else null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markComponentErrored && $c2b45657dc5a240d$var$B.markComponentErrored(c, b, $c2b45657dc5a240d$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $c2b45657dc5a240d$var$Z;
                k.flags |= 32768;
                $c2b45657dc5a240d$var$mc && $c2b45657dc5a240d$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $c2b45657dc5a240d$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $c2b45657dc5a240d$var$yj(z, h, k, g, b);
                        z.mode & 1 && $c2b45657dc5a240d$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c2b45657dc5a240d$var$uj(g, l, b);
                            $c2b45657dc5a240d$var$Zj();
                            break a;
                        }
                        f = Error($c2b45657dc5a240d$var$p(426));
                    }
                } else if ($c2b45657dc5a240d$var$J && k.mode & 1) {
                    var C = $c2b45657dc5a240d$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $c2b45657dc5a240d$var$yj(C, h, k, g, b);
                        $c2b45657dc5a240d$var$Xg($c2b45657dc5a240d$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $c2b45657dc5a240d$var$lj(f, k);
                4 !== $c2b45657dc5a240d$var$T && ($c2b45657dc5a240d$var$T = 2);
                null === $c2b45657dc5a240d$var$dl ? $c2b45657dc5a240d$var$dl = [
                    g
                ] : $c2b45657dc5a240d$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $c2b45657dc5a240d$var$pj(g, f, b);
                            $c2b45657dc5a240d$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $c2b45657dc5a240d$var$tj || !$c2b45657dc5a240d$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $c2b45657dc5a240d$var$sj(g, k, b);
                                $c2b45657dc5a240d$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $c2b45657dc5a240d$var$Fl(c);
        } catch (ca) {
            b = ca;
            $c2b45657dc5a240d$var$Y === c && null !== c && ($c2b45657dc5a240d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c2b45657dc5a240d$var$vl() {
    var a = $c2b45657dc5a240d$var$Yk.current;
    $c2b45657dc5a240d$var$Yk.current = $c2b45657dc5a240d$var$ei;
    return null === a ? $c2b45657dc5a240d$var$ei : a;
}
function $c2b45657dc5a240d$var$Zj() {
    if (0 === $c2b45657dc5a240d$var$T || 3 === $c2b45657dc5a240d$var$T || 2 === $c2b45657dc5a240d$var$T) $c2b45657dc5a240d$var$T = 4;
    null === $c2b45657dc5a240d$var$Q || 0 === ($c2b45657dc5a240d$var$Fh & 268435455) && 0 === ($c2b45657dc5a240d$var$bl & 268435455) || $c2b45657dc5a240d$var$ol($c2b45657dc5a240d$var$Q, $c2b45657dc5a240d$var$Z);
}
function $c2b45657dc5a240d$var$ul(a, b) {
    var c = $c2b45657dc5a240d$var$K;
    $c2b45657dc5a240d$var$K |= 2;
    var d = $c2b45657dc5a240d$var$vl();
    if ($c2b45657dc5a240d$var$Q !== a || $c2b45657dc5a240d$var$Z !== b) {
        if ($c2b45657dc5a240d$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($c2b45657dc5a240d$var$wj(a, $c2b45657dc5a240d$var$Z), e.clear());
            $c2b45657dc5a240d$var$Qc(a, b);
        }
        $c2b45657dc5a240d$var$fl = null;
        $c2b45657dc5a240d$var$wl(a, b);
    }
    $c2b45657dc5a240d$var$wc(b);
    for(;;)try {
        $c2b45657dc5a240d$var$Gl();
        break;
    } catch (f) {
        $c2b45657dc5a240d$var$yl(a, f);
    }
    $c2b45657dc5a240d$var$nh();
    $c2b45657dc5a240d$var$K = c;
    $c2b45657dc5a240d$var$Yk.current = d;
    if (null !== $c2b45657dc5a240d$var$Y) throw Error($c2b45657dc5a240d$var$p(261));
    $c2b45657dc5a240d$var$xc();
    $c2b45657dc5a240d$var$Q = null;
    $c2b45657dc5a240d$var$Z = 0;
    return $c2b45657dc5a240d$var$T;
}
function $c2b45657dc5a240d$var$Gl() {
    for(; null !== $c2b45657dc5a240d$var$Y;)$c2b45657dc5a240d$var$Hl($c2b45657dc5a240d$var$Y);
}
function $c2b45657dc5a240d$var$xl() {
    for(; null !== $c2b45657dc5a240d$var$Y && !$c2b45657dc5a240d$var$cc();)$c2b45657dc5a240d$var$Hl($c2b45657dc5a240d$var$Y);
}
function $c2b45657dc5a240d$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($c2b45657dc5a240d$var$Wi = $c2b45657dc5a240d$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $c2b45657dc5a240d$var$Ti()), b = $c2b45657dc5a240d$var$Il(b, a, $c2b45657dc5a240d$var$Jj), $c2b45657dc5a240d$var$$i(a, !0)) : b = $c2b45657dc5a240d$var$Il(b, a, $c2b45657dc5a240d$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c2b45657dc5a240d$var$Fl(a) : $c2b45657dc5a240d$var$Y = b;
    $c2b45657dc5a240d$var$Zk.current = null;
}
function $c2b45657dc5a240d$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $c2b45657dc5a240d$var$kk(c, b, $c2b45657dc5a240d$var$Jj);
            else {
                var d = b;
                $c2b45657dc5a240d$var$Wi = $c2b45657dc5a240d$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $c2b45657dc5a240d$var$Ti());
                c = $c2b45657dc5a240d$var$kk(c, b, $c2b45657dc5a240d$var$Jj);
                $c2b45657dc5a240d$var$$i(b, !1);
            }
            if (null !== c) {
                $c2b45657dc5a240d$var$Y = c;
                return;
            }
        } else {
            c = $c2b45657dc5a240d$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c2b45657dc5a240d$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $c2b45657dc5a240d$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c2b45657dc5a240d$var$T = 6;
                $c2b45657dc5a240d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c2b45657dc5a240d$var$Y = b;
            return;
        }
        $c2b45657dc5a240d$var$Y = b = a;
    }while (null !== b);
    0 === $c2b45657dc5a240d$var$T && ($c2b45657dc5a240d$var$T = 5);
}
function $c2b45657dc5a240d$var$Cl(a, b, c) {
    var d = $c2b45657dc5a240d$var$E, e = $c2b45657dc5a240d$var$$k.transition;
    try {
        $c2b45657dc5a240d$var$$k.transition = null, $c2b45657dc5a240d$var$E = 1, $c2b45657dc5a240d$var$Jl(a, b, c, d);
    } finally{
        $c2b45657dc5a240d$var$$k.transition = e, $c2b45657dc5a240d$var$E = d;
    }
    return null;
}
function $c2b45657dc5a240d$var$Jl(a, b, c, d) {
    do $c2b45657dc5a240d$var$tl();
    while (null !== $c2b45657dc5a240d$var$hl);
    if (0 !== ($c2b45657dc5a240d$var$K & 6)) throw Error($c2b45657dc5a240d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markCommitStarted && $c2b45657dc5a240d$var$B.markCommitStarted(e);
    if (null === c) return $c2b45657dc5a240d$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c2b45657dc5a240d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c2b45657dc5a240d$var$Nc(a, f);
    a === $c2b45657dc5a240d$var$Q && ($c2b45657dc5a240d$var$Y = $c2b45657dc5a240d$var$Q = null, $c2b45657dc5a240d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c2b45657dc5a240d$var$gl || ($c2b45657dc5a240d$var$gl = !0, $c2b45657dc5a240d$var$rl($c2b45657dc5a240d$var$hc, function() {
        $c2b45657dc5a240d$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c2b45657dc5a240d$var$$k.transition;
        $c2b45657dc5a240d$var$$k.transition = null;
        var g = $c2b45657dc5a240d$var$E;
        $c2b45657dc5a240d$var$E = 1;
        var h = $c2b45657dc5a240d$var$K;
        $c2b45657dc5a240d$var$K |= 4;
        $c2b45657dc5a240d$var$Zk.current = null;
        $c2b45657dc5a240d$var$yk(a, c);
        $c2b45657dc5a240d$var$Ui = $c2b45657dc5a240d$var$Ti();
        $c2b45657dc5a240d$var$Mk(a, c, e);
        $c2b45657dc5a240d$var$bf($c2b45657dc5a240d$var$Rf);
        $c2b45657dc5a240d$var$rd = !!$c2b45657dc5a240d$var$Qf;
        $c2b45657dc5a240d$var$Rf = $c2b45657dc5a240d$var$Qf = null;
        a.current = c;
        null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markLayoutEffectsStarted && $c2b45657dc5a240d$var$B.markLayoutEffectsStarted(e);
        $c2b45657dc5a240d$var$Sk(c, a, e);
        null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markLayoutEffectsStopped && $c2b45657dc5a240d$var$B.markLayoutEffectsStopped();
        $c2b45657dc5a240d$var$dc();
        $c2b45657dc5a240d$var$K = h;
        $c2b45657dc5a240d$var$E = g;
        $c2b45657dc5a240d$var$$k.transition = f;
    } else a.current = c, $c2b45657dc5a240d$var$Ui = $c2b45657dc5a240d$var$Ti();
    $c2b45657dc5a240d$var$gl && ($c2b45657dc5a240d$var$gl = !1, $c2b45657dc5a240d$var$hl = a, $c2b45657dc5a240d$var$il = e);
    f = a.pendingLanes;
    0 === f && ($c2b45657dc5a240d$var$tj = null);
    $c2b45657dc5a240d$var$nc(c.stateNode, d);
    $c2b45657dc5a240d$var$mc && a.memoizedUpdaters.clear();
    $c2b45657dc5a240d$var$pl(a, $c2b45657dc5a240d$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c2b45657dc5a240d$var$qj) throw $c2b45657dc5a240d$var$qj = !1, a = $c2b45657dc5a240d$var$rj, $c2b45657dc5a240d$var$rj = null, a;
    0 !== ($c2b45657dc5a240d$var$il & 1) && 0 !== a.tag && $c2b45657dc5a240d$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($c2b45657dc5a240d$var$Zi = !0, a === $c2b45657dc5a240d$var$ll ? $c2b45657dc5a240d$var$kl++ : ($c2b45657dc5a240d$var$kl = 0, $c2b45657dc5a240d$var$ll = a)) : $c2b45657dc5a240d$var$kl = 0;
    $c2b45657dc5a240d$var$xg();
    $c2b45657dc5a240d$var$rc();
    return null;
}
function $c2b45657dc5a240d$var$tl() {
    if (null !== $c2b45657dc5a240d$var$hl) {
        var a = $c2b45657dc5a240d$var$Rc($c2b45657dc5a240d$var$il), b = $c2b45657dc5a240d$var$$k.transition, c = $c2b45657dc5a240d$var$E;
        try {
            $c2b45657dc5a240d$var$$k.transition = null;
            $c2b45657dc5a240d$var$E = 16 > a ? 16 : a;
            if (null === $c2b45657dc5a240d$var$hl) var d = !1;
            else {
                a = $c2b45657dc5a240d$var$hl;
                var e = $c2b45657dc5a240d$var$il;
                $c2b45657dc5a240d$var$hl = null;
                $c2b45657dc5a240d$var$il = 0;
                if (0 !== ($c2b45657dc5a240d$var$K & 6)) throw Error($c2b45657dc5a240d$var$p(331));
                null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markPassiveEffectsStarted && $c2b45657dc5a240d$var$B.markPassiveEffectsStarted(e);
                e = $c2b45657dc5a240d$var$K;
                $c2b45657dc5a240d$var$K |= 4;
                for($c2b45657dc5a240d$var$U = a.current; null !== $c2b45657dc5a240d$var$U;){
                    var f = $c2b45657dc5a240d$var$U, g = f.child;
                    if (0 !== ($c2b45657dc5a240d$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c2b45657dc5a240d$var$U = l; null !== $c2b45657dc5a240d$var$U;){
                                    var n = $c2b45657dc5a240d$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($c2b45657dc5a240d$var$Xi = $c2b45657dc5a240d$var$Ti(), $c2b45657dc5a240d$var$zk(8, q, f), $c2b45657dc5a240d$var$bj(q)) : $c2b45657dc5a240d$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $c2b45657dc5a240d$var$U = r;
                                    else for(; null !== $c2b45657dc5a240d$var$U;){
                                        n = $c2b45657dc5a240d$var$U;
                                        var z = n.sibling, m = n.return;
                                        $c2b45657dc5a240d$var$Ck(n);
                                        if (n === l) {
                                            $c2b45657dc5a240d$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $c2b45657dc5a240d$var$U = z;
                                            break;
                                        }
                                        $c2b45657dc5a240d$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $c2b45657dc5a240d$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c2b45657dc5a240d$var$U = g;
                    else b: for(; null !== $c2b45657dc5a240d$var$U;){
                        f = $c2b45657dc5a240d$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($c2b45657dc5a240d$var$Xi = $c2b45657dc5a240d$var$Ti(), $c2b45657dc5a240d$var$zk(9, k, k.return), $c2b45657dc5a240d$var$bj(k)) : $c2b45657dc5a240d$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $c2b45657dc5a240d$var$U = y;
                            break b;
                        }
                        $c2b45657dc5a240d$var$U = f.return;
                    }
                }
                var v = a.current;
                for($c2b45657dc5a240d$var$U = v; null !== $c2b45657dc5a240d$var$U;){
                    g = $c2b45657dc5a240d$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $c2b45657dc5a240d$var$U = D;
                    else b: for(g = v; null !== $c2b45657dc5a240d$var$U;){
                        h = $c2b45657dc5a240d$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $c2b45657dc5a240d$var$Xi = $c2b45657dc5a240d$var$Ti();
                                        try {
                                            $c2b45657dc5a240d$var$Ak(9, l);
                                        } finally{
                                            $c2b45657dc5a240d$var$bj(l);
                                        }
                                    } else $c2b45657dc5a240d$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $c2b45657dc5a240d$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $c2b45657dc5a240d$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $c2b45657dc5a240d$var$U = ca;
                            break b;
                        }
                        $c2b45657dc5a240d$var$U = h.return;
                    }
                }
                v = $c2b45657dc5a240d$var$jl;
                $c2b45657dc5a240d$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $c2b45657dc5a240d$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $c2b45657dc5a240d$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markPassiveEffectsStopped && $c2b45657dc5a240d$var$B.markPassiveEffectsStopped();
                $c2b45657dc5a240d$var$K = e;
                $c2b45657dc5a240d$var$xg();
                if ($c2b45657dc5a240d$var$lc && "function" === typeof $c2b45657dc5a240d$var$lc.onPostCommitFiberRoot) try {
                    $c2b45657dc5a240d$var$lc.onPostCommitFiberRoot($c2b45657dc5a240d$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $c2b45657dc5a240d$var$E = c, $c2b45657dc5a240d$var$$k.transition = b;
        }
    }
    return !1;
}
function $c2b45657dc5a240d$var$Wk(a) {
    $c2b45657dc5a240d$var$jl.push(a);
    $c2b45657dc5a240d$var$gl || ($c2b45657dc5a240d$var$gl = !0, $c2b45657dc5a240d$var$rl($c2b45657dc5a240d$var$hc, function() {
        $c2b45657dc5a240d$var$tl();
        return null;
    }));
}
function $c2b45657dc5a240d$var$Kl(a, b, c) {
    b = $c2b45657dc5a240d$var$lj(c, b);
    b = $c2b45657dc5a240d$var$pj(a, b, 1);
    a = $c2b45657dc5a240d$var$Bh(a, b, 1);
    b = $c2b45657dc5a240d$var$Ri();
    null !== a && ($c2b45657dc5a240d$var$Mc(a, 1, b), $c2b45657dc5a240d$var$pl(a, b));
}
function $c2b45657dc5a240d$var$W(a, b, c) {
    if (3 === a.tag) $c2b45657dc5a240d$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c2b45657dc5a240d$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c2b45657dc5a240d$var$tj || !$c2b45657dc5a240d$var$tj.has(d))) {
                a = $c2b45657dc5a240d$var$lj(c, a);
                a = $c2b45657dc5a240d$var$sj(b, a, 1);
                b = $c2b45657dc5a240d$var$Bh(b, a, 1);
                a = $c2b45657dc5a240d$var$Ri();
                null !== b && ($c2b45657dc5a240d$var$Mc(b, 1, a), $c2b45657dc5a240d$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c2b45657dc5a240d$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c2b45657dc5a240d$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $c2b45657dc5a240d$var$Q === a && ($c2b45657dc5a240d$var$Z & c) === c && (4 === $c2b45657dc5a240d$var$T || 3 === $c2b45657dc5a240d$var$T && ($c2b45657dc5a240d$var$Z & 130023424) === $c2b45657dc5a240d$var$Z && 500 > $c2b45657dc5a240d$var$A() - $c2b45657dc5a240d$var$Qk ? $c2b45657dc5a240d$var$wl(a, 0) : $c2b45657dc5a240d$var$cl |= c);
    $c2b45657dc5a240d$var$pl(a, b);
}
function $c2b45657dc5a240d$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c2b45657dc5a240d$var$Ec, $c2b45657dc5a240d$var$Ec <<= 1, 0 === ($c2b45657dc5a240d$var$Ec & 130023424) && ($c2b45657dc5a240d$var$Ec = 4194304)));
    var c = $c2b45657dc5a240d$var$Ri();
    a = $c2b45657dc5a240d$var$wh(a, b);
    null !== a && ($c2b45657dc5a240d$var$Mc(a, b, c), $c2b45657dc5a240d$var$pl(a, c));
}
function $c2b45657dc5a240d$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c2b45657dc5a240d$var$Ll(a, c);
}
function $c2b45657dc5a240d$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c2b45657dc5a240d$var$p(314));
    }
    null !== d && d.delete(b);
    $c2b45657dc5a240d$var$Ll(a, c);
}
var $c2b45657dc5a240d$var$Il;
$c2b45657dc5a240d$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c2b45657dc5a240d$var$jg.current) $c2b45657dc5a240d$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c2b45657dc5a240d$var$rh = !1, $c2b45657dc5a240d$var$ek(a, b, c);
            $c2b45657dc5a240d$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c2b45657dc5a240d$var$rh = !1, $c2b45657dc5a240d$var$J && 0 !== (b.flags & 1048576) && $c2b45657dc5a240d$var$Ig(b, $c2b45657dc5a240d$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c2b45657dc5a240d$var$Mj(a, b);
            a = b.pendingProps;
            var e = $c2b45657dc5a240d$var$lg(b, $c2b45657dc5a240d$var$I.current);
            $c2b45657dc5a240d$var$qh(b, c);
            $c2b45657dc5a240d$var$sc(b);
            e = $c2b45657dc5a240d$var$ai(null, b, d, a, e, c);
            var f = $c2b45657dc5a240d$var$fi();
            $c2b45657dc5a240d$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c2b45657dc5a240d$var$mg(d) ? (f = !0, $c2b45657dc5a240d$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c2b45657dc5a240d$var$yh(b), e.updater = $c2b45657dc5a240d$var$gj, b.stateNode = e, e._reactInternals = b, $c2b45657dc5a240d$var$kj(b, d, a, c), b = $c2b45657dc5a240d$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $c2b45657dc5a240d$var$J && f && $c2b45657dc5a240d$var$Jg(b), $c2b45657dc5a240d$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c2b45657dc5a240d$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c2b45657dc5a240d$var$Ml(d);
                a = $c2b45657dc5a240d$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $c2b45657dc5a240d$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c2b45657dc5a240d$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c2b45657dc5a240d$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c2b45657dc5a240d$var$Dj(null, b, d, $c2b45657dc5a240d$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($c2b45657dc5a240d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c2b45657dc5a240d$var$ej(d, e), $c2b45657dc5a240d$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c2b45657dc5a240d$var$ej(d, e), $c2b45657dc5a240d$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $c2b45657dc5a240d$var$Oj(b);
                if (null === a) throw Error($c2b45657dc5a240d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c2b45657dc5a240d$var$zh(a, b);
                $c2b45657dc5a240d$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c2b45657dc5a240d$var$lj(Error($c2b45657dc5a240d$var$p(423)), b);
                        b = $c2b45657dc5a240d$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c2b45657dc5a240d$var$lj(Error($c2b45657dc5a240d$var$p(424)), b);
                        b = $c2b45657dc5a240d$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($c2b45657dc5a240d$var$Mg = $c2b45657dc5a240d$var$Zf(b.stateNode.containerInfo.firstChild), $c2b45657dc5a240d$var$Lg = b, $c2b45657dc5a240d$var$J = !0, $c2b45657dc5a240d$var$Ng = null, c = $c2b45657dc5a240d$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c2b45657dc5a240d$var$Wg();
                    if (d === e) {
                        b = $c2b45657dc5a240d$var$Cj(a, b, c);
                        break a;
                    }
                    $c2b45657dc5a240d$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c2b45657dc5a240d$var$Oh(b), null === a && $c2b45657dc5a240d$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c2b45657dc5a240d$var$Sf(d, e) ? g = null : null !== f && $c2b45657dc5a240d$var$Sf(d, f) && (b.flags |= 32), $c2b45657dc5a240d$var$Kj(a, b), $c2b45657dc5a240d$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $c2b45657dc5a240d$var$Sg(b), null;
        case 13:
            return $c2b45657dc5a240d$var$Uj(a, b, c);
        case 4:
            return $c2b45657dc5a240d$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c2b45657dc5a240d$var$hh(b, null, d, c) : $c2b45657dc5a240d$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c2b45657dc5a240d$var$ej(d, e), $c2b45657dc5a240d$var$Bj(a, b, d, e, c);
        case 7:
            return $c2b45657dc5a240d$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c2b45657dc5a240d$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $c2b45657dc5a240d$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c2b45657dc5a240d$var$H($c2b45657dc5a240d$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c2b45657dc5a240d$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$c2b45657dc5a240d$var$jg.current) {
                            b = $c2b45657dc5a240d$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c2b45657dc5a240d$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c2b45657dc5a240d$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c2b45657dc5a240d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c2b45657dc5a240d$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c2b45657dc5a240d$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c2b45657dc5a240d$var$qh(b, c), e = $c2b45657dc5a240d$var$sh(e), $c2b45657dc5a240d$var$sc(b), d = d(e), $c2b45657dc5a240d$var$tc(), b.flags |= 1, $c2b45657dc5a240d$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c2b45657dc5a240d$var$ej(d, b.pendingProps), e = $c2b45657dc5a240d$var$ej(d.type, e), $c2b45657dc5a240d$var$Dj(a, b, d, e, c);
        case 15:
            return $c2b45657dc5a240d$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c2b45657dc5a240d$var$ej(d, e), $c2b45657dc5a240d$var$Mj(a, b), b.tag = 1, $c2b45657dc5a240d$var$mg(d) ? (a = !0, $c2b45657dc5a240d$var$qg(b)) : a = !1, $c2b45657dc5a240d$var$qh(b, c), $c2b45657dc5a240d$var$ij(b, d, e), $c2b45657dc5a240d$var$kj(b, d, e, c), $c2b45657dc5a240d$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $c2b45657dc5a240d$var$dk(a, b, c);
        case 22:
            return $c2b45657dc5a240d$var$Hj(a, b, c);
    }
    throw Error($c2b45657dc5a240d$var$p(156, b.tag));
};
function $c2b45657dc5a240d$var$wj(a, b) {
    $c2b45657dc5a240d$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $c2b45657dc5a240d$var$Pc(a, c, b);
    });
}
function $c2b45657dc5a240d$var$rl(a, b) {
    return $c2b45657dc5a240d$var$ac(a, b);
}
function $c2b45657dc5a240d$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $c2b45657dc5a240d$var$Pg(a, b, c, d) {
    return new $c2b45657dc5a240d$var$Nl(a, b, c, d);
}
function $c2b45657dc5a240d$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c2b45657dc5a240d$var$Ml(a) {
    if ("function" === typeof a) return $c2b45657dc5a240d$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c2b45657dc5a240d$var$Da) return 11;
        if (a === $c2b45657dc5a240d$var$Ga) return 14;
    }
    return 2;
}
function $c2b45657dc5a240d$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $c2b45657dc5a240d$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $c2b45657dc5a240d$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c2b45657dc5a240d$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c2b45657dc5a240d$var$ya:
            return $c2b45657dc5a240d$var$gh(c.children, e, f, b);
        case $c2b45657dc5a240d$var$za:
            g = 8;
            e |= 8;
            break;
        case $c2b45657dc5a240d$var$Aa:
            return a = $c2b45657dc5a240d$var$Pg(12, c, b, e | 2), a.elementType = $c2b45657dc5a240d$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $c2b45657dc5a240d$var$Ea:
            return a = $c2b45657dc5a240d$var$Pg(13, c, b, e), a.elementType = $c2b45657dc5a240d$var$Ea, a.lanes = f, a;
        case $c2b45657dc5a240d$var$Fa:
            return a = $c2b45657dc5a240d$var$Pg(19, c, b, e), a.elementType = $c2b45657dc5a240d$var$Fa, a.lanes = f, a;
        case $c2b45657dc5a240d$var$Ia:
            return $c2b45657dc5a240d$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c2b45657dc5a240d$var$Ba:
                    g = 10;
                    break a;
                case $c2b45657dc5a240d$var$Ca:
                    g = 9;
                    break a;
                case $c2b45657dc5a240d$var$Da:
                    g = 11;
                    break a;
                case $c2b45657dc5a240d$var$Ga:
                    g = 14;
                    break a;
                case $c2b45657dc5a240d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c2b45657dc5a240d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c2b45657dc5a240d$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c2b45657dc5a240d$var$gh(a, b, c, d) {
    a = $c2b45657dc5a240d$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c2b45657dc5a240d$var$Vj(a, b, c, d) {
    a = $c2b45657dc5a240d$var$Pg(22, a, d, b);
    a.elementType = $c2b45657dc5a240d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c2b45657dc5a240d$var$dh(a, b, c) {
    a = $c2b45657dc5a240d$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c2b45657dc5a240d$var$fh(a, b, c) {
    b = $c2b45657dc5a240d$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c2b45657dc5a240d$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c2b45657dc5a240d$var$Lc(0);
    this.expirationTimes = $c2b45657dc5a240d$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c2b45657dc5a240d$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $c2b45657dc5a240d$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $c2b45657dc5a240d$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $c2b45657dc5a240d$var$mc && (b |= 2);
    f = $c2b45657dc5a240d$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c2b45657dc5a240d$var$yh(f);
    return a;
}
function $c2b45657dc5a240d$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c2b45657dc5a240d$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c2b45657dc5a240d$var$Rl(a) {
    if (!a) return $c2b45657dc5a240d$var$ig;
    a = a._reactInternals;
    a: {
        if ($c2b45657dc5a240d$var$Vb(a) !== a || 1 !== a.tag) throw Error($c2b45657dc5a240d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c2b45657dc5a240d$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c2b45657dc5a240d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c2b45657dc5a240d$var$mg(c)) return $c2b45657dc5a240d$var$pg(a, c, b);
    }
    return b;
}
function $c2b45657dc5a240d$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $c2b45657dc5a240d$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $c2b45657dc5a240d$var$Rl(null);
    c = a.current;
    d = $c2b45657dc5a240d$var$Ri();
    e = $c2b45657dc5a240d$var$Oi(c);
    f = $c2b45657dc5a240d$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c2b45657dc5a240d$var$Bh(c, f, e);
    a.current.lanes = e;
    $c2b45657dc5a240d$var$Mc(a, e, d);
    $c2b45657dc5a240d$var$pl(a, d);
    return a;
}
function $c2b45657dc5a240d$var$Tl(a, b, c, d) {
    var e = b.current, f = $c2b45657dc5a240d$var$Ri(), g = $c2b45657dc5a240d$var$Oi(e);
    null !== $c2b45657dc5a240d$var$B && "function" === typeof $c2b45657dc5a240d$var$B.markRenderScheduled && $c2b45657dc5a240d$var$B.markRenderScheduled(g);
    c = $c2b45657dc5a240d$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c2b45657dc5a240d$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c2b45657dc5a240d$var$Bh(e, b, g);
    null !== a && ($c2b45657dc5a240d$var$ui(a, e, g, f), $c2b45657dc5a240d$var$Ch(a, e, g));
    return g;
}
function $c2b45657dc5a240d$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c2b45657dc5a240d$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c2b45657dc5a240d$var$Wl(a, b) {
    $c2b45657dc5a240d$var$Vl(a, b);
    (a = a.alternate) && $c2b45657dc5a240d$var$Vl(a, b);
}
function $c2b45657dc5a240d$var$Xl() {
    return null;
}
var $c2b45657dc5a240d$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c2b45657dc5a240d$var$Zl(a) {
    this._internalRoot = a;
}
$c2b45657dc5a240d$var$$l.prototype.render = $c2b45657dc5a240d$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c2b45657dc5a240d$var$p(409));
    $c2b45657dc5a240d$var$Tl(a, b, null, null);
};
$c2b45657dc5a240d$var$$l.prototype.unmount = $c2b45657dc5a240d$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c2b45657dc5a240d$var$El(function() {
            $c2b45657dc5a240d$var$Tl(null, a, null, null);
        });
        b[$c2b45657dc5a240d$var$If] = null;
    }
};
function $c2b45657dc5a240d$var$$l(a) {
    this._internalRoot = a;
}
$c2b45657dc5a240d$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c2b45657dc5a240d$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c2b45657dc5a240d$var$dd.length && 0 !== b && b < $c2b45657dc5a240d$var$dd[c].priority; c++);
        $c2b45657dc5a240d$var$dd.splice(c, 0, a);
        0 === c && $c2b45657dc5a240d$var$id(a);
    }
};
function $c2b45657dc5a240d$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c2b45657dc5a240d$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c2b45657dc5a240d$var$cm() {}
function $c2b45657dc5a240d$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c2b45657dc5a240d$var$Ul(g);
                f.call(a);
            };
        }
        var g = $c2b45657dc5a240d$var$Sl(b, d, a, 0, null, !1, !1, "", $c2b45657dc5a240d$var$cm);
        a._reactRootContainer = g;
        a[$c2b45657dc5a240d$var$If] = g.current;
        $c2b45657dc5a240d$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $c2b45657dc5a240d$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c2b45657dc5a240d$var$Ul(k);
            h.call(a);
        };
    }
    var k = $c2b45657dc5a240d$var$Pl(a, 0, !1, null, null, !1, !1, "", $c2b45657dc5a240d$var$cm);
    a._reactRootContainer = k;
    a[$c2b45657dc5a240d$var$If] = k.current;
    $c2b45657dc5a240d$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $c2b45657dc5a240d$var$El(function() {
        $c2b45657dc5a240d$var$Tl(b, k, c, d);
    });
    return k;
}
function $c2b45657dc5a240d$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c2b45657dc5a240d$var$Ul(g);
                h.call(a);
            };
        }
        $c2b45657dc5a240d$var$Tl(b, g, a, e);
    } else g = $c2b45657dc5a240d$var$dm(c, b, a, e, d);
    return $c2b45657dc5a240d$var$Ul(g);
}
$c2b45657dc5a240d$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c2b45657dc5a240d$var$Fc(b.pendingLanes);
                0 !== c && ($c2b45657dc5a240d$var$Oc(b, c | 1), $c2b45657dc5a240d$var$pl(b, $c2b45657dc5a240d$var$A()), 0 === ($c2b45657dc5a240d$var$K & 6) && ($c2b45657dc5a240d$var$mk = $c2b45657dc5a240d$var$A() + 500, $c2b45657dc5a240d$var$xg()));
            }
            break;
        case 13:
            $c2b45657dc5a240d$var$El(function() {
                var b = $c2b45657dc5a240d$var$wh(a, 1);
                if (null !== b) {
                    var c = $c2b45657dc5a240d$var$Ri();
                    $c2b45657dc5a240d$var$ui(b, a, 1, c);
                }
            }), $c2b45657dc5a240d$var$Wl(a, 1);
    }
};
$c2b45657dc5a240d$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $c2b45657dc5a240d$var$wh(a, 134217728);
        if (null !== b) {
            var c = $c2b45657dc5a240d$var$Ri();
            $c2b45657dc5a240d$var$ui(b, a, 134217728, c);
        }
        $c2b45657dc5a240d$var$Wl(a, 134217728);
    }
};
$c2b45657dc5a240d$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $c2b45657dc5a240d$var$Oi(a), c = $c2b45657dc5a240d$var$wh(a, b);
        if (null !== c) {
            var d = $c2b45657dc5a240d$var$Ri();
            $c2b45657dc5a240d$var$ui(c, a, b, d);
        }
        $c2b45657dc5a240d$var$Wl(a, b);
    }
};
$c2b45657dc5a240d$var$Vc = function() {
    return $c2b45657dc5a240d$var$E;
};
$c2b45657dc5a240d$var$Wc = function(a, b) {
    var c = $c2b45657dc5a240d$var$E;
    try {
        return $c2b45657dc5a240d$var$E = a, b();
    } finally{
        $c2b45657dc5a240d$var$E = c;
    }
};
$c2b45657dc5a240d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c2b45657dc5a240d$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c2b45657dc5a240d$var$Db(d);
                        if (!e) throw Error($c2b45657dc5a240d$var$p(90));
                        $c2b45657dc5a240d$var$Wa(d);
                        $c2b45657dc5a240d$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c2b45657dc5a240d$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $c2b45657dc5a240d$var$eb(a, !!c.multiple, b, !1);
    }
};
$c2b45657dc5a240d$var$Gb = $c2b45657dc5a240d$var$Dl;
$c2b45657dc5a240d$var$Hb = $c2b45657dc5a240d$var$El;
var $c2b45657dc5a240d$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $c2b45657dc5a240d$var$Cb,
        $c2b45657dc5a240d$var$Ie,
        $c2b45657dc5a240d$var$Db,
        $c2b45657dc5a240d$var$Eb,
        $c2b45657dc5a240d$var$Fb,
        $c2b45657dc5a240d$var$Dl
    ]
}, $c2b45657dc5a240d$var$gm = {
    findFiberByHostInstance: $c2b45657dc5a240d$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $c2b45657dc5a240d$var$u({}, a, {
            getLaneLabelMap: $c2b45657dc5a240d$var$pc,
            injectProfilingHooks: $c2b45657dc5a240d$var$oc
        }), $c2b45657dc5a240d$var$kc = b.inject(a), $c2b45657dc5a240d$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $c2b45657dc5a240d$var$gm.bundleType,
    version: $c2b45657dc5a240d$var$gm.version,
    rendererPackageName: $c2b45657dc5a240d$var$gm.rendererPackageName,
    rendererConfig: $c2b45657dc5a240d$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c2b45657dc5a240d$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c2b45657dc5a240d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c2b45657dc5a240d$var$gm.findFiberByHostInstance || $c2b45657dc5a240d$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$c2b45657dc5a240d$export$ae55be85d98224ed = $c2b45657dc5a240d$var$fm;
$c2b45657dc5a240d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c2b45657dc5a240d$var$am(b)) throw Error($c2b45657dc5a240d$var$p(200));
    return $c2b45657dc5a240d$var$Ql(a, b, null, c);
};
$c2b45657dc5a240d$export$882461b6382ed46c = function(a, b) {
    if (!$c2b45657dc5a240d$var$am(a)) throw Error($c2b45657dc5a240d$var$p(299));
    var c = !1, d = "", e = $c2b45657dc5a240d$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c2b45657dc5a240d$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$c2b45657dc5a240d$var$If] = b.current;
    $c2b45657dc5a240d$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $c2b45657dc5a240d$var$Zl(b);
};
$c2b45657dc5a240d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c2b45657dc5a240d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c2b45657dc5a240d$var$p(268, a));
    }
    a = $c2b45657dc5a240d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c2b45657dc5a240d$export$cd75ccfd720a3cd4 = function(a) {
    return $c2b45657dc5a240d$var$El(a);
};
$c2b45657dc5a240d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c2b45657dc5a240d$var$bm(b)) throw Error($c2b45657dc5a240d$var$p(200));
    return $c2b45657dc5a240d$var$em(null, a, b, !0, c);
};
$c2b45657dc5a240d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c2b45657dc5a240d$var$am(a)) throw Error($c2b45657dc5a240d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c2b45657dc5a240d$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c2b45657dc5a240d$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c2b45657dc5a240d$var$If] = b.current;
    $c2b45657dc5a240d$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c2b45657dc5a240d$var$$l(b);
};
$c2b45657dc5a240d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c2b45657dc5a240d$var$bm(b)) throw Error($c2b45657dc5a240d$var$p(200));
    return $c2b45657dc5a240d$var$em(null, a, b, !1, c);
};
$c2b45657dc5a240d$export$502457920280e6be = function(a) {
    if (!$c2b45657dc5a240d$var$bm(a)) throw Error($c2b45657dc5a240d$var$p(40));
    return a._reactRootContainer ? ($c2b45657dc5a240d$var$El(function() {
        $c2b45657dc5a240d$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c2b45657dc5a240d$var$If] = null;
        });
    }), !0) : !1;
};
$c2b45657dc5a240d$export$c78a37762a8d58e1 = $c2b45657dc5a240d$var$Dl;
$c2b45657dc5a240d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c2b45657dc5a240d$var$bm(c)) throw Error($c2b45657dc5a240d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c2b45657dc5a240d$var$p(38));
    return $c2b45657dc5a240d$var$em(a, b, c, !1, d);
};
$c2b45657dc5a240d$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("40GmU", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aLWdb"));

});



parcelRegister("7IywQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $59e76d2732044c53$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $59e76d2732044c53$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $59e76d2732044c53$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))),
    devtools: false,
    middlewares: new Set(),
    mutator: $59e76d2732044c53$var$defaultMutator
};
var $59e76d2732044c53$export$2e2bcd8739ae039 = $59e76d2732044c53$var$defaults;

});

parcelRegister("5riux", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f5dd16c6ebe2597$export$2e2bcd8739ae039);
const $3f5dd16c6ebe2597$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $3f5dd16c6ebe2597$export$2e2bcd8739ae039 = $3f5dd16c6ebe2597$var$supports;

});


parcelRegister("gfNVK", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $bd54c7382b786dc6$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $bd54c7382b786dc6$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $bd54c7382b786dc6$export$6e4e5611de132e85);

var $bSJIT = parcelRequire("bSJIT");

var $jl5L8 = parcelRequire("jl5L8");

var $5FN91 = parcelRequire("5FN91");

var $bBhJi = parcelRequire("bBhJi");
const $bd54c7382b786dc6$var$EMPTY_SELECTOR = ()=>undefined;
const $bd54c7382b786dc6$var$DEFAULT_SELECTOR = (state)=>state;
function $bd54c7382b786dc6$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $bSJIT.useContext)((0, $5FN91.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $bSJIT.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $bSJIT.useMemo)(()=>selector ? (0, $bBhJi.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $bd54c7382b786dc6$var$EMPTY_SELECTOR : $bd54c7382b786dc6$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $bSJIT.useState)({})[1];
        const getSnapshot = (0, $bSJIT.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $jl5L8.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $bd54c7382b786dc6$export$7c643e1d6648e418(Store) {
    const useHook = $bd54c7382b786dc6$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $bd54c7382b786dc6$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $bd54c7382b786dc6$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("jl5L8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iPGLW"));

});
parcelRegister("iPGLW", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $db5e2b13d413ca60$export$306c0aa65ff9ec16, (v) => $db5e2b13d413ca60$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db5e2b13d413ca60$export$306c0aa65ff9ec16;
"use strict";

var $bSJIT = parcelRequire("bSJIT");
function $db5e2b13d413ca60$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $db5e2b13d413ca60$var$objectIs = "function" === typeof Object.is ? Object.is : $db5e2b13d413ca60$var$is, $db5e2b13d413ca60$var$useState = $bSJIT.useState, $db5e2b13d413ca60$var$useEffect = $bSJIT.useEffect, $db5e2b13d413ca60$var$useLayoutEffect = $bSJIT.useLayoutEffect, $db5e2b13d413ca60$var$useDebugValue = $bSJIT.useDebugValue;
function $db5e2b13d413ca60$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $db5e2b13d413ca60$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $db5e2b13d413ca60$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $db5e2b13d413ca60$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $db5e2b13d413ca60$var$useEffect(function() {
        $db5e2b13d413ca60$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $db5e2b13d413ca60$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $db5e2b13d413ca60$var$useDebugValue(value);
    return value;
}
function $db5e2b13d413ca60$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$db5e2b13d413ca60$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $db5e2b13d413ca60$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $db5e2b13d413ca60$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $db5e2b13d413ca60$var$useSyncExternalStore$1 : $db5e2b13d413ca60$var$useSyncExternalStore$2;
$db5e2b13d413ca60$export$306c0aa65ff9ec16 = void 0 !== $bSJIT.useSyncExternalStore ? $bSJIT.useSyncExternalStore : $db5e2b13d413ca60$var$shim;

});


parcelRegister("5FN91", function(module, exports) {
$parcel$export(module.exports, "Context", () => $4216e72b91970084$export$841858b892ce1f4c);

var $bSJIT = parcelRequire("bSJIT");

var $jhZn5 = parcelRequire("jhZn5");
const $4216e72b91970084$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({
    globalRegistry: (0, $jhZn5.defaultRegistry),
    retrieveStore: (Store)=>(0, $jhZn5.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("jhZn5", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $e0af35e9c448d381$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $e0af35e9c448d381$export$9d726ae4880b1060);

var $5riux = parcelRequire("5riux");

var $a8CBv = parcelRequire("a8CBv");

var $hAloB = parcelRequire("hAloB");
const $e0af35e9c448d381$export$e4d628ba0054221b = '__global__';
class $e0af35e9c448d381$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $e0af35e9c448d381$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $5riux.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $hAloB.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $a8CBv.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $e0af35e9c448d381$export$9d726ae4880b1060 = new $e0af35e9c448d381$export$acb47f32da33501e();

});
parcelRegister("a8CBv", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $761898b01e5aff48$export$5ee1d46cd0883a22);

var $7IywQ = parcelRequire("7IywQ");
const $761898b01e5aff48$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $761898b01e5aff48$var$warnings = new WeakMap();
const $761898b01e5aff48$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $7IywQ.default).devtools ? $761898b01e5aff48$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$761898b01e5aff48$var$warnings.has(actionFn)) $761898b01e5aff48$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $761898b01e5aff48$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $761898b01e5aff48$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});

parcelRegister("hAloB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccd6653c9bbb7a48$export$2e2bcd8739ae039);

var $ccYNI = parcelRequire("ccYNI");

var $loefS = parcelRequire("loefS");

var $7IywQ = parcelRequire("7IywQ");

var $eU2LW = parcelRequire("eU2LW");
function $ccd6653c9bbb7a48$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $eU2LW.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $ccYNI.default)(storeState, (0, $7IywQ.default).middlewares);
    return storeState;
}
var $ccd6653c9bbb7a48$export$2e2bcd8739ae039 = (0, $loefS.default)($ccd6653c9bbb7a48$var$createStoreState);

});
parcelRegister("ccYNI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e35c4d467484517$export$2e2bcd8739ae039);

var $7IywQ = parcelRequire("7IywQ");

var $7E03P = parcelRequire("7E03P");
const $8e35c4d467484517$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $7E03P.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $7IywQ.default).mutator);
var $8e35c4d467484517$export$2e2bcd8739ae039 = $8e35c4d467484517$var$applyMiddleware;

});
parcelRegister("7E03P", function(module, exports) {
$parcel$export(module.exports, "default", () => $590c50e39c8b083b$export$2e2bcd8739ae039);

var $lazmu = parcelRequire("lazmu");
const $590c50e39c8b083b$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $lazmu.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $590c50e39c8b083b$export$2e2bcd8739ae039 = $590c50e39c8b083b$var$updateMiddleware;

});
parcelRegister("lazmu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f695f640e2d739cb$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $f695f640e2d739cb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $f695f640e2d739cb$var$CACHE = new WeakMap();
function $f695f640e2d739cb$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($f695f640e2d739cb$var$CACHE.has(objA)) keysA = $f695f640e2d739cb$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $f695f640e2d739cb$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($f695f640e2d739cb$var$CACHE.has(objB)) keysB = $f695f640e2d739cb$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $f695f640e2d739cb$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$f695f640e2d739cb$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("loefS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f926e59bfc96da2c$export$2e2bcd8739ae039);

var $7IywQ = parcelRequire("7IywQ");
const $f926e59bfc96da2c$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $f926e59bfc96da2c$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $7IywQ.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $7IywQ.default).devtools === 'function' ? (0, $7IywQ.default).devtools(storeState) : {};
                        devTools = $f926e59bfc96da2c$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $f926e59bfc96da2c$export$2e2bcd8739ae039 = $f926e59bfc96da2c$var$withDevtools;

});

parcelRegister("eU2LW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad98722f822cfcb4$export$2e2bcd8739ae039);

var $7IywQ = parcelRequire("7IywQ");

var $bQodR = parcelRequire("bQodR");

var $5riux = parcelRequire("5riux");
const $ad98722f822cfcb4$var$QUEUE = [];
let $ad98722f822cfcb4$var$scheduled;
function $ad98722f822cfcb4$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $7IywQ.default).batchUpdates || !(0, $5riux.default).scheduling()) return (0, $bQodR.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$ad98722f822cfcb4$var$QUEUE.includes(fn)) $ad98722f822cfcb4$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($ad98722f822cfcb4$var$scheduled) return;
    $ad98722f822cfcb4$var$scheduled = (0, $bQodR.batch)(()=>{
        let queueFn;
        while(queueFn = $ad98722f822cfcb4$var$QUEUE.shift())queueFn();
        $ad98722f822cfcb4$var$scheduled = null;
    });
}

});




parcelRegister("bBhJi", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $8720e727f6bfe738$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $8720e727f6bfe738$export$38d24f3c60944dd5);

var $fc2Mk = parcelRequire("fc2Mk");
function $8720e727f6bfe738$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $fc2Mk.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $fc2Mk.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $8720e727f6bfe738$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $8720e727f6bfe738$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $8720e727f6bfe738$var$cache = new WeakMap();
function $8720e727f6bfe738$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$8720e727f6bfe738$var$cache.has(storeState)) $8720e727f6bfe738$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $8720e727f6bfe738$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $8720e727f6bfe738$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $8720e727f6bfe738$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("fc2Mk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0fa21c42c5c4981$export$2e2bcd8739ae039);

var $lazmu = parcelRequire("lazmu");
function $b0fa21c42c5c4981$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $b0fa21c42c5c4981$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $lazmu.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$b0fa21c42c5c4981$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $b0fa21c42c5c4981$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $b0fa21c42c5c4981$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $lazmu.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("adFyB", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $770b5aae7692bac2$export$26ae5ca175b4ec5a);

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $5FN91 = parcelRequire("5FN91");

var $a8CBv = parcelRequire("a8CBv");
var $jhZn5 = parcelRequire("jhZn5");

var $lazmu = parcelRequire("lazmu");
const $770b5aae7692bac2$var$_excluded = [
    "children"
], $770b5aae7692bac2$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $770b5aae7692bac2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $770b5aae7692bac2$var$noop = ()=>()=>{};
function $770b5aae7692bac2$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $770b5aae7692bac2$var$noop, onUpdate: onUpdate = $770b5aae7692bac2$var$noop, onCleanup: onCleanup = $770b5aae7692bac2$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $770b5aae7692bac2$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $770b5aae7692bac2$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $770b5aae7692bac2$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $770b5aae7692bac2$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $770b5aae7692bac2$var$createFunctionContainer(StoreOrOptions);
}
function $770b5aae7692bac2$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $bSJIT.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $jhZn5.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $770b5aae7692bac2$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $bSJIT.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $bSJIT.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $a8CBv.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $a8CBv.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $770b5aae7692bac2$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $bSJIT.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $bSJIT.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $770b5aae7692bac2$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $770b5aae7692bac2$var$_objectWithoutPropertiesLoose(props, $770b5aae7692bac2$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $770b5aae7692bac2$var$_objectWithoutPropertiesLoose(restProps, $770b5aae7692bac2$var$_excluded2);
        const ctx = (0, $bSJIT.useContext)((0, $5FN91.Context));
        const registry = $770b5aae7692bac2$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $bSJIT.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $770b5aae7692bac2$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $770b5aae7692bac2$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $lazmu.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $bSJIT.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $bSJIT.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5FN91.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).bool
    };
    return FunctionContainer;
}

});

parcelRegister("7CE69", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $58cb2fabc30b0120$export$f51a9068ac82ea43);

var $bUfrN = parcelRequire("bUfrN");
function $58cb2fabc30b0120$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $bUfrN.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $58cb2fabc30b0120$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $58cb2fabc30b0120$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("bUfrN", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ab0e83449305892$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $8ab0e83449305892$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("lFj9V", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $fc5c49e85722ff80$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $fc5c49e85722ff80$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $fc5c49e85722ff80$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $fc5c49e85722ff80$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $fc5c49e85722ff80$export$c9237620ff7fdf7c);

var $cd8bt = parcelRequire("cd8bt");
parcelRequire("4bmA3");
var $2JZPC = parcelRequire("2JZPC");
const $fc5c49e85722ff80$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $fc5c49e85722ff80$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $fc5c49e85722ff80$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $fc5c49e85722ff80$var$stripTrailingSlash(prefix);
        prefix = $fc5c49e85722ff80$var$addLeadingSlash(prefix);
        path = $fc5c49e85722ff80$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $fc5c49e85722ff80$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $fc5c49e85722ff80$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$fc5c49e85722ff80$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($cd8bt)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($cd8bt)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $fc5c49e85722ff80$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$fc5c49e85722ff80$export$e83e3719fc818ee5(path)) {
        path = $fc5c49e85722ff80$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($cd8bt)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $fc5c49e85722ff80$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $cd8bt.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $fc5c49e85722ff80$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $fc5c49e85722ff80$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $2JZPC.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("2a9Vu", function(module, exports) {
$parcel$export(module.exports, "Router", () => $19343716ad05b112$export$55185c17a0fcbe46);

var $g8vBZ = parcelRequire("g8vBZ");

var $kHwwG = parcelRequire("kHwwG");

var $bSJIT = parcelRequire("bSJIT");

var $giOHo = parcelRequire("giOHo");
const $19343716ad05b112$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $giOHo.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $19343716ad05b112$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $bSJIT.useMemo)(()=>(0, $kHwwG.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($19343716ad05b112$export$55185c17a0fcbe46, (0, $g8vBZ.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("eRf9Q", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $3DuDW = parcelRequire("3DuDW");
const $ad11c5eef74b6775$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $3DuDW.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(actions));
};
$ad11c5eef74b6775$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("3DuDW", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $2a5cc8b77987a479$export$402e82ff1b20594b);

var $giOHo = parcelRequire("giOHo");
const $2a5cc8b77987a479$export$402e82ff1b20594b = (0, $giOHo.useRouterStoreActions);

});


parcelRegister("a6Y7T", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => $75c91abc3f7a1570$export$672d721d310ff5f0);

var $kV77Q = parcelRequire("kV77Q");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("4bmA3");
var $Nt5no = parcelRequire("Nt5no");

var $giOHo = parcelRequire("giOHo");
const $75c91abc3f7a1570$var$_excluded = [
    "listen"
];
const $75c91abc3f7a1570$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $giOHo.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $kV77Q.default)(_ref, $75c91abc3f7a1570$var$_excluded);
    if (!state.unlisten && !(0, $Nt5no.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(state, actions));
};

});
parcelRegister("kV77Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3aea885b6d10361$export$2e2bcd8739ae039);
function $f3aea885b6d10361$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("3Gmp6", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $2ae6ac4bdb84f72a$export$8c8591dcd57728e6);

var $bSJIT = parcelRequire("bSJIT");

var $gfNVK = parcelRequire("gfNVK");

var $giOHo = parcelRequire("giOHo");
const $2ae6ac4bdb84f72a$var$createPathParamHook = (0, $gfNVK.createHook)((0, $giOHo.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $2ae6ac4bdb84f72a$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $2ae6ac4bdb84f72a$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $bSJIT.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("liXIH", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $f8299a8e86c8d3b0$export$ae316f0eeb712a36);

var $bSJIT = parcelRequire("bSJIT");

var $gfNVK = parcelRequire("gfNVK");

var $giOHo = parcelRequire("giOHo");
const $f8299a8e86c8d3b0$var$createQueryParamHook = (0, $gfNVK.createHook)((0, $giOHo.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $f8299a8e86c8d3b0$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $f8299a8e86c8d3b0$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $bSJIT.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("hbIgt", function(module, exports) {
$parcel$export(module.exports, "withRouter", () => $c835ccca03e71549$export$369b6b2b30582e8e);

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");

var $giOHo = parcelRequire("giOHo");
const $c835ccca03e71549$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $c835ccca03e71549$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $c835ccca03e71549$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $giOHo.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, (0, $g8vBZ.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("9nn9c", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("3rmIb")).default);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("7t0F6")).RouteComponent);

var $3rmIb = parcelRequire("3rmIb");

var $7t0F6 = parcelRequire("7t0F6");

});
parcelRegister("3rmIb", function(module, exports) {
$parcel$export(module.exports, "default", () => $281582c81dc38eff$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");

var $kHwwG = parcelRequire("kHwwG");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("4bmA3");
var $67m70 = parcelRequire("67m70");
var $3bxzQ = parcelRequire("3bxzQ");

var $giOHo = parcelRequire("giOHo");

var $3O51A = parcelRequire("3O51A");
parcelRequire("dIHuj");
var $l1xNi = parcelRequire("l1xNi");
var $awJZC = parcelRequire("awJZC");
const $281582c81dc38eff$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $281582c81dc38eff$var$PREFETCH_DELAY = 225;
const $281582c81dc38eff$var$Link = /*#__PURE__*/ (0, $bSJIT.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $kV77Q.default)(_ref, $281582c81dc38eff$var$_excluded);
    const routerActions = (0, $giOHo.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $3O51A.useTimeout)($281582c81dc38eff$var$PREFETCH_DELAY);
    const validLinkType = (0, $l1xNi.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $bSJIT.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $kHwwG.createPath)((0, $3bxzQ.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $bSJIT.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $67m70.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $awJZC.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $bSJIT.createElement)(validLinkType, (0, $g8vBZ.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$281582c81dc38eff$var$Link.displayName = 'Link';
var $281582c81dc38eff$export$2e2bcd8739ae039 = $281582c81dc38eff$var$Link;

});
parcelRegister("3O51A", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $2c59f0629a9c8576$export$d8e6abf214c9ec0f);

var $bSJIT = parcelRequire("bSJIT");
const $2c59f0629a9c8576$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $bSJIT.useRef)();
    const schedule = (0, $bSJIT.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("dIHuj", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("l1xNi")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("awJZC")).handleNavigation);

var $l1xNi = parcelRequire("l1xNi");

var $awJZC = parcelRequire("awJZC");

});
parcelRegister("l1xNi", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $f4e3e7c2adfefe34$export$855ece989b15eb57);
const $f4e3e7c2adfefe34$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $f4e3e7c2adfefe34$export$855ece989b15eb57 = (type)=>$f4e3e7c2adfefe34$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("awJZC", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $7aa091bfddb99cf2$export$706ad1af8096e280);

var $5FYHq = parcelRequire("5FYHq");
const $7aa091bfddb99cf2$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $5FYHq.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $5FYHq.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $5FYHq.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("5FYHq", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $421fddb7fc08313b$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $421fddb7fc08313b$export$130b789831072f4c);
const $421fddb7fc08313b$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $421fddb7fc08313b$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("7t0F6", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $56fbc1458b245513$export$7903e4b73fc7d6c3);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("fBrkg");
var $h1bGI = parcelRequire("h1bGI");
const $56fbc1458b245513$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $h1bGI.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("hjbmn", function(module, exports) {
parcelRequire("4bmA3");
var $67m70 = parcelRequire("67m70");
const $c99d05e296aad61b$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $67m70.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("iZLh2", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => (parcelRequire("B4vXG")).createResourcesPlugin);
$parcel$export(module.exports, "useResource", () => (parcelRequire("hMsRa")).useResource);
$parcel$export(module.exports, "createResource", () => (parcelRequire("iXC0o")).createResource);

var $B4vXG = parcelRequire("B4vXG");

var $3HVrG = parcelRequire("3HVrG");

var $hMsRa = parcelRequire("hMsRa");

var $eQ4kV = parcelRequire("eQ4kV");
parcelRequire("4tXVt");
var $iXC0o = parcelRequire("iXC0o");

var $B4vXG = parcelRequire("B4vXG");

var $7YYDZ = parcelRequire("7YYDZ");

});
parcelRegister("B4vXG", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $06f6f54db5ae21b5$export$23ed892c481a96fe);

var $4tXVt = parcelRequire("4tXVt");
parcelRequire("iJePW");
var $cdQQR = parcelRequire("cdQQR");
const $06f6f54db5ae21b5$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $06f6f54db5ae21b5$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $4tXVt.getResourceStore)().actions;
    const nextResources = (0, $cdQQR.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $06f6f54db5ae21b5$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $4tXVt.getResourceStore)().actions;
    const nextResources = (0, $cdQQR.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $06f6f54db5ae21b5$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $4tXVt.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $06f6f54db5ae21b5$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $06f6f54db5ae21b5$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $06f6f54db5ae21b5$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $4tXVt.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $4tXVt.getResourceStore)().actions;
            const nextResources = (0, $cdQQR.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $4tXVt.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("4tXVt", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $34385ae3067380c3$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $34385ae3067380c3$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $34385ae3067380c3$export$98e41a62c9bef75e);
$parcel$export(module.exports, "createResource", () => (parcelRequire("iXC0o")).createResource);

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");

var $gfNVK = parcelRequire("gfNVK");
var $adFyB = parcelRequire("adFyB");
var $7CE69 = parcelRequire("7CE69");
var $6h2Sh = parcelRequire("6h2Sh");
var $jhZn5 = parcelRequire("jhZn5");
parcelRequire("4bmA3");
var $Nt5no = parcelRequire("Nt5no");

var $5NrAW = parcelRequire("5NrAW");
parcelRequire("iJePW");
var $24Gwi = parcelRequire("24Gwi");
var $8YPFv = parcelRequire("8YPFv");
var $iXC0o = parcelRequire("iXC0o");
var $7ATbl = parcelRequire("7ATbl");
var $5tDGo = parcelRequire("5tDGo");
var $amTjC = parcelRequire("amTjC");
var $1oTG0 = parcelRequire("1oTG0");
var $ssi5M = parcelRequire("ssi5M");
var $bzFNF = parcelRequire("bzFNF");
var $h3DqH = parcelRequire("h3DqH");
var $fPeql = parcelRequire("fPeql");
var $htgb2 = parcelRequire("htgb2");
var $aSfpS = parcelRequire("aSfpS");
const $34385ae3067380c3$var$_excluded = [
    "context"
], $34385ae3067380c3$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $34385ae3067380c3$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $7ATbl.deleteResourceState)(type, key));
                dispatch((0, $24Gwi.executeForDependents)(resource, (dependentResource)=>$34385ae3067380c3$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $7ATbl.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $kV77Q.default)(_getState, $34385ae3067380c3$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $5NrAW.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $g8vBZ.default)({}, prevSlice, changes, {
                expiresAt: (0, $ssi5M.getExpiresAt)(maxAge),
                accessedAt: (0, $amTjC.getAccessedAt)()
            });
            dispatch((0, $7ATbl.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $24Gwi.executeForDependents)(resource, (dependentResource)=>$34385ae3067380c3$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $7ATbl.getResourceState)(type, key));
            if (cached && (0, $bzFNF.shouldUseCache)(cached)) {
                if ((0, $bzFNF.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $h3DqH.setSsrDataPromise)(cached);
                    cached = (0, $ssi5M.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $amTjC.getAccessedAt)();
                dispatch((0, $7ATbl.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($34385ae3067380c3$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $7ATbl.getResourceState)(type, key)) || (0, $1oTG0.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $aSfpS.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $7ATbl.getPrefetchSlice)(type, key)) || (0, $8YPFv.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $24Gwi.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $7ATbl.setResourceState)(type, key, (0, $g8vBZ.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $amTjC.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $24Gwi.executeForDependents)(resource, (dependentResource)=>$34385ae3067380c3$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $fPeql.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $7ATbl.getResourceState)(type, key));
            const finalSlice = (0, $g8vBZ.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $amTjC.getAccessedAt)(),
                expiresAt: (0, $ssi5M.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $7ATbl.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $7ATbl.getPrefetchSlice)(type, key)) || (0, $8YPFv.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $24Gwi.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $7ATbl.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $24Gwi.executeForDependents)(resource, (dependentResource)=>$34385ae3067380c3$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $34385ae3067380c3$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $24Gwi.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $34385ae3067380c3$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $24Gwi.actionWithDependencies)(routerStoreContext.route.resources, resource, $34385ae3067380c3$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $24Gwi.actionWithDependencies)(routerStoreContext.route.resources, resource, $34385ae3067380c3$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $24Gwi.actionWithDependencies)(routerStoreContext.route.resources, resource, $34385ae3067380c3$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($34385ae3067380c3$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $7ATbl.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $7ATbl.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $Nt5no.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $24Gwi.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$34385ae3067380c3$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $24Gwi.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$34385ae3067380c3$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $g8vBZ.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $htgb2.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $kV77Q.default)(_ref, $34385ae3067380c3$var$_excluded2);
                const deserializedError = !error ? null : (0, $5tDGo.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $g8vBZ.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $htgb2.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $5tDGo.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $fPeql.TimeoutError) ? loading : false
                }))
};
const $34385ae3067380c3$export$94f50dade551bd01 = (0, $7CE69.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $34385ae3067380c3$export$e324594224ef24da,
    name: 'router-resources'
});
const $34385ae3067380c3$export$cc90fb9c37c5589d = (0, $adFyB.createContainer)($34385ae3067380c3$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $34385ae3067380c3$export$fee1a6213543bd78 = (0, $6h2Sh.createSubscriber)($34385ae3067380c3$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $5NrAW.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $34385ae3067380c3$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $jhZn5.defaultRegistry).getStore($34385ae3067380c3$export$94f50dade551bd01);
const $34385ae3067380c3$export$ac3608e0bb357c7 = (0, $gfNVK.createHook)($34385ae3067380c3$export$94f50dade551bd01, {
    selector: (0, $5NrAW.getSliceForResource)
});
const $34385ae3067380c3$export$98e41a62c9bef75e = (0, $gfNVK.createActionsHook)($34385ae3067380c3$export$94f50dade551bd01);
const $34385ae3067380c3$export$e59f52df235ac7b3 = (0, $gfNVK.createHook)($34385ae3067380c3$export$94f50dade551bd01, {
    selector: (0, $5NrAW.getResourceStoreContext)
});

});
parcelRegister("6h2Sh", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $49168f65f76e7e9e$export$48f338a7e080595c);

var $gfNVK = parcelRequire("gfNVK");
const $49168f65f76e7e9e$var$_excluded = [
    "children"
];
function $49168f65f76e7e9e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $49168f65f76e7e9e$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $49168f65f76e7e9e$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $gfNVK.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $49168f65f76e7e9e$var$_objectWithoutPropertiesLoose(_ref, $49168f65f76e7e9e$var$_excluded);
        const api = useStore($49168f65f76e7e9e$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("5NrAW", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $4386ef1626d1113c$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $4386ef1626d1113c$export$6a0b1779210de0ee);

var $g8vBZ = parcelRequire("g8vBZ");
parcelRequire("iJePW");
var $1oTG0 = parcelRequire("1oTG0");
const $4386ef1626d1113c$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $g8vBZ.default)({}, slice) : (0, $1oTG0.getDefaultStateSlice)();
};
const $4386ef1626d1113c$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("iJePW", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("amTjC")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("8YPFv")).createLoadingSlice);
$parcel$export(module.exports, "createResource", () => (parcelRequire("iXC0o")).createResource);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("24Gwi")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("24Gwi")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("24Gwi")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("24Gwi")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("ssi5M")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("ssi5M")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("1oTG0")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("cdQQR")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("aSfpS")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("7ATbl")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("7ATbl")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("7ATbl")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("7ATbl")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("7ATbl")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("5tDGo")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("5tDGo")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("bzFNF")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("bzFNF")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("h3DqH")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("fPeql")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("htgb2")).transformData);

var $amTjC = parcelRequire("amTjC");

var $8YPFv = parcelRequire("8YPFv");

var $iXC0o = parcelRequire("iXC0o");

var $24Gwi = parcelRequire("24Gwi");

var $ssi5M = parcelRequire("ssi5M");

var $fB80H = parcelRequire("fB80H");

var $1oTG0 = parcelRequire("1oTG0");

var $j9P87 = parcelRequire("j9P87");

var $cdQQR = parcelRequire("cdQQR");

var $aSfpS = parcelRequire("aSfpS");

var $7ATbl = parcelRequire("7ATbl");

var $fKD98 = parcelRequire("fKD98");

var $5tDGo = parcelRequire("5tDGo");

var $bzFNF = parcelRequire("bzFNF");

var $h3DqH = parcelRequire("h3DqH");

var $fPeql = parcelRequire("fPeql");

var $htgb2 = parcelRequire("htgb2");

});
parcelRegister("amTjC", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $78c6ddf3f9628d08$export$9ccb639b7a119f61);
const $78c6ddf3f9628d08$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("8YPFv", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $689c019add05bbf8$export$dc62515c8f0b52dd);

var $g8vBZ = parcelRequire("g8vBZ");

var $klPN1 = parcelRequire("klPN1");

var $ssi5M = parcelRequire("ssi5M");

var $fB80H = parcelRequire("fB80H");

var $fPeql = parcelRequire("fPeql");

var $2qqnZ = parcelRequire("2qqnZ");
function $689c019add05bbf8$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $g8vBZ.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $fB80H.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $fPeql.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $ssi5M.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $klPN1.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $ssi5M.getExpiresAt)((0, $2qqnZ.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("klPN1", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $ed0df129e516a25d$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $ed0df129e516a25d$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $ed0df129e516a25d$export$12c1dc38ea1692da);
const $ed0df129e516a25d$export$881d135f98d8d7d0 = 100;
const $ed0df129e516a25d$export$9ab5bdcb8a1d6c34 = false;
const $ed0df129e516a25d$export$12c1dc38ea1692da = 0;

});

parcelRegister("ssi5M", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $05588f9aef3fefe6$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $05588f9aef3fefe6$export$18d1d420fd588368);

var $g8vBZ = parcelRequire("g8vBZ");
const $05588f9aef3fefe6$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $05588f9aef3fefe6$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $g8vBZ.default)({}, slice, {
        expiresAt: $05588f9aef3fefe6$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("fB80H", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $b5b08661c6e525f1$export$58634b3a58ae66b7);
const $b5b08661c6e525f1$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("fPeql", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $b856ceba32629d17$export$66d311bf29d5c89c);
class $b856ceba32629d17$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("2qqnZ", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $1c427a281264fecc$export$37d3126be6549b13);
const $1c427a281264fecc$export$37d3126be6549b13 = 10000;

});


parcelRegister("iXC0o", function(module, exports) {
$parcel$export(module.exports, "createResource", () => $dcdb37c1c5b3a397$export$edd172c6c83c39cc);

var $klPN1 = parcelRequire("klPN1");
/**
 * Utility method to created async versions of getData functions
 */ const $dcdb37c1c5b3a397$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $dcdb37c1c5b3a397$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $dcdb37c1c5b3a397$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $klPN1.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $klPN1.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $klPN1.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("24Gwi", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $182cf0120f8b6325$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $182cf0120f8b6325$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $182cf0120f8b6325$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $182cf0120f8b6325$export$75915f81f2a6540a);

var $g8vBZ = parcelRequire("g8vBZ");

var $1oTG0 = parcelRequire("1oTG0");

var $7ATbl = parcelRequire("7ATbl");
var $182cf0120f8b6325$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $182cf0120f8b6325$var$fromEntries = ($182cf0120f8b6325$var$_Object$fromEntries = Object.fromEntries) != null ? $182cf0120f8b6325$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $182cf0120f8b6325$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $182cf0120f8b6325$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $182cf0120f8b6325$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($182cf0120f8b6325$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($182cf0120f8b6325$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($182cf0120f8b6325$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $182cf0120f8b6325$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($182cf0120f8b6325$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $182cf0120f8b6325$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$182cf0120f8b6325$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $182cf0120f8b6325$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($182cf0120f8b6325$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $182cf0120f8b6325$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($182cf0120f8b6325$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $182cf0120f8b6325$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($182cf0120f8b6325$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $182cf0120f8b6325$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $182cf0120f8b6325$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $182cf0120f8b6325$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $7ATbl.getResourceState)(dependencyType, key)) || (0, $1oTG0.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $7ATbl.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $g8vBZ.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("1oTG0", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $1053388a526ffc07$export$fa8e33c3301e2e94);

var $g8vBZ = parcelRequire("g8vBZ");

var $amTjC = parcelRequire("amTjC");

var $klPN1 = parcelRequire("klPN1");

var $ssi5M = parcelRequire("ssi5M");

var $cDdpj = parcelRequire("cDdpj");
const $1053388a526ffc07$export$fa8e33c3301e2e94 = ()=>(0, $g8vBZ.default)({}, (0, $cDdpj.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $ssi5M.getExpiresAt)((0, $klPN1.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $amTjC.getAccessedAt)()
    });

});
parcelRegister("cDdpj", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $932386f643ec3bbc$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $932386f643ec3bbc$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("7ATbl", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $5876b32da472fb92$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $5876b32da472fb92$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $5876b32da472fb92$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $5876b32da472fb92$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $5876b32da472fb92$export$d40f35dc5952864b);

var $kV77Q = parcelRequire("kV77Q");

var $g8vBZ = parcelRequire("g8vBZ");
function $5876b32da472fb92$var$_toPropertyKey(t) {
    var i = $5876b32da472fb92$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $5876b32da472fb92$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $5876b32da472fb92$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $5876b32da472fb92$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $g8vBZ.default)({}, prefetching, {
                [type]: (0, $g8vBZ.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $5876b32da472fb92$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($5876b32da472fb92$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $g8vBZ.default)({}, data, {
                [type]: (0, $g8vBZ.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $5876b32da472fb92$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $5876b32da472fb92$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $kV77Q.default)(data, [
            type
        ].map($5876b32da472fb92$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $kV77Q.default)(resourceForType, [
                key
            ].map($5876b32da472fb92$var$_toPropertyKey));
            setState({
                data: (0, $g8vBZ.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("j9P87", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $df2684e723903600$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $df2684e723903600$export$cd7fbe7e979df558);
const $df2684e723903600$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $df2684e723903600$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$df2684e723903600$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("cdQQR", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $8e5fb2252225d400$export$7cbbc763e2f3d65d);

var $j9P87 = parcelRequire("j9P87");

var $fKD98 = parcelRequire("fKD98");
const $8e5fb2252225d400$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $fKD98.routeHasResources)(nextRoute)) return [];
    if ((0, $fKD98.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $j9P87.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $j9P87.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("fKD98", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $b779848e668ef87a$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $b779848e668ef87a$export$221027ff1aa38f82);
const $b779848e668ef87a$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $b779848e668ef87a$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("aSfpS", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $7eaae7ea8637b954$export$89440b7623c2c75c);

var $7ATbl = parcelRequire("7ATbl");
const $7eaae7ea8637b954$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $7eaae7ea8637b954$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $7eaae7ea8637b954$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $7eaae7ea8637b954$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $7eaae7ea8637b954$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $7ATbl.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("5tDGo", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $3fce715a1eab9421$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $3fce715a1eab9421$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $3fce715a1eab9421$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $3fce715a1eab9421$var$NonError);
    }
}
const $3fce715a1eab9421$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $3fce715a1eab9421$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $3fce715a1eab9421$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $3fce715a1eab9421$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $3fce715a1eab9421$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $3fce715a1eab9421$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $3fce715a1eab9421$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $3fce715a1eab9421$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $3fce715a1eab9421$var$NonError(value);
};

});

parcelRegister("bzFNF", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $86d36339e6a74f6b$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $86d36339e6a74f6b$export$399de8c43d0ece3c);
const $86d36339e6a74f6b$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $86d36339e6a74f6b$var$isFresh = (resource)=>{
    if ($86d36339e6a74f6b$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $86d36339e6a74f6b$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($86d36339e6a74f6b$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("h3DqH", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $c6b14d5f40cd3bf9$export$2e4da1b414980956);

var $g8vBZ = parcelRequire("g8vBZ");
const $c6b14d5f40cd3bf9$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $g8vBZ.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("htgb2", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $cb81b1879010e958$export$3ceb62baab058c6b);
const $cb81b1879010e958$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("3HVrG", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $hMsRa = parcelRequire("hMsRa");
const $2b31f2bf77a9afd7$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $hMsRa.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(result));
};

});
parcelRegister("hMsRa", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $cf1d4da97fd9ceba$export$9f6abfd74295843b);

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");

var $gfNVK = parcelRequire("gfNVK");
parcelRequire("5lPCP");
var $giOHo = parcelRequire("giOHo");

var $4tXVt = parcelRequire("4tXVt");
const $cf1d4da97fd9ceba$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $4tXVt.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $giOHo.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $bSJIT.useMemo)(()=>(0, $gfNVK.createHook)((0, $giOHo.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $4tXVt.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $bSJIT.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $bSJIT.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $bSJIT.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $bSJIT.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $bSJIT.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $g8vBZ.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("eQ4kV", function(module, exports) {

var $4tXVt = parcelRequire("4tXVt");
const $acd9492651967d2f$export$dee7bf9fc0ff48c3 = (fn)=>(0, $4tXVt.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("7YYDZ", function(module, exports) {
const $5cfd2da8f0e412c5$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("53hm0", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $769be296d3c113e3$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getEventQueue", () => $769be296d3c113e3$export$584d8b0a0989eefd);
/**
 * Wrapper around AJS
 */ 
var $4ZMmh = parcelRequire("4ZMmh");

var $fuVmc = parcelRequire("fuVmc");
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $769be296d3c113e3$var$ajs = window.AJS;
const $769be296d3c113e3$export$c47913ca32a5c6f7 = (key)=>{
    if ($769be296d3c113e3$var$ajs && $769be296d3c113e3$var$ajs.Meta) return $769be296d3c113e3$var$ajs.Meta.get(key);
    /** When jsd-dw-portal-wrm-optimisations is on we fallback to a native version of getMeta that doesn't rely on AJS being loaded on the page via WRM */ const value = (0, $fuVmc.getMetaFromHTML)(key);
    return (0, $4ZMmh.isNil)(value) ? undefined : value;
};
const $769be296d3c113e3$export$584d8b0a0989eefd = ()=>{
    return $769be296d3c113e3$var$ajs === undefined ? undefined : $769be296d3c113e3$var$ajs.EventQueue;
};

});



parcelRegister("6JJ8C", function(module, exports) {
$parcel$export(module.exports, "devLog", () => $0b61a131f0ef3399$export$c45ebb6cef9d5b7b);

var $iW3CQ = parcelRequire("iW3CQ");
function $0b61a131f0ef3399$export$c45ebb6cef9d5b7b(message, ...optionalParams) {
    const env = (0, $iW3CQ.getEnv)();
    // eslint-disable-next-line no-console
    env.environment !== (0, $iW3CQ.EnvType).PROD && console.log(message, ...optionalParams);
}

});

parcelRegister("eKcQp", function(module, exports) {
$parcel$export(module.exports, "getApplicationType", () => $bdcf06d423735b6e$export$4f7ec84576d049fa);

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
const $bdcf06d423735b6e$export$4f7ec84576d049fa = ()=>{
    return {
        applicationType: (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) ? 'jcs' : 'jsm'
    };
};

});

parcelRegister("5B7Ib", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterAnalyticsData", () => $17a8d5db7273c74d$export$bd448d1bc798d83d);

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");
const $17a8d5db7273c74d$export$bd448d1bc798d83d = ()=>{
    if ((0, $hCnLH.isHelpCentersManagement)()) return undefined;
    const { edition: edition } = (0, $iW3CQ.getEnv)();
    return {
        helpCenterType: (0, $hCnLH.isAdvancedHelpCenter)() ? 'custom' : 'default',
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        ...edition ? {
            edition: edition
        } : {},
        ...(0, $lFpPv.isSendRawHelpCenterTypeInAnalyticsEnabled)() ? {
            helpCenterCategory: (0, $iW3CQ.getEnv)().helpCenterType
        } : {}
    };
};

});


parcelRegister("jfKi6", function(module, exports) {
$parcel$export(module.exports, "sentryQueue", () => $650eebc3f25d85c3$export$4bff35a64b482759);

var $a6ENB = parcelRequire("a6ENB");
const $650eebc3f25d85c3$export$4bff35a64b482759 = {
    pushError (err) {
        if ((0, $a6ENB.isSentryEnabled)()) {
            if (!window.JSM_EXCEPTION_QUEUE) window.JSM_EXCEPTION_QUEUE = [
                err
            ];
            else window.JSM_EXCEPTION_QUEUE.push(err);
        }
    },
    flushErrors () {
        var _window$JSM_EXCEPTION;
        (_window$JSM_EXCEPTION = window.JSM_EXCEPTION_QUEUE) === null || _window$JSM_EXCEPTION === void 0 || _window$JSM_EXCEPTION.forEach((err)=>(0, $a6ENB.reportError)(err));
        delete window.JSM_EXCEPTION_QUEUE;
    }
};

});
parcelRegister("a6ENB", function(module, exports) {
$parcel$export(module.exports, "isSentryEnabled", () => $54ddeafc152abed7$export$ec3dcf0ab235344b);
$parcel$export(module.exports, "reportError", () => $54ddeafc152abed7$export$b33b857ad1d9900e);

var $kOZtN = parcelRequire("kOZtN");

var $3ukjC = parcelRequire("3ukjC");

var $4ZMmh = parcelRequire("4ZMmh");

var $iW3CQ = parcelRequire("iW3CQ");
const $54ddeafc152abed7$export$ec3dcf0ab235344b = ()=>{
    const env = (0, $iW3CQ.getEnv)();
    if (env.environment === (0, $iW3CQ.EnvType).STAGING) return true;
    return env.environment === (0, $iW3CQ.EnvType).PROD;
};
const $54ddeafc152abed7$export$b33b857ad1d9900e = (exception, additionalErrorData)=>{
    // eslint-disable-next-line no-console
    console.error('reportError', exception, additionalErrorData);
    if ($54ddeafc152abed7$export$ec3dcf0ab235344b()) {
        if (additionalErrorData && (0, $4ZMmh.isNil)(additionalErrorData.message) && exception instanceof Error) $kOZtN.withScope((scope)=>{
            const { teamName: teamName, errorBoundaryId: errorBoundaryId, errorBoundaryPackageName: packageName } = additionalErrorData;
            if (errorBoundaryId) scope.setTag('errorBoundaryId', errorBoundaryId);
            if (packageName) scope.setTag('packageName', packageName);
            if (teamName) scope.setTag('teamName', teamName);
            const event = (0, $3ukjC.eventFromUnknownInput)(exception);
            $kOZtN.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        });
        else {
            const event = (0, $3ukjC.eventFromUnknownInput)(exception);
            $kOZtN.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        }
    }
};

});
parcelRegister("kOZtN", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $f2882abe840907a5$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $f2882abe840907a5$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $f2882abe840907a5$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $f2882abe840907a5$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $f2882abe840907a5$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $f2882abe840907a5$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $f2882abe840907a5$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $f2882abe840907a5$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $f2882abe840907a5$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $f2882abe840907a5$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $f2882abe840907a5$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $f2882abe840907a5$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $f2882abe840907a5$export$e262da7ae6480481);

var $3Cq0D = parcelRequire("3Cq0D");

var $iSbcz = parcelRequire("iSbcz");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f2882abe840907a5$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $iSbcz.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $3Cq0D.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $f2882abe840907a5$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $f2882abe840907a5$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $f2882abe840907a5$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $f2882abe840907a5$var$callOnHub('captureMessage', message, level, (0, $3Cq0D.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $f2882abe840907a5$export$1462b974fdcf6ba2(event) {
    return $f2882abe840907a5$var$callOnHub('captureEvent', event);
}
function $f2882abe840907a5$export$99d44f04437e9cb8(callback) {
    $f2882abe840907a5$var$callOnHub('configureScope', callback);
}
function $f2882abe840907a5$export$efda9a273d7a036d(breadcrumb) {
    $f2882abe840907a5$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $f2882abe840907a5$export$2f04de43fe27971a(name, context) {
    $f2882abe840907a5$var$callOnHub('setContext', name, context);
}
function $f2882abe840907a5$export$bb4922da0dd51b92(extras) {
    $f2882abe840907a5$var$callOnHub('setExtras', extras);
}
function $f2882abe840907a5$export$74a8fb34822092e6(tags) {
    $f2882abe840907a5$var$callOnHub('setTags', tags);
}
function $f2882abe840907a5$export$8e8e7789d42ed61d(key, extra) {
    $f2882abe840907a5$var$callOnHub('setExtra', key, extra);
}
function $f2882abe840907a5$export$a37d07ee78eb4569(key, value) {
    $f2882abe840907a5$var$callOnHub('setTag', key, value);
}
function $f2882abe840907a5$export$8b6bb3dd62a01be2(user) {
    $f2882abe840907a5$var$callOnHub('setUser', user);
}
function $f2882abe840907a5$export$ec58d9285c204497(callback) {
    $f2882abe840907a5$var$callOnHub('withScope', callback);
}
function $f2882abe840907a5$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $f2882abe840907a5$var$callOnHub.apply(void 0, (0, $3Cq0D.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $f2882abe840907a5$export$e262da7ae6480481(context, customSamplingContext) {
    return $f2882abe840907a5$var$callOnHub('startTransaction', (0, $3Cq0D.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("3Cq0D", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $2a29189a5553343e$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $2a29189a5553343e$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $2a29189a5553343e$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $2a29189a5553343e$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $2a29189a5553343e$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $2a29189a5553343e$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $2a29189a5553343e$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $2a29189a5553343e$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $2a29189a5553343e$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $2a29189a5553343e$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $2a29189a5553343e$export$1216008129fb82ed);
$parcel$export(module.exports, "__importDefault", () => $2a29189a5553343e$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $2a29189a5553343e$var$extendStatics = function(d, b) {
    $2a29189a5553343e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2a29189a5553343e$var$extendStatics(d, b);
};
function $2a29189a5553343e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2a29189a5553343e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2a29189a5553343e$export$18ce0697a983be9b = function() {
    $2a29189a5553343e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a29189a5553343e$export$18ce0697a983be9b.apply(this, arguments);
};
function $2a29189a5553343e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2a29189a5553343e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2a29189a5553343e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2a29189a5553343e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2a29189a5553343e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2a29189a5553343e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2a29189a5553343e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2a29189a5553343e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2a29189a5553343e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2a29189a5553343e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2a29189a5553343e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2a29189a5553343e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2a29189a5553343e$export$45d3717a4c69092e(o, m, p);
}
function $2a29189a5553343e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2a29189a5553343e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2a29189a5553343e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2a29189a5553343e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2a29189a5553343e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2a29189a5553343e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2a29189a5553343e$export$10c90e4f7922046c(v) {
    return this instanceof $2a29189a5553343e$export$10c90e4f7922046c ? (this.v = v, this) : new $2a29189a5553343e$export$10c90e4f7922046c(v);
}
function $2a29189a5553343e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2a29189a5553343e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2a29189a5553343e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2a29189a5553343e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2a29189a5553343e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2a29189a5553343e$export$19a8beecd37a4c45 === "function" ? $2a29189a5553343e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2a29189a5553343e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2a29189a5553343e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $2a29189a5553343e$var$ownKeys = function(o) {
    $2a29189a5553343e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $2a29189a5553343e$var$ownKeys(o);
};
function $2a29189a5553343e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $2a29189a5553343e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $2a29189a5553343e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $2a29189a5553343e$var$__setModuleDefault(result, mod);
    return result;
}
function $2a29189a5553343e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2a29189a5553343e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2a29189a5553343e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2a29189a5553343e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2a29189a5553343e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2a29189a5553343e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2a29189a5553343e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2a29189a5553343e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $2a29189a5553343e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $2a29189a5553343e$export$2e2bcd8739ae039 = {
    __extends: $2a29189a5553343e$export$a8ba968b8961cb8a,
    __assign: $2a29189a5553343e$export$18ce0697a983be9b,
    __rest: $2a29189a5553343e$export$3c9a16f847548506,
    __decorate: $2a29189a5553343e$export$29e00dfd3077644b,
    __param: $2a29189a5553343e$export$d5ad3fd78186038f,
    __esDecorate: $2a29189a5553343e$export$3a84e1ae4e97e9b0,
    __runInitializers: $2a29189a5553343e$export$d831c04e792af3d,
    __propKey: $2a29189a5553343e$export$6a2a36740a146cb8,
    __setFunctionName: $2a29189a5553343e$export$d1a06452d3489bc7,
    __metadata: $2a29189a5553343e$export$f1db080c865becb9,
    __awaiter: $2a29189a5553343e$export$1050f835b63b671e,
    __generator: $2a29189a5553343e$export$67ebef60e6f28a6,
    __createBinding: $2a29189a5553343e$export$45d3717a4c69092e,
    __exportStar: $2a29189a5553343e$export$f33643c0debef087,
    __values: $2a29189a5553343e$export$19a8beecd37a4c45,
    __read: $2a29189a5553343e$export$8d051b38c9118094,
    __spread: $2a29189a5553343e$export$afc72e2116322959,
    __spreadArrays: $2a29189a5553343e$export$6388937ca91ccae8,
    __spreadArray: $2a29189a5553343e$export$1216008129fb82ed,
    __await: $2a29189a5553343e$export$10c90e4f7922046c,
    __asyncGenerator: $2a29189a5553343e$export$e427f37a30a4de9b,
    __asyncDelegator: $2a29189a5553343e$export$bbd80228419bb833,
    __asyncValues: $2a29189a5553343e$export$e3b29a3d6162315f,
    __makeTemplateObject: $2a29189a5553343e$export$4fb47efe1390b86f,
    __importStar: $2a29189a5553343e$export$c21735bcef00d192,
    __importDefault: $2a29189a5553343e$export$da59b14a69baef04,
    __classPrivateFieldGet: $2a29189a5553343e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2a29189a5553343e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2a29189a5553343e$export$81fdc39f203e4e04,
    __addDisposableResource: $2a29189a5553343e$export$88ac25d8e944e405,
    __disposeResources: $2a29189a5553343e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $2a29189a5553343e$export$889dfb5d17574b0b
};

});

parcelRegister("iSbcz", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $dbd5f592cb120f38$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $dbd5f592cb120f38$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $dbd5f592cb120f38$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $dbd5f592cb120f38$export$a07cdf6544bbd7c);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("coyZw");
var $cFpBE = parcelRequire("cFpBE");
var $3Y8kR = parcelRequire("3Y8kR");
var $i9h6J = parcelRequire("i9h6J");
var $1422b = parcelRequire("1422b");
var $gsN1G = parcelRequire("gsN1G");

var $iNbNC = parcelRequire("iNbNC");

var $eEUgk = parcelRequire("eEUgk");

var $d5Pn9 = parcelRequire("d5Pn9");
var $dbd5f592cb120f38$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $dbd5f592cb120f38$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $dbd5f592cb120f38$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $eEUgk.Scope)();
        if (_version === void 0) _version = $dbd5f592cb120f38$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $eEUgk.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $gsN1G.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $gsN1G.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $gsN1G.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $dbd5f592cb120f38$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $3Y8kR.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $3Cq0D.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $cFpBE.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $dbd5f592cb120f38$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $dbd5f592cb120f38$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $iNbNC.IS_DEBUG_BUILD) && (0, $cFpBE.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $i9h6J.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $d5Pn9.Session)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $3Cq0D.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $dbd5f592cb120f38$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $iNbNC.IS_DEBUG_BUILD) && (0, $cFpBE.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $dbd5f592cb120f38$export$19eade501500c6c1() {
    var carrier = (0, $i9h6J.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $dbd5f592cb120f38$export$4188a14ad302d1bc(hub) {
    var registry = $dbd5f592cb120f38$export$19eade501500c6c1();
    var oldHub = $dbd5f592cb120f38$export$bfa8a924a84a76b7(registry);
    $dbd5f592cb120f38$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $dbd5f592cb120f38$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $dbd5f592cb120f38$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$dbd5f592cb120f38$var$hasHubOnCarrier(registry) || $dbd5f592cb120f38$export$bfa8a924a84a76b7(registry).isOlderThan($dbd5f592cb120f38$export$24a86ef7798177e4)) $dbd5f592cb120f38$export$849f05434e95d2f2(registry, new $dbd5f592cb120f38$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $1422b.isNodeEnv)()) return $dbd5f592cb120f38$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $dbd5f592cb120f38$export$bfa8a924a84a76b7(registry);
}
function $dbd5f592cb120f38$export$1c4d656130202699() {
    (0, $iNbNC.IS_DEBUG_BUILD) && (0, $cFpBE.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $dbd5f592cb120f38$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $dbd5f592cb120f38$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $dbd5f592cb120f38$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $dbd5f592cb120f38$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$dbd5f592cb120f38$var$hasHubOnCarrier(activeDomain) || $dbd5f592cb120f38$export$bfa8a924a84a76b7(activeDomain).isOlderThan($dbd5f592cb120f38$export$24a86ef7798177e4)) {
            var registryHubTopStack = $dbd5f592cb120f38$export$bfa8a924a84a76b7(registry).getStackTop();
            $dbd5f592cb120f38$export$849f05434e95d2f2(activeDomain, new $dbd5f592cb120f38$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $eEUgk.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $dbd5f592cb120f38$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $dbd5f592cb120f38$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $dbd5f592cb120f38$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $dbd5f592cb120f38$export$bfa8a924a84a76b7(carrier) {
    return (0, $i9h6J.getGlobalSingleton)('hub', function() {
        return new $dbd5f592cb120f38$export$8c41bb232f1008b1();
    }, carrier);
}
function $dbd5f592cb120f38$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("coyZw", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("i9h6J")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("i9h6J")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("4PMWs")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("4PMWs")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("cFpBE")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("cFpBE")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("gsN1G")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("ivJ4n")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("lQrZd")).SyncPromise);





parcelRequire("i9h6J");

parcelRequire("4PMWs");
parcelRequire("cFpBE");

parcelRequire("gsN1G");

var $1422b = parcelRequire("1422b");

parcelRequire("ivJ4n");







parcelRequire("lQrZd");

var $3Y8kR = parcelRequire("3Y8kR");





$parcel$exportWildcard(module.exports, $1422b);
$parcel$exportWildcard(module.exports, $3Y8kR);

});
parcelRegister("i9h6J", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $d36656798750602a$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $d36656798750602a$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $1422b = parcelRequire("1422b");
var $d36656798750602a$var$fallbackGlobalObject = {};
function $d36656798750602a$export$256479dc0cea61c4() {
    return (0, $1422b.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $d36656798750602a$var$fallbackGlobalObject;
}
function $d36656798750602a$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $d36656798750602a$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("1422b", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $h4SDo = parcelRequire("h4SDo");

var $4eGW1 = parcelRequire("4eGW1");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $h4SDo.isBrowserBundle)() && Object.prototype.toString.call(typeof $4eGW1 !== 'undefined' ? $4eGW1 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("h4SDo", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $c6ed30a8bb1d06f9$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $c6ed30a8bb1d06f9$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("4PMWs", function(module, exports) {
$parcel$export(module.exports, "isError", () => $3851e3b0792bc87a$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $3851e3b0792bc87a$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $3851e3b0792bc87a$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $3851e3b0792bc87a$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $3851e3b0792bc87a$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $3851e3b0792bc87a$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $3851e3b0792bc87a$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $3851e3b0792bc87a$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $3851e3b0792bc87a$export$f5b060c2914b97c8);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $3851e3b0792bc87a$var$objectToString = Object.prototype.toString;
function $3851e3b0792bc87a$export$e6127cc7fe7395c3(wat) {
    switch($3851e3b0792bc87a$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $3851e3b0792bc87a$export$49034edbe6b62415(wat, Error);
    }
}
function $3851e3b0792bc87a$var$isBuiltin(wat, ty) {
    return $3851e3b0792bc87a$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $3851e3b0792bc87a$export$9f9636d330b71954(wat) {
    return $3851e3b0792bc87a$var$isBuiltin(wat, 'ErrorEvent');
}
function $3851e3b0792bc87a$export$ef9e2056653f0c8e(wat) {
    return $3851e3b0792bc87a$var$isBuiltin(wat, 'DOMError');
}
function $3851e3b0792bc87a$export$12e869b2a583f783(wat) {
    return $3851e3b0792bc87a$var$isBuiltin(wat, 'DOMException');
}
function $3851e3b0792bc87a$export$844ec244b1367d54(wat) {
    return $3851e3b0792bc87a$var$isBuiltin(wat, 'String');
}
function $3851e3b0792bc87a$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $3851e3b0792bc87a$export$53b83ca8eaab0383(wat) {
    return $3851e3b0792bc87a$var$isBuiltin(wat, 'Object');
}
function $3851e3b0792bc87a$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $3851e3b0792bc87a$export$49034edbe6b62415(wat, Event);
}
function $3851e3b0792bc87a$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $3851e3b0792bc87a$export$49034edbe6b62415(wat, Element);
}
function $3851e3b0792bc87a$export$49841c62b9eff15(wat) {
    return $3851e3b0792bc87a$var$isBuiltin(wat, 'RegExp');
}
function $3851e3b0792bc87a$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $3851e3b0792bc87a$export$bc2894c7158efbac(wat) {
    return $3851e3b0792bc87a$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $3851e3b0792bc87a$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $3851e3b0792bc87a$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("cFpBE", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", () => $938d2d3eae0498a6$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $938d2d3eae0498a6$export$af88d00dbe7f521);

var $3Cq0D = parcelRequire("3Cq0D");

var $ii2ob = parcelRequire("ii2ob");

var $i9h6J = parcelRequire("i9h6J");
// TODO: Implement different loggers for different environments
var $938d2d3eae0498a6$var$global = (0, $i9h6J.getGlobalObject)();
/** Prefix for logging strings */ var $938d2d3eae0498a6$var$PREFIX = 'Sentry Logger ';
var $938d2d3eae0498a6$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $938d2d3eae0498a6$export$cda52e2a8927a2ca(callback) {
    var global = (0, $i9h6J.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $938d2d3eae0498a6$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $938d2d3eae0498a6$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $ii2ob.IS_DEBUG_BUILD) $938d2d3eae0498a6$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $938d2d3eae0498a6$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $938d2d3eae0498a6$var$global.console)[name].apply(_a, (0, $3Cq0D.__spread)([
                    $938d2d3eae0498a6$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $938d2d3eae0498a6$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $938d2d3eae0498a6$export$af88d00dbe7f521;
if (0, $ii2ob.IS_DEBUG_BUILD) $938d2d3eae0498a6$export$af88d00dbe7f521 = (0, $i9h6J.getGlobalSingleton)('logger', $938d2d3eae0498a6$var$makeLogger);
else $938d2d3eae0498a6$export$af88d00dbe7f521 = $938d2d3eae0498a6$var$makeLogger();

});
parcelRegister("ii2ob", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $d50bc2db7b7525b8$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d50bc2db7b7525b8$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("gsN1G", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $bfc54a71b72666b6$export$19f53698e68b2496);

var $3Cq0D = parcelRequire("3Cq0D");

var $i9h6J = parcelRequire("i9h6J");

var $ivJ4n = parcelRequire("ivJ4n");

var $jDBHl = parcelRequire("jDBHl");
function $bfc54a71b72666b6$export$19f53698e68b2496() {
    var global = (0, $i9h6J.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $bfc54a71b72666b6$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $bfc54a71b72666b6$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $bfc54a71b72666b6$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $bfc54a71b72666b6$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $bfc54a71b72666b6$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $bfc54a71b72666b6$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $bfc54a71b72666b6$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $bfc54a71b72666b6$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $bfc54a71b72666b6$export$d364f2020ab30578(input) {
    var match = input.match($bfc54a71b72666b6$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $bfc54a71b72666b6$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $jDBHl.snipLine)(line, 0);
    });
    frame.context_line = (0, $jDBHl.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $jDBHl.snipLine)(line, 0);
    });
}
function $bfc54a71b72666b6$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $bfc54a71b72666b6$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $ivJ4n.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("ivJ4n", function(module, exports) {
$parcel$export(module.exports, "addNonEnumerableProperty", () => $d79e151dd993bfb4$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $d79e151dd993bfb4$export$d25f2688db1bb433);

var $3Cq0D = parcelRequire("3Cq0D");

var $2KsID = parcelRequire("2KsID");

var $4PMWs = parcelRequire("4PMWs");

var $jDBHl = parcelRequire("jDBHl");
function $d79e151dd993bfb4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $d79e151dd993bfb4$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $d79e151dd993bfb4$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $d79e151dd993bfb4$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $d79e151dd993bfb4$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $d79e151dd993bfb4$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $d79e151dd993bfb4$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $d79e151dd993bfb4$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $4PMWs.isError)(value)) newObj = (0, $3Cq0D.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $d79e151dd993bfb4$var$getOwnProperties(value));
    else if ((0, $4PMWs.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3Cq0D.__assign)({
            type: event_1.type,
            target: $d79e151dd993bfb4$var$serializeEventTarget(event_1.target),
            currentTarget: $d79e151dd993bfb4$var$serializeEventTarget(event_1.currentTarget)
        }, $d79e151dd993bfb4$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $4PMWs.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $d79e151dd993bfb4$var$serializeEventTarget(target) {
    try {
        return (0, $4PMWs.isElement)(target) ? (0, $2KsID.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d79e151dd993bfb4$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $d79e151dd993bfb4$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($d79e151dd993bfb4$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jDBHl.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jDBHl.truncate)(serialized, maxLength);
    }
    return '';
}
function $d79e151dd993bfb4$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $4PMWs.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3Cq0D.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $d79e151dd993bfb4$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($d79e151dd993bfb4$export$d25f2688db1bb433);
    return val;
}
function $d79e151dd993bfb4$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $4PMWs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("2KsID", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $2006279d107933b5$export$5647df6b7814ac86);

var $i9h6J = parcelRequire("i9h6J");

var $4PMWs = parcelRequire("4PMWs");
function $2006279d107933b5$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2006279d107933b5$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2006279d107933b5$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $4PMWs.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $2006279d107933b5$export$1cfafeee2987818b() {
    var global = (0, $i9h6J.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("jDBHl", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $e4bee6e4c9872b4e$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e4bee6e4c9872b4e$export$4215662d762d6f9d);

var $4PMWs = parcelRequire("4PMWs");
function $e4bee6e4c9872b4e$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $e4bee6e4c9872b4e$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $e4bee6e4c9872b4e$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $e4bee6e4c9872b4e$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $4PMWs.isString)(value)) return false;
    if ((0, $4PMWs.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $e4bee6e4c9872b4e$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("lQrZd", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $fe7429d13b24e8a3$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $4PMWs = parcelRequire("4PMWs");
function $fe7429d13b24e8a3$export$1fda8aa4d135f8aa(value) {
    return new $fe7429d13b24e8a3$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $fe7429d13b24e8a3$export$78e43115b553f358(reason) {
    return new $fe7429d13b24e8a3$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $fe7429d13b24e8a3$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $4PMWs.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("3Y8kR", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $i9h6J = parcelRequire("i9h6J");

var $1422b = parcelRequire("1422b");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $i9h6J.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $1422b.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $1422b.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $i9h6J.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("iNbNC", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $dae5f4b3ad15d450$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $dae5f4b3ad15d450$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("eEUgk", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $02c10a17666bac49$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $02c10a17666bac49$export$8e4e25f54d456511);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("coyZw");
var $3Y8kR = parcelRequire("3Y8kR");
var $i9h6J = parcelRequire("i9h6J");
var $4PMWs = parcelRequire("4PMWs");
var $lQrZd = parcelRequire("lQrZd");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $02c10a17666bac49$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $02c10a17666bac49$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $3Cq0D.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $3Cq0D.__assign)({}, scope._tags);
            newScope._extra = (0, $3Cq0D.__assign)({}, scope._extra);
            newScope._contexts = (0, $3Cq0D.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $3Cq0D.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $4PMWs.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $02c10a17666bac49$var$MAX_BREADCRUMBS) : $02c10a17666bac49$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $3Cq0D.__assign)({
            timestamp: (0, $3Y8kR.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $3Cq0D.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $3Cq0D.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $3Cq0D.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $3Cq0D.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $3Cq0D.__spread)($02c10a17666bac49$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $lQrZd.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $3Cq0D.__assign)({}, event), hint);
                if ((0, $4PMWs.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $02c10a17666bac49$var$getGlobalEventProcessors() {
    return (0, $i9h6J.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $02c10a17666bac49$export$8e4e25f54d456511(callback) {
    $02c10a17666bac49$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("d5Pn9", function(module, exports) {
$parcel$export(module.exports, "Session", () => $9883977d6247650a$export$1fb4852a55678982);
parcelRequire("coyZw");
var $ivJ4n = parcelRequire("ivJ4n");
var $3Y8kR = parcelRequire("3Y8kR");
var $gsN1G = parcelRequire("gsN1G");
/**
 * @inheritdoc
 */ var $9883977d6247650a$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $gsN1G.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $3Y8kR.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $3Y8kR.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $gsN1G.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $ivJ4n.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("3ukjC", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Cq0D = parcelRequire("3Cq0D");

var $icZGb = parcelRequire("icZGb");
parcelRequire("ea3Tu");
var $fwPq8 = parcelRequire("fwPq8");
var $fNUki = parcelRequire("fNUki");
var $85DVE = parcelRequire("85DVE");
var $cnzqx = parcelRequire("cnzqx");
var $g8CZ7 = parcelRequire("g8CZ7");
var $gYYZR = parcelRequire("gYYZR");

var $fwEJ0 = parcelRequire("fwEJ0");
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */ function $28a3eea3c451305d$var$exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $28a3eea3c451305d$var$parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: $28a3eea3c451305d$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
module.exports.exceptionFromError = $28a3eea3c451305d$var$exceptionFromError;
/**
 * @hidden
 */ function $28a3eea3c451305d$var$eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: $cnzqx.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + $85DVE.extractExceptionKeysForMessage(exception)
                }
            ]
        },
        extra: {
            __serialized__: $g8CZ7.normalizeToSize(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $28a3eea3c451305d$var$parseStackFrames(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
module.exports.eventFromPlainObject = $28a3eea3c451305d$var$eventFromPlainObject;
/**
 * @hidden
 */ function $28a3eea3c451305d$var$eventFromError(ex) {
    return {
        exception: {
            values: [
                $28a3eea3c451305d$var$exceptionFromError(ex)
            ]
        }
    };
}
module.exports.eventFromError = $28a3eea3c451305d$var$eventFromError;
/** Parses stack frames from an error */ function $28a3eea3c451305d$var$parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $28a3eea3c451305d$var$getPopSize(ex);
    try {
        return $fNUki.createStackParser($fwEJ0.opera10StackParser, $fwEJ0.opera11StackParser, $fwEJ0.chromeStackParser, $fwEJ0.winjsStackParser, $fwEJ0.geckoStackParser)(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
module.exports.parseStackFrames = $28a3eea3c451305d$var$parseStackFrames;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $28a3eea3c451305d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $28a3eea3c451305d$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($28a3eea3c451305d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $28a3eea3c451305d$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $28a3eea3c451305d$var$eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $28a3eea3c451305d$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    $fwPq8.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = $icZGb.Severity.Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $gYYZR.resolvedSyncPromise(event);
}
module.exports.eventFromException = $28a3eea3c451305d$var$eventFromException;
/**
 * Builds and Event from a Message
 * @hidden
 */ function $28a3eea3c451305d$var$eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) level = $icZGb.Severity.Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $28a3eea3c451305d$var$eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $gYYZR.resolvedSyncPromise(event);
}
module.exports.eventFromMessage = $28a3eea3c451305d$var$eventFromMessage;
/**
 * @hidden
 */ function $28a3eea3c451305d$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ($cnzqx.isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $28a3eea3c451305d$var$eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ($cnzqx.isDOMError(exception) || $cnzqx.isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $28a3eea3c451305d$var$eventFromError(exception);
        else {
            var name_1 = domException.name || ($cnzqx.isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $28a3eea3c451305d$var$eventFromString(message, syntheticException, attachStacktrace);
            $fwPq8.addExceptionTypeValue(event, message);
        }
        if ('code' in domException) event.tags = $3Cq0D.__assign($3Cq0D.__assign({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ($cnzqx.isError(exception)) // we have a real Error object, do nothing
    return $28a3eea3c451305d$var$eventFromError(exception);
    if ($cnzqx.isPlainObject(exception) || $cnzqx.isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $28a3eea3c451305d$var$eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        $fwPq8.addExceptionMechanism(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $28a3eea3c451305d$var$eventFromString(exception, syntheticException, attachStacktrace);
    $fwPq8.addExceptionTypeValue(event, "" + exception, undefined);
    $fwPq8.addExceptionMechanism(event, {
        synthetic: true
    });
    return event;
}
module.exports.eventFromUnknownInput = $28a3eea3c451305d$var$eventFromUnknownInput;
/**
 * @hidden
 */ function $28a3eea3c451305d$var$eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $28a3eea3c451305d$var$parseStackFrames(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}
module.exports.eventFromString = $28a3eea3c451305d$var$eventFromString;

});
parcelRegister("icZGb", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $d41931343f4e6ece$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $d41931343f4e6ece$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($d41931343f4e6ece$export$918a9776c0a3cf27 || ($d41931343f4e6ece$export$918a9776c0a3cf27 = {}));
var $d41931343f4e6ece$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("ea3Tu", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("1UAf4")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("kcI9y")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("kcI9y")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("3lcRq")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("3lcRq")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("7yugL")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("k9z5g")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("jXpOk")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("cnzqx")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("cnzqx")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("cnzqx")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("cnzqx")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("cnzqx")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("cnzqx")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("cnzqx")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("cnzqx")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("cnzqx")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("cnzqx")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("4vHb7")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("fwPq8")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("fwPq8")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("fwPq8")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("fwPq8")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("fwPq8")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("fwPq8")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("g8CZ7")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("g8CZ7")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("85DVE")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("85DVE")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("85DVE")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("85DVE")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("85DVE")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("85DVE")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("4Habf")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("aRGS2")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("fNUki")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("fNUki")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("dVCfU")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("hzPhA")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("hzPhA")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("hzPhA")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("1vLPF")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("1vLPF")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("1vLPF")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("gYYZR")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("gYYZR")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("gYYZR")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("cxyLF")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("cxyLF")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("cxyLF")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("5oiSX")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("22R6W")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("22R6W")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("22R6W")).updateRateLimits);
parcelRequire("1UAf4");
parcelRequire("kcI9y");
parcelRequire("3lcRq");

parcelRequire("7yugL");
parcelRequire("k9z5g");
parcelRequire("jXpOk");
parcelRequire("cnzqx");
parcelRequire("4vHb7");

parcelRequire("fwPq8");

var $2OeAs = parcelRequire("2OeAs");
parcelRequire("g8CZ7");
parcelRequire("85DVE");

parcelRequire("4Habf");
parcelRequire("aRGS2");
parcelRequire("fNUki");
parcelRequire("dVCfU");
parcelRequire("hzPhA");
parcelRequire("1vLPF");
parcelRequire("gYYZR");

var $9Xxtl = parcelRequire("9Xxtl");


parcelRequire("cxyLF");
parcelRequire("5oiSX");
parcelRequire("22R6W");
$parcel$exportWildcard(module.exports, $2OeAs);
$parcel$exportWildcard(module.exports, $9Xxtl);

});
parcelRegister("1UAf4", function(module, exports) {
$parcel$export(module.exports, "forget", () => $1647225778824bec$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1647225778824bec$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("kcI9y", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $eb572d7fabb43de8$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $eb572d7fabb43de8$export$1cfafeee2987818b);

var $k9z5g = parcelRequire("k9z5g");

var $cnzqx = parcelRequire("cnzqx");
function $eb572d7fabb43de8$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $eb572d7fabb43de8$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $eb572d7fabb43de8$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $cnzqx.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $eb572d7fabb43de8$export$1cfafeee2987818b() {
    var global = (0, $k9z5g.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("k9z5g", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $eabfdcd4d1c6a1c6$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $eabfdcd4d1c6a1c6$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $2OeAs = parcelRequire("2OeAs");
var $eabfdcd4d1c6a1c6$var$fallbackGlobalObject = {};
function $eabfdcd4d1c6a1c6$export$256479dc0cea61c4() {
    return (0, $2OeAs.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $eabfdcd4d1c6a1c6$var$fallbackGlobalObject;
}
function $eabfdcd4d1c6a1c6$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $eabfdcd4d1c6a1c6$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("2OeAs", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $dCHcn = parcelRequire("dCHcn");

var $4eGW1 = parcelRequire("4eGW1");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $dCHcn.isBrowserBundle)() && Object.prototype.toString.call(typeof $4eGW1 !== 'undefined' ? $4eGW1 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("dCHcn", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $9eb0554b94e30915$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9eb0554b94e30915$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("cnzqx", function(module, exports) {
$parcel$export(module.exports, "isError", () => $90331d182ad56f6d$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $90331d182ad56f6d$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $90331d182ad56f6d$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $90331d182ad56f6d$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $90331d182ad56f6d$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $90331d182ad56f6d$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $90331d182ad56f6d$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $90331d182ad56f6d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $90331d182ad56f6d$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $90331d182ad56f6d$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $90331d182ad56f6d$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $90331d182ad56f6d$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $90331d182ad56f6d$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $90331d182ad56f6d$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $90331d182ad56f6d$var$objectToString = Object.prototype.toString;
function $90331d182ad56f6d$export$e6127cc7fe7395c3(wat) {
    switch($90331d182ad56f6d$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $90331d182ad56f6d$export$49034edbe6b62415(wat, Error);
    }
}
function $90331d182ad56f6d$var$isBuiltin(wat, ty) {
    return $90331d182ad56f6d$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $90331d182ad56f6d$export$9f9636d330b71954(wat) {
    return $90331d182ad56f6d$var$isBuiltin(wat, 'ErrorEvent');
}
function $90331d182ad56f6d$export$ef9e2056653f0c8e(wat) {
    return $90331d182ad56f6d$var$isBuiltin(wat, 'DOMError');
}
function $90331d182ad56f6d$export$12e869b2a583f783(wat) {
    return $90331d182ad56f6d$var$isBuiltin(wat, 'DOMException');
}
function $90331d182ad56f6d$export$844ec244b1367d54(wat) {
    return $90331d182ad56f6d$var$isBuiltin(wat, 'String');
}
function $90331d182ad56f6d$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $90331d182ad56f6d$export$53b83ca8eaab0383(wat) {
    return $90331d182ad56f6d$var$isBuiltin(wat, 'Object');
}
function $90331d182ad56f6d$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $90331d182ad56f6d$export$49034edbe6b62415(wat, Event);
}
function $90331d182ad56f6d$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $90331d182ad56f6d$export$49034edbe6b62415(wat, Element);
}
function $90331d182ad56f6d$export$49841c62b9eff15(wat) {
    return $90331d182ad56f6d$var$isBuiltin(wat, 'RegExp');
}
function $90331d182ad56f6d$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $90331d182ad56f6d$export$bc2894c7158efbac(wat) {
    return $90331d182ad56f6d$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $90331d182ad56f6d$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $90331d182ad56f6d$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("3lcRq", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $26ed4f1aa3979d61$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $26ed4f1aa3979d61$export$128827c3562ec0cb);

var $3Cq0D = parcelRequire("3Cq0D");

var $7yugL = parcelRequire("7yugL");

var $kPbyx = parcelRequire("kPbyx");
/** Regular expression used to parse a Dsn. */ var $26ed4f1aa3979d61$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $26ed4f1aa3979d61$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $26ed4f1aa3979d61$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $26ed4f1aa3979d61$var$dsnFromString(str) {
    var match = $26ed4f1aa3979d61$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $7yugL.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $3Cq0D.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $26ed4f1aa3979d61$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $26ed4f1aa3979d61$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $26ed4f1aa3979d61$var$validateDsn(dsn) {
    if (!(0, $kPbyx.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $7yugL.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $7yugL.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$26ed4f1aa3979d61$var$isValidProtocol(protocol)) throw new (0, $7yugL.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $7yugL.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $26ed4f1aa3979d61$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $26ed4f1aa3979d61$var$dsnFromString(from) : $26ed4f1aa3979d61$var$dsnFromComponents(from);
    $26ed4f1aa3979d61$var$validateDsn(components);
    return components;
}

});
parcelRegister("7yugL", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $58033042e9fe2c95$export$5949942ba2a7c0e2);

var $3Cq0D = parcelRequire("3Cq0D");

var $9CQ4f = parcelRequire("9CQ4f");
/** An error emitted by Sentry SDKs and related utilities. */ var $58033042e9fe2c95$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $9CQ4f.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("9CQ4f", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $70200d308ef42650$export$1cb0d91350beb6cc);
var $70200d308ef42650$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $70200d308ef42650$var$setProtoOf : $70200d308ef42650$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $70200d308ef42650$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $70200d308ef42650$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("kPbyx", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f29188e051891502$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f29188e051891502$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("jXpOk", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $e8778c7d0ec0bc7f$export$285b9172a3741fb7);

var $3Cq0D = parcelRequire("3Cq0D");

var $kPbyx = parcelRequire("kPbyx");

var $k9z5g = parcelRequire("k9z5g");

var $cnzqx = parcelRequire("cnzqx");

var $4vHb7 = parcelRequire("4vHb7");

var $85DVE = parcelRequire("85DVE");

var $fNUki = parcelRequire("fNUki");

var $1vLPF = parcelRequire("1vLPF");
var $e8778c7d0ec0bc7f$var$global = (0, $k9z5g.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $e8778c7d0ec0bc7f$var$handlers = {};
var $e8778c7d0ec0bc7f$var$instrumented = {};
/** Instruments given API */ function $e8778c7d0ec0bc7f$var$instrument(type) {
    if ($e8778c7d0ec0bc7f$var$instrumented[type]) return;
    $e8778c7d0ec0bc7f$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $e8778c7d0ec0bc7f$var$instrumentConsole();
            break;
        case 'dom':
            $e8778c7d0ec0bc7f$var$instrumentDOM();
            break;
        case 'xhr':
            $e8778c7d0ec0bc7f$var$instrumentXHR();
            break;
        case 'fetch':
            $e8778c7d0ec0bc7f$var$instrumentFetch();
            break;
        case 'history':
            $e8778c7d0ec0bc7f$var$instrumentHistory();
            break;
        case 'error':
            $e8778c7d0ec0bc7f$var$instrumentError();
            break;
        case 'unhandledrejection':
            $e8778c7d0ec0bc7f$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $kPbyx.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $e8778c7d0ec0bc7f$export$285b9172a3741fb7(type, callback) {
    $e8778c7d0ec0bc7f$var$handlers[type] = $e8778c7d0ec0bc7f$var$handlers[type] || [];
    $e8778c7d0ec0bc7f$var$handlers[type].push(callback);
    $e8778c7d0ec0bc7f$var$instrument(type);
}
/** JSDoc */ function $e8778c7d0ec0bc7f$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$e8778c7d0ec0bc7f$var$handlers[type]) return;
    try {
        for(var _b = (0, $3Cq0D.__values)($e8778c7d0ec0bc7f$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $kPbyx.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $fNUki.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentConsole() {
    if (!('console' in $e8778c7d0ec0bc7f$var$global)) return;
    (0, $4vHb7.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $e8778c7d0ec0bc7f$var$global.console)) return;
        (0, $85DVE.fill)($e8778c7d0ec0bc7f$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $e8778c7d0ec0bc7f$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($e8778c7d0ec0bc7f$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentFetch() {
    if (!(0, $1vLPF.supportsNativeFetch)()) return;
    (0, $85DVE.fill)($e8778c7d0ec0bc7f$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $e8778c7d0ec0bc7f$var$getFetchMethod(args),
                    url: $e8778c7d0ec0bc7f$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $e8778c7d0ec0bc7f$var$triggerHandlers('fetch', (0, $3Cq0D.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($e8778c7d0ec0bc7f$var$global, args).then(function(response) {
                $e8778c7d0ec0bc7f$var$triggerHandlers('fetch', (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $e8778c7d0ec0bc7f$var$triggerHandlers('fetch', (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $e8778c7d0ec0bc7f$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $e8778c7d0ec0bc7f$var$global && (0, $cnzqx.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $e8778c7d0ec0bc7f$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $e8778c7d0ec0bc7f$var$global && (0, $cnzqx.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $e8778c7d0ec0bc7f$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $85DVE.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $cnzqx.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $cnzqx.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $e8778c7d0ec0bc7f$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $85DVE.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $85DVE.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $e8778c7d0ec0bc7f$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $e8778c7d0ec0bc7f$var$lastHref;
/** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentHistory() {
    if (!(0, $1vLPF.supportsHistory)()) return;
    var oldOnPopState = $e8778c7d0ec0bc7f$var$global.onpopstate;
    $e8778c7d0ec0bc7f$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $e8778c7d0ec0bc7f$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $e8778c7d0ec0bc7f$var$lastHref;
        $e8778c7d0ec0bc7f$var$lastHref = to;
        $e8778c7d0ec0bc7f$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $e8778c7d0ec0bc7f$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $e8778c7d0ec0bc7f$var$lastHref = to;
                $e8778c7d0ec0bc7f$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $85DVE.fill)($e8778c7d0ec0bc7f$var$global.history, 'pushState', historyReplacementFunction);
    (0, $85DVE.fill)($e8778c7d0ec0bc7f$var$global.history, 'replaceState', historyReplacementFunction);
}
var $e8778c7d0ec0bc7f$var$debounceDuration = 1000;
var $e8778c7d0ec0bc7f$var$debounceTimerID;
var $e8778c7d0ec0bc7f$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $e8778c7d0ec0bc7f$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $e8778c7d0ec0bc7f$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $e8778c7d0ec0bc7f$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $e8778c7d0ec0bc7f$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($e8778c7d0ec0bc7f$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($e8778c7d0ec0bc7f$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e8778c7d0ec0bc7f$var$lastCapturedEvent = event;
        } else if ($e8778c7d0ec0bc7f$var$shouldShortcircuitPreviousDebounce($e8778c7d0ec0bc7f$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e8778c7d0ec0bc7f$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($e8778c7d0ec0bc7f$var$debounceTimerID);
        $e8778c7d0ec0bc7f$var$debounceTimerID = $e8778c7d0ec0bc7f$var$global.setTimeout(function() {
            $e8778c7d0ec0bc7f$var$debounceTimerID = undefined;
        }, $e8778c7d0ec0bc7f$var$debounceDuration);
    };
}
/** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentDOM() {
    if (!('document' in $e8778c7d0ec0bc7f$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $e8778c7d0ec0bc7f$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $e8778c7d0ec0bc7f$var$makeDOMEventHandler(triggerDOMHandler, true);
    $e8778c7d0ec0bc7f$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $e8778c7d0ec0bc7f$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $e8778c7d0ec0bc7f$var$global[target] && $e8778c7d0ec0bc7f$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $85DVE.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $e8778c7d0ec0bc7f$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $85DVE.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $e8778c7d0ec0bc7f$var$_oldOnErrorHandler = null;
/** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentError() {
    $e8778c7d0ec0bc7f$var$_oldOnErrorHandler = $e8778c7d0ec0bc7f$var$global.onerror;
    $e8778c7d0ec0bc7f$var$global.onerror = function(msg, url, line, column, error) {
        $e8778c7d0ec0bc7f$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($e8778c7d0ec0bc7f$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $e8778c7d0ec0bc7f$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $e8778c7d0ec0bc7f$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $e8778c7d0ec0bc7f$var$instrumentUnhandledRejection() {
    $e8778c7d0ec0bc7f$var$_oldOnUnhandledRejectionHandler = $e8778c7d0ec0bc7f$var$global.onunhandledrejection;
    $e8778c7d0ec0bc7f$var$global.onunhandledrejection = function(e) {
        $e8778c7d0ec0bc7f$var$triggerHandlers('unhandledrejection', e);
        if ($e8778c7d0ec0bc7f$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $e8778c7d0ec0bc7f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("4vHb7", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $348b8cfb1f1aff63$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $348b8cfb1f1aff63$export$af88d00dbe7f521);

var $3Cq0D = parcelRequire("3Cq0D");

var $kPbyx = parcelRequire("kPbyx");

var $k9z5g = parcelRequire("k9z5g");
// TODO: Implement different loggers for different environments
var $348b8cfb1f1aff63$var$global = (0, $k9z5g.getGlobalObject)();
/** Prefix for logging strings */ var $348b8cfb1f1aff63$var$PREFIX = 'Sentry Logger ';
var $348b8cfb1f1aff63$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $348b8cfb1f1aff63$export$cda52e2a8927a2ca(callback) {
    var global = (0, $k9z5g.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $348b8cfb1f1aff63$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $348b8cfb1f1aff63$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $kPbyx.IS_DEBUG_BUILD) $348b8cfb1f1aff63$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $348b8cfb1f1aff63$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $348b8cfb1f1aff63$var$global.console)[name].apply(_a, (0, $3Cq0D.__spread)([
                    $348b8cfb1f1aff63$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $348b8cfb1f1aff63$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $348b8cfb1f1aff63$export$af88d00dbe7f521;
if (0, $kPbyx.IS_DEBUG_BUILD) $348b8cfb1f1aff63$export$af88d00dbe7f521 = (0, $k9z5g.getGlobalSingleton)('logger', $348b8cfb1f1aff63$var$makeLogger);
else $348b8cfb1f1aff63$export$af88d00dbe7f521 = $348b8cfb1f1aff63$var$makeLogger();

});

parcelRegister("85DVE", function(module, exports) {
$parcel$export(module.exports, "fill", () => $5e3dc3680c214120$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $5e3dc3680c214120$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $5e3dc3680c214120$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $5e3dc3680c214120$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $5e3dc3680c214120$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $5e3dc3680c214120$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $5e3dc3680c214120$export$b0244d5063c0b61b);

var $3Cq0D = parcelRequire("3Cq0D");

var $kcI9y = parcelRequire("kcI9y");

var $cnzqx = parcelRequire("cnzqx");

var $hzPhA = parcelRequire("hzPhA");
function $5e3dc3680c214120$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $5e3dc3680c214120$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $5e3dc3680c214120$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $5e3dc3680c214120$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $5e3dc3680c214120$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $5e3dc3680c214120$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $5e3dc3680c214120$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $5e3dc3680c214120$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $cnzqx.isError)(value)) newObj = (0, $3Cq0D.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $5e3dc3680c214120$var$getOwnProperties(value));
    else if ((0, $cnzqx.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3Cq0D.__assign)({
            type: event_1.type,
            target: $5e3dc3680c214120$var$serializeEventTarget(event_1.target),
            currentTarget: $5e3dc3680c214120$var$serializeEventTarget(event_1.currentTarget)
        }, $5e3dc3680c214120$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $cnzqx.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $5e3dc3680c214120$var$serializeEventTarget(target) {
    try {
        return (0, $cnzqx.isElement)(target) ? (0, $kcI9y.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $5e3dc3680c214120$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $5e3dc3680c214120$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($5e3dc3680c214120$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $hzPhA.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hzPhA.truncate)(serialized, maxLength);
    }
    return '';
}
function $5e3dc3680c214120$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $cnzqx.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3Cq0D.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $5e3dc3680c214120$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($5e3dc3680c214120$export$d25f2688db1bb433);
    return val;
}
function $5e3dc3680c214120$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $cnzqx.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("hzPhA", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $ccbd7c34a9e39fd0$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $ccbd7c34a9e39fd0$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $ccbd7c34a9e39fd0$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $ccbd7c34a9e39fd0$export$cdded5b28a5f8c6d);

var $cnzqx = parcelRequire("cnzqx");
function $ccbd7c34a9e39fd0$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $ccbd7c34a9e39fd0$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $ccbd7c34a9e39fd0$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $ccbd7c34a9e39fd0$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $cnzqx.isString)(value)) return false;
    if ((0, $cnzqx.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $ccbd7c34a9e39fd0$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("fNUki", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $b8171fda3f7810d1$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $b8171fda3f7810d1$export$aad197c7121a6651);

var $3Cq0D = parcelRequire("3Cq0D");
var $b8171fda3f7810d1$var$STACKTRACE_LIMIT = 50;
function $b8171fda3f7810d1$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $3Cq0D.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $3Cq0D.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $b8171fda3f7810d1$export$c55c24c0eeba0205(frames);
    };
}
function $b8171fda3f7810d1$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $b8171fda3f7810d1$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $b8171fda3f7810d1$var$defaultFunctionName = '<anonymous>';
function $b8171fda3f7810d1$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b8171fda3f7810d1$var$defaultFunctionName;
        return fn.name || $b8171fda3f7810d1$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b8171fda3f7810d1$var$defaultFunctionName;
    }
}

});

parcelRegister("1vLPF", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $119dca31b9d4ffa1$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $119dca31b9d4ffa1$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $119dca31b9d4ffa1$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $119dca31b9d4ffa1$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $119dca31b9d4ffa1$export$67fc34576016d6ec);

var $kPbyx = parcelRequire("kPbyx");

var $k9z5g = parcelRequire("k9z5g");

var $4vHb7 = parcelRequire("4vHb7");
function $119dca31b9d4ffa1$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $119dca31b9d4ffa1$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $119dca31b9d4ffa1$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $119dca31b9d4ffa1$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $k9z5g.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $119dca31b9d4ffa1$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $119dca31b9d4ffa1$export$c82d238e23c40b21() {
    if (!$119dca31b9d4ffa1$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $k9z5g.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($119dca31b9d4ffa1$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $119dca31b9d4ffa1$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $kPbyx.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $119dca31b9d4ffa1$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $k9z5g.getGlobalObject)();
}
function $119dca31b9d4ffa1$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$119dca31b9d4ffa1$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $119dca31b9d4ffa1$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $k9z5g.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("fwPq8", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $b4e1bb332abe831f$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $b4e1bb332abe831f$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $b4e1bb332abe831f$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $b4e1bb332abe831f$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $b4e1bb332abe831f$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $b4e1bb332abe831f$export$6de4ffac6a2f1098);

var $3Cq0D = parcelRequire("3Cq0D");

var $k9z5g = parcelRequire("k9z5g");

var $85DVE = parcelRequire("85DVE");

var $hzPhA = parcelRequire("hzPhA");
function $b4e1bb332abe831f$export$19f53698e68b2496() {
    var global = (0, $k9z5g.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $b4e1bb332abe831f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $b4e1bb332abe831f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $b4e1bb332abe831f$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $b4e1bb332abe831f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $b4e1bb332abe831f$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $b4e1bb332abe831f$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $b4e1bb332abe831f$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $b4e1bb332abe831f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $b4e1bb332abe831f$export$d364f2020ab30578(input) {
    var match = input.match($b4e1bb332abe831f$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $b4e1bb332abe831f$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $hzPhA.snipLine)(line, 0);
    });
    frame.context_line = (0, $hzPhA.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $hzPhA.snipLine)(line, 0);
    });
}
function $b4e1bb332abe831f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $b4e1bb332abe831f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $85DVE.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("g8CZ7", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $bbfba23d46666e70$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $bbfba23d46666e70$export$23fbbb20bed71033);

var $3Cq0D = parcelRequire("3Cq0D");

var $cnzqx = parcelRequire("cnzqx");

var $gl67z = parcelRequire("gl67z");

var $85DVE = parcelRequire("85DVE");

var $fNUki = parcelRequire("fNUki");
function $bbfba23d46666e70$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $bbfba23d46666e70$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $bbfba23d46666e70$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $bbfba23d46666e70$export$a3295358bff77e(object, depth);
    if ($bbfba23d46666e70$var$jsonSize(normalized) > maxSize) return $bbfba23d46666e70$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $bbfba23d46666e70$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $gl67z.memoBuilder)();
    var _a = (0, $3Cq0D.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $cnzqx.isNaN)(value)) return value;
    var stringified = $bbfba23d46666e70$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $cnzqx.isError)(value) || (0, $cnzqx.isEvent)(value) ? (0, $85DVE.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $bbfba23d46666e70$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $bbfba23d46666e70$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $cnzqx.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $fNUki.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $bbfba23d46666e70$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $bbfba23d46666e70$var$jsonSize(value) {
    return $bbfba23d46666e70$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("gl67z", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $be535b0d77353502$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $be535b0d77353502$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("4Habf", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $36b3132c74e5f510$export$85a4f67f852183e6);

var $7yugL = parcelRequire("7yugL");

var $gYYZR = parcelRequire("gYYZR");
function $36b3132c74e5f510$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $gYYZR.rejectedSyncPromise)(new (0, $7yugL.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $gYYZR.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $gYYZR.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("gYYZR", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $0330cca7b262d160$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $0330cca7b262d160$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $0330cca7b262d160$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $cnzqx = parcelRequire("cnzqx");
function $0330cca7b262d160$export$1fda8aa4d135f8aa(value) {
    return new $0330cca7b262d160$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $0330cca7b262d160$export$78e43115b553f358(reason) {
    return new $0330cca7b262d160$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $0330cca7b262d160$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $cnzqx.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("aRGS2", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $7e901bd0c6cfc63f$export$e01cef29b4327697);

var $icZGb = parcelRequire("icZGb");

var $kJdFw = parcelRequire("kJdFw");
function $7e901bd0c6cfc63f$var$isSupportedSeverity(level) {
    return (0, $kJdFw.SeverityLevels).indexOf(level) !== -1;
}
function $7e901bd0c6cfc63f$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $icZGb.Severity).Warning;
    if ($7e901bd0c6cfc63f$var$isSupportedSeverity(level)) return level;
    return (0, $icZGb.Severity).Log;
}

});
parcelRegister("kJdFw", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $f1729cef5142b1c7$export$484b1ea9aec914c);
var $f1729cef5142b1c7$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("dVCfU", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $a23e4603a1ee8ace$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $a23e4603a1ee8ace$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("9Xxtl", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $k9z5g = parcelRequire("k9z5g");

var $2OeAs = parcelRequire("2OeAs");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $k9z5g.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $2OeAs.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $2OeAs.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $k9z5g.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("cxyLF", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $92138943414e23e3$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $92138943414e23e3$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $92138943414e23e3$export$32f9b428425aac85);

var $3Cq0D = parcelRequire("3Cq0D");

var $cnzqx = parcelRequire("cnzqx");
function $92138943414e23e3$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $92138943414e23e3$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $3Cq0D.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $3Cq0D.__spread)(items, [
            newItem
        ])
    ];
}
function $92138943414e23e3$export$d84939284bbafcd4(envelope) {
    var _a = (0, $3Cq0D.__read)(envelope, 2), _b = (0, $3Cq0D.__read)(_a[1], 1), _c = (0, $3Cq0D.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $92138943414e23e3$export$32f9b428425aac85(envelope) {
    var _a = (0, $3Cq0D.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $3Cq0D.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $cnzqx.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("5oiSX", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $3ecdd7dfe1265dd1$export$f3b9ed77c03eeb00);

var $cxyLF = parcelRequire("cxyLF");

var $9Xxtl = parcelRequire("9Xxtl");
function $3ecdd7dfe1265dd1$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $9Xxtl.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $cxyLF.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("22R6W", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $17d4f7656ea84161$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $17d4f7656ea84161$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $17d4f7656ea84161$export$699aff705e0d49d4);

var $3Cq0D = parcelRequire("3Cq0D");
var $17d4f7656ea84161$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $17d4f7656ea84161$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $17d4f7656ea84161$export$b09ce39faaeb1e7c;
}
function $17d4f7656ea84161$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $17d4f7656ea84161$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $17d4f7656ea84161$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $17d4f7656ea84161$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $3Cq0D.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $3Cq0D.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $3Cq0D.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $17d4f7656ea84161$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("fwEJ0", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Cq0D = parcelRequire("3Cq0D");
// global reference to slice
var $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION = '?';
var $b4d96f48f9fe4232$var$OPERA10_PRIORITY = 10;
var $b4d96f48f9fe4232$var$OPERA11_PRIORITY = 20;
var $b4d96f48f9fe4232$var$CHROME_PRIORITY = 30;
var $b4d96f48f9fe4232$var$WINJS_PRIORITY = 40;
var $b4d96f48f9fe4232$var$GECKO_PRIORITY = 50;
function $b4d96f48f9fe4232$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $b4d96f48f9fe4232$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $b4d96f48f9fe4232$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $b4d96f48f9fe4232$var$chrome = function(line) {
    var parts = $b4d96f48f9fe4232$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $b4d96f48f9fe4232$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = $3Cq0D.__read($b4d96f48f9fe4232$var$extractSafariExtensionDetails(parts[1] || $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $b4d96f48f9fe4232$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
module.exports.chromeStackParser = [
    $b4d96f48f9fe4232$var$CHROME_PRIORITY,
    $b4d96f48f9fe4232$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $b4d96f48f9fe4232$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $b4d96f48f9fe4232$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $b4d96f48f9fe4232$var$gecko = function(line) {
    var _a;
    var parts = $b4d96f48f9fe4232$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $b4d96f48f9fe4232$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION;
        _a = $3Cq0D.__read($b4d96f48f9fe4232$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $b4d96f48f9fe4232$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
module.exports.geckoStackParser = [
    $b4d96f48f9fe4232$var$GECKO_PRIORITY,
    $b4d96f48f9fe4232$var$gecko
];
var $b4d96f48f9fe4232$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $b4d96f48f9fe4232$var$winjs = function(line) {
    var parts = $b4d96f48f9fe4232$var$winjsRegex.exec(line);
    return parts ? $b4d96f48f9fe4232$var$createFrame(parts[2], parts[1] || $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
module.exports.winjsStackParser = [
    $b4d96f48f9fe4232$var$WINJS_PRIORITY,
    $b4d96f48f9fe4232$var$winjs
];
var $b4d96f48f9fe4232$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $b4d96f48f9fe4232$var$opera10 = function(line) {
    var parts = $b4d96f48f9fe4232$var$opera10Regex.exec(line);
    return parts ? $b4d96f48f9fe4232$var$createFrame(parts[2], parts[3] || $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
module.exports.opera10StackParser = [
    $b4d96f48f9fe4232$var$OPERA10_PRIORITY,
    $b4d96f48f9fe4232$var$opera10
];
var $b4d96f48f9fe4232$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $b4d96f48f9fe4232$var$opera11 = function(line) {
    var parts = $b4d96f48f9fe4232$var$opera11Regex.exec(line);
    return parts ? $b4d96f48f9fe4232$var$createFrame(parts[5], parts[3] || parts[4] || $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
module.exports.opera11StackParser = [
    $b4d96f48f9fe4232$var$OPERA11_PRIORITY,
    $b4d96f48f9fe4232$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $b4d96f48f9fe4232$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $b4d96f48f9fe4232$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});




parcelRegister("9XeYn", function(module, exports) {
$parcel$export(module.exports, "getApplication", () => $9aeff85e1003943b$export$205bc258834dc08);
$parcel$export(module.exports, "bootstrap", () => $9aeff85e1003943b$export$36aff1fbb4f5dfc6);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $fuVmc = parcelRequire("fuVmc");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("cJJTb");
var $kTS4R = parcelRequire("kTS4R");

var $lJH1c = parcelRequire("lJH1c");

var $awkgb = parcelRequire("awkgb");

var $hDP4J = parcelRequire("hDP4J");

var $db841 = parcelRequire("db841");

var $dpQiX = parcelRequire("dpQiX");

var $iW3CQ = parcelRequire("iW3CQ");

var $6gSQT = parcelRequire("6gSQT");

var $1n2TR = parcelRequire("1n2TR");

var $6oRGF = parcelRequire("6oRGF");
const $9aeff85e1003943b$var$initialiseAppUtilities = (0, $4ZMmh.once)(()=>{
    (0, $6gSQT.initialisePlatformFeatureFlags)();
    (0, $dpQiX.initialiseConnectAndSentryAndCleanUrl)();
    (0, $hDP4J.install)();
    (0, $db841.initBrowserMetricsV3)();
});
const $9aeff85e1003943b$export$205bc258834dc08 = ()=>{
    const atlassianHelpConfig = {
        ...(0, $iW3CQ.getEnv)(),
        ...(0, $fuVmc.getMetaData)()
    };
    (0, $lJH1c.ModelsCache).getInstance().initFromInitialJsonPayload();
    $9aeff85e1003943b$var$initialiseAppUtilities();
    return /*#__PURE__*/ $bSJIT.createElement((0, $awkgb.default), {
        name: "help-center-root"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $6oRGF.AtlassianHelp), {
        config: atlassianHelpConfig
    }));
};
const $9aeff85e1003943b$export$36aff1fbb4f5dfc6 = ()=>{
    (0, $kTS4R.LooselyLazy).init({
        retry: 3
    });
    const rootId = 'root';
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let container = document.getElementById(rootId);
    if (!container) {
        // If there is no root element available yet, add one.
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        container = document.createElement('span');
        container.id = rootId;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.body.appendChild(container);
    }
    // Invalid report.
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const isPageServerSideRendered = (0, $iW3CQ.getIsPageServerSideRendered)();
    // Workaround for this google translate problem https://github.com/facebook/react/issues/11538#issuecomment-417504600
    // which is causing this issue https://hello.jira.atlassian.cloud/browse/PORTAL-5241, affecting view page reliability
    (0, $1n2TR.handleDOMGoogleTranslateIssues)();
    if (isPageServerSideRendered) (0, $4Sf72.hydrate)($9aeff85e1003943b$export$205bc258834dc08(), container);
    else (0, $4Sf72.render)($9aeff85e1003943b$export$205bc258834dc08(), container);
};

});
parcelRegister("cJJTb", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("kTS4R")).LooselyLazy);
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("2vYDF")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("2vYDF")).lazy);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("1ssyA")).LazyWait);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("bf3Xm")).LazySuspense);
parcelRequire("eRBPT");
var $dPtEF = parcelRequire("dPtEF");

var $kTS4R = parcelRequire("kTS4R");

var $2vYDF = parcelRequire("2vYDF");
parcelRequire("g3OjY");
var $1ssyA = parcelRequire("1ssyA");
parcelRequire("dTxxB");
var $bf3Xm = parcelRequire("bf3Xm");

var $lQgWB = parcelRequire("lQgWB");

var $hv2i0 = parcelRequire("hv2i0");

});
parcelRegister("eRBPT", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $ad235d5fca292aba$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $ad235d5fca292aba$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("dPtEF")).MODE);

var $dPtEF = parcelRequire("dPtEF");
const $ad235d5fca292aba$var$DEFAULT_CROSS_ORIGIN = undefined;
const $ad235d5fca292aba$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $ad235d5fca292aba$var$DEFAULT_MODE = (0, $dPtEF.MODE).HYDRATE;
const $ad235d5fca292aba$var$DEFAULT_RETRY = 2;
const $ad235d5fca292aba$var$config = {
    crossOrigin: $ad235d5fca292aba$var$DEFAULT_CROSS_ORIGIN,
    manifest: $ad235d5fca292aba$var$DEFAULT_MANIFEST,
    mode: $ad235d5fca292aba$var$DEFAULT_MODE,
    retry: $ad235d5fca292aba$var$DEFAULT_RETRY
};
const $ad235d5fca292aba$export$44487a86467333c3 = ()=>$ad235d5fca292aba$var$config;
const $ad235d5fca292aba$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $ad235d5fca292aba$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $ad235d5fca292aba$var$DEFAULT_CROSS_ORIGIN;
    $ad235d5fca292aba$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $ad235d5fca292aba$var$DEFAULT_MANIFEST;
    $ad235d5fca292aba$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $ad235d5fca292aba$var$DEFAULT_MODE;
    $ad235d5fca292aba$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $ad235d5fca292aba$var$DEFAULT_RETRY;
};

});
parcelRegister("dPtEF", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $a1170a9e54a1cc70$export$e48589d9e4824227);
const $a1170a9e54a1cc70$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("kTS4R", function(module, exports) {
$parcel$export(module.exports, "LooselyLazy", () => $f372e45ce017ca5b$export$33c5f161e1d4706);

var $1W6Dl = parcelRequire("1W6Dl");

var $eRBPT = parcelRequire("eRBPT");
parcelRequire("lQgWB");
var $9lkLw = parcelRequire("9lkLw");
var $d3BUO = parcelRequire("d3BUO");

var $2u7Cv = parcelRequire("2u7Cv");
const $f372e45ce017ca5b$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $eRBPT.setConfig)(config);
        (0, $9lkLw.LISTENERS).length = 0;
        (0, $d3BUO.setCurrent)(0);
        if (!(0, $2u7Cv.isNodeEnvironment)()) (0, $1W6Dl.collect)();
    }
};

});
parcelRegister("1W6Dl", function(module, exports) {
$parcel$export(module.exports, "collect", () => $16905a82fc484d79$export$bb44f104e3c54dae);

var $eRBPT = parcelRequire("eRBPT");
var $dPtEF = parcelRequire("dPtEF");

var $as5jW = parcelRequire("as5jW");

var $kzlcz = parcelRequire("kzlcz");

var $7Ksmn = parcelRequire("7Ksmn");
const $16905a82fc484d79$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $eRBPT.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dPtEF.MODE).RENDER ? (0, $kzlcz.cloneElements)(markers[i], lazyBegin) : (0, $7Ksmn.refElements)(markers[i], lazyBegin);
        if ((0, $as5jW.COLLECTED).has(lazyBegin)) (0, $as5jW.COLLECTED).get(lazyBegin).push(value);
        else (0, $as5jW.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("as5jW", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $79c0a57fe018b380$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $79c0a57fe018b380$export$4831ef3968ea94ef);
const $79c0a57fe018b380$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $79c0a57fe018b380$export$4831ef3968ea94ef = new Map();

});

parcelRegister("kzlcz", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $ef9785becef958d7$export$c42217d53a7ebafb);
const $ef9785becef958d7$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("7Ksmn", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $5a42d3f6172ff63f$export$c69443129766a7fc);
const $5a42d3f6172ff63f$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("lQgWB", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("d3BUO")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("d3BUO")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("9lkLw")).LISTENERS);

var $d3BUO = parcelRequire("d3BUO");

var $9lkLw = parcelRequire("9lkLw");

var $5y2hG = parcelRequire("5y2hG");

});
parcelRegister("d3BUO", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $9818f76313a7a192$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $9818f76313a7a192$export$5a25eca35e5debcb);

var $bSJIT = parcelRequire("bSJIT");

var $as5jW = parcelRequire("as5jW");

var $9lkLw = parcelRequire("9lkLw");

var $5y2hG = parcelRequire("5y2hG");
let $9818f76313a7a192$var$CURRENT_PHASE = (0, $as5jW.PHASE).PAINT;
const $9818f76313a7a192$export$5f80f094fd31fffd = (phase)=>{
    $9818f76313a7a192$var$CURRENT_PHASE = phase;
    (0, $9lkLw.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $9818f76313a7a192$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $bSJIT.createContext)({
    subscribe: (0, $5y2hG.createSubscribe)((0, $9lkLw.LISTENERS)),
    currentValue: ()=>$9818f76313a7a192$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $9818f76313a7a192$export$5f80f094fd31fffd((0, $as5jW.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$9818f76313a7a192$export$5f80f094fd31fffd((0, $as5jW.PHASE).PAINT)
    }
});
const $9818f76313a7a192$export$1dc361b277327f88 = ()=>{
    const v = (0, $bSJIT.useContext)($9818f76313a7a192$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("9lkLw", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $6cd62ed1cfa073bf$export$81b9c458a026d68f);
const $6cd62ed1cfa073bf$export$81b9c458a026d68f = [];

});

parcelRegister("5y2hG", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $40a1e658d5c2b0db$export$364097d812234b3f);
const $40a1e658d5c2b0db$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("2u7Cv", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $1cf44b4ace7b9cb2$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $1cf44b4ace7b9cb2$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $1cf44b4ace7b9cb2$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $1cf44b4ace7b9cb2$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("cLZDV")).default);

var $cLZDV = parcelRequire("cLZDV");
const $1cf44b4ace7b9cb2$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $1cf44b4ace7b9cb2$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $1cf44b4ace7b9cb2$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $1cf44b4ace7b9cb2$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("cLZDV", function(module, exports) {
$parcel$export(module.exports, "default", () => $94c9b0d3e499af7f$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $94c9b0d3e499af7f$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("2vYDF", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $1d4d83a4e51de28a$export$c952e5f94576010e);
$parcel$export(module.exports, "lazy", () => $1d4d83a4e51de28a$export$488013bae63b21da);

var $5P2wZ = parcelRequire("5P2wZ");

var $eRBPT = parcelRequire("eRBPT");

var $as5jW = parcelRequire("as5jW");

var $2u7Cv = parcelRequire("2u7Cv");
var $cLZDV = parcelRequire("cLZDV");

var $6sAKo = parcelRequire("6sAKo");

var $dYFjo = parcelRequire("dYFjo");

var $42tNw = parcelRequire("42tNw");

var $XicIY = parcelRequire("XicIY");

var $74628 = parcelRequire("74628");

var $h9q3v = parcelRequire("h9q3v");

var $4UDsS = parcelRequire("4UDsS");
function $1d4d83a4e51de28a$var$_extends() {
    $1d4d83a4e51de28a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d4d83a4e51de28a$var$_extends.apply(this, arguments);
}
function $1d4d83a4e51de28a$var$lazyProxy(_loader, { defer: defer = (0, $as5jW.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $2u7Cv.isNodeEnvironment)();
    const dataLazyId = (0, $cLZDV.default)(moduleId);
    const LazyInternal = isServer ? (0, $42tNw.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $dYFjo.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $XicIY.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $eRBPT.getConfig)();
                return (0, $h9q3v.retry)(_loader, {
                    delay: (0, $6sAKo.RETRY_DELAY),
                    factor: (0, $6sAKo.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $2u7Cv.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $eRBPT.getConfig)();
        return (0, $5P2wZ.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $as5jW.PHASE).PAINT ? (0, $6sAKo.PRIORITY).HIGH : (0, $6sAKo.PRIORITY).LOW;
        return (0, $74628.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $1d4d83a4e51de28a$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $as5jW.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $as5jW.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $as5jW.PHASE).LAZY
    }
};
function $1d4d83a4e51de28a$export$c952e5f94576010e(loader, opts) {
    return $1d4d83a4e51de28a$var$lazyProxy(loader, $1d4d83a4e51de28a$var$_extends({}, $1d4d83a4e51de28a$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $1d4d83a4e51de28a$export$291dd592399bdafa(loader, opts) {
    return $1d4d83a4e51de28a$var$lazyProxy(loader, $1d4d83a4e51de28a$var$_extends({}, $1d4d83a4e51de28a$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $1d4d83a4e51de28a$export$488013bae63b21da(loader, opts) {
    return $1d4d83a4e51de28a$var$lazyProxy(loader, $1d4d83a4e51de28a$var$_extends({}, $1d4d83a4e51de28a$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("5P2wZ", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $43d3adcc68ce4dd4$export$303f43e55cf1ef2f);
const $43d3adcc68ce4dd4$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("6sAKo", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $4b41dcd2981da452$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $4b41dcd2981da452$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $4b41dcd2981da452$export$ba64c908e55507fe);
const $4b41dcd2981da452$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $4b41dcd2981da452$export$a339266ad71b2447 = 300;
const $4b41dcd2981da452$export$ba64c908e55507fe = 1;

});

parcelRegister("dYFjo", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $a2d0ec9e95cb7eb6$export$6898b5504b58699a);

var $bSJIT = parcelRequire("bSJIT");

var $eRBPT = parcelRequire("eRBPT");
var $dPtEF = parcelRequire("dPtEF");

var $as5jW = parcelRequire("as5jW");
parcelRequire("g3OjY");
var $cJ9Pf = parcelRequire("cJ9Pf");
parcelRequire("lQgWB");
var $d3BUO = parcelRequire("d3BUO");
parcelRequire("dTxxB");
var $c5TN9 = parcelRequire("c5TN9");

var $6sAKo = parcelRequire("6sAKo");

var $4UDsS = parcelRequire("4UDsS");

var $4OHEW = parcelRequire("4OHEW");

var $3405I = parcelRequire("3405I");

var $74628 = parcelRequire("74628");

var $hv2i0 = parcelRequire("hv2i0");

var $9ww3r = parcelRequire("9ww3r");
function $a2d0ec9e95cb7eb6$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $bSJIT.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $as5jW.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $as5jW.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $bSJIT.useContext)((0, $hv2i0.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $4UDsS.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $9ww3r.useSubscription)({
            context: (0, $cJ9Pf.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $as5jW.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $9ww3r.useSubscription)({
                context: (0, $d3BUO.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $bSJIT.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $74628.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $6sAKo.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $bSJIT.useContext)((0, $c5TN9.LazySuspenseContext));
        (0, $bSJIT.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $as5jW.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $eRBPT.getConfig)().mode === (0, $dPtEF.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4OHEW.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3405I.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("g3OjY", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("cJ9Pf")).WaitContext);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("1ssyA")).LazyWait);

var $cJ9Pf = parcelRequire("cJ9Pf");

var $1ssyA = parcelRequire("1ssyA");

});
parcelRegister("cJ9Pf", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $94414f23a8282233$export$9ba3fe09d15de47b);

var $bSJIT = parcelRequire("bSJIT");

var $7rhK6 = parcelRequire("7rhK6");
const $94414f23a8282233$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $bSJIT.createContext)({
    subscribe: ()=>(0, $7rhK6.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("7rhK6", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $56a8d1575afe7114$export$276c7dbda7675aec);
const $56a8d1575afe7114$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("1ssyA", function(module, exports) {
$parcel$export(module.exports, "LazyWait", () => $10fe8ec0f590fada$export$7bf6cf03fd32cddb);

var $bSJIT = parcelRequire("bSJIT");

var $cJ9Pf = parcelRequire("cJ9Pf");
const $10fe8ec0f590fada$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $bSJIT.useContext)((0, $cJ9Pf.WaitContext));
    const value = (0, $bSJIT.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $bSJIT.useRef)(new Set());
    const api = (0, $bSJIT.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $bSJIT.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJ9Pf.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("dTxxB", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("bf3Xm")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("c5TN9")).LazySuspenseContext);

var $bf3Xm = parcelRequire("bf3Xm");

var $c5TN9 = parcelRequire("c5TN9");

});
parcelRegister("bf3Xm", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $82f42a17fb9844d6$export$256c542058532d6f);

var $bSJIT = parcelRequire("bSJIT");

var $2u7Cv = parcelRequire("2u7Cv");

var $c5TN9 = parcelRequire("c5TN9");
class $82f42a17fb9844d6$export$256c542058532d6f extends (0, $bSJIT.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $bSJIT.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c5TN9.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c5TN9.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $2u7Cv.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("c5TN9", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $8ce13abf605810ec$export$c33990e84065970c);

var $bSJIT = parcelRequire("bSJIT");
const $8ce13abf605810ec$export$c33990e84065970c = /*#__PURE__*/ (0, $bSJIT.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("4UDsS", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $393b013e4004842f$export$c73a6a6f0bf7d425);
const $393b013e4004842f$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $393b013e4004842f$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$393b013e4004842f$export$6aa69c1258005366]: true
    });
    return error;
};
const $393b013e4004842f$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($393b013e4004842f$export$6aa69c1258005366);

});

parcelRegister("4OHEW", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $381db2c639dc222e$export$d55db778a3e1446b);

var $bSJIT = parcelRequire("bSJIT");
function $381db2c639dc222e$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $381db2c639dc222e$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $bSJIT.useRef)(null);
    const { current: ssrDomNodes } = (0, $bSJIT.useRef)(content || []);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($381db2c639dc222e$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $381db2c639dc222e$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $381db2c639dc222e$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("3405I", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $23b1d0eab6d8c559$export$ca5b8fbc835d95e4);

var $bSJIT = parcelRequire("bSJIT");

var $2u7Cv = parcelRequire("2u7Cv");
function $23b1d0eab6d8c559$var$_extends() {
    $23b1d0eab6d8c559$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23b1d0eab6d8c559$var$_extends.apply(this, arguments);
}
const $23b1d0eab6d8c559$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $2u7Cv.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $bSJIT.createElement)((0, $bSJIT.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $bSJIT.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $bSJIT.createElement)(tagName.toLowerCase(), $23b1d0eab6d8c559$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("74628", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $524d963705945371$export$25bad4aa00c45355);

var $5P2wZ = parcelRequire("5P2wZ");

var $7rhK6 = parcelRequire("7rhK6");

var $eRBPT = parcelRequire("eRBPT");

var $2u7Cv = parcelRequire("2u7Cv");

var $6sAKo = parcelRequire("6sAKo");

var $hAiCV = parcelRequire("hAiCV");

var $hv2i0 = parcelRequire("hv2i0");
function $524d963705945371$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $eRBPT.getConfig)();
    const assets = (0, $5P2wZ.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $hAiCV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $524d963705945371$var$fakePromise = {
    then: ()=>$524d963705945371$var$fakePromise,
    catch: ()=>$524d963705945371$var$fakePromise,
    finally: ()=>$524d963705945371$var$fakePromise
};
function $524d963705945371$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $hAiCV.insertLinkTag)(href, rel));
        return $524d963705945371$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $524d963705945371$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $7rhK6.noopCleanup;
}
function $524d963705945371$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $2u7Cv.isNodeEnvironment)()) return 0, $7rhK6.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hv2i0.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $6sAKo.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $524d963705945371$export$3af04dbcb01bad4d,
        $524d963705945371$export$1046fd6a49d5e7a,
        $524d963705945371$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $7rhK6.noopCleanup;
}

});
parcelRegister("hAiCV", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $ccd43f5784cb2f51$export$6610512821c8a4ce);

var $hv2i0 = parcelRequire("hv2i0");

var $7rhK6 = parcelRequire("7rhK6");

var $eRBPT = parcelRequire("eRBPT");
function $ccd43f5784cb2f51$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $7rhK6.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $eRBPT.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hv2i0.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});
parcelRegister("hv2i0", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cbd71b91ce138aa8$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cbd71b91ce138aa8$export$8146ab57a3f7a7cb);

var $bSJIT = parcelRequire("bSJIT");
const $cbd71b91ce138aa8$export$e2d53c0cbedd2710 = {
    current: null
};
const $cbd71b91ce138aa8$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $bSJIT.createContext)($cbd71b91ce138aa8$export$e2d53c0cbedd2710);

});



parcelRegister("9ww3r", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $6eeff792778cb6c1$export$368b4214baeb914c);

var $bSJIT = parcelRequire("bSJIT");
function $6eeff792778cb6c1$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $bSJIT.useContext)(context);
    (0, $bSJIT.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("42tNw", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $2f0e76898ff273a1$export$eb2e4b04351cdd9e);

var $5P2wZ = parcelRequire("5P2wZ");

var $bSJIT = parcelRequire("bSJIT");

var $eRBPT = parcelRequire("eRBPT");

var $as5jW = parcelRequire("as5jW");
parcelRequire("dTxxB");
var $c5TN9 = parcelRequire("c5TN9");

var $2u7Cv = parcelRequire("2u7Cv");

var $4UDsS = parcelRequire("4UDsS");
function $2f0e76898ff273a1$var$load(moduleId, loader) {
    try {
        return (0, $2u7Cv.getExport)(loader());
    } catch (err) {
        throw (0, $4UDsS.createLoaderError)(err);
    }
}
function $2f0e76898ff273a1$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $2f0e76898ff273a1$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $bSJIT.useContext)((0, $c5TN9.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $eRBPT.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $as5jW.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $5P2wZ.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("link", {
                key: url,
                rel: defer === (0, $as5jW.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("XicIY", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $0b23a1c8c2d9d715$export$e673efccd97e4223);
const $0b23a1c8c2d9d715$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("h9q3v", function(module, exports) {
$parcel$export(module.exports, "retry", () => $c7c77d069daad2da$export$9369b12211e1fce4);
const $c7c77d069daad2da$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $c7c77d069daad2da$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $c7c77d069daad2da$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $c7c77d069daad2da$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $c7c77d069daad2da$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $c7c77d069daad2da$var$calculateDelay(context, policy);
        if (delay) await $c7c77d069daad2da$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("lJH1c", function(module, exports) {
$parcel$export(module.exports, "ModelsCache", () => $d7cd8938c06b7451$export$6525a85e50433f6b);

var $4ZMmh = parcelRequire("4ZMmh");

var $g6Upu = parcelRequire("g6Upu");

var $gEVth = parcelRequire("gEVth");

var $1btpl = parcelRequire("1btpl");
const $d7cd8938c06b7451$var$TEN_MINUTE_TIMEOUT = 600;
const $d7cd8938c06b7451$var$createCacheOperationalPayload = (modelType, cacheEventType)=>{
    return {
        action: cacheEventType,
        actionSubject: 'model-caches',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $d7cd8938c06b7451$var$fireCacheMissOperationalEvent = (modelType)=>{
    (0, $gEVth.operationalEvent)($d7cd8938c06b7451$var$createCacheOperationalPayload(modelType, 'cache-missed'));
};
const $d7cd8938c06b7451$var$fireCacheHitOperationalEvent = (modelType)=>{
    (0, $gEVth.operationalEvent)($d7cd8938c06b7451$var$createCacheOperationalPayload(modelType, 'cache-hit'));
};
class $d7cd8938c06b7451$export$6525a85e50433f6b {
    constructor(){
        /**
   * We will cache the user model later after splitting it into two; a static component and one for dynamic data such
   * as counts.
   */ this.toCacheModels = [
            'helpCenterBranding',
            'suggestedRequestTypes',
            'organisations',
            'portalsAndRequestTypes',
            ...this.addNewModelsToCache()
        ];
        const cacheTTL = $d7cd8938c06b7451$var$TEN_MINUTE_TIMEOUT;
        this.cache = new (0, (/*@__PURE__*/$parcel$interopDefault($g6Upu)))({
            stdTTL: cacheTTL,
            checkperiod: cacheTTL * 0.5,
            useClones: false
        });
    }
    static getInstance() {
        if (!$d7cd8938c06b7451$export$6525a85e50433f6b.instance) $d7cd8938c06b7451$export$6525a85e50433f6b.instance = new $d7cd8938c06b7451$export$6525a85e50433f6b();
        return $d7cd8938c06b7451$export$6525a85e50433f6b.instance;
    }
    shouldCache(modelType) {
        return this.toCacheModels.includes(modelType);
    }
    getFromCache(request) {
        const cachedResult = this.getFromCacheInternal(request);
        if (cachedResult !== undefined) $d7cd8938c06b7451$var$fireCacheHitOperationalEvent(request.type);
        else $d7cd8938c06b7451$var$fireCacheMissOperationalEvent(request.type);
        return cachedResult;
    }
    getFromCacheInternal(request) {
        const requestCacheEntries = this.cache.get(request.type) || [];
        return requestCacheEntries.find((cacheEntry)=>(0, $4ZMmh.isEqual)(cacheEntry.request, request));
    }
    putToCache(request, modelsResponse) {
        const fromCache = this.getFromCacheInternal(request);
        if (fromCache === undefined) {
            const requests = this.cache.get(request.type) || [];
            requests.push({
                request: request,
                response: modelsResponse
            });
            this.cache.set(request.type, requests);
        }
    }
    del(modelType) {
        this.cache.del(modelType);
    }
    /**
   * Initialise model cache with models contained in jsonPayload div.
   * This avoids loading them again during app init.
   *
   * Note that this implementation assumes model requests during initial page loads don't contain any parameters
   * other than the modelType.
   */ initFromInitialJsonPayload() {
        const initialModelState = (0, $1btpl.default)();
        for (const modelTypeStr of Object.keys(initialModelState)){
            const modelType = modelTypeStr;
            if ($d7cd8938c06b7451$export$6525a85e50433f6b.getInstance().shouldCache(modelType)) $d7cd8938c06b7451$export$6525a85e50433f6b.getInstance().putToCache({
                type: modelType,
                params: {}
            }, // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            {
                [modelType]: initialModelState[modelType]
            });
        }
    }
    addNewModelsToCache() {
        return [
            'portal',
            'branding',
            'portalWebFragments',
            'user'
        ];
    }
}

});
parcelRegister("g6Upu", function(module, exports) {

/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var exports;
    exports = module.exports = (parcelRequire("jQ2nU"));
    exports.version = '5.1.2';
}).call(module.exports);

});
parcelRegister("jQ2nU", function(module, exports) {

var $gn15R = parcelRequire("gn15R");
var $e714b92b9ac856be$require$Buffer = $gn15R.Buffer;


/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var EventEmitter, NodeCache, clone, splice = [].splice, boundMethodCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new Error('Bound instance method accessed before binding');
    }, indexOf = [].indexOf;
    clone = (parcelRequire("6co1L"));
    EventEmitter = (parcelRequire("03cmj")).EventEmitter;
    // generate superclass
    module.exports = NodeCache = (function() {
        class NodeCache extends EventEmitter {
            constructor(options = {}){
                super();
                // ## get
                // get a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.get "myKey", ( err, val )
                this.get = this.get.bind(this);
                // ## mget
                // get multiple cached keys at once and change the stats
                // **Parameters:**
                // * `keys` ( String|Number[] ): an array of keys
                // **Example:**
                //	myCache.mget [ "foo", "bar" ]
                this.mget = this.mget.bind(this);
                // ## set
                // set a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // * `value` ( Any ): A element to cache. If the option `option.forceString` is `true` the module trys to translate it to a serialized JSON
                // * `[ ttl ]` ( Number | String ): ( optional ) The time to live in seconds.
                // **Example:**
                //	myCache.set "myKey", "my_String Value"
                //	myCache.set "myKey", "my_String Value", 10
                this.set = this.set.bind(this);
                // ## mset
                // set multiple keys at once
                // **Parameters:**
                // * `keyValueSet` ( Object[] ): an array of object which includes key,value and ttl
                // **Example:**
                //	myCache.mset(
                //		[
                //			{
                //				key: "myKey",
                //				val: "myValue",
                //				ttl: [ttl in seconds]
                //			}
                //		])
                this.mset = this.mset.bind(this);
                // ## del
                // remove keys
                // **Parameters:**
                // * `keys` ( String | Number | String|Number[] ): cache key to delete or a array of cache keys
                // **Return**
                // ( Number ): Number of deleted keys
                // **Example:**
                //	myCache.del( "myKey" )
                this.del = this.del.bind(this);
                // ## take
                // get the cached value and remove the key from the cache.
                // Equivalent to calling `get(key)` + `del(key)`.
                // Useful for implementing `single use` mechanism such as OTP, where once a value is read it will become obsolete.
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.take "myKey", ( err, val )
                this.take = this.take.bind(this);
                // ## ttl
                // reset or redefine the ttl of a key. `ttl` = 0 means infinite lifetime.
                // If `ttl` is not passed the default ttl is used.
                // If `ttl` < 0 the key will be deleted.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to reset the ttl value
                // * `ttl` ( Number ): ( optional -> options.stdTTL || 0 ) The time to live in seconds
                // **Return**
                // ( Boolen ): key found and ttl set
                // **Example:**
                //	myCache.ttl( "myKey" ) // will set ttl to default ttl
                //	myCache.ttl( "myKey", 1000 )
                this.ttl = this.ttl.bind(this);
                // ## getTtl
                // receive the ttl of a key.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Number|undefined ): The timestamp in ms when the key will expire, 0 if it will never expire or undefined if it not exists
                // **Example:**
                //	myCache.getTtl( "myKey" )
                this.getTtl = this.getTtl.bind(this);
                // ## keys
                // list all keys within this cache
                // **Return**
                // ( Array ): An array of all keys
                // **Example:**
                //     _keys = myCache.keys()
                //     # [ "foo", "bar", "fizz", "buzz", "anotherKeys" ]
                this.keys = this.keys.bind(this);
                // ## has
                // Check if a key is cached
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Boolean ): A boolean that indicates if the key is cached
                // **Example:**
                //     _exists = myCache.has('myKey')
                //     # true
                this.has = this.has.bind(this);
                // ## getStats
                // get the stats
                // **Parameters:**
                // -
                // **Return**
                // ( Object ): Stats data
                // **Example:**
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.getStats = this.getStats.bind(this);
                // ## flushAll
                // flush the whole data and reset the stats
                // **Example:**
                //     myCache.flushAll()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushAll = this.flushAll.bind(this);
                // ## flushStats
                // flush the stats and reset all counters to 0
                // **Example:**
                //     myCache.flushStats()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushStats = this.flushStats.bind(this);
                // ## close
                // This will clear the interval timeout which is set on checkperiod option.
                // **Example:**
                //     myCache.close()
                this.close = this.close.bind(this);
                // ## _checkData
                // internal housekeeping method.
                // Check all the cached data and delete the invalid values
                this._checkData = this._checkData.bind(this);
                // ## _check
                // internal method the check the value. If it's not valid any more delete it
                this._check = this._check.bind(this);
                // ## _isInvalidKey
                // internal method to check if the type of a key is either `number` or `string`
                this._isInvalidKey = this._isInvalidKey.bind(this);
                // ## _wrap
                // internal method to wrap a value in an object with some metadata
                this._wrap = this._wrap.bind(this);
                // ## _getValLength
                // internal method to calculate the value length
                this._getValLength = this._getValLength.bind(this);
                // ## _error
                // internal method to handle an error message
                this._error = this._error.bind(this);
                // ## _initErrors
                // internal method to generate error message templates
                this._initErrors = this._initErrors.bind(this);
                this.options = options;
                this._initErrors();
                // container for cached data
                this.data = {};
                // module options
                this.options = Object.assign({
                    // convert all elements to string
                    forceString: false,
                    // used standard size for calculating value size
                    objectValueSize: 80,
                    promiseValueSize: 80,
                    arrayValueSize: 40,
                    // standard time to live in seconds. 0 = infinity;
                    stdTTL: 0,
                    // time in seconds to check all data and delete expired keys
                    checkperiod: 600,
                    // en/disable cloning of variables. If `true` you'll get a copy of the cached variable. If `false` you'll save and get just the reference
                    useClones: true,
                    // whether values should be deleted automatically at expiration
                    deleteOnExpire: true,
                    // enable legacy callbacks
                    enableLegacyCallbacks: false,
                    // max amount of keys that are being stored
                    maxKeys: -1
                }, this.options);
                // generate functions with callbacks (legacy)
                if (this.options.enableLegacyCallbacks) {
                    console.warn("WARNING! node-cache legacy callback support will drop in v6.x");
                    [
                        "get",
                        "mget",
                        "set",
                        "del",
                        "ttl",
                        "getTtl",
                        "keys",
                        "has"
                    ].forEach((methodKey)=>{
                        var oldMethod;
                        // reference real function
                        oldMethod = this[methodKey];
                        this[methodKey] = function(...args) {
                            var cb, err, ref, res;
                            ref = args, [...args] = ref, [cb] = splice.call(args, -1);
                            // return a callback if cb is defined and a function
                            if (typeof cb === "function") try {
                                res = oldMethod(...args);
                                cb(null, res);
                            } catch (error1) {
                                err = error1;
                                cb(err);
                            }
                            else return oldMethod(...args, cb);
                        };
                    });
                }
                // statistics container
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // pre allocate valid keytypes array
                this.validKeyTypes = [
                    "string",
                    "number"
                ];
                // initalize checking period
                this._checkData();
                return;
            }
            get(key) {
                var _ret, err;
                boundMethodCheck(this, NodeCache);
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // get data and incremet stats
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    this.stats.hits++;
                    _ret = this._unwrap(this.data[key]);
                    // return data
                    return _ret;
                } else {
                    // if not found return undefined
                    this.stats.misses++;
                    return void 0;
                }
            }
            mget(keys) {
                var _err, err, i, key, len, oRet;
                boundMethodCheck(this, NodeCache);
                // convert a string to an array of one key
                if (!Array.isArray(keys)) {
                    _err = this._error("EKEYSTYPE");
                    throw _err;
                }
                // define return
                oRet = {};
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // get data and increment stats
                    if (this.data[key] != null && this._check(key, this.data[key])) {
                        this.stats.hits++;
                        oRet[key] = this._unwrap(this.data[key]);
                    } else // if not found return a error
                    this.stats.misses++;
                }
                // return all found keys
                return oRet;
            }
            set(key, value, ttl) {
                var _err, err, existent;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // force the data to string
                this.options.forceString;
                // set default ttl if not passed
                if (ttl == null) ttl = this.options.stdTTL;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // internal helper variables
                existent = false;
                // remove existing data from stats
                if (this.data[key]) {
                    existent = true;
                    this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                }
                // set the value
                this.data[key] = this._wrap(value, ttl);
                this.stats.vsize += this._getValLength(value);
                // only add the keys and key-size if the key is new
                if (!existent) {
                    this.stats.ksize += this._getKeyLength(key);
                    this.stats.keys++;
                }
                this.emit("set", key, value);
                // return true
                return true;
            }
            mset(keyValueSet) {
                var _err, err, i, j, key, keyValuePair, len, len1, ttl, val;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys + keyValueSet.length >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // loop over keyValueSet to validate key and ttl
                for(i = 0, len = keyValueSet.length; i < len; i++){
                    keyValuePair = keyValueSet[i];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    // check if there is ttl and it's a number
                    if (ttl && typeof ttl !== "number") {
                        _err = this._error("ETTLTYPE");
                        throw _err;
                    }
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                }
                for(j = 0, len1 = keyValueSet.length; j < len1; j++){
                    keyValuePair = keyValueSet[j];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    this.set(key, val, ttl);
                }
                return true;
            }
            del(keys) {
                var delCount, err, i, key, len, oldVal;
                boundMethodCheck(this, NodeCache);
                // convert keys to an array of itself
                if (!Array.isArray(keys)) keys = [
                    keys
                ];
                delCount = 0;
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // only delete if existent
                    if (this.data[key] != null) {
                        // calc the stats
                        this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                        this.stats.ksize -= this._getKeyLength(key);
                        this.stats.keys--;
                        delCount++;
                        // delete the value
                        oldVal = this.data[key];
                        delete this.data[key];
                        // return true
                        this.emit("del", key, oldVal.v);
                    }
                }
                return delCount;
            }
            take(key) {
                var _ret;
                boundMethodCheck(this, NodeCache);
                _ret = this.get(key);
                if (_ret != null) this.del(key);
                return _ret;
            }
            ttl(key, ttl) {
                var err;
                boundMethodCheck(this, NodeCache);
                ttl || (ttl = this.options.stdTTL);
                if (!key) return false;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existent data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    // if ttl < 0 delete the key. otherwise reset the value
                    if (ttl >= 0) this.data[key] = this._wrap(this.data[key].v, ttl, false);
                    else this.del(key);
                    return true;
                } else // return false if key has not been found
                return false;
            }
            getTtl(key) {
                var _ttl, err;
                boundMethodCheck(this, NodeCache);
                if (!key) return void 0;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existant data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    _ttl = this.data[key].t;
                    return _ttl;
                } else // return undefined if key has not been found
                return void 0;
            }
            keys() {
                var _keys;
                boundMethodCheck(this, NodeCache);
                _keys = Object.keys(this.data);
                return _keys;
            }
            has(key) {
                var _exists;
                boundMethodCheck(this, NodeCache);
                _exists = this.data[key] != null && this._check(key, this.data[key]);
                return _exists;
            }
            getStats() {
                boundMethodCheck(this, NodeCache);
                return this.stats;
            }
            flushAll(_startPeriod = true) {
                boundMethodCheck(this, NodeCache);
                // parameter just for testing
                // set data empty
                this.data = {};
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // reset check period
                this._killCheckPeriod();
                this._checkData(_startPeriod);
                this.emit("flush");
            }
            flushStats() {
                boundMethodCheck(this, NodeCache);
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                this.emit("flush_stats");
            }
            close() {
                boundMethodCheck(this, NodeCache);
                this._killCheckPeriod();
            }
            _checkData(startPeriod = true) {
                var key, ref, value;
                boundMethodCheck(this, NodeCache);
                ref = this.data;
                // run the housekeeping method
                for(key in ref){
                    value = ref[key];
                    this._check(key, value);
                }
                if (startPeriod && this.options.checkperiod > 0) {
                    this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1000, startPeriod);
                    if (this.checkTimeout != null && this.checkTimeout.unref != null) this.checkTimeout.unref();
                }
            }
            // ## _killCheckPeriod
            // stop the checkdata period. Only needed to abort the script in testing mode.
            _killCheckPeriod() {
                if (this.checkTimeout != null) return clearTimeout(this.checkTimeout);
            }
            _check(key, data) {
                var _retval;
                boundMethodCheck(this, NodeCache);
                _retval = true;
                // data is invalid if the ttl is too old and is not 0
                // console.log data.t < Date.now(), data.t, Date.now()
                if (data.t !== 0 && data.t < Date.now()) {
                    if (this.options.deleteOnExpire) {
                        _retval = false;
                        this.del(key);
                    }
                    this.emit("expired", key, this._unwrap(data));
                }
                return _retval;
            }
            _isInvalidKey(key) {
                var ref;
                boundMethodCheck(this, NodeCache);
                if (ref = typeof key, indexOf.call(this.validKeyTypes, ref) < 0) return this._error("EKEYTYPE", {
                    type: typeof key
                });
            }
            _wrap(value, ttl, asClone = true) {
                var livetime, now, oReturn, ttlMultiplicator;
                boundMethodCheck(this, NodeCache);
                if (!this.options.useClones) asClone = false;
                // define the time to live
                now = Date.now();
                livetime = 0;
                ttlMultiplicator = 1000;
                // use given ttl
                if (ttl === 0) livetime = 0;
                else if (ttl) livetime = now + ttl * ttlMultiplicator;
                else // use standard ttl
                if (this.options.stdTTL === 0) livetime = this.options.stdTTL;
                else livetime = now + this.options.stdTTL * ttlMultiplicator;
                // return the wrapped value
                return oReturn = {
                    t: livetime,
                    v: asClone ? clone(value) : value
                };
            }
            // ## _unwrap
            // internal method to extract get the value out of the wrapped value
            _unwrap(value, asClone = true) {
                if (!this.options.useClones) asClone = false;
                if (value.v != null) {
                    if (asClone) return clone(value.v);
                    else return value.v;
                }
                return null;
            }
            // ## _getKeyLength
            // internal method the calculate the key length
            _getKeyLength(key) {
                return key.toString().length;
            }
            _getValLength(value) {
                boundMethodCheck(this, NodeCache);
                if (typeof value === "string") // if the value is a String get the real length
                return value.length;
                else if (this.options.forceString) // force string if it's defined and not passed
                return JSON.stringify(value).length;
                else if (Array.isArray(value)) // if the data is an Array multiply each element with a defined default length
                return this.options.arrayValueSize * value.length;
                else if (typeof value === "number") return 8;
                else if (typeof (value != null ? value.then : void 0) === "function") // if the data is a Promise, use defined default
                // (can't calculate actual/resolved value size synchronously)
                return this.options.promiseValueSize;
                else if (typeof $e714b92b9ac856be$require$Buffer !== "undefined" && $e714b92b9ac856be$require$Buffer !== null ? $e714b92b9ac856be$require$Buffer.isBuffer(value) : void 0) return value.length;
                else if (value != null && typeof value === "object") // if the data is an Object multiply each element with a defined default length
                return this.options.objectValueSize * Object.keys(value).length;
                else if (typeof value === "boolean") return 8;
                else // default fallback
                return 0;
            }
            _error(type, data = {}) {
                var error;
                boundMethodCheck(this, NodeCache);
                // generate the error object
                error = new Error();
                error.name = type;
                error.errorcode = type;
                error.message = this.ERRORS[type] != null ? this.ERRORS[type](data) : "-";
                error.data = data;
                // return the error object
                return error;
            }
            _initErrors() {
                var _errMsg, _errT, ref;
                boundMethodCheck(this, NodeCache);
                this.ERRORS = {};
                ref = this._ERRORS;
                for(_errT in ref){
                    _errMsg = ref[_errT];
                    this.ERRORS[_errT] = this.createErrorMessage(_errMsg);
                }
            }
            createErrorMessage(errMsg) {
                return function(args) {
                    return errMsg.replace("__key", args.type);
                };
            }
        }
        NodeCache.prototype._ERRORS = {
            "ENOTFOUND": "Key `__key` not found",
            "ECACHEFULL": "Cache max keys amount exceeded",
            "EKEYTYPE": "The key argument has to be of type `string` or `number`. Found: `__key`",
            "EKEYSTYPE": "The keys argument has to be an array.",
            "ETTLTYPE": "The ttl argument has to be a number."
        };
        return NodeCache;
    }).call(this);
}).call(module.exports);

});
parcelRegister("gn15R", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $beafa4765bdd077d$export$a143d493d941bafc, (v) => $beafa4765bdd077d$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $beafa4765bdd077d$export$e4cf37d7f6fb9e0a, (v) => $beafa4765bdd077d$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $beafa4765bdd077d$export$f99ded8fe4b79145, (v) => $beafa4765bdd077d$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $beafa4765bdd077d$export$599f31c3813fae4d, (v) => $beafa4765bdd077d$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $beafa4765bdd077d$export$a143d493d941bafc;
var $beafa4765bdd077d$export$e4cf37d7f6fb9e0a;
var $beafa4765bdd077d$export$f99ded8fe4b79145;
var $beafa4765bdd077d$export$599f31c3813fae4d;
'use strict';

var $dQV3l = parcelRequire("dQV3l");

var $j26CL = parcelRequire("j26CL");
var $beafa4765bdd077d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$beafa4765bdd077d$export$a143d493d941bafc = $beafa4765bdd077d$var$Buffer;
$beafa4765bdd077d$export$e4cf37d7f6fb9e0a = $beafa4765bdd077d$var$SlowBuffer;
$beafa4765bdd077d$export$f99ded8fe4b79145 = 50;
var $beafa4765bdd077d$var$K_MAX_LENGTH = 0x7fffffff;
$beafa4765bdd077d$export$599f31c3813fae4d = $beafa4765bdd077d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $beafa4765bdd077d$var$Buffer.TYPED_ARRAY_SUPPORT = $beafa4765bdd077d$var$typedArraySupport();
if (!$beafa4765bdd077d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $beafa4765bdd077d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($beafa4765bdd077d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$beafa4765bdd077d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($beafa4765bdd077d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$beafa4765bdd077d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $beafa4765bdd077d$var$createBuffer(length) {
    if (length > $beafa4765bdd077d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $beafa4765bdd077d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $beafa4765bdd077d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $beafa4765bdd077d$var$allocUnsafe(arg);
    }
    return $beafa4765bdd077d$var$from(arg, encodingOrOffset, length);
}
$beafa4765bdd077d$var$Buffer.poolSize = 8192; // not used by this implementation
function $beafa4765bdd077d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $beafa4765bdd077d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $beafa4765bdd077d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($beafa4765bdd077d$var$isInstance(value, ArrayBuffer) || value && $beafa4765bdd077d$var$isInstance(value.buffer, ArrayBuffer)) return $beafa4765bdd077d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($beafa4765bdd077d$var$isInstance(value, SharedArrayBuffer) || value && $beafa4765bdd077d$var$isInstance(value.buffer, SharedArrayBuffer))) return $beafa4765bdd077d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $beafa4765bdd077d$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $beafa4765bdd077d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $beafa4765bdd077d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $beafa4765bdd077d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $beafa4765bdd077d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($beafa4765bdd077d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($beafa4765bdd077d$var$Buffer, Uint8Array);
function $beafa4765bdd077d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $beafa4765bdd077d$var$alloc(size, fill, encoding) {
    $beafa4765bdd077d$var$assertSize(size);
    if (size <= 0) return $beafa4765bdd077d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $beafa4765bdd077d$var$createBuffer(size).fill(fill, encoding) : $beafa4765bdd077d$var$createBuffer(size).fill(fill);
    return $beafa4765bdd077d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $beafa4765bdd077d$var$Buffer.alloc = function(size, fill, encoding) {
    return $beafa4765bdd077d$var$alloc(size, fill, encoding);
};
function $beafa4765bdd077d$var$allocUnsafe(size) {
    $beafa4765bdd077d$var$assertSize(size);
    return $beafa4765bdd077d$var$createBuffer(size < 0 ? 0 : $beafa4765bdd077d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $beafa4765bdd077d$var$Buffer.allocUnsafe = function(size) {
    return $beafa4765bdd077d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $beafa4765bdd077d$var$Buffer.allocUnsafeSlow = function(size) {
    return $beafa4765bdd077d$var$allocUnsafe(size);
};
function $beafa4765bdd077d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$beafa4765bdd077d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $beafa4765bdd077d$var$byteLength(string, encoding) | 0;
    var buf = $beafa4765bdd077d$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $beafa4765bdd077d$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $beafa4765bdd077d$var$checked(array.length) | 0;
    var buf = $beafa4765bdd077d$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $beafa4765bdd077d$var$fromArrayView(arrayView) {
    if ($beafa4765bdd077d$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $beafa4765bdd077d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $beafa4765bdd077d$var$fromArrayLike(arrayView);
}
function $beafa4765bdd077d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $beafa4765bdd077d$var$Buffer.prototype);
    return buf;
}
function $beafa4765bdd077d$var$fromObject(obj) {
    if ($beafa4765bdd077d$var$Buffer.isBuffer(obj)) {
        var len = $beafa4765bdd077d$var$checked(obj.length) | 0;
        var buf = $beafa4765bdd077d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $beafa4765bdd077d$var$numberIsNaN(obj.length)) return $beafa4765bdd077d$var$createBuffer(0);
        return $beafa4765bdd077d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $beafa4765bdd077d$var$fromArrayLike(obj.data);
}
function $beafa4765bdd077d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $beafa4765bdd077d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $beafa4765bdd077d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $beafa4765bdd077d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $beafa4765bdd077d$var$Buffer.alloc(+length);
}
$beafa4765bdd077d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $beafa4765bdd077d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$beafa4765bdd077d$var$Buffer.compare = function compare(a, b) {
    if ($beafa4765bdd077d$var$isInstance(a, Uint8Array)) a = $beafa4765bdd077d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($beafa4765bdd077d$var$isInstance(b, Uint8Array)) b = $beafa4765bdd077d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$beafa4765bdd077d$var$Buffer.isBuffer(a) || !$beafa4765bdd077d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$beafa4765bdd077d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$beafa4765bdd077d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $beafa4765bdd077d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $beafa4765bdd077d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($beafa4765bdd077d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $beafa4765bdd077d$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$beafa4765bdd077d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $beafa4765bdd077d$var$byteLength(string, encoding) {
    if ($beafa4765bdd077d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $beafa4765bdd077d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $beafa4765bdd077d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $beafa4765bdd077d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $beafa4765bdd077d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$beafa4765bdd077d$var$Buffer.byteLength = $beafa4765bdd077d$var$byteLength;
function $beafa4765bdd077d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $beafa4765bdd077d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $beafa4765bdd077d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $beafa4765bdd077d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $beafa4765bdd077d$var$latin1Slice(this, start, end);
        case 'base64':
            return $beafa4765bdd077d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $beafa4765bdd077d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$beafa4765bdd077d$var$Buffer.prototype._isBuffer = true;
function $beafa4765bdd077d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$beafa4765bdd077d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$beafa4765bdd077d$var$swap(this, i, i + 1);
    return this;
};
$beafa4765bdd077d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $beafa4765bdd077d$var$swap(this, i, i + 3);
        $beafa4765bdd077d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$beafa4765bdd077d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $beafa4765bdd077d$var$swap(this, i, i + 7);
        $beafa4765bdd077d$var$swap(this, i + 1, i + 6);
        $beafa4765bdd077d$var$swap(this, i + 2, i + 5);
        $beafa4765bdd077d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$beafa4765bdd077d$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $beafa4765bdd077d$var$utf8Slice(this, 0, length);
    return $beafa4765bdd077d$var$slowToString.apply(this, arguments);
};
$beafa4765bdd077d$var$Buffer.prototype.toLocaleString = $beafa4765bdd077d$var$Buffer.prototype.toString;
$beafa4765bdd077d$var$Buffer.prototype.equals = function equals(b) {
    if (!$beafa4765bdd077d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $beafa4765bdd077d$var$Buffer.compare(this, b) === 0;
};
$beafa4765bdd077d$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $beafa4765bdd077d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($beafa4765bdd077d$var$customInspectSymbol) $beafa4765bdd077d$var$Buffer.prototype[$beafa4765bdd077d$var$customInspectSymbol] = $beafa4765bdd077d$var$Buffer.prototype.inspect;
$beafa4765bdd077d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($beafa4765bdd077d$var$isInstance(target, Uint8Array)) target = $beafa4765bdd077d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$beafa4765bdd077d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $beafa4765bdd077d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($beafa4765bdd077d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $beafa4765bdd077d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($beafa4765bdd077d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $beafa4765bdd077d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $beafa4765bdd077d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $beafa4765bdd077d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$beafa4765bdd077d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$beafa4765bdd077d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $beafa4765bdd077d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$beafa4765bdd077d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $beafa4765bdd077d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $beafa4765bdd077d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($beafa4765bdd077d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $beafa4765bdd077d$var$utf8Write(buf, string, offset, length) {
    return $beafa4765bdd077d$var$blitBuffer($beafa4765bdd077d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $beafa4765bdd077d$var$asciiWrite(buf, string, offset, length) {
    return $beafa4765bdd077d$var$blitBuffer($beafa4765bdd077d$var$asciiToBytes(string), buf, offset, length);
}
function $beafa4765bdd077d$var$base64Write(buf, string, offset, length) {
    return $beafa4765bdd077d$var$blitBuffer($beafa4765bdd077d$var$base64ToBytes(string), buf, offset, length);
}
function $beafa4765bdd077d$var$ucs2Write(buf, string, offset, length) {
    return $beafa4765bdd077d$var$blitBuffer($beafa4765bdd077d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$beafa4765bdd077d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $beafa4765bdd077d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $beafa4765bdd077d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $beafa4765bdd077d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $beafa4765bdd077d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $beafa4765bdd077d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$beafa4765bdd077d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $beafa4765bdd077d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $dQV3l.fromByteArray(buf);
    else return $dQV3l.fromByteArray(buf.slice(start, end));
}
function $beafa4765bdd077d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $beafa4765bdd077d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $beafa4765bdd077d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $beafa4765bdd077d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $beafa4765bdd077d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $beafa4765bdd077d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $beafa4765bdd077d$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $beafa4765bdd077d$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $beafa4765bdd077d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $beafa4765bdd077d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $beafa4765bdd077d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$beafa4765bdd077d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $beafa4765bdd077d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $beafa4765bdd077d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$beafa4765bdd077d$var$Buffer.prototype.readUintLE = $beafa4765bdd077d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$beafa4765bdd077d$var$Buffer.prototype.readUintBE = $beafa4765bdd077d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$beafa4765bdd077d$var$Buffer.prototype.readUint8 = $beafa4765bdd077d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$beafa4765bdd077d$var$Buffer.prototype.readUint16LE = $beafa4765bdd077d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$beafa4765bdd077d$var$Buffer.prototype.readUint16BE = $beafa4765bdd077d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$beafa4765bdd077d$var$Buffer.prototype.readUint32LE = $beafa4765bdd077d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$beafa4765bdd077d$var$Buffer.prototype.readUint32BE = $beafa4765bdd077d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$beafa4765bdd077d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$beafa4765bdd077d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$beafa4765bdd077d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$beafa4765bdd077d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$beafa4765bdd077d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$beafa4765bdd077d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$beafa4765bdd077d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$beafa4765bdd077d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 4, this.length);
    return $j26CL.read(this, offset, true, 23, 4);
};
$beafa4765bdd077d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 4, this.length);
    return $j26CL.read(this, offset, false, 23, 4);
};
$beafa4765bdd077d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 8, this.length);
    return $j26CL.read(this, offset, true, 52, 8);
};
$beafa4765bdd077d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkOffset(offset, 8, this.length);
    return $j26CL.read(this, offset, false, 52, 8);
};
function $beafa4765bdd077d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$beafa4765bdd077d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$beafa4765bdd077d$var$Buffer.prototype.writeUintLE = $beafa4765bdd077d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $beafa4765bdd077d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$beafa4765bdd077d$var$Buffer.prototype.writeUintBE = $beafa4765bdd077d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $beafa4765bdd077d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$beafa4765bdd077d$var$Buffer.prototype.writeUint8 = $beafa4765bdd077d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$beafa4765bdd077d$var$Buffer.prototype.writeUint16LE = $beafa4765bdd077d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$beafa4765bdd077d$var$Buffer.prototype.writeUint16BE = $beafa4765bdd077d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$beafa4765bdd077d$var$Buffer.prototype.writeUint32LE = $beafa4765bdd077d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$beafa4765bdd077d$var$Buffer.prototype.writeUint32BE = $beafa4765bdd077d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$beafa4765bdd077d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $beafa4765bdd077d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$beafa4765bdd077d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $beafa4765bdd077d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$beafa4765bdd077d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$beafa4765bdd077d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$beafa4765bdd077d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$beafa4765bdd077d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$beafa4765bdd077d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $beafa4765bdd077d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $beafa4765bdd077d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $j26CL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$beafa4765bdd077d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $beafa4765bdd077d$var$writeFloat(this, value, offset, true, noAssert);
};
$beafa4765bdd077d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $beafa4765bdd077d$var$writeFloat(this, value, offset, false, noAssert);
};
function $beafa4765bdd077d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $beafa4765bdd077d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $j26CL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$beafa4765bdd077d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $beafa4765bdd077d$var$writeDouble(this, value, offset, true, noAssert);
};
$beafa4765bdd077d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $beafa4765bdd077d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$beafa4765bdd077d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$beafa4765bdd077d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$beafa4765bdd077d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$beafa4765bdd077d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $beafa4765bdd077d$var$Buffer.isBuffer(val) ? val : $beafa4765bdd077d$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $beafa4765bdd077d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $beafa4765bdd077d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($beafa4765bdd077d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $beafa4765bdd077d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $beafa4765bdd077d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $beafa4765bdd077d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $beafa4765bdd077d$var$base64ToBytes(str) {
    return $dQV3l.toByteArray($beafa4765bdd077d$var$base64clean(str));
}
function $beafa4765bdd077d$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $beafa4765bdd077d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $beafa4765bdd077d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $beafa4765bdd077d$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("dQV3l", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $029a43aa3baccf11$export$d622b2ad8d90c771, (v) => $029a43aa3baccf11$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $029a43aa3baccf11$export$6100ba28696e12de, (v) => $029a43aa3baccf11$export$6100ba28696e12de = v);
var $029a43aa3baccf11$export$a48f0734ac7c2329;
var $029a43aa3baccf11$export$d622b2ad8d90c771;
var $029a43aa3baccf11$export$6100ba28696e12de;
'use strict';
$029a43aa3baccf11$export$a48f0734ac7c2329 = $029a43aa3baccf11$var$byteLength;
$029a43aa3baccf11$export$d622b2ad8d90c771 = $029a43aa3baccf11$var$toByteArray;
$029a43aa3baccf11$export$6100ba28696e12de = $029a43aa3baccf11$var$fromByteArray;
var $029a43aa3baccf11$var$lookup = [];
var $029a43aa3baccf11$var$revLookup = [];
var $029a43aa3baccf11$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $029a43aa3baccf11$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $029a43aa3baccf11$var$i = 0, $029a43aa3baccf11$var$len = $029a43aa3baccf11$var$code.length; $029a43aa3baccf11$var$i < $029a43aa3baccf11$var$len; ++$029a43aa3baccf11$var$i){
    $029a43aa3baccf11$var$lookup[$029a43aa3baccf11$var$i] = $029a43aa3baccf11$var$code[$029a43aa3baccf11$var$i];
    $029a43aa3baccf11$var$revLookup[$029a43aa3baccf11$var$code.charCodeAt($029a43aa3baccf11$var$i)] = $029a43aa3baccf11$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$029a43aa3baccf11$var$revLookup['-'.charCodeAt(0)] = 62;
$029a43aa3baccf11$var$revLookup['_'.charCodeAt(0)] = 63;
function $029a43aa3baccf11$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $029a43aa3baccf11$var$byteLength(b64) {
    var lens = $029a43aa3baccf11$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $029a43aa3baccf11$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $029a43aa3baccf11$var$toByteArray(b64) {
    var tmp;
    var lens = $029a43aa3baccf11$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $029a43aa3baccf11$var$Arr($029a43aa3baccf11$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i)] << 18 | $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i)] << 2 | $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i)] << 10 | $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $029a43aa3baccf11$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $029a43aa3baccf11$var$tripletToBase64(num) {
    return $029a43aa3baccf11$var$lookup[num >> 18 & 0x3F] + $029a43aa3baccf11$var$lookup[num >> 12 & 0x3F] + $029a43aa3baccf11$var$lookup[num >> 6 & 0x3F] + $029a43aa3baccf11$var$lookup[num & 0x3F];
}
function $029a43aa3baccf11$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($029a43aa3baccf11$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $029a43aa3baccf11$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($029a43aa3baccf11$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($029a43aa3baccf11$var$lookup[tmp >> 2] + $029a43aa3baccf11$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($029a43aa3baccf11$var$lookup[tmp >> 10] + $029a43aa3baccf11$var$lookup[tmp >> 4 & 0x3F] + $029a43aa3baccf11$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("j26CL", function(module, exports) {
$parcel$export(module.exports, "read", () => $ddb357a3902145f4$export$aafa59e2e03f2942, (v) => $ddb357a3902145f4$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $ddb357a3902145f4$export$68d8715fc104d294, (v) => $ddb357a3902145f4$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ddb357a3902145f4$export$aafa59e2e03f2942;
var $ddb357a3902145f4$export$68d8715fc104d294;
$ddb357a3902145f4$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ddb357a3902145f4$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6co1L", function(module, exports) {

var $gn15R = parcelRequire("gn15R");
var $4836806a64cecb60$require$Buffer = $gn15R.Buffer;
var $4836806a64cecb60$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $4836806a64cecb60$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $4836806a64cecb60$require$Buffer.isBuffer(parent)) {
                if ($4836806a64cecb60$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $4836806a64cecb60$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $4836806a64cecb60$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (module.exports) module.exports = $4836806a64cecb60$var$clone;

});

parcelRegister("03cmj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $0099de246b25ffbe$var$R = typeof Reflect === 'object' ? Reflect : null;
var $0099de246b25ffbe$var$ReflectApply = $0099de246b25ffbe$var$R && typeof $0099de246b25ffbe$var$R.apply === 'function' ? $0099de246b25ffbe$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $0099de246b25ffbe$var$ReflectOwnKeys;
if ($0099de246b25ffbe$var$R && typeof $0099de246b25ffbe$var$R.ownKeys === 'function') $0099de246b25ffbe$var$ReflectOwnKeys = $0099de246b25ffbe$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $0099de246b25ffbe$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $0099de246b25ffbe$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $0099de246b25ffbe$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $0099de246b25ffbe$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $0099de246b25ffbe$var$EventEmitter() {
    $0099de246b25ffbe$var$EventEmitter.init.call(this);
}
module.exports = $0099de246b25ffbe$var$EventEmitter;
module.exports.once = $0099de246b25ffbe$var$once;
// Backwards-compat with node 0.10.x
$0099de246b25ffbe$var$EventEmitter.EventEmitter = $0099de246b25ffbe$var$EventEmitter;
$0099de246b25ffbe$var$EventEmitter.prototype._events = undefined;
$0099de246b25ffbe$var$EventEmitter.prototype._eventsCount = 0;
$0099de246b25ffbe$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $0099de246b25ffbe$var$defaultMaxListeners = 10;
function $0099de246b25ffbe$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($0099de246b25ffbe$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $0099de246b25ffbe$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $0099de246b25ffbe$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $0099de246b25ffbe$var$defaultMaxListeners = arg;
    }
});
$0099de246b25ffbe$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$0099de246b25ffbe$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $0099de246b25ffbe$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $0099de246b25ffbe$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $0099de246b25ffbe$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$0099de246b25ffbe$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $0099de246b25ffbe$var$_getMaxListeners(this);
};
$0099de246b25ffbe$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $0099de246b25ffbe$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $0099de246b25ffbe$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$0099de246b25ffbe$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $0099de246b25ffbe$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $0099de246b25ffbe$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $0099de246b25ffbe$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $0099de246b25ffbe$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$0099de246b25ffbe$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $0099de246b25ffbe$var$_addListener(this, type, listener, false);
};
$0099de246b25ffbe$var$EventEmitter.prototype.on = $0099de246b25ffbe$var$EventEmitter.prototype.addListener;
$0099de246b25ffbe$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $0099de246b25ffbe$var$_addListener(this, type, listener, true);
};
function $0099de246b25ffbe$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $0099de246b25ffbe$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $0099de246b25ffbe$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$0099de246b25ffbe$var$EventEmitter.prototype.once = function once(type, listener) {
    $0099de246b25ffbe$var$checkListener(listener);
    this.on(type, $0099de246b25ffbe$var$_onceWrap(this, type, listener));
    return this;
};
$0099de246b25ffbe$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $0099de246b25ffbe$var$checkListener(listener);
    this.prependListener(type, $0099de246b25ffbe$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$0099de246b25ffbe$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $0099de246b25ffbe$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $0099de246b25ffbe$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$0099de246b25ffbe$var$EventEmitter.prototype.off = $0099de246b25ffbe$var$EventEmitter.prototype.removeListener;
$0099de246b25ffbe$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $0099de246b25ffbe$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $0099de246b25ffbe$var$unwrapListeners(evlistener) : $0099de246b25ffbe$var$arrayClone(evlistener, evlistener.length);
}
$0099de246b25ffbe$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $0099de246b25ffbe$var$_listeners(this, type, true);
};
$0099de246b25ffbe$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $0099de246b25ffbe$var$_listeners(this, type, false);
};
$0099de246b25ffbe$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $0099de246b25ffbe$var$listenerCount.call(emitter, type);
};
$0099de246b25ffbe$var$EventEmitter.prototype.listenerCount = $0099de246b25ffbe$var$listenerCount;
function $0099de246b25ffbe$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$0099de246b25ffbe$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $0099de246b25ffbe$var$ReflectOwnKeys(this._events) : [];
};
function $0099de246b25ffbe$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $0099de246b25ffbe$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $0099de246b25ffbe$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $0099de246b25ffbe$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $0099de246b25ffbe$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $0099de246b25ffbe$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $0099de246b25ffbe$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $0099de246b25ffbe$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $0099de246b25ffbe$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("gEVth", function(module, exports) {
$parcel$export(module.exports, "AnalyticsActionSubjects", () => $c6b42ac77bfe252b$export$5378e27bf4bd9964);
$parcel$export(module.exports, "AnalyticsTrackActions", () => $c6b42ac77bfe252b$export$66cb7b42e8abaf2a);
$parcel$export(module.exports, "trackIssueEvent", () => $c6b42ac77bfe252b$export$a5fa4cf2c5c28270);
$parcel$export(module.exports, "trackIssueEventNext", () => $c6b42ac77bfe252b$export$3967c914d9a6a7eb);
$parcel$export(module.exports, "trackRequestCreateNonGenericErrors", () => $c6b42ac77bfe252b$export$6d75dc6487ba0729);
$parcel$export(module.exports, "firstInteraction", () => $c6b42ac77bfe252b$export$f90e311dc845e78d);
$parcel$export(module.exports, "uiEvent", () => $c6b42ac77bfe252b$export$62d6d0288077e3fc);
$parcel$export(module.exports, "operationalEvent", () => $c6b42ac77bfe252b$export$396108a0e963cc78);
$parcel$export(module.exports, "ConnectRequestCreateEventType", () => $c6b42ac77bfe252b$export$814045484cc5c60c);
$parcel$export(module.exports, "sendConnectTimeoutEventForRequestCreation", () => $c6b42ac77bfe252b$export$bd82f0e8f384bdee);
$parcel$export(module.exports, "composeAnalyticsEvent", () => $c6b42ac77bfe252b$export$812115af7f978952);

var $4ZMmh = parcelRequire("4ZMmh");

var $haAAx = parcelRequire("haAAx");

var $jcRK7 = parcelRequire("jcRK7");

var $a6ENB = parcelRequire("a6ENB");

var $iRD29 = parcelRequire("iRD29");
var $c6b42ac77bfe252b$export$5378e27bf4bd9964 = /*#__PURE__*/ function(AnalyticsActionSubjects) {
    AnalyticsActionSubjects["ISSUE"] = "issue";
    AnalyticsActionSubjects["FORM"] = "form";
    AnalyticsActionSubjects["COMMENT"] = "comment";
    AnalyticsActionSubjects["REQUEST_TYPE"] = "issueType";
    AnalyticsActionSubjects["REQUEST_TYPE_GROUP"] = "requestTypeGroup";
    return AnalyticsActionSubjects;
}({});
var $c6b42ac77bfe252b$export$66cb7b42e8abaf2a = /*#__PURE__*/ function(AnalyticsTrackActions) {
    AnalyticsTrackActions["CREATED"] = "created";
    AnalyticsTrackActions["DELETED"] = "deleted";
    AnalyticsTrackActions["UPDATED"] = "updated";
    AnalyticsTrackActions["VIEWED"] = "viewed";
    AnalyticsTrackActions["FETCHED"] = "fetched";
    AnalyticsTrackActions["CREATED_FAILURE"] = "created_failure";
    AnalyticsTrackActions["DELETED_FAILURE"] = "deleted_failure";
    AnalyticsTrackActions["UPDATED_FAILURE"] = "updated_failure";
    AnalyticsTrackActions["FETCHED_FAILURE"] = "fetched_failure";
    return AnalyticsTrackActions;
}({});
var $c6b42ac77bfe252b$export$3b99c8679ca910fe = /*#__PURE__*/ function(AnalyticsUIActions) {
    AnalyticsUIActions["CLICKED"] = "clicked";
    return AnalyticsUIActions;
}({});
const $c6b42ac77bfe252b$var$defaultTrackData = {
    source: 'portalScreen'
};
const $c6b42ac77bfe252b$var$issueTrackData = {
    ...$c6b42ac77bfe252b$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "issue"
};
function $c6b42ac77bfe252b$var$getUserRole(user, portal) {
    if (user.getAccountId()) {
        if (portal && portal.getPortalAnnouncement().getCanAdministerProject()) return 'agent-project-admin';
        if (user.getAgentForPortal()) return 'agent';
        return 'customer';
    }
    return 'anonymous';
}
const $c6b42ac77bfe252b$var$getDefaultAttributes = (user, portal)=>({
        attributes: {
            jsdRole: $c6b42ac77bfe252b$var$getUserRole(user, portal),
            projectType: 'serviceDesk'
        }
    });
function $c6b42ac77bfe252b$export$a5fa4cf2c5c28270(data, user, portal) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $4ZMmh.defaultsDeep)($c6b42ac77bfe252b$var$getDefaultAttributes(user, portal), $c6b42ac77bfe252b$var$issueTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackIssueEvent: failed to send analytics data', err);
        }
    }
}
function $c6b42ac77bfe252b$export$3967c914d9a6a7eb(data, user, createAnalyticsEvent, portal) {
    try {
        const trackData = {
            analyticsType: 'TRACK',
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            ...$c6b42ac77bfe252b$var$issueTrackData,
            ...$c6b42ac77bfe252b$var$getDefaultAttributes(user, portal).attributes,
            ...data.attributes
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.fire();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('trackIssueEventNext: failed to send analytics data', err);
    }
}
function $c6b42ac77bfe252b$export$6d75dc6487ba0729(errors, createAnalyticsEvent) {
    if (!createAnalyticsEvent) return;
    try {
        // Refrain from passing error messages from fieldError and submissionError to avoid PII logging
        const { errorReasonKey: errorReasonKey, traceId: traceId, fieldErrors: fieldErrors = {}, submissionError: submissionError = {} } = errors;
        const trackData = {
            errorReasonKey: errorReasonKey,
            traceId: traceId,
            hasSubmissionErrors: Object.keys(submissionError).length > 0,
            hasFieldErrors: Object.keys(fieldErrors).length > 0,
            analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
            action: 'failed',
            actionSubject: 'requestCreateNonGenericError'
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.context.push({
            componentName: 'requestCreateNonGenericError'
        });
        analyticsEvent.fire();
    } catch (err) {
        (0, $a6ENB.reportError)(err, {
            message: 'trackRequestCreateNonGenericErrors: failed to send analytics data'
        });
    }
}
let $c6b42ac77bfe252b$var$firstInteractionTracked = false;
function $c6b42ac77bfe252b$export$f90e311dc845e78d(data) {
    // In the interest of not spamming the analytics server, we try to limit this request to one per tab.
    // This does not guarantee that there is only 1 event fired per interaction as the user can start interaction on a separate tab
    if (!$c6b42ac77bfe252b$var$firstInteractionTracked) {
        $c6b42ac77bfe252b$var$firstInteractionTracked = true;
        const combinedData = {
            action: 'firstPortalMeaningfulInteraction',
            actionSubject: data.actionSubject,
            source: data.source,
            attributes: {
                isNewPortal: String(!!data.isNewPortal)
            }
        };
        $c6b42ac77bfe252b$export$62d6d0288077e3fc(combinedData);
    }
}
function $c6b42ac77bfe252b$export$62d6d0288077e3fc(data) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $4ZMmh.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendUIEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('uiEvent: failed to send analytics data', err);
        }
    }
}
function $c6b42ac77bfe252b$export$396108a0e963cc78(data) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $4ZMmh.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendOperationalEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('operationalEvent: failed to send analytics data', err);
        }
    }
}
const $c6b42ac77bfe252b$var$commentTrackData = {
    ...$c6b42ac77bfe252b$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "comment"
};
function $c6b42ac77bfe252b$export$ef4b02ed2d124f10(data, user, portal) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $4ZMmh.defaultsDeep)($c6b42ac77bfe252b$var$getDefaultAttributes(user, portal), $c6b42ac77bfe252b$var$commentTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            actionSubjectId: data.commentId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackCommentEvent: failed to send analytics data', err);
        }
    }
}
var $c6b42ac77bfe252b$export$814045484cc5c60c = /*#__PURE__*/ function(ConnectRequestCreateEventType) {
    ConnectRequestCreateEventType["VALIDATE"] = "connectValidationTimedOut";
    ConnectRequestCreateEventType["SERIALIZE"] = "connectSerializationTimedOut";
    ConnectRequestCreateEventType["LEGACY"] = "connectValidationOrSerializationTimedOut";
    return ConnectRequestCreateEventType;
}({});
function $c6b42ac77bfe252b$export$bd82f0e8f384bdee(eventType, connectKey, requestTypeId) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) try {
        const event = {
            actionSubject: 'connectKey.requestType',
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            actionSubjectId: `${connectKey}.${requestTypeId}`
        };
        if (eventType === "connectValidationOrSerializationTimedOut") {
            event.actionSubject = 'requestType';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            event.actionSubjectId = `${requestTypeId}`;
        }
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsWebClient.getInstance().sendOperationalEvent({
            action: eventType,
            actionSubject: event.actionSubject,
            actionSubjectId: event.actionSubjectId,
            source: (0, $jcRK7.ScreenName).REQUEST_CREATE
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('sendConnectTimeoutEventForRequestCreation: failed to send analytics data', err);
    }
}
const $c6b42ac77bfe252b$export$812115af7f978952 = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent) return createAnalyticsEvent({
            analyticsType: payload.analyticsType,
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: payload.actionSubjectId,
            ...payload.attributes
        });
        return undefined;
    };

});

parcelRegister("1btpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $958228e47acb55d1$export$2e2bcd8739ae039);
/**
 * Util to help pre-fetching of initial model data
 */ 
var $4U3zK = parcelRequire("4U3zK");

var $hCnLH = parcelRequire("hCnLH");
let $958228e47acb55d1$var$cachedObject;
var $958228e47acb55d1$export$2e2bcd8739ae039 = ()=>{
    const jsonPayload = (0, $4U3zK.default).getElementById('jsonPayload');
    if (!$958228e47acb55d1$var$cachedObject) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $958228e47acb55d1$var$cachedObject = jsonPayload && jsonPayload.textContent && JSON.parse(jsonPayload.textContent) || {};
    if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)()) {
        delete $958228e47acb55d1$var$cachedObject.helpCenterBranding;
        delete $958228e47acb55d1$var$cachedObject.featuredAndSortedPortals;
        delete $958228e47acb55d1$var$cachedObject.loginAnnouncements;
    }
    return $958228e47acb55d1$var$cachedObject;
};
const $958228e47acb55d1$export$246d7bb795c4c0e = ()=>{
    $958228e47acb55d1$var$cachedObject = undefined;
};

});


parcelRegister("awkgb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47952cb34905abd5$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $1DGz6 = parcelRequire("1DGz6");


var $47952cb34905abd5$export$2e2bcd8739ae039 = (0, $1DGz6.default);

});
parcelRegister("1DGz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $418db57878e59325$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $40GmU = parcelRequire("40GmU");

var $7RHfd = parcelRequire("7RHfd");

var $actRr = parcelRequire("actRr");

var $aae7p = parcelRequire("aae7p");

var $ecrda = parcelRequire("ecrda");

var $dH1v3 = parcelRequire("dH1v3");

var $2FLYp = parcelRequire("2FLYp");

var $lmUvw = parcelRequire("lmUvw");

var $cSYYL = parcelRequire("cSYYL");

var $juFEH = parcelRequire("juFEH");

var $lIf8L = parcelRequire("lIf8L");

var $3NMgN = parcelRequire("3NMgN");

var $5DSgV = parcelRequire("5DSgV");

var $c1B2A = parcelRequire("c1B2A");
let $418db57878e59325$var$tryCompleteHandle;
/** A portion of the page we apply measurement to */ const $418db57878e59325$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party', excludeFromMetrics: excludeFromMetrics = false })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $aae7p.isUFOEnabled)();
    const parentContext = (0, $bSJIT.useContext)((0, $lmUvw.default));
    const segmentIdMap = (0, $bSJIT.useMemo)(()=>{
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $bSJIT.useMemo)(()=>{
        if (mode === 'single') return (0, $3NMgN.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $3NMgN.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $bSJIT.useMemo)(()=>{
        // Only stamp `excludeFromMetrics` alongside a third-party type.
        // So it can never remove first-party work from metrics.
        const label = {
            name: segmentName,
            segmentId: segmentId,
            ...type !== 'first-party' ? {
                type: type
            } : {},
            // Only pass non-default types (not 'first-party') in payload to reduce size
            ...excludeFromMetrics && type === 'third-party' ? {
                excludeFromMetrics: true
            } : {}
        };
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [
            ...parentContext.labelStack,
            label
        ] : [
            label
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type,
        excludeFromMetrics
    ]);
    const interactionId = (0, $bSJIT.useContext)((0, $cSYYL.default));
    const interactionContext = (0, $bSJIT.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($418db57878e59325$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($418db57878e59325$var$tryCompleteHandle);
                    }
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            const isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $418db57878e59325$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $418db57878e59325$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $juFEH.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $juFEH.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $40GmU.unstable_scheduleCallback)((0, $40GmU.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $juFEH.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $juFEH.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $juFEH.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $aae7p.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $aae7p.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    const activeInteraction = (0, $juFEH.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $juFEH.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $aae7p.getInteractionRate)(name, 'press');
                if ((0, $actRr.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $7RHfd.default)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $2FLYp.setInteractionActiveTrace)(newId, 'press');
                    (0, $juFEH.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $lIf8L.default).current, (0, $dH1v3.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $juFEH.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $juFEH.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $juFEH.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $juFEH.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $juFEH.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $juFEH.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $juFEH.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $juFEH.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $5DSgV.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $bSJIT.useRef)(false);
    const onRender = (0, $bSJIT.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $aae7p.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $bSJIT.useEffect)(()=>{
        (0, $juFEH.addSegment)(labelStack);
        return ()=>{
            (0, $juFEH.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $bSJIT.useMemo)(()=>labelStack.map((l)=>(0, $ecrda.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lmUvw.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c1B2A.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
$418db57878e59325$var$UFOSegment.displayName = 'UFOSegment';
var $418db57878e59325$export$2e2bcd8739ae039 = $418db57878e59325$var$UFOSegment;

});
parcelRegister("2FLYp", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $214984a3cd252c8f$export$f2e521e495a88544);

var $5Uji8 = parcelRequire("5Uji8");

var $JuT7H = parcelRequire("JuT7H");
function $214984a3cd252c8f$export$f2e521e495a88544(interactionId, experienceType) {
    (0, $JuT7H.setActiveTrace)(interactionId.replace(/-/g, ''), (0, $5Uji8.generateSpanId)(), experienceType);
}

});
parcelRegister("5Uji8", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $003e33a34e118cef$export$295213bc4d0c54ad);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
function $003e33a34e118cef$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("JuT7H", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $fe0fcb1ce9e93067$export$a1002be327997103);

var $j3jZT = parcelRequire("j3jZT");

var $gdUUy = parcelRequire("gdUUy");

var $kGyQS = parcelRequire("kGyQS");

var $c0tNN = parcelRequire("c0tNN");

var $a2arA = parcelRequire("a2arA");

var $cGQlM = parcelRequire("cGQlM");

var $4VOnD = parcelRequire("4VOnD");
function $fe0fcb1ce9e93067$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $gdUUy.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $j3jZT.ROOT_CONTEXT).setValue((0, $4VOnD.traceIdKey), traceId).setValue((0, $a2arA.spanIdKey), spanId).setValue((0, $c0tNN.experienceTypeKey), type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $kGyQS.getContextManager)() instanceof (0, $kGyQS.UFOContextManager)) {
            let contextManager = (0, $kGyQS.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else (0, $cGQlM.state).context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}

});


parcelRegister("lmUvw", function(module, exports) {
$parcel$export(module.exports, "default", () => $817e65bbba243252$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cyIUy = parcelRequire("cyIUy");

var $817e65bbba243252$export$2e2bcd8739ae039 = (0, $cyIUy.default);

});

parcelRegister("cSYYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c3be1549a7bd706$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $bSJIT = parcelRequire("bSJIT");

var $3GoE4 = parcelRequire("3GoE4");



// We use a context to allow modals to have their own lifecycle
const $1c3be1549a7bd706$var$interactionContext = (0, $bSJIT.createContext)((0, $3GoE4.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1c3be1549a7bd706$export$2e2bcd8739ae039 = $1c3be1549a7bd706$var$interactionContext;

});

parcelRegister("3NMgN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c183add0ce5461bf$export$2e2bcd8739ae039);
function $c183add0ce5461bf$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $c183add0ce5461bf$export$2e2bcd8739ae039 = $c183add0ce5461bf$var$generateId;

});

parcelRegister("5DSgV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e649c792a79f1b83$export$2e2bcd8739ae039);

var $4eGW1 = parcelRequire("4eGW1");
function $e649c792a79f1b83$var$scheduleOnPaint(callback) {
    var _process, _globalThis$document;
    const isSSR = typeof window === 'undefined' || Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $4eGW1 !== 'undefined' && Boolean((_process = $4eGW1) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $e649c792a79f1b83$export$2e2bcd8739ae039 = $e649c792a79f1b83$var$scheduleOnPaint;

});

parcelRegister("c1B2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $534db418b1b82cc6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $3vMl6 = parcelRequire("3vMl6");

var $dPiW0 = parcelRequire("dPiW0");

var $4eGW1 = parcelRequire("4eGW1");
var $534db418b1b82cc6$var$_process;
const $534db418b1b82cc6$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $4eGW1 !== 'undefined' && Boolean((($534db418b1b82cc6$var$_process = $4eGW1) === null || $534db418b1b82cc6$var$_process === void 0 || ($534db418b1b82cc6$var$_process = $534db418b1b82cc6$var$_process.env) === null || $534db418b1b82cc6$var$_process === void 0 ? void 0 : $534db418b1b82cc6$var$_process.REACT_SSR) || false);
const $534db418b1b82cc6$var$SsrRenderProfiler = (props)=>{
    if ($534db418b1b82cc6$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dPiW0.SsrRenderProfilerInner), props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3vMl6.ProfilerMarker), null), props.children);
};
var $534db418b1b82cc6$export$2e2bcd8739ae039 = $534db418b1b82cc6$var$SsrRenderProfiler;

});
parcelRegister("3vMl6", function(module, exports) {
$parcel$export(module.exports, "ProfilerMarker", () => $81f0f721e7f52c17$export$18d523e2a9aac2d9);
const $81f0f721e7f52c17$export$18d523e2a9aac2d9 = ({ onRender: onRender })=>{
    onRender === null || onRender === void 0 || onRender();
    return null;
};

});

parcelRegister("dPiW0", function(module, exports) {
$parcel$export(module.exports, "SsrRenderProfilerInner", () => $caaec554eef63181$export$b8bd105b650b1c1e);

var $bSJIT = parcelRequire("bSJIT");

var $aae7p = parcelRequire("aae7p");

var $ecrda = parcelRequire("ecrda");

var $juFEH = parcelRequire("juFEH");

var $eOpdH = parcelRequire("eOpdH");

var $3vMl6 = parcelRequire("3vMl6");

var $khqjG = parcelRequire("khqjG");
function $caaec554eef63181$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    const activeInteractionId = (_getActiveInteraction = (0, $juFEH.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!(0, $khqjG.default).lastActiveInteraction && (0, $khqjG.default).lastActiveInteraction !== activeInteractionId) (0, $eOpdH.clearState)();
    (0, $khqjG.default).lastActiveInteraction = activeInteractionId;
}
const $caaec554eef63181$var$getIsNativeTracingEnabled = ()=>{
    var _getConfig;
    return ((_getConfig = (0, $aae7p.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) ?? false;
};
const $caaec554eef63181$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    var _state$startTimes$get, _vm_internals__;
    if (!(0, $khqjG.default).startTimes.has(id)) (0, $khqjG.default).startTimes.set(id, []);
    (_state$startTimes$get = (0, $khqjG.default).startTimes.get(id)) === null || _state$startTimes$get === void 0 || _state$startTimes$get.push(performance.now());
    if (!$caaec554eef63181$var$getIsNativeTracingEnabled()) return null;
    const startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    let spanState = (0, $khqjG.default).spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        (0, $khqjG.default).spanStates.set(id, spanState);
    }
    return spanState;
};
const $caaec554eef63181$var$ParentSpanContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $caaec554eef63181$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $bSJIT.useMemo)(()=>labelStack.map((l)=>(0, $ecrda.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $caaec554eef63181$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $bSJIT.useContext)($caaec554eef63181$var$ParentSpanContext);
    const currentSpanState = $caaec554eef63181$var$onStartRender(reactProfilerId, (0, $ecrda.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($caaec554eef63181$var$ParentSpanContext.Provider, {
        value: (currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3vMl6.ProfilerMarker), {
        onRender: ()=>{
            const startTimesForId = (0, $khqjG.default).startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = (0, $khqjG.default).spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};

});
parcelRegister("eOpdH", function(module, exports) {
$parcel$export(module.exports, "clearState", () => $f5e9c96700287d63$export$cf4e4023c0a34c8d);

var $khqjG = parcelRequire("khqjG");
const $f5e9c96700287d63$export$cf4e4023c0a34c8d = ()=>{
    (0, $khqjG.default).startTimes.clear();
    (0, $khqjG.default).spanStates.clear();
};

});





parcelRegister("hDP4J", function(module, exports) {
$parcel$export(module.exports, "install", () => $0a62cb1a7c2430ea$export$4b3e715f166fdd78);

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("ckSGE");
var $gIFN2 = parcelRequire("gIFN2");
parcelRequire("iX6PB");
var $1oYUn = parcelRequire("1oYUn");
const $0a62cb1a7c2430ea$export$4b3e715f166fdd78 = (0, $4ZMmh.once)(()=>{
    // asset-field-value is rendered on Request Details; it displays the names of assets linked to the request
    if (typeof window !== 'undefined' && window.customElements) {
        customElements.define('asset-field-value', (0, $gIFN2.getAssetFieldValueElementClass)());
        customElements.define('cmdb-field-value', (0, $1oYUn.getCmdbFieldValueElement)());
    }
});

});
parcelRegister("ckSGE", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => (parcelRequire("gIFN2")).getAssetFieldValueElementClass);

var $gIFN2 = parcelRequire("gIFN2");

});
parcelRegister("gIFN2", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => $9e7d9a5e9ef1385d$export$586e8886906ef36f);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $fuVmc = parcelRequire("fuVmc");

var $dTM5i = parcelRequire("dTM5i");

var $amYpB = parcelRequire("amYpB");

var $81Vbr = parcelRequire("81Vbr");

var $a6ENB = parcelRequire("a6ENB");

var $Jze2i = parcelRequire("Jze2i");
const $9e7d9a5e9ef1385d$var$onIntlError = (intlError)=>{
    try {
        $a6ENB.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $9e7d9a5e9ef1385d$export$3bcefabe8b04378c = (intlError)=>{
    $9e7d9a5e9ef1385d$var$onIntlError(intlError.message);
};
const $9e7d9a5e9ef1385d$export$586e8886906ef36f = ()=>{
    class AssetFieldValueElement extends HTMLElement {
        connectedCallback() {
            // create a Shadow DOM (i.e. the contents of this web component)
            const shadow = this.attachShadow({
                mode: 'open'
            });
            // Jira passes the asset's origin as a data-origin attribute
            const origin = this.getAttribute('data-origin');
            // render the component with its props, and add to the Shadow DOM
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const root = document.createElement('span');
            // eslint-disable-next-line react/no-deprecated
            $4Sf72.render(/*#__PURE__*/ $bSJIT.createElement((0, $dTM5i.default), {
                messages: (0, $amYpB.default)(),
                locale: (0, $81Vbr.getLanguageFromLocale)((0, $fuVmc.getMetaData)().userLocale),
                onError: $9e7d9a5e9ef1385d$export$3bcefabe8b04378c
            }, /*#__PURE__*/ $bSJIT.createElement((0, $Jze2i.default), {
                origin: origin
            })), root);
            shadow.appendChild(root);
        }
    }
    return AssetFieldValueElement;
};

});
parcelRegister("dTM5i", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1e5b60192023549$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3Cq0D = parcelRequire("3Cq0D");

var $9WiA8 = parcelRequire("9WiA8");

var $bSJIT = parcelRequire("bSJIT");

var $dETlE = parcelRequire("dETlE");

var $2z7V1 = parcelRequire("2z7V1");

var $fK3tS = parcelRequire("fK3tS");
function $a1e5b60192023549$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $a1e5b60192023549$var$IntlProvider = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $9WiA8.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $2z7V1.createIntl)($a1e5b60192023549$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $a1e5b60192023549$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $a1e5b60192023549$var$processIntlConfig(props);
        if (!(0, $dETlE.shallowEqual)(prevConfig, config)) return {
            intl: (0, $2z7V1.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $dETlE.invariantIntlContext)(this.state.intl);
        return $bSJIT.createElement((0, $fK3tS.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $dETlE.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($bSJIT.PureComponent);
var $a1e5b60192023549$export$2e2bcd8739ae039 = $a1e5b60192023549$var$IntlProvider;

});
parcelRegister("9WiA8", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $73c7f1d0105b2262$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $73c7f1d0105b2262$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $73c7f1d0105b2262$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $73c7f1d0105b2262$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $73c7f1d0105b2262$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $73c7f1d0105b2262$export$4ee1db8ce44a209b);

var $3Cq0D = parcelRequire("3Cq0D");

var $hMpr9 = parcelRequire("hMpr9");
parcelRequire("bKFPg");
var $2JWc7 = parcelRequire("2JWc7");

var $2lffa = parcelRequire("2lffa");
function $73c7f1d0105b2262$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $73c7f1d0105b2262$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $73c7f1d0105b2262$var$defaultErrorHandler = function(error) {};
var $73c7f1d0105b2262$var$defaultWarnHandler = function(warning) {};
var $73c7f1d0105b2262$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $73c7f1d0105b2262$var$defaultErrorHandler,
    onWarn: $73c7f1d0105b2262$var$defaultWarnHandler
};
function $73c7f1d0105b2262$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $73c7f1d0105b2262$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $73c7f1d0105b2262$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $73c7f1d0105b2262$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $hMpr9.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3Cq0D.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $hMpr9.strategies).variadic
    });
    var getNumberFormat = (0, $hMpr9.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3Cq0D.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.number),
        strategy: (0, $hMpr9.strategies).variadic
    });
    var getPluralRules = (0, $hMpr9.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3Cq0D.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $hMpr9.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $hMpr9.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $2JWc7.IntlMessageFormat)(message, locales, overrideFormats, (0, $3Cq0D.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.message),
            strategy: (0, $hMpr9.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $hMpr9.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $3Cq0D.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $hMpr9.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $hMpr9.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $3Cq0D.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.list),
            strategy: (0, $hMpr9.strategies).variadic
        }),
        getDisplayNames: (0, $hMpr9.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $3Cq0D.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $73c7f1d0105b2262$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $hMpr9.strategies).variadic
        })
    };
}
function $73c7f1d0105b2262$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $2lffa.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("hMpr9", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $cf1aa697d67130bd$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $cf1aa697d67130bd$export$c5491a8691a23b9e);
//
// Main
//
function $cf1aa697d67130bd$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $cf1aa697d67130bd$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $cf1aa697d67130bd$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $cf1aa697d67130bd$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $cf1aa697d67130bd$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $cf1aa697d67130bd$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $cf1aa697d67130bd$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $cf1aa697d67130bd$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $cf1aa697d67130bd$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $cf1aa697d67130bd$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $cf1aa697d67130bd$var$monadic : $cf1aa697d67130bd$var$variadic;
    return $cf1aa697d67130bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $cf1aa697d67130bd$var$strategyVariadic(fn, options) {
    return $cf1aa697d67130bd$var$assemble(fn, this, $cf1aa697d67130bd$var$variadic, options.cache.create(), options.serializer);
}
function $cf1aa697d67130bd$var$strategyMonadic(fn, options) {
    return $cf1aa697d67130bd$var$assemble(fn, this, $cf1aa697d67130bd$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $cf1aa697d67130bd$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $cf1aa697d67130bd$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $cf1aa697d67130bd$var$cacheDefault = {
    create: function create() {
        return new $cf1aa697d67130bd$var$ObjectWithoutPrototypeCache();
    }
};
var $cf1aa697d67130bd$export$c5491a8691a23b9e = {
    variadic: $cf1aa697d67130bd$var$strategyVariadic,
    monadic: $cf1aa697d67130bd$var$strategyMonadic
};

});

parcelRegister("bKFPg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("hZIq9")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("hZIq9")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("8MStW")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("2JWc7")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $2JWc7 = parcelRequire("2JWc7");
parcelRequire("hZIq9");
parcelRequire("8MStW");
var $88e46f4dcef0140e$export$2e2bcd8739ae039 = (0, $2JWc7.IntlMessageFormat);

});
parcelRegister("2JWc7", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $1fececedf55e3388$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $3Cq0D = parcelRequire("3Cq0D");

var $hMpr9 = parcelRequire("hMpr9");

var $h5P6y = parcelRequire("h5P6y");

var $8MStW = parcelRequire("8MStW");
// -- MessageFormat --------------------------------------------------------
function $1fececedf55e3388$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $1fececedf55e3388$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $1fececedf55e3388$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $3Cq0D.__assign)({}, defaultConfig));
}
function $1fececedf55e3388$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $1fececedf55e3388$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $hMpr9.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3Cq0D.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1fececedf55e3388$var$createFastMemoizeCache(cache.number),
            strategy: (0, $hMpr9.strategies).variadic
        }),
        getDateTimeFormat: (0, $hMpr9.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3Cq0D.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1fececedf55e3388$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $hMpr9.strategies).variadic
        }),
        getPluralRules: (0, $hMpr9.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3Cq0D.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $1fececedf55e3388$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $hMpr9.strategies).variadic
        })
    };
}
var $1fececedf55e3388$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $8MStW.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $8MStW.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $3Cq0D.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $1fececedf55e3388$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $1fececedf55e3388$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $h5P6y.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("h5P6y", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("fzKQk")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("fzKQk")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("fzKQk")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("fzKQk")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("fzKQk")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("fzKQk")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("fzKQk")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("fzKQk")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("fzKQk")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("fzKQk")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("fzKQk")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("fzKQk")).TYPE);
$parcel$export(module.exports, "parse", () => $c71a8ba169589304$export$98e6a39c04603d36);

var $3Cq0D = parcelRequire("3Cq0D");

var $hCOV0 = parcelRequire("hCOV0");

var $7UYJw = parcelRequire("7UYJw");

var $fzKQk = parcelRequire("fzKQk");

var $lAhVy = parcelRequire("lAhVy");
function $c71a8ba169589304$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $fzKQk.isSelectElement)(el) || (0, $fzKQk.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $c71a8ba169589304$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $fzKQk.isNumberElement)(el) && (0, $fzKQk.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $fzKQk.isDateElement)(el) || (0, $fzKQk.isTimeElement)(el)) && (0, $fzKQk.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $fzKQk.isTagElement)(el)) $c71a8ba169589304$var$pruneLocation(el.children);
    });
}
function $c71a8ba169589304$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $3Cq0D.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $7UYJw.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $hCOV0.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $c71a8ba169589304$var$pruneLocation(result.val);
    return result.val;
}
var $c71a8ba169589304$export$d3c1bfa0f7d806e9 = (0, $7UYJw.Parser);

});
parcelRegister("hCOV0", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $cd4d7ba55857f4d1$export$896afd8541959ee5);
var $cd4d7ba55857f4d1$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($cd4d7ba55857f4d1$export$896afd8541959ee5 || ($cd4d7ba55857f4d1$export$896afd8541959ee5 = {}));

});

parcelRegister("7UYJw", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $5c3cdfbed2c163e9$export$7acfa6ed01010e37);

var $3Cq0D = parcelRequire("3Cq0D");

var $hCOV0 = parcelRequire("hCOV0");

var $fzKQk = parcelRequire("fzKQk");

var $1ZbJb = parcelRequire("1ZbJb");
parcelRequire("dZNzU");
var $2l2Dl = parcelRequire("2l2Dl");
var $hhs3k = parcelRequire("hhs3k");

var $2svNt = parcelRequire("2svNt");
var $5c3cdfbed2c163e9$var$_a;
var $5c3cdfbed2c163e9$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $1ZbJb.SPACE_SEPARATOR_REGEX).source, "*"));
var $5c3cdfbed2c163e9$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $1ZbJb.SPACE_SEPARATOR_REGEX).source, "*$"));
function $5c3cdfbed2c163e9$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $5c3cdfbed2c163e9$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $5c3cdfbed2c163e9$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $5c3cdfbed2c163e9$var$hasNativeFromEntries = !!Object.fromEntries;
var $5c3cdfbed2c163e9$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $5c3cdfbed2c163e9$var$hasTrimStart = !!String.prototype.trimStart;
var $5c3cdfbed2c163e9$var$hasTrimEnd = !!String.prototype.trimEnd;
var $5c3cdfbed2c163e9$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $5c3cdfbed2c163e9$var$isSafeInteger = $5c3cdfbed2c163e9$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $5c3cdfbed2c163e9$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $5c3cdfbed2c163e9$var$re = $5c3cdfbed2c163e9$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $5c3cdfbed2c163e9$var$REGEX_SUPPORTS_U_AND_Y = (($5c3cdfbed2c163e9$var$_a = $5c3cdfbed2c163e9$var$re.exec('a')) === null || $5c3cdfbed2c163e9$var$_a === void 0 ? void 0 : $5c3cdfbed2c163e9$var$_a[0]) === 'a';
} catch (_) {
    $5c3cdfbed2c163e9$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $5c3cdfbed2c163e9$var$startsWith = $5c3cdfbed2c163e9$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $5c3cdfbed2c163e9$var$fromCodePoint = $5c3cdfbed2c163e9$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $5c3cdfbed2c163e9$var$fromEntries = // native
$5c3cdfbed2c163e9$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $5c3cdfbed2c163e9$var$codePointAt = $5c3cdfbed2c163e9$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $5c3cdfbed2c163e9$var$trimStart = $5c3cdfbed2c163e9$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($5c3cdfbed2c163e9$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $5c3cdfbed2c163e9$var$trimEnd = $5c3cdfbed2c163e9$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($5c3cdfbed2c163e9$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $5c3cdfbed2c163e9$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $5c3cdfbed2c163e9$var$matchIdentifierAtIndex;
if ($5c3cdfbed2c163e9$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $5c3cdfbed2c163e9$var$IDENTIFIER_PREFIX_RE_1 = $5c3cdfbed2c163e9$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $5c3cdfbed2c163e9$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $5c3cdfbed2c163e9$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $5c3cdfbed2c163e9$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$5c3cdfbed2c163e9$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $5c3cdfbed2c163e9$var$codePointAt(s, index);
        if (c === undefined || $5c3cdfbed2c163e9$var$_isWhiteSpace(c) || $5c3cdfbed2c163e9$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $5c3cdfbed2c163e9$var$fromCodePoint.apply(void 0, match);
};
var $5c3cdfbed2c163e9$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $fzKQk.TYPE).pound,
                    location: $5c3cdfbed2c163e9$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $hCOV0.ErrorKind).UNMATCHED_CLOSING_TAG, $5c3cdfbed2c163e9$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $5c3cdfbed2c163e9$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $fzKQk.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $5c3cdfbed2c163e9$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$5c3cdfbed2c163e9$var$_isAlpha(this.char())) return this.error((0, $hCOV0.ErrorKind).INVALID_TAG, $5c3cdfbed2c163e9$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $hCOV0.ErrorKind).UNMATCHED_CLOSING_TAG, $5c3cdfbed2c163e9$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $hCOV0.ErrorKind).INVALID_TAG, $5c3cdfbed2c163e9$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $fzKQk.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $5c3cdfbed2c163e9$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $hCOV0.ErrorKind).UNCLOSED_TAG, $5c3cdfbed2c163e9$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $hCOV0.ErrorKind).INVALID_TAG, $5c3cdfbed2c163e9$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $5c3cdfbed2c163e9$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $5c3cdfbed2c163e9$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $fzKQk.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$5c3cdfbed2c163e9$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $5c3cdfbed2c163e9$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $5c3cdfbed2c163e9$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $hCOV0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $hCOV0.ErrorKind).EMPTY_ARGUMENT, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $hCOV0.ErrorKind).MALFORMED_ARGUMENT, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $hCOV0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $fzKQk.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $hCOV0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $hCOV0.ErrorKind).MALFORMED_ARGUMENT, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $5c3cdfbed2c163e9$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $5c3cdfbed2c163e9$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $hCOV0.ErrorKind).EXPECT_ARGUMENT_TYPE, $5c3cdfbed2c163e9$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $5c3cdfbed2c163e9$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $hCOV0.ErrorKind).EXPECT_ARGUMENT_STYLE, $5c3cdfbed2c163e9$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $5c3cdfbed2c163e9$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $5c3cdfbed2c163e9$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $5c3cdfbed2c163e9$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $fzKQk.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $hCOV0.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $2svNt.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $fzKQk.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $2l2Dl.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $fzKQk.TYPE).date : (0, $fzKQk.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $fzKQk.TYPE).number : argType === 'date' ? (0, $fzKQk.TYPE).date : (0, $fzKQk.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $hCOV0.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $5c3cdfbed2c163e9$var$createLocation(typeEndPosition_1, (0, $3Cq0D.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $hCOV0.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $5c3cdfbed2c163e9$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $hCOV0.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $hCOV0.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $fzKQk.TYPE).select,
                        value: value,
                        options: $5c3cdfbed2c163e9$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $fzKQk.TYPE).plural,
                        value: value,
                        options: $5c3cdfbed2c163e9$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $hCOV0.ErrorKind).INVALID_ARGUMENT_TYPE, $5c3cdfbed2c163e9$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $hCOV0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $hCOV0.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $5c3cdfbed2c163e9$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $hhs3k.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $hCOV0.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $fzKQk.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $hhs3k.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $hCOV0.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $hCOV0.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $5c3cdfbed2c163e9$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $hCOV0.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $hCOV0.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $hCOV0.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $hCOV0.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $5c3cdfbed2c163e9$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $5c3cdfbed2c163e9$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $hCOV0.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $hCOV0.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $5c3cdfbed2c163e9$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $hCOV0.ErrorKind).MISSING_OTHER_CLAUSE, $5c3cdfbed2c163e9$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $5c3cdfbed2c163e9$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$5c3cdfbed2c163e9$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $5c3cdfbed2c163e9$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($5c3cdfbed2c163e9$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $5c3cdfbed2c163e9$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $5c3cdfbed2c163e9$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $5c3cdfbed2c163e9$var$_isAlphaOrSlash(codepoint) {
    return $5c3cdfbed2c163e9$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $5c3cdfbed2c163e9$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $5c3cdfbed2c163e9$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $5c3cdfbed2c163e9$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("fzKQk", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $b56e75f4dcd2b36a$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $b56e75f4dcd2b36a$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $b56e75f4dcd2b36a$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $b56e75f4dcd2b36a$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $b56e75f4dcd2b36a$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $b56e75f4dcd2b36a$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $b56e75f4dcd2b36a$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $b56e75f4dcd2b36a$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $b56e75f4dcd2b36a$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $b56e75f4dcd2b36a$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $b56e75f4dcd2b36a$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $b56e75f4dcd2b36a$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $b56e75f4dcd2b36a$export$7680c41f1a55f4cf);
var $b56e75f4dcd2b36a$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($b56e75f4dcd2b36a$export$b87f371cbc396fcf || ($b56e75f4dcd2b36a$export$b87f371cbc396fcf = {}));
var $b56e75f4dcd2b36a$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($b56e75f4dcd2b36a$export$906452485466fa53 || ($b56e75f4dcd2b36a$export$906452485466fa53 = {}));
function $b56e75f4dcd2b36a$export$cfa10c5697238752(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.literal;
}
function $b56e75f4dcd2b36a$export$4f55724281bdfaf9(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.argument;
}
function $b56e75f4dcd2b36a$export$e11187b219e191e1(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.number;
}
function $b56e75f4dcd2b36a$export$32d811605da75f40(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.date;
}
function $b56e75f4dcd2b36a$export$34ec46f596b1702f(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.time;
}
function $b56e75f4dcd2b36a$export$dcfe1c11d168b5a1(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.select;
}
function $b56e75f4dcd2b36a$export$6c796d116f0a4fbc(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.plural;
}
function $b56e75f4dcd2b36a$export$c0ece297bdd0c082(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.pound;
}
function $b56e75f4dcd2b36a$export$5c83de34745812b(el) {
    return el.type === $b56e75f4dcd2b36a$export$b87f371cbc396fcf.tag;
}
function $b56e75f4dcd2b36a$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $b56e75f4dcd2b36a$export$906452485466fa53.number);
}
function $b56e75f4dcd2b36a$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $b56e75f4dcd2b36a$export$906452485466fa53.dateTime);
}
function $b56e75f4dcd2b36a$export$f0ac572c1121c662(value) {
    return {
        type: $b56e75f4dcd2b36a$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $b56e75f4dcd2b36a$export$425e864b0ba114f1(value, style) {
    return {
        type: $b56e75f4dcd2b36a$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("1ZbJb", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $172495d1a6a6d5b9$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $172495d1a6a6d5b9$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $172495d1a6a6d5b9$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("dZNzU", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("2l2Dl")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("hhs3k")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("hhs3k")).parseNumberSkeletonFromString);
parcelRequire("2l2Dl");
parcelRequire("hhs3k");

});
parcelRegister("2l2Dl", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $1b3f95ea653c518d$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $1b3f95ea653c518d$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $1b3f95ea653c518d$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($1b3f95ea653c518d$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("hhs3k", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $c949c8e2872caccd$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $c949c8e2872caccd$export$47c6f8480bda3e11);

var $3Cq0D = parcelRequire("3Cq0D");

var $sArJT = parcelRequire("sArJT");
function $c949c8e2872caccd$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $sArJT.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $c949c8e2872caccd$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $c949c8e2872caccd$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $c949c8e2872caccd$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $c949c8e2872caccd$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $c949c8e2872caccd$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $c949c8e2872caccd$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($c949c8e2872caccd$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $c949c8e2872caccd$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $c949c8e2872caccd$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$c949c8e2872caccd$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $c949c8e2872caccd$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $c949c8e2872caccd$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $c949c8e2872caccd$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $c949c8e2872caccd$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, all), $c949c8e2872caccd$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, all), $c949c8e2872caccd$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($c949c8e2872caccd$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($c949c8e2872caccd$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($c949c8e2872caccd$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($c949c8e2872caccd$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), $c949c8e2872caccd$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($c949c8e2872caccd$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), $c949c8e2872caccd$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $c949c8e2872caccd$var$parseSign(token.stem);
        if (signOpts) result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $c949c8e2872caccd$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("sArJT", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $055ee3231cec8150$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $055ee3231cec8150$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("2svNt", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $1ca6dc8870d599bb$export$29c5368be8904d27);

var $6PvfE = parcelRequire("6PvfE");
function $1ca6dc8870d599bb$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $1ca6dc8870d599bb$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $1ca6dc8870d599bb$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $6PvfE.timeData)[regionTag || ''] || (0, $6PvfE.timeData)[languageTag || ''] || (0, $6PvfE.timeData)["".concat(languageTag, "-001")] || (0, $6PvfE.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("6PvfE", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $4f8fbf615ffe42fb$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $4f8fbf615ffe42fb$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("lAhVy", function(module, exports) {

var $3Cq0D = parcelRequire("3Cq0D");

var $fzKQk = parcelRequire("fzKQk");
function $fb6addc0a6f206d6$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $3Cq0D.__spreadArray)([], obj.map($fb6addc0a6f206d6$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $fb6addc0a6f206d6$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $fb6addc0a6f206d6$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $fb6addc0a6f206d6$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $fb6addc0a6f206d6$export$be5687ba8bbdf416((0, $3Cq0D.__spreadArray)((0, $3Cq0D.__spreadArray)((0, $3Cq0D.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $fb6addc0a6f206d6$var$isPluralOrSelectElement(el) {
    return (0, $fzKQk.isPluralElement)(el) || (0, $fzKQk.isSelectElement)(el);
}
function $fb6addc0a6f206d6$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($fb6addc0a6f206d6$var$isPluralOrSelectElement(el)) return true;
        if ((0, $fzKQk.isTagElement)(el)) return $fb6addc0a6f206d6$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $fb6addc0a6f206d6$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($fb6addc0a6f206d6$var$isPluralOrSelectElement(el)) return [
            $fb6addc0a6f206d6$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $fzKQk.isTagElement)(el) && $fb6addc0a6f206d6$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $fb6addc0a6f206d6$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $fzKQk.isArgumentElement)(el) || (0, $fzKQk.isDateElement)(el) || (0, $fzKQk.isTimeElement)(el) || (0, $fzKQk.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $fzKQk.isPluralElement)(el) || (0, $fzKQk.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $fb6addc0a6f206d6$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $fzKQk.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $fb6addc0a6f206d6$var$collectVariables(el.children, vars);
        }
    });
}
function $fb6addc0a6f206d6$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $fb6addc0a6f206d6$var$collectVariables(a, aVars);
    $fb6addc0a6f206d6$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $fzKQk.TYPE)[type], " vs ").concat((0, $fzKQk.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("8MStW", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $665d11641b15c349$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $665d11641b15c349$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $665d11641b15c349$export$275d4a3bb5f66fda);
parcelRequire("h5P6y");
var $fzKQk = parcelRequire("fzKQk");

var $hZIq9 = parcelRequire("hZIq9");
var $665d11641b15c349$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($665d11641b15c349$export$49694c2877b44c57 || ($665d11641b15c349$export$49694c2877b44c57 = {}));
function $665d11641b15c349$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $665d11641b15c349$export$49694c2877b44c57.literal || part.type !== $665d11641b15c349$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $665d11641b15c349$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $665d11641b15c349$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $fzKQk.isLiteralElement)(els[0])) return [
        {
            type: $665d11641b15c349$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $fzKQk.isLiteralElement)(el)) {
            result.push({
                type: $665d11641b15c349$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $fzKQk.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $665d11641b15c349$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $hZIq9.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $fzKQk.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $665d11641b15c349$export$49694c2877b44c57.literal : $665d11641b15c349$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $fzKQk.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $fzKQk.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $665d11641b15c349$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $fzKQk.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $fzKQk.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $665d11641b15c349$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $fzKQk.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $fzKQk.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $665d11641b15c349$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $fzKQk.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$665d11641b15c349$export$df0c12a2d414a163(formatFn)) throw new (0, $hZIq9.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $665d11641b15c349$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $665d11641b15c349$export$49694c2877b44c57.literal : $665d11641b15c349$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $fzKQk.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $hZIq9.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $665d11641b15c349$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $fzKQk.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $hZIq9.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $hZIq9.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $hZIq9.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $665d11641b15c349$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $665d11641b15c349$var$mergeLiteral(result);
}

});
parcelRegister("hZIq9", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $d19a973bff01d4df$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $d19a973bff01d4df$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $d19a973bff01d4df$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $d19a973bff01d4df$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $d19a973bff01d4df$export$8bfc137e4d23fdf0);

var $3Cq0D = parcelRequire("3Cq0D");
var $d19a973bff01d4df$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($d19a973bff01d4df$export$d4e71bc0b80dc0fb || ($d19a973bff01d4df$export$d4e71bc0b80dc0fb = {}));
var $d19a973bff01d4df$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $d19a973bff01d4df$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $d19a973bff01d4df$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($d19a973bff01d4df$export$7369836851cc1329);
var $d19a973bff01d4df$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $d19a973bff01d4df$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($d19a973bff01d4df$export$7369836851cc1329);
var $d19a973bff01d4df$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $d19a973bff01d4df$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($d19a973bff01d4df$export$7369836851cc1329);

});




parcelRegister("2lffa", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $1b495dfbb0b3bea8$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $1b495dfbb0b3bea8$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $1b495dfbb0b3bea8$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $1b495dfbb0b3bea8$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $1b495dfbb0b3bea8$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $1b495dfbb0b3bea8$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $1b495dfbb0b3bea8$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $1b495dfbb0b3bea8$export$2ddcb436d0aa3688);

var $3Cq0D = parcelRequire("3Cq0D");
var $1b495dfbb0b3bea8$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($1b495dfbb0b3bea8$export$557d6acb76e8a244 || ($1b495dfbb0b3bea8$export$557d6acb76e8a244 = {}));
var $1b495dfbb0b3bea8$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $1b495dfbb0b3bea8$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $1b495dfbb0b3bea8$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($1b495dfbb0b3bea8$export$c016d36112f6ddf8);
var $1b495dfbb0b3bea8$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $1b495dfbb0b3bea8$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($1b495dfbb0b3bea8$export$c016d36112f6ddf8);
var $1b495dfbb0b3bea8$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $1b495dfbb0b3bea8$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($1b495dfbb0b3bea8$export$c016d36112f6ddf8);
var $1b495dfbb0b3bea8$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $1b495dfbb0b3bea8$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($1b495dfbb0b3bea8$export$c016d36112f6ddf8);
var $1b495dfbb0b3bea8$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($1b495dfbb0b3bea8$export$e3b7eee1dbc44895);
var $1b495dfbb0b3bea8$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $1b495dfbb0b3bea8$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($1b495dfbb0b3bea8$export$c016d36112f6ddf8);

});


parcelRegister("dETlE", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $9f19f1cf067ae252$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $9f19f1cf067ae252$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $9f19f1cf067ae252$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $9f19f1cf067ae252$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $9f19f1cf067ae252$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $9f19f1cf067ae252$export$d36bdfa510afb180);

var $3Cq0D = parcelRequire("3Cq0D");

var $bSJIT = parcelRequire("bSJIT");

var $9WiA8 = parcelRequire("9WiA8");
function $9f19f1cf067ae252$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $9f19f1cf067ae252$export$45c4bbf6e55bba1f(intl) {
    $9f19f1cf067ae252$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $9f19f1cf067ae252$export$b52f8d6fc0d47415 = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, (0, $9WiA8.DEFAULT_INTL_CONFIG)), {
    textComponent: $bSJIT.Fragment
});
var $9f19f1cf067ae252$var$toKeyedReactNode = function(reactNode, key) {
    return $bSJIT.isValidElement(reactNode) ? $bSJIT.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $9f19f1cf067ae252$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $bSJIT.Children.map(children, $9f19f1cf067ae252$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $9f19f1cf067ae252$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($9f19f1cf067ae252$export$d2fd241e0b53c057(parts));
    };
}
function $9f19f1cf067ae252$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});

parcelRegister("2z7V1", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $1de4fe2b38d0adb7$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3Cq0D = parcelRequire("3Cq0D");

var $gqsO5 = parcelRequire("gqsO5");
var $1Xiqw = parcelRequire("1Xiqw");

var $8MStW = parcelRequire("8MStW");

var $dETlE = parcelRequire("dETlE");
function $1de4fe2b38d0adb7$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $8MStW.isFormatXMLElementFn)(v) ? (0, $dETlE.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $1de4fe2b38d0adb7$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1de4fe2b38d0adb7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $1Xiqw.formatMessage).apply(void 0, (0, $3Cq0D.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $dETlE.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $1de4fe2b38d0adb7$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $3Cq0D.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1de4fe2b38d0adb7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $gqsO5.createIntl)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, (0, $dETlE.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, coreIntl), {
        formatMessage: $1de4fe2b38d0adb7$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $1de4fe2b38d0adb7$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("gqsO5", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $bf556b76ff941469$export$7e4cbedfdd7b4c0d);

var $3Cq0D = parcelRequire("3Cq0D");

var $9KI5y = parcelRequire("9KI5y");

var $6BqCF = parcelRequire("6BqCF");

var $2lffa = parcelRequire("2lffa");

var $hQrCG = parcelRequire("hQrCG");

var $1Xiqw = parcelRequire("1Xiqw");

var $iyl6S = parcelRequire("iyl6S");

var $3EKZ8 = parcelRequire("3EKZ8");

var $9Nyrw = parcelRequire("9Nyrw");

var $9WiA8 = parcelRequire("9WiA8");
function $bf556b76ff941469$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $bf556b76ff941469$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $bf556b76ff941469$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $bf556b76ff941469$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $9WiA8.createFormatters)(cache);
    var resolvedConfig = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, (0, $9WiA8.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $2lffa.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $2lffa.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $2lffa.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $bf556b76ff941469$var$verifyConfigMessages(resolvedConfig);
    return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $iyl6S.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $iyl6S.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $9Nyrw.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $9KI5y.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $9KI5y.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $9KI5y.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $9KI5y.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $9KI5y.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $3EKZ8.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $1Xiqw.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $1Xiqw.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $hQrCG.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $hQrCG.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $6BqCF.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("9KI5y", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $719a9c07fbd3e263$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $719a9c07fbd3e263$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $719a9c07fbd3e263$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $719a9c07fbd3e263$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $719a9c07fbd3e263$export$af6e5d7a5c73edeb);

var $3Cq0D = parcelRequire("3Cq0D");

var $2lffa = parcelRequire("2lffa");

var $9WiA8 = parcelRequire("9WiA8");
var $719a9c07fbd3e263$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $719a9c07fbd3e263$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $9WiA8.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $9WiA8.filterProps)(options, $719a9c07fbd3e263$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $719a9c07fbd3e263$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $719a9c07fbd3e263$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $719a9c07fbd3e263$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $719a9c07fbd3e263$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $719a9c07fbd3e263$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $719a9c07fbd3e263$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $719a9c07fbd3e263$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $719a9c07fbd3e263$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $719a9c07fbd3e263$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $719a9c07fbd3e263$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("6BqCF", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $4cead98006847f12$export$62fe1a4d9e891fa2);

var $9WiA8 = parcelRequire("9WiA8");

var $hZIq9 = parcelRequire("hZIq9");

var $2lffa = parcelRequire("2lffa");
var $4cead98006847f12$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $4cead98006847f12$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $hZIq9.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $hZIq9.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $9WiA8.filterProps)(options, $4cead98006847f12$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $2lffa.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("hQrCG", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $cfdcb852cf43dd8e$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $cfdcb852cf43dd8e$export$6f284aad1934db69);

var $3Cq0D = parcelRequire("3Cq0D");

var $hZIq9 = parcelRequire("hZIq9");

var $2lffa = parcelRequire("2lffa");

var $9WiA8 = parcelRequire("9WiA8");
var $cfdcb852cf43dd8e$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $cfdcb852cf43dd8e$var$now = Date.now();
function $cfdcb852cf43dd8e$var$generateToken(i) {
    return "".concat($cfdcb852cf43dd8e$var$now, "_").concat(i, "_").concat($cfdcb852cf43dd8e$var$now);
}
function $cfdcb852cf43dd8e$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $cfdcb852cf43dd8e$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $cfdcb852cf43dd8e$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $hZIq9.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $hZIq9.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $9WiA8.filterProps)(options, $cfdcb852cf43dd8e$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $cfdcb852cf43dd8e$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $2lffa.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("1Xiqw", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $16c9985514788270$export$25868d1e8e76735f);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("h5P6y");
var $fzKQk = parcelRequire("fzKQk");
parcelRequire("bKFPg");
var $2JWc7 = parcelRequire("2JWc7");

var $2lffa = parcelRequire("2lffa");

var $9WiA8 = parcelRequire("9WiA8");
function $16c9985514788270$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $3Cq0D.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $16c9985514788270$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $16c9985514788270$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $2JWc7.IntlMessageFormat).formats;
    return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, mfFormats), f1), {
        date: $16c9985514788270$var$deepMergeOptions($16c9985514788270$var$setTimeZoneInOptions(mfFormats.date, timeZone), $16c9985514788270$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $16c9985514788270$var$deepMergeOptions($16c9985514788270$var$setTimeZoneInOptions(mfFormats.time, timeZone), $16c9985514788270$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $16c9985514788270$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $9WiA8.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $fzKQk.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, defaultRichTextElements), values || {});
    formats = $16c9985514788270$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $16c9985514788270$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $2lffa.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $2lffa.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $3Cq0D.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $2lffa.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $2lffa.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("iyl6S", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $d81bc6f55d9e64fe$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $d81bc6f55d9e64fe$export$6871080848f10b2f);

var $2lffa = parcelRequire("2lffa");

var $9WiA8 = parcelRequire("9WiA8");
var $d81bc6f55d9e64fe$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $d81bc6f55d9e64fe$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $9WiA8.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $9WiA8.filterProps)(options, $d81bc6f55d9e64fe$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $d81bc6f55d9e64fe$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d81bc6f55d9e64fe$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $d81bc6f55d9e64fe$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d81bc6f55d9e64fe$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("3EKZ8", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $2a998dcbb9d28e61$export$bbbd05c900f3568d);

var $hZIq9 = parcelRequire("hZIq9");

var $2lffa = parcelRequire("2lffa");

var $9WiA8 = parcelRequire("9WiA8");
var $2a998dcbb9d28e61$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $2a998dcbb9d28e61$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $hZIq9.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $hZIq9.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $9WiA8.filterProps)(options, $2a998dcbb9d28e61$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $2lffa.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("9Nyrw", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $7223684e75f478e0$export$b4ea3b48dcf921f6);

var $9WiA8 = parcelRequire("9WiA8");

var $hZIq9 = parcelRequire("hZIq9");

var $2lffa = parcelRequire("2lffa");
var $7223684e75f478e0$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $7223684e75f478e0$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $9WiA8.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $9WiA8.filterProps)(options, $7223684e75f478e0$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $7223684e75f478e0$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $hZIq9.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $hZIq9.ErrorCode).MISSING_INTL_API));
    try {
        return $7223684e75f478e0$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $2lffa.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("fK3tS", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $b75dda197f1e9344$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $b75dda197f1e9344$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $b75dda197f1e9344$export$2e2bcd8739ae039);

var $3Cq0D = parcelRequire("3Cq0D");

var $jNar1 = parcelRequire("jNar1");

var $bSJIT = parcelRequire("bSJIT");

var $dETlE = parcelRequire("dETlE");
function $b75dda197f1e9344$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $b75dda197f1e9344$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $bSJIT.createContext(null)) : $bSJIT.createContext(null);
var $b75dda197f1e9344$var$IntlConsumer = $b75dda197f1e9344$var$IntlContext.Consumer, $b75dda197f1e9344$var$IntlProvider = $b75dda197f1e9344$var$IntlContext.Provider;
var $b75dda197f1e9344$export$2881499e37b75b9a = $b75dda197f1e9344$var$IntlProvider;
var $b75dda197f1e9344$export$841858b892ce1f4c = $b75dda197f1e9344$var$IntlContext;
function $b75dda197f1e9344$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $bSJIT.createElement($b75dda197f1e9344$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $dETlE.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $bSJIT.createElement(WrappedComponent, (0, $3Cq0D.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($b75dda197f1e9344$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($jNar1)))(// @ts-expect-error
    $bSJIT.forwardRef(function(props, ref) {
        return $bSJIT.createElement(WithIntl, (0, $3Cq0D.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jNar1)))(WithIntl, WrappedComponent);
}

});
parcelRegister("jNar1", function(module, exports) {
'use strict';

var $e4Sjd = parcelRequire("e4Sjd");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $e68ab00ec6c44b2e$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e68ab00ec6c44b2e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e68ab00ec6c44b2e$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e68ab00ec6c44b2e$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e68ab00ec6c44b2e$var$TYPE_STATICS = {};
$e68ab00ec6c44b2e$var$TYPE_STATICS[$e4Sjd.ForwardRef] = $e68ab00ec6c44b2e$var$FORWARD_REF_STATICS;
$e68ab00ec6c44b2e$var$TYPE_STATICS[$e4Sjd.Memo] = $e68ab00ec6c44b2e$var$MEMO_STATICS;
function $e68ab00ec6c44b2e$var$getStatics(component) {
    // React v16.11 and below
    if ($e4Sjd.isMemo(component)) return $e68ab00ec6c44b2e$var$MEMO_STATICS;
     // React v16.12 and above
    return $e68ab00ec6c44b2e$var$TYPE_STATICS[component['$$typeof']] || $e68ab00ec6c44b2e$var$REACT_STATICS;
}
var $e68ab00ec6c44b2e$var$defineProperty = Object.defineProperty;
var $e68ab00ec6c44b2e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e68ab00ec6c44b2e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e68ab00ec6c44b2e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e68ab00ec6c44b2e$var$getPrototypeOf = Object.getPrototypeOf;
var $e68ab00ec6c44b2e$var$objectPrototype = Object.prototype;
function $e68ab00ec6c44b2e$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($e68ab00ec6c44b2e$var$objectPrototype) {
            var inheritedComponent = $e68ab00ec6c44b2e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e68ab00ec6c44b2e$var$objectPrototype) $e68ab00ec6c44b2e$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $e68ab00ec6c44b2e$var$getOwnPropertyNames(sourceComponent);
        if ($e68ab00ec6c44b2e$var$getOwnPropertySymbols) keys = keys.concat($e68ab00ec6c44b2e$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $e68ab00ec6c44b2e$var$getStatics(targetComponent);
        var sourceStatics = $e68ab00ec6c44b2e$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$e68ab00ec6c44b2e$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $e68ab00ec6c44b2e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $e68ab00ec6c44b2e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $e68ab00ec6c44b2e$var$hoistNonReactStatics;

});
parcelRegister("e4Sjd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3P4KK"));

});
parcelRegister("3P4KK", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $2c89d25a70651e3d$export$2b8d127b894957b9, (v) => $2c89d25a70651e3d$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2c89d25a70651e3d$export$cea3a54a6425200c, (v) => $2c89d25a70651e3d$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2c89d25a70651e3d$export$a7c73072b1a182ae, (v) => $2c89d25a70651e3d$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2c89d25a70651e3d$export$9f27bc3417b4524d, (v) => $2c89d25a70651e3d$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2c89d25a70651e3d$export$db77ccec0bb4ccac, (v) => $2c89d25a70651e3d$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2c89d25a70651e3d$export$8392c0c9d3dcbd35, (v) => $2c89d25a70651e3d$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2c89d25a70651e3d$export$ffb0004e005737fa, (v) => $2c89d25a70651e3d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2c89d25a70651e3d$export$b624eff549462981, (v) => $2c89d25a70651e3d$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2c89d25a70651e3d$export$7897aa7841a5380c, (v) => $2c89d25a70651e3d$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2c89d25a70651e3d$export$602eac185826482c, (v) => $2c89d25a70651e3d$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2c89d25a70651e3d$export$e2c29f18771995cb, (v) => $2c89d25a70651e3d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2c89d25a70651e3d$export$5f8d39834fd61797, (v) => $2c89d25a70651e3d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2c89d25a70651e3d$export$74bf444e3cd11ea5, (v) => $2c89d25a70651e3d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2c89d25a70651e3d$export$92387174baf9b227, (v) => $2c89d25a70651e3d$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2c89d25a70651e3d$export$ec112efeb987d9c6, (v) => $2c89d25a70651e3d$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2c89d25a70651e3d$export$b706b080d889d2c9, (v) => $2c89d25a70651e3d$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2c89d25a70651e3d$export$5be5a87408f70ddc, (v) => $2c89d25a70651e3d$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2c89d25a70651e3d$export$45a5e7f76e0caa8d, (v) => $2c89d25a70651e3d$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2c89d25a70651e3d$export$455c2e768291efa6, (v) => $2c89d25a70651e3d$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2c89d25a70651e3d$export$9522e17588c12572, (v) => $2c89d25a70651e3d$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2c89d25a70651e3d$export$2110ac352bb060b9, (v) => $2c89d25a70651e3d$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2c89d25a70651e3d$export$56885ab8b9c456ab, (v) => $2c89d25a70651e3d$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2c89d25a70651e3d$export$d927fcb6adf8f9de, (v) => $2c89d25a70651e3d$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2c89d25a70651e3d$export$b82d16f27459e05a, (v) => $2c89d25a70651e3d$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2c89d25a70651e3d$export$522c17b4f5e123e8, (v) => $2c89d25a70651e3d$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2c89d25a70651e3d$export$1aabd8a0274ecfd6, (v) => $2c89d25a70651e3d$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2c89d25a70651e3d$export$9b621391a187a31a, (v) => $2c89d25a70651e3d$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2c89d25a70651e3d$export$f5bbd400c2f4426f, (v) => $2c89d25a70651e3d$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2c89d25a70651e3d$export$2b8d127b894957b9;
var $2c89d25a70651e3d$export$cea3a54a6425200c;
var $2c89d25a70651e3d$export$a7c73072b1a182ae;
var $2c89d25a70651e3d$export$9f27bc3417b4524d;
var $2c89d25a70651e3d$export$db77ccec0bb4ccac;
var $2c89d25a70651e3d$export$8392c0c9d3dcbd35;
var $2c89d25a70651e3d$export$ffb0004e005737fa;
var $2c89d25a70651e3d$export$b624eff549462981;
var $2c89d25a70651e3d$export$7897aa7841a5380c;
var $2c89d25a70651e3d$export$602eac185826482c;
var $2c89d25a70651e3d$export$e2c29f18771995cb;
var $2c89d25a70651e3d$export$5f8d39834fd61797;
var $2c89d25a70651e3d$export$74bf444e3cd11ea5;
var $2c89d25a70651e3d$export$92387174baf9b227;
var $2c89d25a70651e3d$export$ec112efeb987d9c6;
var $2c89d25a70651e3d$export$b706b080d889d2c9;
var $2c89d25a70651e3d$export$5be5a87408f70ddc;
var $2c89d25a70651e3d$export$45a5e7f76e0caa8d;
var $2c89d25a70651e3d$export$455c2e768291efa6;
var $2c89d25a70651e3d$export$9522e17588c12572;
var $2c89d25a70651e3d$export$2110ac352bb060b9;
var $2c89d25a70651e3d$export$56885ab8b9c456ab;
var $2c89d25a70651e3d$export$d927fcb6adf8f9de;
var $2c89d25a70651e3d$export$b82d16f27459e05a;
var $2c89d25a70651e3d$export$522c17b4f5e123e8;
var $2c89d25a70651e3d$export$1aabd8a0274ecfd6;
var $2c89d25a70651e3d$export$9b621391a187a31a;
var $2c89d25a70651e3d$export$f5bbd400c2f4426f;
'use strict';
var $2c89d25a70651e3d$var$b = "function" === typeof Symbol && Symbol.for, $2c89d25a70651e3d$var$c = $2c89d25a70651e3d$var$b ? Symbol.for("react.element") : 60103, $2c89d25a70651e3d$var$d = $2c89d25a70651e3d$var$b ? Symbol.for("react.portal") : 60106, $2c89d25a70651e3d$var$e = $2c89d25a70651e3d$var$b ? Symbol.for("react.fragment") : 60107, $2c89d25a70651e3d$var$f = $2c89d25a70651e3d$var$b ? Symbol.for("react.strict_mode") : 60108, $2c89d25a70651e3d$var$g = $2c89d25a70651e3d$var$b ? Symbol.for("react.profiler") : 60114, $2c89d25a70651e3d$var$h = $2c89d25a70651e3d$var$b ? Symbol.for("react.provider") : 60109, $2c89d25a70651e3d$var$k = $2c89d25a70651e3d$var$b ? Symbol.for("react.context") : 60110, $2c89d25a70651e3d$var$l = $2c89d25a70651e3d$var$b ? Symbol.for("react.async_mode") : 60111, $2c89d25a70651e3d$var$m = $2c89d25a70651e3d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2c89d25a70651e3d$var$n = $2c89d25a70651e3d$var$b ? Symbol.for("react.forward_ref") : 60112, $2c89d25a70651e3d$var$p = $2c89d25a70651e3d$var$b ? Symbol.for("react.suspense") : 60113, $2c89d25a70651e3d$var$q = $2c89d25a70651e3d$var$b ? Symbol.for("react.suspense_list") : 60120, $2c89d25a70651e3d$var$r = $2c89d25a70651e3d$var$b ? Symbol.for("react.memo") : 60115, $2c89d25a70651e3d$var$t = $2c89d25a70651e3d$var$b ? Symbol.for("react.lazy") : 60116, $2c89d25a70651e3d$var$v = $2c89d25a70651e3d$var$b ? Symbol.for("react.block") : 60121, $2c89d25a70651e3d$var$w = $2c89d25a70651e3d$var$b ? Symbol.for("react.fundamental") : 60117, $2c89d25a70651e3d$var$x = $2c89d25a70651e3d$var$b ? Symbol.for("react.responder") : 60118, $2c89d25a70651e3d$var$y = $2c89d25a70651e3d$var$b ? Symbol.for("react.scope") : 60119;
function $2c89d25a70651e3d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2c89d25a70651e3d$var$c:
                switch(a = a.type, a){
                    case $2c89d25a70651e3d$var$l:
                    case $2c89d25a70651e3d$var$m:
                    case $2c89d25a70651e3d$var$e:
                    case $2c89d25a70651e3d$var$g:
                    case $2c89d25a70651e3d$var$f:
                    case $2c89d25a70651e3d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2c89d25a70651e3d$var$k:
                            case $2c89d25a70651e3d$var$n:
                            case $2c89d25a70651e3d$var$t:
                            case $2c89d25a70651e3d$var$r:
                            case $2c89d25a70651e3d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2c89d25a70651e3d$var$d:
                return u;
        }
    }
}
function $2c89d25a70651e3d$var$A(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$m;
}
$2c89d25a70651e3d$export$2b8d127b894957b9 = $2c89d25a70651e3d$var$l;
$2c89d25a70651e3d$export$cea3a54a6425200c = $2c89d25a70651e3d$var$m;
$2c89d25a70651e3d$export$a7c73072b1a182ae = $2c89d25a70651e3d$var$k;
$2c89d25a70651e3d$export$9f27bc3417b4524d = $2c89d25a70651e3d$var$h;
$2c89d25a70651e3d$export$db77ccec0bb4ccac = $2c89d25a70651e3d$var$c;
$2c89d25a70651e3d$export$8392c0c9d3dcbd35 = $2c89d25a70651e3d$var$n;
$2c89d25a70651e3d$export$ffb0004e005737fa = $2c89d25a70651e3d$var$e;
$2c89d25a70651e3d$export$b624eff549462981 = $2c89d25a70651e3d$var$t;
$2c89d25a70651e3d$export$7897aa7841a5380c = $2c89d25a70651e3d$var$r;
$2c89d25a70651e3d$export$602eac185826482c = $2c89d25a70651e3d$var$d;
$2c89d25a70651e3d$export$e2c29f18771995cb = $2c89d25a70651e3d$var$g;
$2c89d25a70651e3d$export$5f8d39834fd61797 = $2c89d25a70651e3d$var$f;
$2c89d25a70651e3d$export$74bf444e3cd11ea5 = $2c89d25a70651e3d$var$p;
$2c89d25a70651e3d$export$92387174baf9b227 = function(a) {
    return $2c89d25a70651e3d$var$A(a) || $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$l;
};
$2c89d25a70651e3d$export$ec112efeb987d9c6 = $2c89d25a70651e3d$var$A;
$2c89d25a70651e3d$export$b706b080d889d2c9 = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$k;
};
$2c89d25a70651e3d$export$5be5a87408f70ddc = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$h;
};
$2c89d25a70651e3d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2c89d25a70651e3d$var$c;
};
$2c89d25a70651e3d$export$455c2e768291efa6 = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$n;
};
$2c89d25a70651e3d$export$9522e17588c12572 = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$e;
};
$2c89d25a70651e3d$export$2110ac352bb060b9 = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$t;
};
$2c89d25a70651e3d$export$56885ab8b9c456ab = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$r;
};
$2c89d25a70651e3d$export$d927fcb6adf8f9de = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$d;
};
$2c89d25a70651e3d$export$b82d16f27459e05a = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$g;
};
$2c89d25a70651e3d$export$522c17b4f5e123e8 = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$f;
};
$2c89d25a70651e3d$export$1aabd8a0274ecfd6 = function(a) {
    return $2c89d25a70651e3d$var$z(a) === $2c89d25a70651e3d$var$p;
};
$2c89d25a70651e3d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2c89d25a70651e3d$var$e || a === $2c89d25a70651e3d$var$m || a === $2c89d25a70651e3d$var$g || a === $2c89d25a70651e3d$var$f || a === $2c89d25a70651e3d$var$p || a === $2c89d25a70651e3d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2c89d25a70651e3d$var$t || a.$$typeof === $2c89d25a70651e3d$var$r || a.$$typeof === $2c89d25a70651e3d$var$h || a.$$typeof === $2c89d25a70651e3d$var$k || a.$$typeof === $2c89d25a70651e3d$var$n || a.$$typeof === $2c89d25a70651e3d$var$w || a.$$typeof === $2c89d25a70651e3d$var$x || a.$$typeof === $2c89d25a70651e3d$var$y || a.$$typeof === $2c89d25a70651e3d$var$v);
};
$2c89d25a70651e3d$export$f5bbd400c2f4426f = $2c89d25a70651e3d$var$z;

});





parcelRegister("amYpB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf92167125bbcb27$export$2e2bcd8739ae039);
$parcel$export(module.exports, "onIntlError", () => $bf92167125bbcb27$export$ec3f29afcf92cc87);
$parcel$export(module.exports, "onIntlNextError", () => $bf92167125bbcb27$export$3bcefabe8b04378c);

var $gEVth = parcelRequire("gEVth");

var $iBovR = parcelRequire("iBovR");
function $bf92167125bbcb27$export$2e2bcd8739ae039() {
    window.__JSD_I18N_MESSAGES = window.__JSD_I18N_MESSAGES || {};
    return window.__JSD_I18N_MESSAGES;
}
const $bf92167125bbcb27$export$ec3f29afcf92cc87 = (intlError)=>{
    try {
        if (!intlError) return;
        const isExternalTranslation = intlError.match(/Missing message: "fabric\.(editor|media|theme|emoji)\..*/);
        const { errorKey: errorKey, errorLocale: errorLocale, isNonFinal: isNonFinal } = (0, $iBovR.intlErrorMatch)(intlError);
        // According to https://hello.atlassian.net/wiki/spaces/i18n/pages/647802766/
        // Localized+Language+Support+Coverage+and+Strategy the following locales were
        // discontinued in 2018.
        const isUnSupportedLocale = !!intlError.match(/.*Missing message.*for locale "(ro|pt|no|sk|et|is)".*/);
        if (isExternalTranslation || isUnSupportedLocale) return;
        (0, $gEVth.operationalEvent)({
            attributes: {
                isNonFinal: isNonFinal,
                key: errorKey,
                locale: errorLocale
            },
            actionSubject: 'intl_translation',
            action: 'missing',
            source: 'unknownSource'
        });
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $bf92167125bbcb27$export$3bcefabe8b04378c = (intlError)=>{
    $bf92167125bbcb27$export$ec3f29afcf92cc87(`IntlV5: ${intlError.message}`);
};

});
parcelRegister("iBovR", function(module, exports) {
$parcel$export(module.exports, "intlErrorMatch", () => $69f1325ceb278e3c$export$c8d26e19aa1787d3);
const $69f1325ceb278e3c$export$c8d26e19aa1787d3 = (intlError)=>{
    const match = intlError.match(/Missing message: "(.*)" for locale "(.*)", using default message as fallback./);
    let isNonFinal = false;
    const errorKey = match ? match[1] : null;
    if (errorKey) isNonFinal = [
        '.non-final',
        'nonFinal'
    ].some((checkString)=>errorKey.includes(checkString));
    return {
        errorKey: errorKey,
        isNonFinal: isNonFinal,
        errorLocale: match ? match[2] : null
    };
};

});


parcelRegister("81Vbr", function(module, exports) {
$parcel$export(module.exports, "getLanguageFromLocale", () => $0ebb0ca593082365$export$e085862dfb8d71);
// get language from locale for usage with react-intl. For eg: en_US => en
const $0ebb0ca593082365$export$e085862dfb8d71 = (locale)=>{
    if (locale && locale.trim()) {
        if (locale === 'pt_BR' || locale === 'pt-BR') return 'pt-BR';
        return locale.split('_')[0].split('-')[0].trim();
    }
    // default to 'en'
    return 'en';
};

});

parcelRegister("Jze2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9feb965199fc8b3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $llRGw = parcelRequire("llRGw");

var $fK3tS = parcelRequire("fK3tS");

var $eDcdn = parcelRequire("eDcdn");

var $9FFIB = parcelRequire("9FFIB");
class $b9feb965199fc8b3$export$1e0c5ecf7bd99e3 extends $bSJIT.Component {
    componentDidMount() {
        const { origin: origin } = this.props;
        if (origin === null) return;
        (0, $llRGw.get)(`${(0, $eDcdn.contextPath)}/rest/assetapi/asset/${origin}`)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        .map((asset)=>this.setState({
                value: asset.label.value
            })).subscribe({
            error: ()=>this.setState({
                    isErrored: true
                })
        });
    }
    render() {
        const { intl: intl, origin: origin } = this.props;
        const { value: value, isErrored: isErrored } = this.state;
        if (isErrored || origin === null) return intl.formatMessage((0, $9FFIB.default).unknown);
        if (value === undefined) return intl.formatMessage((0, $9FFIB.default).loading);
        return value;
    }
    constructor(...args){
        super(...args), this.state = {};
    }
}
var $b9feb965199fc8b3$export$2e2bcd8739ae039 = (0, $fK3tS.default)($b9feb965199fc8b3$export$1e0c5ecf7bd99e3);

});
parcelRegister("llRGw", function(module, exports) {
$parcel$export(module.exports, "get", () => $c8fc239115588189$export$3988ae62b71be9a3);
$parcel$export(module.exports, "post", () => $c8fc239115588189$export$299ba2dee77727e9);
$parcel$export(module.exports, "put", () => $c8fc239115588189$export$327f7b26ebf455db);
$parcel$export(module.exports, "doDelete", () => $c8fc239115588189$export$3450a603e4796ceb);

var $8jOUp = parcelRequire("8jOUp");

var $c8w5e = parcelRequire("c8w5e");
const $c8fc239115588189$export$e68fce4c5f453854 = (0, $8jOUp.Observable).ajax;
const $c8fc239115588189$export$3988ae62b71be9a3 = (0, $c8w5e.traceableAjaxGet);
const $c8fc239115588189$export$299ba2dee77727e9 = (0, $c8w5e.traceableAjaxPost);
const $c8fc239115588189$export$327f7b26ebf455db = (0, $c8w5e.traceableAjaxPut);
const $c8fc239115588189$export$3450a603e4796ceb = (0, $c8w5e.traceableAjaxDelete);

});
parcelRegister("c8w5e", function(module, exports) {
$parcel$export(module.exports, "traceableAjaxGet", () => $e17cb8bb1d5c2fd0$export$9b2538eb22ed41e3);
$parcel$export(module.exports, "traceableAjaxPost", () => $e17cb8bb1d5c2fd0$export$9f4e186c104ab31a);
$parcel$export(module.exports, "traceableAjaxPut", () => $e17cb8bb1d5c2fd0$export$54de09e82d9434c3);
$parcel$export(module.exports, "traceableAjaxDelete", () => $e17cb8bb1d5c2fd0$export$d507aea434380fd4);

var $8jOUp = parcelRequire("8jOUp");

var $85Uxt = parcelRequire("85Uxt");
const $e17cb8bb1d5c2fd0$var$extendHeadersWithTracing = (url, originalHeaders = {})=>({
        ...originalHeaders,
        ...(0, $85Uxt.getActiveTraceHttpRequestHeaders)(url)
    });
const $e17cb8bb1d5c2fd0$export$9b2538eb22ed41e3 = (url, headers)=>{
    return (0, $8jOUp.Observable).ajax.get(url, $e17cb8bb1d5c2fd0$var$extendHeadersWithTracing(url, headers));
};
const $e17cb8bb1d5c2fd0$export$9f4e186c104ab31a = (url, body, headers)=>{
    return (0, $8jOUp.Observable).ajax.post(url, body, $e17cb8bb1d5c2fd0$var$extendHeadersWithTracing(url, headers));
};
const $e17cb8bb1d5c2fd0$export$54de09e82d9434c3 = (url, body, headers)=>{
    return (0, $8jOUp.Observable).ajax.put(url, body, $e17cb8bb1d5c2fd0$var$extendHeadersWithTracing(url, headers));
};
const $e17cb8bb1d5c2fd0$export$d507aea434380fd4 = (url, headers)=>{
    return (0, $8jOUp.Observable).ajax.delete(url, $e17cb8bb1d5c2fd0$var$extendHeadersWithTracing(url, headers));
};

});
parcelRegister("85Uxt", function(module, exports) {
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $cbba2c71a9a27f55$export$6e17cce6446848f9);

var $dH1v3 = parcelRequire("dH1v3");

var $46FTX = parcelRequire("46FTX");
function $cbba2c71a9a27f55$export$6e17cce6446848f9(_url) {
    if ((0, $dH1v3.getActiveTrace)() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = (0, $dH1v3.getActiveTrace)();
    return (0, $46FTX.makeTraceHttpRequestHeaders)(traceId, spanId);
}

});
parcelRegister("46FTX", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $600d4a2f01a5ff19$export$1115c5277eb10d5e);
function $600d4a2f01a5ff19$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});




parcelRegister("9FFIB", function(module, exports) {
$parcel$export(module.exports, "default", () => $70f0b1b458ec1a11$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $70f0b1b458ec1a11$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    loading: {
        id: 'asset.tracking.field.loading.asset',
        defaultMessage: 'Loading asset...',
        description: 'Displayed when asset label is being loaded from saffron (asset microservice)'
    },
    unknown: {
        id: 'asset.tracking.field.unknown.asset',
        defaultMessage: 'Unknown asset',
        description: 'Displayed when a value for an asset field is not known (eg: it has been deleted)'
    }
});

});
parcelRegister("f0Pt4", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $aedec791bfeb06e2$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $aedec791bfeb06e2$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $aedec791bfeb06e2$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $aedec791bfeb06e2$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $aedec791bfeb06e2$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $aedec791bfeb06e2$export$f52b44e459e6e71d);

var $e46W4 = parcelRequire("e46W4");

var $2z7V1 = parcelRequire("2z7V1");

var $d9d6a = parcelRequire("d9d6a");

var $fK3tS = parcelRequire("fK3tS");

var $5cKiX = parcelRequire("5cKiX");

var $5ayp8 = parcelRequire("5ayp8");

var $dTM5i = parcelRequire("dTM5i");

var $2mDer = parcelRequire("2mDer");

var $4vLTk = parcelRequire("4vLTk");

var $9WiA8 = parcelRequire("9WiA8");
var $2lffa = parcelRequire("2lffa");
function $aedec791bfeb06e2$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $aedec791bfeb06e2$export$747d244ee58120dd(msg) {
    return msg;
}
var $aedec791bfeb06e2$export$40ae3194919d16b = (0, $e46W4.createFormattedComponent)('formatDate');
var $aedec791bfeb06e2$export$5b390a54f8a846f7 = (0, $e46W4.createFormattedComponent)('formatTime');
var $aedec791bfeb06e2$export$db80edc1e6b2f63d = (0, $e46W4.createFormattedComponent)('formatNumber');
var $aedec791bfeb06e2$export$f52b44e459e6e71d = (0, $e46W4.createFormattedComponent)('formatList');
var $aedec791bfeb06e2$export$c2336ea5aaab92fa = (0, $e46W4.createFormattedComponent)('formatDisplayName');
var $aedec791bfeb06e2$export$7fdc7d2c91ce149b = (0, $e46W4.createFormattedDateTimePartsComponent)('formatDate');
var $aedec791bfeb06e2$export$ec35873761676c2a = (0, $e46W4.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("e46W4", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $a3d6d1ac6a1b104b$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $a3d6d1ac6a1b104b$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $a3d6d1ac6a1b104b$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $a3d6d1ac6a1b104b$export$b37e14176d001dec);

var $3Cq0D = parcelRequire("3Cq0D");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
var $a3d6d1ac6a1b104b$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($a3d6d1ac6a1b104b$var$DisplayName || ($a3d6d1ac6a1b104b$var$DisplayName = {}));
var $a3d6d1ac6a1b104b$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($a3d6d1ac6a1b104b$var$DisplayNameParts || ($a3d6d1ac6a1b104b$var$DisplayNameParts = {}));
var $a3d6d1ac6a1b104b$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $4vLTk.default)();
    var value = props.value, children = props.children, formatProps = (0, $3Cq0D.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$a3d6d1ac6a1b104b$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $a3d6d1ac6a1b104b$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $4vLTk.default)();
    var value = props.value, children = props.children, formatProps = (0, $3Cq0D.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$a3d6d1ac6a1b104b$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $a3d6d1ac6a1b104b$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $4vLTk.default)();
        var value = props.value, children = props.children, formatProps = (0, $3Cq0D.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $a3d6d1ac6a1b104b$var$DisplayNameParts[name];
    return ComponentParts;
}
function $a3d6d1ac6a1b104b$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $4vLTk.default)();
        var value = props.value, children = props.children, formatProps = (0, $3Cq0D.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $bSJIT.Fragment;
        return $bSJIT.createElement(Text, null, formattedValue);
    };
    Component.displayName = $a3d6d1ac6a1b104b$var$DisplayName[name];
    return Component;
}

});
parcelRegister("4vLTk", function(module, exports) {
$parcel$export(module.exports, "default", () => $348f34e3f550e2e1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dETlE = parcelRequire("dETlE");

var $fK3tS = parcelRequire("fK3tS");
function $348f34e3f550e2e1$export$2e2bcd8739ae039() {
    var intl = $bSJIT.useContext((0, $fK3tS.Context));
    (0, $dETlE.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("d9d6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $992646b6ef199bfb$export$2e2bcd8739ae039);

var $3Cq0D = parcelRequire("3Cq0D");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
var $992646b6ef199bfb$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $4vLTk.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $3Cq0D.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $bSJIT.Fragment;
    return $bSJIT.createElement(Text, null, formattedValue);
};
$992646b6ef199bfb$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $992646b6ef199bfb$export$2e2bcd8739ae039 = $992646b6ef199bfb$var$FormattedDateTimeRange;

});

parcelRegister("5cKiX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ca1fde80a1d23f0$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3Cq0D = parcelRequire("3Cq0D");

var $bSJIT = parcelRequire("bSJIT");

var $dETlE = parcelRequire("dETlE");

var $4vLTk = parcelRequire("4vLTk");
function $3ca1fde80a1d23f0$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $3Cq0D.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $3Cq0D.__rest)(nextProps, [
        "values"
    ]);
    return (0, $dETlE.shallowEqual)(nextValues, values) && (0, $dETlE.shallowEqual)(otherProps, nextOtherProps);
}
function $3ca1fde80a1d23f0$var$FormattedMessage(props) {
    var intl = (0, $4vLTk.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $bSJIT.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $bSJIT.createElement(Component, null, nodes);
    return $bSJIT.createElement($bSJIT.Fragment, null, nodes);
}
$3ca1fde80a1d23f0$var$FormattedMessage.displayName = 'FormattedMessage';
var $3ca1fde80a1d23f0$var$MemoizedFormattedMessage = $bSJIT.memo($3ca1fde80a1d23f0$var$FormattedMessage, $3ca1fde80a1d23f0$var$areEqual);
$3ca1fde80a1d23f0$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $3ca1fde80a1d23f0$export$2e2bcd8739ae039 = $3ca1fde80a1d23f0$var$MemoizedFormattedMessage;

});

parcelRegister("5ayp8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c3892edad8eea23$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
var $3c3892edad8eea23$var$FormattedPlural = function(props) {
    var _a = (0, $4vLTk.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $bSJIT.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$3c3892edad8eea23$var$FormattedPlural.displayName = 'FormattedPlural';
var $3c3892edad8eea23$export$2e2bcd8739ae039 = $3c3892edad8eea23$var$FormattedPlural;

});

parcelRegister("2mDer", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b8c11769c39470f$export$2e2bcd8739ae039);

var $3Cq0D = parcelRequire("3Cq0D");

var $bSJIT = parcelRequire("bSJIT");

var $dETlE = parcelRequire("dETlE");

var $4vLTk = parcelRequire("4vLTk");
var $1b8c11769c39470f$var$MINUTE = 60;
var $1b8c11769c39470f$var$HOUR = 3600;
var $1b8c11769c39470f$var$DAY = 86400;
function $1b8c11769c39470f$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $1b8c11769c39470f$var$MINUTE) return 'second';
    if (absValue < $1b8c11769c39470f$var$HOUR) return 'minute';
    if (absValue < $1b8c11769c39470f$var$DAY) return 'hour';
    return 'day';
}
function $1b8c11769c39470f$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $1b8c11769c39470f$var$MINUTE;
        case 'hour':
            return $1b8c11769c39470f$var$HOUR;
        default:
            return $1b8c11769c39470f$var$DAY;
    }
}
function $1b8c11769c39470f$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $1b8c11769c39470f$var$MINUTE;
        default:
            return value * $1b8c11769c39470f$var$HOUR;
    }
}
var $1b8c11769c39470f$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $1b8c11769c39470f$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $1b8c11769c39470f$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $1b8c11769c39470f$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $4vLTk.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $3Cq0D.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $bSJIT.createElement(Text, null, formattedRelativeTime);
    return $bSJIT.createElement($bSJIT.Fragment, null, formattedRelativeTime);
};
var $1b8c11769c39470f$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $3Cq0D.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $dETlE.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $1b8c11769c39470f$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $bSJIT.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $bSJIT.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $bSJIT.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($1b8c11769c39470f$var$canIncrement(unit) ? $1b8c11769c39470f$var$valueToSeconds(value, unit) : 0);
    }
    $bSJIT.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$1b8c11769c39470f$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $1b8c11769c39470f$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $1b8c11769c39470f$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($1b8c11769c39470f$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $1b8c11769c39470f$var$selectUnit(currentValueInSeconds);
        var unitDuration = $1b8c11769c39470f$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $bSJIT.createElement($1b8c11769c39470f$var$SimpleFormattedRelativeTime, (0, $3Cq0D.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$1b8c11769c39470f$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $1b8c11769c39470f$export$2e2bcd8739ae039 = $1b8c11769c39470f$var$FormattedRelativeTime;

});






parcelRegister("iX6PB", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => (parcelRequire("1oYUn")).getCmdbFieldValueElement);

var $1oYUn = parcelRequire("1oYUn");

});
parcelRegister("1oYUn", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => $f131fb07fc8060ac$export$ce19e854d193d5b3);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $fT4XN = parcelRequire("fT4XN");

var $fuVmc = parcelRequire("fuVmc");

var $dTM5i = parcelRequire("dTM5i");

var $1w9as = parcelRequire("1w9as");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $amYpB = parcelRequire("amYpB");

var $81Vbr = parcelRequire("81Vbr");

var $a6ENB = parcelRequire("a6ENB");
parcelRequire("g7Wu4");
var $3U7LN = parcelRequire("3U7LN");
const $f131fb07fc8060ac$var$onIntlError = (intlError)=>{
    try {
        $a6ENB.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $f131fb07fc8060ac$export$3bcefabe8b04378c = (intlError)=>{
    $f131fb07fc8060ac$var$onIntlError(intlError.message);
};
const $f131fb07fc8060ac$export$3c09dff16567da2f = (base64String)=>{
    try {
        // Decode base64 string while preserving Unicode characters
        const binaryString = atob(base64String || '');
        const bytes = new Uint8Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
        const decoder = new TextDecoder('utf-8');
        const decodedString = decoder.decode(bytes);
        return JSON.parse(decodedString);
    } catch (e) {
        return null;
    }
};
const $f131fb07fc8060ac$export$ce19e854d193d5b3 = ()=>{
    class CmdbFieldValueElement extends HTMLElement {
        connectedCallback() {
            // Jira passes the cmdb object data as a data-object-details-base64 attribute
            const objectDetailsBase64 = this.getAttribute('data-object-details-base64');
            const parsedObjectDetails = $f131fb07fc8060ac$export$3c09dff16567da2f(objectDetailsBase64);
            if (!parsedObjectDetails) return;
            // render the component with its props, and add to the Shadow DOM
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const root = document.createElement('span');
            // eslint-disable-next-line react/no-deprecated
            $4Sf72.render(/*#__PURE__*/ $bSJIT.createElement((0, $dTM5i.default), {
                messages: (0, $amYpB.default)(),
                locale: (0, $81Vbr.getLanguageFromLocale)((0, $fuVmc.getMetaData)().userLocale),
                onError: $f131fb07fc8060ac$export$3bcefabe8b04378c
            }, /*#__PURE__*/ $bSJIT.createElement((0, $1w9as.default), {
                onEvent: (0, $jBiia.legacySendEvent)
            }, /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
                sourceName: "portalUnknown",
                sourceType: (0, $haAAx.ScreenTypes).SCREEN,
                attributes: {
                    context: 'Portal'
                }
            }, /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
                packageName: "cmdbFieldValueWebComponent",
                id: "cmdb-object-card",
                renderError: ()=>null
            }, /*#__PURE__*/ $bSJIT.createElement((0, $3U7LN.default), {
                cmdbObject: parsedObjectDetails
            }))))), root);
            this.appendChild(root);
        }
    }
    return CmdbFieldValueElement;
};

});
parcelRegister("fT4XN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6124f0bd12a0cce7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $jBiia = parcelRequire("jBiia");
const $6124f0bd12a0cce7$var$SENTRY_EXCLUDED_STATUS_CODES = [
    429
];
class $6124f0bd12a0cce7$export$e926676385687eaf extends $bSJIT.Component {
    componentDidCatch(error) {
        const { id: id, createAnalyticsEvent: createAnalyticsEvent, analyticsAttributes: analyticsAttributes, packageName: packageName, onError: onError } = this.props;
        this.setState({
            error: error
        });
        const data = {};
        if (id) data.errorBoundaryId = id;
        if (packageName) data.errorBoundaryPackageName = packageName;
        const shouldExclude = error && error.hasOwnProperty('status') && $6124f0bd12a0cce7$var$SENTRY_EXCLUDED_STATUS_CODES.includes(error.status);
        if (!shouldExclude) (0, $jBiia.trackError)('app.boundary.uncaught.error', data, error);
        if (createAnalyticsEvent !== undefined) {
            const analyticsEvent = createAnalyticsEvent({
                ...analyticsAttributes,
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                errorMessage: (0, $jBiia.getErrorData)(error)
            });
            // TODO: FSD-4121 switch to using '@atlassian/error-handling'
            // Note that `componentName` is used as `actionSubject` in gasV3 operational events, and takes this form as described at
            // https://hello.atlassian.net/wiki/spaces/ALBS/pages/589347147/Jira+monitoring+frontend+errors#Step-2%3A-register-events
            const finalId = id || 'unknownErrorBoundary';
            const finalPackage = packageName || 'unknownPackage';
            const actionSubject = `${finalPackage}.${finalId}`;
            analyticsEvent.context.push({
                componentName: actionSubject
            });
            analyticsEvent.fire();
        }
        if (onError) onError(error);
    }
    render() {
        const { children: children, renderError: renderError } = this.props;
        const { error: error } = this.state;
        if (error) return renderError ? renderError(error) : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
var $6124f0bd12a0cce7$export$2e2bcd8739ae039 = (0, $2usNr.default)()((0, $kIbto.default)()($6124f0bd12a0cce7$export$e926676385687eaf));

});
parcelRegister("2usNr", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7a571433b3be915$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");
const $d7a571433b3be915$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $bSJIT.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $d7a571433b3be915$export$2e2bcd8739ae039 = $d7a571433b3be915$var$withAnalyticsContext;

});

parcelRegister("jBiia", function(module, exports) {
$parcel$export(module.exports, "legacySendEvent", () => $1073e90c1a8fc3c3$export$31613c62bfdc6a53);
$parcel$export(module.exports, "sendEventFromAnalyticsBridge", () => $1073e90c1a8fc3c3$export$80c476f25a50624a);
$parcel$export(module.exports, "sendAtlaskitUIEvent", () => $1073e90c1a8fc3c3$export$8c604b65319094be);
$parcel$export(module.exports, "legacyTrackEvent", () => $1073e90c1a8fc3c3$export$d34aefccac2c4e2b);
$parcel$export(module.exports, "getErrorData", () => $1073e90c1a8fc3c3$export$6fd42d413c537998);
$parcel$export(module.exports, "trackError", () => $1073e90c1a8fc3c3$export$5a6ec5e5079bbe35);

var $lFpPv = parcelRequire("lFpPv");

var $clpci = parcelRequire("clpci");

var $haAAx = parcelRequire("haAAx");

var $gEVth = parcelRequire("gEVth");

var $758n4 = parcelRequire("758n4");

var $a6ENB = parcelRequire("a6ENB");

var $bLmdo = parcelRequire("bLmdo");

var $iRD29 = parcelRequire("iRD29");

var $1825i = parcelRequire("1825i");
const $1073e90c1a8fc3c3$var$getMeta = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,  @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    const buildVersion = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION;
    return {
        sessionId: $1825i.sessionId,
        context: window.location.pathname,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        version: buildVersion ? buildVersion.buildKey : 'JPF-STORYBOOK-000'
    };
};
function $1073e90c1a8fc3c3$export$31613c62bfdc6a53(event) {
    $1073e90c1a8fc3c3$var$sendEvent(event);
}
function $1073e90c1a8fc3c3$export$80c476f25a50624a(event) {
    $1073e90c1a8fc3c3$var$sendEvent(event, (0, $clpci.ANALYTICS_BRIDGE_CHANNEL));
}
function $1073e90c1a8fc3c3$var$sendEvent(event, channel) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) analyticsWebClient.sendEvent(event, channel);
    (0, $bLmdo.reportAnalyticsEvent)(event);
}
const $1073e90c1a8fc3c3$var$extractFromEventContext = (propertyNames, event)=>// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    event.context// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    .reduceRight((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
function $1073e90c1a8fc3c3$export$8c604b65319094be(event) {
    const analyticsWebClient = (0, $iRD29.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        event.update({
            // Don't override analyticsType if it already exists.
            // Else set it to UI_EVENT_TYPE.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            analyticsType: event.payload.analyticsType || (0, $haAAx.UI_EVENT_TYPE),
            // Extract actionSubjectId from context.
            // Analytics web react enforces it must be defined here - else it won't pick it up.
            // See: https://bitbucket.org/atlassian/analytics-web-react/src/master/src/utils/extract-data-from-event.js?at=master#lines-89
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            actionSubjectId: $1073e90c1a8fc3c3$var$extractFromEventContext([
                'actionSubjectId'
            ], event)[0]
        });
        analyticsWebClient.sendEvent(event);
    }
}
function $1073e90c1a8fc3c3$export$d34aefccac2c4e2b(eventName, data) {
    const mergedData = {
        ...data,
        ...$1073e90c1a8fc3c3$var$getMeta()
    };
    (0, $758n4.trackLegacyEvent)(eventName, mergedData);
}
function $1073e90c1a8fc3c3$var$truncateMessage(message, length = 25) {
    if (message === null || message === undefined) return 'null';
    return message.slice(0, length);
}
function $1073e90c1a8fc3c3$var$sendErrorToSentry(error, additionalErrorData) {
    try {
        // log to sentry
        (0, $a6ENB.reportError)(error, additionalErrorData);
    } catch (ex) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access ,@typescript-eslint/no-unsafe-assignment
        const errorMessage = JSON.stringify({
            name: ex.name,
            msg: ex.message
        });
        $1073e90c1a8fc3c3$export$d34aefccac2c4e2b('sentry.error.tracking.failed', {
            error: errorMessage
        });
        (0, $gEVth.operationalEvent)({
            action: 'failed',
            actionSubjectId: 'SentryErrorTracking',
            attributes: {
                error: errorMessage,
                ...additionalErrorData
            },
            source: 'unknownSource'
        });
    }
}
/**
 * this error tracking event is to send the caught sentry error to the newer GASv3 analytics as an
 * operational event
 */ function $1073e90c1a8fc3c3$var$sendOperationalErrorEvent(eventName, error, additionalAttribute) {
    (0, $gEVth.operationalEvent)({
        action: 'failed',
        actionSubjectId: 'SentryErrorTracking',
        actionSubject: 'sentryError',
        source: 'unknownSource',
        attributes: {
            ...additionalAttribute,
            error: error,
            eventName: eventName
        }
    });
}
function $1073e90c1a8fc3c3$export$6fd42d413c537998(error) {
    let errorData = '';
    if (!error) // undefined error
    errorData = JSON.stringify({
        msg: 'null'
    });
    else if (!!error.xhr) {
        // ajax error
        const ajaxError = error;
        const xhr = ajaxError.xhr;
        errorData = JSON.stringify({
            name: 'AjaxError',
            // we can hard code this here because we know it's an ajax error
            stat: xhr.status,
            msg: $1073e90c1a8fc3c3$var$truncateMessage(ajaxError.message)
        });
    } else if (typeof error === 'string') // error as string
    errorData = JSON.stringify({
        msg: error
    });
    else {
        // generic js error
        const jsError = error;
        errorData = JSON.stringify({
            name: $1073e90c1a8fc3c3$var$truncateMessage(jsError.name),
            msg: $1073e90c1a8fc3c3$var$truncateMessage(jsError.message, 100)
        });
    }
    return errorData;
}
function $1073e90c1a8fc3c3$export$5a6ec5e5079bbe35(eventName, data, error) {
    const errorData = $1073e90c1a8fc3c3$export$6fd42d413c537998(error);
    // Skip sending to Sentry if it's an AjaxError or if filterFromSentry is true
    if (error && !error.xhr && !error.filterFromSentry) {
        if (typeof error === 'string') $1073e90c1a8fc3c3$var$sendErrorToSentry(new Error(error), data);
        else {
            // generic js error
            const jsError = error;
            $1073e90c1a8fc3c3$var$sendErrorToSentry(jsError, data);
        }
    }
    /**  behind the WRM optimisation feature flag and do not fire
   *  operational event for errors caught by error boundary
   */ if ((0, $lFpPv.isWrmOptimizationsEnabled)() && !(data && data.errorBoundaryId)) $1073e90c1a8fc3c3$var$sendOperationalErrorEvent(eventName, errorData, data);
    const eventData = {
        ...data,
        error: errorData
    };
    return $1073e90c1a8fc3c3$export$d34aefccac2c4e2b(eventName, eventData);
}

});
parcelRegister("758n4", function(module, exports) {
$parcel$export(module.exports, "trackLegacyEvent", () => $3f1c3744182ed534$export$655ee831d8b45890);

var $lFpPv = parcelRequire("lFpPv");

var $53hm0 = parcelRequire("53hm0");

var $1825i = parcelRequire("1825i");

var $k5qfr = parcelRequire("k5qfr");

var $2fSx2 = parcelRequire("2fSx2");

var $F3zzd = parcelRequire("F3zzd");
const $3f1c3744182ed534$var$sanitizeAnalyticEvent = (eventName, eventProperties)=>{
    // for any new events which have been added to portal frontend whitelist
    // we will add a prefix to the eventname and sanitize its properties
    if ((0, $k5qfr.isWhiteListEvent)(eventName)) return {
        name: `jsd.portal.frontend.${eventName}`,
        properties: (0, $k5qfr.sanitizeEventProperties)(eventName, eventProperties)
    };
    // if events not in whitelist, we will let cloud analytic plugin handle it instead
    return {
        name: eventName,
        properties: eventProperties
    };
};
const $3f1c3744182ed534$export$655ee831d8b45890 = (name, data)=>{
    const props = {
        ...data,
        sessionId: $1825i.sessionId
    };
    props.sdVersion = (0, $2fSx2.getPluginVersion)() || props.sdVersion || 'unknown';
    props.portalFrontendBuildKey = (0, $2fSx2.getCustomerPortalFrontendBuildKey)() || props.portalFrontendBuildKey || 'unknown';
    const safeEventObject = $3f1c3744182ed534$var$sanitizeAnalyticEvent(name, props);
    // TODO: replace with fireLegacyEvent(safeEventObject) from src/rest/legacy-event
    // the reason now here is to cater for the https://jdog.jira-dev.com/browse/JSDKB-1468 task which
    // still consumes the GASv2 events, this following code should be removed once the above task is fixed
    if ((0, $lFpPv.isWrmOptimizationsEnabled)()) {
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $F3zzd.fireLegacyEvent)(safeEventObject);
        return;
    }
    const eventQueue = (0, $53hm0.getEventQueue)();
    eventQueue && eventQueue.push(safeEventObject);
};

});
parcelRegister("1825i", function(module, exports) {
$parcel$export(module.exports, "sessionId", () => $995f5f8b2b4bef7b$export$f1faf18bafef2950);

var $lL6HC = parcelRequire("lL6HC");
const $995f5f8b2b4bef7b$export$f1faf18bafef2950 = (0, $lL6HC.default)();

});
parcelRegister("lL6HC", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b4fb2cf90c57b5a$export$2e2bcd8739ae039);

var $cPF6v = parcelRequire("cPF6v");
const $5b4fb2cf90c57b5a$var$s4 = ()=>(0, $cPF6v.default).floor((1 + (0, $cPF6v.default).random()) * 0x10000).toString(16).substring(1);
function $5b4fb2cf90c57b5a$export$2e2bcd8739ae039() {
    return `${$5b4fb2cf90c57b5a$var$s4()}${$5b4fb2cf90c57b5a$var$s4()}-${$5b4fb2cf90c57b5a$var$s4()}-${$5b4fb2cf90c57b5a$var$s4()}-${$5b4fb2cf90c57b5a$var$s4()}-${$5b4fb2cf90c57b5a$var$s4()}${$5b4fb2cf90c57b5a$var$s4()}${$5b4fb2cf90c57b5a$var$s4()}`;
}

});
parcelRegister("cPF6v", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a82888d1b016d41$export$2e2bcd8739ae039);
// This exists so we can have an easier time stubbing it out in tests.
var $5a82888d1b016d41$export$2e2bcd8739ae039 = Math;

});



parcelRegister("k5qfr", function(module, exports) {
$parcel$export(module.exports, "isWhiteListEvent", () => $7bdec36a1754466e$export$364166d55b6d152b);
$parcel$export(module.exports, "sanitizeEventProperties", () => $7bdec36a1754466e$export$fc45a7cd0562e9ff);

var $4ZMmh = parcelRequire("4ZMmh");

var $hfh2O = parcelRequire("hfh2O");
const $7bdec36a1754466e$var$WHITELIST_KEYS = Object.keys($hfh2O);
const $7bdec36a1754466e$export$364166d55b6d152b = (eventName)=>(0, $4ZMmh.includes)($7bdec36a1754466e$var$WHITELIST_KEYS, eventName);
const $7bdec36a1754466e$export$fc45a7cd0562e9ff = (eventName, eventProperties)=>{
    return (0, $4ZMmh.pick)(eventProperties, $hfh2O[eventName]);
};

});
parcelRegister("hfh2O", function(module, exports) {
module.exports = JSON.parse("{\"footer.waclink.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"search.overlay.button.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"session.logout.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"header.avatar.menu.opened\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.profile.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.logout.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.all.requests.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.pending.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.organisation.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.spotlight.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.not.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"request.change.spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"search.result.kb.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.portal.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"sentry.error.tracking.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"helpcenter.search.textbox.focused\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"helpcenter.search.textbox.submit\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.dismiss.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.target.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"spotlightKey\",\"error\"],\"servicedesk.customerview.smartportal.browse.popular.portals.portal.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"portalFrontendBuildKey\"],\"servicedesk.customerview.smartportal.browse.popular.portals.browse.all.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"organisation.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"kbsuggestions.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"findlabel.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"finduser.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"servicedesk.customerview.smartportal.browse.recent.requesttypes.requesttype.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.save.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.cancel.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"async.loader.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"portal.home.announcement.banner.collapse.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"portal.home.announcement.banner.expand.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"categories.fetch.all.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"category.articles.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"raise.request.cta.button\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"]}");

});


parcelRegister("2fSx2", function(module, exports) {
$parcel$export(module.exports, "getPluginVersion", () => $f7d70f8b8faa1ebb$export$face9f52d66c8c0f);
$parcel$export(module.exports, "getCustomerPortalFrontendBuildKey", () => $f7d70f8b8faa1ebb$export$d9a9dd9e37b497b6);

var $53hm0 = parcelRequire("53hm0");
const $f7d70f8b8faa1ebb$export$face9f52d66c8c0f = ()=>{
    return (0, $53hm0.getMeta) && (0, $53hm0.getMeta)('sdPluginVersion');
};
const $f7d70f8b8faa1ebb$export$d9a9dd9e37b497b6 = ()=>{
    if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    return undefined;
};

});

parcelRegister("F3zzd", function(module, exports) {
$parcel$export(module.exports, "fireLegacyEvent", () => $d8f4da342d2e9f8f$export$88121588a617f5f9);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $d8f4da342d2e9f8f$export$88121588a617f5f9 = (event, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/analytics/1.0/publish/bulk`;
    const body = [
        event
    ];
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise();
};

});


parcelRegister("bLmdo", function(module, exports) {
$parcel$export(module.exports, "reportAnalyticsEvent", () => $794fd58ab104bf76$export$4d9f272573494add);

var $kOZtN = parcelRequire("kOZtN");
var $icZGb = parcelRequire("icZGb");

var $haAAx = parcelRequire("haAAx");

var $6JJ8C = parcelRequire("6JJ8C");
const $794fd58ab104bf76$export$4d9f272573494add = (event)=>{
    try {
        const { analyticsType: analyticsType, action: action, componentName: componentName, actionSubjectId: actionSubjectId, source: source } = [
            ...event.context || [],
            event.payload
        ].reduce((acc, curr)=>({
                ...acc,
                ...curr
            }), {
            eventType: undefined,
            action: undefined,
            componentName: undefined,
            actionSubjectId: undefined,
            source: undefined
        });
        // for screen events, source has the name of the screen
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
        const actionSubject = analyticsType === (0, $haAAx.SCREEN_EVENT_TYPE) ? `screen<${source}>` : componentName;
        if (analyticsType && action && actionSubject) {
            if (analyticsType !== (0, $haAAx.UI_EVENT_TYPE) && analyticsType !== (0, $haAAx.TRACK_EVENT_TYPE) && analyticsType !== (0, $haAAx.OPERATIONAL_EVENT_TYPE) && analyticsType !== (0, $haAAx.SCREEN_EVENT_TYPE)) {
                (0, $6JJ8C.devLog)(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `An event was left out of Sentry breadcrumbs because it had an invalid analyticsType: ${analyticsType}.\nAllowed types: ${[
                    (0, $haAAx.UI_EVENT_TYPE),
                    (0, $haAAx.TRACK_EVENT_TYPE),
                    (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                    (0, $haAAx.SCREEN_EVENT_TYPE)
                ].join(', ')}`);
                return;
            }
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const eventDescription = `${analyticsType} ${action} ${actionSubject}`;
            const eventDescriptionWithId = actionSubjectId ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescription}<${actionSubjectId}>` : eventDescription;
            // omit source for screen events because it's already about them!
            const eventMessage = source && analyticsType !== (0, $haAAx.SCREEN_EVENT_TYPE) ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescriptionWithId} from source<${source}>` : eventDescriptionWithId;
            // Scenario: a user clicks on a button with ID myButton on a screen with ID myScreen
            // Here's what's sent as a breadcrumb: ui clicked button<myButton> from source<myScreen>
            // When some data is missing, it's omitted, so we still get a good idea of what was going on.
            $kOZtN.addBreadcrumb({
                category: 'analytics',
                message: eventMessage,
                level: $icZGb.Severity.Info
            });
        }
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.error('Error capturing analytics event as Sentry breadcrumb', exception);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        $kOZtN.captureEvent({
            exception: exception,
            message: 'Error capturing analytics event as Sentry breadcrumb'
        });
    }
};

});



parcelRegister("1w9as", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5c03eea8dde15f9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $gExTV = parcelRequire("gExTV");

var $4m3i7 = parcelRequire("4m3i7");

var $pW6JL = parcelRequire("pW6JL");
const $f5c03eea8dde15f9$var$AnalyticsListener = (props)=>{
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this listener.
    const [isModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(()=>(0, $gExTV.default) || (0, $gdUUy.fg)('analytics-next-use-legacy-context') === false || (0, $gdUUy.fg)('adminhub-analytics-next-use-modern-context') || (0, $gdUUy.fg)('bitbucket-analytics-next-use-modern-context'));
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $pW6JL.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4m3i7.default), props);
};
var $f5c03eea8dde15f9$export$2e2bcd8739ae039 = $f5c03eea8dde15f9$var$AnalyticsListener;

});
parcelRegister("4m3i7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e269f22bb945491$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $euFUz = parcelRequire("euFUz");
const $1e269f22bb945491$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
};
const $1e269f22bb945491$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1e269f22bb945491$var$AnalyticsListener extends (0, $bSJIT.Component) {
    static #_ = this.contextTypes = $1e269f22bb945491$var$ContextTypes;
    static #_2 = this.childContextTypes = $1e269f22bb945491$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $1e269f22bb945491$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $1e269f22bb945491$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $euFUz.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $1e269f22bb945491$export$2e2bcd8739ae039 = $1e269f22bb945491$var$AnalyticsListener;

});

parcelRegister("pW6JL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7962a1efde1ff496$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $euFUz = parcelRequire("euFUz");

var $6ZxMT = parcelRequire("6ZxMT");

var $lE3PD = parcelRequire("lE3PD");
const $7962a1efde1ff496$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $6ZxMT.useAnalyticsContext)();
    const onEventRef = (0, $lE3PD.useTrackedRef)(onEvent);
    const channelRef = (0, $lE3PD.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $bSJIT.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $bSJIT.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $euFUz.default).Provider, {
        value: value
    }, children);
};
var $7962a1efde1ff496$export$2e2bcd8739ae039 = $7962a1efde1ff496$var$AnalyticsListener;

});


parcelRegister("g7Wu4", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectCard", () => (parcelRequire("3U7LN")).default);

var $3U7LN = parcelRequire("3U7LN");

});
parcelRegister("3U7LN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d6a75b3407376c0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4U3zK = parcelRequire("4U3zK");

var $fK3tS = parcelRequire("fK3tS");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $hDkm2 = parcelRequire("hDkm2");

var $87QgR = parcelRequire("87QgR");

var $gEVth = parcelRequire("gEVth");
parcelRequire("arQGg");
var $9LGCi = parcelRequire("9LGCi");
parcelRequire("8HBIN");
var $a89AW = parcelRequire("a89AW");
parcelRequire("8n9rx");
var $kYvaZ = parcelRequire("kYvaZ");

var $cfOqf = parcelRequire("cfOqf");
const $7d6a75b3407376c0$var$CmdbObjectCard = ({ cmdbObject: cmdbObject, onExpand: onExpand, intl: intl, hideExpand: hideExpand = false, alwaysShowExpand: alwaysShowExpand = false, isLoadingAttributes: isLoadingAttributes = false })=>{
    var _clientServerBridge$q;
    const [expanded, setExpanded] = (0, $bSJIT.useState)(false);
    const [hasRequestedAttributes, setHasRequestedAttributes] = (0, $bSJIT.useState)(false);
    const handleToggleExpand = ()=>{
        const next = !expanded;
        setExpanded(next);
        // Expand/collapse analytics are only for the new (GA-gated) experience — the old picker
        // must not emit this event.
        if ((0, $87QgR.default).checkGate('assets_custom_fields_limit_increase_ga')) (0, $gEVth.uiEvent)({
            action: next ? 'expanded' : 'collapsed',
            actionSubject: 'cmdbObjectCard',
            source: 'cmdbObjectCard'
        });
        if (next && !hasRequestedAttributes && onExpand && cmdbObject) {
            setHasRequestedAttributes(true);
            onExpand(cmdbObject.id);
        }
    };
    const timezoneId = // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    typeof document !== 'undefined' ? (_clientServerBridge$q = (0, $4U3zK.default).querySelector('meta[name="user-timezone"]')) === null || _clientServerBridge$q === void 0 ? void 0 : _clientServerBridge$q.getAttribute('content') : undefined;
    if (cmdbObject === null) return intl.formatMessage((0, $cfOqf.default).error);
    const renderChevronButton = ()=>{
        if (hideExpand || cmdbObject.attributes.length === 0 && !alwaysShowExpand) return null;
        const buttonLabel = intl.formatMessage(expanded ? (0, $cfOqf.default).collapseLabel : (0, $cfOqf.default).expandLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kYvaZ.ExpandCollapseToggle), {
            isExpanded: expanded,
            label: buttonLabel,
            onClick: handleToggleExpand,
            testId: "cmdb-object-card-expand-collapse-toggle"
        });
    };
    const containerVariantStyles = [
        $7d6a75b3407376c0$var$containerStyles,
        ...hideExpand || alwaysShowExpand ? [
            $7d6a75b3407376c0$var$newExperienceCardStyles
        ] : [],
        ...hideExpand ? [
            $7d6a75b3407376c0$var$reserveRemoveSpaceStyles
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: containerVariantStyles,
        testId: "cmdb-object-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9LGCi.MemoizedInsightIcon), {
        ...cmdbObject.avatar.mediaClientConfig,
        iconUrl: cmdbObject.avatar.url48
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $7d6a75b3407376c0$var$labelStyles
    }, cmdbObject.label), renderChevronButton()), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $7d6a75b3407376c0$var$attributesListContainerStyles
    }, (0, $87QgR.default).checkGate('assets_custom_fields_limit_increase_ga') && isLoadingAttributes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $7d6a75b3407376c0$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), {
        size: "small",
        label: intl.formatMessage((0, $cfOqf.default).loadingAttributes)
    })), (!(0, $87QgR.default).checkGate('assets_custom_fields_limit_increase_ga') || !isLoadingAttributes) && cmdbObject.attributes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a89AW.AttributeList), {
        attributes: cmdbObject.attributes,
        timezoneId: timezoneId
    }), (0, $87QgR.default).checkGate('assets_custom_fields_limit_increase_ga') && !isLoadingAttributes && cmdbObject.attributes.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $7d6a75b3407376c0$var$noAttributesStyles,
        role: "status",
        "aria-live": "polite"
    }, intl.formatMessage((0, $cfOqf.default).noAttributes))));
};
var $7d6a75b3407376c0$export$2e2bcd8739ae039 = (0, $fK3tS.default)($7d6a75b3407376c0$var$CmdbObjectCard);
const $7d6a75b3407376c0$var$containerStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    width: '100%',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    marginBottom: 'space.100',
    padding: 'space.100',
    boxSizing: 'border-box'
});
const $7d6a75b3407376c0$var$newExperienceCardStyles = (0, $9BVpB.xcss)({
    marginBottom: 'space.025',
    borderRadius: 'radius.medium'
});
const $7d6a75b3407376c0$var$reserveRemoveSpaceStyles = (0, $9BVpB.xcss)({
    maxWidth: '100%',
    paddingRight: 'space.400'
});
const $7d6a75b3407376c0$var$labelStyles = (0, $9BVpB.xcss)({
    font: 'font.body',
    color: 'color.text.subtle',
    margin: 'space.0',
    paddingLeft: 'space.100',
    flexGrow: 1,
    minWidth: 'space.0',
    overflowWrap: 'break-word'
});
const $7d6a75b3407376c0$var$attributesListContainerStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.200'
});
const $7d6a75b3407376c0$var$noAttributesStyles = (0, $9BVpB.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtlest'
});
const $7d6a75b3407376c0$var$loadingStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingBlock: 'space.100'
});

});
parcelRegister("gUpf2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Box", () => $0bcbb53da1b3072e$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $0bcbb53da1b3072e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $dHEk9 = parcelRequire("dHEk9");

var $ivKmQ = parcelRequire("ivKmQ");

var $9oUW7 = parcelRequire("9oUW7");

var $2UbVv = parcelRequire("2UbVv");

var $gfZ3w = parcelRequire("gfZ3w");

var $gCSUx = parcelRequire("gCSUx");
function $0bcbb53da1b3072e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0bcbb53da1b3072e$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $gfZ3w.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $9dQre.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $0bcbb53da1b3072e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ivKmQ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9oUW7.isSurfaceColorToken)(backgroundColor) && (0, $gCSUx.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $2UbVv.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $2UbVv.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $2UbVv.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $2UbVv.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $2UbVv.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $2UbVv.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $2UbVv.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $dHEk9.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0bcbb53da1b3072e$export$2e2bcd8739ae039 = $0bcbb53da1b3072e$export$e71c4d32a2263218;
const $0bcbb53da1b3072e$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("9dQre", function(module, exports) {
$parcel$export(module.exports, "Global", () => $6b6e0114f19c96e0$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $6b6e0114f19c96e0$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $6b6e0114f19c96e0$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $6b6e0114f19c96e0$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $6b6e0114f19c96e0$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("2aX1J")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("2aX1J")).w);

var $2aX1J = parcelRequire("2aX1J");

var $bSJIT = parcelRequire("bSJIT");

var $luUQ5 = parcelRequire("luUQ5");

var $imtW8 = parcelRequire("imtW8");

var $etF6B = parcelRequire("etF6B");
parcelRequire("cmyh6");
parcelRequire("g8vBZ");
parcelRequire("lVXSF");

parcelRequire("jNar1");
var $6b6e0114f19c96e0$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $2aX1J.h).call(props, 'css')) return $bSJIT.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $2aX1J.E);
    createElementArgArray[1] = (0, $2aX1J.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $bSJIT.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($6b6e0114f19c96e0$export$c8a8987d4410bf2d || ($6b6e0114f19c96e0$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $6b6e0114f19c96e0$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $2aX1J.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $etF6B.serializeStyles)([
        styles
    ], undefined, $bSJIT.useContext((0, $2aX1J.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bSJIT.useRef();
    (0, $imtW8.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $imtW8.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $luUQ5.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $6b6e0114f19c96e0$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $etF6B.serializeStyles)(args);
}
function $6b6e0114f19c96e0$export$d25ddfdf17c3ad3e() {
    var insertable = $6b6e0114f19c96e0$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $6b6e0114f19c96e0$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $6b6e0114f19c96e0$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $luUQ5.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $6b6e0114f19c96e0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $imtW8.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $luUQ5.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $6b6e0114f19c96e0$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $2aX1J.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $2aX1J.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $etF6B.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $luUQ5.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $2aX1J.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $6b6e0114f19c96e0$var$merge(cache.registered, css, $6b6e0114f19c96e0$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bSJIT.useContext((0, $2aX1J.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($6b6e0114f19c96e0$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("2aX1J", function(module, exports) {
$parcel$export(module.exports, "i", () => $195a4d7aa7b0324d$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $195a4d7aa7b0324d$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $195a4d7aa7b0324d$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $195a4d7aa7b0324d$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $195a4d7aa7b0324d$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $195a4d7aa7b0324d$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $195a4d7aa7b0324d$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $195a4d7aa7b0324d$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $195a4d7aa7b0324d$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $195a4d7aa7b0324d$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $195a4d7aa7b0324d$export$a9c23c6ac3fc3eca);

var $bSJIT = parcelRequire("bSJIT");

var $cmyh6 = parcelRequire("cmyh6");

var $g8vBZ = parcelRequire("g8vBZ");

var $lVXSF = parcelRequire("lVXSF");

var $l4aTk = parcelRequire("l4aTk");

var $luUQ5 = parcelRequire("luUQ5");

var $etF6B = parcelRequire("etF6B");

var $imtW8 = parcelRequire("imtW8");
var $195a4d7aa7b0324d$export$23f2a1d2818174ef = false;
var $195a4d7aa7b0324d$var$EmotionCacheContext = /* #__PURE__ */ $bSJIT.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $cmyh6.default)({
    key: 'css'
}) : null);
var $195a4d7aa7b0324d$export$e7094788287c5e9b = $195a4d7aa7b0324d$var$EmotionCacheContext.Provider;
var $195a4d7aa7b0324d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $bSJIT.useContext)($195a4d7aa7b0324d$var$EmotionCacheContext);
};
var $195a4d7aa7b0324d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $bSJIT.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bSJIT.useContext)($195a4d7aa7b0324d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $195a4d7aa7b0324d$export$971d5caa766a69d7 = /* #__PURE__ */ $bSJIT.createContext({});
var $195a4d7aa7b0324d$export$3b14a55fb2447963 = function useTheme() {
    return $bSJIT.useContext($195a4d7aa7b0324d$export$971d5caa766a69d7);
};
var $195a4d7aa7b0324d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $g8vBZ.default)({}, outerTheme, theme);
};
var $195a4d7aa7b0324d$var$createCacheWithTheme = /* #__PURE__ */ (0, $lVXSF.default)(function(outerTheme) {
    return (0, $lVXSF.default)(function(theme) {
        return $195a4d7aa7b0324d$var$getTheme(outerTheme, theme);
    });
});
var $195a4d7aa7b0324d$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $bSJIT.useContext($195a4d7aa7b0324d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $195a4d7aa7b0324d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bSJIT.createElement($195a4d7aa7b0324d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $195a4d7aa7b0324d$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $bSJIT.forwardRef(function render(props, ref) {
        var theme = $bSJIT.useContext($195a4d7aa7b0324d$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bSJIT.createElement(Component, (0, $g8vBZ.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $l4aTk.default)(WithTheme, Component);
}
var $195a4d7aa7b0324d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $195a4d7aa7b0324d$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $195a4d7aa7b0324d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($195a4d7aa7b0324d$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$195a4d7aa7b0324d$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $195a4d7aa7b0324d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $luUQ5.registerStyles)(cache, serialized, isStringTag);
    (0, $imtW8.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $luUQ5.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $195a4d7aa7b0324d$var$Emotion = /* #__PURE__ */ $195a4d7aa7b0324d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$195a4d7aa7b0324d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $luUQ5.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $etF6B.serializeStyles)(registeredStyles, undefined, $bSJIT.useContext($195a4d7aa7b0324d$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($195a4d7aa7b0324d$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $195a4d7aa7b0324d$var$typePropName && !$195a4d7aa7b0324d$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($195a4d7aa7b0324d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, newProps));
});
var $195a4d7aa7b0324d$export$a9c23c6ac3fc3eca = $195a4d7aa7b0324d$var$Emotion;

});
parcelRegister("cmyh6", function(module, exports) {
$parcel$export(module.exports, "default", () => $900220604196b457$export$2e2bcd8739ae039);

var $eremi = parcelRequire("eremi");

var $jSt1s = parcelRequire("jSt1s");
var $a6PuG = parcelRequire("a6PuG");
var $8yVxV = parcelRequire("8yVxV");
var $fGWJZ = parcelRequire("fGWJZ");
var $lbEEU = parcelRequire("lbEEU");
var $aRMnA = parcelRequire("aRMnA");
parcelRequire("lVXSF");
parcelRequire("1MzDO");
var $900220604196b457$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $jSt1s.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $jSt1s.token)(character)) break;
        (0, $jSt1s.next)();
    }
    return (0, $jSt1s.slice)(begin, (0, $jSt1s.position));
};
var $900220604196b457$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $jSt1s.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $jSt1s.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $900220604196b457$var$identifierWithPointTracking((0, $jSt1s.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $jSt1s.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $jSt1s.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $a6PuG.from)(character);
    }
    while (character = (0, $jSt1s.next)());
    return parsed;
};
var $900220604196b457$var$getRules = function getRules(value, points) {
    return (0, $jSt1s.dealloc)($900220604196b457$var$toRules((0, $jSt1s.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $900220604196b457$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $900220604196b457$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$900220604196b457$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $900220604196b457$var$fixedElements.set(element, true);
    var points = [];
    var rules = $900220604196b457$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $900220604196b457$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $900220604196b457$var$prefix(value, length) {
    switch((0, $a6PuG.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fGWJZ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fGWJZ.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MOZ) + value + (0, $fGWJZ.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + value + value;
        // order
        case 6165:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fGWJZ.WEBKIT) + value + (0, $a6PuG.replace)(value, /(\w+).+(:[^]+)/, (0, $fGWJZ.WEBKIT) + 'box-$1$2' + (0, $fGWJZ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + 'flex-item-' + (0, $a6PuG.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + 'flex-line-pack' + (0, $a6PuG.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fGWJZ.WEBKIT) + 'box-' + (0, $a6PuG.replace)(value, '-grow', '') + (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fGWJZ.WEBKIT) + (0, $a6PuG.replace)(value, /([^-])(transform)/g, '$1' + (0, $fGWJZ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $a6PuG.replace)((0, $a6PuG.replace)((0, $a6PuG.replace)(value, /(zoom-|grab)/, (0, $fGWJZ.WEBKIT) + '$1'), /(image-set)/, (0, $fGWJZ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $a6PuG.replace)(value, /(image-set\([^]*)/, (0, $fGWJZ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $a6PuG.replace)((0, $a6PuG.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fGWJZ.WEBKIT) + 'box-pack:$3' + (0, $fGWJZ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fGWJZ.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $a6PuG.replace)(value, /(.+)-inline(.+)/, (0, $fGWJZ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $a6PuG.strlen)(value) - 1 - length > 6) switch((0, $a6PuG.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $a6PuG.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $a6PuG.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fGWJZ.WEBKIT) + '$2-$3' + '$1' + (0, $fGWJZ.MOZ) + ((0, $a6PuG.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $a6PuG.indexof)(value, 'stretch') ? $900220604196b457$var$prefix((0, $a6PuG.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $a6PuG.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $a6PuG.charat)(value, (0, $a6PuG.strlen)(value) - 3 - (~(0, $a6PuG.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $a6PuG.replace)(value, ':', ':' + (0, $fGWJZ.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $a6PuG.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fGWJZ.WEBKIT) + ((0, $a6PuG.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fGWJZ.WEBKIT) + '$2$3' + '$1' + (0, $fGWJZ.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $a6PuG.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + value + value;
    }
    return value;
}
var $900220604196b457$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fGWJZ.DECLARATION:
                element["return"] = $900220604196b457$var$prefix(element.value, element.length);
                break;
            case 0, $fGWJZ.KEYFRAMES:
                return (0, $aRMnA.serialize)([
                    (0, $jSt1s.copy)(element, {
                        value: (0, $a6PuG.replace)(element.value, '@', '@' + (0, $fGWJZ.WEBKIT))
                    })
                ], callback);
            case 0, $fGWJZ.RULESET:
                if (element.length) return (0, $a6PuG.combine)(element.props, function(value) {
                    switch((0, $a6PuG.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $aRMnA.serialize)([
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(read-\w+)/, ':' + (0, $fGWJZ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $aRMnA.serialize)([
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(plac\w+)/, ':' + (0, $fGWJZ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(plac\w+)/, ':' + (0, $fGWJZ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(plac\w+)/, (0, $fGWJZ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $900220604196b457$var$defaultStylisPlugins = [
    $900220604196b457$var$prefixer
];
var $900220604196b457$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $900220604196b457$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $900220604196b457$var$compat,
        $900220604196b457$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $aRMnA.stringify),
        (0, $lbEEU.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $lbEEU.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $aRMnA.serialize)((0, $8yVxV.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $eremi.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("eremi", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $a82eb99a4a9abc3e$export$9d753cd7ae895cce);
var $a82eb99a4a9abc3e$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $a82eb99a4a9abc3e$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $a82eb99a4a9abc3e$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $a82eb99a4a9abc3e$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$a82eb99a4a9abc3e$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($a82eb99a4a9abc3e$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $a82eb99a4a9abc3e$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("jSt1s", function(module, exports) {
$parcel$export(module.exports, "position", () => $e78992b9d9d9f500$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $e78992b9d9d9f500$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $e78992b9d9d9f500$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $e78992b9d9d9f500$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $e78992b9d9d9f500$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $e78992b9d9d9f500$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $e78992b9d9d9f500$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $e78992b9d9d9f500$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $e78992b9d9d9f500$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $e78992b9d9d9f500$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $e78992b9d9d9f500$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $e78992b9d9d9f500$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $e78992b9d9d9f500$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $e78992b9d9d9f500$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $e78992b9d9d9f500$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $e78992b9d9d9f500$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $e78992b9d9d9f500$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $e78992b9d9d9f500$export$4254d4e2b3745c4c);

var $a6PuG = parcelRequire("a6PuG");
var $e78992b9d9d9f500$export$53f1d5ea8de3d7c = 1;
var $e78992b9d9d9f500$export$4e0c71f277ca26b3 = 1;
var $e78992b9d9d9f500$export$f24224f1c91d8156 = 0;
var $e78992b9d9d9f500$export$5880b8b5730aff45 = 0;
var $e78992b9d9d9f500$export$c0306caf338ac095 = 0;
var $e78992b9d9d9f500$export$30a86d91af8ff6e6 = '';
function $e78992b9d9d9f500$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $e78992b9d9d9f500$export$53f1d5ea8de3d7c,
        column: $e78992b9d9d9f500$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $e78992b9d9d9f500$export$784d13d8ee351f07(root, props) {
    return (0, $a6PuG.assign)($e78992b9d9d9f500$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $e78992b9d9d9f500$export$eba6f6f03b0a92e7() {
    return $e78992b9d9d9f500$export$c0306caf338ac095;
}
function $e78992b9d9d9f500$export$232faf9add678146() {
    $e78992b9d9d9f500$export$c0306caf338ac095 = $e78992b9d9d9f500$export$5880b8b5730aff45 > 0 ? (0, $a6PuG.charat)($e78992b9d9d9f500$export$30a86d91af8ff6e6, --$e78992b9d9d9f500$export$5880b8b5730aff45) : 0;
    if ($e78992b9d9d9f500$export$4e0c71f277ca26b3--, $e78992b9d9d9f500$export$c0306caf338ac095 === 10) $e78992b9d9d9f500$export$4e0c71f277ca26b3 = 1, $e78992b9d9d9f500$export$53f1d5ea8de3d7c--;
    return $e78992b9d9d9f500$export$c0306caf338ac095;
}
function $e78992b9d9d9f500$export$48cfd1e771a65c4f() {
    $e78992b9d9d9f500$export$c0306caf338ac095 = $e78992b9d9d9f500$export$5880b8b5730aff45 < $e78992b9d9d9f500$export$f24224f1c91d8156 ? (0, $a6PuG.charat)($e78992b9d9d9f500$export$30a86d91af8ff6e6, $e78992b9d9d9f500$export$5880b8b5730aff45++) : 0;
    if ($e78992b9d9d9f500$export$4e0c71f277ca26b3++, $e78992b9d9d9f500$export$c0306caf338ac095 === 10) $e78992b9d9d9f500$export$4e0c71f277ca26b3 = 1, $e78992b9d9d9f500$export$53f1d5ea8de3d7c++;
    return $e78992b9d9d9f500$export$c0306caf338ac095;
}
function $e78992b9d9d9f500$export$4d3fb11e950abb9e() {
    return (0, $a6PuG.charat)($e78992b9d9d9f500$export$30a86d91af8ff6e6, $e78992b9d9d9f500$export$5880b8b5730aff45);
}
function $e78992b9d9d9f500$export$e88cb2efb12ae807() {
    return $e78992b9d9d9f500$export$5880b8b5730aff45;
}
function $e78992b9d9d9f500$export$58adb3bec8346d0f(begin, end) {
    return (0, $a6PuG.substr)($e78992b9d9d9f500$export$30a86d91af8ff6e6, begin, end);
}
function $e78992b9d9d9f500$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e78992b9d9d9f500$export$2de70f21292aac9e(value) {
    return $e78992b9d9d9f500$export$53f1d5ea8de3d7c = $e78992b9d9d9f500$export$4e0c71f277ca26b3 = 1, $e78992b9d9d9f500$export$f24224f1c91d8156 = (0, $a6PuG.strlen)($e78992b9d9d9f500$export$30a86d91af8ff6e6 = value), $e78992b9d9d9f500$export$5880b8b5730aff45 = 0, [];
}
function $e78992b9d9d9f500$export$45918ac1574455b1(value) {
    return $e78992b9d9d9f500$export$30a86d91af8ff6e6 = '', value;
}
function $e78992b9d9d9f500$export$410ac95b9ec204b8(type) {
    return (0, $a6PuG.trim)($e78992b9d9d9f500$export$58adb3bec8346d0f($e78992b9d9d9f500$export$5880b8b5730aff45 - 1, $e78992b9d9d9f500$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $e78992b9d9d9f500$export$660b2ee2d4fb4eff(value) {
    return $e78992b9d9d9f500$export$45918ac1574455b1($e78992b9d9d9f500$export$5f8c09e3ae6f64e1($e78992b9d9d9f500$export$2de70f21292aac9e(value)));
}
function $e78992b9d9d9f500$export$7af1228ff777d175(type) {
    while($e78992b9d9d9f500$export$c0306caf338ac095 = $e78992b9d9d9f500$export$4d3fb11e950abb9e())if ($e78992b9d9d9f500$export$c0306caf338ac095 < 33) $e78992b9d9d9f500$export$48cfd1e771a65c4f();
    else break;
    return $e78992b9d9d9f500$export$9e1725a4cfeada27(type) > 2 || $e78992b9d9d9f500$export$9e1725a4cfeada27($e78992b9d9d9f500$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $e78992b9d9d9f500$export$5f8c09e3ae6f64e1(children) {
    while($e78992b9d9d9f500$export$48cfd1e771a65c4f())switch($e78992b9d9d9f500$export$9e1725a4cfeada27($e78992b9d9d9f500$export$c0306caf338ac095)){
        case 0:
            (0, $a6PuG.append)($e78992b9d9d9f500$export$c2ab62c7bf24634($e78992b9d9d9f500$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $a6PuG.append)($e78992b9d9d9f500$export$410ac95b9ec204b8($e78992b9d9d9f500$export$c0306caf338ac095), children);
            break;
        default:
            (0, $a6PuG.append)((0, $a6PuG.from)($e78992b9d9d9f500$export$c0306caf338ac095), children);
    }
    return children;
}
function $e78992b9d9d9f500$export$955ba06d119e085e(index, count) {
    while(--count && $e78992b9d9d9f500$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($e78992b9d9d9f500$export$c0306caf338ac095 < 48 || $e78992b9d9d9f500$export$c0306caf338ac095 > 102 || $e78992b9d9d9f500$export$c0306caf338ac095 > 57 && $e78992b9d9d9f500$export$c0306caf338ac095 < 65 || $e78992b9d9d9f500$export$c0306caf338ac095 > 70 && $e78992b9d9d9f500$export$c0306caf338ac095 < 97) break;
    return $e78992b9d9d9f500$export$58adb3bec8346d0f(index, $e78992b9d9d9f500$export$e88cb2efb12ae807() + (count < 6 && $e78992b9d9d9f500$export$4d3fb11e950abb9e() == 32 && $e78992b9d9d9f500$export$48cfd1e771a65c4f() == 32));
}
function $e78992b9d9d9f500$export$c889f2fcc19dbf12(type) {
    while($e78992b9d9d9f500$export$48cfd1e771a65c4f())switch($e78992b9d9d9f500$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $e78992b9d9d9f500$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $e78992b9d9d9f500$export$c889f2fcc19dbf12($e78992b9d9d9f500$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $e78992b9d9d9f500$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $e78992b9d9d9f500$export$48cfd1e771a65c4f();
            break;
    }
    return $e78992b9d9d9f500$export$5880b8b5730aff45;
}
function $e78992b9d9d9f500$export$4254d4e2b3745c4c(type, index) {
    while($e78992b9d9d9f500$export$48cfd1e771a65c4f())// //
    if (type + $e78992b9d9d9f500$export$c0306caf338ac095 === 57) break;
    else if (type + $e78992b9d9d9f500$export$c0306caf338ac095 === 84 && $e78992b9d9d9f500$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $e78992b9d9d9f500$export$58adb3bec8346d0f(index, $e78992b9d9d9f500$export$5880b8b5730aff45 - 1) + '*' + (0, $a6PuG.from)(type === 47 ? type : $e78992b9d9d9f500$export$48cfd1e771a65c4f());
}
function $e78992b9d9d9f500$export$c2ab62c7bf24634(index) {
    while(!$e78992b9d9d9f500$export$9e1725a4cfeada27($e78992b9d9d9f500$export$4d3fb11e950abb9e()))$e78992b9d9d9f500$export$48cfd1e771a65c4f();
    return $e78992b9d9d9f500$export$58adb3bec8346d0f(index, $e78992b9d9d9f500$export$5880b8b5730aff45);
}

});
parcelRegister("a6PuG", function(module, exports) {
$parcel$export(module.exports, "abs", () => $75c268852f17082f$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $75c268852f17082f$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $75c268852f17082f$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $75c268852f17082f$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $75c268852f17082f$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $75c268852f17082f$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $75c268852f17082f$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $75c268852f17082f$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $75c268852f17082f$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $75c268852f17082f$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $75c268852f17082f$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $75c268852f17082f$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $75c268852f17082f$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $75c268852f17082f$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $75c268852f17082f$export$2335f513bbd82c6d = Math.abs;
var $75c268852f17082f$export$6788812c4e6611e6 = String.fromCharCode;
var $75c268852f17082f$export$e6e34fd1f2686227 = Object.assign;
function $75c268852f17082f$export$d6af199866bfb566(value, length) {
    return $75c268852f17082f$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $75c268852f17082f$export$a9db5e087081082d(value, 0)) << 2 ^ $75c268852f17082f$export$a9db5e087081082d(value, 1)) << 2 ^ $75c268852f17082f$export$a9db5e087081082d(value, 2)) << 2 ^ $75c268852f17082f$export$a9db5e087081082d(value, 3) : 0;
}
function $75c268852f17082f$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $75c268852f17082f$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $75c268852f17082f$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $75c268852f17082f$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $75c268852f17082f$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $75c268852f17082f$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $75c268852f17082f$export$36776f635604f274(value) {
    return value.length;
}
function $75c268852f17082f$export$f9084667e487ed46(value) {
    return value.length;
}
function $75c268852f17082f$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $75c268852f17082f$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("8yVxV", function(module, exports) {
$parcel$export(module.exports, "compile", () => $63be23336b184773$export$ef7acd7185315e22);

var $fGWJZ = parcelRequire("fGWJZ");

var $a6PuG = parcelRequire("a6PuG");

var $jSt1s = parcelRequire("jSt1s");
function $63be23336b184773$export$ef7acd7185315e22(value) {
    return (0, $jSt1s.dealloc)($63be23336b184773$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $jSt1s.alloc)(value), 0, [
        0
    ], value));
}
function $63be23336b184773$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $jSt1s.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $a6PuG.charat)(characters, length - 1) == 58) {
                if ((0, $a6PuG.indexof)(characters += (0, $a6PuG.replace)((0, $jSt1s.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $jSt1s.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $jSt1s.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $jSt1s.escaping)((0, $jSt1s.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $jSt1s.peek)()){
                case 42:
                case 47:
                    (0, $a6PuG.append)($63be23336b184773$export$4a34f930e789283c((0, $jSt1s.commenter)((0, $jSt1s.next)(), (0, $jSt1s.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $a6PuG.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $a6PuG.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $a6PuG.strlen)(characters) - length) (0, $a6PuG.append)(property > 32 ? $63be23336b184773$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $63be23336b184773$export$f8483753829ec8f3((0, $a6PuG.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $a6PuG.append)(reference = $63be23336b184773$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $63be23336b184773$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $a6PuG.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $63be23336b184773$export$98e6a39c04603d36(value, reference, reference, rule && (0, $a6PuG.append)($63be23336b184773$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $63be23336b184773$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $a6PuG.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $jSt1s.prev)() == 125) continue;
            }
            switch(characters += (0, $a6PuG.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $a6PuG.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $jSt1s.peek)() === 45) characters += (0, $jSt1s.delimit)((0, $jSt1s.next)());
                    atrule = (0, $jSt1s.peek)(), offset = length = (0, $a6PuG.strlen)(type = characters += (0, $jSt1s.identifier)((0, $jSt1s.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $a6PuG.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $63be23336b184773$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $a6PuG.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $a6PuG.substr)(value, post + 1, post = (0, $a6PuG.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $a6PuG.trim)(j > 0 ? rule[x] + ' ' + y : (0, $a6PuG.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $jSt1s.node)(value, root, parent, offset === 0 ? (0, $fGWJZ.RULESET) : type, props, children, length);
}
function $63be23336b184773$export$4a34f930e789283c(value, root, parent) {
    return (0, $jSt1s.node)(value, root, parent, (0, $fGWJZ.COMMENT), (0, $a6PuG.from)((0, $jSt1s.char)()), (0, $a6PuG.substr)(value, 2, -2), 0);
}
function $63be23336b184773$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $jSt1s.node)(value, root, parent, (0, $fGWJZ.DECLARATION), (0, $a6PuG.substr)(value, 0, length), (0, $a6PuG.substr)(value, length + 1, -1), length);
}

});
parcelRegister("fGWJZ", function(module, exports) {
$parcel$export(module.exports, "MS", () => $b6c857f5d2dc325c$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $b6c857f5d2dc325c$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $b6c857f5d2dc325c$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $b6c857f5d2dc325c$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $b6c857f5d2dc325c$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $b6c857f5d2dc325c$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $b6c857f5d2dc325c$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $b6c857f5d2dc325c$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $b6c857f5d2dc325c$export$d773506282b3cfe6);
var $b6c857f5d2dc325c$export$71ad59f2e432cfe8 = '-ms-';
var $b6c857f5d2dc325c$export$2c0f367103c8d01c = '-moz-';
var $b6c857f5d2dc325c$export$39dfd62a25e0fe93 = '-webkit-';
var $b6c857f5d2dc325c$export$a29989082612d0d9 = 'comm';
var $b6c857f5d2dc325c$export$aa3a2e812ca8570d = 'rule';
var $b6c857f5d2dc325c$export$527d108ccf083c2b = 'decl';
var $b6c857f5d2dc325c$export$d3d35020fa5b54f0 = '@page';
var $b6c857f5d2dc325c$export$500415a86c544f73 = '@media';
var $b6c857f5d2dc325c$export$a763edbf796b780a = '@import';
var $b6c857f5d2dc325c$export$2790aeb8b4e5c826 = '@charset';
var $b6c857f5d2dc325c$export$1cc683e23b84b133 = '@viewport';
var $b6c857f5d2dc325c$export$9447a5efea57e862 = '@supports';
var $b6c857f5d2dc325c$export$ef011b4e114b1fba = '@document';
var $b6c857f5d2dc325c$export$6aad947bda0f3f46 = '@namespace';
var $b6c857f5d2dc325c$export$b44a8529a35fcb60 = '@keyframes';
var $b6c857f5d2dc325c$export$2c16de31893252e6 = '@font-face';
var $b6c857f5d2dc325c$export$3d846dd52e150c6f = '@counter-style';
var $b6c857f5d2dc325c$export$22314bfbb57653fe = '@font-feature-values';
var $b6c857f5d2dc325c$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("lbEEU", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $f6ca2a0b143b2047$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $f6ca2a0b143b2047$export$38bcb760f1d4871c);

var $fGWJZ = parcelRequire("fGWJZ");

var $a6PuG = parcelRequire("a6PuG");

var $jSt1s = parcelRequire("jSt1s");

var $aRMnA = parcelRequire("aRMnA");

var $lI63i = parcelRequire("lI63i");
function $f6ca2a0b143b2047$export$5a7767152ae0305f(collection) {
    var length = (0, $a6PuG.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $f6ca2a0b143b2047$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $f6ca2a0b143b2047$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $fGWJZ.DECLARATION:
                element.return = (0, $lI63i.prefix)(element.value, element.length, children);
                return;
            case 0, $fGWJZ.KEYFRAMES:
                return (0, $aRMnA.serialize)([
                    (0, $jSt1s.copy)(element, {
                        value: (0, $a6PuG.replace)(element.value, '@', '@' + (0, $fGWJZ.WEBKIT))
                    })
                ], callback);
            case 0, $fGWJZ.RULESET:
                if (element.length) return (0, $a6PuG.combine)(element.props, function(value) {
                    switch((0, $a6PuG.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $aRMnA.serialize)([
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(read-\w+)/, ':' + (0, $fGWJZ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $aRMnA.serialize)([
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(plac\w+)/, ':' + (0, $fGWJZ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(plac\w+)/, ':' + (0, $fGWJZ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $jSt1s.copy)(element, {
                                    props: [
                                        (0, $a6PuG.replace)(value, /:(plac\w+)/, (0, $fGWJZ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $f6ca2a0b143b2047$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $fGWJZ.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $a6PuG.combine)((0, $jSt1s.tokenize)(value), function(value, index, children) {
                    switch((0, $a6PuG.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $a6PuG.substr)(value, 1, (0, $a6PuG.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $a6PuG.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $a6PuG.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $a6PuG.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("aRMnA", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $7e9461c14410e5a5$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $7e9461c14410e5a5$export$fac44ee5b035f737);

var $fGWJZ = parcelRequire("fGWJZ");

var $a6PuG = parcelRequire("a6PuG");
function $7e9461c14410e5a5$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $a6PuG.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $7e9461c14410e5a5$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $fGWJZ.LAYER:
            if (element.children.length) break;
        case 0, $fGWJZ.IMPORT:
        case 0, $fGWJZ.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $fGWJZ.COMMENT:
            return '';
        case 0, $fGWJZ.KEYFRAMES:
            return element.return = element.value + '{' + $7e9461c14410e5a5$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $fGWJZ.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $a6PuG.strlen)(children = $7e9461c14410e5a5$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("lI63i", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $fce266df609ab4be$export$82e9f45cca5ba907);

var $fGWJZ = parcelRequire("fGWJZ");

var $a6PuG = parcelRequire("a6PuG");
function $fce266df609ab4be$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $a6PuG.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fGWJZ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fGWJZ.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $fGWJZ.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MOZ) + value + (0, $fGWJZ.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $a6PuG.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + value + value;
        // order
        case 6165:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fGWJZ.WEBKIT) + value + (0, $a6PuG.replace)(value, /(\w+).+(:[^]+)/, (0, $fGWJZ.WEBKIT) + 'box-$1$2' + (0, $fGWJZ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + 'flex-item-' + (0, $a6PuG.replace)(value, /flex-|-self/g, '') + (!(0, $a6PuG.match)(value, /flex-|baseline/) ? (0, $fGWJZ.MS) + 'grid-row-' + (0, $a6PuG.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + 'flex-line-pack' + (0, $a6PuG.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fGWJZ.WEBKIT) + 'box-' + (0, $a6PuG.replace)(value, '-grow', '') + (0, $fGWJZ.WEBKIT) + value + (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fGWJZ.WEBKIT) + (0, $a6PuG.replace)(value, /([^-])(transform)/g, '$1' + (0, $fGWJZ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $a6PuG.replace)((0, $a6PuG.replace)((0, $a6PuG.replace)(value, /(zoom-|grab)/, (0, $fGWJZ.WEBKIT) + '$1'), /(image-set)/, (0, $fGWJZ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $a6PuG.replace)(value, /(image-set\([^]*)/, (0, $fGWJZ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $a6PuG.replace)((0, $a6PuG.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fGWJZ.WEBKIT) + 'box-pack:$3' + (0, $fGWJZ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fGWJZ.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $a6PuG.match)(value, /flex-|baseline/)) return (0, $fGWJZ.MS) + 'grid-column-align' + (0, $a6PuG.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $a6PuG.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $a6PuG.indexof)(value + (children = children[length].value), 'span') ? value : (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, '-start', '') + value + (0, $fGWJZ.MS) + 'grid-row-span:' + (~(0, $a6PuG.indexof)(children, 'span') ? (0, $a6PuG.match)(children, /\d+/) : +(0, $a6PuG.match)(children, /\d+/) - +(0, $a6PuG.match)(value, /\d+/)) + ';';
            return (0, $fGWJZ.MS) + (0, $a6PuG.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $a6PuG.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $fGWJZ.MS) + (0, $a6PuG.replace)((0, $a6PuG.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $a6PuG.replace)(value, /(.+)-inline(.+)/, (0, $fGWJZ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $a6PuG.strlen)(value) - 1 - length > 6) switch((0, $a6PuG.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $a6PuG.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $a6PuG.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fGWJZ.WEBKIT) + '$2-$3' + '$1' + (0, $fGWJZ.MOZ) + ((0, $a6PuG.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $a6PuG.indexof)(value, 'stretch') ? $fce266df609ab4be$export$82e9f45cca5ba907((0, $a6PuG.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $a6PuG.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $fGWJZ.MS) + a + ':' + b + f + (c ? (0, $fGWJZ.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $a6PuG.charat)(value, length + 6) === 121) return (0, $a6PuG.replace)(value, ':', ':' + (0, $fGWJZ.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $a6PuG.charat)(value, (0, $a6PuG.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $a6PuG.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $fGWJZ.WEBKIT) + ((0, $a6PuG.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fGWJZ.WEBKIT) + '$2$3' + '$1' + (0, $fGWJZ.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $a6PuG.replace)(value, ':', ':' + (0, $fGWJZ.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $a6PuG.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("lVXSF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff7d5ee4d1acecd5$export$2e2bcd8739ae039);
var $ff7d5ee4d1acecd5$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("1MzDO", function(module, exports) {
$parcel$export(module.exports, "default", () => $14c5ebbe6c97fb77$export$2e2bcd8739ae039);
function $14c5ebbe6c97fb77$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("l4aTk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5626b837cb63d43$export$2e2bcd8739ae039);

var $jNar1 = parcelRequire("jNar1");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f5626b837cb63d43$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jNar1)))(targetComponent, sourceComponent);
};

});

parcelRegister("luUQ5", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $fa687d5f44c15235$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $fa687d5f44c15235$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $fa687d5f44c15235$export$6f077d94b33a01aa);
var $fa687d5f44c15235$var$isBrowser = true;
function $fa687d5f44c15235$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $fa687d5f44c15235$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $fa687d5f44c15235$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $fa687d5f44c15235$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $fa687d5f44c15235$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("etF6B", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $a8a3a8d79e75d0e7$export$6321afa313b251b5);

var $f0ZAY = parcelRequire("f0ZAY");

var $hKnpQ = parcelRequire("hKnpQ");

var $1MzDO = parcelRequire("1MzDO");
var $a8a3a8d79e75d0e7$var$isDevelopment = false;
var $a8a3a8d79e75d0e7$var$hyphenateRegex = /[A-Z]|^ms/g;
var $a8a3a8d79e75d0e7$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $a8a3a8d79e75d0e7$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $a8a3a8d79e75d0e7$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $a8a3a8d79e75d0e7$var$processStyleName = /* #__PURE__ */ (0, $1MzDO.default)(function(styleName) {
    return $a8a3a8d79e75d0e7$var$isCustomProperty(styleName) ? styleName : styleName.replace($a8a3a8d79e75d0e7$var$hyphenateRegex, '-$&').toLowerCase();
});
var $a8a3a8d79e75d0e7$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($a8a3a8d79e75d0e7$var$animationRegex, function(match, p1, p2) {
                $a8a3a8d79e75d0e7$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $a8a3a8d79e75d0e7$var$cursor
                };
                return p1;
            });
    }
    if ((0, $hKnpQ.default)[key] !== 1 && !$a8a3a8d79e75d0e7$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $a8a3a8d79e75d0e7$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $a8a3a8d79e75d0e7$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $a8a3a8d79e75d0e7$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $a8a3a8d79e75d0e7$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $a8a3a8d79e75d0e7$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $a8a3a8d79e75d0e7$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $a8a3a8d79e75d0e7$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $a8a3a8d79e75d0e7$var$cursor;
                var result = interpolation(mergedProps);
                $a8a3a8d79e75d0e7$var$cursor = previousCursor;
                return $a8a3a8d79e75d0e7$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $a8a3a8d79e75d0e7$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $a8a3a8d79e75d0e7$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($a8a3a8d79e75d0e7$var$isProcessableValue(asString)) string += $a8a3a8d79e75d0e7$var$processStyleName(key) + ":" + $a8a3a8d79e75d0e7$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $a8a3a8d79e75d0e7$var$isDevelopment) throw new Error($a8a3a8d79e75d0e7$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($a8a3a8d79e75d0e7$var$isProcessableValue(value[_i])) string += $a8a3a8d79e75d0e7$var$processStyleName(key) + ":" + $a8a3a8d79e75d0e7$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $a8a3a8d79e75d0e7$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $a8a3a8d79e75d0e7$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $a8a3a8d79e75d0e7$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $a8a3a8d79e75d0e7$var$cursor;
function $a8a3a8d79e75d0e7$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $a8a3a8d79e75d0e7$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $a8a3a8d79e75d0e7$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $a8a3a8d79e75d0e7$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $a8a3a8d79e75d0e7$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $a8a3a8d79e75d0e7$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $f0ZAY.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $a8a3a8d79e75d0e7$var$cursor
    };
}

});
parcelRegister("f0ZAY", function(module, exports) {
$parcel$export(module.exports, "default", () => $aee6a2a7ce934273$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $aee6a2a7ce934273$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("hKnpQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ceb8e571cd5f830c$export$2e2bcd8739ae039);
var $ceb8e571cd5f830c$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("imtW8", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $d5e180e2d90b0db4$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $d5e180e2d90b0db4$export$811a713a7276cb9d);

var $bSJIT = parcelRequire("bSJIT");
var $d5e180e2d90b0db4$var$syncFallback = function syncFallback(create) {
    return create();
};
var $d5e180e2d90b0db4$var$useInsertionEffect = false;
var $d5e180e2d90b0db4$export$db21c7ffa21794e7 = $d5e180e2d90b0db4$var$useInsertionEffect || $d5e180e2d90b0db4$var$syncFallback;
var $d5e180e2d90b0db4$export$811a713a7276cb9d = $d5e180e2d90b0db4$var$useInsertionEffect || $bSJIT.useLayoutEffect;

});



parcelRegister("dHEk9", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $bd441c2d7535ea42$export$1ca2a26fecb070ae);

var $bSJIT = parcelRequire("bSJIT");
const $bd441c2d7535ea42$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $bSJIT.createContext)('elevation.surface');

});

parcelRegister("ivKmQ", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $ac856eca3966ff90$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aGYUm = parcelRequire("aGYUm");

var $yxwLu = parcelRequire("yxwLu");
const $ac856eca3966ff90$export$e7af83bafe7f9e63 = (0, $yxwLu.getSerializedStylesMap)('backgroundColor', (0, $aGYUm.backgroundColorMap));

});
parcelRegister("aGYUm", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $563fb7db05a3cc8c$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b9ffd6dcccead720baadbffd4a1648a>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $563fb7db05a3cc8c$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("yxwLu", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $9cb03e6fec12743c$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
const $9cb03e6fec12743c$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = /*#__PURE__*/ (0, $9dQre.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("9oUW7", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $6c3b06f590e2992d$export$5e65a44e5b6ecadb);

var $8HLhf = parcelRequire("8HLhf");
const $6c3b06f590e2992d$export$5e65a44e5b6ecadb = (color)=>(0, $8HLhf.surfaceColorMap)[color] !== undefined;

});
parcelRegister("8HLhf", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $6a9b2a8513e3b04e$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c124f7044e82421c90bec6e00efe281>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $6a9b2a8513e3b04e$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("2UbVv", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $bb316cc9591d16f7$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $gOmtX = parcelRequire("gOmtX");

var $cCXmu = parcelRequire("cCXmu");
const $bb316cc9591d16f7$export$e615f061ca585a6c = (0, $gOmtX.createSpacingStylesMap)((0, $cCXmu.positiveSpaceMap), [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd'
]);

});
parcelRegister("gOmtX", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $649546256b3ff6dd$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $yxwLu = parcelRequire("yxwLu");
const $649546256b3ff6dd$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $649546256b3ff6dd$export$f2bee1f59203ac70 = (tokenMap, properties)=>{
    return properties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $yxwLu.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("cCXmu", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $4ee2f798855f794e$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530295593aa7866ac0aa775911222ebc>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::d315a72fd47775e37868465c88b3ebfb>>
 */ const $4ee2f798855f794e$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("gfZ3w", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $56170ec12f8a0e84$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ /* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("bSJIT");

var $alSNM = parcelRequire("alSNM");
const $56170ec12f8a0e84$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $56170ec12f8a0e84$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $alSNM.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("alSNM", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $2e628ae70c0b6064$export$43e479c916cb4ada);
const $2e628ae70c0b6064$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("gCSUx", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $4a00a8cffd3b6742$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $fjtMM = parcelRequire("fjtMM");

var $yxwLu = parcelRequire("yxwLu");

var $8HLhf = parcelRequire("8HLhf");
const $4a00a8cffd3b6742$export$ff257d957d48c421 = (0, $yxwLu.getSerializedStylesMap)((0, $fjtMM.CURRENT_SURFACE_CSS_VAR), (0, $8HLhf.surfaceColorMap));

});
parcelRegister("fjtMM", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $3ee92a3df5c28a58$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $3ee92a3df5c28a58$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $3ee92a3df5c28a58$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $3ee92a3df5c28a58$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $3ee92a3df5c28a58$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $3ee92a3df5c28a58$export$9d7b58831ae93caa);
const $3ee92a3df5c28a58$export$4ef52930e33717cd = 'data-theme';
const $3ee92a3df5c28a58$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $3ee92a3df5c28a58$export$a00eac3f8684bcd0 = 'data-color-mode';
const $3ee92a3df5c28a58$export$2112803007239c61 = 'data-contrast-mode';
const $3ee92a3df5c28a58$export$352e418ed5b6193a = 'data-custom-theme';
const $3ee92a3df5c28a58$export$6f0c6fb8c80fcc92 = 'ds';
const $3ee92a3df5c28a58$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $3ee92a3df5c28a58$export$dddac1532e822863 = `--${$3ee92a3df5c28a58$export$6f0c6fb8c80fcc92}-token-not-found`;
const $3ee92a3df5c28a58$export$9d7b58831ae93caa = `--${$3ee92a3df5c28a58$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});



parcelRegister("2IITT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Inline", () => $413864bacd409e07$export$fbae5b5ffd8af05e);
$parcel$export(module.exports, "default", () => $413864bacd409e07$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $9BVpB = parcelRequire("9BVpB");

var $cMYsY = parcelRequire("cMYsY");
const $413864bacd409e07$var$flexGrowMap = {
    hug: (0, $9BVpB.xcss)({
        flexGrow: 0
    }),
    fill: (0, $9BVpB.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $413864bacd409e07$var$separatorStyles = /*#__PURE__*/ (0, $9dQre.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $413864bacd409e07$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $413864bacd409e07$var$separatorStyles
    }, children);
const $413864bacd409e07$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $9dQre.jsx)($413864bacd409e07$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $bSJIT.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $413864bacd409e07$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $cMYsY.Flex), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$413864bacd409e07$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$413864bacd409e07$export$2e2bcd8739ae039 = $413864bacd409e07$export$fbae5b5ffd8af05e;

});
parcelRegister("9BVpB", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $309c56c6ba19b67f$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $900Mm = parcelRequire("900Mm");

var $alSNM = parcelRequire("alSNM");

var $4eGW1 = parcelRequire("4eGW1");
const $309c56c6ba19b67f$var$isSafeEnvToThrow = ()=>typeof $4eGW1 === 'object' && typeof $4eGW1.env === 'object' && false;
const $309c56c6ba19b67f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $309c56c6ba19b67f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $309c56c6ba19b67f$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($309c56c6ba19b67f$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $309c56c6ba19b67f$var$safeSelectors.test(key)) {
            styleObj[key] = $309c56c6ba19b67f$var$transformStyles(value);
            return;
        }
        if ($309c56c6ba19b67f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($309c56c6ba19b67f$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $900Mm.tokensMap))) return;
        const tokenValue = (0, $900Mm.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $309c56c6ba19b67f$var$baseXcss = (style)=>{
    const transformedStyles = $309c56c6ba19b67f$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $alSNM.uniqueSymbol)]: /*#__PURE__*/ (0, $9dQre.css)(transformedStyles)
    };
};
function $309c56c6ba19b67f$export$f6c783d06584602c(style) {
    return $309c56c6ba19b67f$var$baseXcss(style);
}

});
parcelRegister("900Mm", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $7a523f2e5aabbf41$export$9a199fbafee0014e);

var $780Hz = parcelRequire("780Hz");

var $aGYUm = parcelRequire("aGYUm");

var $fQ18X = parcelRequire("fQ18X");

var $e2aHS = parcelRequire("e2aHS");

var $jkSvc = parcelRequire("jkSvc");

var $f8LrM = parcelRequire("f8LrM");

var $1qmac = parcelRequire("1qmac");

var $1ChCD = parcelRequire("1ChCD");

var $Izo1c = parcelRequire("Izo1c");

var $ae2v3 = parcelRequire("ae2v3");

var $d6ESg = parcelRequire("d6ESg");

var $hyWiz = parcelRequire("hyWiz");

var $cCXmu = parcelRequire("cCXmu");

var $lihWu = parcelRequire("lihWu");

var $iIpMq = parcelRequire("iIpMq");
const $7a523f2e5aabbf41$export$9a199fbafee0014e = {
    backgroundColor: (0, $aGYUm.backgroundColorMap),
    blockSize: (0, $f8LrM.dimensionMap),
    borderBlockColor: (0, $fQ18X.borderColorMap),
    borderBlockEndColor: (0, $fQ18X.borderColorMap),
    borderBlockEndWidth: (0, $jkSvc.borderWidthMap),
    borderBlockStartColor: (0, $fQ18X.borderColorMap),
    borderBlockStartWidth: (0, $jkSvc.borderWidthMap),
    borderBlockWidth: (0, $jkSvc.borderWidthMap),
    borderBottomColor: (0, $fQ18X.borderColorMap),
    borderBottomLeftRadius: (0, $e2aHS.borderRadiusMap),
    borderBottomRightRadius: (0, $e2aHS.borderRadiusMap),
    borderBottomWidth: (0, $jkSvc.borderWidthMap),
    borderColor: (0, $fQ18X.borderColorMap),
    borderEndEndRadius: (0, $e2aHS.borderRadiusMap),
    borderEndStartRadius: (0, $e2aHS.borderRadiusMap),
    borderInlineColor: (0, $fQ18X.borderColorMap),
    borderInlineEndColor: (0, $fQ18X.borderColorMap),
    borderInlineEndWidth: (0, $jkSvc.borderWidthMap),
    borderInlineStartColor: (0, $fQ18X.borderColorMap),
    borderInlineStartWidth: (0, $jkSvc.borderWidthMap),
    borderInlineWidth: (0, $jkSvc.borderWidthMap),
    borderLeftColor: (0, $fQ18X.borderColorMap),
    borderLeftWidth: (0, $jkSvc.borderWidthMap),
    borderRadius: (0, $e2aHS.borderRadiusMap),
    borderRightColor: (0, $fQ18X.borderColorMap),
    borderRightWidth: (0, $jkSvc.borderWidthMap),
    borderStartEndRadius: (0, $e2aHS.borderRadiusMap),
    borderStartStartRadius: (0, $e2aHS.borderRadiusMap),
    borderTopColor: (0, $fQ18X.borderColorMap),
    borderTopLeftRadius: (0, $e2aHS.borderRadiusMap),
    borderTopRightRadius: (0, $e2aHS.borderRadiusMap),
    borderTopWidth: (0, $jkSvc.borderWidthMap),
    borderWidth: (0, $jkSvc.borderWidthMap),
    bottom: (0, $780Hz.allSpaceMap),
    boxShadow: (0, $lihWu.shadowMap),
    color: (0, $iIpMq.textColorMap),
    columnGap: (0, $ae2v3.gapSpaceMap),
    font: (0, $1qmac.fontMap),
    fontFamily: (0, $1ChCD.fontFamilyMap),
    fontWeight: (0, $Izo1c.fontWeightMap),
    gap: (0, $ae2v3.gapSpaceMap),
    height: (0, $f8LrM.dimensionMap),
    inlineSize: (0, $f8LrM.dimensionMap),
    inset: (0, $780Hz.allSpaceMap),
    insetBlock: (0, $780Hz.allSpaceMap),
    insetBlockEnd: (0, $780Hz.allSpaceMap),
    insetBlockStart: (0, $780Hz.allSpaceMap),
    insetInline: (0, $780Hz.allSpaceMap),
    insetInlineEnd: (0, $780Hz.allSpaceMap),
    insetInlineStart: (0, $780Hz.allSpaceMap),
    left: (0, $780Hz.allSpaceMap),
    margin: (0, $780Hz.allSpaceMap),
    marginBlock: (0, $780Hz.allSpaceMap),
    marginBlockEnd: (0, $780Hz.allSpaceMap),
    marginBlockStart: (0, $780Hz.allSpaceMap),
    marginBottom: (0, $780Hz.allSpaceMap),
    marginInline: (0, $780Hz.allSpaceMap),
    marginInlineEnd: (0, $780Hz.allSpaceMap),
    marginInlineStart: (0, $780Hz.allSpaceMap),
    marginLeft: (0, $780Hz.allSpaceMap),
    marginRight: (0, $780Hz.allSpaceMap),
    marginTop: (0, $780Hz.allSpaceMap),
    maxBlockSize: (0, $f8LrM.dimensionMap),
    maxHeight: (0, $f8LrM.dimensionMap),
    maxInlineSize: (0, $f8LrM.dimensionMap),
    maxWidth: (0, $f8LrM.dimensionMap),
    minBlockSize: (0, $f8LrM.dimensionMap),
    minHeight: (0, $f8LrM.dimensionMap),
    minInlineSize: (0, $f8LrM.dimensionMap),
    minWidth: (0, $f8LrM.dimensionMap),
    opacity: (0, $hyWiz.opacityMap),
    outlineColor: (0, $fQ18X.borderColorMap),
    outlineOffset: (0, $780Hz.allSpaceMap),
    outlineWidth: (0, $jkSvc.borderWidthMap),
    padding: (0, $cCXmu.positiveSpaceMap),
    paddingBlock: (0, $cCXmu.positiveSpaceMap),
    paddingBlockEnd: (0, $cCXmu.positiveSpaceMap),
    paddingBlockStart: (0, $cCXmu.positiveSpaceMap),
    paddingBottom: (0, $cCXmu.positiveSpaceMap),
    paddingInline: (0, $cCXmu.positiveSpaceMap),
    paddingInlineEnd: (0, $cCXmu.positiveSpaceMap),
    paddingInlineStart: (0, $cCXmu.positiveSpaceMap),
    paddingLeft: (0, $cCXmu.positiveSpaceMap),
    paddingRight: (0, $cCXmu.positiveSpaceMap),
    paddingTop: (0, $cCXmu.positiveSpaceMap),
    right: (0, $780Hz.allSpaceMap),
    rowGap: (0, $ae2v3.gapSpaceMap),
    top: (0, $780Hz.allSpaceMap),
    width: (0, $f8LrM.dimensionMap),
    zIndex: (0, $d6ESg.layerMap)
};

});
parcelRegister("780Hz", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $a4c8ba921f0125a5$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7046dc26bdc5919611c94881a16cf5f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::d315a72fd47775e37868465c88b3ebfb>>
 */ const $a4c8ba921f0125a5$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("fQ18X", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $27d3649deec78e5b$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2852cd6e8656adbef1c6b8cb926235c9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $27d3649deec78e5b$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("e2aHS", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $f393786c927720ba$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac51b10fd4c84e2b653aff461a93b73>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $f393786c927720ba$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("jkSvc", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $5683774791ad7f92$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cdb9fba904c3ac54bf1c429a821ffc2>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $5683774791ad7f92$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("f8LrM", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $2737e3e0b08d70a6$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $2737e3e0b08d70a6$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("1qmac", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $7ac3b0fc1d236d32$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $7ac3b0fc1d236d32$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("1ChCD", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $f3aa59deca215658$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $f3aa59deca215658$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("Izo1c", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $9480152ffa4fdb9a$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $9480152ffa4fdb9a$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("ae2v3", function(module, exports) {
$parcel$export(module.exports, "gapSpaceMap", () => $2a47543a7a083c62$export$ae2d66f16ab57ecd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaab37d95b3ad5a410df83f119600eba>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::d315a72fd47775e37868465c88b3ebfb>>
 */ const $2a47543a7a083c62$export$ae2d66f16ab57ecd = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.gap.large': "var(--ds-space-gap-large, 12px)",
    'space.gap.medium': "var(--ds-space-gap-medium, 8px)",
    'space.gap.small': "var(--ds-space-gap-small, 6px)",
    'space.gap.xlarge': "var(--ds-space-gap-xlarge, 16px)",
    'space.gap.xsmall': "var(--ds-space-gap-xsmall, 4px)",
    'space.gap.xxlarge': "var(--ds-space-gap-xxlarge, 24px)",
    'space.gap.xxsmall': "var(--ds-space-gap-xxsmall, 2px)"
};

});

parcelRegister("d6ESg", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $06eb5eae43e924ab$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $06eb5eae43e924ab$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("hyWiz", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $a64815137b2d0396$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f768e44d85ca8256730a17510c4d3901>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $a64815137b2d0396$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("lihWu", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $b00926bed51593ed$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31f7af0716c25896201100f27266bca7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $b00926bed51593ed$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("iIpMq", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $3d7f42abbb0d91ec$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $3d7f42abbb0d91ec$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("cMYsY", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $d182d4e5425ee34b$export$f51f4c4ede09e011);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $gfZ3w = parcelRequire("gfZ3w");

var $lFZ63 = parcelRequire("lFZ63");
function $d182d4e5425ee34b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d182d4e5425ee34b$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $d182d4e5425ee34b$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $d182d4e5425ee34b$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $d182d4e5425ee34b$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $d182d4e5425ee34b$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
const $d182d4e5425ee34b$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $gfZ3w.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9dQre.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $d182d4e5425ee34b$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lFZ63.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lFZ63.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lFZ63.spaceStylesMap).rowGap[rowGap],
            alignItems && $d182d4e5425ee34b$var$alignItemsMap[alignItems],
            direction && $d182d4e5425ee34b$var$flexDirectionMap[direction],
            justifyContent && $d182d4e5425ee34b$var$justifyContentMap[justifyContent],
            wrap && $d182d4e5425ee34b$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d182d4e5425ee34b$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d182d4e5425ee34b$export$2e2bcd8739ae039 = $d182d4e5425ee34b$export$f51f4c4ede09e011;

});
parcelRegister("lFZ63", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $adea6130e0fea832$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $gOmtX = parcelRequire("gOmtX");

var $ae2v3 = parcelRequire("ae2v3");
const $adea6130e0fea832$export$bf46c3f9eeafc71f = (0, $gOmtX.createSpacingStylesMap)((0, $ae2v3.gapSpaceMap), [
    'gap',
    'rowGap',
    'columnGap'
]);

});



parcelRegister("hDkm2", function(module, exports) {
$parcel$export(module.exports, "default", () => $448c8275672a6f12$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $cyIUy = parcelRequire("cyIUy");

var $hWjXa = parcelRequire("hWjXa");
/**
 * Returns the appropriate circle stroke color.
 */ function $448c8275672a6f12$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $448c8275672a6f12$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $448c8275672a6f12$var$loadIn = null;
const $448c8275672a6f12$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $448c8275672a6f12$var$useLayoutEffect = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $448c8275672a6f12$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $hWjXa.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $448c8275672a6f12$var$getStrokeColor(appearance);
    const context = (0, $bSJIT.useContext)((0, $cyIUy.default));
    $448c8275672a6f12$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9fU1q.default)([
            $448c8275672a6f12$var$styles.wrapperStyles,
            $448c8275672a6f12$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $9fU1q.default)([
                $448c8275672a6f12$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $9fU1q.default)([
                    $448c8275672a6f12$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $448c8275672a6f12$export$2e2bcd8739ae039 = $448c8275672a6f12$var$Spinner;

});
parcelRegister("dc70d", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bufmC"));

});
parcelRegister("bufmC", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $85ce69f83f7c9a9b$export$ffb0004e005737fa, (v) => $85ce69f83f7c9a9b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $85ce69f83f7c9a9b$export$34b9dba7ce09269b, (v) => $85ce69f83f7c9a9b$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $85ce69f83f7c9a9b$export$25062201e9e25d76, (v) => $85ce69f83f7c9a9b$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $85ce69f83f7c9a9b$export$ffb0004e005737fa;
var $85ce69f83f7c9a9b$export$34b9dba7ce09269b;
var $85ce69f83f7c9a9b$export$25062201e9e25d76;
'use strict';

var $bSJIT = parcelRequire("bSJIT");
var $85ce69f83f7c9a9b$var$k = Symbol.for("react.element"), $85ce69f83f7c9a9b$var$l = Symbol.for("react.fragment"), $85ce69f83f7c9a9b$var$m = Object.prototype.hasOwnProperty, $85ce69f83f7c9a9b$var$n = $bSJIT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $85ce69f83f7c9a9b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $85ce69f83f7c9a9b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$85ce69f83f7c9a9b$var$m.call(a, b) && !$85ce69f83f7c9a9b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $85ce69f83f7c9a9b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $85ce69f83f7c9a9b$var$n.current
    };
}
$85ce69f83f7c9a9b$export$ffb0004e005737fa = $85ce69f83f7c9a9b$var$l;
$85ce69f83f7c9a9b$export$34b9dba7ce09269b = $85ce69f83f7c9a9b$var$q;
$85ce69f83f7c9a9b$export$25062201e9e25d76 = $85ce69f83f7c9a9b$var$q;

});


parcelRegister("9fU1q", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd0f88f7896f245$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $6bd0f88f7896f245$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $6bd0f88f7896f245$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $6bd0f88f7896f245$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("hWjXa", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $657f1375454479bb$export$4e9f1640bbe7a1a8);
const $657f1375454479bb$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("arQGg", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => (parcelRequire("9LGCi")).MemoizedInsightIcon);

var $9LGCi = parcelRequire("9LGCi");

});
parcelRegister("9LGCi", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => $410a031b6723e515$export$55641517b59933d7);

var $bSJIT = parcelRequire("bSJIT");

var $JD7lD = parcelRequire("JD7lD");

var $10HUP = parcelRequire("10HUP");

var $2h5Gy = parcelRequire("2h5Gy");

var $jUca3 = parcelRequire("jUca3");
const $410a031b6723e515$var$ICON_SIZE = 'small';
const $410a031b6723e515$var$sizeInPx = (0, $2h5Gy.AVATAR_SIZES)[$410a031b6723e515$var$ICON_SIZE];
// We want to reuse mediaClientConfigs across all InsightIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $410a031b6723e515$var$mediaClientConfigs = new Map();
const $410a031b6723e515$var$getMediaClientConfig = ({ mediaJwtToken: mediaJwtToken, clientId: clientId, mediaBaseUrl: mediaBaseUrl })=>{
    const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
    if ($410a031b6723e515$var$mediaClientConfigs.has(key)) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return $410a031b6723e515$var$mediaClientConfigs.get(key);
    const mediaClientConfig = {
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: mediaJwtToken,
                baseUrl: mediaBaseUrl
            }),
        useSha256ForUploads: true
    };
    $410a031b6723e515$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $410a031b6723e515$var$hasAuth = ({ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, clientId: clientId })=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const $410a031b6723e515$var$DefaultIcon = ()=>/*#__PURE__*/ $bSJIT.createElement((0, $JD7lD.default), {
        appearance: "square",
        size: "small"
    });
// Mimics logic from jira/src/packages/servicedesk/insight-common/insight-icon/src/ui/index.tsx
const $410a031b6723e515$var$renderAvatar = (src)=>/*#__PURE__*/ $bSJIT.createElement("img", {
        loading: "lazy",
        src: src,
        width: $410a031b6723e515$var$sizeInPx,
        height: $410a031b6723e515$var$sizeInPx,
        alt: ""
    });
const $410a031b6723e515$export$4f72cced31fa9b94 = (props)=>{
    const { fileId: fileId, iconUrl: iconUrl, MediaImage: MediaImage = (0, $jUca3.MediaImageWithErrorBoundary) } = props;
    if (!$410a031b6723e515$var$hasAuth({
        ...props
    }) || !MediaImage) {
        if (iconUrl) return $410a031b6723e515$var$renderAvatar(iconUrl);
        return /*#__PURE__*/ $bSJIT.createElement($410a031b6723e515$var$DefaultIcon, null);
    }
    const fileIdentifier = {
        id: fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: 24,
        height: 24
    };
    return /*#__PURE__*/ $bSJIT.createElement("div", null, /*#__PURE__*/ $bSJIT.createElement(MediaImage, {
        identifier: fileIdentifier,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        mediaClientConfig: $410a031b6723e515$var$getMediaClientConfig(props),
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $bSJIT.createElement((0, $10HUP.default), {
            appearance: "square",
            size: "small"
        });
        if (error) return /*#__PURE__*/ $bSJIT.createElement($410a031b6723e515$var$DefaultIcon, null);
        if (!data) return /*#__PURE__*/ $bSJIT.createElement($410a031b6723e515$var$DefaultIcon, null);
        return /*#__PURE__*/ $bSJIT.createElement((0, $JD7lD.default), {
            src: data.src,
            appearance: "square",
            size: "small"
        });
    }));
};
const $410a031b6723e515$export$55641517b59933d7 = /*#__PURE__*/ $bSJIT.memo($410a031b6723e515$export$4f72cced31fa9b94);

});
parcelRegister("JD7lD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7ff0ca2ab5b3a36$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $6WltM = parcelRequire("6WltM");

var $d6mTg = parcelRequire("d6mTg");

var $gdUUy = parcelRequire("gdUUy");

var $7h4V9 = parcelRequire("7h4V9");

var $geSsm = parcelRequire("geSsm");

var $14gX3 = parcelRequire("14gX3");

var $dJ2e5 = parcelRequire("dJ2e5");

var $90QrD = parcelRequire("90QrD");

var $1s5TV = parcelRequire("1s5TV");

var $bwoW2 = parcelRequire("bwoW2");

var $69Fh9 = parcelRequire("69Fh9");
const $d7ff0ca2ab5b3a36$var$packageName = undefined;
const $d7ff0ca2ab5b3a36$var$packageVersion = undefined;
const $d7ff0ca2ab5b3a36$var$containerStyles = null;
const $d7ff0ca2ab5b3a36$var$updatedHexagonNegativeMarginMap = {
    xxsmall: "_6rth1b3j _1pfh1b3j",
    small: "_6rth1tv6 _1pfh1tv6",
    medium: "_6rth1lmm _1pfh1lmm",
    large: "_6rth1wmd _1pfh1wmd",
    xlarge: "_6rth130q _1pfh130q",
    xxlarge: "_6rthyzhl _1pfhyzhl"
};
const $d7ff0ca2ab5b3a36$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $gdUUy.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
const $d7ff0ca2ab5b3a36$var$Avatar = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const context = (0, $69Fh9.useAvatarContext)();
    const size = $d7ff0ca2ab5b3a36$var$normalizeAvatarSize(sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium');
    const isUpdatedHexagonGeometry = appearance === 'hexagon' && Boolean(UNSAFE_isUpdatedGeometry) && size !== 'UNSAFE_xsmall';
    const customPresenceNode = /*#__PURE__*/ (0, $bSJIT.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $bSJIT.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $bSJIT.useRef)(analyticsContext);
    const labelId = (0, $d6mTg.useId)();
    (0, $bSJIT.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $bSJIT.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $d7ff0ca2ab5b3a36$var$packageName,
                packageVersion: $d7ff0ca2ab5b3a36$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $d7ff0ca2ab5b3a36$var$packageName,
            packageVersion: $d7ff0ca2ab5b3a36$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dJ2e5.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $9fU1q.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm",
                isUpdatedHexagonGeometry && $d7ff0ca2ab5b3a36$var$updatedHexagonNegativeMarginMap[size]
            ]),
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $14gX3.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $90QrD.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $dc70d.jsx)((0, $geSsm.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $dc70d.jsx)((0, $7h4V9.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $dc70d.jsx)((0, $1s5TV.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $dc70d.jsx)((0, $bwoW2.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$d7ff0ca2ab5b3a36$var$Avatar.displayName = 'Avatar';
var $d7ff0ca2ab5b3a36$export$2e2bcd8739ae039 = $d7ff0ca2ab5b3a36$var$Avatar;

});
parcelRegister("d6mTg", function(module, exports) {
$parcel$export(module.exports, "useId", () => $b4c49d159b726098$export$f680877a34711e37);

var $bSJIT = parcelRequire("bSJIT");
function $b4c49d159b726098$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("7h4V9", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $1d1201fc44e28b51$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");

var $14gX3 = parcelRequire("14gX3");

var $i4t9P = parcelRequire("i4t9P");
const $1d1201fc44e28b51$var$boxShadowCssVar = '--avatar-box-shadow';
const $1d1201fc44e28b51$var$bgColorCssVar = '--avatar-bg-color';
const $1d1201fc44e28b51$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $1d1201fc44e28b51$var$unboundStyles = {
    root: "_11q7cxp3 _vchh1ntv _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    updatedHexagonClipPath: "_mkrz1ezo",
    hexagonBorderContainer: "_11q7cxp3 _1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _m6k41e03 _1llweo6y"
};
const $1d1201fc44e28b51$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const $1d1201fc44e28b51$var$updatedHexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5di1a _1q51di1a _y4tiidpf _bozgidpf _6rthwit5 _1pfhwit5 _12l2idpf _ahbqidpf",
    hexagonFocusContainer: "_85i51hhc _1q511hhc _y4ti1dm9 _bozg1dm9 _6rthypyw _1pfhypyw _12l21ksc _ahbq1ksc"
};
const $1d1201fc44e28b51$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
// The sole source of truth for the updated hexagon width/height geometry (per size).
const $1d1201fc44e28b51$var$updatedHexagonDimensionMap = {
    xxsmall: "_1bsbgaek _4t3ikzaa",
    small: "_1bsb1ftb _4t3i1pm0",
    medium: "_1bsb1cun _4t3i3vj5",
    large: "_1bsbctg4 _4t3i15zd",
    xlarge: "_1bsbovoe _4t3i1sfy",
    xxlarge: "_1bsbhec5 _4t3i1ejz"
};
const $1d1201fc44e28b51$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children }, ref)=>{
    (0, $i4t9P.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $bSJIT.useContext)((0, $14gX3.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $dc70d.jsx)(Container, {
        style: {
            [$1d1201fc44e28b51$var$bgColorCssVar]: borderColor,
            [$1d1201fc44e28b51$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $9fU1q.default)([
            $1d1201fc44e28b51$var$unboundStyles.root,
            $1d1201fc44e28b51$var$styles.root,
            appearance === 'square' && $1d1201fc44e28b51$var$styles.square,
            appearance === 'circle' && $1d1201fc44e28b51$var$styles.circle,
            appearance === 'hexagon' && $1d1201fc44e28b51$var$unboundStyles.hexagon,
            $1d1201fc44e28b51$var$widthHeightMap[size],
            UNSAFE_isUpdatedGeometry && $1d1201fc44e28b51$var$updatedHexagonDimensionMap[size],
            stackIndex !== undefined && $1d1201fc44e28b51$var$styles.positionRelative,
            isInteractive && !isDisabled && $1d1201fc44e28b51$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $gdUUy.fg)('platform-dst-motion-uplift') && $1d1201fc44e28b51$var$unboundStyles.interactiveMotion,
            isDisabled && $1d1201fc44e28b51$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            [$1d1201fc44e28b51$var$bgColorCssVar]: borderColor,
            [$1d1201fc44e28b51$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $9fU1q.default)([
            $1d1201fc44e28b51$var$unboundStyles.hexagonFocusContainer,
            UNSAFE_isUpdatedGeometry && $1d1201fc44e28b51$var$unboundStyles.updatedHexagonClipPath,
            isInteractive && !isDisabled && (0, $gdUUy.fg)('platform-dst-motion-uplift') && $1d1201fc44e28b51$var$unboundStyles.interactiveMotion,
            UNSAFE_isUpdatedGeometry && $1d1201fc44e28b51$var$updatedHexagonBorderFixStyles.hexagonFocusContainer,
            (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $1d1201fc44e28b51$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $9fU1q.default)([
                $1d1201fc44e28b51$var$unboundStyles.hexagonBorderContainer,
                UNSAFE_isUpdatedGeometry && $1d1201fc44e28b51$var$updatedHexagonBorderFixStyles.hexagonBorderContainer,
                (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $1d1201fc44e28b51$var$hexagonBorderFixStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("14gX3", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $38026b0503ff8cc8$export$b983474ddd0b6d28);

var $bSJIT = parcelRequire("bSJIT");
const $38026b0503ff8cc8$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $38026b0503ff8cc8$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $bSJIT.createContext)($38026b0503ff8cc8$var$defaultAvatarContentProps);

});

parcelRegister("i4t9P", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $7cc35f70f8737dcc$export$7db5c57474082dd9);

var $bSJIT = parcelRequire("bSJIT");

var $dJ2e5 = parcelRequire("dJ2e5");
const $7cc35f70f8737dcc$export$7db5c57474082dd9 = ()=>{
    const context = (0, $bSJIT.useContext)((0, $dJ2e5.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("dJ2e5", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $422bd71c3af534a6$export$6b4cbd90d24955ad);

var $bSJIT = parcelRequire("bSJIT");
const $422bd71c3af534a6$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});



parcelRegister("geSsm", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbf892006fd367e7$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $2fT5e = parcelRequire("2fT5e");

var $6aGyu = parcelRequire("6aGyu");

var $5TbNn = parcelRequire("5TbNn");
const $fbf892006fd367e7$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g",
    updatedHexagonIcon: "_4cvr1h6o _1bah1h6o",
    updatedHexagonImage: "_mkrz1kw7 _5ral1dfr _1kem1wug"
};
const $fbf892006fd367e7$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $fbf892006fd367e7$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const $fbf892006fd367e7$var$updatedHexagonNestedSvgStylesMap = {
    xxsmall: "_w8l5gaek _1752kzaa",
    small: "_w8l51ftb _17521pm0",
    medium: "_w8l51cun _17523vj5",
    large: "_w8l5ctg4 _175215zd",
    xlarge: "_w8l5ovoe _17521sfy",
    xxlarge: "_w8l5hec5 _17521ejz"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $fbf892006fd367e7$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $bSJIT.useState)(false);
    // If src changes, reset state
    (0, $bSJIT.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6aGyu))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2fT5e))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5TbNn))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                $fbf892006fd367e7$var$styles.icon,
                UNSAFE_isUpdatedGeometry ? $fbf892006fd367e7$var$updatedHexagonNestedSvgStylesMap[size] : $fbf892006fd367e7$var$nestedSvgStylesMap[size],
                UNSAFE_isUpdatedGeometry && $fbf892006fd367e7$var$styles.updatedHexagonIcon
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $9fU1q.default)([
            $fbf892006fd367e7$var$styles.image,
            $fbf892006fd367e7$var$borderRadiusMap[size],
            appearance === 'circle' && $fbf892006fd367e7$var$styles.circle,
            appearance === 'hexagon' && $fbf892006fd367e7$var$styles.hexagon,
            UNSAFE_isUpdatedGeometry && $fbf892006fd367e7$var$styles.updatedHexagonImage
        ])
    });
};
var $fbf892006fd367e7$export$2e2bcd8739ae039 = $fbf892006fd367e7$var$AvatarImage;

});
parcelRegister("2fT5e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a47b5e24b274efc$var$_react = $1a47b5e24b274efc$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $1a47b5e24b274efc$var$_iconNew = $1a47b5e24b274efc$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $1a47b5e24b274efc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a47b5e24b274efc$var$AiAgentIcon = (props)=>/*#__PURE__*/ $1a47b5e24b274efc$var$_react.default.createElement($1a47b5e24b274efc$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$1a47b5e24b274efc$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $1a47b5e24b274efc$var$_default = module.exports.default = $1a47b5e24b274efc$var$AiAgentIcon;

});
parcelRegister("gHJ0W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $6aec49fc82774e13$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $6aec49fc82774e13$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $6aec49fc82774e13$var$svgStyles = null;
const $6aec49fc82774e13$var$iconStyles = null;
const $6aec49fc82774e13$var$smallIconStyles = null;
const $6aec49fc82774e13$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $6aec49fc82774e13$var$baseHcmStyles = null;
const $6aec49fc82774e13$var$scaleSize = null;
const $6aec49fc82774e13$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $6aec49fc82774e13$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $6aec49fc82774e13$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $6aec49fc82774e13$export$f04a61298a47a40f = /*#__PURE__*/ (0, $bSJIT.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $6aec49fc82774e13$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $6aec49fc82774e13$var$coreSizeSmall[spacing] : $6aec49fc82774e13$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$6aec49fc82774e13$export$2e2bcd8739ae039 = $6aec49fc82774e13$export$f04a61298a47a40f;

});


parcelRegister("6aGyu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47e4afd2f6369626$var$_react = $47e4afd2f6369626$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $47e4afd2f6369626$var$_iconNew = $47e4afd2f6369626$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $47e4afd2f6369626$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47e4afd2f6369626$var$PersonIcon = (props)=>/*#__PURE__*/ $47e4afd2f6369626$var$_react.default.createElement($47e4afd2f6369626$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$47e4afd2f6369626$var$PersonIcon.displayName = 'PersonIcon';
var $47e4afd2f6369626$var$_default = module.exports.default = $47e4afd2f6369626$var$PersonIcon;

});

parcelRegister("5TbNn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $449b3d20cf01df06$var$_react = $449b3d20cf01df06$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $449b3d20cf01df06$var$_iconNew = $449b3d20cf01df06$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $449b3d20cf01df06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $449b3d20cf01df06$var$ReleaseIcon = (props)=>/*#__PURE__*/ $449b3d20cf01df06$var$_react.default.createElement($449b3d20cf01df06$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$449b3d20cf01df06$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $449b3d20cf01df06$var$_default = module.exports.default = $449b3d20cf01df06$var$ReleaseIcon;

});


parcelRegister("90QrD", function(module, exports) {
$parcel$export(module.exports, "default", () => $11852bdf6cce2da7$export$2e2bcd8739ae039);
const $11852bdf6cce2da7$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $11852bdf6cce2da7$export$2e2bcd8739ae039 = $11852bdf6cce2da7$var$getCustomElement;

});

parcelRegister("1s5TV", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ee4791ac99f0ca8$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $8qIue = parcelRequire("8qIue");
const $0ee4791ac99f0ca8$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $0ee4791ac99f0ca8$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $0ee4791ac99f0ca8$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $0ee4791ac99f0ca8$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $0ee4791ac99f0ca8$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $0ee4791ac99f0ca8$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $9fU1q.default)([
            $0ee4791ac99f0ca8$var$styles.root,
            $0ee4791ac99f0ca8$var$iconSizeMap[size],
            $0ee4791ac99f0ca8$var$circleIconOffsetMap[size],
            appearance === 'square' && $0ee4791ac99f0ca8$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $0ee4791ac99f0ca8$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8qIue.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
var $0ee4791ac99f0ca8$export$2e2bcd8739ae039 = $0ee4791ac99f0ca8$var$PresenceWrapper;

});
parcelRegister("8qIue", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cbd6c47eb307083$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $eQ1xN = parcelRequire("eQ1xN");
const $7cbd6c47eb307083$var$BusyIndicator = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
    children: [
        /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $7cbd6c47eb307083$var$FocusIndicator = /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
    children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $7cbd6c47eb307083$var$OfflineIndicator = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
    children: [
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $7cbd6c47eb307083$var$OnlineIndicator = /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $7cbd6c47eb307083$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $7cbd6c47eb307083$var$BusyIndicator;
        case 'focus':
            return $7cbd6c47eb307083$var$FocusIndicator;
        case 'offline':
            return $7cbd6c47eb307083$var$OfflineIndicator;
        case 'online':
            return $7cbd6c47eb307083$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $7cbd6c47eb307083$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $eQ1xN.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $7cbd6c47eb307083$var$getPresence(presence)
        }) : children
    });
var $7cbd6c47eb307083$export$2e2bcd8739ae039 = $7cbd6c47eb307083$var$AvatarPresence;

});
parcelRegister("eQ1xN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fed4f5565d63f78a$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $fed4f5565d63f78a$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $fed4f5565d63f78a$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $fed4f5565d63f78a$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $9fU1q.default)([
            $fed4f5565d63f78a$var$styles.root,
            $fed4f5565d63f78a$var$unboundStyles.root
        ]),
        children: children
    });
var $fed4f5565d63f78a$export$2e2bcd8739ae039 = $fed4f5565d63f78a$var$IconWrapper;

});



parcelRegister("bwoW2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2a207c1ecd2c459$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $6jtir = parcelRequire("6jtir");
const $c2a207c1ecd2c459$var$styles = {
    root: "_kqswstnw"
};
const $c2a207c1ecd2c459$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $c2a207c1ecd2c459$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $c2a207c1ecd2c459$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $c2a207c1ecd2c459$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $c2a207c1ecd2c459$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $9fU1q.default)([
            $c2a207c1ecd2c459$var$styles.root,
            $c2a207c1ecd2c459$var$iconSizeMap[size],
            $c2a207c1ecd2c459$var$circleIconOffsetMap[size],
            appearance === 'square' && $c2a207c1ecd2c459$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $c2a207c1ecd2c459$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6jtir.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
var $c2a207c1ecd2c459$export$2e2bcd8739ae039 = $c2a207c1ecd2c459$var$StatusWrapper;

});
parcelRegister("6jtir", function(module, exports) {
$parcel$export(module.exports, "default", () => $a10a9a263a796a5f$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $eQ1xN = parcelRequire("eQ1xN");
const $a10a9a263a796a5f$var$ApprovedIndicator = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
    children: [
        /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $a10a9a263a796a5f$var$DeclinedIndicator = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
    children: [
        /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $a10a9a263a796a5f$var$LockedIndicator = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
    children: [
        /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
const $a10a9a263a796a5f$var$WarningIndicator = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
    children: [
        /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
            fill: "var(--ds-icon-warning, #E06C00)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
        })
    ]
});
function $a10a9a263a796a5f$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $a10a9a263a796a5f$var$ApprovedIndicator;
        case 'declined':
            return $a10a9a263a796a5f$var$DeclinedIndicator;
        case 'locked':
            return $a10a9a263a796a5f$var$LockedIndicator;
        case 'warning':
            return $a10a9a263a796a5f$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $a10a9a263a796a5f$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $eQ1xN.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $a10a9a263a796a5f$var$getStatus(status)
        }) : children
    });
var $a10a9a263a796a5f$export$2e2bcd8739ae039 = $a10a9a263a796a5f$var$AvatarStatus;

});


parcelRegister("69Fh9", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $1dc6f1980ee5cf73$export$b50b87a1c4086b23);

var $bSJIT = parcelRequire("bSJIT");

var $2AqKr = parcelRequire("2AqKr");
const $1dc6f1980ee5cf73$export$b50b87a1c4086b23 = ()=>(0, $bSJIT.useContext)((0, $2AqKr.AvatarContext));

});
parcelRegister("2AqKr", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $41933c25d4aaa05f$export$a20dad690e1279e2);

var $bSJIT = parcelRequire("bSJIT");
const $41933c25d4aaa05f$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});



parcelRegister("10HUP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d8f74b39852b86d$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $4d8f74b39852b86d$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $4d8f74b39852b86d$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d1j28 _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $4d8f74b39852b86d$var$sizeStyles = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $4d8f74b39852b86d$var$Skeleton = ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            [$4d8f74b39852b86d$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $9fU1q.default)([
            $4d8f74b39852b86d$var$styles.root,
            $4d8f74b39852b86d$var$sizeStyles[avatarSize],
            appearance === 'square' && $4d8f74b39852b86d$var$styles.square,
            appearance === 'hexagon' && $4d8f74b39852b86d$var$styles.hexagon,
            weight === 'strong' && $4d8f74b39852b86d$var$styles.strongOpacity
        ])
    });
};
var $4d8f74b39852b86d$export$2e2bcd8739ae039 = $4d8f74b39852b86d$var$Skeleton;

});

parcelRegister("2h5Gy", function(module, exports) {
$parcel$export(module.exports, "AVATAR_SIZES", () => $5447aa4b350e862b$export$9a270941bcff7e77);
const $5447aa4b350e862b$export$9a270941bcff7e77 = {
    xxsmall: 16,
    xsmall: 16,
    UNSAFE_xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};

});

parcelRegister("jUca3", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $1522233cb29bf56f$export$758a2fef95a29ad0);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $fDeMK = parcelRequire("fDeMK");
const $1522233cb29bf56f$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fDeMK.MediaImageWithMediaClient), props));

});
parcelRegister("eime1", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $a683fc9b1a97e2e1$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $a683fc9b1a97e2e1$export$f0c7a449e0cfaec7);

var $bSJIT = parcelRequire("bSJIT");
'use client';
const $a683fc9b1a97e2e1$export$b16d9fb1a22de840 = (0, $bSJIT.createContext)(null);
const $a683fc9b1a97e2e1$var$initialState = {
    didCatch: false,
    error: null
};
class $a683fc9b1a97e2e1$export$e926676385687eaf extends (0, $bSJIT.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $a683fc9b1a97e2e1$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($a683fc9b1a97e2e1$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $a683fc9b1a97e2e1$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($a683fc9b1a97e2e1$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $bSJIT.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $bSJIT.createElement)($a683fc9b1a97e2e1$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $a683fc9b1a97e2e1$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $a683fc9b1a97e2e1$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $a683fc9b1a97e2e1$export$c052f6604b7d51fe() {
    const context = (0, $bSJIT.useContext)($a683fc9b1a97e2e1$export$b16d9fb1a22de840);
    $a683fc9b1a97e2e1$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $bSJIT.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $bSJIT.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $a683fc9b1a97e2e1$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $bSJIT.forwardRef)((props, ref)=>(0, $bSJIT.createElement)($a683fc9b1a97e2e1$export$e926676385687eaf, errorBoundaryProps, (0, $bSJIT.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("fDeMK", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithMediaClient", () => $56c8cb94a80769b9$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $1fspY = parcelRequire("1fspY");

var $ftW9p = parcelRequire("ftW9p");

var $gdUUy = parcelRequire("gdUUy");
const $56c8cb94a80769b9$var$copyDivStyles = null;
const $56c8cb94a80769b9$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $ftW9p.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview !== null && preview !== void 0 && preview.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview === null || preview === void 0 ? void 0 : preview.dataURI
        } : undefined
    }), (0, $gdUUy.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $bSJIT.createElement("div", {
        ref: copyNodeRef,
        className: (0, $9fU1q.default)([
            "_1e0cglyw"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $bSJIT.createElement("script", getSsrScriptProps()));
};
const $56c8cb94a80769b9$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $bSJIT.useMemo)(()=>(0, $1fspY.withMediaClient)($56c8cb94a80769b9$var$MediaImageBase), []);
    return /*#__PURE__*/ $bSJIT.createElement(MediaImageComponent, props);
};

});
parcelRegister("1fspY", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $f329b74e623b6501$export$9f7977d4a2561bee);

var $bSJIT = parcelRequire("bSJIT");

var $3aMs2 = parcelRequire("3aMs2");

var $gdUUy = parcelRequire("gdUUy");

var $83J3A = parcelRequire("83J3A");

var $35T7J = parcelRequire("35T7J");
const $f329b74e623b6501$export$9f7977d4a2561bee = (Component)=>(0, $3aMs2.componentWithCondition)(()=>(0, $gdUUy.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $bSJIT.useContext)((0, $35T7J.MediaClientContext));
        const mediaClient = (0, $bSJIT.useMemo)(()=>existingMediaClient ?? (0, $83J3A.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));

});
parcelRegister("3aMs2", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $c46180ad8009db54$export$6e8ea24b15199873);

var $bSJIT = parcelRequire("bSJIT");
function $c46180ad8009db54$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("83J3A", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $058617320497e520$export$c9ecbc1b719fd417);

var $6Pjzp = parcelRequire("6Pjzp");
const $058617320497e520$export$f92e83e86b03c398 = new Map();
const $058617320497e520$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $6Pjzp.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $058617320497e520$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $6Pjzp.MediaClient)(mediaClientConfig);
        $058617320497e520$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("6Pjzp", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $b803c5900f535670$export$fba8b4ca6d386aec);

var $3O8jZ = parcelRequire("3O8jZ");

var $cL66s = parcelRequire("cL66s");

var $9tvow = parcelRequire("9tvow");

var $kmrqJ = parcelRequire("kmrqJ");

var $2gvlV = parcelRequire("2gvlV");

var $bQ9uH = parcelRequire("bQ9uH");

class $b803c5900f535670$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $9tvow.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $2gvlV.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $cL66s.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $kmrqJ.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $3O8jZ.EventEmitter2)();
        this.stargate = new (0, $bQ9uH.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params, seededCdnUrl) {
        return this.mediaStore.getFileImageURLSync(id, params, seededCdnUrl);
    }
    async getClientId(collectionName) {
        return this.mediaStore.getClientId(collectionName);
    }
    getClientIdSync() {
        return this.mediaStore.getClientIdSync();
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("ivwwl"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("3O8jZ", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $4eGW1 = parcelRequire("4eGW1");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $4eGW1 !== 'undefined' && $4eGW1.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $4eGW1.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("cL66s", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $d74212d7f4983879$export$d3e73a50cc549c2e);
var $d74212d7f4983879$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});

parcelRegister("9tvow", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $382a13cebd8afe46$export$5785580dea19518d);

var $j2Fcm = parcelRequire("j2Fcm");

var $5hlbE = parcelRequire("5hlbE");

var $66zU2 = parcelRequire("66zU2");
const $382a13cebd8afe46$var$mediaStoreWithoutDevtools = (0, $66zU2.createStore)()((0, $j2Fcm.subscribeWithSelector)((0, $5hlbE.immer)(()=>({
        files: {}
    }))));
const $382a13cebd8afe46$var$mediaStoreWithDevtools = (0, $66zU2.createStore)()((0, $j2Fcm.devtools)((0, $j2Fcm.subscribeWithSelector)((0, $5hlbE.immer)(()=>({
        files: {}
    })))));
const $382a13cebd8afe46$export$5785580dea19518d = $382a13cebd8afe46$var$mediaStoreWithoutDevtools;

});
parcelRegister("j2Fcm", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $ddce295819544e8f$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $ddce295819544e8f$export$5c593627aef9f076);
var $ddce295819544e8f$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/middleware.mjs"
});
const $ddce295819544e8f$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $ddce295819544e8f$export$4feba8a1bc8e9afd = $ddce295819544e8f$var$reduxImpl;
const $ddce295819544e8f$var$trackedConnections = /* @__PURE__ */ new Map();
const $ddce295819544e8f$var$getTrackedConnectionState = (name)=>{
    const api = $ddce295819544e8f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $ddce295819544e8f$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $ddce295819544e8f$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $ddce295819544e8f$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $ddce295819544e8f$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($ddce295819544e8f$import_meta.env ? $ddce295819544e8f$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($ddce295819544e8f$import_meta.env ? $ddce295819544e8f$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $ddce295819544e8f$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$ddce295819544e8f$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($ddce295819544e8f$import_meta.env ? $ddce295819544e8f$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $ddce295819544e8f$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($ddce295819544e8f$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($ddce295819544e8f$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $ddce295819544e8f$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($ddce295819544e8f$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $ddce295819544e8f$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $ddce295819544e8f$export$6922d3b3a607469e = $ddce295819544e8f$var$devtoolsImpl;
const $ddce295819544e8f$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $ddce295819544e8f$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $ddce295819544e8f$export$5c593627aef9f076 = $ddce295819544e8f$var$subscribeWithSelectorImpl;
const $ddce295819544e8f$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $ddce295819544e8f$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $ddce295819544e8f$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $ddce295819544e8f$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $ddce295819544e8f$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $ddce295819544e8f$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $ddce295819544e8f$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $ddce295819544e8f$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $ddce295819544e8f$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $ddce295819544e8f$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $ddce295819544e8f$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $ddce295819544e8f$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($ddce295819544e8f$import_meta.env ? $ddce295819544e8f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $ddce295819544e8f$var$oldImpl(config, baseOptions);
    }
    return $ddce295819544e8f$var$newImpl(config, baseOptions);
};
const $ddce295819544e8f$export$9a6132153fba2e0 = $ddce295819544e8f$var$persistImpl;

});

parcelRegister("5hlbE", function(module, exports) {
$parcel$export(module.exports, "immer", () => $3d7ef98cc5b09d1f$export$428de7ec69ac95c);

var $kxz2G = parcelRequire("kxz2G");
const $3d7ef98cc5b09d1f$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $kxz2G.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $3d7ef98cc5b09d1f$export$428de7ec69ac95c = $3d7ef98cc5b09d1f$var$immerImpl;

});
parcelRegister("kxz2G", function(module, exports) {
$parcel$export(module.exports, "produce", () => $ef4212660b69d47b$export$b46cabe22e78bc00);
// src/utils/env.ts
var $ef4212660b69d47b$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $ef4212660b69d47b$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $ef4212660b69d47b$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $ef4212660b69d47b$var$errors = [];
function $ef4212660b69d47b$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $ef4212660b69d47b$var$O = Object;
var $ef4212660b69d47b$var$getPrototypeOf = $ef4212660b69d47b$var$O.getPrototypeOf;
var $ef4212660b69d47b$var$CONSTRUCTOR = "constructor";
var $ef4212660b69d47b$var$PROTOTYPE = "prototype";
var $ef4212660b69d47b$var$CONFIGURABLE = "configurable";
var $ef4212660b69d47b$var$ENUMERABLE = "enumerable";
var $ef4212660b69d47b$var$WRITABLE = "writable";
var $ef4212660b69d47b$var$VALUE = "value";
var $ef4212660b69d47b$export$541ac630993a4c84 = (value)=>!!value && !!value[$ef4212660b69d47b$var$DRAFT_STATE];
function $ef4212660b69d47b$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $ef4212660b69d47b$var$isPlainObject(value) || $ef4212660b69d47b$var$isArray(value) || !!value[$ef4212660b69d47b$export$6ee2082928bcb0ee] || !!value[$ef4212660b69d47b$var$CONSTRUCTOR]?.[$ef4212660b69d47b$export$6ee2082928bcb0ee] || $ef4212660b69d47b$var$isMap(value) || $ef4212660b69d47b$var$isSet(value);
}
var $ef4212660b69d47b$var$objectCtorString = $ef4212660b69d47b$var$O[$ef4212660b69d47b$var$PROTOTYPE][$ef4212660b69d47b$var$CONSTRUCTOR].toString();
var $ef4212660b69d47b$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $ef4212660b69d47b$var$isPlainObject(value) {
    if (!value || !$ef4212660b69d47b$var$isObjectish(value)) return false;
    const proto = $ef4212660b69d47b$var$getPrototypeOf(value);
    if (proto === null || proto === $ef4212660b69d47b$var$O[$ef4212660b69d47b$var$PROTOTYPE]) return true;
    const Ctor = $ef4212660b69d47b$var$O.hasOwnProperty.call(proto, $ef4212660b69d47b$var$CONSTRUCTOR) && proto[$ef4212660b69d47b$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$ef4212660b69d47b$var$isFunction(Ctor)) return false;
    let ctorString = $ef4212660b69d47b$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $ef4212660b69d47b$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $ef4212660b69d47b$var$objectCtorString;
}
function $ef4212660b69d47b$export$22e8af3f75a010e3(value) {
    if (!$ef4212660b69d47b$export$541ac630993a4c84(value)) $ef4212660b69d47b$var$die(15, value);
    return value[$ef4212660b69d47b$var$DRAFT_STATE].base_;
}
function $ef4212660b69d47b$var$each(obj, iter, strict = true) {
    if ($ef4212660b69d47b$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $ef4212660b69d47b$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $ef4212660b69d47b$var$getArchtype(thing) {
    const state = thing[$ef4212660b69d47b$var$DRAFT_STATE];
    return state ? state.type_ : $ef4212660b69d47b$var$isArray(thing) ? 1 /* Array */  : $ef4212660b69d47b$var$isMap(thing) ? 2 /* Map */  : $ef4212660b69d47b$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $ef4212660b69d47b$var$has = (thing, prop, type = $ef4212660b69d47b$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $ef4212660b69d47b$var$O[$ef4212660b69d47b$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $ef4212660b69d47b$var$get = (thing, prop, type = $ef4212660b69d47b$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $ef4212660b69d47b$var$set = (thing, propOrOldValue, value, type = $ef4212660b69d47b$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $ef4212660b69d47b$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $ef4212660b69d47b$var$isArray = Array.isArray;
var $ef4212660b69d47b$var$isMap = (target)=>target instanceof Map;
var $ef4212660b69d47b$var$isSet = (target)=>target instanceof Set;
var $ef4212660b69d47b$var$isObjectish = (target)=>typeof target === "object";
var $ef4212660b69d47b$var$isFunction = (target)=>typeof target === "function";
var $ef4212660b69d47b$var$isBoolean = (target)=>typeof target === "boolean";
function $ef4212660b69d47b$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $ef4212660b69d47b$var$getProxyDraft = (value)=>{
    if (!$ef4212660b69d47b$var$isObjectish(value)) return null;
    return value?.[$ef4212660b69d47b$var$DRAFT_STATE];
};
var $ef4212660b69d47b$var$latest = (state)=>state.copy_ || state.base_;
var $ef4212660b69d47b$var$getValue = (value)=>{
    const proxyDraft = $ef4212660b69d47b$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $ef4212660b69d47b$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $ef4212660b69d47b$var$shallowCopy(base, strict) {
    if ($ef4212660b69d47b$var$isMap(base)) return new Map(base);
    if ($ef4212660b69d47b$var$isSet(base)) return new Set(base);
    if ($ef4212660b69d47b$var$isArray(base)) return Array[$ef4212660b69d47b$var$PROTOTYPE].slice.call(base);
    const isPlain = $ef4212660b69d47b$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $ef4212660b69d47b$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$ef4212660b69d47b$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$ef4212660b69d47b$var$WRITABLE] === false) {
                desc[$ef4212660b69d47b$var$WRITABLE] = true;
                desc[$ef4212660b69d47b$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$ef4212660b69d47b$var$CONFIGURABLE]: true,
                [$ef4212660b69d47b$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$ef4212660b69d47b$var$ENUMERABLE]: desc[$ef4212660b69d47b$var$ENUMERABLE],
                [$ef4212660b69d47b$var$VALUE]: base[key]
            };
        }
        return $ef4212660b69d47b$var$O.create($ef4212660b69d47b$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $ef4212660b69d47b$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $ef4212660b69d47b$var$O.create(proto);
        return $ef4212660b69d47b$var$O.assign(obj, base);
    }
}
function $ef4212660b69d47b$export$792f3d81ea979f55(obj, deep = false) {
    if ($ef4212660b69d47b$var$isFrozen(obj) || $ef4212660b69d47b$export$541ac630993a4c84(obj) || !$ef4212660b69d47b$export$16e3aed3edb85946(obj)) return obj;
    if ($ef4212660b69d47b$var$getArchtype(obj) > 1) $ef4212660b69d47b$var$O.defineProperties(obj, {
        set: $ef4212660b69d47b$var$dontMutateMethodOverride,
        add: $ef4212660b69d47b$var$dontMutateMethodOverride,
        clear: $ef4212660b69d47b$var$dontMutateMethodOverride,
        delete: $ef4212660b69d47b$var$dontMutateMethodOverride
    });
    $ef4212660b69d47b$var$O.freeze(obj);
    if (deep) $ef4212660b69d47b$var$each(obj, (_key, value)=>{
        $ef4212660b69d47b$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $ef4212660b69d47b$var$dontMutateFrozenCollections() {
    $ef4212660b69d47b$var$die(2);
}
var $ef4212660b69d47b$var$dontMutateMethodOverride = {
    [$ef4212660b69d47b$var$VALUE]: $ef4212660b69d47b$var$dontMutateFrozenCollections
};
function $ef4212660b69d47b$var$isFrozen(obj) {
    if (obj === null || !$ef4212660b69d47b$var$isObjectish(obj)) return true;
    return $ef4212660b69d47b$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $ef4212660b69d47b$var$PluginMapSet = "MapSet";
var $ef4212660b69d47b$var$PluginPatches = "Patches";
var $ef4212660b69d47b$var$PluginArrayMethods = "ArrayMethods";
var $ef4212660b69d47b$var$plugins = {};
function $ef4212660b69d47b$var$getPlugin(pluginKey) {
    const plugin = $ef4212660b69d47b$var$plugins[pluginKey];
    if (!plugin) $ef4212660b69d47b$var$die(0, pluginKey);
    return plugin;
}
var $ef4212660b69d47b$var$isPluginLoaded = (pluginKey)=>!!$ef4212660b69d47b$var$plugins[pluginKey];
function $ef4212660b69d47b$var$loadPlugin(pluginKey, implementation) {
    if (!$ef4212660b69d47b$var$plugins[pluginKey]) $ef4212660b69d47b$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $ef4212660b69d47b$var$currentScope;
var $ef4212660b69d47b$var$getCurrentScope = ()=>$ef4212660b69d47b$var$currentScope;
var $ef4212660b69d47b$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $ef4212660b69d47b$var$isPluginLoaded($ef4212660b69d47b$var$PluginMapSet) ? $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $ef4212660b69d47b$var$isPluginLoaded($ef4212660b69d47b$var$PluginArrayMethods) ? $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginArrayMethods) : void 0
    });
function $ef4212660b69d47b$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $ef4212660b69d47b$var$revokeScope(scope) {
    $ef4212660b69d47b$var$leaveScope(scope);
    scope.drafts_.forEach($ef4212660b69d47b$var$revokeDraft);
    scope.drafts_ = null;
}
function $ef4212660b69d47b$var$leaveScope(scope) {
    if (scope === $ef4212660b69d47b$var$currentScope) $ef4212660b69d47b$var$currentScope = scope.parent_;
}
var $ef4212660b69d47b$var$enterScope = (immer2)=>$ef4212660b69d47b$var$currentScope = $ef4212660b69d47b$var$createScope($ef4212660b69d47b$var$currentScope, immer2);
function $ef4212660b69d47b$var$revokeDraft(draft) {
    const state = draft[$ef4212660b69d47b$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $ef4212660b69d47b$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$ef4212660b69d47b$var$DRAFT_STATE].modified_) {
            $ef4212660b69d47b$var$revokeScope(scope);
            $ef4212660b69d47b$var$die(4);
        }
        if ($ef4212660b69d47b$export$16e3aed3edb85946(result)) result = $ef4212660b69d47b$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$ef4212660b69d47b$var$DRAFT_STATE].base_, result, scope);
    } else result = $ef4212660b69d47b$var$finalize(scope, baseDraft);
    $ef4212660b69d47b$var$maybeFreeze(scope, result, true);
    $ef4212660b69d47b$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $ef4212660b69d47b$export$45b790e32b2810ee ? result : void 0;
}
function $ef4212660b69d47b$var$finalize(rootScope, value) {
    if ($ef4212660b69d47b$var$isFrozen(value)) return value;
    const state = value[$ef4212660b69d47b$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $ef4212660b69d47b$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$ef4212660b69d47b$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $ef4212660b69d47b$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $ef4212660b69d47b$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $ef4212660b69d47b$export$792f3d81ea979f55(value, deep);
}
function $ef4212660b69d47b$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $ef4212660b69d47b$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $ef4212660b69d47b$var$EMPTY_LOCATIONS_RESULT = [];
function $ef4212660b69d47b$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $ef4212660b69d47b$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $ef4212660b69d47b$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $ef4212660b69d47b$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $ef4212660b69d47b$var$each(parentCopy, (key, value)=>{
            if ($ef4212660b69d47b$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $ef4212660b69d47b$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$ef4212660b69d47b$var$set(parentCopy, location, finalizedValue, parentType);
}
function $ef4212660b69d47b$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$ef4212660b69d47b$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $ef4212660b69d47b$var$getFinalValue(state);
        $ef4212660b69d47b$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $ef4212660b69d47b$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $ef4212660b69d47b$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $ef4212660b69d47b$var$markStateFinalized(state);
    }
}
function $ef4212660b69d47b$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($ef4212660b69d47b$export$541ac630993a4c84(value)) {
        const state = value[$ef4212660b69d47b$var$DRAFT_STATE];
        if ($ef4212660b69d47b$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $ef4212660b69d47b$var$prepareCopy(target);
            const finalizedValue = $ef4212660b69d47b$var$getFinalValue(state);
            $ef4212660b69d47b$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($ef4212660b69d47b$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $ef4212660b69d47b$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $ef4212660b69d47b$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($ef4212660b69d47b$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $ef4212660b69d47b$var$handleValue($ef4212660b69d47b$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $ef4212660b69d47b$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($ef4212660b69d47b$export$541ac630993a4c84(target) || handledSet.has(target) || !$ef4212660b69d47b$export$16e3aed3edb85946(target) || $ef4212660b69d47b$var$isFrozen(target)) return target;
    handledSet.add(target);
    $ef4212660b69d47b$var$each(target, (key, value)=>{
        if ($ef4212660b69d47b$export$541ac630993a4c84(value)) {
            const state = value[$ef4212660b69d47b$var$DRAFT_STATE];
            if ($ef4212660b69d47b$var$isSameScope(state, rootScope)) {
                const updatedValue = $ef4212660b69d47b$var$getFinalValue(state);
                $ef4212660b69d47b$var$set(target, key, updatedValue, target.type_);
                $ef4212660b69d47b$var$markStateFinalized(state);
            }
        } else if ($ef4212660b69d47b$export$16e3aed3edb85946(value)) $ef4212660b69d47b$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $ef4212660b69d47b$var$createProxyProxy(base, parent) {
    const baseIsArray = $ef4212660b69d47b$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $ef4212660b69d47b$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $ef4212660b69d47b$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $ef4212660b69d47b$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $ef4212660b69d47b$var$objectTraps = {
    get (state, prop) {
        if (prop === $ef4212660b69d47b$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $ef4212660b69d47b$var$latest(state);
        if (!$ef4212660b69d47b$var$has(source, prop, state.type_)) return $ef4212660b69d47b$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$ef4212660b69d47b$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $ef4212660b69d47b$var$isArrayIndex(prop)) return value;
        if (value === $ef4212660b69d47b$var$peek(state.base_, prop)) {
            $ef4212660b69d47b$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $ef4212660b69d47b$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $ef4212660b69d47b$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($ef4212660b69d47b$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $ef4212660b69d47b$var$getDescriptorFromProto($ef4212660b69d47b$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $ef4212660b69d47b$var$peek($ef4212660b69d47b$var$latest(state), prop);
            const currentState = current2?.[$ef4212660b69d47b$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($ef4212660b69d47b$var$is(value, current2) && (value !== void 0 || $ef4212660b69d47b$var$has(state.base_, prop, state.type_))) return true;
            $ef4212660b69d47b$var$prepareCopy(state);
            $ef4212660b69d47b$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $ef4212660b69d47b$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $ef4212660b69d47b$var$prepareCopy(state);
        if ($ef4212660b69d47b$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $ef4212660b69d47b$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $ef4212660b69d47b$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$ef4212660b69d47b$var$WRITABLE]: true,
            [$ef4212660b69d47b$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$ef4212660b69d47b$var$ENUMERABLE]: desc[$ef4212660b69d47b$var$ENUMERABLE],
            [$ef4212660b69d47b$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $ef4212660b69d47b$var$die(11);
    },
    getPrototypeOf (state) {
        return $ef4212660b69d47b$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $ef4212660b69d47b$var$die(12);
    }
};
var $ef4212660b69d47b$var$arrayTraps = {};
for(let key in $ef4212660b69d47b$var$objectTraps){
    let fn = $ef4212660b69d47b$var$objectTraps[key];
    $ef4212660b69d47b$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$ef4212660b69d47b$var$arrayTraps.deleteProperty = function(state, prop) {
    return $ef4212660b69d47b$var$arrayTraps.set.call(this, state, prop, void 0);
};
$ef4212660b69d47b$var$arrayTraps.set = function(state, prop, value) {
    return $ef4212660b69d47b$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $ef4212660b69d47b$var$peek(draft, prop) {
    const state = draft[$ef4212660b69d47b$var$DRAFT_STATE];
    const source = state ? $ef4212660b69d47b$var$latest(state) : draft;
    return source[prop];
}
function $ef4212660b69d47b$var$readPropFromProto(state, source, prop) {
    const desc = $ef4212660b69d47b$var$getDescriptorFromProto(source, prop);
    return desc ? $ef4212660b69d47b$var$VALUE in desc ? desc[$ef4212660b69d47b$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $ef4212660b69d47b$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $ef4212660b69d47b$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $ef4212660b69d47b$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $ef4212660b69d47b$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $ef4212660b69d47b$var$markChanged(state.parent_);
    }
}
function $ef4212660b69d47b$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $ef4212660b69d47b$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $ef4212660b69d47b$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($ef4212660b69d47b$var$isFunction(base) && !$ef4212660b69d47b$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$ef4212660b69d47b$var$isFunction(recipe)) $ef4212660b69d47b$var$die(6);
            if (patchListener !== void 0 && !$ef4212660b69d47b$var$isFunction(patchListener)) $ef4212660b69d47b$var$die(7);
            let result;
            if ($ef4212660b69d47b$export$16e3aed3edb85946(base)) {
                const scope = $ef4212660b69d47b$var$enterScope(this);
                const proxy = $ef4212660b69d47b$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $ef4212660b69d47b$var$revokeScope(scope);
                    else $ef4212660b69d47b$var$leaveScope(scope);
                }
                $ef4212660b69d47b$var$usePatchesInScope(scope, patchListener);
                return $ef4212660b69d47b$var$processResult(result, scope);
            } else if (!base || !$ef4212660b69d47b$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $ef4212660b69d47b$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $ef4212660b69d47b$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $ef4212660b69d47b$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($ef4212660b69d47b$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($ef4212660b69d47b$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($ef4212660b69d47b$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($ef4212660b69d47b$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$ef4212660b69d47b$export$16e3aed3edb85946(base)) $ef4212660b69d47b$var$die(8);
        if ($ef4212660b69d47b$export$541ac630993a4c84(base)) base = $ef4212660b69d47b$export$97aac956da55dae9(base);
        const scope = $ef4212660b69d47b$var$enterScope(this);
        const proxy = $ef4212660b69d47b$var$createProxy(scope, base, void 0);
        proxy[$ef4212660b69d47b$var$DRAFT_STATE].isManual_ = true;
        $ef4212660b69d47b$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$ef4212660b69d47b$var$DRAFT_STATE];
        if (!state || !state.isManual_) $ef4212660b69d47b$var$die(9);
        const { scope_: scope } = state;
        $ef4212660b69d47b$var$usePatchesInScope(scope, patchListener);
        return $ef4212660b69d47b$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginPatches).applyPatches_;
        if ($ef4212660b69d47b$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $ef4212660b69d47b$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $ef4212660b69d47b$var$isMap(value) ? $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginMapSet).proxyMap_(value, parent) : $ef4212660b69d47b$var$isSet(value) ? $ef4212660b69d47b$var$getPlugin($ef4212660b69d47b$var$PluginMapSet).proxySet_(value, parent) : $ef4212660b69d47b$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $ef4212660b69d47b$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $ef4212660b69d47b$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $ef4212660b69d47b$export$97aac956da55dae9(value) {
    if (!$ef4212660b69d47b$export$541ac630993a4c84(value)) $ef4212660b69d47b$var$die(10, value);
    return $ef4212660b69d47b$var$currentImpl(value);
}
function $ef4212660b69d47b$var$currentImpl(value) {
    if (!$ef4212660b69d47b$export$16e3aed3edb85946(value) || $ef4212660b69d47b$var$isFrozen(value)) return value;
    const state = value[$ef4212660b69d47b$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $ef4212660b69d47b$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $ef4212660b69d47b$var$shallowCopy(value, true);
    $ef4212660b69d47b$var$each(copy, (key, childValue)=>{
        $ef4212660b69d47b$var$set(copy, key, $ef4212660b69d47b$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $ef4212660b69d47b$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $ef4212660b69d47b$var$getProxyDraft($ef4212660b69d47b$var$get(parentCopy, state.key_));
            const valueAtKey = $ef4212660b69d47b$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $ef4212660b69d47b$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $ef4212660b69d47b$var$get(current2, key);
            if (!$ef4212660b69d47b$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$ef4212660b69d47b$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $ef4212660b69d47b$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $ef4212660b69d47b$var$get(base_, key, type_);
            const value = $ef4212660b69d47b$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $ef4212660b69d47b$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $ef4212660b69d47b$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $ef4212660b69d47b$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $ef4212660b69d47b$var$CONSTRUCTOR)) $ef4212660b69d47b$var$die(errorOffset + 3);
                if ($ef4212660b69d47b$var$isFunction(base) && p === $ef4212660b69d47b$var$PROTOTYPE) $ef4212660b69d47b$var$die(errorOffset + 3);
                base = $ef4212660b69d47b$var$get(base, p);
                if (!$ef4212660b69d47b$var$isObjectish(base)) $ef4212660b69d47b$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $ef4212660b69d47b$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $ef4212660b69d47b$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $ef4212660b69d47b$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$ef4212660b69d47b$export$16e3aed3edb85946(obj)) return obj;
        if ($ef4212660b69d47b$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($ef4212660b69d47b$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($ef4212660b69d47b$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($ef4212660b69d47b$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($ef4212660b69d47b$var$has(obj, $ef4212660b69d47b$export$6ee2082928bcb0ee)) cloned[$ef4212660b69d47b$export$6ee2082928bcb0ee] = obj[$ef4212660b69d47b$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($ef4212660b69d47b$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $ef4212660b69d47b$var$loadPlugin($ef4212660b69d47b$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $ef4212660b69d47b$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$ef4212660b69d47b$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $ef4212660b69d47b$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $ef4212660b69d47b$var$latest(this[$ef4212660b69d47b$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $ef4212660b69d47b$var$latest(this[$ef4212660b69d47b$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$ef4212660b69d47b$var$latest(state).has(key) || $ef4212660b69d47b$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $ef4212660b69d47b$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $ef4212660b69d47b$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $ef4212660b69d47b$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($ef4212660b69d47b$var$latest(state).size) {
                prepareMapCopy(state);
                $ef4212660b69d47b$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $ef4212660b69d47b$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            $ef4212660b69d47b$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $ef4212660b69d47b$var$latest(state).get(key);
            if (state.finalized_ || !$ef4212660b69d47b$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $ef4212660b69d47b$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $ef4212660b69d47b$var$latest(this[$ef4212660b69d47b$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($ef4212660b69d47b$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$ef4212660b69d47b$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$ef4212660b69d47b$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $ef4212660b69d47b$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $ef4212660b69d47b$var$latest(this[$ef4212660b69d47b$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $ef4212660b69d47b$var$markChanged(state);
                state.copy_.add(value);
                $ef4212660b69d47b$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $ef4212660b69d47b$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($ef4212660b69d47b$var$latest(state).size) {
                prepareSetCopy(state);
                $ef4212660b69d47b$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$ef4212660b69d47b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($ef4212660b69d47b$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$ef4212660b69d47b$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($ef4212660b69d47b$export$16e3aed3edb85946(value)) {
                    const draft = $ef4212660b69d47b$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $ef4212660b69d47b$var$die(3, JSON.stringify($ef4212660b69d47b$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($ef4212660b69d47b$var$getValue(value));
            });
        }
    }
    $ef4212660b69d47b$var$loadPlugin($ef4212660b69d47b$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $ef4212660b69d47b$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $ef4212660b69d47b$var$prepareCopy(state);
        const result = operation();
        $ef4212660b69d47b$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $ef4212660b69d47b$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $ef4212660b69d47b$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $ef4212660b69d47b$var$loadPlugin($ef4212660b69d47b$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $ef4212660b69d47b$var$immer = new $ef4212660b69d47b$export$aaadc6ff0f822719();
var $ef4212660b69d47b$export$b46cabe22e78bc00 = $ef4212660b69d47b$var$immer.produce;
var $ef4212660b69d47b$export$4da66d41c9492c78 = /* @__PURE__ */ $ef4212660b69d47b$var$immer.produceWithPatches.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$573f26f60825c493 = /* @__PURE__ */ $ef4212660b69d47b$var$immer.setAutoFreeze.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$333ce65961cbe047 = /* @__PURE__ */ $ef4212660b69d47b$var$immer.setUseStrictShallowCopy.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$1045b3be3904c489 = /* @__PURE__ */ $ef4212660b69d47b$var$immer.setUseStrictIteration.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $ef4212660b69d47b$var$immer.applyPatches.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$3c3214997190395f = /* @__PURE__ */ $ef4212660b69d47b$var$immer.createDraft.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$c60f5e69c521b528 = /* @__PURE__ */ $ef4212660b69d47b$var$immer.finishDraft.bind($ef4212660b69d47b$var$immer);
var $ef4212660b69d47b$export$c05b21e3257751e5 = (value)=>value;
var $ef4212660b69d47b$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("66zU2", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $471f272862d0c890$export$f51a9068ac82ea43);
var $471f272862d0c890$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/vanilla.mjs"
});
const $471f272862d0c890$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($471f272862d0c890$import_meta.env ? $471f272862d0c890$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $471f272862d0c890$export$f51a9068ac82ea43 = (createState)=>createState ? $471f272862d0c890$var$createStoreImpl(createState) : $471f272862d0c890$var$createStoreImpl;
var $471f272862d0c890$export$2e2bcd8739ae039 = (createState)=>{
    if (($471f272862d0c890$import_meta.env ? $471f272862d0c890$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $471f272862d0c890$export$f51a9068ac82ea43(createState);
};

});


parcelRegister("kmrqJ", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $e1d9da2b926be1d5$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("6Pqir")).FileFetcherError);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $4rNEC = parcelRequire("4rNEC");

var $bP9Wc = parcelRequire("bP9Wc");

var $aAAtt = parcelRequire("aAAtt");

var $7RHfd = parcelRequire("7RHfd");

var $8FIIl = parcelRequire("8FIIl");

var $8FlfH = parcelRequire("8FlfH");

var $gph1Q = parcelRequire("gph1Q");

var $58zEP = parcelRequire("58zEP");

var $9tvow = parcelRequire("9tvow");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $6k8oQ = parcelRequire("6k8oQ");

var $9lJti = parcelRequire("9lJti");

var $bdBRx = parcelRequire("bdBRx");

var $efYiC = parcelRequire("efYiC");

var $gqk6k = parcelRequire("gqk6k");

var $39N5R = parcelRequire("39N5R");

var $9lreT = parcelRequire("9lreT");

var $3Gewy = parcelRequire("3Gewy");

var $cWwMF = parcelRequire("cWwMF");

var $euBvF = parcelRequire("euBvF");

var $aWAVX = parcelRequire("aWAVX");

var $krYrG = parcelRequire("krYrG");

var $7iksD = parcelRequire("7iksD");

var $l6scP = parcelRequire("l6scP");

var $hZw9e = parcelRequire("hZw9e");

var $e4QoN = parcelRequire("e4QoN");

var $jnEsw = parcelRequire("jnEsw");

var $lp9vn = parcelRequire("lp9vn");

var $jNsur = parcelRequire("jNsur");

var $h4ea8 = parcelRequire("h4ea8");

var $2iQUH = parcelRequire("2iQUH");

var $l7t1O = parcelRequire("l7t1O");

var $3cWar = parcelRequire("3cWar");

var $avVvB = parcelRequire("avVvB");

var $30AWv = parcelRequire("30AWv");

var $l3OfC = parcelRequire("l3OfC");

var $2gvlV = parcelRequire("2gvlV");

var $6Pqir = parcelRequire("6Pqir");

const $e1d9da2b926be1d5$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $e1d9da2b926be1d5$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
const $e1d9da2b926be1d5$var$EXTERNAL_UPLOAD_FALLBACK_STEM = 'image';
// Only used to resolve relative urls so their path can be read; never requested.
const $e1d9da2b926be1d5$var$EXTERNAL_UPLOAD_URL_BASE = 'https://media.invalid';
// A leading dot names a file rather than an extension, so `.gitignore` splits to a stem.
const $e1d9da2b926be1d5$var$splitExtension = (name)=>{
    const index = name.lastIndexOf('.');
    return index > 0 ? [
        name.slice(0, index),
        name.slice(index)
    ] : [
        name,
        ''
    ];
};
// Publishing copies media into page attachments keyed by filename, and same-named files collapse
// into versions of a single attachment. External URLs are frequently endpoint-style (for example
// `/binary`), so the stem is made unique before the upload reaches Media Services.
const $e1d9da2b926be1d5$var$buildExternalUploadName = (url, anonymizeFilename)=>{
    if (anonymizeFilename) return crypto.randomUUID();
    if (!(0, $gdUUy.fg)('platform_media_unique_external_upload_name')) return url.split('/').pop() || '';
    // Reading the path drops any query string, which would otherwise be captured as part of the
    // extension and suppress the MIME-derived fallback.
    const urlName = new URL(url, $e1d9da2b926be1d5$var$EXTERNAL_UPLOAD_URL_BASE).pathname.split('/').pop() || '';
    const [stem, extension] = $e1d9da2b926be1d5$var$splitExtension(urlName);
    return `${stem || $e1d9da2b926be1d5$var$EXTERNAL_UPLOAD_FALLBACK_STEM}-${crypto.randomUUID()}${extension}`;
};
class $e1d9da2b926be1d5$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $9tvow.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $39N5R.isCommonMediaClientError)(error)) return (0, $gqk6k.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $efYiC.CommonMediaClientError)(error);
                return (0, $gqk6k.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $efYiC.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
                return (0, $gqk6k.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh, initialFileState)=>{
            const subject = (0, $jnEsw.createMediaSubject)(initialFileState);
            const poll = new (0, $avVvB.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (!forceRefresh && (initialFileState === null || initialFileState === void 0 ? void 0 : initialFileState.status) === 'processed') {
                    subject.complete();
                    return;
                }
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $cWwMF.isNotFoundMediaItemDetails)(response)) throw new (0, $6Pqir.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $lp9vn.isEmptyFile)(response)) throw new (0, $6Pqir.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $krYrG.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $l6scP.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' // name property is not available in base64 image
             } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $h4ea8.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $krYrG.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            var _fileState$mediaMetad;
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if ('mediaMetadata' in fileState && (_fileState$mediaMetad = fileState.mediaMetadata) !== null && _fileState$mediaMetad !== void 0 && _fileState$mediaMetad.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch  {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $e4QoN.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $hZw9e.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh, initialFileState: initialFileState } = options;
        if (!(0, $8FlfH.isValidUuid)(id)) {
            // Do NOT pass initialFileState here — for an invalid UUID the SSR seed
            // is meaningless and would cause subscribers to briefly see a
            // valid-looking file state before the error is emitted.
            const subject = (0, $jnEsw.createMediaSubject)();
            const err = new (0, $6Pqir.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $2iQUH.fromObservable)(subject);
        }
        if (forceRefresh) (0, $9lJti.getFileStreamsCache)().remove(id);
        return (0, $2iQUH.fromObservable)((0, $9lJti.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh, initialFileState);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $l7t1O.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge, name) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge, name);
    }
    touchFiles(descriptors, collection, traceContext, expectedFileSize) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext, {
            expectedFileSize: expectedFileSize
        }).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext, expectedFileSize) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $7RHfd.default)();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const occurrenceKey = (0, $7RHfd.default)();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext, expectedFileSize).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext, anonymizeFilename) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $jnEsw.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const initialName = $e1d9da2b926be1d5$var$buildExternalUploadName(url, anonymizeFilename);
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: initialName,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $9lJti.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const extensionAllowed = anonymizeFilename ? (0, $3y2s4.isExperimentEnabled)('cc_maui_polish_changes_batch_8') : (0, $gdUUy.fg)('platform_media_unique_external_upload_name');
            const [, existingExtension] = $e1d9da2b926be1d5$var$splitExtension(initialName);
            const extension = extensionAllowed && !existingExtension ? (0, $4rNEC.getExtension)(type) : undefined;
            const name = extension ? `${initialName}.${extension}` : initialName;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $gph1Q.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $jNsur.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext, file.size);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $jnEsw.createMediaSubject)();
        (0, $9lJti.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $aAAtt.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $bP9Wc.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $3cWar.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $7iksD.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller === null || controller === void 0 || controller.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $2iQUH.fromObservable)(subject);
    }
    async downloadBinary(id, name, collectionName, traceContext) {
        const downloadName = name ?? 'download';
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName, undefined, name);
        (0, $8FIIl.downloadUrl)(url, {
            name: downloadName
        });
        (0, $bdBRx.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $6k8oQ.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $30AWv.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $2gvlV.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $58zEP.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext, source.clientId);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $9lJti.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($e1d9da2b926be1d5$var$isCopySourceFileWithToken(source) && $e1d9da2b926be1d5$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $gph1Q.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $aWAVX.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $jnEsw.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $9lreT.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $3Gewy.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $l3OfC.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $3cWar.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $3cWar.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $9lreT.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $euBvF.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $9lreT.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $9lJti.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $jnEsw.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("4rNEC", function(module, exports) {
'use strict';

var $6pGe5 = parcelRequire("6pGe5");


module.exports = new $6pGe5((parcelRequire("dtKrX")), (parcelRequire("8Bj4o")));

});
parcelRegister("6pGe5", function(module, exports) {
'use strict';
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function $4ab5d518edc67ae2$var$Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ $4ab5d518edc67ae2$var$Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === '*') continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== '*' ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ $4ab5d518edc67ae2$var$Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, '').toLowerCase();
    let ext = last.replace(/^.*\./, '').toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ $4ab5d518edc67ae2$var$Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
module.exports = $4ab5d518edc67ae2$var$Mime;

});

parcelRegister("dtKrX", function(module, exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

});

parcelRegister("8Bj4o", function(module, exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

});


parcelRegister("bP9Wc", function(module, exports) {
"use strict";
var $89bc2a8d9ea999f3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $89bc2a8d9ea999f3$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $89bc2a8d9ea999f3$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $89bc2a8d9ea999f3$var$map;
var $89bc2a8d9ea999f3$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $89bc2a8d9ea999f3$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $89bc2a8d9ea999f3$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $89bc2a8d9ea999f3$var$MapSubscriber = function(_super) {
    $89bc2a8d9ea999f3$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($66gCN.Subscriber);

});

parcelRegister("8FIIl", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $f0fbe17f60ed4391$export$8a96edb1c96563f4);
const $f0fbe17f60ed4391$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("8FlfH", function(module, exports) {
$parcel$export(module.exports, "isValidUuid", () => $77ab223c401b4d59$export$6ad459db9a6bcc76);
const $77ab223c401b4d59$var$BASIC_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $77ab223c401b4d59$export$6ad459db9a6bcc76 = (value)=>{
    if (typeof value !== 'string') return false;
    const normalizedValue = value.toLowerCase();
    if (!$77ab223c401b4d59$var$BASIC_UUID_REGEX.test(normalizedValue)) return false;
    const version = normalizedValue[14];
    if (version === '1' || version === '2') return true;
    if (version === '3' || version === '4' || version === '5') {
        const variant = normalizedValue[19];
        return variant === '8' || variant === '9' || variant === 'a' || variant === 'b';
    }
    return false;
};

});

parcelRegister("gph1Q", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $9094c7ef50b368ad$export$79e1dc0d1801e8ef);

var $fQMl8 = parcelRequire("fQMl8");

var $8pXuy = parcelRequire("8pXuy");

var $9fGCC = parcelRequire("9fGCC");

const $9094c7ef50b368ad$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $fQMl8.isArchive)(mimeType)) return 'archive';
    if ((0, $8pXuy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $9fGCC.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $8pXuy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $9fGCC.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $8pXuy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $9fGCC.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $8pXuy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $9fGCC.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("fQMl8", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $840804df56092a06$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $840804df56092a06$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("8pXuy", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $88f8b6f1564dcf83$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $88f8b6f1564dcf83$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $88f8b6f1564dcf83$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $88f8b6f1564dcf83$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $88f8b6f1564dcf83$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $88f8b6f1564dcf83$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $88f8b6f1564dcf83$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $88f8b6f1564dcf83$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $88f8b6f1564dcf83$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $88f8b6f1564dcf83$export$55ca6cdaf6093034 = (mimeType)=>$88f8b6f1564dcf83$export$74325e3c843a9555(mimeType) || $88f8b6f1564dcf83$export$c021f2623a75015f(mimeType) || $88f8b6f1564dcf83$export$ff36075ea755a717(mimeType) || $88f8b6f1564dcf83$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("9fGCC", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $141ff5e63f5d4bb5$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $141ff5e63f5d4bb5$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $141ff5e63f5d4bb5$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $141ff5e63f5d4bb5$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $141ff5e63f5d4bb5$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $141ff5e63f5d4bb5$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $141ff5e63f5d4bb5$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $141ff5e63f5d4bb5$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $141ff5e63f5d4bb5$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $141ff5e63f5d4bb5$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $141ff5e63f5d4bb5$export$548d9148a80556a3 = (mimeType)=>$141ff5e63f5d4bb5$export$e9a065a80f76311e(mimeType) || $141ff5e63f5d4bb5$export$86baad7a89d908e9(mimeType) || $141ff5e63f5d4bb5$export$8cba23825d020bbb(mimeType) || $141ff5e63f5d4bb5$export$9c2b4de5fdca2ce3(mimeType) || $141ff5e63f5d4bb5$export$94e1479e01d2af53(mimeType);

});


parcelRegister("58zEP", function(module, exports) {
$parcel$export(module.exports, "authToOwner", () => $b529cd1f44dd3ca0$export$17f6055767a8d96a);

var $cqiVL = parcelRequire("cqiVL");
const $b529cd1f44dd3ca0$export$17f6055767a8d96a = (auth)=>{
    if ((0, $cqiVL.isAsapBasedAuth)(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});
parcelRegister("cqiVL", function(module, exports) {
$parcel$export(module.exports, "isAsapBasedAuth", () => $c29ff380c3c0a3ae$export$af1ab14f2246ef72);
function $c29ff380c3c0a3ae$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}

});


parcelRegister("3y2s4", function(module, exports) {
$parcel$export(module.exports, "isExperimentEnabled", () => $94d7b46e93a6aae3$export$336b018592dc9972);

var $9Mjpq = parcelRequire("9Mjpq");
function $94d7b46e93a6aae3$export$336b018592dc9972(experimentName) {
    return (0, $9Mjpq.expVal)(experimentName, 'isEnabled', false) === true;
}

});
parcelRegister("9Mjpq", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $0267e84e775ece61$export$9db1624a8af791a4);

var $lBMNf = parcelRequire("lBMNf");
function $0267e84e775ece61$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $lBMNf.expValInternal)(experimentName, param, defaultValue, true);
}

});
parcelRegister("lBMNf", function(module, exports) {
$parcel$export(module.exports, "expValInternal", () => $77c886ac63ff9c71$export$48708229abf6ab93);

var $87QgR = parcelRequire("87QgR");

var $i2aoZ = parcelRequire("i2aoZ");

var $kperT = parcelRequire("kperT");
function $77c886ac63ff9c71$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $kperT.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $kperT.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $i2aoZ.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $87QgR.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $87QgR.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $i2aoZ.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}

});
parcelRegister("kperT", function(module, exports) {
$parcel$export(module.exports, "devOverrides", () => $187622d8bc7e8915$export$89f9222be8849d61);
const $187622d8bc7e8915$export$89f9222be8849d61 = new Map();
let $187622d8bc7e8915$export$1443858d5f82511f = false;
function $187622d8bc7e8915$export$6bce865e33a255c3(value) {
    $187622d8bc7e8915$export$1443858d5f82511f = value;
}

});




parcelRegister("6k8oQ", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $ce1d466eacf99cd8$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $ce1d466eacf99cd8$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $ce1d466eacf99cd8$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $ce1d466eacf99cd8$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $ce1d466eacf99cd8$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $ce1d466eacf99cd8$export$f14f521f3d306044);
$parcel$export(module.exports, "FILE_READER_FALLBACK_ERROR_NAME", () => $ce1d466eacf99cd8$export$b3e78a9a23c941e9);

var $hkEHH = parcelRequire("hkEHH");
const $ce1d466eacf99cd8$export$860a16125e30000b = 'recents';
const $ce1d466eacf99cd8$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $ce1d466eacf99cd8$export$6e70f30e392bc53f = 4096;
const $ce1d466eacf99cd8$export$c1abb8bab1e615cd = 5 * (0, $hkEHH.DATA_UNIT).MB;
const $ce1d466eacf99cd8$export$3d5157f0def70e54 = 1000;
const $ce1d466eacf99cd8$export$f14f521f3d306044 = 2 * (0, $hkEHH.DATA_UNIT).TB;
const $ce1d466eacf99cd8$export$b3e78a9a23c941e9 = 'FileReaderError';

});
parcelRegister("hkEHH", function(module, exports) {
$parcel$export(module.exports, "DATA_UNIT", () => $85e61c63c18b774e$export$76cfea4c354af843);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

var $85e61c63c18b774e$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("9lJti", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $b707d3e55b3a5f81$export$f2f061938c1e6810);

var $3mWce = parcelRequire("3mWce");
let $b707d3e55b3a5f81$var$streamCache;

const $b707d3e55b3a5f81$export$f2f061938c1e6810 = ()=>{
    if (!$b707d3e55b3a5f81$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("6hlzF")).mediaState;
        $b707d3e55b3a5f81$var$streamCache = new (0, $3mWce.StreamsCache)(mediaState.streams);
    }
    return $b707d3e55b3a5f81$var$streamCache;
};

});
parcelRegister("3mWce", function(module, exports) {
$parcel$export(module.exports, "StreamsCache", () => $56b60c10580cb4f4$export$4293896e79732236);
class $56b60c10580cb4f4$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}

});

parcelRegister("6hlzF", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $06745e6ddd6de9aa$export$8cef61637918b288);

var $3O8jZ = parcelRequire("3O8jZ");

var $5j6lg = parcelRequire("5j6lg");
const $06745e6ddd6de9aa$export$8cef61637918b288 = {
    streams: new (0, $5j6lg.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $3O8jZ.EventEmitter2)()
};

});
parcelRegister("5j6lg", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("bdBRx", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $b2a2c9a0fd8d7a1c$export$68d003d3105952ad);

var $6hlzF = parcelRequire("6hlzF");
const $b2a2c9a0fd8d7a1c$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $6hlzF.mediaState).eventEmitter) (0, $6hlzF.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $6hlzF.mediaState).eventEmitter) (0, $6hlzF.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $6hlzF.mediaState).eventEmitter) return (0, $6hlzF.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("efYiC", function(module, exports) {
$parcel$export(module.exports, "CommonMediaClientError", () => $a7543d287dc52934$export$e574d1724215079f);

var $hXxYI = parcelRequire("hXxYI");
class $a7543d287dc52934$export$e574d1724215079f extends (0, $hXxYI.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}

});
parcelRegister("hXxYI", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $e7073bb44684ad28$export$2b0aca14d61c3190);
class $e7073bb44684ad28$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});


parcelRegister("gqk6k", function(module, exports) {
$parcel$export(module.exports, "fromCommonMediaClientError", () => $6c34f4ebe1574f23$export$c2b89b9a32286816);
const $6c34f4ebe1574f23$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error === null || error === void 0 ? void 0 : error.reason,
                metadata: error === null || error === void 0 ? void 0 : error.metadata,
                innerError: error === null || error === void 0 ? void 0 : error.innerError
            },
            // Legacy details
            ...error === null || error === void 0 ? void 0 : error.attributes
        },
        message: error === null || error === void 0 ? void 0 : error.message
    };
};

});

parcelRegister("39N5R", function(module, exports) {
$parcel$export(module.exports, "isCommonMediaClientError", () => $15c82498edbb8011$export$881f0f9bc813e1f3);

var $efYiC = parcelRequire("efYiC");
function $15c82498edbb8011$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof (0, $efYiC.CommonMediaClientError)) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}

});

parcelRegister("9lreT", function(module, exports) {
$parcel$export(module.exports, "isErrorFileState", () => $1c2cd2f223d8f703$export$f863e1e09c8a926);
const $1c2cd2f223d8f703$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';

});

parcelRegister("3Gewy", function(module, exports) {
$parcel$export(module.exports, "isFinalFileState", () => $d3baaeeae94a0b2f$export$270b3fc27120edd0);
const $d3baaeeae94a0b2f$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);

});

parcelRegister("cWwMF", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $c855d7db5e93d76d$export$fd27d7abbc4a746d);
const $c855d7db5e93d76d$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};

});

parcelRegister("euBvF", function(module, exports) {
$parcel$export(module.exports, "isProcessingFileState", () => $6c9f809a338760b0$export$5c30e6dd75278e66);
const $6c9f809a338760b0$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';

});

parcelRegister("aWAVX", function(module, exports) {
$parcel$export(module.exports, "mapMediaFileToFileState", () => $a4464a1fc22827f0$export$ddfd67d20657322f);
const $a4464a1fc22827f0$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata, failReason: failReason, previewCdnUrl: previewCdnUrl } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata,
        previewCdnUrl: previewCdnUrl
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing',
                failReason: failReason
            };
    }
};

});

parcelRegister("krYrG", function(module, exports) {
$parcel$export(module.exports, "mapMediaItemToFileState", () => $cb67542422d76cf5$export$ea3730792e8bebfb);

var $aWAVX = parcelRequire("aWAVX");
const $cb67542422d76cf5$export$ea3730792e8bebfb = (id, item)=>{
    return (0, $aWAVX.mapMediaFileToFileState)({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("7iksD", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $2536f8575f2d7bb3$export$a5575dbeeffdad98);

var $iwjU4 = parcelRequire("iwjU4");

var $h4te9 = parcelRequire("h4te9");

var $fKQIh = parcelRequire("fKQIh");

var $6k8oQ = parcelRequire("6k8oQ");

var $ahbtk = parcelRequire("ahbtk");

var $9Su0W = parcelRequire("9Su0W");

var $lTOKG = parcelRequire("lTOKG");
const $2536f8575f2d7bb3$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $ahbtk.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $2536f8575f2d7bb3$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $2536f8575f2d7bb3$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext, size)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $2536f8575f2d7bb3$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext, {
            expectedFileSize: size
        });
        offset += chunks.length;
    };
};
const $2536f8575f2d7bb3$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType, content: content } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    // If the file is a Blob and the size is not passed from consumer, set the file size from file content
    if (content instanceof Blob && !file.size) file.size = content.size;
    return store.createFileFromUpload({
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    }, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext, {
        expectedFileSize: file.size
    });
};
const $2536f8575f2d7bb3$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $6k8oQ.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $9Su0W.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $9Su0W.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $lTOKG.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $fKQIh.chunkinator)(content, {
        hashingFunction: (blob)=>$2536f8575f2d7bb3$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $2536f8575f2d7bb3$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6k8oQ.PROCESSING_BATCH_SIZE),
        processingFunction: $2536f8575f2d7bb3$var$createProcessingFunction(store, deferredUploadId, collection, traceContext, file.size)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $iwjU4.from)(deferredUploadId).pipe((0, $h4te9.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $h4te9.concatMap)(()=>(0, $iwjU4.from)($2536f8575f2d7bb3$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $2536f8575f2d7bb3$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("iwjU4", function(module, exports) {
$parcel$export(module.exports, "from", () => $d7baa78f7a8d1b39$export$6788812c4e6611e6, (v) => $d7baa78f7a8d1b39$export$6788812c4e6611e6 = v);
var $d7baa78f7a8d1b39$export$6788812c4e6611e6;
"use strict";

var $aYgqf = parcelRequire("aYgqf");
$d7baa78f7a8d1b39$export$6788812c4e6611e6 = $aYgqf.FromObservable.create;

});
parcelRegister("aYgqf", function(module, exports) {
"use strict";
var $7fcc3f1a923b7b55$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gWadc = parcelRequire("gWadc");

var $dq5Zt = parcelRequire("dq5Zt");

var $bxsId = parcelRequire("bxsId");

var $2Tk1a = parcelRequire("2Tk1a");

var $jfGQ7 = parcelRequire("jfGQ7");

var $fznCF = parcelRequire("fznCF");

var $aD57t = parcelRequire("aD57t");

var $huYam = parcelRequire("huYam");

var $8jOUp = parcelRequire("8jOUp");

var $2fC9E = parcelRequire("2fC9E");

var $8omzy = parcelRequire("8omzy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7fcc3f1a923b7b55$var$FromObservable = function(_super) {
    $7fcc3f1a923b7b55$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$8omzy.observable] === 'function') {
                if (ish instanceof $8jOUp.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($gWadc.isArray(ish)) return new $fznCF.ArrayObservable(ish, scheduler);
            else if ($bxsId.isPromise(ish)) return new $2Tk1a.PromiseObservable(ish, scheduler);
            else if (typeof ish[$huYam.iterator] === 'function' || typeof ish === 'string') return new $jfGQ7.IteratorObservable(ish, scheduler);
            else if ($dq5Zt.isArrayLike(ish)) return new $aD57t.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$8omzy.observable]().subscribe(subscriber);
        else return ish[$8omzy.observable]().subscribe(new $2fC9E.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($8jOUp.Observable);
module.exports.FromObservable = $7fcc3f1a923b7b55$var$FromObservable;

});
parcelRegister("dq5Zt", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $9c5259ac7eed5005$export$1e2f57719e155213, (v) => $9c5259ac7eed5005$export$1e2f57719e155213 = v);
var $9c5259ac7eed5005$export$1e2f57719e155213;
"use strict";
$9c5259ac7eed5005$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("bxsId", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $86690c66556f3564$export$4369c812aac99591, (v) => $86690c66556f3564$export$4369c812aac99591 = v);
var $86690c66556f3564$export$4369c812aac99591;
"use strict";
function $86690c66556f3564$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$86690c66556f3564$export$4369c812aac99591 = $86690c66556f3564$var$isPromise;

});

parcelRegister("2Tk1a", function(module, exports) {
"use strict";
var $21b03ef43bea3a15$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a5Mzo = parcelRequire("a5Mzo");

var $8jOUp = parcelRequire("8jOUp");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $21b03ef43bea3a15$var$PromiseObservable = function(_super) {
    $21b03ef43bea3a15$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $a5Mzo.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($21b03ef43bea3a15$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($21b03ef43bea3a15$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($21b03ef43bea3a15$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $a5Mzo.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($8jOUp.Observable);
module.exports.PromiseObservable = $21b03ef43bea3a15$var$PromiseObservable;
function $21b03ef43bea3a15$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $21b03ef43bea3a15$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});

parcelRegister("jfGQ7", function(module, exports) {
"use strict";
var $e040a615ee701ef2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a5Mzo = parcelRequire("a5Mzo");

var $8jOUp = parcelRequire("8jOUp");

var $huYam = parcelRequire("huYam");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $e040a615ee701ef2$var$IteratorObservable = function(_super) {
    $e040a615ee701ef2$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $e040a615ee701ef2$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($8jOUp.Observable);
module.exports.IteratorObservable = $e040a615ee701ef2$var$IteratorObservable;
var $e040a615ee701ef2$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$huYam.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $e040a615ee701ef2$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $e040a615ee701ef2$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$huYam.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $e040a615ee701ef2$var$getIterator(obj) {
    var i = obj[$huYam.iterator];
    if (!i && typeof obj === 'string') return new $e040a615ee701ef2$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $e040a615ee701ef2$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$huYam.iterator]();
}
var $e040a615ee701ef2$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $e040a615ee701ef2$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$e040a615ee701ef2$var$numberIsFinite(len)) return len;
    len = $e040a615ee701ef2$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $e040a615ee701ef2$var$maxSafeInteger) return $e040a615ee701ef2$var$maxSafeInteger;
    return len;
}
function $e040a615ee701ef2$var$numberIsFinite(value) {
    return typeof value === 'number' && $a5Mzo.root.isFinite(value);
}
function $e040a615ee701ef2$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});
parcelRegister("huYam", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $cbd3e8bd434a8a40$export$6f58e2338da23f4d, (v) => $cbd3e8bd434a8a40$export$6f58e2338da23f4d = v);
var $cbd3e8bd434a8a40$export$77b88d321d1c84c6;
var $cbd3e8bd434a8a40$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $cbd3e8bd434a8a40$export$9785f547d3164dac;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
function $cbd3e8bd434a8a40$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$cbd3e8bd434a8a40$export$77b88d321d1c84c6 = $cbd3e8bd434a8a40$var$symbolIteratorPonyfill;
$cbd3e8bd434a8a40$export$6f58e2338da23f4d = $cbd3e8bd434a8a40$var$symbolIteratorPonyfill($a5Mzo.root);
$cbd3e8bd434a8a40$export$9785f547d3164dac = $cbd3e8bd434a8a40$export$6f58e2338da23f4d;

});


parcelRegister("fznCF", function(module, exports) {
"use strict";
var $b55c72dc3bfffea3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $b3QMc = parcelRequire("b3QMc");

var $cUooy = parcelRequire("cUooy");

var $86ewR = parcelRequire("86ewR");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $b55c72dc3bfffea3$var$ArrayObservable = function(_super) {
    $b55c72dc3bfffea3$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($86ewR.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $b3QMc.ScalarObservable(array[0], scheduler);
        else return new $cUooy.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($8jOUp.Observable);
module.exports.ArrayObservable = $b55c72dc3bfffea3$var$ArrayObservable;

});
parcelRegister("b3QMc", function(module, exports) {
"use strict";
var $80d8e9d600cf8a05$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $80d8e9d600cf8a05$var$ScalarObservable = function(_super) {
    $80d8e9d600cf8a05$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($8jOUp.Observable);
module.exports.ScalarObservable = $80d8e9d600cf8a05$var$ScalarObservable;

});

parcelRegister("cUooy", function(module, exports) {
"use strict";
var $965da3538814ec52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $965da3538814ec52$var$EmptyObservable = function(_super) {
    $965da3538814ec52$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($8jOUp.Observable);
module.exports.EmptyObservable = $965da3538814ec52$var$EmptyObservable;

});

parcelRegister("86ewR", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $5e5a276f6ad85de8$export$187e35932e88c15c, (v) => $5e5a276f6ad85de8$export$187e35932e88c15c = v);
var $5e5a276f6ad85de8$export$187e35932e88c15c;
"use strict";
function $5e5a276f6ad85de8$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$5e5a276f6ad85de8$export$187e35932e88c15c = $5e5a276f6ad85de8$var$isScheduler;

});


parcelRegister("aD57t", function(module, exports) {
"use strict";
var $7bd18482ecc756bd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $b3QMc = parcelRequire("b3QMc");

var $cUooy = parcelRequire("cUooy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7bd18482ecc756bd$var$ArrayLikeObservable = function(_super) {
    $7bd18482ecc756bd$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $cUooy.EmptyObservable();
        else if (length === 1) return new $b3QMc.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($8jOUp.Observable);
module.exports.ArrayLikeObservable = $7bd18482ecc756bd$var$ArrayLikeObservable;

});

parcelRegister("2fC9E", function(module, exports) {
"use strict";
var $1a3a943b2fed3225$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $fTcsX = parcelRequire("fTcsX");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $1a3a943b2fed3225$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $1a3a943b2fed3225$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $1a3a943b2fed3225$var$observeOn;
var $1a3a943b2fed3225$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1a3a943b2fed3225$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $1a3a943b2fed3225$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1a3a943b2fed3225$var$ObserveOnSubscriber = function(_super) {
    $1a3a943b2fed3225$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $1a3a943b2fed3225$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($fTcsX.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($fTcsX.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($fTcsX.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($66gCN.Subscriber);
module.exports.ObserveOnSubscriber = $1a3a943b2fed3225$var$ObserveOnSubscriber;
var $1a3a943b2fed3225$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $1a3a943b2fed3225$var$ObserveOnMessage;

});
parcelRegister("fTcsX", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $b915a99028d35171$export$14834abbfce3b8cd, (v) => $b915a99028d35171$export$14834abbfce3b8cd = v);
var $b915a99028d35171$export$14834abbfce3b8cd;
"use strict";

var $8jOUp = parcelRequire("8jOUp");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $b915a99028d35171$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $8jOUp.Observable.of(this.value);
            case 'E':
                return $8jOUp.Observable.throw(this.error);
            case 'C':
                return $8jOUp.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$b915a99028d35171$export$14834abbfce3b8cd = $b915a99028d35171$var$Notification;

});




parcelRegister("h4te9", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $c6d97b553dc57375$export$c28c8388be0ab31a, (v) => $c6d97b553dc57375$export$c28c8388be0ab31a = v);
var $c6d97b553dc57375$export$c28c8388be0ab31a;
"use strict";

var $jcL4C = parcelRequire("jcL4C");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $c6d97b553dc57375$var$concatMap(project, resultSelector) {
    return $jcL4C.mergeMap(project, resultSelector, 1);
}
$c6d97b553dc57375$export$c28c8388be0ab31a = $c6d97b553dc57375$var$concatMap;

});
parcelRegister("jcL4C", function(module, exports) {
"use strict";
var $dfb3a720ee52d1aa$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $dfb3a720ee52d1aa$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $dfb3a720ee52d1aa$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $dfb3a720ee52d1aa$var$mergeMap;
var $dfb3a720ee52d1aa$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $dfb3a720ee52d1aa$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $dfb3a720ee52d1aa$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $dfb3a720ee52d1aa$var$MergeMapSubscriber = function(_super) {
    $dfb3a720ee52d1aa$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($jziWR.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.MergeMapSubscriber = $dfb3a720ee52d1aa$var$MergeMapSubscriber;

});
parcelRegister("jziWR", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $e3effbf54ffa2e23$export$d0604af3321cfb1b, (v) => $e3effbf54ffa2e23$export$d0604af3321cfb1b = v);
var $e3effbf54ffa2e23$export$d0604af3321cfb1b;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");

var $dq5Zt = parcelRequire("dq5Zt");

var $bxsId = parcelRequire("bxsId");

var $50N0M = parcelRequire("50N0M");

var $8jOUp = parcelRequire("8jOUp");

var $huYam = parcelRequire("huYam");

var $dCKuP = parcelRequire("dCKuP");

var $8omzy = parcelRequire("8omzy");
function $e3effbf54ffa2e23$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $dCKuP.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $8jOUp.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($dq5Zt.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($bxsId.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $a5Mzo.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$huYam.iterator] === 'function') {
        var iterator = result[$huYam.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$8omzy.observable] === 'function') {
        var obs = result[$8omzy.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $dCKuP.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $50N0M.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$e3effbf54ffa2e23$export$d0604af3321cfb1b = $e3effbf54ffa2e23$var$subscribeToResult;

});
parcelRegister("dCKuP", function(module, exports) {
"use strict";
var $9eb2e42b7dce71a2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9eb2e42b7dce71a2$var$InnerSubscriber = function(_super) {
    $9eb2e42b7dce71a2$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($66gCN.Subscriber);
module.exports.InnerSubscriber = $9eb2e42b7dce71a2$var$InnerSubscriber;

});


parcelRegister("2L5Gq", function(module, exports) {
"use strict";
var $2024612726a690c0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2024612726a690c0$var$OuterSubscriber = function(_super) {
    $2024612726a690c0$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($66gCN.Subscriber);
module.exports.OuterSubscriber = $2024612726a690c0$var$OuterSubscriber;

});



parcelRegister("fKQIh", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $3ba23d8fa19058dd$export$9ab6bef3838698f8);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $9rSmK = parcelRequire("9rSmK");
const $3ba23d8fa19058dd$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return (0, $9rSmK.getObservableFromFile)(file, options, callbacks);
};

});
parcelRegister("9rSmK", function(module, exports) {
$parcel$export(module.exports, "getObservableFromFile", () => $9846f2243d3c6516$export$88e80b3a0bb31f63);

var $iwjU4 = parcelRequire("iwjU4");

var $aUfUg = parcelRequire("aUfUg");

var $3gIhm = parcelRequire("3gIhm");

var $h4te9 = parcelRequire("h4te9");

var $9y2UG = parcelRequire("9y2UG");

var $g6dte = parcelRequire("g6dte");

var $a0tnP = parcelRequire("a0tnP");

var $5MA2W = parcelRequire("5MA2W");

var $5kEH7 = parcelRequire("5kEH7");

var $7MkE9 = parcelRequire("7MkE9");
const $9846f2243d3c6516$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $aUfUg.fromPromise)((0, $g6dte.fetchBlob)(file)).pipe((0, $h4te9.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $5kEH7.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $a0tnP.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $7MkE9.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $9y2UG.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $5MA2W.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $h4te9.concatMap)((batchedChunks)=>{
            return (0, $iwjU4.from)(batchedChunks);
        }), (0, $3gIhm.bufferCount)(totalChunks));
    }));

});
parcelRegister("aUfUg", function(module, exports) {
$parcel$export(module.exports, "fromPromise", () => $7f0b790f48d84151$export$60f45028237c39d1, (v) => $7f0b790f48d84151$export$60f45028237c39d1 = v);
var $7f0b790f48d84151$export$60f45028237c39d1;
"use strict";

var $2Tk1a = parcelRequire("2Tk1a");
$7f0b790f48d84151$export$60f45028237c39d1 = $2Tk1a.PromiseObservable.create;

});

parcelRegister("3gIhm", function(module, exports) {
"use strict";
var $261536a2c4f5a920$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $261536a2c4f5a920$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $261536a2c4f5a920$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $261536a2c4f5a920$var$bufferCount;
var $261536a2c4f5a920$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $261536a2c4f5a920$var$BufferCountSubscriber;
        else this.subscriberClass = $261536a2c4f5a920$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $261536a2c4f5a920$var$BufferCountSubscriber = function(_super) {
    $261536a2c4f5a920$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($66gCN.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $261536a2c4f5a920$var$BufferSkipCountSubscriber = function(_super) {
    $261536a2c4f5a920$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($66gCN.Subscriber);

});

parcelRegister("9y2UG", function(module, exports) {
"use strict";
var $6f398c8f629d947a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $6f398c8f629d947a$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $6f398c8f629d947a$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $6f398c8f629d947a$var$tap;
var $6f398c8f629d947a$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6f398c8f629d947a$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6f398c8f629d947a$var$DoSubscriber = function(_super) {
    $6f398c8f629d947a$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $66gCN.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($66gCN.Subscriber);

});

parcelRegister("g6dte", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $4e58adf45125d1f4$export$14e9cfd4a872cc1e);
async function $4e58adf45125d1f4$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}

});

parcelRegister("a0tnP", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $17aaae0ff67fe78a$export$d5f5a550a38ec367);

var $EjF96 = parcelRequire("EjF96");

var $dOJXB = parcelRequire("dOJXB");
const $17aaae0ff67fe78a$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $EjF96.asyncMap)((0, $dOJXB.blobToHashedBlob)(hasher), concurrency)(blobs$);

});
parcelRegister("EjF96", function(module, exports) {
$parcel$export(module.exports, "asyncMap", () => $0cff3d8160c27692$export$707ee4c4c95d39e3);

var $8jOUp = parcelRequire("8jOUp");

var $jcL4C = parcelRequire("jcL4C");
const $0cff3d8160c27692$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $0cff3d8160c27692$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $8jOUp.Observable)((sub)=>{
            notifiers.push($0cff3d8160c27692$var$notify(project(value), sub, onReady));
        });
};
const $0cff3d8160c27692$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $jcL4C.mergeMap)($0cff3d8160c27692$var$mapper(project), concurrent);

});

parcelRegister("dOJXB", function(module, exports) {
$parcel$export(module.exports, "blobToHashedBlob", () => $9d526621ab23efdf$export$28a452a485721473);
const $9d526621ab23efdf$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));

});


parcelRegister("5MA2W", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $8b0d8a318f5dfdb7$export$2f21790600302ed);

var $3gIhm = parcelRequire("3gIhm");

var $h4te9 = parcelRequire("h4te9");
const $8b0d8a318f5dfdb7$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $3gIhm.bufferCount)(options.batchSize)).pipe((0, $h4te9.concatMap)(process));
};

});

parcelRegister("5kEH7", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $6243405a2db552eb$export$5b92d769f2f57509);

var $jZJNg = parcelRequire("jZJNg");

var $bP9Wc = parcelRequire("bP9Wc");
const $6243405a2db552eb$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $jZJNg.range)(0, totalChunks).pipe((0, $bP9Wc.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});
parcelRegister("jZJNg", function(module, exports) {
$parcel$export(module.exports, "range", () => $e8e73c75f7e991de$export$d02631cccf789723, (v) => $e8e73c75f7e991de$export$d02631cccf789723 = v);
var $e8e73c75f7e991de$export$d02631cccf789723;
"use strict";

var $hp6WX = parcelRequire("hp6WX");
$e8e73c75f7e991de$export$d02631cccf789723 = $hp6WX.RangeObservable.create;

});
parcelRegister("hp6WX", function(module, exports) {
"use strict";
var $caba298f3b3d873c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $caba298f3b3d873c$var$RangeObservable = function(_super) {
    $caba298f3b3d873c$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($8jOUp.Observable);
module.exports.RangeObservable = $caba298f3b3d873c$var$RangeObservable;

});



parcelRegister("7MkE9", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $77a5121c0288ea84$export$94ce0f3fcf999415);

var $EjF96 = parcelRequire("EjF96");
const $77a5121c0288ea84$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $EjF96.asyncMap)(upload, options.concurrency));
};

});



parcelRegister("ahbtk", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $672f4c629baa6f06$export$14b114effbc08b6b);

var $cL66s = parcelRequire("cL66s");
let $672f4c629baa6f06$var$hasher = null;
let $672f4c629baa6f06$var$sha256Hasher = null;
const $672f4c629baa6f06$export$d9c9d11cd648a505 = ()=>{
    $672f4c629baa6f06$var$hasher = null;
    $672f4c629baa6f06$var$sha256Hasher = null;
};


const $672f4c629baa6f06$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $cL66s.ChunkHashAlgorithm).Sha256) {
            if (!$672f4c629baa6f06$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("aCRoC"));
                $672f4c629baa6f06$var$sha256Hasher = new SimpleHasher();
            }
            return $672f4c629baa6f06$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("hiFq9"));
    $672f4c629baa6f06$var$hasher = new SimpleHasher();
    return $672f4c629baa6f06$var$hasher;
};

});
parcelRegister("aCRoC", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bEToq").then(()=>parcelRequire('3duHc'));

});

parcelRegister("hiFq9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fe9LF"),
    $kOunM("kuhHl")
]).then(()=>parcelRequire('4ItDT'));

});


parcelRegister("9Su0W", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $f2a7cab02209e5d4$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $f2a7cab02209e5d4$export$71f452e02035c1e2);

var $6k8oQ = parcelRequire("6k8oQ");

var $hkEHH = parcelRequire("hkEHH");
const $f2a7cab02209e5d4$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $f2a7cab02209e5d4$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $6k8oQ.MAX_UPLOAD_FILE_SIZE)) throw new Error($f2a7cab02209e5d4$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $hkEHH.DATA_UNIT).GB) return 5 * (0, $hkEHH.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $hkEHH.DATA_UNIT).GB && fileSize <= 50 * (0, $hkEHH.DATA_UNIT).GB) return 50 * (0, $hkEHH.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $hkEHH.DATA_UNIT).GB && fileSize <= 0.95 * (0, $hkEHH.DATA_UNIT).TB) return 100 * (0, $hkEHH.DATA_UNIT).MB;
    return 210 * (0, $hkEHH.DATA_UNIT).MB;
};

});

parcelRegister("lTOKG", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $58e08bbd50c96064$export$515240c3f059c807);

var $hXxYI = parcelRequire("hXxYI");
class $58e08bbd50c96064$export$515240c3f059c807 extends (0, $hXxYI.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}

});


parcelRegister("l6scP", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $6795727126d06928$export$ed17558b11b88056);
const $6795727126d06928$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("hZw9e", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $96ba5dd81a2c6395$export$57945b6819e39246);

var $5muzC = parcelRequire("5muzC");

var $hEbiH = parcelRequire("hEbiH");
const $96ba5dd81a2c6395$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $96ba5dd81a2c6395$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $hEbiH.getRandomTelemetryId)(),
                spanId: (0, $hEbiH.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            var _items$find;
            return (_items$find = items.find((item)=>item.id === id && item.collection === collectionName)) === null || _items$find === void 0 ? void 0 : _items$find.error;
        });
    };
}
function $96ba5dd81a2c6395$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($5muzC)))($96ba5dd81a2c6395$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $96ba5dd81a2c6395$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});
parcelRegister("5muzC", function(module, exports) {

var $4eGW1 = parcelRequire("4eGW1");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3e76b916521bd028$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3e76b916521bd028$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3e76b916521bd028$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3e76b916521bd028$var$getValidCacheKeyFn(options);
        this._cacheMap = $3e76b916521bd028$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $3e76b916521bd028$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $3e76b916521bd028$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$3e76b916521bd028$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3e76b916521bd028$var$enqueuePostPromiseJob = typeof $4eGW1 === 'object' && typeof $4eGW1.nextTick === 'function' ? function(fn) {
    if (!$3e76b916521bd028$var$resolvedPromise) $3e76b916521bd028$var$resolvedPromise = Promise.resolve();
    $3e76b916521bd028$var$resolvedPromise.then(function() {
        $4eGW1.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $3e76b916521bd028$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3e76b916521bd028$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $3e76b916521bd028$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3e76b916521bd028$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3e76b916521bd028$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $3e76b916521bd028$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3e76b916521bd028$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3e76b916521bd028$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3e76b916521bd028$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $3e76b916521bd028$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3e76b916521bd028$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3e76b916521bd028$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3e76b916521bd028$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3e76b916521bd028$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3e76b916521bd028$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3e76b916521bd028$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3e76b916521bd028$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3e76b916521bd028$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $3e76b916521bd028$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $3e76b916521bd028$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3e76b916521bd028$var$DataLoader;

});

parcelRegister("hEbiH", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $e3c3793641154023$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $e3c3793641154023$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $e3c3793641154023$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $e3c3793641154023$export$2e36de8639bad0ad);
const $e3c3793641154023$export$fce6876652108ab = (value)=>value === undefined;
const $e3c3793641154023$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $e3c3793641154023$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $e3c3793641154023$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $e3c3793641154023$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $e3c3793641154023$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $e3c3793641154023$export$456b25e3a9b4a843(byte) {
    var _window;
    let randomHex;
    if ((_window = window) !== null && _window !== void 0 && _window.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $e3c3793641154023$var$getRandomHexValues(byte);
    }
    else randomHex = $e3c3793641154023$var$getRandomHexValues(byte);
    return randomHex;
}
function $e3c3793641154023$export$2e36de8639bad0ad() {
    return $e3c3793641154023$export$456b25e3a9b4a843(8);
}

});


parcelRegister("e4QoN", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $3d40ea01642181f3$export$ae188fee39529b82);

var $5muzC = parcelRequire("5muzC");

var $gfX8H = parcelRequire("gfX8H");

var $234Hr = parcelRequire("234Hr");
function $3d40ea01642181f3$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($5muzC)))((0, $gfX8H.createBatchLoadingFunc)(mediaStore), {
        maxBatchSize: (0, $234Hr.MAX_BATCH_SIZE)
    });
}

});
parcelRegister("gfX8H", function(module, exports) {
$parcel$export(module.exports, "createBatchLoadingFunc", () => $f94deb406ecf208d$export$4a53beb129e8c49a);

var $hEbiH = parcelRequire("hEbiH");

var $2DYBp = parcelRequire("2DYBp");
function $f94deb406ecf208d$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $hEbiH.getRandomTelemetryId)(),
                spanId: (0, $hEbiH.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return (0, $2DYBp.getItemsFromKeys)(keys, items);
    };
}

});
parcelRegister("2DYBp", function(module, exports) {
$parcel$export(module.exports, "getItemsFromKeys", () => $adfa8cbec6b9c0fc$export$71cd2e8f8162d47b);
const $adfa8cbec6b9c0fc$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $adfa8cbec6b9c0fc$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $adfa8cbec6b9c0fc$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $adfa8cbec6b9c0fc$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $adfa8cbec6b9c0fc$var$makeCacheKey(id, collection);
        if ($adfa8cbec6b9c0fc$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($adfa8cbec6b9c0fc$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $adfa8cbec6b9c0fc$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};

});


parcelRegister("234Hr", function(module, exports) {
$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $383124bcc05983a6$export$b79d95ee17a87a);
const $383124bcc05983a6$export$b79d95ee17a87a = 100;

});


parcelRegister("jnEsw", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $4fda558eaeb86b7d$export$bc76d51553fa5e35);

var $9nelC = parcelRequire("9nelC");
function $4fda558eaeb86b7d$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $9nelC.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});
parcelRegister("9nelC", function(module, exports) {
"use strict";
var $6d3164355de0a2c5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $8k954 = parcelRequire("8k954");

var $aAAtt = parcelRequire("aAAtt");

var $2fC9E = parcelRequire("2fC9E");

var $b9gng = parcelRequire("b9gng");

var $6k90u = parcelRequire("6k90u");
/**
 * @class ReplaySubject<T>
 */ var $6d3164355de0a2c5$var$ReplaySubject = function(_super) {
    $6d3164355de0a2c5$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $6d3164355de0a2c5$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $aAAtt.Subscription.EMPTY;
        else if (this.isStopped) subscription = $aAAtt.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $6k90u.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $2fC9E.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $8k954.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($gJqoA.Subject);
module.exports.ReplaySubject = $6d3164355de0a2c5$var$ReplaySubject;
var $6d3164355de0a2c5$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRegister("gJqoA", function(module, exports) {
"use strict";
var $c2e552ec400f842b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $66gCN = parcelRequire("66gCN");

var $aAAtt = parcelRequire("aAAtt");

var $b9gng = parcelRequire("b9gng");

var $6k90u = parcelRequire("6k90u");

var $1HBFJ = parcelRequire("1HBFJ");
/**
 * @class SubjectSubscriber<T>
 */ var $c2e552ec400f842b$var$SubjectSubscriber = function(_super) {
    $c2e552ec400f842b$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($66gCN.Subscriber);
module.exports.SubjectSubscriber = $c2e552ec400f842b$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $c2e552ec400f842b$var$Subject = function(_super) {
    $c2e552ec400f842b$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$1HBFJ.rxSubscriber] = function() {
        return new $c2e552ec400f842b$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $c2e552ec400f842b$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $aAAtt.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $aAAtt.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $6k90u.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $8jOUp.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $c2e552ec400f842b$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($8jOUp.Observable);
module.exports.Subject = $c2e552ec400f842b$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $c2e552ec400f842b$var$AnonymousSubject = function(_super) {
    $c2e552ec400f842b$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $aAAtt.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($c2e552ec400f842b$var$Subject);
module.exports.AnonymousSubject = $c2e552ec400f842b$var$AnonymousSubject;

});
parcelRegister("b9gng", function(module, exports) {
"use strict";
var $81dd3c8cd0ea3e57$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $81dd3c8cd0ea3e57$var$ObjectUnsubscribedError = function(_super) {
    $81dd3c8cd0ea3e57$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $81dd3c8cd0ea3e57$var$ObjectUnsubscribedError;

});

parcelRegister("6k90u", function(module, exports) {
"use strict";
var $49ab98ebfba31e1e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aAAtt = parcelRequire("aAAtt");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $49ab98ebfba31e1e$var$SubjectSubscription = function(_super) {
    $49ab98ebfba31e1e$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($aAAtt.Subscription);
module.exports.SubjectSubscription = $49ab98ebfba31e1e$var$SubjectSubscription;

});


parcelRegister("8k954", function(module, exports) {
$parcel$export(module.exports, "queue", () => $60f73c3906abf5c9$export$4f7fa46ff53e516f, (v) => $60f73c3906abf5c9$export$4f7fa46ff53e516f = v);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $60f73c3906abf5c9$export$4f7fa46ff53e516f;
"use strict";

var $dDX8C = parcelRequire("dDX8C");

var $7yvXL = parcelRequire("7yvXL");
$60f73c3906abf5c9$export$4f7fa46ff53e516f = new $7yvXL.QueueScheduler($dDX8C.QueueAction);

});
parcelRegister("dDX8C", function(module, exports) {
"use strict";
var $9eecca79e8f8761d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1GOJd = parcelRequire("1GOJd");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9eecca79e8f8761d$var$QueueAction = function(_super) {
    $9eecca79e8f8761d$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($1GOJd.AsyncAction);
module.exports.QueueAction = $9eecca79e8f8761d$var$QueueAction;

});
parcelRegister("1GOJd", function(module, exports) {
"use strict";
var $13b1104305377288$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a5Mzo = parcelRequire("a5Mzo");

var $jeZWR = parcelRequire("jeZWR");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $13b1104305377288$var$AsyncAction = function(_super) {
    $13b1104305377288$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $a5Mzo.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $a5Mzo.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($jeZWR.Action);
module.exports.AsyncAction = $13b1104305377288$var$AsyncAction;

});
parcelRegister("jeZWR", function(module, exports) {
"use strict";
var $e01f60cd0b0dc571$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aAAtt = parcelRequire("aAAtt");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $e01f60cd0b0dc571$var$Action = function(_super) {
    $e01f60cd0b0dc571$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($aAAtt.Subscription);
module.exports.Action = $e01f60cd0b0dc571$var$Action;

});



parcelRegister("7yvXL", function(module, exports) {
"use strict";
var $5804808f03c4085a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5aY3c = parcelRequire("5aY3c");
var $5804808f03c4085a$var$QueueScheduler = function(_super) {
    $5804808f03c4085a$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($5aY3c.AsyncScheduler);
module.exports.QueueScheduler = $5804808f03c4085a$var$QueueScheduler;

});
parcelRegister("5aY3c", function(module, exports) {
"use strict";
var $3c4c77b577c99deb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3EgZx = parcelRequire("3EgZx");
var $3c4c77b577c99deb$var$AsyncScheduler = function(_super) {
    $3c4c77b577c99deb$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($3EgZx.Scheduler);
module.exports.AsyncScheduler = $3c4c77b577c99deb$var$AsyncScheduler;

});
parcelRegister("3EgZx", function(module, exports) {
$parcel$export(module.exports, "Scheduler", () => $2a8249b6888c7002$export$d3e54bb8584cda7c, (v) => $2a8249b6888c7002$export$d3e54bb8584cda7c = v);
var $2a8249b6888c7002$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $2a8249b6888c7002$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$2a8249b6888c7002$export$d3e54bb8584cda7c = $2a8249b6888c7002$var$Scheduler;

});






parcelRegister("lp9vn", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $f3fa7c4e44074e9d$export$728192ce8dd94659);
const $f3fa7c4e44074e9d$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $f3fa7c4e44074e9d$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $f3fa7c4e44074e9d$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("jNsur", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $df761dce98b97ebc$export$71797c284d89a3e1);

var $h0tIn = parcelRequire("h0tIn");

var $7HLnn = parcelRequire("7HLnn");
const $df761dce98b97ebc$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $h0tIn.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $7HLnn.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("h0tIn", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $35a6c87278fd09c6$export$a1c3205f28a20414);
const $35a6c87278fd09c6$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("7HLnn", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $3ee2c254038cf4b3$export$62aabd5ff85d0451);
const $3ee2c254038cf4b3$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("h4ea8", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $443e81a9658edbf2$export$ac3214931ffd82af);

var $gph1Q = parcelRequire("gph1Q");
const $443e81a9658edbf2$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $gph1Q.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});

parcelRegister("2iQUH", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $705c2cff2fe152f9$export$4b2432e2d8723823);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
function $705c2cff2fe152f9$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}

});

parcelRegister("l7t1O", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $31542008a00b9eca$export$4dbaaf6c79705e6c);

var $aAAtt = parcelRequire("aAAtt");
const $31542008a00b9eca$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aAAtt.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("3cWar", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $3f6b6d51c555e386$export$89097c0ec1e0dee1);

var $9lreT = parcelRequire("9lreT");
const $3f6b6d51c555e386$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $9lreT.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("avVvB", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $5e7bb9f7a95093ec$export$4c54d536f8e37dc2);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lMBbD = parcelRequire("lMBbD");

const $5e7bb9f7a95093ec$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $5e7bb9f7a95093ec$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$5e7bb9f7a95093ec$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $lMBbD.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $lMBbD.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("lMBbD", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $dfac9e0ff7597f86$export$c3748c310e92340a);

var $hXxYI = parcelRequire("hXxYI");
class $dfac9e0ff7597f86$export$c3748c310e92340a extends (0, $hXxYI.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}

});


parcelRegister("30AWv", function(module, exports) {
$parcel$export(module.exports, "defaultShouldRetryError", () => $acd8de9729a2f46b$export$fee2242cbb339663);

var $1q4Jv = parcelRequire("1q4Jv");

var $BgNeO = parcelRequire("BgNeO");
const $acd8de9729a2f46b$export$fee2242cbb339663 = (err)=>{
    const statusCode = (0, $1q4Jv.getStatusCode)(err);
    return (0, $BgNeO.isFetchNetworkError)(err) || (statusCode ? statusCode >= 500 : false);
};

});
parcelRegister("1q4Jv", function(module, exports) {
$parcel$export(module.exports, "getStatusCode", () => $a9e5fdcc17088c49$export$68868794c9b58e55);

var $fhaKE = parcelRequire("fhaKE");
const $a9e5fdcc17088c49$export$68868794c9b58e55 = (error)=>{
    var _error$metadata;
    return (0, $fhaKE.isRequestError)(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.statusCode) && error.metadata.statusCode;
};

});
parcelRegister("fhaKE", function(module, exports) {
$parcel$export(module.exports, "isRequestError", () => $833e0d9b7fb50977$export$3717b1ffef4428ea);

var $5s06H = parcelRequire("5s06H");
function $833e0d9b7fb50977$export$3717b1ffef4428ea(err) {
    return err instanceof (0, $5s06H.RequestError);
}

});
parcelRegister("5s06H", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $07d53b34873dd934$export$43ee7d0e4f429743);

var $hXxYI = parcelRequire("hXxYI");
class $07d53b34873dd934$export$43ee7d0e4f429743 extends (0, $hXxYI.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}

});



parcelRegister("BgNeO", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $3e2cd9a67bc636e3$export$ad8c5cf7dd4c3caf);
// fetch throws TypeError for network errors
function $3e2cd9a67bc636e3$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}

});


parcelRegister("l3OfC", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $4f5ad4c5a64e146e$export$2ccdd6f9a9eba6a);

var $8pXuy = parcelRequire("8pXuy");

var $9fGCC = parcelRequire("9fGCC");

var $7HLnn = parcelRequire("7HLnn");
async function $4f5ad4c5a64e146e$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $8pXuy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $9fGCC.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $7HLnn.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("2gvlV", function(module, exports) {
$parcel$export(module.exports, "MEDIA_API_REGION", () => $35176fb78ac18c41$export$ae7fb0ee64408016);
$parcel$export(module.exports, "MEDIA_API_ENVIRONMENT", () => $35176fb78ac18c41$export$2e3b0a8a2a2bf81c);
$parcel$export(module.exports, "MediaStore", () => $35176fb78ac18c41$export$572b8a2a9fd7cbba);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cL66s = parcelRequire("cL66s");

var $bkfCH = parcelRequire("bkfCH");

var $gdUUy = parcelRequire("gdUUy");

var $6k8oQ = parcelRequire("6k8oQ");

var $1XHYQ = parcelRequire("1XHYQ");

var $gEOh9 = parcelRequire("gEOh9");

var $IOtar = parcelRequire("IOtar");

var $jEIN2 = parcelRequire("jEIN2");

var $60OI6 = parcelRequire("60OI6");

var $hjnbk = parcelRequire("hjnbk");

var $fhaKE = parcelRequire("fhaKE");
var $cQsDn = parcelRequire("cQsDn");

var $im7UC = parcelRequire("im7UC");

var $7ZYwt = parcelRequire("7ZYwt");

var $89rWN = parcelRequire("89rWN");

var $30AWv = parcelRequire("30AWv");

var $1bHZQ = parcelRequire("1bHZQ");

var $1hmeR = parcelRequire("1hmeR");

var $eXFkC = parcelRequire("eXFkC");

var $kOXif = parcelRequire("kOXif");

var $gWb3t = parcelRequire("gWb3t");

var $l9Scc = parcelRequire("l9Scc");

var $2IKNO = parcelRequire("2IKNO");

var $hZjio = parcelRequire("hZjio");

var $2NgHh = parcelRequire("2NgHh");



const $35176fb78ac18c41$export$ae7fb0ee64408016 = 'media-api-region';
const $35176fb78ac18c41$export$2e3b0a8a2a2bf81c = 'media-api-environment';
class $35176fb78ac18c41$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $6k8oQ.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $1bHZQ.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $cQsDn.request)(artifactUrl, options, abortController).then((0, $im7UC.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $2IKNO.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hZjio.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $cL66s.ChunkHashAlgorithm).Sha256;
    }
    async getClientId(collectionName) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return $35176fb78ac18c41$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
    }
    getClientIdSync() {
        try {
            const auth = this.resolveInitialAuth();
            return $35176fb78ac18c41$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
        } catch  {
            // initialAuth may not be available, return undefined
            return undefined;
        }
    }
    static extractClientIdFromAuth(auth) {
        if ((0, $bkfCH.isClientBasedAuth)(auth)) return auth.clientId;
        // decode JWT token and get clientId (or iss) from payload
        try {
            const jwtPayload = (0, $kOXif.decodeJwtToken)(auth.token);
            return jwtPayload.clientId;
        } catch  {
        // leave clientId as undefined
        }
        return undefined;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const headers = {
            ...(0, $l9Scc.jsonHeaders)
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $gdUUy.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', requestOptions).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const headers = {
            ...(0, $l9Scc.jsonHeaders)
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $gdUUy.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', requestOptions).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params, seededCdnUrl) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params, seededCdnUrl);
    }
    createFileImageURL(id, auth, params, seededCdnUrl) {
        const wmv = (0, $gdUUy.fg)('confluence_watermark_admin_ui') ? (0, $1hmeR.getWatermarkVersionFromToken)(auth.token) : undefined;
        const options = {
            params: {
                ...(0, $gWb3t.extendImageParams)(params),
                ...wmv ? {
                    wmv: wmv
                } : {}
            },
            auth: auth
        };
        const imageEndpoint = (0, $eXFkC.cdnFeatureFlag)('image');
        if (seededCdnUrl && (0, $gEOh9.isCDNEnabled)()) return (0, $hjnbk.mapToSeedBasedCdnUrl)(seededCdnUrl, options.params);
        if ((0, $IOtar.isPathBasedEnabled)()) return (0, $60OI6.mapToPathBasedUrl)((0, $89rWN.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $jEIN2.mapToMediaCdnUrl)((0, $89rWN.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $6k8oQ.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = (0, $eXFkC.cdnFeatureFlag)('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $im7UC.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $6k8oQ.FILE_CACHE_MAX_AGE), name) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge,
                ...name ? {
                    name: name
                } : {}
            },
            auth: auth
        };
        const binaryEndpoint = (0, $eXFkC.cdnFeatureFlag)('binary');
        if ((0, $IOtar.isPathBasedEnabled)()) return (0, $60OI6.mapToPathBasedUrl)((0, $89rWN.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $jEIN2.mapToMediaCdnUrl)((0, $89rWN.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $6k8oQ.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
    	const cdnUrl = artifacts[artifactName]?.cdnUrl;
    	if (cdnUrl) {
    		return cdnUrl;
    	}
    } */ const artifactUrl = (0, $1XHYQ.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $jEIN2.mapToMediaCdnUrl)((0, $89rWN.createUrl)(`${auth.baseUrl}${artifactUrl}`, options), auth.token);
        if ((0, $IOtar.isPathBasedEnabled)()) return (0, $60OI6.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = (0, $eXFkC.cdnFeatureFlag)('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        let wmvParams = {};
        let authOptions = {
            authContext: {
                collectionName: params && params.collection
            }
        };
        if ((0, $gdUUy.fg)('confluence_watermark_admin_ui')) {
            const auth = await this.resolveAuth(authOptions.authContext);
            const wmv = (0, $1hmeR.getWatermarkVersionFromToken)(auth.token);
            if (wmv) wmvParams = {
                wmv: wmv
            };
            authOptions = {
                resolvedAuth: auth
            };
        }
        const options = {
            ...metadata,
            ...authOptions,
            params: {
                ...(0, $gWb3t.extendImageParams)(params, fetchMaxRes),
                ...wmvParams
            },
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $im7UC.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: (0, $l9Scc.jsonHeaders),
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? (0, $eXFkC.cdnFeatureFlag)('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $6k8oQ.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? (0, $eXFkC.cdnFeatureFlag)('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $6k8oQ.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $im7UC.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext, options) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const headers = {
            ...(0, $l9Scc.jsonHeaders)
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $gdUUy.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, requestOptions);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: // Contains collection name to write to
            params,
            // Contains collection name to write to
            headers: (0, $l9Scc.jsonHeaders),
            body: JSON.stringify(body),
            traceContext: // Contains collection name to read from
            traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext, clientId) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: (0, $l9Scc.jsonHeaders),
            body: JSON.stringify({
                id: id,
                clientId: clientId
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>{
                        var _err$metadata;
                        return (0, $30AWv.defaultShouldRetryError)(err) || (0, $fhaKE.isRequestError)(err) && (err === null || err === void 0 || (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode) === 401;
                    }
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $7ZYwt.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: (0, $l9Scc.jsonHeaders),
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $bkfCH.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $1bHZQ.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $jEIN2.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $IOtar.isPathBasedEnabled)()) url = (0, $60OI6.mapToPathBasedUrl)(url);
        const response = await (0, $cQsDn.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        (0, $2NgHh.setKeyValueInSessionStorage)($35176fb78ac18c41$export$ae7fb0ee64408016, response.headers.get('x-media-region'));
        (0, $2NgHh.setKeyValueInSessionStorage)($35176fb78ac18c41$export$2e3b0a8a2a2bf81c, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $cQsDn.request)(url, {
            method: 'HEAD',
            traceContext: (0, $1bHZQ.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}

});
parcelRegister("bkfCH", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $69ee0dbc479fa2c8$export$6ba49fcac9c46e54);
function $69ee0dbc479fa2c8$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}

});

parcelRegister("1XHYQ", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $694b4efaa5115f75$export$1cc24defa44e7f84);

var $gEOh9 = parcelRequire("gEOh9");
const $694b4efaa5115f75$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    var _artifacts$prop, _artifacts$prop3;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $gEOh9.isCDNEnabled)() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
        var _artifacts$prop2;
        return `${(_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url}/cdn`;
    }
    return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};

});
parcelRegister("gEOh9", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $6b57b1e340a168cf$export$3e47d0e609e44278);

var $hzYXZ = parcelRequire("hzYXZ");

var $7190A = parcelRequire("7190A");

var $aZESv = parcelRequire("aZESv");

var $gdUUy = parcelRequire("gdUUy");

var $35iLI = parcelRequire("35iLI");

var $IOtar = parcelRequire("IOtar");
function $6b57b1e340a168cf$export$3e47d0e609e44278() {
    return (0, $35iLI.isCommercial)() && !(0, $7190A.isIsolatedCloud)() && !((0, $hzYXZ.isGoogleCloudPlatform)() || (0, $aZESv.isGCPtenant)()) && (0, $gdUUy.fg)('platform_media_cdn_delivery') && !(0, $IOtar.isPathBasedEnabled)();
}

});
parcelRegister("aZESv", function(module, exports) {
$parcel$export(module.exports, "isGCPtenant", () => $f514086d2592e755$export$1e98abd71682b665);
/**
 * Returns true if the current hostname matches the GCP tenant pattern.
 * GCP tenants follow the pattern: <name>-cdp-<cdp-id>.jira-dev.com
 *
 * CDN (CloudFront) is an AWS service and is not available on GCP tenants.
 * This function is used to gate CDN delivery, mirroring the isIsolatedCloud() pattern.
 *
 * @deprecated This is a staging-only hostname heuristic and should not be used for
 * new code. Prefer `isGoogleCloudPlatform()` from `@atlaskit/atlassian-context/cloud-provider`
 * (cookie/SSR-based) to detect GCP tenants. This helper is retained only as a fallback for
 * staging tenants, which do not reliably have a proper value for the
 * `Bifrost-Atl-Ctx-Cloud-Service-Provider` cookie.
 *
 * @param hostname - Optional hostname override (defaults to globalThis.location?.hostname). Used for testing.
 */ function $f514086d2592e755$export$1e98abd71682b665(hostname) {
    var _location;
    const host = hostname ?? (typeof globalThis !== 'undefined' ? (_location = globalThis.location) === null || _location === void 0 ? void 0 : _location.hostname : undefined);
    if (!host) return false;
    const gcpTenantPattern = /^.*-cdp-\w+\.jira-dev\.com$/;
    return gcpTenantPattern.test(host);
}

});

parcelRegister("35iLI", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $6f8861f99cb4eb0a$export$df69ff6733e73e50);
function $6f8861f99cb4eb0a$export$df69ff6733e73e50() {
    var _global$location;
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !((_global$location = global.location) !== null && _global$location !== void 0 && (_global$location = _global$location.hostname) !== null && _global$location !== void 0 && _global$location.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/));
}

});

parcelRegister("IOtar", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $a7be93d8138bb260$export$6de3392754e98e65);

var $gdUUy = parcelRequire("gdUUy");

var $7tR45 = parcelRequire("7tR45");
function $a7be93d8138bb260$export$6de3392754e98e65() {
    var _getDocument;
    const isLocalhost = ((_getDocument = (0, $7tR45.default)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
    return (0, $gdUUy.fg)('platform_media_path_based_route') && !isLocalhost;
}

});
parcelRegister("7tR45", function(module, exports) {
$parcel$export(module.exports, "default", () => $c055d448159648d1$export$2e2bcd8739ae039);
var $c055d448159648d1$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("jEIN2", function(module, exports) {
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $37c58a7bdbf68e78$export$fb88a576cf28364d);

var $hzYXZ = parcelRequire("hzYXZ");

var $aZESv = parcelRequire("aZESv");

var $gdUUy = parcelRequire("gdUUy");

var $gEOh9 = parcelRequire("gEOh9");

var $d2Ejs = parcelRequire("d2Ejs");
function $37c58a7bdbf68e78$export$fb88a576cf28364d(url, token) {
    const tokenLength = (token === null || token === void 0 ? void 0 : token.length) ?? 0;
    if (!(0, $gEOh9.isCDNEnabled)() || tokenLength > (0, $d2Ejs.MEDIA_TOKEN_LENGTH_LIMIT)) return url;
    const isGcpTenant = (0, $hzYXZ.isGoogleCloudPlatform)() || (0, $aZESv.isGCPtenant)();
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!isGcpTenant && (0, $gdUUy.fg)('platform_media_cdn_delivery') && (0, $gdUUy.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = (0, $d2Ejs.MEDIA_CDN_MAP)[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("d2Ejs", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CDN_MAP", () => $0bf6fc213598e399$export$8a9b6ab3569a543a);
$parcel$export(module.exports, "MEDIA_TOKEN_LENGTH_LIMIT", () => $0bf6fc213598e399$export$9c6324050210f959);

var $gEOh9 = parcelRequire("gEOh9");
const $0bf6fc213598e399$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
const $0bf6fc213598e399$export$9c6324050210f959 = 7000;

});


parcelRegister("60OI6", function(module, exports) {
$parcel$export(module.exports, "mapToPathBasedUrl", () => $d5a4127a4a152678$export$774e2add1fbe26aa);

var $7tR45 = parcelRequire("7tR45");

var $IOtar = parcelRequire("IOtar");

var $bofOT = parcelRequire("bofOT");
function $d5a4127a4a152678$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $d5a4127a4a152678$export$774e2add1fbe26aa(url) {
    if ((0, $IOtar.isPathBasedEnabled)()) {
        var _getDocument;
        const parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith((0, $bofOT.mediaApiPathPrefix))) parsedUrl.pathname = `${0, $bofOT.mediaApiPathPrefix}${parsedUrl.pathname}`;
        const location = (_getDocument = (0, $7tR45.default)()) === null || _getDocument === void 0 ? void 0 : _getDocument.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $d5a4127a4a152678$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}

});
parcelRegister("bofOT", function(module, exports) {
$parcel$export(module.exports, "mediaApiPathPrefix", () => $b2ce5cd3b42b6bd0$export$401b0a9ee44eb977);
const $b2ce5cd3b42b6bd0$export$401b0a9ee44eb977 = '/media-api';

});


parcelRegister("hjnbk", function(module, exports) {
$parcel$export(module.exports, "mapToSeedBasedCdnUrl", () => $5d5f848307eb8e49$export$6a61eda13a74de3b);
const $5d5f848307eb8e49$var$IMAGE_PARAM_KEYS = new Set([
    'width',
    'height',
    'mode',
    'allowAnimated',
    'upscale',
    'version',
    'max-age'
]);
const $5d5f848307eb8e49$export$6a61eda13a74de3b = (seededCdnUrl, params)=>{
    const insert = Object.entries(params ?? {}).filter(([key, value])=>value != null && $5d5f848307eb8e49$var$IMAGE_PARAM_KEYS.has(key)).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`).join('&');
    if (!insert) return seededCdnUrl;
    const wm = seededCdnUrl.search(/[?&]wm-ari=/);
    if (wm !== -1) {
        const separator = seededCdnUrl[wm];
        return `${seededCdnUrl.slice(0, wm)}${separator}${insert}&${seededCdnUrl.slice(wm + 1)}`;
    }
    return `${seededCdnUrl}${seededCdnUrl.includes('?') ? '&' : '?'}${insert}`;
};

});

parcelRegister("cQsDn", function(module, exports) {
$parcel$export(module.exports, "request", () => $13c952c84ab90212$export$b5fe3f66a567bec0);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5s06H = parcelRequire("5s06H");

var $fhaKE = parcelRequire("fhaKE");



var $gdUUy = parcelRequire("gdUUy");

var $aPbqo = parcelRequire("aPbqo");

var $9iefD = parcelRequire("9iefD");

var $kkKGc = parcelRequire("kkKGc");

var $89rWN = parcelRequire("89rWN");

var $30AWv = parcelRequire("30AWv");

var $6yCeQ = parcelRequire("6yCeQ");

var $8y4NU = parcelRequire("8y4NU");

var $BgNeO = parcelRequire("BgNeO");
async function $13c952c84ab90212$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $89rWN.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $6yCeQ.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $kkKGc.createProcessFetchResponse)(metadata));
    if ((0, $gdUUy.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            var _getNavigator;
            if ((0, $BgNeO.isFetchNetworkError)(err) && (_getNavigator = (0, $aPbqo.default)()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) return false;
            return (0, $30AWv.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $8y4NU.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            var _getNavigator2;
            if ((0, $BgNeO.isFetchNetworkError)(error) && (_getNavigator2 = (0, $aPbqo.default)()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $89rWN.createUrl)((0, $9iefD.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $6yCeQ.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $kkKGc.createProcessFetchResponse)(metadata));
                return (0, $8y4NU.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $8y4NU.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("aPbqo", function(module, exports) {
$parcel$export(module.exports, "default", () => $64cbce462d64509a$export$2e2bcd8739ae039);
var $64cbce462d64509a$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});

parcelRegister("9iefD", function(module, exports) {
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $27613bf2747a03c1$export$e71b0af0000b3cfa);

var $7tR45 = parcelRequire("7tR45");

var $bofOT = parcelRequire("bofOT");
function $27613bf2747a03c1$export$e71b0af0000b3cfa(url) {
    var _getDocument;
    const parsedUrl = new URL(url);
    parsedUrl.host = ((_getDocument = (0, $7tR45.default)()) === null || _getDocument === void 0 ? void 0 : _getDocument.location.host) ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith((0, $bofOT.mediaApiPathPrefix))) parsedUrl.pathname = `${0, $bofOT.mediaApiPathPrefix}${parsedUrl.pathname}`;
    return parsedUrl;
}

});

parcelRegister("kkKGc", function(module, exports) {
$parcel$export(module.exports, "createProcessFetchResponse", () => $3622fac491b21cae$export$6e2e477edb7d6032);

var $5xULz = parcelRequire("5xULz");
function $3622fac491b21cae$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = (0, $5xULz.createRequestErrorFromResponse)(metadata, response);
        throw requestError;
    };
}

});
parcelRegister("5xULz", function(module, exports) {
$parcel$export(module.exports, "createRequestErrorFromResponse", () => $975f69e5654883d9$export$d171f49f6b4ddc33);

var $53Kr6 = parcelRequire("53Kr6");

var $bWRoe = parcelRequire("bWRoe");

var $5s06H = parcelRequire("5s06H");
function $975f69e5654883d9$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = (0, $53Kr6.createRequestErrorReason)(statusCode);
    return new (0, $5s06H.RequestError)(reason, {
        ...metadata,
        ...(0, $bWRoe.extractMediaHeaders)(response),
        statusCode: statusCode
    });
}

});
parcelRegister("53Kr6", function(module, exports) {
$parcel$export(module.exports, "createRequestErrorReason", () => $68cbee941f923ca9$export$6397609af718d008);
function $68cbee941f923ca9$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}

});

parcelRegister("bWRoe", function(module, exports) {
$parcel$export(module.exports, "extractMediaHeaders", () => $0cf7c3c078076563$export$ea175c0c5497224);
function $0cf7c3c078076563$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});



parcelRegister("89rWN", function(module, exports) {
$parcel$export(module.exports, "createUrl", () => $577f52cbcf8ca8ca$export$7138c24907de3954);

var $5Dgmi = parcelRequire("5Dgmi");
function $577f52cbcf8ca8ca$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth === null || auth === void 0 ? void 0 : auth.baseUrl);
    const authParams = auth && (0, $5Dgmi.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}

});
parcelRegister("5Dgmi", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $ccbac96c42643102$export$6833b130611df767);

var $bkfCH = parcelRequire("bkfCH");
function $ccbac96c42643102$export$6833b130611df767(auth) {
    if ((0, $bkfCH.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("6yCeQ", function(module, exports) {
$parcel$export(module.exports, "extendHeaders", () => $bb8a0bbe33cb3cb5$export$18cfbabc415d771c);

var $ekroL = parcelRequire("ekroL");

var $ee3xw = parcelRequire("ee3xw");
const $bb8a0bbe33cb3cb5$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [(0, $ekroL.ZipkinHeaderKeys).traceId]: traceContext.traceId,
        [(0, $ekroL.ZipkinHeaderKeys).spanId]: traceContext.spanId
    } : {};
};
function $bb8a0bbe33cb3cb5$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...(0, $ee3xw.mapAuthToRequestHeaders)(auth),
        ...$bb8a0bbe33cb3cb5$var$mapTraceIdToRequestHeaders(traceContext)
    };
}

});
parcelRegister("ekroL", function(module, exports) {
$parcel$export(module.exports, "ZipkinHeaderKeys", () => $4db6232b01df1657$export$922566b90d0535ce);
$parcel$export(module.exports, "DEFAULT_RETRY_OPTIONS", () => $4db6232b01df1657$export$c65cfa70960d8fe5);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

















const $4db6232b01df1657$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $4db6232b01df1657$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};

});

parcelRegister("ee3xw", function(module, exports) {
$parcel$export(module.exports, "mapAuthToRequestHeaders", () => $cf3eb6d12df1a4fb$export$eaf4479116d2f925);

var $bkfCH = parcelRequire("bkfCH");
function $cf3eb6d12df1a4fb$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $bkfCH.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}

});


parcelRegister("8y4NU", function(module, exports) {
$parcel$export(module.exports, "fetchRetry", () => $ad18ece70be9aad0$export$782df2acbe10b22c);

var $4SBx5 = parcelRequire("4SBx5");

var $30AWv = parcelRequire("30AWv");

var $ekroL = parcelRequire("ekroL");

var $k0kkO = parcelRequire("k0kkO");

var $fhaKE = parcelRequire("fhaKE");

var $5s06H = parcelRequire("5s06H");

var $lEHPp = parcelRequire("lEHPp");
async function $ad18ece70be9aad0$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...(0, $ekroL.DEFAULT_RETRY_OPTIONS),
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = (0, $30AWv.defaultShouldRetryError) } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await (0, $lEHPp.waitPromise)(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ((0, $k0kkO.isAbortedRequestError)(err)) throw new (0, $5s06H.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $fhaKE.isRequestError)(lastError)) throw (0, $4SBx5.cloneRequestError)(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $5s06H.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}

});
parcelRegister("4SBx5", function(module, exports) {
$parcel$export(module.exports, "cloneRequestError", () => $9400581d2cfc6db7$export$359f19ca51f9eba1);

var $5s06H = parcelRequire("5s06H");
function $9400581d2cfc6db7$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $5s06H.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}

});

parcelRegister("k0kkO", function(module, exports) {
$parcel$export(module.exports, "isAbortedRequestError", () => $bdaf8400c7edb1c5$export$de0b576cf7ce4a53);
function $bdaf8400c7edb1c5$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}

});

parcelRegister("lEHPp", function(module, exports) {
$parcel$export(module.exports, "waitPromise", () => $712250824a3fcb55$export$80c51ea1e89203dd);
function $712250824a3fcb55$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}

});



parcelRegister("im7UC", function(module, exports) {
$parcel$export(module.exports, "createMapResponseToBlob", () => $c16cc623a9766a21$export$5cc7b0795397da86);

var $bWRoe = parcelRequire("bWRoe");

var $5s06H = parcelRequire("5s06H");
function $c16cc623a9766a21$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $5s06H.RequestError)('serverInvalidBody', {
                ...metadata,
                ...(0, $bWRoe.extractMediaHeaders)(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}

});

parcelRegister("7ZYwt", function(module, exports) {
$parcel$export(module.exports, "createMapResponseToJson", () => $496e1764f65abd95$export$e0519b126b73efa6);

var $bWRoe = parcelRequire("bWRoe");

var $5s06H = parcelRequire("5s06H");
function $496e1764f65abd95$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $5s06H.RequestError)('serverInvalidBody', {
                ...metadata,
                ...(0, $bWRoe.extractMediaHeaders)(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}

});

parcelRegister("1bHZQ", function(module, exports) {
$parcel$export(module.exports, "extendTraceContext", () => $cf1c9441121d37cb$export$ee24a95986dfd173);

var $hEbiH = parcelRequire("hEbiH");
const $cf1c9441121d37cb$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $hEbiH.getRandomTelemetryId)()
    } : undefined;

});

parcelRegister("1hmeR", function(module, exports) {
$parcel$export(module.exports, "getWatermarkVersionFromToken", () => $8305c51d82d971ff$export$5296269cf74e58e);
function $8305c51d82d971ff$export$5296269cf74e58e(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return undefined;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        const watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch  {
        return undefined;
    }
}

});

parcelRegister("eXFkC", function(module, exports) {
$parcel$export(module.exports, "cdnFeatureFlag", () => $cccd671b3b40df40$export$fca9c48f5ff2eb1a);

var $gEOh9 = parcelRequire("gEOh9");
const $cccd671b3b40df40$export$fca9c48f5ff2eb1a = (endpoint)=>{
    let result = endpoint;
    if ((0, $gEOh9.isCDNEnabled)()) result += '/cdn';
    return result;
};

});

parcelRegister("kOXif", function(module, exports) {
$parcel$export(module.exports, "decodeJwtToken", () => $53e4ed142cda77a7$export$a8b71bcb3b2f6325);
const $53e4ed142cda77a7$export$a8b71bcb3b2f6325 = (token)=>{
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};

});

parcelRegister("gWb3t", function(module, exports) {
$parcel$export(module.exports, "extendImageParams", () => $34c1cdbed070d73a$export$1f6f5681971a5e73);

var $6k8oQ = parcelRequire("6k8oQ");
const $34c1cdbed070d73a$export$1f6f5681971a5e73 = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': (params === null || params === void 0 ? void 0 : params['max-age']) ?? (0, $6k8oQ.FILE_CACHE_MAX_AGE),
        allowAnimated: (params === null || params === void 0 ? void 0 : params.allowAnimated) ?? true,
        mode: (params === null || params === void 0 ? void 0 : params.mode) ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $6k8oQ.MAX_RESOLUTION),
            height: (0, $6k8oQ.MAX_RESOLUTION)
        } : {}
    };
};

});

parcelRegister("l9Scc", function(module, exports) {
$parcel$export(module.exports, "jsonHeaders", () => $4110d59873c61a05$export$dd23d116120d45cc);
const $4110d59873c61a05$export$dd23d116120d45cc = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};

});

parcelRegister("2IKNO", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $fb94b6ebe9612f84$export$4b4cec3dcdfce972);

var $gdUUy = parcelRequire("gdUUy");

var $bdBRx = parcelRequire("bdBRx");

var $fs8c1 = parcelRequire("fs8c1");

var $hfh1Z = parcelRequire("hfh1Z");
const $fb94b6ebe9612f84$export$560085fe411c0660 = 10000;
const $fb94b6ebe9612f84$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $fb94b6ebe9612f84$export$560085fe411c0660)=>{
    const startTime = performance.now();
    let eventEmitted = false;
    // Feature flag: wrap authProvider with analytics event emission
    const authProviderPromise = (0, $gdUUy.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then((result)=>{
        const durationMs = performance.now() - startTime;
        if (!eventEmitted) {
            eventEmitted = true;
            (0, $bdBRx.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext
            });
        } else {
            // Timeout already fired - auth arrived too late
            const timeoutError = new (0, $hfh1Z.MediaStoreError)('authProviderTimedOut');
            (0, $bdBRx.globalMediaEventEmitter).emit('auth-provider-failed', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext,
                error: timeoutError
            });
        }
        return result;
    }).catch((error)=>{
        const durationMs = performance.now() - startTime;
        eventEmitted = true;
        (0, $bdBRx.globalMediaEventEmitter).emit('auth-provider-failed', {
            durationMs: durationMs,
            timeoutMs: authProviderTimeout,
            authContext: authContext,
            error: error
        });
        throw error;
    }) : authProvider(authContext); // Original behavior when FG off
    let auth;
    try {
        auth = await Promise.race([
            authProviderPromise,
            (0, $fs8c1.rejectTimeout)(authProviderTimeout, new (0, $hfh1Z.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
        if (!eventEmitted && (0, $gdUUy.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
        // PRESERVE ORIGINAL ERROR HANDLING
        if (err instanceof (0, $hfh1Z.MediaStoreError)) throw err;
        throw new (0, $hfh1Z.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $hfh1Z.MediaStoreError)('emptyAuth');
    /*
  Only client-based auth carries a clientId. Fail fast when it is present but empty, instead of
  letting the request reach dt-auth and get rejected with `Client id "" is invalid`.
   */ if ('clientId' in auth && !auth.clientId && (0, $gdUUy.fg)('platform_media_validate_client_id')) throw new (0, $hfh1Z.MediaStoreError)('emptyClientId');
    /*
     We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
     Token expiration check in the frontend is a bad idea. Don't do it!
     More info:
     https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
     https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
   */ return auth;
};

});
parcelRegister("fs8c1", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $6eafd045c02009f1$export$cf2d2a1124beacb2);
const $6eafd045c02009f1$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});

parcelRegister("hfh1Z", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $03a0f226171bd356$export$b78480bd311630bc);

var $hXxYI = parcelRequire("hXxYI");
class $03a0f226171bd356$export$b78480bd311630bc extends (0, $hXxYI.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}

});


parcelRegister("hZjio", function(module, exports) {
$parcel$export(module.exports, "resolveInitialAuth", () => $b76271bb129a57e4$export$5211e1371264aec3);

var $hfh1Z = parcelRequire("hfh1Z");
const $b76271bb129a57e4$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $hfh1Z.MediaStoreError)('missingInitialAuth');
    return auth;
};

});

parcelRegister("2NgHh", function(module, exports) {
$parcel$export(module.exports, "setKeyValueInSessionStorage", () => $868ce5761fca7732$export$be4c63de2c8c945);
const $868ce5761fca7732$export$be4c63de2c8c945 = (key, value)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (!value || !(window && window.sessionStorage)) return;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.sessionStorage.setItem(key, value);
};

});


parcelRegister("6Pqir", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $b5b0151aa5724a10$export$e3e60f0dab8641de);

var $hXxYI = parcelRequire("hXxYI");
class $b5b0151aa5724a10$export$e3e60f0dab8641de extends (0, $hXxYI.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}

});


parcelRegister("bQ9uH", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $c57f17044c5bf725$export$c66ca190f89caaac);
class $c57f17044c5bf725$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("ivwwl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dBlKs").then(()=>parcelRequire('3Moge'));

});



parcelRegister("35T7J", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $821848ae4d233c5f$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $821848ae4d233c5f$export$5bff351c86f56d97);

var $bSJIT = parcelRequire("bSJIT");

var $83J3A = parcelRequire("83J3A");
const $821848ae4d233c5f$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(undefined);
const $821848ae4d233c5f$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $bSJIT.useMemo)(()=>(0, $83J3A.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($821848ae4d233c5f$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};

});


parcelRegister("ftW9p", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $964c6e8de79c0fb3$export$4eaebdef02112fe4);

var $bSJIT = parcelRequire("bSJIT");

var $5k1f2 = parcelRequire("5k1f2");
var $dX7O8 = parcelRequire("dX7O8");

var $2MOOQ = parcelRequire("2MOOQ");

var $fvY2O = parcelRequire("fvY2O");

var $46b54 = parcelRequire("46b54");

var $gEOh9 = parcelRequire("gEOh9");

var $8pXuy = parcelRequire("8pXuy");

var $gdUUy = parcelRequire("gdUUy");

var $83k1Z = parcelRequire("83k1Z");

var $ggiqQ = parcelRequire("ggiqQ");

var $cTuC6 = parcelRequire("cTuC6");

var $a6Jes = parcelRequire("a6Jes");

var $29CSm = parcelRequire("29CSm");

var $hp1v8 = parcelRequire("hp1v8");

var $eKJoa = parcelRequire("eKJoa");

var $8VZ1g = parcelRequire("8VZ1g");

var $gtXaM = parcelRequire("gtXaM");

var $fj6zl = parcelRequire("fj6zl");

var $l508r = parcelRequire("l508r");

var $4nmTH = parcelRequire("4nmTH");

var $40cEI = parcelRequire("40cEI");

var $jplZ4 = parcelRequire("jplZ4");

var $jJnAw = parcelRequire("jJnAw");

var $cYq5l = parcelRequire("cYq5l");

var $iYUxs = parcelRequire("iYUxs");

var $fa85A = parcelRequire("fa85A");

var $bUrBx = parcelRequire("bUrBx");

var $1YqrL = parcelRequire("1YqrL");

var $j3OIw = parcelRequire("j3OIw");

var $bv8lI = parcelRequire("bv8lI");
// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $964c6e8de79c0fb3$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $964c6e8de79c0fb3$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source, initialFileState: initialFileState })=>{
    const mediaClient = (0, $46b54.useMediaClient)();
    const [status, setStatus] = (0, $bSJIT.useState)('loading');
    const [error, setError] = (0, $bSJIT.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $bSJIT.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $bSJIT.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $bSJIT.useState)('not-resolved');
    const ssrReliabilityRef = (0, $bSJIT.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $83k1Z.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (isLoading) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $bSJIT.useMemo)(()=>dimensions ? (0, $cTuC6.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $bv8lI.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $hp1v8.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $iYUxs.getSSRData)(identifier, resizeMode);
            if (ssrData !== null && ssrData !== void 0 && ssrData.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!(ssrData !== null && ssrData !== void 0 && ssrData.dataURI)) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    // When the relay/SSR-seed path provided a full pre-signed CDN asset
                    // URL, pass it through to getImageUrlSync as the base. That inserts
                    // the client's image-transform params before &wm-ari and preserves
                    // the backend's v2 CDN path, CloudFront signature and watermark
                    // anchors that a rebuilt /file/{id}/image/cdn URL cannot reproduce.
                    const seededCdnUrl = initialFileState && initialFileState.status !== 'error' ? initialFileState.previewCdnUrl : undefined;
                    // Only use the seeded CDN URL when CDN delivery is actually in use.
                    // isCDNEnabled() is false for path-based routing (and for isolated
                    // cloud / GCP), where the signed media-cdn URL is not served — there
                    // getImageUrlSync must build the URL on the product's own /media-api
                    // host instead.
                    const ssrSeededCdnUrl = seededCdnUrl && (0, $gEOh9.isCDNEnabled)() && (0, $gdUUy.fg)('platform_media_ssr_data_seed') ? seededCdnUrl : undefined;
                    return (0, $gtXaM.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs, ssrSeededCdnUrl);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $29CSm.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $bSJIT.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $fvY2O.useFileState)(identifier.id, {
        initialFileState: initialFileState,
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $5k1f2.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && (fileState === null || fileState === void 0 ? void 0 : fileState.status) !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $bSJIT.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $j3OIw.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $j3OIw.MediaFilePreviewError)('metadata-fetch', (0, $dX7O8.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $bSJIT.useEffect)(()=>{
        var _getSSRData;
        if (!(0, $gdUUy.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (_getSSRData = (0, $iYUxs.getSSRData)(identifier, resizeMode)) === null || _getSSRData === void 0 ? void 0 : _getSSRData.loadPromise;
        if (preview && (0, $40cEI.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $bv8lI.useCurrentValueRef)(()=>{
        return (0, $8VZ1g.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $bSJIT.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $bUrBx.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $bv8lI.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $bSJIT.useEffect)(()=>{
        const cachedPreview = (0, $hp1v8.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $bUrBx.isBigger)(cachedPreview === null || cachedPreview === void 0 ? void 0 : cachedPreview.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $jJnAw.isSupportedLocalPreview)(mediaType) && (0, $8pXuy.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $eKJoa.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $bUrBx.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $jplZ4.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview && (0, $jplZ4.isSSRPreview)(preview) && !(0, $1YqrL.isWider)(preview.dimensions, dimensions) && (0, $gdUUy.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $a6Jes.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $bSJIT.useEffect)(()=>{
        (0, $hp1v8.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $hp1v8.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $bSJIT.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $4nmTH.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $ggiqQ.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $40cEI.isSSRDataPreview)(failedPreview) || (0, $4nmTH.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $ggiqQ.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $ggiqQ.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
        const isLocal = (0, $fj6zl.isLocalPreview)(failedPreview);
        const isRemote = (0, $l508r.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $fa85A.ImageLoadError)(failedPreview === null || failedPreview === void 0 ? void 0 : failedPreview.source);
            (0, $hp1v8.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview === null || preview === void 0 ? void 0 : preview.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $bSJIT.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $4nmTH.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $40cEI.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if ((newPreview === null || newPreview === void 0 ? void 0 : newPreview.dataURI) !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
    }, [
        preview === null || preview === void 0 ? void 0 : preview.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>{
        var _ssrReliabilityRef$cu;
        return (0, $cYq5l.generateScriptProps)(identifier, preview === null || preview === void 0 ? void 0 : preview.dataURI, resizeMode, preview === null || preview === void 0 ? void 0 : preview.srcSet, requestDimensions, ((_ssrReliabilityRef$cu = ssrReliabilityRef.current.server) === null || _ssrReliabilityRef$cu === void 0 ? void 0 : _ssrReliabilityRef$cu.status) === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $gdUUy.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $gdUUy.fg)('media-perf-lazy-loading-optimisation')
        });
    } : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $2MOOQ.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $gdUUy.fg)('media-perf-uplift-mutation-fix') ? $964c6e8de79c0fb3$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("5k1f2", function(module, exports) {
$parcel$export(module.exports, "isImageRepresentationReady", () => $15873392e887c154$export$4e33ccde53b4f0bf);
const $15873392e887c154$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};

});

parcelRegister("dX7O8", function(module, exports) {
$parcel$export(module.exports, "toCommonMediaClientError", () => $0cfc1177a6c6bb54$export$a5db89cfc88eff9);

var $efYiC = parcelRequire("efYiC");
const $0cfc1177a6c6bb54$export$a5db89cfc88eff9 = (errorFileState)=>{
    var _errorFileState$detai;
    const error = (_errorFileState$detai = errorFileState.details) === null || _errorFileState$detai === void 0 ? void 0 : _errorFileState$detai.error;
    return new (0, $efYiC.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown-reason', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
};

});

parcelRegister("2MOOQ", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $33801ce94d123a8e$export$46fd859414de9d62);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $gdUUy = parcelRequire("gdUUy");

var $46b54 = parcelRequire("46b54");

var $cSQQy = parcelRequire("cSQQy");

var $2vhiM = parcelRequire("2vhiM");

var $egKvF = parcelRequire("egKvF");
function $33801ce94d123a8e$var$useCurrentValueRef(value) {
    const ref = (0, $bSJIT.useRef)(value);
    ref.current = value;
    return ref;
}
const $33801ce94d123a8e$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $46b54.useMediaClient)();
    const innerRef = (0, $bSJIT.useRef)(null);
    const clientIdRef = (0, $bSJIT.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $33801ce94d123a8e$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $2vhiM.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $cSQQy.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $bSJIT.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $gdUUy.fg)('platform_media_cross_client_copy')) elem === null || elem === void 0 || elem.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $bSJIT.useCallback)((event)=>{
        var _getSelection;
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && ((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.containsNode(currentCopyTarget, true));
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth')) {
                var _event$clipboardData;
                const clientId = clientIdRef.current;
                const html = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId) {
                    var _event$clipboardData2;
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId}"$2`);
                    (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 || _event$clipboardData2.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $gdUUy.fg)('platform_media_cross_client_copy')) {
            var _getDocument;
            (_getDocument = (0, $egKvF.getDocument)()) === null || _getDocument === void 0 || _getDocument.addEventListener('copy', onGlobalCopy);
        }
        return ()=>{
            var _getDocument2;
            return (_getDocument2 = (0, $egKvF.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.removeEventListener('copy', onGlobalCopy);
        };
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("46b54", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $8336f59edf9e212a$export$8b3e87ea56c3a345);

var $bSJIT = parcelRequire("bSJIT");

var $35T7J = parcelRequire("35T7J");

var $bu3n5 = parcelRequire("bu3n5");
const $8336f59edf9e212a$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $35T7J.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $bu3n5.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("bu3n5", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $d0e0411fc9152803$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $d0e0411fc9152803$export$57164260bc1f1218);

var $bSJIT = parcelRequire("bSJIT");

var $83J3A = parcelRequire("83J3A");

var $9At6j = parcelRequire("9At6j");
const $d0e0411fc9152803$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(undefined);
const $d0e0411fc9152803$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $bSJIT.useMemo)(()=>(0, $83J3A.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $9At6j.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d0e0411fc9152803$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};

});
parcelRegister("9At6j", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $4272507be00d46ac$export$d54af28440a5efc0);

var $bSJIT = parcelRequire("bSJIT");

var $4yzwI = parcelRequire("4yzwI");
const $4272507be00d46ac$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $bSJIT.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4yzwI.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4yzwI", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $8dd332c0a0ca1e00$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $8dd332c0a0ca1e00$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $8dd332c0a0ca1e00$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($8dd332c0a0ca1e00$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $8dd332c0a0ca1e00$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $8dd332c0a0ca1e00$export$2d23ed2854ac1650 = $8dd332c0a0ca1e00$export$7e209e67b965bc63($8dd332c0a0ca1e00$var$defaultUserPreferences);

});




parcelRegister("cSQQy", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $eeab59849204383b$export$3ab52330b662b987);

var $fhaKE = parcelRequire("fhaKE");
const $eeab59849204383b$var$getRequestErrorDetails = (err)=>{
    if ((0, $fhaKE.isRequestError)(err)) {
        var _err$metadata, _err$metadata2, _err$metadata3, _err$metadata4;
        return {
            request: {
                statusCode: (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode,
                traceContext: (_err$metadata2 = err.metadata) === null || _err$metadata2 === void 0 ? void 0 : _err$metadata2.traceContext,
                mediaEnv: (_err$metadata3 = err.metadata) === null || _err$metadata3 === void 0 ? void 0 : _err$metadata3.mediaEnv,
                mediaRegion: (_err$metadata4 = err.metadata) === null || _err$metadata4 === void 0 ? void 0 : _err$metadata4.mediaRegion
            }
        };
    }
    return undefined;
};
const $eeab59849204383b$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $fhaKE.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$eeab59849204383b$var$getRequestErrorDetails(error)
        }
    };
};

});

parcelRegister("2vhiM", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $0d36e6b0c1632511$export$aacb463551da2e8f);
const $0d36e6b0c1632511$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("egKvF", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $1a0f95668929842f$export$f65ca476c09acec0);
const $1a0f95668929842f$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("fvY2O", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $6e4aecb00d9252cc$export$90ff537b0999afb);

var $bSJIT = parcelRequire("bSJIT");

var $46b54 = parcelRequire("46b54");

var $xNLmi = parcelRequire("xNLmi");
function $6e4aecb00d9252cc$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const mediaClient = (0, $46b54.useMediaClient)();
    const fileState = (0, $xNLmi.useMediaStore)((state)=>state.files[id]);
    // Capture initialFileState as a ref so it's a stable one-time SSR seed that
    // doesn't affect the useEffect dependency array. Including it directly would
    // cause repeated unsubscribe/resubscribe cycles whenever the caller passes a
    // new (unstabilized) object reference — each cycle fires getFileState before
    // the store is populated.
    const initialFileStateRef = (0, $bSJIT.useRef)(initialFileState);
    (0, $bSJIT.useEffect)(()=>{
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            initialFileState: initialFileStateRef.current,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState ?? initialFileState
    };
}

});
parcelRegister("xNLmi", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $d5269e3185d28642$export$8a9cc8c330400af8);

var $44Cch = parcelRequire("44Cch");

var $46b54 = parcelRequire("46b54");
const $d5269e3185d28642$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $44Cch.useStore)(store, selector, equals);
function $d5269e3185d28642$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $46b54.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5269e3185d28642$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("44Cch", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $2f752a463bce7402$export$6ccbb43953eebf8);

var $66zU2 = parcelRequire("66zU2");

var $bSJIT = parcelRequire("bSJIT");

var $9yiJm = parcelRequire("9yiJm");
var $2f752a463bce7402$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $2f752a463bce7402$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT)));
const { useSyncExternalStoreWithSelector: $2f752a463bce7402$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($9yiJm)));
let $2f752a463bce7402$var$didWarnAboutEqualityFn = false;
const $2f752a463bce7402$var$identity = (arg)=>arg;
function $2f752a463bce7402$export$6ccbb43953eebf8(api, selector = $2f752a463bce7402$var$identity, equalityFn) {
    if (($2f752a463bce7402$import_meta.env ? $2f752a463bce7402$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$2f752a463bce7402$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $2f752a463bce7402$var$didWarnAboutEqualityFn = true;
    }
    const slice = $2f752a463bce7402$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $2f752a463bce7402$var$useDebugValue(slice);
    return slice;
}
const $2f752a463bce7402$var$createImpl = (createState)=>{
    if (($2f752a463bce7402$import_meta.env ? $2f752a463bce7402$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $66zU2.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$2f752a463bce7402$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $2f752a463bce7402$export$185802fd694ee1f5 = (createState)=>createState ? $2f752a463bce7402$var$createImpl(createState) : $2f752a463bce7402$var$createImpl;
var $2f752a463bce7402$export$2e2bcd8739ae039 = (createState)=>{
    if (($2f752a463bce7402$import_meta.env ? $2f752a463bce7402$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $2f752a463bce7402$export$185802fd694ee1f5(createState);
};

});
parcelRegister("9yiJm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kM0tD"));

});
parcelRegister("kM0tD", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $f1f8a90ae738fd31$export$bf730a2d8bf68b42, (v) => $f1f8a90ae738fd31$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f1f8a90ae738fd31$export$bf730a2d8bf68b42;
"use strict";

var $bSJIT = parcelRequire("bSJIT");

var $jl5L8 = parcelRequire("jl5L8");
function $f1f8a90ae738fd31$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f1f8a90ae738fd31$var$objectIs = "function" === typeof Object.is ? Object.is : $f1f8a90ae738fd31$var$is, $f1f8a90ae738fd31$var$useSyncExternalStore = $jl5L8.useSyncExternalStore, $f1f8a90ae738fd31$var$useRef = $bSJIT.useRef, $f1f8a90ae738fd31$var$useEffect = $bSJIT.useEffect, $f1f8a90ae738fd31$var$useMemo = $bSJIT.useMemo, $f1f8a90ae738fd31$var$useDebugValue = $bSJIT.useDebugValue;
$f1f8a90ae738fd31$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $f1f8a90ae738fd31$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $f1f8a90ae738fd31$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($f1f8a90ae738fd31$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $f1f8a90ae738fd31$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $f1f8a90ae738fd31$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $f1f8a90ae738fd31$var$useDebugValue(value);
    return value;
};

});





parcelRegister("ggiqQ", function(module, exports) {
$parcel$export(module.exports, "createFailedSSRObject", () => $d494e5f6f44e82ab$export$768c370ed0dbaeb3);

var $29CSm = parcelRequire("29CSm");

var $fa85A = parcelRequire("fa85A");
const $d494e5f6f44e82ab$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...(0, $29CSm.extractErrorInfo)(new (0, $fa85A.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("29CSm", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $021562b7a765c268$export$74aaf4784c2edb2c);

var $hvPnY = parcelRequire("hvPnY");

var $dun0Q = parcelRequire("dun0Q");

var $6SCrp = parcelRequire("6SCrp");

var $do47Y = parcelRequire("do47Y");
const $021562b7a765c268$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: (0, $do47Y.getRenderErrorFailReason)(error),
        error: (0, $6SCrp.getRenderErrorErrorReason)(error),
        errorDetail: (0, $dun0Q.getRenderErrorErrorDetail)(error),
        metadataTraceContext: metadataTraceContext ?? (0, $hvPnY.getErrorTraceContext)(error)
    };
};

});
parcelRegister("hvPnY", function(module, exports) {
$parcel$export(module.exports, "getErrorTraceContext", () => $da083a315ceca955$export$29aa614726672b2e);

var $39N5R = parcelRequire("39N5R");
const $da083a315ceca955$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $39N5R.isCommonMediaClientError)(secondaryError)) {
        var _secondaryError$metad;
        return (_secondaryError$metad = secondaryError.metadata) === null || _secondaryError$metad === void 0 ? void 0 : _secondaryError$metad.traceContext;
    }
};

});

parcelRegister("dun0Q", function(module, exports) {
$parcel$export(module.exports, "getRenderErrorErrorDetail", () => $a64f3c27a59d4480$export$9ccc5365d056da4b);

var $39N5R = parcelRequire("39N5R");
const $a64f3c27a59d4480$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $39N5R.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};

});

parcelRegister("6SCrp", function(module, exports) {
$parcel$export(module.exports, "getRenderErrorErrorReason", () => $18147cbc48df1cd2$export$88c61dcad53762da);

var $39N5R = parcelRequire("39N5R");
const $18147cbc48df1cd2$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $39N5R.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};

});

parcelRegister("do47Y", function(module, exports) {
$parcel$export(module.exports, "getRenderErrorFailReason", () => $080d456746e90702$export$4af9d71992e89714);
const $080d456746e90702$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};

});


parcelRegister("fa85A", function(module, exports) {
$parcel$export(module.exports, "ImageLoadError", () => $2fc163c03958d80a$export$d0a45ab59b4606b);

var $j3OIw = parcelRequire("j3OIw");
const $2fc163c03958d80a$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $2fc163c03958d80a$export$d0a45ab59b4606b extends (0, $j3OIw.MediaFilePreviewError) {
    constructor(source){
        super($2fc163c03958d80a$var$getImageLoadPrimaryReason(source));
    }
}

});
parcelRegister("j3OIw", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $e42bce3a31c59672$export$96e559194c287cf4);
class $e42bce3a31c59672$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});



parcelRegister("cTuC6", function(module, exports) {
$parcel$export(module.exports, "createRequestDimensions", () => $d90dd5787a527a4e$export$3063221e86a58f9);
/** Verifies if the current screen is retina display */ function $d90dd5787a527a4e$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $d90dd5787a527a4e$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $d90dd5787a527a4e$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};

});

parcelRegister("a6Jes", function(module, exports) {
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $4718874af3feef17$export$7156ce7b78b49bd7);

var $7q9Qr = parcelRequire("7q9Qr");

var $j3OIw = parcelRequire("j3OIw");
const $4718874af3feef17$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ((0, $7q9Qr.isMediaFilePreviewError)(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new (0, $j3OIw.MediaFilePreviewError)(primaryReason, error.secondaryError);
        return error;
    }
    return new (0, $j3OIw.MediaFilePreviewError)(primaryReason, error);
};

});
parcelRegister("7q9Qr", function(module, exports) {
$parcel$export(module.exports, "isMediaFilePreviewError", () => $47488e5f95317cf0$export$553696a6e769784c);

var $j3OIw = parcelRequire("j3OIw");
function $47488e5f95317cf0$export$553696a6e769784c(err) {
    return err instanceof (0, $j3OIw.MediaFilePreviewError);
}

});


parcelRegister("hp1v8", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $17b45d6adfb21202$export$b7e8ee3f7a41459);

var $1fbtB = parcelRequire("1fbtB");

var $459XQ = parcelRequire("459XQ");
const $17b45d6adfb21202$export$b7e8ee3f7a41459 = new (0, $1fbtB.CardPreviewCacheImpl)((0, $459XQ.createObjectURLCache)());

});
parcelRegister("1fbtB", function(module, exports) {
$parcel$export(module.exports, "CardPreviewCacheImpl", () => $aaa28f86b8cb56c5$export$7b50526c091bb915);

var $bOd2A = parcelRequire("bOd2A");
class $aaa28f86b8cb56c5$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = (0, $bOd2A.getCacheKey)(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = (0, $bOd2A.getCacheKey)(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = (0, $bOd2A.getCacheKey)(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = (0, $bOd2A.getCacheKey)(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = (0, $bOd2A.getCacheKey)(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}

});
parcelRegister("bOd2A", function(module, exports) {
$parcel$export(module.exports, "getCacheKey", () => $c5b4a6c977d0055a$export$611736262b635f8d);
const $c5b4a6c977d0055a$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};

});


parcelRegister("459XQ", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $0cf9d7a6264f0371$export$ba71be67d5c32535);

var $fqY9U = parcelRequire("fqY9U");

var $izdBN = parcelRequire("izdBN");
const $0cf9d7a6264f0371$export$ba71be67d5c32535 = ()=>new (0, $izdBN.ObjectURLCache)((0, $fqY9U.PREVIEW_CACHE_LRU_SIZE));

});
parcelRegister("fqY9U", function(module, exports) {
$parcel$export(module.exports, "PREVIEW_CACHE_LRU_SIZE", () => $399814f010b3d43b$export$36d0f9859761643d);
const $399814f010b3d43b$export$36d0f9859761643d = 50;

});

parcelRegister("izdBN", function(module, exports) {
$parcel$export(module.exports, "ObjectURLCache", () => $94ec174045406ee4$export$75d1c8c9ba1d0773);

var $5j6lg = parcelRequire("5j6lg");
/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * The oldest entry is kept if `shouldEvict` returns false.
 */ class $94ec174045406ee4$var$EvictionLRUCache extends (0, $5j6lg.LRUMap) {
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = options === null || options === void 0 ? void 0 : options.shouldEvict;
        this.onEvict = options === null || options === void 0 ? void 0 : options.onEvict;
    }
    shift() {
        const oldest = this.oldest;
        if (oldest && this.shouldEvict && !this.shouldEvict([
            oldest.key,
            oldest.value
        ])) return undefined;
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
}
class $94ec174045406ee4$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.activeRefs = new Map();
        this.cache = new $94ec174045406ee4$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = entry[1].dataURI.split('#')[0];
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = removed === null || removed === void 0 ? void 0 : removed.dataURI.split('#')[0];
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
}

});



parcelRegister("eKJoa", function(module, exports) {
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $d7dc8c99af778779$export$98e935d981c884d);

var $g32hK = parcelRequire("g32hK");

var $g1Vdg = parcelRequire("g1Vdg");

var $jKhZ1 = parcelRequire("jKhZ1");
const $d7dc8c99af778779$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $jKhZ1.getLocalPreview)(filePreview),
        (0, $g32hK.enrichAttrsWithClientId)(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return (0, $g1Vdg.extendAndCachePreview)(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};

});
parcelRegister("g32hK", function(module, exports) {
$parcel$export(module.exports, "enrichAttrsWithClientId", () => $a99cf396055e6d83$export$9c3033a429726afd);

var $gdUUy = parcelRequire("gdUUy");

var $3TRa5 = parcelRequire("3TRa5");
const $a99cf396055e6d83$export$9c3033a429726afd = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return (0, $3TRa5.mergeClientIdIntoAttrs)(clientId, id, mediaBlobUrlAttrs, collectionName);
};

});
parcelRegister("3TRa5", function(module, exports) {
$parcel$export(module.exports, "mergeClientIdIntoAttrs", () => $53f223a492711136$export$95365db502f725a1);
const $53f223a492711136$export$95365db502f725a1 = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};

});


parcelRegister("g1Vdg", function(module, exports) {
$parcel$export(module.exports, "extendAndCachePreview", () => $528042913e9794d9$export$f47ee10612bdcb19);

var $4O54o = parcelRequire("4O54o");

var $hp1v8 = parcelRequire("hp1v8");
const $528042913e9794d9$export$f47ee10612bdcb19 = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $4O54o.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $hp1v8.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};

});
parcelRegister("4O54o", function(module, exports) {
$parcel$export(module.exports, "addFileAttrsToUrl", () => $bcf1539e3fb75db8$export$e51a8146182600b8);

var $bNMrq = parcelRequire("bNMrq");

var $7FZfL = parcelRequire("7FZfL");
const $bcf1539e3fb75db8$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [(0, $7FZfL.mediaBlobUrlIdentifier)]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = (0, $bNMrq.objectToQueryString)(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});
parcelRegister("bNMrq", function(module, exports) {
$parcel$export(module.exports, "objectToQueryString", () => $2a8e4940c80fc6e6$export$89a7e74069fbb7af);
const $2a8e4940c80fc6e6$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};

});

parcelRegister("7FZfL", function(module, exports) {
$parcel$export(module.exports, "mediaBlobUrlIdentifier", () => $9ac3b538211ce022$export$dbe437e0902936cc);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 



const $9ac3b538211ce022$export$dbe437e0902936cc = 'media-blob-url';

});



parcelRegister("jKhZ1", function(module, exports) {
$parcel$export(module.exports, "getLocalPreview", () => $0eafa6992bba0615$export$3d6ed68e437b8c99);

var $gph1Q = parcelRequire("gph1Q");

var $jjRCr = parcelRequire("jjRCr");

var $3iPa6 = parcelRequire("3iPa6");

var $2LCmM = parcelRequire("2LCmM");
const $0eafa6992bba0615$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $jjRCr.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $3iPa6.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $0eafa6992bba0615$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $2LCmM.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $3iPa6.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $0eafa6992bba0615$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $3iPa6.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $gph1Q.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $0eafa6992bba0615$var$getImageLocalPreview(value);
            case 'video':
                return $0eafa6992bba0615$var$getVideoLocalPreview(value);
            default:
                throw new (0, $3iPa6.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $3iPa6.LocalPreviewError)('local-preview-unsupported');
};

});
parcelRegister("jjRCr", function(module, exports) {
$parcel$export(module.exports, "getOrientation", () => $02b319f0fca9e808$export$67689507e8404821);

var $74dOD = parcelRequire("74dOD");

var $iz65r = parcelRequire("iz65r");
const $02b319f0fca9e808$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[(0, $iz65r.SupportedImageMetaTag).Orientation]) {
        const tagValue = tags[(0, $iz65r.SupportedImageMetaTag).Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $iz65r.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $02b319f0fca9e808$export$67689507e8404821(file) {
    const tags = await (0, $74dOD.readImageMetaTags)(file);
    return $02b319f0fca9e808$var$getOrientationFromTags(tags);
}

});
parcelRegister("74dOD", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $0351e9a6d75d0661$export$41982b5c7acb23c4);

var $dTusv = parcelRequire("dTusv");

var $7hY70 = parcelRequire("7hY70");

var $ijWLW = parcelRequire("ijWLW");

var $iz65r = parcelRequire("iz65r");
async function $0351e9a6d75d0661$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $iz65r.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7hY70.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $ijWLW.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $iz65r.ImageType).JPEG) return await (0, $dTusv.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dTusv", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $45794134bba4d20a$export$556b2ccec62d7f2a);

var $iz65r = parcelRequire("iz65r");
const { XResolution: $45794134bba4d20a$var$XResolution, YResolution: $45794134bba4d20a$var$YResolution } = (0, $iz65r.SupportedImageMetaTag);
let $45794134bba4d20a$var$loadImage;

function $45794134bba4d20a$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$45794134bba4d20a$var$loadImage) {
            const module = await (parcelRequire("96E4n"));
            $45794134bba4d20a$var$loadImage = module.default || module;
        }
        $45794134bba4d20a$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $45794134bba4d20a$var$XResolution || key === $45794134bba4d20a$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("iz65r", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $f6c9b4e686c2413d$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $f6c9b4e686c2413d$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $f6c9b4e686c2413d$export$f6ea0c89fd7d156);
var $f6c9b4e686c2413d$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $f6c9b4e686c2413d$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $f6c9b4e686c2413d$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    // none
    'top-right': 2,
    // flip horizontal
    'bottom-right': 3,
    // rotate 180
    'bottom-left': 4,
    // flip vertical
    'left-top': 5,
    // transpose
    'right-top': 6,
    // rotate 90
    'right-bottom': 7,
    // transverse
    'left-bottom': 8 // rotate 270
};

});

parcelRegister("96E4n", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("f5XmE").then(()=>parcelRequire('f4Hkq'));

});


parcelRegister("7hY70", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $4b85038dc1effea6$export$5fb37736440fca6f);

var $h81E2 = parcelRequire("h81E2");

var $5POBk = parcelRequire("5POBk");
let $4b85038dc1effea6$var$pngChunksExtract;

async function $4b85038dc1effea6$export$5fb37736440fca6f(file) {
    if (!$4b85038dc1effea6$var$pngChunksExtract) {
        const module = await (parcelRequire("VbARn"));
        $4b85038dc1effea6$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $h81E2.fileToArrayBuffer)(file);
    const chunks = $4b85038dc1effea6$var$pngChunksExtract(buffer);
    return await (0, $5POBk.parsePNGChunks)(chunks);
}

});
parcelRegister("h81E2", function(module, exports) {
$parcel$export(module.exports, "fileToArrayBuffer", () => $052edb299f60ba67$export$956310555b96755a);
function $052edb299f60ba67$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}

});

parcelRegister("5POBk", function(module, exports) {
$parcel$export(module.exports, "parsePNGChunks", () => $c709c115679d5199$export$9185743fdd58ce45);
async function $c709c115679d5199$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
   * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
   * Order of every chunk is not guaranteed.
   * And both iTXt and pHYs are Ancillary chunks.
   */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
     * iTXt contains the useful XMP/XML string data of meta tags
     */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
     * Pixels per unit, X axis: 4 bytes (unsigned integer)
     * Pixels per unit, Y axis: 4 bytes (unsigned integer)
     * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
     */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});

parcelRegister("VbARn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("c7Z3B").then(()=>parcelRequire('2nevi'));

});


parcelRegister("ijWLW", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $36f74e15c5b1ad2f$export$55c3bc9841b19de2);
function $36f74e15c5b1ad2f$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});



parcelRegister("3iPa6", function(module, exports) {
$parcel$export(module.exports, "LocalPreviewError", () => $d342bb5d6a280f9c$export$2c035820a31723e);

var $j3OIw = parcelRequire("j3OIw");
class $d342bb5d6a280f9c$export$2c035820a31723e extends (0, $j3OIw.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}

});

parcelRegister("2LCmM", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $caec400582ed2bbc$export$4269d30173168e5c);
const $caec400582ed2bbc$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("8VZ1g", function(module, exports) {
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $9eac075f64a6ba11$export$49721bcc26fb9388);

var $g32hK = parcelRequire("g32hK");

var $g1Vdg = parcelRequire("g1Vdg");

var $cbgJ9 = parcelRequire("cbgJ9");
const $9eac075f64a6ba11$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $cbgJ9.getRemotePreview)(mediaClient, id, params, traceContext),
        (0, $g32hK.enrichAttrsWithClientId)(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return (0, $g1Vdg.extendAndCachePreview)(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};

});
parcelRegister("cbgJ9", function(module, exports) {
$parcel$export(module.exports, "getRemotePreview", () => $b11cf631f5e7b058$export$bfe20bd01db02b3);

var $9fVmy = parcelRequire("9fVmy");
const $b11cf631f5e7b058$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $9fVmy.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("9fVmy", function(module, exports) {
$parcel$export(module.exports, "RemotePreviewError", () => $cb9b06628380130e$export$10ab445310d30114);

var $j3OIw = parcelRequire("j3OIw");
class $cb9b06628380130e$export$10ab445310d30114 extends (0, $j3OIw.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}

});



parcelRegister("gtXaM", function(module, exports) {
$parcel$export(module.exports, "getSSRPreview", () => $2848c153a64dc4f2$export$faf1c301c59a1bdc);

var $4O54o = parcelRequire("4O54o");

var $gdUUy = parcelRequire("gdUUy");

var $joemp = parcelRequire("joemp");

var $3TRa5 = parcelRequire("3TRa5");
const $2848c153a64dc4f2$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs, seededCdnUrl)=>{
    const signedDataURI = mediaClient.getImageUrlSync(id, params, seededCdnUrl);
    return mediaBlobUrlAttrs ? (0, $4O54o.addFileAttrsToUrl)(signedDataURI, mediaBlobUrlAttrs) : signedDataURI;
};
const $2848c153a64dc4f2$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs, seededCdnUrl)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = (0, $3TRa5.mergeClientIdIntoAttrs)(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $2848c153a64dc4f2$var$getDataUri(mediaClient, id, params, attrsWithClientId, seededCdnUrl);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $2848c153a64dc4f2$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId, seededCdnUrl);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $joemp.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("joemp", function(module, exports) {
$parcel$export(module.exports, "SsrPreviewError", () => $ce6f4a1659ee4022$export$18e89b7e50818288);

var $j3OIw = parcelRequire("j3OIw");
class $ce6f4a1659ee4022$export$18e89b7e50818288 extends (0, $j3OIw.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}

});


parcelRegister("fj6zl", function(module, exports) {
$parcel$export(module.exports, "isLocalPreview", () => $5232fcc9bb5100d5$export$78ad02c5efc361c9);
const $5232fcc9bb5100d5$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};

});

parcelRegister("l508r", function(module, exports) {
$parcel$export(module.exports, "isRemotePreview", () => $e9139a7024ab1bbb$export$87442a14a8a19e0);
const $e9139a7024ab1bbb$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};

});

parcelRegister("4nmTH", function(module, exports) {
$parcel$export(module.exports, "isSSRClientPreview", () => $13e58730c43b28b5$export$36aae1afbc0a9661);
const $13e58730c43b28b5$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';

});

parcelRegister("40cEI", function(module, exports) {
$parcel$export(module.exports, "isSSRDataPreview", () => $337ed78ba703d3dd$export$f366c2c8a792cce6);
const $337ed78ba703d3dd$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';

});

parcelRegister("jplZ4", function(module, exports) {
$parcel$export(module.exports, "isSSRPreview", () => $7503600b4d98bb99$export$dea79d05143ccf4);
const $7503600b4d98bb99$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};

});

parcelRegister("jJnAw", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b5737a3f5893888$export$1fa85b75e8662d54);
const $3b5737a3f5893888$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';

});

parcelRegister("cYq5l", function(module, exports) {
$parcel$export(module.exports, "generateScriptProps", () => $cc7822a28c9fe184$export$de7c49925e44d75d);

var $hVnlh = parcelRequire("hVnlh");

var $9kVEd = parcelRequire("9kVEd");
const $cc7822a28c9fe184$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = (0, $hVnlh.getKey)(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: (0, $9kVEd.MAX_EAGER_LOAD_COUNT)
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $cc7822a28c9fe184$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $cc7822a28c9fe184$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });

});
parcelRegister("hVnlh", function(module, exports) {
$parcel$export(module.exports, "getKey", () => $40c230f5d3aeb326$export$a47fb462a08de82f);
const $40c230f5d3aeb326$var$dashed = (param)=>param ? `-${param}` : '';
const $40c230f5d3aeb326$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$40c230f5d3aeb326$var$dashed(collectionName)}${$40c230f5d3aeb326$var$dashed(occurrenceKey)}${$40c230f5d3aeb326$var$dashed(resizeMode)}`;

});

parcelRegister("9kVEd", function(module, exports) {
$parcel$export(module.exports, "MAX_EAGER_LOAD_COUNT", () => $4122c6499d466543$export$4ced612cd8b14538);
const $4122c6499d466543$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $4122c6499d466543$export$d26005e8749921c9 = 'mediaCountSsr';
const $4122c6499d466543$export$7aeb4eab53a57df7 = 'performanceEntries';
const $4122c6499d466543$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $4122c6499d466543$export$4ced612cd8b14538 = 6;

});


parcelRegister("iYUxs", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $0b57e76745615b47$export$d3a890b0f7844b6f);

var $hVnlh = parcelRequire("hVnlh");

var $8P6Q4 = parcelRequire("8P6Q4");
const $0b57e76745615b47$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $8P6Q4.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $hVnlh.getKey)(identifier, resizeMode)];
};

});
parcelRegister("8P6Q4", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $cf216dc56bae9ea4$export$ede93d4564eaa8da);

var $9nqZV = parcelRequire("9nqZV");
function $cf216dc56bae9ea4$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = (0, $9nqZV.getMediaGlobalScope)(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}

});
parcelRegister("9nqZV", function(module, exports) {
$parcel$export(module.exports, "getMediaGlobalScope", () => $d2cf41669bd8b12e$export$96a3cfb3a41e9bb2);
function $d2cf41669bd8b12e$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}

});



parcelRegister("bUrBx", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $816abcf78114a060$export$912a00e9a5470d9a);
const $816abcf78114a060$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};

});

parcelRegister("1YqrL", function(module, exports) {
$parcel$export(module.exports, "isWider", () => $e2e4f5eb89d4d929$export$ae6224430098bc5f);
const $e2e4f5eb89d4d929$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = (current === null || current === void 0 ? void 0 : current.width) || 0;
    const nextWidth = (next === null || next === void 0 ? void 0 : next.width) || 0;
    return currentWidth < nextWidth;
};

});

parcelRegister("bv8lI", function(module, exports) {
$parcel$export(module.exports, "useCurrentValueRef", () => $4d9d76408e6c3621$export$b3e10e1f0fbb71db);

var $bSJIT = parcelRequire("bSJIT");
function $4d9d76408e6c3621$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $bSJIT.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("8HBIN", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => (parcelRequire("a89AW")).AttributeList);

var $a89AW = parcelRequire("a89AW");

});
parcelRegister("a89AW", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => $c3cbf53980aa421c$export$f632a70b7942a9ca);

var $bSJIT = parcelRequire("bSJIT");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $ke6wr = parcelRequire("ke6wr");
const $c3cbf53980aa421c$export$f632a70b7942a9ca = ({ attributes: attributes, timezoneId: timezoneId })=>{
    const objectAttributeValuesAreNotEmpty = (values)=>{
        return values.every((value)=>Object.keys(value).length > 0);
    };
    const renderAttribute = (attribute)=>{
        var _attribute$objectType;
        if (((_attribute$objectType = attribute.objectTypeAttribute.defaultType) === null || _attribute$objectType === void 0 ? void 0 : _attribute$objectType.name) === 'DateTime' && timezoneId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            const displayValue = value.value ? (0, $ke6wr.convertToTimezone)(value.value, timezoneId) : value.displayValue;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
                key: index
            }, displayValue);
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
                key: index
            }, value.displayValue);
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $c3cbf53980aa421c$var$ListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "dl",
        xcss: $c3cbf53980aa421c$var$ListStyles
    }, attributes.map((attribute)=>objectAttributeValuesAreNotEmpty(attribute.objectAttributeValues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            key: attribute.id ?? attribute.objectTypeAttribute.name,
            xcss: $c3cbf53980aa421c$var$AttributeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "dt",
            xcss: $c3cbf53980aa421c$var$AttributeLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
            size: "xsmall",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "span",
            xcss: $c3cbf53980aa421c$var$attributeLabelStyles
        }, attribute.objectTypeAttribute.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "dd",
            xcss: $c3cbf53980aa421c$var$AttributeValueStyles
        }, renderAttribute(attribute))))));
};
const $c3cbf53980aa421c$var$ListStyles = (0, $9BVpB.xcss)({
    paddingLeft: 'space.0'
});
const $c3cbf53980aa421c$var$ListWrapperStyles = (0, $9BVpB.xcss)({
    /* Offset the outside padding from children */ // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.negative.050',
    marginRight: 'space.negative.150',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.150'
});
const $c3cbf53980aa421c$var$attributeLabelStyles = (0, $9BVpB.xcss)({
    color: 'color.text.subtle'
});
const $c3cbf53980aa421c$var$AttributeLabelWrapperStyles = (0, $9BVpB.xcss)({
    marginBlock: 'space.050',
    marginInline: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '112px',
    flexGrow: 1
});
const $c3cbf53980aa421c$var$AttributeValueStyles = (0, $9BVpB.xcss)({
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    color: 'color.text',
    // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.050',
    marginRight: 'space.150',
    marginBottom: 'space.050',
    marginLeft: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '224px',
    flexGrow: 1
});
const $c3cbf53980aa421c$var$AttributeWrapperStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
});

});
parcelRegister("7WQx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1796a4d074b41d79$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $eMcp0 = parcelRequire("eMcp0");

var $fMEHk = parcelRequire("fMEHk");

var $bAcCw = parcelRequire("bAcCw");

var $4eGW1 = parcelRequire("4eGW1");
const $1796a4d074b41d79$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $1796a4d074b41d79$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $1796a4d074b41d79$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $1796a4d074b41d79$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $1796a4d074b41d79$var$useColor = (colorProp)=>{
    const surface = (0, $eMcp0.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $fMEHk.inverseColorMap).hasOwnProperty(surface)) return (0, $fMEHk.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $1796a4d074b41d79$var$Heading = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $4eGW1;
    const [hLevel, inferredElement] = (0, $bAcCw.useHeading)($1796a4d074b41d79$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $1796a4d074b41d79$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $9fU1q.default)([
            $1796a4d074b41d79$var$styles.reset,
            $1796a4d074b41d79$var$headingSizeStyles[size],
            $1796a4d074b41d79$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $1796a4d074b41d79$export$2e2bcd8739ae039 = $1796a4d074b41d79$var$Heading;

});
parcelRegister("eMcp0", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $3c5acf2e9a99b5ce$export$1aeb4f6b93c4540d);

var $bSJIT = parcelRequire("bSJIT");

var $dHEk9 = parcelRequire("dHEk9");
const $3c5acf2e9a99b5ce$export$1aeb4f6b93c4540d = ()=>{
    return (0, $bSJIT.useContext)((0, $dHEk9.SurfaceContext));
};
(0, $dHEk9.SurfaceContext).displayName = 'SurfaceProvider';

});

parcelRegister("fMEHk", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $6ce0c4cd89fd1ece$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f941eca1bf309f7088207fc024b707>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $6ce0c4cd89fd1ece$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("bAcCw", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $fdbabe53b0bec988$export$97a37b1befbbf9b1);

var $8Oj6N = parcelRequire("8Oj6N");
const $fdbabe53b0bec988$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $8Oj6N.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("8Oj6N", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $17549c80ecfb987e$export$6a64a1e2d0bbbf75);

var $bSJIT = parcelRequire("bSJIT");

var $kPIeQ = parcelRequire("kPIeQ");
const $17549c80ecfb987e$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $bSJIT.useContext)((0, $kPIeQ.HeadingLevelContext));
};

});
parcelRegister("kPIeQ", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $fdac724557e8cd69$export$d1fa8a19e192bc63);

var $bSJIT = parcelRequire("bSJIT");
const $fdac724557e8cd69$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $bSJIT.createContext)(0);

});




parcelRegister("ke6wr", function(module, exports) {
$parcel$export(module.exports, "convertToTimezone", () => $4093d3ae0bb44980$export$4d189baac548427);
const $4093d3ae0bb44980$export$4d189baac548427 = (dateString, timezoneId)=>{
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timezoneId
    }).format(date);
};

});



parcelRegister("8n9rx", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => (parcelRequire("kYvaZ")).ExpandCollapseToggle);

var $kYvaZ = parcelRequire("kYvaZ");

});
parcelRegister("kYvaZ", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => $8f63360beb5a3f30$export$170fda29b81e014c);

var $bSJIT = parcelRequire("bSJIT");

var $hzFIQ = parcelRequire("hzFIQ");

var $4GWyU = parcelRequire("4GWyU");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $lavtv = parcelRequire("lavtv");
const $8f63360beb5a3f30$export$170fda29b81e014c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: props.label,
        hasNewContentOnTriggerClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: props.onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: [
                $8f63360beb5a3f30$var$animatedRotationStyles,
                props.isExpanded && $8f63360beb5a3f30$var$animatedRotationStylesInverted
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            spacing: "spacious",
            label: props.label,
            size: "small"
        })),
        testId: props.testId
    }));
};
const $8f63360beb5a3f30$var$animatedRotationStyles = (0, $9BVpB.xcss)({
    transition: '200ms ease all',
    transform: 'rotate(0deg)'
});
const $8f63360beb5a3f30$var$animatedRotationStylesInverted = (0, $9BVpB.xcss)({
    transform: 'rotate(180deg)'
});

});
parcelRegister("hzFIQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $215f838862ddfc91$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $68v77 = parcelRequire("68v77");

var $a5ag5 = parcelRequire("a5ag5");

var $7n1Pc = parcelRequire("7n1Pc");
const $215f838862ddfc91$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $215f838862ddfc91$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $1OdZP.default), onMouseUp: providedOnMouseUp = (0, $1OdZP.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $7n1Pc.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $bSJIT.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $bSJIT.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($215f838862ddfc91$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $bSJIT.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($215f838862ddfc91$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $bSJIT.useMemo)(()=>(0, $a5ag5.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $68v77.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$215f838862ddfc91$var$Button.displayName = 'Button';
var $215f838862ddfc91$export$2e2bcd8739ae039 = $215f838862ddfc91$var$Button;

});
parcelRegister("1OdZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $723fa7d0d512800c$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $723fa7d0d512800c$export$2e2bcd8739ae039() {}

});

parcelRegister("68v77", function(module, exports) {
$parcel$export(module.exports, "default", () => $6368812abca30913$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $21u3G = parcelRequire("21u3G");

var $dbbkH = parcelRequire("dbbkH");

var $cyIUy = parcelRequire("cyIUy");

var $6sOtw = parcelRequire("6sOtw");

var $gjIiX = parcelRequire("gjIiX");

var $8OFjm = parcelRequire("8OFjm");

var $favRo = parcelRequire("favRo");

var $ecJKi = parcelRequire("ecJKi");

var $bxdCf = parcelRequire("bxdCf");
function $6368812abca30913$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $6368812abca30913$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $6368812abca30913$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $6368812abca30913$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $6368812abca30913$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $ecJKi.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $6368812abca30913$var$getChildren = (children, childrenStyles)=>{
    if ((0, $ecJKi.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $6368812abca30913$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $1OdZP.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $1OdZP.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $bSJIT.useRef)();
    const setRef = (0, $bSJIT.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $21u3G.default)(ourRef, autoFocus);
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $bSJIT.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $bSJIT.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $9dQre.css)((0, $8OFjm.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $dbbkH.default), null, /*#__PURE__*/ (0, $9dQre.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $6368812abca30913$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $6sOtw.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $favRo.getIconStyle)({
                spacing: spacing
            }),
            $6368812abca30913$var$getSpacingFix(children, $6368812abca30913$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $6368812abca30913$var$getChildren(children, [
        fadeStyles,
        (0, $gjIiX.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $favRo.getIconStyle)({
                spacing: spacing
            }),
            $6368812abca30913$var$getSpacingFix(children, $6368812abca30913$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: [
            (0, $bxdCf.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6368812abca30913$export$2e2bcd8739ae039 = $6368812abca30913$var$ButtonBase;

});
parcelRegister("kIUP1", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $aad8444794c24874$export$a4687b0234b40e28);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $lE3PD = parcelRequire("lE3PD");
function $aad8444794c24874$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $lE3PD.useTrackedRef)(analyticsData);
    const fnRef = (0, $lE3PD.useTrackedRef)(fn);
    const handler = (0, $bSJIT.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("21u3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $c01f4b1f1df76170$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $c01f4b1f1df76170$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $bSJIT.useRef)(true);
    (0, $bSJIT.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("dbbkH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbfb0848c8cf29c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");
const $bbfb0848c8cf29c7$var$BORDER_WIDTH = 2;
const $bbfb0848c8cf29c7$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $9dQre.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $bbfb0848c8cf29c7$var$BORDER_WIDTH
});
const $bbfb0848c8cf29c7$var$baseInsetStyles = /*#__PURE__*/ (0, $9dQre.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$bbfb0848c8cf29c7$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $bbfb0848c8cf29c7$var$focusRingStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $bbfb0848c8cf29c7$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $bbfb0848c8cf29c7$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $bbfb0848c8cf29c7$var$insetFocusRingStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $bbfb0848c8cf29c7$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $bbfb0848c8cf29c7$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $bbfb0848c8cf29c7$var$FocusRing = /*#__PURE__*/ (0, $bSJIT.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $bbfb0848c8cf29c7$var$baseInsetStyles : $bbfb0848c8cf29c7$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $bbfb0848c8cf29c7$var$insetFocusRingStyles : $bbfb0848c8cf29c7$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $9dQre.ClassNames), null, ({ css: css, cx: cx })=>(0, $bSJIT.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $bSJIT.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$bbfb0848c8cf29c7$var$FocusRing.displayName = 'FocusRing';
var $bbfb0848c8cf29c7$export$2e2bcd8739ae039 = $bbfb0848c8cf29c7$var$FocusRing;

});

parcelRegister("6sOtw", function(module, exports) {
$parcel$export(module.exports, "default", () => $15197120bc24d08c$export$2e2bcd8739ae039);
function $15197120bc24d08c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $15197120bc24d08c$var$tabKeyCode = 9;
function $15197120bc24d08c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $15197120bc24d08c$var$tabKeyCode) return;
    $15197120bc24d08c$var$abort(event);
}
const $15197120bc24d08c$var$block = {
    onMouseDownCapture: $15197120bc24d08c$var$abort,
    onMouseUpCapture: $15197120bc24d08c$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $15197120bc24d08c$var$onKey,
    onKeyUpCapture: $15197120bc24d08c$var$onKey,
    onTouchStartCapture: $15197120bc24d08c$var$abort,
    onTouchEndCapture: $15197120bc24d08c$var$abort,
    onPointerDownCapture: $15197120bc24d08c$var$abort,
    onPointerUpCapture: $15197120bc24d08c$var$abort,
    onClickCapture: $15197120bc24d08c$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $15197120bc24d08c$var$abort
};
const $15197120bc24d08c$var$doNotBlock = {};
function $15197120bc24d08c$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $15197120bc24d08c$var$doNotBlock : $15197120bc24d08c$var$block;
}

});

parcelRegister("gjIiX", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $ac2b3541487d4f2e$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
function $ac2b3541487d4f2e$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("8OFjm", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $5214ad0ead4186fd$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
function $5214ad0ead4186fd$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("favRo", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $b97ca5198447bc24$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
function $b97ca5198447bc24$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $9dQre.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("ecJKi", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $7ec13dac99d3ad87$export$20bbd2efb0d734c4);

var $bSJIT = parcelRequire("bSJIT");

var $9Abbn = parcelRequire("9Abbn");
const $7ec13dac99d3ad87$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $bSJIT.isValidElement)(children) && children.type === (0, $9Abbn.default);
};

});
parcelRegister("9Abbn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a13a881a376620ed$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $a13a881a376620ed$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $a13a881a376620ed$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$a13a881a376620ed$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $a13a881a376620ed$export$2e2bcd8739ae039 = $a13a881a376620ed$var$VisuallyHidden;

});


parcelRegister("bxdCf", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $185a2ac6abc6ed19$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $185a2ac6abc6ed19$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("a5ag5", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $920907a4a2d27078$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gdUUy = parcelRequire("gdUUy");
const $920907a4a2d27078$var$gridSize = 8;
const $920907a4a2d27078$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $920907a4a2d27078$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $920907a4a2d27078$var$lineHeights = {
    default: $920907a4a2d27078$var$heights.default,
    compact: $920907a4a2d27078$var$heights.compact,
    none: 'inherit'
};
const $920907a4a2d27078$var$padding = {
    // 10px gutter
    default: `0 ${$920907a4a2d27078$var$gridSize + $920907a4a2d27078$var$gridSize / 4}px`,
    compact: `0 ${$920907a4a2d27078$var$gridSize + $920907a4a2d27078$var$gridSize / 4}px`,
    none: '0'
};
const $920907a4a2d27078$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$920907a4a2d27078$var$gridSize / 4}px`,
    default: `0 ${$920907a4a2d27078$var$gridSize / 4}px`,
    none: '0'
};
const $920907a4a2d27078$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $920907a4a2d27078$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $920907a4a2d27078$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$920907a4a2d27078$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    },
    textDecoration: 'none'
};
const $920907a4a2d27078$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$920907a4a2d27078$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $920907a4a2d27078$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $920907a4a2d27078$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseAppearanceStyles = {
        ...appearance === 'default' && $920907a4a2d27078$var$defaultStyles,
        ...appearance === 'primary' && $920907a4a2d27078$var$primaryStyles,
        ...appearance === 'link' && $920907a4a2d27078$var$linkStyles,
        ...appearance === 'subtle' && $920907a4a2d27078$var$subtleStyles,
        ...appearance === 'subtle-link' && $920907a4a2d27078$var$subtleLinkStyles,
        ...appearance === 'warning' && $920907a4a2d27078$var$warningStyles,
        ...appearance === 'danger' && $920907a4a2d27078$var$dangerStyles
    };
    const appearanceStyles = appearance === 'default' && (0, $gdUUy.fg)('platform-dst-tokens-finesse') ? {
        ...baseAppearanceStyles,
        '&:hover': {
            ...baseAppearanceStyles['&:hover'],
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        '&:active': {
            ...baseAppearanceStyles['&:active'],
            background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        }
    } : baseAppearanceStyles;
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-medium, 6px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)`,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $920907a4a2d27078$var$heights[spacing],
        lineHeight: $920907a4a2d27078$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $920907a4a2d27078$var$singleIconPadding[spacing] : $920907a4a2d27078$var$padding[spacing],
        verticalAlign: $920907a4a2d27078$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $920907a4a2d27078$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $920907a4a2d27078$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $920907a4a2d27078$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $920907a4a2d27078$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$920907a4a2d27078$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("7n1Pc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8331a41e8ee131c7$export$2e2bcd8739ae039);

var $ecJKi = parcelRequire("ecJKi");
function $8331a41e8ee131c7$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $ecJKi.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("4GWyU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36a882dcac715209$var$_react = $36a882dcac715209$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $36a882dcac715209$var$_iconNew = $36a882dcac715209$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $36a882dcac715209$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36a882dcac715209$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $36a882dcac715209$var$_react.default.createElement($36a882dcac715209$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$36a882dcac715209$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $36a882dcac715209$var$_default = module.exports.default = $36a882dcac715209$var$ChevronDownIcon;

});

parcelRegister("lavtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $490dfa41c5635713$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $iBoJv = parcelRequire("iBoJv");

var $fGbV9 = parcelRequire("fGbV9");

var $1OdZP = parcelRequire("1OdZP");

var $jvva2 = parcelRequire("jvva2");

var $5RQhg = parcelRequire("5RQhg");

var $6gXOx = parcelRequire("6gXOx");

var $jvbf5 = parcelRequire("jvbf5");

var $8W36W = parcelRequire("8W36W");

var $gdUUy = parcelRequire("gdUUy");

var $ffwxl = parcelRequire("ffwxl");

var $cglph = parcelRequire("cglph");

var $juI4y = parcelRequire("juI4y");

var $65Dj6 = parcelRequire("65Dj6");

var $jfBg8 = parcelRequire("jfBg8");

var $7nmZk = parcelRequire("7nmZk");

var $8Ihum = parcelRequire("8Ihum");

var $aQKfL = parcelRequire("aQKfL");

var $2I3Ix = parcelRequire("2I3Ix");

var $eHxps = parcelRequire("eHxps");

var $aK4UE = parcelRequire("aK4UE");

var $d3S4D = parcelRequire("d3S4D");

var $3Pind = parcelRequire("3Pind");

var $5VL29 = parcelRequire("5VL29");
const $490dfa41c5635713$var$tooltipZIndex = (0, $juI4y.layers).tooltip();
const $490dfa41c5635713$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $490dfa41c5635713$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $490dfa41c5635713$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $490dfa41c5635713$var$isTopLayerPointerReEntry({ trigger: trigger, relatedTarget: relatedTarget }) {
    if (!(0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $490dfa41c5635713$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $5VL29.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $1OdZP.default), onHide: onHide = (0, $1OdZP.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    // The deprecated hide props win over `hasNewContentOnTriggerClick`, as the prop
    // docs say. Setting both is a mistake, so keep the older behaviour. Read only
    // together with `platform-dst-top-layer-tooltip`; without the gate a press
    // never closes.
    const isStayOpenOnTriggerClick = hasNewContentOnTriggerClick && !hideTooltipOnClick && !hideTooltipOnMouseDown;
    const onShowHandler = (0, $iBoJv.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$490dfa41c5635713$var$analyticsAttributes
    });
    const onHideHandler = (0, $iBoJv.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$490dfa41c5635713$var$analyticsAttributes
    });
    const apiRef = (0, $bSJIT.useRef)(null);
    const [state, setState] = (0, $bSJIT.useState)('hide');
    const targetRef = (0, $bSJIT.useRef)(null);
    const containerRef = (0, $bSJIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $bSJIT.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $5RQhg.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $5RQhg.default)(onShowHandler);
    const onHideHandlerStable = (0, $5RQhg.default)(onHideHandler);
    const delayStable = (0, $5RQhg.default)(delay);
    const canAppearStable = (0, $5RQhg.default)(canAppear);
    const hasCalledShowHandler = (0, $bSJIT.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $5RQhg.default)(shouldAlwaysFadeIn);
    const start = (0, $bSJIT.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $bSJIT.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $bSJIT.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $bSJIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        return (0, $2I3Ix.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    const isTopLayerPointerDismissedRef = (0, $bSJIT.useRef)(false);
    const tryShowTooltip = (0, $bSJIT.useCallback)((source)=>{
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $d3S4D.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $bSJIT.useCallback)(()=>{
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="hint" handles Escape natively
    (0, $jvva2.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $gdUUy.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $bSJIT.useCallback)(()=>{
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    const handlePopoverClose = (0, $bSJIT.useCallback)(()=>{
        var _apiRef$current4;
        if ((0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        if (state === 'hide') return 0, $1OdZP.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $bAB3U.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $bSJIT.useCallback)(()=>{
        // `hasNewContentOnTriggerClick`: `TopLayerTooltipPopup` re-shows the popover
        // after the light dismiss, so there is nothing to record, and a pending
        // show goes ahead with the new content, as it does without the gate.
        if (isStayOpenOnTriggerClick && (0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) return;
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        const shouldCancelPendingShow = stableState.current === 'hide' && (0, $gdUUy.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        isStayOpenOnTriggerClick,
        stableState
    ]);
    const onClick = (0, $bSJIT.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $bSJIT.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($490dfa41c5635713$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $bSJIT.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $bSJIT.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $bSJIT.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $bSJIT.useCallback)(()=>{
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $bSJIT.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $bSJIT.useCallback)(()=>{
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $gdUUy.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $aK4UE.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $3Pind.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $bSJIT.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $bSJIT.Fragment) : $490dfa41c5635713$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : /*#__PURE__*/ (0, $dc70d.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        /**
   * TODO: Why is role="presentation" added?
   * - Is it only to "remove" the `Container` from screen readers?
   * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
   * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
   */ role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current8;
        return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
            children: [
                trigger,
                shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $dc70d.jsx)($490dfa41c5635713$var$TopLayerTooltipPopup, {
                    targetRef: targetRef,
                    tooltipPosition: tooltipPosition,
                    mousePos: ((_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) ?? undefined,
                    position: position,
                    onMouseOut: onMouseOut,
                    onMouseOverTooltip: onMouseOverTooltip,
                    ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                    truncate: truncate,
                    testId: testId,
                    shortcut: shortcut,
                    content: content,
                    Container: Container,
                    onClose: handlePopoverClose,
                    shouldStayOpenOnTriggerClick: isStayOpenOnTriggerClick,
                    onExitFinish: handleExitFinish,
                    isOpen: state !== 'hide' && state !== 'top-layer-exit'
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $dc70d.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ffwxl.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $490dfa41c5635713$var$invertedDirection[$490dfa41c5635713$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8W36W.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $dc70d.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $490dfa41c5635713$export$2e2bcd8739ae039 = $490dfa41c5635713$var$Tooltip;
const $490dfa41c5635713$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cglph.default), {
        zIndex: $490dfa41c5635713$var$tooltipZIndex,
        children: children
    });
};
const $490dfa41c5635713$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with two positioning
 * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
 * fight for ownership, so `isEnabled` is derived from one boolean and negated:
 *
 *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
 *     `mouse-x`, `mouse-y`) activated by a pointer.
 *   - `useAnchoredPopover` for everything else, including a cursor position
 *     activated via keyboard focus, where there is no cursor to track and
 *     anchoring to the trigger is what keeps the tooltip beside the target.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $490dfa41c5635713$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen, shouldStayOpenOnTriggerClick: shouldStayOpenOnTriggerClick }) {
    const popoverRef = (0, $bSJIT.useRef)(null);
    // Never read. Some custom `component` wrappers render nothing without a ref.
    const containerRef = (0, $bSJIT.useRef)(null);
    // The host unmounts on close and remounts on open, so set `data-placement`
    // whenever a node attaches, as well as when the placement changes.
    const setPopoverNode = (0, $bSJIT.useCallback)((node)=>{
        node === null || node === void 0 || node.setAttribute('data-placement', tooltipPosition);
    }, [
        tooltipPosition
    ]);
    const hostRef = (0, $fGbV9.default)([
        popoverRef,
        setPopoverNode
    ]);
    // `shouldStayOpenOnTriggerClick`: a press on the trigger light-dismisses the hint
    // popover, and the browser gives no way to cancel that. The dismiss runs
    // before the `pointerup` is dispatched, so show the popover again from the
    // trigger's `pointerup`. It is the same task, so no closed frame is painted,
    // the entry transition does not restart, and the `toggle` events coalesce
    // to open -> open, so `onClose` is not called. `mouseup` covers
    // environments that dismiss on `mouseup` too, such as the test polyfill.
    // `showPopover()` does nothing when the popover is already open. A layout
    // effect, so the listener is gone in the same commit that closes the
    // popover: a passive cleanup runs later, and a `pointerup` in that gap would
    // re-open a closing tooltip.
    (0, $bSJIT.useLayoutEffect)(()=>{
        const trigger = targetRef.current;
        if (!shouldStayOpenOnTriggerClick || !isOpen || !trigger) return;
        const reshow = ()=>{
            try {
                var _popoverRef$current;
                (_popoverRef$current = popoverRef.current) === null || _popoverRef$current === void 0 || _popoverRef$current.showPopover();
            } catch  {}
        };
        return (0, $bAB3U.bindAll)(trigger, [
            {
                type: 'pointerup',
                listener: reshow
            },
            {
                type: 'mouseup',
                listener: reshow
            }
        ]);
    }, [
        shouldStayOpenOnTriggerClick,
        isOpen,
        targetRef
    ]);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    const placement = (0, $65Dj6.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // One object so the two calls cannot drift on `placement` or `isOpen`.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $7nmZk.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    });
    // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $8Ihum.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isMouseStrategyActive,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $eHxps.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jfBg8.Popover), {
        ref: hostRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $490dfa41c5635713$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $490dfa41c5635713$var$tooltipMouseAnimationStyles.exit,
        placement: placement,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aQKfL.DefaultRoleContext).Provider, {
            value: "presentation",
            children: /*#__PURE__*/ (0, $dc70d.jsx)(Container, {
                ref: containerRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
                className: "Tooltip",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- top-layer spike
                style: ignoreTooltipPointerEvents ? {
                    pointerEvents: 'none'
                } : undefined,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut,
                children: typeof content === 'function' ? content({
                    update: (0, $1OdZP.default)
                }) : content
            })
        })
    });
}

});
parcelRegister("iBoJv", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $87839f5330b9d4f2$export$1a04351537078b55);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $lE3PD = parcelRequire("lE3PD");
function $87839f5330b9d4f2$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $lE3PD.useTrackedRef)(analyticsData);
    const fnRef = (0, $lE3PD.useTrackedRef)(fn);
    const handler = (0, $bSJIT.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("fGbV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f35c26d35aaea7f$export$2e2bcd8739ae039);
function $6f35c26d35aaea7f$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("jvva2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0f9a8e5876a2fc5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $gL5sM = parcelRequire("gL5sM");
function $d0f9a8e5876a2fc5$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $bSJIT.useRef)(false);
    const onKeyDown = (0, $bSJIT.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $gL5sM.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $bSJIT.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $bAB3U.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("gL5sM", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $da0ec6080e17952f$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $da0ec6080e17952f$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $da0ec6080e17952f$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $da0ec6080e17952f$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $da0ec6080e17952f$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $da0ec6080e17952f$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $da0ec6080e17952f$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $da0ec6080e17952f$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $da0ec6080e17952f$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $da0ec6080e17952f$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $da0ec6080e17952f$export$390330c10ff2b9a1 = 'ArrowUp';
const $da0ec6080e17952f$export$a80636c6f41931fe = 'ArrowDown';
const $da0ec6080e17952f$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $da0ec6080e17952f$export$c40f9845adc73fb5 = 'ArrowRight';
const $da0ec6080e17952f$export$4af703091671bc = 'Home';
const $da0ec6080e17952f$export$e2bc30913faa5db7 = 'End';
const $da0ec6080e17952f$export$10f6869ed0a7d75b = 'Tab';
const $da0ec6080e17952f$export$8152f929a25a0ff4 = 'Enter';
const $da0ec6080e17952f$export$e51a3576c045c8d5 = 'Space';
const $da0ec6080e17952f$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("5RQhg", function(module, exports) {
$parcel$export(module.exports, "default", () => $79f5a538cdd19451$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $79f5a538cdd19451$export$2e2bcd8739ae039(value) {
    const ref = (0, $bSJIT.useRef)(value);
    (0, $bSJIT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("6gXOx", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $1e7bea6c05516462$export$469bb693f11edc7f);

var $bSJIT = parcelRequire("bSJIT");

var $5iouV = parcelRequire("5iouV");

var $iUMSA = parcelRequire("iUMSA");
function $1e7bea6c05516462$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $bSJIT.useContext)((0, $5iouV.OpenLayerObserverContext));
    const namespace = (0, $iUMSA.useOpenLayerObserverNamespace)();
    (0, $bSJIT.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("5iouV", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $b53770952ee5e11a$export$5fbf4d7fae6cdc00);

var $bSJIT = parcelRequire("bSJIT");
const $b53770952ee5e11a$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);

});

parcelRegister("iUMSA", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $8ae45e1877c7dfea$export$1d57e79091cc3046);

var $bSJIT = parcelRequire("bSJIT");

var $6E1rl = parcelRequire("6E1rl");
function $8ae45e1877c7dfea$export$1d57e79091cc3046() {
    const namespace = (0, $bSJIT.useContext)((0, $6E1rl.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("6E1rl", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $f2914439a7f56b0c$export$644a49f3b8c50fcd);

var $bSJIT = parcelRequire("bSJIT");
const $f2914439a7f56b0c$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $bSJIT.createContext)(null);

});



parcelRegister("jvbf5", function(module, exports) {
$parcel$export(module.exports, "defaultExitingContext", () => $1582d2656cd92479$export$52502485782d6180);
$parcel$export(module.exports, "ExitingContext", () => $1582d2656cd92479$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $1582d2656cd92479$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
const $1582d2656cd92479$export$52502485782d6180 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
const $1582d2656cd92479$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $bSJIT.createContext)($1582d2656cd92479$export$52502485782d6180);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $1582d2656cd92479$var$wrapChildWithContextProvider = (child, value = $1582d2656cd92479$export$52502485782d6180)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($1582d2656cd92479$export$b9c4904d7a6929e6.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $1582d2656cd92479$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $bSJIT.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $1582d2656cd92479$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $1582d2656cd92479$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $1582d2656cd92479$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $1582d2656cd92479$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $1582d2656cd92479$var$ExitingPersistence = /*#__PURE__*/ (0, $bSJIT.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $bSJIT.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $bSJIT.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $bSJIT.useState)(()=>({
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        }));
    (0, $bSJIT.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $1582d2656cd92479$var$childrenToArray(previousChildren);
    const current = $1582d2656cd92479$var$childrenToArray(currentChildren);
    if (currentChildren !== children) {
        // Parent updates can rerender this boundary before its children finish exiting. Keep
        // the previous children until their onFinish callbacks release them.
        const hasPendingExit = ((0, $gdUUy.fg)('platform-dst-motion-uplift-labels') || (0, $gdUUy.fg)('platform-dst-motion-uplift-input')) && $1582d2656cd92479$var$getMissingKeys(current, previous).size > 0;
        setChildren([
            hasPendingExit ? previousChildren : currentChildren,
            children
        ]);
    }
    const nextChildren = currentChildren !== children ? $1582d2656cd92479$var$childrenToArray(children) : current;
    const missingKeys = $1582d2656cd92479$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $1582d2656cd92479$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $gdUUy.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        // Retained exits can span several parent renders. Unchanged siblings should
        // keep their context identity instead of receiving redundant updates.
        if (((0, $gdUUy.fg)('platform-dst-motion-uplift-labels') || (0, $gdUUy.fg)('platform-dst-motion-uplift-input')) && !isExiting) return $1582d2656cd92479$var$wrapChildWithContextProvider(child, defaultContext);
        return $1582d2656cd92479$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$1582d2656cd92479$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1582d2656cd92479$export$2e2bcd8739ae039 = $1582d2656cd92479$var$ExitingPersistence;
$1582d2656cd92479$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("8W36W", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cfd97edcb113fd3$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3eoZ6 = parcelRequire("3eoZ6");
const $6cfd97edcb113fd3$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $6cfd97edcb113fd3$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $6cfd97edcb113fd3$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3eoZ6.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $6cfd97edcb113fd3$export$2e2bcd8739ae039 = $6cfd97edcb113fd3$var$FadeIn;

});
parcelRegister("3eoZ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $25612845ec485084$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $lj4Nn = parcelRequire("lj4Nn");

var $dLJet = parcelRequire("dLJet");

var $iWZGm = parcelRequire("iWZGm");

var $1QkMl = parcelRequire("1QkMl");

var $8Mgn9 = parcelRequire("8Mgn9");

var $z8N4c = parcelRequire("z8N4c");
const $25612845ec485084$var$zoomIn = null;
const $25612845ec485084$var$zoomOut = null;
const $25612845ec485084$var$fadeIn = null;
const $25612845ec485084$var$fadeOut = null;
const $25612845ec485084$var$fadeInFromTop = null;
const $25612845ec485084$var$fadeOutFromTop = null;
const $25612845ec485084$var$fadeInFromLeft = null;
const $25612845ec485084$var$fadeOutFromLeft = null;
const $25612845ec485084$var$fadeInFromBottom = null;
const $25612845ec485084$var$fadeOutFromBottom = null;
const $25612845ec485084$var$fadeInFromRight = null;
const $25612845ec485084$var$fadeOutFromRight = null;
const $25612845ec485084$var$fadeInFromTopConstant = null;
const $25612845ec485084$var$fadeOutFromTopConstant = null;
const $25612845ec485084$var$fadeInFromLeftConstant = null;
const $25612845ec485084$var$fadeOutFromLeftConstant = null;
const $25612845ec485084$var$fadeInFromBottomConstant = null;
const $25612845ec485084$var$fadeOutFromBottomConstant = null;
const $25612845ec485084$var$fadeInFromRightConstant = null;
const $25612845ec485084$var$fadeOutFromRightConstant = null;
const $25612845ec485084$var$slideInFromTop = null;
const $25612845ec485084$var$slideOutFromTop = null;
const $25612845ec485084$var$slideInFromRight = null;
const $25612845ec485084$var$slideOutFromRight = null;
const $25612845ec485084$var$slideInFromBottom = null;
const $25612845ec485084$var$slideOutFromBottom = null;
const $25612845ec485084$var$slideInFromLeft = null;
const $25612845ec485084$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $25612845ec485084$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $z8N4c.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8Mgn9.useExitingPersistence)();
    const setTimeout = (0, $1QkMl.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $bSJIT.useState)(appear);
    (0, $bSJIT.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $iWZGm.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $dLJet.exitingDurations)[duration] : (0, $lj4Nn.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $9fU1q.default)([
            (0, $9fU1q.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $9fU1q.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $9fU1q.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $9fU1q.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $9fU1q.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $9fU1q.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $9fU1q.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $9fU1q.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $9fU1q.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $9fU1q.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $9fU1q.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $9fU1q.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $9fU1q.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $9fU1q.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $9fU1q.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $9fU1q.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $9fU1q.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $9fU1q.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $9fU1q.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $9fU1q.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $9fU1q.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $9fU1q.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $9fU1q.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $9fU1q.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $9fU1q.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $9fU1q.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $9fU1q.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $9fU1q.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $9fU1q.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $9fU1q.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $9fU1q.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $9fU1q.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $9fU1q.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $9fU1q.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $9fU1q.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $9fU1q.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $9fU1q.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $9fU1q.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $9fU1q.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $9fU1q.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $9fU1q.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $9fU1q.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $9fU1q.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $9fU1q.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $9fU1q.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $9fU1q.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $9fU1q.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $9fU1q.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $9fU1q.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $9fU1q.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $9fU1q.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $25612845ec485084$export$2e2bcd8739ae039 = $25612845ec485084$var$EnteringMotion;

});
parcelRegister("lj4Nn", function(module, exports) {
$parcel$export(module.exports, "durations", () => $49e7b67840715e19$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $49e7b67840715e19$export$368bacef0dacbe05 = 25;
const $49e7b67840715e19$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("dLJet", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $16df4fa931974ddc$export$30fa1a2e62ae150c);

var $lj4Nn = parcelRequire("lj4Nn");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $16df4fa931974ddc$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $16df4fa931974ddc$export$30fa1a2e62ae150c = {
    none: (0, $lj4Nn.durations).none,
    small: (0, $lj4Nn.durations).small * $16df4fa931974ddc$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $lj4Nn.durations).medium * $16df4fa931974ddc$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $lj4Nn.durations).large * $16df4fa931974ddc$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("iWZGm", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $bef88b6448e510b1$export$b7baf7667a68d87c);

var $4we3j = parcelRequire("4we3j");
const $bef88b6448e510b1$export$b7baf7667a68d87c = ()=>{
    if (!(0, $4we3j.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("4we3j", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $1e94b07206ef64c7$export$c5406bd59b374abd);
const $1e94b07206ef64c7$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("1QkMl", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $c49c9e2540d49a8c$export$4f34107a2b00f39c);

var $bSJIT = parcelRequire("bSJIT");
const $c49c9e2540d49a8c$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $c49c9e2540d49a8c$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $bSJIT.useRef)([]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c49c9e2540d49a8c$var$getHookDeps(opts));
    return (0, $bSJIT.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("8Mgn9", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $f1924f49cbc47f88$export$3b6f38abbdcbd000);

var $bSJIT = parcelRequire("bSJIT");

var $jvbf5 = parcelRequire("jvbf5");
const $f1924f49cbc47f88$export$3b6f38abbdcbd000 = ()=>{
    return (0, $bSJIT.useContext)((0, $jvbf5.ExitingContext));
};

});

parcelRegister("z8N4c", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $145a4d776dbf39cb$export$25c7213fc07ec080);

var $bSJIT = parcelRequire("bSJIT");

var $eMJVv = parcelRequire("eMJVv");

var $dqxDY = parcelRequire("dqxDY");
const $145a4d776dbf39cb$export$25c7213fc07ec080 = ()=>{
    const identifier = (0, $eMJVv.useUniqueId)();
    const context = (0, $bSJIT.useContext)((0, $dqxDY.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("eMJVv", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $25810f1df59a3d9d$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $bSJIT = parcelRequire("bSJIT");
function $25810f1df59a3d9d$export$c485849f2e393253() {
    const identifier = (0, $bSJIT.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("dqxDY", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $9eb2955f9d5f50cd$export$5e65d7d58ae96ad8);
$parcel$export(module.exports, "default", () => $9eb2955f9d5f50cd$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $4Ajbl = parcelRequire("4Ajbl");
const $9eb2955f9d5f50cd$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $bSJIT.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $1OdZP.default)
    }));
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $9eb2955f9d5f50cd$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $bSJIT.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $bSJIT.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $4Ajbl.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $dc70d.jsx)($9eb2955f9d5f50cd$export$5e65d7d58ae96ad8.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9eb2955f9d5f50cd$export$2e2bcd8739ae039 = $9eb2955f9d5f50cd$var$StaggeredEntrance;

});
parcelRegister("4Ajbl", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $04f0091adc7069ed$export$e5c5a5f917a5871c);

var $bSJIT = parcelRequire("bSJIT");
const $04f0091adc7069ed$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);

});





parcelRegister("ffwxl", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $a59788f848a593aa$export$badac9ada3a0bdf9);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3r3CF = parcelRequire("3r3CF");

var $gdUUy = parcelRequire("gdUUy");

var $cHkkv = parcelRequire("cHkkv");

var $gqj7z = parcelRequire("gqj7z");

const $a59788f848a593aa$var$viewportPadding = 5;
const $a59788f848a593aa$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $a59788f848a593aa$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $a59788f848a593aa$var$defaultChildrenFn() {
    return null;
}
const $a59788f848a593aa$var$defaultOffset = [
    0,
    8
];
function $a59788f848a593aa$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $gdUUy.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gqj7z.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($a59788f848a593aa$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $a59788f848a593aa$var$LegacyPopper({ children: children = $a59788f848a593aa$var$defaultChildrenFn, offset: offset = $a59788f848a593aa$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $bSJIT.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $a59788f848a593aa$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $cHkkv.getMaxSizeModifiers)({
            viewportPadding: $a59788f848a593aa$var$viewportPadding
        }) : [];
        return [
            ...$a59788f848a593aa$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $bSJIT.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3r3CF.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("3r3CF", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $2806b41730ce138a$export$badac9ada3a0bdf9);

var $bSJIT = parcelRequire("bSJIT");

var $1ydlN = parcelRequire("1ydlN");

var $c9X19 = parcelRequire("c9X19");

var $em1l4 = parcelRequire("em1l4");
var $2806b41730ce138a$var$NOOP = function NOOP() {
    return void 0;
};
var $2806b41730ce138a$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $2806b41730ce138a$var$EMPTY_MODIFIERS = [];
function $2806b41730ce138a$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $2806b41730ce138a$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $bSJIT.useContext((0, $1ydlN.ManagerReferenceNodeContext));
    var _React$useState = $bSJIT.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $bSJIT.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $bSJIT.useEffect(function() {
        (0, $c9X19.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $bSJIT.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $em1l4.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $bSJIT.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $2806b41730ce138a$var$NOOP,
            update: update || $2806b41730ce138a$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $c9X19.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("1ydlN", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $1213528c7a20e026$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $1213528c7a20e026$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $1213528c7a20e026$export$d0d38e7dec7a1a61);

var $bSJIT = parcelRequire("bSJIT");
var $1213528c7a20e026$export$3dbd3405086fec7b = $bSJIT.createContext();
var $1213528c7a20e026$export$cbabb21c2529b130 = $bSJIT.createContext();
function $1213528c7a20e026$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $bSJIT.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $bSJIT.useRef(false);
    $bSJIT.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $bSJIT.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $bSJIT.createElement($1213528c7a20e026$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $bSJIT.createElement($1213528c7a20e026$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("c9X19", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $8da41afbd3027a33$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $8da41afbd3027a33$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $8da41afbd3027a33$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $8da41afbd3027a33$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $8da41afbd3027a33$export$700979bc83e7db82);

var $bSJIT = parcelRequire("bSJIT");
var $8da41afbd3027a33$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $8da41afbd3027a33$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $8da41afbd3027a33$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $8da41afbd3027a33$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $8da41afbd3027a33$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $8da41afbd3027a33$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $bSJIT.useLayoutEffect : $bSJIT.useEffect;

});

parcelRegister("em1l4", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $a734289dae1d3783$export$f4d5bf230a36dd6e);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $eDeOg = parcelRequire("eDeOg");

var $78bx9 = parcelRequire("78bx9");

var $c9X19 = parcelRequire("c9X19");
var $a734289dae1d3783$var$EMPTY_MODIFIERS = [];
var $a734289dae1d3783$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $bSJIT.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $a734289dae1d3783$var$EMPTY_MODIFIERS
    };
    var _React$useState = $bSJIT.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $bSJIT.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $4Sf72.flushSync(function() {
                    setState({
                        styles: (0, $c9X19.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $c9X19.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $bSJIT.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($78bx9)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $bSJIT.useRef();
    (0, $c9X19.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $c9X19.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $eDeOg.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("eDeOg", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $aa70321fb2f2d3c2$export$8f7491d57c8f97a9);

var $iCxiq = parcelRequire("iCxiq");

var $kKRbV = parcelRequire("kKRbV");

var $KjIr3 = parcelRequire("KjIr3");

var $b5HIG = parcelRequire("b5HIG");

var $7XKHv = parcelRequire("7XKHv");

var $3beNh = parcelRequire("3beNh");

var $cQIPs = parcelRequire("cQIPs");

var $kc3U6 = parcelRequire("kc3U6");

var $gvzOP = parcelRequire("gvzOP");

var $7yujs = parcelRequire("7yujs");


var $aa70321fb2f2d3c2$export$d34966752335dd47 = [
    (0, $kKRbV.default),
    (0, $KjIr3.default),
    (0, $b5HIG.default),
    (0, $7XKHv.default),
    (0, $3beNh.default),
    (0, $cQIPs.default),
    (0, $kc3U6.default),
    (0, $gvzOP.default),
    (0, $7yujs.default)
];
var $aa70321fb2f2d3c2$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $iCxiq.popperGenerator)({
    defaultModifiers: $aa70321fb2f2d3c2$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("iCxiq", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $d8e59a83982afba6$export$ed5e13716264f202);

var $37C0z = parcelRequire("37C0z");

var $e4Emj = parcelRequire("e4Emj");

var $ky8GL = parcelRequire("ky8GL");

var $ebnzC = parcelRequire("ebnzC");

var $220Az = parcelRequire("220Az");

var $i32lh = parcelRequire("i32lh");

var $bqApr = parcelRequire("bqApr");


var $kzIwr = parcelRequire("kzIwr");
var $d8e59a83982afba6$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $d8e59a83982afba6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $d8e59a83982afba6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $d8e59a83982afba6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $d8e59a83982afba6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kzIwr.isElement)(reference) ? (0, $ky8GL.default)(reference) : reference.contextElement ? (0, $ky8GL.default)(reference.contextElement) : [],
                    popper: (0, $ky8GL.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $220Az.default)((0, $bqApr.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$d8e59a83982afba6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $37C0z.default)(reference, (0, $ebnzC.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $e4Emj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $i32lh.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$d8e59a83982afba6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $d8e59a83982afba6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $d8e59a83982afba6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("37C0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $245f822cf73e24ce$export$2e2bcd8739ae039);

var $2kurF = parcelRequire("2kurF");

var $b8aDT = parcelRequire("b8aDT");

var $eEbQv = parcelRequire("eEbQv");

var $kzIwr = parcelRequire("kzIwr");

var $c1hq8 = parcelRequire("c1hq8");

var $3e4zL = parcelRequire("3e4zL");

var $4WH0c = parcelRequire("4WH0c");

var $d5OO4 = parcelRequire("d5OO4");
function $245f822cf73e24ce$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $d5OO4.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $d5OO4.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $245f822cf73e24ce$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kzIwr.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kzIwr.isHTMLElement)(offsetParent) && $245f822cf73e24ce$var$isElementScaled(offsetParent);
    var documentElement = (0, $3e4zL.default)(offsetParent);
    var rect = (0, $2kurF.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $eEbQv.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $4WH0c.default)(documentElement)) scroll = (0, $b8aDT.default)(offsetParent);
        if ((0, $kzIwr.isHTMLElement)(offsetParent)) {
            offsets = (0, $2kurF.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $c1hq8.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2kurF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b2510d530607c53$export$2e2bcd8739ae039);

var $kzIwr = parcelRequire("kzIwr");

var $d5OO4 = parcelRequire("d5OO4");

var $8xrEc = parcelRequire("8xrEc");

var $cmZWn = parcelRequire("cmZWn");
function $1b2510d530607c53$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kzIwr.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $d5OO4.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $d5OO4.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kzIwr.isElement)(element) ? (0, $8xrEc.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $cmZWn.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("kzIwr", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $efa99cb759505d5f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $efa99cb759505d5f$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $efa99cb759505d5f$export$af51f0f06c0f328a);

var $8xrEc = parcelRequire("8xrEc");
function $efa99cb759505d5f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $8xrEc.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $efa99cb759505d5f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $8xrEc.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $efa99cb759505d5f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $8xrEc.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("8xrEc", function(module, exports) {
$parcel$export(module.exports, "default", () => $6376d9fdce15596a$export$2e2bcd8739ae039);
function $6376d9fdce15596a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("d5OO4", function(module, exports) {
$parcel$export(module.exports, "max", () => $98832724f0721deb$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $98832724f0721deb$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $98832724f0721deb$export$2077e0241d6afd3c);
var $98832724f0721deb$export$8960430cfd85939f = Math.max;
var $98832724f0721deb$export$96ec731ed4dcb222 = Math.min;
var $98832724f0721deb$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("cmZWn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9017963afdb8237e$export$2e2bcd8739ae039);

var $28oKT = parcelRequire("28oKT");
function $9017963afdb8237e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $28oKT.default)());
}

});
parcelRegister("28oKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $18df87fffba07783$export$2e2bcd8739ae039);
function $18df87fffba07783$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("b8aDT", function(module, exports) {
$parcel$export(module.exports, "default", () => $81a8b26cbf3c36e8$export$2e2bcd8739ae039);

var $5Ukjo = parcelRequire("5Ukjo");

var $8xrEc = parcelRequire("8xrEc");

var $kzIwr = parcelRequire("kzIwr");

var $1dWxy = parcelRequire("1dWxy");
function $81a8b26cbf3c36e8$export$2e2bcd8739ae039(node) {
    if (node === (0, $8xrEc.default)(node) || !(0, $kzIwr.isHTMLElement)(node)) return (0, $5Ukjo.default)(node);
    else return (0, $1dWxy.default)(node);
}

});
parcelRegister("5Ukjo", function(module, exports) {
$parcel$export(module.exports, "default", () => $44d1f03b331717a2$export$2e2bcd8739ae039);

var $8xrEc = parcelRequire("8xrEc");
function $44d1f03b331717a2$export$2e2bcd8739ae039(node) {
    var win = (0, $8xrEc.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("1dWxy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e446a39ed1b0d9d$export$2e2bcd8739ae039);
function $0e446a39ed1b0d9d$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("eEbQv", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa9dfd6fd00afa26$export$2e2bcd8739ae039);
function $aa9dfd6fd00afa26$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("c1hq8", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c0317690a9d8817$export$2e2bcd8739ae039);

var $2kurF = parcelRequire("2kurF");

var $3e4zL = parcelRequire("3e4zL");

var $5Ukjo = parcelRequire("5Ukjo");
function $8c0317690a9d8817$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2kurF.default)((0, $3e4zL.default)(element)).left + (0, $5Ukjo.default)(element).scrollLeft;
}

});
parcelRegister("3e4zL", function(module, exports) {
$parcel$export(module.exports, "default", () => $25963a982be6f3e0$export$2e2bcd8739ae039);

var $kzIwr = parcelRequire("kzIwr");
function $25963a982be6f3e0$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kzIwr.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("4WH0c", function(module, exports) {
$parcel$export(module.exports, "default", () => $399def92c2eef4af$export$2e2bcd8739ae039);

var $b1IYK = parcelRequire("b1IYK");
function $399def92c2eef4af$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $b1IYK.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("b1IYK", function(module, exports) {
$parcel$export(module.exports, "default", () => $8072ad8bc93b4ee5$export$2e2bcd8739ae039);

var $8xrEc = parcelRequire("8xrEc");
function $8072ad8bc93b4ee5$export$2e2bcd8739ae039(element) {
    return (0, $8xrEc.default)(element).getComputedStyle(element);
}

});



parcelRegister("e4Emj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3f0bedda0e061f3$export$2e2bcd8739ae039);

var $2kurF = parcelRequire("2kurF");
function $a3f0bedda0e061f3$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2kurF.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("ky8GL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef5db902bee58c5f$export$2e2bcd8739ae039);

var $jJS3N = parcelRequire("jJS3N");

var $cG1Ab = parcelRequire("cG1Ab");

var $8xrEc = parcelRequire("8xrEc");

var $4WH0c = parcelRequire("4WH0c");
function $ef5db902bee58c5f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $jJS3N.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $8xrEc.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $4WH0c.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ef5db902bee58c5f$export$2e2bcd8739ae039((0, $cG1Ab.default)(target)));
}

});
parcelRegister("jJS3N", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5ec27830a09455a$export$2e2bcd8739ae039);

var $cG1Ab = parcelRequire("cG1Ab");

var $4WH0c = parcelRequire("4WH0c");

var $eEbQv = parcelRequire("eEbQv");

var $kzIwr = parcelRequire("kzIwr");
function $e5ec27830a09455a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $eEbQv.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kzIwr.isHTMLElement)(node) && (0, $4WH0c.default)(node)) return node;
    return $e5ec27830a09455a$export$2e2bcd8739ae039((0, $cG1Ab.default)(node));
}

});
parcelRegister("cG1Ab", function(module, exports) {
$parcel$export(module.exports, "default", () => $93aaa28eeeffbce6$export$2e2bcd8739ae039);

var $eEbQv = parcelRequire("eEbQv");

var $3e4zL = parcelRequire("3e4zL");

var $kzIwr = parcelRequire("kzIwr");
function $93aaa28eeeffbce6$export$2e2bcd8739ae039(element) {
    if ((0, $eEbQv.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kzIwr.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $3e4zL.default)(element) // fallback
    );
}

});



parcelRegister("ebnzC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a53460f503d38e06$export$2e2bcd8739ae039);

var $8xrEc = parcelRequire("8xrEc");

var $eEbQv = parcelRequire("eEbQv");

var $b1IYK = parcelRequire("b1IYK");

var $kzIwr = parcelRequire("kzIwr");

var $9B8J1 = parcelRequire("9B8J1");

var $cG1Ab = parcelRequire("cG1Ab");

var $28oKT = parcelRequire("28oKT");
function $a53460f503d38e06$var$getTrueOffsetParent(element) {
    if (!(0, $kzIwr.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $b1IYK.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a53460f503d38e06$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $28oKT.default)());
    var isIE = /Trident/i.test((0, $28oKT.default)());
    if (isIE && (0, $kzIwr.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $b1IYK.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $cG1Ab.default)(element);
    if ((0, $kzIwr.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kzIwr.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $eEbQv.default)(currentNode)) < 0){
        var css = (0, $b1IYK.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a53460f503d38e06$export$2e2bcd8739ae039(element) {
    var window = (0, $8xrEc.default)(element);
    var offsetParent = $a53460f503d38e06$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $9B8J1.default)(offsetParent) && (0, $b1IYK.default)(offsetParent).position === 'static')offsetParent = $a53460f503d38e06$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $eEbQv.default)(offsetParent) === 'html' || (0, $eEbQv.default)(offsetParent) === 'body' && (0, $b1IYK.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $a53460f503d38e06$var$getContainingBlock(element) || window;
}

});
parcelRegister("9B8J1", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fce5660d1a97ee0$export$2e2bcd8739ae039);

var $eEbQv = parcelRequire("eEbQv");
function $6fce5660d1a97ee0$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $eEbQv.default)(element)) >= 0;
}

});


parcelRegister("220Az", function(module, exports) {
$parcel$export(module.exports, "default", () => $17ac399bae35b77f$export$2e2bcd8739ae039);

var $1FEFy = parcelRequire("1FEFy");
function $17ac399bae35b77f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $17ac399bae35b77f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $17ac399bae35b77f$var$order(modifiers); // order based on phase
    return (0, $1FEFy.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1FEFy", function(module, exports) {
$parcel$export(module.exports, "top", () => $13792ad692bc9323$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $13792ad692bc9323$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $13792ad692bc9323$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $13792ad692bc9323$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $13792ad692bc9323$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $13792ad692bc9323$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $13792ad692bc9323$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $13792ad692bc9323$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $13792ad692bc9323$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $13792ad692bc9323$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $13792ad692bc9323$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $13792ad692bc9323$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $13792ad692bc9323$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $13792ad692bc9323$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $13792ad692bc9323$export$d087d3878fdf71d5);
var $13792ad692bc9323$export$1e95b668f3b82d = 'top';
var $13792ad692bc9323$export$40e543e69a8b3fbb = 'bottom';
var $13792ad692bc9323$export$79ffe56a765070d2 = 'right';
var $13792ad692bc9323$export$eabcd2c8791e7bf4 = 'left';
var $13792ad692bc9323$export$dfb5619354ba860 = 'auto';
var $13792ad692bc9323$export$aec2ce47c367b8c3 = [
    $13792ad692bc9323$export$1e95b668f3b82d,
    $13792ad692bc9323$export$40e543e69a8b3fbb,
    $13792ad692bc9323$export$79ffe56a765070d2,
    $13792ad692bc9323$export$eabcd2c8791e7bf4
];
var $13792ad692bc9323$export$b3571188c770cc5a = 'start';
var $13792ad692bc9323$export$bd5df0f255a350f8 = 'end';
var $13792ad692bc9323$export$390fd549c5303b4d = 'clippingParents';
var $13792ad692bc9323$export$d7b7311ec04a3e8f = 'viewport';
var $13792ad692bc9323$export$ae5ab1c730825774 = 'popper';
var $13792ad692bc9323$export$ca50aac9f3ba507f = 'reference';
var $13792ad692bc9323$export$368f9a87e87fa4e1 = /*#__PURE__*/ $13792ad692bc9323$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $13792ad692bc9323$export$b3571188c770cc5a,
        placement + "-" + $13792ad692bc9323$export$bd5df0f255a350f8
    ]);
}, []);
var $13792ad692bc9323$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($13792ad692bc9323$export$aec2ce47c367b8c3, [
    $13792ad692bc9323$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $13792ad692bc9323$export$b3571188c770cc5a,
        placement + "-" + $13792ad692bc9323$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $13792ad692bc9323$export$421679a7c3d56e = 'beforeRead';
var $13792ad692bc9323$export$aafa59e2e03f2942 = 'read';
var $13792ad692bc9323$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $13792ad692bc9323$export$c65e99957a05207c = 'beforeMain';
var $13792ad692bc9323$export$f22da7240b7add18 = 'main';
var $13792ad692bc9323$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $13792ad692bc9323$export$8d4d2d70e7d46032 = 'beforeWrite';
var $13792ad692bc9323$export$68d8715fc104d294 = 'write';
var $13792ad692bc9323$export$70a6e5159acce2e6 = 'afterWrite';
var $13792ad692bc9323$export$d087d3878fdf71d5 = [
    $13792ad692bc9323$export$421679a7c3d56e,
    $13792ad692bc9323$export$aafa59e2e03f2942,
    $13792ad692bc9323$export$6964f6c886723980,
    $13792ad692bc9323$export$c65e99957a05207c,
    $13792ad692bc9323$export$f22da7240b7add18,
    $13792ad692bc9323$export$bab79516f2d662fe,
    $13792ad692bc9323$export$8d4d2d70e7d46032,
    $13792ad692bc9323$export$68d8715fc104d294,
    $13792ad692bc9323$export$70a6e5159acce2e6
];

});


parcelRegister("i32lh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d23a52e9f72925fa$export$2e2bcd8739ae039);
function $d23a52e9f72925fa$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("bqApr", function(module, exports) {
$parcel$export(module.exports, "default", () => $851e5d8e7c16df59$export$2e2bcd8739ae039);
function $851e5d8e7c16df59$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("kKRbV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1c15d339e4f9f50$export$2e2bcd8739ae039);

var $8xrEc = parcelRequire("8xrEc");
var $f1c15d339e4f9f50$var$passive = {
    passive: true
};
function $f1c15d339e4f9f50$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $8xrEc.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $f1c15d339e4f9f50$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $f1c15d339e4f9f50$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $f1c15d339e4f9f50$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $f1c15d339e4f9f50$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $f1c15d339e4f9f50$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $f1c15d339e4f9f50$var$effect,
    data: {}
};

});

parcelRegister("KjIr3", function(module, exports) {
$parcel$export(module.exports, "default", () => $08b3971e98ce508d$export$2e2bcd8739ae039);

var $ddX9z = parcelRequire("ddX9z");
function $08b3971e98ce508d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $ddX9z.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $08b3971e98ce508d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $08b3971e98ce508d$var$popperOffsets,
    data: {}
};

});
parcelRegister("ddX9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a0a5fdf499f3ae9$export$2e2bcd8739ae039);

var $hdrOT = parcelRequire("hdrOT");

var $4C2xf = parcelRequire("4C2xf");

var $eJdlE = parcelRequire("eJdlE");

var $1FEFy = parcelRequire("1FEFy");
function $9a0a5fdf499f3ae9$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $hdrOT.default)(placement) : null;
    var variation = placement ? (0, $4C2xf.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1FEFy.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1FEFy.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1FEFy.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1FEFy.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $eJdlE.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1FEFy.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1FEFy.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("hdrOT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8893b00f0fffad9$export$2e2bcd8739ae039);

function $c8893b00f0fffad9$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("4C2xf", function(module, exports) {
$parcel$export(module.exports, "default", () => $35bcad8023de4929$export$2e2bcd8739ae039);
function $35bcad8023de4929$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("eJdlE", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab8f9f5756dcb72c$export$2e2bcd8739ae039);
function $ab8f9f5756dcb72c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("b5HIG", function(module, exports) {
$parcel$export(module.exports, "default", () => $813213285fff0e2c$export$2e2bcd8739ae039);

var $1FEFy = parcelRequire("1FEFy");

var $ebnzC = parcelRequire("ebnzC");

var $8xrEc = parcelRequire("8xrEc");

var $3e4zL = parcelRequire("3e4zL");

var $b1IYK = parcelRequire("b1IYK");

var $hdrOT = parcelRequire("hdrOT");

var $4C2xf = parcelRequire("4C2xf");

var $d5OO4 = parcelRequire("d5OO4");
var $813213285fff0e2c$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $813213285fff0e2c$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $d5OO4.round)(x * dpr) / dpr || 0,
        y: (0, $d5OO4.round)(y * dpr) / dpr || 0
    };
}
function $813213285fff0e2c$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1FEFy.left);
    var sideY = (0, $1FEFy.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ebnzC.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $8xrEc.default)(popper)) {
            offsetParent = (0, $3e4zL.default)(popper);
            if ((0, $b1IYK.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1FEFy.top) || (placement === (0, $1FEFy.left) || placement === (0, $1FEFy.right)) && variation === (0, $1FEFy.end)) {
            sideY = (0, $1FEFy.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1FEFy.left) || (placement === (0, $1FEFy.top) || placement === (0, $1FEFy.bottom)) && variation === (0, $1FEFy.end)) {
            sideX = (0, $1FEFy.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $813213285fff0e2c$var$unsetSides);
    var _ref4 = roundOffsets === true ? $813213285fff0e2c$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $8xrEc.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $813213285fff0e2c$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $hdrOT.default)(state.placement),
        variation: (0, $4C2xf.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $813213285fff0e2c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $813213285fff0e2c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $813213285fff0e2c$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $813213285fff0e2c$var$computeStyles,
    data: {}
};

});

parcelRegister("7XKHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cc244e13525e59d$export$2e2bcd8739ae039);

var $eEbQv = parcelRequire("eEbQv");

var $kzIwr = parcelRequire("kzIwr");
// and applies them to the HTMLElements such as popper and arrow
function $5cc244e13525e59d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kzIwr.isHTMLElement)(element) || !(0, $eEbQv.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5cc244e13525e59d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kzIwr.isHTMLElement)(element) || !(0, $eEbQv.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5cc244e13525e59d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5cc244e13525e59d$var$applyStyles,
    effect: $5cc244e13525e59d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("3beNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $250ddfe7b37f2a62$export$2e2bcd8739ae039);

var $hdrOT = parcelRequire("hdrOT");

var $1FEFy = parcelRequire("1FEFy");
function $250ddfe7b37f2a62$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $hdrOT.default)(placement);
    var invertDistance = [
        (0, $1FEFy.left),
        (0, $1FEFy.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1FEFy.left),
        (0, $1FEFy.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $250ddfe7b37f2a62$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1FEFy.placements).reduce(function(acc, placement) {
        acc[placement] = $250ddfe7b37f2a62$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $250ddfe7b37f2a62$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $250ddfe7b37f2a62$var$offset
};

});

parcelRegister("cQIPs", function(module, exports) {
$parcel$export(module.exports, "default", () => $95ad1d750dbd78f6$export$2e2bcd8739ae039);

var $7pKIp = parcelRequire("7pKIp");

var $hdrOT = parcelRequire("hdrOT");

var $fFwID = parcelRequire("fFwID");

var $4vxJq = parcelRequire("4vxJq");

var $2kPSs = parcelRequire("2kPSs");

var $1FEFy = parcelRequire("1FEFy");

var $4C2xf = parcelRequire("4C2xf");
function $95ad1d750dbd78f6$var$getExpandedFallbackPlacements(placement) {
    if ((0, $hdrOT.default)(placement) === (0, $1FEFy.auto)) return [];
    var oppositePlacement = (0, $7pKIp.default)(placement);
    return [
        (0, $fFwID.default)(placement),
        oppositePlacement,
        (0, $fFwID.default)(oppositePlacement)
    ];
}
function $95ad1d750dbd78f6$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $hdrOT.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $7pKIp.default)(preferredPlacement)
    ] : $95ad1d750dbd78f6$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $hdrOT.default)(placement) === (0, $1FEFy.auto) ? (0, $2kPSs.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $hdrOT.default)(placement);
        var isStartVariation = (0, $4C2xf.default)(placement) === (0, $1FEFy.start);
        var isVertical = [
            (0, $1FEFy.top),
            (0, $1FEFy.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $4vxJq.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1FEFy.right) : (0, $1FEFy.left) : isStartVariation ? (0, $1FEFy.bottom) : (0, $1FEFy.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $7pKIp.default)(mainVariationSide);
        var altVariationSide = (0, $7pKIp.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $95ad1d750dbd78f6$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $95ad1d750dbd78f6$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("7pKIp", function(module, exports) {
$parcel$export(module.exports, "default", () => $565f1ae57374202f$export$2e2bcd8739ae039);
var $565f1ae57374202f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $565f1ae57374202f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $565f1ae57374202f$var$hash[matched];
    });
}

});

parcelRegister("fFwID", function(module, exports) {
$parcel$export(module.exports, "default", () => $b684109f5e6134bb$export$2e2bcd8739ae039);
var $b684109f5e6134bb$var$hash = {
    start: 'end',
    end: 'start'
};
function $b684109f5e6134bb$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b684109f5e6134bb$var$hash[matched];
    });
}

});

parcelRegister("4vxJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3484390ef3c29eee$export$2e2bcd8739ae039);

var $ll5Gr = parcelRequire("ll5Gr");

var $3e4zL = parcelRequire("3e4zL");

var $2kurF = parcelRequire("2kurF");

var $ddX9z = parcelRequire("ddX9z");

var $i2AhN = parcelRequire("i2AhN");

var $1FEFy = parcelRequire("1FEFy");

var $kzIwr = parcelRequire("kzIwr");

var $iePL9 = parcelRequire("iePL9");

var $e8P0e = parcelRequire("e8P0e");
function $3484390ef3c29eee$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1FEFy.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1FEFy.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1FEFy.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $iePL9.default)(typeof padding !== 'number' ? padding : (0, $e8P0e.default)(padding, (0, $1FEFy.basePlacements)));
    var altContext = elementContext === (0, $1FEFy.popper) ? (0, $1FEFy.reference) : (0, $1FEFy.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $ll5Gr.default)((0, $kzIwr.isElement)(element) ? element : element.contextElement || (0, $3e4zL.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2kurF.default)(state.elements.reference);
    var popperOffsets = (0, $ddX9z.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $i2AhN.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1FEFy.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1FEFy.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1FEFy.right),
                (0, $1FEFy.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1FEFy.top),
                (0, $1FEFy.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("ll5Gr", function(module, exports) {
$parcel$export(module.exports, "default", () => $f88ff7c2ed3b81bc$export$2e2bcd8739ae039);

var $1FEFy = parcelRequire("1FEFy");

var $93OIb = parcelRequire("93OIb");

var $b1DIa = parcelRequire("b1DIa");

var $ky8GL = parcelRequire("ky8GL");

var $ebnzC = parcelRequire("ebnzC");

var $3e4zL = parcelRequire("3e4zL");

var $b1IYK = parcelRequire("b1IYK");

var $kzIwr = parcelRequire("kzIwr");

var $2kurF = parcelRequire("2kurF");

var $cG1Ab = parcelRequire("cG1Ab");

var $9PYdT = parcelRequire("9PYdT");

var $eEbQv = parcelRequire("eEbQv");

var $i2AhN = parcelRequire("i2AhN");

var $d5OO4 = parcelRequire("d5OO4");
function $f88ff7c2ed3b81bc$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2kurF.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $f88ff7c2ed3b81bc$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1FEFy.viewport) ? (0, $i2AhN.default)((0, $93OIb.default)(element, strategy)) : (0, $kzIwr.isElement)(clippingParent) ? $f88ff7c2ed3b81bc$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $i2AhN.default)((0, $b1DIa.default)((0, $3e4zL.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $f88ff7c2ed3b81bc$var$getClippingParents(element) {
    var clippingParents = (0, $ky8GL.default)((0, $cG1Ab.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $b1IYK.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kzIwr.isHTMLElement)(element) ? (0, $ebnzC.default)(element) : element;
    if (!(0, $kzIwr.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kzIwr.isElement)(clippingParent) && (0, $9PYdT.default)(clippingParent, clipperElement) && (0, $eEbQv.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $f88ff7c2ed3b81bc$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $f88ff7c2ed3b81bc$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $f88ff7c2ed3b81bc$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $d5OO4.max)(rect.top, accRect.top);
        accRect.right = (0, $d5OO4.min)(rect.right, accRect.right);
        accRect.bottom = (0, $d5OO4.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $d5OO4.max)(rect.left, accRect.left);
        return accRect;
    }, $f88ff7c2ed3b81bc$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("93OIb", function(module, exports) {
$parcel$export(module.exports, "default", () => $698bbb26677eb4fc$export$2e2bcd8739ae039);

var $8xrEc = parcelRequire("8xrEc");

var $3e4zL = parcelRequire("3e4zL");

var $c1hq8 = parcelRequire("c1hq8");

var $cmZWn = parcelRequire("cmZWn");
function $698bbb26677eb4fc$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $8xrEc.default)(element);
    var html = (0, $3e4zL.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $cmZWn.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $c1hq8.default)(element),
        y: y
    };
}

});

parcelRegister("b1DIa", function(module, exports) {
$parcel$export(module.exports, "default", () => $806e97922c270145$export$2e2bcd8739ae039);

var $3e4zL = parcelRequire("3e4zL");

var $b1IYK = parcelRequire("b1IYK");

var $c1hq8 = parcelRequire("c1hq8");

var $5Ukjo = parcelRequire("5Ukjo");

var $d5OO4 = parcelRequire("d5OO4");
function $806e97922c270145$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $3e4zL.default)(element);
    var winScroll = (0, $5Ukjo.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $d5OO4.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $d5OO4.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $c1hq8.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $b1IYK.default)(body || html).direction === 'rtl') x += (0, $d5OO4.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("9PYdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $72979780e45018c2$export$2e2bcd8739ae039);

var $kzIwr = parcelRequire("kzIwr");
function $72979780e45018c2$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kzIwr.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("i2AhN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2248f8ec96a4d65$export$2e2bcd8739ae039);
function $d2248f8ec96a4d65$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("iePL9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d471af233b38d83b$export$2e2bcd8739ae039);

var $3nmJ3 = parcelRequire("3nmJ3");
function $d471af233b38d83b$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $3nmJ3.default)(), paddingObject);
}

});
parcelRegister("3nmJ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $275525f37b8716ec$export$2e2bcd8739ae039);
function $275525f37b8716ec$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("e8P0e", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4b9601efa343271$export$2e2bcd8739ae039);
function $a4b9601efa343271$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("2kPSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b35b0c6df210fdc$export$2e2bcd8739ae039);

var $4C2xf = parcelRequire("4C2xf");

var $1FEFy = parcelRequire("1FEFy");

var $4vxJq = parcelRequire("4vxJq");

var $hdrOT = parcelRequire("hdrOT");
function $1b35b0c6df210fdc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1FEFy.placements) : _options$allowedAutoP;
    var variation = (0, $4C2xf.default)(placement);
    var placements = variation ? flipVariations ? (0, $1FEFy.variationPlacements) : (0, $1FEFy.variationPlacements).filter(function(placement) {
        return (0, $4C2xf.default)(placement) === variation;
    }) : (0, $1FEFy.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $4vxJq.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $hdrOT.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("kc3U6", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb37f4e0055a0e7d$export$2e2bcd8739ae039);

var $1FEFy = parcelRequire("1FEFy");

var $hdrOT = parcelRequire("hdrOT");

var $eJdlE = parcelRequire("eJdlE");

var $dmDU4 = parcelRequire("dmDU4");

var $kfQYm = parcelRequire("kfQYm");

var $e4Emj = parcelRequire("e4Emj");

var $ebnzC = parcelRequire("ebnzC");

var $4vxJq = parcelRequire("4vxJq");

var $4C2xf = parcelRequire("4C2xf");

var $3nmJ3 = parcelRequire("3nmJ3");

var $d5OO4 = parcelRequire("d5OO4");
function $eb37f4e0055a0e7d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $4vxJq.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $hdrOT.default)(state.placement);
    var variation = (0, $4C2xf.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $eJdlE.default)(basePlacement);
    var altAxis = (0, $dmDU4.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1FEFy.top) : (0, $1FEFy.left);
        var altSide = mainAxis === 'y' ? (0, $1FEFy.bottom) : (0, $1FEFy.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1FEFy.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1FEFy.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $e4Emj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $3nmJ3.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $kfQYm.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ebnzC.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $kfQYm.within)(tether ? (0, $d5OO4.min)(min, tetherMin) : min, offset, tether ? (0, $d5OO4.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1FEFy.top) : (0, $1FEFy.left);
        var _altSide = mainAxis === 'x' ? (0, $1FEFy.bottom) : (0, $1FEFy.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1FEFy.top),
            (0, $1FEFy.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $kfQYm.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $kfQYm.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $eb37f4e0055a0e7d$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $eb37f4e0055a0e7d$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dmDU4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bac486d50ba5776$export$2e2bcd8739ae039);
function $9bac486d50ba5776$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("kfQYm", function(module, exports) {
$parcel$export(module.exports, "within", () => $ebee4c9655978213$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $ebee4c9655978213$export$86c8af6d3ef0b4a);

var $d5OO4 = parcelRequire("d5OO4");
function $ebee4c9655978213$export$f28d906d67a997f3(min, value, max) {
    return (0, $d5OO4.max)(min, (0, $d5OO4.min)(value, max));
}
function $ebee4c9655978213$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ebee4c9655978213$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gvzOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $c04b5372245b4d1f$export$2e2bcd8739ae039);

var $hdrOT = parcelRequire("hdrOT");

var $e4Emj = parcelRequire("e4Emj");

var $9PYdT = parcelRequire("9PYdT");

var $ebnzC = parcelRequire("ebnzC");

var $eJdlE = parcelRequire("eJdlE");

var $kfQYm = parcelRequire("kfQYm");

var $iePL9 = parcelRequire("iePL9");

var $e8P0e = parcelRequire("e8P0e");

var $1FEFy = parcelRequire("1FEFy");
var $c04b5372245b4d1f$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $iePL9.default)(typeof padding !== 'number' ? padding : (0, $e8P0e.default)(padding, (0, $1FEFy.basePlacements)));
};
function $c04b5372245b4d1f$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $hdrOT.default)(state.placement);
    var axis = (0, $eJdlE.default)(basePlacement);
    var isVertical = [
        (0, $1FEFy.left),
        (0, $1FEFy.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c04b5372245b4d1f$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $e4Emj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1FEFy.top) : (0, $1FEFy.left);
    var maxProp = axis === 'y' ? (0, $1FEFy.bottom) : (0, $1FEFy.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ebnzC.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $kfQYm.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c04b5372245b4d1f$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $9PYdT.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c04b5372245b4d1f$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c04b5372245b4d1f$var$arrow,
    effect: $c04b5372245b4d1f$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("7yujs", function(module, exports) {
$parcel$export(module.exports, "default", () => $580338dbb4505aab$export$2e2bcd8739ae039);

var $1FEFy = parcelRequire("1FEFy");

var $4vxJq = parcelRequire("4vxJq");
function $580338dbb4505aab$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $580338dbb4505aab$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1FEFy.top),
        (0, $1FEFy.right),
        (0, $1FEFy.bottom),
        (0, $1FEFy.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $580338dbb4505aab$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $4vxJq.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $4vxJq.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $580338dbb4505aab$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $580338dbb4505aab$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $580338dbb4505aab$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $580338dbb4505aab$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $580338dbb4505aab$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $580338dbb4505aab$var$hide
};

});


parcelRegister("78bx9", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $53123a1eb8575a33$var$hasElementType = typeof Element !== 'undefined';
var $53123a1eb8575a33$var$hasMap = typeof Map === 'function';
var $53123a1eb8575a33$var$hasSet = typeof Set === 'function';
var $53123a1eb8575a33$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $53123a1eb8575a33$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$53123a1eb8575a33$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($53123a1eb8575a33$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$53123a1eb8575a33$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($53123a1eb8575a33$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($53123a1eb8575a33$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($53123a1eb8575a33$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$53123a1eb8575a33$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $53123a1eb8575a33$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("cHkkv", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $b915cf37f5fa95da$export$6d8c2b45c99d6e3f);
function $b915cf37f5fa95da$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                var _data$viewport, _data$viewport2, _state$modifiersData;
                const data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = ((_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("gqj7z", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $ed66b87ac5d94773$export$9802f50720ab826e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $65Dj6 = parcelRequire("65Dj6");

var $jfBg8 = parcelRequire("jfBg8");

var $7nmZk = parcelRequire("7nmZk");

var $8Ihum = parcelRequire("8Ihum");

var $jFqOs = parcelRequire("jFqOs");

var $4mi4Q = parcelRequire("4mi4Q");

var $4AqC0 = parcelRequire("4AqC0");

var $lloz0 = parcelRequire("lloz0");

var $d3Exm = parcelRequire("d3Exm");

var $ctYhw = parcelRequire("ctYhw");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $ed66b87ac5d94773$var$noopStyle = {};
const $ed66b87ac5d94773$var$noopSetRef = (0, $1OdZP.default);
const $ed66b87ac5d94773$var$noopUpdate = ()=>Promise.resolve(null);
const $ed66b87ac5d94773$var$noopForceUpdate = ()=>({});
const $ed66b87ac5d94773$var$noopArrowProps = {
    ref: $ed66b87ac5d94773$var$noopSetRef,
    style: $ed66b87ac5d94773$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $ed66b87ac5d94773$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * SSR-safe `instanceof HTMLElement`. This runs during render, and the server
 * has no `HTMLElement` global. No hydration mismatch: refs are unset on the
 * server and on the first client render, so both sides get the same result.
 */ function $ed66b87ac5d94773$var$isHTMLElement(value) {
    return typeof HTMLElement !== 'undefined' && value instanceof HTMLElement;
}
function $ed66b87ac5d94773$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $d3Exm.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes are anchored by `useAnchoredPopover`; popper
    // `VirtualElement`s go to `useAnchoredPopoverAtPoint`, which owns a synthetic
    // anchor element in `document.body`.
    const htmlAnchor = $ed66b87ac5d94773$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !$ed66b87ac5d94773$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const htmlAnchorRef = (0, $bSJIT.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $bSJIT.useRef)(null);
    const popoverId = (0, $jFqOs.usePopoverId)();
    // Track the resolved DOM anchor in state so the visibility hook re-runs when
    // its identity changes. Virtual anchors do not feed that hook, because their
    // probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $bSJIT.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $bSJIT.useMemo)(()=>{
        return (0, $65Dj6.fromLegacyPlacement)({
            legacy: (0, $lloz0.toLegacyPlacement)(placement),
            offset: $ed66b87ac5d94773$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // Refs, because `getPoint` is LATCHED: called once per activation, so a
    // closed-over value would go stale if either prop changed while it stayed open.
    const virtualReferenceRef = (0, $bSJIT.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $bSJIT.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    // Two positioning hooks, at most one enabled: `htmlAnchor` and
    // `virtualReference` both derive from `effectiveReference`, so they are never
    // both set, and when neither is the popover is closed.
    const isElementAnchored = htmlAnchor !== null;
    const isPointAnchored = virtualReference !== null;
    // Passed as one object so the element and point calls cannot drift.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        inlineSize: shouldFitViewport ? 'max-available' : 'content',
        blockSize: shouldFitViewport ? 'max-available' : 'content'
    };
    (0, $7nmZk.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: htmlAnchorRef,
        isEnabled: isElementAnchored
    });
    (0, $8Ihum.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isPointAnchored,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $4AqC0.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $4mi4Q.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $ctYhw.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $ed66b87ac5d94773$var$noopSetRef,
        style: $ed66b87ac5d94773$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $ed66b87ac5d94773$var$noopUpdate,
        forceUpdate: $ed66b87ac5d94773$var$noopForceUpdate,
        arrowProps: $ed66b87ac5d94773$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // Rendered directly into the `<Popover>` host, which supplies the flex
    // formatting context the size caps need — so the render prop must return ONE
    // element. See `children` in `@atlaskit/top-layer`'s `popover/types.tsx`.
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jfBg8.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}

});
parcelRegister("65Dj6", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $b1746e2f7f2b159b$export$69e99ed50b2534c9);

var $7qZDc = parcelRequire("7qZDc");
function $b1746e2f7f2b159b$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $7qZDc.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("7qZDc", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $1cc9c5fa68f4fad8$export$27df359c528b7120);
const $1cc9c5fa68f4fad8$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("jfBg8", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $4dbeca520117078d$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ /* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $bAB3U = parcelRequire("bAB3U");

var $fGbV9 = parcelRequire("fGbV9");

var $bAWQa = parcelRequire("bAWQa");

var $ghAbV = parcelRequire("ghAbV");

var $6gXOx = parcelRequire("6gXOx");

var $f0XQL = parcelRequire("f0XQL");

var $e4JX7 = parcelRequire("e4JX7");

var $johsC = parcelRequire("johsC");

var $1hbON = parcelRequire("1hbON");

var $kj7Ld = parcelRequire("kj7Ld");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $4dbeca520117078d$var$restoreFocus({ popover: popover, focusRestorationTarget: focusRestorationTarget }) {
    if (!focusRestorationTarget) return;
    const { ownerDocument: ownerDocument } = popover;
    // Native restoration has finished. Preserve focus moved outside the popover.
    const activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $4dbeca520117078d$var$supportsPopoverHint = (0, $bAWQa.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
/**
 * **Surface reset**
 *
 * The host is still a DOM child of its trigger for inheritance, so it inherits
 * values like `pointer-events: none` or `white-space: nowrap`. Resets them to
 * what `<body>` gave the portal path. `font` and direction still inherit.
 * Not `all: initial`: that would also override the UA `[popover]` rules.
 *
 * `color` is a reset too: the UA `[popover]` rule sets `color: CanvasText`, so
 * the host never inherits a colour. `color.text` is what `<body>` gave the portal
 * path. Not `inherit`, which would take the trigger's colour (for example a link).
 * See `notes/decisions/surface-reset-color.md`.
 *
 * KEEP IN SYNC with `dialog/dialog-content.tsx` (ADS forbids shared styles).
 * The `satisfies` check below catches drift.
 */ const $4dbeca520117078d$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $4dbeca520117078d$var$styles = {
    root: "_lzhqglyw _az2pidpf _13shidpf _1mjeidpf _byz4idpf _b2a9idpf _z3e7idpf _1aqridpf _1ap0idpf _1vdi1wug _wmifewfl _1blzewfl _1rec1j28 _kqwmvrvc _1maw1q9c _17ke4jg8 _1ogd4jg8 _1dqv1n9t _qctn1ns9 _1rmr1wug _1yd01wug _li0iglyw _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1p7w1txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $4dbeca520117078d$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ const $4dbeca520117078d$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
const $4dbeca520117078d$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $bSJIT.useId)();
    const ownRef = (0, $bSJIT.useRef)(null);
    const combinedRef = (0, $fGbV9.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    const onCloseRef = (0, $bSJIT.useRef)(onClose);
    (0, $ghAbV.useLayoutEffect)(()=>{
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined. Without `onClose`
    // the layer cannot be closed, so it does not register.
    const handleObserverClose = (0, $bSJIT.useCallback)(()=>{
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        type: role && $4dbeca520117078d$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen && Boolean(onClose),
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$4dbeca520117078d$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $bSJIT.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $e4JX7.resolvePlacement)({
            placement: placement
        });
        return $4dbeca520117078d$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    const closeReasonRef = (0, $bSJIT.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    const focusRestorationTargetRef = (0, $bSJIT.useRef)(null);
    const handleBeforeToggle = (0, $bSJIT.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const { ownerDocument: ownerDocument } = popover;
        const { activeElement: activeElement } = ownerDocument;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    const handleToggleClosed = (0, $bSJIT.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        const reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $4dbeca520117078d$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $johsC.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $1hbON.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $kj7Ld.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $ghAbV.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $bAB3U.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $f0XQL.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $bAB3U.bind)(element, {
            type: 'toggle',
            listener: (event)=>{
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        const unbindBeforeToggle = (0, $bAB3U.bind)(element, {
            type: 'beforetoggle',
            listener: (event)=>{
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $ghAbV.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $4dbeca520117078d$var$styles.root,
            $4dbeca520117078d$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $4dbeca520117078d$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $4dbeca520117078d$var$styles.exit,
            shouldAnimate && $4dbeca520117078d$var$styles.motion,
            (0, $14TCm.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("14TCm", function(module, exports) {
$parcel$export(module.exports, "cx", () => $0c914ea991db9b3c$export$a274e22fb40f762e);

var $9fU1q = parcelRequire("9fU1q");
const $0c914ea991db9b3c$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9fU1q.default)(actualStyles);
};

});

parcelRegister("bAWQa", function(module, exports) {
$parcel$export(module.exports, "default", () => $185b5c94f0785bba$export$2e2bcd8739ae039);
function $185b5c94f0785bba$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("ghAbV", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $88a1457f8342523d$export$e5c5a5f917a5871c);

var $bSJIT = parcelRequire("bSJIT");
const $88a1457f8342523d$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);

});

parcelRegister("f0XQL", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $fe4ec2262104b7dc$export$89b923e18c14644d);
function $fe4ec2262104b7dc$export$89b923e18c14644d({ element: element }) {
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch  {
        return false;
    }
}

});

parcelRegister("e4JX7", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $94bb0dd8ccdcaa57$export$63044d21bc3d3fa2);

var $bulC0 = parcelRequire("bulC0");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const $94bb0dd8ccdcaa57$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $94bb0dd8ccdcaa57$export$63044d21bc3d3fa2({ placement: placement }) {
    var _placement$offset, _placement$offset2, _placement$offset3;
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $bulC0.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $bulC0.toCssLengthString)({
                value: ((_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) ?? $94bb0dd8ccdcaa57$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $bulC0.toCssLengthString)({
                    value: ((_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) ?? 0
                }),
                direction: ((_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("bulC0", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $5c28af9a949662b4$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $5c28af9a949662b4$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("johsC", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $1dedb86d50ff3d59$export$1bccb45daf07907f);

var $bSJIT = parcelRequire("bSJIT");

var $ghAbV = parcelRequire("ghAbV");

var $f0XQL = parcelRequire("f0XQL");

var $elsVP = parcelRequire("elsVP");
function $1dedb86d50ff3d59$var$runCancellableSettlement({ schedule: schedule, onSettled: onSettled }) {
    let isCancelled = false;
    schedule(()=>{
        if (isCancelled) return;
        onSettled();
    });
    return ()=>{
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $1dedb86d50ff3d59$var$runOnAnimationsSettled({ element: element, onSettled: onSettled }) {
    return $1dedb86d50ff3d59$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: (settle)=>{
            var _element$getAnimation;
            const animations = ((_element$getAnimation = element.getAnimations) === null || _element$getAnimation === void 0 ? void 0 : _element$getAnimation.call(element)) ?? [];
            Promise.allSettled(animations.map((animation)=>animation.finished)).then(settle);
        }
    });
}
function $1dedb86d50ff3d59$var$getInitialVisibilityState({ isOpen: isOpen, willAnimate: willAnimate }) {
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $1dedb86d50ff3d59$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        const shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return {
            ...state,
            controlledIntent: 'open'
        };
    }
    if (action.type === 'close-requested') return {
        ...state,
        controlledIntent: 'closed'
    };
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'exiting'
        };
    }
    // A browser dismiss started the exit, and something showed the element
    // again before the exit settled, while controlled intent stayed open. For
    // example, `@atlaskit/tooltip` re-shows after a light dismiss in the same
    // task. The element never painted closed, so go back to `open`.
    if (action.type === 'native-open-started') {
        if (state.phase !== 'exiting' || state.controlledIntent !== 'open') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return {
            ...state,
            phase: 'closed'
        };
    }
    return state;
}
function $1dedb86d50ff3d59$export$1bccb45daf07907f({ isOpen: isOpen, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $elsVP.prefersReducedMotion)();
    const [visibilityState, dispatch] = (0, $bSJIT.useReducer)($1dedb86d50ff3d59$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $1dedb86d50ff3d59$var$getInitialVisibilityState);
    const { phase: phase, controlledIntent: controlledIntent } = visibilityState;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, $bSJIT.useRef)(onEnterFinish);
    const onExitFinishRef = (0, $bSJIT.useRef)(onExitFinish);
    const willAnimateRef = (0, $bSJIT.useRef)(willAnimate);
    (0, $ghAbV.useLayoutEffect)(()=>{
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    const prevPhaseRef = (0, $bSJIT.useRef)('closed');
    (0, $bSJIT.useEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    const isMounted = phase !== 'closed';
    const cancelExitSettlementRef = (0, $bSJIT.useRef)(()=>{});
    // Exit must notify consumers before `closed` unmounts the host.
    const settleExit = (0, $bSJIT.useCallback)(()=>{
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    const onBeforeToggle = (0, $bSJIT.useCallback)((event)=>{
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        const element = event.currentTarget;
        if (event.newState === 'open') {
            if (element instanceof HTMLElement) {
                element.removeAttribute('inert');
                element.removeAttribute('aria-hidden');
            }
            // Dispatched on every native open. The reducer only acts when a browser
            // dismiss left the host `exiting` while `isOpen` stayed `true`.
            dispatch({
                type: 'native-open-started'
            });
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(()=>{
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $f0XQL.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    const onToggle = (0, $bSJIT.useCallback)((event)=>{
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $1dedb86d50ff3d59$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $1dedb86d50ff3d59$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $ghAbV.useLayoutEffect)(()=>()=>{
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $bSJIT.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        return $1dedb86d50ff3d59$var$runOnAnimationsSettled({
            element: element,
            onSettled () {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("elsVP", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $5a28c6f9b1d3f6fb$export$ff7706047246b98b);

var $bAWQa = parcelRequire("bAWQa");
const $5a28c6f9b1d3f6fb$export$ff7706047246b98b = (0, $bAWQa.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("1hbON", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $b6fbd3b7278d200b$export$4f6462e86a70abe5);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $ehZai = parcelRequire("ehZai");

var $eeNWO = parcelRequire("eeNWO");

var $leCCk = parcelRequire("leCCk");

var $gSzxC = parcelRequire("gSzxC");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/decisions/menu-keyboard.md
 */ function $b6fbd3b7278d200b$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $b6fbd3b7278d200b$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $bSJIT.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$b6fbd3b7278d200b$var$roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, $bAB3U.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $gSzxC.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, $leCCk.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, $ehZai.getFirstFocusable)({
                    container: element
                }) : (0, $eeNWO.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("ehZai", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $33b5c629c0fd7f58$export$748138f04a69bf21);

var $k0YUb = parcelRequire("k0YUb");
function $33b5c629c0fd7f58$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $k0YUb.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("k0YUb", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $0fce8b5509691dd4$export$f6768025e418420e);

var $9E8Bq = parcelRequire("9E8Bq");
const $0fce8b5509691dd4$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
const $0fce8b5509691dd4$var$exclusionSelector = $0fce8b5509691dd4$var$focusableExclusions.map((selector)=>`:not(${selector})`).join('');
const $0fce8b5509691dd4$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map((selector)=>`${selector}${$0fce8b5509691dd4$var$exclusionSelector}`).join(',');
function $0fce8b5509691dd4$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch  {
        return true;
    }
}
function $0fce8b5509691dd4$export$f6768025e418420e({ container: container, filter: filter }) {
    const containerLayer = (0, $9E8Bq.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($0fce8b5509691dd4$var$focusableSelector)).filter((element)=>{
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $9E8Bq.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$0fce8b5509691dd4$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("9E8Bq", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $7d5770d8f261cf29$export$3c9385904be131db);
function $7d5770d8f261cf29$export$3c9385904be131db({ element: element }) {
    return element.closest('[popover], dialog');
}

});



parcelRegister("eeNWO", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $6cbe77e8fc7d80d2$export$73e81fa65335a75b);

var $k0YUb = parcelRequire("k0YUb");
function $6cbe77e8fc7d80d2$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $k0YUb.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("leCCk", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $7947296c5eef23f0$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $k0YUb = parcelRequire("k0YUb");
function $7947296c5eef23f0$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const all = (0, $k0YUb.getFocusables)({
        container: container,
        filter: filter
    });
    const first = all[0];
    const last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    const current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    const index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        const followingIndex = all.findIndex((element)=>Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING));
        if (direction === 'forwards') // If nothing follows the current element, then wrap to the start.
        return all[followingIndex] ?? first;
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return all[followingIndex - 1] ?? last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') return all[index + 1] ?? first;
    return all[index - 1] ?? last;
}

});

parcelRegister("gSzxC", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $6b06a0bb146287de$export$b9590fdfeb5f722f);

var $9E8Bq = parcelRequire("9E8Bq");
function $6b06a0bb146287de$export$b9590fdfeb5f722f({ container: container }) {
    const focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $9E8Bq.getClosestLayer)({
        element: focused
    }) !== (0, $9E8Bq.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("kj7Ld", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $f04197de716c4c2e$export$e992c40175757a22);

var $bSJIT = parcelRequire("bSJIT");

var $ehZai = parcelRequire("ehZai");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox. This applies to `menu`, `listbox`, and to
 * `dialog` / `alertdialog` when the combobox is outside the dialog. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, menu, or dialog), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $f04197de716c4c2e$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $f04197de716c4c2e$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $f04197de716c4c2e$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $f04197de716c4c2e$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$f04197de716c4c2e$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $f04197de716c4c2e$var$getInitialFocusTarget({ container: container, role: role }) {
    if (role === 'dialog' || role === 'alertdialog') {
        // APG allows a combobox to control a dialog popup. Focus stays on the
        // combobox only when it is OUTSIDE the dialog. A dialog that contains
        // its own combobox still takes focus (see the comment below on why the
        // carve-out is per-role).
        if (!container.contains(container.ownerDocument.activeElement) && $f04197de716c4c2e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $ehZai.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific rather than hoisted.
    // Hoisting it over-matched on dialog popups that contain a nested
    // combobox (e.g. datetime-picker's dialog hosts a react-select), where
    // the active combobox's `aria-controls` falsely matched the container
    // and suppressed the dialog's own focus contract. The dialog branch
    // above therefore skips only for a combobox outside the dialog.
    if (role === 'menu') {
        if ($f04197de716c4c2e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/decisions/menu-keyboard.md
        return (0, $ehZai.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($f04197de716c4c2e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $ehZai.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $f04197de716c4c2e$export$e992c40175757a22({ elementRef: elementRef, phase: phase, role: role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, $bSJIT.useRef)('closed');
    (0, $bSJIT.useEffect)(()=>{
        var _getInitialFocusTarge;
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $f04197de716c4c2e$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("7nmZk", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $75c0c87ab2eb9485$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $d6mTg = parcelRequire("d6mTg");

var $ghAbV = parcelRequire("ghAbV");

var $3Kray = parcelRequire("3Kray");

var $bmgDZ = parcelRequire("bmgDZ");

var $eyVyH = parcelRequire("eyVyH");

var $e4JX7 = parcelRequire("e4JX7");

var $hNkxU = parcelRequire("hNkxU");

var $2Y5lK = parcelRequire("2Y5lK");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $75c0c87ab2eb9485$var$getPopoverWritingMode({ popover: popover }) {
    // `String()` because not every test environment implements `writing-mode`.
    const writingMode = String(getComputedStyle(popover).writingMode);
    const isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $75c0c87ab2eb9485$var$measureAnchorSize({ anchor: anchor, writingMode: writingMode }) {
    if (writingMode === 'vertical') return {
        inline: `${anchor.offsetHeight}px`,
        block: `${anchor.offsetWidth}px`
    };
    return {
        inline: `${anchor.offsetWidth}px`,
        block: `${anchor.offsetHeight}px`
    };
}
const $75c0c87ab2eb9485$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
const $75c0c87ab2eb9485$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $75c0c87ab2eb9485$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $75c0c87ab2eb9485$var$useNewAnchorName() {
    const id = (0, $d6mTg.useId)();
    return (0, $bSJIT.useMemo)(()=>`--anchor-${id.replace(/[^A-Za-z0-9_-]/g, '_')}`, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $75c0c87ab2eb9485$var$useStablePlacement(placement) {
    const resolved = (0, $e4JX7.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const minSize = resolved.minSize;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $bSJIT.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $75c0c87ab2eb9485$export$147d8888d96bf7a3({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement, isOpen: isOpen, isEnabled: isEnabled = true, inlineSize: inlineSize = 'content', blockSize: blockSize = 'content', shouldPreserveInlineSize: shouldPreserveInlineSize = false, forceFallbackPositioning: forceFallbackPositioning = false }) {
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    const fallbackAnchorName = $75c0c87ab2eb9485$var$useNewAnchorName();
    const stablePlacement = $75c0c87ab2eb9485$var$useStablePlacement(placement);
    (0, $ghAbV.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        const isUsingCssAnchorPositioning = (0, $hNkxU.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        const canUseAnchorSize = isUsingCssAnchorPositioning && (0, $2Y5lK.supportsAnchorSize)();
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        const writingMode = $75c0c87ab2eb9485$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        const needsAnchorSize = $75c0c87ab2eb9485$var$isAnchorRelative(inlineSize) || $75c0c87ab2eb9485$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        const anchorSize = needsAnchorSize ? canUseAnchorSize ? $75c0c87ab2eb9485$var$CSS_ANCHOR_SIZE : $75c0c87ab2eb9485$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $75c0c87ab2eb9485$var$NO_ANCHOR_SIZE;
        const sizeStyles = (0, $bmgDZ.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $3Kray.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $eyVyH.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("3Kray", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $bba4c6e3bc71d95c$export$50da8074e1408934);
/**
 * The CSS Anchor Positioning path: `position-anchor`, `position-area`,
 * `position-try-fallbacks` and the gap / shift margins, all declared on the
 * popover so the browser owns placement and flipping. The twin of
 * `../javascript-fallback/apply-javascript-fallback-positioning`.
 */ 
var $bvxgC = parcelRequire("bvxgC");

var $5C375 = parcelRequire("5C375");

var $ipAjb = parcelRequire("ipAjb");

var $hIxJT = parcelRequire("hIxJT");

var $2FN6j = parcelRequire("2FN6j");

var $j7x84 = parcelRequire("j7x84");

var $cfnsv = parcelRequire("cfnsv");
function $bba4c6e3bc71d95c$export$50da8074e1408934({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles, isFitting: isFitting, fallbackAnchorName: fallbackAnchorName }) {
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    const existingAnchorName = (0, $2FN6j.getExistingAnchorName)(anchor);
    const anchorName = existingAnchorName ?? fallbackAnchorName;
    const gap = (0, $ipAjb.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    const crossAxisShift = (0, $5C375.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    const popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $j7x84.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $cfnsv.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * `position-visibility` is used to control the visibility of an anchored
   * popover based on the visibility of the element being anchored to (the target).
   *
   * Default `position-visibility` value: `anchors-visible` → hide the anchored
   * popover when the target is fully clipped by an ancestor (eg a scroll container)
   * or is `visibility:hidden`.
   * Sadly this "automatic hiding" does not actually "close" the popover,
   * so things like `:popover-open` are still active, even though the popover
   * is no longer painted and no longer receives pointer input. Chrome keeps it
   * focusable and in the accessibility tree, so keyboard and screen reader users
   * can still land inside a surface that is not painted.
   * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
   *
   * Generally we have not run into issues with the default (`anchors-visible`)
   *
   * Exceptions:
   *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
   *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
   *  - A trigger is scrolled out of its scroll container while the popover is open.
   *
   * We are switching from `anchors-visible` → `always` _for now_ to force no
   * automatic hiding of the popover. There seems to be no compelling reason to use
   * the default value. If one arises in the future, we could look towards making
   *  this behaviour configurable.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap,
        // When fitting, the shift margins come back COMPOSED with the reserved
        // viewport padding, rather than being written twice.
        ...isFitting ? (0, $hIxJT.getFitMarginDeclarations)({
            placement: placement,
            crossAxisShiftMargins: crossAxisShift
        }) : crossAxisShift,
        ...sizeStyles
    ];
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $bvxgC.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("bvxgC", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $ddb43c06189d22e0$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ function $ddb43c06189d22e0$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("5C375", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $9ed9f03bde3c3db7$export$f7505ccec0897ae3);
function $9ed9f03bde3c3db7$export$f7505ccec0897ae3({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    const negated = `calc(-1 * ${crossAxisShiftCssValue})`;
    const isForwards = direction === 'forwards';
    return [
        {
            property: `margin-${crossAxis}-start`,
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: `margin-${crossAxis}-end`,
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("ipAjb", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $a5b1692d46266577$export$b94d052c6b40496);
function $a5b1692d46266577$export$b94d052c6b40496({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    // The side FACING the anchor is always opposite the placement edge.
    const anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: `margin-${axis}-${anchorFacingEdge}`,
        value: offset
    };
}

});

parcelRegister("hIxJT", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $be67aa7fa95e86d0$export$a7ffde4a856e8d8e);

var $bmgDZ = parcelRequire("bmgDZ");
/**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $be67aa7fa95e86d0$var$viewportFacingCrossAxisSides({ align: align }) {
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $be67aa7fa95e86d0$export$a7ffde4a856e8d8e({ placement: placement, crossAxisShiftMargins: crossAxisShiftMargins }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    const paddedProperties = new Set($be67aa7fa95e86d0$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map((side)=>`margin-${crossAxis}-${side}`));
    return [
        {
            property: `margin-${placement.axis}-${placement.edge}`,
            value: (0, $bmgDZ.VIEWPORT_PADDING)
        },
        ...crossAxisShiftMargins.map(({ property: property, value: value })=>paddedProperties.has(property) ? {
                property: property,
                value: `calc(${value} + ${0, $bmgDZ.VIEWPORT_PADDING})`
            } : {
                property: property,
                value: value
            })
    ];
}

});
parcelRegister("bmgDZ", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $2158c911fe90f772$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $2158c911fe90f772$export$860b30329fa0b990);
const $2158c911fe90f772$export$9f2fdbacbc62226e = '5px';
const $2158c911fe90f772$export$32ab78b2bb853a01 = '150px';
/**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $2158c911fe90f772$var$viewportUnit({ axis: axis, writingMode: writingMode }) {
    const isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
function $2158c911fe90f772$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $2158c911fe90f772$var$viewportCap({ axis: axis, writingMode: writingMode }) {
    return `calc(100${$2158c911fe90f772$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    })} - 2 * ${$2158c911fe90f772$export$9f2fdbacbc62226e})`;
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $2158c911fe90f772$var$cellCap({ gap: gap }) {
    return `calc(100% - ${$2158c911fe90f772$export$9f2fdbacbc62226e} - ${gap})`;
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $2158c911fe90f772$var$getPlacementAxisAnchorFloor({ placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, canFlip: canFlip, writingMode: writingMode }) {
    const hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return `min(${anchorValue}, ${$2158c911fe90f772$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    })})`;
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $2158c911fe90f772$var$getDefaultPlacementAxisFloor({ placementAxis: placementAxis, anchorValue: anchorValue, gap: gap, writingMode: writingMode }) {
    if (anchorValue === null) return $2158c911fe90f772$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    const viewport = `100${$2158c911fe90f772$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    })}`;
    const halfOfRemainingViewport = `calc((${viewport} - ${anchorValue}) / 2 - ${gap} - ${$2158c911fe90f772$export$9f2fdbacbc62226e})`;
    return `min(${$2158c911fe90f772$export$32ab78b2bb853a01}, max(0px, ${halfOfRemainingViewport}))`;
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $2158c911fe90f772$var$getPlacementAxisFloor({ minSize: minSize, placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, gap: gap, canFlip: canFlip, writingMode: writingMode }) {
    const anchorFloor = $2158c911fe90f772$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : `max(${minSize}, ${anchorFloor})`;
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $2158c911fe90f772$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $2158c911fe90f772$export$860b30329fa0b990({ placement: placement, inlineSize: inlineSize, blockSize: blockSize, isUsingCssAnchorPositioning: isUsingCssAnchorPositioning, anchorSize: anchorSize, writingMode: writingMode, shouldPreserveInlineSize: shouldPreserveInlineSize = false }) {
    const placementAxis = placement.axis;
    const crossAxis = $2158c911fe90f772$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    const size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    const canFlip = isFitting && isUsingCssAnchorPositioning;
    const declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: `max-${placementAxis}-size`,
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $2158c911fe90f772$var$cellCap({
                gap: placement.offset.gap
            }) : $2158c911fe90f772$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: `max-${crossAxis}-size`,
            value: $2158c911fe90f772$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for (const axis of [
        placementAxis,
        crossAxis
    ]){
        const anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: `${axis}-size`,
            value: anchorValue
        });
    }
    const placementAxisFloor = $2158c911fe90f772$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: `min-${placementAxis}-size`,
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    const crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: `min-${crossAxis}-size`,
        value: `min(${crossAxisAnchorValue}, ${$2158c911fe90f772$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        })})`
    });
    return declarations;
}

});


parcelRegister("2FN6j", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $0110c18bc4f3f5e5$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $0110c18bc4f3f5e5$export$948d15b01d509455(element) {
    const declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    const first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("j7x84", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $755a69ff34200a2e$export$de49b61f233ddeb9);
function $755a69ff34200a2e$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

});

parcelRegister("cfnsv", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $4412ff3da2e0c868$export$c4e16947a95d61f1);
/**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $4412ff3da2e0c868$var$slideOnEdge({ align: align, edgeKey: edgeKey, crossAxis: crossAxis, isOppositeEdge: isOppositeEdge }) {
    if (align === 'center') return [
        `${edgeKey} span-${crossAxis}-end`,
        `${edgeKey} span-${crossAxis}-start`
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    const far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        `${edgeKey} span-${crossAxis}-${far}`
    ];
}
function $4412ff3da2e0c868$var$flipDiagonally({ axis: axis }) {
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${flipOnMainAxis} ${flipToCrossAxis}`;
}
function $4412ff3da2e0c868$export$c4e16947a95d61f1({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${flippedEdge}`;
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $4412ff3da2e0c868$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $4412ff3da2e0c868$var$flipDiagonally({
            axis: axis
        }) : null,
        $4412ff3da2e0c868$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("eyVyH", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $47cb5d6fc88ad326$export$89babc4c2047d2ba);
/**
 * The JavaScript positioning fallback: measured `position: fixed` coordinates for
 * browsers without CSS Anchor Positioning.
 *
 * Best effort, degrading in that order: measured anchored position, then anchored
 * with unresolvable offsets treated as `0`, then centred in the viewport, and
 * always visible. The two hazards differ in kind: `new ResizeObserver` runs
 * synchronously in the layout effect, where a throw unmounts the React tree,
 * while `update` runs asynchronously, where the danger is an uncleared
 * `opacity: 0`.
 */ 
var $bAB3U = parcelRequire("bAB3U");

var $9wZWu = parcelRequire("9wZWu");

var $dUqWC = parcelRequire("dUqWC");

var $bvxgC = parcelRequire("bvxgC");

var $hZs5k = parcelRequire("hZs5k");

var $h0wmB = parcelRequire("h0wmB");

var $79amg = parcelRequire("79amg");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $47cb5d6fc88ad326$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $47cb5d6fc88ad326$var$createFirstLayoutObserver({ popover: popover, onFirstLayout: onFirstLayout }) {
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        const observer = new ResizeObserver(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $79amg.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $47cb5d6fc88ad326$export$89babc4c2047d2ba({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles }) {
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    const cleanupBaseStyles = (0, $bvxgC.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            },
            ...sizeStyles
        ]
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    let undoPosition;
    let undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    let resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $h0wmB.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $h0wmB.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _undoHide;
        (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
        undoHide = undefined;
    }
    function restorePosition() {
        var _undoPosition;
        (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $bvxgC.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $bvxgC.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            const triggerRect = anchor.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            const { gap: gap, crossAxisShift: crossAxisShift } = getResolvedOffsets();
            const { top: top, left: left } = (0, $hZs5k.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            });
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $bvxgC.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: `${top}px`
                    },
                    {
                        property: 'left',
                        value: `${left}px`
                    }
                ]
            });
        } catch (error) {
            (0, $79amg.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch  {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    const scheduledScrollUpdate = (0, $9wZWu.default)(update);
    const scheduledResizeUpdate = (0, $9wZWu.default)(invalidateAndUpdate);
    const firstLayoutObserver = $47cb5d6fc88ad326$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($47cb5d6fc88ad326$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $dUqWC.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $bAB3U.bind)(popover, {
        type: 'toggle',
        listener: (event)=>{
            const toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), ()=>firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect(), (0, $bAB3U.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $bAB3U.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), ()=>{
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("9wZWu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0726ab111467c2$export$2e2bcd8739ae039);
var $6f0726ab111467c2$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $6f0726ab111467c2$export$2e2bcd8739ae039 = $6f0726ab111467c2$var$rafSchd;

});

parcelRegister("dUqWC", function(module, exports) {
$parcel$export(module.exports, "combine", () => $ddd9639ba96dc54d$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $ddd9639ba96dc54d$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback === null || callback === void 0 ? void 0 : callback());
    };
}

});

parcelRegister("hZs5k", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $4140e6b26462d711$export$d5ef1dac02135664);
/**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $4140e6b26462d711$var$computeEdgePosition({ axis: axis, edge: edge, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $4140e6b26462d711$var$applyAlignment({ position: position, axis: axis, align: align, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return {
            ...position,
            left: triggerRect.left
        };
        // align === 'end'
        return {
            ...position,
            left: triggerRect.right - popoverWidth
        };
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return {
        ...position,
        top: triggerRect.top
    };
    // align === 'end'
    return {
        ...position,
        top: triggerRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $4140e6b26462d711$var$applyCrossAxisShift({ position: position, axis: axis, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $4140e6b26462d711$export$d5ef1dac02135664({ triggerRect: triggerRect, popoverEl: popoverEl, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = $4140e6b26462d711$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $4140e6b26462d711$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $4140e6b26462d711$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("h0wmB", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $0e9770dddbae119d$export$98721546d2816d9e);

var $79amg = parcelRequire("79amg");
/**
 * `null` when the environment cannot measure at all.
 */ function $0e9770dddbae119d$var$measureWithProbe({ value: value, container: container }) {
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    const view = container.ownerDocument.defaultView;
    if (!view) return null;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        const resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $79amg.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $0e9770dddbae119d$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return $0e9770dddbae119d$var$measureWithProbe({
        value: value,
        container: container
    }) ?? 0;
}

});
parcelRegister("79amg", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $93d648eae55efc18$export$e142245b95267f17);

function $93d648eae55efc18$export$e142245b95267f17({ error: error }) {
    return;
}

});



parcelRegister("hNkxU", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $4b87849cc490ed18$export$7192e63dfa9e8124);

var $3VDBF = parcelRequire("3VDBF");
const $4b87849cc490ed18$export$7192e63dfa9e8124 = (0, $3VDBF.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("3VDBF", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $02626de720bf57e8$export$69de71b4b7c76bad);

var $bAWQa = parcelRequire("bAWQa");
function $02626de720bf57e8$export$69de71b4b7c76bad({ property: property, value: value }) {
    return (0, $bAWQa.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("2Y5lK", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $46d49546d5d497ea$export$1c8dd0d1c9df9c6e);

var $3VDBF = parcelRequire("3VDBF");
const $46d49546d5d497ea$export$1c8dd0d1c9df9c6e = (0, $3VDBF.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("8Ihum", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopoverAtPoint", () => $f0ca82afd1be1b81$export$3c5c8baff3ccd957);
/**
 * Positioning and sizing for a popover anchored to a viewport COORDINATE. No
 * positioning logic here: CSS Anchor Positioning needs a real element to carry
 * `anchor-name`, so this hook creates a hidden, zero-size one at the requested
 * point and delegates everything else to `useAnchoredPopover`.
 *
 * See `notes/decisions/anchored-popover-at-point.md` for why this is a sibling
 * hook instead of an anchor union inside `useAnchoredPopover`.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $ghAbV = parcelRequire("ghAbV");

var $7nmZk = parcelRequire("7nmZk");
/**
 * Appended to `document.body` to escape any transformed ancestor, which would
 * break viewport-relative resolution of `position: fixed`. `Object.assign`
 * rather than `setStyle`: we own the element, so there is nothing to restore.
 */ function $f0ca82afd1be1b81$var$mountAnchorElementAtPoint({ point: point }) {
    const element = document.createElement('div');
    element.setAttribute('aria-hidden', 'true');
    Object.assign(element.style, {
        position: 'fixed',
        // Physical insets: `inset-inline-start` would need `viewportWidth - point.x`
        // in RTL.
        top: `${point.y}px`,
        left: `${point.x}px`,
        // Zero size, so placement alone decides which side the popover sits on.
        width: '0',
        height: '0',
        pointerEvents: 'none'
    });
    document.body.appendChild(element);
    return {
        element: element,
        cleanup: function cleanup() {
            element.remove();
        }
    };
}
function $f0ca82afd1be1b81$export$3c5c8baff3ccd957({ getPoint: getPoint, isEnabled: isEnabled = true, ...rest }) {
    const anchorRef = (0, $bSJIT.useRef)(null);
    // Latched, keyed on `isEnabled`: consumers read mutable refs inside `getPoint`,
    // so re-reading it would move an already-open popover, and keying on
    // `getPoint`'s identity would re-latch on every parent render.
    const getPointRef = (0, $bSJIT.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Declared BEFORE `useAnchoredPopover` below, so the element exists when that
    // hook's effect reads the ref (React runs layout effects in source order). This
    // effect must not depend on anything the delegated effect does not: a dependency
    // here alone re-creates the element without that hook writing an `anchor-name`
    // onto it, and positioning silently dies.
    (0, $ghAbV.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const { element: element, cleanup: unmountAnchorElement } = $f0ca82afd1be1b81$var$mountAnchorElementAtPoint({
            point: point
        });
        anchorRef.current = element;
        return function cleanup() {
            unmountAnchorElement();
            anchorRef.current = null;
        };
    // The latch. See `getPointRef` above: `getPoint` is deliberately absent.
    }, [
        isEnabled
    ]);
    (0, $7nmZk.useAnchoredPopover)({
        ...rest,
        anchorRef: anchorRef,
        isEnabled: isEnabled
    });
}

});

parcelRegister("jFqOs", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $c29b5f9747c816a8$export$9198c6c168be2eeb);

var $d6mTg = parcelRequire("d6mTg");
function $c29b5f9747c816a8$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return `popover-${(0, $d6mTg.useId)()}`;
}

});

parcelRegister("4mi4Q", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $274455a6bdede2b1$export$175375e9a2b5515d);

var $c9wRy = parcelRequire("c9wRy");
function $274455a6bdede2b1$export$175375e9a2b5515d() {
    const document = (0, $c9wRy.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("4AqC0", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $2dd304c8e3c69366$export$b065aeb850c3e87f);
function $2dd304c8e3c69366$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $2dd304c8e3c69366$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $2dd304c8e3c69366$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $2dd304c8e3c69366$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $2dd304c8e3c69366$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $2dd304c8e3c69366$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $2dd304c8e3c69366$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("lloz0", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $97d47b314ae8298d$export$e9a6fdb80170ffd);
function $97d47b314ae8298d$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("d3Exm", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $75f4be36fdf5c88b$export$941a7e8bf0b9eafd);

var $bSJIT = parcelRequire("bSJIT");

var $cFWBM = parcelRequire("cFWBM");
function $75f4be36fdf5c88b$export$941a7e8bf0b9eafd() {
    return (0, $bSJIT.useContext)((0, $cFWBM.AnchorContext));
}

});
parcelRegister("cFWBM", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $a2b9a80f7bb829f3$export$8f73317645bb7b8e);

var $bSJIT = parcelRequire("bSJIT");
const $a2b9a80f7bb829f3$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $bSJIT.createContext)(null);

});


parcelRegister("ctYhw", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $5670b52ae018ef51$export$61d36e2b682e92f7);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $ghAbV = parcelRequire("ghAbV");

var $aFYTL = parcelRequire("aFYTL");
const $5670b52ae018ef51$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $5670b52ae018ef51$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $5670b52ae018ef51$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $5670b52ae018ef51$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $5670b52ae018ef51$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $5670b52ae018ef51$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $5670b52ae018ef51$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $bSJIT.useState)($5670b52ae018ef51$var$INITIAL);
    const measure = (0, $bSJIT.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $5670b52ae018ef51$var$INITIAL);
            return;
        }
        const viewport = (0, $aFYTL.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $5670b52ae018ef51$var$isFullyOutsideViewport(anchorRect, viewport) || $5670b52ae018ef51$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $5670b52ae018ef51$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $ghAbV.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $bAB3U.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $bAB3U.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("aFYTL", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $f594e4e11bfd772f$export$64beed533e21f72d);
function $f594e4e11bfd772f$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("cglph", function(module, exports) {
$parcel$export(module.exports, "default", () => $b138ac43c4bb3227$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $hQpIA = parcelRequire("hQpIA");

var $7sVqe = parcelRequire("7sVqe");

var $7PkeD = parcelRequire("7PkeD");

var $50ru5 = parcelRequire("50ru5");
function $b138ac43c4bb3227$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $7PkeD.default)(mountStrategy);
    (0, $50ru5.default)(zIndex);
    return !(0, $gdUUy.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hQpIA.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7sVqe.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("hQpIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $19e2bb940fbf9812$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $2lSxZ = parcelRequire("2lSxZ");

var $e1pWM = parcelRequire("e1pWM");

var $5khki = parcelRequire("5khki");

var $gIy8r = parcelRequire("gIy8r");

var $jGNgw = parcelRequire("jGNgw");

var $7hCdu = parcelRequire("7hCdu");
function $19e2bb940fbf9812$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $bSJIT.useMemo)(()=>(0, $jGNgw.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $e1pWM.useColorMode)();
    const isInsideThemeProvider = (0, $5khki.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $gIy8r.appendPortalContainerIfNotAppended)(container);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            (0, $7hCdu.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $4Sf72.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2lSxZ.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("2lSxZ", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $d50a007be00c3366$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $gdUUy = parcelRequire("gdUUy");

var $fjtMM = parcelRequire("fjtMM");

var $1Y3QR = parcelRequire("1Y3QR");

var $kb9eq = parcelRequire("kb9eq");

var $jddJj = parcelRequire("jddJj");

var $4TDr3 = parcelRequire("4TDr3");

var $02VbC = parcelRequire("02VbC");

var $dqIYa = parcelRequire("dqIYa");

var $1HIrH = parcelRequire("1HIrH");

var $mj35z = parcelRequire("mj35z");

var $bl9pr = parcelRequire("bl9pr");

var $5khki = parcelRequire("5khki");

var $hgo8f = parcelRequire("hgo8f");

var $dZGRh = parcelRequire("dZGRh");
const $d50a007be00c3366$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
const $d50a007be00c3366$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d50a007be00c3366$var$prefersDarkModeMql = $d50a007be00c3366$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d50a007be00c3366$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d50a007be00c3366$var$prefersDarkModeMql !== null && $d50a007be00c3366$var$prefersDarkModeMql !== void 0 && $d50a007be00c3366$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
const $d50a007be00c3366$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $d50a007be00c3366$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $bSJIT.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $bSJIT.useState)($d50a007be00c3366$var$getReconciledColorMode(defaultColorMode));
    const isInsideAppProvider = (0, $02VbC.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $4TDr3.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $5khki.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    /**
   * Each provider owns its own override stylesheet, so nested providers don't overwrite or remove
   * each other's overrides. `useId` is stable between the server render and hydration.
   *
   * Subtree providers also scope their override selector to their own element. Otherwise every
   * subtree using the same custom theme would match every provider's overrides, and the last
   * stylesheet in the document would win. The root provider targets `html`, which subtrees
   * inherit from.
   */ const customThemeOverridesStyleId = (0, $bSJIT.useId)();
    const { theme: normalizedDefaultTheme, inlineStyles: inlineStyles } = (0, $1Y3QR.getThemeAndOverrides)(defaultTheme, isRootThemeProvider ? undefined : customThemeOverridesStyleId);
    const [theme, setTheme] = (0, $bSJIT.useState)(()=>({
            ...$d50a007be00c3366$var$defaultThemeSettings,
            ...normalizedDefaultTheme
        }));
    const [hasHoistedInlineThemeStyles, setHasHoistedInlineThemeStyles] = (0, $bSJIT.useState)(false);
    const setColorMode = (0, $bSJIT.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d50a007be00c3366$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $bSJIT.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $bSJIT.useRef)(null);
    /**
   * Custom theme overrides apply regardless of `platform-static-theme-loading`: that gate only
   * controls how the theme stylesheets themselves are loaded.
   */ const inlineThemeStylesOverrides = inlineStyles;
    (0, $bSJIT.useLayoutEffect)(()=>{
        return ()=>{
            var _document$head$queryS;
            (_document$head$queryS = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`)) === null || _document$head$queryS === void 0 || _document$head$queryS.remove();
        };
    }, [
        customThemeOverridesStyleId
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const isStaticThemeLoadingEnabled = (0, $gdUUy.fg)('platform-static-theme-loading');
        if (isStaticThemeLoadingEnabled && !hasHoistedInlineThemeStyles) (0, $hgo8f.getInlineThemeStyles)(theme, chosenColorMode).forEach(({ id: id, css: css })=>{
            if (document.head.querySelector(`style[data-theme="${id}"]`)) return;
            const style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        const existingOverrideStyle = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`);
        if (inlineThemeStylesOverrides) {
            if (existingOverrideStyle) existingOverrideStyle.textContent = inlineThemeStylesOverrides;
            else {
                const style = document.createElement('style');
                style.dataset.themeOverrides = customThemeOverridesStyleId;
                style.textContent = inlineThemeStylesOverrides;
                document.head.appendChild(style);
            }
        } else existingOverrideStyle === null || existingOverrideStyle === void 0 || existingOverrideStyle.remove();
        // Only re-render to drop the inline styles when there are any to drop.
        if (!hasHoistedInlineThemeStyles && (isStaticThemeLoadingEnabled || inlineThemeStylesOverrides)) setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        customThemeOverridesStyleId,
        hasHoistedInlineThemeStyles,
        inlineThemeStylesOverrides,
        theme
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $jddJj.setGlobalTheme)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        }
        // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $dZGRh.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!$d50a007be00c3366$var$prefersDarkModeMql) return;
        const unbindListener = (0, $bAB3U.bind)($d50a007be00c3366$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $kb9eq.getThemeHtmlAttrs)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $fjtMM.SUBTREE_THEME_ATTRIBUTE)]: true,
        // Matches this provider's scoped override selector. Only set when there are overrides.
        ...inlineThemeStylesOverrides ? {
            [(0, $1Y3QR.CUSTOM_THEME_SCOPE_ATTRIBUTE)]: customThemeOverridesStyleId
        } : {}
    };
    const inlineThemeStyles = (0, $gdUUy.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $hgo8f.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1HIrH.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dqIYa.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $mj35z.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bl9pr.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bl9pr.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                            ...attrs,
                            className: (0, $9fU1q.default)([
                                $d50a007be00c3366$var$contentStyles.body
                            ]),
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $dc70d.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $dc70d.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        }) : /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $dc70d.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $dc70d.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("1Y3QR", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_THEME_SCOPE_ATTRIBUTE", () => $ce6e271b66d41057$export$e5f6e0f338f81b9a);
$parcel$export(module.exports, "getThemeAndOverrides", () => $ce6e271b66d41057$export$12087c26a9b2e83e);
function $ce6e271b66d41057$var$isThemeWithOverrides(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'overrides' in value && typeof value.id === 'string' && typeof value.overrides === 'object' && value.overrides !== null;
}
const $ce6e271b66d41057$export$e5f6e0f338f81b9a = 'data-theme-overrides-scope';
function $ce6e271b66d41057$export$12087c26a9b2e83e(themeWithOverrides, scope) {
    const theme = {};
    const overrides = {};
    for (const [themeKind, value] of Object.entries(themeWithOverrides || {})){
        if ($ce6e271b66d41057$var$isThemeWithOverrides(value)) {
            theme[themeKind] = value.id;
            overrides[themeKind] = {
                [value.id]: value.overrides
            };
            continue;
        }
        theme[themeKind] = value;
    }
    return {
        theme: theme,
        inlineStyles: $ce6e271b66d41057$var$getCustomThemeOverrideStyles(overrides, scope)
    };
}
/**
 * Escapes a value for use inside a double-quoted CSS attribute selector.
 */ function $ce6e271b66d41057$var$escapeAttributeValue(value) {
    return value.replace(/["\\]/g, '\\$&');
}
function $ce6e271b66d41057$var$getThemeOverrideSelector(themeKind, themeName, scope) {
    // Colour themes only apply in their own colour mode.
    const colorMode = themeKind === 'light' || themeKind === 'dark' ? `[data-color-mode="${themeKind}"]` : '';
    const theme = `${colorMode}[data-theme~="${themeKind}:${themeName}"]`;
    if (scope) return `[data-subtree-theme][${$ce6e271b66d41057$export$e5f6e0f338f81b9a}="${$ce6e271b66d41057$var$escapeAttributeValue(scope)}"]${theme}`;
    return `html${theme}, [data-subtree-theme]${theme}`;
}
function $ce6e271b66d41057$var$getCssVariableName(propertyName) {
    return `--ds-${propertyName.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
}
/**
 * Generates CSS for custom theme overrides.
 *
 * Override property names are converted from camel case to `--ds-` CSS custom properties.
 */ function $ce6e271b66d41057$var$getCustomThemeOverrideStyles(overrides, scope) {
    if (!overrides) return '';
    return Object.entries(overrides).flatMap(([themeKind, themes])=>Object.entries(themes || {}).flatMap(([themeName, values])=>{
            const styles = Object.entries(values || {})// Unset optional inputs are skipped so the theme's `var()` fallback applies. Writing
            // `undefined` would be a valid custom property value that breaks the formula.
            .filter(([, value])=>value !== undefined && value !== null).map(([propertyName, value])=>`${$ce6e271b66d41057$var$getCssVariableName(propertyName)}: ${value};`).join('');
            return styles ? `
		${$ce6e271b66d41057$var$getThemeOverrideSelector(themeKind, themeName, scope)} {
			${styles}
		}
	` : [];
        })).join('');
}

});

parcelRegister("kb9eq", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", () => $2a944064c9831392$export$e1f80cb7a749802f);
$parcel$export(module.exports, "default", () => $2a944064c9831392$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $fjtMM = parcelRequire("fjtMM");

var $kZ1cC = parcelRequire("kZ1cC");

var $1znDm = parcelRequire("1znDm");

var $8zlhI = parcelRequire("8zlhI");

var $3jq1w = parcelRequire("3jq1w");
const $2a944064c9831392$var$defaultColorMode = 'light';
const $2a944064c9831392$var$defaultContrastMode = 'no-preference';
const $2a944064c9831392$export$e1f80cb7a749802f = ({ colorMode: colorMode = (0, $1znDm.themeStateDefaults)['colorMode'], dark: dark = (0, $1znDm.themeStateDefaults)['dark'], light: light = (0, $1znDm.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $1znDm.themeStateDefaults)['contrastMode'], motion: motion = (0, $1znDm.themeStateDefaults)['motion'](), shape: shape = (0, $1znDm.themeStateDefaults)['shape'], spacing: spacing = (0, $1znDm.themeStateDefaults)['spacing'], typography: typography = (0, $1znDm.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $1znDm.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $kZ1cC.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $fjtMM.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $fjtMM.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $2a944064c9831392$var$defaultColorMode : colorMode
    };
    if ((0, $gdUUy.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $fjtMM.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $2a944064c9831392$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $3jq1w.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $8zlhI.hash)(optionString);
        result[0, $fjtMM.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $2a944064c9831392$export$2e2bcd8739ae039 = $2a944064c9831392$export$e1f80cb7a749802f;

});
parcelRegister("kZ1cC", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $fe716b58e06f0e02$export$62c37ab81302621a);

var $k5Th6 = parcelRequire("k5Th6");

var $8sQAy = parcelRequire("8sQAy");

var $aWYUn = parcelRequire("aWYUn");
const $fe716b58e06f0e02$var$customThemeOptions = 'UNSAFE_themeOptions';
const $fe716b58e06f0e02$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $k5Th6.isColorMode)(id) || // custom theme state
        kind === $fe716b58e06f0e02$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $aWYUn.isThemeKind)(kind) && typeof id === 'string' && (0, $8sQAy.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});
parcelRegister("k5Th6", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $d8c89a2a9099c5b0$export$4a14e169b1de4ee7);
const $d8c89a2a9099c5b0$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("8sQAy", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $84f6dd0cc086b678$export$ea35b8958c39dd07);

var $2QyeA = parcelRequire("2QyeA");
const $84f6dd0cc086b678$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $2QyeA.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("2QyeA", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $bd5ca90ce996a980$export$7d43e72a58e3283f);
const $bd5ca90ce996a980$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-dynamic',
    'UNSAFE-dynamic-dark',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'UNSAFE-typography',
    'motion'
];

});


parcelRegister("aWYUn", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $e25607e8807aa3ea$export$958fa026be3a263e);
const $e25607e8807aa3ea$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $e25607e8807aa3ea$export$958fa026be3a263e = (themeKind)=>{
    return $e25607e8807aa3ea$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});


parcelRegister("1znDm", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $0081434e9dce97d5$export$9aedcfa7336a207);
function $0081434e9dce97d5$var$getMotionDefault() {
    return 'motion';
}
const $0081434e9dce97d5$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $0081434e9dce97d5$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("8zlhI", function(module, exports) {
$parcel$export(module.exports, "hash", () => $0d0e05069d4cf31e$export$d6af199866bfb566);
const $0d0e05069d4cf31e$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("3jq1w", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $6b9fe32f3988ed1f$export$53031ac1ecb71f44);
const $6b9fe32f3988ed1f$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("jddJj", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", () => $4831535b12b6a7bb$export$fd7e0dd2b74807f7);

var $gdUUy = parcelRequire("gdUUy");

var $bDsJN = parcelRequire("bDsJN");

var $1znDm = parcelRequire("1znDm");

var $kFDch = parcelRequire("kFDch");

var $dSH8L = parcelRequire("dSH8L");

var $aLj6d = parcelRequire("aLj6d");

var $FnfSF = parcelRequire("FnfSF");

var $3jq1w = parcelRequire("3jq1w");

var $4vmFm = parcelRequire("4vmFm");

var $lOw3F = parcelRequire("lOw3F");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $4831535b12b6a7bb$export$fd7e0dd2b74807f7 = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $1znDm.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $1znDm.themeStateDefaults)['contrastMode'], dark: dark = (0, $1znDm.themeStateDefaults)['dark'], light: light = (0, $1znDm.themeStateDefaults)['light'], shape: shape = (0, $1znDm.themeStateDefaults)['shape'], spacing: spacing = (0, $1znDm.themeStateDefaults)['spacing'], typography: typography = (0, $1znDm.themeStateDefaults)['typography'], motion: motion = (0, $1znDm.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $1znDm.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $1znDm.themeStateDefaults),
        typography: (0, $1znDm.themeStateDefaults)['typography'],
        shape: (0, $1znDm.themeStateDefaults)['shape'],
        motion: (0, $1znDm.themeStateDefaults)['motion'](),
        ...(0, $bDsJN.getGlobalTheme)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $gdUUy.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    const themePreferences = (0, $FnfSF.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $lOw3F.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    const themeOverridePreferences = (0, $aLj6d.getThemeOverridePreferences)(themeState);
    // Start loading override CSS before the first await. It is appended only after the standard
    // themes have loaded so that the override cascade order remains deterministic.
    const overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map((themeId)=>(0, $4vmFm.loadThemeCss)(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $3jq1w.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
        const mode = colorMode || (0, $1znDm.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $dSH8L.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("3si2u"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    if (themeLoader) for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    else {
        const overrideThemeCss = await Promise.all(overrideThemeCssLoadingTasks);
        await Promise.all(themeOverridePreferences.map((themeId, index)=>(0, $lOw3F.loadAndAppendThemeCss)(themeId, overrideThemeCss[index])));
    }
    const autoUnbind = (0, $kFDch.default)(themeState);
    return autoUnbind;
};

});
parcelRegister("bDsJN", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $bc63ca221f2214d8$export$813ecdf77207a053);

var $fjtMM = parcelRequire("fjtMM");

var $c2AtM = parcelRequire("c2AtM");

var $6pHJy = parcelRequire("6pHJy");
const $bc63ca221f2214d8$export$813ecdf77207a053 = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $fjtMM.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $fjtMM.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $6pHJy.themeStringToObject)(theme),
        ...(0, $c2AtM.isThemeColorMode)(colorMode) && {
            colorMode: colorMode
        }
    };
};

});
parcelRegister("c2AtM", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $1b739e869aa69e9d$export$fcfb1976c88f9f75);

var $kz1kF = parcelRequire("kz1kF");
const $1b739e869aa69e9d$export$fcfb1976c88f9f75 = (colorMode)=>{
    return (0, $kz1kF.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};

});
parcelRegister("kz1kF", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $49b771ac9fec32b4$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $49b771ac9fec32b4$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("6pHJy", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $86ab1c11cb1cfc5c$export$f19b488f7c0547ee);

var $k5Th6 = parcelRequire("k5Th6");

var $8sQAy = parcelRequire("8sQAy");

var $aWYUn = parcelRequire("aWYUn");
const $86ab1c11cb1cfc5c$var$customThemeOptions = 'UNSAFE_themeOptions';
const $86ab1c11cb1cfc5c$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $k5Th6.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $aWYUn.isThemeKind)(kind) && (0, $8sQAy.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $86ab1c11cb1cfc5c$var$customThemeOptions) try {
            themeObject[$86ab1c11cb1cfc5c$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("kFDch", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee1ff4e7e37c05ee$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");

var $kb9eq = parcelRequire("kb9eq");

var $jayLZ = parcelRequire("jayLZ");

var $a0xo5 = parcelRequire("a0xo5");
function $ee1ff4e7e37c05ee$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $jayLZ.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $jayLZ.default).bind();
    } else (0, $jayLZ.default).unbind();
    if ((0, $gdUUy.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $a0xo5.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $a0xo5.default).bind();
        } else (0, $a0xo5.default).unbind();
    }
    const themeAttributes = (0, $kb9eq.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $jayLZ.default).unbind();
        if ((0, $gdUUy.fg)('platform_increased-contrast-themes')) (0, $a0xo5.default).unbind();
    };
}

});
parcelRegister("jayLZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d52e9c29f54800$export$2e2bcd8739ae039);

var $bAB3U = parcelRequire("bAB3U");

var $fjtMM = parcelRequire("fjtMM");

var $lOw3F = parcelRequire("lOw3F");
const $b1d52e9c29f54800$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $b1d52e9c29f54800$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $fjtMM.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $b1d52e9c29f54800$var$darkModeMql = $b1d52e9c29f54800$var$isMatchMediaAvailable && window.matchMedia((0, $lOw3F.darkModeMediaQuery));
class $b1d52e9c29f54800$var$ColorModeObserver {
    getColorMode() {
        if (!$b1d52e9c29f54800$var$darkModeMql) return 'light';
        return $b1d52e9c29f54800$var$darkModeMql !== null && $b1d52e9c29f54800$var$darkModeMql !== void 0 && $b1d52e9c29f54800$var$darkModeMql.matches ? 'dark' : 'light';
    }
    bind() {
        if ($b1d52e9c29f54800$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $bAB3U.bind)($b1d52e9c29f54800$var$darkModeMql, {
            type: 'change',
            listener: $b1d52e9c29f54800$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $b1d52e9c29f54800$var$SingletonColorModeObserver = new $b1d52e9c29f54800$var$ColorModeObserver();
var $b1d52e9c29f54800$export$2e2bcd8739ae039 = $b1d52e9c29f54800$var$SingletonColorModeObserver;

});
parcelRegister("lOw3F", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $37c467f64c237f1d$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $37c467f64c237f1d$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $37c467f64c237f1d$export$8662df6937d86fcb);

var $fjtMM = parcelRequire("fjtMM");

var $4vmFm = parcelRequire("4vmFm");
const $37c467f64c237f1d$export$26cd7ae85c7144e5 = async (themeId, preloadedThemeCss)=>{
    if (document.head.querySelector(`style[${(0, $fjtMM.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $fjtMM.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = preloadedThemeCss ?? await (0, $4vmFm.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $37c467f64c237f1d$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $37c467f64c237f1d$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("4vmFm", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $df910e8723f9b093$export$8a48286ed7df6720);

var $e6of9 = parcelRequire("e6of9");
const $df910e8723f9b093$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $e6of9.default)[themeId]();
    return themeCss;
};

});
parcelRegister("e6of9", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", () => $7bf5db5d7bc2858e$export$3a171c49f8c16356);
$parcel$export(module.exports, "default", () => $7bf5db5d7bc2858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::b1d12c60fe57e05a2251249c2cea7224>>
 * @codegenCommand yarn build tokens
 */ 



















const $7bf5db5d7bc2858e$export$3a171c49f8c16356 = {
    'light': ()=>(parcelRequire("5xbwR")),
    'light-future': ()=>(parcelRequire("6s7Ax")),
    'light-finesse': ()=>(parcelRequire("lD7V4")),
    'light-increased-contrast-finesse': ()=>(parcelRequire("dpTiz")),
    'light-increased-contrast': ()=>(parcelRequire("hyfk4")),
    'UNSAFE-dynamic': ()=>(parcelRequire("8AmAR")),
    'UNSAFE-dynamic-dark': ()=>(parcelRequire("6IEbG")),
    'UNSAFE-test-light': ()=>(parcelRequire("7niBo")),
    'UNSAFE-test-dark': ()=>(parcelRequire("7OLHM")),
    'dark': ()=>(parcelRequire("ctzjI")),
    'dark-future': ()=>(parcelRequire("4z35p")),
    'dark-finesse': ()=>(parcelRequire("5g4Ng")),
    'dark-increased-contrast-finesse': ()=>(parcelRequire("liWOB")),
    'dark-increased-contrast': ()=>(parcelRequire("1Cz48")),
    'spacing': ()=>(parcelRequire("lpaII")),
    'typography': ()=>(parcelRequire("l5fd5")),
    'UNSAFE-typography': ()=>(parcelRequire("d01y7")),
    'typography-finesse': ()=>(parcelRequire("6SbdQ")),
    'shape': ()=>(parcelRequire("3xaKX")),
    'motion': ()=>(parcelRequire("dgnti"))
};
var $7bf5db5d7bc2858e$export$2e2bcd8739ae039 = $7bf5db5d7bc2858e$export$3a171c49f8c16356;

});
parcelRegister("5xbwR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ijFwx").then(()=>parcelRequire('jazbr'));

});

parcelRegister("6s7Ax", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("65Jth").then(()=>parcelRequire('iBXFx'));

});

parcelRegister("lD7V4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9lmoV").then(()=>parcelRequire('7pPlT'));

});

parcelRegister("dpTiz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bnHCM").then(()=>parcelRequire('1FRLg'));

});

parcelRegister("hyfk4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5O0X0").then(()=>parcelRequire('6uH75'));

});

parcelRegister("8AmAR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1MXqU").then(()=>parcelRequire('98jOL'));

});

parcelRegister("6IEbG", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("twEga").then(()=>parcelRequire('81qXL'));

});

parcelRegister("7niBo", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("b4sSU").then(()=>parcelRequire('kO4yi'));

});

parcelRegister("7OLHM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dhMW2").then(()=>parcelRequire('aFWwT'));

});

parcelRegister("ctzjI", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("EJedW").then(()=>parcelRequire('crEQ1'));

});

parcelRegister("4z35p", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gwDMI").then(()=>parcelRequire('gQRfo'));

});

parcelRegister("5g4Ng", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("asJFa").then(()=>parcelRequire('jsSFm'));

});

parcelRegister("liWOB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("l3Qg4").then(()=>parcelRequire('eYB7M'));

});

parcelRegister("1Cz48", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jqPom").then(()=>parcelRequire('dEZXF'));

});

parcelRegister("lpaII", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7Ne5M").then(()=>parcelRequire('85o0K'));

});

parcelRegister("l5fd5", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("44mvA").then(()=>parcelRequire('3ba4n'));

});

parcelRegister("d01y7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8KRIa").then(()=>parcelRequire('6xUd9'));

});

parcelRegister("6SbdQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("k2MTt").then(()=>parcelRequire('hfmqd'));

});

parcelRegister("3xaKX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kxXl3").then(()=>parcelRequire('k04FR'));

});

parcelRegister("dgnti", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3vE35").then(()=>parcelRequire('bashC'));

});





parcelRegister("a0xo5", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee02ed34252d739$export$2e2bcd8739ae039);

var $bAB3U = parcelRequire("bAB3U");

var $fjtMM = parcelRequire("fjtMM");

var $lOw3F = parcelRequire("lOw3F");
const $eee02ed34252d739$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $eee02ed34252d739$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $fjtMM.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $eee02ed34252d739$var$contrastModeMql = $eee02ed34252d739$var$isMatchMediaAvailable && window.matchMedia((0, $lOw3F.moreContrastMediaQuery));
class $eee02ed34252d739$var$ContrastModeObserver {
    getContrastMode() {
        if (!$eee02ed34252d739$var$contrastModeMql) return 'no-preference';
        return $eee02ed34252d739$var$contrastModeMql !== null && $eee02ed34252d739$var$contrastModeMql !== void 0 && $eee02ed34252d739$var$contrastModeMql.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($eee02ed34252d739$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $bAB3U.bind)($eee02ed34252d739$var$contrastModeMql, {
            type: 'change',
            listener: $eee02ed34252d739$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $eee02ed34252d739$var$SingletonContrastModeObserver = new $eee02ed34252d739$var$ContrastModeObserver();
var $eee02ed34252d739$export$2e2bcd8739ae039 = $eee02ed34252d739$var$SingletonContrastModeObserver;

});


parcelRegister("dSH8L", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $1d001d1c6091e974$export$bd1ac9300b0e885a);

var $fjtMM = parcelRequire("fjtMM");

var $8zlhI = parcelRequire("8zlhI");
function $1d001d1c6091e974$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $8zlhI.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $fjtMM.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $fjtMM.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("aLj6d", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $aa925e79b5853d5a$export$5d76d7014f4a5d08);

var $gdUUy = parcelRequire("gdUUy");

var $1nvQV = parcelRequire("1nvQV");
const $aa925e79b5853d5a$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
const $aa925e79b5853d5a$export$5d76d7014f4a5d08 = (themeState)=>{
    if (!(0, $gdUUy.fg)('platform-dst-tokens-finesse')) return [];
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, typography: typography } = themeState;
    const selectedThemes = [
        ...colorMode === 'auto' ? [
            light,
            dark
        ] : [
            themeState[colorMode]
        ],
        typography
    ];
    if (contrastMode !== 'no-preference' && (0, $gdUUy.fg)('platform_increased-contrast-themes')) selectedThemes.forEach((themeId)=>{
        const increasedContrastTheme = (0, $1nvQV.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    const themeOverridePreferences = selectedThemes.map((themeId)=>$aa925e79b5853d5a$var$finesseOverrides[themeId]).filter((themeId)=>themeId !== undefined);
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("1nvQV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dca171719b02c52$export$2e2bcd8739ae039);

var $bu8ak = parcelRequire("bu8ak");
function $6dca171719b02c52$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $bu8ak.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("bu8ak", function(module, exports) {
$parcel$export(module.exports, "themeOverrideIds", () => $09fbc617e2abbc62$export$ba8a43b83ecc69f8);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $09fbc617e2abbc62$export$92ba366331403db2);
$parcel$export(module.exports, "default", () => $09fbc617e2abbc62$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $2QyeA = parcelRequire("2QyeA");


/**
 * Contrast preferences: The system contrast preference
 */ const $09fbc617e2abbc62$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $09fbc617e2abbc62$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
const $09fbc617e2abbc62$export$92ba366331403db2 = [
    ...(0, $2QyeA.themeIds),
    ...$09fbc617e2abbc62$export$ba8a43b83ecc69f8
];
const $09fbc617e2abbc62$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-dynamic': {
        id: 'UNSAFE-dynamic',
        displayName: 'UNSAFE Dynamic Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-dynamic-dark': {
        id: 'UNSAFE-dynamic-dark',
        displayName: 'UNSAFE Dynamic Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'UNSAFE-typography': {
        id: 'UNSAFE-typography',
        displayName: 'UNSAFE Dynamic Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        extends: 'typography'
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$09fbc617e2abbc62$export$2e2bcd8739ae039 = $09fbc617e2abbc62$export$9d64ff89b6869900;

});



parcelRegister("FnfSF", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $de72bc6cc784bf81$export$dd6aeb7c823fc03d);

var $gdUUy = parcelRequire("gdUUy");

var $1nvQV = parcelRequire("1nvQV");
const $de72bc6cc784bf81$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $gdUUy.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $1nvQV.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $gdUUy.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $1nvQV.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});

parcelRegister("3si2u", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6VmOh"),
    $kOunM("gH3lx")
]).then(()=>parcelRequire('eCjgO'));

});


parcelRegister("4TDr3", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $23054122518ebe93$export$a782702263f77544);

var $bSJIT = parcelRequire("bSJIT");

var $cPEYf = parcelRequire("cPEYf");
const $23054122518ebe93$export$a782702263f77544 = ()=>{
    return (0, $bSJIT.useContext)((0, $cPEYf.AppProviderThemingEnabledContext));
};

});
parcelRegister("cPEYf", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $4834550268c8e743$export$d2def9838ca456c0);

var $bSJIT = parcelRequire("bSJIT");
const $4834550268c8e743$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});


parcelRegister("02VbC", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $0ead17ab723cf312$export$26aa23367bfbab0e);

var $bSJIT = parcelRequire("bSJIT");

var $fuMfQ = parcelRequire("fuMfQ");
const $0ead17ab723cf312$export$26aa23367bfbab0e = ()=>{
    return (0, $bSJIT.useContext)((0, $fuMfQ.InsideAppProviderContext));
};

});
parcelRegister("fuMfQ", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $80ae1301ca638289$export$7981b2444296e410);

var $bSJIT = parcelRequire("bSJIT");
const $80ae1301ca638289$export$7981b2444296e410 = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});


parcelRegister("dqIYa", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $101ae05c343503b5$export$49ddd74a6729fdb0);

var $bSJIT = parcelRequire("bSJIT");
const $101ae05c343503b5$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});

parcelRegister("1HIrH", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $89c70cf960c728ab$export$332347eeb335453c);

var $bSJIT = parcelRequire("bSJIT");
const $89c70cf960c728ab$export$332347eeb335453c = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});

parcelRegister("mj35z", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $ef93014a8dc3e1e6$export$b06130bad0bbc70f);

var $bSJIT = parcelRequire("bSJIT");
const $ef93014a8dc3e1e6$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});

parcelRegister("bl9pr", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $a9bf98d3f7ca5427$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $a9bf98d3f7ca5427$export$f7a97b47760e2a13);

var $bSJIT = parcelRequire("bSJIT");
const $a9bf98d3f7ca5427$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $a9bf98d3f7ca5427$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});

parcelRegister("5khki", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $72cf309e9f5b9f73$export$7ca11437599d653d);

var $bSJIT = parcelRequire("bSJIT");

var $1HIrH = parcelRequire("1HIrH");
const $72cf309e9f5b9f73$export$7ca11437599d653d = ()=>{
    return (0, $bSJIT.useContext)((0, $1HIrH.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("hgo8f", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", () => $209f1905d9367462$export$ae40e6ba718781b9);

var $bSJIT = parcelRequire("bSJIT");

var $e6of9 = parcelRequire("e6of9");

var $aLj6d = parcelRequire("aLj6d");

var $FnfSF = parcelRequire("FnfSF");
const $209f1905d9367462$var$themeCssPromises = new Map();
function $209f1905d9367462$var$getThemeCssPromise(themeId) {
    let themeCssPromise = $209f1905d9367462$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $e6of9.themeImportMap)[themeId]().then(({ default: css })=>css);
        $209f1905d9367462$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $209f1905d9367462$var$getInlineThemeCss(themeId) {
    var _document$body$queryS;
    const reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).use;
    const isServer = globalThis.__SERVER__ === true || typeof document === 'undefined';
    if (isServer) return reactUse === null || reactUse === void 0 ? void 0 : reactUse($209f1905d9367462$var$getThemeCssPromise(themeId));
    return ((_document$body$queryS = document.body.querySelector(`style[data-theme="${themeId}"]`)) === null || _document$body$queryS === void 0 ? void 0 : _document$body$queryS.textContent) ?? undefined;
}
function $209f1905d9367462$export$ae40e6ba718781b9(theme, colorMode) {
    const themeState = {
        ...theme,
        colorMode: colorMode,
        contrastMode: 'no-preference'
    };
    const themeIds = [
        ...(0, $FnfSF.getThemePreferences)(themeState),
        ...(0, $aLj6d.getThemeOverridePreferences)(themeState)
    ];
    return [
        ...new Set(themeIds)
    ].map((themeId)=>{
        const css = $209f1905d9367462$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter((style)=>style !== undefined);
}

});

parcelRegister("dZGRh", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $482144bf493a54ce$export$7d4a7e812d176b24);

var $c9wRy = parcelRequire("c9wRy");

var $e6of9 = parcelRequire("e6of9");

var $6VzHY = parcelRequire("6VzHY");
const $482144bf493a54ce$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $6VzHY.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $e6of9.themeImportMap)[themeId]();
    return themeCss;
};
const $482144bf493a54ce$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $c9wRy.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $6VzHY.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $482144bf493a54ce$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $482144bf493a54ce$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $482144bf493a54ce$var$mountThemeCss(themeCss, themeId);
};
const $482144bf493a54ce$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($482144bf493a54ce$var$loadAndMountThemeCss);
};

});
parcelRegister("6VzHY", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $f0736d8a91d3b430$export$835a0dc855d02822);

var $c9wRy = parcelRequire("c9wRy");

var $fjtMM = parcelRequire("fjtMM");
function $f0736d8a91d3b430$export$835a0dc855d02822(themeId) {
    const doc = (0, $c9wRy.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $fjtMM.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("e1pWM", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $25bafd5da26d6298$export$20f3076712c8dfa);

var $bSJIT = parcelRequire("bSJIT");

var $bDsJN = parcelRequire("bDsJN");

var $bTehu = parcelRequire("bTehu");

var $dqIYa = parcelRequire("dqIYa");
function $25bafd5da26d6298$export$20f3076712c8dfa() {
    const value = (0, $bSJIT.useContext)((0, $dqIYa.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $bDsJN.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $bSJIT.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
    (0, $bSJIT.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $bTehu.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("bTehu", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", () => $4938565dc5643743$export$b741a7c3bcb1c635);
$parcel$export(module.exports, "default", () => $4938565dc5643743$export$2e2bcd8739ae039);

var $fjtMM = parcelRequire("fjtMM");

var $bDsJN = parcelRequire("bDsJN");
class $4938565dc5643743$export$b741a7c3bcb1c635 {
    static #_ = this.observer = null;
    static #_2 = this.callbacks = new Set();
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $4938565dc5643743$export$b741a7c3bcb1c635.callbacks.add(callback);
    }
    observe() {
        if (!$4938565dc5643743$export$b741a7c3bcb1c635.observer) {
            $4938565dc5643743$export$b741a7c3bcb1c635.observer = new MutationObserver(()=>{
                const theme = (0, $bDsJN.getGlobalTheme)();
                $4938565dc5643743$export$b741a7c3bcb1c635.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $4938565dc5643743$export$b741a7c3bcb1c635.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $fjtMM.THEME_DATA_ATTRIBUTE),
                    (0, $fjtMM.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $4938565dc5643743$export$b741a7c3bcb1c635.callbacks.delete(this.callback);
        if ($4938565dc5643743$export$b741a7c3bcb1c635.callbacks.size === 0 && $4938565dc5643743$export$b741a7c3bcb1c635.observer) {
            $4938565dc5643743$export$b741a7c3bcb1c635.observer.disconnect();
            $4938565dc5643743$export$b741a7c3bcb1c635.observer = null;
        }
    }
}
var $4938565dc5643743$export$2e2bcd8739ae039 = $4938565dc5643743$export$b741a7c3bcb1c635;

});


parcelRegister("gIy8r", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $e56de140cda11fa1$export$c582005add11e141);

var $kTaul = parcelRequire("kTaul");

var $aPlTT = parcelRequire("aPlTT");
const $e56de140cda11fa1$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $kTaul.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $kTaul.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $aPlTT.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $e56de140cda11fa1$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $e56de140cda11fa1$var$getPortalParent().appendChild(container);
};

});
parcelRegister("kTaul", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $c3e662cca4dbc91b$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $c3e662cca4dbc91b$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $c3e662cca4dbc91b$export$13f57c02915787b3);
const $c3e662cca4dbc91b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $c3e662cca4dbc91b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $c3e662cca4dbc91b$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("aPlTT", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $5759e09287ac99cd$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $5759e09287ac99cd$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("jGNgw", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $16fe8c50af54dbfc$export$26ae5ca175b4ec5a);

var $kTaul = parcelRequire("kTaul");
const $16fe8c50af54dbfc$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $kTaul.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("7hCdu", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $71e6aec9085515a9$export$da99f98bf3fe55b3);

var $kTaul = parcelRequire("kTaul");

var $aPlTT = parcelRequire("aPlTT");
const $71e6aec9085515a9$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $kTaul.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $kTaul.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $aPlTT.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $71e6aec9085515a9$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $71e6aec9085515a9$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("7sVqe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d99c5117c63ff68c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $2lSxZ = parcelRequire("2lSxZ");

var $e1pWM = parcelRequire("e1pWM");

var $5khki = parcelRequire("5khki");

var $4VUkd = parcelRequire("4VUkd");

var $id8L3 = parcelRequire("id8L3");

var $7Aoly = parcelRequire("7Aoly");
function $d99c5117c63ff68c$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $bSJIT.useState)(null);
    const colorMode = (0, $e1pWM.useColorMode)();
    const isInsideThemeProvider = (0, $5khki.useIsInsideThemeProvider)();
    (0, $4VUkd.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $id8L3.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $7Aoly.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2lSxZ.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $4Sf72.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("4VUkd", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $65617e87684d2732$export$700979bc83e7db82);

var $bSJIT = parcelRequire("bSJIT");
const $65617e87684d2732$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $bSJIT.useLayoutEffect) : (0, $bSJIT.useEffect);

});

parcelRegister("id8L3", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $0cf406c7e0dee640$export$fef014d7cef9e543);

var $kTaul = parcelRequire("kTaul");
const $0cf406c7e0dee640$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $0cf406c7e0dee640$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($0cf406c7e0dee640$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $kTaul.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("7Aoly", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $21ea3b27ec76bd67$export$95029ca7aca2989e);

var $kTaul = parcelRequire("kTaul");

var $aPlTT = parcelRequire("aPlTT");
const $21ea3b27ec76bd67$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $21ea3b27ec76bd67$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($21ea3b27ec76bd67$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $kTaul.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            const parent = document.createElement('div');
            parent.className = (0, $kTaul.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $aPlTT.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("7PkeD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad6f3c620ce9c570$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4VUkd = parcelRequire("4VUkd");
const $ad6f3c620ce9c570$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $bSJIT.useState)(false);
    const [useMountEffect] = (0, $bSJIT.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $4VUkd.useIsomorphicLayoutEffect) : (0, $bSJIT.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ad6f3c620ce9c570$export$2e2bcd8739ae039 = $ad6f3c620ce9c570$var$useIsSubsequentRender;

});

parcelRegister("50ru5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a2848a00adcc810$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $94Bqt = parcelRequire("94Bqt");

var $3Twje = parcelRequire("3Twje");
const $1a2848a00adcc810$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $bSJIT.useEffect)(()=>{
        (0, $3Twje.default)((0, $94Bqt.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $3Twje.default)((0, $94Bqt.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $1a2848a00adcc810$export$2e2bcd8739ae039 = $1a2848a00adcc810$var$useFirePortalEvent;

});
parcelRegister("94Bqt", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $26a180dea894882e$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $26a180dea894882e$export$80816bd900e5bd00);
const $26a180dea894882e$export$ed5835cc67e87f72 = 'akPortalMount';
const $26a180dea894882e$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("3Twje", function(module, exports) {
$parcel$export(module.exports, "default", () => $4daf11ca47a71acd$export$2e2bcd8739ae039);
const $4daf11ca47a71acd$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $4daf11ca47a71acd$var$getLayerName = (zIndex)=>{
    return $4daf11ca47a71acd$var$zIndexToName.hasOwnProperty(zIndex) ? $4daf11ca47a71acd$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $4daf11ca47a71acd$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $4daf11ca47a71acd$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $4daf11ca47a71acd$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $4daf11ca47a71acd$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("juI4y", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $33aVD = parcelRequire("33aVD");
module.exports = Object.assign({}, $33aVD, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($33aVD.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("33aVD", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $333e73fe7c8566d3$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $333e73fe7c8566d3$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $333e73fe7c8566d3$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $333e73fe7c8566d3$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $333e73fe7c8566d3$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $333e73fe7c8566d3$export$c93026a968943f95 = 'light';
const $333e73fe7c8566d3$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $333e73fe7c8566d3$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});


parcelRegister("aQKfL", function(module, exports) {
$parcel$export(module.exports, "DefaultRoleContext", () => $4af732c9b4abf0c5$export$acf85578b9060d4d);
$parcel$export(module.exports, "useDefaultRole", () => $4af732c9b4abf0c5$export$940503e6d676c973);

var $bSJIT = parcelRequire("bSJIT");
const $4af732c9b4abf0c5$export$acf85578b9060d4d = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
function $4af732c9b4abf0c5$export$940503e6d676c973() {
    return (0, $bSJIT.useContext)($4af732c9b4abf0c5$export$acf85578b9060d4d);
}

});

parcelRegister("2I3Ix", function(module, exports) {
$parcel$export(module.exports, "register", () => $476368d021f907d6$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $bAB3U = parcelRequire("bAB3U");
const $476368d021f907d6$var$registrations = new Set();
let $476368d021f907d6$var$cleanupEndEventListeners = null;
function $476368d021f907d6$var$onDragStart() {
    if ($476368d021f907d6$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $476368d021f907d6$var$cleanupEndEventListeners = (0, $bAB3U.bindAll)(window, [
        {
            type: 'dragend',
            listener: $476368d021f907d6$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $476368d021f907d6$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $476368d021f907d6$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($476368d021f907d6$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $476368d021f907d6$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $476368d021f907d6$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $476368d021f907d6$var$cleanupEndEventListeners = null;
    const clone = Array.from($476368d021f907d6$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $476368d021f907d6$var$bindStartEvents() {
    return (0, $bAB3U.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $476368d021f907d6$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $476368d021f907d6$var$onDragStart
        }
    ]);
}
let $476368d021f907d6$var$cleanupStartEventListeners = null;
function $476368d021f907d6$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$476368d021f907d6$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $476368d021f907d6$var$cleanupStartEventListeners = $476368d021f907d6$var$bindStartEvents();
    $476368d021f907d6$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $476368d021f907d6$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $476368d021f907d6$var$registrations.delete(registration);
        if ($476368d021f907d6$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $476368d021f907d6$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $476368d021f907d6$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("eHxps", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $cbe1f02b15aa7393$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $cbe1f02b15aa7393$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $cbe1f02b15aa7393$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $cbe1f02b15aa7393$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $cbe1f02b15aa7393$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $cbe1f02b15aa7393$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("aK4UE", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $c19b28aca00139e6$export$2e68479e0a5d8746);
function $c19b28aca00139e6$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("d3S4D", function(module, exports) {
$parcel$export(module.exports, "show", () => $e5e741366304a0c1$export$57bf213be019eeb0);

var $gdUUy = parcelRequire("gdUUy");
let $e5e741366304a0c1$var$delayId = null;
function $e5e741366304a0c1$var$clearScheduled() {
    if ($e5e741366304a0c1$var$delayId != null) {
        window.clearTimeout($e5e741366304a0c1$var$delayId);
        $e5e741366304a0c1$var$delayId = null;
    }
}
function $e5e741366304a0c1$var$scheduleTimeout(fn, delay) {
    $e5e741366304a0c1$var$clearScheduled();
    $e5e741366304a0c1$var$delayId = window.setTimeout(()=>{
        $e5e741366304a0c1$var$delayId = null;
        fn();
    }, delay);
}
let $e5e741366304a0c1$var$active = null;
function $e5e741366304a0c1$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($e5e741366304a0c1$var$active && $e5e741366304a0c1$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $e5e741366304a0c1$var$clearScheduled();
            $e5e741366304a0c1$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $e5e741366304a0c1$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $e5e741366304a0c1$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $gdUUy.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $e5e741366304a0c1$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($e5e741366304a0c1$var$active && $e5e741366304a0c1$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($e5e741366304a0c1$var$active) {
            $e5e741366304a0c1$var$clearScheduled();
            $e5e741366304a0c1$var$active.entry.hide({
                isImmediate: true
            });
            $e5e741366304a0c1$var$active.entry.done();
            $e5e741366304a0c1$var$active = null;
        }
        // this tooltip is now the active tooltip
        $e5e741366304a0c1$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $e5e741366304a0c1$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("3Pind", function(module, exports) {
$parcel$export(module.exports, "default", () => $c687f374fd14c6bf$export$2e2bcd8739ae039);

var $5ZZ9C = parcelRequire("5ZZ9C");
function $c687f374fd14c6bf$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $5ZZ9C.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("5ZZ9C", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $ecbf8633f817cd49$export$6ee17796e3d70de2);

var $d6mTg = parcelRequire("d6mTg");
function $ecbf8633f817cd49$export$6ee17796e3d70de2() {
    const uid = (0, $d6mTg.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("5VL29", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2e2aaffbc80ac78$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $7A3Bb = parcelRequire("7A3Bb");
const $f2e2aaffbc80ac78$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $f2e2aaffbc80ac78$var$TooltipContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7A3Bb.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            $f2e2aaffbc80ac78$var$styles.base,
            truncate && $f2e2aaffbc80ac78$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});
$f2e2aaffbc80ac78$var$TooltipContainer.displayName = 'TooltipContainer';
var $f2e2aaffbc80ac78$export$2e2bcd8739ae039 = $f2e2aaffbc80ac78$var$TooltipContainer;

});
parcelRegister("7A3Bb", function(module, exports) {
$parcel$export(module.exports, "default", () => $2efd07d3e19c8138$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $aQKfL = parcelRequire("aQKfL");

var $bXDBE = parcelRequire("bXDBE");
const $2efd07d3e19c8138$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $2efd07d3e19c8138$var$TooltipPrimitive = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const defaultRole = (0, $aQKfL.useDefaultRole)();
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
            role: role ?? defaultRole ?? 'tooltip',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9fU1q.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $aQKfL.DefaultRoleContext).Provider, {
                    value: undefined,
                    children: children
                }),
                shortcut && /*#__PURE__*/ (0, $dc70d.jsx)((0, $bXDBE.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$2efd07d3e19c8138$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $2efd07d3e19c8138$export$2e2bcd8739ae039 = $2efd07d3e19c8138$var$TooltipPrimitive;

});
parcelRegister("bXDBE", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $619b6f23fe42608f$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $619b6f23fe42608f$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $619b6f23fe42608f$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $619b6f23fe42608f$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $dc70d.jsx)("kbd", {
                className: (0, $9fU1q.default)([
                    $619b6f23fe42608f$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});






parcelRegister("cfOqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a62e7ff36e4a2cc$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $1a62e7ff36e4a2cc$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    error: {
        id: 'cmdb.object.card.error.loading.object',
        defaultMessage: 'Error occured loading object',
        description: 'Displayed when a value for a CMDB Assets field does not load'
    },
    expandLabel: {
        id: 'cmdb.object.card.expand.label',
        defaultMessage: 'Expand object details',
        description: 'Label for the expand button on the CMDB object field'
    },
    collapseLabel: {
        id: 'cmdb.object.card.collapse.label',
        defaultMessage: 'Collapse object details',
        description: 'Label for the collapse button on the CMDB object field'
    },
    noAttributes: {
        id: 'cmdb.object.card.no.attributes',
        defaultMessage: 'No attributes to display',
        description: 'Shown when an expanded CMDB object card has no attribute details available'
    },
    loadingAttributes: {
        id: 'cmdb.object.card.loading.attributes',
        defaultMessage: 'Loading object details',
        description: 'Accessible label for the spinner shown while a CMDB object card lazily loads its attributes on expand'
    }
});

});






parcelRegister("db841", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetricsV3", () => $f58fbf353047f099$export$229e3124c8dc9ca9);
$parcel$export(module.exports, "startPageLoad", () => $f58fbf353047f099$export$5244fe38dccf2e1d);
$parcel$export(module.exports, "perfMark", () => $f58fbf353047f099$export$61a691dabeb80f51);

var $bSJIT = parcelRequire("bSJIT");

var $kScVw = parcelRequire("kScVw");

var $9hihM = parcelRequire("9hihM");

var $g3L3I = parcelRequire("g3L3I");

var $bDjT0 = parcelRequire("bDjT0");

var $iRD29 = parcelRequire("iRD29");

var $2HsNW = parcelRequire("2HsNW");

var $6JJ8C = parcelRequire("6JJ8C");

var $fuVmc = parcelRequire("fuVmc");

var $lJPdj = parcelRequire("lJPdj");

var $bz32m = parcelRequire("bz32m");

var $cxf4u = parcelRequire("cxf4u");
const $f58fbf353047f099$var$PERFORMANCE_MARK_PREFIX = 'jsd.performance.profile.customer.portal';
/**
 * List of feature flags whose value has to be sent along with Browser metrics.
 */ const $f58fbf353047f099$var$FEATURE_FLAGS_TO_REPORT = [];
const $f58fbf353047f099$export$229e3124c8dc9ca9 = ()=>{
    var _window$JSD_CUSTOMER_;
    if (typeof window === 'undefined') return;
    /**
   * tenant and region information for UFO
   */ const region = (0, $fuVmc.getMeta)('ajs-region');
    const tenantType = (0, $fuVmc.getMeta)('ajs-is-synthetic') === 'true' ? (0, $cxf4u.TenantType).Synthetic : (0, $cxf4u.TenantType).RealUser;
    /**
   * Framework and Product Info
   */ const perimeter = (0, $9hihM.isFedRamp)() ? (0, $kScVw.PerimeterType).FEDRAMP_MODERATE : (0, $kScVw.PerimeterType).COMMERCIAL;
    const info = {
        perimeter: perimeter,
        product: 'jira',
        app: {
            version: {
                web: ((_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || _window$JSD_CUSTOMER_ === void 0 ? void 0 : _window$JSD_CUSTOMER_.buildKey) || 'local'
            },
            framework: {
                version: $bSJIT.version,
                name: 'react'
            }
        },
        region: region !== null ? region : 'none'
    };
    /**
   * eventPipelineClient expects pre configured `analytics-web-client` promise.
   */ const endpoints = {
        eventPipelineClient: (0, $iRD29.getAnalyticsWebClientPromise)().then((client)=>{
            return client.getInstance();
        })
    };
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (0, $iRD29.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $bz32m.payloadPublisher).setup({
            product: info.product,
            app: info.app,
            region: region || info.region,
            gasv3: client.getInstance(),
            resourceTimings: (0, $bDjT0.resourceTimingsPlugin),
            featureFlags: $f58fbf353047f099$var$FEATURE_FLAGS_TO_REPORT,
            ...tenantType && {
                tenantType: tenantType
            }
        });
    });
    (0, $g3L3I.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: {
            featureFlags: (0, $bDjT0.featureFlagsPlugin),
            resourceTimings: (0, $bDjT0.resourceTimingsPlugin)
        },
        events: {
            all: {
                featureFlags: $f58fbf353047f099$var$FEATURE_FLAGS_TO_REPORT,
                plugins: [
                    (0, $bDjT0.customPerfMarks)
                ]
            }
        },
        ssr: {
            getDoneMark: ()=>{
                var _getMark;
                return ((_getMark = (0, $lJPdj.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) || null;
            }
        }
    });
};
let $f58fbf353047f099$var$isInitialPageLoadTracked = false;
const $f58fbf353047f099$export$5244fe38dccf2e1d = (screenName)=>{
    if (typeof window === 'undefined') return;
    if ((0, $2HsNW.isPageLoadInstrumented)(screenName)) {
        (0, $6JJ8C.devLog)('Browser metrics v3: startPageLoad() fired');
        (0, $g3L3I.browserMetrics).startPageLoad({
            isInitial: !$f58fbf353047f099$var$isInitialPageLoadTracked
        });
    }
    if (!$f58fbf353047f099$var$isInitialPageLoadTracked) $f58fbf353047f099$var$isInitialPageLoadTracked = true;
};
function $f58fbf353047f099$export$61a691dabeb80f51(shortKey) {
    let key = shortKey.trim();
    if (!key.startsWith($f58fbf353047f099$var$PERFORMANCE_MARK_PREFIX)) key = `${$f58fbf353047f099$var$PERFORMANCE_MARK_PREFIX}.${shortKey}`;
    window.performance && window.performance.mark && window.performance.mark(key);
}

});
parcelRegister("g3L3I", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $d4e6affbfffacf2a$export$c08e7affcf78b064);

var $2zcL8 = parcelRequire("2zcL8");

var $eJL12 = parcelRequire("eJL12");

var $eHKuC = parcelRequire("eHKuC");

var $hR6on = parcelRequire("hR6on");

var $f80Lm = parcelRequire("f80Lm");

var $eYq11 = parcelRequire("eYq11");

var $1l4tD = parcelRequire("1l4tD");

var $3okgE = parcelRequire("3okgE");
const $d4e6affbfffacf2a$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            var _config$events$BMEven, _config$ssr;
            (0, $hR6on.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $3okgE.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $f80Lm.webVitalsObserver).start();
            if (config.debug) {
                (0, $eJL12.logger).enable();
                (0, $1l4tD.submitter).setDebug(true);
                (0, $eHKuC.pageLoadMetaMetric).setDebug(true);
            }
            (0, $1l4tD.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $2zcL8.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $eYq11.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $eHKuC.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $eHKuC.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $eHKuC.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $eHKuC.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $eHKuC.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $eHKuC.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $d4e6affbfffacf2a$export$c08e7affcf78b064 = $d4e6affbfffacf2a$var$makeBrowserMetrics();

});
parcelRegister("2zcL8", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $6a0763251f56966b$export$9e87a201397ac0a9);
const $6a0763251f56966b$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $6a0763251f56966b$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("eJL12", function(module, exports) {
$parcel$export(module.exports, "logger", () => $060f854040786197$export$af88d00dbe7f521);
const $060f854040786197$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("eHKuC", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $26c454133de6b66d$export$24b7a1a311eb05dc);

var $3okgE = parcelRequire("3okgE");

var $ks10H = parcelRequire("ks10H");

var $lCDMk = parcelRequire("lCDMk");
class $26c454133de6b66d$export$9609608c00ea5077 extends (0, $lCDMk.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $ks10H.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $26c454133de6b66d$export$24b7a1a311eb05dc = new $26c454133de6b66d$export$9609608c00ea5077({
    type: (0, $3okgE.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("3okgE", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $fbbde106230fd0a9$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $fbbde106230fd0a9$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $fbbde106230fd0a9$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $fbbde106230fd0a9$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $fbbde106230fd0a9$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $fbbde106230fd0a9$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $fbbde106230fd0a9$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $fbbde106230fd0a9$export$983b017156c2aee2);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $fbbde106230fd0a9$export$60c0193054fc3040);
var $fbbde106230fd0a9$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $fbbde106230fd0a9$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $fbbde106230fd0a9$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $fbbde106230fd0a9$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $fbbde106230fd0a9$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $fbbde106230fd0a9$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $fbbde106230fd0a9$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $fbbde106230fd0a9$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $fbbde106230fd0a9$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});

parcelRegister("ks10H", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $40f62c2af2e8f237$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $40f62c2af2e8f237$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $40f62c2af2e8f237$export$2bce4ffdd840e878);

var $gdUUy = parcelRequire("gdUUy");

var $6mdBG = parcelRequire("6mdBG");

var $eroKj = parcelRequire("eroKj");

var $dYSIi = parcelRequire("dYSIi");

var $9cfIG = parcelRequire("9cfIG");

var $arOcd = parcelRequire("arOcd");

var $hBt3O = parcelRequire("hBt3O");

var $eJL12 = parcelRequire("eJL12");

var $hR6on = parcelRequire("hR6on");

var $bJg0H = parcelRequire("bJg0H");
var $40f62c2af2e8f237$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $40f62c2af2e8f237$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $40f62c2af2e8f237$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $40f62c2af2e8f237$export$2bce4ffdd840e878 {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $40f62c2af2e8f237$var$getPageVisibleState();
        this.traceContext = null;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        var _this$config$timings;
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach((entry)=>{
            if ((0, $hBt3O.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $eJL12.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $40f62c2af2e8f237$var$getPageVisibleState();
        (0, $hR6on.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
        this.startTrace(this.key);
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $eJL12.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $eJL12.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $hR6on.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        this.stopTrace();
        return true;
    }
    startTrace(metricKey) {
        if ((0, $gdUUy.fg)('uip_bm3_tracing')) {
            let traceContext = (0, $9cfIG.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $dYSIi.generateTraceId)(),
                    spanId: (0, $eroKj.generateSpanId)()
                };
                (0, $arOcd.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'bm3.' + metricKey);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $gdUUy.fg)('uip_bm3_tracing')) (0, $6mdBG.clearActiveTrace)();
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $eJL12.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $hR6on.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type,
            ...(0, $gdUUy.fg)('uip_bm3_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
   *
   * @param metric
   * The array of Until metrics can be of two types
   * This function returns an UntilExperience
   */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $40f62c2af2e8f237$export$2bce4ffdd840e878 ? (0, $bJg0H.UntilExperience).fromMetric(metricOrConfig) : (0, $bJg0H.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = (currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $40f62c2af2e8f237$var$getPageVisibleState();
        this.traceContext = null;
    }
}

});
parcelRegister("6mdBG", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $825d206ff4973234$export$17ab21d7be720b);

var $l2GR0 = parcelRequire("l2GR0");
function $825d206ff4973234$export$17ab21d7be720b() {
    (0, $l2GR0.state).context = null;
}

});
parcelRegister("l2GR0", function(module, exports) {
$parcel$export(module.exports, "state", () => $417cb176e077d931$export$ca000e230c0caa3e);
const $417cb176e077d931$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("eroKj", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $d0e7a252ee02a02d$export$295213bc4d0c54ad);
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $d0e7a252ee02a02d$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("dYSIi", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $fb9cbf1a939a9851$export$dc6d7ea554bcce10);
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $fb9cbf1a939a9851$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("9cfIG", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $bba38b8f4f40149e$export$b6ac780db3a3cc77);

var $l2GR0 = parcelRequire("l2GR0");
function $bba38b8f4f40149e$export$b6ac780db3a3cc77() {
    return (0, $l2GR0.state).context;
}

});

parcelRegister("arOcd", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $b9a6ae5a4697e9aa$export$a1002be327997103);

var $f2Pmd = parcelRequire("f2Pmd");

var $h8q15 = parcelRequire("h8q15");

var $l2GR0 = parcelRequire("l2GR0");
const $b9a6ae5a4697e9aa$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $h8q15.getEnvironment)();
            instance = new (0, $f2Pmd.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $b9a6ae5a4697e9aa$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $l2GR0.state).context !== null) $b9a6ae5a4697e9aa$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $l2GR0.state).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $l2GR0.state).context = {
        traceId: traceId,
        spanId: spanId
    };
}

});
parcelRegister("h8q15", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $7d18e03cb5c76644$export$57570b1603cf6adb);

var $gNwHK = parcelRequire("gNwHK");
function $7d18e03cb5c76644$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $gNwHK.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $gNwHK.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $gNwHK.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $gNwHK.envType).STAGING;
    return (0, $gNwHK.envType).PROD;
}

});


parcelRegister("hBt3O", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $d595c1b131df7930$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $d595c1b131df7930$export$df21d285cfcda81e);
const $d595c1b131df7930$export$1d17377365286b00 = [
    'ssr'
];
const $d595c1b131df7930$export$df21d285cfcda81e = 7500;

});

parcelRegister("hR6on", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $c7805bd210db3aba$export$13e680397ec8f3eb);
class $c7805bd210db3aba$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $c7805bd210db3aba$export$13e680397ec8f3eb = new $c7805bd210db3aba$var$VisibilityChangeObserver();

});

parcelRegister("bJg0H", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $965f992108192005$export$3fcc0936ee2cc852);
class $965f992108192005$export$3fcc0936ee2cc852 {
    static #_ = this.FMP = 'fmp';
    static fromConfig(config) {
        return new $965f992108192005$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $965f992108192005$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$965f992108192005$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
   * Get the time it takes for a segment to become fully interactable,
   * regardless of whether it uses the FMP as the stop time. (Eventual load)
   */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$965f992108192005$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});


parcelRegister("lCDMk", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $4abde74f98d7f7da$export$fd1447b187f590fe);

var $eJL12 = parcelRequire("eJL12");

var $ks10H = parcelRequire("ks10H");
class $4abde74f98d7f7da$export$fd1447b187f590fe extends (0, $ks10H.BaseMetric) {
    static #_ = this.FMP = 'fmp';
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $eJL12.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $ks10H.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $eJL12.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $eJL12.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $ks10H.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $4abde74f98d7f7da$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4abde74f98d7f7da$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($4abde74f98d7f7da$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("f80Lm", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $115f1aedf82580bb$export$253d38dccbb37615);


class $115f1aedf82580bb$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("30UHw"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("kc0VJ"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $115f1aedf82580bb$export$253d38dccbb37615 = new $115f1aedf82580bb$var$WebVitalsObserver();

});
parcelRegister("30UHw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gXexQ").then(()=>parcelRequire('8TzfW'));

});

parcelRegister("kc0VJ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4uVPT").then(()=>parcelRequire('fUzIi'));

});


parcelRegister("eYq11", function(module, exports) {
$parcel$export(module.exports, "Route", () => $6b42d9b11fb55ff4$export$e7b0ac011bb776c6);
const $6b42d9b11fb55ff4$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("1l4tD", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $2f623b2185a125e7$export$c21a25872e3f5a2b);

var $juFEH = parcelRequire("juFEH");

var $3okgE = parcelRequire("3okgE");

var $8Gs1J = parcelRequire("8Gs1J");

var $gTpl2 = parcelRequire("gTpl2");
const $2f623b2185a125e7$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $gTpl2.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $3okgE.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $juFEH.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $8Gs1J.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("8Gs1J", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $3de67472b12d3cea$export$896b6e121bbaec25);

var $hBt3O = parcelRequire("hBt3O");

var $eJL12 = parcelRequire("eJL12");

var $cQxED = parcelRequire("cQxED");

var $6ro5r = parcelRequire("6ro5r");

var $cMils = parcelRequire("cMils");

var $7jx3n = parcelRequire("7jx3n");

var $bCOr7 = parcelRequire("bCOr7");

var $4PlVa = parcelRequire("4PlVa");

var $6eur7 = parcelRequire("6eur7");

var $2Pypa = parcelRequire("2Pypa");

var $e1TV0 = parcelRequire("e1TV0");

var $8y3jn = parcelRequire("8y3jn");

var $7HlCk = parcelRequire("7HlCk");

var $2zo9E = parcelRequire("2zo9E");

var $9NZuy = parcelRequire("9NZuy");

var $36bJ4 = parcelRequire("36bJ4");

var $5bdlJ = parcelRequire("5bdlJ");

var $6xjyk = parcelRequire("6xjyk");

var $4zIGd = parcelRequire("4zIGd");

var $lUHCZ = parcelRequire("lUHCZ");

var $3q1qz = parcelRequire("3q1qz");

var $gLJxk = parcelRequire("gLJxk");

var $6i33c = parcelRequire("6i33c");

var $jo4gA = parcelRequire("jo4gA");

var $iIcim = parcelRequire("iIcim");

var $f0lXO = parcelRequire("f0lXO");

var $46MGk = parcelRequire("46MGk");

var $Ld7K0 = parcelRequire("Ld7K0");

var $hdHjE = parcelRequire("hdHjE");

var $dugK5 = parcelRequire("dugK5");

var $esLAp = parcelRequire("esLAp");

var $gtEMo = parcelRequire("gtEMo");

var $kNeNH = parcelRequire("kNeNH");

var $QDpcR = parcelRequire("QDpcR");

var $hpdJs = parcelRequire("hpdJs");

var $c1s2D = parcelRequire("c1s2D");

var $3bNp9 = parcelRequire("3bNp9");

var $lg8ki = parcelRequire("lg8ki");

var $5kSIR = parcelRequire("5kSIR");

var $3okgE = parcelRequire("3okgE");
const $3de67472b12d3cea$var$defaultSet = [
    (0, $e1TV0.eventKey),
    (0, $5bdlJ.eventType),
    (0, $2zo9E.eventProduct),
    (0, $7HlCk.eventPopulation),
    (0, $36bJ4.eventRoute),
    (0, $6eur7.eventId),
    (0, $8y3jn.eventLocalTime),
    (0, $9NZuy.eventRegion),
    (0, $cMils.appFramework),
    (0, $7jx3n.appVersion),
    (0, $bCOr7.bmVersion),
    (0, $gtEMo.telemetryBrowser),
    (0, $kNeNH.telemetryCpu),
    (0, $QDpcR.telemetryMemory),
    (0, $hpdJs.telemetryNetwork),
    (0, $4PlVa.customData),
    (0, $6xjyk.featureFlags),
    (0, $4zIGd.hostname),
    (0, $hdHjE.productCustomData),
    (0, $c1s2D.appTimings),
    (0, $lg8ki.resourceTimings),
    (0, $5kSIR.traceContext)
];
const $3de67472b12d3cea$var$pageLoadCommon = [
    ...$3de67472b12d3cea$var$defaultSet,
    (0, $46MGk.pageVisibleState),
    (0, $Ld7K0.pageVisibleValue),
    (0, $2Pypa.eventInitial),
    (0, $jo4gA.pageLoadMetrics),
    (0, $3bNp9.bundleEvalTimings)
];
const $3de67472b12d3cea$var$initialPageLoadSet = [
    ...$3de67472b12d3cea$var$pageLoadCommon,
    (0, $3q1qz.initialPageLoadMetrics),
    (0, $6i33c.navigationMetrics),
    (0, $esLAp.ssrSuccess),
    (0, $dugK5.ssrFeatureFlags)
];
const $3de67472b12d3cea$var$spaTransitionSet = [
    ...$3de67472b12d3cea$var$pageLoadCommon
];
const $3de67472b12d3cea$var$pageSegmentLoadSet = [
    ...$3de67472b12d3cea$var$defaultSet,
    (0, $iIcim.pageSegmentLoadMetrics),
    (0, $46MGk.pageVisibleState),
    (0, $Ld7K0.pageVisibleValue),
    (0, $2Pypa.eventInitial),
    (0, $3bNp9.bundleEvalTimings)
];
const $3de67472b12d3cea$var$interactionSet = [
    ...$3de67472b12d3cea$var$defaultSet,
    (0, $46MGk.pageVisibleState),
    (0, $Ld7K0.pageVisibleValue),
    (0, $gLJxk.interactionMetrics)
];
const $3de67472b12d3cea$var$customMetricSet = [
    ...$3de67472b12d3cea$var$defaultSet,
    (0, $46MGk.pageVisibleState),
    (0, $Ld7K0.pageVisibleValue),
    (0, $lUHCZ.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $3de67472b12d3cea$var$webVitalsMetricSet = [
    ...$3de67472b12d3cea$var$defaultSet,
    (0, $f0lXO.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $3de67472b12d3cea$var$waitForCLS = (delay = (0, $hBt3O.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $3de67472b12d3cea$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $eJL12.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $3okgE.BMEventsType).PAGE_LOAD && (0, $cQxED.isPageLoadMetricData)(data) && data.isInitial) set = $3de67472b12d3cea$var$initialPageLoadSet;
    if (data.config.type === (0, $3okgE.BMEventsType).PAGE_LOAD && (0, $cQxED.isPageLoadMetricData)(data) && !data.isInitial) set = $3de67472b12d3cea$var$spaTransitionSet;
    if (data.config.type === (0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD && (0, $6ro5r.isPageSegmentLoadMetricData)(data)) set = $3de67472b12d3cea$var$pageSegmentLoadSet;
    if (data.config.type === (0, $3okgE.BMEventsType).INLINE_RESULT) set = $3de67472b12d3cea$var$interactionSet;
    if (data.config.type === (0, $3okgE.BMEventsType).CUSTOM) set = $3de67472b12d3cea$var$customMetricSet;
    if (data.config.type === (0, $3okgE.BMEventsType).WEB_VITALS) {
        set = $3de67472b12d3cea$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $3de67472b12d3cea$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, // some plugins support page load specific data with special check
        globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("cQxED", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $70d67205a526cebb$export$b0e12e7abb0bff11);

var $3okgE = parcelRequire("3okgE");
const $70d67205a526cebb$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $3okgE.BMEventsType).PAGE_LOAD;
};

});

parcelRegister("6ro5r", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $c3a37459d338ea4e$export$83d0099ee6dbb5b0);

var $3okgE = parcelRequire("3okgE");
const $c3a37459d338ea4e$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD;
};

});

parcelRegister("cMils", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $79070bd7e37e0f64$export$e34e4529b979f74c);
const $79070bd7e37e0f64$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("7jx3n", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $2602fc14ab460ff0$export$82ae485178b37419);
const $2602fc14ab460ff0$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("bCOr7", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $ae27fd196baf9425$export$5cafa465fc876895);
const $ae27fd196baf9425$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("4PlVa", function(module, exports) {
$parcel$export(module.exports, "customData", () => $ae894849ae07ee41$export$f7e743c7db162193);
const $ae894849ae07ee41$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("6eur7", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $8f5b0e3fff1909e3$export$aed28df7ac07d79a);
const $8f5b0e3fff1909e3$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("2Pypa", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $fc9c3c7246a5d6e3$export$fa8e91d436b3ef8b);

var $cQxED = parcelRequire("cQxED");

var $6ro5r = parcelRequire("6ro5r");
const $fc9c3c7246a5d6e3$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $cQxED.isPageLoadMetricData)(data) && !(0, $6ro5r.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("e1TV0", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $7a547bcac56b7956$export$10be2d3a558d3f88);

var $bfEcm = parcelRequire("bfEcm");
const $7a547bcac56b7956$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $bfEcm.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("bfEcm", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $150d169ce4f04c91$export$b334d07f11140768);

var $3okgE = parcelRequire("3okgE");
const $150d169ce4f04c91$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $3okgE.BMEventsType).CUSTOM:
            return (0, $3okgE.StorableBMEventsType).CUSTOM;
        case (0, $3okgE.BMEventsType).INLINE_RESULT:
            return (0, $3okgE.StorableBMEventsType).INLINE_RESULT;
        case (0, $3okgE.BMEventsType).PAGE_LOAD:
            return (0, $3okgE.StorableBMEventsType).PAGE_LOAD;
        case (0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $3okgE.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $3okgE.BMEventsType).WEB_VITALS:
            return (0, $3okgE.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("8y3jn", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $b140edbb113631b0$export$5219854ae7ec45da);

var $53JkC = parcelRequire("53JkC");
const $b140edbb113631b0$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $53JkC.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $53JkC.default)(new Date(), 'i'), 10)
    });

});
parcelRegister("53JkC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3af06577c7b657ba$export$2e2bcd8739ae039);

var $lMRHO = parcelRequire("lMRHO");

var $hxQgK = parcelRequire("hxQgK");

var $897M5 = parcelRequire("897M5");

var $iQuxT = parcelRequire("iQuxT");

var $fA6jx = parcelRequire("fA6jx");

var $6nu0h = parcelRequire("6nu0h");

var $ko8Cm = parcelRequire("ko8Cm");

var $cPnJw = parcelRequire("cPnJw");

var $OPOsJ = parcelRequire("OPOsJ");

var $lLJTa = parcelRequire("lLJTa");

var $3Bqtq = parcelRequire("3Bqtq");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3af06577c7b657ba$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3af06577c7b657ba$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3af06577c7b657ba$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3af06577c7b657ba$var$doubleQuoteRegExp = /''/g;
var $3af06577c7b657ba$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3af06577c7b657ba$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $OPOsJ.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3Bqtq.default);
    var firstWeekContainsDate = (0, $cPnJw.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $cPnJw.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $897M5.default)(dirtyDate);
    if (!(0, $lMRHO.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $6nu0h.default)(originalDate);
    var utcDate = (0, $hxQgK.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($3af06577c7b657ba$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $fA6jx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($3af06577c7b657ba$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $3af06577c7b657ba$var$cleanEscapedString(substring);
        var formatter = (0, $iQuxT.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ko8Cm.isProtectedWeekYearToken)(substring)) (0, $ko8Cm.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ko8Cm.isProtectedDayOfYearToken)(substring)) (0, $ko8Cm.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($3af06577c7b657ba$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $3af06577c7b657ba$var$cleanEscapedString(input) {
    var matched = input.match($3af06577c7b657ba$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3af06577c7b657ba$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lMRHO", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdc7bd7d613249eb$export$2e2bcd8739ae039);

var $fz7Yo = parcelRequire("fz7Yo");

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $fdc7bd7d613249eb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    if (!(0, $fz7Yo.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $897M5.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("fz7Yo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5504f2c5ce5108d$export$2e2bcd8739ae039);

var $2JMbT = parcelRequire("2JMbT");

var $OPOsJ = parcelRequire("OPOsJ");
function $b5504f2c5ce5108d$export$2e2bcd8739ae039(value) {
    (0, $OPOsJ.default)(1, arguments);
    return value instanceof Date || (0, $2JMbT.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("hxQgK", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc5e10461b5c563b$export$2e2bcd8739ae039);

var $kvHVs = parcelRequire("kvHVs");

var $OPOsJ = parcelRequire("OPOsJ");

var $cPnJw = parcelRequire("cPnJw");
function $cc5e10461b5c563b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $OPOsJ.default)(2, arguments);
    var amount = (0, $cPnJw.default)(dirtyAmount);
    return (0, $kvHVs.default)(dirtyDate, -amount);
}

});
parcelRegister("kvHVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee8c69fa4b3679f$export$2e2bcd8739ae039);

var $cPnJw = parcelRequire("cPnJw");

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $eee8c69fa4b3679f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $OPOsJ.default)(2, arguments);
    var timestamp = (0, $897M5.default)(dirtyDate).getTime();
    var amount = (0, $cPnJw.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("cPnJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $956ca866d498b29a$export$2e2bcd8739ae039);
function $956ca866d498b29a$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("iQuxT", function(module, exports) {
$parcel$export(module.exports, "default", () => $db84c70ca1f544f9$export$2e2bcd8739ae039);

var $hM6oI = parcelRequire("hM6oI");

var $kfhLT = parcelRequire("kfhLT");

var $fNPeV = parcelRequire("fNPeV");

var $gMkvx = parcelRequire("gMkvx");

var $ljvvf = parcelRequire("ljvvf");

var $cE071 = parcelRequire("cE071");

var $buD5A = parcelRequire("buD5A");
var $db84c70ca1f544f9$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $db84c70ca1f544f9$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $buD5A.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $ljvvf.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $cE071.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $cE071.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $fNPeV.default)(date);
        // Padding
        return (0, $cE071.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $cE071.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $cE071.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $cE071.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $buD5A.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $cE071.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $gMkvx.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $cE071.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $kfhLT.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $cE071.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $buD5A.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $hM6oI.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $cE071.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $cE071.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $cE071.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $cE071.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $db84c70ca1f544f9$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $db84c70ca1f544f9$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $db84c70ca1f544f9$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $db84c70ca1f544f9$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $db84c70ca1f544f9$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $db84c70ca1f544f9$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $buD5A.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $buD5A.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $cE071.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $cE071.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $buD5A.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $buD5A.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $buD5A.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $db84c70ca1f544f9$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $db84c70ca1f544f9$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $db84c70ca1f544f9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $db84c70ca1f544f9$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $db84c70ca1f544f9$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $db84c70ca1f544f9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $db84c70ca1f544f9$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $db84c70ca1f544f9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $db84c70ca1f544f9$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $db84c70ca1f544f9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $cE071.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $cE071.default)(timestamp, token.length);
    }
};
function $db84c70ca1f544f9$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $cE071.default)(minutes, 2);
}
function $db84c70ca1f544f9$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $cE071.default)(Math.abs(offset) / 60, 2);
    }
    return $db84c70ca1f544f9$var$formatTimezone(offset, dirtyDelimiter);
}
function $db84c70ca1f544f9$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $cE071.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $cE071.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $db84c70ca1f544f9$export$2e2bcd8739ae039 = $db84c70ca1f544f9$var$formatters;

});
parcelRegister("hM6oI", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf0be1d04b20552e$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
var $cf0be1d04b20552e$var$MILLISECONDS_IN_DAY = 86400000;
function $cf0be1d04b20552e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $cf0be1d04b20552e$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("kfhLT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebd2fe6e49d39cdd$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $6d9cX = parcelRequire("6d9cX");

var $bZdxy = parcelRequire("bZdxy");

var $OPOsJ = parcelRequire("OPOsJ");
var $ebd2fe6e49d39cdd$var$MILLISECONDS_IN_WEEK = 604800000;
function $ebd2fe6e49d39cdd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var diff = (0, $6d9cX.default)(date).getTime() - (0, $bZdxy.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ebd2fe6e49d39cdd$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("6d9cX", function(module, exports) {
$parcel$export(module.exports, "default", () => $485b197949cf924c$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $485b197949cf924c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $897M5.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("bZdxy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b9fe4fed5f38d26$export$2e2bcd8739ae039);

var $fNPeV = parcelRequire("fNPeV");

var $6d9cX = parcelRequire("6d9cX");

var $OPOsJ = parcelRequire("OPOsJ");
function $8b9fe4fed5f38d26$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var year = (0, $fNPeV.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $6d9cX.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("fNPeV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8132dc29f275777$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");

var $6d9cX = parcelRequire("6d9cX");
function $b8132dc29f275777$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6d9cX.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6d9cX.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gMkvx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c371096cdf64cd04$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $aeMW9 = parcelRequire("aeMW9");

var $8rAG1 = parcelRequire("8rAG1");

var $OPOsJ = parcelRequire("OPOsJ");
var $c371096cdf64cd04$var$MILLISECONDS_IN_WEEK = 604800000;
function $c371096cdf64cd04$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var diff = (0, $aeMW9.default)(date, options).getTime() - (0, $8rAG1.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c371096cdf64cd04$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("aeMW9", function(module, exports) {
$parcel$export(module.exports, "default", () => $77412c08e7810b40$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");

var $cPnJw = parcelRequire("cPnJw");

var $lLJTa = parcelRequire("lLJTa");
function $77412c08e7810b40$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $OPOsJ.default)(1, arguments);
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var weekStartsOn = (0, $cPnJw.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $897M5.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("lLJTa", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $fd91954c61a78d20$export$430a3269e24b912e);
var $fd91954c61a78d20$var$defaultOptions = {};
function $fd91954c61a78d20$export$430a3269e24b912e() {
    return $fd91954c61a78d20$var$defaultOptions;
}
function $fd91954c61a78d20$export$95365be1b0704abc(newOptions) {
    $fd91954c61a78d20$var$defaultOptions = newOptions;
}

});


parcelRegister("8rAG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $625d4b974f94333d$export$2e2bcd8739ae039);

var $ljvvf = parcelRequire("ljvvf");

var $OPOsJ = parcelRequire("OPOsJ");

var $aeMW9 = parcelRequire("aeMW9");

var $cPnJw = parcelRequire("cPnJw");

var $lLJTa = parcelRequire("lLJTa");
function $625d4b974f94333d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $OPOsJ.default)(1, arguments);
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var firstWeekContainsDate = (0, $cPnJw.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $ljvvf.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $aeMW9.default)(firstWeek, options);
    return date;
}

});
parcelRegister("ljvvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f843cf2476a187b6$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");

var $aeMW9 = parcelRequire("aeMW9");

var $cPnJw = parcelRequire("cPnJw");

var $lLJTa = parcelRequire("lLJTa");
function $f843cf2476a187b6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var firstWeekContainsDate = (0, $cPnJw.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $aeMW9.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $aeMW9.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("cE071", function(module, exports) {
$parcel$export(module.exports, "default", () => $93494ec22a1316ce$export$2e2bcd8739ae039);
function $93494ec22a1316ce$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("buD5A", function(module, exports) {
$parcel$export(module.exports, "default", () => $85e0d15b7276a5d8$export$2e2bcd8739ae039);

var $cE071 = parcelRequire("cE071");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $85e0d15b7276a5d8$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $cE071.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $cE071.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $cE071.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $cE071.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $cE071.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $cE071.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $cE071.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $cE071.default)(fractionalSeconds, token.length);
    }
};
var $85e0d15b7276a5d8$export$2e2bcd8739ae039 = $85e0d15b7276a5d8$var$formatters;

});


parcelRegister("fA6jx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b57f1daa865fa1b5$export$2e2bcd8739ae039);
var $b57f1daa865fa1b5$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $b57f1daa865fa1b5$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $b57f1daa865fa1b5$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $b57f1daa865fa1b5$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $b57f1daa865fa1b5$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $b57f1daa865fa1b5$var$timeLongFormatter(timePattern, formatLong));
};
var $b57f1daa865fa1b5$var$longFormatters = {
    p: $b57f1daa865fa1b5$var$timeLongFormatter,
    P: $b57f1daa865fa1b5$var$dateTimeLongFormatter
};
var $b57f1daa865fa1b5$export$2e2bcd8739ae039 = $b57f1daa865fa1b5$var$longFormatters;

});

parcelRegister("ko8Cm", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $ed7cbbdbeeab8ec6$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $ed7cbbdbeeab8ec6$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $ed7cbbdbeeab8ec6$export$8073c1ae88f0e727);
var $ed7cbbdbeeab8ec6$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $ed7cbbdbeeab8ec6$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $ed7cbbdbeeab8ec6$export$c6cc36aa33304772(token) {
    return $ed7cbbdbeeab8ec6$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $ed7cbbdbeeab8ec6$export$c6b49d6dceb604a1(token) {
    return $ed7cbbdbeeab8ec6$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $ed7cbbdbeeab8ec6$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("3Bqtq", function(module, exports) {
$parcel$export(module.exports, "default", () => $29f95ce6f9655f0d$export$2e2bcd8739ae039);

var $frtSF = parcelRequire("frtSF");
var $29f95ce6f9655f0d$export$2e2bcd8739ae039 = (0, $frtSF.default);

});
parcelRegister("frtSF", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3e08e5895a584d3$export$2e2bcd8739ae039);

var $iYn57 = parcelRequire("iYn57");

var $01YgD = parcelRequire("01YgD");

var $crwhr = parcelRequire("crwhr");

var $h8r8M = parcelRequire("h8r8M");

var $7HSQX = parcelRequire("7HSQX");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b3e08e5895a584d3$var$locale = {
    code: 'en-US',
    formatDistance: (0, $iYn57.default),
    formatLong: (0, $01YgD.default),
    formatRelative: (0, $crwhr.default),
    localize: (0, $h8r8M.default),
    match: (0, $7HSQX.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b3e08e5895a584d3$export$2e2bcd8739ae039 = $b3e08e5895a584d3$var$locale;

});
parcelRegister("iYn57", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcffbc1ee7571ede$export$2e2bcd8739ae039);
var $dcffbc1ee7571ede$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $dcffbc1ee7571ede$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $dcffbc1ee7571ede$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $dcffbc1ee7571ede$export$2e2bcd8739ae039 = $dcffbc1ee7571ede$var$formatDistance;

});

parcelRegister("01YgD", function(module, exports) {
$parcel$export(module.exports, "default", () => $005ed7f7772bab8e$export$2e2bcd8739ae039);

var $8kC29 = parcelRequire("8kC29");
var $005ed7f7772bab8e$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $005ed7f7772bab8e$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $005ed7f7772bab8e$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $005ed7f7772bab8e$var$formatLong = {
    date: (0, $8kC29.default)({
        formats: $005ed7f7772bab8e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8kC29.default)({
        formats: $005ed7f7772bab8e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8kC29.default)({
        formats: $005ed7f7772bab8e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $005ed7f7772bab8e$export$2e2bcd8739ae039 = $005ed7f7772bab8e$var$formatLong;

});
parcelRegister("8kC29", function(module, exports) {
$parcel$export(module.exports, "default", () => $610db1b547f80a39$export$2e2bcd8739ae039);
function $610db1b547f80a39$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("crwhr", function(module, exports) {
$parcel$export(module.exports, "default", () => $90f10bdd40671db9$export$2e2bcd8739ae039);
var $90f10bdd40671db9$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $90f10bdd40671db9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $90f10bdd40671db9$var$formatRelativeLocale[token];
};
var $90f10bdd40671db9$export$2e2bcd8739ae039 = $90f10bdd40671db9$var$formatRelative;

});

parcelRegister("h8r8M", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7983c91e6058ae9$export$2e2bcd8739ae039);

var $4wACE = parcelRequire("4wACE");
var $c7983c91e6058ae9$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $c7983c91e6058ae9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c7983c91e6058ae9$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $c7983c91e6058ae9$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $c7983c91e6058ae9$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $c7983c91e6058ae9$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $c7983c91e6058ae9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $c7983c91e6058ae9$var$localize = {
    ordinalNumber: $c7983c91e6058ae9$var$ordinalNumber,
    era: (0, $4wACE.default)({
        values: $c7983c91e6058ae9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4wACE.default)({
        values: $c7983c91e6058ae9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4wACE.default)({
        values: $c7983c91e6058ae9$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4wACE.default)({
        values: $c7983c91e6058ae9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4wACE.default)({
        values: $c7983c91e6058ae9$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c7983c91e6058ae9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c7983c91e6058ae9$export$2e2bcd8739ae039 = $c7983c91e6058ae9$var$localize;

});
parcelRegister("4wACE", function(module, exports) {
$parcel$export(module.exports, "default", () => $34b68f01699fd482$export$2e2bcd8739ae039);
function $34b68f01699fd482$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("7HSQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $59c719418c64e8e9$export$2e2bcd8739ae039);

var $263Sx = parcelRequire("263Sx");

var $fPN6X = parcelRequire("fPN6X");
var $59c719418c64e8e9$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $59c719418c64e8e9$var$parseOrdinalNumberPattern = /\d+/i;
var $59c719418c64e8e9$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $59c719418c64e8e9$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $59c719418c64e8e9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $59c719418c64e8e9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $59c719418c64e8e9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $59c719418c64e8e9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $59c719418c64e8e9$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $59c719418c64e8e9$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $59c719418c64e8e9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $59c719418c64e8e9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $59c719418c64e8e9$var$match = {
    ordinalNumber: (0, $fPN6X.default)({
        matchPattern: $59c719418c64e8e9$var$matchOrdinalNumberPattern,
        parsePattern: $59c719418c64e8e9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $263Sx.default)({
        matchPatterns: $59c719418c64e8e9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59c719418c64e8e9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $263Sx.default)({
        matchPatterns: $59c719418c64e8e9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59c719418c64e8e9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $263Sx.default)({
        matchPatterns: $59c719418c64e8e9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59c719418c64e8e9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $263Sx.default)({
        matchPatterns: $59c719418c64e8e9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59c719418c64e8e9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $263Sx.default)({
        matchPatterns: $59c719418c64e8e9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $59c719418c64e8e9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $59c719418c64e8e9$export$2e2bcd8739ae039 = $59c719418c64e8e9$var$match;

});
parcelRegister("263Sx", function(module, exports) {
$parcel$export(module.exports, "default", () => $186f268444a7d71e$export$2e2bcd8739ae039);
function $186f268444a7d71e$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $186f268444a7d71e$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $186f268444a7d71e$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $186f268444a7d71e$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $186f268444a7d71e$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("fPN6X", function(module, exports) {
$parcel$export(module.exports, "default", () => $b871b6ecb2f71b37$export$2e2bcd8739ae039);
function $b871b6ecb2f71b37$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("7HlCk", function(module, exports) {
$parcel$export(module.exports, "eventPopulation", () => $029181a5efe1123e$export$9086dbeda9b1d633);
const $029181a5efe1123e$export$9086dbeda9b1d633 = (_config, _data, globalConfig)=>{
    if (!globalConfig.population) return {};
    return {
        'event:population': `${globalConfig.population}`
    };
};

});

parcelRegister("2zo9E", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $da5efdbc3822d19e$export$a7df4e8088db8843);
const $da5efdbc3822d19e$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("9NZuy", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $b274782644be5a08$export$d0117b71adcdebc0);
const $b274782644be5a08$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("36bJ4", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $9a6613ebe9399f26$export$44d3627af289ca16);
const $9a6613ebe9399f26$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("5bdlJ", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $d67f3175c284d4a2$export$4c045e605d532c98);

var $bfEcm = parcelRequire("bfEcm");
const $d67f3175c284d4a2$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $bfEcm.mapEventType)(config.type)
    };
};

});

parcelRegister("6xjyk", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $44df764495463852$export$e62953d023125748);
const $44df764495463852$export$e62953d023125748 = (config, _data, globalConfig)=>{
    var _config$featureFlags;
    const localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("4zIGd", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $5f3ccf7d7e51cc33$export$640106f6dc7d2706);
const $5f3ccf7d7e51cc33$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("lUHCZ", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $34ad68f97703800d$export$cab039265c52a2e9);

var $b5fnS = parcelRequire("b5fnS");
const $34ad68f97703800d$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    var _config$slo, _config$histogram;
    if (!(0, $b5fnS.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});
parcelRegister("b5fnS", function(module, exports) {
$parcel$export(module.exports, "isCustomConfig", () => $e390c1a05e80e4b0$export$b493eb8b2ba87421);

var $3okgE = parcelRequire("3okgE");
const $e390c1a05e80e4b0$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $3okgE.BMEventsType).CUSTOM;
};

});


parcelRegister("3q1qz", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $2111981db71e11c2$export$cc95aa3f6ea8e5cb);
const $2111981db71e11c2$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("gLJxk", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $2449dd66527c924b$export$86db56030b57ba34);

var $gD2M3 = parcelRequire("gD2M3");

var $bF5y2 = parcelRequire("bF5y2");

var $3okgE = parcelRequire("3okgE");
const $2449dd66527c924b$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    var _config$histogram;
    if (!(0, $bF5y2.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $3okgE.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $gD2M3.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $3okgE.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $3okgE.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $gD2M3.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});
parcelRegister("gD2M3", function(module, exports) {
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $ec46721274d8d4cb$export$b10c1d9a7db7765b);
const $ec46721274d8d4cb$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};

});

parcelRegister("bF5y2", function(module, exports) {
$parcel$export(module.exports, "isInteractionConfig", () => $8f480162767a92fd$export$ae68674b6a9353be);

var $3okgE = parcelRequire("3okgE");
const $8f480162767a92fd$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $3okgE.BMEventsType).INLINE_RESULT;
};

});


parcelRegister("6i33c", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $a9784b83620c0ccb$export$b88d990436be0f8a);
const $a9784b83620c0ccb$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("jo4gA", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $0a616060292b2f8f$export$2878bf482e539059);

var $fG0r4 = parcelRequire("fG0r4");

var $cRwEv = parcelRequire("cRwEv");

var $3okgE = parcelRequire("3okgE");
const $0a616060292b2f8f$var$getThreshold = (isInitial, metric)=>{
    return (0, $fG0r4.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $0a616060292b2f8f$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $0a616060292b2f8f$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $cRwEv.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $3okgE.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $0a616060292b2f8f$var$getHistogram(data.isInitial, (0, $3okgE.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $0a616060292b2f8f$var$getHistogram(data.isInitial, (0, $3okgE.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $0a616060292b2f8f$var$getHistogram(data.isInitial, (0, $3okgE.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $0a616060292b2f8f$var$getHistogram(data.isInitial, (0, $3okgE.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $0a616060292b2f8f$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $0a616060292b2f8f$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});
parcelRegister("fG0r4", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $91c0f0f6c7490dba$export$5866f95702a15142);
const $91c0f0f6c7490dba$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("cRwEv", function(module, exports) {
$parcel$export(module.exports, "isPageLoadConfig", () => $a19bf2fb6558aae0$export$8672fa27ba8bba88);

var $3okgE = parcelRequire("3okgE");
const $a19bf2fb6558aae0$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $3okgE.BMEventsType).PAGE_LOAD;
};

});


parcelRegister("iIcim", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $b82389aa0b9ba38d$export$ba86cb47f2f22db5);

var $eoYMP = parcelRequire("eoYMP");

var $6iolB = parcelRequire("6iolB");

var $eHKuC = parcelRequire("eHKuC");

var $3okgE = parcelRequire("3okgE");
const $b82389aa0b9ba38d$var$getThreshold = (isInitial, metric)=>{
    return (0, $eoYMP.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $b82389aa0b9ba38d$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $b82389aa0b9ba38d$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    var _config$slo, _config$slo2;
    if (!(0, $6iolB.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $3okgE.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $b82389aa0b9ba38d$var$getHistogram(data.isInitial, (0, $3okgE.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $b82389aa0b9ba38d$var$getHistogram(data.isInitial, (0, $3okgE.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $b82389aa0b9ba38d$var$getHistogram(data.isInitial, (0, $3okgE.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $b82389aa0b9ba38d$var$getHistogram(data.isInitial, (0, $3okgE.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        const threshold = $b82389aa0b9ba38d$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        const threshold = $b82389aa0b9ba38d$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $3okgE.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $3okgE.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $eHKuC.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $3okgE.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});
parcelRegister("eoYMP", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $3c6493a2dbe028ab$export$f087a59bd717e49d);
const $3c6493a2dbe028ab$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("6iolB", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $d6b0a3058afb30d9$export$abe063537ef4987b);

var $3okgE = parcelRequire("3okgE");
const $d6b0a3058afb30d9$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD;
};

});


parcelRegister("f0lXO", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $997af0e18547168c$export$3731db279f590f30);

var $ks10H = parcelRequire("ks10H");

var $hR6on = parcelRequire("hR6on");

var $Ld7K0 = parcelRequire("Ld7K0");

var $4Vg7D = parcelRequire("4Vg7D");
const $997af0e18547168c$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $ks10H.PageVisibleState).MIXED;
    };
    (0, $hR6on.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
    const webVitalMetrics = await (0, $4Vg7D.webVitalsMetricCustomTimeout)(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
    (0, $hR6on.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $Ld7K0.pageVisibleValue)(config, data, globalConfig)
    };
};

});
parcelRegister("Ld7K0", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $57b67cbe1b4ee3cb$export$177b923114656380);

var $ks10H = parcelRequire("ks10H");

var $3okgE = parcelRequire("3okgE");
const $57b67cbe1b4ee3cb$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $3okgE.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $ks10H.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});

parcelRegister("4Vg7D", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetricCustomTimeout", () => $fd608fe1c771fb44$export$193ae490b52081dd);

var $f80Lm = parcelRequire("f80Lm");
const $fd608fe1c771fb44$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $f80Lm.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $f80Lm.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $f80Lm.webVitalsObserver).data;
};

});


parcelRegister("46MGk", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $cb16be8ecc5dd211$export$723b4c298aca63af);
const $cb16be8ecc5dd211$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("hdHjE", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $6591b858267b5603$export$fa2af6e412815a74);
const $6591b858267b5603$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("dugK5", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $c0ccd46b84e47d59$export$fdbea518c19dfa8);

var $3okgE = parcelRequire("3okgE");
const $c0ccd46b84e47d59$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $c0ccd46b84e47d59$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
    // no config or missing
    if (!((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags)) return null;
    const includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $3okgE.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $3okgE.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $3okgE.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $c0ccd46b84e47d59$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("esLAp", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $438281b976013764$export$a3dc8251cf55b2e0);
const $438281b976013764$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("gtEMo", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $1adde893457632b3$export$386b10ac64a50b1);

var $iMLER = parcelRequire("iMLER");
const $1adde893457632b3$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($iMLER))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($iMLER))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("iMLER", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("kNeNH", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $b3f013a4983e2474$export$9f84cb359ed29139);
const $b3f013a4983e2474$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("QDpcR", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $b3ce2522151db15b$export$496c14d72b257e07);
const $b3ce2522151db15b$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("hpdJs", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $08e5cf68c7ff2bdf$export$88bf7b55f7fc4e8e);
const $08e5cf68c7ff2bdf$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("c1s2D", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $628ae8cf9fe1ffe3$export$e952f50a4f2d02da);

var $3okgE = parcelRequire("3okgE");

var $gwbbZ = parcelRequire("gwbbZ");

var $69nGM = parcelRequire("69nGM");
const $628ae8cf9fe1ffe3$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $3okgE.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $gwbbZ.customTimings)(config, data);
    const ssr = config.type === (0, $3okgE.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $69nGM.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("gwbbZ", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $d94fae5bd93485d6$export$6126f85083a72c6e);

var $iB8r3 = parcelRequire("iB8r3");
const $d94fae5bd93485d6$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $d94fae5bd93485d6$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $d94fae5bd93485d6$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $d94fae5bd93485d6$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $iB8r3.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("iB8r3", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $6fed4b4e17892409$export$b98e411ae80c806f);
const $6fed4b4e17892409$export$b98e411ae80c806f = '/';

});


parcelRegister("69nGM", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $1f92cb93efd95336$export$130f411261a599c5);

var $iB8r3 = parcelRequire("iB8r3");
const $1f92cb93efd95336$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $1f92cb93efd95336$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $1f92cb93efd95336$var$SSR_PREFIX = 'ssr';
const $1f92cb93efd95336$var$mapKey = (key)=>{
    if (key === 'total') return $1f92cb93efd95336$var$SSR_PREFIX;
    return `${$1f92cb93efd95336$var$SSR_PREFIX}${0, $iB8r3.NESTED_METRIC_SEPARATOR}${key}`;
};
const $1f92cb93efd95336$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($1f92cb93efd95336$var$filterEntry(entry[1])) acc[$1f92cb93efd95336$var$mapKey(entry[0])] = $1f92cb93efd95336$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("3bNp9", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $9f9d2b4a3b9a506c$export$1a2bb347935fc536);
const $9f9d2b4a3b9a506c$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $9f9d2b4a3b9a506c$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($9f9d2b4a3b9a506c$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("lg8ki", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $799940383e12ec51$export$81a7d52441a06b50);
const $799940383e12ec51$var$cacheableTypes = [
    'script',
    'link'
];
const $799940383e12ec51$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $799940383e12ec51$var$CACHE_NETWORK = 'network';
const $799940383e12ec51$var$CACHE_MEMORY = 'memory';
const $799940383e12ec51$var$CACHE_DISK = 'disk';
const $799940383e12ec51$var$calculateTransferType = (type, duration, size)=>{
    if (!$799940383e12ec51$var$cacheableTypes.includes(type)) return $799940383e12ec51$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $799940383e12ec51$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $799940383e12ec51$var$CACHE_DISK;
    if (size === undefined) return null;
    return $799940383e12ec51$var$CACHE_NETWORK;
};
const $799940383e12ec51$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$799940383e12ec51$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $799940383e12ec51$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $799940383e12ec51$var$withoutHeaders = ()=>false;
const $799940383e12ec51$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $799940383e12ec51$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $799940383e12ec51$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $799940383e12ec51$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $799940383e12ec51$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $799940383e12ec51$var$getNetworkData = (item, eventStart, hasTimingHeaders = $799940383e12ec51$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$799940383e12ec51$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($799940383e12ec51$var$cacheableTypes.includes(type)) {
        const transferType = $799940383e12ec51$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$799940383e12ec51$var$getSizeObject(size)
        };
        if (transferType !== $799940383e12ec51$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$799940383e12ec51$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$799940383e12ec51$var$getSizeObject(size)
    };
};
const $799940383e12ec51$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $799940383e12ec51$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $799940383e12ec51$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$799940383e12ec51$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$799940383e12ec51$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});

parcelRegister("5kSIR", function(module, exports) {
$parcel$export(module.exports, "traceContext", () => $dc37dc0ab9ccebb6$export$90f20fc1d8cfb95b);
const $dc37dc0ab9ccebb6$export$90f20fc1d8cfb95b = (_config, data, _globalConfig)=>{
    if (!data.traceContext) return null;
    return {
        tracingContext: {
            'X-B3-TraceId': data.traceContext.traceId,
            'X-B3-SpanId': data.traceContext.spanId
        }
    };
};

});


parcelRegister("gTpl2", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $b055c5f29859b402$export$5b4fb14409a2a825);

var $3okgE = parcelRequire("3okgE");
const $b055c5f29859b402$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $b055c5f29859b402$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) ?? (allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) ?? (0, $3okgE.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($b055c5f29859b402$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    });
};
const $b055c5f29859b402$export$5b4fb14409a2a825 = async (globalConfig)=>{
    var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: (_globalConfig$events$ = globalConfig.events[(0, $3okgE.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $3okgE.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $3okgE.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
        }
    };
    return {
        [(0, $3okgE.BMEventsType).PAGE_LOAD]: $b055c5f29859b402$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3okgE.BMEventsType).PAGE_LOAD]),
        [(0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD]: $b055c5f29859b402$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $3okgE.BMEventsType).INLINE_RESULT]: $b055c5f29859b402$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3okgE.BMEventsType).INLINE_RESULT]),
        [(0, $3okgE.BMEventsType).CUSTOM]: $b055c5f29859b402$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3okgE.BMEventsType).CUSTOM]),
        [(0, $3okgE.BMEventsType).WEB_VITALS]: $b055c5f29859b402$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3okgE.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("bDjT0", function(module, exports) {
$parcel$export(module.exports, "featureFlagsPlugin", () => $10d15e587f3a0bf1$export$79626a094e303f80);
$parcel$export(module.exports, "resourceTimingsPlugin", () => $10d15e587f3a0bf1$export$8c43ac1c32352978);
$parcel$export(module.exports, "customPerfMarks", () => $10d15e587f3a0bf1$export$960f38db9936e6ea);

var $87QgR = parcelRequire("87QgR");

var $6JJ8C = parcelRequire("6JJ8C");

var $l8KUO = parcelRequire("l8KUO");

var $71efu = parcelRequire("71efu");
const $10d15e587f3a0bf1$export$e5bb225813e92c1f = (url)=>url.includes('jsm-portal-frontend');
const $10d15e587f3a0bf1$export$79626a094e303f80 = {
    client: Promise.resolve({
        getValue: (featureFlagName)=>{
            return (0, $87QgR.default).checkGate(featureFlagName);
        }
    })
};
const $10d15e587f3a0bf1$export$6dfc8bfc2349f367 = (url)=>{
    const { isProcessed: isProcessed, url: processedUrl } = (0, $71efu.processUrl)(url, []);
    if (!isProcessed) {
        (0, $6JJ8C.devLog)(`Unsanitised URL: ${processedUrl}`);
        return 'unknown';
    }
    return processedUrl;
};
const $10d15e587f3a0bf1$export$8c43ac1c32352978 = {
    hasTimingHeaders: $10d15e587f3a0bf1$export$e5bb225813e92c1f,
    sanitiseEndpoints: $10d15e587f3a0bf1$export$6dfc8bfc2349f367,
    mapResources: (0, $l8KUO.sanitizeAssetName)(false)
};
function $10d15e587f3a0bf1$export$960f38db9936e6ea() {
    var _window$performance, _window$performance$g;
    const marks = {};
    const entries = (_window$performance = window.performance) === null || _window$performance === void 0 || (_window$performance$g = _window$performance.getEntriesByType) === null || _window$performance$g === void 0 ? void 0 : _window$performance$g.call(_window$performance, 'mark');
    if (entries && entries.length > 0) entries.forEach((entry)=>{
        const key = `mark__${entry.name}`;
        const value = Math.floor(entry.startTime);
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        marks[key] = value;
    });
    return marks;
}

});
parcelRegister("l8KUO", function(module, exports) {
$parcel$export(module.exports, "sanitizeAssetName", () => $dfa30f26be3c58ac$export$715967a06dea6152);
/**
 * Webpack dev assets without hashes
 */ const $dfa30f26be3c58ac$var$webpackDevAssetsRegexp = /(.*)\.(?:chunk|bundle)(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * Webpack prod assets with hashes
 */ const $dfa30f26be3c58ac$var$webpackProdAssetsRegexp = /(.*)\.(?:chunk|bundle)\..*(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * jira.webresources:calendar.js asset with localization string
 */ const $dfa30f26be3c58ac$var$calendarWRMRegexp = /(jira.webresources:calendar)(-[a-z]+).js$/;
/**
 * This returns the base name of the asset/url that is getting loaded.
 * eg: for: https://<your-domain>/assets/servicedesk-vendor.chunk.js
 * return servicedesk-vendor.chunk.js
 * @param assetPathOrURL all the external asset/path urls,  eg: anything refereced using <link>, <script> etc tag
 */ const $dfa30f26be3c58ac$var$getBaseName = (assetPathOrURL)=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop() || '';
const $dfa30f26be3c58ac$export$715967a06dea6152 = (isDevelopment)=>(assetPathOrURL)=>{
        const assetBaseName = $dfa30f26be3c58ac$var$getBaseName(assetPathOrURL);
        const webpackAssetsMatch = assetBaseName.match(isDevelopment ? $dfa30f26be3c58ac$var$webpackDevAssetsRegexp : $dfa30f26be3c58ac$var$webpackProdAssetsRegexp);
        if (webpackAssetsMatch) return `${webpackAssetsMatch[1]}.js`;
        const calendarWRMMatch = assetBaseName.match($dfa30f26be3c58ac$var$calendarWRMRegexp);
        if (calendarWRMMatch) return `${calendarWRMMatch[1]}.js`;
        return assetBaseName;
    };

});

parcelRegister("71efu", function(module, exports) {
$parcel$export(module.exports, "processUrl", () => $8cd921221285832a$export$8378cb52a6ed7e05);
class $8cd921221285832a$export$b323b8cc3ace981b {
    /**
   * Processes URLs that match a given pattern.
   *
   * @param pattern The pattern to match the URL against
   * @param onMatch The action to perform on the URL
   */ constructor(options){
        this.hasMatched = false;
        this.name = options.name;
        this.onMatch = options.onMatch;
        this.pattern = options.pattern;
    }
    /**
   * True if the last URL processed matched the processor's pattern.
   */ getHasMatched() {
        return this.hasMatched;
    }
    /**
   * The name of the processor.
   */ getName() {
        return this.name;
    }
    /**
   * Attempt to process the URL.
   *
   * If the URL matches the processor's pattern, then the URL is processed
   * and `hasMatched` is set to true. Otherwise, return the URL as is, and
   * set `hasMatched` to false.
   *
   * @param url The URL to process
   * @returns The URL (processed if the pattern matched, otherwise as-is)
   */ process(url) {
        const match = url.match(this.pattern);
        if (match) {
            this.hasMatched = true;
            const processedUrl = this.onMatch(url, match);
            return processedUrl;
        }
        this.hasMatched = false;
        return url;
    }
}
const $8cd921221285832a$export$8378cb52a6ed7e05 = (url, processors)=>{
    for (const processor of processors){
        const processedUrl = processor.process(url);
        if (processor.getHasMatched()) return {
            url: processedUrl,
            isProcessed: true
        };
    }
    return {
        url: url,
        isProcessed: false
    };
};

});


parcelRegister("2HsNW", function(module, exports) {
$parcel$export(module.exports, "isPageLoadInstrumented", () => $29da65e36b0bfe1f$export$f571430402d3e925);
$parcel$export(module.exports, "default", () => $29da65e36b0bfe1f$export$2e2bcd8739ae039);

var $1ZJcz = parcelRequire("1ZJcz");

var $jcRK7 = parcelRequire("jcRK7");
const $29da65e36b0bfe1f$export$8d6ac02b84099d24 = ()=>{
    if (window.__IS_PAGE_SERVER_SIDE_RENDERED__) return {
        ssr: {
            doneAsFmp: true
        }
    };
    return {};
};
/**
 * Object containing page load metric for all instrumented screens,
 * as we instrument BM3 for more screens we update values here
 * all new keys will follow the `service-management.help-center.[screenName]` schema
 * and can be accessed using `jira.fe.page-load.service-management.help-center.[screenName]`
 */ const $29da65e36b0bfe1f$var$perfConfig = {
    [(0, $jcRK7.ScreenName).HELP_CENTER]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-help-center',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).PORTAL_REORDER_SETTINGS]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-reorder-settings',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).VIEW_TOPIC]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.view-topic',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).EDIT_TOPIC]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.edit-topic',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).EDIT_HOMEPAGE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.edit-homepage',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-knowledge-resources',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).ADD_HELP_CONTENT_EXTERNAL_LINKS]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-external-links',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).UNIFIED_HELP_HOME_PAGE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.unified-help-center.home-page',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).HELP_CENTERS_MANAGEMENT]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.help-centers-management',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).HELP_HUBS_MANAGEMENT]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.help-hubs-management',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    })
};
const $29da65e36b0bfe1f$var$bm3BatchOneMetrics = {
    [(0, $jcRK7.ScreenName).REQUEST_LIST]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-requests',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).LOGIN]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-login',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.knowledge-article',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).LOGIN_SINGLE_SIGN_ON]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-single-sign-on',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).SIGNUP]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-signup',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).APPROVAL_LIST]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-approvals',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).KNOWLEDGE_CATEGORY]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.category-page',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).USER_PROFILE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-profile',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).CHECK_EMAIL]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-validate-email',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).COMPLETE_SIGNUP]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).RESET_PASSWORD]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-reset-password',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).INVITED_SIGNUP]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-accept-invite',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).COMPLETE_SIGNUP_TOKEN_INVALID]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-invalid',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).COMPLETE_SIGNUP_TOKEN_EXPIRED]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-expired',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-forgot-password-confirmation',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).CONSENT_FORM_PAGE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.user-consent',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    })
};
const $29da65e36b0bfe1f$var$bm3BatchTwoMetrics = {
    [(0, $jcRK7.ScreenName).REQUEST_DETAILS]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-details',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).REQUEST_CREATE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-create',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).PORTAL_HOME]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.single-portal',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).REQUEST_GROUP]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.request-group',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).REQUEST_GROUP_LIST]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.request-group-list',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).FEEDBACK]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.request-create-anonymous-success',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).UNSUBSCRIBE]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-unsubscribe-confirmation',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    }),
    [(0, $jcRK7.ScreenName).FEEDBACK_SUBMITTED]: (0, $1ZJcz.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback-comment-submitted',
        ...$29da65e36b0bfe1f$export$8d6ac02b84099d24()
    })
};
Object.assign($29da65e36b0bfe1f$var$perfConfig, $29da65e36b0bfe1f$var$bm3BatchOneMetrics, $29da65e36b0bfe1f$var$bm3BatchTwoMetrics);
const $29da65e36b0bfe1f$export$f571430402d3e925 = (screenName)=>{
    if (!screenName) return false;
    return $29da65e36b0bfe1f$var$perfConfig.hasOwnProperty(screenName);
};
var $29da65e36b0bfe1f$export$2e2bcd8739ae039 = $29da65e36b0bfe1f$var$perfConfig;

});
parcelRegister("1ZJcz", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $f88f9997836f6255$export$b0c5c2fac8144e54);

var $2nfFE = parcelRequire("2nfFE");

var $h2AEy = parcelRequire("h2AEy");

var $aks5t = parcelRequire("aks5t");

var $9YlzO = parcelRequire("9YlzO");

var $jt5pb = parcelRequire("jt5pb");
const $f88f9997836f6255$export$b0c5c2fac8144e54 = {
    pageLoad: $9YlzO.pageLoad,
    pageSegmentLoad: $jt5pb.pageSegmentLoad,
    interaction: $aks5t.interaction,
    custom: $h2AEy.custom,
    concurrent: $2nfFE.concurrent
};

});
parcelRegister("2nfFE", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $48ea81c48fb0d560$export$370df09ecc3de059);

var $3okgE = parcelRequire("3okgE");

var $h2AEy = parcelRequire("h2AEy");

var $aks5t = parcelRequire("aks5t");
const $48ea81c48fb0d560$var$concurrentMetrics = {};
const $48ea81c48fb0d560$var$getKey = (config, type)=>`${type}--${config.key}`;
const $48ea81c48fb0d560$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $48ea81c48fb0d560$var$ensurePath = (config, type)=>{
    const key = $48ea81c48fb0d560$var$getKey(config, type);
    if (!(key in $48ea81c48fb0d560$var$concurrentMetrics)) $48ea81c48fb0d560$var$concurrentMetrics[key] = {};
};
const $48ea81c48fb0d560$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $48ea81c48fb0d560$var$getKey(config, type);
    if (concurrentKey in $48ea81c48fb0d560$var$concurrentMetrics && $48ea81c48fb0d560$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $48ea81c48fb0d560$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $48ea81c48fb0d560$var$concurrentMetrics)) $48ea81c48fb0d560$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $48ea81c48fb0d560$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $48ea81c48fb0d560$var$validateConfig(config);
    $48ea81c48fb0d560$var$ensurePath(config, type);
    const metricFromCache = $48ea81c48fb0d560$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $3okgE.BMEventsType).INLINE_RESULT ? (0, $aks5t.interaction) : (0, $h2AEy.custom);
    const metric = metricFactory(config);
    $48ea81c48fb0d560$var$concurrentMetrics[$48ea81c48fb0d560$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $48ea81c48fb0d560$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$48ea81c48fb0d560$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$48ea81c48fb0d560$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $3okgE.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$48ea81c48fb0d560$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $3okgE.BMEventsType).CUSTOM)
};

});
parcelRegister("h2AEy", function(module, exports) {
$parcel$export(module.exports, "custom", () => $6af32f53a06ae742$export$4c00f665f0d4b443);

var $1o5Pr = parcelRequire("1o5Pr");

var $3okgE = parcelRequire("3okgE");
const $6af32f53a06ae742$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $1o5Pr.Metric)({
        ...config,
        type: (0, $3okgE.BMEventsType).CUSTOM
    });
};

});
parcelRegister("1o5Pr", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $a71751c3cf342979$export$efdd3e096bc27746);

var $eYq11 = parcelRequire("eYq11");

var $1l4tD = parcelRequire("1l4tD");

var $ks10H = parcelRequire("ks10H");
class $a71751c3cf342979$export$efdd3e096bc27746 extends (0, $ks10H.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $eYq11.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $1l4tD.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});


parcelRegister("aks5t", function(module, exports) {
$parcel$export(module.exports, "interaction", () => $95b248caeb41bea4$export$92473e6020ad89b4);

var $1o5Pr = parcelRequire("1o5Pr");

var $3okgE = parcelRequire("3okgE");
const $95b248caeb41bea4$export$92473e6020ad89b4 = (config)=>{
    return new (0, $1o5Pr.Metric)({
        ...config,
        type: (0, $3okgE.BMEventsType).INLINE_RESULT
    });
};

});


parcelRegister("9YlzO", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $727c9d5eb3ac4c34$export$791d520f7e8058a5);

var $2ZNOa = parcelRequire("2ZNOa");

var $3okgE = parcelRequire("3okgE");
const $727c9d5eb3ac4c34$export$791d520f7e8058a5 = (config)=>{
    return new (0, $2ZNOa.PageLoadMetric)({
        ...config,
        type: (0, $3okgE.BMEventsType).PAGE_LOAD
    });
};

});
parcelRegister("2ZNOa", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $31a729062ffc0520$export$3c51073271a9eac3);

var $2zcL8 = parcelRequire("2zcL8");

var $eJL12 = parcelRequire("eJL12");

var $eYq11 = parcelRequire("eYq11");

var $1l4tD = parcelRequire("1l4tD");

var $3okgE = parcelRequire("3okgE");

var $lCDMk = parcelRequire("lCDMk");

var $eHKuC = parcelRequire("eHKuC");

var $iAslL = parcelRequire("iAslL");
class $31a729062ffc0520$export$3c51073271a9eac3 extends (0, $lCDMk.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $eHKuC.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        var _this$config$ssr;
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $eHKuC.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $eHKuC.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[(0, $lCDMk.BasePageLoadMetric).FMP]) {
                const mark = (0, $2zcL8.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $eHKuC.pageLoadMetaMetric).markFMP(mark);
            } else (0, $eHKuC.pageLoadMetaMetric).markFMP(this.marks[(0, $lCDMk.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $eYq11.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $1l4tD.submitter).queue(data);
        (0, $eJL12.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $eHKuC.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $eHKuC.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $eHKuC.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        var _configChunk$BMEvents;
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $1l4tD.submitter).config.configChunk;
        if (!(configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $3okgE.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled)) return false;
        const webVitalMetric = new (0, $iAslL.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $1l4tD.submitter).queue(webVitalMetric.getData());
        (0, $eJL12.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("iAslL", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $0eb24df9f99b9f11$export$dc0d85d4d6503cd7);

var $3okgE = parcelRequire("3okgE");

var $ks10H = parcelRequire("ks10H");
class $0eb24df9f99b9f11$export$dc0d85d4d6503cd7 extends (0, $ks10H.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $3okgE.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $ks10H.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});



parcelRegister("jt5pb", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $b88b7c6f2ae39f0e$export$94114666844d5f66);

var $4gxwm = parcelRequire("4gxwm");

var $3okgE = parcelRequire("3okgE");
const $b88b7c6f2ae39f0e$export$94114666844d5f66 = (config)=>{
    return new (0, $4gxwm.PageSegmentLoadMetric)({
        ...config,
        type: (0, $3okgE.BMEventsType).PAGE_SEGMENT_LOAD
    });
};

});
parcelRegister("4gxwm", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $58acc2670c9bf3ce$export$24c8bfcd77494cc1);

var $2zcL8 = parcelRequire("2zcL8");

var $3okgE = parcelRequire("3okgE");

var $ks10H = parcelRequire("ks10H");

var $1o5Pr = parcelRequire("1o5Pr");

var $eHKuC = parcelRequire("eHKuC");
class $58acc2670c9bf3ce$export$24c8bfcd77494cc1 extends (0, $1o5Pr.Metric) {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $eHKuC.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $58acc2670c9bf3ce$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($58acc2670c9bf3ce$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        var _this$config$ssr;
        const pageLoadData = (0, $eHKuC.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[$58acc2670c9bf3ce$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $2zcL8.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $3okgE.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $ks10H.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $ks10H.MetricState).STARTED) (0, $eHKuC.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("lJPdj", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $ae3c81cc3458b395$export$f45af69d005a6ed);
const $ae3c81cc3458b395$export$f45af69d005a6ed = (markName)=>{
    if (!performance.getEntriesByName) return null;
    const marks = performance.getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};

});

parcelRegister("bz32m", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $47d959ce2ff63fcc$export$edb879ae55bb9be3);

var $gdUUy = parcelRequire("gdUUy");

var $7r7ey = parcelRequire("7r7ey");

var $6JVSW = parcelRequire("6JVSW");

var $fkaq4 = parcelRequire("fkaq4");

var $iIik8 = parcelRequire("iIik8");

var $bm7wG = parcelRequire("bm7wG");

var $l8Bc9 = parcelRequire("l8Bc9");

var $6WXky = parcelRequire("6WXky");

var $dqXYp = parcelRequire("dqXYp");

var $cxf4u = parcelRequire("cxf4u");

var $cVv0D = parcelRequire("cVv0D");

var $otbni = parcelRequire("otbni");

var $4YGpB = parcelRequire("4YGpB");

var $bsv35 = parcelRequire("bsv35");

var $6BAdo = parcelRequire("6BAdo");

var $aVCHi = parcelRequire("aVCHi");

var $4WEs9 = parcelRequire("4WEs9");

var $gdM20 = parcelRequire("gdM20");

var $jIejc = parcelRequire("jIejc");

var $5SCjo = parcelRequire("5SCjo");

var $4okUq = parcelRequire("4okUq");

var $eUGHo = parcelRequire("eUGHo");

var $goM7S = parcelRequire("goM7S");

var $cqQ56 = parcelRequire("cqQ56");

var $kPfm2 = parcelRequire("kPfm2");

var $d7ymv = parcelRequire("d7ymv");

var $7Y50g = parcelRequire("7Y50g");
var $47d959ce2ff63fcc$var$_getWindowObject;
const $47d959ce2ff63fcc$var$UNKNOWN_VALUE = 'unknown';
const $47d959ce2ff63fcc$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $47d959ce2ff63fcc$var$UNKNOWN_VALUE,
    id: $47d959ce2ff63fcc$var$UNKNOWN_VALUE,
    uuid: $47d959ce2ff63fcc$var$UNKNOWN_VALUE,
    state: {
        id: $47d959ce2ff63fcc$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $7r7ey.ExperienceTypes).Experience,
    category: $47d959ce2ff63fcc$var$UNKNOWN_VALUE,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $l8Bc9.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $47d959ce2ff63fcc$var$Publisher {
    publish(data) {
        var _getPerformanceObject, _getPerformanceObject2, _getPerformanceObject3;
        const payloadStart = ((_getPerformanceObject = (0, $kPfm2.getPerformanceObject)()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $bm7wG.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$47d959ce2ff63fcc$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $dqXYp.UFO_BUILD_VERSION) || $47d959ce2ff63fcc$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $4WEs9.eventBrowserPlugin)(),
                    ...(0, $gdM20.eventCpusPlugin)(),
                    ...(0, $5SCjo.eventMemoryPlugin)(),
                    ...(0, $4okUq.eventNetworkPlugin)(),
                    ...(0, $6BAdo.appFramework)(this.app),
                    ...(0, $aVCHi.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $cxf4u.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $4YGpB.pageVisibleState)(supportedData),
                    ...(0, $7Y50g.isInitialPageLoad)(supportedData) && (0, $goM7S.ssrSuccess)(this.ssr),
                    ...(0, $7Y50g.isInitialPageLoad)(supportedData) && (0, $eUGHo.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $jIejc.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $gdUUy.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: ((_getPerformanceObject2 = (0, $kPfm2.getPerformanceObject)()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.timeOrigin) ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = ((_getPerformanceObject3 = (0, $kPfm2.getPerformanceObject)()) === null || _getPerformanceObject3 === void 0 ? void 0 : _getPerformanceObject3.now()) || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $iIik8.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $6JVSW.getGlobalEventStream)() instanceof (0, $cVv0D.UFOGlobalEventStream))) {
            const eventStream = new (0, $cVv0D.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $l8Bc9.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $fkaq4.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $6WXky.visibilityChangeObserver).start();
        (0, $bsv35.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $otbni.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $47d959ce2ff63fcc$var$UNKNOWN_VALUE;
        this.hostname = (($47d959ce2ff63fcc$var$_getWindowObject = (0, $d7ymv.getWindowObject)()) === null || $47d959ce2ff63fcc$var$_getWindowObject === void 0 || ($47d959ce2ff63fcc$var$_getWindowObject = $47d959ce2ff63fcc$var$_getWindowObject.location) === null || $47d959ce2ff63fcc$var$_getWindowObject === void 0 ? void 0 : $47d959ce2ff63fcc$var$_getWindowObject.hostname) || '';
        this.tenantType = (0, $cxf4u.TenantType).RealUser;
        this.app = {
            version: {
                web: $47d959ce2ff63fcc$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $cqQ56.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $47d959ce2ff63fcc$export$edb879ae55bb9be3 = new $47d959ce2ff63fcc$var$Publisher();

});
parcelRegister("7r7ey", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $c66246a592dec347$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $c66246a592dec347$export$cc26007c03242fff);
var $c66246a592dec347$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $c66246a592dec347$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("6JVSW", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $87071e55fb0f4286$export$6123a44dc2384540);

var $gerNB = parcelRequire("gerNB");
const $87071e55fb0f4286$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $gerNB.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("gerNB", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $b39543e59234c3a7$export$d8b468db8a225bc9);
const $b39543e59234c3a7$export$d8b468db8a225bc9 = 250;

});


parcelRegister("fkaq4", function(module, exports) {
$parcel$export(module.exports, "setGlobalEventStream", () => $e4fb51c23b463e2a$export$c1522520b417b066);

var $bm7wG = parcelRequire("bm7wG");
const $e4fb51c23b463e2a$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $bm7wG.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};

});
parcelRegister("bm7wG", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $87ea63b80d514826$export$d53d07b6034c4560);

var $2LRbX = parcelRequire("2LRbX");
const $87ea63b80d514826$export$d53d07b6034c4560 = (...args)=>{
    (0, $2LRbX.ufologger).warn(...args);
};

});
parcelRegister("2LRbX", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $620dc166f2e3f33a$export$4ab84f6f04f6566d);
class $620dc166f2e3f33a$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($620dc166f2e3f33a$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($620dc166f2e3f33a$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $620dc166f2e3f33a$export$4ab84f6f04f6566d = new $620dc166f2e3f33a$var$UFOLogger();

});



parcelRegister("iIik8", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $e149677c40bf7755$export$b4958caff08a0960);

var $2LRbX = parcelRequire("2LRbX");
const $e149677c40bf7755$export$b4958caff08a0960 = (...args)=>{
    (0, $2LRbX.ufologger).log(...args);
};

});

parcelRegister("l8Bc9", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2306461fe578807f$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2306461fe578807f$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2306461fe578807f$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2306461fe578807f$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2306461fe578807f$export$837e0f79a8056912);
var $2306461fe578807f$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2306461fe578807f$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2306461fe578807f$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2306461fe578807f$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2306461fe578807f$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2306461fe578807f$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2306461fe578807f$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2306461fe578807f$export$9f2bf58999404c75 = 'fmp';
const $2306461fe578807f$export$837e0f79a8056912 = 'inline-response';

});

parcelRegister("6WXky", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $0ceeef2160f75ace$export$13e680397ec8f3eb);

var $8xKZS = parcelRequire("8xKZS");
class $0ceeef2160f75ace$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $8xKZS.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $0ceeef2160f75ace$export$13e680397ec8f3eb = new $0ceeef2160f75ace$var$VisibilityChangeObserver();

});
parcelRegister("8xKZS", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $242dd307580e39d4$export$15e172712955e18f);
const $242dd307580e39d4$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("dqXYp", function(module, exports) {
$parcel$export(module.exports, "UFO_BUILD_VERSION", () => $37b1dfb55d463227$export$93809551debf385f);
// temp solution until a proper versioning
const $37b1dfb55d463227$export$93809551debf385f = '0.1.7';

});

parcelRegister("cxf4u", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $499eb0233c893fc9$export$92a757ac1398962f);
var $499eb0233c893fc9$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("cVv0D", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $5905ba3ecdd1b8d3$export$faf4c91b80fc830e);

var $iIik8 = parcelRequire("iIik8");

var $l8Bc9 = parcelRequire("l8Bc9");
class $5905ba3ecdd1b8d3$export$faf4c91b80fc830e {
    push(event) {
        (0, $iIik8.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $l8Bc9.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $l8Bc9.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $l8Bc9.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        var _this$subscribers$eve;
        if (this.subscribers[0, $l8Bc9.SUBSCRIBE_ALL]) this.subscribers[0, $l8Bc9.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $iIik8.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("otbni", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $f40af9fc7b661749$export$738d24377baf6a5e);

var $7r7ey = parcelRequire("7r7ey");

var $7Y50g = parcelRequire("7Y50g");

var $g2SVk = parcelRequire("g2SVk");

var $cMX6N = parcelRequire("cMX6N");

var $eu1jK = parcelRequire("eu1jK");

var $50oqy = parcelRequire("50oqy");

var $ex6rk = parcelRequire("ex6rk");

var $iw79P = parcelRequire("iw79P");

var $5yXPJ = parcelRequire("5yXPJ");
const $f40af9fc7b661749$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $7r7ey.ExperiencePerformanceTypes).PageLoad:
        case (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad:
            return (0, $eu1jK.getLoadMetrics)(data, ssr, performanceConfig);
        case (0, $7r7ey.ExperiencePerformanceTypes).InlineResult:
            return (0, $cMX6N.getInlineResultMetrics)(data, performanceConfig);
        case (0, $7r7ey.ExperiencePerformanceTypes).Custom:
            return (0, $g2SVk.getCustomMetrics)(data, performanceConfig);
    }
};
const $f40af9fc7b661749$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$f40af9fc7b661749$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $5yXPJ.resourceTimings)(data, resourceConfig),
        ...(0, $iw79P.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $ex6rk.appTimings)(data, ssr),
        ...(0, $7Y50g.isInitialPageLoad)(data) ? (0, $50oqy.navigationMetrics)() : null
    };
};

});
parcelRegister("7Y50g", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $b907922d6ba300ef$export$7167d96e9881d500);

var $7r7ey = parcelRequire("7r7ey");
const $b907922d6ba300ef$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $7r7ey.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("g2SVk", function(module, exports) {
$parcel$export(module.exports, "getCustomMetrics", () => $1293606ba8bef778$export$c25c1b3ff2ce92cf);

var $ebeAf = parcelRequire("ebeAf");

var $hKH6o = parcelRequire("hKH6o");
const $1293606ba8bef778$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [(0, $ebeAf.CustomMetricKeys).duration]: Math.round(duration),
        ...(0, $hKH6o.getHistogram)(data, performanceConfig)
    };
};

});
parcelRegister("ebeAf", function(module, exports) {
$parcel$export(module.exports, "CustomMetricKeys", () => $5f258344436892ea$export$8b4d49d876b19889);
const $5f258344436892ea$export$8b4d49d876b19889 = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};

});

parcelRegister("hKH6o", function(module, exports) {
$parcel$export(module.exports, "getHistogram", () => $6cf06d2d15a27d04$export$908946735178c541);

var $7r7ey = parcelRequire("7r7ey");

var $ebeAf = parcelRequire("ebeAf");

var $JKxWJ = parcelRequire("JKxWJ");

var $kfhZ6 = parcelRequire("kfhZ6");
const $6cf06d2d15a27d04$export$908946735178c541 = (data, performanceConfig, isInitial)=>{
    var _data$performanceConf;
    let histogram = {};
    if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $7r7ey.ExperiencePerformanceTypes).PageLoad:
            case (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [(0, $kfhZ6.LoadMetricKeys).ttiHistograms]: histograms[histogramType].tti,
                    [(0, $kfhZ6.LoadMetricKeys).fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $7r7ey.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [(0, $JKxWJ.InlineResultMetricKeys).resultHistograms]: histograms.result,
                    [(0, $JKxWJ.InlineResultMetricKeys).responseHistograms]: histograms.response
                } : {};
            case (0, $7r7ey.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [(0, $ebeAf.CustomMetricKeys).durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};

});
parcelRegister("JKxWJ", function(module, exports) {
$parcel$export(module.exports, "InlineResultMetricKeys", () => $2dcb41271d580c34$export$1bc754b4266cc540);
const $2dcb41271d580c34$export$1bc754b4266cc540 = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};

});

parcelRegister("kfhZ6", function(module, exports) {
$parcel$export(module.exports, "LoadMetricKeys", () => $074da02372f9f4ac$export$6869ee9ee4309612);
const $074da02372f9f4ac$export$6869ee9ee4309612 = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};

});



parcelRegister("cMX6N", function(module, exports) {
$parcel$export(module.exports, "getInlineResultMetrics", () => $1137f94d80d1258b$export$47f0208fd62dffce);

var $l8Bc9 = parcelRequire("l8Bc9");

var $hKH6o = parcelRequire("hKH6o");

var $JKxWJ = parcelRequire("JKxWJ");
const $1137f94d80d1258b$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $l8Bc9.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [(0, $JKxWJ.InlineResultMetricKeys).result]: Math.round(result),
        [(0, $JKxWJ.InlineResultMetricKeys).response]: Math.round(response),
        ...(0, $hKH6o.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("eu1jK", function(module, exports) {
$parcel$export(module.exports, "getLoadMetrics", () => $fe915d89d9e55960$export$bd4e6d81a822ece6);

var $l8Bc9 = parcelRequire("l8Bc9");

var $7Y50g = parcelRequire("7Y50g");

var $hKH6o = parcelRequire("hKH6o");

var $kfhZ6 = parcelRequire("kfhZ6");
const $fe915d89d9e55960$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    var _data$metrics$marks$f;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find((mark)=>mark.name === (0, $l8Bc9.FMP_MARK))) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || (0, $7Y50g.isInitialPageLoad)(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [(0, $kfhZ6.LoadMetricKeys).tti]: Math.round(tti),
        [(0, $kfhZ6.LoadMetricKeys).fmp]: Math.round(fmp),
        ...(0, $hKH6o.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("50oqy", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $3254c474102d782b$export$b88d990436be0f8a);
const $3254c474102d782b$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("ex6rk", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $b0b3fa760d9e6287$export$e952f50a4f2d02da);

var $7r7ey = parcelRequire("7r7ey");

var $7Y50g = parcelRequire("7Y50g");

var $aBCax = parcelRequire("aBCax");

var $7wdme = parcelRequire("7wdme");
const $b0b3fa760d9e6287$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $7r7ey.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $aBCax.customTimings)(data);
    const ssr = (0, $7Y50g.isInitialPageLoad)(data) ? (0, $7wdme.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("aBCax", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $0140dc6335079f2b$export$6126f85083a72c6e);
const $0140dc6335079f2b$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $0140dc6335079f2b$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $0140dc6335079f2b$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("7wdme", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $c1bad961830355c0$export$130f411261a599c5);

var $ikEuw = parcelRequire("ikEuw");
const $c1bad961830355c0$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $c1bad961830355c0$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $c1bad961830355c0$var$SSR_PREFIX = 'ssr';
const $c1bad961830355c0$var$mapKey = (key)=>{
    if (key === 'total') return $c1bad961830355c0$var$SSR_PREFIX;
    return `${$c1bad961830355c0$var$SSR_PREFIX}${0, $ikEuw.NESTED_METRIC_SEPARATOR}${key}`;
};
const $c1bad961830355c0$export$130f411261a599c5 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getTimings)) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($c1bad961830355c0$var$filterEntry(entry[1])) acc[$c1bad961830355c0$var$mapKey(entry[0])] = $c1bad961830355c0$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("ikEuw", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $24b481c13c45d975$export$b98e411ae80c806f);
const $24b481c13c45d975$export$b98e411ae80c806f = '/';

});



parcelRegister("iw79P", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $301d65c6a276ac02$export$1a2bb347935fc536);

var $kPfm2 = parcelRequire("kPfm2");
const $301d65c6a276ac02$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $kPfm2.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings !== null && bundleEvalTimings !== void 0 && bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("kPfm2", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObject", () => $2d41490f91dbb9a3$export$8cd0c777b0eb66a0);

var $d7ymv = parcelRequire("d7ymv");
const $2d41490f91dbb9a3$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = (0, $d7ymv.getWindowObject)() || {};
    return performance;
};

});
parcelRegister("d7ymv", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $0078497151f82c05$export$9aa44f85591248d9);
const $0078497151f82c05$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};

});



parcelRegister("5yXPJ", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $257e7a2a121d8eae$export$81a7d52441a06b50);

var $kPfm2 = parcelRequire("kPfm2");

var $d7ymv = parcelRequire("d7ymv");

var $bsv35 = parcelRequire("bsv35");
const $257e7a2a121d8eae$var$cacheableTypes = [
    'script',
    'link'
];
const $257e7a2a121d8eae$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $257e7a2a121d8eae$var$CACHE_NETWORK = 'network';
const $257e7a2a121d8eae$var$CACHE_MEMORY = 'memory';
const $257e7a2a121d8eae$var$CACHE_DISK = 'disk';
const $257e7a2a121d8eae$var$calculateTransferType = (type, duration, size)=>{
    if (!$257e7a2a121d8eae$var$cacheableTypes.includes(type)) return $257e7a2a121d8eae$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $257e7a2a121d8eae$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $257e7a2a121d8eae$var$CACHE_DISK;
    if (size === undefined) return null;
    return $257e7a2a121d8eae$var$CACHE_NETWORK;
};
const $257e7a2a121d8eae$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$257e7a2a121d8eae$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $d7ymv.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $257e7a2a121d8eae$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $257e7a2a121d8eae$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $257e7a2a121d8eae$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $257e7a2a121d8eae$var$getNetworkData = (item, eventStart, hasTimingHeaders = $257e7a2a121d8eae$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$257e7a2a121d8eae$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($257e7a2a121d8eae$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $257e7a2a121d8eae$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$257e7a2a121d8eae$var$getSizeObject(transferSize)
        };
        if (transferType !== $257e7a2a121d8eae$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$257e7a2a121d8eae$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$257e7a2a121d8eae$var$getSizeObject(transferSize)
    };
};
const $257e7a2a121d8eae$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $kPfm2.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !(resourceTimings !== null && resourceTimings !== void 0 && resourceTimings.sanitiseEndpoints)) return null;
    const resources = (0, $bsv35.getResourceTimings)(data.result.startTime, performance);
    if (!(resources !== null && resources !== void 0 && resources.length)) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $257e7a2a121d8eae$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $257e7a2a121d8eae$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$257e7a2a121d8eae$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("bsv35", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $5462a4b03e807b8b$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $5462a4b03e807b8b$export$9eebb59359c2e9e5);
// @flow strict-local

var $2LRbX = parcelRequire("2LRbX");

var $kPfm2 = parcelRequire("kPfm2");

var $55TB8 = parcelRequire("55TB8");
const $5462a4b03e807b8b$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $kPfm2.getPerformanceObject)(), PerformanceObserver1 = (0, $55TB8.getPerformanceObserverObject)())=>{
        var _performance$getEntri;
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($5462a4b03e807b8b$export$bea963256235a63e.observer) {
            (0, $2LRbX.ufologger).warn('Observer is already running');
            return;
        }
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $5462a4b03e807b8b$export$bea963256235a63e.timings = resources.map((resource)=>$5462a4b03e807b8b$export$bea963256235a63e.transformResource(resource));
        $5462a4b03e807b8b$export$bea963256235a63e.observer = new PerformanceObserver1($5462a4b03e807b8b$export$bea963256235a63e.addTimings);
        $5462a4b03e807b8b$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($5462a4b03e807b8b$export$bea963256235a63e.observer) {
            $5462a4b03e807b8b$export$bea963256235a63e.observer.disconnect();
            $5462a4b03e807b8b$export$bea963256235a63e.observer = null;
        }
        $5462a4b03e807b8b$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$5462a4b03e807b8b$export$bea963256235a63e.transformResource(entry));
        const overflow = $5462a4b03e807b8b$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $5462a4b03e807b8b$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $5462a4b03e807b8b$export$bea963256235a63e.maxSize;
            $5462a4b03e807b8b$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $5462a4b03e807b8b$export$bea963256235a63e.timings.push(...entries);
    }
};
const $5462a4b03e807b8b$export$9eebb59359c2e9e5 = (startTime, performance = (0, $kPfm2.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$5462a4b03e807b8b$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $5462a4b03e807b8b$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});
parcelRegister("55TB8", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserverObject", () => $d4e2b6b41d3f3083$export$74560fd4e61fd440);

var $d7ymv = parcelRequire("d7ymv");
const $d4e2b6b41d3f3083$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = (0, $d7ymv.getWindowObject)() || {};
    return PerformanceObserver;
};

});




parcelRegister("4YGpB", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $ce384bbd99195ddc$export$723b4c298aca63af);

var $l8Bc9 = parcelRequire("l8Bc9");
const $ce384bbd99195ddc$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $l8Bc9.PageVisibleState).HIDDEN : (0, $l8Bc9.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("6BAdo", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $fd7b2307bae48a80$export$e34e4529b979f74c);
const $fd7b2307bae48a80$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("aVCHi", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $3b0144070bc21621$export$82ae485178b37419);
const $3b0144070bc21621$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("4WEs9", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $855e198ed8441309$export$f435c2789ca334a7);

var $iMLER = parcelRequire("iMLER");

var $57l7A = parcelRequire("57l7A");

var $d7ymv = parcelRequire("d7ymv");
const $855e198ed8441309$export$f435c2789ca334a7 = (0, $57l7A.default)(()=>{
    var _getWindowObject;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($iMLER))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($iMLER))).getParser(((_getWindowObject = (0, $d7ymv.getWindowObject)()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.navigator) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("gdM20", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $65e792011e44f81c$export$db7649b8854107ad);

var $57l7A = parcelRequire("57l7A");
const $65e792011e44f81c$export$db7649b8854107ad = (0, $57l7A.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("jIejc", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $e7c072c74585ccb2$export$e62953d023125748);
const $e7c072c74585ccb2$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("5SCjo", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $eaa5ab47790e273c$export$81efaf8414879a1a);

var $57l7A = parcelRequire("57l7A");
const $eaa5ab47790e273c$export$81efaf8414879a1a = (0, $57l7A.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("4okUq", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $a9592902944203cd$export$ce1cf816dce1da56);
const $a9592902944203cd$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("eUGHo", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $6777a01446d8eeb3$export$fdbea518c19dfa8);
const $6777a01446d8eeb3$export$fdbea518c19dfa8 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("goM7S", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $0bc6b52aefac1335$export$a3dc8251cf55b2e0);
const $0bc6b52aefac1335$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("cqQ56", function(module, exports) {
$parcel$export(module.exports, "Route", () => $8a9b354495d3264c$export$e7b0ac011bb776c6);
const $8a9b354495d3264c$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});



parcelRegister("dpQiX", function(module, exports) {
$parcel$export(module.exports, "initialiseConnectAndSentryAndCleanUrl", () => $3b5fda731e25250c$export$d937591d0adcb4ed);

var $lFpPv = parcelRequire("lFpPv");

var $fWZxi = parcelRequire("fWZxi");

var $dxNM2 = parcelRequire("dxNM2");

var $5LmQo = parcelRequire("5LmQo");

var $gYDJY = parcelRequire("gYDJY");

var $a6ENB = parcelRequire("a6ENB");

var $epm6C = parcelRequire("epm6C");

var $jfKi6 = parcelRequire("jfKi6");
const $3b5fda731e25250c$export$d937591d0adcb4ed = ()=>{
    if (!(0, $lFpPv.isWrmOptimizationsEnabled)()) (0, $fWZxi.awaitGlobal)('connectHost', (0, $dxNM2.default));
    if ((0, $a6ENB.isSentryEnabled)()) {
        (0, $epm6C.install)();
        (0, $jfKi6.sentryQueue).flushErrors();
    }
    const url = (0, $gYDJY.href)();
    const modifiedUrl = (0, $5LmQo.removeParamsFromUrl)(url, [
        'sda_source'
    ]);
    if (url !== modifiedUrl) (0, $5LmQo.set)({
        sda_source: undefined
    });
};

});
parcelRegister("fWZxi", function(module, exports) {
$parcel$export(module.exports, "awaitGlobal", () => $3d47d8a1295b780f$export$653e97524db056d2);
const $3d47d8a1295b780f$var$isGlobalDefined = (objName)=>{
    // @ts-ignore TS(7015) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    return window[objName] !== undefined;
};
const $3d47d8a1295b780f$export$653e97524db056d2 = (objectName, cb)=>{
    if ($3d47d8a1295b780f$var$isGlobalDefined(objectName)) cb();
    else {
        const intervalTime = 100;
        let loopCounter = 0;
        const awaitInterval = setInterval(()=>{
            if ($3d47d8a1295b780f$var$isGlobalDefined(objectName)) {
                clearInterval(awaitInterval);
                cb();
            }
            loopCounter += 1;
            // Loop will run for maximum of 10 seconds
            if (loopCounter > 100) clearInterval(awaitInterval);
        }, intervalTime);
    }
};

});

parcelRegister("dxNM2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea25cdbee9fa5ce0$export$2e2bcd8739ae039);

var $hbEJt = parcelRequire("hbEJt");
function $ea25cdbee9fa5ce0$var$init() {
    const { connectHost: connectHost } = window;
    const api = (0, $hbEJt.connectApi)(connectHost);
    function createRequestPropertiesModule() {
        class RequestProperties {
            validate(isValid, context) {
                api.validate(isValid, context._context);
            }
            serialize(data, context) {
                api.serialize(data, context._context);
            }
        }
        return {
            constructor: RequestProperties,
            validate: RequestProperties.prototype.validate,
            serialize: RequestProperties.prototype.serialize
        };
    }
    const jiraServiceDesk = {
        RequestProperties: createRequestPropertiesModule()
    };
    connectHost.defineModule('jiraServiceDesk', jiraServiceDesk);
}
var $ea25cdbee9fa5ce0$export$2e2bcd8739ae039 = $ea25cdbee9fa5ce0$var$init;

});
parcelRegister("hbEJt", function(module, exports) {
$parcel$export(module.exports, "getAppKeyFromFullKey", () => $bc1bad09e4b82e9c$export$30f3f10c136c0ee6);
$parcel$export(module.exports, "getUniqueAppKeysFromConnectFragments", () => $bc1bad09e4b82e9c$export$bc66b351c49d3b94);
$parcel$export(module.exports, "connectApi", () => $bc1bad09e4b82e9c$export$b0d55f75723432a0);
$parcel$export(module.exports, "validate", () => $bc1bad09e4b82e9c$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "serialize", () => $bc1bad09e4b82e9c$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "register", () => $bc1bad09e4b82e9c$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $bc1bad09e4b82e9c$export$d07f55d4c15c0440);
// Events that the connect field add-on will need to listen to, These are API.
// We don't need to worry about these as it's handled by us but they shouldn't be changed.

var $4ZMmh = parcelRequire("4ZMmh");
const $bc1bad09e4b82e9c$var$EVENTS = {
    VALIDATE: 'jira-servicedesk-request-properties-validate',
    SERIALIZE: 'jira-servicedesk-request-properties-serialize'
};
const $bc1bad09e4b82e9c$var$connectPluginKey = 'com.atlassian.plugins.atlassian-connect-plugin';
const $bc1bad09e4b82e9c$var$internalListOfAddons = {};
function $bc1bad09e4b82e9c$var$getFullkey(context) {
    const addonKey = context.extension.addon_key;
    const panelKey = context.extension.key;
    return `${$bc1bad09e4b82e9c$var$connectPluginKey}:${addonKey}__${panelKey}`;
}
const $bc1bad09e4b82e9c$export$30f3f10c136c0ee6 = (fullKey = '')=>{
    const strippedOfModuleKey = fullKey.substring(0, fullKey.lastIndexOf('__'));
    return strippedOfModuleKey.substring(strippedOfModuleKey.lastIndexOf(':') + 1);
};
const $bc1bad09e4b82e9c$export$bc66b351c49d3b94 = (connectFragments)=>{
    return (0, $4ZMmh.uniq)(connectFragments.map((fragment)=>$bc1bad09e4b82e9c$export$30f3f10c136c0ee6(fragment.key)));
};
let $bc1bad09e4b82e9c$var$connectHost;
const $bc1bad09e4b82e9c$export$b0d55f75723432a0 = (host)=>{
    $bc1bad09e4b82e9c$var$connectHost = host;
    $bc1bad09e4b82e9c$var$connectHost.onIframeEstablished((context)=>{
        const fullKey = $bc1bad09e4b82e9c$var$getFullkey(context);
        const addonRef = $bc1bad09e4b82e9c$var$internalListOfAddons[fullKey];
        if (!!addonRef) $bc1bad09e4b82e9c$var$internalListOfAddons[fullKey] = {
            ...$bc1bad09e4b82e9c$var$internalListOfAddons[fullKey],
            contextExtension: context.extension
        };
    });
    return {
        // add-ons will call this on the request create page with the result of the validation after they receive the EVENTS.VALIDATE event
        validate (isValid, context) {
            const fullKey = $bc1bad09e4b82e9c$var$getFullkey(context);
            const addonRef = $bc1bad09e4b82e9c$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onValidated(isValid);
        },
        // add-ons will call this on the request create page with the serialized data after they receive the EVENTS.SERIALIZE event
        serialize (data, context) {
            const fullKey = $bc1bad09e4b82e9c$var$getFullkey(context);
            const addonRef = $bc1bad09e4b82e9c$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onSerialized(data);
        }
    };
};
const $bc1bad09e4b82e9c$export$a22775fa5e2eebd9 = (key)=>{
    const addonRef = $bc1bad09e4b82e9c$var$internalListOfAddons[key];
    $bc1bad09e4b82e9c$var$connectHost && addonRef && addonRef.contextExtension && $bc1bad09e4b82e9c$var$connectHost.broadcastEvent($bc1bad09e4b82e9c$var$EVENTS.VALIDATE, addonRef.contextExtension);
};
const $bc1bad09e4b82e9c$export$dfdc1655ccc5b9cb = (key)=>{
    const addonRef = $bc1bad09e4b82e9c$var$internalListOfAddons[key];
    $bc1bad09e4b82e9c$var$connectHost && addonRef && addonRef.contextExtension && $bc1bad09e4b82e9c$var$connectHost.broadcastEvent($bc1bad09e4b82e9c$var$EVENTS.SERIALIZE, addonRef.contextExtension);
};
const $bc1bad09e4b82e9c$export$6503ec6e8aabbaf = (key, onSerialized, onValidated)=>{
    $bc1bad09e4b82e9c$var$internalListOfAddons[key] = {
        onSerialized: onSerialized,
        onValidated: onValidated
    };
};
const $bc1bad09e4b82e9c$export$d07f55d4c15c0440 = (key)=>{
    delete $bc1bad09e4b82e9c$var$internalListOfAddons[key];
};

});


parcelRegister("5LmQo", function(module, exports) {
$parcel$export(module.exports, "getAll", () => $6bd4959d9c6f1f96$export$2774c37398bee8b2);
$parcel$export(module.exports, "get", () => $6bd4959d9c6f1f96$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $6bd4959d9c6f1f96$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "addParamsToUrl", () => $6bd4959d9c6f1f96$export$e1e3ddd390fd26f2);
$parcel$export(module.exports, "removeParamsFromUrl", () => $6bd4959d9c6f1f96$export$9d6317f3c41bff91);

var $4ZMmh = parcelRequire("4ZMmh");

var $fvUqa = parcelRequire("fvUqa");

var $eDcdn = parcelRequire("eDcdn");
function $6bd4959d9c6f1f96$export$2774c37398bee8b2() {
    if (!(0, $eDcdn.default).location.search) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...$fvUqa.parse((0, $eDcdn.default).location.search)
    };
}
function $6bd4959d9c6f1f96$export$3988ae62b71be9a3(key) {
    const values = $6bd4959d9c6f1f96$export$2774c37398bee8b2();
    return values && values[key];
}
const $6bd4959d9c6f1f96$export$fac44ee5b035f737 = (queryParams)=>$fvUqa.stringify(queryParams).replace(/%20/g, '+');
function $6bd4959d9c6f1f96$export$adaa4cf7ef1b65be(newValues, replace = true) {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values = $fvUqa.parse((0, $eDcdn.default).location.search);
    const search = $6bd4959d9c6f1f96$export$fac44ee5b035f737({
        ...values,
        ...newValues
    });
    const newLocation = {
        ...(0, $eDcdn.default).location,
        search: search
    };
    if (replace) (0, $eDcdn.default).replace(newLocation);
    else (0, $eDcdn.default).push(newLocation);
}
const $6bd4959d9c6f1f96$export$e1e3ddd390fd26f2 = (url, addParams)=>{
    const qs = $fvUqa.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = {
        ...$fvUqa.parse(qs),
        ...addParams
    };
    const newQueryString = $6bd4959d9c6f1f96$export$fac44ee5b035f737(params);
    if (newQueryString) return `${url.split('?')[0]}?${newQueryString}`;
    return url;
};
const $6bd4959d9c6f1f96$export$9d6317f3c41bff91 = (url, paramsToRemove)=>{
    const qs = $fvUqa.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = $fvUqa.parse(qs);
    let isParamsRemoved = false;
    paramsToRemove.forEach((paramToRemove)=>{
        if ((0, $4ZMmh.has)(params, paramToRemove)) {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            delete params[paramToRemove];
            isParamsRemoved = true;
        }
    });
    // don't modify url if there is nothing to remove
    if (!isParamsRemoved) return url;
    const newQueryString = $6bd4959d9c6f1f96$export$fac44ee5b035f737(params);
    const urlWithoutQuery = url.split('?')[0];
    if (newQueryString) return `${urlWithoutQuery}?${newQueryString}`;
    return urlWithoutQuery;
};

});
parcelRegister("fvUqa", function(module, exports) {
$parcel$export(module.exports, "extract", () => $b4b584536254fbe5$export$f9380c9a627682d3, (v) => $b4b584536254fbe5$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $b4b584536254fbe5$export$98e6a39c04603d36, (v) => $b4b584536254fbe5$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $b4b584536254fbe5$export$fac44ee5b035f737, (v) => $b4b584536254fbe5$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $b4b584536254fbe5$export$7a5253c0f62e0150, (v) => $b4b584536254fbe5$export$7a5253c0f62e0150 = v);
var $b4b584536254fbe5$export$f9380c9a627682d3;
var $b4b584536254fbe5$export$98e6a39c04603d36;
var $b4b584536254fbe5$export$fac44ee5b035f737;
var $b4b584536254fbe5$export$7a5253c0f62e0150;
'use strict';

var $FZvRt = parcelRequire("FZvRt");

var $govCU = parcelRequire("govCU");

var $9MaaA = parcelRequire("9MaaA");
function $b4b584536254fbe5$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $b4b584536254fbe5$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $b4b584536254fbe5$var$encode(key, opts),
                    '[',
                    $b4b584536254fbe5$var$encode(index, opts),
                    ']=',
                    $b4b584536254fbe5$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $b4b584536254fbe5$var$encode(key, opts) : [
                    $b4b584536254fbe5$var$encode(key, opts),
                    '[]=',
                    $b4b584536254fbe5$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $b4b584536254fbe5$var$encode(key, opts) : [
                    $b4b584536254fbe5$var$encode(key, opts),
                    '=',
                    $b4b584536254fbe5$var$encode(value, opts)
                ].join('');
            };
    }
}
function $b4b584536254fbe5$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $b4b584536254fbe5$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $FZvRt(value) : encodeURIComponent(value);
    return value;
}
function $b4b584536254fbe5$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $b4b584536254fbe5$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $b4b584536254fbe5$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $b4b584536254fbe5$var$parse(str, opts) {
    opts = $govCU({
        arrayFormat: 'none'
    }, opts);
    var formatter = $b4b584536254fbe5$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $9MaaA(val);
        formatter($9MaaA(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $b4b584536254fbe5$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$b4b584536254fbe5$export$f9380c9a627682d3 = $b4b584536254fbe5$var$extract;
$b4b584536254fbe5$export$98e6a39c04603d36 = $b4b584536254fbe5$var$parse;
$b4b584536254fbe5$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $govCU(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $b4b584536254fbe5$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $b4b584536254fbe5$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $b4b584536254fbe5$var$encode(key, opts) + '=' + $b4b584536254fbe5$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$b4b584536254fbe5$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $b4b584536254fbe5$var$parse($b4b584536254fbe5$var$extract(str), opts)
    };
};

});
parcelRegister("FZvRt", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("govCU", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $bef76b9b350c530a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bef76b9b350c530a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $bef76b9b350c530a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $bef76b9b350c530a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $bef76b9b350c530a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $bef76b9b350c530a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $bef76b9b350c530a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($bef76b9b350c530a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($bef76b9b350c530a$var$getOwnPropertySymbols) {
            symbols = $bef76b9b350c530a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($bef76b9b350c530a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("gYDJY", function(module, exports) {
$parcel$export(module.exports, "reload", () => $82b70cc7c97a81a7$export$32da5b5043dcd88c);
$parcel$export(module.exports, "replace", () => $82b70cc7c97a81a7$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "pathname", () => $82b70cc7c97a81a7$export$7333db99aa99d383);
$parcel$export(module.exports, "location", () => $82b70cc7c97a81a7$export$17b07c660794dc13);
$parcel$export(module.exports, "href", () => $82b70cc7c97a81a7$export$8f51af5840e0602a);
$parcel$export(module.exports, "hash", () => $82b70cc7c97a81a7$export$d6af199866bfb566);
$parcel$export(module.exports, "origin", () => $82b70cc7c97a81a7$export$f710a83a91838a36);
$parcel$export(module.exports, "search", () => $82b70cc7c97a81a7$export$d76128d007d19019);
$parcel$export(module.exports, "open", () => $82b70cc7c97a81a7$export$3ce6949f20cea765);
$parcel$export(module.exports, "assign", () => $82b70cc7c97a81a7$export$e6e34fd1f2686227);
$parcel$export(module.exports, "isValidLocation", () => $82b70cc7c97a81a7$export$f15ea956d38b6f8a);

var $4ZMmh = parcelRequire("4ZMmh");
const $82b70cc7c97a81a7$export$32da5b5043dcd88c = ()=>window.location.reload();
const $82b70cc7c97a81a7$export$77ad94ebf1c2b9ed = (path)=>window.location.replace(path);
const $82b70cc7c97a81a7$export$7333db99aa99d383 = ()=>window.location.pathname;
const $82b70cc7c97a81a7$export$17b07c660794dc13 = ()=>window.location;
const $82b70cc7c97a81a7$export$8f51af5840e0602a = ()=>window.location.href;
const $82b70cc7c97a81a7$export$d6af199866bfb566 = ()=>window.location.hash;
const $82b70cc7c97a81a7$export$f710a83a91838a36 = ()=>window.location.origin;
const $82b70cc7c97a81a7$export$d76128d007d19019 = ()=>window.location.search;
const $82b70cc7c97a81a7$export$3ce6949f20cea765 = (url, target)=>window.open(url, target);
const $82b70cc7c97a81a7$export$e6e34fd1f2686227 = (url)=>window.location.assign(url);
const $82b70cc7c97a81a7$export$f15ea956d38b6f8a = (maybeUrl)=>{
    if (decodeURIComponent(maybeUrl).startsWith('//')) return false;
    return (0, $4ZMmh.startsWith)(maybeUrl, 'http') || (0, $4ZMmh.startsWith)(maybeUrl, '/') || (0, $4ZMmh.startsWith)(maybeUrl, '%2F') || (0, $4ZMmh.startsWith)(maybeUrl, '%2f');
};

});

parcelRegister("epm6C", function(module, exports) {
$parcel$export(module.exports, "install", () => $120a26bf587ac378$export$4b3e715f166fdd78);

var $kOZtN = parcelRequire("kOZtN");
var $iSbcz = parcelRequire("iSbcz");
var $eqszJ = parcelRequire("eqszJ");

var $7HKIZ = parcelRequire("7HKIZ");

var $9hihM = parcelRequire("9hihM");

var $fuVmc = parcelRequire("fuVmc");

var $iW3CQ = parcelRequire("iW3CQ");
function $120a26bf587ac378$export$94684a7ef5037b24(event) {
    try {
        var _event$exception;
        const rewriteStacktrace = (value)=>{
            var _value$stacktrace, _value$stacktrace2;
            if (!Array.isArray(value === null || value === void 0 || (_value$stacktrace = value.stacktrace) === null || _value$stacktrace === void 0 ? void 0 : _value$stacktrace.frames)) return;
            value === null || value === void 0 || (_value$stacktrace2 = value.stacktrace) === null || _value$stacktrace2 === void 0 || _value$stacktrace2.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `event.stacktrace`
        rewriteStacktrace(event);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (Array.isArray(event === null || event === void 0 || (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values)) {
            var _event$exception2;
            event === null || event === void 0 || (_event$exception2 = event.exception) === null || _event$exception2 === void 0 || _event$exception2.values.forEach(rewriteStacktrace);
        }
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return event;
}
function $120a26bf587ac378$var$getSentryEnv(env) {
    switch(env){
        case (0, $iW3CQ.EnvType).PROD:
            return 'production';
        case (0, $iW3CQ.EnvType).STAGING:
            return 'staging';
        default:
            return 'development';
    }
}
class $120a26bf587ac378$var$SentryInstaller {
    static install() {
        // Check if we have already initialised Sentry to be defensive in case two fragments are loaded in the same page, we don't want duplicated error reports.
        const client = $iSbcz.getCurrentHub().getClient();
        if (client && client.getOptions().enabled) return;
        $eqszJ.init({
            dsn: $120a26bf587ac378$var$SentryInstaller.JS_ERROR_TRACKING_SENTRY_URL,
            release: $120a26bf587ac378$var$SentryInstaller.getRelease(),
            environment: $120a26bf587ac378$var$getSentryEnv((0, $iW3CQ.getEnv)().environment),
            // This is evaluated against the *first* frame of the stack trace. If it doesn't match, the error is not sent.
            whitelistUrls: $120a26bf587ac378$var$SentryInstaller.FRONTEND_RESOURCES,
            beforeSend: (event)=>{
                return $120a26bf587ac378$export$94684a7ef5037b24(event);
            },
            maxBreadcrumbs: 100,
            integrations: (integrations)=>{
                integrations.push(// This is used to mark which frames of the stacktrace are part of our app. They will be displayed in a different UI in Sentry.
                new $7HKIZ.RewriteFrames({
                    iteratee: (frame)=>{
                        if (frame.filename) frame.in_app = $120a26bf587ac378$var$SentryInstaller.FRONTEND_RESOURCES.some((path)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            path.test(frame.filename));
                        return frame;
                    }
                }));
                return integrations;
            }
        });
        // This is for OpsGenie, so that alerts are tagged correctly.
        $kOZtN.configureScope((scope)=>{
            scope.setTag('environment_type', (0, $iW3CQ.getEnv)().environment);
            scope.setTag('service_id', 'jsm-portal-frontend');
            const commit = $120a26bf587ac378$var$SentryInstaller.getCommit();
            if (commit) scope.setTag('commit', commit);
            const cloudId = $120a26bf587ac378$var$SentryInstaller.getCloudId();
            if (cloudId) scope.setTag('cloud_id', cloudId);
        });
    // TODO: add Aa ID + feature flags state tracking  - FSD-2309
    }
    static #_ = // TODO: extract this URL in a env variable - FSD-2309
    this.JS_ERROR_TRACKING_SENTRY_URL = (0, $9hihM.isFedRamp)() ? 'https://9f5728b18f4afcbbd6127c57b615afa3@sentry.prod.services.kitt-inf-us-gov-mod.net/15' : 'https://dc9ea62591514adf8234e2c995959d5c@o55978.ingest.sentry.io/5988807';
    static #_2 = this.FRONTEND_RESOURCES = [
        // Our DEV and PROD environments in Micros Static.
        /https:\/\/jsm-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsd-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atlassian-us-gov-mod\.com\//,
        // For devs using `yarn dev`.
        /localhost/
    ];
    static getCommit() {
        if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit;
        return undefined;
    }
    static getRelease() {
        return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    }
    static getCloudId() {
        return (0, $fuVmc.getMeta)('tenant-id');
    }
}
const $120a26bf587ac378$export$4b3e715f166fdd78 = $120a26bf587ac378$var$SentryInstaller.install;

});
parcelRegister("eqszJ", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $a809a8de8923a504$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $a809a8de8923a504$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $a809a8de8923a504$export$3a8fd680da42627b);
$parcel$export(module.exports, "lastEventId", () => $a809a8de8923a504$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "forceLoad", () => $a809a8de8923a504$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $a809a8de8923a504$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "flush", () => $a809a8de8923a504$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $a809a8de8923a504$export$8360e631d277ea4d);
$parcel$export(module.exports, "wrap", () => $a809a8de8923a504$export$4997ffc0176396a6);

var $3Cq0D = parcelRequire("3Cq0D");

var $iSbcz = parcelRequire("iSbcz");
var $89YeA = parcelRequire("89YeA");
var $dLDTQ = parcelRequire("dLDTQ");
parcelRequire("ea3Tu");
var $jXpOk = parcelRequire("jXpOk");
var $k9z5g = parcelRequire("k9z5g");
var $4vHb7 = parcelRequire("4vHb7");
var $gYYZR = parcelRequire("gYYZR");

var $ibPGb = parcelRequire("ibPGb");

var $e4npB = parcelRequire("e4npB");

var $fPVq6 = parcelRequire("fPVq6");

var $7IowH = parcelRequire("7IowH");
var $iiJPA = parcelRequire("iiJPA");
var $2s2RI = parcelRequire("2s2RI");
var $ih4aa = parcelRequire("ih4aa");
var $fTsHB = parcelRequire("fTsHB");
var $7Ih51 = parcelRequire("7Ih51");
var $a809a8de8923a504$export$5ef831fccfce35e5 = [
    new (0, $dLDTQ).InboundFilters(),
    new (0, $dLDTQ).FunctionToString(),
    new (0, $fTsHB.TryCatch)(),
    new (0, $7IowH.Breadcrumbs)(),
    new (0, $2s2RI.GlobalHandlers)(),
    new (0, $ih4aa.LinkedErrors)(),
    new (0, $iiJPA.Dedupe)(),
    new (0, $7Ih51.UserAgent)()
];
function $a809a8de8923a504$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $a809a8de8923a504$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $k9z5g.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $89YeA.initAndBind)((0, $ibPGb.BrowserClient), options);
    if (options.autoSessionTracking) $a809a8de8923a504$var$startSessionTracking();
}
function $a809a8de8923a504$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $iSbcz.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $a809a8de8923a504$export$5d4e9fd7fac8e617() {
    return (0, $iSbcz.getCurrentHub)().lastEventId();
}
function $a809a8de8923a504$export$a3f323d81eede727() {
// Noop
}
function $a809a8de8923a504$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $a809a8de8923a504$export$4909b86c8034bf73(timeout) {
    var client = (0, $iSbcz.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Cannot flush events. No client defined.');
    return (0, $gYYZR.resolvedSyncPromise)(false);
}
function $a809a8de8923a504$export$8360e631d277ea4d(timeout) {
    var client = (0, $iSbcz.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $gYYZR.resolvedSyncPromise)(false);
}
function $a809a8de8923a504$export$4997ffc0176396a6(fn) {
    return (0, $fPVq6.wrap)(fn)();
}
function $a809a8de8923a504$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $a809a8de8923a504$var$startSessionTracking() {
    var window = (0, $k9z5g.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $iSbcz.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $a809a8de8923a504$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $jXpOk.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $a809a8de8923a504$var$startSessionOnHub((0, $iSbcz.getCurrentHub)());
    });
}

});
parcelRegister("89YeA", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $5f0de33e67a17e39$export$5333c3f1c58d9bc1);

var $iSbcz = parcelRequire("iSbcz");
parcelRequire("ea3Tu");
var $4vHb7 = parcelRequire("4vHb7");

var $jmmo3 = parcelRequire("jmmo3");
function $5f0de33e67a17e39$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $jmmo3.IS_DEBUG_BUILD) (0, $4vHb7.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $iSbcz.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("jmmo3", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $e1816fff9d5df45d$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $e1816fff9d5df45d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("dLDTQ", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("5JwKp")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("9gTST")).InboundFilters);

var $5JwKp = parcelRequire("5JwKp");

var $9gTST = parcelRequire("9gTST");

});
parcelRegister("5JwKp", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $42ca8eb6d2390cb0$export$da4704525c20ae79);
parcelRequire("ea3Tu");
var $85DVE = parcelRequire("85DVE");
var $42ca8eb6d2390cb0$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $42ca8eb6d2390cb0$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $42ca8eb6d2390cb0$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $85DVE.getOriginalFunction)(this) || this;
            return $42ca8eb6d2390cb0$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("9gTST", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $6c00f5262008aa78$export$2ffbb5359dcc6be4);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("ea3Tu");
var $fwPq8 = parcelRequire("fwPq8");
var $hzPhA = parcelRequire("hzPhA");
var $4vHb7 = parcelRequire("4vHb7");

var $jmmo3 = parcelRequire("jmmo3");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $6c00f5262008aa78$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $6c00f5262008aa78$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $6c00f5262008aa78$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $6c00f5262008aa78$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $6c00f5262008aa78$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $3Cq0D.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $3Cq0D.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $3Cq0D.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $6c00f5262008aa78$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $6c00f5262008aa78$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $6c00f5262008aa78$var$_isSentryError(event)) {
        (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $fwPq8.getEventDescription)(event));
        return true;
    }
    if ($6c00f5262008aa78$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $fwPq8.getEventDescription)(event));
        return true;
    }
    if ($6c00f5262008aa78$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $fwPq8.getEventDescription)(event) + ".\nUrl: " + $6c00f5262008aa78$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$6c00f5262008aa78$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $fwPq8.getEventDescription)(event) + ".\nUrl: " + $6c00f5262008aa78$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $6c00f5262008aa78$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $6c00f5262008aa78$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $hzPhA.isMatchingPattern)(message, pattern);
        });
    });
}
function $6c00f5262008aa78$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $6c00f5262008aa78$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $hzPhA.isMatchingPattern)(url, pattern);
    });
}
function $6c00f5262008aa78$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $6c00f5262008aa78$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $hzPhA.isMatchingPattern)(url, pattern);
    });
}
function $6c00f5262008aa78$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error("Cannot extract message for event " + (0, $fwPq8.getEventDescription)(event));
        return [];
    }
    return [];
}
function $6c00f5262008aa78$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $6c00f5262008aa78$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $6c00f5262008aa78$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $6c00f5262008aa78$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $6c00f5262008aa78$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error("Cannot extract url for event " + (0, $fwPq8.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("ibPGb", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $d3e15787e8ca6705$export$1df9218a526d318d);

var $3Cq0D = parcelRequire("3Cq0D");

var $hTQ7I = parcelRequire("hTQ7I");
var $93u3F = parcelRequire("93u3F");
parcelRequire("ea3Tu");
var $k9z5g = parcelRequire("k9z5g");
var $4vHb7 = parcelRequire("4vHb7");

var $eAJ6J = parcelRequire("eAJ6J");

var $e4npB = parcelRequire("e4npB");

var $fPVq6 = parcelRequire("fPVq6");

var $7IowH = parcelRequire("7IowH");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $d3e15787e8ca6705$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $93u3F.SDK_VERSION)
                }
            ],
            version: (0, $93u3F.SDK_VERSION)
        };
        _this = _super.call(this, (0, $eAJ6J.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $k9z5g.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $fPVq6.injectReportDialog)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $7IowH.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $hTQ7I.BaseClient));

});
parcelRegister("hTQ7I", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $d080015e4a44f75f$export$4f22f74eddb7716a);

var $3Cq0D = parcelRequire("3Cq0D");

var $eEUgk = parcelRequire("eEUgk");
parcelRequire("ea3Tu");
var $fwPq8 = parcelRequire("fwPq8");
var $9Xxtl = parcelRequire("9Xxtl");
var $cnzqx = parcelRequire("cnzqx");
var $4vHb7 = parcelRequire("4vHb7");
var $3lcRq = parcelRequire("3lcRq");
var $g8CZ7 = parcelRequire("g8CZ7");
var $gYYZR = parcelRequire("gYYZR");
var $7yugL = parcelRequire("7yugL");
var $hzPhA = parcelRequire("hzPhA");

var $jmmo3 = parcelRequire("jmmo3");

var $1qnlN = parcelRequire("1qnlN");
var $d080015e4a44f75f$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $d080015e4a44f75f$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $3lcRq.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $fwPq8.checkOrSetAlreadyCaught)(exception)) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log($d080015e4a44f75f$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $cnzqx.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $fwPq8.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log($d080015e4a44f75f$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $1qnlN.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $3Cq0D.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $gYYZR.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $fwPq8.uuid4)()),
            timestamp: event.timestamp || (0, $9Xxtl.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $eEUgk.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $gYYZR.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $g8CZ7.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, b), b.data && {
                    data: (0, $g8CZ7.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $g8CZ7.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $g8CZ7.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $g8CZ7.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $hzPhA.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $hzPhA.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $hzPhA.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $3Cq0D.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $gYYZR.rejectedSyncPromise)(new (0, $7yugL.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $gYYZR.rejectedSyncPromise)(new (0, $7yugL.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $7yugL.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $d080015e4a44f75f$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $7yugL.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $7yugL.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $7yugL.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $d080015e4a44f75f$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $cnzqx.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $cnzqx.isPlainObject)(event) || event === null)) throw new (0, $7yugL.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $7yugL.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $cnzqx.isPlainObject)(rv) || rv === null)) throw new (0, $7yugL.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("1qnlN", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $109a55181c744902$export$51abed9797baa598);

var $3Cq0D = parcelRequire("3Cq0D");

var $eEUgk = parcelRequire("eEUgk");
var $iSbcz = parcelRequire("iSbcz");
parcelRequire("ea3Tu");
var $85DVE = parcelRequire("85DVE");
var $4vHb7 = parcelRequire("4vHb7");

var $jmmo3 = parcelRequire("jmmo3");
var $109a55181c744902$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $109a55181c744902$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $109a55181c744902$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $3Cq0D.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $3Cq0D.__spread)($109a55181c744902$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $3Cq0D.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $109a55181c744902$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $3Cq0D.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $109a55181c744902$export$e7390a03b70a6f2f(integration) {
    if ($109a55181c744902$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $eEUgk.addGlobalEventProcessor), (0, $iSbcz.getCurrentHub));
    $109a55181c744902$export$b14a8888f80a0b3e.push(integration.name);
    (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log("Integration installed: " + integration.name);
}
function $109a55181c744902$export$51abed9797baa598(options) {
    var integrations = {};
    $109a55181c744902$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $109a55181c744902$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $85DVE.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("93u3F", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $697bb5c79785481a$export$31499a9cd224b78c);
var $697bb5c79785481a$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("eAJ6J", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $a9f76ae93ab1d1f8$export$2526e21aec9d0ce7);

var $3Cq0D = parcelRequire("3Cq0D");

var $jQM9d = parcelRequire("jQM9d");
var $fhNHf = parcelRequire("fhNHf");

var $icZGb = parcelRequire("icZGb");
parcelRequire("ea3Tu");
var $1vLPF = parcelRequire("1vLPF");

var $graJR = parcelRequire("graJR");

var $j4nkA = parcelRequire("j4nkA");
var $7tx6Y = parcelRequire("7tx6Y");
var $gRK2a = parcelRequire("gRK2a");
var $k0cvm = parcelRequire("k0cvm");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $a9f76ae93ab1d1f8$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $graJR.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $icZGb.Severity).Info;
        return (0, $graJR.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $fhNHf.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $fhNHf.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $1vLPF.supportsFetch)()) {
            var requestOptions = (0, $3Cq0D.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $7tx6Y.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $j4nkA.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $gRK2a.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $k0cvm.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $jQM9d.BaseBackend));

});
parcelRegister("jQM9d", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $e73838c2abeac3f4$export$8f43a53a38d7e95f);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("ea3Tu");
var $4vHb7 = parcelRequire("4vHb7");
var $7yugL = parcelRequire("7yugL");

var $fhNHf = parcelRequire("fhNHf");

var $jmmo3 = parcelRequire("jmmo3");

var $kwhah = parcelRequire("kwhah");

var $lC717 = parcelRequire("lC717");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $e73838c2abeac3f4$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $7yugL.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $7yugL.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fhNHf.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $kwhah.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fhNHf.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $3Cq0D.__read)((0, $kwhah.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $jmmo3.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $lC717.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("fhNHf", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $b20efe4207b1f632$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $b20efe4207b1f632$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $b20efe4207b1f632$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $b20efe4207b1f632$export$671c7ed8e40a7a57);
parcelRequire("ea3Tu");
var $3lcRq = parcelRequire("3lcRq");
var $85DVE = parcelRequire("85DVE");
var $b20efe4207b1f632$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $b20efe4207b1f632$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $3lcRq.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $b20efe4207b1f632$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $b20efe4207b1f632$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $b20efe4207b1f632$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $b20efe4207b1f632$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $b20efe4207b1f632$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $3lcRq.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b20efe4207b1f632$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $b20efe4207b1f632$var$_getIngestEndpoint(dsn, target) {
    return "" + $b20efe4207b1f632$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b20efe4207b1f632$var$_encodedAuth(dsn) {
    return (0, $85DVE.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $b20efe4207b1f632$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $b20efe4207b1f632$var$getStoreEndpoint(dsn) {
    return $b20efe4207b1f632$var$_getIngestEndpoint(dsn, 'store');
}
function $b20efe4207b1f632$export$c1677e22ac2217a5(dsn) {
    return $b20efe4207b1f632$var$getStoreEndpoint(dsn) + "?" + $b20efe4207b1f632$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $b20efe4207b1f632$var$_getEnvelopeEndpoint(dsn) {
    return $b20efe4207b1f632$var$_getIngestEndpoint(dsn, 'envelope');
}
function $b20efe4207b1f632$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $b20efe4207b1f632$var$_getEnvelopeEndpoint(dsn) + "?" + $b20efe4207b1f632$var$_encodedAuth(dsn);
}
function $b20efe4207b1f632$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $b20efe4207b1f632$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $b20efe4207b1f632$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $3lcRq.makeDsn)(dsnLike);
    var endpoint = $b20efe4207b1f632$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $3lcRq.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("kwhah", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $ef041c6069250c44$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $ef041c6069250c44$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $ef041c6069250c44$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $ef041c6069250c44$export$2006389de558b996);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("ea3Tu");
var $cxyLF = parcelRequire("cxyLF");
var $3lcRq = parcelRequire("3lcRq");
var $g8CZ7 = parcelRequire("g8CZ7");

var $fhNHf = parcelRequire("fhNHf");
/** Extract sdk info from from the API metadata */ function $ef041c6069250c44$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $ef041c6069250c44$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $3Cq0D.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $3Cq0D.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $ef041c6069250c44$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $ef041c6069250c44$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $3lcRq.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $cxyLF.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $ef041c6069250c44$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $3Cq0D.__read)($ef041c6069250c44$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $cxyLF.serializeEnvelope)(envelope),
        type: type,
        url: (0, $fhNHf.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $ef041c6069250c44$export$c31057337a18010f(event, api) {
    var sdkInfo = $ef041c6069250c44$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $ef041c6069250c44$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $3lcRq.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $cxyLF.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $ef041c6069250c44$export$2006389de558b996(event, api) {
    var sdkInfo = $ef041c6069250c44$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $ef041c6069250c44$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $g8CZ7.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $fhNHf.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $fhNHf.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $3lcRq.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $cxyLF.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $cxyLF.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("lC717", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $fbc297070adc902a$export$6f2767450ea1346c);
parcelRequire("ea3Tu");
var $gYYZR = parcelRequire("gYYZR");
/** Noop transport */ var $fbc297070adc902a$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $gYYZR.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $gYYZR.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("graJR", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $bf777f7048c2c9de$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $bf777f7048c2c9de$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $bf777f7048c2c9de$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $bf777f7048c2c9de$export$5425b53185d13d6c);

var $3Cq0D = parcelRequire("3Cq0D");

var $icZGb = parcelRequire("icZGb");
parcelRequire("ea3Tu");
var $fwPq8 = parcelRequire("fwPq8");
var $fNUki = parcelRequire("fNUki");
var $85DVE = parcelRequire("85DVE");
var $cnzqx = parcelRequire("cnzqx");
var $g8CZ7 = parcelRequire("g8CZ7");
var $gYYZR = parcelRequire("gYYZR");

var $7Ufl0 = parcelRequire("7Ufl0");
function $bf777f7048c2c9de$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $bf777f7048c2c9de$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $bf777f7048c2c9de$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $bf777f7048c2c9de$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $cnzqx.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $85DVE.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $g8CZ7.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $bf777f7048c2c9de$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $bf777f7048c2c9de$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $bf777f7048c2c9de$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $bf777f7048c2c9de$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $bf777f7048c2c9de$var$getPopSize(ex);
    try {
        return (0, $fNUki.createStackParser)((0, $7Ufl0.opera10StackParser), (0, $7Ufl0.opera11StackParser), (0, $7Ufl0.chromeStackParser), (0, $7Ufl0.winjsStackParser), (0, $7Ufl0.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $bf777f7048c2c9de$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $bf777f7048c2c9de$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($bf777f7048c2c9de$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $bf777f7048c2c9de$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $bf777f7048c2c9de$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $bf777f7048c2c9de$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $fwPq8.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $icZGb.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gYYZR.resolvedSyncPromise)(event);
}
function $bf777f7048c2c9de$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $icZGb.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $bf777f7048c2c9de$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $gYYZR.resolvedSyncPromise)(event);
}
function $bf777f7048c2c9de$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $cnzqx.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $bf777f7048c2c9de$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $cnzqx.isDOMError)(exception) || (0, $cnzqx.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $bf777f7048c2c9de$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $cnzqx.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $bf777f7048c2c9de$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $fwPq8.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $cnzqx.isError)(exception)) // we have a real Error object, do nothing
    return $bf777f7048c2c9de$export$73fbea5a0a5234af(exception);
    if ((0, $cnzqx.isPlainObject)(exception) || (0, $cnzqx.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $bf777f7048c2c9de$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $fwPq8.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $bf777f7048c2c9de$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $fwPq8.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $fwPq8.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $bf777f7048c2c9de$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $bf777f7048c2c9de$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("7Ufl0", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $5c19a91ceb3d1b61$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $5c19a91ceb3d1b61$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $5c19a91ceb3d1b61$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $5c19a91ceb3d1b61$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $5c19a91ceb3d1b61$export$989a1824b4734ce6);

var $3Cq0D = parcelRequire("3Cq0D");
// global reference to slice
var $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION = '?';
var $5c19a91ceb3d1b61$var$OPERA10_PRIORITY = 10;
var $5c19a91ceb3d1b61$var$OPERA11_PRIORITY = 20;
var $5c19a91ceb3d1b61$var$CHROME_PRIORITY = 30;
var $5c19a91ceb3d1b61$var$WINJS_PRIORITY = 40;
var $5c19a91ceb3d1b61$var$GECKO_PRIORITY = 50;
function $5c19a91ceb3d1b61$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $5c19a91ceb3d1b61$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $5c19a91ceb3d1b61$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $5c19a91ceb3d1b61$var$chrome = function(line) {
    var parts = $5c19a91ceb3d1b61$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $5c19a91ceb3d1b61$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $3Cq0D.__read)($5c19a91ceb3d1b61$var$extractSafariExtensionDetails(parts[1] || $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $5c19a91ceb3d1b61$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $5c19a91ceb3d1b61$export$c693d9295441d8f9 = [
    $5c19a91ceb3d1b61$var$CHROME_PRIORITY,
    $5c19a91ceb3d1b61$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $5c19a91ceb3d1b61$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $5c19a91ceb3d1b61$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $5c19a91ceb3d1b61$var$gecko = function(line) {
    var _a;
    var parts = $5c19a91ceb3d1b61$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $5c19a91ceb3d1b61$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION;
        _a = (0, $3Cq0D.__read)($5c19a91ceb3d1b61$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $5c19a91ceb3d1b61$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $5c19a91ceb3d1b61$export$c9ddf1e2b5d48bff = [
    $5c19a91ceb3d1b61$var$GECKO_PRIORITY,
    $5c19a91ceb3d1b61$var$gecko
];
var $5c19a91ceb3d1b61$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $5c19a91ceb3d1b61$var$winjs = function(line) {
    var parts = $5c19a91ceb3d1b61$var$winjsRegex.exec(line);
    return parts ? $5c19a91ceb3d1b61$var$createFrame(parts[2], parts[1] || $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $5c19a91ceb3d1b61$export$b6d155d85c1dcba5 = [
    $5c19a91ceb3d1b61$var$WINJS_PRIORITY,
    $5c19a91ceb3d1b61$var$winjs
];
var $5c19a91ceb3d1b61$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $5c19a91ceb3d1b61$var$opera10 = function(line) {
    var parts = $5c19a91ceb3d1b61$var$opera10Regex.exec(line);
    return parts ? $5c19a91ceb3d1b61$var$createFrame(parts[2], parts[3] || $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $5c19a91ceb3d1b61$export$966ec832d9699d6 = [
    $5c19a91ceb3d1b61$var$OPERA10_PRIORITY,
    $5c19a91ceb3d1b61$var$opera10
];
var $5c19a91ceb3d1b61$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $5c19a91ceb3d1b61$var$opera11 = function(line) {
    var parts = $5c19a91ceb3d1b61$var$opera11Regex.exec(line);
    return parts ? $5c19a91ceb3d1b61$var$createFrame(parts[5], parts[3] || parts[4] || $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $5c19a91ceb3d1b61$export$989a1824b4734ce6 = [
    $5c19a91ceb3d1b61$var$OPERA11_PRIORITY,
    $5c19a91ceb3d1b61$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $5c19a91ceb3d1b61$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $5c19a91ceb3d1b61$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("j4nkA", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $de207d1fcf0bfc31$export$2bdee3f9b92f4e82);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("ea3Tu");
var $7yugL = parcelRequire("7yugL");
var $1vLPF = parcelRequire("1vLPF");
var $gYYZR = parcelRequire("gYYZR");

var $bP6WX = parcelRequire("bP6WX");

var $14Vwt = parcelRequire("14Vwt");
/** `fetch` based transport */ var $de207d1fcf0bfc31$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $14Vwt.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $1vLPF.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $gYYZR.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $7yugL.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $bP6WX.BaseTransport));

});
parcelRegister("bP6WX", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $89b9d93d1202bfbc$export$74b99d619e90f481);

var $3Cq0D = parcelRequire("3Cq0D");

var $kwhah = parcelRequire("kwhah");
var $fhNHf = parcelRequire("fhNHf");
parcelRequire("ea3Tu");
var $5oiSX = parcelRequire("5oiSX");
var $22R6W = parcelRequire("22R6W");
var $3lcRq = parcelRequire("3lcRq");
var $dVCfU = parcelRequire("dVCfU");
var $k9z5g = parcelRequire("k9z5g");
var $4vHb7 = parcelRequire("4vHb7");
var $4Habf = parcelRequire("4Habf");
var $cxyLF = parcelRequire("cxyLF");

var $e4npB = parcelRequire("e4npB");

var $14Vwt = parcelRequire("14Vwt");
function $89b9d93d1202bfbc$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $89b9d93d1202bfbc$var$global = (0, $k9z5g.getGlobalObject)();
/** Base Transport class implementation */ var $89b9d93d1202bfbc$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $4Habf.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $fhNHf.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $fhNHf.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $89b9d93d1202bfbc$var$global.document) $89b9d93d1202bfbc$var$global.document.addEventListener('visibilitychange', function() {
            if ($89b9d93d1202bfbc$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $kwhah.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $kwhah.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $89b9d93d1202bfbc$var$requestTypeToCategory(category) + ":" + reason;
        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log('No outcomes to flush');
            return;
        }
        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $fhNHf.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $3Cq0D.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $5oiSX.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $3lcRq.dsnToString)(this._api.dsn));
        try {
            (0, $14Vwt.sendReport)(url, (0, $cxyLF.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $dVCfU.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $22R6W.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $e4npB.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $4vHb7.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $89b9d93d1202bfbc$var$requestTypeToCategory(requestType);
        return new Date((0, $22R6W.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $89b9d93d1202bfbc$var$requestTypeToCategory(requestType);
        return (0, $22R6W.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("e4npB", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a3e3998e738e0176$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a3e3998e738e0176$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("14Vwt", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $0c92c8f8ce571036$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $0c92c8f8ce571036$export$84bb63b2c17ec44d);
parcelRequire("ea3Tu");
var $1UAf4 = parcelRequire("1UAf4");
var $k9z5g = parcelRequire("k9z5g");
var $1vLPF = parcelRequire("1vLPF");
var $4vHb7 = parcelRequire("4vHb7");

var $e4npB = parcelRequire("e4npB");
var $0c92c8f8ce571036$var$global = (0, $k9z5g.getGlobalObject)();
var $0c92c8f8ce571036$var$cachedFetchImpl;
function $0c92c8f8ce571036$export$8be2119ce08e3379() {
    if ($0c92c8f8ce571036$var$cachedFetchImpl) return $0c92c8f8ce571036$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $1vLPF.isNativeFetch)($0c92c8f8ce571036$var$global.fetch)) return $0c92c8f8ce571036$var$cachedFetchImpl = $0c92c8f8ce571036$var$global.fetch.bind($0c92c8f8ce571036$var$global);
    var document = $0c92c8f8ce571036$var$global.document;
    var fetchImpl = $0c92c8f8ce571036$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $0c92c8f8ce571036$var$cachedFetchImpl = fetchImpl.bind($0c92c8f8ce571036$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $0c92c8f8ce571036$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($0c92c8f8ce571036$var$global && $0c92c8f8ce571036$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $0c92c8f8ce571036$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $0c92c8f8ce571036$var$global.navigator.sendBeacon.bind($0c92c8f8ce571036$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $1vLPF.supportsFetch)()) {
        var fetch_1 = $0c92c8f8ce571036$export$8be2119ce08e3379();
        return (0, $1UAf4.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("7tx6Y", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $5714ed1c1c7f5d5f$export$1c57e6bfd09bad13);

var $3Cq0D = parcelRequire("3Cq0D");

var $eHLai = parcelRequire("eHLai");

var $14Vwt = parcelRequire("14Vwt");
function $5714ed1c1c7f5d5f$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $14Vwt.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $3Cq0D.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $eHLai.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("eHLai", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $ab49aad0f1c56950$export$d09f50d9ab7f7b69);
parcelRequire("ea3Tu");
var $22R6W = parcelRequire("22R6W");
var $dVCfU = parcelRequire("dVCfU");
var $cxyLF = parcelRequire("cxyLF");
var $4Habf = parcelRequire("4Habf");
var $gYYZR = parcelRequire("gYYZR");
var $ab49aad0f1c56950$export$d8a725a7dce95622 = 'error';
var $ab49aad0f1c56950$export$99adc6fe67a3c63e = 'transaction';
var $ab49aad0f1c56950$export$9d7ad34f132fe68f = 'attachment';
var $ab49aad0f1c56950$export$42d9e7b5fc564c45 = 'session';
var $ab49aad0f1c56950$export$e515cf6dfd2f98b8 = 30;
function $ab49aad0f1c56950$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $4Habf.makePromiseBuffer)(options.bufferSize || $ab49aad0f1c56950$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $cxyLF.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $cxyLF.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $22R6W.isRateLimited)(rateLimits, category)) return (0, $gYYZR.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $ab49aad0f1c56950$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $dVCfU.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $22R6W.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $gYYZR.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $gYYZR.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $ab49aad0f1c56950$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $ab49aad0f1c56950$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $22R6W.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("gRK2a", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $c4754dfccce38f67$export$4c0ac1dd4bbf4921);

var $eHLai = parcelRequire("eHLai");
parcelRequire("ea3Tu");
var $gYYZR = parcelRequire("gYYZR");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $c4754dfccce38f67$var$XHR_READYSTATE_DONE = 4;
function $c4754dfccce38f67$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $gYYZR.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $c4754dfccce38f67$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $eHLai.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("k0cvm", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $e8fd81f049cf1497$export$874a283af77e8e62);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("ea3Tu");
var $7yugL = parcelRequire("7yugL");
var $gYYZR = parcelRequire("gYYZR");

var $bP6WX = parcelRequire("bP6WX");
/** `XHR` based transport */ var $e8fd81f049cf1497$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $3Cq0D.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $gYYZR.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $7yugL.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $bP6WX.BaseTransport));

});


parcelRegister("fPVq6", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $b87828ddee89ba99$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $b87828ddee89ba99$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $b87828ddee89ba99$export$deb9aac8ea0b576c);

var $3Cq0D = parcelRequire("3Cq0D");

var $kOZtN = parcelRequire("kOZtN");
var $fhNHf = parcelRequire("fhNHf");
parcelRequire("ea3Tu");
var $fwPq8 = parcelRequire("fwPq8");
var $85DVE = parcelRequire("85DVE");
var $k9z5g = parcelRequire("k9z5g");
var $4vHb7 = parcelRequire("4vHb7");

var $e4npB = parcelRequire("e4npB");
var $b87828ddee89ba99$var$global = (0, $k9z5g.getGlobalObject)();
var $b87828ddee89ba99$var$ignoreOnError = 0;
function $b87828ddee89ba99$export$b79738ab10c590b2() {
    return $b87828ddee89ba99$var$ignoreOnError > 0;
}
function $b87828ddee89ba99$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b87828ddee89ba99$var$ignoreOnError += 1;
    setTimeout(function() {
        $b87828ddee89ba99$var$ignoreOnError -= 1;
    });
}
function $b87828ddee89ba99$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $85DVE.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $b87828ddee89ba99$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b87828ddee89ba99$export$1265a142ff5ba165();
            (0, $kOZtN.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $fwPq8.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $fwPq8.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $kOZtN.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $85DVE.markFunctionWrapped)(sentryWrapped, fn);
    (0, $85DVE.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $b87828ddee89ba99$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$b87828ddee89ba99$var$global.document) return;
    if (!options.eventId) {
        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $b87828ddee89ba99$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $fhNHf.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $b87828ddee89ba99$var$global.document.head || $b87828ddee89ba99$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("7IowH", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $59dfaae31845bde1$export$2dc68d50d56fbbd);

var $3Cq0D = parcelRequire("3Cq0D");

var $iSbcz = parcelRequire("iSbcz");

var $icZGb = parcelRequire("icZGb");
parcelRequire("ea3Tu");
var $jXpOk = parcelRequire("jXpOk");
var $fwPq8 = parcelRequire("fwPq8");
var $k9z5g = parcelRequire("k9z5g");
var $kcI9y = parcelRequire("kcI9y");
var $hzPhA = parcelRequire("hzPhA");
var $aRGS2 = parcelRequire("aRGS2");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $59dfaae31845bde1$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $3Cq0D.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $iSbcz.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $fwPq8.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $jXpOk.addInstrumentationHandler)('console', $59dfaae31845bde1$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $jXpOk.addInstrumentationHandler)('dom', $59dfaae31845bde1$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $jXpOk.addInstrumentationHandler)('xhr', $59dfaae31845bde1$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $jXpOk.addInstrumentationHandler)('fetch', $59dfaae31845bde1$var$_fetchBreadcrumb);
        if (this._options.history) (0, $jXpOk.addInstrumentationHandler)('history', $59dfaae31845bde1$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $59dfaae31845bde1$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $kcI9y.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $kcI9y.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $iSbcz.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $59dfaae31845bde1$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $aRGS2.severityFromString)(handlerData.level),
        message: (0, $hzPhA.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $hzPhA.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $iSbcz.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $59dfaae31845bde1$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $iSbcz.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $59dfaae31845bde1$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $iSbcz.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $icZGb.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $iSbcz.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $59dfaae31845bde1$var$_historyBreadcrumb(handlerData) {
    var global = (0, $k9z5g.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $fwPq8.parseUrl)(global.location.href);
    var parsedFrom = (0, $fwPq8.parseUrl)(from);
    var parsedTo = (0, $fwPq8.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $iSbcz.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("iiJPA", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $d52d7586e5b4c6d1$export$688d98c249d31ad3);
parcelRequire("ea3Tu");
var $4vHb7 = parcelRequire("4vHb7");

var $e4npB = parcelRequire("e4npB");
/** Deduplication filter */ var $d52d7586e5b4c6d1$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($d52d7586e5b4c6d1$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $d52d7586e5b4c6d1$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($d52d7586e5b4c6d1$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($d52d7586e5b4c6d1$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $d52d7586e5b4c6d1$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$d52d7586e5b4c6d1$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$d52d7586e5b4c6d1$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $d52d7586e5b4c6d1$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $d52d7586e5b4c6d1$var$_getExceptionFromEvent(previousEvent);
    var currentException = $d52d7586e5b4c6d1$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$d52d7586e5b4c6d1$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$d52d7586e5b4c6d1$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $d52d7586e5b4c6d1$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $d52d7586e5b4c6d1$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $d52d7586e5b4c6d1$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $d52d7586e5b4c6d1$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $d52d7586e5b4c6d1$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $d52d7586e5b4c6d1$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("2s2RI", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $1c906b51520b0695$export$204155decbc90e5a);

var $3Cq0D = parcelRequire("3Cq0D");

var $iSbcz = parcelRequire("iSbcz");

var $icZGb = parcelRequire("icZGb");
parcelRequire("ea3Tu");
var $fwPq8 = parcelRequire("fwPq8");
var $jXpOk = parcelRequire("jXpOk");
var $kcI9y = parcelRequire("kcI9y");
var $cnzqx = parcelRequire("cnzqx");
var $4vHb7 = parcelRequire("4vHb7");

var $graJR = parcelRequire("graJR");

var $e4npB = parcelRequire("e4npB");

var $fPVq6 = parcelRequire("fPVq6");
/** Global handlers */ var $1c906b51520b0695$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $1c906b51520b0695$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $1c906b51520b0695$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $3Cq0D.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $1c906b51520b0695$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $1c906b51520b0695$var$_installGlobalOnErrorHandler() {
    (0, $jXpOk.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $3Cq0D.__read)($1c906b51520b0695$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($1c906b51520b0695$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $fPVq6.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $cnzqx.isString)(msg) ? $1c906b51520b0695$var$_eventFromIncompleteOnError(msg, url, line, column) : $1c906b51520b0695$var$_enhanceEventWithInitialFrame((0, $graJR.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $icZGb.Severity).Error;
        $1c906b51520b0695$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $1c906b51520b0695$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $jXpOk.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $3Cq0D.__read)($1c906b51520b0695$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($1c906b51520b0695$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $fPVq6.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $cnzqx.isPrimitive)(error) ? $1c906b51520b0695$var$_eventFromRejectionWithPrimitive(error) : (0, $graJR.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $icZGb.Severity).Error;
        $1c906b51520b0695$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $1c906b51520b0695$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c906b51520b0695$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $cnzqx.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $1c906b51520b0695$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c906b51520b0695$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $cnzqx.isString)(url) && url.length > 0 ? url : (0, $kcI9y.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $1c906b51520b0695$var$globalHandlerLog(type) {
    (0, $e4npB.IS_DEBUG_BUILD) && (0, $4vHb7.logger).log("Global Handler attached: " + type);
}
function $1c906b51520b0695$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $fwPq8.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $1c906b51520b0695$var$getHubAndAttachStacktrace() {
    var hub = (0, $iSbcz.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("ih4aa", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $d4dd0b306ef3a297$export$8d1e60aaf616fb4f);

var $3Cq0D = parcelRequire("3Cq0D");

var $eEUgk = parcelRequire("eEUgk");
var $iSbcz = parcelRequire("iSbcz");
parcelRequire("ea3Tu");
var $cnzqx = parcelRequire("cnzqx");

var $graJR = parcelRequire("graJR");
var $d4dd0b306ef3a297$var$DEFAULT_KEY = 'cause';
var $d4dd0b306ef3a297$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $d4dd0b306ef3a297$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $d4dd0b306ef3a297$var$DEFAULT_KEY;
        this._limit = options.limit || $d4dd0b306ef3a297$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $eEUgk.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $iSbcz.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $d4dd0b306ef3a297$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $d4dd0b306ef3a297$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $cnzqx.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $d4dd0b306ef3a297$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $3Cq0D.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $d4dd0b306ef3a297$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $cnzqx.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $graJR.exceptionFromError)(error[key]);
    return $d4dd0b306ef3a297$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $3Cq0D.__spread)([
        exception
    ], stack));
}

});

parcelRegister("fTsHB", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $b92241b9f9278ace$export$f1a018517668e6d3);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("ea3Tu");
var $85DVE = parcelRequire("85DVE");
var $fNUki = parcelRequire("fNUki");
var $k9z5g = parcelRequire("k9z5g");

var $fPVq6 = parcelRequire("fPVq6");
var $b92241b9f9278ace$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $b92241b9f9278ace$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $3Cq0D.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $k9z5g.getGlobalObject)();
        if (this._options.setTimeout) (0, $85DVE.fill)(global, 'setTimeout', $b92241b9f9278ace$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $85DVE.fill)(global, 'setInterval', $b92241b9f9278ace$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $85DVE.fill)(global, 'requestAnimationFrame', $b92241b9f9278ace$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $85DVE.fill)(XMLHttpRequest.prototype, 'send', $b92241b9f9278ace$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $b92241b9f9278ace$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($b92241b9f9278ace$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $b92241b9f9278ace$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $fPVq6.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $fNUki.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b92241b9f9278ace$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $fPVq6.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $fNUki.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $b92241b9f9278ace$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $85DVE.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $fNUki.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $85DVE.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $fNUki.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $fPVq6.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $b92241b9f9278ace$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $k9z5g.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $85DVE.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $fPVq6.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $fNUki.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $fPVq6.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $fNUki.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $85DVE.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("7Ih51", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $59d9e432ec7f40ca$export$5fba5e10934a4faf);

var $3Cq0D = parcelRequire("3Cq0D");

var $eEUgk = parcelRequire("eEUgk");
var $iSbcz = parcelRequire("iSbcz");
parcelRequire("ea3Tu");
var $k9z5g = parcelRequire("k9z5g");
var $59d9e432ec7f40ca$var$global = (0, $k9z5g.getGlobalObject)();
/** UserAgent */ var $59d9e432ec7f40ca$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $eEUgk.addGlobalEventProcessor)(function(event) {
            if ((0, $iSbcz.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$59d9e432ec7f40ca$var$global.navigator && !$59d9e432ec7f40ca$var$global.location && !$59d9e432ec7f40ca$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $59d9e432ec7f40ca$var$global.location && $59d9e432ec7f40ca$var$global.location.href;
                var referrer = ($59d9e432ec7f40ca$var$global.document || {}).referrer;
                var userAgent = ($59d9e432ec7f40ca$var$global.navigator || {}).userAgent;
                var headers = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("7HKIZ", function(module, exports) {
$parcel$export(module.exports, "RewriteFrames", () => $59c0cb176061b116$export$af39fa91d1acf248);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("cHlzq");
var $5ndCo = parcelRequire("5ndCo");
/** Rewrite event frames paths */ var $59c0cb176061b116$export$af39fa91d1acf248 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */ this._prefix = 'app:///';
        /**
         * @inheritDoc
         */ this._iteratee = function(frame) {
            if (!frame.filename) return frame;
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame ? frame.filename.replace(/^[A-Z]:/, '') // remove Windows-style prefix
                .replace(/\\/g, '/') // replace all `\\` instances with `/`
                 : frame.filename;
                var base = _this._root ? (0, $5ndCo.relative)(_this._root, filename) : (0, $5ndCo.basename)(filename);
                frame.filename = "" + _this._prefix + base;
            }
            return frame;
        };
        if (options.root) this._root = options.root;
        if (options.prefix) this._prefix = options.prefix;
        if (options.iteratee) this._iteratee = options.iteratee;
    }
    /**
     * @inheritDoc
     */ RewriteFrames.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) return self.process(event);
            return event;
        });
    };
    /** JSDoc */ RewriteFrames.prototype.process = function(originalEvent) {
        var processedEvent = originalEvent;
        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = this._processExceptionsEvent(processedEvent);
        if (originalEvent.stacktrace) processedEvent = this._processStacktraceEvent(processedEvent);
        return processedEvent;
    };
    /** JSDoc */ RewriteFrames.prototype._processExceptionsEvent = function(event) {
        var _this = this;
        try {
            return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event), {
                exception: (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, value), {
                            stacktrace: _this._processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktraceEvent = function(event) {
        try {
            return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event), {
                stacktrace: this._processStacktrace(event.stacktrace)
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktrace = function(stacktrace) {
        var _this = this;
        return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return _this._iteratee(f);
            })
        });
    };
    /**
     * @inheritDoc
     */ RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}();

});
parcelRegister("cHlzq", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("5uXzW")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("7lAlq")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("7lAlq")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("aOrxf")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("aOrxf")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("1LVrE")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("fjzvX")).fill);
$parcel$export(module.exports, "basename", () => (parcelRequire("5ndCo")).basename);
$parcel$export(module.exports, "relative", () => (parcelRequire("5ndCo")).relative);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("kgsGe")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("9NITo")).safeJoin);





parcelRequire("5uXzW");

parcelRequire("7lAlq");
parcelRequire("aOrxf");



var $5SuB0 = parcelRequire("5SuB0");
parcelRequire("1LVrE");
parcelRequire("fjzvX");
parcelRequire("5ndCo");

parcelRequire("kgsGe");


parcelRequire("9NITo");



var $cIfKZ = parcelRequire("cIfKZ");





$parcel$exportWildcard(module.exports, $5SuB0);
$parcel$exportWildcard(module.exports, $cIfKZ);

});
parcelRegister("5uXzW", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $400df831b51821e7$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $400df831b51821e7$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5SuB0 = parcelRequire("5SuB0");
var $400df831b51821e7$var$fallbackGlobalObject = {};
function $400df831b51821e7$export$256479dc0cea61c4() {
    return (0, $5SuB0.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $400df831b51821e7$var$fallbackGlobalObject;
}
function $400df831b51821e7$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $400df831b51821e7$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("5SuB0", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $fhwrr = parcelRequire("fhwrr");

var $4eGW1 = parcelRequire("4eGW1");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $fhwrr.isBrowserBundle)() && Object.prototype.toString.call(typeof $4eGW1 !== 'undefined' ? $4eGW1 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("fhwrr", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $b2019bc1ca5cbafe$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $b2019bc1ca5cbafe$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("7lAlq", function(module, exports) {
$parcel$export(module.exports, "isError", () => $5596afd28b2884fe$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $5596afd28b2884fe$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $5596afd28b2884fe$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $5596afd28b2884fe$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $5596afd28b2884fe$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $5596afd28b2884fe$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $5596afd28b2884fe$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $5596afd28b2884fe$export$49841c62b9eff15);
$parcel$export(module.exports, "isSyntheticEvent", () => $5596afd28b2884fe$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $5596afd28b2884fe$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $5596afd28b2884fe$var$objectToString = Object.prototype.toString;
function $5596afd28b2884fe$export$e6127cc7fe7395c3(wat) {
    switch($5596afd28b2884fe$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $5596afd28b2884fe$export$49034edbe6b62415(wat, Error);
    }
}
function $5596afd28b2884fe$var$isBuiltin(wat, ty) {
    return $5596afd28b2884fe$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $5596afd28b2884fe$export$9f9636d330b71954(wat) {
    return $5596afd28b2884fe$var$isBuiltin(wat, 'ErrorEvent');
}
function $5596afd28b2884fe$export$ef9e2056653f0c8e(wat) {
    return $5596afd28b2884fe$var$isBuiltin(wat, 'DOMError');
}
function $5596afd28b2884fe$export$12e869b2a583f783(wat) {
    return $5596afd28b2884fe$var$isBuiltin(wat, 'DOMException');
}
function $5596afd28b2884fe$export$844ec244b1367d54(wat) {
    return $5596afd28b2884fe$var$isBuiltin(wat, 'String');
}
function $5596afd28b2884fe$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $5596afd28b2884fe$export$53b83ca8eaab0383(wat) {
    return $5596afd28b2884fe$var$isBuiltin(wat, 'Object');
}
function $5596afd28b2884fe$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $5596afd28b2884fe$export$49034edbe6b62415(wat, Event);
}
function $5596afd28b2884fe$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $5596afd28b2884fe$export$49034edbe6b62415(wat, Element);
}
function $5596afd28b2884fe$export$49841c62b9eff15(wat) {
    return $5596afd28b2884fe$var$isBuiltin(wat, 'RegExp');
}
function $5596afd28b2884fe$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $5596afd28b2884fe$export$bc2894c7158efbac(wat) {
    return $5596afd28b2884fe$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $5596afd28b2884fe$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $5596afd28b2884fe$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("aOrxf", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $7df3eecd392f9da2$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $7df3eecd392f9da2$export$af88d00dbe7f521);

var $3Cq0D = parcelRequire("3Cq0D");

var $9haEj = parcelRequire("9haEj");

var $5uXzW = parcelRequire("5uXzW");
// TODO: Implement different loggers for different environments
var $7df3eecd392f9da2$var$global = (0, $5uXzW.getGlobalObject)();
/** Prefix for logging strings */ var $7df3eecd392f9da2$var$PREFIX = 'Sentry Logger ';
var $7df3eecd392f9da2$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $7df3eecd392f9da2$export$cda52e2a8927a2ca(callback) {
    var global = (0, $5uXzW.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $7df3eecd392f9da2$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $7df3eecd392f9da2$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $9haEj.IS_DEBUG_BUILD) $7df3eecd392f9da2$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $7df3eecd392f9da2$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $7df3eecd392f9da2$var$global.console)[name].apply(_a, (0, $3Cq0D.__spread)([
                    $7df3eecd392f9da2$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $7df3eecd392f9da2$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $7df3eecd392f9da2$export$af88d00dbe7f521;
if (0, $9haEj.IS_DEBUG_BUILD) $7df3eecd392f9da2$export$af88d00dbe7f521 = (0, $5uXzW.getGlobalSingleton)('logger', $7df3eecd392f9da2$var$makeLogger);
else $7df3eecd392f9da2$export$af88d00dbe7f521 = $7df3eecd392f9da2$var$makeLogger();

});
parcelRegister("9haEj", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $6c0df64e374ddcc5$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $6c0df64e374ddcc5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("1LVrE", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $14a6bd9748d7e7b7$export$a3295358bff77e);

var $3Cq0D = parcelRequire("3Cq0D");

var $7lAlq = parcelRequire("7lAlq");

var $5EbJC = parcelRequire("5EbJC");

var $fjzvX = parcelRequire("fjzvX");

var $kVXEJ = parcelRequire("kVXEJ");
function $14a6bd9748d7e7b7$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $14a6bd9748d7e7b7$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $14a6bd9748d7e7b7$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $14a6bd9748d7e7b7$export$a3295358bff77e(object, depth);
    if ($14a6bd9748d7e7b7$var$jsonSize(normalized) > maxSize) return $14a6bd9748d7e7b7$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $14a6bd9748d7e7b7$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $5EbJC.memoBuilder)();
    var _a = (0, $3Cq0D.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $7lAlq.isNaN)(value)) return value;
    var stringified = $14a6bd9748d7e7b7$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $7lAlq.isError)(value) || (0, $7lAlq.isEvent)(value) ? (0, $fjzvX.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $14a6bd9748d7e7b7$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $14a6bd9748d7e7b7$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $7lAlq.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $kVXEJ.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $14a6bd9748d7e7b7$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $14a6bd9748d7e7b7$var$jsonSize(value) {
    return $14a6bd9748d7e7b7$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("5EbJC", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $010fa44c2880544c$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $010fa44c2880544c$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("fjzvX", function(module, exports) {
$parcel$export(module.exports, "fill", () => $b2642dc66f770c4e$export$9563e054e6f787fb);
$parcel$export(module.exports, "convertToPlainObject", () => $b2642dc66f770c4e$export$62ff257738bf57f5);

var $3Cq0D = parcelRequire("3Cq0D");

var $2bZY0 = parcelRequire("2bZY0");

var $7lAlq = parcelRequire("7lAlq");

var $9NITo = parcelRequire("9NITo");
function $b2642dc66f770c4e$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $b2642dc66f770c4e$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $b2642dc66f770c4e$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $b2642dc66f770c4e$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $b2642dc66f770c4e$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $b2642dc66f770c4e$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $b2642dc66f770c4e$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $b2642dc66f770c4e$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7lAlq.isError)(value)) newObj = (0, $3Cq0D.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $b2642dc66f770c4e$var$getOwnProperties(value));
    else if ((0, $7lAlq.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $3Cq0D.__assign)({
            type: event_1.type,
            target: $b2642dc66f770c4e$var$serializeEventTarget(event_1.target),
            currentTarget: $b2642dc66f770c4e$var$serializeEventTarget(event_1.currentTarget)
        }, $b2642dc66f770c4e$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $7lAlq.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $b2642dc66f770c4e$var$serializeEventTarget(target) {
    try {
        return (0, $7lAlq.isElement)(target) ? (0, $2bZY0.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $b2642dc66f770c4e$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $b2642dc66f770c4e$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($b2642dc66f770c4e$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $9NITo.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $9NITo.truncate)(serialized, maxLength);
    }
    return '';
}
function $b2642dc66f770c4e$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7lAlq.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $3Cq0D.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $b2642dc66f770c4e$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($b2642dc66f770c4e$export$d25f2688db1bb433);
    return val;
}
function $b2642dc66f770c4e$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7lAlq.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("2bZY0", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $198cad2d2cc6eba7$export$5647df6b7814ac86);

var $5uXzW = parcelRequire("5uXzW");

var $7lAlq = parcelRequire("7lAlq");
function $198cad2d2cc6eba7$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $198cad2d2cc6eba7$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $198cad2d2cc6eba7$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7lAlq.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $198cad2d2cc6eba7$export$1cfafeee2987818b() {
    var global = (0, $5uXzW.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("9NITo", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $722b835f31992c5b$export$6a506b36fdea397d);
$parcel$export(module.exports, "safeJoin", () => $722b835f31992c5b$export$465e9d514283d4fd);

var $7lAlq = parcelRequire("7lAlq");
function $722b835f31992c5b$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $722b835f31992c5b$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $722b835f31992c5b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $722b835f31992c5b$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7lAlq.isString)(value)) return false;
    if ((0, $7lAlq.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $722b835f31992c5b$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("kVXEJ", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $f3d767f62a97754b$export$aad197c7121a6651);

var $3Cq0D = parcelRequire("3Cq0D");
var $f3d767f62a97754b$var$STACKTRACE_LIMIT = 50;
function $f3d767f62a97754b$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $3Cq0D.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $3Cq0D.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $f3d767f62a97754b$export$c55c24c0eeba0205(frames);
    };
}
function $f3d767f62a97754b$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $f3d767f62a97754b$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $f3d767f62a97754b$var$defaultFunctionName = '<anonymous>';
function $f3d767f62a97754b$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $f3d767f62a97754b$var$defaultFunctionName;
        return fn.name || $f3d767f62a97754b$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $f3d767f62a97754b$var$defaultFunctionName;
    }
}

});


parcelRegister("5ndCo", function(module, exports) {
$parcel$export(module.exports, "relative", () => $3e99aa096e69966b$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $3e99aa096e69966b$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $3e99aa096e69966b$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $3e99aa096e69966b$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $3e99aa096e69966b$var$splitPath(filename) {
    var parts = $3e99aa096e69966b$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $3e99aa096e69966b$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $3e99aa096e69966b$var$normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $3e99aa096e69966b$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $3e99aa096e69966b$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $3e99aa096e69966b$export$f7ad0328861e2f03(from).substr(1);
    to = $3e99aa096e69966b$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $3e99aa096e69966b$var$trim(from.split('/'));
    var toParts = $3e99aa096e69966b$var$trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function $3e99aa096e69966b$export$6af368f973c74c5(path) {
    var isPathAbsolute = $3e99aa096e69966b$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = $3e99aa096e69966b$var$normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function $3e99aa096e69966b$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
function $3e99aa096e69966b$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $3e99aa096e69966b$export$6af368f973c74c5(args.join('/'));
}
function $3e99aa096e69966b$export$7f7b8152cc673abe(path) {
    var result = $3e99aa096e69966b$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $3e99aa096e69966b$export$9bf319d8f74f51d1(path, ext) {
    var f = $3e99aa096e69966b$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("kgsGe", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $ec0b8c8f13f24903$export$e01cef29b4327697);

var $icZGb = parcelRequire("icZGb");

var $fEQca = parcelRequire("fEQca");
function $ec0b8c8f13f24903$var$isSupportedSeverity(level) {
    return (0, $fEQca.SeverityLevels).indexOf(level) !== -1;
}
function $ec0b8c8f13f24903$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $icZGb.Severity).Warning;
    if ($ec0b8c8f13f24903$var$isSupportedSeverity(level)) return level;
    return (0, $icZGb.Severity).Log;
}

});
parcelRegister("fEQca", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $b6631454b478c4d8$export$484b1ea9aec914c);
var $b6631454b478c4d8$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("cIfKZ", function(module, exports) {

var $5uXzW = parcelRequire("5uXzW");

var $5SuB0 = parcelRequire("5SuB0");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $5uXzW.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5SuB0.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5SuB0.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $5uXzW.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});





parcelRegister("6gSQT", function(module, exports) {
$parcel$export(module.exports, "initialisePlatformFeatureFlags", () => $42d1b4e613c942b2$export$bcd24dd77ba35b8a);
/**
 *  Adapted from JFE:
 *  https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/common-legacy-do-not-add-anything-new/src/util/get-feature-flag-value.js
 *
 */ 
var $87QgR = parcelRequire("87QgR");

var $1wY2l = parcelRequire("1wY2l");
const $42d1b4e613c942b2$export$bcd24dd77ba35b8a = ()=>{
    (0, $1wY2l.setBooleanFeatureFlagResolver)((flagKey)=>(0, $87QgR.default).checkGate(flagKey));
};

});
parcelRegister("1wY2l", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $22bc4bd0ce31534e$export$ba05d765b8392e5e);

var $7vBTQ = parcelRequire("7vBTQ");
function $22bc4bd0ce31534e$export$ba05d765b8392e5e(flagResolver) {
    (0, $7vBTQ.setBooleanResolver)(flagResolver);
}

});
parcelRegister("7vBTQ", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $02b15968d5b96b00$export$f2b591175b3e424c);

var $ieD62 = parcelRequire("ieD62");

var $lAT6B = parcelRequire("lAT6B");
function $02b15968d5b96b00$export$f2b591175b3e424c(resolver) {
    (0, $ieD62.globalVar)[0, $lAT6B.PFF_GLOBAL_KEY].booleanResolver = resolver;
}

});



parcelRegister("1n2TR", function(module, exports) {
$parcel$export(module.exports, "handleDOMGoogleTranslateIssues", () => $07bd44539617e7c6$export$d1215808cd22e615);
// #reference /confluence/packages/confluence-frontend-server/src/google-translate-issue-workaround.js

var $jBiia = parcelRequire("jBiia");
const $07bd44539617e7c6$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $07bd44539617e7c6$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot remove a child from a different parent', child, this);
                    $07bd44539617e7c6$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $07bd44539617e7c6$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $07bd44539617e7c6$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $07bd44539617e7c6$var$extractNodeData(childNode)
    };
    $07bd44539617e7c6$var$sendAnalyticsEvent($07bd44539617e7c6$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $07bd44539617e7c6$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $07bd44539617e7c6$var$extractNodeData(newNode),
        referenceNode: $07bd44539617e7c6$var$extractNodeData(referenceNode)
    };
    $07bd44539617e7c6$var$sendAnalyticsEvent($07bd44539617e7c6$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $07bd44539617e7c6$var$sendAnalyticsEvent(action, nodeData) {
    (0, $jBiia.trackError)('google.translate.issue.error', {
        ...nodeData,
        errorBoundaryId: 'root',
        suppressedError: action,
        errorBoundaryPackageName: 'unknown'
    }, new Error(action));
}
function $07bd44539617e7c6$var$extractNodeData(node) {
    var _node$parentElement;
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.nodeName,
        isConnected: node.isConnected
    };
}

});

parcelRegister("6oRGF", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelp", () => $99928f755fd06c38$export$1d3b4fb23d556424);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $7RZPz = parcelRequire("7RZPz");
parcelRequire("kKBZy");
var $4GSP0 = parcelRequire("4GSP0");
parcelRequire("7IgzX");
var $3U8AI = parcelRequire("3U8AI");
parcelRequire("c4AiK");
var $3kSrQ = parcelRequire("3kSrQ");
const $99928f755fd06c38$var$renderError = ()=>/*#__PURE__*/ $bSJIT.createElement((0, $4GSP0.default), null);
const $99928f755fd06c38$export$1d3b4fb23d556424 = ({ config: config })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $7RZPz.AppProviders), {
        config: config
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
        renderError: $99928f755fd06c38$var$renderError
    }, /*#__PURE__*/ $bSJIT.createElement((0, $3kSrQ.ThemingContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $3U8AI.default), null))));
};

});
parcelRegister("7RZPz", function(module, exports) {
$parcel$export(module.exports, "store", () => $8869f1820517dfd2$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "injectReducer", () => $8869f1820517dfd2$export$8d491a82891620e4);
$parcel$export(module.exports, "onIntlNextError", () => $8869f1820517dfd2$export$3bcefabe8b04378c);
$parcel$export(module.exports, "AppProviders", () => $8869f1820517dfd2$export$6c4743022ef2c318);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $fQZdp = parcelRequire("fQZdp");

var $lFpPv = parcelRequire("lFpPv");

var $4ZMmh = parcelRequire("4ZMmh");

var $dTM5i = parcelRequire("dTM5i");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");

var $qR04C = parcelRequire("qR04C");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $djv3i = parcelRequire("djv3i");
parcelRequire("0X0OG");
var $gGwju = parcelRequire("gGwju");
parcelRequire("1GaMW");
var $j98Hb = parcelRequire("j98Hb");
parcelRequire("20ilI");
var $2LrvN = parcelRequire("2LrvN");
parcelRequire("ckGNT");
var $iStmz = parcelRequire("iStmz");

var $V3xq2 = parcelRequire("V3xq2");

var $1l5zG = parcelRequire("1l5zG");

var $1w9as = parcelRequire("1w9as");

var $87QgR = parcelRequire("87QgR");

var $clpci = parcelRequire("clpci");

var $5Z3B8 = parcelRequire("5Z3B8");

var $jBiia = parcelRequire("jBiia");

var $iRD29 = parcelRequire("iRD29");

var $3wXsr = parcelRequire("3wXsr");

var $hvyCD = parcelRequire("hvyCD");

var $jBiia = parcelRequire("jBiia");

var $3bY4T = parcelRequire("3bY4T");

var $7WD1V = parcelRequire("7WD1V");

var $amYpB = parcelRequire("amYpB");

var $81Vbr = parcelRequire("81Vbr");

var $kbkME = parcelRequire("kbkME");

var $c8MAW = parcelRequire("c8MAW");
parcelRequire("f5fLA");
var $9fGWB = parcelRequire("9fGWB");
const $8869f1820517dfd2$var$initialState = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8869f1820517dfd2$var$accountTypeMetaTagMiddleware = ()=>(next)=>(action)=>{
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (action.type === (0, $kd70W.UPDATE_USER_MODEL)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $5Z3B8.setAccountMetaTag)(action.payload.atlassianAccountManaged, action.payload.accountId);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return next(action);
        };
const { store: $8869f1820517dfd2$export$6f57813fe9f31bf9, injectReducer: $8869f1820517dfd2$export$8d491a82891620e4 } = (0, $qR04C.default)({
    initialState: $8869f1820517dfd2$var$initialState,
    middleware: [
        $8869f1820517dfd2$var$accountTypeMetaTagMiddleware
    ]
});
const $8869f1820517dfd2$export$ec3f29afcf92cc87 = (0, $amYpB.onIntlError);
const $8869f1820517dfd2$export$3bcefabe8b04378c = (0, $amYpB.onIntlNextError);
const $8869f1820517dfd2$var$onAnalyticsEvent = (event)=>{
    if ((0, $87QgR.default).checkGate('enable_help_center_analytics_bridge')) (0, $jBiia.sendEventFromAnalyticsBridge)(event);
    else (0, $jBiia.legacySendEvent)(event);
};
class $8869f1820517dfd2$export$6c4743022ef2c318 extends $bSJIT.Component {
    render() {
        const { config: config } = this.props;
        const analyticsClient = (0, $iRD29.getAnalyticsWebClient)().getInstance();
        const envFeatureFlags = $8869f1820517dfd2$export$6f57813fe9f31bf9.getState().persisted.env.featureFlags;
        const configFeatureFlags = config === null || config === void 0 ? void 0 : config.featureFlags;
        const memoizedFeatureFlags = (0, $4ZMmh.memoize)(// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (envFFs, configFFs)=>({
                ...envFFs,
                ...configFFs
            }), (...args)=>(0, $4ZMmh.keys)({
                ...args[0],
                ...args[1]
            }));
        const WrmResourceProvider = (0, $lFpPv.isWrmOptimizationsEnabled)() ? (0, $c8MAW.default) : $bSJIT.Fragment;
        return /*#__PURE__*/ $bSJIT.createElement((0, $a2qIF.RelayEnvironmentProvider), {
            environment: (0, $kbkME.getRelayEnvironment)()
        }, /*#__PURE__*/ $bSJIT.createElement((0, $3wXsr.CustomDomainsAnalyticsProvider), {
            baseUrl: config.baseUrl
        }, /*#__PURE__*/ $bSJIT.createElement((0, $V3xq2.default), {
            client: analyticsClient,
            excludedChannels: [
                (0, $1l5zG.FabricChannel).atlaskit
            ]
        }, /*#__PURE__*/ $bSJIT.createElement((0, $gGwju.EngagementProviderWrapper), {
            config: config,
            analyticsClientInstance: analyticsClient
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1w9as.default), {
            onEvent: (0, $jBiia.sendAtlaskitUIEvent),
            channel: "atlaskit"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1w9as.default), {
            onEvent: (0, $jBiia.sendEventFromAnalyticsBridge),
            channel: (0, $clpci.ANALYTICS_BRIDGE_CHANNEL)
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1w9as.default), {
            onEvent: $8869f1820517dfd2$var$onAnalyticsEvent
        }, /*#__PURE__*/ $bSJIT.createElement((0, $dTM5i.default), {
            messages: (0, $amYpB.default)(),
            locale: (0, $81Vbr.getLanguageFromLocale)((0, $fBLyB.getLocale)($8869f1820517dfd2$export$6f57813fe9f31bf9.getState())),
            onError: $8869f1820517dfd2$export$3bcefabe8b04378c
        }, /*#__PURE__*/ $bSJIT.createElement((0, $fQZdp.default), {
            store: $8869f1820517dfd2$export$6f57813fe9f31bf9
        }, /*#__PURE__*/ $bSJIT.createElement((0, $9fGWB.default), {
            config: this.props.config
        }, /*#__PURE__*/ $bSJIT.createElement(WrmResourceProvider, null, /*#__PURE__*/ $bSJIT.createElement((0, $3bY4T.PortalAnalyticsContext), null, /*#__PURE__*/ $bSJIT.createElement((0, $djv3i.HelpSeekerTypeProvider), null, /*#__PURE__*/ $bSJIT.createElement((0, $j98Hb.default), {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            featureFlags: memoizedFeatureFlags(envFeatureFlags, configFeatureFlags)
        }, /*#__PURE__*/ $bSJIT.createElement((0, $hvyCD.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $7WD1V.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $2LrvN.TFECacheProvider), null, /*#__PURE__*/ $bSJIT.createElement((0, $iStmz.CustomiseSidebarTriggerProvider), null, this.props.children))))))))))))))))));
    }
}

});
parcelRegister("egQxE", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("fQZdp")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("f2mlD")).default);

var $fQZdp = parcelRequire("fQZdp");

var $9nTN4 = parcelRequire("9nTN4");

var $25XUK = parcelRequire("25XUK");

var $f2mlD = parcelRequire("f2mlD");

});
parcelRegister("fQZdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8ab326f7488ce79$export$2e2bcd8739ae039);

var $huZMc = parcelRequire("huZMc");

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $25XUK = parcelRequire("25XUK");
var $b8ab326f7488ce79$var$Provider = /*#__PURE__*/ function(_Component) {
    (0, $huZMc.default)(Provider, _Component);
    function Provider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        var store = props.store;
        _this.state = {
            storeState: store.getState(),
            store: store
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.subscribe();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this._isMounted = false;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.store !== prevProps.store) {
            if (this.unsubscribe) this.unsubscribe();
            this.subscribe();
        }
    };
    _proto.subscribe = function subscribe() {
        var _this2 = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function() {
            var newStoreState = store.getState();
            if (!_this2._isMounted) return;
            _this2.setState(function(providerState) {
                // If the value is the same, skip the unnecessary state update.
                if (providerState.storeState === newStoreState) return null;
                return {
                    storeState: newStoreState
                };
            });
        }); // Actions might have been dispatched between render and mount - handle those
        var postMountStoreState = store.getState();
        if (postMountStoreState !== this.state.storeState) this.setState({
            storeState: postMountStoreState
        });
    };
    _proto.render = function render() {
        var Context = this.props.context || (0, $25XUK.ReactReduxContext);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Context.Provider, {
            value: this.state
        }, this.props.children);
    };
    return Provider;
}((0, $bSJIT.Component));
$b8ab326f7488ce79$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).any
};
var $b8ab326f7488ce79$export$2e2bcd8739ae039 = $b8ab326f7488ce79$var$Provider;

});
parcelRegister("huZMc", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbd5288477b3acdf$export$2e2bcd8739ae039);

var $3cJx8 = parcelRequire("3cJx8");
function $cbd5288477b3acdf$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3cJx8.default)(t, o);
}

});
parcelRegister("3cJx8", function(module, exports) {
$parcel$export(module.exports, "default", () => $2555d01152d8dc4c$export$2e2bcd8739ae039);
function $2555d01152d8dc4c$export$2e2bcd8739ae039(t, e) {
    return $2555d01152d8dc4c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2555d01152d8dc4c$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("25XUK", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $186a86223cca0c7d$export$cc80c08dc91f1c00);

var $bSJIT = parcelRequire("bSJIT");
var $186a86223cca0c7d$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(null);
var $186a86223cca0c7d$export$2e2bcd8739ae039 = $186a86223cca0c7d$export$cc80c08dc91f1c00;

});


parcelRegister("9nTN4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d5189dcf0f4f844$export$2e2bcd8739ae039);

var $iyejT = parcelRequire("iyejT");

var $huZMc = parcelRequire("huZMc");

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");

var $jNar1 = parcelRequire("jNar1");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");

var $e4Sjd = parcelRequire("e4Sjd");

var $25XUK = parcelRequire("25XUK");
var $6d5189dcf0f4f844$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $6d5189dcf0f4f844$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $25XUK.ReactReduxContext) : _ref2$context, connectOptions = (0, $kV77Q.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bt114)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($bt114)))(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
    var customStoreWarningMessage = "To use a custom Redux store for specific components,  create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($bt114)))(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $g8vBZ.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        var OuterBaseComponent = (0, $bSJIT.Component);
        if (pure) OuterBaseComponent = (0, $bSJIT.PureComponent);
        function makeDerivedPropsSelector() {
            var lastProps;
            var lastState;
            var lastDerivedProps;
            var lastStore;
            var lastSelectorFactoryOptions;
            var sourceSelector;
            return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
                if (pure && lastProps === props && lastState === state) return lastDerivedProps;
                if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
                    lastStore = store;
                    lastSelectorFactoryOptions = selectorFactoryOptions;
                    sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
                }
                lastProps = props;
                lastState = state;
                var nextProps = sourceSelector(state, props);
                lastDerivedProps = nextProps;
                return lastDerivedProps;
            };
        }
        function makeChildElementSelector() {
            var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
            return function selectChildElement(WrappedComponent, childProps, forwardRef) {
                if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
                    lastChildProps = childProps;
                    lastForwardRef = forwardRef;
                    lastComponent = WrappedComponent;
                    lastChildElement = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, (0, $g8vBZ.default)({}, childProps, {
                        ref: forwardRef
                    }));
                }
                return lastChildElement;
            };
        }
        var Connect = /*#__PURE__*/ function(_OuterBaseComponent) {
            (0, $huZMc.default)(Connect, _OuterBaseComponent);
            function Connect(props) {
                var _this;
                _this = _OuterBaseComponent.call(this, props) || this;
                (0, (/*@__PURE__*/$parcel$interopDefault($bt114)))(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
                _this.selectDerivedProps = makeDerivedPropsSelector();
                _this.selectChildElement = makeChildElementSelector();
                _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, $iyejT.default)(_this));
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
                // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
                return this.renderWrappedComponent(value);
            };
            _proto.renderWrappedComponent = function renderWrappedComponent(value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($bt114)))(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
                var storeState = value.storeState, store = value.store;
                var wrapperProps = this.props;
                var forwardedRef;
                if (forwardRef) {
                    wrapperProps = this.props.wrapperProps;
                    forwardedRef = this.props.forwardedRef;
                }
                var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
                return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
            };
            _proto.render = function render() {
                var ContextToUse = this.props.context && this.props.context.Consumer && (0, $e4Sjd.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
                return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
            };
            return Connect;
        }(OuterBaseComponent);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Connect, {
                    wrapperProps: props,
                    forwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($jNar1)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($jNar1)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("iyejT", function(module, exports) {
$parcel$export(module.exports, "default", () => $d816829a212fa3ce$export$2e2bcd8739ae039);
function $d816829a212fa3ce$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("bt114", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $859330efeaf06f52$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $859330efeaf06f52$var$invariant;

});


parcelRegister("f2mlD", function(module, exports) {
$parcel$export(module.exports, "default", () => $af2860c02da2ddfa$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");

var $9nTN4 = parcelRequire("9nTN4");

var $5i085 = parcelRequire("5i085");

var $gjhFo = parcelRequire("gjhFo");

var $aBtg6 = parcelRequire("aBtg6");

var $j6srv = parcelRequire("j6srv");

var $jiYkJ = parcelRequire("jiYkJ");
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $af2860c02da2ddfa$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $af2860c02da2ddfa$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $af2860c02da2ddfa$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $9nTN4.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $aBtg6.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $gjhFo.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $j6srv.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $jiYkJ.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $af2860c02da2ddfa$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $5i085.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $5i085.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $5i085.default) : _ref3$areMergedPropsE, extraOptions = (0, $kV77Q.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $af2860c02da2ddfa$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $af2860c02da2ddfa$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $af2860c02da2ddfa$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $g8vBZ.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $af2860c02da2ddfa$export$2e2bcd8739ae039 = $af2860c02da2ddfa$export$9f9feb656dec1fc4();

});
parcelRegister("5i085", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d9ebbe3d3deb14b$export$2e2bcd8739ae039);
var $3d9ebbe3d3deb14b$var$hasOwn = Object.prototype.hasOwnProperty;
function $3d9ebbe3d3deb14b$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3d9ebbe3d3deb14b$export$2e2bcd8739ae039(objA, objB) {
    if ($3d9ebbe3d3deb14b$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$3d9ebbe3d3deb14b$var$hasOwn.call(objB, keysA[i]) || !$3d9ebbe3d3deb14b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("gjhFo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdfc1feae0c58a8b$export$2e2bcd8739ae039);
parcelRequire("1mIIj");
var $O3Wws = parcelRequire("O3Wws");

var $fMHP2 = parcelRequire("fMHP2");
function $bdfc1feae0c58a8b$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $fMHP2.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $bdfc1feae0c58a8b$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $fMHP2.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $bdfc1feae0c58a8b$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $fMHP2.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $O3Wws.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $bdfc1feae0c58a8b$export$2e2bcd8739ae039 = [
    $bdfc1feae0c58a8b$export$a9f27b4b187c1166,
    $bdfc1feae0c58a8b$export$ba20d1a7aa0c4a90,
    $bdfc1feae0c58a8b$export$94a6e55709d4d961
];

});
parcelRegister("1mIIj", function(module, exports) {
$parcel$export(module.exports, "createStore", () => (parcelRequire("5nEeT")).default);
$parcel$export(module.exports, "combineReducers", () => (parcelRequire("j5nqc")).default);
$parcel$export(module.exports, "bindActionCreators", () => (parcelRequire("O3Wws")).default);
$parcel$export(module.exports, "applyMiddleware", () => (parcelRequire("7Fvyo")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("6LgZh")).default);

var $5nEeT = parcelRequire("5nEeT");

var $j5nqc = parcelRequire("j5nqc");

var $O3Wws = parcelRequire("O3Wws");

var $7Fvyo = parcelRequire("7Fvyo");

var $6LgZh = parcelRequire("6LgZh");
parcelRequire("kixqf");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $0fea87bb535e3821$var$isCrushed() {}

});
parcelRegister("5nEeT", function(module, exports) {
$parcel$export(module.exports, "ActionTypes", () => $3eae506a20c24968$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "default", () => $3eae506a20c24968$export$2e2bcd8739ae039);

var $2Adxz = parcelRequire("2Adxz");

var $2GfMH = parcelRequire("2GfMH");
var $3eae506a20c24968$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $3eae506a20c24968$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($3eae506a20c24968$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $2Adxz.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $3eae506a20c24968$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $2GfMH.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $3eae506a20c24968$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $2GfMH.default] = observable, _ref2;
}

});
parcelRegister("2Adxz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e19726f909cca93$export$2e2bcd8739ae039);

var $cq9W5 = parcelRequire("cq9W5");

var $4MFoO = parcelRequire("4MFoO");

var $84GGJ = parcelRequire("84GGJ");
/** `Object#toString` result references. */ var $1e19726f909cca93$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1e19726f909cca93$var$funcProto = Function.prototype, $1e19726f909cca93$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1e19726f909cca93$var$funcToString = $1e19726f909cca93$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1e19726f909cca93$var$hasOwnProperty = $1e19726f909cca93$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $1e19726f909cca93$var$objectCtorString = $1e19726f909cca93$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $1e19726f909cca93$var$isPlainObject(value) {
    if (!(0, $84GGJ.default)(value) || (0, $cq9W5.default)(value) != $1e19726f909cca93$var$objectTag) return false;
    var proto = (0, $4MFoO.default)(value);
    if (proto === null) return true;
    var Ctor = $1e19726f909cca93$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $1e19726f909cca93$var$funcToString.call(Ctor) == $1e19726f909cca93$var$objectCtorString;
}
var $1e19726f909cca93$export$2e2bcd8739ae039 = $1e19726f909cca93$var$isPlainObject;

});
parcelRegister("cq9W5", function(module, exports) {
$parcel$export(module.exports, "default", () => $90af9eccebf281ac$export$2e2bcd8739ae039);

var $f7xY2 = parcelRequire("f7xY2");

var $5OO7d = parcelRequire("5OO7d");

var $bm4QT = parcelRequire("bm4QT");
/** `Object#toString` result references. */ var $90af9eccebf281ac$var$nullTag = '[object Null]', $90af9eccebf281ac$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $90af9eccebf281ac$var$symToStringTag = (0, $f7xY2.default) ? (0, $f7xY2.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $90af9eccebf281ac$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $90af9eccebf281ac$var$undefinedTag : $90af9eccebf281ac$var$nullTag;
    return $90af9eccebf281ac$var$symToStringTag && $90af9eccebf281ac$var$symToStringTag in Object(value) ? (0, $5OO7d.default)(value) : (0, $bm4QT.default)(value);
}
var $90af9eccebf281ac$export$2e2bcd8739ae039 = $90af9eccebf281ac$var$baseGetTag;

});
parcelRegister("f7xY2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b021dba84ebf7a6b$export$2e2bcd8739ae039);

var $c8UeL = parcelRequire("c8UeL");
/** Built-in value references. */ var $b021dba84ebf7a6b$var$Symbol = (0, $c8UeL.default).Symbol;
var $b021dba84ebf7a6b$export$2e2bcd8739ae039 = $b021dba84ebf7a6b$var$Symbol;

});
parcelRegister("c8UeL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d71dae6bc2f539e$export$2e2bcd8739ae039);

var $rCoQ1 = parcelRequire("rCoQ1");
/** Detect free variable `self`. */ var $8d71dae6bc2f539e$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8d71dae6bc2f539e$var$root = (0, $rCoQ1.default) || $8d71dae6bc2f539e$var$freeSelf || Function('return this')();
var $8d71dae6bc2f539e$export$2e2bcd8739ae039 = $8d71dae6bc2f539e$var$root;

});
parcelRegister("rCoQ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $05304f1834edfa6c$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $05304f1834edfa6c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $05304f1834edfa6c$export$2e2bcd8739ae039 = $05304f1834edfa6c$var$freeGlobal;

});



parcelRegister("5OO7d", function(module, exports) {
$parcel$export(module.exports, "default", () => $43c87f238f6e7393$export$2e2bcd8739ae039);

var $f7xY2 = parcelRequire("f7xY2");
/** Used for built-in method references. */ var $43c87f238f6e7393$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $43c87f238f6e7393$var$hasOwnProperty = $43c87f238f6e7393$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $43c87f238f6e7393$var$nativeObjectToString = $43c87f238f6e7393$var$objectProto.toString;
/** Built-in value references. */ var $43c87f238f6e7393$var$symToStringTag = (0, $f7xY2.default) ? (0, $f7xY2.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $43c87f238f6e7393$var$getRawTag(value) {
    var isOwn = $43c87f238f6e7393$var$hasOwnProperty.call(value, $43c87f238f6e7393$var$symToStringTag), tag = value[$43c87f238f6e7393$var$symToStringTag];
    try {
        value[$43c87f238f6e7393$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $43c87f238f6e7393$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$43c87f238f6e7393$var$symToStringTag] = tag;
        else delete value[$43c87f238f6e7393$var$symToStringTag];
    }
    return result;
}
var $43c87f238f6e7393$export$2e2bcd8739ae039 = $43c87f238f6e7393$var$getRawTag;

});

parcelRegister("bm4QT", function(module, exports) {
$parcel$export(module.exports, "default", () => $844583548a289644$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $844583548a289644$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $844583548a289644$var$nativeObjectToString = $844583548a289644$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $844583548a289644$var$objectToString(value) {
    return $844583548a289644$var$nativeObjectToString.call(value);
}
var $844583548a289644$export$2e2bcd8739ae039 = $844583548a289644$var$objectToString;

});


parcelRegister("4MFoO", function(module, exports) {
$parcel$export(module.exports, "default", () => $37bbc2264452778a$export$2e2bcd8739ae039);

var $dYyja = parcelRequire("dYyja");
/** Built-in value references. */ var $37bbc2264452778a$var$getPrototype = (0, $dYyja.default)(Object.getPrototypeOf, Object);
var $37bbc2264452778a$export$2e2bcd8739ae039 = $37bbc2264452778a$var$getPrototype;

});
parcelRegister("dYyja", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2cb7dd39b4d50a7$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $a2cb7dd39b4d50a7$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $a2cb7dd39b4d50a7$export$2e2bcd8739ae039 = $a2cb7dd39b4d50a7$var$overArg;

});


parcelRegister("84GGJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e0fcf74d7ea6f5c$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5e0fcf74d7ea6f5c$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $5e0fcf74d7ea6f5c$export$2e2bcd8739ae039 = $5e0fcf74d7ea6f5c$var$isObjectLike;

});


parcelRegister("2GfMH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f3bbf7cc493e0a7$export$2e2bcd8739ae039);
/* global window */ 
var $4DrAe = parcelRequire("4DrAe");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $4DrAe.default)(root);
var $1f3bbf7cc493e0a7$export$2e2bcd8739ae039 = result;

});
parcelRegister("4DrAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $3600336eb7b61c93$export$2e2bcd8739ae039);
function $3600336eb7b61c93$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("j5nqc", function(module, exports) {
$parcel$export(module.exports, "default", () => $de50a6f91fb6f2d7$export$2e2bcd8739ae039);

var $5nEeT = parcelRequire("5nEeT");

var $2Adxz = parcelRequire("2Adxz");
parcelRequire("kixqf");
function $de50a6f91fb6f2d7$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $de50a6f91fb6f2d7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $5nEeT.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $2Adxz.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $de50a6f91fb6f2d7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $5nEeT.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $5nEeT.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $de50a6f91fb6f2d7$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $de50a6f91fb6f2d7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $de50a6f91fb6f2d7$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("kixqf", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ec6f6a113be659df$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("O3Wws", function(module, exports) {
$parcel$export(module.exports, "default", () => $0967ba9b38058a1b$export$2e2bcd8739ae039);
function $0967ba9b38058a1b$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $0967ba9b38058a1b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $0967ba9b38058a1b$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $0967ba9b38058a1b$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("7Fvyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $5954d6a798153e92$export$2e2bcd8739ae039);

var $6LgZh = parcelRequire("6LgZh");
var $5954d6a798153e92$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $5954d6a798153e92$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $6LgZh.default).apply(undefined, chain)(store.dispatch);
            return $5954d6a798153e92$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("6LgZh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ec44f35b749e85f$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $4ec44f35b749e85f$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("fMHP2", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $b7dd54dde1a72581$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $b7dd54dde1a72581$export$8d46c7f53c8c602f);
parcelRequire("1DoB0");
function $b7dd54dde1a72581$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $b7dd54dde1a72581$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $b7dd54dde1a72581$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b7dd54dde1a72581$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b7dd54dde1a72581$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("1DoB0", function(module, exports) {

var $hyf2C = parcelRequire("hyf2C");

var $5kzrv = parcelRequire("5kzrv");
function $130c833164e4ef3a$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $hyf2C.default)(value)) (0, $5kzrv.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("hyf2C", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc71477f23934622$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $cc71477f23934622$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("5kzrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e1a502e6765fcf4$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $3e1a502e6765fcf4$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("aBtg6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b840e45c9fd22de$export$2e2bcd8739ae039);

var $fMHP2 = parcelRequire("fMHP2");
function $7b840e45c9fd22de$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $fMHP2.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $7b840e45c9fd22de$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $fMHP2.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $7b840e45c9fd22de$export$2e2bcd8739ae039 = [
    $7b840e45c9fd22de$export$23fc470827b14aa,
    $7b840e45c9fd22de$export$514bc8c1a53c1d66
];

});

parcelRegister("j6srv", function(module, exports) {
$parcel$export(module.exports, "default", () => $de84a3f426a30696$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");
parcelRequire("1DoB0");
function $de84a3f426a30696$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $g8vBZ.default)({}, ownProps, stateProps, dispatchProps);
}
function $de84a3f426a30696$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $de84a3f426a30696$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $de84a3f426a30696$export$5b105939c84b5234(mergeProps) : undefined;
}
function $de84a3f426a30696$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $de84a3f426a30696$export$691c327fc30bc857;
    } : undefined;
}
var $de84a3f426a30696$export$2e2bcd8739ae039 = [
    $de84a3f426a30696$export$d61b680184bc3f00,
    $de84a3f426a30696$export$a13ba70ef50dda6d
];

});

parcelRegister("jiYkJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0de7fba4f87fdd0$export$2e2bcd8739ae039);

var $kV77Q = parcelRequire("kV77Q");
parcelRequire("5jK7h");
function $e0de7fba4f87fdd0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $e0de7fba4f87fdd0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $e0de7fba4f87fdd0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $kV77Q.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $e0de7fba4f87fdd0$export$d20c0c2ca6eb2b6f : $e0de7fba4f87fdd0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("5jK7h", function(module, exports) {

var $5kzrv = parcelRequire("5kzrv");
function $3df27fd8cdd3d4b6$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!selector.hasOwnProperty('dependsOnOwnProps')) (0, $5kzrv.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $3df27fd8cdd3d4b6$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $3df27fd8cdd3d4b6$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $3df27fd8cdd3d4b6$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $3df27fd8cdd3d4b6$var$verify(mergeProps, 'mergeProps', displayName);
}

});




parcelRegister("a2qIF", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("9pgZe"));

});
parcelRegister("9pgZe", function(module, exports) {
'use strict';

var $ajh5K = parcelRequire("ajh5K");

var $9dJmo = parcelRequire("9dJmo");

var $5s8bz = parcelRequire("5s8bz");

var $kycFu = parcelRequire("kycFu");

var $fti6A = parcelRequire("fti6A");

var $64oHH = parcelRequire("64oHH");

var $5qwtE = parcelRequire("5qwtE");

var $7XYjZ = parcelRequire("7XYjZ");

var $lR6HQ = parcelRequire("lR6HQ");
var $01c47210a7737984$var$loadQuery = $lR6HQ.loadQuery;

var $h8qaV = parcelRequire("h8qaV");

var $6v1UG = parcelRequire("6v1UG");

var $hJpcW = parcelRequire("hJpcW");

var $bM0sC = parcelRequire("bM0sC");

var $9g3NB = parcelRequire("9g3NB");

var $96mIX = parcelRequire("96mIX");

var $cF6oC = parcelRequire("cF6oC");

var $60gfm = parcelRequire("60gfm");

var $eHdgl = parcelRequire("eHdgl");

var $gBm2Y = parcelRequire("gBm2Y");

var $jOt5L = parcelRequire("jOt5L");

var $7Bqx6 = parcelRequire("7Bqx6");

var $ctuwe = parcelRequire("ctuwe");

var $eu5v5 = parcelRequire("eu5v5");

var $iwELz = parcelRequire("iwELz");

var $4270B = parcelRequire("4270B");
module.exports = {
    ConnectionHandler: $4270B.ConnectionHandler,
    QueryRenderer: $fti6A,
    LocalQueryRenderer: $5s8bz,
    MutationTypes: $4270B.MutationTypes,
    RangeOperations: $4270B.RangeOperations,
    ReactRelayContext: $ajh5K,
    applyOptimisticMutation: $4270B.applyOptimisticMutation,
    commitLocalUpdate: $4270B.commitLocalUpdate,
    commitMutation: $4270B.commitMutation,
    createFragmentContainer: $9dJmo.createContainer,
    createPaginationContainer: $kycFu.createContainer,
    createRefetchContainer: $64oHH.createContainer,
    fetchQuery_DEPRECATED: $4270B.fetchQuery_DEPRECATED,
    graphql: $4270B.graphql,
    readInlineData: $4270B.readInlineData,
    requestSubscription: $4270B.requestSubscription,
    EntryPointContainer: $5qwtE,
    RelayEnvironmentProvider: $6v1UG,
    ProfilerContext: $h8qaV,
    fetchQuery: $4270B.fetchQuery,
    loadQuery: $01c47210a7737984$var$loadQuery,
    loadEntryPoint: $7XYjZ,
    useClientQuery: $hJpcW,
    useFragment: $9g3NB,
    useLazyLoadQuery: $96mIX,
    useEntryPointLoader: $bM0sC,
    useQueryLoader: $jOt5L,
    useMutation: $cF6oC,
    usePaginationFragment: $60gfm,
    usePreloadedQuery: $gBm2Y,
    useRefetchableFragment: $7Bqx6,
    usePrefetchableForwardPaginationFragment: $eHdgl,
    useRelayEnvironment: $ctuwe,
    useSubscribeToInvalidationState: $eu5v5,
    useSubscription: $iwELz
};

});
parcelRegister("ajh5K", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $7818efce2014a7e1$var$createRelayContext = $4270B.__internal.createRelayContext;
module.exports = $7818efce2014a7e1$var$createRelayContext($bSJIT);

});
parcelRegister("4270B", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("sFMmw"));

});
parcelRegister("sFMmw", function(module, exports) {
'use strict';

var $coRVQ = parcelRequire("coRVQ");
var $05630616185e7b56$var$isErrorResult = $coRVQ.isErrorResult, $05630616185e7b56$var$isValueResult = $coRVQ.isValueResult;

var $j1oma = parcelRequire("j1oma");

var $kqQfT = parcelRequire("kqQfT");

var $3Ejbt = parcelRequire("3Ejbt");

var $b2H0r = parcelRequire("b2H0r");

var $hjIph = parcelRequire("hjIph");

var $i4ACq = parcelRequire("i4ACq");

var $91ZvW = parcelRequire("91ZvW");

var $2xVPy = parcelRequire("2xVPy");

var $8qCM6 = parcelRequire("8qCM6");

var $147kh = parcelRequire("147kh");

var $blGZ1 = parcelRequire("blGZ1");

var $kBdRw = parcelRequire("kBdRw");

var $4qfpy = parcelRequire("4qfpy");

var $1I87o = parcelRequire("1I87o");

var $emGVK = parcelRequire("emGVK");

var $hJbo4 = parcelRequire("hJbo4");

var $fuThW = parcelRequire("fuThW");
var $05630616185e7b56$var$generateClientID = $fuThW.generateClientID, $05630616185e7b56$var$generateUniqueClientID = $fuThW.generateUniqueClientID, $05630616185e7b56$var$isClientID = $fuThW.isClientID;

var $8azUy = parcelRequire("8azUy");

var $27rIu = parcelRequire("27rIu");

var $kZ5Nx = parcelRequire("kZ5Nx");

var $hDQtO = parcelRequire("hDQtO");

var $kXikJ = parcelRequire("kXikJ");
var $05630616185e7b56$var$isSuspenseSentinel = $kXikJ.isSuspenseSentinel, $05630616185e7b56$var$suspenseSentinel = $kXikJ.suspenseSentinel;

var $ceVKc = parcelRequire("ceVKc");

var $3y63I = parcelRequire("3y63I");

var $5573k = parcelRequire("5573k");

var $6BNRn = parcelRequire("6BNRn");

var $bt5FL = parcelRequire("bt5FL");

var $2Yj88 = parcelRequire("2Yj88");

var $7mhru = parcelRequire("7mhru");

var $bdoqY = parcelRequire("bdoqY");

var $28AUq = parcelRequire("28AUq");

var $6Ip1f = parcelRequire("6Ip1f");

var $axvNS = parcelRequire("axvNS");

var $kXfEz = parcelRequire("kXfEz");

var $fv7WG = parcelRequire("fv7WG");

var $1VBZ4 = parcelRequire("1VBZ4");

var $9eaFC = parcelRequire("9eaFC");

var $hls5V = parcelRequire("hls5V");

var $fB1gY = parcelRequire("fB1gY");

var $7HrDY = parcelRequire("7HrDY");

var $38Zg0 = parcelRequire("38Zg0");

var $jJOFW = parcelRequire("jJOFW");

var $PTV2Q = parcelRequire("PTV2Q");

var $hI54l = parcelRequire("hI54l");

var $k5XXK = parcelRequire("k5XXK");

var $kbJmN = parcelRequire("kbJmN");

var $gkcXR = parcelRequire("gkcXR");
var $05630616185e7b56$var$handlePotentialSnapshotErrors = $gkcXR.handlePotentialSnapshotErrors;

var $lAaCv = parcelRequire("lAaCv");

var $giHAT = parcelRequire("giHAT");

var $2tzVZ = parcelRequire("2tzVZ");

var $7UmEy = parcelRequire("7UmEy");

var $aQVCW = parcelRequire("aQVCW");

var $bJPoz = parcelRequire("bJPoz");

var $1i6fU = parcelRequire("1i6fU");

var $4zNlW = parcelRequire("4zNlW");

var $0ebxq = parcelRequire("0ebxq");

var $abxbg = parcelRequire("abxbg");
var $05630616185e7b56$var$hasCycle = $abxbg.hasCycle, $05630616185e7b56$var$stableCopy = $abxbg.stableCopy;

var $kXyrn = parcelRequire("kXyrn");
var $05630616185e7b56$var$mapStr, $05630616185e7b56$var$setStr, $05630616185e7b56$var$promiseStr, $05630616185e7b56$var$objStr;
module.exports = {
    Environment: $6BNRn,
    Network: $8qCM6,
    Observable: $147kh,
    QueryResponseCache: $blGZ1,
    RecordSource: $6Ip1f,
    Record: $2Yj88,
    ReplaySubject: $0ebxq,
    Store: $bdoqY,
    areEqualSelectors: $7mhru.areEqualSelectors,
    createFragmentSpecResolver: $8azUy,
    createNormalizationSelector: $7mhru.createNormalizationSelector,
    createOperationDescriptor: $bt5FL.createOperationDescriptor,
    createReaderSelector: $7mhru.createReaderSelector,
    createRequestDescriptor: $bt5FL.createRequestDescriptor,
    getArgumentValues: $axvNS.getArgumentValues,
    getDataIDsFromFragment: $7mhru.getDataIDsFromFragment,
    getDataIDsFromObject: $7mhru.getDataIDsFromObject,
    getNode: $emGVK.getNode,
    getFragment: $emGVK.getFragment,
    getInlineDataFragment: $emGVK.getInlineDataFragment,
    getModuleComponentKey: $axvNS.getModuleComponentKey,
    getModuleOperationKey: $axvNS.getModuleOperationKey,
    getPaginationFragment: $emGVK.getPaginationFragment,
    getPluralSelector: $7mhru.getPluralSelector,
    getRefetchableFragment: $emGVK.getRefetchableFragment,
    getRequest: $emGVK.getRequest,
    getRequestIdentifier: $k5XXK,
    getSelector: $7mhru.getSelector,
    getSelectorsFromObject: $7mhru.getSelectorsFromObject,
    getSingularSelector: $7mhru.getSingularSelector,
    getStorageKey: $axvNS.getStorageKey,
    getVariablesFromFragment: $7mhru.getVariablesFromFragment,
    getVariablesFromObject: $7mhru.getVariablesFromObject,
    getVariablesFromPluralFragment: $7mhru.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $7mhru.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $05630616185e7b56$var$handlePotentialSnapshotErrors,
    graphql: $emGVK.graphql,
    isErrorResult: $05630616185e7b56$var$isErrorResult,
    isValueResult: $05630616185e7b56$var$isValueResult,
    isFragment: $emGVK.isFragment,
    isInlineDataFragment: $emGVK.isInlineDataFragment,
    isSuspenseSentinel: $05630616185e7b56$var$isSuspenseSentinel,
    suspenseSentinel: $05630616185e7b56$var$suspenseSentinel,
    isRequest: $emGVK.isRequest,
    readInlineData: $3y63I,
    readFragment: $kXfEz.readFragment,
    MutationTypes: $2xVPy.MutationTypes,
    RangeOperations: $2xVPy.RangeOperations,
    DefaultHandlerProvider: $b2H0r,
    ConnectionHandler: $j1oma,
    MutationHandlers: $3Ejbt,
    VIEWER_ID: $fv7WG.VIEWER_ID,
    VIEWER_TYPE: $fv7WG.VIEWER_TYPE,
    applyOptimisticMutation: $hjIph,
    commitLocalUpdate: $i4ACq,
    commitMutation: $91ZvW,
    fetchQuery: $kBdRw,
    fetchQuery_DEPRECATED: $4qfpy,
    isRelayModernEnvironment: $hDQtO,
    requestSubscription: $1VBZ4,
    ConnectionInterface: $kqQfT,
    PreloadableQueryRegistry: $hJbo4,
    RelayProfiler: $4zNlW,
    createPayloadFor3DField: $9eaFC,
    RelayConcreteNode: $7UmEy,
    RelayError: $bJPoz,
    RelayFeatureFlags: $1i6fU,
    DEFAULT_HANDLE_KEY: $aQVCW.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $axvNS.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $axvNS.FRAGMENT_OWNER_KEY,
    ID_KEY: $axvNS.ID_KEY,
    REF_KEY: $axvNS.REF_KEY,
    REFS_KEY: $axvNS.REFS_KEY,
    ROOT_ID: $axvNS.ROOT_ID,
    ROOT_TYPE: $axvNS.ROOT_TYPE,
    TYPENAME_KEY: $axvNS.TYPENAME_KEY,
    deepFreeze: $hls5V,
    generateClientID: $05630616185e7b56$var$generateClientID,
    generateUniqueClientID: $05630616185e7b56$var$generateUniqueClientID,
    getRelayHandleKey: $hI54l,
    isClientID: $05630616185e7b56$var$isClientID,
    isPromise: $lAaCv,
    isScalarAndEqual: $giHAT,
    recycleNodesInto: $2tzVZ,
    stableCopy: $05630616185e7b56$var$stableCopy,
    hasCycle: $05630616185e7b56$var$hasCycle,
    getFragmentIdentifier: $fB1gY,
    getRefetchMetadata: $PTV2Q,
    getPaginationMetadata: $7HrDY,
    getPaginationVariables: $38Zg0,
    getPendingOperationsForFragment: $jJOFW,
    getValueAtPath: $kbJmN,
    __internal: {
        ResolverFragments: $kXfEz,
        OperationTracker: $28AUq,
        createRelayContext: $27rIu,
        createRelayLoggingContext: $kZ5Nx,
        getOperationVariables: $5573k.getOperationVariables,
        getLocalVariables: $5573k.getLocalVariables,
        fetchQuery: $1I87o.fetchQuery,
        fetchQueryDeduped: $1I87o.fetchQueryDeduped,
        getPromiseForActiveRequest: $1I87o.getPromiseForActiveRequest,
        getObservableForActiveRequest: $1I87o.getObservableForActiveRequest,
        normalizeResponse: $ceVKc,
        withProvidedVariables: $kXyrn
    }
};

});
parcelRegister("coRVQ", function(module, exports) {
'use strict';

var $gNkNo = parcelRequire("gNkNo");

var $iYIvU = parcelRequire("iYIvU");
var $90718fb4d7b162dc$var$observeFragment = $iYIvU.observeFragment;

var $g50Vu = parcelRequire("g50Vu");
var $90718fb4d7b162dc$var$observeQuery = $g50Vu.observeQuery;

var $dHKe9 = parcelRequire("dHKe9");
var $90718fb4d7b162dc$var$waitForFragmentData = $dHKe9.waitForFragmentData;
function $90718fb4d7b162dc$var$isValueResult(input) {
    return input.ok === true;
}
function $90718fb4d7b162dc$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $gNkNo,
    isValueResult: $90718fb4d7b162dc$var$isValueResult,
    isErrorResult: $90718fb4d7b162dc$var$isErrorResult,
    observeQuery: $90718fb4d7b162dc$var$observeQuery,
    observeFragment: $90718fb4d7b162dc$var$observeFragment,
    waitForFragmentData: $90718fb4d7b162dc$var$waitForFragmentData
};

});
parcelRegister("gNkNo", function(module, exports) {
'use strict';

var $kXfEz = parcelRequire("kXfEz");
var $c3a15a8a92cbc130$var$readFragment = $kXfEz.readFragment;

var $bt114 = parcelRequire("bt114");
function $c3a15a8a92cbc130$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $c3a15a8a92cbc130$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $bt114(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $bt114(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $bt114(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $c3a15a8a92cbc130$var$resolverDataInjector;

});
parcelRegister("kXfEz", function(module, exports) {
'use strict';

var $emGVK = parcelRequire("emGVK");
var $f41575c4a0606833$var$getFragment = $emGVK.getFragment;

var $gkcXR = parcelRequire("gkcXR");
var $f41575c4a0606833$var$eventShouldThrow = $gkcXR.eventShouldThrow;

var $7mhru = parcelRequire("7mhru");
var $f41575c4a0606833$var$getSelector = $7mhru.getSelector;

var $bt114 = parcelRequire("bt114");
var $f41575c4a0606833$var$contextStack = [];
function $f41575c4a0606833$var$withResolverContext(context, cb) {
    $f41575c4a0606833$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $f41575c4a0606833$var$contextStack.pop();
    }
}
function $f41575c4a0606833$var$readFragment(fragmentInput, fragmentKey) {
    if (!$f41575c4a0606833$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $f41575c4a0606833$var$contextStack[$f41575c4a0606833$var$contextStack.length - 1];
    var fragmentNode = $f41575c4a0606833$var$getFragment(fragmentInput);
    var fragmentSelector = $f41575c4a0606833$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $bt114(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $bt114(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($f41575c4a0606833$var$eventShouldThrow)) throw $f41575c4a0606833$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $f41575c4a0606833$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $f41575c4a0606833$var$readFragment,
    withResolverContext: $f41575c4a0606833$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $f41575c4a0606833$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("emGVK", function(module, exports) {
'use strict';

var $7UmEy = parcelRequire("7UmEy");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $a7546bd84be9a253$var$graphql(strings) {
    $bt114(false);
}
function $a7546bd84be9a253$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $a7546bd84be9a253$var$isFragment(node) {
    var fragment = $a7546bd84be9a253$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $7UmEy.FRAGMENT;
}
function $a7546bd84be9a253$var$isRequest(node) {
    var request = $a7546bd84be9a253$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $7UmEy.REQUEST;
}
function $a7546bd84be9a253$var$isUpdatableQuery(node) {
    var updatableQuery = $a7546bd84be9a253$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $7UmEy.UPDATABLE_QUERY;
}
function $a7546bd84be9a253$var$isInlineDataFragment(node) {
    var fragment = $a7546bd84be9a253$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $7UmEy.INLINE_DATA_FRAGMENT;
}
function $a7546bd84be9a253$var$getFragment(taggedNode) {
    var fragment = $a7546bd84be9a253$var$getNode(taggedNode);
    !$a7546bd84be9a253$var$isFragment(fragment) && $bt114(false);
    return fragment;
}
function $a7546bd84be9a253$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $a7546bd84be9a253$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $a7546bd84be9a253$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $a7546bd84be9a253$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $a7546bd84be9a253$var$getRequest(taggedNode) {
    var request = $a7546bd84be9a253$var$getNode(taggedNode);
    !$a7546bd84be9a253$var$isRequest(request) && $bt114(false);
    return request;
}
function $a7546bd84be9a253$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $a7546bd84be9a253$var$getNode(taggedNode);
    !$a7546bd84be9a253$var$isUpdatableQuery(updatableQuery) && $bt114(false);
    return updatableQuery;
}
function $a7546bd84be9a253$var$getInlineDataFragment(taggedNode) {
    var fragment = $a7546bd84be9a253$var$getNode(taggedNode);
    !$a7546bd84be9a253$var$isInlineDataFragment(fragment) && $bt114(false);
    return fragment;
}
module.exports = {
    getFragment: $a7546bd84be9a253$var$getFragment,
    getNode: $a7546bd84be9a253$var$getNode,
    getPaginationFragment: $a7546bd84be9a253$var$getPaginationFragment,
    getRefetchableFragment: $a7546bd84be9a253$var$getRefetchableFragment,
    getRequest: $a7546bd84be9a253$var$getRequest,
    getUpdatableQuery: $a7546bd84be9a253$var$getUpdatableQuery,
    getInlineDataFragment: $a7546bd84be9a253$var$getInlineDataFragment,
    graphql: $a7546bd84be9a253$var$graphql,
    isFragment: $a7546bd84be9a253$var$isFragment,
    isRequest: $a7546bd84be9a253$var$isRequest,
    isUpdatableQuery: $a7546bd84be9a253$var$isUpdatableQuery,
    isInlineDataFragment: $a7546bd84be9a253$var$isInlineDataFragment
};

});
parcelRegister("7UmEy", function(module, exports) {
'use strict';
var $5c1f55d0782ba974$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $5c1f55d0782ba974$var$RelayConcreteNode;

});

parcelRegister("h4FgL", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $47tEu = parcelRequire("47tEu");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $c6e2d2a201e9e947$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $c6e2d2a201e9e947$var$warning = $47tEu;
module.exports = $c6e2d2a201e9e947$var$warning;

});
parcelRegister("47tEu", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $2ffed12a0ef38111$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $2ffed12a0ef38111$var$emptyFunction = function emptyFunction() {};
$2ffed12a0ef38111$var$emptyFunction.thatReturns = $2ffed12a0ef38111$var$makeEmptyFunction;
$2ffed12a0ef38111$var$emptyFunction.thatReturnsFalse = $2ffed12a0ef38111$var$makeEmptyFunction(false);
$2ffed12a0ef38111$var$emptyFunction.thatReturnsTrue = $2ffed12a0ef38111$var$makeEmptyFunction(true);
$2ffed12a0ef38111$var$emptyFunction.thatReturnsNull = $2ffed12a0ef38111$var$makeEmptyFunction(null);
$2ffed12a0ef38111$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$2ffed12a0ef38111$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $2ffed12a0ef38111$var$emptyFunction;

});



parcelRegister("gkcXR", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $be28920e89fa23bb$var$_interopRequireDefault = $vsDHM.default;

var $be28920e89fa23bb$var$_objectSpread2 = $be28920e89fa23bb$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $be28920e89fa23bb$var$_createForOfIteratorHelper2 = $be28920e89fa23bb$var$_interopRequireDefault((parcelRequire("itJC0")));

var $bt114 = parcelRequire("bt114");
function $be28920e89fa23bb$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $be28920e89fa23bb$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $be28920e89fa23bb$var$_objectSpread2["default"])((0, $be28920e89fa23bb$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $be28920e89fa23bb$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($be28920e89fa23bb$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $bt114(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $be28920e89fa23bb$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $be28920e89fa23bb$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $be28920e89fa23bb$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: $be28920e89fa23bb$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $be28920e89fa23bb$var$eventShouldThrow
};

});
parcelRegister("vsDHM", function(module, exports) {
function $05e91c8dfe5f480d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $05e91c8dfe5f480d$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5bEq2", function(module, exports) {

var $bpeOS = parcelRequire("bpeOS");
function $3c6d552f7d21364f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c6d552f7d21364f$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c6d552f7d21364f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bpeOS(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c6d552f7d21364f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $3c6d552f7d21364f$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bpeOS", function(module, exports) {

var $17baj = parcelRequire("17baj");
function $84dd865f5ffd96c2$var$_defineProperty(e, r, t) {
    return (r = $17baj(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $84dd865f5ffd96c2$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("17baj", function(module, exports) {

var $kH7Qm = parcelRequire("kH7Qm");
var $0cff1b1914c0e25e$var$_typeof = $kH7Qm.default;

var $lBkiI = parcelRequire("lBkiI");
function $0cff1b1914c0e25e$var$toPropertyKey(t) {
    var i = $lBkiI(t, "string");
    return "symbol" == $0cff1b1914c0e25e$var$_typeof(i) ? i : i + "";
}
module.exports = $0cff1b1914c0e25e$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kH7Qm", function(module, exports) {
function $f10de86235ee258f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $f10de86235ee258f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f10de86235ee258f$var$_typeof(o);
}
module.exports = $f10de86235ee258f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lBkiI", function(module, exports) {

var $kH7Qm = parcelRequire("kH7Qm");
var $fb9ccd0696e37dca$var$_typeof = $kH7Qm.default;
function $fb9ccd0696e37dca$var$toPrimitive(t, r) {
    if ("object" != $fb9ccd0696e37dca$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fb9ccd0696e37dca$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $fb9ccd0696e37dca$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("itJC0", function(module, exports) {

var $fVqBJ = parcelRequire("fVqBJ");
function $d73e5100386b8bf6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fVqBJ(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $d73e5100386b8bf6$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fVqBJ", function(module, exports) {

var $7K9vI = parcelRequire("7K9vI");
function $b980d1984a53949d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7K9vI(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7K9vI(r, a) : void 0;
    }
}
module.exports = $b980d1984a53949d$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7K9vI", function(module, exports) {
function $5a3434d9e35c53e0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $5a3434d9e35c53e0$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("7mhru", function(module, exports) {
'use strict';

var $5573k = parcelRequire("5573k");
var $55b81e2e1f38aa5e$var$getFragmentVariables = $5573k.getFragmentVariables;

var $axvNS = parcelRequire("axvNS");
var $55b81e2e1f38aa5e$var$CLIENT_EDGE_TRAVERSAL_PATH = $axvNS.CLIENT_EDGE_TRAVERSAL_PATH, $55b81e2e1f38aa5e$var$FRAGMENT_OWNER_KEY = $axvNS.FRAGMENT_OWNER_KEY, $55b81e2e1f38aa5e$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $axvNS.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $55b81e2e1f38aa5e$var$FRAGMENTS_KEY = $axvNS.FRAGMENTS_KEY, $55b81e2e1f38aa5e$var$ID_KEY = $axvNS.ID_KEY;

var $54oEM = parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $55b81e2e1f38aa5e$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $bt114(false);
    var dataID = item[$55b81e2e1f38aa5e$var$ID_KEY];
    var fragments = item[$55b81e2e1f38aa5e$var$FRAGMENTS_KEY];
    var mixedOwner = item[$55b81e2e1f38aa5e$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$55b81e2e1f38aa5e$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $55b81e2e1f38aa5e$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$55b81e2e1f38aa5e$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $55b81e2e1f38aa5e$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $55b81e2e1f38aa5e$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $55b81e2e1f38aa5e$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $55b81e2e1f38aa5e$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $bt114(false);
        return $55b81e2e1f38aa5e$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $bt114(false);
        return $55b81e2e1f38aa5e$var$getSingularSelector(fragment, item);
    }
}
function $55b81e2e1f38aa5e$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $55b81e2e1f38aa5e$var$getSelector(fragment, item);
    }
    return selectors;
}
function $55b81e2e1f38aa5e$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $55b81e2e1f38aa5e$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $55b81e2e1f38aa5e$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $bt114(false);
        return $55b81e2e1f38aa5e$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $bt114(false);
        return $55b81e2e1f38aa5e$var$getDataID(fragment, item);
    }
}
function $55b81e2e1f38aa5e$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $55b81e2e1f38aa5e$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $55b81e2e1f38aa5e$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $bt114(false);
    var dataID = item[$55b81e2e1f38aa5e$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $55b81e2e1f38aa5e$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $55b81e2e1f38aa5e$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $55b81e2e1f38aa5e$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $bt114(false);
        return $55b81e2e1f38aa5e$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $bt114(false);
        return $55b81e2e1f38aa5e$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $55b81e2e1f38aa5e$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $55b81e2e1f38aa5e$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $55b81e2e1f38aa5e$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $55b81e2e1f38aa5e$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $55b81e2e1f38aa5e$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $54oEM(thisSelector.variables, thatSelector.variables) && $55b81e2e1f38aa5e$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $55b81e2e1f38aa5e$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $55b81e2e1f38aa5e$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $54oEM(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $55b81e2e1f38aa5e$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $55b81e2e1f38aa5e$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $55b81e2e1f38aa5e$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $55b81e2e1f38aa5e$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $55b81e2e1f38aa5e$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $55b81e2e1f38aa5e$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $55b81e2e1f38aa5e$var$areEqualSelectors,
    createReaderSelector: $55b81e2e1f38aa5e$var$createReaderSelector,
    createNormalizationSelector: $55b81e2e1f38aa5e$var$createNormalizationSelector,
    getDataIDsFromFragment: $55b81e2e1f38aa5e$var$getDataIDsFromFragment,
    getDataIDsFromObject: $55b81e2e1f38aa5e$var$getDataIDsFromObject,
    getSingularSelector: $55b81e2e1f38aa5e$var$getSingularSelector,
    getPluralSelector: $55b81e2e1f38aa5e$var$getPluralSelector,
    getSelector: $55b81e2e1f38aa5e$var$getSelector,
    getSelectorsFromObject: $55b81e2e1f38aa5e$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $55b81e2e1f38aa5e$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $55b81e2e1f38aa5e$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $55b81e2e1f38aa5e$var$getVariablesFromFragment,
    getVariablesFromObject: $55b81e2e1f38aa5e$var$getVariablesFromObject
};

});
parcelRegister("5573k", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $3b32e3e63bae7180$var$_interopRequireDefault = $vsDHM.default;

var $3b32e3e63bae7180$var$_objectSpread2 = $3b32e3e63bae7180$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $axvNS = parcelRequire("axvNS");
var $3b32e3e63bae7180$var$getArgumentValues = $axvNS.getArgumentValues;

var $bt114 = parcelRequire("bt114");
function $3b32e3e63bae7180$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $3b32e3e63bae7180$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $bt114(false);
        }
    });
    return variables || argumentVariables;
}
function $3b32e3e63bae7180$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $3b32e3e63bae7180$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $3b32e3e63bae7180$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $3b32e3e63bae7180$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $3b32e3e63bae7180$var$getLocalVariables,
    getFragmentVariables: $3b32e3e63bae7180$var$getFragmentVariables,
    getOperationVariables: $3b32e3e63bae7180$var$getOperationVariables
};

});
parcelRegister("axvNS", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $7ac5a7ef7152892a$var$_interopRequireDefault = $vsDHM.default;

var $7ac5a7ef7152892a$var$_toConsumableArray2 = $7ac5a7ef7152892a$var$_interopRequireDefault((parcelRequire("8bSRK")));

var $hI54l = parcelRequire("hI54l");

var $7UmEy = parcelRequire("7UmEy");

var $1i6fU = parcelRequire("1i6fU");

var $abxbg = parcelRequire("abxbg");
var $7ac5a7ef7152892a$var$stableCopy = $abxbg.stableCopy;

var $bt114 = parcelRequire("bt114");
var $7ac5a7ef7152892a$var$VARIABLE = $7UmEy.VARIABLE, $7ac5a7ef7152892a$var$LITERAL = $7UmEy.LITERAL, $7ac5a7ef7152892a$var$OBJECT_VALUE = $7UmEy.OBJECT_VALUE, $7ac5a7ef7152892a$var$LIST_VALUE = $7UmEy.LIST_VALUE;
var $7ac5a7ef7152892a$var$ERRORS_KEY = '__errors';
var $7ac5a7ef7152892a$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $7ac5a7ef7152892a$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $7ac5a7ef7152892a$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $7ac5a7ef7152892a$var$getArgumentValue(arg, variables) {
    if (arg.kind === $7ac5a7ef7152892a$var$VARIABLE) return $7ac5a7ef7152892a$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $7ac5a7ef7152892a$var$LITERAL) return arg.value;
    else if (arg.kind === $7ac5a7ef7152892a$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $7ac5a7ef7152892a$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $7ac5a7ef7152892a$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($7ac5a7ef7152892a$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $7ac5a7ef7152892a$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$7ac5a7ef7152892a$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $7ac5a7ef7152892a$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $7ac5a7ef7152892a$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $hI54l(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $7ac5a7ef7152892a$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $7ac5a7ef7152892a$var$formatStorageKey(handleName, $7ac5a7ef7152892a$var$getArgumentValues(filterArgs, variables));
}
function $7ac5a7ef7152892a$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $7ac5a7ef7152892a$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $7ac5a7ef7152892a$var$formatStorageKey(name, $7ac5a7ef7152892a$var$getArgumentValues(args, variables)) : name;
}
function $7ac5a7ef7152892a$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $7ac5a7ef7152892a$var$getStorageKey(field, variables);
    return $1i6fU.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $7ac5a7ef7152892a$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $7ac5a7ef7152892a$var$getStableStorageKey(name, args) {
    return $7ac5a7ef7152892a$var$formatStorageKey(name, $7ac5a7ef7152892a$var$stableCopy(args));
}
function $7ac5a7ef7152892a$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $7ac5a7ef7152892a$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $bt114(false);
    return $7ac5a7ef7152892a$var$stableCopy(variables[name]);
}
function $7ac5a7ef7152892a$var$getModuleComponentKey(documentName) {
    return "".concat($7ac5a7ef7152892a$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $7ac5a7ef7152892a$var$getModuleOperationKey(documentName) {
    return "".concat($7ac5a7ef7152892a$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $7ac5a7ef7152892a$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $7ac5a7ef7152892a$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $7ac5a7ef7152892a$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $7ac5a7ef7152892a$var$formatStorageKey,
    getArgumentValue: $7ac5a7ef7152892a$var$getArgumentValue,
    getArgumentValues: $7ac5a7ef7152892a$var$getArgumentValues,
    getHandleStorageKey: $7ac5a7ef7152892a$var$getHandleStorageKey,
    getStorageKey: $7ac5a7ef7152892a$var$getStorageKey,
    getReadTimeResolverStorageKey: $7ac5a7ef7152892a$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $7ac5a7ef7152892a$var$getStableStorageKey,
    getModuleComponentKey: $7ac5a7ef7152892a$var$getModuleComponentKey,
    getModuleOperationKey: $7ac5a7ef7152892a$var$getModuleOperationKey
};
module.exports = $7ac5a7ef7152892a$var$RelayStoreUtils;

});
parcelRegister("8bSRK", function(module, exports) {

var $7p5cN = parcelRequire("7p5cN");

var $ct0hC = parcelRequire("ct0hC");

var $fVqBJ = parcelRequire("fVqBJ");

var $1eSxe = parcelRequire("1eSxe");
function $5f69e90561114c3b$var$_toConsumableArray(r) {
    return $7p5cN(r) || $ct0hC(r) || $fVqBJ(r) || $1eSxe();
}
module.exports = $5f69e90561114c3b$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7p5cN", function(module, exports) {

var $7K9vI = parcelRequire("7K9vI");
function $563ee7e933168dff$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7K9vI(r);
}
module.exports = $563ee7e933168dff$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ct0hC", function(module, exports) {
function $913869b4da415607$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $913869b4da415607$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1eSxe", function(module, exports) {
function $0e7166c0a273e687$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $0e7166c0a273e687$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hI54l", function(module, exports) {
'use strict';

var $aQVCW = parcelRequire("aQVCW");
var $ce4a7a5de5e7fc08$var$DEFAULT_HANDLE_KEY = $aQVCW.DEFAULT_HANDLE_KEY;

var $bt114 = parcelRequire("bt114");
function $ce4a7a5de5e7fc08$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $ce4a7a5de5e7fc08$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $bt114(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $ce4a7a5de5e7fc08$var$getRelayHandleKey;

});
parcelRegister("aQVCW", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("1i6fU", function(module, exports) {
'use strict';
var $0f0c531d6960ef3e$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = $0f0c531d6960ef3e$var$RelayFeatureFlags;

});

parcelRegister("abxbg", function(module, exports) {
'use strict';
function $76a4ab72b64f783f$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($76a4ab72b64f783f$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $76a4ab72b64f783f$var$stableCopy(value[keys[i]]);
    return stable;
}
function $76a4ab72b64f783f$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $76a4ab72b64f783f$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $76a4ab72b64f783f$var$stableCopy,
    hasCycle: $76a4ab72b64f783f$var$hasCycle
};

});



parcelRegister("54oEM", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $3b1073c3e745f70e$var$aStackPool = [];
var $3b1073c3e745f70e$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $3b1073c3e745f70e$var$areEqual(a, b) {
    var aStack = $3b1073c3e745f70e$var$aStackPool.length ? $3b1073c3e745f70e$var$aStackPool.pop() : [];
    var bStack = $3b1073c3e745f70e$var$bStackPool.length ? $3b1073c3e745f70e$var$bStackPool.pop() : [];
    var result = $3b1073c3e745f70e$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $3b1073c3e745f70e$var$aStackPool.push(aStack);
    $3b1073c3e745f70e$var$bStackPool.push(bStack);
    return result;
}
function $3b1073c3e745f70e$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$3b1073c3e745f70e$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$3b1073c3e745f70e$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $3b1073c3e745f70e$var$areEqual;

});




parcelRegister("iYIvU", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
var $dd105c1853b6bcaa$var$_interopRequireDefault = $vsDHM.default;

var $2PwAo = parcelRequire("2PwAo");
var $dd105c1853b6bcaa$require$_asyncToGenerator = $2PwAo.default;

var $dd105c1853b6bcaa$var$_createForOfIteratorHelper2 = $dd105c1853b6bcaa$var$_interopRequireDefault((parcelRequire("itJC0")));

var $147kh = parcelRequire("147kh");

var $1I87o = parcelRequire("1I87o");
var $dd105c1853b6bcaa$var$getObservableForActiveRequest = $1I87o.getObservableForActiveRequest;

var $emGVK = parcelRequire("emGVK");
var $dd105c1853b6bcaa$var$getFragment = $emGVK.getFragment;

var $gkcXR = parcelRequire("gkcXR");
var $dd105c1853b6bcaa$var$handlePotentialSnapshotErrors = $gkcXR.handlePotentialSnapshotErrors;

var $7mhru = parcelRequire("7mhru");
var $dd105c1853b6bcaa$var$getSelector = $7mhru.getSelector;

var $bt114 = parcelRequire("bt114");
function $dd105c1853b6bcaa$var$waitForFragmentData(_x, _x2, _x3) {
    return $dd105c1853b6bcaa$var$_waitForFragmentData.apply(this, arguments);
}
function $dd105c1853b6bcaa$var$_waitForFragmentData() {
    $dd105c1853b6bcaa$var$_waitForFragmentData = $dd105c1853b6bcaa$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $dd105c1853b6bcaa$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $dd105c1853b6bcaa$var$_waitForFragmentData.apply(this, arguments);
}
function $dd105c1853b6bcaa$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $dd105c1853b6bcaa$var$getFragment(fragment);
    var fragmentSelector = $dd105c1853b6bcaa$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $bt114(false);
    !(fragmentSelector != null) && $bt114(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $dd105c1853b6bcaa$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $dd105c1853b6bcaa$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $bt114(false);
}
function $dd105c1853b6bcaa$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $147kh.create(function(sink) {
        sink.next($dd105c1853b6bcaa$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($dd105c1853b6bcaa$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $dd105c1853b6bcaa$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $147kh.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $dd105c1853b6bcaa$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($dd105c1853b6bcaa$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $dd105c1853b6bcaa$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($dd105c1853b6bcaa$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $dd105c1853b6bcaa$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($dd105c1853b6bcaa$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $dd105c1853b6bcaa$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $bt114(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $dd105c1853b6bcaa$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $dd105c1853b6bcaa$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $dd105c1853b6bcaa$var$observeFragment,
    waitForFragmentData: $dd105c1853b6bcaa$var$waitForFragmentData
};

});
parcelRegister("2PwAo", function(module, exports) {
function $20f99f1afb23b337$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $20f99f1afb23b337$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $20f99f1afb23b337$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $20f99f1afb23b337$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $20f99f1afb23b337$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("147kh", function(module, exports) {
'use strict';

var $lAaCv = parcelRequire("lAaCv");
var $0c6bd8f5670a097a$var$hostReportError = $0c6bd8f5670a097a$var$swallowError;
var $0c6bd8f5670a097a$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $0c6bd8f5670a097a$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $0c6bd8f5670a097a$var$isObservable(obj) ? $0c6bd8f5670a097a$var$fromObservable(obj) : $lAaCv(obj) ? $0c6bd8f5670a097a$var$fromPromise(obj) : $0c6bd8f5670a097a$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $0c6bd8f5670a097a$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $0c6bd8f5670a097a$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $0c6bd8f5670a097a$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $0c6bd8f5670a097a$var$fromObservable(obj) {
    return obj instanceof $0c6bd8f5670a097a$var$RelayObservable ? obj : $0c6bd8f5670a097a$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $0c6bd8f5670a097a$var$fromPromise(promise) {
    return $0c6bd8f5670a097a$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $0c6bd8f5670a097a$var$fromValue(value) {
    return $0c6bd8f5670a097a$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $0c6bd8f5670a097a$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $0c6bd8f5670a097a$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $0c6bd8f5670a097a$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $0c6bd8f5670a097a$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $0c6bd8f5670a097a$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $0c6bd8f5670a097a$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $0c6bd8f5670a097a$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $0c6bd8f5670a097a$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $0c6bd8f5670a097a$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $0c6bd8f5670a097a$var$RelayObservable;

});
parcelRegister("lAaCv", function(module, exports) {
'use strict';
function $fb6532ac1fa531cf$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $fb6532ac1fa531cf$var$isPromise;

});


parcelRegister("1I87o", function(module, exports) {
'use strict';

var $147kh = parcelRequire("147kh");

var $0ebxq = parcelRequire("0ebxq");

var $bt114 = parcelRequire("bt114");
var $13f0329e413ad38d$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $13f0329e413ad38d$var$requestCachesByEnvironment = $13f0329e413ad38d$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $13f0329e413ad38d$var$fetchQuery(environment, operation) {
    return $13f0329e413ad38d$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $13f0329e413ad38d$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $147kh.create(function(sink) {
        var requestCache = $13f0329e413ad38d$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $0ebxq(),
                    subjectForInFlightStatus: new $0ebxq(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $13f0329e413ad38d$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $13f0329e413ad38d$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $13f0329e413ad38d$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $13f0329e413ad38d$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $bt114(false);
        return $13f0329e413ad38d$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $13f0329e413ad38d$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $147kh.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $13f0329e413ad38d$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $147kh.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $13f0329e413ad38d$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $13f0329e413ad38d$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $13f0329e413ad38d$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $13f0329e413ad38d$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $13f0329e413ad38d$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $13f0329e413ad38d$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $13f0329e413ad38d$var$getRequestCache(environment) {
    var cached = $13f0329e413ad38d$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $13f0329e413ad38d$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $13f0329e413ad38d$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $bt114(false);
    return cached;
}
module.exports = {
    fetchQuery: $13f0329e413ad38d$var$fetchQuery,
    fetchQueryDeduped: $13f0329e413ad38d$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $13f0329e413ad38d$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $13f0329e413ad38d$var$getObservableForActiveRequest
};

});
parcelRegister("0ebxq", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $000b01112854c7ca$var$_interopRequireDefault = $vsDHM.default;

var $000b01112854c7ca$var$_createForOfIteratorHelper2 = $000b01112854c7ca$var$_interopRequireDefault((parcelRequire("itJC0")));

var $000b01112854c7ca$var$_defineProperty2 = $000b01112854c7ca$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $147kh = parcelRequire("147kh");

var $bt114 = parcelRequire("bt114");
var $000b01112854c7ca$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $000b01112854c7ca$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $000b01112854c7ca$var$_defineProperty2["default"])(this, "_events", []);
        (0, $000b01112854c7ca$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $000b01112854c7ca$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $147kh.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $bt114(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $000b01112854c7ca$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $000b01112854c7ca$var$RelayReplaySubject;

});



parcelRegister("g50Vu", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $bb4dd4ed6d99b26f$var$_interopRequireDefault = $vsDHM.default;

var $bb4dd4ed6d99b26f$var$_defineProperty2 = $bb4dd4ed6d99b26f$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $iYIvU = parcelRequire("iYIvU");
var $bb4dd4ed6d99b26f$var$observeFragment = $iYIvU.observeFragment;

var $bt5FL = parcelRequire("bt5FL");
var $bb4dd4ed6d99b26f$var$createOperationDescriptor = $bt5FL.createOperationDescriptor;
function $bb4dd4ed6d99b26f$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $bb4dd4ed6d99b26f$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $bb4dd4ed6d99b26f$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return $bb4dd4ed6d99b26f$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $bb4dd4ed6d99b26f$var$observeQuery
};

});
parcelRegister("bt5FL", function(module, exports) {
'use strict';
parcelRequire("hls5V");

var $k5XXK = parcelRequire("k5XXK");

var $1i6fU = parcelRequire("1i6fU");

var $abxbg = parcelRequire("abxbg");
var $8596cd9b0c30aa89$var$hasCycle = $abxbg.hasCycle;

var $5573k = parcelRequire("5573k");
var $8596cd9b0c30aa89$var$getOperationVariables = $5573k.getOperationVariables;

var $7mhru = parcelRequire("7mhru");
var $8596cd9b0c30aa89$var$createNormalizationSelector = $7mhru.createNormalizationSelector, $8596cd9b0c30aa89$var$createReaderSelector = $7mhru.createReaderSelector;

var $axvNS = parcelRequire("axvNS");
var $8596cd9b0c30aa89$var$ROOT_ID = $axvNS.ROOT_ID;

var $bt114 = parcelRequire("bt114");
function $8596cd9b0c30aa89$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $8596cd9b0c30aa89$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $8596cd9b0c30aa89$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($1i6fU.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$8596cd9b0c30aa89$var$hasCycle(operationVariables) && $bt114(false);
    var requestDescriptor = $8596cd9b0c30aa89$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $8596cd9b0c30aa89$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $8596cd9b0c30aa89$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $8596cd9b0c30aa89$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $k5XXK(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $8596cd9b0c30aa89$var$createOperationDescriptor,
    createRequestDescriptor: $8596cd9b0c30aa89$var$createRequestDescriptor
};

});
parcelRegister("hls5V", function(module, exports) {
'use strict';
function $ca0a30d8dd4440a8$var$deepFreeze(object) {
    if (!$ca0a30d8dd4440a8$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $ca0a30d8dd4440a8$var$deepFreeze(property);
    });
    return object;
}
function $ca0a30d8dd4440a8$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $ca0a30d8dd4440a8$var$deepFreeze;

});

parcelRegister("k5XXK", function(module, exports) {
'use strict';

var $abxbg = parcelRequire("abxbg");
var $03c67f1f5feba820$var$stableCopy = $abxbg.stableCopy;

var $bt114 = parcelRequire("bt114");
function $03c67f1f5feba820$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $bt114(false);
    return requestID + JSON.stringify($03c67f1f5feba820$var$stableCopy(variables));
}
module.exports = $03c67f1f5feba820$var$getRequestIdentifier;

});



parcelRegister("dHKe9", function(module, exports) {
"use strict";

var $2PwAo = parcelRequire("2PwAo");
var $9fa326447b91a4b4$require$_asyncToGenerator = $2PwAo.default;

var $iYIvU = parcelRequire("iYIvU");
var $9fa326447b91a4b4$var$observeFragment = $iYIvU.observeFragment;
function $9fa326447b91a4b4$var$waitForFragmentData(_x, _x2, _x3) {
    return $9fa326447b91a4b4$var$_waitForFragmentData.apply(this, arguments);
}
function $9fa326447b91a4b4$var$_waitForFragmentData() {
    $9fa326447b91a4b4$var$_waitForFragmentData = $9fa326447b91a4b4$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $9fa326447b91a4b4$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $9fa326447b91a4b4$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $9fa326447b91a4b4$var$waitForFragmentData
};

});


parcelRegister("j1oma", function(module, exports) {
'use strict';

var $fuThW = parcelRequire("fuThW");
var $dd910101078a81f3$var$generateClientID = $fuThW.generateClientID;

var $axvNS = parcelRequire("axvNS");
var $dd910101078a81f3$var$getStableStorageKey = $axvNS.getStableStorageKey;

var $hI54l = parcelRequire("hI54l");

var $kqQfT = parcelRequire("kqQfT");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
var $dd910101078a81f3$var$CONNECTION = 'connection';
var $dd910101078a81f3$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $dd910101078a81f3$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $kqQfT.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $dd910101078a81f3$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $dd910101078a81f3$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $dd910101078a81f3$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($dd910101078a81f3$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $dd910101078a81f3$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $dd910101078a81f3$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $dd910101078a81f3$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $dd910101078a81f3$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $dd910101078a81f3$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $dd910101078a81f3$var$getConnection(record, key, filters) {
    var handleKey = $hI54l($dd910101078a81f3$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $dd910101078a81f3$var$getConnectionID(recordID, key, filters) {
    var handleKey = $hI54l($dd910101078a81f3$var$CONNECTION, key, null);
    var storageKey = $dd910101078a81f3$var$getStableStorageKey(handleKey, filters);
    return $dd910101078a81f3$var$generateClientID(recordID, storageKey);
}
function $dd910101078a81f3$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $kqQfT.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $dd910101078a81f3$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $kqQfT.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $dd910101078a81f3$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $dd910101078a81f3$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $kqQfT.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $dd910101078a81f3$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $kqQfT.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $dd910101078a81f3$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $kqQfT.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($dd910101078a81f3$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $bt114(false);
    var edgeID = $dd910101078a81f3$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $dd910101078a81f3$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $dd910101078a81f3$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $kqQfT.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $dd910101078a81f3$var$buildConnectionEdge,
    createEdge: $dd910101078a81f3$var$createEdge,
    deleteNode: $dd910101078a81f3$var$deleteNode,
    getConnection: $dd910101078a81f3$var$getConnection,
    getConnectionID: $dd910101078a81f3$var$getConnectionID,
    insertEdgeAfter: $dd910101078a81f3$var$insertEdgeAfter,
    insertEdgeBefore: $dd910101078a81f3$var$insertEdgeBefore,
    update: $dd910101078a81f3$var$update
};

});
parcelRegister("fuThW", function(module, exports) {
'use strict';

var $1i6fU = parcelRequire("1i6fU");

var $jrEzK = parcelRequire("jrEzK");
var $b4848b8009496e19$var$intern = $jrEzK.intern;
var $b4848b8009496e19$var$PREFIX = 'client:';
function $b4848b8009496e19$var$generateClientID(id, storageKey, index) {
    var internedId = $1i6fU.STRING_INTERN_LEVEL <= 0 ? id : $b4848b8009496e19$var$intern(id, $1i6fU.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($b4848b8009496e19$var$PREFIX) !== 0) key = $b4848b8009496e19$var$PREFIX + key;
    return key;
}
function $b4848b8009496e19$var$isClientID(id) {
    return id.indexOf($b4848b8009496e19$var$PREFIX) === 0;
}
var $b4848b8009496e19$var$localID = 0;
function $b4848b8009496e19$var$generateUniqueClientID() {
    return "".concat($b4848b8009496e19$var$PREFIX, "local:").concat($b4848b8009496e19$var$localID++);
}
function $b4848b8009496e19$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($b4848b8009496e19$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $b4848b8009496e19$var$generateClientID,
    generateClientObjectClientID: $b4848b8009496e19$var$generateClientObjectClientID,
    generateUniqueClientID: $b4848b8009496e19$var$generateUniqueClientID,
    isClientID: $b4848b8009496e19$var$isClientID
};

});
parcelRegister("jrEzK", function(module, exports) {
'use strict';
var $e2800360f7b8a971$var$internTable = new Map();
var $e2800360f7b8a971$var$nextIndex = 1;
var $e2800360f7b8a971$var$digits = $e2800360f7b8a971$var$initDigitTable();
var $e2800360f7b8a971$var$INTERN_PREFIX = '\t';
var $e2800360f7b8a971$var$ESCAPE_PREFIX = '\v';
function $e2800360f7b8a971$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $e2800360f7b8a971$var$escape(str) {
    if (str[0] === $e2800360f7b8a971$var$INTERN_PREFIX && $e2800360f7b8a971$var$digits.has(str[1]) || str[0] === $e2800360f7b8a971$var$ESCAPE_PREFIX) return $e2800360f7b8a971$var$ESCAPE_PREFIX + str;
    return str;
}
function $e2800360f7b8a971$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $e2800360f7b8a971$var$escape(str);
    var internedString = $e2800360f7b8a971$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $e2800360f7b8a971$var$INTERN_PREFIX + $e2800360f7b8a971$var$nextIndex++;
    $e2800360f7b8a971$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $e2800360f7b8a971$var$intern
};

});


parcelRegister("kqQfT", function(module, exports) {
'use strict';
var $edfec52f12e0f682$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $edfec52f12e0f682$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $edfec52f12e0f682$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $edfec52f12e0f682$var$config = newConfig;
    },
    get: function get() {
        return $edfec52f12e0f682$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $edfec52f12e0f682$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $edfec52f12e0f682$var$ConnectionInterface;

});


parcelRegister("3Ejbt", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $2a83fd116af5f898$var$_interopRequireDefault = $vsDHM.default;

var $2a83fd116af5f898$var$_createForOfIteratorHelper2 = $2a83fd116af5f898$var$_interopRequireDefault((parcelRequire("itJC0")));

var $j1oma = parcelRequire("j1oma");

var $kqQfT = parcelRequire("kqQfT");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
var $2a83fd116af5f898$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $2a83fd116af5f898$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $bt114(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $2a83fd116af5f898$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $j1oma.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $2a83fd116af5f898$var$AppendEdgeHandler = {
    update: $2a83fd116af5f898$var$edgeUpdater($j1oma.insertEdgeAfter)
};
var $2a83fd116af5f898$var$PrependEdgeHandler = {
    update: $2a83fd116af5f898$var$edgeUpdater($j1oma.insertEdgeBefore)
};
var $2a83fd116af5f898$var$AppendNodeHandler = {
    update: $2a83fd116af5f898$var$nodeUpdater($j1oma.insertEdgeAfter)
};
var $2a83fd116af5f898$var$PrependNodeHandler = {
    update: $2a83fd116af5f898$var$nodeUpdater($j1oma.insertEdgeBefore)
};
function $2a83fd116af5f898$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $bt114(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $kqQfT.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $2a83fd116af5f898$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $2a83fd116af5f898$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $j1oma.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $bt114(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $2a83fd116af5f898$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $bt114(false);
        !(edgeTypeName != null) && $bt114(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $kqQfT.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $2a83fd116af5f898$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $2a83fd116af5f898$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $j1oma.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $bt114(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $2a83fd116af5f898$var$AppendEdgeHandler,
    DeleteRecordHandler: $2a83fd116af5f898$var$DeleteRecordHandler,
    PrependEdgeHandler: $2a83fd116af5f898$var$PrependEdgeHandler,
    AppendNodeHandler: $2a83fd116af5f898$var$AppendNodeHandler,
    PrependNodeHandler: $2a83fd116af5f898$var$PrependNodeHandler,
    DeleteEdgeHandler: $2a83fd116af5f898$var$DeleteEdgeHandler
};

});

parcelRegister("b2H0r", function(module, exports) {
'use strict';

var $j1oma = parcelRequire("j1oma");

var $3Ejbt = parcelRequire("3Ejbt");

var $bt114 = parcelRequire("bt114");
function $02131de639c52195$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $j1oma;
        case 'deleteRecord':
            return $3Ejbt.DeleteRecordHandler;
        case 'deleteEdge':
            return $3Ejbt.DeleteEdgeHandler;
        case 'appendEdge':
            return $3Ejbt.AppendEdgeHandler;
        case 'prependEdge':
            return $3Ejbt.PrependEdgeHandler;
        case 'appendNode':
            return $3Ejbt.AppendNodeHandler;
        case 'prependNode':
            return $3Ejbt.PrependNodeHandler;
    }
    $bt114(false);
}
module.exports = $02131de639c52195$var$RelayDefaultHandlerProvider;

});

parcelRegister("hjIph", function(module, exports) {
'use strict';

var $emGVK = parcelRequire("emGVK");
var $c9b6a8427d4f6519$var$getRequest = $emGVK.getRequest;

var $hDQtO = parcelRequire("hDQtO");

var $bt5FL = parcelRequire("bt5FL");
var $c9b6a8427d4f6519$var$createOperationDescriptor = $bt5FL.createOperationDescriptor;

var $2xVPy = parcelRequire("2xVPy");

var $bt114 = parcelRequire("bt114");
function $c9b6a8427d4f6519$var$applyOptimisticMutation(environment, config) {
    !$hDQtO(environment) && $bt114(false);
    var mutation = $c9b6a8427d4f6519$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $c9b6a8427d4f6519$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $2xVPy.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $c9b6a8427d4f6519$var$applyOptimisticMutation;

});
parcelRegister("hDQtO", function(module, exports) {
'use strict';
function $03507f1f5f10c279$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $03507f1f5f10c279$var$isRelayModernEnvironment;

});

parcelRegister("2xVPy", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $1dab85c4281cd08c$var$_interopRequireDefault = $vsDHM.default;

var $1dab85c4281cd08c$var$_createForOfIteratorHelper2 = $1dab85c4281cd08c$var$_interopRequireDefault((parcelRequire("itJC0")));

var $j1oma = parcelRequire("j1oma");
parcelRequire("h4FgL");
var $1dab85c4281cd08c$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $1dab85c4281cd08c$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $1dab85c4281cd08c$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $1dab85c4281cd08c$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $1dab85c4281cd08c$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $1dab85c4281cd08c$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $1dab85c4281cd08c$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $1dab85c4281cd08c$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $1dab85c4281cd08c$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $1dab85c4281cd08c$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $1dab85c4281cd08c$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $j1oma.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $j1oma.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $j1oma.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $j1oma.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $1dab85c4281cd08c$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $1dab85c4281cd08c$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $1dab85c4281cd08c$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $1dab85c4281cd08c$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $1dab85c4281cd08c$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $1dab85c4281cd08c$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $j1oma.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $j1oma.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $1dab85c4281cd08c$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $1dab85c4281cd08c$var$MutationTypes,
    RangeOperations: $1dab85c4281cd08c$var$RangeOperations,
    convert: $1dab85c4281cd08c$var$convert
};

});


parcelRegister("i4ACq", function(module, exports) {
'use strict';
function $d2850172ef1a17bd$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $d2850172ef1a17bd$var$commitLocalUpdate;

});

parcelRegister("91ZvW", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $6933ec76750ce734$var$_interopRequireDefault = $vsDHM.default;

var $6933ec76750ce734$var$_toConsumableArray2 = $6933ec76750ce734$var$_interopRequireDefault((parcelRequire("8bSRK")));

var $emGVK = parcelRequire("emGVK");
var $6933ec76750ce734$var$getRequest = $emGVK.getRequest;

var $fuThW = parcelRequire("fuThW");
var $6933ec76750ce734$var$generateUniqueClientID = $fuThW.generateUniqueClientID;

var $hDQtO = parcelRequire("hDQtO");

var $bt5FL = parcelRequire("bt5FL");
var $6933ec76750ce734$var$createOperationDescriptor = $bt5FL.createOperationDescriptor;

var $2xVPy = parcelRequire("2xVPy");
parcelRequire("ff4lu");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $6933ec76750ce734$var$commitMutation(environment, config) {
    !$hDQtO(environment) && $bt114(false);
    var mutation = $6933ec76750ce734$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $6933ec76750ce734$var$createOperationDescriptor(mutation, variables, cacheConfig, $6933ec76750ce734$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $2xVPy.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $6933ec76750ce734$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $6933ec76750ce734$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $6933ec76750ce734$var$commitMutation;

});
parcelRegister("ff4lu", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $b18ba0a86c2fded1$var$_interopRequireDefault = $vsDHM.default;

var $b18ba0a86c2fded1$var$_objectSpread2 = $b18ba0a86c2fded1$var$_interopRequireDefault((parcelRequire("5bEq2")));
parcelRequire("h4FgL");
var $b18ba0a86c2fded1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b18ba0a86c2fded1$var$validateMutation = function validateMutation() {};
var $b18ba0a86c2fded1$var$addFieldToDiff, $b18ba0a86c2fded1$var$validateSelections, $b18ba0a86c2fded1$var$validateSelection, $b18ba0a86c2fded1$var$validateModuleImport, $b18ba0a86c2fded1$var$validateAbstractKey, $b18ba0a86c2fded1$var$validateField, $b18ba0a86c2fded1$var$validateOptimisticResponse;
module.exports = $b18ba0a86c2fded1$var$validateMutation;

});


parcelRegister("8qCM6", function(module, exports) {
'use strict';

var $kXyrn = parcelRequire("kXyrn");

var $iayNg = parcelRequire("iayNg");
var $622ed455ad8c280c$var$convertFetch = $iayNg.convertFetch;

var $bt114 = parcelRequire("bt114");
function $622ed455ad8c280c$var$create(fetchFn, subscribe) {
    var observeFetch = $622ed455ad8c280c$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $kXyrn(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $bt114(false);
            !!uploadables && $bt114(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $bt114(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $622ed455ad8c280c$var$create
};

});
parcelRegister("kXyrn", function(module, exports) {
'use strict';
parcelRequire("54oEM");
parcelRequire("h4FgL");
var $f424088729d6d518$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $f424088729d6d518$var$debugCache = $f424088729d6d518$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $f424088729d6d518$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$f424088729d6d518$var$debugCache.has(providerFunction)) {
                $f424088729d6d518$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $f424088729d6d518$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$f424088729d6d518$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $f424088729d6d518$var$withProvidedVariables;

});

parcelRegister("iayNg", function(module, exports) {
'use strict';

var $147kh = parcelRequire("147kh");
function $d3a4266f08edd00e$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $147kh.create(function(sink) {
            return sink.error(result);
        });
        return $147kh.from(result);
    };
}
module.exports = {
    convertFetch: $d3a4266f08edd00e$var$convertFetch
};

});


parcelRegister("blGZ1", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $8432ff75de4d21d8$var$_interopRequireDefault = $vsDHM.default;

var $8432ff75de4d21d8$var$_objectSpread2 = $8432ff75de4d21d8$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $abxbg = parcelRequire("abxbg");
var $8432ff75de4d21d8$var$stableCopy = $abxbg.stableCopy;

var $bt114 = parcelRequire("bt114");
var $8432ff75de4d21d8$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $bt114(false);
        !(ttl > 0) && $bt114(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $8432ff75de4d21d8$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$8432ff75de4d21d8$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $8432ff75de4d21d8$var$_objectSpread2["default"])((0, $8432ff75de4d21d8$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $8432ff75de4d21d8$var$_objectSpread2["default"])((0, $8432ff75de4d21d8$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $8432ff75de4d21d8$var$_objectSpread2["default"])((0, $8432ff75de4d21d8$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $8432ff75de4d21d8$var$_objectSpread2["default"])((0, $8432ff75de4d21d8$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $8432ff75de4d21d8$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $8432ff75de4d21d8$var$getCacheKey(queryID, variables) {
    return JSON.stringify($8432ff75de4d21d8$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $8432ff75de4d21d8$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $8432ff75de4d21d8$var$RelayQueryResponseCache;

});

parcelRegister("kBdRw", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $eff204203a9cc6e7$var$_interopRequireDefault = $vsDHM.default;

var $eff204203a9cc6e7$var$_objectSpread2 = $eff204203a9cc6e7$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $147kh = parcelRequire("147kh");

var $bt5FL = parcelRequire("bt5FL");
var $eff204203a9cc6e7$var$createOperationDescriptor = $bt5FL.createOperationDescriptor;

var $gkcXR = parcelRequire("gkcXR");
var $eff204203a9cc6e7$var$handlePotentialSnapshotErrors = $gkcXR.handlePotentialSnapshotErrors;

var $1I87o = parcelRequire("1I87o");

var $emGVK = parcelRequire("emGVK");
var $eff204203a9cc6e7$var$getRequest = $emGVK.getRequest;

var $bt114 = parcelRequire("bt114");
function $eff204203a9cc6e7$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $eff204203a9cc6e7$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $bt114(false);
    var networkCacheConfig = (0, $eff204203a9cc6e7$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $eff204203a9cc6e7$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $eff204203a9cc6e7$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $eff204203a9cc6e7$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $147kh.from(environment.lookup(operation.fragment)).map(readData);
            return $eff204203a9cc6e7$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $eff204203a9cc6e7$var$getNetworkObservable(environment, operation) {
    return $1I87o.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $eff204203a9cc6e7$var$fetchQuery;

});

parcelRegister("4qfpy", function(module, exports) {
'use strict';

var $bt5FL = parcelRequire("bt5FL");
var $33858b73881d6227$var$createOperationDescriptor = $bt5FL.createOperationDescriptor;

var $emGVK = parcelRequire("emGVK");
var $33858b73881d6227$var$getRequest = $emGVK.getRequest;
function $33858b73881d6227$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $33858b73881d6227$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $33858b73881d6227$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $33858b73881d6227$var$fetchQuery_DEPRECATED;

});

parcelRegister("hJbo4", function(module, exports) {
'use strict';
var $ce7f78e863a522ed$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $ce7f78e863a522ed$var$preloadableQueryRegistry = new $ce7f78e863a522ed$var$PreloadableQueryRegistry();
module.exports = $ce7f78e863a522ed$var$preloadableQueryRegistry;

});

parcelRegister("8azUy", function(module, exports) {
'use strict';

var $4u9x1 = parcelRequire("4u9x1");
parcelRequire("h4FgL");
function $5f2b1d1722a98e3b$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $4u9x1(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $5f2b1d1722a98e3b$var$createFragmentSpecResolver;

});
parcelRegister("4u9x1", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $34415b864ea65958$var$_interopRequireDefault = $vsDHM.default;

var $34415b864ea65958$var$_objectSpread2 = $34415b864ea65958$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $34415b864ea65958$var$_defineProperty2 = $34415b864ea65958$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $jJOFW = parcelRequire("jJOFW");

var $gkcXR = parcelRequire("gkcXR");
var $34415b864ea65958$var$handlePotentialSnapshotErrors = $gkcXR.handlePotentialSnapshotErrors;

var $giHAT = parcelRequire("giHAT");

var $2tzVZ = parcelRequire("2tzVZ");

var $1i6fU = parcelRequire("1i6fU");

var $bt5FL = parcelRequire("bt5FL");
var $34415b864ea65958$var$createRequestDescriptor = $bt5FL.createRequestDescriptor;

var $7mhru = parcelRequire("7mhru");
var $34415b864ea65958$var$areEqualSelectors = $7mhru.areEqualSelectors, $34415b864ea65958$var$createReaderSelector = $7mhru.createReaderSelector, $34415b864ea65958$var$getSelectorsFromObject = $7mhru.getSelectorsFromObject;

var $54oEM = parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
var $34415b864ea65958$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $34415b864ea65958$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $34415b864ea65958$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $34415b864ea65958$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$giHAT(_nextItem, prevItem)) {
                        nextData = nextData || (0, $34415b864ea65958$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($1i6fU.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $34415b864ea65958$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $34415b864ea65958$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $34415b864ea65958$var$SelectorListResolver) && $bt114(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $34415b864ea65958$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $34415b864ea65958$var$SelectorResolver) && $bt114(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $34415b864ea65958$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $34415b864ea65958$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($1i6fU.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $jJOFW(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $34415b864ea65958$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $34415b864ea65958$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $2tzVZ(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($54oEM(variables, this._selector.variables)) return;
        var requestDescriptor = $34415b864ea65958$var$createRequestDescriptor(request, variables);
        var selector = $34415b864ea65958$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $34415b864ea65958$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $34415b864ea65958$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($34415b864ea65958$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $34415b864ea65958$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $34415b864ea65958$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $34415b864ea65958$var$RelayModernFragmentSpecResolver;

});
parcelRegister("jJOFW", function(module, exports) {
'use strict';

var $1I87o = parcelRequire("1I87o");
var $e5e9875e5d001492$var$getPromiseForActiveRequest = $1I87o.getPromiseForActiveRequest;
function $e5e9875e5d001492$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $e5e9875e5d001492$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $e5e9875e5d001492$var$getPendingOperationsForFragment;

});

parcelRegister("giHAT", function(module, exports) {
'use strict';
function $bde024a988ef33c3$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $bde024a988ef33c3$var$isScalarAndEqual;

});

parcelRegister("2tzVZ", function(module, exports) {
'use strict';
function $1cda2a03a0de93ea$var$recycleNodesInto(prevData, nextData) {
    return $1cda2a03a0de93ea$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $1cda2a03a0de93ea$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $1cda2a03a0de93ea$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $1cda2a03a0de93ea$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $1cda2a03a0de93ea$var$recycleNodesInto;

});



parcelRegister("27rIu", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");
var $18b1bc2c0fcd1bc6$var$relayContext;
var $18b1bc2c0fcd1bc6$var$firstReact;
function $18b1bc2c0fcd1bc6$var$createRelayContext(react) {
    if (!$18b1bc2c0fcd1bc6$var$relayContext) {
        $18b1bc2c0fcd1bc6$var$relayContext = react.createContext(null);
        $18b1bc2c0fcd1bc6$var$firstReact = react;
    }
    !(react === $18b1bc2c0fcd1bc6$var$firstReact) && $bt114(false);
    return $18b1bc2c0fcd1bc6$var$relayContext;
}
module.exports = $18b1bc2c0fcd1bc6$var$createRelayContext;

});

parcelRegister("kZ5Nx", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");
var $f46e00833e3771fb$var$relayLoggingContext;
var $f46e00833e3771fb$var$firstReact;
function $f46e00833e3771fb$var$createRelayLoggingContext(react) {
    if (!$f46e00833e3771fb$var$relayLoggingContext) {
        $f46e00833e3771fb$var$relayLoggingContext = react.createContext(null);
        $f46e00833e3771fb$var$firstReact = react;
    }
    !(react === $f46e00833e3771fb$var$firstReact) && $bt114(false);
    return $f46e00833e3771fb$var$relayLoggingContext;
}
module.exports = $f46e00833e3771fb$var$createRelayLoggingContext;

});

parcelRegister("kXikJ", function(module, exports) {
'use strict';
var $f41789f89b4e89fb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $f41789f89b4e89fb$var$suspenseSentinel() {
    return $f41789f89b4e89fb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $f41789f89b4e89fb$var$isSuspenseSentinel(value) {
    return value === $f41789f89b4e89fb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $f41789f89b4e89fb$var$isSuspenseSentinel,
    suspenseSentinel: $f41789f89b4e89fb$var$suspenseSentinel
};

});

parcelRegister("ceVKc", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $8e93959bf95b9176$var$_interopRequireDefault = $vsDHM.default;

var $8e93959bf95b9176$var$_objectSpread2 = $8e93959bf95b9176$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $8e93959bf95b9176$var$_RelayModernRecord = $8e93959bf95b9176$var$_interopRequireDefault((parcelRequire("2Yj88")));

var $8e93959bf95b9176$var$_RelayRecordSource = $8e93959bf95b9176$var$_interopRequireDefault((parcelRequire("6Ip1f")));

var $8e93959bf95b9176$var$_RelayResponseNormalizer = $8e93959bf95b9176$var$_interopRequireDefault((parcelRequire("2rhVW")));
function $8e93959bf95b9176$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $8e93959bf95b9176$var$_RelayRecordSource["default"].create();
    var record = $8e93959bf95b9176$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $8e93959bf95b9176$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $8e93959bf95b9176$var$_objectSpread2["default"])((0, $8e93959bf95b9176$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $8e93959bf95b9176$var$normalizeResponse;

});
parcelRegister("2Yj88", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $22a00640aa3708ae$var$_interopRequireDefault = $vsDHM.default;

var $22a00640aa3708ae$var$_defineProperty2 = $22a00640aa3708ae$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $22a00640aa3708ae$var$_objectWithoutPropertiesLoose2 = $22a00640aa3708ae$var$_interopRequireDefault((parcelRequire("g4Uat")));

var $22a00640aa3708ae$var$_toPropertyKey2 = $22a00640aa3708ae$var$_interopRequireDefault((parcelRequire("17baj")));

var $22a00640aa3708ae$var$_objectSpread2 = $22a00640aa3708ae$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $hls5V = parcelRequire("hls5V");

var $fuThW = parcelRequire("fuThW");
var $22a00640aa3708ae$var$generateClientObjectClientID = $fuThW.generateClientObjectClientID, $22a00640aa3708ae$var$isClientID = $fuThW.isClientID;

var $kXikJ = parcelRequire("kXikJ");
var $22a00640aa3708ae$var$isSuspenseSentinel = $kXikJ.isSuspenseSentinel;

var $axvNS = parcelRequire("axvNS");
var $22a00640aa3708ae$var$ACTOR_IDENTIFIER_KEY = $axvNS.ACTOR_IDENTIFIER_KEY, $22a00640aa3708ae$var$ERRORS_KEY = $axvNS.ERRORS_KEY, $22a00640aa3708ae$var$ID_KEY = $axvNS.ID_KEY, $22a00640aa3708ae$var$INVALIDATED_AT_KEY = $axvNS.INVALIDATED_AT_KEY, $22a00640aa3708ae$var$REF_KEY = $axvNS.REF_KEY, $22a00640aa3708ae$var$REFS_KEY = $axvNS.REFS_KEY, $22a00640aa3708ae$var$RELAY_RESOLVER_VALUE_KEY = $axvNS.RELAY_RESOLVER_VALUE_KEY, $22a00640aa3708ae$var$ROOT_ID = $axvNS.ROOT_ID, $22a00640aa3708ae$var$TYPENAME_KEY = $axvNS.TYPENAME_KEY;

var $54oEM = parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $22a00640aa3708ae$var$clone(record) {
    return (0, $22a00640aa3708ae$var$_objectSpread2["default"])({}, record);
}
function $22a00640aa3708ae$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $22a00640aa3708ae$var$ID_KEY && key !== $22a00640aa3708ae$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $22a00640aa3708ae$var$create(dataID, typeName) {
    var record = {};
    record[$22a00640aa3708ae$var$ID_KEY] = dataID;
    record[$22a00640aa3708ae$var$TYPENAME_KEY] = typeName;
    return record;
}
function $22a00640aa3708ae$var$fromObject(json) {
    return json;
}
function $22a00640aa3708ae$var$getDataID(record) {
    return record[$22a00640aa3708ae$var$ID_KEY];
}
function $22a00640aa3708ae$var$getFields(record) {
    if ($22a00640aa3708ae$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $22a00640aa3708ae$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $22a00640aa3708ae$var$getType(record) {
    return record[$22a00640aa3708ae$var$TYPENAME_KEY];
}
function $22a00640aa3708ae$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$22a00640aa3708ae$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $22a00640aa3708ae$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($22a00640aa3708ae$var$REF_KEY) && !value.hasOwnProperty($22a00640aa3708ae$var$REFS_KEY)) && $bt114(false);
    return value;
}
function $22a00640aa3708ae$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $22a00640aa3708ae$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$22a00640aa3708ae$var$REF_KEY] === 'string') && $bt114(false);
    return link[$22a00640aa3708ae$var$REF_KEY];
}
function $22a00640aa3708ae$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$22a00640aa3708ae$var$REF_KEY] === 'string';
}
function $22a00640aa3708ae$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$22a00640aa3708ae$var$REFS_KEY])) && $bt114(false);
    return links[$22a00640aa3708ae$var$REFS_KEY];
}
function $22a00640aa3708ae$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$22a00640aa3708ae$var$REFS_KEY]) && links[$22a00640aa3708ae$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $22a00640aa3708ae$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$22a00640aa3708ae$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $22a00640aa3708ae$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$22a00640aa3708ae$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$22a00640aa3708ae$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$54oEM(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $22a00640aa3708ae$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $22a00640aa3708ae$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($54oEM(prevValue, nextValue) && $54oEM(prevErrors, nextErrors)) continue;
            updated = (0, $22a00640aa3708ae$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$22a00640aa3708ae$var$ERRORS_KEY] = (0, $22a00640aa3708ae$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $22a00640aa3708ae$var$setValue(updated, _storageKey2, nextValue);
        $22a00640aa3708ae$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $22a00640aa3708ae$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($22a00640aa3708ae$var$ERRORS_KEY in record1 || $22a00640aa3708ae$var$ERRORS_KEY in record2) {
        var errors1 = record1[$22a00640aa3708ae$var$ERRORS_KEY], fields1 = (0, $22a00640aa3708ae$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $22a00640aa3708ae$var$ERRORS_KEY
        ].map($22a00640aa3708ae$var$_toPropertyKey2["default"]));
        var errors2 = record2[$22a00640aa3708ae$var$ERRORS_KEY], fields2 = (0, $22a00640aa3708ae$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $22a00640aa3708ae$var$ERRORS_KEY
        ].map($22a00640aa3708ae$var$_toPropertyKey2["default"]));
        var updated = (0, $22a00640aa3708ae$var$_objectSpread2["default"])((0, $22a00640aa3708ae$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$22a00640aa3708ae$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $22a00640aa3708ae$var$_objectSpread2["default"])((0, $22a00640aa3708ae$var$_objectSpread2["default"])({}, record1), record2);
}
function $22a00640aa3708ae$var$freeze(record) {
    $hls5V(record);
}
function $22a00640aa3708ae$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$22a00640aa3708ae$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$22a00640aa3708ae$var$ERRORS_KEY] = (0, $22a00640aa3708ae$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$22a00640aa3708ae$var$ERRORS_KEY];
        }
    }
}
function $22a00640aa3708ae$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $22a00640aa3708ae$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$22a00640aa3708ae$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $22a00640aa3708ae$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$22a00640aa3708ae$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $22a00640aa3708ae$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$22a00640aa3708ae$var$REF_KEY] = linkedID;
    link[$22a00640aa3708ae$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $22a00640aa3708ae$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$22a00640aa3708ae$var$REF_KEY] === 'string' && link[$22a00640aa3708ae$var$ACTOR_IDENTIFIER_KEY] != null) && $bt114(false);
    return [
        link[$22a00640aa3708ae$var$ACTOR_IDENTIFIER_KEY],
        link[$22a00640aa3708ae$var$REF_KEY]
    ];
}
function $22a00640aa3708ae$var$getResolverLinkedRecordID(record, typeName) {
    var id = $22a00640aa3708ae$var$getValue(record, $22a00640aa3708ae$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $22a00640aa3708ae$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $bt114(false);
    return $22a00640aa3708ae$var$generateClientObjectClientID(typeName, id);
}
function $22a00640aa3708ae$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $22a00640aa3708ae$var$getValue(record, $22a00640aa3708ae$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $22a00640aa3708ae$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $bt114(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $bt114(false);
        return $22a00640aa3708ae$var$generateClientObjectClientID(typeName, id);
    });
}
function $22a00640aa3708ae$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $22a00640aa3708ae$var$clone,
    copyFields: $22a00640aa3708ae$var$copyFields,
    create: $22a00640aa3708ae$var$create,
    freeze: $22a00640aa3708ae$var$freeze,
    fromObject: $22a00640aa3708ae$var$fromObject,
    getDataID: $22a00640aa3708ae$var$getDataID,
    getErrors: $22a00640aa3708ae$var$getErrors,
    getFields: $22a00640aa3708ae$var$getFields,
    getInvalidationEpoch: $22a00640aa3708ae$var$getInvalidationEpoch,
    getLinkedRecordID: $22a00640aa3708ae$var$getLinkedRecordID,
    getLinkedRecordIDs: $22a00640aa3708ae$var$getLinkedRecordIDs,
    getType: $22a00640aa3708ae$var$getType,
    getValue: $22a00640aa3708ae$var$getValue,
    hasValue: $22a00640aa3708ae$var$hasValue,
    hasLinkedRecordID: $22a00640aa3708ae$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $22a00640aa3708ae$var$hasLinkedRecordIDs,
    merge: $22a00640aa3708ae$var$merge,
    setErrors: $22a00640aa3708ae$var$setErrors,
    setValue: $22a00640aa3708ae$var$setValue,
    setLinkedRecordID: $22a00640aa3708ae$var$setLinkedRecordID,
    setLinkedRecordIDs: $22a00640aa3708ae$var$setLinkedRecordIDs,
    update: $22a00640aa3708ae$var$update,
    getActorLinkedRecordID: $22a00640aa3708ae$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $22a00640aa3708ae$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $22a00640aa3708ae$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $22a00640aa3708ae$var$getResolverLinkedRecordIDs,
    toJSON: $22a00640aa3708ae$var$toJSON
};

});
parcelRegister("g4Uat", function(module, exports) {
function $bb4896d53cb8e2d3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $bb4896d53cb8e2d3$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6Ip1f", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $4e3a426d83f04691$var$_interopRequireDefault = $vsDHM.default;

var $4e3a426d83f04691$var$_createForOfIteratorHelper2 = $4e3a426d83f04691$var$_interopRequireDefault((parcelRequire("itJC0")));

var $2Yj88 = parcelRequire("2Yj88");

var $i0MCx = parcelRequire("i0MCx");
var $4e3a426d83f04691$var$EXISTENT = $i0MCx.EXISTENT, $4e3a426d83f04691$var$NONEXISTENT = $i0MCx.NONEXISTENT, $4e3a426d83f04691$var$UNKNOWN = $i0MCx.UNKNOWN;
var $4e3a426d83f04691$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $2Yj88.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $4e3a426d83f04691$var$UNKNOWN;
        return this._records.get(dataID) == null ? $4e3a426d83f04691$var$NONEXISTENT : $4e3a426d83f04691$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $4e3a426d83f04691$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $2Yj88.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $4e3a426d83f04691$var$RelayRecordSource;

});
parcelRegister("i0MCx", function(module, exports) {
'use strict';
var $d1cdf11b445f864e$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $d1cdf11b445f864e$var$RelayRecordState;

});


parcelRegister("2rhVW", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $1c6c039e5e0dabc0$var$_interopRequireDefault = $vsDHM.default;

var $1c6c039e5e0dabc0$var$_createForOfIteratorHelper2 = $1c6c039e5e0dabc0$var$_interopRequireDefault((parcelRequire("itJC0")));

var $1c6c039e5e0dabc0$var$_toConsumableArray2 = $1c6c039e5e0dabc0$var$_interopRequireDefault((parcelRequire("8bSRK")));

var $7xt1G = parcelRequire("7xt1G");
var $1c6c039e5e0dabc0$var$ACTOR_IDENTIFIER_FIELD_NAME = $7xt1G.ACTOR_IDENTIFIER_FIELD_NAME, $1c6c039e5e0dabc0$var$getActorIdentifierFromPayload = $7xt1G.getActorIdentifierFromPayload;

var $1i6fU = parcelRequire("1i6fU");

var $fuThW = parcelRequire("fuThW");
var $1c6c039e5e0dabc0$var$generateClientID = $fuThW.generateClientID, $1c6c039e5e0dabc0$var$isClientID = $fuThW.isClientID;

var $5573k = parcelRequire("5573k");
var $1c6c039e5e0dabc0$var$getLocalVariables = $5573k.getLocalVariables;

var $eYcuJ = parcelRequire("eYcuJ");
var $1c6c039e5e0dabc0$var$buildErrorTrie = $eYcuJ.buildErrorTrie, $1c6c039e5e0dabc0$var$getErrorsByKey = $eYcuJ.getErrorsByKey, $1c6c039e5e0dabc0$var$getNestedErrorTrieByKey = $eYcuJ.getNestedErrorTrieByKey;

var $2Yj88 = parcelRequire("2Yj88");

var $7mhru = parcelRequire("7mhru");
var $1c6c039e5e0dabc0$var$createNormalizationSelector = $7mhru.createNormalizationSelector;

var $axvNS = parcelRequire("axvNS");
var $1c6c039e5e0dabc0$var$ROOT_ID = $axvNS.ROOT_ID, $1c6c039e5e0dabc0$var$TYPENAME_KEY = $axvNS.TYPENAME_KEY, $1c6c039e5e0dabc0$var$getArgumentValues = $axvNS.getArgumentValues, $1c6c039e5e0dabc0$var$getHandleStorageKey = $axvNS.getHandleStorageKey, $1c6c039e5e0dabc0$var$getModuleComponentKey = $axvNS.getModuleComponentKey, $1c6c039e5e0dabc0$var$getModuleOperationKey = $axvNS.getModuleOperationKey, $1c6c039e5e0dabc0$var$getStorageKey = $axvNS.getStorageKey;

var $hORvL = parcelRequire("hORvL");
var $1c6c039e5e0dabc0$var$TYPE_SCHEMA_TYPE = $hORvL.TYPE_SCHEMA_TYPE, $1c6c039e5e0dabc0$var$generateTypeID = $hORvL.generateTypeID;
parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $1c6c039e5e0dabc0$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $1c6c039e5e0dabc0$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $1c6c039e5e0dabc0$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $1c6c039e5e0dabc0$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $bt114(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $1c6c039e5e0dabc0$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $1c6c039e5e0dabc0$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $1c6c039e5e0dabc0$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $2Yj88.create(typeID, $1c6c039e5e0dabc0$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $2Yj88.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bt114(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$1c6c039e5e0dabc0$var$TYPENAME_KEY];
        !(typeName != null) && $bt114(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $1c6c039e5e0dabc0$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $2Yj88.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = $2Yj88.getType(record);
                        var typeID = $1c6c039e5e0dabc0$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $2Yj88.create(typeID, $1c6c039e5e0dabc0$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $2Yj88.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = $2Yj88.getType(record);
                    var _typeID = $1c6c039e5e0dabc0$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $2Yj88.create(_typeID, $1c6c039e5e0dabc0$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $2Yj88.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $1c6c039e5e0dabc0$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $1c6c039e5e0dabc0$var$getStorageKey(selection, this._variables);
                    var handleKey = $1c6c039e5e0dabc0$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $2Yj88.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $1c6c039e5e0dabc0$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $bt114(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $1c6c039e5e0dabc0$var$_toConsumableArray2["default"])(this._path),
            selector: $1c6c039e5e0dabc0$var$createNormalizationSelector(defer, $2Yj88.getDataID(record), this._variables),
            typeName: $2Yj88.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $1c6c039e5e0dabc0$var$_toConsumableArray2["default"])(this._path),
            parentID: $2Yj88.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $bt114(false);
        var typeName = $2Yj88.getType(record);
        var componentKey = $1c6c039e5e0dabc0$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $2Yj88.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $1c6c039e5e0dabc0$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $2Yj88.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $2Yj88.getDataID(record),
            operationReference: operationReference,
            path: (0, $1c6c039e5e0dabc0$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $bt114(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $1c6c039e5e0dabc0$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $1i6fU.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $2Yj88.setLinkedRecordIDs(record, storageKey, []);
                else $2Yj88.setValue(record, storageKey, []);
            } else $2Yj88.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $1c6c039e5e0dabc0$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $2Yj88.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $2Yj88.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $1c6c039e5e0dabc0$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $bt114(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $bt114(false);
        var responseKey = field.alias || field.name;
        var storageKey = $1c6c039e5e0dabc0$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $2Yj88.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $1c6c039e5e0dabc0$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $2Yj88.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $2Yj88.getLinkedRecordID(record, storageKey) || $1c6c039e5e0dabc0$var$generateClientID($2Yj88.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $bt114(false);
        $2Yj88.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $1c6c039e5e0dabc0$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $bt114(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $2Yj88.getLinkedRecordID(record, storageKey) || $1c6c039e5e0dabc0$var$generateClientID($2Yj88.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $bt114(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($2Yj88.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $2Yj88.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $2Yj88.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $bt114(false);
        var prevIDs = $2Yj88.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $1c6c039e5e0dabc0$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $bt114(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $1c6c039e5e0dabc0$var$generateClientID($2Yj88.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $bt114(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $2Yj88.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $2Yj88.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($1i6fU.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $2Yj88.getDataID(record);
            var expected = $1c6c039e5e0dabc0$var$isClientID(dataID) && dataID !== $1c6c039e5e0dabc0$var$ROOT_ID || $2Yj88.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: $2Yj88.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $1c6c039e5e0dabc0$var$normalize
};

});
parcelRegister("7xt1G", function(module, exports) {
'use strict';
var $57d221707b257357$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $ceLG3 = parcelRequire("ceLG3");
var $57d221707b257357$var$getActorIdentifier = $ceLG3.getActorIdentifier;
function $57d221707b257357$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$57d221707b257357$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $57d221707b257357$var$getActorIdentifier(payload[$57d221707b257357$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $57d221707b257357$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $57d221707b257357$var$getActorIdentifierFromPayload
};

});
parcelRegister("ceLG3", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");
var $8e8bc68d20ecd9cb$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $8e8bc68d20ecd9cb$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $8e8bc68d20ecd9cb$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $bt114(false);
}
module.exports = {
    assertInternalActorIdentifier: $8e8bc68d20ecd9cb$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $8e8bc68d20ecd9cb$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("eYcuJ", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $ae605c7cd0a69f7f$var$_interopRequireDefault = $vsDHM.default;

var $ae605c7cd0a69f7f$var$_objectSpread2 = $ae605c7cd0a69f7f$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $ae605c7cd0a69f7f$var$_objectWithoutPropertiesLoose2 = $ae605c7cd0a69f7f$var$_interopRequireDefault((parcelRequire("g4Uat")));

var $ae605c7cd0a69f7f$var$_createForOfIteratorHelper2 = $ae605c7cd0a69f7f$var$_interopRequireDefault((parcelRequire("itJC0")));

var $ae605c7cd0a69f7f$var$_toConsumableArray2 = $ae605c7cd0a69f7f$var$_interopRequireDefault((parcelRequire("8bSRK")));
var $ae605c7cd0a69f7f$var$_excluded = [
    "path",
    "locations"
];
var $ae605c7cd0a69f7f$var$SELF = Symbol('$SELF');
function $ae605c7cd0a69f7f$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $ae605c7cd0a69f7f$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $ae605c7cd0a69f7f$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $ae605c7cd0a69f7f$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($ae605c7cd0a69f7f$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $ae605c7cd0a69f7f$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $ae605c7cd0a69f7f$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $ae605c7cd0a69f7f$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $ae605c7cd0a69f7f$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $ae605c7cd0a69f7f$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $ae605c7cd0a69f7f$var$_toConsumableArray2["default"])(value));
            else $ae605c7cd0a69f7f$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $ae605c7cd0a69f7f$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $ae605c7cd0a69f7f$var$_objectSpread2["default"])((0, $ae605c7cd0a69f7f$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $ae605c7cd0a69f7f$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $ae605c7cd0a69f7f$var$SELF,
    buildErrorTrie: $ae605c7cd0a69f7f$var$buildErrorTrie,
    getNestedErrorTrieByKey: $ae605c7cd0a69f7f$var$getNestedErrorTrieByKey,
    getErrorsByKey: $ae605c7cd0a69f7f$var$getErrorsByKey
};

});

parcelRegister("hORvL", function(module, exports) {
'use strict';
var $cf909d66fb499013$var$PREFIX = 'client:__type:';
var $cf909d66fb499013$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $cf909d66fb499013$var$generateTypeID(typeName) {
    return $cf909d66fb499013$var$PREFIX + typeName;
}
function $cf909d66fb499013$var$isTypeID(id) {
    return id.indexOf($cf909d66fb499013$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $cf909d66fb499013$var$generateTypeID,
    isTypeID: $cf909d66fb499013$var$isTypeID,
    TYPE_SCHEMA_TYPE: $cf909d66fb499013$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("3y63I", function(module, exports) {
'use strict';

var $emGVK = parcelRequire("emGVK");
var $29593f44483dea7d$var$getInlineDataFragment = $emGVK.getInlineDataFragment;

var $axvNS = parcelRequire("axvNS");
var $29593f44483dea7d$var$FRAGMENTS_KEY = $axvNS.FRAGMENTS_KEY;

var $bt114 = parcelRequire("bt114");
function $29593f44483dea7d$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $29593f44483dea7d$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $bt114(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$29593f44483dea7d$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $bt114(false);
    return inlineData;
}
module.exports = $29593f44483dea7d$var$readInlineData;

});

parcelRegister("6BNRn", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $4cfcdfe95a0f1ee0$var$_interopRequireDefault = $vsDHM.default;

var $4cfcdfe95a0f1ee0$var$_objectSpread2 = $4cfcdfe95a0f1ee0$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $b2H0r = parcelRequire("b2H0r");

var $ceLG3 = parcelRequire("ceLG3");
var $4cfcdfe95a0f1ee0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $ceLG3.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $4cfcdfe95a0f1ee0$var$assertInternalActorIdentifier = $ceLG3.assertInternalActorIdentifier;

var $147kh = parcelRequire("147kh");

var $25gCV = parcelRequire("25gCV");

var $28AUq = parcelRequire("28AUq");

var $Kn04e = parcelRequire("Kn04e");

var $8HCKp = parcelRequire("8HCKp");

var $jMEF1 = parcelRequire("jMEF1");

var $ceVKc = parcelRequire("ceVKc");

var $kEFkv = parcelRequire("kEFkv");

var $bdoqY = parcelRequire("bdoqY");

var $9DKIz = parcelRequire("9DKIz");

var $6Ip1f = parcelRequire("6Ip1f");
parcelRequire("bt114");
var $4cfcdfe95a0f1ee0$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $bdoqY(new $6Ip1f(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $4cfcdfe95a0f1ee0$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $jMEF1;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $25gCV(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $8HCKp;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $9DKIz(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $b2H0r, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $ceVKc;
        this.__setNet = function(newNet) {
            return _this._network = $25gCV(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $28AUq();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $Kn04e(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $147kh.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$4cfcdfe95a0f1ee0$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $147kh.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $6Ip1f.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $4cfcdfe95a0f1ee0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $4cfcdfe95a0f1ee0$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $4cfcdfe95a0f1ee0$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $4cfcdfe95a0f1ee0$var$_objectSpread2["default"])((0, $4cfcdfe95a0f1ee0$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $147kh.create(function(sink) {
            var executor = $kEFkv.execute({
                actorIdentifier: $4cfcdfe95a0f1ee0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $4cfcdfe95a0f1ee0$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $4cfcdfe95a0f1ee0$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $4cfcdfe95a0f1ee0$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$4cfcdfe95a0f1ee0$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $4cfcdfe95a0f1ee0$var$emptyFunction() {}
module.exports = $4cfcdfe95a0f1ee0$var$RelayModernEnvironment;

});
parcelRegister("25gCV", function(module, exports) {
'use strict';

var $gqIky = parcelRequire("gqIky");
function $1848f21e7b2aaec7$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $gqIky();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $1848f21e7b2aaec7$var$wrapNetworkWithLogObserver;

});
parcelRegister("gqIky", function(module, exports) {
'use strict';
var $bf61762bd3616bd9$var$id = 100000;
function $bf61762bd3616bd9$var$generateID() {
    return $bf61762bd3616bd9$var$id++;
}
module.exports = $bf61762bd3616bd9$var$generateID;

});


parcelRegister("28AUq", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $18e8f57da86a0514$var$_interopRequireDefault = $vsDHM.default;

var $18e8f57da86a0514$var$_createForOfIteratorHelper2 = $18e8f57da86a0514$var$_interopRequireDefault((parcelRequire("itJC0")));

var $bt114 = parcelRequire("bt114");
var $18e8f57da86a0514$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $18e8f57da86a0514$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $18e8f57da86a0514$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $18e8f57da86a0514$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $18e8f57da86a0514$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $18e8f57da86a0514$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $bt114(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $18e8f57da86a0514$var$RelayOperationTracker;

});

parcelRegister("Kn04e", function(module, exports) {
'use strict';
function $08b623546fadd7fe$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $08b623546fadd7fe$var$registerEnvironmentWithDevTools;

});

parcelRegister("8HCKp", function(module, exports) {
'use strict';

var $fv7WG = parcelRequire("fv7WG");
var $65606553dcb2c29f$var$VIEWER_ID = $fv7WG.VIEWER_ID, $65606553dcb2c29f$var$VIEWER_TYPE = $fv7WG.VIEWER_TYPE;
function $65606553dcb2c29f$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $65606553dcb2c29f$var$VIEWER_TYPE) return fieldValue.id == null ? $65606553dcb2c29f$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $65606553dcb2c29f$var$defaultGetDataID;

});
parcelRegister("fv7WG", function(module, exports) {
'use strict';

var $fuThW = parcelRequire("fuThW");
var $b48fea0d9c587278$var$generateClientID = $fuThW.generateClientID;

var $axvNS = parcelRequire("axvNS");
var $b48fea0d9c587278$var$ROOT_ID = $axvNS.ROOT_ID;
var $b48fea0d9c587278$var$VIEWER_ID = $b48fea0d9c587278$var$generateClientID($b48fea0d9c587278$var$ROOT_ID, 'viewer');
var $b48fea0d9c587278$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $b48fea0d9c587278$var$VIEWER_ID,
    VIEWER_TYPE: $b48fea0d9c587278$var$VIEWER_TYPE
};

});


parcelRegister("jMEF1", function(module, exports) {
'use strict';
var $e6720a5b59e51fdb$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $e6720a5b59e51fdb$var$defaultRelayFieldLogger;

});

parcelRegister("kEFkv", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $f0979a501e1b956e$var$_interopRequireDefault = $vsDHM.default;

var $f0979a501e1b956e$var$_createForOfIteratorHelper2 = $f0979a501e1b956e$var$_interopRequireDefault((parcelRequire("itJC0")));

var $f0979a501e1b956e$var$_toConsumableArray2 = $f0979a501e1b956e$var$_interopRequireDefault((parcelRequire("8bSRK")));

var $147kh = parcelRequire("147kh");

var $gqIky = parcelRequire("gqIky");

var $hrn6V = parcelRequire("hrn6V");

var $bJPoz = parcelRequire("bJPoz");

var $1i6fU = parcelRequire("1i6fU");

var $abxbg = parcelRequire("abxbg");
var $f0979a501e1b956e$var$stableCopy = $abxbg.stableCopy;

var $kvwch = parcelRequire("kvwch");

var $fuThW = parcelRequire("fuThW");
var $f0979a501e1b956e$var$generateClientID = $fuThW.generateClientID, $f0979a501e1b956e$var$generateUniqueClientID = $fuThW.generateUniqueClientID;

var $5573k = parcelRequire("5573k");
var $f0979a501e1b956e$var$getLocalVariables = $5573k.getLocalVariables;

var $2Yj88 = parcelRequire("2Yj88");

var $7mhru = parcelRequire("7mhru");
var $f0979a501e1b956e$var$createNormalizationSelector = $7mhru.createNormalizationSelector, $f0979a501e1b956e$var$createReaderSelector = $7mhru.createReaderSelector;

var $6Ip1f = parcelRequire("6Ip1f");

var $axvNS = parcelRequire("axvNS");
var $f0979a501e1b956e$var$ROOT_TYPE = $axvNS.ROOT_TYPE, $f0979a501e1b956e$var$TYPENAME_KEY = $axvNS.TYPENAME_KEY, $f0979a501e1b956e$var$getStorageKey = $axvNS.getStorageKey;

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $f0979a501e1b956e$var$execute(config) {
    return new $f0979a501e1b956e$var$Executor(config);
}
var $f0979a501e1b956e$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $gqIky();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($1i6fU.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!$1i6fU.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $bt114(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $147kh.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $bJPoz.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $bt114(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $bt114(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $f0979a501e1b956e$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $f0979a501e1b956e$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $f0979a501e1b956e$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $f0979a501e1b956e$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new $6Ip1f(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $bt114(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $f0979a501e1b956e$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $f0979a501e1b956e$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $6Ip1f.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($1i6fU.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $f0979a501e1b956e$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $f0979a501e1b956e$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $bt114(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $f0979a501e1b956e$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $f0979a501e1b956e$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $hrn6V(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $f0979a501e1b956e$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $f0979a501e1b956e$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $f0979a501e1b956e$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $hrn6V(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $147kh.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $147kh.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $hrn6V(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $1i6fU.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $kvwch(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $bt114(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $bt114(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $f0979a501e1b956e$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $bt114(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $2Yj88.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $f0979a501e1b956e$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $bt114(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $bt114(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $bt114(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $6Ip1f.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $bt114(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $f0979a501e1b956e$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $6Ip1f.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $bt114(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $f0979a501e1b956e$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $bt114(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $2Yj88.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $bt114(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $bt114(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$f0979a501e1b956e$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $bt114(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $f0979a501e1b956e$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $bt114(false);
        var selector = $f0979a501e1b956e$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $2Yj88.clone(parentRecord);
        var nextIDs = (0, $f0979a501e1b956e$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $2Yj88.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $f0979a501e1b956e$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $f0979a501e1b956e$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $f0979a501e1b956e$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $f0979a501e1b956e$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $f0979a501e1b956e$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $bt114(false);
        return operationLoader;
    };
    return Executor;
}();
function $f0979a501e1b956e$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $bt114(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $f0979a501e1b956e$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($f0979a501e1b956e$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $f0979a501e1b956e$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $bt114(false);
}
module.exports = {
    execute: $f0979a501e1b956e$var$execute
};

});
parcelRegister("hrn6V", function(module, exports) {
'use strict';

var $7UmEy = parcelRequire("7UmEy");
var $cb26e29b4df9e173$var$REQUEST = $7UmEy.REQUEST, $cb26e29b4df9e173$var$SPLIT_OPERATION = $7UmEy.SPLIT_OPERATION;
function $cb26e29b4df9e173$var$getOperation(node) {
    switch(node.kind){
        case $cb26e29b4df9e173$var$REQUEST:
            return node.operation;
        case $cb26e29b4df9e173$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $cb26e29b4df9e173$var$getOperation;

});

parcelRegister("bJPoz", function(module, exports) {
'use strict';
function $88bbc3b1ab1c6b91$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $88bbc3b1ab1c6b91$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $88bbc3b1ab1c6b91$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("kvwch", function(module, exports) {
'use strict';
var $eedfad94f1eb5de6$var$_window, $eedfad94f1eb5de6$var$_window$performance;
var $eedfad94f1eb5de6$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($eedfad94f1eb5de6$var$_window = window) === null || $eedfad94f1eb5de6$var$_window === void 0 ? void 0 : ($eedfad94f1eb5de6$var$_window$performance = $eedfad94f1eb5de6$var$_window.performance) === null || $eedfad94f1eb5de6$var$_window$performance === void 0 ? void 0 : $eedfad94f1eb5de6$var$_window$performance.now) === 'function';
function $eedfad94f1eb5de6$var$currentTimestamp() {
    if ($eedfad94f1eb5de6$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $eedfad94f1eb5de6$var$withStartAndDuration(cb) {
    var startTime = $eedfad94f1eb5de6$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $eedfad94f1eb5de6$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $eedfad94f1eb5de6$var$withStartAndDuration;

});


parcelRegister("bdoqY", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $82a3dcb7d8222463$var$_interopRequireDefault = $vsDHM.default;

var $82a3dcb7d8222463$var$_createForOfIteratorHelper2 = $82a3dcb7d8222463$var$_interopRequireDefault((parcelRequire("itJC0")));

var $82a3dcb7d8222463$var$_defineProperty2 = $82a3dcb7d8222463$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $ceLG3 = parcelRequire("ceLG3");
var $82a3dcb7d8222463$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $ceLG3.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $82a3dcb7d8222463$var$assertInternalActorIdentifier = $ceLG3.assertInternalActorIdentifier;
parcelRequire("hls5V");

var $fxZ2h = parcelRequire("fxZ2h");

var $aEj3l = parcelRequire("aEj3l");

var $8HCKp = parcelRequire("8HCKp");

var $M0mE6 = parcelRequire("M0mE6");
var $82a3dcb7d8222463$var$LiveResolverCache = $M0mE6.LiveResolverCache, $82a3dcb7d8222463$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $M0mE6.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $82a3dcb7d8222463$var$getUpdatedDataIDs = $M0mE6.getUpdatedDataIDs;

var $2Yj88 = parcelRequire("2Yj88");

var $eYe7L = parcelRequire("eYe7L");

var $hSpfc = parcelRequire("hSpfc");

var $gEP3Q = parcelRequire("gEP3Q");

var $5DoNz = parcelRequire("5DoNz");

var $axvNS = parcelRequire("axvNS");

var $axvNS = parcelRequire("axvNS");
var $82a3dcb7d8222463$var$ROOT_ID = $axvNS.ROOT_ID, $82a3dcb7d8222463$var$ROOT_TYPE = $axvNS.ROOT_TYPE;

var $bt114 = parcelRequire("bt114");
var $82a3dcb7d8222463$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $82a3dcb7d8222463$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $82a3dcb7d8222463$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $82a3dcb7d8222463$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $fxZ2h;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $8HCKp;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $82a3dcb7d8222463$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $5DoNz(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $82a3dcb7d8222463$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $82a3dcb7d8222463$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $82a3dcb7d8222463$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $aEj3l.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $82a3dcb7d8222463$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $82a3dcb7d8222463$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $hSpfc.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $82a3dcb7d8222463$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $2Yj88.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $82a3dcb7d8222463$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $bt114(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $eYe7L.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $bt114(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $eYe7L.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $82a3dcb7d8222463$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $bt114(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $gEP3Q.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $2Yj88.getValue(record, $82a3dcb7d8222463$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $82a3dcb7d8222463$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $82a3dcb7d8222463$var$initializeRecordSource(target) {
    if (!target.has($82a3dcb7d8222463$var$ROOT_ID)) {
        var rootRecord = $2Yj88.create($82a3dcb7d8222463$var$ROOT_ID, $82a3dcb7d8222463$var$ROOT_TYPE);
        target.set($82a3dcb7d8222463$var$ROOT_ID, rootRecord);
    }
}
function $82a3dcb7d8222463$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $2Yj88.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $2Yj88.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $2Yj88.setValue(nextRecord, $axvNS.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $2Yj88.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $82a3dcb7d8222463$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $82a3dcb7d8222463$var$RelayModernStore;

});
parcelRegister("fxZ2h", function(module, exports) {
'use strict';
var $b5194889a1e2c453$var$resolvedPromise = Promise.resolve();
function $b5194889a1e2c453$var$resolveImmediate(callback) {
    $b5194889a1e2c453$var$resolvedPromise.then(callback)["catch"]($b5194889a1e2c453$var$throwNext);
}
function $b5194889a1e2c453$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $b5194889a1e2c453$var$resolveImmediate;

});

parcelRegister("aEj3l", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $7c0c6b4ddea1ee47$var$_interopRequireDefault = $vsDHM.default;

var $7c0c6b4ddea1ee47$var$_createForOfIteratorHelper2 = $7c0c6b4ddea1ee47$var$_interopRequireDefault((parcelRequire("itJC0")));

var $ieZUX = parcelRequire("ieZUX");

var $hSwXB = parcelRequire("hSwXB");

var $hrn6V = parcelRequire("hrn6V");

var $fuThW = parcelRequire("fuThW");
var $7c0c6b4ddea1ee47$var$isClientID = $fuThW.isClientID;

var $8X4hj = parcelRequire("8X4hj");

var $bTgBh = parcelRequire("bTgBh");

var $5573k = parcelRequire("5573k");
var $7c0c6b4ddea1ee47$var$getLocalVariables = $5573k.getLocalVariables;

var $2Yj88 = parcelRequire("2Yj88");

var $i0MCx = parcelRequire("i0MCx");
var $7c0c6b4ddea1ee47$var$EXISTENT = $i0MCx.EXISTENT, $7c0c6b4ddea1ee47$var$UNKNOWN = $i0MCx.UNKNOWN;

var $axvNS = parcelRequire("axvNS");

var $hORvL = parcelRequire("hORvL");
var $7c0c6b4ddea1ee47$var$TYPE_SCHEMA_TYPE = $hORvL.TYPE_SCHEMA_TYPE, $7c0c6b4ddea1ee47$var$generateTypeID = $hORvL.generateTypeID;

var $bt114 = parcelRequire("bt114");
var $7c0c6b4ddea1ee47$var$getModuleOperationKey = $axvNS.getModuleOperationKey, $7c0c6b4ddea1ee47$var$getStorageKey = $axvNS.getStorageKey, $7c0c6b4ddea1ee47$var$getArgumentValues = $axvNS.getArgumentValues;
function $7c0c6b4ddea1ee47$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $7c0c6b4ddea1ee47$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $7c0c6b4ddea1ee47$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $ieZUX(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $hSwXB(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bt114(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $7c0c6b4ddea1ee47$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $7c0c6b4ddea1ee47$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $7c0c6b4ddea1ee47$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $7c0c6b4ddea1ee47$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $7c0c6b4ddea1ee47$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $7c0c6b4ddea1ee47$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $7c0c6b4ddea1ee47$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $7c0c6b4ddea1ee47$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $7c0c6b4ddea1ee47$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $7c0c6b4ddea1ee47$var$UNKNOWN) this._handleMissing();
        if (status === $7c0c6b4ddea1ee47$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $2Yj88.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $bt114(false);
                        var _typeID = $7c0c6b4ddea1ee47$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $8X4hj(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $bTgBh(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $7c0c6b4ddea1ee47$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $bt114(false);
                    var typeID = $7c0c6b4ddea1ee47$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $bt114(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $bt114(false);
        var operationKey = $7c0c6b4ddea1ee47$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $hrn6V(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $7c0c6b4ddea1ee47$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $7c0c6b4ddea1ee47$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $7c0c6b4ddea1ee47$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $7c0c6b4ddea1ee47$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $7c0c6b4ddea1ee47$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $2Yj88.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $7c0c6b4ddea1ee47$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $7c0c6b4ddea1ee47$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $7c0c6b4ddea1ee47$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $7c0c6b4ddea1ee47$var$check
};

});
parcelRegister("ieZUX", function(module, exports) {
'use strict';

var $2Yj88 = parcelRequire("2Yj88");

var $i0MCx = parcelRequire("i0MCx");
var $d4799057d936e50d$var$EXISTENT = $i0MCx.EXISTENT;

var $bt114 = parcelRequire("bt114");
var $d4799057d936e50d$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $2Yj88.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $2Yj88.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $2Yj88.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $bt114(false);
            sinkRecord = $2Yj88.create(dataID, $2Yj88.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $bt114(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $2Yj88.copyFields(baseSource, sink);
        if (sinkSource) $2Yj88.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $2Yj88.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $d4799057d936e50d$var$EXISTENT && this._sink.getStatus(dataID) !== $d4799057d936e50d$var$EXISTENT) && $bt114(false);
        var record = $2Yj88.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $2Yj88.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $2Yj88.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2Yj88.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $2Yj88.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2Yj88.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $2Yj88.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2Yj88.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $2Yj88.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2Yj88.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $d4799057d936e50d$var$RelayRecordSourceMutator;

});

parcelRegister("hSwXB", function(module, exports) {
'use strict';

var $2Yj88 = parcelRequire("2Yj88");

var $i0MCx = parcelRequire("i0MCx");
var $d0410c0b276c4a09$var$EXISTENT = $i0MCx.EXISTENT, $d0410c0b276c4a09$var$NONEXISTENT = $i0MCx.NONEXISTENT;

var $axvNS = parcelRequire("axvNS");
var $d0410c0b276c4a09$var$ROOT_ID = $axvNS.ROOT_ID, $d0410c0b276c4a09$var$ROOT_TYPE = $axvNS.ROOT_TYPE;

var $7mtMM = parcelRequire("7mtMM");
var $d0410c0b276c4a09$var$_readUpdatableFragment = $7mtMM.readUpdatableFragment;

var $gNHrN = parcelRequire("gNHrN");
var $d0410c0b276c4a09$var$_readUpdatableQuery = $gNHrN.readUpdatableQuery;

var $a7ut1 = parcelRequire("a7ut1");

var $bt114 = parcelRequire("bt114");
var $d0410c0b276c4a09$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $d0410c0b276c4a09$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $d0410c0b276c4a09$var$EXISTENT) _this.create(dataID, $2Yj88.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $d0410c0b276c4a09$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $bt114(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $bt114(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $d0410c0b276c4a09$var$ROOT_ID) && $bt114(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $d0410c0b276c4a09$var$EXISTENT) this._proxies[dataID] = new $a7ut1(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $d0410c0b276c4a09$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($d0410c0b276c4a09$var$ROOT_ID);
        if (!root) root = this.create($d0410c0b276c4a09$var$ROOT_ID, $d0410c0b276c4a09$var$ROOT_TYPE);
        !(root && root.getType() === $d0410c0b276c4a09$var$ROOT_TYPE) && $bt114(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $d0410c0b276c4a09$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $d0410c0b276c4a09$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $d0410c0b276c4a09$var$RelayRecordSourceProxy;

});
parcelRegister("7mtMM", function(module, exports) {
'use strict';

var $emGVK = parcelRequire("emGVK");
var $55c1b14fd2e3a435$var$getFragment = $emGVK.getFragment;

var $7mhru = parcelRequire("7mhru");
var $55c1b14fd2e3a435$var$getVariablesFromFragment = $7mhru.getVariablesFromFragment;

var $axvNS = parcelRequire("axvNS");
var $55c1b14fd2e3a435$var$ID_KEY = $axvNS.ID_KEY;

var $6S5JL = parcelRequire("6S5JL");
var $55c1b14fd2e3a435$var$createUpdatableProxy = $6S5JL.createUpdatableProxy;

var $bt114 = parcelRequire("bt114");
function $55c1b14fd2e3a435$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $55c1b14fd2e3a435$var$getFragment(fragment);
    var fragmentVariables = $55c1b14fd2e3a435$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$55c1b14fd2e3a435$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $bt114(false);
    return {
        updatableData: $55c1b14fd2e3a435$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $55c1b14fd2e3a435$var$readUpdatableFragment
};

});
parcelRegister("6S5JL", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $500c3c7d7c063a8a$var$_interopRequireDefault = $vsDHM.default;

var $500c3c7d7c063a8a$var$_createForOfIteratorHelper2 = $500c3c7d7c063a8a$var$_interopRequireDefault((parcelRequire("itJC0")));

var $axvNS = parcelRequire("axvNS");
var $500c3c7d7c063a8a$var$getArgumentValues = $axvNS.getArgumentValues;
var $500c3c7d7c063a8a$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $500c3c7d7c063a8a$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $500c3c7d7c063a8a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $500c3c7d7c063a8a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $500c3c7d7c063a8a$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $500c3c7d7c063a8a$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $500c3c7d7c063a8a$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $500c3c7d7c063a8a$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $500c3c7d7c063a8a$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $500c3c7d7c063a8a$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $500c3c7d7c063a8a$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $500c3c7d7c063a8a$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $500c3c7d7c063a8a$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $500c3c7d7c063a8a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $500c3c7d7c063a8a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $500c3c7d7c063a8a$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $500c3c7d7c063a8a$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $500c3c7d7c063a8a$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $500c3c7d7c063a8a$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $500c3c7d7c063a8a$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $500c3c7d7c063a8a$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $500c3c7d7c063a8a$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $500c3c7d7c063a8a$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $500c3c7d7c063a8a$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $500c3c7d7c063a8a$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $500c3c7d7c063a8a$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $500c3c7d7c063a8a$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $500c3c7d7c063a8a$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $500c3c7d7c063a8a$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $500c3c7d7c063a8a$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $500c3c7d7c063a8a$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $500c3c7d7c063a8a$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $500c3c7d7c063a8a$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $500c3c7d7c063a8a$var$createUpdatableProxy
};

});


parcelRegister("gNHrN", function(module, exports) {
'use strict';

var $emGVK = parcelRequire("emGVK");
var $c3b2ecb3fb1df12c$var$getUpdatableQuery = $emGVK.getUpdatableQuery;

var $6S5JL = parcelRequire("6S5JL");
var $c3b2ecb3fb1df12c$var$createUpdatableProxy = $6S5JL.createUpdatableProxy;
function $c3b2ecb3fb1df12c$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $c3b2ecb3fb1df12c$var$getUpdatableQuery(query);
    return {
        updatableData: $c3b2ecb3fb1df12c$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $c3b2ecb3fb1df12c$var$readUpdatableQuery
};

});

parcelRegister("a7ut1", function(module, exports) {
'use strict';

var $fuThW = parcelRequire("fuThW");
var $75e230f894fc611a$var$generateClientID = $fuThW.generateClientID;

var $axvNS = parcelRequire("axvNS");
var $75e230f894fc611a$var$getStableStorageKey = $axvNS.getStableStorageKey;

var $bt114 = parcelRequire("bt114");
var $75e230f894fc611a$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $bt114(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$75e230f894fc611a$var$isValidLeafValue(value) && $bt114(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $bt114(false);
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
            var clientID = $75e230f894fc611a$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $bt114(false);
        var storageKey = $75e230f894fc611a$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $75e230f894fc611a$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($75e230f894fc611a$var$isValidLeafValue);
}
module.exports = $75e230f894fc611a$var$RelayRecordProxy;

});


parcelRegister("8X4hj", function(module, exports) {
'use strict';

var $7UmEy = parcelRequire("7UmEy");
var $6847270224e112b2$var$LINKED_FIELD = $7UmEy.LINKED_FIELD;

var $axvNS = parcelRequire("axvNS");
var $6847270224e112b2$var$getHandleStorageKey = $axvNS.getHandleStorageKey;

var $54oEM = parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");
function $6847270224e112b2$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $6847270224e112b2$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $54oEM(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $6847270224e112b2$var$LINKED_FIELD) && $bt114(false);
    var handleKey = $6847270224e112b2$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $6847270224e112b2$var$cloneRelayHandleSourceField;

});

parcelRegister("bTgBh", function(module, exports) {
'use strict';

var $7UmEy = parcelRequire("7UmEy");
var $8a81b53e77ea5a6f$var$SCALAR_FIELD = $7UmEy.SCALAR_FIELD;

var $axvNS = parcelRequire("axvNS");
var $8a81b53e77ea5a6f$var$getHandleStorageKey = $axvNS.getHandleStorageKey;

var $54oEM = parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");
function $8a81b53e77ea5a6f$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $8a81b53e77ea5a6f$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $54oEM(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $8a81b53e77ea5a6f$var$SCALAR_FIELD) && $bt114(false);
    var handleKey = $8a81b53e77ea5a6f$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $8a81b53e77ea5a6f$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("M0mE6", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $0904c42493b2d245$var$_interopRequireDefault = $vsDHM.default;

var $0904c42493b2d245$var$_createForOfIteratorHelper2 = $0904c42493b2d245$var$_interopRequireDefault((parcelRequire("itJC0")));

var $2tzVZ = parcelRequire("2tzVZ");

var $7UmEy = parcelRequire("7UmEy");
var $0904c42493b2d245$var$RELAY_LIVE_RESOLVER = $7UmEy.RELAY_LIVE_RESOLVER;

var $1i6fU = parcelRequire("1i6fU");

var $aSXuj = parcelRequire("aSXuj");

var $fuThW = parcelRequire("fuThW");
var $0904c42493b2d245$var$generateClientID = $fuThW.generateClientID, $0904c42493b2d245$var$generateClientObjectClientID = $fuThW.generateClientObjectClientID;

var $2Yj88 = parcelRequire("2Yj88");

var $7mhru = parcelRequire("7mhru");
var $0904c42493b2d245$var$createNormalizationSelector = $7mhru.createNormalizationSelector;

var $6Ip1f = parcelRequire("6Ip1f");

var $2rhVW = parcelRequire("2rhVW");
var $0904c42493b2d245$var$normalize = $2rhVW.normalize;

var $axvNS = parcelRequire("axvNS");
var $0904c42493b2d245$var$RELAY_RESOLVER_ERROR_KEY = $axvNS.RELAY_RESOLVER_ERROR_KEY, $0904c42493b2d245$var$RELAY_RESOLVER_INVALIDATION_KEY = $axvNS.RELAY_RESOLVER_INVALIDATION_KEY, $0904c42493b2d245$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $axvNS.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $0904c42493b2d245$var$RELAY_RESOLVER_SNAPSHOT_KEY = $axvNS.RELAY_RESOLVER_SNAPSHOT_KEY, $0904c42493b2d245$var$RELAY_RESOLVER_VALUE_KEY = $axvNS.RELAY_RESOLVER_VALUE_KEY, $0904c42493b2d245$var$getReadTimeResolverStorageKey = $axvNS.getReadTimeResolverStorageKey, $0904c42493b2d245$var$getStorageKey = $axvNS.getStorageKey;

var $hoyBC = parcelRequire("hoyBC");

var $7yEyO = parcelRequire("7yEyO");

var $kXikJ = parcelRequire("kXikJ");
var $0904c42493b2d245$var$isSuspenseSentinel = $kXikJ.isSuspenseSentinel;

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
var $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $0904c42493b2d245$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $0904c42493b2d245$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $0904c42493b2d245$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $0904c42493b2d245$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $0904c42493b2d245$var$expectRecord(recordSource, recordID);
        var storageKey = $0904c42493b2d245$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $2Yj88.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $0904c42493b2d245$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $0904c42493b2d245$var$generateClientID(recordID, storageKey);
            linkedRecord = $2Yj88.create(linkedID, $0904c42493b2d245$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $2Yj88.setValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $2Yj88.setValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $0904c42493b2d245$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $bt114(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $0904c42493b2d245$var$expectRecord(recordSource, recordID);
            var nextRecord = $2Yj88.clone(currentRecord);
            $2Yj88.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $0904c42493b2d245$var$getStorageKey(field.fragment, variables);
                var resolverID = $0904c42493b2d245$var$generateClientID(recordID, fragmentStorageKey);
                $0904c42493b2d245$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $0904c42493b2d245$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $0904c42493b2d245$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $0904c42493b2d245$var$RELAY_LIVE_RESOLVER && $2Yj88.getValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $0904c42493b2d245$var$generateClientID(recordID, storageKey);
            linkedRecord = $2Yj88.clone(linkedRecord);
            var _liveState = $2Yj88.getValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$7yEyO(_liveState)) $bt114(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $2Yj88.setValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $2Yj88.getValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $2Yj88.getValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($0904c42493b2d245$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $0904c42493b2d245$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $bt114(false);
        var liveState = $2Yj88.getValue(liveStateRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $2Yj88.setValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $2Yj88.setValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $2Yj88.setValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$2Yj88.hasValue(currentRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $2Yj88.clone(currentRecord);
            $2Yj88.setValue(nextRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $6Ip1f.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $6Ip1f.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $bt114(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $2Yj88.setValue(resolverRecord, $0904c42493b2d245$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$0904c42493b2d245$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $hoyBC(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $bt114(false);
                resolverValue = [];
                var nextSource = $6Ip1f.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $bt114(false);
                    var typename = $0904c42493b2d245$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $0904c42493b2d245$var$generateClientObjectClientID(typename, $2Yj88.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $0904c42493b2d245$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $0904c42493b2d245$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $bt114(false);
                var _typename = $0904c42493b2d245$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $0904c42493b2d245$var$generateClientObjectClientID(_typename, $2Yj88.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $0904c42493b2d245$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $2Yj88.setValue(resolverRecord, $0904c42493b2d245$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $aSXuj(resolverValue);
            $2Yj88.setValue(resolverRecord, $0904c42493b2d245$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $aSXuj(value);
            $2Yj88.setValue(resolverRecord, $0904c42493b2d245$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $2Yj88.getValue(resolverRecord, $0904c42493b2d245$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $0904c42493b2d245$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$2Yj88.getValue(record, $0904c42493b2d245$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $2Yj88.getValue(record, $0904c42493b2d245$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $2tzVZ(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($1i6fU.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $2Yj88.clone(record);
            $2Yj88.setValue(nextRecord, $0904c42493b2d245$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($2Yj88.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $6Ip1f.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $2Yj88.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $0904c42493b2d245$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $0904c42493b2d245$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $2Yj88.create(outputTypeDataID, typename);
                $2Yj88.setValue(_record, $0904c42493b2d245$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $bt114(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $0904c42493b2d245$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $2Yj88.create(key, typeName);
            $2Yj88.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $0904c42493b2d245$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $0904c42493b2d245$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $0904c42493b2d245$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $0904c42493b2d245$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $0904c42493b2d245$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $2Yj88.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $0904c42493b2d245$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $0904c42493b2d245$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $2Yj88.getFields(record).forEach(function(field) {
        if ($2Yj88.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $2Yj88.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($2Yj88.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $2Yj88.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $0904c42493b2d245$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $2Yj88.clone(record);
    $2Yj88.setValue(nextRecord, $0904c42493b2d245$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $0904c42493b2d245$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $0904c42493b2d245$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $0904c42493b2d245$var$isResolverRecord(_record2)) $0904c42493b2d245$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $0904c42493b2d245$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $0904c42493b2d245$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $0904c42493b2d245$var$isResolverRecord(record)) $0904c42493b2d245$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $0904c42493b2d245$var$isResolverRecord(record) {
    return $2Yj88.getType(record) === $0904c42493b2d245$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $0904c42493b2d245$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $2Yj88.getValue(linkedRecord, $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $0904c42493b2d245$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $bt114(false);
    return record;
}
function $0904c42493b2d245$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $0904c42493b2d245$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $bt114(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $0904c42493b2d245$var$LiveResolverCache,
    getUpdatedDataIDs: $0904c42493b2d245$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $0904c42493b2d245$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("aSXuj", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("hoyBC", function(module, exports) {
'use strict';

var $2Yj88 = parcelRequire("2Yj88");

var $axvNS = parcelRequire("axvNS");
var $ca9f8588934431b0$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $axvNS.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $bt114 = parcelRequire("bt114");
function $ca9f8588934431b0$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $2Yj88.getValue(record, $ca9f8588934431b0$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $bt114(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $ca9f8588934431b0$var$getOutputTypeRecordIDs;

});

parcelRegister("7yEyO", function(module, exports) {
'use strict';
function $580b2bd99fd83267$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $580b2bd99fd83267$var$isLiveStateValue;

});


parcelRegister("eYe7L", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $ae61a015dba247d7$var$_interopRequireDefault = $vsDHM.default;

var $ae61a015dba247d7$var$_objectSpread2 = $ae61a015dba247d7$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $2Yj88 = parcelRequire("2Yj88");

var $6Ip1f = parcelRequire("6Ip1f");

var $bt114 = parcelRequire("bt114");
var $ae61a015dba247d7$var$UNPUBLISH_RECORD_SENTINEL = $2Yj88.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $ae61a015dba247d7$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $6Ip1f.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $ae61a015dba247d7$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $ae61a015dba247d7$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $6Ip1f.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $ae61a015dba247d7$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $ae61a015dba247d7$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $2Yj88.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $ae61a015dba247d7$var$create(base) {
    return new $ae61a015dba247d7$var$RelayOptimisticRecordSource(base);
}
function $ae61a015dba247d7$var$getOptimisticRecordIDs(source) {
    !(source instanceof $ae61a015dba247d7$var$RelayOptimisticRecordSource) && $bt114(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $ae61a015dba247d7$var$create,
    getOptimisticRecordIDs: $ae61a015dba247d7$var$getOptimisticRecordIDs
};

});

parcelRegister("hSpfc", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $d03b0fca54b8d3b1$var$_interopRequireDefault = $vsDHM.default;

var $d03b0fca54b8d3b1$var$_objectSpread2 = $d03b0fca54b8d3b1$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $d03b0fca54b8d3b1$var$_defineProperty2 = $d03b0fca54b8d3b1$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $d03b0fca54b8d3b1$var$_objectWithoutPropertiesLoose2 = $d03b0fca54b8d3b1$var$_interopRequireDefault((parcelRequire("g4Uat")));

var $d03b0fca54b8d3b1$var$_toConsumableArray2 = $d03b0fca54b8d3b1$var$_interopRequireDefault((parcelRequire("8bSRK")));
var $d03b0fca54b8d3b1$var$_excluded = [
    "message"
];

var $1i6fU = parcelRequire("1i6fU");

var $kXikJ = parcelRequire("kXikJ");
var $d03b0fca54b8d3b1$var$isSuspenseSentinel = $kXikJ.isSuspenseSentinel;

var $5573k = parcelRequire("5573k");

var $2Yj88 = parcelRequire("2Yj88");

var $axvNS = parcelRequire("axvNS");
var $d03b0fca54b8d3b1$var$CLIENT_EDGE_TRAVERSAL_PATH = $axvNS.CLIENT_EDGE_TRAVERSAL_PATH, $d03b0fca54b8d3b1$var$FRAGMENT_OWNER_KEY = $axvNS.FRAGMENT_OWNER_KEY, $d03b0fca54b8d3b1$var$FRAGMENT_PROP_NAME_KEY = $axvNS.FRAGMENT_PROP_NAME_KEY, $d03b0fca54b8d3b1$var$FRAGMENTS_KEY = $axvNS.FRAGMENTS_KEY, $d03b0fca54b8d3b1$var$ID_KEY = $axvNS.ID_KEY, $d03b0fca54b8d3b1$var$MODULE_COMPONENT_KEY = $axvNS.MODULE_COMPONENT_KEY, $d03b0fca54b8d3b1$var$ROOT_ID = $axvNS.ROOT_ID, $d03b0fca54b8d3b1$var$getArgumentValues = $axvNS.getArgumentValues, $d03b0fca54b8d3b1$var$getModuleComponentKey = $axvNS.getModuleComponentKey, $d03b0fca54b8d3b1$var$getStorageKey = $axvNS.getStorageKey;

var $cy31O = parcelRequire("cy31O");
var $d03b0fca54b8d3b1$var$NoopResolverCache = $cy31O.NoopResolverCache;

var $kXfEz = parcelRequire("kXfEz");
var $d03b0fca54b8d3b1$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $kXfEz.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $d03b0fca54b8d3b1$var$withResolverContext = $kXfEz.withResolverContext;

var $hORvL = parcelRequire("hORvL");
var $d03b0fca54b8d3b1$var$generateTypeID = $hORvL.generateTypeID;

var $bt114 = parcelRequire("bt114");
function $d03b0fca54b8d3b1$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $d03b0fca54b8d3b1$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $d03b0fca54b8d3b1$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $d03b0fca54b8d3b1$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $d03b0fca54b8d3b1$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $2Yj88.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bt114(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($d03b0fca54b8d3b1$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $d03b0fca54b8d3b1$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $d03b0fca54b8d3b1$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $bt114(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $bt114(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $bt114(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $bt114(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $2Yj88.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = $d03b0fca54b8d3b1$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $d03b0fca54b8d3b1$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $d03b0fca54b8d3b1$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$d03b0fca54b8d3b1$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $d03b0fca54b8d3b1$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $d03b0fca54b8d3b1$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $d03b0fca54b8d3b1$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $d03b0fca54b8d3b1$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($d03b0fca54b8d3b1$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $bt114(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $d03b0fca54b8d3b1$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $bt114(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $bt114(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $bt114(false);
                var localId = $d03b0fca54b8d3b1$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $bt114(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $d03b0fca54b8d3b1$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $d03b0fca54b8d3b1$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $bt114(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $bt114(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $bt114(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $bt114(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $d03b0fca54b8d3b1$var$getStorageKey(field, this._variables);
        var value = $2Yj88.getValue(record, storageKey);
        if (value === null || $1i6fU.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $d03b0fca54b8d3b1$var$getStorageKey(field, this._variables);
        var linkedID = $2Yj88.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $bt114(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $d03b0fca54b8d3b1$var$getStorageKey(field, this._variables);
        var externalRef = $2Yj88.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $2Yj88.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $d03b0fca54b8d3b1$var$getStorageKey(field, this._variables);
        var linkedIDs = $2Yj88.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $1i6fU.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $bt114(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $bt114(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $d03b0fca54b8d3b1$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $2Yj88.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$d03b0fca54b8d3b1$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$d03b0fca54b8d3b1$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $2Yj88.getType(record);
        return typeName != null && typeName === type || $2Yj88.getDataID(record) === $d03b0fca54b8d3b1$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$d03b0fca54b8d3b1$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$d03b0fca54b8d3b1$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $bt114(false);
        if (data[$d03b0fca54b8d3b1$var$ID_KEY] == null) data[$d03b0fca54b8d3b1$var$ID_KEY] = $2Yj88.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $d03b0fca54b8d3b1$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$d03b0fca54b8d3b1$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$d03b0fca54b8d3b1$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $d03b0fca54b8d3b1$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$d03b0fca54b8d3b1$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$d03b0fca54b8d3b1$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $bt114(false);
        if (data[$d03b0fca54b8d3b1$var$ID_KEY] == null) data[$d03b0fca54b8d3b1$var$ID_KEY] = $2Yj88.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $d03b0fca54b8d3b1$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $5573k.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $2Yj88.getType(record);
        var typeRecord = this._recordSource.get($d03b0fca54b8d3b1$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $2Yj88.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $d03b0fca54b8d3b1$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $d03b0fca54b8d3b1$var$_objectSpread2["default"])((0, $d03b0fca54b8d3b1$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $bt114(false);
    }
}
function $d03b0fca54b8d3b1$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $d03b0fca54b8d3b1$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $d03b0fca54b8d3b1$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $d03b0fca54b8d3b1$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $bt114(false);
}
module.exports = {
    read: $d03b0fca54b8d3b1$var$read
};

});
parcelRegister("cy31O", function(module, exports) {
'use strict';

var $7UmEy = parcelRequire("7UmEy");
var $922b0256cf024324$var$RELAY_LIVE_RESOLVER = $7UmEy.RELAY_LIVE_RESOLVER;

var $bt114 = parcelRequire("bt114");
var $922b0256cf024324$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $922b0256cf024324$var$RELAY_LIVE_RESOLVER) && $bt114(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $bt114(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $922b0256cf024324$var$NoopResolverCache
};

});


parcelRegister("gEP3Q", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $c207fd6cb085097a$var$_interopRequireDefault = $vsDHM.default;

var $c207fd6cb085097a$var$_createForOfIteratorHelper2 = $c207fd6cb085097a$var$_interopRequireDefault((parcelRequire("itJC0")));

var $hrn6V = parcelRequire("hrn6V");

var $8X4hj = parcelRequire("8X4hj");

var $hoyBC = parcelRequire("hoyBC");

var $5573k = parcelRequire("5573k");
var $c207fd6cb085097a$var$getLocalVariables = $5573k.getLocalVariables;

var $2Yj88 = parcelRequire("2Yj88");

var $axvNS = parcelRequire("axvNS");

var $hORvL = parcelRequire("hORvL");
var $c207fd6cb085097a$var$generateTypeID = $hORvL.generateTypeID;

var $bt114 = parcelRequire("bt114");
var $c207fd6cb085097a$var$getReadTimeResolverStorageKey = $axvNS.getReadTimeResolverStorageKey, $c207fd6cb085097a$var$getStorageKey = $axvNS.getStorageKey, $c207fd6cb085097a$var$getModuleOperationKey = $axvNS.getModuleOperationKey;
function $c207fd6cb085097a$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $c207fd6cb085097a$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $c207fd6cb085097a$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bt114(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $2Yj88.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $axvNS.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $2Yj88.getType(record);
                        var typeID = $c207fd6cb085097a$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $c207fd6cb085097a$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $8X4hj(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $2Yj88.getType(record);
                    var _typeID = $c207fd6cb085097a$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $bt114(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $hoyBC(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $c207fd6cb085097a$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $2Yj88.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $c207fd6cb085097a$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $2Yj88.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $c207fd6cb085097a$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $2Yj88.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $bt114(false);
        var operationKey = $c207fd6cb085097a$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $2Yj88.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $hrn6V(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $c207fd6cb085097a$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $c207fd6cb085097a$var$getStorageKey(field, this._variables);
        var linkedID = $2Yj88.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $c207fd6cb085097a$var$getStorageKey(field, this._variables);
        var linkedIDs = $2Yj88.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $c207fd6cb085097a$var$mark
};

});

parcelRegister("5DoNz", function(module, exports) {
'use strict';
parcelRequire("hls5V");

var $2tzVZ = parcelRequire("2tzVZ");

var $1i6fU = parcelRequire("1i6fU");

var $bpoWq = parcelRequire("bpoWq");

var $8FF2M = parcelRequire("8FF2M");

var $hSpfc = parcelRequire("hSpfc");
var $41a3d4c3c4e4ed48$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $hSpfc.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $2tzVZ(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $bpoWq(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $hSpfc.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $2tzVZ(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $1i6fU.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($1i6fU.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $8FF2M(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $41a3d4c3c4e4ed48$var$RelayStoreSubscriptions;

});
parcelRegister("bpoWq", function(module, exports) {
'use strict';
var $84e560562df3c823$var$ITERATOR_KEY = Symbol.iterator;
function $84e560562df3c823$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$84e560562df3c823$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $84e560562df3c823$var$hasOverlappingIDs;

});

parcelRegister("8FF2M", function(module, exports) {
'use strict';

var $axvNS = parcelRequire("axvNS");
var $6501fd887e981dc9$var$ROOT_ID = $axvNS.ROOT_ID;

var $fv7WG = parcelRequire("fv7WG");
var $6501fd887e981dc9$var$VIEWER_ID = $fv7WG.VIEWER_ID;
var $6501fd887e981dc9$var$ITERATOR_KEY = Symbol.iterator;
function $6501fd887e981dc9$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$6501fd887e981dc9$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $6501fd887e981dc9$var$ROOT_ID && key !== $6501fd887e981dc9$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $6501fd887e981dc9$var$hasSignificantOverlappingIDs;

});



parcelRegister("9DKIz", function(module, exports) {
'use strict';
var $704bfec580bbe5dc$var$_global$ErrorUtils$ap, $704bfec580bbe5dc$var$_global$ErrorUtils;

var $ieZUX = parcelRequire("ieZUX");

var $hSwXB = parcelRequire("hSwXB");

var $ir7mb = parcelRequire("ir7mb");

var $1i6fU = parcelRequire("1i6fU");

var $hSpfc = parcelRequire("hSpfc");

var $6Ip1f = parcelRequire("6Ip1f");

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
var $704bfec580bbe5dc$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $704bfec580bbe5dc$var$applyWithGuard = ($704bfec580bbe5dc$var$_global$ErrorUtils$ap = $704bfec580bbe5dc$var$_global === null || $704bfec580bbe5dc$var$_global === void 0 ? void 0 : ($704bfec580bbe5dc$var$_global$ErrorUtils = $704bfec580bbe5dc$var$_global.ErrorUtils) === null || $704bfec580bbe5dc$var$_global$ErrorUtils === void 0 ? void 0 : $704bfec580bbe5dc$var$_global$ErrorUtils.applyWithGuard) !== null && $704bfec580bbe5dc$var$_global$ErrorUtils$ap !== void 0 ? $704bfec580bbe5dc$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $704bfec580bbe5dc$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $bt114(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $1i6fU.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $bt114(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $ieZUX(this._store.getSource(), source);
        var recordSourceProxy = new $hSwXB(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $bt114(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $bt114(false);
            var recordSourceSelectorProxy = new $ir7mb(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $704bfec580bbe5dc$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $6Ip1f.create();
                var mutator = new $ieZUX(_this2._store.getSource(), sink);
                var recordSourceProxy = new $hSwXB(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $704bfec580bbe5dc$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $6Ip1f.create();
        var mutator = new $ieZUX(this._store.getSource(), sink);
        var recordSourceProxy = new $hSwXB(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $704bfec580bbe5dc$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $704bfec580bbe5dc$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $ir7mb(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $704bfec580bbe5dc$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $704bfec580bbe5dc$var$lookupSelector(source, selector) {
    var selectorData = $hSpfc.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $704bfec580bbe5dc$var$RelayPublishQueue;

});
parcelRegister("ir7mb", function(module, exports) {
'use strict';

var $axvNS = parcelRequire("axvNS");
var $d6c07488e2cdefe8$var$ROOT_TYPE = $axvNS.ROOT_TYPE, $d6c07488e2cdefe8$var$getStorageKey = $axvNS.getStorageKey;

var $7mtMM = parcelRequire("7mtMM");
var $d6c07488e2cdefe8$var$_readUpdatableFragment = $7mtMM.readUpdatableFragment;

var $gNHrN = parcelRequire("gNHrN");
var $d6c07488e2cdefe8$var$_readUpdatableQuery = $gNHrN.readUpdatableQuery;

var $bt114 = parcelRequire("bt114");
var $d6c07488e2cdefe8$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $d6c07488e2cdefe8$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $bt114(false);
        !(field.plural === plural) && $bt114(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $d6c07488e2cdefe8$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $d6c07488e2cdefe8$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $d6c07488e2cdefe8$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $d6c07488e2cdefe8$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $d6c07488e2cdefe8$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("1VBZ4", function(module, exports) {
'use strict';

var $2xVPy = parcelRequire("2xVPy");

var $emGVK = parcelRequire("emGVK");
var $16789423c86ed6a7$var$getRequest = $emGVK.getRequest;

var $bt5FL = parcelRequire("bt5FL");
var $16789423c86ed6a7$var$createOperationDescriptor = $bt5FL.createOperationDescriptor;

var $7mhru = parcelRequire("7mhru");
var $16789423c86ed6a7$var$createReaderSelector = $7mhru.createReaderSelector;
parcelRequire("h4FgL");
function $16789423c86ed6a7$var$requestSubscription(environment, config) {
    var subscription = $16789423c86ed6a7$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $16789423c86ed6a7$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $2xVPy.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $16789423c86ed6a7$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $16789423c86ed6a7$var$requestSubscription;

});

parcelRegister("9eaFC", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $6b7db2bc925881c0$var$_interopRequireDefault = $vsDHM.default;

var $6b7db2bc925881c0$var$_objectSpread2 = $6b7db2bc925881c0$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $axvNS = parcelRequire("axvNS");
var $6b7db2bc925881c0$var$getModuleComponentKey = $axvNS.getModuleComponentKey, $6b7db2bc925881c0$var$getModuleOperationKey = $axvNS.getModuleOperationKey;
function $6b7db2bc925881c0$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $6b7db2bc925881c0$var$_objectSpread2["default"])({}, response);
    data[$6b7db2bc925881c0$var$getModuleComponentKey(name)] = component;
    data[$6b7db2bc925881c0$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $6b7db2bc925881c0$var$createPayloadFor3DField;

});

parcelRegister("fB1gY", function(module, exports) {
'use strict';

var $7mhru = parcelRequire("7mhru");
var $b5ab4c7a996b2c8b$var$getDataIDsFromFragment = $7mhru.getDataIDsFromFragment, $b5ab4c7a996b2c8b$var$getSelector = $7mhru.getSelector, $b5ab4c7a996b2c8b$var$getVariablesFromFragment = $7mhru.getVariablesFromFragment;

var $684gx = parcelRequire("684gx");

var $1i6fU = parcelRequire("1i6fU");

var $abxbg = parcelRequire("abxbg");
var $b5ab4c7a996b2c8b$var$stableCopy = $abxbg.stableCopy;

var $jrEzK = parcelRequire("jrEzK");
var $b5ab4c7a996b2c8b$var$intern = $jrEzK.intern;
function $b5ab4c7a996b2c8b$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $b5ab4c7a996b2c8b$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $b5ab4c7a996b2c8b$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $b5ab4c7a996b2c8b$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($1i6fU.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $1i6fU.STRING_INTERN_LEVEL <= 1 ? ids : $b5ab4c7a996b2c8b$var$intern(ids, $1i6fU.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $684gx(fragmentVariables) ? '{}' : JSON.stringify($b5ab4c7a996b2c8b$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $1i6fU.STRING_INTERN_LEVEL <= 1 ? _ids : $b5ab4c7a996b2c8b$var$intern(_ids, $1i6fU.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($b5ab4c7a996b2c8b$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $b5ab4c7a996b2c8b$var$getFragmentIdentifier;

});
parcelRegister("684gx", function(module, exports) {
'use strict';
var $4766cc81e5b663e2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $4766cc81e5b663e2$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($4766cc81e5b663e2$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $4766cc81e5b663e2$var$isEmptyObject;

});


parcelRegister("7HrDY", function(module, exports) {
'use strict';

var $PTV2Q = parcelRequire("PTV2Q");

var $bt114 = parcelRequire("bt114");
function $59b1fe071601f88d$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $PTV2Q(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $bt114(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $bt114(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $bt114(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $59b1fe071601f88d$var$getPaginationMetadata;

});
parcelRegister("PTV2Q", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");
function $09c023e61ce6d83b$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $bt114(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $bt114(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $bt114(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $bt114(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $bt114(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $09c023e61ce6d83b$var$getRefetchMetadata;

});


parcelRegister("38Zg0", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $24a1a2d367994061$var$_interopRequireDefault = $vsDHM.default;

var $24a1a2d367994061$var$_defineProperty2 = $24a1a2d367994061$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $24a1a2d367994061$var$_objectSpread4 = $24a1a2d367994061$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $bt114 = parcelRequire("bt114");
parcelRequire("h4FgL");
function $24a1a2d367994061$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $bt114(false);
        var _paginationVariables = (0, $24a1a2d367994061$var$_objectSpread4["default"])((0, $24a1a2d367994061$var$_objectSpread4["default"])((0, $24a1a2d367994061$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $24a1a2d367994061$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $24a1a2d367994061$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $bt114(false);
    var paginationVariables = (0, $24a1a2d367994061$var$_objectSpread4["default"])((0, $24a1a2d367994061$var$_objectSpread4["default"])((0, $24a1a2d367994061$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $24a1a2d367994061$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $24a1a2d367994061$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $24a1a2d367994061$var$getPaginationVariables;

});

parcelRegister("kbJmN", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $eb28069f2eb4ca73$var$_interopRequireDefault = $vsDHM.default;

var $eb28069f2eb4ca73$var$_createForOfIteratorHelper2 = $eb28069f2eb4ca73$var$_interopRequireDefault((parcelRequire("itJC0")));

var $bt114 = parcelRequire("bt114");
function $eb28069f2eb4ca73$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $eb28069f2eb4ca73$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $bt114(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $bt114(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $eb28069f2eb4ca73$var$getValueAtPath;

});

parcelRegister("4zNlW", function(module, exports) {
'use strict';
var $3550b6c68070d66e$var$profileHandlersByName = {};
var $3550b6c68070d66e$var$defaultProfiler = {
    stop: function stop() {}
};
var $3550b6c68070d66e$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $3550b6c68070d66e$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $3550b6c68070d66e$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$3550b6c68070d66e$var$profileHandlersByName.hasOwnProperty(name)) $3550b6c68070d66e$var$profileHandlersByName[name] = [];
        $3550b6c68070d66e$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($3550b6c68070d66e$var$profileHandlersByName.hasOwnProperty(name)) $3550b6c68070d66e$var$removeFromArray($3550b6c68070d66e$var$profileHandlersByName[name], handler);
    }
};
function $3550b6c68070d66e$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $3550b6c68070d66e$var$RelayProfiler;

});




parcelRegister("9dJmo", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $6b688389a3c01630$var$_interopRequireDefault = $vsDHM.default;

var $6b688389a3c01630$var$_extends2 = $6b688389a3c01630$var$_interopRequireDefault((parcelRequire("f7z2D")));

var $6b688389a3c01630$var$_objectWithoutPropertiesLoose2 = $6b688389a3c01630$var$_interopRequireDefault((parcelRequire("g4Uat")));

var $6b688389a3c01630$var$_assertThisInitialized2 = $6b688389a3c01630$var$_interopRequireDefault((parcelRequire("3ojnT")));

var $6b688389a3c01630$var$_inheritsLoose2 = $6b688389a3c01630$var$_interopRequireDefault((parcelRequire("2bGHW")));

var $6b688389a3c01630$var$_defineProperty2 = $6b688389a3c01630$var$_interopRequireDefault((parcelRequire("bpeOS")));
var $6b688389a3c01630$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $9zPIQ = parcelRequire("9zPIQ");

var $gN4JZ = parcelRequire("gN4JZ");
var $6b688389a3c01630$var$getContainerName = $gN4JZ.getContainerName;

var $kGixQ = parcelRequire("kGixQ");
var $6b688389a3c01630$var$assertRelayContext = $kGixQ.assertRelayContext;

var $54oEM = parcelRequire("54oEM");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $6b688389a3c01630$var$createFragmentSpecResolver = $4270B.createFragmentSpecResolver, $6b688389a3c01630$var$getDataIDsFromObject = $4270B.getDataIDsFromObject, $6b688389a3c01630$var$isScalarAndEqual = $4270B.isScalarAndEqual;
function $6b688389a3c01630$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $6b688389a3c01630$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $6b688389a3c01630$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $6b688389a3c01630$var$_defineProperty2["default"])((0, $6b688389a3c01630$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $6b688389a3c01630$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $6b688389a3c01630$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $6b688389a3c01630$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $6b688389a3c01630$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $6b688389a3c01630$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $6b688389a3c01630$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $6b688389a3c01630$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$54oEM(prevIDs, nextIDs)) {
                resolver = $6b688389a3c01630$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $6b688389a3c01630$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $6b688389a3c01630$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$6b688389a3c01630$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $6b688389a3c01630$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $6b688389a3c01630$var$_excluded);
            return /*#__PURE__*/ $bSJIT.createElement(Component, (0, $6b688389a3c01630$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($bSJIT.Component), (0, $6b688389a3c01630$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $6b688389a3c01630$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $6b688389a3c01630$var$createContainer(Component, fragmentSpec) {
    return $9zPIQ(Component, fragmentSpec, $6b688389a3c01630$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $6b688389a3c01630$var$createContainer
};

});
parcelRegister("f7z2D", function(module, exports) {
function $b022b0f53315afd3$var$_extends() {
    return module.exports = $b022b0f53315afd3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b022b0f53315afd3$var$_extends.apply(null, arguments);
}
module.exports = $b022b0f53315afd3$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3ojnT", function(module, exports) {
function $2782a652a11a1dcd$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $2782a652a11a1dcd$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2bGHW", function(module, exports) {

var $6vKeh = parcelRequire("6vKeh");
function $197dbcb8bf6488bd$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $6vKeh(t, o);
}
module.exports = $197dbcb8bf6488bd$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6vKeh", function(module, exports) {
function $4bd97f818dfd609d$var$_setPrototypeOf(t, e) {
    return module.exports = $4bd97f818dfd609d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4bd97f818dfd609d$var$_setPrototypeOf(t, e);
}
module.exports = $4bd97f818dfd609d$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9zPIQ", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $6f8f80eb919108cd$var$_interopRequireDefault = $vsDHM.default;

var $6f8f80eb919108cd$var$_extends2 = $6f8f80eb919108cd$var$_interopRequireDefault((parcelRequire("f7z2D")));

var $kMbWe = parcelRequire("kMbWe");

var $gN4JZ = parcelRequire("gN4JZ");
var $6f8f80eb919108cd$var$getComponentName = $gN4JZ.getComponentName, $6f8f80eb919108cd$var$getContainerName = $gN4JZ.getContainerName;

var $ajh5K = parcelRequire("ajh5K");

var $ai69o = parcelRequire("ai69o");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $6f8f80eb919108cd$var$getFragment = $4270B.getFragment;
var $6f8f80eb919108cd$var$useContext = $bSJIT.useContext;
function $6f8f80eb919108cd$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $6f8f80eb919108cd$var$getContainerName(ComponentClass);
    $kMbWe($6f8f80eb919108cd$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $6f8f80eb919108cd$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $6f8f80eb919108cd$var$useContext($ajh5K);
        !(context != null) && $bt114(false);
        var queryRendererContext = $6f8f80eb919108cd$var$useContext($ai69o);
        return /*#__PURE__*/ $bSJIT.createElement(Container, (0, $6f8f80eb919108cd$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $bSJIT.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $6f8f80eb919108cd$var$buildReactRelayContainer;

});
parcelRegister("kMbWe", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");
function $f2018d03c59f00fb$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $bt114(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $bt114(false);
    }
}
module.exports = $f2018d03c59f00fb$var$assertFragmentMap;

});

parcelRegister("gN4JZ", function(module, exports) {
'use strict';
function $c394e65f8b6d878c$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $c394e65f8b6d878c$var$getContainerName(Component) {
    return 'Relay(' + $c394e65f8b6d878c$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $c394e65f8b6d878c$var$getComponentName,
    getContainerName: $c394e65f8b6d878c$var$getContainerName
};

});

parcelRegister("ai69o", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");
module.exports = $bSJIT.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("kGixQ", function(module, exports) {
'use strict';

var $a7Gqr = parcelRequire("a7Gqr");

var $bt114 = parcelRequire("bt114");
function $f0e61d8332a61981$var$assertRelayContext(relay) {
    !$f0e61d8332a61981$var$isRelayContext(relay) && $bt114(false);
    return relay;
}
function $f0e61d8332a61981$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $a7Gqr(context.environment);
}
module.exports = {
    assertRelayContext: $f0e61d8332a61981$var$assertRelayContext,
    isRelayContext: $f0e61d8332a61981$var$isRelayContext
};

});
parcelRegister("a7Gqr", function(module, exports) {
'use strict';
function $75eb77a01e20280f$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $75eb77a01e20280f$var$isRelayEnvironment;

});



parcelRegister("5s8bz", function(module, exports) {
'use strict';

var $ajh5K = parcelRequire("ajh5K");

var $ai69o = parcelRequire("ai69o");

var $54oEM = parcelRequire("54oEM");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $3f85eac9698692cf$var$createOperationDescriptor = $4270B.createOperationDescriptor, $3f85eac9698692cf$var$deepFreeze = $4270B.deepFreeze, $3f85eac9698692cf$var$getRequest = $4270B.getRequest;
var $3f85eac9698692cf$var$useLayoutEffect = $bSJIT.useLayoutEffect, $3f85eac9698692cf$var$useState = $bSJIT.useState, $3f85eac9698692cf$var$useRef = $bSJIT.useRef, $3f85eac9698692cf$var$useMemo = $bSJIT.useMemo;
var $3f85eac9698692cf$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $3f85eac9698692cf$var$useDeepCompare(value) {
    var latestValue = $bSJIT.useRef(value);
    if (!$54oEM(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $3f85eac9698692cf$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $3f85eac9698692cf$var$useDeepCompare(variables);
    var operation = $3f85eac9698692cf$var$useMemo(function() {
        var request = $3f85eac9698692cf$var$getRequest(query);
        return $3f85eac9698692cf$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $3f85eac9698692cf$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $3f85eac9698692cf$var$useRef(null);
    var _useState = $3f85eac9698692cf$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $3f85eac9698692cf$var$useRef(null);
    var snapshot = $3f85eac9698692cf$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $3f85eac9698692cf$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($ajh5K.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $bSJIT.createElement($ai69o.Provider, {
        value: $3f85eac9698692cf$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $3f85eac9698692cf$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("kycFu", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $ef60cf477d80307f$var$_interopRequireDefault = $vsDHM.default;

var $ef60cf477d80307f$var$_extends2 = $ef60cf477d80307f$var$_interopRequireDefault((parcelRequire("f7z2D")));

var $ef60cf477d80307f$var$_objectWithoutPropertiesLoose2 = $ef60cf477d80307f$var$_interopRequireDefault((parcelRequire("g4Uat")));

var $ef60cf477d80307f$var$_assertThisInitialized2 = $ef60cf477d80307f$var$_interopRequireDefault((parcelRequire("3ojnT")));

var $ef60cf477d80307f$var$_inheritsLoose2 = $ef60cf477d80307f$var$_interopRequireDefault((parcelRequire("2bGHW")));

var $ef60cf477d80307f$var$_defineProperty2 = $ef60cf477d80307f$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $ef60cf477d80307f$var$_objectSpread3 = $ef60cf477d80307f$var$_interopRequireDefault((parcelRequire("5bEq2")));
var $ef60cf477d80307f$var$_excluded = [
    "componentRef"
], $ef60cf477d80307f$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $ef60cf477d80307f$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $9zPIQ = parcelRequire("9zPIQ");

var $cn3V4 = parcelRequire("cn3V4");

var $gN4JZ = parcelRequire("gN4JZ");
var $ef60cf477d80307f$var$getComponentName = $gN4JZ.getComponentName, $ef60cf477d80307f$var$getContainerName = $gN4JZ.getContainerName;

var $ajh5K = parcelRequire("ajh5K");

var $4KyEc = parcelRequire("4KyEc");

var $kGixQ = parcelRequire("kGixQ");
var $ef60cf477d80307f$var$assertRelayContext = $kGixQ.assertRelayContext;

var $54oEM = parcelRequire("54oEM");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $ef60cf477d80307f$var$ConnectionInterface = $4270B.ConnectionInterface, $ef60cf477d80307f$var$Observable = $4270B.Observable, $ef60cf477d80307f$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $ef60cf477d80307f$var$createFragmentSpecResolver = $4270B.createFragmentSpecResolver, $ef60cf477d80307f$var$createOperationDescriptor = $4270B.createOperationDescriptor, $ef60cf477d80307f$var$getDataIDsFromObject = $4270B.getDataIDsFromObject, $ef60cf477d80307f$var$getRequest = $4270B.getRequest, $ef60cf477d80307f$var$getVariablesFromObject = $4270B.getVariablesFromObject, $ef60cf477d80307f$var$isScalarAndEqual = $4270B.isScalarAndEqual;
parcelRequire("h4FgL");
var $ef60cf477d80307f$var$FORWARD = 'forward';
function $ef60cf477d80307f$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $bt114(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $ef60cf477d80307f$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $bt114(false);
    return function(prevVars, totalCount) {
        return (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, prevVars), {}, (0, $ef60cf477d80307f$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $ef60cf477d80307f$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $bt114(false);
            !!foundConnectionMetadata && $bt114(false);
            foundConnectionMetadata = (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $bt114(false);
    return foundConnectionMetadata || {};
}
function $ef60cf477d80307f$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $ef60cf477d80307f$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $ef60cf477d80307f$var$getComponentName(Component);
    var containerName = $ef60cf477d80307f$var$getContainerName(Component);
    var metadata = $ef60cf477d80307f$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $ef60cf477d80307f$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $bt114(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $ef60cf477d80307f$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $ef60cf477d80307f$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $ef60cf477d80307f$var$_defineProperty2["default"])((0, $ef60cf477d80307f$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $ef60cf477d80307f$var$_defineProperty2["default"])((0, $ef60cf477d80307f$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $ef60cf477d80307f$var$_defineProperty2["default"])((0, $ef60cf477d80307f$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $ef60cf477d80307f$var$_defineProperty2["default"])((0, $ef60cf477d80307f$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $ef60cf477d80307f$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $ef60cf477d80307f$var$_defineProperty2["default"])((0, $ef60cf477d80307f$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $ef60cf477d80307f$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $ef60cf477d80307f$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $ef60cf477d80307f$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $ef60cf477d80307f$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($ef60cf477d80307f$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $ef60cf477d80307f$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $ef60cf477d80307f$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($ef60cf477d80307f$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($ef60cf477d80307f$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $ef60cf477d80307f$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $ef60cf477d80307f$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $ef60cf477d80307f$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $cn3V4(fragments, this.props);
            var nextRootVariables = $cn3V4(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$54oEM(prevRootVariables, nextRootVariables) || !$54oEM(prevIDs, nextIDs)) {
                this._cleanup();
                if ($ef60cf477d80307f$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $ef60cf477d80307f$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $ef60cf477d80307f$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$ef60cf477d80307f$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $ef60cf477d80307f$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $ef60cf477d80307f$var$_excluded);
            var props = (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $ef60cf477d80307f$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $bt114(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $bt114(false);
            !(typeof pageInfo === 'object') && $bt114(false);
            var hasMore = direction === $ef60cf477d80307f$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $ef60cf477d80307f$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $4KyEc();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $ef60cf477d80307f$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $ef60cf477d80307f$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $ef60cf477d80307f$var$_excluded2);
            var props = (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $cn3V4(fragments, restProps);
            fragmentVariables = $ef60cf477d80307f$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $bt114(false);
            fetchVariables = (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $ef60cf477d80307f$var$_objectSpread3["default"])((0, $ef60cf477d80307f$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $ef60cf477d80307f$var$getRequest(connectionConfig.query);
            var operation = $ef60cf477d80307f$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$54oEM(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $ef60cf477d80307f$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $ef60cf477d80307f$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $ef60cf477d80307f$var$_excluded3);
            return /*#__PURE__*/ $bSJIT.createElement($ajh5K.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $bSJIT.createElement(Component, (0, $ef60cf477d80307f$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($bSJIT.Component), (0, $ef60cf477d80307f$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $ef60cf477d80307f$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $9zPIQ(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $ef60cf477d80307f$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $ef60cf477d80307f$var$createContainer
};

});
parcelRegister("cn3V4", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $901aac599a11e5bd$var$_interopRequireDefault = $vsDHM.default;

var $901aac599a11e5bd$var$_objectSpread2 = $901aac599a11e5bd$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $4270B = parcelRequire("4270B");
var $901aac599a11e5bd$var$getSelector = $4270B.getSelector;
function $901aac599a11e5bd$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $901aac599a11e5bd$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $901aac599a11e5bd$var$_objectSpread2["default"])((0, $901aac599a11e5bd$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $901aac599a11e5bd$var$getRootVariablesForFragments;

});

parcelRegister("4KyEc", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $3756558666e56653$var$_interopRequireDefault = $vsDHM.default;

var $3756558666e56653$var$_defineProperty2 = $3756558666e56653$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $bt114 = parcelRequire("bt114");

var $4270B = parcelRequire("4270B");
var $3756558666e56653$var$fetchQuery = $4270B.__internal.fetchQuery, $3756558666e56653$var$createOperationDescriptor = $4270B.createOperationDescriptor, $3756558666e56653$var$isRelayModernEnvironment = $4270B.isRelayModernEnvironment;
var $3756558666e56653$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $3756558666e56653$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $3756558666e56653$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$3756558666e56653$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $3756558666e56653$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $bt114(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $3756558666e56653$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $bt114(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $bt114(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $3756558666e56653$var$ReactRelayQueryFetcher;

});


parcelRegister("fti6A", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $b4379bc676fd170d$var$_interopRequireDefault = $vsDHM.default;

var $b4379bc676fd170d$var$_objectSpread2 = $b4379bc676fd170d$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $b4379bc676fd170d$var$_assertThisInitialized2 = $b4379bc676fd170d$var$_interopRequireDefault((parcelRequire("3ojnT")));

var $b4379bc676fd170d$var$_inheritsLoose2 = $b4379bc676fd170d$var$_interopRequireDefault((parcelRequire("2bGHW")));

var $b4379bc676fd170d$var$_defineProperty2 = $b4379bc676fd170d$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $ajh5K = parcelRequire("ajh5K");

var $4KyEc = parcelRequire("4KyEc");

var $ai69o = parcelRequire("ai69o");

var $54oEM = parcelRequire("54oEM");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $b4379bc676fd170d$var$createOperationDescriptor = $4270B.createOperationDescriptor, $b4379bc676fd170d$var$deepFreeze = $4270B.deepFreeze, $b4379bc676fd170d$var$getRequest = $4270B.getRequest;
var $b4379bc676fd170d$var$requestCache = {};
var $b4379bc676fd170d$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $b4379bc676fd170d$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $b4379bc676fd170d$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $b4379bc676fd170d$var$_defineProperty2["default"])((0, $b4379bc676fd170d$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $b4379bc676fd170d$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $b4379bc676fd170d$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $b4379bc676fd170d$var$getRequest(query);
            requestCacheKey = $b4379bc676fd170d$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $b4379bc676fd170d$var$requestCache[requestCacheKey] ? $b4379bc676fd170d$var$requestCache[requestCacheKey].queryFetcher : new $4KyEc();
        } else queryFetcher = new $4KyEc();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $b4379bc676fd170d$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $b4379bc676fd170d$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$54oEM(prevState.prevPropsVariables, nextProps.variables)) return $b4379bc676fd170d$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $b4379bc676fd170d$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $b4379bc676fd170d$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $b4379bc676fd170d$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $b4379bc676fd170d$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $b4379bc676fd170d$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $b4379bc676fd170d$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $bSJIT.createElement($ajh5K.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $bSJIT.createElement($ai69o.Provider, {
            value: $b4379bc676fd170d$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($bSJIT.Component);
function $b4379bc676fd170d$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $b4379bc676fd170d$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $b4379bc676fd170d$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $b4379bc676fd170d$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $b4379bc676fd170d$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $b4379bc676fd170d$var$getRequest(query);
        var requestCacheKey = $b4379bc676fd170d$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $b4379bc676fd170d$var$requestCache[requestCacheKey] ? $b4379bc676fd170d$var$requestCache[requestCacheKey].queryFetcher : new $4KyEc(prevSelectionReferences);
    } else queryFetcher = new $4KyEc(prevSelectionReferences);
    return (0, $b4379bc676fd170d$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $b4379bc676fd170d$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $b4379bc676fd170d$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $b4379bc676fd170d$var$getRequest(query);
        var operation = $b4379bc676fd170d$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $b4379bc676fd170d$var$requestCache[requestCacheKey]) {
            var snapshot = $b4379bc676fd170d$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $b4379bc676fd170d$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $b4379bc676fd170d$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $b4379bc676fd170d$var$getRequestCacheKey(request.params, props.variables);
            $b4379bc676fd170d$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $b4379bc676fd170d$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $b4379bc676fd170d$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $b4379bc676fd170d$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $b4379bc676fd170d$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $b4379bc676fd170d$var$ReactRelayQueryRenderer;

});

parcelRegister("64oHH", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $46b647793d02b32b$var$_interopRequireDefault = $vsDHM.default;

var $46b647793d02b32b$var$_extends2 = $46b647793d02b32b$var$_interopRequireDefault((parcelRequire("f7z2D")));

var $46b647793d02b32b$var$_objectWithoutPropertiesLoose2 = $46b647793d02b32b$var$_interopRequireDefault((parcelRequire("g4Uat")));

var $46b647793d02b32b$var$_objectSpread2 = $46b647793d02b32b$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $46b647793d02b32b$var$_assertThisInitialized2 = $46b647793d02b32b$var$_interopRequireDefault((parcelRequire("3ojnT")));

var $46b647793d02b32b$var$_inheritsLoose2 = $46b647793d02b32b$var$_interopRequireDefault((parcelRequire("2bGHW")));

var $46b647793d02b32b$var$_defineProperty2 = $46b647793d02b32b$var$_interopRequireDefault((parcelRequire("bpeOS")));
var $46b647793d02b32b$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $9zPIQ = parcelRequire("9zPIQ");

var $cn3V4 = parcelRequire("cn3V4");

var $gN4JZ = parcelRequire("gN4JZ");
var $46b647793d02b32b$var$getContainerName = $gN4JZ.getContainerName;

var $ajh5K = parcelRequire("ajh5K");

var $4KyEc = parcelRequire("4KyEc");

var $kGixQ = parcelRequire("kGixQ");
var $46b647793d02b32b$var$assertRelayContext = $kGixQ.assertRelayContext;

var $54oEM = parcelRequire("54oEM");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $46b647793d02b32b$var$Observable = $4270B.Observable, $46b647793d02b32b$var$createFragmentSpecResolver = $4270B.createFragmentSpecResolver, $46b647793d02b32b$var$createOperationDescriptor = $4270B.createOperationDescriptor, $46b647793d02b32b$var$getDataIDsFromObject = $4270B.getDataIDsFromObject, $46b647793d02b32b$var$getRequest = $4270B.getRequest, $46b647793d02b32b$var$getVariablesFromObject = $4270B.getVariablesFromObject, $46b647793d02b32b$var$isScalarAndEqual = $4270B.isScalarAndEqual;
parcelRequire("h4FgL");
function $46b647793d02b32b$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $46b647793d02b32b$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $46b647793d02b32b$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $46b647793d02b32b$var$_defineProperty2["default"])((0, $46b647793d02b32b$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $46b647793d02b32b$var$_defineProperty2["default"])((0, $46b647793d02b32b$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $46b647793d02b32b$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $cn3V4(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $46b647793d02b32b$var$_objectSpread2["default"])((0, $46b647793d02b32b$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $46b647793d02b32b$var$_objectSpread2["default"])((0, $46b647793d02b32b$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $46b647793d02b32b$var$getRequest(taggedNode);
                var operation = $46b647793d02b32b$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $46b647793d02b32b$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $46b647793d02b32b$var$_objectSpread2["default"])((0, $46b647793d02b32b$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $46b647793d02b32b$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $46b647793d02b32b$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $46b647793d02b32b$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $46b647793d02b32b$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $46b647793d02b32b$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $46b647793d02b32b$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $cn3V4(fragments, prevProps);
            var nextRootVariables = $cn3V4(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$54oEM(prevRootVariables, nextRootVariables) || !$54oEM(prevIDs, nextIDs)) {
                resolver = $46b647793d02b32b$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $46b647793d02b32b$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$46b647793d02b32b$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $46b647793d02b32b$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $4KyEc();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $46b647793d02b32b$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $46b647793d02b32b$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $bSJIT.createElement($ajh5K.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $bSJIT.createElement(Component, (0, $46b647793d02b32b$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($bSJIT.Component), (0, $46b647793d02b32b$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $46b647793d02b32b$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $46b647793d02b32b$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $9zPIQ(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $46b647793d02b32b$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $46b647793d02b32b$var$createContainer
};

});

parcelRegister("5qwtE", function(module, exports) {
'use strict';

var $h8qaV = parcelRequire("h8qaV");

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");

var $bSJIT = parcelRequire("bSJIT");
var $3f3892c6640f636f$var$useContext = $bSJIT.useContext, $3f3892c6640f636f$var$useEffect = $bSJIT.useEffect;
parcelRequire("h4FgL");
function $3f3892c6640f636f$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $3f3892c6640f636f$var$useContext($h8qaV);
    var environment = $ctuwe();
    $3f3892c6640f636f$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $bSJIT.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $3f3892c6640f636f$var$EntryPointContainer;

});
parcelRegister("h8qaV", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");
var $c7977cdb0030b577$var$ProfilerContext = $bSJIT.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $c7977cdb0030b577$var$ProfilerContext;

});

parcelRegister("ctuwe", function(module, exports) {
'use strict';

var $ajh5K = parcelRequire("ajh5K");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $914fdddd97ce69c6$var$useContext = $bSJIT.useContext;
function $914fdddd97ce69c6$var$useRelayEnvironment() {
    var context = $914fdddd97ce69c6$var$useContext($ajh5K);
    !(context != null) && $bt114(false);
    return context.environment;
}
module.exports = $914fdddd97ce69c6$var$useRelayEnvironment;

});


parcelRegister("7XYjZ", function(module, exports) {
'use strict';

var $lR6HQ = parcelRequire("lR6HQ");
var $5cccd5b16a0082b3$var$loadQuery = $lR6HQ.loadQuery;
function $5cccd5b16a0082b3$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $5cccd5b16a0082b3$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $5cccd5b16a0082b3$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $5cccd5b16a0082b3$var$loadEntryPoint;

});
parcelRegister("lR6HQ", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $fe93bfeb0e402e4c$var$_interopRequireDefault = $vsDHM.default;

var $fe93bfeb0e402e4c$var$_objectSpread2 = $fe93bfeb0e402e4c$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $bt114 = parcelRequire("bt114");

var $4270B = parcelRequire("4270B");
var $fe93bfeb0e402e4c$var$fetchQueryDeduped = $4270B.__internal.fetchQueryDeduped, $fe93bfeb0e402e4c$var$Observable = $4270B.Observable, $fe93bfeb0e402e4c$var$PreloadableQueryRegistry = $4270B.PreloadableQueryRegistry, $fe93bfeb0e402e4c$var$ReplaySubject = $4270B.ReplaySubject, $fe93bfeb0e402e4c$var$createOperationDescriptor = $4270B.createOperationDescriptor, $fe93bfeb0e402e4c$var$getRequest = $4270B.getRequest, $fe93bfeb0e402e4c$var$getRequestIdentifier = $4270B.getRequestIdentifier;
var $fe93bfeb0e402e4c$var$fetchKey = 100001;
function $fe93bfeb0e402e4c$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $fe93bfeb0e402e4c$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $fe93bfeb0e402e4c$var$_objectSpread2["default"])((0, $fe93bfeb0e402e4c$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $fe93bfeb0e402e4c$var$ReplaySubject();
    var returnedObservable = $fe93bfeb0e402e4c$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $fe93bfeb0e402e4c$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $fe93bfeb0e402e4c$var$getRequestIdentifier(params, variables);
        var observable = $fe93bfeb0e402e4c$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $fe93bfeb0e402e4c$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $fe93bfeb0e402e4c$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $fe93bfeb0e402e4c$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $bt114(false);
        var _module = $fe93bfeb0e402e4c$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $fe93bfeb0e402e4c$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $fe93bfeb0e402e4c$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $fe93bfeb0e402e4c$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $fe93bfeb0e402e4c$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $fe93bfeb0e402e4c$var$loadQuery
};

});


parcelRegister("6v1UG", function(module, exports) {
'use strict';

var $ajh5K = parcelRequire("ajh5K");

var $bSJIT = parcelRequire("bSJIT");
var $4bb71f4547f5a383$var$useMemo = $bSJIT.useMemo;
function $4bb71f4547f5a383$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $4bb71f4547f5a383$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($ajh5K.Provider, {
        value: context
    }, children);
}
module.exports = $4bb71f4547f5a383$var$RelayEnvironmentProvider;

});

parcelRegister("hJpcW", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $ce8a3164135e3d8a$var$_interopRequireDefault = $vsDHM.default;

var $ce8a3164135e3d8a$var$_objectSpread2 = $ce8a3164135e3d8a$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $96mIX = parcelRequire("96mIX");
function $ce8a3164135e3d8a$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $96mIX(query, variables, (0, $ce8a3164135e3d8a$var$_objectSpread2["default"])((0, $ce8a3164135e3d8a$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $ce8a3164135e3d8a$var$useClientQuery;

});
parcelRegister("96mIX", function(module, exports) {
'use strict';

var $7zQVQ = parcelRequire("7zQVQ");

var $bAKMj = parcelRequire("bAKMj");

var $ctuwe = parcelRequire("ctuwe");

var $4270B = parcelRequire("4270B");
var $6a064d282f696b32$var$fetchQuery = $4270B.__internal.fetchQuery;
function $6a064d282f696b32$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $ctuwe();
    var query = $bAKMj(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $7zQVQ({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $6a064d282f696b32$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $6a064d282f696b32$var$useLazyLoadQuery;

});
parcelRegister("7zQVQ", function(module, exports) {
'use strict';

var $h8qaV = parcelRequire("h8qaV");

var $lLnw7 = parcelRequire("lLnw7");
var $5844dc7d30b9dd6c$var$getQueryCacheIdentifier = $lLnw7.getQueryCacheIdentifier, $5844dc7d30b9dd6c$var$getQueryResourceForEnvironment = $lLnw7.getQueryResourceForEnvironment;

var $bnOlH = parcelRequire("bnOlH");

var $axYGv = parcelRequire("axYGv");

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");
var $5844dc7d30b9dd6c$var$useContext = $bSJIT.useContext, $5844dc7d30b9dd6c$var$useEffect = $bSJIT.useEffect, $5844dc7d30b9dd6c$var$useState = $bSJIT.useState, $5844dc7d30b9dd6c$var$useRef = $bSJIT.useRef;
function $5844dc7d30b9dd6c$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $ctuwe();
    var profilerContext = $5844dc7d30b9dd6c$var$useContext($h8qaV);
    var QueryResource = $5844dc7d30b9dd6c$var$getQueryResourceForEnvironment(environment);
    var _useState = $5844dc7d30b9dd6c$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $bnOlH(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $5844dc7d30b9dd6c$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $5844dc7d30b9dd6c$var$useRef(false);
    $5844dc7d30b9dd6c$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $5844dc7d30b9dd6c$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $5844dc7d30b9dd6c$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $axYGv(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $5844dc7d30b9dd6c$var$useLazyLoadQueryNode;

});
parcelRegister("lLnw7", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $fd803ac79cea7859$var$_interopRequireDefault = $vsDHM.default;

var $fd803ac79cea7859$var$_objectSpread2 = $fd803ac79cea7859$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $fd803ac79cea7859$var$_defineProperty2 = $fd803ac79cea7859$var$_interopRequireDefault((parcelRequire("bpeOS")));

var $kWRHC = parcelRequire("kWRHC");

var $gWXBW = parcelRequire("gWXBW");

var $bt114 = parcelRequire("bt114");

var $4270B = parcelRequire("4270B");
var $fd803ac79cea7859$var$isPromise = $4270B.isPromise;
parcelRequire("h4FgL");
var $fd803ac79cea7859$var$CACHE_CAPACITY = 1000;
var $fd803ac79cea7859$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $fd803ac79cea7859$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $fd803ac79cea7859$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $fd803ac79cea7859$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $fd803ac79cea7859$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $fd803ac79cea7859$var$operationIsLiveQuery(operation) ? $fd803ac79cea7859$var$DEFAULT_LIVE_FETCH_POLICY : $fd803ac79cea7859$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $fd803ac79cea7859$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $fd803ac79cea7859$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $fd803ac79cea7859$var$nextID = 200000;
function $fd803ac79cea7859$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $fd803ac79cea7859$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $gWXBW(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $fd803ac79cea7859$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $fd803ac79cea7859$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $fd803ac79cea7859$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $kWRHC.create($fd803ac79cea7859$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $fd803ac79cea7859$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $fd803ac79cea7859$var$operationIsLiveQuery(operation) ? $fd803ac79cea7859$var$DEFAULT_LIVE_FETCH_POLICY : $fd803ac79cea7859$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $fd803ac79cea7859$var$_objectSpread2["default"])((0, $fd803ac79cea7859$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($fd803ac79cea7859$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $fd803ac79cea7859$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $fd803ac79cea7859$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $fd803ac79cea7859$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $fd803ac79cea7859$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $fd803ac79cea7859$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $fd803ac79cea7859$var$_objectSpread2["default"])((0, $fd803ac79cea7859$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($fd803ac79cea7859$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $fd803ac79cea7859$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $bt114(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $fd803ac79cea7859$var$createQueryResource(environment) {
    return new $fd803ac79cea7859$var$QueryResourceImpl(environment);
}
var $fd803ac79cea7859$var$dataResources = $fd803ac79cea7859$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $fd803ac79cea7859$var$getQueryResourceForEnvironment(environment) {
    var cached = $fd803ac79cea7859$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $fd803ac79cea7859$var$createQueryResource(environment);
    $fd803ac79cea7859$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $fd803ac79cea7859$var$createQueryResource,
    getQueryResourceForEnvironment: $fd803ac79cea7859$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $fd803ac79cea7859$var$getQueryCacheIdentifier
};

});
parcelRegister("kWRHC", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");
var $f402e1a3ded9b567$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $bt114(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $f402e1a3ded9b567$var$create(capacity) {
    return new $f402e1a3ded9b567$var$LRUCache(capacity);
}
module.exports = {
    create: $f402e1a3ded9b567$var$create
};

});

parcelRegister("gWXBW", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $c5704da1bc15e861$var$_interopRequireDefault = $vsDHM.default;

var $c5704da1bc15e861$var$_defineProperty2 = $c5704da1bc15e861$var$_interopRequireDefault((parcelRequire("bpeOS")));
parcelRequire("h4FgL");
var $c5704da1bc15e861$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $c5704da1bc15e861$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $c5704da1bc15e861$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $c5704da1bc15e861$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $c5704da1bc15e861$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $c5704da1bc15e861$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $c5704da1bc15e861$var$SuspenseResource;

});


parcelRegister("bnOlH", function(module, exports) {
'use strict';

var $ehnPI = parcelRequire("ehnPI");

var $bSJIT = parcelRequire("bSJIT");
var $8498e5f90a939a79$var$useCallback = $bSJIT.useCallback, $8498e5f90a939a79$var$useEffect = $bSJIT.useEffect;
function $8498e5f90a939a79$var$useFetchTrackingRef() {
    var subscriptionRef = $ehnPI(null);
    var isFetchingRef = $ehnPI(false);
    var disposeFetch = $8498e5f90a939a79$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $8498e5f90a939a79$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $8498e5f90a939a79$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $8498e5f90a939a79$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $8498e5f90a939a79$var$useFetchTrackingRef;

});
parcelRegister("ehnPI", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");
var $a65523f7d71d73bf$var$useMemo = $bSJIT.useMemo;
function $a65523f7d71d73bf$var$useUnsafeRef_DEPRECATED(init) {
    return $a65523f7d71d73bf$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $a65523f7d71d73bf$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("axYGv", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $7adc0f2074919418$var$_interopRequireDefault = $vsDHM.default;

var $7adc0f2074919418$var$_useFragmentInternal_CURRENT = $7adc0f2074919418$var$_interopRequireDefault((parcelRequire("42fua")));

var $7adc0f2074919418$var$_useFragmentInternal_EXPERIMENTAL = $7adc0f2074919418$var$_interopRequireDefault((parcelRequire("e1xP6")));

var $4270B = parcelRequire("4270B");
function $7adc0f2074919418$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($4270B.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $7adc0f2074919418$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $7adc0f2074919418$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $7adc0f2074919418$var$useFragmentInternal;

});
parcelRegister("42fua", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $2f035c7307605956$var$_interopRequireDefault = $vsDHM.default;

var $2f035c7307605956$var$_objectSpread2 = $2f035c7307605956$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $2f035c7307605956$var$_createForOfIteratorHelper2 = $2f035c7307605956$var$_interopRequireDefault((parcelRequire("itJC0")));

var $2f035c7307605956$var$_toConsumableArray2 = $2f035c7307605956$var$_interopRequireDefault((parcelRequire("8bSRK")));

var $lLnw7 = parcelRequire("lLnw7");
var $2f035c7307605956$var$getQueryResourceForEnvironment = $lLnw7.getQueryResourceForEnvironment;

var $ctuwe = parcelRequire("ctuwe");

var $2sjlB = parcelRequire("2sjlB");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $2f035c7307605956$var$useDebugValue = $bSJIT.useDebugValue, $2f035c7307605956$var$useEffect = $bSJIT.useEffect, $2f035c7307605956$var$useMemo = $bSJIT.useMemo, $2f035c7307605956$var$useRef = $bSJIT.useRef, $2f035c7307605956$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $2f035c7307605956$var$_require3$__internal = $4270B.__internal, $2f035c7307605956$var$fetchQueryInternal = $2f035c7307605956$var$_require3$__internal.fetchQuery, $2f035c7307605956$var$getPromiseForActiveRequest = $2f035c7307605956$var$_require3$__internal.getPromiseForActiveRequest, $2f035c7307605956$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $2f035c7307605956$var$areEqualSelectors = $4270B.areEqualSelectors, $2f035c7307605956$var$createOperationDescriptor = $4270B.createOperationDescriptor, $2f035c7307605956$var$getPendingOperationsForFragment = $4270B.getPendingOperationsForFragment, $2f035c7307605956$var$getSelector = $4270B.getSelector, $2f035c7307605956$var$getVariablesFromFragment = $4270B.getVariablesFromFragment, $2f035c7307605956$var$handlePotentialSnapshotErrors = $4270B.handlePotentialSnapshotErrors, $2f035c7307605956$var$recycleNodesInto = $4270B.recycleNodesInto;
parcelRequire("h4FgL");
function $2f035c7307605956$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $2f035c7307605956$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $2f035c7307605956$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $2f035c7307605956$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $2f035c7307605956$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $2f035c7307605956$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $2f035c7307605956$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $2f035c7307605956$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $2f035c7307605956$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $bt114(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $2f035c7307605956$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $2f035c7307605956$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $2f035c7307605956$var$_objectSpread2["default"])((0, $2f035c7307605956$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $2f035c7307605956$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $2f035c7307605956$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $2f035c7307605956$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $2f035c7307605956$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $2f035c7307605956$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $2f035c7307605956$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $2f035c7307605956$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $2f035c7307605956$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $2f035c7307605956$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $2f035c7307605956$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $2f035c7307605956$var$useMemo(function() {
        return $2f035c7307605956$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bt114(false);
    else !!Array.isArray(fragmentRef) && $bt114(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bt114(false);
    var environment = $ctuwe();
    var loggerContext;
    if ($2f035c7307605956$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $2sjlB();
    var _useState = $2f035c7307605956$var$useState(function() {
        return $2f035c7307605956$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $2f035c7307605956$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $2f035c7307605956$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $2f035c7307605956$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$2f035c7307605956$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $2f035c7307605956$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $2f035c7307605956$var$useRef(false);
    $2f035c7307605956$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $2f035c7307605956$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $2f035c7307605956$var$useMemo(function() {
            var missingClientEdges = $2f035c7307605956$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $2f035c7307605956$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $2f035c7307605956$var$useEffect(function() {
            var QueryResource = $2f035c7307605956$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $2f035c7307605956$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($2f035c7307605956$var$isMissingData(state)) {
        var suspendingLiveResolvers = $2f035c7307605956$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($2f035c7307605956$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$2f035c7307605956$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $bt114(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $2f035c7307605956$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $2f035c7307605956$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $2f035c7307605956$var$useRef(false);
    $2f035c7307605956$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $2f035c7307605956$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $2f035c7307605956$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $2f035c7307605956$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $2f035c7307605956$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $bt114(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $bt114(false);
        data = state.snapshot.data;
    }
    if ($2f035c7307605956$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $2f035c7307605956$var$useFragmentInternal;

});
parcelRegister("2sjlB", function(module, exports) {
'use strict';

var $fiY2j = parcelRequire("fiY2j");

var $bSJIT = parcelRequire("bSJIT");
var $1c9d34507cb3b8a5$var$useContext = $bSJIT.useContext;
function $1c9d34507cb3b8a5$var$useRelayLoggingContext() {
    return $1c9d34507cb3b8a5$var$useContext($fiY2j);
}
module.exports = $1c9d34507cb3b8a5$var$useRelayLoggingContext;

});
parcelRegister("fiY2j", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $b2471b6e66c5b1e8$var$createRelayLoggingContext = $4270B.__internal.createRelayLoggingContext;
module.exports = $b2471b6e66c5b1e8$var$createRelayLoggingContext($bSJIT);

});



parcelRegister("e1xP6", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $a35b6540691ffd05$var$_interopRequireDefault = $vsDHM.default;

var $a35b6540691ffd05$var$_objectSpread2 = $a35b6540691ffd05$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $a35b6540691ffd05$var$_createForOfIteratorHelper2 = $a35b6540691ffd05$var$_interopRequireDefault((parcelRequire("itJC0")));

var $a35b6540691ffd05$var$_toConsumableArray2 = $a35b6540691ffd05$var$_interopRequireDefault((parcelRequire("8bSRK")));

var $lLnw7 = parcelRequire("lLnw7");
var $a35b6540691ffd05$var$getQueryResourceForEnvironment = $lLnw7.getQueryResourceForEnvironment;

var $ctuwe = parcelRequire("ctuwe");

var $2sjlB = parcelRequire("2sjlB");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $a35b6540691ffd05$var$useDebugValue = $bSJIT.useDebugValue, $a35b6540691ffd05$var$useEffect = $bSJIT.useEffect, $a35b6540691ffd05$var$useMemo = $bSJIT.useMemo, $a35b6540691ffd05$var$useRef = $bSJIT.useRef, $a35b6540691ffd05$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $a35b6540691ffd05$var$_require3$__internal = $4270B.__internal, $a35b6540691ffd05$var$fetchQueryInternal = $a35b6540691ffd05$var$_require3$__internal.fetchQuery, $a35b6540691ffd05$var$getPromiseForActiveRequest = $a35b6540691ffd05$var$_require3$__internal.getPromiseForActiveRequest, $a35b6540691ffd05$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $a35b6540691ffd05$var$areEqualSelectors = $4270B.areEqualSelectors, $a35b6540691ffd05$var$createOperationDescriptor = $4270B.createOperationDescriptor, $a35b6540691ffd05$var$getPendingOperationsForFragment = $4270B.getPendingOperationsForFragment, $a35b6540691ffd05$var$getSelector = $4270B.getSelector, $a35b6540691ffd05$var$getVariablesFromFragment = $4270B.getVariablesFromFragment, $a35b6540691ffd05$var$handlePotentialSnapshotErrors = $4270B.handlePotentialSnapshotErrors, $a35b6540691ffd05$var$recycleNodesInto = $4270B.recycleNodesInto;
parcelRequire("h4FgL");
function $a35b6540691ffd05$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $a35b6540691ffd05$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $a35b6540691ffd05$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $a35b6540691ffd05$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $a35b6540691ffd05$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $a35b6540691ffd05$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $a35b6540691ffd05$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $a35b6540691ffd05$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $a35b6540691ffd05$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $bt114(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $a35b6540691ffd05$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $a35b6540691ffd05$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $a35b6540691ffd05$var$_objectSpread2["default"])((0, $a35b6540691ffd05$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $a35b6540691ffd05$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $a35b6540691ffd05$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $a35b6540691ffd05$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $a35b6540691ffd05$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $a35b6540691ffd05$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $a35b6540691ffd05$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $a35b6540691ffd05$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $a35b6540691ffd05$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $a35b6540691ffd05$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $a35b6540691ffd05$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $a35b6540691ffd05$var$useMemo(function() {
        return $a35b6540691ffd05$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bt114(false);
    else !!Array.isArray(fragmentRef) && $bt114(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bt114(false);
    var environment = $ctuwe();
    var loggerContext;
    if ($a35b6540691ffd05$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $2sjlB();
    var _useState = $a35b6540691ffd05$var$useState(function() {
        return $a35b6540691ffd05$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$a35b6540691ffd05$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $a35b6540691ffd05$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $a35b6540691ffd05$var$useRef(false);
    $a35b6540691ffd05$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $a35b6540691ffd05$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $a35b6540691ffd05$var$useMemo(function() {
            var missingClientEdges = $a35b6540691ffd05$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $a35b6540691ffd05$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $a35b6540691ffd05$var$useEffect(function() {
            var QueryResource = $a35b6540691ffd05$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $a35b6540691ffd05$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($a35b6540691ffd05$var$isMissingData(state)) {
        var suspendingLiveResolvers = $a35b6540691ffd05$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($a35b6540691ffd05$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$a35b6540691ffd05$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $bt114(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $a35b6540691ffd05$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $a35b6540691ffd05$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $a35b6540691ffd05$var$useRef(null);
    $a35b6540691ffd05$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $a35b6540691ffd05$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $a35b6540691ffd05$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $a35b6540691ffd05$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $a35b6540691ffd05$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $a35b6540691ffd05$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $bt114(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $bt114(false);
        data = state.snapshot.data;
    }
    if ($a35b6540691ffd05$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $a35b6540691ffd05$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("bAKMj", function(module, exports) {
'use strict';

var $5jBc1 = parcelRequire("5jBc1");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $870757b4fc3cc5f1$var$createOperationDescriptor = $4270B.createOperationDescriptor, $870757b4fc3cc5f1$var$getRequest = $4270B.getRequest;
var $870757b4fc3cc5f1$var$useMemo = $bSJIT.useMemo;
function $870757b4fc3cc5f1$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $5jBc1(variables);
    var memoCacheConfig = $5jBc1(cacheConfig || {});
    return $870757b4fc3cc5f1$var$useMemo(function() {
        return $870757b4fc3cc5f1$var$createOperationDescriptor($870757b4fc3cc5f1$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $870757b4fc3cc5f1$var$useMemoOperationDescriptor;

});
parcelRegister("5jBc1", function(module, exports) {
'use strict';

var $54oEM = parcelRequire("54oEM");

var $bSJIT = parcelRequire("bSJIT");
var $3deb93d9be569b8e$var$useState = $bSJIT.useState;
function $3deb93d9be569b8e$var$useMemoVariables(variables) {
    var _useState = $3deb93d9be569b8e$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($54oEM(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $3deb93d9be569b8e$var$useMemoVariables;

});




parcelRegister("bM0sC", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $892488e2829dc272$var$_interopRequireDefault = $vsDHM.default;

var $892488e2829dc272$var$_createForOfIteratorHelper2 = $892488e2829dc272$var$_interopRequireDefault((parcelRequire("itJC0")));

var $7XYjZ = parcelRequire("7XYjZ");

var $6lMcn = parcelRequire("6lMcn");

var $bSJIT = parcelRequire("bSJIT");
var $892488e2829dc272$var$useCallback = $bSJIT.useCallback, $892488e2829dc272$var$useEffect = $bSJIT.useEffect, $892488e2829dc272$var$useRef = $bSJIT.useRef, $892488e2829dc272$var$useState = $bSJIT.useState;
var $892488e2829dc272$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $892488e2829dc272$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $892488e2829dc272$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $6lMcn();
    var undisposedEntryPointReferencesRef = $892488e2829dc272$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $892488e2829dc272$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $892488e2829dc272$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $892488e2829dc272$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $892488e2829dc272$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $7XYjZ(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $892488e2829dc272$var$useRef(false);
    $892488e2829dc272$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $892488e2829dc272$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $892488e2829dc272$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $892488e2829dc272$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $892488e2829dc272$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $892488e2829dc272$var$useLoadEntryPoint;

});
parcelRegister("6lMcn", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");
var $49fa17761ce8ed04$var$useEffect = $bSJIT.useEffect, $49fa17761ce8ed04$var$useRef = $bSJIT.useRef;
function $49fa17761ce8ed04$var$useIsMountedRef() {
    var isMountedRef = $49fa17761ce8ed04$var$useRef(true);
    $49fa17761ce8ed04$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $49fa17761ce8ed04$var$useIsMountedRef;

});


parcelRegister("9g3NB", function(module, exports) {
'use strict';

var $axYGv = parcelRequire("axYGv");

var $22M0y = parcelRequire("22M0y");

var $bSJIT = parcelRequire("bSJIT");
var $6bd88e10a35bc1db$var$useDebugValue = $bSJIT.useDebugValue;

var $4270B = parcelRequire("4270B");
var $6bd88e10a35bc1db$var$getFragment = $4270B.getFragment;
function $6bd88e10a35bc1db$var$useFragment(fragment, key) {
    var fragmentNode = $6bd88e10a35bc1db$var$getFragment(fragment);
    $22M0y(fragmentNode, 'first argument of useFragment()');
    var data = $axYGv(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $6bd88e10a35bc1db$var$useFragment;

});
parcelRegister("22M0y", function(module, exports) {
'use strict';
parcelRequire("ehnPI");
parcelRequire("h4FgL");
function $17d102085a3f1cf0$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $17d102085a3f1cf0$var$useStaticFragmentNodeWarning;

});


parcelRegister("cF6oC", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $937e468417fccb67$var$_interopRequireDefault = $vsDHM.default;

var $937e468417fccb67$var$_objectSpread2 = $937e468417fccb67$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $6lMcn = parcelRequire("6lMcn");

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $937e468417fccb67$var$defaultCommitMutation = $4270B.commitMutation;
var $937e468417fccb67$var$useState = $bSJIT.useState, $937e468417fccb67$var$useEffect = $bSJIT.useEffect, $937e468417fccb67$var$useRef = $bSJIT.useRef, $937e468417fccb67$var$useCallback = $bSJIT.useCallback;
function $937e468417fccb67$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $937e468417fccb67$var$defaultCommitMutation;
    var environment = $ctuwe();
    var isMountedRef = $6lMcn();
    var environmentRef = $937e468417fccb67$var$useRef(environment);
    var mutationRef = $937e468417fccb67$var$useRef(mutation);
    var inFlightMutationsRef = $937e468417fccb67$var$useRef(new Set());
    var _useState = $937e468417fccb67$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $937e468417fccb67$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $937e468417fccb67$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $937e468417fccb67$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $937e468417fccb67$var$_objectSpread2["default"])((0, $937e468417fccb67$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $937e468417fccb67$var$useMutation;

});

parcelRegister("60gfm", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $45ef586ff5cc7038$var$_interopRequireDefault = $vsDHM.default;

var $45ef586ff5cc7038$var$_objectSpread2 = $45ef586ff5cc7038$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $57Nmh = parcelRequire("57Nmh");

var $1QuoU = parcelRequire("1QuoU");

var $ctuwe = parcelRequire("ctuwe");

var $22M0y = parcelRequire("22M0y");

var $bSJIT = parcelRequire("bSJIT");
var $45ef586ff5cc7038$var$useCallback = $bSJIT.useCallback, $45ef586ff5cc7038$var$useDebugValue = $bSJIT.useDebugValue, $45ef586ff5cc7038$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $45ef586ff5cc7038$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $45ef586ff5cc7038$var$getFragment = $4270B.getFragment, $45ef586ff5cc7038$var$getFragmentIdentifier = $4270B.getFragmentIdentifier, $45ef586ff5cc7038$var$getPaginationMetadata = $4270B.getPaginationMetadata;
function $45ef586ff5cc7038$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $45ef586ff5cc7038$var$getFragment(fragmentInput);
    $22M0y(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $45ef586ff5cc7038$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $1QuoU(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $45ef586ff5cc7038$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $45ef586ff5cc7038$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $45ef586ff5cc7038$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $45ef586ff5cc7038$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $45ef586ff5cc7038$var$_objectSpread2["default"])((0, $45ef586ff5cc7038$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $45ef586ff5cc7038$var$useLoadMore(args) {
    var environment = $ctuwe();
    var _useState = $45ef586ff5cc7038$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $45ef586ff5cc7038$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $57Nmh((0, $45ef586ff5cc7038$var$_objectSpread2["default"])((0, $45ef586ff5cc7038$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $45ef586ff5cc7038$var$usePaginationFragment;

});
parcelRegister("57Nmh", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $3bb3e4c1c6a6690e$var$_interopRequireDefault = $vsDHM.default;

var $3bb3e4c1c6a6690e$var$_objectSpread2 = $3bb3e4c1c6a6690e$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $hM8eg = parcelRequire("hM8eg");

var $bnOlH = parcelRequire("bnOlH");

var $6lMcn = parcelRequire("6lMcn");

var $bmeH7 = parcelRequire("bmeH7");

var $dHnZb = parcelRequire("dHnZb");

var $ctuwe = parcelRequire("ctuwe");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $3bb3e4c1c6a6690e$var$useCallback = $bSJIT.useCallback, $3bb3e4c1c6a6690e$var$useEffect = $bSJIT.useEffect, $3bb3e4c1c6a6690e$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $3bb3e4c1c6a6690e$var$fetchQuery = $4270B.__internal.fetchQuery, $3bb3e4c1c6a6690e$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $3bb3e4c1c6a6690e$var$createOperationDescriptor = $4270B.createOperationDescriptor, $3bb3e4c1c6a6690e$var$getPaginationVariables = $4270B.getPaginationVariables, $3bb3e4c1c6a6690e$var$getRefetchMetadata = $4270B.getRefetchMetadata, $3bb3e4c1c6a6690e$var$getSelector = $4270B.getSelector;
parcelRequire("h4FgL");
function $3bb3e4c1c6a6690e$var$useLoadMoreFunction(args) {
    if ($3bb3e4c1c6a6690e$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $dHnZb(args);
    return $3bb3e4c1c6a6690e$var$useLoadMoreFunction_CURRENT(args);
}
function $3bb3e4c1c6a6690e$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $ctuwe();
    var _useFetchTrackingRef = $bnOlH(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $3bb3e4c1c6a6690e$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $6lMcn();
    var _useState = $3bb3e4c1c6a6690e$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $3bb3e4c1c6a6690e$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $bmeH7(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $hM8eg(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $3bb3e4c1c6a6690e$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $3bb3e4c1c6a6690e$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $3bb3e4c1c6a6690e$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $bt114(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $3bb3e4c1c6a6690e$var$_objectSpread2["default"])((0, $3bb3e4c1c6a6690e$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $3bb3e4c1c6a6690e$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $3bb3e4c1c6a6690e$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $3bb3e4c1c6a6690e$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $3bb3e4c1c6a6690e$var$fetchQuery(environment, paginationQuery).subscribe((0, $3bb3e4c1c6a6690e$var$_objectSpread2["default"])((0, $3bb3e4c1c6a6690e$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $3bb3e4c1c6a6690e$var$useLoadMoreFunction;

});
parcelRegister("hM8eg", function(module, exports) {
'use strict';

var $bt114 = parcelRequire("bt114");

var $4270B = parcelRequire("4270B");
var $cf0d4d7e08c00acd$var$ConnectionInterface = $4270B.ConnectionInterface, $cf0d4d7e08c00acd$var$getValueAtPath = $4270B.getValueAtPath;
function $cf0d4d7e08c00acd$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $cf0d4d7e08c00acd$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $cf0d4d7e08c00acd$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $bt114(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $bt114(false);
    !(typeof pageInfo === 'object') && $bt114(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $bt114(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $cf0d4d7e08c00acd$var$getConnectionState;

});

parcelRegister("bmeH7", function(module, exports) {
'use strict';

var $ctuwe = parcelRequire("ctuwe");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");
var $844d25c84435d737$var$getObservableForActiveRequest = $4270B.__internal.getObservableForActiveRequest, $844d25c84435d737$var$getSelector = $4270B.getSelector;
var $844d25c84435d737$var$useEffect = $bSJIT.useEffect, $844d25c84435d737$var$useState = $bSJIT.useState, $844d25c84435d737$var$useMemo = $bSJIT.useMemo;
function $844d25c84435d737$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $ctuwe();
    var observable = $844d25c84435d737$var$useMemo(function() {
        var selector = $844d25c84435d737$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $bt114(false);
        return $844d25c84435d737$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $844d25c84435d737$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $844d25c84435d737$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $844d25c84435d737$var$useIsOperationNodeActive;

});

parcelRegister("dHnZb", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $9f91e59e0f3c7a92$var$_interopRequireDefault = $vsDHM.default;

var $9f91e59e0f3c7a92$var$_objectSpread2 = $9f91e59e0f3c7a92$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $hM8eg = parcelRequire("hM8eg");

var $6lMcn = parcelRequire("6lMcn");

var $bmeH7 = parcelRequire("bmeH7");

var $ctuwe = parcelRequire("ctuwe");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $9f91e59e0f3c7a92$var$useCallback = $bSJIT.useCallback, $9f91e59e0f3c7a92$var$useRef = $bSJIT.useRef, $9f91e59e0f3c7a92$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $9f91e59e0f3c7a92$var$fetchQuery = $4270B.__internal.fetchQuery, $9f91e59e0f3c7a92$var$createOperationDescriptor = $4270B.createOperationDescriptor, $9f91e59e0f3c7a92$var$getPaginationVariables = $4270B.getPaginationVariables, $9f91e59e0f3c7a92$var$getRefetchMetadata = $4270B.getRefetchMetadata, $9f91e59e0f3c7a92$var$getSelector = $4270B.getSelector;
parcelRequire("h4FgL");
function $9f91e59e0f3c7a92$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $ctuwe();
    var _getRefetchMetadata = $9f91e59e0f3c7a92$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $9f91e59e0f3c7a92$var$useRef({
        kind: 'none'
    });
    var _useState = $9f91e59e0f3c7a92$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $9f91e59e0f3c7a92$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $bmeH7(fragmentNode, fragmentRef);
    var forceDisposeFn = $9f91e59e0f3c7a92$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $hM8eg(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $6lMcn();
    var loadMore = $9f91e59e0f3c7a92$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $9f91e59e0f3c7a92$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $bt114(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $9f91e59e0f3c7a92$var$_objectSpread2["default"])((0, $9f91e59e0f3c7a92$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $9f91e59e0f3c7a92$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $9f91e59e0f3c7a92$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $9f91e59e0f3c7a92$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $9f91e59e0f3c7a92$var$fetchQuery(environment, paginationQuery).subscribe((0, $9f91e59e0f3c7a92$var$_objectSpread2["default"])((0, $9f91e59e0f3c7a92$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $9f91e59e0f3c7a92$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("1QuoU", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $15823abcb038f5ae$var$_interopRequireDefault = $vsDHM.default;

var $15823abcb038f5ae$var$_objectSpread2 = $15823abcb038f5ae$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $h8qaV = parcelRequire("h8qaV");

var $lLnw7 = parcelRequire("lLnw7");
var $15823abcb038f5ae$var$getQueryResourceForEnvironment = $lLnw7.getQueryResourceForEnvironment;

var $4pD6n = parcelRequire("4pD6n");

var $axYGv = parcelRequire("axYGv");

var $6lMcn = parcelRequire("6lMcn");

var $jOt5L = parcelRequire("jOt5L");

var $ctuwe = parcelRequire("ctuwe");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $15823abcb038f5ae$var$useCallback = $bSJIT.useCallback, $15823abcb038f5ae$var$useContext = $bSJIT.useContext, $15823abcb038f5ae$var$useReducer = $bSJIT.useReducer;

var $4270B = parcelRequire("4270B");
var $15823abcb038f5ae$var$fetchQuery = $4270B.__internal.fetchQuery, $15823abcb038f5ae$var$createOperationDescriptor = $4270B.createOperationDescriptor, $15823abcb038f5ae$var$getFragmentIdentifier = $4270B.getFragmentIdentifier, $15823abcb038f5ae$var$getRefetchMetadata = $4270B.getRefetchMetadata, $15823abcb038f5ae$var$getSelector = $4270B.getSelector, $15823abcb038f5ae$var$getValueAtPath = $4270B.getValueAtPath;
parcelRequire("h4FgL");
function $15823abcb038f5ae$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $15823abcb038f5ae$var$_objectSpread2["default"])((0, $15823abcb038f5ae$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $15823abcb038f5ae$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $ctuwe();
    var _getRefetchMetadata = $15823abcb038f5ae$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $15823abcb038f5ae$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $15823abcb038f5ae$var$useReducer($15823abcb038f5ae$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $15823abcb038f5ae$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $15823abcb038f5ae$var$useContext($h8qaV);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $jOt5L(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $15823abcb038f5ae$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $4pD6n(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $bt114(false);
        var refetchedFragmentRef = $15823abcb038f5ae$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $axYGv(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $15823abcb038f5ae$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $15823abcb038f5ae$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $6lMcn();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $15823abcb038f5ae$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $15823abcb038f5ae$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $15823abcb038f5ae$var$_objectSpread2["default"])((0, $15823abcb038f5ae$var$_objectSpread2["default"])((0, $15823abcb038f5ae$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $15823abcb038f5ae$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $15823abcb038f5ae$var$debugFunctions;
module.exports = $15823abcb038f5ae$var$useRefetchableFragmentInternal;

});
parcelRegister("4pD6n", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $3367d40e0ca08693$var$_interopRequireDefault = $vsDHM.default;

var $3367d40e0ca08693$var$_objectSpread2 = $3367d40e0ca08693$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $3367d40e0ca08693$var$_createForOfIteratorHelper2 = $3367d40e0ca08693$var$_interopRequireDefault((parcelRequire("itJC0")));

var $lLnw7 = parcelRequire("lLnw7");
var $3367d40e0ca08693$var$getQueryResourceForEnvironment = $lLnw7.getQueryResourceForEnvironment;

var $bt114 = parcelRequire("bt114");

var $4270B = parcelRequire("4270B");
var $3367d40e0ca08693$var$fetchQueryInternal = $4270B.__internal.fetchQuery, $3367d40e0ca08693$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $3367d40e0ca08693$var$createOperationDescriptor = $4270B.createOperationDescriptor, $3367d40e0ca08693$var$getPendingOperationsForFragment = $4270B.getPendingOperationsForFragment, $3367d40e0ca08693$var$getSelector = $4270B.getSelector, $3367d40e0ca08693$var$getVariablesFromFragment = $4270B.getVariablesFromFragment, $3367d40e0ca08693$var$handlePotentialSnapshotErrors = $4270B.handlePotentialSnapshotErrors;
parcelRequire("h4FgL");
function $3367d40e0ca08693$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $3367d40e0ca08693$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $3367d40e0ca08693$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $3367d40e0ca08693$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $3367d40e0ca08693$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $3367d40e0ca08693$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $3367d40e0ca08693$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $3367d40e0ca08693$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $3367d40e0ca08693$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $3367d40e0ca08693$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $3367d40e0ca08693$var$_objectSpread2["default"])((0, $3367d40e0ca08693$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $3367d40e0ca08693$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $3367d40e0ca08693$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $3367d40e0ca08693$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $3367d40e0ca08693$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $3367d40e0ca08693$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $3367d40e0ca08693$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bt114(false);
    else !!Array.isArray(fragmentRef) && $bt114(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bt114(false);
    var state = $3367d40e0ca08693$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $3367d40e0ca08693$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $3367d40e0ca08693$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $3367d40e0ca08693$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($3367d40e0ca08693$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($3367d40e0ca08693$var$isMissingData(state)) {
        !(fragmentSelector != null) && $bt114(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $3367d40e0ca08693$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $3367d40e0ca08693$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($3367d40e0ca08693$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $3367d40e0ca08693$var$readFragmentInternal;

});

parcelRegister("jOt5L", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $e6c940de85614b4f$var$_interopRequireDefault = $vsDHM.default;

var $e6c940de85614b4f$var$_createForOfIteratorHelper2 = $e6c940de85614b4f$var$_interopRequireDefault((parcelRequire("itJC0")));

var $lR6HQ = parcelRequire("lR6HQ");
var $e6c940de85614b4f$var$loadQuery = $lR6HQ.loadQuery;

var $6lMcn = parcelRequire("6lMcn");

var $5RGoW = parcelRequire("5RGoW");

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");
var $e6c940de85614b4f$var$useCallback = $bSJIT.useCallback, $e6c940de85614b4f$var$useEffect = $bSJIT.useEffect, $e6c940de85614b4f$var$useRef = $bSJIT.useRef, $e6c940de85614b4f$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $e6c940de85614b4f$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $e6c940de85614b4f$var$getRequest = $4270B.getRequest;
var $e6c940de85614b4f$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $e6c940de85614b4f$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $e6c940de85614b4f$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $e6c940de85614b4f$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($e6c940de85614b4f$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $5RGoW(preloadableRequest, initialQueryReference);
    return $e6c940de85614b4f$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $e6c940de85614b4f$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $e6c940de85614b4f$var$initialNullQueryReferenceState;
    var environment = $ctuwe();
    var isMountedRef = $6lMcn();
    var undisposedQueryReferencesRef = $e6c940de85614b4f$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $e6c940de85614b4f$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $e6c940de85614b4f$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $e6c940de85614b4f$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($e6c940de85614b4f$var$initialNullQueryReferenceState);
            setQueryReference($e6c940de85614b4f$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $e6c940de85614b4f$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $e6c940de85614b4f$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $e6c940de85614b4f$var$useRef(false);
    $e6c940de85614b4f$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $e6c940de85614b4f$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $e6c940de85614b4f$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($e6c940de85614b4f$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $e6c940de85614b4f$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $e6c940de85614b4f$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($e6c940de85614b4f$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $e6c940de85614b4f$var$useQueryLoader;

});
parcelRegister("5RGoW", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $4452cafe509f7198$var$_interopRequireDefault = $vsDHM.default;

var $4452cafe509f7198$var$_createForOfIteratorHelper2 = $4452cafe509f7198$var$_interopRequireDefault((parcelRequire("itJC0")));

var $lR6HQ = parcelRequire("lR6HQ");
var $4452cafe509f7198$var$loadQuery = $lR6HQ.loadQuery;

var $6lMcn = parcelRequire("6lMcn");

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");
var $4452cafe509f7198$var$useCallback = $bSJIT.useCallback, $4452cafe509f7198$var$useEffect = $bSJIT.useEffect, $4452cafe509f7198$var$useInsertionEffect = $bSJIT.useInsertionEffect, $4452cafe509f7198$var$useRef = $bSJIT.useRef, $4452cafe509f7198$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $4452cafe509f7198$var$getRequest = $4270B.getRequest;
var $4452cafe509f7198$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $4452cafe509f7198$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $4452cafe509f7198$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $4452cafe509f7198$var$CLEANUP_TIMEOUT = 300000;
function $4452cafe509f7198$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $4452cafe509f7198$var$initialNullQueryReferenceState;
    var environment = $ctuwe();
    var isMountedRef = $6lMcn();
    var undisposedQueryReferencesRef = $4452cafe509f7198$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $4452cafe509f7198$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $4452cafe509f7198$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $4452cafe509f7198$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($4452cafe509f7198$var$initialNullQueryReferenceState);
            setQueryReference($4452cafe509f7198$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $4452cafe509f7198$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $4452cafe509f7198$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $4452cafe509f7198$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $4452cafe509f7198$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($4452cafe509f7198$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $4452cafe509f7198$var$useRef(null);
    $4452cafe509f7198$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $4452cafe509f7198$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $4452cafe509f7198$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $4452cafe509f7198$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("eHdgl", function(module, exports) {
'use strict';

var $vsDHM = parcelRequire("vsDHM");
var $ab2f5e8947e20772$var$_interopRequireDefault = $vsDHM.default;

var $ab2f5e8947e20772$var$_objectSpread2 = $ab2f5e8947e20772$var$_interopRequireDefault((parcelRequire("5bEq2")));

var $9g3NB = parcelRequire("9g3NB");

var $57Nmh = parcelRequire("57Nmh");

var $1QuoU = parcelRequire("1QuoU");

var $ctuwe = parcelRequire("ctuwe");

var $22M0y = parcelRequire("22M0y");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $ab2f5e8947e20772$var$useCallback = $bSJIT.useCallback, $ab2f5e8947e20772$var$useDebugValue = $bSJIT.useDebugValue, $ab2f5e8947e20772$var$useEffect = $bSJIT.useEffect, $ab2f5e8947e20772$var$useLayoutEffect = $bSJIT.useLayoutEffect, $ab2f5e8947e20772$var$useMemo = $bSJIT.useMemo, $ab2f5e8947e20772$var$useRef = $bSJIT.useRef, $ab2f5e8947e20772$var$useState = $bSJIT.useState;

var $4270B = parcelRequire("4270B");
var $ab2f5e8947e20772$var$getFragment = $4270B.getFragment, $ab2f5e8947e20772$var$getFragmentIdentifier = $4270B.getFragmentIdentifier, $ab2f5e8947e20772$var$getPaginationMetadata = $4270B.getPaginationMetadata;

var $4270B = parcelRequire("4270B");
var $ab2f5e8947e20772$var$ConnectionInterface = $4270B.ConnectionInterface, $ab2f5e8947e20772$var$RelayFeatureFlags = $4270B.RelayFeatureFlags, $ab2f5e8947e20772$var$getSelector = $4270B.getSelector, $ab2f5e8947e20772$var$getValueAtPath = $4270B.getValueAtPath;
function $ab2f5e8947e20772$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $ab2f5e8947e20772$var$getFragment(fragmentInput);
    $22M0y(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $ab2f5e8947e20772$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $1QuoU(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $ab2f5e8947e20772$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $ab2f5e8947e20772$var$useMemo(function() {
        var connection = $ab2f5e8947e20772$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $ab2f5e8947e20772$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $ab2f5e8947e20772$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $ctuwe();
    var _useState2 = $ab2f5e8947e20772$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $ab2f5e8947e20772$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $ab2f5e8947e20772$var$useRef(0);
    var setIsLoadingMore = $ab2f5e8947e20772$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $ab2f5e8947e20772$var$useRef(false);
    var observer = $ab2f5e8947e20772$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $ab2f5e8947e20772$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $ab2f5e8947e20772$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $57Nmh({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $ab2f5e8947e20772$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $ab2f5e8947e20772$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $ab2f5e8947e20772$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $bt114(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $bt114(false);
    $ab2f5e8947e20772$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $ab2f5e8947e20772$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $bt114(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $ab2f5e8947e20772$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $9g3NB(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $ab2f5e8947e20772$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $ab2f5e8947e20772$var$_objectSpread2["default"])((0, $ab2f5e8947e20772$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $ab2f5e8947e20772$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("gBm2Y", function(module, exports) {
'use strict';

var $7zQVQ = parcelRequire("7zQVQ");

var $bAKMj = parcelRequire("bAKMj");

var $ctuwe = parcelRequire("ctuwe");

var $bt114 = parcelRequire("bt114");

var $bSJIT = parcelRequire("bSJIT");
var $c161341979b51111$var$useDebugValue = $bSJIT.useDebugValue;

var $4270B = parcelRequire("4270B");
var $c161341979b51111$var$_require2$__internal = $4270B.__internal, $c161341979b51111$var$fetchQueryDeduped = $c161341979b51111$var$_require2$__internal.fetchQueryDeduped, $c161341979b51111$var$fetchQuery = $c161341979b51111$var$_require2$__internal.fetchQuery;
parcelRequire("h4FgL");
function $c161341979b51111$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $ctuwe();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $bAKMj(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $bt114(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $c161341979b51111$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $c161341979b51111$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $7zQVQ(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $c161341979b51111$var$usePreloadedQuery;

});

parcelRegister("7Bqx6", function(module, exports) {
'use strict';

var $1QuoU = parcelRequire("1QuoU");

var $22M0y = parcelRequire("22M0y");

var $bSJIT = parcelRequire("bSJIT");
var $58909202415c1602$var$useDebugValue = $bSJIT.useDebugValue;

var $4270B = parcelRequire("4270B");
var $58909202415c1602$var$getFragment = $4270B.getFragment;
function $58909202415c1602$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $58909202415c1602$var$getFragment(fragmentInput);
    $22M0y(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $1QuoU(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $58909202415c1602$var$useRefetchableFragment;

});

parcelRegister("eu5v5", function(module, exports) {
'use strict';

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");
var $a8b822453a1d2f66$var$useEffect = $bSJIT.useEffect, $a8b822453a1d2f66$var$useRef = $bSJIT.useRef;
function $a8b822453a1d2f66$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $ctuwe();
    var disposableRef = $a8b822453a1d2f66$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $a8b822453a1d2f66$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $a8b822453a1d2f66$var$useSubscribeToInvalidationState;

});

parcelRegister("iwELz", function(module, exports) {
'use strict';

var $ctuwe = parcelRequire("ctuwe");

var $bSJIT = parcelRequire("bSJIT");
var $d7cad676035a8042$var$useEffect = $bSJIT.useEffect;

var $4270B = parcelRequire("4270B");
var $d7cad676035a8042$var$requestSubscription = $4270B.requestSubscription;
function $d7cad676035a8042$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $d7cad676035a8042$var$requestSubscription;
    var environment = $ctuwe();
    $d7cad676035a8042$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $d7cad676035a8042$var$useSubscription;

});



parcelRegister("j6ZrI", function(module, exports) {
$parcel$export(module.exports, "updateUserModelAction", () => (parcelRequire("kd70W")).updateUserModelAction);
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => (parcelRequire("kd70W")).UPDATE_USER_MODEL);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => (parcelRequire("kd70W")).updateUserModelAnonymousAction);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => (parcelRequire("kd70W")).UPDATE_USER_TO_ANON);
$parcel$export(module.exports, "saveUserProfile", () => (parcelRequire("kd70W")).saveUserProfile);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => (parcelRequire("kd70W")).SAVE_USER_PROFILE);
$parcel$export(module.exports, "saveUserProfileFailure", () => (parcelRequire("kd70W")).saveUserProfileFailure);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => (parcelRequire("kd70W")).SAVE_USER_PROFILE_FAILURE);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => (parcelRequire("kd70W")).setUserProfileValidationErrors);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => (parcelRequire("kd70W")).SET_USER_PROFILE_VALIDATION_ERRORS);
$parcel$export(module.exports, "saveUserProfileSuccess", () => (parcelRequire("kd70W")).saveUserProfileSuccess);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => (parcelRequire("kd70W")).SAVE_USER_PROFILE_SUCCESS);
$parcel$export(module.exports, "showChangePasswordDialog", () => (parcelRequire("kd70W")).showChangePasswordDialog);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("kd70W")).SHOW_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "closeChangePasswordDialog", () => (parcelRequire("kd70W")).closeChangePasswordDialog);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("kd70W")).CLOSE_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => (parcelRequire("kd70W")).validateAndSavePasswordChange);
$parcel$export(module.exports, "validatePassword", () => (parcelRequire("kd70W")).validatePassword);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => (parcelRequire("kd70W")).VALIDATE_PASSWORD);
$parcel$export(module.exports, "validatePasswordSuccess", () => (parcelRequire("kd70W")).validatePasswordSuccess);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => (parcelRequire("kd70W")).VALIDATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => (parcelRequire("kd70W")).VALIDATE_AND_SAVE_PASSWORD_CHANGE);
$parcel$export(module.exports, "changePassword", () => (parcelRequire("kd70W")).changePassword);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => (parcelRequire("kd70W")).CHANGE_PASSWORD);
$parcel$export(module.exports, "changePasswordFailure", () => (parcelRequire("kd70W")).changePasswordFailure);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => (parcelRequire("kd70W")).CHANGE_PASSWORD_FAILURE);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => (parcelRequire("kd70W")).CHANGE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "successfullyLoggedIn", () => (parcelRequire("kd70W")).successfullyLoggedIn);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => (parcelRequire("kd70W")).SUCCESSFULLY_LOGGED_IN);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => (parcelRequire("kd70W")).UPDATE_USER_REQUESTS_COUNTS_MODEL);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("kd70W")).forgotPassword);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("kd70W")).forgotPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordFailure", () => (parcelRequire("kd70W")).forgotPasswordFailure);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => (parcelRequire("kd70W")).USER_PROFILE_FORGOT_PASSWORD);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("kd70W")).USER_PROFILE_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("kd70W")).USER_PROFILE_FORGOT_PASSWORD_FAILURE);

var $kd70W = parcelRequire("kd70W");

});
parcelRegister("kd70W", function(module, exports) {
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => $80facd60deedfdad$export$bb738d1d47f9c080);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => $80facd60deedfdad$export$e2e5f617828e4213);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => $80facd60deedfdad$export$b1b3790fd3dd41e);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => $80facd60deedfdad$export$ed8e9a22a73d5238);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => $80facd60deedfdad$export$c705a7e05c58a85d);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => $80facd60deedfdad$export$617cd283d6722784);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => $80facd60deedfdad$export$9e99a97090f99b20);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => $80facd60deedfdad$export$dbaf6c31aeaab4c0);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => $80facd60deedfdad$export$15f268d233a1a9e8);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => $80facd60deedfdad$export$5ea2388969a07735);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => $80facd60deedfdad$export$d4203d6239c0a45f);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => $80facd60deedfdad$export$2776cc46c0e74482);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => $80facd60deedfdad$export$87c02ba615b030f7);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => $80facd60deedfdad$export$67e8c4b0fd356271);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => $80facd60deedfdad$export$52dd5c72d66642a1);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => $80facd60deedfdad$export$8095eb34b5a9bf48);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => $80facd60deedfdad$export$b03aac23a3b960e0);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => $80facd60deedfdad$export$fd1274b492be3442);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => $80facd60deedfdad$export$228c8378e3cf38db);
$parcel$export(module.exports, "updateUserModelAction", () => $80facd60deedfdad$export$e64d70be6597f269);
$parcel$export(module.exports, "updateUserRequestsCountsAction", () => $80facd60deedfdad$export$8de1e14d714c3764);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => $80facd60deedfdad$export$c79034a87b96133d);
$parcel$export(module.exports, "saveUserProfile", () => $80facd60deedfdad$export$12b30392f405d671);
$parcel$export(module.exports, "saveUserProfileSuccess", () => $80facd60deedfdad$export$7ded1c1b185ee372);
$parcel$export(module.exports, "saveUserProfileFailure", () => $80facd60deedfdad$export$bb55fe7965c57a31);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => $80facd60deedfdad$export$f5417889851341ee);
$parcel$export(module.exports, "showChangePasswordDialog", () => $80facd60deedfdad$export$b473bd12e6a9a566);
$parcel$export(module.exports, "closeChangePasswordDialog", () => $80facd60deedfdad$export$1a2f283b7350e33f);
$parcel$export(module.exports, "validatePassword", () => $80facd60deedfdad$export$4d2a7159fda5dc93);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => $80facd60deedfdad$export$3d37c4744747732c);
$parcel$export(module.exports, "changePassword", () => $80facd60deedfdad$export$99d837dc30eb1ef7);
$parcel$export(module.exports, "validatePasswordSuccess", () => $80facd60deedfdad$export$6c2ac98735d96a42);
$parcel$export(module.exports, "changePasswordFailure", () => $80facd60deedfdad$export$a60289eb7ee45981);
$parcel$export(module.exports, "successfullyLoggedIn", () => $80facd60deedfdad$export$ffc865c9cfe87560);
$parcel$export(module.exports, "forgotPassword", () => $80facd60deedfdad$export$66791fb2cfeec3e);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $80facd60deedfdad$export$e65d2e9031cf7578);
$parcel$export(module.exports, "forgotPasswordFailure", () => $80facd60deedfdad$export$c82fc620622643dd);
const $80facd60deedfdad$export$bb738d1d47f9c080 = 'state.persisted.user.UPDATE_USER_MODEL';
const $80facd60deedfdad$export$e2e5f617828e4213 = 'state.persisted.user.UPDATE_USER_REQUESTS_COUNTS_MODEL';
const $80facd60deedfdad$export$b1b3790fd3dd41e = 'state.persisted.user.UPDATE_USER_TO_ANON';
const $80facd60deedfdad$export$ed8e9a22a73d5238 = 'state.persisted.user.SAVE_USER_PROFILE';
const $80facd60deedfdad$export$c705a7e05c58a85d = 'state.persisted.user.SAVE_USER_PROFILE_SUCCESS';
const $80facd60deedfdad$export$617cd283d6722784 = 'state.persisted.user.SAVE_USER_PROFILE_FAILURE';
const $80facd60deedfdad$export$9e99a97090f99b20 = 'state.persisted.user.SET_USER_PROFILE_VALIDATION_ERRORS';
const $80facd60deedfdad$export$dbaf6c31aeaab4c0 = 'state.persisted.user.SUCCESSFULLY_LOGGED_IN';
const $80facd60deedfdad$export$15f268d233a1a9e8 = 'state.ui.user.profile.SHOW_CHANGE_PASSWORD_DIALOG';
const $80facd60deedfdad$export$5ea2388969a07735 = 'state.ui.user.profile.CLOSE_CHANGE_PASSWORD_DIALOG';
const $80facd60deedfdad$export$d4203d6239c0a45f = 'state.persisted.user.VALIDATE_AND_SAVE_PASSWORD_CHANGE';
const $80facd60deedfdad$export$2776cc46c0e74482 = 'state.persisted.user.VALIDATE_PASSWORD';
const $80facd60deedfdad$export$87c02ba615b030f7 = 'state.persisted.user.VALIDATE_PASSWORD_SUCCESS';
const $80facd60deedfdad$export$67e8c4b0fd356271 = 'state.persisted.user.CHANGE_PASSWORD';
const $80facd60deedfdad$export$52dd5c72d66642a1 = 'state.persisted.user.CHANGE_PASSWORD_SUCCESS';
const $80facd60deedfdad$export$8095eb34b5a9bf48 = 'state.persisted.user.CHANGE_PASSWORD_FAILURE';
const $80facd60deedfdad$export$b03aac23a3b960e0 = 'state.ui.user.profile.FORGOT_PASSWORD';
const $80facd60deedfdad$export$fd1274b492be3442 = 'state.ui.user.profile.FORGOT_PASSWORD_SUCCESS';
const $80facd60deedfdad$export$228c8378e3cf38db = 'state.ui.user.profile.FORGOT_PASSWORD_FAILURE';
const $80facd60deedfdad$export$e64d70be6597f269 = (userResponse)=>({
        payload: userResponse,
        type: $80facd60deedfdad$export$bb738d1d47f9c080
    });
const $80facd60deedfdad$export$8de1e14d714c3764 = (userRequestsCountsResponse)=>({
        payload: userRequestsCountsResponse,
        type: $80facd60deedfdad$export$e2e5f617828e4213
    });
const $80facd60deedfdad$export$c79034a87b96133d = ()=>({
        type: $80facd60deedfdad$export$b1b3790fd3dd41e
    });
const $80facd60deedfdad$export$12b30392f405d671 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $80facd60deedfdad$export$ed8e9a22a73d5238
    });
const $80facd60deedfdad$export$7ded1c1b185ee372 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $80facd60deedfdad$export$c705a7e05c58a85d
    });
const $80facd60deedfdad$export$bb55fe7965c57a31 = ()=>({
        type: $80facd60deedfdad$export$617cd283d6722784
    });
const $80facd60deedfdad$export$f5417889851341ee = (nameError, timezoneError)=>({
        payload: {
            nameError: nameError,
            timezoneError: timezoneError
        },
        type: $80facd60deedfdad$export$9e99a97090f99b20
    });
const $80facd60deedfdad$export$b473bd12e6a9a566 = ()=>({
        type: $80facd60deedfdad$export$15f268d233a1a9e8
    });
const $80facd60deedfdad$export$1a2f283b7350e33f = ()=>({
        type: $80facd60deedfdad$export$5ea2388969a07735
    });
const $80facd60deedfdad$export$4d2a7159fda5dc93 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $80facd60deedfdad$export$2776cc46c0e74482
    });
const $80facd60deedfdad$export$3d37c4744747732c = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $80facd60deedfdad$export$d4203d6239c0a45f
    });
const $80facd60deedfdad$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $80facd60deedfdad$export$67e8c4b0fd356271
    });
const $80facd60deedfdad$export$6c2ac98735d96a42 = ()=>({
        type: $80facd60deedfdad$export$87c02ba615b030f7
    });
const $80facd60deedfdad$export$592a066e988f52df = ()=>({
        type: $80facd60deedfdad$export$52dd5c72d66642a1
    });
const $80facd60deedfdad$export$a60289eb7ee45981 = (currentPasswordError, newPasswordError, confirmPasswordError, generalError)=>({
        payload: {
            currentPasswordError: currentPasswordError,
            newPasswordError: newPasswordError,
            confirmPasswordError: confirmPasswordError,
            generalError: generalError
        },
        type: $80facd60deedfdad$export$8095eb34b5a9bf48
    });
const $80facd60deedfdad$export$ffc865c9cfe87560 = ()=>{
    return {
        type: $80facd60deedfdad$export$dbaf6c31aeaab4c0
    };
};
const $80facd60deedfdad$export$66791fb2cfeec3e = (resetUrl, email, createAnalyticsEvent)=>({
        type: $80facd60deedfdad$export$b03aac23a3b960e0,
        payload: {
            resetUrl: resetUrl,
            email: email,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $80facd60deedfdad$export$e65d2e9031cf7578 = ()=>({
        type: $80facd60deedfdad$export$fd1274b492be3442
    });
const $80facd60deedfdad$export$c82fc620622643dd = ()=>({
        type: $80facd60deedfdad$export$228c8378e3cf38db
    });

});


parcelRegister("qR04C", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdcae6f7436497ad$export$2e2bcd8739ae039);
parcelRequire("1mIIj");
var $7Fvyo = parcelRequire("7Fvyo");
var $j5nqc = parcelRequire("j5nqc");
var $6LgZh = parcelRequire("6LgZh");
var $5nEeT = parcelRequire("5nEeT");
parcelRequire("2ycHZ");
var $58g8v = parcelRequire("58g8v");

var $i2Moh = parcelRequire("i2Moh");

var $fXrKb = parcelRequire("fXrKb");

var $a30Ux = parcelRequire("a30Ux");

var $1cJoI = parcelRequire("1cJoI");
const $cdcae6f7436497ad$var$createReducer = (asyncPersistedReducers, asyncUIReducers)=>{
    const persisted = (0, $fXrKb.getCombinedPersistedReducer)(asyncPersistedReducers);
    const ui = (0, $1cJoI.getCombinedUIReducer)(asyncUIReducers);
    return (0, $j5nqc.default)({
        persisted: persisted,
        ui: ui
    });
};
/**
 * Sometimes we want to run storybooks as standalone apps so we can embed them. In that case they
 * behave a little differently to when they are embedded inside the Storybook application frame.
 * This checks a query parameter to make sure we don't run into CORS issues.
 *
 * @returns True if we're in a storybook and it's being embedded outside the usual storybook frame.
 */ const $cdcae6f7436497ad$var$isStandaloneStory = ()=>{
    const params = new URLSearchParams(window.location.search);
    return (params.get('singleStory') || params.get('singlestory')) === 'true';
};
function $cdcae6f7436497ad$export$2e2bcd8739ae039({ initialState: initialState, middleware: middleware = [], initializeEpics: initializeEpics = true } = {}) {
    // Enables redux for storybook
    // trueWindow will hold the value of the window in which portal is loaded
    let trueWindow;
    // if portal is loaded inside an iframe, window.self will not be equal to window.top
    if ($cdcae6f7436497ad$var$isStandaloneStory() || window.self !== window.top) trueWindow = window.self || window;
    else trueWindow = window.parent || window;
    const composeEnhancers = trueWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $6LgZh.default);
    const epicMiddlewares = initializeEpics ? [
        (0, $58g8v.createEpicMiddleware)((0, $i2Moh.default))
    ] : [];
    const store = (0, $5nEeT.default)((0, $a30Ux.default), initialState || {}, composeEnhancers((0, $7Fvyo.default)(...epicMiddlewares, ...middleware)));
    let asyncPersistedReducers = {};
    let asyncUIReducers = {};
    const injectReducer = (storeType, key, asyncReducer)=>{
        if (storeType === 'ui') asyncUIReducers = {
            ...asyncUIReducers,
            [key]: asyncReducer
        };
        if (storeType === 'persisted') asyncPersistedReducers = {
            ...asyncPersistedReducers,
            [key]: asyncReducer
        };
        store.replaceReducer($cdcae6f7436497ad$var$createReducer(asyncPersistedReducers, asyncUIReducers));
    };
    return {
        store: store,
        injectReducer: injectReducer
    };
}

});
parcelRegister("2ycHZ", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => (parcelRequire("58g8v")).createEpicMiddleware);
$parcel$export(module.exports, "combineEpics", () => (parcelRequire("4nFla")).combineEpics);

var $58g8v = parcelRequire("58g8v");

var $kaZSy = parcelRequire("kaZSy");

var $4nFla = parcelRequire("4nFla");

var $gOck1 = parcelRequire("gOck1");

var $aKVpz = parcelRequire("aKVpz");

});
parcelRegister("58g8v", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => $3bca376980412c2f$export$147cf6f7ce5462cb);

var $gJqoA = parcelRequire("gJqoA");

var $7gHg9 = parcelRequire("7gHg9");

var $jTG1y = parcelRequire("jTG1y");

var $kaZSy = parcelRequire("kaZSy");

var $gOck1 = parcelRequire("gOck1");
var $3bca376980412c2f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3bca376980412c2f$var$defaultAdapter = {
    input: function input(action$) {
        return action$;
    },
    output: function output(action$) {
        return action$;
    }
};
var $3bca376980412c2f$var$defaultOptions = {
    adapter: $3bca376980412c2f$var$defaultAdapter
};
function $3bca376980412c2f$export$147cf6f7ce5462cb(rootEpic) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3bca376980412c2f$var$defaultOptions;
    if (typeof rootEpic !== 'function') throw new TypeError('You must provide a root Epic to createEpicMiddleware');
    // even though we used default param, we need to merge the defaults
    // inside the options object as well in case they declare only some
    options = $3bca376980412c2f$var$_extends({}, $3bca376980412c2f$var$defaultOptions, options);
    var input$ = new (0, $gJqoA.Subject)();
    var action$ = options.adapter.input(new (0, $kaZSy.ActionsObservable)(input$));
    var epic$ = new (0, $gJqoA.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        return function(next) {
            var _context;
            (_context = (0, $7gHg9.map).call(epic$, function(epic) {
                var vault = store;
                var output$ = 'dependencies' in options ? epic(action$, vault, options.dependencies) : epic(action$, vault);
                if (!output$) throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
                return output$;
            }), $jTG1y.switchMap).call(_context, function(output$) {
                return options.adapter.output(output$);
            }).subscribe(store.dispatch);
            // Setup initial root epic
            epic$.next(rootEpic);
            return function(action) {
                var result = next(action);
                input$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.replaceEpic = function(rootEpic) {
        // gives the previous root Epic a last chance
        // to do some clean up
        store.dispatch({
            type: (0, $gOck1.EPIC_END)
        });
        // switches to the new root Epic, synchronously terminating
        // the previous one
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

});
parcelRegister("7gHg9", function(module, exports) {
$parcel$export(module.exports, "map", () => $54ab9576d59719cc$export$871de8747c9eaa88, (v) => $54ab9576d59719cc$export$871de8747c9eaa88 = v);
var $54ab9576d59719cc$export$871de8747c9eaa88;
"use strict";

var $bP9Wc = parcelRequire("bP9Wc");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $54ab9576d59719cc$var$map(project, thisArg) {
    return $bP9Wc.map(project, thisArg)(this);
}
$54ab9576d59719cc$export$871de8747c9eaa88 = $54ab9576d59719cc$var$map;

});

parcelRegister("jTG1y", function(module, exports) {
$parcel$export(module.exports, "switchMap", () => $e7c3c07d5b286ebd$export$9f6ea8e48bc26eab, (v) => $e7c3c07d5b286ebd$export$9f6ea8e48bc26eab = v);
var $e7c3c07d5b286ebd$export$9f6ea8e48bc26eab;
"use strict";

var $1phCj = parcelRequire("1phCj");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $e7c3c07d5b286ebd$var$switchMap(project, resultSelector) {
    return $1phCj.switchMap(project, resultSelector)(this);
}
$e7c3c07d5b286ebd$export$9f6ea8e48bc26eab = $e7c3c07d5b286ebd$var$switchMap;

});
parcelRegister("1phCj", function(module, exports) {
"use strict";
var $1065ca9e8011b0b7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $1065ca9e8011b0b7$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $1065ca9e8011b0b7$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $1065ca9e8011b0b7$var$switchMap;
var $1065ca9e8011b0b7$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1065ca9e8011b0b7$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1065ca9e8011b0b7$var$SwitchMapSubscriber = function(_super) {
    $1065ca9e8011b0b7$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $jziWR.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($2L5Gq.OuterSubscriber);

});


parcelRegister("kaZSy", function(module, exports) {
$parcel$export(module.exports, "ActionsObservable", () => $eb04bdb32a5c88f6$export$fa75b7f5c32db4e9);

var $8jOUp = parcelRequire("8jOUp");

var $6ApxR = parcelRequire("6ApxR");

var $iwjU4 = parcelRequire("iwjU4");

var $aKVpz = parcelRequire("aKVpz");
var $eb04bdb32a5c88f6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $eb04bdb32a5c88f6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eb04bdb32a5c88f6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $eb04bdb32a5c88f6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $eb04bdb32a5c88f6$export$fa75b7f5c32db4e9 = function(_Observable) {
    $eb04bdb32a5c88f6$var$_inherits(ActionsObservable, _Observable);
    $eb04bdb32a5c88f6$var$_createClass(ActionsObservable, null, [
        {
            key: 'of',
            value: function of() {
                return new this((0, $6ApxR.of).apply(undefined, arguments));
            }
        },
        {
            key: 'from',
            value: function from(actions, scheduler) {
                return new this((0, $iwjU4.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        $eb04bdb32a5c88f6$var$_classCallCheck(this, ActionsObservable);
        var _this = $eb04bdb32a5c88f6$var$_possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    $eb04bdb32a5c88f6$var$_createClass(ActionsObservable, [
        {
            key: 'lift',
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: 'ofType',
            value: function ofType() {
                return (0, $aKVpz.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, $8jOUp.Observable));

});
parcelRegister("6ApxR", function(module, exports) {
$parcel$export(module.exports, "of", () => $4cb9eb9f3d12d4d8$export$ba255e9e49e00608, (v) => $4cb9eb9f3d12d4d8$export$ba255e9e49e00608 = v);
var $4cb9eb9f3d12d4d8$export$ba255e9e49e00608;
"use strict";

var $fznCF = parcelRequire("fznCF");
$4cb9eb9f3d12d4d8$export$ba255e9e49e00608 = $fznCF.ArrayObservable.of;

});

parcelRegister("aKVpz", function(module, exports) {
$parcel$export(module.exports, "ofType", () => $7d4abbfc45b2722a$export$5db8774c0df95fce);

var $7YjW8 = parcelRequire("7YjW8");
var $7d4abbfc45b2722a$var$keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === 'function' && type === key.toString();
};
function $7d4abbfc45b2722a$export$5db8774c0df95fce() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function ofTypeOperatorFunction(source) {
        return (0, $7YjW8.filter).call(source, function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return $7d4abbfc45b2722a$var$keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if ($7d4abbfc45b2722a$var$keyHasType(type, keys[i])) return true;
            }
            return false;
        });
    };
}

});
parcelRegister("7YjW8", function(module, exports) {
$parcel$export(module.exports, "filter", () => $5cdd9a07b9ad84d4$export$3dea766d36a8935f, (v) => $5cdd9a07b9ad84d4$export$3dea766d36a8935f = v);
var $5cdd9a07b9ad84d4$export$3dea766d36a8935f;
"use strict";

var $dCzwc = parcelRequire("dCzwc");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $5cdd9a07b9ad84d4$var$filter(predicate, thisArg) {
    return $dCzwc.filter(predicate, thisArg)(this);
}
$5cdd9a07b9ad84d4$export$3dea766d36a8935f = $5cdd9a07b9ad84d4$var$filter;

});
parcelRegister("dCzwc", function(module, exports) {
"use strict";
var $9eaa6031a905d015$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $9eaa6031a905d015$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $9eaa6031a905d015$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $9eaa6031a905d015$var$filter;
var $9eaa6031a905d015$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9eaa6031a905d015$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9eaa6031a905d015$var$FilterSubscriber = function(_super) {
    $9eaa6031a905d015$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($66gCN.Subscriber);

});




parcelRegister("gOck1", function(module, exports) {
$parcel$export(module.exports, "EPIC_END", () => $c3cadfb8171b5d55$export$b74d5afcca2d016c);
var $c3cadfb8171b5d55$export$b74d5afcca2d016c = '@@redux-observable/EPIC_END';

});


parcelRegister("4nFla", function(module, exports) {
$parcel$export(module.exports, "combineEpics", () => $330960c58bffd156$export$6259fe981e4a41dc);

var $6kyyx = parcelRequire("6kyyx");
function $330960c58bffd156$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $330960c58bffd156$export$6259fe981e4a41dc = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, $6kyyx.merge).apply(undefined, $330960c58bffd156$var$_toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
            return output$;
        })));
    };
};

});
parcelRegister("6kyyx", function(module, exports) {
$parcel$export(module.exports, "merge", () => $49bf6a773df9f471$export$4950aa0f605343fb, (v) => $49bf6a773df9f471$export$4950aa0f605343fb = v);
var $49bf6a773df9f471$export$4950aa0f605343fb;
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $fznCF = parcelRequire("fznCF");

var $86ewR = parcelRequire("86ewR");

var $aapek = parcelRequire("aapek");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $49bf6a773df9f471$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($86ewR.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $8jOUp.Observable) return observables[0];
    return $aapek.mergeAll(concurrent)(new $fznCF.ArrayObservable(observables, scheduler));
}
$49bf6a773df9f471$export$4950aa0f605343fb = $49bf6a773df9f471$var$merge;

});
parcelRegister("aapek", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $766e68c0cdabf116$export$18aef43295bbe906, (v) => $766e68c0cdabf116$export$18aef43295bbe906 = v);
var $766e68c0cdabf116$export$18aef43295bbe906;
"use strict";

var $jcL4C = parcelRequire("jcL4C");

var $83Ass = parcelRequire("83Ass");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $766e68c0cdabf116$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $jcL4C.mergeMap($83Ass.identity, null, concurrent);
}
$766e68c0cdabf116$export$18aef43295bbe906 = $766e68c0cdabf116$var$mergeAll;

});
parcelRegister("83Ass", function(module, exports) {
$parcel$export(module.exports, "identity", () => $5ddae2540e19c697$export$f0954fd7d5368655, (v) => $5ddae2540e19c697$export$f0954fd7d5368655 = v);
var $5ddae2540e19c697$export$f0954fd7d5368655;
"use strict";
function $5ddae2540e19c697$var$identity(x) {
    return x;
}
$5ddae2540e19c697$export$f0954fd7d5368655 = $5ddae2540e19c697$var$identity;

});





parcelRegister("i2Moh", function(module, exports) {
$parcel$export(module.exports, "epic$", () => $7d839244aa83c2db$export$5eda8fe942b06fa7);
$parcel$export(module.exports, "default", () => $7d839244aa83c2db$export$2e2bcd8739ae039);
parcelRequire("2ycHZ");
var $4nFla = parcelRequire("4nFla");

var $lJ0l5 = parcelRequire("lJ0l5");

var $gnOql = parcelRequire("gnOql");

var $eSZoS = parcelRequire("eSZoS");

var $2ujK0 = parcelRequire("2ujK0");

var $6IRIY = parcelRequire("6IRIY");

var $kvtf9 = parcelRequire("kvtf9");

var $heEvb = parcelRequire("heEvb");

var $7O9Ek = parcelRequire("7O9Ek");

var $6x6Ac = parcelRequire("6x6Ac");

var $3wcJe = parcelRequire("3wcJe");
var $iWImt = parcelRequire("iWImt");
var $5Qw0R = parcelRequire("5Qw0R");
var $32hH7 = parcelRequire("32hH7");
var $d6UVh = parcelRequire("d6UVh");

var $5Cby0 = parcelRequire("5Cby0");

var $82SlT = parcelRequire("82SlT");

var $9yiUM = parcelRequire("9yiUM");

var $31ZeC = parcelRequire("31ZeC");

var $8mW3b = parcelRequire("8mW3b");

var $5iLP3 = parcelRequire("5iLP3");
var $8M3pr = parcelRequire("8M3pr");
var $gJFTm = parcelRequire("gJFTm");
var $byiOV = parcelRequire("byiOV");
var $ivz24 = parcelRequire("ivz24");
var $aQzC7 = parcelRequire("aQzC7");
var $b7O7r = parcelRequire("b7O7r");
var $6OFyt = parcelRequire("6OFyt");

var $gEZz8 = parcelRequire("gEZz8");

var $9LO37 = parcelRequire("9LO37");
var $9ITVk = parcelRequire("9ITVk");
var $d2dBy = parcelRequire("d2dBy");
var $gnxk7 = parcelRequire("gnxk7");
var $5tRND = parcelRequire("5tRND");

var $7iSP5 = parcelRequire("7iSP5");

var $kkx6E = parcelRequire("kkx6E");

var $77M2h = parcelRequire("77M2h");

var $9pfcu = parcelRequire("9pfcu");

var $3WITp = parcelRequire("3WITp");

var $2Tw0k = parcelRequire("2Tw0k");
const $7d839244aa83c2db$export$678ceb4a4ee87d76 = [
    (0, $31ZeC.default),
    (0, $77M2h.default),
    (0, $9yiUM.logOutEpic),
    (0, $6IRIY.default),
    (0, $gEZz8.requestGroupsEpic),
    (0, $9ITVk.createGroupWithRequestTypeEpic),
    (0, $9LO37.addRequestTypeToRequestGroupEpic),
    (0, $d2dBy.deleteRequestTypeFromGroupEpic),
    (0, $5tRND.setRequestTypeGroupsEpic),
    (0, $gnxk7.reorderRequestTypeEpic),
    (0, $5iLP3.changeRequestSubscriptionEpic),
    (0, $8M3pr.createCommentEpic),
    (0, $gJFTm.decideApprovalEpic),
    (0, $ivz24.removeOrganisationEpic),
    (0, $aQzC7.removeParticipantEpic),
    (0, $b7O7r.shareRequestEpic),
    (0, $6OFyt.transitionRequestEpic),
    (0, $byiOV.getMediaReadCredentialsEpic),
    (0, $kvtf9.handleAjaxErrorEpic),
    (0, $9pfcu.resendValidationEmailEpic),
    (0, $3WITp.validateAndSavePasswordChangeEpic),
    (0, $3WITp.validateEpic),
    (0, $3WITp.changePasswordEpic),
    (0, $3WITp.updateUserProfileEpic),
    (0, $3wcJe.checkLoginActionEpic),
    (0, $32hH7.forgotPasswordEpic),
    (0, $iWImt.createPasswordEpic),
    (0, $d6UVh.loginEpic),
    (0, $7O9Ek.invitedSignUpEpic),
    (0, $eSZoS.completeSignupEpic),
    (0, $eSZoS.sendNewSignupLinkEpic),
    (0, $heEvb.updateHelpCenterBrandingEpic),
    (0, $heEvb.updateHelpCenterBrandingEpicMutationSuccess),
    (0, $heEvb.updateHelpCenterBrandingEpicMutationFailure),
    (0, $kkx6E.resetPasswordEpic),
    (0, $5Cby0.updateLoginAnnouncementsEpic),
    (0, $8mW3b.updatePortalAnnouncementsEpic),
    (0, $2Tw0k.forgotPasswordEpic),
    (0, $5Qw0R.exitTestModeEpic),
    (0, $7iSP5.resendVerifyEmailEpic),
    (0, $82SlT.loginConsentEpic),
    (0, $2ujK0.fetchCrossSiteArticleEpic),
    (0, $6x6Ac.fetchLinkedSpacesEpic)
];
const $7d839244aa83c2db$var$staticEpics = (0, $4nFla.combineEpics)(...$7d839244aa83c2db$export$678ceb4a4ee87d76);
const $7d839244aa83c2db$export$5eda8fe942b06fa7 = new (0, $lJ0l5.BehaviorSubject)($7d839244aa83c2db$var$staticEpics);
const $7d839244aa83c2db$var$combinedEpic = (action$, store$, deps)=>$7d839244aa83c2db$export$5eda8fe942b06fa7.pipe((0, $gnOql.mergeMap)((epic)=>epic(action$, store$, deps)));
var $7d839244aa83c2db$export$2e2bcd8739ae039 = $7d839244aa83c2db$var$combinedEpic;

});
parcelRegister("lJ0l5", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $fd0e104372588fe8$export$77cea355fa80b5f4, (v) => $fd0e104372588fe8$export$77cea355fa80b5f4 = v);
$parcel$export(module.exports, "BehaviorSubject", () => $fd0e104372588fe8$export$cc3d42e6b2b9cf8b, (v) => $fd0e104372588fe8$export$cc3d42e6b2b9cf8b = v);
$parcel$export(module.exports, "AjaxError", () => $fd0e104372588fe8$export$9b8f4d0b97ba3d22, (v) => $fd0e104372588fe8$export$9b8f4d0b97ba3d22 = v);
$parcel$export(module.exports, "Scheduler", () => $fd0e104372588fe8$export$d3e54bb8584cda7c, (v) => $fd0e104372588fe8$export$d3e54bb8584cda7c = v);
var $fd0e104372588fe8$export$b6bbab5a9b109038;
var $fd0e104372588fe8$export$155189cde295587d;
var $fd0e104372588fe8$export$77cea355fa80b5f4;
var $fd0e104372588fe8$export$f55210826850c514;
var $fd0e104372588fe8$export$60959659b2c22881;
var $fd0e104372588fe8$export$fe960da701faae26;
var $fd0e104372588fe8$export$915d2682b0aa0991;
var $fd0e104372588fe8$export$cc3d42e6b2b9cf8b;
var $fd0e104372588fe8$export$9038dea0172d3ba9;
var $fd0e104372588fe8$export$14834abbfce3b8cd;
var $fd0e104372588fe8$export$78f6d1b1dbcda304;
var $fd0e104372588fe8$export$630691c4a0cd4093;
var $fd0e104372588fe8$export$f708eee25634bc80;
var $fd0e104372588fe8$export$66d311bf29d5c89c;
var $fd0e104372588fe8$export$c9648b76fd580c34;
var $fd0e104372588fe8$export$8bb95198b45adaac;
var $fd0e104372588fe8$export$d9bcbd5e1ff81430;
var $fd0e104372588fe8$export$62927158df9c43dd;
var $fd0e104372588fe8$export$789cef2613b1402;
var $fd0e104372588fe8$export$ae07db09d6fbd01b;
var $fd0e104372588fe8$export$9b8f4d0b97ba3d22;
var $fd0e104372588fe8$export$fcf72a1ab36e1e65;
var $fd0e104372588fe8$export$a4627e546088548d;
var $fd0e104372588fe8$export$ccbce4efa7f8029b;
var $fd0e104372588fe8$export$d3e54bb8584cda7c;
var $fd0e104372588fe8$export$3e25e887b7a5b37b;
"use strict";

var $gJqoA = parcelRequire("gJqoA");
$fd0e104372588fe8$export$b6bbab5a9b109038 = $gJqoA.Subject;
$fd0e104372588fe8$export$155189cde295587d = $gJqoA.AnonymousSubject;

var $8jOUp = parcelRequire("8jOUp");
$fd0e104372588fe8$export$77cea355fa80b5f4 = $8jOUp.Observable;
parcelRequire("8PACw");
parcelRequire("aTlqk");
parcelRequire("1q3At");
parcelRequire("89SKO");
parcelRequire("7B748");
parcelRequire("1gQaH");
parcelRequire("3p7sY");
parcelRequire("47ywS");
parcelRequire("f79Nv");
parcelRequire("hf5nB");
parcelRequire("iYtHS");
parcelRequire("8psTp");
parcelRequire("cL2hf");
parcelRequire("fjxCH");
parcelRequire("kMywu");
parcelRequire("lxkd0");
parcelRequire("1cqUb");
parcelRequire("4MHPJ");
parcelRequire("f0Eam");
parcelRequire("TrRno");
parcelRequire("fX1QG");
parcelRequire("lvkYi");
parcelRequire("fYU2O");
parcelRequire("hdpvy");
parcelRequire("7CQsp");
parcelRequire("kXbZr");
parcelRequire("3QeMM");
parcelRequire("40kBs");
parcelRequire("tjSSI");
parcelRequire("166ck");
parcelRequire("dlyvF");
parcelRequire("bW02i");
parcelRequire("cN9YV");
parcelRequire("4Ao32");
parcelRequire("6Ucv4");
parcelRequire("2v7Tu");
parcelRequire("1SgA8");
parcelRequire("F6XBw");
parcelRequire("1k0mq");
parcelRequire("7DNBi");
parcelRequire("jWHQw");
parcelRequire("gJ4lB");
parcelRequire("4MHp0");
parcelRequire("jgsJa");
parcelRequire("ffeq9");
parcelRequire("eXlok");
parcelRequire("8tULk");
parcelRequire("9Esoe");
parcelRequire("eG3Rt");
parcelRequire("hrDOT");
parcelRequire("gEe0l");
parcelRequire("80Ua7");
parcelRequire("5UjSW");
parcelRequire("7DkpP");
parcelRequire("725aW");
parcelRequire("1dIg6");
parcelRequire("9csP0");
parcelRequire("f3nHB");
parcelRequire("l114D");
parcelRequire("hDFF8");
parcelRequire("2EjtJ");
parcelRequire("kjg5i");
parcelRequire("2J7QU");
parcelRequire("j1K3d");
parcelRequire("axDN0");
parcelRequire("j0hca");
parcelRequire("bPh8v");
parcelRequire("fITcD");
parcelRequire("dfzyl");
parcelRequire("enquq");
parcelRequire("9de7r");
parcelRequire("dlrG8");
parcelRequire("8vQHO");
parcelRequire("04cNN");
parcelRequire("byrgM");
parcelRequire("coufH");
parcelRequire("aB4Sq");
parcelRequire("aEZBF");
parcelRequire("a0XIB");
parcelRequire("2vJS1");
parcelRequire("hTh9y");
parcelRequire("bM3FB");
parcelRequire("exxsm");
parcelRequire("aZNfb");
parcelRequire("95DGT");
parcelRequire("hoPOo");
parcelRequire("12cfI");
parcelRequire("dQj0O");
parcelRequire("aJNuu");
parcelRequire("1nD9i");
parcelRequire("kybeY");
parcelRequire("1S4eh");
parcelRequire("kLVHh");
parcelRequire("g23Cu");
parcelRequire("dSmep");
parcelRequire("2t0n8");
parcelRequire("3FU5I");
parcelRequire("crBQ4");
parcelRequire("4PT5g");
parcelRequire("1tNRj");
parcelRequire("g5I8P");
parcelRequire("9NDNe");
parcelRequire("gIKfZ");
parcelRequire("dOM56");
parcelRequire("1CcwI");
parcelRequire("546kW");
parcelRequire("kGGlg");
parcelRequire("kf022");
parcelRequire("iFbu9");
parcelRequire("ed3uB");
parcelRequire("gqdWZ");
parcelRequire("iNt9j");
parcelRequire("gOCL6");
parcelRequire("cWllG");
parcelRequire("2kDj5");
parcelRequire("YasA0");
parcelRequire("l4YVh");
parcelRequire("bTCk8");
parcelRequire("jWTKA");
parcelRequire("8fjnZ");
parcelRequire("7VLNH");
parcelRequire("8O0cE");
parcelRequire("5ZgfI");
parcelRequire("8ia4q");
parcelRequire("it5lw");
parcelRequire("jZheq");
parcelRequire("8GDmx");
parcelRequire("Y8Pfr");
parcelRequire("j54Uz");

var $aAAtt = parcelRequire("aAAtt");
$fd0e104372588fe8$export$f55210826850c514 = $aAAtt.Subscription;

var $66gCN = parcelRequire("66gCN");
$fd0e104372588fe8$export$60959659b2c22881 = $66gCN.Subscriber;

var $42fQ9 = parcelRequire("42fQ9");
$fd0e104372588fe8$export$fe960da701faae26 = $42fQ9.AsyncSubject;

var $9nelC = parcelRequire("9nelC");
$fd0e104372588fe8$export$915d2682b0aa0991 = $9nelC.ReplaySubject;

var $dbTkL = parcelRequire("dbTkL");
$fd0e104372588fe8$export$cc3d42e6b2b9cf8b = $dbTkL.BehaviorSubject;

var $abjpW = parcelRequire("abjpW");
$fd0e104372588fe8$export$9038dea0172d3ba9 = $abjpW.ConnectableObservable;

var $fTcsX = parcelRequire("fTcsX");
$fd0e104372588fe8$export$14834abbfce3b8cd = $fTcsX.Notification;

var $hLArM = parcelRequire("hLArM");
$fd0e104372588fe8$export$78f6d1b1dbcda304 = $hLArM.EmptyError;

var $4IOSZ = parcelRequire("4IOSZ");
$fd0e104372588fe8$export$630691c4a0cd4093 = $4IOSZ.ArgumentOutOfRangeError;

var $b9gng = parcelRequire("b9gng");
$fd0e104372588fe8$export$f708eee25634bc80 = $b9gng.ObjectUnsubscribedError;

var $5CVEe = parcelRequire("5CVEe");
$fd0e104372588fe8$export$66d311bf29d5c89c = $5CVEe.TimeoutError;

var $g0zKH = parcelRequire("g0zKH");
$fd0e104372588fe8$export$c9648b76fd580c34 = $g0zKH.UnsubscriptionError;

var $c84MS = parcelRequire("c84MS");
$fd0e104372588fe8$export$8bb95198b45adaac = $c84MS.TimeInterval;

var $hBG9v = parcelRequire("hBG9v");
$fd0e104372588fe8$export$d9bcbd5e1ff81430 = $hBG9v.Timestamp;

var $jSFdI = parcelRequire("jSFdI");
$fd0e104372588fe8$export$62927158df9c43dd = $jSFdI.TestScheduler;

var $3OnTQ = parcelRequire("3OnTQ");
$fd0e104372588fe8$export$789cef2613b1402 = $3OnTQ.VirtualTimeScheduler;

var $hZ6dG = parcelRequire("hZ6dG");
$fd0e104372588fe8$export$ae07db09d6fbd01b = $hZ6dG.AjaxResponse;
$fd0e104372588fe8$export$9b8f4d0b97ba3d22 = $hZ6dG.AjaxError;
$fd0e104372588fe8$export$fcf72a1ab36e1e65 = $hZ6dG.AjaxTimeoutError;

var $2b9KJ = parcelRequire("2b9KJ");
$fd0e104372588fe8$export$a4627e546088548d = $2b9KJ.pipe;

var $ejgy5 = parcelRequire("ejgy5");

var $kESbZ = parcelRequire("kESbZ");

var $8k954 = parcelRequire("8k954");

var $h6Y6J = parcelRequire("h6Y6J");

var $1HBFJ = parcelRequire("1HBFJ");

var $huYam = parcelRequire("huYam");

var $8omzy = parcelRequire("8omzy");

var $gnOql = parcelRequire("gnOql");
$fd0e104372588fe8$export$ccbce4efa7f8029b = $gnOql;
/* tslint:enable:no-unused-variable */ /**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */ var $fd0e104372588fe8$var$Scheduler = {
    asap: $ejgy5.asap,
    queue: $8k954.queue,
    animationFrame: $h6Y6J.animationFrame,
    async: $kESbZ.async
};
$fd0e104372588fe8$export$d3e54bb8584cda7c = $fd0e104372588fe8$var$Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */ var $fd0e104372588fe8$var$Symbol = {
    rxSubscriber: $1HBFJ.rxSubscriber,
    observable: $8omzy.observable,
    iterator: $huYam.iterator
};
$fd0e104372588fe8$export$3e25e887b7a5b37b = $fd0e104372588fe8$var$Symbol;

});
parcelRegister("8PACw", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $gltpi = parcelRequire("gltpi");
$8jOUp.Observable.bindCallback = $gltpi.bindCallback;

});
parcelRegister("gltpi", function(module, exports) {
$parcel$export(module.exports, "bindCallback", () => $be656b24f4f966b2$export$ba9059a8de3f18e, (v) => $be656b24f4f966b2$export$ba9059a8de3f18e = v);
var $be656b24f4f966b2$export$ba9059a8de3f18e;
"use strict";

var $i3Cny = parcelRequire("i3Cny");
$be656b24f4f966b2$export$ba9059a8de3f18e = $i3Cny.BoundCallbackObservable.create;

});
parcelRegister("i3Cny", function(module, exports) {
"use strict";
var $d256470bfd925e8d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $42fQ9 = parcelRequire("42fQ9");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $d256470bfd925e8d$var$BoundCallbackObservable = function(_super) {
    $d256470bfd925e8d$var$__extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments it will return an Observable. If function `func`
     * calls its callback with one argument the Observable will emit that value.
     * If on the other hand the callback is called with multiple values the resulting
     * Observable will emit an array with said values as arguments.
     *
     * It is very important to remember that input function `func` is not called
     * when the output function is, but rather when the Observable returned by the output
     * function is subscribed. This means if `func` makes an AJAX request, that request
     * will be made every time someone subscribes to the resulting Observable, but not before.
     *
     * Optionally, a selector function can be passed to `bindObservable`. The selector function
     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
     * Even though by default multiple arguments passed to callback appear in the stream as an array
     * the selector function will be called with arguments directly, just as the callback would.
     * This means you can imagine the default selector (when one is not provided explicitly)
     * as a function that aggregates all its arguments into an array, or simply returns first argument
     * if there is only one.
     *
     * The last optional parameter - {@link Scheduler} - can be used to control when the call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
     * and call `subscribe` on the output Observable all function calls that are currently executing
     * will end before `func` is invoked.
     *
     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
     * In particular, if the callback is called synchronously the subscription of the resulting Observable
     * will call the `next` function synchronously as well.  If you want to defer that call,
     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that the Observable created by the output function will always emit a single value
     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
     * calls will not appear in the stream. If you need to listen for multiple calls,
     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
     * will be the context that the output function has at call time. In particular, if `func`
     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
     * it is recommended that the context of the output function is set to that object as well.
     *
     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions the same as any other and error parameters
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive an array of arguments passed to a callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with a selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on an object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func A function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps them to a value that is emitted on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */ BoundCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $42fQ9.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = $cxrX4.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $2afHm.errorObject) subject.error($2afHm.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $cxrX4.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $2afHm.errorObject) subject.error($2afHm.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule(BoundCallbackObservable.dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    BoundCallbackObservable.dispatch = function(state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new $42fQ9.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = $cxrX4.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === $2afHm.errorObject) self.add(scheduler.schedule($d256470bfd925e8d$var$dispatchError, 0, {
                        err: $2afHm.errorObject.e,
                        subject: subject
                    }));
                    else self.add(scheduler.schedule($d256470bfd925e8d$var$dispatchNext, 0, {
                        value: result_2,
                        subject: subject
                    }));
                } else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule($d256470bfd925e8d$var$dispatchNext, 0, {
                        value: value,
                        subject: subject
                    }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = $cxrX4.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === $2afHm.errorObject) subject.error($2afHm.errorObject.e);
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}($8jOUp.Observable);
module.exports.BoundCallbackObservable = $d256470bfd925e8d$var$BoundCallbackObservable;
function $d256470bfd925e8d$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $d256470bfd925e8d$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});
parcelRegister("42fQ9", function(module, exports) {
"use strict";
var $2f03a2dcf9c80ccc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $aAAtt = parcelRequire("aAAtt");
/**
 * @class AsyncSubject<T>
 */ var $2f03a2dcf9c80ccc$var$AsyncSubject = function(_super) {
    $2f03a2dcf9c80ccc$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $aAAtt.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $aAAtt.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($gJqoA.Subject);
module.exports.AsyncSubject = $2f03a2dcf9c80ccc$var$AsyncSubject;

});




parcelRegister("aTlqk", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $gtgxs = parcelRequire("gtgxs");
$8jOUp.Observable.bindNodeCallback = $gtgxs.bindNodeCallback;

});
parcelRegister("gtgxs", function(module, exports) {
$parcel$export(module.exports, "bindNodeCallback", () => $bfdc2efb07eadde6$export$4893451713772b1a, (v) => $bfdc2efb07eadde6$export$4893451713772b1a = v);
var $bfdc2efb07eadde6$export$4893451713772b1a;
"use strict";

var $eJ0oI = parcelRequire("eJ0oI");
$bfdc2efb07eadde6$export$4893451713772b1a = $eJ0oI.BoundNodeCallbackObservable.create;

});
parcelRegister("eJ0oI", function(module, exports) {
"use strict";
var $ab859399b4f0becf$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $42fQ9 = parcelRequire("42fQ9");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ab859399b4f0becf$var$BoundNodeCallbackObservable = function(_super) {
    $ab859399b4f0becf$var$__extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */ BoundNodeCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $42fQ9.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) subject.error(err);
                    else if (selector) {
                        var result_1 = $cxrX4.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $2afHm.errorObject) subject.error($2afHm.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $cxrX4.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $2afHm.errorObject) subject.error($2afHm.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule($ab859399b4f0becf$var$dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    return BoundNodeCallbackObservable;
}($8jOUp.Observable);
module.exports.BoundNodeCallbackObservable = $ab859399b4f0becf$var$BoundNodeCallbackObservable;
function $ab859399b4f0becf$var$dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new $42fQ9.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) self.add(scheduler.schedule($ab859399b4f0becf$var$dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else if (selector) {
                var result_2 = $cxrX4.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === $2afHm.errorObject) self.add(scheduler.schedule($ab859399b4f0becf$var$dispatchError, 0, {
                    err: $2afHm.errorObject.e,
                    subject: subject
                }));
                else self.add(scheduler.schedule($ab859399b4f0becf$var$dispatchNext, 0, {
                    value: result_2,
                    subject: subject
                }));
            } else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule($ab859399b4f0becf$var$dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = $cxrX4.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === $2afHm.errorObject) self.add(scheduler.schedule($ab859399b4f0becf$var$dispatchError, 0, {
            err: $2afHm.errorObject.e,
            subject: subject
        }));
    }
    self.add(subject.subscribe(subscriber));
}
function $ab859399b4f0becf$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $ab859399b4f0becf$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});



parcelRegister("1q3At", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9ad1q = parcelRequire("9ad1q");
$8jOUp.Observable.combineLatest = $9ad1q.combineLatest;

});
parcelRegister("9ad1q", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $6abf261f355cbf7c$export$77fa7d86f5204e8a, (v) => $6abf261f355cbf7c$export$77fa7d86f5204e8a = v);
var $6abf261f355cbf7c$export$77fa7d86f5204e8a;
"use strict";

var $86ewR = parcelRequire("86ewR");

var $gWadc = parcelRequire("gWadc");

var $fznCF = parcelRequire("fznCF");

var $5IzkJ = parcelRequire("5IzkJ");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */ function $6abf261f355cbf7c$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    var scheduler = null;
    if ($86ewR.isScheduler(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $gWadc.isArray(observables[0])) observables = observables[0];
    return new $fznCF.ArrayObservable(observables, scheduler).lift(new $5IzkJ.CombineLatestOperator(project));
}
$6abf261f355cbf7c$export$77fa7d86f5204e8a = $6abf261f355cbf7c$var$combineLatest;

});
parcelRegister("5IzkJ", function(module, exports) {
"use strict";
var $429c784845ffd53e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fznCF = parcelRequire("fznCF");

var $gWadc = parcelRequire("gWadc");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
var $429c784845ffd53e$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $429c784845ffd53e$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $gWadc.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $fznCF.ArrayObservable([
            source
        ].concat(observables)), new $429c784845ffd53e$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $429c784845ffd53e$var$combineLatest;
var $429c784845ffd53e$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $429c784845ffd53e$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $429c784845ffd53e$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $429c784845ffd53e$var$CombineLatestSubscriber = function(_super) {
    $429c784845ffd53e$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($429c784845ffd53e$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($jziWR.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $429c784845ffd53e$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.CombineLatestSubscriber = $429c784845ffd53e$var$CombineLatestSubscriber;

});



parcelRegister("89SKO", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $77dSs = parcelRequire("77dSs");
$8jOUp.Observable.concat = $77dSs.concat;

});
parcelRegister("77dSs", function(module, exports) {
$parcel$export(module.exports, "concat", () => $52e3f3975c73d7af$export$ee1b3e54f0441b22, (v) => $52e3f3975c73d7af$export$ee1b3e54f0441b22 = v);
var $52e3f3975c73d7af$export$ee1b3e54f0441b22;
"use strict";

var $86ewR = parcelRequire("86ewR");

var $6ApxR = parcelRequire("6ApxR");

var $iwjU4 = parcelRequire("iwjU4");

var $7xfVB = parcelRequire("7xfVB");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */ function $52e3f3975c73d7af$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    if (observables.length === 1 || observables.length === 2 && $86ewR.isScheduler(observables[1])) return $iwjU4.from(observables[0]);
    return $7xfVB.concatAll()($6ApxR.of.apply(void 0, observables));
}
$52e3f3975c73d7af$export$ee1b3e54f0441b22 = $52e3f3975c73d7af$var$concat;

});
parcelRegister("7xfVB", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $57c7f874fc2a5f68$export$b314777ae20abca9, (v) => $57c7f874fc2a5f68$export$b314777ae20abca9 = v);
var $57c7f874fc2a5f68$export$b314777ae20abca9;
"use strict";

var $aapek = parcelRequire("aapek");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $57c7f874fc2a5f68$var$concatAll() {
    return $aapek.mergeAll(1);
}
$57c7f874fc2a5f68$export$b314777ae20abca9 = $57c7f874fc2a5f68$var$concatAll;

});



parcelRegister("7B748", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kt8uq = parcelRequire("kt8uq");
$8jOUp.Observable.defer = $kt8uq.defer;

});
parcelRegister("kt8uq", function(module, exports) {
$parcel$export(module.exports, "defer", () => $ee6d19fd3706738e$export$260e5c0943f31606, (v) => $ee6d19fd3706738e$export$260e5c0943f31606 = v);
var $ee6d19fd3706738e$export$260e5c0943f31606;
"use strict";

var $8tNLi = parcelRequire("8tNLi");
$ee6d19fd3706738e$export$260e5c0943f31606 = $8tNLi.DeferObservable.create;

});
parcelRegister("8tNLi", function(module, exports) {
"use strict";
var $62c7a1d4838927d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $62c7a1d4838927d7$var$DeferObservable = function(_super) {
    $62c7a1d4838927d7$var$__extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */ DeferObservable.create = function(observableFactory) {
        return new DeferObservable(observableFactory);
    };
    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function(subscriber) {
        return new $62c7a1d4838927d7$var$DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}($8jOUp.Observable);
module.exports.DeferObservable = $62c7a1d4838927d7$var$DeferObservable;
var $62c7a1d4838927d7$var$DeferSubscriber = function(_super) {
    $62c7a1d4838927d7$var$__extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function() {
        try {
            this._callFactory();
        } catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function() {
        var result = this.factory();
        if (result) this.add($jziWR.subscribeToResult(this, result));
    };
    return DeferSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("1gQaH", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $dFHpA = parcelRequire("dFHpA");
$8jOUp.Observable.empty = $dFHpA.empty;

});
parcelRegister("dFHpA", function(module, exports) {
$parcel$export(module.exports, "empty", () => $9f40c756c52cc964$export$6e22c362a0406a2c, (v) => $9f40c756c52cc964$export$6e22c362a0406a2c = v);
var $9f40c756c52cc964$export$6e22c362a0406a2c;
"use strict";

var $cUooy = parcelRequire("cUooy");
$9f40c756c52cc964$export$6e22c362a0406a2c = $cUooy.EmptyObservable.create;

});


parcelRegister("3p7sY", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9MYnb = parcelRequire("9MYnb");
$8jOUp.Observable.forkJoin = $9MYnb.forkJoin;

});
parcelRegister("9MYnb", function(module, exports) {
$parcel$export(module.exports, "forkJoin", () => $72076d89eab5c7ea$export$b5bbde3786dfbd68, (v) => $72076d89eab5c7ea$export$b5bbde3786dfbd68 = v);
var $72076d89eab5c7ea$export$b5bbde3786dfbd68;
"use strict";

var $dhw14 = parcelRequire("dhw14");
$72076d89eab5c7ea$export$b5bbde3786dfbd68 = $dhw14.ForkJoinObservable.create;

});
parcelRegister("dhw14", function(module, exports) {
"use strict";
var $9ab5b2ab537aab1a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $cUooy = parcelRequire("cUooy");

var $gWadc = parcelRequire("gWadc");

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $9ab5b2ab537aab1a$var$ForkJoinObservable = function(_super) {
    $9ab5b2ab537aab1a$var$__extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */ /**
     * Joins last values emitted by passed Observables.
     *
     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
     *
     * <img src="./img/forkJoin.png" width="100%">
     *
     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
     * or directly as arguments. If no input Observables are provided, resulting stream will complete
     * immediately.
     *
     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
     * array will have `n` values, where first value is the last thing emitted by the first Observable,
     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
     * not emit more than once and it will complete after that. If you need to emit combined values not only
     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
     * or {@link zip} instead.
     *
     * In order for resulting array to have the same length as the number of input Observables, whenever any of
     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
     * and it will not emit anything either, even if it already has some last values from other Observables.
     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
     * unless at any point some other Observable completes without emitting value, which brings us back to
     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
     * have to emit something at least once and complete.
     *
     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
     * will be immediately unsubscribed.
     *
     * Optionally `forkJoin` accepts project function, that will be called with values which normally
     * would land in emitted array. Whatever is returned by project function, will appear in output
     * Observable instead. This means that default project can be thought of as a function that takes
     * all its arguments and puts them into an array. Note that project function will be called only
     * when output Observable is supposed to emit a result.
     *
     * @example <caption>Use forkJoin with operator emitting immediately</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.of(1, 2, 3, 4),
     *   Rx.Observable.of(5, 6, 7, 8)
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [4, 8]
     * // "This is how it ends!"
     *
     *
     * @example <caption>Use forkJoin with operator emitting after some time</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [2, 3] after 3 seconds
     * // "This is how it ends!" immediately after
     *
     *
     * @example <caption>Use forkJoin with project function</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
     *   (n, m) => n + m
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // 5 after 3 seconds
     * // "This is how it ends!" immediately after
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     *
     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
     * passed directly to the operator.
     * @param {function} [project] Function that takes values emitted by input Observables and returns value
     * that will appear in resulting Observable instead of default array.
     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
     * or value from project function.
     * @static true
     * @name forkJoin
     * @owner Observable
     */ ForkJoinObservable.create = function() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i - 0] = arguments[_i];
        if (sources === null || arguments.length === 0) return new $cUooy.EmptyObservable();
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') resultSelector = sources.pop();
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && $gWadc.isArray(sources[0])) sources = sources[0];
        if (sources.length === 0) return new $cUooy.EmptyObservable();
        return new ForkJoinObservable(sources, resultSelector);
    };
    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function(subscriber) {
        return new $9ab5b2ab537aab1a$var$ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}($8jOUp.Observable);
module.exports.ForkJoinObservable = $9ab5b2ab537aab1a$var$ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9ab5b2ab537aab1a$var$ForkJoinSubscriber = function(_super) {
    $9ab5b2ab537aab1a$var$__extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for(var i = 0; i < len; i++){
            var source = sources[i];
            var innerSubscription = $jziWR.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function(innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) return;
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("47ywS", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $iwjU4 = parcelRequire("iwjU4");
$8jOUp.Observable.from = $iwjU4.from;

});

parcelRegister("f79Nv", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $5lrxJ = parcelRequire("5lrxJ");
$8jOUp.Observable.fromEvent = $5lrxJ.fromEvent;

});
parcelRegister("5lrxJ", function(module, exports) {
$parcel$export(module.exports, "fromEvent", () => $3e444760b9a90249$export$a36e16046ae8f1bb, (v) => $3e444760b9a90249$export$a36e16046ae8f1bb = v);
var $3e444760b9a90249$export$a36e16046ae8f1bb;
"use strict";

var $gMa1I = parcelRequire("gMa1I");
$3e444760b9a90249$export$a36e16046ae8f1bb = $gMa1I.FromEventObservable.create;

});
parcelRegister("gMa1I", function(module, exports) {
"use strict";
var $c368e825129eea18$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $cxrX4 = parcelRequire("cxrX4");

var $dZ9NH = parcelRequire("dZ9NH");

var $2afHm = parcelRequire("2afHm");

var $aAAtt = parcelRequire("aAAtt");
var $c368e825129eea18$var$toString = Object.prototype.toString;
function $c368e825129eea18$var$isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function $c368e825129eea18$var$isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function $c368e825129eea18$var$isNodeList(sourceObj) {
    return !!sourceObj && $c368e825129eea18$var$toString.call(sourceObj) === '[object NodeList]';
}
function $c368e825129eea18$var$isHTMLCollection(sourceObj) {
    return !!sourceObj && $c368e825129eea18$var$toString.call(sourceObj) === '[object HTMLCollection]';
}
function $c368e825129eea18$var$isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $c368e825129eea18$var$FromEventObservable = function(_super) {
    $c368e825129eea18$var$__extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */ /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node.js
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * `fromEvent` accepts as a first argument event target, which is an object with methods
     * for registering event handler functions. As a second argument it takes string that indicates
     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
     * which are described in detail below. If your event target does not match any of the ones listed,
     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
     * handler functions have different names, but they all accept a string describing event type
     * and function itself, which will be called whenever said event happens.
     *
     * Every time resulting Observable is subscribed, event handler function will be registered
     * to event target on given event type. When that event fires, value
     * passed as a first argument to registered function will be emitted by output Observable.
     * When Observable is unsubscribed, function will be unregistered from event target.
     *
     * Note that if event target calls registered function with more than one argument, second
     * and following arguments will not appear in resulting stream. In order to get access to them,
     * you can pass to `fromEvent` optional project function, which will be called with all arguments
     * passed to event handler. Output Observable will then emit value returned by project function,
     * instead of the usual value.
     *
     * Remember that event targets listed below are checked via duck typing. It means that
     * no matter what kind of object you have and no matter what environment you work in,
     * you can safely use `fromEvent` on that object if it exposes described methods (provided
     * of course they behave as was described above). So for example if Node.js library exposes
     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
     * a good choice.
     *
     * If the API you use is more callback then event handler oriented (subscribed
     * callback function fires only once and thus there is no need to manually
     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
     * instead.
     *
     * `fromEvent` supports following types of event targets:
     *
     * **DOM EventTarget**
     *
     * This is an object with `addEventListener` and `removeEventListener` methods.
     *
     * In the browser, `addEventListener` accepts - apart from event type string and event
     * handler function arguments - optional third parameter, which is either an object or boolean,
     * both used for additional configuration how and when passed function will be called. When
     * `fromEvent` is used with event target of that type, you can provide this values
     * as third parameter as well.
     *
     * **Node.js EventEmitter**
     *
     * An object with `addListener` and `removeListener` methods.
     *
     * **JQuery-style event target**
     *
     * An object with `on` and `off` methods
     *
     * **DOM NodeList**
     *
     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
     *
     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
     * it contains and install event handler function in every of them. When returned Observable
     * is unsubscribed, function will be removed from all Nodes.
     *
     * **DOM HtmlCollection**
     *
     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
     * installed and removed in each of elements.
     *
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console every time a click
     * // occurs on the document.
     *
     *
     * @example <caption>Use addEventListener with capture option</caption>
     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
     *                                                                          // which will be passed to addEventListener
     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
     *
     * clicksInDocument.subscribe(() => console.log('document'));
     * clicksInDiv.subscribe(() => console.log('div'));
     *
     * // By default events bubble UP in DOM tree, so normally
     * // when we would click on div in document
     * // "div" would be logged first and then "document".
     * // Since we specified optional `capture` option, document
     * // will catch event when it goes DOWN DOM tree, so console
     * // will log "document" and then "div".
     *
     * @see {@link bindCallback}
     * @see {@link bindNodeCallback}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOM EventTarget, Node.js
     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */ FromEventObservable.create = function(target, eventName, options, selector) {
        if ($dZ9NH.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function(sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if ($c368e825129eea18$var$isNodeList(sourceObj) || $c368e825129eea18$var$isHTMLCollection(sourceObj)) for(var i = 0, len = sourceObj.length; i < len; i++)FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        else if ($c368e825129eea18$var$isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function() {
                return source_1.removeEventListener(eventName, handler, options);
            };
        } else if ($c368e825129eea18$var$isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function() {
                return source_2.off(eventName, handler);
            };
        } else if ($c368e825129eea18$var$isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function() {
                return source_3.removeListener(eventName, handler);
            };
        } else throw new TypeError('Invalid event target');
        subscriber.add(new $aAAtt.Subscription(unsubscribe));
    };
    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function(subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            var result = $cxrX4.tryCatch(selector).apply(void 0, args);
            if (result === $2afHm.errorObject) subscriber.error($2afHm.errorObject.e);
            else subscriber.next(result);
        } : function(e) {
            return subscriber.next(e);
        };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}($8jOUp.Observable);
module.exports.FromEventObservable = $c368e825129eea18$var$FromEventObservable;

});



parcelRegister("hf5nB", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $3K78Q = parcelRequire("3K78Q");
$8jOUp.Observable.fromEventPattern = $3K78Q.fromEventPattern;

});
parcelRegister("3K78Q", function(module, exports) {
$parcel$export(module.exports, "fromEventPattern", () => $2b9b352979edcd35$export$af596f9f0ff848f8, (v) => $2b9b352979edcd35$export$af596f9f0ff848f8 = v);
var $2b9b352979edcd35$export$af596f9f0ff848f8;
"use strict";

var $ewycJ = parcelRequire("ewycJ");
$2b9b352979edcd35$export$af596f9f0ff848f8 = $ewycJ.FromEventPatternObservable.create;

});
parcelRegister("ewycJ", function(module, exports) {
"use strict";
var $a92e9622bd94f59c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dZ9NH = parcelRequire("dZ9NH");

var $8jOUp = parcelRequire("8jOUp");

var $aAAtt = parcelRequire("aAAtt");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a92e9622bd94f59c$var$FromEventPatternObservable = function(_super) {
    $a92e9622bd94f59c$var$__extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */ FromEventPatternObservable.create = function(addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            _this._callSelector(subscriber, args);
        } : function(e) {
            subscriber.next(e);
        };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!$dZ9NH.isFunction(removeHandler)) return;
        subscriber.add(new $aAAtt.Subscription(function() {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function(subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        } catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function(handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        } catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}($8jOUp.Observable);
module.exports.FromEventPatternObservable = $a92e9622bd94f59c$var$FromEventPatternObservable;

});



parcelRegister("iYtHS", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $aUfUg = parcelRequire("aUfUg");
$8jOUp.Observable.fromPromise = $aUfUg.fromPromise;

});

parcelRegister("8psTp", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $967qY = parcelRequire("967qY");
$8jOUp.Observable.generate = $967qY.generate;

});
parcelRegister("967qY", function(module, exports) {
$parcel$export(module.exports, "generate", () => $69fa70d562e24cbe$export$80d376111cc09ad7, (v) => $69fa70d562e24cbe$export$80d376111cc09ad7 = v);
var $69fa70d562e24cbe$export$80d376111cc09ad7;
"use strict";

var $JuN44 = parcelRequire("JuN44");
$69fa70d562e24cbe$export$80d376111cc09ad7 = $JuN44.GenerateObservable.create;

});
parcelRegister("JuN44", function(module, exports) {
"use strict";
var $088c1668c8b79bd6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $86ewR = parcelRequire("86ewR");
var $088c1668c8b79bd6$var$selfSelector = function(value) {
    return value;
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $088c1668c8b79bd6$var$GenerateObservable = function(_super) {
    $088c1668c8b79bd6$var$__extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || $088c1668c8b79bd6$var$selfSelector, initialStateOrOptions.scheduler);
        if (resultSelectorOrObservable === undefined || $86ewR.isScheduler(resultSelectorOrObservable)) return new GenerateObservable(initialStateOrOptions, condition, iterate, $088c1668c8b79bd6$var$selfSelector, resultSelectorOrObservable);
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function(subscriber) {
        var state = this.initialState;
        if (this.scheduler) return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
            subscriber: subscriber,
            iterate: this.iterate,
            condition: this.condition,
            resultSelector: this.resultSelector,
            state: state
        });
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
        }while (true);
    };
    GenerateObservable.dispatch = function(state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) return;
        if (state.needIterate) try {
            state.state = state.iterate(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        else state.needIterate = true;
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) return;
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) return;
        subscriber.next(value);
        if (subscriber.closed) return;
        return this.schedule(state);
    };
    return GenerateObservable;
}($8jOUp.Observable);
module.exports.GenerateObservable = $088c1668c8b79bd6$var$GenerateObservable;

});



parcelRegister("cL2hf", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $3mt1J = parcelRequire("3mt1J");
$8jOUp.Observable.if = $3mt1J._if;

});
parcelRegister("3mt1J", function(module, exports) {
$parcel$export(module.exports, "_if", () => $2729f155c18d9967$export$3d19121892ad9076, (v) => $2729f155c18d9967$export$3d19121892ad9076 = v);
var $2729f155c18d9967$export$3d19121892ad9076;
"use strict";

var $9UMzO = parcelRequire("9UMzO");
$2729f155c18d9967$export$3d19121892ad9076 = $9UMzO.IfObservable.create;

});
parcelRegister("9UMzO", function(module, exports) {
"use strict";
var $737f064eea2b6812$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $737f064eea2b6812$var$IfObservable = function(_super) {
    $737f064eea2b6812$var$__extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function(condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function(subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new $737f064eea2b6812$var$IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}($8jOUp.Observable);
module.exports.IfObservable = $737f064eea2b6812$var$IfObservable;
var $737f064eea2b6812$var$IfSubscriber = function(_super) {
    $737f064eea2b6812$var$__extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function() {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) this.add($jziWR.subscribeToResult(this, source));
            else this._complete();
        } catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("fjxCH", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9Y4d1 = parcelRequire("9Y4d1");
$8jOUp.Observable.interval = $9Y4d1.interval;

});
parcelRegister("9Y4d1", function(module, exports) {
$parcel$export(module.exports, "interval", () => $741cfb7d59672d75$export$3174cdbf0a0cbc84, (v) => $741cfb7d59672d75$export$3174cdbf0a0cbc84 = v);
var $741cfb7d59672d75$export$3174cdbf0a0cbc84;
"use strict";

var $bkgd9 = parcelRequire("bkgd9");
$741cfb7d59672d75$export$3174cdbf0a0cbc84 = $bkgd9.IntervalObservable.create;

});
parcelRegister("bkgd9", function(module, exports) {
"use strict";
var $83ee2324f1adf30d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hHpuK = parcelRequire("hHpuK");

var $8jOUp = parcelRequire("8jOUp");

var $kESbZ = parcelRequire("kESbZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $83ee2324f1adf30d$var$IntervalObservable = function(_super) {
    $83ee2324f1adf30d$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $kESbZ.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$hHpuK.isNumeric(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $kESbZ.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $kESbZ.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($8jOUp.Observable);
module.exports.IntervalObservable = $83ee2324f1adf30d$var$IntervalObservable;

});
parcelRegister("hHpuK", function(module, exports) {
$parcel$export(module.exports, "isNumeric", () => $ce2a3a95fd0a0b81$export$e90fb89750dba83f, (v) => $ce2a3a95fd0a0b81$export$e90fb89750dba83f = v);
var $ce2a3a95fd0a0b81$export$e90fb89750dba83f;
"use strict";

var $gWadc = parcelRequire("gWadc");
function $ce2a3a95fd0a0b81$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$gWadc.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$ce2a3a95fd0a0b81$export$e90fb89750dba83f = $ce2a3a95fd0a0b81$var$isNumeric;

});

parcelRegister("kESbZ", function(module, exports) {
$parcel$export(module.exports, "async", () => $f0a1948891d043fe$export$12af436354f1a4f7, (v) => $f0a1948891d043fe$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $f0a1948891d043fe$export$12af436354f1a4f7;
"use strict";

var $1GOJd = parcelRequire("1GOJd");

var $5aY3c = parcelRequire("5aY3c");
$f0a1948891d043fe$export$12af436354f1a4f7 = new $5aY3c.AsyncScheduler($1GOJd.AsyncAction);

});




parcelRegister("kMywu", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6kyyx = parcelRequire("6kyyx");
$8jOUp.Observable.merge = $6kyyx.merge;

});

parcelRegister("lxkd0", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $cBBhW = parcelRequire("cBBhW");
$8jOUp.Observable.race = $cBBhW.race;

});
parcelRegister("cBBhW", function(module, exports) {
"use strict";
var $92d5dd7173753620$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gWadc = parcelRequire("gWadc");

var $fznCF = parcelRequire("fznCF");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
function $92d5dd7173753620$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($gWadc.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $fznCF.ArrayObservable(observables).lift(new $92d5dd7173753620$var$RaceOperator());
}
module.exports.race = $92d5dd7173753620$var$race;
var $92d5dd7173753620$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $92d5dd7173753620$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $92d5dd7173753620$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $92d5dd7173753620$var$RaceSubscriber = function(_super) {
    $92d5dd7173753620$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $jziWR.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.RaceSubscriber = $92d5dd7173753620$var$RaceSubscriber;

});


parcelRegister("1cqUb", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $cAqqA = parcelRequire("cAqqA");
$8jOUp.Observable.never = $cAqqA.never;

});
parcelRegister("cAqqA", function(module, exports) {
$parcel$export(module.exports, "never", () => $929d58d48d549622$export$b3e22bcfd64c1022, (v) => $929d58d48d549622$export$b3e22bcfd64c1022 = v);
var $929d58d48d549622$export$b3e22bcfd64c1022;
"use strict";

var $3soRf = parcelRequire("3soRf");
$929d58d48d549622$export$b3e22bcfd64c1022 = $3soRf.NeverObservable.create;

});
parcelRegister("3soRf", function(module, exports) {
"use strict";
var $284744ddea1a0764$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $chmr4 = parcelRequire("chmr4");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $284744ddea1a0764$var$NeverObservable = function(_super) {
    $284744ddea1a0764$var$__extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */ NeverObservable.create = function() {
        return new NeverObservable();
    };
    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function(subscriber) {
        $chmr4.noop();
    };
    return NeverObservable;
}($8jOUp.Observable);
module.exports.NeverObservable = $284744ddea1a0764$var$NeverObservable;

});



parcelRegister("4MHPJ", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6ApxR = parcelRequire("6ApxR");
$8jOUp.Observable.of = $6ApxR.of;

});

parcelRegister("f0Eam", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $gudT2 = parcelRequire("gudT2");
$8jOUp.Observable.onErrorResumeNext = $gudT2.onErrorResumeNext;

});
parcelRegister("gudT2", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $c00a384563ef5d9b$export$5fba66d61591f42, (v) => $c00a384563ef5d9b$export$5fba66d61591f42 = v);
var $c00a384563ef5d9b$export$5fba66d61591f42;
"use strict";

var $3eCwJ = parcelRequire("3eCwJ");
$c00a384563ef5d9b$export$5fba66d61591f42 = $3eCwJ.onErrorResumeNextStatic;

});
parcelRegister("3eCwJ", function(module, exports) {
"use strict";
var $25b0909050450c33$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aYgqf = parcelRequire("aYgqf");

var $gWadc = parcelRequire("gWadc");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $25b0909050450c33$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $gWadc.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $25b0909050450c33$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $25b0909050450c33$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $25b0909050450c33$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $gWadc.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $aYgqf.FromObservable(source, null).lift(new $25b0909050450c33$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $25b0909050450c33$var$onErrorResumeNextStatic;
var $25b0909050450c33$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $25b0909050450c33$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $25b0909050450c33$var$OnErrorResumeNextSubscriber = function(_super) {
    $25b0909050450c33$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($jziWR.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("TrRno", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $bUOun = parcelRequire("bUOun");
$8jOUp.Observable.pairs = $bUOun.pairs;

});
parcelRegister("bUOun", function(module, exports) {
$parcel$export(module.exports, "pairs", () => $8acc16bff140f2bf$export$589748d90c221be3, (v) => $8acc16bff140f2bf$export$589748d90c221be3 = v);
var $8acc16bff140f2bf$export$589748d90c221be3;
"use strict";

var $ljOcV = parcelRequire("ljOcV");
$8acc16bff140f2bf$export$589748d90c221be3 = $ljOcV.PairsObservable.create;

});
parcelRegister("ljOcV", function(module, exports) {
"use strict";
var $f852517f47756276$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");
function $f852517f47756276$var$dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([
        key,
        obj[key]
    ]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f852517f47756276$var$PairsObservable = function(_super) {
    $f852517f47756276$var$__extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */ PairsObservable.create = function(obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function(subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) return scheduler.schedule($f852517f47756276$var$dispatch, 0, {
            obj: this.obj,
            keys: keys,
            length: length,
            index: 0,
            subscriber: subscriber
        });
        else {
            for(var idx = 0; idx < length; idx++){
                var key = keys[idx];
                subscriber.next([
                    key,
                    this.obj[key]
                ]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}($8jOUp.Observable);
module.exports.PairsObservable = $f852517f47756276$var$PairsObservable;

});



parcelRegister("fX1QG", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $jZJNg = parcelRequire("jZJNg");
$8jOUp.Observable.range = $jZJNg.range;

});

parcelRegister("lvkYi", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $b9gPU = parcelRequire("b9gPU");
$8jOUp.Observable.using = $b9gPU.using;

});
parcelRegister("b9gPU", function(module, exports) {
$parcel$export(module.exports, "using", () => $81dd9851c24da404$export$fb1889ddede82380, (v) => $81dd9851c24da404$export$fb1889ddede82380 = v);
var $81dd9851c24da404$export$fb1889ddede82380;
"use strict";

var $kpMgi = parcelRequire("kpMgi");
$81dd9851c24da404$export$fb1889ddede82380 = $kpMgi.UsingObservable.create;

});
parcelRegister("kpMgi", function(module, exports) {
"use strict";
var $edcb94420ca80e3b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $edcb94420ca80e3b$var$UsingObservable = function(_super) {
    $edcb94420ca80e3b$var$__extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function(resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function(subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new $edcb94420ca80e3b$var$UsingSubscriber(subscriber, resource, observableFactory);
        } catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}($8jOUp.Observable);
module.exports.UsingObservable = $edcb94420ca80e3b$var$UsingObservable;
var $edcb94420ca80e3b$var$UsingSubscriber = function(_super) {
    $edcb94420ca80e3b$var$__extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function() {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) this.add($jziWR.subscribeToResult(this, source));
        } catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("fYU2O", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $3XD9t = parcelRequire("3XD9t");
$8jOUp.Observable.throw = $3XD9t._throw;

});
parcelRegister("3XD9t", function(module, exports) {
$parcel$export(module.exports, "_throw", () => $2e2540825e115a19$export$82a8af9b11518516, (v) => $2e2540825e115a19$export$82a8af9b11518516 = v);
var $2e2540825e115a19$export$82a8af9b11518516;
"use strict";

var $65p3G = parcelRequire("65p3G");
$2e2540825e115a19$export$82a8af9b11518516 = $65p3G.ErrorObservable.create;

});
parcelRegister("65p3G", function(module, exports) {
"use strict";
var $46e6a5cb62644e7f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $46e6a5cb62644e7f$var$ErrorObservable = function(_super) {
    $46e6a5cb62644e7f$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($8jOUp.Observable);
module.exports.ErrorObservable = $46e6a5cb62644e7f$var$ErrorObservable;

});



parcelRegister("hdpvy", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $hDHgc = parcelRequire("hDHgc");
$8jOUp.Observable.timer = $hDHgc.timer;

});
parcelRegister("hDHgc", function(module, exports) {
$parcel$export(module.exports, "timer", () => $cd77a2c83772d92a$export$9dc4ecf953986f04, (v) => $cd77a2c83772d92a$export$9dc4ecf953986f04 = v);
var $cd77a2c83772d92a$export$9dc4ecf953986f04;
"use strict";

var $6x85r = parcelRequire("6x85r");
$cd77a2c83772d92a$export$9dc4ecf953986f04 = $6x85r.TimerObservable.create;

});
parcelRegister("6x85r", function(module, exports) {
"use strict";
var $4c1c18fd46c21ed3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hHpuK = parcelRequire("hHpuK");

var $8jOUp = parcelRequire("8jOUp");

var $kESbZ = parcelRequire("kESbZ");

var $86ewR = parcelRequire("86ewR");

var $aElH5 = parcelRequire("aElH5");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $4c1c18fd46c21ed3$var$TimerObservable = function(_super) {
    $4c1c18fd46c21ed3$var$__extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) dueTime = 0;
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if ($hHpuK.isNumeric(period)) this.period = Number(period) < 1 && 1 || Number(period);
        else if ($86ewR.isScheduler(period)) scheduler = period;
        if (!$86ewR.isScheduler(scheduler)) scheduler = $kESbZ.async;
        this.scheduler = scheduler;
        this.dueTime = $aElH5.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */ TimerObservable.create = function(initialDelay, period, scheduler) {
        if (initialDelay === void 0) initialDelay = 0;
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function(state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) return;
        else if (period === -1) return subscriber.complete();
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index,
            period: period,
            subscriber: subscriber
        });
    };
    return TimerObservable;
}($8jOUp.Observable);
module.exports.TimerObservable = $4c1c18fd46c21ed3$var$TimerObservable;

});
parcelRegister("aElH5", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $7c0e77c6d0972da0$export$871608497c498473, (v) => $7c0e77c6d0972da0$export$871608497c498473 = v);
var $7c0e77c6d0972da0$export$871608497c498473;
"use strict";
function $7c0e77c6d0972da0$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$7c0e77c6d0972da0$export$871608497c498473 = $7c0e77c6d0972da0$var$isDate;

});




parcelRegister("7CQsp", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $c8wpU = parcelRequire("c8wpU");
$8jOUp.Observable.zip = $c8wpU.zip;

});
parcelRegister("c8wpU", function(module, exports) {
$parcel$export(module.exports, "zip", () => $8d5f60b2f6b617d6$export$8901015135f2fb22, (v) => $8d5f60b2f6b617d6$export$8901015135f2fb22 = v);
var $8d5f60b2f6b617d6$export$8901015135f2fb22;
"use strict";

var $2mE2X = parcelRequire("2mE2X");
$8d5f60b2f6b617d6$export$8901015135f2fb22 = $2mE2X.zipStatic;

});
parcelRegister("2mE2X", function(module, exports) {
"use strict";
var $1b8cb34817fc0100$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fznCF = parcelRequire("fznCF");

var $gWadc = parcelRequire("gWadc");

var $66gCN = parcelRequire("66gCN");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");

var $huYam = parcelRequire("huYam");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $1b8cb34817fc0100$var$zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call($1b8cb34817fc0100$var$zipStatic.apply(void 0, [
            source
        ].concat(observables)));
    };
}
module.exports.zip = $1b8cb34817fc0100$var$zip;
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */ function $1b8cb34817fc0100$var$zipStatic() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = observables[observables.length - 1];
    if (typeof project === 'function') observables.pop();
    return new $fznCF.ArrayObservable(observables).lift(new $1b8cb34817fc0100$var$ZipOperator(project));
}
module.exports.zipStatic = $1b8cb34817fc0100$var$zipStatic;
var $1b8cb34817fc0100$var$ZipOperator = function() {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8cb34817fc0100$var$ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}();
module.exports.ZipOperator = $1b8cb34817fc0100$var$ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8cb34817fc0100$var$ZipSubscriber = function(_super) {
    $1b8cb34817fc0100$var$__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) values = Object.create(null);
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = typeof project === 'function' ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ($gWadc.isArray(value)) iterators.push(new $1b8cb34817fc0100$var$StaticArrayIterator(value));
        else if (typeof value[$huYam.iterator] === 'function') iterators.push(new $1b8cb34817fc0100$var$StaticIterator(value[$huYam.iterator]()));
        else iterators.push(new $1b8cb34817fc0100$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) this.add(iterator.subscribe(iterator, i));
            else this.active--; // not an observable
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) this._tryProject(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}($66gCN.Subscriber);
module.exports.ZipSubscriber = $1b8cb34817fc0100$var$ZipSubscriber;
var $1b8cb34817fc0100$var$StaticIterator = function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}();
var $1b8cb34817fc0100$var$StaticArrayIterator = function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[$huYam.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8cb34817fc0100$var$ZipBufferIterator = function(_super) {
    $1b8cb34817fc0100$var$__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[$huYam.iterator] = function() {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function(value, index) {
        return $jziWR.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("kXbZr", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $5tSgB = parcelRequire("5tSgB");
$8jOUp.Observable.ajax = $5tSgB.ajax;

});
parcelRegister("5tSgB", function(module, exports) {
$parcel$export(module.exports, "ajax", () => $3fd9c1762f2a4f3b$export$e68fce4c5f453854, (v) => $3fd9c1762f2a4f3b$export$e68fce4c5f453854 = v);
var $3fd9c1762f2a4f3b$export$e68fce4c5f453854;
"use strict";

var $hZ6dG = parcelRequire("hZ6dG");
$3fd9c1762f2a4f3b$export$e68fce4c5f453854 = $hZ6dG.AjaxObservable.create;

});
parcelRegister("hZ6dG", function(module, exports) {
"use strict";
var $d17cf543809e5b91$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a5Mzo = parcelRequire("a5Mzo");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $8jOUp = parcelRequire("8jOUp");

var $66gCN = parcelRequire("66gCN");

var $bP9Wc = parcelRequire("bP9Wc");
function $d17cf543809e5b91$var$getCORSRequest() {
    if ($a5Mzo.root.XMLHttpRequest) return new $a5Mzo.root.XMLHttpRequest();
    else if (!!$a5Mzo.root.XDomainRequest) return new $a5Mzo.root.XDomainRequest();
    else throw new Error('CORS is not supported by your browser');
}
function $d17cf543809e5b91$var$getXMLHttpRequest() {
    if ($a5Mzo.root.XMLHttpRequest) return new $a5Mzo.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                'Msxml2.XMLHTTP',
                'Microsoft.XMLHTTP',
                'Msxml2.XMLHTTP.4.0'
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $a5Mzo.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $a5Mzo.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function $d17cf543809e5b91$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $d17cf543809e5b91$var$AjaxObservable({
        method: 'GET',
        url: url,
        headers: headers
    });
}
module.exports.ajaxGet = $d17cf543809e5b91$var$ajaxGet;
function $d17cf543809e5b91$var$ajaxPost(url, body, headers) {
    return new $d17cf543809e5b91$var$AjaxObservable({
        method: 'POST',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPost = $d17cf543809e5b91$var$ajaxPost;
function $d17cf543809e5b91$var$ajaxDelete(url, headers) {
    return new $d17cf543809e5b91$var$AjaxObservable({
        method: 'DELETE',
        url: url,
        headers: headers
    });
}
module.exports.ajaxDelete = $d17cf543809e5b91$var$ajaxDelete;
function $d17cf543809e5b91$var$ajaxPut(url, body, headers) {
    return new $d17cf543809e5b91$var$AjaxObservable({
        method: 'PUT',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPut = $d17cf543809e5b91$var$ajaxPut;
function $d17cf543809e5b91$var$ajaxPatch(url, body, headers) {
    return new $d17cf543809e5b91$var$AjaxObservable({
        method: 'PATCH',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPatch = $d17cf543809e5b91$var$ajaxPatch;
var $d17cf543809e5b91$var$mapResponse = $bP9Wc.map(function(x, index) {
    return x.response;
});
function $d17cf543809e5b91$var$ajaxGetJSON(url, headers) {
    return $d17cf543809e5b91$var$mapResponse(new $d17cf543809e5b91$var$AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
module.exports.ajaxGetJSON = $d17cf543809e5b91$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $d17cf543809e5b91$var$AjaxObservable = function(_super) {
    $d17cf543809e5b91$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $d17cf543809e5b91$var$getCORSRequest.call(this) : $d17cf543809e5b91$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $d17cf543809e5b91$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $d17cf543809e5b91$var$ajaxGet;
        create.post = $d17cf543809e5b91$var$ajaxPost;
        create.delete = $d17cf543809e5b91$var$ajaxDelete;
        create.put = $d17cf543809e5b91$var$ajaxPut;
        create.patch = $d17cf543809e5b91$var$ajaxPatch;
        create.getJSON = $d17cf543809e5b91$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($8jOUp.Observable);
module.exports.AjaxObservable = $d17cf543809e5b91$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d17cf543809e5b91$var$AjaxSubscriber = function(_super) {
    $d17cf543809e5b91$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) headers['X-Requested-With'] = 'XMLHttpRequest';
        // ensure content type is set
        if (!('Content-Type' in headers) && !($a5Mzo.root.FormData && request.body instanceof $a5Mzo.root.FormData) && typeof request.body !== 'undefined') headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $d17cf543809e5b91$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $cxrX4.tryCatch(createXHR).call(request);
        if (xhr === $2afHm.errorObject) this.error($2afHm.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $cxrX4.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $cxrX4.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $2afHm.errorObject) {
                this.error($2afHm.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $cxrX4.tryCatch(xhr.send).call(xhr, body) : $cxrX4.tryCatch(xhr.send).call(xhr);
            if (result === $2afHm.errorObject) {
                this.error($2afHm.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === 'string') return body;
        else if ($a5Mzo.root.FormData && body instanceof $a5Mzo.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $d17cf543809e5b91$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($a5Mzo.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $d17cf543809e5b91$var$AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === 'text' ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $d17cf543809e5b91$var$AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($66gCN.Subscriber);
module.exports.AjaxSubscriber = $d17cf543809e5b91$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $d17cf543809e5b91$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $d17cf543809e5b91$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
module.exports.AjaxResponse = $d17cf543809e5b91$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $d17cf543809e5b91$var$AjaxError = function(_super) {
    $d17cf543809e5b91$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $d17cf543809e5b91$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
module.exports.AjaxError = $d17cf543809e5b91$var$AjaxError;
function $d17cf543809e5b91$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case 'json':
            if ('response' in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || 'null');
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return 'response' in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $d17cf543809e5b91$var$AjaxTimeoutError = function(_super) {
    $d17cf543809e5b91$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}($d17cf543809e5b91$var$AjaxError);
module.exports.AjaxTimeoutError = $d17cf543809e5b91$var$AjaxTimeoutError;

});



parcelRegister("3QeMM", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $aLz8q = parcelRequire("aLz8q");
$8jOUp.Observable.webSocket = $aLz8q.webSocket;

});
parcelRegister("aLz8q", function(module, exports) {
$parcel$export(module.exports, "webSocket", () => $7d698c36d0508ff1$export$debf5095acd2163f, (v) => $7d698c36d0508ff1$export$debf5095acd2163f = v);
var $7d698c36d0508ff1$export$debf5095acd2163f;
"use strict";

var $dqnJY = parcelRequire("dqnJY");
$7d698c36d0508ff1$export$debf5095acd2163f = $dqnJY.WebSocketSubject.create;

});
parcelRegister("dqnJY", function(module, exports) {
"use strict";
var $9c601e7086711d3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $66gCN = parcelRequire("66gCN");

var $8jOUp = parcelRequire("8jOUp");

var $aAAtt = parcelRequire("aAAtt");

var $a5Mzo = parcelRequire("a5Mzo");

var $9nelC = parcelRequire("9nelC");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $hXcAd = parcelRequire("hXcAd");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $9c601e7086711d3c$var$WebSocketSubject = function(_super) {
    $9c601e7086711d3c$var$__extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof $8jOUp.Observable) _super.call(this, destination, urlConfigOrSource);
        else {
            _super.call(this);
            this.WebSocketCtor = $a5Mzo.root.WebSocket;
            this._output = new $gJqoA.Subject();
            if (typeof urlConfigOrSource === 'string') this.url = urlConfigOrSource;
            else // WARNING: config object could override important members here.
            $hXcAd.assign(this, urlConfigOrSource);
            if (!this.WebSocketCtor) throw new Error('no WebSocket constructor can be found');
            this.destination = new $9nelC.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function(e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */ WebSocketSubject.create = function(urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function(operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function() {
        this.socket = null;
        if (!this.source) this.destination = new $9nelC.ReplaySubject();
        this._output = new $gJqoA.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function(subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new $8jOUp.Observable(function(observer) {
            var result = $cxrX4.tryCatch(subMsg)();
            if (result === $2afHm.errorObject) observer.error($2afHm.errorObject.e);
            else self.next(result);
            var subscription = self.subscribe(function(x) {
                var result = $cxrX4.tryCatch(messageFilter)(x);
                if (result === $2afHm.errorObject) observer.error($2afHm.errorObject.e);
                else if (result) observer.next(x);
            }, function(err) {
                return observer.error(err);
            }, function() {
                return observer.complete();
            });
            return function() {
                var result = $cxrX4.tryCatch(unsubMsg)();
                if (result === $2afHm.errorObject) observer.error($2afHm.errorObject.e);
                else self.next(result);
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function() {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ? new WebSocketCtor(this.url, this.protocol) : new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) this.socket.binaryType = this.binaryType;
        } catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new $aAAtt.Subscription(function() {
            _this.socket = null;
            if (socket && socket.readyState === 1) socket.close();
        });
        socket.onopen = function(e) {
            var openObserver = _this.openObserver;
            if (openObserver) openObserver.next(e);
            var queue = _this.destination;
            _this.destination = $66gCN.Subscriber.create(function(x) {
                return socket.readyState === 1 && socket.send(x);
            }, function(e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                if (e && e.code) socket.close(e.code, e.reason);
                else observer.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }"));
                _this._resetState();
            }, function() {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof $9nelC.ReplaySubject) subscription.add(queue.subscribe(_this.destination));
        };
        socket.onerror = function(e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function(e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) closeObserver.next(e);
            if (e.wasClean) observer.complete();
            else observer.error(e);
        };
        socket.onmessage = function(e) {
            var result = $cxrX4.tryCatch(_this.resultSelector)(e);
            if (result === $2afHm.errorObject) observer.error($2afHm.errorObject.e);
            else observer.next(result);
        };
    };
    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function(subscriber) {
        var _this = this;
        var source = this.source;
        if (source) return source.subscribe(subscriber);
        if (!this.socket) this._connectSocket();
        var subscription = new $aAAtt.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function() {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) socket.close();
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function() {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) this.destination = new $9nelC.ReplaySubject();
    };
    return WebSocketSubject;
}($gJqoA.AnonymousSubject);
module.exports.WebSocketSubject = $9c601e7086711d3c$var$WebSocketSubject;

});
parcelRegister("hXcAd", function(module, exports) {
$parcel$export(module.exports, "assign", () => $d121b5155dba28ec$export$e6e34fd1f2686227, (v) => $d121b5155dba28ec$export$e6e34fd1f2686227 = v);
var $d121b5155dba28ec$export$b668effad3120ef4;
var $d121b5155dba28ec$export$e4f7f8fe212de33b;
var $d121b5155dba28ec$export$e6e34fd1f2686227;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
function $d121b5155dba28ec$var$assignImpl(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    var len = sources.length;
    for(var i = 0; i < len; i++){
        var source = sources[i];
        for(var k in source)if (source.hasOwnProperty(k)) target[k] = source[k];
    }
    return target;
}
$d121b5155dba28ec$export$b668effad3120ef4 = $d121b5155dba28ec$var$assignImpl;
function $d121b5155dba28ec$var$getAssign(root) {
    return root.Object.assign || $d121b5155dba28ec$var$assignImpl;
}
$d121b5155dba28ec$export$e4f7f8fe212de33b = $d121b5155dba28ec$var$getAssign;
$d121b5155dba28ec$export$e6e34fd1f2686227 = $d121b5155dba28ec$var$getAssign($a5Mzo.root);

});




parcelRegister("40kBs", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $cvzWQ = parcelRequire("cvzWQ");
$8jOUp.Observable.prototype.buffer = $cvzWQ.buffer;

});
parcelRegister("cvzWQ", function(module, exports) {
$parcel$export(module.exports, "buffer", () => $91b443d06eb1aec0$export$ab1029bcae9ddb4a, (v) => $91b443d06eb1aec0$export$ab1029bcae9ddb4a = v);
var $91b443d06eb1aec0$export$ab1029bcae9ddb4a;
"use strict";

var $8XIgu = parcelRequire("8XIgu");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $91b443d06eb1aec0$var$buffer(closingNotifier) {
    return $8XIgu.buffer(closingNotifier)(this);
}
$91b443d06eb1aec0$export$ab1029bcae9ddb4a = $91b443d06eb1aec0$var$buffer;

});
parcelRegister("8XIgu", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var BufferSubscriber = function(_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add($jziWR.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("tjSSI", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9E9LQ = parcelRequire("9E9LQ");
$8jOUp.Observable.prototype.bufferCount = $9E9LQ.bufferCount;

});
parcelRegister("9E9LQ", function(module, exports) {
$parcel$export(module.exports, "bufferCount", () => $705f6dbca3725d26$export$8916d2c8119541bb, (v) => $705f6dbca3725d26$export$8916d2c8119541bb = v);
var $705f6dbca3725d26$export$8916d2c8119541bb;
"use strict";

var $3gIhm = parcelRequire("3gIhm");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $705f6dbca3725d26$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return $3gIhm.bufferCount(bufferSize, startBufferEvery)(this);
}
$705f6dbca3725d26$export$8916d2c8119541bb = $705f6dbca3725d26$var$bufferCount;

});


parcelRegister("166ck", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $ilQNp = parcelRequire("ilQNp");
$8jOUp.Observable.prototype.bufferTime = $ilQNp.bufferTime;

});
parcelRegister("ilQNp", function(module, exports) {
$parcel$export(module.exports, "bufferTime", () => $d5c32451a152f90a$export$d6b40c95035461c7, (v) => $d5c32451a152f90a$export$d6b40c95035461c7 = v);
var $d5c32451a152f90a$export$d6b40c95035461c7;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $86ewR = parcelRequire("86ewR");

var $ajXNp = parcelRequire("ajXNp");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $d5c32451a152f90a$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $kESbZ.async;
    if ($86ewR.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return $ajXNp.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
$d5c32451a152f90a$export$d6b40c95035461c7 = $d5c32451a152f90a$var$bufferTime;

});
parcelRegister("ajXNp", function(module, exports) {
"use strict";
var $783a0fee19702044$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kESbZ = parcelRequire("kESbZ");

var $66gCN = parcelRequire("66gCN");

var $86ewR = parcelRequire("86ewR");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $783a0fee19702044$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $kESbZ.async;
    if ($86ewR.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new $783a0fee19702044$var$BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
module.exports.bufferTime = $783a0fee19702044$var$bufferTime;
var $783a0fee19702044$var$BufferTimeOperator = function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $783a0fee19702044$var$BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var $783a0fee19702044$var$Context = function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $783a0fee19702044$var$BufferTimeSubscriber = function(_super) {
    $783a0fee19702044$var$__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = scheduler.schedule($783a0fee19702044$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(context.closeAction = scheduler.schedule($783a0fee19702044$var$dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule($783a0fee19702044$var$dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule($783a0fee19702044$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new $783a0fee19702044$var$Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}($66gCN.Subscriber);
function $783a0fee19702044$var$dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function $783a0fee19702044$var$dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule($783a0fee19702044$var$dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function $783a0fee19702044$var$dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

});



parcelRegister("dlyvF", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9GynI = parcelRequire("9GynI");
$8jOUp.Observable.prototype.bufferToggle = $9GynI.bufferToggle;

});
parcelRegister("9GynI", function(module, exports) {
$parcel$export(module.exports, "bufferToggle", () => $70d2b4bb5e237a56$export$91115bdd8709945f, (v) => $70d2b4bb5e237a56$export$91115bdd8709945f = v);
var $70d2b4bb5e237a56$export$91115bdd8709945f;
"use strict";

var $kURQw = parcelRequire("kURQw");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $70d2b4bb5e237a56$var$bufferToggle(openings, closingSelector) {
    return $kURQw.bufferToggle(openings, closingSelector)(this);
}
$70d2b4bb5e237a56$export$91115bdd8709945f = $70d2b4bb5e237a56$var$bufferToggle;

});
parcelRegister("kURQw", function(module, exports) {
"use strict";
var $03edfb11ee73d7c5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aAAtt = parcelRequire("aAAtt");

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $03edfb11ee73d7c5$var$bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new $03edfb11ee73d7c5$var$BufferToggleOperator(openings, closingSelector));
    };
}
module.exports.bufferToggle = $03edfb11ee73d7c5$var$bufferToggle;
var $03edfb11ee73d7c5$var$BufferToggleOperator = function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $03edfb11ee73d7c5$var$BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $03edfb11ee73d7c5$var$BufferToggleSubscriber = function(_super) {
    $03edfb11ee73d7c5$var$__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add($jziWR.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new $aAAtt.Subscription();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = $jziWR.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("bW02i", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $g6oLT = parcelRequire("g6oLT");
$8jOUp.Observable.prototype.bufferWhen = $g6oLT.bufferWhen;

});
parcelRegister("g6oLT", function(module, exports) {
$parcel$export(module.exports, "bufferWhen", () => $bb906bffc89dca16$export$9e55760d3282e08c, (v) => $bb906bffc89dca16$export$9e55760d3282e08c = v);
var $bb906bffc89dca16$export$9e55760d3282e08c;
"use strict";

var $2Z676 = parcelRequire("2Z676");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $bb906bffc89dca16$var$bufferWhen(closingSelector) {
    return $2Z676.bufferWhen(closingSelector)(this);
}
$bb906bffc89dca16$export$9e55760d3282e08c = $bb906bffc89dca16$var$bufferWhen;

});
parcelRegister("2Z676", function(module, exports) {
"use strict";
var $22c6055218c9d847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aAAtt = parcelRequire("aAAtt");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $22c6055218c9d847$var$bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new $22c6055218c9d847$var$BufferWhenOperator(closingSelector));
    };
}
module.exports.bufferWhen = $22c6055218c9d847$var$bufferWhen;
var $22c6055218c9d847$var$BufferWhenOperator = function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $22c6055218c9d847$var$BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $22c6055218c9d847$var$BufferWhenSubscriber = function(_super) {
    $22c6055218c9d847$var$__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier = $cxrX4.tryCatch(this.closingSelector)();
        if (closingNotifier === $2afHm.errorObject) this.error($2afHm.errorObject.e);
        else {
            closingSubscription = new $aAAtt.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add($jziWR.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("cN9YV", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4H0Br = parcelRequire("4H0Br");
$8jOUp.Observable.prototype.catch = $4H0Br._catch;
$8jOUp.Observable.prototype._catch = $4H0Br._catch;

});
parcelRegister("4H0Br", function(module, exports) {
$parcel$export(module.exports, "_catch", () => $36aba552e7757213$export$7f43fa37c3d8a0b3, (v) => $36aba552e7757213$export$7f43fa37c3d8a0b3 = v);
var $36aba552e7757213$export$7f43fa37c3d8a0b3;
"use strict";

var $gtLoC = parcelRequire("gtLoC");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $36aba552e7757213$var$_catch(selector) {
    return $gtLoC.catchError(selector)(this);
}
$36aba552e7757213$export$7f43fa37c3d8a0b3 = $36aba552e7757213$var$_catch;

});
parcelRegister("gtLoC", function(module, exports) {
"use strict";
var $bff41ea5de269ce0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $bff41ea5de269ce0$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $bff41ea5de269ce0$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $bff41ea5de269ce0$var$catchError;
var $bff41ea5de269ce0$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bff41ea5de269ce0$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bff41ea5de269ce0$var$CatchSubscriber = function(_super) {
    $bff41ea5de269ce0$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($jziWR.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("4Ao32", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $8KfhN = parcelRequire("8KfhN");
$8jOUp.Observable.prototype.combineAll = $8KfhN.combineAll;

});
parcelRegister("8KfhN", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $65de7a151cd4d641$export$29ae691b7de52fe3, (v) => $65de7a151cd4d641$export$29ae691b7de52fe3 = v);
var $65de7a151cd4d641$export$29ae691b7de52fe3;
"use strict";

var $dm9qI = parcelRequire("dm9qI");
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */ function $65de7a151cd4d641$var$combineAll(project) {
    return $dm9qI.combineAll(project)(this);
}
$65de7a151cd4d641$export$29ae691b7de52fe3 = $65de7a151cd4d641$var$combineAll;

});
parcelRegister("dm9qI", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $9b94a5022c6e9d25$export$29ae691b7de52fe3, (v) => $9b94a5022c6e9d25$export$29ae691b7de52fe3 = v);
var $9b94a5022c6e9d25$export$29ae691b7de52fe3;
"use strict";

var $5IzkJ = parcelRequire("5IzkJ");
function $9b94a5022c6e9d25$var$combineAll(project) {
    return function(source) {
        return source.lift(new $5IzkJ.CombineLatestOperator(project));
    };
}
$9b94a5022c6e9d25$export$29ae691b7de52fe3 = $9b94a5022c6e9d25$var$combineAll;

});



parcelRegister("6Ucv4", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kpgYC = parcelRequire("kpgYC");
$8jOUp.Observable.prototype.combineLatest = $kpgYC.combineLatest;

});
parcelRegister("kpgYC", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $edb34fb132a07b41$export$77fa7d86f5204e8a, (v) => $edb34fb132a07b41$export$77fa7d86f5204e8a = v);
var $edb34fb132a07b41$export$77fa7d86f5204e8a;
"use strict";

var $5IzkJ = parcelRequire("5IzkJ");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $edb34fb132a07b41$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $5IzkJ.combineLatest.apply(void 0, observables)(this);
}
$edb34fb132a07b41$export$77fa7d86f5204e8a = $edb34fb132a07b41$var$combineLatest;

});


parcelRegister("2v7Tu", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $5zlKY = parcelRequire("5zlKY");
$8jOUp.Observable.prototype.concat = $5zlKY.concat;

});
parcelRegister("5zlKY", function(module, exports) {
$parcel$export(module.exports, "concat", () => $40e1190f2a3e9f9a$export$ee1b3e54f0441b22, (v) => $40e1190f2a3e9f9a$export$ee1b3e54f0441b22 = v);
var $40e1190f2a3e9f9a$export$9343b684b018b33a;
var $40e1190f2a3e9f9a$export$ee1b3e54f0441b22;
"use strict";

var $dlsxa = parcelRequire("dlsxa");

var $77dSs = parcelRequire("77dSs");
$40e1190f2a3e9f9a$export$9343b684b018b33a = $77dSs.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $40e1190f2a3e9f9a$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $dlsxa.concat.apply(void 0, observables)(this);
}
$40e1190f2a3e9f9a$export$ee1b3e54f0441b22 = $40e1190f2a3e9f9a$var$concat;

});
parcelRegister("dlsxa", function(module, exports) {
$parcel$export(module.exports, "concat", () => $9b735ec832fb277e$export$ee1b3e54f0441b22, (v) => $9b735ec832fb277e$export$ee1b3e54f0441b22 = v);
var $9b735ec832fb277e$export$9343b684b018b33a;
var $9b735ec832fb277e$export$ee1b3e54f0441b22;
"use strict";

var $77dSs = parcelRequire("77dSs");

var $77dSs = parcelRequire("77dSs");
$9b735ec832fb277e$export$9343b684b018b33a = $77dSs.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $9b735ec832fb277e$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($77dSs.concat.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$9b735ec832fb277e$export$ee1b3e54f0441b22 = $9b735ec832fb277e$var$concat;

});



parcelRegister("1SgA8", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $2zt48 = parcelRequire("2zt48");
$8jOUp.Observable.prototype.concatAll = $2zt48.concatAll;

});
parcelRegister("2zt48", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $1df5657dbacb659d$export$b314777ae20abca9, (v) => $1df5657dbacb659d$export$b314777ae20abca9 = v);
var $1df5657dbacb659d$export$b314777ae20abca9;
"use strict";

var $7xfVB = parcelRequire("7xfVB");
/* tslint:enable:max-line-length */ /**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $1df5657dbacb659d$var$concatAll() {
    return $7xfVB.concatAll()(this);
}
$1df5657dbacb659d$export$b314777ae20abca9 = $1df5657dbacb659d$var$concatAll;

});


parcelRegister("F6XBw", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $cWrXT = parcelRequire("cWrXT");
$8jOUp.Observable.prototype.concatMap = $cWrXT.concatMap;

});
parcelRegister("cWrXT", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $96c0981c2929a8b0$export$c28c8388be0ab31a, (v) => $96c0981c2929a8b0$export$c28c8388be0ab31a = v);
var $96c0981c2929a8b0$export$c28c8388be0ab31a;
"use strict";

var $h4te9 = parcelRequire("h4te9");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $96c0981c2929a8b0$var$concatMap(project, resultSelector) {
    return $h4te9.concatMap(project, resultSelector)(this);
}
$96c0981c2929a8b0$export$c28c8388be0ab31a = $96c0981c2929a8b0$var$concatMap;

});


parcelRegister("1k0mq", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9gpVV = parcelRequire("9gpVV");
$8jOUp.Observable.prototype.concatMapTo = $9gpVV.concatMapTo;

});
parcelRegister("9gpVV", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $6be9b97a8a115e46$export$82fbd7a2841d2484, (v) => $6be9b97a8a115e46$export$82fbd7a2841d2484 = v);
var $6be9b97a8a115e46$export$82fbd7a2841d2484;
"use strict";

var $7L3r1 = parcelRequire("7L3r1");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $6be9b97a8a115e46$var$concatMapTo(innerObservable, resultSelector) {
    return $7L3r1.concatMapTo(innerObservable, resultSelector)(this);
}
$6be9b97a8a115e46$export$82fbd7a2841d2484 = $6be9b97a8a115e46$var$concatMapTo;

});
parcelRegister("7L3r1", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $5a5f9640be2e102d$export$82fbd7a2841d2484, (v) => $5a5f9640be2e102d$export$82fbd7a2841d2484 = v);
var $5a5f9640be2e102d$export$82fbd7a2841d2484;
"use strict";

var $h4te9 = parcelRequire("h4te9");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $5a5f9640be2e102d$var$concatMapTo(innerObservable, resultSelector) {
    return $h4te9.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$5a5f9640be2e102d$export$82fbd7a2841d2484 = $5a5f9640be2e102d$var$concatMapTo;

});



parcelRegister("7DNBi", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $eL1OZ = parcelRequire("eL1OZ");
$8jOUp.Observable.prototype.count = $eL1OZ.count;

});
parcelRegister("eL1OZ", function(module, exports) {
$parcel$export(module.exports, "count", () => $abe6de3184458543$export$85b9a36db797e02b, (v) => $abe6de3184458543$export$85b9a36db797e02b = v);
var $abe6de3184458543$export$85b9a36db797e02b;
"use strict";

var $fYYEX = parcelRequire("fYYEX");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $abe6de3184458543$var$count(predicate) {
    return $fYYEX.count(predicate)(this);
}
$abe6de3184458543$export$85b9a36db797e02b = $abe6de3184458543$var$count;

});
parcelRegister("fYYEX", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("jWHQw", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $8nmCR = parcelRequire("8nmCR");
$8jOUp.Observable.prototype.dematerialize = $8nmCR.dematerialize;

});
parcelRegister("8nmCR", function(module, exports) {
$parcel$export(module.exports, "dematerialize", () => $619205b94dd4228a$export$ab9a5985b741fa7a, (v) => $619205b94dd4228a$export$ab9a5985b741fa7a = v);
var $619205b94dd4228a$export$ab9a5985b741fa7a;
"use strict";

var $5AZnY = parcelRequire("5AZnY");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $619205b94dd4228a$var$dematerialize() {
    return $5AZnY.dematerialize()(this);
}
$619205b94dd4228a$export$ab9a5985b741fa7a = $619205b94dd4228a$var$dematerialize;

});
parcelRegister("5AZnY", function(module, exports) {
"use strict";
var $412fee7ab3cdcb42$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $412fee7ab3cdcb42$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $412fee7ab3cdcb42$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $412fee7ab3cdcb42$var$dematerialize;
var $412fee7ab3cdcb42$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $412fee7ab3cdcb42$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $412fee7ab3cdcb42$var$DeMaterializeSubscriber = function(_super) {
    $412fee7ab3cdcb42$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("gJ4lB", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $1tdyB = parcelRequire("1tdyB");
$8jOUp.Observable.prototype.debounce = $1tdyB.debounce;

});
parcelRegister("1tdyB", function(module, exports) {
$parcel$export(module.exports, "debounce", () => $11230406260d1eda$export$61fc7d43ac8f84b0, (v) => $11230406260d1eda$export$61fc7d43ac8f84b0 = v);
var $11230406260d1eda$export$61fc7d43ac8f84b0;
"use strict";

var $8pSz4 = parcelRequire("8pSz4");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $11230406260d1eda$var$debounce(durationSelector) {
    return $8pSz4.debounce(durationSelector)(this);
}
$11230406260d1eda$export$61fc7d43ac8f84b0 = $11230406260d1eda$var$debounce;

});
parcelRegister("8pSz4", function(module, exports) {
"use strict";
var $620afbf52d057a55$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $620afbf52d057a55$var$debounce(durationSelector) {
    return function(source) {
        return source.lift(new $620afbf52d057a55$var$DebounceOperator(durationSelector));
    };
}
module.exports.debounce = $620afbf52d057a55$var$debounce;
var $620afbf52d057a55$var$DebounceOperator = function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $620afbf52d057a55$var$DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $620afbf52d057a55$var$DebounceSubscriber = function(_super) {
    $620afbf52d057a55$var$__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = $jziWR.subscribeToResult(this, duration);
        if (!subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("4MHp0", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $3boVB = parcelRequire("3boVB");
$8jOUp.Observable.prototype.debounceTime = $3boVB.debounceTime;

});
parcelRegister("3boVB", function(module, exports) {
$parcel$export(module.exports, "debounceTime", () => $2515bc6003a81f89$export$7843a4469d64c07e, (v) => $2515bc6003a81f89$export$7843a4469d64c07e = v);
var $2515bc6003a81f89$export$7843a4469d64c07e;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $45ySv = parcelRequire("45ySv");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $2515bc6003a81f89$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $45ySv.debounceTime(dueTime, scheduler)(this);
}
$2515bc6003a81f89$export$7843a4469d64c07e = $2515bc6003a81f89$var$debounceTime;

});
parcelRegister("45ySv", function(module, exports) {
"use strict";
var $2fa2af23c5e99911$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $kESbZ = parcelRequire("kESbZ");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $2fa2af23c5e99911$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return function(source) {
        return source.lift(new $2fa2af23c5e99911$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $2fa2af23c5e99911$var$debounceTime;
var $2fa2af23c5e99911$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2fa2af23c5e99911$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2fa2af23c5e99911$var$DebounceTimeSubscriber = function(_super) {
    $2fa2af23c5e99911$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($2fa2af23c5e99911$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($66gCN.Subscriber);
function $2fa2af23c5e99911$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});



parcelRegister("jgsJa", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kLC0L = parcelRequire("kLC0L");
$8jOUp.Observable.prototype.defaultIfEmpty = $kLC0L.defaultIfEmpty;

});
parcelRegister("kLC0L", function(module, exports) {
$parcel$export(module.exports, "defaultIfEmpty", () => $f1e5aeabd0ba5979$export$e4ca6d7b7a6dcf9b, (v) => $f1e5aeabd0ba5979$export$e4ca6d7b7a6dcf9b = v);
var $f1e5aeabd0ba5979$export$e4ca6d7b7a6dcf9b;
"use strict";

var $7DEqP = parcelRequire("7DEqP");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $f1e5aeabd0ba5979$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $7DEqP.defaultIfEmpty(defaultValue)(this);
}
$f1e5aeabd0ba5979$export$e4ca6d7b7a6dcf9b = $f1e5aeabd0ba5979$var$defaultIfEmpty;

});
parcelRegister("7DEqP", function(module, exports) {
"use strict";
var $58fb89d02b637d50$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $58fb89d02b637d50$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $58fb89d02b637d50$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $58fb89d02b637d50$var$defaultIfEmpty;
var $58fb89d02b637d50$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $58fb89d02b637d50$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $58fb89d02b637d50$var$DefaultIfEmptySubscriber = function(_super) {
    $58fb89d02b637d50$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($66gCN.Subscriber);

});



parcelRegister("ffeq9", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $bBSkk = parcelRequire("bBSkk");
$8jOUp.Observable.prototype.delay = $bBSkk.delay;

});
parcelRegister("bBSkk", function(module, exports) {
$parcel$export(module.exports, "delay", () => $873d4a92d74da0f3$export$1391212d75b2ee65, (v) => $873d4a92d74da0f3$export$1391212d75b2ee65 = v);
var $873d4a92d74da0f3$export$1391212d75b2ee65;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $4s1nx = parcelRequire("4s1nx");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $873d4a92d74da0f3$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $4s1nx.delay(delay, scheduler)(this);
}
$873d4a92d74da0f3$export$1391212d75b2ee65 = $873d4a92d74da0f3$var$delay;

});
parcelRegister("4s1nx", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kESbZ = parcelRequire("kESbZ");

var $aElH5 = parcelRequire("aElH5");

var $66gCN = parcelRequire("66gCN");

var $fTcsX = parcelRequire("fTcsX");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    var absoluteDelay = $aElH5.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($fTcsX.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($fTcsX.Notification.createComplete());
    };
    return DelaySubscriber;
}($66gCN.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});



parcelRegister("eXlok", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $CWkbB = parcelRequire("CWkbB");
$8jOUp.Observable.prototype.delayWhen = $CWkbB.delayWhen;

});
parcelRegister("CWkbB", function(module, exports) {
$parcel$export(module.exports, "delayWhen", () => $0750cac584871cac$export$286ca829307725c9, (v) => $0750cac584871cac$export$286ca829307725c9 = v);
var $0750cac584871cac$export$286ca829307725c9;
"use strict";

var $1Z46w = parcelRequire("1Z46w");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $0750cac584871cac$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    return $1Z46w.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
$0750cac584871cac$export$286ca829307725c9 = $0750cac584871cac$var$delayWhen;

});
parcelRegister("1Z46w", function(module, exports) {
"use strict";
var $171eabef8ce8c65e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $8jOUp = parcelRequire("8jOUp");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $171eabef8ce8c65e$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $171eabef8ce8c65e$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $171eabef8ce8c65e$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $171eabef8ce8c65e$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $171eabef8ce8c65e$var$delayWhen;
var $171eabef8ce8c65e$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $171eabef8ce8c65e$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $171eabef8ce8c65e$var$DelayWhenSubscriber = function(_super) {
    $171eabef8ce8c65e$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $jziWR.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($2L5Gq.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $171eabef8ce8c65e$var$SubscriptionDelayObservable = function(_super) {
    $171eabef8ce8c65e$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $171eabef8ce8c65e$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($8jOUp.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $171eabef8ce8c65e$var$SubscriptionDelaySubscriber = function(_super) {
    $171eabef8ce8c65e$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($66gCN.Subscriber);

});



parcelRegister("8tULk", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $707dN = parcelRequire("707dN");
$8jOUp.Observable.prototype.distinct = $707dN.distinct;

});
parcelRegister("707dN", function(module, exports) {
$parcel$export(module.exports, "distinct", () => $518e22848fd4af68$export$983a3b5fb2f7202e, (v) => $518e22848fd4af68$export$983a3b5fb2f7202e = v);
var $518e22848fd4af68$export$983a3b5fb2f7202e;
"use strict";

var $7VsUA = parcelRequire("7VsUA");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $518e22848fd4af68$var$distinct(keySelector, flushes) {
    return $7VsUA.distinct(keySelector, flushes)(this);
}
$518e22848fd4af68$export$983a3b5fb2f7202e = $518e22848fd4af68$var$distinct;

});
parcelRegister("7VsUA", function(module, exports) {
"use strict";
var $5c544885d69a72b8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");

var $lb5GF = parcelRequire("lb5GF");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $5c544885d69a72b8$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $5c544885d69a72b8$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $5c544885d69a72b8$var$distinct;
var $5c544885d69a72b8$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5c544885d69a72b8$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5c544885d69a72b8$var$DistinctSubscriber = function(_super) {
    $5c544885d69a72b8$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $lb5GF.Set();
        if (flushes) this.add($jziWR.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.DistinctSubscriber = $5c544885d69a72b8$var$DistinctSubscriber;

});
parcelRegister("lb5GF", function(module, exports) {
$parcel$export(module.exports, "Set", () => $f6af096dabc64ee2$export$bdf4ff5a442cbbc5, (v) => $f6af096dabc64ee2$export$bdf4ff5a442cbbc5 = v);
var $f6af096dabc64ee2$export$ac57f2e66ff143c0;
var $f6af096dabc64ee2$export$bdf4ff5a442cbbc5;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
function $f6af096dabc64ee2$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$f6af096dabc64ee2$export$ac57f2e66ff143c0 = $f6af096dabc64ee2$var$minimalSetImpl;
$f6af096dabc64ee2$export$bdf4ff5a442cbbc5 = $a5Mzo.root.Set || $f6af096dabc64ee2$var$minimalSetImpl();

});




parcelRegister("9Esoe", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $f4ah3 = parcelRequire("f4ah3");
$8jOUp.Observable.prototype.distinctUntilChanged = $f4ah3.distinctUntilChanged;

});
parcelRegister("f4ah3", function(module, exports) {
$parcel$export(module.exports, "distinctUntilChanged", () => $af7f32fa2583f74b$export$779c5fb865a0172e, (v) => $af7f32fa2583f74b$export$779c5fb865a0172e = v);
var $af7f32fa2583f74b$export$779c5fb865a0172e;
"use strict";

var $cgjPk = parcelRequire("cgjPk");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $af7f32fa2583f74b$var$distinctUntilChanged(compare, keySelector) {
    return $cgjPk.distinctUntilChanged(compare, keySelector)(this);
}
$af7f32fa2583f74b$export$779c5fb865a0172e = $af7f32fa2583f74b$var$distinctUntilChanged;

});
parcelRegister("cgjPk", function(module, exports) {
"use strict";
var $8ed65bdf78b01a78$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $8ed65bdf78b01a78$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $8ed65bdf78b01a78$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $8ed65bdf78b01a78$var$distinctUntilChanged;
var $8ed65bdf78b01a78$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8ed65bdf78b01a78$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8ed65bdf78b01a78$var$DistinctUntilChangedSubscriber = function(_super) {
    $8ed65bdf78b01a78$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $cxrX4.tryCatch(this.keySelector)(value);
            if (key === $2afHm.errorObject) return this.destination.error($2afHm.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $cxrX4.tryCatch(this.compare)(this.key, key);
            if (result === $2afHm.errorObject) return this.destination.error($2afHm.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("eG3Rt", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $ivN8K = parcelRequire("ivN8K");
$8jOUp.Observable.prototype.distinctUntilKeyChanged = $ivN8K.distinctUntilKeyChanged;

});
parcelRegister("ivN8K", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $d7a13d6d05e1d708$export$571da16e28367bde, (v) => $d7a13d6d05e1d708$export$571da16e28367bde = v);
var $d7a13d6d05e1d708$export$571da16e28367bde;
"use strict";

var $9M05L = parcelRequire("9M05L");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $d7a13d6d05e1d708$var$distinctUntilKeyChanged(key, compare) {
    return $9M05L.distinctUntilKeyChanged(key, compare)(this);
}
$d7a13d6d05e1d708$export$571da16e28367bde = $d7a13d6d05e1d708$var$distinctUntilKeyChanged;

});
parcelRegister("9M05L", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $01d613464f8a3616$export$571da16e28367bde, (v) => $01d613464f8a3616$export$571da16e28367bde = v);
var $01d613464f8a3616$export$571da16e28367bde;
"use strict";

var $cgjPk = parcelRequire("cgjPk");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $01d613464f8a3616$var$distinctUntilKeyChanged(key, compare) {
    return $cgjPk.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$01d613464f8a3616$export$571da16e28367bde = $01d613464f8a3616$var$distinctUntilKeyChanged;

});



parcelRegister("hrDOT", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $64WuG = parcelRequire("64WuG");
$8jOUp.Observable.prototype.do = $64WuG._do;
$8jOUp.Observable.prototype._do = $64WuG._do;

});
parcelRegister("64WuG", function(module, exports) {
$parcel$export(module.exports, "_do", () => $46d07d7e0d9f8ac8$export$6e1c2ce23f3c9991, (v) => $46d07d7e0d9f8ac8$export$6e1c2ce23f3c9991 = v);
var $46d07d7e0d9f8ac8$export$6e1c2ce23f3c9991;
"use strict";

var $9y2UG = parcelRequire("9y2UG");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $46d07d7e0d9f8ac8$var$_do(nextOrObserver, error, complete) {
    return $9y2UG.tap(nextOrObserver, error, complete)(this);
}
$46d07d7e0d9f8ac8$export$6e1c2ce23f3c9991 = $46d07d7e0d9f8ac8$var$_do;

});


parcelRegister("gEe0l", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9e1us = parcelRequire("9e1us");
$8jOUp.Observable.prototype.exhaust = $9e1us.exhaust;

});
parcelRegister("9e1us", function(module, exports) {
$parcel$export(module.exports, "exhaust", () => $6b7693caac6c2203$export$31039f1fbd797b9c, (v) => $6b7693caac6c2203$export$31039f1fbd797b9c = v);
var $6b7693caac6c2203$export$31039f1fbd797b9c;
"use strict";

var $aAoKV = parcelRequire("aAoKV");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $6b7693caac6c2203$var$exhaust() {
    return $aAoKV.exhaust()(this);
}
$6b7693caac6c2203$export$31039f1fbd797b9c = $6b7693caac6c2203$var$exhaust;

});
parcelRegister("aAoKV", function(module, exports) {
"use strict";
var $7b50782fde0d3230$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $7b50782fde0d3230$var$exhaust() {
    return function(source) {
        return source.lift(new $7b50782fde0d3230$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $7b50782fde0d3230$var$exhaust;
var $7b50782fde0d3230$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7b50782fde0d3230$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7b50782fde0d3230$var$SwitchFirstSubscriber = function(_super) {
    $7b50782fde0d3230$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($jziWR.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("80Ua7", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $10qJ5 = parcelRequire("10qJ5");
$8jOUp.Observable.prototype.exhaustMap = $10qJ5.exhaustMap;

});
parcelRegister("10qJ5", function(module, exports) {
$parcel$export(module.exports, "exhaustMap", () => $0bba85d2f13c121b$export$d70d492cd31004c0, (v) => $0bba85d2f13c121b$export$d70d492cd31004c0 = v);
var $0bba85d2f13c121b$export$d70d492cd31004c0;
"use strict";

var $7D9cz = parcelRequire("7D9cz");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $0bba85d2f13c121b$var$exhaustMap(project, resultSelector) {
    return $7D9cz.exhaustMap(project, resultSelector)(this);
}
$0bba85d2f13c121b$export$d70d492cd31004c0 = $0bba85d2f13c121b$var$exhaustMap;

});
parcelRegister("7D9cz", function(module, exports) {
"use strict";
var $58e35036ac2b0be2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $58e35036ac2b0be2$var$exhaustMap(project, resultSelector) {
    return function(source) {
        return source.lift(new $58e35036ac2b0be2$var$SwitchFirstMapOperator(project, resultSelector));
    };
}
module.exports.exhaustMap = $58e35036ac2b0be2$var$exhaustMap;
var $58e35036ac2b0be2$var$SwitchFirstMapOperator = function() {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $58e35036ac2b0be2$var$SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $58e35036ac2b0be2$var$SwitchFirstMapSubscriber = function(_super) {
    $58e35036ac2b0be2$var$__extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function(value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add($jziWR.subscribeToResult(this, result, value, index));
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstMapSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("5UjSW", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4YSqs = parcelRequire("4YSqs");
$8jOUp.Observable.prototype.expand = $4YSqs.expand;

});
parcelRegister("4YSqs", function(module, exports) {
$parcel$export(module.exports, "expand", () => $3a06fbda8bf99adc$export$9f77e0932fb78f72, (v) => $3a06fbda8bf99adc$export$9f77e0932fb78f72 = v);
var $3a06fbda8bf99adc$export$9f77e0932fb78f72;
"use strict";

var $aK3w2 = parcelRequire("aK3w2");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $3a06fbda8bf99adc$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return $aK3w2.expand(project, concurrent, scheduler)(this);
}
$3a06fbda8bf99adc$export$9f77e0932fb78f72 = $3a06fbda8bf99adc$var$expand;

});
parcelRegister("aK3w2", function(module, exports) {
"use strict";
var $7d20ed6cea72c931$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $7d20ed6cea72c931$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $7d20ed6cea72c931$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $7d20ed6cea72c931$var$expand;
var $7d20ed6cea72c931$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7d20ed6cea72c931$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $7d20ed6cea72c931$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7d20ed6cea72c931$var$ExpandSubscriber = function(_super) {
    $7d20ed6cea72c931$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $cxrX4.tryCatch(this.project)(value, index);
            if (result === $2afHm.errorObject) destination.error($2afHm.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($jziWR.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.ExpandSubscriber = $7d20ed6cea72c931$var$ExpandSubscriber;

});



parcelRegister("7DkpP", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6WlDT = parcelRequire("6WlDT");
$8jOUp.Observable.prototype.elementAt = $6WlDT.elementAt;

});
parcelRegister("6WlDT", function(module, exports) {
$parcel$export(module.exports, "elementAt", () => $50d8f29b281e83bc$export$91d69c7761a17bbc, (v) => $50d8f29b281e83bc$export$91d69c7761a17bbc = v);
var $50d8f29b281e83bc$export$91d69c7761a17bbc;
"use strict";

var $kfIc1 = parcelRequire("kfIc1");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $50d8f29b281e83bc$var$elementAt(index, defaultValue) {
    return $kfIc1.elementAt(index, defaultValue)(this);
}
$50d8f29b281e83bc$export$91d69c7761a17bbc = $50d8f29b281e83bc$var$elementAt;

});
parcelRegister("kfIc1", function(module, exports) {
"use strict";
var $ebe77d2c8cba3393$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $4IOSZ = parcelRequire("4IOSZ");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $ebe77d2c8cba3393$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $ebe77d2c8cba3393$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $ebe77d2c8cba3393$var$elementAt;
var $ebe77d2c8cba3393$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $4IOSZ.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ebe77d2c8cba3393$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ebe77d2c8cba3393$var$ElementAtSubscriber = function(_super) {
    $ebe77d2c8cba3393$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $4IOSZ.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($66gCN.Subscriber);

});
parcelRegister("4IOSZ", function(module, exports) {
"use strict";
var $3702be5b2dd2fd37$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $3702be5b2dd2fd37$var$ArgumentOutOfRangeError = function(_super) {
    $3702be5b2dd2fd37$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $3702be5b2dd2fd37$var$ArgumentOutOfRangeError;

});




parcelRegister("725aW", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $7YjW8 = parcelRequire("7YjW8");
$8jOUp.Observable.prototype.filter = $7YjW8.filter;

});

parcelRegister("1dIg6", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4YzZW = parcelRequire("4YzZW");
$8jOUp.Observable.prototype.finally = $4YzZW._finally;
$8jOUp.Observable.prototype._finally = $4YzZW._finally;

});
parcelRegister("4YzZW", function(module, exports) {
$parcel$export(module.exports, "_finally", () => $39f8b075f41669c7$export$f6224470e4cea3fa, (v) => $39f8b075f41669c7$export$f6224470e4cea3fa = v);
var $39f8b075f41669c7$export$f6224470e4cea3fa;
"use strict";

var $45H2I = parcelRequire("45H2I");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $39f8b075f41669c7$var$_finally(callback) {
    return $45H2I.finalize(callback)(this);
}
$39f8b075f41669c7$export$f6224470e4cea3fa = $39f8b075f41669c7$var$_finally;

});
parcelRegister("45H2I", function(module, exports) {
"use strict";
var $2fa9047b5cdd2637$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $aAAtt = parcelRequire("aAAtt");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $2fa9047b5cdd2637$var$finalize(callback) {
    return function(source) {
        return source.lift(new $2fa9047b5cdd2637$var$FinallyOperator(callback));
    };
}
module.exports.finalize = $2fa9047b5cdd2637$var$finalize;
var $2fa9047b5cdd2637$var$FinallyOperator = function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2fa9047b5cdd2637$var$FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2fa9047b5cdd2637$var$FinallySubscriber = function(_super) {
    $2fa9047b5cdd2637$var$__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new $aAAtt.Subscription(callback));
    }
    return FinallySubscriber;
}($66gCN.Subscriber);

});



parcelRegister("9csP0", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $037wj = parcelRequire("037wj");
$8jOUp.Observable.prototype.find = $037wj.find;

});
parcelRegister("037wj", function(module, exports) {
$parcel$export(module.exports, "find", () => $00961d44b1112616$export$71aa6c912b956294, (v) => $00961d44b1112616$export$71aa6c912b956294 = v);
var $00961d44b1112616$export$71aa6c912b956294;
"use strict";

var $eNyfg = parcelRequire("eNyfg");
/* tslint:enable:max-line-length */ /**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $00961d44b1112616$var$find(predicate, thisArg) {
    return $eNyfg.find(predicate, thisArg)(this);
}
$00961d44b1112616$export$71aa6c912b956294 = $00961d44b1112616$var$find;

});
parcelRegister("eNyfg", function(module, exports) {
"use strict";
var $ac6034af7a1449e4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $ac6034af7a1449e4$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $ac6034af7a1449e4$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $ac6034af7a1449e4$var$find;
var $ac6034af7a1449e4$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ac6034af7a1449e4$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $ac6034af7a1449e4$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ac6034af7a1449e4$var$FindValueSubscriber = function(_super) {
    $ac6034af7a1449e4$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($66gCN.Subscriber);
module.exports.FindValueSubscriber = $ac6034af7a1449e4$var$FindValueSubscriber;

});



parcelRegister("f3nHB", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $eClGK = parcelRequire("eClGK");
$8jOUp.Observable.prototype.findIndex = $eClGK.findIndex;

});
parcelRegister("eClGK", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $aa4570304d5df4ac$export$de3a4d4a0d731119, (v) => $aa4570304d5df4ac$export$de3a4d4a0d731119 = v);
var $aa4570304d5df4ac$export$de3a4d4a0d731119;
"use strict";

var $4fuVe = parcelRequire("4fuVe");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $aa4570304d5df4ac$var$findIndex(predicate, thisArg) {
    return $4fuVe.findIndex(predicate, thisArg)(this);
}
$aa4570304d5df4ac$export$de3a4d4a0d731119 = $aa4570304d5df4ac$var$findIndex;

});
parcelRegister("4fuVe", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $31808c9b3d1a24d7$export$de3a4d4a0d731119, (v) => $31808c9b3d1a24d7$export$de3a4d4a0d731119 = v);
var $31808c9b3d1a24d7$export$de3a4d4a0d731119;
"use strict";

var $eNyfg = parcelRequire("eNyfg");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $31808c9b3d1a24d7$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $eNyfg.FindValueOperator(predicate, source, true, thisArg));
    };
}
$31808c9b3d1a24d7$export$de3a4d4a0d731119 = $31808c9b3d1a24d7$var$findIndex;

});



parcelRegister("l114D", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $apxpi = parcelRequire("apxpi");
$8jOUp.Observable.prototype.first = $apxpi.first;

});
parcelRegister("apxpi", function(module, exports) {
$parcel$export(module.exports, "first", () => $79462721a28141e3$export$43128fadae87b74a, (v) => $79462721a28141e3$export$43128fadae87b74a = v);
var $79462721a28141e3$export$43128fadae87b74a;
"use strict";

var $3agVN = parcelRequire("3agVN");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $79462721a28141e3$var$first(predicate, resultSelector, defaultValue) {
    return $3agVN.first(predicate, resultSelector, defaultValue)(this);
}
$79462721a28141e3$export$43128fadae87b74a = $79462721a28141e3$var$first;

});
parcelRegister("3agVN", function(module, exports) {
"use strict";
var $24df7071c2c93329$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $hLArM = parcelRequire("hLArM");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $24df7071c2c93329$var$first(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $24df7071c2c93329$var$FirstOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.first = $24df7071c2c93329$var$first;
var $24df7071c2c93329$var$FirstOperator = function() {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $24df7071c2c93329$var$FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $24df7071c2c93329$var$FirstSubscriber = function(_super) {
    $24df7071c2c93329$var$__extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else this._emit(value, index);
    };
    FirstSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this._emit(value, index);
    };
    FirstSubscriber.prototype._emit = function(value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function(value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        } else if (!this.hasCompleted) destination.error(new $hLArM.EmptyError);
    };
    return FirstSubscriber;
}($66gCN.Subscriber);

});
parcelRegister("hLArM", function(module, exports) {
"use strict";
var $cef31912c7c1e686$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */ var $cef31912c7c1e686$var$EmptyError = function(_super) {
    $cef31912c7c1e686$var$__extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error);
module.exports.EmptyError = $cef31912c7c1e686$var$EmptyError;

});




parcelRegister("hDFF8", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $1taLb = parcelRequire("1taLb");
$8jOUp.Observable.prototype.groupBy = $1taLb.groupBy;

});
parcelRegister("1taLb", function(module, exports) {
$parcel$export(module.exports, "groupBy", () => $1120d8925c9c5791$export$3f063810d7bf01bd, (v) => $1120d8925c9c5791$export$3f063810d7bf01bd = v);
var $1120d8925c9c5791$export$ff26824b3dc37d8c;
var $1120d8925c9c5791$export$3f063810d7bf01bd;
"use strict";

var $4zLKD = parcelRequire("4zLKD");
$1120d8925c9c5791$export$ff26824b3dc37d8c = $4zLKD.GroupedObservable;
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $1120d8925c9c5791$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return $4zLKD.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
$1120d8925c9c5791$export$3f063810d7bf01bd = $1120d8925c9c5791$var$groupBy;

});
parcelRegister("4zLKD", function(module, exports) {
"use strict";
var $354f78b234e8a916$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $aAAtt = parcelRequire("aAAtt");

var $8jOUp = parcelRequire("8jOUp");

var $gJqoA = parcelRequire("gJqoA");

var $iq1i9 = parcelRequire("iq1i9");

var $3Osxx = parcelRequire("3Osxx");
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $354f78b234e8a916$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new $354f78b234e8a916$var$GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
module.exports.groupBy = $354f78b234e8a916$var$groupBy;
var $354f78b234e8a916$var$GroupByOperator = function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $354f78b234e8a916$var$GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $354f78b234e8a916$var$GroupBySubscriber = function(_super) {
    $354f78b234e8a916$var$__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = typeof key === 'string' ? new $3Osxx.FastMap() : new $iq1i9.Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new $gJqoA.Subject();
            groups.set(key, group);
            var groupedObservable = new $354f78b234e8a916$var$GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new $354f78b234e8a916$var$GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new $354f78b234e8a916$var$GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}($66gCN.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $354f78b234e8a916$var$GroupDurationSubscriber = function(_super) {
    $354f78b234e8a916$var$__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}($66gCN.Subscriber);
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */ var $354f78b234e8a916$var$GroupedObservable = function(_super) {
    $354f78b234e8a916$var$__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new $aAAtt.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new $354f78b234e8a916$var$InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}($8jOUp.Observable);
module.exports.GroupedObservable = $354f78b234e8a916$var$GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $354f78b234e8a916$var$InnerRefCountSubscription = function(_super) {
    $354f78b234e8a916$var$__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}($aAAtt.Subscription);

});
parcelRegister("iq1i9", function(module, exports) {
$parcel$export(module.exports, "Map", () => $d68ba839691f918d$export$a5c7b93649eaf8f8, (v) => $d68ba839691f918d$export$a5c7b93649eaf8f8 = v);
var $d68ba839691f918d$export$a5c7b93649eaf8f8;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");

var $eAQHj = parcelRequire("eAQHj");
$d68ba839691f918d$export$a5c7b93649eaf8f8 = $a5Mzo.root.Map || function() {
    return $eAQHj.MapPolyfill;
}();

});
parcelRegister("eAQHj", function(module, exports) {
$parcel$export(module.exports, "MapPolyfill", () => $a9fd4e1f2dd80fdb$export$dd450425f6b4a07, (v) => $a9fd4e1f2dd80fdb$export$dd450425f6b4a07 = v);
var $a9fd4e1f2dd80fdb$export$dd450425f6b4a07;
"use strict";
var $a9fd4e1f2dd80fdb$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function(key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function(key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        } else this._values[i] = value;
        return this;
    };
    MapPolyfill.prototype.delete = function(key) {
        var i = this._keys.indexOf(key);
        if (i === -1) return false;
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function() {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function(cb, thisArg) {
        for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
    };
    return MapPolyfill;
}();
$a9fd4e1f2dd80fdb$export$dd450425f6b4a07 = $a9fd4e1f2dd80fdb$var$MapPolyfill;

});


parcelRegister("3Osxx", function(module, exports) {
$parcel$export(module.exports, "FastMap", () => $2c6c2e0b849deeed$export$d3f0a24774bb4055, (v) => $2c6c2e0b849deeed$export$d3f0a24774bb4055 = v);
var $2c6c2e0b849deeed$export$d3f0a24774bb4055;
"use strict";
var $2c6c2e0b849deeed$var$FastMap = function() {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function(key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function(key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function(key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function(cb, thisArg) {
        var values = this.values;
        for(var key in values)if (values.hasOwnProperty(key) && values[key] !== null) cb.call(thisArg, values[key], key);
    };
    FastMap.prototype.clear = function() {
        this.values = {};
    };
    return FastMap;
}();
$2c6c2e0b849deeed$export$d3f0a24774bb4055 = $2c6c2e0b849deeed$var$FastMap;

});




parcelRegister("2EjtJ", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $5QbBm = parcelRequire("5QbBm");
$8jOUp.Observable.prototype.ignoreElements = $5QbBm.ignoreElements;

});
parcelRegister("5QbBm", function(module, exports) {
$parcel$export(module.exports, "ignoreElements", () => $440acee4ae6f06aa$export$6953b97c7d866605, (v) => $440acee4ae6f06aa$export$6953b97c7d866605 = v);
var $440acee4ae6f06aa$export$6953b97c7d866605;
"use strict";

var $5NA3Y = parcelRequire("5NA3Y");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $440acee4ae6f06aa$var$ignoreElements() {
    return $5NA3Y.ignoreElements()(this);
}
$440acee4ae6f06aa$export$6953b97c7d866605 = $440acee4ae6f06aa$var$ignoreElements;

});
parcelRegister("5NA3Y", function(module, exports) {
"use strict";
var $438d80b4f3bd2748$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $chmr4 = parcelRequire("chmr4");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $438d80b4f3bd2748$var$ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new $438d80b4f3bd2748$var$IgnoreElementsOperator());
    };
}
module.exports.ignoreElements = $438d80b4f3bd2748$var$ignoreElements;
var $438d80b4f3bd2748$var$IgnoreElementsOperator = function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $438d80b4f3bd2748$var$IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $438d80b4f3bd2748$var$IgnoreElementsSubscriber = function(_super) {
    $438d80b4f3bd2748$var$__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {
        $chmr4.noop();
    };
    return IgnoreElementsSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("kjg5i", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $gi05A = parcelRequire("gi05A");
$8jOUp.Observable.prototype.isEmpty = $gi05A.isEmpty;

});
parcelRegister("gi05A", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $bdbe65776d6b6015$export$dd1bc94b04021eeb, (v) => $bdbe65776d6b6015$export$dd1bc94b04021eeb = v);
var $bdbe65776d6b6015$export$dd1bc94b04021eeb;
"use strict";

var $kKzvg = parcelRequire("kKzvg");
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */ function $bdbe65776d6b6015$var$isEmpty() {
    return $kKzvg.isEmpty()(this);
}
$bdbe65776d6b6015$export$dd1bc94b04021eeb = $bdbe65776d6b6015$var$isEmpty;

});
parcelRegister("kKzvg", function(module, exports) {
"use strict";
var $f1b3a4b6323364f7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
function $f1b3a4b6323364f7$var$isEmpty() {
    return function(source) {
        return source.lift(new $f1b3a4b6323364f7$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $f1b3a4b6323364f7$var$isEmpty;
var $f1b3a4b6323364f7$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $f1b3a4b6323364f7$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f1b3a4b6323364f7$var$IsEmptySubscriber = function(_super) {
    $f1b3a4b6323364f7$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($66gCN.Subscriber);

});



parcelRegister("2J7QU", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $bg36f = parcelRequire("bg36f");
$8jOUp.Observable.prototype.audit = $bg36f.audit;

});
parcelRegister("bg36f", function(module, exports) {
$parcel$export(module.exports, "audit", () => $832397e2d8ba8c51$export$d779b02e6b68c3e8, (v) => $832397e2d8ba8c51$export$d779b02e6b68c3e8 = v);
var $832397e2d8ba8c51$export$d779b02e6b68c3e8;
"use strict";

var $l9FiH = parcelRequire("l9FiH");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $832397e2d8ba8c51$var$audit(durationSelector) {
    return $l9FiH.audit(durationSelector)(this);
}
$832397e2d8ba8c51$export$d779b02e6b68c3e8 = $832397e2d8ba8c51$var$audit;

});
parcelRegister("l9FiH", function(module, exports) {
"use strict";
var $f66a79a7bdf4ac28$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $f66a79a7bdf4ac28$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $f66a79a7bdf4ac28$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $f66a79a7bdf4ac28$var$audit;
var $f66a79a7bdf4ac28$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f66a79a7bdf4ac28$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f66a79a7bdf4ac28$var$AuditSubscriber = function(_super) {
    $f66a79a7bdf4ac28$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $cxrX4.tryCatch(this.durationSelector)(value);
            if (duration === $2afHm.errorObject) this.destination.error($2afHm.errorObject.e);
            else {
                var innerSubscription = $jziWR.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("j1K3d", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $bgk7W = parcelRequire("bgk7W");
$8jOUp.Observable.prototype.auditTime = $bgk7W.auditTime;

});
parcelRegister("bgk7W", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $8330cd2c48547330$export$719c70722b10e5ff, (v) => $8330cd2c48547330$export$719c70722b10e5ff = v);
var $8330cd2c48547330$export$719c70722b10e5ff;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $01CpP = parcelRequire("01CpP");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $8330cd2c48547330$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $01CpP.auditTime(duration, scheduler)(this);
}
$8330cd2c48547330$export$719c70722b10e5ff = $8330cd2c48547330$var$auditTime;

});
parcelRegister("01CpP", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $004de49fd5db98e5$export$719c70722b10e5ff, (v) => $004de49fd5db98e5$export$719c70722b10e5ff = v);
var $004de49fd5db98e5$export$719c70722b10e5ff;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $l9FiH = parcelRequire("l9FiH");

var $hDHgc = parcelRequire("hDHgc");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $004de49fd5db98e5$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $l9FiH.audit(function() {
        return $hDHgc.timer(duration, scheduler);
    });
}
$004de49fd5db98e5$export$719c70722b10e5ff = $004de49fd5db98e5$var$auditTime;

});



parcelRegister("axDN0", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $83E2t = parcelRequire("83E2t");
$8jOUp.Observable.prototype.last = $83E2t.last;

});
parcelRegister("83E2t", function(module, exports) {
$parcel$export(module.exports, "last", () => $5ddda968ebab0ff0$export$4c7897fafd92b108, (v) => $5ddda968ebab0ff0$export$4c7897fafd92b108 = v);
var $5ddda968ebab0ff0$export$4c7897fafd92b108;
"use strict";

var $vNigh = parcelRequire("vNigh");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $5ddda968ebab0ff0$var$last(predicate, resultSelector, defaultValue) {
    return $vNigh.last(predicate, resultSelector, defaultValue)(this);
}
$5ddda968ebab0ff0$export$4c7897fafd92b108 = $5ddda968ebab0ff0$var$last;

});
parcelRegister("vNigh", function(module, exports) {
"use strict";
var $05f92209170c1feb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $hLArM = parcelRequire("hLArM");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $05f92209170c1feb$var$last(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $05f92209170c1feb$var$LastOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.last = $05f92209170c1feb$var$last;
var $05f92209170c1feb$var$LastOperator = function() {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $05f92209170c1feb$var$LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $05f92209170c1feb$var$LastSubscriber = function(_super) {
    $05f92209170c1feb$var$__extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        } else destination.error(new $hLArM.EmptyError);
    };
    return LastSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("j0hca", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $lXvHy = parcelRequire("lXvHy");
$8jOUp.Observable.prototype.let = $lXvHy.letProto;
$8jOUp.Observable.prototype.letBind = $lXvHy.letProto;

});
parcelRegister("lXvHy", function(module, exports) {
$parcel$export(module.exports, "letProto", () => $ffc7b2e7c053c424$export$50696b801ff96e66, (v) => $ffc7b2e7c053c424$export$50696b801ff96e66 = v);
var $ffc7b2e7c053c424$export$50696b801ff96e66;
"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */ function $ffc7b2e7c053c424$var$letProto(func) {
    return func(this);
}
$ffc7b2e7c053c424$export$50696b801ff96e66 = $ffc7b2e7c053c424$var$letProto;

});


parcelRegister("bPh8v", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $eyzji = parcelRequire("eyzji");
$8jOUp.Observable.prototype.every = $eyzji.every;

});
parcelRegister("eyzji", function(module, exports) {
$parcel$export(module.exports, "every", () => $a98fa18da3914d0f$export$7ecc1a3b11b57dab, (v) => $a98fa18da3914d0f$export$7ecc1a3b11b57dab = v);
var $a98fa18da3914d0f$export$7ecc1a3b11b57dab;
"use strict";

var $diRdy = parcelRequire("diRdy");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $a98fa18da3914d0f$var$every(predicate, thisArg) {
    return $diRdy.every(predicate, thisArg)(this);
}
$a98fa18da3914d0f$export$7ecc1a3b11b57dab = $a98fa18da3914d0f$var$every;

});
parcelRegister("diRdy", function(module, exports) {
"use strict";
var $9af63cb60ad29518$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $9af63cb60ad29518$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $9af63cb60ad29518$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $9af63cb60ad29518$var$every;
var $9af63cb60ad29518$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $9af63cb60ad29518$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9af63cb60ad29518$var$EverySubscriber = function(_super) {
    $9af63cb60ad29518$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($66gCN.Subscriber);

});



parcelRegister("fITcD", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $7gHg9 = parcelRequire("7gHg9");
$8jOUp.Observable.prototype.map = $7gHg9.map;

});

parcelRegister("dfzyl", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6uXbi = parcelRequire("6uXbi");
$8jOUp.Observable.prototype.mapTo = $6uXbi.mapTo;

});
parcelRegister("6uXbi", function(module, exports) {
$parcel$export(module.exports, "mapTo", () => $4bb37391152e2be7$export$e0eaf3a86c03b2ad, (v) => $4bb37391152e2be7$export$e0eaf3a86c03b2ad = v);
var $4bb37391152e2be7$export$e0eaf3a86c03b2ad;
"use strict";

var $31RSE = parcelRequire("31RSE");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $4bb37391152e2be7$var$mapTo(value) {
    return $31RSE.mapTo(value)(this);
}
$4bb37391152e2be7$export$e0eaf3a86c03b2ad = $4bb37391152e2be7$var$mapTo;

});
parcelRegister("31RSE", function(module, exports) {
"use strict";
var $234b42a6c3f4d4e9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $234b42a6c3f4d4e9$var$mapTo(value) {
    return function(source) {
        return source.lift(new $234b42a6c3f4d4e9$var$MapToOperator(value));
    };
}
module.exports.mapTo = $234b42a6c3f4d4e9$var$mapTo;
var $234b42a6c3f4d4e9$var$MapToOperator = function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $234b42a6c3f4d4e9$var$MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $234b42a6c3f4d4e9$var$MapToSubscriber = function(_super) {
    $234b42a6c3f4d4e9$var$__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("enquq", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $lO7HQ = parcelRequire("lO7HQ");
$8jOUp.Observable.prototype.materialize = $lO7HQ.materialize;

});
parcelRegister("lO7HQ", function(module, exports) {
$parcel$export(module.exports, "materialize", () => $fe043ec2d8e16b53$export$76dbd6ffd832405d, (v) => $fe043ec2d8e16b53$export$76dbd6ffd832405d = v);
var $fe043ec2d8e16b53$export$76dbd6ffd832405d;
"use strict";

var $9vc76 = parcelRequire("9vc76");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $fe043ec2d8e16b53$var$materialize() {
    return $9vc76.materialize()(this);
}
$fe043ec2d8e16b53$export$76dbd6ffd832405d = $fe043ec2d8e16b53$var$materialize;

});
parcelRegister("9vc76", function(module, exports) {
"use strict";
var $6eb067cf84ffecb5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $fTcsX = parcelRequire("fTcsX");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $6eb067cf84ffecb5$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $6eb067cf84ffecb5$var$MaterializeOperator());
    };
}
module.exports.materialize = $6eb067cf84ffecb5$var$materialize;
var $6eb067cf84ffecb5$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6eb067cf84ffecb5$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6eb067cf84ffecb5$var$MaterializeSubscriber = function(_super) {
    $6eb067cf84ffecb5$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($fTcsX.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($fTcsX.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($fTcsX.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("9de7r", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $2hhR5 = parcelRequire("2hhR5");
$8jOUp.Observable.prototype.max = $2hhR5.max;

});
parcelRegister("2hhR5", function(module, exports) {
$parcel$export(module.exports, "max", () => $1a8b04f52c255bae$export$8960430cfd85939f, (v) => $1a8b04f52c255bae$export$8960430cfd85939f = v);
var $1a8b04f52c255bae$export$8960430cfd85939f;
"use strict";

var $gMQNi = parcelRequire("gMQNi");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $1a8b04f52c255bae$var$max(comparer) {
    return $gMQNi.max(comparer)(this);
}
$1a8b04f52c255bae$export$8960430cfd85939f = $1a8b04f52c255bae$var$max;

});
parcelRegister("gMQNi", function(module, exports) {
$parcel$export(module.exports, "max", () => $c38a14dcc279d44c$export$8960430cfd85939f, (v) => $c38a14dcc279d44c$export$8960430cfd85939f = v);
var $c38a14dcc279d44c$export$8960430cfd85939f;
"use strict";

var $de1nH = parcelRequire("de1nH");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $c38a14dcc279d44c$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $de1nH.reduce(max);
}
$c38a14dcc279d44c$export$8960430cfd85939f = $c38a14dcc279d44c$var$max;

});
parcelRegister("de1nH", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $9a0da77697797f83$export$533b26079ad0b4b, (v) => $9a0da77697797f83$export$533b26079ad0b4b = v);
var $9a0da77697797f83$export$533b26079ad0b4b;
"use strict";

var $cKrD4 = parcelRequire("cKrD4");

var $kzAXk = parcelRequire("kzAXk");

var $7DEqP = parcelRequire("7DEqP");

var $2b9KJ = parcelRequire("2b9KJ");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $9a0da77697797f83$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $2b9KJ.pipe($cKrD4.scan(accumulator, seed), $kzAXk.takeLast(1), $7DEqP.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $2b9KJ.pipe($cKrD4.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $kzAXk.takeLast(1))(source);
    };
}
$9a0da77697797f83$export$533b26079ad0b4b = $9a0da77697797f83$var$reduce;

});
parcelRegister("cKrD4", function(module, exports) {
"use strict";
var $947f36798afcf6d6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $947f36798afcf6d6$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $947f36798afcf6d6$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $947f36798afcf6d6$var$scan;
var $947f36798afcf6d6$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $947f36798afcf6d6$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $947f36798afcf6d6$var$ScanSubscriber = function(_super) {
    $947f36798afcf6d6$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($66gCN.Subscriber);

});

parcelRegister("kzAXk", function(module, exports) {
"use strict";
var $efa3be2f862401a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $4IOSZ = parcelRequire("4IOSZ");

var $cUooy = parcelRequire("cUooy");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $efa3be2f862401a1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $cUooy.EmptyObservable();
        else return source.lift(new $efa3be2f862401a1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $efa3be2f862401a1$var$takeLast;
var $efa3be2f862401a1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $4IOSZ.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $efa3be2f862401a1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $efa3be2f862401a1$var$TakeLastSubscriber = function(_super) {
    $efa3be2f862401a1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($66gCN.Subscriber);

});





parcelRegister("dlrG8", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $dZsIa = parcelRequire("dZsIa");
$8jOUp.Observable.prototype.merge = $dZsIa.merge;

});
parcelRegister("dZsIa", function(module, exports) {
$parcel$export(module.exports, "merge", () => $a2f73e5bf0a5f92a$export$4950aa0f605343fb, (v) => $a2f73e5bf0a5f92a$export$4950aa0f605343fb = v);
var $a2f73e5bf0a5f92a$export$9f199afc30ae2269;
var $a2f73e5bf0a5f92a$export$4950aa0f605343fb;
"use strict";

var $3cAvp = parcelRequire("3cAvp");

var $6kyyx = parcelRequire("6kyyx");
$a2f73e5bf0a5f92a$export$9f199afc30ae2269 = $6kyyx.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $a2f73e5bf0a5f92a$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $3cAvp.merge.apply(void 0, observables)(this);
}
$a2f73e5bf0a5f92a$export$4950aa0f605343fb = $a2f73e5bf0a5f92a$var$merge;

});
parcelRegister("3cAvp", function(module, exports) {
$parcel$export(module.exports, "merge", () => $254ecf58207eb7ce$export$4950aa0f605343fb, (v) => $254ecf58207eb7ce$export$4950aa0f605343fb = v);
var $254ecf58207eb7ce$export$9f199afc30ae2269;
var $254ecf58207eb7ce$export$4950aa0f605343fb;
"use strict";

var $6kyyx = parcelRequire("6kyyx");

var $6kyyx = parcelRequire("6kyyx");
$254ecf58207eb7ce$export$9f199afc30ae2269 = $6kyyx.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $254ecf58207eb7ce$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($6kyyx.merge.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$254ecf58207eb7ce$export$4950aa0f605343fb = $254ecf58207eb7ce$var$merge;

});



parcelRegister("8vQHO", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $3mzr3 = parcelRequire("3mzr3");
$8jOUp.Observable.prototype.mergeAll = $3mzr3.mergeAll;

});
parcelRegister("3mzr3", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $272ee9e5521af6a8$export$18aef43295bbe906, (v) => $272ee9e5521af6a8$export$18aef43295bbe906 = v);
var $272ee9e5521af6a8$export$18aef43295bbe906;
"use strict";

var $aapek = parcelRequire("aapek");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $272ee9e5521af6a8$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $aapek.mergeAll(concurrent)(this);
}
$272ee9e5521af6a8$export$18aef43295bbe906 = $272ee9e5521af6a8$var$mergeAll;

});


parcelRegister("04cNN", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $giJWG = parcelRequire("giJWG");
$8jOUp.Observable.prototype.mergeMap = $giJWG.mergeMap;
$8jOUp.Observable.prototype.flatMap = $giJWG.mergeMap;

});
parcelRegister("giJWG", function(module, exports) {
$parcel$export(module.exports, "mergeMap", () => $bde1f7939f8692ae$export$6b9f6c0d32c093f9, (v) => $bde1f7939f8692ae$export$6b9f6c0d32c093f9 = v);
var $bde1f7939f8692ae$export$6b9f6c0d32c093f9;
"use strict";

var $jcL4C = parcelRequire("jcL4C");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $bde1f7939f8692ae$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $jcL4C.mergeMap(project, resultSelector, concurrent)(this);
}
$bde1f7939f8692ae$export$6b9f6c0d32c093f9 = $bde1f7939f8692ae$var$mergeMap;

});


parcelRegister("byrgM", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $k1uxx = parcelRequire("k1uxx");
$8jOUp.Observable.prototype.flatMapTo = $k1uxx.mergeMapTo;
$8jOUp.Observable.prototype.mergeMapTo = $k1uxx.mergeMapTo;

});
parcelRegister("k1uxx", function(module, exports) {
$parcel$export(module.exports, "mergeMapTo", () => $e93b9736c1de809c$export$bd7cfc9a42b8a412, (v) => $e93b9736c1de809c$export$bd7cfc9a42b8a412 = v);
var $e93b9736c1de809c$export$bd7cfc9a42b8a412;
"use strict";

var $lW3W5 = parcelRequire("lW3W5");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $e93b9736c1de809c$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $lW3W5.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
}
$e93b9736c1de809c$export$bd7cfc9a42b8a412 = $e93b9736c1de809c$var$mergeMapTo;

});
parcelRegister("lW3W5", function(module, exports) {
"use strict";
var $ff821152c685846b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $ff821152c685846b$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $ff821152c685846b$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $ff821152c685846b$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $ff821152c685846b$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ff821152c685846b$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $ff821152c685846b$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ff821152c685846b$var$MergeMapToSubscriber = function(_super) {
    $ff821152c685846b$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($jziWR.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.MergeMapToSubscriber = $ff821152c685846b$var$MergeMapToSubscriber;

});



parcelRegister("coufH", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4qgr8 = parcelRequire("4qgr8");
$8jOUp.Observable.prototype.mergeScan = $4qgr8.mergeScan;

});
parcelRegister("4qgr8", function(module, exports) {
$parcel$export(module.exports, "mergeScan", () => $3386571e8dfe3f8e$export$c1fc905202bced53, (v) => $3386571e8dfe3f8e$export$c1fc905202bced53 = v);
var $3386571e8dfe3f8e$export$c1fc905202bced53;
"use strict";

var $bgwIP = parcelRequire("bgwIP");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $3386571e8dfe3f8e$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $bgwIP.mergeScan(accumulator, seed, concurrent)(this);
}
$3386571e8dfe3f8e$export$c1fc905202bced53 = $3386571e8dfe3f8e$var$mergeScan;

});
parcelRegister("bgwIP", function(module, exports) {
"use strict";
var $833a924344539e45$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $jziWR = parcelRequire("jziWR");

var $2L5Gq = parcelRequire("2L5Gq");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $833a924344539e45$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $833a924344539e45$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $833a924344539e45$var$mergeScan;
var $833a924344539e45$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $833a924344539e45$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $833a924344539e45$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $833a924344539e45$var$MergeScanSubscriber = function(_super) {
    $833a924344539e45$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $cxrX4.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $2afHm.errorObject) destination.error($2afHm.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($jziWR.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($2L5Gq.OuterSubscriber);
module.exports.MergeScanSubscriber = $833a924344539e45$var$MergeScanSubscriber;

});



parcelRegister("aB4Sq", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $afyrR = parcelRequire("afyrR");
$8jOUp.Observable.prototype.min = $afyrR.min;

});
parcelRegister("afyrR", function(module, exports) {
$parcel$export(module.exports, "min", () => $776606ceed61aeb1$export$96ec731ed4dcb222, (v) => $776606ceed61aeb1$export$96ec731ed4dcb222 = v);
var $776606ceed61aeb1$export$96ec731ed4dcb222;
"use strict";

var $itQYd = parcelRequire("itQYd");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $776606ceed61aeb1$var$min(comparer) {
    return $itQYd.min(comparer)(this);
}
$776606ceed61aeb1$export$96ec731ed4dcb222 = $776606ceed61aeb1$var$min;

});
parcelRegister("itQYd", function(module, exports) {
$parcel$export(module.exports, "min", () => $d7440632a7680d98$export$96ec731ed4dcb222, (v) => $d7440632a7680d98$export$96ec731ed4dcb222 = v);
var $d7440632a7680d98$export$96ec731ed4dcb222;
"use strict";

var $de1nH = parcelRequire("de1nH");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $d7440632a7680d98$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $de1nH.reduce(min);
}
$d7440632a7680d98$export$96ec731ed4dcb222 = $d7440632a7680d98$var$min;

});



parcelRegister("aEZBF", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $glGwi = parcelRequire("glGwi");
$8jOUp.Observable.prototype.multicast = $glGwi.multicast;

});
parcelRegister("glGwi", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $be6f970ec171bf77$export$1364843af8d5a963, (v) => $be6f970ec171bf77$export$1364843af8d5a963 = v);
var $be6f970ec171bf77$export$1364843af8d5a963;
"use strict";

var $3CYRc = parcelRequire("3CYRc");
/* tslint:enable:max-line-length */ /**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */ function $be6f970ec171bf77$var$multicast(subjectOrSubjectFactory, selector) {
    return $3CYRc.multicast(subjectOrSubjectFactory, selector)(this);
}
$be6f970ec171bf77$export$1364843af8d5a963 = $be6f970ec171bf77$var$multicast;

});
parcelRegister("3CYRc", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $2a4420a370e55a03$export$1364843af8d5a963, (v) => $2a4420a370e55a03$export$1364843af8d5a963 = v);
var $2a4420a370e55a03$export$1364843af8d5a963;
var $2a4420a370e55a03$export$150d52413393bf2c;
"use strict";

var $abjpW = parcelRequire("abjpW");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $2a4420a370e55a03$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $2a4420a370e55a03$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $abjpW.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$2a4420a370e55a03$export$1364843af8d5a963 = $2a4420a370e55a03$var$multicast;
var $2a4420a370e55a03$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$2a4420a370e55a03$export$150d52413393bf2c = $2a4420a370e55a03$var$MulticastOperator;

});
parcelRegister("abjpW", function(module, exports) {
"use strict";
var $7699fe5f83a67b6c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $8jOUp = parcelRequire("8jOUp");

var $66gCN = parcelRequire("66gCN");

var $aAAtt = parcelRequire("aAAtt");

var $ilBr9 = parcelRequire("ilBr9");
/**
 * @class ConnectableObservable<T>
 */ var $7699fe5f83a67b6c$var$ConnectableObservable = function(_super) {
    $7699fe5f83a67b6c$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $aAAtt.Subscription();
            connection.add(this.source.subscribe(new $7699fe5f83a67b6c$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $aAAtt.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $ilBr9.refCount()(this);
    };
    return ConnectableObservable;
}($8jOUp.Observable);
module.exports.ConnectableObservable = $7699fe5f83a67b6c$var$ConnectableObservable;
var $7699fe5f83a67b6c$var$connectableProto = $7699fe5f83a67b6c$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $7699fe5f83a67b6c$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $7699fe5f83a67b6c$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $7699fe5f83a67b6c$var$connectableProto.getSubject
    },
    connect: {
        value: $7699fe5f83a67b6c$var$connectableProto.connect
    },
    refCount: {
        value: $7699fe5f83a67b6c$var$connectableProto.refCount
    }
};
var $7699fe5f83a67b6c$var$ConnectableSubscriber = function(_super) {
    $7699fe5f83a67b6c$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($gJqoA.SubjectSubscriber);
var $7699fe5f83a67b6c$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $7699fe5f83a67b6c$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $7699fe5f83a67b6c$var$RefCountSubscriber = function(_super) {
    $7699fe5f83a67b6c$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($66gCN.Subscriber);

});
parcelRegister("ilBr9", function(module, exports) {
"use strict";
var $d5b73a59b79593d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
function $d5b73a59b79593d7$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $d5b73a59b79593d7$var$RefCountOperator(source));
    };
}
module.exports.refCount = $d5b73a59b79593d7$var$refCount;
var $d5b73a59b79593d7$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $d5b73a59b79593d7$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $d5b73a59b79593d7$var$RefCountSubscriber = function(_super) {
    $d5b73a59b79593d7$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($66gCN.Subscriber);

});





parcelRegister("a0XIB", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $7hfNf = parcelRequire("7hfNf");
$8jOUp.Observable.prototype.observeOn = $7hfNf.observeOn;

});
parcelRegister("7hfNf", function(module, exports) {
$parcel$export(module.exports, "observeOn", () => $54c65f25557258d1$export$9007f49c319d1ac7, (v) => $54c65f25557258d1$export$9007f49c319d1ac7 = v);
var $54c65f25557258d1$export$9007f49c319d1ac7;
"use strict";

var $2fC9E = parcelRequire("2fC9E");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $54c65f25557258d1$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $2fC9E.observeOn(scheduler, delay)(this);
}
$54c65f25557258d1$export$9007f49c319d1ac7 = $54c65f25557258d1$var$observeOn;

});


parcelRegister("2vJS1", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $2zdkP = parcelRequire("2zdkP");
$8jOUp.Observable.prototype.onErrorResumeNext = $2zdkP.onErrorResumeNext;

});
parcelRegister("2zdkP", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $1de931b24d8bfc17$export$5fba66d61591f42, (v) => $1de931b24d8bfc17$export$5fba66d61591f42 = v);
var $1de931b24d8bfc17$export$5fba66d61591f42;
"use strict";

var $3eCwJ = parcelRequire("3eCwJ");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $1de931b24d8bfc17$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    return $3eCwJ.onErrorResumeNext.apply(void 0, nextSources)(this);
}
$1de931b24d8bfc17$export$5fba66d61591f42 = $1de931b24d8bfc17$var$onErrorResumeNext;

});


parcelRegister("hTh9y", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $lLcr2 = parcelRequire("lLcr2");
$8jOUp.Observable.prototype.pairwise = $lLcr2.pairwise;

});
parcelRegister("lLcr2", function(module, exports) {
$parcel$export(module.exports, "pairwise", () => $fd77a21cf411b288$export$8f9d79d42bff1aac, (v) => $fd77a21cf411b288$export$8f9d79d42bff1aac = v);
var $fd77a21cf411b288$export$8f9d79d42bff1aac;
"use strict";

var $cPuW4 = parcelRequire("cPuW4");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $fd77a21cf411b288$var$pairwise() {
    return $cPuW4.pairwise()(this);
}
$fd77a21cf411b288$export$8f9d79d42bff1aac = $fd77a21cf411b288$var$pairwise;

});
parcelRegister("cPuW4", function(module, exports) {
"use strict";
var $95723e9becae6705$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $95723e9becae6705$var$pairwise() {
    return function(source) {
        return source.lift(new $95723e9becae6705$var$PairwiseOperator());
    };
}
module.exports.pairwise = $95723e9becae6705$var$pairwise;
var $95723e9becae6705$var$PairwiseOperator = function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $95723e9becae6705$var$PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $95723e9becae6705$var$PairwiseSubscriber = function(_super) {
    $95723e9becae6705$var$__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        if (this.hasPrev) this.destination.next([
            this.prev,
            value
        ]);
        else this.hasPrev = true;
        this.prev = value;
    };
    return PairwiseSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("bM3FB", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $iXQx9 = parcelRequire("iXQx9");
$8jOUp.Observable.prototype.partition = $iXQx9.partition;

});
parcelRegister("iXQx9", function(module, exports) {
$parcel$export(module.exports, "partition", () => $dce67cc70b6e583b$export$b29f828819edca8d, (v) => $dce67cc70b6e583b$export$b29f828819edca8d = v);
var $dce67cc70b6e583b$export$b29f828819edca8d;
"use strict";

var $cdkl9 = parcelRequire("cdkl9");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $dce67cc70b6e583b$var$partition(predicate, thisArg) {
    return $cdkl9.partition(predicate, thisArg)(this);
}
$dce67cc70b6e583b$export$b29f828819edca8d = $dce67cc70b6e583b$var$partition;

});
parcelRegister("cdkl9", function(module, exports) {
$parcel$export(module.exports, "partition", () => $8e467a0ef78af013$export$b29f828819edca8d, (v) => $8e467a0ef78af013$export$b29f828819edca8d = v);
var $8e467a0ef78af013$export$b29f828819edca8d;
"use strict";

var $61aSz = parcelRequire("61aSz");

var $dCzwc = parcelRequire("dCzwc");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $8e467a0ef78af013$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $dCzwc.filter(predicate, thisArg)(source),
            $dCzwc.filter($61aSz.not(predicate, thisArg))(source)
        ];
    };
}
$8e467a0ef78af013$export$b29f828819edca8d = $8e467a0ef78af013$var$partition;

});
parcelRegister("61aSz", function(module, exports) {
$parcel$export(module.exports, "not", () => $461b467821392f67$export$6003a5f097c73977, (v) => $461b467821392f67$export$6003a5f097c73977 = v);
var $461b467821392f67$export$6003a5f097c73977;
"use strict";
function $461b467821392f67$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$461b467821392f67$export$6003a5f097c73977 = $461b467821392f67$var$not;

});




parcelRegister("exxsm", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $3L1MV = parcelRequire("3L1MV");
$8jOUp.Observable.prototype.pluck = $3L1MV.pluck;

});
parcelRegister("3L1MV", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $2bc725fa0b1fd05b$export$c44985b87d605eff, (v) => $2bc725fa0b1fd05b$export$c44985b87d605eff = v);
var $2bc725fa0b1fd05b$export$c44985b87d605eff;
"use strict";

var $3xPAc = parcelRequire("3xPAc");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $2bc725fa0b1fd05b$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    return $3xPAc.pluck.apply(void 0, properties)(this);
}
$2bc725fa0b1fd05b$export$c44985b87d605eff = $2bc725fa0b1fd05b$var$pluck;

});
parcelRegister("3xPAc", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $294c776cfb6e6555$export$c44985b87d605eff, (v) => $294c776cfb6e6555$export$c44985b87d605eff = v);
var $294c776cfb6e6555$export$c44985b87d605eff;
"use strict";

var $bP9Wc = parcelRequire("bP9Wc");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $294c776cfb6e6555$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return function(source) {
        return $bP9Wc.map($294c776cfb6e6555$var$plucker(properties, length))(source);
    };
}
$294c776cfb6e6555$export$c44985b87d605eff = $294c776cfb6e6555$var$pluck;
function $294c776cfb6e6555$var$plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

});



parcelRegister("aZNfb", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $frxRU = parcelRequire("frxRU");
$8jOUp.Observable.prototype.publish = $frxRU.publish;

});
parcelRegister("frxRU", function(module, exports) {
$parcel$export(module.exports, "publish", () => $b3e3a63647b95942$export$89b472e03be495df, (v) => $b3e3a63647b95942$export$89b472e03be495df = v);
var $b3e3a63647b95942$export$89b472e03be495df;
"use strict";

var $K815z = parcelRequire("K815z");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $b3e3a63647b95942$var$publish(selector) {
    return $K815z.publish(selector)(this);
}
$b3e3a63647b95942$export$89b472e03be495df = $b3e3a63647b95942$var$publish;

});
parcelRegister("K815z", function(module, exports) {
$parcel$export(module.exports, "publish", () => $08aa83ea2fddda69$export$89b472e03be495df, (v) => $08aa83ea2fddda69$export$89b472e03be495df = v);
var $08aa83ea2fddda69$export$89b472e03be495df;
"use strict";

var $gJqoA = parcelRequire("gJqoA");

var $3CYRc = parcelRequire("3CYRc");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $08aa83ea2fddda69$var$publish(selector) {
    return selector ? $3CYRc.multicast(function() {
        return new $gJqoA.Subject();
    }, selector) : $3CYRc.multicast(new $gJqoA.Subject());
}
$08aa83ea2fddda69$export$89b472e03be495df = $08aa83ea2fddda69$var$publish;

});



parcelRegister("95DGT", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6dGGC = parcelRequire("6dGGC");
$8jOUp.Observable.prototype.publishBehavior = $6dGGC.publishBehavior;

});
parcelRegister("6dGGC", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $4875119a2fc766c2$export$16ae46fda9567053, (v) => $4875119a2fc766c2$export$16ae46fda9567053 = v);
var $4875119a2fc766c2$export$16ae46fda9567053;
"use strict";

var $Up4mT = parcelRequire("Up4mT");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $4875119a2fc766c2$var$publishBehavior(value) {
    return $Up4mT.publishBehavior(value)(this);
}
$4875119a2fc766c2$export$16ae46fda9567053 = $4875119a2fc766c2$var$publishBehavior;

});
parcelRegister("Up4mT", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $0a98ad595192a8b8$export$16ae46fda9567053, (v) => $0a98ad595192a8b8$export$16ae46fda9567053 = v);
var $0a98ad595192a8b8$export$16ae46fda9567053;
"use strict";

var $dbTkL = parcelRequire("dbTkL");

var $3CYRc = parcelRequire("3CYRc");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $0a98ad595192a8b8$var$publishBehavior(value) {
    return function(source) {
        return $3CYRc.multicast(new $dbTkL.BehaviorSubject(value))(source);
    };
}
$0a98ad595192a8b8$export$16ae46fda9567053 = $0a98ad595192a8b8$var$publishBehavior;

});
parcelRegister("dbTkL", function(module, exports) {
"use strict";
var $99a7399535f436ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $b9gng = parcelRequire("b9gng");
/**
 * @class BehaviorSubject<T>
 */ var $99a7399535f436ff$var$BehaviorSubject = function(_super) {
    $99a7399535f436ff$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $b9gng.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gJqoA.Subject);
module.exports.BehaviorSubject = $99a7399535f436ff$var$BehaviorSubject;

});




parcelRegister("hoPOo", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $iTKR2 = parcelRequire("iTKR2");
$8jOUp.Observable.prototype.publishReplay = $iTKR2.publishReplay;

});
parcelRegister("iTKR2", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $dc21b55d20b2ef4a$export$1f3342bf81d92d52, (v) => $dc21b55d20b2ef4a$export$1f3342bf81d92d52 = v);
var $dc21b55d20b2ef4a$export$1f3342bf81d92d52;
"use strict";

var $4vqFc = parcelRequire("4vqFc");
/* tslint:enable:max-line-length */ /**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */ function $dc21b55d20b2ef4a$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return $4vqFc.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
$dc21b55d20b2ef4a$export$1f3342bf81d92d52 = $dc21b55d20b2ef4a$var$publishReplay;

});
parcelRegister("4vqFc", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $347ebd7db9555060$export$1f3342bf81d92d52, (v) => $347ebd7db9555060$export$1f3342bf81d92d52 = v);
var $347ebd7db9555060$export$1f3342bf81d92d52;
"use strict";

var $9nelC = parcelRequire("9nelC");

var $3CYRc = parcelRequire("3CYRc");
/* tslint:enable:max-line-length */ function $347ebd7db9555060$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $9nelC.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $3CYRc.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$347ebd7db9555060$export$1f3342bf81d92d52 = $347ebd7db9555060$var$publishReplay;

});



parcelRegister("12cfI", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $2mg9Q = parcelRequire("2mg9Q");
$8jOUp.Observable.prototype.publishLast = $2mg9Q.publishLast;

});
parcelRegister("2mg9Q", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $1b7a2b771a4a35a3$export$42d9b6b38c68d989, (v) => $1b7a2b771a4a35a3$export$42d9b6b38c68d989 = v);
var $1b7a2b771a4a35a3$export$42d9b6b38c68d989;
"use strict";

var $6Zq4e = parcelRequire("6Zq4e");
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */ function $1b7a2b771a4a35a3$var$publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return $6Zq4e.publishLast()(this);
}
$1b7a2b771a4a35a3$export$42d9b6b38c68d989 = $1b7a2b771a4a35a3$var$publishLast;

});
parcelRegister("6Zq4e", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $516ca9053916bc3e$export$42d9b6b38c68d989, (v) => $516ca9053916bc3e$export$42d9b6b38c68d989 = v);
var $516ca9053916bc3e$export$42d9b6b38c68d989;
"use strict";

var $42fQ9 = parcelRequire("42fQ9");

var $3CYRc = parcelRequire("3CYRc");
function $516ca9053916bc3e$var$publishLast() {
    return function(source) {
        return $3CYRc.multicast(new $42fQ9.AsyncSubject())(source);
    };
}
$516ca9053916bc3e$export$42d9b6b38c68d989 = $516ca9053916bc3e$var$publishLast;

});



parcelRegister("dQj0O", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $23ffl = parcelRequire("23ffl");
$8jOUp.Observable.prototype.race = $23ffl.race;

});
parcelRegister("23ffl", function(module, exports) {
$parcel$export(module.exports, "race", () => $17e7b03adf696ff5$export$236c05de452bec2, (v) => $17e7b03adf696ff5$export$236c05de452bec2 = v);
var $17e7b03adf696ff5$export$dc3f181b77d95dcc;
var $17e7b03adf696ff5$export$236c05de452bec2;
"use strict";

var $5BI5v = parcelRequire("5BI5v");

var $cBBhW = parcelRequire("cBBhW");
$17e7b03adf696ff5$export$dc3f181b77d95dcc = $cBBhW.race;
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $17e7b03adf696ff5$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $5BI5v.race.apply(void 0, observables)(this);
}
$17e7b03adf696ff5$export$236c05de452bec2 = $17e7b03adf696ff5$var$race;

});
parcelRegister("5BI5v", function(module, exports) {
$parcel$export(module.exports, "race", () => $41529b6440a284d2$export$236c05de452bec2, (v) => $41529b6440a284d2$export$236c05de452bec2 = v);
var $41529b6440a284d2$export$236c05de452bec2;
"use strict";

var $gWadc = parcelRequire("gWadc");

var $cBBhW = parcelRequire("cBBhW");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $41529b6440a284d2$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $gWadc.isArray(observables[0])) observables = observables[0];
        return source.lift.call($cBBhW.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$41529b6440a284d2$export$236c05de452bec2 = $41529b6440a284d2$var$race;

});



parcelRegister("aJNuu", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $KP5OU = parcelRequire("KP5OU");
$8jOUp.Observable.prototype.reduce = $KP5OU.reduce;

});
parcelRegister("KP5OU", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $08cbedf8f695ecd1$export$533b26079ad0b4b, (v) => $08cbedf8f695ecd1$export$533b26079ad0b4b = v);
var $08cbedf8f695ecd1$export$533b26079ad0b4b;
"use strict";

var $de1nH = parcelRequire("de1nH");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $08cbedf8f695ecd1$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return $de1nH.reduce(accumulator, seed)(this);
    return $de1nH.reduce(accumulator)(this);
}
$08cbedf8f695ecd1$export$533b26079ad0b4b = $08cbedf8f695ecd1$var$reduce;

});


parcelRegister("1nD9i", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6awLi = parcelRequire("6awLi");
$8jOUp.Observable.prototype.repeat = $6awLi.repeat;

});
parcelRegister("6awLi", function(module, exports) {
$parcel$export(module.exports, "repeat", () => $47dd1713477f2446$export$76d90c956114f2c2, (v) => $47dd1713477f2446$export$76d90c956114f2c2 = v);
var $47dd1713477f2446$export$76d90c956114f2c2;
"use strict";

var $6dn34 = parcelRequire("6dn34");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $47dd1713477f2446$var$repeat(count) {
    if (count === void 0) count = -1;
    return $6dn34.repeat(count)(this);
}
$47dd1713477f2446$export$76d90c956114f2c2 = $47dd1713477f2446$var$repeat;

});
parcelRegister("6dn34", function(module, exports) {
"use strict";
var $4865d5ed3db8f836$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $cUooy = parcelRequire("cUooy");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $4865d5ed3db8f836$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $cUooy.EmptyObservable();
        else if (count < 0) return source.lift(new $4865d5ed3db8f836$var$RepeatOperator(-1, source));
        else return source.lift(new $4865d5ed3db8f836$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $4865d5ed3db8f836$var$repeat;
var $4865d5ed3db8f836$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4865d5ed3db8f836$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4865d5ed3db8f836$var$RepeatSubscriber = function(_super) {
    $4865d5ed3db8f836$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("kybeY", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kPlh1 = parcelRequire("kPlh1");
$8jOUp.Observable.prototype.repeatWhen = $kPlh1.repeatWhen;

});
parcelRegister("kPlh1", function(module, exports) {
$parcel$export(module.exports, "repeatWhen", () => $f299128e17f74d3d$export$b39ac5b4ffd1415a, (v) => $f299128e17f74d3d$export$b39ac5b4ffd1415a = v);
var $f299128e17f74d3d$export$b39ac5b4ffd1415a;
"use strict";

var $1LLSb = parcelRequire("1LLSb");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $f299128e17f74d3d$var$repeatWhen(notifier) {
    return $1LLSb.repeatWhen(notifier)(this);
}
$f299128e17f74d3d$export$b39ac5b4ffd1415a = $f299128e17f74d3d$var$repeatWhen;

});
parcelRegister("1LLSb", function(module, exports) {
"use strict";
var $149f50c9210133b1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $149f50c9210133b1$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $149f50c9210133b1$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $149f50c9210133b1$var$repeatWhen;
var $149f50c9210133b1$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $149f50c9210133b1$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $149f50c9210133b1$var$RepeatWhenSubscriber = function(_super) {
    $149f50c9210133b1$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $gJqoA.Subject();
        var retries = $cxrX4.tryCatch(this.notifier)(this.notifications);
        if (retries === $2afHm.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $jziWR.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("1S4eh", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $jsdKS = parcelRequire("jsdKS");
$8jOUp.Observable.prototype.retry = $jsdKS.retry;

});
parcelRegister("jsdKS", function(module, exports) {
$parcel$export(module.exports, "retry", () => $e29b4d5396f27872$export$9369b12211e1fce4, (v) => $e29b4d5396f27872$export$9369b12211e1fce4 = v);
var $e29b4d5396f27872$export$9369b12211e1fce4;
"use strict";

var $evUR9 = parcelRequire("evUR9");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $e29b4d5396f27872$var$retry(count) {
    if (count === void 0) count = -1;
    return $evUR9.retry(count)(this);
}
$e29b4d5396f27872$export$9369b12211e1fce4 = $e29b4d5396f27872$var$retry;

});
parcelRegister("evUR9", function(module, exports) {
"use strict";
var $a9101068ac213f4a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $a9101068ac213f4a$var$retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $a9101068ac213f4a$var$RetryOperator(count, source));
    };
}
module.exports.retry = $a9101068ac213f4a$var$retry;
var $a9101068ac213f4a$var$RetryOperator = function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a9101068ac213f4a$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a9101068ac213f4a$var$RetrySubscriber = function(_super) {
    $a9101068ac213f4a$var$__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}($66gCN.Subscriber);

});



parcelRegister("kLVHh", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $9z3E9 = parcelRequire("9z3E9");
$8jOUp.Observable.prototype.retryWhen = $9z3E9.retryWhen;

});
parcelRegister("9z3E9", function(module, exports) {
$parcel$export(module.exports, "retryWhen", () => $6f6a3613ebf93ce9$export$1281551253cfee02, (v) => $6f6a3613ebf93ce9$export$1281551253cfee02 = v);
var $6f6a3613ebf93ce9$export$1281551253cfee02;
"use strict";

var $alXRc = parcelRequire("alXRc");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $6f6a3613ebf93ce9$var$retryWhen(notifier) {
    return $alXRc.retryWhen(notifier)(this);
}
$6f6a3613ebf93ce9$export$1281551253cfee02 = $6f6a3613ebf93ce9$var$retryWhen;

});
parcelRegister("alXRc", function(module, exports) {
"use strict";
var $789a4be50451daf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $789a4be50451daf1$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $789a4be50451daf1$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $789a4be50451daf1$var$retryWhen;
var $789a4be50451daf1$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $789a4be50451daf1$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $789a4be50451daf1$var$RetryWhenSubscriber = function(_super) {
    $789a4be50451daf1$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $gJqoA.Subject();
                retries = $cxrX4.tryCatch(this.notifier)(errors);
                if (retries === $2afHm.errorObject) return _super.prototype.error.call(this, $2afHm.errorObject.e);
                retriesSubscription = $jziWR.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("g23Cu", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $llwK4 = parcelRequire("llwK4");
$8jOUp.Observable.prototype.sample = $llwK4.sample;

});
parcelRegister("llwK4", function(module, exports) {
$parcel$export(module.exports, "sample", () => $f8a4f50394f3d966$export$4812e460280c6ef2, (v) => $f8a4f50394f3d966$export$4812e460280c6ef2 = v);
var $f8a4f50394f3d966$export$4812e460280c6ef2;
"use strict";

var $10ape = parcelRequire("10ape");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $f8a4f50394f3d966$var$sample(notifier) {
    return $10ape.sample(notifier)(this);
}
$f8a4f50394f3d966$export$4812e460280c6ef2 = $f8a4f50394f3d966$var$sample;

});
parcelRegister("10ape", function(module, exports) {
"use strict";
var $0baddcf28619f848$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $0baddcf28619f848$var$sample(notifier) {
    return function(source) {
        return source.lift(new $0baddcf28619f848$var$SampleOperator(notifier));
    };
}
module.exports.sample = $0baddcf28619f848$var$sample;
var $0baddcf28619f848$var$SampleOperator = function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new $0baddcf28619f848$var$SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add($jziWR.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0baddcf28619f848$var$SampleSubscriber = function(_super) {
    $0baddcf28619f848$var$__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("dSmep", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $biy1o = parcelRequire("biy1o");
$8jOUp.Observable.prototype.sampleTime = $biy1o.sampleTime;

});
parcelRegister("biy1o", function(module, exports) {
$parcel$export(module.exports, "sampleTime", () => $839bc41c0b08f47e$export$fe33c7b2002d97b0, (v) => $839bc41c0b08f47e$export$fe33c7b2002d97b0 = v);
var $839bc41c0b08f47e$export$fe33c7b2002d97b0;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $fV0Ji = parcelRequire("fV0Ji");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $839bc41c0b08f47e$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $fV0Ji.sampleTime(period, scheduler)(this);
}
$839bc41c0b08f47e$export$fe33c7b2002d97b0 = $839bc41c0b08f47e$var$sampleTime;

});
parcelRegister("fV0Ji", function(module, exports) {
"use strict";
var $b96cbec342cde8ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $kESbZ = parcelRequire("kESbZ");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $b96cbec342cde8ff$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return function(source) {
        return source.lift(new $b96cbec342cde8ff$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $b96cbec342cde8ff$var$sampleTime;
var $b96cbec342cde8ff$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b96cbec342cde8ff$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b96cbec342cde8ff$var$SampleTimeSubscriber = function(_super) {
    $b96cbec342cde8ff$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($b96cbec342cde8ff$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($66gCN.Subscriber);
function $b96cbec342cde8ff$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});



parcelRegister("2t0n8", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4gJEC = parcelRequire("4gJEC");
$8jOUp.Observable.prototype.scan = $4gJEC.scan;

});
parcelRegister("4gJEC", function(module, exports) {
$parcel$export(module.exports, "scan", () => $31bc12036c09f27d$export$c87d910e63d22ed6, (v) => $31bc12036c09f27d$export$c87d910e63d22ed6 = v);
var $31bc12036c09f27d$export$c87d910e63d22ed6;
"use strict";

var $cKrD4 = parcelRequire("cKrD4");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $31bc12036c09f27d$var$scan(accumulator, seed) {
    if (arguments.length >= 2) return $cKrD4.scan(accumulator, seed)(this);
    return $cKrD4.scan(accumulator)(this);
}
$31bc12036c09f27d$export$c87d910e63d22ed6 = $31bc12036c09f27d$var$scan;

});


parcelRegister("3FU5I", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $icsmh = parcelRequire("icsmh");
$8jOUp.Observable.prototype.sequenceEqual = $icsmh.sequenceEqual;

});
parcelRegister("icsmh", function(module, exports) {
$parcel$export(module.exports, "sequenceEqual", () => $d3ff58630bbe2f89$export$d0a07e60ae428313, (v) => $d3ff58630bbe2f89$export$d0a07e60ae428313 = v);
var $d3ff58630bbe2f89$export$d0a07e60ae428313;
"use strict";

var $63tY2 = parcelRequire("63tY2");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $d3ff58630bbe2f89$var$sequenceEqual(compareTo, comparor) {
    return $63tY2.sequenceEqual(compareTo, comparor)(this);
}
$d3ff58630bbe2f89$export$d0a07e60ae428313 = $d3ff58630bbe2f89$var$sequenceEqual;

});
parcelRegister("63tY2", function(module, exports) {
"use strict";
var $468a44c267233510$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $468a44c267233510$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $468a44c267233510$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $468a44c267233510$var$sequenceEqual;
var $468a44c267233510$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $468a44c267233510$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $468a44c267233510$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $468a44c267233510$var$SequenceEqualSubscriber = function(_super) {
    $468a44c267233510$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $468a44c267233510$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $cxrX4.tryCatch(comparor)(a, b);
                if (areEqual === $2afHm.errorObject) this.destination.error($2afHm.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($66gCN.Subscriber);
module.exports.SequenceEqualSubscriber = $468a44c267233510$var$SequenceEqualSubscriber;
var $468a44c267233510$var$SequenceEqualCompareToSubscriber = function(_super) {
    $468a44c267233510$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("crBQ4", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $fZNsr = parcelRequire("fZNsr");
$8jOUp.Observable.prototype.share = $fZNsr.share;

});
parcelRegister("fZNsr", function(module, exports) {
$parcel$export(module.exports, "share", () => $ba52eac8176b1d83$export$ed80d9de1d9df928, (v) => $ba52eac8176b1d83$export$ed80d9de1d9df928 = v);
var $ba52eac8176b1d83$export$ed80d9de1d9df928;
"use strict";

var $g1tTT = parcelRequire("g1tTT");
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $ba52eac8176b1d83$var$share() {
    return $g1tTT.share()(this);
}
$ba52eac8176b1d83$export$ed80d9de1d9df928 = $ba52eac8176b1d83$var$share;

});
parcelRegister("g1tTT", function(module, exports) {
$parcel$export(module.exports, "share", () => $baa3eef6226e5cc6$export$ed80d9de1d9df928, (v) => $baa3eef6226e5cc6$export$ed80d9de1d9df928 = v);
var $baa3eef6226e5cc6$export$ed80d9de1d9df928;
"use strict";

var $3CYRc = parcelRequire("3CYRc");

var $ilBr9 = parcelRequire("ilBr9");

var $gJqoA = parcelRequire("gJqoA");
function $baa3eef6226e5cc6$var$shareSubjectFactory() {
    return new $gJqoA.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $baa3eef6226e5cc6$var$share() {
    return function(source) {
        return $ilBr9.refCount()($3CYRc.multicast($baa3eef6226e5cc6$var$shareSubjectFactory)(source));
    };
}
$baa3eef6226e5cc6$export$ed80d9de1d9df928 = $baa3eef6226e5cc6$var$share;

});



parcelRegister("4PT5g", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $crSOA = parcelRequire("crSOA");
$8jOUp.Observable.prototype.shareReplay = $crSOA.shareReplay;

});
parcelRegister("crSOA", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $910286bdd2ccbc1b$export$db61d692014e534e, (v) => $910286bdd2ccbc1b$export$db61d692014e534e = v);
var $910286bdd2ccbc1b$export$db61d692014e534e;
"use strict";

var $bOzV7 = parcelRequire("bOzV7");
/**
 * @method shareReplay
 * @owner Observable
 */ function $910286bdd2ccbc1b$var$shareReplay(bufferSize, windowTime, scheduler) {
    return $bOzV7.shareReplay(bufferSize, windowTime, scheduler)(this);
}
$910286bdd2ccbc1b$export$db61d692014e534e = $910286bdd2ccbc1b$var$shareReplay;

});
parcelRegister("bOzV7", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $89a03a37271cb936$export$db61d692014e534e, (v) => $89a03a37271cb936$export$db61d692014e534e = v);
var $89a03a37271cb936$export$db61d692014e534e;
"use strict";

var $9nelC = parcelRequire("9nelC");
/**
 * @method shareReplay
 * @owner Observable
 */ function $89a03a37271cb936$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($89a03a37271cb936$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$89a03a37271cb936$export$db61d692014e534e = $89a03a37271cb936$var$shareReplay;
function $89a03a37271cb936$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $9nelC.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});



parcelRegister("1tNRj", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $laYnw = parcelRequire("laYnw");
$8jOUp.Observable.prototype.single = $laYnw.single;

});
parcelRegister("laYnw", function(module, exports) {
$parcel$export(module.exports, "single", () => $f6a95e04192cad2f$export$863d7ca51b416cee, (v) => $f6a95e04192cad2f$export$863d7ca51b416cee = v);
var $f6a95e04192cad2f$export$863d7ca51b416cee;
"use strict";

var $hGbb9 = parcelRequire("hGbb9");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $f6a95e04192cad2f$var$single(predicate) {
    return $hGbb9.single(predicate)(this);
}
$f6a95e04192cad2f$export$863d7ca51b416cee = $f6a95e04192cad2f$var$single;

});
parcelRegister("hGbb9", function(module, exports) {
"use strict";
var $cdef07c62643ba20$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $hLArM = parcelRequire("hLArM");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $cdef07c62643ba20$var$single(predicate) {
    return function(source) {
        return source.lift(new $cdef07c62643ba20$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $cdef07c62643ba20$var$single;
var $cdef07c62643ba20$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cdef07c62643ba20$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cdef07c62643ba20$var$SingleSubscriber = function(_super) {
    $cdef07c62643ba20$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $hLArM.EmptyError);
    };
    return SingleSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("g5I8P", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4E3aB = parcelRequire("4E3aB");
$8jOUp.Observable.prototype.skip = $4E3aB.skip;

});
parcelRegister("4E3aB", function(module, exports) {
$parcel$export(module.exports, "skip", () => $361d5b5f2bd9cdb5$export$955fc4a6c4be454d, (v) => $361d5b5f2bd9cdb5$export$955fc4a6c4be454d = v);
var $361d5b5f2bd9cdb5$export$955fc4a6c4be454d;
"use strict";

var $8b8V8 = parcelRequire("8b8V8");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $361d5b5f2bd9cdb5$var$skip(count) {
    return $8b8V8.skip(count)(this);
}
$361d5b5f2bd9cdb5$export$955fc4a6c4be454d = $361d5b5f2bd9cdb5$var$skip;

});
parcelRegister("8b8V8", function(module, exports) {
"use strict";
var $018964369f6fd9a6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $018964369f6fd9a6$var$skip(count) {
    return function(source) {
        return source.lift(new $018964369f6fd9a6$var$SkipOperator(count));
    };
}
module.exports.skip = $018964369f6fd9a6$var$skip;
var $018964369f6fd9a6$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $018964369f6fd9a6$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $018964369f6fd9a6$var$SkipSubscriber = function(_super) {
    $018964369f6fd9a6$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("9NDNe", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $bnyB6 = parcelRequire("bnyB6");
$8jOUp.Observable.prototype.skipLast = $bnyB6.skipLast;

});
parcelRegister("bnyB6", function(module, exports) {
$parcel$export(module.exports, "skipLast", () => $848cae07d7fdc3e9$export$635f6273df29ea1c, (v) => $848cae07d7fdc3e9$export$635f6273df29ea1c = v);
var $848cae07d7fdc3e9$export$635f6273df29ea1c;
"use strict";

var $3Nv3L = parcelRequire("3Nv3L");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $848cae07d7fdc3e9$var$skipLast(count) {
    return $3Nv3L.skipLast(count)(this);
}
$848cae07d7fdc3e9$export$635f6273df29ea1c = $848cae07d7fdc3e9$var$skipLast;

});
parcelRegister("3Nv3L", function(module, exports) {
"use strict";
var $2c3e0a7dd34205ae$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $4IOSZ = parcelRequire("4IOSZ");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $2c3e0a7dd34205ae$var$skipLast(count) {
    return function(source) {
        return source.lift(new $2c3e0a7dd34205ae$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $2c3e0a7dd34205ae$var$skipLast;
var $2c3e0a7dd34205ae$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $4IOSZ.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $66gCN.Subscriber(subscriber));
        else return source.subscribe(new $2c3e0a7dd34205ae$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c3e0a7dd34205ae$var$SkipLastSubscriber = function(_super) {
    $2c3e0a7dd34205ae$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("gIKfZ", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $bFYfc = parcelRequire("bFYfc");
$8jOUp.Observable.prototype.skipUntil = $bFYfc.skipUntil;

});
parcelRegister("bFYfc", function(module, exports) {
$parcel$export(module.exports, "skipUntil", () => $88024145beb8b7fb$export$facc584867c26fde, (v) => $88024145beb8b7fb$export$facc584867c26fde = v);
var $88024145beb8b7fb$export$facc584867c26fde;
"use strict";

var $fxjWN = parcelRequire("fxjWN");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $88024145beb8b7fb$var$skipUntil(notifier) {
    return $fxjWN.skipUntil(notifier)(this);
}
$88024145beb8b7fb$export$facc584867c26fde = $88024145beb8b7fb$var$skipUntil;

});
parcelRegister("fxjWN", function(module, exports) {
"use strict";
var $b4f9693982edd063$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $b4f9693982edd063$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $b4f9693982edd063$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $b4f9693982edd063$var$skipUntil;
var $b4f9693982edd063$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b4f9693982edd063$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b4f9693982edd063$var$SkipUntilSubscriber = function(_super) {
    $b4f9693982edd063$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($jziWR.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("dOM56", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $lRFSA = parcelRequire("lRFSA");
$8jOUp.Observable.prototype.skipWhile = $lRFSA.skipWhile;

});
parcelRegister("lRFSA", function(module, exports) {
$parcel$export(module.exports, "skipWhile", () => $feaf089a67ebecf5$export$175dedd748069215, (v) => $feaf089a67ebecf5$export$175dedd748069215 = v);
var $feaf089a67ebecf5$export$175dedd748069215;
"use strict";

var $aM7z9 = parcelRequire("aM7z9");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $feaf089a67ebecf5$var$skipWhile(predicate) {
    return $aM7z9.skipWhile(predicate)(this);
}
$feaf089a67ebecf5$export$175dedd748069215 = $feaf089a67ebecf5$var$skipWhile;

});
parcelRegister("aM7z9", function(module, exports) {
"use strict";
var $7d844188f75fb48a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $7d844188f75fb48a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $7d844188f75fb48a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $7d844188f75fb48a$var$skipWhile;
var $7d844188f75fb48a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7d844188f75fb48a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7d844188f75fb48a$var$SkipWhileSubscriber = function(_super) {
    $7d844188f75fb48a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("1CcwI", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $1MCZM = parcelRequire("1MCZM");
$8jOUp.Observable.prototype.startWith = $1MCZM.startWith;

});
parcelRegister("1MCZM", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $14c885cd0455516f$export$a4fe86229b0e9bdd, (v) => $14c885cd0455516f$export$a4fe86229b0e9bdd = v);
var $14c885cd0455516f$export$a4fe86229b0e9bdd;
"use strict";

var $gVaRN = parcelRequire("gVaRN");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $14c885cd0455516f$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return $gVaRN.startWith.apply(void 0, array)(this);
}
$14c885cd0455516f$export$a4fe86229b0e9bdd = $14c885cd0455516f$var$startWith;

});
parcelRegister("gVaRN", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $c51a6620aaed0d5b$export$a4fe86229b0e9bdd, (v) => $c51a6620aaed0d5b$export$a4fe86229b0e9bdd = v);
var $c51a6620aaed0d5b$export$a4fe86229b0e9bdd;
"use strict";

var $fznCF = parcelRequire("fznCF");

var $b3QMc = parcelRequire("b3QMc");

var $cUooy = parcelRequire("cUooy");

var $77dSs = parcelRequire("77dSs");

var $86ewR = parcelRequire("86ewR");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $c51a6620aaed0d5b$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return function(source) {
        var scheduler = array[array.length - 1];
        if ($86ewR.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len === 1) return $77dSs.concat(new $b3QMc.ScalarObservable(array[0], scheduler), source);
        else if (len > 1) return $77dSs.concat(new $fznCF.ArrayObservable(array, scheduler), source);
        else return $77dSs.concat(new $cUooy.EmptyObservable(scheduler), source);
    };
}
$c51a6620aaed0d5b$export$a4fe86229b0e9bdd = $c51a6620aaed0d5b$var$startWith;

});



parcelRegister("546kW", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kmT25 = parcelRequire("kmT25");
$8jOUp.Observable.prototype.subscribeOn = $kmT25.subscribeOn;

});
parcelRegister("kmT25", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $ed408d13a9aa229b$export$1eb44d8f5f64733b, (v) => $ed408d13a9aa229b$export$1eb44d8f5f64733b = v);
var $ed408d13a9aa229b$export$1eb44d8f5f64733b;
"use strict";

var $eMy2c = parcelRequire("eMy2c");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $ed408d13a9aa229b$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $eMy2c.subscribeOn(scheduler, delay)(this);
}
$ed408d13a9aa229b$export$1eb44d8f5f64733b = $ed408d13a9aa229b$var$subscribeOn;

});
parcelRegister("eMy2c", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $ac2ff2f0fdf04a3d$export$1eb44d8f5f64733b, (v) => $ac2ff2f0fdf04a3d$export$1eb44d8f5f64733b = v);
var $ac2ff2f0fdf04a3d$export$1eb44d8f5f64733b;
"use strict";

var $97p3b = parcelRequire("97p3b");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $ac2ff2f0fdf04a3d$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new $ac2ff2f0fdf04a3d$var$SubscribeOnOperator(scheduler, delay));
    };
}
$ac2ff2f0fdf04a3d$export$1eb44d8f5f64733b = $ac2ff2f0fdf04a3d$var$subscribeOn;
var $ac2ff2f0fdf04a3d$var$SubscribeOnOperator = function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new $97p3b.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

});
parcelRegister("97p3b", function(module, exports) {
"use strict";
var $6a3832f974d34442$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $ejgy5 = parcelRequire("ejgy5");

var $hHpuK = parcelRequire("hHpuK");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $6a3832f974d34442$var$SubscribeOnObservable = function(_super) {
    $6a3832f974d34442$var$__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = $ejgy5.asap;
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!$hHpuK.isNumeric(delayTime) || delayTime < 0) this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $ejgy5.asap;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = $ejgy5.asap;
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}($8jOUp.Observable);
module.exports.SubscribeOnObservable = $6a3832f974d34442$var$SubscribeOnObservable;

});
parcelRegister("ejgy5", function(module, exports) {
$parcel$export(module.exports, "asap", () => $a6afad4e1b7e3daf$export$dc4d482300a341e1, (v) => $a6afad4e1b7e3daf$export$dc4d482300a341e1 = v);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */ var $a6afad4e1b7e3daf$export$dc4d482300a341e1;
"use strict";

var $b6boj = parcelRequire("b6boj");

var $15qeo = parcelRequire("15qeo");
$a6afad4e1b7e3daf$export$dc4d482300a341e1 = new $15qeo.AsapScheduler($b6boj.AsapAction);

});
parcelRegister("b6boj", function(module, exports) {
"use strict";
var $814917475c2cedd9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hQ4lH = parcelRequire("hQ4lH");

var $1GOJd = parcelRequire("1GOJd");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $814917475c2cedd9$var$AsapAction = function(_super) {
    $814917475c2cedd9$var$__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = $hQ4lH.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            $hQ4lH.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}($1GOJd.AsyncAction);
module.exports.AsapAction = $814917475c2cedd9$var$AsapAction;

});
parcelRegister("hQ4lH", function(module, exports) {
$parcel$export(module.exports, "Immediate", () => $cfcaaa97fc38b7c8$export$9bf7f22d83f7b5af, (v) => $cfcaaa97fc38b7c8$export$9bf7f22d83f7b5af = v);
/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/ var $cfcaaa97fc38b7c8$export$9dc12cb738f70fa0;
var $cfcaaa97fc38b7c8$export$9bf7f22d83f7b5af;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
var $cfcaaa97fc38b7c8$var$ImmediateDefinition = function() {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        } else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) // For Node.js before 0.9
            this.setImmediate = this.createProcessNextTickSetImmediate();
            else if (this.canUsePostMessage()) // For non-IE10 modern browsers
            this.setImmediate = this.createPostMessageSetImmediate();
            else if (this.canUseMessageChannel()) // For web workers, where supported
            this.setImmediate = this.createMessageChannelSetImmediate();
            else if (this.canUseReadyStateChange()) // For IE 6–8
            this.setImmediate = this.createReadyStateChangeSetImmediate();
            else // For older browsers
            this.setImmediate = this.createSetTimeoutSetImmediate();
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function(o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function() {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function() {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function() {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function() {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function() {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function(handler) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') handler.apply(undefined, args);
            else new Function('' + handler)();
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function(args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root && typeof event.data === 'string' && event.data.indexOf(messagePrefix) === 0) instance.runIfPresent(+event.data.slice(messagePrefix.length));
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function(handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // 'too much recursion' error.
        this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                } finally{
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function() {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function() {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}();
$cfcaaa97fc38b7c8$export$9dc12cb738f70fa0 = $cfcaaa97fc38b7c8$var$ImmediateDefinition;
$cfcaaa97fc38b7c8$export$9bf7f22d83f7b5af = new $cfcaaa97fc38b7c8$var$ImmediateDefinition($a5Mzo.root);

});


parcelRegister("15qeo", function(module, exports) {
"use strict";
var $0caa9b0a88ec2993$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5aY3c = parcelRequire("5aY3c");
var $0caa9b0a88ec2993$var$AsapScheduler = function(_super) {
    $0caa9b0a88ec2993$var$__extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}($5aY3c.AsyncScheduler);
module.exports.AsapScheduler = $0caa9b0a88ec2993$var$AsapScheduler;

});






parcelRegister("kGGlg", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $cjz7w = parcelRequire("cjz7w");
$8jOUp.Observable.prototype.switch = $cjz7w._switch;
$8jOUp.Observable.prototype._switch = $cjz7w._switch;

});
parcelRegister("cjz7w", function(module, exports) {
$parcel$export(module.exports, "_switch", () => $8f72808d31da55d1$export$424b8b2ab9af2944, (v) => $8f72808d31da55d1$export$424b8b2ab9af2944 = v);
var $8f72808d31da55d1$export$424b8b2ab9af2944;
"use strict";

var $2hLYY = parcelRequire("2hLYY");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */ function $8f72808d31da55d1$var$_switch() {
    return $2hLYY.switchAll()(this);
}
$8f72808d31da55d1$export$424b8b2ab9af2944 = $8f72808d31da55d1$var$_switch;

});
parcelRegister("2hLYY", function(module, exports) {
$parcel$export(module.exports, "switchAll", () => $1aa2639eea67cb3b$export$6a45284a4b0bf33a, (v) => $1aa2639eea67cb3b$export$6a45284a4b0bf33a = v);
var $1aa2639eea67cb3b$export$6a45284a4b0bf33a;
"use strict";

var $1phCj = parcelRequire("1phCj");

var $83Ass = parcelRequire("83Ass");
function $1aa2639eea67cb3b$var$switchAll() {
    return $1phCj.switchMap($83Ass.identity);
}
$1aa2639eea67cb3b$export$6a45284a4b0bf33a = $1aa2639eea67cb3b$var$switchAll;

});



parcelRegister("kf022", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $jTG1y = parcelRequire("jTG1y");
$8jOUp.Observable.prototype.switchMap = $jTG1y.switchMap;

});

parcelRegister("iFbu9", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $iezRB = parcelRequire("iezRB");
$8jOUp.Observable.prototype.switchMapTo = $iezRB.switchMapTo;

});
parcelRegister("iezRB", function(module, exports) {
$parcel$export(module.exports, "switchMapTo", () => $d4655a8b57ae2ade$export$a439dc30c845238, (v) => $d4655a8b57ae2ade$export$a439dc30c845238 = v);
var $d4655a8b57ae2ade$export$a439dc30c845238;
"use strict";

var $hAXvt = parcelRequire("hAXvt");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $d4655a8b57ae2ade$var$switchMapTo(innerObservable, resultSelector) {
    return $hAXvt.switchMapTo(innerObservable, resultSelector)(this);
}
$d4655a8b57ae2ade$export$a439dc30c845238 = $d4655a8b57ae2ade$var$switchMapTo;

});
parcelRegister("hAXvt", function(module, exports) {
"use strict";
var $ccf3f53ff5768437$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $ccf3f53ff5768437$var$switchMapTo(innerObservable, resultSelector) {
    return function(source) {
        return source.lift(new $ccf3f53ff5768437$var$SwitchMapToOperator(innerObservable, resultSelector));
    };
}
module.exports.switchMapTo = $ccf3f53ff5768437$var$switchMapTo;
var $ccf3f53ff5768437$var$SwitchMapToOperator = function() {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ccf3f53ff5768437$var$SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ccf3f53ff5768437$var$SwitchMapToSubscriber = function(_super) {
    $ccf3f53ff5768437$var$__extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function(value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $jziWR.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("ed3uB", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $i46hK = parcelRequire("i46hK");
$8jOUp.Observable.prototype.take = $i46hK.take;

});
parcelRegister("i46hK", function(module, exports) {
$parcel$export(module.exports, "take", () => $d26d79dc93ac51aa$export$b7df5d561049483a, (v) => $d26d79dc93ac51aa$export$b7df5d561049483a = v);
var $d26d79dc93ac51aa$export$b7df5d561049483a;
"use strict";

var $bCu3B = parcelRequire("bCu3B");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $d26d79dc93ac51aa$var$take(count) {
    return $bCu3B.take(count)(this);
}
$d26d79dc93ac51aa$export$b7df5d561049483a = $d26d79dc93ac51aa$var$take;

});
parcelRegister("bCu3B", function(module, exports) {
"use strict";
var $875a8f0336ce44ec$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $4IOSZ = parcelRequire("4IOSZ");

var $cUooy = parcelRequire("cUooy");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $875a8f0336ce44ec$var$take(count) {
    return function(source) {
        if (count === 0) return new $cUooy.EmptyObservable();
        else return source.lift(new $875a8f0336ce44ec$var$TakeOperator(count));
    };
}
module.exports.take = $875a8f0336ce44ec$var$take;
var $875a8f0336ce44ec$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $4IOSZ.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $875a8f0336ce44ec$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $875a8f0336ce44ec$var$TakeSubscriber = function(_super) {
    $875a8f0336ce44ec$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("gqdWZ", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kcVzF = parcelRequire("kcVzF");
$8jOUp.Observable.prototype.takeLast = $kcVzF.takeLast;

});
parcelRegister("kcVzF", function(module, exports) {
$parcel$export(module.exports, "takeLast", () => $eb6196b63342745a$export$1b47ad771ce5af5e, (v) => $eb6196b63342745a$export$1b47ad771ce5af5e = v);
var $eb6196b63342745a$export$1b47ad771ce5af5e;
"use strict";

var $kzAXk = parcelRequire("kzAXk");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $eb6196b63342745a$var$takeLast(count) {
    return $kzAXk.takeLast(count)(this);
}
$eb6196b63342745a$export$1b47ad771ce5af5e = $eb6196b63342745a$var$takeLast;

});


parcelRegister("iNt9j", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $8CeR6 = parcelRequire("8CeR6");
$8jOUp.Observable.prototype.takeUntil = $8CeR6.takeUntil;

});
parcelRegister("8CeR6", function(module, exports) {
$parcel$export(module.exports, "takeUntil", () => $645d6550f34b61bf$export$ac8dfd3a7ad06e80, (v) => $645d6550f34b61bf$export$ac8dfd3a7ad06e80 = v);
var $645d6550f34b61bf$export$ac8dfd3a7ad06e80;
"use strict";

var $kbGrt = parcelRequire("kbGrt");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $645d6550f34b61bf$var$takeUntil(notifier) {
    return $kbGrt.takeUntil(notifier)(this);
}
$645d6550f34b61bf$export$ac8dfd3a7ad06e80 = $645d6550f34b61bf$var$takeUntil;

});
parcelRegister("kbGrt", function(module, exports) {
"use strict";
var $eb25c1df04d4561b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $eb25c1df04d4561b$var$takeUntil(notifier) {
    return function(source) {
        return source.lift(new $eb25c1df04d4561b$var$TakeUntilOperator(notifier));
    };
}
module.exports.takeUntil = $eb25c1df04d4561b$var$takeUntil;
var $eb25c1df04d4561b$var$TakeUntilOperator = function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $eb25c1df04d4561b$var$TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $eb25c1df04d4561b$var$TakeUntilSubscriber = function(_super) {
    $eb25c1df04d4561b$var$__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add($jziWR.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    return TakeUntilSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("gOCL6", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $kv6f2 = parcelRequire("kv6f2");
$8jOUp.Observable.prototype.takeWhile = $kv6f2.takeWhile;

});
parcelRegister("kv6f2", function(module, exports) {
$parcel$export(module.exports, "takeWhile", () => $eecb8b57bbdafaaa$export$9384c7afe4015e42, (v) => $eecb8b57bbdafaaa$export$9384c7afe4015e42 = v);
var $eecb8b57bbdafaaa$export$9384c7afe4015e42;
"use strict";

var $7fvhJ = parcelRequire("7fvhJ");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $eecb8b57bbdafaaa$var$takeWhile(predicate) {
    return $7fvhJ.takeWhile(predicate)(this);
}
$eecb8b57bbdafaaa$export$9384c7afe4015e42 = $eecb8b57bbdafaaa$var$takeWhile;

});
parcelRegister("7fvhJ", function(module, exports) {
"use strict";
var $547233aa94717d8b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $547233aa94717d8b$var$takeWhile(predicate) {
    return function(source) {
        return source.lift(new $547233aa94717d8b$var$TakeWhileOperator(predicate));
    };
}
module.exports.takeWhile = $547233aa94717d8b$var$takeWhile;
var $547233aa94717d8b$var$TakeWhileOperator = function() {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $547233aa94717d8b$var$TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $547233aa94717d8b$var$TakeWhileSubscriber = function(_super) {
    $547233aa94717d8b$var$__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else destination.complete();
    };
    return TakeWhileSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("cWllG", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $dnqoD = parcelRequire("dnqoD");
$8jOUp.Observable.prototype.throttle = $dnqoD.throttle;

});
parcelRegister("dnqoD", function(module, exports) {
$parcel$export(module.exports, "throttle", () => $9bd1e619d1f1db41$export$de363e709c412c8a, (v) => $9bd1e619d1f1db41$export$de363e709c412c8a = v);
var $9bd1e619d1f1db41$export$de363e709c412c8a;
"use strict";

var $g0Y5L = parcelRequire("g0Y5L");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $9bd1e619d1f1db41$var$throttle(durationSelector, config) {
    if (config === void 0) config = $g0Y5L.defaultThrottleConfig;
    return $g0Y5L.throttle(durationSelector, config)(this);
}
$9bd1e619d1f1db41$export$de363e709c412c8a = $9bd1e619d1f1db41$var$throttle;

});
parcelRegister("g0Y5L", function(module, exports) {
"use strict";
var $ba8b426f5179f871$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
module.exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $ba8b426f5179f871$var$throttle(durationSelector, config) {
    if (config === void 0) config = module.exports.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $ba8b426f5179f871$var$ThrottleOperator(durationSelector, config.leading, config.trailing));
    };
}
module.exports.throttle = $ba8b426f5179f871$var$throttle;
var $ba8b426f5179f871$var$ThrottleOperator = function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ba8b426f5179f871$var$ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */ var $ba8b426f5179f871$var$ThrottleSubscriber = function(_super) {
    $ba8b426f5179f871$var$__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        } else {
            var duration = this.tryDurationSelector(value);
            if (duration) this.add(this.throttled = $jziWR.subscribeToResult(this, duration));
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function() {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function() {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("2kDj5", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $czcZY = parcelRequire("czcZY");
$8jOUp.Observable.prototype.throttleTime = $czcZY.throttleTime;

});
parcelRegister("czcZY", function(module, exports) {
$parcel$export(module.exports, "throttleTime", () => $9262d626ea6998da$export$4efe28f192921dd4, (v) => $9262d626ea6998da$export$4efe28f192921dd4 = v);
var $9262d626ea6998da$export$4efe28f192921dd4;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $g0Y5L = parcelRequire("g0Y5L");

var $dz6eQ = parcelRequire("dz6eQ");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $9262d626ea6998da$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    if (config === void 0) config = $g0Y5L.defaultThrottleConfig;
    return $dz6eQ.throttleTime(duration, scheduler, config)(this);
}
$9262d626ea6998da$export$4efe28f192921dd4 = $9262d626ea6998da$var$throttleTime;

});
parcelRegister("dz6eQ", function(module, exports) {
"use strict";
var $9e036215fb4e6c15$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $kESbZ = parcelRequire("kESbZ");

var $g0Y5L = parcelRequire("g0Y5L");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $9e036215fb4e6c15$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    if (config === void 0) config = $g0Y5L.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $9e036215fb4e6c15$var$ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
module.exports.throttleTime = $9e036215fb4e6c15$var$throttleTime;
var $9e036215fb4e6c15$var$ThrottleTimeOperator = function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9e036215fb4e6c15$var$ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9e036215fb4e6c15$var$ThrottleTimeSubscriber = function(_super) {
    $9e036215fb4e6c15$var$__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule($9e036215fb4e6c15$var$dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}($66gCN.Subscriber);
function $9e036215fb4e6c15$var$dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

});



parcelRegister("YasA0", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $c84MS = parcelRequire("c84MS");
$8jOUp.Observable.prototype.timeInterval = $c84MS.timeInterval;

});
parcelRegister("c84MS", function(module, exports) {
$parcel$export(module.exports, "TimeInterval", () => $8d49f20b4906d31b$export$8bb95198b45adaac, (v) => $8d49f20b4906d31b$export$8bb95198b45adaac = v);
$parcel$export(module.exports, "timeInterval", () => $8d49f20b4906d31b$export$1a539c8b2950ab40, (v) => $8d49f20b4906d31b$export$1a539c8b2950ab40 = v);
var $8d49f20b4906d31b$export$8bb95198b45adaac;
var $8d49f20b4906d31b$export$1a539c8b2950ab40;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $jODVt = parcelRequire("jODVt");
$8d49f20b4906d31b$export$8bb95198b45adaac = $jODVt.TimeInterval;
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */ function $8d49f20b4906d31b$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $jODVt.timeInterval(scheduler)(this);
}
$8d49f20b4906d31b$export$1a539c8b2950ab40 = $8d49f20b4906d31b$var$timeInterval;

});
parcelRegister("jODVt", function(module, exports) {
"use strict";
var $e6d1a84866cbf5a3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $kESbZ = parcelRequire("kESbZ");
function $e6d1a84866cbf5a3$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return function(source) {
        return source.lift(new $e6d1a84866cbf5a3$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $e6d1a84866cbf5a3$var$timeInterval;
var $e6d1a84866cbf5a3$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $e6d1a84866cbf5a3$var$TimeInterval;
var $e6d1a84866cbf5a3$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $e6d1a84866cbf5a3$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e6d1a84866cbf5a3$var$TimeIntervalSubscriber = function(_super) {
    $e6d1a84866cbf5a3$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $e6d1a84866cbf5a3$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("l4YVh", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $8hfh4 = parcelRequire("8hfh4");
$8jOUp.Observable.prototype.timeout = $8hfh4.timeout;

});
parcelRegister("8hfh4", function(module, exports) {
$parcel$export(module.exports, "timeout", () => $606bc2705b09595f$export$83e74882c5df8fe1, (v) => $606bc2705b09595f$export$83e74882c5df8fe1 = v);
var $606bc2705b09595f$export$83e74882c5df8fe1;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $b6gR6 = parcelRequire("b6gR6");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $606bc2705b09595f$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $b6gR6.timeout(due, scheduler)(this);
}
$606bc2705b09595f$export$83e74882c5df8fe1 = $606bc2705b09595f$var$timeout;

});
parcelRegister("b6gR6", function(module, exports) {
"use strict";
var $814d5460f00b7e07$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kESbZ = parcelRequire("kESbZ");

var $aElH5 = parcelRequire("aElH5");

var $66gCN = parcelRequire("66gCN");

var $5CVEe = parcelRequire("5CVEe");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $814d5460f00b7e07$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    var absoluteTimeout = $aElH5.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $814d5460f00b7e07$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $5CVEe.TimeoutError()));
    };
}
module.exports.timeout = $814d5460f00b7e07$var$timeout;
var $814d5460f00b7e07$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $814d5460f00b7e07$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $814d5460f00b7e07$var$TimeoutSubscriber = function(_super) {
    $814d5460f00b7e07$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($66gCN.Subscriber);

});
parcelRegister("5CVEe", function(module, exports) {
"use strict";
var $418d380a26faf283$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $418d380a26faf283$var$TimeoutError = function(_super) {
    $418d380a26faf283$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $418d380a26faf283$var$TimeoutError;

});




parcelRegister("bTCk8", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $5Xbe6 = parcelRequire("5Xbe6");
$8jOUp.Observable.prototype.timeoutWith = $5Xbe6.timeoutWith;

});
parcelRegister("5Xbe6", function(module, exports) {
$parcel$export(module.exports, "timeoutWith", () => $455b2bc2cca97625$export$86fe999fba7953f2, (v) => $455b2bc2cca97625$export$86fe999fba7953f2 = v);
var $455b2bc2cca97625$export$86fe999fba7953f2;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $f4G6g = parcelRequire("f4G6g");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $455b2bc2cca97625$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $f4G6g.timeoutWith(due, withObservable, scheduler)(this);
}
$455b2bc2cca97625$export$86fe999fba7953f2 = $455b2bc2cca97625$var$timeoutWith;

});
parcelRegister("f4G6g", function(module, exports) {
"use strict";
var $af97e2e65d51b61a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kESbZ = parcelRequire("kESbZ");

var $aElH5 = parcelRequire("aElH5");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $af97e2e65d51b61a$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return function(source) {
        var absoluteTimeout = $aElH5.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $af97e2e65d51b61a$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $af97e2e65d51b61a$var$timeoutWith;
var $af97e2e65d51b61a$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $af97e2e65d51b61a$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $af97e2e65d51b61a$var$TimeoutWithSubscriber = function(_super) {
    $af97e2e65d51b61a$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($jziWR.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("jWTKA", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $hom32 = parcelRequire("hom32");
$8jOUp.Observable.prototype.timestamp = $hom32.timestamp;

});
parcelRegister("hom32", function(module, exports) {
$parcel$export(module.exports, "timestamp", () => $ca95c7d252236dd5$export$fc00ee57782020aa, (v) => $ca95c7d252236dd5$export$fc00ee57782020aa = v);
var $ca95c7d252236dd5$export$fc00ee57782020aa;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $hBG9v = parcelRequire("hBG9v");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function $ca95c7d252236dd5$var$timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $hBG9v.timestamp(scheduler)(this);
}
$ca95c7d252236dd5$export$fc00ee57782020aa = $ca95c7d252236dd5$var$timestamp;

});
parcelRegister("hBG9v", function(module, exports) {
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $bP9Wc = parcelRequire("bP9Wc");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $kESbZ.async;
    return $bP9Wc.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});



parcelRegister("8fjnZ", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $fqLyq = parcelRequire("fqLyq");
$8jOUp.Observable.prototype.toArray = $fqLyq.toArray;

});
parcelRegister("fqLyq", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $b3be2c032e39883b$export$45b10814cc054894, (v) => $b3be2c032e39883b$export$45b10814cc054894 = v);
var $b3be2c032e39883b$export$45b10814cc054894;
"use strict";

var $cZJcN = parcelRequire("cZJcN");
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */ function $b3be2c032e39883b$var$toArray() {
    return $cZJcN.toArray()(this);
}
$b3be2c032e39883b$export$45b10814cc054894 = $b3be2c032e39883b$var$toArray;

});
parcelRegister("cZJcN", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $975e3f670ede6e51$export$45b10814cc054894, (v) => $975e3f670ede6e51$export$45b10814cc054894 = v);
var $975e3f670ede6e51$export$45b10814cc054894;
"use strict";

var $de1nH = parcelRequire("de1nH");
function $975e3f670ede6e51$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $975e3f670ede6e51$var$toArray() {
    return $de1nH.reduce($975e3f670ede6e51$var$toArrayReducer, []);
}
$975e3f670ede6e51$export$45b10814cc054894 = $975e3f670ede6e51$var$toArray;

});



parcelRegister("7VLNH", function(module, exports) {
// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.

});

parcelRegister("8O0cE", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $ctGcW = parcelRequire("ctGcW");
$8jOUp.Observable.prototype.window = $ctGcW.window;

});
parcelRegister("ctGcW", function(module, exports) {
$parcel$export(module.exports, "window", () => $9158ef0de55d7e42$export$8291e5b88f90ce4, (v) => $9158ef0de55d7e42$export$8291e5b88f90ce4 = v);
var $9158ef0de55d7e42$export$8291e5b88f90ce4;
"use strict";

var $88oef = parcelRequire("88oef");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function $9158ef0de55d7e42$var$window(windowBoundaries) {
    return $88oef.window(windowBoundaries)(this);
}
$9158ef0de55d7e42$export$8291e5b88f90ce4 = $9158ef0de55d7e42$var$window;

});
parcelRegister("88oef", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add($jziWR.subscribeToResult(windowSubscriber, this.windowBoundaries));
        return sourceSubscription;
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var WindowSubscriber = function(_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new $gJqoA.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new $gJqoA.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("5ZgfI", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $8uO6X = parcelRequire("8uO6X");
$8jOUp.Observable.prototype.windowCount = $8uO6X.windowCount;

});
parcelRegister("8uO6X", function(module, exports) {
$parcel$export(module.exports, "windowCount", () => $62f7ff2349c2e96a$export$f3a19e933f377396, (v) => $62f7ff2349c2e96a$export$f3a19e933f377396 = v);
var $62f7ff2349c2e96a$export$f3a19e933f377396;
"use strict";

var $9HqMq = parcelRequire("9HqMq");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $62f7ff2349c2e96a$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return $9HqMq.windowCount(windowSize, startWindowEvery)(this);
}
$62f7ff2349c2e96a$export$f3a19e933f377396 = $62f7ff2349c2e96a$var$windowCount;

});
parcelRegister("9HqMq", function(module, exports) {
"use strict";
var $70fce7315476c7ee$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $66gCN = parcelRequire("66gCN");

var $gJqoA = parcelRequire("gJqoA");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $70fce7315476c7ee$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $70fce7315476c7ee$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $70fce7315476c7ee$var$windowCount;
var $70fce7315476c7ee$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $70fce7315476c7ee$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $70fce7315476c7ee$var$WindowCountSubscriber = function(_super) {
    $70fce7315476c7ee$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $gJqoA.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $gJqoA.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($66gCN.Subscriber);

});



parcelRegister("8ia4q", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $6rzYr = parcelRequire("6rzYr");
$8jOUp.Observable.prototype.windowTime = $6rzYr.windowTime;

});
parcelRegister("6rzYr", function(module, exports) {
$parcel$export(module.exports, "windowTime", () => $4b112b55430fc11d$export$1284415effa79ee0, (v) => $4b112b55430fc11d$export$1284415effa79ee0 = v);
var $4b112b55430fc11d$export$1284415effa79ee0;
"use strict";

var $kESbZ = parcelRequire("kESbZ");

var $hHpuK = parcelRequire("hHpuK");

var $86ewR = parcelRequire("86ewR");

var $d0dcb = parcelRequire("d0dcb");
function $4b112b55430fc11d$var$windowTime(windowTimeSpan) {
    var scheduler = $kESbZ.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($86ewR.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($86ewR.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($hHpuK.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($86ewR.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($hHpuK.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return $d0dcb.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
$4b112b55430fc11d$export$1284415effa79ee0 = $4b112b55430fc11d$var$windowTime;

});
parcelRegister("d0dcb", function(module, exports) {
"use strict";
var $977582cd3b5048a0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $kESbZ = parcelRequire("kESbZ");

var $66gCN = parcelRequire("66gCN");

var $hHpuK = parcelRequire("hHpuK");

var $86ewR = parcelRequire("86ewR");
function $977582cd3b5048a0$var$windowTime(windowTimeSpan) {
    var scheduler = $kESbZ.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($86ewR.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($86ewR.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($hHpuK.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($86ewR.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($hHpuK.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $977582cd3b5048a0$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $977582cd3b5048a0$var$windowTime;
var $977582cd3b5048a0$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $977582cd3b5048a0$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $977582cd3b5048a0$var$CountedSubject = function(_super) {
    $977582cd3b5048a0$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($gJqoA.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $977582cd3b5048a0$var$WindowTimeSubscriber = function(_super) {
    $977582cd3b5048a0$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($977582cd3b5048a0$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($977582cd3b5048a0$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($977582cd3b5048a0$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $977582cd3b5048a0$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($66gCN.Subscriber);
function $977582cd3b5048a0$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $977582cd3b5048a0$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($977582cd3b5048a0$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $977582cd3b5048a0$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});



parcelRegister("it5lw", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $jZ2Z1 = parcelRequire("jZ2Z1");
$8jOUp.Observable.prototype.windowToggle = $jZ2Z1.windowToggle;

});
parcelRegister("jZ2Z1", function(module, exports) {
$parcel$export(module.exports, "windowToggle", () => $e8c60741de6740f1$export$3182be990e0eeaad, (v) => $e8c60741de6740f1$export$3182be990e0eeaad = v);
var $e8c60741de6740f1$export$3182be990e0eeaad;
"use strict";

var $hDgkp = parcelRequire("hDgkp");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $e8c60741de6740f1$var$windowToggle(openings, closingSelector) {
    return $hDgkp.windowToggle(openings, closingSelector)(this);
}
$e8c60741de6740f1$export$3182be990e0eeaad = $e8c60741de6740f1$var$windowToggle;

});
parcelRegister("hDgkp", function(module, exports) {
"use strict";
var $cd62bea423845c70$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $aAAtt = parcelRequire("aAAtt");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $cd62bea423845c70$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $cd62bea423845c70$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $cd62bea423845c70$var$windowToggle;
var $cd62bea423845c70$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cd62bea423845c70$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cd62bea423845c70$var$WindowToggleSubscriber = function(_super) {
    $cd62bea423845c70$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $jziWR.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $cxrX4.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $2afHm.errorObject) return this.error($2afHm.errorObject.e);
            else {
                var window_1 = new $gJqoA.Subject();
                var subscription = new $aAAtt.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $jziWR.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("jZheq", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $k1Djo = parcelRequire("k1Djo");
$8jOUp.Observable.prototype.windowWhen = $k1Djo.windowWhen;

});
parcelRegister("k1Djo", function(module, exports) {
$parcel$export(module.exports, "windowWhen", () => $e94265233351cf02$export$6a5dea797879f644, (v) => $e94265233351cf02$export$6a5dea797879f644 = v);
var $e94265233351cf02$export$6a5dea797879f644;
"use strict";

var $8HLqu = parcelRequire("8HLqu");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $e94265233351cf02$var$windowWhen(closingSelector) {
    return $8HLqu.windowWhen(closingSelector)(this);
}
$e94265233351cf02$export$6a5dea797879f644 = $e94265233351cf02$var$windowWhen;

});
parcelRegister("8HLqu", function(module, exports) {
"use strict";
var $656720bc11f9366b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $cxrX4 = parcelRequire("cxrX4");

var $2afHm = parcelRequire("2afHm");

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $656720bc11f9366b$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $656720bc11f9366b$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $656720bc11f9366b$var$windowWhen;
var $656720bc11f9366b$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $656720bc11f9366b$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $656720bc11f9366b$var$WindowSubscriber = function(_super) {
    $656720bc11f9366b$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $gJqoA.Subject();
        this.destination.next(window);
        var closingNotifier = $cxrX4.tryCatch(this.closingSelector)();
        if (closingNotifier === $2afHm.errorObject) {
            var err = $2afHm.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $jziWR.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("8GDmx", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $jqF9E = parcelRequire("jqF9E");
$8jOUp.Observable.prototype.withLatestFrom = $jqF9E.withLatestFrom;

});
parcelRegister("jqF9E", function(module, exports) {
$parcel$export(module.exports, "withLatestFrom", () => $e2505e7b32627408$export$d449030e5c10edf7, (v) => $e2505e7b32627408$export$d449030e5c10edf7 = v);
var $e2505e7b32627408$export$d449030e5c10edf7;
"use strict";

var $229RS = parcelRequire("229RS");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $e2505e7b32627408$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return $229RS.withLatestFrom.apply(void 0, args)(this);
}
$e2505e7b32627408$export$d449030e5c10edf7 = $e2505e7b32627408$var$withLatestFrom;

});
parcelRegister("229RS", function(module, exports) {
"use strict";
var $17b36c414c48da42$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2L5Gq = parcelRequire("2L5Gq");

var $jziWR = parcelRequire("jziWR");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $17b36c414c48da42$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === 'function') project = args.pop();
        var observables = args;
        return source.lift(new $17b36c414c48da42$var$WithLatestFromOperator(observables, project));
    };
}
module.exports.withLatestFrom = $17b36c414c48da42$var$withLatestFrom;
var $17b36c414c48da42$var$WithLatestFromOperator = function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $17b36c414c48da42$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $17b36c414c48da42$var$WithLatestFromSubscriber = function(_super) {
    $17b36c414c48da42$var$__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for(var i = 0; i < len; i++)this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            this.add($jziWR.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}($2L5Gq.OuterSubscriber);

});



parcelRegister("Y8Pfr", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $4DRRP = parcelRequire("4DRRP");
$8jOUp.Observable.prototype.zip = $4DRRP.zipProto;

});
parcelRegister("4DRRP", function(module, exports) {
$parcel$export(module.exports, "zipProto", () => $361496dec97d54f4$export$ad1b5245dc53c655, (v) => $361496dec97d54f4$export$ad1b5245dc53c655 = v);
var $361496dec97d54f4$export$ad1b5245dc53c655;
"use strict";

var $2mE2X = parcelRequire("2mE2X");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $361496dec97d54f4$var$zipProto() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $2mE2X.zip.apply(void 0, observables)(this);
}
$361496dec97d54f4$export$ad1b5245dc53c655 = $361496dec97d54f4$var$zipProto;

});


parcelRegister("j54Uz", function(module, exports) {
"use strict";

var $8jOUp = parcelRequire("8jOUp");

var $ivOQm = parcelRequire("ivOQm");
$8jOUp.Observable.prototype.zipAll = $ivOQm.zipAll;

});
parcelRegister("ivOQm", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $d7a28fbbd9ce12e7$export$adddb6a2fa3864e9, (v) => $d7a28fbbd9ce12e7$export$adddb6a2fa3864e9 = v);
var $d7a28fbbd9ce12e7$export$adddb6a2fa3864e9;
"use strict";

var $dEwdi = parcelRequire("dEwdi");
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */ function $d7a28fbbd9ce12e7$var$zipAll(project) {
    return $dEwdi.zipAll(project)(this);
}
$d7a28fbbd9ce12e7$export$adddb6a2fa3864e9 = $d7a28fbbd9ce12e7$var$zipAll;

});
parcelRegister("dEwdi", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $9f07ffba03faa98a$export$adddb6a2fa3864e9, (v) => $9f07ffba03faa98a$export$adddb6a2fa3864e9 = v);
var $9f07ffba03faa98a$export$adddb6a2fa3864e9;
"use strict";

var $2mE2X = parcelRequire("2mE2X");
function $9f07ffba03faa98a$var$zipAll(project) {
    return function(source) {
        return source.lift(new $2mE2X.ZipOperator(project));
    };
}
$9f07ffba03faa98a$export$adddb6a2fa3864e9 = $9f07ffba03faa98a$var$zipAll;

});



parcelRegister("jSFdI", function(module, exports) {
"use strict";
var $e79308eb69f5e47f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $fTcsX = parcelRequire("fTcsX");

var $8UQpU = parcelRequire("8UQpU");

var $8HqAR = parcelRequire("8HqAR");

var $81B85 = parcelRequire("81B85");

var $3OnTQ = parcelRequire("3OnTQ");
var $e79308eb69f5e47f$var$defaultMaxFrame = 750;
var $e79308eb69f5e47f$var$TestScheduler = function(_super) {
    $e79308eb69f5e47f$var$__extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, $3OnTQ.VirtualAction, $e79308eb69f5e47f$var$defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function(marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) throw new Error('marble diagram for time should have a completion marker "|"');
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function(marbles, values, error) {
        if (marbles.indexOf('^') !== -1) throw new Error('cold observable cannot have subscription offset "^"');
        if (marbles.indexOf('!') !== -1) throw new Error('cold observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new $8UQpU.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function(marbles, values, error) {
        if (marbles.indexOf('!') !== -1) throw new Error('hot observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new $8HqAR.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function(observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function(value) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $fTcsX.Notification.createNext(value)
            });
        }, function(err) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $fTcsX.Notification.createError(err)
            });
        }, function() {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $fTcsX.Notification.createComplete()
            });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function(observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) unsubscriptionMarbles = null;
        var actual = [];
        var flushTest = {
            actual: actual,
            ready: false
        };
        var unsubscriptionFrame = TestScheduler.parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function() {
            subscription = observable.subscribe(function(x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof $8jOUp.Observable) value = _this.materializeInnerObservable(value, _this.frame);
                actual.push({
                    frame: _this.frame,
                    notification: $fTcsX.Notification.createNext(value)
                });
            }, function(err) {
                actual.push({
                    frame: _this.frame,
                    notification: $fTcsX.Notification.createError(err)
                });
            }, function() {
                actual.push({
                    frame: _this.frame,
                    notification: $fTcsX.Notification.createComplete()
                });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) this.schedule(function() {
            return subscription.unsubscribe();
        }, unsubscriptionFrame);
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function(actualSubscriptionLogs) {
        var flushTest = {
            actual: actualSubscriptionLogs,
            ready: false
        };
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles) {
                var marblesArray = typeof marbles === 'string' ? [
                    marbles
                ] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function(marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function() {
        var hotObservables = this.hotObservables;
        while(hotObservables.length > 0)hotObservables.shift().setup();
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function(test) {
            return test.ready;
        });
        while(readyFlushTests.length > 0){
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function(marbles) {
        if (typeof marbles !== 'string') return new $81B85.SubscriptionLog(Number.POSITIVE_INFINITY);
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error("there can only be '^' and '!' markers in a subscription marble diagram. Found instead '" + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) return new $81B85.SubscriptionLog(subscriptionFrame);
        else return new $81B85.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
    };
    TestScheduler.parseMarbles = function(marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) materializeInnerObservables = false;
        if (marbles.indexOf('!') !== -1) throw new Error('conventional marble diagrams cannot have the unsubscription marker "!"');
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : subIndex * -this.frameTimeFactor;
        var getValue = typeof values !== 'object' ? function(x) {
            return x;
        } : function(x) {
            // Support Observable-of-Observables
            if (materializeInnerObservables && values[x] instanceof $8UQpU.ColdObservable) return values[x].messages;
            return values[x];
        };
        var groupStart = -1;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = $fTcsX.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = $fTcsX.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = $fTcsX.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) testMessages.push({
                frame: groupStart > -1 ? groupStart : frame,
                notification: notification
            });
        }
        return testMessages;
    };
    return TestScheduler;
}($3OnTQ.VirtualTimeScheduler);
module.exports.TestScheduler = $e79308eb69f5e47f$var$TestScheduler;

});
parcelRegister("8UQpU", function(module, exports) {
"use strict";
var $67dc3693c9f4c6dd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8jOUp = parcelRequire("8jOUp");

var $aAAtt = parcelRequire("aAAtt");

var $lDzLw = parcelRequire("lDzLw");

var $7Bi8t = parcelRequire("7Bi8t");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $67dc3693c9f4c6dd$var$ColdObservable = function(_super) {
    $67dc3693c9f4c6dd$var$__extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function(subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new $aAAtt.Subscription(function() {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function(subscriber) {
        var messagesLength = this.messages.length;
        for(var i = 0; i < messagesLength; i++){
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function(_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, {
                message: message,
                subscriber: subscriber
            }));
        }
    };
    return ColdObservable;
}($8jOUp.Observable);
module.exports.ColdObservable = $67dc3693c9f4c6dd$var$ColdObservable;
$7Bi8t.applyMixins($67dc3693c9f4c6dd$var$ColdObservable, [
    $lDzLw.SubscriptionLoggable
]);

});
parcelRegister("lDzLw", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLoggable", () => $fc08fbc5be63c8a4$export$b07abd1cdf2201bb, (v) => $fc08fbc5be63c8a4$export$b07abd1cdf2201bb = v);
var $fc08fbc5be63c8a4$export$b07abd1cdf2201bb;
"use strict";

var $81B85 = parcelRequire("81B85");
var $fc08fbc5be63c8a4$var$SubscriptionLoggable = function() {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function() {
        this.subscriptions.push(new $81B85.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function(index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new $81B85.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}();
$fc08fbc5be63c8a4$export$b07abd1cdf2201bb = $fc08fbc5be63c8a4$var$SubscriptionLoggable;

});
parcelRegister("81B85", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLog", () => $5d7b37dec5db20d1$export$63bb55968f4c7c1e, (v) => $5d7b37dec5db20d1$export$63bb55968f4c7c1e = v);
var $5d7b37dec5db20d1$export$63bb55968f4c7c1e;
"use strict";
var $5d7b37dec5db20d1$var$SubscriptionLog = function() {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) unsubscribedFrame = Number.POSITIVE_INFINITY;
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}();
$5d7b37dec5db20d1$export$63bb55968f4c7c1e = $5d7b37dec5db20d1$var$SubscriptionLog;

});


parcelRegister("7Bi8t", function(module, exports) {
$parcel$export(module.exports, "applyMixins", () => $588a0e7973e9dcb5$export$6ccb92ce135089b4, (v) => $588a0e7973e9dcb5$export$6ccb92ce135089b4 = v);
var $588a0e7973e9dcb5$export$6ccb92ce135089b4;
"use strict";
function $588a0e7973e9dcb5$var$applyMixins(derivedCtor, baseCtors) {
    for(var i = 0, len = baseCtors.length; i < len; i++){
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for(var j = 0, len2 = propertyKeys.length; j < len2; j++){
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
$588a0e7973e9dcb5$export$6ccb92ce135089b4 = $588a0e7973e9dcb5$var$applyMixins;

});


parcelRegister("8HqAR", function(module, exports) {
"use strict";
var $6556f7d079f21b8f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gJqoA = parcelRequire("gJqoA");

var $aAAtt = parcelRequire("aAAtt");

var $lDzLw = parcelRequire("lDzLw");

var $7Bi8t = parcelRequire("7Bi8t");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6556f7d079f21b8f$var$HotObservable = function(_super) {
    $6556f7d079f21b8f$var$__extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function(subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new $aAAtt.Subscription(function() {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function() {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */ for(var i = 0; i < messagesLength; i++)(function() {
            var message = subject.messages[i];
            /* tslint:enable */ subject.scheduler.schedule(function() {
                message.notification.observe(subject);
            }, message.frame);
        })();
    };
    return HotObservable;
}($gJqoA.Subject);
module.exports.HotObservable = $6556f7d079f21b8f$var$HotObservable;
$7Bi8t.applyMixins($6556f7d079f21b8f$var$HotObservable, [
    $lDzLw.SubscriptionLoggable
]);

});

parcelRegister("3OnTQ", function(module, exports) {
"use strict";
var $2c68949306a53d46$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1GOJd = parcelRequire("1GOJd");

var $5aY3c = parcelRequire("5aY3c");
var $2c68949306a53d46$var$VirtualTimeScheduler = function(_super) {
    $2c68949306a53d46$var$__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) SchedulerAction = $2c68949306a53d46$var$VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        _super.call(this, SchedulerAction, function() {
            return _this.frame;
        });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */ VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions.shift()) && (this.frame = action.delay) <= maxFrames){
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}($5aY3c.AsyncScheduler);
module.exports.VirtualTimeScheduler = $2c68949306a53d46$var$VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c68949306a53d46$var$VirtualAction = function(_super) {
    $2c68949306a53d46$var$__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}($1GOJd.AsyncAction);
module.exports.VirtualAction = $2c68949306a53d46$var$VirtualAction;

});


parcelRegister("h6Y6J", function(module, exports) {
$parcel$export(module.exports, "animationFrame", () => $c7519f51c8b9cdf7$export$1402cba6a733f33a, (v) => $c7519f51c8b9cdf7$export$1402cba6a733f33a = v);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */ var $c7519f51c8b9cdf7$export$1402cba6a733f33a;
"use strict";

var $5OSjY = parcelRequire("5OSjY");

var $1RqhD = parcelRequire("1RqhD");
$c7519f51c8b9cdf7$export$1402cba6a733f33a = new $1RqhD.AnimationFrameScheduler($5OSjY.AnimationFrameAction);

});
parcelRegister("5OSjY", function(module, exports) {
"use strict";
var $43cbc24f03b37795$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1GOJd = parcelRequire("1GOJd");

var $fP8Sh = parcelRequire("fP8Sh");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $43cbc24f03b37795$var$AnimationFrameAction = function(_super) {
    $43cbc24f03b37795$var$__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = $fP8Sh.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            $fP8Sh.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}($1GOJd.AsyncAction);
module.exports.AnimationFrameAction = $43cbc24f03b37795$var$AnimationFrameAction;

});
parcelRegister("fP8Sh", function(module, exports) {
$parcel$export(module.exports, "AnimationFrame", () => $b85280b43f007cb4$export$1f3d5b43727c648a, (v) => $b85280b43f007cb4$export$1f3d5b43727c648a = v);
var $b85280b43f007cb4$export$5e49294fc1f79cc3;
var $b85280b43f007cb4$export$1f3d5b43727c648a;
"use strict";

var $a5Mzo = parcelRequire("a5Mzo");
var $b85280b43f007cb4$var$RequestAnimationFrameDefinition = function() {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        } else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        } else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        } else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        } else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        } else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function(cb) {
                return root.setTimeout(cb, 1000 / 60);
            };
        }
    }
    return RequestAnimationFrameDefinition;
}();
$b85280b43f007cb4$export$5e49294fc1f79cc3 = $b85280b43f007cb4$var$RequestAnimationFrameDefinition;
$b85280b43f007cb4$export$1f3d5b43727c648a = new $b85280b43f007cb4$var$RequestAnimationFrameDefinition($a5Mzo.root);

});


parcelRegister("1RqhD", function(module, exports) {
"use strict";
var $15af2100187736e6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5aY3c = parcelRequire("5aY3c");
var $15af2100187736e6$var$AnimationFrameScheduler = function(_super) {
    $15af2100187736e6$var$__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}($5aY3c.AsyncScheduler);
module.exports.AnimationFrameScheduler = $15af2100187736e6$var$AnimationFrameScheduler;

});


parcelRegister("gnOql", function(module, exports) {
$parcel$export(module.exports, "audit", () => $bed5e8718f2b11e4$export$d779b02e6b68c3e8, (v) => $bed5e8718f2b11e4$export$d779b02e6b68c3e8 = v);
$parcel$export(module.exports, "auditTime", () => $bed5e8718f2b11e4$export$719c70722b10e5ff, (v) => $bed5e8718f2b11e4$export$719c70722b10e5ff = v);
$parcel$export(module.exports, "buffer", () => $bed5e8718f2b11e4$export$ab1029bcae9ddb4a, (v) => $bed5e8718f2b11e4$export$ab1029bcae9ddb4a = v);
$parcel$export(module.exports, "bufferCount", () => $bed5e8718f2b11e4$export$8916d2c8119541bb, (v) => $bed5e8718f2b11e4$export$8916d2c8119541bb = v);
$parcel$export(module.exports, "bufferTime", () => $bed5e8718f2b11e4$export$d6b40c95035461c7, (v) => $bed5e8718f2b11e4$export$d6b40c95035461c7 = v);
$parcel$export(module.exports, "bufferToggle", () => $bed5e8718f2b11e4$export$91115bdd8709945f, (v) => $bed5e8718f2b11e4$export$91115bdd8709945f = v);
$parcel$export(module.exports, "bufferWhen", () => $bed5e8718f2b11e4$export$9e55760d3282e08c, (v) => $bed5e8718f2b11e4$export$9e55760d3282e08c = v);
$parcel$export(module.exports, "catchError", () => $bed5e8718f2b11e4$export$3dede90624df3ba9, (v) => $bed5e8718f2b11e4$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "combineAll", () => $bed5e8718f2b11e4$export$29ae691b7de52fe3, (v) => $bed5e8718f2b11e4$export$29ae691b7de52fe3 = v);
$parcel$export(module.exports, "combineLatest", () => $bed5e8718f2b11e4$export$77fa7d86f5204e8a, (v) => $bed5e8718f2b11e4$export$77fa7d86f5204e8a = v);
$parcel$export(module.exports, "concat", () => $bed5e8718f2b11e4$export$ee1b3e54f0441b22, (v) => $bed5e8718f2b11e4$export$ee1b3e54f0441b22 = v);
$parcel$export(module.exports, "concatAll", () => $bed5e8718f2b11e4$export$b314777ae20abca9, (v) => $bed5e8718f2b11e4$export$b314777ae20abca9 = v);
$parcel$export(module.exports, "concatMap", () => $bed5e8718f2b11e4$export$c28c8388be0ab31a, (v) => $bed5e8718f2b11e4$export$c28c8388be0ab31a = v);
$parcel$export(module.exports, "concatMapTo", () => $bed5e8718f2b11e4$export$82fbd7a2841d2484, (v) => $bed5e8718f2b11e4$export$82fbd7a2841d2484 = v);
$parcel$export(module.exports, "count", () => $bed5e8718f2b11e4$export$85b9a36db797e02b, (v) => $bed5e8718f2b11e4$export$85b9a36db797e02b = v);
$parcel$export(module.exports, "debounce", () => $bed5e8718f2b11e4$export$61fc7d43ac8f84b0, (v) => $bed5e8718f2b11e4$export$61fc7d43ac8f84b0 = v);
$parcel$export(module.exports, "debounceTime", () => $bed5e8718f2b11e4$export$7843a4469d64c07e, (v) => $bed5e8718f2b11e4$export$7843a4469d64c07e = v);
$parcel$export(module.exports, "defaultIfEmpty", () => $bed5e8718f2b11e4$export$e4ca6d7b7a6dcf9b, (v) => $bed5e8718f2b11e4$export$e4ca6d7b7a6dcf9b = v);
$parcel$export(module.exports, "delay", () => $bed5e8718f2b11e4$export$1391212d75b2ee65, (v) => $bed5e8718f2b11e4$export$1391212d75b2ee65 = v);
$parcel$export(module.exports, "delayWhen", () => $bed5e8718f2b11e4$export$286ca829307725c9, (v) => $bed5e8718f2b11e4$export$286ca829307725c9 = v);
$parcel$export(module.exports, "dematerialize", () => $bed5e8718f2b11e4$export$ab9a5985b741fa7a, (v) => $bed5e8718f2b11e4$export$ab9a5985b741fa7a = v);
$parcel$export(module.exports, "distinct", () => $bed5e8718f2b11e4$export$983a3b5fb2f7202e, (v) => $bed5e8718f2b11e4$export$983a3b5fb2f7202e = v);
$parcel$export(module.exports, "distinctUntilChanged", () => $bed5e8718f2b11e4$export$779c5fb865a0172e, (v) => $bed5e8718f2b11e4$export$779c5fb865a0172e = v);
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $bed5e8718f2b11e4$export$571da16e28367bde, (v) => $bed5e8718f2b11e4$export$571da16e28367bde = v);
$parcel$export(module.exports, "elementAt", () => $bed5e8718f2b11e4$export$91d69c7761a17bbc, (v) => $bed5e8718f2b11e4$export$91d69c7761a17bbc = v);
$parcel$export(module.exports, "every", () => $bed5e8718f2b11e4$export$7ecc1a3b11b57dab, (v) => $bed5e8718f2b11e4$export$7ecc1a3b11b57dab = v);
$parcel$export(module.exports, "exhaust", () => $bed5e8718f2b11e4$export$31039f1fbd797b9c, (v) => $bed5e8718f2b11e4$export$31039f1fbd797b9c = v);
$parcel$export(module.exports, "exhaustMap", () => $bed5e8718f2b11e4$export$d70d492cd31004c0, (v) => $bed5e8718f2b11e4$export$d70d492cd31004c0 = v);
$parcel$export(module.exports, "expand", () => $bed5e8718f2b11e4$export$9f77e0932fb78f72, (v) => $bed5e8718f2b11e4$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "filter", () => $bed5e8718f2b11e4$export$3dea766d36a8935f, (v) => $bed5e8718f2b11e4$export$3dea766d36a8935f = v);
$parcel$export(module.exports, "finalize", () => $bed5e8718f2b11e4$export$578723aef62d92f5, (v) => $bed5e8718f2b11e4$export$578723aef62d92f5 = v);
$parcel$export(module.exports, "find", () => $bed5e8718f2b11e4$export$71aa6c912b956294, (v) => $bed5e8718f2b11e4$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "findIndex", () => $bed5e8718f2b11e4$export$de3a4d4a0d731119, (v) => $bed5e8718f2b11e4$export$de3a4d4a0d731119 = v);
$parcel$export(module.exports, "first", () => $bed5e8718f2b11e4$export$43128fadae87b74a, (v) => $bed5e8718f2b11e4$export$43128fadae87b74a = v);
$parcel$export(module.exports, "groupBy", () => $bed5e8718f2b11e4$export$3f063810d7bf01bd, (v) => $bed5e8718f2b11e4$export$3f063810d7bf01bd = v);
$parcel$export(module.exports, "ignoreElements", () => $bed5e8718f2b11e4$export$6953b97c7d866605, (v) => $bed5e8718f2b11e4$export$6953b97c7d866605 = v);
$parcel$export(module.exports, "isEmpty", () => $bed5e8718f2b11e4$export$dd1bc94b04021eeb, (v) => $bed5e8718f2b11e4$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "last", () => $bed5e8718f2b11e4$export$4c7897fafd92b108, (v) => $bed5e8718f2b11e4$export$4c7897fafd92b108 = v);
$parcel$export(module.exports, "map", () => $bed5e8718f2b11e4$export$871de8747c9eaa88, (v) => $bed5e8718f2b11e4$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mapTo", () => $bed5e8718f2b11e4$export$e0eaf3a86c03b2ad, (v) => $bed5e8718f2b11e4$export$e0eaf3a86c03b2ad = v);
$parcel$export(module.exports, "materialize", () => $bed5e8718f2b11e4$export$76dbd6ffd832405d, (v) => $bed5e8718f2b11e4$export$76dbd6ffd832405d = v);
$parcel$export(module.exports, "max", () => $bed5e8718f2b11e4$export$8960430cfd85939f, (v) => $bed5e8718f2b11e4$export$8960430cfd85939f = v);
$parcel$export(module.exports, "merge", () => $bed5e8718f2b11e4$export$4950aa0f605343fb, (v) => $bed5e8718f2b11e4$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "mergeAll", () => $bed5e8718f2b11e4$export$18aef43295bbe906, (v) => $bed5e8718f2b11e4$export$18aef43295bbe906 = v);
$parcel$export(module.exports, "mergeMap", () => $bed5e8718f2b11e4$export$6b9f6c0d32c093f9, (v) => $bed5e8718f2b11e4$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "flatMap", () => $bed5e8718f2b11e4$export$5b8affa63fc6df16, (v) => $bed5e8718f2b11e4$export$5b8affa63fc6df16 = v);
$parcel$export(module.exports, "mergeMapTo", () => $bed5e8718f2b11e4$export$bd7cfc9a42b8a412, (v) => $bed5e8718f2b11e4$export$bd7cfc9a42b8a412 = v);
$parcel$export(module.exports, "mergeScan", () => $bed5e8718f2b11e4$export$c1fc905202bced53, (v) => $bed5e8718f2b11e4$export$c1fc905202bced53 = v);
$parcel$export(module.exports, "min", () => $bed5e8718f2b11e4$export$96ec731ed4dcb222, (v) => $bed5e8718f2b11e4$export$96ec731ed4dcb222 = v);
$parcel$export(module.exports, "multicast", () => $bed5e8718f2b11e4$export$1364843af8d5a963, (v) => $bed5e8718f2b11e4$export$1364843af8d5a963 = v);
$parcel$export(module.exports, "observeOn", () => $bed5e8718f2b11e4$export$9007f49c319d1ac7, (v) => $bed5e8718f2b11e4$export$9007f49c319d1ac7 = v);
$parcel$export(module.exports, "onErrorResumeNext", () => $bed5e8718f2b11e4$export$5fba66d61591f42, (v) => $bed5e8718f2b11e4$export$5fba66d61591f42 = v);
$parcel$export(module.exports, "pairwise", () => $bed5e8718f2b11e4$export$8f9d79d42bff1aac, (v) => $bed5e8718f2b11e4$export$8f9d79d42bff1aac = v);
$parcel$export(module.exports, "partition", () => $bed5e8718f2b11e4$export$b29f828819edca8d, (v) => $bed5e8718f2b11e4$export$b29f828819edca8d = v);
$parcel$export(module.exports, "pluck", () => $bed5e8718f2b11e4$export$c44985b87d605eff, (v) => $bed5e8718f2b11e4$export$c44985b87d605eff = v);
$parcel$export(module.exports, "publish", () => $bed5e8718f2b11e4$export$89b472e03be495df, (v) => $bed5e8718f2b11e4$export$89b472e03be495df = v);
$parcel$export(module.exports, "publishBehavior", () => $bed5e8718f2b11e4$export$16ae46fda9567053, (v) => $bed5e8718f2b11e4$export$16ae46fda9567053 = v);
$parcel$export(module.exports, "publishLast", () => $bed5e8718f2b11e4$export$42d9b6b38c68d989, (v) => $bed5e8718f2b11e4$export$42d9b6b38c68d989 = v);
$parcel$export(module.exports, "publishReplay", () => $bed5e8718f2b11e4$export$1f3342bf81d92d52, (v) => $bed5e8718f2b11e4$export$1f3342bf81d92d52 = v);
$parcel$export(module.exports, "race", () => $bed5e8718f2b11e4$export$236c05de452bec2, (v) => $bed5e8718f2b11e4$export$236c05de452bec2 = v);
$parcel$export(module.exports, "reduce", () => $bed5e8718f2b11e4$export$533b26079ad0b4b, (v) => $bed5e8718f2b11e4$export$533b26079ad0b4b = v);
$parcel$export(module.exports, "repeat", () => $bed5e8718f2b11e4$export$76d90c956114f2c2, (v) => $bed5e8718f2b11e4$export$76d90c956114f2c2 = v);
$parcel$export(module.exports, "repeatWhen", () => $bed5e8718f2b11e4$export$b39ac5b4ffd1415a, (v) => $bed5e8718f2b11e4$export$b39ac5b4ffd1415a = v);
$parcel$export(module.exports, "retry", () => $bed5e8718f2b11e4$export$9369b12211e1fce4, (v) => $bed5e8718f2b11e4$export$9369b12211e1fce4 = v);
$parcel$export(module.exports, "retryWhen", () => $bed5e8718f2b11e4$export$1281551253cfee02, (v) => $bed5e8718f2b11e4$export$1281551253cfee02 = v);
$parcel$export(module.exports, "refCount", () => $bed5e8718f2b11e4$export$18d0766d894cba0c, (v) => $bed5e8718f2b11e4$export$18d0766d894cba0c = v);
$parcel$export(module.exports, "sample", () => $bed5e8718f2b11e4$export$4812e460280c6ef2, (v) => $bed5e8718f2b11e4$export$4812e460280c6ef2 = v);
$parcel$export(module.exports, "sampleTime", () => $bed5e8718f2b11e4$export$fe33c7b2002d97b0, (v) => $bed5e8718f2b11e4$export$fe33c7b2002d97b0 = v);
$parcel$export(module.exports, "scan", () => $bed5e8718f2b11e4$export$c87d910e63d22ed6, (v) => $bed5e8718f2b11e4$export$c87d910e63d22ed6 = v);
$parcel$export(module.exports, "sequenceEqual", () => $bed5e8718f2b11e4$export$d0a07e60ae428313, (v) => $bed5e8718f2b11e4$export$d0a07e60ae428313 = v);
$parcel$export(module.exports, "share", () => $bed5e8718f2b11e4$export$ed80d9de1d9df928, (v) => $bed5e8718f2b11e4$export$ed80d9de1d9df928 = v);
$parcel$export(module.exports, "shareReplay", () => $bed5e8718f2b11e4$export$db61d692014e534e, (v) => $bed5e8718f2b11e4$export$db61d692014e534e = v);
$parcel$export(module.exports, "single", () => $bed5e8718f2b11e4$export$863d7ca51b416cee, (v) => $bed5e8718f2b11e4$export$863d7ca51b416cee = v);
$parcel$export(module.exports, "skip", () => $bed5e8718f2b11e4$export$955fc4a6c4be454d, (v) => $bed5e8718f2b11e4$export$955fc4a6c4be454d = v);
$parcel$export(module.exports, "skipLast", () => $bed5e8718f2b11e4$export$635f6273df29ea1c, (v) => $bed5e8718f2b11e4$export$635f6273df29ea1c = v);
$parcel$export(module.exports, "skipUntil", () => $bed5e8718f2b11e4$export$facc584867c26fde, (v) => $bed5e8718f2b11e4$export$facc584867c26fde = v);
$parcel$export(module.exports, "skipWhile", () => $bed5e8718f2b11e4$export$175dedd748069215, (v) => $bed5e8718f2b11e4$export$175dedd748069215 = v);
$parcel$export(module.exports, "startWith", () => $bed5e8718f2b11e4$export$a4fe86229b0e9bdd, (v) => $bed5e8718f2b11e4$export$a4fe86229b0e9bdd = v);
$parcel$export(module.exports, "switchAll", () => $bed5e8718f2b11e4$export$6a45284a4b0bf33a, (v) => $bed5e8718f2b11e4$export$6a45284a4b0bf33a = v);
$parcel$export(module.exports, "switchMap", () => $bed5e8718f2b11e4$export$9f6ea8e48bc26eab, (v) => $bed5e8718f2b11e4$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "switchMapTo", () => $bed5e8718f2b11e4$export$a439dc30c845238, (v) => $bed5e8718f2b11e4$export$a439dc30c845238 = v);
$parcel$export(module.exports, "take", () => $bed5e8718f2b11e4$export$b7df5d561049483a, (v) => $bed5e8718f2b11e4$export$b7df5d561049483a = v);
$parcel$export(module.exports, "takeLast", () => $bed5e8718f2b11e4$export$1b47ad771ce5af5e, (v) => $bed5e8718f2b11e4$export$1b47ad771ce5af5e = v);
$parcel$export(module.exports, "takeUntil", () => $bed5e8718f2b11e4$export$ac8dfd3a7ad06e80, (v) => $bed5e8718f2b11e4$export$ac8dfd3a7ad06e80 = v);
$parcel$export(module.exports, "takeWhile", () => $bed5e8718f2b11e4$export$9384c7afe4015e42, (v) => $bed5e8718f2b11e4$export$9384c7afe4015e42 = v);
$parcel$export(module.exports, "tap", () => $bed5e8718f2b11e4$export$3f23594af5f37336, (v) => $bed5e8718f2b11e4$export$3f23594af5f37336 = v);
$parcel$export(module.exports, "throttle", () => $bed5e8718f2b11e4$export$de363e709c412c8a, (v) => $bed5e8718f2b11e4$export$de363e709c412c8a = v);
$parcel$export(module.exports, "throttleTime", () => $bed5e8718f2b11e4$export$4efe28f192921dd4, (v) => $bed5e8718f2b11e4$export$4efe28f192921dd4 = v);
$parcel$export(module.exports, "timeInterval", () => $bed5e8718f2b11e4$export$1a539c8b2950ab40, (v) => $bed5e8718f2b11e4$export$1a539c8b2950ab40 = v);
$parcel$export(module.exports, "timeout", () => $bed5e8718f2b11e4$export$83e74882c5df8fe1, (v) => $bed5e8718f2b11e4$export$83e74882c5df8fe1 = v);
$parcel$export(module.exports, "timeoutWith", () => $bed5e8718f2b11e4$export$86fe999fba7953f2, (v) => $bed5e8718f2b11e4$export$86fe999fba7953f2 = v);
$parcel$export(module.exports, "timestamp", () => $bed5e8718f2b11e4$export$fc00ee57782020aa, (v) => $bed5e8718f2b11e4$export$fc00ee57782020aa = v);
$parcel$export(module.exports, "toArray", () => $bed5e8718f2b11e4$export$45b10814cc054894, (v) => $bed5e8718f2b11e4$export$45b10814cc054894 = v);
$parcel$export(module.exports, "window", () => $bed5e8718f2b11e4$export$8291e5b88f90ce4, (v) => $bed5e8718f2b11e4$export$8291e5b88f90ce4 = v);
$parcel$export(module.exports, "windowCount", () => $bed5e8718f2b11e4$export$f3a19e933f377396, (v) => $bed5e8718f2b11e4$export$f3a19e933f377396 = v);
$parcel$export(module.exports, "windowTime", () => $bed5e8718f2b11e4$export$1284415effa79ee0, (v) => $bed5e8718f2b11e4$export$1284415effa79ee0 = v);
$parcel$export(module.exports, "windowToggle", () => $bed5e8718f2b11e4$export$3182be990e0eeaad, (v) => $bed5e8718f2b11e4$export$3182be990e0eeaad = v);
$parcel$export(module.exports, "windowWhen", () => $bed5e8718f2b11e4$export$6a5dea797879f644, (v) => $bed5e8718f2b11e4$export$6a5dea797879f644 = v);
$parcel$export(module.exports, "withLatestFrom", () => $bed5e8718f2b11e4$export$d449030e5c10edf7, (v) => $bed5e8718f2b11e4$export$d449030e5c10edf7 = v);
$parcel$export(module.exports, "zip", () => $bed5e8718f2b11e4$export$8901015135f2fb22, (v) => $bed5e8718f2b11e4$export$8901015135f2fb22 = v);
$parcel$export(module.exports, "zipAll", () => $bed5e8718f2b11e4$export$adddb6a2fa3864e9, (v) => $bed5e8718f2b11e4$export$adddb6a2fa3864e9 = v);
var $bed5e8718f2b11e4$export$d779b02e6b68c3e8;
var $bed5e8718f2b11e4$export$719c70722b10e5ff;
var $bed5e8718f2b11e4$export$ab1029bcae9ddb4a;
var $bed5e8718f2b11e4$export$8916d2c8119541bb;
var $bed5e8718f2b11e4$export$d6b40c95035461c7;
var $bed5e8718f2b11e4$export$91115bdd8709945f;
var $bed5e8718f2b11e4$export$9e55760d3282e08c;
var $bed5e8718f2b11e4$export$3dede90624df3ba9;
var $bed5e8718f2b11e4$export$29ae691b7de52fe3;
var $bed5e8718f2b11e4$export$77fa7d86f5204e8a;
var $bed5e8718f2b11e4$export$ee1b3e54f0441b22;
var $bed5e8718f2b11e4$export$b314777ae20abca9;
var $bed5e8718f2b11e4$export$c28c8388be0ab31a;
var $bed5e8718f2b11e4$export$82fbd7a2841d2484;
var $bed5e8718f2b11e4$export$85b9a36db797e02b;
var $bed5e8718f2b11e4$export$61fc7d43ac8f84b0;
var $bed5e8718f2b11e4$export$7843a4469d64c07e;
var $bed5e8718f2b11e4$export$e4ca6d7b7a6dcf9b;
var $bed5e8718f2b11e4$export$1391212d75b2ee65;
var $bed5e8718f2b11e4$export$286ca829307725c9;
var $bed5e8718f2b11e4$export$ab9a5985b741fa7a;
var $bed5e8718f2b11e4$export$983a3b5fb2f7202e;
var $bed5e8718f2b11e4$export$779c5fb865a0172e;
var $bed5e8718f2b11e4$export$571da16e28367bde;
var $bed5e8718f2b11e4$export$91d69c7761a17bbc;
var $bed5e8718f2b11e4$export$7ecc1a3b11b57dab;
var $bed5e8718f2b11e4$export$31039f1fbd797b9c;
var $bed5e8718f2b11e4$export$d70d492cd31004c0;
var $bed5e8718f2b11e4$export$9f77e0932fb78f72;
var $bed5e8718f2b11e4$export$3dea766d36a8935f;
var $bed5e8718f2b11e4$export$578723aef62d92f5;
var $bed5e8718f2b11e4$export$71aa6c912b956294;
var $bed5e8718f2b11e4$export$de3a4d4a0d731119;
var $bed5e8718f2b11e4$export$43128fadae87b74a;
var $bed5e8718f2b11e4$export$3f063810d7bf01bd;
var $bed5e8718f2b11e4$export$6953b97c7d866605;
var $bed5e8718f2b11e4$export$dd1bc94b04021eeb;
var $bed5e8718f2b11e4$export$4c7897fafd92b108;
var $bed5e8718f2b11e4$export$871de8747c9eaa88;
var $bed5e8718f2b11e4$export$e0eaf3a86c03b2ad;
var $bed5e8718f2b11e4$export$76dbd6ffd832405d;
var $bed5e8718f2b11e4$export$8960430cfd85939f;
var $bed5e8718f2b11e4$export$4950aa0f605343fb;
var $bed5e8718f2b11e4$export$18aef43295bbe906;
var $bed5e8718f2b11e4$export$6b9f6c0d32c093f9;
var $bed5e8718f2b11e4$export$5b8affa63fc6df16;
var $bed5e8718f2b11e4$export$bd7cfc9a42b8a412;
var $bed5e8718f2b11e4$export$c1fc905202bced53;
var $bed5e8718f2b11e4$export$96ec731ed4dcb222;
var $bed5e8718f2b11e4$export$1364843af8d5a963;
var $bed5e8718f2b11e4$export$9007f49c319d1ac7;
var $bed5e8718f2b11e4$export$5fba66d61591f42;
var $bed5e8718f2b11e4$export$8f9d79d42bff1aac;
var $bed5e8718f2b11e4$export$b29f828819edca8d;
var $bed5e8718f2b11e4$export$c44985b87d605eff;
var $bed5e8718f2b11e4$export$89b472e03be495df;
var $bed5e8718f2b11e4$export$16ae46fda9567053;
var $bed5e8718f2b11e4$export$42d9b6b38c68d989;
var $bed5e8718f2b11e4$export$1f3342bf81d92d52;
var $bed5e8718f2b11e4$export$236c05de452bec2;
var $bed5e8718f2b11e4$export$533b26079ad0b4b;
var $bed5e8718f2b11e4$export$76d90c956114f2c2;
var $bed5e8718f2b11e4$export$b39ac5b4ffd1415a;
var $bed5e8718f2b11e4$export$9369b12211e1fce4;
var $bed5e8718f2b11e4$export$1281551253cfee02;
var $bed5e8718f2b11e4$export$18d0766d894cba0c;
var $bed5e8718f2b11e4$export$4812e460280c6ef2;
var $bed5e8718f2b11e4$export$fe33c7b2002d97b0;
var $bed5e8718f2b11e4$export$c87d910e63d22ed6;
var $bed5e8718f2b11e4$export$d0a07e60ae428313;
var $bed5e8718f2b11e4$export$ed80d9de1d9df928;
var $bed5e8718f2b11e4$export$db61d692014e534e;
var $bed5e8718f2b11e4$export$863d7ca51b416cee;
var $bed5e8718f2b11e4$export$955fc4a6c4be454d;
var $bed5e8718f2b11e4$export$635f6273df29ea1c;
var $bed5e8718f2b11e4$export$facc584867c26fde;
var $bed5e8718f2b11e4$export$175dedd748069215;
var $bed5e8718f2b11e4$export$a4fe86229b0e9bdd;
var $bed5e8718f2b11e4$export$6a45284a4b0bf33a;
var $bed5e8718f2b11e4$export$9f6ea8e48bc26eab;
var $bed5e8718f2b11e4$export$a439dc30c845238;
var $bed5e8718f2b11e4$export$b7df5d561049483a;
var $bed5e8718f2b11e4$export$1b47ad771ce5af5e;
var $bed5e8718f2b11e4$export$ac8dfd3a7ad06e80;
var $bed5e8718f2b11e4$export$9384c7afe4015e42;
var $bed5e8718f2b11e4$export$3f23594af5f37336;
var $bed5e8718f2b11e4$export$de363e709c412c8a;
var $bed5e8718f2b11e4$export$4efe28f192921dd4;
var $bed5e8718f2b11e4$export$1a539c8b2950ab40;
var $bed5e8718f2b11e4$export$83e74882c5df8fe1;
var $bed5e8718f2b11e4$export$86fe999fba7953f2;
var $bed5e8718f2b11e4$export$fc00ee57782020aa;
var $bed5e8718f2b11e4$export$45b10814cc054894;
var $bed5e8718f2b11e4$export$8291e5b88f90ce4;
var $bed5e8718f2b11e4$export$f3a19e933f377396;
var $bed5e8718f2b11e4$export$1284415effa79ee0;
var $bed5e8718f2b11e4$export$3182be990e0eeaad;
var $bed5e8718f2b11e4$export$6a5dea797879f644;
var $bed5e8718f2b11e4$export$d449030e5c10edf7;
var $bed5e8718f2b11e4$export$8901015135f2fb22;
var $bed5e8718f2b11e4$export$adddb6a2fa3864e9;
"use strict";

var $l9FiH = parcelRequire("l9FiH");
$bed5e8718f2b11e4$export$d779b02e6b68c3e8 = $l9FiH.audit;

var $01CpP = parcelRequire("01CpP");
$bed5e8718f2b11e4$export$719c70722b10e5ff = $01CpP.auditTime;

var $8XIgu = parcelRequire("8XIgu");
$bed5e8718f2b11e4$export$ab1029bcae9ddb4a = $8XIgu.buffer;

var $3gIhm = parcelRequire("3gIhm");
$bed5e8718f2b11e4$export$8916d2c8119541bb = $3gIhm.bufferCount;

var $ajXNp = parcelRequire("ajXNp");
$bed5e8718f2b11e4$export$d6b40c95035461c7 = $ajXNp.bufferTime;

var $kURQw = parcelRequire("kURQw");
$bed5e8718f2b11e4$export$91115bdd8709945f = $kURQw.bufferToggle;

var $2Z676 = parcelRequire("2Z676");
$bed5e8718f2b11e4$export$9e55760d3282e08c = $2Z676.bufferWhen;

var $gtLoC = parcelRequire("gtLoC");
$bed5e8718f2b11e4$export$3dede90624df3ba9 = $gtLoC.catchError;

var $dm9qI = parcelRequire("dm9qI");
$bed5e8718f2b11e4$export$29ae691b7de52fe3 = $dm9qI.combineAll;

var $5IzkJ = parcelRequire("5IzkJ");
$bed5e8718f2b11e4$export$77fa7d86f5204e8a = $5IzkJ.combineLatest;

var $dlsxa = parcelRequire("dlsxa");
$bed5e8718f2b11e4$export$ee1b3e54f0441b22 = $dlsxa.concat;

var $7xfVB = parcelRequire("7xfVB");
$bed5e8718f2b11e4$export$b314777ae20abca9 = $7xfVB.concatAll;

var $h4te9 = parcelRequire("h4te9");
$bed5e8718f2b11e4$export$c28c8388be0ab31a = $h4te9.concatMap;

var $7L3r1 = parcelRequire("7L3r1");
$bed5e8718f2b11e4$export$82fbd7a2841d2484 = $7L3r1.concatMapTo;

var $fYYEX = parcelRequire("fYYEX");
$bed5e8718f2b11e4$export$85b9a36db797e02b = $fYYEX.count;

var $8pSz4 = parcelRequire("8pSz4");
$bed5e8718f2b11e4$export$61fc7d43ac8f84b0 = $8pSz4.debounce;

var $45ySv = parcelRequire("45ySv");
$bed5e8718f2b11e4$export$7843a4469d64c07e = $45ySv.debounceTime;

var $7DEqP = parcelRequire("7DEqP");
$bed5e8718f2b11e4$export$e4ca6d7b7a6dcf9b = $7DEqP.defaultIfEmpty;

var $4s1nx = parcelRequire("4s1nx");
$bed5e8718f2b11e4$export$1391212d75b2ee65 = $4s1nx.delay;

var $1Z46w = parcelRequire("1Z46w");
$bed5e8718f2b11e4$export$286ca829307725c9 = $1Z46w.delayWhen;

var $5AZnY = parcelRequire("5AZnY");
$bed5e8718f2b11e4$export$ab9a5985b741fa7a = $5AZnY.dematerialize;

var $7VsUA = parcelRequire("7VsUA");
$bed5e8718f2b11e4$export$983a3b5fb2f7202e = $7VsUA.distinct;

var $cgjPk = parcelRequire("cgjPk");
$bed5e8718f2b11e4$export$779c5fb865a0172e = $cgjPk.distinctUntilChanged;

var $9M05L = parcelRequire("9M05L");
$bed5e8718f2b11e4$export$571da16e28367bde = $9M05L.distinctUntilKeyChanged;

var $kfIc1 = parcelRequire("kfIc1");
$bed5e8718f2b11e4$export$91d69c7761a17bbc = $kfIc1.elementAt;

var $diRdy = parcelRequire("diRdy");
$bed5e8718f2b11e4$export$7ecc1a3b11b57dab = $diRdy.every;

var $aAoKV = parcelRequire("aAoKV");
$bed5e8718f2b11e4$export$31039f1fbd797b9c = $aAoKV.exhaust;

var $7D9cz = parcelRequire("7D9cz");
$bed5e8718f2b11e4$export$d70d492cd31004c0 = $7D9cz.exhaustMap;

var $aK3w2 = parcelRequire("aK3w2");
$bed5e8718f2b11e4$export$9f77e0932fb78f72 = $aK3w2.expand;

var $dCzwc = parcelRequire("dCzwc");
$bed5e8718f2b11e4$export$3dea766d36a8935f = $dCzwc.filter;

var $45H2I = parcelRequire("45H2I");
$bed5e8718f2b11e4$export$578723aef62d92f5 = $45H2I.finalize;

var $eNyfg = parcelRequire("eNyfg");
$bed5e8718f2b11e4$export$71aa6c912b956294 = $eNyfg.find;

var $4fuVe = parcelRequire("4fuVe");
$bed5e8718f2b11e4$export$de3a4d4a0d731119 = $4fuVe.findIndex;

var $3agVN = parcelRequire("3agVN");
$bed5e8718f2b11e4$export$43128fadae87b74a = $3agVN.first;

var $4zLKD = parcelRequire("4zLKD");
$bed5e8718f2b11e4$export$3f063810d7bf01bd = $4zLKD.groupBy;

var $5NA3Y = parcelRequire("5NA3Y");
$bed5e8718f2b11e4$export$6953b97c7d866605 = $5NA3Y.ignoreElements;

var $kKzvg = parcelRequire("kKzvg");
$bed5e8718f2b11e4$export$dd1bc94b04021eeb = $kKzvg.isEmpty;

var $vNigh = parcelRequire("vNigh");
$bed5e8718f2b11e4$export$4c7897fafd92b108 = $vNigh.last;

var $bP9Wc = parcelRequire("bP9Wc");
$bed5e8718f2b11e4$export$871de8747c9eaa88 = $bP9Wc.map;

var $31RSE = parcelRequire("31RSE");
$bed5e8718f2b11e4$export$e0eaf3a86c03b2ad = $31RSE.mapTo;

var $9vc76 = parcelRequire("9vc76");
$bed5e8718f2b11e4$export$76dbd6ffd832405d = $9vc76.materialize;

var $gMQNi = parcelRequire("gMQNi");
$bed5e8718f2b11e4$export$8960430cfd85939f = $gMQNi.max;

var $3cAvp = parcelRequire("3cAvp");
$bed5e8718f2b11e4$export$4950aa0f605343fb = $3cAvp.merge;

var $aapek = parcelRequire("aapek");
$bed5e8718f2b11e4$export$18aef43295bbe906 = $aapek.mergeAll;

var $jcL4C = parcelRequire("jcL4C");
$bed5e8718f2b11e4$export$6b9f6c0d32c093f9 = $jcL4C.mergeMap;

var $jcL4C = parcelRequire("jcL4C");
$bed5e8718f2b11e4$export$5b8affa63fc6df16 = $jcL4C.mergeMap;

var $lW3W5 = parcelRequire("lW3W5");
$bed5e8718f2b11e4$export$bd7cfc9a42b8a412 = $lW3W5.mergeMapTo;

var $bgwIP = parcelRequire("bgwIP");
$bed5e8718f2b11e4$export$c1fc905202bced53 = $bgwIP.mergeScan;

var $itQYd = parcelRequire("itQYd");
$bed5e8718f2b11e4$export$96ec731ed4dcb222 = $itQYd.min;

var $3CYRc = parcelRequire("3CYRc");
$bed5e8718f2b11e4$export$1364843af8d5a963 = $3CYRc.multicast;

var $2fC9E = parcelRequire("2fC9E");
$bed5e8718f2b11e4$export$9007f49c319d1ac7 = $2fC9E.observeOn;

var $3eCwJ = parcelRequire("3eCwJ");
$bed5e8718f2b11e4$export$5fba66d61591f42 = $3eCwJ.onErrorResumeNext;

var $cPuW4 = parcelRequire("cPuW4");
$bed5e8718f2b11e4$export$8f9d79d42bff1aac = $cPuW4.pairwise;

var $cdkl9 = parcelRequire("cdkl9");
$bed5e8718f2b11e4$export$b29f828819edca8d = $cdkl9.partition;

var $3xPAc = parcelRequire("3xPAc");
$bed5e8718f2b11e4$export$c44985b87d605eff = $3xPAc.pluck;

var $K815z = parcelRequire("K815z");
$bed5e8718f2b11e4$export$89b472e03be495df = $K815z.publish;

var $Up4mT = parcelRequire("Up4mT");
$bed5e8718f2b11e4$export$16ae46fda9567053 = $Up4mT.publishBehavior;

var $6Zq4e = parcelRequire("6Zq4e");
$bed5e8718f2b11e4$export$42d9b6b38c68d989 = $6Zq4e.publishLast;

var $4vqFc = parcelRequire("4vqFc");
$bed5e8718f2b11e4$export$1f3342bf81d92d52 = $4vqFc.publishReplay;

var $5BI5v = parcelRequire("5BI5v");
$bed5e8718f2b11e4$export$236c05de452bec2 = $5BI5v.race;

var $de1nH = parcelRequire("de1nH");
$bed5e8718f2b11e4$export$533b26079ad0b4b = $de1nH.reduce;

var $6dn34 = parcelRequire("6dn34");
$bed5e8718f2b11e4$export$76d90c956114f2c2 = $6dn34.repeat;

var $1LLSb = parcelRequire("1LLSb");
$bed5e8718f2b11e4$export$b39ac5b4ffd1415a = $1LLSb.repeatWhen;

var $evUR9 = parcelRequire("evUR9");
$bed5e8718f2b11e4$export$9369b12211e1fce4 = $evUR9.retry;

var $alXRc = parcelRequire("alXRc");
$bed5e8718f2b11e4$export$1281551253cfee02 = $alXRc.retryWhen;

var $ilBr9 = parcelRequire("ilBr9");
$bed5e8718f2b11e4$export$18d0766d894cba0c = $ilBr9.refCount;

var $10ape = parcelRequire("10ape");
$bed5e8718f2b11e4$export$4812e460280c6ef2 = $10ape.sample;

var $fV0Ji = parcelRequire("fV0Ji");
$bed5e8718f2b11e4$export$fe33c7b2002d97b0 = $fV0Ji.sampleTime;

var $cKrD4 = parcelRequire("cKrD4");
$bed5e8718f2b11e4$export$c87d910e63d22ed6 = $cKrD4.scan;

var $63tY2 = parcelRequire("63tY2");
$bed5e8718f2b11e4$export$d0a07e60ae428313 = $63tY2.sequenceEqual;

var $g1tTT = parcelRequire("g1tTT");
$bed5e8718f2b11e4$export$ed80d9de1d9df928 = $g1tTT.share;

var $bOzV7 = parcelRequire("bOzV7");
$bed5e8718f2b11e4$export$db61d692014e534e = $bOzV7.shareReplay;

var $hGbb9 = parcelRequire("hGbb9");
$bed5e8718f2b11e4$export$863d7ca51b416cee = $hGbb9.single;

var $8b8V8 = parcelRequire("8b8V8");
$bed5e8718f2b11e4$export$955fc4a6c4be454d = $8b8V8.skip;

var $3Nv3L = parcelRequire("3Nv3L");
$bed5e8718f2b11e4$export$635f6273df29ea1c = $3Nv3L.skipLast;

var $fxjWN = parcelRequire("fxjWN");
$bed5e8718f2b11e4$export$facc584867c26fde = $fxjWN.skipUntil;

var $aM7z9 = parcelRequire("aM7z9");
$bed5e8718f2b11e4$export$175dedd748069215 = $aM7z9.skipWhile;

var $gVaRN = parcelRequire("gVaRN");
$bed5e8718f2b11e4$export$a4fe86229b0e9bdd = $gVaRN.startWith;

var $2hLYY = parcelRequire("2hLYY");
$bed5e8718f2b11e4$export$6a45284a4b0bf33a = $2hLYY.switchAll;

var $1phCj = parcelRequire("1phCj");
$bed5e8718f2b11e4$export$9f6ea8e48bc26eab = $1phCj.switchMap;

var $hAXvt = parcelRequire("hAXvt");
$bed5e8718f2b11e4$export$a439dc30c845238 = $hAXvt.switchMapTo;

var $bCu3B = parcelRequire("bCu3B");
$bed5e8718f2b11e4$export$b7df5d561049483a = $bCu3B.take;

var $kzAXk = parcelRequire("kzAXk");
$bed5e8718f2b11e4$export$1b47ad771ce5af5e = $kzAXk.takeLast;

var $kbGrt = parcelRequire("kbGrt");
$bed5e8718f2b11e4$export$ac8dfd3a7ad06e80 = $kbGrt.takeUntil;

var $7fvhJ = parcelRequire("7fvhJ");
$bed5e8718f2b11e4$export$9384c7afe4015e42 = $7fvhJ.takeWhile;

var $9y2UG = parcelRequire("9y2UG");
$bed5e8718f2b11e4$export$3f23594af5f37336 = $9y2UG.tap;

var $g0Y5L = parcelRequire("g0Y5L");
$bed5e8718f2b11e4$export$de363e709c412c8a = $g0Y5L.throttle;

var $dz6eQ = parcelRequire("dz6eQ");
$bed5e8718f2b11e4$export$4efe28f192921dd4 = $dz6eQ.throttleTime;

var $jODVt = parcelRequire("jODVt");
$bed5e8718f2b11e4$export$1a539c8b2950ab40 = $jODVt.timeInterval;

var $b6gR6 = parcelRequire("b6gR6");
$bed5e8718f2b11e4$export$83e74882c5df8fe1 = $b6gR6.timeout;

var $f4G6g = parcelRequire("f4G6g");
$bed5e8718f2b11e4$export$86fe999fba7953f2 = $f4G6g.timeoutWith;

var $hBG9v = parcelRequire("hBG9v");
$bed5e8718f2b11e4$export$fc00ee57782020aa = $hBG9v.timestamp;

var $cZJcN = parcelRequire("cZJcN");
$bed5e8718f2b11e4$export$45b10814cc054894 = $cZJcN.toArray;

var $88oef = parcelRequire("88oef");
$bed5e8718f2b11e4$export$8291e5b88f90ce4 = $88oef.window;

var $9HqMq = parcelRequire("9HqMq");
$bed5e8718f2b11e4$export$f3a19e933f377396 = $9HqMq.windowCount;

var $d0dcb = parcelRequire("d0dcb");
$bed5e8718f2b11e4$export$1284415effa79ee0 = $d0dcb.windowTime;

var $hDgkp = parcelRequire("hDgkp");
$bed5e8718f2b11e4$export$3182be990e0eeaad = $hDgkp.windowToggle;

var $8HLqu = parcelRequire("8HLqu");
$bed5e8718f2b11e4$export$6a5dea797879f644 = $8HLqu.windowWhen;

var $229RS = parcelRequire("229RS");
$bed5e8718f2b11e4$export$d449030e5c10edf7 = $229RS.withLatestFrom;

var $2mE2X = parcelRequire("2mE2X");
$bed5e8718f2b11e4$export$8901015135f2fb22 = $2mE2X.zip;

var $dEwdi = parcelRequire("dEwdi");
$bed5e8718f2b11e4$export$adddb6a2fa3864e9 = $dEwdi.zipAll;

});


parcelRegister("eSZoS", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $a335e3b301dd246a$export$c3902030a5d4d47a);
$parcel$export(module.exports, "sendNewSignupLinkEpic", () => $a335e3b301dd246a$export$5566cb2a1dee7448);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $42Hon = parcelRequire("42Hon");

var $3wcna = parcelRequire("3wcna");
parcelRequire("9bj9n");
var $cP3WD = parcelRequire("cP3WD");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");

var $1vXf6 = parcelRequire("1vXf6");
const $a335e3b301dd246a$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $cP3WD.COMPLETE_SIGNUP)).mergeMap((completeSignupAction)=>{
        const { jwtToken: jwtToken, fullName: fullName, password: password, email: email, contactAdminsFormEnabled: contactAdminsFormEnabled, continueParam: continueParam } = completeSignupAction.payload;
        return (0, $42Hon.completeSignup)(jwtToken, fullName, password).flatMap(()=>{
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $cP3WD.completeSignupSuccess)()), (0, $8jOUp.Observable).of((0, $xAy39.loginAttempt)({
                email: email,
                password: password,
                continueParam: continueParam ?? null
            })));
        }).catch((error)=>{
            const parsedError = (0, $1vXf6.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $8jOUp.Observable).of((0, $cP3WD.completeSignupFailure)(parsedError));
        });
    });
};
const $a335e3b301dd246a$export$5566cb2a1dee7448 = (action$)=>{
    return action$.ofType((0, $cP3WD.SEND_NEW_SIGNUP_LINK)).mergeMap((sendNewSignupLinkAction)=>{
        const { email: email, portalId: portalId } = sendNewSignupLinkAction.payload;
        return (0, $3wcna.resendValidationEmail)(email, portalId, undefined).map(()=>{
            return (0, $cP3WD.sendNewSignupLinkSuccess)();
        }).catch((error)=>{
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $cP3WD.sendNewSignupLinkFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("xb2jO", function(module, exports) {
$parcel$export(module.exports, "HANDLE_AJAX_ERROR", () => $a2ae182181495064$export$a7c57e52be964b91);
$parcel$export(module.exports, "SHOW_ERROR_FLAG", () => $a2ae182181495064$export$2b6b999b3eafcf24);
$parcel$export(module.exports, "SHOW_WARNING_FLAG", () => $a2ae182181495064$export$4f0f0fac05b2a93f);
$parcel$export(module.exports, "SHOW_SUCCESS_FLAG", () => $a2ae182181495064$export$c911d7565dd7a733);
$parcel$export(module.exports, "SHOW_BOLD_APPEARANCE_FLAG", () => $a2ae182181495064$export$8eec0f3e4bc42e5c);
$parcel$export(module.exports, "DISMISS_FLAG", () => $a2ae182181495064$export$1eb56620df104bf);
$parcel$export(module.exports, "handleAjaxError", () => $a2ae182181495064$export$1245fce1755f5ec2);
$parcel$export(module.exports, "showErrorFlag", () => $a2ae182181495064$export$dfa2148cdb92917d);
$parcel$export(module.exports, "showWarningFlag", () => $a2ae182181495064$export$9475ea83c9ea0d1c);
$parcel$export(module.exports, "showSuccessFlag", () => $a2ae182181495064$export$fef8478a2c810f18);
$parcel$export(module.exports, "showBoldAppearanceFlag", () => $a2ae182181495064$export$4231a8f3b05ab067);
$parcel$export(module.exports, "dismissFlag", () => $a2ae182181495064$export$900a08a292ad23cd);
const $a2ae182181495064$export$a7c57e52be964b91 = 'state.ui.flags.HANDLE_AJAX_ERROR';
const $a2ae182181495064$export$2b6b999b3eafcf24 = 'state.ui.flags.SHOW_ERROR_FLAG';
const $a2ae182181495064$export$4f0f0fac05b2a93f = 'state.ui.flags.SHOW_WARNING_FLAG';
const $a2ae182181495064$export$c911d7565dd7a733 = 'state.ui.flags.SHOW_SUCCESS_FLAG';
const $a2ae182181495064$export$8eec0f3e4bc42e5c = 'state.ui.flags.SHOW_BOLD_APPEARANCE_FLAG';
const $a2ae182181495064$export$1eb56620df104bf = 'state.ui.flags.DISMISS_FLAG';
const $a2ae182181495064$export$1245fce1755f5ec2 = (error)=>({
        type: $a2ae182181495064$export$a7c57e52be964b91,
        payload: {
            error: error
        }
    });
const $a2ae182181495064$export$dfa2148cdb92917d = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $a2ae182181495064$export$2b6b999b3eafcf24,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $a2ae182181495064$export$9475ea83c9ea0d1c = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $a2ae182181495064$export$4f0f0fac05b2a93f,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $a2ae182181495064$export$fef8478a2c810f18 = (titleMessage, titleMessageValues, descriptionMessage, actions, descriptionMessageValues)=>({
        type: $a2ae182181495064$export$c911d7565dd7a733,
        payload: {
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            actions: actions
        }
    });
const $a2ae182181495064$export$4231a8f3b05ab067 = (appearance, titleMessage, titleMessageValues, descriptionMessage, descriptionMessageValues, actions, dismissActionValue)=>({
        type: $a2ae182181495064$export$8eec0f3e4bc42e5c,
        payload: {
            appearance: appearance,
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            dismissActionValue: dismissActionValue,
            actions: actions
        }
    });
const $a2ae182181495064$export$900a08a292ad23cd = (flagId)=>({
        type: $a2ae182181495064$export$1eb56620df104bf,
        payload: {
            flagId: flagId
        }
    });

});

parcelRegister("42Hon", function(module, exports) {
$parcel$export(module.exports, "completeSignup", () => $e513671c0c198010$export$96271c6a96268661);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $e513671c0c198010$export$96271c6a96268661 = (token, fullName, password, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/complete-signup?jwt=${token}`;
    const body = $e513671c0c198010$var$createBody(fullName, password);
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};
const $e513671c0c198010$var$createBody = (fullName, password)=>{
    return JSON.stringify({
        fullName: fullName,
        password: password
    });
};

});

parcelRegister("3wcna", function(module, exports) {
$parcel$export(module.exports, "signUp", () => $c23304871fd7f06a$export$cf64224bcd829024);
$parcel$export(module.exports, "resendValidationEmail", () => $c23304871fd7f06a$export$b53bc6c531462e2c);

var $llRGw = parcelRequire("llRGw");

var $fuVmc = parcelRequire("fuVmc");

var $eDcdn = parcelRequire("eDcdn");
const $c23304871fd7f06a$var$baseSignupBody = (email, portalId, redirectUrl)=>({
        email: email,
        signUpContext: {
            portalId: portalId,
            redirectUrl: redirectUrl,
            helpCenterAri: (0, $fuVmc.getHelpCenterAri)()
        }
    });
const $c23304871fd7f06a$export$cf64224bcd829024 = async (email, secondaryEmail, portalId, redirectUrl, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/signup`;
    const body = {
        ...$c23304871fd7f06a$var$baseSignupBody(email, portalId, redirectUrl),
        secondaryEmail: secondaryEmail,
        usingNewUi: true
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise().catch((e)=>Promise.reject(e));
};
const $c23304871fd7f06a$export$b53bc6c531462e2c = (email, portalId, redirectUrl, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/send-validation-email`;
    const body = $c23304871fd7f06a$var$baseSignupBody(email, portalId, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("9bj9n", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => (parcelRequire("cP3WD")).FETCH_COMPLETE_SIGNUP_MODEL);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => (parcelRequire("cP3WD")).FETCH_COMPLETE_SIGNUP_SUCCESS);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("cP3WD")).FETCH_COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => (parcelRequire("cP3WD")).COMPLETE_SIGNUP);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("cP3WD")).COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => (parcelRequire("cP3WD")).SEND_NEW_SIGNUP_LINK);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => (parcelRequire("cP3WD")).SEND_NEW_SIGNUP_LINK_SUCCESS);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => (parcelRequire("cP3WD")).SEND_NEW_SIGNUP_LINK_FAILURE);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => (parcelRequire("cP3WD")).fetchCompleteSignupModel);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => (parcelRequire("cP3WD")).fetchCompleteSignupSuccess);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => (parcelRequire("cP3WD")).fetchCompleteSignupFailure);
$parcel$export(module.exports, "completeSignup", () => (parcelRequire("cP3WD")).completeSignup);
$parcel$export(module.exports, "completeSignupSuccess", () => (parcelRequire("cP3WD")).completeSignupSuccess);
$parcel$export(module.exports, "completeSignupFailure", () => (parcelRequire("cP3WD")).completeSignupFailure);
$parcel$export(module.exports, "sendNewSignupLink", () => (parcelRequire("cP3WD")).sendNewSignupLink);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => (parcelRequire("cP3WD")).sendNewSignupLinkSuccess);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => (parcelRequire("cP3WD")).sendNewSignupLinkFailure);

var $cP3WD = parcelRequire("cP3WD");

});
parcelRegister("cP3WD", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => $9e8ce993ce6f4f82$export$a57d1f559f8199cb);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => $9e8ce993ce6f4f82$export$c991c467f18c47c4);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => $9e8ce993ce6f4f82$export$af520912b7d6706d);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => $9e8ce993ce6f4f82$export$53ff245dddbf796c);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => $9e8ce993ce6f4f82$export$88f081a1fe475d4e);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => $9e8ce993ce6f4f82$export$d76ccb8fbc57714);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => $9e8ce993ce6f4f82$export$50cb33d74bd8c2e4);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => $9e8ce993ce6f4f82$export$10f6ec3c86fb611d);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => $9e8ce993ce6f4f82$export$22acc17286f74b59);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => $9e8ce993ce6f4f82$export$93e33f94b1c7e30b);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => $9e8ce993ce6f4f82$export$7559c63f3aa1d23b);
$parcel$export(module.exports, "completeSignup", () => $9e8ce993ce6f4f82$export$96271c6a96268661);
$parcel$export(module.exports, "completeSignupSuccess", () => $9e8ce993ce6f4f82$export$854f5c75b16a30e1);
$parcel$export(module.exports, "completeSignupFailure", () => $9e8ce993ce6f4f82$export$76e49af38e42140f);
$parcel$export(module.exports, "sendNewSignupLink", () => $9e8ce993ce6f4f82$export$bc99093a83dfa75);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => $9e8ce993ce6f4f82$export$1277dcc40c57fab3);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => $9e8ce993ce6f4f82$export$f5f09020b407e701);

var $hn5Mq = parcelRequire("hn5Mq");
const $9e8ce993ce6f4f82$export$a57d1f559f8199cb = 'epic.model.FETCH_COMPLETE_SIGNUP_MODEL';
const $9e8ce993ce6f4f82$export$c991c467f18c47c4 = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_SUCCESS';
const $9e8ce993ce6f4f82$export$af520912b7d6706d = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_FAILURE';
const $9e8ce993ce6f4f82$export$53ff245dddbf796c = 'state.ui.invited.sign.up.COMPLETE_SIGNUP';
const $9e8ce993ce6f4f82$export$e7a1360e631dd35b = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_SUCCESS';
const $9e8ce993ce6f4f82$export$88f081a1fe475d4e = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_FAILURE';
const $9e8ce993ce6f4f82$export$d76ccb8fbc57714 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK';
const $9e8ce993ce6f4f82$export$50cb33d74bd8c2e4 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_SUCCESS';
const $9e8ce993ce6f4f82$export$10f6ec3c86fb611d = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_FAILURE';
const $9e8ce993ce6f4f82$export$22acc17286f74b59 = (0, $hn5Mq.buildModelsActionCreator)($9e8ce993ce6f4f82$export$a57d1f559f8199cb, 'completeSignup');
const $9e8ce993ce6f4f82$export$93e33f94b1c7e30b = (completeSignupResponse)=>({
        type: $9e8ce993ce6f4f82$export$c991c467f18c47c4,
        payload: completeSignupResponse
    });
const $9e8ce993ce6f4f82$export$7559c63f3aa1d23b = (error)=>({
        type: $9e8ce993ce6f4f82$export$af520912b7d6706d,
        payload: {
            error: error
        }
    });
const $9e8ce993ce6f4f82$export$96271c6a96268661 = (jwtToken, fullName, password, email, contactAdminsFormEnabled, continueParam)=>({
        type: $9e8ce993ce6f4f82$export$53ff245dddbf796c,
        payload: {
            jwtToken: jwtToken,
            fullName: fullName,
            password: password,
            email: email,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            continueParam: continueParam
        }
    });
const $9e8ce993ce6f4f82$export$854f5c75b16a30e1 = ()=>({
        type: $9e8ce993ce6f4f82$export$e7a1360e631dd35b
    });
const $9e8ce993ce6f4f82$export$76e49af38e42140f = (error)=>({
        type: $9e8ce993ce6f4f82$export$88f081a1fe475d4e,
        payload: {
            error: error
        }
    });
const $9e8ce993ce6f4f82$export$bc99093a83dfa75 = (email, portalId)=>({
        type: $9e8ce993ce6f4f82$export$d76ccb8fbc57714,
        payload: {
            email: email,
            portalId: portalId
        }
    });
const $9e8ce993ce6f4f82$export$1277dcc40c57fab3 = ()=>({
        type: $9e8ce993ce6f4f82$export$50cb33d74bd8c2e4
    });
const $9e8ce993ce6f4f82$export$f5f09020b407e701 = ()=>({
        type: $9e8ce993ce6f4f82$export$10f6ec3c86fb611d
    });

});
parcelRegister("hn5Mq", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $99acff1fc726dd34$export$9f8a38b5e77ac29);
const $99acff1fc726dd34$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});



parcelRegister("kYL0m", function(module, exports) {
$parcel$export(module.exports, "changeEmailInput", () => (parcelRequire("xAy39")).changeEmailInput);
$parcel$export(module.exports, "checkLoginAction", () => (parcelRequire("xAy39")).checkLoginAction);
$parcel$export(module.exports, "checkLoginActionSuccess", () => (parcelRequire("xAy39")).checkLoginActionSuccess);
$parcel$export(module.exports, "checkLoginActionFailure", () => (parcelRequire("xAy39")).checkLoginActionFailure);
$parcel$export(module.exports, "fetchLoginSuccess", () => (parcelRequire("xAy39")).fetchLoginSuccess);
$parcel$export(module.exports, "fetchLoginFailure", () => (parcelRequire("xAy39")).fetchLoginFailure);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("xAy39")).forgotPassword);
$parcel$export(module.exports, "createPassword", () => (parcelRequire("xAy39")).createPassword);
$parcel$export(module.exports, "createPasswordSuccess", () => (parcelRequire("xAy39")).createPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("xAy39")).forgotPasswordSuccess);
$parcel$export(module.exports, "loginAttempt", () => (parcelRequire("xAy39")).loginAttempt);
$parcel$export(module.exports, "loginAttemptSuccess", () => (parcelRequire("xAy39")).loginAttemptSuccess);
$parcel$export(module.exports, "loginAttemptFailure", () => (parcelRequire("xAy39")).loginAttemptFailure);
$parcel$export(module.exports, "resetLogin", () => (parcelRequire("xAy39")).resetLogin);
$parcel$export(module.exports, "exitTestModeAction", () => (parcelRequire("xAy39")).exitTestModeAction);
$parcel$export(module.exports, "caSsoTestModeFailure", () => (parcelRequire("xAy39")).caSsoTestModeFailure);
$parcel$export(module.exports, "loginConsentFailure", () => (parcelRequire("xAy39")).loginConsentFailure);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => (parcelRequire("xAy39")).CHANGE_EMAIL_INPUT);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => (parcelRequire("xAy39")).CHECK_LOGIN_ACTION);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => (parcelRequire("xAy39")).CHECK_LOGIN_ACTION_FAILURE);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => (parcelRequire("xAy39")).CHECK_LOGIN_ACTION_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => (parcelRequire("xAy39")).FETCH_LOGIN_FAILURE);
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => (parcelRequire("xAy39")).FETCH_LOGIN_SUCCESS);
$parcel$export(module.exports, "CREATE_PASSWORD", () => (parcelRequire("xAy39")).CREATE_PASSWORD);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => (parcelRequire("xAy39")).CREATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => (parcelRequire("xAy39")).FORGOT_PASSWORD);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("xAy39")).FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => (parcelRequire("xAy39")).FORGOT_PASSWORD_FAILURE);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => (parcelRequire("xAy39")).LOGIN_ATTEMPT);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => (parcelRequire("xAy39")).LOGIN_ATTEMPT_SUCCESS);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => (parcelRequire("xAy39")).LOGIN_ATTEMPT_FAILURE);
$parcel$export(module.exports, "RESET_LOGIN", () => (parcelRequire("xAy39")).RESET_LOGIN);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => (parcelRequire("xAy39")).CA_SSO_TEST_MODE_FAILURE);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => (parcelRequire("xAy39")).LOGIN_CONSENT_FAILURE);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => (parcelRequire("xAy39")).EXIT_TEST_MODE_ACTION);

var $xAy39 = parcelRequire("xAy39");

});
parcelRegister("xAy39", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => $51a5b8a7ef00816e$export$839deb1eefe4e515);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => $51a5b8a7ef00816e$export$8cf8563c2d1c6683);
$parcel$export(module.exports, "CREATE_PASSWORD", () => $51a5b8a7ef00816e$export$fe8137105dc1ed9);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => $51a5b8a7ef00816e$export$66c73e13cf8b697a);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => $51a5b8a7ef00816e$export$816b17d1322118b2);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => $51a5b8a7ef00816e$export$f5cb563064a027ff);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => $51a5b8a7ef00816e$export$150db551ad2bf414);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => $51a5b8a7ef00816e$export$e479859894f5f058);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => $51a5b8a7ef00816e$export$e70701c4dc1893e1);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => $51a5b8a7ef00816e$export$7e8a762ed2d6f2d2);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => $51a5b8a7ef00816e$export$f3ad885eaa1b5f72);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => $51a5b8a7ef00816e$export$716c6a62442b28d7);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => $51a5b8a7ef00816e$export$1c3cf2fdaea15601);
$parcel$export(module.exports, "RESET_LOGIN", () => $51a5b8a7ef00816e$export$afec5a557a208da9);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => $51a5b8a7ef00816e$export$98672ea6f23cc2ca);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => $51a5b8a7ef00816e$export$cbb84f780c133cae);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => $51a5b8a7ef00816e$export$82f99ffed31fea50);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => $51a5b8a7ef00816e$export$daf9894dcc19911a);
$parcel$export(module.exports, "fetchLoginSuccess", () => $51a5b8a7ef00816e$export$edced81742fba4bc);
$parcel$export(module.exports, "fetchLoginFailure", () => $51a5b8a7ef00816e$export$d8cdd04268f89e8d);
$parcel$export(module.exports, "checkLoginAction", () => $51a5b8a7ef00816e$export$a4840b835bebc845);
$parcel$export(module.exports, "checkLoginActionSuccess", () => $51a5b8a7ef00816e$export$80f72fff3f8aebd3);
$parcel$export(module.exports, "checkLoginActionFailure", () => $51a5b8a7ef00816e$export$ab186d6cbffedaab);
$parcel$export(module.exports, "loginAttempt", () => $51a5b8a7ef00816e$export$bff2b4217ebde9c3);
$parcel$export(module.exports, "loginAttemptSuccess", () => $51a5b8a7ef00816e$export$4b4199104faef544);
$parcel$export(module.exports, "loginAttemptFailure", () => $51a5b8a7ef00816e$export$6df4ba6cdf3cad7f);
$parcel$export(module.exports, "forgotPassword", () => $51a5b8a7ef00816e$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $51a5b8a7ef00816e$export$2effc3102ad6a101);
$parcel$export(module.exports, "createPasswordSuccess", () => $51a5b8a7ef00816e$export$dc17890d1692fbd);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $51a5b8a7ef00816e$export$e65d2e9031cf7578);
$parcel$export(module.exports, "resetLogin", () => $51a5b8a7ef00816e$export$9a31ad345a1aa336);
$parcel$export(module.exports, "exitTestModeAction", () => $51a5b8a7ef00816e$export$ba564c8e35ce769d);
$parcel$export(module.exports, "changeEmailInput", () => $51a5b8a7ef00816e$export$c55ade57a8bbcea5);
$parcel$export(module.exports, "caSsoTestModeFailure", () => $51a5b8a7ef00816e$export$cf9ecdd9f9c734b3);
$parcel$export(module.exports, "loginConsentFailure", () => $51a5b8a7ef00816e$export$22b3a2f6203607fa);
const $51a5b8a7ef00816e$export$839deb1eefe4e515 = 'state.ui.login.FETCH_LOGIN_SUCCESS';
const $51a5b8a7ef00816e$export$8cf8563c2d1c6683 = 'state.ui.login.FETCH_LOGIN_FAILURE';
const $51a5b8a7ef00816e$export$fe8137105dc1ed9 = 'state.ui.login.CREATE_PASSWORD';
const $51a5b8a7ef00816e$export$66c73e13cf8b697a = 'state.ui.login.CREATE_PASSWORD_SUCCESS';
const $51a5b8a7ef00816e$export$816b17d1322118b2 = 'state.ui.login.CHECK_LOGIN_ACTION';
const $51a5b8a7ef00816e$export$f5cb563064a027ff = 'state.ui.login.CHECK_LOGIN_ACTION_SUCCESS';
const $51a5b8a7ef00816e$export$150db551ad2bf414 = 'state.ui.login.CHECK_LOGIN_ACTION_FAILURE';
const $51a5b8a7ef00816e$export$e479859894f5f058 = 'state.ui.login.FORGOT_PASSWORD';
const $51a5b8a7ef00816e$export$e70701c4dc1893e1 = 'state.ui.login.FORGOT_PASSWORD_SUCCESS';
const $51a5b8a7ef00816e$export$7e8a762ed2d6f2d2 = 'state.ui.login.FORGOT_PASSWORD_FAILURE';
const $51a5b8a7ef00816e$export$f3ad885eaa1b5f72 = 'state.ui.login.LOGIN_ATTEMPT';
const $51a5b8a7ef00816e$export$716c6a62442b28d7 = 'state.ui.login.LOGIN_ATTEMPT_SUCCESS';
const $51a5b8a7ef00816e$export$1c3cf2fdaea15601 = 'state.ui.login.LOGIN_ATTEMPT_FAILURE';
const $51a5b8a7ef00816e$export$afec5a557a208da9 = 'state.ui.login.RESET_LOGIN';
const $51a5b8a7ef00816e$export$98672ea6f23cc2ca = 'state.ui.login.EXIT_TEST_MODE_ACTION';
const $51a5b8a7ef00816e$export$cbb84f780c133cae = 'state.ui.login.CHANGE_EMAIL_INPUT';
const $51a5b8a7ef00816e$export$82f99ffed31fea50 = 'state.ui.login.CA_SSO_TEST_MODE_FAILURE';
const $51a5b8a7ef00816e$export$daf9894dcc19911a = 'state.ui.login.LOGIN_CONSENT_FAILURE';
const $51a5b8a7ef00816e$export$edced81742fba4bc = (loginModel)=>({
        payload: loginModel,
        type: $51a5b8a7ef00816e$export$839deb1eefe4e515
    });
const $51a5b8a7ef00816e$export$d8cdd04268f89e8d = (error)=>({
        type: $51a5b8a7ef00816e$export$8cf8563c2d1c6683,
        payload: {
            error: error
        }
    });
const $51a5b8a7ef00816e$export$a4840b835bebc845 = (email, portalId, authData, createAnalyticsEvent)=>({
        type: $51a5b8a7ef00816e$export$816b17d1322118b2,
        payload: {
            email: email,
            portalId: portalId,
            authData: authData,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $51a5b8a7ef00816e$export$80f72fff3f8aebd3 = (action, authInfo)=>({
        type: $51a5b8a7ef00816e$export$f5cb563064a027ff,
        payload: {
            action: action,
            authInfo: authInfo
        }
    });
const $51a5b8a7ef00816e$export$ab186d6cbffedaab = (error)=>({
        type: $51a5b8a7ef00816e$export$150db551ad2bf414,
        payload: {
            error: error
        }
    });
const $51a5b8a7ef00816e$export$bff2b4217ebde9c3 = (payload)=>({
        payload: payload,
        type: $51a5b8a7ef00816e$export$f3ad885eaa1b5f72
    });
const $51a5b8a7ef00816e$export$4b4199104faef544 = (loginAttemptResponse)=>({
        type: $51a5b8a7ef00816e$export$716c6a62442b28d7,
        payload: {
            loginAttemptResponse: loginAttemptResponse
        }
    });
const $51a5b8a7ef00816e$export$6df4ba6cdf3cad7f = (error)=>({
        type: $51a5b8a7ef00816e$export$1c3cf2fdaea15601,
        payload: {
            error: error
        }
    });
const $51a5b8a7ef00816e$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>({
        type: $51a5b8a7ef00816e$export$e479859894f5f058,
        payload: {
            resetUrl: resetUrl,
            email: email,
            redirectUrl: redirectUrl
        }
    });
const $51a5b8a7ef00816e$export$2effc3102ad6a101 = (resetUrl, email)=>({
        type: $51a5b8a7ef00816e$export$fe8137105dc1ed9,
        payload: {
            resetUrl: resetUrl,
            email: email
        }
    });
const $51a5b8a7ef00816e$export$dc17890d1692fbd = ()=>({
        type: $51a5b8a7ef00816e$export$66c73e13cf8b697a
    });
const $51a5b8a7ef00816e$export$e65d2e9031cf7578 = ()=>({
        type: $51a5b8a7ef00816e$export$e70701c4dc1893e1
    });
const $51a5b8a7ef00816e$export$c82fc620622643dd = (error)=>({
        type: $51a5b8a7ef00816e$export$7e8a762ed2d6f2d2,
        payload: {
            error: error
        }
    });
const $51a5b8a7ef00816e$export$9a31ad345a1aa336 = (email = '')=>({
        type: $51a5b8a7ef00816e$export$afec5a557a208da9,
        payload: {
            email: email
        }
    });
const $51a5b8a7ef00816e$export$ba564c8e35ce769d = (email = '')=>({
        type: $51a5b8a7ef00816e$export$98672ea6f23cc2ca,
        payload: {
            email: email
        }
    });
const $51a5b8a7ef00816e$export$c55ade57a8bbcea5 = (email)=>({
        type: $51a5b8a7ef00816e$export$cbb84f780c133cae,
        payload: {
            email: email
        }
    });
const $51a5b8a7ef00816e$export$cf9ecdd9f9c734b3 = ()=>({
        type: $51a5b8a7ef00816e$export$82f99ffed31fea50
    });
const $51a5b8a7ef00816e$export$22b3a2f6203607fa = ()=>({
        type: $51a5b8a7ef00816e$export$daf9894dcc19911a
    });

});


parcelRegister("1vXf6", function(module, exports) {
$parcel$export(module.exports, "getFirstMessageFromJiraError", () => $68e7a5d720e7f261$export$63b892f0c5ffc91e);
$parcel$export(module.exports, "getJiraErrorOrDefault", () => $68e7a5d720e7f261$export$c3183aaaea823e43);
$parcel$export(module.exports, "getDefaultError", () => $68e7a5d720e7f261$export$7419e04ae130d87b);
$parcel$export(module.exports, "getJiraErrorResponse", () => $68e7a5d720e7f261$export$93579a27d9d34c28);
$parcel$export(module.exports, "genericError", () => $68e7a5d720e7f261$export$28cd364e99d3d2cb);
$parcel$export(module.exports, "getDefaultSignUpError", () => $68e7a5d720e7f261$export$48e9b610f790f75b);
$parcel$export(module.exports, "getDefaultCheckLoginError", () => $68e7a5d720e7f261$export$e35369cd8bc15322);
$parcel$export(module.exports, "isSsoTestModeError", () => $68e7a5d720e7f261$export$ef531073403eb96);
$parcel$export(module.exports, "getUserProfileForgotPasswordFailedError", () => $68e7a5d720e7f261$export$8258d31b06384bf2);

var $cTy7E = parcelRequire("cTy7E");

var $gYDJY = parcelRequire("gYDJY");
const $68e7a5d720e7f261$export$ce1888b50106d3cd = (errorResponse)=>{
    const hasError = errorResponse && errorResponse.errors;
    return hasError ? errorResponse.errors.map((error)=>error && error.errorMessage) : [];
};
const $68e7a5d720e7f261$export$63b892f0c5ffc91e = (errorResponse)=>{
    const errorMessages = $68e7a5d720e7f261$export$ce1888b50106d3cd(errorResponse);
    return errorMessages.length > 0 ? errorMessages[0] : '';
};
const $68e7a5d720e7f261$export$c3183aaaea823e43 = (error)=>{
    const jiraErrorMessage = $68e7a5d720e7f261$export$63b892f0c5ffc91e(error.response);
    if (jiraErrorMessage.length > 0) return {
        errorMessage: jiraErrorMessage
    };
    return $68e7a5d720e7f261$export$7419e04ae130d87b(error);
};
const $68e7a5d720e7f261$export$93579a27d9d34c28 = (error)=>{
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (error.response && error.response.errors) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return error.response;
    return undefined;
};
const $68e7a5d720e7f261$export$7419e04ae130d87b = (error)=>{
    if ($68e7a5d720e7f261$var$isRateLimitedError(error)) return $68e7a5d720e7f261$export$91ba33ab5aae4f04;
    if ($68e7a5d720e7f261$var$isNetworkError(error)) return $68e7a5d720e7f261$export$2b69dc41a4a4ae83();
    return $68e7a5d720e7f261$export$28cd364e99d3d2cb;
};
const $68e7a5d720e7f261$export$48e9b610f790f75b = (error, contactAdminsFormEnabled)=>{
    if ($68e7a5d720e7f261$var$isNetworkError(error)) return $68e7a5d720e7f261$export$2b69dc41a4a4ae83();
    return $68e7a5d720e7f261$export$fb8509ea6df35a83(contactAdminsFormEnabled);
};
const $68e7a5d720e7f261$export$e35369cd8bc15322 = (error)=>{
    const jiraErrorResponse = $68e7a5d720e7f261$export$93579a27d9d34c28(error);
    if (jiraErrorResponse) {
        if ($68e7a5d720e7f261$var$isSignupDomainBlockedError(error)) return $68e7a5d720e7f261$export$7528741a99bb3a62;
        if ($68e7a5d720e7f261$var$isEmailInvalidError(error)) return $68e7a5d720e7f261$export$e97b837fddbca6b3;
    } else if ($68e7a5d720e7f261$var$isNetworkError(error)) return $68e7a5d720e7f261$export$2b69dc41a4a4ae83();
    return $68e7a5d720e7f261$export$28cd364e99d3d2cb;
};
const $68e7a5d720e7f261$export$ef531073403eb96 = (error)=>$68e7a5d720e7f261$export$93579a27d9d34c28(error) && $68e7a5d720e7f261$var$isSsoTestModeFailure(error);
const $68e7a5d720e7f261$export$fb8509ea6df35a83 = (contactAdminsFormEnabled)=>{
    const noContactDescription = (0, $cTy7E.GenericSignUpErrorNoContactLinkDescription);
    const description = contactAdminsFormEnabled ? (0, $cTy7E.GenericSignUpErrorDescriptionUnified) : noContactDescription;
    return {
        description: description,
        title: (0, $cTy7E.GenericErrorTitle),
        action: $68e7a5d720e7f261$var$getGenericErrorFlagActions()
    };
};
const $68e7a5d720e7f261$var$isNetworkError = (errorResponse)=>errorResponse.status === 0;
const $68e7a5d720e7f261$var$isSignupDomainBlockedError = (errorResponse)=>{
    var _errorResponse$respon, _errorResponse$respon2;
    return errorResponse.status === 403 && (((_errorResponse$respon = errorResponse.response) === null || _errorResponse$respon === void 0 ? void 0 : _errorResponse$respon.reasonKey) === 'sd.customer.management.rest.error.customer.account.signup.blocked' || ((_errorResponse$respon2 = errorResponse.response) === null || _errorResponse$respon2 === void 0 ? void 0 : _errorResponse$respon2.reasonKey) === 'customer-signup-domain-blocked');
};
const $68e7a5d720e7f261$var$isEmailInvalidError = (errorResponse)=>{
    var _errorResponse$respon3;
    return errorResponse.status === 400 && ((_errorResponse$respon3 = errorResponse.response) === null || _errorResponse$respon3 === void 0 ? void 0 : _errorResponse$respon3.reasonKey) === 'signup.error.email.valid';
};
const $68e7a5d720e7f261$var$isSsoTestModeFailure = (errorResponse)=>{
    var _errorResponse$respon4;
    return errorResponse.status === 400 && ((_errorResponse$respon4 = errorResponse.response) === null || _errorResponse$respon4 === void 0 ? void 0 : _errorResponse$respon4.reasonKey) === 'CA_SSO_TEST_MODE_NOT_ENABLED';
};
const $68e7a5d720e7f261$var$isRateLimited = (errorResponse)=>errorResponse.status === 429;
const $68e7a5d720e7f261$var$isRateLimitedError = (errorResponse)=>{
    var _errorResponse$respon5;
    return $68e7a5d720e7f261$var$isRateLimited(errorResponse) && ((_errorResponse$respon5 = errorResponse.response) === null || _errorResponse$respon5 === void 0 ? void 0 : _errorResponse$respon5.reasonKey) === 'sd.email.signup.email.rate.limited';
};
const $68e7a5d720e7f261$var$getGenericErrorFlagActions = ()=>({
        href: (0, $gYDJY.location)().href,
        content: (0, $cTy7E.GenericErrorRefreshPageAction)
    });
const $68e7a5d720e7f261$export$2b69dc41a4a4ae83 = ()=>$68e7a5d720e7f261$export$5bd59b549d90b63;
const $68e7a5d720e7f261$export$5bd59b549d90b63 = {
    title: (0, $cTy7E.NoNetworkTitle),
    description: (0, $cTy7E.NoNetworkDescription)
};
const $68e7a5d720e7f261$export$91ba33ab5aae4f04 = {
    title: (0, $cTy7E.GenericErrorTitle),
    description: (0, $cTy7E.SignupEmailResendRateLimitedDescription)
};
const $68e7a5d720e7f261$export$7528741a99bb3a62 = {
    title: (0, $cTy7E.SignupDomainBlockedTitle),
    description: (0, $cTy7E.SignupDomainBlockedDescription)
};
const $68e7a5d720e7f261$export$e97b837fddbca6b3 = {
    title: (0, $cTy7E.InvalidEmailTitle),
    description: (0, $cTy7E.InvalidEmailDescription)
};
const $68e7a5d720e7f261$export$28cd364e99d3d2cb = {
    title: (0, $cTy7E.GenericErrorTitle),
    description: (0, $cTy7E.GenericErrorDescription),
    action: $68e7a5d720e7f261$var$getGenericErrorFlagActions()
};
const $68e7a5d720e7f261$var$genericUserProfileForgotPasswordFailedError = {
    title: (0, $cTy7E.UserProfileForgotPasswordFailedErrorTitle),
    description: (0, $cTy7E.UserProfileForgotPasswordFailedErrorDescription)
};
const $68e7a5d720e7f261$export$3cd8f5c164dad65c = {
    title: (0, $cTy7E.UserProfileForgotPasswordRateLimitedErrorTitle),
    description: (0, $cTy7E.UserProfileForgotPasswordRateLimitedErrorDescription)
};
const $68e7a5d720e7f261$export$8258d31b06384bf2 = (error)=>{
    if ($68e7a5d720e7f261$var$isNetworkError(error)) return $68e7a5d720e7f261$export$2b69dc41a4a4ae83();
    if ($68e7a5d720e7f261$var$isRateLimited(error)) return $68e7a5d720e7f261$export$3cd8f5c164dad65c;
    return $68e7a5d720e7f261$var$genericUserProfileForgotPasswordFailedError;
};

});
parcelRegister("cTy7E", function(module, exports) {
$parcel$export(module.exports, "GenericErrorTitle", () => $ebca1cb9ccb418e8$export$e882af1f191f98ed);
$parcel$export(module.exports, "GenericErrorDescription", () => $ebca1cb9ccb418e8$export$435282e749b7e900);
$parcel$export(module.exports, "GenericSignUpErrorDescriptionUnified", () => $ebca1cb9ccb418e8$export$814e1ad271462eee);
$parcel$export(module.exports, "GenericSignUpErrorNoContactLinkDescription", () => $ebca1cb9ccb418e8$export$53a250c0a0614ddf);
$parcel$export(module.exports, "RefreshPageLinkText", () => $ebca1cb9ccb418e8$export$2c865db45566f3fc);
$parcel$export(module.exports, "TellUsAboutIssueLinkText", () => $ebca1cb9ccb418e8$export$4cd0b637ea791e58);
$parcel$export(module.exports, "LetUsKnowLinkText", () => $ebca1cb9ccb418e8$export$91b106f2d7a60f86);
$parcel$export(module.exports, "GenericErrorRefreshPageAction", () => $ebca1cb9ccb418e8$export$20483281c243b1a0);
$parcel$export(module.exports, "NoNetworkTitle", () => $ebca1cb9ccb418e8$export$b0cc5cbdc11d8431);
$parcel$export(module.exports, "SignupEmailResendRateLimitedDescription", () => $ebca1cb9ccb418e8$export$fdbfe2d9101e694);
$parcel$export(module.exports, "NoNetworkDescription", () => $ebca1cb9ccb418e8$export$d349948b740c510b);
$parcel$export(module.exports, "SignupDomainBlockedDescription", () => $ebca1cb9ccb418e8$export$f1af5cb5b09d8e91);
$parcel$export(module.exports, "SignupDomainBlockedTitle", () => $ebca1cb9ccb418e8$export$23a02d68ec91feaf);
$parcel$export(module.exports, "InvalidEmailTitle", () => $ebca1cb9ccb418e8$export$593b1e00f52b5f5e);
$parcel$export(module.exports, "InvalidEmailDescription", () => $ebca1cb9ccb418e8$export$82cbc81342a448dd);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorTitle", () => $ebca1cb9ccb418e8$export$6e2b8a076a84e30b);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorDescription", () => $ebca1cb9ccb418e8$export$eb78dd4efec095b1);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorTitle", () => $ebca1cb9ccb418e8$export$17669172b666864);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorDescription", () => $ebca1cb9ccb418e8$export$6daa483c0f823589);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("cSbPZ")).default);

var $cSbPZ = parcelRequire("cSbPZ");

var $ji8Ja = parcelRequire("ji8Ja");
const $ebca1cb9ccb418e8$export$e882af1f191f98ed = (0, $ji8Ja.default).genericErrorTitle;
const $ebca1cb9ccb418e8$export$435282e749b7e900 = (0, $ji8Ja.default).genericErrorDescription;
const $ebca1cb9ccb418e8$export$814e1ad271462eee = (0, $ji8Ja.default).genericSignUpErrorDescriptionUnified;
const $ebca1cb9ccb418e8$export$53a250c0a0614ddf = (0, $ji8Ja.default).genericSignUpErrorNoContactLinkDescription;
const $ebca1cb9ccb418e8$export$2c865db45566f3fc = (0, $ji8Ja.default).refreshPageLinkText;
const $ebca1cb9ccb418e8$export$4cd0b637ea791e58 = (0, $ji8Ja.default).tellUsAboutIssueLinkText;
const $ebca1cb9ccb418e8$export$91b106f2d7a60f86 = (0, $ji8Ja.default).letUsKnowLinkText;
const $ebca1cb9ccb418e8$export$20483281c243b1a0 = (0, $ji8Ja.default).genericErrorRefreshPageAction;
const $ebca1cb9ccb418e8$export$b0cc5cbdc11d8431 = (0, $ji8Ja.default).noNetworkTitle;
const $ebca1cb9ccb418e8$export$fdbfe2d9101e694 = (0, $ji8Ja.default).signupEmailResendRateLimitedDescription;
const $ebca1cb9ccb418e8$export$d349948b740c510b = (0, $ji8Ja.default).noNetworkDescription;
const $ebca1cb9ccb418e8$export$f1af5cb5b09d8e91 = (0, $ji8Ja.default).blockedDescription;
const $ebca1cb9ccb418e8$export$23a02d68ec91feaf = (0, $ji8Ja.default).blockedTitle;
const $ebca1cb9ccb418e8$export$593b1e00f52b5f5e = (0, $ji8Ja.default).invalidEmailTitle;
const $ebca1cb9ccb418e8$export$82cbc81342a448dd = (0, $ji8Ja.default).invalidEmailDescription;
const $ebca1cb9ccb418e8$export$6e2b8a076a84e30b = (0, $ji8Ja.default).userProfileForgotPasswordFailedFlagTitle;
const $ebca1cb9ccb418e8$export$eb78dd4efec095b1 = (0, $ji8Ja.default).userProfileForgotPasswordFailedFlagDescription;
const $ebca1cb9ccb418e8$export$17669172b666864 = (0, $ji8Ja.default).userProfileForgotPasswordRateLimitedFlagTitle;
const $ebca1cb9ccb418e8$export$6daa483c0f823589 = (0, $ji8Ja.default).userProfileForgotPasswordRateLimitedFlagDescription;

});
parcelRegister("cSbPZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $258028ebfc68aa30$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $xb2jO = parcelRequire("xb2jO");
parcelRequire("fGsCH");
var $lDuQl = parcelRequire("lDuQl");

var $dw4HG = parcelRequire("dw4HG");
const $258028ebfc68aa30$var$selector = (0, $BOq7h.createSelector)((state)=>(0, $lDuQl.getFlags)(state), (flags)=>({
        flags: flags
    }));
var $258028ebfc68aa30$export$2e2bcd8739ae039 = (0, $f2mlD.default)($258028ebfc68aa30$var$selector, {
    dismissFlagAction: (0, $xb2jO.dismissFlag)
})((0, $dw4HG.default));

});
parcelRegister("BOq7h", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $071a91393b697f17$export$595d22ed68ca2841, (v) => $071a91393b697f17$export$595d22ed68ca2841 = v);
var $071a91393b697f17$export$1e511d4a378977f5;
var $071a91393b697f17$export$281bff7f05488aa2;
var $071a91393b697f17$export$5943f4447f6ef248;
var $071a91393b697f17$export$75979cfcd91bf38f;
var $071a91393b697f17$export$595d22ed68ca2841;
'use strict';
$071a91393b697f17$export$1e511d4a378977f5 = true;
$071a91393b697f17$export$281bff7f05488aa2 = $071a91393b697f17$var$defaultMemoize;
$071a91393b697f17$export$5943f4447f6ef248 = $071a91393b697f17$var$createSelectorCreator;
$071a91393b697f17$export$75979cfcd91bf38f = $071a91393b697f17$var$createStructuredSelector;
function $071a91393b697f17$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $071a91393b697f17$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $071a91393b697f17$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $071a91393b697f17$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$071a91393b697f17$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $071a91393b697f17$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $071a91393b697f17$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $071a91393b697f17$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $071a91393b697f17$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $071a91393b697f17$var$createSelector = $071a91393b697f17$export$595d22ed68ca2841 = $071a91393b697f17$var$createSelectorCreator($071a91393b697f17$var$defaultMemoize);
function $071a91393b697f17$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $071a91393b697f17$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("fGsCH", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => (parcelRequire("lDuQl")).getFlags);

var $lDuQl = parcelRequire("lDuQl");

});
parcelRegister("lDuQl", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => $71605a2f13fdf96d$export$d5815430bcc75df0);
const $71605a2f13fdf96d$export$d5815430bcc75df0 = (state)=>{
    return state.ui.flags.flags;
};

});


parcelRegister("dw4HG", function(module, exports) {
$parcel$export(module.exports, "default", () => $aafa358b15740664$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5ZSSZ");
var $4bEdp = parcelRequire("4bEdp");
class $aafa358b15740664$export$2e2bcd8739ae039 extends $bSJIT.Component {
    render() {
        const { flags: flags, dismissFlagAction: dismissFlagAction } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $4bEdp.default), {
            flags: flags,
            dismissFlagAction: dismissFlagAction
        });
    }
}

});
parcelRegister("5ZSSZ", function(module, exports) {
$parcel$export(module.exports, "FlagGroupStateless", () => (parcelRequire("4bEdp")).default);

var $4bEdp = parcelRequire("4bEdp");

});
parcelRegister("4bEdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd84c872f577f8a3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $lJzMO = parcelRequire("lJzMO");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $cBVmT = parcelRequire("cBVmT");

var $68E0O = parcelRequire("68E0O");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");
const $bd84c872f577f8a3$var$isSuccessFlagAction = (flagAction)=>{
    return 'contentNode' in flagAction && !!flagAction.contentNode;
};
class $bd84c872f577f8a3$export$bf63ac67069f812 extends $bSJIT.Component {
    render() {
        const { flags: flags } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $lJzMO.default), {
            onDismissed: this.handleFlagDismissed
        }, flags.map((flag)=>this.renderFlag(flag)));
    }
    constructor(...args){
        super(...args), this.handleFlagDismissed = (flagId)=>{
            this.props.dismissFlagAction(flagId);
        }, this.i18nFlagActions = (actions)=>{
            const { intl: intl } = this.props;
            return actions.map((action)=>{
                return $bd84c872f577f8a3$var$isSuccessFlagAction(action) ? {
                    content: action.contentNode,
                    href: action === null || action === void 0 ? void 0 : action.href
                } : {
                    content: intl.formatMessage(action.content),
                    href: action.href
                };
            });
        }, this.getIcon = (flag)=>{
            switch(flag.type){
                case 'error':
                    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'warning':
                    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-warning, #FF8B00)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'success':
                    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #36B37E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'bold':
                    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-information, #42526E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                default:
                    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
            }
        }, this.renderFlag = (flag)=>{
            const { intl: intl } = this.props;
            if (flag.type === 'bold') {
                const dismissAction = [];
                if (flag.dismissActionValue) dismissAction.push({
                    content: intl.formatMessage(flag.dismissActionValue),
                    onClick: ()=>{
                        this.handleFlagDismissed(flag.id);
                    }
                });
                return /*#__PURE__*/ $bSJIT.createElement((0, $eJ0Uu.default), {
                    appearance: flag.appearance,
                    id: flag.id,
                    key: flag.id,
                    icon: this.getIcon(flag),
                    title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                    description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                    actions: [
                        ...flag.actions,
                        ...dismissAction
                    ]
                });
            }
            return /*#__PURE__*/ $bSJIT.createElement((0, $eJ0Uu.default), {
                id: flag.id,
                key: flag.id,
                icon: this.getIcon(flag),
                title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                actions: this.i18nFlagActions(flag.actions)
            });
        };
    }
}
var $bd84c872f577f8a3$export$2e2bcd8739ae039 = (0, $fK3tS.default)($bd84c872f577f8a3$export$bf63ac67069f812);

});
parcelRegister("lJzMO", function(module, exports) {
$parcel$export(module.exports, "FlagGroup", () => $07c91fd83ca4ffce$export$a2c3479950310d7d);
$parcel$export(module.exports, "default", () => $07c91fd83ca4ffce$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $bAB3U = parcelRequire("bAB3U");

var $6WltM = parcelRequire("6WltM");

var $c9wRy = parcelRequire("c9wRy");

var $jDsoo = parcelRequire("jDsoo");

var $1OdZP = parcelRequire("1OdZP");

var $iRdwF = parcelRequire("iRdwF");

var $jvbf5 = parcelRequire("jvbf5");

var $lqv8M = parcelRequire("lqv8M");

var $gdUUy = parcelRequire("gdUUy");

var $cglph = parcelRequire("cglph");

var $9PwDt = parcelRequire("9PwDt");

var $juI4y = parcelRequire("juI4y");

var $jfBg8 = parcelRequire("jfBg8");

var $9Abbn = parcelRequire("9Abbn");

var $gCqt0 = parcelRequire("gCqt0");

var $6815P = parcelRequire("6815P");
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $07c91fd83ca4ffce$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $07c91fd83ca4ffce$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $07c91fd83ca4ffce$var$dismissAllowedStyles = null;
const $07c91fd83ca4ffce$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $07c91fd83ca4ffce$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $07c91fd83ca4ffce$var$flagGroupContainerStylesSymmetric = null;
const $07c91fd83ca4ffce$export$a2c3479950310d7d = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $1OdZP.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $bSJIT.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const latestRef = (0, $bSJIT.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $bSJIT.useEffect)(()=>{
        if (!(0, $gdUUy.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $c9wRy.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, $bAB3U.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                var _props;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = (_props = firstFlag.props) === null || _props === void 0 ? void 0 : _props.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    var _latestRef$current$on, _latestRef$current;
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    (_latestRef$current$on = (_latestRef$current = latestRef.current).onDismissed) === null || _latestRef$current$on === void 0 || _latestRef$current$on.call(_latestRef$current, id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $bSJIT.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $gdUUy.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                xcss: (0, $jDsoo.cx)($07c91fd83ca4ffce$var$groupStylesNew.root, index === 0 && $07c91fd83ca4ffce$var$groupStylesNew.first, index === 1 && $07c91fd83ca4ffce$var$groupStylesNew.second, index >= 2 && $07c91fd83ca4ffce$var$groupStylesNew.nth, index >= 3 && $07c91fd83ca4ffce$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iRdwF.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6815P.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, $gCqt0.defaultFlagGroupContext),
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $lqv8M.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $9fU1q.default)([
                            $07c91fd83ca4ffce$var$groupStyles.root,
                            index === 0 && $07c91fd83ca4ffce$var$groupStyles.first,
                            index === 1 && $07c91fd83ca4ffce$var$groupStyles.second,
                            index >= 1 && $07c91fd83ca4ffce$var$groupStyles.nth,
                            index >= 2 && $07c91fd83ca4ffce$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6815P.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, $gCqt0.defaultFlagGroupContext),
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const useTopLayer = (0, $gdUUy.fg)('platform-dst-top-layer');
    const useSymmetricAnchor = (0, $gdUUy.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $gdUUy.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $9fU1q.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                children: /*#__PURE__*/ (0, $dc70d.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    if (useTopLayer) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jfBg8.Popover), {
        mode: "manual",
        isOpen: true,
        children: flags
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cglph.default), {
        zIndex: (0, $juI4y.layers).flag(),
        children: flags
    });
};
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$07c91fd83ca4ffce$export$2e2bcd8739ae039 = $07c91fd83ca4ffce$export$a2c3479950310d7d;

});
parcelRegister("jDsoo", function(module, exports) {
$parcel$export(module.exports, "cx", () => $eb55afcdaa9d7ccf$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("bSJIT");

var $bJmKt = parcelRequire("bJmKt");
const $eb55afcdaa9d7ccf$var$strictApi = (0, $bJmKt.createStrictAPI)();
const $eb55afcdaa9d7ccf$export$dbf350e5966cf602 = $eb55afcdaa9d7ccf$var$strictApi.css;
const $eb55afcdaa9d7ccf$export$eb1ecd84a24ee424 = $eb55afcdaa9d7ccf$var$strictApi.cssMap;
$eb55afcdaa9d7ccf$var$strictApi.cssMap;
const $eb55afcdaa9d7ccf$export$a274e22fb40f762e = $eb55afcdaa9d7ccf$var$strictApi.cx;
const $eb55afcdaa9d7ccf$var$XCSSProp = $eb55afcdaa9d7ccf$var$strictApi.XCSSProp;

});
parcelRegister("bJmKt", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $88a58b107b1660b8$export$39716b4af53f4ad);

var $h0oGH = parcelRequire("h0oGH");

var $14TCm = parcelRequire("14TCm");
function $88a58b107b1660b8$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $h0oGH.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $h0oGH.createStrictSetupError)();
        },
        cx: $14TCm.cx,
        XCSSProp () {
            throw (0, $h0oGH.createStrictSetupError)();
        }
    };
}

});
parcelRegister("h0oGH", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $c6159638cd35a9e4$export$c4df1cb0c2b4d77c);
const $c6159638cd35a9e4$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $c6159638cd35a9e4$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("iRdwF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7399b66e21409d1$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $gdUUy = parcelRequire("gdUUy");

var $vPAqS = parcelRequire("vPAqS");

var $4tNCH = parcelRequire("4tNCH");

var $iWZGm = parcelRequire("iWZGm");

var $2IxoV = parcelRequire("2IxoV");

var $guzQ3 = parcelRequire("guzQ3");

var $8Mgn9 = parcelRequire("8Mgn9");

var $lvHAN = parcelRequire("lvHAN");

var $z8N4c = parcelRequire("z8N4c");
const $a7399b66e21409d1$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const $a7399b66e21409d1$var$MotionLegacy = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $z8N4c.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8Mgn9.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $bSJIT.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $bSJIT.useRef)(null);
    const reanimateRef = (0, $bSJIT.useRef)();
    const animationRef = (0, $bSJIT.useRef)();
    const staggeredEntryRef = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $bSJIT.useEffect)(()=>{
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $bSJIT.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $guzQ3.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $guzQ3.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $iWZGm.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $4tNCH.getDurationMs)((0, $2IxoV.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $vPAqS.getComputedAnimationDurationMs)(styles.animationName, styles.animationDuration, styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $bSJIT.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $guzQ3.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $guzQ3.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            hasAnimationStyles && $a7399b66e21409d1$var$styles.base,
            state === 'init' && $a7399b66e21409d1$var$styles.hidden,
            (0, $jDsoo.cx)(xcss, customAnimation)
        ]),
        ref: (0, $fGbV9.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? {
            ...styleProp,
            ...style
        } : undefined,
        "data-testid": testId,
        children: children
    });
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const $a7399b66e21409d1$var$MotionNext = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $lvHAN.useMotion)({
        onFinish: onFinishMotion
    });
    (0, $bSJIT.useImperativeHandle)(ref, ()=>({
            reanimate: reanimate
        }), [
        reanimate
    ]);
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            state === 'init' && $a7399b66e21409d1$var$styles.hidden,
            (0, $jDsoo.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...styleProp,
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        },
        "data-testid": testId,
        children: children
    });
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ const $a7399b66e21409d1$var$Motion = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    if ((0, $gdUUy.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, $dc70d.jsx)($a7399b66e21409d1$var$MotionNext, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($a7399b66e21409d1$var$MotionLegacy, {
        ...props,
        ref: ref
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a7399b66e21409d1$export$2e2bcd8739ae039 = $a7399b66e21409d1$var$Motion;

});
parcelRegister("vPAqS", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $8569218865e9072a$export$dd9b73a7482d05b6);

var $h36IQ = parcelRequire("h36IQ");
const $8569218865e9072a$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
const $8569218865e9072a$var$toCssList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean);
const $8569218865e9072a$var$toTimeList = (value)=>$8569218865e9072a$var$toCssList(value).filter((time)=>$8569218865e9072a$var$cssTimePattern.test(time)).map((0, $h36IQ.convertToMs));
const $8569218865e9072a$export$dd9b73a7482d05b6 = (animationName, animationDuration, animationDelay)=>{
    const names = $8569218865e9072a$var$toCssList(animationName);
    const durations = $8569218865e9072a$var$toTimeList(animationDuration);
    const delays = $8569218865e9072a$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    let longestDuration = 0;
    for(let index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        const duration = durations[index % durations.length];
        const delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("h36IQ", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $8dec634ed83c9ef4$export$75eee42ff540d8ae);
const $8dec634ed83c9ef4$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("4tNCH", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $78fccb546b101d72$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $78fccb546b101d72$export$d0038b6e47881463 = (animation)=>{
    const animations = animation.split(/,(?![^()]*\))/).map((value)=>[
            ...value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
        ]).filter((matches)=>matches.length > 0);
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce((longest, matches)=>{
        const toMilliseconds = (match)=>{
            const value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        const timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("2IxoV", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $7926e08b843c7b1a$export$82b92541889a035d);

var $c9wRy = parcelRequire("c9wRy");
const $7926e08b843c7b1a$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        const documentElement = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("guzQ3", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $26ec1ada9df58598$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $26ec1ada9df58598$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("lvHAN", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $defe03c6202f5ad5$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Exposes start and finish callbacks while useMotion coordinates the animation lifecycle.

var $bSJIT = parcelRequire("bSJIT");

var $fGbV9 = parcelRequire("fGbV9");

var $vPAqS = parcelRequire("vPAqS");

var $4tNCH = parcelRequire("4tNCH");

var $iWZGm = parcelRequire("iWZGm");

var $2IxoV = parcelRequire("2IxoV");

var $4Ajbl = parcelRequire("4Ajbl");

var $guzQ3 = parcelRequire("guzQ3");

var $8Mgn9 = parcelRequire("8Mgn9");

var $z8N4c = parcelRequire("z8N4c");
function $defe03c6202f5ad5$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, onStart: onStartMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $iWZGm.isReducedMotion)();
    const staggered = (0, $z8N4c.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8Mgn9.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $bSJIT.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'));
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    const motionState = isExiting ? 'exiting' : state;
    const elementRef = (0, $bSJIT.useRef)(null);
    const onFinishMotionRef = (0, $bSJIT.useRef)(onFinishMotion);
    onFinishMotionRef.current = onFinishMotion;
    const onStartMotionRef = (0, $bSJIT.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    const onExitFinishedRef = (0, $bSJIT.useRef)(onExitFinished);
    onExitFinishedRef.current = onExitFinished;
    const reanimateRef = (0, $bSJIT.useRef)();
    const animationRef = (0, $bSJIT.useRef)();
    const staggeredEntryRef = (0, $bSJIT.useRef)();
    (0, $4Ajbl.useLayoutEffect)(()=>{
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $bSJIT.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            var _onFinishMotionRef$cu;
            if (!reanimateRef.current) {
                var _onExitFinishedRef$cu;
                // Updates the `ExitingPersistence` to remove this child
                (_onExitFinishedRef$cu = onExitFinishedRef.current) === null || _onExitFinishedRef$cu === void 0 || _onExitFinishedRef$cu.call(onExitFinishedRef);
            }
            (_onFinishMotionRef$cu = onFinishMotionRef.current) === null || _onFinishMotionRef$cu === void 0 || _onFinishMotionRef$cu.call(onFinishMotionRef, 'exiting');
        }
        if (currentState === 'entering') {
            var _onFinishMotionRef$cu2;
            (_onFinishMotionRef$cu2 = onFinishMotionRef.current) === null || _onFinishMotionRef$cu2 === void 0 || _onFinishMotionRef$cu2.call(onFinishMotionRef, 'entering');
        }
        if (reanimateRef.current === (0, $guzQ3.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $guzQ3.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $guzQ3.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $guzQ3.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Handles staggered entry
    (0, $bSJIT.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $4tNCH.getDurationMs)((0, $2IxoV.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $vPAqS.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $bSJIT.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $guzQ3.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $guzQ3.Reanimate).enter) setState('entering');
        else if (value === (0, $guzQ3.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $bSJIT.useMemo)(()=>(0, $fGbV9.default)([
            staggered.ref,
            elementRef
        ]), [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});


parcelRegister("lqv8M", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27a835bdc7619e5$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3eoZ6 = parcelRequire("3eoZ6");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $e27a835bdc7619e5$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3eoZ6.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $e27a835bdc7619e5$export$2e2bcd8739ae039 = $e27a835bdc7619e5$var$SlideIn;

});

parcelRegister("9PwDt", function(module, exports) {
$parcel$export(module.exports, "Box", () => $0d2290025966a3f7$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ /* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $dHEk9 = parcelRequire("dHEk9");
const $0d2290025966a3f7$var$baseStyles = null;
const $0d2290025966a3f7$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $0d2290025966a3f7$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $0d2290025966a3f7$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $0d2290025966a3f7$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $0d2290025966a3f7$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $0d2290025966a3f7$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $0d2290025966a3f7$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
const $0d2290025966a3f7$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9fU1q.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $0d2290025966a3f7$var$backgroundColorMap[backgroundColor],
            backgroundColor && $0d2290025966a3f7$var$isSurfaceToken(backgroundColor) && $0d2290025966a3f7$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $0d2290025966a3f7$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $0d2290025966a3f7$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $0d2290025966a3f7$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $0d2290025966a3f7$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dHEk9.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
function $0d2290025966a3f7$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $0d2290025966a3f7$var$setSurfaceTokenMap;
}

});

parcelRegister("gCqt0", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $f30bbdf9449be6b5$export$643760c4938da30d);

var $1OdZP = parcelRequire("1OdZP");
const $f30bbdf9449be6b5$export$643760c4938da30d = {
    onDismissed: (0, $1OdZP.default),
    isDismissAllowed: false
};

});

parcelRegister("6815P", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $588dcc60d19d053c$export$c57ba665aaa722be);

var $bSJIT = parcelRequire("bSJIT");

var $gCqt0 = parcelRequire("gCqt0");
const $588dcc60d19d053c$export$c57ba665aaa722be = /*#__PURE__*/ (0, $bSJIT.createContext)((0, $gCqt0.defaultFlagGroupContext));

});


parcelRegister("eJ0Uu", function(module, exports) {
$parcel$export(module.exports, "default", () => $24a0dc84d1d93f92$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $2bmUD = parcelRequire("2bmUD");

var $2HPPa = parcelRequire("2HPPa");
const $24a0dc84d1d93f92$var$packageName = undefined;
const $24a0dc84d1d93f92$var$packageVersion = undefined;
const $24a0dc84d1d93f92$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $24a0dc84d1d93f92$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $1OdZP.default), autoDismissSeconds: autoDismissSeconds = $24a0dc84d1d93f92$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $bSJIT.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $2HPPa.useFlagGroup)();
    const onDismissed = (0, $bSJIT.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $24a0dc84d1d93f92$var$packageName,
        packageVersion: $24a0dc84d1d93f92$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $bSJIT.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $bSJIT.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $bSJIT.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $bSJIT.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2bmUD.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $24a0dc84d1d93f92$export$2e2bcd8739ae039 = $24a0dc84d1d93f92$var$AutoDismissFlag;

});
parcelRegister("2bmUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $686e66c45f878585$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $7WQx2 = parcelRequire("7WQx2");

var $2HQOV = parcelRequire("2HQOV");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $9Abbn = parcelRequire("9Abbn");

var $aKeQm = parcelRequire("aKeQm");

var $36x0I = parcelRequire("36x0I");

var $28bcj = parcelRequire("28bcj");

var $6nkTn = parcelRequire("6nkTn");

var $HJ3uu = parcelRequire("HJ3uu");

var $wysLF = parcelRequire("wysLF");

var $3ekrI = parcelRequire("3ekrI");

var $lU62j = parcelRequire("lU62j");

var $2aHo6 = parcelRequire("2aHo6");

var $2HPPa = parcelRequire("2HPPa");
const $686e66c45f878585$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rko1mok _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    contentStack: "_k8m01vax _1oec1mzy _156yru3m"
};
const $686e66c45f878585$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $686e66c45f878585$var$descriptionStyles = null;
const $686e66c45f878585$var$flagWrapperStyles = null;
const $686e66c45f878585$var$iconWrapperStyles = null;
const $686e66c45f878585$var$transitionStyles = null;
const $686e66c45f878585$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const $686e66c45f878585$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $aKeQm.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $1OdZP.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $1OdZP.default), onDismissed: onDismissedProp = (0, $1OdZP.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $bSJIT.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $2HPPa.useFlagGroup)();
    const onDismissed = (0, $bSJIT.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $bSJIT.useState)(false);
    const onDismissedAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$686e66c45f878585$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $aKeQm.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $bSJIT.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $bSJIT.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$686e66c45f878585$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$686e66c45f878585$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $wysLF.flagTextColor)[appearance];
    const iconColor = (0, $6nkTn.flagIconColor)[appearance];
    const iconGlyph = (0, $HJ3uu.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    const isCollapseAnimationEnabled = (0, $gdUUy.fg)('platform-dst-flag-collapse-animation-fix');
    // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $2HQOV.default), {
            children: [
                title,
                description
            ]
        })
    }) : undefined;
    // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $9fU1q.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
            padding: "space.200",
            backgroundColor: (0, $28bcj.flagBackgroundColor)[appearance],
            xcss: $686e66c45f878585$var$styles.flag,
            children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            [$686e66c45f878585$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $9fU1q.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                        className: (0, $9fU1q.default)([
                            "_v5641hdc _1ul9idpf _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            xcss: isCollapseAnimationEnabled ? $686e66c45f878585$var$styles.contentStack : undefined,
                            testId: testId && `${testId}-content-stack`,
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $686e66c45f878585$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                                                        children: title
                                                    })
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $lU62j.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dc70d.jsxs)((0, $2aHo6.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            style: {
                                                color: (0, $3ekrI.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                            className: (0, $9fU1q.default)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $36x0I.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $686e66c45f878585$export$2e2bcd8739ae039 = $686e66c45f878585$var$Flag;

});
parcelRegister("2HQOV", function(module, exports) {
$parcel$export(module.exports, "default", () => $381dc42d6ede0628$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $jvbf5 = parcelRequire("jvbf5");
function $381dc42d6ede0628$export$2e2bcd8739ae039({ children: children }) {
    return (0, $gdUUy.fg)('platform-dst-motion-isolate-presence') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.ExitingContext).Provider, {
        value: (0, $jvbf5.defaultExitingContext),
        children: children
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children
    });
}

});

parcelRegister("fZ0ZI", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $984b908194b92028$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ /* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jDsoo = parcelRequire("jDsoo");

var $6X9z7 = parcelRequire("6X9z7");
const $984b908194b92028$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $984b908194b92028$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            $984b908194b92028$var$styles.separator
        ]),
        children: children
    });
const $984b908194b92028$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $dc70d.jsx)($984b908194b92028$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $bSJIT.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $jDsoo.cx)(grow === 'hug' && $984b908194b92028$var$styles.hug, grow === 'fill' && $984b908194b92028$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$984b908194b92028$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("6X9z7", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $c187b39195ddbdd9$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $c187b39195ddbdd9$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz",
    'space.gap.xxsmall': "_1p571j29",
    'space.gap.xsmall': "_1p57t24t",
    'space.gap.small': "_1p57e2kt",
    'space.gap.medium': "_1p57slki",
    'space.gap.large': "_1p571l0c",
    'space.gap.xlarge': "_1p571a4g",
    'space.gap.xxlarge': "_1p57rdp2"
};
const $c187b39195ddbdd9$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz",
    'space.gap.xxsmall': "_gy1p1j29",
    'space.gap.xsmall': "_gy1pt24t",
    'space.gap.small': "_gy1pe2kt",
    'space.gap.medium': "_gy1pslki",
    'space.gap.large': "_gy1p1l0c",
    'space.gap.xlarge': "_gy1p1a4g",
    'space.gap.xxlarge': "_gy1prdp2"
};
const $c187b39195ddbdd9$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $c187b39195ddbdd9$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $c187b39195ddbdd9$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $c187b39195ddbdd9$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $c187b39195ddbdd9$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
const $c187b39195ddbdd9$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $9fU1q.default)([
            $c187b39195ddbdd9$var$styles.root,
            gap && $c187b39195ddbdd9$var$columnGapMap[gap],
            columnGap && $c187b39195ddbdd9$var$columnGapMap[columnGap],
            gap && $c187b39195ddbdd9$var$rowGapMap[gap],
            rowGap && $c187b39195ddbdd9$var$rowGapMap[rowGap],
            alignItems && $c187b39195ddbdd9$var$alignItemsMap[alignItems],
            direction && $c187b39195ddbdd9$var$flexDirectionMap[direction],
            justifyContent && $c187b39195ddbdd9$var$justifyContentMap[justifyContent],
            wrap && $c187b39195ddbdd9$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$c187b39195ddbdd9$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("dDEhr", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $9ecf047fc9b5cda7$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ /* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $6X9z7 = parcelRequire("6X9z7");
const $9ecf047fc9b5cda7$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $9ecf047fc9b5cda7$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $jDsoo.cx)(grow === 'hug' && $9ecf047fc9b5cda7$var$styles.hug, grow === 'fill' && $9ecf047fc9b5cda7$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$9ecf047fc9b5cda7$export$694e0d28c7ffc90c.displayName = 'Stack';

});

parcelRegister("aKeQm", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $db35fcfb785c4324$export$d6830277b06edd6);
const $db35fcfb785c4324$export$d6830277b06edd6 = 'normal';
const $db35fcfb785c4324$export$1eee5ddc4f6d41c5 = 400;

});

parcelRegister("36x0I", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9ed1aa3135e0eb9$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $2U5M0 = parcelRequire("2U5M0");

var $gdUUy = parcelRequire("gdUUy");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $9XtPp = parcelRequire("9XtPp");

var $aKeQm = parcelRequire("aKeQm");

var $106cC = parcelRequire("106cC");
const $c9ed1aa3135e0eb9$var$buttonStylesOld = null;
const $c9ed1aa3135e0eb9$var$buttonStyles = null;
const $c9ed1aa3135e0eb9$var$fontStyles = null;
const $c9ed1aa3135e0eb9$var$appearanceNormalButtonStyles = null;
const $c9ed1aa3135e0eb9$var$appearanceBoldButtonStyles = null;
const $c9ed1aa3135e0eb9$var$appearanceNormalActionsContainerStyles = null;
const $c9ed1aa3135e0eb9$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $aKeQm.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $aKeQm.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>(0, $gdUUy.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $2U5M0.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $9XtPp.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $106cC.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $106cC.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $106cC.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $9fU1q.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $2U5M0.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $9XtPp.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $106cC.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $106cC.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $106cC.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $9fU1q.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c9ed1aa3135e0eb9$export$2e2bcd8739ae039 = $c9ed1aa3135e0eb9$var$FlagActions;

});
parcelRegister("2U5M0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e345455cb6e83750$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $i7mMb = parcelRequire("i7mMb");

var $68v77 = parcelRequire("68v77");

var $7n1Pc = parcelRequire("7n1Pc");

var $7oUXt = parcelRequire("7oUXt");

var $cRLgX = parcelRequire("cRLgX");

var $jg3Jg = parcelRequire("jg3Jg");

var $4TO83 = parcelRequire("4TO83");
function $e345455cb6e83750$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $e345455cb6e83750$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $e345455cb6e83750$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $cRLgX.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $bSJIT.useState)($e345455cb6e83750$var$initial);
    const onMouseEnter = (0, $bSJIT.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $bSJIT.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $bSJIT.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $bSJIT.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $bSJIT.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $bSJIT.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TO83.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $i7mMb.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $4TO83.default).Consumer, {
                    mode: mode,
                    state: $e345455cb6e83750$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $7n1Pc.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $68v77.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $7oUXt.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $jg3Jg.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$e345455cb6e83750$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $e345455cb6e83750$export$2e2bcd8739ae039 = $e345455cb6e83750$var$CustomThemeButton;

});
parcelRegister("i7mMb", function(module, exports) {
$parcel$export(module.exports, "default", () => $09f9c43867ed31a3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $bEPk4 = parcelRequire("bEPk4");
// Create default global light theme
const $09f9c43867ed31a3$var$dest = (0, $bEPk4.createTheme)(()=>({
        mode: 'light'
    }));
const $09f9c43867ed31a3$var$Provider = $09f9c43867ed31a3$var$dest.Provider;
const $09f9c43867ed31a3$var$Consumer = $09f9c43867ed31a3$var$dest.Consumer;
const $09f9c43867ed31a3$export$7692396083754928 = $09f9c43867ed31a3$var$dest.useTheme;
const $09f9c43867ed31a3$var$Theme = {
    Provider: $09f9c43867ed31a3$var$Provider,
    Consumer: $09f9c43867ed31a3$var$Consumer
};
var /**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2652 Internal documentation for deprecation (no external access)}
 * Use design tokens and the supported customization APIs of Atlassian Design System components.
 */ $09f9c43867ed31a3$export$2e2bcd8739ae039 = $09f9c43867ed31a3$var$Theme;

});
parcelRegister("bEPk4", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $a37bd4b28f31b757$export$25d302a5b900a763);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
function $a37bd4b28f31b757$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $bSJIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $bSJIT.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
            children: children(tokens)
        });
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $bSJIT.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $bSJIT.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $dc70d.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("7oUXt", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5156a267b6f84b8$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hDkm2 = parcelRequire("hDkm2");
function $d5156a267b6f84b8$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $d5156a267b6f84b8$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
        size: size,
        label: ", Loading",
        appearance: $d5156a267b6f84b8$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("cRLgX", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $183050b2ec5dd3e0$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $183050b2ec5dd3e0$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("jg3Jg", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $0b09f3ff57429289$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0b09f3ff57429289$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("4TO83", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e987389cc2cdbfc$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @atlaskit/ui-styling-standard/no-atlaskit-theme -- Ignored via go/DSP-18766

var $bEPk4 = parcelRequire("bEPk4");

var $bxAEe = parcelRequire("bxAEe");
const $8e987389cc2cdbfc$var$Theme = (0, $bEPk4.createTheme)((themeProps)=>({
        buttonStyles: (0, $bxAEe.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8e987389cc2cdbfc$export$2e2bcd8739ae039 = $8e987389cc2cdbfc$var$Theme;

});
parcelRegister("bxAEe", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $f6212e9cacdcafd0$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $a5ag5 = parcelRequire("a5ag5");
const $f6212e9cacdcafd0$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $f6212e9cacdcafd0$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $a5ag5.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $f6212e9cacdcafd0$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("9XtPp", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $301ef41f93e3398f$export$7bcfe3cca4dd78b6);
const $301ef41f93e3398f$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("106cC", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $82be0c276611564a$export$81ba6b63eedb299f);
const $82be0c276611564a$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("28bcj", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $d5cf96e8488e91db$export$59e42969c95d314);
const $d5cf96e8488e91db$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("6nkTn", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $1978a89d0a712754$export$7f70afe2167f8235);
const $1978a89d0a712754$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("HJ3uu", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $f26b86443a3ada2a$export$73f08aee70487cd4);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hkLEY = parcelRequire("hkLEY");

var $68E0O = parcelRequire("68E0O");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");
const $f26b86443a3ada2a$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        label: ""
    })
};

});
parcelRegister("hkLEY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9e9462fe22ec8ea$var$_react = $c9e9462fe22ec8ea$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c9e9462fe22ec8ea$var$_iconNew = $c9e9462fe22ec8ea$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c9e9462fe22ec8ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9e9462fe22ec8ea$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $c9e9462fe22ec8ea$var$_react.default.createElement($c9e9462fe22ec8ea$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$c9e9462fe22ec8ea$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $c9e9462fe22ec8ea$var$_default = module.exports.default = $c9e9462fe22ec8ea$var$StatusErrorIcon;

});

parcelRegister("68E0O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $478286fe7495bc3e$var$_react = $478286fe7495bc3e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $478286fe7495bc3e$var$_iconNew = $478286fe7495bc3e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $478286fe7495bc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $478286fe7495bc3e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $478286fe7495bc3e$var$_react.default.createElement($478286fe7495bc3e$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$478286fe7495bc3e$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $478286fe7495bc3e$var$_default = module.exports.default = $478286fe7495bc3e$var$StatusInformationIcon;

});

parcelRegister("lP6sB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fec260a5beb0e93db2111df1ab9a2e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe335f49f6f803c6$var$_react = $fe335f49f6f803c6$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $fe335f49f6f803c6$var$_iconNew = $fe335f49f6f803c6$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $fe335f49f6f803c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe335f49f6f803c6$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $fe335f49f6f803c6$var$_react.default.createElement($fe335f49f6f803c6$var$_iconNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$fe335f49f6f803c6$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $fe335f49f6f803c6$var$_default = module.exports.default = $fe335f49f6f803c6$var$StatusSuccessIcon;

});

parcelRegister("dsw4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cc6c4f9674c2c71$var$_react = $9cc6c4f9674c2c71$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $9cc6c4f9674c2c71$var$_iconNew = $9cc6c4f9674c2c71$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $9cc6c4f9674c2c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cc6c4f9674c2c71$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $9cc6c4f9674c2c71$var$_react.default.createElement($9cc6c4f9674c2c71$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$9cc6c4f9674c2c71$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $9cc6c4f9674c2c71$var$_default = module.exports.default = $9cc6c4f9674c2c71$var$StatusWarningIcon;

});


parcelRegister("wysLF", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $644a57bcf7a0647e$export$f50075b2584087f);
const $644a57bcf7a0647e$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("3ekrI", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $87d24f7621763d0e$export$13b42cd9d596bfe0);
const $87d24f7621763d0e$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("lU62j", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fa881cf4a42f806$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4TRbS = parcelRequire("4TRbS");

var $4GWyU = parcelRequire("4GWyU");

var $8yxPv = parcelRequire("8yxPv");

var $9dYEz = parcelRequire("9dYEz");

var $3ekrI = parcelRequire("3ekrI");
const $5fa881cf4a42f806$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($9dYEz)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($8yxPv))) : (0, (/*@__PURE__*/$parcel$interopDefault($4GWyU)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $3ekrI.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $5fa881cf4a42f806$var$DismissButton = /*#__PURE__*/ (0, $bSJIT.memo)($5fa881cf4a42f806$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fa881cf4a42f806$export$2e2bcd8739ae039 = $5fa881cf4a42f806$var$DismissButton;

});
parcelRegister("4TRbS", function(module, exports) {
$parcel$export(module.exports, "default", () => $62f59f7eee9916df$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fGbV9 = parcelRequire("fGbV9");

var $lavtv = parcelRequire("lavtv");

var $9Abbn = parcelRequire("9Abbn");

var $7ZmGm = parcelRequire("7ZmGm");

var $kLU70 = parcelRequire("kLU70");

var $aHtkE = parcelRequire("aHtkE");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $62f59f7eee9916df$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7ZmGm.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kLU70.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7ZmGm.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    var _triggerProps$onClick;
                    onClick === null || onClick === void 0 || onClick(e, analyticsEvent);
                    (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
                },
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                ref: (0, $fGbV9.default)([
                    ref,
                    triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kLU70.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$62f59f7eee9916df$var$IconButton.displayName = 'IconButton';
var $62f59f7eee9916df$export$2e2bcd8739ae039 = $62f59f7eee9916df$var$IconButton;

});
parcelRegister("7ZmGm", function(module, exports) {
$parcel$export(module.exports, "default", () => $1096d89832766b1c$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $21u3G = parcelRequire("21u3G");

var $d6mTg = parcelRequire("d6mTg");

var $gdUUy = parcelRequire("gdUUy");

var $gXqq0 = parcelRequire("gXqq0");

var $9Abbn = parcelRequire("9Abbn");

var $eHubG = parcelRequire("eHubG");

var $d8Ktz = parcelRequire("d8Ktz");

var $jmA0v = parcelRequire("jmA0v");

var $fDhEm = parcelRequire("fDhEm");
const $1096d89832766b1c$var$LOADING_LABEL = ', Loading';
const $1096d89832766b1c$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_2rko12b0 _1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $1096d89832766b1c$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $1096d89832766b1c$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $1096d89832766b1c$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $1096d89832766b1c$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $1096d89832766b1c$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $1096d89832766b1c$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $1096d89832766b1c$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $1096d89832766b1c$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $1096d89832766b1c$var$brandSelectedSplitButtonStyles = {
    root: "_bfhk1gmr _syaz1oa5 _8l3ma755 _aetrb3bt _10531oa5 _f8pj1oa5 _30l31oa5 _9h8h1oa5",
    interactive: "_irr33v15 _30l31oa5 _1di6u02c _9h8h1oa5"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $1096d89832766b1c$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, rootXcss: rootXcss, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $bSJIT.useRef)(null);
    const splitButtonContext = (0, $d8Ktz.useSplitButtonContext)();
    const loadingLabelId = (0, $d6mTg.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    const isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    const spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    const isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    // The open dropdown is part of a primary action, not a standalone selection.
    const isBrandSelectedSplitButton = isSelected && appearance === 'primary' && (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'primary' && (0, $gdUUy.fg)('platform-dst-tokens-finesse');
    (0, $21u3G.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $fGbV9.default)([
            localRef,
            ref
        ]),
        xcss: (0, $jDsoo.cx)($1096d89832766b1c$var$styles.base, isInteractive && $1096d89832766b1c$var$styles.interactiveMotion, appearance === 'default' && $1096d89832766b1c$var$defaultStyles.root, appearance === 'default' && isInteractive && $1096d89832766b1c$var$defaultStyles.interactive, appearance === 'primary' && $1096d89832766b1c$var$primaryStyles.root, appearance === 'primary' && isInteractive && $1096d89832766b1c$var$primaryStyles.interactive, appearance === 'rovo' && $1096d89832766b1c$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $1096d89832766b1c$var$rovoStyles.interactive, appearance === 'warning' && $1096d89832766b1c$var$warningStyles.root, appearance === 'warning' && isInteractive && $1096d89832766b1c$var$warningStyles.interactive, appearance === 'danger' && $1096d89832766b1c$var$dangerStyles.root, appearance === 'danger' && isInteractive && $1096d89832766b1c$var$dangerStyles.interactive, appearance === 'discovery' && $1096d89832766b1c$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $1096d89832766b1c$var$discoveryStyles.interactive, appearance === 'subtle' && $1096d89832766b1c$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $1096d89832766b1c$var$subtleStyles.interactive, $1096d89832766b1c$var$styles.linkDecorationUnset, isSelected && $1096d89832766b1c$var$selectedStyles.root, isSelected && isSplitButton && $1096d89832766b1c$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $1096d89832766b1c$var$selectedStyles.interactive, isBrandSelectedSplitButton && $1096d89832766b1c$var$brandSelectedSplitButtonStyles.root, isBrandSelectedSplitButton && isInteractive && $1096d89832766b1c$var$brandSelectedSplitButtonStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $1096d89832766b1c$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $1096d89832766b1c$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $1096d89832766b1c$var$selectedStyles.discovery, isDisabled && $1096d89832766b1c$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $1096d89832766b1c$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $1096d89832766b1c$var$defaultStyles.disabled, spacing === 'compact' && $1096d89832766b1c$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $1096d89832766b1c$var$styles.circle, shouldFitContainer && $1096d89832766b1c$var$styles.fullWidth, hasIconBefore && $1096d89832766b1c$var$styles.buttonIconBefore, hasIconAfter && $1096d89832766b1c$var$styles.buttonIconAfter, isIconButton && $1096d89832766b1c$var$styles.iconButton, isIconButton && spacing === 'compact' && $1096d89832766b1c$var$styles.iconButtonCompact, isLoading && $1096d89832766b1c$var$styles.loading, isSplitButton && $1096d89832766b1c$var$styles.splitButton, isNavigationSplitButton && $1096d89832766b1c$var$styles.navigationSplitButton, rootXcss),
        isDisabled: isDisabled,
        "aria-live": "polite",
        ...isLoading && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$1096d89832766b1c$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $jmA0v.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $eHubG.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: (0, $9fU1q.default)([
                        $1096d89832766b1c$var$styles.loadingOverlay
                    ]),
                    children: (0, $fDhEm.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                    id: loadingLabelId,
                    children: $1096d89832766b1c$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $1096d89832766b1c$export$2e2bcd8739ae039 = $1096d89832766b1c$var$ButtonBase;

});
parcelRegister("gXqq0", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $082c7835df698f71$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $kIUP1 = parcelRequire("kIUP1");

var $h0umZ = parcelRequire("h0umZ");

var $1OdZP = parcelRequire("1OdZP");

var $cyIUy = parcelRequire("cyIUy");

var $aPI66 = parcelRequire("aPI66");
const $082c7835df698f71$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
const $082c7835df698f71$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $1OdZP.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aPI66.Focusable), {
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $h0umZ.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $14TCm.cx)($082c7835df698f71$var$styles.root, isDisabled && $082c7835df698f71$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});

});
parcelRegister("h0umZ", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $029d6d4953ef2ddf$export$95df08bae54cb4df);
function $029d6d4953ef2ddf$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        const ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("aPI66", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $e7bd15e04ea5f9e0$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $e7bd15e04ea5f9e0$var$focusRingStyles = null;
const $e7bd15e04ea5f9e0$var$insetFocusRingStyles = null;
const $e7bd15e04ea5f9e0$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9fU1q.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});

});


parcelRegister("eHubG", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $db7238717dd4d0df$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");
const $db7238717dd4d0df$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});

parcelRegister("d8Ktz", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $111f1ecc360955fe$export$47e2c6fdb142d947);

var $bSJIT = parcelRequire("bSJIT");

var $eHubG = parcelRequire("eHubG");
const $111f1ecc360955fe$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $bSJIT.useContext)((0, $eHubG.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("jmA0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca457790e63acb6$export$2e2bcd8739ae039);
function $8ca457790e63acb6$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $8ca457790e63acb6$var$tabKeyCode = 9;
function $8ca457790e63acb6$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $8ca457790e63acb6$var$tabKeyCode) return;
    $8ca457790e63acb6$var$abort(event);
}
function $8ca457790e63acb6$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $8ca457790e63acb6$var$abort,
        onMouseUpCapture: $8ca457790e63acb6$var$abort,
        onKeyDownCapture: $8ca457790e63acb6$var$onKey,
        onKeyUpCapture: $8ca457790e63acb6$var$onKey,
        onTouchStartCapture: $8ca457790e63acb6$var$abort,
        onTouchEndCapture: $8ca457790e63acb6$var$abort,
        onPointerDownCapture: $8ca457790e63acb6$var$abort,
        onPointerUpCapture: $8ca457790e63acb6$var$abort,
        onClickCapture: $8ca457790e63acb6$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $8ca457790e63acb6$var$abort
    } : events;
}

});

parcelRegister("fDhEm", function(module, exports) {
$parcel$export(module.exports, "default", () => $57f746e39d2ce3b0$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hDkm2 = parcelRequire("hDkm2");
function $57f746e39d2ce3b0$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $57f746e39d2ce3b0$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $57f746e39d2ce3b0$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
        size: $57f746e39d2ce3b0$var$getIconSpacing(spacing),
        appearance: $57f746e39d2ce3b0$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("kLU70", function(module, exports) {
$parcel$export(module.exports, "default", () => $23f8be83f86a5aa3$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $23f8be83f86a5aa3$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $23f8be83f86a5aa3$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            $23f8be83f86a5aa3$var$styles.common,
            type === 'text' && $23f8be83f86a5aa3$var$styles.text,
            type === 'icon' && $23f8be83f86a5aa3$var$styles.icon,
            isLoading && $23f8be83f86a5aa3$var$styles.fade
        ]),
        children: children
    });
};
var $23f8be83f86a5aa3$export$2e2bcd8739ae039 = $23f8be83f86a5aa3$var$Content;

});

parcelRegister("aHtkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8761089d2f24da9c$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
function $8761089d2f24da9c$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $8761089d2f24da9c$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $8761089d2f24da9c$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $gdUUy.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $8761089d2f24da9c$export$2e2bcd8739ae039 = $8761089d2f24da9c$var$IconRenderer;

});


parcelRegister("8yxPv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd264112f4a6872d04b33e03dd95c892>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63abbd95c05cd5b4$var$_react = $63abbd95c05cd5b4$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $63abbd95c05cd5b4$var$_iconNew = $63abbd95c05cd5b4$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $63abbd95c05cd5b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63abbd95c05cd5b4$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $63abbd95c05cd5b4$var$_react.default.createElement($63abbd95c05cd5b4$var$_iconNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$63abbd95c05cd5b4$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $63abbd95c05cd5b4$var$_default = module.exports.default = $63abbd95c05cd5b4$var$ChevronUpIcon;

});

parcelRegister("9dYEz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b746074e985e675$var$_react = $6b746074e985e675$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6b746074e985e675$var$_iconNew = $6b746074e985e675$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6b746074e985e675$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b746074e985e675$var$CrossIcon = (props)=>/*#__PURE__*/ $6b746074e985e675$var$_react.default.createElement($6b746074e985e675$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$6b746074e985e675$var$CrossIcon.displayName = 'CrossIcon';
var $6b746074e985e675$var$_default = module.exports.default = $6b746074e985e675$var$CrossIcon;

});


parcelRegister("2aHo6", function(module, exports) {
$parcel$export(module.exports, "default", () => $695e8fe06b3e57d5$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ /* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $jvbf5 = parcelRequire("jvbf5");

var $8W36W = parcelRequire("8W36W");

var $2HQOV = parcelRequire("2HQOV");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");
const $695e8fe06b3e57d5$var$styles = {
    expander: "_1bsb1osq",
    expanderTransition: "_k8m0wor5 _1oec1mzy _156yru3m",
    expanderCollapsed: "_1reo15vq _18m915vq",
    container: "_v5641xzp"
};
const $695e8fe06b3e57d5$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    const isCollapseAnimationEnabled = (0, $gdUUy.fg)('platform-dst-flag-collapse-animation-fix');
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($695e8fe06b3e57d5$var$styles.expander, isCollapseAnimationEnabled && $695e8fe06b3e57d5$var$styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && $695e8fe06b3e57d5$var$styles.expanderCollapsed),
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8W36W.default), {
                children: (props)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        xcss: (0, $jDsoo.cx)(!isCollapseAnimationEnabled && $695e8fe06b3e57d5$var$styles.container),
                        ...props,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dDEhr.Stack), {
                            space: "space.100",
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                                children: children
                            })
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$695e8fe06b3e57d5$export$2e2bcd8739ae039 = $695e8fe06b3e57d5$var$Expander;

});

parcelRegister("2HPPa", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $71848c1394dd4a40$export$e91ea202abb66350);

var $bSJIT = parcelRequire("bSJIT");

var $6815P = parcelRequire("6815P");
function $71848c1394dd4a40$export$e91ea202abb66350() {
    return (0, $bSJIT.useContext)((0, $6815P.FlagGroupContext));
}

});



parcelRegister("cBVmT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92e570de04969703$var$_react = $92e570de04969703$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $92e570de04969703$var$_iconNew = $92e570de04969703$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $92e570de04969703$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92e570de04969703$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $92e570de04969703$var$_react.default.createElement($92e570de04969703$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$92e570de04969703$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $92e570de04969703$var$_default = module.exports.default = $92e570de04969703$var$CrossCircleIcon;

});





parcelRegister("ji8Ja", function(module, exports) {
$parcel$export(module.exports, "default", () => $46a4d6dfa1d5a0dc$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $46a4d6dfa1d5a0dc$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    genericErrorTitle: {
        id: 'cv.generic.error.title',
        defaultMessage: 'Error',
        description: 'Title of the error panel shown when a generic error has occurred.'
    },
    genericErrorDescription: {
        id: 'cv.generic.error.description',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred.'
    },
    genericSignUpErrorDescriptionUnified: {
        id: 'cv.generic.sign.up.error.description.unified',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again. If you continue to experience issues, {contactAdminLinkUnified}.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    genericSignUpErrorNoContactLinkDescription: {
        id: 'cv.generic.sign.up.error.no.contact.link.description.unified',
        defaultMessage: "We couldn\u2019t submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    refreshPageLinkText: {
        id: 'cv.generic.refresh.page.link.text',
        defaultMessage: 'refresh',
        description: 'The text is shown as a hyperlink label that triggers a page refresh, displayed within an error flag or error panel when a generic error has occurred.'
    },
    tellUsAboutIssueLinkText: {
        id: 'cv.generic.tell.about.issue.link.text',
        defaultMessage: 'tell us about this issue',
        description: 'Text shown for the tell us about this issue link, used to report errors.'
    },
    letUsKnowLinkText: {
        id: 'cv.generic.let.us.know.link.text',
        defaultMessage: 'let us know',
        description: 'Text shown for the let us know link, used to report errors.'
    },
    genericErrorRefreshPageAction: {
        id: 'cv.generic.error.refresh.page.action',
        defaultMessage: 'Refresh page',
        description: 'Label of the refresh page button on the error panel shown when a generic error has occurred.'
    },
    noNetworkTitle: {
        id: 'cv.no.network.title',
        defaultMessage: 'Check your connection',
        description: 'Title of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    noNetworkDescription: {
        id: 'cv.no.network.description.unified',
        defaultMessage: "It looks like you've lost your internet connection. Check your network and try again later.",
        description: 'Message body of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    signupEmailResendRateLimitedDescription: {
        defaultMessage: "There\u2019s an issue with sending the email at the moment. Try again later in 10 minutes",
        description: 'Message to notify the user that the sign up email has been rate limited',
        id: 'cv.sign.up.email.resend.rate.limited.description'
    },
    blockedTitle: {
        id: 'cv.signup.blocked.title',
        defaultMessage: 'Access Blocked',
        description: 'Title of the error panel shown when a blocked action occurs.'
    },
    blockedDescription: {
        id: 'cv.signup.blocked.description',
        defaultMessage: "The email isn't approved for access. Use another email and try again.",
        description: 'Message body of the error panel  shown when a blocked action occurs.'
    },
    invalidEmailTitle: {
        id: 'cv.signup.email.invalid.title',
        defaultMessage: 'Invalid Email',
        description: 'Title of the error panel shown when a invalid email is entered.'
    },
    invalidEmailDescription: {
        id: 'cv.signup.email.invalid.description',
        defaultMessage: 'You must specify a valid email address.',
        description: 'Message body of the error panel shown when a invalid email is entered.'
    },
    userProfileForgotPasswordFailedFlagTitle: {
        id: 'cv.user.profile.forgot.password.failed.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordFailedFlagDescription: {
        id: 'cv.user.profile.forgot.password.failed.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagTitle: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagDescription: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again in a few minutes.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    }
});

});




parcelRegister("2ujK0", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticleEpic", () => $f1d3db3f6f1645da$export$d67800395c791e52);

var $8jOUp = parcelRequire("8jOUp");

var $9KtsW = parcelRequire("9KtsW");
parcelRequire("hpavy");
var $kSHuF = parcelRequire("kSHuF");

var $cVj5q = parcelRequire("cVj5q");

var $jBiia = parcelRequire("jBiia");

var $G6QpT = parcelRequire("G6QpT");
const $f1d3db3f6f1645da$export$3361e9be8093ddcc = (response, articleId)=>{
    const parseAri = (0, $cVj5q.ConfluenceSpaceAri).parse(response.space.id);
    return {
        id: parseInt(articleId, 10),
        title: response.title,
        url: '',
        projects: response.projects.map((project)=>({
                projectId: parseInt(project.projectId, 10),
                portalId: parseInt(project.portalId, 10),
                projectAri: project.projectAri
            })),
        space: {
            key: response.space.key,
            id: parseInt(parseAri.spaceId, 10)
        },
        idInString: articleId,
        hostname: response.hostname
    };
};
const $f1d3db3f6f1645da$export$d67800395c791e52 = (action$)=>action$.ofType((0, $kSHuF.FETCH_CROSS_SITE_ARTICLE)).mergeMap((action)=>{
        const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = action.payload;
        return (0, $9KtsW.fetchCrossSiteArticles)({
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId || ''
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
            const articleResponse = $f1d3db3f6f1645da$export$3361e9be8093ddcc(response, articleId);
            return (0, $kSHuF.fetchArticleSuccess)(articleResponse);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $jBiia.legacySendEvent)((0, $G6QpT.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $8jOUp.Observable).of((0, $kSHuF.fetchArticleFailure)(articleId, error));
        });
    });

});
parcelRegister("9KtsW", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticles", () => $493851ecc2aa7620$export$5cbd1a869c9b635a);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fuVmc = parcelRequire("fuVmc");

var $fvUqa = parcelRequire("fvUqa");

var $hjIcl = parcelRequire("hjIcl");
var $4op5x = parcelRequire("4op5x");

var $87QgR = parcelRequire("87QgR");

var $jBiia = parcelRequire("jBiia");

var $fMFxk = parcelRequire("fMFxk");
/**
 * Feature flag: kb_article_metadata_help_center_project_resolution
 *
 * When enabled, article-metadata uses helpCenterAri to resolve the project for portal-less
 * article URLs when projectAri is omitted.
 */ const $493851ecc2aa7620$var$KB_ARTICLE_METADATA_HELP_CENTER_PROJECT_RESOLUTION = 'kb_article_metadata_help_center_project_resolution';
const $493851ecc2aa7620$export$5cbd1a869c9b635a = ({ articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId })=>{
    const cloudId = (0, $fuVmc.getMeta)('tenant-id') || '';
    const activationId = (0, $fuVmc.getMeta)('activation-id');
    const pageAri = (0, $hjIcl.ConfluencePageAri).create({
        siteId: crossSiteTenantId,
        pageId: articleId
    }).toString();
    const useHelpCenterProjectResolution = (0, $87QgR.default).checkGate($493851ecc2aa7620$var$KB_ARTICLE_METADATA_HELP_CENTER_PROJECT_RESOLUTION);
    const projectAri = projectId ? (0, $4op5x.JiraProjectAri).create({
        projectId: projectId.toString(),
        siteId: cloudId
    }).toString() : undefined;
    const queryStringV2 = $fvUqa.stringify({
        projectAri: projectAri,
        articleAri: pageAri,
        ...useHelpCenterProjectResolution ? {
            helpCenterAri: (0, $fuVmc.getHelpCenterAri)()
        } : {}
    });
    const uri = `${(0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/article-metadata?${queryStringV2}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        (0, $jBiia.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $8jOUp.Observable).throw(e);
    });
};

});
parcelRegister("hjIcl", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAri", () => $c9b67edbce3e9f8f$export$3f931dd15d96caff);

var $bsHUA = parcelRequire("bsHUA");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/confluence/page/manifest.ts
var $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bsHUA.ConfluencePageAriResourceOwner),
    resourceType: (0, $bsHUA.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $c9b67edbce3e9f8f$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $c9b67edbce3e9f8f$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("bsHUA", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $85845f2ffd6ba7f6$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $85845f2ffd6ba7f6$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $85845f2ffd6ba7f6$export$da53e4f7db4c6a71 = "confluence", $85845f2ffd6ba7f6$export$636fc622562a2c5b = "page";

});

parcelRegister("25Thw", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $1866ee2f0af8cc94$export$579ee78b1dcf0a11);

var $5mjkF = parcelRequire("5mjkF");
// src/core/registered-ari.ts
var $1866ee2f0af8cc94$export$579ee78b1dcf0a11 = class extends (0, $5mjkF.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $5mjkF.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("5mjkF", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $3e6e00d3bbc32bf9$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $3e6e00d3bbc32bf9$export$44a7af7122933d6b);

var $hxkLB = parcelRequire("hxkLB");
// src/core/ari.ts
var $3e6e00d3bbc32bf9$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $hxkLB.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $3e6e00d3bbc32bf9$export$44a7af7122933d6b = class _AnyAri extends $3e6e00d3bbc32bf9$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $hxkLB.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $hxkLB.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("hxkLB", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $cc45a0988790e1ca$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $cc45a0988790e1ca$export$ab4b293d0121b8ee);

var $8HDaI = parcelRequire("8HDaI");

var $6q8vU = parcelRequire("6q8vU");
// src/core/rules/cloud-id.ts
function $cc45a0988790e1ca$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $6q8vU.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $cc45a0988790e1ca$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $6q8vU.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $cc45a0988790e1ca$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $cc45a0988790e1ca$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $cc45a0988790e1ca$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $6q8vU.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $cc45a0988790e1ca$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $6q8vU.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $cc45a0988790e1ca$var$NUMBER_OF_ARI_SEGMENTS = 5, $cc45a0988790e1ca$export$4c3a8cde7a55740b = class extends (0, $8HDaI.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $cc45a0988790e1ca$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), ariProperties.resourceIdSegmentFormats) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $8HDaI.validateAriQualifier)(qualifier), (0, $8HDaI.validatePlatformQualifier)(platformQualifier), $cc45a0988790e1ca$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $cc45a0988790e1ca$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $cc45a0988790e1ca$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $cc45a0988790e1ca$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, segmentFormats) {
        var _a;
        let expectedKeys = Object.keys(segmentFormats), slugVariables = (_a = slug.match(/\{(.*?)\}/g)) != null ? _a : [], finalVariable = slugVariables[slugVariables.length - 1], finalVariableKey = finalVariable == null ? void 0 : finalVariable.slice(1, -1), slugWithFinalSegmentFormat = slug.replace(/\{(.*?)\}/g, (_placeholder, key)=>{
            var _a2;
            let finalSegmentFormat = key === finalVariableKey ? segmentFormats[key] : void 0;
            return `(?<${key}>${(_a2 = finalSegmentFormat == null ? void 0 : finalSegmentFormat.source) != null ? _a2 : ".*?"})`;
        }), regexpResult = new RegExp(`^${slugWithFinalSegmentFormat}$`).exec(incomingSegments);
        if (!regexpResult) throw new (0, $6q8vU.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a2;
            if (!((_a2 = regexpResult.groups) != null && _a2[expectedKey])) throw new (0, $6q8vU.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $cc45a0988790e1ca$var$NUMBER_OF_ATI_SEGMENTS = 4, $cc45a0988790e1ca$var$AtiParser = class extends (0, $8HDaI.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $cc45a0988790e1ca$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $8HDaI.validateAtiQualifier)(qualifier), (0, $8HDaI.validatePlatformQualifier)(platformQualifier), $cc45a0988790e1ca$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $cc45a0988790e1ca$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $8HDaI.validateAtiQualifier)(qualifier), (0, $8HDaI.validatePlatformQualifier)(platformQualifier), $cc45a0988790e1ca$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $cc45a0988790e1ca$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $cc45a0988790e1ca$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $cc45a0988790e1ca$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("8HDaI", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $6560b99246883ab7$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $6560b99246883ab7$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $6560b99246883ab7$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $6560b99246883ab7$export$3d09a5c28ff3e040);

var $6q8vU = parcelRequire("6q8vU");
// src/core/rules/platform-qualifier.ts
function $6560b99246883ab7$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $6q8vU.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $6560b99246883ab7$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $6q8vU.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $6560b99246883ab7$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $6q8vU.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $6560b99246883ab7$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $6q8vU.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $6560b99246883ab7$var$NUMBER_OF_BASE_SEGMENTS = 5, $6560b99246883ab7$var$SEGMENT_SEPARATOR = ":", $6560b99246883ab7$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($6560b99246883ab7$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $6q8vU.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $6560b99246883ab7$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($6560b99246883ab7$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($6560b99246883ab7$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("6q8vU", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $4acbc66f7cf5b57b$export$2191b9da168c6cf0);
// src/errors.ts
var $4acbc66f7cf5b57b$export$2191b9da168c6cf0 = class extends Error {
};

});






parcelRegister("4op5x", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $332cdd56d69189da$export$75a0a0a7cb0a58ae);

var $iAlzQ = parcelRequire("iAlzQ");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/jira/project/manifest.ts
var $332cdd56d69189da$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $iAlzQ.JiraProjectAriResourceOwner),
    resourceType: (0, $iAlzQ.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $332cdd56d69189da$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $332cdd56d69189da$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $332cdd56d69189da$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $332cdd56d69189da$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $332cdd56d69189da$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $332cdd56d69189da$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $332cdd56d69189da$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("iAlzQ", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $d87c538ac388aeac$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $d87c538ac388aeac$export$736763838d3aa22e);
// src/jira/project/types.ts
var $d87c538ac388aeac$export$99d538a3b04916b1 = "jira", $d87c538ac388aeac$export$736763838d3aa22e = "project";

});


parcelRegister("fMFxk", function(module, exports) {
$parcel$export(module.exports, "APOLLO_STARGATE_CONTEXT_ROOT", () => $b650ac909c46d2de$export$f224912d4ec4705e);
const $b650ac909c46d2de$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

});


parcelRegister("hpavy", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => (parcelRequire("kSHuF")).FETCH_ARTICLE);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => (parcelRequire("kSHuF")).FETCH_ARTICLE_FAILURE);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => (parcelRequire("kSHuF")).FETCH_ARTICLE_SUCCESS);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => (parcelRequire("kSHuF")).FETCH_CROSS_SITE_ARTICLE);
$parcel$export(module.exports, "fetchArticle", () => (parcelRequire("kSHuF")).fetchArticle);
$parcel$export(module.exports, "fetchArticleFailure", () => (parcelRequire("kSHuF")).fetchArticleFailure);
$parcel$export(module.exports, "fetchArticleSuccess", () => (parcelRequire("kSHuF")).fetchArticleSuccess);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => (parcelRequire("kSHuF")).fetchCrossSiteArticle);
parcelRequire("kSHuF");

});
parcelRegister("kSHuF", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => $d23e9a3986648d7e$export$a55f0530be417648);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => $d23e9a3986648d7e$export$2d213dcac7fc3339);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => $d23e9a3986648d7e$export$862d1fc538bf047c);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => $d23e9a3986648d7e$export$ffd65713f8cf7ee0);
$parcel$export(module.exports, "fetchArticle", () => $d23e9a3986648d7e$export$b455945318d7989e);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => $d23e9a3986648d7e$export$9b8d6025673edc75);
$parcel$export(module.exports, "fetchArticleSuccess", () => $d23e9a3986648d7e$export$6910c63a4b3017af);
$parcel$export(module.exports, "fetchArticleFailure", () => $d23e9a3986648d7e$export$b135c19fc249d3ab);

var $hn5Mq = parcelRequire("hn5Mq");
const $d23e9a3986648d7e$export$a55f0530be417648 = 'epic.model.FETCH_ARTICLE';
const $d23e9a3986648d7e$export$2d213dcac7fc3339 = 'state.persisted.article.FETCH_ARTICLE_SUCCESS';
const $d23e9a3986648d7e$export$862d1fc538bf047c = 'state.persisted.article.FETCH_ARTICLE_FAILURE';
const $d23e9a3986648d7e$export$ffd65713f8cf7ee0 = 'epic.model.FETCH_CROSS_SITE_ARTICLE';
const $d23e9a3986648d7e$export$b455945318d7989e = (payload, meta)=>({
        meta: meta,
        ...(0, $hn5Mq.buildModelsActionCreator)($d23e9a3986648d7e$export$a55f0530be417648, 'kbPage')(payload)
    });
const $d23e9a3986648d7e$export$9b8d6025673edc75 = (params)=>{
    const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = params;
    return {
        type: $d23e9a3986648d7e$export$ffd65713f8cf7ee0,
        payload: {
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId,
            meta: meta
        }
    };
};
const $d23e9a3986648d7e$export$6910c63a4b3017af = (article)=>({
        type: $d23e9a3986648d7e$export$2d213dcac7fc3339,
        payload: article
    });
const $d23e9a3986648d7e$export$b135c19fc249d3ab = (id, error)=>({
        type: $d23e9a3986648d7e$export$862d1fc538bf047c,
        payload: {
            id: id,
            error: error
        }
    });

});


parcelRegister("cVj5q", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAri", () => $96899d1c0eb6afb3$export$4e1bd9257e1b7213);

var $cp0r7 = parcelRequire("cp0r7");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/confluence/space/manifest.ts
var $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $cp0r7.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $cp0r7.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $96899d1c0eb6afb3$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $96899d1c0eb6afb3$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("cp0r7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $90782880fa2de427$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $90782880fa2de427$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $90782880fa2de427$export$204c4c730af505ce = "confluence", $90782880fa2de427$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("G6QpT", function(module, exports) {
$parcel$export(module.exports, "logErrorToFailureEvent", () => $b5abf8fd73b2b137$export$7c2011d2dfcd2230);
const $b5abf8fd73b2b137$var$getErrorMessage = (error)=>{
    var _errorMessages;
    const nestedResponse = error.response;
    return (nestedResponse === null || nestedResponse === void 0 ? void 0 : nestedResponse.errorMessage) || error.errorMessage || ((_errorMessages = error.errorMessages) === null || _errorMessages === void 0 ? void 0 : _errorMessages.join(',')) || error.message;
};
const $b5abf8fd73b2b137$var$getErrorStatus = (error)=>{
    const nestedResponse = error.response;
    return error.status || (nestedResponse === null || nestedResponse === void 0 ? void 0 : nestedResponse.statusCode) || error.statusCode;
};
const $b5abf8fd73b2b137$export$7c2011d2dfcd2230 = (analyticsFailureEvent, error)=>{
    analyticsFailureEvent.update((payload)=>({
            ...payload,
            errorMessage: $b5abf8fd73b2b137$var$getErrorMessage(error),
            status: $b5abf8fd73b2b137$var$getErrorStatus(error)
        }));
    return analyticsFailureEvent;
};

});


parcelRegister("6IRIY", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ee034fdecf655d2$export$2e2bcd8739ae039);
parcelRequire("2ycHZ");
var $4nFla = parcelRequire("4nFla");

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("b8PDJ");
var $5ESvo = parcelRequire("5ESvo");

var $3kyZk = parcelRequire("3kyZk");
const $5ee034fdecf655d2$export$21d16fd7fed1f163 = (action$)=>{
    return action$.filter((action)=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        action.type.startsWith('epic.model') && action.type !== (0, $3kyZk.FETCH_HELP_CENTER_BRANDING_MODEL)).switchMap(()=>(0, $fVm9J.default)({
            type: 'xsrfToken',
            params: {}
        }))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    .filter(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    (response)=>!!response && (!!response.xsrfToken || !!response.env.xsrfToken))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    .map((response)=>(0, $5ESvo.updateXsrfAction)(response.xsrfToken || response.env.xsrfToken)).catch((_)=>(0, $8jOUp.Observable).never());
};
var $5ee034fdecf655d2$export$2e2bcd8739ae039 = (0, $4nFla.combineEpics)($5ee034fdecf655d2$export$21d16fd7fed1f163);

});
parcelRegister("fVm9J", function(module, exports) {
$parcel$export(module.exports, "default", () => $24937d277494a830$export$2e2bcd8739ae039);

var $h8cL0 = parcelRequire("h8cL0");
function $24937d277494a830$export$2e2bcd8739ae039(request, options) {
    return (0, $h8cL0.fetchModel)(request, options);
}

});
parcelRegister("h8cL0", function(module, exports) {
$parcel$export(module.exports, "fetchModel", () => $41c05cddf753eb33$export$6146dff2e008af3d);

var $8jOUp = parcelRequire("8jOUp");

var $fuVmc = parcelRequire("fuVmc");

var $4ZMmh = parcelRequire("4ZMmh");

var $02Mkj = parcelRequire("02Mkj");

var $lJH1c = parcelRequire("lJH1c");

var $gEVth = parcelRequire("gEVth");

var $3qDrS = parcelRequire("3qDrS");

var $eDcdn = parcelRequire("eDcdn");
const $41c05cddf753eb33$var$createBatchOperationalPayload = (modelType, batchingType)=>{
    return {
        action: batchingType,
        actionSubject: 'model-batched',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $41c05cddf753eb33$var$mergeOrReplaceOptions = (obj1, obj2, modelType)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    if (!obj1 || obj1.id !== obj2.id) {
        (0, $gEVth.operationalEvent)($41c05cddf753eb33$var$createBatchOperationalPayload(modelType, 'model-replaced'));
        return obj2;
    }
    return (0, $4ZMmh.mergeWith)(obj1, obj2, (value, srcValue, key)=>{
        if (key === 'expand' && value) {
            (0, $gEVth.operationalEvent)($41c05cddf753eb33$var$createBatchOperationalPayload(modelType, 'model-merged'));
            // We merge expand arrays if it is from the same type and they have the same id.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            return (0, $4ZMmh.uniq)(srcValue.concat(value));
        }
        return undefined;
    });
};
function $41c05cddf753eb33$var$fetchModels(requests) {
    const requestTypes = (0, $4ZMmh.uniq)(requests.map((request)=>request.type));
    // This will build up the request params. If the request type is the same and the id is different it will
    // replace the type params, else it will merge them together.
    // If it finds two expand arrays to merge together it will concat them together and ensure only unique values.
    const requestOptions = requests.reduce((obj, request)=>Object.keys(request.params || {}).length ? {
            ...obj,
            [request.type]: $41c05cddf753eb33$var$mergeOrReplaceOptions(obj[request.type], request.params, request.type)
        } : obj, {});
    const modelContext = {
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        clientBasePath: (0, $eDcdn.getBasePath)()
    };
    return (0, $02Mkj.requestModels)(requestTypes, requestOptions, modelContext).toPromise();
}
/**
 * A TS limitation results in this losing its arg type.
 * See: https://github.com/Microsoft/TypeScript/issues/29638
 *
 * As a work around we create another wrapping function and re-type it.
 */ const $41c05cddf753eb33$var$secondaryBatchedFetchModels = (0, $3qDrS.default)($41c05cddf753eb33$var$fetchModels, 0);
const $41c05cddf753eb33$var$primaryBatchedFetchModels = (0, $3qDrS.default)($41c05cddf753eb33$var$fetchModels, 0);
function $41c05cddf753eb33$export$6146dff2e008af3d(request, { type: type, disableBatching: disableBatching } = {
    type: 'primary',
    disableBatching: false
}) {
    const modelContext = {
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        clientBasePath: (0, $eDcdn.getBasePath)()
    };
    if ((0, $lJH1c.ModelsCache).getInstance().shouldCache(request.type)) {
        const cachedData = (0, $lJH1c.ModelsCache).getInstance().getFromCache(request);
        if (cachedData !== undefined) return (0, $8jOUp.Observable).from(Promise.resolve(cachedData.response));
    }
    if (disableBatching) {
        const options = {
            [request.type]: request.params
        };
        return (0, $02Mkj.requestModels)([
            request.type
        ], options, modelContext);
    }
    const promise = type === 'secondary' ? $41c05cddf753eb33$var$secondaryBatchedFetchModels(request).then((successResult)=>$41c05cddf753eb33$export$8d0b7c1ef062bcaa(request, successResult)) : $41c05cddf753eb33$var$primaryBatchedFetchModels(request).then((successResult)=>$41c05cddf753eb33$export$8d0b7c1ef062bcaa(request, successResult));
    return (0, $8jOUp.Observable).from(promise);
}
function $41c05cddf753eb33$export$8d0b7c1ef062bcaa(request, modelsResponse) {
    const requestType = request.type;
    if ((0, $lJH1c.ModelsCache).getInstance().shouldCache(requestType)) (0, $lJH1c.ModelsCache).getInstance().putToCache(request, modelsResponse);
    return modelsResponse;
}

});
parcelRegister("02Mkj", function(module, exports) {
$parcel$export(module.exports, "requestModels", () => $23424ed1bc97fa7c$export$be054e1f3ca89815);

var $llRGw = parcelRequire("llRGw");

var $4U3zK = parcelRequire("4U3zK");

var $kPxiY = parcelRequire("kPxiY");

var $8jOUp = parcelRequire("8jOUp");

var $lFpPv = parcelRequire("lFpPv");

var $4ZMmh = parcelRequire("4ZMmh");

var $gnOql = parcelRequire("gnOql");

var $gEVth = parcelRequire("gEVth");

var $eDcdn = parcelRequire("eDcdn");
const $23424ed1bc97fa7c$var$retryableStatusCodes = [
    429,
    500,
    502,
    503
];
const $23424ed1bc97fa7c$var$isRetryableStatusCode = (status)=>$23424ed1bc97fa7c$var$retryableStatusCodes.includes(status);
const $23424ed1bc97fa7c$var$MAX_RETRY_DELAY_MS = 30000;
const $23424ed1bc97fa7c$var$BASE_DELAY_MS = 10000;
const $23424ed1bc97fa7c$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    return Math.min(exponential, maxDelay) + Math.floor(Math.random() * 1000);
};
const $23424ed1bc97fa7c$var$NUMBER_OF_RETRIES = 2;
const $23424ed1bc97fa7c$var$createOperationalEvent = (models, numberOfRetries, success, status)=>{
    return {
        action: 'fetch',
        actionSubject: 'models',
        source: 'unknownSource',
        attributes: {
            models: models,
            numberOfRetries: numberOfRetries,
            success: success,
            status: status
        }
    };
};
const $23424ed1bc97fa7c$var$optionsNotAvailableInRestEndpoint = [
    'availableLanguages',
    'forgotPassword',
    'organisations',
    'portalsAndRequestTypes',
    'profileWebFragments',
    'sharedPortal',
    'timezones',
    'timezoneRegions',
    'xsrfToken',
    'portalsAndStatuses'
];
const $23424ed1bc97fa7c$var$setTimezoneMetaTag = (timezone)=>{
    const windowDocument = (0, $4U3zK.default).getDataRef();
    if (!timezone || !windowDocument) return;
    let metaTimezone = (0, $4U3zK.default).querySelector('meta[name="user-timezone"]');
    if (metaTimezone) metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
    else {
        metaTimezone = windowDocument.createElement('meta');
        metaTimezone.setAttribute('name', 'user-timezone');
        metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
        windowDocument.head.appendChild(metaTimezone);
    }
};
const $23424ed1bc97fa7c$var$addExtraImplicitDataRequirements = (types, options)=>{
    var _requestOptions$porta;
    const requestTypes = types.concat([]);
    // We want to clone child objects as well so we don't accidentally mutate them.
    // Not having it previously caused downstream actions to no longer have params after we deleted some propeties.
    const requestOptions = (0, $4ZMmh.cloneDeep)(options);
    if (requestTypes.includes('portal') && !requestTypes.includes('branding') && requestOptions.portal) {
        requestTypes.push('branding');
        requestOptions.branding = {
            id: requestOptions.portal.id
        };
    }
    // Implicitly add 'kbs' in portals requestOptions if fetchPortal is requested. // ref src/view/help-center/help-center-content/single-portal/index.tsx:15, projectId & isKbEnabled is considered to be present together
    if (requestTypes.includes('portal') && !((_requestOptions$porta = requestOptions.portal) !== null && _requestOptions$porta !== void 0 && (_requestOptions$porta = _requestOptions$porta.expand) !== null && _requestOptions$porta !== void 0 && _requestOptions$porta.includes('kbs'))) {
        var _requestOptions$porta2;
        (_requestOptions$porta2 = requestOptions.portal) === null || _requestOptions$porta2 === void 0 || (_requestOptions$porta2 = _requestOptions$porta2.expand) === null || _requestOptions$porta2 === void 0 || _requestOptions$porta2.push('kbs');
    }
    // Implicitly fetch portal if portalWebFragments defined portalId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.portalId && !requestTypes.includes('portal')) {
        if (requestOptions.portalWebFragments.portalPage === (0, $kPxiY.REQUEST_CREATE)) requestOptions.portal = {
            id: requestOptions.portalWebFragments.portalId
        };
        else {
            requestTypes.push('portal');
            requestOptions.portal = {
                id: requestOptions.portalWebFragments.portalId
            };
        }
    }
    // Implicitly fetch request create if portalWebFragments defined portalId and requestTypeId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.requestTypeId && requestOptions.portalWebFragments.portalPage === (0, $kPxiY.REQUEST_CREATE) && !requestTypes.includes('reqCreate')) requestOptions.reqCreate = {
        portalId: requestOptions.portalWebFragments.portalId,
        id: requestOptions.portalWebFragments.requestTypeId
    };
    if (requestTypes.includes('portal') && requestOptions.portal) requestOptions.portalId = requestOptions.portal.id;
    return {
        requestTypes: requestTypes,
        requestOptions: requestOptions
    };
};
const $23424ed1bc97fa7c$var$adjustRequestOptions = (options)=>{
    const requestOptions = {
        ...options
    };
    for(const key in requestOptions){
        if (requestOptions.hasOwnProperty(key)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        {
            if (requestOptions[key].portalId) // The backend needs this as a blanket rule.
            // If we run into any we add it onto the request options object.
            // Last one wins.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            requestOptions.portalId = requestOptions[key].portalId;
        }
    }
    for(const key in requestOptions)if ($23424ed1bc97fa7c$var$optionsNotAvailableInRestEndpoint.includes(key)) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    delete requestOptions[key];
    return requestOptions;
};
const $23424ed1bc97fa7c$var$getTraceId = (err)=>{
    let traceId = '';
    try {
        const { xhr: xhr } = err;
        traceId = xhr.getResponseHeader('Atl-Traceid') || '';
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get traceId from error', e);
    }
    return traceId;
};
const $23424ed1bc97fa7c$var$getAllResponseHeaders = (err)=>{
    let headers = '';
    try {
        const { xhr: xhr } = err;
        headers = xhr.getAllResponseHeaders();
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get headers from error', e);
    }
    return headers;
};
const $23424ed1bc97fa7c$export$a06581639cf24e1e = (modelsDescriptor, options, modelContext, context = (0, $eDcdn.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $23424ed1bc97fa7c$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $23424ed1bc97fa7c$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((response)=>response.response).catch((err)=>{
        const traceId = $23424ed1bc97fa7c$var$getTraceId(err);
        const responseHeaders = $23424ed1bc97fa7c$var$getAllResponseHeaders(err);
        return (0, $8jOUp.Observable).throw(err.response ? {
            traceId: traceId,
            responseHeaders: responseHeaders,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            status: err.response.status,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorMessages: err.response.errorMessages,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionUrl: err.response.nextActionUrl,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionDisplayText: err.response.nextActionDisplayText
        } : {
            traceId: traceId,
            responseHeaders: responseHeaders,
            status: err.status,
            errorMessages: []
        });
    });
};
const $23424ed1bc97fa7c$var$requestModelsWithRetries = (modelsDescriptor, options, modelContext, context = (0, $eDcdn.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $23424ed1bc97fa7c$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    let retries = 0;
    return (0, $llRGw.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $23424ed1bc97fa7c$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    }).pipe((0, $gnOql.retryWhen)((errors)=>errors.mergeMap((errorValue)=>{
            retries += 1;
            const status = errorValue.status;
            if (!$23424ed1bc97fa7c$var$isRetryableStatusCode(status) || retries > $23424ed1bc97fa7c$var$NUMBER_OF_RETRIES) return (0, $8jOUp.Observable).throw(errorValue);
            return (0, $8jOUp.Observable).of(errorValue).delay($23424ed1bc97fa7c$var$maxExpBackoffWithJitter(retries, $23424ed1bc97fa7c$var$BASE_DELAY_MS, $23424ed1bc97fa7c$var$MAX_RETRY_DELAY_MS));
        })), (0, $gnOql.map)((response)=>{
        if (retries > 0) //only send event if there were retries to avoid sending too many events
        (0, $gEVth.operationalEvent)($23424ed1bc97fa7c$var$createOperationalEvent(requestTypes, retries, true, undefined));
        //Update timezone meta tag when model response has user properties
        if (response.response) {
            var _modelResponse$user;
            const modelResponse = response.response;
            if (modelResponse !== null && modelResponse !== void 0 && (_modelResponse$user = modelResponse.user) !== null && _modelResponse$user !== void 0 && _modelResponse$user.timezone) {
                var _modelResponse$user2;
                $23424ed1bc97fa7c$var$setTimezoneMetaTag(modelResponse === null || modelResponse === void 0 || (_modelResponse$user2 = modelResponse.user) === null || _modelResponse$user2 === void 0 ? void 0 : _modelResponse$user2.timezone);
            }
        }
        return response.response;
    }), (0, $gnOql.catchError)((err)=>{
        (0, $gEVth.operationalEvent)($23424ed1bc97fa7c$var$createOperationalEvent(requestTypes, retries, false, err.status));
        const traceId = $23424ed1bc97fa7c$var$getTraceId(err);
        const responseHeaders = $23424ed1bc97fa7c$var$getAllResponseHeaders(err);
        return new (0, $8jOUp.Observable)((observer)=>{
            observer.error(err.response ? {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.response.status,
                errorMessages: err.response.errorMessages,
                nextActionUrl: err.response.nextActionUrl,
                nextActionDisplayText: err.response.nextActionDisplayText
            } : {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.status,
                errorMessages: []
            });
        });
    }));
};
const $23424ed1bc97fa7c$export$be054e1f3ca89815 = (modelsDescriptor, options, modelContext, context = (0, $eDcdn.contextPath))=>{
    if ((0, $lFpPv.isRetryMechanismTuningEnabled)()) return $23424ed1bc97fa7c$var$requestModelsWithRetries(modelsDescriptor, options, modelContext, context);
    return $23424ed1bc97fa7c$export$a06581639cf24e1e(modelsDescriptor, options, modelContext, context);
};

});
parcelRegister("kPxiY", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER", () => $1197c0e420708f57$export$8e46b442a40fd146);
$parcel$export(module.exports, "PORTAL_HOME", () => $1197c0e420708f57$export$e7639abf9d430473);
$parcel$export(module.exports, "REQUEST_CREATE", () => $1197c0e420708f57$export$722b80b55a1414f);
$parcel$export(module.exports, "REQUEST_DETAILS", () => $1197c0e420708f57$export$9e5185d6a2a60dc);
$parcel$export(module.exports, "REQUEST_LIST", () => $1197c0e420708f57$export$805e3047ef7cb33e);
$parcel$export(module.exports, "PROFILE", () => $1197c0e420708f57$export$91c3232a793620f2);
$parcel$export(module.exports, "PROFILE_PANEL", () => $1197c0e420708f57$export$b87ce3f352c7af33);
$parcel$export(module.exports, "REQUEST_CREATE_PANEL", () => $1197c0e420708f57$export$fcdaac8f3aa2d02e);
$parcel$export(module.exports, "HEADER", () => $1197c0e420708f57$export$526a1e214ba17198);
$parcel$export(module.exports, "SUB_HEADER", () => $1197c0e420708f57$export$9e49b02bf8c4161f);
$parcel$export(module.exports, "FOOTER", () => $1197c0e420708f57$export$d8d929c77d921e7d);
$parcel$export(module.exports, "DETAILS", () => $1197c0e420708f57$export$e094c4db500be584);
$parcel$export(module.exports, "DETAILS_SIDE_SECTION", () => $1197c0e420708f57$export$6c81f8b23c0dd1d2);
$parcel$export(module.exports, "ConnectFragment", () => $1197c0e420708f57$export$aa8ab018415f92e4);

var $bSJIT = parcelRequire("bSJIT");

var $haAAx = parcelRequire("haAAx");

var $hbEJt = parcelRequire("hbEJt");

var $bNlla = parcelRequire("bNlla");

var $7JRwm = parcelRequire("7JRwm");
const $1197c0e420708f57$export$8e46b442a40fd146 = 'HELP_CENTER';
const $1197c0e420708f57$export$e7639abf9d430473 = 'PORTAL';
const $1197c0e420708f57$export$722b80b55a1414f = 'CREATE_REQUEST';
const $1197c0e420708f57$export$9e5185d6a2a60dc = 'VIEW_REQUEST';
const $1197c0e420708f57$export$805e3047ef7cb33e = 'MY_REQUESTS';
const $1197c0e420708f57$export$91c3232a793620f2 = 'PROFILE';
const $1197c0e420708f57$export$b87ce3f352c7af33 = 'profilePagePanel';
const $1197c0e420708f57$export$fcdaac8f3aa2d02e = 'requestCreatePanel';
const $1197c0e420708f57$export$526a1e214ba17198 = 'headerPanels';
const $1197c0e420708f57$export$9e49b02bf8c4161f = 'subheaderPanels';
const $1197c0e420708f57$export$d8d929c77d921e7d = 'footerPanels';
const $1197c0e420708f57$export$e094c4db500be584 = 'detailsPanels';
const $1197c0e420708f57$export$6c81f8b23c0dd1d2 = 'optionPanels';
class $1197c0e420708f57$export$aa8ab018415f92e4 extends $bSJIT.Component {
    componentDidMount() {
        const { fetchConnectFragments: fetchConnectFragments, page: page, connectFragments: connectFragments, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        if (!connectFragments) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        else this.fireConnectFragmentAnalytics();
        this.fireShowConnectBlockedAppsBanner();
    }
    componentDidUpdate(prevProps) {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId || prevProps.portalId !== portalId;
        if (requestTypeUpdated) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        if (!prevProps.connectFragments && connectFragments) this.fireConnectFragmentAnalytics();
        else if (prevProps.connectFragments && connectFragments) {
            const previouslyErrored = 'error' in prevProps.connectFragments;
            const currentlyErrored = 'error' in connectFragments;
            if (previouslyErrored !== currentlyErrored) this.fireConnectFragmentAnalytics();
        }
        if (prevProps.projectId !== this.props.projectId) this.fireShowConnectBlockedAppsBanner();
    }
    render() {
        const { connectFragments: connectFragments, className: className, location: location } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $7JRwm.default), {
            location: location,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            connectFragments: connectFragments
        });
    }
    constructor(...args){
        super(...args), this.fireShowConnectBlockedAppsBanner = ()=>{
            const { page: page, projectId: projectId } = this.props;
            if ((0, $bNlla.isConnectBlockedAppsRelevantPage)(page)) {
                this.props.resetBannerState(page);
                if (projectId) (0, $bNlla.fetchIsAnyConnectAppBlocked)({
                    projectId: projectId,
                    page: page
                }).then((isBlocked)=>{
                    if (isBlocked) this.props.showBanner(page);
                }).catch(()=>{
                // The error is already logged in the fetchIsAnyConnectAppBlocked function
                });
            }
        }, this.fireConnectFragmentAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, connectFragments: connectFragments, location: location, portalId: portalId, requestTypeId: requestTypeId } = this.props;
            if (!createAnalyticsEvent || !connectFragments) return;
            const isError = 'error' in connectFragments;
            if (!isError && connectFragments.length === 0) return;
            const uniqueAppKeys = !isError ? (0, $hbEJt.getUniqueAppKeysFromConnectFragments)(connectFragments) : [];
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                location: location,
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: isError ? 'failed' : 'loaded',
                appKeys: uniqueAppKeys
            });
            analyticsEvent.fire();
        };
    }
}

});
parcelRegister("bNlla", function(module, exports) {
$parcel$export(module.exports, "isConnectBlockedAppsRelevantPage", () => $7de8397ae1dea094$export$aa2542e596000b48);
$parcel$export(module.exports, "fetchIsAnyConnectAppBlocked", () => $7de8397ae1dea094$export$40f1d90131a12a2);

var $llRGw = parcelRequire("llRGw");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $7de8397ae1dea094$var$perProjectRequestCache = new Map();
const $7de8397ae1dea094$export$aa2542e596000b48 = (page)=>{
    const relevantConnectPages = [
        'PORTAL',
        'CREATE_REQUEST',
        'VIEW_REQUEST'
    ];
    return relevantConnectPages.includes(page);
};
const $7de8397ae1dea094$export$40f1d90131a12a2 = (context)=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/atlassian-connect/latest/addon-access`;
    const body = {
        context: context
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const cacheKey = context.projectId.toString();
    let cachedRequest = $7de8397ae1dea094$var$perProjectRequestCache.get(cacheKey);
    if (!cachedRequest) {
        cachedRequest = (0, $llRGw.post)(uri, body, headers).map(({ response: response })=>response.isAnyAppBlocked).catch((e)=>{
            (0, $jBiia.trackError)('connect.blocked-apps.fetch.failed', {}, e);
            return Promise.reject(e);
        }).toPromise();
        $7de8397ae1dea094$var$perProjectRequestCache.set(cacheKey, cachedRequest);
    }
    return cachedRequest;
};

});

parcelRegister("7JRwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e74f577544f4f6d8$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $4i1bM = parcelRequire("4i1bM");
const $e74f577544f4f6d8$var$ConnectFragmentsDumb = ({ connectFragments: connectFragments, className: className, location: location })=>{
    if (!connectFragments || 'error' in connectFragments) return null;
    if (connectFragments.length) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ $bSJIT.createElement($e74f577544f4f6d8$var$Root, {
        className: className
    }, connectFragments.map((fragment)=>/*#__PURE__*/ $bSJIT.createElement((0, $4i1bM.default), {
            key: fragment.key,
            fullKey: fragment.key,
            location: location,
            fragmentHtml: fragment.html
        }))));
    return null;
};
var $e74f577544f4f6d8$export$2e2bcd8739ae039 = $e74f577544f4f6d8$var$ConnectFragmentsDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e74f577544f4f6d8$var$Root = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-19x1uwk-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("4v2A7", function(module, exports) {
$parcel$export(module.exports, "css", () => $bc256c71d28d9626$export$dbf350e5966cf602);
$parcel$export(module.exports, "injectGlobal", () => $bc256c71d28d9626$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "keyframes", () => $bc256c71d28d9626$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeProvider", () => $bc256c71d28d9626$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $bc256c71d28d9626$export$e8748c6a27b910dc);
$parcel$export(module.exports, "default", () => $bc256c71d28d9626$export$2e2bcd8739ae039);

var $3KQuy = parcelRequire("3KQuy");
const { css: $bc256c71d28d9626$export$dbf350e5966cf602, injectGlobal: $bc256c71d28d9626$export$efb9f5caaa2ca0c7, keyframes: $bc256c71d28d9626$export$d25ddfdf17c3ad3e, ThemeProvider: $bc256c71d28d9626$export$d8964aec282183a3, default: $bc256c71d28d9626$var$styled } = $3KQuy;
// Custom type definition for withTheme method for styled components so that
// we don't have to manually inject theme props in storybook
const $bc256c71d28d9626$export$e8748c6a27b910dc = (component)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $3KQuy.withTheme(component);
var $bc256c71d28d9626$export$2e2bcd8739ae039 = $bc256c71d28d9626$var$styled;

});
parcelRegister("3KQuy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "isStyledComponent", () => $2bbe62bbc402bed9$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "consolidateStreamedStyles", () => $2bbe62bbc402bed9$export$953e7e0c06f2f28b);
$parcel$export(module.exports, "css", () => $2bbe62bbc402bed9$export$dbf350e5966cf602);
$parcel$export(module.exports, "StyleSheetManager", () => $2bbe62bbc402bed9$export$a473771da2f0ff7c);
$parcel$export(module.exports, "ServerStyleSheet", () => $2bbe62bbc402bed9$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "ThemeProvider", () => $2bbe62bbc402bed9$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $2bbe62bbc402bed9$export$e8748c6a27b910dc);
$parcel$export(module.exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", () => $2bbe62bbc402bed9$export$84079c323bb0915e);
$parcel$export(module.exports, "keyframes", () => $2bbe62bbc402bed9$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "injectGlobal", () => $2bbe62bbc402bed9$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "default", () => $2bbe62bbc402bed9$export$2e2bcd8739ae039);

var $jEubn = parcelRequire("jEubn");

var $bSJIT = parcelRequire("bSJIT");

var $lcXix = parcelRequire("lcXix");

var $4wByO = parcelRequire("4wByO");

var $4yQYd = parcelRequire("4yQYd");

var $3qLaL = parcelRequire("3qLaL");

var $e4Sjd = parcelRequire("e4Sjd");

var $4eGW1 = parcelRequire("4eGW1");
var $2bbe62bbc402bed9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $2bbe62bbc402bed9$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $2bbe62bbc402bed9$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $2bbe62bbc402bed9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2bbe62bbc402bed9$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $2bbe62bbc402bed9$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $2bbe62bbc402bed9$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $2bbe62bbc402bed9$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $2bbe62bbc402bed9$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $2bbe62bbc402bed9$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $2bbe62bbc402bed9$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $2bbe62bbc402bed9$var$StyledComponentsError = function(_Error) {
    $2bbe62bbc402bed9$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $2bbe62bbc402bed9$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $2bbe62bbc402bed9$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $2bbe62bbc402bed9$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $2bbe62bbc402bed9$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($2bbe62bbc402bed9$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jEubn)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $2bbe62bbc402bed9$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $2bbe62bbc402bed9$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $2bbe62bbc402bed9$var$isPlainObject(chunk) ? $2bbe62bbc402bed9$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $2bbe62bbc402bed9$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $2bbe62bbc402bed9$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($lcXix)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $2bbe62bbc402bed9$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($lcXix)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $2bbe62bbc402bed9$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $2bbe62bbc402bed9$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $2bbe62bbc402bed9$var$parsingRules;
        $2bbe62bbc402bed9$var$parsingRules = [];
        return parsedRules;
    }
};
var $2bbe62bbc402bed9$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($4wByO)))(function(rule) {
    $2bbe62bbc402bed9$var$parsingRules.push(rule);
});
$2bbe62bbc402bed9$var$stylis.use([
    $2bbe62bbc402bed9$var$parseRulesPlugin,
    $2bbe62bbc402bed9$var$returnRulesPlugin
]);
$2bbe62bbc402bed9$var$stylisSplitter.use([
    $2bbe62bbc402bed9$var$parseRulesPlugin,
    $2bbe62bbc402bed9$var$returnRulesPlugin
]);
var $2bbe62bbc402bed9$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($2bbe62bbc402bed9$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $2bbe62bbc402bed9$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $2bbe62bbc402bed9$var$splitByRules = function splitByRules(css) {
    return $2bbe62bbc402bed9$var$stylisSplitter('', css);
};
// 
function $2bbe62bbc402bed9$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $2bbe62bbc402bed9$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $2bbe62bbc402bed9$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $2bbe62bbc402bed9$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $2bbe62bbc402bed9$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $2bbe62bbc402bed9$var$charsLength; x = Math.floor(x / $2bbe62bbc402bed9$var$charsLength))name = $2bbe62bbc402bed9$var$getAlphabeticChar(x % $2bbe62bbc402bed9$var$charsLength) + name;
    return $2bbe62bbc402bed9$var$getAlphabeticChar(x % $2bbe62bbc402bed9$var$charsLength) + name;
};
// 
var $2bbe62bbc402bed9$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $2bbe62bbc402bed9$var$EMPTY_ARRAY = Object.freeze([]);
var $2bbe62bbc402bed9$var$EMPTY_OBJECT = Object.freeze({});
// 
var $2bbe62bbc402bed9$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $2bbe62bbc402bed9$var$isPlainObject(styles)) // $FlowFixMe
    return $2bbe62bbc402bed9$var$flatten($2bbe62bbc402bed9$var$interleave($2bbe62bbc402bed9$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $2bbe62bbc402bed9$var$flatten($2bbe62bbc402bed9$var$interleave(styles, interpolations));
};
// 
var $2bbe62bbc402bed9$var$SC_ATTR = (typeof $4eGW1 !== 'undefined' && undefined, 'data-styled-components');
var $2bbe62bbc402bed9$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $2bbe62bbc402bed9$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $2bbe62bbc402bed9$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $2bbe62bbc402bed9$var$DISABLE_SPEEDY = false;
// 
var $2bbe62bbc402bed9$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $2bbe62bbc402bed9$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($2bbe62bbc402bed9$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $2bbe62bbc402bed9$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $2bbe62bbc402bed9$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $2bbe62bbc402bed9$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $2bbe62bbc402bed9$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $2bbe62bbc402bed9$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $2bbe62bbc402bed9$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $2bbe62bbc402bed9$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $2bbe62bbc402bed9$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $2bbe62bbc402bed9$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $2bbe62bbc402bed9$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $2bbe62bbc402bed9$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $2bbe62bbc402bed9$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $2bbe62bbc402bed9$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $2bbe62bbc402bed9$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $2bbe62bbc402bed9$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($2bbe62bbc402bed9$var$SC_ATTR, '');
    var nonce = $2bbe62bbc402bed9$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $2bbe62bbc402bed9$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $2bbe62bbc402bed9$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $2bbe62bbc402bed9$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $2bbe62bbc402bed9$var$SC_ATTR + '="' + $2bbe62bbc402bed9$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $2bbe62bbc402bed9$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$2bbe62bbc402bed9$var$SC_ATTR] = $2bbe62bbc402bed9$var$stringifyNames(names), _props);
        var nonce = $2bbe62bbc402bed9$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement('style', $2bbe62bbc402bed9$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $2bbe62bbc402bed9$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $2bbe62bbc402bed9$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $2bbe62bbc402bed9$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $2bbe62bbc402bed9$var$sheetForTag(el);
        var insertIndex = $2bbe62bbc402bed9$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($2bbe62bbc402bed9$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $2bbe62bbc402bed9$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $2bbe62bbc402bed9$var$sheetForTag(el);
        var removalIndex = $2bbe62bbc402bed9$var$addUpUntilIndex(sizes, marker);
        $2bbe62bbc402bed9$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $2bbe62bbc402bed9$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $2bbe62bbc402bed9$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $2bbe62bbc402bed9$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $2bbe62bbc402bed9$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $2bbe62bbc402bed9$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $2bbe62bbc402bed9$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $2bbe62bbc402bed9$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $2bbe62bbc402bed9$var$wrapAsElement(css, names),
        toHTML: $2bbe62bbc402bed9$var$wrapAsHtmlTag(css, names)
    };
};
var $2bbe62bbc402bed9$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($2bbe62bbc402bed9$var$makeTextMarker(id));
};
var $2bbe62bbc402bed9$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $2bbe62bbc402bed9$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $2bbe62bbc402bed9$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $2bbe62bbc402bed9$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $2bbe62bbc402bed9$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $2bbe62bbc402bed9$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $2bbe62bbc402bed9$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $2bbe62bbc402bed9$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $2bbe62bbc402bed9$var$wrapAsElement(css, names),
        toHTML: $2bbe62bbc402bed9$var$wrapAsHtmlTag(css, names)
    };
};
var $2bbe62bbc402bed9$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $2bbe62bbc402bed9$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $2bbe62bbc402bed9$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $2bbe62bbc402bed9$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $2bbe62bbc402bed9$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $2bbe62bbc402bed9$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $2bbe62bbc402bed9$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $2bbe62bbc402bed9$var$wrapAsElement(css, names),
        toHTML: $2bbe62bbc402bed9$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $2bbe62bbc402bed9$var$makeServerTag = function makeServerTag() {
    return $2bbe62bbc402bed9$var$makeServerTagInternal();
};
var $2bbe62bbc402bed9$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($2bbe62bbc402bed9$var$IS_BROWSER && !forceServer) {
        var el = $2bbe62bbc402bed9$var$makeStyleTag(target, tagEl, insertBefore);
        if ($2bbe62bbc402bed9$var$DISABLE_SPEEDY) return $2bbe62bbc402bed9$var$makeBrowserTag(el, getImportRuleTag);
        else return $2bbe62bbc402bed9$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $2bbe62bbc402bed9$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $2bbe62bbc402bed9$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $2bbe62bbc402bed9$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $2bbe62bbc402bed9$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $2bbe62bbc402bed9$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $2bbe62bbc402bed9$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $2bbe62bbc402bed9$var$MAX_SIZE = void 0;
if ($2bbe62bbc402bed9$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $2bbe62bbc402bed9$var$MAX_SIZE = $2bbe62bbc402bed9$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $2bbe62bbc402bed9$var$MAX_SIZE = -1;
var $2bbe62bbc402bed9$var$sheetRunningId = 0;
var $2bbe62bbc402bed9$var$master = void 0;
var $2bbe62bbc402bed9$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $2bbe62bbc402bed9$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $2bbe62bbc402bed9$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $2bbe62bbc402bed9$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $2bbe62bbc402bed9$var$sheetRunningId += 1;
        this.id = $2bbe62bbc402bed9$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$2bbe62bbc402bed9$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $2bbe62bbc402bed9$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($2bbe62bbc402bed9$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($2bbe62bbc402bed9$var$SC_ATTR) || '').trim().split($2bbe62bbc402bed9$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $2bbe62bbc402bed9$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $2bbe62bbc402bed9$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $2bbe62bbc402bed9$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $2bbe62bbc402bed9$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $2bbe62bbc402bed9$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $2bbe62bbc402bed9$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $2bbe62bbc402bed9$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $2bbe62bbc402bed9$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $bSJIT.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $2bbe62bbc402bed9$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $2bbe62bbc402bed9$var$master || ($2bbe62bbc402bed9$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $2bbe62bbc402bed9$var$_StyleSheetManager$ch;
var $2bbe62bbc402bed9$export$a473771da2f0ff7c = function(_Component) {
    $2bbe62bbc402bed9$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $2bbe62bbc402bed9$var$classCallCheck(this, StyleSheetManager);
        return $2bbe62bbc402bed9$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$2bbe62bbc402bed9$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $2bbe62bbc402bed9$var$StyleSheet(this.props.target);
        else throw new $2bbe62bbc402bed9$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $bSJIT.Component));
$2bbe62bbc402bed9$export$a473771da2f0ff7c.childContextTypes = ($2bbe62bbc402bed9$var$_StyleSheetManager$ch = {}, $2bbe62bbc402bed9$var$_StyleSheetManager$ch[$2bbe62bbc402bed9$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).instanceOf($2bbe62bbc402bed9$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).instanceOf($2bbe62bbc402bed9$export$ae8c7d15c8b89a20)
]).isRequired, $2bbe62bbc402bed9$var$_StyleSheetManager$ch);
// 
var $2bbe62bbc402bed9$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $2bbe62bbc402bed9$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $2bbe62bbc402bed9$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $2bbe62bbc402bed9$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2bbe62bbc402bed9$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $2bbe62bbc402bed9$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $2bbe62bbc402bed9$var$LIMIT = 200;
var $2bbe62bbc402bed9$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $2bbe62bbc402bed9$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $2bbe62bbc402bed9$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $2bbe62bbc402bed9$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $2bbe62bbc402bed9$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $2bbe62bbc402bed9$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $2bbe62bbc402bed9$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($2bbe62bbc402bed9$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($2bbe62bbc402bed9$var$dashesAtEnds, '');
}
// 
function $2bbe62bbc402bed9$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $2bbe62bbc402bed9$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $2bbe62bbc402bed9$var$generateDisplayName(target) {
    return $2bbe62bbc402bed9$var$isTag(target) ? 'styled.' + target : 'Styled(' + $2bbe62bbc402bed9$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $2bbe62bbc402bed9$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $2bbe62bbc402bed9$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $2bbe62bbc402bed9$var$ATTRIBUTE_NAME_CHAR = $2bbe62bbc402bed9$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $2bbe62bbc402bed9$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $2bbe62bbc402bed9$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $2bbe62bbc402bed9$var$validAttr = function(name) {
    return $2bbe62bbc402bed9$var$ATTRIBUTE_REGEX.test(name) || $2bbe62bbc402bed9$var$isCustomAttribute(name.toLowerCase());
};
// 
function $2bbe62bbc402bed9$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $2bbe62bbc402bed9$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $2bbe62bbc402bed9$var$_contextShape, $2bbe62bbc402bed9$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $2bbe62bbc402bed9$var$CHANNEL = '__styled-components__';
var $2bbe62bbc402bed9$var$CHANNEL_NEXT = $2bbe62bbc402bed9$var$CHANNEL + 'next__';
var $2bbe62bbc402bed9$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
});
var $2bbe62bbc402bed9$var$contextShape = ($2bbe62bbc402bed9$var$_contextShape = {}, $2bbe62bbc402bed9$var$_contextShape[$2bbe62bbc402bed9$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func, $2bbe62bbc402bed9$var$_contextShape[$2bbe62bbc402bed9$var$CHANNEL_NEXT] = $2bbe62bbc402bed9$var$CONTEXT_CHANNEL_SHAPE, $2bbe62bbc402bed9$var$_contextShape);
var $2bbe62bbc402bed9$var$warnChannelDeprecated = void 0;
var $2bbe62bbc402bed9$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $2bbe62bbc402bed9$export$d8964aec282183a3 = function(_Component) {
    $2bbe62bbc402bed9$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $2bbe62bbc402bed9$var$classCallCheck(this, ThemeProvider);
        var _this = $2bbe62bbc402bed9$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$2bbe62bbc402bed9$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $2bbe62bbc402bed9$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $2bbe62bbc402bed9$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$2bbe62bbc402bed9$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$2bbe62bbc402bed9$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$2bbe62bbc402bed9$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($2bbe62bbc402bed9$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $2bbe62bbc402bed9$var$_typeof(theme)) !== 'object') throw new $2bbe62bbc402bed9$var$StyledComponentsError(8);
        return $2bbe62bbc402bed9$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $bSJIT.Component));
$2bbe62bbc402bed9$export$d8964aec282183a3.childContextTypes = $2bbe62bbc402bed9$var$contextShape;
$2bbe62bbc402bed9$export$d8964aec282183a3.contextTypes = ($2bbe62bbc402bed9$var$_ThemeProvider$contex = {}, $2bbe62bbc402bed9$var$_ThemeProvider$contex[$2bbe62bbc402bed9$var$CHANNEL_NEXT] = $2bbe62bbc402bed9$var$CONTEXT_CHANNEL_SHAPE, $2bbe62bbc402bed9$var$_ThemeProvider$contex);
var $2bbe62bbc402bed9$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $2bbe62bbc402bed9$var$STATIC_EXECUTION_CONTEXT = {};
var $2bbe62bbc402bed9$var$modifiedContextShape = $2bbe62bbc402bed9$var$_extends({}, $2bbe62bbc402bed9$var$contextShape, ($2bbe62bbc402bed9$var$_babelHelpers$extends = {}, $2bbe62bbc402bed9$var$_babelHelpers$extends[$2bbe62bbc402bed9$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).instanceOf($2bbe62bbc402bed9$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).instanceOf($2bbe62bbc402bed9$export$ae8c7d15c8b89a20)
]), $2bbe62bbc402bed9$var$_babelHelpers$extends));
var $2bbe62bbc402bed9$var$identifiers = {};
/* We depend on components having unique IDs */ var $2bbe62bbc402bed9$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $2bbe62bbc402bed9$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($2bbe62bbc402bed9$var$identifiers[displayName] || 0) + 1;
    $2bbe62bbc402bed9$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $2bbe62bbc402bed9$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $2bbe62bbc402bed9$var$BaseStyledComponent = function(_Component) {
    $2bbe62bbc402bed9$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $2bbe62bbc402bed9$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $2bbe62bbc402bed9$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $2bbe62bbc402bed9$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$2bbe62bbc402bed9$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $2bbe62bbc402bed9$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$2bbe62bbc402bed9$var$hasInInheritanceChain(attr, (0, $bSJIT.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $2bbe62bbc402bed9$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$2bbe62bbc402bed9$var$CONTEXT_KEY] || $2bbe62bbc402bed9$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($2bbe62bbc402bed9$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$2bbe62bbc402bed9$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($2bbe62bbc402bed9$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $2bbe62bbc402bed9$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $2bbe62bbc402bed9$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $2bbe62bbc402bed9$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $2bbe62bbc402bed9$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $2bbe62bbc402bed9$var$_extends({}, this.attrs, {
            className: className
        });
        if ($2bbe62bbc402bed9$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $2bbe62bbc402bed9$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $2bbe62bbc402bed9$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $bSJIT.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $bSJIT.Component));
var $2bbe62bbc402bed9$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$2bbe62bbc402bed9$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $2bbe62bbc402bed9$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $2bbe62bbc402bed9$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $2bbe62bbc402bed9$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $2bbe62bbc402bed9$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $2bbe62bbc402bed9$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $2bbe62bbc402bed9$var$classCallCheck(this, StyledComponent);
                return $2bbe62bbc402bed9$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $2bbe62bbc402bed9$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($2bbe62bbc402bed9$var$isTag(tag) ? tag : $2bbe62bbc402bed9$var$escape($2bbe62bbc402bed9$var$getComponentName(tag)));
                var newOptions = $2bbe62bbc402bed9$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $2bbe62bbc402bed9$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $2bbe62bbc402bed9$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $2bbe62bbc402bed9$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $2bbe62bbc402bed9$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $2bbe62bbc402bed9$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($3qLaL)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2bbe62bbc402bed9$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $2bbe62bbc402bed9$var$areStylesCacheable = $2bbe62bbc402bed9$var$IS_BROWSER;
var $2bbe62bbc402bed9$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$2bbe62bbc402bed9$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $2bbe62bbc402bed9$var$isHMREnabled = null && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $2bbe62bbc402bed9$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($2bbe62bbc402bed9$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $2bbe62bbc402bed9$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$2bbe62bbc402bed9$var$isHMREnabled && $2bbe62bbc402bed9$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$2bbe62bbc402bed9$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $2bbe62bbc402bed9$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($2bbe62bbc402bed9$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $2bbe62bbc402bed9$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $2bbe62bbc402bed9$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $2bbe62bbc402bed9$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $2bbe62bbc402bed9$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $2bbe62bbc402bed9$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $2bbe62bbc402bed9$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($2bbe62bbc402bed9$var$murmurhash($2bbe62bbc402bed9$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $2bbe62bbc402bed9$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $2bbe62bbc402bed9$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $2bbe62bbc402bed9$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $2bbe62bbc402bed9$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $2bbe62bbc402bed9$var$EMPTY_OBJECT;
        if (!(0, $e4Sjd.isValidElementType)(tag)) throw new $2bbe62bbc402bed9$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $2bbe62bbc402bed9$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $2bbe62bbc402bed9$var$_extends({}, options, {
                attrs: $2bbe62bbc402bed9$var$_extends({}, options.attrs || $2bbe62bbc402bed9$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $2bbe62bbc402bed9$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $2bbe62bbc402bed9$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $2bbe62bbc402bed9$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $2bbe62bbc402bed9$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $2bbe62bbc402bed9$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $2bbe62bbc402bed9$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $2bbe62bbc402bed9$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$2bbe62bbc402bed9$var$CHANNEL_NEXT];
            var themeProp = $2bbe62bbc402bed9$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $2bbe62bbc402bed9$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $2bbe62bbc402bed9$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$2bbe62bbc402bed9$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $2bbe62bbc402bed9$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component);
    WithTheme.contextTypes = $2bbe62bbc402bed9$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $2bbe62bbc402bed9$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($3qLaL)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $2bbe62bbc402bed9$export$84079c323bb0915e = {
    StyleSheet: $2bbe62bbc402bed9$var$StyleSheet
};
/* Instantiate singletons */ var $2bbe62bbc402bed9$var$ComponentStyle = $2bbe62bbc402bed9$var$_ComponentStyle($2bbe62bbc402bed9$var$generateAlphabeticName, $2bbe62bbc402bed9$var$flatten, $2bbe62bbc402bed9$var$stringifyRules);
var $2bbe62bbc402bed9$var$constructWithOptions = $2bbe62bbc402bed9$var$_constructWithOptions($2bbe62bbc402bed9$export$dbf350e5966cf602);
var $2bbe62bbc402bed9$var$StyledComponent = $2bbe62bbc402bed9$var$_StyledComponent($2bbe62bbc402bed9$var$ComponentStyle, $2bbe62bbc402bed9$var$constructWithOptions);
/* Instantiate exported singletons */ var $2bbe62bbc402bed9$export$d25ddfdf17c3ad3e = $2bbe62bbc402bed9$var$_keyframes($2bbe62bbc402bed9$var$generateAlphabeticName, $2bbe62bbc402bed9$var$stringifyRules, $2bbe62bbc402bed9$export$dbf350e5966cf602);
var $2bbe62bbc402bed9$export$efb9f5caaa2ca0c7 = $2bbe62bbc402bed9$var$_injectGlobal($2bbe62bbc402bed9$var$stringifyRules, $2bbe62bbc402bed9$export$dbf350e5966cf602);
var $2bbe62bbc402bed9$var$styled = $2bbe62bbc402bed9$var$_styled($2bbe62bbc402bed9$var$StyledComponent, $2bbe62bbc402bed9$var$constructWithOptions);
var $2bbe62bbc402bed9$export$2e2bcd8739ae039 = $2bbe62bbc402bed9$var$styled;

});
parcelRegister("jEubn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $2OxsQ = parcelRequire("2OxsQ");
var $e4e92a63589c67c3$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $e4e92a63589c67c3$var$hyphenateStyleName(string) {
    return $2OxsQ(string).replace($e4e92a63589c67c3$var$msPattern, '-ms-');
}
module.exports = $e4e92a63589c67c3$var$hyphenateStyleName;

});
parcelRegister("2OxsQ", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $20ca3596867a4856$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $20ca3596867a4856$var$hyphenate(string) {
    return string.replace($20ca3596867a4856$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $20ca3596867a4856$var$hyphenate;

});


parcelRegister("lcXix", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("4wByO", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("3qLaL", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $27f86452e6d12e0c$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $27f86452e6d12e0c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $27f86452e6d12e0c$var$defineProperty = Object.defineProperty;
var $27f86452e6d12e0c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $27f86452e6d12e0c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $27f86452e6d12e0c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $27f86452e6d12e0c$var$getPrototypeOf = Object.getPrototypeOf;
var $27f86452e6d12e0c$var$objectPrototype = $27f86452e6d12e0c$var$getPrototypeOf && $27f86452e6d12e0c$var$getPrototypeOf(Object);
function $27f86452e6d12e0c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($27f86452e6d12e0c$var$objectPrototype) {
            var inheritedComponent = $27f86452e6d12e0c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $27f86452e6d12e0c$var$objectPrototype) $27f86452e6d12e0c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $27f86452e6d12e0c$var$getOwnPropertyNames(sourceComponent);
        if ($27f86452e6d12e0c$var$getOwnPropertySymbols) keys = keys.concat($27f86452e6d12e0c$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$27f86452e6d12e0c$var$REACT_STATICS[key] && !$27f86452e6d12e0c$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $27f86452e6d12e0c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $27f86452e6d12e0c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $27f86452e6d12e0c$var$hoistNonReactStatics;

});



parcelRegister("4i1bM", function(module, exports) {
$parcel$export(module.exports, "default", () => $42f6c15c734354e5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $haAAx = parcelRequire("haAAx");

var $hbEJt = parcelRequire("hbEJt");
class $42f6c15c734354e5$var$ConnectFragmentDumb extends $bSJIT.Component {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement("div", {
            ref: this.onRef,
            dangerouslySetInnerHTML: {
                __html: this.props.fragmentHtml
            }
        });
    }
    constructor(...args){
        super(...args), this.componentDidMount = ()=>{
            const { onMount: onMount } = this.props;
            onMount && onMount();
        }, this.onRef = (element)=>{
            if (element) this.savedElement = element;
            this.executeConnectIFrameScripts();
        }, this.executeConnectIFrameScripts = ()=>{
            if (this.savedElement) {
                // We manually go through each script tag and then clone it so that it will execute
                const scriptTags = this.savedElement.querySelectorAll('script') || [];
                Array.prototype.forEach.call(scriptTags, (scriptTag)=>{
                    if (scriptTag.parentNode) {
                        // We create a new script tag and then append it to the parent node this way it will execute properly.
                        // Upgrading @atlaskit/platform; fix these violations.
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                        const newScript = document.createElement('script');
                        newScript.innerHTML = scriptTag.innerHTML;
                        scriptTag.parentNode.replaceChild(newScript, scriptTag);
                    }
                });
            }
        }, this.componentDidUpdate = ()=>{
            // If we don't call this, then Connect addon iframes are not rendered when a component is reloaded
            this.executeConnectIFrameScripts();
        };
    }
}
var $42f6c15c734354e5$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'ConnectFragment'
})((0, $kIbto.default)({
    onMount: (create, props)=>create({
            action: 'mounted',
            analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
            location: props.location ?? 'LocationUnknown',
            appKeys: [
                (0, $hbEJt.getAppKeyFromFullKey)(props.fullKey)
            ]
        }).fire()
})($42f6c15c734354e5$var$ConnectFragmentDumb));

});




parcelRegister("3qDrS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d93dc9c1cca2f73e$export$2e2bcd8739ae039);

var $4ZMmh = parcelRequire("4ZMmh");
const $d93dc9c1cca2f73e$var$defer = ()=>{
    let resolve;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reject;
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: // @ts-ignore
        resolve,
        reject: // @ts-ignore
        reject
    };
};
const $d93dc9c1cca2f73e$var$proxyFunction = (func, wait, options = {})=>{
    let arrArg = [];
    let deferred = $d93dc9c1cca2f73e$var$defer();
    const callThenResetArgs = (args)=>{
        try {
            const result = func(args);
            deferred.resolve(result);
        } catch (err) {
            deferred.reject(err);
        }
        arrArg = [];
        deferred = $d93dc9c1cca2f73e$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $4ZMmh.debounce)(callThenResetArgs, wait, options);
    return (arg)=>{
        if (arg) arrArg = arrArg.concat(arg);
        debouncedFunc(arrArg);
        return deferred.promise;
    };
};
var $d93dc9c1cca2f73e$export$2e2bcd8739ae039 = $d93dc9c1cca2f73e$var$proxyFunction;

});



parcelRegister("b8PDJ", function(module, exports) {
$parcel$export(module.exports, "updateEnvAction", () => (parcelRequire("5ESvo")).updateEnvAction);
$parcel$export(module.exports, "UPDATE_ENV", () => (parcelRequire("5ESvo")).UPDATE_ENV);
$parcel$export(module.exports, "updateXsrfAction", () => (parcelRequire("5ESvo")).updateXsrfAction);
$parcel$export(module.exports, "UPDATE_XSRF", () => (parcelRequire("5ESvo")).UPDATE_XSRF);

var $5ESvo = parcelRequire("5ESvo");

});
parcelRegister("5ESvo", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ENV", () => $1470ba66248ee960$export$54fc9c8b94b5595f);
$parcel$export(module.exports, "UPDATE_XSRF", () => $1470ba66248ee960$export$b024063085428a5d);
$parcel$export(module.exports, "updateEnvAction", () => $1470ba66248ee960$export$b66da392cb9395e8);
$parcel$export(module.exports, "updateXsrfAction", () => $1470ba66248ee960$export$1293ace05a0f6e97);
const $1470ba66248ee960$export$54fc9c8b94b5595f = 'state.persisted.env.UPDATE_ENV';
const $1470ba66248ee960$export$b024063085428a5d = 'state.persisted.env.UPDATE_XSRF';
const $1470ba66248ee960$export$b66da392cb9395e8 = (env)=>({
        payload: env,
        type: $1470ba66248ee960$export$54fc9c8b94b5595f
    });
const $1470ba66248ee960$export$1293ace05a0f6e97 = (xsrf)=>({
        payload: xsrf,
        type: $1470ba66248ee960$export$b024063085428a5d
    });

});


parcelRegister("3kyZk", function(module, exports) {
$parcel$export(module.exports, "FETCH_HELP_CENTER_MODEL", () => $cb1b8ff9227b9696$export$5586a78b777598b9);
$parcel$export(module.exports, "INVALIDATE_HELP_CENTER_RELAY_STORE", () => $cb1b8ff9227b9696$export$e3632d3a6ee981be);
$parcel$export(module.exports, "fetchHelpCenterAction", () => $cb1b8ff9227b9696$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "invalidateHelpCenterStoreAction", () => $cb1b8ff9227b9696$export$d06ed959afe649d4);
$parcel$export(module.exports, "FETCH_HELP_CENTER_BRANDING_MODEL", () => $cb1b8ff9227b9696$export$d8cc5374b8afc050);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $cb1b8ff9227b9696$export$42cfcdfd4935cc23);

var $hn5Mq = parcelRequire("hn5Mq");
const $cb1b8ff9227b9696$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $cb1b8ff9227b9696$export$e3632d3a6ee981be = 'epic.model.INVALIDATE_HELP_CENTER_RELAY_STORE';
const $cb1b8ff9227b9696$export$61e2f9e78cb604c7 = (0, $hn5Mq.buildModelsActionCreator)($cb1b8ff9227b9696$export$5586a78b777598b9, 'sharedPortal');
const $cb1b8ff9227b9696$export$d06ed959afe649d4 = ()=>({
        type: $cb1b8ff9227b9696$export$e3632d3a6ee981be
    });
const $cb1b8ff9227b9696$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $cb1b8ff9227b9696$export$42cfcdfd4935cc23 = (0, $hn5Mq.buildModelsActionCreator)($cb1b8ff9227b9696$export$d8cc5374b8afc050, 'helpCenterBranding');

});


parcelRegister("kvtf9", function(module, exports) {
$parcel$export(module.exports, "handleAjaxErrorEpic", () => $63c631a0d01cc9d2$export$91f7ef464c43cc97);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $1vXf6 = parcelRequire("1vXf6");
const $63c631a0d01cc9d2$export$91f7ef464c43cc97 = (action$)=>{
    return action$.ofType((0, $xb2jO.HANDLE_AJAX_ERROR)).mergeMap((handleAjaxErrorAction)=>{
        const { error: error } = handleAjaxErrorAction.payload;
        // TODO: Handle errors that come directly from the backend already translated (https://jdog.jira-dev.com/browse/JNW-236)
        const errorDescriptor = (0, $1vXf6.getDefaultError)(error);
        const genericAction = errorDescriptor.action === undefined ? undefined : [
            errorDescriptor.action
        ];
        const errorFlagAction = (0, $xb2jO.showErrorFlag)(errorDescriptor.title, errorDescriptor.description, genericAction);
        return (0, $8jOUp.Observable).of(errorFlagAction);
    });
};

});

parcelRegister("heEvb", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterBrandingEpic", () => $be8bf5f8199ac69c$export$dbe2bc3705ae4647);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationSuccess", () => $be8bf5f8199ac69c$export$8d56a889e7db4abe);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationFailure", () => $be8bf5f8199ac69c$export$f0ef15072aa7d01f);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $cywwP = parcelRequire("cywwP");

var $3kyZk = parcelRequire("3kyZk");

var $6YkAQ = parcelRequire("6YkAQ");
parcelRequire("bFWGU");
var $dhHUc = parcelRequire("dhHUc");

var $9VIRk = parcelRequire("9VIRk");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");

var $G6QpT = parcelRequire("G6QpT");
const $be8bf5f8199ac69c$var$getAnnouncementBodyFromHCBrandingBody = (body, siteDefaultLanguageTag)=>{
    return {
        header: body.translations[siteDefaultLanguageTag].announcementHeader,
        message: body.translations[siteDefaultLanguageTag].announcementMessage
    };
};
/*
    Different APIs for admins and agents. Admins have permissions to update help center branding along
    with announcements so help center branding api is used. For the agents on the other hand announcement API is used.
    TODO: Separate out announcements from help center branding.
*/ const $be8bf5f8199ac69c$var$getUpdateBrandingPromise = (body, canAdministerJira, rawBrandingResponse)=>{
    return !canAdministerJira && rawBrandingResponse ? (0, $6YkAQ.updateAnnouncement)($be8bf5f8199ac69c$var$getAnnouncementBodyFromHCBrandingBody(body, rawBrandingResponse.siteDefaultLanguageTag)) : (0, $6YkAQ.updateBranding)(body);
};
const $be8bf5f8199ac69c$export$dbe2bc3705ae4647 = (action$, store)=>{
    return action$.ofType((0, $cywwP.UPDATE_HELP_CENTER_BRANDING)).mergeMap((updateBrandingAction)=>{
        const { payload: payload, meta: meta } = updateBrandingAction;
        const { body: body } = payload;
        const state = store.getState();
        const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return $be8bf5f8199ac69c$var$getUpdateBrandingPromise(body, canAdministerJira, rawBrandingResponse).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
            const modifiedResponse = rawBrandingResponse ? {
                ...rawBrandingResponse,
                ...response
            } : response;
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingModelAction)(modifiedResponse)), (0, $8jOUp.Observable).of((0, $cywwP.clearHCPreviewModelAction)()));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && error.status >= 500) (0, $jBiia.legacySendEvent)((0, $G6QpT.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $cywwP.updateBrandingFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
        });
    });
};
const $be8bf5f8199ac69c$export$8d56a889e7db4abe = (action$, store)=>{
    return action$.ofType((0, $cywwP.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS)).mergeMap((updateBrandingMutationSuccessAction)=>{
        const { response: response, meta: meta } = updateBrandingMutationSuccessAction;
        const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9VIRk.updateThemeSideBarExperience).success();
        const modifiedResponse = rawBrandingResponse ? {
            ...rawBrandingResponse,
            ...response
        } : response;
        return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingModelAction)(modifiedResponse)), (0, $8jOUp.Observable).of((0, $cywwP.clearHCPreviewModelAction)()), (0, $8jOUp.Observable).of((0, $3kyZk.invalidateHelpCenterStoreAction)()));
    });
};
const $be8bf5f8199ac69c$export$f0ef15072aa7d01f = (action$)=>{
    return action$.ofType((0, $cywwP.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE)).mergeMap((updateBrandingMutationFailureAction)=>{
        const { error: error, meta: meta } = updateBrandingMutationFailureAction;
        //const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        // const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return (0, $8jOUp.Observable).from(Promise.reject(error)).catch((err)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(err.status)) (0, $jBiia.legacySendEvent)((0, $G6QpT.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            if (!(0, $h92tT.isNetworkOrClientErrorCode)(err.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $9VIRk.updateThemeSideBarExperience).failure({
                metadata: {
                    error: err.message
                }
            });
            else // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $9VIRk.updateThemeSideBarExperience).success();
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $cywwP.updateBrandingFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(err)));
        });
    });
};

});
parcelRegister("cywwP", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_PREVIEW_MODEL", () => $d27a872a14240855$export$f0cfe50b4b81e5e5);
$parcel$export(module.exports, "CLEAR_HELP_CENTER_PREVIEW_MODEL", () => $d27a872a14240855$export$61f6f0f25aef37a);
$parcel$export(module.exports, "EDITING_HELP_CENTER", () => $d27a872a14240855$export$429f706ec067751a);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING", () => $d27a872a14240855$export$e49dc7a9374bb0ed);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS", () => $d27a872a14240855$export$75be5b55c825c5f4);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE", () => $d27a872a14240855$export$bb6272ebd92e455f);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_FAILURE", () => $d27a872a14240855$export$d249354c8afb6e40);
$parcel$export(module.exports, "UPLOAD_START", () => $d27a872a14240855$export$b03358de8b670bd6);
$parcel$export(module.exports, "UPLOAD_END", () => $d27a872a14240855$export$56dfdb40a4995b23);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_SAVE_START", () => $d27a872a14240855$export$d6b07b90ea00e758);
$parcel$export(module.exports, "editingHelpCenter", () => $d27a872a14240855$export$8f5c235cd10e8248);
$parcel$export(module.exports, "updateHCPreviewModelAction", () => $d27a872a14240855$export$52aab28d032a2b51);
$parcel$export(module.exports, "clearHCPreviewModelAction", () => $d27a872a14240855$export$1044307c0b2e2fc4);
$parcel$export(module.exports, "updateBranding", () => $d27a872a14240855$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateBrandingMutationSuccess", () => $d27a872a14240855$export$e7ca67101719c569);
$parcel$export(module.exports, "updateBrandingMutationFailure", () => $d27a872a14240855$export$4522a481460f5735);
$parcel$export(module.exports, "updateBrandingSaveStart", () => $d27a872a14240855$export$676616ec28a47579);
$parcel$export(module.exports, "updateBrandingFailure", () => $d27a872a14240855$export$be3ae179d979bebe);
$parcel$export(module.exports, "uploadStart", () => $d27a872a14240855$export$34ff845ea9831833);
$parcel$export(module.exports, "uploadEnd", () => $d27a872a14240855$export$f986c9a8af4f4565);
const $d27a872a14240855$export$f0cfe50b4b81e5e5 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_PREVIEW_MODEL';
const $d27a872a14240855$export$61f6f0f25aef37a = 'state.ui.help-center-preview.CLEAR_HELP_CENTER_PREVIEW_MODEL';
const $d27a872a14240855$export$429f706ec067751a = 'state.ui.help-center-preview.EDITING_HELP_CENTER';
const $d27a872a14240855$export$e49dc7a9374bb0ed = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING';
const $d27a872a14240855$export$75be5b55c825c5f4 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS';
const $d27a872a14240855$export$bb6272ebd92e455f = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE';
const $d27a872a14240855$export$d249354c8afb6e40 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_FAILURE';
const $d27a872a14240855$export$b03358de8b670bd6 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_START';
const $d27a872a14240855$export$56dfdb40a4995b23 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_END';
const $d27a872a14240855$export$d6b07b90ea00e758 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_SAVE_START';
const $d27a872a14240855$export$8f5c235cd10e8248 = (isEditing)=>({
        type: $d27a872a14240855$export$429f706ec067751a,
        payload: isEditing
    });
const $d27a872a14240855$export$52aab28d032a2b51 = (previewPayload)=>({
        payload: previewPayload,
        type: $d27a872a14240855$export$f0cfe50b4b81e5e5
    });
const $d27a872a14240855$export$1044307c0b2e2fc4 = ()=>({
        type: $d27a872a14240855$export$61f6f0f25aef37a
    });
const $d27a872a14240855$export$eb176b496ba6ad25 = (body, meta = {})=>({
        meta: meta,
        type: $d27a872a14240855$export$e49dc7a9374bb0ed,
        payload: {
            body: body
        }
    });
const $d27a872a14240855$export$e7ca67101719c569 = (response, meta = {})=>({
        meta: meta,
        response: response,
        type: $d27a872a14240855$export$75be5b55c825c5f4
    });
const $d27a872a14240855$export$4522a481460f5735 = (error, meta = {})=>({
        meta: meta,
        error: error,
        type: $d27a872a14240855$export$bb6272ebd92e455f
    });
const $d27a872a14240855$export$676616ec28a47579 = ()=>({
        type: $d27a872a14240855$export$d6b07b90ea00e758
    });
const $d27a872a14240855$export$be3ae179d979bebe = ()=>({
        type: $d27a872a14240855$export$d249354c8afb6e40
    });
const $d27a872a14240855$export$34ff845ea9831833 = (fileCollection)=>({
        type: $d27a872a14240855$export$b03358de8b670bd6,
        payload: {
            fileCollection: fileCollection
        }
    });
const $d27a872a14240855$export$f986c9a8af4f4565 = (fileCollection)=>({
        type: $d27a872a14240855$export$56dfdb40a4995b23,
        payload: {
            fileCollection: fileCollection
        }
    });

});

parcelRegister("6YkAQ", function(module, exports) {
$parcel$export(module.exports, "BrandingTargetCollections", () => $0ea7fc99517a415a$export$b5e98a61473b07ad);
$parcel$export(module.exports, "getUploadTokenWithClientInfo", () => $0ea7fc99517a415a$export$1c22c9bf986a3d58);
$parcel$export(module.exports, "updateBranding", () => $0ea7fc99517a415a$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateAnnouncement", () => $0ea7fc99517a415a$export$159f65cfbafa86b5);

var $llRGw = parcelRequire("llRGw");

var $4ZMmh = parcelRequire("4ZMmh");

var $lJH1c = parcelRequire("lJH1c");

var $eDcdn = parcelRequire("eDcdn");
var $0ea7fc99517a415a$export$b5e98a61473b07ad = /*#__PURE__*/ function(BrandingTargetCollections) {
    BrandingTargetCollections["banner"] = "sd-banner-upload";
    BrandingTargetCollections["logo"] = "sd-logo-upload";
    return BrandingTargetCollections;
}({});
const $0ea7fc99517a415a$export$de87322aceb1e609 = async (targetCollection, context = (0, $eDcdn.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    .map((ajaxResponse)=>ajaxResponse.response.token).toPromise();
};
const $0ea7fc99517a415a$export$1c22c9bf986a3d58 = async (targetCollection, context = (0, $eDcdn.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-media-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise();
};
const $0ea7fc99517a415a$export$eb176b496ba6ad25 = (body, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/with-translations`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $lJH1c.ModelsCache).getInstance().del('helpCenterBranding');
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
/*
    Map announcement response to help center branding response. Since we are using same epic and reducer for
    announcement API and help center branding API. TODO: A new epic for help center announcements.
*/ const $0ea7fc99517a415a$var$mapAnnouncementResponseToHelpCenterBrandingResponse = (ajaxResponse)=>{
    let modifiedTranslations = {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = ajaxResponse.response;
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    modifiedTranslations = (0, $4ZMmh.mapValues)(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    response.translations, (translation)=>({
            announcementHeader: translation.header,
            announcementMessage: translation.message
        }));
    return {
        translations: modifiedTranslations,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementHeader: response.header,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementMessageWiki: response.messageWiki
    };
};
const $0ea7fc99517a415a$export$159f65cfbafa86b5 = (body, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/announcement/help-center`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $lJH1c.ModelsCache).getInstance().del('helpCenterBranding');
    return (0, $llRGw.post)(uri, body, headers).map($0ea7fc99517a415a$var$mapAnnouncementResponseToHelpCenterBrandingResponse);
};

});

parcelRegister("bFWGU", function(module, exports) {
$parcel$export(module.exports, "updateHCBrandingModelAction", () => (parcelRequire("dhHUc")).updateHCBrandingModelAction);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => (parcelRequire("dhHUc")).updateHelpCenterModelAction);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => (parcelRequire("dhHUc")).updateHCBrandingLoaderAction);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => (parcelRequire("dhHUc")).UPDATE_HELP_CENTER_BRANDING_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => (parcelRequire("dhHUc")).UPDATE_HELP_CENTER_BRANDING_LOADER);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => (parcelRequire("dhHUc")).UPDATE_HELP_CENTER_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => (parcelRequire("dhHUc")).UPDATE_HELP_CENTER_THEME_COLOR);

var $dhHUc = parcelRequire("dhHUc");

});
parcelRegister("dhHUc", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => $0cbfa38cdc91abc2$export$791f10ed5ca1afbc);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => $0cbfa38cdc91abc2$export$72877be1acecfff2);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => $0cbfa38cdc91abc2$export$51eff4874ab833ce);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => $0cbfa38cdc91abc2$export$749d9a3565d43c74);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => $0cbfa38cdc91abc2$export$9c200ab172652613);
$parcel$export(module.exports, "updateHCBrandingModelAction", () => $0cbfa38cdc91abc2$export$765a61788077a43a);
$parcel$export(module.exports, "updateHCThemeColorAction", () => $0cbfa38cdc91abc2$export$8865f165e0e8e610);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => $0cbfa38cdc91abc2$export$b9ec760cc662cf16);
const $0cbfa38cdc91abc2$export$791f10ed5ca1afbc = 'state.persisted.help-center.UPDATE_HELP_CENTER_MODEL';
const $0cbfa38cdc91abc2$export$72877be1acecfff2 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_MODEL';
const $0cbfa38cdc91abc2$export$51eff4874ab833ce = 'state.persisted.help-center.UPDATE_HELP_CENTER_THEME_COLOR';
const $0cbfa38cdc91abc2$export$749d9a3565d43c74 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_LOADER';
const $0cbfa38cdc91abc2$export$9c200ab172652613 = (modelResponse)=>({
        payload: modelResponse,
        type: $0cbfa38cdc91abc2$export$791f10ed5ca1afbc
    });
const $0cbfa38cdc91abc2$export$765a61788077a43a = (brandingResponse)=>({
        payload: brandingResponse,
        type: $0cbfa38cdc91abc2$export$72877be1acecfff2
    });
const $0cbfa38cdc91abc2$export$8865f165e0e8e610 = (themeColorResponse)=>({
        payload: themeColorResponse,
        type: $0cbfa38cdc91abc2$export$51eff4874ab833ce
    });
const $0cbfa38cdc91abc2$export$b9ec760cc662cf16 = (loaded)=>({
        payload: {
            loaded: loaded
        },
        type: $0cbfa38cdc91abc2$export$749d9a3565d43c74
    });

});


parcelRegister("9VIRk", function(module, exports) {
$parcel$export(module.exports, "updateAnnouncementSideBarExperience", () => $37e85220eece5005$export$9202b582e9a7e7e5);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperience", () => $37e85220eece5005$export$bbfbb2132f16ad3e);
$parcel$export(module.exports, "updateThemeSideBarExperience", () => $37e85220eece5005$export$d4df676089e680c5);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $37e85220eece5005$export$9202b582e9a7e7e5 = new (0, $1we90.UFOExperience)((0, $eAZuG.updateAnnouncementSideBarExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $37e85220eece5005$export$bbfbb2132f16ad3e = new (0, $1we90.UFOExperience)((0, $eAZuG.updateLoginAnnouncementSideBarExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $37e85220eece5005$export$d4df676089e680c5 = new (0, $1we90.UFOExperience)((0, $eAZuG.updateThemeSideBarExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});
parcelRegister("eAZuG", function(module, exports) {
$parcel$export(module.exports, "ProductExperienceStart", () => $e1a5fb1d3ee96e46$export$8c235a9c4b486599);
$parcel$export(module.exports, "externalLinksProductExperienceId", () => $e1a5fb1d3ee96e46$export$df6053b3f6f8746e);
$parcel$export(module.exports, "yourApprovalExperienceId", () => $e1a5fb1d3ee96e46$export$2748904bbde569a6);
$parcel$export(module.exports, "approvalStatusSectionExperienceId", () => $e1a5fb1d3ee96e46$export$53d4142e5691fc30);
$parcel$export(module.exports, "publishLayoutExperienceId", () => $e1a5fb1d3ee96e46$export$7706cfa126a5e293);
$parcel$export(module.exports, "topicsReorderExperienceId", () => $e1a5fb1d3ee96e46$export$45f14e05062fc2ca);
$parcel$export(module.exports, "helpCenterTopicsProductExperienceId", () => $e1a5fb1d3ee96e46$export$3bdaba26dccf5ee6);
$parcel$export(module.exports, "helpCenterViewHomePageExperienceId", () => $e1a5fb1d3ee96e46$export$d165863a94dcab28);
$parcel$export(module.exports, "helpCenterTopicEditExperienceId", () => $e1a5fb1d3ee96e46$export$d58e75689d75e480);
$parcel$export(module.exports, "helpCenterTopicViewExperienceId", () => $e1a5fb1d3ee96e46$export$f1ae827b1686e4b6);
$parcel$export(module.exports, "viewHomepageExperienceId", () => $e1a5fb1d3ee96e46$export$42633b810d73bab2);
$parcel$export(module.exports, "viewCustomPageExperienceId", () => $e1a5fb1d3ee96e46$export$c25f92d477e645db);
$parcel$export(module.exports, "profileExperienceId", () => $e1a5fb1d3ee96e46$export$6b7cf274ce127c6c);
$parcel$export(module.exports, "updateManageColumnsSidebarExperienceId", () => $e1a5fb1d3ee96e46$export$1d4505191d749c3);
$parcel$export(module.exports, "editHomepageExperienceId", () => $e1a5fb1d3ee96e46$export$f5b418a8fb4c2e52);
$parcel$export(module.exports, "editCustomPageExperienceId", () => $e1a5fb1d3ee96e46$export$1a5dc88687c6c743);
$parcel$export(module.exports, "searchExperienceId", () => $e1a5fb1d3ee96e46$export$8e695cad45fa9462);
$parcel$export(module.exports, "inlineSearchExperienceId", () => $e1a5fb1d3ee96e46$export$ef4e3240bcfb0749);
$parcel$export(module.exports, "helpCenterReportingExperienceId", () => $e1a5fb1d3ee96e46$export$a31e9803c7cf4e9c);
$parcel$export(module.exports, "helpCenterReportingContentGapExperienceId", () => $e1a5fb1d3ee96e46$export$a49db1fcfecaa197);
$parcel$export(module.exports, "helpCentersManagementExperienceId", () => $e1a5fb1d3ee96e46$export$28b0efc551538ce4);
$parcel$export(module.exports, "manageProjectsExperienceId", () => $e1a5fb1d3ee96e46$export$8125d660e6f5341);
$parcel$export(module.exports, "managePagesExperienceId", () => $e1a5fb1d3ee96e46$export$b3c36987f8f3e130);
$parcel$export(module.exports, "editHelpCenterExperienceId", () => $e1a5fb1d3ee96e46$export$9d36a9a1a5392695);
$parcel$export(module.exports, "avatarMenuExperienceId", () => $e1a5fb1d3ee96e46$export$ccd2c0d87dacec5b);
$parcel$export(module.exports, "updateAnnouncementSideBarExperienceId", () => $e1a5fb1d3ee96e46$export$afc2346bbf17f6dc);
$parcel$export(module.exports, "updateSinglePortalAnnouncementSideBarExperienceId", () => $e1a5fb1d3ee96e46$export$ad5e73bffe8e8683);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperienceId", () => $e1a5fb1d3ee96e46$export$7b03636a868ec87a);
$parcel$export(module.exports, "updateThemeSideBarExperienceId", () => $e1a5fb1d3ee96e46$export$3a07bc7f4f48662a);
$parcel$export(module.exports, "requestCreateEntitlementPickerExperienceId", () => $e1a5fb1d3ee96e46$export$950826a562410f6a);
$parcel$export(module.exports, "csmContactsUFormPickerExperienceId", () => $e1a5fb1d3ee96e46$export$eb5378d79d45e2ce);
$parcel$export(module.exports, "csmViewHomepageExperienceId", () => $e1a5fb1d3ee96e46$export$cb86036c3a8f0a3d);

var $7WRjA = parcelRequire("7WRjA");
const $e1a5fb1d3ee96e46$export$8c235a9c4b486599 = (props)=>{
    const { ufoExperience: ufoExperience } = props;
    (0, $7WRjA.useUFOComponentExperience)(ufoExperience);
    return null;
};
const $e1a5fb1d3ee96e46$export$df6053b3f6f8746e = 'service-management.help-center.external-resources';
const $e1a5fb1d3ee96e46$export$2748904bbde569a6 = 'service-management.help-center.your-approval';
const $e1a5fb1d3ee96e46$export$53d4142e5691fc30 = 'service-management.help-center.approval-status-section';
const $e1a5fb1d3ee96e46$export$7706cfa126a5e293 = 'service-management.help-center.publish.layout';
const $e1a5fb1d3ee96e46$export$45f14e05062fc2ca = 'service-management.help-center.topics.reorder';
const $e1a5fb1d3ee96e46$export$3bdaba26dccf5ee6 = 'service-management.help-center.topics';
const $e1a5fb1d3ee96e46$export$d165863a94dcab28 = 'service-management.help-center.view.homepage';
const $e1a5fb1d3ee96e46$export$d58e75689d75e480 = 'service-management.help-center.topic.edit';
const $e1a5fb1d3ee96e46$export$f1ae827b1686e4b6 = 'service-management.help-center.topic.view';
const $e1a5fb1d3ee96e46$export$42633b810d73bab2 = 'service-management.help-center.advanced.homepage.view';
const $e1a5fb1d3ee96e46$export$c25f92d477e645db = 'service-management.help-center.custom.page.view';
const $e1a5fb1d3ee96e46$export$6b7cf274ce127c6c = 'service-management.help-center.profile.view';
const $e1a5fb1d3ee96e46$export$1d4505191d749c3 = 'service-management.help-center.update.manage-columns-sidebar-view';
const $e1a5fb1d3ee96e46$export$f5b418a8fb4c2e52 = 'service-management.help-center.advanced.homepage.edit';
const $e1a5fb1d3ee96e46$export$1a5dc88687c6c743 = 'service-management.help-center.custom.page.edit';
const $e1a5fb1d3ee96e46$export$8e695cad45fa9462 = 'service-management.help-center.search';
const $e1a5fb1d3ee96e46$export$ef4e3240bcfb0749 = 'service-management.help-center.inline-search';
const $e1a5fb1d3ee96e46$export$a31e9803c7cf4e9c = 'service-management.help-center.help-center-reporting';
const $e1a5fb1d3ee96e46$export$a49db1fcfecaa197 = 'service-management.help-center.help-center-reporting-content-gap';
const $e1a5fb1d3ee96e46$export$28b0efc551538ce4 = 'service-management.help-center.help-centers-management';
const $e1a5fb1d3ee96e46$export$8125d660e6f5341 = 'service-management.help-center.manage-projects';
const $e1a5fb1d3ee96e46$export$b3c36987f8f3e130 = 'service-management.help-center.manage-pages';
const $e1a5fb1d3ee96e46$export$9d36a9a1a5392695 = 'service-management.help-center.edit-details';
const $e1a5fb1d3ee96e46$export$814916ea7ef3fe17 = 'service-management.help-center.multi-hc-dropdown';
const $e1a5fb1d3ee96e46$export$ccd2c0d87dacec5b = 'service-management.help-center.avatar-menu';
const $e1a5fb1d3ee96e46$export$afc2346bbf17f6dc = 'service-management.help-center.update.announcement-sidebar';
const $e1a5fb1d3ee96e46$export$ad5e73bffe8e8683 = 'service-management.help-center.update.single-portal-announcement-sidebar';
const $e1a5fb1d3ee96e46$export$7b03636a868ec87a = 'service-management.help-center.update.login-announcement-sidebar';
const $e1a5fb1d3ee96e46$export$3a07bc7f4f48662a = 'service-management.help-center.update.theme-sidebar';
const $e1a5fb1d3ee96e46$export$950826a562410f6a = 'service-management.help-center.request-create.jsm-cs-entitlement-custom-field-load';
const $e1a5fb1d3ee96e46$export$a14ae97aa64fd38f = 'service-management.help-center.csm-help-center-form-picker';
const $e1a5fb1d3ee96e46$export$eb5378d79d45e2ce = 'service-management.help-center.csm-contact-us-form-picker';
const $e1a5fb1d3ee96e46$export$cb86036c3a8f0a3d = 'service-management.help-center.advanced.csm.homepage.view';

});
parcelRegister("7WRjA", function(module, exports) {
$parcel$export(module.exports, "useUFOComponentExperience", () => $be94223533d0d2e0$export$30ab340faaed55d4);

var $bSJIT = parcelRequire("bSJIT");
const $be94223533d0d2e0$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $bSJIT.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $be94223533d0d2e0$export$30ab340faaed55d4 = (experience)=>{
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $be94223533d0d2e0$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("1we90", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $d129f282a66ed118$export$c00d22927c60484a);

var $aoCK3 = parcelRequire("aoCK3");
class $d129f282a66ed118$export$c00d22927c60484a extends (0, $aoCK3.UFOAbstractExperience) {
}

});
parcelRegister("aoCK3", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $610de316dd041acc$export$d31c89db257648c);

var $7RHfd = parcelRequire("7RHfd");

var $gdUUy = parcelRequire("gdUUy");

var $6mdBG = parcelRequire("6mdBG");

var $eroKj = parcelRequire("eroKj");

var $dYSIi = parcelRequire("dYSIi");

var $9cfIG = parcelRequire("9cfIG");

var $arOcd = parcelRequire("arOcd");

var $9xMu4 = parcelRequire("9xMu4");

var $8xKZS = parcelRequire("8xKZS");

var $jInug = parcelRequire("jInug");

var $6JVSW = parcelRequire("6JVSW");

var $6nA7L = parcelRequire("6nA7L");

var $hYvS4 = parcelRequire("hYvS4");

var $iIik8 = parcelRequire("iIik8");

var $bm7wG = parcelRequire("bm7wG");

var $6WXky = parcelRequire("6WXky");

var $l8Bc9 = parcelRequire("l8Bc9");

var $8F2vT = parcelRequire("8F2vT");

var $8Qpx6 = parcelRequire("8Qpx6");

var $7r7ey = parcelRequire("7r7ey");

var $aeKTM = parcelRequire("aeKTM");
const $610de316dd041acc$var$getPageVisibleState = ()=>{
    return !(0, $8xKZS.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $l8Bc9.PageVisibleState).VISIBLE : (0, $l8Bc9.PageVisibleState).HIDDEN;
};
class $610de316dd041acc$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $8F2vT.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $l8Bc9.PageVisibleState).MIXED;
            (0, $6WXky.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $610de316dd041acc$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7r7ey.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $iIik8.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8Qpx6.canTransition)(this.state, newState)) {
            (0, $iIik8.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $8F2vT.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $aeKTM.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $7RHfd.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $aeKTM.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $6JVSW.getGlobalEventStream)().push((0, $hYvS4.unsubscribeEvent)((0, $l8Bc9.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $iIik8.ufolog)('this.parent', this.parent);
                (0, $6JVSW.getGlobalEventStream)().push((0, $jInug.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $iIik8.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bm7wG.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $8F2vT.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $610de316dd041acc$var$getPageVisibleState();
            (0, $6WXky.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $iIik8.ufolog)('subscribed', this.id);
                (0, $6JVSW.getGlobalEventStream)().push((0, $6nA7L.subscribeEvent)((0, $l8Bc9.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $l8Bc9.FMP_MARK) && name !== (0, $l8Bc9.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bm7wG.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $aeKTM.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $8F2vT.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $l8Bc9.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $l8Bc9.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $gdUUy.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $9cfIG.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $dYSIi.generateTraceId)(),
                    spanId: (0, $eroKj.generateSpanId)()
                };
                (0, $arOcd.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $gdUUy.fg)('ufo_v1_tracing')) (0, $6mdBG.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bm7wG.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $6WXky.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $8F2vT.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $8F2vT.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $8F2vT.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $iIik8.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $9xMu4.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $gdUUy.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("9xMu4", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $2288842d8a799682$export$2295b861f318254a);
// temp solution until we can get it automated
const $2288842d8a799682$export$2295b861f318254a = '0.1.5';

});

parcelRegister("jInug", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $4775cf48fb51d76b$export$7c957416596ca127);

var $l8Bc9 = parcelRequire("l8Bc9");
const $4775cf48fb51d76b$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $l8Bc9.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});

parcelRegister("6nA7L", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $cbef358798176c2d$export$37863216db4b714d);

var $l8Bc9 = parcelRequire("l8Bc9");
const $cbef358798176c2d$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $l8Bc9.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("hYvS4", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $745cde03bf6e981f$export$ee1a7bd1fc9ea85e);

var $l8Bc9 = parcelRequire("l8Bc9");
const $745cde03bf6e981f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $l8Bc9.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("8F2vT", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $4985b2e57cd30b93$export$81b70111112841a0);
const $4985b2e57cd30b93$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8Qpx6", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $4628222aba5bd119$export$178881f329fdb81f);

var $8F2vT = parcelRequire("8F2vT");
const $4628222aba5bd119$var$UFOStateAvailableTransitions = {
    [(0, $8F2vT.UFOExperienceState).NOT_STARTED.id]: [
        (0, $8F2vT.UFOExperienceState).STARTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).STARTED.id]: [
        (0, $8F2vT.UFOExperienceState).IN_PROGRESS.id,
        (0, $8F2vT.UFOExperienceState).BLOCKED.id,
        (0, $8F2vT.UFOExperienceState).SUCCEEDED.id,
        (0, $8F2vT.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $8F2vT.UFOExperienceState).FAILED.id,
        (0, $8F2vT.UFOExperienceState).ABORTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $8F2vT.UFOExperienceState).BLOCKED.id,
        (0, $8F2vT.UFOExperienceState).SUCCEEDED.id,
        (0, $8F2vT.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $8F2vT.UFOExperienceState).FAILED.id,
        (0, $8F2vT.UFOExperienceState).ABORTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).BLOCKED.id]: [
        (0, $8F2vT.UFOExperienceState).RECOVERED.id,
        (0, $8F2vT.UFOExperienceState).ABORTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).RECOVERED.id]: [
        (0, $8F2vT.UFOExperienceState).STARTED.id,
        (0, $8F2vT.UFOExperienceState).SUCCEEDED.id,
        (0, $8F2vT.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $8F2vT.UFOExperienceState).FAILED.id,
        (0, $8F2vT.UFOExperienceState).ABORTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).SUCCEEDED.id]: [
        (0, $8F2vT.UFOExperienceState).STARTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $8F2vT.UFOExperienceState).SUCCEEDED.id,
        (0, $8F2vT.UFOExperienceState).FAILED.id,
        (0, $8F2vT.UFOExperienceState).ABORTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).FAILED.id]: [
        (0, $8F2vT.UFOExperienceState).STARTED.id
    ],
    [(0, $8F2vT.UFOExperienceState).ABORTED.id]: [
        (0, $8F2vT.UFOExperienceState).STARTED.id
    ]
};
const $4628222aba5bd119$export$178881f329fdb81f = (state1, state2)=>{
    return $4628222aba5bd119$var$UFOStateAvailableTransitions[state1.id] && $4628222aba5bd119$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("aeKTM", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $fc80280e2d69a247$export$c753e8669d30c8ad);

var $kUbVp = parcelRequire("kUbVp");
const $fc80280e2d69a247$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $kUbVp.roundPerfNow)();
};

});
parcelRegister("kUbVp", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $b6296e91685fcdd2$export$5f490af6b2b115cf);
const $b6296e91685fcdd2$export$5f490af6b2b115cf = ()=>~~performance.now();

});





parcelRegister("h92tT", function(module, exports) {
$parcel$export(module.exports, "isNetworkErrorCode", () => $10d8890fe4dd6670$export$1a5a4674dd906e7e);
$parcel$export(module.exports, "isClientErrorCode", () => $10d8890fe4dd6670$export$d31fd506ce75fa65);
$parcel$export(module.exports, "isNetworkOrClientErrorCode", () => $10d8890fe4dd6670$export$53ee51427129200c);
const $10d8890fe4dd6670$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $10d8890fe4dd6670$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $10d8890fe4dd6670$export$53ee51427129200c = (statusCode)=>$10d8890fe4dd6670$export$1a5a4674dd906e7e(statusCode) || $10d8890fe4dd6670$export$d31fd506ce75fa65(statusCode);

});


parcelRegister("7O9Ek", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpEpic", () => $3913041c8533f27e$export$ccd8cad10bc12583);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $dFQ3X = parcelRequire("dFQ3X");
parcelRequire("xOZC4");
var $jN84E = parcelRequire("jN84E");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");

var $1vXf6 = parcelRequire("1vXf6");
const $3913041c8533f27e$export$ccd8cad10bc12583 = (action$)=>{
    return action$.ofType((0, $jN84E.INVITED_SIGN_UP)).mergeMap((invitedSignUpAction)=>{
        const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, contactAdminsFormEnabled: contactAdminsFormEnabled, setPasswordJwt: setPasswordJwt } = invitedSignUpAction.payload;
        return (0, $dFQ3X.invitedSignUp)({
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            setPasswordJwt: setPasswordJwt
        }).flatMap(()=>{
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $jN84E.invitedSignUpSuccess)()), (0, $8jOUp.Observable).of((0, $xAy39.loginAttempt)({
                email: email,
                password: password,
                continueParam: null
            })));
        }).catch((error)=>{
            const parsedError = (0, $1vXf6.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $8jOUp.Observable).of((0, $jN84E.invitedSignUpFailure)(parsedError));
        });
    });
};

});
parcelRegister("dFQ3X", function(module, exports) {
$parcel$export(module.exports, "invitedSignUp", () => $65f1c437e1b5e759$export$3693303625071052);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $65f1c437e1b5e759$export$3693303625071052 = (params)=>{
    const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, setPasswordJwt: setPasswordJwt, context: context = (0, $eDcdn.contextPath) } = params;
    const uri = setPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword?jwt=${setPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword`;
    const body = {
        fullName: fullName,
        password: password,
        username: username,
        email: email,
        ...token ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};

});

parcelRegister("xOZC4", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => (parcelRequire("jN84E")).FETCH_VISIT_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => (parcelRequire("jN84E")).FETCH_VISIT_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => (parcelRequire("jN84E")).FETCH_VISIT_PORTAL_FAILURE);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => (parcelRequire("jN84E")).INVITED_SIGN_UP);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => (parcelRequire("jN84E")).INVITED_SIGN_UP_FAILURE);
$parcel$export(module.exports, "fetchVisitPortalModel", () => (parcelRequire("jN84E")).fetchVisitPortalModel);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => (parcelRequire("jN84E")).fetchVisitPortalSuccess);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => (parcelRequire("jN84E")).fetchVisitPortalFailure);
$parcel$export(module.exports, "invitedSignUp", () => (parcelRequire("jN84E")).invitedSignUp);
$parcel$export(module.exports, "invitedSignUpSuccess", () => (parcelRequire("jN84E")).invitedSignUpSuccess);
$parcel$export(module.exports, "invitedSignUpFailure", () => (parcelRequire("jN84E")).invitedSignUpFailure);

var $jN84E = parcelRequire("jN84E");

});
parcelRegister("jN84E", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => $0fefa96ece4d973a$export$5aa92ec48cad67e1);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => $0fefa96ece4d973a$export$cd1a8438490d4c7e);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => $0fefa96ece4d973a$export$7d63bf92ff546bd4);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => $0fefa96ece4d973a$export$10a878c7005ffa23);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => $0fefa96ece4d973a$export$fc43f808dcbef187);
$parcel$export(module.exports, "fetchVisitPortalModel", () => $0fefa96ece4d973a$export$6513e51a3bb59ea8);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => $0fefa96ece4d973a$export$fd6356a11ec803b4);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => $0fefa96ece4d973a$export$4807fff848ef2c1a);
$parcel$export(module.exports, "invitedSignUp", () => $0fefa96ece4d973a$export$3693303625071052);
$parcel$export(module.exports, "invitedSignUpSuccess", () => $0fefa96ece4d973a$export$a2add4c6435cf561);
$parcel$export(module.exports, "invitedSignUpFailure", () => $0fefa96ece4d973a$export$7ae6305616bacef7);

var $hn5Mq = parcelRequire("hn5Mq");
const $0fefa96ece4d973a$export$5aa92ec48cad67e1 = 'epic.model.FETCH_VISIT_PORTAL_MODEL';
const $0fefa96ece4d973a$export$cd1a8438490d4c7e = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_SUCCESS';
const $0fefa96ece4d973a$export$7d63bf92ff546bd4 = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_FAILURE';
const $0fefa96ece4d973a$export$10a878c7005ffa23 = 'state.ui.invited.sign.up.INVITED_SIGN_UP';
const $0fefa96ece4d973a$export$6bf64c2d60f7e63d = 'state.ui.invited.sign.up.INVITED_SIGN_UP_SUCCESS';
const $0fefa96ece4d973a$export$fc43f808dcbef187 = 'state.ui.invited.sign.up.INVITED_SIGN_UP_FAILURE';
const $0fefa96ece4d973a$export$6513e51a3bb59ea8 = (0, $hn5Mq.buildModelsActionCreator)($0fefa96ece4d973a$export$5aa92ec48cad67e1, 'visitPortal');
const $0fefa96ece4d973a$export$fd6356a11ec803b4 = (visitPortalResponse)=>({
        type: $0fefa96ece4d973a$export$cd1a8438490d4c7e,
        payload: visitPortalResponse
    });
const $0fefa96ece4d973a$export$4807fff848ef2c1a = (error)=>({
        type: $0fefa96ece4d973a$export$7d63bf92ff546bd4,
        payload: {
            error: error
        }
    });
const $0fefa96ece4d973a$export$3693303625071052 = (portalId, email, fullName, password, token, username, contactAdminsFormEnabled, setPasswordJwt)=>({
        type: $0fefa96ece4d973a$export$10a878c7005ffa23,
        payload: {
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            setPasswordJwt: setPasswordJwt
        }
    });
const $0fefa96ece4d973a$export$a2add4c6435cf561 = ()=>({
        type: $0fefa96ece4d973a$export$6bf64c2d60f7e63d
    });
const $0fefa96ece4d973a$export$7ae6305616bacef7 = (error)=>({
        type: $0fefa96ece4d973a$export$fc43f808dcbef187,
        payload: {
            error: error
        }
    });

});



parcelRegister("6x6Ac", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpacesEpic", () => $f451b381bd25bb28$export$fe4c3219e901f34f);

var $8jOUp = parcelRequire("8jOUp");

var $6sdgR = parcelRequire("6sdgR");
parcelRequire("L0WDy");
var $kv9UF = parcelRequire("kv9UF");

var $jBiia = parcelRequire("jBiia");
const $f451b381bd25bb28$export$fe4c3219e901f34f = (action$)=>action$.ofType((0, $kv9UF.FETCH_LINKED_SPACES)).mergeMap((action)=>{
        const { meta: meta } = action.payload;
        return (0, $6sdgR.fetchLinkedSpaces)().map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $kv9UF.fetchLinkedSpacesSuccess)(response.linkedSpaces.map((space)=>space.spaceKey));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) {
                const failureEvent = meta.analyticsFailureEvent.update((payload)=>({
                        ...payload,
                        status: error.status
                    }));
                (0, $jBiia.legacySendEvent)(failureEvent);
            }
            return (0, $8jOUp.Observable).of((0, $kv9UF.fetchLinkedSpacesFailure)(error));
        });
    });

});
parcelRegister("6sdgR", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpaces", () => $e469aa3d2f942856$export$1999596e4ea30c16);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fuVmc = parcelRequire("fuVmc");

var $fMFxk = parcelRequire("fMFxk");

var $jBiia = parcelRequire("jBiia");
const $e469aa3d2f942856$export$1999596e4ea30c16 = ()=>{
    const activationId = (0, $fuVmc.getMeta)('activation-id');
    const uri = `${(0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/linked-spaces`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        return response;
    }).catch((e)=>{
        (0, $jBiia.trackError)('linked-spaces.fetch.failed', {}, e);
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("L0WDy", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => (parcelRequire("kv9UF")).FETCH_LINKED_SPACES);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => (parcelRequire("kv9UF")).FETCH_LINKED_SPACES_SUCCESS);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => (parcelRequire("kv9UF")).FETCH_LINKED_SPACES_FAILURE);
$parcel$export(module.exports, "fetchLinkedSpaces", () => (parcelRequire("kv9UF")).fetchLinkedSpaces);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => (parcelRequire("kv9UF")).fetchLinkedSpacesSuccess);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => (parcelRequire("kv9UF")).fetchLinkedSpacesFailure);

var $kv9UF = parcelRequire("kv9UF");

});
parcelRegister("kv9UF", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => $fc8c58d3177164e7$export$3d78263a729bb91);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => $fc8c58d3177164e7$export$55cd199355628b5a);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => $fc8c58d3177164e7$export$9c186423b974805a);
$parcel$export(module.exports, "fetchLinkedSpaces", () => $fc8c58d3177164e7$export$1999596e4ea30c16);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => $fc8c58d3177164e7$export$ad2cc5272eef487);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => $fc8c58d3177164e7$export$e63a5f7249c4e5d6);
const $fc8c58d3177164e7$export$3d78263a729bb91 = 'state.actions.linked-spaces.FETCH_LINKED_SPACES';
const $fc8c58d3177164e7$export$55cd199355628b5a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_SUCCESS';
const $fc8c58d3177164e7$export$9c186423b974805a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_FAILURE';
const $fc8c58d3177164e7$export$1999596e4ea30c16 = (meta)=>({
        type: $fc8c58d3177164e7$export$3d78263a729bb91,
        payload: {
            meta: meta
        }
    });
const $fc8c58d3177164e7$export$ad2cc5272eef487 = (linkedSpaces)=>({
        type: $fc8c58d3177164e7$export$55cd199355628b5a,
        payload: {
            linkedSpaces: linkedSpaces
        }
    });
const $fc8c58d3177164e7$export$e63a5f7249c4e5d6 = (error)=>({
        type: $fc8c58d3177164e7$export$9c186423b974805a,
        payload: {
            error: error
        }
    });

});



parcelRegister("3wcJe", function(module, exports) {
$parcel$export(module.exports, "checkLoginActionEpic", () => $97c0eb7e192093e7$export$f1b0b99279015d5e);

var $lJ0l5 = parcelRequire("lJ0l5");

var $8jOUp = parcelRequire("8jOUp");

var $677lk = parcelRequire("677lk");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("8eZY0");
var $hh4QA = parcelRequire("hh4QA");

var $1vXf6 = parcelRequire("1vXf6");

var $hV3x9 = parcelRequire("hV3x9");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");

var $O9KKV = parcelRequire("O9KKV");

var $oORS9 = parcelRequire("oORS9");
const $97c0eb7e192093e7$export$f1b0b99279015d5e = (action$)=>{
    return action$.ofType((0, $xAy39.CHECK_LOGIN_ACTION)).mergeMap((checkLoginActionAction)=>{
        const { email: email, portalId: portalId, authData: authData, createAnalyticsEvent: createAnalyticsEvent } = checkLoginActionAction.payload;
        return (0, $hV3x9.fetchAwsWafToken)(createAnalyticsEvent).mergeMap((token)=>(0, $677lk.checkLoginAction)({
                email: email,
                authData: authData,
                awsWafToken: token
            })).flatMap((response)=>{
            const autoInfo = $97c0eb7e192093e7$var$extractAuthInfoFromResponse(response);
            const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'enteredEmailAndClickedNext',
                actionSubject: 'jsmPortalUnifiedLogin',
                attributes: {
                    accountStage: autoInfo.accountStage,
                    authMethodTypes: Array.from(autoInfo.authMethods.keys())
                }
            });
            trackEvent && (0, $jBiia.legacySendEvent)(trackEvent);
            if (response.action === (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_SIGNUP) return (0, $8jOUp.Observable).of((0, $hh4QA.setSignupDataAction)(email, autoInfo)).do(()=>{
                // Make sure we set the signup state first before doing the transition
                (0, $lJ0l5.Scheduler).async.schedule(()=>{
                    (0, $eDcdn.default).push((0, $oORS9.getSignupUrl)(portalId ? Number.parseInt(portalId, 10) : undefined));
                }, 0);
            });
            return (0, $8jOUp.Observable).of((0, $xAy39.checkLoginActionSuccess)(response.action, autoInfo));
        }).catch((error)=>{
            if ((0, $1vXf6.isSsoTestModeError)(error)) return (0, $8jOUp.Observable).of((0, $xAy39.caSsoTestModeFailure)());
            const parsedError = (0, $1vXf6.getDefaultCheckLoginError)(error);
            return (0, $8jOUp.Observable).of((0, $xAy39.checkLoginActionFailure)(parsedError));
        });
    });
};
const $97c0eb7e192093e7$var$getAccountStage = (action)=>{
    switch(action){
        case (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $O9KKV.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
            return (0, $O9KKV.AccountStageType).SIGNUP;
        case (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        case (0, $O9KKV.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
        default:
            return (0, $O9KKV.AccountStageType).LOGIN;
    }
};
const $97c0eb7e192093e7$var$extractAuthInfoFromResponse = (payload)=>{
    const { action: action, methods: methods } = payload;
    const stage = $97c0eb7e192093e7$var$getAccountStage(action);
    if (methods.length === 0) // add observable
    // cleanup entire part when FF is cleaned up - Jira ticket
    switch(action){
        case (0, $O9KKV.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $O9KKV.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $O9KKV.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {}
                    ]
                ])
            };
        case (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            };
    }
    switch(action){
        case (0, $O9KKV.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $O9KKV.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    return [
                        (0, $O9KKV.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                }))
            };
        case (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    if (method.authType === 'SSO') return [
                        (0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                    return [
                        (0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ];
                }))
            };
    }
};

});
parcelRegister("677lk", function(module, exports) {
$parcel$export(module.exports, "LoginAttemptErrorType", () => $23f6c9e2dead2ccc$export$d265801d14b9cbd6);
$parcel$export(module.exports, "checkLoginAction", () => $23f6c9e2dead2ccc$export$a4840b835bebc845);
$parcel$export(module.exports, "forgotPassword", () => $23f6c9e2dead2ccc$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $23f6c9e2dead2ccc$export$2effc3102ad6a101);
$parcel$export(module.exports, "loginV2", () => $23f6c9e2dead2ccc$export$c5789ac087856ec0);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $87QgR = parcelRequire("87QgR");

var $gEVth = parcelRequire("gEVth");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $a6ENB = parcelRequire("a6ENB");

var $oORS9 = parcelRequire("oORS9");
const $23f6c9e2dead2ccc$var$IDENTITY_LOGIN_RETRY_DELAY_MS = 500;
const $23f6c9e2dead2ccc$var$IDENTITY_LOGIN_MAX_RETRIES = 2;
const $23f6c9e2dead2ccc$var$isRetryableError = (status)=>{
    // Retry on 5xx server errors or network errors (status 0)
    return status >= 500 || status === 0;
};
const $23f6c9e2dead2ccc$var$delay = (ms)=>{
    return new (0, $8jOUp.Observable)((subscriber)=>{
        const timeoutId = setTimeout(()=>{
            subscriber.next();
            subscriber.complete();
        }, ms);
        return ()=>clearTimeout(timeoutId);
    });
};
var $23f6c9e2dead2ccc$export$d265801d14b9cbd6 = /*#__PURE__*/ function(LoginAttemptErrorType) {
    LoginAttemptErrorType[LoginAttemptErrorType["INVALID_CREDENTIALS"] = 0] = "INVALID_CREDENTIALS";
    LoginAttemptErrorType[LoginAttemptErrorType["ACCOUNT_LOCKED_ERROR"] = 1] = "ACCOUNT_LOCKED_ERROR";
    LoginAttemptErrorType[LoginAttemptErrorType["MISC_LOGIN_ERROR"] = 2] = "MISC_LOGIN_ERROR";
    return LoginAttemptErrorType;
}({});
const $23f6c9e2dead2ccc$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'login',
        source: 'unknownSource'
    };
};
const $23f6c9e2dead2ccc$export$a4840b835bebc845 = (params)=>{
    const { email: email, authData: authData, awsWafToken: awsWafToken, context: context = (0, $eDcdn.contextPath) } = params;
    const uri = `${context}/rest/servicedesk/customer-management/1/twosteplogin/action`;
    const body = JSON.stringify({
        email: email,
        ...authData
    });
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...awsWafToken ? {
            'x-aws-waf-token': `${awsWafToken}`
        } : {},
        ...(0, $87QgR.default).getExperiment('bypass_jsm_two_step_login_waf_challenge_js').value.value ? {
            'atl-jsm-login-challenge-bypass': true
        } : {}
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $23f6c9e2dead2ccc$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>{
    const uri = (0, $oORS9.prependWithSlashIfAbsent)(resetUrl);
    const body = $23f6c9e2dead2ccc$var$createBodyForForgotPassword(email, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers);
};
const $23f6c9e2dead2ccc$export$2effc3102ad6a101 = (resetUrl, email)=>{
    const uri = (0, $oORS9.prependWithSlashIfAbsent)(resetUrl);
    const body = $23f6c9e2dead2ccc$var$createBodyForForgotPassword(email);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers);
};
const $23f6c9e2dead2ccc$var$createBodyForForgotPassword = (usernameOrEmail, redirectUrl)=>{
    return JSON.stringify({
        usernameOrEmail: usernameOrEmail,
        redirectUrl: redirectUrl
    });
};
const $23f6c9e2dead2ccc$var$responseKeyToErrorType = (loginPayload)=>{
    if (loginPayload) switch(loginPayload.key){
        case 'invalid-user-credentials':
            return 0;
        case 'blocked-user-credentials':
            return 1;
        default:
    }
    return 2;
};
const $23f6c9e2dead2ccc$export$4030e1d1ae5ebd69 = (ajaxError)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ajaxResponse = ajaxError.response;
    if (ajaxError.status === 403) {
        const errorType = $23f6c9e2dead2ccc$var$responseKeyToErrorType(ajaxResponse);
        if (errorType === 2) (0, $a6ENB.reportError)(ajaxError, {
            message: JSON.stringify(ajaxResponse)
        });
        return {
            loginSucceeded: false,
            error: {
                errorType: errorType
            }
        };
    }
    (0, $a6ENB.reportError)(ajaxError, {
        message: JSON.stringify(ajaxResponse)
    });
    throw ajaxError;
};
const $23f6c9e2dead2ccc$export$abbe0c285917a9df = ()=>`${(0, $gYDJY.origin)()}${(0, $eDcdn.getBaseName)()}${(0, $oORS9.getHelpCenterUrl)()}`;
const $23f6c9e2dead2ccc$export$f7ebdb13a3e88fec = (params)=>{
    const { email: email, password: password, context: context = (0, $eDcdn.contextPath) } = params;
    const continueParam = params.continueParam ? params.continueParam : $23f6c9e2dead2ccc$export$abbe0c285917a9df();
    const uri = `${context}/jsd-login-v2/v2/customer/login/authenticate?continue=${continueParam}`;
    const body = {
        email: email,
        password: password
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    const envWithEdition = (0, $iW3CQ.getEnv)();
    const edition = envWithEdition.edition;
    const maxRetries = $23f6c9e2dead2ccc$var$IDENTITY_LOGIN_MAX_RETRIES;
    const fireSuccessEvent = (ajaxResponse, retryCount)=>{
        (0, $gEVth.operationalEvent)($23f6c9e2dead2ccc$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString(),
            traceId: ajaxResponse.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const fireErrorEvent = (ajaxError, retryCount)=>{
        const response = ajaxError.response;
        (0, $gEVth.operationalEvent)($23f6c9e2dead2ccc$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            errorKey: (response === null || response === void 0 ? void 0 : response.key) || 'unknown',
            errorMessage: typeof (response === null || response === void 0 ? void 0 : response.context) === 'object' && response.context ? response.context.errorDetail || 'unknown' : 'unknown',
            traceId: ajaxError.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const makeRequest = (retryCount)=>{
        return (0, $llRGw.post)(uri, body, headers).do((ajaxResponse)=>fireSuccessEvent(ajaxResponse, retryCount), (ajaxError)=>{
            if (retryCount >= maxRetries || !$23f6c9e2dead2ccc$var$isRetryableError(ajaxError.status)) fireErrorEvent(ajaxError, retryCount);
        }).map(()=>({
                loginSucceeded: true,
                error: null
            })).catch((ajaxError)=>{
            if (retryCount < maxRetries && $23f6c9e2dead2ccc$var$isRetryableError(ajaxError.status)) return $23f6c9e2dead2ccc$var$delay($23f6c9e2dead2ccc$var$IDENTITY_LOGIN_RETRY_DELAY_MS).switchMap(()=>makeRequest(retryCount + 1));
            return (0, $8jOUp.Observable).of($23f6c9e2dead2ccc$export$4030e1d1ae5ebd69(ajaxError));
        });
    };
    return makeRequest(0);
};
const $23f6c9e2dead2ccc$export$c5789ac087856ec0 = (email, password, continueParam)=>{
    return $23f6c9e2dead2ccc$export$f7ebdb13a3e88fec({
        email: email,
        password: password,
        continueParam: continueParam
    });
};

});
parcelRegister("oORS9", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER_URL", () => $8ff7fe00a32717b7$export$5b56ffbd3ae3f811);
$parcel$export(module.exports, "getLoginUrl", () => $8ff7fe00a32717b7$export$8abe2e83e8d74da2);
$parcel$export(module.exports, "getLoginUrlForPortalId", () => $8ff7fe00a32717b7$export$2c3bf2ac72f35daf);
$parcel$export(module.exports, "getLoginUrlForPortalIdAsString", () => $8ff7fe00a32717b7$export$cf0d2e77a068eb02);
$parcel$export(module.exports, "getSignupUrl", () => $8ff7fe00a32717b7$export$61811316248f3423);
$parcel$export(module.exports, "getRedirectUrlOrLoginUrlIfNotLoggedIn", () => $8ff7fe00a32717b7$export$e1ec45c36436315e);
$parcel$export(module.exports, "stripBasename", () => $8ff7fe00a32717b7$export$b69e3301ce081aa3);
$parcel$export(module.exports, "getLoginUrlForTestMode", () => $8ff7fe00a32717b7$export$538cfa4687a1dbf1);
$parcel$export(module.exports, "parseLoginSignupRedirectUrlParams", () => $8ff7fe00a32717b7$export$63db7ca0fb70fb36);
$parcel$export(module.exports, "getManageAtlassianAccountUrl", () => $8ff7fe00a32717b7$export$ad959f16b2c52bb0);
$parcel$export(module.exports, "getEditAccountPreferenceUrl", () => $8ff7fe00a32717b7$export$aa7a50c8d9783676);
$parcel$export(module.exports, "getHelpCenterUrl", () => $8ff7fe00a32717b7$export$bb97e50e9203cc1d);
$parcel$export(module.exports, "getLearnMoreUrl", () => $8ff7fe00a32717b7$export$54cf7883df84f437);
$parcel$export(module.exports, "getPortalUrl", () => $8ff7fe00a32717b7$export$8f6fdb27182bf17e);
$parcel$export(module.exports, "getPortalUrlWithPortalIdAsString", () => $8ff7fe00a32717b7$export$46b08aeb2d28084e);
$parcel$export(module.exports, "prependWithSlashIfAbsent", () => $8ff7fe00a32717b7$export$1d7449e2f82591f7);
$parcel$export(module.exports, "parseIssueKeyFromUrl", () => $8ff7fe00a32717b7$export$286b4bf70293043b);
$parcel$export(module.exports, "getNextgenSettingsUrl", () => $8ff7fe00a32717b7$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsRequestTypesUrl", () => $8ff7fe00a32717b7$export$289b05216208b30f);
$parcel$export(module.exports, "getPortalGroupSettingsUrl", () => $8ff7fe00a32717b7$export$902d92fe4f764798);
$parcel$export(module.exports, "getTeamManagedPortalGroupSettingsUrl", () => $8ff7fe00a32717b7$export$668319f0cf7cb94b);
$parcel$export(module.exports, "getRequestTypeSettingsUrl", () => $8ff7fe00a32717b7$export$521ab03a93b5e8f0);
$parcel$export(module.exports, "getMyPendingApprovalsUrl", () => $8ff7fe00a32717b7$export$b7fb861bceb68e9e);
$parcel$export(module.exports, "isTestModeRequested", () => $8ff7fe00a32717b7$export$87980cf49820be56);
$parcel$export(module.exports, "getSsoTestModeParamFromUrl", () => $8ff7fe00a32717b7$export$a992d459a03ed45d);
$parcel$export(module.exports, "convertAbsoluteUrlToRelativeUrl", () => $8ff7fe00a32717b7$export$71e894c24943ddb2);
$parcel$export(module.exports, "getUpdatedDisplayLink", () => $8ff7fe00a32717b7$export$1f8744d5447339dc);
$parcel$export(module.exports, "getBillingUrl", () => $8ff7fe00a32717b7$export$776b50dd35ff8711);
$parcel$export(module.exports, "formatTitleForUrl", () => $8ff7fe00a32717b7$export$4ff2caca9bc551ab);
$parcel$export(module.exports, "getDefaultDestination", () => $8ff7fe00a32717b7$export$3621fe01f0e72eb7);
$parcel$export(module.exports, "getContinueParam", () => $8ff7fe00a32717b7$export$46b6a16917b33fad);
$parcel$export(module.exports, "getRedirectUrlForSignupAndResetPasswordRequestParam", () => $8ff7fe00a32717b7$export$c20e132b33b4b975);

var $fvUqa = parcelRequire("fvUqa");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $5LmQo = parcelRequire("5LmQo");

var $gYDJY = parcelRequire("gYDJY");

var $O9KKV = parcelRequire("O9KKV");
const $8ff7fe00a32717b7$export$5b56ffbd3ae3f811 = (0, $hCnLH.isAdvancedHelpCenter)() || (0, $hCnLH.isUnifiedHelpHelpCenter)() || (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) ? '/' : '/portals';
const $8ff7fe00a32717b7$var$ATLASSIAN_ACCOUNT_URL = 'https://id.atlassian.com';
const $8ff7fe00a32717b7$var$ATLASSIAN_ACCOUNT_STG_URL = 'https://id.stg.internal.atlassian.com';
const $8ff7fe00a32717b7$var$envToAtlassianAccountUrlMap = new Map([
    [
        (0, $iW3CQ.EnvType).LOCAL,
        $8ff7fe00a32717b7$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $iW3CQ.EnvType).DEV,
        $8ff7fe00a32717b7$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $iW3CQ.EnvType).STAGING,
        $8ff7fe00a32717b7$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $iW3CQ.EnvType).PROD,
        $8ff7fe00a32717b7$var$ATLASSIAN_ACCOUNT_URL
    ]
]);
const $8ff7fe00a32717b7$export$8abe2e83e8d74da2 = (loginOptions)=>{
    return $8ff7fe00a32717b7$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl);
};
const $8ff7fe00a32717b7$export$2c3bf2ac72f35daf = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/login${(0, $gYDJY.search)()}` : `/user/login${(0, $gYDJY.search)()}`;
};
const $8ff7fe00a32717b7$export$cf0d2e77a068eb02 = (portalIdAsString)=>{
    return $8ff7fe00a32717b7$export$2c3bf2ac72f35daf($8ff7fe00a32717b7$var$stringToNumberOrUndefined(portalIdAsString));
};
const $8ff7fe00a32717b7$export$61811316248f3423 = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/signup${(0, $gYDJY.search)()}` : `/user/signup${(0, $gYDJY.search)()}`;
};
const $8ff7fe00a32717b7$export$e1ec45c36436315e = (redirectToLogin, url, portalId)=>{
    const strippedUrl = $8ff7fe00a32717b7$export$b69e3301ce081aa3(url);
    if (redirectToLogin) return $8ff7fe00a32717b7$var$internalGetLoginUrl(false, portalId, strippedUrl);
    return strippedUrl;
};
const $8ff7fe00a32717b7$var$internalGetLoginUrl = (isAbsolute, portalId, redirectUrl)=>{
    const pathUrl = portalId ? `portal/${portalId}/user/login` : 'user/login';
    const portalUrl = isAbsolute ? `${(0, $eDcdn.getBaseName)()}/${pathUrl}` : `/${pathUrl}`;
    if (redirectUrl) {
        // trim leading slash if it is present
        const url = redirectUrl.replace(/^\/+/g, '');
        return (0, $5LmQo.addParamsToUrl)(portalUrl, {
            destination: url
        });
    }
    return portalUrl;
};
const $8ff7fe00a32717b7$export$538cfa4687a1dbf1 = (loginOptions)=>{
    return (0, $5LmQo.addParamsToUrl)($8ff7fe00a32717b7$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl), {
        [(0, $O9KKV.QUERY_PARAM_SSO_TEST)]: 'true'
    });
};
const $8ff7fe00a32717b7$export$63db7ca0fb70fb36 = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedSearchQuery = $fvUqa.parse((0, $gYDJY.search)());
    return {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        destination: parsedSearchQuery.destination,
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        isAbsolute: parsedSearchQuery.absolute === 'true'
    };
};
const $8ff7fe00a32717b7$export$ad959f16b2c52bb0 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $5LmQo.addParamsToUrl)(url, {
        target: 'profile-visibility'
    });
};
const $8ff7fe00a32717b7$export$aa7a50c8d9783676 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $5LmQo.addParamsToUrl)(url, {
        target: 'edit-preference'
    });
};
const $8ff7fe00a32717b7$export$bb97e50e9203cc1d = ()=>{
    return $8ff7fe00a32717b7$export$5b56ffbd3ae3f811;
};
const $8ff7fe00a32717b7$export$54cf7883df84f437 = ()=>{
    var _envToAtlassianAccoun;
    return (_envToAtlassianAccoun = $8ff7fe00a32717b7$var$envToAtlassianAccountUrlMap.get((0, $iW3CQ.getEnv)().environment)) === null || _envToAtlassianAccoun === void 0 ? void 0 : _envToAtlassianAccoun.concat('/manage-profile/apps');
};
const $8ff7fe00a32717b7$export$8f6fdb27182bf17e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $8ff7fe00a32717b7$export$bb97e50e9203cc1d();
};
const $8ff7fe00a32717b7$export$46b08aeb2d28084e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $8ff7fe00a32717b7$export$bb97e50e9203cc1d();
};
const $8ff7fe00a32717b7$export$b69e3301ce081aa3 = (url)=>{
    if (url) {
        const pos = url.indexOf((0, $eDcdn.getRelativeBasePath)());
        if (pos >= 0) return url.substring(pos + (0, $eDcdn.getRelativeBasePath)().length);
    }
    return url;
};
const $8ff7fe00a32717b7$export$1ca0042661bee534 = (parameters)=>{
    const queryParameters = [
        `page=${parameters.page}`
    ];
    if (parameters.reporter) queryParameters.push(`reporter=${parameters.reporter}`);
    if (parameters.statuses) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    queryParameters.push(`statuses=${parameters.statuses}`);
    return `/user/requests?${queryParameters.join('&')}`;
};
const $8ff7fe00a32717b7$export$1d7449e2f82591f7 = (toPrepend)=>{
    if (toPrepend.startsWith('/')) return toPrepend;
    return `/${toPrepend}`;
};
const $8ff7fe00a32717b7$var$stringToNumberOrUndefined = (toConvert)=>toConvert === undefined ? undefined : Number(toConvert);
const $8ff7fe00a32717b7$export$286b4bf70293043b = (url)=>{
    const jiraUrlMatch = `${(0, $gYDJY.origin)()}/browse/([A-Z][A-Z0-9_]+-\\d+)`;
    const portalUrlMatch = `${(0, $gYDJY.origin)()}${(0, $eDcdn.getRelativeBasePath)()}/portal/\\d+/([A-Z][A-Z0-9_]+-\\d+)`;
    const jiraMatch = url.match(jiraUrlMatch);
    if (jiraMatch) return jiraMatch[1];
    const portalMatch = url.match(portalUrlMatch);
    return portalMatch === null ? null : portalMatch[1];
};
const $8ff7fe00a32717b7$export$26432406821aa7bf = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/settings`;
const $8ff7fe00a32717b7$export$718bab188935b069 = (projectKey)=>`${$8ff7fe00a32717b7$export$26432406821aa7bf(projectKey)}/language`;
const $8ff7fe00a32717b7$export$289b05216208b30f = (projectKey)=>`${$8ff7fe00a32717b7$export$26432406821aa7bf(projectKey)}/issuetypes`;
const $8ff7fe00a32717b7$export$c38761508d5f074d = (projectKey, requestTypeId)=>`${$8ff7fe00a32717b7$export$289b05216208b30f(projectKey)}/${requestTypeId}`;
const $8ff7fe00a32717b7$export$902d92fe4f764798 = (projectKey)=>`${$8ff7fe00a32717b7$export$26432406821aa7bf(projectKey)}/portal-settings/portal-groups`;
const $8ff7fe00a32717b7$export$668319f0cf7cb94b = (projectKey)=>`${$8ff7fe00a32717b7$export$26432406821aa7bf(projectKey)}/channels/portal-settings/portal-groups`;
const $8ff7fe00a32717b7$export$521ab03a93b5e8f0 = (projectKey, requestTypeId)=>`${$8ff7fe00a32717b7$export$26432406821aa7bf(projectKey)}/request-types/category/service-requests/request-type/${requestTypeId}/request-form`;
const $8ff7fe00a32717b7$export$7517f177d0bcebc3 = (url, jiraBaseUrl)=>{
    return url.startsWith(jiraBaseUrl);
};
const $8ff7fe00a32717b7$export$b7fb861bceb68e9e = ()=>{
    return `/user/approvals?approvalQueryType=myPending&page=1`;
};
const $8ff7fe00a32717b7$export$87980cf49820be56 = (ssoTest)=>{
    return ssoTest === 'true';
};
const $8ff7fe00a32717b7$export$a992d459a03ed45d = (params)=>{
    return params.get((0, $O9KKV.QUERY_PARAM_SSO_TEST)) === 'true';
};
const $8ff7fe00a32717b7$export$a1cbf2de32a9fd1 = (url)=>{
    if (decodeURIComponent(url).startsWith('//')) return false;
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $8ff7fe00a32717b7$export$71e894c24943ddb2 = (url)=>{
    if ($8ff7fe00a32717b7$export$a1cbf2de32a9fd1(url)) return url.replace(`${new URL(url).origin}`, '') || '/';
    return url;
};
const $8ff7fe00a32717b7$export$1f8744d5447339dc = (displayLink)=>{
    const isBasicHCRegex = /\/servicedesk\/customer\/.+/;
    if ((0, $hCnLH.isAdvancedHelpCenter)() && isBasicHCRegex.test(displayLink) && !$8ff7fe00a32717b7$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace('/servicedesk/customer/', '/');
    return displayLink;
};
const $8ff7fe00a32717b7$export$6c23a56732080745 = (displayLink)=>{
    if ((0, $hCnLH.isAdvancedHelpCenter)() && displayLink.includes('/servicedesk/customer/') && $8ff7fe00a32717b7$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace(/.+\/servicedesk\/customer\//, `${(0, $eDcdn.getRelativeBasePath)()}/`);
    return displayLink;
};
const $8ff7fe00a32717b7$var$ADMIN_STAGING_URL = 'http://admin.stg.atlassian.com';
const $8ff7fe00a32717b7$var$ADMIN_PROD_URL = 'https://admin.atlassian.com';
const $8ff7fe00a32717b7$export$1cfdf9a01e3f7773 = ()=>window.location.host.includes('-dev.com') ? false : true;
const $8ff7fe00a32717b7$export$995f5f30765d3edb = $8ff7fe00a32717b7$export$1cfdf9a01e3f7773() ? $8ff7fe00a32717b7$var$ADMIN_PROD_URL : $8ff7fe00a32717b7$var$ADMIN_STAGING_URL;
const $8ff7fe00a32717b7$export$776b50dd35ff8711 = (products, cloudId)=>{
    const baseUrl = `${$8ff7fe00a32717b7$export$995f5f30765d3edb}/s/${cloudId}`;
    return products.length === 1 ? `${baseUrl}/billing/applications/change-edition/${products[0]}.ondemand` : `${baseUrl}/billing-preview`;
};
const $8ff7fe00a32717b7$export$4ff2caca9bc551ab = (title)=>{
    return title.trim().replace(/[^a-zA-Z0-9]+/g, '+').replace(/^(?:\++)|(?:\++)$/g, '');
};
const $8ff7fe00a32717b7$export$3621fe01f0e72eb7 = (portalId)=>{
    if (portalId) return `portal/${portalId}`;
    return $8ff7fe00a32717b7$export$bb97e50e9203cc1d().replace(/\//g, '');
};
const $8ff7fe00a32717b7$export$46b6a16917b33fad = (portalId)=>{
    const { destination: destination, isAbsolute: isAbsolute } = $8ff7fe00a32717b7$export$63db7ca0fb70fb36();
    const prefix = destination && isAbsolute ? '' : `${(0, $gYDJY.origin)()}${(0, $eDcdn.getBaseName)()}/`;
    const continueParam = `${prefix}${destination || $8ff7fe00a32717b7$export$3621fe01f0e72eb7(portalId)}`;
    return `${continueParam}`;
};
const $8ff7fe00a32717b7$export$c20e132b33b4b975 = (baseUrl)=>{
    const { destination: destination } = $8ff7fe00a32717b7$export$63db7ca0fb70fb36();
    if (destination && ($8ff7fe00a32717b7$export$7517f177d0bcebc3(destination, baseUrl) || !$8ff7fe00a32717b7$export$a1cbf2de32a9fd1(destination))) return destination;
    return undefined;
};

});
parcelRegister("O9KKV", function(module, exports) {
$parcel$export(module.exports, "AccountStageType", () => $3e60f3d70c7e1fa4$export$fcf6b116730276db);
$parcel$export(module.exports, "AuthMethodType", () => $3e60f3d70c7e1fa4$export$ccd4174b7ee5aaf9);
$parcel$export(module.exports, "LoginType", () => $3e60f3d70c7e1fa4$export$7ecae1a0f094da22);
$parcel$export(module.exports, "QUERY_PARAM_SSO_TEST", () => $3e60f3d70c7e1fa4$export$491b9d320a651537);
// eslint-disable-next-line no-shadow
var $3e60f3d70c7e1fa4$export$fcf6b116730276db = /*#__PURE__*/ function(AccountStageType) {
    AccountStageType["LOGIN"] = "LOGIN";
    AccountStageType["SIGNUP"] = "SIGNUP";
    return AccountStageType;
}({});
var $3e60f3d70c7e1fa4$export$ccd4174b7ee5aaf9 = /*#__PURE__*/ function(AuthMethodType) {
    AuthMethodType["CUSTOMER_ACCOUNT_PASSWORD"] = "CUSTOMER_ACCOUNT_PASSWORD";
    AuthMethodType["CUSTOMER_ACCOUNT_SSO"] = "CUSTOMER_ACCOUNT_SSO";
    AuthMethodType["ATLASSIAN_ACCOUNT_SSO"] = "ATLASSIAN_ACCOUNT_SSO";
    return AuthMethodType;
}({});
var $3e60f3d70c7e1fa4$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["ATLASSIAN_ACCOUNT_LOGIN"] = "atlassian.account.login";
    LoginType["ATLASSIAN_ACCOUNT_SIGNUP"] = "atlassian.account.signup";
    LoginType["CUSTOMER_ACCOUNT_LOGIN"] = "customer.account.login";
    LoginType["CUSTOMER_ACCOUNT_SIGNUP"] = "customer.account.signup";
    return LoginType;
}({});
const $3e60f3d70c7e1fa4$export$491b9d320a651537 = 'sso_test';

});



parcelRegister("8eZY0", function(module, exports) {
$parcel$export(module.exports, "enableResendValidationEmailLink", () => (parcelRequire("hh4QA")).enableResendValidationEmailLink);
$parcel$export(module.exports, "resendValidationEmail", () => (parcelRequire("hh4QA")).resendValidationEmail);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => (parcelRequire("hh4QA")).resendValidationEmailSuccess);
$parcel$export(module.exports, "resendValidationEmailFailure", () => (parcelRequire("hh4QA")).resendValidationEmailFailure);
$parcel$export(module.exports, "setSignupDataAction", () => (parcelRequire("hh4QA")).setSignupDataAction);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => (parcelRequire("hh4QA")).ENABLE_RESEND_VALIDATION_EMAIL_LINK);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => (parcelRequire("hh4QA")).RESEND_VALIDATION_EMAIL);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => (parcelRequire("hh4QA")).RESEND_VALIDATION_EMAIL_SUCCESS);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => (parcelRequire("hh4QA")).RESEND_VALIDATION_EMAIL_FAILURE);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => (parcelRequire("hh4QA")).SET_SIGN_UP_DATA);

var $hh4QA = parcelRequire("hh4QA");

});
parcelRegister("hh4QA", function(module, exports) {
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => $3b7325153d3758f6$export$9186eb7b1196909f);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => $3b7325153d3758f6$export$54095a5808d614c5);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => $3b7325153d3758f6$export$bb70263db5ecc48f);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => $3b7325153d3758f6$export$1f3acfffff4b90ca);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => $3b7325153d3758f6$export$b5da7c907fc7ff71);
$parcel$export(module.exports, "resendValidationEmail", () => $3b7325153d3758f6$export$b53bc6c531462e2c);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => $3b7325153d3758f6$export$5e093ceac56a577c);
$parcel$export(module.exports, "resendValidationEmailFailure", () => $3b7325153d3758f6$export$49a7f6865c86a52a);
$parcel$export(module.exports, "enableResendValidationEmailLink", () => $3b7325153d3758f6$export$bfd31929fb03dc3a);
$parcel$export(module.exports, "setSignupDataAction", () => $3b7325153d3758f6$export$b9b1c14c91a0ee7a);
const $3b7325153d3758f6$export$9186eb7b1196909f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL';
const $3b7325153d3758f6$export$54095a5808d614c5 = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_SUCCESS';
const $3b7325153d3758f6$export$bb70263db5ecc48f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_FAILURE';
const $3b7325153d3758f6$export$1f3acfffff4b90ca = 'epic.persisted.signup.ENABLE_RESEND_VALIDATION_EMAIL_LINK';
const $3b7325153d3758f6$export$b5da7c907fc7ff71 = 'epic.persisted.signup.SET_SIGN_UP_DATA';
const $3b7325153d3758f6$export$b53bc6c531462e2c = (email, portalId, redirectUrl)=>({
        type: $3b7325153d3758f6$export$9186eb7b1196909f,
        payload: {
            email: email,
            portalId: portalId,
            redirectUrl: redirectUrl
        }
    });
const $3b7325153d3758f6$export$5e093ceac56a577c = ()=>({
        type: $3b7325153d3758f6$export$54095a5808d614c5
    });
const $3b7325153d3758f6$export$49a7f6865c86a52a = ()=>({
        type: $3b7325153d3758f6$export$bb70263db5ecc48f
    });
const $3b7325153d3758f6$export$bfd31929fb03dc3a = ()=>({
        type: $3b7325153d3758f6$export$1f3acfffff4b90ca
    });
const $3b7325153d3758f6$export$b9b1c14c91a0ee7a = (email, authInfo)=>({
        type: $3b7325153d3758f6$export$b5da7c907fc7ff71,
        payload: {
            email: email,
            authInfo: authInfo
        }
    });

});


parcelRegister("hV3x9", function(module, exports) {
$parcel$export(module.exports, "fetchAwsWafToken", () => $00d49d3053992ed6$export$408b4a82d889c63b);

var $8jOUp = parcelRequire("8jOUp");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");
const $00d49d3053992ed6$export$408b4a82d889c63b = (createAnalyticsEvent)=>{
    try {
        if (typeof AwsWafIntegration !== 'undefined' && typeof AwsWafIntegration.getToken === 'function') return (0, $8jOUp.Observable).from(AwsWafIntegration.getToken());
        $00d49d3053992ed6$var$sendFailToFetchWafTokenEvent("js.not.load", createAnalyticsEvent);
        return (0, $8jOUp.Observable).of(undefined);
    } catch (error) {
        $00d49d3053992ed6$var$sendFailToFetchWafTokenEvent("unknown.error", createAnalyticsEvent);
        return (0, $8jOUp.Observable).of(undefined);
    }
};
const $00d49d3053992ed6$var$sendFailToFetchWafTokenEvent = (failureType, createAnalyticsEvent)=>{
    const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
        analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
        action: 'failed',
        actionSubject: 'fetchWafToken',
        attributes: {
            failureType: failureType
        }
    });
    trackEvent && (0, $jBiia.legacySendEvent)(trackEvent);
};

});


parcelRegister("iWImt", function(module, exports) {
$parcel$export(module.exports, "createPasswordEpic", () => $7ac00fdc6d3e74e1$export$4f23d4ad55796890);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $677lk = parcelRequire("677lk");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
const $7ac00fdc6d3e74e1$export$4f23d4ad55796890 = (action$)=>{
    return action$.ofType((0, $xAy39.CREATE_PASSWORD)).mergeMap((createPasswordAction)=>{
        const { resetUrl: resetUrl, email: email } = createPasswordAction.payload;
        return (0, $677lk.createPassword)(resetUrl, email).map(()=>{
            return (0, $xAy39.createPasswordSuccess)();
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("5Qw0R", function(module, exports) {
$parcel$export(module.exports, "exitTestModeEpic", () => $08c0e7b8e0772b4d$export$2da1b652de0f5c38);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");

var $eDcdn = parcelRequire("eDcdn");

var $oORS9 = parcelRequire("oORS9");

var $fEwcZ = parcelRequire("fEwcZ");
const $08c0e7b8e0772b4d$export$2da1b652de0f5c38 = (action$)=>{
    return action$.ofType((0, $xAy39.EXIT_TEST_MODE_ACTION)).mergeMap((exitTestModeAction)=>{
        const { email: email } = exitTestModeAction.payload;
        return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $xAy39.resetLogin)(email)), (0, $8jOUp.Observable).of((0, $xb2jO.showSuccessFlag)((0, $fEwcZ.default).exitTestModeSuccessFlagTitle, undefined, (0, $fEwcZ.default).exitTestModeSuccessFlagDescription, undefined, {
            emailAddress: email
        }))).do(()=>{
            (0, $eDcdn.default).push((0, $oORS9.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
        });
    });
};

});
parcelRegister("fEwcZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d814381d795e4f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $59d814381d795e4f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    exitTestModeSuccessFlagTitle: {
        defaultMessage: "You\u2019re out of single sign-on test mode",
        description: 'Message title for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.title'
    },
    exitTestModeSuccessFlagDescription: {
        defaultMessage: 'Go to the Authentication page in your Jira settings to enable single sign-on for customers.',
        description: 'Message description for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.description'
    }
});

});


parcelRegister("32hH7", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $0ab8e2fd0361ca6c$export$cb36b6e8b9a45314);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $677lk = parcelRequire("677lk");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
const $0ab8e2fd0361ca6c$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $xAy39.FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, redirectUrl: redirectUrl } = forgotPasswordAction.payload;
        return (0, $677lk.forgotPassword)(resetUrl, email, redirectUrl).map(()=>{
            return (0, $xAy39.forgotPasswordSuccess)();
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("d6UVh", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $035537c76b0bcaac$export$da8045e9cad7ec9b);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $677lk = parcelRequire("677lk");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");

var $1vXf6 = parcelRequire("1vXf6");
const $035537c76b0bcaac$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $xAy39.LOGIN_ATTEMPT)).mergeMap((loginAction)=>{
        const { email: email, password: password, continueParam: continueParam } = loginAction.payload;
        const loginResponse = (0, $677lk.loginV2)(email, password, continueParam);
        return loginResponse.flatMap((response)=>{
            if (response.loginSucceeded) return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $xAy39.loginAttemptSuccess)(response)), (0, $8jOUp.Observable).of((0, $kd70W.successfullyLoggedIn)()));
            return (0, $8jOUp.Observable).of((0, $xAy39.loginAttemptSuccess)(response));
        }).catch((error)=>{
            const parsedError = (0, $1vXf6.getDefaultError)(error);
            return (0, $8jOUp.Observable).of((0, $xAy39.loginAttemptFailure)(parsedError));
        });
    });
};

});

parcelRegister("5Cby0", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsEpic", () => $2a4ed2732360c3e6$export$2bd3c7829bd01a9c);

var $jcRK7 = parcelRequire("jcRK7");

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");
parcelRequire("f2i8V");
var $osBO5 = parcelRequire("osBO5");

var $9VIRk = parcelRequire("9VIRk");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");

var $3i1VP = parcelRequire("3i1VP");

var $G6QpT = parcelRequire("G6QpT");
const $2a4ed2732360c3e6$var$gqlMutationLoginAnnouncements = (action)=>{
    var _inputVariables$input, _inputVariables$input2;
    const { meta: meta, payload: payload } = action;
    const inputVariables = (0, $3i1VP.mapLoginAnnouncementsPayloadToGqlInput)(payload);
    if (!((_inputVariables$input = inputVariables.input.nameTranslations) !== null && _inputVariables$input !== void 0 && _inputVariables$input.every((translation)=>translation.locale)) || !((_inputVariables$input2 = inputVariables.input.descriptionTranslations) !== null && _inputVariables$input2 !== void 0 && _inputVariables$input2.every((translation)=>translation.locale))) {
        // making sure that empty locale is not sent to the server
        const errorResponse = {
            status: (0, $jcRK7.HTTP).BAD_REQUEST
        };
        return (0, $8jOUp.Observable).from(Promise.reject(errorResponse)).catch((error)=>{
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $osBO5.updateLoginAnnouncementsFailure)(errorResponse)), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
        });
    }
    return (0, $8jOUp.Observable).from((0, $3i1VP.updateLoginAnnouncementsData)(inputVariables).then((response)=>{
        var _response$helpCenter, _response$helpCenter2, _response$helpCenter3;
        if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateLoginAnnouncement) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) // incase of mutation success, we get success as true and no errors
        return true;
        // we get success as false and errors in case of mutation failure
        const errorResponse = {
            errorMessages: ((_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateLoginAnnouncement) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.errors) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.map((error)=>error.message ?? '')) ?? [],
            status: ((_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateLoginAnnouncement) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.errors) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3[0]) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.extensions) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.statusCode) ?? (0, $jcRK7.HTTP).SERVER
        };
        return Promise.reject(errorResponse);
    })).flatMap(()=>{
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9VIRk.updateLoginAnnouncementSideBarExperience).success();
        // unlink model mutation call, we do not get login announcements in response, hence using payload to call updateLoginAnnouncementsSuccess
        return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $osBO5.updateLoginAnnouncementsSuccess)(payload)), (0, $8jOUp.Observable).of((0, $osBO5.resetLoginAnnouncements)()));
    }).catch((error)=>{
        if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(error.status)) (0, $jBiia.legacySendEvent)((0, $G6QpT.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
        if (!(0, $h92tT.isNetworkOrClientErrorCode)(error.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9VIRk.updateLoginAnnouncementSideBarExperience).failure({
            metadata: {
                error: error.message
            }
        });
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9VIRk.updateLoginAnnouncementSideBarExperience).success();
        // we are mapping the error, because mutation error in not always in form of AjaxError
        const errorResponse = {
            ...error,
            errorMessages: [
                error.message
            ],
            status: error.status ?? (0, $jcRK7.HTTP).SERVER
        };
        return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $osBO5.updateLoginAnnouncementsFailure)(errorResponse)), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(errorResponse)));
    });
};
const $2a4ed2732360c3e6$export$2bd3c7829bd01a9c = (action$)=>{
    return action$.ofType((0, $osBO5.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL)).mergeMap((action)=>{
        return $2a4ed2732360c3e6$var$gqlMutationLoginAnnouncements(action);
    });
};

});
parcelRegister("f2i8V", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => (parcelRequire("osBO5")).fetchLoginAnnouncementModel);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("osBO5")).FETCH_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("osBO5")).FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("osBO5")).FETCH_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => (parcelRequire("osBO5")).fetchLoginAnnouncementsSuccess);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => (parcelRequire("osBO5")).fetchLoginAnnouncementsFailure);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => (parcelRequire("osBO5")).UPDATE_LOGIN_ANNOUNCEMENTS_MODEL);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("osBO5")).UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("osBO5")).UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("osBO5")).UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("osBO5")).RESET_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => (parcelRequire("osBO5")).updateLoginAnnouncementsModel);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => (parcelRequire("osBO5")).updateLoginAnnouncementsSuccess);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => (parcelRequire("osBO5")).updateLoginAnnouncementsFailure);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => (parcelRequire("osBO5")).updateLoginAnnouncementsUIState);
$parcel$export(module.exports, "resetLoginAnnouncements", () => (parcelRequire("osBO5")).resetLoginAnnouncements);

var $osBO5 = parcelRequire("osBO5");

});
parcelRegister("osBO5", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => $aa995047842d912a$export$dc62bc08b47f80d);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $aa995047842d912a$export$b975358f73425401);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => $aa995047842d912a$export$182afe1fbca9c1ad);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => $aa995047842d912a$export$ebcd8b9795616937);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => $aa995047842d912a$export$85451866d84a5811);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $aa995047842d912a$export$bca8bb13b9278354);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => $aa995047842d912a$export$12b5ff9da9aaaa28);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => $aa995047842d912a$export$2ef132370a38839c);
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => $aa995047842d912a$export$2510bc335620bfa4);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => $aa995047842d912a$export$66b083401f2dd420);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => $aa995047842d912a$export$b7ec07a46de8ffd1);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => $aa995047842d912a$export$c139274c332846b7);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => $aa995047842d912a$export$1723ccec0130d524);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => $aa995047842d912a$export$682d06bd9eef1572);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => $aa995047842d912a$export$5b3b63a7f806c6d8);
$parcel$export(module.exports, "resetLoginAnnouncements", () => $aa995047842d912a$export$c992a3f94eef7527);

var $hn5Mq = parcelRequire("hn5Mq");
const $aa995047842d912a$export$dc62bc08b47f80d = 'epic.model.FETCH_LOGIN_ANNOUNCEMENTS';
const $aa995047842d912a$export$b975358f73425401 = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $aa995047842d912a$export$182afe1fbca9c1ad = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE';
const $aa995047842d912a$export$ebcd8b9795616937 = 'epic.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL';
const $aa995047842d912a$export$85451866d84a5811 = 'state.ui.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE';
const $aa995047842d912a$export$bca8bb13b9278354 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $aa995047842d912a$export$12b5ff9da9aaaa28 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE';
const $aa995047842d912a$export$2ef132370a38839c = 'state.ui.loginAnnouncements.RESET_LOGIN_ANNOUNCEMENTS';
const $aa995047842d912a$export$2510bc335620bfa4 = (0, $hn5Mq.buildModelsActionCreator)($aa995047842d912a$export$dc62bc08b47f80d, 'loginAnnouncements');
const $aa995047842d912a$export$66b083401f2dd420 = (loginAnnouncementsModel)=>({
        type: $aa995047842d912a$export$b975358f73425401,
        payload: loginAnnouncementsModel
    });
const $aa995047842d912a$export$b7ec07a46de8ffd1 = (error)=>({
        type: $aa995047842d912a$export$182afe1fbca9c1ad,
        payload: {
            error: error
        }
    });
const $aa995047842d912a$export$c139274c332846b7 = (loginAnnouncementsModel, meta)=>({
        meta: meta,
        type: $aa995047842d912a$export$ebcd8b9795616937,
        payload: loginAnnouncementsModel
    });
const $aa995047842d912a$export$1723ccec0130d524 = (loginAnnouncementsModel)=>({
        type: $aa995047842d912a$export$bca8bb13b9278354,
        payload: loginAnnouncementsModel
    });
const $aa995047842d912a$export$682d06bd9eef1572 = (error)=>({
        type: $aa995047842d912a$export$12b5ff9da9aaaa28,
        payload: {
            error: error
        }
    });
const $aa995047842d912a$export$5b3b63a7f806c6d8 = (loginAnnouncementsModel)=>({
        type: $aa995047842d912a$export$85451866d84a5811,
        payload: loginAnnouncementsModel
    });
const $aa995047842d912a$export$c992a3f94eef7527 = ()=>({
        type: $aa995047842d912a$export$2ef132370a38839c
    });

});


parcelRegister("3i1VP", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsData", () => $3907fc8058ccb997$export$40a99b486fb0f5fd);
$parcel$export(module.exports, "mapLoginAnnouncementsPayloadToGqlInput", () => $3907fc8058ccb997$export$85e7a57e62ad0fbc);

var $gRdkp = parcelRequire("gRdkp");

var $4270B = parcelRequire("4270B");

var $fuVmc = parcelRequire("fuVmc");

var $kbkME = parcelRequire("kbkME");
const $3907fc8058ccb997$export$40a99b486fb0f5fd = (variables)=>{
    return new Promise((resolve, reject)=>{
        (0, $4270B.commitMutation)((0, $kbkME.getRelayEnvironment)(), {
            variables: variables,
            mutation: (0, $gRdkp.default),
            onCompleted: (response)=>{
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};
const $3907fc8058ccb997$export$85e7a57e62ad0fbc = (payload)=>{
    const nameTranslations = [];
    const descriptionTranslations = [];
    // map payload to gql input
    Object.keys(payload.translatedLogInAnnouncements).forEach((locale)=>{
        nameTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].header
        });
        descriptionTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].message
        });
    });
    return {
        cloudId: (0, $fuVmc.getCloudId)(),
        input: {
            nameTranslations: nameTranslations,
            descriptionTranslations: descriptionTranslations,
            helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
            descriptionType: 'WIKI_MARKUP'
        }
    };
};

});
parcelRegister("gRdkp", function(module, exports) {
$parcel$export(module.exports, "default", () => $91d60bbbe04c98f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a43a0b0a9899057b05221c5b213a09fa>>
 * @relayHash d08d5aad8dde8629cc060f7256c65f6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c
const $91d60bbbe04c98f0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c",
            "metadata": {},
            "name": "loginAnnouncementsUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$91d60bbbe04c98f0$var$node.hash = "a5dd7f4861ac93d9b41cc3104b2a0e6a";
var $91d60bbbe04c98f0$export$2e2bcd8739ae039 = $91d60bbbe04c98f0$var$node;

});

parcelRegister("kbkME", function(module, exports) {
$parcel$export(module.exports, "getRelayEnvironment", () => $4498c8078f9deaf0$export$ffa93f1e5be01566);

var $lFpPv = parcelRequire("lFpPv");

var $gdUUy = parcelRequire("gdUUy");

var $9qsI2 = parcelRequire("9qsI2");

var $e2CvF = parcelRequire("e2CvF");

var $lAkwg = parcelRequire("lAkwg");

var $jRsLy = parcelRequire("jRsLy");

var $eO8XI = parcelRequire("eO8XI");

var $dvY3d = parcelRequire("dvY3d");
const $4498c8078f9deaf0$var$resolveSharedRelayGetDataIDConfig = ()=>{
    if ((0, $lFpPv.isFixRelayIdConflictForHelpObjectStoreEnabled)()) return {
        getDataID: (0, $e2CvF.resolveGetDataID)()
    };
    if (!(0, $lFpPv.isFixRelayIdConflictInHelpCenter)()) return {
        getDataID: undefined
    };
    return {};
};
const $4498c8078f9deaf0$var$sharedRelayEnvironment = (0, $9qsI2.createRelayEnvironment)({
    ...$4498c8078f9deaf0$var$resolveSharedRelayGetDataIDConfig(),
    networkOptions: {
        setEndpoint: (0, $lAkwg.default).setEndpoint,
        getHeaders: (0, $lAkwg.default).getHeaders,
        isServer: false,
        subscribeExtensions: (0, $eO8XI.subscribeOptions).extensions,
        onSubscribeError: (0, $eO8XI.subscribeOptions).onError,
        onSubscribeTrigger: (0, $eO8XI.subscribeOptions).onTrigger,
        queryResponseCache: (0, $jRsLy.QueryResponseCache),
        validateResponse: (0, $lAkwg.default).validateResponse,
        onFetchError: (0, $lAkwg.default).onFetchError
    }
});
const $4498c8078f9deaf0$export$ffa93f1e5be01566 = ()=>{
    if ((0, $gdUUy.fg)('platform_relay_use_shared_relay_env_help_center')) return $4498c8078f9deaf0$var$sharedRelayEnvironment;
    return 0, $e2CvF.default;
};

});
parcelRegister("9qsI2", function(module, exports) {
$parcel$export(module.exports, "isAtlassianRelayEnvironment", () => $47747796ac54cf17$export$56db1ec1ca8ef90c);
$parcel$export(module.exports, "createRelayEnvironment", () => $47747796ac54cf17$export$7afaa9c867644497);

var $4270B = parcelRequire("4270B");

var $dzT3z = parcelRequire("dzT3z");

var $gdUUy = parcelRequire("gdUUy");

var $heqZo = parcelRequire("heqZo");

var $6undV = parcelRequire("6undV");

var $fPhns = parcelRequire("fPhns");

var $anIvV = parcelRequire("anIvV");

var $2oTJu = parcelRequire("2oTJu");

var $b6ktr = parcelRequire("b6ktr");

var $8HDp8 = parcelRequire("8HDp8");

var $7Je5m = parcelRequire("7Je5m");
// Enable Relay Resolvers globally for this module
(0, $4270B.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $47747796ac54cf17$var$createNetwork(networkOptions, getEnableUfoHolds) {
    const fetchOperation = (request, variables, cacheConfig)=>(0, $fPhns.fetch)(request, variables, cacheConfig, networkOptions);
    const fetchOperationWithMiddleware = (0, $7Je5m.ufoDataFetchHoldMiddleware)(fetchOperation, {
        getIsEnabled: getEnableUfoHolds
    });
    return (0, $4270B.Network).create(fetchOperationWithMiddleware, networkOptions.isServer === false ? (0, $b6ktr.createSubscribeFn)(networkOptions) : undefined);
}
/**
 * Brand attached to every environment produced by {@link createRelayEnvironment}.
 *
 * We use `Symbol.for` (the global symbol registry) rather than a module-local `Symbol()` so the
 * brand stays stable even if this module ends up duplicated across bundles/realms — the guard in a
 * consumer will still recognise an environment created by another copy of this package.
 */ const $47747796ac54cf17$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND = Symbol.for('@atlassian/relay-environment.AtlassianRelayEnvironment');
function $47747796ac54cf17$var$brandEnvironment(environment) {
    Object.defineProperty(environment, $47747796ac54cf17$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND, {
        value: true,
        enumerable: false,
        configurable: false,
        writable: false
    });
    return environment;
}
function $47747796ac54cf17$export$56db1ec1ca8ef90c(environment) {
    return environment != null && (typeof environment === 'object' || typeof environment === 'function') && environment[$47747796ac54cf17$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND] === true;
}
/**
 * Relay calls `environment.UNSTABLE_getDefaultRenderPolicy()` on every `QueryResource.prepare`, so
 * this allows overriding it dynamically (and not during module scope evaluation).
 */ class $47747796ac54cf17$var$DynamicRenderPolicyEnvironment extends (0, $4270B.Environment) {
    constructor(config, getRenderPolicy){
        super(config);
        this.getRenderPolicy = getRenderPolicy;
    }
    /**
   * Note: currently missing from @types/relay-runtime (version 20.1.1) but DOES exist at runtime.
   */ UNSTABLE_getDefaultRenderPolicy() {
        return this.getRenderPolicy();
    }
}
const $47747796ac54cf17$var$createStore = (source, options)=>new (0, (/*@__PURE__*/$parcel$interopDefault($dzT3z)))(source, options);
function $47747796ac54cf17$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, getDefaultRenderPolicy: getDefaultRenderPolicy, getEnableUfoHolds: getEnableUfoHolds, wsClientOptions: wsClientOptions }) {
    if ((0, $gdUUy.fg)('platform_relay_enable_activity_compatibility_flag') || (0, $gdUUy.fg)('platform_relay_activity_compatibility_townsquare')) (0, $4270B.RelayFeatureFlags).ENABLE_ACTIVITY_COMPATIBILITY = true;
    if (wsClientOptions) (0, $heqZo.configureWebSocketClient)(wsClientOptions);
    const source = new (0, $4270B.RecordSource)();
    const config = {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $47747796ac54cf17$var$createNetwork(networkOptions || {
            isServer: false
        }, getEnableUfoHolds),
        store: $47747796ac54cf17$var$createStore(source, {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $6undV.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $6undV.default),
        scheduler: (0, $2oTJu.default),
        missingFieldHandlers: (0, $anIvV.default),
        handlerProvider: (0, $8HDp8.createRelayHandlerProvider)(source)
    };
    const environment = getDefaultRenderPolicy ? new $47747796ac54cf17$var$DynamicRenderPolicyEnvironment(config, getDefaultRenderPolicy) : new (0, $4270B.Environment)(config);
    return $47747796ac54cf17$var$brandEnvironment(environment);
}

});
parcelRegister("dzT3z", function(module, exports) {
'use strict';

var $bdoqY = parcelRequire("bdoqY");
module.exports = $bdoqY;

});

parcelRegister("heqZo", function(module, exports) {
$parcel$export(module.exports, "configureWebSocketClient", () => $3078c65054bd59dd$export$155768b0e0a38663);
$parcel$export(module.exports, "getClient", () => $3078c65054bd59dd$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getSocketConnectionState", () => $3078c65054bd59dd$export$83dc7d6f7d0a4fad);

var $5FQ3H = parcelRequire("5FQ3H");

var $gdUUy = parcelRequire("gdUUy");

var $4sBOg = parcelRequire("4sBOg");

var $d3yWq = parcelRequire("d3yWq");

var $hL8n8 = parcelRequire("hL8n8");

var $ekWJW = parcelRequire("ekWJW");

var $3LvDt = parcelRequire("3LvDt");
let $3078c65054bd59dd$var$client;
let $3078c65054bd59dd$var$configuredOptions;
let $3078c65054bd59dd$var$isSocketConnected = ()=>false;
let $3078c65054bd59dd$var$abortPendingRetryWait = ()=>false;
let $3078c65054bd59dd$var$observesSocketState = false;
let $3078c65054bd59dd$var$recoveryCount = 0;
let $3078c65054bd59dd$var$detachRecovery;
const $3078c65054bd59dd$export$155768b0e0a38663 = (options)=>{
    if ($3078c65054bd59dd$var$client) {
        // eslint-disable-next-line no-console
        console.warn('configureWebSocketClient was called after the subscription client was already created, so these options have been ignored. Configure it while creating the relay environment, before any subscription starts.');
        return;
    }
    $3078c65054bd59dd$var$configuredOptions = options;
};
const $3078c65054bd59dd$export$6bb76d6eba7e258c = ()=>{
    if ((0, $hL8n8.isSSR)()) return null;
    if (!$3078c65054bd59dd$var$client) {
        var _configuredOptions, _configuredOptions$ge, _window, _window2;
        const onConnectionEvent = (_configuredOptions = $3078c65054bd59dd$var$configuredOptions) === null || _configuredOptions === void 0 || (_configuredOptions$ge = _configuredOptions.getConnectionEventReporter) === null || _configuredOptions$ge === void 0 ? void 0 : _configuredOptions$ge.call(_configuredOptions);
        const terminate = ()=>{
            var _client;
            return (_client = $3078c65054bd59dd$var$client) === null || _client === void 0 ? void 0 : _client.terminate();
        };
        const { listeners: listeners, isConnected: isConnected } = (0, $3LvDt.createSocketListeners)({
            onConnectionEvent: onConnectionEvent,
            pongWaitTimeout: (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? (0, $d3yWq.WS_CLIENT_PONG_WAIT) : 0,
            terminate: terminate
        });
        $3078c65054bd59dd$var$isSocketConnected = isConnected;
        const rateLimitedRetryWait = (0, $gdUUy.fg)('platform_relay_subscription_reliability') && (0, $gdUUy.fg)('platform_relay_subscription_rate_limit_backoff') ? (0, $ekWJW.createRateLimitedRetryWait)((0, $d3yWq.WS_CLIENT_MAX_RETRY_WAIT)) : undefined;
        const retryWait = (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? rateLimitedRetryWait ?? (0, $ekWJW.createRetryWait)((0, $d3yWq.WS_CLIENT_MAX_RETRY_WAIT)) : undefined;
        $3078c65054bd59dd$var$abortPendingRetryWait = (retryWait === null || retryWait === void 0 ? void 0 : retryWait.abort) ?? (()=>false);
        $3078c65054bd59dd$var$observesSocketState = (0, $gdUUy.fg)('platform_relay_subscription_reliability-additional') && Boolean(onConnectionEvent || (0, $gdUUy.fg)('platform_relay_subscription_reliability'));
        $3078c65054bd59dd$var$client = (0, $5FQ3H.createClient)({
            url: (0, $hL8n8.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? (0, $d3yWq.WS_CLIENT_LIVENESS_KEEP_ALIVE) : (0, $d3yWq.WS_CLIENT_KEEP_ALIVE),
            retryAttempts: (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? (0, $d3yWq.WS_CLIENT_CAPPED_RETRIES) : (0, $d3yWq.WS_CLIENT_RETRIES),
            retryWait: retryWait === null || retryWait === void 0 ? void 0 : retryWait.wait,
            shouldRetry: (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? (0, $ekWJW.shouldRetryTransportFailure) : undefined,
            // 0 = wait forever (graphql-ws default).
            connectionAckWaitTimeout: (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? (0, $d3yWq.WS_CLIENT_CONNECTION_ACK_WAIT) : 0,
            lazyCloseTimeout: (0, $gdUUy.fg)('platform_relay_subscription_connection_reuse') ? (0, $d3yWq.WS_CLIENT_LAZY_CLOSE) : 0,
            on: onConnectionEvent || (0, $gdUUy.fg)('platform_relay_subscription_reliability') ? listeners : undefined,
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${((_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) ?? ''}::${((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.SSR_BUILD_KEY) ?? ''}`,
                'X-ExperimentalApi': (0, $4sBOg.getRelayExperimentalApis)().join(',')
            }
        });
        if (rateLimitedRetryWait) $3078c65054bd59dd$var$client.on('closed', rateLimitedRetryWait.recordClose);
    }
    return $3078c65054bd59dd$var$client;
};
const $3078c65054bd59dd$export$b4412e664c6cc09b = ()=>{
    if (!(0, $gdUUy.fg)('platform_relay_subscription_reliability')) return ()=>{};
    $3078c65054bd59dd$var$recoveryCount += 1;
    $3078c65054bd59dd$var$detachRecovery ?? ($3078c65054bd59dd$var$detachRecovery = (0, $ekWJW.addRecoveryListeners)({
        terminate: ()=>{
            var _client2;
            return (_client2 = $3078c65054bd59dd$var$client) === null || _client2 === void 0 ? void 0 : _client2.terminate();
        },
        isConnected: ()=>$3078c65054bd59dd$var$isSocketConnected(),
        abortRetryWait: ()=>$3078c65054bd59dd$var$abortPendingRetryWait()
    }));
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        $3078c65054bd59dd$var$recoveryCount -= 1;
        if ($3078c65054bd59dd$var$recoveryCount === 0) {
            var _detachRecovery;
            (_detachRecovery = $3078c65054bd59dd$var$detachRecovery) === null || _detachRecovery === void 0 || _detachRecovery();
            $3078c65054bd59dd$var$detachRecovery = undefined;
        }
    };
};
const $3078c65054bd59dd$export$2f0afd443356d36f = ()=>{
    $3078c65054bd59dd$var$client = null;
    $3078c65054bd59dd$var$configuredOptions = undefined;
    $3078c65054bd59dd$var$isSocketConnected = ()=>false;
    $3078c65054bd59dd$var$abortPendingRetryWait = ()=>false;
    $3078c65054bd59dd$var$observesSocketState = false;
};
const $3078c65054bd59dd$export$83dc7d6f7d0a4fad = ()=>(0, $gdUUy.fg)('platform_relay_subscription_reliability-additional') && $3078c65054bd59dd$var$observesSocketState ? $3078c65054bd59dd$var$isSocketConnected() ? 'connected' : 'disconnected' : 'unknown';

});
parcelRegister("5FQ3H", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $421929dd27db43d3$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $bvXY0 = parcelRequire("bvXY0");

var $ik7nW = parcelRequire("ik7nW");
var $421929dd27db43d3$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $421929dd27db43d3$var$__await ? (this.v = v, this) : new $421929dd27db43d3$var$__await(v);
};
var $421929dd27db43d3$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $421929dd27db43d3$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $421929dd27db43d3$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $421929dd27db43d3$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$421929dd27db43d3$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $bvXY0.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $bvXY0.stringifyMessage)({
                                    type: (0, $bvXY0.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $421929dd27db43d3$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $bvXY0.stringifyMessage)(payload ? {
                            type: (0, $bvXY0.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $bvXY0.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $bvXY0.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $bvXY0.CloseCode).InternalClientError, (0, $ik7nW.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $bvXY0.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $bvXY0.stringifyMessage)(message.payload ? {
                                    type: (0, $bvXY0.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $bvXY0.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $bvXY0.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $bvXY0.CloseCode).BadResponse, (0, $ik7nW.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($421929dd27db43d3$var$isLikeCloseEvent(errOrCloseEvent) && ($421929dd27db43d3$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $bvXY0.CloseCode).InternalServerError,
            (0, $bvXY0.CloseCode).InternalClientError,
            (0, $bvXY0.CloseCode).BadRequest,
            (0, $bvXY0.CloseCode).BadResponse,
            (0, $bvXY0.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $bvXY0.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $bvXY0.CloseCode).SubscriberAlreadyExists,
            (0, $bvXY0.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($421929dd27db43d3$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $bvXY0.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $bvXY0.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $bvXY0.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $bvXY0.stringifyMessage)({
                    id: id,
                    type: (0, $bvXY0.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $bvXY0.stringifyMessage)({
                        id: id,
                        type: (0, $bvXY0.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $421929dd27db43d3$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $421929dd27db43d3$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $421929dd27db43d3$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $421929dd27db43d3$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $421929dd27db43d3$export$f5b1bfead8e118a7());
        }
    };
}
class $421929dd27db43d3$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $421929dd27db43d3$var$isLikeCloseEvent(val) {
    return (0, $ik7nW.isObject)(val) && 'code' in val && 'reason' in val;
}
function $421929dd27db43d3$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $421929dd27db43d3$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("bvXY0", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $86211b1b9fd2896e$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $86211b1b9fd2896e$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $86211b1b9fd2896e$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $86211b1b9fd2896e$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $86211b1b9fd2896e$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $ik7nW = parcelRequire("ik7nW");
const $86211b1b9fd2896e$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $86211b1b9fd2896e$export$ec743af8bb66f3be = 'graphql-ws';
var $86211b1b9fd2896e$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($86211b1b9fd2896e$export$777128f41f6616ec || ($86211b1b9fd2896e$export$777128f41f6616ec = {}));
var $86211b1b9fd2896e$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($86211b1b9fd2896e$export$80edbf15fa61a4db || ($86211b1b9fd2896e$export$80edbf15fa61a4db = {}));
function $86211b1b9fd2896e$export$c17861b159b1b673(val) {
    if (!(0, $ik7nW.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $ik7nW.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $ik7nW.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.ConnectionInit:
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.ConnectionAck:
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.Ping:
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $ik7nW.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ik7nW.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ik7nW.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $ik7nW.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $ik7nW.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $ik7nW.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $ik7nW.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $ik7nW.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $ik7nW.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $ik7nW.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $ik7nW.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ik7nW.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ik7nW.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $ik7nW.extendedTypeof)(val.payload)}`);
            break;
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ik7nW.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ik7nW.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $86211b1b9fd2896e$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ik7nW.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $86211b1b9fd2896e$export$9e0e49e75fa7d548(val) {
    try {
        $86211b1b9fd2896e$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $86211b1b9fd2896e$export$f2f615077a189f21(data, reviver) {
    return $86211b1b9fd2896e$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $86211b1b9fd2896e$export$77896e5b47bfd50b(msg, replacer) {
    $86211b1b9fd2896e$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("ik7nW", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $d56fd2cda16d51fa$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $d56fd2cda16d51fa$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $d56fd2cda16d51fa$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $d56fd2cda16d51fa$export$2937fa0c8dddae54);
/** @private */ function $d56fd2cda16d51fa$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $d56fd2cda16d51fa$export$a6cdc56e425d0d0a(val) {
    return $d56fd2cda16d51fa$export$573326049e1b1c6b(val) === 'object';
}
function $d56fd2cda16d51fa$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $d56fd2cda16d51fa$export$92bd080471bc30f1(val) {
    return $d56fd2cda16d51fa$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $d56fd2cda16d51fa$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $d56fd2cda16d51fa$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("4sBOg", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $045688470d15fd2b$export$2cb71284f72ca45b);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $045688470d15fd2b$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const $045688470d15fd2b$export$2cb71284f72ca45b = ()=>$045688470d15fd2b$export$ebe3a775ce3053a5;

});

parcelRegister("d3yWq", function(module, exports) {
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $e4fe0551d59fb388$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_LIVENESS_KEEP_ALIVE", () => $e4fe0551d59fb388$export$68a6a6cccbaf5f06);
$parcel$export(module.exports, "WS_CLIENT_PONG_WAIT", () => $e4fe0551d59fb388$export$6fe3216720bb7a79);
$parcel$export(module.exports, "WS_CLIENT_CONNECTION_ACK_WAIT", () => $e4fe0551d59fb388$export$e5f3cb8ab5223cd4);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $e4fe0551d59fb388$export$bf6cd96e19b2987f);
$parcel$export(module.exports, "WS_CLIENT_MAX_RETRY_WAIT", () => $e4fe0551d59fb388$export$bcf3b302e1a0ba63);
$parcel$export(module.exports, "WS_CLOSE_RATE_LIMITED", () => $e4fe0551d59fb388$export$74f911c394187993);
$parcel$export(module.exports, "WS_CLIENT_MAX_RETRY_AFTER", () => $e4fe0551d59fb388$export$5d72de7e544ab20f);
$parcel$export(module.exports, "WS_CLIENT_RATE_LIMIT_SPREAD", () => $e4fe0551d59fb388$export$a5991d6597d2d0f8);
$parcel$export(module.exports, "WS_CLIENT_CAPPED_RETRIES", () => $e4fe0551d59fb388$export$6a0c27ebdbd1f0ed);
$parcel$export(module.exports, "WS_CLIENT_LAZY_CLOSE", () => $e4fe0551d59fb388$export$3f57674185473b5d);
// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $e4fe0551d59fb388$export$8b012b965402e06a = 580000;
const $e4fe0551d59fb388$export$68a6a6cccbaf5f06 = 30000;
const $e4fe0551d59fb388$export$6fe3216720bb7a79 = 15000;
const $e4fe0551d59fb388$export$e5f3cb8ab5223cd4 = 15000;
const $e4fe0551d59fb388$export$bf6cd96e19b2987f = 100;
const $e4fe0551d59fb388$export$bcf3b302e1a0ba63 = 30000;
const $e4fe0551d59fb388$export$74f911c394187993 = 4430;
const $e4fe0551d59fb388$export$5d72de7e544ab20f = 300000;
const $e4fe0551d59fb388$export$a5991d6597d2d0f8 = 15000;
const $e4fe0551d59fb388$export$6a0c27ebdbd1f0ed = 240;
const $e4fe0551d59fb388$export$3f57674185473b5d = 5000;
const $e4fe0551d59fb388$export$1ad8434180c5936c = 300000;

});

parcelRegister("hL8n8", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $4ac5b364cb57304d$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $4ac5b364cb57304d$export$29a72e89601dfc59);
const $4ac5b364cb57304d$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $4ac5b364cb57304d$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});

parcelRegister("ekWJW", function(module, exports) {
$parcel$export(module.exports, "createRetryWait", () => $fa20783a6c42717c$export$ea2f6b7dff89727b);
$parcel$export(module.exports, "shouldRetryTransportFailure", () => $fa20783a6c42717c$export$f7ed0a50263b7ba7);
$parcel$export(module.exports, "createRateLimitedRetryWait", () => $fa20783a6c42717c$export$7543ed35130ad0de);
$parcel$export(module.exports, "addRecoveryListeners", () => $fa20783a6c42717c$export$693cd641fa681cb1);

var $c9wRy = parcelRequire("c9wRy");

var $d3yWq = parcelRequire("d3yWq");
const $fa20783a6c42717c$export$ea2f6b7dff89727b = (maxRetryWait)=>{
    let abortCurrent;
    return {
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            abortCurrent = undefined;
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            const delay = Math.min(1000 * 2 ** retries + jitter, maxRetryWait);
            await new Promise((resolve)=>{
                const timer = setTimeout(()=>{
                    abortCurrent = undefined;
                    resolve();
                }, delay);
                abortCurrent = ()=>{
                    clearTimeout(timer);
                    resolve();
                };
            });
        }
    };
};
// The library's own default `shouldRetry`. From 5.16, `Client.terminate()` emits a close-like
// `Error`, so the close shape must be checked before the type.
const $fa20783a6c42717c$var$isLikeCloseEvent = (value)=>typeof value === 'object' && value !== null && 'code' in value && 'reason' in value;
const $fa20783a6c42717c$export$f7ed0a50263b7ba7 = (errOrCloseEvent)=>$fa20783a6c42717c$var$isLikeCloseEvent(errOrCloseEvent) || !(errOrCloseEvent instanceof Error);
/** Retry-after in ms of a rate-limit close, or undefined for any other close. */ const $fa20783a6c42717c$var$getRateLimitRetryAfter = (event)=>{
    if (!$fa20783a6c42717c$var$isLikeCloseEvent(event) || event.code !== (0, $d3yWq.WS_CLOSE_RATE_LIMITED) || typeof event.reason !== 'string' || !/^\d+$/.test(event.reason)) return undefined;
    return Math.min(Math.max(Number(event.reason), 1) * 1000, (0, $d3yWq.WS_CLIENT_MAX_RETRY_AFTER));
};
const $fa20783a6c42717c$export$7543ed35130ad0de = (maxRetryWait)=>{
    let notBefore = 0;
    let abortCurrent;
    return {
        recordClose: (event)=>{
            const retryAfter = $fa20783a6c42717c$var$getRateLimitRetryAfter(event);
            if (retryAfter !== undefined) notBefore = Date.now() + retryAfter + Math.floor(Math.random() * (0, $d3yWq.WS_CLIENT_RATE_LIMIT_SPREAD));
        },
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            // Jitter after the cap, so clients that reached it do not retry in lockstep.
            const backoff = Math.min(1000 * 2 ** retries, maxRetryWait) + jitter;
            await new Promise((resolve)=>{
                let timer;
                const finish = ()=>{
                    clearTimeout(timer);
                    abortCurrent = undefined;
                    resolve();
                };
                const finishAfter = (delay)=>{
                    clearTimeout(timer);
                    timer = setTimeout(finish, delay);
                };
                finishAfter(Math.max(backoff, notBefore - Date.now()));
                abortCurrent = ()=>{
                    const untilDeadline = notBefore - Date.now();
                    if (untilDeadline > 0) finishAfter(untilDeadline);
                    else finish();
                };
            });
        }
    };
};
const $fa20783a6c42717c$export$693cd641fa681cb1 = ({ terminate: terminate, isConnected: isConnected, abortRetryWait: abortRetryWait })=>{
    const doc = (0, $c9wRy.getDocument)();
    const reconnect = ()=>{
        if (abortRetryWait()) return;
        terminate();
    };
    const wakeIfDisconnected = ()=>{
        if (!isConnected()) reconnect();
    };
    const onVisibilityChange = ()=>{
        if ((doc === null || doc === void 0 ? void 0 : doc.visibilityState) === 'visible') wakeIfDisconnected();
    };
    const onPageShow = (event)=>{
        // pageshow also fires on ordinary loads; only `persisted` is bfcache.
        if (event.persisted) reconnect();
    };
    const onResume = ()=>{
        reconnect();
    };
    window.addEventListener('online', wakeIfDisconnected);
    window.addEventListener('pageshow', onPageShow);
    doc === null || doc === void 0 || doc.addEventListener('visibilitychange', onVisibilityChange);
    // Chrome tab freeze; no pageshow.
    doc === null || doc === void 0 || doc.addEventListener('resume', onResume);
    return ()=>{
        window.removeEventListener('online', wakeIfDisconnected);
        window.removeEventListener('pageshow', onPageShow);
        doc === null || doc === void 0 || doc.removeEventListener('visibilitychange', onVisibilityChange);
        doc === null || doc === void 0 || doc.removeEventListener('resume', onResume);
    };
};

});

parcelRegister("3LvDt", function(module, exports) {
$parcel$export(module.exports, "createSocketListeners", () => $6c1b9f0c0197282e$export$e9b0d6f3238eb01d);

var $5sp5V = parcelRequire("5sp5V");
// Browser close is a CloseEvent; Client.terminate() emits a close-like object, which from
// graphql-ws 5.16 is an Error.
const $6c1b9f0c0197282e$var$readCloseInfo = (event)=>{
    if (typeof event !== 'object' || event === null) return {
        closeCode: null,
        reason: null,
        wasClean: null
    };
    const code = 'code' in event ? event.code : undefined;
    const reason = 'reason' in event ? event.reason : undefined;
    const wasClean = 'wasClean' in event ? event.wasClean : undefined;
    return {
        closeCode: typeof code === 'number' ? code : null,
        reason: typeof reason === 'string' ? reason : null,
        wasClean: typeof wasClean === 'boolean' ? wasClean : null
    };
};
const $6c1b9f0c0197282e$export$e9b0d6f3238eb01d = ({ onConnectionEvent: onConnectionEvent, pongWaitTimeout: pongWaitTimeout, terminate: terminate })=>{
    let attempt = 0;
    let connectionCount = 0;
    let connectedAt = null;
    let pongDeadline;
    const report = (event)=>{
        if (!onConnectionEvent) return;
        try {
            onConnectionEvent(event);
        } catch  {
        // Avoid breaking the transport if reporting throws.
        }
    };
    const clearPongDeadline = ()=>{
        clearTimeout(pongDeadline);
        pongDeadline = undefined;
    };
    return {
        isConnected: ()=>connectedAt !== null,
        listeners: {
            connecting: ()=>{
                attempt += 1;
                report({
                    type: 'connecting',
                    attempt: attempt
                });
            },
            opened: ()=>{
                report({
                    type: 'opened',
                    attempt: attempt
                });
            },
            connected: ()=>{
                connectionCount += 1;
                connectedAt = Date.now();
                report({
                    type: 'connected',
                    attempt: attempt,
                    connectionCount: connectionCount
                });
                attempt = 0;
            },
            closed: (event)=>{
                // Drop the deadline so it cannot kill a reconnecting socket.
                clearPongDeadline();
                report({
                    type: 'closed',
                    ...$6c1b9f0c0197282e$var$readCloseInfo(event),
                    connectedForMs: connectedAt === null ? null : Date.now() - connectedAt
                });
                connectedAt = null;
            },
            // Only our outbound ping arms the deadline; only an inbound pong clears it.
            ping: (received)=>{
                if (received || pongWaitTimeout <= 0) return;
                clearPongDeadline();
                pongDeadline = setTimeout(terminate, pongWaitTimeout);
            },
            pong: (received)=>{
                if (received) clearPongDeadline();
            },
            error: (error)=>{
                report({
                    type: 'error',
                    message: error instanceof Error ? error.message : null,
                    kind: (0, $5sp5V.getSinkError)(error).kind
                });
            }
        }
    };
};

});
parcelRegister("5sp5V", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $d89a0c20337703ae$export$ece4736473c28965);

var $gdUUy = parcelRequire("gdUUy");
/** `Array.isArray` alone narrows a `readonly` array to `any[]`, losing the element type. */ const $d89a0c20337703ae$var$isGraphQLErrorArray = (error)=>Array.isArray(error);
/**
 * Events are duck-typed rather than matched with `instanceof`: `Event`, `CloseEvent` and
 * `ErrorEvent` are not globals in every environment the client runs in, and `instanceof`
 * throws outright when its right-hand side is undefined.
 */ const $d89a0c20337703ae$var$isEventLike = (error)=>typeof error === 'object' && error !== null && 'type' in error && typeof error.type === 'string';
const $d89a0c20337703ae$var$isCloseEvent = (error)=>$d89a0c20337703ae$var$isEventLike(error) && error.type === 'close';
const $d89a0c20337703ae$var$isErrorEvent = (error)=>$d89a0c20337703ae$var$isEventLike(error) && error.type === 'error';
// The numeric `code` keeps out Node-style errors, whose `code` is a string such as `ECONNRESET`.
const $d89a0c20337703ae$var$isCloseLike = (error)=>typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'number' && 'reason' in error && typeof error.reason === 'string';
/** Non-enumerable details on a shared Error instance (same object goes to every sink). */ const $d89a0c20337703ae$var$withDetails = (error, details)=>{
    for (const [key, value] of Object.entries(details))Object.defineProperty(error, key, {
        value: value,
        enumerable: false,
        configurable: true,
        writable: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return error;
};
/** Pre-gate sink shaping. */ const $d89a0c20337703ae$var$getLegacySinkError = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const closeEvent = error;
        errorInfo = new Error(`CloseEvent: ${closeEvent.reason}`);
        errorInfo.closeCode = closeEvent.code;
        errorInfo.wasClean = closeEvent.wasClean;
    } else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
const $d89a0c20337703ae$var$getStructuredSinkError = (error)=>{
    if ($d89a0c20337703ae$var$isGraphQLErrorArray(error)) {
        const [firstError] = error;
        // A real Error, not the raw payload element typed as one, so it carries a stack. AGG
        // sends these as JSON, so the element is a plain object however it is typed.
        const errorInfo = Object.assign(new Error(firstError === null || firstError === void 0 ? void 0 : firstError.message), {
            kind: 'graphql-errors',
            graphQLErrors: error
        });
        if (firstError !== null && firstError !== void 0 && firstError.stack) errorInfo.stack = firstError.stack;
        return errorInfo;
    }
    if (error instanceof Error) // Its own `wasClean`, where it has one, is left as it is rather than redefined.
    return $d89a0c20337703ae$var$withDetails(error, $d89a0c20337703ae$var$isCloseLike(error) ? {
        kind: 'close-event',
        closeCode: error.code
    } : {
        kind: 'error'
    });
    if ($d89a0c20337703ae$var$isCloseEvent(error)) return Object.assign(new Error(`CloseEvent: ${error.reason}`), {
        kind: 'close-event',
        closeCode: error.code,
        wasClean: error.wasClean
    });
    if ($d89a0c20337703ae$var$isErrorEvent(error)) return Object.assign(new Error(`ErrorEvent: "${error.error}"`), {
        kind: 'error-event'
    });
    if ($d89a0c20337703ae$var$isEventLike(error)) return Object.assign(new Error(`Event: ${error.type}`), {
        kind: 'event'
    });
    // `String` rather than interpolation, which throws for a symbol.
    const message = `Unknown sink error: ${String(error)}`;
    // A close with no `type`, such as "All Subscriptions Gone". The message stays as it was,
    // because consumers match on it.
    if ($d89a0c20337703ae$var$isCloseLike(error)) return Object.assign(new Error(message), {
        kind: 'close-event',
        closeCode: error.code,
        ...'wasClean' in error && typeof error.wasClean === 'boolean' ? {
            wasClean: error.wasClean
        } : {}
    });
    return Object.assign(new Error(message), {
        kind: 'unknown'
    });
};
const $d89a0c20337703ae$export$ece4736473c28965 = (error)=>{
    if ((0, $gdUUy.fg)('platform_relay_subscription_sink_error')) return $d89a0c20337703ae$var$getStructuredSinkError(error);
    // Gate off: legacy shape (no `kind`).
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $d89a0c20337703ae$var$getLegacySinkError(error);
};

});



parcelRegister("6undV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5444366b84c66fb6$export$2e2bcd8739ae039);
function $5444366b84c66fb6$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("fPhns", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $b63fec569c49bfb3$export$e7aa7bc5c1b3cfb3);

var $bWsVm = parcelRequire("bWsVm");

var $4270B = parcelRequire("4270B");

var $gdUUy = parcelRequire("gdUUy");

var $TvwfJ = parcelRequire("TvwfJ");

var $e0zRE = parcelRequire("e0zRE");

var $jDno0 = parcelRequire("jDno0");

var $4XXwT = parcelRequire("4XXwT");

var $fsh8e = parcelRequire("fsh8e");

var $fjTcf = parcelRequire("fjTcf");

var $8DT44 = parcelRequire("8DT44");

var $3RbRc = parcelRequire("3RbRc");

var $jsU08 = parcelRequire("jsU08");

var $dYqZf = parcelRequire("dYqZf");

var $lz3Qb = parcelRequire("lz3Qb");

var $90tZt = parcelRequire("90tZt");
const $b63fec569c49bfb3$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $b63fec569c49bfb3$var$moduleID = 'relay-fetch';
const $b63fec569c49bfb3$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    var _dependencies$didPref, _dependencies$getLogg, _cacheConfig$metadata;
    if ((dependencies === null || dependencies === void 0 || (_dependencies$didPref = dependencies.didPreflightAuthenticationCheckTriggerRedirect) === null || _dependencies$didPref === void 0 ? void 0 : _dependencies$didPref.call(dependencies, request, variables, cacheConfig)) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
    // while the redirect takes over instead of starting a fetch with a stale auth state.
    return (0, $4270B.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies === null || dependencies === void 0 || (_dependencies$getLogg = dependencies.getLoggingAndMetricsHelper) === null || _dependencies$getLogg === void 0 ? void 0 : _dependencies$getLogg.call(dependencies, loggingMetadata);
    // Per-query opt-in (cacheConfig.metadata.captureErrors) to forward this operation's response to
    // the product's capture callback, if one is provided. Whether to actually capture (feature gates,
    // etc.) is a product concern owned by the callback itself, not by this platform code.
    const shouldCaptureErrors = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.captureErrors) === true && !(dependencies !== null && dependencies !== void 0 && dependencies.isServer);
    let responseHeaders;
    function augmentResponse(response) {
        const traceIdFromHeader = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $gdUUy.fg)('platform_relay_fetch_traceid_header_fallback') && responseHeaders ? responseHeaders.get('atl-traceid') ?? undefined : undefined;
        (0, $4XXwT.addTraceId)(queryName, (0, $90tZt.getTraceIdFromExtensions)(response) ?? traceIdFromHeader);
        (0, $TvwfJ.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $4270B.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$b63fec569c49bfb3$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                var _dependencies$earlySc;
                const endpoint = (0, $e0zRE.getAggEndpoint)(request, cacheConfig);
                const body = (0, $e0zRE.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies !== null && dependencies !== void 0 && dependencies.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies !== null && dependencies !== void 0 && dependencies.getAbortSignal) options.signal = dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal();
                const fetchOverNetwork = (0, $8DT44.buildGraphqlSmartFetch)({
                    url: dependencies !== null && dependencies !== void 0 && dependencies.setEndpoint ? dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies === null || dependencies === void 0 || (_dependencies$earlySc = dependencies.earlyScriptPromise) === null || _dependencies$earlySc === void 0 ? void 0 : _dependencies$earlySc.call(dependencies, request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies !== null && dependencies !== void 0 && dependencies.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $3RbRc.processMultipartPromise)(()=>(0, $dYqZf.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $lz3Qb.shouldRetry),
                        retryAttempts: (0, $jsU08.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logErrorRetry
                    }), dependencies === null || dependencies === void 0 ? void 0 : dependencies.onFetchError, (headers)=>{
                    responseHeaders = headers;
                });
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $b63fec569c49bfb3$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $jDno0.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $jDno0.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $jDno0.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $b63fec569c49bfb3$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $fjTcf.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (shouldCaptureErrors && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.captureResponseErrors) === 'function') dependencies.captureResponseErrors(request, singularResponse);
                            if (dependencies !== null && dependencies !== void 0 && dependencies.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                var _dependencies$onInval;
                                dependencies === null || dependencies === void 0 || (_dependencies$onInval = dependencies.onInvalidResponse) === null || _dependencies$onInval === void 0 || _dependencies$onInval.call(dependencies, request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && requestID != null && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.queryResponseCache) !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $b63fec569c49bfb3$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && requestID != null) {
                var _dependencies$queryRe;
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies === null || dependencies === void 0 || (_dependencies$queryRe = dependencies.queryResponseCache) === null || _dependencies$queryRe === void 0 ? void 0 : _dependencies$queryRe.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($bWsVm)))(ssrCache)) {
                    var _dependencies$queryRe2;
                    // The cached payload is seeded into Relay below without passing through
                    // validateResponse, so capture its errors here instead.
                    if (shouldCaptureErrors && !Array.isArray(ssrCache) && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.captureResponseErrors) === 'function') dependencies.captureResponseErrors(request, ssrCache);
                    dependencies === null || dependencies === void 0 || (_dependencies$queryRe2 = dependencies.queryResponseCache) === null || _dependencies$queryRe2 === void 0 || _dependencies$queryRe2.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($b63fec569c49bfb3$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $fsh8e.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $fsh8e.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                var _dependencies$handleA;
                                dependencies === null || dependencies === void 0 || (_dependencies$handleA = dependencies.handleAbort) === null || _dependencies$handleA === void 0 || _dependencies$handleA.call(dependencies, request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("bWsVm", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $8b1b8c3e49d3a2d3$var$isNil(value) {
    return value == null;
}
module.exports = $8b1b8c3e49d3a2d3$var$isNil;

});

parcelRegister("TvwfJ", function(module, exports) {
$parcel$export(module.exports, "putExtensions", () => $6d10d6e041c5a516$export$17dc47fdf278de21);
const $6d10d6e041c5a516$var$OperationExtensionsMap = {};
const $6d10d6e041c5a516$export$8656ba3981c6f6c1 = (operationName)=>{
    $6d10d6e041c5a516$var$OperationExtensionsMap[operationName] = $6d10d6e041c5a516$var$OperationExtensionsMap[operationName] || [];
};
const $6d10d6e041c5a516$export$f16fa6040161f056 = (operationName)=>{
    $6d10d6e041c5a516$var$OperationExtensionsMap[operationName] = undefined;
};
const $6d10d6e041c5a516$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $6d10d6e041c5a516$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $6d10d6e041c5a516$export$7c6ea4184129ef74 = (operationName)=>$6d10d6e041c5a516$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("e0zRE", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $1a946ab1b39fe0ad$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $1a946ab1b39fe0ad$export$55bce18df99af758);

var $4eGW1 = parcelRequire("4eGW1");
const $1a946ab1b39fe0ad$var$branchSlug = typeof $4eGW1 !== 'undefined' && $4eGW1.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $1a946ab1b39fe0ad$var$serviceOverrides = typeof $4eGW1 !== 'undefined' && $4eGW1.env ? undefined : undefined;
const $1a946ab1b39fe0ad$export$8f8c52ac77845a86 = `/gateway/api/graphql${$1a946ab1b39fe0ad$var$branchSlug ? `/${$1a946ab1b39fe0ad$var$branchSlug}/graphql` : ''}`;
const $1a946ab1b39fe0ad$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    var _cacheConfig$metadata;
    let endpoint = $1a946ab1b39fe0ad$export$8f8c52ac77845a86;
    if ((_cacheConfig$metadata = cacheConfig.metadata) !== null && _cacheConfig$metadata !== void 0 && _cacheConfig$metadata.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($1a946ab1b39fe0ad$var$serviceOverrides) url = `${url}&serviceOverride=${$1a946ab1b39fe0ad$var$serviceOverrides}`;
    return url;
};
const $1a946ab1b39fe0ad$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("jDno0", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $d8ad20361899a4df$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $d8ad20361899a4df$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $d8ad20361899a4df$export$607b80f5bc6e396d = new Map();
const $d8ad20361899a4df$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("4XXwT", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIds", () => $996adb59070f0f09$export$a2bcb2fac360646c);
$parcel$export(module.exports, "addTraceId", () => $996adb59070f0f09$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $996adb59070f0f09$export$5113e470f5c95670);
const $996adb59070f0f09$var$OperationTraceIdMap = {};
const $996adb59070f0f09$export$a2bcb2fac360646c = (operationName)=>{
    $996adb59070f0f09$var$OperationTraceIdMap[operationName] = $996adb59070f0f09$var$OperationTraceIdMap[operationName] || [];
};
const $996adb59070f0f09$export$559128bdc4352001 = (operationName)=>{
    $996adb59070f0f09$var$OperationTraceIdMap[operationName] = undefined;
};
const $996adb59070f0f09$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $996adb59070f0f09$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $996adb59070f0f09$export$5113e470f5c95670 = (operationName)=>$996adb59070f0f09$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("fsh8e", function(module, exports) {
$parcel$export(module.exports, "getClientDispatcher", () => $246e5052b39586e6$export$5bb012cf9b3a5452);

var $gC63p = parcelRequire("gC63p");
const $246e5052b39586e6$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $246e5052b39586e6$var$dispatcher;
const $246e5052b39586e6$export$5bb012cf9b3a5452 = ()=>{
    if (!$246e5052b39586e6$var$dispatcher) {
        $246e5052b39586e6$var$dispatcher = new (0, $gC63p.ClientDispatcher)();
        // Handle the server hangup scenarios
        $246e5052b39586e6$var$dispatcher.register($246e5052b39586e6$export$eb5d9c90d65c7fea, $246e5052b39586e6$var$dispatcher._abort.bind($246e5052b39586e6$var$dispatcher));
    }
    return $246e5052b39586e6$var$dispatcher;
};

});
parcelRegister("gC63p", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $685c1d1d9e6261d4$export$3f5ba18eb97af725);
class $685c1d1d9e6261d4$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("fjTcf", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $e528edb0e2b6f5ac$export$bd50bc4cd3c601ee);
const $e528edb0e2b6f5ac$var$events = [];
const $e528edb0e2b6f5ac$export$bd50bc4cd3c601ee = (event)=>{
    $e528edb0e2b6f5ac$var$events.push(event);
};
const $e528edb0e2b6f5ac$export$3c7145db84d4587c = ()=>{
    return $e528edb0e2b6f5ac$var$events.splice(0, $e528edb0e2b6f5ac$var$events.length);
};

});

parcelRegister("8DT44", function(module, exports) {
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $c0af735d9f11087d$export$33c9c992c7855d86);

var $euGak = parcelRequire("euGak");

var $4sBOg = parcelRequire("4sBOg");

var $4zbRc = parcelRequire("4zbRc");

var $2y0K8 = parcelRequire("2y0K8");
const $c0af735d9f11087d$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $c0af735d9f11087d$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    var _cacheConfig$metadata;
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $c0af735d9f11087d$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $4sBOg.getRelayExperimentalApis)().join(','),
        ...(cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.headers) || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = (0, $2y0K8.shouldUseGetMethod)({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = (0, $4zbRc.buildGetUrl)(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("4zbRc", function(module, exports) {
$parcel$export(module.exports, "buildGetUrl", () => $7e6ddba25701c12f$export$28ae0033b80c6303);
function $7e6ddba25701c12f$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}

});

parcelRegister("2y0K8", function(module, exports) {
$parcel$export(module.exports, "shouldUseGetMethod", () => $291ab2d15231d9eb$export$5ad31d96a9271d42);

var $bDrdY = parcelRequire("bDrdY");

var $4zbRc = parcelRequire("4zbRc");

var $6Vbhl = parcelRequire("6Vbhl");
const $291ab2d15231d9eb$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $291ab2d15231d9eb$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
function $291ab2d15231d9eb$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $bDrdY.killswitch)('relay-get-queries')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = (0, $4zbRc.buildGetUrl)(baseUrl, variables).length;
    const headersSize = (0, $6Vbhl.calculateHeadersSize)(headers || {});
    return queryLength <= $291ab2d15231d9eb$var$MAX_QUERY_LENGTH && headersSize <= $291ab2d15231d9eb$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}

});
parcelRegister("bDrdY", function(module, exports) {
$parcel$export(module.exports, "killswitch", () => $41a53b79de6bad8f$export$fcfcaa5d2f57d3a7);

var $87QgR = parcelRequire("87QgR");
let $41a53b79de6bad8f$var$cachedNames;
const $41a53b79de6bad8f$var$isStringArray = (value)=>Array.isArray(value) && value.every((name)=>typeof name === 'string');
function $41a53b79de6bad8f$export$fcfcaa5d2f57d3a7(name) {
    if (!$41a53b79de6bad8f$var$cachedNames) {
        // Do not permanently cache the default before the host initializes the SDK.
        if (!(0, $87QgR.default).initializeCompleted()) return false;
        // Killswitches are operational controls and must not fire experiment exposures.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- shared dynamic config killswitch helper
        const config = (0, $87QgR.default).getExperimentValue('killswitch', 'value', [], {
            fireExperimentExposure: false,
            typeGuard: $41a53b79de6bad8f$var$isStringArray
        });
        // SDK mocks and config overrides can bypass the SDK's type guard.
        $41a53b79de6bad8f$var$cachedNames = new Set($41a53b79de6bad8f$var$isStringArray(config) ? config.map((entry)=>entry.toLowerCase()) : []);
    }
    return $41a53b79de6bad8f$var$cachedNames.has(name.toLowerCase());
}

});

parcelRegister("6Vbhl", function(module, exports) {
$parcel$export(module.exports, "calculateHeadersSize", () => $b1d0f56d03929529$export$dd754c3ef60c6999);
// Calculate the size of the headers
function $b1d0f56d03929529$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}

});



parcelRegister("3RbRc", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $3aa005931391d3b5$export$f76505a7f2969e4e);

var $4270B = parcelRequire("4270B");

var $gdUUy = parcelRequire("gdUUy");

var $bgamJ = parcelRequire("bgamJ");
const $3aa005931391d3b5$var$NO_CONTENT = 204;
function $3aa005931391d3b5$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $3aa005931391d3b5$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $3aa005931391d3b5$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $3aa005931391d3b5$var$getBoundary(contentType || '');
    if (!boundary) {
        $3aa005931391d3b5$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        (0, $bgamJ.processStream)(streamReader(), boundary, observer).catch((error)=>$3aa005931391d3b5$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $3aa005931391d3b5$var$emitError(observer, error, response, onFetchError);
    }
}
function $3aa005931391d3b5$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$3aa005931391d3b5$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $3aa005931391d3b5$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        var _response$headers;
        let traceId = '';
        if ((0, $gdUUy.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $3aa005931391d3b5$var$emitError(observer, error, response, onFetchError);
    });
}
function $3aa005931391d3b5$export$f76505a7f2969e4e(source, onFetchError, onResponseHeaders) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $4270B.Observable).create((observer)=>{
        result.then((response)=>{
            // Expose the response headers via a side-channel so the consumer can
            // read values such as `atl-traceid` without changing the payload emission shape.
            if ((0, $gdUUy.fg)('platform_relay_fetch_traceid_header_fallback')) onResponseHeaders === null || onResponseHeaders === void 0 || onResponseHeaders(response.headers);
            if (response.status === $3aa005931391d3b5$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $3aa005931391d3b5$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $3aa005931391d3b5$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $3aa005931391d3b5$var$handleMultipartResponse(response, observer, onFetchError);
            else $3aa005931391d3b5$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$3aa005931391d3b5$var$emitError(observer, error, undefined, onFetchError));
    });
}

});
parcelRegister("bgamJ", function(module, exports) {
$parcel$export(module.exports, "processStream", () => $79b9a4c7081c6733$export$efb69f1fe7577739);

var $dqQOY = parcelRequire("dqQOY");
async function $79b9a4c7081c6733$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = (0, $dqQOY.processChunk)(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) (0, $dqQOY.processChunk)(incompleteChunk, boundaryString, observer);
    observer.complete();
}

});
parcelRegister("dqQOY", function(module, exports) {
$parcel$export(module.exports, "processChunk", () => $8fca98fb1c04cf47$export$701544522b0c6c99);
function $8fca98fb1c04cf47$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}

});



parcelRegister("jsU08", function(module, exports) {
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $f2dcf2d31c965c25$export$9dec0f42cc67f6ab);

var $ajj5E = parcelRequire("ajj5E");
const $f2dcf2d31c965c25$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return 0, $ajj5E.RETRY_ATTEMPTS_LIMIT;
    return 0;
};

});
parcelRegister("ajj5E", function(module, exports) {
$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $105feb55577a9474$export$81189edc9b923717);
const $105feb55577a9474$export$81189edc9b923717 = 1;

});


parcelRegister("dYqZf", function(module, exports) {
$parcel$export(module.exports, "retryOnError", () => $b3e453c77090ce8c$export$f859c88bfac2cf2c);

var $ajj5E = parcelRequire("ajj5E");
const $b3e453c77090ce8c$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = (0, $ajj5E.RETRY_ATTEMPTS_LIMIT), onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > (0, $ajj5E.RETRY_ATTEMPTS_LIMIT) ? (0, $ajj5E.RETRY_ATTEMPTS_LIMIT) : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("lz3Qb", function(module, exports) {
$parcel$export(module.exports, "shouldRetry", () => $a042ee560c7be1b2$export$7bfea3c3d460ecd8);
const $a042ee560c7be1b2$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});

parcelRegister("90tZt", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $cba89ba004375e67$export$eefb7f54c3b07211);

var $gdUUy = parcelRequire("gdUUy");
const $cba89ba004375e67$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions == null || extensions.gateway == null) return undefined;
    if ((0, $gdUUy.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

});


parcelRegister("anIvV", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d0b23e1dea4950b$export$2e2bcd8739ae039);

var $4mToR = parcelRequire("4mToR");

var $6undV = parcelRequire("6undV");
const $1d0b23e1dea4950b$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $1d0b23e1dea4950b$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $1d0b23e1dea4950b$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $4mToR.JiraFilterAri).parse(id).filterId;
            if ($1d0b23e1dea4950b$var$isCustomFilter(filterId)) return (0, $6undV.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($1d0b23e1dea4950b$var$isSystemFilter(filterId)) return (0, $6undV.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $1d0b23e1dea4950b$var$MissingFieldHandlers = [
    $1d0b23e1dea4950b$export$77232ec02db7a24a
];
var $1d0b23e1dea4950b$export$2e2bcd8739ae039 = $1d0b23e1dea4950b$var$MissingFieldHandlers;

});
parcelRegister("4mToR", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $32e430c3bbede580$export$3cfb6cc809e835bd);

var $1zOWD = parcelRequire("1zOWD");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/jira/filter/manifest.ts
var $32e430c3bbede580$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1zOWD.JiraFilterAriResourceOwner),
    resourceType: (0, $1zOWD.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $32e430c3bbede580$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $32e430c3bbede580$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $32e430c3bbede580$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $32e430c3bbede580$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $32e430c3bbede580$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $32e430c3bbede580$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $32e430c3bbede580$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("1zOWD", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $126093e1f9e8b35d$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $126093e1f9e8b35d$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $126093e1f9e8b35d$export$e6199848f52f1119 = "jira", $126093e1f9e8b35d$export$3c64de4ae038e3ae = "filter";

});



parcelRegister("2oTJu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6d1f8052d9453c7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$e6d1f8052d9453c7$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $4Sf72.version) === 'undefined' || (0, $4Sf72.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).startTransition === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});

parcelRegister("b6ktr", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $7c287ad99c000bfc$export$10f5a0700f263f11);

var $4270B = parcelRequire("4270B");

var $gdUUy = parcelRequire("gdUUy");

var $heqZo = parcelRequire("heqZo");

var $5sp5V = parcelRequire("5sp5V");
const $7c287ad99c000bfc$var$channels = new Map();
function $7c287ad99c000bfc$var$stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null';
    if (Array.isArray(value)) return `[${value.map($7c287ad99c000bfc$var$stableStringify).join(',')}]`;
    const obj = value;
    const keys = Object.keys(obj).sort();
    return `{${keys.map((k)=>`${JSON.stringify(k)}:${$7c287ad99c000bfc$var$stableStringify(obj[k])}`).join(',')}}`;
}
function $7c287ad99c000bfc$var$channelKey(payload) {
    var _payload$extensions;
    return $7c287ad99c000bfc$var$stableStringify({
        pq: ((_payload$extensions = payload.extensions) === null || _payload$extensions === void 0 ? void 0 : _payload$extensions.pq) ?? null,
        operationName: payload.operationName ?? null,
        variables: payload.variables ?? null,
        extensions: payload.extensions ?? null
    });
}
let $7c287ad99c000bfc$var$cachedDefaultSubscribe;
function $7c287ad99c000bfc$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $7c287ad99c000bfc$var$cachedDefaultSubscribe !== 'undefined') return $7c287ad99c000bfc$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $4270B.Observable).create((sink)=>{
            var _cacheConfig$metadata, _subscribeOptions$onS;
            const client = (0, $heqZo.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.replay) || undefined;
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...(subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {},
                    ...replayExtensions
                }
            };
            subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions$onS === void 0 || _subscribeOptions$onS.call(subscribeOptions, payload);
            const key = $7c287ad99c000bfc$var$channelKey(payload);
            // Keep one cleanup policy for the entire observer lifetime.
            const guardChannelOwnership = !(0, $gdUUy.fg)('relay_subscription_cleanup_killswitch');
            const existingChannel = $7c287ad99c000bfc$var$channels.get(key);
            let joinedChannel = existingChannel;
            // Capture before failure; the channel may reopen first.
            const isNewChannel = !existingChannel;
            const observerCount = ((existingChannel === null || existingChannel === void 0 ? void 0 : existingChannel.sinks.size) ?? 0) + 1;
            // Reuse the product-level subscription reporter instead of a per-call metadata callback.
            const diagnosticsEnabled = (0, $gdUUy.fg)('platform_relay_subscription_reliability-additional');
            const diagnostics = diagnosticsEnabled && typeof (subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.onSubscriptionDiagnostic) === 'function' ? subscribeOptions.onSubscriptionDiagnostic : undefined;
            const report = (event)=>{
                try {
                    diagnostics === null || diagnostics === void 0 || diagnostics({
                        operationName: payload.operationName,
                        variables: payload.variables,
                        ...event
                    });
                } catch  {
                // Diagnostics must not interrupt subscriptions.
                }
            };
            if (diagnostics) report({
                type: 'attached',
                isNewChannel: isNewChannel,
                observerCount: observerCount,
                channelHasReceivedResponse: (existingChannel === null || existingChannel === void 0 ? void 0 : existingChannel.hasReceivedResponse) ?? false,
                socketState: (0, $heqZo.getSocketConnectionState)()
            });
            const removeConnected = diagnostics ? client.on('connected', ()=>report({
                    type: 'connected'
                })) : undefined;
            const removeClosed = diagnostics ? client.on('closed', ()=>report({
                    type: 'closed'
                })) : undefined;
            const detachDiagnostics = ()=>{
                removeConnected === null || removeConnected === void 0 || removeConnected();
                removeClosed === null || removeClosed === void 0 || removeClosed();
            };
            const localSink = {
                next: (value)=>{
                    if (diagnostics) {
                        var _extensions$gateway, _extensions$gateway2, _extensions$gateway3, _extensions$agg;
                        const extensions = value === null || value === void 0 ? void 0 : value.extensions;
                        const requestId = extensions === null || extensions === void 0 || (_extensions$gateway = extensions.gateway) === null || _extensions$gateway === void 0 ? void 0 : _extensions$gateway.request_id;
                        const traceId = (extensions === null || extensions === void 0 || (_extensions$gateway2 = extensions.gateway) === null || _extensions$gateway2 === void 0 ? void 0 : _extensions$gateway2.tId) ?? (extensions === null || extensions === void 0 || (_extensions$gateway3 = extensions.gateway) === null || _extensions$gateway3 === void 0 ? void 0 : _extensions$gateway3.trace_id);
                        const channel = extensions === null || extensions === void 0 || (_extensions$agg = extensions.agg) === null || _extensions$agg === void 0 ? void 0 : _extensions$agg.channel;
                        report({
                            type: 'response',
                            requestId: typeof requestId === 'string' ? requestId : null,
                            traceId: typeof traceId === 'string' ? traceId : null,
                            channel: typeof channel === 'string' ? channel : null
                        });
                    }
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (err, requestId)=>{
                    var _subscribeOptions$onS2;
                    report({
                        type: 'error',
                        requestId: requestId
                    });
                    detachDiagnostics();
                    sink.error(err);
                    subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS2 = subscribeOptions.onSubscribeError) === null || _subscribeOptions$onS2 === void 0 || _subscribeOptions$onS2.call(subscribeOptions, {
                        ...payload,
                        requestId: requestId,
                        isNewChannel: isNewChannel,
                        observerCount: observerCount
                    });
                },
                complete: ()=>{
                    var _sink$complete;
                    report({
                        type: 'completed'
                    });
                    detachDiagnostics();
                    (_sink$complete = sink.complete) === null || _sink$complete === void 0 || _sink$complete.call(sink);
                }
            };
            if (!existingChannel) {
                const newChannel = {
                    sinks: new Set([
                        localSink
                    ]),
                    dispose: ()=>{},
                    lastRequestId: null,
                    hasReceivedResponse: false
                };
                joinedChannel = newChannel;
                let terminated = false;
                newChannel.dispose = client.subscribe(payload, {
                    next: (value)=>{
                        var _value$extensions;
                        if (diagnosticsEnabled) newChannel.hasReceivedResponse = true;
                        // @ts-expect-error agg prop is missing on generic "extensions" type
                        const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                        if (aggRequestId) newChannel.lastRequestId = aggRequestId;
                        for (const s of Array.from(newChannel.sinks))try {
                            s.next(value);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    error: (sinkError)=>{
                        terminated = true;
                        const errorInfo = (0, $5sp5V.getSinkError)(sinkError);
                        const sinks = Array.from(newChannel.sinks);
                        const { lastRequestId: lastRequestId } = newChannel;
                        if (!guardChannelOwnership || $7c287ad99c000bfc$var$channels.get(key) === newChannel) $7c287ad99c000bfc$var$channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.error(errorInfo, lastRequestId);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    complete: ()=>{
                        terminated = true;
                        const sinks = Array.from(newChannel.sinks);
                        if (!guardChannelOwnership || $7c287ad99c000bfc$var$channels.get(key) === newChannel) $7c287ad99c000bfc$var$channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            var _s$complete;
                            (_s$complete = s.complete) === null || _s$complete === void 0 || _s$complete.call(s);
                        } catch  {
                        /* isolate sinks */ }
                    }
                });
                // A synchronous terminal callback may already have opened a replacement.
                // Register only a live channel, once its real disposer is available.
                if (!guardChannelOwnership || !terminated) $7c287ad99c000bfc$var$channels.set(key, newChannel);
            } else existingChannel.sinks.add(localSink);
            return ()=>{
                report({
                    type: 'disposed'
                });
                detachDiagnostics();
                const c = guardChannelOwnership ? joinedChannel : $7c287ad99c000bfc$var$channels.get(key);
                if (!c) return;
                const removed = c.sinks.delete(localSink);
                if (guardChannelOwnership && !removed) return;
                if (c.sinks.size === 0) {
                    if (!guardChannelOwnership || $7c287ad99c000bfc$var$channels.get(key) === c) $7c287ad99c000bfc$var$channels.delete(key);
                    try {
                        c.dispose();
                    } catch  {
                    /* upstream dispose errors must not break Relay teardown */ }
                }
            };
        });
    if (typeof subscribeOptions === 'undefined') $7c287ad99c000bfc$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $7c287ad99c000bfc$export$ec068583843480e7 = $7c287ad99c000bfc$export$10f5a0700f263f11();

});

parcelRegister("8HDp8", function(module, exports) {
$parcel$export(module.exports, "createRelayHandlerProvider", () => $551d7ca57bbab508$export$a40b5c8b00dd9369);

var $4270B = parcelRequire("4270B");

var $gdUUy = parcelRequire("gdUUy");

var $bPuc7 = parcelRequire("bPuc7");

var $fDPEv = parcelRequire("fDPEv");
function $551d7ca57bbab508$export$a40b5c8b00dd9369(source) {
    const DeleteRecordHandler = (0, $gdUUy.fg)('platform_relay_delete_record_handler') ? (0, $fDPEv.createDeleteRecordHandler)(source) : (0, $4270B.DefaultHandlerProvider)('deleteRecord');
    return (handle)=>{
        switch(handle){
            case 'deleteEdge':
                return 0, $bPuc7.DeleteEdgeHandler;
            case 'deleteRecord':
                return DeleteRecordHandler;
            default:
                return (0, $4270B.DefaultHandlerProvider)(handle);
        }
    };
}

});
parcelRegister("bPuc7", function(module, exports) {
$parcel$export(module.exports, "DeleteEdgeHandler", () => $1dabf1ec95464709$export$a2264b8f69028704);

var $4270B = parcelRequire("4270B");

var $jCkxO = parcelRequire("jCkxO");

var $jfv5h = parcelRequire("jfv5h");
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $1dabf1ec95464709$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $4270B.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
const $1dabf1ec95464709$export$a2264b8f69028704 = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $jCkxO.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $jfv5h.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $1dabf1ec95464709$var$deleteNode(connection, id);
            }
        });
    }
};

});
parcelRegister("jfv5h", function(module, exports) {
$parcel$export(module.exports, "default", () => $e03787b2e6b249c3$export$2e2bcd8739ae039);
var $e03787b2e6b249c3$var$isProduction = true;
function $e03787b2e6b249c3$var$warning(condition, message) {
    if (!$e03787b2e6b249c3$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $e03787b2e6b249c3$export$2e2bcd8739ae039 = $e03787b2e6b249c3$var$warning;

});


parcelRegister("fDPEv", function(module, exports) {
$parcel$export(module.exports, "createDeleteRecordHandler", () => $a5d7238a8ab46cdd$export$a61ecd985ed07422);
const $a5d7238a8ab46cdd$var$RELAY_DATA_ID_SEPARATOR = ':::::';
const $a5d7238a8ab46cdd$export$a61ecd985ed07422 = (source)=>({
        update: (store, payload)=>{
            const record = store.get(payload.dataID);
            if (record == null) return;
            const idOrIds = record.getValue(payload.fieldKey);
            const aris = Array.isArray(idOrIds) ? idOrIds : [
                idOrIds
            ];
            const idsInStore = source.getRecordIDs();
            const arisToDelete = aris.flatMap((id)=>{
                if (typeof id !== 'string') return [];
                const typeQualifiedPrefix = `${id}${$a5d7238a8ab46cdd$var$RELAY_DATA_ID_SEPARATOR}`;
                const matchingStoreIDs = idsInStore.filter((dataID)=>dataID.startsWith(typeQualifiedPrefix));
                return matchingStoreIDs;
            });
            arisToDelete.forEach((dataID)=>store.delete(dataID));
        }
    });

});


parcelRegister("7Je5m", function(module, exports) {
$parcel$export(module.exports, "ufoDataFetchHoldMiddleware", () => $e4a664ea8eb17887$export$3e78a79ab7bcbcc3);

var $4270B = parcelRequire("4270B");

var $4flmM = parcelRequire("4flmM");
const $e4a664ea8eb17887$var$HELD_INTERACTION_TYPES = [
    'press',
    'typing'
];
const $e4a664ea8eb17887$export$3e78a79ab7bcbcc3 = (next, options)=>(request, variables, cacheConfig, uploadables)=>{
        var _options$getIsEnabled;
        if ((options === null || options === void 0 || (_options$getIsEnabled = options.getIsEnabled) === null || _options$getIsEnabled === void 0 ? void 0 : _options$getIsEnabled.call(options)) !== true) return next(request, variables, cacheConfig, uploadables);
        const source = next(request, variables, cacheConfig, uploadables);
        if ('subscribe' in source) return (0, $4270B.Observable).create((sink)=>{
            const releaseHold = (0, $4flmM.startDataFetchHold)({
                label: `relay-${request.operationKind}`,
                // `as const` to ignore `no-literal-string-in-object`
                name: request.name,
                interactionTypes: $e4a664ea8eb17887$var$HELD_INTERACTION_TYPES
            });
            const subscription = source.subscribe(sink);
            return ()=>{
                try {
                    subscription.unsubscribe();
                } finally{
                    releaseHold === null || releaseHold === void 0 || releaseHold();
                }
            };
        });
        return source;
    };

});
parcelRegister("4flmM", function(module, exports) {
$parcel$export(module.exports, "startDataFetchHold", () => $e5bba2312da1366f$export$fbd04cc8165928ea);

var $juFEH = parcelRequire("juFEH");

var $5DSgV = parcelRequire("5DSgV");
function $e5bba2312da1366f$export$fbd04cc8165928ea({ label: label, name: name, interactionTypes: interactionTypes }) {
    const interaction = (0, $juFEH.getActiveInteraction)();
    if (!interaction || interaction.end !== 0) return;
    if (interactionTypes && !interactionTypes.includes(interaction.type)) return;
    const releaseHold = (0, $juFEH.addHold)(interaction.id, [
        {
            name: label
        }
    ], name, false);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        (0, $5DSgV.default)(()=>{
            releaseHold();
            (0, $juFEH.tryComplete)(interaction.id);
        });
    };
}

});



parcelRegister("e2CvF", function(module, exports) {
$parcel$export(module.exports, "resolveGetDataID", () => $e3584064fb2b22af$export$e6629d3c6f1259a8);
$parcel$export(module.exports, "default", () => $e3584064fb2b22af$export$2e2bcd8739ae039);

var $lFpPv = parcelRequire("lFpPv");

var $4270B = parcelRequire("4270B");

var $iW3CQ = parcelRequire("iW3CQ");

var $6undV = parcelRequire("6undV");

var $fN5wA = parcelRequire("fN5wA");

var $5yTAN = parcelRequire("5yTAN");

var $eO8XI = parcelRequire("eO8XI");

var $1g06R = parcelRequire("1g06R");
const $e3584064fb2b22af$var$fetchRelay = (params, variables, cacheConfig, uploadables)=>{
    const fetcher = (0, $iW3CQ.getIsPageServerSideRendered)() ? (0, $5yTAN.default) : (0, $fN5wA.default);
    return fetcher(params, variables, cacheConfig, uploadables);
};
const $e3584064fb2b22af$var$getNetWork = ()=>{
    if ((0, $1g06R.isSSR)()) return (0, $4270B.Network).create($e3584064fb2b22af$var$fetchRelay);
    return (0, $4270B.Network).create($e3584064fb2b22af$var$fetchRelay, (0, $eO8XI.subscribe));
};
const $e3584064fb2b22af$export$215146372577871a = new Set([
    'HelpObjectStoreEntityData',
    'JiraServiceManagementRequestType',
    'HelpObjectStorePortalGroup',
    'HelpObjectStoreKbCategories',
    'HelpObjectStoreRequestForm',
    'HelpObjectStoreHelpObject',
    'HelpObjectStorePortalGroupRequestForm',
    'HelpCenterPageParentReference'
]);
const $e3584064fb2b22af$var$getHelpObjectStoreDataID = (fieldValue, typeName)=>{
    if ($e3584064fb2b22af$export$215146372577871a.has(typeName)) return (0, $6undV.default)(fieldValue, typeName);
    // Mirror Relay's default id derivation for all other types. Copied the implementation from RelayDataID.
    const { id: id } = fieldValue;
    return id == null ? undefined : String(id);
};
const $e3584064fb2b22af$export$e6629d3c6f1259a8 = ()=>{
    if ((0, $lFpPv.isFixRelayIdConflictForHelpObjectStoreEnabled)()) return $e3584064fb2b22af$var$getHelpObjectStoreDataID;
    if ((0, $lFpPv.isFixRelayIdConflictInHelpCenter)()) return 0, $6undV.default;
    return undefined;
};
const $e3584064fb2b22af$var$getDataID = $e3584064fb2b22af$export$e6629d3c6f1259a8();
var // Export a singleton instance of Relay Environment configured with our network function:
$e3584064fb2b22af$export$2e2bcd8739ae039 = new (0, $4270B.Environment)({
    network: $e3584064fb2b22af$var$getNetWork(),
    store: new (0, $4270B.Store)(new (0, $4270B.RecordSource)()),
    ...$e3584064fb2b22af$var$getDataID ? {
        getDataID: $e3584064fb2b22af$var$getDataID
    } : {}
});

});
parcelRegister("fN5wA", function(module, exports) {
$parcel$export(module.exports, "default", () => $548a747ecab7a98f$export$2e2bcd8739ae039);

var $51XYw = parcelRequire("51XYw");

var $lAkwg = parcelRequire("lAkwg");
const $548a747ecab7a98f$var$fetchQuery = ({ operationKind: operationKind, id: id, name: name }, variables)=>{
    const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
    const AGG_PATH = (0, $lAkwg.default).getJsmScaleTestAggPath(id) ?? AGG_BASE_PATH;
    const body = JSON.stringify({
        variables: variables,
        operationName: name
    });
    return (0, $51XYw.fetchJson)(AGG_PATH, {
        body: body,
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            ...operationKind === 'mutation' && {
                'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
            },
            ...(0, $lAkwg.default).getHeaders()
        }
    });
};
var $548a747ecab7a98f$export$2e2bcd8739ae039 = $548a747ecab7a98f$var$fetchQuery;

});
parcelRegister("51XYw", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $0448c9281f717757$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $0448c9281f717757$export$6d71b655afe1638d);
$parcel$export(module.exports, "handleGraphQlErrors", () => $0448c9281f717757$export$e7e6c134f67b83b7);
$parcel$export(module.exports, "isFetchNetworkOrClientError", () => $0448c9281f717757$export$68d314c2a361832e);

var $4ZMmh = parcelRequire("4ZMmh");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
const $0448c9281f717757$var$NO_CONTENT = 204;
const $0448c9281f717757$var$NETWORK_ERROR_MESSAGE = 'Failed to fetch';
const $0448c9281f717757$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $0448c9281f717757$var$NETWORK_ERROR_CODE = 0;
class $0448c9281f717757$export$26e841bcf1aeb894 extends Error {
    constructor(message, status, filterFromSentry){
        super(message);
        this.status = status;
        this.filterFromSentry = filterFromSentry;
    }
}
const $0448c9281f717757$export$6d71b655afe1638d = (url, params)=>{
    return fetch(url, params).then($0448c9281f717757$var$handleErrors).then($0448c9281f717757$var$processResponseFromServer).then($0448c9281f717757$export$e7e6c134f67b83b7).catch($0448c9281f717757$var$handleNetworkErrors);
};
const $0448c9281f717757$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new $0448c9281f717757$export$26e841bcf1aeb894($0448c9281f717757$var$NETWORK_ERROR_MESSAGE, $0448c9281f717757$var$NETWORK_ERROR_CODE);
    throw err;
};
const $0448c9281f717757$var$handleErrors = (response)=>{
    if (!response.ok) {
        const traceId = response.headers.get('atl-traceid');
        // If the traceId is null, it indicates that the request never reached the Atlassian network. In such cases, we should not throw an error. This situation may occur if the request has been intercepted by a firewall or another proxy server. For more details, refer to the discussion in the following Slack thread: https://atlassian.slack.com/archives/C06Q6AC22MV/p1711342785804189?thread_ts=1711335142.173669&cid=C06Q6AC22MV
        if (!traceId) // If the request does not have a traceId we treat it as a network error.
        throw new $0448c9281f717757$export$26e841bcf1aeb894($0448c9281f717757$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $0448c9281f717757$var$NETWORK_ERROR_CODE);
        if (traceId) // We filter out network errors with traceId from Sentry as they are not actionable and can be investigated from Splunk.
        throw new $0448c9281f717757$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: ${traceId}`, response.status, true);
        throw new $0448c9281f717757$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: null`, response.status);
    }
    return response;
};
const $0448c9281f717757$var$processResponseFromServer = (response)=>{
    if (response.status === $0448c9281f717757$var$NO_CONTENT) return Promise.resolve(null);
    return response.json();
};
const $0448c9281f717757$export$e7e6c134f67b83b7 = (response)=>{
    const dataEmptyCheck = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && response && typeof response === 'object' && 'data' in response ? (0, $4ZMmh.isEmpty)(response.data) : true;
    if (response && typeof response === 'object' && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('errors') && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('extensions') && dataEmptyCheck) {
        var _graphQlResponse$exte, _graphQlResponse$erro3, _graphQlResponse$erro4;
        // throw error from graphql API
        const graphQlResponse = response;
        const traceId = (_graphQlResponse$exte = graphQlResponse.extensions) === null || _graphQlResponse$exte === void 0 || (_graphQlResponse$exte = _graphQlResponse$exte.gateway) === null || _graphQlResponse$exte === void 0 ? void 0 : _graphQlResponse$exte.request_id;
        if (traceId) {
            var _graphQlResponse$erro, _graphQlResponse$erro2;
            throw new $0448c9281f717757$export$26e841bcf1aeb894(`ErrorCode: ${(_graphQlResponse$erro = graphQlResponse.errors) === null || _graphQlResponse$erro === void 0 || (_graphQlResponse$erro = _graphQlResponse$erro[0]) === null || _graphQlResponse$erro === void 0 ? void 0 : _graphQlResponse$erro.message}, traceId: ${traceId}`, Number((_graphQlResponse$erro2 = graphQlResponse.errors) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2[0]) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2.extensions) === null || _graphQlResponse$erro2 === void 0 ? void 0 : _graphQlResponse$erro2.statusCode) || 500, true);
        }
        throw new $0448c9281f717757$export$26e841bcf1aeb894(`Error: ${(_graphQlResponse$erro3 = graphQlResponse.errors) === null || _graphQlResponse$erro3 === void 0 || (_graphQlResponse$erro3 = _graphQlResponse$erro3[0]) === null || _graphQlResponse$erro3 === void 0 ? void 0 : _graphQlResponse$erro3.message}, traceId: null`, Number((_graphQlResponse$erro4 = graphQlResponse.errors) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4[0]) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4.extensions) === null || _graphQlResponse$erro4 === void 0 ? void 0 : _graphQlResponse$erro4.statusCode) || 500);
    }
    return response;
};
const $0448c9281f717757$export$ad8c5cf7dd4c3caf = (err)=>{
    return err.status === $0448c9281f717757$var$NETWORK_ERROR_CODE;
};
const $0448c9281f717757$export$fa5c2d120eda5e1c = (err)=>{
    return err.status < 500;
};
const $0448c9281f717757$export$68d314c2a361832e = (err)=>{
    return $0448c9281f717757$export$ad8c5cf7dd4c3caf(err) || $0448c9281f717757$export$fa5c2d120eda5e1c(err);
};

});

parcelRegister("lAkwg", function(module, exports) {
$parcel$export(module.exports, "default", () => $022437c0bddaad79$export$2e2bcd8739ae039);

var $51XYw = parcelRequire("51XYw");

var $lFpPv = parcelRequire("lFpPv");

var $iW3CQ = parcelRequire("iW3CQ");
const $022437c0bddaad79$var$JSM_SCALE_TEST_AGG_BRANCH_SLUG = 'branch-issue-remove-rate-limit';
const $022437c0bddaad79$var$isJsmScaleTestAggOverrideEnabled = ()=>(0, $lFpPv.isJsmScale60KAggBranchOverrideInHelpCenterEnabled)() && (0, $iW3CQ.getEnv)().environment !== (0, $iW3CQ.EnvType).PROD;
const $022437c0bddaad79$var$getJsmScaleTestAggPath = (id)=>{
    if (!$022437c0bddaad79$var$isJsmScaleTestAggOverrideEnabled()) return null;
    return id ? `/gateway/api/graphql/${$022437c0bddaad79$var$JSM_SCALE_TEST_AGG_BRANCH_SLUG}/graphql/pq/${id}` : `/gateway/api/graphql/${$022437c0bddaad79$var$JSM_SCALE_TEST_AGG_BRANCH_SLUG}/graphql`;
};
const $022437c0bddaad79$var$setEndpoint = (endpoint)=>{
    $022437c0bddaad79$var$isJsmScaleTestAggOverrideEnabled();
    return endpoint;
};
const $022437c0bddaad79$var$EDGE_FALLBACK_HEADER = {
    'X-Edge-Fallback-To-Unidentified': 'true'
};
const $022437c0bddaad79$var$getHeaders = ()=>({
        ...$022437c0bddaad79$var$EDGE_FALLBACK_HEADER
    });
// Refactored from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/92866a25d86943454624c5ac4fe38a59a17ed7d1/help-center/packages/util/fetch/fetch.tsx#fetch.tsx-51:66
const $022437c0bddaad79$var$NETWORK_ERROR_CODE = 0;
const $022437c0bddaad79$var$NETWORK_ERROR_MESSAGE = 'Failed to fetch';
const $022437c0bddaad79$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $022437c0bddaad79$var$validateResponse = (_request, gqlData)=>{
    if (typeof gqlData === 'object' && typeof gqlData.data === 'undefined') {
        var _gqlData$extensions;
        const traceId = (_gqlData$extensions = gqlData.extensions) === null || _gqlData$extensions === void 0 || (_gqlData$extensions = _gqlData$extensions.gateway) === null || _gqlData$extensions === void 0 ? void 0 : _gqlData$extensions.request_id;
        const statusCode = $022437c0bddaad79$var$getErrorStatusCode('errors' in gqlData && gqlData.errors || []);
        if (typeof traceId === 'undefined') throw new (0, $51XYw.FetchError)($022437c0bddaad79$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $022437c0bddaad79$var$NETWORK_ERROR_CODE);
        if (traceId) throw new (0, $51XYw.FetchError)(`ErrorCode: ${statusCode}, traceId: ${traceId}`, statusCode, true);
    }
    // This function returns the response but this unused.
    // All that we rely upon is thrown errors to ensure that there aren't any problems with the response.
    (0, $51XYw.handleGraphQlErrors)(gqlData);
    // This returns true as the response will be valid if an error is not thrown above.
    return true;
};
function $022437c0bddaad79$var$errorHasAggErrorExtension(err) {
    if (typeof err !== 'object' || err === null) return false;
    if ('extensions' in err === false || typeof err !== 'object' || err === null) return false;
    if (typeof err.extensions !== 'object' || err.extensions === null || 'statusCode' in err.extensions === false) return false;
    return typeof err.extensions.statusCode === 'number';
}
function $022437c0bddaad79$var$getErrorStatusCode(errors) {
    var _errorExtension$exten;
    if (Array.isArray(errors) === false) return 200;
    const errorExtension = errors.find($022437c0bddaad79$var$errorHasAggErrorExtension);
    if (typeof (errorExtension === null || errorExtension === void 0 || (_errorExtension$exten = errorExtension.extensions) === null || _errorExtension$exten === void 0 ? void 0 : _errorExtension$exten.statusCode) !== 'number') return 500;
    return errorExtension.extensions.statusCode;
}
/**
 * Product hook for `ExternalDependencies['onFetchError']` in `platform/packages/relay/relay-fetch/src/multi-fetch.ts`.
 * Called whenever the relay fetch pipeline is about to surface an error to Relay.
 *
 * Help-center's error filtering (see `help-center/packages/util/fetch/fetch.tsx`:
 * `isFetchClientError`/`isFetchNetworkOrClientError`) keys off `FetchError.status`. Errors emitted from the platform
 * `handleTextResponse` /`handleJsonResponse` catch blocks are plain `Error`s with no `status` attached, which means
 * downstream filtering treats them as unclassified server errors and incorrectly fails the view-help-center SLO for
 * upstream proxy/CDN responses (e.g. an HTML `405 Method Not Allowed` page).
 *
 * We wrap any non-`FetchError` error into a `FetchError` so the existing classification pipeline applies.
 *
 * Errors surfaced before an HTTP `Response` was received (e.g. network failure) have `response === undefined`. The
 * shared relay environment runs the platform `relay-fetch` pipeline, which does NOT route through help-center's
 * `fetchJson`/`handleNetworkErrors`, so we must replicate that conversion here: the browser surfaces network failures
 * as a raw `TypeError` ("Failed to fetch") with no `status`. Left unwrapped, it reaches `isFetchNetworkOrClientError`
 * with `status === undefined`, is misclassified as a server error, and incorrectly fails the view-help-center premium
 * SLO. We wrap it into a `FetchError(NETWORK_ERROR_MESSAGE, NETWORK_ERROR_CODE)` (status `0`) so it is classified as a
 * network error and filtered out — matching the legacy (non-shared) relay environment behaviour. Non-`TypeError`
 * pre-response errors are left unchanged, mirroring `handleNetworkErrors`.
 */ const $022437c0bddaad79$var$onFetchError = (error, response)=>{
    if (!response) {
        if (error instanceof TypeError) return new (0, $51XYw.FetchError)($022437c0bddaad79$var$NETWORK_ERROR_MESSAGE, $022437c0bddaad79$var$NETWORK_ERROR_CODE);
        return error;
    }
    if (error instanceof (0, $51XYw.FetchError)) return error;
    const message = error instanceof Error ? error.message : String(error);
    const filterFromSentry = Boolean(response.headers.get('atl-traceid'));
    return new (0, $51XYw.FetchError)(message, response.status, filterFromSentry);
};
var $022437c0bddaad79$export$2e2bcd8739ae039 = {
    setEndpoint: $022437c0bddaad79$var$setEndpoint,
    getJsmScaleTestAggPath: $022437c0bddaad79$var$getJsmScaleTestAggPath,
    getHeaders: $022437c0bddaad79$var$getHeaders,
    validateResponse: $022437c0bddaad79$var$validateResponse,
    onFetchError: $022437c0bddaad79$var$onFetchError,
    getErrorStatusCode: $022437c0bddaad79$var$getErrorStatusCode,
    errorHasAggErrorExtension: $022437c0bddaad79$var$errorHasAggErrorExtension
};

});


parcelRegister("5yTAN", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c52aff716711f7b$export$2e2bcd8739ae039);

var $4ZMmh = parcelRequire("4ZMmh");

var $4270B = parcelRequire("4270B");

var $51XYw = parcelRequire("51XYw");

var $lAkwg = parcelRequire("lAkwg");

var $jRsLy = parcelRequire("jRsLy");
const $5c52aff716711f7b$export$aa8bf897e49821c3 = new Set();
const $5c52aff716711f7b$var$fetchQuery = (request, variables)=>{
    return (0, $4270B.Observable).create((sink)=>{
        const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
        const cachedResponse = requestID ? (0, $jRsLy.QueryResponseCache).get(requestID, variables) : undefined;
        /**
     * If we're on the client and we have a cached response, return it immediately.
     */ if (!(0, $4ZMmh.isNil)(cachedResponse)) {
            if (requestID != null) (0, $jRsLy.QueryResponseCache).delete(requestID, variables);
            sink.next(cachedResponse);
            sink.complete();
            return;
        }
        const { id: id, operationKind: operationKind, name: queryName } = request;
        const metaData = {
            queryName: queryName,
            operationKind: operationKind
        };
        const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
        const AGG_PATH = (0, $lAkwg.default).getJsmScaleTestAggPath(id) ?? AGG_BASE_PATH;
        const body = JSON.stringify({
            variables: variables
        });
        const promise = (0, $51XYw.fetchJson)(`${AGG_PATH}`, {
            body: body,
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                ...operationKind === 'mutation' && {
                    'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
                },
                ...(0, $lAkwg.default).getHeaders()
            }
        });
        promise.then((response)=>{
            sink.next(response);
            sink.complete();
            return response;
        }).catch((error)=>{
            sink.error(error);
        });
    });
};
var $5c52aff716711f7b$export$2e2bcd8739ae039 = $5c52aff716711f7b$var$fetchQuery;

});
parcelRegister("jRsLy", function(module, exports) {
$parcel$export(module.exports, "QueryResponseCache", () => $8edb49104e21b267$export$688bd21be71b9e5d);
/**
 * This implementation is copied from Jira frontend.
 */ 
var $4270B = parcelRequire("4270B");

var $a6ENB = parcelRequire("a6ENB");
const $8edb49104e21b267$var$CACHE_NAME = 'RELAY_SSR_CACHE';
const $8edb49104e21b267$export$611736262b635f8d = (queryID, variables)=>JSON.stringify((0, $4270B.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
const $8edb49104e21b267$export$1e65e863cf3a0f21 = (cacheKey)=>JSON.parse(cacheKey).queryID;
class $8edb49104e21b267$export$be21c283b097d175 extends (0, $4270B.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        // Load cached data from the server, if available
        let spaState = {};
        {
            var _document$getElementB;
            const spaStateFromServer = (_document$getElementB = document.getElementById('spa-state')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.getAttribute('data-state');
            try {
                spaState = spaStateFromServer ? JSON.parse(decodeURIComponent(spaStateFromServer)) : {};
            } catch (err) {
                (0, $a6ENB.reportError)(err);
            }
        }
        const cachedData = spaState[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(undefined);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        setTimeout(()=>{
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $8edb49104e21b267$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $8edb49104e21b267$export$688bd21be71b9e5d = new $8edb49104e21b267$export$be21c283b097d175({
    cacheName: $8edb49104e21b267$var$CACHE_NAME,
    size: Infinity,
    ttl: Infinity
});
const $8edb49104e21b267$export$de9cebd147177ad2 = ()=>$8edb49104e21b267$export$688bd21be71b9e5d.serialize();

});


parcelRegister("eO8XI", function(module, exports) {
$parcel$export(module.exports, "subscribeOptions", () => $170da13669225f64$export$9bdaf447ae2b3b45);
$parcel$export(module.exports, "subscribe", () => $170da13669225f64$export$ec068583843480e7);

var $4270B = parcelRequire("4270B");

var $iRD29 = parcelRequire("iRD29");

var $a7v7n = parcelRequire("a7v7n");
const $170da13669225f64$export$9bdaf447ae2b3b45 = {
    extensions: {},
    onTrigger: (payload)=>(0, $iRD29.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'triggered',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                ...payload
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        }),
    onError: (payload)=>(0, $iRD29.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'failed',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                operationName: payload.operationName,
                requestId: payload.requestId
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        })
};
const $170da13669225f64$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $4270B.Observable).create((sink)=>{
        const client = (0, $a7v7n.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            operationName: operationName,
            variables: variables,
            query: '',
            extensions: {
                pq: id,
                ...$170da13669225f64$export$9bdaf447ae2b3b45.extensions
            }
        };
        let requestId;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $170da13669225f64$export$9bdaf447ae2b3b45.onTrigger(payload);
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                var _value$extensions;
                const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                requestId = aggRequestId ?? requestId;
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = $170da13669225f64$export$ece4736473c28965(sinkError);
                sink.error(errorInfo);
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                $170da13669225f64$export$9bdaf447ae2b3b45.onError({
                    operationName: operationName,
                    requestId: requestId
                });
            }
        });
    });
const $170da13669225f64$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
    else // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});
parcelRegister("a7v7n", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $3c2eb30132adfb3e$export$6bb76d6eba7e258c);

var $5FQ3H = parcelRequire("5FQ3H");

var $1g06R = parcelRequire("1g06R");
let $3c2eb30132adfb3e$var$client = null;
const $3c2eb30132adfb3e$export$6bb76d6eba7e258c = ()=>{
    if ((0, $1g06R.isSSR)()) return null;
    if ($3c2eb30132adfb3e$var$client == null) $3c2eb30132adfb3e$var$client = (0, $5FQ3H.createClient)({
        url: (0, $1g06R.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $1g06R.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $1g06R.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend'
        }
    });
    return $3c2eb30132adfb3e$var$client;
};
const $3c2eb30132adfb3e$export$2f0afd443356d36f = ()=>{
    $3c2eb30132adfb3e$var$client = null;
};

});
parcelRegister("1g06R", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $b37dc8df1a6a4f1f$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $b37dc8df1a6a4f1f$export$29a72e89601dfc59);
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $b37dc8df1a6a4f1f$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $b37dc8df1a6a4f1f$export$bf6cd96e19b2987f);
const $b37dc8df1a6a4f1f$export$48d7c418edadb60c = ()=>false ?? false;
const $b37dc8df1a6a4f1f$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
const $b37dc8df1a6a4f1f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $b37dc8df1a6a4f1f$export$bf6cd96e19b2987f = 100;

});




parcelRegister("dvY3d", function(module, exports) {
$parcel$export(module.exports, "getRelayDataId", () => $acbda461dbddb8dd$export$944f9dc3d03637c3);

var $lFpPv = parcelRequire("lFpPv");

var $6undV = parcelRequire("6undV");
const $acbda461dbddb8dd$export$944f9dc3d03637c3 = (id, typeName)=>{
    if ((0, $lFpPv.isFixRelayIdConflictInHelpCenter)()) return (0, $6undV.default)({
        id: id
    }, typeName);
    return id;
};

});




parcelRegister("82SlT", function(module, exports) {
$parcel$export(module.exports, "loginConsentEpic", () => $e242e45710e1bf2e$export$90c588d343cf5f98);

var $8jOUp = parcelRequire("8jOUp");

var $bi2A1 = parcelRequire("bi2A1");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("dvibe");
var $kloWR = parcelRequire("kloWR");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $oORS9 = parcelRequire("oORS9");
const $e242e45710e1bf2e$export$90c588d343cf5f98 = (action$)=>{
    return action$.ofType((0, $kloWR.LOGIN_CONSENT)).mergeMap((action)=>{
        const { param: param } = action.payload;
        return (0, $bi2A1.loginConsent)(param).mergeMap(({ response: response })=>{
            (0, $gYDJY.replace)(response.uri);
            return (0, $8jOUp.Observable).empty();
        }).catch(()=>{
            (0, $eDcdn.default).push((0, $oORS9.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
            return (0, $8jOUp.Observable).of((0, $xAy39.loginConsentFailure)());
        });
    });
};

});
parcelRegister("bi2A1", function(module, exports) {
$parcel$export(module.exports, "loginConsent", () => $9222cfcc09a2a456$export$fd88d7fe0deeba34);

var $llRGw = parcelRequire("llRGw");
const $9222cfcc09a2a456$export$fd88d7fe0deeba34 = (param)=>{
    const uri = `/jsd-login-v2/v2/customer/login/fedramp/consent${param}`;
    const body = {
        fedrampConsent: 'provided'
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers);
};

});

parcelRegister("dvibe", function(module, exports) {
$parcel$export(module.exports, "loginConsentAction", () => (parcelRequire("kloWR")).loginConsentAction);
$parcel$export(module.exports, "LOGIN_CONSENT", () => (parcelRequire("kloWR")).LOGIN_CONSENT);

var $kloWR = parcelRequire("kloWR");

});
parcelRegister("kloWR", function(module, exports) {
$parcel$export(module.exports, "LOGIN_CONSENT", () => $34c98c481b9350f9$export$12110c14f93a926f);
$parcel$export(module.exports, "loginConsentAction", () => $34c98c481b9350f9$export$684d17f74d8831a7);
const $34c98c481b9350f9$export$12110c14f93a926f = 'state.ui.LOGIN_CONSENT';
const $34c98c481b9350f9$export$684d17f74d8831a7 = (param)=>{
    return {
        payload: {
            param: param
        },
        type: $34c98c481b9350f9$export$12110c14f93a926f
    };
};

});



parcelRegister("9yiUM", function(module, exports) {
$parcel$export(module.exports, "logOutEpic", () => $5a77878e02e8f76d$export$c4456f69976aae9b);

var $8jOUp = parcelRequire("8jOUp");

var $iHzDl = parcelRequire("iHzDl");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");

var $3kjRG = parcelRequire("3kjRG");

var $gYDJY = parcelRequire("gYDJY");

var $oORS9 = parcelRequire("oORS9");

var $4pKDb = parcelRequire("4pKDb");
const $5a77878e02e8f76d$var$AA_LOGOUT_REDIRECT_URL = `/logout?dest-url=${encodeURIComponent(`${(0, $eDcdn.getRelativeBasePath)()}${(0, $oORS9.getHelpCenterUrl)()}`)}`;
const $5a77878e02e8f76d$export$8931338e80b3349d = (state)=>{
    if ((0, $fBLyB.isAtlassianAccountManaged)(state)) // no need to call Jira to log out Atlassian accounts. Simply redirect to AA logout page
    return (0, $8jOUp.Observable).of({
        logoutRedirectUrl: $5a77878e02e8f76d$var$AA_LOGOUT_REDIRECT_URL
    });
    return (0, $iHzDl.logoutUsingIdentity)(`${(0, $fOlM6.getBaseUrl)(state)}${$5a77878e02e8f76d$var$getAfterLogoutUrl(state)}`);
};
const $5a77878e02e8f76d$export$c4456f69976aae9b = (action$, store)=>{
    return action$.ofType((0, $4pKDb.LOG_OUT)).mergeMap(()=>{
        const state = store.getState();
        // Removing cached response of help-seeker-type on logout
        (0, $3kjRG.removeLocalStorageItem)('help-seeker-type');
        return $5a77878e02e8f76d$export$8931338e80b3349d(state).mergeMap((response)=>{
            // We do a full page load to the login or help center page to clear out the redux store and avoid
            // data for one user being seen by another if one logs out and another logs in in the same tab
            (0, $gYDJY.assign)($5a77878e02e8f76d$var$getLogoutDestination(state, response));
            return (0, $8jOUp.Observable).empty();
        }).catch((error)=>{
            return $5a77878e02e8f76d$var$handleLogoutError(error);
        });
    });
};
function $5a77878e02e8f76d$var$handleLogoutError(error) {
    (0, $jBiia.trackError)('session.logout.failed', {}, error);
    (0, $gYDJY.reload)();
    return (0, $8jOUp.Observable).empty();
}
function $5a77878e02e8f76d$var$getAfterLogoutUrl(state) {
    if ((0, $fOlM6.getIsAnonymousEnabled)(state)) return (0, $oORS9.getHelpCenterUrl)();
    return (0, $oORS9.getLoginUrlForPortalId)((0, $9Yoxp.getPortalId)(state));
}
function $5a77878e02e8f76d$var$getLogoutDestination(state, logoutResponseBody) {
    if (logoutResponseBody && logoutResponseBody.logoutRedirectUrl) return logoutResponseBody.logoutRedirectUrl;
    return `${(0, $eDcdn.getBaseName)()}${$5a77878e02e8f76d$var$getAfterLogoutUrl(state)}`;
}

});
parcelRegister("iHzDl", function(module, exports) {
$parcel$export(module.exports, "logoutUsingIdentity", () => $2596f61f6e7b01f4$export$7d7e0f6e9da553cb);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $jBiia = parcelRequire("jBiia");

var $gEVth = parcelRequire("gEVth");

var $eDcdn = parcelRequire("eDcdn");
const $2596f61f6e7b01f4$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'logout',
        source: 'unknownSource'
    };
};
const $2596f61f6e7b01f4$export$7d7e0f6e9da553cb = (redirectUrl, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/jsd-login-v2/v2/customer/logout?continue=${redirectUrl}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri).do((ajaxResponse)=>{
        (0, $gEVth.operationalEvent)($2596f61f6e7b01f4$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString()
        }));
    }, (ajaxError)=>{
        var _ajaxError$response;
        (0, $gEVth.operationalEvent)($2596f61f6e7b01f4$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorKey: (_ajaxError$response = ajaxError.response) === null || _ajaxError$response === void 0 ? void 0 : _ajaxError$response.key
        }));
        (0, $jBiia.trackError)('session.logout.failed', {}, ajaxError);
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};

});

parcelRegister("1xrTy", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => (parcelRequire("9Yoxp")).getPathname);
$parcel$export(module.exports, "getPortalId", () => (parcelRequire("9Yoxp")).getPortalId);

var $9Yoxp = parcelRequire("9Yoxp");

});
parcelRegister("9Yoxp", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => $a4ed40926727360f$export$b829272b1dcc6798);
$parcel$export(module.exports, "getPortalId", () => $a4ed40926727360f$export$79c9b12a0a57147a);
const $a4ed40926727360f$export$f71e6ac2c1d88be0 = (state)=>state.ui.context.portalId !== undefined && state.ui.context.portalId !== null && !isNaN(state.ui.context.portalId);
const $a4ed40926727360f$export$b829272b1dcc6798 = (state)=>state.ui.context.pathname;
const $a4ed40926727360f$export$6c570a1091322ad4 = (state)=>state.ui.context.routeName;
const $a4ed40926727360f$export$79c9b12a0a57147a = (state)=>{
    if (!$a4ed40926727360f$export$f71e6ac2c1d88be0(state)) return undefined;
    return state.ui.context.portalId;
};

});


parcelRegister("6GvED", function(module, exports) {
$parcel$export(module.exports, "getWacLink", () => (parcelRequire("fOlM6")).getWacLink);
$parcel$export(module.exports, "getHeadless", () => (parcelRequire("fOlM6")).getHeadless);
$parcel$export(module.exports, "getServiceDeskVersion", () => (parcelRequire("fOlM6")).getServiceDeskVersion);
$parcel$export(module.exports, "getXsrfToken", () => (parcelRequire("fOlM6")).getXsrfToken);
$parcel$export(module.exports, "getBaseUrl", () => (parcelRequire("fOlM6")).getBaseUrl);
$parcel$export(module.exports, "getContactLink", () => (parcelRequire("fOlM6")).getContactLink);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => (parcelRequire("fOlM6")).getIsAnonymousEnabled);
$parcel$export(module.exports, "getFabricEmojiUrl", () => (parcelRequire("fOlM6")).getFabricEmojiUrl);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => (parcelRequire("fOlM6")).getJsmAIConfigEnabled);
$parcel$export(module.exports, "getJiraDisplayUrl", () => (parcelRequire("fOlM6")).getJiraDisplayUrl);

var $fOlM6 = parcelRequire("fOlM6");

});
parcelRegister("fOlM6", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskVersion", () => $e9f3e5798053f487$export$cf63d87096689a17);
$parcel$export(module.exports, "getWacLink", () => $e9f3e5798053f487$export$94833c7df37d6b17);
$parcel$export(module.exports, "getHeadless", () => $e9f3e5798053f487$export$915f62c9c01bc3d6);
$parcel$export(module.exports, "getXsrfToken", () => $e9f3e5798053f487$export$14407a25c57e1f92);
$parcel$export(module.exports, "getContactLink", () => $e9f3e5798053f487$export$a204de3b9df9c687);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => $e9f3e5798053f487$export$10062cf4ec7decdd);
$parcel$export(module.exports, "getFabricEmojiUrl", () => $e9f3e5798053f487$export$81a8d16acc87f947);
$parcel$export(module.exports, "getBaseUrl", () => $e9f3e5798053f487$export$f654b28f82155665);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $e9f3e5798053f487$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $e9f3e5798053f487$export$9679fa5312e1354b);
const $e9f3e5798053f487$export$cf63d87096689a17 = (state)=>state.persisted.env.serviceDeskVersion;
const $e9f3e5798053f487$export$94833c7df37d6b17 = (state)=>state.persisted.env.wacLink;
const $e9f3e5798053f487$export$915f62c9c01bc3d6 = (state)=>state.persisted.env.headless;
const $e9f3e5798053f487$export$14407a25c57e1f92 = (state)=>state.persisted.env.xsrfToken;
const $e9f3e5798053f487$export$a204de3b9df9c687 = (state)=>state.persisted.env.contactLink;
const $e9f3e5798053f487$export$10062cf4ec7decdd = (state)=>state.persisted.env.anonymousEnabled;
const $e9f3e5798053f487$export$81a8d16acc87f947 = (state)=>state.persisted.env.fabricEmojiUrl;
const $e9f3e5798053f487$export$f654b28f82155665 = (state)=>state.persisted.env.baseUrl;
const $e9f3e5798053f487$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $e9f3e5798053f487$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $e9f3e5798053f487$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $e9f3e5798053f487$export$23a8be9c477ed0ba = (state)=>state.persisted.env.hoistedProjectId;
const $e9f3e5798053f487$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;
const $e9f3e5798053f487$export$16e2ca57934a087e = (state)=>state.persisted.env.customerAccountAvailabilty;

});


parcelRegister("aI0YR", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => (parcelRequire("fBLyB")).getLocale);
$parcel$export(module.exports, "getAvatar", () => (parcelRequire("fBLyB")).getAvatar);
$parcel$export(module.exports, "AvatarSizes", () => (parcelRequire("fBLyB")).AvatarSizes);
$parcel$export(module.exports, "isLoggedIn", () => (parcelRequire("fBLyB")).isLoggedIn);
$parcel$export(module.exports, "isUserLoaded", () => (parcelRequire("fBLyB")).isUserLoaded);
$parcel$export(module.exports, "getCanAdministerJIRA", () => (parcelRequire("fBLyB")).getCanAdministerJIRA);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => (parcelRequire("fBLyB")).getHasSiteAdministerAccess);
$parcel$export(module.exports, "getAgentForPortal", () => (parcelRequire("fBLyB")).getAgentForPortal);
$parcel$export(module.exports, "getAccountId", () => (parcelRequire("fBLyB")).getAccountId);
$parcel$export(module.exports, "getDisplayName", () => (parcelRequire("fBLyB")).getDisplayName);
$parcel$export(module.exports, "getAvatarSrc", () => (parcelRequire("fBLyB")).getAvatarSrc);
$parcel$export(module.exports, "getCustomMenuLinks", () => (parcelRequire("fBLyB")).getCustomMenuLinks);
$parcel$export(module.exports, "getUserState", () => (parcelRequire("fBLyB")).getUserState);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => (parcelRequire("fBLyB")).isAtlassianAccountManaged);

var $fBLyB = parcelRequire("fBLyB");

});
parcelRegister("fBLyB", function(module, exports) {
$parcel$export(module.exports, "AvatarSizes", () => $fd8ad567e1423944$export$a56a976854e036b3);
$parcel$export(module.exports, "isLoggedIn", () => $fd8ad567e1423944$export$256a5a3564694cfc);
$parcel$export(module.exports, "isUserLoaded", () => $fd8ad567e1423944$export$e184595b7ec7bf2a);
$parcel$export(module.exports, "getLocale", () => $fd8ad567e1423944$export$180605366c04f0cd);
$parcel$export(module.exports, "getAvatar", () => $fd8ad567e1423944$export$4832dff6e2fcc91f);
$parcel$export(module.exports, "getAvatarSrc", () => $fd8ad567e1423944$export$35125d98e6f1484);
$parcel$export(module.exports, "getCustomMenuLinks", () => $fd8ad567e1423944$export$bf9a934424e2dbf1);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $fd8ad567e1423944$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $fd8ad567e1423944$export$c5f994129d97ed23);
$parcel$export(module.exports, "getAgentForPortal", () => $fd8ad567e1423944$export$a163df73b48c15df);
$parcel$export(module.exports, "getAccountId", () => $fd8ad567e1423944$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getDisplayName", () => $fd8ad567e1423944$export$be63e0664592e141);
$parcel$export(module.exports, "getUserState", () => $fd8ad567e1423944$export$531a2013799771e3);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => $fd8ad567e1423944$export$9055c338585b9def);
var $fd8ad567e1423944$export$a56a976854e036b3 = /*#__PURE__*/ function(AvatarSizes) {
    AvatarSizes["XSMALL"] = "xsmall";
    AvatarSizes["SMALL"] = "small";
    AvatarSizes["MEDIUM"] = "medium";
    AvatarSizes["LARGE"] = "large";
    AvatarSizes["XLARGE"] = "xlarge";
    return AvatarSizes;
}({});
const $fd8ad567e1423944$export$256a5a3564694cfc = (state)=>state.persisted.user.isLoggedIn;
const $fd8ad567e1423944$export$e184595b7ec7bf2a = (state)=>state.persisted.user.isLoaded;
const $fd8ad567e1423944$export$180605366c04f0cd = (state)=>state.persisted.user.language.key;
const $fd8ad567e1423944$export$4832dff6e2fcc91f = (state, size)=>{
    if (state.persisted.user.avatars && size) return state.persisted.user.avatars[size];
    return undefined;
};
const $fd8ad567e1423944$export$35125d98e6f1484 = (state)=>$fd8ad567e1423944$export$4832dff6e2fcc91f(state, "xlarge");
const $fd8ad567e1423944$export$ee387765d0284f6c = (state)=>{
    return state.persisted.user.userRequests;
};
const $fd8ad567e1423944$export$aa593f8d08aea763 = (state)=>{
    return state.persisted.user.userRequests.myRequestCount;
};
const $fd8ad567e1423944$export$e088f15960c351f6 = (state)=>{
    return state.persisted.user.userRequests.pendingApprovalCount;
};
const $fd8ad567e1423944$export$c0edbdc6282ca463 = (state)=>{
    return state.persisted.user.userRequests.approvalCount;
};
const $fd8ad567e1423944$export$bf9a934424e2dbf1 = (state)=>state.persisted.user.customMenuLinks;
const $fd8ad567e1423944$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $fd8ad567e1423944$export$c5f994129d97ed23 = (state)=>{
    return state.persisted.user.hasSiteAdministerAccess;
};
const $fd8ad567e1423944$export$a163df73b48c15df = (state)=>{
    return state.persisted.user.agentForPortal;
};
const $fd8ad567e1423944$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $fd8ad567e1423944$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName;
};
const $fd8ad567e1423944$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $fd8ad567e1423944$export$531a2013799771e3 = (state)=>{
    return state.persisted.user;
};
const $fd8ad567e1423944$export$9055c338585b9def = (state)=>{
    return state.persisted.user.atlassianAccountManaged;
};

});


parcelRegister("3kjRG", function(module, exports) {
$parcel$export(module.exports, "getLocalStorageItem", () => $32d4261714434379$export$93d719890ad66653);
$parcel$export(module.exports, "setLocalStorageItem", () => $32d4261714434379$export$5aa524d86254b4f);
$parcel$export(module.exports, "removeLocalStorageItem", () => $32d4261714434379$export$baf306891f1b93bd);

var $cxi2Z = parcelRequire("cxi2Z");

var $4vSIK = parcelRequire("4vSIK");
const $32d4261714434379$export$93d719890ad66653 = (key, errorHandler)=>{
    return (0, $4vSIK.safeAccessWithErrorHandler)(()=>(0, $cxi2Z.AtlBrowserStorageLocal).getItem(key), errorHandler);
};
const $32d4261714434379$export$5aa524d86254b4f = (key, value, errorHandler)=>{
    return (0, $4vSIK.safeAccessWithErrorHandler)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $cxi2Z.AtlBrowserStorageLocal).setItem(key, value);
    }, errorHandler);
};
const $32d4261714434379$export$baf306891f1b93bd = (key, errorHandler)=>{
    return (0, $4vSIK.safeAccessWithErrorHandler)(()=>(0, $cxi2Z.AtlBrowserStorageLocal).removeItem(key), errorHandler);
};

});
parcelRegister("cxi2Z", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $1db20be275c9eabb$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $1db20be275c9eabb$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $1db20be275c9eabb$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("1EGd8")).WebStorageType);

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");
var $lsoqf = parcelRequire("lsoqf");
var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");

var $fhC5O = parcelRequire("fhC5O");

var $1EGd8 = parcelRequire("1EGd8");

var $iiWz6 = parcelRequire("iiWz6");
var $7zDPJ = parcelRequire("7zDPJ");
var $1T5gr = parcelRequire("1T5gr");
class $1db20be275c9eabb$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $c76Jg.getBscGlobalState)().webStorageEnabled) return true;
        (0, $cYNDs.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $cYNDs.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $iiWz6.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            // BSC controls are disabled (pre-init, caller opted out, or killswitch active).
            // Write proceeds unconditionally — emit analytics so we can quantify bypass volume
            // (gated by platform_bsc_consent_bypass_analytics for safe rollout).
            if ((0, $gdUUy.fg)('platform_bsc_consent_bypass_analytics')) {
                const globalState = (0, $c76Jg.getBscGlobalState)();
                (0, $2xHPy.sendPackageOperationalEvent)({
                    action: 'usedAtlBrowserStorageSetItemBscDisabled',
                    attributes: {
                        storageType: this.storageType,
                        product: globalState.product,
                        hasInitialized: globalState.hasInitialized ?? false
                    }
                });
            }
            this.storage.setItem(key, value);
            return {
                status: (0, $fhC5O.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $cYNDs.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $fhC5O.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $c76Jg.getBscGlobalState)().product;
        const wasInitialized = (0, $c76Jg.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $7zDPJ.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized) (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, $fhC5O.Status).SUCCESS) (0, $cYNDs.Logger).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, $fhC5O.Status).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, $cYNDs.Logger).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, $cYNDs.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, $cYNDs.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $cYNDs.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $1T5gr.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, $c76Jg.getBscGlobalState)().hasInitialized) (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $cYNDs.Logger).debug(`${itemSetStatus === (0, $fhC5O.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $cYNDs.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $lsoqf.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $1db20be275c9eabb$export$c8cc3ffd3f2c1d2f = new $1db20be275c9eabb$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, $1EGd8.WebStorageType).LocalStorage);
const $1db20be275c9eabb$export$edbae459bdf957a5 = new $1db20be275c9eabb$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, $1EGd8.WebStorageType).SessionStorage);
const $1db20be275c9eabb$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $1EGd8.WebStorageType).LocalStorage]: $1db20be275c9eabb$export$c8cc3ffd3f2c1d2f,
        [(0, $1EGd8.WebStorageType).SessionStorage]: $1db20be275c9eabb$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("c76Jg", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $23ca037ced147909$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $23ca037ced147909$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetPatternFormat", () => $23ca037ced147909$export$f9550288b9b1f6e3);
$parcel$export(module.exports, "__internalSetPatternFormat", () => $23ca037ced147909$export$f10a7691f1fb3cb);
$parcel$export(module.exports, "__internalGetResolvedFlatPatternFileFormat", () => $23ca037ced147909$export$8bf1367cc4bb66da);
$parcel$export(module.exports, "__internalSetResolvedFlatPatternFileFormat", () => $23ca037ced147909$export$2bd306fd2b97e710);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $23ca037ced147909$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $23ca037ced147909$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $23ca037ced147909$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $23ca037ced147909$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $23ca037ced147909$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $23ca037ced147909$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $23ca037ced147909$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", () => $23ca037ced147909$export$cff869f7e58c9036);
$parcel$export(module.exports, "__internalSetCacheLoadedDate", () => $23ca037ced147909$export$491d0e6c401a0697);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $23ca037ced147909$export$ea32fe1e8610fd3b);

var $fhC5O = parcelRequire("fhC5O");

var $lXTjH = parcelRequire("lXTjH");
let $23ca037ced147909$var$analyticsEnabledGlobalState;
let $23ca037ced147909$var$productGlobalState;
let $23ca037ced147909$var$perimeterGlobalState;
let $23ca037ced147909$var$webStorageControlsEnabledGlobalState;
let $23ca037ced147909$var$indexedDbControlsEnabledGlobalState;
let $23ca037ced147909$var$disableWebStorageConsentChecksGlobalState;
let $23ca037ced147909$var$localConsentModeGlobalState;
let $23ca037ced147909$var$packageLogLevelGlobalState;
let $23ca037ced147909$var$allowUncategorizedCookiesInOverridesGlobalState;
let $23ca037ced147909$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $23ca037ced147909$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $23ca037ced147909$var$disableIndexedDbConsentChecksGlobalState;
let $23ca037ced147909$var$userIdGlobalState;
let $23ca037ced147909$var$cloudIdGlobalState;
let $23ca037ced147909$var$hasInitialized = false;
let $23ca037ced147909$var$cacheLoadedDateGlobalState;
let $23ca037ced147909$var$patternFormatGlobalState;
let $23ca037ced147909$var$resolvedFlatPatternFileFormatGlobalState;
let $23ca037ced147909$var$cookiesCacheLoader;
let $23ca037ced147909$var$localStorageCacheLoader;
let $23ca037ced147909$var$sessionStorageCacheLoader;
let $23ca037ced147909$var$indexedDBCacheLoader;
let $23ca037ced147909$var$loadCache = async (storageType)=>{
    var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL, _indexedDBCacheLoader;
    switch(storageType){
        case (0, $fhC5O.CategoryStorageType).Cookies:
            return await ((_cookiesCacheLoader = $23ca037ced147909$var$cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData());
        case (0, $fhC5O.CategoryStorageType).LocalStorage:
            return await ((_localStorageCacheLoa = $23ca037ced147909$var$localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData());
        case (0, $fhC5O.CategoryStorageType).SessionStorage:
            return await ((_sessionStorageCacheL = $23ca037ced147909$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData());
        case (0, $fhC5O.CategoryStorageType).IndexedDB:
            return await ((_indexedDBCacheLoader = $23ca037ced147909$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader === void 0 ? void 0 : _indexedDBCacheLoader.loadStorageControlsData());
        default:
            return undefined;
    }
};
let $23ca037ced147909$var$loadCacheMaybeSync = (storageType)=>{
    var _cookiesCacheLoader2, _cookiesCacheLoader3, _localStorageCacheLoa2, _localStorageCacheLoa3, _sessionStorageCacheL2, _sessionStorageCacheL3, _indexedDBCacheLoader2, _indexedDBCacheLoader3;
    switch(storageType){
        case (0, $fhC5O.CategoryStorageType).Cookies:
            return ((_cookiesCacheLoader2 = $23ca037ced147909$var$cookiesCacheLoader) === null || _cookiesCacheLoader2 === void 0 ? void 0 : _cookiesCacheLoader2.getStorageControlsDataFromCache()) ?? ((_cookiesCacheLoader3 = $23ca037ced147909$var$cookiesCacheLoader) === null || _cookiesCacheLoader3 === void 0 ? void 0 : _cookiesCacheLoader3.loadStorageControlsData());
        case (0, $fhC5O.CategoryStorageType).LocalStorage:
            return ((_localStorageCacheLoa2 = $23ca037ced147909$var$localStorageCacheLoader) === null || _localStorageCacheLoa2 === void 0 ? void 0 : _localStorageCacheLoa2.getStorageControlsDataFromCache()) ?? ((_localStorageCacheLoa3 = $23ca037ced147909$var$localStorageCacheLoader) === null || _localStorageCacheLoa3 === void 0 ? void 0 : _localStorageCacheLoa3.loadStorageControlsData());
        case (0, $fhC5O.CategoryStorageType).SessionStorage:
            return ((_sessionStorageCacheL2 = $23ca037ced147909$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL2 === void 0 ? void 0 : _sessionStorageCacheL2.getStorageControlsDataFromCache()) ?? ((_sessionStorageCacheL3 = $23ca037ced147909$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL3 === void 0 ? void 0 : _sessionStorageCacheL3.loadStorageControlsData());
        case (0, $fhC5O.CategoryStorageType).IndexedDB:
            return ((_indexedDBCacheLoader2 = $23ca037ced147909$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader2 === void 0 ? void 0 : _indexedDBCacheLoader2.getStorageControlsDataFromCache()) ?? ((_indexedDBCacheLoader3 = $23ca037ced147909$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader3 === void 0 ? void 0 : _indexedDBCacheLoader3.loadStorageControlsData());
        default:
            return undefined;
    }
};
const $23ca037ced147909$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $23ca037ced147909$var$analyticsEnabledGlobalState ?? true,
        product: $23ca037ced147909$var$productGlobalState,
        perimeter: $23ca037ced147909$var$perimeterGlobalState,
        webStorageEnabled: $23ca037ced147909$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $23ca037ced147909$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $23ca037ced147909$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $23ca037ced147909$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $23ca037ced147909$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $23ca037ced147909$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $23ca037ced147909$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $23ca037ced147909$var$disableIndexedDbConsentChecksGlobalState ?? false,
        packageLogLevel: $23ca037ced147909$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $23ca037ced147909$var$cookiesCacheLoader,
        localStorageCacheLoader: $23ca037ced147909$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $23ca037ced147909$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $23ca037ced147909$var$indexedDBCacheLoader,
        loadCache: $23ca037ced147909$var$loadCache,
        loadCacheMaybeSync: $23ca037ced147909$var$loadCacheMaybeSync,
        hasInitialized: $23ca037ced147909$var$hasInitialized,
        userId: $23ca037ced147909$var$userIdGlobalState,
        cloudId: $23ca037ced147909$var$cloudIdGlobalState,
        cacheLoadedDate: $23ca037ced147909$var$cacheLoadedDateGlobalState,
        patternFormat: $23ca037ced147909$var$patternFormatGlobalState
    };
};
const $23ca037ced147909$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $23ca037ced147909$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $23ca037ced147909$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $23ca037ced147909$var$productGlobalState = overrideProduct;
};
const $23ca037ced147909$export$ac7c2edd09656c05 = ()=>{
    $23ca037ced147909$var$analyticsEnabledGlobalState = undefined;
    $23ca037ced147909$var$productGlobalState = undefined;
    $23ca037ced147909$var$webStorageControlsEnabledGlobalState = undefined;
    $23ca037ced147909$var$indexedDbControlsEnabledGlobalState = undefined;
    $23ca037ced147909$var$disableWebStorageConsentChecksGlobalState = undefined;
    $23ca037ced147909$var$localConsentModeGlobalState = undefined;
    $23ca037ced147909$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $23ca037ced147909$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $23ca037ced147909$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $23ca037ced147909$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $23ca037ced147909$var$userIdGlobalState = undefined;
    $23ca037ced147909$var$cloudIdGlobalState = undefined;
    $23ca037ced147909$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $lXTjH.resetLogLevelCache)();
    $23ca037ced147909$var$cookiesCacheLoader = undefined;
    $23ca037ced147909$var$localStorageCacheLoader = undefined;
    $23ca037ced147909$var$sessionStorageCacheLoader = undefined;
    $23ca037ced147909$var$indexedDBCacheLoader = undefined;
    $23ca037ced147909$var$hasInitialized = false;
    $23ca037ced147909$var$cacheLoadedDateGlobalState = undefined;
    $23ca037ced147909$var$patternFormatGlobalState = undefined;
    $23ca037ced147909$var$resolvedFlatPatternFileFormatGlobalState = undefined;
};
function $23ca037ced147909$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $23ca037ced147909$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $23ca037ced147909$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $23ca037ced147909$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $23ca037ced147909$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $23ca037ced147909$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $23ca037ced147909$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $23ca037ced147909$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $23ca037ced147909$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $23ca037ced147909$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $23ca037ced147909$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $23ca037ced147909$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $23ca037ced147909$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $23ca037ced147909$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $23ca037ced147909$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $23ca037ced147909$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $23ca037ced147909$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $23ca037ced147909$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $23ca037ced147909$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $23ca037ced147909$var$userIdGlobalState = updates.userIdGlobalState;
}
function $23ca037ced147909$export$f9550288b9b1f6e3() {
    return $23ca037ced147909$var$patternFormatGlobalState;
}
function $23ca037ced147909$export$f10a7691f1fb3cb(patternFormat) {
    if ($23ca037ced147909$var$patternFormatGlobalState === undefined) $23ca037ced147909$var$patternFormatGlobalState = patternFormat;
}
function $23ca037ced147909$export$8bf1367cc4bb66da() {
    return $23ca037ced147909$var$resolvedFlatPatternFileFormatGlobalState;
}
function $23ca037ced147909$export$2bd306fd2b97e710(value) {
    if ($23ca037ced147909$var$resolvedFlatPatternFileFormatGlobalState === undefined) $23ca037ced147909$var$resolvedFlatPatternFileFormatGlobalState = value;
}
function $23ca037ced147909$export$8835d45f445e6ba4() {
    return $23ca037ced147909$var$hasInitialized;
}
function $23ca037ced147909$export$9dfdd17bbd03b460() {
    return $23ca037ced147909$var$productGlobalState;
}
function $23ca037ced147909$export$d96c3b0fb6d35c5d() {
    return $23ca037ced147909$var$webStorageControlsEnabledGlobalState;
}
function $23ca037ced147909$export$c8554d68c78456d3() {
    return $23ca037ced147909$var$indexedDbControlsEnabledGlobalState;
}
function $23ca037ced147909$export$ea650e4f51ec84d8() {
    return $23ca037ced147909$var$disableWebStorageConsentChecksGlobalState;
}
function $23ca037ced147909$export$fa1f6ebb49ec4b30() {
    return $23ca037ced147909$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $23ca037ced147909$export$b60c6437117dfaf9() {
    return $23ca037ced147909$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $23ca037ced147909$export$cff869f7e58c9036() {
    return $23ca037ced147909$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $23ca037ced147909$export$491d0e6c401a0697(date) {
    if ($23ca037ced147909$var$cacheLoadedDateGlobalState === undefined) $23ca037ced147909$var$cacheLoadedDateGlobalState = date;
}
function $23ca037ced147909$export$ea32fe1e8610fd3b() {
    return $23ca037ced147909$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("fhC5O", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $79372c80f7f4d67d$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $79372c80f7f4d67d$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $79372c80f7f4d67d$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $79372c80f7f4d67d$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $79372c80f7f4d67d$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $79372c80f7f4d67d$export$96e9906d6d93a972);
var $79372c80f7f4d67d$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $79372c80f7f4d67d$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $79372c80f7f4d67d$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $79372c80f7f4d67d$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $79372c80f7f4d67d$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $79372c80f7f4d67d$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $79372c80f7f4d67d$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $79372c80f7f4d67d$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("lXTjH", function(module, exports) {
$parcel$export(module.exports, "determineLogLevel", () => $431e0c5eef9a8fc6$export$5461380538f47d52);
$parcel$export(module.exports, "resetLogLevelCache", () => $431e0c5eef9a8fc6$export$977223726df102da);

var $cG0CM = parcelRequire("cG0CM");

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");

var $jGBZm = parcelRequire("jGBZm");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $431e0c5eef9a8fc6$var$cachedLogLevel;
const $431e0c5eef9a8fc6$export$5461380538f47d52 = ()=>{
    if ($431e0c5eef9a8fc6$var$cachedLogLevel !== undefined) return $431e0c5eef9a8fc6$var$cachedLogLevel;
    $431e0c5eef9a8fc6$var$cachedLogLevel = $431e0c5eef9a8fc6$var$readDebugCookieOverride() ?? $431e0c5eef9a8fc6$var$readInitParamLogLevel() ?? (0, $jGBZm.DEFAULT_LOG_LEVEL);
    return $431e0c5eef9a8fc6$var$cachedLogLevel;
};
const $431e0c5eef9a8fc6$export$977223726df102da = ()=>{
    $431e0c5eef9a8fc6$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $431e0c5eef9a8fc6$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $cG0CM.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $gdUUy.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $jGBZm.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $431e0c5eef9a8fc6$var$readInitParamLogLevel = ()=>{
    return (0, $jGBZm.packageLogLevelStringToEnum)((0, $c76Jg.getBscGlobalState)().packageLogLevel);
};

});
parcelRegister("jGBZm", function(module, exports) {
$parcel$export(module.exports, "LogLevel", () => $923e11a9c316e319$export$243e62d78d3b544d);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $923e11a9c316e319$export$97d4c6871900dcac);
$parcel$export(module.exports, "packageLogLevelStringToEnum", () => $923e11a9c316e319$export$6b31b02af0747fdf);
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $923e11a9c316e319$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $923e11a9c316e319$export$97d4c6871900dcac = 1;
const $923e11a9c316e319$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $923e11a9c316e319$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $923e11a9c316e319$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};

});



parcelRegister("lsoqf", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $3897809bcb759494$export$48d7c418edadb60c);

var $f2Pmd = parcelRequire("f2Pmd");

var $gdUUy = parcelRequire("gdUUy");
const $3897809bcb759494$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $gdUUy.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $f2Pmd.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("2xHPy", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $5091d91699bbb327$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $5091d91699bbb327$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $5091d91699bbb327$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $5091d91699bbb327$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $5091d91699bbb327$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $5091d91699bbb327$export$1ba525b8a711eaac);

var $gNwHK = parcelRequire("gNwHK");

var $f2Pmd = parcelRequire("f2Pmd");

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");

var $1KqOk = parcelRequire("1KqOk");

var $gphZ8 = parcelRequire("gphZ8");

var $3RwVg = parcelRequire("3RwVg");

var $cOzro = parcelRequire("cOzro");
const $5091d91699bbb327$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $gNwHK.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $gNwHK.envType).DEV;
    return (0, $gNwHK.envType).PROD;
};
const $5091d91699bbb327$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $5091d91699bbb327$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $5091d91699bbb327$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $5091d91699bbb327$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $5091d91699bbb327$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $5091d91699bbb327$var$decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState$pr;
    const { domain: domain, product: product } = $5091d91699bbb327$export$fce3dd735e04d566();
    return {
        packageName: (0, $gdUUy.fg)('platform_bsc_use_generated_package_info') ? (0, $3RwVg.packageName) : (0, $gphZ8.packageName),
        packageVersion: (0, $gdUUy.fg)('platform_bsc_use_generated_package_info') ? (0, $3RwVg.packageVersion) : (0, $gphZ8.packageVersion),
        domain: domain,
        product: ((_getBscGlobalState$pr = (0, $c76Jg.getBscGlobalState)().product) === null || _getBscGlobalState$pr === void 0 ? void 0 : _getBscGlobalState$pr.toLowerCase()) ?? product,
        ...attributes && attributes
    };
};
const $5091d91699bbb327$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $c76Jg.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $f2Pmd.default)({
                    env: $5091d91699bbb327$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $c76Jg.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $gNwHK.tenantType).CLOUD_ID, (0, $c76Jg.getBscGlobalState)().cloudId);
                if ((0, $c76Jg.getBscGlobalState)().userId) instance.setUserInfo((0, $gNwHK.userType).ATLASSIAN_ACCOUNT, (0, $c76Jg.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $1KqOk.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $c76Jg.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $5091d91699bbb327$export$5bfe55348e7aebc1(properties) {
    (0, $cOzro.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $5091d91699bbb327$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $5091d91699bbb327$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $5091d91699bbb327$export$c986f0e7f985d67f(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $5091d91699bbb327$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $5091d91699bbb327$var$decorateEventAttributes(properties.attributes)
    });
}
function $5091d91699bbb327$export$1aecf263098db667(properties) {
    (0, $cOzro.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>{
        var _getAnalyticsClient3;
        return (_getAnalyticsClient3 = $5091d91699bbb327$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 ? void 0 : _getAnalyticsClient3.sendUIEvent({
            ...properties,
            attributes: $5091d91699bbb327$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $5091d91699bbb327$export$22a3b1671f38a193(properties) {
    (0, $cOzro.withAnalyticsEventSampling)(properties.name, ()=>{
        var _getAnalyticsClient4;
        return (_getAnalyticsClient4 = $5091d91699bbb327$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 ? void 0 : _getAnalyticsClient4.sendScreenEvent({
            ...properties,
            attributes: $5091d91699bbb327$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $5091d91699bbb327$export$1ba525b8a711eaac(properties) {
    const { onSent: onSent, ...eventProperties } = properties;
    (0, $cOzro.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        const client = $5091d91699bbb327$export$fde53e78fd93a54d();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent({
            ...eventProperties,
            attributes: $5091d91699bbb327$var$decorateEventAttributes(properties.attributes)
        });
        onSent === null || onSent === void 0 || onSent();
    });
}

});
parcelRegister("1KqOk", function(module, exports) {
$parcel$export(module.exports, "LOG_PREFIX", () => $9bba85b5a8ca38bd$export$5e28bf885ebebfa6);
$parcel$export(module.exports, "ERROR_EVENT_THROTTLE_INTERVAL_MS", () => $9bba85b5a8ca38bd$export$aeb1f5aa1188ce28);
$parcel$export(module.exports, "ERROR_EVENT_MAX_PER_SESSION", () => $9bba85b5a8ca38bd$export$ee3d07c2528881e2);
const $9bba85b5a8ca38bd$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $9bba85b5a8ca38bd$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $9bba85b5a8ca38bd$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

});

parcelRegister("gphZ8", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $7cfd6673dd8372b1$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $7cfd6673dd8372b1$export$91546b032799aa40);
const $7cfd6673dd8372b1$export$9345d7360ffe0722 = undefined ?? '';
const $7cfd6673dd8372b1$export$91546b032799aa40 = undefined ?? '';

});

parcelRegister("3RwVg", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $f61cdedf06fe5062$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $f61cdedf06fe5062$export$91546b032799aa40);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gXWbZ = parcelRequire("gXWbZ");
const $f61cdedf06fe5062$export$9345d7360ffe0722 = (0, (/*@__PURE__*/$parcel$interopDefault($gXWbZ))).name;
const $f61cdedf06fe5062$export$91546b032799aa40 = (0, (/*@__PURE__*/$parcel$interopDefault($gXWbZ))).version;

});
parcelRegister("gXWbZ", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@atlassian/browser-storage-controls\",\"version\":\"11.2.0\",\"description\":\"Package containing utilities and components for collecting and enforcing user preferences on atlassian browser storage (cookies,localstorage, indexedDB etc.)\",\"publishConfig\":{\"registry\":\"https://packages.atlassian.com/api/npm/npm-remote\"},\"repository\":\"https://bitbucket.org/atlassian/atlassian-frontend-monorepo\",\"author\":\"Atlassian Pty Ltd\",\"main\":\"dist/cjs/index.js\",\"module\":\"dist/esm/index.js\",\"module:es2019\":\"dist/es2019/index.js\",\"types\":\"dist/types/index.d.ts\",\"sideEffects\":[\"*.compiled.css\"],\"atlaskit:src\":\"src/index.ts\",\"atlassian\":{\"team\":\"trust-privacy-controls-eng-team\",\"i18n\":true},\"scripts\":{\"webpack-build\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js\",\"ak-postbuild\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js && cp package.json dist/package.json\",\"test\":\"node -r esbuild-register build/ci/test-pipeline/scripts/run-test.ts -c packages/policy-platform/browser-storage-controls/jest.config.js\"},\"dependencies\":{\"@atlaskit/atlassian-context\":\"workspace:^\",\"@atlaskit/button\":\"workspace:^\",\"@atlaskit/checkbox\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlaskit/flag\":\"workspace:^\",\"@atlaskit/form\":\"workspace:^\",\"@atlaskit/heading\":\"workspace:^\",\"@atlaskit/icon\":\"workspace:^\",\"@atlaskit/intl-messages-provider\":\"workspace:^\",\"@atlaskit/modal-dialog\":\"workspace:^\",\"@atlaskit/platform-feature-flags\":\"workspace:^\",\"@atlaskit/primitives\":\"workspace:^\",\"@atlaskit/react-ufo\":\"workspace:^\",\"@atlaskit/tokens\":\"workspace:^\",\"@atlaskit/tooltip\":\"workspace:^\",\"@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls\":\"root:*\",\"@atlassian/atl-context\":\"workspace:^\",\"@atlassian/ufo\":\"workspace:^\",\"@atlassian/ufo-experimental\":\"workspace:^\",\"@atlassiansox/analytics-web-client\":\"workspace:^\",\"@atlassiansox/frontend-feature-encoding\":\"root:*\",\"@babel/runtime\":\"root:*\",\"bind-event-listener\":\"root:*\",\"js-cookie\":\"root:*\",\"react-error-boundary\":\"root:*\",\"react-magnetic-di\":\"root:*\"},\"peerDependencies\":{\"react\":\"^18.2.0\",\"react-dom\":\"^18.2.0\",\"react-intl\":\"^5.25.1 || ^6.0.0 || ^7.0.0\"},\"devDependencies\":{\"@af/integration-testing\":\"workspace:^\",\"@af/visual-regression\":\"workspace:^\",\"@atlaskit/code\":\"workspace:^\",\"@atlaskit/css\":\"workspace:^\",\"@atlaskit/docs\":\"workspace:^\",\"@atlaskit/ssr\":\"workspace:^\",\"@atlaskit/toggle\":\"workspace:^\",\"@atlassian/feature-flags-storybook-utils\":\"workspace:^\",\"@atlassian/feature-flags-test-utils\":\"workspace:^\",\"@atlassian/multi-entry-tools\":\"workspace:^\",\"@atlassian/platform-storybook-helpers\":\"workspace:^\",\"@atlassian/testing-library\":\"workspace:^\",\"@babel/preset-typescript\":\"root:*\",\"@storybook/addon-actions\":\"root:*\",\"@storybook/test\":\"root:*\",\"@testing-library/react\":\"root:*\",\"@testing-library/user-event\":\"root:*\",\"@types/node\":\"root:*\",\"fake-indexeddb\":\"root:*\",\"fetch-mock\":\"root:*\",\"react\":\"root:*\",\"react-dom\":\"root:*\",\"react-intl\":\"root:*\",\"wait-for-expect\":\"root:*\",\"webpack-cli\":\"root:*\"},\"exports\":{\".\":\"./src/index.ts\",\"./banner-controls\":\"./src/controllers/banner-controls/index.ts\",\"./consent-banner\":\"./src/ui/consent-banner/index.tsx\",\"./consent-banner/preference-modal\":\"./src/ui/consent-banner/preference-modal/index.tsx\",\"./constants\":\"./src/constants.ts\",\"./controllers/banner-controls/get-banner-visibility\":\"./src/controllers/banner-controls/get-banner-visibility/index.ts\",\"./controllers/banner-controls/should-banner-render-prefetched\":\"./src/controllers/banner-controls/should-banner-render-prefetched/index.ts\",\"./controllers/banner-controls/should-banner-render\":\"./src/controllers/banner-controls/should-banner-render/index.ts\",\"./controllers/banner-controls/types\":\"./src/controllers/banner-controls/types.ts\",\"./controllers/cookie-controls/delete-cookie\":\"./src/controllers/cookie-controls/delete-cookie/index.ts\",\"./controllers/cookie-controls/get-cookie\":\"./src/controllers/cookie-controls/get-cookie/index.ts\",\"./controllers/cookie-controls/initialize-controls\":\"./src/controllers/cookie-controls/initialize-controls/index.ts\",\"./controllers/cookie-controls/set-cookie\":\"./src/controllers/cookie-controls/set-cookie/index.ts\",\"./controllers/cookie-controls/set-cookie/types\":\"./src/controllers/cookie-controls/set-cookie/types.ts\",\"./controllers/cookie-controls/set-strictly-necessary-cookie\":\"./src/controllers/cookie-controls/set-strictly-necessary-cookie/index.ts\",\"./controllers/cookie-controls/transformer\":\"./src/controllers/cookie-controls/transformer/index.ts\",\"./controllers/preferences-controls/get-preferences\":\"./src/controllers/preferences-controls/get-preferences/index.ts\",\"./controllers/third-party-controls/check-third-party\":\"./src/controllers/third-party-controls/check-third-party/index.ts\",\"./cookie-controls\":\"./src/controllers/cookie-controls/index.ts\",\"./core\":\"./src/common/utils/bsc-global-state/core.ts\",\"./consent-hub-service/types\":\"./src/services/consent-hub-service/types.ts\",\"./consent-hub-service/utils\":\"./src/services/consent-hub-service/utils.ts\",\"./i18n/*\":{\"publish\":null,\"default\":\"./src/i18n/*.ts\"},\"./indexed-db-wrapper-service\":\"./src/services/indexed-db-wrapper-service/index.ts\",\"./indexed-db-wrapper-service/types\":\"./src/services/indexed-db-wrapper-service/types.ts\",\"./types\":\"./src/types.ts\",\"./utils/item-processing\":\"./src/common/utils/item-processing/index.ts\",\"./utils/load-storage-controls-data/constants\":\"./src/common/utils/load-storage-controls-data/constants.ts\",\"./web-storage-service\":\"./src/services/web-storage-service/index.ts\",\"./web-storage-service/types\":\"./src/services/web-storage-service/types.ts\"},\"platform-feature-flags\":{\"platform_bsc_auto_detect_perimeter\":{\"type\":\"boolean\"},\"platform.moonjelly.block-unknown-cookies\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ssr_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ui_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_master_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_debug_mode\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_web_storage_killswitch\":{\"type\":\"boolean\"},\"product-terminology-refresh\":{\"type\":\"boolean\"},\"platform_remove_bsc_overrides\":{\"type\":\"boolean\"},\"platform_bsc_flat_pattern_file_structure\":{\"type\":\"boolean\"},\"platform_bsc_ssr_flat_pattern_file_format\":{\"type\":\"boolean\"},\"platform_bsc_longest_pattern_match_wins\":{\"type\":\"boolean\"},\"platform_bsc_flat_lookup_skip_merge\":{\"type\":\"boolean\"},\"platform_bsc_cleanup_revoked_storage_live_delete\":{\"type\":\"boolean\"},\"platform_bsc_cleanup_coverage_telemetry\":{\"type\":\"boolean\"},\"platform_bsc_consent_hub_x_origin_app_normalized\":{\"type\":\"boolean\"},\"platform_bsc_browser_extension_detection\":{\"type\":\"boolean\"},\"platform_bsc_consent_bypass_analytics\":{\"type\":\"boolean\"},\"platform_bsc_sync_initialize_controls\":{\"type\":\"boolean\"},\"platform_bsc_use_generated_package_info\":{\"type\":\"boolean\"},\"platform_dst_modal-dialog-use-modal-title\":{\"type\":\"boolean\",\"referenceOnly\":true}}}");

});


parcelRegister("cOzro", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $118de09c90f525b9$export$67b6e87f323cb6ad);

var $fhC5O = parcelRequire("fhC5O");

var $c76Jg = parcelRequire("c76Jg");

var $5VOMU = parcelRequire("5VOMU");

var $lsoqf = parcelRequire("lsoqf");
const $118de09c90f525b9$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 1000,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    browserExtensionKeysAllowed: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    detectPerimeterError: 1,
    usedAtlBrowserStorageSetItemBscDisabled: 100,
    usedSetCookieMasterKillswitch: 100,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $118de09c90f525b9$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $118de09c90f525b9$var$loadSamplingConfig() {
    if ((0, $5VOMU.cache).cachedSamplingConfig) return (0, $5VOMU.cache).cachedSamplingConfig;
    if ((0, $lsoqf.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $c76Jg.getBscGlobalState)();
    const controlsData = await loadCache((0, $fhC5O.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, $5VOMU.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $118de09c90f525b9$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($118de09c90f525b9$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $118de09c90f525b9$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $118de09c90f525b9$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $118de09c90f525b9$export$1138592b3c099377;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $118de09c90f525b9$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $118de09c90f525b9$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $118de09c90f525b9$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $118de09c90f525b9$export$b286f5e8716d11ad(analyticsEventKey);
    $118de09c90f525b9$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("5VOMU", function(module, exports) {
$parcel$export(module.exports, "cache", () => $84e3940d599be773$export$69a3209f1a06c04d);

var $jBZg2 = parcelRequire("jBZg2");
const $84e3940d599be773$export$69a3209f1a06c04d = new (0, $jBZg2.CachedSamplingConfig)();

});
parcelRegister("jBZg2", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $fba40a96a1c564e3$export$b886edaf6623554a);
class $fba40a96a1c564e3$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});




parcelRegister("cYNDs", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $f57a77b7418501f3$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $2xHPy = parcelRequire("2xHPy");

var $1KqOk = parcelRequire("1KqOk");

var $lXTjH = parcelRequire("lXTjH");

var $1Tiwb = parcelRequire("1Tiwb");

var $jGBZm = parcelRequire("jGBZm");
const $f57a77b7418501f3$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $f57a77b7418501f3$export$efa9a398d6368992 {
    // Console output is controlled solely by the resolved log level. `DEFAULT_LOG_LEVEL` is ERROR,
    // so info/warn/debug stay silent unless a consumer raises `packageLogLevel` or a developer sets
    // the `atl-bsc-debug-mode` cookie. ERROR output is intentionally always on.
    //
    // Keep these guards free of `fg` calls: `Logger.*` runs at module-load time in some consumers
    // (e.g. the AtlIndexedDb singleton), and evaluating a feature gate during a plain import breaks
    // consumers whose tests mock `fg` with a not-yet-initialized factory variable. The one gate this
    // path can still reach is handled in determine-log-level.ts, which checks its cookie first.
    static info(message, metadata) {
        if ((0, $lXTjH.determineLogLevel)() >= (0, $jGBZm.LogLevel).INFO) console.info(`${(0, $1KqOk.LOG_PREFIX)}: ${message}`, $f57a77b7418501f3$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $lXTjH.determineLogLevel)() >= (0, $jGBZm.LogLevel).WARN) console.warn(`${(0, $1KqOk.LOG_PREFIX)}: ${message}`, $f57a77b7418501f3$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $lXTjH.determineLogLevel)() >= (0, $jGBZm.LogLevel).ERROR) console.error(`${(0, $1KqOk.LOG_PREFIX)}: ${message}`, $f57a77b7418501f3$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $lXTjH.determineLogLevel)() >= (0, $jGBZm.LogLevel).DEBUG) console.debug(`${(0, $1KqOk.LOG_PREFIX)}: DEBUG ${message}`, $f57a77b7418501f3$var$formatMetadata(metadata));
    }
    /**
   * Sends an unsampled operational event to backend telemetry and also emits the message via
   * `Logger.error`. The telemetry send is throttled per-action (see error-event-throttle). The
   * console output is always at ERROR level (subject to the resolved log level).
   */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // shouldSendErrorEvent records the send and limits per-action volume, so a repeatedly
            // failing call site cannot flood telemetry with duplicate events.
            if ((0, $1Tiwb.shouldSendErrorEvent)(action)) (0, $2xHPy.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

});
parcelRegister("1Tiwb", function(module, exports) {
$parcel$export(module.exports, "shouldSendErrorEvent", () => $b674a0aa554a0356$export$e54335114720f029);

var $1KqOk = parcelRequire("1KqOk");
// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $b674a0aa554a0356$var$throttleState = new Map();
function $b674a0aa554a0356$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $b674a0aa554a0356$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $b674a0aa554a0356$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $1KqOk.ERROR_EVENT_MAX_PER_SESSION)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $1KqOk.ERROR_EVENT_THROTTLE_INTERVAL_MS)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $b674a0aa554a0356$export$a5ff37ede5ff9625() {
    $b674a0aa554a0356$var$throttleState.clear();
}

});


parcelRegister("1EGd8", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $6108e0fedacce49b$export$259e3a861f28589b);
var $6108e0fedacce49b$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("iiWz6", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $954cfd839cfd3722$export$e612bb1301d659de);

var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");
const $954cfd839cfd3722$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("7zDPJ", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $2a8c5fc63b56c93e$export$5ee8760f703d9d62);

var $c76Jg = parcelRequire("c76Jg");
var $2xHPy = parcelRequire("2xHPy");

var $1OAF2 = parcelRequire("1OAF2");

var $fhC5O = parcelRequire("fhC5O");

var $8KLlH = parcelRequire("8KLlH");

var $1EGd8 = parcelRequire("1EGd8");

var $fA9wy = parcelRequire("fA9wy");
const $2a8c5fc63b56c93e$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $2a8c5fc63b56c93e$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $1EGd8.WebStorageType).LocalStorage ? (0, $fhC5O.CategoryStorageType).LocalStorage : (0, $fhC5O.CategoryStorageType).SessionStorage;
    const disableWebStorageConsentChecks = (0, $c76Jg.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $8KLlH.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, $fA9wy.reportSetItemError)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, $fhC5O.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, $1OAF2.isProcessingAllowedByPreferencesMaybeSync)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            if ($2a8c5fc63b56c93e$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, $2xHPy.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $fA9wy.reportSetItemError)({
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, $fhC5O.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, $1OAF2.isProcessingAllowedByPreferencesMaybeSync)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    if ($2a8c5fc63b56c93e$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $8KLlH.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $fhC5O.Status).SUCCESS
            };
        } else return {
            status: (0, $fhC5O.Status).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, $fA9wy.reportSetItemError)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, $fhC5O.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("1OAF2", function(module, exports) {
$parcel$export(module.exports, "getItemCategoryFromPassedCache", () => $ff7a492f7816c516$export$69d5b68d01f4a366);
$parcel$export(module.exports, "getItemCategory", () => $ff7a492f7816c516$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isPromise", () => $ff7a492f7816c516$export$4369c812aac99591);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesMaybeSync", () => $ff7a492f7816c516$export$ffbb879d3fefb45c);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $ff7a492f7816c516$export$e7a3dca206fec6e2);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesWithCategory", () => $ff7a492f7816c516$export$17e4a7e00d5b99d9);

var $gdUUy = parcelRequire("gdUUy");

var $fvY9l = parcelRequire("fvY9l");

var $fhC5O = parcelRequire("fhC5O");

var $2xHPy = parcelRequire("2xHPy");

var $c76Jg = parcelRequire("c76Jg");

var $jY7dm = parcelRequire("jY7dm");

var $cYNDs = parcelRequire("cYNDs");
/**
 * Narrows a payload to the layout it declares, so the matchers below can be type-checked against a
 * concrete pattern shape rather than casting.
 *
 * An absent `patternFormat` means the legacy trie layout — the format the CDN serves while the
 * flat-format gate is off, and what a payload fetched by a consumer that predates COOK-632 will be.
 * TypeScript cannot infer that rule, so this is the one place it is asserted.
 */ const $ff7a492f7816c516$var$asConcreteCache = (storageControlsData)=>storageControlsData.patternFormat === 'flat' ? storageControlsData : storageControlsData;
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $ff7a492f7816c516$var$compiledRegExpCache = new WeakMap();
const $ff7a492f7816c516$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($ff7a492f7816c516$var$compiledRegExpCache.has(rawPatterns)) return $ff7a492f7816c516$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $cYNDs.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $ff7a492f7816c516$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $ff7a492f7816c516$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $ff7a492f7816c516$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $ff7a492f7816c516$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $ff7a492f7816c516$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $ff7a492f7816c516$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $ff7a492f7816c516$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $ff7a492f7816c516$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $ff7a492f7816c516$var$hasOwn = (map, key)=>map !== undefined && Object.prototype.hasOwnProperty.call(map, key);
/**
 * Picks the longer of a product and an 'all' pattern match. A tie can only be the same pattern in
 * both maps (two distinct prefixes or suffixes of equal length cannot both match one key), and the
 * product entry wins it — the value a merge of the two maps would have produced.
 */ const $ff7a492f7816c516$var$pickLongerMatch = (productMatch, allMatch)=>{
    if (productMatch === null) return allMatch;
    if (allMatch === null || productMatch.length >= allMatch.length) return productMatch;
    return allMatch;
};
/**
 * Resolves an item key's category number from a flat payload without merging the 'all' and
 * product maps. Merging allocated four objects per lookup, and the merged regexp object was new
 * every call so `compiledRegExpCache` never hit. Each stage checks the product map before 'all',
 * matching the precedence of the legacy trie path.
 */ const $ff7a492f7816c516$var$findFlatItemCategoryNumber = (itemKey, cache, product)=>{
    var _patterns$regexp, _patterns$regexp2;
    const { keys: keys, patterns: patterns } = cache;
    const productKeys = product ? keys[product] : undefined;
    if ($ff7a492f7816c516$var$hasOwn(productKeys, itemKey)) return productKeys[itemKey];
    const allKeys = keys['all'];
    if ($ff7a492f7816c516$var$hasOwn(allKeys, itemKey)) return allKeys[itemKey];
    const productStartsWith = product ? patterns.startsWith[product] : undefined;
    const allStartsWith = patterns.startsWith['all'];
    const productEndsWith = product ? patterns.endsWith[product] : undefined;
    const allEndsWith = patterns.endsWith['all'];
    if ((0, $gdUUy.fg)('platform_bsc_longest_pattern_match_wins')) {
        const swMatch = $ff7a492f7816c516$var$pickLongerMatch(productStartsWith ? $ff7a492f7816c516$export$4381be1b9fd38456(itemKey, productStartsWith) : null, allStartsWith ? $ff7a492f7816c516$export$4381be1b9fd38456(itemKey, allStartsWith) : null);
        if (swMatch !== null) return swMatch.category;
        const ewMatch = $ff7a492f7816c516$var$pickLongerMatch(productEndsWith ? $ff7a492f7816c516$export$495f1917e0bfb98c(itemKey, productEndsWith) : null, allEndsWith ? $ff7a492f7816c516$export$495f1917e0bfb98c(itemKey, allEndsWith) : null);
        if (ewMatch !== null) return ewMatch.category;
    } else {
        // Compare against null, not truthiness: category 0 (strictly necessary) is a valid match.
        if (productStartsWith) {
            const match = $ff7a492f7816c516$export$915dea35caff63c(itemKey, productStartsWith);
            if (match !== null) return match;
        }
        if (allStartsWith) {
            const match = $ff7a492f7816c516$export$915dea35caff63c(itemKey, allStartsWith);
            if (match !== null) return match;
        }
        if (productEndsWith) {
            const match = $ff7a492f7816c516$export$f6f7882079c4a2cb(itemKey, productEndsWith);
            if (match !== null) return match;
        }
        if (allEndsWith) {
            const match = $ff7a492f7816c516$export$f6f7882079c4a2cb(itemKey, allEndsWith);
            if (match !== null) return match;
        }
    }
    // The payload's own regexp maps are stable objects, so the WeakMap compile cache hits.
    const productRegExp = product ? (_patterns$regexp = patterns.regexp) === null || _patterns$regexp === void 0 ? void 0 : _patterns$regexp[product] : undefined;
    if (productRegExp) {
        const match = $ff7a492f7816c516$export$81a82818a800a999(itemKey, $ff7a492f7816c516$var$compileRegExpPatterns(productRegExp));
        if (match !== null) return match;
    }
    const allRegExp = (_patterns$regexp2 = patterns.regexp) === null || _patterns$regexp2 === void 0 ? void 0 : _patterns$regexp2['all'];
    if (allRegExp) return $ff7a492f7816c516$export$81a82818a800a999(itemKey, $ff7a492f7816c516$var$compileRegExpPatterns(allRegExp));
    return null;
};
/**
 * A matcher can hand back a value that is not a category number when the payload's shape does
 * not match the matcher in use, so the lookup misses. Coalesce that miss to `null` to honour
 * the declared `PreferenceCategory | null` return type; callers treat `null` as uncategorized.
 */ const $ff7a492f7816c516$var$toPreferenceCategory = (itemCategoryNumber, categories)=>{
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $fhC5O.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $fhC5O.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $fhC5O.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $fhC5O.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $fhC5O.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] ?? null : null;
};
const $ff7a492f7816c516$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName === null || productName === void 0 ? void 0 : productName.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    // The payload states its own format, recorded when it was fetched. Re-evaluating the flat-format
    // rollout gate here could disagree with the gate value that chose the file we actually fetched — an
    // unresolved Statsig client, a stale cross-request SSR cache entry, or a gate flip mid-session — and
    // the losing matcher silently returns null for every pattern rather than erroring. The gate stays
    // the sole input to the *fetch* decision.
    const cache = $ff7a492f7816c516$var$asConcreteCache(storageControlsData);
    if (cache.patternFormat === 'flat' && (0, $gdUUy.fg)('platform_bsc_flat_lookup_skip_merge')) return $ff7a492f7816c516$var$toPreferenceCategory($ff7a492f7816c516$var$findFlatItemCategoryNumber(itemKey, cache, downcasedProduct), categories);
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if (cache.patternFormat === 'flat') {
        // Flat prefix/suffix maps merge cleanly, because each key is a whole pattern rather than one
        // character of one.
        const productStartsWithPatterns = {
            ...cache.patterns.startsWith['all'],
            ...downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : {}
        };
        const productEndsWithPatterns = {
            ...cache.patterns.endsWith['all'],
            ...downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : {}
        };
        if ((0, $gdUUy.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $ff7a492f7816c516$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $ff7a492f7816c516$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $ff7a492f7816c516$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $ff7a492f7816c516$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
    } else {
        // Legacy trie matching path. We search the product trie first and fall back
        // to the 'all' trie; a merged trie is unsafe because a shared first character
        // silently drops the entire 'all' subtree under it (HOT-303432).
        const productStartsWith = downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : undefined;
        const productEndsWith = downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : undefined;
        const allStartsWith = cache.patterns.startsWith['all'];
        const allEndsWith = cache.patterns.endsWith['all'];
        if (productStartsWith) itemCategoryNumber = $ff7a492f7816c516$export$2c141b1c00f3e482(itemKey, productStartsWith);
        if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $ff7a492f7816c516$export$2c141b1c00f3e482(itemKey, allStartsWith);
        if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $ff7a492f7816c516$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
        if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $ff7a492f7816c516$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
    }
    // RegExp fallback, applied to both the flat and legacy trie pattern paths
    if (itemCategoryNumber === null) {
        var _patterns$regexp3, _patterns$regexp4;
        const rawRegExpPatterns = {
            ...(_patterns$regexp3 = patterns.regexp) === null || _patterns$regexp3 === void 0 ? void 0 : _patterns$regexp3['all'],
            ...downcasedProduct ? (_patterns$regexp4 = patterns.regexp) === null || _patterns$regexp4 === void 0 ? void 0 : _patterns$regexp4[downcasedProduct] : {}
        };
        const compiledPatterns = $ff7a492f7816c516$var$compileRegExpPatterns(rawRegExpPatterns);
        itemCategoryNumber = $ff7a492f7816c516$export$81a82818a800a999(itemKey, compiledPatterns);
    }
    return $ff7a492f7816c516$var$toPreferenceCategory(itemCategoryNumber, categories);
};
const $ff7a492f7816c516$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $c76Jg.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $ff7a492f7816c516$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $ff7a492f7816c516$export$4369c812aac99591 = (value)=>value != null && typeof value.then === 'function';
const $ff7a492f7816c516$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $c76Jg.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if ($ff7a492f7816c516$export$4369c812aac99591(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $ff7a492f7816c516$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $ff7a492f7816c516$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $ff7a492f7816c516$var$getEffectiveCategory(category) {
    if (category === null) return (0, $fhC5O.PreferenceCategory).Marketing;
    return category;
}
function $ff7a492f7816c516$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    const effectiveCategory = $ff7a492f7816c516$var$getEffectiveCategory(category);
    if (!!preferences) {
        if (!!effectiveCategory) return preferences[effectiveCategory];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $ff7a492f7816c516$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $fhC5O.PreferenceCategory).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($ff7a492f7816c516$export$4369c812aac99591(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $ff7a492f7816c516$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $ff7a492f7816c516$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $ff7a492f7816c516$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $ff7a492f7816c516$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $fvY9l.getPreferencesMaybeSync)();
    if ($ff7a492f7816c516$export$4369c812aac99591(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$ff7a492f7816c516$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $ff7a492f7816c516$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $ff7a492f7816c516$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $ff7a492f7816c516$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    const handleDecision = ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory }, wasAsync)=>{
        if (shouldProcessItem) {
            allowedCallback === null || allowedCallback === void 0 || allowedCallback({
                wasAsync: wasAsync
            });
            return shouldProcessItem;
        }
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $jY7dm.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $2xHPy.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback === null || allowedCallback === void 0 || allowedCallback({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback === null || blockedCallback === void 0 || blockedCallback({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
        return shouldProcessItem;
    };
    if ($ff7a492f7816c516$export$4369c812aac99591(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then((categoryAndPreference)=>handleDecision(categoryAndPreference, true));
    else return handleDecision(categoryAndPreferenceOrPromise, false);
};
const $ff7a492f7816c516$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = $ff7a492f7816c516$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($ff7a492f7816c516$export$4369c812aac99591(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback === null || allowedCallback === void 0 || allowedCallback({
        wasAsync: wasAsync
    });
    else {
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $jY7dm.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $2xHPy.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback === null || allowedCallback === void 0 || allowedCallback({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback === null || blockedCallback === void 0 || blockedCallback({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
    }
    return shouldProcessItem;
};
const $ff7a492f7816c516$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $ff7a492f7816c516$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($ff7a492f7816c516$export$4369c812aac99591(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    // Check if blocked item is from extension
    if (!shouldProcessItem) {
        const extensionCaller = itemCategory === null ? (0, $jY7dm.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $2xHPy.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            return {
                isAllowed: true,
                itemCategory: itemCategory
            };
        }
    }
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};

});
parcelRegister("fvY9l", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $dc7b34ac2766bb2c$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $dc7b34ac2766bb2c$export$39c2cb6e65c1c16b);

var $c76Jg = parcelRequire("c76Jg");
var $lsoqf = parcelRequire("lsoqf");

var $ahXPR = parcelRequire("ahXPR");

var $2raXS = parcelRequire("2raXS");

var $iiTNF = parcelRequire("iiTNF");

var $3t6nL = parcelRequire("3t6nL");
async function $dc7b34ac2766bb2c$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $c76Jg.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $iiTNF.getCookie)((0, $ahXPR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $3t6nL.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $2raXS.getConsentToken)();
            if ((0, $lsoqf.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $3t6nL.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $3t6nL.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $dc7b34ac2766bb2c$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $c76Jg.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $iiTNF.getCookie)((0, $ahXPR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $3t6nL.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $2raXS.getConsentToken)().then((consentToken)=>{
            if ((0, $lsoqf.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $3t6nL.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $3t6nL.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("ahXPR", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $4f4dbae57329f1dc$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $4f4dbae57329f1dc$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $4f4dbae57329f1dc$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $4f4dbae57329f1dc$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $4f4dbae57329f1dc$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $4f4dbae57329f1dc$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $4f4dbae57329f1dc$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $4f4dbae57329f1dc$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $4f4dbae57329f1dc$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $4f4dbae57329f1dc$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $4f4dbae57329f1dc$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $4f4dbae57329f1dc$export$31deaeaebce525bb);

var $fhC5O = parcelRequire("fhC5O");
const $4f4dbae57329f1dc$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $4f4dbae57329f1dc$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $4f4dbae57329f1dc$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $4f4dbae57329f1dc$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $4f4dbae57329f1dc$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $4f4dbae57329f1dc$export$37073d560ecebada = 'atl-testing-consents';
const $4f4dbae57329f1dc$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $4f4dbae57329f1dc$export$b28b5d760fe14a21 = {
    [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $fhC5O.PreferenceCategory).Functional]: true,
    [(0, $fhC5O.PreferenceCategory).Marketing]: true,
    [(0, $fhC5O.PreferenceCategory).Analytics]: true,
    [(0, $fhC5O.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $4f4dbae57329f1dc$export$4a12f9e99971760a = {
    [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $fhC5O.PreferenceCategory).Functional]: false,
    [(0, $fhC5O.PreferenceCategory).Marketing]: false,
    [(0, $fhC5O.PreferenceCategory).Analytics]: false,
    [(0, $fhC5O.PreferenceCategory).Unknown]: false
};
const $4f4dbae57329f1dc$export$f0fd1d13ec1d48f2 = {
    ...$4f4dbae57329f1dc$export$4a12f9e99971760a,
    [(0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $4f4dbae57329f1dc$export$f95182b7aa141c57 = '001';
const $4f4dbae57329f1dc$export$1f25427b34f9c405 = '002';
const $4f4dbae57329f1dc$export$31deaeaebce525bb = '003';

});

parcelRegister("2raXS", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $2f80a519fe57beed$export$f1b8f2ca713fca08);

var $ahXPR = parcelRequire("ahXPR");

var $iiTNF = parcelRequire("iiTNF");

var $701co = parcelRequire("701co");

var $7PqK8 = parcelRequire("7PqK8");

var $dQhDn = parcelRequire("dQhDn");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $2f80a519fe57beed$var$inFlightConsentToken = null;
const $2f80a519fe57beed$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $dQhDn.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $701co.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $iiTNF.getCookie)((0, $ahXPR.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $7PqK8.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $7PqK8.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $7PqK8.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $2f80a519fe57beed$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($2f80a519fe57beed$var$inFlightConsentToken) return $2f80a519fe57beed$var$inFlightConsentToken;
    $2f80a519fe57beed$var$inFlightConsentToken = $2f80a519fe57beed$var$_getConsentToken().finally(()=>{
        $2f80a519fe57beed$var$inFlightConsentToken = null;
    });
    return $2f80a519fe57beed$var$inFlightConsentToken;
};

});
parcelRegister("iiTNF", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $60a283e089145f06$export$4be65e66cfa2648a);

var $cG0CM = parcelRequire("cG0CM");

var $gdUUy = parcelRequire("gdUUy");

var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");
function $60a283e089145f06$export$4be65e66cfa2648a(key) {
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $cG0CM.default).get(key) : (0, $cG0CM.default).get();
    try {
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $cG0CM.default).get(key) : (0, $cG0CM.default).get();
    } catch (e) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("701co", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $3a8f8163415cbfe4$export$b5282052fc15e1ae);

var $ahXPR = parcelRequire("ahXPR");

var $iiTNF = parcelRequire("iiTNF");
const $3a8f8163415cbfe4$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $iiTNF.getCookie)((0, $ahXPR.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("7PqK8", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $17f7d5c5a96b8453$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $17f7d5c5a96b8453$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $17f7d5c5a96b8453$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $17f7d5c5a96b8453$export$b3365240280cb3c3);

var $corRd = parcelRequire("corRd");
var $cYNDs = parcelRequire("cYNDs");

var $ahXPR = parcelRequire("ahXPR");

var $5qyOC = parcelRequire("5qyOC");

var $acppk = parcelRequire("acppk");
const $17f7d5c5a96b8453$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $17f7d5c5a96b8453$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $17f7d5c5a96b8453$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($17f7d5c5a96b8453$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $17f7d5c5a96b8453$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $17f7d5c5a96b8453$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $17f7d5c5a96b8453$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $17f7d5c5a96b8453$export$6e0b780517c88191();
const $17f7d5c5a96b8453$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + $17f7d5c5a96b8453$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES * 60000);
    return expiryDate;
};
const $17f7d5c5a96b8453$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $acppk.setStrictlyNecessaryCookie)((0, $ahXPR.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $17f7d5c5a96b8453$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $cYNDs.Logger).debug(`Set Consent Token ${(0, $ahXPR.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $17f7d5c5a96b8453$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $acppk.setStrictlyNecessaryCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $cYNDs.Logger).debug(`set fallback consent token: ${(0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $17f7d5c5a96b8453$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $5qyOC.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $corRd.getBitValueFromBool)(!!bannerVisibility);
    (0, $acppk.setStrictlyNecessaryCookie)((0, $ahXPR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $17f7d5c5a96b8453$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $cYNDs.Logger).debug(`set shouldShowBannerCookie: ${(0, $ahXPR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $17f7d5c5a96b8453$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $17f7d5c5a96b8453$export$8e560d0760f733a2(consentToken);
    $17f7d5c5a96b8453$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("corRd", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $9e522a3a639a43d2$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $9e522a3a639a43d2$export$27647458f3cf29d2);
const $9e522a3a639a43d2$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $9e522a3a639a43d2$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("5qyOC", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $1a77907111ebadaa$export$bfdb9f82a9194c1e);

var $cG0CM = parcelRequire("cG0CM");

var $lsoqf = parcelRequire("lsoqf");

var $corRd = parcelRequire("corRd");

var $ahXPR = parcelRequire("ahXPR");

var $cX8bE = parcelRequire("cX8bE");

var $iiTNF = parcelRequire("iiTNF");

var $3t6nL = parcelRequire("3t6nL");
const $1a77907111ebadaa$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $3t6nL.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $1a77907111ebadaa$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $1a77907111ebadaa$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $corRd.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $cX8bE.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $1a77907111ebadaa$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $cX8bE.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $1a77907111ebadaa$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $cX8bE.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $1a77907111ebadaa$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $1a77907111ebadaa$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $corRd.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $cX8bE.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $1a77907111ebadaa$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $cX8bE.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $1a77907111ebadaa$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $cX8bE.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $1a77907111ebadaa$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $cG0CM.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $lsoqf.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $1a77907111ebadaa$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $corRd.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $1a77907111ebadaa$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $1a77907111ebadaa$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("cX8bE", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $40d04cbd6efb3162$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $40d04cbd6efb3162$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $40d04cbd6efb3162$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $40d04cbd6efb3162$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $40d04cbd6efb3162$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $40d04cbd6efb3162$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $40d04cbd6efb3162$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $40d04cbd6efb3162$export$a79c0ea3d7c2444a);

var $corRd = parcelRequire("corRd");

var $ahXPR = parcelRequire("ahXPR");

var $iiTNF = parcelRequire("iiTNF");

var $fhC5O = parcelRequire("fhC5O");

var $i1tcd = parcelRequire("i1tcd");
const $40d04cbd6efb3162$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $ahXPR.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $40d04cbd6efb3162$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $ahXPR.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $40d04cbd6efb3162$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($40d04cbd6efb3162$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $40d04cbd6efb3162$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $40d04cbd6efb3162$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $40d04cbd6efb3162$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $40d04cbd6efb3162$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $corRd.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $40d04cbd6efb3162$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $ahXPR.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $ahXPR.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $fhC5O.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $corRd.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $corRd.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $corRd.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $40d04cbd6efb3162$export$42a0b3fb1e53e7b9 = (consents)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $ahXPR.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $corRd.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $i1tcd.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $corRd.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $i1tcd.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $corRd.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $i1tcd.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $corRd.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $i1tcd.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $40d04cbd6efb3162$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $40d04cbd6efb3162$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $40d04cbd6efb3162$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $40d04cbd6efb3162$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $40d04cbd6efb3162$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $fhC5O.PreferenceCategory).StrictlyNecessary,
        (0, $fhC5O.PreferenceCategory).Functional,
        (0, $fhC5O.PreferenceCategory).Analytics,
        (0, $fhC5O.PreferenceCategory).Marketing,
        (0, $fhC5O.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: (0, $i1tcd.ConsentHubKey).StrictlyNecessary,
        [(0, $fhC5O.PreferenceCategory).Functional]: (0, $i1tcd.ConsentHubKey).Functional,
        [(0, $fhC5O.PreferenceCategory).Analytics]: (0, $i1tcd.ConsentHubKey).Analytics,
        [(0, $fhC5O.PreferenceCategory).Marketing]: (0, $i1tcd.ConsentHubKey).Marketing,
        [(0, $fhC5O.PreferenceCategory).Unknown]: (0, $i1tcd.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $40d04cbd6efb3162$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $40d04cbd6efb3162$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $40d04cbd6efb3162$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $40d04cbd6efb3162$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $40d04cbd6efb3162$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $40d04cbd6efb3162$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $40d04cbd6efb3162$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("i1tcd", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $bf4074da42ba1e8a$export$31140359b1e505cf);
var $bf4074da42ba1e8a$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("3t6nL", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $78ea1e7f82d504ee$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $78ea1e7f82d504ee$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $78ea1e7f82d504ee$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initializePreferencesData", () => $78ea1e7f82d504ee$export$7962405c3ca274b1);

var $c76Jg = parcelRequire("c76Jg");

var $corRd = parcelRequire("corRd");

var $ahXPR = parcelRequire("ahXPR");

var $cX8bE = parcelRequire("cX8bE");

var $fhC5O = parcelRequire("fhC5O");
const $78ea1e7f82d504ee$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $ahXPR.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $ahXPR.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $ahXPR.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $ahXPR.V001_SCHEMA_KEY),
        (0, $ahXPR.V002_SCHEMA_KEY),
        (0, $ahXPR.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $78ea1e7f82d504ee$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $ahXPR.V001_SCHEMA_KEY);
    return [
        version,
        (0, $corRd.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $corRd.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $corRd.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $corRd.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $78ea1e7f82d504ee$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $fhC5O.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $fhC5O.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $fhC5O.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $fhC5O.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $78ea1e7f82d504ee$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $ahXPR.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $fhC5O.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $fhC5O.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $fhC5O.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $fhC5O.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Functional]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Analytics]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Marketing]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Unknown]),
        (0, $corRd.getBitValueFromBool)(isDefaultConsentBit),
        (0, $corRd.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $corRd.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $78ea1e7f82d504ee$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $cX8bE.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$78ea1e7f82d504ee$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $78ea1e7f82d504ee$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $ahXPR.V003_SCHEMA_KEY);
    return [
        version,
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Functional]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Analytics]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Marketing]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.PreferenceCategory).Unknown]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $corRd.getBitValueFromBool)(userPreferences[(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $78ea1e7f82d504ee$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $fhC5O.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $fhC5O.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $fhC5O.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $fhC5O.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $78ea1e7f82d504ee$var$V002SpecificBitKeys = [
    (0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $fhC5O.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $fhC5O.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $fhC5O.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $fhC5O.ConsentPreferenceV2).ConsentedUnderFADP
];
const $78ea1e7f82d504ee$var$V003SpecificBitKeys = [
    (0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault,
    (0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated,
    (0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable
];
function $78ea1e7f82d504ee$export$3199823fec979bd1(userPreferences) {
    if ((0, $c76Jg.getBscGlobalState)().localConsentMode) return $78ea1e7f82d504ee$var$packPrefsVersion001(userPreferences);
    const isV002 = $78ea1e7f82d504ee$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $78ea1e7f82d504ee$var$packPrefsVersion002(userPreferences);
    const isV003 = $78ea1e7f82d504ee$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $78ea1e7f82d504ee$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $78ea1e7f82d504ee$var$packPrefsVersion001(userPreferences);
}
function $78ea1e7f82d504ee$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $c76Jg.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $ahXPR.V001_SCHEMA_KEY)) return $78ea1e7f82d504ee$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $78ea1e7f82d504ee$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $78ea1e7f82d504ee$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $78ea1e7f82d504ee$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $78ea1e7f82d504ee$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $78ea1e7f82d504ee$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $78ea1e7f82d504ee$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $fhC5O.PrefetchedPreferenceState).INTERNAL) {
        if ($78ea1e7f82d504ee$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $78ea1e7f82d504ee$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $cX8bE.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $78ea1e7f82d504ee$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $fhC5O.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("acppk", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $7478cb0669eb3cec$export$93509ff9a62ee022);

var $cG0CM = parcelRequire("cG0CM");

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");
var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");
const $7478cb0669eb3cec$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $cG0CM.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $c76Jg.getBscGlobalState)().hasInitialized) (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $cG0CM.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});


parcelRegister("dQhDn", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $0e2d504d579fbb7b$export$c515de1cc9cebc71);

var $ahXPR = parcelRequire("ahXPR");

var $H4xrH = parcelRequire("H4xrH");

var $3t6nL = parcelRequire("3t6nL");
const $0e2d504d579fbb7b$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $H4xrH.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $3t6nL.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $ahXPR.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("H4xrH", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $6b7508adb97679be$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $6b7508adb97679be$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $6b7508adb97679be$export$f8422650c3dec8b2);

var $gdUUy = parcelRequire("gdUUy");

var $cYNDs = parcelRequire("cYNDs");

var $c76Jg = parcelRequire("c76Jg");

var $cX8bE = parcelRequire("cX8bE");
const $6b7508adb97679be$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $6b7508adb97679be$var$POST_CONSENTS_URL = `${$6b7508adb97679be$var$BASE_CONSENTS_URL}/user`;
const $6b7508adb97679be$var$GET_CONSENTS_URL = `${$6b7508adb97679be$var$POST_CONSENTS_URL}/consents/cookies`;
const $6b7508adb97679be$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        'X-Request-Origin': 'bsc',
        'X-Request-Origin-App': $6b7508adb97679be$var$getProductForConsentHubHeader()
    });
const $6b7508adb97679be$var$getProductForConsentHubHeader = ()=>{
    const product = (0, $c76Jg.getBscGlobalState)().product;
    if (!product || product === 'all') return 'unknown';
    if ((0, $gdUUy.fg)('platform_bsc_consent_hub_x_origin_app_normalized')) // ConsentHub buckets anything that is not lowercase and hyphen-separated as `unknown`.
    return product.toLowerCase().replace(/\s+/g, '-');
    return product;
};
const $6b7508adb97679be$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $cX8bE.serializeConsents)(consentData);
        const consentTimestamp = (0, $cX8bE.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $cX8bE.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $6b7508adb97679be$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$6b7508adb97679be$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $6b7508adb97679be$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $6b7508adb97679be$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $6b7508adb97679be$export$bd9f5bcbf9cd947c();
    }
};
const $6b7508adb97679be$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $cX8bE.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $6b7508adb97679be$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$6b7508adb97679be$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $6b7508adb97679be$var$getConsentHubHeaders(),
            body: $6b7508adb97679be$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $cX8bE.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});




parcelRegister("jY7dm", function(module, exports) {
$parcel$export(module.exports, "captureCallerSignals", () => $6f0555eb2ca5b2d0$export$9a9299a14dc0c1cb);
$parcel$export(module.exports, "attributeExtensionCaller", () => $6f0555eb2ca5b2d0$export$9674893ac982a3cc);
// Detects storage writes made by browser extensions so consent enforcement doesn't block them.
// Chromium family (Chrome, Chromium Edge, Brave, Opera) all use `chrome-extension://`.
// Firefox uses `moz-extension://`; Safari uses `safari-web-extension://`.
// `ms-browser-extension://` is the legacy EdgeHTML
const $6f0555eb2ca5b2d0$export$99d1f70e3d2681ed = /(chrome-extension|moz-extension|safari-web-extension|ms-browser-extension):\/\/([^/)\s]+)/;
// A frame's script location, minus the `:line:column`. Matches V8's `at fn (url:1:2)` and
// SpiderMonkey/JavaScriptCore's `fn@url:1:2`.
const $6f0555eb2ca5b2d0$var$FRAME_LOCATION = /([a-z][a-z0-9+.-]*:\/\/[^\s)]+?)(?::\d+){0,2}\)?$/i;
// A frame line, not the `Error: ` header V8 prefixes the trace with. V8 starts frames with `at `; the
// other engines use `name@url` and emit no header, so filtering keeps indices comparable.
const $6f0555eb2ca5b2d0$var$FRAME_LINE = /^at\s|@/;
// How many leading frames can hold the code that made the write. BSC sits 2 frames above the caller —
// `captureCallerSignals` and the override closure — and neither can be inlined away: the closure is the
// value installed on `setItem`/the cookie accessor, and a minifier won't inline a function containing
// try/catch. The capture is deliberately one function for that reason.
//
// Bounding the scan is the point of this module. Matching an extension URL anywhere in the stack also
// matches every write made by Atlassian code that an extension merely called into, which turns the
// extension allowance into a blanket consent bypass for our own writes.
const $6f0555eb2ca5b2d0$var$ORIGINATOR_FRAME_WINDOW = 3;
// Nothing past the window is read. V8 defaults to 10 and a product can lower it, so pin it.
const $6f0555eb2ca5b2d0$var$CAPTURED_FRAME_LIMIT = 6;
const $6f0555eb2ca5b2d0$var$parseFrames = (stack)=>stack.split('\n').map((line)=>line.trim()).filter((line)=>$6f0555eb2ca5b2d0$var$FRAME_LINE.test(line));
const $6f0555eb2ca5b2d0$var$asExtensionCaller = (frame)=>{
    var _frame$match;
    const extension = frame === null || frame === void 0 || (_frame$match = frame.match($6f0555eb2ca5b2d0$var$FRAME_LOCATION)) === null || _frame$match === void 0 || (_frame$match = _frame$match[1]) === null || _frame$match === void 0 ? void 0 : _frame$match.match($6f0555eb2ca5b2d0$export$99d1f70e3d2681ed);
    return extension ? {
        scheme: extension[1],
        id: extension[2]
    } : null;
};
const $6f0555eb2ca5b2d0$export$d5f56ab842d0792b = (captured)=>{
    const stack = captured === null || captured === void 0 ? void 0 : captured.stack;
    if (!stack) return null;
    for (const frame of $6f0555eb2ca5b2d0$var$parseFrames(stack).slice(0, $6f0555eb2ca5b2d0$var$ORIGINATOR_FRAME_WINDOW)){
        const caller = $6f0555eb2ca5b2d0$var$asExtensionCaller(frame);
        if (caller) return caller;
    }
    return null;
};
const $6f0555eb2ca5b2d0$export$9a9299a14dc0c1cb = ()=>{
    try {
        const previousLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = $6f0555eb2ca5b2d0$var$CAPTURED_FRAME_LIMIT;
        const stack = new Error();
        Error.stackTraceLimit = previousLimit;
        return {
            stack: stack
        };
    } catch  {
        return {
            stack: new Error()
        };
    }
};
const $6f0555eb2ca5b2d0$export$9674893ac982a3cc = (signals)=>signals ? $6f0555eb2ca5b2d0$export$d5f56ab842d0792b(signals.stack) : null;

});


parcelRegister("8KLlH", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $e95b4b713d591d8b$export$ff3c91e80f54f26c);

var $fhC5O = parcelRequire("fhC5O");
class $e95b4b713d591d8b$var$ItemKeyCacheService {
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $fhC5O.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $e95b4b713d591d8b$export$ff3c91e80f54f26c = new $e95b4b713d591d8b$var$ItemKeyCacheService();

});

parcelRegister("fA9wy", function(module, exports) {
$parcel$export(module.exports, "reportSetItemError", () => $ea518d1774255ffb$export$ba6a684424c69e54);

var $cYNDs = parcelRequire("cYNDs");
/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const $ea518d1774255ffb$var$isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name: name, code: code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const $ea518d1774255ffb$export$ba6a684424c69e54 = ({ message: message, attributes: attributes, error: error })=>{
    if ($ea518d1774255ffb$var$isQuotaExceededError(error)) {
        (0, $cYNDs.Logger).error(message);
        return;
    }
    (0, $cYNDs.Logger).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message: message,
        attributes: attributes
    });
};

});


parcelRegister("1T5gr", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $408966441b7a815d$export$f1b0c189562aa9fd);

var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");

var $fhC5O = parcelRequire("fhC5O");

var $8KLlH = parcelRequire("8KLlH");

var $1EGd8 = parcelRequire("1EGd8");
const $408966441b7a815d$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, $8KLlH.ItemKeyCache).markSetByPackage(storageType === (0, $1EGd8.WebStorageType).LocalStorage ? (0, $fhC5O.CategoryStorageType).LocalStorage : (0, $fhC5O.CategoryStorageType).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, $fhC5O.Status).SUCCESS;
    } catch (e) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $fhC5O.Status).FAILED;
    }
};

});


parcelRegister("4vSIK", function(module, exports) {
$parcel$export(module.exports, "safeAccessWithErrorHandler", () => $01cb56cda1b00dd4$export$d1415594ea5ec958);
const $01cb56cda1b00dd4$export$d1415594ea5ec958 = (action, errorCase)=>{
    try {
        return action();
    } catch (err) {
        return errorCase && errorCase();
    }
};

});


parcelRegister("4pKDb", function(module, exports) {
$parcel$export(module.exports, "LOG_OUT", () => $39415973c4a881b5$export$cb307dad255adf47);
$parcel$export(module.exports, "logOutAction", () => $39415973c4a881b5$export$1a3865346be34527);
const $39415973c4a881b5$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $39415973c4a881b5$export$1a3865346be34527 = ()=>{
    return {
        type: $39415973c4a881b5$export$cb307dad255adf47
    };
};

});


parcelRegister("31ZeC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f068e4993a54a5c$export$2e2bcd8739ae039);
parcelRequire("2ycHZ");
var $4nFla = parcelRequire("4nFla");

var $9prXJ = parcelRequire("9prXJ");

var $h1vxd = parcelRequire("h1vxd");

var $6FlbJ = parcelRequire("6FlbJ");

var $jWFe4 = parcelRequire("jWFe4");

var $5Yk7j = parcelRequire("5Yk7j");

var $aGC2G = parcelRequire("aGC2G");

var $6h3Sh = parcelRequire("6h3Sh");

var $iBjad = parcelRequire("iBjad");

var $5h4vI = parcelRequire("5h4vI");

var $dQGnI = parcelRequire("dQGnI");

var $khYBz = parcelRequire("khYBz");

var $cbclE = parcelRequire("cbclE");

var $3Fdfn = parcelRequire("3Fdfn");

var $2rnki = parcelRequire("2rnki");

var $2cdbV = parcelRequire("2cdbV");

var $96ANS = parcelRequire("96ANS");

var $8fk7c = parcelRequire("8fk7c");

var $6B4eU = parcelRequire("6B4eU");

var $43E2w = parcelRequire("43E2w");

var $iRbxO = parcelRequire("iRbxO");

var $ah34q = parcelRequire("ah34q");

var $eUM4k = parcelRequire("eUM4k");

var $7rn1m = parcelRequire("7rn1m");

var $54eLq = parcelRequire("54eLq");

var $dSYAK = parcelRequire("dSYAK");

var $jwg9A = parcelRequire("jwg9A");

var $k7C1J = parcelRequire("k7C1J");
var // Need to force typescript to pick up the right combineEpics
$2f068e4993a54a5c$export$2e2bcd8739ae039 = (0, $4nFla.combineEpics)((0, $dQGnI.helpCenterBrandingEpic), (0, $dQGnI.helpCenterEpic), (0, $dQGnI.invalidateHelpCenterBrandingEpic), (0, $8fk7c.portalEpic), (0, $8fk7c.portalUploadMediaTokenEpic), (0, $8fk7c.refreshPortalUploadMediaTokenBeforeExpiryEpic), (0, $9prXJ.default), (0, $96ANS.organisationsEpic), (0, $6B4eU.requestCreateEpic), (0, $eUM4k.requestTypeSuggestionEpic), (0, $6h3Sh.connectFragmentsEpic), (0, $cbclE.default), (0, $khYBz.default), (0, $jwg9A.unsubscribedConfirmationEpic), (0, $2rnki.loginEpic), (0, $2cdbV.loginAnnouncementsEpic), (0, $5h4vI.forgotPasswordEpic), (0, $5Yk7j.fetchArticleEpic), (0, $43E2w.requestDetailsEpic), (0, $ah34q.reqSlasEpic), (0, $iRbxO.requestListEpic), (0, $7rn1m.requestsColumnSettingsEpic), (0, $jWFe4.approvalListEpic), (0, $3Fdfn.languagesEpic), (0, $54eLq.timezoneRegionsEpic), (0, $54eLq.timezonesEpic), (0, $6h3Sh.profileConnectFragmentsEpic), (0, $k7C1J.visitPortalEpic), (0, $aGC2G.completeSignupEpic), (0, $h1vxd.default), (0, $iBjad.featuredAndSortedPortalsEpic), (0, $6FlbJ.aiAnswerFeedbackPageEpic), (0, $dSYAK.uiModificationsEpic));

});
parcelRegister("9prXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5d49a3ecf2f6d5f$export$2e2bcd8739ae039);

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");

var $fVm9J = parcelRequire("fVm9J");

var $iCbt2 = parcelRequire("iCbt2");
const $d5d49a3ecf2f6d5f$var$epic = (action$)=>{
    return action$.ofType((0, $iCbt2.FETCH_USER_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).map((response)=>{
            // If we requested for a user model but never got one or got an empty user object we assume that the user is anonymous.
            if (!response.user || !response.user.accountId) return (0, $kd70W.updateUserModelAnonymousAction)();
            return (0, $kd70W.updateUserModelAction)(response.user);
        }).catch(()=>(0, $8jOUp.Observable).never()));
};
var $d5d49a3ecf2f6d5f$export$2e2bcd8739ae039 = $d5d49a3ecf2f6d5f$var$epic;

});
parcelRegister("iCbt2", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_MODEL", () => $386b22269128becc$export$d79dd8ba2ab60f61);
$parcel$export(module.exports, "fetchUserModelAction", () => $386b22269128becc$export$d4f34f8f1b2704a8);

var $hn5Mq = parcelRequire("hn5Mq");
const $386b22269128becc$export$d79dd8ba2ab60f61 = 'epic.model.FETCH_USER_MODEL';
const $386b22269128becc$export$d4f34f8f1b2704a8 = (params = {})=>{
    const excludeRequestCountsParam = {
        ...params,
        fetchRequestCounts: false
    };
    return (0, $hn5Mq.buildModelsActionCreator)($386b22269128becc$export$d79dd8ba2ab60f61, 'user')(excludeRequestCountsParam);
};

});


parcelRegister("h1vxd", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b7636b3d627f9cd$export$2e2bcd8739ae039);

var $8jOUp = parcelRequire("8jOUp");

var $kd70W = parcelRequire("kd70W");

var $fVm9J = parcelRequire("fVm9J");

var $jSu8y = parcelRequire("jSu8y");
const $6b7636b3d627f9cd$var$fetchUserRequestsCountsEpic = (action$)=>{
    return action$.ofType((0, $jSu8y.FETCH_USER_REQUESTS_COUNTS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.userRequestsCounts).map((response)=>(0, $kd70W.updateUserRequestsCountsAction)(response.userRequestsCounts)).catch(()=>(0, $8jOUp.Observable).never()));
};
var $6b7636b3d627f9cd$export$2e2bcd8739ae039 = $6b7636b3d627f9cd$var$fetchUserRequestsCountsEpic;

});
parcelRegister("jSu8y", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_REQUESTS_COUNTS_MODEL", () => $11fdf30f3527939d$export$dfecf710cdf030b1);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $11fdf30f3527939d$export$71172847a48a08a6);

var $hn5Mq = parcelRequire("hn5Mq");
const $11fdf30f3527939d$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $11fdf30f3527939d$export$71172847a48a08a6 = (0, $hn5Mq.buildModelsActionCreator)($11fdf30f3527939d$export$dfecf710cdf030b1, 'userRequestsCounts');

});


parcelRegister("6FlbJ", function(module, exports) {
$parcel$export(module.exports, "aiAnswerFeedbackPageEpic", () => $dd4e75f42acd8b09$export$ceff4b1bfa1bc6ba);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("jddwe");
var $bylfW = parcelRequire("bylfW");
const $dd4e75f42acd8b09$export$ceff4b1bfa1bc6ba = (action$)=>{
    return action$.ofType((0, $bylfW.FETCH_AI_ANSWER_FEEDBACK_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.aianswer).map((response)=>{
            return (0, $bylfW.fetchAiAnswerFeedbackSuccess)(response.aianswer);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $bylfW.fetchAiAnswerFeedbackFailure)(error));
        }));
};

});
parcelRegister("jddwe", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => (parcelRequire("bylfW")).FETCH_AI_ANSWER_FEEDBACK_MODEL);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => (parcelRequire("bylfW")).FETCH_AI_ANSWER_FEEDBACK_SUCCESS);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => (parcelRequire("bylfW")).FETCH_AI_ANSWER_FEEDBACK_FAILURE);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => (parcelRequire("bylfW")).fetchAiAnswerFeedbackModel);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => (parcelRequire("bylfW")).fetchAiAnswerFeedbackSuccess);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => (parcelRequire("bylfW")).fetchAiAnswerFeedbackFailure);

var $bylfW = parcelRequire("bylfW");

});
parcelRegister("bylfW", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => $8f96b588ac3fc4f3$export$ae77fa01ad25f4c9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => $8f96b588ac3fc4f3$export$6f922337a7af3b9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => $8f96b588ac3fc4f3$export$4daab78c9d39cdb5);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => $8f96b588ac3fc4f3$export$4514f111c053f647);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => $8f96b588ac3fc4f3$export$4da568a91bd226dc);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => $8f96b588ac3fc4f3$export$a1584ed81f70c36d);

var $hn5Mq = parcelRequire("hn5Mq");
const $8f96b588ac3fc4f3$export$ae77fa01ad25f4c9 = 'epic.model.FETCH_AI_ANSWER_FEEDBACK_MODEL';
const $8f96b588ac3fc4f3$export$6f922337a7af3b9 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_SUCCESS';
const $8f96b588ac3fc4f3$export$4daab78c9d39cdb5 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_FAILURE';
const $8f96b588ac3fc4f3$export$4514f111c053f647 = (0, $hn5Mq.buildModelsActionCreator)($8f96b588ac3fc4f3$export$ae77fa01ad25f4c9, 'aianswer');
const $8f96b588ac3fc4f3$export$4da568a91bd226dc = (aiAnswerFeedbackResponse)=>({
        type: $8f96b588ac3fc4f3$export$6f922337a7af3b9,
        payload: aiAnswerFeedbackResponse
    });
const $8f96b588ac3fc4f3$export$a1584ed81f70c36d = (error)=>({
        type: $8f96b588ac3fc4f3$export$4daab78c9d39cdb5,
        payload: {
            error: error
        }
    });

});



parcelRegister("jWFe4", function(module, exports) {
$parcel$export(module.exports, "approvalListEpic", () => $fda70f0676ce7246$export$77e5ddee619f2d69);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("gnTDP");
var $4FH4O = parcelRequire("4FH4O");
const $fda70f0676ce7246$export$77e5ddee619f2d69 = (action$)=>{
    return action$.ofType((0, $4FH4O.FETCH_APPROVAL_LIST_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.approvalListFilter && !!response.approvalListFilter.requests).map((response)=>{
            return (0, $4FH4O.fetchApprovalListSuccess)(response.approvalListFilter);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $4FH4O.fetchApprovalListFailure)(error));
        }));
};

});
parcelRegister("gnTDP", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => (parcelRequire("4FH4O")).FETCH_APPROVAL_LIST_MODEL);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => (parcelRequire("4FH4O")).FETCH_APPROVAL_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => (parcelRequire("4FH4O")).FETCH_APPROVAL_LIST_FAILURE);
$parcel$export(module.exports, "fetchApprovalListModel", () => (parcelRequire("4FH4O")).fetchApprovalListModel);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => (parcelRequire("4FH4O")).fetchApprovalListSuccess);
$parcel$export(module.exports, "fetchApprovalListFailure", () => (parcelRequire("4FH4O")).fetchApprovalListFailure);

var $4FH4O = parcelRequire("4FH4O");

});
parcelRegister("4FH4O", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => $08b2749bc3880b32$export$2e7343d23ce2e264);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => $08b2749bc3880b32$export$42d9c935d4bfef61);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => $08b2749bc3880b32$export$132a25b8ba1cc94);
$parcel$export(module.exports, "fetchApprovalListModel", () => $08b2749bc3880b32$export$c4decf32e9c96894);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => $08b2749bc3880b32$export$2ac6685d409334fa);
$parcel$export(module.exports, "fetchApprovalListFailure", () => $08b2749bc3880b32$export$9059cd838e20fcf6);

var $hn5Mq = parcelRequire("hn5Mq");
const $08b2749bc3880b32$export$2e7343d23ce2e264 = 'epic.model.FETCH_APPROVAL_LIST_MODEL';
const $08b2749bc3880b32$export$42d9c935d4bfef61 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_SUCCESS';
const $08b2749bc3880b32$export$132a25b8ba1cc94 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_FAILURE';
const $08b2749bc3880b32$export$c4decf32e9c96894 = (0, $hn5Mq.buildModelsActionCreator)($08b2749bc3880b32$export$2e7343d23ce2e264, 'approvalListFilter');
const $08b2749bc3880b32$export$2ac6685d409334fa = (approvalListFilter)=>({
        type: $08b2749bc3880b32$export$42d9c935d4bfef61,
        payload: approvalListFilter
    });
const $08b2749bc3880b32$export$9059cd838e20fcf6 = (error)=>({
        type: $08b2749bc3880b32$export$132a25b8ba1cc94,
        payload: {
            error: error
        }
    });

});



parcelRegister("5Yk7j", function(module, exports) {
$parcel$export(module.exports, "fetchArticleEpic", () => $93fe91d06a82e0f5$export$3c4e80b80ffa2c37);

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("hpavy");
var $kSHuF = parcelRequire("kSHuF");

var $jBiia = parcelRequire("jBiia");

var $G6QpT = parcelRequire("G6QpT");

var $fVm9J = parcelRequire("fVm9J");
const $93fe91d06a82e0f5$export$3c4e80b80ffa2c37 = (action$)=>action$.ofType((0, $kSHuF.FETCH_ARTICLE)).mergeMap((action)=>{
        const { meta: meta } = action;
        return (0, $fVm9J.default)(action.payload).filter((response)=>!!response.kbPage).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $kSHuF.fetchArticleSuccess)(response.kbPage);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $jBiia.legacySendEvent)((0, $G6QpT.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $8jOUp.Observable).of((0, $kSHuF.fetchArticleFailure)(action.payload.params.id, error));
        });
    });

});

parcelRegister("aGC2G", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $16edf412e1dd5c61$export$c3902030a5d4d47a);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("9bj9n");
var $cP3WD = parcelRequire("cP3WD");
const $16edf412e1dd5c61$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $cP3WD.FETCH_COMPLETE_SIGNUP_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.completeSignup && !!response.completeSignup.emailAddress).map((response)=>{
            return (0, $cP3WD.fetchCompleteSignupSuccess)(response.completeSignup);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $cP3WD.fetchCompleteSignupFailure)(error));
        }));
};

});

parcelRegister("6h3Sh", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsEpic", () => $68d1b7aeff371a9c$export$da9f118c732015e);
$parcel$export(module.exports, "profileConnectFragmentsEpic", () => $68d1b7aeff371a9c$export$a3ede6811238e533);

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("1Gp5B");
var $6GUVM = parcelRequire("6GUVM");

var $fVm9J = parcelRequire("fVm9J");
const $68d1b7aeff371a9c$export$da9f118c732015e = (action$)=>action$.ofType((0, $6GUVM.FETCH_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $fVm9J.default)(action.payload, {
            type: action.payload.params.portalPage === 'CREATE_REQUEST' ? 'secondary' : 'primary'
        }).filter((response)=>!!response.portalWebFragments).map((response)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $6GUVM.fetchConnectFragmentsSuccess)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                requestKey: requestKey,
                portalPageName: portalPage,
                connectFragments: response.portalWebFragments
            });
        }).catch((error)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $8jOUp.Observable).of((0, $6GUVM.fetchConnectFragmentsFailure)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                error: error,
                requestKey: requestKey,
                portalPageName: portalPage
            }));
        }));
const $68d1b7aeff371a9c$export$a3ede6811238e533 = (action$)=>action$.ofType((0, $6GUVM.FETCH_PROFILE_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.profileWebFragments).map((response)=>{
            return (0, $6GUVM.fetchProfileConnectFragmentsSuccess)(response.profileWebFragments);
        }).catch((error)=>(0, $8jOUp.Observable).of((0, $6GUVM.fetchProfileConnectFragmentsFailure)(error))));

});
parcelRegister("1Gp5B", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => (parcelRequire("6GUVM")).FETCH_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("6GUVM")).FETCH_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("6GUVM")).FETCH_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => (parcelRequire("6GUVM")).FETCH_PROFILE_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("6GUVM")).FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("6GUVM")).FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => (parcelRequire("6GUVM")).fetchConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => (parcelRequire("6GUVM")).fetchConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => (parcelRequire("6GUVM")).fetchProfileConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => (parcelRequire("6GUVM")).fetchProfileConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => (parcelRequire("6GUVM")).fetchConnectFragmentsAction);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => (parcelRequire("6GUVM")).fetchProfileConnectFragmentsAction);

var $6GUVM = parcelRequire("6GUVM");

});
parcelRegister("6GUVM", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => $bafd9d56c7ccc4b0$export$be3b6b321a4b2e30);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => $bafd9d56c7ccc4b0$export$8c14498d55ee35d5);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => $bafd9d56c7ccc4b0$export$c4d0c4cc4d23ec29);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => $bafd9d56c7ccc4b0$export$ac33d6e70ef6394b);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => $bafd9d56c7ccc4b0$export$93b4a584ef971c3e);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => $bafd9d56c7ccc4b0$export$bd274633ff57df1a);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => $bafd9d56c7ccc4b0$export$acefa59403de59c3);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => $bafd9d56c7ccc4b0$export$9b734d900be9577d);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => $bafd9d56c7ccc4b0$export$2e62b6b504d95c08);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => $bafd9d56c7ccc4b0$export$ea99ad4f53065bdf);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => $bafd9d56c7ccc4b0$export$802082c6f9bfe7);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => $bafd9d56c7ccc4b0$export$3b319d8313349388);

var $hn5Mq = parcelRequire("hn5Mq");
const $bafd9d56c7ccc4b0$export$be3b6b321a4b2e30 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_SUCCESS';
const $bafd9d56c7ccc4b0$export$8c14498d55ee35d5 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_FAILURE';
const $bafd9d56c7ccc4b0$export$c4d0c4cc4d23ec29 = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS';
const $bafd9d56c7ccc4b0$export$ac33d6e70ef6394b = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE';
const $bafd9d56c7ccc4b0$export$93b4a584ef971c3e = 'epic.model.FETCH_CONNECT_FRAGMENTS';
const $bafd9d56c7ccc4b0$export$bd274633ff57df1a = (0, $hn5Mq.buildModelsActionCreator)($bafd9d56c7ccc4b0$export$93b4a584ef971c3e, 'portalWebFragments');
const $bafd9d56c7ccc4b0$export$acefa59403de59c3 = 'epic.model.FETCH_PROFILE_CONNECT_FRAGMENTS';
const $bafd9d56c7ccc4b0$export$9b734d900be9577d = (0, $hn5Mq.buildModelsActionCreator)($bafd9d56c7ccc4b0$export$acefa59403de59c3, 'profileWebFragments');
const $bafd9d56c7ccc4b0$export$2e62b6b504d95c08 = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey })=>({
        type: $bafd9d56c7ccc4b0$export$be3b6b321a4b2e30,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            connectFragments: connectFragments,
            requestKey: requestKey
        }
    });
const $bafd9d56c7ccc4b0$export$ea99ad4f53065bdf = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey })=>({
        type: $bafd9d56c7ccc4b0$export$8c14498d55ee35d5,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error,
            requestKey: requestKey
        }
    });
const $bafd9d56c7ccc4b0$export$802082c6f9bfe7 = (fragments)=>({
        type: $bafd9d56c7ccc4b0$export$c4d0c4cc4d23ec29,
        payload: {
            fragments: fragments
        }
    });
const $bafd9d56c7ccc4b0$export$3b319d8313349388 = (error)=>({
        type: $bafd9d56c7ccc4b0$export$ac33d6e70ef6394b,
        payload: {
            error: error
        }
    });

});



parcelRegister("iBjad", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsEpic", () => $5bf19250c44c147a$export$482dd9b2afe107b5);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("ahGdU");
var $gmXRj = parcelRequire("gmXRj");

var $hCnLH = parcelRequire("hCnLH");

var $hbFy6 = parcelRequire("hbFy6");
const $5bf19250c44c147a$var$emptyFeaturedAndSortedPortalsResponse = {
    portals: [],
    total: 0
};
const $5bf19250c44c147a$export$482dd9b2afe107b5 = (action$)=>{
    return action$.ofType((0, $gmXRj.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL)).mergeMap((action)=>{
        const { isPortalReorderingSelected: isPortalReorderingSelected, ...params } = action.payload.params;
        if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)()) return (0, $8jOUp.Observable).from((0, $hbFy6.fetchFeaturedAndSortedPortalsData)(params).toPromise().then((response)=>(0, $hbFy6.convertToFeaturedAndSortedPortalsResponse)(response))).flatMap((data)=>{
            return (0, $8jOUp.Observable).of((0, $gmXRj.fetchFeaturedAndSortedPortalsSuccess)(data || $5bf19250c44c147a$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gmXRj.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $8jOUp.Observable).of((0, $gmXRj.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
        return (0, $fVm9J.default)({
            ...action.payload,
            params: params
        }).filter((response)=>!!response.featuredAndSortedPortals).flatMap((response)=>{
            return (0, $8jOUp.Observable).of((0, $gmXRj.fetchFeaturedAndSortedPortalsSuccess)(response.featuredAndSortedPortals || $5bf19250c44c147a$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gmXRj.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $8jOUp.Observable).of((0, $gmXRj.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
    });
};

});
parcelRegister("ahGdU", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => (parcelRequire("gmXRj")).FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => (parcelRequire("gmXRj")).fetchFeaturedAndSortedPortalsSuccess);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => (parcelRequire("gmXRj")).FETCH_FEATURED_AND_SORTED_PORTALS_MODEL);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => (parcelRequire("gmXRj")).fetchFeaturedAndSortedPortalsModel);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => (parcelRequire("gmXRj")).FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => (parcelRequire("gmXRj")).fetchFeaturedAndSortedPortalsFailure);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => (parcelRequire("gmXRj")).REORDER_FEATURED_PORTAL);
$parcel$export(module.exports, "reorderFeaturedPortal", () => (parcelRequire("gmXRj")).reorderFeaturedPortal);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => (parcelRequire("gmXRj")).MARK_PORTAL_FEATURED);
$parcel$export(module.exports, "markPortalFeatured", () => (parcelRequire("gmXRj")).markPortalFeatured);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("gmXRj")).UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => (parcelRequire("gmXRj")).updatePortalReorderSettingsSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => (parcelRequire("gmXRj")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => (parcelRequire("gmXRj")).updatePortalReorderSettingsModel);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => (parcelRequire("gmXRj")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => (parcelRequire("gmXRj")).updatePortalReorderSettingsModelSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => (parcelRequire("gmXRj")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => (parcelRequire("gmXRj")).updatePortalReorderSettingsModelFailure);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => (parcelRequire("gmXRj")).UPDATE_PORTAL_REORDER_SETTINGS_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => (parcelRequire("gmXRj")).updatePortalReorderSettingsFailure);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => (parcelRequire("gmXRj")).RESET_PORTAL_REORDER_SETTINGS);
$parcel$export(module.exports, "resetPortalReorderSettings", () => (parcelRequire("gmXRj")).resetPortalReorderSettings);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("gmXRj")).RESET_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => (parcelRequire("gmXRj")).resetPortalReorderSettingsSuccess);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => (parcelRequire("gmXRj")).MARK_PORTAL_REORDER_SETTINGS_DIRTY);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => (parcelRequire("gmXRj")).markPortalReorderSettingsDirty);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => (parcelRequire("gmXRj")).TOGGLE_PORTAL_VISIBILITY);
$parcel$export(module.exports, "togglePortalVisibility", () => (parcelRequire("gmXRj")).togglePortalVisibility);

var $gmXRj = parcelRequire("gmXRj");

});
parcelRegister("gmXRj", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => $e1dd8b97b1c47d64$export$8772f11deb28968a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => $e1dd8b97b1c47d64$export$6ed163277f07d17a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => $e1dd8b97b1c47d64$export$9198b985767ee6a9);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => $e1dd8b97b1c47d64$export$c4ada71ac24d5427);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => $e1dd8b97b1c47d64$export$e78177131adb1a7a);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => $e1dd8b97b1c47d64$export$f04d3c0a6161427f);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => $e1dd8b97b1c47d64$export$68f1a628095e7df5);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => $e1dd8b97b1c47d64$export$aa2114acd4f820aa);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => $e1dd8b97b1c47d64$export$2d425395f1203ae4);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => $e1dd8b97b1c47d64$export$e6dde7e78d51edc9);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => $e1dd8b97b1c47d64$export$d6299724cb4f13de);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => $e1dd8b97b1c47d64$export$47862f368a701d13);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => $e1dd8b97b1c47d64$export$bce4411b856ef9e5);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => $e1dd8b97b1c47d64$export$a90731f74ba59c30);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => $e1dd8b97b1c47d64$export$6ea18f901a4f825e);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => $e1dd8b97b1c47d64$export$6d3c5bcff4d8dcfc);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => $e1dd8b97b1c47d64$export$9d041bf07bd04f34);
$parcel$export(module.exports, "markPortalFeatured", () => $e1dd8b97b1c47d64$export$3b1a77584c9a6b81);
$parcel$export(module.exports, "togglePortalVisibility", () => $e1dd8b97b1c47d64$export$89b8e7ec4e1c2d07);
$parcel$export(module.exports, "reorderFeaturedPortal", () => $e1dd8b97b1c47d64$export$62b3d711c52e9aa2);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => $e1dd8b97b1c47d64$export$ff946f5ffd1293d7);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => $e1dd8b97b1c47d64$export$eeed66775c51f217);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => $e1dd8b97b1c47d64$export$eb2d78b304e5909c);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => $e1dd8b97b1c47d64$export$8fabcd6d8271b790);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => $e1dd8b97b1c47d64$export$4b50f99aebbcd6b7);
$parcel$export(module.exports, "resetPortalReorderSettings", () => $e1dd8b97b1c47d64$export$4157bb81256cfd7f);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => $e1dd8b97b1c47d64$export$d0f9348a57407b6c);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => $e1dd8b97b1c47d64$export$5c52eef312473e8b);
const $e1dd8b97b1c47d64$export$8772f11deb28968a = 'epic.model.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL';
const $e1dd8b97b1c47d64$export$6ed163277f07d17a = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS';
const $e1dd8b97b1c47d64$export$9198b985767ee6a9 = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE';
const $e1dd8b97b1c47d64$export$c4ada71ac24d5427 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_FEATURED';
const $e1dd8b97b1c47d64$export$e78177131adb1a7a = 'state.ui.featuredAndSortedPortals.REORDER_FEATURED_PORTAL';
const $e1dd8b97b1c47d64$export$f04d3c0a6161427f = 'state.ui.featuredAndSortedPortals.TOGGLE_PORTAL_VISIBILITY';
const $e1dd8b97b1c47d64$export$68f1a628095e7df5 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL';
const $e1dd8b97b1c47d64$export$aa2114acd4f820aa = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS';
const $e1dd8b97b1c47d64$export$2d425395f1203ae4 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE';
const $e1dd8b97b1c47d64$export$e6dde7e78d51edc9 = 'state.persisted.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS';
const $e1dd8b97b1c47d64$export$d6299724cb4f13de = 'state.ui.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE';
const $e1dd8b97b1c47d64$export$47862f368a701d13 = 'epic.portal-reorder-settings.RESET_PORTAL_REORDER_SETTINGS';
const $e1dd8b97b1c47d64$export$bce4411b856ef9e5 = 'state.ui.featuredAndSortedPortals.RESET_PORTAL_REORDER_SETTINGS_SUCCESS';
const $e1dd8b97b1c47d64$export$a90731f74ba59c30 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_REORDER_SETTINGS_DIRTY';
/* isPortalReorderingSelected is used to distinguish between the calls made to featuredAndSortedPortals model in case of help-seeker view from that of portal reordering screen view, inside the state reducers */ const $e1dd8b97b1c47d64$var$buildModelsActionCreatorForFeaturedAndSortedPortals = (actionType, type)=>(params = {}, isPortalReorderingSelected)=>({
            type: actionType,
            payload: {
                type: type,
                params: {
                    ...params,
                    isPortalReorderingSelected: isPortalReorderingSelected
                }
            }
        });
const $e1dd8b97b1c47d64$export$6ea18f901a4f825e = $e1dd8b97b1c47d64$var$buildModelsActionCreatorForFeaturedAndSortedPortals($e1dd8b97b1c47d64$export$8772f11deb28968a, 'featuredAndSortedPortals');
const $e1dd8b97b1c47d64$export$6d3c5bcff4d8dcfc = (featuredAndSortedPortalsModel, requestParams)=>({
        requestParams: requestParams,
        type: $e1dd8b97b1c47d64$export$6ed163277f07d17a,
        payload: featuredAndSortedPortalsModel
    });
const $e1dd8b97b1c47d64$export$9d041bf07bd04f34 = (error, requestParams)=>({
        requestParams: requestParams,
        type: $e1dd8b97b1c47d64$export$9198b985767ee6a9,
        payload: {
            error: error
        }
    });
const $e1dd8b97b1c47d64$export$3b1a77584c9a6b81 = (id, isFeatured)=>({
        type: $e1dd8b97b1c47d64$export$c4ada71ac24d5427,
        payload: {
            isFeatured: isFeatured,
            id: id
        }
    });
const $e1dd8b97b1c47d64$export$89b8e7ec4e1c2d07 = (id, hiddenFromHomeScreen)=>({
        type: $e1dd8b97b1c47d64$export$f04d3c0a6161427f,
        payload: {
            id: id,
            hiddenFromHomeScreen: hiddenFromHomeScreen
        }
    });
const $e1dd8b97b1c47d64$export$62b3d711c52e9aa2 = (oldIndex, newIndex)=>({
        type: $e1dd8b97b1c47d64$export$e78177131adb1a7a,
        payload: {
            oldIndex: oldIndex,
            newIndex: newIndex
        }
    });
const $e1dd8b97b1c47d64$export$ff946f5ffd1293d7 = (meta)=>({
        meta: meta,
        type: $e1dd8b97b1c47d64$export$68f1a628095e7df5
    });
const $e1dd8b97b1c47d64$export$eeed66775c51f217 = (meta)=>({
        meta: meta,
        type: $e1dd8b97b1c47d64$export$aa2114acd4f820aa
    });
const $e1dd8b97b1c47d64$export$eb2d78b304e5909c = (meta, error)=>({
        meta: meta,
        error: error,
        type: $e1dd8b97b1c47d64$export$2d425395f1203ae4
    });
const $e1dd8b97b1c47d64$export$8fabcd6d8271b790 = (featuredPortalIds, sortBy, orderedPortalIds, hiddenPortalIds)=>({
        type: $e1dd8b97b1c47d64$export$e6dde7e78d51edc9,
        payload: {
            featuredPortalIds: featuredPortalIds,
            sortBy: sortBy,
            orderedPortalIds: orderedPortalIds,
            hiddenPortalIds: hiddenPortalIds
        }
    });
const $e1dd8b97b1c47d64$export$4b50f99aebbcd6b7 = (error)=>({
        type: $e1dd8b97b1c47d64$export$d6299724cb4f13de,
        payload: {
            error: error
        }
    });
const $e1dd8b97b1c47d64$export$4157bb81256cfd7f = (shouldRedirect)=>({
        type: $e1dd8b97b1c47d64$export$47862f368a701d13,
        payload: {
            shouldRedirect: shouldRedirect
        }
    });
const $e1dd8b97b1c47d64$export$d0f9348a57407b6c = ()=>({
        type: $e1dd8b97b1c47d64$export$a90731f74ba59c30
    });
const $e1dd8b97b1c47d64$export$5c52eef312473e8b = (featuredPortalIds, orderedPortalIds, sortBy)=>({
        type: $e1dd8b97b1c47d64$export$bce4411b856ef9e5,
        payload: {
            featuredPortalIds: featuredPortalIds,
            orderedPortalIds: orderedPortalIds,
            sortBy: sortBy
        }
    });

});


parcelRegister("hbFy6", function(module, exports) {
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsData", () => $50b4ddb93da041fc$export$1e547feda5a72cb5);
$parcel$export(module.exports, "convertToFeaturedAndSortedPortalsResponse", () => $50b4ddb93da041fc$export$af9ca8a283fc9983);

var $3mBpq = parcelRequire("3mBpq");

var $lJ0l5 = parcelRequire("lJ0l5");

var $4270B = parcelRequire("4270B");

var $fuVmc = parcelRequire("fuVmc");

var $kbkME = parcelRequire("kbkME");
const $50b4ddb93da041fc$export$1e547feda5a72cb5 = (params)=>{
    return (0, $4270B.fetchQuery)((0, $kbkME.getRelayEnvironment)(), (0, $3mBpq.default), {
        cloudId: (0, $fuVmc.getCloudId)(),
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        sortOrder: $50b4ddb93da041fc$var$getSortIngParams(params.sortBy),
        portalsFilter: $50b4ddb93da041fc$var$getFilterParams(params.exploreAll)
    });
};
const $50b4ddb93da041fc$var$getFilterParams = (exploreAll)=>{
    if (exploreAll) return undefined;
    return {
        typeFilter: [
            'VISIBLE'
        ]
    };
};
const $50b4ddb93da041fc$var$getSortIngParams = (sortBy)=>{
    if (sortBy === 'ALPHABETICALLY') return 'NAME_ASCENDING';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $50b4ddb93da041fc$var$getSortIngValues = (sortBy)=>{
    if (sortBy === 'NAME_ASCENDING') return 'ALPHABETICALLY';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $50b4ddb93da041fc$export$af9ca8a283fc9983 = (response)=>{
    var _response$helpCenter;
    if (response === undefined) return undefined;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') {
        const extensions = data.extensions;
        const message = data.message;
        if (extensions && Array.isArray(extensions) && extensions.length > 0 && message) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const { statusCode: statusCode } = extensions[0];
            const xhr = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                status: statusCode,
                responseType: 'json',
                response: data
            };
            throw new (0, $lJ0l5.AjaxError)(`${message} with status ${String(statusCode)}`, xhr, {});
        }
        throw new Error(message || '');
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        const portals = data.portals;
        const { portalsList: portalsList } = portals || {
            portalsList: []
        };
        return {
            sortBy: $50b4ddb93da041fc$var$getSortIngValues(portals === null || portals === void 0 ? void 0 : portals.sortOrder),
            // Backend will return all the portals there is no pagination
            total: portalsList === null || portalsList === void 0 ? void 0 : portalsList.length,
            // This FF has been rolled out so this is always true
            isPortalHidingEnabled: true,
            portals: (portalsList === null || portalsList === void 0 ? void 0 : portalsList.map((portal)=>({
                    // right now id is number will have to verify while backend integration
                    id: parseInt(portal.id, 10),
                    key: portal.key || '',
                    name: portal.name || '',
                    description: portal.description || '',
                    logoUrl: portal.logoUrl || undefined,
                    rank: portal.rank || -1,
                    portalBaseUrl: portal.portalBaseUrl,
                    isFeatured: !!portal.isFeatured,
                    hiddenFromHomeScreen: !!portal.isHidden,
                    isPortalNotVisibleOnHelpCentre: false
                }))) || []
        };
    }
    return undefined;
};

});
parcelRegister("3mBpq", function(module, exports) {
$parcel$export(module.exports, "default", () => $52751d79da5b8e9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d849493470a62f53c7a36f89d8810125>>
 * @relayHash 25e6269361cd6efc34c09587ad76c352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e
const $52751d79da5b8e9c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortOrder"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "portalsFilter",
                "variableName": "portalsFilter"
            },
            {
                "kind": "Variable",
                "name": "sortOrder",
                "variableName": "sortOrder"
            }
        ],
        "concreteType": "HelpCenterPortals",
        "kind": "LinkedField",
        "name": "portals",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sortOrder"
            },
            {
                "concreteType": "HelpCenterPortal",
                "kind": "LinkedField",
                "name": "portalsList",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "logoUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "portalBaseUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isFeatured"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isHidden"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rank"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e",
            "metadata": {},
            "name": "featuredAndSortedPortalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52751d79da5b8e9c$var$node.hash = "db239181519d00ccb6f4d7cba5dc3acd";
var $52751d79da5b8e9c$export$2e2bcd8739ae039 = $52751d79da5b8e9c$var$node;

});



parcelRegister("5h4vI", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $89da27cf43337d24$export$cb36b6e8b9a45314);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("5MEXK");
var $bfKnT = parcelRequire("bfKnT");

var $dSuNn = parcelRequire("dSuNn");
const $89da27cf43337d24$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $dSuNn.FETCH_FORGOT_PASSWORD_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.forgotPassword && !!response.forgotPassword.resetUrl).map((response)=>{
            return (0, $bfKnT.fetchForgotPasswordModelSuccess)(response.forgotPassword);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $bfKnT.fetchForgotPasswordModelFailure)(error));
        }));
};

});
parcelRegister("5MEXK", function(module, exports) {
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => (parcelRequire("bfKnT")).fetchForgotPasswordModelSuccess);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => (parcelRequire("bfKnT")).fetchForgotPasswordModelFailure);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("bfKnT")).FETCH_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("bfKnT")).FETCH_FORGOT_PASSWORD_FAILURE);

var $bfKnT = parcelRequire("bfKnT");

});
parcelRegister("bfKnT", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => $abd17f845e87f728$export$78f743c8c0190142);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => $abd17f845e87f728$export$aeb2acd4962d8ce9);
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => $abd17f845e87f728$export$f5ac004adf4f85e3);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => $abd17f845e87f728$export$d6a87818b7101f95);
const $abd17f845e87f728$export$78f743c8c0190142 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_SUCCESS';
const $abd17f845e87f728$export$aeb2acd4962d8ce9 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_FAILURE';
const $abd17f845e87f728$export$f5ac004adf4f85e3 = (forgotPasswordModel)=>({
        payload: forgotPasswordModel,
        type: $abd17f845e87f728$export$78f743c8c0190142
    });
const $abd17f845e87f728$export$d6a87818b7101f95 = (error)=>({
        type: $abd17f845e87f728$export$aeb2acd4962d8ce9,
        payload: {
            error: error
        }
    });

});


parcelRegister("dSuNn", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_MODEL", () => $2459ebb2abeeac60$export$8908eff00e7804c6);
$parcel$export(module.exports, "fetchForgotPasswordModel", () => $2459ebb2abeeac60$export$41d4a614faed30ee);

var $hn5Mq = parcelRequire("hn5Mq");
const $2459ebb2abeeac60$export$8908eff00e7804c6 = 'epic.model.FETCH_FORGOT_PASSWORD_MODEL';
const $2459ebb2abeeac60$export$41d4a614faed30ee = (0, $hn5Mq.buildModelsActionCreator)($2459ebb2abeeac60$export$8908eff00e7804c6, 'forgotPassword');

});


parcelRegister("dQGnI", function(module, exports) {
$parcel$export(module.exports, "helpCenterEpic", () => $28c0549b9fa34a2f$export$5b8469c39769260e);
$parcel$export(module.exports, "invalidateHelpCenterBrandingEpic", () => $28c0549b9fa34a2f$export$dc52639d81083812);
$parcel$export(module.exports, "helpCenterBrandingEpic", () => $28c0549b9fa34a2f$export$10de7c69d36b21f6);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $4270B = parcelRequire("4270B");
parcelRequire("bFWGU");
var $dhHUc = parcelRequire("dhHUc");

var $hCnLH = parcelRequire("hCnLH");

var $gAOgD = parcelRequire("gAOgD");

var $kbkME = parcelRequire("kbkME");

var $fVm9J = parcelRequire("fVm9J");

var $3kyZk = parcelRequire("3kyZk");
const $28c0549b9fa34a2f$export$5b8469c39769260e = (action$)=>{
    return action$.ofType((0, $3kyZk.FETCH_HELP_CENTER_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.sharedPortal).map((response)=>{
            return (0, $dhHUc.updateHelpCenterModelAction)(response.sharedPortal);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $8jOUp.Observable).never()));
};
const $28c0549b9fa34a2f$export$dc52639d81083812 = (action$)=>{
    return action$.ofType((0, $3kyZk.INVALIDATE_HELP_CENTER_RELAY_STORE)).mergeMap(()=>{
        // invalidate local cache of relay store for help center branding
        (0, $4270B.commitLocalUpdate)((0, $kbkME.getRelayEnvironment)(), (relayStore)=>{
            const root = relayStore.getRoot();
            const query = root.getLinkedRecord('helpCenter', {
                cloudId: (0, $fuVmc.getCloudId)()
            });
            const helpCenter = query === null || query === void 0 ? void 0 : query.getLinkedRecord('helpCenterById', {
                helpCenterAri: (0, $fuVmc.getHelpCenterAri)()
            });
            helpCenter === null || helpCenter === void 0 || helpCenter.invalidateRecord();
        });
        const noAction = (0, $8jOUp.Observable).never();
        return noAction;
    });
};
const $28c0549b9fa34a2f$export$10de7c69d36b21f6 = (action$)=>{
    return action$.ofType((0, $3kyZk.FETCH_HELP_CENTER_BRANDING_MODEL)).mergeMap((action)=>{
        const noAction = (0, $8jOUp.Observable).never();
        if ((0, $lFpPv.isDefaultHCUsingGqlBrandingCalls)() || (0, $hCnLH.isKoshEnabledForDefaultHelpCenter)()) return (0, $8jOUp.Observable).from((0, $gAOgD.fetchBrandingData)().toPromise().then((response)=>(0, $gAOgD.convertToHCBrandingResponse)(response))).filter((data)=>!!data).flatMap((data)=>{
            if (data) return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingModelAction)(data)), (0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingLoaderAction)(true)));
            throw new Error('No data');
        }).catch(()=>(0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingLoaderAction)(true)));
        return (0, $8jOUp.Observable).from((0, $fVm9J.default)(action.payload).filter((response)=>!!response.helpCenterBranding).flatMap((response)=>{
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingModelAction)(response.helpCenterBranding)), (0, $8jOUp.Observable).of((0, $dhHUc.updateHCBrandingLoaderAction)(true)));
        }).catch((_)=>noAction));
    });
};

});
parcelRegister("gAOgD", function(module, exports) {
$parcel$export(module.exports, "fetchBrandingData", () => $2110ab3e2aa15d52$export$7bfdb01d731b8001);
$parcel$export(module.exports, "convertToHCBrandingResponse", () => $2110ab3e2aa15d52$export$4560b37f8fc33ae3);

var $dDgZw = parcelRequire("dDgZw");

var $fuVmc = parcelRequire("fuVmc");

var $4270B = parcelRequire("4270B");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $kbkME = parcelRequire("kbkME");
const $2110ab3e2aa15d52$export$7bfdb01d731b8001 = ()=>{
    return (0, $4270B.fetchQuery)((0, $kbkME.getRelayEnvironment)(), (0, $dDgZw.default), {
        cloudId: (0, $fuVmc.getCloudId)(),
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)()
    }, {
        fetchPolicy: 'store-or-network'
    });
};
const $2110ab3e2aa15d52$var$mapTranslations = (translations, fieldName, acc)=>{
    translations === null || translations === void 0 || translations.forEach((translation)=>{
        if (translation && acc[translation === null || translation === void 0 ? void 0 : translation.locale] !== undefined) acc[translation.locale][fieldName] = translation.value;
        else if (translation) acc[translation === null || translation === void 0 ? void 0 : translation.locale] = {
            [fieldName]: translation.value,
            localeDisplayName: translation.localeDisplayName
        };
    });
};
const $2110ab3e2aa15d52$export$4560b37f8fc33ae3 = (response)=>{
    var _response$helpCenter;
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        var _homePageAnnouncement, _homePageAnnouncement2;
        const branding = data.helpCenterBranding;
        const announcements = data.announcements;
        const sharedPortalName = data.name;
        const { homePageAnnouncements: homePageAnnouncements } = announcements || {};
        const { logo: logo, banner: banner, homePageTitle: homePageTitle, colors: colors, hasTopBarBeenSplit: hasTopBarBeenSplit } = branding;
        const initialTranslation = {};
        let translations = {};
        if (homePageAnnouncements) translations = homePageAnnouncements === null || homePageAnnouncements === void 0 ? void 0 : homePageAnnouncements.filter((announcement)=>!!announcement).reduce((acc, announcement)=>{
            const { nameTranslationsRaw: nameTranslationsRaw, descriptionTranslationsRaw: descriptionTranslationsRaw } = announcement;
            $2110ab3e2aa15d52$var$mapTranslations(nameTranslationsRaw, 'announcementHeader', acc);
            $2110ab3e2aa15d52$var$mapTranslations(descriptionTranslationsRaw, 'announcementMessage', acc);
            return acc;
        }, initialTranslation);
        $2110ab3e2aa15d52$var$mapTranslations(sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.translations, 'sharedPortalName', translations);
        $2110ab3e2aa15d52$var$mapTranslations(homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.translations, 'helpCenterTitle', translations);
        const getDefaultTitle = ()=>{
            if (isCSM) return 'How can we help?';
            return 'Welcome to the Help Center';
        };
        const portalThemeColor = (colors === null || colors === void 0 ? void 0 : colors.primary) || '#0074e0';
        const helpCenterTitleColor = (colors === null || colors === void 0 ? void 0 : colors.bannerTextColor) || '#ffffff';
        return {
            translations: translations,
            portalThemeColor: portalThemeColor,
            helpCenterTitleColor: helpCenterTitleColor,
            logoUrl: (logo === null || logo === void 0 ? void 0 : logo.url) || '',
            logoId: (logo === null || logo === void 0 ? void 0 : logo.fileId) || '',
            bannerMediaApiFileId: (banner === null || banner === void 0 ? void 0 : banner.fileId) || '',
            bannerMediaApiUrl: (banner === null || banner === void 0 ? void 0 : banner.url) || '',
            helpCenterTitle: (homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.default) || getDefaultTitle(),
            canEditAnnouncement: !!(announcements !== null && announcements !== void 0 && announcements.canEditHomePageAnnouncement),
            userInitialAnnouncementHeader: homePageAnnouncements && ((_homePageAnnouncement = homePageAnnouncements[0]) === null || _homePageAnnouncement === void 0 ? void 0 : _homePageAnnouncement.name) || '',
            userInitialAnnouncementMessageWiki: homePageAnnouncements && ((_homePageAnnouncement2 = homePageAnnouncements[0]) === null || _homePageAnnouncement2 === void 0 ? void 0 : _homePageAnnouncement2.description) || '',
            sharedPortalName: isCSM ? '' : (sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.default) || '',
            siteDefaultLanguageTag: data.siteDefaultLanguageTag || 'en-US',
            userLanguageTag: data.userLanguageTag || 'en-US',
            topBarColor: (colors === null || colors === void 0 ? void 0 : colors.topBarColor) || portalThemeColor,
            topBarTextColor: (colors === null || colors === void 0 ? void 0 : colors.topBarTextColor) || helpCenterTitleColor,
            hasTopBarBeenSplit: hasTopBarBeenSplit ?? false,
            isBannerAvailable: !!branding.isBannerAvailable,
            useDefaultBanner: !!branding.useDefaultBanner,
            isLogoAvailable: !!branding.isLogoAvailable
        };
    }
    return null;
};

});
parcelRegister("dDgZw", function(module, exports) {
$parcel$export(module.exports, "default", () => $651e5f99e2114573$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<762b42f3490374656d56e2bee709a301>>
 * @relayHash d9e8688fd258712e7252323bfaac25bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6
const $651e5f99e2114573$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "default"
        },
        {
            "concreteType": "HelpCenterTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": true,
            "selections": v4 /*: any*/ 
        }
    ], v6 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "fileId"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v8 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterHomePageTitle",
                "kind": "LinkedField",
                "name": "homePageTitle",
                "plural": false,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bannerTextColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarTextColor"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "isBannerAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "isLogoAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            },
            {
                "kind": "ScalarField",
                "name": "hasTopBarBeenSplit"
            }
        ]
    }, v9 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canEditHomePageAnnouncement"
            },
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "homePageAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    }
                ]
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v11 = {
        "kind": "ScalarField",
        "name": "userLanguageTag"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "helpCenter.helpCenterById.helpCenterBranding"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6",
            "metadata": {},
            "name": "helpCenterBrandingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$651e5f99e2114573$var$node.hash = "4d4bfd3b05fd09feee5f588ec411df08";
var $651e5f99e2114573$export$2e2bcd8739ae039 = $651e5f99e2114573$var$node;

});



parcelRegister("khYBz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af01eb304348912$export$2e2bcd8739ae039);

var $77dSs = parcelRequire("77dSs");
var $9MYnb = parcelRequire("9MYnb");
var $8jOUp = parcelRequire("8jOUp");

var $9K4F5 = parcelRequire("9K4F5");

var $xvbWG = parcelRequire("xvbWG");
parcelRequire("4V6Ho");
var $8CcW6 = parcelRequire("8CcW6");
parcelRequire("8xjib");
var $6g2X0 = parcelRequire("6g2X0");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");

var $dWiWC = parcelRequire("dWiWC");
const $0af01eb304348912$var$categoryArticlesEpic = (action$)=>{
    return action$.ofType((0, $dWiWC.FETCH_ARTICLES)).mergeMap((action)=>{
        const { projectId: projectId, categoryId: categoryId, portalId: portalId, categoryDataRequired: categoryDataRequired, meta: meta } = action.payload;
        if (categoryDataRequired) // parallelize categories request with articles, used on initial category page load, ensures we always have the necessary category data
        return (0, $9MYnb.forkJoin)((0, $xvbWG.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((articlesResponse)=>(0, $8CcW6.fetchArticlesSuccess)(articlesResponse, categoryId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(error.statusCode)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $8CcW6.fetchArticlesFailure)(error, portalId, categoryId));
        }), (0, $9K4F5.fetchCategories)({
            projectId: projectId
        }).map((categoriesResponse)=>(0, $6g2X0.fetchCategoriesSuccess)(categoriesResponse, portalId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(error.statusCode)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $6g2X0.fetchCategoriesFailure)(error, portalId));
        })).mergeMap(([articlesSuccessOrFailure, categoriesSuccessOrFailure])=>(0, $77dSs.concat)((0, $8jOUp.Observable).of(articlesSuccessOrFailure), (0, $8jOUp.Observable).of(categoriesSuccessOrFailure)));
        return (0, $xvbWG.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((response)=>{
            return (0, $8CcW6.fetchArticlesSuccess)(response, categoryId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(error.statusCode)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $8CcW6.fetchArticlesFailure)(error, portalId, categoryId));
        });
    });
};
var $0af01eb304348912$export$2e2bcd8739ae039 = $0af01eb304348912$var$categoryArticlesEpic;

});
parcelRegister("9K4F5", function(module, exports) {
$parcel$export(module.exports, "fetchCategories", () => $85fa270f6816d9ad$export$416ec9f5729de215);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fuVmc = parcelRequire("fuVmc");

var $fMFxk = parcelRequire("fMFxk");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $85fa270f6816d9ad$var$mapApolloErrorResponse = (error)=>{
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: error.message || ''
    };
};
const $85fa270f6816d9ad$export$416ec9f5729de215 = ({ projectId: projectId, contextPath: contextPath = (0, $eDcdn.contextPath) })=>{
    const activationId = (0, $fuVmc.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category`;
    return (0, $llRGw.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $jBiia.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $8jOUp.Observable).throw($85fa270f6816d9ad$var$mapApolloErrorResponse(e));
    });
};

});

parcelRegister("xvbWG", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesForCategory", () => $c074f85eb7ec6962$export$b51ae2f6685b749);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fuVmc = parcelRequire("fuVmc");

var $fvUqa = parcelRequire("fvUqa");

var $fMFxk = parcelRequire("fMFxk");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");

var $5JZdD = parcelRequire("5JZdD");
const $c074f85eb7ec6962$var$errorKeyToMessage = {
    'jsd.apollo.error.category.not.found': (0, $5JZdD.default).categoryNotFound,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $5JZdD.default).noPermission,
    'jsd.apollo.error.article.not.found': (0, $5JZdD.default).articleNotFound
};
const $c074f85eb7ec6962$var$mapApolloErrorResponse = (error)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = error.response;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (response && response.errorKey && $c074f85eb7ec6962$var$errorKeyToMessage[response.errorKey]) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const translatedMessage = $c074f85eb7ec6962$var$errorKeyToMessage[response.errorKey];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return {
            ...error.response,
            errorMessage: translatedMessage
        };
    }
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: ''
    };
};
const $c074f85eb7ec6962$export$b51ae2f6685b749 = ({ projectId: projectId, categoryId: categoryId, contextPath: contextPath = (0, $eDcdn.contextPath) })=>{
    const queryString = $fvUqa.stringify({
        limit: 100,
        orderBy: '+featured',
        expand: 'category'
    });
    const activationId = (0, $fuVmc.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category/${categoryId}/article?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $jBiia.trackError)('category.article.fetch.failed', {}, e);
        return (0, $8jOUp.Observable).throw($c074f85eb7ec6962$var$mapApolloErrorResponse(e));
    });
};

});
parcelRegister("5JZdD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d6a849c4944500$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $c1d6a849c4944500$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    categoryNotFound: {
        id: 'cv.error.page.category.page.category.not.found',
        defaultMessage: "That category doesn't exist.",
        description: 'The error message shown when the category not found on the category page.'
    },
    articleNotFound: {
        id: 'cv.error.page.category.page.article.not.found',
        defaultMessage: "That article doesn't exist.",
        description: 'The error message shown when the requested article was not found on the category page.'
    },
    noPermission: {
        id: 'cv.error.page.category.page.no-permission',
        defaultMessage: 'You do not have permission to view this category. Ask an admin to check your permissions.',
        description: 'The error shown when the user does not have permission to add categories to the project.'
    },
    callToActionText: {
        id: 'cv.error.page.category.page.call.to.action',
        defaultMessage: 'Go back',
        description: 'Call to action message shown when an error occurs on the category page'
    }
});

});


parcelRegister("4V6Ho", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesSuccess", () => (parcelRequire("8CcW6")).fetchArticlesSuccess);
$parcel$export(module.exports, "fetchArticlesFailure", () => (parcelRequire("8CcW6")).fetchArticlesFailure);

var $8CcW6 = parcelRequire("8CcW6");

});
parcelRegister("8CcW6", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES_SUCCESS", () => $c918c39221cd7814$export$76b83d637130c0fa);
$parcel$export(module.exports, "FETCH_ARTICLES_FAILURE", () => $c918c39221cd7814$export$7c415676e9f98e60);
$parcel$export(module.exports, "fetchArticlesSuccess", () => $c918c39221cd7814$export$5a1d149417c43ad9);
$parcel$export(module.exports, "fetchArticlesFailure", () => $c918c39221cd7814$export$47896f258d652153);
const $c918c39221cd7814$export$76b83d637130c0fa = 'state.persisted.kb.articles.FETCH_ARTICLES_SUCCESS';
const $c918c39221cd7814$export$7c415676e9f98e60 = 'state.persisted.kb.articles.FETCH_ARTICLES_FAILURE';
const $c918c39221cd7814$export$5a1d149417c43ad9 = (response, categoryId)=>({
        type: $c918c39221cd7814$export$76b83d637130c0fa,
        payload: {
            response: response,
            categoryId: categoryId
        }
    });
const $c918c39221cd7814$export$47896f258d652153 = (error, portalId, categoryId)=>({
        type: $c918c39221cd7814$export$7c415676e9f98e60,
        payload: {
            error: error,
            portalId: portalId,
            categoryId: categoryId
        }
    });

});


parcelRegister("8xjib", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => (parcelRequire("6g2X0")).FETCH_CATEGORIES_SUCCESS);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => (parcelRequire("6g2X0")).FETCH_CATEGORIES_FAILURE);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => (parcelRequire("6g2X0")).fetchCategoriesSuccess);
$parcel$export(module.exports, "fetchCategoriesFailure", () => (parcelRequire("6g2X0")).fetchCategoriesFailure);

var $6g2X0 = parcelRequire("6g2X0");

});
parcelRegister("6g2X0", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => $6f706eaa7c393d23$export$8fe15054f89178e3);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => $6f706eaa7c393d23$export$4425a101b60fad1);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => $6f706eaa7c393d23$export$1372a078b0bbb728);
$parcel$export(module.exports, "fetchCategoriesFailure", () => $6f706eaa7c393d23$export$10b1ac5b71f5513e);
const $6f706eaa7c393d23$export$8fe15054f89178e3 = 'state.persisted.kb.categories.FETCH_CATEGORIES_SUCCESS';
const $6f706eaa7c393d23$export$4425a101b60fad1 = 'state.persisted.kb.categories.FETCH_CATEGORIES_FAILURE';
const $6f706eaa7c393d23$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $6f706eaa7c393d23$export$1372a078b0bbb728 = (response, portalId)=>{
    if (Array.isArray(response)) return {
        type: $6f706eaa7c393d23$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: response
        }
    };
    const isCategoriesSupported = response.categoriesSupported;
    return {
        type: $6f706eaa7c393d23$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: isCategoriesSupported ? response.categories : $6f706eaa7c393d23$export$baa53a1870be4bc5
        }
    };
};
const $6f706eaa7c393d23$export$10b1ac5b71f5513e = (error, portalId)=>({
        type: $6f706eaa7c393d23$export$4425a101b60fad1,
        payload: {
            error: error,
            portalId: portalId
        }
    });

});


parcelRegister("dWiWC", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES", () => $af995fb2246d7f90$export$d5cdb0266add81c8);
$parcel$export(module.exports, "fetchArticlesAction", () => $af995fb2246d7f90$export$43937e098a3fb347);
const $af995fb2246d7f90$export$d5cdb0266add81c8 = 'epic.model.FETCH_KB_ARTICLES';
const $af995fb2246d7f90$export$43937e098a3fb347 = (params)=>{
    const { projectId: projectId, portalId: portalId, categoryId: categoryId, categoryDataRequired: categoryDataRequired, meta: meta } = params;
    return {
        type: $af995fb2246d7f90$export$d5cdb0266add81c8,
        payload: {
            projectId: projectId,
            portalId: portalId,
            categoryId: categoryId,
            categoryDataRequired: categoryDataRequired,
            meta: meta
        }
    };
};

});


parcelRegister("cbclE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6f5af49c90a84d8$export$2e2bcd8739ae039);

var $8jOUp = parcelRequire("8jOUp");

var $9K4F5 = parcelRequire("9K4F5");
parcelRequire("8xjib");
var $6g2X0 = parcelRequire("6g2X0");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");

var $g4BKO = parcelRequire("g4BKO");
const $f6f5af49c90a84d8$var$categoriesEpic = (action$)=>{
    return action$.ofType((0, $g4BKO.FETCH_CATEGORIES)).mergeMap((action)=>{
        const { portalId: portalId, projectId: projectId, meta: meta } = action.payload;
        return (0, $9K4F5.fetchCategories)({
            projectId: projectId
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $6g2X0.fetchCategoriesSuccess)(response, portalId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(error.statusCode)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $6g2X0.fetchCategoriesFailure)(error, portalId));
        });
    });
};
var $f6f5af49c90a84d8$export$2e2bcd8739ae039 = $f6f5af49c90a84d8$var$categoriesEpic;

});
parcelRegister("g4BKO", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES", () => $1fb82c115520b119$export$cce9a7031b65f96c);
$parcel$export(module.exports, "fetchCategoriesAction", () => $1fb82c115520b119$export$10813fa84276d50);
const $1fb82c115520b119$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $1fb82c115520b119$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $1fb82c115520b119$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});


parcelRegister("3Fdfn", function(module, exports) {
$parcel$export(module.exports, "languagesEpic", () => $87160f85d20aa972$export$f18fac0a77b35e0d);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("gHK4P");
var $8c69X = parcelRequire("8c69X");

var $1vXf6 = parcelRequire("1vXf6");
const $87160f85d20aa972$export$f18fac0a77b35e0d = (action$)=>{
    return action$.ofType((0, $8c69X.FETCH_LANGUAGES_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.availableLanguages).map((response)=>{
            return (0, $8c69X.fetchLanguagesSuccess)(response.availableLanguages || []);
        }).catch((_)=>{
            return (0, $8jOUp.Observable).of((0, $xb2jO.showErrorFlag)((0, $1vXf6.genericError).title, (0, $1vXf6.genericError).description));
        }));
};

});
parcelRegister("gHK4P", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => (parcelRequire("8c69X")).FETCH_LANGUAGES_SUCCESS);
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => (parcelRequire("8c69X")).FETCH_LANGUAGES_MODEL);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => (parcelRequire("8c69X")).fetchLanguagesSuccess);
$parcel$export(module.exports, "fetchLanguagesModel", () => (parcelRequire("8c69X")).fetchLanguagesModel);

var $8c69X = parcelRequire("8c69X");

});
parcelRegister("8c69X", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => $006a8e7ca11b0c6b$export$50695c17a56afb1c);
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => $006a8e7ca11b0c6b$export$e4a250eae790b1c0);
$parcel$export(module.exports, "fetchLanguagesModel", () => $006a8e7ca11b0c6b$export$93153c0d57b5d23f);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => $006a8e7ca11b0c6b$export$5ecfd42a9b3d2b31);

var $hn5Mq = parcelRequire("hn5Mq");
const $006a8e7ca11b0c6b$export$50695c17a56afb1c = 'epic.model.FETCH_LANGUAGES_MODEL';
const $006a8e7ca11b0c6b$export$e4a250eae790b1c0 = 'state.persisted.languages.FETCH_LANGUAGES_SUCCESS';
const $006a8e7ca11b0c6b$export$93153c0d57b5d23f = (0, $hn5Mq.buildModelsActionCreator)($006a8e7ca11b0c6b$export$50695c17a56afb1c, 'availableLanguages');
const $006a8e7ca11b0c6b$export$5ecfd42a9b3d2b31 = (languages)=>({
        type: $006a8e7ca11b0c6b$export$e4a250eae790b1c0,
        payload: {
            languages: languages
        }
    });

});



parcelRegister("2rnki", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $db8256f2a02fa6df$export$da8045e9cad7ec9b);

var $i2WqQ = parcelRequire("i2WqQ");

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");

var $e630u = parcelRequire("e630u");
const $db8256f2a02fa6df$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $e630u.FETCH_LOGIN_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.login && !(0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ)))(response.login)).map((response)=>{
            return (0, $xAy39.fetchLoginSuccess)(response.login);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $xAy39.fetchLoginFailure)(error));
        }));
};

});
parcelRegister("i2WqQ", function(module, exports) {

var $7MNHj = parcelRequire("7MNHj");

var $4J8KV = parcelRequire("4J8KV");

var $aSgk4 = parcelRequire("aSgk4");

var $lVkdr = parcelRequire("lVkdr");

var $d5SgW = parcelRequire("d5SgW");

var $1TItY = parcelRequire("1TItY");

var $6hADJ = parcelRequire("6hADJ");

var $abOQN = parcelRequire("abOQN");
/** `Object#toString` result references. */ var $d235bd426da3aee3$var$mapTag = '[object Map]', $d235bd426da3aee3$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $d235bd426da3aee3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d235bd426da3aee3$var$hasOwnProperty = $d235bd426da3aee3$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $d235bd426da3aee3$var$isEmpty(value) {
    if (value == null) return true;
    if ($d5SgW(value) && ($lVkdr(value) || typeof value == 'string' || typeof value.splice == 'function' || $1TItY(value) || $abOQN(value) || $aSgk4(value))) return !value.length;
    var tag = $4J8KV(value);
    if (tag == $d235bd426da3aee3$var$mapTag || tag == $d235bd426da3aee3$var$setTag) return !value.size;
    if ($6hADJ(value)) return !$7MNHj(value).length;
    for(var key in value){
        if ($d235bd426da3aee3$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $d235bd426da3aee3$var$isEmpty;

});

parcelRegister("e630u", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_MODEL", () => $7eec6a4f9b80c70e$export$c7e01c95750f0d63);
$parcel$export(module.exports, "fetchLoginModel", () => $7eec6a4f9b80c70e$export$6e443fe31e715257);

var $hn5Mq = parcelRequire("hn5Mq");
const $7eec6a4f9b80c70e$export$c7e01c95750f0d63 = 'epic.model.FETCH_LOGIN_MODEL';
const $7eec6a4f9b80c70e$export$6e443fe31e715257 = (0, $hn5Mq.buildModelsActionCreator)($7eec6a4f9b80c70e$export$c7e01c95750f0d63, 'login');

});


parcelRegister("2cdbV", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsEpic", () => $46883589fb151f39$export$8abec8cdaadd5d28);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("f2i8V");
var $osBO5 = parcelRequire("osBO5");

var $hCnLH = parcelRequire("hCnLH");

var $9KvT1 = parcelRequire("9KvT1");
const $46883589fb151f39$export$32d9db53927095d3 = {
    defaultLocale: '',
    translatedLoginAnnouncements: {}
};
const $46883589fb151f39$export$8abec8cdaadd5d28 = (action$)=>{
    return action$.ofType((0, $osBO5.FETCH_LOGIN_ANNOUNCEMENTS)).mergeMap((action)=>{
        if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)()) return (0, $8jOUp.Observable).from((0, $9KvT1.fetchLoginAnnouncementsData)().toPromise().then((response)=>(0, $9KvT1.convertToLoginAnnouncementsResponse)(response))).filter((data)=>Boolean(data)).map((data)=>{
            if (data) return (0, $osBO5.fetchLoginAnnouncementsSuccess)(data);
            return (0, $osBO5.fetchLoginAnnouncementsSuccess)($46883589fb151f39$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $osBO5.fetchLoginAnnouncementsFailure)(error));
        });
        return (0, $fVm9J.default)(action.payload).filter((response)=>Boolean(response)).map((response)=>{
            if (response.loginAnnouncements) return (0, $osBO5.fetchLoginAnnouncementsSuccess)(response.loginAnnouncements);
            return (0, $osBO5.fetchLoginAnnouncementsSuccess)($46883589fb151f39$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $osBO5.fetchLoginAnnouncementsFailure)(error));
        });
    });
};

});
parcelRegister("9KvT1", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementsData", () => $bef0222b03451826$export$32c914da1ff32f72);
$parcel$export(module.exports, "convertToLoginAnnouncementsResponse", () => $bef0222b03451826$export$a8a0b51b62d54e0);

var $ari1D = parcelRequire("ari1D");

var $fuVmc = parcelRequire("fuVmc");

var $4270B = parcelRequire("4270B");

var $kbkME = parcelRequire("kbkME");
const $bef0222b03451826$export$32c914da1ff32f72 = ()=>{
    return (0, $4270B.fetchQuery)((0, $kbkME.getRelayEnvironment)(), (0, $ari1D.default), {
        cloudId: (0, $fuVmc.getCloudId)(),
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)()
    });
};
const $bef0222b03451826$var$mergeNameAndDescriptionTranslations = (nameTranslationsRaw, descriptionTranslationsRaw)=>{
    const translatedLoginAnnouncements = {};
    nameTranslationsRaw === null || nameTranslationsRaw === void 0 || nameTranslationsRaw.forEach((translationName)=>{
        const locale = translationName.locale;
        const header = translationName.value;
        const targetDescriptionAnnouncement = descriptionTranslationsRaw === null || descriptionTranslationsRaw === void 0 ? void 0 : descriptionTranslationsRaw.find((translationDescription)=>translationDescription.locale === locale);
        translatedLoginAnnouncements[locale] = {
            header: header,
            message: (targetDescriptionAnnouncement === null || targetDescriptionAnnouncement === void 0 ? void 0 : targetDescriptionAnnouncement.value) || '',
            localeDisplayName: translationName.localeDisplayName
        };
    });
    return translatedLoginAnnouncements;
};
const $bef0222b03451826$export$a8a0b51b62d54e0 = (response)=>{
    var _response$helpCenter, _data$announcements;
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && (_data$announcements = data.announcements) !== null && _data$announcements !== void 0 && (_data$announcements = _data$announcements.loginAnnouncements) !== null && _data$announcements !== void 0 && _data$announcements.length) {
        // Currently we only support one login announcement
        const targetLoginAnnouncement = data.announcements.loginAnnouncements[0];
        return {
            translatedLoginAnnouncements: $bef0222b03451826$var$mergeNameAndDescriptionTranslations(targetLoginAnnouncement.nameTranslationsRaw || [], targetLoginAnnouncement.descriptionTranslationsRaw || []),
            defaultLocale: data.siteDefaultLanguageTag || ''
        };
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && data.siteDefaultLanguageTag) // case then loginAnnouncements array is empty but siteDefaultLanguageTag is present, we have to map default locale
    return {
        translatedLoginAnnouncements: {
            [data.siteDefaultLanguageTag]: {
                localeDisplayName: data.siteDefaultLanguageTag,
                header: '',
                message: ''
            }
        },
        defaultLocale: data.siteDefaultLanguageTag
    };
    return null;
};

});
parcelRegister("ari1D", function(module, exports) {
$parcel$export(module.exports, "default", () => $5269624502d3b353$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9a2845fdb0ebf85b6c1c8816fcdfced>>
 * @relayHash 71f2f66044bc8f8bd3ab026ad2505549
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b
const $5269624502d3b353$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b",
            "metadata": {},
            "name": "loginAnnouncementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5269624502d3b353$var$node.hash = "76319886fc90231eee48f51d80798d47";
var $5269624502d3b353$export$2e2bcd8739ae039 = $5269624502d3b353$var$node;

});



parcelRegister("96ANS", function(module, exports) {
$parcel$export(module.exports, "organisationsEpic", () => $8e3228074ae6b0a0$export$11ed7e95538202ff);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");

var $2fYPj = parcelRequire("2fYPj");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("hmA7a");
var $jUYjx = parcelRequire("jUYjx");
const $8e3228074ae6b0a0$export$11ed7e95538202ff = (action$)=>{
    return action$.ofType((0, $2fYPj.FETCH_ORGANISATIONS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.organisations && !(0, $4ZMmh.isEmpty)(response.organisations)).map((response)=>{
            return (0, $jUYjx.updateOrganisationsModelAction)(response.organisations);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $8jOUp.Observable).never()));
};
var $8e3228074ae6b0a0$export$2e2bcd8739ae039 = $8e3228074ae6b0a0$export$11ed7e95538202ff;

});
parcelRegister("2fYPj", function(module, exports) {
$parcel$export(module.exports, "FETCH_ORGANISATIONS_MODEL", () => $335d62ec6359adfd$export$b60557155cf3c6c0);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $335d62ec6359adfd$export$cbdd5d7a098d34a2);

var $hn5Mq = parcelRequire("hn5Mq");
const $335d62ec6359adfd$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $335d62ec6359adfd$export$cbdd5d7a098d34a2 = (0, $hn5Mq.buildModelsActionCreator)($335d62ec6359adfd$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("hmA7a", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => (parcelRequire("jUYjx")).UPDATE_ORGANISATIONS_MODEL);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => (parcelRequire("jUYjx")).updateOrganisationsModelAction);

var $jUYjx = parcelRequire("jUYjx");

});
parcelRegister("jUYjx", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => $3c43fde7e934e218$export$1fb754e532426cdc);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => $3c43fde7e934e218$export$72c2e60e3f358ed9);
const $3c43fde7e934e218$export$1fb754e532426cdc = 'state.persisted.organisations.UPDATE_ORGANISATIONS_MODEL';
const $3c43fde7e934e218$export$72c2e60e3f358ed9 = (organisations)=>({
        payload: organisations,
        type: $3c43fde7e934e218$export$1fb754e532426cdc
    });

});



parcelRegister("8fk7c", function(module, exports) {
$parcel$export(module.exports, "portalEpic", () => $6b9df7d9ed881612$export$a9922bad2863d6ee);
$parcel$export(module.exports, "portalUploadMediaTokenEpic", () => $6b9df7d9ed881612$export$a5051d4620a9cd24);
$parcel$export(module.exports, "refreshPortalUploadMediaTokenBeforeExpiryEpic", () => $6b9df7d9ed881612$export$9bf2e8f39289e99a);

var $8jOUp = parcelRequire("8jOUp");

var $eNRmj = parcelRequire("eNRmj");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");

var $jBiia = parcelRequire("jBiia");

var $fVm9J = parcelRequire("fVm9J");
const $6b9df7d9ed881612$export$a9922bad2863d6ee = (action$)=>{
    return action$.ofType((0, $jeW3I.FETCH_PORTAL_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.portal && !!response.branding).map((response)=>{
            var _action$meta;
            if ((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(action.meta.analyticsSuccessEvent);
            return (0, $jeW3I.fetchPortalSuccess)(response.portal, response.branding);
        }).catch((error)=>{
            var _action$meta2;
            if ((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.analyticsFailureEvent && error.status !== 0) (0, $jBiia.legacySendEvent)(action.meta.analyticsFailureEvent);
            const params = action.payload.params;
            return (0, $8jOUp.Observable).of((0, $jeW3I.fetchPortalFailure)(params.id, error));
        }));
};
const $6b9df7d9ed881612$export$a5051d4620a9cd24 = (action$)=>{
    return action$.ofType((0, $jeW3I.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION)).mergeMap((action)=>{
        const portalId = action.payload.portalId;
        return (0, $eNRmj.getUploadCredentialsObservable)(portalId).map((response)=>(0, $jeW3I.fetchPortalUploadMediaTokenSuccess)({
                ...response,
                tokenDurationInMins: (response.expiryEpoch - Date.now()) / 60000
            }, portalId)).catch(()=>{
            return (0, $8jOUp.Observable).of((0, $jeW3I.fetchPortalUploadMediaTokenFailure)());
        });
    });
};
const $6b9df7d9ed881612$export$9bf2e8f39289e99a = (action$)=>{
    return action$.ofType((0, $jeW3I.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS), (0, $jeW3I.FETCH_PORTAL_SUCCESS)).switchMap((action)=>{
        const uploadContext = action.payload.mediaApiUploadInformation;
        if (uploadContext && 'token' in uploadContext) {
            const mediaApiUploadToken = uploadContext;
            // gets the token duration in milliseconds minus 5 minute buffer for network calls/inactive tab throttling
            const wantsRefreshAt = mediaApiUploadToken.tokenDurationInMins * 60000 - 300000;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt);
            const portalId = action.type === (0, $jeW3I.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS) ? action.payload.portalId : action.payload.id;
            if (portalId) return (0, $8jOUp.Observable).of((0, $jeW3I.fetchPortalUploadMediaTokenAction)(Number(portalId))).delay(timeUntilRefresh);
        }
        return (0, $8jOUp.Observable).empty();
    });
};

});
parcelRegister("eNRmj", function(module, exports) {
$parcel$export(module.exports, "getUploadCredentials", () => $f86aead2a4b25833$export$1d8e51ec2b973100);
$parcel$export(module.exports, "getUploadCredentialsObservable", () => $f86aead2a4b25833$export$42e3feb9754fda17);
$parcel$export(module.exports, "getCredentialsForMediaRequest", () => $f86aead2a4b25833$export$ec7ab5d74f1f3c37);
$parcel$export(module.exports, "getUploadCredentialsForRequest", () => $f86aead2a4b25833$export$766d1bd3b5e7fe1b);
$parcel$export(module.exports, "getReadCredentialsForRequest", () => $f86aead2a4b25833$export$9748c08f8d568d41);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $f86aead2a4b25833$export$1d8e51ec2b973100 = (portalId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $f86aead2a4b25833$export$42e3feb9754fda17 = (portalId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $f86aead2a4b25833$export$ec7ab5d74f1f3c37 = (portalId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload/inline`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $f86aead2a4b25833$export$766d1bd3b5e7fe1b = (portalId, requestId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $f86aead2a4b25833$export$9748c08f8d568d41 = (portalId, requestId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/read`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers).map((response)=>response.response);
};

});

parcelRegister("gUbcQ", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => (parcelRequire("jeW3I")).FETCH_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => (parcelRequire("jeW3I")).FETCH_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => (parcelRequire("jeW3I")).FETCH_PORTAL_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => (parcelRequire("jeW3I")).UPDATE_PORTAL_ANNOUNCEMENT_MODEL);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => (parcelRequire("jeW3I")).UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => (parcelRequire("jeW3I")).UPDATE_PORTAL_ANNOUNCEMENT_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("jeW3I")).UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => (parcelRequire("jeW3I")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => (parcelRequire("jeW3I")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS);
$parcel$export(module.exports, "fetchPortalAction", () => (parcelRequire("jeW3I")).fetchPortalAction);
$parcel$export(module.exports, "fetchPortalSuccess", () => (parcelRequire("jeW3I")).fetchPortalSuccess);
$parcel$export(module.exports, "fetchPortalFailure", () => (parcelRequire("jeW3I")).fetchPortalFailure);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => (parcelRequire("jeW3I")).updatePortalAnnouncementModel);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => (parcelRequire("jeW3I")).updatePortalAnnouncementSuccess);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => (parcelRequire("jeW3I")).updatePortalAnnouncementFailure);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => (parcelRequire("jeW3I")).updatePortalAnnouncementsUIState);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => (parcelRequire("jeW3I")).fetchPortalUploadMediaTokenAction);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => (parcelRequire("jeW3I")).fetchPortalUploadMediaTokenSuccess);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => (parcelRequire("jeW3I")).fetchPortalUploadMediaTokenFailure);

var $jeW3I = parcelRequire("jeW3I");

});
parcelRegister("jeW3I", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => $4ce41d1cf1c2cd7e$export$fca1c6628f14bdf2);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => $4ce41d1cf1c2cd7e$export$b929cb285face2c);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => $4ce41d1cf1c2cd7e$export$d0378806ff79f20f);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => $4ce41d1cf1c2cd7e$export$f1992600da6904c6);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => $4ce41d1cf1c2cd7e$export$9181049110925f2a);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => $4ce41d1cf1c2cd7e$export$d5fa92c7d79f8706);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => $4ce41d1cf1c2cd7e$export$6a473efc246ca86a);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => $4ce41d1cf1c2cd7e$export$eedf58a097d7a901);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => $4ce41d1cf1c2cd7e$export$c769ac1c1c5f67f5);
$parcel$export(module.exports, "fetchPortalAction", () => $4ce41d1cf1c2cd7e$export$8262b38db2952a96);
$parcel$export(module.exports, "fetchPortalSuccess", () => $4ce41d1cf1c2cd7e$export$c9cc1b81c69f8b54);
$parcel$export(module.exports, "fetchPortalFailure", () => $4ce41d1cf1c2cd7e$export$bc631fe34431953a);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => $4ce41d1cf1c2cd7e$export$a2c25b3a57d1e1e1);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => $4ce41d1cf1c2cd7e$export$1cb4859b979a107e);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => $4ce41d1cf1c2cd7e$export$a71bb12efca5ed02);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => $4ce41d1cf1c2cd7e$export$7f7bb35e246605cc);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => $4ce41d1cf1c2cd7e$export$82b91227c2617f7c);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => $4ce41d1cf1c2cd7e$export$977a37e5820c7d60);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => $4ce41d1cf1c2cd7e$export$5531ab3802c122e6);

var $hn5Mq = parcelRequire("hn5Mq");
const $4ce41d1cf1c2cd7e$export$fca1c6628f14bdf2 = 'epic.model.FETCH_PORTAL_MODEL';
const $4ce41d1cf1c2cd7e$export$b929cb285face2c = 'state.persisted.portals.FETCH_PORTAL_SUCCESS';
const $4ce41d1cf1c2cd7e$export$d0378806ff79f20f = 'state.persisted.portals.FETCH_PORTAL_FAILURE';
const $4ce41d1cf1c2cd7e$export$f1992600da6904c6 = 'epic.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENT_MODEL';
const $4ce41d1cf1c2cd7e$export$9181049110925f2a = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS';
const $4ce41d1cf1c2cd7e$export$d5fa92c7d79f8706 = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE';
const $4ce41d1cf1c2cd7e$export$6a473efc246ca86a = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION';
const $4ce41d1cf1c2cd7e$export$eedf58a097d7a901 = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $4ce41d1cf1c2cd7e$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE';
const $4ce41d1cf1c2cd7e$export$c769ac1c1c5f67f5 = 'state.ui.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE';
const $4ce41d1cf1c2cd7e$export$8262b38db2952a96 = (payload, meta)=>({
        meta: meta,
        ...(0, $hn5Mq.buildModelsActionCreator)($4ce41d1cf1c2cd7e$export$fca1c6628f14bdf2, 'portal')(payload)
    });
const $4ce41d1cf1c2cd7e$export$c9cc1b81c69f8b54 = (portalModel, portalBrandingResponse)=>{
    return {
        payload: {
            ...portalBrandingResponse,
            ...portalModel
        },
        type: $4ce41d1cf1c2cd7e$export$b929cb285face2c
    };
};
const $4ce41d1cf1c2cd7e$export$bc631fe34431953a = (portalId, error)=>({
        type: $4ce41d1cf1c2cd7e$export$d0378806ff79f20f,
        payload: {
            portalId: portalId,
            error: error
        }
    });
const $4ce41d1cf1c2cd7e$export$a2c25b3a57d1e1e1 = (portalId, portalAnnouncementModel, meta)=>({
        portalId: portalId,
        meta: meta,
        type: $4ce41d1cf1c2cd7e$export$f1992600da6904c6,
        payload: portalAnnouncementModel
    });
const $4ce41d1cf1c2cd7e$export$1cb4859b979a107e = (portalAnnouncementModel)=>({
        type: $4ce41d1cf1c2cd7e$export$9181049110925f2a,
        payload: portalAnnouncementModel
    });
const $4ce41d1cf1c2cd7e$export$a71bb12efca5ed02 = (error)=>({
        type: $4ce41d1cf1c2cd7e$export$d5fa92c7d79f8706,
        payload: {
            error: error
        }
    });
const $4ce41d1cf1c2cd7e$export$7f7bb35e246605cc = (portalAnnouncementModel)=>({
        type: $4ce41d1cf1c2cd7e$export$c769ac1c1c5f67f5,
        payload: portalAnnouncementModel
    });
const $4ce41d1cf1c2cd7e$export$82b91227c2617f7c = (portalId)=>({
        type: $4ce41d1cf1c2cd7e$export$6a473efc246ca86a,
        payload: {
            portalId: portalId
        }
    });
const $4ce41d1cf1c2cd7e$export$977a37e5820c7d60 = (mediaUploadToken, portalId)=>{
    return {
        type: $4ce41d1cf1c2cd7e$export$eedf58a097d7a901,
        payload: {
            portalId: portalId,
            mediaApiUploadInformation: mediaUploadToken
        }
    };
};
const $4ce41d1cf1c2cd7e$export$5531ab3802c122e6 = ()=>{
    return {
        type: $4ce41d1cf1c2cd7e$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE
    };
};

});



parcelRegister("6B4eU", function(module, exports) {
$parcel$export(module.exports, "requestCreateEpic", () => $7c27c4fc59a4f3ad$export$a2b66173a86c1319);

var $8jOUp = parcelRequire("8jOUp");

var $lFpPv = parcelRequire("lFpPv");

var $fVm9J = parcelRequire("fVm9J");

var $gxy5f = parcelRequire("gxy5f");

var $dp27t = parcelRequire("dp27t");
parcelRequire("1biTA");
var $35X2j = parcelRequire("35X2j");

var $4EUgw = parcelRequire("4EUgw");

var $axowX = parcelRequire("axowX");
parcelRequire("8UaEm");
var $8y1MK = parcelRequire("8y1MK");
const $7c27c4fc59a4f3ad$export$a2b66173a86c1319 = (action$)=>{
    return action$.ofType((0, $35X2j.FETCH_REQUEST_CREATE_MODEL)).mergeMap((action)=>{
        const portalId = action.payload && action.payload.params && action.payload.params.portalId;
        const requestTypeId = action.payload && action.payload.params && action.payload.params.id;
        if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)()) return (0, $fVm9J.default)(action.payload).filter((response)=>!!response.reqCreate).mergeMap((response)=>{
            return $7c27c4fc59a4f3ad$var$hydrateUrlParamOverrides(response.reqCreate, portalId, requestTypeId).then(({ requestCreateResponse: requestCreateResponse, hydratedUrlParamOverrides: hydratedUrlParamOverrides })=>(0, $35X2j.fetchRequestCreateSuccess)({
                    ...requestCreateResponse,
                    hydratedUrlParamOverrides: hydratedUrlParamOverrides,
                    portalId: portalId
                }));
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $8jOUp.Observable).of((0, $35X2j.fetchRequestCreateFailure)(portalId, params.id, error));
        });
        return (0, $fVm9J.default)(action.payload).filter((response)=>!!response.reqCreate).map((response)=>{
            return (0, $35X2j.fetchRequestCreateSuccess)({
                ...response.reqCreate,
                portalId: portalId,
                hydratedUrlParamOverrides: {}
            });
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $8jOUp.Observable).of((0, $35X2j.fetchRequestCreateFailure)(portalId, params.id, error));
        });
    });
};
/**
 * Builds a set of URL param overrides from the query parameters, and attempts to hydrate any overrides
 * for dynamic fields.
 *
 * This should never break the request create flow. If a dynamic field cannot be hydrated successfully (failed
 * API call), this function will proceed as though a URL override was not provided for that field.
 */ const $7c27c4fc59a4f3ad$var$hydrateUrlParamOverrides = async (requestCreateResponse, portalId, requestTypeId)=>{
    const fieldStates = (0, $4EUgw.toFieldStates)(requestCreateResponse.fields);
    const fieldStatesMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    const fieldValueOverrides = (0, $axowX.parseFieldUrlParams)(fieldStates);
    const asyncFieldStatesWithDependencies = [];
    // This is a map used to store a representation of all current field values (including any hydrated ones)
    // so that it can be sent in the payload for CMDB queries. CMDB queries require this since AQL can filter
    // based on dependencies on other fields.
    const fieldValueMap = fieldStates.reduce((valueMap, field)=>{
        var _field$value;
        valueMap[field.id] = (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.toString();
        return valueMap;
    }, {});
    // Mapping all dynamic pre-fill fields to promises so they can be hydrated in parallel.
    // Fields with dependencies need to be mapped last so we can populate the fielValueMap
    // as much as possible. The only known field with dependencies at the moment are CMDB fields.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const asyncFieldValuePromises = fieldStates.map((fieldState)=>{
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                // We don't resolve CMDB fields immediately because they may have dependencies that need to be resolved first
                asyncFieldStatesWithDependencies.push(fieldState);
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'userpicker':
                return $7c27c4fc59a4f3ad$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'reporter':
                return $7c27c4fc59a4f3ad$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'multiuserpicker':
                return $7c27c4fc59a4f3ad$var$getMultiUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'organisationpicker':
                return $7c27c4fc59a4f3ad$var$getOrganisationPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, undefined, requestCreateResponse.userOrganisations);
            case 'entitlementpicker':
                // Entitlement picker value is just passed through as a string
                if (fieldValueOverrides[fieldState.id]) return Promise.resolve({
                    fieldId: fieldState.id,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    value: fieldValueOverrides[fieldState.id]
                });
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'multiservicepicker':
                return $7c27c4fc59a4f3ad$var$getMultiServicePickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            // The following are static fields which have been converted into options. They need to be converted
            // to a different format for the fieldValueMap
            case 'labelpicker':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((defaultLabel)=>defaultLabel.value).toString();
                return undefined;
            case 'select':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].value;
                return undefined;
            case 'multiselect':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((multiSelectOverride)=>multiSelectOverride.value).toString();
                return undefined;
            // All other static field types don't need to be hydrated or transformed, so we can store them
            // directly on fieldValueMap
            default:
                // TODO: Work out the format for cascading select data. This is currently also broken in the existing
                // CMDB field implementation so we're only being consistent with how cascading fields work in
                // Portal view.
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].toString();
                return undefined;
        }
    }).filter((loader)=>loader !== undefined);
    // When storing the hydrated results of dynamic fields, we need to keep asyncFieldValueOverrides in sync with
    // fieldValueMap. They need to store the same results, but in a different representation.
    const asyncFieldValueOverrides = await Promise.all(asyncFieldValuePromises).then((results)=>results.reduce((accumulator, result)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            accumulator[result.fieldId] = result.value;
            if (result.value === undefined) return accumulator;
            const fieldType = fieldStatesMap[result.fieldId].type;
            switch(fieldType){
                case 'userpicker':
                case 'reporter':
                    {
                        const userValue = result.value;
                        fieldValueMap[result.fieldId] = userValue.accountId;
                        break;
                    }
                case 'multiuserpicker':
                    {
                        const userValues = result.value;
                        fieldValueMap[result.fieldId] = userValues.map((user)=>user.accountId).toString();
                        break;
                    }
                case 'organisationpicker':
                    {
                        const organisationValue = result.value;
                        fieldValueMap[result.fieldId] = organisationValue.id.toString();
                        break;
                    }
                case 'multiservicepicker':
                    {
                        const multiServiceValues = result.value;
                        if (multiServiceValues && multiServiceValues.length > 0) fieldValueMap[result.fieldId] = multiServiceValues.toString();
                        break;
                    }
                default:
                    break;
            }
            return accumulator;
        }, {}));
    // A for loop is needed because CMDB fields can depend on other CMDB fields. Hence we need to hydrate them one
    // at a time and make subsequent calls with an updated fieldValueMap.
    for (const fieldState of asyncFieldStatesWithDependencies){
        const fieldId = fieldState.id;
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                {
                    // oxlint-disable-next-line no-await-in-loop
                    const cmdbLoaderResult = await $7c27c4fc59a4f3ad$var$getCmdbObjectLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap);
                    const cmdbPickerValue = cmdbLoaderResult.value;
                    asyncFieldValueOverrides[fieldId] = cmdbPickerValue;
                    if (cmdbPickerValue === undefined) break;
                    fieldValueMap[fieldId] = cmdbPickerValue.map((value)=>value.value).toString();
                    break;
                }
            default:
                break;
        }
    }
    const hydratedUrlParamOverrides = Object.fromEntries(Object.entries({
        ...fieldValueOverrides,
        ...asyncFieldValueOverrides
    }).filter(([, fieldValue])=>fieldValue !== undefined));
    return {
        requestCreateResponse: requestCreateResponse,
        hydratedUrlParamOverrides: hydratedUrlParamOverrides
    };
};
const $7c27c4fc59a4f3ad$var$getMultiUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiUserPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof multiUserPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Split comma-separated user queries and search for each
    const userQueries = multiUserPickerQuery.split(',').map((query)=>query.trim()).filter((query)=>query.length > 0);
    if (userQueries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userSearchPromises = userQueries.map((query)=>(0, $dp27t.searchUser)({
            portalId: portalId,
            query: query,
            fieldName: fieldId,
            fieldConfigId: fieldState.fieldConfigId
        }).toPromise().then((userSearchResponse)=>{
            if (userSearchResponse.length === 0) return undefined;
            // Return the first matching user for this query
            const userResult = userSearchResponse[0];
            return {
                accountId: userResult.accountId,
                email: userResult.emailAddress,
                iconUrl: userResult.avatar,
                label: userResult.displayName,
                value: userResult.accountId
            };
        }).catch(()=>undefined));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Promise.all(userSearchPromises).then((results)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const users = results.filter((user)=>user !== undefined);
        return {
            fieldId: fieldState.id,
            value: users.length > 0 ? users : undefined
        };
    });
};
const $7c27c4fc59a4f3ad$var$getUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const userPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof userPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return (0, $dp27t.searchUser)({
        portalId: portalId,
        query: userPickerQuery,
        fieldName: fieldId,
        fieldConfigId: fieldState.fieldConfigId
    }).toPromise().then((userSearchResponse)=>{
        if (userSearchResponse.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstUserResult = userSearchResponse[0];
        return {
            fieldId: fieldState.id,
            value: {
                accountId: firstUserResult.accountId,
                email: firstUserResult.emailAddress,
                iconUrl: firstUserResult.avatar,
                label: firstUserResult.displayName,
                value: firstUserResult.accountId
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};
const $7c27c4fc59a4f3ad$var$getOrganisationPickerLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap, userOrganisations)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const organisationPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof organisationPickerQuery !== 'string' || !userOrganisations) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Try to match the URL parameter against user's organisations
    // First, try to match by ID (if the query is numeric)
    const queryAsId = parseInt(organisationPickerQuery, 10);
    if (!isNaN(queryAsId)) {
        const matchedOrgById = userOrganisations.find((org)=>org.id === queryAsId);
        if (matchedOrgById) return Promise.resolve({
            fieldId: fieldId,
            value: {
                id: matchedOrgById.id,
                name: matchedOrgById.name,
                domain: ''
            }
        });
    }
    // Try to match by name (case-insensitive)
    const matchedOrgByName = userOrganisations.find((org)=>org.name.toLowerCase() === organisationPickerQuery.toLowerCase());
    if (matchedOrgByName) return Promise.resolve({
        fieldId: fieldId,
        value: {
            id: matchedOrgByName.id,
            name: matchedOrgByName.name,
            domain: ''
        }
    });
    // No matching organisation found
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $7c27c4fc59a4f3ad$var$getMultiServicePickerLoader = async (fieldState, fieldValueOverrides)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiServicePickerQuery = fieldValueOverrides[fieldState.id];
    if (!multiServicePickerQuery) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Handle both single value and array of values
    let queries = [];
    if (Array.isArray(multiServicePickerQuery)) queries = multiServicePickerQuery;
    else if (typeof multiServicePickerQuery === 'string') queries = [
        multiServicePickerQuery
    ];
    if (queries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    const matchedServiceIds = [];
    // For each query, try to find a matching service
    for (const query of queries)try {
        // Try to match by searching for the service name
        // oxlint-disable-next-line no-await-in-loop
        const result = await (0, $gxy5f.fetchServices)(query);
        // Find exact or partial match by name
        let matchedService = result.services.find((service)=>service.label.toLowerCase() === query.toLowerCase());
        // If no exact match, try to match by ID
        if (!matchedService) matchedService = result.services.find((service)=>service.value === query);
        if (matchedService) matchedServiceIds.push(matchedService.value);
    } catch (error) {
        // If fetch fails, continue to next query
        // oxlint-disable-next-line no-console
        console.warn(`Failed to fetch services for query: ${query}`, error);
    }
    if (matchedServiceIds.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return Promise.resolve({
        fieldId: fieldId,
        value: matchedServiceIds
    });
};
const $7c27c4fc59a4f3ad$var$getCmdbObjectLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const cmdbPickerQuery = fieldValueOverrides[fieldState.id];
    const abortController = new AbortController();
    const { signal: signal } = abortController;
    if (typeof cmdbPickerQuery === 'string') return $7c27c4fc59a4f3ad$var$getSingleCmdbObjectLoader(signal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId).then((cmdbResult)=>cmdbResult.value === undefined ? {
            fieldId: cmdbResult.fieldId,
            value: undefined
        } : {
            fieldId: cmdbResult.fieldId,
            value: [
                cmdbResult.value
            ]
        });
    if (Array.isArray(cmdbPickerQuery)) {
        const cmdbObjectPickerQueries = cmdbPickerQuery.filter((query)=>typeof query === 'string');
        const cmdbObjectPickerPromises = cmdbObjectPickerQueries.map((query)=>$7c27c4fc59a4f3ad$var$getSingleCmdbObjectLoader(signal, query, fieldId, fieldValueMap, portalId, requestTypeId));
        return Promise.all(cmdbObjectPickerPromises).then((results)=>{
            const options = results.map((loaderResult)=>loaderResult.value).filter((option)=>option !== undefined);
            return {
                fieldId: fieldId,
                value: options.length === 0 ? undefined : options
            };
        });
    }
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $7c27c4fc59a4f3ad$var$getSingleCmdbObjectLoader = (abortSignal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId)=>{
    return (0, $8y1MK.fetchCmdbObjectsWithSignal)(portalId, requestTypeId, fieldId, cmdbPickerQuery, Object.entries(fieldValueMap).filter(([_, fieldValue])=>!!fieldValue), abortSignal, 0).then((response)=>{
        const responseObjects = response.cmdbObjects;
        if (responseObjects.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstResult = responseObjects[0];
        return {
            fieldId: fieldId,
            value: {
                cmdbObject: firstResult,
                label: firstResult.label,
                value: firstResult.id
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};

});
parcelRegister("gxy5f", function(module, exports) {
$parcel$export(module.exports, "fetchServices", () => $83e2203b032e63b7$export$aaba171dbee0d63b);

var $llRGw = parcelRequire("llRGw");

var $fuVmc = parcelRequire("fuVmc");

var $eDcdn = parcelRequire("eDcdn");
const $83e2203b032e63b7$export$6ad2d0b3772389f4 = `
    query GetServices($cloudId: String!, $nameContains: String!, $first: Int!, $after: String) {
        devOpsServices(cloudId: $cloudId, filter: { nameContains: $nameContains }, first: $first, after: $after) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;
const $83e2203b032e63b7$var$pageLimit = 20;
const $83e2203b032e63b7$export$aaba171dbee0d63b = async (inputValue, after)=>(0, $llRGw.post)(`${(0, $eDcdn.contextPath)}/gateway/api/graphql`, JSON.stringify({
        query: $83e2203b032e63b7$export$6ad2d0b3772389f4,
        variables: {
            after: after,
            cloudId: (0, $fuVmc.getMeta)('tenant-id'),
            nameContains: inputValue,
            first: $83e2203b032e63b7$var$pageLimit
        }
    }), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const res = response;
        const { data: { devOpsServices: { nodes: nodes, pageInfo: { hasNextPage: hasNextPage, endCursor: endCursor } } } } = res;
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            services: nodes.map(({ id: id, name: name })=>({
                    label: name,
                    value: id
                }))
        };
    }).toPromise();

});

parcelRegister("dp27t", function(module, exports) {
$parcel$export(module.exports, "searchUser", () => $77d7e04262def14b$export$c6a60b910185c7f2);
$parcel$export(module.exports, "updateUserProfile", () => $77d7e04262def14b$export$c92c4ec7a2418617);
$parcel$export(module.exports, "changePassword", () => $77d7e04262def14b$export$99d837dc30eb1ef7);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fvUqa = parcelRequire("fvUqa");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $77d7e04262def14b$export$c6a60b910185c7f2 = (userQuery, context = (0, $eDcdn.contextPath))=>{
    const query = {
        query: userQuery.query,
        fieldName: userQuery.fieldName,
        fieldConfigId: userQuery.fieldConfigId
    };
    const queryString = $fvUqa.stringify(query);
    const uri = `${context}/rest/servicedesk/1/customer/portal/${userQuery.portalId}/user-search?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).catch((e)=>{
        (0, $jBiia.trackError)('finduser.fetch.failed', {}, e);
        return (0, $8jOUp.Observable).throw(e);
    });
};
const $77d7e04262def14b$export$c92c4ec7a2418617 = (displayName, languageKey, timezone, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user`;
    const body = {
        displayName: displayName,
        languageKey: languageKey,
        timezone: timezone
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $8jOUp.Observable).throw(e);
    });
};
const $77d7e04262def14b$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmNewPassword, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user/password`;
    const body = {
        current: currentPassword,
        password: newPassword,
        confirm: confirmNewPassword
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("1biTA", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => (parcelRequire("35X2j")).FETCH_REQUEST_CREATE_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => (parcelRequire("35X2j")).FETCH_REQUEST_CREATE_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => (parcelRequire("35X2j")).FETCH_REQUEST_CREATE_FAILURE);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => (parcelRequire("35X2j")).RESET_REQUEST_CREATE_STATE);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => (parcelRequire("35X2j")).PROFORMA_FORM_DIRTY);
$parcel$export(module.exports, "fetchRequestCreateAction", () => (parcelRequire("35X2j")).fetchRequestCreateAction);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => (parcelRequire("35X2j")).fetchRequestCreateSuccess);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => (parcelRequire("35X2j")).fetchRequestCreateFailure);
$parcel$export(module.exports, "proformaFormDirtyAction", () => (parcelRequire("35X2j")).proformaFormDirtyAction);

var $35X2j = parcelRequire("35X2j");

});
parcelRegister("35X2j", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => $da0d283fe8848c56$export$d4d8c69b4715e057);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => $da0d283fe8848c56$export$372a19d33177b0bf);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => $da0d283fe8848c56$export$fee18c3aa48984ad);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => $da0d283fe8848c56$export$8b4f4d20da5c4667);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => $da0d283fe8848c56$export$b8bfd97914e38eff);
$parcel$export(module.exports, "fetchRequestCreateAction", () => $da0d283fe8848c56$export$466553923c00f94b);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => $da0d283fe8848c56$export$180824a15bbc742e);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => $da0d283fe8848c56$export$fdc3fd637ad84f03);
$parcel$export(module.exports, "proformaFormDirtyAction", () => $da0d283fe8848c56$export$b8e903edf5d19376);

var $hn5Mq = parcelRequire("hn5Mq");
const $da0d283fe8848c56$export$d4d8c69b4715e057 = 'epic.model.FETCH_REQUEST_CREATE_MODEL';
const $da0d283fe8848c56$export$372a19d33177b0bf = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_SUCCESS';
const $da0d283fe8848c56$export$fee18c3aa48984ad = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_FAILURE';
const $da0d283fe8848c56$export$8b4f4d20da5c4667 = 'state.persisted.reqCreate.RESET_REQUEST_CREATE_STATE';
const $da0d283fe8848c56$export$67e1c6172c207525 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_ACTION';
const $da0d283fe8848c56$export$9d7c65c6842f6093 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $da0d283fe8848c56$export$751581aefd0ecd0 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_FAILURE';
const $da0d283fe8848c56$export$b8bfd97914e38eff = 'state.persisted.reqCreate.PROFORMA_FORM_DIRTY';
const $da0d283fe8848c56$export$466553923c00f94b = (0, $hn5Mq.buildModelsActionCreator)($da0d283fe8848c56$export$d4d8c69b4715e057, 'reqCreate');
const $da0d283fe8848c56$export$180824a15bbc742e = (requestCreateResponse)=>({
        payload: requestCreateResponse,
        type: $da0d283fe8848c56$export$372a19d33177b0bf
    });
const $da0d283fe8848c56$export$fdc3fd637ad84f03 = (portalId, requestCreateId, error)=>({
        type: $da0d283fe8848c56$export$fee18c3aa48984ad,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId,
            error: error
        }
    });
const $da0d283fe8848c56$export$702e4cce91196841 = (portalId, requestCreateId)=>({
        type: $da0d283fe8848c56$export$67e1c6172c207525,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    });
const $da0d283fe8848c56$export$a6d0fa922519029e = (mediaApiUploadInformation, portalId, requestCreateId)=>{
    return {
        type: $da0d283fe8848c56$export$9d7c65c6842f6093,
        payload: {
            mediaApiUploadInformation: mediaApiUploadInformation,
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    };
};
const $da0d283fe8848c56$export$e9635fc96da2dc14 = ()=>{
    return {
        type: $da0d283fe8848c56$export$751581aefd0ecd0
    };
};
const $da0d283fe8848c56$export$4f2b3c2ed928ac62 = ()=>{
    return {
        type: $da0d283fe8848c56$export$8b4f4d20da5c4667,
        payload: {}
    };
};
const $da0d283fe8848c56$export$b8e903edf5d19376 = (payload)=>{
    return {
        payload: payload,
        type: $da0d283fe8848c56$export$b8bfd97914e38eff
    };
};

});


parcelRegister("4EUgw", function(module, exports) {
$parcel$export(module.exports, "toFieldStates", () => $33c8ce5ea6ee33f8$export$9144b5804cf423d6);

var $lFpPv = parcelRequire("lFpPv");

var $53JkC = parcelRequire("53JkC");
var $lMRHO = parcelRequire("lMRHO");

var $6wlH1 = parcelRequire("6wlH1");
const $33c8ce5ea6ee33f8$var$MAX_CMDB_OBJECTS_PER_FIELD = 20;
const $33c8ce5ea6ee33f8$var$MAX_AFFECTED_SERVICES_PER_FIELD = 20;
const $33c8ce5ea6ee33f8$export$9144b5804cf423d6 = (fields)=>{
    return fields.map((field)=>{
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'text':
                return $33c8ce5ea6ee33f8$var$toTextFieldState(field);
            case 'textarea':
                return $33c8ce5ea6ee33f8$var$toTextAreaState(field);
            case 'checkbox':
                return $33c8ce5ea6ee33f8$var$toCheckboxGroupState(field);
            case 'radio':
                return $33c8ce5ea6ee33f8$var$toRadioGroupState(field);
            case 'date':
            case 'duedate':
                return $33c8ce5ea6ee33f8$var$toDateState(field, fieldType);
            case 'datetime':
                return $33c8ce5ea6ee33f8$var$toDateTimeState(field);
            case 'attachment':
                return $33c8ce5ea6ee33f8$var$toAttachmentState(field);
            case 'reporter':
                return $33c8ce5ea6ee33f8$var$toReporterState(field);
            case 'userpicker':
                return $33c8ce5ea6ee33f8$var$toUserPickerState(field);
            case 'multiuserpicker':
                return $33c8ce5ea6ee33f8$var$toMultiUserPickerState(field);
            case 'organduserpicker':
                // When feature flag is off, treat as unknown (like before)
                return $33c8ce5ea6ee33f8$var$toUnknownState(field);
            case 'labelpicker':
                return $33c8ce5ea6ee33f8$var$toLabelPickerState(field);
            case 'select':
                return $33c8ce5ea6ee33f8$var$toSelectState(field);
            case 'multiselect':
                return $33c8ce5ea6ee33f8$var$toMultiSelectState(field);
            case 'organisationpicker':
                return $33c8ce5ea6ee33f8$var$toOrganisationState(field);
            case 'assetspicker':
                return $33c8ce5ea6ee33f8$var$toAssetsState(field);
            case 'multiservicepicker':
                return $33c8ce5ea6ee33f8$var$toMultiServicePickerState(field);
            case 'cascadingselect':
                return $33c8ce5ea6ee33f8$var$toCascadingSelect(field);
            case 'cmdbobjectpicker':
                return $33c8ce5ea6ee33f8$var$toCmdbObjectPickerState(field);
            case 'entitlementpicker':
                return $33c8ce5ea6ee33f8$var$toEntitlementPickerState(field);
            case 'forge':
                return $33c8ce5ea6ee33f8$var$toForgeFieldState(field);
            default:
                return $33c8ce5ea6ee33f8$var$toUnknownState(field);
        }
    });
};
/**
 * Parses defaultObjectAsJson and converts to an object if it can be parsed
 */ const $33c8ce5ea6ee33f8$var$getDefaultObjectAsJsonFromField = (field)=>{
    const { defaultObjectAsJson: defaultObjectAsJson } = field;
    let defaultObj;
    try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultObj = defaultObjectAsJson && JSON.parse(defaultObjectAsJson);
    } catch (e) {
    // Swallow the error here
    }
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return defaultObj;
};
// This extracts all the common field properties, normally the only difference between fields are
// type and value
const $33c8ce5ea6ee33f8$var$extractCommonFieldProperties = (field)=>({
        id: field.fieldId,
        displayed: field.displayed,
        label: field.label,
        required: field.required,
        description: field.descriptionHtml,
        ...(0, $lFpPv.isUiModificationsSupportEnabled)() ? {
            jiraFieldType: field.jiraFieldType
        } : {}
    });
const $33c8ce5ea6ee33f8$var$toTextFieldState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'text',
        value: defaultObject ? defaultObject : ''
    };
};
const $33c8ce5ea6ee33f8$var$toTextAreaState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, rendererType: rendererType, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    const emptyDefaultValue = (0, $lFpPv.isRichTextAreaEnabled)() && rendererType === 'atlassian-wiki-renderer' ? undefined : '';
    return {
        ...baseFieldProperties,
        rendererType: rendererType,
        fieldConfigId: fieldConfigId,
        type: 'textarea',
        value: defaultObject ? defaultObject : emptyDefaultValue
    };
};
const $33c8ce5ea6ee33f8$var$toCheckboxGroupState = (field)=>{
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const checkboxItems = fieldValues.map((fieldValue)=>({
            label: fieldValue.label,
            value: fieldValue.value,
            checked: fieldValue.selected
        }));
    const checkedItems = checkboxItems.filter((item)=>!!item.checked);
    const value = checkedItems.map((item)=>item.value);
    return {
        ...baseFieldProperties,
        value: value,
        type: 'checkbox',
        items: checkboxItems
    };
};
const $33c8ce5ea6ee33f8$var$toRadioGroupState = (field)=>{
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const radioGroupItems = fieldValues.map((item)=>({
            name: field.fieldId,
            label: item.label,
            value: item.value,
            selected: item.selected
        }));
    const selectedItem = radioGroupItems.find((item)=>!!item.selected);
    const value = selectedItem ? selectedItem.value : '';
    return {
        ...baseFieldProperties,
        value: value,
        items: radioGroupItems,
        type: 'radio'
    };
};
const $33c8ce5ea6ee33f8$var$IsoDateFormat = /^\d{4}-\d{2}-\d{2}$/;
const $33c8ce5ea6ee33f8$var$normalizeDateTimeFromJson = (field, isoFormat)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    let defaultDate = $33c8ce5ea6ee33f8$var$getDefaultObjectAsJsonFromField(field);
    if (!defaultDate || !(0, $lMRHO.default)(new Date(defaultDate))) // This needs fallback to undefined so the datetime picker sets todays date
    // as the initial screen correctly, else it's 1970.
    return undefined;
    // Fix for the one-day-off issue with new Date()
    // Link: [DateTime Picker One Day Off Issue](https://hello.atlassian.net/wiki/x/zwTjxw)
    if (defaultDate.match($33c8ce5ea6ee33f8$var$IsoDateFormat)) defaultDate = defaultDate.replace(/-/g, '/');
    return (0, $53JkC.default)(new Date(defaultDate), isoFormat);
};
const $33c8ce5ea6ee33f8$var$toDateState = (field, fieldType)=>{
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $33c8ce5ea6ee33f8$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd'),
        type: fieldType,
        value: $33c8ce5ea6ee33f8$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd')
    };
};
const $33c8ce5ea6ee33f8$var$toDateTimeState = (field)=>{
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $33c8ce5ea6ee33f8$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm"),
        type: 'datetime',
        // We don't store timezone date, it's assumed the timezone will be the users timezone set in Jira.
        value: $33c8ce5ea6ee33f8$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm")
    };
};
const $33c8ce5ea6ee33f8$var$toReporterState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'reporter',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultReporter: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $33c8ce5ea6ee33f8$var$toUserPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'userpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUser: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $33c8ce5ea6ee33f8$var$toMultiUserPickerState = (field)=>{
    const defaultList = field.defaultList || [];
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'multiuserpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUsers: defaultList,
        fieldConfigId: field.fieldConfigId ? String(field.fieldConfigId) : '',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        value: defaultList.map((u)=>u.id).join(',')
    };
};
const $33c8ce5ea6ee33f8$var$toSelectState = (field)=>{
    const selectedValue = field.values ? field.values.find((v)=>v.selected) : undefined;
    const value = selectedValue && selectedValue.value;
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        value: value,
        type: 'select',
        options: field.values || [],
        defaultValue: selectedValue
    };
};
const $33c8ce5ea6ee33f8$var$toMultiSelectState = (field)=>{
    const selectedValues = field.values ? field.values.filter((v)=>v.selected) : [];
    const values = selectedValues.map((v)=>v.value);
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        type: 'multiselect',
        options: field.values || [],
        defaultValue: selectedValues,
        value: values
    };
};
const $33c8ce5ea6ee33f8$var$toLabelPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const value = field.defaultList || [];
    /**
   * The field id takes the form of customfield_xxxx where xxxx is the custom field id.
   *
   * The field id can also be "label" if it is the system label field.
   * In the case where the field is the system field we will consider the custom field id to be undefiend
   */ const fieldIdTokens = (field.fieldId || '').toLowerCase().split('customfield_');
    const customFieldId = fieldIdTokens.length > 1 ? fieldIdTokens[1] : undefined;
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        value: value,
        customFieldId: customFieldId,
        type: 'labelpicker',
        defaultLabels: value.map((labelStr)=>({
                label: labelStr,
                value: labelStr
            }))
    };
};
const $33c8ce5ea6ee33f8$var$toCascadingSelect = (field)=>{
    const selectedGroup = field.values && field.values.find((v)=>v.selected);
    const selectedValue = selectedGroup && selectedGroup.children.find((v)=>v.selected);
    const value = selectedGroup && {
        primaryValue: selectedGroup.value,
        children: selectedValue && selectedValue.value
    };
    /**
   * UI Modifications requires defaultValue because it includes both labels and values for parent and child options,
   * whereas the value field only contains the values. This enables the getValueTransformer to properly
   * reconstruct the complete option data structure with value and labels.
   */ const defaultValue = selectedGroup ? {
        primaryValue: {
            label: selectedGroup.label,
            value: selectedGroup.value
        },
        children: selectedValue ? {
            label: selectedValue.label,
            value: selectedValue.value
        } : undefined
    } : undefined;
    const options = field.values ? field.values.map((v)=>({
            label: v.label,
            value: v.value,
            children: v.children
        })) : [];
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        options: options,
        value: value,
        type: 'cascadingselect',
        ...(0, $lFpPv.cascadingSelectDefaultValueSupportEnabled)() ? {
            defaultValue: defaultValue
        } : {}
    };
};
const $33c8ce5ea6ee33f8$var$toOrganisationState = (field)=>{
    var _field$portalFieldCon;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { fieldConfigId: fieldConfigId, defaultObject: defaultObject } = field;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const shareWithOrgByDefault = ((_field$portalFieldCon = field.portalFieldConfiguration) === null || _field$portalFieldCon === void 0 ? void 0 : _field$portalFieldCon.shareWithOrgByDefault) ?? true;
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        fieldConfigId: fieldConfigId,
        shareWithOrgByDefault: // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        shareWithOrgByDefault,
        type: 'organisationpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
};
const $33c8ce5ea6ee33f8$var$toAssetsState = (field)=>{
    const { fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        fieldConfigId: fieldConfigId,
        type: 'assetspicker'
    };
};
const $33c8ce5ea6ee33f8$var$toMultiServicePickerState = (field)=>{
    var _field$portalFieldCon2;
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        type: 'multiservicepicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon2 = field.portalFieldConfiguration) === null || _field$portalFieldCon2 === void 0 ? void 0 : _field$portalFieldCon2.limit) ?? $33c8ce5ea6ee33f8$var$MAX_AFFECTED_SERVICES_PER_FIELD
    };
};
const $33c8ce5ea6ee33f8$var$toAttachmentState = (field)=>{
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        value: [],
        type: 'attachment'
    };
};
const $33c8ce5ea6ee33f8$var$toCmdbObjectPickerState = (field)=>{
    var _field$portalFieldCon3, _field$portalFieldCon4, _field$portalFieldCon5;
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        hasValidConfig: Boolean(field.portalFieldConfiguration),
        type: 'cmdbobjectpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        isMulti: field.portalFieldConfiguration ? field.portalFieldConfiguration.isMulti : false,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        filterAttributes: field.portalFieldConfiguration ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        field.portalFieldConfiguration.filterAttributes : [],
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon3 = field.portalFieldConfiguration) === null || _field$portalFieldCon3 === void 0 ? void 0 : _field$portalFieldCon3.limit) ?? $33c8ce5ea6ee33f8$var$MAX_CMDB_OBJECTS_PER_FIELD,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        placeholderKeys: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon4 = field.portalFieldConfiguration) === null || _field$portalFieldCon4 === void 0 ? void 0 : _field$portalFieldCon4.placeholderKeys) ?? undefined,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        populateDefaultValue: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon5 = field.portalFieldConfiguration) === null || _field$portalFieldCon5 === void 0 ? void 0 : _field$portalFieldCon5.populateDefaultValue) ?? false
    };
};
const $33c8ce5ea6ee33f8$var$toEntitlementPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)()) return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
    return {
        ...$33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker'
    };
};
const $33c8ce5ea6ee33f8$var$toForgeFieldState = (field)=>{
    var _field$forge, _forgeExtension$prope, _forgeExtension$prope2;
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    const forgeExtension = (_field$forge = field.forge) === null || _field$forge === void 0 ? void 0 : _field$forge.extension;
    const fieldType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope = forgeExtension.properties) === null || _forgeExtension$prope === void 0 ? void 0 : _forgeExtension$prope.type;
    const collectionType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope2 = forgeExtension.properties) === null || _forgeExtension$prope2 === void 0 ? void 0 : _forgeExtension$prope2.collection;
    // defaultObject is typed as any in the Field type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const defaultObject = field.defaultObject;
    const defaultList = field.defaultList || [];
    const { value: value, additionalProps: additionalProps } = (0, $6wlH1.forgeFieldParamsParser)(fieldType, collectionType, defaultObject, defaultList);
    if ((0, $lFpPv.isForgeCustomFieldsOnPortalViewEnabled)()) return {
        value: value,
        ...baseFieldProperties,
        ...additionalProps,
        type: 'forge',
        extension: forgeExtension
    };
    return {
        ...baseFieldProperties,
        type: 'forge',
        jiraFieldType: field.jiraFieldType // TODO: remove as with ditto_uim_-_jsm_support_main FF cleanup
    };
};
const $33c8ce5ea6ee33f8$var$toUnknownState = (field)=>{
    const baseFieldProperties = $33c8ce5ea6ee33f8$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'unknown'
    };
};

});
parcelRegister("6wlH1", function(module, exports) {
$parcel$export(module.exports, "forgeFieldParamsParser", () => $ef91e7c07047f823$export$ba975bd6e357689d);

var $53JkC = parcelRequire("53JkC");
const $ef91e7c07047f823$export$ba975bd6e357689d = (fieldType, collectionType, defaultObject, defaultList)=>{
    let value;
    let additionalProps = {};
    switch(fieldType){
        case 'string':
            if (collectionType === 'list') {
                value = defaultList;
                additionalProps = {
                    // String list is rendered as label picker
                    defaultLabels: value.map((labelStr)=>({
                            label: labelStr,
                            value: labelStr
                        }))
                };
            } else value = defaultObject;
            break;
        case 'number':
            value = defaultObject;
            break;
        case 'date':
            value = defaultObject ? (0, $53JkC.default)(new Date(defaultObject), 'yyyy-MM-dd') : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'datetime':
            value = defaultObject ? (0, $53JkC.default)(new Date(defaultObject), "yyyy-MM-dd'T'HH:mm") : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'user':
            if (collectionType === 'list') {
                value = defaultList.map((u)=>u.id).join(',');
                additionalProps = {
                    defaultUsers: defaultList
                };
            } else {
                value = defaultList && defaultList.length > 0 ? defaultList[0].id : undefined;
                additionalProps = {
                    defaultUser: defaultList[0]
                };
            }
            break;
        default:
            value = null;
            break;
    }
    return {
        value: value,
        additionalProps: additionalProps
    };
};

});


parcelRegister("axowX", function(module, exports) {
$parcel$export(module.exports, "parseFieldUrlParams", () => $d7c28d8b7206961a$export$23f65b7a085343aa);

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $fvUqa = parcelRequire("fvUqa");

var $2Zepk = parcelRequire("2Zepk");

var $gEVth = parcelRequire("gEVth");

var $gYDJY = parcelRequire("gYDJY");
const $d7c28d8b7206961a$var$CASCADE_SELECT_ID_SUFFIX = ':1';
function $d7c28d8b7206961a$export$23f65b7a085343aa(fields) {
    if (!fields || fields.length === 0) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const urlParams = (0, $fvUqa.parse)((0, $gYDJY.search)());
    if (!urlParams) return {};
    return fields.reduce((values, field)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const urlParamValue = urlParams[field.id];
        if (urlParamValue !== undefined) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const cascadeNestedSelectUrlParamValue = urlParams[`${field.id}${$d7c28d8b7206961a$var$CASCADE_SELECT_ID_SUFFIX}`];
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            values[field.id] = $d7c28d8b7206961a$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue);
            if (cascadeNestedSelectUrlParamValue) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            values[`${field.id}${$d7c28d8b7206961a$var$CASCADE_SELECT_ID_SUFFIX}`] = cascadeNestedSelectUrlParamValue;
        }
        return values;
    }, {});
}
function $d7c28d8b7206961a$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue) {
    $d7c28d8b7206961a$var$firePrePopAnalyticsEvent(field);
    switch(field.type){
        case 'labelpicker':
            return $d7c28d8b7206961a$var$parseLabelsUrlParam(urlParamValue);
        case 'checkbox':
            {
                const checkboxGroup = field;
                return $d7c28d8b7206961a$var$parseCheckboxUrlParam(urlParamValue, checkboxGroup.items);
            }
        case 'select':
            {
                const select = field;
                return $d7c28d8b7206961a$var$parseSelectUrlParam(urlParamValue, select.options);
            }
        case 'multiselect':
            {
                const multiSelect = field;
                return $d7c28d8b7206961a$var$parseMultiSelectUrlParam(urlParamValue, multiSelect.options);
            }
        case 'cascadingselect':
            {
                const cascadingSelectState = field;
                return $d7c28d8b7206961a$var$parseCascadingSelectUrlParam(cascadingSelectState.options, urlParamValue, cascadeNestedSelectUrlParamValue);
            }
        case 'textarea':
            if ((0, $lFpPv.isRichTextAreaEnabled)() && field.rendererType === 'atlassian-wiki-renderer') return $d7c28d8b7206961a$var$parseRichTextAreaUrlParam(urlParamValue);
            return urlParamValue;
        case 'multiuserpicker':
            return urlParamValue;
        default:
            // Dynamic fields are handled directly in hydrateUrlParamOverrides() since async calls need to be made
            return urlParamValue;
    }
}
function $d7c28d8b7206961a$var$firePrePopAnalyticsEvent(field) {
    const actionSubjectId = field.id.startsWith('customfield') ? 'customfield' : field.id;
    (0, $gEVth.operationalEvent)({
        actionSubjectId: actionSubjectId,
        action: 'prePopulated',
        actionSubject: 'field',
        source: (0, $jcRK7.ScreenName).REQUEST_CREATE,
        attributes: {
            fieldType: field.type
        }
    });
}
function $d7c28d8b7206961a$var$parseLabelsUrlParam(labels) {
    if ($d7c28d8b7206961a$var$isEmptyStringOrArray(labels)) return [];
    if (typeof labels === 'string') {
        const singleLabel = labels;
        return [
            {
                label: singleLabel,
                value: singleLabel
            }
        ];
    }
    const multipleLabels = labels;
    return multipleLabels.map((toConvert)=>({
            label: toConvert,
            value: toConvert
        }));
}
const $d7c28d8b7206961a$var$isEmptyStringOrArray = (value)=>value.length === 0;
const $d7c28d8b7206961a$var$parseSelectUrlParam = (urlParam, options)=>options.find((option)=>option.value === urlParam);
function $d7c28d8b7206961a$var$parseCheckboxUrlParam(checkedUrlParam, items) {
    if ($d7c28d8b7206961a$var$isEmptyStringOrArray(checkedUrlParam)) return [];
    if (typeof checkedUrlParam === 'string') {
        const checkedBoxValue = checkedUrlParam;
        const checkedBox = items.find((item)=>item.value === checkedBoxValue);
        return checkedBox ? [
            checkedBox.value
        ] : [];
    }
    const checkedBoxValues = checkedUrlParam;
    return items.filter((item)=>checkedBoxValues.includes(item.value)).map((item)=>item.value);
}
function $d7c28d8b7206961a$var$parseMultiSelectUrlParam(selected, options) {
    if ($d7c28d8b7206961a$var$isEmptyStringOrArray(selected)) return [];
    if (typeof selected === 'string') {
        const selection = selected;
        return options.filter((option)=>option.value === selection);
    }
    const selections = selected;
    return options.filter((option)=>selections.includes(option.value));
}
function $d7c28d8b7206961a$var$parseCascadingSelectUrlParam(options, parentUrlParam, childUrlParam) {
    const parentOption = options.find((option)=>option.value === parentUrlParam);
    if (!parentOption) return null;
    const childOption = parentOption.children.find((option)=>option.value === childUrlParam);
    return {
        primaryValue: parentOption.value,
        children: childOption && childOption.value
    };
}
const $d7c28d8b7206961a$var$parseRichTextAreaUrlParam = (urlParam)=>JSON.stringify((0, $2Zepk.plainTextToAdfParagraph)(urlParam));

});
parcelRegister("2Zepk", function(module, exports) {
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $5d81549f87468b7a$export$cf4bde415465976c);
$parcel$export(module.exports, "parseAdf", () => $5d81549f87468b7a$export$5659c60045974de9);
$parcel$export(module.exports, "plainTextToAdfParagraph", () => $5d81549f87468b7a$export$a5c4f0d0658bc780);
$parcel$export(module.exports, "getAccountIdsFromComment", () => $5d81549f87468b7a$export$f9672ae84945eb8e);

var $hMBe3 = parcelRequire("hMBe3");

var $758n4 = parcelRequire("758n4");

var $oORS9 = parcelRequire("oORS9");
const $5d81549f87468b7a$var$hardBreakNodeType = 'hardBreak';
const $5d81549f87468b7a$export$cf4bde415465976c = (adf)=>{
    if (adf && adf.content) return adf.content.every((content)=>{
        return $5d81549f87468b7a$var$isOnlyWhitespaceParagraphNode(content);
    });
    return false;
};
const $5d81549f87468b7a$var$isOnlyWhitespaceParagraphNode = (content)=>{
    if (content.type === 'paragraph') return content.content === undefined || content.content.length === 0 || content.content.every((innerContent)=>$5d81549f87468b7a$var$isOnlyWhitespaceTextNode(innerContent) || $5d81549f87468b7a$var$isHardBreakNode(innerContent));
    return false;
};
const $5d81549f87468b7a$var$isOnlyWhitespaceTextNode = (content)=>{
    if ((content === null || content === void 0 ? void 0 : content.type) === 'text') return content.text === undefined || content.text.match(/^\s*$/) !== null;
    return false;
};
const $5d81549f87468b7a$var$isHardBreakNode = (content)=>{
    return (content === null || content === void 0 ? void 0 : content.type) === $5d81549f87468b7a$var$hardBreakNodeType;
};
const $5d81549f87468b7a$export$5659c60045974de9 = (content)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const node = JSON.parse(content);
    /*
     With Editor and Media upgrade, we have a strongly typed renderer, which is causing some types
     to break. This (typecasting to DocNode['content']) should be fixed in a follow-up.
     */ node.content = $5d81549f87468b7a$var$removeSuffixFromNodes(node.content);
    return node;
};
const $5d81549f87468b7a$var$removeSuffixFromNodes = (nodes)=>{
    if (!nodes) return nodes;
    return nodes.map((node)=>{
        if (!node) return node;
        if (node.type === 'inlineCard' && node.attrs) node.attrs = $5d81549f87468b7a$var$updateInlineCardAttributes(node.attrs);
        if (node.content) node.content = $5d81549f87468b7a$var$removeSuffixFromNodes(node.content);
        return node;
    });
};
const $5d81549f87468b7a$export$a5c4f0d0658bc780 = (plainText)=>({
        version: 1,
        // Using static version number as this doesn't seem to change
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: plainText
                    }
                ]
            }
        ]
    });
const $5d81549f87468b7a$var$removedIcftFromUrlCache = {};
const $5d81549f87468b7a$var$updateInlineCardAttributes = (attributes)=>{
    if (attributes.url && (0, $oORS9.parseIssueKeyFromUrl)(attributes.url)) {
        if (!$5d81549f87468b7a$var$removedIcftFromUrlCache[attributes.url]) {
            (0, $758n4.trackLegacyEvent)('servicedesk.customerview.util.adf.remove.icft.suffix', {});
            $5d81549f87468b7a$var$removedIcftFromUrlCache[attributes.url] = true;
        }
        attributes.url = $5d81549f87468b7a$var$removeICFTURLSuffix(attributes.url);
    }
    return attributes;
};
const $5d81549f87468b7a$var$removeICFTURLSuffix = (content)=>{
    return content.replace(/#icft=[A-Z][A-Z0-9_]+-\d+/gi, '');
};
const $5d81549f87468b7a$export$f9672ae84945eb8e = (adfText)=>{
    const accountIds = new Map();
    (0, $hMBe3.traverse)(adfText, {
        mention: (node)=>{
            var _node$attrs, _node$attrs2;
            /* text can be of form @user_name or user_name */ // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            let displayName = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.text;
            if (displayName) displayName = displayName.charAt(0) === '@' ? displayName.substring(1) : displayName;
            accountIds.set((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.id, displayName);
        }
    });
    return accountIds;
};

});
parcelRegister("hMBe3", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $a881f4b1474baa4f$export$df3f009e3d155b20);

var $jGM2Z = parcelRequire("jGM2Z");
function $a881f4b1474baa4f$export$df3f009e3d155b20(adf, visitors) {
    if (!(0, $jGM2Z.validateVisitors)(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $a881f4b1474baa4f$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a881f4b1474baa4f$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $a881f4b1474baa4f$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});
parcelRegister("jGM2Z", function(module, exports) {
$parcel$export(module.exports, "validateVisitors", () => $a18535452bc3bcf2$export$735cfea22ce30f58);
function $a18535452bc3bcf2$export$735cfea22ce30f58(_visitors) {
    return true;
}

});




parcelRegister("8UaEm", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => (parcelRequire("8y1MK")).fetchCmdbObjectsWithSignal);
$parcel$export(module.exports, "fetchCmdbObjectDetails", () => (parcelRequire("8y1MK")).fetchCmdbObjectDetails);

var $8y1MK = parcelRequire("8y1MK");

});
parcelRegister("8y1MK", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectDetails", () => $ea3404352105246f$export$8b96c3d6d1277eda);
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => $ea3404352105246f$export$d4d0e07838855f63);

var $51XYw = parcelRequire("51XYw");

var $eDcdn = parcelRequire("eDcdn");
const $ea3404352105246f$export$8b96c3d6d1277eda = (requestKey, fieldId, objectGlobalId, signal)=>(0, $51XYw.fetchJson)(`${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/request/${requestKey}/cmdb/field/${fieldId}/object/${objectGlobalId}`, {
        signal: signal,
        method: 'GET'
    }).then(({ attributes: attributes })=>attributes ?? []);
const $ea3404352105246f$export$d4d0e07838855f63 = (portalId, requestTypeId, fieldId, inputValue, fieldValueMap, signal, start)=>{
    const fieldValueMapObject = fieldValueMap.reduce((accumulator, field)=>{
        if (field[0] !== 'attachment') accumulator[field[0]] = field[1];
        return accumulator;
    }, {});
    const body = {
        query: inputValue,
        fieldValueMap: fieldValueMapObject
    };
    return (0, $51XYw.fetchJson)(`${(0, $eDcdn.contextPath)}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}`, {
        signal: signal,
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(({ results: results, total: total, hasNextPage: hasNextPage })=>({
            total: total,
            hasNextPage: hasNextPage,
            cmdbObjects: results
        }));
};

});



parcelRegister("43E2w", function(module, exports) {
$parcel$export(module.exports, "requestDetailsEpic", () => $e5a3e914c461344a$export$211ba11a17095531);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");
const $e5a3e914c461344a$export$211ba11a17095531 = (action$)=>{
    return action$.ofType((0, $gXSFL.FETCH_REQUEST_DETAILS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload, {
            type: 'secondary',
            disableBatching: true
        }).filter((response)=>!!response.reqDetails && !!response.reqDetails.issue).map((response)=>{
            return (0, $gXSFL.fetchRequestDetailsSuccess)(response.reqDetails);
        }).catch((error)=>{
            const key = action.payload.params.key;
            return (0, $8jOUp.Observable).of((0, $gXSFL.fetchRequestDetailsFailure)(key, error));
        }));
};

});
parcelRegister("bkU3q", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => (parcelRequire("gXSFL")).CHANGE_SUBSCRIPTION);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => (parcelRequire("gXSFL")).CHANGE_SUBSCRIPTION_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT", () => (parcelRequire("gXSFL")).CREATE_COMMENT);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => (parcelRequire("gXSFL")).CREATE_COMMENT_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => (parcelRequire("gXSFL")).CREATE_COMMENT_FAILURE);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => (parcelRequire("gXSFL")).GET_MEDIA_READ_CREDENTIALS);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => (parcelRequire("gXSFL")).GET_MEDIA_READ_CREDENTIALS_SUCCESS);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => (parcelRequire("gXSFL")).DECIDE_APPROVAL);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => (parcelRequire("gXSFL")).DECIDE_APPROVAL_FAILURE);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => (parcelRequire("gXSFL")).FETCH_REQUEST_DETAILS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => (parcelRequire("gXSFL")).FETCH_REQUEST_DETAILS_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => (parcelRequire("gXSFL")).FETCH_REQUEST_DETAILS_FAILURE);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => (parcelRequire("gXSFL")).REMOVE_ORGANISATION);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => (parcelRequire("gXSFL")).REMOVE_ORGANISATION_SUCCESS);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => (parcelRequire("gXSFL")).ADD_PARTICIPANTS_SUCCESS);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => (parcelRequire("gXSFL")).REMOVE_PARTICIPANT);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => (parcelRequire("gXSFL")).REMOVE_PARTICIPANT_SUCCESS);
$parcel$export(module.exports, "SHARE_REQUEST", () => (parcelRequire("gXSFL")).SHARE_REQUEST);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => (parcelRequire("gXSFL")).SHOW_TRANSITION_DIALOG);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => (parcelRequire("gXSFL")).HIDE_TRANSITION_DIALOG);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => (parcelRequire("gXSFL")).TRANSITION_REQUEST);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => (parcelRequire("gXSFL")).TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => (parcelRequire("gXSFL")).CLEAR_TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "changeSubscription", () => (parcelRequire("gXSFL")).changeSubscription);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => (parcelRequire("gXSFL")).changeSubscriptionSuccess);
$parcel$export(module.exports, "createCommentFailure", () => (parcelRequire("gXSFL")).createCommentFailure);
$parcel$export(module.exports, "createComment", () => (parcelRequire("gXSFL")).createComment);
$parcel$export(module.exports, "createCommentSuccess", () => (parcelRequire("gXSFL")).createCommentSuccess);
$parcel$export(module.exports, "getReadCredentials", () => (parcelRequire("gXSFL")).getReadCredentials);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => (parcelRequire("gXSFL")).getReadCredentialsSuccess);
$parcel$export(module.exports, "getReadCredentialsFailure", () => (parcelRequire("gXSFL")).getReadCredentialsFailure);
$parcel$export(module.exports, "decideApproval", () => (parcelRequire("gXSFL")).decideApproval);
$parcel$export(module.exports, "decideApprovalFailure", () => (parcelRequire("gXSFL")).decideApprovalFailure);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => (parcelRequire("gXSFL")).fetchRequestDetailsModel);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => (parcelRequire("gXSFL")).fetchRequestDetailsSuccess);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => (parcelRequire("gXSFL")).fetchRequestDetailsFailure);
$parcel$export(module.exports, "removeOrganisation", () => (parcelRequire("gXSFL")).removeOrganisation);
$parcel$export(module.exports, "removeOrganisationSuccess", () => (parcelRequire("gXSFL")).removeOrganisationSuccess);
$parcel$export(module.exports, "addParticipantsSuccess", () => (parcelRequire("gXSFL")).addParticipantsSuccess);
$parcel$export(module.exports, "removeParticipant", () => (parcelRequire("gXSFL")).removeParticipant);
$parcel$export(module.exports, "removeParticipantSuccess", () => (parcelRequire("gXSFL")).removeParticipantSuccess);
$parcel$export(module.exports, "shareRequest", () => (parcelRequire("gXSFL")).shareRequest);
$parcel$export(module.exports, "showTransitionDialog", () => (parcelRequire("gXSFL")).showTransitionDialog);
$parcel$export(module.exports, "hideTransitionDialog", () => (parcelRequire("gXSFL")).hideTransitionDialog);
$parcel$export(module.exports, "transitionRequest", () => (parcelRequire("gXSFL")).transitionRequest);
$parcel$export(module.exports, "transitionRequestFailure", () => (parcelRequire("gXSFL")).transitionRequestFailure);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => (parcelRequire("gXSFL")).clearTransitionRequestFailure);

var $gXSFL = parcelRequire("gXSFL");

});
parcelRegister("gXSFL", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => $d888deb8929e780f$export$c82a76c42259b55e);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => $d888deb8929e780f$export$aed2f68a180d5132);
$parcel$export(module.exports, "CREATE_COMMENT", () => $d888deb8929e780f$export$b2aae42fb0a19db3);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => $d888deb8929e780f$export$5e5d6c973a5c4e53);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => $d888deb8929e780f$export$423d075659092bbe);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => $d888deb8929e780f$export$6e57eb44a84791a7);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => $d888deb8929e780f$export$710f501aa8462ae0);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => $d888deb8929e780f$export$17b4c1a883566436);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => $d888deb8929e780f$export$32a89de369c73827);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => $d888deb8929e780f$export$c6977262f615318f);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => $d888deb8929e780f$export$16e2b1f014063eb8);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => $d888deb8929e780f$export$b793c4f327f63a76);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => $d888deb8929e780f$export$8fb5a515e01e48c5);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => $d888deb8929e780f$export$74436d62ceb0e590);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => $d888deb8929e780f$export$85378bb183dca844);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => $d888deb8929e780f$export$fbce83858fb867fb);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => $d888deb8929e780f$export$dfb1c2f386aee705);
$parcel$export(module.exports, "SHARE_REQUEST", () => $d888deb8929e780f$export$5cf2f51c187a7d5f);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => $d888deb8929e780f$export$7fb10a1857e0e02a);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => $d888deb8929e780f$export$3a407eae5b6f60b);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => $d888deb8929e780f$export$a966f1a0c1a920e7);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => $d888deb8929e780f$export$fd4af480b5082555);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => $d888deb8929e780f$export$9e405a82dd6dd4e1);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => $d888deb8929e780f$export$5d6a7943e794d360);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => $d888deb8929e780f$export$f9b1366a7a60a8a);
$parcel$export(module.exports, "addParticipantsSuccess", () => $d888deb8929e780f$export$524d371754c76f3c);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => $d888deb8929e780f$export$5ef0f7883c2144b6);
$parcel$export(module.exports, "changeSubscription", () => $d888deb8929e780f$export$99effa43b85cc1d1);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => $d888deb8929e780f$export$e91b59ae91b1c17d);
$parcel$export(module.exports, "decideApprovalFailure", () => $d888deb8929e780f$export$8ab1e7354f0ec72f);
$parcel$export(module.exports, "decideApproval", () => $d888deb8929e780f$export$5fffe31f8df4a90b);
$parcel$export(module.exports, "removeOrganisation", () => $d888deb8929e780f$export$66d4278db03b2954);
$parcel$export(module.exports, "removeOrganisationSuccess", () => $d888deb8929e780f$export$f8de82921adab699);
$parcel$export(module.exports, "removeParticipant", () => $d888deb8929e780f$export$971a7382b074b466);
$parcel$export(module.exports, "removeParticipantSuccess", () => $d888deb8929e780f$export$9be1ee8fbc799e1c);
$parcel$export(module.exports, "shareRequest", () => $d888deb8929e780f$export$904a7ffbfa202969);
$parcel$export(module.exports, "showTransitionDialog", () => $d888deb8929e780f$export$375ec276b5b0476c);
$parcel$export(module.exports, "hideTransitionDialog", () => $d888deb8929e780f$export$69175c2908a46e20);
$parcel$export(module.exports, "transitionRequest", () => $d888deb8929e780f$export$e72771314c1d54);
$parcel$export(module.exports, "transitionRequestFailure", () => $d888deb8929e780f$export$18f56c137e75378a);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => $d888deb8929e780f$export$20cf1fa346e88708);
$parcel$export(module.exports, "createComment", () => $d888deb8929e780f$export$2a15b079e3f46654);
$parcel$export(module.exports, "createCommentSuccess", () => $d888deb8929e780f$export$e993efecfd9a08b4);
$parcel$export(module.exports, "createCommentFailure", () => $d888deb8929e780f$export$5e212521c28e6663);
$parcel$export(module.exports, "getReadCredentials", () => $d888deb8929e780f$export$c62f8329852c0c3e);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => $d888deb8929e780f$export$1c3602ad787f66de);
$parcel$export(module.exports, "getReadCredentialsFailure", () => $d888deb8929e780f$export$c1fdee8bb31030c2);

var $hn5Mq = parcelRequire("hn5Mq");
const $d888deb8929e780f$export$c82a76c42259b55e = 'state.persisted.request.details.CHANGE_SUBSCRIPTION';
const $d888deb8929e780f$export$aed2f68a180d5132 = 'state.persisted.request.details.CHANGE_SUBSCRIPTION_SUCCESS';
const $d888deb8929e780f$export$b2aae42fb0a19db3 = 'state.persisted.request.details.CREATE_COMMENT';
const $d888deb8929e780f$export$5e5d6c973a5c4e53 = 'state.persisted.request.details.CREATE_COMMENT_SUCCESS';
const $d888deb8929e780f$export$423d075659092bbe = 'state.persisted.request.details.CREATE_COMMENT_FAILURE';
const $d888deb8929e780f$export$6e57eb44a84791a7 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS';
const $d888deb8929e780f$export$710f501aa8462ae0 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_SUCCESS';
const $d888deb8929e780f$export$73373e74567a5c83 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_FAILURE';
const $d888deb8929e780f$export$17b4c1a883566436 = 'state.persisted.request.details.DECIDE_APPROVAL';
const $d888deb8929e780f$export$32a89de369c73827 = 'state.persisted.request.details.DECIDE_APPROVAL_FAILURE';
const $d888deb8929e780f$export$c6977262f615318f = 'epic.model.FETCH_REQUEST_DETAILS_MODEL';
const $d888deb8929e780f$export$16e2b1f014063eb8 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_SUCCESS';
const $d888deb8929e780f$export$b793c4f327f63a76 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_FAILURE';
const $d888deb8929e780f$export$8fb5a515e01e48c5 = 'state.persisted.request.details.REMOVE_ORGANISATION';
const $d888deb8929e780f$export$74436d62ceb0e590 = 'state.persisted.request.details.REMOVE_ORGANISATION_SUCCESS';
const $d888deb8929e780f$export$85378bb183dca844 = 'state.persisted.request.details.ADD_PARTICIPANTS_SUCCESS';
const $d888deb8929e780f$export$fbce83858fb867fb = 'state.persisted.request.details.REMOVE_PARTICIPANT';
const $d888deb8929e780f$export$dfb1c2f386aee705 = 'state.persisted.request.details.REMOVE_PARTICIPANT_SUCCESS';
const $d888deb8929e780f$export$5cf2f51c187a7d5f = 'state.persisted.request.details.SHARE_REQUEST';
const $d888deb8929e780f$export$7fb10a1857e0e02a = 'state.ui.request.details.SHOW_TRANSITION_DIALOG';
const $d888deb8929e780f$export$3a407eae5b6f60b = 'state.ui.request.details.HIDE_TRANSITION_DIALOG';
const $d888deb8929e780f$export$a966f1a0c1a920e7 = 'state.persisted.request.details.TRANSITION_REQUEST';
const $d888deb8929e780f$export$fd4af480b5082555 = 'state.persisted.request.details.TRANSITION_REQUEST_FAILURE';
const $d888deb8929e780f$export$9e405a82dd6dd4e1 = 'state.persisted.request.details.CLEAR_TRANSITION_REQUEST';
const $d888deb8929e780f$export$5d6a7943e794d360 = (0, $hn5Mq.buildModelsActionCreator)($d888deb8929e780f$export$c6977262f615318f, 'reqDetails');
const $d888deb8929e780f$export$f9b1366a7a60a8a = (requestDetailsModel)=>({
        type: $d888deb8929e780f$export$16e2b1f014063eb8,
        payload: requestDetailsModel
    });
const $d888deb8929e780f$export$524d371754c76f3c = (requestKey, addParticipantsSuccessResponse, userMentionedDuringRequestCreation = false)=>({
        type: $d888deb8929e780f$export$85378bb183dca844,
        payload: {
            requestKey: requestKey,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            addParticipantsSuccessResponse: addParticipantsSuccessResponse
        }
    });
const $d888deb8929e780f$export$5ef0f7883c2144b6 = (requestKey, error)=>({
        type: $d888deb8929e780f$export$b793c4f327f63a76,
        payload: {
            requestKey: requestKey,
            error: error
        }
    });
const $d888deb8929e780f$export$99effa43b85cc1d1 = (requestKey, requestId, shouldSubscribe)=>({
        type: $d888deb8929e780f$export$c82a76c42259b55e,
        payload: {
            requestKey: requestKey,
            requestId: requestId,
            shouldSubscribe: shouldSubscribe
        }
    });
const $d888deb8929e780f$export$e91b59ae91b1c17d = (requestKey, shouldSubscribe)=>({
        type: $d888deb8929e780f$export$aed2f68a180d5132,
        payload: {
            requestKey: requestKey,
            shouldSubscribe: shouldSubscribe
        }
    });
const $d888deb8929e780f$export$8ab1e7354f0ec72f = ()=>({
        type: $d888deb8929e780f$export$32a89de369c73827
    });
const $d888deb8929e780f$export$5fffe31f8df4a90b = (portalId, requestKey, approvalId, approve, createAnalyticsEvent)=>({
        type: $d888deb8929e780f$export$17b4c1a883566436,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            approvalId: approvalId,
            approve: approve,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $d888deb8929e780f$export$66d4278db03b2954 = (requestKey, organisationId)=>({
        type: $d888deb8929e780f$export$8fb5a515e01e48c5,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $d888deb8929e780f$export$f8de82921adab699 = (requestKey, organisationId)=>({
        type: $d888deb8929e780f$export$74436d62ceb0e590,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $d888deb8929e780f$export$971a7382b074b466 = (requestKey, accountId)=>({
        type: $d888deb8929e780f$export$fbce83858fb867fb,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $d888deb8929e780f$export$9be1ee8fbc799e1c = (requestKey, accountId)=>({
        type: $d888deb8929e780f$export$dfb1c2f386aee705,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $d888deb8929e780f$export$904a7ffbfa202969 = (requestKey, organizations, emailAddresses, accountIds, isUserMentioned, mentionedUserName, userMentionedDuringRequestCreation)=>({
        type: $d888deb8929e780f$export$5cf2f51c187a7d5f,
        payload: {
            requestKey: requestKey,
            organizations: organizations,
            emailAddresses: emailAddresses,
            accountIds: accountIds,
            isUserMentioned: isUserMentioned,
            mentionedUserName: mentionedUserName,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation
        }
    });
const $d888deb8929e780f$export$375ec276b5b0476c = (id)=>({
        type: $d888deb8929e780f$export$7fb10a1857e0e02a,
        payload: {
            id: id
        }
    });
const $d888deb8929e780f$export$69175c2908a46e20 = ()=>({
        type: $d888deb8929e780f$export$3a407eae5b6f60b
    });
const $d888deb8929e780f$export$e72771314c1d54 = (portalId, requestKey, transitionId, comment, createAnalyticsEvent)=>({
        type: $d888deb8929e780f$export$a966f1a0c1a920e7,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            transitionId: transitionId,
            comment: comment,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $d888deb8929e780f$export$18f56c137e75378a = (error)=>({
        type: $d888deb8929e780f$export$fd4af480b5082555,
        payload: {
            error: error
        }
    });
const $d888deb8929e780f$export$20cf1fa346e88708 = ()=>({
        type: $d888deb8929e780f$export$9e405a82dd6dd4e1
    });
const $d888deb8929e780f$export$2a15b079e3f46654 = (portalId, requestId, requestKey, comment, fileIds, xsrftoken, numberOfMentionedUsers, meta)=>({
        type: $d888deb8929e780f$export$b2aae42fb0a19db3,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey,
            comment: comment,
            fileIds: fileIds,
            xsrftoken: xsrftoken,
            numberOfMentionedUsers: numberOfMentionedUsers,
            meta: meta
        }
    });
const $d888deb8929e780f$export$e993efecfd9a08b4 = (requestKey, response)=>({
        type: $d888deb8929e780f$export$5e5d6c973a5c4e53,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $d888deb8929e780f$export$5e212521c28e6663 = ()=>({
        type: $d888deb8929e780f$export$423d075659092bbe,
        payload: {}
    });
const $d888deb8929e780f$export$c62f8329852c0c3e = (portalId, requestId, requestKey)=>({
        type: $d888deb8929e780f$export$6e57eb44a84791a7,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey
        }
    });
const $d888deb8929e780f$export$1c3602ad787f66de = (requestKey, response)=>({
        type: $d888deb8929e780f$export$710f501aa8462ae0,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $d888deb8929e780f$export$c1fdee8bb31030c2 = ()=>({
        type: $d888deb8929e780f$export$73373e74567a5c83,
        payload: {}
    });

});



parcelRegister("iRbxO", function(module, exports) {
$parcel$export(module.exports, "requestListEpic", () => $49236484233eefa4$export$ab46e56cc8f700e6);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("cqYZw");
var $jJY1A = parcelRequire("jJY1A");
const $49236484233eefa4$export$ab46e56cc8f700e6 = (action$)=>{
    return action$.ofType((0, $jJY1A.FETCH_REQUEST_LIST_MODEL)).switchMap((action)=>{
        return (0, $fVm9J.default)(action.payload).filter((response)=>response.allReqFilter !== undefined && 'requestList' in response.allReqFilter && Array.isArray(response.allReqFilter.requestList)).flatMap((response)=>{
            const filter = action.payload.params.filter;
            // TypeScript's Observable.filter() does not narrow types, so response.allReqFilter
            // is still typed as RequestListResponse | undefined here even though the preceding
            // .filter() guarantees it is defined and has a valid requestList array.
            const requestListModel = response.allReqFilter;
            return (0, $8jOUp.Observable).of((0, $jJY1A.fetchRequestListSuccess)({
                ...requestListModel,
                filter: filter
            }));
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $jJY1A.fetchRequestListFailure)(error));
        });
    });
};

});
parcelRegister("cqYZw", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => (parcelRequire("jJY1A")).FETCH_REQUEST_LIST_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => (parcelRequire("jJY1A")).FETCH_REQUEST_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => (parcelRequire("jJY1A")).FETCH_REQUEST_LIST_FAILURE);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => (parcelRequire("jJY1A")).MARK_INITIAL_PAGE_LOAD_RENDERED);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => (parcelRequire("jJY1A")).INVALIDATE_PAGES);
$parcel$export(module.exports, "fetchRequestListModel", () => (parcelRequire("jJY1A")).fetchRequestListModel);
$parcel$export(module.exports, "fetchRequestListSuccess", () => (parcelRequire("jJY1A")).fetchRequestListSuccess);
$parcel$export(module.exports, "fetchRequestListFailure", () => (parcelRequire("jJY1A")).fetchRequestListFailure);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => (parcelRequire("jJY1A")).markInitialPageLoadRendered);
$parcel$export(module.exports, "invalidatePages", () => (parcelRequire("jJY1A")).invalidatePages);

var $jJY1A = parcelRequire("jJY1A");

});
parcelRegister("jJY1A", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => $ec98364cc26bdbc1$export$7ee1e1fb4cf5db91);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => $ec98364cc26bdbc1$export$f9ff6948957ba5c5);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => $ec98364cc26bdbc1$export$f5e5c834c1e2e455);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => $ec98364cc26bdbc1$export$4f7af1d62055a261);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => $ec98364cc26bdbc1$export$d772cf5cfb44df9);
$parcel$export(module.exports, "fetchRequestListModel", () => $ec98364cc26bdbc1$export$decc5f94205f709e);
$parcel$export(module.exports, "invalidatePages", () => $ec98364cc26bdbc1$export$64b565f3a0ba7cb5);
$parcel$export(module.exports, "fetchRequestListSuccess", () => $ec98364cc26bdbc1$export$132d3416d8175125);
$parcel$export(module.exports, "fetchRequestListFailure", () => $ec98364cc26bdbc1$export$a842eadee8280475);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => $ec98364cc26bdbc1$export$b643261c092a4f6);

var $hn5Mq = parcelRequire("hn5Mq");
const $ec98364cc26bdbc1$export$7ee1e1fb4cf5db91 = 'epic.model.FETCH_REQUEST_LIST_MODEL';
const $ec98364cc26bdbc1$export$f9ff6948957ba5c5 = 'state.persisted.request.List.FETCH_REQUEST_LIST_SUCCESS';
const $ec98364cc26bdbc1$export$f5e5c834c1e2e455 = 'state.persisted.request.List.FETCH_REQUEST_LIST_FAILURE';
const $ec98364cc26bdbc1$export$4f7af1d62055a261 = 'state.persisted.request.List.MARK_INITIAL_PAGE_LOAD_RENDERED';
const $ec98364cc26bdbc1$export$d772cf5cfb44df9 = 'state.persisted.request.List.INVALIDATE_PAGES';
const $ec98364cc26bdbc1$export$decc5f94205f709e = (0, $hn5Mq.buildModelsActionCreator)($ec98364cc26bdbc1$export$7ee1e1fb4cf5db91, 'allReqFilter');
const $ec98364cc26bdbc1$export$64b565f3a0ba7cb5 = (currentPage)=>({
        type: $ec98364cc26bdbc1$export$d772cf5cfb44df9,
        payload: currentPage
    });
const $ec98364cc26bdbc1$export$132d3416d8175125 = (requestListModel)=>({
        type: $ec98364cc26bdbc1$export$f9ff6948957ba5c5,
        payload: requestListModel
    });
const $ec98364cc26bdbc1$export$a842eadee8280475 = (error)=>({
        type: $ec98364cc26bdbc1$export$f5e5c834c1e2e455,
        payload: {
            error: error
        }
    });
const $ec98364cc26bdbc1$export$b643261c092a4f6 = ()=>({
        type: $ec98364cc26bdbc1$export$4f7af1d62055a261
    });

});



parcelRegister("ah34q", function(module, exports) {
$parcel$export(module.exports, "reqSlasEpic", () => $0636e2f198035f10$export$426760a75e6f1897);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("Ra0Dc");
var $hIjnn = parcelRequire("hIjnn");

var $c5oCA = parcelRequire("c5oCA");
const $0636e2f198035f10$export$426760a75e6f1897 = (action$)=>{
    return action$.ofType((0, $c5oCA.FETCH_REQ_SLAS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>response.reqSlas !== undefined).map((response)=>(0, $hIjnn.updateReqSlasModelAction)(action.payload.params.key, response.reqSlas)).catch(()=>(0, $8jOUp.Observable).never()));
};

});
parcelRegister("Ra0Dc", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQ_SLAS_MODEL", () => (parcelRequire("hIjnn")).UPDATE_REQ_SLAS_MODEL);
$parcel$export(module.exports, "updateReqSlasModelAction", () => (parcelRequire("hIjnn")).updateReqSlasModelAction);

var $hIjnn = parcelRequire("hIjnn");

});
parcelRegister("hIjnn", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQ_SLAS_MODEL", () => $c5b96ea64ab24b5c$export$14a7b72e42866a9e);
$parcel$export(module.exports, "updateReqSlasModelAction", () => $c5b96ea64ab24b5c$export$75741563899043b4);
const $c5b96ea64ab24b5c$export$14a7b72e42866a9e = 'state.persisted.reqSlas.UPDATE_REQ_SLAS_MODEL';
const $c5b96ea64ab24b5c$export$75741563899043b4 = (requestKey, reqSlas)=>({
        type: $c5b96ea64ab24b5c$export$14a7b72e42866a9e,
        payload: {
            requestKey: requestKey,
            reqSlas: reqSlas
        }
    });

});


parcelRegister("c5oCA", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQ_SLAS_MODEL", () => $1d355869fe3214ee$export$38987f165c420e6c);
$parcel$export(module.exports, "fetchReqSlasModelAction", () => $1d355869fe3214ee$export$15b0feb96f424331);

var $hn5Mq = parcelRequire("hn5Mq");
const $1d355869fe3214ee$export$38987f165c420e6c = 'epic.model.FETCH_REQ_SLAS_MODEL';
const $1d355869fe3214ee$export$15b0feb96f424331 = (0, $hn5Mq.buildModelsActionCreator)($1d355869fe3214ee$export$38987f165c420e6c, 'reqSlas');

});


parcelRegister("eUM4k", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionEpic", () => $7358ce8438b2b353$export$6dca1de129d1f3d9);

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("2m8Do");
var $iLBgj = parcelRequire("iLBgj");

var $fVm9J = parcelRequire("fVm9J");
const $7358ce8438b2b353$export$6dca1de129d1f3d9 = (action$)=>{
    return action$.ofType((0, $iLBgj.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.suggestedRequestTypes).map((response)=>(0, $iLBgj.fetchRequestTypeSuggestionSuccess)(response.suggestedRequestTypes))// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $8jOUp.Observable).never()));
};

});
parcelRegister("2m8Do", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => (parcelRequire("iLBgj")).FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => (parcelRequire("iLBgj")).FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => (parcelRequire("iLBgj")).fetchRequestTypeSuggestionAction);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => (parcelRequire("iLBgj")).fetchRequestTypeSuggestionSuccess);

var $iLBgj = parcelRequire("iLBgj");

});
parcelRegister("iLBgj", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => $dd5517bcd5a6d697$export$19c1cce5df18edab);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => $dd5517bcd5a6d697$export$16165835dcce301e);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => $dd5517bcd5a6d697$export$2eae5c2f108f9b38);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => $dd5517bcd5a6d697$export$677aa00fa9ff8a57);

var $hn5Mq = parcelRequire("hn5Mq");
const $dd5517bcd5a6d697$export$19c1cce5df18edab = 'epic.model.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL';
const $dd5517bcd5a6d697$export$16165835dcce301e = 'state.persisted.request-type-suggestion.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS';
const $dd5517bcd5a6d697$export$2eae5c2f108f9b38 = (0, $hn5Mq.buildModelsActionCreator)($dd5517bcd5a6d697$export$19c1cce5df18edab, 'suggestedRequestTypes');
const $dd5517bcd5a6d697$export$677aa00fa9ff8a57 = (requestTypeSuggestions)=>({
        payload: requestTypeSuggestions,
        type: $dd5517bcd5a6d697$export$16165835dcce301e
    });

});



parcelRegister("7rn1m", function(module, exports) {
$parcel$export(module.exports, "requestsColumnSettingsEpic", () => $942775f3f01eebca$export$3d5be110c2cef28d);

var $8jOUp = parcelRequire("8jOUp");

var $jFO7B = parcelRequire("jFO7B");

var $fVm9J = parcelRequire("fVm9J");
const $942775f3f01eebca$export$3d5be110c2cef28d = (action$)=>{
    return action$.ofType((0, $jFO7B.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.requestsColumnSettings).map((response)=>{
            return (0, $jFO7B.fetchRequestsColumnSettingsSuccess)(response.requestsColumnSettings || []);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $jFO7B.fetchRequestsColumnSettingsFailure)(error));
        }));
};

});
parcelRegister("jFO7B", function(module, exports) {
$parcel$export(module.exports, "CUSTOMIZING_REQUEST_LIST_COLUMN", () => $3042d3f4ad402337$export$71e1a7c3232c719e);
$parcel$export(module.exports, "TOGGLE_COLUMN_RE_ORDER_WIDGET", () => $3042d3f4ad402337$export$839cbba59bbe0238);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_MODEL", () => $3042d3f4ad402337$export$abc90ee82ed578f);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $3042d3f4ad402337$export$47e32c3c3500bef2);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $3042d3f4ad402337$export$10398b8018af3940);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL", () => $3042d3f4ad402337$export$f90917a8f5386b09);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $3042d3f4ad402337$export$e560350e06e586db);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $3042d3f4ad402337$export$79deac20d43b585c);
$parcel$export(module.exports, "RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS", () => $3042d3f4ad402337$export$29dc39ddf284347c);
$parcel$export(module.exports, "REORDER_REQUEST_LIST_COLUMNS", () => $3042d3f4ad402337$export$8d4d9dae0354b673);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL", () => $3042d3f4ad402337$export$ff2ed1ddece23eaa);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS", () => $3042d3f4ad402337$export$70626e2ee8f09144);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE", () => $3042d3f4ad402337$export$3fe3cdc959a8c16a);
$parcel$export(module.exports, "customizingRequestListColumn", () => $3042d3f4ad402337$export$cef6e00d44beb902);
$parcel$export(module.exports, "toggleColumnReOrderWidget", () => $3042d3f4ad402337$export$82755465bec7b53d);
$parcel$export(module.exports, "fetchRequestsColumnSettingsModel", () => $3042d3f4ad402337$export$2ddd8f55c6e79cad);
$parcel$export(module.exports, "fetchRequestsColumnSettingsSuccess", () => $3042d3f4ad402337$export$91fa974aae399c3e);
$parcel$export(module.exports, "fetchRequestsColumnSettingsFailure", () => $3042d3f4ad402337$export$358a9b23c953cceb);
$parcel$export(module.exports, "updateRequestsColumnSettingsModel", () => $3042d3f4ad402337$export$d283121346cbb92e);
$parcel$export(module.exports, "updateRequestsColumnSettingsSuccess", () => $3042d3f4ad402337$export$46519305d1bd5dcc);
$parcel$export(module.exports, "updateRequestsColumnSettingsFailure", () => $3042d3f4ad402337$export$a9e9b393ae51b9eb);
$parcel$export(module.exports, "resetCustomizeRequestsColumnSettings", () => $3042d3f4ad402337$export$b835f37760c00124);
$parcel$export(module.exports, "reOrderRequestListColumns", () => $3042d3f4ad402337$export$7401badd435f0b7c);
$parcel$export(module.exports, "updateOrderedRequestListColumnsModel", () => $3042d3f4ad402337$export$bca82c1325293cdd);
$parcel$export(module.exports, "updateOrderedRequestListColumnsSuccess", () => $3042d3f4ad402337$export$7e3f487fe57e88e3);
$parcel$export(module.exports, "updateOrderedRequestListColumnsFailure", () => $3042d3f4ad402337$export$98a8373db0072493);

var $hn5Mq = parcelRequire("hn5Mq");
const $3042d3f4ad402337$export$71e1a7c3232c719e = 'state.ui.requests.column.settings.CUSTOMIZING_REQUEST_LIST_COLUMN';
const $3042d3f4ad402337$export$839cbba59bbe0238 = 'state.ui.requests.column.settings.TOGGLE_COLUMN_RE_ORDER_WIDGET';
const $3042d3f4ad402337$export$abc90ee82ed578f = 'epic.model.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL';
const $3042d3f4ad402337$export$47e32c3c3500bef2 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $3042d3f4ad402337$export$10398b8018af3940 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $3042d3f4ad402337$export$f90917a8f5386b09 = 'epic.requests-column-settings.UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL';
const $3042d3f4ad402337$export$e560350e06e586db = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $3042d3f4ad402337$export$79deac20d43b585c = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $3042d3f4ad402337$export$29dc39ddf284347c = 'state.ui.requests.column.settings.RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS';
const $3042d3f4ad402337$export$8d4d9dae0354b673 = 'state.ui.requests.column.settings.REORDER_REQUEST_LIST_COLUMNS';
const $3042d3f4ad402337$export$ff2ed1ddece23eaa = 'epic.requests-column-settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL';
const $3042d3f4ad402337$export$70626e2ee8f09144 = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS';
const $3042d3f4ad402337$export$3fe3cdc959a8c16a = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE';
const $3042d3f4ad402337$export$cef6e00d44beb902 = (isCustomizing)=>({
        type: $3042d3f4ad402337$export$71e1a7c3232c719e,
        payload: isCustomizing
    });
const $3042d3f4ad402337$export$82755465bec7b53d = (isReOrdering)=>({
        type: $3042d3f4ad402337$export$839cbba59bbe0238,
        payload: isReOrdering
    });
const $3042d3f4ad402337$export$2ddd8f55c6e79cad = (0, $hn5Mq.buildModelsActionCreator)($3042d3f4ad402337$export$abc90ee82ed578f, 'requestsColumnSettings');
const $3042d3f4ad402337$export$91fa974aae399c3e = (requestsColumnSettingsModel)=>({
        type: $3042d3f4ad402337$export$47e32c3c3500bef2,
        payload: requestsColumnSettingsModel
    });
const $3042d3f4ad402337$export$358a9b23c953cceb = (error)=>({
        type: $3042d3f4ad402337$export$10398b8018af3940,
        payload: {
            error: error
        }
    });
const $3042d3f4ad402337$export$d283121346cbb92e = (requestsColumnSettingsModel, meta)=>({
        meta: meta,
        type: $3042d3f4ad402337$export$f90917a8f5386b09,
        payload: requestsColumnSettingsModel
    });
const $3042d3f4ad402337$export$46519305d1bd5dcc = (requestsColumnSettingsModel)=>({
        type: $3042d3f4ad402337$export$e560350e06e586db,
        payload: requestsColumnSettingsModel
    });
const $3042d3f4ad402337$export$a9e9b393ae51b9eb = (error)=>({
        type: $3042d3f4ad402337$export$79deac20d43b585c,
        payload: {
            error: error
        }
    });
const $3042d3f4ad402337$export$b835f37760c00124 = ()=>({
        type: $3042d3f4ad402337$export$29dc39ddf284347c
    });
const $3042d3f4ad402337$export$7401badd435f0b7c = (newOrder)=>({
        type: $3042d3f4ad402337$export$8d4d9dae0354b673,
        payload: newOrder
    });
const $3042d3f4ad402337$export$bca82c1325293cdd = (newOrder, meta)=>{
    return {
        meta: meta,
        type: $3042d3f4ad402337$export$ff2ed1ddece23eaa,
        payload: newOrder
    };
};
const $3042d3f4ad402337$export$7e3f487fe57e88e3 = (requestsColumnSettings)=>({
        type: $3042d3f4ad402337$export$70626e2ee8f09144,
        payload: requestsColumnSettings
    });
const $3042d3f4ad402337$export$98a8373db0072493 = (error)=>({
        type: $3042d3f4ad402337$export$3fe3cdc959a8c16a,
        payload: {
            error: error
        }
    });

});


parcelRegister("54eLq", function(module, exports) {
$parcel$export(module.exports, "timezonesEpic", () => $8390e8e00a8fca35$export$be7068db419e43b3);
$parcel$export(module.exports, "timezoneRegionsEpic", () => $8390e8e00a8fca35$export$f2ed825e49baebf1);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("ivsTx");
var $jWhmA = parcelRequire("jWhmA");

var $1vXf6 = parcelRequire("1vXf6");
const $8390e8e00a8fca35$export$be7068db419e43b3 = (action$)=>{
    return action$.ofType((0, $jWhmA.FETCH_TIMEZONES_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.timezones).map((response)=>{
            return (0, $jWhmA.fetchTimezonesSuccess)(response.timezones || []);
        }).catch((_)=>{
            return (0, $8jOUp.Observable).of((0, $xb2jO.showErrorFlag)((0, $1vXf6.genericError).title, (0, $1vXf6.genericError).description));
        }));
};
const $8390e8e00a8fca35$export$f2ed825e49baebf1 = (action$)=>{
    return action$.ofType((0, $jWhmA.FETCH_TIMEZONE_REGIONS_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.timezoneRegions).map((response)=>{
            return (0, $jWhmA.fetchTimezoneRegionsSuccess)(response.timezoneRegions || []);
        }).catch((_)=>{
            return (0, $8jOUp.Observable).of((0, $xb2jO.showErrorFlag)((0, $1vXf6.genericError).title, (0, $1vXf6.genericError).description));
        }));
};

});
parcelRegister("ivsTx", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => (parcelRequire("jWhmA")).FETCH_TIMEZONES_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => (parcelRequire("jWhmA")).FETCH_TIMEZONE_REGIONS_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => (parcelRequire("jWhmA")).FETCH_TIMEZONES_SUCCESS);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => (parcelRequire("jWhmA")).FETCH_TIMEZONE_REGIONS_SUCCESS);
$parcel$export(module.exports, "fetchTimezonesModel", () => (parcelRequire("jWhmA")).fetchTimezonesModel);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => (parcelRequire("jWhmA")).fetchTimezoneRegionsModel);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => (parcelRequire("jWhmA")).fetchTimezonesSuccess);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => (parcelRequire("jWhmA")).fetchTimezoneRegionsSuccess);

var $jWhmA = parcelRequire("jWhmA");

});
parcelRegister("jWhmA", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => $9e11647a9bf97111$export$932af27e6d5887a0);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => $9e11647a9bf97111$export$3b699f83ba8d2c06);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => $9e11647a9bf97111$export$6b053ef4439b07a6);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => $9e11647a9bf97111$export$6932839fde3fd591);
$parcel$export(module.exports, "fetchTimezonesModel", () => $9e11647a9bf97111$export$f02c0cf38058cca0);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => $9e11647a9bf97111$export$2ac437e497040cf4);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => $9e11647a9bf97111$export$f577dd22c3538327);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => $9e11647a9bf97111$export$219ccd71bd1012b);

var $hn5Mq = parcelRequire("hn5Mq");
const $9e11647a9bf97111$export$932af27e6d5887a0 = 'epic.model.FETCH_TIMEZONES_MODEL';
const $9e11647a9bf97111$export$3b699f83ba8d2c06 = 'epic.model.FETCH_TIMEZONE_REGIONS_MODEL';
const $9e11647a9bf97111$export$6b053ef4439b07a6 = 'state.persisted.timezone.FETCH_TIMEZONEs_SUCCESS';
const $9e11647a9bf97111$export$6932839fde3fd591 = 'state.persisted.timezone.FETCH_TIMEZONE_REGIONS_SUCCESS';
const $9e11647a9bf97111$export$f02c0cf38058cca0 = (0, $hn5Mq.buildModelsActionCreator)($9e11647a9bf97111$export$932af27e6d5887a0, 'timezones');
const $9e11647a9bf97111$export$2ac437e497040cf4 = (0, $hn5Mq.buildModelsActionCreator)($9e11647a9bf97111$export$3b699f83ba8d2c06, 'timezoneRegions');
const $9e11647a9bf97111$export$f577dd22c3538327 = (timezoneRegions)=>({
        type: $9e11647a9bf97111$export$6932839fde3fd591,
        payload: {
            timezoneRegions: timezoneRegions
        }
    });
const $9e11647a9bf97111$export$219ccd71bd1012b = (timezones)=>({
        type: $9e11647a9bf97111$export$6b053ef4439b07a6,
        payload: {
            timezones: timezones
        }
    });

});



parcelRegister("dSYAK", function(module, exports) {
$parcel$export(module.exports, "uiModificationsEpic", () => $5746e991a7d1a0c6$export$b3e7540861af6314);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("iYz1m");
var $fJgYk = parcelRequire("fJgYk");
const $5746e991a7d1a0c6$export$b3e7540861af6314 = (action$)=>{
    return action$.ofType((0, $fJgYk.FETCH_UI_MODIFICATIONS_MODEL)).mergeMap((action)=>{
        var _action$payload, _action$payload2;
        const portalId = (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.params) === null || _action$payload === void 0 ? void 0 : _action$payload.portalId;
        const requestTypeId = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 || (_action$payload2 = _action$payload2.params) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.requestTypeId;
        // Guard clause: ensure required params are defined
        // If params are missing, don't emit any action (nothing meaningful to store)
        if (portalId === undefined || requestTypeId === undefined) return (0, $8jOUp.Observable).empty();
        return (0, $fVm9J.default)(action.payload).filter((response)=>{
            return !!response.uiModifications;
        }).mergeMap((response)=>{
            const uiModifications = response.uiModifications;
            // Check if the response contains an error object
            if ('error' in uiModifications && uiModifications.error) {
                const error = uiModifications.error;
                return (0, $8jOUp.Observable).of((0, $fJgYk.fetchUiModificationsFailure)(portalId, requestTypeId, {
                    status: 500,
                    errorMessages: [
                        error.message || error.code || 'Unknown error'
                    ]
                }));
            }
            return (0, $8jOUp.Observable).of((0, $fJgYk.fetchUiModificationsSuccess)(portalId, requestTypeId, uiModifications));
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $fJgYk.fetchUiModificationsFailure)(portalId, requestTypeId, error));
        });
    });
};

});
parcelRegister("iYz1m", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => (parcelRequire("fJgYk")).FETCH_UI_MODIFICATIONS_MODEL);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => (parcelRequire("fJgYk")).FETCH_UI_MODIFICATIONS_SUCCESS);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => (parcelRequire("fJgYk")).FETCH_UI_MODIFICATIONS_FAILURE);
$parcel$export(module.exports, "fetchUiModificationsAction", () => (parcelRequire("fJgYk")).fetchUiModificationsAction);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => (parcelRequire("fJgYk")).fetchUiModificationsSuccess);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => (parcelRequire("fJgYk")).fetchUiModificationsFailure);

var $fJgYk = parcelRequire("fJgYk");

});
parcelRegister("fJgYk", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => $85fb8f569ba9bd30$export$8dbb39b6146e28fc);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => $85fb8f569ba9bd30$export$7165d2daf9f7546b);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => $85fb8f569ba9bd30$export$f2bc8b8032fa83f9);
$parcel$export(module.exports, "fetchUiModificationsAction", () => $85fb8f569ba9bd30$export$d5c10586cf66ad48);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => $85fb8f569ba9bd30$export$5811aa4798efe56f);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => $85fb8f569ba9bd30$export$aa1b71ac6d05f568);

var $hn5Mq = parcelRequire("hn5Mq");
const $85fb8f569ba9bd30$export$8dbb39b6146e28fc = 'epic.model.FETCH_UI_MODIFICATIONS_MODEL';
const $85fb8f569ba9bd30$export$7165d2daf9f7546b = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_SUCCESS';
const $85fb8f569ba9bd30$export$f2bc8b8032fa83f9 = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_FAILURE';
const $85fb8f569ba9bd30$export$d5c10586cf66ad48 = (0, $hn5Mq.buildModelsActionCreator)($85fb8f569ba9bd30$export$8dbb39b6146e28fc, 'uiModifications');
const $85fb8f569ba9bd30$export$5811aa4798efe56f = (portalId, requestTypeId, uiModifications)=>({
        type: $85fb8f569ba9bd30$export$7165d2daf9f7546b,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            uiModifications: uiModifications
        }
    });
const $85fb8f569ba9bd30$export$aa1b71ac6d05f568 = (portalId, requestTypeId, error)=>({
        type: $85fb8f569ba9bd30$export$f2bc8b8032fa83f9,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error
        }
    });

});



parcelRegister("jwg9A", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationEpic", () => $2c14450090a283f9$export$a5c82ee4d4a62853);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("9zTvk");
var $wC1sN = parcelRequire("wC1sN");

var $lH75E = parcelRequire("lH75E");
const $2c14450090a283f9$export$a5c82ee4d4a62853 = (action$)=>{
    return action$.ofType((0, $lH75E.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.unsubscribedConfirmation && !!response.unsubscribedConfirmation.requestKey).map((response)=>{
            return (0, $wC1sN.fetchUnsubscribedConfirmationSuccess)(response.unsubscribedConfirmation);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $wC1sN.fetchUnsubscribedConfirmationFailure)(error));
        }));
};

});
parcelRegister("9zTvk", function(module, exports) {
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => (parcelRequire("wC1sN")).fetchUnsubscribedConfirmationSuccess);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => (parcelRequire("wC1sN")).fetchUnsubscribedConfirmationFailure);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => (parcelRequire("wC1sN")).FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => (parcelRequire("wC1sN")).FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS);

var $wC1sN = parcelRequire("wC1sN");

});
parcelRegister("wC1sN", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => $de717e64638d6c71$export$f72ddca71405b95d);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => $de717e64638d6c71$export$ebaa1597e87c25cb);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => $de717e64638d6c71$export$c1bfe5b0bc39b67c);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => $de717e64638d6c71$export$97f97477d437893);
const $de717e64638d6c71$export$f72ddca71405b95d = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS';
const $de717e64638d6c71$export$ebaa1597e87c25cb = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE';
const $de717e64638d6c71$export$c1bfe5b0bc39b67c = (unsubscribedConfirmationModel)=>({
        payload: unsubscribedConfirmationModel,
        type: $de717e64638d6c71$export$f72ddca71405b95d
    });
const $de717e64638d6c71$export$97f97477d437893 = (error)=>({
        type: $de717e64638d6c71$export$ebaa1597e87c25cb,
        payload: {
            error: error
        }
    });

});


parcelRegister("lH75E", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL", () => $f78c98403aa45465$export$2e46ab911cbec5e7);
$parcel$export(module.exports, "fetchUnsubscribedConfirmation", () => $f78c98403aa45465$export$4b67c7752a799aa6);

var $hn5Mq = parcelRequire("hn5Mq");
const $f78c98403aa45465$export$2e46ab911cbec5e7 = 'epic.model.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL';
const $f78c98403aa45465$export$4b67c7752a799aa6 = (0, $hn5Mq.buildModelsActionCreator)($f78c98403aa45465$export$2e46ab911cbec5e7, 'unsubscribedConfirmation');

});


parcelRegister("k7C1J", function(module, exports) {
$parcel$export(module.exports, "visitPortalEpic", () => $809265e976f49de7$export$b0dd3b8f13c4a9ce);

var $8jOUp = parcelRequire("8jOUp");

var $fVm9J = parcelRequire("fVm9J");
parcelRequire("xOZC4");
var $jN84E = parcelRequire("jN84E");
const $809265e976f49de7$export$b0dd3b8f13c4a9ce = (action$)=>{
    return action$.ofType((0, $jN84E.FETCH_VISIT_PORTAL_MODEL)).mergeMap((action)=>(0, $fVm9J.default)(action.payload).filter((response)=>!!response.visitPortal && !!response.visitPortal.email).map((response)=>{
            return (0, $jN84E.fetchVisitPortalSuccess)(response.visitPortal);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $jN84E.fetchVisitPortalFailure)(error));
        }));
};

});


parcelRegister("8mW3b", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncementsEpic", () => $83671ce54f091f2d$export$e4577247bf7a5bb1);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $6zQBG = parcelRequire("6zQBG");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");

var $jBiia = parcelRequire("jBiia");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");

var $G6QpT = parcelRequire("G6QpT");
const $83671ce54f091f2d$export$e4577247bf7a5bb1 = (action$)=>{
    return action$.ofType((0, $jeW3I.UPDATE_PORTAL_ANNOUNCEMENT_MODEL)).mergeMap((action)=>{
        const { meta: meta, portalId: portalId } = action;
        return (0, $6zQBG.updatePortalAnnouncements)(action.payload, portalId).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $jeW3I.updatePortalAnnouncementSuccess)(response)));
        }).catch((error)=>{
            if ((0, $h92tT.isNetworkOrClientErrorCode)(error.status)) // Filter out client errors
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            else {
                if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $jBiia.legacySendEvent)((0, $G6QpT.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.failure({
                    metadata: {
                        error: (0, $jBiia.getErrorData)(error)
                    }
                });
            }
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $jeW3I.updatePortalAnnouncementFailure)(error)), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("6zQBG", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncements", () => $d4dacb0116d8e94a$export$9e961f2770667246);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $d4dacb0116d8e94a$export$9e961f2770667246 = (payload, portalId, context = (0, $eDcdn.contextPath))=>{
    const portalAnnouncementUpdateURI = `${context}/rest/servicedesk/1/servicedesk-data/announcement/portal/${portalId}`;
    const contentType = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(portalAnnouncementUpdateURI, payload, contentType)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $lJ0l5.Observable).throw(e));
};

});


parcelRegister("5iLP3", function(module, exports) {
$parcel$export(module.exports, "changeRequestSubscriptionEpic", () => $d0d37fcc1fd7f79c$export$43fea900952d51e2);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $aiwIi = parcelRequire("aiwIi");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");
const $d0d37fcc1fd7f79c$export$43fea900952d51e2 = (action$)=>{
    return action$.ofType((0, $gXSFL.CHANGE_SUBSCRIPTION)).mergeMap((changeSubscriptionAction)=>{
        const { shouldSubscribe: shouldSubscribe, requestId: requestId, requestKey: requestKey } = changeSubscriptionAction.payload;
        const restCall = shouldSubscribe ? (0, $aiwIi.subscribe) : (0, $aiwIi.unsubscribe);
        return restCall(requestId).map(()=>{
            return (0, $gXSFL.changeSubscriptionSuccess)(requestKey, shouldSubscribe);
        }).catch((error)=>{
            return (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("aiwIi", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $03afab27a670e35f$export$ec068583843480e7);
$parcel$export(module.exports, "unsubscribe", () => $03afab27a670e35f$export$f500693cef883ffd);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $03afab27a670e35f$export$ec068583843480e7 = (requestId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $llRGw.put)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};
const $03afab27a670e35f$export$f500693cef883ffd = (requestId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $llRGw.doDelete)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};

});


parcelRegister("8M3pr", function(module, exports) {
$parcel$export(module.exports, "createCommentEpic", () => $44117dade5b0a86c$export$3d130ce773bd2648);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $bLSsJ = parcelRequire("bLSsJ");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");

var $inHba = parcelRequire("inHba");
const $44117dade5b0a86c$export$3d130ce773bd2648 = (action$)=>{
    return action$.ofType((0, $gXSFL.CREATE_COMMENT)).mergeMap((createCommentAction)=>{
        const payload = createCommentAction.payload;
        return (0, $bLSsJ.createComment)(payload.requestId, payload.comment, payload.fileIds, payload.xsrftoken).flatMap((createCommentResponse)=>{
            const { meta: meta, numberOfMentionedUsers: numberOfMentionedUsers } = payload;
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) {
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // oxlint-disable-next-line no-shadow
                meta === null || meta === void 0 || meta.analyticsSuccessEvent.update((payload)=>({
                        ...payload,
                        count: numberOfMentionedUsers || 0
                    }));
                (0, $jBiia.legacySendEvent)(meta === null || meta === void 0 ? void 0 : meta.analyticsSuccessEvent);
            }
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gXSFL.createCommentSuccess)(payload.requestKey, createCommentResponse)), (0, $8jOUp.Observable).of((0, $gXSFL.getReadCredentials)(payload.portalId, payload.requestId, payload.requestKey)));
        }).catch((error)=>{
            const meta = payload.meta;
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent);
            const isShowErrorFlag = payload.numberOfMentionedUsers && payload.numberOfMentionedUsers > 0 && !(0, $h92tT.isNetworkErrorCode)(error.status);
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gXSFL.createCommentFailure)()), (0, $8jOUp.Observable).of(isShowErrorFlag ? (0, $xb2jO.showErrorFlag)((0, $inHba.default).commentCreateWithMentionsFailedTitle, (0, $inHba.default).commentCreateWithMentionsFailedDescription) : (0, $xb2jO.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("bLSsJ", function(module, exports) {
$parcel$export(module.exports, "createComment", () => $925ec601143a53b4$export$2a15b079e3f46654);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");
const $925ec601143a53b4$export$2a15b079e3f46654 = (issueId, comment, fileIds, xsrfToken, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/customer/comment`;
    const body = {
        issueId: issueId,
        comment: comment,
        fileIds: fileIds,
        xsrfToken: xsrfToken
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).catch((e)=>{
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("inHba", function(module, exports) {
$parcel$export(module.exports, "default", () => $9989b672c8cafe82$export$2e2bcd8739ae039);
/* Note: these messages are not final */ 
var $f0Pt4 = parcelRequire("f0Pt4");
var $9989b672c8cafe82$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    commentCreateWithMentionsFailedTitle: {
        defaultMessage: "We couldn\u2019t add this comment",
        description: 'Comment containing user mentions failed to create title',
        id: 'sd.comment.create.with.mentions.failed.title'
    },
    commentCreateWithMentionsFailedDescription: {
        defaultMessage: 'Try adding it again in a few minutes. ',
        description: 'Comment containing user mentions failed to create description',
        id: 'sd.comment.create.with.mentions.failed.description'
    }
});

});


parcelRegister("gJFTm", function(module, exports) {
$parcel$export(module.exports, "decideApprovalEpic", () => $35e048a005c5b14b$export$d61d906dee97954f);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $lFpPv = parcelRequire("lFpPv");

var $xb2jO = parcelRequire("xb2jO");

var $7YVZ6 = parcelRequire("7YVZ6");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $1P2Tw = parcelRequire("1P2Tw");
const $35e048a005c5b14b$var$isClientSideError = (error)=>error.status >= 400 && error.status < 500;
const $35e048a005c5b14b$export$d61d906dee97954f = (action$)=>{
    return action$.ofType((0, $gXSFL.DECIDE_APPROVAL)).mergeMap((decideApprovalAction)=>{
        const payload = decideApprovalAction.payload;
        const restCall = payload.approve ? (0, $7YVZ6.approve)(payload.approvalId) : (0, $7YVZ6.decline)(payload.approvalId);
        return restCall.map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'recorded'
            });
            if (successEvent) {
                successEvent.context.push({
                    componentName: 'approverDecision'
                });
                (0, $jBiia.legacySendEvent)(successEvent);
            }
            return (0, $gXSFL.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        })// @ts-ignore
        .catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                statusCode: $35e048a005c5b14b$var$isClientSideError(error) ? '4XX' : '5XX'
            });
            if (failEvent) {
                failEvent.context.push({
                    componentName: 'portalRequestDetailsScreen.answerApprovalService'
                });
                (0, $jBiia.legacySendEvent)(failEvent);
            }
            if (error.status === 409) return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gXSFL.decideApprovalFailure)()), (0, $8jOUp.Observable).of((0, $gXSFL.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            })), (0, $8jOUp.Observable).of((0, $xb2jO.showErrorFlag)((0, $1P2Tw.default).conflictErrorTitle, (0, $lFpPv.isItsmIssueRenamingEnabled)() ? (0, $1P2Tw.default).conflictErrorDescriptionIssueTermRefresh : (0, $1P2Tw.default).conflictErrorDescription)));
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gXSFL.decideApprovalFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("7YVZ6", function(module, exports) {
$parcel$export(module.exports, "approve", () => $19cd9d59c57f4d58$export$5ba7c78c9d5e2122);
$parcel$export(module.exports, "decline", () => $19cd9d59c57f4d58$export$ff9b5abb0defe452);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $19cd9d59c57f4d58$export$5ba7c78c9d5e2122 = (approvalId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/approve`;
    return (0, $llRGw.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};
const $19cd9d59c57f4d58$export$ff9b5abb0defe452 = (approvalId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/reject`;
    return (0, $llRGw.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};

});

parcelRegister("1P2Tw", function(module, exports) {
$parcel$export(module.exports, "default", () => $86620fd805357f19$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $86620fd805357f19$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    conflictErrorTitle: {
        defaultMessage: 'Error',
        description: 'Conflict error when user clicking a stale approval panel decision button.',
        id: 'sd.stale.approval.panel.conflict.title'
    },
    conflictErrorDescription: {
        defaultMessage: 'An approval response has already been submitted for this issue.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description'
    },
    conflictErrorDescriptionIssueTermRefresh: {
        defaultMessage: 'An approval response has already been submitted for this work item.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description-issue-term-refresh'
    }
});

});


parcelRegister("byiOV", function(module, exports) {
$parcel$export(module.exports, "getMediaReadCredentialsEpic", () => $e3d7f2658f355ed3$export$248d895b14907a3);

var $8jOUp = parcelRequire("8jOUp");

var $eNRmj = parcelRequire("eNRmj");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");
const $e3d7f2658f355ed3$export$248d895b14907a3 = (action$)=>{
    return action$.ofType((0, $gXSFL.GET_MEDIA_READ_CREDENTIALS)).mergeMap((getReadCredentialsAction)=>{
        const payload = getReadCredentialsAction.payload;
        return (0, $eNRmj.getReadCredentialsForRequest)(payload.portalId, payload.requestId).map((getReadCredentialsResponse)=>{
            return (0, $gXSFL.getReadCredentialsSuccess)(payload.requestKey, getReadCredentialsResponse);
        }).catch((_)=>{
            return (0, $8jOUp.Observable).of((0, $gXSFL.getReadCredentialsFailure)());
        });
    });
};

});

parcelRegister("ivz24", function(module, exports) {
$parcel$export(module.exports, "removeOrganisationEpic", () => $7e1a4fcbf942e849$export$b62b13475aa4d5e);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $7jMVB = parcelRequire("7jMVB");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $4B8GV = parcelRequire("4B8GV");
const $7e1a4fcbf942e849$export$b62b13475aa4d5e = (action$)=>{
    return action$.ofType((0, $gXSFL.REMOVE_ORGANISATION)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, organisationId: organisationId } = removeParticipantAction.payload;
        return (0, $7jMVB.removeOrganisation)(requestKey, organisationId).map(()=>{
            return (0, $gXSFL.removeOrganisationSuccess)(requestKey, organisationId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $8jOUp.Observable).of(isPermissionDenied ? (0, $xb2jO.showErrorFlag)((0, $4B8GV.default).permissionDeniedErrorTitle, (0, $4B8GV.default).permissionDeniedErrorDescription) : (0, $xb2jO.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("7jMVB", function(module, exports) {
$parcel$export(module.exports, "removeUsingAccountId", () => $b970b2c05d599de9$export$d06c11dbdb4f724e);
$parcel$export(module.exports, "removeOrganisation", () => $b970b2c05d599de9$export$66d4278db03b2954);
$parcel$export(module.exports, "search", () => $b970b2c05d599de9$export$d76128d007d19019);
$parcel$export(module.exports, "addParticipants", () => $b970b2c05d599de9$export$600fe12d720e6ff9);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fvUqa = parcelRequire("fvUqa");

var $eDcdn = parcelRequire("eDcdn");
const $b970b2c05d599de9$export$d06c11dbdb4f724e = (requestKey, accountId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeParticipant`;
    const body = {
        accountId: accountId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $8jOUp.Observable).throw(e));
};
const $b970b2c05d599de9$export$66d4278db03b2954 = (requestKey, organisationId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeOrganisation`;
    const body = {
        organisationId: organisationId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $8jOUp.Observable).throw(e));
};
const $b970b2c05d599de9$export$d76128d007d19019 = (requestKey, query = '', context = (0, $eDcdn.contextPath))=>{
    const queryString = $fvUqa.stringify({
        q: query
    });
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/search?${queryString}`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response).catch((e)=>Promise.reject(e));
};
const $b970b2c05d599de9$export$600fe12d720e6ff9 = (requestKey, accountIds, organizationIds, emailAddresses, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/add`;
    const body = {
        accountIds: accountIds,
        organisationIds: organizationIds,
        emails: emailAddresses
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.put)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("4B8GV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ab97520af103302$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $7ab97520af103302$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.organization.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.organization.permission.denied.description'
    }
});

});


parcelRegister("aQzC7", function(module, exports) {
$parcel$export(module.exports, "removeParticipantEpic", () => $05ec5e1df68f2a93$export$3f20d6b824d24e4c);

var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $7jMVB = parcelRequire("7jMVB");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $anesL = parcelRequire("anesL");
const $05ec5e1df68f2a93$export$3f20d6b824d24e4c = (action$)=>{
    return action$.ofType((0, $gXSFL.REMOVE_PARTICIPANT)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, accountId: accountId } = removeParticipantAction.payload;
        return (0, $7jMVB.removeUsingAccountId)(requestKey, accountId).map(()=>{
            return (0, $gXSFL.removeParticipantSuccess)(requestKey, accountId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $8jOUp.Observable).of(isPermissionDenied ? (0, $xb2jO.showErrorFlag)((0, $anesL.default).permissionDeniedErrorTitle, (0, $anesL.default).permissionDeniedErrorDescription) : (0, $xb2jO.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("anesL", function(module, exports) {
$parcel$export(module.exports, "default", () => $274c181f3fbb315a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $274c181f3fbb315a$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.participants.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.participants.permission.denied.description'
    }
});

});


parcelRegister("b7O7r", function(module, exports) {
$parcel$export(module.exports, "shareRequestEpic", () => $f04cb93ce0e694de$export$d11c340ce54e3cbb);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $7jMVB = parcelRequire("7jMVB");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $jN006 = parcelRequire("jN006");
const $f04cb93ce0e694de$export$d11c340ce54e3cbb = (action$)=>action$.ofType((0, $gXSFL.SHARE_REQUEST)).mergeMap((shareRequestAction)=>{
        const { requestKey: requestKey, organizations: organizations, emailAddresses: emailAddresses, accountIds: accountIds, isUserMentioned: isUserMentioned, mentionedUserName: mentionedUserName, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation } = shareRequestAction.payload;
        return (0, $7jMVB.addParticipants)(requestKey, accountIds, organizations, emailAddresses).flatMap((response)=>{
            if (isUserMentioned) {
                const messageTitle = mentionedUserName ? (0, $jN006.default).requestSharedWithSingleMentionedUserSuccessTitle : (0, $jN006.default).requestSharedWithMentionedUsersSuccessTitle;
                const messageDescription = mentionedUserName ? (0, $jN006.default).requestSharedWithSingleMentionedUserSuccessDescription : (0, $jN006.default).requestSharedWithMentionedUsersSuccessDescription;
                const descriptionValues = mentionedUserName ? {
                    userName: mentionedUserName
                } : undefined;
                return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $gXSFL.addParticipantsSuccess)(requestKey, response, userMentionedDuringRequestCreation)), (0, $8jOUp.Observable).of((0, $xb2jO.showSuccessFlag)(messageTitle, undefined, messageDescription, undefined, descriptionValues)));
            }
            return (0, $8jOUp.Observable).of((0, $gXSFL.addParticipantsSuccess)(requestKey, response));
        }).catch((error)=>{
            const isShowErrorFlag = isUserMentioned;
            const messageTitle = mentionedUserName ? (0, $jN006.default).requestSharedWithSingleMentionedUserFailureTitle : (0, $jN006.default).requestSharedWithMentionedUsersFailureTitle;
            const messageDescription = mentionedUserName ? (0, $jN006.default).requestSharedWithSingleMentionedUserFailureDescription : (0, $jN006.default).requestSharedWithMentionedUsersFailureDescription;
            const descriptionValues = mentionedUserName ? {
                userName: mentionedUserName
            } : undefined;
            return (0, $8jOUp.Observable).of(isShowErrorFlag ? (0, $xb2jO.showErrorFlag)(messageTitle, messageDescription, undefined, undefined, descriptionValues) : (0, $xb2jO.handleAjaxError)(error));
        });
    });

});
parcelRegister("jN006", function(module, exports) {
$parcel$export(module.exports, "default", () => $e50ed5ed9efc0abc$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e50ed5ed9efc0abc$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    requestSharedWithSingleMentionedUserSuccessTitle: {
        defaultMessage: 'New request participant added',
        description: 'request shared with the single user mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.title'
    },
    requestSharedWithSingleMentionedUserSuccessDescription: {
        defaultMessage: '{userName} has been added as a request participant to this request.',
        description: 'request shared with the single user mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.description'
    },
    requestSharedWithMentionedUsersSuccessTitle: {
        defaultMessage: 'New request participants added',
        description: 'request shared with users mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.title'
    },
    requestSharedWithMentionedUsersSuccessDescription: {
        defaultMessage: 'The users you mentioned have been added as request participants to this request.',
        description: 'request shared with users mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.description'
    },
    requestSharedWithSingleMentionedUserFailureTitle: {
        defaultMessage: "We couldn\u2019t add this request participant",
        description: 'requests sharing with single user failed title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.title'
    },
    requestSharedWithSingleMentionedUserFailureDescription: {
        defaultMessage: "{userName} couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing with single user failed description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.description'
    },
    requestSharedWithMentionedUsersFailureTitle: {
        defaultMessage: "We couldn\u2019t add these request participants",
        description: 'Title shown when sharing request with multiple mentioned users fails',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.title'
    },
    requestSharedWithMentionedUsersFailureDescription: {
        defaultMessage: "The users you mentioned couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing failed description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.description'
    }
});

});


parcelRegister("6OFyt", function(module, exports) {
$parcel$export(module.exports, "transitionRequestEpic", () => $5e95b3c89234e3f9$export$2b9c3ffd3e776468);

var $8jOUp = parcelRequire("8jOUp");

var $fIBaR = parcelRequire("fIBaR");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $1vXf6 = parcelRequire("1vXf6");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
const $5e95b3c89234e3f9$export$2b9c3ffd3e776468 = (action$, store)=>{
    return action$.ofType((0, $gXSFL.TRANSITION_REQUEST)).mergeMap((transitionAction)=>{
        const payload = transitionAction.payload;
        return (0, $fIBaR.transition)(payload.requestKey, payload.transitionId, payload.comment).map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'customerTransition',
                projectId: (0, $iWhHo.getProjectId)(store.getState(), payload.portalId)
            });
            successEvent && (0, $jBiia.legacySendEvent)(successEvent);
            return (0, $gXSFL.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        }).catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'customerTransition'
            });
            failEvent && (0, $jBiia.legacySendEvent)(failEvent);
            return (0, $8jOUp.Observable).of((0, $gXSFL.transitionRequestFailure)((0, $1vXf6.getJiraErrorOrDefault)(error)));
        });
    });
};

});
parcelRegister("fIBaR", function(module, exports) {
$parcel$export(module.exports, "transition", () => $eb54ad8c3bad7410$export$66bb15e2994e6a26);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $eb54ad8c3bad7410$export$66bb15e2994e6a26 = (issueKey, transitionId, comment, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/requests/transition`;
    const body = {
        issueKey: issueKey,
        transitionId: transitionId,
        comment: comment
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.put)(uri, body, headers);
};

});

parcelRegister("ik9zp", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => (parcelRequire("iWhHo")).getPortalAnalyticAttributes);
$parcel$export(module.exports, "getName", () => (parcelRequire("iWhHo")).getName);
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("iWhHo")).getLogoUrl);
$parcel$export(module.exports, "getDescription", () => (parcelRequire("iWhHo")).getDescription);
$parcel$export(module.exports, "getPortalLocale", () => (parcelRequire("iWhHo")).getPortalLocale);
$parcel$export(module.exports, "getPortalI18nTranslations", () => (parcelRequire("iWhHo")).getPortalI18nTranslations);
$parcel$export(module.exports, "getCategories", () => (parcelRequire("iWhHo")).getCategories);
$parcel$export(module.exports, "getCategory", () => (parcelRequire("iWhHo")).getCategory);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("iWhHo")).getIsKbEnabled);
$parcel$export(module.exports, "getIsKbServer", () => (parcelRequire("iWhHo")).getIsKbServer);
$parcel$export(module.exports, "getIsPortalLoaded", () => (parcelRequire("iWhHo")).getIsPortalLoaded);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("iWhHo")).getProjectId);
$parcel$export(module.exports, "getProjectKey", () => (parcelRequire("iWhHo")).getProjectKey);
$parcel$export(module.exports, "getPortalRequestGroups", () => (parcelRequire("iWhHo")).getPortalRequestGroups);
$parcel$export(module.exports, "getPortalRequestTypes", () => (parcelRequire("iWhHo")).getPortalRequestTypes);
$parcel$export(module.exports, "getPortalRequestType", () => (parcelRequire("iWhHo")).getPortalRequestType);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => (parcelRequire("iWhHo")).getPortalRequestTypesForRequestGroup);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => (parcelRequire("iWhHo")).getPortalRequestTypesNotInRequestGroup);
$parcel$export(module.exports, "getPortal", () => (parcelRequire("iWhHo")).getPortal);
$parcel$export(module.exports, "getPortalOrError", () => (parcelRequire("iWhHo")).getPortalOrError);
$parcel$export(module.exports, "getPortalAnnouncement", () => (parcelRequire("iWhHo")).getPortalAnnouncement);
$parcel$export(module.exports, "getCanAdministerProject", () => (parcelRequire("iWhHo")).getCanAdministerProject);
$parcel$export(module.exports, "getIsProjectSimplified", () => (parcelRequire("iWhHo")).getIsProjectSimplified);
$parcel$export(module.exports, "getPortalLink", () => (parcelRequire("iWhHo")).getPortalLink);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => (parcelRequire("iWhHo")).getRequestGroupsForRequestType);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => (parcelRequire("iWhHo")).getIsRequestTypeBelongsToGroup);
$parcel$export(module.exports, "canCreateRequest", () => (parcelRequire("iWhHo")).canCreateRequest);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => (parcelRequire("iWhHo")).getPortalAnnouncementPersisted);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => (parcelRequire("iWhHo")).getPortalAnnouncementsUI);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("iWhHo")).isSaveInProgress);
$parcel$export(module.exports, "isSaveFailed", () => (parcelRequire("iWhHo")).isSaveFailed);
$parcel$export(module.exports, "getServiceDeskId", () => (parcelRequire("iWhHo")).getServiceDeskId);
$parcel$export(module.exports, "getKbSuggestions", () => (parcelRequire("iWhHo")).getKbSuggestions);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => (parcelRequire("iWhHo")).getKbLinkDomainURLs);
$parcel$export(module.exports, "getMediaApiUploadToken", () => (parcelRequire("iWhHo")).getMediaApiUploadToken);
$parcel$export(module.exports, "getMediaApiError", () => (parcelRequire("iWhHo")).getMediaApiError);

var $iWhHo = parcelRequire("iWhHo");

});
parcelRegister("iWhHo", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => $15fbda2148a35411$export$c60f1a869d2c2c74);
$parcel$export(module.exports, "getPortal", () => $15fbda2148a35411$export$e16cb606b6ef4a60);
$parcel$export(module.exports, "getName", () => $15fbda2148a35411$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getLogoUrl", () => $15fbda2148a35411$export$976f80239b15365);
$parcel$export(module.exports, "getDescription", () => $15fbda2148a35411$export$67580b1c13935958);
$parcel$export(module.exports, "getPortalLocale", () => $15fbda2148a35411$export$7bcd1890b058c84b);
$parcel$export(module.exports, "getPortalI18nTranslations", () => $15fbda2148a35411$export$c02a81e0fafa0a40);
$parcel$export(module.exports, "getIsPortalLoaded", () => $15fbda2148a35411$export$bf5e3f9152d94e3b);
$parcel$export(module.exports, "getPortalRequestGroups", () => $15fbda2148a35411$export$78d9d04100263c2d);
$parcel$export(module.exports, "getPortalRequestTypes", () => $15fbda2148a35411$export$64da133fb6380f70);
$parcel$export(module.exports, "getPortalRequestType", () => $15fbda2148a35411$export$d1bf58a210f1b84e);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => $15fbda2148a35411$export$4965f91d890eed3b);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => $15fbda2148a35411$export$5a1e358eca2c7b0a);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => $15fbda2148a35411$export$2f20ba1ff04c787e);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => $15fbda2148a35411$export$3e60634ba4e73f5f);
$parcel$export(module.exports, "getProjectKey", () => $15fbda2148a35411$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $15fbda2148a35411$export$89040d072f281f85);
$parcel$export(module.exports, "getPortalOrError", () => $15fbda2148a35411$export$aa66ead34639a340);
$parcel$export(module.exports, "getIsKbEnabled", () => $15fbda2148a35411$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getIsKbServer", () => $15fbda2148a35411$export$62e14b755e26ac1e);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => $15fbda2148a35411$export$8f367c2862b9eaf4);
$parcel$export(module.exports, "getPortalAnnouncement", () => $15fbda2148a35411$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $15fbda2148a35411$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $15fbda2148a35411$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $15fbda2148a35411$export$7a0f33e8df10bd94);
$parcel$export(module.exports, "getCategory", () => $15fbda2148a35411$export$410364bbb673ddbc);
$parcel$export(module.exports, "getPortalLink", () => $15fbda2148a35411$export$ed7921430af91c7c);
$parcel$export(module.exports, "canCreateRequest", () => $15fbda2148a35411$export$f609845398295f39);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => $15fbda2148a35411$export$65fec43abdb7eb83);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => $15fbda2148a35411$export$bf2c3b9a218e4a01);
$parcel$export(module.exports, "isSaveInProgress", () => $15fbda2148a35411$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isSaveFailed", () => $15fbda2148a35411$export$3620a86b3ad94622);
$parcel$export(module.exports, "getServiceDeskId", () => $15fbda2148a35411$export$f65464f8f75f45bc);
$parcel$export(module.exports, "getKbSuggestions", () => $15fbda2148a35411$export$e8626520ddba5456);
$parcel$export(module.exports, "getMediaApiUploadToken", () => $15fbda2148a35411$export$b87c6f04552c18ef);
$parcel$export(module.exports, "getMediaApiError", () => $15fbda2148a35411$export$ddddbd1696231d6a);

var $4ZMmh = parcelRequire("4ZMmh");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
const $15fbda2148a35411$export$c60f1a869d2c2c74 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.analyticAttributes;
};
const $15fbda2148a35411$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.name;
};
const $15fbda2148a35411$export$976f80239b15365 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.logoUrl;
};
const $15fbda2148a35411$export$67580b1c13935958 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.description;
};
const $15fbda2148a35411$export$7bcd1890b058c84b = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.locale;
};
const $15fbda2148a35411$export$c02a81e0fafa0a40 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.i18nTranslations;
};
const $15fbda2148a35411$export$bf5e3f9152d94e3b = (state, portalId)=>!!$15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
const $15fbda2148a35411$export$78d9d04100263c2d = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqGroups : [];
};
const $15fbda2148a35411$export$8a8ef1c92929d685 = (state, portalId, requestGroupId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    if (!portal) return undefined;
    const requestGroupWithId = portal.reqGroups.find((reqGroup)=>reqGroup.id === requestGroupId);
    return requestGroupWithId;
};
const $15fbda2148a35411$export$64da133fb6380f70 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqTypes : [];
};
const $15fbda2148a35411$export$d1bf58a210f1b84e = (state, portalId, requestTypeId)=>{
    if ((0, $4ZMmh.isNil)(portalId) || (0, $4ZMmh.isNil)(requestTypeId)) return undefined;
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.reqTypes.find((reqType)=>reqType.id === String(requestTypeId));
};
const $15fbda2148a35411$export$4965f91d890eed3b = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $15fbda2148a35411$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $15fbda2148a35411$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return [];
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesInGroup = reqTypesIdsInSelectedGroup// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((id)=>allRequestTypesInPortal.find((rt)=>rt.id === id)).filter(Boolean);
    return requestTypesInGroup;
};
const $15fbda2148a35411$export$5a1e358eca2c7b0a = ({ state: state, portalId: portalId, requestTypeId: requestTypeId })=>{
    const requestGroups = $15fbda2148a35411$export$78d9d04100263c2d(state, portalId);
    return requestGroups.filter((group)=>group.reqTypes.includes(String(requestTypeId)));
};
const $15fbda2148a35411$export$2f20ba1ff04c787e = (state, portalId, requestGroupId, requestTypeId)=>{
    const requestGroups = $15fbda2148a35411$export$5a1e358eca2c7b0a({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return (requestGroups || []).filter((requestGroup)=>requestGroup.id === requestGroupId).length > 0;
};
const $15fbda2148a35411$export$3e60634ba4e73f5f = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $15fbda2148a35411$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $15fbda2148a35411$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return allRequestTypesInPortal;
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesNotInSelectedGroup = allRequestTypesInPortal.filter(({ id: idInPortal })=>// only include request types that are not in the specified group
        !reqTypesIdsInSelectedGroup.some((idInGroup)=>idInGroup === idInPortal));
    return requestTypesNotInSelectedGroup;
};
const $15fbda2148a35411$export$667f2a0f99c75faa = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && portal.projectKey && portal.projectKey.toUpperCase();
};
const $15fbda2148a35411$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $4ZMmh.isNil)(portalId)) return undefined;
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $15fbda2148a35411$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $4ZMmh.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $15fbda2148a35411$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $15fbda2148a35411$export$d56e4bff0fec91ad = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && !!portal.knowledgeBase;
};
const $15fbda2148a35411$export$62e14b755e26ac1e = (state, portalId)=>{
    var _portal$knowledgeBase;
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return Boolean(portal === null || portal === void 0 || (_portal$knowledgeBase = portal.knowledgeBase) === null || _portal$knowledgeBase === void 0 || (_portal$knowledgeBase = _portal$knowledgeBase.kbLink) === null || _portal$knowledgeBase === void 0 ? void 0 : _portal$knowledgeBase.isServer);
};
const $15fbda2148a35411$export$8f367c2862b9eaf4 = (state, portalId)=>{
    var _portal$knowledgeBase2;
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return (portal === null || portal === void 0 || (_portal$knowledgeBase2 = portal.knowledgeBase) === null || _portal$knowledgeBase2 === void 0 ? void 0 : _portal$knowledgeBase2.kbLinkDomainURLs) || [];
};
const $15fbda2148a35411$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $15fbda2148a35411$export$b88ee522e5c6bc90 = (state, portalId)=>{
    const portalAnnouncement = $15fbda2148a35411$export$78e1a2ab89c0908b(state, portalId);
    return !!portalAnnouncement && portalAnnouncement.canEditAnnouncement;
};
const $15fbda2148a35411$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $15fbda2148a35411$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement && portalAnnouncement.canAdministerProject;
};
const $15fbda2148a35411$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.isProjectSimplified : undefined;
};
const $15fbda2148a35411$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};
const $15fbda2148a35411$export$410364bbb673ddbc = (state, portalId, categoryId)=>{
    if (!categoryId || !portalId) return undefined;
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        if (Array.isArray(categoryOrError)) return categoryOrError.find((category)=>category.id === categoryId);
        return categoryOrError;
    }
    return undefined;
};
const $15fbda2148a35411$export$ed7921430af91c7c = (state, portalId)=>{
    const requestGroups = $15fbda2148a35411$export$78d9d04100263c2d(state, portalId);
    // If the user has exactly 1 request group and request type, we link them directly to that form.
    // Otherwise we direct them to the request groups
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    let portalLink = `/portal/${portalId}/group/-1`;
    if (requestGroups.length === 1) {
        const [requestGroup] = requestGroups;
        if (requestGroup.reqTypes.length === 1) {
            const [requestTypeId] = requestGroup.reqTypes;
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            portalLink = `/portal/${portalId}/group/${requestGroup.id}/create/${requestTypeId}`;
        }
    }
    return portalLink;
};
const $15fbda2148a35411$export$f609845398295f39 = (state, portalId)=>{
    if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType)) return false;
    return Object.keys($15fbda2148a35411$export$78d9d04100263c2d(state, Number(portalId))).length > 0;
};
const $15fbda2148a35411$export$65fec43abdb7eb83 = (state, payload)=>{
    const portalAnnouncement = $15fbda2148a35411$export$78e1a2ab89c0908b(state, payload === null || payload === void 0 ? void 0 : payload.portalId);
    return portalAnnouncement ? portalAnnouncement : undefined;
};
const $15fbda2148a35411$export$bf2c3b9a218e4a01 = (state)=>state.ui.portals.portalAnnouncementsResponse;
const $15fbda2148a35411$export$2b75ac2de7a23db1 = (state)=>state.ui.portals.isSaveInProgress;
const $15fbda2148a35411$export$3620a86b3ad94622 = (state)=>state.ui.portals.isSaveFailed;
const $15fbda2148a35411$export$f65464f8f75f45bc = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.serviceDeskId;
};
const $15fbda2148a35411$export$e8626520ddba5456 = (state, portalId)=>{
    var _portal$knowledgeBase3;
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    const kbSuggestions = portal && !('error' in portal) && ((_portal$knowledgeBase3 = portal.knowledgeBase) === null || _portal$knowledgeBase3 === void 0 ? void 0 : _portal$knowledgeBase3.kbArticleSuggestions);
    if (kbSuggestions === false || kbSuggestions === undefined) return [];
    return kbSuggestions;
};
const $15fbda2148a35411$export$b87c6f04552c18ef = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiUploadToken;
};
const $15fbda2148a35411$export$ddddbd1696231d6a = (state, portalId)=>{
    const portal = $15fbda2148a35411$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiError;
};

});



parcelRegister("gEZz8", function(module, exports) {
$parcel$export(module.exports, "requestGroupsEpic", () => $4fecb4fda922196f$export$194ec9e5a7b72182);
parcelRequire("2ycHZ");
var $4nFla = parcelRequire("4nFla");

var $dvKyT = parcelRequire("dvKyT");

var $fufIr = parcelRequire("fufIr");

var $aF3kU = parcelRequire("aF3kU");

var $lGYIe = parcelRequire("lGYIe");
const $4fecb4fda922196f$export$194ec9e5a7b72182 = (0, $4nFla.combineEpics)((0, $dvKyT.addRequestGroupEpic), (0, $lGYIe.reorderRequestGroupEpic), (0, $aF3kU.removeRequestGroupEpic), (0, $fufIr.getAllRequestGroupsEpic));

});
parcelRegister("dvKyT", function(module, exports) {
$parcel$export(module.exports, "addRequestGroupEpic", () => $45908fdefd8982c1$export$8362a74d5020b3ae);

var $8jOUp = parcelRequire("8jOUp");

var $8ZGQ1 = parcelRequire("8ZGQ1");
parcelRequire("6WAjm");
var $f4Rep = parcelRequire("f4Rep");
parcelRequire("l3hoq");
var $eB2UK = parcelRequire("eB2UK");

var $1vXf6 = parcelRequire("1vXf6");

var $jBiia = parcelRequire("jBiia");
const $45908fdefd8982c1$export$8362a74d5020b3ae = (action$)=>{
    return action$.ofType((0, $f4Rep.ADD_REQUEST_GROUP)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId, groupName: groupName, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        return (0, $8ZGQ1.addRequestGroup)(groupName, projectId).map((response)=>{
            if (analyticsEvent) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEvent.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $jBiia.legacySendEvent)(analyticsEvent);
            }
            return (0, $eB2UK.getRequestGroupsAction)(projectId, portalId);
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $jBiia.legacySendEvent)(analyticsFailureEvent);
            return (0, $8jOUp.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $f4Rep.addRequestGroupFailedAction)((0, $1vXf6.getFirstMessageFromJiraError)(error.response), groupName));
        });
    });
};

});
parcelRegister("8ZGQ1", function(module, exports) {
$parcel$export(module.exports, "addRequestGroup", () => $79c19e4ef58cfbb8$export$2a108ddc24673b82);
$parcel$export(module.exports, "updateRequestGroup", () => $79c19e4ef58cfbb8$export$6343ebb5dbd23e24);
$parcel$export(module.exports, "fetchAllRequestGroups", () => $79c19e4ef58cfbb8$export$1baf2ae38689e29e);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $79c19e4ef58cfbb8$export$2a108ddc24673b82 = (name, projectId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $llRGw.post)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $lJ0l5.Observable).throw(e);
    });
};
const $79c19e4ef58cfbb8$export$6343ebb5dbd23e24 = ({ name: name, projectId: projectId, requestGroupId: requestGroupId, context: context = (0, $eDcdn.contextPath) })=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}`;
    return (0, $llRGw.put)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $lJ0l5.Observable).throw(e));
};
const $79c19e4ef58cfbb8$export$1baf2ae38689e29e = (projectId, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $llRGw.get)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $lJ0l5.Observable).throw(e));
};

});

parcelRegister("6WAjm", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => (parcelRequire("f4Rep")).ADD_REQUEST_GROUP);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => (parcelRequire("f4Rep")).ADD_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestGroupAction", () => (parcelRequire("f4Rep")).addRequestGroupAction);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => (parcelRequire("f4Rep")).addRequestGroupFailedAction);

var $f4Rep = parcelRequire("f4Rep");

});
parcelRegister("f4Rep", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => $129157aadf1db5e7$export$8e1d62e25202aae2);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => $129157aadf1db5e7$export$3098f04a186c7a1a);
$parcel$export(module.exports, "addRequestGroupAction", () => $129157aadf1db5e7$export$207b3b17fddc56c6);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => $129157aadf1db5e7$export$668bfa1c007e18ef);
const $129157aadf1db5e7$export$8e1d62e25202aae2 = 'epic.request-groups.ADD_REQUEST_GROUP';
const $129157aadf1db5e7$export$3098f04a186c7a1a = 'epic.request-groups.ADD_REQUEST_GROUP_FAILED';
const $129157aadf1db5e7$export$207b3b17fddc56c6 = (payload)=>({
        payload: payload,
        type: $129157aadf1db5e7$export$8e1d62e25202aae2
    });
const $129157aadf1db5e7$export$668bfa1c007e18ef = (message, groupNameThatCausedError)=>({
        payload: {
            message: message,
            groupNameThatCausedError: groupNameThatCausedError
        },
        type: $129157aadf1db5e7$export$3098f04a186c7a1a
    });

});


parcelRegister("l3hoq", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => (parcelRequire("eB2UK")).GET_ALL_REQUEST_GROUPS);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => (parcelRequire("eB2UK")).GET_ALL_REQUEST_GROUPS_FAILURE);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => (parcelRequire("eB2UK")).GET_ALL_REQUEST_GROUPS_SUCCESS);
$parcel$export(module.exports, "getRequestGroupsAction", () => (parcelRequire("eB2UK")).getRequestGroupsAction);
$parcel$export(module.exports, "getRequestGroupsFailure", () => (parcelRequire("eB2UK")).getRequestGroupsFailure);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => (parcelRequire("eB2UK")).getRequestGroupsSuccess);
parcelRequire("eB2UK");

});
parcelRegister("eB2UK", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => $95e07dd630817901$export$4385e1518ec9ee53);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => $95e07dd630817901$export$b61d00db9e210ef);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => $95e07dd630817901$export$80b563f5e425073f);
$parcel$export(module.exports, "getRequestGroupsAction", () => $95e07dd630817901$export$9c0c7a1030efe8de);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => $95e07dd630817901$export$c1f5fa36efe1c1c7);
$parcel$export(module.exports, "getRequestGroupsFailure", () => $95e07dd630817901$export$a8d060d6575e9dfb);
const $95e07dd630817901$export$4385e1518ec9ee53 = 'epic.request-groups.GET_ALL_REQUEST_GROUPS';
const $95e07dd630817901$export$b61d00db9e210ef = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_SUCCESS';
const $95e07dd630817901$export$80b563f5e425073f = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_FAILURE';
const $95e07dd630817901$export$9c0c7a1030efe8de = (projectId, portalId)=>({
        payload: {
            projectId: projectId,
            portalId: portalId
        },
        type: $95e07dd630817901$export$4385e1518ec9ee53
    });
const $95e07dd630817901$export$c1f5fa36efe1c1c7 = (payload)=>({
        payload: payload,
        type: $95e07dd630817901$export$b61d00db9e210ef
    });
const $95e07dd630817901$export$a8d060d6575e9dfb = (payload)=>({
        payload: payload,
        type: $95e07dd630817901$export$80b563f5e425073f
    });

});



parcelRegister("fufIr", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsEpic", () => $bf6eeb73607d537c$export$53dc813939b78da1);

var $lJ0l5 = parcelRequire("lJ0l5");

var $8ZGQ1 = parcelRequire("8ZGQ1");
parcelRequire("l3hoq");
var $eB2UK = parcelRequire("eB2UK");

var $1vXf6 = parcelRequire("1vXf6");
const $bf6eeb73607d537c$export$53dc813939b78da1 = (action$)=>action$.ofType((0, $eB2UK.GET_ALL_REQUEST_GROUPS)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId } = action.payload;
        return (0, $8ZGQ1.fetchAllRequestGroups)(projectId).map((requestGroups)=>(0, $eB2UK.getRequestGroupsSuccess)({
                portalId: portalId,
                requestGroups: requestGroups
            })).catch((e)=>{
            const errorMessage = (0, $1vXf6.getFirstMessageFromJiraError)(e.response);
            return (0, $lJ0l5.Observable).of((0, $eB2UK.getRequestGroupsFailure)({
                errorMessage: errorMessage,
                projectId: projectId
            }));
        });
    });

});

parcelRegister("aF3kU", function(module, exports) {
$parcel$export(module.exports, "removeRequestGroupEpic", () => $0821429985402f94$export$7a528fd4d213cd7);

var $8jOUp = parcelRequire("8jOUp");

var $dWFzC = parcelRequire("dWFzC");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("fw9T9");
var $hjSyw = parcelRequire("hjSyw");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $jBiia = parcelRequire("jBiia");
const $0821429985402f94$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $0821429985402f94$export$7a528fd4d213cd7 = (action$, store)=>{
    return action$.ofType((0, $hjSyw.REMOVE_REQUEST_GROUP)).mergeMap(({ payload: { portalId: portalId, deletedId: deletedId, onRemoveGroupSuccess: onRemoveGroupSuccess, onRemoveGroupError: onRemoveGroupError, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $iWhHo.getProjectId)(state, portalId);
        const requestGroups = (0, $iWhHo.getPortalRequestGroups)(state, portalId);
        const newOrder = requestGroups.map(({ id: id })=>id).filter((id)=>id !== deletedId);
        // Perform the rest call to update groups
        return (0, $dWFzC.requestGroupReorder)({
            projectId: projectId,
            order: newOrder,
            id: $0821429985402f94$var$REQUEST_ID,
            deleted: [
                deletedId
            ],
            inline: true
        })// On success, refresh the model
        .map(()=>{
            analyticsEvent && (0, $jBiia.legacySendEvent)(analyticsEvent);
            if (onRemoveGroupSuccess) onRemoveGroupSuccess();
            return (0, $jeW3I.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        })// On fail, clear the ui state to reverse optimistic update
        .catch(()=>{
            if (onRemoveGroupError) onRemoveGroupError();
            if (analyticsFailureEvent) (0, $jBiia.legacySendEvent)(analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $hjSyw.removeRequestGroupFailedAction)());
        });
    });
};

});
parcelRegister("dWFzC", function(module, exports) {
$parcel$export(module.exports, "requestGroupReorder", () => $01c1dbee3f5f1e9e$export$e26022a90e227660);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");
const $01c1dbee3f5f1e9e$export$e26022a90e227660 = ({ id: id, deleted: deleted, order: order, inline: inline, projectId: projectId })=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    const body = {
        id: id,
        deleted: deleted,
        order: order,
        inline: inline
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.put)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("fw9T9", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => (parcelRequire("hjSyw")).REMOVE_REQUEST_GROUP);
$parcel$export(module.exports, "removeRequestGroupAction", () => (parcelRequire("hjSyw")).removeRequestGroupAction);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => (parcelRequire("hjSyw")).removeRequestGroupFailedAction);

var $hjSyw = parcelRequire("hjSyw");

});
parcelRegister("hjSyw", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => $f618a14c88ca2862$export$7aaaf575c1ef21c8);
$parcel$export(module.exports, "removeRequestGroupAction", () => $f618a14c88ca2862$export$fe2120d3bdfd11a7);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => $f618a14c88ca2862$export$35f1f33f6fdb929d);
const $f618a14c88ca2862$export$7aaaf575c1ef21c8 = 'epic.request-groups.REMOVE_REQUEST_GROUP';
const $f618a14c88ca2862$var$REMOVE_REQUEST_GROUP_FAILED = 'epic.request-groups.REMOVE_REQUEST_GROUP_FAILED';
const $f618a14c88ca2862$export$fe2120d3bdfd11a7 = (payload)=>{
    return {
        payload: payload,
        type: $f618a14c88ca2862$export$7aaaf575c1ef21c8
    };
};
const $f618a14c88ca2862$export$35f1f33f6fdb929d = ()=>{
    return {
        type: $f618a14c88ca2862$var$REMOVE_REQUEST_GROUP_FAILED
    };
};

});



parcelRegister("lGYIe", function(module, exports) {
$parcel$export(module.exports, "reorderRequestGroupEpic", () => $5dea28cad4e68b97$export$691172c527fd88df);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $dWFzC = parcelRequire("dWFzC");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("3dIfO");
var $buG9s = parcelRequire("buG9s");
parcelRequire("l3hoq");
var $eB2UK = parcelRequire("eB2UK");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("leWfj");
var $2TBUB = parcelRequire("2TBUB");

var $jBiia = parcelRequire("jBiia");
const $5dea28cad4e68b97$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $5dea28cad4e68b97$export$691172c527fd88df = (action$, store)=>{
    return action$.ofType((0, $buG9s.UPDATE_REQUEST_GROUPS_ORDER))// User may perform updates (reorders and deletes) rapidly but we want to minimise unnecessary REST calls
    // We could debounce but we want ALL the analytics events so instead we buffer, get ALL the analytics events
    // and then just process the most recent event and if successful fire ALL analytics events
    .bufferTime(500).mergeMap((bufferedActions)=>{
        // First, create list of buffered analytic events (ALL will be fired if `update request groups` REST call is successful)
        const analyticsEvents = bufferedActions.map((action)=>action.payload.analyticsEvent).filter(Boolean);
        const analyticsFailureEvents = bufferedActions.map((action)=>action.payload.analyticsFailureEvent).filter(Boolean);
        // Second, pop the most recently published action
        const mostRecentAction = bufferedActions.pop();
        if (!mostRecentAction) return (0, $8jOUp.Observable).empty();
        const { portalId: portalId, order: order } = mostRecentAction.payload;
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $iWhHo.getProjectId)(state, portalId);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const requestGroups = (0, $2TBUB.getUIRequestGroups)(state, portalId);
        const deletedIds = requestGroups.map(({ id: id })=>id).filter((id)=>!order.includes(id));
        // Perform the rest call to update groups
        return (0, $dWFzC.requestGroupReorder)({
            projectId: projectId,
            order: order,
            deleted: deletedIds,
            id: $5dea28cad4e68b97$var$REQUEST_ID,
            inline: true
        })// On success, refresh the model
        .mergeMap(()=>{
            // Success; fire ALL analytics events
            analyticsEvents.forEach((0, $jBiia.legacySendEvent));
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $eB2UK.getRequestGroupsAction)(projectId, portalId)), (0, $8jOUp.Observable).of((0, $jeW3I.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            })));
        })// On fail, clear the ui state to reverse optimistic update
        .catch((_)=>{
            analyticsFailureEvents.forEach((0, $jBiia.legacySendEvent));
            return (0, $8jOUp.Observable).of((0, $buG9s.clearRequestGroupsOrderAction)());
        });
    });
};

});
parcelRegister("3dIfO", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => (parcelRequire("buG9s")).UPDATE_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => (parcelRequire("buG9s")).CLEAR_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => (parcelRequire("buG9s")).CLEAR_ERROR_MESSAGE);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => (parcelRequire("buG9s")).CLEAR_REQUEST_TYPES_ORDER);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => (parcelRequire("buG9s")).updateRequestGroupsOrderAction);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => (parcelRequire("buG9s")).clearRequestGroupsOrderAction);
$parcel$export(module.exports, "clearErrorMessageAction", () => (parcelRequire("buG9s")).clearErrorMessageAction);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => (parcelRequire("buG9s")).clearRequestTypesOrderAction);

var $buG9s = parcelRequire("buG9s");

});
parcelRegister("buG9s", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => $b129a89997ddc0d3$export$3206afd0265da736);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => $b129a89997ddc0d3$export$cef961ec6e406565);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => $b129a89997ddc0d3$export$954b6cd4735c91da);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => $b129a89997ddc0d3$export$896c4eec286cc76c);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => $b129a89997ddc0d3$export$c362b5f333b2372c);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => $b129a89997ddc0d3$export$1a19c76107cb4b0c);
$parcel$export(module.exports, "clearErrorMessageAction", () => $b129a89997ddc0d3$export$a72b98a8de57346e);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => $b129a89997ddc0d3$export$8e8d01bbfddde092);
const $b129a89997ddc0d3$export$3206afd0265da736 = 'state.ui.portal-customisation.UPDATE_REQUEST_GROUPS_ORDER';
const $b129a89997ddc0d3$export$cef961ec6e406565 = 'state.ui.portal-customisation.CLEAR_REQUEST_GROUPS_ORDER';
const $b129a89997ddc0d3$export$954b6cd4735c91da = 'state.ui.portal-customisation.CLEAR_ERROR_MESSAGE';
const $b129a89997ddc0d3$export$896c4eec286cc76c = 'state.ui.portal-customisation.CLEAR_REQUEST_TYPES_ORDER';
const $b129a89997ddc0d3$export$c362b5f333b2372c = (payload)=>({
        payload: payload,
        type: $b129a89997ddc0d3$export$3206afd0265da736
    });
const $b129a89997ddc0d3$export$1a19c76107cb4b0c = ()=>({
        type: $b129a89997ddc0d3$export$cef961ec6e406565
    });
const $b129a89997ddc0d3$export$a72b98a8de57346e = ()=>({
        type: $b129a89997ddc0d3$export$954b6cd4735c91da
    });
const $b129a89997ddc0d3$export$8e8d01bbfddde092 = ()=>({
        type: $b129a89997ddc0d3$export$896c4eec286cc76c
    });

});


parcelRegister("leWfj", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => (parcelRequire("2TBUB")).getAllRequestGroupsWithRequestTypesForPortal);
$parcel$export(module.exports, "getErrorMessage", () => (parcelRequire("2TBUB")).getErrorMessage);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => (parcelRequire("2TBUB")).getGroupNameThatCausedError);
$parcel$export(module.exports, "getPortalCustomisationError", () => (parcelRequire("2TBUB")).getPortalCustomisationError);
$parcel$export(module.exports, "getRequestGroupById", () => (parcelRequire("2TBUB")).getRequestGroupById);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => (parcelRequire("2TBUB")).getUIIsParentRequestGroupsLoading);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => (parcelRequire("2TBUB")).getUIParentRequestGroupsForRequestType);
$parcel$export(module.exports, "getUIRequestGroups", () => (parcelRequire("2TBUB")).getUIRequestGroups);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => (parcelRequire("2TBUB")).getUIRequestGroupsOrder);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => (parcelRequire("2TBUB")).getUIRequestGroupsWithRequestTypes);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => (parcelRequire("2TBUB")).getUIRequestTypesInRequestGroupById);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => (parcelRequire("2TBUB")).getUIRequestTypesNotInRequestGroupById);
parcelRequire("2TBUB");

});
parcelRegister("2TBUB", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => $45c493805a25f6b7$export$eafd9d6b190f9991);
$parcel$export(module.exports, "getErrorMessage", () => $45c493805a25f6b7$export$82f46aa4e6535a45);
$parcel$export(module.exports, "getRequestGroupById", () => $45c493805a25f6b7$export$c93f0b0a861dcf03);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => $45c493805a25f6b7$export$13689122403cb761);
$parcel$export(module.exports, "getUIRequestGroups", () => $45c493805a25f6b7$export$5b1cb606e38791c6);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => $45c493805a25f6b7$export$5d023274645990b2);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => $45c493805a25f6b7$export$3257afc3359cfce);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => $45c493805a25f6b7$export$9abf85e04ff9329b);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => $45c493805a25f6b7$export$1863e442385dba5c);
$parcel$export(module.exports, "getPortalCustomisationError", () => $45c493805a25f6b7$export$7b32ab9a7ad364f3);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => $45c493805a25f6b7$export$9f49200face9760d);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => $45c493805a25f6b7$export$5f6e3f684cf8395b);
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
/**
 *
 *  Persisted Portal Customisation state selectors
 *
 */ const $45c493805a25f6b7$var$withRequestTypesPopulated = (groupsWithTypes)=>(reqGroup)=>{
        const existingReqTypes = groupsWithTypes.find((rg)=>rg.id === reqGroup.id);
        return {
            ...reqGroup,
            reqTypes: !!existingReqTypes ? existingReqTypes.reqTypes : []
        };
    };
const $45c493805a25f6b7$export$25ec121fd14d9df3 = (state)=>state.persisted.portalCustomisation.allRequestGroups;
const $45c493805a25f6b7$export$514a0edc3b518db9 = (state, portalId)=>{
    const allRequestGroups = $45c493805a25f6b7$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return allRequestGroups[portalId];
};
const $45c493805a25f6b7$export$eafd9d6b190f9991 = (state, portalId)=>{
    const allRequestGroups = $45c493805a25f6b7$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    const groupsWithExistingRequestTypes = (0, $iWhHo.getPortalRequestGroups)(state, portalId);
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const requestGroupsWithRequestTypes = allRequestGroups[portalId].map($45c493805a25f6b7$var$withRequestTypesPopulated(groupsWithExistingRequestTypes));
    return requestGroupsWithRequestTypes;
};
const $45c493805a25f6b7$export$82f46aa4e6535a45 = (state)=>state.persisted.portalCustomisation.errorMessage;
const $45c493805a25f6b7$export$c93f0b0a861dcf03 = (state, portalId, requestGroupId)=>{
    const requestGroups = $45c493805a25f6b7$export$eafd9d6b190f9991(state, portalId);
    return !!requestGroups ? requestGroups.find((group)=>group.id === requestGroupId) : undefined;
};
const $45c493805a25f6b7$export$13689122403cb761 = (state)=>state.ui.portalCustomisation.requestGroupsOrder;
const $45c493805a25f6b7$export$f7da43c7a00426c = (state)=>state.ui.portalCustomisation.requestTypesOrder;
const $45c493805a25f6b7$export$5b1cb606e38791c6 = (state, portalId)=>state.ui.portalCustomisation.requestGroups || $45c493805a25f6b7$export$514a0edc3b518db9(state, portalId);
const $45c493805a25f6b7$export$5d023274645990b2 = (state, portalId)=>state.ui.portalCustomisation.requestGroups ? state.ui.portalCustomisation.requestGroups.map($45c493805a25f6b7$var$withRequestTypesPopulated((0, $iWhHo.getPortalRequestGroups)(state, portalId))) : $45c493805a25f6b7$export$eafd9d6b190f9991(state, portalId);
const $45c493805a25f6b7$export$3257afc3359cfce = (state, portalId, requestGroupId)=>{
    let requestTypesInRequestGroup = state.ui.portalCustomisation.requestTypesInRequestGroup || (0, $iWhHo.getPortalRequestTypesForRequestGroup)(state, portalId, requestGroupId);
    const requestTypesOrder = $45c493805a25f6b7$export$f7da43c7a00426c(state);
    if (requestTypesOrder) requestTypesInRequestGroup = requestTypesOrder.map((requestTypeId)=>requestTypesInRequestGroup.find((rt)=>Number(rt.id) === requestTypeId)).filter(Boolean);
    return requestTypesInRequestGroup;
};
const $45c493805a25f6b7$export$9abf85e04ff9329b = (state, portalId, requestTypeId)=>{
    const parentRequestGroups = state.ui.portalCustomisation.parentRequestGroups || (0, $iWhHo.getRequestGroupsForRequestType)({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return [
        ...parentRequestGroups
    ].sort((first, second)=>first.name.toLowerCase().localeCompare(second.name.toLowerCase()));
};
const $45c493805a25f6b7$export$1863e442385dba5c = (state)=>{
    return state.ui.portalCustomisation.isParentRequestGroupsLoading;
};
const $45c493805a25f6b7$export$7b32ab9a7ad364f3 = (state)=>state.ui.portalCustomisation.error;
const $45c493805a25f6b7$export$9f49200face9760d = (state)=>state.ui.portalCustomisation.groupNameThatCausedError;
const $45c493805a25f6b7$export$5f6e3f684cf8395b = (state, portalId, requestGroupId)=>{
    return state.ui.portalCustomisation.requestTypesNotInRequestGroup || (0, $iWhHo.getPortalRequestTypesNotInRequestGroup)(state, portalId, requestGroupId);
};

});




parcelRegister("9LO37", function(module, exports) {
$parcel$export(module.exports, "addRequestTypeToRequestGroupEpic", () => $e5352da0903e9380$export$7219fe759636c43a);

var $8jOUp = parcelRequire("8jOUp");

var $4ZMmh = parcelRequire("4ZMmh");

var $hoR7G = parcelRequire("hoR7G");
parcelRequire("700bz");
var $br0Cz = parcelRequire("br0Cz");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("leWfj");
var $2TBUB = parcelRequire("2TBUB");

var $1vXf6 = parcelRequire("1vXf6");

var $jBiia = parcelRequire("jBiia");
const $e5352da0903e9380$var$getAssociatedGroups = (requestType, requestGroup, requestGroups)=>{
    const associatedRequestGroups = (0, $4ZMmh.uniqBy)(requestGroups, 'id').filter((reqGroup)=>reqGroup.reqTypes.includes(requestType.id));
    // Add group association to request type if not already added
    if (!associatedRequestGroups.includes(requestGroup)) associatedRequestGroups.push(requestGroup);
    return associatedRequestGroups;
};
const $e5352da0903e9380$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $e5352da0903e9380$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $e5352da0903e9380$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroup, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $e5352da0903e9380$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $e5352da0903e9380$var$getSanitizedText(requestType.descriptionHtml),
        groups: $e5352da0903e9380$var$getAssociatedGroups(requestType, requestGroup, requestGroups)
    });
const $e5352da0903e9380$export$7219fe759636c43a = (action$, store)=>{
    return action$.ofType((0, $br0Cz.ADD_REQUEST_TYPE_TO_REQUEST_GROUP)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroup: requestGroup, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        const requestGroups = (0, $2TBUB.getAllRequestGroupsWithRequestTypesForPortal)(state, portalId) || [];
        return (0, $hoR7G.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: requestGroup.id,
            requestGroupId: requestGroup.id,
            requestType: $e5352da0903e9380$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroup, requestGroups)
        }).map(()=>{
            analyticsEvent && (0, $jBiia.legacySendEvent)(analyticsEvent);
            return (0, $jeW3I.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $jBiia.legacySendEvent)(analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $br0Cz.addRequestTypeToRequestGroupFailedAction)((0, $1vXf6.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("hoR7G", function(module, exports) {
$parcel$export(module.exports, "setRequestGroupsForRequestType", () => $88510227a334c9b8$export$9067d57db9e6b38e);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");
const $88510227a334c9b8$export$9067d57db9e6b38e = ({ isProjectSimplified: isProjectSimplified, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroupId: requestGroupId, projectId: projectId, context: context = (0, $eDcdn.contextPath) })=>{
    if (isProjectSimplified) {
        const nextGenUri = (groupId)=>`${context}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${groupId}/${requestType.id}`;
        const isAdded = requestType.groups.some(({ id: id })=>id === updatedRequestTypeGroupId);
        const httpMethod = isAdded ? (0, $llRGw.put) : (0, $llRGw.doDelete);
        return httpMethod(nextGenUri(updatedRequestTypeGroupId))// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response).catch((e)=>{
            // Rethrow error
            return (0, $8jOUp.Observable).throw(e);
        });
    }
    // In Classic:
    // The request type <-> group association is stored on a request type in the backend
    // We call the update request type endpoint with the request type in the body with the new group associsation
    const classicUri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestType.id}`;
    return (0, $llRGw.put)(classicUri, requestType, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("700bz", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => (parcelRequire("br0Cz")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => (parcelRequire("br0Cz")).addRequestTypeToRequestGroupAction);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => (parcelRequire("br0Cz")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => (parcelRequire("br0Cz")).addRequestTypeToRequestGroupFailedAction);

var $br0Cz = parcelRequire("br0Cz");

});
parcelRegister("br0Cz", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => $4f42b72cf2db9ac1$export$eb48643df0521b0d);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => $4f42b72cf2db9ac1$export$196767c05c5a3485);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => $4f42b72cf2db9ac1$export$e0f4630e32187ebc);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => $4f42b72cf2db9ac1$export$87cedd1ffa234cc5);
const $4f42b72cf2db9ac1$export$eb48643df0521b0d = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP';
const $4f42b72cf2db9ac1$export$196767c05c5a3485 = (payload)=>{
    return {
        payload: payload,
        type: $4f42b72cf2db9ac1$export$eb48643df0521b0d
    };
};
const $4f42b72cf2db9ac1$var$ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED';
const $4f42b72cf2db9ac1$export$e0f4630e32187ebc = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED';
const $4f42b72cf2db9ac1$export$87cedd1ffa234cc5 = (message)=>({
        payload: {
            message: message
        },
        type: $4f42b72cf2db9ac1$export$e0f4630e32187ebc
    });

});



parcelRegister("9ITVk", function(module, exports) {
$parcel$export(module.exports, "createGroupWithRequestTypeEpic", () => $97b9bb576c9dcc20$export$2d5fcba5bbcf0933);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $8ZGQ1 = parcelRequire("8ZGQ1");
parcelRequire("8EnIC");
var $jubPh = parcelRequire("jubPh");
parcelRequire("l3hoq");
var $eB2UK = parcelRequire("eB2UK");
parcelRequire("do8oT");
var $c5rB4 = parcelRequire("c5rB4");

var $1vXf6 = parcelRequire("1vXf6");

var $jBiia = parcelRequire("jBiia");
const $97b9bb576c9dcc20$export$2d5fcba5bbcf0933 = (action$)=>{
    return action$.ofType((0, $jubPh.CREATE_GROUP_WITH_REQUEST_TYPE)).mergeMap((action)=>{
        const { isProjectSimplified: isProjectSimplified, projectId: projectId, portalId: portalId, groupName: groupName, analyticsEventRequestGroupCreated: analyticsEventRequestGroupCreated, analyticsEventRequestGroupUpdated: analyticsEventRequestGroupUpdated, requestType: requestType, requestGroups: requestGroups, analyticsEventRequestGroupCreatedFailure: analyticsEventRequestGroupCreatedFailure, analyticsEventRequestGroupUpdatedFailure: analyticsEventRequestGroupUpdatedFailure } = action.payload;
        return (0, $8ZGQ1.addRequestGroup)(groupName, projectId).mergeMap((response)=>{
            if (analyticsEventRequestGroupCreated) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEventRequestGroupCreated.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $jBiia.legacySendEvent)(analyticsEventRequestGroupCreated);
            }
            if (analyticsEventRequestGroupUpdated) // Update the analytics event with newly created Request type group's ID as the actionSubjectId
            analyticsEventRequestGroupUpdated.update((payload)=>({
                    ...payload,
                    actionSubjectId: response.id
                }));
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $eB2UK.getRequestGroupsAction)(projectId, portalId)), (0, $8jOUp.Observable).of((0, $c5rB4.setRequestTypeGroupsAction)({
                isProjectSimplified: isProjectSimplified,
                portalId: portalId,
                projectId: projectId,
                requestType: requestType,
                updatedRequestTypeGroupId: response.id,
                analyticsEvent: analyticsEventRequestGroupUpdated,
                requestGroups: [
                    ...requestGroups,
                    response
                ]
            })));
        }).catch((error)=>{
            [
                analyticsEventRequestGroupCreatedFailure,
                analyticsEventRequestGroupUpdatedFailure
            ].filter((x)=>x).forEach((event)=>{
                (0, $jBiia.legacySendEvent)(event);
            });
            return (0, $8jOUp.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $jubPh.createGroupWithRequestTypeFailedAction)((0, $1vXf6.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("8EnIC", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => (parcelRequire("jubPh")).CREATE_GROUP_WITH_REQUEST_TYPE);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => (parcelRequire("jubPh")).CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => (parcelRequire("jubPh")).CREATE_GROUP_WITH_REQUEST_TYPE_FAILED);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => (parcelRequire("jubPh")).createGroupWithRequestTypeAction);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => (parcelRequire("jubPh")).createGroupWithRequestTypeFailedAction);

var $jubPh = parcelRequire("jubPh");

});
parcelRegister("jubPh", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => $f69e1c2e80959399$export$c69550447058b57a);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => $f69e1c2e80959399$export$c456181637c5858e);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => $f69e1c2e80959399$export$71c9976978aa32b4);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => $f69e1c2e80959399$export$10336454f9456d40);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => $f69e1c2e80959399$export$729bba13ddb7a330);
const $f69e1c2e80959399$export$c69550447058b57a = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE';
const $f69e1c2e80959399$export$c456181637c5858e = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED';
const $f69e1c2e80959399$export$71c9976978aa32b4 = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED';
const $f69e1c2e80959399$export$10336454f9456d40 = (payload)=>({
        payload: payload,
        type: $f69e1c2e80959399$export$c69550447058b57a
    });
const $f69e1c2e80959399$export$8bd250cf41846ec6 = ()=>({
        type: $f69e1c2e80959399$export$c456181637c5858e
    });
const $f69e1c2e80959399$export$729bba13ddb7a330 = (message)=>({
        payload: {
            message: message
        },
        type: $f69e1c2e80959399$export$71c9976978aa32b4
    });

});


parcelRegister("do8oT", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => (parcelRequire("c5rB4")).SET_REQUEST_TYPE_GROUPS);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => (parcelRequire("c5rB4")).setRequestTypeGroupsAction);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => (parcelRequire("c5rB4")).SET_REQUEST_TYPE_GROUPS_FAILED);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => (parcelRequire("c5rB4")).setRequestTypeGroupsFailedAction);

var $c5rB4 = parcelRequire("c5rB4");

});
parcelRegister("c5rB4", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => $260157093eea9340$export$44dbc716b23b5565);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => $260157093eea9340$export$9d952046e09fb735);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => $260157093eea9340$export$509c65d9f883a62a);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => $260157093eea9340$export$337a82f6e04125f9);
const $260157093eea9340$export$44dbc716b23b5565 = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS';
const $260157093eea9340$export$9d952046e09fb735 = (payload)=>{
    return {
        payload: payload,
        type: $260157093eea9340$export$44dbc716b23b5565
    };
};
const $260157093eea9340$export$509c65d9f883a62a = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS_FAILED';
const $260157093eea9340$export$337a82f6e04125f9 = (message)=>({
        payload: {
            message: message
        },
        type: $260157093eea9340$export$509c65d9f883a62a
    });

});



parcelRegister("d2dBy", function(module, exports) {
$parcel$export(module.exports, "deleteRequestTypeFromGroupEpic", () => $a7ca6fc6ffa93da3$export$d1c43b1bbe33b61c);

var $8jOUp = parcelRequire("8jOUp");

var $4oHi9 = parcelRequire("4oHi9");
parcelRequire("ovmd1");
var $3UF8G = parcelRequire("3UF8G");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("3dIfO");
var $buG9s = parcelRequire("buG9s");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $jBiia = parcelRequire("jBiia");
const $a7ca6fc6ffa93da3$export$d1c43b1bbe33b61c = (action$, store)=>{
    return action$.ofType((0, $3UF8G.DELETE_REQUEST_TYPE_FROM_GROUP)).mergeMap((action)=>{
        const state = store.getState();
        const { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroupId: requestGroupId, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        const updatedRequestGroups = (0, $iWhHo.getRequestGroupsForRequestType)({
            state: state,
            portalId: portalId,
            requestTypeId: Number(requestType.id)
        }).filter((requestGroup)=>requestGroup.id !== requestGroupId);
        const body = {
            ...requestType,
            groups: updatedRequestGroups
        };
        return (0, $4oHi9.deleteRequestTypeFromGroup)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            requestGroupId: requestGroupId,
            requestType: body
        }).map(()=>{
            analyticsEvent && (0, $jBiia.legacySendEvent)(analyticsEvent);
            return (0, $jeW3I.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $jBiia.legacySendEvent)(analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $buG9s.clearRequestTypesOrderAction)());
        });
    });
};

});
parcelRegister("4oHi9", function(module, exports) {
$parcel$export(module.exports, "requestTypeReorder", () => $754a7e8370790b50$export$f7d2151053714646);
$parcel$export(module.exports, "deleteRequestTypeFromGroup", () => $754a7e8370790b50$export$4ef0a9afff40ad59);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");
const $754a7e8370790b50$export$f7d2151053714646 = ({ projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, body: body })=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}/move`;
    return (0, $llRGw.post)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $8jOUp.Observable).throw(e));
};
const $754a7e8370790b50$export$4ef0a9afff40ad59 = ({ isProjectSimplified: isProjectSimplified, projectId: projectId, requestGroupId: requestGroupId, requestType: toUpdate })=>{
    const { id: requestTypeId } = toUpdate;
    if (isProjectSimplified) {
        const nextGenUri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${requestGroupId}/${requestTypeId}`;
        return (0, $llRGw.doDelete)(nextGenUri, undefined).map(({ response: response })=>response).catch((e)=>(0, $8jOUp.Observable).throw(e));
    }
    const classicUri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}`;
    return (0, $llRGw.put)(classicUri, toUpdate, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $8jOUp.Observable).throw(e));
};

});

parcelRegister("ovmd1", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => (parcelRequire("3UF8G")).DELETE_REQUEST_TYPE_FROM_GROUP);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => (parcelRequire("3UF8G")).deleteRequestTypeFromGroupAction);
parcelRequire("3UF8G");

});
parcelRegister("3UF8G", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => $1f6d01ee1a9e98a0$export$37d5cf3470d18d4a);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => $1f6d01ee1a9e98a0$export$dd2f56a17442f2c4);
const $1f6d01ee1a9e98a0$export$37d5cf3470d18d4a = 'epic.request-types.DELETE_REQUEST_TYPE_FROM_GROUP';
const $1f6d01ee1a9e98a0$export$dd2f56a17442f2c4 = (payload)=>({
        payload: payload,
        type: $1f6d01ee1a9e98a0$export$37d5cf3470d18d4a
    });

});



parcelRegister("gnxk7", function(module, exports) {
$parcel$export(module.exports, "reorderRequestTypeEpic", () => $d140a112aef73161$export$efb6288a30e93a3a);

var $8jOUp = parcelRequire("8jOUp");

var $4oHi9 = parcelRequire("4oHi9");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("3dIfO");
var $buG9s = parcelRequire("buG9s");
parcelRequire("ahMzO");
var $gmBeu = parcelRequire("gmBeu");

var $jBiia = parcelRequire("jBiia");
const $d140a112aef73161$export$efb6288a30e93a3a = (action$)=>action$.ofType((0, $gmBeu.REORDER_REQUEST_TYPE)).mergeMap(({ payload: { portalId: portalId, projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex, requestTypes: requestTypes, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const body = $d140a112aef73161$var$getReorderPayload({
            requestTypes: requestTypes,
            fromIndex: fromIndex,
            toIndex: toIndex,
            projectId: projectId,
            requestGroupId: requestGroupId
        });
        return (0, $4oHi9.requestTypeReorder)({
            requestTypeId: requestTypeId,
            projectId: projectId,
            requestGroupId: requestGroupId,
            body: body
        }).map(()=>{
            analyticsEvent && (0, $jBiia.legacySendEvent)(analyticsEvent);
            return (0, $jeW3I.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $jBiia.legacySendEvent)(analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $buG9s.clearRequestTypesOrderAction)());
        });
    });
// The POST endpoint for reordering request types expects the body payload of POST request to look like:
// { position: 'First' } - when dragging a request type to the top of the list
// and { after: [url + requestTypeId] } - where requestTypeId is the id of the request type which the dragged req type will be under.
function $d140a112aef73161$var$getReorderPayload({ requestTypes: requestTypes, projectId: projectId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex }) {
    if (toIndex === 0) return {
        position: 'First'
    };
    let requestTypeAfter;
    if (toIndex < fromIndex) // if we're dragging UP the list we want it to set 'after' to the item above
    requestTypeAfter = requestTypes[toIndex - 1];
    else requestTypeAfter = requestTypes[toIndex];
    return {
        after: `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeAfter.id}`
    };
}

});
parcelRegister("ahMzO", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => (parcelRequire("gmBeu")).REORDER_REQUEST_TYPE);
$parcel$export(module.exports, "reorderRequestTypeAction", () => (parcelRequire("gmBeu")).reorderRequestTypeAction);
parcelRequire("gmBeu");

});
parcelRegister("gmBeu", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => $f69e38549da977be$export$46dd7d5218860986);
$parcel$export(module.exports, "reorderRequestTypeAction", () => $f69e38549da977be$export$f0a9fcf0696aeebb);
const $f69e38549da977be$export$46dd7d5218860986 = 'epic.request-types.REORDER_REQUEST_TYPE';
const $f69e38549da977be$export$f0a9fcf0696aeebb = (payload)=>({
        payload: payload,
        type: $f69e38549da977be$export$46dd7d5218860986
    });

});



parcelRegister("5tRND", function(module, exports) {
$parcel$export(module.exports, "setRequestTypeGroupsEpic", () => $6b0bd7a3bd32699c$export$da9fdc969ff1b05d);

var $8jOUp = parcelRequire("8jOUp");

var $hoR7G = parcelRequire("hoR7G");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("do8oT");
var $c5rB4 = parcelRequire("c5rB4");

var $1vXf6 = parcelRequire("1vXf6");

var $jBiia = parcelRequire("jBiia");
const $6b0bd7a3bd32699c$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $6b0bd7a3bd32699c$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $6b0bd7a3bd32699c$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $6b0bd7a3bd32699c$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $6b0bd7a3bd32699c$var$getSanitizedText(requestType.descriptionHtml),
        groups: requestGroups
    });
const $6b0bd7a3bd32699c$export$da9fdc969ff1b05d = (action$)=>{
    return action$.ofType((0, $c5rB4.SET_REQUEST_TYPE_GROUPS)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroups: requestGroups, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        return (0, $hoR7G.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: updatedRequestTypeGroupId,
            requestGroupId: 'hidden',
            requestType: $6b0bd7a3bd32699c$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroups)
        }).map(()=>{
            if (analyticsEvent) (0, $jBiia.legacySendEvent)(analyticsEvent);
            return (0, $jeW3I.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $jBiia.legacySendEvent)(analyticsFailureEvent);
            return (0, $8jOUp.Observable).of((0, $c5rB4.setRequestTypeGroupsFailedAction)((0, $1vXf6.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});

parcelRegister("7iSP5", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmailEpic", () => $855cb500ab80d031$export$a8c26f01f6ef2d73);

var $8jOUp = parcelRequire("8jOUp");

var $1wXU7 = parcelRequire("1wXU7");
parcelRequire("76IQl");
var $1nXbO = parcelRequire("1nXbO");
const $855cb500ab80d031$export$a8c26f01f6ef2d73 = (action$)=>{
    return action$.ofType((0, $1nXbO.FETCH_RESEND_VERIFY_EMAIL)).mergeMap((action)=>{
        const { emailAddress: emailAddress, portalId: portalId } = action.payload.params;
        const errorResponse = {
            status: 503
        };
        return (0, $1wXU7.resendVerifyEmail)(emailAddress, portalId).map((response)=>{
            if (response.status === 204) return (0, $1nXbO.fetchResendVerificationSuccess)();
            return (0, $1nXbO.fetchResendVerificationFailure)(errorResponse);
        }).catch((error)=>(0, $8jOUp.Observable).of((0, $1nXbO.fetchResendVerificationFailure)(error)));
    });
};

});
parcelRegister("1wXU7", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmail", () => $8d4cfc90bc5d2a5c$export$da8af7e7b05b444);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $8d4cfc90bc5d2a5c$var$getResendVerifyEmailRequestBody = (email, portalId)=>({
        email: email,
        verificationContext: {
            portalId: portalId
        }
    });
const $8d4cfc90bc5d2a5c$export$da8af7e7b05b444 = (email, portalId)=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/pages/user/resend-verification-email`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const body = $8d4cfc90bc5d2a5c$var$getResendVerifyEmailRequestBody(email, portalId);
    return (0, $llRGw.post)(uri, body, headers);
};

});

parcelRegister("76IQl", function(module, exports) {
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => (parcelRequire("1nXbO")).fetchResendVerifyEmailAction);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => (parcelRequire("1nXbO")).fetchResendVerificationFailure);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => (parcelRequire("1nXbO")).fetchResendVerificationSuccess);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => (parcelRequire("1nXbO")).FETCH_RESEND_VERIFICATION_FAILURE);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => (parcelRequire("1nXbO")).FETCH_RESEND_VERIFICATION_SUCCESS);
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => (parcelRequire("1nXbO")).FETCH_RESEND_VERIFY_EMAIL);

var $1nXbO = parcelRequire("1nXbO");

});
parcelRegister("1nXbO", function(module, exports) {
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => $0dcd738d6d351c5f$export$c41322ca6fdfdd1f);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => $0dcd738d6d351c5f$export$5d8d6d17a7bb9f46);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => $0dcd738d6d351c5f$export$7517f0d1f77dd091);
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => $0dcd738d6d351c5f$export$33f84eb26dff7a8d);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => $0dcd738d6d351c5f$export$548d04925c9d810e);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => $0dcd738d6d351c5f$export$ccba2c058636a09f);
const $0dcd738d6d351c5f$export$c41322ca6fdfdd1f = 'epic.verify-email.FETCH_RESEND_VERIFY_EMAIL';
const $0dcd738d6d351c5f$export$5d8d6d17a7bb9f46 = 'state.ui.resendVerifyEmail.FAILED';
const $0dcd738d6d351c5f$export$7517f0d1f77dd091 = 'state.ui.resendVerifyEmail.SUCCEEDED';
const $0dcd738d6d351c5f$export$33f84eb26dff7a8d = ({ emailAddress: emailAddress, portalId: portalId })=>{
    return {
        type: $0dcd738d6d351c5f$export$c41322ca6fdfdd1f,
        payload: {
            params: {
                emailAddress: emailAddress,
                portalId: portalId
            }
        }
    };
};
const $0dcd738d6d351c5f$export$548d04925c9d810e = ()=>({
        type: $0dcd738d6d351c5f$export$7517f0d1f77dd091
    });
const $0dcd738d6d351c5f$export$ccba2c058636a09f = (error)=>({
        type: $0dcd738d6d351c5f$export$5d8d6d17a7bb9f46,
        payload: {
            error: error
        }
    });

});



parcelRegister("kkx6E", function(module, exports) {
$parcel$export(module.exports, "resetPasswordEpic", () => $d7ffa9f07347f566$export$eb399c940b1a806e);

var $8jOUp = parcelRequire("8jOUp");

var $lKHuM = parcelRequire("lKHuM");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("7dLth");
var $do9VR = parcelRequire("do9VR");

var $1vXf6 = parcelRequire("1vXf6");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");
const $d7ffa9f07347f566$export$eb399c940b1a806e = (action$)=>{
    return action$.ofType((0, $do9VR.RESET_PASSWORD)).mergeMap((resetPasswordAction)=>{
        const { emailAddress: emailAddress, password: password, token: token, resetPasswordJwt: resetPasswordJwt, createAnalyticsEvent: createAnalyticsEvent, redirectUrl: redirectUrl } = resetPasswordAction.payload;
        return (0, $lKHuM.resetPassword)({
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt
        }).map(()=>{
            return (0, $xAy39.loginAttempt)({
                password: password,
                email: emailAddress,
                continueParam: redirectUrl ?? null
            });
        }).catch((error)=>{
            if (createAnalyticsEvent && error.status === 400) {
                const event = createAnalyticsEvent({
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                    actionSubject: 'submitNewPassword',
                    action: 'failed'
                });
                (0, $jBiia.legacySendEvent)(event);
            }
            return (0, $8jOUp.Observable).of((0, $do9VR.resetPasswordFailure)((0, $1vXf6.getDefaultError)(error)));
        });
    });
};

});
parcelRegister("lKHuM", function(module, exports) {
$parcel$export(module.exports, "resetPassword", () => $fa62cc5d5420ab75$export$dc726c8e334dd814);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");
const $fa62cc5d5420ab75$export$dc726c8e334dd814 = (params)=>{
    const { emailAddress: emailAddress, password: password, resetPasswordJwt: resetPasswordJwt, token: token, context: context = (0, $eDcdn.contextPath) } = params;
    const uri = resetPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/user/resetpassword?jwt=${resetPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/user/resetpassword`;
    const body = {
        emailAddress: emailAddress,
        password: password,
        ...token.length > 0 ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $8jOUp.Observable).throw(e));
};

});

parcelRegister("7dLth", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => (parcelRequire("do9VR")).RESET_PASSWORD);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => (parcelRequire("do9VR")).RESET_PASSWORD_FAILURE);
$parcel$export(module.exports, "resetPassword", () => (parcelRequire("do9VR")).resetPassword);
$parcel$export(module.exports, "resetPasswordFailure", () => (parcelRequire("do9VR")).resetPasswordFailure);

var $do9VR = parcelRequire("do9VR");

});
parcelRegister("do9VR", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => $0c1e592ce96a2fc0$export$bf768f070251ce56);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => $0c1e592ce96a2fc0$export$682377d29726ee75);
$parcel$export(module.exports, "resetPassword", () => $0c1e592ce96a2fc0$export$dc726c8e334dd814);
$parcel$export(module.exports, "resetPasswordFailure", () => $0c1e592ce96a2fc0$export$70c45c9f946d241a);
const $0c1e592ce96a2fc0$export$bf768f070251ce56 = 'state.persisted.RESET_PASSWORD';
const $0c1e592ce96a2fc0$export$682377d29726ee75 = 'state.persisted.RESET_PASSWORD_FAILURE';
const $0c1e592ce96a2fc0$export$dc726c8e334dd814 = (emailAddress, password, token, resetPasswordJwt, createAnalyticsEvent, redirectUrl)=>({
        payload: {
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt,
            createAnalyticsEvent: createAnalyticsEvent,
            redirectUrl: redirectUrl
        },
        type: $0c1e592ce96a2fc0$export$bf768f070251ce56
    });
const $0c1e592ce96a2fc0$export$70c45c9f946d241a = (error)=>({
        payload: {
            error: error
        },
        type: $0c1e592ce96a2fc0$export$682377d29726ee75
    });

});



parcelRegister("77M2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a8ab8e5121ee7f7$export$2e2bcd8739ae039);
parcelRequire("2ycHZ");
var $4nFla = parcelRequire("4nFla");

var $iaPWO = parcelRequire("iaPWO");

var $aRYKp = parcelRequire("aRYKp");

var $19qWf = parcelRequire("19qWf");
var $2a8ab8e5121ee7f7$export$2e2bcd8739ae039 = (0, $4nFla.combineEpics)((0, $aRYKp.default), (0, $iaPWO.default), (0, $19qWf.searchEpic), (0, $19qWf.fetchSearchResultsEpic), (0, $19qWf.fetchKbSearchResultsEpic));

});
parcelRegister("iaPWO", function(module, exports) {
$parcel$export(module.exports, "context", () => $6f621cdef74a875a$export$a078c61943f9dbbe);
$parcel$export(module.exports, "default", () => $6f621cdef74a875a$export$2e2bcd8739ae039);

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("5aCJX");
var $j4AtC = parcelRequire("j4AtC");

var $eDcdn = parcelRequire("eDcdn");

var $5LmQo = parcelRequire("5LmQo");
const $6f621cdef74a875a$export$a078c61943f9dbbe = 'from-location';
const $6f621cdef74a875a$var$epic = (_, store)=>{
    return (0, $eDcdn.historyObservable).mergeMap(({ action: action })=>{
        const queryParams = $5LmQo.getAll();
        const hasQueryParams = queryParams && queryParams.hasOwnProperty && queryParams.hasOwnProperty('q');
        if (action === 'POP') {
            if (hasQueryParams) return (0, $8jOUp.Observable).of($j4AtC.search(queryParams.q, {
                context: $6f621cdef74a875a$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (action === 'PUSH') {
            if (hasQueryParams) return (0, $8jOUp.Observable).of($j4AtC.updateSearch(queryParams.q, {
                context: $6f621cdef74a875a$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (!hasQueryParams) {
            const state = store.getState();
            if (state.ui.search.shown) return (0, $8jOUp.Observable).of($j4AtC.showSearch(false, {
                context: $6f621cdef74a875a$export$a078c61943f9dbbe
            }));
            return (0, $8jOUp.Observable).empty();
        }
        return (0, $8jOUp.Observable).empty();
    });
};
var $6f621cdef74a875a$export$2e2bcd8739ae039 = $6f621cdef74a875a$var$epic;

});
parcelRegister("5aCJX", function(module, exports) {
$parcel$export(module.exports, "SEARCH", () => (parcelRequire("j4AtC")).SEARCH);
$parcel$export(module.exports, "search", () => (parcelRequire("j4AtC")).search);
$parcel$export(module.exports, "resetSearch", () => (parcelRequire("j4AtC")).resetSearch);
$parcel$export(module.exports, "RESET_SEARCH", () => (parcelRequire("j4AtC")).RESET_SEARCH);
$parcel$export(module.exports, "SHOW_SEARCH", () => (parcelRequire("j4AtC")).SHOW_SEARCH);
$parcel$export(module.exports, "showSearch", () => (parcelRequire("j4AtC")).showSearch);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => (parcelRequire("j4AtC")).CLEAR_SEARCH_RESULTS);
$parcel$export(module.exports, "clearSearchResults", () => (parcelRequire("j4AtC")).clearSearchResults);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => (parcelRequire("j4AtC")).FETCH_SEARCH_RESULTS);
$parcel$export(module.exports, "fetchSearchResultsAction", () => (parcelRequire("j4AtC")).fetchSearchResultsAction);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => (parcelRequire("j4AtC")).FETCH_KB_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => (parcelRequire("j4AtC")).UPDATE_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => (parcelRequire("j4AtC")).UPDATE_SEARCH_RESULTS_BY_TYPE);
$parcel$export(module.exports, "updateSearchResultsByType", () => (parcelRequire("j4AtC")).updateSearchResultsByType);
$parcel$export(module.exports, "UPDATE_SEARCH", () => (parcelRequire("j4AtC")).UPDATE_SEARCH);
$parcel$export(module.exports, "updateSearch", () => (parcelRequire("j4AtC")).updateSearch);

var $j4AtC = parcelRequire("j4AtC");

});
parcelRegister("j4AtC", function(module, exports) {
$parcel$export(module.exports, "SHOW_SEARCH", () => $757ccc831afe288d$export$c3d32479efe3cefd);
$parcel$export(module.exports, "SEARCH", () => $757ccc831afe288d$export$a6b9aaee40d49fd0);
$parcel$export(module.exports, "RESET_SEARCH", () => $757ccc831afe288d$export$1357260dfbbdd047);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => $757ccc831afe288d$export$51c1b519f9597fb6);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => $757ccc831afe288d$export$ada24bdba9b1de5);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => $757ccc831afe288d$export$41015fa2c6363474);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => $757ccc831afe288d$export$83fbaab84674965e);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => $757ccc831afe288d$export$e8fd6ac9f3290dd1);
$parcel$export(module.exports, "UPDATE_SEARCH", () => $757ccc831afe288d$export$e88baa2479d0f7d);
$parcel$export(module.exports, "fetchSearchResultsAction", () => $757ccc831afe288d$export$e6c9557a57e930cb);
$parcel$export(module.exports, "showSearch", () => $757ccc831afe288d$export$6a74a1717b2c4c0);
$parcel$export(module.exports, "resetSearch", () => $757ccc831afe288d$export$f4d94e8b97ed073f);
$parcel$export(module.exports, "search", () => $757ccc831afe288d$export$d76128d007d19019);
$parcel$export(module.exports, "updateSearchResultsByType", () => $757ccc831afe288d$export$d929024984f1b2ad);
$parcel$export(module.exports, "clearSearchResults", () => $757ccc831afe288d$export$20893a65977b35d3);
$parcel$export(module.exports, "updateSearch", () => $757ccc831afe288d$export$b14c90fc27f0b629);
const $757ccc831afe288d$export$c3d32479efe3cefd = 'ui.search.SHOW_SEARCH';
const $757ccc831afe288d$export$a6b9aaee40d49fd0 = 'ui.search.SEARCH';
const $757ccc831afe288d$export$1357260dfbbdd047 = 'ui.search.RESET_SEARCH';
const $757ccc831afe288d$export$51c1b519f9597fb6 = 'epic.search.FETCH_KB_SEARCH_RESULTS';
const $757ccc831afe288d$export$ada24bdba9b1de5 = 'epic.search.FETCH_SEARCH_RESULTS';
const $757ccc831afe288d$export$41015fa2c6363474 = 'ui.search.UPDATE_SEARCH_RESULTS';
const $757ccc831afe288d$export$83fbaab84674965e = 'ui.search.UPDATE_SEARCH_RESULTS_BY_TYPE';
const $757ccc831afe288d$export$e8fd6ac9f3290dd1 = 'ui.search.CLEAR_SEARCH_RESULTS';
const $757ccc831afe288d$export$e88baa2479d0f7d = 'ui.search.UPDATE_SEARCH';
const $757ccc831afe288d$export$e6c9557a57e930cb = (term, searchStartTime, meta)=>({
        payload: {
            term: term,
            searchStartTime: searchStartTime,
            meta: meta
        },
        type: $757ccc831afe288d$export$ada24bdba9b1de5
    });
const $757ccc831afe288d$export$6a74a1717b2c4c0 = (show, options = {})=>({
        payload: {
            show: show,
            ...options
        },
        type: $757ccc831afe288d$export$c3d32479efe3cefd
    });
const $757ccc831afe288d$export$f4d94e8b97ed073f = ()=>({
        type: $757ccc831afe288d$export$1357260dfbbdd047
    });
const $757ccc831afe288d$export$d76128d007d19019 = (term, { time: time = Date.now(), show: show = true, ...options } = {}, meta)=>({
        type: $757ccc831afe288d$export$a6b9aaee40d49fd0,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options,
            meta: meta
        }
    });
const $757ccc831afe288d$export$1ef413033527da6d = ({ term: term, limit: limit, expandPortal: expandPortal, meta: meta, categoryIds: categoryIds, portalIds: portalIds })=>{
    return {
        type: $757ccc831afe288d$export$51c1b519f9597fb6,
        payload: {
            term: term,
            limit: limit,
            expandPortal: expandPortal,
            categoryIds: categoryIds,
            portalIds: portalIds,
            meta: meta
        }
    };
};
//export type SearchType = 'portals' | 'requestTypes' | 'kbs';
const $757ccc831afe288d$var$searchTypes = [
    'portals',
    'requestTypes',
    'kbs'
];
const $757ccc831afe288d$export$d929024984f1b2ad = (searchResult, searchType)=>({
        searchType: searchType,
        type: $757ccc831afe288d$export$83fbaab84674965e,
        payload: searchResult
    });
const $757ccc831afe288d$export$20893a65977b35d3 = ()=>({
        type: $757ccc831afe288d$export$e8fd6ac9f3290dd1
    });
const $757ccc831afe288d$export$b14c90fc27f0b629 = (term, { time: time = Date.now(), show: show = true, ...options } = {})=>({
        type: $757ccc831afe288d$export$e88baa2479d0f7d,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options
        }
    });

});



parcelRegister("aRYKp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0967fca352d09b7$export$2e2bcd8739ae039);
parcelRequire("5aCJX");
var $j4AtC = parcelRequire("j4AtC");

var $5LmQo = parcelRequire("5LmQo");

var $iaPWO = parcelRequire("iaPWO");
const $b0967fca352d09b7$var$isValidSearchAction = (action)=>(action.type === (0, $j4AtC.SHOW_SEARCH) || action.type === (0, $j4AtC.SEARCH) || action.type === (0, $j4AtC.UPDATE_SEARCH)) && action.payload.context !== (0, $iaPWO.context);
const $b0967fca352d09b7$var$setSearchQueryParams = (term, replaceRoute = false)=>{
    $5LmQo.set({
        q: term
    }, replaceRoute);
};
const $b0967fca352d09b7$var$epic = (action$, store)=>{
    return action$.filter($b0967fca352d09b7$var$isValidSearchAction).do((action)=>{
        if ((action.type === (0, $j4AtC.SEARCH) || action.type === (0, $j4AtC.UPDATE_SEARCH)) && action.payload.show) {
            const shouldReplaceRoute = $5LmQo.get('q') !== undefined;
            $b0967fca352d09b7$var$setSearchQueryParams(action.payload.term, shouldReplaceRoute);
            return;
        }
        if (action.type === (0, $j4AtC.SHOW_SEARCH)) {
            if (action.payload.show) {
                const state = store.getState();
                if (state.ui.search.term) {
                    $b0967fca352d09b7$var$setSearchQueryParams(state.ui.search.term);
                    return;
                }
                $b0967fca352d09b7$var$setSearchQueryParams('');
                return;
            }
            $b0967fca352d09b7$var$setSearchQueryParams(undefined);
        }
    }).ignoreElements();
};
var $b0967fca352d09b7$export$2e2bcd8739ae039 = $b0967fca352d09b7$var$epic;

});

parcelRegister("19qWf", function(module, exports) {
$parcel$export(module.exports, "searchEpic", () => $c80731dae6097f70$export$54e39fbf71be6145);
$parcel$export(module.exports, "fetchSearchResultsEpic", () => $c80731dae6097f70$export$afbb5f5d68ce3b2b);
$parcel$export(module.exports, "fetchKbSearchResultsEpic", () => $c80731dae6097f70$export$afb8d00d671f0126);
/**
 * Epic for performing the search request
 */ 
var $jcRK7 = parcelRequire("jcRK7");

var $8jOUp = parcelRequire("8jOUp");
parcelRequire("5aCJX");
var $j4AtC = parcelRequire("j4AtC");

var $efzaM = parcelRequire("efzaM");
const $c80731dae6097f70$var$SEARCH_PROVIDERS = [
    (0, $efzaM.KbSearchProvider),
    (0, $efzaM.RequestTypeSearchProvider),
    (0, $efzaM.PortalSearchProvider)
];
const $c80731dae6097f70$export$54e39fbf71be6145 = (action$)=>{
    return action$.ofType((0, $j4AtC.SEARCH)).map((action)=>{
        const { meta: meta, term: query } = action.payload;
        if (!query || query.trim() === '') return (0, $j4AtC.clearSearchResults)();
        return (0, $j4AtC.fetchSearchResultsAction)(query, performance.now(), meta);
    });
};
const $c80731dae6097f70$export$afbb5f5d68ce3b2b = (action$, store)=>{
    return action$.ofType((0, $j4AtC.FETCH_SEARCH_RESULTS)).debounceTime((0, $jcRK7.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        // This cast is necessary otherwise TS doesn't know that this action can only be a FetchSearchResultsAction
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta } = action.payload;
        const observablesToWaitFor = $c80731dae6097f70$var$SEARCH_PROVIDERS.map((provider)=>provider.execute(term, state, meta));
        return (0, $8jOUp.Observable).from(observablesToWaitFor).mergeMap((observable)=>{
            return observable.map((response)=>(0, $j4AtC.updateSearchResultsByType)(response, Object.keys(response)[0]));
        });
    }).takeUntil(action$.ofType((0, $j4AtC.CLEAR_SEARCH_RESULTS))).repeat();
};
const $c80731dae6097f70$export$afb8d00d671f0126 = (action$, store)=>{
    return action$.ofType((0, $j4AtC.FETCH_KB_SEARCH_RESULTS)).debounceTime((0, $jcRK7.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta, limit: limit, expandPortal: expandPortal, categoryIds: categoryIds, portalIds: portalIds } = action.payload;
        return (0, $efzaM.KbSearchProvider).execute(term, state, meta, limit, expandPortal, categoryIds, portalIds).map((response)=>(0, $j4AtC.updateSearchResultsByType)(response, Object.keys(response)[0]));
    }).takeUntil(action$.ofType((0, $j4AtC.CLEAR_SEARCH_RESULTS))).repeat();
};

});
parcelRegister("efzaM", function(module, exports) {
$parcel$export(module.exports, "KbSearchProvider", () => $dc94261609eb2035$export$96508bc27743153d);
$parcel$export(module.exports, "RequestTypeSearchProvider", () => $dc94261609eb2035$export$836cf63ac20b672f);
$parcel$export(module.exports, "PortalSearchProvider", () => $dc94261609eb2035$export$c437cd06ecaa9215);

var $8jOUp = parcelRequire("8jOUp");

var $kbQUS = parcelRequire("kbQUS");
var $7j78z = parcelRequire("7j78z");
var $4tTHi = parcelRequire("4tTHi");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");
const $dc94261609eb2035$export$1e7a22c99c64fffc = 30;
const $dc94261609eb2035$export$96508bc27743153d = {
    execute: (query, state, meta, resultLimit, expandPortal, categoryIds, portalIds)=>{
        const DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL = 8;
        return $dc94261609eb2035$var$searchKbSuppressError(query.trim(), state, resultLimit || DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL, meta, expandPortal, categoryIds, portalIds);
    }
};
const $dc94261609eb2035$var$searchKbSuppressError = (query, state, resultLimit, meta, expandPortal, categoryIds, portalIds)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    const projectId = (0, $iWhHo.getProjectId)(state, portalId);
    if (portalId) {
        // If the portal model is available and the kb is disabled then we will not make the kb search request.
        // i.e. if there is no portal model we will still make a kb request regardless
        if ((0, $iWhHo.getIsPortalLoaded)(state, portalId) && !(0, $iWhHo.getIsKbEnabled)(state, portalId)) return (0, $8jOUp.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    } else if ((0, $hvIQS.getIsLoaded)(state) && !(0, $hvIQS.getIsKbEnabled)(state)) // We will only NOT make a KB search request if the help center is loaded and kb is disabled
    return (0, $8jOUp.Observable).of({
        kbs: {
            articles: [],
            totalSize: 0
        }
    });
    const kbsQuery = {
        categoryIds: categoryIds,
        portalIds: portalIds,
        query: query,
        projectId: projectId,
        resultLimit: resultLimit,
        expandPortalName: expandPortal
    };
    return (0, $kbQUS.searchKbs)(kbsQuery).map((response)=>{
        var _meta$analyticsSucces;
        if (meta !== null && meta !== void 0 && (_meta$analyticsSucces = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces !== void 0 && _meta$analyticsSucces.kb) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent.kb);
        return {
            kbs: response
        };
    }).catch((error)=>{
        var _meta$analyticsFailur;
        if (meta !== null && meta !== void 0 && (_meta$analyticsFailur = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur !== void 0 && _meta$analyticsFailur.kb && !(0, $h92tT.isNetworkOrClientErrorCode)(error.status)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent.kb);
        return (0, $8jOUp.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    });
};
const $dc94261609eb2035$export$836cf63ac20b672f = {
    execute: (query, state, meta)=>{
        var _performance;
        const DEFAULT_MAX_RT_RESULTS = 5;
        const requestTypeQuery = {
            query: query,
            resultLimit: DEFAULT_MAX_RT_RESULTS,
            includeRequestTypesFromOtherPortals: true,
            serviceDeskId: (0, $9Yoxp.getPortalId)(state)
        };
        const start = (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.now();
        return (0, $4tTHi.searchRequestTypes)(requestTypeQuery).map((response)=>{
            var _meta$analyticsSucces2;
            const uiAnalyticsEvent = meta === null || meta === void 0 || (_meta$analyticsSucces2 = meta.analyticsSuccessEvent) === null || _meta$analyticsSucces2 === void 0 ? void 0 : _meta$analyticsSucces2.requestType;
            uiAnalyticsEvent === null || uiAnalyticsEvent === void 0 || uiAnalyticsEvent.update((payload)=>{
                var _performance2;
                return {
                    ...payload,
                    timeTaken: ((_performance2 = performance) === null || _performance2 === void 0 ? void 0 : _performance2.now()) - start
                };
            });
            if (uiAnalyticsEvent) (0, $jBiia.legacySendEvent)(uiAnalyticsEvent);
            return {
                requestTypes: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur2;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur2 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur2 !== void 0 && _meta$analyticsFailur2.requestType && !(0, $h92tT.isNetworkOrClientErrorCode)(error.status)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent.requestType);
            return (0, $8jOUp.Observable).of({
                requestTypes: []
            });
        });
    }
};
const $dc94261609eb2035$export$c437cd06ecaa9215 = {
    execute: (query, state, meta)=>{
        const DEFAULT_MAX_PORTAL_RESULTS = 3;
        const portalQuery = {
            query: query,
            limit: DEFAULT_MAX_PORTAL_RESULTS,
            excludedPortalId: (0, $9Yoxp.getPortalId)(state)
        };
        return (0, $7j78z.searchPortals)(portalQuery).map((response)=>{
            var _meta$analyticsSucces3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsSucces3 = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces3 !== void 0 && _meta$analyticsSucces3.portal) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent.portal);
            return {
                portals: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur3 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur3 !== void 0 && _meta$analyticsFailur3.portal && !(0, $h92tT.isNetworkOrClientErrorCode)(error.status)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent.portal);
            return (0, $8jOUp.Observable).of({
                portals: []
            });
        });
    }
};

});
parcelRegister("kbQUS", function(module, exports) {
$parcel$export(module.exports, "searchKbs", () => $d6cd58e10068b58c$export$14f2b1f126d32b28);

var $llRGw = parcelRequire("llRGw");

var $fuVmc = parcelRequire("fuVmc");

var $fvUqa = parcelRequire("fvUqa");

var $fMFxk = parcelRequire("fMFxk");
const $d6cd58e10068b58c$export$14f2b1f126d32b28 = (kbsQuery)=>{
    const { projectId: projectId, query: query, resultLimit: resultLimit, expandPortalName: expandPortalName, categoryIds: categoryIds, portalIds: portalIds, labels: labels, requestTypeId: requestTypeId } = kbsQuery;
    const queryParams = {
        labels: labels,
        portalIds: portalIds,
        categoryIds: categoryIds,
        searchQuery: query,
        limit: resultLimit,
        expand: expandPortalName ? 'portal' : undefined
    };
    const queryString = $fvUqa.stringify(queryParams);
    let uri;
    const activationId = (0, $fuVmc.getMeta)('activation-id');
    if (projectId) {
        if (requestTypeId) uri = `${0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
        else uri = `${0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
    } else uri = `${0, $fMFxk.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/articles?${queryString}`;
    return (0, $llRGw.get)(uri, {
        'Content-Type': 'application/json'
    }).map((ajaxResponse)=>{
        const result = ajaxResponse.response;
        return {
            ...result,
            articles: result.articles.map((article)=>({
                    id: article.articleId,
                    name: article.articleTitle,
                    articleSnippet: article.articleSnippet,
                    pageVersion: article.articleVersion,
                    score: article.snippetScore,
                    isSmartSnippet: article.isSmartSnippet,
                    linkedPortals: article.linkedPortals,
                    sourceType: article.articleSource,
                    articleUrl: article.articleUrl
                }))
        };
    });
};

});

parcelRegister("7j78z", function(module, exports) {
$parcel$export(module.exports, "searchPortals", () => $bcc4709c6d4a3cc9$export$89b85885f9d0f13);

var $llRGw = parcelRequire("llRGw");

var $4ZMmh = parcelRequire("4ZMmh");

var $fvUqa = parcelRequire("fvUqa");

var $eDcdn = parcelRequire("eDcdn");
const $bcc4709c6d4a3cc9$export$89b85885f9d0f13 = (portalsQuery)=>{
    const sanitizedQuery = (0, $4ZMmh.pickBy)(portalsQuery, (prop)=>!(0, $4ZMmh.isNil)(prop));
    const queryString = $fvUqa.stringify(sanitizedQuery);
    return (0, $llRGw.get)(`${(0, $eDcdn.contextPath)}/rest/servicedesk/search/1/search/portals?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.portals;
    });
};

});

parcelRegister("4tTHi", function(module, exports) {
$parcel$export(module.exports, "searchRequestTypes", () => $8ce167df860a9b91$export$c3cad6e5e6fca0f1);

var $llRGw = parcelRequire("llRGw");

var $4ZMmh = parcelRequire("4ZMmh");

var $fvUqa = parcelRequire("fvUqa");

var $eDcdn = parcelRequire("eDcdn");
const $8ce167df860a9b91$export$c3cad6e5e6fca0f1 = (requestTypesQuery)=>{
    const sanitizedQuery = (0, $4ZMmh.pickBy)(requestTypesQuery, (prop)=>!(0, $4ZMmh.isNil)(prop));
    const queryString = $fvUqa.stringify(sanitizedQuery);
    return (0, $llRGw.get)(`${(0, $eDcdn.contextPath)}/rest/servicedesk/search/1/search/request-type?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.requestTypes;
    });
};

});

parcelRegister("edKNU", function(module, exports) {
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("hvIQS")).getLogoUrl);
$parcel$export(module.exports, "getSharedPortalName", () => (parcelRequire("hvIQS")).getSharedPortalName);
$parcel$export(module.exports, "getThemeColor", () => (parcelRequire("hvIQS")).getThemeColor);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("hvIQS")).getIsKbEnabled);
$parcel$export(module.exports, "getIsLoaded", () => (parcelRequire("hvIQS")).getIsLoaded);
$parcel$export(module.exports, "getHelpCenterBanner", () => (parcelRequire("hvIQS")).getHelpCenterBanner);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => (parcelRequire("hvIQS")).getHelpCenterTitleColor);
$parcel$export(module.exports, "getCanCustomize", () => (parcelRequire("hvIQS")).getCanCustomize);
$parcel$export(module.exports, "getHelpCenterState", () => (parcelRequire("hvIQS")).getHelpCenterState);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => (parcelRequire("hvIQS")).getDefaultSiteLanguageTag);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => (parcelRequire("hvIQS")).getHelpCenterStateTranslationPersisted);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => (parcelRequire("hvIQS")).getKbHelpCenterLinkDomainURLs);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => (parcelRequire("hvIQS")).getHelpCenterBrandingLoader);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => (parcelRequire("hvIQS")).getHelpCenterTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => (parcelRequire("hvIQS")).getHelpCenterPersistedTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => (parcelRequire("hvIQS")).getHelpCenterTopBarColor);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => (parcelRequire("hvIQS")).getHelpCenterTopBarTextColor);

var $hvIQS = parcelRequire("hvIQS");

});
parcelRegister("hvIQS", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterState", () => $bfc6524b00957f9a$export$85757b7e55ef3c9f);
$parcel$export(module.exports, "getLogoUrl", () => $bfc6524b00957f9a$export$976f80239b15365);
$parcel$export(module.exports, "getSharedPortalName", () => $bfc6524b00957f9a$export$bef10d4690ba4a95);
$parcel$export(module.exports, "getThemeColor", () => $bfc6524b00957f9a$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getIsLoaded", () => $bfc6524b00957f9a$export$c2ab4f36d4c3d60a);
$parcel$export(module.exports, "getIsKbEnabled", () => $bfc6524b00957f9a$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => $bfc6524b00957f9a$export$16e1b34e36aec9ef);
$parcel$export(module.exports, "getHelpCenterBanner", () => $bfc6524b00957f9a$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getCanCustomize", () => $bfc6524b00957f9a$export$eb9b5e885139dc39);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => $bfc6524b00957f9a$export$4b8ac8e47961f765);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => $bfc6524b00957f9a$export$62574aae884b522a);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => $bfc6524b00957f9a$export$76facf9cf6c06c3);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => $bfc6524b00957f9a$export$8dce832817c5aeef);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => $bfc6524b00957f9a$export$734cf776f7b0100e);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => $bfc6524b00957f9a$export$eaa9a84fffbc3381);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => $bfc6524b00957f9a$export$8b6136ed26edce36);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => $bfc6524b00957f9a$export$7a7dbec5ebf74e05);

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
const $bfc6524b00957f9a$export$85757b7e55ef3c9f = (state)=>(0, $4ZMmh.mergeWith)({}, state.persisted.helpCenter, state.ui.helpCenterPreview, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    (_, srcValue)=>{
        // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
        // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
const $bfc6524b00957f9a$var$getTranslation = (state, language)=>$bfc6524b00957f9a$export$85757b7e55ef3c9f(state).translations[language];
const $bfc6524b00957f9a$export$976f80239b15365 = (state)=>$bfc6524b00957f9a$export$85757b7e55ef3c9f(state).logoUrl;
const $bfc6524b00957f9a$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $fBLyB.getLocale)(state);
    const translation = userLocale && $bfc6524b00957f9a$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $bfc6524b00957f9a$export$e22c5d06d177c3fa = (state)=>$bfc6524b00957f9a$export$85757b7e55ef3c9f(state).themeColor;
const $bfc6524b00957f9a$export$c2ab4f36d4c3d60a = (state)=>state.persisted.helpCenter.isLoaded;
const $bfc6524b00957f9a$export$d56e4bff0fec91ad = (state)=>{
    return !!state.persisted.helpCenter.knowledgeBase;
};
const $bfc6524b00957f9a$export$f18b5fbfa1271f69 = (state)=>{
    return state.persisted.helpCenter.rawBrandingResponse;
};
const $bfc6524b00957f9a$export$16e1b34e36aec9ef = (state)=>{
    const rawBrandingResponse = $bfc6524b00957f9a$export$f18b5fbfa1271f69(state);
    return rawBrandingResponse !== undefined ? rawBrandingResponse.siteDefaultLanguageTag : undefined;
};
const $bfc6524b00957f9a$export$3b3c747bea011f3c = (state)=>$bfc6524b00957f9a$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
const $bfc6524b00957f9a$export$eb9b5e885139dc39 = (state)=>$bfc6524b00957f9a$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
const $bfc6524b00957f9a$export$899cf8c7a36d20bc = (state)=>{
    const userLocale = (0, $fBLyB.getLocale)(state);
    const translation = userLocale && $bfc6524b00957f9a$var$getTranslation(state, userLocale);
    const helpCenterTitle = translation && translation.helpCenterTitle ? translation.helpCenterTitle : $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).helpCenterTitle;
    return helpCenterTitle;
};
const $bfc6524b00957f9a$export$4b8ac8e47961f765 = (state)=>{
    return $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).helpCenterTitleColor;
};
const $bfc6524b00957f9a$export$62574aae884b522a = (state)=>{
    return $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).isBrandingLoaded;
};
const $bfc6524b00957f9a$export$76facf9cf6c06c3 = (state)=>{
    return $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).hasTopBarBeenSplit;
};
const $bfc6524b00957f9a$export$8dce832817c5aeef = (state)=>{
    var _state$persisted$help;
    return (_state$persisted$help = state.persisted.helpCenter) === null || _state$persisted$help === void 0 ? void 0 : _state$persisted$help.hasTopBarBeenSplit;
};
const $bfc6524b00957f9a$export$734cf776f7b0100e = (state)=>{
    return $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).topBarColor;
};
const $bfc6524b00957f9a$export$eaa9a84fffbc3381 = (state)=>{
    return $bfc6524b00957f9a$export$85757b7e55ef3c9f(state).topBarTextColor;
};
const $bfc6524b00957f9a$export$33a08d7ce0f06d3 = (state)=>{
    const helpCenterState = $bfc6524b00957f9a$export$85757b7e55ef3c9f(state);
    const announcementHeader = helpCenterState.announcementHeader ? helpCenterState.announcementHeader : undefined;
    const announcementMessage = helpCenterState.announcementMessage ? helpCenterState.announcementMessage : undefined;
    return {
        announcementHeader: announcementHeader,
        announcementMessage: announcementMessage
    };
};
const $bfc6524b00957f9a$export$8b6136ed26edce36 = (state)=>{
    var _state$persisted$help2;
    return ((_state$persisted$help2 = state.persisted.helpCenter) === null || _state$persisted$help2 === void 0 || (_state$persisted$help2 = _state$persisted$help2.knowledgeBase) === null || _state$persisted$help2 === void 0 ? void 0 : _state$persisted$help2.kbLinkDomainURLs) || [];
};
const $bfc6524b00957f9a$export$7a7dbec5ebf74e05 = (state)=>{
    return state.persisted.helpCenter.translations ?? {};
};

});





parcelRegister("9pfcu", function(module, exports) {
$parcel$export(module.exports, "resendValidationEmailEpic", () => $c2a038d9497d830c$export$a58a5733508cf172);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $3wcna = parcelRequire("3wcna");
parcelRequire("8eZY0");
var $hh4QA = parcelRequire("hh4QA");

var $9VXJ7 = parcelRequire("9VXJ7");
const $c2a038d9497d830c$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS = 5000;
const $c2a038d9497d830c$export$a58a5733508cf172 = (action$)=>{
    return action$.ofType((0, $hh4QA.RESEND_VALIDATION_EMAIL)).mergeMap((transitionAction)=>{
        const { email: email, portalId: portalId, redirectUrl: redirectUrl } = transitionAction.payload;
        return (0, $3wcna.resendValidationEmail)(email, portalId, redirectUrl).flatMap(()=>(0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $xb2jO.showSuccessFlag)((0, $9VXJ7.default).emailSentSuccessMessage, {
                emailAddress: email
            })), (0, $8jOUp.Observable).of((0, $hh4QA.resendValidationEmailSuccess)()), (0, $8jOUp.Observable).of((0, $hh4QA.enableResendValidationEmailLink)()).delay($c2a038d9497d830c$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS))).catch((error)=>{
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $hh4QA.resendValidationEmailFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error)), (0, $8jOUp.Observable).of((0, $hh4QA.enableResendValidationEmailLink)()));
        });
    });
};

});
parcelRegister("9VXJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $47fb85d57f24ea89$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $47fb85d57f24ea89$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    documentTitle: {
        defaultMessage: 'Verify your email',
        description: 'The text is shown as the browser document title on the email verification page, displayed in the browser tab after the user registers and is prompted to verify their email address.',
        id: 'cv.sign.up.check.email.document.title'
    },
    emailSentSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'The text is shown in a success notification after the user requests a verification email resend. The placeholder {emailAddress} will be substituted with the recipient email address.',
        id: 'cv.sign.up.check.email.resend.success.message'
    },
    checkEmailToFinishSignup: {
        defaultMessage: 'Check your email to set your password',
        description: 'The text is shown as the main heading on the sign-up email verification page, instructing the user to check their inbox to complete the password setup process.',
        id: 'cv.sign.up.check.your.email.to.signup'
    },
    emailSentHint: {
        defaultMessage: "We've sent information on how to set your password to {emailAddress}.",
        description: 'help text to explain that and email has been sent and that the user has to check his inbox',
        id: 'cv.sign.up.check.email.sub.title'
    },
    resendSignupLink: {
        defaultMessage: 'Resend password setup link',
        description: 'The text is shown on a button on the email verification page that allows the user to resend the password setup email if they did not receive it.',
        id: 'cv.sign.up.resend.signup.link.button'
    }
});

});


parcelRegister("3WITp", function(module, exports) {
$parcel$export(module.exports, "updateUserProfileEpic", () => $9cc92a8aa9dbb3b3$export$776b3daee68de137);
$parcel$export(module.exports, "validateAndSavePasswordChangeEpic", () => $9cc92a8aa9dbb3b3$export$dbb7ca6f3fcbf9c2);
$parcel$export(module.exports, "validateEpic", () => $9cc92a8aa9dbb3b3$export$4a45b80683fc2fca);
$parcel$export(module.exports, "changePasswordEpic", () => $9cc92a8aa9dbb3b3$export$2ab2d1c48dcca790);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $4pKDb = parcelRequire("4pKDb");

var $dp27t = parcelRequire("dp27t");
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");

var $1vXf6 = parcelRequire("1vXf6");

var $4Bwvp = parcelRequire("4Bwvp");

var $cQI4A = parcelRequire("cQI4A");
const $9cc92a8aa9dbb3b3$export$776b3daee68de137 = (action$)=>{
    return action$.ofType((0, $kd70W.SAVE_USER_PROFILE)).mergeMap((updateUserProfileAction)=>{
        const { displayName: displayName, language: language, timezone: timezone } = updateUserProfileAction.payload;
        const languageKey = language === undefined ? undefined : language.originalKey;
        const timezoneId = timezone === undefined ? undefined : timezone.id;
        return (0, $dp27t.updateUserProfile)(displayName, languageKey, timezoneId).flatMap(()=>(0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $kd70W.saveUserProfileSuccess)(displayName, language, timezone)), (0, $8jOUp.Observable).of((0, $xb2jO.showSuccessFlag)((0, $cQI4A.default).profileDetailsUpdatedHeaderMessage, undefined, (0, $cQI4A.default).profileDetailsUpdatedBodyMessage)))).catch((error)=>(0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $kd70W.saveUserProfileFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.handleAjaxError)(error))));
    });
};
const $9cc92a8aa9dbb3b3$export$dbb7ca6f3fcbf9c2 = (action$)=>{
    return action$.ofType((0, $kd70W.VALIDATE_AND_SAVE_PASSWORD_CHANGE)).mergeMap((validateAndSavePasswordChangeAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validateAndSavePasswordChangeAction.payload;
        const validationErrors = $9cc92a8aa9dbb3b3$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $kd70W.changePassword)(currentPassword, newPassword, confirmPassword);
        return (0, $8jOUp.Observable).of(result);
    });
};
const $9cc92a8aa9dbb3b3$export$4a45b80683fc2fca = (action$)=>{
    return action$.ofType((0, $kd70W.VALIDATE_PASSWORD)).mergeMap((validatePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validatePasswordAction.payload;
        const validationErrors = $9cc92a8aa9dbb3b3$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $kd70W.validatePasswordSuccess)();
        return (0, $8jOUp.Observable).of(result);
    });
};
const $9cc92a8aa9dbb3b3$var$validate = (currentPassword, newPassword, confirmPassword)=>{
    const currentPasswordError = !currentPassword.trim() ? (0, $cQI4A.default).currentPasswordMissingError : undefined;
    let newPasswordError = !newPassword.trim() ? (0, $cQI4A.default).newPasswordMissingError : undefined;
    let confirmPasswordError = !confirmPassword.trim() ? (0, $cQI4A.default).confirmPasswordMissingError : undefined;
    if (!newPasswordError && newPassword.length < (0, $4Bwvp.MIN_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $cQI4A.default).newPasswordTooShortError;
    if (!newPasswordError && newPassword.length > (0, $4Bwvp.MAX_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $cQI4A.default).newPasswordTooLongError;
    if (!newPasswordError && !confirmPasswordError && confirmPassword !== newPassword) confirmPasswordError = (0, $cQI4A.default).confirmPasswordDoesNotMatchError;
    if (currentPasswordError || newPasswordError || confirmPasswordError) return (0, $kd70W.changePasswordFailure)(currentPasswordError, newPasswordError, confirmPasswordError, undefined);
    return undefined;
};
const $9cc92a8aa9dbb3b3$export$2ab2d1c48dcca790 = (action$)=>{
    return action$.ofType((0, $kd70W.CHANGE_PASSWORD)).mergeMap((receivedChangePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = receivedChangePasswordAction.payload;
        return (0, $dp27t.changePassword)(currentPassword, newPassword, confirmPassword).map(()=>{
            return (0, $4pKDb.logOutAction)();
        }).catch((error)=>{
            const jiraError = (0, $1vXf6.getJiraErrorResponse)(error);
            if (jiraError) return (0, $8jOUp.Observable).of($9cc92a8aa9dbb3b3$var$getJiraErrorFailure(jiraError, error));
            return (0, $8jOUp.Observable).of($9cc92a8aa9dbb3b3$var$getGenericErrorFailure(error));
        });
    });
};
const $9cc92a8aa9dbb3b3$var$getJiraErrorFailure = (jiraError, ajaxError)=>{
    const currentError = $9cc92a8aa9dbb3b3$var$getPasswordError(jiraError, 'current');
    const newError = $9cc92a8aa9dbb3b3$var$getPasswordError(jiraError, 'password');
    const confirmError = $9cc92a8aa9dbb3b3$var$getPasswordError(jiraError, 'confirm');
    if (currentError === undefined && newError === undefined && confirmError === undefined) return $9cc92a8aa9dbb3b3$var$getGenericErrorFailure(ajaxError);
    return (0, $kd70W.changePasswordFailure)(currentError, newError, confirmError, undefined);
};
const $9cc92a8aa9dbb3b3$var$getPasswordError = (error, field)=>{
    return error.errors.filter((e)=>e.field === field).map((e)=>e.errorMessage)[0];
};
const $9cc92a8aa9dbb3b3$var$getGenericErrorFailure = (error)=>{
    return (0, $kd70W.changePasswordFailure)(undefined, undefined, undefined, (0, $1vXf6.getDefaultError)(error));
};

});
parcelRegister("4Bwvp", function(module, exports) {
$parcel$export(module.exports, "MAX_FULL_NAME_LENGTH_IN_CHARS", () => $9beab17c10e87a39$export$abf6aa48eca27616);
$parcel$export(module.exports, "MAX_PASSWORD_LENGTH_IN_CHARS", () => $9beab17c10e87a39$export$778010a9ee5e9c9b);
$parcel$export(module.exports, "MIN_PASSWORD_LENGTH_IN_CHARS", () => $9beab17c10e87a39$export$5dbee9b10a861405);
$parcel$export(module.exports, "validateAll", () => $9beab17c10e87a39$export$d1393b0ce6100c11);
$parcel$export(module.exports, "validateFullName", () => $9beab17c10e87a39$export$8369f6c309ebe358);
$parcel$export(module.exports, "validatePassword", () => $9beab17c10e87a39$export$4d2a7159fda5dc93);

var $1ZYMt = parcelRequire("1ZYMt");
const $9beab17c10e87a39$export$abf6aa48eca27616 = 255;
const $9beab17c10e87a39$export$778010a9ee5e9c9b = 72;
const $9beab17c10e87a39$export$5dbee9b10a861405 = 8;
function $9beab17c10e87a39$export$d1393b0ce6100c11(fullName, password) {
    const fullNameError = $9beab17c10e87a39$export$8369f6c309ebe358(fullName);
    const passwordError = $9beab17c10e87a39$export$4d2a7159fda5dc93(password);
    if (fullNameError || passwordError) return {
        fullNameError: fullNameError,
        passwordError: passwordError
    };
    return undefined;
}
function $9beab17c10e87a39$export$8369f6c309ebe358(fullName) {
    const trimmedFullName = fullName.trim();
    if (trimmedFullName.length === 0) return (0, $1ZYMt.default).fullNameMissingError;
    if (trimmedFullName.length > $9beab17c10e87a39$export$abf6aa48eca27616) return (0, $1ZYMt.default).fullNameTooLongError;
    return undefined;
}
function $9beab17c10e87a39$export$4d2a7159fda5dc93(password) {
    if (password.trim().length === 0) return (0, $1ZYMt.default).passwordMissingError;
    if (password.length < $9beab17c10e87a39$export$5dbee9b10a861405) return (0, $1ZYMt.default).passwordTooShortError;
    if (password.length > $9beab17c10e87a39$export$778010a9ee5e9c9b) return (0, $1ZYMt.default).passwordTooLongError;
    return undefined;
}

});
parcelRegister("1ZYMt", function(module, exports) {
$parcel$export(module.exports, "default", () => $00e16002941b43fe$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $00e16002941b43fe$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    fullNameMissingError: {
        defaultMessage: 'You must enter a full name',
        description: 'Error message when the full name field is blank',
        id: 'cv.sign.up.full.name.empty.error'
    },
    fullNameTooLongError: {
        defaultMessage: 'Full name must be less than 255 characters',
        description: 'Error message when the full name field value is too long',
        id: 'cv.sign.up.full.name.too.long.error'
    },
    passwordMissingError: {
        defaultMessage: 'You must enter a password',
        description: 'Error message when the password field is blank',
        id: 'cv.sign.up.password.empty.error'
    },
    passwordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.sign.up.password.too.short.error'
    },
    passwordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.sign.up.password.too.long.error.old'
    }
});

});


parcelRegister("cQI4A", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d5cec4851579015$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $4d5cec4851579015$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    currentPasswordMissingError: {
        defaultMessage: 'You must type your current password',
        description: 'error message when the current password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.current.error'
    },
    newPasswordMissingError: {
        defaultMessage: 'You must specify a new password',
        description: 'error message when the new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.new.error'
    },
    newPasswordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.user.profile.change.password.new.too.short.error'
    },
    newPasswordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.user.profile.change.password.too.new.long.error'
    },
    confirmPasswordMissingError: {
        defaultMessage: 'You must re-type the new password',
        description: 'error message when the confirm new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.error'
    },
    confirmPasswordDoesNotMatchError: {
        defaultMessage: 'Passwords do not match',
        description: 'error message when the confirmation password does not match the new password in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.mismatch.error'
    },
    profileDetailsUpdatedHeaderMessage: {
        defaultMessage: 'Profile details updated',
        description: 'message header when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.header'
    },
    profileDetailsUpdatedBodyMessage: {
        defaultMessage: 'Your changes may take up to five minutes to appear.',
        description: 'message body when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.body'
    }
});

});


parcelRegister("2Tw0k", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $9fc29fa17165a4ad$export$cb36b6e8b9a45314);

var $77dSs = parcelRequire("77dSs");
var $8jOUp = parcelRequire("8jOUp");

var $xb2jO = parcelRequire("xb2jO");

var $677lk = parcelRequire("677lk");
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");

var $1vXf6 = parcelRequire("1vXf6");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $6oJv3 = parcelRequire("6oJv3");
const $9fc29fa17165a4ad$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $kd70W.USER_PROFILE_FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, createAnalyticsEvent: createAnalyticsEvent } = forgotPasswordAction.payload;
        return (0, $677lk.forgotPassword)(resetUrl, email).flatMap(()=>{
            const successEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'sent',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            successEvent && (0, $jBiia.legacySendEvent)(successEvent);
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $kd70W.forgotPasswordSuccess)()), (0, $8jOUp.Observable).of((0, $xb2jO.showSuccessFlag)((0, $6oJv3.default).forgotPasswordSuccessFlagTitle, undefined, (0, $6oJv3.default).forgotPasswordSuccessFlagDescription, undefined, {
                emailAddress: email
            })));
        }).catch((error)=>{
            const failEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            failEvent && (0, $jBiia.legacySendEvent)(failEvent);
            const parsedError = (0, $1vXf6.getUserProfileForgotPasswordFailedError)(error);
            const errorAction = parsedError.action === undefined ? undefined : [
                parsedError.action
            ];
            return (0, $77dSs.concat)((0, $8jOUp.Observable).of((0, $kd70W.forgotPasswordFailure)()), (0, $8jOUp.Observable).of((0, $xb2jO.showErrorFlag)(parsedError.title, parsedError.description, errorAction)));
        });
    });
};

});
parcelRegister("6oJv3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2bdd641a79f1ba9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e2bdd641a79f1ba9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    forgotPasswordSuccessFlagTitle: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Message title for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.title'
    },
    forgotPasswordSuccessFlagDescription: {
        defaultMessage: "We've sent a reset password link to {emailAddress}.",
        description: 'Message descritpion for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.description'
    }
});

});



parcelRegister("fXrKb", function(module, exports) {
$parcel$export(module.exports, "getCombinedPersistedReducer", () => $e8a4f4176b36ee70$export$1e1389697ca32ad5);
$parcel$export(module.exports, "default", () => $e8a4f4176b36ee70$export$2e2bcd8739ae039);
parcelRequire("1mIIj");
var $j5nqc = parcelRequire("j5nqc");
parcelRequire("j5L7P");
var $9WNwm = parcelRequire("9WNwm");
parcelRequire("dv2xr");
var $4EIvk = parcelRequire("4EIvk");
parcelRequire("awcP9");
var $j4oHE = parcelRequire("j4oHE");
parcelRequire("aBjiz");
var $cFbVk = parcelRequire("cFbVk");
parcelRequire("hLBik");
var $lRgcF = parcelRequire("lRgcF");
parcelRequire("59x5L");
var $5QfDm = parcelRequire("5QfDm");
parcelRequire("ee9JS");
var $jpPwF = parcelRequire("jpPwF");
parcelRequire("ltIpC");
var $2OIZI = parcelRequire("2OIZI");
parcelRequire("aevvU");
var $e9tp5 = parcelRequire("e9tp5");
parcelRequire("jIKSZ");
var $h9WHh = parcelRequire("h9WHh");
parcelRequire("gddoe");
var $8Bt0o = parcelRequire("8Bt0o");
parcelRequire("2VoUC");
var $5OBOj = parcelRequire("5OBOj");
parcelRequire("aCeF0");
var $j7qO3 = parcelRequire("j7qO3");
parcelRequire("jc6qu");
var $d9qgx = parcelRequire("d9qgx");
parcelRequire("4twnN");
var $lwprd = parcelRequire("lwprd");
parcelRequire("deNjZ");
var $3zNkK = parcelRequire("3zNkK");
parcelRequire("3SKLF");
var $a3Yji = parcelRequire("a3Yji");
parcelRequire("eUBPx");
var $2O41m = parcelRequire("2O41m");
parcelRequire("iy9e5");
var $ahotB = parcelRequire("ahotB");
parcelRequire("fNiQZ");
var $2afXa = parcelRequire("2afXa");
parcelRequire("d1Rd5");
var $2GNG6 = parcelRequire("2GNG6");
parcelRequire("020gi");
var $cVheI = parcelRequire("cVheI");
parcelRequire("01co2");
var $fvTLy = parcelRequire("fvTLy");
parcelRequire("2An5Y");
var $cKIE3 = parcelRequire("cKIE3");
parcelRequire("gM8is");
var $hWLt8 = parcelRequire("hWLt8");
parcelRequire("4TeUy");
var $a0InA = parcelRequire("a0InA");
parcelRequire("1gsM6");
var $4mEe1 = parcelRequire("4mEe1");
parcelRequire("3hENx");
var $9cJv2 = parcelRequire("9cJv2");
parcelRequire("jjTJg");
var $9bdTO = parcelRequire("9bdTO");
parcelRequire("6y7Tg");
var $4yKEC = parcelRequire("4yKEC");
parcelRequire("hsr33");
var $9hypW = parcelRequire("9hypW");
parcelRequire("910Vy");
var $jy9cS = parcelRequire("jy9cS");
parcelRequire("b74tt");
var $7ZbsY = parcelRequire("7ZbsY");
parcelRequire("8pxud");
var $4EPZP = parcelRequire("4EPZP");
parcelRequire("978Rt");
var $5XmqC = parcelRequire("5XmqC");
const $e8a4f4176b36ee70$var$reducerCollection = {
    helpCenter: (0, $8Bt0o.default),
    portals: (0, $ahotB.default),
    user: (0, $jy9cS.default),
    env: (0, $2OIZI.default),
    meta: (0, $a3Yji.default),
    organisations: (0, $2O41m.default),
    requestCreate: (0, $cVheI.default),
    requestTypeSuggestion: (0, $a0InA.default),
    connectFragments: (0, $jpPwF.default),
    kbArticles: (0, $5OBOj.default),
    portalCustomisation: (0, $2afXa.portalCustomisationReducer),
    unsubscribedConfirmation: (0, $9hypW.unsubscribedConfirmationReducer),
    login: (0, $lwprd.loginReducer),
    forgotPassword: (0, $h9WHh.forgotPasswordReducer),
    // Preserve the legacy state contract while accepting Jira's stricter Redux declarations.
    // This reducer can return partial request details during creation; model that state and
    // its consumers separately rather than changing runtime behavior for hoisting (JIV-23832).
    requestDetails: (0, $fvTLy.requestDetailsReducer),
    reqSlas: (0, $hWLt8.reqSlasReducer),
    timezones: (0, $9bdTO.timezonesReducer),
    languages: (0, $j7qO3.languagesReducer),
    profileWebFragments: (0, $2GNG6.profileWebFragmentReducer),
    requestList: (0, $cKIE3.requestListReducer),
    approvalList: (0, $cFbVk.approvalListReducer),
    visitPortal: (0, $5XmqC.visitPortalReducer),
    resetPassword: (0, $4mEe1.resetPasswordReducer),
    completeSignup: (0, $5QfDm.completeSignupReducer),
    verifyEmail: (0, $4EPZP.verifyEmailReducer),
    signUp: (0, $9cJv2.signUpReducer),
    userRequestsCounts: (0, $7ZbsY.default),
    anonymousApproval: (0, $j4oHE.anonymousApprovalReducer),
    featuredAndSortedPortals: (0, $e9tp5.featuredAndSortedPortalsReducer),
    loginAnnouncements: (0, $3zNkK.loginAnnouncementsReducer),
    blockedAppsBanner: (0, $9WNwm.default),
    aiAnswerFeedbackPage: (0, $4EIvk.aiAnswerReducer),
    linkedSpaces: (0, $d9qgx.default),
    branding: (0, $lRgcF.brandingReducer),
    uiModifications: (0, $4yKEC.uiModificationsReducer)
};
const $e8a4f4176b36ee70$export$1e1389697ca32ad5 = (asyncReducers)=>(0, $j5nqc.default)({
        ...$e8a4f4176b36ee70$var$reducerCollection,
        ...asyncReducers
    });
var $e8a4f4176b36ee70$export$2e2bcd8739ae039 = (0, $j5nqc.default)($e8a4f4176b36ee70$var$reducerCollection);

});
parcelRegister("j5L7P", function(module, exports) {
$parcel$export(module.exports, "blockedAppsBannerReducer", () => (parcelRequire("9WNwm")).default);

var $9WNwm = parcelRequire("9WNwm");

});
parcelRegister("9WNwm", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsBanner", () => $b371ced0e7e52c70$export$de142fee58ebb9a8);
$parcel$export(module.exports, "mapConnectDispatchToPropsBanner", () => $b371ced0e7e52c70$export$b08e00302c3c215c);
$parcel$export(module.exports, "default", () => $b371ced0e7e52c70$export$2e2bcd8739ae039);
const $b371ced0e7e52c70$export$e872b6f4d4c58319 = 'state.persisted.blockedAppsBanner.SHOW_BANNER';
const $b371ced0e7e52c70$export$8c1102f190441ac3 = 'state.persisted.blockedAppsBanner.SHOW_CONNECT_BANNER';
const $b371ced0e7e52c70$export$c23ca0c98b7b93db = 'state.persisted.blockedAppsBanner.RESET_BANNER_STATE';
const $b371ced0e7e52c70$export$24e8a154ba80b759 = 'state.persisted.blockedAppsBanner.RESET_CONNECT_BANNER_STATE';
const $b371ced0e7e52c70$export$ad5fb8b7cdde24d7 = 'create_request';
const $b371ced0e7e52c70$export$1f3af91a079bff22 = 'csm_create_request';
const $b371ced0e7e52c70$export$e63cec9acfdad935 = 'view_request';
const $b371ced0e7e52c70$export$ac4d91f5203d82ae = 'portal';
const $b371ced0e7e52c70$var$defaultState = {
    create_request: false,
    portal: false,
    view_request: false,
    csm_create_request: false,
    connect: {
        create_request: false,
        view_request: false,
        portal: false
    }
};
const $b371ced0e7e52c70$export$4a89ccf10a725e56 = (page)=>({
        type: $b371ced0e7e52c70$export$e872b6f4d4c58319,
        payload: {
            page: page
        }
    });
const $b371ced0e7e52c70$export$cf79152bba576f84 = (page)=>({
        type: $b371ced0e7e52c70$export$8c1102f190441ac3,
        payload: {
            page: page
        }
    });
const $b371ced0e7e52c70$export$4d7eca3346df6596 = (page)=>({
        type: $b371ced0e7e52c70$export$c23ca0c98b7b93db,
        payload: {
            page: page
        }
    });
const $b371ced0e7e52c70$export$9a8e10487635d611 = (page)=>({
        type: $b371ced0e7e52c70$export$24e8a154ba80b759,
        payload: {
            page: page
        }
    });
const $b371ced0e7e52c70$export$e04d0f37424da45e = (connectPageName)=>{
    switch(connectPageName){
        case 'PORTAL':
            return $b371ced0e7e52c70$export$ac4d91f5203d82ae;
        case 'CREATE_REQUEST':
            return $b371ced0e7e52c70$export$ad5fb8b7cdde24d7;
        case 'VIEW_REQUEST':
            return $b371ced0e7e52c70$export$e63cec9acfdad935;
        default:
            return null;
    }
};
const $b371ced0e7e52c70$export$912af6a6ce89d10c = (forgePageName)=>{
    let screen;
    switch(forgePageName){
        case 'create_request':
            screen = $b371ced0e7e52c70$export$ad5fb8b7cdde24d7;
            break;
        case 'portal':
            screen = $b371ced0e7e52c70$export$ac4d91f5203d82ae;
            break;
        case 'view_request':
            screen = $b371ced0e7e52c70$export$e63cec9acfdad935;
            break;
        case 'csm_create_request':
            screen = $b371ced0e7e52c70$export$1f3af91a079bff22;
            break;
        default:
            screen = null;
    }
    return screen;
};
const $b371ced0e7e52c70$export$a1659b54bac3252a = ()=>{
    return {
        ...$b371ced0e7e52c70$var$defaultState
    };
};
const $b371ced0e7e52c70$export$de142fee58ebb9a8 = (dispatch)=>{
    return {
        showBanner: (forgePageName)=>{
            return dispatch($b371ced0e7e52c70$export$4a89ccf10a725e56($b371ced0e7e52c70$export$912af6a6ce89d10c(forgePageName)));
        },
        resetBannerState: (forgePageName)=>{
            return dispatch($b371ced0e7e52c70$export$4d7eca3346df6596($b371ced0e7e52c70$export$912af6a6ce89d10c(forgePageName)));
        }
    };
};
const $b371ced0e7e52c70$export$b08e00302c3c215c = {
    showBanner: (connectPageName)=>{
        return $b371ced0e7e52c70$export$cf79152bba576f84($b371ced0e7e52c70$export$e04d0f37424da45e(connectPageName));
    },
    resetBannerState: (connectPageName)=>{
        return $b371ced0e7e52c70$export$9a8e10487635d611($b371ced0e7e52c70$export$e04d0f37424da45e(connectPageName));
    }
};
function $b371ced0e7e52c70$export$2e2bcd8739ae039(currentState = $b371ced0e7e52c70$export$a1659b54bac3252a(), action) {
    const newState = {
        ...currentState
    };
    switch(action.type){
        case $b371ced0e7e52c70$export$e872b6f4d4c58319:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = true;
                return newState;
            }
        case $b371ced0e7e52c70$export$8c1102f190441ac3:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: true
                };
                return newState;
            }
        case $b371ced0e7e52c70$export$c23ca0c98b7b93db:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = false;
                return newState;
            }
        case $b371ced0e7e52c70$export$24e8a154ba80b759:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: false
                };
                return newState;
            }
        default:
            return currentState;
    }
}

});


parcelRegister("dv2xr", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => (parcelRequire("4EIvk")).aiAnswerReducer);

var $4EIvk = parcelRequire("4EIvk");

});
parcelRegister("4EIvk", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => $1f44def0e9b7cfde$export$2a26170741a0330c);
parcelRequire("jddwe");
var $bylfW = parcelRequire("bylfW");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $1f44def0e9b7cfde$var$defaultState = {
    feedback: '',
    issueKey: '',
    projectId: 0,
    initialError: undefined
};
const $1f44def0e9b7cfde$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.aiAnswerFeedbackPage) return initialModelState.aiAnswerFeedbackPage;
    return $1f44def0e9b7cfde$var$defaultState;
};
function $1f44def0e9b7cfde$export$2a26170741a0330c(state = $1f44def0e9b7cfde$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $bylfW.FETCH_AI_ANSWER_FEEDBACK_SUCCESS:
            return $1f44def0e9b7cfde$var$handleFetchAiAnswerFeedbackSuccess(state, action);
        case 0, $bylfW.FETCH_AI_ANSWER_FEEDBACK_FAILURE:
            return $1f44def0e9b7cfde$var$handleFetchAiAnswerFeedbackFailure(state, action);
        default:
            return state;
    }
}
function $1f44def0e9b7cfde$var$handleFetchAiAnswerFeedbackSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        feedback: response.feedback,
        issueKey: response.issueKey,
        projectId: response.projectId
    };
}
function $1f44def0e9b7cfde$var$handleFetchAiAnswerFeedbackFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("awcP9", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => (parcelRequire("j4oHE")).anonymousApprovalReducer);

var $j4oHE = parcelRequire("j4oHE");

});
parcelRegister("j4oHE", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => $8ca6fa3826f52f56$export$12846d9286d41238);

var $1btpl = parcelRequire("1btpl");
const $8ca6fa3826f52f56$var$defaultState = {
    token: '',
    requestDetailsUrl: '',
    loggedIn: false,
    initialError: undefined
};
const $8ca6fa3826f52f56$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.anonymousApproval) return initialModelState.anonymousApproval;
    return $8ca6fa3826f52f56$var$defaultState;
};
const $8ca6fa3826f52f56$export$12846d9286d41238 = (state = $8ca6fa3826f52f56$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("aBjiz", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => (parcelRequire("cFbVk")).approvalListReducer);

var $cFbVk = parcelRequire("cFbVk");

});
parcelRegister("cFbVk", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => $fd69a94fc4cbe00d$export$18397d0445d17954);
parcelRequire("gnTDP");
var $4FH4O = parcelRequire("4FH4O");

var $lFpPv = parcelRequire("lFpPv");
const $fd69a94fc4cbe00d$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    },
    portalsRequestTypes: []
};
const $fd69a94fc4cbe00d$var$defaultState = $fd69a94fc4cbe00d$var$emptyState;
function $fd69a94fc4cbe00d$export$18397d0445d17954(state = $fd69a94fc4cbe00d$var$defaultState, action) {
    switch(action.type){
        case 0, $4FH4O.FETCH_APPROVAL_LIST_SUCCESS:
            return $fd69a94fc4cbe00d$var$handleFetchApprovalListSuccess(state, action);
        default:
            return state;
    }
}
function $fd69a94fc4cbe00d$var$handleFetchApprovalListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.totalResults !== state.totalResults;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requests.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requests : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        approvalFilter: response.approvalFilterValue,
        portalId: response.portalId,
        requestTypeId: response.requestTypeId,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        nextToken: response.nextToken,
        allRows: newRows,
        pages: {
            isInitialPageLoad: false,
            [response.selectedPage]: response.requests
        },
        portalsRequestTypes: response.portalRequestTypes
    };
}
function $fd69a94fc4cbe00d$var$handleFetchApprovalListSuccess(state, action) {
    if ((0, $lFpPv.isApprovalListInfiniteScrollEnabled)()) return $fd69a94fc4cbe00d$var$handleFetchApprovalListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) return {
            ...state,
            pages: {
                ...state.pages,
                [response.selectedPage]: response.requests
            }
        };
        return {
            approvalFilter: response.approvalFilterValue,
            portalId: response.portalId,
            requestTypeId: response.requestTypeId,
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requests
            },
            portalsRequestTypes: response.portalRequestTypes
        };
    }
    return state;
}

});


parcelRegister("hLBik", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => (parcelRequire("lRgcF")).brandingReducer);

var $lRgcF = parcelRequire("lRgcF");

});
parcelRegister("lRgcF", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => $4120c65a886674e5$export$77a6a980433b33f5);

var $1btpl = parcelRequire("1btpl");
const $4120c65a886674e5$var$defaultState = {
    id: '',
    key: '',
    name: '',
    portalBaseUrl: ''
};
const $4120c65a886674e5$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.branding) return initialModelState.branding;
    return $4120c65a886674e5$var$defaultState;
};
const $4120c65a886674e5$export$77a6a980433b33f5 = (state = $4120c65a886674e5$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("59x5L", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => (parcelRequire("5QfDm")).completeSignupReducer);

var $5QfDm = parcelRequire("5QfDm");

});
parcelRegister("5QfDm", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => $b2d117797946761e$export$b5b8ee9188984cd7);
parcelRequire("9bj9n");
var $cP3WD = parcelRequire("cP3WD");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $b2d117797946761e$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: undefined,
    portalId: undefined,
    initialError: undefined
};
const $b2d117797946761e$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.completeSignup) return initialModelState.completeSignup;
    return $b2d117797946761e$var$defaultState;
};
function $b2d117797946761e$export$b5b8ee9188984cd7(state = $b2d117797946761e$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $cP3WD.FETCH_COMPLETE_SIGNUP_SUCCESS:
            return $b2d117797946761e$var$handleFetchCompleteSignupSuccess(state, action);
        case 0, $cP3WD.FETCH_COMPLETE_SIGNUP_FAILURE:
            return $b2d117797946761e$var$handleFetchCompleteSignupFailure(state, action);
        default:
            return state;
    }
}
function $b2d117797946761e$var$handleFetchCompleteSignupSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        signupToken: response.signupToken,
        emailAddress: response.emailAddress,
        validationOutcome: response.validationOutcome,
        portalId: response.portalId,
        redirectUrl: response.redirectUrl
    };
}
function $b2d117797946761e$var$handleFetchCompleteSignupFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("ee9JS", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsReducer", () => (parcelRequire("jpPwF")).default);
$parcel$export(module.exports, "generateKey", () => (parcelRequire("jpPwF")).generateKey);

var $jpPwF = parcelRequire("jpPwF");

});
parcelRegister("jpPwF", function(module, exports) {
$parcel$export(module.exports, "generateKey", () => $8ad3997ba22080b3$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "default", () => $8ad3997ba22080b3$export$2e2bcd8739ae039);
parcelRequire("1Gp5B");
var $6GUVM = parcelRequire("6GUVM");

var $1btpl = parcelRequire("1btpl");
const $8ad3997ba22080b3$export$3a7728e868aa3ebd = (portalPageName, portalId, requestTypeId, requestKey)=>`${portalPageName}_${portalId || 'none'}_${requestTypeId || 'none'}${`_${requestKey || 'none'}`}`;
const $8ad3997ba22080b3$export$a1659b54bac3252a = ()=>{
    const initialModelState = (0, $1btpl.default)();
    const { portal: portal, portalWebFragments: portalWebFragments, reqCreate: reqCreate } = initialModelState;
    const initialState = {
        HELP_CENTER_none_none: {},
        PORTAL_none_none: {},
        CREATE_REQUEST_none_none: {},
        REQUEST_DETAILS_none_none: {},
        PROFILE_none_none: {}
    };
    if (portal && portalWebFragments && reqCreate) {
        const { id: portalId } = portal;
        const { id: requestTypeId } = reqCreate;
        const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = portalWebFragments;
        const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
        return {
            ...initialState,
            [$8ad3997ba22080b3$export$3a7728e868aa3ebd('CREATE_REQUEST', Number(portalId), requestTypeId, undefined)]: {
                headerPanels: headerPanels,
                subheaderPanels: subheaderPanels,
                footerPanels: footerPanels,
                propertyPanels: propertyPanels
            }
        };
    }
    return initialState;
};
const $8ad3997ba22080b3$export$49d5fc8cba920a0 = $8ad3997ba22080b3$export$a1659b54bac3252a();
function $8ad3997ba22080b3$export$2e2bcd8739ae039(state = $8ad3997ba22080b3$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $6GUVM.FETCH_CONNECT_FRAGMENTS_SUCCESS:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey } = action.payload;
                const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = connectFragments;
                const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
                return {
                    ...state,
                    [$8ad3997ba22080b3$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        headerPanels: headerPanels,
                        subheaderPanels: subheaderPanels,
                        footerPanels: footerPanels,
                        propertyPanels: propertyPanels
                    }
                };
            }
        case 0, $6GUVM.FETCH_CONNECT_FRAGMENTS_FAILURE:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey } = action.payload;
                return {
                    ...state,
                    [$8ad3997ba22080b3$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        error: error
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("ltIpC", function(module, exports) {
$parcel$export(module.exports, "envReducer", () => (parcelRequire("2OIZI")).default);

var $2OIZI = parcelRequire("2OIZI");

});
parcelRegister("2OIZI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7814ea445738eba6$export$2e2bcd8739ae039);
parcelRequire("b8PDJ");
var $5ESvo = parcelRequire("5ESvo");

var $iW3CQ = parcelRequire("iW3CQ");
const $7814ea445738eba6$var$getStateFromEnvObject = (envObject)=>({
        headless: envObject.headless,
        wacLink: envObject.wacLink,
        xsrfToken: envObject.xsrfToken,
        baseUrl: envObject.baseUrl,
        mediaApiAppClientId: envObject.mediaApiAppClientId,
        mediaApiExternalUrl: envObject.mediaApiExternalUrl,
        serviceDeskVersion: envObject.serviceDeskVersion,
        featureFlags: envObject.featureFlags,
        contactLink: envObject.contactLink,
        anonymousEnabled: envObject.anonymousEnabled,
        fabricEmojiUrl: envObject.fabricEmojiUrl,
        jiraDisplayUrl: envObject.jiraDisplayUrl,
        helpCenterType: envObject.helpCenterType,
        featuredValues: envObject.featuredValues,
        hoistedProjectKey: envObject.hoistedProjectKey,
        hoistedProjectId: envObject.hoistedProjectId,
        customerAccountAvailabilty: envObject.customerAccountAvailabilty
    });
const $7814ea445738eba6$var$defaultState = $7814ea445738eba6$var$getStateFromEnvObject((0, $iW3CQ.getEnv)());
function $7814ea445738eba6$export$2e2bcd8739ae039(state = $7814ea445738eba6$var$defaultState, action) {
    switch(action.type){
        case 0, $5ESvo.UPDATE_ENV:
            {
                const newState = $7814ea445738eba6$var$getStateFromEnvObject(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $5ESvo.UPDATE_XSRF:
            return {
                ...state,
                xsrfToken: action.payload
            };
        default:
            return state;
    }
}

});


parcelRegister("aevvU", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("e9tp5")).featuredAndSortedPortalsReducer);

var $e9tp5 = parcelRequire("e9tp5");

});
parcelRegister("e9tp5", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $c703408f79c09249$export$be9fe934804fce97);
parcelRequire("ahGdU");
var $gmXRj = parcelRequire("gmXRj");
parcelRequire("80y9N");
var $ks6At = parcelRequire("ks6At");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $c703408f79c09249$var$FEATURED_PORTALS_LIMIT = 15;
const $c703408f79c09249$export$1c29b8ca59adcf6d = {
    portals: {},
    orderedPortalIds: [],
    sortBy: 'POPULARITY',
    limit: $c703408f79c09249$var$FEATURED_PORTALS_LIMIT,
    total: 0,
    isPortalHidingEnabled: false
};
const $c703408f79c09249$export$eb6ead3c9b4f1957 = (portals)=>{
    return portals.reduce((acc, portalSummary)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[portalSummary.id] = {
            id: portalSummary.id,
            key: portalSummary.key,
            name: portalSummary.name,
            description: portalSummary.description,
            logoUrl: portalSummary.logoUrl,
            isFeatured: 'isFeatured' in portalSummary && portalSummary.isFeatured,
            rank: 'rank' in portalSummary && portalSummary.rank,
            isPortalNotVisibleOnHelpCentre: portalSummary.isPortalNotVisibleOnHelpCentre,
            hiddenFromHomeScreen: 'hiddenFromHomeScreen' in portalSummary && portalSummary.hiddenFromHomeScreen
        };
        return acc;
    }, {});
};
const $c703408f79c09249$export$67c021876d6362b9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals) {
        const modelResponse = initialModelState.featuredAndSortedPortals;
        return {
            portals: $c703408f79c09249$export$eb6ead3c9b4f1957(modelResponse.portals),
            orderedPortalIds: modelResponse.portals.map((portal)=>portal.id),
            sortBy: modelResponse.sortBy ? modelResponse.sortBy : 'POPULARITY',
            limit: modelResponse.limit ? modelResponse.limit : $c703408f79c09249$var$FEATURED_PORTALS_LIMIT,
            total: modelResponse.total ? modelResponse.total : 0,
            isPortalHidingEnabled: modelResponse.isPortalHidingEnabled
        };
    }
    return $c703408f79c09249$export$1c29b8ca59adcf6d;
};
const $c703408f79c09249$var$defaultState = $c703408f79c09249$export$67c021876d6362b9();
/**
 * This method is to return only those portals which are not already stored
 * This ensures that the rank and isFeatured values stored in existing data will not get overridden with new data missing these values
 */ const $c703408f79c09249$var$getPortalsNotAlreadyStored = (storedPortals, portals)=>{
    return portals.filter((portal)=>!storedPortals[portal.id]);
};
const $c703408f79c09249$var$updateFeaturedPortals = (state, updatedFeaturedPortalIds, updatedOrderedPortalIds, hiddenPortalIds)=>{
    const portals = {};
    updatedOrderedPortalIds.forEach((portalId)=>{
        portals[portalId] = {
            id: portalId,
            key: state.portals[portalId].key,
            name: state.portals[portalId].name,
            description: state.portals[portalId].description,
            logoUrl: state.portals[portalId].logoUrl,
            isPortalNotVisibleOnHelpCentre: state.portals[portalId].isPortalNotVisibleOnHelpCentre,
            isFeatured: false,
            hiddenFromHomeScreen: hiddenPortalIds.includes(portalId),
            rank: -1
        };
    });
    updatedFeaturedPortalIds.forEach((portalId, index)=>{
        portals[portalId] = {
            ...portals[portalId],
            isFeatured: true,
            rank: index
        };
    });
    return portals;
};
function $c703408f79c09249$export$be9fe934804fce97(state = $c703408f79c09249$var$defaultState, action) {
    switch(action.type){
        case 0, $gmXRj.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $c703408f79c09249$var$handleFetchFeaturedAndSortedPortalsSuccess(action, state);
        case 0, $gmXRj.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $c703408f79c09249$var$handleFetchFeaturedAndSortedPortalsFailure(action, state);
        case 0, $gmXRj.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $c703408f79c09249$var$handleUpdatePortalReorderSettingsSuccess(action, state);
        default:
            return state;
    }
}
const $c703408f79c09249$var$handleFetchFeaturedAndSortedPortalsSuccess = (action, state)=>{
    const { portals: portals, sortBy: sortBy, limit: limit, total: total, isPortalHidingEnabled: isPortalHidingEnabled } = action.payload;
    /* On help seeker screen */ if (!action.requestParams.isPortalReorderingSelected) {
        /* On clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            portals: {
                ...state.portals,
                ...$c703408f79c09249$export$eb6ead3c9b4f1957($c703408f79c09249$var$getPortalsNotAlreadyStored(state.portals, portals))
            },
            orderedPortalIds: portals.map((portal)=>portal.id)
        };
        /* initial load */ return {
            ...state,
            isPortalHidingEnabled: isPortalHidingEnabled,
            portals: $c703408f79c09249$export$eb6ead3c9b4f1957(portals),
            orderedPortalIds: portals.map((portal)=>portal.id),
            sortBy: sortBy ? sortBy : 'POPULARITY',
            limit: limit ? limit : $c703408f79c09249$var$FEATURED_PORTALS_LIMIT,
            total: total ? total : 0,
            error: undefined
        };
    }
    /* On Portal reordering screen initial load */ if (!action.requestParams.sortBy) return {
        ...state,
        isPortalHidingEnabled: isPortalHidingEnabled,
        portals: $c703408f79c09249$export$eb6ead3c9b4f1957(portals),
        orderedPortalIds: portals.map((portal)=>portal.id),
        sortBy: sortBy ? sortBy : 'POPULARITY',
        limit: limit ? limit : $c703408f79c09249$var$FEATURED_PORTALS_LIMIT,
        total: total ? total : 0,
        error: undefined
    };
    return state;
};
const $c703408f79c09249$var$handleFetchFeaturedAndSortedPortalsFailure = (action, state)=>{
    const { error: error } = action.payload;
    const errorObject = {
        status: error.status,
        message: (error.errorMessages || [])[0],
        callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    /* Error in both help center and portal reordering view initial loads */ if (!action.requestParams.sortBy) return {
        ...state,
        error: errorObject
    };
    return state;
};
const $c703408f79c09249$var$handleUpdatePortalReorderSettingsSuccess = (action, state)=>{
    const { featuredPortalIds: featuredPortalIds, sortBy: sortBy, orderedPortalIds: orderedPortalIds, hiddenPortalIds: hiddenPortalIds } = action.payload;
    const portals = $c703408f79c09249$var$updateFeaturedPortals(state, featuredPortalIds, orderedPortalIds, hiddenPortalIds);
    const total = Object.values(portals).filter((portal)=>!(0, $ks6At.isHiddenPortal)(portal)).length;
    return {
        ...state,
        sortBy: sortBy,
        orderedPortalIds: orderedPortalIds,
        portals: portals,
        total: total
    };
};

});
parcelRegister("80y9N", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => (parcelRequire("ks6At")).getFeaturedPortalsInSortedOrderByRank);
$parcel$export(module.exports, "isFeaturedPortal", () => (parcelRequire("ks6At")).isFeaturedPortal);
$parcel$export(module.exports, "isHiddenPortal", () => (parcelRequire("ks6At")).isHiddenPortal);
$parcel$export(module.exports, "getPortals", () => (parcelRequire("ks6At")).getPortals);
$parcel$export(module.exports, "getSortBy", () => (parcelRequire("ks6At")).getSortBy);
$parcel$export(module.exports, "getLimit", () => (parcelRequire("ks6At")).getLimit);
$parcel$export(module.exports, "getIsDirty", () => (parcelRequire("ks6At")).getIsDirty);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => (parcelRequire("ks6At")).getIsReorderingExperienceLoading);
$parcel$export(module.exports, "getIsSortedDataLoading", () => (parcelRequire("ks6At")).getIsSortedDataLoading);
$parcel$export(module.exports, "getTotal", () => (parcelRequire("ks6At")).getTotal);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => (parcelRequire("ks6At")).getfeaturedAndSortedPortalsError);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => (parcelRequire("ks6At")).getUIFeaturedPortalIds);
$parcel$export(module.exports, "getUISortBy", () => (parcelRequire("ks6At")).getUISortBy);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => (parcelRequire("ks6At")).getUIOrderedPortalIds);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => (parcelRequire("ks6At")).getPersistedOrderedPortalIds);
$parcel$export(module.exports, "getIsSaveInProgress", () => (parcelRequire("ks6At")).getIsSaveInProgress);
$parcel$export(module.exports, "getDefaultViewLoading", () => (parcelRequire("ks6At")).getDefaultViewLoading);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => (parcelRequire("ks6At")).getIsPortalReorderingDataLoaded);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => (parcelRequire("ks6At")).getUIHiddenPortalIds);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => (parcelRequire("ks6At")).getIsPortalHidingEnabled);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => (parcelRequire("ks6At")).getTotalVisiblePortalCount);
$parcel$export(module.exports, "getAllVisiblePortals", () => (parcelRequire("ks6At")).getAllVisiblePortals);
$parcel$export(module.exports, "getDefaultViewPortals", () => (parcelRequire("ks6At")).getDefaultViewPortals);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => (parcelRequire("ks6At")).getFeaturedPortalsUI);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => (parcelRequire("ks6At")).getUnFeaturedPortalsUI);

var $ks6At = parcelRequire("ks6At");

});
parcelRegister("ks6At", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => $e2ece0f68c5f07a1$export$92cc2a471200c3dd);
$parcel$export(module.exports, "isFeaturedPortal", () => $e2ece0f68c5f07a1$export$4758cf9aa2bbe6ae);
$parcel$export(module.exports, "isHiddenPortal", () => $e2ece0f68c5f07a1$export$40fc3a80f8881250);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => $e2ece0f68c5f07a1$export$22d41892c655b6a1);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => $e2ece0f68c5f07a1$export$9d389d624d531812);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => $e2ece0f68c5f07a1$export$8bc764a453455857);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => $e2ece0f68c5f07a1$export$e907b47f94c1ad77);
$parcel$export(module.exports, "getUISortBy", () => $e2ece0f68c5f07a1$export$3d2a08be86a3576b);
$parcel$export(module.exports, "getPortals", () => $e2ece0f68c5f07a1$export$9fa4c2091a9d3b38);
$parcel$export(module.exports, "getSortBy", () => $e2ece0f68c5f07a1$export$c7052c2989e7b681);
$parcel$export(module.exports, "getLimit", () => $e2ece0f68c5f07a1$export$fb8ce379717a383d);
$parcel$export(module.exports, "getIsDirty", () => $e2ece0f68c5f07a1$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getTotal", () => $e2ece0f68c5f07a1$export$94860ac4a286a8d9);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => $e2ece0f68c5f07a1$export$9a33f9aea44dc01f);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => $e2ece0f68c5f07a1$export$8cc97acec2e1b274);
$parcel$export(module.exports, "getIsSortedDataLoading", () => $e2ece0f68c5f07a1$export$20cc91a7c763745e);
$parcel$export(module.exports, "getIsSaveInProgress", () => $e2ece0f68c5f07a1$export$3f495b2b37e734f1);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => $e2ece0f68c5f07a1$export$3e1f7fc063cfb951);
$parcel$export(module.exports, "getDefaultViewLoading", () => $e2ece0f68c5f07a1$export$2b83ab3fa69f277d);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => $e2ece0f68c5f07a1$export$6113b36bf23cc2fe);
$parcel$export(module.exports, "getAllVisiblePortals", () => $e2ece0f68c5f07a1$export$30b34a0e1d7ec1fa);
$parcel$export(module.exports, "getDefaultViewPortals", () => $e2ece0f68c5f07a1$export$35863edd27d88bac);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => $e2ece0f68c5f07a1$export$22b4f0e1072fa163);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => $e2ece0f68c5f07a1$export$2650dad54aca58e1);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => $e2ece0f68c5f07a1$export$2834f451d5fc36b1);

var $BOq7h = parcelRequire("BOq7h");

var $hCnLH = parcelRequire("hCnLH");
const $e2ece0f68c5f07a1$var$MAX_PORTAL_CARDS = 9;
const $e2ece0f68c5f07a1$var$getPersistedPortals = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $e2ece0f68c5f07a1$var$nanToZero = (rank)=>rank || 0;
const $e2ece0f68c5f07a1$export$92cc2a471200c3dd = (portals)=>{
    return Object.values(portals).filter((portal)=>$e2ece0f68c5f07a1$export$4758cf9aa2bbe6ae(portal)).sort((portal1, portal2)=>$e2ece0f68c5f07a1$var$nanToZero(portal1.rank) - $e2ece0f68c5f07a1$var$nanToZero(portal2.rank));
};
const $e2ece0f68c5f07a1$export$4758cf9aa2bbe6ae = (portal)=>'isFeatured' in portal && portal.isFeatured;
const $e2ece0f68c5f07a1$export$40fc3a80f8881250 = (portal)=>'hiddenFromHomeScreen' in portal && !!portal.hiddenFromHomeScreen;
const $e2ece0f68c5f07a1$export$50625c10d80bbff6 = (portal)=>'isFeatured' in portal && !portal.isFeatured;
const $e2ece0f68c5f07a1$export$22d41892c655b6a1 = (state)=>{
    return state.persisted.featuredAndSortedPortals.orderedPortalIds;
};
const $e2ece0f68c5f07a1$export$9d389d624d531812 = (state)=>{
    return state.ui.featuredAndSortedPortals.featuredPortalIds;
};
const $e2ece0f68c5f07a1$export$8bc764a453455857 = (state)=>{
    return state.ui.featuredAndSortedPortals.hiddenPortalIds;
};
const $e2ece0f68c5f07a1$export$e907b47f94c1ad77 = (state)=>{
    return state.ui.featuredAndSortedPortals.orderedPortalIds;
};
const $e2ece0f68c5f07a1$export$3d2a08be86a3576b = (state)=>{
    return state.ui.featuredAndSortedPortals.sortBy;
};
const $e2ece0f68c5f07a1$export$9fa4c2091a9d3b38 = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $e2ece0f68c5f07a1$export$c7052c2989e7b681 = (state)=>{
    return state.persisted.featuredAndSortedPortals.sortBy;
};
const $e2ece0f68c5f07a1$export$fb8ce379717a383d = (state)=>{
    return state.persisted.featuredAndSortedPortals.limit;
};
const $e2ece0f68c5f07a1$export$4b1964ee9ad6f220 = (state)=>{
    return state.ui.featuredAndSortedPortals.isDirty;
};
const $e2ece0f68c5f07a1$export$94860ac4a286a8d9 = (state)=>{
    return state.persisted.featuredAndSortedPortals.total;
};
const $e2ece0f68c5f07a1$export$9a33f9aea44dc01f = (state)=>{
    return state.persisted.featuredAndSortedPortals.error;
};
const $e2ece0f68c5f07a1$export$8cc97acec2e1b274 = (state)=>{
    return state.ui.featuredAndSortedPortals.isReorderingExperienceLoading;
};
const $e2ece0f68c5f07a1$export$20cc91a7c763745e = (state)=>{
    return state.ui.featuredAndSortedPortals.isSortedDataLoading;
};
const $e2ece0f68c5f07a1$export$3f495b2b37e734f1 = (state)=>{
    return state.ui.featuredAndSortedPortals.isSaveInProgress;
};
const $e2ece0f68c5f07a1$export$3e1f7fc063cfb951 = (state)=>{
    return state.ui.featuredAndSortedPortals.isPortalReorderingDataLoaded;
};
const $e2ece0f68c5f07a1$export$2b83ab3fa69f277d = (state)=>{
    return state.ui.featuredAndSortedPortals.isDefaultViewLoading;
};
const $e2ece0f68c5f07a1$export$2cff399032fd66c7 = (state)=>{
    return state.ui.featuredAndSortedPortals.isExpandedViewLoading;
};
const $e2ece0f68c5f07a1$export$6113b36bf23cc2fe = (state)=>{
    return state.persisted.featuredAndSortedPortals.isPortalHidingEnabled;
};
const $e2ece0f68c5f07a1$export$30b34a0e1d7ec1fa = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, (persistedPortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return Object.values(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre);
});
const $e2ece0f68c5f07a1$export$731766e21e298d5 = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$export$30b34a0e1d7ec1fa, (allVisiblePortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.values(allVisiblePortals).filter((portal)=>!$e2ece0f68c5f07a1$export$40fc3a80f8881250(portal));
});
const $e2ece0f68c5f07a1$export$35863edd27d88bac = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    const featuredPortals = $e2ece0f68c5f07a1$export$92cc2a471200c3dd(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).filter((portal)=>!$e2ece0f68c5f07a1$export$40fc3a80f8881250(portal));
    if (featuredPortals.length > 0) return featuredPortals;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$e2ece0f68c5f07a1$export$40fc3a80f8881250(portal)).slice(0, Math.min(persistedOrderedPortalIds.length, $e2ece0f68c5f07a1$var$MAX_PORTAL_CARDS));
});
const $e2ece0f68c5f07a1$export$22b4f0e1072fa163 = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)()) return persistedOrderedPortalIds.length;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).length;
});
const $e2ece0f68c5f07a1$export$7a3c1f03fc45a503 = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>{
        var _persistedPortals$por;
        return !((_persistedPortals$por = persistedPortals[portalId]) !== null && _persistedPortals$por !== void 0 && _persistedPortals$por.isPortalNotVisibleOnHelpCentre);
    }).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$e2ece0f68c5f07a1$export$40fc3a80f8881250(portal)).length;
});
const $e2ece0f68c5f07a1$export$7574c566fd98dead = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$35863edd27d88bac, $e2ece0f68c5f07a1$export$22d41892c655b6a1, (persistedPortals, defaultViewPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>!defaultViewPortals.some((defaultViewPortal)=>portalId === defaultViewPortal.id) && !persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$e2ece0f68c5f07a1$export$40fc3a80f8881250(portal));
});
const $e2ece0f68c5f07a1$export$bf663b849d73b99a = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, (persistedPortals)=>{
    return $e2ece0f68c5f07a1$export$92cc2a471200c3dd(persistedPortals);
});
const $e2ece0f68c5f07a1$export$e666136461a3c9a3 = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$export$bf663b849d73b99a, (featuredPortals)=>{
    return featuredPortals.filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).length;
});
const $e2ece0f68c5f07a1$export$2706ef7f7cb3a94c = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.map((portalId)=>persistedPortals[portalId]).filter($e2ece0f68c5f07a1$export$50625c10d80bbff6);
});
const $e2ece0f68c5f07a1$export$2650dad54aca58e1 = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$export$9d389d624d531812, $e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$8bc764a453455857, (uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiFeaturedPortalIds.map((portalId)=>{
        const portal = persistedPortals[portalId];
        return {
            ...portal,
            isFeatured: true,
            rank: $e2ece0f68c5f07a1$export$4758cf9aa2bbe6ae(portal) ? portal.rank : -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        };
    });
});
const $e2ece0f68c5f07a1$export$2834f451d5fc36b1 = (0, $BOq7h.createSelector)($e2ece0f68c5f07a1$export$e907b47f94c1ad77, $e2ece0f68c5f07a1$export$9d389d624d531812, $e2ece0f68c5f07a1$var$getPersistedPortals, $e2ece0f68c5f07a1$export$8bc764a453455857, (uiOrderedPortalIds, uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiOrderedPortalIds.filter((portalId)=>!uiFeaturedPortalIds.includes(portalId)).map((portalId)=>({
            ...persistedPortals[portalId],
            isFeatured: false,
            rank: -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        }));
});

});




parcelRegister("jIKSZ", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => (parcelRequire("h9WHh")).forgotPasswordReducer);

var $h9WHh = parcelRequire("h9WHh");

});
parcelRegister("h9WHh", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => $4a7b267f174b023d$export$545b1c441fc64b70);

var $dSuNn = parcelRequire("dSuNn");
parcelRequire("5MEXK");
var $bfKnT = parcelRequire("bfKnT");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $4a7b267f174b023d$export$4ad260a5db9e01cf = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.forgotPassword) return {
        forgotPassword: initialModelState.forgotPassword
    };
    return {};
};
const $4a7b267f174b023d$var$defaultState = $4a7b267f174b023d$export$4ad260a5db9e01cf();
function $4a7b267f174b023d$export$545b1c441fc64b70(state = $4a7b267f174b023d$var$defaultState, action) {
    switch(action.type){
        case 0, $dSuNn.FETCH_FORGOT_PASSWORD_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $bfKnT.FETCH_FORGOT_PASSWORD_FAILURE:
            {
                const fetchForgotPasswordFailureAction = action;
                const { error: error } = fetchForgotPasswordFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $bfKnT.FETCH_FORGOT_PASSWORD_SUCCESS:
            {
                const fetchPForgotPasswordSuccessAction = action;
                const response = fetchPForgotPasswordSuccessAction.payload;
                return {
                    forgotPassword: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("gddoe", function(module, exports) {
$parcel$export(module.exports, "helpcenterReducer", () => (parcelRequire("8Bt0o")).default);

var $8Bt0o = parcelRequire("8Bt0o");

});
parcelRegister("8Bt0o", function(module, exports) {
$parcel$export(module.exports, "default", () => $af05d794975134c4$export$2e2bcd8739ae039);

var $lFpPv = parcelRequire("lFpPv");

var $d60Lc = parcelRequire("d60Lc");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("bFWGU");
var $dhHUc = parcelRequire("dhHUc");

var $hCnLH = parcelRequire("hCnLH");

var $hCnLH = parcelRequire("hCnLH");

var $1btpl = parcelRequire("1btpl");
function $af05d794975134c4$var$reduceHCBrandingToState(helpCenterBrandingResponse) {
    const translationState = (0, $4ZMmh.mapValues)(helpCenterBrandingResponse.translations, (translation)=>({
            ...translation
        }));
    const isAdvancedHelpCenterThemingEnabled = (0, $lFpPv.isCustomThemingEnabled)() && ((0, $hCnLH.isAdvancedHelpCenter)() || (0, $hCnLH.isDefaultHelpCenter)());
    const portalThemeColor = helpCenterBrandingResponse.portalThemeColor || '#0074e0';
    return {
        logoUrl: helpCenterBrandingResponse.logoUrl,
        logoMediaApiFileId: helpCenterBrandingResponse.logoId,
        sharedPortalName: helpCenterBrandingResponse.sharedPortalName,
        translations: translationState,
        helpCenterBannerUrl: helpCenterBrandingResponse.useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($d60Lc))) : helpCenterBrandingResponse.bannerMediaApiUrl,
        bannerMediaApiFileId: helpCenterBrandingResponse.bannerMediaApiFileId,
        canCustomizeHelpCenter: !!helpCenterBrandingResponse.canEditAnnouncement,
        helpCenterTitle: helpCenterBrandingResponse.helpCenterTitle,
        helpCenterTitleColor: helpCenterBrandingResponse.helpCenterTitleColor,
        ...(0, $lFpPv.isUseHelpCenterRefresh)() ? {
            topBarColor: helpCenterBrandingResponse.topBarColor || portalThemeColor,
            topBarTextColor: helpCenterBrandingResponse.topBarTextColor || helpCenterBrandingResponse.helpCenterTitleColor,
            hasTopBarBeenSplit: helpCenterBrandingResponse.hasTopBarBeenSplit ?? false
        } : {},
        rawBrandingResponse: helpCenterBrandingResponse,
        announcementHeader: helpCenterBrandingResponse.userInitialAnnouncementHeader,
        announcementMessage: helpCenterBrandingResponse.userInitialAnnouncementMessageWiki,
        useDefaultBanner: helpCenterBrandingResponse.useDefaultBanner,
        isLoaded: true,
        ...isAdvancedHelpCenterThemingEnabled ? {} : {
            themeColor: portalThemeColor
        }
    };
}
function $af05d794975134c4$var$reduceHelpCenterToState(helpCenterResponse) {
    const newState = helpCenterResponse.kbs && helpCenterResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            appLinkUrl: helpCenterResponse.kbs.appLinkUrl,
            kbLinkDomainURLs: helpCenterResponse.kbs.kbLinkDomainURLs
        }
    } : {};
    return {
        ...newState,
        isLoaded: true
    };
}
const $af05d794975134c4$var$getInitialBrandingState = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.helpCenterBranding) return $af05d794975134c4$var$reduceHCBrandingToState(initialModelState.helpCenterBranding);
    return undefined;
};
const $af05d794975134c4$var$getInitialHelpCenterState = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.sharedPortal) return $af05d794975134c4$var$reduceHelpCenterToState(initialModelState.sharedPortal);
    return undefined;
};
const $af05d794975134c4$var$getInitialIsBrandingLoadedFlag = ()=>{
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)()) {
        const initialModelState = (0, $1btpl.default)();
        if (initialModelState && initialModelState.helpCenterBranding) return true;
    }
    return false;
};
const $af05d794975134c4$var$getDefaultState = ()=>({
        sharedPortalName: '',
        helpCenterTitle: '',
        helpCenterTitleColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarTextColor: '#0D1424',
        // do not tokenize as of now (this might fail on the polished methods)
        translations: {
            'en-US': {
                sharedPortalName: '',
                helpCenterTitle: '',
                localeDisplayName: ''
            }
        },
        canCustomizeHelpCenter: false,
        isLoaded: false,
        themeColor: '#0052CC',
        // do not tokenize as of now (this will fail on the polished methods)
        useDefaultBanner: true,
        ...$af05d794975134c4$var$getInitialHelpCenterState(),
        ...$af05d794975134c4$var$getInitialBrandingState(),
        isBrandingLoaded: $af05d794975134c4$var$getInitialIsBrandingLoadedFlag()
    });
function $af05d794975134c4$export$2e2bcd8739ae039(state = $af05d794975134c4$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $dhHUc.UPDATE_HELP_CENTER_THEME_COLOR:
            return {
                ...state,
                ...action.payload
            };
        case 0, $dhHUc.UPDATE_HELP_CENTER_MODEL:
            {
                const newState = $af05d794975134c4$var$reduceHelpCenterToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $dhHUc.UPDATE_HELP_CENTER_BRANDING_MODEL:
            {
                const newState = $af05d794975134c4$var$reduceHCBrandingToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $dhHUc.UPDATE_HELP_CENTER_BRANDING_LOADER:
            return {
                ...state,
                isBrandingLoaded: action.payload.loaded
            };
        default:
            return state;
    }
}

});
parcelRegister("d60Lc", function(module, exports) {
module.exports = new URL("../images/default-banner.8e21c182.png", import.meta.url).toString();

});



parcelRegister("2VoUC", function(module, exports) {
$parcel$export(module.exports, "articlesReducer", () => (parcelRequire("5OBOj")).default);

var $5OBOj = parcelRequire("5OBOj");

});
parcelRegister("5OBOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $de97a6eb97c9f579$export$2e2bcd8739ae039);

var $dWiWC = parcelRequire("dWiWC");
parcelRequire("hpavy");
var $kSHuF = parcelRequire("kSHuF");

var $8CcW6 = parcelRequire("8CcW6");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $de97a6eb97c9f579$var$reduceArticle = (article)=>({
        editUrl: '',
        id: `${article.id}`,
        isFeatured: false,
        friendlyLastModified: '',
        lastModified: '',
        shareUrl: '',
        summaryExcerpt: '',
        title: article.title,
        titleExcerpt: article.title,
        viewCount: -1,
        viewUrl: article.url,
        projects: article.projects,
        space: article.space,
        hostname: article.hostname
    });
const $de97a6eb97c9f579$var$getArticleId = (article)=>article.idInString;
const $de97a6eb97c9f579$var$getInitialState = ()=>{
    const models = (0, $1btpl.default)();
    return {
        articles: {},
        legacyArticles: models.kbPage ? {
            [$de97a6eb97c9f579$var$getArticleId(models.kbPage)]: $de97a6eb97c9f579$var$reduceArticle(models.kbPage)
        } : {}
    };
};
const $de97a6eb97c9f579$var$defaultState = $de97a6eb97c9f579$var$getInitialState();
function $de97a6eb97c9f579$export$2e2bcd8739ae039(state = $de97a6eb97c9f579$var$defaultState, action) {
    switch(action.type){
        case 0, $dWiWC.FETCH_ARTICLES:
            {
                const { categoryId: categoryId } = action.payload;
                if (state.articles[categoryId] && 'error' in state.articles[categoryId]) {
                    const newState = {
                        ...state,
                        articles: {
                            ...state.articles
                        }
                    };
                    delete newState.articles[categoryId];
                    return newState;
                }
                return state;
            }
        case 0, $8CcW6.FETCH_ARTICLES_SUCCESS:
            {
                const { categoryId: categoryId, response: { results: articles } } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: articles.map(({ featuredInCategories: featuredInCategories, ...article })=>({
                                    ...article,
                                    isFeatured: !!featuredInCategories && featuredInCategories.includes(categoryId)
                                }))
                        }
                    }
                };
            }
        case 0, $8CcW6.FETCH_ARTICLES_FAILURE:
            {
                const { portalId: portalId, categoryId: categoryId, error: apolloError } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: [],
                            error: {
                                error: {
                                    status: apolloError.statusCode,
                                    message: apolloError.errorMessage,
                                    callToActionText: 'Go back',
                                    callToActionUrl: `/portal/${portalId}`
                                }
                            }
                        }
                    }
                };
            }
        case 0, $kSHuF.FETCH_ARTICLE:
            {
                const { id: id } = action.payload.params;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $kSHuF.FETCH_ARTICLE_SUCCESS:
            {
                const articleId = action.payload.idInString;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [articleId]: $de97a6eb97c9f579$var$reduceArticle(action.payload)
                    }
                };
            }
        case 0, $kSHuF.FETCH_ARTICLE_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [action.payload.id]: {
                            error: {
                                // We really only care about the first error message
                                // grab it and throw the rest away
                                status: error.status,
                                message: (error.errorMessages || [])[0],
                                // Remove basename from the URL, we don't need it as the basename
                                // is already set inside react router.
                                // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                                callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                                callToActionText: error.nextActionDisplayText || ''
                            }
                        }
                    }
                };
            }
        case 0, $kSHuF.FETCH_CROSS_SITE_ARTICLE:
            {
                const { articleId: id } = action.payload;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        default:
            return state;
    }
}

});


parcelRegister("aCeF0", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => (parcelRequire("j7qO3")).languagesReducer);

var $j7qO3 = parcelRequire("j7qO3");

});
parcelRegister("j7qO3", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => $7b967562f12407cf$export$675c3b6bfa6435e6);
parcelRequire("gHK4P");
var $8c69X = parcelRequire("8c69X");

var $1etMn = parcelRequire("1etMn");

var $1btpl = parcelRequire("1btpl");
const $7b967562f12407cf$export$ef8b6f0b1af42002 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState) {
        const languages = initialModelState.availableLanguages === undefined ? [] : (0, $1etMn.ensureConsistentResponses)(initialModelState.availableLanguages);
        return {
            languages: languages
        };
    }
    return {
        languages: []
    };
};
const $7b967562f12407cf$var$defaultState = $7b967562f12407cf$export$ef8b6f0b1af42002();
function $7b967562f12407cf$export$675c3b6bfa6435e6(state = $7b967562f12407cf$var$defaultState, action) {
    switch(action.type){
        case 0, $8c69X.FETCH_LANGUAGES_SUCCESS:
            return $7b967562f12407cf$var$handleFetchLanguagesSuccess(state, action);
        default:
            return state;
    }
}
const $7b967562f12407cf$var$handleFetchLanguagesSuccess = (state, action)=>({
        ...state,
        languages: (0, $1etMn.ensureConsistentResponses)(action.payload.languages)
    });

});
parcelRegister("1etMn", function(module, exports) {
$parcel$export(module.exports, "ensureConsistentKey", () => $479e29f6c9bde32d$export$6117ad7803ddf800);
$parcel$export(module.exports, "ensureConsistentResponses", () => $479e29f6c9bde32d$export$131bf7a7b9860e71);
const $479e29f6c9bde32d$export$6117ad7803ddf800 = (localeKey)=>localeKey.replace('_', '-');
const $479e29f6c9bde32d$var$ensureConsistentResponse = (response)=>({
        key: $479e29f6c9bde32d$export$6117ad7803ddf800(response.key),
        originalKey: response.key,
        displayName: response.displayName
    });
const $479e29f6c9bde32d$export$131bf7a7b9860e71 = (responses)=>responses.map((response)=>$479e29f6c9bde32d$var$ensureConsistentResponse(response));

});



parcelRegister("jc6qu", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("d9qgx")).default);

var $d9qgx = parcelRequire("d9qgx");

});
parcelRegister("d9qgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $327d88209750622e$export$2e2bcd8739ae039);
parcelRequire("L0WDy");
var $kv9UF = parcelRequire("kv9UF");
const $327d88209750622e$var$defaultState = {
    linkedSpaces: [],
    hasLoaded: false
};
function $327d88209750622e$export$2e2bcd8739ae039(state = $327d88209750622e$var$defaultState, action) {
    switch(action.type){
        case 0, $kv9UF.FETCH_LINKED_SPACES:
            return {
                ...state,
                error: undefined
            };
        case 0, $kv9UF.FETCH_LINKED_SPACES_SUCCESS:
            {
                const { linkedSpaces: linkedSpaces } = action.payload;
                return {
                    ...state,
                    linkedSpaces: linkedSpaces || [],
                    hasLoaded: true,
                    error: undefined
                };
            }
        case 0, $kv9UF.FETCH_LINKED_SPACES_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    hasLoaded: true,
                    error: {
                        error: {
                            status: error.status,
                            message: error.message || 'Failed to fetch linked spaces',
                            callToActionText: '',
                            callToActionUrl: ''
                        }
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("4twnN", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => (parcelRequire("lwprd")).loginReducer);

var $lwprd = parcelRequire("lwprd");

});
parcelRegister("lwprd", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => $8f9073e98408d257$export$3d13b312f34d11e5);

var $e630u = parcelRequire("e630u");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $8f9073e98408d257$export$5b80378ff66478a5 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.login) return {
        login: initialModelState.login
    };
    return {};
};
const $8f9073e98408d257$var$defaultState = $8f9073e98408d257$export$5b80378ff66478a5();
function $8f9073e98408d257$export$3d13b312f34d11e5(state = $8f9073e98408d257$var$defaultState, action) {
    switch(action.type){
        case 0, $e630u.FETCH_LOGIN_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $xAy39.FETCH_LOGIN_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $xAy39.FETCH_LOGIN_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const response = fetchPortalSuccessAction.payload;
                return {
                    login: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("deNjZ", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("3zNkK")).loginAnnouncementsReducer);

var $3zNkK = parcelRequire("3zNkK");

});
parcelRegister("3zNkK", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $f0bc2ad542d2040b$export$14afe2784a94db4d);

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("f2i8V");
var $osBO5 = parcelRequire("osBO5");

var $1btpl = parcelRequire("1btpl");
const $f0bc2ad542d2040b$export$d383b838c87089ae = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements) return initialModelState.loginAnnouncements;
    return {
        defaultLocale: '',
        translatedLoginAnnouncements: {}
    };
};
const $f0bc2ad542d2040b$var$defaultState = $f0bc2ad542d2040b$export$d383b838c87089ae();
function $f0bc2ad542d2040b$export$14afe2784a94db4d(state = $f0bc2ad542d2040b$var$defaultState, action) {
    switch(action.type){
        case 0, $osBO5.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return action.payload;
        case 0, $osBO5.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
            {
                const { payload: payload } = action;
                if ((0, $4ZMmh.isEmpty)(payload)) return state;
                return {
                    defaultLocale: state.defaultLocale,
                    translatedLoginAnnouncements: Object.keys(payload.translatedLogInAnnouncements).reduce((acc, languageKey)=>{
                        var _state$translatedLogi;
                        return {
                            ...acc,
                            [languageKey]: {
                                header: payload.translatedLogInAnnouncements[languageKey].header,
                                message: payload.translatedLogInAnnouncements[languageKey].message,
                                localeDisplayName: (_state$translatedLogi = state.translatedLoginAnnouncements[languageKey]) === null || _state$translatedLogi === void 0 ? void 0 : _state$translatedLogi.localeDisplayName
                            }
                        };
                    }, {})
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("3SKLF", function(module, exports) {
$parcel$export(module.exports, "metaReducer", () => (parcelRequire("a3Yji")).default);

var $a3Yji = parcelRequire("a3Yji");

});
parcelRegister("a3Yji", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8846f65df829c3d$export$2e2bcd8739ae039);
parcelRequire("bYzAz");
var $dhxdT = parcelRequire("dhxdT");
const $e8846f65df829c3d$var$defaultState = {};
function $e8846f65df829c3d$export$2e2bcd8739ae039(state = $e8846f65df829c3d$var$defaultState, action) {
    if (action.type === (0, $dhxdT.UPDATE_META)) {
        const newState = action.payload;
        return {
            ...state,
            ...newState
        };
    }
    return state;
}

});
parcelRegister("bYzAz", function(module, exports) {
$parcel$export(module.exports, "updateMetaAction", () => (parcelRequire("dhxdT")).updateMetaAction);
$parcel$export(module.exports, "UPDATE_META", () => (parcelRequire("dhxdT")).UPDATE_META);

var $dhxdT = parcelRequire("dhxdT");

});
parcelRegister("dhxdT", function(module, exports) {
$parcel$export(module.exports, "UPDATE_META", () => $0093ea8e6567db30$export$7db07bf896c7e69b);
$parcel$export(module.exports, "updateMetaAction", () => $0093ea8e6567db30$export$4a183f4e7a49f459);
const $0093ea8e6567db30$export$7db07bf896c7e69b = 'state.persisted.env.UPDATE_META';
const $0093ea8e6567db30$export$4a183f4e7a49f459 = (meta)=>({
        payload: meta,
        type: $0093ea8e6567db30$export$7db07bf896c7e69b
    });

});




parcelRegister("eUBPx", function(module, exports) {
$parcel$export(module.exports, "organisationsReducer", () => (parcelRequire("2O41m")).default);

var $2O41m = parcelRequire("2O41m");

});
parcelRegister("2O41m", function(module, exports) {
$parcel$export(module.exports, "default", () => $93fdcbbba93917cf$export$2e2bcd8739ae039);
parcelRequire("hmA7a");
var $jUYjx = parcelRequire("jUYjx");

var $1btpl = parcelRequire("1btpl");
const $93fdcbbba93917cf$var$emptyState = {
    organisations: []
};
const $93fdcbbba93917cf$export$a7f9736258a0bacb = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.organisations) return {
        organisations: initialModelState.organisations.organisations
    };
    return $93fdcbbba93917cf$var$emptyState;
};
const $93fdcbbba93917cf$var$defaultState = $93fdcbbba93917cf$export$a7f9736258a0bacb();
function $93fdcbbba93917cf$export$2e2bcd8739ae039(state = $93fdcbbba93917cf$var$defaultState, action) {
    switch(action.type){
        case 0, $jUYjx.UPDATE_ORGANISATIONS_MODEL:
            {
                const organisations = action.payload.organisations.map((org)=>({
                        id: org.id,
                        name: org.name
                    }));
                const newState = {
                    organisations: organisations
                };
                return {
                    ...state,
                    ...newState
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("iy9e5", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("ahotB")).default);

var $ahotB = parcelRequire("ahotB");

});
parcelRegister("ahotB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e603af4f9999aabe$export$2e2bcd8739ae039);

var $5RxZm = parcelRequire("5RxZm");
parcelRequire("8xjib");
var $6g2X0 = parcelRequire("6g2X0");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("kY7do");
var $8BuVB = parcelRequire("8BuVB");
parcelRequire("1biTA");
var $35X2j = parcelRequire("35X2j");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $e603af4f9999aabe$var$getMediaUploadToken = (mediaApiUploadInformation)=>{
    if ('token' in mediaApiUploadInformation) return {
        clientId: mediaApiUploadInformation.clientId,
        token: mediaApiUploadInformation.token,
        endpointUrl: mediaApiUploadInformation.endpointUrl,
        targetCollection: mediaApiUploadInformation.targetCollection,
        tokenDurationInMins: mediaApiUploadInformation.tokenDurationInMins
    };
    return undefined;
};
const $e603af4f9999aabe$var$getMediaError = (mediaApiUploadInformation)=>{
    if ('error' in mediaApiUploadInformation) return mediaApiUploadInformation.error;
    return undefined;
};
function $e603af4f9999aabe$var$reducePortalResponseToState(portalResponse, oldState = {}) {
    const portalId = parseInt(portalResponse.id, 10);
    const mediaApiUploadInformation = portalResponse.mediaApiUploadInformation;
    const mediaApiUploadToken = mediaApiUploadInformation && $e603af4f9999aabe$var$getMediaUploadToken(mediaApiUploadInformation);
    const mediaApiError = mediaApiUploadInformation && $e603af4f9999aabe$var$getMediaError(mediaApiUploadInformation);
    const newSinglePortalState = {
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiError: mediaApiError,
        id: portalId,
        name: portalResponse.name,
        logoUrl: portalResponse.logoUrl,
        description: portalResponse.description,
        projectKey: portalResponse.key,
        projectId: portalResponse.projectId,
        portalAnnouncement: portalResponse.portalAnnouncement,
        isProjectSimplified: portalResponse.isProjectSimplified,
        serviceDeskId: portalResponse.serviceDeskId,
        reqGroups: [],
        reqTypes: [],
        // Omitted rather than set to undefined so existing state snapshots keep matching.
        ...portalResponse.locale !== undefined ? {
            locale: portalResponse.locale
        } : {},
        ...portalResponse.i18nTranslations !== undefined ? {
            i18nTranslations: portalResponse.i18nTranslations
        } : {}
    };
    const categoriesData = portalResponse.categories;
    const categories = categoriesData !== null && categoriesData !== void 0 && categoriesData.categoriesSupported ? categoriesData.categories : undefined;
    const kbState = portalResponse.kbs && portalResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            kbLink: portalResponse.kbs.kbLink,
            kbLinkDomainURLs: portalResponse.kbs.kbLinkDomainURLs,
            kbCategories: categories
        }
    } : {};
    // If there is KB we try to maintain the previous categories
    if (!!kbState.knowledgeBase) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingPortal = oldState[portalId];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingCategories = existingPortal && !('error' in existingPortal) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase.kbCategories;
        if (existingCategories) // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        kbState.knowledgeBase = {
            ...kbState.knowledgeBase,
            kbCategories: existingCategories
        };
    }
    const reqTypesState = portalResponse.reqTypes ? {
        reqTypes: portalResponse.reqTypes.map((reqtype)=>({
                id: reqtype.id,
                name: reqtype.name,
                // This is actually the description, not the intro.
                // The backend is wrecked.
                descriptionHtml: reqtype.introHtml,
                // This is actually the help text, not the description.
                // The backend is wrecked.
                helpTextHtml: reqtype.descriptionHtml,
                // Icon id here is required to pass backend validation of req type when removing from group
                // can remove once backend change JDW-292 is complete
                icon: reqtype.icon,
                iconUrl: reqtype.iconUrl || `${0, $eDcdn.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${reqtype.icon}`
            }))
    } : {};
    const orderMapping = portalResponse.orderMapping || {};
    const reqGroupsState = (portalResponse.reqGroups || []).map((reqGroup)=>({
            id: reqGroup.id,
            name: reqGroup.name,
            reqTypes: (orderMapping[reqGroup.id] || []).map(String)
        }));
    const { analyticsContext: analyticsContext } = portalResponse;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const oldPortalState = oldState[portalId];
    const analyticAttributesState = analyticsContext ? {
        analyticAttributes: {
            jsdRole: analyticsContext.jsdRole,
            initialProjectTemplate: analyticsContext.initialProjectTemplate,
            openAccess: analyticsContext.openAccess,
            publicSignup: analyticsContext.publicSignup,
            nextGenProject: analyticsContext.nextGenProject,
            demoProject: analyticsContext.demoProject,
            eapOptedIn: analyticsContext.eapOptedIn,
            jsdDwCohort: analyticsContext.jsdDwCohort,
            previousSupportedProjects: analyticsContext.previousSupportedProjects,
            supportedProjects: analyticsContext.supportedProjects
        }
    } : {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...oldPortalState && oldPortalState.analyticAttributes ? // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        {
            analyticAttributes: oldPortalState.analyticAttributes
        } : {}
    };
    return {
        [portalId]: {
            ...newSinglePortalState,
            ...kbState,
            ...reqTypesState,
            ...analyticAttributesState,
            reqGroups: reqGroupsState
        }
    };
}
const $e603af4f9999aabe$export$6189f5b9656c1eb4 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.portal) {
        if (initialModelState.branding) return $e603af4f9999aabe$var$reducePortalResponseToState({
            ...initialModelState.branding,
            ...initialModelState.portal
        });
        return $e603af4f9999aabe$var$reducePortalResponseToState({
            ...initialModelState.portal,
            logoUrl: undefined,
            theme: {}
        });
    }
    return {};
};
const $e603af4f9999aabe$var$defaultState = $e603af4f9999aabe$export$6189f5b9656c1eb4();
function $e603af4f9999aabe$export$2e2bcd8739ae039(state = $e603af4f9999aabe$var$defaultState, action) {
    switch(action.type){
        case 0, $jeW3I.FETCH_PORTAL_MODEL:
            {
                const fetchPortalAction = action;
                const portalId = fetchPortalAction.payload.params && fetchPortalAction.payload.params.id;
                if (portalId) {
                    const portal = state[portalId];
                    if (portal && 'error' in portal) {
                        const newState = {
                            ...state
                        };
                        delete newState[portalId];
                        return newState;
                    }
                }
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $35X2j.FETCH_REQUEST_CREATE_FAILURE:
        case 0, $jeW3I.FETCH_PORTAL_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error, portalId: portalId } = fetchPortalFailureAction.payload;
                return {
                    ...state,
                    [portalId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || '',
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders
                        }
                    }
                };
            }
        case 0, $jeW3I.FETCH_PORTAL_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                return {
                    ...state,
                    ...$e603af4f9999aabe$var$reducePortalResponseToState(fetchPortalSuccessAction.payload, state)
                };
            }
        case 0, $6g2X0.FETCH_CATEGORIES_SUCCESS:
            {
                const categoriesSuccessAction = action;
                const { portalId: portalId, categories: categories } = categoriesSuccessAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: categories
                        }
                    }
                };
            }
        case 0, $6g2X0.FETCH_CATEGORIES_FAILURE:
            {
                const categoriesFailureAction = action;
                const { portalId: portalId, error: categoryError } = categoriesFailureAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: {
                                error: {
                                    status: categoryError.statusCode,
                                    message: categoryError.errorMessage,
                                    callToActionUrl: '/portal/',
                                    callToActionText: 'Go back'
                                }
                            }
                        }
                    }
                };
            }
        case 0, $jeW3I.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
            {
                const { payload: payload } = action;
                if (!payload) return state;
                const { portalId: portalId } = payload;
                const portal = state[portalId];
                const portalAnnouncement = payload ?? portal.portalAnnouncement;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        portalAnnouncement: portalAnnouncement
                    }
                };
            }
        case 0, $5RxZm.FETCH_KB_SUGGESTIONS_SUCCESS:
            {
                const { kbArticleSuggestions: kbArticleSuggestions, portalId: portalId } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (!portal || 'error' in portal) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbArticleSuggestions: kbArticleSuggestions
                        }
                    }
                };
            }
        case 0, $8BuVB.PROFORMA_FORM_LOADED:
            {
                const { portalId: portalId, proformaFormIsLoaded: proformaFormIsLoaded } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        proformaFormIsLoaded: proformaFormIsLoaded
                    }
                };
            }
        case 0, $jeW3I.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS:
            {
                const { portalId: portalId, mediaApiUploadInformation: mediaApiUploadInformation } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (portal && !('error' in portal)) return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        mediaApiUploadToken: $e603af4f9999aabe$var$getMediaUploadToken(mediaApiUploadInformation)
                    }
                };
                return state;
            }
        default:
            return state;
    }
}

});
parcelRegister("5RxZm", function(module, exports) {
$parcel$export(module.exports, "FETCH_KB_SUGGESTIONS_SUCCESS", () => $b1dba2c640199949$export$1b2c5db514ac0bd7);
$parcel$export(module.exports, "fetchKBSuggestionsSuccessAction", () => $b1dba2c640199949$export$ce6a80dfe554c3b6);
const $b1dba2c640199949$export$1b2c5db514ac0bd7 = 'epic.model.FETCH_KB_SUGGESTIONS';
const $b1dba2c640199949$export$ce6a80dfe554c3b6 = (params)=>{
    return {
        type: $b1dba2c640199949$export$1b2c5db514ac0bd7,
        payload: params
    };
};

});

parcelRegister("kY7do", function(module, exports) {
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => (parcelRequire("8BuVB")).fetchPortalAndRequestTypesModel);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => (parcelRequire("8BuVB")).fetchPortalsAndRequestTypesSuccess);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => (parcelRequire("8BuVB")).FETCH_PORTAL_AND_REQUEST_TYPES);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => (parcelRequire("8BuVB")).FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => (parcelRequire("8BuVB")).PROFORMA_FORM_LOADED);

var $8BuVB = parcelRequire("8BuVB");

});
parcelRegister("8BuVB", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => $0be73a6cd29042c9$export$172324766a8910d6);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => $0be73a6cd29042c9$export$5f63fa3daf3ecef8);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => $0be73a6cd29042c9$export$4c0299a035f236e5);
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => $0be73a6cd29042c9$export$b4741ec41baec80b);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => $0be73a6cd29042c9$export$da57d2f9cae3a05f);

var $hn5Mq = parcelRequire("hn5Mq");
const $0be73a6cd29042c9$export$172324766a8910d6 = 'epic.model.FETCH_PORTAL_AND_REQUEST_TYPES';
const $0be73a6cd29042c9$export$5f63fa3daf3ecef8 = 'state.persisted.portals-and-request-types.FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS';
const $0be73a6cd29042c9$export$4c0299a035f236e5 = 'state.persisted.portals-and-request-types.PROFORMA_FORM_LOADED';
const $0be73a6cd29042c9$export$b4741ec41baec80b = (payload = {}, meta)=>({
        meta: meta,
        ...(0, $hn5Mq.buildModelsActionCreator)($0be73a6cd29042c9$export$172324766a8910d6, 'portalsAndRequestTypes')(payload)
    });
const $0be73a6cd29042c9$export$da57d2f9cae3a05f = (portalsAndRequestTypesModel)=>({
        payload: portalsAndRequestTypesModel,
        type: $0be73a6cd29042c9$export$5f63fa3daf3ecef8
    });

});




parcelRegister("fNiQZ", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("2afXa")).portalCustomisationReducer);

var $2afXa = parcelRequire("2afXa");

});
parcelRegister("2afXa", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => $3a6a361988960a02$export$b5745e15c8a52df8);
parcelRequire("l3hoq");
var $eB2UK = parcelRequire("eB2UK");
const $3a6a361988960a02$export$49d5fc8cba920a0 = {
    allRequestGroups: {},
    errorMessage: undefined
};
function $3a6a361988960a02$export$b5745e15c8a52df8(state = $3a6a361988960a02$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $eB2UK.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { portalId: portalId, requestGroups: requestGroups } = action.payload;
                return {
                    errorMessage: undefined,
                    allRequestGroups: {
                        ...state.allRequestGroups,
                        [portalId]: requestGroups
                    }
                };
            }
        case 0, $eB2UK.GET_ALL_REQUEST_GROUPS_FAILURE:
            {
                const { errorMessage: errorMessage } = action.payload;
                return {
                    ...state,
                    errorMessage: errorMessage
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("d1Rd5", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => (parcelRequire("2GNG6")).profileWebFragmentReducer);

var $2GNG6 = parcelRequire("2GNG6");

});
parcelRegister("2GNG6", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => $b239f82104962cd2$export$530037ab477140ce);
parcelRequire("1Gp5B");
var $6GUVM = parcelRequire("6GUVM");

var $1btpl = parcelRequire("1btpl");
const $b239f82104962cd2$export$f9c142b09e8e12af = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.profileWebFragments) return {
        ...initialModelState.profileWebFragments
    };
    return {};
};
const $b239f82104962cd2$export$49d5fc8cba920a0 = $b239f82104962cd2$export$f9c142b09e8e12af();
const $b239f82104962cd2$var$handleFetchProfileConnectFragmentsSuccess = (state, action)=>({
        ...state,
        ...action.payload.fragments
    });
const $b239f82104962cd2$var$handleFetchProfileConnectFragmentsFailure = (state, action)=>({
        ...state,
        panels: action.payload
    });
function $b239f82104962cd2$export$530037ab477140ce(state = $b239f82104962cd2$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $6GUVM.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS:
            return $b239f82104962cd2$var$handleFetchProfileConnectFragmentsSuccess(state, action);
        case 0, $6GUVM.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE:
            return $b239f82104962cd2$var$handleFetchProfileConnectFragmentsFailure(state, action);
        default:
            return state;
    }
}

});


parcelRegister("020gi", function(module, exports) {
$parcel$export(module.exports, "requestCreateReducer", () => (parcelRequire("cVheI")).default);

var $cVheI = parcelRequire("cVheI");

});
parcelRegister("cVheI", function(module, exports) {
$parcel$export(module.exports, "default", () => $795a4ca3a0a606b8$export$2e2bcd8739ae039);

var $lFpPv = parcelRequire("lFpPv");

var $axowX = parcelRequire("axowX");
parcelRequire("1biTA");
var $35X2j = parcelRequire("35X2j");

var $4EUgw = parcelRequire("4EUgw");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");

var $aYbXa = parcelRequire("aYbXa");

var $6hTxC = parcelRequire("6hTxC");
const $795a4ca3a0a606b8$var$buildStoreKey = (portalId, requestCreateId)=>`${portalId || 'undefined'}/${requestCreateId}`;
const $795a4ca3a0a606b8$var$convertHydratedFieldValuesToInitialValues = (hydratedUrlParamOverrides, fieldStates)=>{
    const fieldStateMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    return Object.fromEntries(Object.entries(hydratedUrlParamOverrides).map(([fieldId, valueOverride])=>{
        const fieldState = fieldStateMap[fieldId];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let overrideValue; // Setting this so TS can pick up the correct return value type
        if (!fieldState) {
            overrideValue = [
                fieldId,
                null
            ];
            return overrideValue;
        }
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.map((value)=>value.value)
                ];
                break;
            case 'userpicker':
            case 'reporter':
                overrideValue = [
                    fieldId,
                    valueOverride.accountId
                ];
                break;
            case 'multiuserpicker':
                {
                    const users = valueOverride;
                    overrideValue = [
                        fieldId,
                        users.map((user)=>user.accountId).join(',')
                    ];
                    break;
                }
            case 'organisationpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.id
                ];
                break;
            case 'entitlementpicker':
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
                break;
            case 'multiservicepicker':
                {
                    const services = valueOverride;
                    overrideValue = [
                        fieldId,
                        services
                    ];
                    break;
                }
            default:
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
        }
        return overrideValue;
    }).filter(([_, initialValue])=>initialValue !== null));
};
function $795a4ca3a0a606b8$var$reduceReqCreateResponseToState(reqCreateResponse) {
    var _reqCreateResponse$is, _reqCreateResponse$is2;
    const { hydratedUrlParamOverrides: hydratedUrlParamOverrides, portalId: portalId, id: requestCreateId } = reqCreateResponse;
    const storeId = $795a4ca3a0a606b8$var$buildStoreKey(portalId, requestCreateId);
    const { showRecaptcha: showRecaptcha, siteKey: siteKey, proformaTemplateForm: proformaTemplateForm, form: { name: name, intro: intro, instructions: instructions, descriptionHtml: descriptionHtml, icon: icon, iconUrl: iconUrl } } = reqCreateResponse;
    const form = {
        name: name,
        intro: intro,
        instructions: instructions,
        descriptionHtml: descriptionHtml,
        iconUrl: iconUrl || `${0, $eDcdn.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${icon}`,
        captchaEnabled: showRecaptcha,
        sitekey: siteKey
    };
    const kbState = reqCreateResponse.kbs && reqCreateResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            spaceKey: reqCreateResponse.kbs.kbLink.spaceKey,
            labels: reqCreateResponse.kbs.labels,
            projectKey: reqCreateResponse.kbs.projectKey
        }
    } : {};
    const dateFormat = (0, $6hTxC.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateIfFormat);
    const dateTimeFormat = (0, $6hTxC.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateTimeIfFormat);
    const firstDay = reqCreateResponse.calendarParams.firstDay;
    const useISO8601WeekNumbers = reqCreateResponse.calendarParams.useISO8601WeekNumbers;
    const fields = (0, $4EUgw.toFieldStates)(reqCreateResponse.fields);
    let initialFieldValues = fields.reduce((values, field)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[field.id] = field.value;
        return values;
    }, {});
    const { lastSavedFormData: lastSavedFormData } = reqCreateResponse;
    if (lastSavedFormData && lastSavedFormData.portalId === portalId && lastSavedFormData.requestId === requestCreateId) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    initialFieldValues = {
        ...initialFieldValues,
        ...lastSavedFormData.formInput
    };
    let urlParamFieldValueOverrides;
    if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)()) {
        urlParamFieldValueOverrides = hydratedUrlParamOverrides;
        if (Object.keys(hydratedUrlParamOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...$795a4ca3a0a606b8$var$convertHydratedFieldValuesToInitialValues(hydratedUrlParamOverrides, fields)
        };
    } else {
        urlParamFieldValueOverrides = (0, $axowX.parseFieldUrlParams)(fields);
        if (Object.keys(urlParamFieldValueOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...urlParamFieldValueOverrides
        };
    }
    const organisationsForCurrentUser = reqCreateResponse.userOrganisations;
    const requestCreateFormState = {
        form: form,
        fields: fields,
        initialFieldValues: initialFieldValues,
        urlParamFieldValueOverrides: urlParamFieldValueOverrides,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        organisationsForCurrentUser: organisationsForCurrentUser,
        firstDay: firstDay,
        useISO8601WeekNumbers: useISO8601WeekNumbers,
        proformaTemplateForm: proformaTemplateForm,
        id: reqCreateResponse.id,
        projectId: reqCreateResponse.projectId,
        issueType: (_reqCreateResponse$is = reqCreateResponse.issueType) === null || _reqCreateResponse$is === void 0 ? void 0 : _reqCreateResponse$is.name,
        issueTypeId: (_reqCreateResponse$is2 = reqCreateResponse.issueType) === null || _reqCreateResponse$is2 === void 0 ? void 0 : _reqCreateResponse$is2.id,
        canBrowseUsers: !!reqCreateResponse.canBrowseUsers,
        canCreateUsers: !!reqCreateResponse.canSubmitWithEmailAddress,
        projectHasProformaForms: !!reqCreateResponse.hasProformaForm,
        proforma: reqCreateResponse.proforma,
        proformaFormIsLoaded: false,
        proformaFormIsDirty: false
    };
    return {
        [storeId]: {
            ...requestCreateFormState,
            ...kbState,
            initialFieldValues: initialFieldValues
        }
    };
}
const $795a4ca3a0a606b8$export$f7e14415d5a64cdc = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.reqCreate) {
        const portalId = (0, $aYbXa.toNumber)(initialModelState.portal && initialModelState.portal.id);
        const initialState = $795a4ca3a0a606b8$var$reduceReqCreateResponseToState({
            portalId: portalId,
            ...initialModelState.reqCreate,
            hydratedUrlParamOverrides: {}
        });
        // When the jsm_portal_rovo_integration flag is on, pre-fill logic runs in the epic
        // asynchronously. If URL params are present for any field, we need to delay rendering
        // the form until the epic resolves and dispatches FETCH_REQUEST_CREATE_SUCCESS with the
        // hydrated values. Without this, Formik initialises with empty values before the epic
        // completes, and the pre-fill data has no effect.
        if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)()) {
            const storeKey = $795a4ca3a0a606b8$var$buildStoreKey(portalId, initialModelState.reqCreate.id);
            const formState = initialState[storeKey];
            if (formState) {
                const urlParamOverrides = (0, $axowX.parseFieldUrlParams)(formState.fields);
                if (Object.keys(urlParamOverrides).length > 0) return {
                    [storeKey]: {
                        ...formState,
                        prefillPending: true
                    }
                };
            }
        }
        return initialState;
    }
    return {};
};
const $795a4ca3a0a606b8$var$defaultState = $795a4ca3a0a606b8$export$f7e14415d5a64cdc();
function $795a4ca3a0a606b8$export$2e2bcd8739ae039(state = $795a4ca3a0a606b8$var$defaultState, action) {
    switch(action.type){
        case 0, $35X2j.FETCH_REQUEST_CREATE_MODEL:
            {
                const requestCreateId = action.payload.params && action.payload.params.id;
                const portalId = action.payload.params && action.payload.params.portalId;
                if (requestCreateId && portalId) {
                    const storeId = $795a4ca3a0a606b8$var$buildStoreKey(portalId, requestCreateId);
                    const requestCreate = state[storeId];
                    if (requestCreate && 'error' in requestCreate) {
                        const newState = {
                            ...state
                        };
                        delete newState[storeId];
                        return newState;
                    }
                }
                return state;
            }
        case 0, $35X2j.FETCH_REQUEST_CREATE_FAILURE:
            {
                const { error: error, portalId: portalId, requestCreateId: requestCreateId } = action.payload;
                const storeId = $795a4ca3a0a606b8$var$buildStoreKey(portalId, requestCreateId);
                return {
                    ...state,
                    [storeId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders,
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || ''
                        }
                    }
                };
            }
        case 0, $35X2j.FETCH_REQUEST_CREATE_SUCCESS:
            return {
                ...state,
                ...$795a4ca3a0a606b8$var$reduceReqCreateResponseToState(action.payload)
            };
        case 0, $35X2j.PROFORMA_FORM_DIRTY:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, isDirty: isDirty } = action.payload;
                const storeId = $795a4ca3a0a606b8$var$buildStoreKey(portalId, requestTypeId);
                if (!state[storeId]) return state;
                return {
                    ...state,
                    [storeId]: {
                        ...state[storeId],
                        proformaFormIsDirty: isDirty
                    }
                };
            }
        case 0, $35X2j.RESET_REQUEST_CREATE_STATE:
            // Reset the state to the default initial state
            return $795a4ca3a0a606b8$export$f7e14415d5a64cdc();
        default:
            return state;
    }
}

});
parcelRegister("aYbXa", function(module, exports) {
$parcel$export(module.exports, "toNumber", () => $d675e35aba73833c$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "toString", () => $d675e35aba73833c$export$f84e8e69fd4488a5);
// This exists as a shorthand func to return a default value if the parsed
// string was somehow not a valid number.
const $d675e35aba73833c$export$a0a81dc3380ce7d3 = (str, defaultValue)=>{
    if (typeof str === 'number') return str;
    if (str) {
        const parsedNumber = parseInt(str, 10);
        if (!isNaN(parsedNumber)) return parsedNumber;
    }
    return defaultValue;
};
const $d675e35aba73833c$export$f84e8e69fd4488a5 = (num)=>{
    if (num) return String(num);
    return undefined;
};

});

parcelRegister("6hTxC", function(module, exports) {
$parcel$export(module.exports, "convertToDateFnsFormat", () => $82f29ecb86a2ff7c$export$e007e5b3b423e0a6);
$parcel$export(module.exports, "splitDateTimeFormat", () => $82f29ecb86a2ff7c$export$b565d8b0afadc612);
/**
 * Utility to convert a subset of the unix date time format to data-fns.
 * Date-fns format: https://date-fns.org/v2.30.0/docs/format
 * Unix date time format: http://old-www.cs.dartmouth.edu/~cs50/data/tse/wikipedia/wiki/Date_(Unix).html#Formatting
 */ /**
 * This is a mapping of all equivalent time formats between unix and date-fns.
 *
 * There are a number of commented out unix time formats, these are the unix time formats that we don't support. There are no
 * direct equivalent for any of these between unix time format and date fns. I have left the closest matching date fns time format
 * for each of these keys if there are any, or I marked it as INCOMPATIBLE if there are no date fns that even remotely matches the
 * unix time format.
 */ const $82f29ecb86a2ff7c$var$UNIX_TO_DATE_FNS_MAPPING = {
    '%a': 'iii',
    '%A': 'iiii',
    '%d': 'dd',
    '%e': 'd',
    '%j': 'DDD',
    '%u': 'i',
    // '%w': 'd',
    // '%U': 'WW',
    // '%W': 'WW',
    '%V': 'II',
    '%m': 'MM',
    '%h': 'MMM',
    '%b': 'MMM',
    '%B': 'MMMM',
    '%y': 'yy',
    '%Y': 'yyyy',
    // '%g': 'YY',
    // '%G': 'YYYY',
    // '%C': 'INCOMPATIBLE',
    '%D': 'MM/dd/yy',
    // '%x': "INCOMPATIBLE",
    '%F': 'yyyy-MM-dd',
    '%l': 'h',
    '%I': 'hh',
    '%k': 'H',
    '%H': 'HH',
    '%p': 'a',
    '%P': 'aaaa',
    '%M': 'mm',
    '%s': 't',
    '%S': 'ss',
    // '%N': 'INCOMPATIBLE',
    '%r': 'hh:mm:ss',
    '%R': 'HH:mm',
    '%T': 'HH:mm:ss',
    // '%X': 'INCOMPATIBLE',
    // '%c': 'INCOMPATIBLE',
    '%z': 'xx'
};
/**
 * These are the date-fns characters that are associated with 'time', time in this case refers to hour, minute, second and timezone.
 * This is used by splitDateTimeFormat to determine which sections of a date format is associated with time and which are associated  * with day.
 * This list IS case sensitive as capital M is month and not minute, see https://date-fns.org/v2.30.0/docs/format for full list.
 */ const $82f29ecb86a2ff7c$var$LIST_OF_TIME_CHARS = [
    'h',
    // Hour
    'H',
    // Hour
    'm',
    // Minute (NOTE: capital M is month not minute)
    's',
    // Second
    'S',
    // Part of a second
    'a',
    // AM PM
    'xxx',
    // Timezone
    't',
    // Timestamp
    'T' // Timestamp
];
// eslint-disable-next-line no-useless-escape
const $82f29ecb86a2ff7c$var$unixTimeFormatTokenRegex = /\%\w/gi;
const $82f29ecb86a2ff7c$var$escapeRegExp = (literalString)=>literalString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string;
/**
 * Converts a unix date time format to its closest equivalent in date-fns format
 * @param unixDateTimeFormat The unix date time format you want to convert
 */ function $82f29ecb86a2ff7c$export$e007e5b3b423e0a6(unixDateTimeFormat) {
    let transformedString = unixDateTimeFormat;
    const incompatibleFormatString = [];
    const matches = unixDateTimeFormat.match($82f29ecb86a2ff7c$var$unixTimeFormatTokenRegex);
    if (matches) matches.forEach((match)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const equivalentDateFnsFunctionString = $82f29ecb86a2ff7c$var$UNIX_TO_DATE_FNS_MAPPING[match];
        if (equivalentDateFnsFunctionString) // Replaces all cases of the match with it's equivalent in date-fns time format
        transformedString = transformedString.replace(new RegExp($82f29ecb86a2ff7c$var$escapeRegExp(match), 'g'), equivalentDateFnsFunctionString);
        else incompatibleFormatString.push(match);
    });
    return transformedString;
}
/**
 * Naively splits a date fns time format between date and time components. It is split by matching each individual character
 * Naively in this case means that there is a distinct separate between date and time, i.e. they're not mixed in between each other.
 */ function $82f29ecb86a2ff7c$export$b565d8b0afadc612(dateFnsTimeFormat) {
    const matches = dateFnsTimeFormat.match(/\w/g);
    let lastMatchType;
    let indexOfMatchTypeChange = dateFnsTimeFormat.length;
    if (matches) {
        for (const match of matches){
            // We assume that any keys that are not time keys are used to represent date, date in this case refers to years, months, weeks and days
            const isTime = $82f29ecb86a2ff7c$var$LIST_OF_TIME_CHARS.includes(match);
            const matchType = isTime ? 'time' : 'date';
            if (!lastMatchType) lastMatchType = matchType;
            else if (matchType !== lastMatchType) {
                // If the match type has changed, i.e. from date -> time or from time -> date we will stop and use this match to
                // split the date time to date and time.
                indexOfMatchTypeChange = dateFnsTimeFormat.indexOf(match);
                break;
            }
        }
        if (lastMatchType === 'date') // If we went from date -> time
        return {
            dateFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            timeFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
        // splitDateTimeFormat went from time -> date
        return {
            timeFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            dateFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
    }
    return {
        timeFormat: 'hh:mm a',
        dateFormat: 'yyyy-MM-dd'
    };
}

});



parcelRegister("01co2", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("fvTLy")).requestDetailsReducer);

var $fvTLy = parcelRequire("fvTLy");

});
parcelRegister("fvTLy", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => $5adf82b12046da07$export$dfa3e5ac1f5274b8);

var $4ZMmh = parcelRequire("4ZMmh");

var $6UR8m = parcelRequire("6UR8m");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $5adf82b12046da07$export$efef4e30b826ddbf = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.reqDetails) return {
        [initialModelState.reqDetails.key]: initialModelState.reqDetails
    };
    return {};
};
const $5adf82b12046da07$var$defaultState = $5adf82b12046da07$export$efef4e30b826ddbf();
function $5adf82b12046da07$export$dfa3e5ac1f5274b8(state = $5adf82b12046da07$var$defaultState, action) {
    switch(action.type){
        case 0, $gXSFL.FETCH_REQUEST_DETAILS_MODEL:
            return $5adf82b12046da07$var$handleFetchRequestDetailsModel(state, action);
        case 0, $gXSFL.FETCH_REQUEST_DETAILS_FAILURE:
            return $5adf82b12046da07$var$handleFetchRequestDetailsFailureAction(state, action);
        case 0, $gXSFL.FETCH_REQUEST_DETAILS_SUCCESS:
            return $5adf82b12046da07$var$handleFetchRequestDetailsSuccessAction(state, action);
        case 0, $gXSFL.CREATE_COMMENT_SUCCESS:
            return $5adf82b12046da07$var$handleCreateCommentSuccessAction(state, action);
        case 0, $gXSFL.CHANGE_SUBSCRIPTION_SUCCESS:
            return $5adf82b12046da07$var$handleChangeSubscriptionSuccessAction(state, action);
        case 0, $gXSFL.REMOVE_PARTICIPANT_SUCCESS:
            return $5adf82b12046da07$var$handleRemoveParticipant(state, action);
        case 0, $gXSFL.REMOVE_ORGANISATION_SUCCESS:
            return $5adf82b12046da07$var$handleRemoveOrganisation(state, action);
        case 0, $gXSFL.GET_MEDIA_READ_CREDENTIALS_SUCCESS:
            return $5adf82b12046da07$var$handleGetReadCredentialsSuccess(state, action);
        case 0, $gXSFL.ADD_PARTICIPANTS_SUCCESS:
            return $5adf82b12046da07$var$handleAddParticipantsSuccess(state, action);
        default:
            return state;
    }
}
function $5adf82b12046da07$var$handleFetchRequestDetailsModel(state, action) {
    const requestKey = action.payload.params.key;
    if (requestKey) {
        const requestDetails = state[requestKey];
        if (requestDetails && 'error' in requestDetails) {
            const newState = {
                ...state
            };
            delete newState[requestKey];
            return newState;
        }
    }
    return state;
}
function $5adf82b12046da07$var$handleFetchRequestDetailsFailureAction(state, action) {
    const { requestKey: requestKey, error: error } = action.payload;
    const errorObject = {
        // We really only care about the first error message
        // grab it and throw the rest away
        status: error.status,
        message: (error.errorMessages || [])[0] || '',
        // Remove basename from the URL, we don't need it as the basename
        // is already set inside react router.
        // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
        callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    return {
        ...state,
        [requestKey]: {
            error: errorObject
        }
    };
}
function $5adf82b12046da07$var$populateWithPreexistingState(preExistingRequestDetails, response) {
    let preExistingProperties;
    if (preExistingRequestDetails && !('error' in preExistingRequestDetails)) {
        if (preExistingRequestDetails.userMentionedDuringRequestCreation) preExistingProperties = {
            participants: (0, $4ZMmh.uniqBy)([
                ...preExistingRequestDetails.participants,
                ...response.participants
            ], 'accountId'),
            userMentionedDuringRequestCreation: false
        };
    }
    return preExistingProperties;
}
function $5adf82b12046da07$var$handleFetchRequestDetailsSuccessAction(state, action) {
    const response = action.payload;
    const requestKey = response.key;
    const preExistingProperties = $5adf82b12046da07$var$populateWithPreexistingState(state[requestKey], response);
    return {
        ...state,
        [requestKey]: {
            ...response,
            ...preExistingProperties
        }
    };
}
function $5adf82b12046da07$var$handleChangeSubscriptionSuccessAction(state, action) {
    const { requestKey: requestKey, shouldSubscribe: shouldSubscribe } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) {
        let newSubscribeAction = (0, $6UR8m.SUBSCRIBE_ACTION_KEY);
        if (shouldSubscribe) newSubscribeAction = (0, $6UR8m.UNSUBSCRIBE_ACTION_KEY);
        return {
            ...state,
            [requestKey]: {
                ...requestDetails,
                subscribeAction: newSubscribeAction
            }
        };
    }
    return state;
}
function $5adf82b12046da07$var$handleCreateCommentSuccessAction(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                activityStream: [
                    ...requestDetails.issue.activityStream,
                    response.comment
                ],
                status: response.status
            }
        }
    };
    return state;
}
function $5adf82b12046da07$var$handleRemoveOrganisation(state, action) {
    const { requestKey: requestKey, organisationId: organisationId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            organisations: requestDetails.organisations.filter((organisation)=>organisation.id !== organisationId),
            issue: {
                ...requestDetails.issue,
                organisations: requestDetails.issue.organisations.filter((organisation)=>organisation.id !== organisationId)
            }
        }
    };
    return state;
}
const $5adf82b12046da07$var$filterRemovedParticipant = (participants, removedUserAccountId)=>participants.filter((participant)=>participant.accountId !== removedUserAccountId);
function $5adf82b12046da07$var$handleRemoveParticipant(state, action) {
    const { requestKey: requestKey, accountId: accountId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            participants: $5adf82b12046da07$var$filterRemovedParticipant(requestDetails.participants, accountId),
            issue: {
                ...requestDetails.issue,
                participants: $5adf82b12046da07$var$filterRemovedParticipant(requestDetails.issue.participants, accountId)
            }
        }
    };
    return state;
}
function $5adf82b12046da07$var$handleGetReadCredentialsSuccess(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            readFileMediaCredentials: response
        }
    };
    return state;
}
function $5adf82b12046da07$var$handleAddParticipantsSuccess(state, action) {
    const { requestKey: requestKey, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation, addParticipantsSuccessResponse: addParticipantsSuccessResponse } = action.payload;
    const requestDetails = state[requestKey];
    const { participants: updatedParticipants, organisations: updatedOrganisations } = addParticipantsSuccessResponse;
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                participants: updatedParticipants,
                organisations: updatedOrganisations
            },
            participants: updatedParticipants,
            organisations: updatedOrganisations
        }
    };
    if (!requestDetails && userMentionedDuringRequestCreation) return {
        ...state,
        [requestKey]: {
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            issue: {
                participants: updatedParticipants,
                activityStream: [],
                fields: []
            },
            participants: updatedParticipants,
            approvalStatus: []
        }
    };
    return state;
}

});
parcelRegister("6UR8m", function(module, exports) {
$parcel$export(module.exports, "SUBSCRIBE_ACTION_KEY", () => $77f9c5a9c7d6b9f6$export$2f3123aa49f16a3c);
$parcel$export(module.exports, "UNSUBSCRIBE_ACTION_KEY", () => $77f9c5a9c7d6b9f6$export$5a45f83be8b212b8);
const $77f9c5a9c7d6b9f6$export$2f3123aa49f16a3c = 'subscribe';
const $77f9c5a9c7d6b9f6$export$5a45f83be8b212b8 = 'unsubscribe';
const $77f9c5a9c7d6b9f6$export$f10e0fb31f869e32 = 'none';

});



parcelRegister("2An5Y", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("cKIE3")).requestListReducer);

var $cKIE3 = parcelRequire("cKIE3");

});
parcelRegister("cKIE3", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $00930b553ea59d9d$export$476a1a148617ffd3);
parcelRequire("cqYZw");
var $jJY1A = parcelRequire("jJY1A");

var $1btpl = parcelRequire("1btpl");

var $lFpPv = parcelRequire("lFpPv");
const $00930b553ea59d9d$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    }
};
const $00930b553ea59d9d$export$c1708a8d295610ca = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.allReqFilter) {
        const { resultsPerPage: resultsPerPage, totalResults: totalResults, sortBy: sortBy, sortOrder: sortOrder, requestList: requestList, nextToken: nextToken } = initialModelState.allReqFilter;
        const baseState = {
            resultsPerPage: resultsPerPage,
            totalResults: totalResults,
            sortBy: sortBy,
            sortOrder: sortOrder,
            pages: {
                isInitialPageLoad: true,
                [initialModelState.allReqFilter.selectedPage]: requestList
            }
        };
        if ((0, $lFpPv.isRequestListInfiniteScrollEnabled)()) {
            baseState.nextToken = nextToken;
            baseState.allRows = requestList ?? [];
            baseState.filter = initialModelState.allReqFilter.filter ?? '';
        }
        return baseState;
    }
    return $00930b553ea59d9d$var$emptyState;
};
const $00930b553ea59d9d$var$defaultState = $00930b553ea59d9d$export$c1708a8d295610ca();
function $00930b553ea59d9d$export$476a1a148617ffd3(state = $00930b553ea59d9d$var$defaultState, action) {
    switch(action.type){
        case 0, $jJY1A.FETCH_REQUEST_LIST_SUCCESS:
            return $00930b553ea59d9d$var$handleFetchRequestListSuccess(state, action);
        case 0, $jJY1A.MARK_INITIAL_PAGE_LOAD_RENDERED:
            return $00930b553ea59d9d$var$handleMarkInitialPageLoadRendered(state);
        case 0, $jJY1A.INVALIDATE_PAGES:
            return $00930b553ea59d9d$var$handleInvalidatePages(state, action);
        default:
            return state;
    }
}
function $00930b553ea59d9d$var$handleInvalidatePages(state, action) {
    const currentPage = action.payload;
    return {
        ...state,
        pages: {
            isInitialPageLoad: false,
            [currentPage]: state.pages[currentPage]
        }
    };
}
function $00930b553ea59d9d$var$handleFetchRequestListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder || response.totalResults !== state.totalResults || response.filter !== state.filter;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requestList.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requestList : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        sortBy: response.sortBy,
        sortOrder: response.sortOrder,
        nextToken: response.nextToken,
        filter: response.filter,
        allRows: newRows,
        // The `pages` object (keyed by selectedPage) is only used by the non-infinite-scroll
        // pagination path. In the infinite scroll path, `allRows` is the canonical source of
        // truth for all fetched rows, so we do not populate `pages[selectedPage]` here.
        // Doing so would store stale page-indexed data that is never consumed by infinite
        // scroll consumers, and `selectedPage` is irrelevant in nextToken-based pagination.
        pages: {
            isInitialPageLoad: false
        }
    };
}
function $00930b553ea59d9d$var$handleFetchRequestListSuccess(state, action) {
    if ((0, $lFpPv.isRequestListInfiniteScrollEnabled)()) return $00930b553ea59d9d$var$handleFetchRequestListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) {
            if (response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder) {
                if (response.selectedPage === 1) return {
                    ...state,
                    sortOrder: response.sortOrder,
                    sortBy: response.sortBy,
                    pages: {
                        isInitialPageLoad: false,
                        [response.selectedPage]: response.requestList
                    }
                };
            }
            return {
                ...state,
                pages: {
                    ...state.pages,
                    isInitialPageLoad: false,
                    [response.selectedPage]: response.requestList
                }
            };
        }
        return {
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            sortBy: response.sortBy,
            sortOrder: response.sortOrder,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requestList
            }
        };
    }
    return state;
}
const $00930b553ea59d9d$var$handleMarkInitialPageLoadRendered = (state)=>({
        ...state,
        pages: {
            ...state.pages,
            isInitialPageLoad: false
        }
    });

});


parcelRegister("gM8is", function(module, exports) {
$parcel$export(module.exports, "reqSlasReducer", () => (parcelRequire("hWLt8")).reqSlasReducer);

var $hWLt8 = parcelRequire("hWLt8");

});
parcelRegister("hWLt8", function(module, exports) {
$parcel$export(module.exports, "reqSlasReducer", () => $5322c4a1387b33db$export$55a46cf03dbe4d53);

var $1btpl = parcelRequire("1btpl");
parcelRequire("Ra0Dc");
var $hIjnn = parcelRequire("hIjnn");
const $5322c4a1387b33db$export$3bc01640ec2791f4 = ()=>{
    const { reqDetails: reqDetails, reqSlas: reqSlas } = (0, $1btpl.default)();
    return reqDetails && reqSlas ? {
        [reqDetails.key]: reqSlas
    } : {};
};
const $5322c4a1387b33db$export$55a46cf03dbe4d53 = (state = $5322c4a1387b33db$export$3bc01640ec2791f4(), action)=>{
    switch(action.type){
        case 0, $hIjnn.UPDATE_REQ_SLAS_MODEL:
            return {
                ...state,
                [action.payload.requestKey]: action.payload.reqSlas
            };
        default:
            return state;
    }
};

});


parcelRegister("4TeUy", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionReducer", () => (parcelRequire("a0InA")).default);
/**
 * This should be normalized with the normal request type model at some point
 */ 
var $a0InA = parcelRequire("a0InA");

});
parcelRegister("a0InA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e3cfdf5806025b$export$2e2bcd8739ae039);
parcelRequire("2m8Do");
var $iLBgj = parcelRequire("iLBgj");

var $eDcdn = parcelRequire("eDcdn");
const $b4e3cfdf5806025b$var$defaultState = {
    suggestions: [],
    isLoaded: false
};
function $b4e3cfdf5806025b$export$2e2bcd8739ae039(state = $b4e3cfdf5806025b$var$defaultState, action) {
    switch(action.type){
        case 0, $iLBgj.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL:
            // When we are making a new request for the request type model we will reset the state
            return {
                suggestions: [],
                isLoaded: false
            };
        case 0, $iLBgj.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS:
            {
                const requestTypeSuggestions = action.payload.map((suggestion)=>{
                    const requestTypeId = parseInt(String(suggestion.id), 10);
                    return {
                        id: requestTypeId,
                        portalId: suggestion.cvId,
                        portalName: suggestion.portalName,
                        name: suggestion.name,
                        descriptionHtml: suggestion.descriptionHtml,
                        iconUrl: suggestion.iconUrl || `${0, $eDcdn.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${suggestion.icon}`
                    };
                });
                return {
                    suggestions: requestTypeSuggestions,
                    isLoaded: true
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("1gsM6", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("4mEe1")).resetPasswordReducer);

var $4mEe1 = parcelRequire("4mEe1");

});
parcelRegister("4mEe1", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $ce43276797b5b446$export$b0c3be5071e95c02);

var $1btpl = parcelRequire("1btpl");
const $ce43276797b5b446$var$defaultState = {
    emailAddress: undefined,
    username: undefined,
    resetPasswordJwt: undefined
};
const $ce43276797b5b446$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.resetPassword) return {
        ...$ce43276797b5b446$var$defaultState,
        ...initialModelState.resetPassword
    };
    return $ce43276797b5b446$var$defaultState;
};
const $ce43276797b5b446$export$b0c3be5071e95c02 = (state = $ce43276797b5b446$export$53ac33307b5acee9())=>state;

});


parcelRegister("3hENx", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => (parcelRequire("9cJv2")).signUpReducer);

var $9cJv2 = parcelRequire("9cJv2");

});
parcelRegister("9cJv2", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => $6ef2969368dab509$export$a3d522c435cab174);
parcelRequire("8eZY0");
var $hh4QA = parcelRequire("hh4QA");

var $O9KKV = parcelRequire("O9KKV");

var $1btpl = parcelRequire("1btpl");
const $6ef2969368dab509$var$defaultState = {
    authInfo: {
        accountStage: (0, $O9KKV.AccountStageType).SIGNUP,
        authMethods: new Map([
            [
                (0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    emailAddress: null,
    requestKey: null,
    requestSummary: null
};
const $6ef2969368dab509$var$getInitialState = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.signUp && initialModelState.signUp.emailAddress) return {
        ...$6ef2969368dab509$var$defaultState,
        ...initialModelState.signUp
    };
    return $6ef2969368dab509$var$defaultState;
};
const $6ef2969368dab509$export$a3d522c435cab174 = (state = $6ef2969368dab509$var$getInitialState(), action)=>{
    switch(action.type){
        case 0, $hh4QA.SET_SIGN_UP_DATA:
            return {
                ...state,
                emailAddress: action.payload.email,
                authInfo: action.payload.authInfo
            };
        default:
            return state;
    }
};

});


parcelRegister("jjTJg", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => (parcelRequire("9bdTO")).timezonesReducer);

var $9bdTO = parcelRequire("9bdTO");

});
parcelRegister("9bdTO", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => $3ec3df780b782a2b$export$98e58b85fdd67f49);
parcelRequire("ivsTx");
var $jWhmA = parcelRequire("jWhmA");

var $1btpl = parcelRequire("1btpl");
const $3ec3df780b782a2b$export$84faa4a7b0294c11 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState) return {
        timezoneRegions: initialModelState.timezoneRegions || [],
        timezones: initialModelState.timezones || []
    };
    return {
        timezoneRegions: [],
        timezones: []
    };
};
const $3ec3df780b782a2b$var$defaultState = $3ec3df780b782a2b$export$84faa4a7b0294c11();
function $3ec3df780b782a2b$export$98e58b85fdd67f49(state = $3ec3df780b782a2b$var$defaultState, action) {
    switch(action.type){
        case 0, $jWhmA.FETCH_TIMEZONES_SUCCESS:
            return $3ec3df780b782a2b$var$handleFetchTimezonesSuccess(state, action);
        case 0, $jWhmA.FETCH_TIMEZONE_REGIONS_SUCCESS:
            return $3ec3df780b782a2b$var$handleFetchTimezoneRegionsSuccess(state, action);
        default:
            return state;
    }
}
const $3ec3df780b782a2b$var$handleFetchTimezonesSuccess = (state, action)=>({
        ...state,
        timezones: action.payload.timezones
    });
const $3ec3df780b782a2b$var$handleFetchTimezoneRegionsSuccess = (state, action)=>({
        ...state,
        timezoneRegions: action.payload.timezoneRegions
    });

});


parcelRegister("6y7Tg", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => (parcelRequire("4yKEC")).uiModificationsReducer);

var $4yKEC = parcelRequire("4yKEC");

});
parcelRegister("4yKEC", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => $deb1ce071b45e020$export$821013f52f243078);
parcelRequire("iYz1m");
var $fJgYk = parcelRequire("fJgYk");
const $deb1ce071b45e020$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $deb1ce071b45e020$var$defaultState = {};
function $deb1ce071b45e020$export$821013f52f243078(state = $deb1ce071b45e020$var$defaultState, action) {
    switch(action.type){
        case 0, $fJgYk.FETCH_UI_MODIFICATIONS_SUCCESS:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, uiModifications: uiModifications } = action.payload;
                const storeKey = $deb1ce071b45e020$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: uiModifications,
                        error: undefined
                    }
                };
            }
        case 0, $fJgYk.FETCH_UI_MODIFICATIONS_FAILURE:
            {
                var _error$errorMessages;
                const { portalId: portalId, requestTypeId: requestTypeId, error: error } = action.payload;
                const storeKey = $deb1ce071b45e020$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: undefined,
                        error: ((_error$errorMessages = error.errorMessages) === null || _error$errorMessages === void 0 ? void 0 : _error$errorMessages[0]) ?? 'Failed to fetch UI modifications'
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("hsr33", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => (parcelRequire("9hypW")).unsubscribedConfirmationReducer);

var $9hypW = parcelRequire("9hypW");

});
parcelRegister("9hypW", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => $028507856f37207f$export$ac175372d3d2c582);

var $lH75E = parcelRequire("lH75E");
parcelRequire("9zTvk");
var $wC1sN = parcelRequire("wC1sN");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $028507856f37207f$export$c8b25b5da8be069b = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.unsubscribedConfirmation) return {
        unsubscribedConfirmation: initialModelState.unsubscribedConfirmation
    };
    return {};
};
const $028507856f37207f$var$defaultState = $028507856f37207f$export$c8b25b5da8be069b();
function $028507856f37207f$export$ac175372d3d2c582(state = $028507856f37207f$var$defaultState, action) {
    switch(action.type){
        case 0, $lH75E.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL:
            {
                const unsubscribedConfirmation = state.unsubscribedConfirmation;
                if (unsubscribedConfirmation && 'error' in unsubscribedConfirmation) return {};
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $wC1sN.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    ...state,
                    unsubscribedConfirmation: {
                        error: errorObject
                    }
                };
            }
        case 0, $wC1sN.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const requestKey = fetchPortalSuccessAction.payload.requestKey;
                const unsubscribedConfirmation = {
                    requestKey: requestKey,
                    requestUrl: fetchPortalSuccessAction.payload.requestUrl,
                    summary: fetchPortalSuccessAction.payload.summary
                };
                return {
                    ...state,
                    unsubscribedConfirmation: unsubscribedConfirmation
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("910Vy", function(module, exports) {
$parcel$export(module.exports, "userReducer", () => (parcelRequire("jy9cS")).default);

var $jy9cS = parcelRequire("jy9cS");

});
parcelRegister("jy9cS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a07de7fbeb5c97f$export$2e2bcd8739ae039);
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");

var $53hm0 = parcelRequire("53hm0");

var $1etMn = parcelRequire("1etMn");

var $1btpl = parcelRequire("1btpl");
function $1a07de7fbeb5c97f$var$reduceResponseToState(userResponse) {
    const state = {
        language: {
            key: (0, $1etMn.ensureConsistentKey)(userResponse.language.key),
            originalKey: userResponse.language.key,
            displayName: userResponse.language.displayName
        },
        storedLanguage: {
            key: (0, $1etMn.ensureConsistentKey)(userResponse.storedLanguage.key),
            originalKey: userResponse.storedLanguage.key,
            displayName: userResponse.storedLanguage.displayName
        },
        timezone: {
            id: userResponse.timezone.id,
            regionKey: userResponse.timezone.regionKey,
            city: userResponse.timezone.city,
            gmtOffset: userResponse.timezone.gmtOffset
        },
        avatars: userResponse.avatars,
        userRequests: {},
        isLoaded: true,
        isLoggedIn: !!userResponse.accountId,
        customMenuLinks: userResponse.customMenuLinks ? userResponse.customMenuLinks : [],
        canAdministerJIRA: userResponse.canAdministerJIRA,
        hasSiteAdministerAccess: userResponse.hasSiteAdministerAccess ?? false,
        agentForPortal: userResponse.agentForPortal,
        accountId: userResponse.accountId,
        displayName: userResponse.displayName,
        email: userResponse.email,
        atlassianAccountManaged: userResponse.atlassianAccountManaged,
        scimManaged: userResponse.scimManaged ?? false,
        externalCustomer: userResponse.externalCustomer
    };
    return state;
}
const $1a07de7fbeb5c97f$export$180605366c04f0cd = ()=>$53hm0.getMeta('user-locale') || $53hm0.getMeta('ajs-user-locale') || '';
const $1a07de7fbeb5c97f$var$getInitialUserState = ()=>{
    const initialState = (0, $1btpl.default)();
    if (initialState && initialState.user) return $1a07de7fbeb5c97f$var$reduceResponseToState(initialState.user);
    return undefined;
};
const $1a07de7fbeb5c97f$var$anonymousState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $1etMn.ensureConsistentKey)($1a07de7fbeb5c97f$export$180605366c04f0cd()),
        originalKey: $1a07de7fbeb5c97f$export$180605366c04f0cd(),
        displayName: $1a07de7fbeb5c97f$export$180605366c04f0cd()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $1etMn.ensureConsistentKey)($1a07de7fbeb5c97f$export$180605366c04f0cd()),
        originalKey: $1a07de7fbeb5c97f$export$180605366c04f0cd(),
        displayName: $1a07de7fbeb5c97f$export$180605366c04f0cd()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: true,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false
};
const $1a07de7fbeb5c97f$var$defaultState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $1etMn.ensureConsistentKey)($1a07de7fbeb5c97f$export$180605366c04f0cd()),
        originalKey: $1a07de7fbeb5c97f$export$180605366c04f0cd(),
        displayName: $1a07de7fbeb5c97f$export$180605366c04f0cd()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $1etMn.ensureConsistentKey)($1a07de7fbeb5c97f$export$180605366c04f0cd()),
        originalKey: $1a07de7fbeb5c97f$export$180605366c04f0cd(),
        displayName: $1a07de7fbeb5c97f$export$180605366c04f0cd()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: false,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false,
    // Initial user state spreads _last_ just in case there are things on the server that should
    // override initial (local) state.
    ...$1a07de7fbeb5c97f$var$getInitialUserState()
};
function $1a07de7fbeb5c97f$export$2e2bcd8739ae039(state = $1a07de7fbeb5c97f$var$defaultState, action) {
    switch(action.type){
        case 0, $kd70W.UPDATE_USER_MODEL:
            {
                const userResponse = action.payload;
                const newState = $1a07de7fbeb5c97f$var$reduceResponseToState(userResponse);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $kd70W.UPDATE_USER_TO_ANON:
            return {
                ...$1a07de7fbeb5c97f$var$anonymousState
            };
        case 0, $kd70W.SAVE_USER_PROFILE_SUCCESS:
            return $1a07de7fbeb5c97f$var$handleUpdateUserProfileSuccessAction(state, action);
        case 0, $kd70W.SUCCESSFULLY_LOGGED_IN:
            return $1a07de7fbeb5c97f$var$handleSuccessfullyLoggedIn(state);
        default:
            return state;
    }
}
function $1a07de7fbeb5c97f$var$handleUpdateUserProfileSuccessAction(state, action) {
    const displayName = action.payload.displayName || state.displayName;
    const language = action.payload.language || state.storedLanguage;
    const timezone = action.payload.timezone || state.timezone;
    return {
        ...state,
        displayName: displayName,
        timezone: timezone,
        storedLanguage: {
            key: (0, $1etMn.ensureConsistentKey)(language.originalKey),
            originalKey: language.originalKey,
            displayName: language.displayName
        }
    };
}
const $1a07de7fbeb5c97f$var$handleSuccessfullyLoggedIn = (state)=>({
        ...state,
        isLoggedIn: true
    });

});


parcelRegister("b74tt", function(module, exports) {
$parcel$export(module.exports, "userRequestsCountsReducer", () => (parcelRequire("7ZbsY")).default);

var $7ZbsY = parcelRequire("7ZbsY");

});
parcelRegister("7ZbsY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5d04e601231d273$export$2e2bcd8739ae039);
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");
function $a5d04e601231d273$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 0, $kd70W.UPDATE_USER_REQUESTS_COUNTS_MODEL:
            {
                const userRequestCountResponse = action.payload;
                return {
                    myRequestCount: userRequestCountResponse.allOpenRequestsCount,
                    pendingApprovalCount: userRequestCountResponse.pendingApprovalsCount,
                    approvalCount: userRequestCountResponse.approvalsCount
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("8pxud", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => (parcelRequire("4EPZP")).verifyEmailReducer);

var $4EPZP = parcelRequire("4EPZP");

});
parcelRegister("4EPZP", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => $9f8a6145cc35a3e2$export$681ecd52c505c479);

var $avrLD = parcelRequire("avrLD");

var $1btpl = parcelRequire("1btpl");
const $9f8a6145cc35a3e2$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: (0, $avrLD.SUCCESSFUL_VERIFICATION_OUTCOMES).SUCCEEDED,
    portalName: null,
    portalId: null
};
const $9f8a6145cc35a3e2$export$681ecd52c505c479 = (state = $9f8a6145cc35a3e2$export$53ac33307b5acee9())=>state;
const $9f8a6145cc35a3e2$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.verifyEmail) return initialModelState.verifyEmail;
    return $9f8a6145cc35a3e2$var$defaultState;
};

});
parcelRegister("avrLD", function(module, exports) {
$parcel$export(module.exports, "FAILED_VERIFICATION_OUTCOMES", () => $ab455ef1b1d1b44b$export$d054ec592d4dac6f);
$parcel$export(module.exports, "SUCCESSFUL_VERIFICATION_OUTCOMES", () => $ab455ef1b1d1b44b$export$a94c4b05d26d720a);
const $ab455ef1b1d1b44b$export$d054ec592d4dac6f = {
    IDENTITY_ERROR: 'IDENTITY_ERROR',
    TOKEN_INVALID: 'TOKEN_INVALID',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    PROCESSING_ERROR: 'PROCESSING_ERROR'
};
const $ab455ef1b1d1b44b$export$a94c4b05d26d720a = {
    SUCCEEDED: 'SUCCEEDED'
};

});



parcelRegister("978Rt", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => (parcelRequire("5XmqC")).visitPortalReducer);

var $5XmqC = parcelRequire("5XmqC");

});
parcelRegister("5XmqC", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => $053aab7a3c1371bd$export$8f27b2a880eeba34);
parcelRequire("xOZC4");
var $jN84E = parcelRequire("jN84E");

var $eDcdn = parcelRequire("eDcdn");

var $1btpl = parcelRequire("1btpl");
const $053aab7a3c1371bd$var$defaultState = {
    loggedInBeforeCheck: false,
    email: '',
    portalName: '',
    initialError: undefined,
    setPasswordJwt: undefined
};
const $053aab7a3c1371bd$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $1btpl.default)();
    if (initialModelState && initialModelState.visitPortal) return initialModelState.visitPortal;
    return $053aab7a3c1371bd$var$defaultState;
};
function $053aab7a3c1371bd$export$8f27b2a880eeba34(state = $053aab7a3c1371bd$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $jN84E.FETCH_VISIT_PORTAL_SUCCESS:
            return $053aab7a3c1371bd$var$handleFetchVisitPortalSuccess(state, action);
        case 0, $jN84E.FETCH_VISIT_PORTAL_FAILURE:
            return $053aab7a3c1371bd$var$handleFetchVisitPortalFailure(state, action);
        default:
            return state;
    }
}
function $053aab7a3c1371bd$var$handleFetchVisitPortalSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        loggedInBeforeCheck: response.loggedInBeforeCheck,
        email: response.email,
        portalName: response.portalName,
        setPasswordJwt: response.setPasswordJwt
    };
}
function $053aab7a3c1371bd$var$handleFetchVisitPortalFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $eDcdn.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});



parcelRegister("a30Ux", function(module, exports) {
$parcel$export(module.exports, "default", () => $17bc86388e1126e6$export$2e2bcd8739ae039);
parcelRequire("1mIIj");
var $j5nqc = parcelRequire("j5nqc");

var $fXrKb = parcelRequire("fXrKb");

var $1cJoI = parcelRequire("1cJoI");
var $17bc86388e1126e6$export$2e2bcd8739ae039 = (0, $j5nqc.default)({
    persisted: $fXrKb.default,
    ui: $1cJoI.default
});

});
parcelRegister("1cJoI", function(module, exports) {
$parcel$export(module.exports, "getCombinedUIReducer", () => $2d0957af2f092d94$export$7d44d6add2bebf09);
$parcel$export(module.exports, "default", () => $2d0957af2f092d94$export$2e2bcd8739ae039);
parcelRequire("1mIIj");
var $j5nqc = parcelRequire("j5nqc");
parcelRequire("1quxx");
var $2Xh4h = parcelRequire("2Xh4h");
parcelRequire("6gTq6");
var $k3zEC = parcelRequire("k3zEC");
parcelRequire("cIIlx");
var $IeO0j = parcelRequire("IeO0j");
parcelRequire("iHpFO");
var $gVqlB = parcelRequire("gVqlB");
parcelRequire("8x6WS");
var $61t50 = parcelRequire("61t50");
parcelRequire("lpNa4");
var $bUnK3 = parcelRequire("bUnK3");
parcelRequire("2kj1h");
var $jmAg3 = parcelRequire("jmAg3");
parcelRequire("hDQSM");
var $hp2QN = parcelRequire("hp2QN");
parcelRequire("3qoeW");
var $lTwS1 = parcelRequire("lTwS1");
parcelRequire("5fSTa");
var $3XQvD = parcelRequire("3XQvD");
parcelRequire("jajxI");
var $1vUiY = parcelRequire("1vUiY");
parcelRequire("33wXA");
var $eEo6k = parcelRequire("eEo6k");
parcelRequire("8wnFc");
var $daZ9q = parcelRequire("daZ9q");
parcelRequire("2rGUa");
var $aC7BT = parcelRequire("aC7BT");
parcelRequire("5gZTW");
var $1vv1a = parcelRequire("1vv1a");
parcelRequire("aVXp3");
var $8IYBK = parcelRequire("8IYBK");
parcelRequire("kWW84");
var $jtV2A = parcelRequire("jtV2A");
parcelRequire("78p6t");
var $5idyo = parcelRequire("5idyo");
parcelRequire("gB1xB");
var $bbOKY = parcelRequire("bbOKY");
parcelRequire("eKZay");
var $hsEgN = parcelRequire("hsEgN");
parcelRequire("eNCGE");
var $3Mkhc = parcelRequire("3Mkhc");
const $2d0957af2f092d94$var$reducerCollection = {
    context: (0, $gVqlB.default),
    search: (0, $5idyo.default),
    helpCenterPreview: (0, $hp2QN.default),
    portalCustomisation: (0, $daZ9q.default),
    requestDetails: (0, $aC7BT.requestDetailsReducer),
    requestList: (0, $1vv1a.requestListReducer),
    approvalList: (0, $2Xh4h.approvalistReducer),
    flags: (0, $jmAg3.flagsReducer),
    userProfile: (0, $3Mkhc.userProfileReducer),
    login: (0, $3XQvD.loginUiReducer),
    loginAnnouncements: (0, $1vUiY.loginAnnouncementsReducer),
    invitedSignUp: (0, $lTwS1.invitedSignUpUiReducer),
    resetPassword: (0, $jtV2A.resetPasswordReducer),
    completeSignup: (0, $IeO0j.completeSignupUiReducer),
    signUpCheckEmail: (0, $bbOKY.checkEmailUiReducer),
    featuredAndSortedPortals: (0, $61t50.featuredAndSortedPortalsReducer),
    feedbackCollector: (0, $bUnK3.feedbackCollectorReducer),
    portals: (0, $eEo6k.portalReducer),
    resendVerifyEmail: (0, $8IYBK.resendVerifyReducer),
    topics: (0, $hsEgN.default),
    chatDetails: (0, $k3zEC.chatDetailsReducer)
};
const $2d0957af2f092d94$export$7d44d6add2bebf09 = (asyncReducers)=>(0, $j5nqc.default)({
        ...$2d0957af2f092d94$var$reducerCollection,
        ...asyncReducers
    });
var $2d0957af2f092d94$export$2e2bcd8739ae039 = (0, $j5nqc.default)($2d0957af2f092d94$var$reducerCollection);

});
parcelRegister("1quxx", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => (parcelRequire("2Xh4h")).approvalistReducer);

var $2Xh4h = parcelRequire("2Xh4h");

});
parcelRegister("2Xh4h", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => $bb00f756da076426$export$b467bcef5b3409ab);
parcelRequire("gnTDP");
var $4FH4O = parcelRequire("4FH4O");
const $bb00f756da076426$var$defaultState = {
    isLoading: false
};
function $bb00f756da076426$export$b467bcef5b3409ab(state = $bb00f756da076426$var$defaultState, action) {
    switch(action.type){
        case 0, $4FH4O.FETCH_APPROVAL_LIST_MODEL:
            return $bb00f756da076426$var$handleFetchApprovalListAction(state);
        case 0, $4FH4O.FETCH_APPROVAL_LIST_SUCCESS:
            return $bb00f756da076426$var$handleFetchApprovalListSuccess(state);
        case 0, $4FH4O.FETCH_APPROVAL_LIST_FAILURE:
            return $bb00f756da076426$var$handleFetchApprovalListFailure(state);
        default:
            return state;
    }
}
const $bb00f756da076426$var$handleFetchApprovalListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $bb00f756da076426$var$handleFetchApprovalListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $bb00f756da076426$var$handleFetchApprovalListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("6gTq6", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => (parcelRequire("k3zEC")).chatDetailsReducer);

var $k3zEC = parcelRequire("k3zEC");

});
parcelRegister("k3zEC", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => $70efe8d2948a075b$export$38fe3740469ec1e6);
parcelRequire("7bFih");
var $lEZQu = parcelRequire("lEZQu");
const $70efe8d2948a075b$export$29e68d440392d68e = {
    isChatSideBarOpen: false
};
function $70efe8d2948a075b$export$38fe3740469ec1e6(state = $70efe8d2948a075b$export$29e68d440392d68e, action) {
    if (action.type === (0, $lEZQu.OPEN_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: true
    };
    if (action.type === (0, $lEZQu.CLOSE_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: false
    };
    return state;
}

});
parcelRegister("7bFih", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => (parcelRequire("lEZQu")).OPEN_CHAT_SIDE_BAR);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => (parcelRequire("lEZQu")).CLOSE_CHAT_SIDE_BAR);
$parcel$export(module.exports, "openChatSideBar", () => (parcelRequire("lEZQu")).openChatSideBar);
$parcel$export(module.exports, "closeChatSideBar", () => (parcelRequire("lEZQu")).closeChatSideBar);

var $lEZQu = parcelRequire("lEZQu");

});
parcelRegister("lEZQu", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => $3e1456edb08a2a6c$export$dc5a6dd48e3ba8bf);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => $3e1456edb08a2a6c$export$c4de34e9e1c374f8);
$parcel$export(module.exports, "openChatSideBar", () => $3e1456edb08a2a6c$export$348d5042d1099e44);
$parcel$export(module.exports, "closeChatSideBar", () => $3e1456edb08a2a6c$export$7fb0f09e601a69a9);
const $3e1456edb08a2a6c$export$dc5a6dd48e3ba8bf = 'state.ui.chat-details.OPEN_CHAT_SIDE_BAR';
const $3e1456edb08a2a6c$export$c4de34e9e1c374f8 = 'state.ui.chat-details.CLOSE_CHAT_SIDE_BAR';
const $3e1456edb08a2a6c$export$348d5042d1099e44 = ()=>({
        type: $3e1456edb08a2a6c$export$dc5a6dd48e3ba8bf
    });
const $3e1456edb08a2a6c$export$7fb0f09e601a69a9 = ()=>({
        type: $3e1456edb08a2a6c$export$c4de34e9e1c374f8
    });

});




parcelRegister("cIIlx", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => (parcelRequire("IeO0j")).completeSignupUiReducer);

var $IeO0j = parcelRequire("IeO0j");

});
parcelRegister("IeO0j", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => $dfc944d0b4a9535a$export$11cdd5afa8f3d37e);
parcelRequire("9bj9n");
var $cP3WD = parcelRequire("cP3WD");
const $dfc944d0b4a9535a$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    submitError: undefined,
    isNewSignupLinkBeingSent: false,
    newSignupLinkSuccessfullySent: false
};
function $dfc944d0b4a9535a$export$11cdd5afa8f3d37e(state = $dfc944d0b4a9535a$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $cP3WD.COMPLETE_SIGNUP:
            return $dfc944d0b4a9535a$var$handleCompleteSignup(state);
        case 0, $cP3WD.COMPLETE_SIGNUP_FAILURE:
            return $dfc944d0b4a9535a$var$handleCompleteSignupFailure(state, action);
        case 0, $cP3WD.SEND_NEW_SIGNUP_LINK:
            return $dfc944d0b4a9535a$var$handleSendNewSignupLink(state);
        case 0, $cP3WD.SEND_NEW_SIGNUP_LINK_SUCCESS:
            return $dfc944d0b4a9535a$var$handleSendNewSignupLinkSuccess(state);
        case 0, $cP3WD.SEND_NEW_SIGNUP_LINK_FAILURE:
            return $dfc944d0b4a9535a$var$handleSendNewSignupLinkFailure(state);
        default:
            return state;
    }
}
const $dfc944d0b4a9535a$var$handleCompleteSignup = (state)=>({
        ...state,
        isSubmitting: true,
        submitError: undefined
    });
const $dfc944d0b4a9535a$var$handleCompleteSignupFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        submitError: action.payload.error
    });
const $dfc944d0b4a9535a$var$handleSendNewSignupLink = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: true
    });
const $dfc944d0b4a9535a$var$handleSendNewSignupLinkSuccess = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false,
        newSignupLinkSuccessfullySent: true
    });
const $dfc944d0b4a9535a$var$handleSendNewSignupLinkFailure = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false
    });

});


parcelRegister("iHpFO", function(module, exports) {
$parcel$export(module.exports, "contextReducer", () => (parcelRequire("gVqlB")).default);

var $gVqlB = parcelRequire("gVqlB");

});
parcelRegister("gVqlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c6664471243e45b$export$2e2bcd8739ae039);
parcelRequire("gvsW5");
var $oi8Kq = parcelRequire("oi8Kq");

var $1btpl = parcelRequire("1btpl");

var $aYbXa = parcelRequire("aYbXa");
const $0c6664471243e45b$export$53ac33307b5acee9 = ()=>{
    var _initialModelState$po;
    const initialModelState = (0, $1btpl.default)();
    const initialState = initialModelState !== null && initialModelState !== void 0 && initialModelState.portal ? {
        portalId: Number((_initialModelState$po = initialModelState.portal) === null || _initialModelState$po === void 0 ? void 0 : _initialModelState$po.id)
    } : {};
    return initialState;
};
const $0c6664471243e45b$export$49d5fc8cba920a0 = $0c6664471243e45b$export$53ac33307b5acee9();
function $0c6664471243e45b$export$2e2bcd8739ae039(state = $0c6664471243e45b$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $oi8Kq.UPDATE_CONTEXT:
            {
                const { pathname: pathname, pathParams: pathParams, routeName: routeName } = action.payload;
                let portalId;
                if (pathParams) portalId = (0, $aYbXa.toNumber)(pathParams.portalId);
                return {
                    portalId: portalId,
                    pathname: pathname,
                    routeName: routeName
                };
            }
        case 0, $oi8Kq.CLEAR_CONTEXT:
            return {};
        default:
            return state;
    }
}

});
parcelRegister("gvsW5", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => (parcelRequire("oi8Kq")).UPDATE_CONTEXT);
$parcel$export(module.exports, "updateContextAction", () => (parcelRequire("oi8Kq")).updateContextAction);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => (parcelRequire("oi8Kq")).CLEAR_CONTEXT);
$parcel$export(module.exports, "clearContextAction", () => (parcelRequire("oi8Kq")).clearContextAction);

var $oi8Kq = parcelRequire("oi8Kq");

});
parcelRegister("oi8Kq", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => $ef435342e5c08898$export$5f26c565ccbc9352);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => $ef435342e5c08898$export$58f534967683dfbc);
$parcel$export(module.exports, "updateContextAction", () => $ef435342e5c08898$export$42bc3ab9d92c16ac);
$parcel$export(module.exports, "clearContextAction", () => $ef435342e5c08898$export$a40d7f795b5e0d7d);
const $ef435342e5c08898$export$5f26c565ccbc9352 = 'state.ui.context.UPDATE_CONTEXT';
const $ef435342e5c08898$export$58f534967683dfbc = 'state.ui.context.CLEAR_CONTEXT';
const $ef435342e5c08898$export$42bc3ab9d92c16ac = (context)=>({
        type: $ef435342e5c08898$export$5f26c565ccbc9352,
        payload: context
    });
const $ef435342e5c08898$export$a40d7f795b5e0d7d = ()=>({
        type: $ef435342e5c08898$export$58f534967683dfbc
    });

});




parcelRegister("8x6WS", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("61t50")).featuredAndSortedPortalsReducer);

var $61t50 = parcelRequire("61t50");

});
parcelRegister("61t50", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $a60397d0b6cab610$export$be9fe934804fce97);

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("ahGdU");
var $gmXRj = parcelRequire("gmXRj");
parcelRequire("80y9N");
var $ks6At = parcelRequire("ks6At");

var $1btpl = parcelRequire("1btpl");
const $a60397d0b6cab610$export$aa8b8e485fe6d2cc = ()=>{
    const initialModelState = (0, $1btpl.default)();
    return {
        featuredPortalIds: [],
        orderedPortalIds: [],
        hiddenPortalIds: [],
        sortBy: 'POPULARITY',
        isDefaultViewLoading: !(initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals),
        isExpandedViewLoading: false,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false,
        isDirty: false,
        isSaveInProgress: false,
        isPortalReorderingDataLoaded: false
    };
};
const $a60397d0b6cab610$export$95d7509c19bcb89a = (rank)=>rank || 0;
const $a60397d0b6cab610$var$defaultState = $a60397d0b6cab610$export$aa8b8e485fe6d2cc();
function $a60397d0b6cab610$export$be9fe934804fce97(state = $a60397d0b6cab610$var$defaultState, action) {
    switch(action.type){
        case 0, $gmXRj.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL:
            return $a60397d0b6cab610$var$handleFetchFeaturedAndSortedPortalsAction(state, action);
        case 0, $gmXRj.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $a60397d0b6cab610$var$handleFetchFeaturedAndSortedPortalsSuccess(state, action);
        case 0, $gmXRj.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $a60397d0b6cab610$var$handleFetchFeaturedAndSortedPortalsFailure(state, action);
        case 0, $gmXRj.MARK_PORTAL_FEATURED:
            return $a60397d0b6cab610$var$handleMarkPortalFeatured(state, action);
        case 0, $gmXRj.TOGGLE_PORTAL_VISIBILITY:
            return $a60397d0b6cab610$var$handleTogglePortalVisibility(state, action);
        case 0, $gmXRj.REORDER_FEATURED_PORTAL:
            return $a60397d0b6cab610$var$handleReorderFeaturedPortal(state, action);
        case 0, $gmXRj.UPDATE_PORTAL_REORDER_SETTINGS_MODEL:
            return $a60397d0b6cab610$var$handleUpdatePortalReorderSettings(state);
        case 0, $gmXRj.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS:
            return $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsModelSuccess(state);
        case 0, $gmXRj.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE:
            return $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsModelFailure(state);
        case 0, $gmXRj.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsSuccess(state);
        case 0, $gmXRj.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE:
            return $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsFailure(state);
        case 0, $gmXRj.RESET_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $a60397d0b6cab610$var$handleResetPortalReorderSettingsSuccess(state, action);
        case 0, $gmXRj.MARK_PORTAL_REORDER_SETTINGS_DIRTY:
            return $a60397d0b6cab610$var$handleMarkPortalReorderSettingsDirty(state);
        default:
            return state;
    }
}
const $a60397d0b6cab610$var$handleFetchFeaturedAndSortedPortalsAction = (state, action)=>{
    if (action.payload.params.exploreAll) {
        /* On help seekers view, and clicked on exploreAll */ if (!action.payload.params.isPortalReorderingSelected) return {
            ...state,
            isExpandedViewLoading: true
        };
        /* on changing sorted preference on portal reordering screen */ if (action.payload.params.sortBy) return {
            ...state,
            isSortedDataLoading: true,
            sortBy: action.payload.params.sortBy ? action.payload.params.sortBy : 'POPULARITY'
        };
        /* on initial page load for portal reordering screen */ return {
            ...state,
            isReorderingExperienceLoading: true
        };
    }
    /* On help seekers view, initial loading for featured portals or top 6 sorted portals */ return {
        ...state,
        isDefaultViewLoading: true
    };
};
const $a60397d0b6cab610$var$handleFetchFeaturedAndSortedPortalsSuccess = (state, action)=>{
    if (!action.requestParams.isPortalReorderingSelected) {
        /* on Help seeker view - on clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            isExpandedViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
        /* on Help seeker view - initial loading */ return {
            ...state,
            isDefaultViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
    }
    /* on portal reordering screen - on changing sortBy option */ if (action.requestParams.sortBy) return {
        ...state,
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isSortedDataLoading: false,
        sortBy: action.requestParams.sortBy || state.sortBy
    };
    /* on portal reordering screen - initial load */ return {
        ...state,
        featuredPortalIds: action.payload.portals.filter((0, $ks6At.isFeaturedPortal)).sort((portal1, portal2)=>$a60397d0b6cab610$export$95d7509c19bcb89a(portal1.rank) - $a60397d0b6cab610$export$95d7509c19bcb89a(portal2.rank)).map((portal)=>portal.id),
        hiddenPortalIds: action.payload.portals.filter((0, $ks6At.isHiddenPortal)).map((portal)=>portal.id),
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isReorderingExperienceLoading: false,
        sortBy: action.payload.sortBy || state.sortBy,
        isPortalReorderingDataLoaded: true
    };
};
const $a60397d0b6cab610$var$handleFetchFeaturedAndSortedPortalsFailure = (state, action)=>{
    /* Error in  help seekers view*/ if (!action.requestParams.isPortalReorderingSelected) return {
        ...state,
        isExpandedViewLoading: false,
        isDefaultViewLoading: false
    };
    /* Error in portal reordering view */ return {
        ...state,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false
    };
};
const $a60397d0b6cab610$var$handleMarkPortalFeatured = (state, action)=>{
    const { id: id, isFeatured: isFeatured } = action.payload;
    const { featuredPortalIds: featuredPortalIds } = state;
    const updateFeaturedPortalIds = [
        ...featuredPortalIds
    ];
    if (isFeatured) updateFeaturedPortalIds.push(id);
    else (0, $4ZMmh.remove)(updateFeaturedPortalIds, (item)=>item === id);
    return {
        ...state,
        featuredPortalIds: updateFeaturedPortalIds,
        isDirty: true
    };
};
const $a60397d0b6cab610$var$handleTogglePortalVisibility = (state, action)=>{
    const { id: id, hiddenFromHomeScreen: hiddenFromHomeScreen } = action.payload;
    const { hiddenPortalIds: hiddenPortalIds } = state;
    const updatedHiddenPortalIds = [
        ...hiddenPortalIds
    ];
    if (hiddenFromHomeScreen) updatedHiddenPortalIds.push(id);
    else (0, $4ZMmh.remove)(updatedHiddenPortalIds, (item)=>item === id);
    return {
        ...state,
        hiddenPortalIds: (0, $4ZMmh.uniq)(updatedHiddenPortalIds),
        isDirty: true
    };
};
const $a60397d0b6cab610$var$reOrder = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const $a60397d0b6cab610$var$handleReorderFeaturedPortal = (state, action)=>{
    const { oldIndex: oldIndex, newIndex: newIndex } = action.payload;
    return {
        ...state,
        featuredPortalIds: $a60397d0b6cab610$var$reOrder(state.featuredPortalIds, oldIndex, newIndex),
        isDirty: true
    };
};
const $a60397d0b6cab610$var$handleUpdatePortalReorderSettings = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsModelSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsModelFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false
    };
};
const $a60397d0b6cab610$var$handleUpdatePortalReorderSettingsFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: true
    };
};
// Common logic for both Reset and Cancel action
const $a60397d0b6cab610$var$handleResetPortalReorderSettingsSuccess = (state, action)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false,
        sortBy: action.payload.sortBy,
        featuredPortalIds: action.payload.featuredPortalIds,
        orderedPortalIds: action.payload.orderedPortalIds
    };
};
const $a60397d0b6cab610$var$handleMarkPortalReorderSettingsDirty = (state)=>{
    return {
        ...state,
        isDirty: true
    };
};

});


parcelRegister("lpNa4", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => (parcelRequire("bUnK3")).feedbackCollectorReducer);

var $bUnK3 = parcelRequire("bUnK3");

});
parcelRegister("bUnK3", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => $4053e95d321b2c70$export$8085646591e2a0b2);
parcelRequire("6Wh6Q");
var $fNpdN = parcelRequire("fNpdN");

var $iW3CQ = parcelRequire("iW3CQ");
const $4053e95d321b2c70$var$addPortalPrefix = (featureName)=>{
    return 'JSM Portal '.concat(featureName);
};
const $4053e95d321b2c70$export$fe349eba520514db = {
    shouldOpenFeedbackWidget: false,
    showTypeField: false,
    additionalFields: {}
};
const $4053e95d321b2c70$var$defaultState = $4053e95d321b2c70$export$fe349eba520514db;
function $4053e95d321b2c70$export$8085646591e2a0b2(state = $4053e95d321b2c70$var$defaultState, action) {
    switch(action.type){
        case 0, $fNpdN.SHOW_FEEDACK_COLLECTOR:
            return $4053e95d321b2c70$var$handleFeedbackCollector(state, action);
        case 0, $fNpdN.HIDE_FEEDACK_COLLECTOR:
            return $4053e95d321b2c70$var$handleFeedbackCollector(state, action);
        case 0, $fNpdN.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR:
            return $4053e95d321b2c70$var$handleUpdateAdditionalFieldsInFeedbackCollector(state, action);
        default:
            return state;
    }
}
const $4053e95d321b2c70$var$handleFeedbackCollector = (state, action)=>{
    if (action.type === (0, $fNpdN.HIDE_FEEDACK_COLLECTOR)) return {
        ...state,
        shouldOpenFeedbackWidget: false
    };
    const { showTypeField: showTypeField, CustomComponent: CustomComponent, featureName: featureName, env: env } = action.payload;
    const newState = {
        ...state,
        showTypeField: showTypeField,
        CustomComponent: CustomComponent,
        shouldOpenFeedbackWidget: true
    };
    if (env === (0, $iW3CQ.EnvType).PROD) {
        newState.additionalFields = {
            // Do not change this field as this is an actual custom field in https://jira-feedback.atlassian.net. Changing this will break feedback collector in production.
            customfield_10076: $4053e95d321b2c70$var$addPortalPrefix(featureName)
        };
        return newState;
    }
    newState.additionalFields = {
        // Do not change this field as this is an actual custom field in https://arajpal.atlassian.net. Changing this will break feedback collector in staging.
        customfield_10094: $4053e95d321b2c70$var$addPortalPrefix(featureName)
    };
    return newState;
};
const $4053e95d321b2c70$var$handleUpdateAdditionalFieldsInFeedbackCollector = (state, action)=>{
    return {
        ...state,
        additionalFields: {
            ...state.additionalFields,
            ...action.payload.additionalFields
        }
    };
};

});
parcelRegister("6Wh6Q", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => (parcelRequire("fNpdN")).SHOW_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "showFeedbackCollector", () => (parcelRequire("fNpdN")).showFeedbackCollector);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => (parcelRequire("fNpdN")).HIDE_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "hideFeedbackCollector", () => (parcelRequire("fNpdN")).hideFeedbackCollector);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => (parcelRequire("fNpdN")).UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => (parcelRequire("fNpdN")).updateAdditionalFieldsInFeedbackCollector);

var $fNpdN = parcelRequire("fNpdN");

});
parcelRegister("fNpdN", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => $99adce8f13bb5b5a$export$e920d8568364aa72);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => $99adce8f13bb5b5a$export$20dd51f415d7804e);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => $99adce8f13bb5b5a$export$3366d0333401654a);
$parcel$export(module.exports, "showFeedbackCollector", () => $99adce8f13bb5b5a$export$c759098e05f62ce0);
$parcel$export(module.exports, "hideFeedbackCollector", () => $99adce8f13bb5b5a$export$92f2211d73785c9);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => $99adce8f13bb5b5a$export$41e78cf91821ccad);
const $99adce8f13bb5b5a$export$e920d8568364aa72 = 'state.ui.feedback-collector.SHOW_FEEDACK_COLLECTOR';
const $99adce8f13bb5b5a$export$20dd51f415d7804e = 'state.ui.feedback-collector.HIDE_FEEDACK_COLLECTOR';
const $99adce8f13bb5b5a$export$3366d0333401654a = 'state.ui.feedback-collector.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR';
const $99adce8f13bb5b5a$export$c759098e05f62ce0 = (payload)=>({
        payload: payload,
        type: $99adce8f13bb5b5a$export$e920d8568364aa72
    });
const $99adce8f13bb5b5a$export$92f2211d73785c9 = ()=>({
        type: $99adce8f13bb5b5a$export$20dd51f415d7804e
    });
const $99adce8f13bb5b5a$export$41e78cf91821ccad = (additionalFields)=>({
        type: $99adce8f13bb5b5a$export$3366d0333401654a,
        payload: {
            additionalFields: additionalFields
        }
    });

});




parcelRegister("2kj1h", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => (parcelRequire("jmAg3")).flagsReducer);

var $jmAg3 = parcelRequire("jmAg3");

});
parcelRegister("jmAg3", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => $8b379a085a79e646$export$64fc5b4c35b25733);

var $xb2jO = parcelRequire("xb2jO");
const $8b379a085a79e646$var$MAX_FLAG_ID = 99999;
const $8b379a085a79e646$var$defaultState = {
    flags: []
};
function $8b379a085a79e646$export$64fc5b4c35b25733(state = $8b379a085a79e646$var$defaultState, action) {
    switch(action.type){
        case 0, $xb2jO.SHOW_ERROR_FLAG:
            return $8b379a085a79e646$var$handleShowErrorFlag(state, action);
        case 0, $xb2jO.SHOW_WARNING_FLAG:
            return $8b379a085a79e646$var$handleShowWarningFlag(state, action);
        case 0, $xb2jO.SHOW_SUCCESS_FLAG:
            return $8b379a085a79e646$var$handleShowSuccessFlag(state, action);
        case 0, $xb2jO.DISMISS_FLAG:
            return $8b379a085a79e646$var$handleFlagDismissal(state, action);
        case 0, $xb2jO.SHOW_BOLD_APPEARANCE_FLAG:
            return $8b379a085a79e646$var$handleShowBoldAppearanceFlag(state, action);
        default:
            return state;
    }
}
function $8b379a085a79e646$var$handleShowErrorFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8b379a085a79e646$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'error'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $8b379a085a79e646$var$handleShowWarningFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8b379a085a79e646$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'warning'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $8b379a085a79e646$var$handleShowSuccessFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8b379a085a79e646$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'success'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $8b379a085a79e646$var$handleShowBoldAppearanceFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8b379a085a79e646$var$generateFlagId(),
        appearance: action.payload.appearance,
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        dismissActionValue: action.payload.dismissActionValue,
        type: 'bold'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
const $8b379a085a79e646$var$generateFlagId = ()=>// Integer between 0 and MAX_FLAG_ID
    Math.floor(Math.random() * Math.floor($8b379a085a79e646$var$MAX_FLAG_ID));
function $8b379a085a79e646$var$handleFlagDismissal(state, action) {
    const updatedFlags = state.flags.filter((flag)=>flag.id !== action.payload.flagId);
    return {
        ...state,
        flags: updatedFlags
    };
}

});


parcelRegister("hDQSM", function(module, exports) {
$parcel$export(module.exports, "helpcenterPreviewReducer", () => (parcelRequire("hp2QN")).default);

var $hp2QN = parcelRequire("hp2QN");

});
parcelRegister("hp2QN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cae94a4185ed482$export$2e2bcd8739ae039);

var $cywwP = parcelRequire("cywwP");

var $4ZMmh = parcelRequire("4ZMmh");
const $3cae94a4185ed482$var$getDefaultState = ()=>({
        isCustomizing: false,
        isSaveInProgress: false,
        translations: {},
        uploadsInProgress: {}
    });
function $3cae94a4185ed482$export$2e2bcd8739ae039(state = $3cae94a4185ed482$var$getDefaultState(), action) {
    switch(action.type){
        case $cywwP.UPDATE_HELP_CENTER_PREVIEW_MODEL:
            {
                const newState = (0, $4ZMmh.mergeWith)({}, {
                    ...state
                }, {
                    ...action.payload
                }, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/ban-types
                (_, srcValue)=>{
                    // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
                    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
                    if (srcValue === undefined) return null;
                    // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
                    return undefined;
                });
                return {
                    ...newState
                };
            }
        case $cywwP.EDITING_HELP_CENTER:
            return {
                ...state,
                isCustomizing: action.payload
            };
        case $cywwP.CLEAR_HELP_CENTER_PREVIEW_MODEL:
            return {
                translations: {},
                uploadsInProgress: {},
                isCustomizing: false,
                isSaveInProgress: false
            };
        case $cywwP.UPDATE_HELP_CENTER_BRANDING:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $cywwP.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $cywwP.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $cywwP.UPDATE_HELP_CENTER_BRANDING_SAVE_START:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $cywwP.UPDATE_HELP_CENTER_BRANDING_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $cywwP.UPLOAD_START:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: true
                }
            };
        case $cywwP.UPLOAD_END:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: false
                }
            };
        default:
            return state;
    }
}

});


parcelRegister("3qoeW", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => (parcelRequire("lTwS1")).invitedSignUpUiReducer);

var $lTwS1 = parcelRequire("lTwS1");

});
parcelRegister("lTwS1", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => $8ce9e1d919eb2aef$export$cbd9046ae6d17b9c);
parcelRequire("xOZC4");
var $jN84E = parcelRequire("jN84E");
const $8ce9e1d919eb2aef$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    error: undefined
};
function $8ce9e1d919eb2aef$export$cbd9046ae6d17b9c(state = $8ce9e1d919eb2aef$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $jN84E.INVITED_SIGN_UP:
            return $8ce9e1d919eb2aef$var$handleInvitedSignUp(state);
        case 0, $jN84E.INVITED_SIGN_UP_FAILURE:
            return $8ce9e1d919eb2aef$var$handleInvitedSignUpFailure(state, action);
        default:
            return state;
    }
}
const $8ce9e1d919eb2aef$var$handleInvitedSignUp = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $8ce9e1d919eb2aef$var$handleInvitedSignUpFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("5fSTa", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => (parcelRequire("3XQvD")).loginUiReducer);

var $3XQvD = parcelRequire("3XQvD");

});
parcelRegister("3XQvD", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => $4c4b3740a74cc5bc$export$b52e2813f588ee78);
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");

var $O9KKV = parcelRequire("O9KKV");
const $4c4b3740a74cc5bc$export$49d5fc8cba920a0 = {
    email: '',
    atlassianAccountCheckPerformed: false,
    isSubmitting: false,
    isSendingForgotPasswordEmail: false,
    isSendingCreatePasswordEmail: false,
    authInfo: {
        accountStage: (0, $O9KKV.AccountStageType).LOGIN,
        authMethods: new Map([
            [
                (0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    showPasswordConfirmation: false,
    showSsoTestModeErrorPage: false,
    showLoginConsentErrorPage: false
};
function $4c4b3740a74cc5bc$export$b52e2813f588ee78(state = $4c4b3740a74cc5bc$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $xAy39.CHANGE_EMAIL_INPUT:
            return $4c4b3740a74cc5bc$var$handleChangeEmailInput(state, action);
        case 0, $xAy39.CHECK_LOGIN_ACTION:
            return $4c4b3740a74cc5bc$var$handleCheckLoginActionAction(state);
        case 0, $xAy39.CHECK_LOGIN_ACTION_SUCCESS:
            return $4c4b3740a74cc5bc$var$handleCheckLoginActionSuccess(state, action);
        case 0, $xAy39.CHECK_LOGIN_ACTION_FAILURE:
            return $4c4b3740a74cc5bc$var$handleCheckLoginActionFailure(state, action);
        case 0, $xAy39.CREATE_PASSWORD:
            return $4c4b3740a74cc5bc$var$handleCreatePassword(state);
        case 0, $xAy39.FORGOT_PASSWORD:
            return $4c4b3740a74cc5bc$var$handleForgotPassword(state);
        case 0, $xAy39.FORGOT_PASSWORD_FAILURE:
            return $4c4b3740a74cc5bc$var$handleForgotPasswordFailure(state);
        case 0, $xAy39.FORGOT_PASSWORD_SUCCESS:
            return $4c4b3740a74cc5bc$var$handleForgotPasswordSuccess(state);
        case 0, $xAy39.CREATE_PASSWORD_SUCCESS:
            return $4c4b3740a74cc5bc$var$handleCreatePasswordSuccess(state);
        case 0, $xAy39.LOGIN_ATTEMPT:
            return $4c4b3740a74cc5bc$var$handleLoginAttempt(state);
        case 0, $xAy39.LOGIN_ATTEMPT_SUCCESS:
            return $4c4b3740a74cc5bc$var$handleLoginAttemptSuccess(state, action);
        case 0, $xAy39.LOGIN_ATTEMPT_FAILURE:
            return $4c4b3740a74cc5bc$var$handleLoginAttemptFailure(state, action);
        case 0, $xAy39.CA_SSO_TEST_MODE_FAILURE:
            return $4c4b3740a74cc5bc$var$handleCaSsoTestModeFailure(state);
        case 0, $xAy39.LOGIN_CONSENT_FAILURE:
            return $4c4b3740a74cc5bc$var$handleLoginConsentFailure(state);
        case 0, $xAy39.RESET_LOGIN:
            return $4c4b3740a74cc5bc$var$resetLogin(action);
        default:
            return state;
    }
}
const $4c4b3740a74cc5bc$var$handleChangeEmailInput = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        email: action.payload.email
    });
const $4c4b3740a74cc5bc$var$handleCheckLoginActionAction = (state)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: undefined
    });
const $4c4b3740a74cc5bc$var$handleCheckLoginActionSuccess = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: true,
        authInfo: {
            ...state.authInfo,
            accountStage: action.payload.authInfo.accountStage,
            authMethods: action.payload.authInfo.authMethods
        },
        error: undefined
    });
const $4c4b3740a74cc5bc$var$handleCaSsoTestModeFailure = (state)=>({
        ...state,
        showSsoTestModeErrorPage: true
    });
const $4c4b3740a74cc5bc$var$handleLoginConsentFailure = (state)=>({
        ...state,
        showLoginConsentErrorPage: true
    });
const $4c4b3740a74cc5bc$var$handleCheckLoginActionFailure = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: action.payload.error
    });
const $4c4b3740a74cc5bc$var$handleCreatePassword = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: true
    });
const $4c4b3740a74cc5bc$var$handleCreatePasswordSuccess = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: false,
        showPasswordConfirmation: true
    });
const $4c4b3740a74cc5bc$var$handleForgotPassword = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: true
    });
const $4c4b3740a74cc5bc$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false
    });
const $4c4b3740a74cc5bc$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false,
        showPasswordConfirmation: true
    });
const $4c4b3740a74cc5bc$var$handleLoginAttempt = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined,
        loginAttemptResponse: undefined
    });
function $4c4b3740a74cc5bc$var$handleLoginAttemptSuccess(state, action) {
    const { loginAttemptResponse: loginAttemptResponse } = action.payload;
    const defaultValues = {
        loginAttemptResponse: loginAttemptResponse,
        isSubmitting: false,
        error: undefined
    };
    if (loginAttemptResponse.loginSucceeded) return {
        ...state,
        ...defaultValues,
        email: '',
        atlassianAccountCheckPerformed: false
    };
    return {
        ...state,
        ...defaultValues
    };
}
const $4c4b3740a74cc5bc$var$handleLoginAttemptFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        loginAttemptResponse: undefined,
        error: action.payload.error
    });
const $4c4b3740a74cc5bc$var$resetLogin = (action)=>({
        ...$4c4b3740a74cc5bc$export$49d5fc8cba920a0,
        email: action.payload.email
    });

});


parcelRegister("jajxI", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("1vUiY")).loginAnnouncementsReducer);

var $1vUiY = parcelRequire("1vUiY");

});
parcelRegister("1vUiY", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $2059565d277153f8$export$14afe2784a94db4d);
parcelRequire("f2i8V");
var $osBO5 = parcelRequire("osBO5");

var $1btpl = parcelRequire("1btpl");
const $2059565d277153f8$export$13a9a218541141cd = ()=>{
    const initialModelState = (0, $1btpl.default)();
    return {
        loginAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements ? initialModelState.loginAnnouncements : {
            defaultLocale: '',
            translatedLoginAnnouncements: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $2059565d277153f8$var$doesContainLocaleDisplayName = (translatedLoginAnnouncement)=>{
    return 'localeDisplayName' in translatedLoginAnnouncement && !!translatedLoginAnnouncement.localeDisplayName;
};
const $2059565d277153f8$export$49d5fc8cba920a0 = $2059565d277153f8$export$13a9a218541141cd();
const $2059565d277153f8$export$a85783f8b89d3dc8 = (payload, state)=>{
    return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$loginAnnouncem;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $2059565d277153f8$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$loginAnnouncem = state.loginAnnouncementsResponse.translatedLoginAnnouncements[languageKey]) === null || _state$loginAnnouncem === void 0 ? void 0 : _state$loginAnnouncem.localeDisplayName
            }
        };
    }, {});
};
function $2059565d277153f8$export$14afe2784a94db4d(state = $2059565d277153f8$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $osBO5.FETCH_LOGIN_ANNOUNCEMENTS:
            return $2059565d277153f8$var$handleFetchLoginAnnouncements(state, true);
        case 0, $osBO5.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return $2059565d277153f8$var$handleFetchLoginAnnouncementsSuccess(state, action.payload, false);
        case 0, $osBO5.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE:
            return $2059565d277153f8$var$handleFetchLoginAnnouncements(state, false);
        case 0, $osBO5.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL:
            {
                const newState = {
                    ...state,
                    loginAnnouncementsResponse: {
                        ...state.loginAnnouncementsResponse,
                        translatedLoginAnnouncements: $2059565d277153f8$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $osBO5.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $osBO5.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                loginAnnouncementsResponse: {
                    ...state.loginAnnouncementsResponse,
                    translatedLoginAnnouncements: $2059565d277153f8$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                }
            };
        case 0, $osBO5.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
        case 0, $osBO5.RESET_LOGIN_ANNOUNCEMENTS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}
const $2059565d277153f8$var$handleFetchLoginAnnouncementsSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        loginAnnouncementsResponse: {
            ...state.loginAnnouncementsResponse,
            defaultLocale: payload.defaultLocale,
            translatedLoginAnnouncements: $2059565d277153f8$export$a85783f8b89d3dc8(payload.translatedLoginAnnouncements, state)
        },
        isSaveFailed: false
    });
const $2059565d277153f8$var$handleFetchLoginAnnouncements = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });

});


parcelRegister("33wXA", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("eEo6k")).portalReducer);

var $eEo6k = parcelRequire("eEo6k");

});
parcelRegister("eEo6k", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => $c68ffa67ea7f6fbc$export$7b4acfe1c1a43b7c);

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");

var $1btpl = parcelRequire("1btpl");
const $c68ffa67ea7f6fbc$export$db2e6bec0a5d318f = ()=>{
    var _initialModelState$po, _initialModelState$po2;
    const initialModelState = (0, $1btpl.default)();
    return {
        portalAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && (_initialModelState$po = initialModelState.portal) !== null && _initialModelState$po !== void 0 && _initialModelState$po.portalAnnouncement ? initialModelState === null || initialModelState === void 0 || (_initialModelState$po2 = initialModelState.portal) === null || _initialModelState$po2 === void 0 ? void 0 : _initialModelState$po2.portalAnnouncement : {
            canAdministerProject: false,
            canEditAnnouncement: false,
            defaultLanguageDisplayName: '',
            defaultLanguageHeader: '',
            defaultLanguageMessage: '',
            isUsingLanguageSupport: false,
            portalId: 0,
            portalProjectKey: '',
            userLanguageHeader: '',
            userLanguageMessageWiki: '',
            translations: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $c68ffa67ea7f6fbc$var$doesContainLocaleDisplayName = (translatedPortalAnnouncement)=>'localeDisplayName' in translatedPortalAnnouncement && !!translatedPortalAnnouncement.localeDisplayName;
const $c68ffa67ea7f6fbc$export$49d5fc8cba920a0 = $c68ffa67ea7f6fbc$export$db2e6bec0a5d318f();
const $c68ffa67ea7f6fbc$export$76e9a6f613765d59 = (payload, state)=>{
    if (payload && !(0, $4ZMmh.isEmpty)(payload)) return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$portalAnnounce;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $c68ffa67ea7f6fbc$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$portalAnnounce = state.portalAnnouncementsResponse.translations) === null || _state$portalAnnounce === void 0 || (_state$portalAnnounce = _state$portalAnnounce[languageKey]) === null || _state$portalAnnounce === void 0 ? void 0 : _state$portalAnnounce.localeDisplayName
            }
        };
    }, {});
    return {};
};
const $c68ffa67ea7f6fbc$var$handleFetchPortalSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        portalAnnouncementsResponse: {
            ...payload,
            defaultLanguageDisplayName: payload.defaultLanguageDisplayName,
            translations: $c68ffa67ea7f6fbc$export$76e9a6f613765d59(payload.translations, state)
        },
        isSaveFailed: false
    });
const $c68ffa67ea7f6fbc$var$handleFetchPortal = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });
function $c68ffa67ea7f6fbc$export$7b4acfe1c1a43b7c(state = $c68ffa67ea7f6fbc$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $jeW3I.FETCH_PORTAL_MODEL:
            return $c68ffa67ea7f6fbc$var$handleFetchPortal(state, true);
        case 0, $jeW3I.FETCH_PORTAL_SUCCESS:
            return $c68ffa67ea7f6fbc$var$handleFetchPortalSuccess(state, action.payload.portalAnnouncement, false);
        case 0, $jeW3I.FETCH_PORTAL_FAILURE:
            return $c68ffa67ea7f6fbc$var$handleFetchPortal(state, false);
        case 0, $jeW3I.UPDATE_PORTAL_ANNOUNCEMENT_MODEL:
            {
                const newState = {
                    ...state,
                    portalAnnouncementsResponse: {
                        ...state.portalAnnouncementsResponse,
                        translations: $c68ffa67ea7f6fbc$export$76e9a6f613765d59(action.payload.translations, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $jeW3I.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $jeW3I.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                portalAnnouncementsResponse: {
                    ...state.portalAnnouncementsResponse,
                    ...action.payload,
                    translations: $c68ffa67ea7f6fbc$export$76e9a6f613765d59(action.payload.translations, state)
                }
            };
        case 0, $jeW3I.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}

});


parcelRegister("8wnFc", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("daZ9q")).default);
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => (parcelRequire("daZ9q")).PLACEHOLDER_REQUEST_GROUP_ID);

var $daZ9q = parcelRequire("daZ9q");

});
parcelRegister("daZ9q", function(module, exports) {
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => $88ebc57c63e8646c$export$1d5c0939993f01ba);
$parcel$export(module.exports, "default", () => $88ebc57c63e8646c$export$2e2bcd8739ae039);
parcelRequire("6WAjm");
var $f4Rep = parcelRequire("f4Rep");
parcelRequire("700bz");
var $br0Cz = parcelRequire("br0Cz");
parcelRequire("8EnIC");
var $jubPh = parcelRequire("jubPh");
parcelRequire("ovmd1");
var $3UF8G = parcelRequire("3UF8G");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("3dIfO");
var $buG9s = parcelRequire("buG9s");
parcelRequire("ahMzO");
var $gmBeu = parcelRequire("gmBeu");
parcelRequire("l3hoq");
var $eB2UK = parcelRequire("eB2UK");
parcelRequire("do8oT");
var $c5rB4 = parcelRequire("c5rB4");
parcelRequire("bIbo7");
var $fK096 = parcelRequire("fK096");
const $88ebc57c63e8646c$export$1d5c0939993f01ba = -1;
const $88ebc57c63e8646c$var$getDefaultState = ()=>({
        requestGroups: undefined,
        requestGroupsOrder: undefined,
        requestTypesOrder: undefined,
        requestTypesInRequestGroup: undefined,
        requestTypesNotInRequestGroup: undefined,
        parentRequestGroups: undefined,
        error: undefined,
        groupNameThatCausedError: undefined,
        isParentRequestGroupsLoading: false
    });
function $88ebc57c63e8646c$export$2e2bcd8739ae039(state = $88ebc57c63e8646c$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $buG9s.UPDATE_REQUEST_GROUPS_ORDER:
            return {
                ...state,
                requestGroupsOrder: action.payload.order
            };
        case 0, $f4Rep.ADD_REQUEST_GROUP:
            {
                const newGroup = {
                    name: action.payload.groupName,
                    id: $88ebc57c63e8646c$export$1d5c0939993f01ba // We don't have an id yet because the request hasn't completed, we put in a fake number temporarily. the groups here will get cleared when the persisted model is fetched
                };
                return {
                    ...state,
                    requestGroups: [
                        ...action.payload.existingGroups,
                        newGroup
                    ],
                    error: undefined,
                    groupNameThatCausedError: undefined
                };
            }
        case 0, $f4Rep.ADD_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestGroups: undefined,
                error: action.payload.message,
                groupNameThatCausedError: action.payload.groupNameThatCausedError
            };
        case 0, $jubPh.CREATE_GROUP_WITH_REQUEST_TYPE:
            return {
                ...state,
                isParentRequestGroupsLoading: true
            };
        case 0, $jubPh.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $jubPh.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $3UF8G.DELETE_REQUEST_TYPE_FROM_GROUP:
            {
                const { requestTypes: requestTypes, index: index } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const udpatedRequestTypeIds = (0, $fK096.deleteFromList)(requestTypeIds, index);
                return {
                    ...state,
                    requestTypesInRequestGroup: undefined,
                    requestTypesNotInRequestGroup: undefined,
                    requestTypesOrder: udpatedRequestTypeIds
                };
            }
        case 0, $c5rB4.SET_REQUEST_TYPE_GROUPS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    parentRequestGroups: requestGroups
                };
            }
        case 0, $c5rB4.SET_REQUEST_TYPE_GROUPS_FAILED:
            return {
                ...state,
                parentRequestGroups: undefined
            };
        case 0, $gmBeu.REORDER_REQUEST_TYPE:
            {
                const { requestTypes: requestTypes, fromIndex: fromIndex, toIndex: toIndex } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const updatedRequestTypeIds = (0, $fK096.reorderList)(requestTypeIds, fromIndex, toIndex);
                return {
                    ...state,
                    requestTypesOrder: updatedRequestTypeIds
                };
            }
        case 0, $jeW3I.FETCH_PORTAL_SUCCESS:
            return $88ebc57c63e8646c$var$getDefaultState();
        case 0, $br0Cz.ADD_REQUEST_TYPE_TO_REQUEST_GROUP:
            {
                const { requestType: requestType, requestTypesNotInRequestGroup: requestTypesNotInRequestGroup, requestTypesInRequestGroup: requestTypesInRequestGroup } = action.payload;
                // Remove request type from requestTypesNotInRequestGroup used for request type search options
                const optimisticRequestTypesNotInRequestGroup = requestTypesNotInRequestGroup.filter((requestTypeNotInRequestGroup)=>requestTypeNotInRequestGroup.id !== requestType.id);
                // Add request type as the last element of requestTypesInRequestGroup used to render request types in group
                const optimisticRequestTypesInRequestGroup = [
                    ...requestTypesInRequestGroup,
                    requestType
                ];
                // This will have the new request type as the last index (the order will then be persisted)
                const requestTypeIds = optimisticRequestTypesInRequestGroup.map(({ id: requestTypeId })=>Number(requestTypeId));
                return {
                    ...state,
                    requestTypesOrder: requestTypeIds,
                    requestTypesInRequestGroup: [
                        ...optimisticRequestTypesInRequestGroup
                    ],
                    requestTypesNotInRequestGroup: [
                        ...optimisticRequestTypesNotInRequestGroup
                    ],
                    error: undefined
                };
            }
        case 0, $br0Cz.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestTypesOrder: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: action.payload.message
            };
        case 0, $buG9s.CLEAR_REQUEST_TYPES_ORDER:
            return {
                ...state,
                requestGroups: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: undefined,
                requestTypesOrder: undefined
            };
        case 0, $buG9s.CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                error: undefined,
                groupNameThatCausedError: undefined,
                requestTypesOrder: undefined
            };
        // Reset any errors and clear the UI state version of request groups so it can be populated with the newly persisted list as the new source of truth
        case 0, $buG9s.CLEAR_REQUEST_GROUPS_ORDER:
            return $88ebc57c63e8646c$var$getDefaultState();
        // On successful edit clear UI state order, and use the newly persisted request groups state as the source of truth for the request groups list.
        case 0, $eB2UK.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    requestGroups: requestGroups,
                    requestGroupsOrder: undefined
                };
            }
        default:
            return state;
    }
}

});
parcelRegister("bIbo7", function(module, exports) {
$parcel$export(module.exports, "deleteFromList", () => (parcelRequire("fK096")).deleteFromList);
$parcel$export(module.exports, "reorderList", () => (parcelRequire("fK096")).reorderList);
parcelRequire("fK096");

});
parcelRegister("fK096", function(module, exports) {
$parcel$export(module.exports, "reorderList", () => $9b2eee820ba5fe22$export$1c97eb4883130bfd);
$parcel$export(module.exports, "deleteFromList", () => $9b2eee820ba5fe22$export$e786ade68cfa1610);
/** Utility functions to assist managing drop events in React Beautiful DnD */ 
var $4ZMmh = parcelRequire("4ZMmh");
const $9b2eee820ba5fe22$export$1c97eb4883130bfd = (list, fromIndex, toIndex)=>{
    const newList = Array.from(list);
    if (!(0, $4ZMmh.isNil)(toIndex) && !(0, $4ZMmh.isNil)(fromIndex)) {
        newList.splice(fromIndex, 1);
        newList.splice(toIndex, 0, list[fromIndex]);
    }
    return newList;
};
const $9b2eee820ba5fe22$export$e786ade68cfa1610 = (list, index)=>{
    const newList = Array.from(list);
    if (!(0, $4ZMmh.isNil)(index)) newList.splice(index, 1);
    return newList;
};

});




parcelRegister("2rGUa", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("aC7BT")).requestDetailsReducer);
$parcel$export(module.exports, "ApprovalDecision", () => (parcelRequire("aC7BT")).ApprovalDecision);

var $aC7BT = parcelRequire("aC7BT");

});
parcelRegister("aC7BT", function(module, exports) {
$parcel$export(module.exports, "ApprovalDecision", () => $d5e703a3624b103c$export$b84e6e5b33fd1d21);
$parcel$export(module.exports, "requestDetailsReducer", () => $d5e703a3624b103c$export$dfa3e5ac1f5274b8);
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");
var $d5e703a3624b103c$export$b84e6e5b33fd1d21 = /*#__PURE__*/ function(ApprovalDecision) {
    ApprovalDecision[ApprovalDecision["APPROVE"] = 0] = "APPROVE";
    ApprovalDecision[ApprovalDecision["DECLINE"] = 1] = "DECLINE";
    return ApprovalDecision;
}({});
const $d5e703a3624b103c$var$defaultState = {
    commentSubmitting: false,
    commentBeingSubmitted: undefined
};
function $d5e703a3624b103c$export$dfa3e5ac1f5274b8(state = $d5e703a3624b103c$var$defaultState, action) {
    switch(action.type){
        case 0, $gXSFL.TRANSITION_REQUEST:
            return $d5e703a3624b103c$var$handleTransition(state, action);
        case 0, $gXSFL.TRANSITION_REQUEST_FAILURE:
            return $d5e703a3624b103c$var$handleTransitionFailure(state, action);
        case 0, $gXSFL.CLEAR_TRANSITION_REQUEST_FAILURE:
            return $d5e703a3624b103c$var$handleClearTransitionFailure(state);
        case 0, $gXSFL.FETCH_REQUEST_DETAILS_SUCCESS:
            return $d5e703a3624b103c$var$defaultState;
        case 0, $gXSFL.CREATE_COMMENT:
            return $d5e703a3624b103c$var$handleCommentCreate(state, action);
        case 0, $gXSFL.CREATE_COMMENT_SUCCESS:
            return $d5e703a3624b103c$var$handleCommentCreateSuccess(state);
        case 0, $gXSFL.CREATE_COMMENT_FAILURE:
            return $d5e703a3624b103c$var$handleCommentCreateFailure(state);
        case 0, $gXSFL.SHOW_TRANSITION_DIALOG:
            return $d5e703a3624b103c$var$handleShowTransitionDialog(state, action);
        case 0, $gXSFL.HIDE_TRANSITION_DIALOG:
            return $d5e703a3624b103c$var$handleHideTransitionDialog(state);
        case 0, $gXSFL.DECIDE_APPROVAL:
            return $d5e703a3624b103c$var$handleDecideApproval(state, action);
        case 0, $gXSFL.DECIDE_APPROVAL_FAILURE:
            return $d5e703a3624b103c$var$handleDecideApprovalFailure(state);
        default:
            return state;
    }
}
const $d5e703a3624b103c$var$handleShowTransitionDialog = (state, action)=>({
        ...state,
        visibleTransitionDialog: action.payload.id
    });
const $d5e703a3624b103c$var$handleHideTransitionDialog = (state)=>({
        ...state,
        visibleTransitionDialog: undefined
    });
const $d5e703a3624b103c$var$handleTransition = (state, action)=>({
        ...state,
        inProgressTransitionId: action.payload.transitionId,
        transitionFailure: undefined
    });
function $d5e703a3624b103c$var$handleDecideApproval(state, action) {
    const approvalDecision = action.payload.approve ? 0 : 1;
    return {
        ...state,
        inProgressApprovalAction: approvalDecision
    };
}
const $d5e703a3624b103c$var$handleDecideApprovalFailure = (state)=>({
        ...state,
        inProgressApprovalAction: undefined
    });
const $d5e703a3624b103c$var$handleTransitionFailure = (state, action)=>({
        ...state,
        inProgressTransitionId: undefined,
        transitionFailure: action.payload.error
    });
const $d5e703a3624b103c$var$handleClearTransitionFailure = (state)=>({
        ...state,
        transitionFailure: undefined
    });
const $d5e703a3624b103c$var$handleCommentCreate = (state, action)=>({
        ...state,
        commentSubmitting: true,
        commentBeingSubmitted: action.payload.comment
    });
const $d5e703a3624b103c$var$handleCommentCreateSuccess = (state)=>({
        ...state,
        commentSubmitting: false,
        commentBeingSubmitted: undefined
    });
const $d5e703a3624b103c$var$handleCommentCreateFailure = (state)=>({
        ...state,
        commentSubmitting: false
    });

});


parcelRegister("5gZTW", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("1vv1a")).requestListReducer);

var $1vv1a = parcelRequire("1vv1a");

});
parcelRegister("1vv1a", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $79e15f8dcf513bdd$export$476a1a148617ffd3);
parcelRequire("cqYZw");
var $jJY1A = parcelRequire("jJY1A");
const $79e15f8dcf513bdd$var$defaultState = {
    isLoading: false
};
function $79e15f8dcf513bdd$export$476a1a148617ffd3(state = $79e15f8dcf513bdd$var$defaultState, action) {
    switch(action.type){
        case 0, $jJY1A.FETCH_REQUEST_LIST_MODEL:
            return $79e15f8dcf513bdd$var$handleFetchRequestListAction(state);
        case 0, $jJY1A.FETCH_REQUEST_LIST_SUCCESS:
            return $79e15f8dcf513bdd$var$handleFetchRequestListSuccess(state);
        case 0, $jJY1A.FETCH_REQUEST_LIST_FAILURE:
            return $79e15f8dcf513bdd$var$handleFetchRequestListFailure(state);
        default:
            return state;
    }
}
const $79e15f8dcf513bdd$var$handleFetchRequestListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $79e15f8dcf513bdd$var$handleFetchRequestListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $79e15f8dcf513bdd$var$handleFetchRequestListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("aVXp3", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => (parcelRequire("8IYBK")).resendVerifyReducer);

var $8IYBK = parcelRequire("8IYBK");

});
parcelRegister("8IYBK", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => $57aba95302ca14fb$export$92942a05b04ae72);
parcelRequire("76IQl");
var $1nXbO = parcelRequire("1nXbO");

var $2pRWd = parcelRequire("2pRWd");
const $57aba95302ca14fb$export$49d5fc8cba920a0 = {
    value: (0, $2pRWd.ResendStatus).NONE
};
function $57aba95302ca14fb$export$92942a05b04ae72(state = $57aba95302ca14fb$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $1nXbO.FETCH_RESEND_VERIFY_EMAIL:
            return {
                value: (0, $2pRWd.ResendStatus).RESENDING
            };
        case 0, $1nXbO.FETCH_RESEND_VERIFICATION_SUCCESS:
            return {
                value: (0, $2pRWd.ResendStatus).SUCCEEDED
            };
        case 0, $1nXbO.FETCH_RESEND_VERIFICATION_FAILURE:
            return {
                errorStatus: action.payload.error,
                value: (0, $2pRWd.ResendStatus).FAILED
            };
        default:
            return state;
    }
}

});
parcelRegister("2pRWd", function(module, exports) {
$parcel$export(module.exports, "ResendStatus", () => $174e1c1f43890297$export$167f7de0a3de3f78);
const $174e1c1f43890297$export$167f7de0a3de3f78 = {
    NONE: 'NONE',
    RESENDING: 'RESENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};

});



parcelRegister("kWW84", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("jtV2A")).resetPasswordReducer);

var $jtV2A = parcelRequire("jtV2A");

});
parcelRegister("jtV2A", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $0aef49b93316166a$export$b0c3be5071e95c02);
parcelRequire("7dLth");
var $do9VR = parcelRequire("do9VR");
const $0aef49b93316166a$var$defaultState = {
    isSubmitting: false
};
function $0aef49b93316166a$export$b0c3be5071e95c02(state = $0aef49b93316166a$var$defaultState, action) {
    switch(action.type){
        case 0, $do9VR.RESET_PASSWORD:
            return $0aef49b93316166a$var$handleResetPassword(state);
        case 0, $do9VR.RESET_PASSWORD_FAILURE:
            return $0aef49b93316166a$var$handleResetPasswordFailure(state, action);
        default:
            return state;
    }
}
const $0aef49b93316166a$var$handleResetPassword = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $0aef49b93316166a$var$handleResetPasswordFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("78p6t", function(module, exports) {
$parcel$export(module.exports, "searchReducer", () => (parcelRequire("5idyo")).default);

var $5idyo = parcelRequire("5idyo");

});
parcelRegister("5idyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aa4b198cf14c1da$export$2e2bcd8739ae039);
parcelRequire("5aCJX");
var $j4AtC = parcelRequire("j4AtC");

var $eDcdn = parcelRequire("eDcdn");

var $5LmQo = parcelRequire("5LmQo");
const $9aa4b198cf14c1da$var$generateDefaultSearchResults = ()=>{
    return {
        portals: [],
        requestTypes: [],
        knowledgeBase: {
            articles: [],
            totalSize: 0
        }
    };
};
const $9aa4b198cf14c1da$var$generateDefaultState = ()=>{
    const strings = $5LmQo.getAll();
    if (strings && strings.q !== undefined) return {
        shown: true,
        term: strings.q,
        time: strings.q_time ? +strings.q_time : undefined,
        hasError: false,
        isSearching: true,
        results: $9aa4b198cf14c1da$var$generateDefaultSearchResults(),
        isSearchingPortals: true,
        isSearchingKb: true,
        isSearchingRequestTypes: true
    };
    return {
        shown: false,
        term: '',
        portalIds: [],
        time: undefined,
        hasError: false,
        isSearching: false,
        results: $9aa4b198cf14c1da$var$generateDefaultSearchResults()
    };
};
const $9aa4b198cf14c1da$var$portalResponseToState = (portal)=>({
        id: portal.id,
        name: portal.name,
        iconUrl: portal.logoUrl
    });
const $9aa4b198cf14c1da$var$requestTypesResponseToState = (requestType)=>({
        id: requestType.id,
        portalId: requestType.cvId,
        name: requestType.name,
        portalName: requestType.portalName,
        iconUrl: requestType.iconUrl || `${0, $eDcdn.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${requestType.icon}`,
        searchMetaData: requestType.searchMetaData
    });
function $9aa4b198cf14c1da$export$2e2bcd8739ae039(state = $9aa4b198cf14c1da$var$generateDefaultState(), action) {
    switch(action.type){
        case 0, $j4AtC.SHOW_SEARCH:
            return {
                ...state,
                shown: action.payload.show,
                searchStartTime: undefined
            };
        case 0, $j4AtC.RESET_SEARCH:
            return {
                shown: false,
                term: '',
                time: undefined,
                hasError: false,
                isSearching: false,
                results: $9aa4b198cf14c1da$var$generateDefaultSearchResults()
            };
        case 0, $j4AtC.SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined,
                isSearchingPortals: true,
                isSearchingKb: true,
                isSearchingRequestTypes: true
            };
        case 0, $j4AtC.FETCH_KB_SEARCH_RESULTS:
            return {
                ...state,
                isSearchingKb: true
            };
        case 0, $j4AtC.UPDATE_SEARCH_RESULTS:
            {
                const result = action.payload;
                const newResultState = {
                    portals: result.portals ? result.portals.map($9aa4b198cf14c1da$var$portalResponseToState) : [],
                    requestTypes: result.requestTypes ? result.requestTypes.map($9aa4b198cf14c1da$var$requestTypesResponseToState) : [],
                    knowledgeBase: $9aa4b198cf14c1da$var$mapKnowledgeBaseResponseToState(result)
                };
                return {
                    ...state,
                    results: newResultState,
                    isSearching: false
                };
            }
        case 0, $j4AtC.UPDATE_SEARCH_RESULTS_BY_TYPE:
            {
                var _newResultState;
                const { searchType: searchType, payload: result } = action;
                let newResultState;
                if (searchType === 'portals') newResultState = {
                    results: {
                        ...state.results,
                        portals: result.portals ? result.portals.map($9aa4b198cf14c1da$var$portalResponseToState) : []
                    },
                    isSearchingPortals: false
                };
                if (searchType === 'requestTypes') newResultState = {
                    results: {
                        ...state.results,
                        requestTypes: result.requestTypes ? result.requestTypes.map($9aa4b198cf14c1da$var$requestTypesResponseToState) : []
                    },
                    isSearchingRequestTypes: false
                };
                if (searchType === 'kbs') newResultState = {
                    results: {
                        ...state.results,
                        knowledgeBase: $9aa4b198cf14c1da$var$mapKnowledgeBaseResponseToState(result)
                    },
                    isSearchingKb: false
                };
                return {
                    ...state,
                    ...newResultState ?? {},
                    isSearching: ((_newResultState = newResultState) === null || _newResultState === void 0 ? void 0 : _newResultState.isSearchingKb) === false ? false : state.isSearching
                };
            }
        case 0, $j4AtC.CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                isSearching: false,
                results: $9aa4b198cf14c1da$var$generateDefaultSearchResults(),
                searchStartTime: undefined
            };
        case 0, $j4AtC.FETCH_SEARCH_RESULTS:
            return {
                ...state,
                searchStartTime: action.payload.searchStartTime
            };
        case 0, $j4AtC.UPDATE_SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined
            };
        default:
            return state;
    }
}
const $9aa4b198cf14c1da$var$mapKnowledgeBaseResponseToState = (result)=>{
    return result.kbs ? result.kbs : {
        articles: [],
        totalSize: 0
    };
};

});


parcelRegister("gB1xB", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => (parcelRequire("bbOKY")).checkEmailUiReducer);

var $bbOKY = parcelRequire("bbOKY");

});
parcelRegister("bbOKY", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => $d66491f2425f147b$export$a518ffb70e2a23c8);
parcelRequire("8eZY0");
var $hh4QA = parcelRequire("hh4QA");
const $d66491f2425f147b$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    resendValidationLinkDisabled: false
};
function $d66491f2425f147b$export$a518ffb70e2a23c8(state = $d66491f2425f147b$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $hh4QA.ENABLE_RESEND_VALIDATION_EMAIL_LINK:
            return $d66491f2425f147b$var$handleEnableResendValidationLink(state);
        case 0, $hh4QA.RESEND_VALIDATION_EMAIL:
            return $d66491f2425f147b$var$handleResendValidationEmail(state);
        case 0, $hh4QA.RESEND_VALIDATION_EMAIL_SUCCESS:
            return $d66491f2425f147b$var$handleResendValidationEmailSuccess(state);
        case 0, $hh4QA.RESEND_VALIDATION_EMAIL_FAILURE:
            return $d66491f2425f147b$var$handleResendValidationEmailFailure(state);
        default:
            return state;
    }
}
const $d66491f2425f147b$var$handleEnableResendValidationLink = (state)=>({
        ...state,
        resendValidationLinkDisabled: false
    });
const $d66491f2425f147b$var$handleResendValidationEmail = (state)=>({
        ...state,
        isSubmitting: true,
        resendValidationLinkDisabled: true
    });
const $d66491f2425f147b$var$handleResendValidationEmailSuccess = (state)=>({
        ...state,
        isSubmitting: false
    });
const $d66491f2425f147b$var$handleResendValidationEmailFailure = (state)=>({
        ...state,
        isSubmitting: false
    });

});


parcelRegister("eKZay", function(module, exports) {
$parcel$export(module.exports, "topicsReducer", () => (parcelRequire("hsEgN")).default);

var $hsEgN = parcelRequire("hsEgN");

});
parcelRegister("hsEgN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef122c75a66131c8$export$2e2bcd8739ae039);
parcelRequire("5vRNB");
var $hsyPM = parcelRequire("hsyPM");
const $ef122c75a66131c8$export$b81eca7e0c669bb0 = {
    fetchKey: 0
};
function $ef122c75a66131c8$export$2e2bcd8739ae039(state = $ef122c75a66131c8$export$b81eca7e0c669bb0, action) {
    if (action.type === (0, $hsyPM.UPDATE_TOPICS_FETCH_KEY)) return {
        ...state,
        fetchKey: state.fetchKey + 1
    };
    return state;
}

});
parcelRegister("5vRNB", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => (parcelRequire("hsyPM")).UPDATE_TOPICS_FETCH_KEY);

var $hsyPM = parcelRequire("hsyPM");

});
parcelRegister("hsyPM", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => $fe877f668415a519$export$9b3f2f1c719b0f8e);
const $fe877f668415a519$export$9b3f2f1c719b0f8e = 'state.ui.topics.UPDATE_TOPICS_FETCH_KEY';
const $fe877f668415a519$export$ff571764686d6022 = ()=>({
        type: $fe877f668415a519$export$9b3f2f1c719b0f8e
    });

});




parcelRegister("eNCGE", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => (parcelRequire("3Mkhc")).userProfileReducer);

var $3Mkhc = parcelRequire("3Mkhc");

});
parcelRegister("3Mkhc", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => $557c5f833634456d$export$6a0a871f19e6c5f6);
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");
const $557c5f833634456d$var$defaultState = {
    saveInProgress: false,
    changePasswordInProgress: false,
    showChangePasswordDialog: false,
    changePasswordErrors: {},
    saveUserProfileErrors: {},
    sendForgotPasswordEmailInProgress: false
};
function $557c5f833634456d$export$6a0a871f19e6c5f6(state = $557c5f833634456d$var$defaultState, action) {
    switch(action.type){
        case 0, $kd70W.SAVE_USER_PROFILE:
            return $557c5f833634456d$var$handleSaveUserProfile(state);
        case 0, $kd70W.SAVE_USER_PROFILE_FAILURE:
            return $557c5f833634456d$var$handleSaveUserProfileFailure(state);
        case 0, $kd70W.SET_USER_PROFILE_VALIDATION_ERRORS:
            return $557c5f833634456d$var$handleSetUserProfileValidationErrors(state, action);
        case 0, $kd70W.SAVE_USER_PROFILE_SUCCESS:
            return $557c5f833634456d$var$handleSaveUserProfileSuccess(state);
        case 0, $kd70W.SHOW_CHANGE_PASSWORD_DIALOG:
            return $557c5f833634456d$var$handleShowChangePasswordDialog(state);
        case 0, $kd70W.CLOSE_CHANGE_PASSWORD_DIALOG:
            return $557c5f833634456d$var$handleCloseChangePasswordDialog(state);
        case 0, $kd70W.CHANGE_PASSWORD:
            return $557c5f833634456d$var$handleChangePassword(state);
        case 0, $kd70W.CHANGE_PASSWORD_SUCCESS:
            return $557c5f833634456d$var$handleChangePasswordSuccess(state);
        case 0, $kd70W.CHANGE_PASSWORD_FAILURE:
            return $557c5f833634456d$var$handleChangePasswordFailure(state, action);
        case 0, $kd70W.VALIDATE_PASSWORD_SUCCESS:
            return $557c5f833634456d$var$handleValidatePasswordSuccess(state);
        case 0, $kd70W.USER_PROFILE_FORGOT_PASSWORD:
            return $557c5f833634456d$var$handleForgotPassword(state);
        case 0, $kd70W.USER_PROFILE_FORGOT_PASSWORD_FAILURE:
            return $557c5f833634456d$var$handleForgotPasswordFailure(state);
        case 0, $kd70W.USER_PROFILE_FORGOT_PASSWORD_SUCCESS:
            return $557c5f833634456d$var$handleForgotPasswordSuccess(state);
        default:
            return state;
    }
}
const $557c5f833634456d$var$handleSaveUserProfile = (state)=>({
        ...state,
        saveInProgress: true
    });
const $557c5f833634456d$var$handleSaveUserProfileFailure = (state)=>({
        ...state,
        saveInProgress: false
    });
function $557c5f833634456d$var$handleSetUserProfileValidationErrors(state, action) {
    const { nameError: nameError, timezoneError: timezoneError } = action.payload;
    return {
        ...state,
        saveUserProfileErrors: {
            nameError: nameError,
            timezoneError: timezoneError
        }
    };
}
const $557c5f833634456d$var$handleSaveUserProfileSuccess = (state)=>({
        ...state,
        saveInProgress: false
    });
const $557c5f833634456d$var$handleShowChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: true
    });
const $557c5f833634456d$var$handleCloseChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordErrors: {}
    });
const $557c5f833634456d$var$handleValidatePasswordSuccess = (state)=>({
        ...state,
        changePasswordErrors: {}
    });
const $557c5f833634456d$var$handleChangePassword = (state)=>({
        ...state,
        changePasswordInProgress: true,
        changePasswordErrors: {}
    });
const $557c5f833634456d$var$handleChangePasswordSuccess = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordInProgress: false,
        changePasswordErrors: {}
    });
const $557c5f833634456d$var$handleChangePasswordFailure = (state, action)=>({
        ...state,
        changePasswordInProgress: false,
        changePasswordErrors: {
            currentPasswordError: action.payload.currentPasswordError,
            newPasswordError: action.payload.newPasswordError,
            confirmPasswordError: action.payload.confirmPasswordError,
            generalError: action.payload.generalError
        }
    });
const $557c5f833634456d$var$handleForgotPassword = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: true,
        showChangePasswordDialog: true
    });
const $557c5f833634456d$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: true
    });
const $557c5f833634456d$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: false
    });

});





parcelRegister("djv3i", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerTypeProvider", () => $7a6d3c2f2c1ef3a4$export$e70650df369196ac);

var $bSJIT = parcelRequire("bSJIT");

var $h0gXc = parcelRequire("h0gXc");

var $2Td4X = parcelRequire("2Td4X");

var $haAAx = parcelRequire("haAAx");
const $7a6d3c2f2c1ef3a4$export$e70650df369196ac = ({ children: children })=>{
    const [helpSeekerTypeAttributes, setHelpSeekerTypeAttributes] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState({
        isUserDomainSameAsAdmin: (0, $h0gXc.helpSeekerTypeAttributeValue).UNIDENTIFIED,
        isUserDomainInApprovedDomains: (0, $h0gXc.helpSeekerTypeAttributeValue).UNIDENTIFIED
    });
    const config = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $2Td4X.AtlassianHelpConfigContext));
    const constructHelpSeekerTypeResponse = (isUserDomainSameAsAdmin, isUserDomainInApprovedDomains, isUserLoggedIn)=>({
            isUserDomainSameAsAdmin: isUserDomainSameAsAdmin,
            isUserDomainInApprovedDomains: isUserDomainInApprovedDomains,
            isUserLoggedIn: isUserLoggedIn
        });
    const evaluateHelpSeekerTypeAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        if (config.accountType === 'customer') (0, $h0gXc.getHelpSeekerTypeAttributes)().subscribe((response)=>{
            setHelpSeekerTypeAttributes({
                ...response,
                isUserLoggedIn: true
            });
        });
        else if (config.accountType === 'atlassian') setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $h0gXc.helpSeekerTypeAttributeValue).YES, (0, $h0gXc.helpSeekerTypeAttributeValue).YES, true));
        else setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $h0gXc.helpSeekerTypeAttributeValue).NO, (0, $h0gXc.helpSeekerTypeAttributeValue).NO, false));
    }, [
        config
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        evaluateHelpSeekerTypeAttributes();
    }, [
        evaluateHelpSeekerTypeAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $haAAx.AnalyticsContext), {
        attributes: helpSeekerTypeAttributes
    }, children);
};

});
parcelRegister("h0gXc", function(module, exports) {
$parcel$export(module.exports, "helpSeekerTypeAttributeValue", () => $375629e46945daa9$export$5f93b09705cc6a59);
$parcel$export(module.exports, "getHelpSeekerTypeAttributes", () => $375629e46945daa9$export$ea5de7279b843e51);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");

var $3kjRG = parcelRequire("3kjRG");
const $375629e46945daa9$export$5f93b09705cc6a59 = Object.freeze({
    YES: 'Yes',
    NO: 'No',
    UNIDENTIFIED: 'Unidentified'
});
const $375629e46945daa9$export$ea5de7279b843e51 = (basePath = (0, $eDcdn.contextPath))=>{
    const uri = `${basePath}/rest/servicedesk/1/customer/analytics/help-seeker/type`;
    const localStorageHelpSeekerTypeResponse = (0, $3kjRG.getLocalStorageItem)('help-seeker-type');
    if (localStorageHelpSeekerTypeResponse) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $8jOUp.Observable).of(JSON.parse(localStorageHelpSeekerTypeResponse));
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        (0, $3kjRG.setLocalStorageItem)('help-seeker-type', JSON.stringify(response));
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response;
    }).catch(()=>{
        return (0, $8jOUp.Observable).of({
            isUserDomainSameAsAdmin: $375629e46945daa9$export$5f93b09705cc6a59.UNIDENTIFIED,
            isUserDomainInApprovedDomains: $375629e46945daa9$export$5f93b09705cc6a59.UNIDENTIFIED
        });
    });
};

});

parcelRegister("2Td4X", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelpConfigContext", () => $ffc4bd7102c011f4$export$15b13d6286254aba);
$parcel$export(module.exports, "default", () => $ffc4bd7102c011f4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");
const $ffc4bd7102c011f4$export$eec32b9030a890bc = (config)=>({
        accountId: config.accountId,
        accountType: config.accountType,
        userLocale: config.userLocale,
        sdPluginVersion: config.sdPluginVersion || '',
        contextPath: config.contextPath,
        environment: config.environment,
        tenantId: config.tenantId,
        activationId: config.activationId,
        helpCenterARI: config.helpCenterARI
    });
const $ffc4bd7102c011f4$export$b5f4a66c86673938 = (config)=>({
        environment: config.environment,
        featureFlags: config.featureFlags || {},
        wacLink: config.wacLink,
        contactLink: config.contactLink,
        headless: config.headless || false,
        serviceDeskVersion: config.serviceDeskVersion || '',
        contextPath: config.contextPath,
        xsrfToken: config.xsrfToken || '',
        baseUrl: config.baseUrl,
        relativeBaseUrl: config.relativeBaseUrl,
        anonymousEnabled: config.anonymousEnabled || false,
        requestIntroEnabled: config.requestIntroEnabled || false,
        mediaApiExternalUrl: config.mediaApiExternalUrl || '',
        mediaApiAppClientId: config.mediaApiAppClientId || '',
        fabricEmojiUrl: config.fabricEmojiUrl || '',
        jiraDisplayUrl: config.jiraDisplayUrl,
        featuredValues: config.featuredValues || {},
        siteDefaultLanguageTag: config.siteDefaultLanguageTag || 'en-US',
        helpCenterType: config.helpCenterType || (0, $jcRK7.DEFAULT_HELP_CENTER_TYPE),
        hoistedProjectKey: config.hoistedProjectKey || undefined,
        helpCenterHomePageSlug: config.helpCenterHomePageSlug || '',
        customerAccountAvailabilty: config.customerAccountAvailabilty || (0, $jcRK7.DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY)
    });
const $ffc4bd7102c011f4$export$15b13d6286254aba = /*#__PURE__*/ $bSJIT.createContext({});
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
// oxlint-disable-next-line no-shadow
const $ffc4bd7102c011f4$var$MetaDataProvider = ({ children: children, config: config, updateEnvAction: updateEnvAction, updateMetaAction: updateMetaAction })=>{
    // We can add React context here in the future once relay is introduced and get rid of reducers altogether
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // oxlint-disable-next-line no-shadow
    const Env = $ffc4bd7102c011f4$export$b5f4a66c86673938(config);
    const Meta = $ffc4bd7102c011f4$export$eec32b9030a890bc(config);
    $bSJIT.useMemo(()=>{
        updateMetaAction(Meta);
        updateEnvAction(Env);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        Env,
        Meta
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($ffc4bd7102c011f4$export$15b13d6286254aba.Provider, {
        value: config
    }, children);
};
var $ffc4bd7102c011f4$export$2e2bcd8739ae039 = $ffc4bd7102c011f4$var$MetaDataProvider;

});


parcelRegister("0X0OG", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => (parcelRequire("gGwju")).EngagementProviderWrapper);

var $gGwju = parcelRequire("gGwju");

});
parcelRegister("gGwju", function(module, exports) {
$parcel$export(module.exports, "EngagementProviderWrapper", () => $a25ca9c746ff7d7f$export$a055f8fe7b78f866);

var $bSJIT = parcelRequire("bSJIT");

var $5F198 = parcelRequire("5F198");

var $gzUXQ = parcelRequire("gzUXQ");

var $fT4XN = parcelRequire("fT4XN");

var $a6ENB = parcelRequire("a6ENB");
const $a25ca9c746ff7d7f$export$a055f8fe7b78f866 = ({ config: config, analyticsClientInstance: analyticsClientInstance, children: children })=>{
    const epConfig = {
        environment: config.environment,
        cloudId: config.tenantId,
        aaid: config.accountId,
        locale: config.userLocale,
        product: 'jira',
        subProduct: 'serviceDesk',
        stargateUrl: '/gateway/api'
    };
    const renderOnError = (0, $bSJIT.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        id: 'engagement-provider-error',
        renderError: renderOnError,
        onError: (0, $a6ENB.reportError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5F198.default), {
        config: epConfig,
        analyticsClientInstance: analyticsClientInstance,
        coordinationOptions: {
            enableChoreographer: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gzUXQ.EngagementMessages), null), children)));
};

});
parcelRegister("5F198", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ace04f4d96dc039$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");

var $51lxt = parcelRequire("51lxt");

var $ay6RT = parcelRequire("ay6RT");

var $aBbAb = parcelRequire("aBbAb");
const $1ace04f4d96dc039$var$EngagementProviderWithEvents = (0, $kIbto.default)()((0, $aBbAb.EngagementProvider));
const $1ace04f4d96dc039$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1ace04f4d96dc039$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $ay6RT.default)(props.config)
    });
};
// eslint-disable-next-line camelcase
const $1ace04f4d96dc039$var$_default_1 = (0, $51lxt.default)($1ace04f4d96dc039$var$EngagementProviderWithDefaultStore);
var // eslint-disable-next-line camelcase
$1ace04f4d96dc039$export$2e2bcd8739ae039 = $1ace04f4d96dc039$var$_default_1;

});
parcelRegister("51lxt", function(module, exports) {
$parcel$export(module.exports, "default", () => $564f7376d81096b5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $564f7376d81096b5$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props))));
    };
}

});

parcelRegister("ay6RT", function(module, exports) {
$parcel$export(module.exports, "store", () => $f642250e0c3943f5$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $f642250e0c3943f5$export$2e2bcd8739ae039);

var $dMMwa = parcelRequire("dMMwa");
parcelRequire("1mIIj");
var $5nEeT = parcelRequire("5nEeT");

var $gvjy3 = parcelRequire("gvjy3");

var $dPQL6 = parcelRequire("dPQL6");

var $auu41 = parcelRequire("auu41");

var $dIujR = parcelRequire("dIujR");
const $f642250e0c3943f5$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $f642250e0c3943f5$var$processMessagesCancellationToken = (0, $gvjy3.createCancellationToken)();
function $f642250e0c3943f5$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $f642250e0c3943f5$export$6f57813fe9f31bf9 = (0, $5nEeT.default)((state = $f642250e0c3943f5$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $auu41.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $auu41.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $auu41.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $f642250e0c3943f5$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $auu41.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $auu41.RESET_STORE:
            return $f642250e0c3943f5$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $f642250e0c3943f5$export$2e2bcd8739ae039 = (config)=>{
    const state = $f642250e0c3943f5$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $f642250e0c3943f5$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $f642250e0c3943f5$var$processMessagesCancellationToken.isCancelled = true;
        $f642250e0c3943f5$var$processMessagesCancellationToken = (0, $gvjy3.createCancellationToken)();
        $f642250e0c3943f5$export$6f57813fe9f31bf9.dispatch((0, $auu41.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $f642250e0c3943f5$export$6f57813fe9f31bf9.dispatch((0, $auu41.initialize)(newConfig));
    if ((0, $dPQL6.isMessagingEnabled)()) (0, $dIujR.processMessages)($f642250e0c3943f5$export$6f57813fe9f31bf9, newConfig, $f642250e0c3943f5$var$processMessagesCancellationToken);
    return $f642250e0c3943f5$export$6f57813fe9f31bf9;
};

});
parcelRegister("dMMwa", function(module, exports) {

var $2Fr8f = parcelRequire("2Fr8f");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $02970e02d86b576c$var$isEqual(value, other) {
    return $2Fr8f(value, other);
}
module.exports = $02970e02d86b576c$var$isEqual;

});

parcelRegister("gvjy3", function(module, exports) {
$parcel$export(module.exports, "createCancellationToken", () => $ae2e307cb12645ae$export$eac027797b968991);
function $ae2e307cb12645ae$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("dPQL6", function(module, exports) {
$parcel$export(module.exports, "isMessagingEnabled", () => $07a9cd0a275f89fe$export$a77934ac158768dd);

var $9hihM = parcelRequire("9hihM");
function $07a9cd0a275f89fe$export$a77934ac158768dd() {
    return !(0, $9hihM.isFedRamp)();
}

});

parcelRegister("auu41", function(module, exports) {
$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $8c9d169d51dbd7e4$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $8c9d169d51dbd7e4$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $8c9d169d51dbd7e4$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $8c9d169d51dbd7e4$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $8c9d169d51dbd7e4$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $8c9d169d51dbd7e4$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $8c9d169d51dbd7e4$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $8c9d169d51dbd7e4$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $8c9d169d51dbd7e4$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $8c9d169d51dbd7e4$export$96105f873ade39d7);
const $8c9d169d51dbd7e4$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $8c9d169d51dbd7e4$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $8c9d169d51dbd7e4$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $8c9d169d51dbd7e4$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $8c9d169d51dbd7e4$export$a9319af002a4c677 = 'SET_CURRENT';
const $8c9d169d51dbd7e4$export$a20a1205b2a2b7e4 = ()=>({
        type: $8c9d169d51dbd7e4$export$874c5149d7f0e3b8
    });
const $8c9d169d51dbd7e4$export$2a47f398eeff8b01 = (config)=>({
        type: $8c9d169d51dbd7e4$export$eacd3ec165715d8,
        config: config
    });
const $8c9d169d51dbd7e4$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $8c9d169d51dbd7e4$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $8c9d169d51dbd7e4$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $8c9d169d51dbd7e4$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $8c9d169d51dbd7e4$export$96105f873ade39d7() {
    return {
        type: $8c9d169d51dbd7e4$export$cb5041d68cb18859
    };
}

});

parcelRegister("dIujR", function(module, exports) {
$parcel$export(module.exports, "processMessages", () => $8de463fc661be4e9$export$d2e92820f98a2592);

var $6Fhdx = parcelRequire("6Fhdx");

var $auu41 = parcelRequire("auu41");

var $ay6RT = parcelRequire("ay6RT");
const $8de463fc661be4e9$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $8de463fc661be4e9$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $ay6RT.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $6Fhdx.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $8de463fc661be4e9$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $auu41.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $8de463fc661be4e9$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("6Fhdx", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $6b73fac8c0115f69$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $6b73fac8c0115f69$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $6b73fac8c0115f69$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $6b73fac8c0115f69$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $6b73fac8c0115f69$export$3683393f780c6905);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ 
var $75rvE = parcelRequire("75rvE");
const $6b73fac8c0115f69$export$f4d1b02d312560f5 = '2';
async function $6b73fac8c0115f69$export$8c20ab16ac9cf14f(_cloudId, _stargateUrl, _product, _locale) {
    return {
        messages: [],
        interval: 0
    };
}
var $6b73fac8c0115f69$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $6b73fac8c0115f69$var$choreographerPlugin;
async function $6b73fac8c0115f69$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $6b73fac8c0115f69$var$startMessageWithChoreographer(startMessageConfig, options);
    return $6b73fac8c0115f69$var$startMessageWithCoordination(startMessageConfig);
}
async function $6b73fac8c0115f69$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $6b73fac8c0115f69$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $6b73fac8c0115f69$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $6b73fac8c0115f69$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$6b73fac8c0115f69$var$choreographerPlugin) $6b73fac8c0115f69$var$choreographerPlugin = new (0, $75rvE.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $6b73fac8c0115f69$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$6b73fac8c0115f69$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $6b73fac8c0115f69$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$6b73fac8c0115f69$var$choreographerPlugin) $6b73fac8c0115f69$var$choreographerPlugin = new (0, $75rvE.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $6b73fac8c0115f69$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$6b73fac8c0115f69$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $6b73fac8c0115f69$var$startMessageWithCoordination(_startMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $6b73fac8c0115f69$var$stopMessageWithCoordination(_stopMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $6b73fac8c0115f69$export$e1fd1449cf83c1f5(_cloudId, _stargateUrl, _messageId, _payload) {
    return Promise.resolve();
}
async function $6b73fac8c0115f69$export$3683393f780c6905(_seenMessageConfig) {
    return Promise.resolve();
}

});
parcelRegister("75rvE", function(module, exports) {
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $d7ee3b84a775689e$export$da23bd36e2d631b);

var $5tO0H = parcelRequire("5tO0H");

var $csdLD = parcelRequire("csdLD");

var $l8zMw = parcelRequire("l8zMw");

var $19pRm = parcelRequire("19pRm");

var $aOjqL = parcelRequire("aOjqL");
const $d7ee3b84a775689e$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $d7ee3b84a775689e$export$da23bd36e2d631b extends (0, $aOjqL.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $csdLD.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $csdLD.MessageAction).START || event.action !== (0, $csdLD.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $5tO0H.Choreographer).getInstance().getCurrentMessage() ?? (0, $5tO0H.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $d7ee3b84a775689e$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $l8zMw.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $csdLD.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $19pRm.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $csdLD.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $csdLD.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $l8zMw.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $csdLD.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("5tO0H", function(module, exports) {
$parcel$export(module.exports, "Choreographer", () => $0791fd7571c7855f$export$236158f15971c92e);

var $gdUUy = parcelRequire("gdUUy");

var $csdLD = parcelRequire("csdLD");

var $l8zMw = parcelRequire("l8zMw");

var $19pRm = parcelRequire("19pRm");

var $aqCvi = parcelRequire("aqCvi");

var $7OVoM = parcelRequire("7OVoM");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $0791fd7571c7855f$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $0791fd7571c7855f$var$singleton;
class $0791fd7571c7855f$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        if (typeof window !== 'undefined') {
            var _window$postOffice, _window$postOffice2;
            if ((_window$postOffice = window.postOffice) !== null && _window$postOffice !== void 0 && (_window$postOffice = _window$postOffice.choreographer) !== null && _window$postOffice !== void 0 && _window$postOffice.singleton) return window.postOffice.choreographer.singleton;
            window.postOffice = {
                ...window.postOffice,
                choreographer: {
                    ...(_window$postOffice2 = window.postOffice) === null || _window$postOffice2 === void 0 ? void 0 : _window$postOffice2.choreographer,
                    singleton: new this()
                }
            };
            return window.postOffice.choreographer.singleton;
        }
        if (!$0791fd7571c7855f$var$singleton) $0791fd7571c7855f$var$singleton = new this();
        return $0791fd7571c7855f$var$singleton;
    }
    constructor(){
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            var _this$state$seenTrans;
            /*
     * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
     * of how many transactional messages we are showing to users.
     *
     * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
     * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
     * messages that are actually being shown to users.
     *
     * Thus, we track which messages have been seen and only log the first time we see a transactional message.
     */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = (props === null || props === void 0 ? void 0 : props.messageType) === (0, $csdLD.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $gdUUy.fg)('post-office_choreographer_log_transactional_msg');
            const seen = (props === null || props === void 0 ? void 0 : props.messageId) && ((_this$state$seenTrans = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans === void 0 ? void 0 : _this$state$seenTrans.has(props.messageId));
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && (props === null || props === void 0 ? void 0 : props[toggleableProp]);
            if (isTransactional && props !== null && props !== void 0 && props.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                var _this$state$seenTrans2, _this$getCurrentMessa;
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                (_this$state$seenTrans2 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans2 === void 0 || _this$state$seenTrans2.add(props.messageId);
                const logger = new (0, $19pRm.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: (_this$getCurrentMessa = this.getCurrentMessage()) === null || _this$getCurrentMessa === void 0 ? void 0 : _this$getCurrentMessa.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $aqCvi.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                timestamp: Date.now(),
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   *
   * @param [plugin] An optional plugin instance
   */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            var _this$state$currentMe, _this$state$currentMe2, _this$state$currentMe3, _this$state$currentMe4;
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $csdLD.MessageAction).START;
            const logger = new (0, $19pRm.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $l8zMw.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: (_this$state$currentMe = this.state.currentMessage) === null || _this$state$currentMe === void 0 ? void 0 : _this$state$currentMe.productId,
                blockedByMessageId: (_this$state$currentMe2 = this.state.currentMessage) === null || _this$state$currentMe2 === void 0 ? void 0 : _this$state$currentMe2.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $csdLD.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: (_this$state$currentMe3 = this.state.currentMessage) === null || _this$state$currentMe3 === void 0 ? void 0 : _this$state$currentMe3.productId,
                    blockedByMessageId: (_this$state$currentMe4 = this.state.currentMessage) === null || _this$state$currentMe4 === void 0 ? void 0 : _this$state$currentMe4.messageId
                }
            });
            resolve((0, $csdLD.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $0791fd7571c7855f$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Returns a snapshot of messages currently queued behind an in-flight start or stop request.
   */ getQueuedMessages() {
        return this.state.messageQueue.map(({ messageId: messageId, productId: productId, timestamp: timestamp })=>({
                messageId: messageId,
                productId: productId,
                timestamp: timestamp
            }));
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
   * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
   * may conflict with messages shown in parent frames.
   *
   * If called outside an iframe then this function is a noop.
   *
   * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
   */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $7OVoM.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        var _this$state$currentMe5;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this$state$currentMe5 = this.state.currentMessage) === null || _this$state$currentMe5 === void 0 ? void 0 : _this$state$currentMe5.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * Returns the registered messages for a product. This is used by diagnostics and tests to inspect
   * the current Choreographer registry without mutating it.
   *
   * @param productId Unique identifier for the product whose messages are being requested.
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $l8zMw.DebugLogger)(productId, messageId);
        const actionSubject = (0, $csdLD.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $19pRm.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$start;
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $csdLD.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $csdLD.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                var _this$state$queueingB, _this$state$queueingB2;
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${(_this$state$queueingB = this.state.queueingBehindMessage) === null || _this$state$queueingB === void 0 ? void 0 : _this$state$queueingB.productId} ${(_this$state$queueingB2 = this.state.queueingBehindMessage) === null || _this$state$queueingB2 === void 0 ? void 0 : _this$state$queueingB2.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                var _this$state$currentMe6, _this$state$currentMe7, _this$state$currentMe8, _this$state$currentMe9;
                logger.blocked({
                    blockedByProductId: (_this$state$currentMe6 = this.state.currentMessage) === null || _this$state$currentMe6 === void 0 ? void 0 : _this$state$currentMe6.productId,
                    blockedByMessageId: (_this$state$currentMe7 = this.state.currentMessage) === null || _this$state$currentMe7 === void 0 ? void 0 : _this$state$currentMe7.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $csdLD.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: (_this$state$currentMe8 = this.state.currentMessage) === null || _this$state$currentMe8 === void 0 ? void 0 : _this$state$currentMe8.productId,
                        blockedByMessageId: (_this$state$currentMe9 = this.state.currentMessage) === null || _this$state$currentMe9 === void 0 ? void 0 : _this$state$currentMe9.messageId
                    }
                });
                return (0, $csdLD.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await ((_message$start = message.start) === null || _message$start === void 0 ? void 0 : _message$start.call(message)) ?? true;
            if (didStart) {
                var _message$onStart;
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                (_message$onStart = message.onStart) === null || _message$onStart === void 0 || _message$onStart.call(message);
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $csdLD.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $csdLD.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $csdLD.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $csdLD.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $csdLD.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $csdLD.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $l8zMw.DebugLogger)(productId, messageId);
        const actionSubject = (0, $csdLD.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $19pRm.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$stop;
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $csdLD.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $csdLD.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await ((_message$stop = message.stop) === null || _message$stop === void 0 ? void 0 : _message$stop.call(message)) ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    var _message$onStop;
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    (_message$onStop = message.onStop) === null || _message$onStop === void 0 || _message$onStop.call(message);
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $csdLD.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $csdLD.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $csdLD.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $csdLD.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $csdLD.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $csdLD.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        var _this$state$messages$, _this$state$messages$2;
        return Boolean((_this$state$messages$ = this.state.messages.get(productId)) === null || _this$state$messages$ === void 0 || (_this$state$messages$2 = _this$state$messages$.has) === null || _this$state$messages$2 === void 0 ? void 0 : _this$state$messages$2.call(_this$state$messages$, messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        var _this$state$messages$3, _this$state$messages$4;
        (_this$state$messages$3 = this.state.messages.get(productId)) === null || _this$state$messages$3 === void 0 || (_this$state$messages$4 = _this$state$messages$3.delete) === null || _this$state$messages$4 === void 0 || _this$state$messages$4.call(_this$state$messages$3, messageId);
    }
    /**
   * This should only be used for test cleanup purposes.
   * Clears the seen transactional messages cache for a given productId.
   *
   * @param productId Unique identifier to clear the seen transactional messages cache for.
   */ clearSeenTransactionalMessages(productId) {
        var _this$state$seenTrans3;
        (_this$state$seenTrans3 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans3 === void 0 || _this$state$seenTrans3.clear();
    }
}

});
parcelRegister("csdLD", function(module, exports) {
$parcel$export(module.exports, "MessageEventType", () => $5228dfabfddf1322$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $5228dfabfddf1322$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $5228dfabfddf1322$export$7fb117db98868be6);
$parcel$export(module.exports, "MessageTypesEnum", () => $5228dfabfddf1322$export$94e85cf3348f045a);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $5228dfabfddf1322$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $5228dfabfddf1322$export$865c0eaaa43d90f8);
const $5228dfabfddf1322$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $5228dfabfddf1322$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $5228dfabfddf1322$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    ProductIds["TRELLO"] = "trello";
    return ProductIds;
}({});
const $5228dfabfddf1322$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $5228dfabfddf1322$export$dbe9e38c9d6f26d0 = [
    $5228dfabfddf1322$export$94e85cf3348f045a.ENGAGEMENT,
    $5228dfabfddf1322$export$94e85cf3348f045a.MARKETING
];
const $5228dfabfddf1322$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $5228dfabfddf1322$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("l8zMw", function(module, exports) {
$parcel$export(module.exports, "DebugLogger", () => $d6309a6c307ad8de$export$21e6cc849c1dc1ab);
function $d6309a6c307ad8de$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $d6309a6c307ad8de$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($d6309a6c307ad8de$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $d6309a6c307ad8de$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($d6309a6c307ad8de$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $d6309a6c307ad8de$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. log.info and log.verbose, which are functions that take an
   * object of any key/value pairs, which will be merged with the productId
   * and the messageId values passed to the constructor, and output via
   * console.table.
   *
   * Example: debugLogger.log({
   *   info: { foo: true },
   *   verbose: {
   *     foo: true,
   *     bar: 123,
   *     baz 'abc',
   *     timestamp: performance.now()
   *   },
   * });
   *
   * @param messages Record<LoggingLevels, Record<string, unknown>> An object
   * keyed by the desired log-level, with each value being an object of any
   * key/value pairs to be output to console.table.
   */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $d6309a6c307ad8de$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. trace.info and trace.verbose, which are functions that take
   * a string to be used as the label for a stack trace via console.trace.
   *
   * Example: debugLogger.trace({
   *   info: 'This is a stack trace',
   *   verbose: `This is a stack trace with a much more verbose message which
   * contains data about the ${productId} and ${messageId} within my function,
   * invoked at ${performance.now()}ms`,
   * });
   *
   * @param messages Record<LoggingLevels, string> An object keyed by the
   * desired log-level, with each value being a string to be output as the
   * label to console.trace.
   */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $d6309a6c307ad8de$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("19pRm", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $802e3966d21f359e$export$efa9a398d6368992);

var $csdLD = parcelRequire("csdLD");
class $802e3966d21f359e$export$efa9a398d6368992 {
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   * @param [plugin] An optional plugin instance.
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        var _plugin$shouldLogEven;
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if ((plugin === null || plugin === void 0 || (_plugin$shouldLogEven = plugin.shouldLogEvent) === null || _plugin$shouldLogEven === void 0 ? void 0 : _plugin$shouldLogEven.call(plugin, event)) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $csdLD.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $csdLD.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $csdLD.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $csdLD.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $csdLD.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $csdLD.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
}

});

parcelRegister("aqCvi", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $bce046284a359156$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $bce046284a359156$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $bce046284a359156$export$7c574bc7a8b74124);

var $bSJIT = parcelRequire("bSJIT");

var $csdLD = parcelRequire("csdLD");
const $bce046284a359156$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions === null || coordinationOptions === void 0 ? void 0 : coordinationOptions.enableChoreographer) && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && (0, $csdLD.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $bce046284a359156$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $bSJIT.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $bce046284a359156$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $bSJIT.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("7OVoM", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $4a14800af4b8a9b3$export$e6c5ffa684aac4d7);
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $4a14800af4b8a9b3$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}

});


parcelRegister("aOjqL", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPlugin", () => $2c4c386f6790f460$export$71324a662782c710);

var $gNwHK = parcelRequire("gNwHK");

var $f2Pmd = parcelRequire("f2Pmd");

var $5tO0H = parcelRequire("5tO0H");
class $2c4c386f6790f460$export$71324a662782c710 {
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Returns the Analytics Web Client instance for this plugin.
   *
   * @returns AnalyticsWebClient instance
   */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $5tO0H.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $5tO0H.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $5tO0H.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $5tO0H.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $5tO0H.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $5tO0H.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp // TODO: Remove this once we no longer need transactional logs
    ) {
        return (0, $5tO0H.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $5tO0H.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $f2Pmd.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $gNwHK.originType).WEB
        });
        return analyticsClient;
    }
}

});





parcelRegister("aBbAb", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => $631139ebecaff8f7$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $bSJIT = parcelRequire("bSJIT");

var $i2xu6 = parcelRequire("i2xu6");

var $iofuG = parcelRequire("iofuG");

var $4yQYd = parcelRequire("4yQYd");

var $Nc9iA = parcelRequire("Nc9iA");

var $ddgXE = parcelRequire("ddgXE");

var $1w9as = parcelRequire("1w9as");

var $csdLD = parcelRequire("csdLD");

var $aqCvi = parcelRequire("aqCvi");

var $6Fhdx = parcelRequire("6Fhdx");

var $hkNkR = parcelRequire("hkNkR");

var $d98L8 = parcelRequire("d98L8");

var $1Y0C6 = parcelRequire("1Y0C6");

var $dPQL6 = parcelRequire("dPQL6");

var $auu41 = parcelRequire("auu41");

var $bVAiQ = parcelRequire("bVAiQ");
const $631139ebecaff8f7$var$MAX_EVENT_QUEUE_SIZE = 100;
const $631139ebecaff8f7$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $631139ebecaff8f7$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $631139ebecaff8f7$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $631139ebecaff8f7$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($i2xu6)))(payload, trigger);
    });
}
function $631139ebecaff8f7$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $ddgXE.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $631139ebecaff8f7$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $631139ebecaff8f7$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $631139ebecaff8f7$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $6Fhdx.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $6Fhdx.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $631139ebecaff8f7$var$fireExposureEvent($631139ebecaff8f7$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $6Fhdx.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions !== null && coordinationOptions !== void 0 && coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $csdLD.MessageDeliveryStatus).STARTED : (0, $csdLD.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $631139ebecaff8f7$var$fireExposureEvent($631139ebecaff8f7$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $auu41.setCurrent)(eventMapping));
        }
    } else {
        $631139ebecaff8f7$var$fireExposureEvent($631139ebecaff8f7$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $auu41.setCurrent)(eventMapping));
    }
}
class $631139ebecaff8f7$export$83b8ae7ce7b4d59c extends (0, $bSJIT.Component) {
    static #_ = this.componentConfig = new Map();
    static #_2 = this.childContextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
    };
    static #_3 = this.defaultProps = {
        eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($Nc9iA)))
    };
    static #_4 = /*
   * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
   * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
   */ this.hasInitializedAtLeastOneEngagementProvider = false;
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$631139ebecaff8f7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $d98L8.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $631139ebecaff8f7$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $631139ebecaff8f7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            var _eventMapping$compone;
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $631139ebecaff8f7$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $1Y0C6.default)({
                eventName: $631139ebecaff8f7$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $dPQL6.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $631139ebecaff8f7$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if ((_eventMapping$compone = eventMapping.component) !== null && _eventMapping$compone !== void 0 && _eventMapping$compone.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $631139ebecaff8f7$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $631139ebecaff8f7$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $631139ebecaff8f7$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            var _this$props$coordinat;
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean((_this$props$coordinat = this.props.coordinationOptions) === null || _this$props$coordinat === void 0 ? void 0 : _this$props$coordinat.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig !== null && componentConfig !== void 0 && componentConfig.messageType ? // Use the component's individual choreographer configuration, if defined,
                // regardless of the EngagementProvider's coordinationOptions
                (0, $aqCvi.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $631139ebecaff8f7$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($631139ebecaff8f7$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $631139ebecaff8f7$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $hkNkR.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $hkNkR.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $hkNkR.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $bVAiQ.default)($631139ebecaff8f7$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $6Fhdx.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $csdLD.MessageDeliveryStatus).STOPPED : (0, $csdLD.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $631139ebecaff8f7$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $auu41.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
            channel: "*",
            onEvent: this.onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
            channel: "engagement",
            onEvent: this.onEngagementEvent
        }, this.props.children));
    }
}

});
parcelRegister("i2xu6", function(module, exports) {

var $8nOke = parcelRequire("8nOke");

var $kIhPT = parcelRequire("kIhPT");
/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */ function $d222633aeb802651$var$isMatch(object, source) {
    return object === source || $8nOke(object, source, $kIhPT(source));
}
module.exports = $d222633aeb802651$var$isMatch;

});

parcelRegister("iofuG", function(module, exports) {

var $3LtQV = parcelRequire("3LtQV");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $d6367ca60b678e42$var$once(func) {
    return $3LtQV(2, func);
}
module.exports = $d6367ca60b678e42$var$once;

});
parcelRegister("3LtQV", function(module, exports) {

var $mx0kf = parcelRequire("mx0kf");
/** Error message constants. */ var $2bdceaff28d0f0d8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $2bdceaff28d0f0d8$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($2bdceaff28d0f0d8$var$FUNC_ERROR_TEXT);
    n = $mx0kf(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
module.exports = $2bdceaff28d0f0d8$var$before;

});
parcelRegister("mx0kf", function(module, exports) {

var $5gV1x = parcelRequire("5gV1x");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $043ba8252d87df5d$var$toInteger(value) {
    var result = $5gV1x(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $043ba8252d87df5d$var$toInteger;

});
parcelRegister("5gV1x", function(module, exports) {

var $5UDqS = parcelRequire("5UDqS");
/** Used as references for various `Number` constants. */ var $3d6aae2029049def$var$INFINITY = 1 / 0, $3d6aae2029049def$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $3d6aae2029049def$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $5UDqS(value);
    if (value === $3d6aae2029049def$var$INFINITY || value === -$3d6aae2029049def$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $3d6aae2029049def$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $3d6aae2029049def$var$toFinite;

});
parcelRegister("5UDqS", function(module, exports) {

var $3HVQN = parcelRequire("3HVQN");

var $awGqx = parcelRequire("awGqx");

var $h7fLv = parcelRequire("h7fLv");
/** Used as references for various `Number` constants. */ var $44e0c536237ab90f$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $44e0c536237ab90f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $44e0c536237ab90f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $44e0c536237ab90f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $44e0c536237ab90f$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $44e0c536237ab90f$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($h7fLv(value)) return $44e0c536237ab90f$var$NAN;
    if ($awGqx(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $awGqx(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $3HVQN(value);
    var isBinary = $44e0c536237ab90f$var$reIsBinary.test(value);
    return isBinary || $44e0c536237ab90f$var$reIsOctal.test(value) ? $44e0c536237ab90f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $44e0c536237ab90f$var$reIsBadHex.test(value) ? $44e0c536237ab90f$var$NAN : +value;
}
module.exports = $44e0c536237ab90f$var$toNumber;

});
parcelRegister("3HVQN", function(module, exports) {

var $iCoGZ = parcelRequire("iCoGZ");
/** Used to match leading whitespace. */ var $2b324324025692e1$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $2b324324025692e1$var$baseTrim(string) {
    return string ? string.slice(0, $iCoGZ(string) + 1).replace($2b324324025692e1$var$reTrimStart, '') : string;
}
module.exports = $2b324324025692e1$var$baseTrim;

});
parcelRegister("iCoGZ", function(module, exports) {
/** Used to match a single whitespace character. */ var $d8deedff2ca4e23b$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d8deedff2ca4e23b$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d8deedff2ca4e23b$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $d8deedff2ca4e23b$var$trimmedEndIndex;

});







parcelRegister("Nc9iA", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("hkNkR", function(module, exports) {
$parcel$export(module.exports, "sendScreenEvent", () => $368122546e4fb1ed$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $368122546e4fb1ed$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $368122546e4fb1ed$export$e5f89b51c6d4e36b);
function $368122546e4fb1ed$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $368122546e4fb1ed$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $368122546e4fb1ed$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("d98L8", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $012feba6c02c69f1$export$6c724a6ffa2dc3e1);
const $012feba6c02c69f1$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $012feba6c02c69f1$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $012feba6c02c69f1$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $012feba6c02c69f1$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $012feba6c02c69f1$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $012feba6c02c69f1$export$cda2203640e08931;
}

});

parcelRegister("1Y0C6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a634875451903316$export$2e2bcd8739ae039);
const $a634875451903316$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $a634875451903316$export$2e2bcd8739ae039 = $a634875451903316$var$createCustomEvent;

});

parcelRegister("bVAiQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d56e38820f1f13af$export$2e2bcd8739ae039);
class $d56e38820f1f13af$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("gzUXQ", function(module, exports) {
$parcel$export(module.exports, "EngagementMessages", () => $1cfdfa654ca16047$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $diShS = parcelRequire("diShS");

var $62Zw3 = parcelRequire("62Zw3");

var $k3jZH = parcelRequire("k3jZH");
class $1cfdfa654ca16047$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k3jZH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $62Zw3.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $diShS.default), null));
    }
}

});
parcelRegister("diShS", function(module, exports) {
$parcel$export(module.exports, "ContextualSurveyWithEvents", () => $344cc79647ca2284$export$42b694a35bb75eda);
$parcel$export(module.exports, "default", () => $344cc79647ca2284$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ContextualSurvey", () => (parcelRequire("dbwSd")).default);
// eslint-disable-next-line import/order

var $1gntC = parcelRequire("1gntC");

var $fNwL4 = parcelRequire("fNwL4");

var $dbwSd = parcelRequire("dbwSd");
const $344cc79647ca2284$export$42b694a35bb75eda = (0, $1gntC.default)((0, $dbwSd.default));
// eslint-disable-next-line camelcase
const $344cc79647ca2284$var$_default_1 = (0, $fNwL4.default)($344cc79647ca2284$export$42b694a35bb75eda, 'contextualSurvey');
var // eslint-disable-next-line camelcase
$344cc79647ca2284$export$2e2bcd8739ae039 = $344cc79647ca2284$var$_default_1;

});
parcelRegister("1gntC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca361d7caba72a5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");
var $8ca361d7caba72a5$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $bSJIT.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $kIbto.default)()(EngagementEventsWrapper);
};

});

parcelRegister("fNwL4", function(module, exports) {
$parcel$export(module.exports, "default", () => $34b1b1e5d5f4e108$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");
var $34b1b1e5d5f4e108$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $bSJIT.Component) {
        static #_ = this.contextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
        };
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $bSJIT.useState)(null);
        const unsubscribeRef = (0, $bSJIT.useRef)(null);
        const removeConfigRef = (0, $bSJIT.useRef)(null);
        const canSubscribe = (0, $bSJIT.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.subscribeEngagementState);
        }, [
            context
        ]);
        const canSetConfig = (0, $bSJIT.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.setComponentConfig);
        }, [
            context
        ]);
        const onStoreChange = (0, $bSJIT.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $bSJIT.useCallback)(()=>{
            var _context$subscribeEng;
            return context === null || context === void 0 || (_context$subscribeEng = context.subscribeEngagementState) === null || _context$subscribeEng === void 0 ? void 0 : _context$subscribeEng.call(context, onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $bSJIT.useCallback)((propsToUse = props)=>{
            var _context$setComponent;
            return context === null || context === void 0 || (_context$setComponent = context.setComponentConfig) === null || _context$setComponent === void 0 ? void 0 : _context$setComponent.call(context, getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $bSJIT.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $bSJIT.useRef)(engagementId);
        const previousMessageType = (0, $bSJIT.useRef)(messageType);
        const previousOnMessageDisposition = (0, $bSJIT.useRef)(onMessageDisposition);
        (0, $bSJIT.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("dbwSd", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb5daf6a9b2097cd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gcviy = parcelRequire("gcviy");

var $6Fhdx = parcelRequire("6Fhdx");

var $2w66G = parcelRequire("2w66G");

var $8bkGS = parcelRequire("8bkGS");
function $cb5daf6a9b2097cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gcviy.default), {
        shouldShow: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bkGS.default), {
            markAsSeenAndFatigued: (0, $6Fhdx.markAsSeenAndFatigued),
            sendUserResponse: (0, $6Fhdx.sendUserResponse),
            getFlag: (0, $2w66G.getFlag),
            setFlag: (0, $2w66G.setFlag),
            ...props
        }));
}

});
parcelRegister("gcviy", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cb342b9be4272ca$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jvbf5 = parcelRequire("jvbf5");

var $lqv8M = parcelRequire("lqv8M");
// 8px is the base unit in pixels
const $3cb342b9be4272ca$var$surveyOffset = "var(--ds-space-600, 48px)";
const $3cb342b9be4272ca$var$marshalLayoutStyles = null;
const $3cb342b9be4272ca$var$marshalMotionLayerStyles = null;
function $3cb342b9be4272ca$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
        appear: true,
        children: shouldShow && /*#__PURE__*/ (0, $dc70d.jsx)((0, $lqv8M.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            children: (motionProps)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    ref: motionProps.ref,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- motion keyframes
                    className: (0, $9fU1q.default)([
                        "_kqsw1n9t _1xi2oahv _94n5oahv",
                        "_1pbyni7l",
                        motionProps.className
                    ]),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- motion animation styles
                    style: motionProps.style,
                    children: children()
                })
        }, "contextual-survey-marshal")
    });
}

});

parcelRegister("2w66G", function(module, exports) {
$parcel$export(module.exports, "getFlag", () => $d5692bf715d38ed8$export$a19b74191e00c5e);
$parcel$export(module.exports, "setFlag", () => $d5692bf715d38ed8$export$5e165df1e30a1331);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ async function $d5692bf715d38ed8$export$a19b74191e00c5e(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return {
        status: false,
        lastSeenDate: ''
    };
}
async function $d5692bf715d38ed8$export$5e165df1e30a1331(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return Promise.resolve();
}

});

parcelRegister("8bkGS", function(module, exports) {
$parcel$export(module.exports, "default", () => $97ced4e5ed1740d5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $cXJPv = parcelRequire("cXJPv");
const $97ced4e5ed1740d5$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $97ced4e5ed1740d5$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cXJPv.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $cXJPv.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        }, this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $97ced4e5ed1740d5$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        }, this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        }, this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $97ced4e5ed1740d5$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}

});
parcelRegister("cXJPv", function(module, exports) {
$parcel$export(module.exports, "DismissTrigger", () => $9cf9b0138a444245$export$151efc60ac534d42);
$parcel$export(module.exports, "default", () => $9cf9b0138a444245$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $8ouco = parcelRequire("8ouco");

var $6FCcT = parcelRequire("6FCcT");

var $7oS1E = parcelRequire("7oS1E");

var $aGXNK = parcelRequire("aGXNK");

var $hXsV3 = parcelRequire("hXsV3");

var $lso8I = parcelRequire("lso8I");
var $9cf9b0138a444245$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
const $9cf9b0138a444245$export$3e8963a077f85f25 = 8000;
var $9cf9b0138a444245$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
    const autoDisappearTimeoutRef = (0, $bSJIT.useRef)(null);
    // only allow a single dismiss for a component
    const isDismissedRef = (0, $bSJIT.useRef)(false);
    const tryDismiss = (0, $bSJIT.useCallback)((trigger)=>{
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    const [currentStep, setCurrentStep] = (0, $bSJIT.useState)('SURVEY');
    const trySetCurrentStep = (0, $bSJIT.useCallback)((step)=>{
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    const onDismissRef = (0, $bSJIT.useRef)(onDismiss);
    (0, $bSJIT.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    // reset isDismissedRef.current on mount to be compatible with double render in react18 strict mode
    (0, $bSJIT.useEffect)(()=>{
        isDismissedRef.current = false;
    }, []);
    const tryClearTimeout = (0, $bSJIT.useCallback)(()=>{
        const id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $bSJIT.useEffect)(()=>{
        return function unmount() {
            tryClearTimeout();
            tryDismiss("UNMOUNT");
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    const onSurveySubmit = (0, $bSJIT.useCallback)(async (formValues, _form, callback = ()=>{})=>{
        // Submitting form: Phase 1 complete
        await onSubmit(formValues);
        // Note: need to call callback just before we navigate away
        // It cleans up the form (required)
        // Optional Phase 2: Asking to join Atlassian Research Group
        // Only enter phase 2 if:
        // 1. not already dismissed; AND
        // 2. permission given to contact; AND
        // 3. user has previously not answered mailing list question (getUserHasAnsweredMailingList returns false)
        // Not entering phase 2: User has dismissed while the submit promise was resolving
        if (isDismissedRef.current) {
            callback();
            return;
        }
        // Not entering phase 2: no permission given to respond to feedback
        if (!formValues.canContact) {
            callback();
            trySetCurrentStep('POST_SURVEY_NO_CONSENT');
            return;
        }
        const userHasAnswered = await getUserHasAnsweredMailingList();
        callback();
        // Not entering phase 2: user has already answered this question
        if (userHasAnswered) {
            trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
            return;
        }
        // Enter phase 2
        trySetCurrentStep('SIGN_UP_PROMPT');
    }, [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    const onMailingListResponse = (0, $bSJIT.useCallback)(async (answer)=>{
        await onMailingListAnswer(answer);
        if (answer) {
            trySetCurrentStep('SIGN_UP_SUCCESS');
            return;
        }
        // We have already thanked to user, we can simply close
        tryDismiss("FINISHED");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $bSJIT.useEffect)(()=>{
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            'SIGN_UP_SUCCESS',
            'POST_SURVEY_NO_CONSENT',
            'POST_SURVEY_HAS_SIGN_UP'
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $9cf9b0138a444245$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $lso8I.default)({
        onDismiss: ()=>tryDismiss("MANUAL")
    });
    const content = (()=>{
        if (currentStep === 'SURVEY') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hXsV3.default), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === 'SIGN_UP_PROMPT') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6FCcT.default), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === 'SIGN_UP_SUCCESS') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7oS1E.default), {});
        if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8ouco.default), {});
        return null;
    })();
    const manualDismiss = (0, $bSJIT.useCallback)(()=>{
        // clear any pending timers
        tryClearTimeout();
        tryDismiss("MANUAL");
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aGXNK.default), {
        onDismiss: manualDismiss,
        children: content
    });
};

});
parcelRegister("8ouco", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef334f69dde9e0bf$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7WQx2 = parcelRequire("7WQx2");

var $jTm1U = parcelRequire("jTm1U");
var $ef334f69dde9e0bf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $jTm1U.default), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
            size: "xsmall",
            children: "Thanks for your feedback"
        })
    });

});
parcelRegister("jTm1U", function(module, exports) {
$parcel$export(module.exports, "default", () => $839431f111fd299c$export$2e2bcd8739ae039);
/* SuccessContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $lP6sB = parcelRequire("lP6sB");
const $839431f111fd299c$var$sectionStyles = null;
const $839431f111fd299c$var$iconContainerStyles = null;
var $839431f111fd299c$export$2e2bcd8739ae039 = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsxs)("section", {
        className: (0, $9fU1q.default)([
            "_18u01jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_kqswstnw _154iv47k _1ltv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
                    spacing: "spacious",
                    label: "",
                    "aria-hidden": true,
                    color: "var(--ds-icon-success, #6A9A23)"
                })
            }),
            children
        ]
    });

});


parcelRegister("6FCcT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ee082804377104d$export$2e2bcd8739ae039);
/* SignUpPrompt.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jNJGJ = parcelRequire("jNJGJ");

var $7WQx2 = parcelRequire("7WQx2");

var $9Rfip = parcelRequire("9Rfip");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $jTm1U = parcelRequire("jTm1U");
const $0ee082804377104d$var$buttonContainerStyles = null;
var $0ee082804377104d$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
    const [pending, setPending] = (0, $bSJIT.useState)(null);
    const answeredWith = (0, $bSJIT.useCallback)(async (answer)=>{
        setPending(answer ? 'yes' : 'no');
        await onAnswer(answer);
    }, [
        setPending,
        onAnswer
    ]);
    const isDisabled = Boolean(pending);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $jTm1U.default), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                size: "xsmall",
                children: "Thanks for your feedback"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                paddingBlockStart: "space.150",
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                            as: "p",
                            children: "Are you interested in participating in our research?"
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $8aT4G.Text), {
                            as: "p",
                            children: [
                                "Sign up for the",
                                ' ',
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Rfip.default), {
                                    href: "https://www.atlassian.com/research-group",
                                    target: "_blank",
                                    children: "Atlassian Research Group"
                                }),
                                ' ',
                                "and we may contact you in the future with research opportunities."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                className: (0, $9fU1q.default)([
                    "_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "subtle",
                        onClick: ()=>answeredWith(false),
                        isDisabled: isDisabled,
                        isLoading: pending === 'no',
                        children: "No, thanks"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "primary",
                        onClick: ()=>answeredWith(true),
                        isDisabled: isDisabled,
                        isLoading: pending === 'yes',
                        children: "Yes, sign me up"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jNJGJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9b597bb800ae8f5a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7ZmGm = parcelRequire("7ZmGm");

var $kLU70 = parcelRequire("kLU70");

var $aHtkE = parcelRequire("aHtkE");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $9b597bb800ae8f5a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7ZmGm.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kLU70.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kLU70.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kLU70.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                    icon: iconAfter
                })
            })
        ]
    });
}));
$9b597bb800ae8f5a$var$Button.displayName = 'Button';
var $9b597bb800ae8f5a$export$2e2bcd8739ae039 = $9b597bb800ae8f5a$var$Button;

});

parcelRegister("9Rfip", function(module, exports) {
$parcel$export(module.exports, "default", () => $81467338b9226d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jDsoo = parcelRequire("jDsoo");

var $bLXMw = parcelRequire("bLXMw");

var $9PwDt = parcelRequire("9PwDt");
const $81467338b9226d05$var$styles = {
    base: "_2rkolb4i _ect4ttxp",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $81467338b9226d05$var$iconStyles = null;
const $81467338b9226d05$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $dc70d.jsxs)((0, $bLXMw.Anchor), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $jDsoo.cx)($81467338b9226d05$var$styles.base, appearance === 'default' && $81467338b9226d05$var$styles.defaultAppearance, appearance === 'subtle' && $81467338b9226d05$var$styles.subtleAppearance, appearance === 'inverse' && $81467338b9226d05$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $81467338b9226d05$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                as: "span",
                xcss: $81467338b9226d05$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $9fU1q.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $81467338b9226d05$var$Link = /*#__PURE__*/ (0, $bSJIT.forwardRef)($81467338b9226d05$var$LinkWithoutRef);
var $81467338b9226d05$export$2e2bcd8739ae039 = $81467338b9226d05$var$Link;

});
parcelRegister("bLXMw", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $d6378e1dee71f536$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ /* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $jCkxO = parcelRequire("jCkxO");

var $kIUP1 = parcelRequire("kIUP1");

var $14KEJ = parcelRequire("14KEJ");

var $1OdZP = parcelRequire("1OdZP");

var $d6mTg = parcelRequire("d6mTg");

var $cyIUy = parcelRequire("cyIUy");

var $9Abbn = parcelRequire("9Abbn");

var $aPI66 = parcelRequire("aPI66");
const $d6378e1dee71f536$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $d6378e1dee71f536$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $d6378e1dee71f536$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $d6378e1dee71f536$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $1OdZP.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $d6mTg.useId)();
    const onClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $14KEJ.useRouterLink)();
    const isExternal = typeof href === 'string' && $d6378e1dee71f536$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $d6378e1dee71f536$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $jCkxO.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aPI66.Focusable), {
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $14TCm.cx)($d6378e1dee71f536$var$styles.root, $d6378e1dee71f536$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
const $d6378e1dee71f536$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $bSJIT.forwardRef)($d6378e1dee71f536$var$AnchorNoRef);

});
parcelRegister("14KEJ", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $891ce9afca14ce2e$export$6d558eab13290f59);

var $bSJIT = parcelRequire("bSJIT");

var $jA7ND = parcelRequire("jA7ND");
const $891ce9afca14ce2e$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $bSJIT.useContext)((0, $jA7ND.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("jA7ND", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $f2a348f37367cd4f$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $f2a348f37367cd4f$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $f2a348f37367cd4f$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $bSJIT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $f2a348f37367cd4f$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($f2a348f37367cd4f$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f2a348f37367cd4f$export$2e2bcd8739ae039 = $f2a348f37367cd4f$var$RouterLinkProvider;

});




parcelRegister("8aT4G", function(module, exports) {
$parcel$export(module.exports, "Text", () => $1adc9aa5bb9ff3ab$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v3.0.2 */ /* text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jCkxO = parcelRequire("jCkxO");

var $jP6ub = parcelRequire("jP6ub");

var $eMcp0 = parcelRequire("eMcp0");

var $dHn3F = parcelRequire("dHn3F");
const $1adc9aa5bb9ff3ab$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $1adc9aa5bb9ff3ab$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $eMcp0.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($1adc9aa5bb9ff3ab$var$inverseColorMap.hasOwnProperty(surface)) return $1adc9aa5bb9ff3ab$var$inverseColorMap[surface];
    return 'color.text';
};
const $1adc9aa5bb9ff3ab$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $1adc9aa5bb9ff3ab$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $1adc9aa5bb9ff3ab$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $1adc9aa5bb9ff3ab$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $1adc9aa5bb9ff3ab$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $1adc9aa5bb9ff3ab$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $jCkxO.default)($1adc9aa5bb9ff3ab$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $dHn3F.useHasTextAncestor)();
    const color = $1adc9aa5bb9ff3ab$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        id: id,
        className: (0, $9fU1q.default)([
            $1adc9aa5bb9ff3ab$var$styles.root,
            size && $1adc9aa5bb9ff3ab$var$fontSizeMap[size],
            color && $1adc9aa5bb9ff3ab$var$textColorMap[color],
            maxLines && $1adc9aa5bb9ff3ab$var$styles.truncation,
            maxLines === 1 && $1adc9aa5bb9ff3ab$var$styles.breakAll,
            align && $1adc9aa5bb9ff3ab$var$styles[`textAlign.${align}`],
            weight && $1adc9aa5bb9ff3ab$var$fontWeightMap[weight],
            Component === 'em' && $1adc9aa5bb9ff3ab$var$styles['as.em'],
            Component === 'strong' && $1adc9aa5bb9ff3ab$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jP6ub.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});

});
parcelRegister("jP6ub", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $43b52195a1700120$export$ae933c6cbe5643ad);

var $8rzC4 = parcelRequire("8rzC4");
const $43b52195a1700120$export$ae933c6cbe5643ad = (0, $8rzC4.HasTextAncestorContext).Provider;

});
parcelRegister("8rzC4", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $20eca88f823dd4cb$export$19538d0bfc69c6e0);

var $bSJIT = parcelRequire("bSJIT");
const $20eca88f823dd4cb$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});


parcelRegister("dHn3F", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $c229e5fe473a7f0d$export$9322276ec105d055);

var $bSJIT = parcelRequire("bSJIT");

var $8rzC4 = parcelRequire("8rzC4");
const $c229e5fe473a7f0d$export$9322276ec105d055 = ()=>(0, $bSJIT.useContext)((0, $8rzC4.HasTextAncestorContext));

});



parcelRegister("7oS1E", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf307d3921ad4909$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7WQx2 = parcelRequire("7WQx2");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $jTm1U = parcelRequire("jTm1U");
var $bf307d3921ad4909$export$2e2bcd8739ae039 = ({})=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $jTm1U.default), {
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                    size: "xsmall",
                    children: "Thanks for signing up"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "p",
                    children: "We may reach out to you in the future to participate in additional research."
                })
            ]
        })
    });

});

parcelRegister("aGXNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7c2ee29a7649a76$export$2e2bcd8739ae039);
/* SurveyContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4TRbS = parcelRequire("4TRbS");

var $9dYEz = parcelRequire("9dYEz");
const $e7c2ee29a7649a76$var$containerStyles = null;
const $e7c2ee29a7649a76$var$buttonWrapperStyles = null;
var $e7c2ee29a7649a76$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        style: {},
        className: (0, $9fU1q.default)([
            "_2rkofajl _bfhk1bhr _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qs130s _1bsb1vif"
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_kqswstnw _154ipxbi _1xi2pxbi"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))),
                    label: "Dismiss",
                    appearance: "subtle",
                    onClick: onDismiss
                })
            }),
            children
        ]
    });
};

});

parcelRegister("hXsV3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3225eb6ca332f577$export$2e2bcd8739ae039);
/* SurveyForm.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $cvNPo = parcelRequire("cvNPo");

var $fbRS9 = parcelRequire("fbRS9");

var $7WQx2 = parcelRequire("7WQx2");

var $6BJBW = parcelRequire("6BJBW");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $9nDyG = parcelRequire("9nDyG");

var $kk1X2 = parcelRequire("kk1X2");
const $3225eb6ca332f577$var$transitionBaseStyles = null;
const $3225eb6ca332f577$var$TRANSITION_DURATION = 200;
var $3225eb6ca332f577$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
    const [expanded, setExpanded] = (0, $bSJIT.useState)(false);
    const [canContactDefault, setCanContactDefault] = (0, $bSJIT.useState)(false);
    const hasAutoFilledCanContactRef = (0, $bSJIT.useRef)(false);
    const onScoreSelect = (0, $bSJIT.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    const onFeedbackChange = (0, $bSJIT.useCallback)(()=>{
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    const resizingHeightProps = (0, $6BJBW.useResizingHeight)({
        duration: ()=>$3225eb6ca332f577$var$TRANSITION_DURATION,
        timingFunction: ()=>'ease-in-out'
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("section", {
        "aria-labelledby": "contextualSurveyQuestion",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                        id: "contextualSurveyQuestion",
                        size: "xsmall",
                        as: "h2",
                        children: question
                    }),
                    statement && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        as: "p",
                        id: "contextualSurveyStatement",
                        children: statement
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fbRS9.default), {
                onSubmit: onSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $dc70d.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvNPo.default), {
                                name: "feedbackScore",
                                isDisabled: submitting,
                                isRequired: true,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9nDyG.default), {
                                        ...fieldProps,
                                        onChange: (score)=>{
                                            fieldProps.onChange(score);
                                            onScoreSelect();
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                ...resizingHeightProps,
                                className: (0, $9fU1q.default)([
                                    "_1reo15vq _18m915vq"
                                ]),
                                children: expanded ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $kk1X2.SurveyFormExpandedFeedback), {
                                    canContactDefault: canContactDefault,
                                    onFeedbackChange: onFeedbackChange,
                                    submitting: submitting,
                                    textLabel: textLabel,
                                    textPlaceholder: textPlaceholder
                                }) : null
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("cvNPo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c496adf0dd9304fa$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $d6mTg = parcelRequire("d6mTg");

var $k1CGD = parcelRequire("k1CGD");

var $h3wFM = parcelRequire("h3wFM");

var $5bVHh = parcelRequire("5bVHh");

var $6l5Zu = parcelRequire("6l5Zu");

var $VrgaD = parcelRequire("VrgaD");

var $ekQN1 = parcelRequire("ekQN1");

var $hUIOI = parcelRequire("hUIOI");

var $7x378 = parcelRequire("7x378");

var $48lWJ = parcelRequire("48lWJ");
const $c496adf0dd9304fa$var$fieldWrapperStyles = null;
function $c496adf0dd9304fa$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $c496adf0dd9304fa$var$isFunction(x) {
    return typeof x === 'function';
}
function $c496adf0dd9304fa$var$usePreviousRef(current) {
    const ref = (0, $bSJIT.useRef)(current);
    // will be updated on the next render
    (0, $bSJIT.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $c496adf0dd9304fa$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $c496adf0dd9304fa$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $bSJIT.useContext)((0, $5bVHh.FormContext));
    const isDisabled = (0, $bSJIT.useContext)((0, $VrgaD.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $c496adf0dd9304fa$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $c496adf0dd9304fa$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$c496adf0dd9304fa$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $bSJIT.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $c496adf0dd9304fa$var$usePreviousRef(state);
    (0, $bSJIT.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $c496adf0dd9304fa$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($c496adf0dd9304fa$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $d6mTg.useId)();
    const fieldId = (0, $bSJIT.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $9fU1q.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $ekQN1.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $dc70d.jsx)((0, $7x378.RequiredAsterisk), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $h3wFM.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $hUIOI.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $dc70d.jsx)((0, $6l5Zu.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $dc70d.jsx)((0, $k1CGD.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $dc70d.jsx)((0, $48lWJ.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("k1CGD", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $89296df22385c645$export$915e9e7bd4f0f96d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $h3wFM = parcelRequire("h3wFM");

var $bGBSI = parcelRequire("bGBSI");

var $heT34 = parcelRequire("heT34");
const $89296df22385c645$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $h3wFM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bGBSI.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $heT34.default).mark($89296df22385c645$export$915e9e7bd4f0f96d);

});
parcelRegister("h3wFM", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $20f0ced3b721c7f0$export$3c4232819458a302);

var $bSJIT = parcelRequire("bSJIT");
const $20f0ced3b721c7f0$export$3c4232819458a302 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});

parcelRegister("bGBSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1d950c2f791aca7$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hkLEY = parcelRequire("hkLEY");

var $lP6sB = parcelRequire("lP6sB");

var $lvHAN = parcelRequire("lvHAN");

var $gdUUy = parcelRequire("gdUUy");

var $3a1Bm = parcelRequire("3a1Bm");

var $lFQDA = parcelRequire("lFQDA");
const $e1d950c2f791aca7$var$messageStyles = null;
const $e1d950c2f791aca7$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $e1d950c2f791aca7$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $e1d950c2f791aca7$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            $e1d950c2f791aca7$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $e1d950c2f791aca7$var$messageIcons = {
    error: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
const $e1d950c2f791aca7$var$MessageRow = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, isExiting: isExiting = false, testId: testId })=>{
    const icon = $e1d950c2f791aca7$var$messageIcons[appearance];
    const { isWrapper: isWrapper } = (0, $bSJIT.useContext)((0, $3a1Bm.MessageWrapperContext));
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-testid": testId,
        id: isExiting ? undefined : fieldId,
        // Let the wrapper own announcements from the first render when present.
        "aria-live": isWrapper ? undefined : 'polite',
        "aria-hidden": isExiting ? true : undefined,
        className: (0, $9fU1q.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $e1d950c2f791aca7$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $dc70d.jsx)($e1d950c2f791aca7$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $e1d950c2f791aca7$var$MotionMessage = (props)=>{
    const isErrorMessage = props.appearance === 'error';
    const { hasMotionBoundary: hasMotionBoundary, transition: transition } = (0, $bSJIT.useContext)((0, $3a1Bm.MessageWrapperContext));
    const shouldAnimate = isErrorMessage || hasMotionBoundary;
    const { ref: ref, state: state } = (0, $lvHAN.useMotion)({
        initialState: shouldAnimate && transition !== 'instant' ? undefined : 'visible'
    });
    const row = /*#__PURE__*/ (0, $dc70d.jsx)($e1d950c2f791aca7$var$MessageRow, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        isExiting: state === 'exiting',
        testId: props.testId,
        children: props.children
    });
    if (!shouldAnimate) return row;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lFQDA.default), {
        state: state,
        transition: transition,
        motionRef: ref,
        testId: props.testId && `${props.testId}-motion`,
        children: row
    });
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const $e1d950c2f791aca7$var$Message = (props)=>{
    if (!(0, $gdUUy.fg)('platform-dst-motion-uplift-input')) return /*#__PURE__*/ (0, $dc70d.jsx)($e1d950c2f791aca7$var$MessageRow, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        testId: props.testId,
        children: props.children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($e1d950c2f791aca7$var$MotionMessage, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        testId: props.testId,
        children: props.children
    });
};
var $e1d950c2f791aca7$export$2e2bcd8739ae039 = $e1d950c2f791aca7$var$Message;

});
parcelRegister("3a1Bm", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $ac32e6f6756e9cb2$export$579aef2c392a54d4);

var $bSJIT = parcelRequire("bSJIT");
const $ac32e6f6756e9cb2$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    isWrapper: false,
    hasMotionBoundary: false,
    transition: 'row'
});

});

parcelRegister("lFQDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e6256eee36466ea$export$2e2bcd8739ae039);
/* message-track.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $9e6256eee36466ea$var$expandRow = null;
const $9e6256eee36466ea$var$collapseRow = null;
const $9e6256eee36466ea$var$messageTrackStyles = {
    root: "_1e0c11p5 _2z05hkll",
    row: "_1tkeidpf",
    hidden: "_2z0563bf _3um015vq",
    invisible: "_3um015vq",
    enteringExpand: "_y44vum57 _1bumglyw",
    exitingCollapse: "_y44vhopr _1bumglyw",
    entering: "_y44v17p6 _1bumglyw",
    exiting: "_y44vst8y _1bumglyw",
    exitingInstant: "_1e0cglyw"
};
const $9e6256eee36466ea$var$MessageTrack = ({ children: children, transition: transition, motionRef: motionRef, state: state, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: motionRef,
        "aria-hidden": state === 'exiting' ? true : undefined,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $9e6256eee36466ea$var$messageTrackStyles.root,
            transition === 'row' && (state === 'init' || state === 'hidden') && $9e6256eee36466ea$var$messageTrackStyles.hidden,
            transition === 'groupEnter' && (state === 'init' || state === 'hidden') && $9e6256eee36466ea$var$messageTrackStyles.invisible,
            transition === 'row' && state === 'entering' && $9e6256eee36466ea$var$messageTrackStyles.enteringExpand,
            transition === 'row' && state === 'exiting' && $9e6256eee36466ea$var$messageTrackStyles.exitingCollapse,
            transition === 'groupEnter' && state === 'entering' && $9e6256eee36466ea$var$messageTrackStyles.entering,
            transition === 'groupExit' && state === 'exiting' && $9e6256eee36466ea$var$messageTrackStyles.exiting,
            transition === 'instant' && state === 'exiting' && $9e6256eee36466ea$var$messageTrackStyles.exitingInstant
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            className: (0, $9fU1q.default)([
                $9e6256eee36466ea$var$messageTrackStyles.row
            ]),
            children: children
        })
    });
var $9e6256eee36466ea$export$2e2bcd8739ae039 = $9e6256eee36466ea$var$MessageTrack;

});


parcelRegister("heT34", function(module, exports) {
$parcel$export(module.exports, "default", () => $21256a4a007a89f1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $21256a4a007a89f1$var$messageMotionCapability = Symbol.for('@atlaskit/form/message-motion-capable');
const $21256a4a007a89f1$var$messageMotion = {
    mark (component) {
        Object.defineProperty(component, $21256a4a007a89f1$var$messageMotionCapability, {
            value: true
        });
    },
    isCapable (child) {
        if (!/*#__PURE__*/ (0, $bSJIT.isValidElement)(child)) return false;
        const childType = child.type;
        return (typeof childType === 'function' || typeof childType === 'object' && childType !== null) && Reflect.get(childType, $21256a4a007a89f1$var$messageMotionCapability) === true;
    }
};
var $21256a4a007a89f1$export$2e2bcd8739ae039 = $21256a4a007a89f1$var$messageMotion;

});


parcelRegister("5bVHh", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $8a4be9f62bc732de$export$c24727297075ec6a);

var $bSJIT = parcelRequire("bSJIT");
const $8a4be9f62bc732de$export$c24727297075ec6a = /*#__PURE__*/ (0, $bSJIT.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("6l5Zu", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $59e503ee3b863f44$export$8fbe3c7d0ed2c683);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $h3wFM = parcelRequire("h3wFM");

var $bGBSI = parcelRequire("bGBSI");

var $heT34 = parcelRequire("heT34");
const $59e503ee3b863f44$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $h3wFM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bGBSI.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $heT34.default).mark($59e503ee3b863f44$export$8fbe3c7d0ed2c683);

});

parcelRegister("VrgaD", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $76af1d410d635ff2$export$c17cf6b332a82dbc);

var $bSJIT = parcelRequire("bSJIT");
const $76af1d410d635ff2$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});

parcelRegister("ekQN1", function(module, exports) {
$parcel$export(module.exports, "Label", () => $5c68c0bb53ff6176$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $5c68c0bb53ff6176$var$fieldsetLabelStyles = null;
const $5c68c0bb53ff6176$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });

});

parcelRegister("hUIOI", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $b4d2b5531d547b21$export$ec445f12f63100a5);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jvbf5 = parcelRequire("jvbf5");

var $gdUUy = parcelRequire("gdUUy");

var $dU97d = parcelRequire("dU97d");

var $3a1Bm = parcelRequire("3a1Bm");

var $hocKn = parcelRequire("hocKn");

var $heT34 = parcelRequire("heT34");
const $b4d2b5531d547b21$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true,
        hasMotionBoundary: false,
        transition: 'row'
    };
    const shouldProvideMotionBoundary = (0, $gdUUy.fg)('platform-dst-motion-uplift-input') && (0, $bSJIT.Children).toArray(children).every((0, $heT34.default).isCapable);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3a1Bm.MessageWrapperContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: shouldProvideMotionBoundary ? /*#__PURE__*/ (0, $dc70d.jsx)($b4d2b5531d547b21$var$MotionMessages, {
                children: children
            }) : children
        })
    });
};
const $b4d2b5531d547b21$var$getChildKeys = (children)=>(0, $bSJIT.Children).toArray(children).filter((0, $bSJIT.isValidElement)).map((child)=>child.key).filter((key)=>key !== null);
const $b4d2b5531d547b21$var$getTransition = (previousKeys, currentKeys)=>{
    const previous = new Set(previousKeys);
    const current = new Set(currentKeys);
    const removedCount = previousKeys.filter((key)=>!current.has(key)).length;
    const addedCount = currentKeys.filter((key)=>!previous.has(key)).length;
    if (removedCount > 0 && addedCount > 0) return 'instant';
    if (previousKeys.length === 0 && addedCount > 1) return 'groupEnter';
    if (currentKeys.length === 0 && removedCount > 1) return 'groupExit';
    return 'row';
};
const $b4d2b5531d547b21$var$MotionMessages = ({ children: children })=>{
    const currentKeys = $b4d2b5531d547b21$var$getChildKeys(children);
    const submitCount = (0, $bSJIT.useContext)((0, $dU97d.FormSubmitContext));
    const [transition, setTransition] = (0, $bSJIT.useState)(()=>({
            keys: currentKeys,
            mode: 'row',
            submitCount: submitCount
        }));
    const hasKeyChange = currentKeys.length !== transition.keys.length || currentKeys.some((key, index)=>key !== transition.keys[index]);
    const isSubmitUpdate = submitCount !== transition.submitCount;
    if (hasKeyChange || isSubmitUpdate) setTransition({
        keys: currentKeys,
        mode: !hasKeyChange ? transition.mode : isSubmitUpdate ? 'instant' : $b4d2b5531d547b21$var$getTransition(transition.keys, currentKeys),
        submitCount: submitCount
    });
    const motionContextValue = (0, $bSJIT.useMemo)(()=>({
            isWrapper: true,
            hasMotionBoundary: true,
            transition: transition.mode
        }), [
        transition.mode
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3a1Bm.MessageWrapperContext).Provider, {
        value: motionContextValue,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hocKn.default), {
            transition: transition.mode,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
                appear: true,
                children: children
            })
        })
    });
};

});
parcelRegister("dU97d", function(module, exports) {
$parcel$export(module.exports, "FormSubmitContext", () => $a195cc806a751b16$export$8f3f615a5fb5d1d6);

var $bSJIT = parcelRequire("bSJIT");
const $a195cc806a751b16$export$8f3f615a5fb5d1d6 = /*#__PURE__*/ (0, $bSJIT.createContext)(0);

});

parcelRegister("hocKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b7ffed856d595d7$export$2e2bcd8739ae039);
/* message-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $3b7ffed856d595d7$var$expandRow = null;
const $3b7ffed856d595d7$var$collapseRow = null;
const $3b7ffed856d595d7$var$messageGroupStyles = {
    root: "_1e0c11p5 _2z05hkll",
    row: "_1tkeidpf",
    expand: "_y44vl7y1 _1bumglyw",
    collapse: "_y44v1avz _1bumglyw"
};
const $3b7ffed856d595d7$var$MessageGroup = ({ children: children, transition: transition })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": "message-wrapper-motion",
        className: (0, $9fU1q.default)([
            $3b7ffed856d595d7$var$messageGroupStyles.root,
            transition === 'groupEnter' && $3b7ffed856d595d7$var$messageGroupStyles.expand,
            transition === 'groupExit' && $3b7ffed856d595d7$var$messageGroupStyles.collapse
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            className: (0, $9fU1q.default)([
                $3b7ffed856d595d7$var$messageGroupStyles.row
            ]),
            children: children
        })
    });
var $3b7ffed856d595d7$export$2e2bcd8739ae039 = $3b7ffed856d595d7$var$MessageGroup;

});


parcelRegister("7x378", function(module, exports) {
$parcel$export(module.exports, "RequiredAsterisk", () => $722fe6f8ebe5dd89$export$a4bb55a1e3b8a49f);
/* required-asterisk.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $722fe6f8ebe5dd89$var$requiredIndicatorStyles = null;
function $722fe6f8ebe5dd89$export$a4bb55a1e3b8a49f() {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $9fU1q.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("48lWJ", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $b2306713105358d9$export$5505afb209a532c8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $h3wFM = parcelRequire("h3wFM");

var $bGBSI = parcelRequire("bGBSI");

var $heT34 = parcelRequire("heT34");
const $b2306713105358d9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $h3wFM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bGBSI.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $heT34.default).mark($b2306713105358d9$export$5505afb209a532c8);

});


parcelRegister("fbRS9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b8906f8ed70c0bc$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v3.0.2 */ /* form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $i4AIC = parcelRequire("i4AIC");

var $3dCdz = parcelRequire("3dCdz");

var $hXIUN = parcelRequire("hXIUN");

var $66tqs = parcelRequire("66tqs");

var $fGbV9 = parcelRequire("fGbV9");

var $gdUUy = parcelRequire("gdUUy");

var $5bVHh = parcelRequire("5bVHh");

var $dU97d = parcelRequire("dU97d");

var $VrgaD = parcelRequire("VrgaD");

var $7EKMD = parcelRequire("7EKMD");
const $3b8906f8ed70c0bc$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $bSJIT.useRef)(null);
    const onSubmitRef = (0, $bSJIT.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $bSJIT.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $i4AIC.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($hXIUN)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($hXIUN)))(values, name, value);
                    }
                }
            }
        });
        (0, $3dCdz.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $7EKMD.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $bSJIT.useState)({
        dirty: false,
        submitting: false
    });
    const [submitCount, setSubmitCount] = (0, $bSJIT.useState)(0);
    (0, $bSJIT.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $bSJIT.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        if ((0, $gdUUy.fg)('platform-dst-motion-uplift-input')) setSubmitCount((count)=>count + 1);
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $bSJIT.useCallback)((name)=>{
        const formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $bSJIT.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $fGbV9.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $dc70d.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5bVHh.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dU97d.FormSubmitContext).Provider, {
            value: submitCount,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $VrgaD.IsDisabledContext).Provider, {
                value: isDisabled,
                children: childrenContent
            })
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $3b8906f8ed70c0bc$var$Form = (0, $66tqs.default)($3b8906f8ed70c0bc$var$FormBase);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3b8906f8ed70c0bc$export$2e2bcd8739ae039 = $3b8906f8ed70c0bc$var$Form;

});
parcelRegister("i4AIC", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $d2851547bcba47a9$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $d2851547bcba47a9$export$f681a8129d2e9d28);

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");
//      
var $d2851547bcba47a9$var$charCodeOfDot = ".".charCodeAt(0);
var $d2851547bcba47a9$var$reEscapeChar = /\\(\\)?/g;
var $d2851547bcba47a9$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $d2851547bcba47a9$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $d2851547bcba47a9$var$charCodeOfDot) result.push("");
    string.replace($d2851547bcba47a9$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($d2851547bcba47a9$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $d2851547bcba47a9$var$keysCache = {};
var $d2851547bcba47a9$var$keysRegex = /[.[\]]+/;
var $d2851547bcba47a9$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($d2851547bcba47a9$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $d2851547bcba47a9$var$keysCache[key] = key.split($d2851547bcba47a9$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $d2851547bcba47a9$var$keysCache[key] = $d2851547bcba47a9$var$stringToPath(key);
    }
    return $d2851547bcba47a9$var$keysCache[key];
};
//      
var $d2851547bcba47a9$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $d2851547bcba47a9$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $d2851547bcba47a9$var$_toPropertyKey(arg) {
    var key = $d2851547bcba47a9$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $d2851547bcba47a9$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d2851547bcba47a9$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $kV77Q.default)(current, [
                key
            ].map($d2851547bcba47a9$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $g8vBZ.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $d2851547bcba47a9$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $d2851547bcba47a9$var$setInRecursor(state, 0, $d2851547bcba47a9$var$toPath(key), value1, destroyArrays);
};
var $d2851547bcba47a9$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $d2851547bcba47a9$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $d2851547bcba47a9$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $d2851547bcba47a9$export$c52e5867d5879e24(values, name);
    var error = $d2851547bcba47a9$export$c52e5867d5879e24(errors, name);
    if (error && error[$d2851547bcba47a9$export$735bebc8ffabf28a]) error = error[$d2851547bcba47a9$export$735bebc8ffabf28a];
    var submitError = submitErrors && $d2851547bcba47a9$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $d2851547bcba47a9$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($d2851547bcba47a9$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $d2851547bcba47a9$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $d2851547bcba47a9$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $d2851547bcba47a9$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$d2851547bcba47a9$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $d2851547bcba47a9$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $d2851547bcba47a9$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $d2851547bcba47a9$var$subscriptionFilter(result, state, previousState, subscription, $d2851547bcba47a9$export$41e855cb628c1b55, $d2851547bcba47a9$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $d2851547bcba47a9$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $d2851547bcba47a9$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $d2851547bcba47a9$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $d2851547bcba47a9$var$subscriptionFilter(result, state, previousState, subscription, $d2851547bcba47a9$export$f1ff97b9d1c7a3c3, $d2851547bcba47a9$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $d2851547bcba47a9$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$d2851547bcba47a9$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $d2851547bcba47a9$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $d2851547bcba47a9$export$83d89fbfd8236492 = "4.20.10";
var $d2851547bcba47a9$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $d2851547bcba47a9$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $d2851547bcba47a9$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $d2851547bcba47a9$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $d2851547bcba47a9$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $d2851547bcba47a9$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $d2851547bcba47a9$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $d2851547bcba47a9$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($d2851547bcba47a9$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $d2851547bcba47a9$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $g8vBZ.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $g8vBZ.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $d2851547bcba47a9$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $g8vBZ.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $g8vBZ.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $g8vBZ.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $d2851547bcba47a9$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $d2851547bcba47a9$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $d2851547bcba47a9$export$e6bdf135a54e021b,
                    shallowEqual: $d2851547bcba47a9$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $g8vBZ.default)({}, state.formState.values)); // clone to avoid writing
            if ($d2851547bcba47a9$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($d2851547bcba47a9$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $d2851547bcba47a9$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $d2851547bcba47a9$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $g8vBZ.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $g8vBZ.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $d2851547bcba47a9$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $d2851547bcba47a9$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $d2851547bcba47a9$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$d2851547bcba47a9$export$735bebc8ffabf28a]) {
                    var existing = $d2851547bcba47a9$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$d2851547bcba47a9$export$735bebc8ffabf28a] = error[$d2851547bcba47a9$export$735bebc8ffabf28a];
                    merged = $d2851547bcba47a9$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$d2851547bcba47a9$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$d2851547bcba47a9$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $g8vBZ.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $d2851547bcba47a9$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $d2851547bcba47a9$var$notify(fieldSubscriber, fieldState, lastFieldState, $d2851547bcba47a9$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $d2851547bcba47a9$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $g8vBZ.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($d2851547bcba47a9$export$c52e5867d5879e24(formState.values, key), $d2851547bcba47a9$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($d2851547bcba47a9$export$c52e5867d5879e24(formState.values, key), $d2851547bcba47a9$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$d2851547bcba47a9$var$hasAnyError(formState.errors) && !(formState.submitErrors && $d2851547bcba47a9$var$hasAnyError(formState.submitErrors));
        var nextFormState = $d2851547bcba47a9$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $d2851547bcba47a9$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $d2851547bcba47a9$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $d2851547bcba47a9$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $d2851547bcba47a9$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $d2851547bcba47a9$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $d2851547bcba47a9$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $d2851547bcba47a9$var$notify(state.subscribers, nextFormState, lastFormState, $d2851547bcba47a9$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $g8vBZ.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($d2851547bcba47a9$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $g8vBZ.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $g8vBZ.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($d2851547bcba47a9$export$c52e5867d5879e24(formState.values, key), $d2851547bcba47a9$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $d2851547bcba47a9$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $d2851547bcba47a9$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $d2851547bcba47a9$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $d2851547bcba47a9$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $d2851547bcba47a9$export$c52e5867d5879e24(state.formState.values, name) === $d2851547bcba47a9$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $d2851547bcba47a9$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $d2851547bcba47a9$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $g8vBZ.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $g8vBZ.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $g8vBZ.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $d2851547bcba47a9$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$d2851547bcba47a9$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $g8vBZ.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $d2851547bcba47a9$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $d2851547bcba47a9$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $d2851547bcba47a9$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $d2851547bcba47a9$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("3dCdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $25803b4a148c6a0a$export$2e2bcd8739ae039);

var $i4AIC = parcelRequire("i4AIC");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $25803b4a148c6a0a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $25803b4a148c6a0a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($25803b4a148c6a0a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $25803b4a148c6a0a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $i4AIC.getIn)(errors, input.name);
    });
};
//      
var $25803b4a148c6a0a$var$noop = function noop() {};
var $25803b4a148c6a0a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $25803b4a148c6a0a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $25803b4a148c6a0a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $25803b4a148c6a0a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $25803b4a148c6a0a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($25803b4a148c6a0a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$25803b4a148c6a0a$export$2e2bcd8739ae039 = $25803b4a148c6a0a$var$createDecorator;

});

parcelRegister("hXIUN", function(module, exports) {

var $g1scD = parcelRequire("g1scD");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $d13ac98f987af673$var$set(object, path, value) {
    return object == null ? object : $g1scD(object, path, value);
}
module.exports = $d13ac98f987af673$var$set;

});

parcelRegister("66tqs", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c35ece0c7d24f56$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $9c35ece0c7d24f56$export$2e2bcd8739ae039 = (0, $bSJIT.forwardRef);

});

parcelRegister("7EKMD", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $316878b82539f7d0$export$fc06342dc8588d3b);

var $i4AIC = parcelRequire("i4AIC");
const $316878b82539f7d0$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $i4AIC.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $i4AIC.getIn)(errors, input.name);
    });
};

});


parcelRegister("6BJBW", function(module, exports) {
$parcel$export(module.exports, "useResizingHeight", () => $d4b1182b2f73351c$export$da99457d6430d83);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $bSJIT = parcelRequire("bSJIT");

var $fg2GS = parcelRequire("fg2GS");

var $lj4Nn = parcelRequire("lj4Nn");

var $iWZGm = parcelRequire("iWZGm");

var $1V8O7 = parcelRequire("1V8O7");

var $4Ajbl = parcelRequire("4Ajbl");

var $e1fGp = parcelRequire("e1fGp");

var $1QkMl = parcelRequire("1QkMl");

var $3TS96 = parcelRequire("3TS96");
const $d4b1182b2f73351c$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $lj4Nn.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $fg2GS.easeInOut) } = {})=>{
    const prevDimensions = (0, $bSJIT.useRef)();
    const [element, setElementRef] = (0, $1V8O7.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $1QkMl.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $e1fGp.useRequestAnimationFrame)();
    (0, $3TS96.useSnapshotBeforeUpdate)(()=>{
        if ((0, $iWZGm.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $4Ajbl.useLayoutEffect)(()=>{
        if ((0, $iWZGm.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("fg2GS", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $b0096720cd4440df$export$c07234257a03d5e9);
$parcel$export(module.exports, "easeOut", () => $b0096720cd4440df$export$57636bb43b1ccbb0);
const $b0096720cd4440df$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $b0096720cd4440df$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $b0096720cd4440df$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $b0096720cd4440df$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $b0096720cd4440df$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $b0096720cd4440df$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $b0096720cd4440df$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("1V8O7", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $699d29def8590ae1$export$ff879f35a69d56b7);

var $bSJIT = parcelRequire("bSJIT");
const $699d29def8590ae1$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $bSJIT.useRef)(null);
    const setRef = (0, $bSJIT.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("e1fGp", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $e2a2027cabd4cfa1$export$1775f27e7c8051ca);

var $bSJIT = parcelRequire("bSJIT");
const $e2a2027cabd4cfa1$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $e2a2027cabd4cfa1$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $bSJIT.useRef)([]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $e2a2027cabd4cfa1$var$getHookDeps(opts));
    return (0, $bSJIT.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("3TS96", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $4fc861a2cad05eb7$export$9e95200239cd148b);

var $bSJIT = parcelRequire("bSJIT");

var $4Ajbl = parcelRequire("4Ajbl");
const $4fc861a2cad05eb7$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $bSJIT.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $4Ajbl.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("9nDyG", function(module, exports) {
$parcel$export(module.exports, "default", () => $96c0b9ba68c38e65$export$2e2bcd8739ae039);
/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jNJGJ = parcelRequire("jNJGJ");

var $8aT4G = parcelRequire("8aT4G");

var $lavtv = parcelRequire("lavtv");
const $96c0b9ba68c38e65$var$tooltipMessage = [
    'Strongly disagree',
    'Disagree',
    'Slightly disagree',
    'Neutral',
    'Slightly agree',
    'Agree',
    'Strongly agree'
];
const $96c0b9ba68c38e65$var$buttonWrapperStyles = null;
const $96c0b9ba68c38e65$var$descriptionWrapperStyles = null;
var $96c0b9ba68c38e65$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>/*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _12eju2gc"
                ]),
                children: Array.from({
                    length: 7
                }, (_, i)=>{
                    const score = i + 1;
                    const isSelected = value === score;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
                        content: $96c0b9ba68c38e65$var$tooltipMessage[i],
                        hideTooltipOnClick: true,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                            onClick: ()=>onChange(score),
                            isSelected: isSelected,
                            "aria-pressed": isSelected,
                            "aria-describedby": "contextualSurveyStatement",
                            "aria-label": $96c0b9ba68c38e65$var$tooltipMessage[i],
                            shouldFitContainer: true,
                            children: score
                        })
                    }, score);
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                "aria-hidden": true,
                className: (0, $9fU1q.default)([
                    "_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "start",
                        children: "Strongly disagree"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "center",
                        children: "Neutral"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "end",
                        children: "Strongly agree"
                    })
                ]
            })
        ]
    });

});

parcelRegister("kk1X2", function(module, exports) {
$parcel$export(module.exports, "SurveyFormExpandedFeedback", () => $197d17da2e869010$export$103c6e57bfbd4a99);
/* SurveyFormExpandedFeedback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $8HhhR = parcelRequire("8HhhR");

var $Wz8Hp = parcelRequire("Wz8Hp");

var $cvNPo = parcelRequire("cvNPo");

var $g0Amm = parcelRequire("g0Amm");

var $5R01U = parcelRequire("5R01U");
function $197d17da2e869010$export$103c6e57bfbd4a99({ canContactDefault: canContactDefault, onFeedbackChange: onFeedbackChange, submitting: submitting, textLabel: textLabel, textPlaceholder: textPlaceholder }) {
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvNPo.default), {
                name: "writtenFeedback",
                defaultValue: "",
                isDisabled: submitting,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5R01U.default), {
                        ...fieldProps,
                        "aria-label": textLabel,
                        placeholder: textPlaceholder,
                        onChange: (event)=>{
                            fieldProps.onChange(event);
                            onFeedbackChange();
                        }
                    })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $Wz8Hp.CheckboxField), {
                name: "canContact",
                isDisabled: submitting,
                defaultIsChecked: canContactDefault,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $8HhhR.Checkbox), {
                        ...fieldProps,
                        label: "Atlassian can contact me about this feedback"
                    })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $g0Amm.FormFooter), {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                    type: "submit",
                    appearance: "primary",
                    isLoading: submitting,
                    children: "Submit"
                })
            })
        ]
    });
}

});
parcelRegister("8HhhR", function(module, exports) {
$parcel$export(module.exports, "Checkbox", () => $46fe8d3ef978126f$export$48513f6b9f8ce62d);
/* checkbox.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIUP1 = parcelRequire("kIUP1");

var $fGbV9 = parcelRequire("fGbV9");

var $RhEcs = parcelRequire("RhEcs");

var $7GXuB = parcelRequire("7GXuB");

var $4abu4 = parcelRequire("4abu4");

var $kPvOb = parcelRequire("kPvOb");
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ const $46fe8d3ef978126f$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
const $46fe8d3ef978126f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $bSJIT.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $bSJIT.useRef)(null);
    const mergedRefs = (0, $fGbV9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $bSJIT.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7GXuB.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                // It is necessary only for Safari. It allows to render focus styles.
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $9fU1q.default)([
                    $46fe8d3ef978126f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $RhEcs.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $4abu4.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kPvOb.default), {})
                ]
            })
        ]
    });
}));
$46fe8d3ef978126f$export$48513f6b9f8ce62d.displayName = 'Checkbox';
var // keep the default export for backwards compatibility
$46fe8d3ef978126f$export$2e2bcd8739ae039 = $46fe8d3ef978126f$export$48513f6b9f8ce62d;

});
parcelRegister("RhEcs", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1a13fe088637ad$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const $6d1a13fe088637ad$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
// Cross-fade colors and glyphs without moving the input or focus outline.
// Semantic tokens keep SVG colors, borders and indicators aligned with input motion.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $6d1a13fe088637ad$var$motionStyles = {
    root: "_v564109b",
    selected: "_tzy4kb7n",
    glyph: "_v564109b _tzy4idpf _1hdqglyw",
    border: "_v564109b"
};
function $6d1a13fe088637ad$var$getIcon(isIndeterminate, isChecked, motionState) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $dc70d.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit",
        className: (0, $9fU1q.default)([
            motionState && $6d1a13fe088637ad$var$motionStyles.glyph,
            motionState === 'visible' && $6d1a13fe088637ad$var$motionStyles.selected
        ])
    });
    if (isChecked) return /*#__PURE__*/ (0, $dc70d.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit",
        className: (0, $9fU1q.default)([
            motionState && $6d1a13fe088637ad$var$motionStyles.glyph,
            motionState === 'visible' && $6d1a13fe088637ad$var$motionStyles.selected
        ])
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $6d1a13fe088637ad$var$CheckboxIcon = /*#__PURE__*/ (0, $bSJIT.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const hasMotion = (0, $gdUUy.fg)('platform_design_system_selection_radial_fade');
    const icon = (0, $bSJIT.useMemo)(()=>$6d1a13fe088637ad$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $9fU1q.default)([
            $6d1a13fe088637ad$var$svgStyles.root,
            hasMotion && $6d1a13fe088637ad$var$motionStyles.root
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $9fU1q.default)([
                        $6d1a13fe088637ad$var$svgStyles.rect,
                        hasMotion && $6d1a13fe088637ad$var$motionStyles.border
                    ])
                }),
                hasMotion ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
                    children: [
                        $6d1a13fe088637ad$var$getIcon(false, true, isChecked && !isIndeterminate ? 'visible' : 'hidden'),
                        $6d1a13fe088637ad$var$getIcon(true, false, isIndeterminate ? 'visible' : 'hidden')
                    ]
                }) : icon
            ]
        })
    });
});
var $6d1a13fe088637ad$export$2e2bcd8739ae039 = $6d1a13fe088637ad$var$CheckboxIcon;

});

parcelRegister("7GXuB", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf9b04138ea82f3$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const $5cf9b04138ea82f3$var$baseStyles = null;
const $5cf9b04138ea82f3$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
const $5cf9b04138ea82f3$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const $5cf9b04138ea82f3$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
const $5cf9b04138ea82f3$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
const $5cf9b04138ea82f3$var$disabledCheckedStyles = null;
function $5cf9b04138ea82f3$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("label", {
        className: (0, $9fU1q.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("4abu4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1c304e8a8109b11$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $f1c304e8a8109b11$var$labelTextStyles = null;
function $f1c304e8a8109b11$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("kPvOb", function(module, exports) {
$parcel$export(module.exports, "default", () => $102ce176756e8f1a$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $102ce176756e8f1a$var$requiredIndicatorStyles = null;
function $102ce176756e8f1a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "aria-hidden": true,
        className: (0, $9fU1q.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("Wz8Hp", function(module, exports) {
$parcel$export(module.exports, "CheckboxField", () => $31fac06452c249f2$export$94195a47b94ed396);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $cvNPo = parcelRequire("cvNPo");
const $31fac06452c249f2$export$94195a47b94ed396 = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $bSJIT.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvNPo.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvNPo.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};

});

parcelRegister("g0Amm", function(module, exports) {
$parcel$export(module.exports, "FormFooter", () => $4a0f194f7d3d6373$export$e7277fd05612133d);
/* form-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $4a0f194f7d3d6373$var$formFooterWrapperStyles = null;
const $4a0f194f7d3d6373$var$justifyContentStyles = null;
function $4a0f194f7d3d6373$export$e7277fd05612133d({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("footer", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("5R01U", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e5fdc23bf690ad7$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $gdUUy = parcelRequire("gdUUy");
const $0e5fdc23bf690ad7$var$packageName = undefined;
const $0e5fdc23bf690ad7$var$packageVersion = undefined;
const $0e5fdc23bf690ad7$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $0e5fdc23bf690ad7$var$packageName,
    packageVersion: $0e5fdc23bf690ad7$var$packageVersion
};
const $0e5fdc23bf690ad7$var$lineHeightBase = 20;
const $0e5fdc23bf690ad7$var$lineHeightCompact = 16;
const $0e5fdc23bf690ad7$var$compactVerticalPadding = 2;
const $0e5fdc23bf690ad7$var$verticalPadding = 6;
const $0e5fdc23bf690ad7$var$borderWidth = 2;
const $0e5fdc23bf690ad7$var$baseStyles = null;
const $0e5fdc23bf690ad7$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $0e5fdc23bf690ad7$var$finessePlaceholderStyles = null;
const $0e5fdc23bf690ad7$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $0e5fdc23bf690ad7$var$fontStyles = {
    default: "_11c8fhey _j4tm1d4k",
    monospace: "_11c8fhey _ect4zzfg _j4tm1d4k _1f2r1vhz"
};
const $0e5fdc23bf690ad7$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $0e5fdc23bf690ad7$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $0e5fdc23bf690ad7$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $0e5fdc23bf690ad7$var$InnerTextArea = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const ourRef = (0, $bSJIT.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const isInputMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = (0, $bSJIT.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $0e5fdc23bf690ad7$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$0e5fdc23bf690ad7$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$0e5fdc23bf690ad7$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $bSJIT.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $0e5fdc23bf690ad7$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $dc70d.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $9fU1q.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1qi0 _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            !isInputMotionEnabled && $0e5fdc23bf690ad7$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $0e5fdc23bf690ad7$var$inputMotionStyles.base,
            (0, $gdUUy.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
            $0e5fdc23bf690ad7$var$appearanceStyles[appearance],
            $0e5fdc23bf690ad7$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $0e5fdc23bf690ad7$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $3zY6O.default)($0e5fdc23bf690ad7$var$lineHeightCompact * minimumRows + $0e5fdc23bf690ad7$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $3zY6O.default)($0e5fdc23bf690ad7$var$lineHeightBase * minimumRows + $0e5fdc23bf690ad7$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $0e5fdc23bf690ad7$var$TextArea = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)($0e5fdc23bf690ad7$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$0e5fdc23bf690ad7$var$TextArea.displayName = 'TextArea';
var $0e5fdc23bf690ad7$export$2e2bcd8739ae039 = $0e5fdc23bf690ad7$var$TextArea;

});
parcelRegister("3zY6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $29b344595c2da506$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $29b344595c2da506$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});




parcelRegister("lso8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $189f4646f9f5c225$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $189f4646f9f5c225$export$4e7f196112fea3c5 = 27;
function $189f4646f9f5c225$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $189f4646f9f5c225$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    const inTextArea = Boolean(target.closest('textarea'));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $189f4646f9f5c225$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
    const onDismissRef = (0, $bSJIT.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $bSJIT.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $bSJIT.useEffect)(()=>{
        let unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $189f4646f9f5c225$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$189f4646f9f5c225$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $189f4646f9f5c225$var$bind(window, 'keydown', // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}

});





parcelRegister("62Zw3", function(module, exports) {
$parcel$export(module.exports, "FlagWithEvents", () => $afa4d04fa20f4f23$export$8423d11067fbf579);
$parcel$export(module.exports, "default", () => $afa4d04fa20f4f23$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Flag", () => (parcelRequire("hE6bc")).default);
// eslint-disable-next-line import/order

var $1gntC = parcelRequire("1gntC");

var $fNwL4 = parcelRequire("fNwL4");

var $hE6bc = parcelRequire("hE6bc");
const $afa4d04fa20f4f23$export$8423d11067fbf579 = (0, $1gntC.default)((0, $hE6bc.default));
// eslint-disable-next-line camelcase
const $afa4d04fa20f4f23$var$_default_1 = (0, $fNwL4.default)($afa4d04fa20f4f23$export$8423d11067fbf579, 'flag');
var // eslint-disable-next-line camelcase
$afa4d04fa20f4f23$export$2e2bcd8739ae039 = $afa4d04fa20f4f23$var$_default_1;

});
parcelRegister("hE6bc", function(module, exports) {
$parcel$export(module.exports, "default", () => $df496acf1be0e43c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fI1BQ = parcelRequire("fI1BQ");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $ewF0y = parcelRequire("ewF0y");

var $6EB1R = parcelRequire("6EB1R");

var $6ej4r = parcelRequire("6ej4r");
class $df496acf1be0e43c$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    static #_ = this.defaultProps = {
        fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ))),
        primaryText: null,
        primaryAction: null,
        secondaryText: null,
        secondaryAction: null,
        icon: 'smallInfo'
    };
    onClickActionHandler(action) {
        if (action && action.type === (0, $ewF0y.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $6ej4r.default)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lJzMO.default), {
            onDismissed: this.onDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2bmUD.default), {
            id: "engagement-flag",
            appearance: "normal",
            icon: FlagIcon,
            title: title,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6EB1R.default), {
                html: body
            }),
            actions: actions
        }));
    }
    constructor(...args){
        super(...args), this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        }, this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        }, this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}

});
parcelRegister("ewF0y", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $19d0c61b99265ffc$export$e7d79186651244da);
const $19d0c61b99265ffc$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("6EB1R", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b14d86aa005db92$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
class $1b14d86aa005db92$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("6ej4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $670d5ac30233a711$export$2e2bcd8739ae039);

var $e8iqP = parcelRequire("e8iqP");

var $eYvps = parcelRequire("eYvps");

var $3iMZX = parcelRequire("3iMZX");

var $jeV46 = parcelRequire("jeV46");

var $hkLEY = parcelRequire("hkLEY");

var $68E0O = parcelRequire("68E0O");

var $dsw4B = parcelRequire("dsw4B");
const $670d5ac30233a711$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($e8iqP))),
        label: 'success',
        color: "var(--ds-icon-success, #6A9A23)"
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))),
        label: 'error',
        color: "var(--ds-icon-danger, #C9372C)"
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O))),
        label: 'info',
        color: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))),
        label: 'warning',
        color: "var(--ds-icon-warning, #E06C00)"
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O))),
        label: 'info',
        color: "var(--ds-icon-discovery, #AF59E1)"
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eYvps))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3iMZX))),
        label: 'download',
        color: "var(--ds-icon, #292A2E)"
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jeV46))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    }
};
var $670d5ac30233a711$export$2e2bcd8739ae039 = $670d5ac30233a711$var$flagMapping;

});
parcelRegister("e8iqP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4a01c333a18f534$var$_react = $a4a01c333a18f534$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a4a01c333a18f534$var$_iconNew = $a4a01c333a18f534$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a4a01c333a18f534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4a01c333a18f534$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $a4a01c333a18f534$var$_react.default.createElement($a4a01c333a18f534$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$a4a01c333a18f534$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $a4a01c333a18f534$var$_default = module.exports.default = $a4a01c333a18f534$var$CheckCircleIcon;

});

parcelRegister("eYvps", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f20400a5f6ff94df1dafee093c930a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae6f089a056bcc00$var$_react = $ae6f089a056bcc00$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $ae6f089a056bcc00$var$_iconNew = $ae6f089a056bcc00$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $ae6f089a056bcc00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/comment
 * Usage guidance:
 * Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae6f089a056bcc00$var$CommentIcon = (props)=>/*#__PURE__*/ $ae6f089a056bcc00$var$_react.default.createElement($ae6f089a056bcc00$var$_iconNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$ae6f089a056bcc00$var$CommentIcon.displayName = 'CommentIcon';
var $ae6f089a056bcc00$var$_default = module.exports.default = $ae6f089a056bcc00$var$CommentIcon;

});

parcelRegister("3iMZX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78b6099804234b515b62cf480a885222>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26790f92f569f963$var$_react = $26790f92f569f963$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $26790f92f569f963$var$_iconNew = $26790f92f569f963$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $26790f92f569f963$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/download
 * Usage guidance:
 * Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26790f92f569f963$var$DownloadIcon = (props)=>/*#__PURE__*/ $26790f92f569f963$var$_react.default.createElement($26790f92f569f963$var$_iconNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$26790f92f569f963$var$DownloadIcon.displayName = 'DownloadIcon';
var $26790f92f569f963$var$_default = module.exports.default = $26790f92f569f963$var$DownloadIcon;

});

parcelRegister("jeV46", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2f2a7460880bea3d59fe6a53c49b2e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e01b9713d7506c15$var$_react = $e01b9713d7506c15$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e01b9713d7506c15$var$_iconNew = $e01b9713d7506c15$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e01b9713d7506c15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/feedback
 * Usage guidance:
 * Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e01b9713d7506c15$var$FeedbackIcon = (props)=>/*#__PURE__*/ $e01b9713d7506c15$var$_react.default.createElement($e01b9713d7506c15$var$_iconNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$e01b9713d7506c15$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $e01b9713d7506c15$var$_default = module.exports.default = $e01b9713d7506c15$var$FeedbackIcon;

});




parcelRegister("k3jZH", function(module, exports) {
$parcel$export(module.exports, "ModalDialogWithEvents", () => $f2f22a46f15ce76f$export$404a075b2b026e91);
$parcel$export(module.exports, "default", () => $f2f22a46f15ce76f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ModalDialog", () => (parcelRequire("2vUwM")).default);
// eslint-disable-next-line import/order

var $1gntC = parcelRequire("1gntC");

var $fNwL4 = parcelRequire("fNwL4");

var $2vUwM = parcelRequire("2vUwM");
const $f2f22a46f15ce76f$export$404a075b2b026e91 = (0, $1gntC.default)((0, $2vUwM.default));
// eslint-disable-next-line camelcase
const $f2f22a46f15ce76f$var$_default_1 = (0, $fNwL4.default)($f2f22a46f15ce76f$export$404a075b2b026e91, 'modalDialog');
var // eslint-disable-next-line camelcase
$f2f22a46f15ce76f$export$2e2bcd8739ae039 = $f2f22a46f15ce76f$var$_default_1;

});
parcelRegister("2vUwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $13d55866ee0b9666$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fvy9N = parcelRequire("fvy9N");

var $ewF0y = parcelRequire("ewF0y");

var $6EB1R = parcelRequire("6EB1R");
function $13d55866ee0b9666$var$header() {
    return null;
}
class $13d55866ee0b9666$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $ewF0y.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $13d55866ee0b9666$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fvy9N.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6EB1R.default), {
            html: body
        }));
    }
    constructor(...args){
        super(...args), this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        }, this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}

});
parcelRegister("fvy9N", function(module, exports) {
$parcel$export(module.exports, "default", () => $28613d01d3d525b7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2U5M0 = parcelRequire("2U5M0");

var $4TO83 = parcelRequire("4TO83");

var $hwgr4 = parcelRequire("hwgr4");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $l6EMG = parcelRequire("l6EMG");

var $anZ2y = parcelRequire("anZ2y");
class $28613d01d3d525b7$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    render() {
        const { actions: _actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $hwgr4.useModal)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l6EMG.ModalHeading), {
                id: titleId
            }, heading);
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l6EMG.ModalBody), null, heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(CustomHeader, null), children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Footer, null)));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l6EMG.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TO83.default).Provider, {
                    value: (0, $anZ2y.modalButtonTheme)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l6EMG.ModalActionContainer), {
                    shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                    const variant = idx ? 'subtle-link' : 'primary';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l6EMG.ModalActionItem), {
                        key: key || (typeof text === 'string' ? text : `${idx}`)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2U5M0.default), {
                        appearance: variant,
                        autoFocus: !idx,
                        ...rest
                    }, text));
                }))) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("hwgr4", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $30a6029f5bff54ef$export$33ffd74ebf07f060);

var $bSJIT = parcelRequire("bSJIT");

var $6gH4c = parcelRequire("6gH4c");
const $30a6029f5bff54ef$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $bSJIT.useContext)((0, $6gH4c.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("6gH4c", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $4abf79aa33cf0d27$export$ab57792b9b6974a6);

var $bSJIT = parcelRequire("bSJIT");
const $4abf79aa33cf0d27$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);

});


parcelRegister("2w1u7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e30d6578c020b652$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");

var $3CE45 = parcelRequire("3CE45");

var $hwgr4 = parcelRequire("hwgr4");

var $cqBdk = parcelRequire("cqBdk");

var $duF7L = parcelRequire("duF7L");
const $e30d6578c020b652$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $e30d6578c020b652$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $hwgr4.useModal)();
    const shouldScrollInViewport = (0, $duF7L.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $e30d6578c020b652$var$styles.root,
            hasInlinePadding && $e30d6578c020b652$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $3CE45.TouchScrollable), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cqBdk.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                "data-testid": testId,
                className: (0, $9fU1q.default)([
                    $e30d6578c020b652$var$styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $e30d6578c020b652$var$styles.paddingBlock,
                    hasInlinePadding && $e30d6578c020b652$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
var $e30d6578c020b652$export$2e2bcd8739ae039 = $e30d6578c020b652$var$ModalBody;

});
parcelRegister("3CE45", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4soxG = parcelRequire("4soxG");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $2a33ffc4875bfe80$var$_interopRequireDefault($4soxG).default;
    }
});

var $1Hfo1 = parcelRequire("1Hfo1");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $1Hfo1.TouchScrollable;
    }
});
function $2a33ffc4875bfe80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("4soxG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $33ecd082c64aea1c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $bSJIT = parcelRequire("bSJIT");
var $33ecd082c64aea1c$var$_react2 = $33ecd082c64aea1c$var$_interopRequireDefault($bSJIT);

var $19JJB = parcelRequire("19JJB");

var $1Hfo1 = parcelRequire("1Hfo1");

var $2ambk = parcelRequire("2ambk");
var $33ecd082c64aea1c$var$_withLockSheet2 = $33ecd082c64aea1c$var$_interopRequireDefault($2ambk);

var $2tdzv = parcelRequire("2tdzv");
var $33ecd082c64aea1c$var$_withTouchListeners2 = $33ecd082c64aea1c$var$_interopRequireDefault($2tdzv);

var $cbl4c = parcelRequire("cbl4c");
function $33ecd082c64aea1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33ecd082c64aea1c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $33ecd082c64aea1c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $33ecd082c64aea1c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $33ecd082c64aea1c$var$ScrollLock = function(_PureComponent) {
    $33ecd082c64aea1c$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $33ecd082c64aea1c$var$_classCallCheck(this, ScrollLock);
        return $33ecd082c64aea1c$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $33ecd082c64aea1c$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$19JJB.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $33ecd082c64aea1c$var$_react2.default.createElement($1Hfo1.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($bSJIT.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $33ecd082c64aea1c$var$compose = (0, $cbl4c.pipe)($33ecd082c64aea1c$var$_withTouchListeners2.default, $33ecd082c64aea1c$var$_withLockSheet2.default);
var $33ecd082c64aea1c$var$SheetLock = $33ecd082c64aea1c$var$compose($33ecd082c64aea1c$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $33ecd082c64aea1c$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $33ecd082c64aea1c$var$_react2.default.createElement($33ecd082c64aea1c$var$SheetLock, props) : props.children;
};
$33ecd082c64aea1c$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $33ecd082c64aea1c$var$LockToggle;

});
parcelRegister("19JJB", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("1Hfo1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $13c5be0af98d2eb7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $13c5be0af98d2eb7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $bSJIT = parcelRequire("bSJIT");

var $19JJB = parcelRequire("19JJB");

var $cbl4c = parcelRequire("cbl4c");
function $13c5be0af98d2eb7$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $13c5be0af98d2eb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13c5be0af98d2eb7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $13c5be0af98d2eb7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $13c5be0af98d2eb7$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $13c5be0af98d2eb7$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $13c5be0af98d2eb7$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $13c5be0af98d2eb7$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $13c5be0af98d2eb7$var$_possibleConstructorReturn(_this, _ret);
    }
    $13c5be0af98d2eb7$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$19JJB.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $cbl4c.preventInertiaScroll, $cbl4c.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $cbl4c.allowTouchMove, $cbl4c.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$19JJB.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $cbl4c.preventInertiaScroll, $cbl4c.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $cbl4c.allowTouchMove, $cbl4c.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $13c5be0af98d2eb7$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $bSJIT.cloneElement)(children, $13c5be0af98d2eb7$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($bSJIT.PureComponent);

});
parcelRegister("cbl4c", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $8de6da86f9893b46$var$preventTouchMove;
module.exports.allowTouchMove = $8de6da86f9893b46$var$allowTouchMove;
module.exports.preventInertiaScroll = $8de6da86f9893b46$var$preventInertiaScroll;
module.exports.isTouchDevice = $8de6da86f9893b46$var$isTouchDevice;
module.exports.camelToKebab = $8de6da86f9893b46$var$camelToKebab;
module.exports.parse = $8de6da86f9893b46$var$parse;
module.exports.getPadding = $8de6da86f9893b46$var$getPadding;
module.exports.getWindowHeight = $8de6da86f9893b46$var$getWindowHeight;
module.exports.getDocumentHeight = $8de6da86f9893b46$var$getDocumentHeight;
module.exports.makeStyleTag = $8de6da86f9893b46$var$makeStyleTag;
module.exports.injectStyles = $8de6da86f9893b46$var$injectStyles;
module.exports.insertStyleTag = $8de6da86f9893b46$var$insertStyleTag;

var $19JJB = parcelRequire("19JJB");
var $8de6da86f9893b46$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $8de6da86f9893b46$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $8de6da86f9893b46$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $8de6da86f9893b46$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8de6da86f9893b46$var$isTouchDevice() {
    if (!$19JJB.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $8de6da86f9893b46$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $8de6da86f9893b46$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $8de6da86f9893b46$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $8de6da86f9893b46$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($8de6da86f9893b46$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $8de6da86f9893b46$var$getPadding() {
    if (!$19JJB.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $8de6da86f9893b46$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($19JJB.canUseDOM) return window.innerHeight * multiplier;
}
function $8de6da86f9893b46$var$getDocumentHeight() {
    if ($19JJB.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $8de6da86f9893b46$var$makeStyleTag() {
    if (!$19JJB.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $8de6da86f9893b46$var$injectStyles(tag, css) {
    if (!$19JJB.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $8de6da86f9893b46$var$insertStyleTag(tag) {
    if (!$19JJB.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("2ambk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $193db8c5d1329748$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $193db8c5d1329748$var$withLockSheet;

var $bSJIT = parcelRequire("bSJIT");
var $193db8c5d1329748$var$_react2 = $193db8c5d1329748$var$_interopRequireDefault($bSJIT);

var $cbl4c = parcelRequire("cbl4c");
function $193db8c5d1329748$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $193db8c5d1329748$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $193db8c5d1329748$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $193db8c5d1329748$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $193db8c5d1329748$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $193db8c5d1329748$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $193db8c5d1329748$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $193db8c5d1329748$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $cbl4c.makeStyleTag)();
                if (!sheet) return;
                (0, $cbl4c.injectStyles)(sheet, styles);
                (0, $cbl4c.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $cbl4c.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $cbl4c.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $193db8c5d1329748$var$_possibleConstructorReturn(_this, _ret);
        }
        $193db8c5d1329748$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $193db8c5d1329748$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($bSJIT.PureComponent);
}

});

parcelRegister("2tdzv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1cc8d147500663fc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $1cc8d147500663fc$var$withTouchListeners;

var $bSJIT = parcelRequire("bSJIT");
var $1cc8d147500663fc$var$_react2 = $1cc8d147500663fc$var$_interopRequireDefault($bSJIT);

var $19JJB = parcelRequire("19JJB");

var $cbl4c = parcelRequire("cbl4c");
function $1cc8d147500663fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1cc8d147500663fc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1cc8d147500663fc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1cc8d147500663fc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $1cc8d147500663fc$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $1cc8d147500663fc$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $1cc8d147500663fc$var$_classCallCheck(this, TouchProvider);
            return $1cc8d147500663fc$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $1cc8d147500663fc$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$19JJB.canUseDOM || !(0, $cbl4c.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $cbl4c.preventTouchMove, $cbl4c.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$19JJB.canUseDOM || !(0, $cbl4c.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $cbl4c.preventTouchMove, $cbl4c.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $1cc8d147500663fc$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($bSJIT.PureComponent);
}

});



parcelRegister("cqBdk", function(module, exports) {
$parcel$export(module.exports, "default", () => $275bda513959bad3$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $9wZWu = parcelRequire("9wZWu");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $1OdZP = parcelRequire("1OdZP");

var $40hpH = parcelRequire("40hpH");

var $aPI66 = parcelRequire("aPI66");
const $275bda513959bad3$var$keylineColor = "var(--ds-border, #0B120E24)";
const $275bda513959bad3$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
const $275bda513959bad3$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $275bda513959bad3$var$ScrollContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $bSJIT.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $bSJIT.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $bSJIT.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $bSJIT.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $bSJIT.useEffect)(()=>{
        const schedule = (0, $9wZWu.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $40hpH.default)((0, $9wZWu.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $275bda513959bad3$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $275bda513959bad3$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $bSJIT.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $bAB3U.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $bAB3U.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $1OdZP.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aPI66.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $fGbV9.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $jDsoo.cx)($275bda513959bad3$var$styles.base, showTopKeyline && $275bda513959bad3$var$styles.topKeyline, showBottomKeyline && $275bda513959bad3$var$styles.bottomKeyline),
        children: children
    });
});
$275bda513959bad3$var$ScrollContainer.displayName = 'ScrollContainer';
var $275bda513959bad3$export$2e2bcd8739ae039 = $275bda513959bad3$var$ScrollContainer;

});
parcelRegister("40hpH", function(module, exports) {
$parcel$export(module.exports, "default", () => $870e6d77428142b3$export$2e2bcd8739ae039);

var $hRSZ1 = parcelRequire("hRSZ1");
function $870e6d77428142b3$export$2e2bcd8739ae039(callback) {
    const ref = (0, $hRSZ1.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("hRSZ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $38449829a83720ed$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $38449829a83720ed$var$uniqueReferencedValue = {};
function $38449829a83720ed$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $bSJIT.useRef)($38449829a83720ed$var$uniqueReferencedValue);
    if (ref.current === $38449829a83720ed$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("duF7L", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fb131891862c7e4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $f2FKY = parcelRequire("f2FKY");
function $7fb131891862c7e4$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $bSJIT.useContext)((0, $f2FKY.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});
parcelRegister("f2FKY", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $7fa484fbeec57d7e$export$dece24112a937f92);

var $bSJIT = parcelRequire("bSJIT");
const $7fa484fbeec57d7e$export$dece24112a937f92 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);

});



parcelRegister("c9mVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0cd42450f1b965d$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $ejA8y = parcelRequire("ejA8y");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $a0cd42450f1b965d$var$ModalWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ejA8y.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$a0cd42450f1b965d$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a0cd42450f1b965d$export$2e2bcd8739ae039 = $a0cd42450f1b965d$var$ModalWrapper;

});
parcelRegister("ejA8y", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d79ca768679c746$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $bAB3U = parcelRequire("bAB3U");

var $kqAcG = parcelRequire("kqAcG");

var $3CE45 = parcelRequire("3CE45");

var $kIUP1 = parcelRequire("kIUP1");

var $hZsX2 = parcelRequire("hZsX2");

var $1OdZP = parcelRequire("1OdZP");

var $21u3G = parcelRequire("21u3G");

var $d6mTg = parcelRequire("d6mTg");

var $iV599 = parcelRequire("iV599");

var $6gXOx = parcelRequire("6gXOx");

var $iRdwF = parcelRequire("iRdwF");

var $8Mgn9 = parcelRequire("8Mgn9");

var $8W36W = parcelRequire("8W36W");

var $2HQOV = parcelRequire("2HQOV");

var $gdUUy = parcelRequire("gdUUy");

var $cglph = parcelRequire("cglph");

var $cdLl4 = parcelRequire("cdLl4");

var $juI4y = parcelRequire("juI4y");

var $atMNJ = parcelRequire("atMNJ");

var $24u1j = parcelRequire("24u1j");

var $cO4NS = parcelRequire("cO4NS");

var $6gH4c = parcelRequire("6gH4c");

var $cd7vh = parcelRequire("cd7vh");

var $iObCy = parcelRequire("iObCy");

var $40WRr = parcelRequire("40WRr");

var $lPqcX = parcelRequire("lPqcX");

var $aGyQS = parcelRequire("aGyQS");

var $f2FKY = parcelRequire("f2FKY");

var $01FCw = parcelRequire("01FCw");

var $cNZiy = parcelRequire("cNZiy");
const $6d79ca768679c746$var$fillScreenStyles = null;
/**
 * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
 */ const $6d79ca768679c746$var$dialogStyles = {
    'body-scroll': "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug",
    'viewport-scroll': "_ln19p27b _1bsbauwl _4t3i1kxc",
    'full-screen': ""
};
// Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $6d79ca768679c746$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
/**
 * Styles applied to the visual modal surface.
 */ const $6d79ca768679c746$var$surfaceStyles = {
    root: "_1e0c1txw _2lx21bp4 _bfhk1bhr _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_2rkoidpf _epkxpb1k"
};
const $6d79ca768679c746$var$topLayerScrollModeStyles = {
    'full-screen': "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
    'viewport-scroll': "_4t3i1kxc _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _1mpv184x _1jyk17ks _g7116m9r _we1i18uh",
    'body-scroll': "_1bsbauwl _4t3i1kxc _1jyk17ks _g7116m9r _we1i18uh"
};
const $6d79ca768679c746$var$topLayerAutoHeightStyles = null;
const $6d79ca768679c746$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
    // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
// Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $6d79ca768679c746$var$useModalCloseHandler(providedOnClose) {
    return (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $1OdZP.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
}
function $6d79ca768679c746$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $6d79ca768679c746$var$isWidthName(value) {
    return (0, $01FCw.width).values.includes(value);
}
function $6d79ca768679c746$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($6d79ca768679c746$var$isWidthName(input)) return `${(0, $01FCw.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $6d79ca768679c746$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $6d79ca768679c746$var$getDialogDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
    return 'none';
}
/**
 * Top-layer rendering path (platform-dst-top-layer).
 *
 * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
 * management with native <dialog> via @atlaskit/top-layer/dialog.
 *
 * Key decisions:
 * - Animation: CSS transitions via @starting-style / allow-discrete.
 * - Close gating: Dialog only forwards allowed reasons.
 * - onClose event param: undefined - consumers should use close reason.
 * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
 *   returnFocus (see accessibility-criteria.md).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * top-layer path, so it never shares a hook sequence with the legacy path.
 */ function $6d79ca768679c746$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $1OdZP.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $cd7vh.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $6d79ca768679c746$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $8Mgn9.useExitingPersistence)();
    // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $d6mTg.useId)();
    const titleId = `modal-dialog-title-${id}`;
    // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $bSJIT.useRef)(null);
    // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $bSJIT.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
    // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $bSJIT.useRef)(null);
    const hasProvidedOnClose = Boolean(providedOnClose);
    const modalDialogContext = (0, $bSJIT.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        hasProvidedOnClose,
        isFullScreen
    ]);
    // Dialog has already applied the close behavior configured by `dismissedBy`.
    // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract.
    const onDialogClose = (0, $bSJIT.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $atMNJ.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]);
    const dismissedBy = $6d79ca768679c746$var$getDialogDismissedBy({
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    });
    const shouldShimCloseOnOverlayClick = shouldCloseOnOverlayClick && !shouldCloseOnEscapePress;
    // Required until we fully remove `shouldCloseOnEscapePress`.
    // Dialog's `dismissedBy` options do not support outside click without Escape (because it is a bad pattern)
    (0, $bSJIT.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!dialog || !shouldShimCloseOnOverlayClick) return;
        return (0, $bAB3U.bind)(dialog, {
            type: 'click',
            listener (event) {
                if (event.target === event.currentTarget) onDialogClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onDialogClose,
        shouldShimCloseOnOverlayClick
    ]);
    // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $bSJIT.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish === null || onExitFinish === void 0 || onExitFinish();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    const handleDialogEnterFinish = (0, $bSJIT.useCallback)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]);
    // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $bSJIT.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []);
    // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $21u3G.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object');
    // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $bSJIT.useEffect)(()=>{
        return (0, $cdLl4.combine)((0, $40WRr.disableDraggingToCrossOriginIFramesForElement)(), (0, $aGyQS.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $lPqcX.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $6d79ca768679c746$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $24u1j.Dialog), {
        ref: dialogRef,
        onClose: onDialogClose,
        dismissedBy: dismissedBy,
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        onEnterFinish: handleDialogEnterFinish,
        shouldHideBackdrop: isBlanketHidden,
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        xcss: $6d79ca768679c746$var$dialogStyles[scrollMode],
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $cO4NS.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                ref: contentRef,
                style: {
                    '--modal-dialog-height': $6d79ca768679c746$var$getTopLayerSurfaceHeight(height),
                    '--modal-dialog-width': $6d79ca768679c746$var$getTopLayerSurfaceWidth(width)
                },
                className: (0, $9fU1q.default)([
                    $6d79ca768679c746$var$surfaceStyles.root,
                    !isFullScreen && $6d79ca768679c746$var$surfaceStyles.borderRadius,
                    $6d79ca768679c746$var$topLayerScrollModeStyles[scrollMode],
                    !height && !isFullScreen && "_e8uo1ris"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6gH4c.ModalContext).Provider, {
                    value: modalDialogContext,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $f2FKY.ScrollContext).Provider, {
                        value: shouldScrollInViewport,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                            children: children
                        })
                    })
                })
            })
        ]
    });
}
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $6d79ca768679c746$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $1OdZP.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $cd7vh.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = $6d79ca768679c746$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $bSJIT.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $bSJIT.useCallback)((element)=>$6d79ca768679c746$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $iObCy.default)();
    // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $1OdZP.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $dc70d.jsx)((0, $hZsX2.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cNZiy.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                children: children
            })
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $1OdZP.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iV599.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cglph.default), {
            zIndex: (0, $juI4y.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, $gdUUy.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $iRdwF.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, $9fU1q.default)([
                        "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kqAcG.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3CE45))), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $3CE45.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $8W36W.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        ...fadeInProps,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: (0, $9fU1q.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kqAcG.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3CE45))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $3CE45.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
});
// Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $6d79ca768679c746$var$InternalModalWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    if ((0, $gdUUy.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ (0, $dc70d.jsx)($6d79ca768679c746$var$ModalWrapperTopLayer, {
        ...props
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($6d79ca768679c746$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d79ca768679c746$export$2e2bcd8739ae039 = $6d79ca768679c746$var$InternalModalWrapper;

});
parcelRegister("kqAcG", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf2519ce1ebce14$export$2e2bcd8739ae039);

var $kprD8 = parcelRequire("kprD8");

var $edf2519ce1ebce14$export$2e2bcd8739ae039 = (0, $kprD8.default);

});
parcelRegister("kprD8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edbb93358e644630$export$2e2bcd8739ae039);

var $kV77Q = parcelRequire("kV77Q");

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");

var $2aWAP = parcelRequire("2aWAP");

var $5fAzZ = parcelRequire("5fAzZ");
var $edbb93358e644630$var$FocusLockCombination = /*#__PURE__*/ $bSJIT.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $bSJIT.createElement((0, $2aWAP.default), (0, $g8vBZ.default)({
        sideCar: (0, $5fAzZ.default),
        ref: ref
    }, props));
});
var $edbb93358e644630$var$_ref = (0, $2aWAP.default).propTypes || {}, $edbb93358e644630$var$sideCar = $edbb93358e644630$var$_ref.sideCar, $edbb93358e644630$var$propTypes = (0, $kV77Q.default)($edbb93358e644630$var$_ref, [
    "sideCar"
]);
$edbb93358e644630$var$FocusLockCombination.propTypes = {};
var $edbb93358e644630$export$2e2bcd8739ae039 = $edbb93358e644630$var$FocusLockCombination;

});
parcelRegister("2aWAP", function(module, exports) {
$parcel$export(module.exports, "default", () => $1959f745a5a42c2c$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");


var $4IISo = parcelRequire("4IISo");

var $dP4Jx = parcelRequire("dP4Jx");

var $dcU7K = parcelRequire("dcU7K");

var $1ZUGe = parcelRequire("1ZUGe");

var $dVnQp = parcelRequire("dVnQp");
var $1959f745a5a42c2c$var$emptyArray = [];
var $1959f745a5a42c2c$var$FocusLock = /*#__PURE__*/ $bSJIT.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $bSJIT.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $bSJIT.useRef();
    var isActive = $bSJIT.useRef(false);
    var originalFocusedElement = $bSJIT.useRef(null);
    var _React$useState2 = $bSJIT.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $1959f745a5a42c2c$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $bSJIT.useState({}), id = _React$useState3[0];
    var onActivation = $bSJIT.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $bSJIT.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $bSJIT.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $bSJIT.useCallback(function(event) {
        if (isActive.current) (0, $1ZUGe.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $1ZUGe.mediumBlur).useMedium;
    var setObserveNode = $bSJIT.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $g8vBZ.default)((_extends2 = {}, _extends2[$4IISo.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$4IISo.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $dP4Jx.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $bSJIT.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $bSJIT.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $dcU7K.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $bSJIT.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $dcU7K.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $bSJIT.createElement(SideCar, {
        id: id,
        sideCar: (0, $1ZUGe.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $bSJIT.createElement(Container, (0, $g8vBZ.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $bSJIT.createElement((0, $dVnQp.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $dcU7K.hiddenGuard)
    }));
});
$1959f745a5a42c2c$var$FocusLock.propTypes = {};
var $1959f745a5a42c2c$export$2e2bcd8739ae039 = $1959f745a5a42c2c$var$FocusLock;

});
parcelRegister("4IISo", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $36fe14f75fbccfff$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $36fe14f75fbccfff$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $36fe14f75fbccfff$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $36fe14f75fbccfff$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $36fe14f75fbccfff$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $36fe14f75fbccfff$export$4f9a06cb7441a087 = 'data-focus-lock';
var $36fe14f75fbccfff$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $36fe14f75fbccfff$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $36fe14f75fbccfff$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $36fe14f75fbccfff$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("dP4Jx", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $a103b5baff9e7ea4$export$74665b213cb5c4cf);

var $bSJIT = parcelRequire("bSJIT");

var $abgtU = parcelRequire("abgtU");

var $awiX1 = parcelRequire("awiX1");
var $a103b5baff9e7ea4$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $bSJIT.useLayoutEffect : $bSJIT.useEffect;
var $a103b5baff9e7ea4$var$currentValues = new WeakMap();
function $a103b5baff9e7ea4$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $awiX1.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $abgtU.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $a103b5baff9e7ea4$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $a103b5baff9e7ea4$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $abgtU.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $abgtU.assignRef)(ref, current_1);
            });
        }
        $a103b5baff9e7ea4$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("abgtU", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $7697b758c5c2862e$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $7697b758c5c2862e$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("awiX1", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $7a8b97c8bd2a7533$export$25bec8c6f54ee79a);

var $bSJIT = parcelRequire("bSJIT");
function $7a8b97c8bd2a7533$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bSJIT.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("dcU7K", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $99d7ee67527dfba1$export$b8c7b07253306600);

var $bSJIT = parcelRequire("bSJIT");

var $99d7ee67527dfba1$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $99d7ee67527dfba1$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $99d7ee67527dfba1$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $bSJIT.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $99d7ee67527dfba1$export$b8c7b07253306600
    }));
};
$99d7ee67527dfba1$var$InFocusGuard.propTypes = {};
var $99d7ee67527dfba1$export$2e2bcd8739ae039 = $99d7ee67527dfba1$var$InFocusGuard;

});

parcelRegister("1ZUGe", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $1747746f277acc25$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $1747746f277acc25$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $1747746f277acc25$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $1747746f277acc25$export$892cbf28e5518020);

var $hxpNy = parcelRequire("hxpNy");
var $1747746f277acc25$export$5733e022b1d538cb = (0, $hxpNy.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $1747746f277acc25$export$b3e9a9312f73723c = (0, $hxpNy.createMedium)();
var $1747746f277acc25$export$3a1d52767cbc07b8 = (0, $hxpNy.createMedium)();
var $1747746f277acc25$export$892cbf28e5518020 = (0, $hxpNy.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("hxpNy", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $cc4987bb338aada1$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $cc4987bb338aada1$export$e13ec7dd7a14088d);

var $3Cq0D = parcelRequire("3Cq0D");
function $cc4987bb338aada1$var$ItoI(a) {
    return a;
}
function $cc4987bb338aada1$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $cc4987bb338aada1$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $cc4987bb338aada1$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $cc4987bb338aada1$var$ItoI;
    return $cc4987bb338aada1$var$innerCreateMedium(defaults, middleware);
}
function $cc4987bb338aada1$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $cc4987bb338aada1$var$innerCreateMedium(null);
    medium.options = (0, $3Cq0D.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("dVnQp", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $a23318321a0694c1$export$f5272e9b1168239c);

var $bSJIT = parcelRequire("bSJIT");
var $a23318321a0694c1$export$f5272e9b1168239c = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});


parcelRegister("5fAzZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d2aba60fdf9fa76$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");


var $2hmzL = parcelRequire("2hmzL");

var $2qbgg = parcelRequire("2qbgg");
var $fHz3D = parcelRequire("fHz3D");
var $1kOSJ = parcelRequire("1kOSJ");
var $etnYu = parcelRequire("etnYu");
var $S81Y3 = parcelRequire("S81Y3");parcelRequire("kjDTm");
var $6JJio = parcelRequire("6JJio");

var $akCxK = parcelRequire("akCxK");

var $1ZUGe = parcelRequire("1ZUGe");
var $3d2aba60fdf9fa76$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $3d2aba60fdf9fa76$var$isFreeFocus = function isFreeFocus() {
    return $3d2aba60fdf9fa76$var$focusOnBody() || (0, $S81Y3.focusIsHidden)();
};
var $3d2aba60fdf9fa76$var$lastActiveTrap = null;
var $3d2aba60fdf9fa76$var$lastActiveFocus = null;
var $3d2aba60fdf9fa76$var$lastPortaledElement = null;
var $3d2aba60fdf9fa76$var$focusWasOutsideWindow = false;
var $3d2aba60fdf9fa76$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $3d2aba60fdf9fa76$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($3d2aba60fdf9fa76$var$lastActiveTrap.whiteList || $3d2aba60fdf9fa76$var$defaultWhitelist)(activeElement);
};
var $3d2aba60fdf9fa76$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $3d2aba60fdf9fa76$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $3d2aba60fdf9fa76$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $3d2aba60fdf9fa76$var$lastPortaledElement && $3d2aba60fdf9fa76$var$lastPortaledElement.portaledElement === element;
};
function $3d2aba60fdf9fa76$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $3d2aba60fdf9fa76$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($3d2aba60fdf9fa76$var$focusWasOutsideWindow);
    return $3d2aba60fdf9fa76$var$focusWasOutsideWindow === 'meanwhile';
};
var $3d2aba60fdf9fa76$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $3d2aba60fdf9fa76$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $3d2aba60fdf9fa76$var$checkInHost(activeElement, area, area);
    });
};
var $3d2aba60fdf9fa76$var$activateTrap = function activateTrap() {
    var result = false;
    if ($3d2aba60fdf9fa76$var$lastActiveTrap) {
        var _lastActiveTrap = $3d2aba60fdf9fa76$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $3d2aba60fdf9fa76$var$lastPortaledElement && $3d2aba60fdf9fa76$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $akCxK.extractRef)).filter(Boolean));
            if (!activeElement || $3d2aba60fdf9fa76$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $3d2aba60fdf9fa76$var$focusWasOutside(crossFrame) || !$3d2aba60fdf9fa76$var$isFreeFocus() || !$3d2aba60fdf9fa76$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $etnYu.focusInside)(workingArea) || activeElement && $3d2aba60fdf9fa76$var$withinHost(activeElement, workingArea) || $3d2aba60fdf9fa76$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$3d2aba60fdf9fa76$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $6JJio.moveFocusInside)(workingArea, $3d2aba60fdf9fa76$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $3d2aba60fdf9fa76$var$lastPortaledElement = {};
                        }
                    }
                    $3d2aba60fdf9fa76$var$focusWasOutsideWindow = false;
                    $3d2aba60fdf9fa76$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $fHz3D.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $3d2aba60fdf9fa76$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $3d2aba60fdf9fa76$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $3d2aba60fdf9fa76$var$onTrap = function onTrap(event) {
    if ($3d2aba60fdf9fa76$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $3d2aba60fdf9fa76$var$onBlur = function onBlur() {
    return (0, $akCxK.deferAction)($3d2aba60fdf9fa76$var$activateTrap);
};
var $3d2aba60fdf9fa76$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $3d2aba60fdf9fa76$var$recordPortal(currentNode, source);
};
var $3d2aba60fdf9fa76$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $3d2aba60fdf9fa76$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        onBlur: $3d2aba60fdf9fa76$var$onBlur,
        onFocus: $3d2aba60fdf9fa76$var$onFocus
    }, children);
};
$3d2aba60fdf9fa76$var$FocusTrap.propTypes = {};
var $3d2aba60fdf9fa76$var$onWindowBlur = function onWindowBlur() {
    $3d2aba60fdf9fa76$var$focusWasOutsideWindow = 'just';
    (0, $akCxK.deferAction)(function() {
        $3d2aba60fdf9fa76$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $3d2aba60fdf9fa76$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $3d2aba60fdf9fa76$var$onTrap);
    document.addEventListener('focusout', $3d2aba60fdf9fa76$var$onBlur);
    window.addEventListener('blur', $3d2aba60fdf9fa76$var$onWindowBlur);
};
var $3d2aba60fdf9fa76$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $3d2aba60fdf9fa76$var$onTrap);
    document.removeEventListener('focusout', $3d2aba60fdf9fa76$var$onBlur);
    window.removeEventListener('blur', $3d2aba60fdf9fa76$var$onWindowBlur);
};
function $3d2aba60fdf9fa76$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $3d2aba60fdf9fa76$var$focusLockAPI = {
    moveFocusInside: (0, $6JJio.moveFocusInside),
    focusInside: (0, $etnYu.focusInside),
    focusNextElement: (0, $1kOSJ.focusNextElement),
    focusPrevElement: (0, $1kOSJ.focusPrevElement),
    focusFirstElement: (0, $1kOSJ.focusFirstElement),
    focusLastElement: (0, $1kOSJ.focusLastElement),
    captureFocusRestore: (0, $2qbgg.captureFocusRestore)
};
function $3d2aba60fdf9fa76$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$3d2aba60fdf9fa76$var$lastActiveTrap) $3d2aba60fdf9fa76$var$attachHandler();
    var lastTrap = $3d2aba60fdf9fa76$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $3d2aba60fdf9fa76$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $3d2aba60fdf9fa76$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($3d2aba60fdf9fa76$var$focusLockAPI);
        $3d2aba60fdf9fa76$var$activateTrap(true);
        (0, $akCxK.deferAction)($3d2aba60fdf9fa76$var$activateTrap);
    } else {
        $3d2aba60fdf9fa76$var$detachHandler();
        $3d2aba60fdf9fa76$var$lastActiveFocus = null;
    }
}
(0, $1ZUGe.mediumFocus).assignSyncMedium($3d2aba60fdf9fa76$var$onFocus);
(0, $1ZUGe.mediumBlur).assignMedium($3d2aba60fdf9fa76$var$onBlur);
(0, $1ZUGe.mediumEffect).assignMedium(function(cb) {
    return cb($3d2aba60fdf9fa76$var$focusLockAPI);
});
var $3d2aba60fdf9fa76$export$2e2bcd8739ae039 = (0, $2hmzL.default)($3d2aba60fdf9fa76$var$reducePropsToState, $3d2aba60fdf9fa76$var$handleStateChangeOnClient)($3d2aba60fdf9fa76$var$FocusWatcher);

});
parcelRegister("2hmzL", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a8eae60630443b3$export$2e2bcd8739ae039);

var $huZMc = parcelRequire("huZMc");

var $98nNe = parcelRequire("98nNe");

var $bSJIT = parcelRequire("bSJIT");
function $1a8eae60630443b3$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $huZMc.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $bSJIT.PureComponent));
        (0, $98nNe.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $1a8eae60630443b3$export$2e2bcd8739ae039 = $1a8eae60630443b3$var$withSideEffect;

});

parcelRegister("2qbgg", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $1c36bebe72ea8f89$export$d357db6e554ff59a);

var $j48K1 = parcelRequire("j48K1");
function $1c36bebe72ea8f89$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $1c36bebe72ea8f89$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $1c36bebe72ea8f89$var$weakRef(currentElement),
            parent: $1c36bebe72ea8f89$var$weakRef(currentElement.parentElement),
            left: $1c36bebe72ea8f89$var$weakRef(currentElement.previousElementSibling),
            right: $1c36bebe72ea8f89$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $1c36bebe72ea8f89$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $1c36bebe72ea8f89$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $j48K1.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $1c36bebe72ea8f89$export$d357db6e554ff59a = function(targetElement) {
    var location = $1c36bebe72ea8f89$export$5061a7725be48ff9(targetElement);
    return function() {
        return $1c36bebe72ea8f89$var$restoreFocusTo(location);
    };
};

});
parcelRegister("j48K1", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $de152be5bf24315d$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $de152be5bf24315d$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $de152be5bf24315d$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $de152be5bf24315d$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $de152be5bf24315d$export$2344b14b097df817);

var $3EgGg = parcelRequire("3EgGg");

var $2DlhK = parcelRequire("2DlhK");

var $lTEP2 = parcelRequire("lTEP2");

var $WmiF7 = parcelRequire("WmiF7");
var $de152be5bf24315d$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $3EgGg.toArray)(nodes).filter(function(node) {
        return (0, $2DlhK.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $2DlhK.notHiddenInput)(node);
    });
};
var $de152be5bf24315d$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $3EgGg.toArray)(nodes).filter(function(node) {
        return (0, $2DlhK.isAutoFocusAllowedCached)(cache, node);
    });
};
var $de152be5bf24315d$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $lTEP2.orderByTabIndex)($de152be5bf24315d$export$6266a5cd5915dc33((0, $WmiF7.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $de152be5bf24315d$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $lTEP2.orderByTabIndex)($de152be5bf24315d$export$6266a5cd5915dc33((0, $WmiF7.getFocusables)(topNodes), visibilityCache), false);
};
var $de152be5bf24315d$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $de152be5bf24315d$export$6266a5cd5915dc33((0, $WmiF7.getParentAutofocusables)(topNode), visibilityCache);
};
var $de152be5bf24315d$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $de152be5bf24315d$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $3EgGg.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $de152be5bf24315d$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $de152be5bf24315d$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("3EgGg", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $2a820bf1a3cf6e63$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $2a820bf1a3cf6e63$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $2a820bf1a3cf6e63$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $2a820bf1a3cf6e63$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $2a820bf1a3cf6e63$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $2a820bf1a3cf6e63$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("2DlhK", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $1eafbc1298f8c1d7$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $1eafbc1298f8c1d7$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $1eafbc1298f8c1d7$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $1eafbc1298f8c1d7$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $1eafbc1298f8c1d7$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $1eafbc1298f8c1d7$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $1eafbc1298f8c1d7$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $1eafbc1298f8c1d7$export$4e62c701997796c1);

var $4IISo = parcelRequire("4IISo");
var $1eafbc1298f8c1d7$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $1eafbc1298f8c1d7$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $1eafbc1298f8c1d7$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $1eafbc1298f8c1d7$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $1eafbc1298f8c1d7$var$isVisibleUncached = function(node, checkParent) {
    return !node || $1eafbc1298f8c1d7$var$isTopNode(node) || !$1eafbc1298f8c1d7$var$isElementHidden(node) && !$1eafbc1298f8c1d7$var$isInert(node) && checkParent($1eafbc1298f8c1d7$var$getParentNode(node));
};
var $1eafbc1298f8c1d7$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $1eafbc1298f8c1d7$var$isVisibleUncached(node, $1eafbc1298f8c1d7$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $1eafbc1298f8c1d7$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$1eafbc1298f8c1d7$var$isTopNode(node) ? $1eafbc1298f8c1d7$export$b8550e27de209d85(node) ? checkParent($1eafbc1298f8c1d7$var$getParentNode(node)) : false : true;
};
var $1eafbc1298f8c1d7$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $1eafbc1298f8c1d7$var$isAutoFocusAllowedUncached(node, $1eafbc1298f8c1d7$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $1eafbc1298f8c1d7$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $1eafbc1298f8c1d7$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $1eafbc1298f8c1d7$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $1eafbc1298f8c1d7$export$9d74f6fbc6f469d0 = function(node) {
    return $1eafbc1298f8c1d7$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $1eafbc1298f8c1d7$export$8197b0ea56b3b055 = function(node) {
    return !(($1eafbc1298f8c1d7$export$88a6ceeed5737ba3(node) || $1eafbc1298f8c1d7$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $1eafbc1298f8c1d7$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $4IISo.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $1eafbc1298f8c1d7$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $1eafbc1298f8c1d7$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $1eafbc1298f8c1d7$export$602e5a0d338d7750 = function(node) {
    return !$1eafbc1298f8c1d7$export$d94b8b58ec2f30eb(node);
};
var $1eafbc1298f8c1d7$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("lTEP2", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $ff0e6672659ac151$export$cb40ee071f0d5226);

var $3EgGg = parcelRequire("3EgGg");
var $ff0e6672659ac151$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $ff0e6672659ac151$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $ff0e6672659ac151$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $3EgGg.toArray)(nodes).map(function(node, index) {
        var tabIndex = $ff0e6672659ac151$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($ff0e6672659ac151$export$350ee6c095d98996);
};

});

parcelRegister("WmiF7", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $0af6b735cfce0467$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $0af6b735cfce0467$export$853fa94d922e78b9);

var $4IISo = parcelRequire("4IISo");

var $3EgGg = parcelRequire("3EgGg");

var $gUah8 = parcelRequire("gUah8");
var $0af6b735cfce0467$var$queryTabbables = (0, $gUah8.tabbables).join(',');
var $0af6b735cfce0467$var$queryGuardTabbables = "".concat($0af6b735cfce0467$var$queryTabbables, ", [data-focus-guard]");
var $0af6b735cfce0467$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $3EgGg.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $0af6b735cfce0467$var$queryGuardTabbables : $0af6b735cfce0467$var$queryTabbables) ? [
            child
        ] : [], $0af6b735cfce0467$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $0af6b735cfce0467$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $0af6b735cfce0467$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $0af6b735cfce0467$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $0af6b735cfce0467$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $0af6b735cfce0467$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $3EgGg.toArray)(parent.parentNode.querySelectorAll($0af6b735cfce0467$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $0af6b735cfce0467$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $4IISo.FOCUS_AUTO), "]"));
    return (0, $3EgGg.toArray)(parentFocus).map(function(node) {
        return $0af6b735cfce0467$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("gUah8", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $c4e9d8c77c6a2fda$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $c4e9d8c77c6a2fda$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("fHz3D", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $b6e610e55716c513$export$f89ac71e91767111);

var $QMZ6b = parcelRequire("QMZ6b");

var $2DlhK = parcelRequire("2DlhK");

var $jynz1 = parcelRequire("jynz1");

var $lTEP2 = parcelRequire("lTEP2");

var $WmiF7 = parcelRequire("WmiF7");
var $b6e610e55716c513$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $QMZ6b.getAllAffectedNodes)(topNode).filter((0, $2DlhK.isNotAGuard));
    var commonParent = (0, $jynz1.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $lTEP2.orderByTabIndex)((0, $WmiF7.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $WmiF7.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $2DlhK.isGuard)(node)
        };
    });
};

});
parcelRegister("QMZ6b", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $09eadabcdaadccb5$export$7e87c4720b9b279b);

var $4IISo = parcelRequire("4IISo");

var $3EgGg = parcelRequire("3EgGg");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $09eadabcdaadccb5$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $09eadabcdaadccb5$var$getTopParent = function(node) {
    return node.parentNode ? $09eadabcdaadccb5$var$getTopParent(node.parentNode) : node;
};
var $09eadabcdaadccb5$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $3EgGg.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $4IISo.FOCUS_GROUP));
        acc.push.apply(acc, group ? $09eadabcdaadccb5$var$filterNested((0, $3EgGg.toArray)($09eadabcdaadccb5$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $4IISo.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $4IISo.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("jynz1", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $e3c3789363b99c69$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $e3c3789363b99c69$export$8f99714c70a37db1);

var $j48K1 = parcelRequire("j48K1");

var $3EgGg = parcelRequire("3EgGg");
var $e3c3789363b99c69$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $e3c3789363b99c69$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $e3c3789363b99c69$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $e3c3789363b99c69$var$getParents(nodeA);
    var parentsB = $e3c3789363b99c69$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $e3c3789363b99c69$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $3EgGg.asArray)(baseActiveElement);
    var leftEntries = (0, $3EgGg.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $e3c3789363b99c69$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $e3c3789363b99c69$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $j48K1.contains)(common, topCommon)) topCommon = common;
                else topCommon = $e3c3789363b99c69$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $e3c3789363b99c69$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $j48K1.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("1kOSJ", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $0f8f20c66be4bf3f$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $0f8f20c66be4bf3f$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $0f8f20c66be4bf3f$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $0f8f20c66be4bf3f$export$6a79073ddabfd6c3);

var $jIUyc = parcelRequire("jIUyc");

var $j48K1 = parcelRequire("j48K1");

var $3EgGg = parcelRequire("3EgGg");
var $0f8f20c66be4bf3f$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $3EgGg.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $j48K1.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $j48K1.getTabbableNodes)(shards, new Map()) : (0, $j48K1.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $0f8f20c66be4bf3f$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $j48K1.getTabbableNodes)((0, $3EgGg.asArray)(shards), new Map()) : (0, $j48K1.getFocusableNodes)((0, $3EgGg.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $0f8f20c66be4bf3f$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $0f8f20c66be4bf3f$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $0f8f20c66be4bf3f$var$defaultOptions(options);
    var solution = $0f8f20c66be4bf3f$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $jIUyc.focusOn)(target.node, newOptions.focusOptions);
};
var $0f8f20c66be4bf3f$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $0f8f20c66be4bf3f$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $0f8f20c66be4bf3f$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $0f8f20c66be4bf3f$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $0f8f20c66be4bf3f$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $0f8f20c66be4bf3f$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $jIUyc.focusOn)(node.node, options.focusOptions);
};
var $0f8f20c66be4bf3f$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $0f8f20c66be4bf3f$var$pickBoundary(scope, options, 'first');
};
var $0f8f20c66be4bf3f$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $0f8f20c66be4bf3f$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("jIUyc", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $e5bdfe26446450a1$export$c12b3da842c43a8);
var $e5bdfe26446450a1$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("etnYu", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $a8965eff67cf6393$export$20115f8da7baa6fa);

var $j48K1 = parcelRequire("j48K1");

var $QMZ6b = parcelRequire("QMZ6b");

var $3EgGg = parcelRequire("3EgGg");

var $sHQs3 = parcelRequire("sHQs3");
var $a8965eff67cf6393$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $a8965eff67cf6393$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $3EgGg.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $a8965eff67cf6393$var$focusInFrame(node, activeElement);
    }));
};
var $a8965eff67cf6393$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $sHQs3.getActiveElement)((0, $3EgGg.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $QMZ6b.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $j48K1.contains)(node, activeElement) || $a8965eff67cf6393$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("sHQs3", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $0564a057744fbe4d$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $hI8x3 = parcelRequire("hI8x3");
var $0564a057744fbe4d$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $0564a057744fbe4d$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $hI8x3.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $0564a057744fbe4d$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("hI8x3", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $ce4d2a03c61d9e69$export$78d20aae35adef88);
var $ce4d2a03c61d9e69$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("S81Y3", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $0a2b45ff573ae163$export$be6b21806d3fd485);

var $4IISo = parcelRequire("4IISo");

var $j48K1 = parcelRequire("j48K1");

var $3EgGg = parcelRequire("3EgGg");

var $sHQs3 = parcelRequire("sHQs3");
var $0a2b45ff573ae163$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $sHQs3.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $3EgGg.toArray)(inDocument.querySelectorAll("[".concat((0, $4IISo.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $j48K1.contains)(node, activeElement);
    });
};

});

parcelRegister("kjDTm", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("6JJio")).moveFocusInside);

var $4IISo = parcelRequire("4IISo");

var $etnYu = parcelRequire("etnYu");

var $S81Y3 = parcelRequire("S81Y3");


var $fHz3D = parcelRequire("fHz3D");

var $6JJio = parcelRequire("6JJio");

var $2qbgg = parcelRequire("2qbgg");

var $1kOSJ = parcelRequire("1kOSJ");

var $j48K1 = parcelRequire("j48K1");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $eca486aef9385564$export$1a988e7317c65621 = $4IISo;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $eca486aef9385564$var$deprecated_default_moveFocusInside = (0, $6JJio.moveFocusInside);
var $eca486aef9385564$export$2e2bcd8739ae039 //
 = $eca486aef9385564$var$deprecated_default_moveFocusInside;

});
parcelRegister("6JJio", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $4e7a14d8052785b1$export$cd599851e879a025);

var $jIUyc = parcelRequire("jIUyc");

var $lfhmc = parcelRequire("lfhmc");
var $4e7a14d8052785b1$var$guardCount = 0;
var $4e7a14d8052785b1$var$lockDisabled = false;
var $4e7a14d8052785b1$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $lfhmc.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($4e7a14d8052785b1$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($4e7a14d8052785b1$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $4e7a14d8052785b1$var$lockDisabled = true;
            setTimeout(function() {
                $4e7a14d8052785b1$var$lockDisabled = false;
            }, 1);
            return;
        }
        $4e7a14d8052785b1$var$guardCount++;
        (0, $jIUyc.focusOn)(focusable.node, options.focusOptions);
        $4e7a14d8052785b1$var$guardCount--;
    }
};

});
parcelRegister("lfhmc", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $f7787673ab8ce68d$export$305758c744b57f6f);

var $gpWoU = parcelRequire("gpWoU");

var $j48K1 = parcelRequire("j48K1");

var $QMZ6b = parcelRequire("QMZ6b");

var $3EgGg = parcelRequire("3EgGg");

var $epMol = parcelRequire("epMol");

var $sHQs3 = parcelRequire("sHQs3");

var $2DlhK = parcelRequire("2DlhK");

var $jynz1 = parcelRequire("jynz1");
var $f7787673ab8ce68d$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $2DlhK.isDefined));
};
var $f7787673ab8ce68d$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $sHQs3.getActiveElement)((0, $3EgGg.asArray)(topNode).length > 0 ? document : (0, $3EgGg.getFirst)(topNode).ownerDocument);
    var entries = (0, $QMZ6b.getAllAffectedNodes)(topNode).filter((0, $2DlhK.isNotAGuard));
    var commonParent = (0, $jynz1.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $j48K1.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $2DlhK.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $j48K1.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $f7787673ab8ce68d$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $gpWoU.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $gpWoU.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $epMol.pickAutofocus)(anyFocusable, innerTabbable, (0, $jynz1.allParentAutofocusables)(entries, visibilityCache)) || (0, $epMol.pickAutofocus)(anyFocusable, innerFocusables, (0, $jynz1.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("gpWoU", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $bf3c484f79181556$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $bf3c484f79181556$export$65842178e9bb4205);

var $cpoX4 = parcelRequire("cpoX4");

var $9Lbu6 = parcelRequire("9Lbu6");

var $2DlhK = parcelRequire("2DlhK");
var $bf3c484f79181556$export$85710b12cf912438 = 'NEW_FOCUS';
var $bf3c484f79181556$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $2DlhK.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $bf3c484f79181556$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $bf3c484f79181556$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $cpoX4.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $9Lbu6.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $9Lbu6.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("cpoX4", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $908b2cb626bd00c5$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $908b2cb626bd00c5$export$4a5a72a7124e45f9);

var $2DlhK = parcelRequire("2DlhK");
var $908b2cb626bd00c5$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $2DlhK.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $908b2cb626bd00c5$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $2DlhK.isRadioElement)(node) && node.name) return $908b2cb626bd00c5$var$findSelectedRadio(node, nodes);
    return node;
};
var $908b2cb626bd00c5$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($908b2cb626bd00c5$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("9Lbu6", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $71b16970c68969f2$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $71b16970c68969f2$export$e06728ee87c96122);

var $cpoX4 = parcelRequire("cpoX4");
var $71b16970c68969f2$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $cpoX4.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $71b16970c68969f2$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $cpoX4.correctNode)(node, nodes));
};

});


parcelRegister("epMol", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $a7e8f00dd6d8673a$export$cfb742983e257555);

var $j48K1 = parcelRequire("j48K1");

var $9Lbu6 = parcelRequire("9Lbu6");

var $2DlhK = parcelRequire("2DlhK");
var $a7e8f00dd6d8673a$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $2DlhK.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $a7e8f00dd6d8673a$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $j48K1.filterAutoFocusable)(nodes.filter($a7e8f00dd6d8673a$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $9Lbu6.pickFirstFocus)(autoFocusable);
    return (0, $9Lbu6.pickFirstFocus)((0, $j48K1.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("akCxK", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $7859ab8f62b14aec$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $7859ab8f62b14aec$export$c613fed06e332533);
function $7859ab8f62b14aec$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $7859ab8f62b14aec$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $7859ab8f62b14aec$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("hZsX2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9093097e8a81a04$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");
const $e9093097e8a81a04$var$packageName = undefined;
const $e9093097e8a81a04$var$packageVersion = undefined;
const $e9093097e8a81a04$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $e9093097e8a81a04$var$packageName,
    packageVersion: $e9093097e8a81a04$var$packageVersion
};
const $e9093097e8a81a04$var$baseStyles = null;
const $e9093097e8a81a04$var$shouldAllowClickThroughStyles = null;
const $e9093097e8a81a04$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $e9093097e8a81a04$var$Blanket = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $1OdZP.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $bSJIT.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$e9093097e8a81a04$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $bSJIT.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $bSJIT.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $9fU1q.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        children: children
    });
}));
$e9093097e8a81a04$var$Blanket.displayName = 'Blanket';
var $e9093097e8a81a04$export$2e2bcd8739ae039 = $e9093097e8a81a04$var$Blanket;

});

parcelRegister("iV599", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $d92ebea76f2f945f$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $alWuP = parcelRequire("alWuP");

var $hKgPS = parcelRequire("hKgPS");

var $iimkL = parcelRequire("iimkL");

var $jViBl = parcelRequire("jViBl");
const $d92ebea76f2f945f$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $bSJIT.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return ()=>{
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hKgPS.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iimkL.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $d92ebea76f2f945f$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $bSJIT.useContext)((0, $hKgPS.LevelContext));
    const parentNode = (0, $bSJIT.useContext)((0, $iimkL.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $bSJIT.useRef)(new (0, $alWuP.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $dc70d.jsx)($d92ebea76f2f945f$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $dc70d.jsx)((0, $jViBl.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("alWuP", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $d79a9326041cb695$export$da4f61fd78d35243);
class $d79a9326041cb695$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("hKgPS", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $423c7f8728393896$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");
const $423c7f8728393896$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $bSJIT.createContext)(0);

});

parcelRegister("iimkL", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $9c43e899a8a8f931$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");
const $9c43e899a8a8f931$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    current: null
});

});

parcelRegister("jViBl", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $47b2048d9ceef5b8$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");
const $47b2048d9ceef5b8$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    current: null
});

});


parcelRegister("cdLl4", function(module, exports) {
$parcel$export(module.exports, "combine", () => $2e35aabd01e66d95$export$1be1fc439b849fdf);
function $2e35aabd01e66d95$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("atMNJ", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $655984fcd861da95$export$330cd73b9da5838b);
function $655984fcd861da95$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("24u1j", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $a0947ea375fc560b$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ /* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $bAB3U = parcelRequire("bAB3U");

var $fGbV9 = parcelRequire("fGbV9");

var $1OdZP = parcelRequire("1OdZP");

var $ghAbV = parcelRequire("ghAbV");

var $6gXOx = parcelRequire("6gXOx");

var $johsC = parcelRequire("johsC");

var $1hbON = parcelRequire("1hbON");

var $8AerU = parcelRequire("8AerU");
// Surface reset, including `color` (the UA `dialog` rule sets `CanvasText`).
// KEEP IN SYNC with `surfaceResetStyles` in `popover/popover.tsx`.
const $a0947ea375fc560b$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $a0947ea375fc560b$var$dialogStyles = {
    root: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fglyw _lzhqglyw _mkdmze3t _lizuze3t _dbnbze3t _v12pze3t _1yd01wug _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1dqv1n9t _6hkqidpf _1rec1j28 _722r1ule",
    motion: "_k8m011k7 _1oeci9qs _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v7kvq",
    exit: "_y44vgeqi"
};
const $a0947ea375fc560b$var$backdropStyles = {
    root: "_1ltk1i5c",
    hidden: "_1ltk1j28",
    enter: "_1m5exbuz",
    exit: "_1m5e1op4"
};
const $a0947ea375fc560b$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, dismissedBy: dismissedBy = 'escape-and-outside-click', onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $bSJIT.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $bSJIT.useRef)(null);
    const combinedRef = (0, $fGbV9.default)([
        ownRef,
        ref
    ]);
    const closeReasonRef = (0, $bSJIT.useRef)(null);
    const dismissedByRef = (0, $bSJIT.useRef)(dismissedBy);
    const onCloseRef = (0, $bSJIT.useRef)(onClose);
    // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $ghAbV.useLayoutEffect)(()=>{
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
    }, [
        dismissedBy,
        onClose
    ]);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $johsC.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Ordering is important: bind native lifecycle listeners before the later
    // layout effect calls showModal() or close(), because `beforetoggle` fires
    // synchronously during those calls.
    (0, $ghAbV.useLayoutEffect)(()=>{
        if (!isMounted) return;
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $bAB3U.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                // Browsers retarget clicks on ::backdrop to the <dialog> element.
                // Close on backdrop click when outside-click dismissal is enabled.
                type: 'click',
                listener (event) {
                    if (event.target === event.currentTarget && dismissedByRef.current === 'escape-and-outside-click') {
                        closeReasonRef.current = 'overlay-click';
                        dialog.close();
                    }
                }
            },
            {
                type: 'toggle',
                listener (event) {
                    if (event.newState === 'closed') {
                        const reason = closeReasonRef.current;
                        closeReasonRef.current = null;
                        // A reason is only set for user-initiated closes. When React closes the
                        // dialog because isOpen changed, the consumer already knows.
                        if (reason) onCloseRef.current({
                            reason: reason
                        });
                    }
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, $1hbON.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        type: 'modal',
        isOpen: isOpen,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $1OdZP.default)
    });
    (0, $ghAbV.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            closeReasonRef.current = null;
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Safari bug: escape closes open dialog and popovers, rather than just innermost popover
    // See notes/decisions/safari-escape-nested-popover-in-dialog.md
    const { shouldIgnoreEscape: shouldIgnoreEscape } = (0, $8AerU.useSafariEscapeFix)({
        dialogRef: ownRef,
        isVisible: isMounted
    });
    // Handle native Escape (cancel event)
    const handleCancel = (0, $bSJIT.useCallback)((event)=>{
        // Only handle a cancel targeting THIS dialog. Native `cancel` does not
        // bubble, but React's synthetic event bubbles up the component tree, so
        // for nested dialogs (one rendered inside another's DOM subtree) the
        // inner dialog's Escape would otherwise also fire an ancestor dialog's
        // handler and close it too. Mirrors the backdrop-click target guard below.
        if (event.target !== event.currentTarget) return;
        // Spurious Safari `cancel`: the keydown snapshot saw an open child
        // popover, so this Escape belongs to that popover (light-dismissed
        // natively). Keep the dialog open instead of forwarding to `onClose`.
        if (shouldIgnoreEscape()) {
            event.preventDefault();
            return;
        }
        // Without native `closedby`, cancel Escape only when dismissal is disabled.
        // Allowed dismissal follows Popover behavior: the browser closes the element
        // and `onClose` notifies the controlled owner of the reason.
        if (dismissedBy === 'none') {
            event.preventDefault();
            return;
        }
        closeReasonRef.current = 'escape';
    }, [
        dismissedBy,
        shouldIgnoreEscape
    ]);
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. A later open
    // remounts a fresh element, so the listener-binding and native-visibility
    // effects run against that element.
    if (!isMounted) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $dc70d.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // `aria-modal` is intentionally NOT set: native `<dialog>.showModal()`
        // already conveys modal semantics to assistive tech, and double-
        // declaring it forecloses non-modal use cases (consumers calling
        // `.show()` would still appear modal). Modern AT (NVDA / JAWS /
        // VoiceOver) infer modality from the platform accessibility API.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        onCancel: handleCancel,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            // Dialog styles
            $a0947ea375fc560b$var$dialogStyles.root,
            $a0947ea375fc560b$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $a0947ea375fc560b$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $a0947ea375fc560b$var$dialogStyles.exit,
            shouldAnimate && $a0947ea375fc560b$var$dialogStyles.motion,
            shouldHideBackdrop ? $a0947ea375fc560b$var$backdropStyles.hidden : $a0947ea375fc560b$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $a0947ea375fc560b$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $a0947ea375fc560b$var$backdropStyles.exit,
            (0, $14TCm.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("8AerU", function(module, exports) {
$parcel$export(module.exports, "useSafariEscapeFix", () => $2c58edd104321a39$export$52c229d83e45be61);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $h0umZ = parcelRequire("h0umZ");
function $2c58edd104321a39$export$52c229d83e45be61({ dialogRef: dialogRef, isVisible: isVisible }) {
    const childPopoverOpenAtEscapeRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (!(0, $h0umZ.isSafari)()) return;
        const dialog = dialogRef.current;
        if (!dialog) return;
        // Bind to `document`, not the dialog: on Safari focus can be on `<body>`
        // (buttons are not focused on click), where a dialog-scoped listener would
        // never fire. The query below stays scoped to this dialog's subtree.
        return (0, $bAB3U.bind)(document, {
            type: 'keydown',
            listener (event) {
                if (event.key !== 'Escape') return;
                try {
                    childPopoverOpenAtEscapeRef.current = Boolean(dialog.querySelector('[popover="auto"]:popover-open, [popover="hint"]:popover-open'));
                } catch  {
                    // `:popover-open` is unsupported in some environments (e.g. jsdom);
                    // treat as "no child popover" so a plain Escape still closes the dialog.
                    childPopoverOpenAtEscapeRef.current = false;
                }
            },
            options: {
                capture: true
            }
        });
    }, [
        dialogRef,
        isVisible
    ]);
    const api = (0, $bSJIT.useMemo)(()=>{
        return {
            shouldIgnoreEscape () {
                if (childPopoverOpenAtEscapeRef.current) {
                    childPopoverOpenAtEscapeRef.current = false;
                    return true;
                }
                return false;
            }
        };
    }, []);
    return api;
}

});


parcelRegister("cO4NS", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $97fe9429409b9f79$export$e458030908e2d723);

var $c9wRy = parcelRequire("c9wRy");

var $ghAbV = parcelRequire("ghAbV");
function $97fe9429409b9f79$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $ghAbV.useLayoutEffect)(()=>{
        var _getDocument;
        if (!isOpen) return;
        const body = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

});

parcelRegister("cd7vh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a24d055c4ccdaee$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $40hpH = parcelRequire("40hpH");

var $4Qo4I = parcelRequire("4Qo4I");

var $cAkpn = parcelRequire("cAkpn");

var $8Mgn9 = parcelRequire("8Mgn9");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $4a24d055c4ccdaee$var$modalStackRegister = [];
function $4a24d055c4ccdaee$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $8Mgn9.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $cAkpn.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $4Qo4I.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $40hpH.default)(()=>{
        const newStackIndex = $4a24d055c4ccdaee$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $bSJIT.useEffect)(()=>{
        const currentStackIndex = $4a24d055c4ccdaee$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $4a24d055c4ccdaee$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $4a24d055c4ccdaee$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $4a24d055c4ccdaee$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $bSJIT.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $4a24d055c4ccdaee$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $4a24d055c4ccdaee$var$modalStackRegister.splice(currentStackIndex, 1);
                $4a24d055c4ccdaee$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("4Qo4I", function(module, exports) {
$parcel$export(module.exports, "default", () => $c45c4f2617ce0762$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $c45c4f2617ce0762$export$2e2bcd8739ae039(value) {
    const ref = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("cAkpn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f1e0ec6e3322630$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $7f1e0ec6e3322630$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $bSJIT.useState)(initialState);
    const valueRef = (0, $bSJIT.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("iObCy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c9667c0082af94c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $1c9667c0082af94c$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $1c9667c0082af94c$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $bSJIT.useState)(0);
    (0, $bSJIT.useLayoutEffect)(()=>{
        setScrollTopOffset($1c9667c0082af94c$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $bSJIT.useCallback)(()=>{
        if ($1c9667c0082af94c$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return (0, $bAB3U.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("40WRr", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $d2f420d119cd95df$export$ec28e97c7d8b1b35);

var $bAB3U = parcelRequire("bAB3U");

var $ejG4k = parcelRequire("ejG4k");

var $cdLl4 = parcelRequire("cdLl4");

var $dTpfS = parcelRequire("dTpfS");
function $d2f420d119cd95df$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $bAB3U.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $ejG4k.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $cdLl4.combine)(unbindEvents, unbindMonitor);
}
function $d2f420d119cd95df$var$watchForInteractionStart({ start: start }) {
    return (0, $bAB3U.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $d2f420d119cd95df$var$api = (0, $dTpfS.makeFixForAdapter)({
    watchForInteractionStart: $d2f420d119cd95df$var$watchForInteractionStart,
    watchForInteractionEnd: $d2f420d119cd95df$var$watchForInteractionEnd
});
function $d2f420d119cd95df$export$ec28e97c7d8b1b35() {
    return $d2f420d119cd95df$var$api.registerUsage();
}

});
parcelRegister("ejG4k", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $3915e4a3bee15dbb$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $3915e4a3bee15dbb$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $3915e4a3bee15dbb$export$c746a5152d4ba26c);

var $bAB3U = parcelRequire("bAB3U");

var $04W7N = parcelRequire("04W7N");

var $gsRFy = parcelRequire("gsRFy");

var $fXk0t = parcelRequire("fXk0t");

var $cdLl4 = parcelRequire("cdLl4");

var $1q0tL = parcelRequire("1q0tL");

var $cn63b = parcelRequire("cn63b");

var $8Awvm = parcelRequire("8Awvm");

var $luhhm = parcelRequire("luhhm");

var $hIUqs = parcelRequire("hIUqs");

var $kJYYW = parcelRequire("kJYYW");

var $k4nGL = parcelRequire("k4nGL");
const $3915e4a3bee15dbb$var$draggableRegistry = new WeakMap();
function $3915e4a3bee15dbb$var$addToRegistry(args) {
    $3915e4a3bee15dbb$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $3915e4a3bee15dbb$var$draggableRegistry.delete(args.element);
    };
}
const $3915e4a3bee15dbb$var$honeyPotFix = (0, $gsRFy.makeHoneyPotFix)();
const $3915e4a3bee15dbb$var$adapter = (0, $fXk0t.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $cdLl4.combine)($3915e4a3bee15dbb$var$honeyPotFix.bindEvents(), (0, $bAB3U.bind)(document, {
            type: 'dragstart',
            listener (event) {
                var _entry$getInitialData, _entry$getInitialData2;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $3915e4a3bee15dbb$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ const input = (0, $luhhm.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $04W7N.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ const nativeData = ((_entry$getInitialData = entry.getInitialDataForExternal) === null || _entry$getInitialData === void 0 ? void 0 : _entry$getInitialData.call(entry, feedback)) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $8Awvm.isAndroid)() && !event.dataTransfer.types.includes((0, $hIUqs.textMediaType)) && !event.dataTransfer.types.includes((0, $kJYYW.URLMediaType))) event.dataTransfer.setData((0, $hIUqs.textMediaType), (0, $8Awvm.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $k4nGL.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: ((_entry$getInitialData2 = entry.getInitialData) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $3915e4a3bee15dbb$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $3915e4a3bee15dbb$var$honeyPotFix.getOnPostDispatch()
});
const $3915e4a3bee15dbb$export$e7140b68045b5036 = $3915e4a3bee15dbb$var$adapter.dropTarget;
const $3915e4a3bee15dbb$export$59a074bac4c54f54 = $3915e4a3bee15dbb$var$adapter.monitor;
function $3915e4a3bee15dbb$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $cdLl4.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $3915e4a3bee15dbb$var$adapter.registerUsage(), $3915e4a3bee15dbb$var$addToRegistry(args), (0, $cn63b.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $1q0tL.once)(cleanup);
}

});
parcelRegister("04W7N", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $5ff2130b12c4a97d$export$81d0353f25f5dd);

var $01SKW = parcelRequire("01SKW");
function $5ff2130b12c4a97d$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $01SKW.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("01SKW", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $fa8d2f27922cc9cd$export$821bdcd739a2706b);

var $iQy97 = parcelRequire("iQy97");
function $fa8d2f27922cc9cd$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $iQy97.honeyPotDataAttribute));
}

});
parcelRegister("iQy97", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $ce97266d5df6790f$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $ce97266d5df6790f$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("gsRFy", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $3103032cbcfe514f$export$8ecad27c959e89e0);

var $bAB3U = parcelRequire("bAB3U");

var $iPkpW = parcelRequire("iPkpW");

var $VjcI7 = parcelRequire("VjcI7");

var $lLguj = parcelRequire("lLguj");

var $iQy97 = parcelRequire("iQy97");
const $3103032cbcfe514f$var$honeyPotSize = 2;
const $3103032cbcfe514f$var$halfHoneyPotSize = $3103032cbcfe514f$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $3103032cbcfe514f$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $3103032cbcfe514f$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $3103032cbcfe514f$var$halfHoneyPotSize,
        y: point.y - $3103032cbcfe514f$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $3103032cbcfe514f$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $3103032cbcfe514f$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $3103032cbcfe514f$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $3103032cbcfe514f$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $3103032cbcfe514f$var$getHoneyPotRectFor({ client: client }) {
    const point = $3103032cbcfe514f$var$preventGoingForwardsOffScreen($3103032cbcfe514f$var$preventGoingBackwardsOffScreen($3103032cbcfe514f$var$pullBackByHalfHoneyPotSize($3103032cbcfe514f$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $3103032cbcfe514f$var$honeyPotSize,
        height: $3103032cbcfe514f$var$honeyPotSize
    });
}
function $3103032cbcfe514f$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $3103032cbcfe514f$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $3103032cbcfe514f$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $iQy97.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $lLguj.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $3103032cbcfe514f$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $lLguj.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $VjcI7.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $iPkpW.maxZIndex)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$3103032cbcfe514f$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $lLguj.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ const unbindPointerMove = (0, $bAB3U.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $3103032cbcfe514f$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $3103032cbcfe514f$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($3103032cbcfe514f$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $bAB3U.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $3103032cbcfe514f$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $bAB3U.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $3103032cbcfe514f$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                const { input: input } = payload.location.current;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("iPkpW", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $5ded5eafb99b47fb$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $5ded5eafb99b47fb$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("VjcI7", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $e9a552453f0f73db$export$74004cb910cdc478);
const $e9a552453f0f73db$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("lLguj", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $a1e7cd056ea35a0e$export$1150b66d0ff92823);

var $1q0tL = parcelRequire("1q0tL");
const $a1e7cd056ea35a0e$export$1150b66d0ff92823 = (0, $1q0tL.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("1q0tL", function(module, exports) {
$parcel$export(module.exports, "once", () => $feb481e909c9110e$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $feb481e909c9110e$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("fXk0t", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $98c38510e3d71581$export$2aa3a33160990d96);

var $lPJch = parcelRequire("lPJch");

var $3rhSU = parcelRequire("3rhSU");

var $f8xJA = parcelRequire("f8xJA");

var $damil = parcelRequire("damil");
function $98c38510e3d71581$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $damil.makeMonitor)();
    const dropTargetAPI = (0, $f8xJA.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $lPJch.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $lPJch.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $3rhSU.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("lPJch", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $2a1499d990f90816$export$3efdceeb8ca25c51);

var $bAB3U = parcelRequire("bAB3U");

var $04W7N = parcelRequire("04W7N");

var $01SKW = parcelRequire("01SKW");

var $7jwvG = parcelRequire("7jwvG");

var $lHuFH = parcelRequire("lHuFH");

var $luhhm = parcelRequire("luhhm");

var $7D7rF = parcelRequire("7D7rF");
const $2a1499d990f90816$var$globalState = {
    isActive: false
};
function $2a1499d990f90816$var$canStart() {
    return !$2a1499d990f90816$var$globalState.isActive;
}
function $2a1499d990f90816$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $2a1499d990f90816$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $2a1499d990f90816$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$2a1499d990f90816$var$canStart()) return;
    const initial = $2a1499d990f90816$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $2a1499d990f90816$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $2a1499d990f90816$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $7D7rF.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $2a1499d990f90816$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $luhhm.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $01SKW.isHoneyPotElement)(event.target) ? (0, $04W7N.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $2a1499d990f90816$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $2a1499d990f90816$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $bAB3U.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $7jwvG.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $luhhm.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $2a1499d990f90816$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $luhhm.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $lHuFH.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $2a1499d990f90816$var$getNativeSetDragImage(event)
    });
}
function $2a1499d990f90816$var$setDropEffectOnEvent({ event: event, current: current }) {
    var _current$;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $2a1499d990f90816$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $luhhm.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $2a1499d990f90816$export$3efdceeb8ca25c51 = {
    canStart: $2a1499d990f90816$var$canStart,
    start: $2a1499d990f90816$var$start
};

});
parcelRegister("7jwvG", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $d70db0bccf61ad3d$export$57d220c74e84a273);

var $6Y0Yd = parcelRequire("6Y0Yd");

var $iyNC6 = parcelRequire("iyNC6");

var $8JPfp = parcelRequire("8JPfp");

var $6QLuF = parcelRequire("6QLuF");
function $d70db0bccf61ad3d$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $iyNC6.isSafari)()) return (0, $6QLuF.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $6Y0Yd.isFirefox)()) return (0, $8JPfp.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("6Y0Yd", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $5b1aa9473338fb40$export$b7d78993b74f766d);

var $1q0tL = parcelRequire("1q0tL");
const $5b1aa9473338fb40$export$b7d78993b74f766d = (0, $1q0tL.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("iyNC6", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $5cef9734039c55f8$export$95df08bae54cb4df);

var $1q0tL = parcelRequire("1q0tL");
const $5cef9734039c55f8$export$95df08bae54cb4df = (0, $1q0tL.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("8JPfp", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $69f4de245e367057$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $69f4de245e367057$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $69f4de245e367057$export$e46810fef53b5b0e(eventTarget) {
    return $69f4de245e367057$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});

parcelRegister("6QLuF", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $3c160475f9575e50$export$f21837c338005454);

var $iyNC6 = parcelRequire("iyNC6");

var $5rnq7 = parcelRequire("5rnq7");
function $3c160475f9575e50$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $iyNC6.isSafari)()) return false;
    return dragLeave.hasOwnProperty((0, $5rnq7.symbols).isLeavingWindow);
}

});
parcelRegister("5rnq7", function(module, exports) {
$parcel$export(module.exports, "symbols", () => $d4521722b2540bfa$export$47616e9f7f5fe113);

var $bAB3U = parcelRequire("bAB3U");

var $iyNC6 = parcelRequire("iyNC6");
const $d4521722b2540bfa$export$47616e9f7f5fe113 = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $iyNC6.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $bAB3U.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$d4521722b2540bfa$export$47616e9f7f5fe113.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$d4521722b2540bfa$export$47616e9f7f5fe113.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});



parcelRegister("lHuFH", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $710f760fc8b4a8d1$export$ac5e5b0daf997b2);
function $710f760fc8b4a8d1$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("luhhm", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $3559847f8abd85c9$export$7c112ceec8941e67);
function $3559847f8abd85c9$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("7D7rF", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $5d36005e3463ce56$export$9f13ecc44e83d682);

var $9wZWu = parcelRequire("9wZWu");
const $5d36005e3463ce56$var$scheduleOnDrag = (0, $9wZWu.default)((fn)=>fn());
const $5d36005e3463ce56$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $5d36005e3463ce56$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $5d36005e3463ce56$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $5d36005e3463ce56$var$dragStart.flush();
            $5d36005e3463ce56$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $5d36005e3463ce56$var$scheduleOnDrag(()=>{
                $5d36005e3463ce56$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $5d36005e3463ce56$var$dragStart.flush();
            $5d36005e3463ce56$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("3rhSU", function(module, exports) {
$parcel$export(module.exports, "register", () => $04d57340101988ea$export$6503ec6e8aabbaf);
const $04d57340101988ea$var$ledger = new Map();
function $04d57340101988ea$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $04d57340101988ea$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $04d57340101988ea$var$ledger.set(typeKey, initial);
    return initial;
}
function $04d57340101988ea$export$6503ec6e8aabbaf(args) {
    const entry = $04d57340101988ea$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $04d57340101988ea$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("f8xJA", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $318cb05a4bbdc1a8$export$47d10e7bd9c81890);

var $cdLl4 = parcelRequire("cdLl4");

var $1q0tL = parcelRequire("1q0tL");

var $cn63b = parcelRequire("cn63b");
function $318cb05a4bbdc1a8$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $318cb05a4bbdc1a8$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $cdLl4.combine)((0, $cn63b.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $1q0tL.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        var _args$getData, _args$getDropEffect;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = ((_args$getData = args.getData) === null || _args$getData === void 0 ? void 0 : _args$getData.call(args, feedback)) ?? {};
        const dropEffect = ((_args$getDropEffect = args.getDropEffect) === null || _args$getDropEffect === void 0 ? void 0 : _args$getDropEffect.call(args, feedback)) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            var _entry$eventName;
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                var _entry$onDropTargetCh;
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) {
                    var _entry$onDragLeave;
                    entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                }
            }
            for (const record of payload.location.current.dropTargets){
                var _entry$onDropTargetCh2, _entry$onDragEnter;
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry === null || entry === void 0 || (_entry$onDropTargetCh2 = entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(entry, args);
                entry === null || entry === void 0 || (_entry$onDragEnter = entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(entry, args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $318cb05a4bbdc1a8$var$copyReverse(current);
        const actualCaptureOrdered = $318cb05a4bbdc1a8$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $318cb05a4bbdc1a8$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("cn63b", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $f9335140c9e80800$export$5dcb5c23b6ba980a);
function $f9335140c9e80800$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("damil", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $3f34905c298d2c48$export$5dd4ed888d5b12ca);

var $1q0tL = parcelRequire("1q0tL");
function $3f34905c298d2c48$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $1q0tL.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) {
            var _monitor$eventName;
            // @ts-expect-error: I cannot get this type working!
            (_monitor$eventName = monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(monitor, payload);
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("8Awvm", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $b977b224a2817707$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $b977b224a2817707$export$aceb3ed8b7f7bd2c);

var $1q0tL = parcelRequire("1q0tL");
const $b977b224a2817707$export$a11b0059900ceec8 = (0, $1q0tL.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $b977b224a2817707$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("hIUqs", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $94fa9f1974fe8dec$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $94fa9f1974fe8dec$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("kJYYW", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $7a92394152ab351a$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $7a92394152ab351a$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("k4nGL", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $fb32d21bcd7d22d8$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $fb32d21bcd7d22d8$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});


parcelRegister("dTpfS", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $e60702e502e410ac$export$a74bff2507e6126b);

var $cdLl4 = parcelRequire("cdLl4");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $e60702e502e410ac$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $e60702e502e410ac$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $e60702e502e410ac$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$e60702e502e410ac$var$hasSameOrigin(window.location.href, iframe.src);
}
const $e60702e502e410ac$var$registry = new Map();
function $e60702e502e410ac$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($e60702e502e410ac$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $e60702e502e410ac$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $e60702e502e410ac$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $e60702e502e410ac$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $e60702e502e410ac$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $cdLl4.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $e60702e502e410ac$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $e60702e502e410ac$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("lPqcX", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $7e2399db6aac6dbb$export$27d79116d3a4e7d5);

var $d1Go3 = parcelRequire("d1Go3");

var $dTpfS = parcelRequire("dTpfS");
function $7e2399db6aac6dbb$var$watchForInteractionStart({ start: start }) {
    return (0, $d1Go3.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $7e2399db6aac6dbb$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $d1Go3.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $7e2399db6aac6dbb$var$api = (0, $dTpfS.makeFixForAdapter)({
    watchForInteractionStart: $7e2399db6aac6dbb$var$watchForInteractionStart,
    watchForInteractionEnd: $7e2399db6aac6dbb$var$watchForInteractionEnd
});
function $7e2399db6aac6dbb$export$27d79116d3a4e7d5() {
    return $7e2399db6aac6dbb$var$api.registerUsage();
}

});
parcelRegister("d1Go3", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $3300f457fab849ce$export$bb1740f3194979c1);

var $9XSwY = parcelRequire("9XSwY");
function $3300f457fab849ce$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return (0, $9XSwY.adapter).monitor(args);
}

});
parcelRegister("9XSwY", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $54ab770df2e48c84$export$e00c9c6684b0ace);

var $bAB3U = parcelRequire("bAB3U");

var $fXk0t = parcelRequire("fXk0t");

var $17mAp = parcelRequire("17mAp");

var $lHuFH = parcelRequire("lHuFH");

var $3svH3 = parcelRequire("3svH3");

var $WK44O = parcelRequire("WK44O");

var $f51YL = parcelRequire("f51YL");
let $54ab770df2e48c84$var$didDragStartLocally = false;
const $54ab770df2e48c84$export$e00c9c6684b0ace = (0, $fXk0t.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $bAB3U.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($54ab770df2e48c84$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $17mAp.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = (0, $WK44O.getAvailableTypes)(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = (0, $3svH3.getAvailableItems)(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!(0, $f51YL.isAnAvailableType)({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $54ab770df2e48c84$export$e00c9c6684b0ace.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $54ab770df2e48c84$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $bAB3U.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $lHuFH.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $bAB3U.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $54ab770df2e48c84$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("17mAp", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $380b4fc20fe73018$export$d1c6f249e893cdf4);

var $6Y0Yd = parcelRequire("6Y0Yd");

var $iyNC6 = parcelRequire("iyNC6");

var $cm8wu = parcelRequire("cm8wu");

var $8JPfp = parcelRequire("8JPfp");
function $380b4fc20fe73018$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $iyNC6.isSafari)()) return (0, $cm8wu.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $6Y0Yd.isFirefox)()) return (0, $8JPfp.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("cm8wu", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $4fcd2104d448d8bb$export$de68634bd94ed596);

var $iyNC6 = parcelRequire("iyNC6");

var $5rnq7 = parcelRequire("5rnq7");
function $4fcd2104d448d8bb$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $iyNC6.isSafari)()) return false;
    return dragEnter.hasOwnProperty((0, $5rnq7.symbols).isEnteringWindow);
}

});


parcelRegister("3svH3", function(module, exports) {
$parcel$export(module.exports, "getAvailableItems", () => $6719d8e1ef558a70$export$8d28cfecded8dcab);

var $f51YL = parcelRequire("f51YL");
function $6719d8e1ef558a70$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || (0, $f51YL.isAnAvailableType)({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}

});
parcelRegister("f51YL", function(module, exports) {
$parcel$export(module.exports, "isAnAvailableType", () => $4c365cb1e2b62127$export$a8e56a860d7957c7);

var $8Awvm = parcelRequire("8Awvm");

var $hIUqs = parcelRequire("hIUqs");

var $k4nGL = parcelRequire("k4nGL");
function $4c365cb1e2b62127$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $k4nGL.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $hIUqs.textMediaType) && value === (0, $8Awvm.androidFallbackText)) return false;
    return true;
}

});


parcelRegister("WK44O", function(module, exports) {
$parcel$export(module.exports, "getAvailableTypes", () => $ec8b88b478b9ef05$export$8c257a3856120a77);

var $f51YL = parcelRequire("f51YL");
function $ec8b88b478b9ef05$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>(0, $f51YL.isAnAvailableType)({
            type: type,
            value: transfer.getData(type)
        }));
}

});




parcelRegister("aGyQS", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $1d45d129372d1456$export$9c0606fcefb5d1e2);

var $bAB3U = parcelRequire("bAB3U");

var $4TtRL = parcelRequire("4TtRL");

var $cdLl4 = parcelRequire("cdLl4");

var $dTpfS = parcelRequire("dTpfS");
function $1d45d129372d1456$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $bAB3U.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $4TtRL.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $cdLl4.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $1d45d129372d1456$var$watchForInteractionStart({ start: start }) {
    return (0, $bAB3U.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $1d45d129372d1456$var$api = (0, $dTpfS.makeFixForAdapter)({
    watchForInteractionStart: $1d45d129372d1456$var$watchForInteractionStart,
    watchForInteractionEnd: $1d45d129372d1456$var$watchForInteractionEnd
});
function $1d45d129372d1456$export$9c0606fcefb5d1e2() {
    return $1d45d129372d1456$var$api.registerUsage();
}

});
parcelRegister("4TtRL", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $ac329233c65fd605$export$2e178e3647f5e6e9);

var $3Dl9T = parcelRequire("3Dl9T");
function $ac329233c65fd605$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return (0, $3Dl9T.adapter).monitor(args);
}

});
parcelRegister("3Dl9T", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $a438a835f11146ff$export$e00c9c6684b0ace);

var $bAB3U = parcelRequire("bAB3U");

var $fXk0t = parcelRequire("fXk0t");

var $cdLl4 = parcelRequire("cdLl4");

var $jKc3k = parcelRequire("jKc3k");

var $hIUqs = parcelRequire("hIUqs");

var $k4nGL = parcelRequire("k4nGL");

var $8NQRV = parcelRequire("8NQRV");

var $bhMjO = parcelRequire("bhMjO");
const $a438a835f11146ff$export$e00c9c6684b0ace = (0, $fXk0t.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $cdLl4.combine)((0, $bhMjO.honeyPotFix).bindEvents(), (0, $bAB3U.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $k4nGL.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $hIUqs.textMediaType))) return;
                const target = (0, $8NQRV.findTextNode)(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $hIUqs.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $jKc3k.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: (0, $bhMjO.honeyPotFix).getOnPostDispatch()
});
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $a438a835f11146ff$export$e00c9c6684b0ace.registerUsage();
})();

});
parcelRegister("jKc3k", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $1e6b43f4c9bc2e88$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $1e6b43f4c9bc2e88$export$338a9f6c7a1f02b0 = 'text/html';

});

parcelRegister("8NQRV", function(module, exports) {
$parcel$export(module.exports, "findTextNode", () => $9286558975e2e77b$export$c15c0fde2d293bb4);

var $iyNC6 = parcelRequire("iyNC6");

var $hIUqs = parcelRequire("hIUqs");
function $9286558975e2e77b$export$c15c0fde2d293bb4(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $iyNC6.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $hIUqs.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}

});

parcelRegister("bhMjO", function(module, exports) {
$parcel$export(module.exports, "honeyPotFix", () => $b1744f98e47cfc55$export$f17744ed5439c0ab);

var $gsRFy = parcelRequire("gsRFy");
const $b1744f98e47cfc55$export$f17744ed5439c0ab = (0, $gsRFy.makeHoneyPotFix)();

});




parcelRegister("01FCw", function(module, exports) {
$parcel$export(module.exports, "width", () => $c881918f8536e8b7$export$7e3df82ee760448c);
const $c881918f8536e8b7$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("cNZiy", function(module, exports) {
$parcel$export(module.exports, "default", () => $41b5164cfc8f04a0$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $21u3G = parcelRequire("21u3G");

var $d6mTg = parcelRequire("d6mTg");

var $4fJxA = parcelRequire("4fJxA");

var $g6jWc = parcelRequire("g6jWc");

var $iRdwF = parcelRequire("iRdwF");

var $8W36W = parcelRequire("8W36W");

var $gdUUy = parcelRequire("gdUUy");

var $cdLl4 = parcelRequire("cdLl4");

var $6gH4c = parcelRequire("6gH4c");

var $eUZeJ = parcelRequire("eUZeJ");

var $40WRr = parcelRequire("40WRr");

var $lPqcX = parcelRequire("lPqcX");

var $aGyQS = parcelRequire("aGyQS");

var $f2FKY = parcelRequire("f2FKY");

var $cX9Sc = parcelRequire("cX9Sc");

var $16Ma0 = parcelRequire("16Ma0");

var $l0QkZ = parcelRequire("l0QkZ");
const $41b5164cfc8f04a0$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $41b5164cfc8f04a0$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
const $41b5164cfc8f04a0$var$viewportScrollStyles = null;
const $41b5164cfc8f04a0$var$bodyScrollStyles = null;
const $41b5164cfc8f04a0$var$ModalDialog = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $d6mTg.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $bSJIT.useEffect)(()=>// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $cdLl4.combine)((0, $40WRr.disableDraggingToCrossOriginIFramesForElement)(), (0, $aGyQS.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $lPqcX.disableDraggingToCrossOriginIFramesForExternal)()), []);
    (0, $21u3G.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $eUZeJ.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $bSJIT.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $4fJxA.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $g6jWc.useLayering)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $l0QkZ.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6gH4c.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $f2FKY.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, $gdUUy.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $iRdwF.default), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, $jDsoo.cx)($41b5164cfc8f04a0$var$dialogStyles.motion, isFullScreen && $41b5164cfc8f04a0$var$dialogStyles.fullscreen),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-width': (0, $16Ma0.dialogWidth)(width),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-height': (0, $cX9Sc.dialogHeight)(height)
                    },
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("section", {
                        "aria-label": label,
                        ref: (0, $fGbV9.default)([
                            motionRef,
                            ref
                        ]),
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': (0, $16Ma0.dialogWidth)(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': (0, $cX9Sc.dialogHeight)(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, $9fU1q.default)([
                            $41b5164cfc8f04a0$var$dialogStyles.root,
                            $41b5164cfc8f04a0$var$dialogStyles.rootMotion,
                            !isFullScreen && $41b5164cfc8f04a0$var$dialogStyles.borderRadius,
                            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $8W36W.default), {
                    /**
         * We don't want a 'slide in' for the full screen modals.
         */ entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $dc70d.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $fGbV9.default)([
                                bottomFadeInProps.ref,
                                motionRef,
                                ref
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $16Ma0.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $cX9Sc.dialogHeight)(height)
                            },
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                            className: (0, $9fU1q.default)([
                                $41b5164cfc8f04a0$var$dialogStyles.root,
                                !isFullScreen && $41b5164cfc8f04a0$var$dialogStyles.borderRadius,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
$41b5164cfc8f04a0$export$2e2bcd8739ae039 = $41b5164cfc8f04a0$var$ModalDialog;

});
parcelRegister("4fJxA", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $832d52607e255517$export$4a4bf067ea9e7886);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $g6jWc = parcelRequire("g6jWc");
const $832d52607e255517$var$ESCAPE = 'Escape';
function $832d52607e255517$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $bSJIT.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $g6jWc.useLayering)();
    const onKeyDown = (0, $bSJIT.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $832d52607e255517$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $bSJIT.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        return (0, $bAB3U.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("g6jWc", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $044d2729865b0397$export$c8b4d54e03dee6ed);

var $bSJIT = parcelRequire("bSJIT");

var $hKgPS = parcelRequire("hKgPS");

var $iimkL = parcelRequire("iimkL");

var $jViBl = parcelRequire("jViBl");
function $044d2729865b0397$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $bSJIT.useContext)((0, $hKgPS.LevelContext));
    const layerNode = (0, $bSJIT.useContext)((0, $iimkL.LevelNodeContext));
    const rootNode = (0, $bSJIT.useContext)((0, $jViBl.RootNodeContext));
    const isLayerDisabled = (0, $bSJIT.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $bSJIT.useCallback)(()=>rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("eUZeJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $56af87fcdfc0f0f1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $56af87fcdfc0f0f1$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $bSJIT.useRef)(null);
    const onMotionFinish = (0, $bSJIT.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("cX9Sc", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $a38c3bc6dffc785f$export$ceba93bf0bdd16f2);
const $a38c3bc6dffc785f$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("16Ma0", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $6539b4db527113fc$export$a3da89b899389ed8);

var $01FCw = parcelRequire("01FCw");
const $6539b4db527113fc$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $01FCw.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $01FCw.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("l0QkZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $34d672f0b29fb3af$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fg2GS = parcelRequire("fg2GS");

var $lj4Nn = parcelRequire("lj4Nn");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $34d672f0b29fb3af$var$positionerStyles = null;
const $34d672f0b29fb3af$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const $34d672f0b29fb3af$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $34d672f0b29fb3af$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $34d672f0b29fb3af$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $34d672f0b29fb3af$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $lj4Nn.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $fg2GS.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $34d672f0b29fb3af$var$stackStyles.stackTransition,
            stackIndex > 0 ? $34d672f0b29fb3af$var$stackStyles.stackTransform : $34d672f0b29fb3af$var$stackStyles.stackIdle,
            $34d672f0b29fb3af$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$34d672f0b29fb3af$export$2e2bcd8739ae039 = $34d672f0b29fb3af$var$Positioner;

});




parcelRegister("l6EMG", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $a834af705bc8ed02$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $a834af705bc8ed02$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $a834af705bc8ed02$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $a834af705bc8ed02$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $a834af705bc8ed02$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9PwDt = parcelRequire("9PwDt");
const $a834af705bc8ed02$var$modalBodyStyles = null;
const $a834af705bc8ed02$var$modalHeadingStyles = null;
const $a834af705bc8ed02$var$modalImageStyles = null;
const $a834af705bc8ed02$var$modalActionContainerStyles = null;
const $a834af705bc8ed02$var$modalActionContainerReversedStyles = null;
const $a834af705bc8ed02$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $a834af705bc8ed02$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ])
    }, children);
const $a834af705bc8ed02$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ $bSJIT.createElement("h1", {
        id: id,
        className: (0, $9fU1q.default)([
            "_11c81af2 _syaz1kw7 _6rthu2gc"
        ])
    }, children);
};
const $a834af705bc8ed02$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ $bSJIT.createElement("img", {
        alt: alt,
        src: src,
        className: (0, $9fU1q.default)([
            "_1bsb1osq _4t3i1wug _5fbcfajl _1s1gfajl _j722idpf"
        ])
    });
const $a834af705bc8ed02$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ])
    }, children);
const $a834af705bc8ed02$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $a834af705bc8ed02$var$modalActionItemStyles.root
    }, children);

});

parcelRegister("anZ2y", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $d8431b0987fd0d4f$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $d8431b0987fd0d4f$export$d131eb21ba4cbd16);
const $d8431b0987fd0d4f$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #0515240F)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $d8431b0987fd0d4f$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #0515240F)",
                dark: "var(--ds-background-disabled, #0515240F)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $d8431b0987fd0d4f$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $d8431b0987fd0d4f$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$d8431b0987fd0d4f$var$extract($d8431b0987fd0d4f$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $d8431b0987fd0d4f$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$d8431b0987fd0d4f$var$extract($d8431b0987fd0d4f$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});







parcelRegister("1GaMW", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("j98Hb")).default);

var $15d2T = parcelRequire("15d2T");
parcelRequire("dezzY");
var $j98Hb = parcelRequire("j98Hb");

});
parcelRegister("15d2T", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("dezzY");
var $j98Hb = parcelRequire("j98Hb");
const $70f8d17a8ed0ce1f$var$FeatureFlag = ({ children: children, name: name, defaultValue: defaultValue, showIf: showIf = 'enabled' })=>{
    const flags = (0, $bSJIT.useContext)((0, $j98Hb.FeatureFlagsContext));
    let value = defaultValue;
    if ((0, $4ZMmh.has)(flags, name)) value = !!flags[name];
    const shouldShow = showIf === 'enabled' ? value : !value;
    return shouldShow ? children : null;
};
var $70f8d17a8ed0ce1f$export$2e2bcd8739ae039 = $70f8d17a8ed0ce1f$var$FeatureFlag;

});
parcelRegister("dezzY", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("j98Hb")).default);
$parcel$export(module.exports, "FeatureFlagsContext", () => (parcelRequire("j98Hb")).FeatureFlagsContext);

var $j98Hb = parcelRequire("j98Hb");

});
parcelRegister("j98Hb", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagsContext", () => $daa4d61b81f8fc5f$export$778f04ce1f3940a0);
$parcel$export(module.exports, "default", () => $daa4d61b81f8fc5f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $daa4d61b81f8fc5f$export$778f04ce1f3940a0 = /*#__PURE__*/ $bSJIT.createContext({});
const $daa4d61b81f8fc5f$var$FeatureFlagProvider = ({ featureFlags: featureFlags, children: children })=>/*#__PURE__*/ $bSJIT.createElement($daa4d61b81f8fc5f$export$778f04ce1f3940a0.Provider, {
        value: featureFlags
    }, children);
var $daa4d61b81f8fc5f$export$2e2bcd8739ae039 = $daa4d61b81f8fc5f$var$FeatureFlagProvider;

});




parcelRegister("20ilI", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => (parcelRequire("2LrvN")).TFECacheProvider);

var $2LrvN = parcelRequire("2LrvN");

});
parcelRegister("2LrvN", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => $51d8f90bb13c80e9$export$55b822f5d1bfb2cf);

var $bSJIT = parcelRequire("bSJIT");

var $g6Upu = parcelRequire("g6Upu");

var $2H5Vw = parcelRequire("2H5Vw");

var $ejSQe = parcelRequire("ejSQe");

var $6WltM = parcelRequire("6WltM");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $3qDrS = parcelRequire("3qDrS");
parcelRequire("bWLBr");
var $9ah7S = parcelRequire("9ah7S");
const $51d8f90bb13c80e9$var$FIVE_MINUTE_IN_SECONDS = 300;
const $51d8f90bb13c80e9$var$batchedGetExtensions = (0, $3qDrS.default)((0, $2H5Vw.fetchTFExtensions), 0);
const $51d8f90bb13c80e9$var$batchedGetExtensionsV2 = (0, $ejSQe.default)((0, $2H5Vw.fetchTFExtensions), 0);
const $51d8f90bb13c80e9$export$55b822f5d1bfb2cf = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const cacheRef = $bSJIT.useRef(new (0, (/*@__PURE__*/$parcel$interopDefault($g6Upu)))({
        stdTTL: $51d8f90bb13c80e9$var$FIVE_MINUTE_IN_SECONDS,
        checkperiod: $51d8f90bb13c80e9$var$FIVE_MINUTE_IN_SECONDS * 0.5,
        useClones: false
    }));
    const getExtensionsByType = (type, page)=>{
        const extensionsByType = cacheRef.current.get(type);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $51d8f90bb13c80e9$var$batchedGetExtensions(type);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: property,
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $jBiia.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const getExtensionsByTypeV2 = (type, resourceContext, page)=>{
        const { resourceId: resourceId } = resourceContext || {};
        const key = constructKey(resourceId, type);
        const extensionsByType = cacheRef.current.get(key);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $51d8f90bb13c80e9$var$batchedGetExtensionsV2(type, resourceContext);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: constructKey(resourceId, property),
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $jBiia.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const constructKey = (resourceId, property)=>resourceId ? resourceId.concat('-'.concat(property)) : property;
    return /*#__PURE__*/ $bSJIT.createElement((0, $9ah7S.TFECacheContext).Provider, {
        value: {
            getExtensionsByType: getExtensionsByType,
            getExtensionsByTypeV2: getExtensionsByTypeV2
        }
    }, children);
};
var $51d8f90bb13c80e9$export$2e2bcd8739ae039 = $51d8f90bb13c80e9$export$55b822f5d1bfb2cf;

});
parcelRegister("2H5Vw", function(module, exports) {
$parcel$export(module.exports, "fetchTFExtensions", () => $1b6853d7117c65ee$export$d3cc23e3d22de5ea);

var $llRGw = parcelRequire("llRGw");

var $i7phc = parcelRequire("i7phc");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $1b6853d7117c65ee$export$d3cc23e3d22de5ea = (types, resourceContext)=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/servicedesk-data/forge/fetch-extensions`;
    let body;
    const { resourceType: resourceType } = resourceContext || {};
    if (resourceType === (0, $i7phc.RESOURCE_TYPE_ISSUE) || resourceType === (0, $i7phc.RESOURCE_TYPE_PROJECT)) body = {
        resourceContext: resourceContext,
        extensionTypes: types
    };
    else body = {
        extensionTypes: types
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    return (0, $llRGw.post)(uri, body, headers).map(({ response: response })=>response.extensions).catch((e)=>{
        (0, $jBiia.trackError)('forge-tfe.fetch.failed', {}, e);
        return Promise.reject(e);
    }).toPromise();
};

});
parcelRegister("i7phc", function(module, exports) {
$parcel$export(module.exports, "FORGE_HELP_CENTER", () => $1d1f09126bb84ba1$export$5fb35f580fb0ead9);
$parcel$export(module.exports, "FORGE_PORTAL_HOME", () => $1d1f09126bb84ba1$export$f54ea43d8fdbc220);
$parcel$export(module.exports, "FORGE_REQUEST_CREATE", () => $1d1f09126bb84ba1$export$7fba94cefb87c359);
$parcel$export(module.exports, "FORGE_REQUEST_DETAILS", () => $1d1f09126bb84ba1$export$bc84cd79c53ab7bc);
$parcel$export(module.exports, "FORGE_REQUEST_LIST", () => $1d1f09126bb84ba1$export$6089843c57d171a8);
$parcel$export(module.exports, "FORGE_PROFILE", () => $1d1f09126bb84ba1$export$6c0b0fa4877ce128);
$parcel$export(module.exports, "FORGE_CSM_REQUEST_DETAILS", () => $1d1f09126bb84ba1$export$4fb482ff92f899c1);
$parcel$export(module.exports, "FORGE_CSM_REQUEST_CREATE", () => $1d1f09126bb84ba1$export$5487c011fec95f35);
$parcel$export(module.exports, "FORGE_CSM_HELP_CENTER", () => $1d1f09126bb84ba1$export$4a57418ad478379b);
$parcel$export(module.exports, "REQUEST_DETAIL_MAIN_SECTION_MODULE", () => $1d1f09126bb84ba1$export$a5069caad77a64d4);
$parcel$export(module.exports, "REQUEST_DETAIL_SIDE_SECTION_MODULE", () => $1d1f09126bb84ba1$export$6df357f715dfd2f4);
$parcel$export(module.exports, "PORTAL_HEADER_MODULE", () => $1d1f09126bb84ba1$export$463e8578e35a18ba);
$parcel$export(module.exports, "PORTAL_FOOTER_MODULE", () => $1d1f09126bb84ba1$export$70cbbad22fbf0821);
$parcel$export(module.exports, "PORTAL_SUBHEADER_MODULE", () => $1d1f09126bb84ba1$export$19ebf81efc141cb9);
$parcel$export(module.exports, "PROFILE_PANEL_MODULE", () => $1d1f09126bb84ba1$export$d47ce30c5cdcdaa7);
$parcel$export(module.exports, "USER_MENU_ACTION_SECTION_MODULE", () => $1d1f09126bb84ba1$export$b7f7df64576d21aa);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_MODULE", () => $1d1f09126bb84ba1$export$2cdcdb01b87d24f8);
$parcel$export(module.exports, "PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE", () => $1d1f09126bb84ba1$export$4df0942241cd5cc);
$parcel$export(module.exports, "HELP_CENTER_LAYOUT_ELEMENT_MODULE", () => $1d1f09126bb84ba1$export$9183c6a9b59c394c);
$parcel$export(module.exports, "CSM_REQUEST_DETAIL_MODULE", () => $1d1f09126bb84ba1$export$3b8e5fc21e252d78);
$parcel$export(module.exports, "CUSTOM_FIELD", () => $1d1f09126bb84ba1$export$522be55130e84de4);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE", () => $1d1f09126bb84ba1$export$96b7ba112deb79bf);
$parcel$export(module.exports, "UI_MODIFICATIONS", () => $1d1f09126bb84ba1$export$c1878e6e4b67d4ad);
$parcel$export(module.exports, "JIRA_MODULES", () => $1d1f09126bb84ba1$export$f9e7f55440c76553);
$parcel$export(module.exports, "USER_MENU_ACTION_COMPONENT", () => $1d1f09126bb84ba1$export$84b6b6a1a76815b6);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_COMPONENT", () => $1d1f09126bb84ba1$export$bec9cdaa83793785);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE", () => $1d1f09126bb84ba1$export$7c5d9a7c5f30e041);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT", () => $1d1f09126bb84ba1$export$39205aa8618a798);
$parcel$export(module.exports, "RESOURCE_TYPE_UNKNOWN", () => $1d1f09126bb84ba1$export$a62b153e8eb10906);
$parcel$export(module.exports, "TOP_LEVEL_COMPONENTS", () => $1d1f09126bb84ba1$export$fa9195e99a5ec8a7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $1d1f09126bb84ba1$export$2b8aeda236486576);
const $1d1f09126bb84ba1$export$5fb35f580fb0ead9 = 'help_center';
const $1d1f09126bb84ba1$export$f54ea43d8fdbc220 = 'portal';
const $1d1f09126bb84ba1$export$7fba94cefb87c359 = 'create_request';
const $1d1f09126bb84ba1$export$bc84cd79c53ab7bc = 'view_request';
const $1d1f09126bb84ba1$export$6089843c57d171a8 = 'my_requests';
const $1d1f09126bb84ba1$export$6c0b0fa4877ce128 = 'profile';
const $1d1f09126bb84ba1$export$4fb482ff92f899c1 = 'csm_view_request';
const $1d1f09126bb84ba1$export$5487c011fec95f35 = 'csm_create_request';
const $1d1f09126bb84ba1$export$4a57418ad478379b = 'csm_help_center';
const $1d1f09126bb84ba1$export$a5069caad77a64d4 = 'jiraServiceManagement:portalRequestDetail';
const $1d1f09126bb84ba1$export$6df357f715dfd2f4 = 'jiraServiceManagement:portalRequestDetailPanel';
const $1d1f09126bb84ba1$export$463e8578e35a18ba = 'jiraServiceManagement:portalHeader';
const $1d1f09126bb84ba1$export$70cbbad22fbf0821 = 'jiraServiceManagement:portalFooter';
const $1d1f09126bb84ba1$export$19ebf81efc141cb9 = 'jiraServiceManagement:portalSubheader';
const $1d1f09126bb84ba1$export$d47ce30c5cdcdaa7 = 'jiraServiceManagement:portalProfilePanel';
const $1d1f09126bb84ba1$export$b7f7df64576d21aa = 'jiraServiceManagement:portalUserMenuAction';
const $1d1f09126bb84ba1$export$2cdcdb01b87d24f8 = 'jiraServiceManagement:portalRequestViewAction';
const $1d1f09126bb84ba1$export$4df0942241cd5cc = 'jiraServiceManagement:portalRequestCreatePropertyPanel';
const $1d1f09126bb84ba1$export$9183c6a9b59c394c = 'jiraServiceManagement:helpCenterLayoutElement';
const $1d1f09126bb84ba1$export$3b8e5fc21e252d78 = 'customerServiceManagement:requestDetail';
const $1d1f09126bb84ba1$export$522be55130e84de4 = 'jira:customField';
const $1d1f09126bb84ba1$export$96b7ba112deb79bf = 'jira:customFieldType';
const $1d1f09126bb84ba1$export$c1878e6e4b67d4ad = 'jira:uiModifications';
const $1d1f09126bb84ba1$export$f9e7f55440c76553 = [
    $1d1f09126bb84ba1$export$522be55130e84de4,
    $1d1f09126bb84ba1$export$96b7ba112deb79bf,
    $1d1f09126bb84ba1$export$c1878e6e4b67d4ad
];
const $1d1f09126bb84ba1$export$84b6b6a1a76815b6 = 'PortalUserMenuAction';
const $1d1f09126bb84ba1$export$bec9cdaa83793785 = 'PortalRequestViewAction';
const $1d1f09126bb84ba1$export$7c5d9a7c5f30e041 = 'ISSUE';
const $1d1f09126bb84ba1$export$39205aa8618a798 = 'PROJECT';
const $1d1f09126bb84ba1$export$a62b153e8eb10906 = 'UNKNOWN';
const $1d1f09126bb84ba1$export$fa9195e99a5ec8a7 = {
    [$1d1f09126bb84ba1$export$a5069caad77a64d4]: 'PortalRequestDetail',
    [$1d1f09126bb84ba1$export$6df357f715dfd2f4]: 'PortalRequestDetailPanel',
    [$1d1f09126bb84ba1$export$463e8578e35a18ba]: 'PortalHeader',
    [$1d1f09126bb84ba1$export$70cbbad22fbf0821]: 'PortalFooter',
    [$1d1f09126bb84ba1$export$19ebf81efc141cb9]: 'PortalSubheader',
    [$1d1f09126bb84ba1$export$d47ce30c5cdcdaa7]: 'PortalProfilePanel',
    [$1d1f09126bb84ba1$export$4df0942241cd5cc]: 'PortalRequestCreatePropertyPanel',
    [$1d1f09126bb84ba1$export$3b8e5fc21e252d78]: 'CsmRequestDetail'
};
const $1d1f09126bb84ba1$export$2b8aeda236486576 = 'edit';

});


parcelRegister("ejSQe", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9fabba26afca7ee$export$2e2bcd8739ae039);

var $4ZMmh = parcelRequire("4ZMmh");
const $c9fabba26afca7ee$var$defer = ()=>{
    let resolve = ()=>{
        throw new Error('Resolve function not implememnted');
    };
    let reject = ()=>{
        throw new Error('Reject function not implemented');
    };
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $c9fabba26afca7ee$var$proxyFunctionV2 = (func, wait, options = {})=>{
    const arrMap = new Map();
    const auxillaryMap = new Map();
    let deferred = $c9fabba26afca7ee$var$defer();
    const callThenResetArgs = (arrMap1, auxillaryMap1)=>{
        try {
            const promiseArr = [];
            arrMap1.forEach((value, key)=>promiseArr.push(func(value, auxillaryMap1.get(key))));
            promiseArr.forEach((value)=>{
                deferred.resolve(value);
            });
        } catch (err) {
            deferred.reject(err);
        }
        arrMap.clear();
        auxillaryMap.clear();
        deferred = $c9fabba26afca7ee$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $4ZMmh.debounce)(callThenResetArgs, wait, options);
    return (arg, resourceContext)=>{
        const { resourceId: resourceId } = resourceContext || {};
        if (!resourceContext || resourceId === undefined) return deferred.promise;
        if (arrMap.has(resourceId)) {
            var _arrMap$get;
            if (!((_arrMap$get = arrMap.get(resourceId)) !== null && _arrMap$get !== void 0 && _arrMap$get.includes(arg))) {
                var _arrMap$get2;
                (_arrMap$get2 = arrMap.get(resourceId)) === null || _arrMap$get2 === void 0 || _arrMap$get2.push(arg);
            }
        } else {
            const arr = [];
            arr.push(arg);
            arrMap.set(resourceId, arr);
            auxillaryMap.set(resourceId, resourceContext);
        }
        debouncedFunc(arrMap, auxillaryMap);
        return deferred.promise;
    };
};
var $c9fabba26afca7ee$export$2e2bcd8739ae039 = $c9fabba26afca7ee$var$proxyFunctionV2;

});

parcelRegister("bWLBr", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => (parcelRequire("9ah7S")).TFECacheContext);

var $9ah7S = parcelRequire("9ah7S");

});
parcelRegister("9ah7S", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => $622fcae98f923853$export$2a99743cd152f1d4);

var $bSJIT = parcelRequire("bSJIT");

var $2H5Vw = parcelRequire("2H5Vw");

var $ejSQe = parcelRequire("ejSQe");

var $3qDrS = parcelRequire("3qDrS");
const $622fcae98f923853$var$batchedGetExtensions = (0, $3qDrS.default)((0, $2H5Vw.fetchTFExtensions), 0);
const $622fcae98f923853$var$batchedGetExtensionsV2 = (0, $ejSQe.default)((0, $2H5Vw.fetchTFExtensions), 0);
const $622fcae98f923853$export$2a99743cd152f1d4 = /*#__PURE__*/ $bSJIT.createContext({
    getExtensionsByType: $622fcae98f923853$var$batchedGetExtensions,
    getExtensionsByTypeV2: $622fcae98f923853$var$batchedGetExtensionsV2
});
$622fcae98f923853$export$2a99743cd152f1d4.displayName = 'TFECacheContext';

});




parcelRegister("ckGNT", function(module, exports) {
$parcel$export(module.exports, "LazyPushingCustomizeSidebar", () => $f8651b167cb27f23$export$1ccd6783fcfdc887);
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("2LtGs")).default);
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("iStmz")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("iStmz")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("iStmz")).useSetCustomiseSidebarTrigger);
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("fVdFI");
var $2LtGs = parcelRequire("2LtGs");
parcelRequire("6RoGV");
var $iStmz = parcelRequire("iStmz");

const $f8651b167cb27f23$export$1ccd6783fcfdc887 = (0, $2vYDF.lazy)(()=>(parcelRequire("kWSHA")), {
    moduleId: "./src/view/common/pushing-customize-sidebar/pushing-customize-sidebar.tsx"
});

});
parcelRegister("fVdFI", function(module, exports) {
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("2LtGs")).default);
$parcel$export(module.exports, "PusherConsumer", () => (parcelRequire("2LtGs")).PusherConsumer);

var $2LtGs = parcelRequire("2LtGs");

});
parcelRegister("2LtGs", function(module, exports) {
$parcel$export(module.exports, "PusherConsumer", () => $946b151e1df5617e$export$693eb5228d48f25d);
$parcel$export(module.exports, "default", () => $946b151e1df5617e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $ki6Qt = parcelRequire("ki6Qt");

var $fU62V = parcelRequire("fU62V");

var $9Yqiu = parcelRequire("9Yqiu");

var $4ZMmh = parcelRequire("4ZMmh");

var $58A3x = parcelRequire("58A3x");
const $946b151e1df5617e$var$PusherContext = /*#__PURE__*/ $bSJIT.createContext({
    onOpen: (0, $4ZMmh.noop),
    onClose: (0, $4ZMmh.noop)
});
const $946b151e1df5617e$export$693eb5228d48f25d = $946b151e1df5617e$var$PusherContext.Consumer;
class $946b151e1df5617e$export$2e2bcd8739ae039 extends $bSJIT.Component {
    render() {
        const { children: children, className: className } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ $bSJIT.createElement($946b151e1df5617e$var$PusherContext.Provider, {
            value: {
                onOpen: this.handleOpen,
                onClose: this.handleClose
            }
        }, /*#__PURE__*/ $bSJIT.createElement($946b151e1df5617e$var$ContainerPusher, {
            className: className,
            isOpen: isOpen
        }, children));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false
        }, this.handleOpen = ()=>{
            this.setState({
                isOpen: true
            });
        }, this.handleClose = ()=>{
            this.setState({
                isOpen: false
            });
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $946b151e1df5617e$var$ContainerPusher = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-sak91x-0"
})`will-change:padding-right;transition:padding-right ${(props)=>props.isOpen ? $9Yqiu.timingFunctions.easeOut : $9Yqiu.timingFunctions.easeIn} ${(0, $58A3x.EXPAND_TIME_MS)}ms;${(props)=>$fU62V.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $4v2A7.css)`padding:${(0, $58A3x.SIDEBAR_HEIGHT_SMALL_VIEWPORT)} 0 0 0;`)};${$ki6Qt.fromMedium.css`
        ${(props)=>$fU62V.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $4v2A7.css)`padding:0 ${(0, $58A3x.SIDEBAR_WIDTH_LARGE_VIEWPORT)} 0 0;`)};
    `};`;

});
parcelRegister("ki6Qt", function(module, exports) {
$parcel$export(module.exports, "fromCustom", () => $c962a05a8b31d14d$export$932b0cf23a178537);
$parcel$export(module.exports, "fromXSmall", () => $c962a05a8b31d14d$export$b7a79c964fba7552);
$parcel$export(module.exports, "fromSmall", () => $c962a05a8b31d14d$export$639a1bf83d3a4645);
$parcel$export(module.exports, "fromMedium", () => $c962a05a8b31d14d$export$e95a160cb61e118);
$parcel$export(module.exports, "fromLarge", () => $c962a05a8b31d14d$export$a37dde2f785d088f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $a7Tmb = parcelRequire("a7Tmb");
const $c962a05a8b31d14d$var$generateBreakpoint = (minSize, maxSize)=>{
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emMinSize = minSize / 16;
    const emMaxSize = maxSize && maxSize / 16;
    let mediaQuery;
    if (emMinSize && emMaxSize) mediaQuery = `(min-width: ${emMinSize}em) and (max-width: ${emMaxSize})`;
    else if (emMinSize) mediaQuery = `(min-width: ${emMinSize}em)`;
    else if (emMaxSize) mediaQuery = `(max-width: ${emMaxSize}em)`;
    const func = (strings, ...interpolations)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        (0, $4v2A7.css)`@media ${mediaQuery}{${(0, $4v2A7.css)(// @ts-expect-error -- css overloads doesn't like this, but this is the exact root type we allow, confirmed to work via Storybook
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        strings, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        ...interpolations)};}`;
    return {
        // So we get syntax highlighting easily.
        css: func
    };
};
const $c962a05a8b31d14d$export$932b0cf23a178537 = (minSize, maxSize)=>$c962a05a8b31d14d$var$generateBreakpoint(minSize, maxSize);
const $c962a05a8b31d14d$export$4da665ccee8caf55 = $c962a05a8b31d14d$var$generateBreakpoint(0, (0, $a7Tmb.sizes).xxsmall);
const $c962a05a8b31d14d$export$9f4ec08b07b6fafc = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).xxsmall);
const $c962a05a8b31d14d$export$b7a79c964fba7552 = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).xsmall);
const $c962a05a8b31d14d$export$639a1bf83d3a4645 = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).small);
const $c962a05a8b31d14d$export$e95a160cb61e118 = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).medium);
const $c962a05a8b31d14d$export$a37dde2f785d088f = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).large);
const $c962a05a8b31d14d$export$3621f41c276f9a6f = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).xlarge);
const $c962a05a8b31d14d$export$86edc938645eb2d4 = $c962a05a8b31d14d$var$generateBreakpoint((0, $a7Tmb.sizes).xxlarge);

});
parcelRegister("a7Tmb", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $5a54a4471bcb59fb$export$c647cb0ee6e282fe);
const $5a54a4471bcb59fb$export$c647cb0ee6e282fe = {
    xxlarge: 1600,
    xlarge: 1440,
    large: 1280,
    medium: 960,
    small: 840,
    xsmall: 600,
    xxsmall: 480,
    tablet: 800
};

});


parcelRegister("fU62V", function(module, exports) {
$parcel$export(module.exports, "focusRing", () => $f24ae679d863846f$export$8e24544ddba725ee);
$parcel$export(module.exports, "borderBox", () => $f24ae679d863846f$export$ed32643c9618a26);
$parcel$export(module.exports, "flexCenter", () => $f24ae679d863846f$export$6f9e4349aad79600);
$parcel$export(module.exports, "center", () => $f24ae679d863846f$export$3481c78889e8fbe8);
$parcel$export(module.exports, "breakWord", () => $f24ae679d863846f$export$7cb287253100bd3f);
$parcel$export(module.exports, "borderRadius", () => $f24ae679d863846f$export$7a57f79000377ca2);
$parcel$export(module.exports, "borderRadiusLarge", () => $f24ae679d863846f$export$d05a297a442a387);
$parcel$export(module.exports, "borderRadiusValue", () => $f24ae679d863846f$export$56a32ffee3e5ef01);
$parcel$export(module.exports, "clamp", () => $f24ae679d863846f$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "multiLineClamp", () => $f24ae679d863846f$export$6a2fc6dc0ea84acc);
$parcel$export(module.exports, "applyIf", () => $f24ae679d863846f$export$64120c40e5147be9);
$parcel$export(module.exports, "placeholder", () => $f24ae679d863846f$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "raiseUpOnHoverOrFocus", () => $f24ae679d863846f$export$44d27400011e4794);
$parcel$export(module.exports, "subtleThemeColorBackground", () => $f24ae679d863846f$export$b2d8a5f61fea402f);
$parcel$export(module.exports, "toolTipPrimitiveStyle", () => $f24ae679d863846f$export$2c414b247dcd2e5d);
$parcel$export(module.exports, "panelExpansionAnimationFix", () => $f24ae679d863846f$export$de6b6b015066ff26);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $87QgR = parcelRequire("87QgR");

var $7QbH4 = parcelRequire("7QbH4");

var $9K7mZ = parcelRequire("9K7mZ");

var $9Yqiu = parcelRequire("9Yqiu");
/**
 * TODO: Replace with `@atlaskit/focus-ring`.
 */ const $f24ae679d863846f$var$atlaskitFocusRing = {
    focusRing: (color = "var(--ds-border-focused, #4C9AFF)", outlineWidth = 2)=>`
        &:focus {
          outline: none;
          box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
        }
      `,
    noFocusRing: ()=>`
        box-shadow: none;
      `
};
const $f24ae679d863846f$var$defaultFocusRing = $f24ae679d863846f$var$atlaskitFocusRing.focusRing();
const $f24ae679d863846f$var$noFocusRing = $f24ae679d863846f$var$atlaskitFocusRing.noFocusRing();
const $f24ae679d863846f$export$8e24544ddba725ee = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    default: (0, $4v2A7.css)`&:focus-visible{${$f24ae679d863846f$var$defaultFocusRing};}&:focus:not(:focus-visible){outline:0;}`,
    none: $f24ae679d863846f$var$noFocusRing
};
const $f24ae679d863846f$export$ed32643c9618a26 = /*#__PURE__*/ (0, $4v2A7.css)`box-sizing:border-box;*{box-sizing:border-box;}`;
const $f24ae679d863846f$export$6f9e4349aad79600 = /*#__PURE__*/ (0, $4v2A7.css)`display:flex;align-items:center;justify-content:center;`;
const $f24ae679d863846f$export$3481c78889e8fbe8 = (position)=>(0, $4v2A7.css)`position:${position};top:50%;left:50%;transform:translate3d(-50%,-50%,0);`;
const $f24ae679d863846f$export$7cb287253100bd3f = /*#__PURE__*/ (0, $4v2A7.css)`white-space:pre-wrap;word-break:break-word;`;
const $f24ae679d863846f$export$7a57f79000377ca2 = /*#__PURE__*/ (0, $4v2A7.css)`border-radius:${"var(--ds-radius-small, 3px)"};`;
const $f24ae679d863846f$export$d05a297a442a387 = /*#__PURE__*/ (0, $4v2A7.css)({
    borderRadius: "var(--ds-radius-large, 8px)"
});
const $f24ae679d863846f$export$56a32ffee3e5ef01 = `${"var(--ds-radius-small, 0.25rem)"}`;
const $f24ae679d863846f$export$7d15b64cf5a3a4c4 = /*#__PURE__*/ (0, $4v2A7.css)`text-overflow:ellipsis;overflow:hidden;white-space:nowrap;`;
const $f24ae679d863846f$export$6a2fc6dc0ea84acc = (lines, lineHeight = $9K7mZ.multiple(2.5).unitless)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $4v2A7.css)`display:-webkit-box;-webkit-line-clamp:${lines};-webkit-box-orient:vertical;max-height:${lineHeight * lines}px;overflow:hidden;`;
const $f24ae679d863846f$export$64120c40e5147be9 = (predicateResult, mixin)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $4v2A7.css)`${predicateResult ? mixin : ''};`;
const $f24ae679d863846f$export$c7187bbd1a7a9244 = (color)=>(0, $4v2A7.css)`&::-webkit-input-placeholder{color:${color};}&::-moz-placeholder{color:${color};opacity:1;}&::-ms-input-placeholder{color:${color};}&:-moz-placeholder{color:${color};opacity:1;}&:-ms-input-placeholder{color:${color};}`;
const $f24ae679d863846f$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $f24ae679d863846f$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($f24ae679d863846f$var$HC_ADS_DROP_COMMIT_2);
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f24ae679d863846f$var$raiseUpOnHoverPsuedoElement = /*#__PURE__*/ (0, $4v2A7.css)`${$f24ae679d863846f$export$7a57f79000377ca2};${()=>$f24ae679d863846f$var$isHcAdsDropCommit2Enabled() && $f24ae679d863846f$export$d05a297a442a387} content:'';position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};`;
const $f24ae679d863846f$export$44d27400011e4794 = (fromElevation = $7QbH4.e100, toElevation = $7QbH4.e200)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $4v2A7.css)`position:relative;transition:transform ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};&::before{${$f24ae679d863846f$var$raiseUpOnHoverPsuedoElement};${fromElevation};z-index:inherit;}&::after{${$f24ae679d863846f$var$raiseUpOnHoverPsuedoElement};${toElevation};opacity:0;z-index:inherit;}&:focus,&:hover{transform:translate3d(0,-2px,0);&::after{opacity:1;}&::before{opacity:0;}}`;
const $f24ae679d863846f$export$b2d8a5f61fea402f = /*#__PURE__*/ (0, $4v2A7.css)`background-image:linear-gradient(to right,rgba(255,255,255,0.85),rgba(255,255,255,0.85)),linear-gradient(to right,${(props)=>props.theme.color},${(props)=>props.theme.color});`;
// Overrides the @atlaskit/css-reset focus ring with our own
// wrapper that only shows it if you interact by keyboard.
(0, $4v2A7.injectGlobal)`a{${$f24ae679d863846f$export$8e24544ddba725ee.default};}`;
const $f24ae679d863846f$export$2c414b247dcd2e5d = /*#__PURE__*/ (0, $4v2A7.css)`color:${"var(--ds-text-inverse, #FFFFFF)"};background-color:${"var(--ds-text, #172B4D)"};padding:${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"};border-radius:${$f24ae679d863846f$export$7a57f79000377ca2};`;
const $f24ae679d863846f$export$de6b6b015066ff26 = /*#__PURE__*/ (0, $4v2A7.css)`> div > div{box-sizing:content-box;}.rah-animating{overflow:visible !important;filter:opacity(0.05);}`;

});
parcelRegister("7QbH4", function(module, exports) {
$parcel$export(module.exports, "e100", () => $0d70846708dfcf53$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $0d70846708dfcf53$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e400", () => $0d70846708dfcf53$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "newElevationsFromDesignSystems", () => $0d70846708dfcf53$export$78129b34f80acd5f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $kU5HH = parcelRequire("kU5HH");
const $0d70846708dfcf53$export$b390b459b8b8d8d0 = /*#__PURE__*/ (0, $4v2A7.css)`box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};z-index:${$kU5HH.card};`;
const $0d70846708dfcf53$export$3c35fb2adfe0992 = /*#__PURE__*/ (0, $4v2A7.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$kU5HH.dialog};`;
const $0d70846708dfcf53$export$f330dca4c33ed51f = /*#__PURE__*/ (0, $4v2A7.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 8px 16px -4px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$kU5HH.modal};`;
const $0d70846708dfcf53$export$3c7c047ca0ed675e = /*#__PURE__*/ (0, $4v2A7.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 12px 24px -6px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$kU5HH.panel};`;
const $0d70846708dfcf53$export$e6af781b0d301e56 = /*#__PURE__*/ (0, $4v2A7.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 20px 32px -8px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$kU5HH.flag};`;
const $0d70846708dfcf53$export$78129b34f80acd5f = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e100: (0, $4v2A7.css)`z-index:${$kU5HH.card};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};`,
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e200: (0, $4v2A7.css)`z-index:${$kU5HH.dialog};box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};`
};

});
parcelRegister("kU5HH", function(module, exports) {
$parcel$export(module.exports, "modal", () => $30164bea6992c98d$export$96e4b36520c26a2c);
$parcel$export(module.exports, "card", () => $30164bea6992c98d$export$aa3e815946b80764);
$parcel$export(module.exports, "dialog", () => $30164bea6992c98d$export$518824cf31321346);
$parcel$export(module.exports, "panel", () => $30164bea6992c98d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "flag", () => $30164bea6992c98d$export$42405f212471e8a2);
$parcel$export(module.exports, "layer", () => $30164bea6992c98d$export$50a222d9023da98b);
$parcel$export(module.exports, "pushingCustomizeSidebarSmall", () => $30164bea6992c98d$export$d937b725511051a5);
$parcel$export(module.exports, "pushingCustomizeSidebarLarge", () => $30164bea6992c98d$export$6d600c1f7c7bf904);
$parcel$export(module.exports, "pageInBannerLayout", () => $30164bea6992c98d$export$b3a6c753aad12c21);
$parcel$export(module.exports, "banner", () => $30164bea6992c98d$export$bb5ee47d9ea2348e);
$parcel$export(module.exports, "portalCardLayout", () => $30164bea6992c98d$export$1f2452f153db200);
$parcel$export(module.exports, "forgeLoadingComponent", () => $30164bea6992c98d$export$6bbd03fd9ab1103f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $juI4y = parcelRequire("juI4y");
const $30164bea6992c98d$export$96e4b36520c26a2c = (0, $juI4y.layers).modal();
const $30164bea6992c98d$export$aa3e815946b80764 = (0, $juI4y.layers).card();
const $30164bea6992c98d$export$518824cf31321346 = (0, $juI4y.layers).dialog();
const $30164bea6992c98d$export$21f42ab9b6679f44 = (0, $juI4y.layers).navigation();
const $30164bea6992c98d$export$42405f212471e8a2 = (0, $juI4y.layers).flag();
const $30164bea6992c98d$export$50a222d9023da98b = (0, $juI4y.layers).layer();
const $30164bea6992c98d$export$4e6f96734dfe12f4 = (0, $juI4y.layers).tooltip();
const $30164bea6992c98d$export$f2ea4ab276c3e3fa = 502; // This has to be > atlaskit blanket which has a z-index of 500 and smaller than the modal layer which is at 510
const $30164bea6992c98d$export$312cd8ab1e0faaaa = $30164bea6992c98d$export$f2ea4ab276c3e3fa;
const $30164bea6992c98d$export$cb3a20fdbbf963aa = $30164bea6992c98d$export$312cd8ab1e0faaaa + 1;
const $30164bea6992c98d$export$d937b725511051a5 = $30164bea6992c98d$export$cb3a20fdbbf963aa + 1;
const $30164bea6992c98d$export$6d600c1f7c7bf904 = $30164bea6992c98d$export$96e4b36520c26a2c - 50;
const $30164bea6992c98d$export$363009303e3f9227 = 1;
const $30164bea6992c98d$export$b339878b6d12ef6c = 2;
const $30164bea6992c98d$export$980027fe3bc5cfbc = 3;
const $30164bea6992c98d$export$b3a6c753aad12c21 = -1;
const $30164bea6992c98d$export$bb5ee47d9ea2348e = -2;
const $30164bea6992c98d$export$1f2452f153db200 = 0;
const $30164bea6992c98d$export$6bbd03fd9ab1103f = 500;

});


parcelRegister("9K7mZ", function(module, exports) {
$parcel$export(module.exports, "unitless", () => $c28bbd9103ce0ed2$export$c6b9faa6b723d31a);
$parcel$export(module.exports, "multiple", () => $c28bbd9103ce0ed2$export$939ddaa3205df08e);
$parcel$export(module.exports, "SINGLE_LINE_PARAGRAPH_HEIGHT", () => $c28bbd9103ce0ed2$export$7a95f3449f53d741);
const $c28bbd9103ce0ed2$export$c6b9faa6b723d31a = 8;
const $c28bbd9103ce0ed2$export$91c0eda1d06bf008 = '8px';
const $c28bbd9103ce0ed2$export$939ddaa3205df08e = (multiplier)=>({
        px: `${multiplier * 8}px`,
        unitless: multiplier * 8,
        multiple: (additionalMultiplier)=>$c28bbd9103ce0ed2$export$939ddaa3205df08e(multiplier * additionalMultiplier)
    });
const $c28bbd9103ce0ed2$export$7a95f3449f53d741 = 20;

});

parcelRegister("9Yqiu", function(module, exports) {
$parcel$export(module.exports, "timingFunctions", () => $38934ad92c347af5$export$61210fa83792a81);
$parcel$export(module.exports, "speedMs", () => $38934ad92c347af5$export$e913427a0c9547b);
$parcel$export(module.exports, "fadeInOutTiming", () => $38934ad92c347af5$export$44a465aba7fd9c0a);
$parcel$export(module.exports, "fadeInOut", () => $38934ad92c347af5$export$6c232a6cba05a953);
$parcel$export(module.exports, "slideInOutFromTop", () => $38934ad92c347af5$export$cb4674081b5c3c03);
$parcel$export(module.exports, "slideInOutFromRight", () => $38934ad92c347af5$export$cb755d7f610bdc3b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
const $38934ad92c347af5$export$61210fa83792a81 = {
    easeOut: 'ease-out',
    easeIn: 'ease-in',
    easeInOut: 'ease-in-out',
    // http://cubic-bezier.com/#.47,0,0,1.19
    easeInOutSpring: 'cubic-bezier(.79,.22,0,1.19)',
    linear: 'linear',
    // Same easing used in Atlaskit modal:
    // https://bitbucket.org/atlassian/atlaskit-mk-2/src/fd22974e576281b2f4d158b0a0df3badc4ed9ab2/packages/core/modal-dialog/src/components/Animation.js?at=master&fileviewer=file-view-default
    easeInOutQuad: 'cubic-bezier(0.23, 1, 0.32, 1)'
};
const $38934ad92c347af5$export$e913427a0c9547b = {
    superFast: 50,
    fast: 140,
    medium: 200,
    slow: 300
};
const $38934ad92c347af5$var$fadeInOutOpacityMap = {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0
};
const $38934ad92c347af5$export$44a465aba7fd9c0a = (ms, delay = 0)=>(0, $4v2A7.css)`transition:opacity ${ms}ms;transition-delay:${delay}ms;transition-timing-function:${$38934ad92c347af5$export$61210fa83792a81.easeOut};`;
const $38934ad92c347af5$export$6c232a6cba05a953 = (ms, delay = 0)=>(0, $4v2A7.css)`${$38934ad92c347af5$export$44a465aba7fd9c0a(ms, delay)};opacity:${(props)=>$38934ad92c347af5$var$fadeInOutOpacityMap[props.state]};`;
const $38934ad92c347af5$export$e83f174dbf56adcc = (ms = $38934ad92c347af5$export$e913427a0c9547b.fast)=>(0, $4v2A7.css)`transition:transform ${ms}ms;transition-timing-function:${$38934ad92c347af5$export$61210fa83792a81.easeInOut};transform:scale(1.1);`;
const $38934ad92c347af5$var$slideInOutFromTopTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(0, -100%, 0)',
    exited: 'translate3d(0, -100%, 0)'
};
const $38934ad92c347af5$var$slideInOutFromRightTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(100%, 0, 0)',
    exited: 'translate3d(100%, 0, 0)'
};
const $38934ad92c347af5$var$slideInOutTransitionMap = (ms)=>({
        /* This will ease out when entering, and ease-in when leaving. */ entering: `transform ${ms}ms ${$38934ad92c347af5$export$61210fa83792a81.easeOut}`,
        entered: `transform ${ms}ms ${$38934ad92c347af5$export$61210fa83792a81.easeOut}`,
        exiting: `transform ${ms}ms ${$38934ad92c347af5$export$61210fa83792a81.easeIn}`
    });
const $38934ad92c347af5$export$cb4674081b5c3c03 = (ms)=>(0, $4v2A7.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $38934ad92c347af5$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$38934ad92c347af5$var$slideInOutFromTopTransformMap[props.state]};`;
const $38934ad92c347af5$export$cb755d7f610bdc3b = (ms)=>(0, $4v2A7.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $38934ad92c347af5$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$38934ad92c347af5$var$slideInOutFromRightTransformMap[props.state]};`;

});


parcelRegister("58A3x", function(module, exports) {
$parcel$export(module.exports, "EXPAND_TIME_MS", () => $844ddd4a3859b3b2$export$a718feb2020f924e);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_MULTIPLIER", () => $844ddd4a3859b3b2$export$916ffa0b867d54d8);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_VIEWPORT", () => $844ddd4a3859b3b2$export$66e2a13bbb493bde);
$parcel$export(module.exports, "SIDEBAR_HEIGHT_SMALL_VIEWPORT", () => $844ddd4a3859b3b2$export$3d0c478f72970318);
$parcel$export(module.exports, "SIDEBAR_FULL_HEIGHT_SMALL_VIEWPORT", () => $844ddd4a3859b3b2$export$aea0de5dee32e42e);
$parcel$export(module.exports, "TAG_BUTTON_HEIGHT", () => $844ddd4a3859b3b2$export$9aa6c06b2eb3bd9e);

var $9K7mZ = parcelRequire("9K7mZ");

var $9Yqiu = parcelRequire("9Yqiu");
const $844ddd4a3859b3b2$export$a718feb2020f924e = $9Yqiu.speedMs.medium;
const $844ddd4a3859b3b2$export$916ffa0b867d54d8 = 50;
const $844ddd4a3859b3b2$export$66e2a13bbb493bde = $9K7mZ.multiple($844ddd4a3859b3b2$export$916ffa0b867d54d8).px;
const $844ddd4a3859b3b2$export$3d0c478f72970318 = '40vh';
const $844ddd4a3859b3b2$export$aea0de5dee32e42e = '100vh';
const $844ddd4a3859b3b2$export$9aa6c06b2eb3bd9e = $9K7mZ.unitless * 5;

});



parcelRegister("6RoGV", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("iStmz")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("iStmz")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("iStmz")).useSetCustomiseSidebarTrigger);

var $iStmz = parcelRequire("iStmz");

});
parcelRegister("iStmz", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => $a7b4049cb9844779$export$80c1c1cfdf49ec8a);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => $a7b4049cb9844779$export$2ffc1f557dddded2);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => $a7b4049cb9844779$export$d2c4b172b3db92fb);

var $bSJIT = parcelRequire("bSJIT");
const $a7b4049cb9844779$var$TriggerRefContext = /*#__PURE__*/ $bSJIT.createContext(null);
const $a7b4049cb9844779$export$80c1c1cfdf49ec8a = ({ children: children })=>{
    const triggerRef = $bSJIT.useRef(null);
    const setTriggerElement = $bSJIT.useCallback((element)=>{
        // Using a mutable ref pattern since we can't reassign .current on a RefObject
        triggerRef.current = element;
    }, []);
    const value = $bSJIT.useMemo(()=>({
            triggerRef: triggerRef,
            setTriggerElement: setTriggerElement
        }), [
        setTriggerElement
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($a7b4049cb9844779$var$TriggerRefContext.Provider, {
        value: value
    }, children);
};
const $a7b4049cb9844779$export$2ffc1f557dddded2 = ()=>{
    const context = $bSJIT.useContext($a7b4049cb9844779$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.triggerRef;
};
const $a7b4049cb9844779$export$d2c4b172b3db92fb = ()=>{
    const context = $bSJIT.useContext($a7b4049cb9844779$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.setTriggerElement;
};

});


parcelRegister("kWSHA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4u401").then(()=>parcelRequire('fdcyt'));

});


parcelRegister("V3xq2", function(module, exports) {
$parcel$export(module.exports, "default", () => $701db2694c5bca55$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $hwfis = parcelRequire("hwfis");

var $96XOb = parcelRequire("96XOb");

var $f6bzI = parcelRequire("f6bzI");

var $7QtFo = parcelRequire("7QtFo");

var $eTE4z = parcelRequire("eTE4z");

var $hkJWb = parcelRequire("hkJWb");

var $fKrkm = parcelRequire("fKrkm");

var $3n2Yr = parcelRequire("3n2Yr");

var $lxfCf = parcelRequire("lxfCf");

var $73RzG = parcelRequire("73RzG");

var $enb0I = parcelRequire("enb0I");

var $g57rj = parcelRequire("g57rj");

var $lWpQf = parcelRequire("lWpQf");

var $73YPr = parcelRequire("73YPr");

var $bD0Wq = parcelRequire("bD0Wq");

var $3MidK = parcelRequire("3MidK");

var $dlLeO = parcelRequire("dlLeO");

var $atlWs = parcelRequire("atlWs");

var $4e4Ls = parcelRequire("4e4Ls");

var $2Vs7t = parcelRequire("2Vs7t");

var $3V6PQ = parcelRequire("3V6PQ");

var $1l5zG = parcelRequire("1l5zG");
const $701db2694c5bca55$var$listenerMap = {
    [(0, $1l5zG.FabricChannel).a2ui]: (0, $hwfis.default),
    [(0, $1l5zG.FabricChannel).elements]: (0, $3n2Yr.default),
    [(0, $1l5zG.FabricChannel).editor]: (0, $fKrkm.default),
    [(0, $1l5zG.FabricChannel).atlaskit]: (0, $7QtFo.default),
    [(0, $1l5zG.FabricChannel).navigation]: (0, $lWpQf.default),
    [(0, $1l5zG.FabricChannel).media]: (0, $g57rj.default),
    [(0, $1l5zG.FabricChannel).peopleTeams]: (0, $3MidK.default),
    [(0, $1l5zG.FabricChannel).notifications]: (0, $73YPr.default),
    [(0, $1l5zG.FabricChannel).recentWork]: (0, $atlWs.default),
    [(0, $1l5zG.FabricChannel).atlas]: (0, $f6bzI.default),
    [(0, $1l5zG.FabricChannel).crossFlow]: (0, $hkJWb.default),
    [(0, $1l5zG.FabricChannel).linkingPlatform]: (0, $enb0I.default),
    [(0, $1l5zG.FabricChannel).postOffice]: (0, $dlLeO.default),
    [(0, $1l5zG.FabricChannel).aiMate]: (0, $96XOb.default),
    [(0, $1l5zG.FabricChannel).avp]: (0, $eTE4z.default),
    [(0, $1l5zG.FabricChannel).growth]: (0, $lxfCf.default),
    [(0, $1l5zG.FabricChannel).omniChannel]: (0, $bD0Wq.default),
    [(0, $1l5zG.FabricChannel).townsquareHome]: (0, $3V6PQ.default),
    [(0, $1l5zG.FabricChannel).rovoExtension]: (0, $4e4Ls.default),
    [(0, $1l5zG.FabricChannel).teamworkGraph]: (0, $2Vs7t.default)
};
class $701db2694c5bca55$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $73RzG.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($701db2694c5bca55$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$701db2694c5bca55$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Listener, {
                client: client,
                logger: this.logger
            }, prev), children);
        return listeners;
    }
}
var $701db2694c5bca55$export$2e2bcd8739ae039 = $701db2694c5bca55$var$FabricAnalyticsListeners;

});
parcelRegister("hwfis", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4bec59ff8b4a0c1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $bJ8PG = parcelRequire("bJ8PG");
function $b4bec59ff8b4a0c1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).a2ui,
        processEvent: (0, $bJ8PG.default)
    });
}

});
parcelRegister("elH2s", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd9dec95743534a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1w9as = parcelRequire("1w9as");

var $93ycG = parcelRequire("93ycG");
class $bcd9dec95743534a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $93ycG.sendEvent)(logger, client)(payload);
        };
    }
}

});
parcelRegister("93ycG", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $c5df843feb722c43$export$7329bcdc3edcd90e);
const $c5df843feb722c43$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $c5df843feb722c43$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($c5df843feb722c43$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});


parcelRegister("1l5zG", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $a4520b5e5a03bae3$export$8faa0b115ef0268b);
var $a4520b5e5a03bae3$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["a2ui"] = "a2ui";
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("bJ8PG", function(module, exports) {
$parcel$export(module.exports, "default", () => $015b0b0b5b35cb53$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $015b0b0b5b35cb53$var$A2UI_CONTEXT = 'a2ui';
const $015b0b0b5b35cb53$var$A2UI_TAG = 'a2ui';
const $015b0b0b5b35cb53$var$listenerVersion = undefined;
var /**
 * This util exists to convert A2UI analytics-next events into the analytics platform format.
 */ $015b0b0b5b35cb53$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, $015b0b0b5b35cb53$var$A2UI_CONTEXT);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, $015b0b0b5b35cb53$var$A2UI_CONTEXT);
    const components = (0, $27Iaf.getComponents)(event, $015b0b0b5b35cb53$var$A2UI_CONTEXT);
    const packages = (0, $lvgDo.getPackageInfo)(event, $015b0b0b5b35cb53$var$A2UI_CONTEXT);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(packages) ?? {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId, containerType: containerType, name: name, objectId: objectId, objectType: objectType, path: path, url: url } = event.payload;
    const attributes = {
        listenerVersion: $015b0b0b5b35cb53$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    tags.add($015b0b0b5b35cb53$var$A2UI_TAG);
    switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags),
                ...path && {
                    path: path
                },
                ...url && {
                    url: url
                }
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("jK5t1", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $11bf3883415abd27$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $11bf3883415abd27$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $11bf3883415abd27$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $11bf3883415abd27$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $11bf3883415abd27$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $11bf3883415abd27$export$a1562d08625f5d7e = 'ui';
const $11bf3883415abd27$export$947dac6c72b26f81 = 'track';
const $11bf3883415abd27$export$f1d537d508d2945a = 'screen';
const $11bf3883415abd27$export$12346a674644c156 = 'operational';
const $11bf3883415abd27$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("27Iaf", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $29ef18dc89921e98$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $gPklX = parcelRequire("gPklX");
const $29ef18dc89921e98$export$4e811121b221213b = (event, contextName)=>(0, $gPklX.extractFromEventContext)([
        'component',
        'componentName'
    ], event, false, contextName);

});
parcelRegister("gPklX", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $49c75687fd5a86d7$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $49c75687fd5a86d7$export$9b947b4502cd2705 = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);

});


parcelRegister("2CiDV", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $60ef496dccefa488$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $euGak = parcelRequire("euGak");

var $gPklX = parcelRequire("gPklX");
const $60ef496dccefa488$export$67c3590839ebecdd = (event, contextName)=>(0, $gPklX.extractFromEventContext)([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(result, extraAttributes), {});

});

parcelRegister("lvgDo", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $5a6d2748b62f35d7$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $5a6d2748b62f35d7$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);

});

parcelRegister("7J7JU", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $535721775ab3f4bd$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $gPklX = parcelRequire("gPklX");
const $535721775ab3f4bd$export$5f9bc633b116660f = (event, contextName)=>(0, $gPklX.extractFromEventContext)([
        'source'
    ], event, false, contextName);

});



parcelRegister("96XOb", function(module, exports) {
$parcel$export(module.exports, "default", () => $213a2e3d6440fc3e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $56ArH = parcelRequire("56ArH");
function $213a2e3d6440fc3e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).aiMate,
        processEvent: (0, $56ArH.default)
    });
}

});
parcelRegister("56ArH", function(module, exports) {
$parcel$export(module.exports, "default", () => $468ecff5d46cc1b4$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $3Rvdy = parcelRequire("3Rvdy");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $468ecff5d46cc1b4$var$AI_MATE_TAG = 'aiMate';
const $468ecff5d46cc1b4$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $468ecff5d46cc1b4$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $3Rvdy.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $3Rvdy.AI_MATE_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $3Rvdy.AI_MATE_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $3Rvdy.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $3Rvdy.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name, objectId: objectId, objectType: objectType, containerType: containerType, containerId: containerId, path: path, url: url } = event.payload;
    const attributes = {
        listenerVersion: $468ecff5d46cc1b4$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($468ecff5d46cc1b4$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags),
                ...path && {
                    path: path
                },
                ...url && {
                    url: url
                }
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("3Rvdy", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $fd4ca3084d533481$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $fd4ca3084d533481$export$de3826c30468da26);

var $9KZx5 = parcelRequire("9KZx5");
const $fd4ca3084d533481$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $fd4ca3084d533481$export$de3826c30468da26 = (0, $9KZx5.default)($fd4ca3084d533481$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});
parcelRegister("9KZx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf99d27161a69c75$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");
const $cf99d27161a69c75$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $cf99d27161a69c75$export$2e2bcd8739ae039 = $cf99d27161a69c75$var$createNamespaceContext;

});




parcelRegister("f6bzI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a14fd9c80ac5df9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $1Io3D = parcelRequire("1Io3D");
function $4a14fd9c80ac5df9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).atlas,
        processEvent: (0, $1Io3D.default)
    });
}

});
parcelRegister("1Io3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd5d620d52525384$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $7wIkc = parcelRequire("7wIkc");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $cd5d620d52525384$var$ATLAS_TAG = 'atlas';
const $cd5d620d52525384$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $cd5d620d52525384$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $7wIkc.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $7wIkc.ATLAS_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $7wIkc.ATLAS_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $7wIkc.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $7wIkc.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $cd5d620d52525384$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($cd5d620d52525384$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("7wIkc", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $177db7392c9828c5$export$4906017439f33fc0);

var $9KZx5 = parcelRequire("9KZx5");
const $177db7392c9828c5$export$4906017439f33fc0 = 'atlasCtx';
const $177db7392c9828c5$export$43ebbe41370d4543 = (0, $9KZx5.default)($177db7392c9828c5$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});



parcelRegister("7QtFo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ad43f6795193168$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $2pknv = parcelRequire("2pknv");
function $8ad43f6795193168$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).atlaskit,
        processEvent: (0, $2pknv.default)
    });
}

});
parcelRegister("2pknv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ead10cc40b925de1$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $gLyaY = parcelRequire("gLyaY");

var $3TNrz = parcelRequire("3TNrz");

var $egeOC = parcelRequire("egeOC");

var $3ZdT7 = parcelRequire("3ZdT7");

var $cET21 = parcelRequire("cET21");

var $9napQ = parcelRequire("9napQ");
const $ead10cc40b925de1$var$ATLASKIT_TAG = 'atlaskit';
const $ead10cc40b925de1$var$listenerVersion = undefined;
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $ead10cc40b925de1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $9napQ.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $egeOC.getExtraAttributes)(event);
    const components = (0, $3TNrz.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $cET21.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $ead10cc40b925de1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $3ZdT7.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($ead10cc40b925de1$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $jK5t1.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $gLyaY.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $jK5t1.TRACK_EVENT_TYPE) || eventType === (0, $jK5t1.OPERATIONAL_EVENT_TYPE) || eventType === (0, $jK5t1.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("gLyaY", function(module, exports) {
$parcel$export(module.exports, "getActionSubject", () => $8da558c711bc6d40$export$6f40cdf6d42c018d);
/**
 * Largely taken from analytics-web-react
 */ 
var $6nLPB = parcelRequire("6nLPB");
const $8da558c711bc6d40$export$6f40cdf6d42c018d = (event)=>{
    const overrides = (0, $6nLPB.extractFromEventContext)('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};

});
parcelRegister("6nLPB", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $93646d78f2f9a1b1$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $93646d78f2f9a1b1$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);

});


parcelRegister("3TNrz", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $961469cb5e24fa74$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $6nLPB = parcelRequire("6nLPB");
const $961469cb5e24fa74$export$4e811121b221213b = (event)=>(0, $6nLPB.extractFromEventContext)('component', event);

});

parcelRegister("egeOC", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $4474ed956108a998$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $euGak = parcelRequire("euGak");

var $6nLPB = parcelRequire("6nLPB");
const $4474ed956108a998$export$67c3590839ebecdd = (event)=>(0, $6nLPB.extractFromEventContext)('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(result, extraAttributes), {});

});

parcelRegister("3ZdT7", function(module, exports) {
$parcel$export(module.exports, "getPackageHierarchy", () => $d64d35ce3d1fc6e5$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $cET21 = parcelRequire("cET21");
function $d64d35ce3d1fc6e5$export$4e0b83da1896ebc7(event) {
    const packages = (0, $cET21.getPackageInfo)(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});
parcelRegister("cET21", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $d47509c123a50f49$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $d47509c123a50f49$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);

});


parcelRegister("9napQ", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $20427917b3d8b264$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $6nLPB = parcelRequire("6nLPB");
const $20427917b3d8b264$export$5f9bc633b116660f = (event)=>(0, $6nLPB.extractFromEventContext)('source', event);

});



parcelRegister("eTE4z", function(module, exports) {
$parcel$export(module.exports, "default", () => $86222de1f7650838$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $8p9rj = parcelRequire("8p9rj");
function $86222de1f7650838$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).avp,
        processEvent: (0, $8p9rj.default)
    });
}

});
parcelRegister("8p9rj", function(module, exports) {
$parcel$export(module.exports, "default", () => $52f9fa6ed892f891$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $96a4c = parcelRequire("96a4c");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $52f9fa6ed892f891$var$AVP_TAG = 'avp';
const $52f9fa6ed892f891$var$AVP_PLATFORM_TAG = 'analyticsVisualizationPlatform';
const $52f9fa6ed892f891$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $52f9fa6ed892f891$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $96a4c.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $96a4c.AVP_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $96a4c.AVP_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $96a4c.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $96a4c.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $52f9fa6ed892f891$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))({}, ...event.context)
    };
    // Put the registered platform tag first for product attribution, retaining the legacy tag.
    const tags = new Set([
        $52f9fa6ed892f891$var$AVP_PLATFORM_TAG,
        $52f9fa6ed892f891$var$AVP_TAG,
        ...event.payload.tags || []
    ]);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("96a4c", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $a1c6b75c47ba6e95$export$c2a811a4e42f4af5);

var $9KZx5 = parcelRequire("9KZx5");
const $a1c6b75c47ba6e95$export$c2a811a4e42f4af5 = 'avpCtx';
const $a1c6b75c47ba6e95$export$da383e8879a25b03 = (0, $9KZx5.default)($a1c6b75c47ba6e95$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});



parcelRegister("hkJWb", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb5217d702824ce1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $cYGPD = parcelRequire("cYGPD");
function $bb5217d702824ce1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).crossFlow,
        processEvent: (0, $cYGPD.default)
    });
}

});
parcelRegister("cYGPD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d303f76d662b6bc$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $jK5t1 = parcelRequire("jK5t1");

var $4i8UQ = parcelRequire("4i8UQ");

var $egeOC = parcelRequire("egeOC");

var $9napQ = parcelRequire("9napQ");

var $2CiDV = parcelRequire("2CiDV");
const $2d303f76d662b6bc$var$CROSS_FLOW_TAG = 'crossFlow';
var $2d303f76d662b6bc$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $9napQ.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $egeOC.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $2CiDV.getExtraAttributes)(event, (0, $4i8UQ.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($2d303f76d662b6bc$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("4i8UQ", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $3f9ffd9c0cd378ff$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $3f9ffd9c0cd378ff$export$d0a82da1a0b94929);

var $9KZx5 = parcelRequire("9KZx5");
const $3f9ffd9c0cd378ff$export$1fd3aad76a7c6788 = 'navigationCtx';
const $3f9ffd9c0cd378ff$export$d0a82da1a0b94929 = (0, $9KZx5.default)($3f9ffd9c0cd378ff$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});



parcelRegister("fKrkm", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $6678e610db916856$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $6678e610db916856$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1w9as = parcelRequire("1w9as");

var $1l5zG = parcelRequire("1l5zG");

var $hefJ3 = parcelRequire("hefJ3");
const $6678e610db916856$export$a1d9dc589a29b3aa = 'editor';
const $6678e610db916856$export$8aa0d788f94a809 = 'fabricEditor';
class $6678e610db916856$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $1l5zG.FabricChannel).editor
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $hefJ3.handleEvent)(event, [
                $6678e610db916856$export$a1d9dc589a29b3aa,
                $6678e610db916856$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("hefJ3", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $9c6564080dcdcb78$export$d6e5ca10785815df);

var $93ycG = parcelRequire("93ycG");

var $3FP8P = parcelRequire("3FP8P");
const $9c6564080dcdcb78$export$d6e5ca10785815df = (event, tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $3FP8P.processEventPayload)(event, tags);
    (0, $93ycG.sendEvent)(logger, client)(payload);
};

});
parcelRegister("3FP8P", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $fc4c3c28cfeaf84a$export$c37d638b7f2ca192);

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $3vqkd = parcelRequire("3vqkd");

var $hdAXu = parcelRequire("hdAXu");

var $fKrkm = parcelRequire("fKrkm");

var $3n2Yr = parcelRequire("3n2Yr");
const $fc4c3c28cfeaf84a$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(result, item), {});
const $fc4c3c28cfeaf84a$var$fieldExtractor = (contextKey)=>$fc4c3c28cfeaf84a$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $fc4c3c28cfeaf84a$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $3n2Yr.ELEMENTS_TAG:
            return 0, $hdAXu.ELEMENTS_CONTEXT;
        case 0, $fKrkm.EDITOR_TAG:
            return 0, $3vqkd.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $fc4c3c28cfeaf84a$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $jK5t1.DEFAULT_SOURCE),
        ...event.payload
    };
    const contextKey = $fc4c3c28cfeaf84a$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $fc4c3c28cfeaf84a$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $jK5t1.DEFAULT_SOURCE),
        ...fields,
        ...event.payload
    };
};
const $fc4c3c28cfeaf84a$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $fc4c3c28cfeaf84a$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $fc4c3c28cfeaf84a$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $fc4c3c28cfeaf84a$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$fc4c3c28cfeaf84a$var$updatePayloadWithContext(primaryTag, event),
        tags: $fc4c3c28cfeaf84a$var$addTags(tagsArray, event.payload.tags)
    };
};

});
parcelRegister("3vqkd", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $2bfe8e6841b34039$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $2bfe8e6841b34039$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $2bfe8e6841b34039$export$629cada6c5e621e1);

var $9KZx5 = parcelRequire("9KZx5");
const $2bfe8e6841b34039$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $2bfe8e6841b34039$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $2bfe8e6841b34039$export$629cada6c5e621e1 = (0, $9KZx5.default)($2bfe8e6841b34039$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("hdAXu", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $6403c15ea4ea228e$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $6403c15ea4ea228e$export$3fe25500478a635c);

var $9KZx5 = parcelRequire("9KZx5");
const $6403c15ea4ea228e$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $6403c15ea4ea228e$export$3fe25500478a635c = (0, $9KZx5.default)($6403c15ea4ea228e$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});

parcelRegister("3n2Yr", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $83dad8fab38c1781$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $83dad8fab38c1781$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1w9as = parcelRequire("1w9as");

var $1l5zG = parcelRequire("1l5zG");

var $hefJ3 = parcelRequire("hefJ3");
const $83dad8fab38c1781$export$ed71ae78997933a = 'fabricElements';
class $83dad8fab38c1781$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $1l5zG.FabricChannel).elements
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $hefJ3.handleEvent)(event, $83dad8fab38c1781$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("lxfCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e7ced3e942001c6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $dICGZ = parcelRequire("dICGZ");
function $5e7ced3e942001c6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).growth,
        processEvent: (0, $dICGZ.default)
    });
}

});
parcelRegister("dICGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $124a88f506d3269d$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $bemJH = parcelRequire("bemJH");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $124a88f506d3269d$var$GROWTH_TAG = 'growth';
const $124a88f506d3269d$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $124a88f506d3269d$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $bemJH.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $bemJH.GROWTH_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $bemJH.GROWTH_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $bemJH.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $bemJH.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $124a88f506d3269d$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($124a88f506d3269d$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("bemJH", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $fefa2e18b80527ba$export$82023f2f4bfb06c1);

var $9KZx5 = parcelRequire("9KZx5");
const $fefa2e18b80527ba$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $fefa2e18b80527ba$export$84980182680018f = (0, $9KZx5.default)($fefa2e18b80527ba$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});



parcelRegister("73RzG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf537ba37821cec$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $2bf537ba37821cec$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $2bf537ba37821cec$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $2bf537ba37821cec$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $2bf537ba37821cec$export$ffe0c436e29512cf.DEBUG && logLevel <= $2bf537ba37821cec$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $2bf537ba37821cec$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($2bf537ba37821cec$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($2bf537ba37821cec$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($2bf537ba37821cec$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($2bf537ba37821cec$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("enb0I", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7aea3aea1b2077a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $502fh = parcelRequire("502fh");
function $a7aea3aea1b2077a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).linkingPlatform,
        processEvent: (0, $502fh.default)
    });
}

});
parcelRegister("502fh", function(module, exports) {
$parcel$export(module.exports, "default", () => $27fe4a6a477d2e62$export$2e2bcd8739ae039);

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $iGLN4 = parcelRequire("iGLN4");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");

var $1l5zG = parcelRequire("1l5zG");
const $27fe4a6a477d2e62$var$listenerVersion = undefined;
var $27fe4a6a477d2e62$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $iGLN4.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $iGLN4.LINKING_PLATFORM_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $iGLN4.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $iGLN4.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1l5zG.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $27fe4a6a477d2e62$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});
parcelRegister("iGLN4", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $ade44549200a7ff0$export$3240443bf2b83834);

var $9KZx5 = parcelRequire("9KZx5");
const $ade44549200a7ff0$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $ade44549200a7ff0$export$6d568da622ce0a08 = (0, $9KZx5.default)($ade44549200a7ff0$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});



parcelRegister("g57rj", function(module, exports) {
$parcel$export(module.exports, "default", () => $28b1b7391428394b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $jWgHs = parcelRequire("jWgHs");
function $28b1b7391428394b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).media,
        processEvent: (0, $jWgHs.processEvent)
    });
}

});
parcelRegister("jWgHs", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $bc1444bc3198044c$export$22af68e3614bf024);

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $96Oa5 = parcelRequire("96Oa5");

var $6nLPB = parcelRequire("6nLPB");

var $3TNrz = parcelRequire("3TNrz");

var $egeOC = parcelRequire("egeOC");

var $3ZdT7 = parcelRequire("3ZdT7");

var $cET21 = parcelRequire("cET21");

var $9napQ = parcelRequire("9napQ");
const $bc1444bc3198044c$var$listenerVersion = undefined;
function $bc1444bc3198044c$var$getMediaContexts(event) {
    return (0, $6nLPB.extractFromEventContext)((0, $96Oa5.MEDIA_CONTEXT), event);
}
function $bc1444bc3198044c$var$getMediaRegion() {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $bc1444bc3198044c$export$22af68e3614bf024(event) {
    const sources = (0, $9napQ.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $cET21.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $egeOC.getExtraAttributes)(event);
    const mediaContexts = $bc1444bc3198044c$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($euGak)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $3TNrz.getComponents)(event);
    const mediaRegion = $bc1444bc3198044c$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $3ZdT7.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $bc1444bc3198044c$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});
parcelRegister("96Oa5", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $5aa6cd7dac855749$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5aa6cd7dac855749$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});



parcelRegister("lWpQf", function(module, exports) {
$parcel$export(module.exports, "default", () => $dec0c818e472de4c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $bC3u4 = parcelRequire("bC3u4");
function $dec0c818e472de4c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).navigation,
        processEvent: (0, $bC3u4.default)
    });
}

});
parcelRegister("bC3u4", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f636f5a8b0330af$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $4i8UQ = parcelRequire("4i8UQ");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $7f636f5a8b0330af$var$NAVIGATION_TAG = 'navigation';
const $7f636f5a8b0330af$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7f636f5a8b0330af$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $4i8UQ.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $4i8UQ.NAVIGATION_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $4i8UQ.NAVIGATION_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $4i8UQ.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $4i8UQ.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $7f636f5a8b0330af$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7f636f5a8b0330af$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("73YPr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e2839822ecd2a6e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $l7DFv = parcelRequire("l7DFv");
function $0e2839822ecd2a6e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).notifications,
        processEvent: (0, $l7DFv.default)
    });
}

});
parcelRegister("l7DFv", function(module, exports) {
$parcel$export(module.exports, "default", () => $99598101e046035b$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $9qrSu = parcelRequire("9qrSu");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");

var $1l5zG = parcelRequire("1l5zG");
const $99598101e046035b$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $99598101e046035b$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $9qrSu.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $9qrSu.NOTIFICATIONS_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $9qrSu.NOTIFICATIONS_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $9qrSu.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $9qrSu.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $99598101e046035b$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1l5zG.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("9qrSu", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $887123274bb76d1c$export$da1befb791e93c7e);

var $9KZx5 = parcelRequire("9KZx5");
const $887123274bb76d1c$export$da1befb791e93c7e = 'NotificationsCtx';
const $887123274bb76d1c$export$6f8e7ff1e3feafd7 = (0, $9KZx5.default)($887123274bb76d1c$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});



parcelRegister("bD0Wq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffea40baa7ab7323$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $jeluv = parcelRequire("jeluv");
const $ffea40baa7ab7323$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).omniChannel,
        processEvent: (0, $jeluv.default)
    });
};
var $ffea40baa7ab7323$export$2e2bcd8739ae039 = $ffea40baa7ab7323$var$OmniChannelAnalyticsListener;

});
parcelRegister("jeluv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e07c2056116bd989$export$2e2bcd8739ae039);

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $5T1Gt = parcelRequire("5T1Gt");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");

var $1l5zG = parcelRequire("1l5zG");
const $e07c2056116bd989$var$listenerVersion = undefined;
var $e07c2056116bd989$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $5T1Gt.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $5T1Gt.OMNI_CHANNEL_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $5T1Gt.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $5T1Gt.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $5T1Gt.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e07c2056116bd989$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1l5zG.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("5T1Gt", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $14e6f0e389c869e5$export$6d3c48fd1b3e4f3b);

var $9KZx5 = parcelRequire("9KZx5");
const $14e6f0e389c869e5$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $14e6f0e389c869e5$export$e4e6df99270bbbb1 = (0, $9KZx5.default)($14e6f0e389c869e5$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});



parcelRegister("3MidK", function(module, exports) {
$parcel$export(module.exports, "default", () => $498d06e30c060cdf$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $8Zdyo = parcelRequire("8Zdyo");
function $498d06e30c060cdf$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).peopleTeams,
        processEvent: (0, $8Zdyo.default)
    });
}

});
parcelRegister("8Zdyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f7553344b5f7627$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $3M4t9 = parcelRequire("3M4t9");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $1f7553344b5f7627$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $1f7553344b5f7627$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1f7553344b5f7627$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $3M4t9.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $3M4t9.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $3M4t9.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $3M4t9.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $3M4t9.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $1f7553344b5f7627$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1f7553344b5f7627$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("3M4t9", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $904771bf6f1f0ec3$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $904771bf6f1f0ec3$export$4119ddb38ccbfb87);

var $9KZx5 = parcelRequire("9KZx5");
const $904771bf6f1f0ec3$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $904771bf6f1f0ec3$export$4119ddb38ccbfb87 = (0, $9KZx5.default)($904771bf6f1f0ec3$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});



parcelRegister("dlLeO", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f1d7700d0e03452$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $i96v1 = parcelRequire("i96v1");
function $2f1d7700d0e03452$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).postOffice,
        processEvent: (0, $i96v1.default)
    });
}

});
parcelRegister("i96v1", function(module, exports) {
$parcel$export(module.exports, "default", () => $14d31dc825633be4$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $6HRWE = parcelRequire("6HRWE");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");

var $1l5zG = parcelRequire("1l5zG");
const $14d31dc825633be4$var$POST_OFFICE_TAG = (0, $1l5zG.FabricChannel).postOffice;
const $14d31dc825633be4$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $14d31dc825633be4$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $6HRWE.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $6HRWE.POST_OFFICE_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $6HRWE.POST_OFFICE_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $6HRWE.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $6HRWE.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $14d31dc825633be4$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($14d31dc825633be4$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("6HRWE", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $9220b3805c2b3acc$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $9220b3805c2b3acc$export$dcd232f3be312f94);

var $9KZx5 = parcelRequire("9KZx5");
const $9220b3805c2b3acc$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $9220b3805c2b3acc$export$dcd232f3be312f94 = (0, $9KZx5.default)($9220b3805c2b3acc$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});



parcelRegister("atlWs", function(module, exports) {
$parcel$export(module.exports, "default", () => $78455ba51660a4ea$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $bbNnP = parcelRequire("bbNnP");
function $78455ba51660a4ea$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).recentWork,
        processEvent: (0, $bbNnP.default)
    });
}

});
parcelRegister("bbNnP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c0519d1f991ce97$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $heoDf = parcelRequire("heoDf");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");

var $1l5zG = parcelRequire("1l5zG");
const $4c0519d1f991ce97$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4c0519d1f991ce97$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $heoDf.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $heoDf.RECENT_WORK_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $heoDf.RECENT_WORK_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $heoDf.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $heoDf.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4c0519d1f991ce97$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1l5zG.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("heoDf", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $aad062898f8141ce$export$fc7a65795610cb71);

var $9KZx5 = parcelRequire("9KZx5");
const $aad062898f8141ce$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $aad062898f8141ce$export$745926731087ebe2 = (0, $9KZx5.default)($aad062898f8141ce$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});



parcelRegister("4e4Ls", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0ab11b510491414$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $dCXOK = parcelRequire("dCXOK");
function $f0ab11b510491414$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).rovoExtension,
        processEvent: (0, $dCXOK.default)
    });
}

});
parcelRegister("dCXOK", function(module, exports) {
$parcel$export(module.exports, "default", () => $abd1bd606da0fe26$export$2e2bcd8739ae039);

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $fkhGn = parcelRequire("fkhGn");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $abd1bd606da0fe26$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $abd1bd606da0fe26$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $abd1bd606da0fe26$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $fkhGn.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $fkhGn.ROVO_EXTENSION_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $fkhGn.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $fkhGn.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $fkhGn.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $abd1bd606da0fe26$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($abd1bd606da0fe26$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("fkhGn", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $761caf9b58c3dfa1$export$fae437eb1dd9520c);

var $9KZx5 = parcelRequire("9KZx5");
const $761caf9b58c3dfa1$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $761caf9b58c3dfa1$export$7fcecc25ee38fbef = (0, $9KZx5.default)($761caf9b58c3dfa1$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});



parcelRegister("2Vs7t", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef6586c515010edd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $3JI5y = parcelRequire("3JI5y");
function $ef6586c515010edd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).teamworkGraph,
        processEvent: (0, $3JI5y.processEvent)
    });
}

});
parcelRegister("3JI5y", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $6571b72cc828c24a$export$22af68e3614bf024);

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $3TNrz = parcelRequire("3TNrz");

var $egeOC = parcelRequire("egeOC");

var $3ZdT7 = parcelRequire("3ZdT7");

var $cET21 = parcelRequire("cET21");

var $9napQ = parcelRequire("9napQ");
const $6571b72cc828c24a$var$listenerVersion = undefined;
function $6571b72cc828c24a$export$22af68e3614bf024(event) {
    const sources = (0, $9napQ.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $cET21.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $egeOC.getExtraAttributes)(event);
    const tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    const components = (0, $3TNrz.getComponents)(event);
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))({}, extraAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $3ZdT7.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $6571b72cc828c24a$var$listenerVersion
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("3V6PQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d571119d082186bb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $elH2s = parcelRequire("elH2s");

var $1l5zG = parcelRequire("1l5zG");

var $1ekyB = parcelRequire("1ekyB");
function $d571119d082186bb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elH2s.default), {
        ...props,
        channel: (0, $1l5zG.FabricChannel).townsquareHome,
        processEvent: (0, $1ekyB.default)
    });
}

});
parcelRegister("1ekyB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e0998e343fd20ee$export$2e2bcd8739ae039);

var $fbpGW = parcelRequire("fbpGW");

var $euGak = parcelRequire("euGak");

var $jK5t1 = parcelRequire("jK5t1");

var $lGTLg = parcelRequire("lGTLg");

var $27Iaf = parcelRequire("27Iaf");

var $2CiDV = parcelRequire("2CiDV");

var $lvgDo = parcelRequire("lvgDo");

var $7J7JU = parcelRequire("7J7JU");
const $6e0998e343fd20ee$var$TOWNSQUARE_TAG = 'townsquare';
const $6e0998e343fd20ee$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $6e0998e343fd20ee$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $6e0998e343fd20ee$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $7J7JU.getSources)(event, (0, $lGTLg.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(sources) || (0, $jK5t1.DEFAULT_SOURCE);
    const extraAttributes = (0, $2CiDV.getExtraAttributes)(event, (0, $lGTLg.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $27Iaf.getComponents)(event, (0, $lGTLg.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $lvgDo.getPackageInfo)(event, (0, $lGTLg.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))((0, $lvgDo.getPackageInfo)(event, (0, $lGTLg.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $jK5t1.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $6e0998e343fd20ee$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($6e0998e343fd20ee$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($6e0998e343fd20ee$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $jK5t1.UI_EVENT_TYPE:
        case 0, $jK5t1.OPERATIONAL_EVENT_TYPE:
        case 0, $jK5t1.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $jK5t1.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("lGTLg", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $da260eb0e26b3d66$export$aa18ab4fff926c9e);

var $9KZx5 = parcelRequire("9KZx5");
const $da260eb0e26b3d66$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $da260eb0e26b3d66$export$d283110f5d85c8f2 = (0, $9KZx5.default)($da260eb0e26b3d66$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});




parcelRegister("5Z3B8", function(module, exports) {
$parcel$export(module.exports, "setAccountMetaTag", () => $25824c5cc2b51d6b$export$3ffe5752aad15e0d);

var $4ZMmh = parcelRequire("4ZMmh");

var $iRD29 = parcelRequire("iRD29");

var $fuVmc = parcelRequire("fuVmc");
const $25824c5cc2b51d6b$export$3ffe5752aad15e0d = (isAtlassianManaged, accountId)=>{
    if (!accountId) return;
    const accountTypeMeta = (0, $fuVmc.getMetaFromHTML)('ajs-account-type');
    const accountIdMeta = (0, $fuVmc.getMetaFromHTML)('ajs-atlassian-account-id');
    if (!(0, $4ZMmh.isNil)(accountTypeMeta) && !(0, $4ZMmh.isNil)(accountIdMeta) && accountIdMeta === accountId) return;
    (0, $fuVmc.setHTMLMeta)('ajs-atlassian-account-id', accountId);
    (0, $fuVmc.setHTMLMeta)('account-id', accountId);
    if (isAtlassianManaged) (0, $fuVmc.setHTMLMeta)('ajs-account-type', 'atlassian');
    else (0, $fuVmc.setHTMLMeta)('ajs-account-type', 'customer');
    (0, $iRD29.updateUserInfo)(accountId);
};

});

parcelRegister("3wXsr", function(module, exports) {
$parcel$export(module.exports, "CustomDomainsAnalyticsProvider", () => $2ccd97e6cc19c6f3$export$8bf41bf02d1555eb);

var $bSJIT = parcelRequire("bSJIT");

var $haAAx = parcelRequire("haAAx");
const $2ccd97e6cc19c6f3$export$8bf41bf02d1555eb = ({ children: children, baseUrl: baseUrl })=>{
    const atlassianDomains = [
        'atlassian.net',
        'jira-dev.com',
        'atlassian.com',
        'jira.com',
        'atl-paas.net',
        'trello.com',
        'bitbucket.org'
    ];
    if (atlassianDomains.some((domain)=>baseUrl.toLowerCase().includes(domain))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $haAAx.AnalyticsContext), {
        attributes: {
            isCustomDomain: false
        }
    }, children);
    const customDomain = new URL(baseUrl).hostname;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $haAAx.AnalyticsContext), {
        attributes: {
            customDomain: customDomain,
            isCustomDomain: true
        }
    }, children);
};

});

parcelRegister("hvyCD", function(module, exports) {
$parcel$export(module.exports, "default", () => $15c75fa0047b6bbb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $haAAx = parcelRequire("haAAx");
const $15c75fa0047b6bbb$var$extractFlags = ()=>Object.entries($lFpPv).reduce((acc, [key, value])=>{
        if (typeof value !== 'function') return acc;
        return {
            ...acc,
            [key]: value()
        };
    }, {});
const $15c75fa0047b6bbb$var$FeatureFlagContext = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $haAAx.AnalyticsContext), {
        attributes: $15c75fa0047b6bbb$var$extractFlags()
    }, children);
var $15c75fa0047b6bbb$export$2e2bcd8739ae039 = $15c75fa0047b6bbb$var$FeatureFlagContext;

});

parcelRegister("3bY4T", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsContext", () => $af40e4f451d59aed$export$156073b6afb2624e);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $dJymo = parcelRequire("dJymo");
const $af40e4f451d59aed$var$selector = (state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    const attributes = (0, $iWhHo.getPortalAnalyticAttributes)(state, portalId);
    return {
        attributes: attributes
    };
};
const $af40e4f451d59aed$export$156073b6afb2624e = (0, $f2mlD.default)($af40e4f451d59aed$var$selector)((0, $dJymo.default));

});
parcelRegister("dJymo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f614645d10ad1ce2$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $haAAx = parcelRequire("haAAx");
const $f614645d10ad1ce2$var$PortalContext = ({ children: children, attributes: attributes })=>/*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
        sourceName: "portalUnknown",
        sourceType: (0, $haAAx.ScreenTypes).SCREEN,
        attributes: {
            context: 'Portal',
            ...attributes
        }
    }, children);
var $f614645d10ad1ce2$export$2e2bcd8739ae039 = $f614645d10ad1ce2$var$PortalContext;

});


parcelRegister("7WD1V", function(module, exports) {
$parcel$export(module.exports, "withCoordinationClient", () => $4fb93c08850f6526$export$eeb046361df75e84);
$parcel$export(module.exports, "default", () => $4fb93c08850f6526$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $fuVmc = parcelRequire("fuVmc");

var $90RSm = parcelRequire("90RSm");

var $a6ENB = parcelRequire("a6ENB");
const $4fb93c08850f6526$export$a91cdb60d3cc20e2 = /*#__PURE__*/ $bSJIT.createContext({
    coordinationClient: undefined
});

const $4fb93c08850f6526$var$CoordinationClientProvider = ({ cloudId: cloudId, children: children })=>{
    const [coordinationClient, setCoordinationClient] = $bSJIT.useState(undefined);
    $bSJIT.useEffect(()=>{
        (0, $90RSm.promiseWithRetries)(()=>(parcelRequire("5QQoK"))).then((module)=>{
            setCoordinationClient(new module.CoordinationClient(cloudId, '/gateway/api'));
        }).catch((error)=>{
            (0, $a6ENB.reportError)(error);
        });
    }, [
        cloudId
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($4fb93c08850f6526$export$a91cdb60d3cc20e2.Provider, {
        value: {
            coordinationClient: coordinationClient
        }
    }, children);
};
const $4fb93c08850f6526$export$eeb046361df75e84 = (InnerComponent)=>{
    const Component = (props)=>{
        const { coordinationClient: coordinationClient } = $bSJIT.useContext($4fb93c08850f6526$export$a91cdb60d3cc20e2);
        return /*#__PURE__*/ $bSJIT.createElement(InnerComponent, {
            ...props,
            coordinationClient: coordinationClient
        });
    };
    return Component;
};
const $4fb93c08850f6526$var$mapStateToProps = ()=>{
    return {
        cloudId: (0, $fuVmc.getMeta)('tenant-id')
    };
};
var $4fb93c08850f6526$export$2e2bcd8739ae039 = (0, $f2mlD.default)($4fb93c08850f6526$var$mapStateToProps)($4fb93c08850f6526$var$CoordinationClientProvider);

});
parcelRegister("90RSm", function(module, exports) {
$parcel$export(module.exports, "promiseWithRetries", () => $cdb72956d6c0ea50$export$e27278bd94558912);
const $cdb72956d6c0ea50$var$DEFAULT_TIMEOUT_MS = 1000;
const $cdb72956d6c0ea50$var$DEFAULT_NUMBER_OF_RETRIES = 3;
const $cdb72956d6c0ea50$var$delay = (timeMs)=>new Promise((resolve)=>setTimeout(resolve, timeMs));
const $cdb72956d6c0ea50$export$e27278bd94558912 = (promise, config = {})=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { numberOfRetries: numberOfRetries = $cdb72956d6c0ea50$var$DEFAULT_NUMBER_OF_RETRIES, timeoutMs: timeoutMs = $cdb72956d6c0ea50$var$DEFAULT_TIMEOUT_MS, error: error = null } = config;
    if (numberOfRetries <= 0) return Promise.reject(error);
    return promise().catch((promiseError)=>$cdb72956d6c0ea50$var$delay(timeoutMs).then(()=>// Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            $cdb72956d6c0ea50$export$e27278bd94558912(promise, {
                ...config,
                numberOfRetries: numberOfRetries - 1,
                error: promiseError
            })));
};

});

parcelRegister("5QQoK", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("7bN6G"),
    $kOunM("bQ3G9"),
    $kOunM("73mdv")
]).then(()=>parcelRequire('h0NmH'));

});


parcelRegister("c8MAW", function(module, exports) {
$parcel$export(module.exports, "default", () => $558640f66e876567$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $7AirO = parcelRequire("7AirO");
const $558640f66e876567$var$selector = (0, $BOq7h.createSelector)((0, $fBLyB.getLocale), (locale)=>({
        locale: locale
    }));
var $558640f66e876567$export$2e2bcd8739ae039 = (0, $f2mlD.default)($558640f66e876567$var$selector)((0, $7AirO.DeferredWrmResourceProvider));

});
parcelRegister("7AirO", function(module, exports) {
$parcel$export(module.exports, "DeferredWrmResourceContext", () => $004db0d77cbc1e10$export$266fd8d1fd8c9019);
$parcel$export(module.exports, "DeferredWrmResourceProvider", () => $004db0d77cbc1e10$export$f1f3f896300d60a3);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $ePuyT = parcelRequire("ePuyT");

var $bB37A = parcelRequire("bB37A");
const $004db0d77cbc1e10$export$266fd8d1fd8c9019 = /*#__PURE__*/ $bSJIT.createContext({
    resourcesLoaded: false,
    setResourcesLoaded: (0, $4ZMmh.noop)
});
const $004db0d77cbc1e10$var$DEFERRED_WRM_CONTEXT = [
    'deferred.customer.portal.wrm'
];
const $004db0d77cbc1e10$var$getDeferredWrmContexts = (0, $ePuyT.default)((locale)=>[
        ...$004db0d77cbc1e10$var$DEFERRED_WRM_CONTEXT,
        `jira.webresources:calendar-${locale}`
    ]);
const $004db0d77cbc1e10$export$f1f3f896300d60a3 = ({ children: children, locale: locale })=>{
    const [resourcesLoaded, setLoaded] = $bSJIT.useState(false);
    const setResourcesLoaded = $bSJIT.useCallback(()=>{
        setLoaded(true);
    }, [
        setLoaded
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($004db0d77cbc1e10$export$266fd8d1fd8c9019.Provider, {
        value: {
            resourcesLoaded: resourcesLoaded,
            setResourcesLoaded: setResourcesLoaded
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $bB37A.default), {
        onResourcesLoaded: setResourcesLoaded,
        resourceKeys: $004db0d77cbc1e10$var$getDeferredWrmContexts(locale)
    }), children);
};

});
parcelRegister("ePuyT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b4780f7bd2dd9d5$export$2e2bcd8739ae039);
/**
 * Copied from https://github.com/alexreardon/memoize-one/tree/master/src
 *
 *
 * Delete this folder when https://github.com/alexreardon/memoize-one/issues/37 is resolved and we can use the package directly
 * turning on esModuleInterop breaks a whole bunch of other tests, so for now this is the least intrusive workaround to get this utility
 *
 */ function $6b4780f7bd2dd9d5$var$areInputsEqual(newInputs, lastInputs) {
    // no checks needed if the inputs length has changed
    if (newInputs.length !== lastInputs.length) return false;
    // Using for loop for speed. It generally performs better than array.every
    // https://github.com/alexreardon/memoize-one/pull/59
    for(let i = 0; i < newInputs.length; i++){
        // using shallow equality check
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $6b4780f7bd2dd9d5$export$2e2bcd8739ae039(resultFn, isEqual = $6b4780f7bd2dd9d5$var$areInputsEqual) {
    let lastThis;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    // breaking cache when context (this) or arguments change
    function memoized(...newArgs) {
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        // Throwing during an assignment aborts the assignment: https://codepen.io/alexreardon/pen/RYKoaz
        // Doing the lastResult assignment first so that if it throws
        // nothing will be overwritten
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        // @typescript-eslint upgrade to v5.61.0
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

});

parcelRegister("bB37A", function(module, exports) {
$parcel$export(module.exports, "default", () => $47a18ea8b5364848$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $jBiia = parcelRequire("jBiia");

var $gEVth = parcelRequire("gEVth");

var $87qRG = parcelRequire("87qRG");
const $47a18ea8b5364848$var$createScriptResource = (url)=>Object.assign(document.createElement('script'), {
        type: 'text/javascript',
        charset: 'utf-8',
        async: true,
        src: url
    });
const $47a18ea8b5364848$var$createCssResource = (url)=>Object.assign(document.createElement('link'), {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });
const $47a18ea8b5364848$var$createResource = (resourceDescriptor)=>{
    const { resourceType: resourceType, url: url } = resourceDescriptor;
    if (resourceType === 'CSS') return $47a18ea8b5364848$var$createCssResource(url);
    return $47a18ea8b5364848$var$createScriptResource(url);
};
const $47a18ea8b5364848$var$loadResources = (0, $4ZMmh.once)((wrmResources, unparsedData)=>{
    window.WRM = {
        _unparsedData: {
            ...unparsedData
        }
    };
    const resources = wrmResources.map((resource)=>new Promise((resolve)=>{
            resource.onload = ()=>{
                resolve();
            };
            resource.onerror = (error)=>{
                (0, $jBiia.trackError)(`deferred.wrm.resource.load.failed`, {}, error.message);
                (0, $gEVth.operationalEvent)({
                    action: 'failed',
                    actionSubject: 'loadWrmResources',
                    source: 'unknownSource',
                    attributes: {
                        errorMessage: error.message
                    }
                });
            };
            document.head.appendChild(resource);
        }));
    return Promise.all(resources);
});
const $47a18ea8b5364848$var$WrmModuleLoader = ({ onResourcesLoaded: onResourcesLoaded, resourceKeys: resourceKeys })=>{
    const asyncWrmRequire = $bSJIT.useCallback(async ()=>{
        try {
            const { unparsedData: unparsedData, resources: resourceDescriptors } = await (0, $87qRG.fetchWrmResourceDescriptors)(resourceKeys);
            const wrmResources = resourceDescriptors.map((resourceDescriptor)=>$47a18ea8b5364848$var$createResource(resourceDescriptor));
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $47a18ea8b5364848$var$loadResources(wrmResources, unparsedData).then(()=>{
                onResourcesLoaded();
            });
        } catch (e) {
            (0, $jBiia.trackError)('fetchWrmResourceDescriptors.fetch.failed', {}, e);
            (0, $gEVth.operationalEvent)({
                action: 'failed',
                actionSubject: 'fetchWrmResourceDescriptors',
                source: 'unknownSource',
                attributes: {
                    resourceKeys: resourceKeys,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    errorMessage: e.message
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (0, $87qRG.fetchWrmResourceDescriptors)
    ]);
    $bSJIT.useEffect(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        asyncWrmRequire();
    }, [
        asyncWrmRequire
    ]);
    return null;
};
var $47a18ea8b5364848$export$2e2bcd8739ae039 = $47a18ea8b5364848$var$WrmModuleLoader;

});
parcelRegister("87qRG", function(module, exports) {
$parcel$export(module.exports, "fetchWrmResourceDescriptors", () => $15565997edad2da3$export$25121547929106be);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $15565997edad2da3$var$getRequestBody = ({ webResources: webResources = [], contexts: contexts = [], excludedContexts: excludedContexts = [], excludedWebResources: excludedWebResources = [] })=>({
        r: webResources,
        c: contexts,
        xc: excludedContexts,
        xr: excludedWebResources
    });
const $15565997edad2da3$export$25121547929106be = (resources)=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/webResources/1.0/resources`;
    const body = $15565997edad2da3$var$getRequestBody({
        contexts: resources
    });
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise().catch((e)=>Promise.reject(e));
};

});




parcelRegister("f5fLA", function(module, exports) {
$parcel$export(module.exports, "MetaDataProvider", () => (parcelRequire("9fGWB")).default);

var $9fGWB = parcelRequire("9fGWB");

var $2Td4X = parcelRequire("2Td4X");

});
parcelRegister("9fGWB", function(module, exports) {
$parcel$export(module.exports, "default", () => $55863d1dfea2744a$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("b8PDJ");
var $5ESvo = parcelRequire("5ESvo");
parcelRequire("bYzAz");
var $dhxdT = parcelRequire("dhxdT");

var $2Td4X = parcelRequire("2Td4X");
const $55863d1dfea2744a$var$mapDispatchToProps = {
    updateEnvAction: $5ESvo.updateEnvAction,
    updateMetaAction: $dhxdT.updateMetaAction
};
var $55863d1dfea2744a$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, $55863d1dfea2744a$var$mapDispatchToProps)((0, $2Td4X.default));

});



parcelRegister("kKBZy", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => (parcelRequire("4GSP0")).default);

var $4GSP0 = parcelRequire("4GSP0");

});
parcelRegister("4GSP0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c0cd0257ef64214$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dJZiw = parcelRequire("dJZiw");

var $hN0ua = parcelRequire("hN0ua");

var $5cKiX = parcelRequire("5cKiX");

var $kKHso = parcelRequire("kKHso");

var $7WQx2 = parcelRequire("7WQx2");

var $aRsbV = parcelRequire("aRsbV");

var $hYh8H = parcelRequire("hYh8H");

var $k4dp8 = parcelRequire("k4dp8");
const $3c0cd0257ef64214$var$GenericErrorPage = ({ title: title, message: message, hideFooter: hideFooter })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $hN0ua.Root), null, /*#__PURE__*/ $bSJIT.createElement((0, $hN0ua.Container), null, /*#__PURE__*/ $bSJIT.createElement((0, $hN0ua.PageErrorIcon), null), /*#__PURE__*/ $bSJIT.createElement((0, $hN0ua.MessageContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
            space: "space.200",
            alignInline: "center"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
            size: "xlarge"
        }, title ? title : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $dJZiw.default).errorTitle)), /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), {
            align: "center"
        }, message ? message : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $dJZiw.default).errorMessage)))
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hN0ua.ErrorMessage), null, title ? title : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $dJZiw.default).errorTitle)), /*#__PURE__*/ $bSJIT.createElement((0, $hN0ua.HelpText), null, message ? message : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $dJZiw.default).errorMessage))))), !hideFooter && /*#__PURE__*/ $bSJIT.createElement((0, $kKHso.Footer), null));
};
var $3c0cd0257ef64214$export$2e2bcd8739ae039 = $3c0cd0257ef64214$var$GenericErrorPage;

});
parcelRegister("dJZiw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae2d8cf6587c5910$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ae2d8cf6587c5910$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorTitle: {
        defaultMessage: "We're on it",
        description: 'Error title to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.title'
    },
    errorMessage: {
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'Error message to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.message'
    }
});

});

parcelRegister("hN0ua", function(module, exports) {
$parcel$export(module.exports, "Root", () => $bf38b0e1577e4366$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Container", () => $bf38b0e1577e4366$export$42a852a2b6b56249);
$parcel$export(module.exports, "ErrorMessage", () => $bf38b0e1577e4366$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "HelpText", () => $bf38b0e1577e4366$export$a67c0bc59081311a);
$parcel$export(module.exports, "MessageContainer", () => $bf38b0e1577e4366$export$616d763e306cba45);
$parcel$export(module.exports, "PageErrorIcon", () => $bf38b0e1577e4366$export$4e475cfbf52c9b29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $f3CQw = parcelRequire("f3CQw");
const $bf38b0e1577e4366$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16pz4j-0"
})`${$fU62V.flexCenter};height:100%;flex:1 1 auto;flex-direction:column;`;
const $bf38b0e1577e4366$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16pz4j-1"
})`${$fU62V.flexCenter};flex:1 1 auto;flex-direction:column;margin-bottom:${"var(--ds-space-800, 64px)"};padding-bottom:${"var(--ds-space-100, 8px)"};`;
const $bf38b0e1577e4366$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $4v2A7.default).h1.withConfig({
    componentId: "sc-16pz4j-2"
})`${$98sDU.h800};`;
const $bf38b0e1577e4366$export$a67c0bc59081311a = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-16pz4j-3"
})`margin-top:${"var(--ds-space-200, 16px)"};`;
const $bf38b0e1577e4366$export$616d763e306cba45 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16pz4j-4"
})`text-align:center;padding:0 ${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-300, 24px)"};max-width:${$9K7mZ.multiple(53).px};`;
const $bf38b0e1577e4366$export$4e475cfbf52c9b29 = /*#__PURE__*/ (0, $4v2A7.default)((0, $f3CQw.default)).withConfig({
    componentId: "sc-16pz4j-5"
})`width:${$9K7mZ.multiple(34).px};`;

});
parcelRegister("98sDU", function(module, exports) {
$parcel$export(module.exports, "small", () => $fd03de8dde33c3d9$export$3c17b0e969a90510);
$parcel$export(module.exports, "regular", () => $fd03de8dde33c3d9$export$28a535dd448ffda4);
$parcel$export(module.exports, "medium", () => $fd03de8dde33c3d9$export$649ecc744817b5c7);
$parcel$export(module.exports, "mediumLarge", () => $fd03de8dde33c3d9$export$eab9f63b1324bb90);
$parcel$export(module.exports, "xsmall", () => $fd03de8dde33c3d9$export$53e73bcd5097e50d);
$parcel$export(module.exports, "h800", () => $fd03de8dde33c3d9$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $fd03de8dde33c3d9$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $fd03de8dde33c3d9$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $fd03de8dde33c3d9$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $fd03de8dde33c3d9$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $fd03de8dde33c3d9$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $fd03de8dde33c3d9$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $fd03de8dde33c3d9$export$dfc0e69214efdc3c);
/* eslint-disable @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css -- Disabled to upgrade atlaskit/theme */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
const $fd03de8dde33c3d9$export$3c17b0e969a90510 = /*#__PURE__*/ (0, $4v2A7.css)`font-size:12px;`;
const $fd03de8dde33c3d9$export$28a535dd448ffda4 = /*#__PURE__*/ (0, $4v2A7.css)`font-size:14px;`;
const $fd03de8dde33c3d9$export$649ecc744817b5c7 = /*#__PURE__*/ (0, $4v2A7.css)`font-size:16px;`;
const $fd03de8dde33c3d9$export$eab9f63b1324bb90 = /*#__PURE__*/ (0, $4v2A7.css)`font-size:18px;`;
const $fd03de8dde33c3d9$export$53e73bcd5097e50d = /*#__PURE__*/ (0, $4v2A7.css)`font-size:11px;`;
const $fd03de8dde33c3d9$export$3953fb6fbd158d23 = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '2.071em',
    fontStyle: 'inherit',
    lineHeight: 1.103
});
const $fd03de8dde33c3d9$export$e4f993a313607daa = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '1.714em',
    fontStyle: 'inherit',
    lineHeight: 1.167
});
const $fd03de8dde33c3d9$export$1e8b2acea3fb3119 = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/use-tokens-space
    marginTop: '28px',
    fontSize: '1.429em',
    fontStyle: 'inherit',
    lineHeight: 1.2
});
const $fd03de8dde33c3d9$export$85aa43a9b9f06707 = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    marginTop: "var(--ds-space-300, 24px)",
    fontSize: '1.143em',
    fontStyle: 'inherit',
    lineHeight: 1.25
});
const $fd03de8dde33c3d9$export$fcb7764b80bd908f = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '1em',
    fontStyle: 'inherit',
    lineHeight: 1.143
});
const $fd03de8dde33c3d9$export$a0e59c3bbc05e815 = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-250, 20px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333,
    textTransform: 'uppercase'
});
const $fd03de8dde33c3d9$export$7ccf32eb2150ac7e = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333
});
const $fd03de8dde33c3d9$export$dfc0e69214efdc3c = /*#__PURE__*/ (0, $4v2A7.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.786em',
    fontStyle: 'inherit',
    lineHeight: 1.455
});

});

parcelRegister("f3CQw", function(module, exports) {
$parcel$export(module.exports, "default", () => $baa4888fdc786db1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $baa4888fdc786db1$var$SvgPageerrorreact = (props)=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 244.1 215.54",
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient",
        x1: 161.63,
        y1: 110.9,
        x2: 64.3,
        y2: 156.29,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-2",
        x1: 14.8,
        y1: 230.34,
        x2: 229.01,
        y2: 16.13,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0,
        stopColor: "#c1c7d0"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 1,
        stopColor: "#fafbfc"
    })), /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-3",
        x1: 44.97,
        y1: 136.36,
        x2: 187.42,
        y2: -6.09,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0,
        stopColor: "#fafbfc",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0.82,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-4",
        x1: 68.71,
        y1: 188.85,
        x2: 148.65,
        y2: 108.91,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0,
        stopColor: "#ebecf0",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 1,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "page_error_react_svg__clip-path"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "page_error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    })), /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "page_error_react_svg__clip-path-2"
    }, /*#__PURE__*/ $bSJIT.createElement("rect", {
        id: "page_error_react_svg___Rectangle_",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    })), /*#__PURE__*/ $bSJIT.createElement("style", null, ".page_error_react_svg__cls-1{fill:#fff}.page_error_react_svg__cls-2{fill:url(#page_error_react_svg__linear-gradient)}.page_error_react_svg__cls-7{fill:#253858}.page_error_react_svg__cls-15{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $bSJIT.createElement("g", {
        style: {
            isolation: "isolate"
        }
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        id: "page_error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        id: "page_error_react_svg__Software"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "page_error_react_svg___Rectangle_2",
        "data-name": "<Rectangle>",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-2)"
        },
        d: "M0 30.92h243.81v184.62H0z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        style: {
            fill: "#ebecf0"
        },
        d: "M0 30.92h243.81v19.67H0z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M244.1 67.68c-69.18-6-108.85.91-132.52 8.71-4.66 1.53-10.66 3.75-20.52 6.35-35.63 9.41-68.6 9.94-90.77 8.93V50.59H244.1Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-3)",
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("circle", {
        className: "page_error_react_svg__cls-7",
        cx: 15.69,
        cy: 40.69,
        r: 5.11
    }), /*#__PURE__*/ $bSJIT.createElement("circle", {
        cx: 32.37,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#a5adba"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("circle", {
        cx: 49.05,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#0065ff"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("rect", {
        id: "page_error_react_svg___Rectangle_3",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    }), /*#__PURE__*/ $bSJIT.createElement("g", {
        style: {
            clipPath: "url(#page_error_react_svg__clip-path-2)"
        }
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "page_error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        d: "m118 78.83 47.32 82A10.81 10.81 0 0 1 156 177H61.36A10.81 10.81 0 0 1 52 160.8l47.32-82a10.81 10.81 0 0 1 18.68.03Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-4)",
            mixBlendMode: "multiply"
        }
    })), /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "page_error_react_svg___Polygon_3",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "page_error_react_svg__cls-7",
        d: "m128.41 130.33 2.05-31.59a6.54 6.54 0 0 0-6.53-7 6.54 6.54 0 0 0-6.53 7l2.05 31.59a4.49 4.49 0 0 0 4.48 4.2 4.49 4.49 0 0 0 4.48-4.2ZM117.13 147.1a6.79 6.79 0 0 0 7.4 6.82 6.89 6.89 0 0 0-.64-13.76 6.87 6.87 0 0 0-6.76 6.94Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M134.17 26.76 126.87.44a.6.6 0 0 0-1.17.05l-4.59 24.72-5.71-1.06a.6.6 0 0 0-.69.75L122 51.23a.6.6 0 0 0 1.17-.05l4.59-24.72 5.71 1.06a.6.6 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "m108 41.19-10.73-8.43a.26.26 0 0 0-.4.32l5.44 11.26-2.62 1.27a.26.26 0 0 0 0 .45l10.71 8.42a.26.26 0 0 0 .4-.32l-5.49-11.26 2.62-1.27a.26.26 0 0 0 .07-.44Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M157.26 36c-1.15 1.57-10.83-5.52-12-3.95s8.53 8.66 7.38 10.23-10.83-5.52-12-3.94 8.53 8.66 7.38 10.23-10.84-5.51-12-3.94 8.53 8.66 7.38 10.24",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "page_error_react_svg__cls-15",
        d: "M162 63.22c-1.44 1.31-6.95-4.71-8.38-3.39s4.07 7.34 2.63 8.65-6.95-4.71-8.38-3.39c-.67.61.16 2.23 1.1 3.93M88 63.09c1.79.76 5-6.77 6.76-6s-1.37 8.28.42 9 5-6.77 6.76-6c.83.35.6 2.16.29 4.07"
    })))));
var $baa4888fdc786db1$export$2e2bcd8739ae039 = $baa4888fdc786db1$var$SvgPageerrorreact;

});


parcelRegister("kKHso", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $18524b2d19b18e6e$export$a06f1c675e846f6f);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");

var $5KeOK = parcelRequire("5KeOK");
const $18524b2d19b18e6e$var$selector = (0, $BOq7h.createSelector)((0, $fOlM6.getWacLink), (linkTo)=>({
        linkTo: linkTo
    }));
const $18524b2d19b18e6e$export$a06f1c675e846f6f = (0, $f2mlD.default)($18524b2d19b18e6e$var$selector)((0, $5KeOK.default));

});
parcelRegister("5KeOK", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0ba4c8fbf7a5722$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $53Khx = parcelRequire("53Khx");

var $lFpPv = parcelRequire("lFpPv");

var $98sDU = parcelRequire("98sDU");

var $9Yqiu = parcelRequire("9Yqiu");

var $8rlxZ = parcelRequire("8rlxZ");

var $5cKiX = parcelRequire("5cKiX");

var $dwOcU = parcelRequire("dwOcU");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $cT7mi = parcelRequire("cT7mi");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $b8UFi = parcelRequire("b8UFi");

var $hKa9R = parcelRequire("hKa9R");
const $a0ba4c8fbf7a5722$var$Footer = ({ linkTo: linkTo, className: className, isCSM: isCSM })=>{
    // isCSM check is used for generating correct footer in CSMRequest Type Previews
    const showCSMFooter = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) || isCSM;
    const renderWacFooterLink = ()=>{
        const footerLink = /*#__PURE__*/ $bSJIT.createElement($a0ba4c8fbf7a5722$var$FooterLink, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation",
            target: "_blank",
            rel: "noopener noreferrer",
            href: linkTo,
            actionSubjectId: "waclink"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
            ...(0, $b8UFi.default).footer,
            values: {
                iconHtml: /*#__PURE__*/ $bSJIT.createElement($a0ba4c8fbf7a5722$var$FooterJsdIcon, null)
            }
        }));
        return (0, $lFpPv.isFooterCookiePreferencesEnabled)() ? /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, footerLink, /*#__PURE__*/ $bSJIT.createElement((0, $cT7mi.CookiePreferencesButton), {
            isInClassicHelpCenter: true
        })) : footerLink;
    };
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            source: 'footer'
        }
    }, /*#__PURE__*/ $bSJIT.createElement($a0ba4c8fbf7a5722$var$FooterContainer, {
        id: "portal-layout-footer",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        "data-testid": "portal-layout-footer"
    }, showCSMFooter ? null : renderWacFooterLink()));
};
var $a0ba4c8fbf7a5722$export$2e2bcd8739ae039 = $a0ba4c8fbf7a5722$var$Footer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a0ba4c8fbf7a5722$var$FooterContainer = /*#__PURE__*/ (0, $4v2A7.default).footer.withConfig({
    componentId: "sc-1d68q8x-0"
})`padding:${`var(--ds-space-600, ${`${(0, $hKa9R.footerPadding)}px`})`} 0;text-align:center;white-space:nowrap;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a0ba4c8fbf7a5722$var$FooterJsdIcon = /*#__PURE__*/ (0, $4v2A7.default)((0, $8rlxZ.default)).withConfig({
    componentId: "sc-1d68q8x-1"
})`object-fit:contain;height:${`var(--ds-space-250, ${`${(0, $hKa9R.footerJsdIconHeight)}px`})`};vertical-align:middle;opacity:0.5;transition:opacity ${$9Yqiu.timingFunctions.easeInOut} ${$9Yqiu.speedMs.fast}ms;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a0ba4c8fbf7a5722$var$FooterLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $53Khx.HtmlAnchor)).withConfig({
    componentId: "sc-1d68q8x-2"
})`${$98sDU.small};color:${"var(--ds-text-subtlest, #5E6C84)"};cursor:pointer;:hover,:active{color:${"var(--ds-text-subtlest, #5E6C84)"};text-decoration:none;${$a0ba4c8fbf7a5722$var$FooterJsdIcon}{opacity:1;stop:first-child{stop-color:${"var(--ds-background-brand-bold-hovered, #0052CC)"};}stop:last-child{stop-color:${"var(--ds-background-brand-bold, #2684FF)"};}> g > g > path:last-child{fill:${"var(--ds-background-brand-bold, #2684FF)"};}}}`;

});
parcelRegister("53Khx", function(module, exports) {
$parcel$export(module.exports, "HtmlAnchor", () => $c11ba04658948772$export$acca9dc24cfe2034);

var $bSJIT = parcelRequire("bSJIT");

var $hWsdJ = parcelRequire("hWsdJ");
const $c11ba04658948772$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...anchorProps })=>{
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content
    return /*#__PURE__*/ $bSJIT.createElement("a", anchorProps);
};
const $c11ba04658948772$export$acca9dc24cfe2034 = (0, $hWsdJ.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($c11ba04658948772$var$InstrumentedLink);

});
parcelRegister("hWsdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ee6efdfeb7c25de$export$2e2bcd8739ae039);

var $4ZMmh = parcelRequire("4ZMmh");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $haAAx = parcelRequire("haAAx");
/**
 * Will create and fire a UI event when the callback is called.
 * Works like the following:
 *
 * YOU NEED TO PASS IN PROPS UNFORTUNATELY SORRY LIMITATION W/ TYPESCRIPT!
 * This means your default props probably won't work. And your props won't be set correctly on the wrapped component.
 * JUST PASS IN TPROPS!
 */ const $8ee6efdfeb7c25de$var$withCreateFireUIAnalytics = (actionSubject, analyticsDefinition)=>{
    return (Component)=>{
        const mappedAnalyticsDefinition = (0, $4ZMmh.mapValues)(analyticsDefinition, (val)=>{
            return (create, props)=>{
                const payload = val(props);
                const event = create({
                    ...payload,
                    ...props.attributes,
                    actionSubjectId: props.actionSubjectId,
                    analyticsType: (0, $haAAx.UI_EVENT_TYPE)
                });
                event.fire();
                return event;
            };
        });
        const WrappedComponent = (0, $2usNr.default)({
            componentName: actionSubject
        })(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $kIbto.default)(mappedAnalyticsDefinition)(Component));
        WrappedComponent.displayName = `withCreateFireUIAnalytics(${Component.displayName || Component.name})`;
        return WrappedComponent;
    };
};
var $8ee6efdfeb7c25de$export$2e2bcd8739ae039 = $8ee6efdfeb7c25de$var$withCreateFireUIAnalytics;

});


parcelRegister("8rlxZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b40aabd56089cc6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $8b40aabd56089cc6$var$SvgJsdIconreact = (props)=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        width: 15,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        x1: "38.04%",
        y1: "6.64%",
        x2: "59.86%",
        y2: "63.78%",
        id: "jsd-icon_react_svg__a"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        stopColor: "#344563",
        offset: "0%"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        stopColor: "#5E6C84",
        offset: "100%"
    }))), /*#__PURE__*/ $bSJIT.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M-9-6h32v32H-9z"
    }), /*#__PURE__*/ $bSJIT.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "m8.93 7.56 5.2.02a.81.81 0 0 1 .65 1.3L7.09 19.14A5.46 5.46 0 0 1 6 11.5l2.94-3.94z",
        fill: "url(#jsd-icon_react_svg__a)"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "m5.98 11.5-5.17-.04a.81.81 0 0 1-.65-1.3L7.77 0a5.46 5.46 0 0 1 1.11 7.64l-2.9 3.86z",
        fill: "#5E6C84"
    }))));
var $8b40aabd56089cc6$export$2e2bcd8739ae039 = $8b40aabd56089cc6$var$SvgJsdIconreact;

});

parcelRegister("cT7mi", function(module, exports) {
$parcel$export(module.exports, "CookiePreferencesButton", () => $46d6fb4ee8b3ffb9$export$931ce0f255e8e770);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $gXqq0 = parcelRequire("gXqq0");

var $6TFrS = parcelRequire("6TFrS");

// Lazy-loaded so the modal bundle is only fetched on interaction, not on initial paint.
const $46d6fb4ee8b3ffb9$var$PreferenceModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>Promise.resolve((parcelRequire("fP3rX"))).then((m)=>({
            default: m.PreferenceModal
        })));
const $46d6fb4ee8b3ffb9$var$styles = {
    classicHelpCenter: "_2rko12b0 _11c8wadc _v564k6bl _1rjc12x7 _18zrutpp _1e0c116y _4cvr1h6o _bfhksm61 _syaz1rc1 _k48pi7a9 _t9ec1qs1 _80omtlke _irr31dpa _1ggl5xtf _1di6fcek"
};
const $46d6fb4ee8b3ffb9$export$931ce0f255e8e770 = ({ appearance: appearance = 'subtle', spacing: spacing = 'compact', isInClassicHelpCenter: isInClassicHelpCenter = false })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const handleOpen = (0, $bSJIT.useCallback)(()=>setIsOpen(true), []);
    const handleClose = (0, $bSJIT.useCallback)(()=>setIsOpen(false), []);
    const label = formatMessage((0, $6TFrS.default).cookiePreferences);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: [
            isInClassicHelpCenter ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
                xcss: $46d6fb4ee8b3ffb9$var$styles.classicHelpCenter,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- xcss fontFamily only accepts ADS tokens; 'inherit' (needed to match the sibling link's system font) is static but has no token, so it must live on the style prop
                style: {
                    fontFamily: 'inherit'
                },
                onClick: handleOpen,
                children: label
            }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                appearance: appearance,
                spacing: spacing,
                onClick: handleOpen,
                children: label
            }),
            isOpen && /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $dc70d.jsx)($46d6fb4ee8b3ffb9$var$PreferenceModal, {
                    onClose: handleClose,
                    onSubmit: handleClose
                })
            })
        ]
    });
};

});
parcelRegister("6TFrS", function(module, exports) {
$parcel$export(module.exports, "default", () => $0901b72a895a325f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $0901b72a895a325f$var$cookiePreferencesMessages = (0, $f0Pt4.defineMessages)({
    cookiePreferences: {
        id: 'hub.cookie-preferences-button.cookiePreferences',
        defaultMessage: 'Cookie preferences',
        description: 'Label for a button that opens a modal where users can review and change their cookie and privacy preferences.'
    }
});
var $0901b72a895a325f$export$2e2bcd8739ae039 = $0901b72a895a325f$var$cookiePreferencesMessages;

});

parcelRegister("fP3rX", function(module, exports) {
$parcel$export(module.exports, "PreferenceModal", () => $ba7abc5551e18a20$export$94c5684831c222e7);

var $bSJIT = parcelRequire("bSJIT");

var $bf1Bt = parcelRequire("bf1Bt");

var $gdUUy = parcelRequire("gdUUy");

var $2xHPy = parcelRequire("2xHPy");

var $6d0Zh = parcelRequire("6d0Zh");

var $cYNDs = parcelRequire("cYNDs");

var $ahXPR = parcelRequire("ahXPR");

var $2b6Yq = parcelRequire("2b6Yq");

var $kKj2j = parcelRequire("kKj2j");

var $lrTI2 = parcelRequire("lrTI2");
const $ba7abc5551e18a20$export$94c5684831c222e7 = (props)=>{
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $gdUUy.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ba7abc5551e18a20$export$30df3cfccbe10e6e, props);
};
const $ba7abc5551e18a20$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $bSJIT.useState)(true);
    const isEventSent = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $2xHPy.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $lrTI2.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $ahXPR.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $bSJIT.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $2xHPy.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $2b6Yq.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $2xHPy.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag === null || showSuccessFlag === void 0 || showSuccessFlag();
            } catch (e) {
                (0, $cYNDs.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
            }
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 || onSubmit();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kKj2j.PresentationalPreferenceModal), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $ahXPR.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, shouldAddWrappers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf1Bt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6d0Zh.BSCIntlProvider), null, modalContent)) : modalContent);
};

});
parcelRegister("bf1Bt", function(module, exports) {
$parcel$export(module.exports, "FlagsProvider", () => $92aaaea680b181e2$export$a4270ab432ac8a58);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $2bmUD = parcelRequire("2bmUD");

var $9Dksr = parcelRequire("9Dksr");

var $lJzMO = parcelRequire("lJzMO");
const $92aaaea680b181e2$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $92aaaea680b181e2$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $bSJIT.useState)([]);
    const removeFlag = (0, $bSJIT.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $bSJIT.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $92aaaea680b181e2$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Dksr.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $lJzMO.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $eJ0Uu.default) : (0, $2bmUD.default);
                    return /*#__PURE__*/ (0, $bSJIT.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}

});
parcelRegister("9Dksr", function(module, exports) {
$parcel$export(module.exports, "FlagContext", () => $7753cf4327f6ad42$export$2eb95677cf2465e1);

var $bSJIT = parcelRequire("bSJIT");
const $7753cf4327f6ad42$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(null);

});


parcelRegister("6d0Zh", function(module, exports) {
$parcel$export(module.exports, "BSCIntlProvider", () => $d9e34d824f8d8e08$export$9aa38aed134c207f);

var $bSJIT = parcelRequire("bSJIT");

var $igKbN = parcelRequire("igKbN");

var $85jEy = parcelRequire("85jEy");
var $chFie = parcelRequire("chFie");
const $d9e34d824f8d8e08$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $igKbN.default), {
        defaultMessages: (0, $85jEy.default),
        loaderFn: (0, $chFie.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("igKbN", function(module, exports) {
$parcel$export(module.exports, "default", () => $366adfca9ee10654$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");

var $kQDdM = parcelRequire("kQDdM");

var $cj4le = parcelRequire("cj4le");
function $366adfca9ee10654$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $cj4le.useSafeIntl)();
    const messages = (0, $kQDdM.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $bSJIT.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("kQDdM", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $f3c16464f0dbb767$export$4d17e2d9c5348842);

var $bSJIT = parcelRequire("bSJIT");

var $jgAkD = parcelRequire("jgAkD");
function $f3c16464f0dbb767$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $bSJIT.useState)((0, $jgAkD.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $bSJIT.useRef)(localeState.locale);
    (0, $bSJIT.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("jgAkD", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $3d8fd417394833f1$export$79618bef82c02d4c);
const $3d8fd417394833f1$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("cj4le", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $74ef23a55f1276de$export$f752ac21ea3960a5);

var $bSJIT = parcelRequire("bSJIT");

var $2z7V1 = parcelRequire("2z7V1");
var $9WiA8 = parcelRequire("9WiA8");
var $fK3tS = parcelRequire("fK3tS");

var $jgAkD = parcelRequire("jgAkD");
// Prevents memory leaks
const $74ef23a55f1276de$var$cache = (0, $9WiA8.createIntlCache)();
const $74ef23a55f1276de$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $bSJIT.useContext)((0, $fK3tS.Context));
    if (!context) return (0, $2z7V1.createIntl)((0, $jgAkD.DEFAULT_LOCALE_STATE), $74ef23a55f1276de$var$cache);
    return context;
};

});


parcelRegister("85jEy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3c5d6c81fef33cb4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5IQ71 = parcelRequire("5IQ71");
var $3c5d6c81fef33cb4$export$2e2bcd8739ae039 = (0, $5IQ71.default);

});
parcelRegister("5IQ71", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c3345ff378a5e05$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $5c3345ff378a5e05$export$2e2bcd8739ae039 = {
    "browser-storage-controls.consent-banner-modal.analytical.description.101024": "Measures usage to improve product performance.",
    "browser-storage-controls.consent-banner-modal.analytical.description.101024-appify": "Measures usage to improve app performance.",
    "browser-storage-controls.consent-banner-modal.analytical.option.082624": "Allow analytical cookies",
    "browser-storage-controls.consent-banner-modal.cancel.button": "Cancel",
    "browser-storage-controls.consent-banner-modal.confirm.button": "Confirm",
    "browser-storage-controls.consent-banner-modal.functional.description.082624": "Provides enhanced functionality and personalization.",
    "browser-storage-controls.consent-banner-modal.functional.option.082624": "Allow functional cookies",
    "browser-storage-controls.consent-banner-modal.marketing.description.082624": "Used for targeted advertising.",
    "browser-storage-controls.consent-banner-modal.marketing.option.082624": "Allow marketing cookies",
    "browser-storage-controls.consent-banner-modal.strict.description.082624": "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    "browser-storage-controls.consent-banner-modal.strict.description.082624-appify": "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    "browser-storage-controls.consent-banner-modal.summary.description.082624": "Because we value your privacy, you can select which cookies you allow. {link}",
    "browser-storage-controls.consent-banner-modal.title": "Cookie preferences",
    "browser-storage-controls.consent-banner-modal.tracking.link.082624": "Review our cookies and tracking notice",
    "browser-storage-controls.consent-banner.accept-all.button": "Accept all",
    "browser-storage-controls.consent-banner.cookies-description.text": "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}",
    "browser-storage-controls.consent-banner.cookies-description.text.no.link": "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.",
    "browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024": "Atlassian cookies and tracking notice",
    "browser-storage-controls.consent-banner.error-flag.description": "Try again in a few minutes.",
    "browser-storage-controls.consent-banner.error-flag.title": "We're unable to update the policy",
    "browser-storage-controls.consent-banner.only-necessary.button": "Only necessary",
    "browser-storage-controls.consent-banner.preferences.button": "Preferences",
    "browser-storage-controls.consent-banner.success-flag.description": "You can change this at any time in your Atlassian account.",
    "browser-storage-controls.consent-banner.success-flag.description-local-only": "Your preferences will only affect this site.",
    "browser-storage-controls.consent-banner.success-flag.title": "Cookie preferences saved",
    "browser-storage-controls.consent-banner.toast.error": "Error",
    "browser-storage-controls.consent-banner.toast.success": "Success"
};

});


parcelRegister("chFie", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $41c95fe05b47e9f9$export$2b153a2030b0feb2);

var $85jEy = parcelRequire("85jEy");




























const $41c95fe05b47e9f9$var$locales = {
    cs: ()=>(parcelRequire("6dhgZ")),
    da: ()=>(parcelRequire("67HoX")),
    de: ()=>(parcelRequire("60zxZ")),
    'en-GB': ()=>(parcelRequire("9OPVM")),
    'en-ZZ': ()=>(parcelRequire("295Yj")),
    en: ()=>Promise.resolve((parcelRequire("85jEy"))),
    es: ()=>(parcelRequire("eYLIL")),
    fi: ()=>(parcelRequire("5axER")),
    fr: ()=>(parcelRequire("38vfq")),
    hu: ()=>(parcelRequire("luHQE")),
    it: ()=>(parcelRequire("6lQer")),
    ja: ()=>(parcelRequire("2rT4W")),
    ko: ()=>(parcelRequire("cPpUt")),
    nb: ()=>(parcelRequire("cT8SI")),
    nl: ()=>(parcelRequire("g3KH6")),
    pl: ()=>(parcelRequire("dEXJV")),
    'pt-BR': ()=>(parcelRequire("ggyEl")),
    ru: ()=>(parcelRequire("76Rju")),
    sl: ()=>(parcelRequire("fVLLw")),
    sr_RS: ()=>(parcelRequire("easJB")),
    sr_YR: ()=>(parcelRequire("FVErg")),
    sv: ()=>(parcelRequire("8nbXz")),
    th: ()=>(parcelRequire("9W7VF")),
    tr: ()=>(parcelRequire("cK2PR")),
    uk: ()=>(parcelRequire("k24VJ")),
    vi: ()=>(parcelRequire("3ghhu")),
    zh_TW: ()=>(parcelRequire("92Z5A")),
    zh: ()=>(parcelRequire("hFbw9"))
};
const $41c95fe05b47e9f9$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $41c95fe05b47e9f9$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $41c95fe05b47e9f9$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("6dhgZ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9edbP").then(()=>parcelRequire('5nwK5'));

});

parcelRegister("67HoX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1GCzg").then(()=>parcelRequire('2vr3p'));

});

parcelRegister("60zxZ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cBPwC").then(()=>parcelRequire('2q5YJ'));

});

parcelRegister("9OPVM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9IhnK").then(()=>parcelRequire('3znIy'));

});

parcelRegister("295Yj", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("E7M2g").then(()=>parcelRequire('bjDma'));

});

parcelRegister("eYLIL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("g4X9R").then(()=>parcelRequire('aVinG'));

});

parcelRegister("5axER", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7DJhc").then(()=>parcelRequire('48OOM'));

});

parcelRegister("38vfq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8MWbG").then(()=>parcelRequire('jr70F'));

});

parcelRegister("luHQE", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("akqhy").then(()=>parcelRequire('2SYag'));

});

parcelRegister("6lQer", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fhkJI").then(()=>parcelRequire('52KkS'));

});

parcelRegister("2rT4W", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lrqdY").then(()=>parcelRequire('foQSm'));

});

parcelRegister("cPpUt", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6Bkkm").then(()=>parcelRequire('iuaEP'));

});

parcelRegister("cT8SI", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("h6UyT").then(()=>parcelRequire('hANAe'));

});

parcelRegister("g3KH6", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kFWWK").then(()=>parcelRequire('8R0Be'));

});

parcelRegister("dEXJV", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3K3pm").then(()=>parcelRequire('cn8UV'));

});

parcelRegister("ggyEl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eeDmb").then(()=>parcelRequire('htIWj'));

});

parcelRegister("76Rju", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4jSbi").then(()=>parcelRequire('iDVI7'));

});

parcelRegister("fVLLw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2mwTR").then(()=>parcelRequire('8VZtV'));

});

parcelRegister("easJB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("457tt").then(()=>parcelRequire('gCmFT'));

});

parcelRegister("FVErg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lU1jO").then(()=>parcelRequire('1abha'));

});

parcelRegister("8nbXz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fFnjn").then(()=>parcelRequire('35pdr'));

});

parcelRegister("9W7VF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ky32P").then(()=>parcelRequire('bpO9p'));

});

parcelRegister("cK2PR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fhKoX").then(()=>parcelRequire('acDqO'));

});

parcelRegister("k24VJ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aU3U0").then(()=>parcelRequire('1XszH'));

});

parcelRegister("3ghhu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5a4K1").then(()=>parcelRequire('kiGFl'));

});

parcelRegister("92Z5A", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iOb3l").then(()=>parcelRequire('6NtEb'));

});

parcelRegister("hFbw9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("78HBw").then(()=>parcelRequire('6pIod'));

});



parcelRegister("2b6Yq", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", () => $a6b434c2ba3bd07d$export$7bb3e177c1a1e841);

var $c76Jg = parcelRequire("c76Jg");

var $ahXPR = parcelRequire("ahXPR");

var $fhC5O = parcelRequire("fhC5O");

var $lAA6d = parcelRequire("lAA6d");

var $acppk = parcelRequire("acppk");

var $3t6nL = parcelRequire("3t6nL");
const $a6b434c2ba3bd07d$var$emptyDisplayedTextMap = {
    [(0, $fhC5O.PreferenceCategory).Analytics]: '',
    [(0, $fhC5O.PreferenceCategory).Functional]: '',
    [(0, $fhC5O.PreferenceCategory).Marketing]: '',
    [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $fhC5O.PreferenceCategory).Unknown]: ''
};
async function $a6b434c2ba3bd07d$export$7bb3e177c1a1e841(preferences, displayedTextMap = $a6b434c2ba3bd07d$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $c76Jg.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $3t6nL.packUserPreferences)(preferences);
        (0, $acppk.setStrictlyNecessaryCookie)((0, $ahXPR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $lAA6d.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("lAA6d", function(module, exports) {
$parcel$export(module.exports, "setConsentToken", () => $cf5e8e936ffc743b$export$fbf549fe6f0e91dc);

var $cYNDs = parcelRequire("cYNDs");

var $H4xrH = parcelRequire("H4xrH");

var $cX8bE = parcelRequire("cX8bE");

var $fhC5O = parcelRequire("fhC5O");

var $7PqK8 = parcelRequire("7PqK8");

var $3t6nL = parcelRequire("3t6nL");

var $8rtVP = parcelRequire("8rtVP");
const $cf5e8e936ffc743b$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $3t6nL.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $cX8bE.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $8rtVP.onlySetFallbackIfDifferent)(consentToken);
    else (0, $7PqK8.setConsentTokenFallbackCookie)(consentToken);
    (0, $7PqK8.setConsentTokenCookie)(consentToken);
    (0, $7PqK8.setShouldShowBannerCookie)(consentToken);
};
const $cf5e8e936ffc743b$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $cX8bE.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $cX8bE.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $3t6nL.packUserPreferences)({
        ...mergedPrefs,
        [(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible // Indicates we were unable to hit ConsentHub when the consents were created
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $cYNDs.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $8rtVP.onlySetFallbackIfDifferent)(consentToken);
        (0, $7PqK8.setConsentTokenCookie)(consentToken);
        (0, $7PqK8.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down beyond the short-lived
    // consent token cookie's expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $cYNDs.Logger).error('Token failed to save');
    (0, $8rtVP.onlySetFallbackIfDifferent)(consentToken);
    (0, $7PqK8.setShouldShowBannerCookie)(consentToken);
};
const $cf5e8e936ffc743b$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $8rtVP.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $H4xrH.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $cf5e8e936ffc743b$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $cf5e8e936ffc743b$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("8rtVP", function(module, exports) {
$parcel$export(module.exports, "mergeConsentUpdates", () => $60536089cdc5b333$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $60536089cdc5b333$export$a023a0b818522757);

var $ahXPR = parcelRequire("ahXPR");

var $fhC5O = parcelRequire("fhC5O");

var $iiTNF = parcelRequire("iiTNF");

var $7PqK8 = parcelRequire("7PqK8");

var $3t6nL = parcelRequire("3t6nL");
const $60536089cdc5b333$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $fhC5O.PreferenceCategory).StrictlyNecessary],
        [(0, $fhC5O.PreferenceCategory).Functional]: updatedPreferences[(0, $fhC5O.PreferenceCategory).Functional],
        [(0, $fhC5O.PreferenceCategory).Analytics]: updatedPreferences[(0, $fhC5O.PreferenceCategory).Analytics],
        [(0, $fhC5O.PreferenceCategory).Marketing]: updatedPreferences[(0, $fhC5O.PreferenceCategory).Marketing],
        [(0, $fhC5O.PreferenceCategory).Unknown]: updatedPreferences[(0, $fhC5O.PreferenceCategory).Unknown]
    };
};
const $60536089cdc5b333$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable]);
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault]);
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $fhC5O.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $fhC5O.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $fhC5O.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $60536089cdc5b333$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $3t6nL.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $ahXPR.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$60536089cdc5b333$var$pruneLegacyProperties(updatedPreferences),
            ...$60536089cdc5b333$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $ahXPR.DEFAULT_PREFERENCES),
            ...$60536089cdc5b333$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $ahXPR.DEFAULT_PREFERENCES),
        ...$60536089cdc5b333$var$pruneLegacyProperties(updatedPreferences),
        ...$60536089cdc5b333$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $60536089cdc5b333$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $7PqK8.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("kKj2j", function(module, exports) {
$parcel$export(module.exports, "PresentationalPreferenceModal", () => $1c0b5d153b71ec03$export$9921ee7829a3ba4);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $hzFIQ = parcelRequire("hzFIQ");

var $fbRS9 = parcelRequire("fbRS9");

var $7WQx2 = parcelRequire("7WQx2");

var $803Gl = parcelRequire("803Gl");

var $hwgr4 = parcelRequire("hwgr4");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $gdUUy = parcelRequire("gdUUy");

var $ixPA5 = parcelRequire("ixPA5");

var $gUpf2 = parcelRequire("gUpf2");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $2xHPy = parcelRequire("2xHPy");

var $ePFrB = parcelRequire("ePFrB");

var $fhC5O = parcelRequire("fhC5O");

var $dauaN = parcelRequire("dauaN");

var $1EKm9 = parcelRequire("1EKm9");
const $1c0b5d153b71ec03$var$categoryNameStyles = (0, $9BVpB.xcss)({
    fontWeight: 'font.weight.bold'
});
const $1c0b5d153b71ec03$var$customHeaderStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $1c0b5d153b71ec03$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($1c0b5d153b71ec03$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node)) {
        if (node.props.children) return $1c0b5d153b71ec03$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $1c0b5d153b71ec03$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $1EKm9.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $1EKm9.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $gdUUy.fg)('product-terminology-refresh') ? (0, $1EKm9.i18n).strictDescriptionAppify : (0, $1EKm9.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $1c0b5d153b71ec03$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $1c0b5d153b71ec03$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $fhC5O.PreferenceCategory).Functional,
            title: (0, $1EKm9.i18n).functionalOption,
            description: (0, $1EKm9.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $fhC5O.PreferenceCategory).Analytics,
            title: (0, $1EKm9.i18n).analyticalOption,
            description: (0, $gdUUy.fg)('product-terminology-refresh') ? (0, $1EKm9.i18n).analyticalOptionDescriptionAppify : (0, $1EKm9.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $fhC5O.PreferenceCategory).Marketing,
            title: (0, $1EKm9.i18n).marketingOption,
            description: (0, $1EKm9.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $ePFrB.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $1c0b5d153b71ec03$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $1c0b5d153b71ec03$var$categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $1c0b5d153b71ec03$var$noop = ()=>{};
const $1c0b5d153b71ec03$var$CustomHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $hwgr4.useModal)();
    if ((0, $gdUUy.fg)('platform_dst_modal-dialog-use-modal-title')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $1EKm9.i18n).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $803Gl.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1c0b5d153b71ec03$var$customHeaderStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $803Gl.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        as: "h1",
        size: "medium",
        id: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $1EKm9.i18n).title)));
};
const $1c0b5d153b71ec03$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $1c0b5d153b71ec03$var$noop, onSubmit: onSubmit = $1c0b5d153b71ec03$var$noop, onClose: onClose = $1c0b5d153b71ec03$var$noop, setIsOpen: setIsOpen = $1c0b5d153b71ec03$var$noop })=>{
    const intl = (0, $4vLTk.default)();
    const onCloseModal = (0, $bSJIT.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $bSJIT.useCallback)(()=>{
        onCloseModal();
        (0, $2xHPy.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $bSJIT.useCallback)(()=>{
        onCloseModal();
        (0, $2xHPy.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $bSJIT.useCallback)(()=>{
        onCloseModal();
        (0, $2xHPy.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $bSJIT.useCallback)(()=>{
        (0, $2xHPy.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $bSJIT.useMemo)(()=>{
        return $1c0b5d153b71ec03$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $bSJIT.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        onClose: onClickBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fbRS9.default), {
        onSubmit: handleSubmission
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1c0b5d153b71ec03$var$CustomHeader, {
        onClose: onClickClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $1EKm9.i18n).summaryDescription,
        values: {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ixPA5.Anchor), {
                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $1EKm9.i18n).trackingLink))
        },
        tagName: 'p'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $gdUUy.fg)('product-terminology-refresh') ? (0, $1EKm9.i18n).strictDescriptionAppify : (0, $1EKm9.i18n).strictDescription,
        values: {
            bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
                    weight: "bold"
                }, msg)
        },
        tagName: 'p'
    })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dauaN.CookieCategorySection), {
            category: category,
            titleElement: titleElement,
            titleString: titleString,
            descriptionElement: description,
            isChecked: (preferences && preferences[category]) ?? false,
            setPreferencesData: setPreferencesData
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: onClickCancel,
        testId: "consent-preference-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $1EKm9.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        type: "submit",
        appearance: "primary",
        onClick: handleSubmission,
        testId: "consent-preference-confirm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $1EKm9.i18n).confirmBtn))))));
};

});
parcelRegister("803Gl", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $40a2ed9cad71f54e$export$de65de8213222d10);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4TRbS = parcelRequire("4TRbS");

var $9dYEz = parcelRequire("9dYEz");
const $40a2ed9cad71f54e$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

});

parcelRegister("7HzAO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $43f00fae4bc178ab$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hwgr4 = parcelRequire("hwgr4");
const $43f00fae4bc178ab$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $43f00fae4bc178ab$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $hwgr4.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $43f00fae4bc178ab$export$2e2bcd8739ae039 = $43f00fae4bc178ab$var$ModalFooter;

});

parcelRegister("j4mCC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $110243288fe23054$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");

var $6X9z7 = parcelRequire("6X9z7");

var $803Gl = parcelRequire("803Gl");

var $hwgr4 = parcelRequire("hwgr4");
const $110243288fe23054$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $110243288fe23054$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false, closeButtonLabel: closeButtonLabel } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $hwgr4.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $110243288fe23054$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $6X9z7.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $110243288fe23054$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $803Gl.CloseButton), {
                        label: closeButtonLabel,
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $110243288fe23054$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
var $110243288fe23054$export$2e2bcd8739ae039 = $110243288fe23054$var$ModalHeader;

});

parcelRegister("4TlNm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $50430149e83c7d2a$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hkLEY = parcelRequire("hkLEY");

var $dsw4B = parcelRequire("dsw4B");

var $hwgr4 = parcelRequire("hwgr4");
const $50430149e83c7d2a$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $50430149e83c7d2a$var$iconStyles = null;
const $50430149e83c7d2a$var$titleStyles = null;
const $50430149e83c7d2a$var$textStyles = null;
const $50430149e83c7d2a$var$truncatedTextStyles = null;
const $50430149e83c7d2a$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))) : (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B)));
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: appearance,
            color: $50430149e83c7d2a$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $50430149e83c7d2a$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $hwgr4.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $dc70d.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $dc70d.jsx)($50430149e83c7d2a$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $9fU1q.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $50430149e83c7d2a$export$2e2bcd8739ae039 = $50430149e83c7d2a$var$ModalTitle;

});

parcelRegister("lFaAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5263f02ffaa6b74$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jvbf5 = parcelRequire("jvbf5");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $b5263f02ffaa6b74$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $b5263f02ffaa6b74$export$2e2bcd8739ae039 = $b5263f02ffaa6b74$var$ModalTransition;

});

parcelRegister("ixPA5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Anchor", () => $8f8b71813ae7d045$export$b688253958b8dfe7);
$parcel$export(module.exports, "default", () => $8f8b71813ae7d045$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $jCkxO = parcelRequire("jCkxO");

var $kIUP1 = parcelRequire("kIUP1");

var $14KEJ = parcelRequire("14KEJ");

var $1OdZP = parcelRequire("1OdZP");

var $d6mTg = parcelRequire("d6mTg");

var $cyIUy = parcelRequire("cyIUy");

var $9Abbn = parcelRequire("9Abbn");

var $ivKmQ = parcelRequire("ivKmQ");

var $fQ18X = parcelRequire("fQ18X");

var $jkSvc = parcelRequire("jkSvc");

var $2UbVv = parcelRequire("2UbVv");

var $gfZ3w = parcelRequire("gfZ3w");

var $cCXmu = parcelRequire("cCXmu");
function $8f8b71813ae7d045$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $8f8b71813ae7d045$var$focusRingStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $fQ18X.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $cCXmu.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $jkSvc.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $jkSvc.borderWidthMap)['border.width']} solid`
        }
    }
});
const $8f8b71813ae7d045$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $8f8b71813ae7d045$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $8f8b71813ae7d045$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $8f8b71813ae7d045$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $8f8b71813ae7d045$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $8f8b71813ae7d045$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $1OdZP.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $d6mTg.useId)();
    const onClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $gfZ3w.parseXcss)(xcss);
    const RouterLink = (0, $14KEJ.useRouterLink)();
    const isExternal = typeof href === 'string' && $8f8b71813ae7d045$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $8f8b71813ae7d045$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $jCkxO.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $9dQre.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $8f8b71813ae7d045$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $8f8b71813ae7d045$var$baseStyles,
            $8f8b71813ae7d045$var$positionStyles,
            $8f8b71813ae7d045$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ivKmQ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $2UbVv.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $2UbVv.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $2UbVv.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $2UbVv.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $2UbVv.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $2UbVv.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $2UbVv.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $9dQre.jsx)((0, $9Abbn.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $8f8b71813ae7d045$var$OPENS_NEW_WINDOW_LABEL}`));
};
const $8f8b71813ae7d045$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $bSJIT.forwardRef)($8f8b71813ae7d045$var$AnchorNoRef);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8f8b71813ae7d045$export$2e2bcd8739ae039 = $8f8b71813ae7d045$export$b688253958b8dfe7;

});

parcelRegister("hYh8H", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $74dc521d7f095a99$export$694e0d28c7ffc90c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $9BVpB = parcelRequire("9BVpB");

var $cMYsY = parcelRequire("cMYsY");
const $74dc521d7f095a99$var$flexGrowMap = {
    hug: (0, $9BVpB.xcss)({
        flexGrow: 0
    }),
    fill: (0, $9BVpB.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $74dc521d7f095a99$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $74dc521d7f095a99$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $cMYsY.Flex), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$74dc521d7f095a99$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$74dc521d7f095a99$export$2e2bcd8739ae039 = $74dc521d7f095a99$export$694e0d28c7ffc90c;

});

parcelRegister("aRsbV", function(module, exports) {
$parcel$export(module.exports, "Text", () => $92afa31a69966b85$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "default", () => $92afa31a69966b85$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $jCkxO = parcelRequire("jCkxO");

var $jP6ub = parcelRequire("jP6ub");

var $eMcp0 = parcelRequire("eMcp0");

var $dHn3F = parcelRequire("dHn3F");

var $fMEHk = parcelRequire("fMEHk");

var $8TpKd = parcelRequire("8TpKd");

var $Vxr0Q = parcelRequire("Vxr0Q");

var $7CEid = parcelRequire("7CEid");
function $92afa31a69966b85$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92afa31a69966b85$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $92afa31a69966b85$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $92afa31a69966b85$var$strongStyles = {
    name: "17rayov",
    styles: "font-weight:var(--ds-font-weight-bold, 653)"
};
const $92afa31a69966b85$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $92afa31a69966b85$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $92afa31a69966b85$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $92afa31a69966b85$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $92afa31a69966b85$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $eMcp0.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $fMEHk.inverseColorMap).hasOwnProperty(surface)) return (0, $fMEHk.inverseColorMap)[surface];
    return 'color.text';
};
const $92afa31a69966b85$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $jCkxO.default)($92afa31a69966b85$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $dHn3F.useHasTextAncestor)();
    const color = $92afa31a69966b85$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $9dQre.jsx)(Component, {
        ref: ref,
        css: [
            $92afa31a69966b85$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $Vxr0Q.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $8TpKd.textColorStylesMap)[color],
            maxLines && $92afa31a69966b85$var$truncationStyles,
            maxLines === 1 && $92afa31a69966b85$var$wordBreakMap.breakAll,
            align && $92afa31a69966b85$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $7CEid.textWeightStylesMap)[weight],
            Component === 'em' && $92afa31a69966b85$var$emStyles,
            Component === 'strong' && $92afa31a69966b85$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $9dQre.jsx)((0, $jP6ub.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$92afa31a69966b85$export$2e2bcd8739ae039 = $92afa31a69966b85$export$5f1af8db9871e1d6;

});
parcelRegister("8TpKd", function(module, exports) {
$parcel$export(module.exports, "textColorStylesMap", () => $617b64b13e118fa1$export$3a1bcba60b23d7f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $yxwLu = parcelRequire("yxwLu");

var $iIpMq = parcelRequire("iIpMq");
const $617b64b13e118fa1$export$3a1bcba60b23d7f0 = (0, $yxwLu.getSerializedStylesMap)('color', (0, $iIpMq.textColorMap));

});

parcelRegister("Vxr0Q", function(module, exports) {
$parcel$export(module.exports, "textSizeStylesMap", () => $808bc12bf7c705f7$export$219d364c0da35ae4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $yxwLu = parcelRequire("yxwLu");

var $3Ihry = parcelRequire("3Ihry");
const $808bc12bf7c705f7$export$219d364c0da35ae4 = (0, $yxwLu.getSerializedStylesMap)('font', (0, $3Ihry.textSizeMap));

});
parcelRegister("3Ihry", function(module, exports) {
$parcel$export(module.exports, "textSizeMap", () => $909d98ef993e9e81$export$236bfe3a33ef1292);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fd3eebcc815c6c62e80e08d3ca4f843>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $909d98ef993e9e81$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});


parcelRegister("7CEid", function(module, exports) {
$parcel$export(module.exports, "textWeightStylesMap", () => $025de7c9ada0adf2$export$38845ca010b93505);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $yxwLu = parcelRequire("yxwLu");

var $6OI3R = parcelRequire("6OI3R");
const $025de7c9ada0adf2$export$38845ca010b93505 = (0, $yxwLu.getSerializedStylesMap)('fontWeight', (0, $6OI3R.textWeightMap));

});
parcelRegister("6OI3R", function(module, exports) {
$parcel$export(module.exports, "textWeightMap", () => $c623b9b09e836075$export$855cfd311192d666);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8120a44c21b94ee961979aa2a9470314>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $c623b9b09e836075$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};

});



parcelRegister("ePFrB", function(module, exports) {
$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $b8321ebdc182f535$export$99df83ca0f45bd54);

var $fhC5O = parcelRequire("fhC5O");
const $b8321ebdc182f535$export$99df83ca0f45bd54 = [
    (0, $fhC5O.PreferenceCategory).Analytics,
    (0, $fhC5O.PreferenceCategory).Functional,
    (0, $fhC5O.PreferenceCategory).Marketing,
    (0, $fhC5O.PreferenceCategory).StrictlyNecessary,
    (0, $fhC5O.PreferenceCategory).Unknown
];

});

parcelRegister("dauaN", function(module, exports) {
$parcel$export(module.exports, "CookieCategorySection", () => $46e8fad489aeda1e$export$3c97a3b492e10ae9);

var $bSJIT = parcelRequire("bSJIT");

var $8HhhR = parcelRequire("8HhhR");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $2xHPy = parcelRequire("2xHPy");

var $fhC5O = parcelRequire("fhC5O");
const $46e8fad489aeda1e$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $46e8fad489aeda1e$var$categoryBoxStyles = (0, $9BVpB.xcss)({
    paddingBlockStart: 'space.200'
});
const $46e8fad489aeda1e$var$categoryDescriptionStyles = (0, $9BVpB.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $46e8fad489aeda1e$var$categoryToEventSubjectMap = {
    [(0, $fhC5O.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $fhC5O.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $fhC5O.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $fhC5O.PreferenceCategory).Unknown]: null,
    [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: null
};
const $46e8fad489aeda1e$var$categoryToTestIdMap = {
    [(0, $fhC5O.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $fhC5O.PreferenceCategory).Analytics]: 'analytics',
    [(0, $fhC5O.PreferenceCategory).Functional]: 'functional',
    [(0, $fhC5O.PreferenceCategory).Marketing]: 'marketing',
    [(0, $fhC5O.PreferenceCategory).Unknown]: null
};
const $46e8fad489aeda1e$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $bSJIT.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $fhC5O.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $46e8fad489aeda1e$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $2xHPy.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${$46e8fad489aeda1e$var$categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $46e8fad489aeda1e$var$categoryBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${$46e8fad489aeda1e$var$tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`,
        testId: `consent-preference-${$46e8fad489aeda1e$var$categoryToTestIdMap[category]}`,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $46e8fad489aeda1e$var$categoryDescriptionStyles,
        id: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small",
        color: "color.text.subtle"
    }, descriptionElement)));
};

});

parcelRegister("1EKm9", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $50e4b10e68b97bef$export$a7357cdd1f0b0168);

var $f0Pt4 = parcelRequire("f0Pt4");
const $50e4b10e68b97bef$export$a7357cdd1f0b0168 = (0, $f0Pt4.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});

});


parcelRegister("lrTI2", function(module, exports) {
$parcel$export(module.exports, "default", () => $03ac8eeb03f6a41b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $3t6nL = parcelRequire("3t6nL");

var $fvY9l = parcelRequire("fvY9l");

var $2b6Yq = parcelRequire("2b6Yq");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $03ac8eeb03f6a41b$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $fvY9l.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $03ac8eeb03f6a41b$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
   * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
   *  during the initial render. Without this flag, the application might incorrectly display a banner based on
   * incomplete or missing preference data. During the rehydration process, this initial render triggers
   * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
   * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
   * and the client-rendered state.
   */ const isInitialRender = (0, $bSJIT.useRef)(true);
    const prefetchedPreferencesData = (0, $bSJIT.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $bSJIT.useState)((0, $3t6nL.initializePreferencesData)(initialPreferences));
    (0, $bSJIT.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $3t6nL.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $2b6Yq.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $03ac8eeb03f6a41b$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.prefs,
        isPrefetchedPreferencesState: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $03ac8eeb03f6a41b$export$2e2bcd8739ae039 = $03ac8eeb03f6a41b$var$usePreferences;

});



parcelRegister("b8UFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $90d6b8c2b8250be7$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $90d6b8c2b8250be7$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    footer: {
        defaultMessage: 'Powered by {iconHtml} Jira Service Management',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.servicemanagement'
    },
    csmFooter: {
        defaultMessage: 'Powered by Jira Customer Service',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.atlassiancustomercollection.non-final'
    }
});

});

parcelRegister("hKa9R", function(module, exports) {
$parcel$export(module.exports, "footerPadding", () => $f39c0d708065af81$export$7d9aba7536a61853);
$parcel$export(module.exports, "footerJsdIconHeight", () => $f39c0d708065af81$export$220c44e1c3ab6f4);
$parcel$export(module.exports, "FOOTER_HEIGHT", () => $f39c0d708065af81$export$a2dd5f25b5a4e5d2);

var $9K7mZ = parcelRequire("9K7mZ");
const $f39c0d708065af81$export$7d9aba7536a61853 = $9K7mZ.multiple(6).unitless;
const $f39c0d708065af81$export$220c44e1c3ab6f4 = $9K7mZ.multiple(2.5).unitless;
const $f39c0d708065af81$export$a2dd5f25b5a4e5d2 = $f39c0d708065af81$export$7d9aba7536a61853 * 2 + $f39c0d708065af81$export$220c44e1c3ab6f4;

});



parcelRegister("k4dp8", function(module, exports) {
$parcel$export(module.exports, "useIsCSMTypographyMigrationEnabled", () => $c2083aa8957fcf02$export$f77c7e452595da18);
$parcel$export(module.exports, "UseTypographyMigratedComponent", () => $c2083aa8957fcf02$export$527b88b630251664);

var $87QgR = parcelRequire("87QgR");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
const $c2083aa8957fcf02$export$f77c7e452595da18 = (useWhiteListedRouteNamesCheck = false)=>{
    if (useWhiteListedRouteNamesCheck) return (0, $87QgR.default).checkGate('enable_typography_token_migration_for_csm') && (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    return (0, $87QgR.default).checkGate('enable_typography_token_migration_for_csm') && (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
};
const $c2083aa8957fcf02$export$527b88b630251664 = (props)=>{
    const isCSMTypographyMigrationEnabled = $c2083aa8957fcf02$export$f77c7e452595da18();
    return isCSMTypographyMigrationEnabled ? props.migratedComponent : props.children;
};

});



parcelRegister("7IgzX", function(module, exports) {
$parcel$export(module.exports, "App", () => (parcelRequire("3U8AI")).default);

var $3U8AI = parcelRequire("3U8AI");

});
parcelRegister("3U8AI", function(module, exports) {
$parcel$export(module.exports, "default", () => $29e9a6ac408b6fff$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");

var $c7bWK = parcelRequire("c7bWK");

var $jGtTN = parcelRequire("jGtTN");
parcelRequire("cTy7E");
var $cSbPZ = parcelRequire("cSbPZ");
parcelRequire("jKUwF");
var $hGKjg = parcelRequire("hGKjg");

var $6luvg = parcelRequire("6luvg");

var $dsw4B = parcelRequire("dsw4B");

var $9ym5V = parcelRequire("9ym5V");

var $haAAx = parcelRequire("haAAx");

var $hCnLH = parcelRequire("hCnLH");

var $hCnLH = parcelRequire("hCnLH");

var $cNer2 = parcelRequire("cNer2");

var $bQGlA = parcelRequire("bQGlA");

var $48InE = parcelRequire("48InE");

var $iW3CQ = parcelRequire("iW3CQ");

var $5LT7v = parcelRequire("5LT7v");

var $cvZci = parcelRequire("cvZci");
parcelRequire("3U5mo");
var $dNTWA = parcelRequire("dNTWA");

var $7WRjA = parcelRequire("7WRjA");

var $b607P = parcelRequire("b607P");

var $9bhHx = parcelRequire("9bhHx");

var $hxJrG = parcelRequire("hxJrG");

var $jyogd = parcelRequire("jyogd");

var $dz5Vz = parcelRequire("dz5Vz");

var $h9hKv = parcelRequire("h9hKv");
parcelRequire("f3Ccb");
var $fIVS9 = parcelRequire("fIVS9");

var $9Iriq = parcelRequire("9Iriq");

var $3OzQg = parcelRequire("3OzQg");
var $29e9a6ac408b6fff$var$_window$JSD_CUSTOMER_;
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $29e9a6ac408b6fff$var$BUILD_KEY = (($29e9a6ac408b6fff$var$_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || $29e9a6ac408b6fff$var$_window$JSD_CUSTOMER_ === void 0 ? void 0 : $29e9a6ac408b6fff$var$_window$JSD_CUSTOMER_.buildKey) || 'local';
const $29e9a6ac408b6fff$export$86fbec116b87613f = (props)=>{
    const { serviceDeskVersion: serviceDeskVersion } = props;
    const isHelpCentersManagementPath = (0, $hCnLH.isHelpCentersManagement)();
    const shouldUseCsmRouter = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) || (0, $hCnLH.isJcsOnlyRestrictedRoute)((0, $iW3CQ.getEnv)().customerAccountAvailabilty);
    const shouldUseHubRouter = (0, $jyogd.getHelpCenterRouteFamily)((0, $iW3CQ.getEnv)().helpCenterType) === (0, $jyogd.HUB_ROUTE_FAMILY);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    (0, $7WRjA.useUFOComponentExperience)((0, $hxJrG.helpCenterViewHomePageExperience));
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $hCnLH.getIsHelpHub)() && (0, $lFpPv.isRequestFormCancelGoBackEnabled)()) return (0, $c7bWK.initializeRequestCreatePreviousLocationTracking)();
        return undefined;
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $5LT7v.hasValidHelpCenterARI)()) {
                (0, $bQGlA.fireAnalyticsForEmptyHelpCenterAri)();
                const traceId = (0, $iW3CQ.getEnv)().traceId ?? '';
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $hxJrG.helpCenterViewHomePageExperience).failure({
                    metadata: {
                        error: `Empty Help Center Ari, traceId: ${traceId}`
                    }
                });
            } else // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $hxJrG.helpCenterViewHomePageExperience).success();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $fuVmc.isValidLayoutAriPresent)()) (0, $48InE.fireAnalyticsForEmptyHelpCenterLayoutAri)();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    const analyticData = {
        version: serviceDeskVersion,
        application: 'jira-servicedesk',
        buildKey: $29e9a6ac408b6fff$var$BUILD_KEY
    };
    const isAdvancedHelpCenterThemingEnabled = ((0, $hCnLH.isAdvancedHelpCenter)() || (0, $hCnLH.isDefaultHelpCenter)()) && (0, $lFpPv.isCustomThemingEnabled)();
    const isCsmAccessControlSplitFgEnabled = (0, $lFpPv.isCsmAccessControlSplitEnabled)();
    const getResourceRouter = $bSJIT.useCallback(()=>{
        if (shouldUseCsmRouter) {
            if (isCsmAccessControlSplitFgEnabled) return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $bSJIT.createElement((0, $b607P.AppContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $9bhHx.CSMResourceRouterNew), null)) : /*#__PURE__*/ $bSJIT.createElement((0, $9bhHx.CSMResourceRouterNew), null);
            return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $bSJIT.createElement((0, $b607P.AppContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $9bhHx.default), null)) : /*#__PURE__*/ $bSJIT.createElement((0, $9bhHx.default), null);
        }
        if (isHelpCentersManagementPath) return /*#__PURE__*/ $bSJIT.createElement((0, $dz5Vz.default), null);
        if (shouldUseHubRouter) return /*#__PURE__*/ $bSJIT.createElement((0, $h9hKv.default), null);
        return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $bSJIT.createElement((0, $b607P.AppContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $9Iriq.default), null)) : /*#__PURE__*/ $bSJIT.createElement((0, $9Iriq.default), null);
    }, [
        shouldUseCsmRouter,
        isHelpCentersManagementPath,
        shouldUseHubRouter,
        isAdvancedHelpCenterThemingEnabled,
        isCsmAccessControlSplitFgEnabled
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $9ym5V.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
        attributes: analyticData
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cNer2.BrowserMetricsScreenTransitionStatusProvider), null, /*#__PURE__*/ $bSJIT.createElement((0, $fIVS9.SSRSafeJSMCookieConsentBanner), null), (0, $cvZci.isBrowserUnsupported)() && /*#__PURE__*/ $bSJIT.createElement((0, $6luvg.default), {
        appearance: "warning",
        icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $3OzQg.default).unsupportedBrowser)), getResourceRouter(), /*#__PURE__*/ $bSJIT.createElement((0, $cSbPZ.default), null), /*#__PURE__*/ $bSJIT.createElement((0, $jGtTN.FeedbackCollector), null), /*#__PURE__*/ $bSJIT.createElement((0, $dNTWA.Heartbeat), null), /*#__PURE__*/ $bSJIT.createElement((0, $hGKjg.MarkAppMounted), null))));
};
const $29e9a6ac408b6fff$var$selector = (0, $BOq7h.createSelector)((0, $fOlM6.getServiceDeskVersion), (serviceDeskVersion)=>({
        serviceDeskVersion: serviceDeskVersion
    }));
var $29e9a6ac408b6fff$export$2e2bcd8739ae039 = (0, $f2mlD.default)($29e9a6ac408b6fff$var$selector)($29e9a6ac408b6fff$export$86fbec116b87613f);

});
parcelRegister("c7bWK", function(module, exports) {
$parcel$export(module.exports, "initializeRequestCreatePreviousLocationTracking", () => $fa85895aadb49d02$export$815420257eb7d834);
$parcel$export(module.exports, "canNavigateBackFromRequestCreate", () => $fa85895aadb49d02$export$5c540869b5908f35);

var $eDcdn = parcelRequire("eDcdn");
let $fa85895aadb49d02$var$canNavigateBack = false;
// Modern Help Center request create forms use the direct path, for example */portal/1/create/2
function $fa85895aadb49d02$var$isRequestCreateLocation(location) {
    return /^\/portal\/\d+\/create\/[^/]+\/?$/.test(location.pathname);
}
const $fa85895aadb49d02$export$815420257eb7d834 = ()=>{
    let currentLocation = (0, $eDcdn.default).location;
    const unlisten = (0, $eDcdn.default).listen((nextLocation, action)=>{
        $fa85895aadb49d02$var$canNavigateBack = action === 'PUSH' && $fa85895aadb49d02$var$isRequestCreateLocation(nextLocation) && !$fa85895aadb49d02$var$isRequestCreateLocation(currentLocation);
        currentLocation = nextLocation;
    });
    return ()=>{
        $fa85895aadb49d02$var$canNavigateBack = false;
        unlisten();
    };
};
const $fa85895aadb49d02$export$5c540869b5908f35 = ()=>$fa85895aadb49d02$var$canNavigateBack;

});

parcelRegister("jGtTN", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollector", () => $81b64e60f8defa51$export$fa63c8dd87ea8148);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $81b64e60f8defa51$export$fa63c8dd87ea8148 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("jFrsf")), {
        moduleId: "./src/view/common/feedback-collector/hocs.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("cVM5r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a278a936494071c1$export$2e2bcd8739ae039);

var $3n4Go = parcelRequire("3n4Go");
/**
 * This will generically handle async loading of components with a
 * loading, timeout, and errored states. If you need more specific
 * handling use react-loosely-lazy directly.
 *
 * Use the preload option if you want the component to start loading
 * immediately.
 */ const $a278a936494071c1$var$withAsync = (options)=>{
    const LoadableComponent = (0, $3n4Go.default)({
        loader: options.loader,
        LoadingSkeleton: options.LoadingSkeleton,
        loadingPosition: options.loadingPosition,
        timeout: 5000
    });
    if (options.preload) LoadableComponent.preload();
    return LoadableComponent;
};
var $a278a936494071c1$export$2e2bcd8739ae039 = $a278a936494071c1$var$withAsync;

});
parcelRegister("3n4Go", function(module, exports) {
$parcel$export(module.exports, "default", () => $640cceae1d8ed5f0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("cJJTb");
var $bf3Xm = parcelRequire("bf3Xm");

var $eTJPi = parcelRequire("eTJPi");
var $6bhLy = parcelRequire("6bhLy");
var $7qqGM = parcelRequire("7qqGM");
const $640cceae1d8ed5f0$var$LooselyLoadableWrapper = (options)=>{
    const Component = options.loader;
    const LazyComponent = (props)=>{
        const renderError = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7qqGM.LoadingComponent), {
                error: error,
                LoadingSkeleton: options.LoadingSkeleton
            });
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eTJPi.ErrorBoundaryAnalytics), {
            renderError: renderError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6bhLy.Fallback), options)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props)));
    };
    LazyComponent.preload = options.loader.preload;
    return LazyComponent;
};
var $640cceae1d8ed5f0$export$2e2bcd8739ae039 = $640cceae1d8ed5f0$var$LooselyLoadableWrapper;

});
parcelRegister("eTJPi", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryAnalytics", () => $753b4a251032ae20$export$627f773fbbb39e);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");
class $753b4a251032ae20$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        if (error.name !== 'ChunkLoadError') {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent !== undefined) {
                // This analytics will help us to note any errors which were previously marked as chunk errors. This might get triggered multiple times if islooselyLazyJsErrorsToSentryEnabled is true.
                const analyticsEvent = createAnalyticsEvent({
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                    action: 'failed',
                    errorMessage: error.message,
                    errorName: error.name,
                    stack: error.stack
                });
                const finalId = 'looselyLazyErrorBoundary';
                const finalPackage = 'looselyLazyPackage';
                const actionSubject = `${finalPackage}.${finalId}`;
                analyticsEvent.context.push({
                    componentName: actionSubject
                });
                analyticsEvent.fire();
            }
        }
        if ((0, $lFpPv.islooselyLazyJsErrorsToSentryEnabled)()) {
            // Differentiate between a chunkLoadError and other JS error.
            if (error.name === 'ChunkLoadError') {
                var _this$props$onError, _this$props;
                (0, $jBiia.trackError)('async.loader.failed', {}, error);
                (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props, error);
            } else {
                var _this$props$onError2, _this$props2;
                (_this$props$onError2 = (_this$props2 = this.props).onError) === null || _this$props$onError2 === void 0 || _this$props$onError2.call(_this$props2, error);
                // this error will be caught by ScreenErrorBoundary at route level which will add it to sentry with packageName derived from route ScreenName
                throw error;
            }
        } else {
            var _this$props$onError3, _this$props3;
            (0, $jBiia.trackError)('async.loader.failed', {}, error);
            (_this$props$onError3 = (_this$props3 = this.props).onError) === null || _this$props$onError3 === void 0 || _this$props$onError3.call(_this$props3, error);
        }
    }
    render() {
        const error = this.state.error;
        return error ? this.props.renderError(error) : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
const $753b4a251032ae20$export$627f773fbbb39e = (0, $2usNr.default)()((0, $kIbto.default)()($753b4a251032ae20$var$ErrorBoundary));

});

parcelRegister("6bhLy", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $29ba91e32070df04$export$fb8d7f40caaeea67);

var $bSJIT = parcelRequire("bSJIT");

var $1qPbZ = parcelRequire("1qPbZ");

var $7qqGM = parcelRequire("7qqGM");
const $29ba91e32070df04$export$fb8d7f40caaeea67 = (options)=>{
    let displayName = 'unknown';
    if ('loader' in options) displayName = options.loader.displayName || 'unknown';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7qqGM.LoadingComponent), {
        LoadingSkeleton: options.LoadingSkeleton,
        timeout: options.timeout
    }));
};

});
parcelRegister("1qPbZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $16222ad969a46edb$export$2e2bcd8739ae039);

var $dDrKe = parcelRequire("dDrKe");
var $16222ad969a46edb$export$2e2bcd8739ae039 = (0, $dDrKe.default);

});
parcelRegister("dDrKe", function(module, exports) {
$parcel$export(module.exports, "default", () => $610b1606855cb0ce$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $aae7p = parcelRequire("aae7p");

var $lmUvw = parcelRequire("lmUvw");

var $cSYYL = parcelRequire("cSYYL");

var $fANwq = parcelRequire("fANwq");
const $610b1606855cb0ce$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $610b1606855cb0ce$var$useInteractionIdValue() {
    const interactionId = (0, $bSJIT.useContext)((0, $cSYYL.default));
    const [currentId, setCurrentId] = (0, $bSJIT.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
    $610b1606855cb0ce$var$useLayoutEffectSAFE(()=>{
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        const unsubscribe = (0, $fANwq.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $610b1606855cb0ce$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $aae7p.isUFOEnabled)();
    const currentInteractionId = $610b1606855cb0ce$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $bSJIT.useContext)((0, $lmUvw.default));
    $610b1606855cb0ce$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children) : null;
}

});


parcelRegister("7qqGM", function(module, exports) {
$parcel$export(module.exports, "LoadingComponent", () => $8caaf16c19ef52b6$export$7db30d367db7d20a);

var $bSJIT = parcelRequire("bSJIT");

var $i5HDF = parcelRequire("i5HDF");
const $8caaf16c19ef52b6$export$7db30d367db7d20a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(function LoadingComponent({ error: error, LoadingSkeleton: LoadingSkeleton, timeout: timeout, loadingPosition: loadingPosition }) {
    const [isTimedOut, setIsTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        let timer;
        if (timeout) timer = setTimeout(()=>{
            setIsTimedOut(true);
        }, timeout);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        timeout
    ]);
    if (LoadingSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(LoadingSkeleton, {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $i5HDF.default), {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition,
        timedOut: isTimedOut
    });
});

});
parcelRegister("i5HDF", function(module, exports) {
$parcel$export(module.exports, "ChunkLoadErrorMessage", () => $28bd00437327b3de$export$7bbd51879bbec526);
$parcel$export(module.exports, "SkeletonLoadingWrapper", () => $28bd00437327b3de$export$48d1937c6c46b883);
$parcel$export(module.exports, "default", () => $28bd00437327b3de$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $jcRK7 = parcelRequire("jcRK7");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $5cKiX = parcelRequire("5cKiX");

var $hkLEY = parcelRequire("hkLEY");

var $hDkm2 = parcelRequire("hDkm2");

var $1N5Pw = parcelRequire("1N5Pw");

var $hF8Ik = parcelRequire("hF8Ik");
const $28bd00437327b3de$var$ICON_SIZE = $9K7mZ.multiple(6);
const $28bd00437327b3de$export$7bbd51879bbec526 = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "",
        size: "medium",
        spacing: "spacious"
    }), /*#__PURE__*/ $bSJIT.createElement($28bd00437327b3de$var$Message, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $1N5Pw.default).error)));
};
const $28bd00437327b3de$export$fead96407cda089b = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-11ukfs2-0"
})`margin-top:${"var(--ds-space-025, 2px)"};`;
const $28bd00437327b3de$export$48d1937c6c46b883 = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $bSJIT.createElement($28bd00437327b3de$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $hF8Ik.LoadingSkeletonFields), null), props.timedOut && /*#__PURE__*/ $bSJIT.createElement($28bd00437327b3de$var$Message, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $1N5Pw.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $hF8Ik.AbsoluteFillContainer) : $28bd00437327b3de$var$Container;
    return /*#__PURE__*/ $bSJIT.createElement($28bd00437327b3de$export$fead96407cda089b, null, /*#__PURE__*/ $bSJIT.createElement(Wrapper, null, content));
};
const $28bd00437327b3de$var$Loading = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $bSJIT.createElement($28bd00437327b3de$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
        interactionName: props.interactionName || 'help-center-unknown-loader',
        delay: (0, $jcRK7.SPINNER_DELAY),
        appearance: "inherit",
        size: $28bd00437327b3de$var$ICON_SIZE.unitless
    }), props.timedOut && /*#__PURE__*/ $bSJIT.createElement($28bd00437327b3de$var$Message, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $1N5Pw.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $hF8Ik.AbsoluteFillContainer) : $28bd00437327b3de$var$Container;
    return /*#__PURE__*/ $bSJIT.createElement(Wrapper, {
        "data-testid": "loading-container"
    }, content);
};
var $28bd00437327b3de$export$2e2bcd8739ae039 = $28bd00437327b3de$var$Loading;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $28bd00437327b3de$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-11ukfs2-1"
})`${$fU62V.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $28bd00437327b3de$var$Message = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-11ukfs2-2"
})`${$98sDU.small};margin-top:${"var(--ds-space-100, 8px)"};`;

});
parcelRegister("1N5Pw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec7e976e8f3da390$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ec7e976e8f3da390$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    error: {
        defaultMessage: 'There was a problem loading, please refresh and try again.',
        description: 'Error message shown when something could not be loaded.',
        id: 'cv.loading.component.error'
    },
    timeout: {
        defaultMessage: 'Taking longer than usual...',
        description: 'Message shown when loading is taking a long time.',
        id: 'cv.loading.component.timeout'
    }
});

});

parcelRegister("hF8Ik", function(module, exports) {
$parcel$export(module.exports, "AbsoluteFillContainer", () => $28955fc28880f360$export$c55b13eeae4b9470);
$parcel$export(module.exports, "LoadingSkeleton", () => $28955fc28880f360$export$44c18d210d5de37b);
$parcel$export(module.exports, "FieldLoadingSkeleton", () => $28955fc28880f360$export$e2529b450e72f74e);
$parcel$export(module.exports, "AvatarLoadingSkeleton", () => $28955fc28880f360$export$281e083a77da722c);
$parcel$export(module.exports, "LoadingSkeletonFields", () => $28955fc28880f360$export$1844a556d867ecb4);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $4ZMmh = parcelRequire("4ZMmh");
const $28955fc28880f360$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ovlcu-0"
})`${$fU62V.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
const $28955fc28880f360$export$c55b13eeae4b9470 = /*#__PURE__*/ (0, $4v2A7.default)($28955fc28880f360$export$42a852a2b6b56249).withConfig({
    componentId: "sc-3ovlcu-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;`;
const $28955fc28880f360$var$fromPositionX = -400;
const $28955fc28880f360$var$toPositionX = 800;
const $28955fc28880f360$var$shimmer = /*#__PURE__*/ (0, $4v2A7.keyframes)({
    '0%': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        backgroundPosition: `${$28955fc28880f360$var$fromPositionX}px 0`
    },
    '100%': {
        backgroundPosition: `${$28955fc28880f360$var$toPositionX}px 0`
    }
});
const $28955fc28880f360$export$44c18d210d5de37b = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ovlcu-2"
})`${$fU62V.borderRadius};height:${(props)=>`${props.height}px`};background-color:${(props)=>props.backgroundColor};background-image:linear-gradient( to right,${(props)=>props.backgroundColor} 10%,${"var(--ds-surface, #FFFFFF)"} 40%,${(props)=>props.backgroundColor} 50% );background-repeat:no-repeat;animation-duration:0.8s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$28955fc28880f360$var$shimmer};animation-timing-function:ease-in;`;
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $28955fc28880f360$var$FieldSkeletonWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ovlcu-3"
})`${$fU62V.borderRadius};border:${"var(--ds-border-width-selected, 2px)"} solid;border-color:${"var(--ds-border, #DFE1E6)"};`;
const $28955fc28880f360$export$e2529b450e72f74e = ()=>/*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$var$FieldSkeletonWrapper, null, /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$44c18d210d5de37b, {
        height: 150,
        backgroundColor: "var(--ds-skeleton-subtle, #FAFBFC)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $28955fc28880f360$var$AvatarSkeletonWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ovlcu-4"
})`min-width:${$9K7mZ.multiple(4.5).px};border-radius:50%;overflow:hidden;`;
const $28955fc28880f360$export$281e083a77da722c = ()=>/*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$var$AvatarSkeletonWrapper, null, /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$44c18d210d5de37b, {
        height: 36,
        backgroundColor: "var(--ds-skeleton, #EBECF0)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $28955fc28880f360$var$TextFieldLoadingSkeletonWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ovlcu-5"
})`margin-top:${"var(--ds-space-500, 40px)"};margin-bottom:${"var(--ds-space-500, 40px)"};`;
const $28955fc28880f360$export$66b8cea0c448285 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ovlcu-6"
})`width:100%;`;
const $28955fc28880f360$export$37ec45a296aa56b5 = ({ shortText: shortText })=>{
    return /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$var$TextFieldLoadingSkeletonWrapper, null, /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$44c18d210d5de37b, {
        height: shortText ? $9K7mZ.multiple(5).unitless : $9K7mZ.multiple(22).unitless,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    }));
};
const $28955fc28880f360$export$1844a556d867ecb4 = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$66b8cea0c448285, null, (0, $4ZMmh.range)(3).map((ndx)=>/*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$37ec45a296aa56b5, {
            key: ndx,
            shortText: true
        })), /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$37ec45a296aa56b5, {
        shortText: false
    }), /*#__PURE__*/ $bSJIT.createElement($28955fc28880f360$export$37ec45a296aa56b5, {
        shortText: true
    })));
};

});






parcelRegister("jFrsf", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("13X7O"),
    $kOunM("9qnWW")
]).then(()=>parcelRequire('eaUFb'));

});


parcelRegister("jKUwF", function(module, exports) {
$parcel$export(module.exports, "MarkAppMounted", () => (parcelRequire("hGKjg")).MarkAppMounted);
$parcel$export(module.exports, "isAppMounted", () => (parcelRequire("hGKjg")).isAppMounted);

var $hGKjg = parcelRequire("hGKjg");

});
parcelRegister("hGKjg", function(module, exports) {
$parcel$export(module.exports, "isAppMounted", () => $8dc2acadf93c3bec$export$495d224993f5c3c8);
$parcel$export(module.exports, "MarkAppMounted", () => $8dc2acadf93c3bec$export$2525a7fc0773bc4d);

var $bSJIT = parcelRequire("bSJIT");
let $8dc2acadf93c3bec$var$isMounted = false;
function $8dc2acadf93c3bec$var$setIsMounted(value) {
    $8dc2acadf93c3bec$var$isMounted = value;
}
const $8dc2acadf93c3bec$export$495d224993f5c3c8 = {
    /** Readonly value and is set only from MarkAppMounted */ get value () {
        return $8dc2acadf93c3bec$var$isMounted;
    }
};
const $8dc2acadf93c3bec$export$2525a7fc0773bc4d = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        $8dc2acadf93c3bec$var$setIsMounted(true);
    }, []);
    return null;
};

});


parcelRegister("6luvg", function(module, exports) {
$parcel$export(module.exports, "default", () => $accd680dec2cc3ef$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");
const $accd680dec2cc3ef$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $accd680dec2cc3ef$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $accd680dec2cc3ef$var$textStyles = {
    root: "_11c8fhey _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $accd680dec2cc3ef$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $accd680dec2cc3ef$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $accd680dec2cc3ef$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $accd680dec2cc3ef$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $accd680dec2cc3ef$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $accd680dec2cc3ef$var$Banner = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $accd680dec2cc3ef$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $accd680dec2cc3ef$var$containerStyles.root,
        backgroundColor: $accd680dec2cc3ef$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $accd680dec2cc3ef$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    as: "span",
                    xcss: $accd680dec2cc3ef$var$iconWrapperStyles.root,
                    style: {
                        fill: $accd680dec2cc3ef$var$tokenBackgroundColors[appearanceType],
                        color: $accd680dec2cc3ef$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    style: {
                        [$accd680dec2cc3ef$var$CSS_VAR_TEXT_COLOR]: $accd680dec2cc3ef$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $9fU1q.default)([
                        $accd680dec2cc3ef$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $accd680dec2cc3ef$export$2e2bcd8739ae039 = $accd680dec2cc3ef$var$Banner;

});

parcelRegister("9ym5V", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $62c50efefd175ec4$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightConsumer", () => $62c50efefd175ec4$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $62c50efefd175ec4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $57l7A = parcelRequire("57l7A");

var $1OdZP = parcelRequire("1OdZP");

var $jvbf5 = parcelRequire("jvbf5");

var $8W36W = parcelRequire("8W36W");

var $cglph = parcelRequire("cglph");

var $ijjRO = parcelRequire("ijjRO");

var $4eGW1 = parcelRequire("4eGW1");
const $62c50efefd175ec4$var$dest = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $62c50efefd175ec4$export$f643dd64c1952cc8 = $62c50efefd175ec4$var$dest.Consumer;
const $62c50efefd175ec4$var$TargetProvider = $62c50efefd175ec4$var$dest.Provider;
const $62c50efefd175ec4$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $bSJIT.createContext)({
    opened: (0, $1OdZP.default),
    closed: (0, $1OdZP.default),
    targets: {}
});
const $62c50efefd175ec4$export$3503199acd121708 = $62c50efefd175ec4$export$7b5aa0f5b37a336d.Consumer;
const $62c50efefd175ec4$var$SpotlightStateProvider = $62c50efefd175ec4$export$7b5aa0f5b37a336d.Provider;
const $62c50efefd175ec4$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Wrapper, null, children);
class $62c50efefd175ec4$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    static #_ = this.defaultProps = {
        blanketIsTinted: true
    };
    componentDidMount() {
        typeof $4eGW1;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($62c50efefd175ec4$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($62c50efefd175ec4$var$TargetProvider, {
            value: this.getTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($62c50efefd175ec4$var$Container, {
            component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jvbf5.default), null, isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8W36W.default), {
            duration: "medium"
        }, ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cglph.default), {
                zIndex: 700
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ijjRO.default), {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                style: style,
                isTinted: blanketIsTinted,
                onBlanketClicked: onBlanketClicked
            })))), children)));
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
   * When enabling React Streaming in Confluence, a
   * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
   * error happens.
   * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
   */ this.getTargetRef = (name)=>(element)=>{
                (0, $bSJIT.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $57l7A.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("ijjRO", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bed9a898644c684$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $1bed9a898644c684$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $1bed9a898644c684$var$Blanket = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $1bed9a898644c684$export$2e2bcd8739ae039 = $1bed9a898644c684$var$Blanket;

});


parcelRegister("cNer2", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusContext", () => $fa17f92344262e69$export$2b9bf691adcf6b30);
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusProvider", () => $fa17f92344262e69$export$71210ed9cdfad1f5);
$parcel$export(module.exports, "default", () => $fa17f92344262e69$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $db841 = parcelRequire("db841");

var $6JJ8C = parcelRequire("6JJ8C");
const $fa17f92344262e69$export$2b9bf691adcf6b30 = /*#__PURE__*/ $bSJIT.createContext({
    preventBrowserMetricsTimerResetOnScreenMount: false,
    startBrowserMetricsTransitionToNewScreen: ()=>undefined,
    stopBrowserMetricsTransitionToNewScreen: ()=>undefined
});
class $fa17f92344262e69$export$71210ed9cdfad1f5 extends $bSJIT.Component {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement($fa17f92344262e69$export$2b9bf691adcf6b30.Provider, {
            value: {
                preventBrowserMetricsTimerResetOnScreenMount: this.state.preventBrowserMetricsTimerResetOnScreenMount,
                startBrowserMetricsTransitionToNewScreen: this.startTransitionToNewScreen,
                stopBrowserMetricsTransitionToNewScreen: this.stopTransitionToNewScreen
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            preventBrowserMetricsTimerResetOnScreenMount: false
        }, /**
   * Explicitly start the browsermetrics timer,
   * and set state that will prevent the timer from being reset when we eventually transition to the new screen.
   */ this.startTransitionToNewScreen = (screenName)=>{
            (0, $6JJ8C.devLog)('Browser metrics: starting timer for new screen before transition:', screenName);
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: true
            });
            /**
     * Browser metrics v3 start page load
     */ (0, $db841.startPageLoad)(screenName);
        }, /**
   * Stop measuring any transition that may have been started.
   * This must be called any time the transition does not go ahead, e.g. if there are errors in a form submission
   * This will also be called any time an AnalyticsScreen component is mounted,
   * so you won't need to call this yourself if the transition is successful
   */ this.stopTransitionToNewScreen = ()=>{
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: false
            });
        };
    }
}
const $fa17f92344262e69$var$withBrowserMetricsScreenTransitionStatus = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $bSJIT.createElement($fa17f92344262e69$export$2b9bf691adcf6b30.Consumer, null, (value)=>/*#__PURE__*/ $bSJIT.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $fa17f92344262e69$export$2e2bcd8739ae039 = $fa17f92344262e69$var$withBrowserMetricsScreenTransitionStatus;

});

parcelRegister("bQGlA", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterAri", () => $c38f812746754e89$export$ac08ed49e9190090);

var $gEVth = parcelRequire("gEVth");

var $iW3CQ = parcelRequire("iW3CQ");
const $c38f812746754e89$export$ac08ed49e9190090 = ()=>{
    const traceId = (0, $iW3CQ.getEnv)().traceId;
    (0, $gEVth.operationalEvent)({
        action: 'emptyHelpCenterAriReceived',
        actionSubject: 'help-center-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("48InE", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterLayoutAri", () => $3f4593989efe44b8$export$c36b085b938f36b6);

var $gEVth = parcelRequire("gEVth");

var $iW3CQ = parcelRequire("iW3CQ");
const $3f4593989efe44b8$export$c36b085b938f36b6 = ()=>{
    const traceId = (0, $iW3CQ.getEnv)().traceId;
    (0, $gEVth.operationalEvent)({
        action: 'emptyHelpCenterLayoutAriReceived',
        actionSubject: 'help-center-layout-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("5LT7v", function(module, exports) {
$parcel$export(module.exports, "hasValidHelpCenterARI", () => $06d5103cad2e9c4b$export$a15bc0aef789ec4c);

var $fuVmc = parcelRequire("fuVmc");
const $06d5103cad2e9c4b$var$EMPTY_VALUES_LIST = [
    'undefined',
    'null'
];
const $06d5103cad2e9c4b$export$a15bc0aef789ec4c = ()=>{
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    return Boolean(helpCenterAri) && !$06d5103cad2e9c4b$var$EMPTY_VALUES_LIST.includes(helpCenterAri);
};

});

parcelRegister("cvZci", function(module, exports) {
$parcel$export(module.exports, "isBrowserUnsupported", () => $5c5eada922907ab7$export$dfffa53722e06033);
$parcel$export(module.exports, "isOldSafari", () => $5c5eada922907ab7$export$572d6d0be4ae9ec5);
$parcel$export(module.exports, "isIE7", () => $5c5eada922907ab7$export$e7ef7234dd9b1f65);
/**
 * Unsupported browsers regex generated using command -
 * npx browserslist-useragent-regexp "Firefox 60 , Firefox 61, Firefox 68, Firefox 72, Safari 12, Safari 15, iOS 12, iOS 15".
 * All unsupported browser versions can be viewed on https://browserslist.dev/, using above query.
 * These browser versions do not support Intersection Observer API.
 * Safari > 12.0 and iOS > 12.1 supports this API but does not support "options.root" parameter to be a Document
 * */ const $5c5eada922907ab7$export$67d4cb90585439f7 = new RegExp(/Firefox\/(6[01]\.0|68\.0|72\.0)(\.\d+|)|Maci.+ Version\/(12\.0|15\.0)([,.]\d+|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(12[._][01]|15[._][01])([._]\d+|)/);
const $5c5eada922907ab7$export$dfffa53722e06033 = (regex = $5c5eada922907ab7$export$67d4cb90585439f7)=>{
    if (!(navigator && navigator.userAgent)) return true;
    if (regex && regex.test) return regex.test(navigator.userAgent);
    return false;
};
function $5c5eada922907ab7$export$572d6d0be4ae9ec5() {
    const userAgentString = navigator.userAgent;
    const safariAgent = userAgentString.indexOf('Safari') > -1;
    // If the current browser is Safari
    if (safariAgent) {
        var _userAgentString$spli;
        const safariVersion = parseInt((_userAgentString$spli = userAgentString.split('Version/')) === null || _userAgentString$spli === void 0 || (_userAgentString$spli = _userAgentString$spli[1]) === null || _userAgentString$spli === void 0 ? void 0 : _userAgentString$spli.split(' Safari')[0], 10);
        // If the Safari version is less than 14
        if (safariVersion < 14) return true;
    }
    return false;
}
function $5c5eada922907ab7$export$e7ef7234dd9b1f65() {
    const userAgentString = navigator.userAgent;
    const msieAgent = userAgentString.indexOf('MSIE') > -1;
    // If the current browser is Internet Explorer
    if (msieAgent) {
        const ieVersion = parseInt(userAgentString.split('MSIE ')[1].split(';')[0], 10);
        // If the IE version is 7
        if (ieVersion === 7) return true;
    }
    return false;
}

});

parcelRegister("3U5mo", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => (parcelRequire("dNTWA")).Heartbeat);

var $dNTWA = parcelRequire("dNTWA");

});
parcelRegister("dNTWA", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => $28f0e20d77c9fd54$export$38f39b921d5551c1);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $3HBS2 = parcelRequire("3HBS2");

var $hI4SP = parcelRequire("hI4SP");
const $28f0e20d77c9fd54$export$b5257641a9b528be = ()=>{
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments.includes('login')) return;
    if (pathSegments.includes('helpcenter-management')) {
        window.location.href = `/servicedesk/customer/user/login`;
        return;
    }
    const path = window.location.pathname + window.location.search;
    const match = path.match(/\/portal\/(\d+)/);
    const portalId = match ? Number(match[1]) : undefined;
    const basePath = pathSegments.slice(0, 2).join('/');
    const loginBasePath = portalId ? `/${basePath}/portal/${portalId}/user/login` : `/${basePath}/user/login`;
    const destination = pathSegments.slice(2).join('/');
    window.location.href = `${loginBasePath}?destination=${encodeURIComponent(destination + window.location.search)}`;
};
const $28f0e20d77c9fd54$export$461970fb9101e674 = ({ isLoggedIn: isLoggedIn })=>{
    return isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hI4SP.AsyncHeartbeat), {
        idleTime: 1200000,
        onAuthenticationFailed: $28f0e20d77c9fd54$export$b5257641a9b528be
    }) : null;
};
const $28f0e20d77c9fd54$export$38f39b921d5551c1 = (0, $f2mlD.default)((state)=>{
    return {
        isLoggedIn: (0, $3HBS2.isLoggedIn)(state)
    };
})($28f0e20d77c9fd54$export$461970fb9101e674);

});
parcelRegister("3HBS2", function(module, exports) {
$parcel$export(module.exports, "getAccountId", () => $5dc3d44e14a6b906$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getEmail", () => $5dc3d44e14a6b906$export$d29968a6889079e0);
$parcel$export(module.exports, "getDisplayName", () => $5dc3d44e14a6b906$export$be63e0664592e141);
$parcel$export(module.exports, "isLoggedIn", () => $5dc3d44e14a6b906$export$256a5a3564694cfc);
$parcel$export(module.exports, "getLocale", () => $5dc3d44e14a6b906$export$180605366c04f0cd);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $5dc3d44e14a6b906$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $5dc3d44e14a6b906$export$c5f994129d97ed23);
$parcel$export(module.exports, "getCustomMenuLinks", () => $5dc3d44e14a6b906$export$bf9a934424e2dbf1);
$parcel$export(module.exports, "getAvatarSrc", () => $5dc3d44e14a6b906$export$35125d98e6f1484);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => $5dc3d44e14a6b906$export$9055c338585b9def);
const $5dc3d44e14a6b906$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $5dc3d44e14a6b906$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $5dc3d44e14a6b906$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName || state.persisted.user.email || '';
};
const $5dc3d44e14a6b906$export$256a5a3564694cfc = (state)=>{
    return state.persisted.user.isLoggedIn;
};
const $5dc3d44e14a6b906$export$180605366c04f0cd = (state)=>{
    return state.persisted.user.language.key;
};
const $5dc3d44e14a6b906$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $5dc3d44e14a6b906$export$c5f994129d97ed23 = (state)=>{
    var _state$persisted$user;
    return ((_state$persisted$user = state.persisted.user) === null || _state$persisted$user === void 0 ? void 0 : _state$persisted$user.hasSiteAdministerAccess) || false;
};
const $5dc3d44e14a6b906$export$bf9a934424e2dbf1 = (state)=>{
    return state.persisted.user.customMenuLinks;
};
const $5dc3d44e14a6b906$export$35125d98e6f1484 = (state)=>{
    var _state$persisted$user2;
    return (_state$persisted$user2 = state.persisted.user.avatars) === null || _state$persisted$user2 === void 0 ? void 0 : _state$persisted$user2.xlarge;
};
const $5dc3d44e14a6b906$export$9055c338585b9def = (state)=>{
    return state.persisted.user.atlassianAccountManaged;
};

});

parcelRegister("hI4SP", function(module, exports) {
$parcel$export(module.exports, "AsyncHeartbeat", () => $4933dd702d13e64d$export$503c0e70c2bcbfc7);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $4933dd702d13e64d$export$503c0e70c2bcbfc7 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("6h5hj")), {
        moduleId: "../platform/packages/security/heartbeat/src/index.ts"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("6h5hj", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4fZrU").then(()=>parcelRequire('iPu5b'));

});




parcelRegister("b607P", function(module, exports) {
$parcel$export(module.exports, "AppContainer", () => $9a466f38efd65b39$export$7469f2cda7546515);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $9a466f38efd65b39$export$7469f2cda7546515 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("iIzvt")), {
        moduleId: "./src/view/app-container/app-container.tsx"
    })
});

});
parcelRegister("iIzvt", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5JDXS").then(()=>parcelRequire('5SIeH'));

});


parcelRegister("9bhHx", function(module, exports) {
$parcel$export(module.exports, "CSMResourceRouterNew", () => $7320a528c8620326$export$a487b0571b6a921a);
$parcel$export(module.exports, "default", () => $7320a528c8620326$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $9cDCX = parcelRequire("9cDCX");

var $f9uTr = parcelRequire("f9uTr");

parcelRequire("5lPCP");
var $7t0F6 = parcelRequire("7t0F6");
var $2a9Vu = parcelRequire("2a9Vu");

var $eLLBi = parcelRequire("eLLBi");

var $jNbk7 = parcelRequire("jNbk7");

var $5Or3j = parcelRequire("5Or3j");

var $8D35l = parcelRequire("8D35l");

var $eNwcA = parcelRequire("eNwcA");

var $7FwJ0 = parcelRequire("7FwJ0");

var $a1EwW = parcelRequire("a1EwW");

var $1Ajtz = parcelRequire("1Ajtz");

var $75GyY = parcelRequire("75GyY");

var $9TNJA = parcelRequire("9TNJA");

var $5Yb8O = parcelRequire("5Yb8O");

var $8b9fA = parcelRequire("8b9fA");

var $XiIOl = parcelRequire("XiIOl");

var $ebTuA = parcelRequire("ebTuA");

var $4T2Ew = parcelRequire("4T2Ew");

var $QUECd = parcelRequire("QUECd");

var $hFRc4 = parcelRequire("hFRc4");

var $ajLNc = parcelRequire("ajLNc");

var $2Wfvm = parcelRequire("2Wfvm");

var $Iy9X2 = parcelRequire("Iy9X2");

var $ab40o = parcelRequire("ab40o");

var $2ylQX = parcelRequire("2ylQX");

var $bcBh3 = parcelRequire("bcBh3");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $8VdVQ = parcelRequire("8VdVQ");
parcelRequire("i7Znb");
var $eV8mZ = parcelRequire("eV8mZ");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $4WbWW = parcelRequire("4WbWW");

var $9Iriq = parcelRequire("9Iriq");

var $fHAr3 = parcelRequire("fHAr3");
parcelRequire("dgMoN");
var $hWMM6 = parcelRequire("hWMM6");
var $36cmj = parcelRequire("36cmj");
// Helper function to determine which requests list route to use
const $7320a528c8620326$var$getRequestsListRoute = ()=>{
    const isHubsEnabled = (0, $lFpPv.isHubsEnabledInHelpCenter)();
    if (isHubsEnabled) return (0, $eV8mZ.getCsmRequestsListRouteWithHubShell)();
    return 0, $75GyY.csmRequestsListRoute;
};
const $7320a528c8620326$var$getCustomPageRoutes = ()=>{
    return (0, $iW3CQ.getIsHCCustomizationEnabled)() ? [
        (0, $5Yb8O.getEditCustomPageRoute)(),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getHubCustompageRoute)() : (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $7FwJ0.getViewCustomPageRoute)())
    ] : [];
};
const $7320a528c8620326$var$getAnonymousRoutes = ()=>{
    return [
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getLoginRouteWithHubShell)() : (0, $QUECd.loginRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getResetPasswordRouteWithHubShell)() : (0, $ab40o.userResetPasswordRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getSignupRouteWithHubShell)() : (0, $ab40o.userSignupRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCompleteSignupRouteWithHubShell)() : (0, $ab40o.userCompleteSignupRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCheckEmailRouteWithHubShell)() : (0, $ab40o.userCheckMailRoute)
    ];
};
const $7320a528c8620326$var$getActiveCsmRoutes = ()=>{
    return {
        activeViewArticleRoute: (0, $1Ajtz.csmViewArticleRoute),
        activeKbPageRoute: (0, $1Ajtz.csmViewKbPageRoute),
        activeCrossSiteArticleRoute: (0, $1Ajtz.csmViewCrossSiteArticleRoute),
        activeUserProfileRoute: (0, $9TNJA.csmUserProfileRoute)
    };
};
const $7320a528c8620326$var$getAccessAndAuthenticationRoutes = ()=>{
    return [
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getPortalAccessForbiddenRouteWithHubShell)() : (0, $hFRc4.portalAccessForbiddenRoute),
        (0, $QUECd.portalLoginRoute),
        (0, $ab40o.portalSignupRoute),
        (0, $ab40o.portalResetPasswordRoute),
        (0, $ab40o.portalCompleteSignupRoute),
        (0, $ab40o.portalInvitedSignupRoute)
    ];
};
const $7320a528c8620326$var$getUserProfileRoute = ()=>{
    const { activeUserProfileRoute: activeUserProfileRoute } = $7320a528c8620326$var$getActiveCsmRoutes();
    return (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmUserProfileRouteWithHubShell)() : activeUserProfileRoute);
};
const $7320a528c8620326$var$getSearchAndArticleRoutes = ()=>{
    const { activeViewArticleRoute: activeViewArticleRoute, activeKbPageRoute: activeKbPageRoute, activeCrossSiteArticleRoute: activeCrossSiteArticleRoute } = $7320a528c8620326$var$getActiveCsmRoutes();
    return [
        (0, $4WbWW.routeWithAiWidgetConfigResource)(activeKbPageRoute),
        (0, $4T2Ew.viewAllSearchResultsRoute),
        (0, $4T2Ew.viewPortalAllSearchResultsRoute),
        (0, $4T2Ew.viewPortalCategoryArticleRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmViewPortalArticleRouteWithHubShell)() : (0, $4T2Ew.viewPortalArticleRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmViewCrossSitePortalArticleRouteWithHubShell)() : (0, $4T2Ew.viewCrossSitePortalArticleRoute),
        (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmViewArticleRouteWithHubShell)() : activeViewArticleRoute),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmViewCrossSiteArticleRouteWithHubShell)() : activeCrossSiteArticleRoute
    ];
};
const $7320a528c8620326$var$getContactUsRoute = ()=>{
    return (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmContactUsRouteWithHubShell)() : (0, $eNwcA.csmContactUsRoute));
};
const $7320a528c8620326$export$30b4ff4634181478 = ()=>{
    const isAdvancedOrFlexiHCEnabled = (0, $hCnLH.isAdvancedHelpCenter)() || (0, $hCnLH.isFlexiHCEnabledInDefaultHC)();
    return [
        ...(0, $lFpPv.isHubsEnabledInHelpCenter)() ? [
            (0, $eV8mZ.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $eLLBi.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $eLLBi.getEditHomePageRoute)()
        ] : [],
        ...(0, $lFpPv.isEmailVerifiedSignalEnabled)() ? [
            (0, $bcBh3.userVerifyEmailRoute)
        ] : [],
        (0, $jNbk7.aiAnswerRoute),
        (0, $8D35l.consentFormRoute),
        ...$7320a528c8620326$var$getAnonymousRoutes(),
        ...$7320a528c8620326$var$getAccessAndAuthenticationRoutes(),
        (0, $hWMM6.requestFeedbackRoute),
        (0, $hWMM6.unsubscribeRoute),
        (0, $ebTuA.getHelpCenterRoute)(),
        (0, $Iy9X2.requestDetailsRoute),
        ...$7320a528c8620326$var$getSearchAndArticleRoutes(),
        (0, $4WbWW.routeWithAiWidgetConfigResource)($7320a528c8620326$var$getRequestsListRoute()),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmRequestDetailsRouteWithHubShell)() : (0, $75GyY.csmRequestDetailsRoute),
        (0, $hWMM6.helpCenterRequestFeedbackRoute),
        (0, $5Or3j.approvalsRoute),
        (0, $2Wfvm.requestApprovalRoute),
        $7320a528c8620326$var$getUserProfileRoute(),
        (0, $4T2Ew.viewPortalKnowledgeCategoryRoute),
        (0, $hWMM6.anonymousRequestSuccessRoute),
        (0, $hWMM6.getRequestCreateRoute)(),
        (0, $ajLNc.getPortalHomeRoutes)(),
        (0, $XiIOl.getEmbedCreateRequestRoute)(),
        (0, $XiIOl.embedSinglePortalRoute),
        (0, $XiIOl.embedKBArticleRoute),
        (0, $36cmj.portalReorderRoute)(true),
        (0, $8b9fA.editTopicRoute),
        (0, $8b9fA.addTopicRoute),
        (0, $2ylQX.getViewTopicRoute)(),
        $7320a528c8620326$var$getContactUsRoute(),
        (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmFolderRouteWithHubShell)() : (0, $a1EwW.csmFolderRoute)),
        ...$7320a528c8620326$var$getCustomPageRoutes(),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getNotFoundRouteWithHubShell)() : (0, $hWMM6.notFoundErrorRoute)
    ];
};
const $7320a528c8620326$export$8dfc12d998aeca9c = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $9cDCX.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $9cDCX.lightenColor)(themeColor);
    const routes = (0, $bSJIT.useMemo)(()=>{
        return $7320a528c8620326$export$30b4ff4634181478();
    }, []);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4v2A7.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2a9Vu.Router), {
        routes: routes,
        history: (0, $eDcdn.default),
        isGlobal: false,
        plugins: [
            (0, $fHAr3.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f9uTr.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8VdVQ.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7t0F6.RouteComponent), null)));
};
const $7320a528c8620326$var$selectorOld = (0, $BOq7h.createSelector)((0, $fOlM6.getHeadless), (0, $hvIQS.getThemeColor), (0, $hvIQS.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
const $7320a528c8620326$export$2f7745f2f5ab3897 = ({ externalCustomer: externalCustomer })=>{
    // Routes that are restricted to non external users when
    // base path is /servicedesk/customer and customerAccountAvailabilty is JCS_ONLY
    const isAdvancedOrFlexiHCEnabled = (0, $hCnLH.isAdvancedHelpCenter)() || (0, $hCnLH.isFlexiHCEnabledInDefaultHC)();
    const restrictedRoutes = [
        ...(0, $lFpPv.isHubsEnabledInHelpCenter)() ? [
            (0, $eV8mZ.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $eLLBi.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $eLLBi.getEditHomePageRoute)()
        ] : [],
        ...(0, $lFpPv.isEmailVerifiedSignalEnabled)() ? [
            (0, $bcBh3.userVerifyEmailRoute)
        ] : [],
        (0, $jNbk7.aiAnswerRoute),
        (0, $8D35l.consentFormRoute),
        ...$7320a528c8620326$var$getAnonymousRoutes(),
        ...$7320a528c8620326$var$getAccessAndAuthenticationRoutes(),
        (0, $hWMM6.requestFeedbackRoute),
        (0, $hWMM6.unsubscribeRoute),
        (0, $ebTuA.getHelpCenterRoute)(),
        (0, $Iy9X2.requestDetailsRoute),
        ...$7320a528c8620326$var$getSearchAndArticleRoutes(),
        (0, $4WbWW.routeWithAiWidgetConfigResource)($7320a528c8620326$var$getRequestsListRoute()),
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmRequestDetailsRouteWithHubShell)() : (0, $75GyY.csmRequestDetailsRoute),
        (0, $hWMM6.helpCenterRequestFeedbackRoute),
        (0, $5Or3j.approvalsRoute),
        (0, $2Wfvm.requestApprovalRoute),
        $7320a528c8620326$var$getUserProfileRoute(),
        (0, $XiIOl.getEmbedCreateRequestRoute)(),
        (0, $XiIOl.embedSinglePortalRoute),
        (0, $XiIOl.embedKBArticleRoute),
        $7320a528c8620326$var$getContactUsRoute(),
        (0, $4WbWW.routeWithAiWidgetConfigResource)((0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getCsmFolderRouteWithHubShell)() : (0, $a1EwW.csmFolderRoute)),
        ...$7320a528c8620326$var$getCustomPageRoutes()
    ];
    return [
        ...(0, $hCnLH.isJcsOnlyRestrictedRoute)((0, $iW3CQ.getEnv)().customerAccountAvailabilty) && externalCustomer ? [] : restrictedRoutes,
        (0, $lFpPv.isHubsEnabledInHelpCenter)() ? (0, $eV8mZ.getNotFoundRouteWithHubShell)() : (0, $hWMM6.notFoundErrorRoute)
    ];
};
const $7320a528c8620326$export$7abc1d14de40c7e1 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor, user: user } = props;
    const readableTextColorFromTheme = (0, $9cDCX.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $9cDCX.lightenColor)(themeColor);
    const routes = (0, $bSJIT.useMemo)(()=>{
        return $7320a528c8620326$export$2f7745f2f5ab3897({
            externalCustomer: user === null || user === void 0 ? void 0 : user.externalCustomer
        });
    }, [
        user
    ]);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    // If JCS_ONLY and accessing a JSM route (path starts with /servicedesk/customer) and the user is not external, redirect to JSM
    if ((0, $hCnLH.isJcsOnlyRestrictedRoute)((0, $iW3CQ.getEnv)().customerAccountAvailabilty) && !(user !== null && user !== void 0 && user.externalCustomer)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Iriq.default), null);
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4v2A7.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2a9Vu.Router), {
        routes: routes,
        history: (0, $eDcdn.default),
        isGlobal: false,
        plugins: [
            (0, $fHAr3.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f9uTr.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8VdVQ.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7t0F6.RouteComponent), null)));
};
const $7320a528c8620326$var$selector = (0, $BOq7h.createSelector)((0, $fOlM6.getHeadless), (0, $hvIQS.getThemeColor), (0, $hvIQS.getHelpCenterTitleColor), (state)=>(0, $fBLyB.getUserState)(state), (headerless, themeColor, titleColor, userState)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor,
        user: {
            externalCustomer: userState.externalCustomer
        }
    }));
const $7320a528c8620326$export$a487b0571b6a921a = (0, $f2mlD.default)($7320a528c8620326$var$selector)($7320a528c8620326$export$7abc1d14de40c7e1);
var $7320a528c8620326$export$2e2bcd8739ae039 = (0, $f2mlD.default)($7320a528c8620326$var$selectorOld)($7320a528c8620326$export$8dfc12d998aeca9c);

});
parcelRegister("9cDCX", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $881100bcc6cd082b$export$3d31854eb05903e0);
$parcel$export(module.exports, "lightenColor", () => $881100bcc6cd082b$export$3abf4abc58accee2);

var $gdFS3 = parcelRequire("gdFS3");
const $881100bcc6cd082b$export$3d31854eb05903e0 = (color)=>{
    return (0, $gdFS3.getLuminance)(color) > 0.5 ? "var(--ds-text, #172B4D)" : "var(--ds-text-inverse, #FFFFFF)";
};
const $881100bcc6cd082b$export$3abf4abc58accee2 = (color)=>{
    return (0, $gdFS3.transparentize)(0.8, color);
};

});
parcelRegister("gdFS3", function(module, exports) {
$parcel$export(module.exports, "darken", () => $bcee56e7524e90f3$export$4b073707ff63303);
$parcel$export(module.exports, "getLuminance", () => $bcee56e7524e90f3$export$c852d90bf7403b62);
$parcel$export(module.exports, "lighten", () => $bcee56e7524e90f3$export$c0816ed86df316af);
$parcel$export(module.exports, "transparentize", () => $bcee56e7524e90f3$export$d11da87e55cc498f);

var $g8vBZ = parcelRequire("g8vBZ");

var $g2Nx4 = parcelRequire("g2Nx4");
// @private
function $bcee56e7524e90f3$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $bcee56e7524e90f3$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $bcee56e7524e90f3$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $bcee56e7524e90f3$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $bcee56e7524e90f3$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$bcee56e7524e90f3$var$generateProperty(property, $bcee56e7524e90f3$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $bcee56e7524e90f3$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $bcee56e7524e90f3$var$generateStyles(property, valuesWithDefaults);
}
function $bcee56e7524e90f3$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $bcee56e7524e90f3$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $bcee56e7524e90f3$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$bcee56e7524e90f3$var$endsWith(pxval, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
            newPxval = $bcee56e7524e90f3$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$bcee56e7524e90f3$var$endsWith(base, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
            newBase = $bcee56e7524e90f3$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        if (typeof newBase === 'string') throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        return "" + newPxval / newBase + to;
    };
};
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $bcee56e7524e90f3$export$c63c6f932822f543 = /*#__PURE__*/ $bcee56e7524e90f3$var$pxtoFactory('em');
var $bcee56e7524e90f3$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */ function $bcee56e7524e90f3$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($bcee56e7524e90f3$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
var $bcee56e7524e90f3$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $bcee56e7524e90f3$var$getRatio(ratioName) {
    return $bcee56e7524e90f3$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $bcee56e7524e90f3$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$bcee56e7524e90f3$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $bcee56e7524e90f3$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $bcee56e7524e90f3$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
    return realBase * Math.pow(realRatio, steps) + "em";
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $bcee56e7524e90f3$export$fb1897a40d146f7f = /*#__PURE__*/ $bcee56e7524e90f3$var$pxtoFactory('rem');
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $bcee56e7524e90f3$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $bcee56e7524e90f3$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $bcee56e7524e90f3$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $bcee56e7524e90f3$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $bcee56e7524e90f3$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $bcee56e7524e90f3$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $bcee56e7524e90f3$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $bcee56e7524e90f3$export$a5b94313d6908893(width) {
    if (width === void 0) width = '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $bcee56e7524e90f3$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _extends2, _extends3;
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var obj = _ref;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $g8vBZ.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $bcee56e7524e90f3$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $g8vBZ.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $g8vBZ.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref2, _ref3, _ref4;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
        return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = $bcee56e7524e90f3$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
    }
}
function $bcee56e7524e90f3$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")";
    });
    return fileFontReferences.join(', ');
}
function $bcee56e7524e90f3$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $bcee56e7524e90f3$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($bcee56e7524e90f3$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($bcee56e7524e90f3$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $bcee56e7524e90f3$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $bcee56e7524e90f3$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        } // Removes undefined fields for cleaner css object.
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $bcee56e7524e90f3$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $bcee56e7524e90f3$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $bcee56e7524e90f3$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $bcee56e7524e90f3$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $bcee56e7524e90f3$export$c7187bbd1a7a9244(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = (0, $g8vBZ.default)({}, styles), _ref[parent + ":-moz-placeholder"] = (0, $g8vBZ.default)({}, styles), _ref[parent + "::-moz-placeholder"] = (0, $g8vBZ.default)({}, styles), _ref[parent + ":-ms-input-placeholder"] = (0, $g8vBZ.default)({}, styles), _ref;
}
function $bcee56e7524e90f3$var$_templateObject() {
    var data = (0, $g2Nx4.default)([
        "radial-gradient(",
        "",
        "",
        "",
        ")"
    ]);
    $bcee56e7524e90f3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $bcee56e7524e90f3$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $bcee56e7524e90f3$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i]; // Adds leading coma if properties preceed color-stops
        if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
        else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $bcee56e7524e90f3$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $bcee56e7524e90f3$var$parseFallback(colorStops),
        backgroundImage: $bcee56e7524e90f3$var$constructGradientValue($bcee56e7524e90f3$var$_templateObject(), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $bcee56e7524e90f3$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
     // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$bcee56e7524e90f3$export$e79006618d7c6cc3()] = (0, $g8vBZ.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $bcee56e7524e90f3$export$7c69810f7b8835c9(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '';
    return _ref = {}, _ref[parent + "::-moz-selection"] = (0, $g8vBZ.default)({}, styles), _ref[parent + "::selection"] = (0, $g8vBZ.default)({}, styles), _ref;
}
/* eslint-disable key-spacing */ var $bcee56e7524e90f3$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $bcee56e7524e90f3$var$getTimingFunction(functionName) {
    return $bcee56e7524e90f3$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $bcee56e7524e90f3$export$61210fa83792a81(timingFunction) {
    return $bcee56e7524e90f3$var$getTimingFunction(timingFunction);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $bcee56e7524e90f3$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
var $bcee56e7524e90f3$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];
        case 'left':
            return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";
        case 'bottom':
            return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];
        case 'right':
            return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
}; // needed for border-color
var $bcee56e7524e90f3$var$reverseDirection = [
    'bottom',
    'left',
    'top',
    'right'
];
var $bcee56e7524e90f3$var$NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $bcee56e7524e90f3$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = [
        parseFloat(width),
        String(width).replace($bcee56e7524e90f3$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    var heightAndUnit = [
        parseFloat(height),
        String(height).replace($bcee56e7524e90f3$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    var reverseDirectionIndex = $bcee56e7524e90f3$var$reverseDirection.indexOf(pointingDirection);
    return (0, $g8vBZ.default)({
        width: '0',
        height: '0',
        borderWidth: $bcee56e7524e90f3$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
        borderStyle: 'solid'
    }, $bcee56e7524e90f3$export$e7fb0694ba2404fc.apply(void 0, Array.from({
        length: 4
    }).map(function(_, index) {
        return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
    })));
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $bcee56e7524e90f3$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $bcee56e7524e90f3$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $bcee56e7524e90f3$var$convertToInt(red, green, blue) {
    return $bcee56e7524e90f3$var$colorToInt(red) + "," + $bcee56e7524e90f3$var$colorToInt(green) + "," + $bcee56e7524e90f3$var$colorToInt(blue);
}
function $bcee56e7524e90f3$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $bcee56e7524e90f3$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $bcee56e7524e90f3$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $bcee56e7524e90f3$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $bcee56e7524e90f3$var$namedColorMap[normalizedColorName] ? "#" + $bcee56e7524e90f3$var$namedColorMap[normalizedColorName] : color;
}
var $bcee56e7524e90f3$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $bcee56e7524e90f3$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $bcee56e7524e90f3$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $bcee56e7524e90f3$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $bcee56e7524e90f3$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $bcee56e7524e90f3$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $bcee56e7524e90f3$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $bcee56e7524e90f3$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $bcee56e7524e90f3$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $bcee56e7524e90f3$var$nameToHex(color);
    if (normalizedColor.match($bcee56e7524e90f3$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($bcee56e7524e90f3$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($bcee56e7524e90f3$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($bcee56e7524e90f3$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $bcee56e7524e90f3$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $bcee56e7524e90f3$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $bcee56e7524e90f3$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $bcee56e7524e90f3$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $bcee56e7524e90f3$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $bcee56e7524e90f3$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $bcee56e7524e90f3$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $bcee56e7524e90f3$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
function $bcee56e7524e90f3$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $bcee56e7524e90f3$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $bcee56e7524e90f3$var$rgbToHsl($bcee56e7524e90f3$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $bcee56e7524e90f3$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $bcee56e7524e90f3$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $bcee56e7524e90f3$var$colorToHex(color) {
    return $bcee56e7524e90f3$var$numberToHex(Math.round(color * 255));
}
function $bcee56e7524e90f3$var$convertToHex(red, green, blue) {
    return $bcee56e7524e90f3$var$reduceHexValue("#" + $bcee56e7524e90f3$var$colorToHex(red) + $bcee56e7524e90f3$var$colorToHex(green) + $bcee56e7524e90f3$var$colorToHex(blue));
}
function $bcee56e7524e90f3$var$hslToHex(hue, saturation, lightness) {
    return $bcee56e7524e90f3$var$hslToRgb(hue, saturation, lightness, $bcee56e7524e90f3$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $bcee56e7524e90f3$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $bcee56e7524e90f3$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $bcee56e7524e90f3$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $bcee56e7524e90f3$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $bcee56e7524e90f3$var$hslToHex(value, saturation, lightness) : "rgba(" + $bcee56e7524e90f3$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $bcee56e7524e90f3$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $bcee56e7524e90f3$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $bcee56e7524e90f3$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $bcee56e7524e90f3$var$reduceHexValue("#" + $bcee56e7524e90f3$var$numberToHex(value) + $bcee56e7524e90f3$var$numberToHex(green) + $bcee56e7524e90f3$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $bcee56e7524e90f3$var$reduceHexValue("#" + $bcee56e7524e90f3$var$numberToHex(value.red) + $bcee56e7524e90f3$var$numberToHex(value.green) + $bcee56e7524e90f3$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $bcee56e7524e90f3$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $bcee56e7524e90f3$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $bcee56e7524e90f3$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $bcee56e7524e90f3$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
var $bcee56e7524e90f3$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $bcee56e7524e90f3$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $bcee56e7524e90f3$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $bcee56e7524e90f3$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $bcee56e7524e90f3$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $bcee56e7524e90f3$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($bcee56e7524e90f3$var$errMsg);
    if ($bcee56e7524e90f3$var$isRgba(color)) return $bcee56e7524e90f3$export$4e46ac54fc82cf3b(color);
    if ($bcee56e7524e90f3$var$isRgb(color)) return $bcee56e7524e90f3$export$8972dc0e6ad9238f(color);
    if ($bcee56e7524e90f3$var$isHsla(color)) return $bcee56e7524e90f3$export$810b04175080204c(color);
    if ($bcee56e7524e90f3$var$isHsl(color)) return $bcee56e7524e90f3$export$8f4a7c0bb78e6ea8(color);
    throw new Error($bcee56e7524e90f3$var$errMsg);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $bcee56e7524e90f3$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $bcee56e7524e90f3$var$curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function $bcee56e7524e90f3$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $bcee56e7524e90f3$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$adjustHue(degree, color) {
    var hslColor = $bcee56e7524e90f3$export$1286688e1b3fde9c(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, hslColor, {
        hue: (hslColor.hue + parseFloat(degree)) % 360
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$2b372a09365374d6 = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$adjustHue);
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $bcee56e7524e90f3$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $bcee56e7524e90f3$export$1286688e1b3fde9c(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $bcee56e7524e90f3$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$darken(amount, color) {
    var hslColor = $bcee56e7524e90f3$export$1286688e1b3fde9c(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, hslColor, {
        lightness: $bcee56e7524e90f3$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$4b073707ff63303 = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$darken);
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$desaturate(amount, color) {
    var hslColor = $bcee56e7524e90f3$export$1286688e1b3fde9c(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, hslColor, {
        saturation: $bcee56e7524e90f3$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$fb75607d98509d9 = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$desaturate);
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $bcee56e7524e90f3$export$c852d90bf7403b62(color) {
    var rgbColor = $bcee56e7524e90f3$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $bcee56e7524e90f3$export$6f416a6db2dfcd5c(color) {
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, $bcee56e7524e90f3$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $bcee56e7524e90f3$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $bcee56e7524e90f3$export$2f48baff6995707a(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$lighten(amount, color) {
    var hslColor = $bcee56e7524e90f3$export$1286688e1b3fde9c(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, hslColor, {
        lightness: $bcee56e7524e90f3$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$c0816ed86df316af = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$lighten);
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $bcee56e7524e90f3$var$mix(weight, color, otherColor) {
    var parsedColor1 = $bcee56e7524e90f3$export$2f48baff6995707a(color);
    var color1 = (0, $g8vBZ.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $bcee56e7524e90f3$export$2f48baff6995707a(otherColor);
    var color2 = (0, $g8vBZ.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
    };
    return $bcee56e7524e90f3$export$4e46ac54fc82cf3b(mixedColor);
} // prettier-ignore
var $bcee56e7524e90f3$export$2c9e8a9632a706b2 = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$mix);
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$opacify(amount, color) {
    var parsedColor = $bcee56e7524e90f3$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $g8vBZ.default)({}, parsedColor, {
        alpha: $bcee56e7524e90f3$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $bcee56e7524e90f3$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $bcee56e7524e90f3$export$f4f50e3877dd0530 = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$opacify);
/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $bcee56e7524e90f3$export$61654c1796c44811(color) {
    return $bcee56e7524e90f3$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$saturate(amount, color) {
    var hslColor = $bcee56e7524e90f3$export$1286688e1b3fde9c(color);
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, hslColor, {
        saturation: $bcee56e7524e90f3$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$5fcac96f5a87e3db = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$saturate);
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$setHue(hue, color) {
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, $bcee56e7524e90f3$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$3bf58ce3e497a846 = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$setHue);
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$setLightness(lightness, color) {
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, $bcee56e7524e90f3$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$7ef5d725337b805d = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$setLightness);
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $bcee56e7524e90f3$var$setSaturation(saturation, color) {
    return $bcee56e7524e90f3$export$42fe740cdf79b2df((0, $g8vBZ.default)({}, $bcee56e7524e90f3$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
} // prettier-ignore
var $bcee56e7524e90f3$export$b40fe421ea7a4f7e = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$setSaturation);
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $bcee56e7524e90f3$var$shade(percentage, color) {
    return $bcee56e7524e90f3$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore
var $bcee56e7524e90f3$export$3e32adda0df4ef5d = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $bcee56e7524e90f3$var$tint(percentage, color) {
    return $bcee56e7524e90f3$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore
var $bcee56e7524e90f3$export$fc176dd65a27d98b = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$tint);
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $bcee56e7524e90f3$var$transparentize(amount, color) {
    var parsedColor = $bcee56e7524e90f3$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $g8vBZ.default)({}, parsedColor, {
        alpha: $bcee56e7524e90f3$var$guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
    });
    return $bcee56e7524e90f3$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $bcee56e7524e90f3$export$d11da87e55cc498f = /*#__PURE__*/ $bcee56e7524e90f3$var$curry($bcee56e7524e90f3$var$transparentize);
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $bcee56e7524e90f3$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $bcee56e7524e90f3$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $bcee56e7524e90f3$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $bcee56e7524e90f3$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $bcee56e7524e90f3$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $bcee56e7524e90f3$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $bcee56e7524e90f3$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $bcee56e7524e90f3$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $bcee56e7524e90f3$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $bcee56e7524e90f3$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $bcee56e7524e90f3$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $bcee56e7524e90f3$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $bcee56e7524e90f3$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $bcee56e7524e90f3$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $bcee56e7524e90f3$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $bcee56e7524e90f3$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($bcee56e7524e90f3$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $bcee56e7524e90f3$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $bcee56e7524e90f3$var$template(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $bcee56e7524e90f3$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $bcee56e7524e90f3$var$statefulSelectors(states, $bcee56e7524e90f3$var$template, $bcee56e7524e90f3$var$stateMap);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $bcee56e7524e90f3$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $bcee56e7524e90f3$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $bcee56e7524e90f3$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $bcee56e7524e90f3$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($bcee56e7524e90f3$var$positionMap$1.indexOf(positionKeyword) >= 0) return (0, $g8vBZ.default)({
        position: positionKeyword
    }, $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $bcee56e7524e90f3$export$4fc00c04dd60af95.apply(void 0, [
            '',
            firstValue
        ].concat(values));
    }
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $bcee56e7524e90f3$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $bcee56e7524e90f3$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $bcee56e7524e90f3$var$template$1(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $bcee56e7524e90f3$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $bcee56e7524e90f3$var$statefulSelectors(states, $bcee56e7524e90f3$var$template$1, $bcee56e7524e90f3$var$stateMap$1);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $bcee56e7524e90f3$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new Error('Property must be a string value.');
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}

});
parcelRegister("g2Nx4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bae34153ec31e2fd$export$2e2bcd8739ae039);
function $bae34153ec31e2fd$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}

});



parcelRegister("f9uTr", function(module, exports) {
$parcel$export(module.exports, "GlobalStyled", () => $294ba59256a8027d$export$b606131378921a7b);
$parcel$export(module.exports, "NewGlobalBGColor", () => $294ba59256a8027d$export$aa61b57bede93357);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
parcelRequire("9H44a");
var $dCSpQ = parcelRequire("dCSpQ");

var $lkNTb = parcelRequire("lkNTb");
const $294ba59256a8027d$var$getLinkColorToken = (props)=>{
    if (props !== null && props !== void 0 && props.isCsm) {
        const generatedColors = (0, $lkNTb.generateThemeBranding)(props.theme.color);
        return `var(--ds-link, ${generatedColors.color900})`;
    }
    return `var(--ds-link, ${props.theme.color})`;
};
const $294ba59256a8027d$export$b606131378921a7b = /*#__PURE__*/ (0, $4v2A7.default)((0, $dCSpQ.default)).withConfig({
    componentId: "sc-15eor0s-0"
})`background-color:${"var(--ds-surface, #FFFFFF)"};font:${"var(--ds-font-body, normal 400 14px/1.42857142857143 -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"};a:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']),a:hover:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']){color:${(props)=>$294ba59256a8027d$var$getLinkColorToken(props)};}h1,h2{letter-spacing:-0.001em;}:root{--ds-space-0:0;--ds-space-025:0.125rem;--ds-space-050:0.25rem;--ds-space-075:0.375rem;--ds-space-100:0.5rem;--ds-space-150:0.75rem;--ds-space-200:1rem;--ds-space-250:1.25rem;--ds-space-300:1.5rem;--ds-space-400:2rem;--ds-space-500:2.5rem;--ds-space-600:3rem;--ds-space-800:4rem;--ds-space-1000:5rem;--ds-font-family-monospace:'SFMono-Medium','SF Mono','Segoe UI Mono','Roboto Mono','Ubuntu Mono',Menlo,Consolas,Courier,monospace;--ds-font-family-sans:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;--ds-font-size-050:11px;--ds-font-size-075:12px;--ds-font-size-100:14px;--ds-font-size-200:16px;--ds-font-size-300:20px;--ds-font-size-400:24px;--ds-font-size-500:29px;--ds-font-size-600:35px;--ds-font-weight-bold:700;--ds-font-weight-medium:500;--ds-font-weight-regular:400;--ds-font-weight-semibold:600;--ds-font-lineHeight-100:1rem;--ds-font-lineHeight-200:1.25rem;--ds-font-lineHeight-300:1.5rem;--ds-font-lineHeight-400:1.75rem;--ds-font-lineHeight-500:2rem;--ds-font-lineHeight-600:2.5rem;}`;
const $294ba59256a8027d$export$aa61b57bede93357 = /*#__PURE__*/ (0, $4v2A7.default)((0, $dCSpQ.default)).withConfig({
    componentId: "sc-15eor0s-1"
})`background-color:${"var(--ds-surface, #FFFFFF)"};`;

});
parcelRegister("9H44a", function(module, exports) {
$parcel$export(module.exports, "BodyClassName", () => (parcelRequire("dCSpQ")).default);

var $dCSpQ = parcelRequire("dCSpQ");

});
parcelRegister("dCSpQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2db9b1e547e9ed0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4U3zK = parcelRequire("4U3zK");
class $d2db9b1e547e9ed0$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    constructor(props){
        super(props);
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            classes.forEach((className)=>{
                (0, $4U3zK.default).addClassName('body', className);
            });
        }
    }
    componentWillUnmount() {
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            classes.forEach((className)=>document.body.classList.remove(className));
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.className !== this.props.className) {
            if (prevProps.className) {
                const prevClasses = prevProps.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.remove(...prevClasses);
            }
            if (this.props.className) {
                const classes = this.props.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.add(...classes);
            }
        }
    }
    render() {
        return null;
    }
}

});


parcelRegister("lkNTb", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $22496286376b59a8$export$c1410db1c88d6e0f);

var $9x9E6 = parcelRequire("9x9E6");

var $i7i8x = parcelRequire("i7i8x");
/**
 * Default primary color for CSM branding
 */ const $22496286376b59a8$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR = '#B5B5B5';
const $22496286376b59a8$export$c1410db1c88d6e0f = (primaryColour)=>(0, $9x9E6.generateColorRamps)((0, $i7i8x.isValidHex)(primaryColour) ? primaryColour : $22496286376b59a8$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR);

});
parcelRegister("9x9E6", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $42d45ffd5cab8df8$export$3a180ce5632a9d57);

var $5GV9S = parcelRequire("5GV9S");

var $c2y0g = parcelRequire("c2y0g");

var $kQmkU = parcelRequire("kQmkU");

var $a7VCi = parcelRequire("a7VCi");
const $42d45ffd5cab8df8$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $42d45ffd5cab8df8$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $42d45ffd5cab8df8$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $5GV9S.deltaE)((0, $5GV9S.hexToRgb)(value), (0, $5GV9S.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $42d45ffd5cab8df8$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $5GV9S.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $5GV9S.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $5GV9S.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $42d45ffd5cab8df8$var$lowLuminanceContrastRatios : $42d45ffd5cab8df8$var$highLuminanceContrastRatios;
    const brandRgba = (0, $5GV9S.hexToRgbA)(brandColor);
    const hctColor = (0, $a7VCi.Hct).fromInt((0, $c2y0g.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $c2y0g.rgbaFromArgb)((0, $a7VCi.Hct).from(hctColor.hue, hctColor.chroma, (0, $kQmkU.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $5GV9S.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $42d45ffd5cab8df8$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $42d45ffd5cab8df8$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $42d45ffd5cab8df8$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("5GV9S", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $c35366aced42159e$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $c35366aced42159e$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $c35366aced42159e$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $c35366aced42159e$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $c35366aced42159e$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $c35366aced42159e$export$e770b01b744f3745);
$parcel$export(module.exports, "deltaE", () => $c35366aced42159e$export$e8ddad763b4bebf9);

var $i7i8x = parcelRequire("i7i8x");
function $c35366aced42159e$export$34d09c4a771c46ef(r, g, b) {
    const chars = (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return `#${chars}`;
}
function $c35366aced42159e$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $c35366aced42159e$export$b36dbdb4f463f05c(hex) {
    if (!(0, $i7i8x.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $c35366aced42159e$export$1212645cf40ebf71(hex)
    ];
}
function $c35366aced42159e$export$5a544e13ad4e1fa5(hex) {
    if (!(0, $i7i8x.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $c35366aced42159e$export$47ea145a83f50dc0(hex) {
    if (!(0, $i7i8x.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $c35366aced42159e$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $c35366aced42159e$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $c35366aced42159e$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $i7i8x.isValidHex)(foreground) || !(0, $i7i8x.isValidHex)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $c35366aced42159e$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $c35366aced42159e$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $c35366aced42159e$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $c35366aced42159e$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $c35366aced42159e$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $c35366aced42159e$var$rgbToLab(rgbA);
    let labB = $c35366aced42159e$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $c35366aced42159e$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});
parcelRegister("i7i8x", function(module, exports) {
$parcel$export(module.exports, "isValidHex", () => $5db7f47a84bb29fd$export$944f75ec5697b362);
const $5db7f47a84bb29fd$export$944f75ec5697b362 = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

});


parcelRegister("c2y0g", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $25117410a0a01a98$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $25117410a0a01a98$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $25117410a0a01a98$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $25117410a0a01a98$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $25117410a0a01a98$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $25117410a0a01a98$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $25117410a0a01a98$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $25117410a0a01a98$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $25117410a0a01a98$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $25117410a0a01a98$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $icnTq = parcelRequire("icnTq");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $25117410a0a01a98$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $25117410a0a01a98$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $25117410a0a01a98$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $25117410a0a01a98$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $25117410a0a01a98$export$7928ddf440518d19(linrgb) {
    const r = $25117410a0a01a98$export$777e26aa2ec02b1(linrgb[0]);
    const g = $25117410a0a01a98$export$777e26aa2ec02b1(linrgb[1]);
    const b = $25117410a0a01a98$export$777e26aa2ec02b1(linrgb[2]);
    return $25117410a0a01a98$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $25117410a0a01a98$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $25117410a0a01a98$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $25117410a0a01a98$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $25117410a0a01a98$var$blueFromArgb(argb) {
    return argb & 255;
}
function $25117410a0a01a98$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $25117410a0a01a98$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $25117410a0a01a98$export$777e26aa2ec02b1(linearR);
    const g = $25117410a0a01a98$export$777e26aa2ec02b1(linearG);
    const b = $25117410a0a01a98$export$777e26aa2ec02b1(linearB);
    return $25117410a0a01a98$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $25117410a0a01a98$var$xyzFromArgb(argb) {
    const r = $25117410a0a01a98$export$dec6bcda7bf47f2c($25117410a0a01a98$var$redFromArgb(argb));
    const g = $25117410a0a01a98$export$dec6bcda7bf47f2c($25117410a0a01a98$var$greenFromArgb(argb));
    const b = $25117410a0a01a98$export$dec6bcda7bf47f2c($25117410a0a01a98$var$blueFromArgb(argb));
    return $icnTq.matrixMultiply([
        r,
        g,
        b
    ], $25117410a0a01a98$var$SRGB_TO_XYZ);
}
function $25117410a0a01a98$export$ae8c227f6d0cbddb(lstar) {
    const y = $25117410a0a01a98$export$7f3071c4a5db05a0(lstar);
    const component = $25117410a0a01a98$export$777e26aa2ec02b1(y);
    return $25117410a0a01a98$export$58a74b9f8e513b7b(component, component, component);
}
function $25117410a0a01a98$export$8b8f7ef2e0a71c61(argb) {
    const y = $25117410a0a01a98$var$xyzFromArgb(argb)[1];
    return 116.0 * $25117410a0a01a98$var$labF(y / 100.0) - 16.0;
}
function $25117410a0a01a98$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $25117410a0a01a98$var$labInvf((lstar + 16.0) / 116.0);
}
function $25117410a0a01a98$export$bfc0d1dd9c64ada2(y) {
    return $25117410a0a01a98$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $25117410a0a01a98$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $25117410a0a01a98$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $icnTq.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $25117410a0a01a98$export$d4534a444c6526c3() {
    return $25117410a0a01a98$var$WHITE_POINT_D65;
}
function $25117410a0a01a98$export$fb1fd26c787a8662(argb) {
    const r = $25117410a0a01a98$var$redFromArgb(argb);
    const g = $25117410a0a01a98$var$greenFromArgb(argb);
    const b = $25117410a0a01a98$var$blueFromArgb(argb);
    const a = $25117410a0a01a98$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $25117410a0a01a98$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $25117410a0a01a98$var$clampComponent(r);
    const gValue = $25117410a0a01a98$var$clampComponent(g);
    const bValue = $25117410a0a01a98$var$clampComponent(b);
    const aValue = $25117410a0a01a98$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $25117410a0a01a98$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $25117410a0a01a98$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $25117410a0a01a98$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("icnTq", function(module, exports) {
$parcel$export(module.exports, "signum", () => $1e03b5aa73a5291e$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $1e03b5aa73a5291e$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $1e03b5aa73a5291e$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $1e03b5aa73a5291e$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $1e03b5aa73a5291e$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $1e03b5aa73a5291e$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $1e03b5aa73a5291e$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $1e03b5aa73a5291e$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $1e03b5aa73a5291e$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $1e03b5aa73a5291e$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $1e03b5aa73a5291e$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $1e03b5aa73a5291e$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("kQmkU", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $27c8d360bdcf12c8$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $c2y0g = parcelRequire("c2y0g");

var $icnTq = parcelRequire("icnTq");
class $27c8d360bdcf12c8$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $icnTq.clampDouble(0.0, 100.0, toneA);
        toneB = $icnTq.clampDouble(0.0, 100.0, toneB);
        return $27c8d360bdcf12c8$export$656ae42051d0ca86.ratioOfYs($c2y0g.yFromLstar(toneA), $c2y0g.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $c2y0g.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $27c8d360bdcf12c8$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $c2y0g.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $c2y0g.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $27c8d360bdcf12c8$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $c2y0g.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $27c8d360bdcf12c8$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $27c8d360bdcf12c8$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("a7VCi", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $7007923b4cde7c17$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c2y0g = parcelRequire("c2y0g");

var $icnTq = parcelRequire("icnTq");
class $7007923b4cde7c17$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $7007923b4cde7c17$export$91d2e033b3924566($7007923b4cde7c17$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $7007923b4cde7c17$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($7007923b4cde7c17$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($7007923b4cde7c17$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($7007923b4cde7c17$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $7007923b4cde7c17$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $c2y0g.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $7007923b4cde7c17$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $c2y0g.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $7007923b4cde7c17$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $7007923b4cde7c17$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $7007923b4cde7c17$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $7007923b4cde7c17$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $c2y0g.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $7007923b4cde7c17$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $7007923b4cde7c17$var$Cam16.fromIntInViewingConditions(argb, $7007923b4cde7c17$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $c2y0g.linearized(red);
        const greenL = $c2y0g.linearized(green);
        const blueL = $c2y0g.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $icnTq.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $icnTq.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $icnTq.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $7007923b4cde7c17$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $7007923b4cde7c17$var$Cam16.fromJchInViewingConditions(j, c, h, $7007923b4cde7c17$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $7007923b4cde7c17$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $7007923b4cde7c17$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $7007923b4cde7c17$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $7007923b4cde7c17$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($7007923b4cde7c17$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $icnTq.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $icnTq.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $icnTq.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $c2y0g.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $icnTq.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $icnTq.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $icnTq.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $7007923b4cde7c17$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $icnTq.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $icnTq.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $icnTq.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $7007923b4cde7c17$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $icnTq.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $icnTq.matrixMultiply(linrgb, $7007923b4cde7c17$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $7007923b4cde7c17$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $7007923b4cde7c17$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $7007923b4cde7c17$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $7007923b4cde7c17$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $7007923b4cde7c17$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $7007923b4cde7c17$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $7007923b4cde7c17$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $7007923b4cde7c17$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $7007923b4cde7c17$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $7007923b4cde7c17$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($7007923b4cde7c17$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($7007923b4cde7c17$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($7007923b4cde7c17$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $7007923b4cde7c17$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $7007923b4cde7c17$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $7007923b4cde7c17$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($7007923b4cde7c17$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $7007923b4cde7c17$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $7007923b4cde7c17$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $7007923b4cde7c17$var$HctSolver.criticalPlaneBelow($7007923b4cde7c17$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $7007923b4cde7c17$var$HctSolver.criticalPlaneAbove($7007923b4cde7c17$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $7007923b4cde7c17$var$HctSolver.criticalPlaneAbove($7007923b4cde7c17$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $7007923b4cde7c17$var$HctSolver.criticalPlaneBelow($7007923b4cde7c17$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $7007923b4cde7c17$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $7007923b4cde7c17$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $7007923b4cde7c17$var$HctSolver.hueOf(mid);
                    if ($7007923b4cde7c17$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $7007923b4cde7c17$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $icnTq.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $7007923b4cde7c17$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $7007923b4cde7c17$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $7007923b4cde7c17$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $7007923b4cde7c17$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $icnTq.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $7007923b4cde7c17$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $7007923b4cde7c17$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $7007923b4cde7c17$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $7007923b4cde7c17$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $c2y0g.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $c2y0g.argbFromLstar(lstar);
        hueDegrees = $icnTq.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $c2y0g.yFromLstar(lstar);
        const exactAnswer = $7007923b4cde7c17$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $7007923b4cde7c17$var$HctSolver.bisectToLimit(y, hueRadians);
        return $c2y0g.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $7007923b4cde7c17$var$Cam16.fromInt($7007923b4cde7c17$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $7007923b4cde7c17$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $7007923b4cde7c17$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $c2y0g.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $c2y0g.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $icnTq.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $icnTq.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $c2y0g.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $7007923b4cde7c17$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});




parcelRegister("eLLBi", function(module, exports) {
$parcel$export(module.exports, "getFlexiHelpCenterRoute", () => $6b39734f631b70b3$export$21b2409877effae5);
$parcel$export(module.exports, "getViewHomePageRoute", () => $6b39734f631b70b3$export$2601c63db4e9c5eb);
$parcel$export(module.exports, "getEditHomePageRoute", () => $6b39734f631b70b3$export$ce4073fcfac7d40d);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $hO5qW = parcelRequire("hO5qW");

var $k30kR = parcelRequire("k30kR");

var $cVM5r = parcelRequire("cVM5r");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("emd1X");
var $5ZKvf = parcelRequire("5ZKvf");
parcelRequire("dgMoN");
var $hWMM6 = parcelRequire("hWMM6");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");
parcelRequire("TdcAL");
var $57PyM = parcelRequire("57PyM");
parcelRequire("7wH5B");
var $30arO = parcelRequire("30arO");

var $1xzNy = parcelRequire("1xzNy");

var $kIbto = parcelRequire("kIbto");

var $haAAx = parcelRequire("haAAx");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $bkEWh = parcelRequire("bkEWh");

var $7EcVw = parcelRequire("7EcVw");

var $a4Y3D = parcelRequire("a4Y3D");
const $6b39734f631b70b3$var$VIEW_HOMEPAGE_PATH = '(/)?';
const $6b39734f631b70b3$var$EDIT_HOMEPAGE_PATH = '/edit';

const $6b39734f631b70b3$var$AsyncViewHomepage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("c88hD")), {
        moduleId: "./src/view/advanced-help-center/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), null)
});

const $6b39734f631b70b3$var$AsyncCSMViewHomepage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("ioALM")), {
        moduleId: "./src/view/customer-service/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), null)
});
const $6b39734f631b70b3$export$21b2409877effae5 = (name = 'help-center', path = $6b39734f631b70b3$var$VIEW_HOMEPAGE_PATH, screenName = (0, $jcRK7.ScreenName).VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = [
        (0, $a4Y3D.brandingResource),
        (0, $k30kR.ViewHomepageResource),
        (0, $k30kR.searchComponentVirtualAgentResource)
    ];
    return (0, $bkEWh.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $6b39734f631b70b3$var$AsyncViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $k30kR.ViewHomepageResource),
            (0, $k30kR.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $6b39734f631b70b3$export$fc52ccc4768cd164 = (name = 'help-center', path = $6b39734f631b70b3$var$VIEW_HOMEPAGE_PATH, screenName = (0, $jcRK7.ScreenName).CSM_VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = [
        (0, $a4Y3D.brandingResource),
        (0, $k30kR.ViewHomepageResource),
        (0, $k30kR.searchComponentVirtualAgentResource)
    ];
    return (0, $bkEWh.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $6b39734f631b70b3$var$AsyncCSMViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $k30kR.ViewHomepageResource),
            (0, $k30kR.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};
const $6b39734f631b70b3$export$2601c63db4e9c5eb = ()=>{
    if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType)) return $6b39734f631b70b3$export$fc52ccc4768cd164();
    return $6b39734f631b70b3$export$21b2409877effae5();
};

const $6b39734f631b70b3$export$400d7e0667f80c3f = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("2SSsq")), {
        moduleId: "./src/view/advanced-help-center/edit-homepage-v2/index.tsx"
    }),
    LoadingSkeleton: ()=>(0, $lFpPv.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5ZKvf.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), {
            showActionBar: true
        })
});
const $6b39734f631b70b3$export$96880615462f6c7f = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: props.location.pathname
    }), (0, $ifEXU.default)({
        message: formatMessage((0, $1xzNy.authPageMessage)),
        callToActionText: formatMessage((0, $1xzNy.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $57PyM.default), {
            path: $6b39734f631b70b3$var$EDIT_HOMEPAGE_PATH,
            component: $6b39734f631b70b3$export$400d7e0667f80c3f,
            screenName: (0, $jcRK7.ScreenName).EDIT_HOMEPAGE,
            isFooterHidden: (0, $lFpPv.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $30arO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
};
const $6b39734f631b70b3$export$ce4073fcfac7d40d = (name = 'edit-homepage', path = '/edit')=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        resources: [
            (0, $7EcVw.EditHomepageV2Resource)
        ],
        exact: true,
        component: (0, $iW3CQ.getIsHCCustomizationEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($6b39734f631b70b3$export$96880615462f6c7f) : (0, $haAAx.withAnalyticsContext)({
            componentName: 'notFoundPage'
        })(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        (0, $kIbto.default)({})((0, $hWMM6.NotFoundPage)))
    };
    return editHomePageRoute;
};

});
parcelRegister("hO5qW", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d44602f913d14af$export$2e2bcd8739ae039);
/* flexible-homepage-loader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hF8Ik = parcelRequire("hF8Ik");

var $1DDTY = parcelRequire("1DDTY");
parcelRequire("7W2NN");
var $fR6LO = parcelRequire("fR6LO");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $1qPbZ = parcelRequire("1qPbZ");
const $6d44602f913d14af$var$SECTION_HEIGHT = 232;
const $6d44602f913d14af$var$FlexibleHomepageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "flexible-homepage-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $6d44602f913d14af$var$skeletonContainer
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fR6LO.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $6d44602f913d14af$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $1DDTY.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6d44602f913d14af$var$SectionLoader, {
            key: `flexibleHCLoader_${index}`,
            "data-testid": "flexible-hc-section-skeleton",
            height: $6d44602f913d14af$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        });
    })));
};
const $6d44602f913d14af$var$skeletonContainer = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $6d44602f913d14af$var$headerContainer = (0, $9BVpB.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6d44602f913d14af$var$SectionLoader = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $hF8Ik.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_2rko12b0 _1bsb1osq _19pk1ejb _69lw94vn _9wd01ejb _n71h1ejb",
            __cmplp.className
        ])
    });
});
var $6d44602f913d14af$export$2e2bcd8739ae039 = $6d44602f913d14af$var$FlexibleHomepageLoader;

});
parcelRegister("1DDTY", function(module, exports) {
$parcel$export(module.exports, "BANNER_HEIGHT", () => $68d046755f91bf17$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $68d046755f91bf17$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "SEARCH_INPUT_FONT_SIZE", () => $68d046755f91bf17$export$1d74cef432cdcb55);
$parcel$export(module.exports, "FilterContainer", () => $68d046755f91bf17$export$2f96f6f204f87534);
$parcel$export(module.exports, "FormErrorContainer", () => $68d046755f91bf17$export$ae0c09a310b3720b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");
const $68d046755f91bf17$export$c09feb53ddd4034b = 300;
const $68d046755f91bf17$export$ed7cc0d417ee89e = $9K7mZ.multiple(44);
const $68d046755f91bf17$export$cdb7fd9d999c7168 = $9K7mZ.unitless * 7;
const $68d046755f91bf17$export$1d74cef432cdcb55 = $98sDU.mediumLarge;
const $68d046755f91bf17$export$2f96f6f204f87534 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1pch1g4-0"
})`display:flex;flex-wrap:wrap;margin-top:${"var(--ds-space-negative-100, -8px)"};margin-right:${"var(--ds-space-negative-200, -16px)"};> *{flex-basis:0;margin-right:${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-100, 8px)"};min-width:${$9K7mZ.multiple(27.5).px};flex-grow:1;}`;
const $68d046755f91bf17$export$ae0c09a310b3720b = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1pch1g4-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("7W2NN", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => (parcelRequire("fR6LO")).ActionBarStateless);

var $fR6LO = parcelRequire("fR6LO");

});
parcelRegister("fR6LO", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => $aa74325e2c3e19db$export$dc910ca71acdb8f0);
/* action-bar-stateless.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $97yQ5 = parcelRequire("97yQ5");

var $bKqvx = parcelRequire("bKqvx");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("3qPbW");
var $2u3cl = parcelRequire("2u3cl");

var $8JEAp = parcelRequire("8JEAp");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $j8rB3 = parcelRequire("j8rB3");
const $aa74325e2c3e19db$export$cc312d5a7378bea1 = 'Help Centers customize page layout';
const $aa74325e2c3e19db$export$dc910ca71acdb8f0 = ({ isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, isPublishing: isPublishing, onPublish: onPublish, onClose: onClose, publishButtonDisabled: publishButtonDisabled, previewButtonDisabled: previewButtonDisabled, children: children, isPageInPreviewMode: isPageInPreviewMode, togglePreviewMode: togglePreviewMode })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (isPageInBrandingPreviewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$ActionsWrapper, {
        isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2u3cl.BrandingPreviewBanner), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$ActionsWrapper, {
        id: "advance-customization-action-bar",
        isPageInBrandingPreviewMode: !!isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$ButtonContainer, null, !isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $aa74325e2c3e19db$var$buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$ButtonWrapper, {
        actionSubjectId: "backToHomePage",
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $j8rB3.default).backToSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bKqvx.default), {
        showIcon: true,
        showTypeField: true,
        featureName: $aa74325e2c3e19db$export$cc312d5a7378bea1,
        buttonLabel: (0, $j8rB3.default).giveFeedback,
        analyticsSubjectId: "customizePageLayoutFeedbackButton"
    })), isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$PreviewButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8JEAp.default), {
        appearance: "info",
        title: formatMessage((0, $j8rB3.default).previewMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.Button), {
        isDisabled: previewButtonDisabled,
        actionSubjectId: "preview",
        appearance: "default",
        onClick: togglePreviewMode
    }, isPageInPreviewMode ? formatMessage((0, $j8rB3.default).exitPreview) : formatMessage((0, $j8rB3.default).preview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($aa74325e2c3e19db$var$ActionButton, {
        appearance: "primary",
        actionSubjectId: "publish",
        isDisabled: publishButtonDisabled,
        onClick: onPublish,
        isLoading: isPublishing
    }, formatMessage((0, $j8rB3.default).publish)))), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $aa74325e2c3e19db$var$ButtonWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $97yQ5.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_18u0xmi2",
            __cmplp.className
        ])
    });
});
const $aa74325e2c3e19db$var$ButtonGroup = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $aa74325e2c3e19db$var$buttonGroup = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'row',
    gap: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $aa74325e2c3e19db$var$ActionButton = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $97yQ5.LoadingButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $aa74325e2c3e19db$var$ActionsWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt46hdp _154iidpf _1ltvidpf _1bsb1osq _kqsw1if8 _16qsfihs _vchhusvi _1pbyaft6",
            __cmplp.isPageInBrandingPreviewMode ? "_bfhkb7r6" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $aa74325e2c3e19db$var$ButtonContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $aa74325e2c3e19db$var$PreviewButtonWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("97yQ5", function(module, exports) {
$parcel$export(module.exports, "Button", () => $0ff31548de6f642c$export$353f5b6fc5456de1);
$parcel$export(module.exports, "IconButton", () => $0ff31548de6f642c$export$c25acd513dcc8062);
$parcel$export(module.exports, "LoadingButton", () => $0ff31548de6f642c$export$4ec83e90d030b2f3);
$parcel$export(module.exports, "ThemedButton", () => $0ff31548de6f642c$export$f67fb575035cc7d0);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $hzFIQ = parcelRequire("hzFIQ");

var $2U5M0 = parcelRequire("2U5M0");

var $lebr5 = parcelRequire("lebr5");

var $4TRbS = parcelRequire("4TRbS");
const $0ff31548de6f642c$export$353f5b6fc5456de1 = /*#__PURE__*/ $bSJIT.memo(/*#__PURE__*/ $bSJIT.forwardRef(function Button({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hzFIQ.default), {
        ...props,
        ref: ref
    }));
}));
const $0ff31548de6f642c$export$c25acd513dcc8062 = /*#__PURE__*/ $bSJIT.memo(/*#__PURE__*/ $bSJIT.forwardRef(function IconButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $4TRbS.default), {
        ...props,
        ref: ref
    }));
}));
const $0ff31548de6f642c$export$4ec83e90d030b2f3 = /*#__PURE__*/ $bSJIT.memo(/*#__PURE__*/ $bSJIT.forwardRef(function LoadingButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $lebr5.default), {
        ...props,
        ref: ref
    }));
}));
const $0ff31548de6f642c$export$f67fb575035cc7d0 = /*#__PURE__*/ $bSJIT.memo(/*#__PURE__*/ $bSJIT.forwardRef(function ThemedButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $2U5M0.default), {
        ...props,
        ref: ref
    }));
}));

});
parcelRegister("lebr5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c80b91e4437a8fd6$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hzFIQ = parcelRequire("hzFIQ");

var $7oUXt = parcelRequire("7oUXt");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $c80b91e4437a8fd6$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hzFIQ.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $7oUXt.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$c80b91e4437a8fd6$var$LoadingButton.displayName = 'LoadingButton';
var $c80b91e4437a8fd6$export$2e2bcd8739ae039 = $c80b91e4437a8fd6$var$LoadingButton;

});


parcelRegister("bKqvx", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf3718c46a278c2d$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $xb2jO = parcelRequire("xb2jO");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("6Wh6Q");
var $fNpdN = parcelRequire("fNpdN");
parcelRequire("fGsCH");
var $lDuQl = parcelRequire("lDuQl");

var $iW3CQ = parcelRequire("iW3CQ");

var $lG162 = parcelRequire("lG162");
const $bf3718c46a278c2d$var$selector = (0, $BOq7h.createSelector)((0, $lDuQl.getFlags), (0, $iW3CQ.getEnv), (flags, env)=>({
        flags: flags,
        env: env.environment
    }));
const $bf3718c46a278c2d$var$mapDispatchToProps = {
    showFeedbackCollector: $fNpdN.showFeedbackCollector,
    dismissFlag: $xb2jO.dismissFlag
};
var $bf3718c46a278c2d$export$2e2bcd8739ae039 = (0, $f2mlD.default)($bf3718c46a278c2d$var$selector, $bf3718c46a278c2d$var$mapDispatchToProps)((0, $fK3tS.default)((0, $lG162.FeedbackCollectorButton)));

});
parcelRegister("lG162", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorButton", () => $ccb638e7085b5201$export$b39479f42d974760);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $lCAV6 = parcelRequire("lCAV6");

var $jeV46 = parcelRequire("jeV46");

var $kM5FK = parcelRequire("kM5FK");
const $ccb638e7085b5201$export$b39479f42d974760 = ({ intl: intl, env: env, flags: flags, showIcon: showIcon, featureName: featureName, showTypeField: showTypeField, buttonLabel: buttonLabel, analyticsSubjectId: analyticsSubjectId, dismissFlagMessage: dismissFlagMessage, dismissFlag: dismissFlag, showFeedbackCollector: showFeedbackCollector, appearance: appearance = 'subtle', spacing: spacing = 'default', useTheme: useTheme = false, useSideNavButton: useSideNavButton = false })=>{
    const openFeedbackCollector = $bSJIT.useCallback(()=>{
        const showFeedbackCollectorPayload = {
            env: env,
            showTypeField: showTypeField,
            featureName: featureName,
            shouldOpenFeedbackWidget: true
        };
        if (dismissFlagMessage) {
            const successFlag = flags.filter(// @ts-ignore TS(2532) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Object is possibly 'undefined'.
            (flag)=>flag.titleMessage.defaultMessage.localeCompare(dismissFlagMessage.defaultMessage) === 0)[0];
            successFlag && dismissFlag(successFlag.id);
        }
        showFeedbackCollector(showFeedbackCollectorPayload);
    }, [
        env,
        showTypeField,
        featureName,
        dismissFlagMessage,
        flags,
        dismissFlag,
        showFeedbackCollector
    ]);
    if (useSideNavButton) return /*#__PURE__*/ $bSJIT.createElement((0, $kM5FK.ButtonItem), {
        iconBefore: showIcon ? /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jeV46))), {
            spacing: "spacious",
            label: ""
        }) : undefined,
        onClick: openFeedbackCollector
    }, intl.formatMessage(buttonLabel));
    const ButtonComponent = useTheme ? (0, $lCAV6.ThemedButton) : (0, $97yQ5.Button);
    return /*#__PURE__*/ $bSJIT.createElement(ButtonComponent, {
        iconBefore: showIcon ? /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jeV46))), {
            spacing: "spacious",
            label: "feedback"
        }) : undefined,
        appearance: appearance,
        onClick: openFeedbackCollector,
        actionSubjectId: analyticsSubjectId,
        spacing: spacing
    }, intl.formatMessage(buttonLabel));
};

});
parcelRegister("lCAV6", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $16665c7cfd1ec0d1$export$f67fb575035cc7d0);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $97yQ5 = parcelRequire("97yQ5");

var $gdFS3 = parcelRequire("gdFS3");

var $lkNTb = parcelRequire("lkNTb");
const $16665c7cfd1ec0d1$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $4v2A7.withTheme)(({ innerRef: innerRef, ...props })=>/*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.ThemedButton), {
        ...props,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...styles } = currentTheme(themeProps);
            let customTheme;
            if (props.appearance === 'primary' && !props.isDisabled) {
                const backgroundColor = {
                    default: props.theme.color,
                    focus: props.theme.color,
                    hover: (0, $gdFS3.lighten)(0.05, props.theme.color),
                    active: (0, $gdFS3.darken)(0.05, props.theme.color)
                };
                customTheme = {
                    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    // Suppressing existing violation. Please fix this.
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    backgroundColor: props.overrideThemeColor || backgroundColor[themeProps.state],
                    color: `${props.theme.readableTextColor} !important` // we need to add !important here for buttons with the href attribute
                };
            }
            if (props.appearance === 'link') {
                const primaryColor = props.overrideThemeColor || props.theme.color;
                const generatedThemeVariations = (0, $lkNTb.generateThemeBranding)(primaryColor);
                customTheme = {
                    color: `${generatedThemeVariations.color900} !important`
                };
            }
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...customTheme
                },
                ...styles
            };
        }
    }));

});

parcelRegister("kM5FK", function(module, exports) {
$parcel$export(module.exports, "ButtonItem", () => $8781e2eeca361630$export$2b4d63c9ba9e72d1);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kpgiw = parcelRequire("kpgiw");

var $51QP7 = parcelRequire("51QP7");
const $8781e2eeca361630$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    rootMotion: "_v564hxmd _o7kshxmd _1ggl87vo",
    selectedMotion: "_v5641rrn _o7kshxmd _1ggl87vo"
};
const $8781e2eeca361630$export$2b4d63c9ba9e72d1 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $51QP7.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kpgiw.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            $8781e2eeca361630$var$styles.root,
            $8781e2eeca361630$var$styles.rootMotion,
            props.isSelected && $8781e2eeca361630$var$styles.selectedStyles,
            props.isSelected && $8781e2eeca361630$var$styles.selectedMotion,
            className
        ]),
        ...props
    });
});

});
parcelRegister("kpgiw", function(module, exports) {
$parcel$export(module.exports, "default", () => $62c0ed03e7a46e0f$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $cyIUy = parcelRequire("cyIUy");

var $9hBeo = parcelRequire("9hBeo");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $62c0ed03e7a46e0f$var$ButtonItem = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9hBeo.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $dc70d.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $62c0ed03e7a46e0f$export$2e2bcd8739ae039 = $62c0ed03e7a46e0f$var$ButtonItem;

});
parcelRegister("9hBeo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7760c1623921afa6$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $4wpvI = parcelRequire("4wpvI");

var $1VahP = parcelRequire("1VahP");
const $7760c1623921afa6$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        ...props
    });
const $7760c1623921afa6$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
const $7760c1623921afa6$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $7760c1623921afa6$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $7760c1623921afa6$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $bSJIT.useContext)((0, $4wpvI.SpacingContext));
    const selectionStyle = (0, $bSJIT.useContext)((0, $1VahP.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $9fU1q.default)([
                (0, $9fU1q.default)([
                    $7760c1623921afa6$var$styles.root,
                    $7760c1623921afa6$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $7760c1623921afa6$var$styles.unselected,
                    !isDisabled && !isSelected && $7760c1623921afa6$var$styles.motionUnselected,
                    !isDisabled && isSelected && $7760c1623921afa6$var$styles.selected,
                    !isDisabled && isSelected && $7760c1623921afa6$var$styles.motionSelected,
                    !isDisabled && isSelected && $7760c1623921afa6$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $7760c1623921afa6$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $7760c1623921afa6$var$styles.selectedNotch,
                    isDisabled && $7760c1623921afa6$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $7760c1623921afa6$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $9fU1q.default)([
                            $7760c1623921afa6$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                        className: (0, $9fU1q.default)([
                            $7760c1623921afa6$var$styles.content
                        ]),
                        children: [
                            $7760c1623921afa6$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $9fU1q.default)([
                                    $7760c1623921afa6$var$styles.title,
                                    shouldTitleWrap ? $7760c1623921afa6$var$styles.wordBreak : $7760c1623921afa6$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $9fU1q.default)([
                                    $7760c1623921afa6$var$styles.description,
                                    isDisabled && $7760c1623921afa6$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $7760c1623921afa6$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $7760c1623921afa6$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $9fU1q.default)([
                            $7760c1623921afa6$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
var $7760c1623921afa6$export$2e2bcd8739ae039 = $7760c1623921afa6$var$MenuItemPrimitive;

});
parcelRegister("4wpvI", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $0f35bda6d000f02d$export$443076ec7ebce042);

var $bSJIT = parcelRequire("bSJIT");
const $0f35bda6d000f02d$export$443076ec7ebce042 = /*#__PURE__*/ (0, $bSJIT.createContext)('cozy');

});

parcelRegister("1VahP", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $d9ea54d5f6f51201$export$9ca534b70725964d);

var $bSJIT = parcelRequire("bSJIT");
const $d9ea54d5f6f51201$export$9ca534b70725964d = /*#__PURE__*/ (0, $bSJIT.createContext)('border');

});



parcelRegister("51QP7", function(module, exports) {
$parcel$export(module.exports, "useShouldNestedElementRender", () => $1f6c923b2c5ba467$export$37e8646a1abfc3e6);

var $bSJIT = parcelRequire("bSJIT");

var $7SJw5 = parcelRequire("7SJw5");
const $1f6c923b2c5ba467$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $bSJIT.useContext)((0, $7SJw5.NestedContext));
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});
parcelRegister("7SJw5", function(module, exports) {
$parcel$export(module.exports, "NestedContext", () => $5fb26db1ee90631f$export$46b2c2071c8c725a);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");
const $5fb26db1ee90631f$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});





parcelRegister("3qPbW", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => (parcelRequire("2u3cl")).BrandingPreviewBanner);

var $2u3cl = parcelRequire("2u3cl");

});
parcelRegister("2u3cl", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => $6d4445be4df66a68$export$f6521d01859545a5);
/* branding-preview-banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $8iYAq = parcelRequire("8iYAq");

var $6NrB7 = parcelRequire("6NrB7");
const $6d4445be4df66a68$export$f6521d01859545a5 = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6d4445be4df66a68$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6d4445be4df66a68$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8iYAq))), {
        label: "watch-icon",
        size: "small",
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", null, formatMessage((0, $6NrB7.default).brandingPreviewText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6d4445be4df66a68$var$Wrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt412x7 _1e0c1txw _1bah1h6o _syaz15cr",
            __cmplp.className
        ])
    });
});
const $6d4445be4df66a68$var$IconWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt4otz2 _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8iYAq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f89c1aa1a1fc190805d6b0905c17361>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60bf0068da5cfbef$var$_react = $60bf0068da5cfbef$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $60bf0068da5cfbef$var$_iconNew = $60bf0068da5cfbef$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $60bf0068da5cfbef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open
 * Usage guidance:
 * Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60bf0068da5cfbef$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $60bf0068da5cfbef$var$_react.default.createElement($60bf0068da5cfbef$var$_iconNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$60bf0068da5cfbef$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $60bf0068da5cfbef$var$_default = module.exports.default = $60bf0068da5cfbef$var$EyeOpenIcon;

});

parcelRegister("6NrB7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e10f076779e67b9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $1e10f076779e67b9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    brandingPreviewText: {
        defaultMessage: 'You are currently previewing your global branding changes',
        description: 'Global Branding Preview Banner Text',
        id: 'cv.branding.preview.banner.text.non-final'
    }
});

});



parcelRegister("8JEAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $03fed5c426e82edf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $d6mTg = parcelRequire("d6mTg");

var $26Jy2 = parcelRequire("26Jy2");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $gXqq0 = parcelRequire("gXqq0");

var $8aT4G = parcelRequire("8aT4G");

var $PC54q = parcelRequire("PC54q");
const $03fed5c426e82edf$var$styles = {
    contentStyles: "_1reo1wug _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $03fed5c426e82edf$var$iconColor = {
    connectivity: "_x5v91ft0",
    confirmation: "_x5v94pcx",
    info: "_x5v9qm1h",
    warning: "_x5v9ervl",
    error: "_x5v9s4qr"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $03fed5c426e82edf$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const id = (0, $d6mTg.useId)();
    const toggleDialog = (0, $bSJIT.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $bSJIT.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $03fed5c426e82edf$var$styles.rootStyles,
            $03fed5c426e82edf$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $26Jy2.Popup), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    xcss: $03fed5c426e82edf$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $03fed5c426e82edf$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $PC54q.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $03fed5c426e82edf$export$2e2bcd8739ae039 = $03fed5c426e82edf$var$InlineMessage;

});
parcelRegister("26Jy2", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $f34dca6ecf657aae$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $d6mTg = parcelRequire("d6mTg");

var $iV599 = parcelRequire("iV599");

var $6gXOx = parcelRequire("6gXOx");

var $jvbf5 = parcelRequire("jvbf5");

var $gdUUy = parcelRequire("gdUUy");

var $bfFIw = parcelRequire("bfFIw");

var $lTYE1 = parcelRequire("lTYE1");

var $cglph = parcelRequire("cglph");

var $9PwDt = parcelRequire("9PwDt");

var $epeO4 = parcelRequire("epeO4");

var $7Tx2P = parcelRequire("7Tx2P");

var $htoHJ = parcelRequire("htoHJ");

var $5WYr0 = parcelRequire("5WYr0");

var $50Kco = parcelRequire("50Kco");
const $f34dca6ecf657aae$var$defaultLayer = 400;
const $f34dca6ecf657aae$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $f34dca6ecf657aae$var$PopupLegacy = (props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $f34dca6ecf657aae$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $bSJIT.useState)(null);
    const getMergedTriggerRef = (0, $5WYr0.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $50Kco.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $d6mTg.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $htoHJ.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $bSJIT.useCallback)(()=>{
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ (0, $dc70d.jsx)((0, $iV599.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $epeO4.default), {
            xcss: xcssPassthrough.value,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            zIndex: zIndex,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bfFIw.Manager), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $lTYE1.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $gdUUy.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $gdUUy.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $gdUUy.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cglph.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $gdUUy.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
                appear: true,
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cglph.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $f34dca6ecf657aae$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
};
const $f34dca6ecf657aae$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $bSJIT.memo)((props)=>{
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $gdUUy.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7Tx2P.PopupTopLayer), {
        ...props
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($f34dca6ecf657aae$var$PopupLegacy, {
        ...props
    });
});

});
parcelRegister("bfFIw", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $b0be147723270275$export$d0d38e7dec7a1a61);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $1ydlN = parcelRequire("1ydlN");

var $cFWBM = parcelRequire("cFWBM");

var $7ljqR = parcelRequire("7ljqR");

var $2ke8l = parcelRequire("2ke8l");
function $b0be147723270275$export$d0d38e7dec7a1a61({ children: children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor: anchor, setAnchor: setAnchor } = (0, $2ke8l.useAnchorState)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1ydlN.Manager), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7ljqR.AnchorSetterContext).Provider, {
            value: setAnchor,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cFWBM.AnchorContext).Provider, {
                value: anchor,
                children: children
            })
        })
    });
}

});
parcelRegister("7ljqR", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $4fb5b10993452a6c$export$804169e6eecdff16);

var $bSJIT = parcelRequire("bSJIT");
const $4fb5b10993452a6c$export$804169e6eecdff16 = /*#__PURE__*/ (0, $bSJIT.createContext)(()=>undefined);

});

parcelRegister("2ke8l", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $c7ed94a4de8fe726$export$1b1b50fdcd7ac375);

var $bSJIT = parcelRequire("bSJIT");
function $c7ed94a4de8fe726$export$1b1b50fdcd7ac375() {
    const [anchor, setAnchor] = (0, $bSJIT.useState)(null);
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("lTYE1", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $860c3b9b8c0a294b$export$e0be378c32fb70a7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dvjW5 = parcelRequire("dvjW5");

var $fGbV9 = parcelRequire("fGbV9");

var $8zENt = parcelRequire("8zENt");
function $860c3b9b8c0a294b$export$e0be378c32fb70a7({ children: children, innerRef: innerRef }) {
    const publishAnchor = (0, $8zENt.useManagerAnchorSetter)();
    const composedRef = (0, $bSJIT.useMemo)(()=>(0, $fGbV9.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dvjW5.Reference), {
        innerRef: composedRef,
        children: children
    });
}

});
parcelRegister("dvjW5", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $9d4da2724fc582ca$export$e0be378c32fb70a7);

var $bSJIT = parcelRequire("bSJIT");

var $d8cIB = parcelRequire("d8cIB");

var $1ydlN = parcelRequire("1ydlN");

var $c9X19 = parcelRequire("c9X19");
function $9d4da2724fc582ca$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $bSJIT.useContext((0, $1ydlN.ManagerReferenceNodeSetterContext));
    var refHandler = $bSJIT.useCallback(function(node) {
        (0, $c9X19.setRef)(innerRef, node);
        (0, $c9X19.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $bSJIT.useEffect(function() {
        return function() {
            return (0, $c9X19.setRef)(innerRef, null);
        };
    }, []);
    $bSJIT.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d8cIB)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $c9X19.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("d8cIB", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $98f5e34e6e5e69f9$var$__DEV__ = false;
var $98f5e34e6e5e69f9$var$warning = function() {};
if ($98f5e34e6e5e69f9$var$__DEV__) {
    var $98f5e34e6e5e69f9$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $98f5e34e6e5e69f9$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $98f5e34e6e5e69f9$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $98f5e34e6e5e69f9$var$warning;

});


parcelRegister("8zENt", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $6a6bd7ece4ad951e$export$fcdda419d7091b3);

var $bSJIT = parcelRequire("bSJIT");

var $7ljqR = parcelRequire("7ljqR");
function $6a6bd7ece4ad951e$export$fcdda419d7091b3() {
    return (0, $bSJIT.useContext)((0, $7ljqR.AnchorSetterContext));
}

});


parcelRegister("epeO4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1f903d38304ac22$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $g6jWc = parcelRequire("g6jWc");

var $iRdwF = parcelRequire("iRdwF");

var $2HQOV = parcelRequire("2HQOV");

var $gdUUy = parcelRequire("gdUUy");

var $ffwxl = parcelRequire("ffwxl");

var $6iL3d = parcelRequire("6iL3d");

var $j8uf9 = parcelRequire("j8uf9");

var $gd6Q1 = parcelRequire("gd6Q1");
const $a1f903d38304ac22$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $a1f903d38304ac22$var$fullWidthStyles = null;
const $a1f903d38304ac22$var$wrapperStyles = {
    root: "_2rko1mok _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
const $a1f903d38304ac22$var$scrollableStyles = null;
const $a1f903d38304ac22$var$blanketStyles = null;
const $a1f903d38304ac22$var$modalStyles = null;
const $a1f903d38304ac22$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $a1f903d38304ac22$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $a1f903d38304ac22$var$DefaultPopupComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            $a1f903d38304ac22$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $gdUUy.fg)('platform-dst-motion-uplift-popup') ? ref : undefined,
        children: children
    });
});
function $a1f903d38304ac22$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $a1f903d38304ac22$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $bSJIT.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $bSJIT.useState)(null);
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $gd6Q1.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $j8uf9.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $g6jWc.useLayering)();
    const mergedModifiers = (0, $bSJIT.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ffwxl.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $dc70d.jsx)(PopupContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $9fU1q.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $gdUUy.fg)('platform-design-system-apply-popup-wrapper-focus') && $a1f903d38304ac22$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $gdUUy.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: (0, $gdUUy.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6iL3d.RepositionOnUpdate), {
                    update: update,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                        children: content({
                            update: update,
                            isOpen: isOpen,
                            onClose: onClose,
                            setInitialFocusRef: setInitialFocusRef
                        })
                    })
                })
            });
            const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
            const container = /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: zIndex
                },
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $9fU1q.default)([
                    shouldFitContainer && $a1f903d38304ac22$var$wrapperStyles.fullWidth
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iRdwF.default), {
                    enteringAnimation: !isAutoPlacement ? $a1f903d38304ac22$var$placementMap[placement].enter : undefined,
                    exitingAnimation: !isAutoPlacement ? $a1f903d38304ac22$var$placementMap[placement].exit : undefined,
                    xcss: $a1f903d38304ac22$var$wrapperStyles.motion,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
                children: [
                    (0, $gdUUy.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        className: (0, $9fU1q.default)([
                            "_1r04idpf _kqsw1n9t _bfhk1i5c"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a1f903d38304ac22$export$2e2bcd8739ae039 = $a1f903d38304ac22$var$PopperWrapper;

});
parcelRegister("6iL3d", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $34ed45d9e97ba22d$export$51eddd7655ca235a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $34ed45d9e97ba22d$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $bSJIT.useRef)(true);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: children
    });
};

});

parcelRegister("j8uf9", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $a31ea2348481073c$export$92dae2778ae88f9d);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $1OdZP = parcelRequire("1OdZP");

var $g6jWc = parcelRequire("g6jWc");

var $gdUUy = parcelRequire("gdUUy");

var $5LKNQ = parcelRequire("5LKNQ");

var $fEQvK = parcelRequire("fEQvK");
const $a31ea2348481073c$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $g6jWc.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $fEQvK.useAnimationFrame)();
    const mouseDownTarget = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $1OdZP.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event)) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    currentLevel = ((_event$target$closest = event.target.closest(`[data-ds--level]`)) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level')) ?? null;
                }
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $gdUUy.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                var _target$closest;
                const layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, `[data-ds--level]`);
                if (layeredElement) {
                    const closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $5LKNQ.isInteractiveElement)(document.activeElement) && (0, $gdUUy.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $gdUUy.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                const levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $gdUUy.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $1OdZP.default);
        if ((0, $gdUUy.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $bAB3U.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $bAB3U.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $1OdZP.default);
        unbindBlur = (0, $bAB3U.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $gdUUy.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("5LKNQ", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $20447449a96e5628$export$3dee5e4542c672d9);
const $20447449a96e5628$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $20447449a96e5628$export$3dee5e4542c672d9 = (element)=>{
    if ($20447449a96e5628$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("fEQvK", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $56d96e309c78f71d$export$641fa9c94086b46e);

var $bSJIT = parcelRequire("bSJIT");
const $56d96e309c78f71d$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $bSJIT.useRef)([]);
    const requestFrame = (0, $bSJIT.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $bSJIT.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $bSJIT.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("gd6Q1", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $accd8fe905074001$export$10c5169755ce7bd7);

var $bSJIT = parcelRequire("bSJIT");

var $iOdDG = parcelRequire("iOdDG");

var $1OdZP = parcelRequire("1OdZP");

var $g6jWc = parcelRequire("g6jWc");

var $gdUUy = parcelRequire("gdUUy");

var $fEQvK = parcelRequire("fEQvK");
const $accd8fe905074001$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $fEQvK.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $g6jWc.useLayering)();
    (0, $bSJIT.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $1OdZP.default;
        if (shouldDisableFocusTrap && (0, $gdUUy.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $1OdZP.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $gdUUy.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iOdDG)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
            if (((0, $gdUUy.fg)('platform-dst-popup-trigger-focus-fix') || (0, $gdUUy.fg)('platform_dst-popup-trigger-initial-focus-ref')) && shouldReturnFocus) requestFrame(()=>{
                if (triggerRef !== null && triggerRef !== void 0 && triggerRef.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("iOdDG", function(module, exports) {

var $kPE9s = parcelRequire("kPE9s");
var $db1779ef7566214a$var$listeningFocusTrap = null;
function $db1779ef7566214a$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $db1779ef7566214a$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($db1779ef7566214a$var$listeningFocusTrap) $db1779ef7566214a$var$listeningFocusTrap.pause();
        $db1779ef7566214a$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $db1779ef7566214a$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $db1779ef7566214a$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $db1779ef7566214a$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $db1779ef7566214a$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $db1779ef7566214a$var$tryFocus(lastTabbableNode);
            return $db1779ef7566214a$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $db1779ef7566214a$var$tryFocus(firstTabbableNode);
        $db1779ef7566214a$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $kPE9s(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $db1779ef7566214a$var$tryFocus(lastTabbableNode);
        $db1779ef7566214a$var$tryFocus(firstTabbableNode);
    }
}
function $db1779ef7566214a$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $db1779ef7566214a$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $db1779ef7566214a$var$focusTrap;

});
parcelRegister("kPE9s", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $f2a7b750557a096e$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $f2a7b750557a096e$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("7Tx2P", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $daf1140bfb8254ac$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $2HQOV = parcelRequire("2HQOV");

var $sGuds = parcelRequire("sGuds");

var $65Dj6 = parcelRequire("65Dj6");

var $gCNJX = parcelRequire("gCNJX");

var $iPO5x = parcelRequire("iPO5x");

var $jfBg8 = parcelRequire("jfBg8");

var $7nmZk = parcelRequire("7nmZk");

var $jFqOs = parcelRequire("jFqOs");

var $ixsTQ = parcelRequire("ixsTQ");

var $grbG1 = parcelRequire("grbG1");

var $85epB = parcelRequire("85epB");
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $daf1140bfb8254ac$var$EMPTY_STYLE = {};
const $daf1140bfb8254ac$export$e24b8cb659609dee = /*#__PURE__*/ (0, $bSJIT.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, trigger: trigger, content: content, onClose: onClose = (0, $1OdZP.default), placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, // top-layer: initial focus follows `role`. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
autoFocus: _autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: maps onto `'max-available'`, capping the popup to the space
// between the trigger and the viewport edge. `PopoverSurface` already owns
// `overflow: auto`, so the capped surface scrolls.
//
// Keep the explicit `false`: `undefined` previously reached an
// `isEnabled = true` default and silently enabled fitting for every popup
// that omitted the prop.
shouldFitViewport = false, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const triggerRef = (0, $bSJIT.useRef)(null);
    const popoverRef = (0, $bSJIT.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ const consumerInitialFocusRef = (0, $bSJIT.useRef)(null);
    const setInitialFocusRef = (0, $bSJIT.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Initial focus, applied once per open:
   *
   * - The underlying `Popover` moves focus by `role` (its internal
   *   `useInitialFocus`). `autoFocus` has no effect here: role and focus
   *   go together. With no role, or a role that does not move focus,
   *   focus stays where it was. See
   *   `@atlaskit/top-layer` `notes/decisions/role-and-focus.md`.
   * - `setInitialFocusRef` wins. React flushes child effects before
   *   parent effects, so this runs after `Popover`'s initial focus.
   *
   * Only `isOpen` is a dependency: a prop change while open never moves focus.
   */ (0, $bSJIT.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) consumerTarget.focus();
    }, [
        isOpen
    ]);
    const popoverId = (0, $jFqOs.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $bSJIT.useMemo)(()=>(0, $65Dj6.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $7nmZk.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $ixsTQ.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $bSJIT.useCallback)(({ reason: reason })=>{
        onClose((0, $iPO5x.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    // The args always hold the setter; the `TPopup` types decide who can see it.
    const contentProps = (0, $bSJIT.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $1OdZP.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $85epB.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const resolvedPopoverId = providedId ?? popoverId;
    const ariaAttributes = (0, $sGuds.getAriaForTrigger)({
        role: (0, $grbG1.getTriggerRole)({
            role: roleProps.role
        }),
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            trigger(triggerProps),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $jfBg8.Popover), {
                ref: popoverRef,
                id: resolvedPopoverId,
                ...roleProps,
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--container`,
                children: Container ? /*#__PURE__*/ (0, $dc70d.jsx)(Container, {
                    style: $daf1140bfb8254ac$var$EMPTY_STYLE,
                    id: providedId,
                    "data-placement": placement,
                    "data-testid": testId,
                    tabIndex: -1,
                    xcss: xcss,
                    // Forwarded because several in-tree containers key their own
                    // `overflow: auto` branch off it.
                    shouldFitViewport: shouldFitViewport,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                        children: content(contentProps)
                    })
                }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
                // same element, so it is the scroll container. The wrapper exists only
                // to carry the consumer's `xcss`: `PopoverSurface` exposes no
                // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
                // surface. `width` works there; surface-level declarations apply one
                // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $gCNJX.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: xcss,
                        "data-testid": testId,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2HQOV.default), {
                            children: content(contentProps)
                        })
                    })
                })
            })
        ]
    });
});

});
parcelRegister("sGuds", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $3b0c37a3deae70a2$export$9dd1d61dd4d4755);
/**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $3b0c37a3deae70a2$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $3b0c37a3deae70a2$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': role ? $3b0c37a3deae70a2$var$roleToAriaHasPopup[role] : undefined,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("gCNJX", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $e04dfb42a7552137$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $e04dfb42a7552137$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $e04dfb42a7552137$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $e04dfb42a7552137$var$styles.root
        ]),
        children: children
    });
}

});

parcelRegister("iPO5x", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $9e93784dd20d6360$export$27b4de066896ac63);
function $9e93784dd20d6360$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("ixsTQ", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $fa68b6cb6c142128$export$60eb6c71554f82c4);
function $fa68b6cb6c142128$export$60eb6c71554f82c4({ shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport }) {
    const blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("grbG1", function(module, exports) {
$parcel$export(module.exports, "getTriggerRole", () => $ff30c7a02d645866$export$7647c858fbf2aa3);
/**
 * Narrows a popup `role` to one that `getAriaForTrigger` accepts.
 *
 * Tooltip-family roles and no role give `undefined`, so the trigger gets no `aria-haspopup`.
 */ function $ff30c7a02d645866$export$7647c858fbf2aa3({ role: role }) {
    if (role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox' || role === 'tree' || role === 'grid') return role;
    return undefined;
}

});

parcelRegister("85epB", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $3ea89e7abf6c6198$export$892580369e97d8b9);

var $bSJIT = parcelRequire("bSJIT");
function $3ea89e7abf6c6198$export$892580369e97d8b9({ role: role, label: label, titleId: titleId }) {
    return (0, $bSJIT.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label ?? 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("htoHJ", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $b214380ef9ee7434$export$4065aef1d79a5730);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $jfgZg = parcelRequire("jfgZg");
function $b214380ef9ee7434$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
   * This gate removes unnecessary state changes across the below-sm boundary
   * The state change is only needed if the popup can become a modal - and this is maintained
   */ const shouldUseMediaQuery = !(0, $gdUUy.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    const mq = (0, $jfgZg.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? (e)=>{
        setIsSmallViewport(!!e.matches);
    } : undefined);
    const [isSmallViewport, setIsSmallViewport] = (0, $bSJIT.useState)(!!(mq !== null && mq !== void 0 && mq.matches));
    const appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("jfgZg", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $0424dbbd7fc95e75$export$49e55ae2c03d6045);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $9RqPE = parcelRequire("9RqPE");
var $0424dbbd7fc95e75$var$_window, $0424dbbd7fc95e75$var$_window$matchMedia, $0424dbbd7fc95e75$var$_window2, $0424dbbd7fc95e75$var$_window2$matchMedia, $0424dbbd7fc95e75$var$_window3, $0424dbbd7fc95e75$var$_window3$matchMedia, $0424dbbd7fc95e75$var$_window4, $0424dbbd7fc95e75$var$_window4$matchMedia, $0424dbbd7fc95e75$var$_window5, $0424dbbd7fc95e75$var$_window5$matchMedia, $0424dbbd7fc95e75$var$_window6, $0424dbbd7fc95e75$var$_window6$matchMedia, $0424dbbd7fc95e75$var$_window7, $0424dbbd7fc95e75$var$_window7$matchMedia, $0424dbbd7fc95e75$var$_window8, $0424dbbd7fc95e75$var$_window8$matchMedia, $0424dbbd7fc95e75$var$_window9, $0424dbbd7fc95e75$var$_window9$matchMedia, $0424dbbd7fc95e75$var$_window0, $0424dbbd7fc95e75$var$_window0$matchMedia, $0424dbbd7fc95e75$var$_window1, $0424dbbd7fc95e75$var$_window1$matchMedia;
const $0424dbbd7fc95e75$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window = window) === null || $0424dbbd7fc95e75$var$_window === void 0 || ($0424dbbd7fc95e75$var$_window$matchMedia = $0424dbbd7fc95e75$var$_window.matchMedia) === null || $0424dbbd7fc95e75$var$_window$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window$matchMedia.call($0424dbbd7fc95e75$var$_window, (0, $9RqPE.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window2 = window) === null || $0424dbbd7fc95e75$var$_window2 === void 0 || ($0424dbbd7fc95e75$var$_window2$matchMedia = $0424dbbd7fc95e75$var$_window2.matchMedia) === null || $0424dbbd7fc95e75$var$_window2$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window2$matchMedia.call($0424dbbd7fc95e75$var$_window2, (0, $9RqPE.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window3 = window) === null || $0424dbbd7fc95e75$var$_window3 === void 0 || ($0424dbbd7fc95e75$var$_window3$matchMedia = $0424dbbd7fc95e75$var$_window3.matchMedia) === null || $0424dbbd7fc95e75$var$_window3$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window3$matchMedia.call($0424dbbd7fc95e75$var$_window3, (0, $9RqPE.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window4 = window) === null || $0424dbbd7fc95e75$var$_window4 === void 0 || ($0424dbbd7fc95e75$var$_window4$matchMedia = $0424dbbd7fc95e75$var$_window4.matchMedia) === null || $0424dbbd7fc95e75$var$_window4$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window4$matchMedia.call($0424dbbd7fc95e75$var$_window4, (0, $9RqPE.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window5 = window) === null || $0424dbbd7fc95e75$var$_window5 === void 0 || ($0424dbbd7fc95e75$var$_window5$matchMedia = $0424dbbd7fc95e75$var$_window5.matchMedia) === null || $0424dbbd7fc95e75$var$_window5$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window5$matchMedia.call($0424dbbd7fc95e75$var$_window5, (0, $9RqPE.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window6 = window) === null || $0424dbbd7fc95e75$var$_window6 === void 0 || ($0424dbbd7fc95e75$var$_window6$matchMedia = $0424dbbd7fc95e75$var$_window6.matchMedia) === null || $0424dbbd7fc95e75$var$_window6$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window6$matchMedia.call($0424dbbd7fc95e75$var$_window6, (0, $9RqPE.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window7 = window) === null || $0424dbbd7fc95e75$var$_window7 === void 0 || ($0424dbbd7fc95e75$var$_window7$matchMedia = $0424dbbd7fc95e75$var$_window7.matchMedia) === null || $0424dbbd7fc95e75$var$_window7$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window7$matchMedia.call($0424dbbd7fc95e75$var$_window7, (0, $9RqPE.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window8 = window) === null || $0424dbbd7fc95e75$var$_window8 === void 0 || ($0424dbbd7fc95e75$var$_window8$matchMedia = $0424dbbd7fc95e75$var$_window8.matchMedia) === null || $0424dbbd7fc95e75$var$_window8$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window8$matchMedia.call($0424dbbd7fc95e75$var$_window8, (0, $9RqPE.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window9 = window) === null || $0424dbbd7fc95e75$var$_window9 === void 0 || ($0424dbbd7fc95e75$var$_window9$matchMedia = $0424dbbd7fc95e75$var$_window9.matchMedia) === null || $0424dbbd7fc95e75$var$_window9$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window9$matchMedia.call($0424dbbd7fc95e75$var$_window9, (0, $9RqPE.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window0 = window) === null || $0424dbbd7fc95e75$var$_window0 === void 0 || ($0424dbbd7fc95e75$var$_window0$matchMedia = $0424dbbd7fc95e75$var$_window0.matchMedia) === null || $0424dbbd7fc95e75$var$_window0$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window0$matchMedia.call($0424dbbd7fc95e75$var$_window0, (0, $9RqPE.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($0424dbbd7fc95e75$var$_window1 = window) === null || $0424dbbd7fc95e75$var$_window1 === void 0 || ($0424dbbd7fc95e75$var$_window1$matchMedia = $0424dbbd7fc95e75$var$_window1.matchMedia) === null || $0424dbbd7fc95e75$var$_window1$matchMedia === void 0 ? void 0 : $0424dbbd7fc95e75$var$_window1$matchMedia.call($0424dbbd7fc95e75$var$_window1, (0, $9RqPE.media).below.xl.replace('@media ', '').trim())
};
const $0424dbbd7fc95e75$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $bSJIT.useRef)(listener);
    (0, $bSJIT.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $0424dbbd7fc95e75$var$queries[queryString];
    (0, $bSJIT.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $bAB3U.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("9RqPE", function(module, exports) {
$parcel$export(module.exports, "media", () => $7d32b276de12e995$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $7d32b276de12e995$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("5WYr0", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $0df9c889ab3684bd$export$7cc5c058dd769dff);

var $bSJIT = parcelRequire("bSJIT");

var $57l7A = parcelRequire("57l7A");
const $0df9c889ab3684bd$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $bSJIT.useState)(()=>(0, $57l7A.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("50Kco", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $4ed4b3205314255d$export$5d3a2de79e07b376);

var $bSJIT = parcelRequire("bSJIT");

var $57l7A = parcelRequire("57l7A");
const $4ed4b3205314255d$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $bSJIT.useState)(()=>(0, $57l7A.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("PC54q", function(module, exports) {
$parcel$export(module.exports, "default", () => $e85fb764136c1b7b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $6C2qG = parcelRequire("6C2qG");
const $e85fb764136c1b7b$var$iconColor = {
    connectivity: "_syaz1ft0",
    confirmation: "_syaz4pcx",
    info: "_syazqm1h",
    warning: "_syazervl",
    error: "_syazs4qr"
};
const $e85fb764136c1b7b$var$iconWrapperStyles = null;
const $e85fb764136c1b7b$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $e85fb764136c1b7b$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $6C2qG.typesMapping);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $9fU1q.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o",
            $e85fb764136c1b7b$var$iconColor[appearance],
            isOpen && "_syaz1kum"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $e85fb764136c1b7b$export$2e2bcd8739ae039 = $e85fb764136c1b7b$var$SelectedIcon;

});
parcelRegister("6C2qG", function(module, exports) {
$parcel$export(module.exports, "typesMapping", () => $35add31730bcdd69$export$4d111645c0b39d5d);

var $hkLEY = parcelRequire("hkLEY");

var $68E0O = parcelRequire("68E0O");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");
const $35add31730bcdd69$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("j8rB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $913fc45b4cb81932$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $913fc45b4cb81932$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    backToSettings: {
        defaultMessage: 'Cancel',
        description: 'Action label for the cancel/back button in the action bar of the help center layout builder screen',
        id: 'cv.portal.customization.action.cancel.help.center.settings'
    },
    giveFeedback: {
        defaultMessage: 'Give feedback',
        description: 'Action label for the give feedback button in the action bar of the help center layout builder screen',
        id: 'cv.portal.customization.action.give.feedback.help.center.settings'
    },
    publish: {
        defaultMessage: 'Publish',
        description: 'Label for the publish button in the action bar of the help center layout builder',
        id: 'cv.portal.customization.action.publish.layout.label'
    },
    preview: {
        defaultMessage: 'Preview',
        description: 'Label for the preview button in the action bar of the help center layout builder',
        id: 'cv.portal.customization.action.preview.layout.label'
    },
    previewMessage: {
        defaultMessage: 'This is a preview of the changes you made to the page layout.',
        description: 'Informational message displayed in the action bar when the user is previewing layout changes in the help center layout builder',
        id: 'cv.portal.customization.action.preview.layout.message'
    },
    exitPreview: {
        defaultMessage: 'Back',
        description: 'Label for the back button that exits the preview mode in the help center layout builder',
        id: 'cv.portal.customization.action.exit.preview.layout.label'
    }
});

});




parcelRegister("k30kR", function(module, exports) {
$parcel$export(module.exports, "ViewHomepageResource", () => $460d7af3a8a5d038$export$6527e8b974db86ba);
$parcel$export(module.exports, "searchComponentVirtualAgentResource", () => $460d7af3a8a5d038$export$b92a87df2da13e74);

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $6gAcU = parcelRequire("6gAcU");

var $7cFus = parcelRequire("7cFus");

var $87QgR = parcelRequire("87QgR");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $3LQyI = parcelRequire("3LQyI");

var $jeIez = parcelRequire("jeIez");
const $460d7af3a8a5d038$export$6527e8b974db86ba = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) ? (0, $3LQyI.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $7cFus.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}) : (0, $3LQyI.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $6gAcU.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $460d7af3a8a5d038$export$b92a87df2da13e74 = (0, $3LQyI.createRelayResource)({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, isUserLoggedIn: isUserLoggedIn })=>{
        const isLoggedIn = (0, $87QgR.default).checkGate('jsd-search-router-login-logic-removal') ? Boolean((0, $fuVmc.getMeta)('ajs-atlassian-account-id')) : isUserLoggedIn;
        return {
            parameters: (0, $jeIez.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $lFpPv.isVAOnHelpCenterGAEnabled)() && isLoggedIn
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("6gAcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7ee2ee423ff3833$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<528eb58a638804d653f316e7c8c17c1d>>
 * @relayHash 52150ef5f0d7c47144a859118fbd07a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14c76222fff73d5c344c4dbaf7f9cbba582818f6f65793980afa0a5fcbe0c9b0
const $b7ee2ee423ff3833$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14c76222fff73d5c344c4dbaf7f9cbba582818f6f65793980afa0a5fcbe0c9b0",
            "metadata": {},
            "name": "viewHomepageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b7ee2ee423ff3833$var$node.hash = "42b522e52d1baf895f59577f86f4867c";
var $b7ee2ee423ff3833$export$2e2bcd8739ae039 = $b7ee2ee423ff3833$var$node;

});

parcelRegister("7cFus", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5e72e4f37dbf8bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<458f53226bb2432219d88352bf96afc7>>
 * @relayHash 75bedb2759687e5e6f48516802def4db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71c95185f2dd2b29635a3a3395cbc06e341c004da231c2e1a9bf5a4c18842223
const $c5e72e4f37dbf8bc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71c95185f2dd2b29635a3a3395cbc06e341c004da231c2e1a9bf5a4c18842223",
            "metadata": {},
            "name": "viewHomepageForCsmQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c5e72e4f37dbf8bc$var$node.hash = "6e15b917f113b3de216943c357988704";
var $c5e72e4f37dbf8bc$export$2e2bcd8739ae039 = $c5e72e4f37dbf8bc$var$node;

});

parcelRegister("3LQyI", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $2223ac631a7198bc$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $2223ac631a7198bc$export$42ca7b248c7aaee);

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");
var $hMsRa = parcelRequire("hMsRa");

var $4270B = parcelRequire("4270B");

var $kbkME = parcelRequire("kbkME");
const $2223ac631a7198bc$export$1cc887c62079ea32 = ({ type: type, getQuery: getQuery })=>(0, $iXC0o.createResource)({
        type: `RELAY_RESOURCE_TYPE_${type}`,
        getKey: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $lFpPv.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return 'RELAY_RESOURCE_DISABLED';
            }
            //@ts-ignore this key does not really matter since max-age is set to zero. This util is a polyfill and will be done away with once we adopt Relay entry points.
            const request = (0, $4270B.getRequest)(parameters);
            const params = request.params;
            const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, options: options, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $lFpPv.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return Promise.resolve(null);
            }
            const queryReference = (0, $a2qIF.loadQuery)((0, $kbkME.getRelayEnvironment)(), parameters, variables || {}, options);
            return Promise.resolve(queryReference);
        },
        maxAge: 0
    });
const $2223ac631a7198bc$export$42ca7b248c7aaee = (resource)=>{
    const { refresh: refresh, data: queryReference } = (0, $hMsRa.useResource)(resource);
    return {
        queryReference: queryReference,
        refresh: refresh
    };
};

});

parcelRegister("jeIez", function(module, exports) {
$parcel$export(module.exports, "default", () => $b327067d1a847a7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cd94073415fdd0bbf4409dae41a9174>>
 * @relayHash 078d7490b0e32c04c06ec9ee114c1d15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da
const $b327067d1a847a7a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v5 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da",
            "metadata": {},
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b327067d1a847a7a$var$node.hash = "fb84e9b37fd41dce66a7b8b53fc81357";
var $b327067d1a847a7a$export$2e2bcd8739ae039 = $b327067d1a847a7a$var$node;

});


parcelRegister("emd1X", function(module, exports) {
$parcel$export(module.exports, "FlexibleEditpageLoader", () => (parcelRequire("5ZKvf")).default);

var $5ZKvf = parcelRequire("5ZKvf");

});
parcelRegister("5ZKvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $acb04c7116b41ac1$export$2e2bcd8739ae039);
/* flexible-edit-page-loader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hF8Ik = parcelRequire("hF8Ik");

var $1DDTY = parcelRequire("1DDTY");
parcelRequire("7W2NN");
var $fR6LO = parcelRequire("fR6LO");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $1qPbZ = parcelRequire("1qPbZ");
const $acb04c7116b41ac1$var$SECTION_HEIGHT = 232;
const $acb04c7116b41ac1$var$FlexibleEditpageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "flexible-edit-page-loader"
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fR6LO.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $acb04c7116b41ac1$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "main",
        xcss: $acb04c7116b41ac1$var$skeletonContainerWithSidebar,
        style: {
            marginRight: '340px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $acb04c7116b41ac1$var$layoutBuilderWrapper
    }, !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $acb04c7116b41ac1$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $1DDTY.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $acb04c7116b41ac1$var$sectionLoader,
            key: `flexibleHCLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            "data-testid": "flexible-hc-section-skeleton",
            height: $acb04c7116b41ac1$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "aside",
        xcss: $acb04c7116b41ac1$var$sidebarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $acb04c7116b41ac1$var$breadcrumbContainer
    }, Array(3).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $acb04c7116b41ac1$var$breadCrumbItem,
            key: `breadCrumbLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($acb04c7116b41ac1$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })))), Array(4).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: [
                $acb04c7116b41ac1$var$configWrapper,
                index === 0 && $acb04c7116b41ac1$var$configWrapper24PxWidth,
                index === 3 && $acb04c7116b41ac1$var$configWrapper146PxWidth
            ],
            key: `ConfigPanelLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($acb04c7116b41ac1$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))));
};
const $acb04c7116b41ac1$var$skeletonContainerWithSidebar = (0, $9BVpB.xcss)({
    position: 'relative',
    padding: 'space.150',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: 'elevation.surface.hovered',
    alignItems: 'center',
    overflowY: 'auto',
    height: 'calc(100vh - 56px)'
});
const $acb04c7116b41ac1$var$headerContainer = (0, $9BVpB.xcss)({
    width: '100%'
});
const $acb04c7116b41ac1$var$container = (0, $9BVpB.xcss)({
    display: 'flex',
    justifyContent: 'stretch',
    flex: '1 1 auto'
});
const $acb04c7116b41ac1$var$sidebarWrapper = (0, $9BVpB.xcss)({
    flex: 0,
    position: 'fixed',
    right: 'space.0',
    width: '340px',
    backgroundColor: 'elevation.surface',
    zIndex: 'navigation',
    minHeight: '-webkit-fill-available',
    boxShadow: 'elevation.shadow.overlay',
    height: 'calc(100vh - 56px)'
});
const $acb04c7116b41ac1$var$layoutBuilderWrapper = (0, $9BVpB.xcss)({
    position: 'relative',
    width: '100%',
    borderRadius: 'radius.large',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised',
    overflow: 'visible'
});
const $acb04c7116b41ac1$var$sectionLoader = (0, $9BVpB.xcss)({
    padding: 'space.400',
    borderRadius: 'radius.large'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $acb04c7116b41ac1$var$SidePanelLoader = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $hF8Ik.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $acb04c7116b41ac1$var$breadcrumbContainer = (0, $9BVpB.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    textAlign: 'left',
    padding: 'space.100',
    borderBottomColor: 'color.border',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid'
});
const $acb04c7116b41ac1$var$breadCrumbItem = (0, $9BVpB.xcss)({
    width: '84px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: 'space.100'
});
const $acb04c7116b41ac1$var$configWrapper = (0, $9BVpB.xcss)({
    width: '100%',
    height: 'space.250',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 'space.300',
    paddingBottom: 'space.0'
});
const $acb04c7116b41ac1$var$configWrapper24PxWidth = (0, $9BVpB.xcss)({
    width: '72px'
});
const $acb04c7116b41ac1$var$configWrapper146PxWidth = (0, $9BVpB.xcss)({
    width: '194px'
});
var $acb04c7116b41ac1$export$2e2bcd8739ae039 = $acb04c7116b41ac1$var$FlexibleEditpageLoader;

});


parcelRegister("dgMoN", function(module, exports) {
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => (parcelRequire("hWMM6")).anonymousRequestSuccessRoute);
$parcel$export(module.exports, "getRequestCreateRoute", () => (parcelRequire("hWMM6")).getRequestCreateRoute);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => (parcelRequire("hWMM6")).helpCenterRequestFeedbackRoute);
$parcel$export(module.exports, "notFoundErrorRoute", () => (parcelRequire("hWMM6")).notFoundErrorRoute);
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("hWMM6")).NotFoundPage);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("36cmj")).portalReorderRoute);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => (parcelRequire("hWMM6")).RenderCreateAnonymousSuccess);
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => (parcelRequire("hWMM6")).RenderRequestCreateForHubs);
$parcel$export(module.exports, "requestFeedbackRoute", () => (parcelRequire("hWMM6")).requestFeedbackRoute);
$parcel$export(module.exports, "unsubscribeRoute", () => (parcelRequire("hWMM6")).unsubscribeRoute);
$parcel$export(module.exports, "userProfileRoute", () => (parcelRequire("hWMM6")).userProfileRoute);
parcelRequire("hWMM6");

});
parcelRegister("hWMM6", function(module, exports) {
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => $6518cbd0ff0a2d4b$export$a877efa523a67c07);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => $6518cbd0ff0a2d4b$export$1d1b8e06f48bd2d4);
$parcel$export(module.exports, "userProfileRoute", () => $6518cbd0ff0a2d4b$export$abc0ddbfeed2cc26);
$parcel$export(module.exports, "NotFoundPage", () => $6518cbd0ff0a2d4b$export$31641b61980e511f);
$parcel$export(module.exports, "getRequestCreateRoute", () => $6518cbd0ff0a2d4b$export$b0cc27459efb2ff4);
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => $6518cbd0ff0a2d4b$export$ea05b9ec1342627e);
$parcel$export(module.exports, "requestFeedbackRoute", () => $6518cbd0ff0a2d4b$export$a3cf9a79f03e97df);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => $6518cbd0ff0a2d4b$export$45634ebe4da270df);
$parcel$export(module.exports, "unsubscribeRoute", () => $6518cbd0ff0a2d4b$export$7dfcaf0a6ac7c9fe);
$parcel$export(module.exports, "notFoundErrorRoute", () => $6518cbd0ff0a2d4b$export$5443dabb022476b2);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("36cmj")).portalReorderRoute);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fFr9c = parcelRequire("fFr9c");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("jWWjz");
var $6EkPI = parcelRequire("6EkPI");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");

var $fDWZJ = parcelRequire("fDWZJ");

var $2ITPO = parcelRequire("2ITPO");

var $eseHb = parcelRequire("eseHb");

var $jK6W9 = parcelRequire("jK6W9");

var $lYtcY = parcelRequire("lYtcY");

var $1s4Gq = parcelRequire("1s4Gq");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $87QgR = parcelRequire("87QgR");

var $haAAx = parcelRequire("haAAx");

var $irUsc = parcelRequire("irUsc");

var $bkEWh = parcelRequire("bkEWh");

var $hxOA5 = parcelRequire("hxOA5");

var $36cmj = parcelRequire("36cmj");
const $6518cbd0ff0a2d4b$var$HUBS_REQUEST_CREATE_KB_SUGGESTIONS = 'hubs_request_create_kb_suggestions';
const $6518cbd0ff0a2d4b$var$isHubsRequestCreateKbSuggestionsEnabled = ()=>(0, $87QgR.default).checkGate($6518cbd0ff0a2d4b$var$HUBS_REQUEST_CREATE_KB_SUGGESTIONS);
const $6518cbd0ff0a2d4b$var$portalRoutePrefix = '/portal/:portalId(\\d+)';
const $6518cbd0ff0a2d4b$export$4340468daf4d707e = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $irUsc.default), {
        screenName: (0, $jcRK7.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d7jBU.default), {
        screenName: (0, $jcRK7.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hxOA5.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2ITPO.RequestCreatePage), routerState))));
};
const $6518cbd0ff0a2d4b$export$a877efa523a67c07 = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $irUsc.default), {
        screenName: (0, $jcRK7.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d7jBU.default), {
        screenName: (0, $jcRK7.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hxOA5.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eseHb.RequestCreatePageForHubs), routerState))), $6518cbd0ff0a2d4b$var$isHubsRequestCreateKbSuggestionsEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6EkPI.default), {
        match: routerState.match,
        location: routerState.location,
        route: routerState.route
    }));
};
const $6518cbd0ff0a2d4b$export$1d1b8e06f48bd2d4 = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $irUsc.default), {
        screenName: (0, $jcRK7.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d7jBU.default), {
        screenName: (0, $jcRK7.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fDWZJ.RequestCreateAnonymousSuccess), routeContext)));
};
const $6518cbd0ff0a2d4b$export$abc0ddbfeed2cc26 = (0, $bkEWh.createRouteWithLayout)({
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $1s4Gq.UserProfile)
}, (0, $jcRK7.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});
const $6518cbd0ff0a2d4b$export$31641b61980e511f = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent && createAnalyticsEvent({
        action: 'rendered',
        analyticsType: (0, $haAAx.UI_EVENT_TYPE)
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fFr9c.default), {
        error: {
            status: (0, $jcRK7.HTTP).NOT_FOUND,
            message: '',
            callToActionUrl: '',
            callToActionText: ''
        }
    }, '');
};
const $6518cbd0ff0a2d4b$export$b0cc27459efb2ff4 = ()=>(0, $bkEWh.createRouteWithLayout)({
        name: 'request-create',
        path: '/portal/:portalId/create/:requestTypeId',
        exact: true,
        component: $6518cbd0ff0a2d4b$export$4340468daf4d707e,
        resources: []
    }, (0, $jcRK7.ScreenName).REQUEST_CREATE, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });
const $6518cbd0ff0a2d4b$export$ea05b9ec1342627e = (0, $bkEWh.createRouteWithLayout)({
    name: 'request-create-anonymous-success',
    path: '/portal/:portalId/create/:requestTypeId/confirm',
    exact: true,
    component: $6518cbd0ff0a2d4b$export$1d1b8e06f48bd2d4,
    resources: []
}, (0, $jcRK7.ScreenName).KNOWLEDGE_CATEGORY, {
    fadeInSearchModal: true
});
const $6518cbd0ff0a2d4b$export$a3cf9a79f03e97df = (0, $bkEWh.createRouteWithLayout)({
    name: 'request-feedback',
    path: `${$6518cbd0ff0a2d4b$var$portalRoutePrefix}/:requestKey/feedback`,
    exact: true,
    component: (0, $jK6W9.RequestFeedback),
    resources: []
}, (0, $jcRK7.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $6518cbd0ff0a2d4b$export$45634ebe4da270df = (0, $bkEWh.createRouteWithLayout)({
    name: 'request-feedback',
    path: `/user/requests/:requestKey/feedback`,
    exact: true,
    component: (0, $jK6W9.RequestFeedback),
    resources: []
}, (0, $jcRK7.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $6518cbd0ff0a2d4b$export$7dfcaf0a6ac7c9fe = (0, $bkEWh.createRouteWithLayout)({
    name: 'unsubscribeRoute',
    path: `${$6518cbd0ff0a2d4b$var$portalRoutePrefix}/:requestKey/unsubscribe`,
    exact: true,
    component: (0, $lYtcY.Unsubscribe),
    resources: []
}, (0, $jcRK7.ScreenName).UNSUBSCRIBE, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $6518cbd0ff0a2d4b$export$5443dabb022476b2 = (0, $bkEWh.createRouteWithLayout)({
    name: 'not-found-error-page',
    path: '(.*)',
    exact: true,
    component: (0, $2usNr.default)({
        componentName: 'notFoundPage'
    })((0, $kIbto.default)({})($6518cbd0ff0a2d4b$export$31641b61980e511f)),
    resources: []
}, (0, $jcRK7.ScreenName).ERROR_NOT_FOUND, {
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("fFr9c", function(module, exports) {
$parcel$export(module.exports, "withErrorPage", () => $7d237fe93c12d439$export$60ebd61e40e72272);
$parcel$export(module.exports, "default", () => $7d237fe93c12d439$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $j2vrN = parcelRequire("j2vrN");

var $jcRK7 = parcelRequire("jcRK7");

var $2ERPT = parcelRequire("2ERPT");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $4b8qO = parcelRequire("4b8qO");

var $cyWTn = parcelRequire("cyWTn");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("cAJ8B");
var $aquFW = parcelRequire("aquFW");

var $7WQx2 = parcelRequire("7WQx2");

var $aRsbV = parcelRequire("aRsbV");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $hCnLH = parcelRequire("hCnLH");

var $k4dp8 = parcelRequire("k4dp8");

var $iW3CQ = parcelRequire("iW3CQ");

var $3gKay = parcelRequire("3gKay");

var $2p5Fp = parcelRequire("2p5Fp");
const $7d237fe93c12d439$var$isUnhandledError = (statusCode)=>{
    // We want to report on any 5xx errors for the experience tracker.
    return `${statusCode}`.startsWith('5');
};
const $7d237fe93c12d439$export$5d56d6fe10c95f05 = ({ error: error, intl: intl })=>{
    let Icon;
    let heading = '';
    let description = '';
    const isCSMHelpCenterEnabled = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    switch(error.status){
        case (0, $jcRK7.HTTP).FORBIDDEN:
            heading = intl.formatMessage((0, $2p5Fp.default).permissionDenied);
            description = intl.formatMessage((0, $2p5Fp.default).permissionDeniedMessage);
            Icon = (0, $cyWTn.default);
            break;
        case (0, $jcRK7.HTTP).NOT_FOUND:
            heading = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $2p5Fp.default).notFoundV2 : (0, $2p5Fp.default).notFound);
            description = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $2p5Fp.default).notFoundMessageV2 : (0, $2p5Fp.default).notFoundMessage);
            Icon = (0, $4b8qO.default);
            break;
        case (0, $jcRK7.HTTP).OFFLINE:
            heading = intl.formatMessage((0, $2p5Fp.default).offlineHeading);
            description = intl.formatMessage((0, $2p5Fp.default).offlineMessage);
            Icon = (0, $4b8qO.default);
            break;
        case (0, $jcRK7.HTTP).SERVER:
        default:
            heading = intl.formatMessage((0, $2p5Fp.default).genericHeading);
            description = intl.formatMessage((0, $2p5Fp.default).genericMessage);
            Icon = (0, $4b8qO.default);
            break;
    }
    if (error.message) // If there is a message with the error we override it.
    description = typeof error.message === 'string' ? error.message : intl.formatMessage(error.message);
    if (error.heading) heading = typeof error.heading === 'string' ? error.heading : intl.formatMessage(error.heading);
    return {
        heading: heading,
        description: description,
        Icon: Icon
    };
};
const $7d237fe93c12d439$export$c120a0e80fd44ca6 = ({ error: error, children: children, intl: intl, config: config })=>{
    if (!!error) {
        const { Icon: Icon, heading: heading, description: description } = $7d237fe93c12d439$export$5d56d6fe10c95f05({
            error: error,
            intl: intl
        });
        // failure logging to be avoided only if the traceId is absent and the config is set to exclude empty traceId logs
        const shouldLogFailure = error.traceId ? true : !(config !== null && config !== void 0 && config.isEmptyTraceIdLogExcluded);
        const shouldRenderExperienceFailure = $7d237fe93c12d439$var$isUnhandledError(error.status) && shouldLogFailure;
        return /*#__PURE__*/ $bSJIT.createElement((0, $2ERPT.default), {
            title: description
        }, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.PaperContent), null, /*#__PURE__*/ $bSJIT.createElement($7d237fe93c12d439$var$Container, null, /*#__PURE__*/ $bSJIT.createElement($7d237fe93c12d439$var$IconContainer, null, /*#__PURE__*/ $bSJIT.createElement(Icon, null)), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
                space: "space.100",
                alignInline: "center",
                xcss: $7d237fe93c12d439$var$errorMessageContainerStyle
            }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                size: "medium",
                as: "div"
            }, heading), /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), {
                align: "center"
            }, description))
        }, /*#__PURE__*/ $bSJIT.createElement($7d237fe93c12d439$export$f69c19e57285b83a, null, heading), /*#__PURE__*/ $bSJIT.createElement($7d237fe93c12d439$var$Description, null, description)), error.status !== (0, $jcRK7.HTTP).OFFLINE && /*#__PURE__*/ $bSJIT.createElement((0, $3gKay.ErrorLink), {
            callToActionUrl: error.callToActionUrl
        }, error.callToActionText), shouldRenderExperienceFailure && /*#__PURE__*/ $bSJIT.createElement((0, $j2vrN.ExperienceFailure), {
            location: "error-page",
            errorMessage: description,
            traceId: error.traceId,
            responseHeaders: error.responseHeaders,
            status: error.status
        }))));
    }
    return $bSJIT.Children.only(children);
};
const $7d237fe93c12d439$var$IntlErrorPage = (0, $fK3tS.default)($7d237fe93c12d439$export$c120a0e80fd44ca6);
const $7d237fe93c12d439$export$60ebd61e40e72272 = (WrappedComponent, config)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $bSJIT.createElement($7d237fe93c12d439$var$IntlErrorPage, {
            ...props,
            error: props.error,
            config: config
        }, /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props));
var $7d237fe93c12d439$export$2e2bcd8739ae039 = $7d237fe93c12d439$var$IntlErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7d237fe93c12d439$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-a8w8t7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7d237fe93c12d439$var$IconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-a8w8t7-1"
})`width:${$9K7mZ.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7d237fe93c12d439$var$Description = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-a8w8t7-2"
})`${$98sDU.regular};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
const $7d237fe93c12d439$export$f69c19e57285b83a = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-a8w8t7-3"
})`${$98sDU.h600};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
const $7d237fe93c12d439$var$errorMessageContainerStyle = (0, $9BVpB.xcss)({
    marginBlockEnd: 'space.100'
});

});
parcelRegister("j2vrN", function(module, exports) {
$parcel$export(module.exports, "withExperienceNotifier", () => $32da1c1868c0195b$export$43b8ee6172152b23);
$parcel$export(module.exports, "ExperienceSuccess", () => $32da1c1868c0195b$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceFailure", () => $32da1c1868c0195b$export$eed1d73ebdd8c7ab);

var $bSJIT = parcelRequire("bSJIT");

var $7ajmc = parcelRequire("7ajmc");
// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
const $32da1c1868c0195b$var$createExperienceNotifier = (type)=>// eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $bSJIT.createElement((0, $7ajmc.default), {
            ...props,
            type: type
        });
const $32da1c1868c0195b$export$43b8ee6172152b23 = (experienceLocation)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $bSJIT.createElement((0, $7ajmc.default), {
                type: "CAN_SUCCEED_OR_FAIL",
                location: experienceLocation
            }, (notify)=>/*#__PURE__*/ $bSJIT.createElement(Component, {
                    ...props,
                    ...notify
                }));
        };
const $32da1c1868c0195b$export$4962f3898bd5c829 = $32da1c1868c0195b$var$createExperienceNotifier('IMMEDIATE_SUCCESS');
const $32da1c1868c0195b$export$eed1d73ebdd8c7ab = $32da1c1868c0195b$var$createExperienceNotifier('IMMEDIATE_FAILURE');

});
parcelRegister("7ajmc", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b57427a81a92c0a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $cvZci = parcelRequire("cvZci");

var $15AtB = parcelRequire("15AtB");
class $7b57427a81a92c0a$export$2e2bcd8739ae039 extends $bSJIT.Component {
    static #_ = this.contextType = (0, $15AtB.ExperienceContext);
    componentDidMount() {
        const { type: type, location: location, errorMessage: errorMessage, traceId: traceId, responseHeaders: responseHeaders, status: status } = this.props;
        if (type !== 'CAN_FAIL') this.context.onPending();
        if (type === 'IMMEDIATE_FAILURE') this.onFailure(errorMessage || location, traceId, responseHeaders, status);
        else if (type === 'IMMEDIATE_SUCCESS') this.onSuccess();
    // Otherwise we wait for the child to either throw an error or call `onExperienceSuccess`.
    }
    componentWillUnmount() {
        // If this component is being unmounted and still hasn't notified - assume it was successful.
        if (this.props.type !== 'CAN_FAIL') this.onSuccess();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        if (!(0, $cvZci.isIE7)()) this.context.onFailure({
            errorMessage: message,
            errorName: name,
            traceId: this.props.traceId,
            unhandledError: true,
            errorLocation: this.props.location
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    render() {
        const { children: children } = this.props;
        const markup = typeof children === 'function' ? children({
            notifySuccess: this.onSuccess,
            notifyFailure: this.onFailure
        }) : children;
        return markup || null;
    }
    constructor(...args){
        super(...args), this.hasSignalledSuccess = false, this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess) {
                this.hasSignalledSuccess = true;
                this.context.onSuccess();
            }
        }, this.onFailure = (errorMessage, traceId, responseHeaders, status)=>{
            if (!(0, $cvZci.isIE7)()) this.context.onFailure({
                errorMessage: errorMessage,
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: status,
                errorName: 'NotifyFailure',
                unhandledError: false,
                errorLocation: this.props.location
            });
        };
    }
}
const $7b57427a81a92c0a$export$eed1d73ebdd8c7ab = ({ experience: experience, config: config })=>{
    $bSJIT.useEffect(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.failure(config);
    }, [
        experience,
        config
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null);
};

});
parcelRegister("15AtB", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $b512730dd145b622$export$fb99266658f5da06);
$parcel$export(module.exports, "default", () => $b512730dd145b622$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $2A2RV = parcelRequire("2A2RV");
const $b512730dd145b622$export$fb99266658f5da06 = /*#__PURE__*/ $bSJIT.createContext({
    onFailure: (0, $4ZMmh.noop),
    onPending: (0, $4ZMmh.noop),
    onSuccess: (0, $4ZMmh.noop)
});
const $b512730dd145b622$export$9c9c79fc1d105790 = (errorMessage)=>{
    if (!errorMessage) return false;
    return errorMessage.includes('Converting circular structure to JSON') && errorMessage.includes('__reactFiber$');
};
class $b512730dd145b622$export$c90b54e658fc4d7c extends $bSJIT.Component {
    static #_ = this.checkNotifiersInterval = 1000;
    static #_2 = this.defaultProps = {
        isExperienceReady: true
    };
    componentDidMount() {
        this.checkAndStartTimer();
        this.trackExperience('taskStart');
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    checkAndStartTimer() {
        if (this.notifierHasBegunPending && this.props.isExperienceReady) this.startTimer();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackFailure({
            errorMessage: message,
            errorName: name,
            unhandledError: true,
            errorLocation: this.props.name
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = window.setTimeout(()=>{
            if (this.pendingCount === 0) this.trackSuccess();
        }, $b512730dd145b622$export$c90b54e658fc4d7c.checkNotifiersInterval);
    }
    trackSuccess() {
        this.trackExperience('taskSuccess');
    }
    trackFailure(failure) {
        // HOT-127428: exclude the third-party DOM-patch client error from the experience SLO.
        // We skip emitting the taskFail event (so it doesn't count against view-help-center) and
        // mark the experience as tracked to mirror an abort.
        if ($b512730dd145b622$export$9c9c79fc1d105790(failure === null || failure === void 0 ? void 0 : failure.errorMessage)) {
            this.hasTrackedExperience = true;
            return;
        }
        this.trackExperience('taskFail', failure);
    }
    trackExperience(action, errorFailure) {
        if (this.hasTrackedExperience) // Ignore any follow up tracking fired after the experience has been tracked.
        return;
        const { createAnalyticsEvent: createAnalyticsEvent, experienceId: experienceId, name: name } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const event = createAnalyticsEvent({});
        switch(action){
            case 'taskFail':
                (0, $2A2RV.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    error: errorFailure
                }, event);
                break;
            case 'taskSuccess':
                (0, $2A2RV.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
            case 'taskStart':
            default:
                (0, $2A2RV.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
        }
        if (action !== 'taskStart') this.hasTrackedExperience = true;
    }
    render() {
        return /*#__PURE__*/ $bSJIT.createElement($b512730dd145b622$export$fb99266658f5da06.Provider, {
            value: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), /**
   * This value is needed so the timer doesn't start until
   * at least one notifier has been turned on.
   */ this.notifierHasBegunPending = false, this.timerId = undefined, this.pendingCount = 0, this.hasTrackedExperience = false, /**
   * Called when a descendant experience notifier is waiting to see if it is successful or not.
   */ this.onPending = ()=>{
            this.pendingCount += 1;
            this.notifierHasBegunPending = true;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier successfully loaded.
   * ALL descendant experience notifiers need to successfully load for a SUCCESS
   * to be considered.
   */ this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier failed to load.
   * This caused the entire experience to FAIL.
   */ this.onFailure = (failure)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackFailure(failure);
        };
    }
}
var // Use "componentName" as a drop-in replacement for "actionSubject"
// analytics-web-react getEvent() currently only supports TRACK events
// setting it directly.
$b512730dd145b622$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'ui'
})((0, $kIbto.default)()($b512730dd145b622$export$c90b54e658fc4d7c));

});
parcelRegister("2A2RV", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd52752d0750bfdd$export$2e2bcd8739ae039);

var $lFpPv = parcelRequire("lFpPv");

var $k2MWg = parcelRequire("k2MWg");

var $clpci = parcelRequire("clpci");

var $haAAx = parcelRequire("haAAx");
const $dd52752d0750bfdd$var$createAnalyticsPayload = ({ name: name, action: action, experienceId: experienceId, ...rest })=>{
    const error = 'error' in rest ? rest.error : undefined;
    return {
        action: action,
        task: name,
        taskId: experienceId,
        reason: error && error.errorMessage,
        ...error
    };
};
var $dd52752d0750bfdd$export$2e2bcd8739ae039 = (experienceDescription, analyticsEvent)=>{
    const payload = $dd52752d0750bfdd$var$createAnalyticsPayload(experienceDescription);
    if ((0, $lFpPv.isMigrateToAnalyticsBridgeEnabled)()) {
        const { action: action, ...rest } = payload;
        (0, $k2MWg.fireAnalytics)(analyticsEvent, (0, $clpci.OPERATIONAL_EVENT_TYPE), {
            action: action,
            attributes: rest
        });
    } else {
        analyticsEvent.update(payload);
        (0, $haAAx.fireAnalyticsEvent)({
            payload: payload,
            analyticsEvent: analyticsEvent,
            type: (0, $haAAx.EventTypes).OPERATIONAL
        });
    }
};

});
parcelRegister("k2MWg", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $f10a758436639bac$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $f10a758436639bac$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $f10a758436639bac$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $f10a758436639bac$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $f10a758436639bac$export$6f46fb37ad7d962b);

var $fbpGW = parcelRequire("fbpGW");

var $clpci = parcelRequire("clpci");

var $ljS6r = parcelRequire("ljS6r");
const $f10a758436639bac$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $clpci.ANALYTICS_BRIDGE_CHANNEL));
};
const $f10a758436639bac$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fbpGW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $f10a758436639bac$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $ljS6r.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $f10a758436639bac$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $f10a758436639bac$export$34ac71ce24cddec2(event, (0, $clpci.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $f10a758436639bac$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $ljS6r.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $f10a758436639bac$export$34ac71ce24cddec2(event, (0, $clpci.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $f10a758436639bac$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $ljS6r.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $f10a758436639bac$export$34ac71ce24cddec2(event, (0, $clpci.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $f10a758436639bac$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $ljS6r.getImperativeAnalyticsDataFromArguments)(rest);
    $f10a758436639bac$export$34ac71ce24cddec2(event, (0, $clpci.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};

});
parcelRegister("ljS6r", function(module, exports) {
$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $346fb9db20182496$export$e6baab532ef8c6bf);
const $346fb9db20182496$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $346fb9db20182496$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $346fb9db20182496$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $346fb9db20182496$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $346fb9db20182496$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $346fb9db20182496$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $346fb9db20182496$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $346fb9db20182496$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $346fb9db20182496$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $346fb9db20182496$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $346fb9db20182496$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $346fb9db20182496$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});






parcelRegister("2ERPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1218feb3112647d0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $abgy5 = parcelRequire("abgy5");

var $fK3tS = parcelRequire("fK3tS");

var $f4oxo = parcelRequire("f4oxo");
const $1218feb3112647d0$export$dd5ad0b65cf665da = ({ children: children, title: title, intl: intl, ignoreBaseTitle: ignoreBaseTitle })=>{
    let documentTitle = intl.formatMessage((0, $f4oxo.default).defaultTitle);
    if (ignoreBaseTitle && title) documentTitle = title;
    else if (title) documentTitle = intl.formatMessage((0, $f4oxo.default).baseTitle, {
        title: title
    });
    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($abgy5))), {
        title: documentTitle
    }, children);
};
var $1218feb3112647d0$export$2e2bcd8739ae039 = (0, $fK3tS.default)($1218feb3112647d0$export$dd5ad0b65cf665da);

});
parcelRegister("abgy5", function(module, exports) {
'use strict';

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $eEIRL = parcelRequire("eEIRL");
function $7697c4b973102896$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $7697c4b973102896$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $7697c4b973102896$var$DocumentTitle() {}
$7697c4b973102896$var$DocumentTitle.prototype = Object.create($bSJIT.Component.prototype);
$7697c4b973102896$var$DocumentTitle.displayName = 'DocumentTitle';
$7697c4b973102896$var$DocumentTitle.propTypes = {
    title: $4yQYd.string.isRequired
};
$7697c4b973102896$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $bSJIT.Children.only(this.props.children);
    else return null;
};
module.exports = $eEIRL($7697c4b973102896$var$reducePropsToState, $7697c4b973102896$var$handleStateChangeOnClient)($7697c4b973102896$var$DocumentTitle);

});
parcelRegister("eEIRL", function(module, exports) {
'use strict';
function $02c0e597214ad0d3$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $bSJIT = parcelRequire("bSJIT");
var $02c0e597214ad0d3$var$React__default = $02c0e597214ad0d3$var$_interopDefault($bSJIT);

var $02c0e597214ad0d3$var$shallowEqual = $02c0e597214ad0d3$var$_interopDefault((parcelRequire("fGF8L")));
function $02c0e597214ad0d3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $02c0e597214ad0d3$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $02c0e597214ad0d3$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $02c0e597214ad0d3$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $02c0e597214ad0d3$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$02c0e597214ad0d3$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $02c0e597214ad0d3$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($bSJIT.Component);
        $02c0e597214ad0d3$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $02c0e597214ad0d3$var$_defineProperty(SideEffect, "canUseDOM", $02c0e597214ad0d3$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $02c0e597214ad0d3$var$withSideEffect;

});
parcelRegister("fGF8L", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("f4oxo", function(module, exports) {
$parcel$export(module.exports, "default", () => $09b165ec0138ed47$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $09b165ec0138ed47$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    defaultTitle: {
        defaultMessage: 'Jira Service Management',
        description: 'Default document page title',
        id: 'cv.jsm.document.page.title.default'
    },
    baseTitle: {
        defaultMessage: '{title} - Jira Service Management',
        description: 'Base document page title appended to custom document titles.',
        id: 'cv.jsm.document.page.title.base'
    }
});

});


parcelRegister("4b8qO", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b94b6a60e723d26$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $1b94b6a60e723d26$var$SvgErrorreact = (props)=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 163.28 218",
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: "error_react_svg__linear-gradient",
        x1: 133.86,
        y1: 136.43,
        x2: -2.79,
        y2: 200.15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "error_react_svg__clip-path"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    })), /*#__PURE__*/ $bSJIT.createElement("style", null, ".error_react_svg__cls-1{fill:url(#error_react_svg__linear-gradient)}.error_react_svg__cls-2{fill:#253858}.error_react_svg__cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $bSJIT.createElement("g", {
        id: "error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        id: "error_react_svg__Software"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "error_react_svg__cls-2",
        d: "m87.22 163.71 2.88-44.35a9.18 9.18 0 0 0-9.16-9.78 9.18 9.18 0 0 0-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89 6.3 6.3 0 0 0 6.28-5.89ZM71.38 187.25a9.53 9.53 0 0 0 10.39 9.58 9.68 9.68 0 0 0-.9-19.32 9.64 9.64 0 0 0-9.49 9.74Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M91.7 27.17 84.29.45A.61.61 0 0 0 83.1.5l-4.66 25.1-5.8-1.08a.61.61 0 0 0-.7.76L79.35 52a.61.61 0 0 0 1.19 0l4.66-25.1 5.8 1.03a.61.61 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "m65.12 41.81-10.88-8.55a.27.27 0 0 0-.41.33L59.36 45l-2.66 1.31a.27.27 0 0 0 0 .45l10.87 8.55a.27.27 0 0 0 .41-.33l-5.57-11.43 2.66-1.29a.27.27 0 0 0 .05-.45Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M115.15 36.6c-1.17 1.59-11-5.6-12.16-4s8.66 8.79 7.5 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "error_react_svg__cls-6",
        d: "M119.92 64.19c-1.46 1.33-7.05-4.78-8.51-3.44s4.13 7.45 2.67 8.78-7.05-4.78-8.51-3.44c-.68.62.16 2.27 1.11 4M44.8 64c1.82.77 5-6.87 6.86-6.1s-1.39 8.4.43 9.17 5-6.87 6.86-6.1c.85.36.61 2.19.29 4.13"
    }))));
var $1b94b6a60e723d26$export$2e2bcd8739ae039 = $1b94b6a60e723d26$var$SvgErrorreact;

});

parcelRegister("cyWTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $94233d36760aa35f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $94233d36760aa35f$var$SvgLockreact = (props)=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 168.837 221.487",
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: "lock_react_svg__linear-gradient",
        x1: 49.42,
        y1: 59.767,
        x2: 122.662,
        y2: 59.767,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0,
        stopColor: "#0065ff"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0.219,
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 0.6,
        stopColor: "#2780ff"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: 1,
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ $bSJIT.createElement("style", null, ".lock_react_svg__cls-2{fill:#de350b}.lock_react_svg__cls-3{fill:#ff5630}")), /*#__PURE__*/ $bSJIT.createElement("g", {
        id: "lock_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        id: "lock_react_svg__Objects"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M122.662 119.535H49.42V36.62a36.621 36.621 0 0 1 73.242 0zm-61.242-12h49.242V36.62a24.621 24.621 0 0 0-49.242 0z",
        fill: "url(#lock_react_svg__linear-gradient)"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "lock_react_svg__cls-2",
        d: "M160.324 111.17a65.496 65.496 0 0 1-5.657-46.117l.002-.009a5.053 5.053 0 0 0-4.904-6.273H19.072a5.053 5.053 0 0 0-4.904 6.273l.002.006a66.149 66.149 0 0 1-5.785 46.367 75.49 75.49 0 0 0 65.21 110.047h17.866a75.491 75.491 0 0 0 68.863-110.294z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "m154.667 65.053.002-.009a5.053 5.053 0 0 0-4.904-6.273H36.94a5.053 5.053 0 0 0-4.904 6.273l.001.006a66.15 66.15 0 0 1-5.784 46.367 75.485 75.485 0 1 0 134.072-.247 65.496 65.496 0 0 1-5.657-46.117z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "lock_react_svg___Path_",
        "data-name": "<Path>",
        d: "M93.352 213.6q-.845 0-1.697-.02a67.603 67.603 0 0 1-58.396-98.539A74.376 74.376 0 0 0 40.47 66.66h105.762a73.488 73.488 0 0 0 7.098 48.16 67.6 67.6 0 0 1-59.975 98.78z",
        fill: "#ff7452"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "M90.007 176.885a16.308 16.308 0 0 1-16.115-18.82l2.23-14.32A24.148 24.148 0 0 1 92.21 102.69c.382-.017.766-.026 1.144-.026a24.15 24.15 0 0 1 17.229 41.08l2.23 14.32a16.31 16.31 0 0 1-16.114 18.82z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        id: "lock_react_svg___Path_2",
        "data-name": "<Path>",
        className: "lock_react_svg__cls-2",
        d: "M108.481 126.824a15.061 15.061 0 0 1-4.83 11.067 7.222 7.222 0 0 0-2.122 6.412l2.36 15.154a7.278 7.278 0 0 1-7.192 8.398h-6.69a7.278 7.278 0 0 1-7.192-8.398l2.388-15.332a7.232 7.232 0 0 0-2.269-6.345 15.064 15.064 0 0 1-4.69-11.753 15.13 15.13 0 0 1 30.237.797z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M82.815 159.457a7.256 7.256 0 1 0 14.333 0l-2.36-15.154a7.221 7.221 0 0 1 2.122-6.412 15.104 15.104 0 0 0-6.945-25.804 15.268 15.268 0 0 0-11.722 13.94 15.063 15.063 0 0 0 4.691 11.753 7.232 7.232 0 0 1 2.268 6.345z",
        fill: "#344563"
    }))));
var $94233d36760aa35f$export$2e2bcd8739ae039 = $94233d36760aa35f$var$SvgLockreact;

});

parcelRegister("cAJ8B", function(module, exports) {
$parcel$export(module.exports, "Paper", () => (parcelRequire("eqXqW")).default);
$parcel$export(module.exports, "PaperContent", () => (parcelRequire("aquFW")).PaperContent);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => (parcelRequire("aquFW")).SmallPaddingPaperContent);

var $eqXqW = parcelRequire("eqXqW");

var $aquFW = parcelRequire("aquFW");

});
parcelRegister("eqXqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $de7d2d7adf04493f$export$2e2bcd8739ae039);
/* paper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("6rN3y");
var $dYTFV = parcelRequire("dYTFV");
parcelRequire("1rVud");
var $3aqSY = parcelRequire("3aqSY");

var $aquFW = parcelRequire("aquFW");
const $de7d2d7adf04493f$var$SkipToMainContent = ({ children: children })=>/*#__PURE__*/ $bSJIT.createElement((0, $3aqSY.MainContentSkipLinkWrapper), null, /*#__PURE__*/ $bSJIT.createElement($de7d2d7adf04493f$var$MainContentSkipLink, null, children));
// We want to delay fade in until after the paper transition is complete
const $de7d2d7adf04493f$var$FadeContent = (0, $dYTFV.default)({
    fadeInTime: (0, $aquFW.paperTransitionTime),
    delay: (0, $aquFW.paperTransitionTime)
})((0, $aquFW.Content));
class $de7d2d7adf04493f$var$Paper extends $bSJIT.Component {
    render() {
        const { children: children, pageKey: pageKey, isCSM: isCSM } = this.props;
        const hide = this.props.appearance === 'none';
        const appearance = this.props.appearance || 'normal';
        if (appearance === 'note') return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.PaperBackground), {
            appearance: "none",
            hide: true
        }), /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.NoteContent), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.NoteBackground), null, children), /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.StyledFooter), null)));
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.PaperBackground), {
            appearance: appearance,
            hide: hide
        }), /*#__PURE__*/ $bSJIT.createElement($de7d2d7adf04493f$var$FadeContent, {
            appearance: appearance,
            hide: hide,
            key: pageKey
        }, /*#__PURE__*/ $bSJIT.createElement($de7d2d7adf04493f$var$SkipToMainContent, null, children, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.StyledFooter), {
            isCSM: isCSM
        }))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $de7d2d7adf04493f$var$MainContentSkipLink = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx21bp4 _1tke1osq",
            __cmplp.className
        ])
    });
});
var $de7d2d7adf04493f$export$2e2bcd8739ae039 = $de7d2d7adf04493f$var$Paper;

});
parcelRegister("6rN3y", function(module, exports) {
$parcel$export(module.exports, "withFadeIn", () => (parcelRequire("dYTFV")).default);

var $dYTFV = parcelRequire("dYTFV");

});
parcelRegister("dYTFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $83332b78f612bafe$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9Yqiu = parcelRequire("9Yqiu");

var $6CMLs = parcelRequire("6CMLs");
parcelRequire("jKUwF");
var $hGKjg = parcelRequire("hGKjg");

var $iW3CQ = parcelRequire("iW3CQ");
const $83332b78f612bafe$var$withFadeIn = (options)=>(WrappedComponent)=>{
        const defaultOptions = {
            fadeInTime: $9Yqiu.speedMs.slow,
            delay: 0
        };
        const mergedOptions = {
            ...defaultOptions,
            ...options
        };
        // eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        const ComponentWithFadeIn = /*#__PURE__*/ (0, $4v2A7.default)(WrappedComponent).withConfig({
            componentId: "sc-1uyl3wn-0"
        })`${$9Yqiu.fadeInOut(mergedOptions.fadeInTime, mergedOptions.delay)};`;
        const ReturnComponent = (props)=>{
            const shouldSkipTransition = $bSJIT.useMemo(()=>!(0, $hGKjg.isAppMounted).value, []);
            /**
     * In server side rendering -  component should appear
     * on First time load from SSR - component should appear
     * on next time onwards - component should transition
     * on client only - component should transition
     */ const shouldTransitOnMount = ()=>{
                // Invalid report.
                // eslint-disable-next-line testing-library/render-result-naming-convention
                const isPageServerSideRendered = (0, $iW3CQ.getIsPageServerSideRendered)();
                if (isPageServerSideRendered && shouldSkipTransition) return false;
                return true;
            };
            return /*#__PURE__*/ $bSJIT.createElement((0, $6CMLs.default), {
                in: true,
                timeout: 0,
                mountOnEnter: true,
                appear: shouldTransitOnMount()
            }, (state)=>// Spreading props blows type checking up for some reason. Why??
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                /*#__PURE__*/ $bSJIT.createElement(ComponentWithFadeIn, {
                    ...props,
                    state: state
                }));
        };
        return ReturnComponent;
    };
var $83332b78f612bafe$export$2e2bcd8739ae039 = $83332b78f612bafe$var$withFadeIn;

});
parcelRegister("6CMLs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d2c1e4d0c734ca1$export$2e2bcd8739ae039, (v) => $4d2c1e4d0c734ca1$export$2e2bcd8739ae039 = v);
var $4d2c1e4d0c734ca1$export$1e511d4a378977f5;
var $4d2c1e4d0c734ca1$export$2e2bcd8739ae039;
var $4d2c1e4d0c734ca1$export$4aacc83d4d59139f;
var $4d2c1e4d0c734ca1$export$78e9e6e3e014d60a;
var $4d2c1e4d0c734ca1$export$df38205c966be359;
var $4d2c1e4d0c734ca1$export$84cbff306f539230;
var $4d2c1e4d0c734ca1$export$bb38bb9a1161268;
"use strict";
$4d2c1e4d0c734ca1$export$1e511d4a378977f5 = true;
$4d2c1e4d0c734ca1$export$2e2bcd8739ae039 = $4d2c1e4d0c734ca1$export$4aacc83d4d59139f = $4d2c1e4d0c734ca1$export$78e9e6e3e014d60a = $4d2c1e4d0c734ca1$export$df38205c966be359 = $4d2c1e4d0c734ca1$export$84cbff306f539230 = $4d2c1e4d0c734ca1$export$bb38bb9a1161268 = void 0;

var $4d2c1e4d0c734ca1$var$PropTypes = $4d2c1e4d0c734ca1$var$_interopRequireWildcard((parcelRequire("4yQYd")));

var $4d2c1e4d0c734ca1$var$_react = $4d2c1e4d0c734ca1$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4d2c1e4d0c734ca1$var$_reactDom = $4d2c1e4d0c734ca1$var$_interopRequireDefault((parcelRequire("4Sf72")));

var $hudco = parcelRequire("hudco");

function $4d2c1e4d0c734ca1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d2c1e4d0c734ca1$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $4d2c1e4d0c734ca1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4d2c1e4d0c734ca1$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4d2c1e4d0c734ca1$var$UNMOUNTED = 'unmounted';
$4d2c1e4d0c734ca1$export$bb38bb9a1161268 = $4d2c1e4d0c734ca1$var$UNMOUNTED;
var $4d2c1e4d0c734ca1$var$EXITED = 'exited';
$4d2c1e4d0c734ca1$export$84cbff306f539230 = $4d2c1e4d0c734ca1$var$EXITED;
var $4d2c1e4d0c734ca1$var$ENTERING = 'entering';
$4d2c1e4d0c734ca1$export$df38205c966be359 = $4d2c1e4d0c734ca1$var$ENTERING;
var $4d2c1e4d0c734ca1$var$ENTERED = 'entered';
$4d2c1e4d0c734ca1$export$78e9e6e3e014d60a = $4d2c1e4d0c734ca1$var$ENTERED;
var $4d2c1e4d0c734ca1$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $4d2c1e4d0c734ca1$export$4aacc83d4d59139f = $4d2c1e4d0c734ca1$var$EXITING;
var $4d2c1e4d0c734ca1$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $4d2c1e4d0c734ca1$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $4d2c1e4d0c734ca1$var$EXITED;
                _this.appearStatus = $4d2c1e4d0c734ca1$var$ENTERING;
            } else initialStatus = $4d2c1e4d0c734ca1$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $4d2c1e4d0c734ca1$var$UNMOUNTED;
        else initialStatus = $4d2c1e4d0c734ca1$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $4d2c1e4d0c734ca1$var$UNMOUNTED) return {
            status: $4d2c1e4d0c734ca1$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $4d2c1e4d0c734ca1$var$ENTERING && status !== $4d2c1e4d0c734ca1$var$ENTERED) nextStatus = $4d2c1e4d0c734ca1$var$ENTERING;
            } else if (status === $4d2c1e4d0c734ca1$var$ENTERING || status === $4d2c1e4d0c734ca1$var$ENTERED) nextStatus = $4d2c1e4d0c734ca1$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $4d2c1e4d0c734ca1$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $4d2c1e4d0c734ca1$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $4d2c1e4d0c734ca1$var$EXITED) this.setState({
            status: $4d2c1e4d0c734ca1$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $4d2c1e4d0c734ca1$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $4d2c1e4d0c734ca1$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $4d2c1e4d0c734ca1$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $4d2c1e4d0c734ca1$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $4d2c1e4d0c734ca1$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $4d2c1e4d0c734ca1$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $4d2c1e4d0c734ca1$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $4d2c1e4d0c734ca1$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $4d2c1e4d0c734ca1$var$_react.default.Children.only(children);
        return $4d2c1e4d0c734ca1$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($4d2c1e4d0c734ca1$var$_react.default.Component);
$4d2c1e4d0c734ca1$var$Transition.contextTypes = {
    transitionGroup: $4d2c1e4d0c734ca1$var$PropTypes.object
};
$4d2c1e4d0c734ca1$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$4d2c1e4d0c734ca1$var$Transition.propTypes = {};
function $4d2c1e4d0c734ca1$var$noop() {}
$4d2c1e4d0c734ca1$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $4d2c1e4d0c734ca1$var$noop,
    onEntering: $4d2c1e4d0c734ca1$var$noop,
    onEntered: $4d2c1e4d0c734ca1$var$noop,
    onExit: $4d2c1e4d0c734ca1$var$noop,
    onExiting: $4d2c1e4d0c734ca1$var$noop,
    onExited: $4d2c1e4d0c734ca1$var$noop
};
$4d2c1e4d0c734ca1$var$Transition.UNMOUNTED = 0;
$4d2c1e4d0c734ca1$var$Transition.EXITED = 1;
$4d2c1e4d0c734ca1$var$Transition.ENTERING = 2;
$4d2c1e4d0c734ca1$var$Transition.ENTERED = 3;
$4d2c1e4d0c734ca1$var$Transition.EXITING = 4;
var $4d2c1e4d0c734ca1$var$_default = (0, $hudco.polyfill)($4d2c1e4d0c734ca1$var$Transition);
$4d2c1e4d0c734ca1$export$2e2bcd8739ae039 = $4d2c1e4d0c734ca1$var$_default;

});
parcelRegister("hudco", function(module, exports) {
$parcel$export(module.exports, "polyfill", () => $cbaf7a03a52c0dc5$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $cbaf7a03a52c0dc5$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $cbaf7a03a52c0dc5$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $cbaf7a03a52c0dc5$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$cbaf7a03a52c0dc5$var$componentWillMount.__suppressDeprecationWarning = true;
$cbaf7a03a52c0dc5$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$cbaf7a03a52c0dc5$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $cbaf7a03a52c0dc5$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $cbaf7a03a52c0dc5$var$componentWillMount;
        prototype.componentWillReceiveProps = $cbaf7a03a52c0dc5$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $cbaf7a03a52c0dc5$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});




parcelRegister("1rVud", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => (parcelRequire("3aqSY")).MainContentSkipLinkWrapper);

var $3aqSY = parcelRequire("3aqSY");

});
parcelRegister("3aqSY", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => $9d6e2c909a04475d$export$505b93f76cb5cb5c);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cOZaA = parcelRequire("cOZaA");

var $l3FLZ = parcelRequire("l3FLZ");
const $9d6e2c909a04475d$export$505b93f76cb5cb5c = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cOZaA.default), {
        id: "main",
        skipLinkTitle: formatMessage((0, $l3FLZ.default).skipToMainA11yLabel),
        testId: "main"
    }, children);
};

});
parcelRegister("cOZaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $df93504f311a54db$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fg2GS = parcelRequire("fg2GS");

var $a05li = parcelRequire("a05li");

var $1qxfZ = parcelRequire("1qxfZ");

var $drY8a = parcelRequire("drY8a");

var $9fOvV = parcelRequire("9fOvV");

var $dLRz7 = parcelRequire("dLRz7");
var $gG3J7 = parcelRequire("gG3J7");

var $jIwmJ = parcelRequire("jIwmJ");
function $df93504f311a54db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $df93504f311a54db$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $9dQre.css)((0, $a05li.prefersReducedMotion)());
const $df93504f311a54db$var$mainStyles = /*#__PURE__*/ (0, $9dQre.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s`
});
const $df93504f311a54db$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $df93504f311a54db$var$flyoutStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $1qxfZ.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $1qxfZ.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $1qxfZ.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $df93504f311a54db$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $gG3J7.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $9fOvV.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $bSJIT.useContext)((0, $dLRz7.SidebarResizeContext));
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jIwmJ.default), null, ({ className: className })=>/*#__PURE__*/ (0, $9dQre.jsx)("main", {
            "data-testid": testId,
            css: [
                $df93504f311a54db$var$mainStyles,
                isDragging && $df93504f311a54db$var$draggingStyles,
                isFlyoutOpen && !isFixed && $df93504f311a54db$var$flyoutStyles,
                $df93504f311a54db$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $drY8a.getPageLayoutSlotSelector)('main')
        }, children));
};
var $df93504f311a54db$export$2e2bcd8739ae039 = $df93504f311a54db$var$Main;

});
parcelRegister("a05li", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $222a04e56e732675$export$ff7706047246b98b);

var $2Afxg = parcelRequire("2Afxg");
const $222a04e56e732675$export$ff7706047246b98b = ()=>(0, $2Afxg.reduceMotionAsPerUserPreference);

});
parcelRegister("2Afxg", function(module, exports) {
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $127abf6e4bc35181$export$f0f789643ba5a83c);
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $127abf6e4bc35181$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

});


parcelRegister("1qxfZ", function(module, exports) {
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $6873af67d0e07d77$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $6873af67d0e07d77$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $6873af67d0e07d77$export$b6744d31294864fd);
$parcel$export(module.exports, "LEFT_PANEL", () => $6873af67d0e07d77$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $6873af67d0e07d77$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $6873af67d0e07d77$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $6873af67d0e07d77$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $6873af67d0e07d77$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $6873af67d0e07d77$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $6873af67d0e07d77$export$539e68c09584883a);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $6873af67d0e07d77$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $6873af67d0e07d77$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $6873af67d0e07d77$export$991d5285ad765a3d);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $6873af67d0e07d77$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $6873af67d0e07d77$export$3749e1104328fde4);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $6873af67d0e07d77$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $6873af67d0e07d77$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $6873af67d0e07d77$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $6873af67d0e07d77$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $6873af67d0e07d77$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $6873af67d0e07d77$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $6873af67d0e07d77$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $6873af67d0e07d77$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $6873af67d0e07d77$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $6873af67d0e07d77$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $6873af67d0e07d77$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $6873af67d0e07d77$export$d2fa14f05b61e66);
// dimension vars
const $6873af67d0e07d77$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $6873af67d0e07d77$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $6873af67d0e07d77$export$c103b605cd368aed = 'rightSidebarWidth';
const $6873af67d0e07d77$export$fa34f417972d6341 = 'rightPanelWidth';
const $6873af67d0e07d77$export$3a6a779d9181047c = 'topNavigationHeight';
const $6873af67d0e07d77$export$bcd94a6a792e7f96 = 'bannerHeight';
const $6873af67d0e07d77$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $6873af67d0e07d77$export$344062f7cfc9528e = 'left-panel';
const $6873af67d0e07d77$export$c7139cc2d6110b5f = 'right-panel';
const $6873af67d0e07d77$export$238d30785c4bca84 = 'banner';
const $6873af67d0e07d77$export$bec6dca2e63de4ae = 'top-navigation';
const $6873af67d0e07d77$export$d1213e82613ff4df = 'content';
const $6873af67d0e07d77$export$be83e7118304b28e = 56;
const $6873af67d0e07d77$export$4a98ee0bd1ae362 = 56;
const $6873af67d0e07d77$export$539e68c09584883a = 240;
const $6873af67d0e07d77$export$b92df8810d2fcd01 = 280;
const $6873af67d0e07d77$export$c3e41153b9288bcf = 368;
const $6873af67d0e07d77$export$c4d6152f86ea28f6 = 368;
const $6873af67d0e07d77$export$46acf8758e9e2636 = 20;
const $6873af67d0e07d77$export$70740f5ad8360a78 = 16;
const $6873af67d0e07d77$export$991d5285ad765a3d = 240;
const $6873af67d0e07d77$export$6949d4f32b161684 = 200;
const $6873af67d0e07d77$export$d6e7e8af042815bb = 350;
const $6873af67d0e07d77$export$3749e1104328fde4 = 300;
const $6873af67d0e07d77$export$1074d925b0b82be5 = 200;
const $6873af67d0e07d77$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $6873af67d0e07d77$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $6873af67d0e07d77$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $6873af67d0e07d77$export$70c702a8c5895f03 = 'data-grab-area-line';
const $6873af67d0e07d77$export$48a43f91e4becf4e = 'data-grab-area';
const $6873af67d0e07d77$export$dac2fb31a9f6844d = 'data-resize-button';
const $6873af67d0e07d77$export$9ecd22db14e6c70e = 'data-resize-control';
const $6873af67d0e07d77$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $6873af67d0e07d77$export$206a08f7f8beb554 = 'Skip to:';
const $6873af67d0e07d77$export$659ee746b31b360d = 'data-layout-container';
const $6873af67d0e07d77$export$f963aecf2d4465bd = `var(--${$6873af67d0e07d77$export$cbfb0f5b2869b17b}, 0px)`;
const $6873af67d0e07d77$export$750459958906793 = `var(--${$6873af67d0e07d77$export$fa34f417972d6341}, 0px)`;
const $6873af67d0e07d77$export$f897e1ed9f8ed251 = `var(--${$6873af67d0e07d77$export$a30f2e00489a8957}, 0px)`;
const $6873af67d0e07d77$export$b44ab66843c05a69 = `var(--${$6873af67d0e07d77$export$c103b605cd368aed}, 0px)`;
const $6873af67d0e07d77$export$aeff86a16f13529 = `var(--${$6873af67d0e07d77$export$3a6a779d9181047c}, 0px)`;
const $6873af67d0e07d77$export$ed7cc0d417ee89e = `var(--${$6873af67d0e07d77$export$bcd94a6a792e7f96}, 0px)`;
const $6873af67d0e07d77$export$d2fa14f05b61e66 = `var(--${$6873af67d0e07d77$export$b6744d31294864fd}, ${$6873af67d0e07d77$export$991d5285ad765a3d}px)`;

});

parcelRegister("drY8a", function(module, exports) {
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $2121d2d5147fd078$export$e895e3e8b708ae2a);

var $1qxfZ = parcelRequire("1qxfZ");
const $2121d2d5147fd078$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $1qxfZ.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });

});

parcelRegister("9fOvV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f66fe34e90a8ebbc$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1qxfZ = parcelRequire("1qxfZ");
const $f66fe34e90a8ebbc$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $1qxfZ.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $f66fe34e90a8ebbc$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $bSJIT.useState)($f66fe34e90a8ebbc$var$getIsDragging);
    (0, $bSJIT.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($f66fe34e90a8ebbc$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $1qxfZ.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $f66fe34e90a8ebbc$export$2e2bcd8739ae039 = $f66fe34e90a8ebbc$var$useIsSidebarDragging;

});

parcelRegister("dLRz7", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeContext", () => $7a80e7e6769f1543$export$aa5a712eea4c2ae8);

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");
const $7a80e7e6769f1543$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $7a80e7e6769f1543$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $1OdZP.default),
    collapseLeftSidebar: (0, $1OdZP.default),
    leftSidebarState: $7a80e7e6769f1543$var$leftSidebarState,
    setLeftSidebarState: (0, $1OdZP.default),
    toggleLeftSidebar: (0, $1OdZP.default)
});

});

parcelRegister("gG3J7", function(module, exports) {
$parcel$export(module.exports, "useSkipLink", () => $a30013def6e16449$export$89d9323301efc7d6);

var $bSJIT = parcelRequire("bSJIT");

var $khQPO = parcelRequire("khQPO");
const $a30013def6e16449$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $khQPO.useSkipLinks)();
    (0, $bSJIT.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("khQPO", function(module, exports) {
$parcel$export(module.exports, "useSkipLinks", () => $fdd719ee76bf35a1$export$c9d9cb2ee9590f87);

var $bSJIT = parcelRequire("bSJIT");

var $beCkl = parcelRequire("beCkl");
const $fdd719ee76bf35a1$export$c9d9cb2ee9590f87 = ()=>(0, $bSJIT.useContext)((0, $beCkl.SkipLinksContext));

});
parcelRegister("beCkl", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $6e8f0af0e077bf6b$export$4c5cc3b14c7678a);

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");
const $6e8f0af0e077bf6b$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $bSJIT.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $1OdZP.default),
    unregisterSkipLink: (0, $1OdZP.default)
});

});



parcelRegister("jIwmJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $08d1f0cc2b59d392$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");
const $08d1f0cc2b59d392$var$focusStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $08d1f0cc2b59d392$var$sidebarFocusStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $08d1f0cc2b59d392$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $9dQre.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($08d1f0cc2b59d392$var$sidebarFocusStyles) : css($08d1f0cc2b59d392$var$focusStyles)
        }));
};
var $08d1f0cc2b59d392$export$2e2bcd8739ae039 = $08d1f0cc2b59d392$var$SlotFocusRing;

});


parcelRegister("l3FLZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c4484581e79d415$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $7c4484581e79d415$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    skipToMainA11yLabel: {
        defaultMessage: 'Skip to Main Content',
        description: 'A11y Label for Skip to Main Content',
        id: 'sd.view.common.skip.links.main-content-skip-link.a11y-label'
    }
});

});



parcelRegister("aquFW", function(module, exports) {
$parcel$export(module.exports, "paperTransitionTime", () => $7ce0dda9de0bad56$export$c04d9b45b952bb2f);
$parcel$export(module.exports, "Content", () => $7ce0dda9de0bad56$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "NoteContent", () => $7ce0dda9de0bad56$export$fe2e0d4376bdc305);
$parcel$export(module.exports, "NoteBackground", () => $7ce0dda9de0bad56$export$8eb56b799bce002f);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => $7ce0dda9de0bad56$export$80c4326e65e7230d);
$parcel$export(module.exports, "PaperContent", () => $7ce0dda9de0bad56$export$bf9cd54d94ffe52b);
$parcel$export(module.exports, "PaperBackground", () => $7ce0dda9de0bad56$export$69bd0e70980f4e9f);
$parcel$export(module.exports, "StyledFooter", () => $7ce0dda9de0bad56$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $ki6Qt = parcelRequire("ki6Qt");

var $7QbH4 = parcelRequire("7QbH4");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $9Yqiu = parcelRequire("9Yqiu");

var $kU5HH = parcelRequire("kU5HH");

var $1DDTY = parcelRequire("1DDTY");

var $kKHso = parcelRequire("kKHso");
// This is the width of the paper without any scaling
// It's fixed at 1000px for easy calculation.
const $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS = $9K7mZ.multiple(125);
// 800px is normal width
const $7ce0dda9de0bad56$var$PAPER_NORMAL_WIDTH = $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.multiple(0.8).unitless;
// 1000px is wide width
const $7ce0dda9de0bad56$var$PAPER_WIDE_WIDTH = $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.multiple(1).unitless;
// 1100px is extra wide width
const $7ce0dda9de0bad56$var$PAPER_XWIDE_WIDTH = $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.multiple(1.1).unitless;
// 1200px is extra wide width
const $7ce0dda9de0bad56$var$PAPER_XXWIDE_WIDTH = $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.multiple(1.2).unitless;
const $7ce0dda9de0bad56$var$PAPER_NOTE_WIDTH = $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.multiple(0.48).unitless;
const $7ce0dda9de0bad56$var$PAPER_PADDING_TOP = "var(--ds-space-300, 24px)";
const $7ce0dda9de0bad56$var$PAPER_PADDING_RIGHT_MOBILE = "var(--ds-space-400, 32px)";
const $7ce0dda9de0bad56$var$PAPER_PADDING_LEFT_MOBILE = "var(--ds-space-400, 32px)";
const $7ce0dda9de0bad56$var$PAPER_PADDING_RIGHT_DESKTOP = $9K7mZ.multiple(13.5).unitless;
const $7ce0dda9de0bad56$var$PAPER_PADDING_LEFT_DESKTOP = $9K7mZ.multiple(11).unitless;
const $7ce0dda9de0bad56$var$PAPER_PADDING_SMALL = "var(--ds-space-600, 48px)";
const $7ce0dda9de0bad56$var$PAPER_NOTE_HEIGHT = $9K7mZ.multiple(52).unitless;
const $7ce0dda9de0bad56$var$PAPER_NOTE_MARGIN_TOP = $9K7mZ.multiple(20).unitless - (0, $1DDTY.HEADER_HEIGHT);
const $7ce0dda9de0bad56$export$c04d9b45b952bb2f = $9Yqiu.speedMs.slow;
const $7ce0dda9de0bad56$var$getContentWidth = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $7ce0dda9de0bad56$var$PAPER_XXWIDE_WIDTH;
        case 'xwide':
            return $7ce0dda9de0bad56$var$PAPER_XWIDE_WIDTH;
        case 'wide':
            return $7ce0dda9de0bad56$var$PAPER_WIDE_WIDTH;
        case 'note':
            return $7ce0dda9de0bad56$var$PAPER_NOTE_WIDTH;
        default:
            return $7ce0dda9de0bad56$var$PAPER_NORMAL_WIDTH;
    }
};
const $7ce0dda9de0bad56$var$getScale = (appearance)=>$7ce0dda9de0bad56$var$getContentWidth(appearance) / $7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.unitless;
const $7ce0dda9de0bad56$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $4v2A7.default).main.withConfig({
    componentId: "sc-1jc43ym-0"
})`box-sizing:border-box;display:flex;flex-direction:column;flex:1 1 auto;margin:${"var(--ds-space-0, 0px)"} auto;width:100%;max-width:${(props)=>props.hide ? '100%' : `${$7ce0dda9de0bad56$var$getContentWidth(props.appearance)}px`};min-height:100%;${$ki6Qt.fromCustom($7ce0dda9de0bad56$var$PAPER_NOTE_WIDTH).css`
        min-height: ${(props)=>props.appearance === 'note' ? `${$7ce0dda9de0bad56$var$PAPER_NOTE_HEIGHT}px` : '100%'};
        margin-top: ${(props)=>props.appearance === 'note' ? `${$7ce0dda9de0bad56$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $7ce0dda9de0bad56$export$fe2e0d4376bdc305 = /*#__PURE__*/ (0, $4v2A7.default)($7ce0dda9de0bad56$export$7c6e2c02157bb7d2).attrs({
    appearance: 'note'
}).withConfig({
    componentId: "sc-1jc43ym-1"
})`align-self:flex-start;max-width:${(props)=>props.hide ? '100%' : `${$7ce0dda9de0bad56$var$getContentWidth(props.appearance)}px`};`;
const $7ce0dda9de0bad56$export$8eb56b799bce002f = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1jc43ym-2"
})`${$7QbH4.e100};border-radius:${"var(--ds-radius-large, 8px)"};background-color:${"var(--ds-surface, #FFFFFF)"};min-height:inherit;`;
const $7ce0dda9de0bad56$export$80c4326e65e7230d = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1jc43ym-3"
})`display:flex;flex-direction:column;flex:1 1 auto;padding-top:${$7ce0dda9de0bad56$var$PAPER_PADDING_TOP};padding-left:${$7ce0dda9de0bad56$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$7ce0dda9de0bad56$var$PAPER_PADDING_RIGHT_MOBILE};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};${$ki6Qt.fromCustom($7ce0dda9de0bad56$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$7ce0dda9de0bad56$var$PAPER_PADDING_SMALL};
        padding-right: ${$7ce0dda9de0bad56$var$PAPER_PADDING_SMALL};
    `};`;
const $7ce0dda9de0bad56$export$49f7b90a0c83f2b0 = /*#__PURE__*/ (0, $4v2A7.css)`padding-top:${$7ce0dda9de0bad56$var$PAPER_PADDING_TOP};padding-left:${$7ce0dda9de0bad56$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$7ce0dda9de0bad56$var$PAPER_PADDING_RIGHT_MOBILE};${$ki6Qt.fromCustom($7ce0dda9de0bad56$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$7ce0dda9de0bad56$var$PAPER_PADDING_LEFT_DESKTOP}px;
        padding-right: ${$7ce0dda9de0bad56$var$PAPER_PADDING_RIGHT_DESKTOP}px;
    `};`;
const $7ce0dda9de0bad56$export$bf9cd54d94ffe52b = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1jc43ym-4"
})`display:flex;flex-direction:column;flex:1 1 auto;${$7ce0dda9de0bad56$export$49f7b90a0c83f2b0};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};`;
const $7ce0dda9de0bad56$export$69bd0e70980f4e9f = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1jc43ym-5"
})`position:absolute;width:${$7ce0dda9de0bad56$var$PAPER_WIDTH_BASIS.px};height:inherit;right:0;bottom:0;top:0;left:50%;${$fU62V.borderRadius};border-bottom-left-radius:0;border-bottom-right-radius:0;background-color:${"var(--ds-surface, #FFFFFF)"};box-shadow:${`var(--ds-shadow-overlay, ${`0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} -${$9K7mZ.multiple(0.5).px} ${'rgba(9, 30, 66, 0.25)'}, 0 0 1px ${'rgba(9, 30, 66, 0.31)'}`})`};z-index:${$kU5HH.pageInBannerLayout};transition:transform ${$9Yqiu.timingFunctions.easeInOutQuad} ${$7ce0dda9de0bad56$export$c04d9b45b952bb2f}ms;transform:${(props)=>`translate3d(-50%, ${props.hide ? '100%' : '0'}, 0) scale3d(${$7ce0dda9de0bad56$var$getScale(props.appearance)}, 1, 1)`};${$ki6Qt.fromCustom($7ce0dda9de0bad56$var$PAPER_NOTE_WIDTH).css`
        height: ${(props)=>props.appearance === 'note' ? `${$7ce0dda9de0bad56$var$PAPER_NOTE_HEIGHT}px` : 'inherit'};
        top: ${(props)=>props.appearance === 'note' ? `${$7ce0dda9de0bad56$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $7ce0dda9de0bad56$export$61905ae62c7860fb = /*#__PURE__*/ (0, $4v2A7.default)((0, $kKHso.Footer)).withConfig({
    componentId: "sc-1jc43ym-6"
})`left:0;right:0;height:${$9K7mZ.multiple(6).px};padding:${"var(--ds-space-600, 48px)"} 0 ${"var(--ds-space-100, 8px)"} 0;display:flex;align-items:center;justify-content:center;`;

});



parcelRegister("3gKay", function(module, exports) {
$parcel$export(module.exports, "ErrorLink", () => $4d4fb490a04c532e$export$d2c8415987899609);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $53Khx = parcelRequire("53Khx");

var $c6H7d = parcelRequire("c6H7d");

var $eDcdn = parcelRequire("eDcdn");

var $fZKGh = parcelRequire("fZKGh");
const $4d4fb490a04c532e$export$d2c8415987899609 = ({ callToActionUrl: callToActionUrl, children: children })=>{
    if (callToActionUrl.includes((0, $fZKGh.LOGIN_ROUTE))) return /*#__PURE__*/ $bSJIT.createElement($4d4fb490a04c532e$export$f13d6b6525b315e0, {
        actionSubjectId: "redirectToLogin",
        href: (0, $eDcdn.getRelativeBasePath)() + callToActionUrl
    }, children);
    return /*#__PURE__*/ $bSJIT.createElement($4d4fb490a04c532e$export$a6c7ac8248d6e38a, {
        actionSubjectId: "callToAction",
        to: callToActionUrl
    }, children);
};
$4d4fb490a04c532e$export$d2c8415987899609.displayName = 'ErrorLink';
const $4d4fb490a04c532e$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $4v2A7.default)((0, $c6H7d.default)).withConfig({
    componentId: "sc-1mmbyta-0"
})`text-align:center;`;
const $4d4fb490a04c532e$export$f13d6b6525b315e0 = /*#__PURE__*/ (0, $4v2A7.default)((0, $53Khx.HtmlAnchor)).withConfig({
    componentId: "sc-1mmbyta-1"
})`text-align:center;`;

});
parcelRegister("c6H7d", function(module, exports) {
$parcel$export(module.exports, "default", () => $e90307162dd1b9ee$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");
const $e90307162dd1b9ee$export$1d567c320f4763bc = /*#__PURE__*/ (0, $4v2A7.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};${(props)=>props.hasUnderline && 'text-decoration: underline;'} &:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e90307162dd1b9ee$var$ThemedLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-1tr99za-0"
})`${$e90307162dd1b9ee$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$e90307162dd1b9ee$export$2e2bcd8739ae039 = $e90307162dd1b9ee$var$ThemedLink;

});
parcelRegister("2OuWT", function(module, exports) {
$parcel$export(module.exports, "Link", () => $c1565d221e393366$export$a6c7ac8248d6e38a);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");

var $hWsdJ = parcelRequire("hWsdJ");

var $4awI5 = parcelRequire("4awI5");
const $c1565d221e393366$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...props })=>{
    const { to: to, target: target, ...rest } = props;
    if (typeof to === 'string') return /*#__PURE__*/ $bSJIT.createElement((0, $4awI5.default), {
        to: to,
        target: target,
        ...rest
    });
    return /*#__PURE__*/ $bSJIT.createElement((0, $3rmIb.default), props);
};
const $c1565d221e393366$export$a6c7ac8248d6e38a = (0, $hWsdJ.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($c1565d221e393366$var$InstrumentedLink);

});
parcelRegister("4awI5", function(module, exports) {
$parcel$export(module.exports, "default", () => $734d5587bbf3c8d7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $kHwwG = parcelRequire("kHwwG");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");
var $a6Y7T = parcelRequire("a6Y7T");

const $734d5587bbf3c8d7$export$d3010bc2e9cc1386 = (to, currentLocation)=>{
    // @ts-ignore the location provided by RRR is compatible with history location
    return (0, $kHwwG.createLocation)(to, null, undefined, currentLocation);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $734d5587bbf3c8d7$var$isModifiedEvent = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
/**
 * In server side rendering we use memory history, which doesn't have the base name. hence append basename manually
 */ function $734d5587bbf3c8d7$var$getHref(history, location) {
    return history.createHref(location);
}
/**
 * React resource router doesn't support baseUrl if the "to" property is a string.
 * We have to introduce this wrapper to workaround it otherwise the migration's surface area become too large.
 * Moving forward we should use "route" instead of string for the link component since it is better supported.
 *
 *  @deprecated this component shouldn't be used directly.
 */ const $734d5587bbf3c8d7$var$BaseUrlRespectLink = (props)=>{
    const { to: to, onClick: onClick, history: history, location: location, ...rest } = props;
    const toAsLocation = $734d5587bbf3c8d7$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $734d5587bbf3c8d7$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $bSJIT.useCallback)((e)=>{
        try {
            onClick && onClick(e);
        } catch (ex) {
            e.preventDefault();
            throw ex;
        }
        if (!e.defaultPrevented && (// onClick prevented default
        e.button === 0 || e.keyCode === 13) && // ignore everything but left clicks or enter
        (!props.target || props.target === '_self') && // let browser handle "target=_blank" etc.
        !$734d5587bbf3c8d7$var$isModifiedEvent(e) // ignore clicks with modifier keys
        ) {
            e.preventDefault();
            const method = props.replace ? history.replace : history.push;
            method(toAsLocation);
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    return /*#__PURE__*/ $bSJIT.createElement((0, $3rmIb.default), {
        href: href,
        ...rest,
        onClick: wrappedOnClick
    });
};
const $734d5587bbf3c8d7$var$BaseUrlRespectLinkWithRouter = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $a6Y7T.RouterSubscriber), null, ({ location: location, history: // @ts-ignore access private `history` store property
    history })=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        /*#__PURE__*/ $bSJIT.createElement($734d5587bbf3c8d7$var$BaseUrlRespectLink, {
            location: location,
            history: history,
            ...props
        }));
};
var $734d5587bbf3c8d7$export$2e2bcd8739ae039 = $734d5587bbf3c8d7$var$BaseUrlRespectLinkWithRouter;

});



parcelRegister("fZKGh", function(module, exports) {
$parcel$export(module.exports, "PORTAL_ROUTE_PREFIX", () => $5f6a31028d3c42a7$export$2b06f7190715126f);
$parcel$export(module.exports, "LOGIN_ROUTE", () => $5f6a31028d3c42a7$export$9f22ab6dfd3d5ec5);
$parcel$export(module.exports, "PROJECT_NAME", () => $5f6a31028d3c42a7$export$cb77c55dd12a845e);
$parcel$export(module.exports, "anonymousScreenLayout", () => $5f6a31028d3c42a7$export$205bfffc91265169);
const $5f6a31028d3c42a7$export$2b06f7190715126f = '/portal/:portalId(\\d+)';
const $5f6a31028d3c42a7$export$9f22ab6dfd3d5ec5 = '/user/login';
const $5f6a31028d3c42a7$export$cb77c55dd12a845e = 'jira-servicedesk.ondemand';
const $5f6a31028d3c42a7$export$205bfffc91265169 = Object.freeze({
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});

});


parcelRegister("2p5Fp", function(module, exports) {
$parcel$export(module.exports, "default", () => $25031e494e0ef849$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $25031e494e0ef849$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    permissionDenied: {
        defaultMessage: 'No Access',
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.error'
    },
    permissionDeniedMessage: {
        defaultMessage: "Sorry you're not allowed to see this.",
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.message'
    },
    notFound: {
        defaultMessage: 'Not Found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error'
    },
    notFoundMessage: {
        defaultMessage: 'We are having trouble finding that. Check the details and try again.',
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message'
    },
    notFoundV2: {
        defaultMessage: 'Site not found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error.v2'
    },
    notFoundMessageV2: {
        defaultMessage: "We couldn\u2019t find the site. Check the details and try again.",
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message.v2'
    },
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.heading'
    },
    genericMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.message'
    },
    offlineHeading: {
        defaultMessage: "You're disconnected from the internet",
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.heading'
    },
    offlineMessage: {
        defaultMessage: 'The internet may be out to lunch. Check your network connection and try again.',
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.message'
    }
});

});


parcelRegister("jWWjz", function(module, exports) {
$parcel$export(module.exports, "ContextSetter", () => (parcelRequire("6EkPI")).default);

var $6EkPI = parcelRequire("6EkPI");

});
parcelRegister("6EkPI", function(module, exports) {
$parcel$export(module.exports, "default", () => $33244b7cc8a17210$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("gvsW5");
var $oi8Kq = parcelRequire("oi8Kq");
class $33244b7cc8a17210$export$28f8b4e4081c59b0 extends $bSJIT.Component {
    updateContextAction(props) {
        const { location: location, match: match, route: route } = props;
        const pathParams = match && match.params || {};
        const pathname = location && location.pathname;
        const routeName = route.name;
        props.updateContextAction({
            pathParams: pathParams,
            pathname: pathname,
            routeName: routeName
        });
    }
    // eslint-disable-next-line react/no-deprecated
    componentWillUpdate(nextProps) {
        this.updateContextAction(nextProps);
    }
    // We use componentDidMount (instead of componentWillMount) here because we need the mount method to be
    // called after all the previous ContextSetters have been unmounted.
    componentDidMount() {
        this.updateContextAction(this.props);
    }
    componentWillUnmount() {
        this.props.clearContextAction();
    }
    render() {
        return null;
    }
}
var $33244b7cc8a17210$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, {
    updateContextAction: $oi8Kq.updateContextAction,
    clearContextAction: $oi8Kq.clearContextAction
})($33244b7cc8a17210$export$28f8b4e4081c59b0);

});


parcelRegister("cdcR8", function(module, exports) {
$parcel$export(module.exports, "ScreenErrorBoundary", () => (parcelRequire("d7jBU")).default);

var $d7jBU = parcelRequire("d7jBU");

});
parcelRegister("d7jBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ec35cd75156387f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");
const $4ec35cd75156387f$var$ScreenErrorBoundary = ({ screenName: screenName, children: children, renderError: renderError })=>// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
        packageName: screenName,
        id: `${screenName}Screen`,
        renderError: renderError
    }, children);
var $4ec35cd75156387f$export$2e2bcd8739ae039 = $4ec35cd75156387f$var$ScreenErrorBoundary;

});


parcelRegister("fDWZJ", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAnonymousSuccess", () => $57315ed56dd195ab$export$c343a4f818004f01);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $57315ed56dd195ab$export$c343a4f818004f01 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1tRYy")), {
        moduleId: "./src/view/request-create-anonymous-success/request-create-anonymous-success.tsx"
    })
});

});
parcelRegister("1tRYy", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6ABma").then(()=>parcelRequire('4BMNq'));

});


parcelRegister("2ITPO", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePage", () => $21cb528502003ec4$export$cf665508b87b4a0f);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $21cb528502003ec4$var$loader = (0, $2vYDF.lazyForPaint)(()=>{
    return (parcelRequire("8UVrY"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hocs.tsx"
});
const $21cb528502003ec4$export$cf665508b87b4a0f = (0, $cVM5r.default)({
    loader: $21cb528502003ec4$var$loader
});

});
parcelRegister("8UVrY", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lB3U9").then(()=>parcelRequire('lR98f'));

});


parcelRegister("eseHb", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePageForHubs", () => $4eb4e20f57c7e484$export$43b5a631464c5e8e);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $4eb4e20f57c7e484$var$loader = (0, $2vYDF.lazyForPaint)(()=>{
    return (parcelRequire("jUy36"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hub-variant/hub-variant.tsx"
});
const $4eb4e20f57c7e484$export$43b5a631464c5e8e = (0, $cVM5r.default)({
    loader: $4eb4e20f57c7e484$var$loader
});

});
parcelRegister("jUy36", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("br2rQ"),
    $kOunM("jdLWQ"),
    $kOunM("jsKIl"),
    $kOunM("dlH2m"),
    $kOunM("8m449"),
    $kOunM("igYwH"),
    $kOunM("92sIe"),
    $kOunM("eScBj"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("aHc5N"),
    $kOunM("esjBs"),
    $kOunM("1gFin"),
    $kOunM("h7CrF")
]).then(()=>parcelRequire('5eDeI'));

});


parcelRegister("jK6W9", function(module, exports) {
$parcel$export(module.exports, "RequestFeedback", () => $1a54c1a45459588f$export$3dcde5242ce8b346);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $1a54c1a45459588f$export$3dcde5242ce8b346 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("i4yCM")), {
        moduleId: "./src/view/request-feedback/hocs.tsx"
    })
});

});
parcelRegister("i4yCM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4cR1d").then(()=>parcelRequire('l4Dt9'));

});


parcelRegister("lYtcY", function(module, exports) {
$parcel$export(module.exports, "Unsubscribe", () => $85253a315a122c6c$export$cf424b9d16eab6b0);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $85253a315a122c6c$export$cf424b9d16eab6b0 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("fduO9")), {
        moduleId: "./src/view/unsubscribe/hocs.tsx"
    })
});

});
parcelRegister("fduO9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6AY9B").then(()=>parcelRequire('55pjL'));

});


parcelRegister("1s4Gq", function(module, exports) {
$parcel$export(module.exports, "UserProfile", () => $867f36d5804aa9c1$export$b7b58f2e100445f7);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $867f36d5804aa9c1$var$loader = (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1QmTq")), {
    moduleId: "./src/view/user-profile/hocs.tsx"
});
const $867f36d5804aa9c1$export$b7b58f2e100445f7 = (0, $cVM5r.default)({
    loader: $867f36d5804aa9c1$var$loader
});

});
parcelRegister("1QmTq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cL5bQ").then(()=>parcelRequire('i9Ib3'));

});


parcelRegister("irUsc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e68287faa16daec7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $haAAx = parcelRequire("haAAx");

var $db841 = parcelRequire("db841");

var $cNer2 = parcelRequire("cNer2");

var $jYOKI = parcelRequire("jYOKI");

var $6JJ8C = parcelRequire("6JJ8C");
class $e68287faa16daec7$var$PortalScreenWithBrowserMetrics extends $bSJIT.Component {
    constructor(props){
        super(props), this.state = {
            screenWasHidden: false
        }, this.startTimer = (screenName)=>{
            const { preventBrowserMetricsTimerResetOnScreenMount: preventBrowserMetricsTimerResetOnScreenMount, stopBrowserMetricsTransitionToNewScreen: stopBrowserMetricsTransitionToNewScreen } = this.props;
            if (!preventBrowserMetricsTimerResetOnScreenMount) {
                (0, $6JJ8C.devLog)('Browser metrics: starting timer for screen:', screenName);
                /**
       * Browser metrics v3 start page load
       */ (0, $db841.startPageLoad)(screenName);
            } else stopBrowserMetricsTransitionToNewScreen();
        }, this.handleVisibilityChange = ()=>{
            this.setState({
                screenWasHidden: true
            });
        };
        this.startTimer(props.screenName);
    }
    // this must be called before post-mount and post-update lifecycle methods
    // to ensure it is called before `endTimer` is called.
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { screenName: screenName, screenId: screenId } = this.props;
        if (nextProps.screenName !== screenName || nextProps.screenId !== screenId) {
            this.setState({
                screenWasHidden: false
            });
            this.startTimer(nextProps.screenName);
        }
    }
    componentDidMount() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    render() {
        const { screenName: screenName, children: children, screenId: screenId } = this.props;
        // We need to set the screen name to undefined if the window visibility changed
        // so the browser metrics event never gets fired.
        // If the user changes tabs while the page is loading, the time to load is calculated incorrectly.
        // So we're discarding these events as a workaround. See FSD-3537.
        const screenNameForBrowserMetrics = this.state.screenWasHidden ? undefined : screenName;
        return /*#__PURE__*/ $bSJIT.createElement((0, $jYOKI.ScreenNameProvider), {
            params: {
                screenId: screenId,
                screenName: screenNameForBrowserMetrics
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
            sourceName: screenName,
            sourceType: (0, $haAAx.ScreenTypes).SCREEN
        }, children));
    }
}
/**
 * Establishes a new screen for analytics and browsermetrics purposes.
 * Will set analytics context, and start a browsermetrics timer for the screen.
 * @param screenName the name of the screen, fired in the event
 * @param screenId an optional further identifier for cases when a user can navigate between two
 * different screens with the same name, e.g. two request create screens for different request types
 */ const $e68287faa16daec7$var$AnalyticsScreen = (props)=>{
    const { screenName: screenName, children: children, screenId: screenId } = props;
    return /*#__PURE__*/ $bSJIT.createElement((0, $cNer2.BrowserMetricsScreenTransitionStatusContext).Consumer, null, (value)=>/*#__PURE__*/ $bSJIT.createElement($e68287faa16daec7$var$PortalScreenWithBrowserMetrics, {
            screenName: screenName,
            screenId: screenId,
            preventBrowserMetricsTimerResetOnScreenMount: value.preventBrowserMetricsTimerResetOnScreenMount,
            stopBrowserMetricsTransitionToNewScreen: value.stopBrowserMetricsTransitionToNewScreen
        }, children));
};
var $e68287faa16daec7$export$2e2bcd8739ae039 = $e68287faa16daec7$var$AnalyticsScreen;

});
parcelRegister("jYOKI", function(module, exports) {
$parcel$export(module.exports, "ScreenNameProvider", () => $81718c0562d02c8f$export$e037354b8fc39c88);
$parcel$export(module.exports, "clearScreenName", () => $81718c0562d02c8f$export$d4736a6a534144a);
$parcel$export(module.exports, "default", () => $81718c0562d02c8f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $81718c0562d02c8f$var$ScreenNameContext = /*#__PURE__*/ $bSJIT.createContext({
    screenName: undefined
});
const $81718c0562d02c8f$export$e037354b8fc39c88 = (props)=>/*#__PURE__*/ $bSJIT.createElement($81718c0562d02c8f$var$ScreenNameContext.Provider, {
        value: props.params
    }, props.children);
const $81718c0562d02c8f$export$d4736a6a534144a = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $bSJIT.createElement($81718c0562d02c8f$var$ScreenNameContext.Provider, {
            value: {
                screenName: undefined
            }
        }, /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props));
const $81718c0562d02c8f$var$withScreenName = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $bSJIT.createElement($81718c0562d02c8f$var$ScreenNameContext.Consumer, null, (value)=>/*#__PURE__*/ $bSJIT.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $81718c0562d02c8f$export$2e2bcd8739ae039 = $81718c0562d02c8f$var$withScreenName;

});


parcelRegister("bkEWh", function(module, exports) {
$parcel$export(module.exports, "createRouteWithLayout", () => $13ed866f21a6cf78$export$64cff199c78ee95d);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("bQE3n");
var $eOp7R = parcelRequire("eOp7R");
const $13ed866f21a6cf78$var$selector = (0, $BOq7h.createSelector)((0, $fOlM6.getHeadless), (headerless)=>({
        headerless: headerless
    }));
const $13ed866f21a6cf78$export$64cff199c78ee95d = (route, screenName, layoutProps)=>{
    const { path: path, component: component } = route;
    const LayoutRouteComponent = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOp7R.BannerWithPaperLayoutRoute), {
            path: path,
            component: component,
            layoutProps: {
                headerless: props.headerless,
                ...layoutProps
            },
            screenName: screenName
        });
    };
    return {
        ...route,
        component: (0, $hbIgt.withRouter)((0, $f2mlD.default)($13ed866f21a6cf78$var$selector)(LayoutRouteComponent))
    };
};

});
parcelRegister("bQE3n", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => (parcelRequire("eOp7R")).BannerWithPaperLayoutRoute);

var $eOp7R = parcelRequire("eOp7R");

});
parcelRegister("eOp7R", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => $f79f254d6c449114$export$fd1a0cfe11934244);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("44VoE");
var $jPujg = parcelRequire("jPujg");

var $1qPbZ = parcelRequire("1qPbZ");

var $33Um8 = parcelRequire("33Um8");
parcelRequire("2sURY");
var $b8OZA = parcelRequire("b8OZA");
parcelRequire("kXI4A");
var $e2Dfm = parcelRequire("e2Dfm");
parcelRequire("1ylIr");
var $cHYPR = parcelRequire("cHYPR");
const $f79f254d6c449114$export$75ef22cdda92e1da = (props)=>{
    const { children: children, helpCenterBanner: helpCenterBanner, ...restProps } = props;
    // Use the useCachedUrl hook to handle the banner URL
    const { cachedBannerUrl: cachedBannerUrl, isLoading: isBannerImageLoading } = (0, $33Um8.useCachedUrl)(helpCenterBanner);
    if ((0, $lFpPv.isUseHelpCenterRefresh)()) return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), /*#__PURE__*/ $bSJIT.createElement((0, $b8OZA.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), /*#__PURE__*/ $bSJIT.createElement((0, $e2Dfm.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
};
const $f79f254d6c449114$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getHelpCenterBanner), (0, $jPujg.getShown), (0, $hvIQS.getHelpCenterBrandingLoader), (helpCenterBanner, searchShown, isBrandingLoaded)=>({
        helpCenterBanner: helpCenterBanner,
        searchShown: searchShown,
        isBrandingLoaded: isBrandingLoaded
    }));
const $f79f254d6c449114$var$ConnectedBannerWithPaperLayout = (0, $f2mlD.default)($f79f254d6c449114$var$selector)($f79f254d6c449114$export$75ef22cdda92e1da);
const $f79f254d6c449114$export$fd1a0cfe11934244 = (0, $cHYPR.default)($f79f254d6c449114$var$ConnectedBannerWithPaperLayout);
var $f79f254d6c449114$export$2e2bcd8739ae039 = $f79f254d6c449114$var$ConnectedBannerWithPaperLayout;

});
parcelRegister("44VoE", function(module, exports) {
$parcel$export(module.exports, "getShown", () => (parcelRequire("jPujg")).getShown);
$parcel$export(module.exports, "getTerm", () => (parcelRequire("jPujg")).getTerm);

var $jPujg = parcelRequire("jPujg");

});
parcelRegister("jPujg", function(module, exports) {
$parcel$export(module.exports, "getShown", () => $be5236cfb9b1f9df$export$75d5ea8092347462);
$parcel$export(module.exports, "getTerm", () => $be5236cfb9b1f9df$export$3947fb2f9e53bfd);
const $be5236cfb9b1f9df$export$75d5ea8092347462 = (state)=>state.ui.search.shown;
const $be5236cfb9b1f9df$export$3947fb2f9e53bfd = (state)=>state.ui.search.term;

});


parcelRegister("33Um8", function(module, exports) {
$parcel$export(module.exports, "useCachedUrl", () => $c73637f69bd65556$export$6c4a7056bc19c165);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $clpci = parcelRequire("clpci");

var $haAAx = parcelRequire("haAAx");

var $4fhUT = parcelRequire("4fhUT");
const $c73637f69bd65556$export$6c4a7056bc19c165 = function(inputUrl) {
    const [cachedBannerUrl, setCachedBannerUrl] = (0, $bSJIT.useState)();
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        if (!!inputUrl && inputUrl.startsWith('blob:')) {
            setCachedBannerUrl(inputUrl);
            setIsLoading(false);
        } else if (!!inputUrl) (0, $4fhUT.getObjectURLFromMediaURLWithCaching)(inputUrl).then((url)=>{
            setCachedBannerUrl(url);
            setIsLoading(false);
        }).catch((error)=>{
            setIsLoading(false);
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'useCachedUrl',
                attributes: {
                    errorMessage: error.message
                }
            }).fire((0, $clpci.ANALYTICS_BRIDGE_CHANNEL));
        });
        else {
            setCachedBannerUrl(null);
            setIsLoading(false);
        }
    }, [
        createAnalyticsEvent,
        inputUrl,
        setCachedBannerUrl
    ]);
    return {
        cachedBannerUrl: cachedBannerUrl,
        isLoading: isLoading
    };
};

});
parcelRegister("4fhUT", function(module, exports) {
$parcel$export(module.exports, "getObjectURLFromMediaURLWithCaching", () => $4bb7807578eaef63$export$183e77d363d2e63e);

var $fvUqa = parcelRequire("fvUqa");

var $coiU7 = parcelRequire("coiU7");
const $4bb7807578eaef63$var$PARAM_KEY_TOKEN = 'token';
const $4bb7807578eaef63$var$PARAM_KEY_MAX_AGE = 'max-age';
const $4bb7807578eaef63$var$PARAM_KEY_HEIGHT = 'height';
const $4bb7807578eaef63$var$DEFAULT_PARAM_VALUE_MAX_AGE = '31536000'; // maximum value for max-age supported by media services
const $4bb7807578eaef63$var$HEIGHT_MAX_PARAM_VALUE = '4096'; // maximum value for height supported by media services
const $4bb7807578eaef63$var$MAX_RETRIES = 5;
const $4bb7807578eaef63$var$MS_BETWEEN_TRIES = 500;
const $4bb7807578eaef63$var$USE_ASYNC = true;
// A local cache for the blob URLs to avoid polluting blob storage
const $4bb7807578eaef63$var$BLOB_CACHE = {};
const $4bb7807578eaef63$export$183e77d363d2e63e = (completeUrl, msBetweenTries = $4bb7807578eaef63$var$MS_BETWEEN_TRIES)=>{
    return $4bb7807578eaef63$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries);
};
const $4bb7807578eaef63$var$internalGetObjectURLFromMediaURLWithCaching = (completeUrl, msBetweenTries = $4bb7807578eaef63$var$MS_BETWEEN_TRIES, tryNumber = 1)=>{
    // Suppressing existing violation. Please fix this.
    const { url: url, token: token } = $4bb7807578eaef63$var$parseUrl(completeUrl);
    // if we already created a blob url for this url, just finish.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if ($4bb7807578eaef63$var$BLOB_CACHE[url]) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    return Promise.resolve($4bb7807578eaef63$var$BLOB_CACHE[url]);
    const req = new XMLHttpRequest();
    req.open('GET', url, $4bb7807578eaef63$var$USE_ASYNC);
    req.responseType = 'arraybuffer';
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    token && req.setRequestHeader('Authorization', `Bearer ${token}`);
    return new Promise((resolve, reject)=>{
        req.onload = ()=>{
            if (req.status === 200) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const blobUrl = (0, $coiU7.createObjectURLFromResponse)(req.response, req.getResponseHeader('content-type'));
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                $4bb7807578eaef63$var$BLOB_CACHE[url] = blobUrl;
                resolve(blobUrl);
            } else reject(req.statusText);
        };
        req.onerror = ()=>{
            if (req.status === 404 && tryNumber < $4bb7807578eaef63$var$MAX_RETRIES) $4bb7807578eaef63$var$wait(msBetweenTries).then(()=>$4bb7807578eaef63$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries, tryNumber + 1)).then(resolve, reject);
            else reject(req.statusText);
        };
        req.send();
    });
};
const $4bb7807578eaef63$var$parseUrl = (completeUrl)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { url: url, query: query } = $fvUqa.parseUrl(completeUrl);
    // parse the url and token
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const mediaApiJwt = query[$4bb7807578eaef63$var$PARAM_KEY_TOKEN];
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    delete query[$4bb7807578eaef63$var$PARAM_KEY_TOKEN];
    // prepare the query string
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$4bb7807578eaef63$var$PARAM_KEY_MAX_AGE] = $4bb7807578eaef63$var$DEFAULT_PARAM_VALUE_MAX_AGE;
    // ensure no cropping/fitting/scaling of the image until we release the cropper
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$4bb7807578eaef63$var$PARAM_KEY_HEIGHT] = $4bb7807578eaef63$var$HEIGHT_MAX_PARAM_VALUE;
    const parsedUrl = `${url}?${$fvUqa.stringify(query)}`;
    return {
        url: parsedUrl,
        token: mediaApiJwt
    };
};
const $4bb7807578eaef63$export$d2adf65b87e47523 = ()=>{
    Object.keys($4bb7807578eaef63$var$BLOB_CACHE).forEach((cachedItem)=>{
        delete $4bb7807578eaef63$var$BLOB_CACHE[cachedItem];
    });
};
const $4bb7807578eaef63$var$wait = (msBetweenTries)=>new Promise((r)=>setTimeout(r, msBetweenTries));

});
parcelRegister("coiU7", function(module, exports) {
$parcel$export(module.exports, "createObjectURLFromResponse", () => $09ac4cd2a09bf14c$export$c1dfa855638dae6c);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $09ac4cd2a09bf14c$export$c1dfa855638dae6c = (response, contentType)=>{
    const arrayBuffer = [
        response
    ];
    const blob = new Blob(arrayBuffer, {
        type: contentType
    });
    return URL.createObjectURL(blob);
};

});



parcelRegister("2sURY", function(module, exports) {
$parcel$export(module.exports, "BannerWithGridLayoutDumb", () => (parcelRequire("b8OZA")).default);

var $b8OZA = parcelRequire("b8OZA");

});
parcelRegister("b8OZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e451b2d67091fe37$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");
parcelRequire("9H44a");
var $dCSpQ = parcelRequire("dCSpQ");
parcelRequire("8Emwg");
var $7XXCW = parcelRequire("7XXCW");
parcelRequire("ckGNT");
var $2LtGs = parcelRequire("2LtGs");

var $kkzNV = parcelRequire("kkzNV");

var $OK0aw = parcelRequire("OK0aw");

var $bSA8a = parcelRequire("bSA8a");

var $gwMCf = parcelRequire("gwMCf");
parcelRequire("gUWC1");
var $jc09K = parcelRequire("jc09K");
parcelRequire("fz2hV");
var $jr0Z4 = parcelRequire("jr0Z4");
const $e451b2d67091fe37$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSA8a.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $OK0aw.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $e451b2d67091fe37$var$BannerWithGridLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, searchShown: searchShown, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent })=>{
    const showCompressedBanner = ![
        'none',
        'note'
    ].includes(paperAppearance || 'normal');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e451b2d67091fe37$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e451b2d67091fe37$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e451b2d67091fe37$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e451b2d67091fe37$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dCSpQ.default), {
        className: "px-paper-layout"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gwMCf.BannerWithLayoutHeaderMemoizedHOC), {
        isAnonymous: isAnonymous,
        removeHeader: removeHeader,
        headerless: headerless,
        hideSearchButton: hideSearchButton,
        helpCenterBanner: helpCenterBanner,
        hideBanner: hideBanner,
        prefetchBrandingModel: prefetchBrandingModel,
        renderForPaperLayout: !showCompressedBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jc09K.default), {
        appearance: paperAppearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jr0Z4.default), {
        appearance: paperAppearance,
        isCSM: isCSM,
        hideSkipToMainContent: hideSkipToMainContent
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kkzNV.AutoHeightBody), null)))));
};
var $e451b2d67091fe37$export$2e2bcd8739ae039 = $e451b2d67091fe37$var$BannerWithGridLayoutDumb;
const $e451b2d67091fe37$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e451b2d67091fe37$var$SidebarPusherRoot = /*#__PURE__*/ (0, $4v2A7.default)((0, $2LtGs.default)).withConfig({
    componentId: "sc-kh8qt6-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e451b2d67091fe37$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-kh8qt6-1"
})`display:flex;flex-direction:column;min-height:${$e451b2d67091fe37$var$CONTAINER_MIN_HEIGHT};`;
const $e451b2d67091fe37$export$36525627ce333d44 = /*#__PURE__*/ (0, $4v2A7.default)((0, $7XXCW.Flipper)).withConfig({
    componentId: "sc-kh8qt6-2"
})`display:flex;flex-direction:column;`;

});
parcelRegister("8Emwg", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("7XXCW")).Flipper);

var $7XXCW = parcelRequire("7XXCW");

});
parcelRegister("7XXCW", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => $c3ff09f5c9bfae1f$export$3e759dc50fe56038);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("ZKQFp");
var $kxZWm = parcelRequire("kxZWm");
var $ckSCC = parcelRequire("ckSCC");
const $c3ff09f5c9bfae1f$export$3e759dc50fe56038 = (props)=>/*#__PURE__*/ $bSJIT.createElement((0, $ckSCC.default), {
        ...props,
        spring: {
            stiffness: 600,
            damping: 40
        }
    }, props.children);
const $c3ff09f5c9bfae1f$export$c3816ea9cb166de0 = (props)=>/*#__PURE__*/ $bSJIT.createElement((0, $kxZWm.default), props, props.children);

});
parcelRegister("ZKQFp", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("ckSCC")).default);
$parcel$export(module.exports, "Flipped", () => (parcelRequire("kxZWm")).default);

var $ckSCC = parcelRequire("ckSCC");

var $kxZWm = parcelRequire("kxZWm");

var $Nxej4 = parcelRequire("Nxej4");
var // for umd build
$0b9a09bfda9a230b$export$2e2bcd8739ae039 = {
    Flipper: (0, $ckSCC.default),
    Flipped: (0, $kxZWm.default),
    ExitContainer: (0, $Nxej4.default)
};

});
parcelRegister("ckSCC", function(module, exports) {
$parcel$export(module.exports, "FlipContext", () => $8fb1b91016e99c12$export$aa77f7b4e64b9ea9);
$parcel$export(module.exports, "PortalContext", () => $8fb1b91016e99c12$export$60d741e20e0aa309);
$parcel$export(module.exports, "default", () => $8fb1b91016e99c12$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");


var $jibci = parcelRequire("jibci");

var $iUPTQ = parcelRequire("iUPTQ");
function $8fb1b91016e99c12$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8fb1b91016e99c12$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8fb1b91016e99c12$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8fb1b91016e99c12$export$aa77f7b4e64b9ea9 = (0, $bSJIT.createContext)("flip");
var $8fb1b91016e99c12$export$60d741e20e0aa309 = (0, $bSJIT.createContext)("portal");
var $8fb1b91016e99c12$var$Flipper = function(_Component) {
    $8fb1b91016e99c12$var$_inherits(Flipper, _Component);
    function Flipper(props) {
        $8fb1b91016e99c12$var$_classCallCheck(this, Flipper);
        var _this = $8fb1b91016e99c12$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.inProgressAnimations = {};
        _this.flipCallbacks = {};
        return _this;
    }
    Flipper.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.flipKey !== this.props.flipKey) return (0, $iUPTQ.getFlippedElementPositionsBeforeUpdate)({
            element: this.el,
            // if onExit callbacks exist here, we'll cache the DOM node
            flipCallbacks: this.flipCallbacks,
            inProgressAnimations: this.inProgressAnimations,
            portalKey: this.props.portalKey
        });
        return null;
    };
    Flipper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, cachedData) {
        if (this.props.flipKey !== prevProps.flipKey) (0, $jibci.default)({
            cachedFlipChildrenPositions: cachedData.flippedElementPositions,
            cachedOrderedFlipIds: cachedData.cachedOrderedFlipIds,
            containerEl: this.el,
            inProgressAnimations: this.inProgressAnimations,
            flipCallbacks: this.flipCallbacks,
            applyTransformOrigin: this.props.applyTransformOrigin,
            spring: this.props.spring,
            debug: this.props.debug,
            portalKey: this.props.portalKey,
            staggerConfig: this.props.staggerConfig,
            handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
            decisionData: {
                prev: prevProps.decisionData,
                current: this.props.decisionData
            }
        });
    };
    Flipper.prototype.render = function render() {
        var _this2 = this;
        var _props = this.props, element = _props.element, className = _props.className, portalKey = _props.portalKey;
        var Element = element;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8fb1b91016e99c12$export$60d741e20e0aa309.Provider, {
            value: portalKey
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8fb1b91016e99c12$export$aa77f7b4e64b9ea9.Provider, {
            value: this.flipCallbacks
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Element, {
            className: className,
            ref: function ref(el) {
                return _this2.el = el;
            }
        }, this.props.children)));
    };
    return Flipper;
}((0, $bSJIT.Component));
$8fb1b91016e99c12$var$Flipper.propTypes = {};
$8fb1b91016e99c12$var$Flipper.defaultProps = {
    applyTransformOrigin: true,
    element: "div"
};
var $8fb1b91016e99c12$export$2e2bcd8739ae039 = $8fb1b91016e99c12$var$Flipper;

});
parcelRegister("jibci", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0b86255ff3a3c83$export$2e2bcd8739ae039);

var $bL9gM = parcelRequire("bL9gM");

var $92y3d = parcelRequire("92y3d");

var $iUPTQ = parcelRequire("iUPTQ");

var $bgcP7 = parcelRequire("bgcP7");

var $6c6bL = parcelRequire("6c6bL");
var $e0b86255ff3a3c83$var$createScopedSelector = function createScopedSelector(element, portalKey) {
    if (portalKey) return function(selector) {
        return document.querySelectorAll("[" + $bgcP7.DATA_PORTAL_KEY + "=" + portalKey + "]" + selector);
    };
    else return function(selector) {
        return element.querySelectorAll(selector);
    };
};
var $e0b86255ff3a3c83$var$createGetElementFunc = function createGetElementFunc(element, portalKey) {
    // this should only ever return 1 element
    return function(id) {
        return $e0b86255ff3a3c83$var$createScopedSelector(element, portalKey)("[" + $bgcP7.DATA_FLIP_ID + "=\"" + id + "\"]")[0];
    };
};
var $e0b86255ff3a3c83$var$onFlipKeyUpdate = function onFlipKeyUpdate(_ref) {
    var _ref$cachedOrderedFli = _ref.cachedOrderedFlipIds, cachedOrderedFlipIds = _ref$cachedOrderedFli === undefined ? [] : _ref$cachedOrderedFli, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, _ref$cachedFlipChildr = _ref.cachedFlipChildrenPositions, cachedFlipChildrenPositions = _ref$cachedFlipChildr === undefined ? {} : _ref$cachedFlipChildr, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, containerEl = _ref.containerEl, applyTransformOrigin = _ref.applyTransformOrigin, spring = _ref.spring, debug = _ref.debug, portalKey = _ref.portalKey, _ref$staggerConfig = _ref.staggerConfig, staggerConfig = _ref$staggerConfig === undefined ? {} : _ref$staggerConfig, _ref$decisionData = _ref.decisionData, decisionData = _ref$decisionData === undefined ? {} : _ref$decisionData, handleEnterUpdateDelete = _ref.handleEnterUpdateDelete;
    var newFlipChildrenPositions = (0, $iUPTQ.getFlippedElementPositionsAfterUpdate)({
        element: containerEl,
        portalKey: portalKey
    });
    var scopedSelector = $e0b86255ff3a3c83$var$createScopedSelector(containerEl, portalKey);
    var getElement = $e0b86255ff3a3c83$var$createGetElementFunc(containerEl, portalKey);
    var isFlipped = function isFlipped(id) {
        return cachedFlipChildrenPositions[id] && newFlipChildrenPositions[id];
    };
    var unflippedIds = Object.keys(cachedFlipChildrenPositions).concat(Object.keys(newFlipChildrenPositions)).filter(function(id) {
        return !isFlipped(id);
    });
    var baseArgs = {
        flipCallbacks: flipCallbacks,
        getElement: getElement,
        cachedFlipChildrenPositions: cachedFlipChildrenPositions,
        newFlipChildrenPositions: newFlipChildrenPositions,
        inProgressAnimations: inProgressAnimations
    };
    var _animateUnflippedElem = (0, $bL9gM.default)((0, $6c6bL.assign)({}, baseArgs, {
        unflippedIds: unflippedIds
    })), hideEnteringElements = _animateUnflippedElem.hideEnteringElements, animateEnteringElements = _animateUnflippedElem.animateEnteringElements, animateExitingElements = _animateUnflippedElem.animateExitingElements;
    var flippedIds = cachedOrderedFlipIds.filter(isFlipped);
    var animateFlippedElementsArgs = (0, $6c6bL.assign)({}, baseArgs, {
        flippedIds: flippedIds,
        applyTransformOrigin: applyTransformOrigin,
        spring: spring,
        debug: debug,
        staggerConfig: staggerConfig,
        decisionData: decisionData,
        scopedSelector: scopedSelector
    });
    // the function handles putting flipped elements back in their original positions
    // and returns another function to actually call flip
    var flip = (0, $92y3d.default)(animateFlippedElementsArgs);
    if (handleEnterUpdateDelete) handleEnterUpdateDelete({
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements,
        animateFlippedElements: flip
    });
    else {
        hideEnteringElements();
        animateExitingElements().then(animateEnteringElements);
        flip();
    }
};
var $e0b86255ff3a3c83$export$2e2bcd8739ae039 = $e0b86255ff3a3c83$var$onFlipKeyUpdate;

});
parcelRegister("bL9gM", function(module, exports) {
$parcel$export(module.exports, "default", () => $88fb463b8802f6ec$export$2e2bcd8739ae039);
var $88fb463b8802f6ec$var$animateUnflippedElements = function animateUnflippedElements(_ref) {
    var unflippedIds = _ref.unflippedIds, flipCallbacks = _ref.flipCallbacks, getElement = _ref.getElement, newFlipChildrenPositions = _ref.newFlipChildrenPositions, cachedFlipChildrenPositions = _ref.cachedFlipChildrenPositions, inProgressAnimations = _ref.inProgressAnimations;
    var enteringElements = unflippedIds.filter(function(id) {
        return newFlipChildrenPositions[id] && flipCallbacks[id];
    });
    var exitingElementIds = unflippedIds.filter(function(id) {
        return cachedFlipChildrenPositions[id] && flipCallbacks[id] && flipCallbacks[id].onExit;
    });
    var hideEnteringElements = function hideEnteringElements() {
        enteringElements.forEach(function(id) {
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) {
                var element = getElement(id);
                element.style.opacity = "0";
            }
        });
    };
    var animateEnteringElements = function animateEnteringElements() {
        enteringElements.forEach(function(id, i) {
            var element = getElement(id);
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) flipCallbacks[id].onAppear(element, i);
        });
    };
    var closureResolve = void 0;
    var promiseToReturn = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var fragmentTuples = [];
    var exitingElementCount = 0;
    var onExitCallbacks = exitingElementIds.map(function(id, i) {
        var _cachedFlipChildrenPo = cachedFlipChildrenPositions[id].domData, element = _cachedFlipChildrenPo.element, parent = _cachedFlipChildrenPo.parent, _cachedFlipChildrenPo2 = _cachedFlipChildrenPo.childPosition, top = _cachedFlipChildrenPo2.top, left = _cachedFlipChildrenPo2.left, width = _cachedFlipChildrenPo2.width, height = _cachedFlipChildrenPo2.height;
        // insert back into dom
        if (getComputedStyle(parent).position === "static") parent.style.position = "relative";
        element.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
        element.style.position = "absolute";
        element.style.top = top + "px";
        element.style.left = left + "px";
        // taken out of the dom flow, the element might have lost these dimensions
        element.style.height = height + "px";
        element.style.width = width + "px";
        var fragmentTuple = fragmentTuples.filter(function(t) {
            return t[0] === parent;
        })[0];
        if (!fragmentTuple) {
            fragmentTuple = [
                parent,
                document.createDocumentFragment()
            ];
            fragmentTuples.push(fragmentTuple);
        }
        fragmentTuple[1].appendChild(element);
        exitingElementCount += 1;
        var stop = function stop() {
            try {
                parent.removeChild(element);
                exitingElementCount -= 1;
                if (exitingElementCount === 0) closureResolve();
            } catch (DOMException) {
            // the element is already gone
            }
        };
        inProgressAnimations[id] = {
            stop: stop
        };
        return function() {
            return flipCallbacks[id].onExit(element, i, stop);
        };
    });
    // now append all the fragments from the onExit callbacks
    // (we use fragments for performance)
    fragmentTuples.forEach(function(t) {
        var parent = t[0];
        var fragment = t[1];
        parent.appendChild(fragment);
    });
    if (!onExitCallbacks.length) closureResolve();
    var animateExitingElements = function animateExitingElements() {
        onExitCallbacks.forEach(function(c) {
            return c();
        });
        return promiseToReturn;
    };
    return {
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements
    };
};
var $88fb463b8802f6ec$export$2e2bcd8739ae039 = $88fb463b8802f6ec$var$animateUnflippedElements;

});

parcelRegister("92y3d", function(module, exports) {
$parcel$export(module.exports, "default", () => $694eb6c0b9a11e50$export$2e2bcd8739ae039);

var $7HLqu = parcelRequire("7HLqu");

var $j6aCF = parcelRequire("j6aCF");

var $6c6bL = parcelRequire("6c6bL");

var $bgcP7 = parcelRequire("bgcP7");

var $hHg5U = parcelRequire("hHg5U");

var $sf4GF = parcelRequire("sf4GF");
var $694eb6c0b9a11e50$export$3bb3cb1a74f66649 = function convertMatrix3dArrayTo2dArray(matrix) {
    return [
        0,
        1,
        4,
        5,
        12,
        13
    ].map(function(index) {
        return matrix[index];
    });
};
var $694eb6c0b9a11e50$export$ae3bd8c5261b681e = function convertMatrix2dArrayToString(matrix) {
    return "matrix(" + matrix.join(", ") + ")";
};
var $694eb6c0b9a11e50$export$7fd64b870f6a7bb9 = function invertTransformsForChildren(_ref) {
    var invertedChildren = _ref.invertedChildren, matrix = _ref.matrix, body = _ref.body;
    invertedChildren.forEach(function(_ref2) {
        var child = _ref2[0], childFlipConfig = _ref2[1];
        if (!body.contains(child)) return;
        var scaleX = matrix[0];
        var scaleY = matrix[3];
        var translateX = matrix[4];
        var translateY = matrix[5];
        var inverseVals = {
            translateX: 0,
            translateY: 0,
            scaleX: 1,
            scaleY: 1
        };
        var transformString = "";
        if (childFlipConfig.translate) {
            inverseVals.translateX = -translateX / scaleX;
            inverseVals.translateY = -translateY / scaleY;
            transformString += "translate(" + inverseVals.translateX + "px, " + inverseVals.translateY + "px)";
        }
        if (childFlipConfig.scale) {
            inverseVals.scaleX = 1 / scaleX;
            inverseVals.scaleY = 1 / scaleY;
            transformString += " scale(" + inverseVals.scaleX + ", " + inverseVals.scaleY + ")";
        }
        child.style.transform = transformString;
    });
};
var $694eb6c0b9a11e50$export$ca4fe190a8429f9e = function createApplyStylesFunc(_ref3) {
    var element = _ref3.element, invertedChildren = _ref3.invertedChildren, body = _ref3.body;
    return function(_ref4) {
        var matrix = _ref4.matrix, opacity = _ref4.opacity, forceMinVals = _ref4.forceMinVals;
        if ((0, $6c6bL.isNumber)(opacity)) element.style.opacity = opacity;
        if (forceMinVals) {
            element.style.minHeight = "1px";
            element.style.minWidth = "1px";
        }
        if (!matrix) return;
        var stringTransform = $694eb6c0b9a11e50$export$ae3bd8c5261b681e(matrix);
        // keep a tiny, (hopefully) invisible rotateZ transform on the element to try to
        // prevent Chrome from pixel-snapping when scale transforms
        // are removed
        stringTransform = stringTransform === "matrix(1, 0, 0, 1, 0, 0)" ? "matrix(1, 0.00001, -0.00001, 1, 0, 0)" : stringTransform;
        element.style.transform = stringTransform;
        if (invertedChildren) $694eb6c0b9a11e50$export$7fd64b870f6a7bb9({
            invertedChildren: invertedChildren,
            matrix: matrix,
            body: body
        });
    };
};
var $694eb6c0b9a11e50$export$90503d75ca6e7d46 = function rectInViewport(_ref5) {
    var top = _ref5.top, bottom = _ref5.bottom, left = _ref5.left, right = _ref5.right;
    return top < window.innerHeight && bottom > 0 && left < window.innerWidth && right > 0;
};
var $694eb6c0b9a11e50$var$getInvertedChildren = function getInvertedChildren(element, id) {
    return (0, $6c6bL.toArray)(element.querySelectorAll("[" + $bgcP7.DATA_INVERSE_FLIP_ID + "=\"" + id + "\"]"));
};
var $694eb6c0b9a11e50$export$3ec95ebfc77511bd = function tweenProp(start, end, position) {
    return start + (end - start) * position;
};
var $694eb6c0b9a11e50$var$animateFlippedElements = function animateFlippedElements(_ref6) {
    var flippedIds = _ref6.flippedIds, flipCallbacks = _ref6.flipCallbacks, inProgressAnimations = _ref6.inProgressAnimations, cachedFlipChildrenPositions = _ref6.cachedFlipChildrenPositions, newFlipChildrenPositions = _ref6.newFlipChildrenPositions, applyTransformOrigin = _ref6.applyTransformOrigin, spring = _ref6.spring, getElement = _ref6.getElement, debug = _ref6.debug, staggerConfig = _ref6.staggerConfig, decisionData = _ref6.decisionData, scopedSelector = _ref6.scopedSelector;
    var body = document.querySelector("body");
    // the stuff below is used so we can return a promise that resolves when all FLIP animations have
    // completed
    var closureResolve = void 0;
    var flipCompletedPromise = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var withInitFuncs = void 0;
    var completedAnimationIds = [];
    if (debug) // eslint-disable-next-line no-console
    console.error('[react-flip-toolkit]\nThe "debug" prop is set to true. All FLIP animations will return at the beginning of the transition.');
    var duplicateFlipIds = (0, $6c6bL.getDuplicateValsAsStrings)(flippedIds);
    if (duplicateFlipIds.length) // eslint-disable-next-line no-console
    console.error("[react-flip-toolkit]\nThere are currently multiple elements with the same flipId on the page.\nThe animation will only work if each Flipped component has a unique flipId.\nDuplicate flipId" + (duplicateFlipIds.length > 1 ? "s" : "") + ": " + duplicateFlipIds.join("\n"));
    var flipDataArray = flippedIds// take all the measurements we need
    // and return an object with animation functions + necessary data
    .map(function(id) {
        var prevRect = cachedFlipChildrenPositions[id].rect;
        var currentRect = newFlipChildrenPositions[id].rect;
        var prevOpacity = cachedFlipChildrenPositions[id].opacity;
        var currentOpacity = newFlipChildrenPositions[id].opacity;
        var needsForcedMinVals = currentRect.width < 1 || currentRect.height < 1;
        // don't animate elements outside of the user's viewport
        if (!$694eb6c0b9a11e50$export$90503d75ca6e7d46(prevRect) && !$694eb6c0b9a11e50$export$90503d75ca6e7d46(currentRect)) return false;
        // it's never going to be visible, so dont animate it
        if (prevRect.width === 0 && currentRect.width === 0 || prevRect.height === 0 && currentRect.height === 0) return false;
        var element = getElement(id);
        // this might happen if we are rapidly adding & removing elements(?)
        if (!element) return false;
        var flipConfig = JSON.parse(element.dataset.flipConfig);
        var springConfig = (0, $j6aCF.getSpringConfig)({
            flipperSpring: spring,
            flippedSpring: flipConfig.spring
        });
        var stagger = flipConfig.stagger === true ? "default" : flipConfig.stagger;
        var toReturn = {
            element: element,
            id: id,
            stagger: stagger,
            springConfig: springConfig,
            noOp: true
        };
        if (flipCallbacks[id] && flipCallbacks[id].shouldFlip) {
            var elementShouldFlip = flipCallbacks[id].shouldFlip(decisionData.prev, decisionData.current);
            // this element wont be animated, but its children might be
            if (!elementShouldFlip) return toReturn;
        }
        // don't animate elements that didn't change
        // but we might want to animate children
        if (prevRect.left === currentRect.left && prevRect.top === currentRect.top && prevRect.width === currentRect.width && prevRect.height === currentRect.height && prevOpacity === currentOpacity) // this element wont be animated, but its children might be
        return toReturn;
        toReturn.noOp = false;
        var currentTransform = $7HLqu.parse(newFlipChildrenPositions[id].transform);
        var toVals = {
            matrix: currentTransform
        };
        var fromVals = {};
        var transformsArray = [
            currentTransform
        ];
        // we're only going to animate the values that the child wants animated
        if (flipConfig.translate) {
            transformsArray.push($7HLqu.translateX(prevRect.left - currentRect.left));
            transformsArray.push($7HLqu.translateY(prevRect.top - currentRect.top));
        }
        // going any smaller than 1px breaks transitions in Chrome
        if (flipConfig.scale) {
            transformsArray.push($7HLqu.scaleX(Math.max(prevRect.width, 1) / Math.max(currentRect.width, 1)));
            transformsArray.push($7HLqu.scaleY(Math.max(prevRect.height, 1) / Math.max(currentRect.height, 1)));
        }
        if (flipConfig.opacity) {
            fromVals.opacity = prevOpacity;
            toVals.opacity = currentOpacity;
        }
        var invertedChildren = [];
        if (!flipCallbacks[id] || !flipCallbacks[id].shouldInvert || flipCallbacks[id].shouldInvert(decisionData.prev, decisionData.current)) invertedChildren = $694eb6c0b9a11e50$var$getInvertedChildren(element, id).map(function(c) {
            return [
                c,
                JSON.parse(c.dataset.flipConfig)
            ];
        });
        fromVals.matrix = $694eb6c0b9a11e50$export$3bb3cb1a74f66649(transformsArray.reduce($7HLqu.multiply));
        toVals.matrix = $694eb6c0b9a11e50$export$3bb3cb1a74f66649(toVals.matrix);
        var applyStyles = $694eb6c0b9a11e50$export$ca4fe190a8429f9e({
            element: element,
            invertedChildren: invertedChildren,
            body: body
        });
        var onComplete = void 0;
        if (flipCallbacks[id] && flipCallbacks[id].onComplete) {
            // must cache or else this could cause an error
            var cachedOnComplete = flipCallbacks[id].onComplete;
            onComplete = function onComplete() {
                return cachedOnComplete(element, decisionData.prev, decisionData.current);
            };
        }
        // this should be called when animation ends naturally
        // but also when it is interrupted
        // when it is called, the animation has already been cancelled
        var onAnimationEnd = function onAnimationEnd() {
            delete inProgressAnimations[id];
            (0, $6c6bL.isFunction)(onComplete) && onComplete();
            if (needsForcedMinVals && element) {
                element.style.minHeight = "";
                element.style.minWidth = "";
            }
            completedAnimationIds.push(id);
            if (completedAnimationIds.length >= withInitFuncs.length) // we can theoretically call multiple times since a promise only resolves 1x
            // but that shouldnt happen
            closureResolve();
        };
        var animateOpacity = (0, $6c6bL.isNumber)(fromVals.opacity) && fromVals.opacity !== toVals.opacity;
        var onStartCalled = false;
        var getOnUpdateFunc = function getOnUpdateFunc(stop) {
            inProgressAnimations[id] = {
                stop: stop,
                onComplete: onComplete
            };
            return function(spring) {
                //trigger the user provided onStart function
                if (!onStartCalled) {
                    onStartCalled = true;
                    if (flipCallbacks[id] && flipCallbacks[id].onStart) flipCallbacks[id].onStart(element, decisionData.prev, decisionData.current);
                }
                var currentValue = spring.getCurrentValue();
                if (!body.contains(element)) {
                    stop();
                    return;
                }
                var vals = {};
                vals.matrix = fromVals.matrix.map(function(fromVal, index) {
                    return $694eb6c0b9a11e50$export$3ec95ebfc77511bd(fromVal, toVals.matrix[index], currentValue);
                });
                if (animateOpacity) vals.opacity = $694eb6c0b9a11e50$export$3ec95ebfc77511bd(fromVals.opacity, toVals.opacity, currentValue);
                applyStyles(vals);
            };
        };
        var initializeFlip = function initializeFlip() {
            // before animating, immediately apply FLIP styles to prevent flicker
            applyStyles({
                matrix: fromVals.matrix,
                opacity: animateOpacity && fromVals.opacity,
                forceMinVals: needsForcedMinVals
            });
            // and batch any other style updates if necessary
            if (flipConfig.transformOrigin) element.style.transformOrigin = flipConfig.transformOrigin;
            else if (applyTransformOrigin) element.style.transformOrigin = "0 0";
            invertedChildren.forEach(function(_ref7) {
                var child = _ref7[0], childFlipConfig = _ref7[1];
                if (childFlipConfig.transformOrigin) child.style.transformOrigin = childFlipConfig.transformOrigin;
                else if (applyTransformOrigin) child.style.transformOrigin = "0 0";
            });
        };
        return (0, $6c6bL.assign)({}, toReturn, {
            stagger: stagger,
            springConfig: springConfig,
            getOnUpdateFunc: getOnUpdateFunc,
            initializeFlip: initializeFlip,
            onAnimationEnd: onAnimationEnd
        });
    }).filter(function(x) {
        return x;
    });
    // we use this array to compare with completed animations
    // to decide when all animations are completed
    withInitFuncs = flipDataArray.filter(function(_ref8) {
        var initializeFlip = _ref8.initializeFlip;
        return Boolean(initializeFlip);
    });
    //  put items back in place
    withInitFuncs.forEach(function(_ref9) {
        var initializeFlip = _ref9.initializeFlip;
        return initializeFlip();
    });
    if (debug) return;
    var flipDict = flipDataArray.reduce(function(acc, curr) {
        acc[curr.id] = curr;
        return acc;
    }, {});
    // this function modifies flipDataArray in-place
    // by removing references to non-direct children
    // to enable recursive stagger
    var _filterFlipDescendant = (0, $hHg5U.default)({
        flipDict: flipDict,
        flippedIds: flippedIds,
        scopedSelector: scopedSelector
    }), topLevelChildren = _filterFlipDescendant.topLevelChildren;
    return function() {
        // there are no active FLIP animations, so immediately resolve the
        // returned promise
        if (!withInitFuncs.length) closureResolve();
        (0, $sf4GF.default)({
            topLevelChildren: topLevelChildren,
            flipDict: flipDict,
            staggerConfig: staggerConfig
        });
        return flipCompletedPromise;
    };
};
var $694eb6c0b9a11e50$export$2e2bcd8739ae039 = $694eb6c0b9a11e50$var$animateFlippedElements;

});
parcelRegister("7HLqu", function(module, exports) {
$parcel$export(module.exports, "multiply", () => $59c1566abf81c81b$export$2060d2db72cce88f);
$parcel$export(module.exports, "parse", () => $59c1566abf81c81b$export$98e6a39c04603d36);
$parcel$export(module.exports, "scaleX", () => $59c1566abf81c81b$export$55295ade51f88202);
$parcel$export(module.exports, "scaleY", () => $59c1566abf81c81b$export$2092e2a44ac13bb2);
$parcel$export(module.exports, "translateX", () => $59c1566abf81c81b$export$5667f2d3f182f284);
$parcel$export(module.exports, "translateY", () => $59c1566abf81c81b$export$a1f0f3245f0cf0a4);
/*! @license Rematrix v0.2.3

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $59c1566abf81c81b$export$d9468344d3651243(source) {
    if (source.constructor !== Array) throw new TypeError('Expected array.');
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError('Expected array with either 6 or 16 values.');
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function $59c1566abf81c81b$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $59c1566abf81c81b$export$70ae2c07e401031b(source) {
    var m = $59c1566abf81c81b$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error('Inverse determinant attempted to divide by zero.');
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function $59c1566abf81c81b$export$2060d2db72cce88f(m, x) {
    var fm = $59c1566abf81c81b$export$d9468344d3651243(m);
    var fx = $59c1566abf81c81b$export$d9468344d3651243(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * **Tip:** In virtually all cases, this method is used to convert
 * a CSS matrix (retrieved as a `string` from computed styles) to
 * its equivalent array format.
 *
 * @param  {string} source - String containing a valid CSS `matrix` or `matrix3d` property.
 * @return {array}
 */ function $59c1566abf81c81b$export$98e6a39c04603d36(source) {
    if (typeof source === 'string') {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(', ').map(parseFloat);
            return $59c1566abf81c81b$export$d9468344d3651243(raw);
        }
    }
    return $59c1566abf81c81b$export$f0954fd7d5368655();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $59c1566abf81c81b$export$bb628a54ab399bc9(angle) {
    return $59c1566abf81c81b$export$ea6eae3365de5b9c(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $59c1566abf81c81b$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $59c1566abf81c81b$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $59c1566abf81c81b$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function $59c1566abf81c81b$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === 'number' ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $59c1566abf81c81b$export$55295ade51f88202(scalar) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $59c1566abf81c81b$export$2092e2a44ac13bb2(scalar) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $59c1566abf81c81b$export$13034b1ece9569d5(scalar) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function $59c1566abf81c81b$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $59c1566abf81c81b$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function $59c1566abf81c81b$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function $59c1566abf81c81b$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $59c1566abf81c81b$export$5667f2d3f182f284(distance) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $59c1566abf81c81b$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $59c1566abf81c81b$export$6e43fd17fc519956(distance) {
    var matrix = $59c1566abf81c81b$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}

});

parcelRegister("j6aCF", function(module, exports) {
$parcel$export(module.exports, "getSpringConfig", () => $de76d1504d9d39a8$export$29bc3b1ca84e38c8);

var $6c6bL = parcelRequire("6c6bL");
var $de76d1504d9d39a8$export$31bbaa982ba04c49 = {
    noWobble: {
        stiffness: 200,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    veryGentle: {
        stiffness: 130,
        damping: 17
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 260,
        damping: 26
    }
};
var $de76d1504d9d39a8$export$29bc3b1ca84e38c8 = function getSpringConfig() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, flipperSpring = _ref.flipperSpring, flippedSpring = _ref.flippedSpring;
    var normalizeSpring = function normalizeSpring(spring) {
        if ((0, $6c6bL.isObject)(spring)) return spring;
        else if ($de76d1504d9d39a8$export$31bbaa982ba04c49[spring]) return $de76d1504d9d39a8$export$31bbaa982ba04c49[spring];
        else return {};
    };
    return (0, $6c6bL.assign)({}, $de76d1504d9d39a8$export$31bbaa982ba04c49.noWobble, normalizeSpring(flipperSpring), normalizeSpring(flippedSpring));
};

});
parcelRegister("6c6bL", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $4828aa081165d84e$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $4828aa081165d84e$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $4828aa081165d84e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toArray", () => $4828aa081165d84e$export$45b10814cc054894);
$parcel$export(module.exports, "getDuplicateValsAsStrings", () => $4828aa081165d84e$export$b118174c74c51022);
$parcel$export(module.exports, "assign", () => $4828aa081165d84e$export$e6e34fd1f2686227);
var $4828aa081165d84e$export$7e4aa119212bc614 = function isNumber(x) {
    return typeof x === "number";
};
var $4828aa081165d84e$export$f6e2535fb5126e54 = function isFunction(x) {
    return typeof x === "function";
};
var $4828aa081165d84e$export$a6cdc56e425d0d0a = function isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
};
var $4828aa081165d84e$export$45b10814cc054894 = function toArray(arrayLike) {
    return Array.prototype.slice.apply(arrayLike);
};
var $4828aa081165d84e$export$b118174c74c51022 = function getDuplicateValsAsStrings(arr) {
    var obj = arr.reduce(function(acc, curr) {
        acc[curr] = acc[curr] ? acc[curr] + 1 : 1;
        return acc;
    }, {});
    return Object.keys(obj).filter(function(val) {
        return obj[val] > 1;
    });
};
var $4828aa081165d84e$export$e6e34fd1f2686227 = function assign(target) {
    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    args.forEach(function(arg) {
        if (!arg) return;
        // Skip over if undefined or null
        for(var nextKey in arg)// Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(arg, nextKey)) target[nextKey] = arg[nextKey];
    });
    return target;
};

});


parcelRegister("bgcP7", function(module, exports) {
$parcel$export(module.exports, "DATA_FLIP_ID", () => $832b22d641541a5d$export$4e7d89757a685662);
$parcel$export(module.exports, "DATA_INVERSE_FLIP_ID", () => $832b22d641541a5d$export$6e4fe3c088b4bf3f);
$parcel$export(module.exports, "DATA_FLIP_CONFIG", () => $832b22d641541a5d$export$94198d9f80ac9749);
$parcel$export(module.exports, "DATA_PORTAL_KEY", () => $832b22d641541a5d$export$a5965b078f441f7e);
$parcel$export(module.exports, "DATA_EXIT_CONTAINER", () => $832b22d641541a5d$export$ee2a39d85d3284e4);
var $832b22d641541a5d$export$4e7d89757a685662 = "data-flip-id";
var $832b22d641541a5d$export$6e4fe3c088b4bf3f = "data-inverse-flip-id";
var $832b22d641541a5d$export$49e62738b103b74e = "data-flip-component-id";
var $832b22d641541a5d$export$94198d9f80ac9749 = "data-flip-config";
var $832b22d641541a5d$export$a5965b078f441f7e = "data-portal-key";
var $832b22d641541a5d$export$ee2a39d85d3284e4 = "data-exit-container";

});

parcelRegister("hHg5U", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce22efcd11f04afd$export$2e2bcd8739ae039);

var $6c6bL = parcelRequire("6c6bL");

var $bgcP7 = parcelRequire("bgcP7");
// scoped selector makes sure we're querying inside the right Flipper
// container, either internally or with the right portal key
var $ce22efcd11f04afd$var$selectFlipChildIds = function selectFlipChildIds(scopedSelector, selector, flippedIds) {
    var childIds = (0, $6c6bL.toArray)(scopedSelector(selector)).map(function(el) {
        return el.dataset.flipId;
    });
    // now return an array ordered by the original order in the DOM
    return flippedIds.filter(function(id) {
        return childIds.indexOf(id) > -1;
    });
};
var $ce22efcd11f04afd$var$baseSelector = "[" + $bgcP7.DATA_FLIP_ID + "]";
var $ce22efcd11f04afd$export$2e2bcd8739ae039 = function(_ref) {
    var flipDict = _ref.flipDict, flippedIds = _ref.flippedIds, scopedSelector = _ref.scopedSelector;
    var levelToChildren = {};
    var buildHierarchy = function buildHierarchy(selector, level, oldResult) {
        var newSelector = selector + " " + $ce22efcd11f04afd$var$baseSelector;
        // make sure this is scoped to the Flipper element in case there are
        // mulitiple Flipper elements on the page
        var newResult = $ce22efcd11f04afd$var$selectFlipChildIds(scopedSelector, newSelector, flippedIds);
        var oldLevelChildren = oldResult.filter(function(id) {
            return newResult.indexOf(id) === -1;
        });
        levelToChildren[level] = oldLevelChildren;
        oldLevelChildren.forEach(function(childId) {
            if (flipDict[childId]) flipDict[childId].level = level;
        });
        if (newResult.length !== 0) buildHierarchy(newSelector, level + 1, newResult);
    };
    // the top level selectChildFlipIds should use the scopedSelector,
    buildHierarchy($ce22efcd11f04afd$var$baseSelector, 0, $ce22efcd11f04afd$var$selectFlipChildIds(scopedSelector, $ce22efcd11f04afd$var$baseSelector, flippedIds));
    // now make sure childIds in each flippedData contains only direct children
    // since to enable nested stagger  we want each parent to be able to kick off
    // the animations only for its direct children
    Object.keys(flipDict).forEach(function(flipId) {
        var data = flipDict[flipId];
        // scop by parent element
        data.childIds = $ce22efcd11f04afd$var$selectFlipChildIds(function(selector) {
            return data.element.querySelectorAll(selector);
        }, $ce22efcd11f04afd$var$baseSelector, flippedIds);
        data.childIds = data.childIds.filter(function(id) {
            return levelToChildren[data.level + 1] && levelToChildren[data.level + 1].indexOf(id) > -1;
        });
    });
    return {
        topLevelChildren: levelToChildren["0"]
    };
};

});

parcelRegister("sf4GF", function(module, exports) {
$parcel$export(module.exports, "default", () => $054e4f24321b1d16$export$2e2bcd8739ae039);

var $lMwsf = parcelRequire("lMwsf");
var $054e4f24321b1d16$var$initiateImmediateAnimations = function initiateImmediateAnimations(immediate) {
    if (!immediate) return;
    immediate.forEach(function(flipped) {
        (0, $lMwsf.createSpring)(flipped);
        initiateImmediateAnimations(flipped.immediate);
    });
};
var $054e4f24321b1d16$export$5e8092f8b030bcec = function createCallTree(_ref) {
    var flipDict = _ref.flipDict, topLevelChildren = _ref.topLevelChildren, initiateStaggeredAnimations = _ref.initiateStaggeredAnimations;
    //build a data struct to run the springs
    var tree = {
        root: {
            staggeredChildren: {},
            immediateChildren: []
        }
    };
    var appendChild = function appendChild(parent, childId) {
        var flipData = flipDict[childId];
        // might have been filtered (e.g. because it was off screen)
        if (!flipData) return;
        if (flipData.stagger) parent.staggeredChildren[flipData.stagger] ? parent.staggeredChildren[flipData.stagger].push(flipData) : parent.staggeredChildren[flipData.stagger] = [
            flipData
        ];
        else parent.immediateChildren.push(flipData);
        // only when the spring is first activated, activate the child animations as well
        // this enables nested stagger
        flipData.onSpringActivate = function() {
            $054e4f24321b1d16$var$initiateImmediateAnimations(flipData.immediateChildren);
            initiateStaggeredAnimations(flipData.staggeredChildren);
        };
        flipData.staggeredChildren = {};
        flipData.immediateChildren = [];
        flipData.childIds.forEach(function(childId) {
            return appendChild(flipData, childId);
        });
    };
    // create the nested structure
    topLevelChildren.forEach(function(c) {
        appendChild(tree.root, c);
    });
    return tree;
};
var $054e4f24321b1d16$export$2e2bcd8739ae039 = function(_ref2) {
    var staggerConfig = _ref2.staggerConfig, flipDict = _ref2.flipDict, topLevelChildren = _ref2.topLevelChildren;
    var initiateStaggeredAnimations = function initiateStaggeredAnimations(staggered) {
        if (!staggered || !Object.keys(staggered).length) return;
        Object.keys(staggered).forEach(function(staggerKey) {
            return (0, $lMwsf.staggeredSprings)(staggered[staggerKey], staggerConfig[staggerKey]);
        });
    };
    var tree = $054e4f24321b1d16$export$5e8092f8b030bcec({
        flipDict: flipDict,
        topLevelChildren: topLevelChildren,
        initiateStaggeredAnimations: initiateStaggeredAnimations
    });
    $054e4f24321b1d16$var$initiateImmediateAnimations(tree.root.immediateChildren);
    initiateStaggeredAnimations(tree.root.staggeredChildren);
};

});
parcelRegister("lMwsf", function(module, exports) {
$parcel$export(module.exports, "createSpring", () => $fdb7417865632adc$export$d1f8fcb84651afa9);
$parcel$export(module.exports, "staggeredSprings", () => $fdb7417865632adc$export$ac7d870a005a890f);
parcelRequire("lCB1c");
var $4cASl = parcelRequire("4cASl");
// this should get created only 1x
var $fdb7417865632adc$var$springSystem = new (0, $4cASl.default)();
var $fdb7417865632adc$export$1c192fd9ecdd1c80 = function createSuspendedSpring(_ref) {
    var _ref$springConfig = _ref.springConfig, stiffness = _ref$springConfig.stiffness, damping = _ref$springConfig.damping, overshootClamping = _ref$springConfig.overshootClamping, noOp = _ref.noOp, onSpringActivate = _ref.onSpringActivate, getOnUpdateFunc = _ref.getOnUpdateFunc, onAnimationEnd = _ref.onAnimationEnd;
    if (noOp) return;
    var spring = $fdb7417865632adc$var$springSystem.createSpring(stiffness, damping);
    spring.setOvershootClampingEnabled(!!overshootClamping);
    spring.addListener({
        onSpringActivate: onSpringActivate,
        onSpringUpdate: getOnUpdateFunc(spring.destroy.bind(spring)),
        onSpringAtRest: function onSpringAtRest() {
            // prevent SpringSystem from caching unused springs
            spring.destroy();
            onAnimationEnd();
        }
    });
    return spring;
};
var $fdb7417865632adc$export$d1f8fcb84651afa9 = function createSpring(flipped) {
    var spring = $fdb7417865632adc$export$1c192fd9ecdd1c80(flipped);
    if (spring) spring.setEndValue(1);
    else // even if it was a noop,
    // we still need to call onSpringActivate in case it calls
    // cascading flip initiation functions
    flipped.onSpringActivate();
};
var $fdb7417865632adc$export$ac7d870a005a890f = function staggeredSprings(flippedArray) {
    var staggerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!flippedArray || !flippedArray.length) return;
    if (staggerConfig.reverse) flippedArray.reverse();
    var normalizedSpeed = staggerConfig.speed ? 1 + Math.max(Math.min(staggerConfig.speed, 0), 1) : 1.1;
    var nextThreshold = 1 / Math.max(Math.min(flippedArray.length, 100), 10);
    var springFuncs = flippedArray.filter(function(flipped) {
        return !flipped.noOp;
    }).map(function(flipped, i) {
        var cachedGetOnUpdate = flipped.getOnUpdateFunc;
        // modify the update function to adjust
        // the end value of the trailing Flipped component
        flipped.getOnUpdateFunc = function(stop) {
            var onUpdate = cachedGetOnUpdate(stop);
            return function(spring) {
                var currentValue = spring.getCurrentValue();
                if (currentValue > nextThreshold) springFuncs[i + 1] && springFuncs[i + 1].setEndValue(Math.min(currentValue * normalizedSpeed, 1));
                // now call the actual update function
                onUpdate(spring);
            };
        };
        return flipped;
    }).map(function(flipped) {
        return $fdb7417865632adc$export$1c192fd9ecdd1c80(flipped);
    });
    springFuncs[0] && springFuncs[0].setEndValue(1);
};

});
parcelRegister("lCB1c", function(module, exports) {
$parcel$export(module.exports, "SpringSystem", () => (parcelRequire("4cASl")).default);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *      
 */ 
var $4cASl = parcelRequire("4cASl");

var $4GYax = parcelRequire("4GYax");

});
parcelRegister("4cASl", function(module, exports) {
$parcel$export(module.exports, "default", () => $30f4e31ee03954cb$export$2e2bcd8739ae039);

var $3Jhdz = parcelRequire("3Jhdz");

var $jU9Xp = parcelRequire("jU9Xp");

var $4GYax = parcelRequire("4GYax");
function $30f4e31ee03954cb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * A set of Springs that all run on the same physics
 * timing loop. To get started with a Rebound animation, first
 * create a new SpringSystem and then add springs to it.
 * @public
 */ var $30f4e31ee03954cb$var$SpringSystem = function() {
    function SpringSystem(looper) {
        $30f4e31ee03954cb$var$_classCallCheck(this, SpringSystem);
        this.looper = looper || new (0, $3Jhdz.AnimationLooper)();
        this.looper.springSystem = this;
        this.listeners = [];
        this._activeSprings = [];
        this._idleSpringIndices = [];
        this._isIdle = true;
        this._lastTimeMillis = -1;
        this._springRegistry = {};
    }
    /**
   * Add a new spring to this SpringSystem. This Spring will now be solved for
   * during the physics iteration loop. By default the spring will use the
   * default Origami spring config with 40 tension and 7 friction, but you can
   * also provide your own values here.
   * @public
   */ SpringSystem.prototype.createSpring = function createSpring(tension, friction) {
        return this.createSpringWithConfig({
            tension: tension,
            friction: friction
        });
    };
    /**
   * Add a spring with the provided SpringConfig.
   * @public
   */ SpringSystem.prototype.createSpringWithConfig = function createSpringWithConfig(springConfig) {
        var spring = new (0, $jU9Xp.default)(this);
        this.registerSpring(spring);
        spring.setSpringConfig(springConfig);
        return spring;
    };
    /**
   * Check if a SpringSystem is idle or active. If all of the Springs in the
   * SpringSystem are at rest, i.e. the physics forces have reached equilibrium,
   * then this method will return true.
   * @public
   */ SpringSystem.prototype.getIsIdle = function getIsIdle() {
        return this._isIdle;
    };
    /**
   * Manually add a spring to this system. This is called automatically
   * if a Spring is created with SpringSystem#createSpring.
   *
   * This method sets the spring up in the registry so that it can be solved
   * in the solver loop.
   * @public
   */ SpringSystem.prototype.registerSpring = function registerSpring(spring) {
        this._springRegistry[spring.getId()] = spring;
    };
    /**
   * Deregister a spring with this SpringSystem. The SpringSystem will
   * no longer consider this Spring during its integration loop once
   * this is called. This is normally done automatically for you when
   * you call Spring#destroy.
   * @public
   */ SpringSystem.prototype.deregisterSpring = function deregisterSpring(spring) {
        (0, $4GYax.removeFirst)(this._activeSprings, spring);
        delete this._springRegistry[spring.getId()];
    };
    SpringSystem.prototype.advance = function advance(time, deltaTime) {
        while(this._idleSpringIndices.length > 0)this._idleSpringIndices.pop();
        for(var i = 0, len = this._activeSprings.length; i < len; i++){
            var spring = this._activeSprings[i];
            // note from alex: had to add this otherwise deleting springs caused errors
            if (!spring) return;
            if (spring.systemShouldAdvance()) spring.advance(time / 1000.0, deltaTime / 1000.0);
            else this._idleSpringIndices.push(this._activeSprings.indexOf(spring));
        }
        while(this._idleSpringIndices.length > 0){
            var idx = this._idleSpringIndices.pop();
            idx >= 0 && this._activeSprings.splice(idx, 1);
        }
    };
    /**
   * This is the main solver loop called to move the simulation
   * forward through time. Before each pass in the solver loop
   * onBeforeIntegrate is called on an any listeners that have
   * registered themeselves with the SpringSystem. This gives you
   * an opportunity to apply any constraints or adjustments to
   * the springs that should be enforced before each iteration
   * loop. Next the advance method is called to move each Spring in
   * the systemShouldAdvance forward to the current time. After the
   * integration step runs in advance, onAfterIntegrate is called
   * on any listeners that have registered themselves with the
   * SpringSystem. This gives you an opportunity to run any post
   * integration constraints or adjustments on the Springs in the
   * SpringSystem.
   * @public
   */ SpringSystem.prototype.loop = function loop(currentTimeMillis) {
        var listener = void 0;
        if (this._lastTimeMillis === -1) this._lastTimeMillis = currentTimeMillis - 1;
        var ellapsedMillis = currentTimeMillis - this._lastTimeMillis;
        this._lastTimeMillis = currentTimeMillis;
        var i = 0;
        var len = this.listeners.length;
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onBeforeIntegrate && listener.onBeforeIntegrate(this);
        }
        this.advance(currentTimeMillis, ellapsedMillis);
        if (this._activeSprings.length === 0) {
            this._isIdle = true;
            this._lastTimeMillis = -1;
        }
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onAfterIntegrate && listener.onAfterIntegrate(this);
        }
        if (!this._isIdle) this.looper.run();
    };
    /**
   * Used to notify the SpringSystem that a Spring has become displaced.
   * The system responds by starting its solver loop up if it is currently idle.
   */ SpringSystem.prototype.activateSpring = function activateSpring(springId) {
        var spring = this._springRegistry[springId];
        if (this._activeSprings.indexOf(spring) === -1) this._activeSprings.push(spring);
        if (this.getIsIdle()) {
            this._isIdle = false;
            this.looper.run();
        }
    };
    return SpringSystem;
}();
var $30f4e31ee03954cb$export$2e2bcd8739ae039 = $30f4e31ee03954cb$var$SpringSystem;

});
parcelRegister("3Jhdz", function(module, exports) {
$parcel$export(module.exports, "AnimationLooper", () => $2b72ee293d498fc5$export$253af54c72735e05);

var $4GYax = parcelRequire("4GYax");
function $2b72ee293d498fc5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $2b72ee293d498fc5$export$253af54c72735e05 = function() {
    function AnimationLooper() {
        $2b72ee293d498fc5$var$_classCallCheck(this, AnimationLooper);
    }
    AnimationLooper.prototype.run = function run() {
        var _this = this;
        (0, $4GYax.onFrame)(function() {
            _this.springSystem.loop((0, $4GYax.performanceNow)());
        });
    };
    return AnimationLooper;
}();

});
parcelRegister("4GYax", function(module, exports) {
$parcel$export(module.exports, "onFrame", () => $36a9c1fce530a85c$export$1241ca3c22b48b34);
$parcel$export(module.exports, "performanceNow", () => $36a9c1fce530a85c$export$fb4230f160368c88);
$parcel$export(module.exports, "removeFirst", () => $36a9c1fce530a85c$export$2529f734547e2830);

var $aNbtF = parcelRequire("aNbtF");
var $36a9c1fce530a85c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $36a9c1fce530a85c$export$1241ca3c22b48b34(func) {
    return (0, $aNbtF.default)(func);
}
var $36a9c1fce530a85c$var$start = Date.now();
var $36a9c1fce530a85c$export$fb4230f160368c88 = (typeof performance === "undefined" ? "undefined" : $36a9c1fce530a85c$var$_typeof(performance)) === "object" && typeof performance.now === "function" ? function() {
    return performance.now();
} : function() {
    return Date.now() - $36a9c1fce530a85c$var$start;
};
function $36a9c1fce530a85c$export$2529f734547e2830(array, item) {
    var idx = array.indexOf(item);
    idx !== -1 && array.splice(idx, 1);
}

});
parcelRegister("aNbtF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7db76233b50bf583$export$2e2bcd8739ae039);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *
 */ var $7db76233b50bf583$var$_onFrame = void 0;
if (typeof window !== "undefined") $7db76233b50bf583$var$_onFrame = window.requestAnimationFrame;
$7db76233b50bf583$var$_onFrame = $7db76233b50bf583$var$_onFrame || function(callback) {
    window.setTimeout(callback, 1000 / 60);
};
var $7db76233b50bf583$export$2e2bcd8739ae039 = $7db76233b50bf583$var$_onFrame;

});



parcelRegister("jU9Xp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7daf89a1676a265$export$2e2bcd8739ae039);

var $4GYax = parcelRequire("4GYax");
function $e7daf89a1676a265$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $e7daf89a1676a265$var$PhysicsState = function PhysicsState() {
    $e7daf89a1676a265$var$_classCallCheck(this, PhysicsState);
    this.position = 0;
    this.velocity = 0;
};
/**
 * Provides a model of a classical spring acting to
 * resolve a body to equilibrium. Springs have configurable
 * tension which is a force multipler on the displacement of the
 * spring from its rest point or `endValue` as defined by [Hooke's
 * law](http://en.wikipedia.org/wiki/Hooke's_law). Springs also have
 * configurable friction, which ensures that they do not oscillate
 * infinitely. When a Spring is displaced by updating it's resting
 * or `currentValue`, the SpringSystems that contain that Spring
 * will automatically start looping to solve for equilibrium. As each
 * timestep passes, `SpringListener` objects attached to the Spring
 * will be notified of the updates providing a way to drive an
 * animation off of the spring's resolution curve.
 * @public
 */ var $e7daf89a1676a265$var$Spring = function() {
    function Spring(springSystem) {
        $e7daf89a1676a265$var$_classCallCheck(this, Spring);
        this._id = "s" + Spring._ID++;
        this._springSystem = springSystem;
        this.listeners = [];
        this._startValue = 0;
        this._currentState = new $e7daf89a1676a265$var$PhysicsState();
        this._displacementFromRestThreshold = 0.001;
        this._endValue = 0;
        this._overshootClampingEnabled = false;
        this._previousState = new $e7daf89a1676a265$var$PhysicsState();
        this._restSpeedThreshold = 0.001;
        this._tempState = new $e7daf89a1676a265$var$PhysicsState();
        this._timeAccumulator = 0;
        this._wasAtRest = true;
    }
    Spring.prototype.getId = function getId() {
        return this._id;
    };
    /**
   * Remove a Spring from simulation and clear its listeners.
   * @public
   */ Spring.prototype.destroy = function destroy() {
        this.listeners = [];
        this._springSystem.deregisterSpring(this);
    };
    /**
   * Set the configuration values for this Spring. A SpringConfig
   * contains the tension and friction values used to solve for the
   * equilibrium of the Spring in the physics loop.
   * @public
   */ Spring.prototype.setSpringConfig = function setSpringConfig(springConfig) {
        this._springConfig = springConfig;
        return this;
    };
    /**
   * Retrieve the current value of the Spring.
   * @public
   */ Spring.prototype.getCurrentValue = function getCurrentValue() {
        return this._currentState.position;
    };
    /**
   * Get the absolute distance of the Spring from a given state value
   */ Spring.prototype.getDisplacementDistanceForState = function getDisplacementDistanceForState(state) {
        return Math.abs(this._endValue - state.position);
    };
    /**
   * Set the endValue or resting position of the spring. If this
   * value is different than the current value, the SpringSystem will
   * be notified and will begin running its solver loop to resolve
   * the Spring to equilibrium. Any listeners that are registered
   * for onSpringEndStateChange will also be notified of this update
   * immediately.
   * @public
   */ Spring.prototype.setEndValue = function setEndValue(endValue) {
        if (this._endValue === endValue && this.isAtRest()) return this;
        this._startValue = this.getCurrentValue();
        this._endValue = endValue;
        this._springSystem.activateSpring(this.getId());
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            var onChange = listener.onSpringEndStateChange;
            onChange && onChange(this);
        }
        return this;
    };
    /**
   * Set the current velocity of the Spring, in pixels per second. As
   * previously mentioned, this can be useful when you are performing
   * a direct manipulation gesture. When a UI element is released you
   * may call setVelocity on its animation Spring so that the Spring
   * continues with the same velocity as the gesture ended with. The
   * friction, tension, and displacement of the Spring will then
   * govern its motion to return to rest on a natural feeling curve.
   * @public
   */ Spring.prototype.setVelocity = function setVelocity(velocity) {
        if (velocity === this._currentState.velocity) return this;
        this._currentState.velocity = velocity;
        this._springSystem.activateSpring(this.getId());
        return this;
    };
    /**
   * Enable overshoot clamping. This means that the Spring will stop
   * immediately when it reaches its resting position regardless of
   * any existing momentum it may have. This can be useful for certain
   * types of animations that should not oscillate such as a scale
   * down to 0 or alpha fade.
   * @public
   */ Spring.prototype.setOvershootClampingEnabled = function setOvershootClampingEnabled(enabled) {
        this._overshootClampingEnabled = enabled;
        return this;
    };
    /**
   * Check if the Spring has gone past its end point by comparing
   * the direction it was moving in when it started to the current
   * position and end value.
   * @public
   */ Spring.prototype.isOvershooting = function isOvershooting() {
        var start = this._startValue;
        var end = this._endValue;
        return this._springConfig.tension > 0 && (start < end && this.getCurrentValue() > end || start > end && this.getCurrentValue() < end);
    };
    /**
   * The main solver method for the Spring. It takes
   * the current time and delta since the last time step and performs
   * an RK4 integration to get the new position and velocity state
   * for the Spring based on the tension, friction, velocity, and
   * displacement of the Spring.
   * @public
   */ Spring.prototype.advance = function advance(time, realDeltaTime) {
        var isAtRest = this.isAtRest();
        if (isAtRest && this._wasAtRest) return;
        var adjustedDeltaTime = realDeltaTime;
        if (realDeltaTime > Spring.MAX_DELTA_TIME_SEC) adjustedDeltaTime = Spring.MAX_DELTA_TIME_SEC;
        this._timeAccumulator += adjustedDeltaTime;
        var tension = this._springConfig.tension;
        var friction = this._springConfig.friction;
        var position = this._currentState.position;
        var velocity = this._currentState.velocity;
        var tempPosition = this._tempState.position;
        var tempVelocity = this._tempState.velocity;
        var aVelocity = void 0;
        var aAcceleration = void 0;
        var bVelocity = void 0;
        var bAcceleration = void 0;
        var cVelocity = void 0;
        var cAcceleration = void 0;
        var dVelocity = void 0;
        var dAcceleration = void 0;
        var dxdt = void 0;
        var dvdt = void 0;
        while(this._timeAccumulator >= Spring.SOLVER_TIMESTEP_SEC){
            this._timeAccumulator -= Spring.SOLVER_TIMESTEP_SEC;
            if (this._timeAccumulator < Spring.SOLVER_TIMESTEP_SEC) {
                this._previousState.position = position;
                this._previousState.velocity = velocity;
            }
            aVelocity = velocity;
            aAcceleration = tension * (this._endValue - tempPosition) - friction * velocity;
            tempPosition = position + aVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + aAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            bVelocity = tempVelocity;
            bAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + bVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + bAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            cVelocity = tempVelocity;
            cAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + cVelocity * Spring.SOLVER_TIMESTEP_SEC;
            tempVelocity = velocity + cAcceleration * Spring.SOLVER_TIMESTEP_SEC;
            dVelocity = tempVelocity;
            dAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            dxdt = 1.0 / 6.0 * (aVelocity + 2.0 * (bVelocity + cVelocity) + dVelocity);
            dvdt = 1.0 / 6.0 * (aAcceleration + 2.0 * (bAcceleration + cAcceleration) + dAcceleration);
            position += dxdt * Spring.SOLVER_TIMESTEP_SEC;
            velocity += dvdt * Spring.SOLVER_TIMESTEP_SEC;
        }
        this._tempState.position = tempPosition;
        this._tempState.velocity = tempVelocity;
        this._currentState.position = position;
        this._currentState.velocity = velocity;
        if (this._timeAccumulator > 0) this._interpolate(this._timeAccumulator / Spring.SOLVER_TIMESTEP_SEC);
        if (this.isAtRest() || this._overshootClampingEnabled && this.isOvershooting()) {
            if (this._springConfig.tension > 0) {
                this._startValue = this._endValue;
                this._currentState.position = this._endValue;
            } else {
                this._endValue = this._currentState.position;
                this._startValue = this._endValue;
            }
            this.setVelocity(0);
            isAtRest = true;
        }
        var notifyActivate = false;
        if (this._wasAtRest) {
            this._wasAtRest = false;
            notifyActivate = true;
        }
        var notifyAtRest = false;
        if (isAtRest) {
            this._wasAtRest = true;
            notifyAtRest = true;
        }
        this.notifyPositionUpdated(notifyActivate, notifyAtRest);
    };
    Spring.prototype.notifyPositionUpdated = function notifyPositionUpdated(notifyActivate, notifyAtRest) {
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            if (notifyActivate && listener.onSpringActivate) listener.onSpringActivate(this);
            if (listener.onSpringUpdate) listener.onSpringUpdate(this);
            if (notifyAtRest && listener.onSpringAtRest) listener.onSpringAtRest(this);
        }
    };
    /**
   * Check if the SpringSystem should advance. Springs are advanced
   * a final frame after they reach equilibrium to ensure that the
   * currentValue is exactly the requested endValue regardless of the
   * displacement threshold.
   * @public
   */ Spring.prototype.systemShouldAdvance = function systemShouldAdvance() {
        return !this.isAtRest() || !this.wasAtRest();
    };
    Spring.prototype.wasAtRest = function wasAtRest() {
        return this._wasAtRest;
    };
    /**
   * Check if the Spring is atRest meaning that it's currentValue and
   * endValue are the same and that it has no velocity. The previously
   * described thresholds for speed and displacement define the bounds
   * of this equivalence check. If the Spring has 0 tension, then it will
   * be considered at rest whenever its absolute velocity drops below the
   * restSpeedThreshold.
   * @public
   */ Spring.prototype.isAtRest = function isAtRest() {
        return Math.abs(this._currentState.velocity) < this._restSpeedThreshold && (this.getDisplacementDistanceForState(this._currentState) <= this._displacementFromRestThreshold || this._springConfig.tension === 0);
    };
    Spring.prototype._interpolate = function _interpolate(alpha) {
        this._currentState.position = this._currentState.position * alpha + this._previousState.position * (1 - alpha);
        this._currentState.velocity = this._currentState.velocity * alpha + this._previousState.velocity * (1 - alpha);
    };
    Spring.prototype.addListener = function addListener(newListener) {
        this.listeners.push(newListener);
        return this;
    };
    Spring.prototype.removeListener = function removeListener(listenerToRemove) {
        (0, $4GYax.removeFirst)(this.listeners, listenerToRemove);
        return this;
    };
    return Spring;
}();
$e7daf89a1676a265$var$Spring._ID = 0;
$e7daf89a1676a265$var$Spring.MAX_DELTA_TIME_SEC = 0.064;
$e7daf89a1676a265$var$Spring.SOLVER_TIMESTEP_SEC = 0.001;
var $e7daf89a1676a265$export$2e2bcd8739ae039 = $e7daf89a1676a265$var$Spring;

});






parcelRegister("iUPTQ", function(module, exports) {
$parcel$export(module.exports, "getFlippedElementPositionsBeforeUpdate", () => $dc55b72d45ccc6d5$export$45700a1d2c971fdb);
$parcel$export(module.exports, "getFlippedElementPositionsAfterUpdate", () => $dc55b72d45ccc6d5$export$df23be7918af8adb);

var $6c6bL = parcelRequire("6c6bL");

var $bgcP7 = parcelRequire("bgcP7");
var $dc55b72d45ccc6d5$var$cancelInProgressAnimations = function cancelInProgressAnimations(inProgressAnimations) {
    Object.keys(inProgressAnimations).forEach(function(id) {
        if (inProgressAnimations[id].stop) inProgressAnimations[id].stop();
        delete inProgressAnimations[id];
    });
};
var $dc55b72d45ccc6d5$var$addTupleToObject = function addTupleToObject(acc, curr) {
    var _assign;
    return (0, $6c6bL.assign)(acc, (_assign = {}, _assign[curr[0]] = curr[1], _assign));
};
var $dc55b72d45ccc6d5$export$b087c5eb899bb598 = function getAllElements(element, portalKey) {
    if (portalKey) return (0, $6c6bL.toArray)(document.querySelectorAll("[" + $bgcP7.DATA_PORTAL_KEY + "=\"" + portalKey + "\"]"));
    else return (0, $6c6bL.toArray)(element.querySelectorAll("[" + $bgcP7.DATA_FLIP_ID + "]"));
};
var $dc55b72d45ccc6d5$export$45700a1d2c971fdb = function getFlippedElementPositionsBeforeUpdate(_ref) {
    var element = _ref.element, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, portalKey = _ref.portalKey;
    var flippedElements = $dc55b72d45ccc6d5$export$b087c5eb899bb598(element, portalKey);
    var inverseFlippedElements = (0, $6c6bL.toArray)(element.querySelectorAll("[" + $bgcP7.DATA_INVERSE_FLIP_ID + "]"));
    var childIdsToParentBCRs = {};
    var parentBCRs = [];
    var childIdsToParents = {};
    // this is for exit animations so we can re-insert exiting elements in the
    // DOM later
    flippedElements.filter(function(el) {
        return flipCallbacks && flipCallbacks[el.dataset.flipId] && flipCallbacks[el.dataset.flipId].onExit;
    }).forEach(function(el) {
        var parent = el.parentNode;
        // this won't work for IE11
        if (el.closest) {
            var exitContainer = el.closest("[" + $bgcP7.DATA_EXIT_CONTAINER + "]");
            if (exitContainer) parent = exitContainer;
        }
        var bcrIndex = parentBCRs.findIndex(function(n) {
            return n[0] === parent;
        });
        if (bcrIndex === -1) {
            parentBCRs.push([
                parent,
                parent.getBoundingClientRect()
            ]);
            bcrIndex = parentBCRs.length - 1;
        }
        childIdsToParentBCRs[el.dataset.flipId] = parentBCRs[bcrIndex][1];
        childIdsToParents[el.dataset.flipId] = parent;
    });
    var flippedElementPositions = flippedElements.map(function(child) {
        var domData = {};
        var childBCR = child.getBoundingClientRect();
        // only cache extra data for exit animations
        // if the element has an onExit listener
        if (flipCallbacks && flipCallbacks[child.dataset.flipId] && flipCallbacks[child.dataset.flipId].onExit) {
            var parentBCR = childIdsToParentBCRs[child.dataset.flipId];
            (0, $6c6bL.assign)(domData, {
                element: child,
                parent: childIdsToParents[child.dataset.flipId],
                childPosition: {
                    top: childBCR.top - parentBCR.top,
                    left: childBCR.left - parentBCR.left,
                    width: childBCR.width,
                    height: childBCR.height
                }
            });
        }
        return [
            child.dataset.flipId,
            {
                rect: childBCR,
                opacity: parseFloat(window.getComputedStyle(child).opacity),
                domData: domData
            }
        ];
    }).reduce($dc55b72d45ccc6d5$var$addTupleToObject, {});
    // do this at the very end since we want to cache positions of elements
    // while they are mid-transition
    $dc55b72d45ccc6d5$var$cancelInProgressAnimations(inProgressAnimations);
    flippedElements.concat(inverseFlippedElements).forEach(function(el) {
        el.style.transform = "";
        el.style.opacity = "";
    });
    return {
        flippedElementPositions: flippedElementPositions,
        cachedOrderedFlipIds: flippedElements.map(function(el) {
            return el.dataset.flipId;
        })
    };
};
var $dc55b72d45ccc6d5$export$df23be7918af8adb = function getFlippedElementPositionsAfterUpdate(_ref2) {
    var element = _ref2.element, portalKey = _ref2.portalKey;
    return $dc55b72d45ccc6d5$export$b087c5eb899bb598(element, portalKey).map(function(child) {
        var computedStyle = window.getComputedStyle(child);
        var rect = child.getBoundingClientRect();
        return [
            child.dataset.flipId,
            {
                rect: rect,
                opacity: parseFloat(computedStyle.opacity),
                domData: {},
                transform: computedStyle.transform
            }
        ];
    }).reduce($dc55b72d45ccc6d5$var$addTupleToObject, {});
};

});



parcelRegister("kxZWm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef56efc8b9537a50$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $ckSCC = parcelRequire("ckSCC");

var $bgcP7 = parcelRequire("bgcP7");

var $6c6bL = parcelRequire("6c6bL");
var $ef56efc8b9537a50$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ef56efc8b9537a50$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ef56efc8b9537a50$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ef56efc8b9537a50$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $ef56efc8b9537a50$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $ef56efc8b9537a50$var$customPropCheck = function customPropCheck(props, propName) {
    if (props.flipId && props.inverseFlipId) return new Error('Please only provide one of the two: "FlipId" or "inverseFlipID"');
    else if (props.flipId === undefined && props.inverseFlipId === undefined) return new Error("Must provide either a \"FlipId\" or an \"InverseFlipId\" prop");
    else if (props[propName] && typeof props[propName] !== "string") return new Error(propName + " must be a string");
};
var $ef56efc8b9537a50$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
    ]).isRequired,
    inverseFlipId: $ef56efc8b9537a50$var$customPropCheck,
    flipId: $ef56efc8b9537a50$var$customPropCheck,
    opacity: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).bool,
    translate: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).bool,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).bool,
    transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).string,
    spring: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).object
    ]),
    onStart: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    onAppear: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    shouldFlip: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    shouldInvert: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func,
    portalKey: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).string,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).bool
    ])
};
function $ef56efc8b9537a50$export$c3816ea9cb166de0(_ref) {
    var _dataAttributes;
    var children = _ref.children, flipId = _ref.flipId, inverseFlipId = _ref.inverseFlipId, portalKey = _ref.portalKey, rest = $ef56efc8b9537a50$var$_objectWithoutProperties(_ref, [
        "children",
        "flipId",
        "inverseFlipId",
        "portalKey"
    ]);
    var child = children;
    var isFunctionAsChildren = typeof child === 'function';
    if (!isFunctionAsChildren) try {
        child = (0, $bSJIT.Children).only(children);
    } catch (e) {
        throw new Error("Each Flipped component must wrap a single child");
    }
    // if nothing is being animated, assume everything is being animated
    if (!rest.scale && !rest.translate && !rest.opacity) (0, $6c6bL.assign)(rest, {
        translate: true,
        scale: true,
        opacity: true
    });
    var dataAttributes = (_dataAttributes = {}, _dataAttributes[$bgcP7.DATA_FLIP_ID] = flipId, _dataAttributes[$bgcP7.DATA_INVERSE_FLIP_ID] = inverseFlipId, _dataAttributes[$bgcP7.DATA_FLIP_CONFIG] = JSON.stringify(rest), _dataAttributes);
    if (portalKey) dataAttributes[$bgcP7.DATA_PORTAL_KEY] = portalKey;
    return isFunctionAsChildren ? child(dataAttributes) : (0, $bSJIT.cloneElement)(child, dataAttributes);
}
var $ef56efc8b9537a50$var$FlippedWithContext = function(_Component) {
    $ef56efc8b9537a50$var$_inherits(FlippedWithContext, _Component);
    function FlippedWithContext() {
        $ef56efc8b9537a50$var$_classCallCheck(this, FlippedWithContext);
        return $ef56efc8b9537a50$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    FlippedWithContext.prototype.render = function render() {
        var _props = this.props, children = _props.children, flipId = _props.flipId, shouldFlip = _props.shouldFlip, shouldInvert = _props.shouldInvert, onAppear = _props.onAppear, onStart = _props.onStart, onComplete = _props.onComplete, onExit = _props.onExit, rest = $ef56efc8b9537a50$var$_objectWithoutProperties(_props, [
            "children",
            "flipId",
            "shouldFlip",
            "shouldInvert",
            "onAppear",
            "onStart",
            "onComplete",
            "onExit"
        ]);
        if (rest.inverseFlipId) return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ef56efc8b9537a50$export$c3816ea9cb166de0, rest, children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ckSCC.PortalContext).Consumer, null, function(portalKey) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ckSCC.FlipContext).Consumer, null, function(data) {
                // if there is no surrounding Flipper component,
                // we don't want to throw an error, so check
                // that data exists and is not the default string
                if ((0, $6c6bL.isObject)(data)) data[flipId] = {
                    shouldFlip: shouldFlip,
                    shouldInvert: shouldInvert,
                    onAppear: onAppear,
                    onStart: onStart,
                    onComplete: onComplete,
                    onExit: onExit
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ef56efc8b9537a50$export$c3816ea9cb166de0, $ef56efc8b9537a50$var$_extends({
                    flipId: flipId
                }, rest, {
                    portalKey: portalKey
                }), children);
            });
        });
    };
    return FlippedWithContext;
}((0, $bSJIT.Component));
$ef56efc8b9537a50$var$FlippedWithContext.propTypes = {};
var $ef56efc8b9537a50$export$2e2bcd8739ae039 = $ef56efc8b9537a50$var$FlippedWithContext;

});

parcelRegister("Nxej4", function(module, exports) {
$parcel$export(module.exports, "default", () => $094e5a74492e0c62$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $bgcP7 = parcelRequire("bgcP7");
var $094e5a74492e0c62$var$ExitContainer = function ExitContainer(_ref) {
    var _cloneElement;
    var children = _ref.children;
    return (0, $bSJIT.cloneElement)(children, (_cloneElement = {}, _cloneElement[0, $bgcP7.DATA_EXIT_CONTAINER] = true, _cloneElement));
};
var $094e5a74492e0c62$export$2e2bcd8739ae039 = $094e5a74492e0c62$var$ExitContainer;

});




parcelRegister("kkzNV", function(module, exports) {
$parcel$export(module.exports, "AutoHeightBody", () => $de09858ddb759853$export$9a6247d807712c45);
$parcel$export(module.exports, "StyledFooter", () => $de09858ddb759853$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");
parcelRequire("9H44a");
var $dCSpQ = parcelRequire("dCSpQ");

var $kKHso = parcelRequire("kKHso");
const $de09858ddb759853$export$9a6247d807712c45 = /*#__PURE__*/ (0, $4v2A7.default)((0, $dCSpQ.default)).withConfig({
    componentId: "sc-vv1aut-0"
})`min-height:100%;height:auto !important;position:relative;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $de09858ddb759853$var$stickyBottom = /*#__PURE__*/ (0, $4v2A7.css)`position:absolute;bottom:0;left:50%;transform:translateX(-50%);`;
const $de09858ddb759853$export$61905ae62c7860fb = /*#__PURE__*/ (0, $4v2A7.default)((0, $kKHso.Footer)).withConfig({
    componentId: "sc-vv1aut-1"
})`${(props)=>props.sticky ? $de09858ddb759853$var$stickyBottom : ''};`;
const $de09858ddb759853$export$2598938b3673d496 = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-vv1aut-2"
})`text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}`;

});

parcelRegister("OK0aw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d770f83dda21eb1b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $1qxfZ = parcelRequire("1qxfZ");
const $d770f83dda21eb1b$var$contentStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1qxfZ.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $d770f83dda21eb1b$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": testId,
        css: $d770f83dda21eb1b$var$contentStyles
    }, children);
};
var $d770f83dda21eb1b$export$2e2bcd8739ae039 = $d770f83dda21eb1b$var$Content;

});

parcelRegister("bSA8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $59a53b2643f77211$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");


var $aXmgv = parcelRequire("aXmgv");

var $1qxfZ = parcelRequire("1qxfZ");

var $fv4ip = parcelRequire("fv4ip");
var $ayD29 = parcelRequire("ayD29");

var $jPKkG = parcelRequire("jPKkG");

var $4eGW1 = parcelRequire("4eGW1");
const $59a53b2643f77211$var$pageLayoutSelector = {
    [(0, $1qxfZ.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $59a53b2643f77211$var$gridTemplateAreasMobile = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $1qxfZ.LEFT_PANEL)} ${(0, $1qxfZ.BANNER)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $1qxfZ.LEFT_PANEL)} ${(0, $1qxfZ.TOP_NAVIGATION)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $1qxfZ.LEFT_PANEL)} ${(0, $1qxfZ.CONTENT)}"
 `;
const $59a53b2643f77211$var$gridTemplateAreas = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $1qxfZ.LEFT_PANEL)} ${(0, $1qxfZ.BANNER)} ${(0, $1qxfZ.RIGHT_PANEL)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $1qxfZ.LEFT_PANEL)} ${(0, $1qxfZ.TOP_NAVIGATION)} ${(0, $1qxfZ.RIGHT_PANEL)}"
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $1qxfZ.LEFT_PANEL)} ${(0, $1qxfZ.CONTENT)} ${(0, $1qxfZ.RIGHT_PANEL)}"
 `;
const $59a53b2643f77211$var$gridStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $59a53b2643f77211$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $1qxfZ.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $1qxfZ.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $1qxfZ.BANNER_HEIGHT)} ${(0, $1qxfZ.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $59a53b2643f77211$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $aXmgv.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $59a53b2643f77211$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $1qxfZ.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $59a53b2643f77211$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $1qxfZ.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    typeof $4eGW1;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $ayD29.SkipLinksController), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jPKkG.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ...$59a53b2643f77211$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $59a53b2643f77211$var$gridStyles,
            $59a53b2643f77211$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fv4ip.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $59a53b2643f77211$export$2e2bcd8739ae039 = $59a53b2643f77211$var$PageLayout;

});
parcelRegister("aXmgv", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $6c2d37aecd66578d$export$c881183ca713c214);

var $4pBHw = parcelRequire("4pBHw");
const $6c2d37aecd66578d$export$c881183ca713c214 = (0, $4pBHw.media);

});
parcelRegister("4pBHw", function(module, exports) {
$parcel$export(module.exports, "media", () => $7e012171623d8380$export$987d49ffe1b0900f);
const $7e012171623d8380$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("fv4ip", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeController", () => $c4c567cc2ba64c2e$export$850bd1bba41f1448);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $1OdZP = parcelRequire("1OdZP");

var $iWZGm = parcelRequire("iWZGm");

var $8m4jB = parcelRequire("8m4jB");

var $1qxfZ = parcelRequire("1qxfZ");

var $aGYdT = parcelRequire("aGYdT");

var $dLRz7 = parcelRequire("dLRz7");
const $c4c567cc2ba64c2e$var$handleDataAttributesAndCb = (callback = (0, $1OdZP.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $1qxfZ.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $c4c567cc2ba64c2e$var$leftSidebarSelector = (0, $aGYdT.getPageLayoutSlotCSSSelector)('left-sidebar');
const $c4c567cc2ba64c2e$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $bSJIT.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $bSJIT.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $bSJIT.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $bSJIT.useRef)(null);
    const mobileMediaQuery = (0, $8m4jB.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $bSJIT.useCallback)(()=>{
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $1qxfZ.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $c4c567cc2ba64c2e$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $1qxfZ.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $c4c567cc2ba64c2e$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($c4c567cc2ba64c2e$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $iWZGm.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $bAB3U.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $bSJIT.useCallback)((_event, collapseWithoutTransition)=>{
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $1qxfZ.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $c4c567cc2ba64c2e$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $1qxfZ.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $1qxfZ.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $c4c567cc2ba64c2e$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($c4c567cc2ba64c2e$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $iWZGm.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $bAB3U.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ const toggleLeftSidebar = (0, $bSJIT.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $bSJIT.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    const context = (0, $bSJIT.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: // Technically this isn't quite true, but with mobile it's a bit safer if apps are using this to roll their own collapse/expand
            expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dLRz7.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});
parcelRegister("8m4jB", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $2c6a4ba5bf3eeafb$export$49e55ae2c03d6045);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $ghAbV = parcelRequire("ghAbV");

var $aXmgv = parcelRequire("aXmgv");
var $2c6a4ba5bf3eeafb$var$_window, $2c6a4ba5bf3eeafb$var$_window$matchMedia, $2c6a4ba5bf3eeafb$var$_window2, $2c6a4ba5bf3eeafb$var$_window2$matchMedia, $2c6a4ba5bf3eeafb$var$_window3, $2c6a4ba5bf3eeafb$var$_window3$matchMedia, $2c6a4ba5bf3eeafb$var$_window4, $2c6a4ba5bf3eeafb$var$_window4$matchMedia, $2c6a4ba5bf3eeafb$var$_window5, $2c6a4ba5bf3eeafb$var$_window5$matchMedia, $2c6a4ba5bf3eeafb$var$_window6, $2c6a4ba5bf3eeafb$var$_window6$matchMedia, $2c6a4ba5bf3eeafb$var$_window7, $2c6a4ba5bf3eeafb$var$_window7$matchMedia, $2c6a4ba5bf3eeafb$var$_window8, $2c6a4ba5bf3eeafb$var$_window8$matchMedia, $2c6a4ba5bf3eeafb$var$_window9, $2c6a4ba5bf3eeafb$var$_window9$matchMedia, $2c6a4ba5bf3eeafb$var$_window0, $2c6a4ba5bf3eeafb$var$_window0$matchMedia, $2c6a4ba5bf3eeafb$var$_window1, $2c6a4ba5bf3eeafb$var$_window1$matchMedia;
const $2c6a4ba5bf3eeafb$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window = window) === null || $2c6a4ba5bf3eeafb$var$_window === void 0 || ($2c6a4ba5bf3eeafb$var$_window$matchMedia = $2c6a4ba5bf3eeafb$var$_window.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window$matchMedia.call($2c6a4ba5bf3eeafb$var$_window, (0, $aXmgv.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window2 = window) === null || $2c6a4ba5bf3eeafb$var$_window2 === void 0 || ($2c6a4ba5bf3eeafb$var$_window2$matchMedia = $2c6a4ba5bf3eeafb$var$_window2.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window2$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window2$matchMedia.call($2c6a4ba5bf3eeafb$var$_window2, (0, $aXmgv.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window3 = window) === null || $2c6a4ba5bf3eeafb$var$_window3 === void 0 || ($2c6a4ba5bf3eeafb$var$_window3$matchMedia = $2c6a4ba5bf3eeafb$var$_window3.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window3$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window3$matchMedia.call($2c6a4ba5bf3eeafb$var$_window3, (0, $aXmgv.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window4 = window) === null || $2c6a4ba5bf3eeafb$var$_window4 === void 0 || ($2c6a4ba5bf3eeafb$var$_window4$matchMedia = $2c6a4ba5bf3eeafb$var$_window4.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window4$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window4$matchMedia.call($2c6a4ba5bf3eeafb$var$_window4, (0, $aXmgv.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window5 = window) === null || $2c6a4ba5bf3eeafb$var$_window5 === void 0 || ($2c6a4ba5bf3eeafb$var$_window5$matchMedia = $2c6a4ba5bf3eeafb$var$_window5.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window5$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window5$matchMedia.call($2c6a4ba5bf3eeafb$var$_window5, (0, $aXmgv.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window6 = window) === null || $2c6a4ba5bf3eeafb$var$_window6 === void 0 || ($2c6a4ba5bf3eeafb$var$_window6$matchMedia = $2c6a4ba5bf3eeafb$var$_window6.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window6$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window6$matchMedia.call($2c6a4ba5bf3eeafb$var$_window6, (0, $aXmgv.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window7 = window) === null || $2c6a4ba5bf3eeafb$var$_window7 === void 0 || ($2c6a4ba5bf3eeafb$var$_window7$matchMedia = $2c6a4ba5bf3eeafb$var$_window7.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window7$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window7$matchMedia.call($2c6a4ba5bf3eeafb$var$_window7, (0, $aXmgv.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window8 = window) === null || $2c6a4ba5bf3eeafb$var$_window8 === void 0 || ($2c6a4ba5bf3eeafb$var$_window8$matchMedia = $2c6a4ba5bf3eeafb$var$_window8.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window8$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window8$matchMedia.call($2c6a4ba5bf3eeafb$var$_window8, (0, $aXmgv.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window9 = window) === null || $2c6a4ba5bf3eeafb$var$_window9 === void 0 || ($2c6a4ba5bf3eeafb$var$_window9$matchMedia = $2c6a4ba5bf3eeafb$var$_window9.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window9$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window9$matchMedia.call($2c6a4ba5bf3eeafb$var$_window9, (0, $aXmgv.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window0 = window) === null || $2c6a4ba5bf3eeafb$var$_window0 === void 0 || ($2c6a4ba5bf3eeafb$var$_window0$matchMedia = $2c6a4ba5bf3eeafb$var$_window0.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window0$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window0$matchMedia.call($2c6a4ba5bf3eeafb$var$_window0, (0, $aXmgv.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($2c6a4ba5bf3eeafb$var$_window1 = window) === null || $2c6a4ba5bf3eeafb$var$_window1 === void 0 || ($2c6a4ba5bf3eeafb$var$_window1$matchMedia = $2c6a4ba5bf3eeafb$var$_window1.matchMedia) === null || $2c6a4ba5bf3eeafb$var$_window1$matchMedia === void 0 ? void 0 : $2c6a4ba5bf3eeafb$var$_window1$matchMedia.call($2c6a4ba5bf3eeafb$var$_window1, (0, $aXmgv.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $2c6a4ba5bf3eeafb$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $bSJIT.useRef)(listener);
    (0, $bSJIT.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $2c6a4ba5bf3eeafb$var$queries[queryString];
    (0, $ghAbV.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $bAB3U.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("aGYdT", function(module, exports) {
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $95569e21f9998316$export$218ece2c32b7db0e);

var $1qxfZ = parcelRequire("1qxfZ");
const $95569e21f9998316$export$218ece2c32b7db0e = (slotName)=>`[${0, $1qxfZ.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});


parcelRegister("ayD29", function(module, exports) {
$parcel$export(module.exports, "SkipLinksController", () => $e1be9e12aeda065d$export$da7be99d6a868f3d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1qxfZ = parcelRequire("1qxfZ");

var $beCkl = parcelRequire("beCkl");
const $e1be9e12aeda065d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $1qxfZ.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $e1be9e12aeda065d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $bSJIT.useState)([]);
    const registerSkipLink = (0, $bSJIT.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($e1be9e12aeda065d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $bSJIT.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $beCkl.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("jPKkG", function(module, exports) {
$parcel$export(module.exports, "SkipLinkWrapper", () => $5351ce288a6ccd59$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $fg2GS = parcelRequire("fg2GS");

var $a05li = parcelRequire("a05li");

var $1qxfZ = parcelRequire("1qxfZ");

var $khQPO = parcelRequire("khQPO");

var $hhj5q = parcelRequire("hhj5q");
function $5351ce288a6ccd59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5351ce288a6ccd59$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $9dQre.css)((0, $a05li.prefersReducedMotion)());
const $5351ce288a6ccd59$var$skipLinkStyles = /*#__PURE__*/ (0, $9dQre.css)({
    margin: "var(--ds-space-250, 20px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $fg2GS.easeOut)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $5351ce288a6ccd59$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $5351ce288a6ccd59$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $5351ce288a6ccd59$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $5351ce288a6ccd59$var$assignIndex(num + 1, arr);
};
const $5351ce288a6ccd59$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $khQPO.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $5351ce288a6ccd59$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $1qxfZ.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    const label = skipLinksLabel || (0, $1qxfZ.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $5351ce288a6ccd59$var$skipLinkStyles,
            $5351ce288a6ccd59$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $9dQre.jsx)("p", {
        css: $5351ce288a6ccd59$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $9dQre.jsx)("ol", {
        css: $5351ce288a6ccd59$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $hhj5q.SkipLink), {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};

});
parcelRegister("hhj5q", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $9a61ff57f409b18b$export$ef95c37428582a65);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $9Rfip = parcelRequire("9Rfip");
function $9a61ff57f409b18b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9a61ff57f409b18b$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $9a61ff57f409b18b$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $9a61ff57f409b18b$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("li", {
        css: $9a61ff57f409b18b$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $9Rfip.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $9a61ff57f409b18b$var$focusTargetRef(href)
    }, children));
};

});



parcelRegister("gwMCf", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoizedHOC", () => $ee4e7d3deae4a204$export$f0da0221ee5515ac);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $B6yjo = parcelRequire("B6yjo");
const $ee4e7d3deae4a204$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getThemeColor), (0, $hvIQS.getHelpCenterBrandingLoader), (0, $hvIQS.getHelpCenterTopBarSplitFlag), (themeColor, isBrandingLoaded, hasTopBarBeenSplit)=>({
        themeColor: themeColor,
        isBrandingLoaded: isBrandingLoaded,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
const $ee4e7d3deae4a204$var$ConnectedBannerWithLayoutHeader = (0, $f2mlD.default)($ee4e7d3deae4a204$var$selector)((0, $B6yjo.BannerWithLayoutHeader));
var $ee4e7d3deae4a204$export$2e2bcd8739ae039 = $ee4e7d3deae4a204$var$ConnectedBannerWithLayoutHeader;
const $ee4e7d3deae4a204$export$f0da0221ee5515ac = (0, $f2mlD.default)($ee4e7d3deae4a204$var$selector)((0, $B6yjo.BannerWithLayoutHeaderMemoized));

});
parcelRegister("B6yjo", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeader", () => $e768d5e08e8bcfe5$export$dc6fa5f6f452943b);
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoized", () => $e768d5e08e8bcfe5$export$2e33b09d9c57faa1);
/* banner-with-layout-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $lFpPv = parcelRequire("lFpPv");

var $hF8Ik = parcelRequire("hF8Ik");

var $9K7mZ = parcelRequire("9K7mZ");

var $1DDTY = parcelRequire("1DDTY");
parcelRequire("7OG9m");
var $iBxSu = parcelRequire("iBxSu");
parcelRequire("7wH5B");
var $30arO = parcelRequire("30arO");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $1qPbZ = parcelRequire("1qPbZ");
const $e768d5e08e8bcfe5$export$ed7cc0d417ee89e = $9K7mZ.unitless * 23; // 184
const $e768d5e08e8bcfe5$export$6ba969052247c298 = $9K7mZ.unitless * 23 + (0, $1DDTY.HEADER_HEIGHT); // 240
const $e768d5e08e8bcfe5$export$87562042682a224f = $9K7mZ.unitless * 37; // 296
const $e768d5e08e8bcfe5$export$f6510fb522c3cc26 = 300;
const $e768d5e08e8bcfe5$export$5c538a381f9a90ef = $9K7mZ.unitless * 22; // 176
const $e768d5e08e8bcfe5$var$BANNER_WITH_REDUCED_HEIGHT = 152;
const $e768d5e08e8bcfe5$export$60963c14ec4e3ee7 = 'layout-banner';
const $e768d5e08e8bcfe5$export$dc6fa5f6f452943b = ({ themeColor: themeColor, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, isBrandingLoaded: isBrandingLoaded, hideBanner: hideBanner, prefetchBrandingModel: prefetchBrandingModel, hasTopBarBeenSplit: hasTopBarBeenSplit, renderForPaperLayout: renderForPaperLayout })=>{
    // Update CSS variable when helpCenterBanner changes
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty('--banner-bg-image', helpCenterBanner ? `url(${helpCenterBanner})` : 'none');
    }, [
        helpCenterBanner
    ]);
    let updatedBannerHeight = hasTopBarBeenSplit ? $e768d5e08e8bcfe5$export$ed7cc0d417ee89e : $e768d5e08e8bcfe5$var$BANNER_WITH_REDUCED_HEIGHT;
    if (renderForPaperLayout) updatedBannerHeight = hasTopBarBeenSplit ? $e768d5e08e8bcfe5$export$f6510fb522c3cc26 : $e768d5e08e8bcfe5$export$87562042682a224f + (0, $1DDTY.HEADER_HEIGHT); // in login page we render paper layout
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) updatedBannerHeight = $e768d5e08e8bcfe5$var$BANNER_WITH_REDUCED_HEIGHT;
    const bannerCustomProp = {
        style: {
            height: `${updatedBannerHeight}px`,
            backgroundColor: themeColor,
            backgroundImage: 'var(--banner-bg-image)',
            borderRadius: hasTopBarBeenSplit ? "var(--ds-radius-large, 8px)" : 'initial'
        }
    };
    const showBannerWithLoader = ()=>{
        if (hideBanner) return null;
        if ((0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $e768d5e08e8bcfe5$var$bannerContainerStyleWithReducedHeight
        }, isBrandingLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            "data-testId": $e768d5e08e8bcfe5$export$60963c14ec4e3ee7,
            xcss: $e768d5e08e8bcfe5$var$bannerStyle,
            ...bannerCustomProp
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
        const bannerContainerCustomPropPaperLayout = {
            style: {
                height: `${updatedBannerHeight + (hasTopBarBeenSplit ? 16 : 0) * 2}px`,
                top: renderForPaperLayout && hasTopBarBeenSplit ? `${0, $1DDTY.HEADER_HEIGHT}px` : 'initial',
                bottom: renderForPaperLayout ? 'initial' : 0,
                paddingTop: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingBottom: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingLeft: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)",
                paddingRight: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)"
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e768d5e08e8bcfe5$var$BannerContainer, {
            ...bannerContainerCustomPropPaperLayout,
            "data-testid": 'BannerContainer'
        }, !isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })), isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e768d5e08e8bcfe5$var$BannerStyleWithImage, {
            "data-testid": $e768d5e08e8bcfe5$export$60963c14ec4e3ee7,
            ...bannerCustomProp
        }));
    };
    let containerHeight = renderForPaperLayout ? (0, $1DDTY.HEADER_HEIGHT) : $e768d5e08e8bcfe5$var$BANNER_WITH_REDUCED_HEIGHT;
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) containerHeight = (0, $1DDTY.HEADER_HEIGHT) + $e768d5e08e8bcfe5$var$BANNER_WITH_REDUCED_HEIGHT + 32;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e768d5e08e8bcfe5$var$Container, {
        "data-testid": 'outer-BannerContainer',
        style: {
            height: removeHeader || headerless || hideBanner ? 'auto' : `${containerHeight}px`
        }
    }, showBannerWithLoader(), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $30arO.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e768d5e08e8bcfe5$var$HeaderContainerStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iBxSu.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    })), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e768d5e08e8bcfe5$var$EmptyHeader, {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            height: `${(0, $1DDTY.HEADER_HEIGHT)}px`
        }
    }));
};
const $e768d5e08e8bcfe5$export$2e33b09d9c57faa1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($e768d5e08e8bcfe5$export$dc6fa5f6f452943b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e768d5e08e8bcfe5$var$Container = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $e768d5e08e8bcfe5$var$BannerStyleWithImage = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1bsb1osq _4t3i1osq _1lrw1dfr _12vemgnk _ouxl1ssb _bfhk1pom _1itk8q6q",
            __cmplp.className
        ])
    });
});
const $e768d5e08e8bcfe5$var$BannerContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswstnw _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $e768d5e08e8bcfe5$var$bannerContainerStyleWithReducedHeight = (0, $9BVpB.xcss)({
    position: 'absolute',
    width: '100%',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.400',
    paddingRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    bottom: 'space.0',
    height: `${$e768d5e08e8bcfe5$var$BANNER_WITH_REDUCED_HEIGHT + 32}px`
});
const $e768d5e08e8bcfe5$var$bannerStyle = (0, $9BVpB.xcss)({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: 'radius.large',
    backgroundColor: 'color.background.brand.bold'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e768d5e08e8bcfe5$var$HeaderContainerStyle = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswh2mm _1pbykuz3",
            __cmplp.className
        ])
    });
});
const $e768d5e08e8bcfe5$var$EmptyHeader = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7OG9m", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("iBxSu")).default);

var $iBxSu = parcelRequire("iBxSu");

});
parcelRegister("iBxSu", function(module, exports) {
$parcel$export(module.exports, "default", () => $20f3a49cc6f66b52$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $iCbt2 = parcelRequire("iCbt2");

var $hF8Ik = parcelRequire("hF8Ik");

var $3kyZk = parcelRequire("3kyZk");

var $2fYPj = parcelRequire("2fYPj");

var $jSu8y = parcelRequire("jSu8y");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("38uh5");
var $8vt1A = parcelRequire("8vt1A");
parcelRequire("hA56G");
var $dRjS6 = parcelRequire("dRjS6");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("hGqAv");
var $egJeM = parcelRequire("egJeM");

var $1DDTY = parcelRequire("1DDTY");

var $1qPbZ = parcelRequire("1qPbZ");

var $hCnLH = parcelRequire("hCnLH");

var $oORS9 = parcelRequire("oORS9");
parcelRequire("gXTTj");
var $emNqx = parcelRequire("emNqx");
const $20f3a49cc6f66b52$var$getHeaderLoginUrl = (state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    return (0, $oORS9.getLoginUrl)({
        portalId: portalId,
        isAbsolute: true,
        redirectUrl: (0, $9Yoxp.getPathname)(state)
    });
};
const $20f3a49cc6f66b52$var$userRequestsSelector = (state)=>{
    return (0, $egJeM.getUserRequestsCounts)(state);
};
const $20f3a49cc6f66b52$var$selector = (0, $BOq7h.createSelector)((0, $fBLyB.isLoggedIn), $20f3a49cc6f66b52$var$getHeaderLoginUrl, (0, $fBLyB.isUserLoaded), (0, $8vt1A.isCustomizing), $20f3a49cc6f66b52$var$userRequestsSelector, (0, $dRjS6.getOrganisations), (0, $fOlM6.getIsAnonymousEnabled), (0, $hvIQS.getHelpCenterBrandingLoader), (0, $hvIQS.getHelpCenterTopBarColor), (0, $hvIQS.getHelpCenterTopBarSplitFlag), (0, $hvIQS.getLogoUrl), (0, $hvIQS.getSharedPortalName), (userLoggedIn, loginUrl, userLoaded, customizing, userRequest, organisations, anonymousEnabled, isBrandingLoaded, topBarColor, hasTopBarBeenSplit, logoUrl, name)=>({
        userLoggedIn: userLoggedIn,
        loginUrl: loginUrl,
        userRequest: userRequest,
        organisations: organisations,
        anonymousEnabled: anonymousEnabled,
        name: name,
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded,
        isCustomizing: customizing,
        headerBackgroundColor: hasTopBarBeenSplit ? topBarColor : undefined,
        logoUrl: logoUrl ?? undefined
    }));
class $20f3a49cc6f66b52$var$Header extends $bSJIT.Component {
    componentDidMount() {
        if (!this.props.isModelCallPrefetched) {
            if (!(0, $hCnLH.isHelpCentersManagement)()) this.props.fetchBranding();
            if (!this.props.isAnonymous) {
                this.props.fetchUser();
                this.props.fetchOrganisations();
                this.props.fetchUserRequestsCounts();
            }
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous && !this.props.isModelCallPrefetched) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)() && !(0, $hCnLH.isHelpCentersManagement)()) {
            if (this.props.isBrandingLoaded) return /*#__PURE__*/ $bSJIT.createElement((0, $emNqx.default), this.props);
            return /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
                name: "header-loader"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $hF8Ik.LoadingSkeleton), {
                "data-testid": "header-skeleton",
                height: (0, $1DDTY.HEADER_HEIGHT),
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        }
        return /*#__PURE__*/ $bSJIT.createElement((0, $emNqx.default), this.props);
    }
}
var $20f3a49cc6f66b52$export$2e2bcd8739ae039 = (0, $f2mlD.default)($20f3a49cc6f66b52$var$selector, {
    fetchBranding: (0, $3kyZk.fetchHelpCenterBrandingAction),
    fetchUser: (0, $iCbt2.fetchUserModelAction),
    fetchOrganisations: (0, $2fYPj.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $jSu8y.fetchUserRequestsCountsAction)
})($20f3a49cc6f66b52$var$Header);

});
parcelRegister("38uh5", function(module, exports) {
$parcel$export(module.exports, "isAnyUploadInProgress", () => (parcelRequire("8vt1A")).isAnyUploadInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("8vt1A")).isCustomizing);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("8vt1A")).isSaveInProgress);
$parcel$export(module.exports, "isUploadInProgress", () => (parcelRequire("8vt1A")).isUploadInProgress);
parcelRequire("8vt1A");

});
parcelRegister("8vt1A", function(module, exports) {
$parcel$export(module.exports, "isCustomizing", () => $aee37b86a3e5af95$export$ce3eed7c98304744);
$parcel$export(module.exports, "isSaveInProgress", () => $aee37b86a3e5af95$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isUploadInProgress", () => $aee37b86a3e5af95$export$cf866b9449681342);
$parcel$export(module.exports, "isAnyUploadInProgress", () => $aee37b86a3e5af95$export$4dfd840e8ddac89d);
const $aee37b86a3e5af95$export$ce3eed7c98304744 = (state)=>state.ui.helpCenterPreview.isCustomizing;
const $aee37b86a3e5af95$export$2b75ac2de7a23db1 = (state)=>state.ui.helpCenterPreview.isSaveInProgress;
const $aee37b86a3e5af95$export$cf866b9449681342 = (state, fileCollection)=>!!state.ui.helpCenterPreview.uploadsInProgress[fileCollection];
const $aee37b86a3e5af95$export$4dfd840e8ddac89d = (state)=>{
    const { uploadsInProgress: uploadsInProgress } = state.ui.helpCenterPreview;
    return Object.keys(uploadsInProgress).find((uploadKey)=>uploadsInProgress[uploadKey]) !== undefined;
};

});


parcelRegister("hA56G", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("dRjS6")).getOrganisations);

var $dRjS6 = parcelRequire("dRjS6");

});
parcelRegister("dRjS6", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => $6b67f776d327756b$export$17495f9c20464b8);
const $6b67f776d327756b$export$17495f9c20464b8 = (state)=>state.persisted.organisations.organisations;

});


parcelRegister("hGqAv", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => (parcelRequire("egJeM")).getUserRequestsCounts);

var $egJeM = parcelRequire("egJeM");

});
parcelRegister("egJeM", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $8b8e152da382ac72$export$be73da9c8fdefffb);
const $8b8e152da382ac72$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});


parcelRegister("gXTTj", function(module, exports) {
$parcel$export(module.exports, "DumbHeader", () => (parcelRequire("emNqx")).default);

var $emNqx = parcelRequire("emNqx");

});
parcelRegister("emNqx", function(module, exports) {
$parcel$export(module.exports, "default", () => $771cbcf1a4ae8bde$export$2e2bcd8739ae039);
/** @jsxFrag React.Fragment */ 
var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $97yQ5 = parcelRequire("97yQ5");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
parcelRequire("6mHzB");
var $93VeQ = parcelRequire("93VeQ");

var $1DDTY = parcelRequire("1DDTY");

var $dwOcU = parcelRequire("dwOcU");

var $10HUP = parcelRequire("10HUP");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $1qPbZ = parcelRequire("1qPbZ");

var $kWBbO = parcelRequire("kWBbO");
parcelRequire("25Mnh");
var $83t8i = parcelRequire("83t8i");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $oORS9 = parcelRequire("oORS9");
parcelRequire("egy8t");
var $5XH4p = parcelRequire("5XH4p");
parcelRequire("k9dqZ");
var $1jNFB = parcelRequire("1jNFB");
parcelRequire("a4I38");
var $3NVdr = parcelRequire("3NVdr");

var $lxMCu = parcelRequire("lxMCu");
const $771cbcf1a4ae8bde$var$Header = ({ isAnonymous: isAnonymous, isUserLoaded: isUserLoaded, userLoggedIn: userLoggedIn, loginUrl: loginUrl, logoTextColor: logoTextColor, hideSearchButton: hideSearchButton, anonymousEnabled: anonymousEnabled, showThemedBackground: showThemedBackground, disableAllHeaderLinks: disableAllHeaderLinks, headerBackgroundColor: headerBackgroundColor, logoUrl: logoUrl, name: name })=>{
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const showPortalLink = isCSM ? !!logoUrl : true;
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const defaultLoginUrl = `/user/login?destination=${(0, $oORS9.getHelpCenterUrl)().replace(/\//g, '')}`;
    const authenticatedNavLinks = $bSJIT.useMemo(()=>/*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, (0, $lFpPv.isVirtualAgentHeaderButtonEnabled)() && !isCSM && /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'virtualAgentHeaderButton'
        }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $bSJIT.createElement((0, $3NVdr.default), {
            portalId: portalId ?? ''
        })))), /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavItem, null, /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'customizeMenu'
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1jNFB.default), {
            disableCustomiseMenu: disableAllHeaderLinks
        }))), isCSM && /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            packageName: "viewLayoutHeaderDumb",
            id: "CsmRequestsHeaderLink"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
            xcss: $771cbcf1a4ae8bde$var$requestsLinkStyles
        }, /*#__PURE__*/ $bSJIT.createElement((0, $kWBbO.CsmRequestsHeaderLink), null)))), /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavItem, null, /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: {
                actionSubjectId: 'navbarAvatar'
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $83t8i.default), {
            disableAvatarMenu: disableAllHeaderLinks
        })))), [
        disableAllHeaderLinks,
        isCSM,
        portalId
    ]);
    const unauthenticatedNavLinks = /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavItem, {
        role: "listitem"
    }, /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$export$7d5b37ae6eb004e5, null, /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$LoginButton, {
        href: loginUrl ? loginUrl : defaultLoginUrl,
        actionSubjectId: "navbarLogin"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $lxMCu.default).login))));
    const anonymousAccessNotEnbledAndUserNotLoggedIn = !(!!anonymousEnabled || !!userLoggedIn);
    let portalLinkUrl;
    let portalLinkAriaLabel;
    if (isAnonymous || anonymousAccessNotEnbledAndUserNotLoggedIn) {
        portalLinkUrl = defaultLoginUrl;
        portalLinkAriaLabel = formatMessage((0, $lxMCu.default).helpCenter);
    } else {
        portalLinkUrl = (0, $oORS9.getHelpCenterUrl)();
        portalLinkAriaLabel = name ? name : formatMessage((0, $lxMCu.default).helpCenter);
    }
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            source: 'navbar'
        }
    }, /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$Root, {
        showThemedBackground: Boolean(showThemedBackground),
        headerBackgroundColor: headerBackgroundColor
    }, showPortalLink && /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$PortalLink, {
        to: portalLinkUrl,
        logoTextColor: logoTextColor,
        actionSubjectId: "navbarHelpCenter",
        disabled: Boolean(disableAllHeaderLinks),
        tabIndex: disableAllHeaderLinks ? -1 : undefined,
        "aria-label": portalLinkAriaLabel
    }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Suspense, {
        fallback: /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
            name: "header-dumb-logo-fallback"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $10HUP.default), {
            appearance: "square",
            size: "medium"
        }))
    }, /*#__PURE__*/ $bSJIT.createElement((0, $93VeQ.LogoMemoizedHOC), null))), /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$Nav, null, /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavList, {
        role: "list"
    }, isUserLoaded && /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, hideSearchButton || /*#__PURE__*/ $bSJIT.createElement($771cbcf1a4ae8bde$var$NavItem, {
        role: "listitem"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5XH4p.default), {
        trigger: "icon",
        disableSearch: disableAllHeaderLinks
    })), userLoggedIn ? authenticatedNavLinks : unauthenticatedNavLinks)))));
};
var $771cbcf1a4ae8bde$export$2e2bcd8739ae039 = $771cbcf1a4ae8bde$var$Header;
// Nav line height set to 0 so it is correctly vertically aligned.
const $771cbcf1a4ae8bde$var$NAV_LINE_HEIGHT = 0;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $771cbcf1a4ae8bde$var$Root = /*#__PURE__*/ (0, $4v2A7.default).header.withConfig({
    componentId: "sc-l83nge-0"
})`display:flex;justify-content:space-between;align-items:center;${()=>{
    if ((0, $lFpPv.isUseHelpCenterRefresh)()) return `
                padding-left: ${"var(--ds-space-200, 16px)"};
            `;
    return `
            padding-left: ${"var(--ds-space-100, 8px)"};
            `;
}} padding-right:${"var(--ds-space-100, 8px)"};height:${(0, $1DDTY.HEADER_HEIGHT)}px;overflow:hidden;${(props)=>{
    if (props.headerBackgroundColor) return props.headerBackgroundColor ? `background-color: ${props.headerBackgroundColor}` : '';
    return props.showThemedBackground ? `background-color: ${props.theme.color}` : '';
}}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve,rulesdir/styled-component-order
const $771cbcf1a4ae8bde$var$Nav = /*#__PURE__*/ (0, $4v2A7.default).nav.withConfig({
    componentId: "sc-l83nge-1"
})`line-height:${$771cbcf1a4ae8bde$var$NAV_LINE_HEIGHT};margin-left:auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $771cbcf1a4ae8bde$var$NavList = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l83nge-2"
})`margin:0;padding:0;display:flex;align-items:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $771cbcf1a4ae8bde$var$NavItem = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l83nge-3"
})`display:inline;margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $771cbcf1a4ae8bde$var$LoginButton = /*#__PURE__*/ (0, $4v2A7.default)((props)=>/*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), props)).withConfig({
    componentId: "sc-l83nge-4"
})`&&{padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};}`;
const $771cbcf1a4ae8bde$export$7d5b37ae6eb004e5 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l83nge-5"
})`${$fU62V.subtleThemeColorBackground};border:${"var(--ds-border-width-selected, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"} solid;border-radius:${$9K7mZ.multiple(2).px};margin-left:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $771cbcf1a4ae8bde$var$PortalLink = /*#__PURE__*/ (0, $4v2A7.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
({ logoTextColor: logoTextColor, ...props })=>// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $bSJIT.createElement((0, $2OuWT.Link), props)).attrs({
    className: 'cv-exclude-from-customisation'
}).withConfig({
    componentId: "sc-l83nge-6"
})`color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};}pointer-events:${(props)=>props.disabled ? 'none' : 'auto'};`;
const $771cbcf1a4ae8bde$var$requestsLinkStyles = (0, $9BVpB.xcss)({
    marginInlineEnd: 'space.075'
});

});
parcelRegister("6mHzB", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => (parcelRequire("93VeQ")).LogoMemoizedHOC);

var $93VeQ = parcelRequire("93VeQ");

});
parcelRegister("93VeQ", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => $a46656fc67440ed8$export$299f731b9b12cd90);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $iqfNd = parcelRequire("iqfNd");
const $a46656fc67440ed8$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getLogoUrl), (0, $hvIQS.getSharedPortalName), (0, $hvIQS.getHelpCenterTopBarTextColor), (0, $hvIQS.getHelpCenterTopBarSplitFlag), (url, name, topBarTextColor, hasTopBarBeenSplit)=>({
        url: url,
        name: name,
        topBarTextColor: hasTopBarBeenSplit ? topBarTextColor : undefined
    }));
const $a46656fc67440ed8$export$299f731b9b12cd90 = (0, $f2mlD.default)($a46656fc67440ed8$var$selector)((0, $iqfNd.LogoMemoized));
var $a46656fc67440ed8$export$2e2bcd8739ae039 = (0, $f2mlD.default)($a46656fc67440ed8$var$selector)((0, $iqfNd.Logo));

});
parcelRegister("iqfNd", function(module, exports) {
$parcel$export(module.exports, "Logo", () => $882092959c6fa352$export$e6ff31bff12b7ff4);
$parcel$export(module.exports, "LogoMemoized", () => $882092959c6fa352$export$acb5f09fe495ae97);

var $gIga8 = parcelRequire("gIga8");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $dhoMU = parcelRequire("dhoMU");

var $a2qIF = parcelRequire("a2qIF");

var $1qPbZ = parcelRequire("1qPbZ");

var $hCnLH = parcelRequire("hCnLH");

var $4fhUT = parcelRequire("4fhUT");
parcelRequire("iaSAv");
var $cUAw6 = parcelRequire("cUAw6");
const $882092959c6fa352$export$e6ff31bff12b7ff4 = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    var _helpCenter$helpCente, _helpCenter$helpCente2;
    const isFetchingData = (0, $lFpPv.isCustomThemingEnabled)();
    const [stateUrl, setStateUrl] = $bSJIT.useState('');
    const [shouldHoldUFO, setShouldHoldUFO] = $bSJIT.useState(true);
    const { helpCenter: helpCenter } = (0, $a2qIF.useLazyLoadQuery)((0, $gIga8.default), {
        cloudId: (0, $fuVmc.getCloudId)(),
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        skip: !isFetchingData
    });
    const advancedName = (helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente = helpCenter.helpCenterById) === null || _helpCenter$helpCente === void 0 || (_helpCenter$helpCente = _helpCenter$helpCente.name) === null || _helpCenter$helpCente === void 0 ? void 0 : _helpCenter$helpCente.default) || name;
    const advancedUrl = helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente2 = helpCenter.helpCenterById) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.helpCenterBranding) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.logo) === null || _helpCenter$helpCente2 === void 0 ? void 0 : _helpCenter$helpCente2.url;
    $bSJIT.useEffect(()=>{
        if (!isFetchingData && url && !url.startsWith('blob:')) (0, $4fhUT.getObjectURLFromMediaURLWithCaching)(url).then(setStateUrl).catch(()=>setStateUrl('')).finally(()=>setShouldHoldUFO(false));
        else {
            setStateUrl(url || '');
            setShouldHoldUFO(false);
        }
    }, [
        url,
        isFetchingData
    ]);
    const isHelpCentersManagementPage = (0, $hCnLH.isHelpCentersManagement)();
    const getUrl = $bSJIT.useCallback(()=>{
        if (isFetchingData) return advancedUrl;
        if (isHelpCentersManagementPage) return 0, (/*@__PURE__*/$parcel$interopDefault($dhoMU));
        return stateUrl;
    }, [
        advancedUrl,
        isFetchingData,
        isHelpCentersManagementPage,
        stateUrl
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, shouldHoldUFO && /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
        name: "help-center-common-logo"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $cUAw6.default), {
        url: getUrl(),
        name: advancedName,
        topBarTextColor: topBarTextColor
    }));
};
const $882092959c6fa352$export$acb5f09fe495ae97 = /*#__PURE__*/ $bSJIT.memo($882092959c6fa352$export$e6ff31bff12b7ff4);

});
parcelRegister("gIga8", function(module, exports) {
$parcel$export(module.exports, "default", () => $05a162c2d73255cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c8437f71d8ffa7c62d1c0fe41e32f02>>
 * @relayHash 89b5ac4560edc5779e88acaa2f693808
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360
const $05a162c2d73255cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360",
            "metadata": {},
            "name": "logoQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$05a162c2d73255cc$var$node.hash = "50f3d8eb5808e1ee69db4f8e639d0b3e";
var $05a162c2d73255cc$export$2e2bcd8739ae039 = $05a162c2d73255cc$var$node;

});

parcelRegister("dhoMU", function(module, exports) {
module.exports = new URL("../images/atlassian-icon.632e3804.png", import.meta.url).toString();

});

parcelRegister("iaSAv", function(module, exports) {
$parcel$export(module.exports, "LogoStateless", () => (parcelRequire("cUAw6")).default);

var $cUAw6 = parcelRequire("cUAw6");

});
parcelRegister("cUAw6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebd1df2827a9edf3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9K7mZ = parcelRequire("9K7mZ");
const $ebd1df2827a9edf3$var$LogoStateless = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    const content = url ? /*#__PURE__*/ $bSJIT.createElement($ebd1df2827a9edf3$var$ImageStyled, {
        src: url,
        alt: name
    }) : /*#__PURE__*/ $bSJIT.createElement("span", null, name);
    return /*#__PURE__*/ $bSJIT.createElement($ebd1df2827a9edf3$var$RootStyled, {
        topBarTextColor: topBarTextColor
    }, content);
};
var $ebd1df2827a9edf3$export$2e2bcd8739ae039 = $ebd1df2827a9edf3$var$LogoStateless;
const $ebd1df2827a9edf3$var$imageHeight = $9K7mZ.unitless * 5;
// Styled-components version (legacy)
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ebd1df2827a9edf3$var$RootStyled = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-prcwi5-0"
})`height:${$ebd1df2827a9edf3$var$imageHeight}px;display:inline-flex;align-items:center;justify-content:center;padding:${"var(--ds-space-075, 6px)"};font-weight:600;color:${(props)=>props.topBarTextColor || 'inherit'};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ebd1df2827a9edf3$var$ImageStyled = /*#__PURE__*/ (0, $4v2A7.default).img.withConfig({
    componentId: "sc-prcwi5-1"
})`height:${$ebd1df2827a9edf3$var$imageHeight}px;`;

});





parcelRegister("kWBbO", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsHeaderLink", () => $4d7865f6263aba69$export$45f0a19e0c7c461b);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $jcRK7 = parcelRequire("jcRK7");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $9EHSp = parcelRequire("9EHSp");

var $d9bXQ = parcelRequire("d9bXQ");

var $dYfqL = parcelRequire("dYfqL");

var $8IuC8 = parcelRequire("8IuC8");
const $4d7865f6263aba69$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getHelpCenterTopBarTextColor), (primaryColor)=>({
        primaryColor: primaryColor
    }));
const $4d7865f6263aba69$var$CsmRequestsHeaderLinkDumb = ({ primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push, baseUrl: baseUrl } = (0, $dYfqL.useLinkPush)();
    const href = baseUrl + (0, $jcRK7.RoutePath).CSM_REQUESTS_LIST_PATH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9EHSp.default), {
        shape: "circle",
        href: href,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
                style: {
                    color: primaryColor
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d9bXQ))), iconProps)),
        label: formatMessage((0, $8IuC8.default).requests),
        onClick: (event)=>{
            push((0, $jcRK7.RoutePath).CSM_REQUESTS_LIST_PATH, event);
        }
    });
};
const $4d7865f6263aba69$export$45f0a19e0c7c461b = (0, $f2mlD.default)($4d7865f6263aba69$var$selector, {})($4d7865f6263aba69$var$CsmRequestsHeaderLinkDumb);

});
parcelRegister("9EHSp", function(module, exports) {
$parcel$export(module.exports, "default", () => $59e16d4477c3861f$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ /* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $21u3G = parcelRequire("21u3G");

var $bLXMw = parcelRequire("bLXMw");

var $lavtv = parcelRequire("lavtv");

var $9Abbn = parcelRequire("9Abbn");

var $kLU70 = parcelRequire("kLU70");

var $aHtkE = parcelRequire("aHtkE");
const $59e16d4477c3861f$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $59e16d4477c3861f$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $59e16d4477c3861f$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $59e16d4477c3861f$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _irr31afz _1di61kru"
};
const $59e16d4477c3861f$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $59e16d4477c3861f$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $59e16d4477c3861f$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $59e16d4477c3861f$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, newWindowLabel: newWindowLabel, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $bSJIT.useRef)(null);
    (0, $21u3G.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bLXMw.Anchor), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                newWindowLabel: newWindowLabel,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    var _triggerProps$onClick;
                    onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: (0, $fGbV9.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $jDsoo.cx)($59e16d4477c3861f$var$styles.base, !isDisabled && $59e16d4477c3861f$var$styles.interactiveMotion, appearance === 'default' && $59e16d4477c3861f$var$defaultStyles.root, appearance === 'primary' && $59e16d4477c3861f$var$primaryStyles.root, appearance === 'rovo' && $59e16d4477c3861f$var$rovoStyles.root, appearance === 'discovery' && $59e16d4477c3861f$var$discoveryStyles.root, appearance === 'subtle' && $59e16d4477c3861f$var$subtleStyles.root, $59e16d4477c3861f$var$styles.linkDecorationUnset, isSelected && $59e16d4477c3861f$var$selectedStyles.root, isSelected && appearance === 'discovery' && $59e16d4477c3861f$var$selectedStyles.discovery, isDisabled && $59e16d4477c3861f$var$styles.disabled, $59e16d4477c3861f$var$styles.iconButton, spacing === 'compact' && $59e16d4477c3861f$var$styles.spacingCompact, shape === 'circle' && $59e16d4477c3861f$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kLU70.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bLXMw.Anchor), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        newWindowLabel: newWindowLabel,
        ref: (0, $fGbV9.default)([
            localRef,
            ref
        ]),
        xcss: (0, $jDsoo.cx)($59e16d4477c3861f$var$styles.base, !isDisabled && $59e16d4477c3861f$var$styles.interactiveMotion, appearance === 'default' && $59e16d4477c3861f$var$defaultStyles.root, appearance === 'primary' && $59e16d4477c3861f$var$primaryStyles.root, appearance === 'rovo' && $59e16d4477c3861f$var$rovoStyles.root, appearance === 'discovery' && $59e16d4477c3861f$var$discoveryStyles.root, appearance === 'subtle' && $59e16d4477c3861f$var$subtleStyles.root, $59e16d4477c3861f$var$styles.linkDecorationUnset, isSelected && $59e16d4477c3861f$var$selectedStyles.root, isSelected && appearance === 'discovery' && $59e16d4477c3861f$var$selectedStyles.discovery, isDisabled && $59e16d4477c3861f$var$styles.disabled, $59e16d4477c3861f$var$styles.iconButton, spacing === 'compact' && $59e16d4477c3861f$var$styles.spacingCompact, shape === 'circle' && $59e16d4477c3861f$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kLU70.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $59e16d4477c3861f$var$WithRef = /*#__PURE__*/ (0, $bSJIT.forwardRef)($59e16d4477c3861f$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $59e16d4477c3861f$var$LinkIconButton = /*#__PURE__*/ (0, $bSJIT.memo)($59e16d4477c3861f$var$WithRef);
var $59e16d4477c3861f$export$2e2bcd8739ae039 = $59e16d4477c3861f$var$LinkIconButton;

});

parcelRegister("d9bXQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fa04d7bec8552f7cf5d65f57f0111e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9925657a3a685047$var$_react = $9925657a3a685047$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $9925657a3a685047$var$_iconNew = $9925657a3a685047$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $9925657a3a685047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/inbox
 * Usage guidance:
 * Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9925657a3a685047$var$InboxIcon = (props)=>/*#__PURE__*/ $9925657a3a685047$var$_react.default.createElement($9925657a3a685047$var$_iconNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$9925657a3a685047$var$InboxIcon.displayName = 'InboxIcon';
var $9925657a3a685047$var$_default = module.exports.default = $9925657a3a685047$var$InboxIcon;

});

parcelRegister("dYfqL", function(module, exports) {
$parcel$export(module.exports, "useLinkPush", () => $815e75345eb7293a$export$52eec4f7709b743e);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $6WltM = parcelRequire("6WltM");

var $haAAx = parcelRequire("haAAx");

var $iW3CQ = parcelRequire("iW3CQ");
const $815e75345eb7293a$export$52eec4f7709b743e = ()=>{
    var _env$baseUrl;
    const env = (0, $iW3CQ.getEnv)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const linkPush = (0, $bSJIT.useCallback)((targetUrl, event, analyticsAttributes)=>{
        if (analyticsAttributes) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            ...analyticsAttributes
        }).fire();
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        push(targetUrl);
    }, [
        push,
        createAnalyticsEvent
    ]);
    return {
        push: linkPush,
        baseUrl: (_env$baseUrl = env.baseUrl) === null || _env$baseUrl === void 0 ? void 0 : _env$baseUrl.replace(/\/+$/, '')
    };
};

});

parcelRegister("8IuC8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a7e0ece677e96da$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $0a7e0ece677e96da$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    requests: {
        id: 'csm-requests-header-link.requests',
        defaultMessage: 'Requests',
        description: 'The text is shown as the label for a navigation link in the page header that takes the user to the list of their submitted customer service requests.'
    }
});

});


parcelRegister("25Mnh", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("83t8i")).default);
parcelRequire("iWQ7r");
var $83t8i = parcelRequire("83t8i");

});
parcelRegister("iWQ7r", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("83t8i")).default);

var $83t8i = parcelRequire("83t8i");

});
parcelRegister("83t8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce51e8277ce0719b$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("8Khoy");
var $2QiWE = parcelRequire("2QiWE");

var $3Y2rF = parcelRequire("3Y2rF");

var $l8AmL = parcelRequire("l8AmL");

var $3lfq2 = parcelRequire("3lfq2");

var $bbFTS = parcelRequire("bbFTS");

var $2pMch = parcelRequire("2pMch");

var $3HBS2 = parcelRequire("3HBS2");

var $9vhEo = parcelRequire("9vhEo");

var $cywwP = parcelRequire("cywwP");

var $jFO7B = parcelRequire("jFO7B");

var $ascJH = parcelRequire("ascJH");
parcelRequire("cbYXR");
var $7cf4f = parcelRequire("7cf4f");
const $ce51e8277ce0719b$var$getCustomMenuLinksProps = (state)=>{
    const customMenuLinks = (0, $3HBS2.getCustomMenuLinks)(state);
    return customMenuLinks.map((menuLink)=>{
        return {
            id: menuLink.id,
            key: menuLink.key,
            label: menuLink.label,
            href: menuLink.href,
            styleClass: menuLink.styleClass
        };
    });
};
const $ce51e8277ce0719b$var$selector = (0, $BOq7h.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $3Y2rF.getPortalId)(state);
    const routeName = (0, $3Y2rF.getRoutename)(state);
    const portal = {
        id: portalId,
        name: (0, $bbFTS.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $bbFTS.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $bbFTS.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $bbFTS.getIsProjectSimplified)(state, portalId))
    };
    const areCustomerServiceSettingsLinksAvailable = (0, $l8AmL.getHelpCenterType)(state) === (0, $ascJH.CUSTOMER_SERVICE_HELP_CENTER_TYPE) && !!(0, $l8AmL.getHoistedProjectKey)(state);
    return {
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: (0, $3HBS2.getAvatarSrc)(state),
        displayName: (0, $3HBS2.getDisplayName)(state),
        email: (0, $3HBS2.getEmail)(state),
        customMenuLinks: $ce51e8277ce0719b$var$getCustomMenuLinksProps(state),
        canAdministerJIRA: (0, $3HBS2.getCanAdministerJIRA)(state),
        canCustomiseHelpCenter: (0, $3lfq2.getCanCustomize)(state),
        pendingApprovalCount: (0, $9vhEo.getUserRequestsCounts)(state).pendingApprovalCount,
        myRequestCount: (0, $9vhEo.getUserRequestsCounts)(state).myRequestCount,
        defaultColumnSettings: (0, $2pMch.getRequestsColumnSettings)(state),
        approvalCount: (0, $9vhEo.getUserRequestsCounts)(state).approvalCount,
        jsmAIConfigEnabled: (0, $l8AmL.getJsmAIConfigEnabled)(state),
        hoistedProjectKey: (0, $l8AmL.getHoistedProjectKey)(state),
        jiraDisplayUrl: (0, $l8AmL.getJiraDisplayUrl)(state),
        hasSiteAdministerAccess: (0, $3HBS2.getHasSiteAdministerAccess)(state)
    };
}, ({ portal: portal, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, avatarSrc: avatarSrc, displayName: displayName, email: email, customMenuLinks: customMenuLinks, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, routeName: routeName, defaultColumnSettings: defaultColumnSettings, pendingApprovalCount: pendingApprovalCount, myRequestCount: myRequestCount, approvalCount: approvalCount, jsmAIConfigEnabled: jsmAIConfigEnabled, hoistedProjectKey: hoistedProjectKey, jiraDisplayUrl: jiraDisplayUrl, hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: avatarSrc,
        displayName: displayName,
        email: email,
        customMenuLinks: customMenuLinks,
        canAdministerJIRA: canAdministerJIRA,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        pendingApprovalCount: pendingApprovalCount,
        approvalCount: approvalCount,
        defaultColumnSettings: defaultColumnSettings,
        myRequestCount: myRequestCount,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        hoistedProjectKey: hoistedProjectKey,
        jiraDisplayUrl: jiraDisplayUrl,
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
var $ce51e8277ce0719b$export$2e2bcd8739ae039 = (0, $f2mlD.default)($ce51e8277ce0719b$var$selector, {
    onLogoutClick: (0, $2QiWE.logOutAction),
    openHelpCenterCustomizationSidebar: ()=>(0, $cywwP.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $jFO7B.customizingRequestListColumn)(true)
})((0, $7cf4f.default));

});
parcelRegister("8Khoy", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("17F5Q")).fetchCategoriesAction);
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("iaagT")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("iaagT")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("cNdkY")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("1lvF7")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("2QiWE")).logOutAction);
parcelRequire("4lNKa");

});
parcelRegister("4lNKa", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("iaagT")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("iaagT")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("cNdkY")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("1lvF7")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("17F5Q")).fetchCategoriesAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("2QiWE")).logOutAction);

var $iaagT = parcelRequire("iaagT");

var $cNdkY = parcelRequire("cNdkY");

var $1lvF7 = parcelRequire("1lvF7");

var $17F5Q = parcelRequire("17F5Q");

var $2QiWE = parcelRequire("2QiWE");

});
parcelRegister("iaagT", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => $be79f1dc598bd46e$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $be79f1dc598bd46e$export$42cfcdfd4935cc23);

var $9FUCC = parcelRequire("9FUCC");
const $be79f1dc598bd46e$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $be79f1dc598bd46e$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $be79f1dc598bd46e$export$61e2f9e78cb604c7 = (0, $9FUCC.buildModelsActionCreator)($be79f1dc598bd46e$export$5586a78b777598b9, 'sharedPortal');
const $be79f1dc598bd46e$export$42cfcdfd4935cc23 = (0, $9FUCC.buildModelsActionCreator)($be79f1dc598bd46e$export$d8cc5374b8afc050, 'helpCenterBranding');

});
parcelRegister("9FUCC", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $4b8c7ef86825163a$export$9f8a38b5e77ac29);
const $4b8c7ef86825163a$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});


parcelRegister("cNdkY", function(module, exports) {
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $e61f2e04d3a826cd$export$cbdd5d7a098d34a2);

var $9FUCC = parcelRequire("9FUCC");
const $e61f2e04d3a826cd$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $e61f2e04d3a826cd$export$cbdd5d7a098d34a2 = (0, $9FUCC.buildModelsActionCreator)($e61f2e04d3a826cd$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("1lvF7", function(module, exports) {
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $8cd52db695d93af8$export$71172847a48a08a6);

var $9FUCC = parcelRequire("9FUCC");
const $8cd52db695d93af8$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $8cd52db695d93af8$export$71172847a48a08a6 = (0, $9FUCC.buildModelsActionCreator)($8cd52db695d93af8$export$dfecf710cdf030b1, 'userRequestsCounts');

});

parcelRegister("17F5Q", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => $b002e6f80390aef6$export$10813fa84276d50);
const $b002e6f80390aef6$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $b002e6f80390aef6$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $b002e6f80390aef6$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});

parcelRegister("2QiWE", function(module, exports) {
$parcel$export(module.exports, "logOutAction", () => $78798074af87ffe1$export$1a3865346be34527);
const $78798074af87ffe1$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $78798074af87ffe1$export$1a3865346be34527 = ()=>{
    return {
        type: $78798074af87ffe1$export$cb307dad255adf47
    };
};

});



parcelRegister("3Y2rF", function(module, exports) {
$parcel$export(module.exports, "getPortalId", () => $4dc11645ba5efc1c$export$79c9b12a0a57147a);
$parcel$export(module.exports, "getRoutename", () => $4dc11645ba5efc1c$export$6c570a1091322ad4);
const $4dc11645ba5efc1c$export$f71e6ac2c1d88be0 = (state)=>{
    var _state$ui, _state$ui2, _state$ui3;
    return ((_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.context.portalId) !== undefined && ((_state$ui2 = state.ui) === null || _state$ui2 === void 0 ? void 0 : _state$ui2.context.portalId) !== null && !isNaN(((_state$ui3 = state.ui) === null || _state$ui3 === void 0 ? void 0 : _state$ui3.context.portalId) || NaN);
};
const $4dc11645ba5efc1c$export$79c9b12a0a57147a = (state)=>{
    var _state$ui4;
    if (!$4dc11645ba5efc1c$export$f71e6ac2c1d88be0(state)) return undefined;
    return (_state$ui4 = state.ui) === null || _state$ui4 === void 0 ? void 0 : _state$ui4.context.portalId;
};
const $4dc11645ba5efc1c$export$6c570a1091322ad4 = (state)=>{
    var _state$ui5;
    return (_state$ui5 = state.ui) === null || _state$ui5 === void 0 ? void 0 : _state$ui5.context.routeName;
};

});

parcelRegister("l8AmL", function(module, exports) {
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $80498693d111b164$export$a90992f5204fc247);
$parcel$export(module.exports, "getHelpCenterType", () => $80498693d111b164$export$7972e6e7445f0142);
$parcel$export(module.exports, "getHoistedProjectKey", () => $80498693d111b164$export$3b0fd0e16a94f75);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $80498693d111b164$export$9679fa5312e1354b);
const $80498693d111b164$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $80498693d111b164$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $80498693d111b164$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $80498693d111b164$export$23a8be9c477ed0ba = (state)=>state.persisted.env.hoistedProjectId;
const $80498693d111b164$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;

});

parcelRegister("3lfq2", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterBanner", () => $509723881ddf9835$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getThemeColor", () => $509723881ddf9835$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getCanCustomize", () => $509723881ddf9835$export$eb9b5e885139dc39);

var $4ZMmh = parcelRequire("4ZMmh");

var $3HBS2 = parcelRequire("3HBS2");
const $509723881ddf9835$export$85757b7e55ef3c9f = (state)=>{
    var _state$ui;
    return (0, $4ZMmh.mergeWith)({}, state.persisted.helpCenter, (_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.helpCenterPreview, // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
    (_, srcValue)=>{
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
};
const $509723881ddf9835$export$3b3c747bea011f3c = (state)=>{
    return $509723881ddf9835$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
};
const $509723881ddf9835$export$e22c5d06d177c3fa = (state)=>{
    return $509723881ddf9835$export$85757b7e55ef3c9f(state).themeColor;
};
const $509723881ddf9835$var$getTranslation = (state, language)=>$509723881ddf9835$export$85757b7e55ef3c9f(state).translations[language];
const $509723881ddf9835$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $3HBS2.getLocale)(state);
    const translation = userLocale && $509723881ddf9835$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $509723881ddf9835$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $509723881ddf9835$export$eb9b5e885139dc39 = (state)=>{
    return $509723881ddf9835$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
};

});

parcelRegister("bbFTS", function(module, exports) {
$parcel$export(module.exports, "getPortalOrError", () => $a91cc584e7783f74$export$aa66ead34639a340);
$parcel$export(module.exports, "getProjectId", () => $a91cc584e7783f74$export$89040d072f281f85);
$parcel$export(module.exports, "getName", () => $a91cc584e7783f74$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getPortalAnnouncement", () => $a91cc584e7783f74$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $a91cc584e7783f74$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $a91cc584e7783f74$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $a91cc584e7783f74$export$7a0f33e8df10bd94);

var $4ZMmh = parcelRequire("4ZMmh");
const $a91cc584e7783f74$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $a91cc584e7783f74$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $4ZMmh.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $a91cc584e7783f74$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $a91cc584e7783f74$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $a91cc584e7783f74$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $4ZMmh.isNil)(portalId)) return undefined;
    const portal = $a91cc584e7783f74$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $a91cc584e7783f74$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $a91cc584e7783f74$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.name : undefined;
};
const $a91cc584e7783f74$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $a91cc584e7783f74$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $a91cc584e7783f74$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $a91cc584e7783f74$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement ? portalAnnouncement.canAdministerProject : false;
};
const $a91cc584e7783f74$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $a91cc584e7783f74$export$e16cb606b6ef4a60(state, portalId);
    return portal ? !!portal.isProjectSimplified : false;
};
const $a91cc584e7783f74$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $a91cc584e7783f74$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};

});

parcelRegister("2pMch", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $b13d694ba85289c2$export$a5e47ac90fcdaee8);
/**
 * Request column settings selectors for accessing column configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */ /**
 * Get the full requests column settings state (includes columns and statusFilter).
 */ const $b13d694ba85289c2$var$getRequestsColumnSettingsState = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $b13d694ba85289c2$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $b13d694ba85289c2$var$getRequestsColumnSettingsState(state);
    return settingsState.columns || [];
};

});

parcelRegister("9vhEo", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $1162cd05cd2b3063$export$be73da9c8fdefffb);
const $1162cd05cd2b3063$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});

parcelRegister("ascJH", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_HELP_CENTER_TYPE", () => $2278c86502218524$export$fc172486e4a9f1fa);
const $2278c86502218524$export$fc172486e4a9f1fa = 'CUSTOMER_SERVICE';

});

parcelRegister("cbYXR", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuDumbV2", () => (parcelRequire("7cf4f")).default);

var $7cf4f = parcelRequire("7cf4f");

});
parcelRegister("7cf4f", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e95ee78becdc65e$export$2e2bcd8739ae039);
/* avatar-menu-dumb-v2.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $7j7Eh = parcelRequire("7j7Eh");

var $97yQ5 = parcelRequire("97yQ5");
var $2OuWT = parcelRequire("2OuWT");

var $53Khx = parcelRequire("53Khx");

var $gYaV0 = parcelRequire("gYaV0");

var $eazQ4 = parcelRequire("eazQ4");

var $jcRK7 = parcelRequire("jcRK7");

var $8gC0T = parcelRequire("8gC0T");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $hiHQM = parcelRequire("hiHQM");

var $i7phc = parcelRequire("i7phc");

var $aWOG4 = parcelRequire("aWOG4");

var $hXaxc = parcelRequire("hXaxc");

var $fuVmc = parcelRequire("fuVmc");

var $dVmKA = parcelRequire("dVmKA");

var $9K7mZ = parcelRequire("9K7mZ");

var $a7Tmb = parcelRequire("a7Tmb");

var $kXBd7 = parcelRequire("kXBd7");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $dwOcU = parcelRequire("dwOcU");

var $6WltM = parcelRequire("6WltM");

var $5zqhO = parcelRequire("5zqhO");

var $JD7lD = parcelRequire("JD7lD");

var $87QgR = parcelRequire("87QgR");

var $cExzV = parcelRequire("cExzV");

var $cjQhO = parcelRequire("cjQhO");

var $fsfgu = parcelRequire("fsfgu");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $9ym5V = parcelRequire("9ym5V");

var $9cAYa = parcelRequire("9cAYa");

var $1jnkF = parcelRequire("1jnkF");

var $26Jy2 = parcelRequire("26Jy2");

var $gUpf2 = parcelRequire("gUpf2");

var $aHbh3 = parcelRequire("aHbh3");

var $9BVpB = parcelRequire("9BVpB");

var $juI4y = parcelRequire("juI4y");

var $8LptA = parcelRequire("8LptA");

var $haAAx = parcelRequire("haAAx");

var $9P2Zq = parcelRequire("9P2Zq");

var $dDjgn = parcelRequire("dDjgn");

var $dLhCs = parcelRequire("dLhCs");

var $duJSM = parcelRequire("duJSM");

var $5oqa3 = parcelRequire("5oqa3");

var $8RL7A = parcelRequire("8RL7A");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $2aw7C = parcelRequire("2aw7C");

var $fY92D = parcelRequire("fY92D");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");

var $f6Ax9 = parcelRequire("f6Ax9");

var $7WRjA = parcelRequire("7WRjA");
parcelRequire("iZ3AQ");
var $l1WpZ = parcelRequire("l1WpZ");

var $jhouu = parcelRequire("jhouu");

var $exEZO = parcelRequire("exEZO");

var $efD9w = parcelRequire("efD9w");

var $ehpnm = parcelRequire("ehpnm");

var $iecar = parcelRequire("iecar");
const $8e95ee78becdc65e$export$c0b4c34c7506f4d = ()=>(0, $87QgR.default).checkGate('jsm_help_center_one-click_rovo_agent');
const $8e95ee78becdc65e$export$e0ae4b37130667df = ({ onClose: onClose })=>{
    const { data: { extensionTitles: extensionTitles }, methods: { setExtensionToDisplay: onClick } } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $aWOG4.ForgeModalContext));
    const forgeActionLinkOnClick = (id, onClickApp)=>()=>{
            onClose('navBarForgeApp');
            return onClickApp(id);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, extensionTitles.map(({ id: id, title: title })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            id: id,
            key: `forge-title_${id}`,
            component: $8e95ee78becdc65e$var$CustomButton,
            actionSubjectId: "navBarForgeApp",
            onClick: forgeActionLinkOnClick(id, onClick)
        }, title);
    }));
};
const $8e95ee78becdc65e$var$menuBottomSection = (onClose, isHelpCenterManagementScreen, onLogoutClick)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        actionSubjectId: "navbarProfile",
        key: `bottom-menu-management-screen-navbarProfile`,
        component: $8e95ee78becdc65e$var$CustomAnchor,
        href: '/servicedesk/customer/user/profile',
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).profile)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        key: `bottom-menu-navbarProfile`,
        component: $8e95ee78becdc65e$var$CustomLink,
        to: '/user/profile',
        actionSubjectId: "navbarProfile",
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).profile)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: 'navbarLogout'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: $8e95ee78becdc65e$var$CustomButton,
        actionSubjectId: "navbarLogout",
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": 'logout',
        onClick: onLogoutClick,
        "data-test-id": "logout-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).logout))));
};
const $8e95ee78becdc65e$export$a552d0e5a7a35aad = ({ customMenuLinks: customMenuLinks, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-test-id": "custom-menu-link"
    }, customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: `custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            actionSubjectId: 'custom-menu-link',
            component: $8e95ee78becdc65e$var$CustomAnchor,
            href: menuLink.href,
            onClick: ()=>onClose('custom-menu-link'),
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label))));
const $8e95ee78becdc65e$var$buildCustomMenuLinks = (customMenuLinks, onClose)=>{
    return customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: `build-custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            actionSubjectId: 'custom-menu-link',
            component: $8e95ee78becdc65e$var$CustomAnchor,
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            onClick: ()=>onClose('custom-menu-link'),
            href: menuLink.href,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label)));
};
const $8e95ee78becdc65e$var$TopMenu = (myRequestCount, onClose, pendingApprovalCount, approvalCount, isHelpCenterManagementScreen)=>{
    const customizeMenu = [
        {
            onClick: ()=>onClose('navbarUserRequests'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/requests?reporter=all&statuses=open' : '/user/requests?reporter=all&statuses=open',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).requests),
            actionSubjectId: 'navbarUserRequests',
            iconAfter: myRequestCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gYaV0.default), null, myRequestCount) : undefined,
            isVisible: !(0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType),
            dataTestId: 'requests-link'
        },
        {
            onClick: ()=>onClose('navbarUserApprovals'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/approvals' : '/user/approvals',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).approvals),
            actionSubjectId: 'navbarUserApprovals',
            iconAfter: pendingApprovalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gYaV0.default), null, pendingApprovalCount) : undefined,
            isVisible: approvalCount > 0 || pendingApprovalCount > 0,
            dataTestId: 'approvals-link'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            actionSubjectId: menu.actionSubjectId,
            key: `top-menu-management-screen_${menu.actionSubjectId}`,
            component: $8e95ee78becdc65e$var$CustomAnchor,
            href: menu.link,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            key: `top-menu_${menu.actionSubjectId}`,
            component: $8e95ee78becdc65e$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $8e95ee78becdc65e$var$CustomMenuItems = ({ menu: menu })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: menu.component ?? $8e95ee78becdc65e$var$CustomLink,
        to: menu.link,
        actionSubjectId: menu.actionSubjectId,
        onClick: menu.onClick,
        testId: menu.testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
            appearance: "discovery"
        }, formatMessage((0, $efD9w.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
            appearance: "discovery"
        }, formatMessage((0, $efD9w.default).newLozenge)), menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
            appearance: "discovery"
        }, formatMessage((0, $efD9w.default).premiumLozenge)))
    }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireUIAnalytics), {
        action: "viewed",
        actionSubject: menu.actionSubjectId
    }));
};
const $8e95ee78becdc65e$var$CustomPressable = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aHbh3.Pressable), {
        componentName: "link",
        xcss: $8e95ee78becdc65e$var$customPressableStyles,
        ...rest
    }, children);
/**
 * Feature gate: premium_benefits_modal_config_driven
 *
 * When enabled, open the new config-driven edition-benefits-modal via its async
 * entrypoint (`editionBenefitsModalEntryPoint` + `ModalTrigger`) instead of the
 * legacy `PremiumBenefitModalTrigger`. The entrypoint loads on demand, keeping
 * the modal's assets out of the initial bundle.
 *
 * Rollout: Pending — gate created 2026-07-15, default off
 * Target: TBD
 * Owner: Sequoia (SQA-4082)
 */ const $8e95ee78becdc65e$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN = 'premium_benefits_modal_config_driven';
const $8e95ee78becdc65e$var$isPremiumBenefitsModalConfigDrivenEnabled = ()=>(0, $87QgR.default).checkGate($8e95ee78becdc65e$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN);
const $8e95ee78becdc65e$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const isConfigDriven = $8e95ee78becdc65e$var$isPremiumBenefitsModalConfigDrivenEnabled();
    const edition = (0, $iW3CQ.getEnv)().edition ?? 'unknown';
    // The config-driven ModalTrigger path doesn't emit the trigger analytics that the
    // legacy PremiumBenefitModalTrigger did, so replicate them here for parity.
    const fireTriggerEvent = (0, $bSJIT.useCallback)((action)=>createAnalyticsEvent({
            action: action,
            eventType: 'ui',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                edition: edition,
                touchpointId: menu.pbmTouchpointId,
                product: 'jira-service-management',
                variantId: 'help-center-customization',
                packageName: '@atlassian/edition-benefits-modal',
                source: 'editionBenefitsModal'
            }
        }).fire('growth'), // FabricChannel.growth
    [
        createAnalyticsEvent,
        edition,
        menu.pbmTouchpointId
    ]);
    const hasFiredViewed = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        // Fire the trigger "viewed" event once when the config-driven trigger is shown.
        if (isConfigDriven && !hasFiredViewed.current) {
            hasFiredViewed.current = true;
            fireTriggerEvent('viewed');
        }
    }, [
        isConfigDriven,
        fireTriggerEvent
    ]);
    const renderTrigger = ({ ref: ref, onTriggerClick: onTriggerClick, props: triggerProps })=>// CustomItem doesn't forward testId to custom components, so we add it to the Box wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            ref: ref,
            ...triggerProps,
            testId: menu.testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$CustomMenuItems, {
            menu: {
                ...menu,
                component: $8e95ee78becdc65e$var$CustomPressable,
                // Compose the trigger analytics with the item's own handler so the "clicked"
                // event fires on the element itself rather than relying on event bubbling.
                ...onTriggerClick ? {
                    onClick: (event)=>{
                        var _menu$onClick;
                        onTriggerClick();
                        (_menu$onClick = menu.onClick) === null || _menu$onClick === void 0 || _menu$onClick.call(menu, event);
                    }
                } : {}
            }
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).HELP_CENTER,
        id: `help-center-${menu.pbmTouchpointId}`,
        renderError: ()=>null
    }, isConfigDriven ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8RL7A.ModalTrigger), {
        entryPoint: (0, $duJSM.editionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: (0, $fuVmc.getCloudId)(),
            product: 'jira-service-management'
        },
        entryPointProps: {
            variantId: 'help-center-customization',
            touchpointId: menu.pbmTouchpointId
        },
        modalProps: (0, $dLhCs.MODAL_CONFIG)
    }, ({ ref: ref })=>renderTrigger({
            ref: ref,
            props: {},
            onTriggerClick: ()=>fireTriggerEvent('clicked')
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDjgn.PremiumBenefitModalTrigger), {
        cloudId: (0, $fuVmc.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: menu.pbmTouchpointId,
        edition: edition
    }, renderTrigger));
};
const $8e95ee78becdc65e$var$ListItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "li",
        xcss: $8e95ee78becdc65e$var$listItemStyles
    }, children);
};
const $8e95ee78becdc65e$export$7ed443719af866bf = ({ customizeMenu: customizeMenu = [] })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $bSJIT.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.isAnchor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            component: $8e95ee78becdc65e$var$CustomAnchor,
            href: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                appearance: "discovery"
            }, formatMessage((0, $efD9w.default).beta)),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: `customize-menu_spotlight_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dVmKA.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9cAYa.default), {
                name: (0, $jcRK7.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
                key: `customize-menu_${menu.actionSubjectId}`,
                component: $8e95ee78becdc65e$var$CustomLink,
                to: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                    appearance: "discovery"
                }, formatMessage((0, $efD9w.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                    appearance: "discovery"
                }, formatMessage((0, $efD9w.default).newLozenge)))
            }, menu.label))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1jnkF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8gC0T.default), {
            messageId: (0, $jcRK7.EngagementMessages).ONBOARD_VA_REPORTING,
            key: (0, $jcRK7.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kXBd7.VaOnboardingSpotlight), {
            setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
        })))));
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: `customize-menu_custom_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(menu.customRenderer, {
            menu: menu
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            component: $8e95ee78becdc65e$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                appearance: "discovery"
            }, formatMessage((0, $efD9w.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                appearance: "discovery"
            }, formatMessage((0, $efD9w.default).newLozenge))),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $8e95ee78becdc65e$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub)=>{
    const isHomePage = routeName === 'help-center' || routeName === 'view-homepage';
    const customizeMenu = [];
    const helpCenterId = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)()).helpCenterId;
    const isVisible = areCustomerServiceSettingsLinksAvailable && !!jiraDisplayUrl && !!hoistedProjectKey && !!helpCenterId && (isHomePage || isServiceHub) && canAdministerJIRA;
    const helpCenterSettingsUrl = (0, $lFpPv.isCsmAppification)() ? `${jiraDisplayUrl ?? ''}/jira/customer-service-management/experiences/${hoistedProjectKey ?? ''}/settings/${helpCenterId}/details` : `${jiraDisplayUrl ?? ''}/jira/helpcenter/projects/${hoistedProjectKey ?? ''}/settings/${helpCenterId}/details`;
    const additionalMenuItems = [
        {
            isVisible: isVisible,
            isAnchor: true,
            link: helpCenterSettingsUrl,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).customerHubSettings),
            actionSubjectId: 'helpCenterSettings',
            testId: 'help-center-settings'
        }
    ];
    customizeMenu.push(...additionalMenuItems);
    const hideSection = ()=>customizeMenu.every((item)=>!item.isVisible);
    if (hideSection()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$export$7ed443719af866bf, {
        customizeMenu: customizeMenu
    });
};
const $8e95ee78becdc65e$var$RenderHCSection = ({ onClick: onClick, showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells, jiraDisplayUrl: jiraDisplayUrl })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
    const customizeMenu = [
        {
            link: `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).manageHc),
            actionSubjectId: 'manageHelpCenter',
            isVisible: true,
            onClick: ()=>onClick('manageHelpCenter'),
            testId: 'manage-hc-link'
        },
        {
            link: (0, $iW3CQ.getIsMultiHCEnabled)() ? (0, $jhouu.getHelpCenterCreationUrl)(jiraDisplayUrl) : '#',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).createHc),
            actionSubjectId: 'createHelpCenter',
            isVisible: showAvatarMenuItemsUpsells,
            pbmTouchpointId: 'portal-avatar-menu-create-help-center',
            customRenderer: (0, $iW3CQ.getIsHCCustomizationEnabled)() ? undefined : $8e95ee78becdc65e$var$PremiumBenefitsModalRenderer,
            onClick: ()=>onClick('createHelpCenter'),
            testId: 'create-hc-link',
            isPremium: !(0, $iW3CQ.getIsHCCustomizationEnabled)()
        },
        {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).managePages),
            actionSubjectId: 'manageHelpCenterPages',
            isVisible: showAvatarMenuItemsUpsells,
            pbmTouchpointId: 'portal-avatar-menu-landing-pages',
            onClick: ()=>onClick('manageHelpCenterPages'),
            testId: 'manage-hc-pages',
            link: `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/pages`,
            isPremium: !(0, $iW3CQ.getIsHCCustomizationEnabled)(),
            customRenderer: (0, $iW3CQ.getIsHCCustomizationEnabled)() ? undefined : $8e95ee78becdc65e$var$PremiumBenefitsModalRenderer,
            showSpotlight: false,
            messageDescription: (0, $efD9w.default).landingPagesNonPremiumDescription
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fsfgu.default), {
        id: "avatar-menu-hc-section-heading"
    }, formatMessage((0, $efD9w.default).helpCenter)), customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(menu.customRenderer, {
            menu: menu
        }), menu.actionSubjectId === 'manageHelpCenterPages' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireUIAnalytics), {
            action: "viewed",
            actionSubject: menu.actionSubjectId
        })));
        const renderMenuItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
                key: `hc-section-menu_${menu.actionSubjectId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
                component: $8e95ee78becdc65e$var$CustomAnchor,
                href: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                iconAfter: menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                    appearance: "discovery"
                }, formatMessage((0, $efD9w.default).premiumLozenge)),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation"
            }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireUIAnalytics), {
                action: "viewed",
                actionSubject: menu.actionSubjectId
            })));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dVmKA.default), {
            delay: 100,
            key: menu.actionSubjectId
        }, ()=>renderMenuItem());
        return renderMenuItem();
    }));
};
const $8e95ee78becdc65e$var$UserProfileConnectActionLinks = (0, $fY92D.withDeferredWrmLoaded)($8e95ee78becdc65e$export$a552d0e5a7a35aad, (0, $eazQ4.initializeConnect));
const $8e95ee78becdc65e$var$AvatarMenuDumbV2 = (props)=>{
    // Reading the from useRouter even thought we are getting from props because
    // there is an unneccessary rerender happening in the component which is causing the Engagement client
    // to make an unnecessary start call
    // Keep useRouter hook call to preserve hook ordering
    (0, $h1bGI.useRouter)();
    const isHomepage = (props === null || props === void 0 ? void 0 : props.routeName) === 'help-center' || (props === null || props === void 0 ? void 0 : props.routeName) === 'view-homepage';
    (0, $7WRjA.useUFOComponentExperience)((0, $exEZO.avatarMenuExperience));
    const isHelpCenterManagementScreen = (0, $eDcdn.getRelativeBasePath)() === (0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const basePath = (0, $hCnLH.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(!!props.isOpen);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $2FLDr.useQueryParams)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const isSmallScreen = window.innerWidth < (0, $a7Tmb.sizes).xsmall;
    // Keep the hook call to preserve hook ordering
    (0, $a2qIF.useRelayEnvironment)();
    const onOpenChange = (0, $bSJIT.useCallback)((open)=>{
        setIsOpen(open);
        // if customize is true and experience is not set, clear customize from the queryParam
        if (!open && customize === 'true' && !experience) (0, $2aw7C.clearSidebarExperienceAndCustomize)();
    }, [
        customize,
        experience
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'avatarMenu',
            version: '2',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    // This state is used to track if the landing pages changeboarding spotlight has been viewed so that the avatar menu is not opened again on state change within same session of seeing change boarding spotlight.
    const [_, setAvatarMenuOpenedOnceForChangeboarding] = (0, $bSJIT.useState)(false);
    const content = ()=>{
        const { myRequestCount: myRequestCount, customMenuLinks: customMenuLinks, onLogoutClick: onLogoutClick, openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, routeName: routeName, pendingApprovalCount: pendingApprovalCount, approvalCount: approvalCount, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, avatarSrc: avatarSrc, displayName: displayName, email: email, hoistedProjectKey: hoistedProjectKey, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, jiraDisplayUrl: jiraDisplayUrl } = props;
        const isServiceHub = !!hoistedProjectKey;
        const virtualAgentAllowed = (0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        const showAvatarMenuItemsUpsells = (0, $iW3CQ.getIsHCCustomizationEnabled)() || Boolean(hasSiteAdministerAccess);
        const showVirtualAgentMenu = !(0, $lFpPv.isHideVsaEndpointsEnabled)() && canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && virtualAgentAllowed && (!hasSiteAdministerAccess || (0, $iW3CQ.getIsHCCustomizationEnabled)());
        // Feature gate: jsm_help_center_one-click_rovo_agent
        // Rovo Agent menu is independent of VSA settings
        const rovoAgentAllowed = (0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent');
        const showRovoAgentMenu = canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && rovoAgentAllowed;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$Wrapper, {
            "aria-label": formatMessage((0, $efD9w.default).tooltip),
            "data-testid": "avatar-menu-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $65Fe1.default), {
            maxHeight: $8e95ee78becdc65e$var$maxHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l1WpZ.AccountDetails), {
            avatarSrc: avatarSrc,
            displayName: displayName,
            email: email
        }), $8e95ee78becdc65e$var$TopMenu(myRequestCount || 0, onItemClick, pendingApprovalCount || 0, approvalCount || 0, isHelpCenterManagementScreen), !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, canAdministerJIRA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
            hasSeparator: !isSmallScreen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "ul",
            xcss: $8e95ee78becdc65e$var$listItemStyles,
            key: "help-center-menu",
            // @ts-ignore - aria-label is valid for ul elements
            "aria-label": formatMessage((0, $efD9w.default).helpCenterMenuOptions)
        }, !isSmallScreen && !isServiceHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$RenderHCSection, {
            showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells,
            onClick: onItemClick,
            jiraDisplayUrl: jiraDisplayUrl
        }), canCustomiseHelpCenter && (isHomepage || isServiceHub) && $8e95ee78becdc65e$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub), showRovoAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: "customize-menu_rovo_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ehpnm.RovoAgentMenu), {
            onClose: onItemClick,
            component: $8e95ee78becdc65e$var$CustomAnchor
        })), showVirtualAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ListItemWrapper, {
            key: "customize-menu_virtual_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iecar.VirtualAgentMenu), {
            onClose: onItemClick,
            component: $8e95ee78becdc65e$var$CustomAnchor
        })))), customMenuLinks && customMenuLinks.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
            hasSeparator: customMenuLinks && customMenuLinks.length > 0
        }, (0, $lFpPv.isWrmOptimizationsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$UserProfileConnectActionLinks, {
            customMenuLinks: customMenuLinks,
            onClose: onItemClick
        }) : $8e95ee78becdc65e$var$buildCustomMenuLinks(customMenuLinks, onItemClick)) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$export$e0ae4b37130667df, {
            onClose: onItemClick
        })), $8e95ee78becdc65e$var$menuBottomSection(onItemClick, isHelpCenterManagementScreen, onLogoutClick)), displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
            experience: (0, $exEZO.avatarMenuExperience)
        }));
    };
    const Trigger = (0, $bSJIT.useCallback)((triggerProps)=>{
        const { avatarSrc: avatarSrc, disableAvatarMenu: disableAvatarMenu = false, pendingApprovalCount: pendingApprovalCount = 0, myRequestCount: myRequestCount = 0 } = props;
        const totalRequests = pendingApprovalCount + myRequestCount;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, !(0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && totalRequests > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$StyledAvatarBadge, null, totalRequests), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$ProfileContainer, {
            disabled: disableAvatarMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9cAYa.default), {
            name: (0, $jcRK7.EngagementMessagesTarget).CHANGE_BOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5zqhO.Profile), {
            ...triggerProps,
            isDisabled: disableAvatarMenu,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
                src: avatarSrc,
                borderColor: "var(--ds-border-inverse, #FFFFFF)"
            }),
            isSelected: isOpen,
            onClick: ()=>{
                onOpenChange(!isOpen);
            },
            "aria-label": formatMessage((0, $efD9w.default).tooltip),
            tooltip: formatMessage((0, $efD9w.default).tooltip),
            testId: "user-avatar-container-2"
        }))));
    }, [
        props,
        isOpen,
        formatMessage,
        onOpenChange
    ]);
    const renderDropdownMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9ym5V.default), {
            blanketIsTinted: true,
            onBlanketClicked: ()=>setAvatarMenuOpenedOnceForChangeboarding(true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5oqa3.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
            isOpen: isOpen,
            shouldRenderToParent: true,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            zIndex: (0, $juI4y.layers).modal(),
            content: content,
            trigger: Trigger,
            // This is required to close the open menu when clicking outside of the menu
            // A complex use case hence attaching a video of the same https://www.loom.com/share/95aa9f0112dd4e028194397e8dfeabea?sid=ef970902-843d-4b62-a578-3ec0f1f1b273
            // shouldUseCaptureOnOutsideClick
            key: 'avatar-menu-dumb-v2-popup'
        })));
    };
    const renderError = (0, $bSJIT.useCallback)((error)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $exEZO.AvatarMenuExperienceFailure), {
            message: error.message
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        onError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8e95ee78becdc65e$var$AvatarMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hXaxc.ForgeModalContextProvider), {
        type: (0, $i7phc.USER_MENU_ACTION_SECTION_MODULE)
    }, renderDropdownMenu(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hiHQM.ForgeActionModule), {
        type: (0, $i7phc.USER_MENU_ACTION_SECTION_MODULE),
        componentName: (0, $i7phc.USER_MENU_ACTION_COMPONENT)
    }))));
};
$8e95ee78becdc65e$var$AvatarMenuDumbV2.defaultProps = {
    customMenuLinks: []
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8e95ee78becdc65e$var$AvatarMenuContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_u5f3u2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$NoUnderlineLink = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $2OuWT.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$Wrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1tvnsw3": (0, $3zY6O.default)($9K7mZ.multiple(29.25).px),
            "--_1rpxolo": (0, $3zY6O.default)($9K7mZ.multiple(100).px)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1ul94vv4 _p12f15fr _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$StyledAvatarBadge = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $gYaV0.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswstnw _1ltvidpf _94n5idpf _1pby1kze",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$CustomLink = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = $8e95ee78becdc65e$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_syaz261p _b8xz168b",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$CustomButton = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $97yQ5.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$CustomAnchor = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $53Khx.HtmlAnchor), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz261p _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$ProfileContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "",
            __cmplp.disabled ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $8e95ee78becdc65e$var$maxHeight = `calc(100vh - ${$9K7mZ.multiple(24).px}`;
const $8e95ee78becdc65e$var$customPressableStyles = (0, $9BVpB.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $8e95ee78becdc65e$var$listItemStyles = (0, $9BVpB.xcss)({
    listStyleType: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
var $8e95ee78becdc65e$export$2e2bcd8739ae039 = $8e95ee78becdc65e$var$AvatarMenuDumbV2;

});
parcelRegister("gYaV0", function(module, exports) {
$parcel$export(module.exports, "default", () => $31423402215526f8$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
// This is the current styling of Badge in AtlasKit. It
// has been duplicated here since AtlasKit does not allow
// color styling at the moment.
// Changed to use atlaskit/badge once https://ecosystem.atlassian.net/browse/AK-4187 resolved
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $31423402215526f8$var$ThemedBadge = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1s9354m-0"
})`background-color:${(props)=>`var(--ds-background-selected-bold, ${props.theme.color})`};border-radius:2em;color:${(props)=>props.theme.readableTextColor};display:inline-block;font-size:12px;font-weight:normal;line-height:1;min-width:1px;padding:0.16666666666667em ${"var(--ds-space-075, 6px)"};text-align:center;`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$31423402215526f8$export$2e2bcd8739ae039 = $31423402215526f8$var$ThemedBadge;

});

parcelRegister("eazQ4", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", () => $2b657cb11d3d4c3c$export$36d45daa6a4925b8);
$parcel$export(module.exports, "ConnectFragment", () => $2b657cb11d3d4c3c$export$aa8ab018415f92e4);
$parcel$export(module.exports, "ConnectFragmentDumb", () => $2b657cb11d3d4c3c$export$3cdf4f8c52fabf27);
$parcel$export(module.exports, "ConnectFragmentsDumb", () => $2b657cb11d3d4c3c$export$93e3ab580ab70dd6);

var $lFpPv = parcelRequire("lFpPv");

var $4ZMmh = parcelRequire("4ZMmh");

var $jBiia = parcelRequire("jBiia");

var $gEVth = parcelRequire("gEVth");

var $fWZxi = parcelRequire("fWZxi");

var $dxNM2 = parcelRequire("dxNM2");

var $fY92D = parcelRequire("fY92D");

var $4i1bM = parcelRequire("4i1bM");

var $7JRwm = parcelRequire("7JRwm");

var $l2e8e = parcelRequire("l2e8e");

var $kPxiY = parcelRequire("kPxiY");
const $2b657cb11d3d4c3c$export$36d45daa6a4925b8 = (0, $4ZMmh.once)(()=>{
    try {
        (0, $fWZxi.awaitGlobal)('connectHost', (0, $dxNM2.default));
    } catch (e) {
        (0, $jBiia.trackError)('connect.fragment.init.failed', {}, e);
        (0, $gEVth.operationalEvent)({
            action: 'failed',
            actionSubject: 'connectFragmentInit',
            source: 'unknownSource',
            attributes: {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                errorMessage: e.message
            }
        });
    }
});
const $2b657cb11d3d4c3c$export$aa8ab018415f92e4 = (0, $lFpPv.isWrmOptimizationsEnabled)() ? (0, $fY92D.withDeferredWrmLoaded)((0, $l2e8e.default), $2b657cb11d3d4c3c$export$36d45daa6a4925b8) : (0, $l2e8e.default);
const $2b657cb11d3d4c3c$export$3cdf4f8c52fabf27 = (0, $lFpPv.isWrmOptimizationsEnabled)() ? (0, $fY92D.withDeferredWrmLoaded)((0, $4i1bM.default), $2b657cb11d3d4c3c$export$36d45daa6a4925b8) : (0, $4i1bM.default);
const $2b657cb11d3d4c3c$export$93e3ab580ab70dd6 = (0, $lFpPv.isWrmOptimizationsEnabled)() ? (0, $fY92D.withDeferredWrmLoaded)((0, $7JRwm.default), $2b657cb11d3d4c3c$export$36d45daa6a4925b8) : (0, $7JRwm.default);

});
parcelRegister("fY92D", function(module, exports) {
$parcel$export(module.exports, "withDeferredWrmLoaded", () => $f7b8c0fbf951c431$export$ae0e017d29ba244d);

var $bSJIT = parcelRequire("bSJIT");

var $7AirO = parcelRequire("7AirO");
const $f7b8c0fbf951c431$export$ae0e017d29ba244d = (Component, onLoad)=>{
    const ComponentWithDeferredWrmLoaded = (props)=>{
        const { resourcesLoaded: resourcesLoaded } = $bSJIT.useContext((0, $7AirO.DeferredWrmResourceContext));
        $bSJIT.useEffect(()=>{
            if (resourcesLoaded) onLoad();
        }, [
            resourcesLoaded
        ]);
        if (!resourcesLoaded) return null;
        return /*#__PURE__*/ $bSJIT.createElement(Component, props);
    };
    return ComponentWithDeferredWrmLoaded;
};

});

parcelRegister("l2e8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1fab959f7520e7f$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("1Gp5B");
var $6GUVM = parcelRequire("6GUVM");

var $9WNwm = parcelRequire("9WNwm");
parcelRequire("84x3k");
var $ajeJ9 = parcelRequire("ajeJ9");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $kPxiY = parcelRequire("kPxiY");
const $c1fab959f7520e7f$var$selector = (0, $BOq7h.createSelector)((state, componentProps)=>{
    const { page: page, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = componentProps;
    const projectId = state ? (0, $iWhHo.getProjectId)(state, portalId) : undefined;
    const connectFragments = (0, $ajeJ9.getConnectAddonPanels)({
        state: state,
        location: location,
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey,
        pageName: page
    });
    return {
        connectFragments: connectFragments,
        projectId: projectId
    };
}, (props)=>props);
const $c1fab959f7520e7f$var$ConnectFragmentWithAnalytics = (0, $2usNr.default)({
    componentName: 'ConnectFragment'
})((0, $kIbto.default)({})((0, $kPxiY.ConnectFragment)));
var $c1fab959f7520e7f$export$2e2bcd8739ae039 = (0, $f2mlD.default)($c1fab959f7520e7f$var$selector, {
    fetchConnectFragments: (0, $6GUVM.fetchConnectFragmentsAction),
    ...(0, $9WNwm.mapConnectDispatchToPropsBanner)
})($c1fab959f7520e7f$var$ConnectFragmentWithAnalytics);

});
parcelRegister("84x3k", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => (parcelRequire("ajeJ9")).getConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => (parcelRequire("ajeJ9")).getProfileConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => (parcelRequire("ajeJ9")).getProfileConnectAddonActions);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => (parcelRequire("ajeJ9")).getRequestSpecificConnectAddonPanels);
$parcel$export(module.exports, "isConnectFragmentsResolved", () => (parcelRequire("ajeJ9")).isConnectFragmentsResolved);

var $ajeJ9 = parcelRequire("ajeJ9");

});
parcelRegister("ajeJ9", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => $9f3f007b08981141$export$be753636105743d4);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => $9f3f007b08981141$export$5d04f04eeff342cb);
$parcel$export(module.exports, "isConnectFragmentsResolved", () => $9f3f007b08981141$export$f5f011115184d299);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => $9f3f007b08981141$export$e91bb9a5dede3485);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => $9f3f007b08981141$export$43a1e23f8855f249);
parcelRequire("ee9JS");
var $jpPwF = parcelRequire("jpPwF");
const $9f3f007b08981141$export$be753636105743d4 = ({ state: state, pageName: pageName, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>{
    switch(location){
        case 'detailsPanels':
        case 'optionPanels':
            return $9f3f007b08981141$export$5d04f04eeff342cb({
                state: state,
                location: location,
                requestKey: requestKey
            });
        default:
            {
                const page = state.persisted.connectFragments[(0, $jpPwF.generateKey)(pageName, portalId, requestTypeId, requestKey)];
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return page && page[location];
            }
    }
};
const $9f3f007b08981141$export$5d04f04eeff342cb = ({ state: state, location: location, requestKey: requestKey })=>{
    const requestDetailsForKey = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    requestKey && state && state.persisted && state.persisted.requestDetails[requestKey];
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return requestDetailsForKey ? requestDetailsForKey[location] : [];
};
const $9f3f007b08981141$export$f5f011115184d299 = ({ state: state, pageName: pageName, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>{
    const page = state.persisted.connectFragments[(0, $jpPwF.generateKey)(pageName, portalId, requestTypeId, requestKey)];
    if (!page) return false;
    if ('error' in page) return true;
    return 'headerPanels' in page || 'subheaderPanels' in page || 'footerPanels' in page || 'propertyPanels' in page;
};
const $9f3f007b08981141$export$e91bb9a5dede3485 = (state)=>{
    return state.persisted.profileWebFragments.panels;
};
const $9f3f007b08981141$export$43a1e23f8855f249 = (state)=>{
    return state.persisted.profileWebFragments.actions;
};

});




parcelRegister("8gC0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $07cccdd85b765e55$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $6cRpo = parcelRequire("6cRpo");

var $7WD1V = parcelRequire("7WD1V");
const $07cccdd85b765e55$export$25215e4c8f710ceb = ({ coordinationClient: coordinationClient, messageId: messageId, children: children })=>{
    if (!coordinationClient) return null;
    return /*#__PURE__*/ $bSJIT.createElement((0, $6cRpo.default), {
        client: coordinationClient,
        messageId: messageId
    }, children);
};
var $07cccdd85b765e55$export$2e2bcd8739ae039 = (0, $7WD1V.withCoordinationClient)($07cccdd85b765e55$export$25215e4c8f710ceb);

});
parcelRegister("6cRpo", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec4efbc2f3e33818$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
class $ec4efbc2f3e33818$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    static #_ = this.defaultProps = {
        fallback: null
    };
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $bSJIT.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});


parcelRegister("hiHQM", function(module, exports) {
$parcel$export(module.exports, "ForgeActionModule", () => $396ab3347b7b3f7d$export$3f817dccc12b0bb3);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $396ab3347b7b3f7d$export$3f817dccc12b0bb3 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("dmrE7")), {
        moduleId: "./packages/common-utils/forge-action/src/forge-action.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("dmrE7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("iHTSu"),
    $kOunM("dKK6W")
]).then(()=>parcelRequire('j7sY7'));

});


parcelRegister("aWOG4", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContext", () => $9693f569e0169bfd$export$7ec9d631dd0c629a);
$parcel$export(module.exports, "ForgeModalContextConsumer", () => $9693f569e0169bfd$export$15f67e1b244563e3);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");
const $9693f569e0169bfd$export$7ec9d631dd0c629a = /*#__PURE__*/ $bSJIT.createContext({
    data: {
        extensions: new Map(),
        extensionToDisplay: '',
        extensionTitles: []
    },
    methods: {
        setExtensionToDisplay: (0, $4ZMmh.noop)
    }
});
$9693f569e0169bfd$export$7ec9d631dd0c629a.displayName = 'ForgeModalContext';
const $9693f569e0169bfd$export$15f67e1b244563e3 = $9693f569e0169bfd$export$7ec9d631dd0c629a.Consumer;

});

parcelRegister("hXaxc", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContextProvider", () => $e74a9c3dbe131f34$export$35485b69e4da19ba);

var $hF8Ik = parcelRequire("hF8Ik");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $e74a9c3dbe131f34$export$35485b69e4da19ba = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("fB583")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/modal-context-provider/modal-context-provider.tsx"
    }),
    LoadingSkeleton: (0, $hF8Ik.AvatarLoadingSkeleton)
});

});
parcelRegister("fB583", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3RhRQ").then(()=>parcelRequire('7yYKq'));

});


parcelRegister("dVmKA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f3595ff15b92937$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
class $8f3595ff15b92937$export$2e2bcd8739ae039 extends $bSJIT.Component {
    componentDidMount() {
        const renderNextAnimationFrame = ()=>{
            window.requestAnimationFrame(()=>{
                window.requestAnimationFrame(()=>{
                    this.setState({
                        render: true
                    });
                });
            });
        };
        if (this.props.delay) window.setTimeout(renderNextAnimationFrame, this.props.delay);
        else renderNextAnimationFrame();
    }
    render() {
        return this.state.render ? this.props.children() : null;
    }
    constructor(...args){
        super(...args), this.state = {
            render: false
        };
    }
}

});

parcelRegister("kXBd7", function(module, exports) {
$parcel$export(module.exports, "VaOnboardingSpotlight", () => $a40e6e308805f203$export$9900d5bc23cb734);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $a40e6e308805f203$export$9900d5bc23cb734 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1qqVP")), {
        moduleId: "./packages/common-utils/va-reporting-onboarding/src/va-reporting-onboarding.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("1qqVP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("hcFya"),
    $kOunM("bQ3G9"),
    $kOunM("lFMGZ")
]).then(()=>parcelRequire('aVclN'));

});


parcelRegister("5zqhO", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $440c6a70698008f9$export$5120f2d0b8d4cab8);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fVqEt = parcelRequire("fVqEt");
const $440c6a70698008f9$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fVqEt.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("fVqEt", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $24a85bd5b63a0141$export$c25acd513dcc8062);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $2U5M0 = parcelRequire("2U5M0");

var $lavtv = parcelRequire("lavtv");

var $9Tu9C = parcelRequire("9Tu9C");

var $hpFRd = parcelRequire("hpFRd");
const $24a85bd5b63a0141$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $9Tu9C.useTheme)();
    const button = /*#__PURE__*/ (0, $dc70d.jsx)((0, $2U5M0.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $hpFRd.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});

});
parcelRegister("9Tu9C", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $dc819dc33d5d13d4$export$93d4e7f90805808f);

var $bSJIT = parcelRequire("bSJIT");

var $kKOMt = parcelRequire("kKOMt");
const $dc819dc33d5d13d4$export$93d4e7f90805808f = ()=>(0, $bSJIT.useContext)((0, $kKOMt.ThemeContext));

});
parcelRegister("kKOMt", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $cd03174265e4f9ad$export$2c657da244d00bd6);

var $bSJIT = parcelRequire("bSJIT");

var $fkjDw = parcelRequire("fkjDw");
const $cd03174265e4f9ad$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $bSJIT.createContext)((0, $fkjDw.defaultTheme));

});
parcelRegister("fkjDw", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $7ce12579bec79c41$export$164de7ab8df77ef0);

var $1iLxs = parcelRequire("1iLxs");
const $7ce12579bec79c41$export$164de7ab8df77ef0 = (0, $1iLxs.atlassianTheme);

});
parcelRegister("1iLxs", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $ee8ab9a414baf706$export$eeee8619e1b91cb0);

var $f8QoD = parcelRequire("f8QoD");

var $hglIo = parcelRequire("hglIo");
const $ee8ab9a414baf706$export$eeee8619e1b91cb0 = (0, $hglIo.generateTheme)({
    name: (0, $f8QoD.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});
parcelRegister("f8QoD", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $26ea1d6d1ad79f4f$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $26ea1d6d1ad79f4f$export$2e2bcd8739ae039);
const $26ea1d6d1ad79f4f$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $26ea1d6d1ad79f4f$var$defaultThemeCopy = JSON.parse(JSON.stringify($26ea1d6d1ad79f4f$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$26ea1d6d1ad79f4f$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$26ea1d6d1ad79f4f$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $26ea1d6d1ad79f4f$export$2491e13b198e597d = 'atlassian';
var $26ea1d6d1ad79f4f$export$2e2bcd8739ae039 = $26ea1d6d1ad79f4f$var$defaultTheme;

});

parcelRegister("hglIo", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $85aedd50e233094a$export$2e4ecffaca289a18);

var $f8QoD = parcelRequire("f8QoD");

var $aqOT4 = parcelRequire("aqOT4");

var $5d3zb = parcelRequire("5d3zb");

var $lkjBP = parcelRequire("lkjBP");

var $9Lgy8 = parcelRequire("9Lgy8");

var $lxLDM = parcelRequire("lxLDM");
const $85aedd50e233094a$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $85aedd50e233094a$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $85aedd50e233094a$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $lxLDM.hexToRGBA)(backgroundColor, 0.65) : (0, $9Lgy8.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $lkjBP.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $lkjBP.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $lxLDM.hexToRGBA)(backgroundColor, 0.8) : (0, $9Lgy8.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $lkjBP.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $9Lgy8.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $lkjBP.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $9Lgy8.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $lkjBP.getBoxShadow)('transparent')
        }
    };
};
const $85aedd50e233094a$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $5d3zb.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $85aedd50e233094a$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $5d3zb.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $f8QoD.DEFAULT_THEME_NAME)) return 0, $aqOT4.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $85aedd50e233094a$var$generateButtonCSSStates($85aedd50e233094a$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $85aedd50e233094a$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $85aedd50e233094a$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $lxLDM.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $lxLDM.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $lxLDM.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $lkjBP.getBoxShadow)((0, $lxLDM.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $9Lgy8.getContrastColor)(0.1, $85aedd50e233094a$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("aqOT4", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $42604c4e0332f7a6$export$77823bc9863eaa03);

var $f8QoD = parcelRequire("f8QoD");
const $42604c4e0332f7a6$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $f8QoD.default)));
const $42604c4e0332f7a6$export$77823bc9863eaa03 = $42604c4e0332f7a6$var$defaultThemeCopy;

});

parcelRegister("5d3zb", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $635d18ec501b7334$export$10a10e7cd1193377);

var $7qLn8 = parcelRequire("7qLn8");

var $4N7h6 = parcelRequire("4N7h6");
const $635d18ec501b7334$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $4N7h6.convertHexShorthand)(color);
    return (0, $7qLn8.default).contrastRatio(converted).hex;
};

});
parcelRegister("7qLn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $568fb534fdccc938$export$2e2bcd8739ae039);
function $568fb534fdccc938$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $568fb534fdccc938$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $568fb534fdccc938$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $568fb534fdccc938$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $568fb534fdccc938$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $568fb534fdccc938$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $568fb534fdccc938$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $568fb534fdccc938$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $568fb534fdccc938$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $568fb534fdccc938$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $568fb534fdccc938$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $568fb534fdccc938$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $568fb534fdccc938$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $568fb534fdccc938$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $568fb534fdccc938$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $568fb534fdccc938$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $568fb534fdccc938$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $568fb534fdccc938$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $568fb534fdccc938$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $568fb534fdccc938$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $568fb534fdccc938$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $568fb534fdccc938$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $568fb534fdccc938$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $568fb534fdccc938$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $568fb534fdccc938$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $568fb534fdccc938$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $568fb534fdccc938$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $568fb534fdccc938$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $568fb534fdccc938$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $568fb534fdccc938$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $568fb534fdccc938$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $568fb534fdccc938$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $568fb534fdccc938$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $568fb534fdccc938$var$fromHex_1 = $568fb534fdccc938$var$fromHex, $568fb534fdccc938$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $568fb534fdccc938$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $568fb534fdccc938$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $568fb534fdccc938$var$fromRgb_1 = $568fb534fdccc938$var$fromRgb, $568fb534fdccc938$var$fromCssRgb_1 = $568fb534fdccc938$var$fromCssRgb, $568fb534fdccc938$var$fromHsl_1 = $568fb534fdccc938$var$fromHsl, $568fb534fdccc938$var$fromCssHsl_1 = $568fb534fdccc938$var$fromCssHsl, $568fb534fdccc938$var$fromHsv_1 = $568fb534fdccc938$var$fromHsv, $568fb534fdccc938$var$fromCmyk_1 = $568fb534fdccc938$var$fromCmyk, $568fb534fdccc938$var$fromYiq_1 = $568fb534fdccc938$var$fromYiq, $568fb534fdccc938$var$fromXYZ_1 = $568fb534fdccc938$var$fromXYZ, $568fb534fdccc938$var$fromxyY_1 = $568fb534fdccc938$var$fromxyY, $568fb534fdccc938$var$fromLms_1 = $568fb534fdccc938$var$fromLms, $568fb534fdccc938$var$fromCieLab_1 = $568fb534fdccc938$var$fromCieLab, $568fb534fdccc938$var$fromCieLuv_1 = $568fb534fdccc938$var$fromCieLuv, $568fb534fdccc938$var$fromCieLch_1 = $568fb534fdccc938$var$fromCieLch, $568fb534fdccc938$var$fromHsluv = $568fb534fdccc938$var$fromCieLch$1, $568fb534fdccc938$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $568fb534fdccc938$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $568fb534fdccc938$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $568fb534fdccc938$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $568fb534fdccc938$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $568fb534fdccc938$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $568fb534fdccc938$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $568fb534fdccc938$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $568fb534fdccc938$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $568fb534fdccc938$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $568fb534fdccc938$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $568fb534fdccc938$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $568fb534fdccc938$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $568fb534fdccc938$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $568fb534fdccc938$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $568fb534fdccc938$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $568fb534fdccc938$var$fromHsluv
    }
}, $568fb534fdccc938$var$adapt_1 = $568fb534fdccc938$var$adapt, $568fb534fdccc938$var$adjacent_1 = $568fb534fdccc938$var$adjacent, $568fb534fdccc938$var$brightness_1 = $568fb534fdccc938$var$brightness, $568fb534fdccc938$var$complementary_1 = $568fb534fdccc938$var$complementary, $568fb534fdccc938$var$contrast_1 = $568fb534fdccc938$var$contrast, $568fb534fdccc938$var$contrastRatio_1 = $568fb534fdccc938$var$contrastRatio, $568fb534fdccc938$var$convert_1 = $568fb534fdccc938$var$convert, $568fb534fdccc938$var$difference_1 = $568fb534fdccc938$var$difference, $568fb534fdccc938$var$fade_1 = $568fb534fdccc938$var$fade, $568fb534fdccc938$var$greyscale_1 = $568fb534fdccc938$var$greyscale, $568fb534fdccc938$var$hue_1 = $568fb534fdccc938$var$hue, $568fb534fdccc938$var$invert_1 = $568fb534fdccc938$var$invert, $568fb534fdccc938$var$invertLightness_1 = $568fb534fdccc938$var$invertLightness, $568fb534fdccc938$var$mid_1 = $568fb534fdccc938$var$mid, $568fb534fdccc938$var$multiply_1 = $568fb534fdccc938$var$multiply, $568fb534fdccc938$var$saturation_1 = $568fb534fdccc938$var$saturation, $568fb534fdccc938$var$sepia_1 = $568fb534fdccc938$var$sepia, $568fb534fdccc938$var$shade_1 = $568fb534fdccc938$var$shade, $568fb534fdccc938$var$temperature_1 = $568fb534fdccc938$var$temperature, $568fb534fdccc938$var$tetrad_1 = $568fb534fdccc938$var$tetrad, $568fb534fdccc938$var$triad_1 = $568fb534fdccc938$var$triad, $568fb534fdccc938$var$index$2 = {
    adapt: $568fb534fdccc938$var$adapt_1,
    adjacent: $568fb534fdccc938$var$adjacent_1,
    brightness: $568fb534fdccc938$var$brightness_1,
    complementary: $568fb534fdccc938$var$complementary_1,
    contrast: $568fb534fdccc938$var$contrast_1,
    contrastRatio: $568fb534fdccc938$var$contrastRatio_1,
    convert: $568fb534fdccc938$var$convert_1,
    difference: $568fb534fdccc938$var$difference_1,
    fade: $568fb534fdccc938$var$fade_1,
    greyscale: $568fb534fdccc938$var$greyscale_1,
    hue: $568fb534fdccc938$var$hue_1,
    invert: $568fb534fdccc938$var$invert_1,
    invertLightness: $568fb534fdccc938$var$invertLightness_1,
    mid: $568fb534fdccc938$var$mid_1,
    multiply: $568fb534fdccc938$var$multiply_1,
    saturation: $568fb534fdccc938$var$saturation_1,
    sepia: $568fb534fdccc938$var$sepia_1,
    shade: $568fb534fdccc938$var$shade_1,
    temperature: $568fb534fdccc938$var$temperature_1,
    tetrad: $568fb534fdccc938$var$tetrad_1,
    triad: $568fb534fdccc938$var$triad_1
}, $568fb534fdccc938$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $568fb534fdccc938$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $568fb534fdccc938$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($568fb534fdccc938$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $568fb534fdccc938$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($568fb534fdccc938$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $568fb534fdccc938$var$api_1 = $568fb534fdccc938$var$api, $568fb534fdccc938$var$helpers = {
    getIlluminant: function(r) {
        return $568fb534fdccc938$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $568fb534fdccc938$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $568fb534fdccc938$var$index)if ($568fb534fdccc938$var$index.hasOwnProperty(e) && $568fb534fdccc938$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $568fb534fdccc938$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $568fb534fdccc938$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $568fb534fdccc938$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $568fb534fdccc938$var$constants, s));
            default:
                return null;
        }
    }
}, $568fb534fdccc938$var$helpers_1 = $568fb534fdccc938$var$helpers, $568fb534fdccc938$var$dependencies = {
    conversions: $568fb534fdccc938$var$index,
    operations: $568fb534fdccc938$var$index$2,
    helpers: $568fb534fdccc938$var$helpers_1
}, $568fb534fdccc938$var$entry = $568fb534fdccc938$var$api_1($568fb534fdccc938$var$dependencies, $568fb534fdccc938$var$constants);
var $568fb534fdccc938$export$2e2bcd8739ae039 = $568fb534fdccc938$var$entry;

});

parcelRegister("4N7h6", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $0cb3b8e54b39451f$export$db8d2130677f868c);
const $0cb3b8e54b39451f$var$hex = '[a-z0-9]';
const $0cb3b8e54b39451f$var$shortHandHexColorPattern = new RegExp(`#(${$0cb3b8e54b39451f$var$hex})(${$0cb3b8e54b39451f$var$hex})(${$0cb3b8e54b39451f$var$hex})`, 'i');
const $0cb3b8e54b39451f$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $0cb3b8e54b39451f$var$isShortHexColor = (color)=>color && color.length === 4;
const $0cb3b8e54b39451f$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$0cb3b8e54b39451f$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $0cb3b8e54b39451f$var$completeTriplet = (colors)=>`#${$0cb3b8e54b39451f$var$repeat(colors[1], 6)}`;
const $0cb3b8e54b39451f$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $0cb3b8e54b39451f$export$db8d2130677f868c = (color)=>{
    if ($0cb3b8e54b39451f$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($0cb3b8e54b39451f$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($0cb3b8e54b39451f$var$isTriplet(colors)) return $0cb3b8e54b39451f$var$completeTriplet(colors);
            else return $0cb3b8e54b39451f$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("lkjBP", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $0d1c2ac869659df7$export$bba5a971afe05444);
const $0d1c2ac869659df7$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("9Lgy8", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $eb8bc93e978165bd$export$77a1051494882576);

var $7qLn8 = parcelRequire("7qLn8");

var $lxLDM = parcelRequire("lxLDM");
const $eb8bc93e978165bd$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $lxLDM.hexToRGBA)((0, $7qLn8.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("lxLDM", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $dec552c1d3f6bc57$export$7229be6d7219ee6a);

var $7qLn8 = parcelRequire("7qLn8");
const $dec552c1d3f6bc57$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $7qLn8.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});







parcelRegister("hpFRd", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", () => $4a738fb074ab79ba$export$f32bddcb857301f3);
const $4a738fb074ab79ba$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("cExzV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ce48acaf447f1e6$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $1emO3 = parcelRequire("1emO3");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $8ce48acaf447f1e6$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $8ce48acaf447f1e6$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $8ce48acaf447f1e6$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $8ce48acaf447f1e6$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $8ce48acaf447f1e6$var$LegacyLozenge = /*#__PURE__*/ (0, $bSJIT.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $bSJIT.useMemo)(()=>$8ce48acaf447f1e6$var$appearanceTypes.includes(appearance) || $8ce48acaf447f1e6$var$newSemanticColors.includes(appearance) ? $8ce48acaf447f1e6$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $8ce48acaf447f1e6$var$styles.container,
            $8ce48acaf447f1e6$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $8ce48acaf447f1e6$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $8ce48acaf447f1e6$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            style: {
                color: style === null || style === void 0 ? void 0 : style.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $9fU1q.default)([
                $8ce48acaf447f1e6$var$styles.text,
                $8ce48acaf447f1e6$var$styles.customLetterspacing,
                $8ce48acaf447f1e6$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$8ce48acaf447f1e6$var$LegacyLozenge.displayName = 'Lozenge';
var $8ce48acaf447f1e6$export$2e2bcd8739ae039 = (0, $1emO3.default);

});
parcelRegister("1emO3", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb8de686bb4adf85$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $mvrOP = parcelRequire("mvrOP");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $eb8de686bb4adf85$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $mvrOP.default), {
        ...baseProps,
        children: children
    });
};
$eb8de686bb4adf85$var$Lozenge.displayName = 'Lozenge';
var $eb8de686bb4adf85$export$2e2bcd8739ae039 = $eb8de686bb4adf85$var$Lozenge;

});
parcelRegister("mvrOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $327901274d873156$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $41GeV = parcelRequire("41GeV");

var $jDsoo = parcelRequire("jDsoo");

var $ghAbV = parcelRequire("ghAbV");

var $4GWyU = parcelRequire("4GWyU");

var $eAVHM = parcelRequire("eAVHM");

var $gdUUy = parcelRequire("gdUUy");

var $aHbh3 = parcelRequire("aHbh3");

var $hDkm2 = parcelRequire("hDkm2");

var $jvVCA = parcelRequire("jvVCA");

var $bGuRG = parcelRequire("bGuRG");

var $6kVUJ = parcelRequire("6kVUJ");
// Get the pressed background color for the selected lozenge dropdown trigger
const $327901274d873156$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $327901274d873156$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
const $327901274d873156$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $327901274d873156$var$LozengeBase = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const enableTruncationFixFG = (0, $gdUUy.fg)('platform-dst-motion-lozenge-truncation-fix');
    const [resizing, setResizing] = (0, $bSJIT.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $bSJIT.useState)(false);
    const textRef = (0, $bSJIT.useRef)(null);
    const onFinishMotion = ()=>setResizing(false);
    // `onStartMotion` fires while the element is at its natural layout, just before the resize
    // animation starts, this allows us to calculate whether the text will be truncated at its
    // final state
    const onStartMotion = ()=>{
        const textElement = textRef.current;
        if (textElement) setIsTruncated(textElement.scrollWidth > textElement.clientWidth);
    };
    const resizingWidth = (0, $eAVHM.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion,
        onStartMotion: enableTruncationFixFG ? onStartMotion : undefined
    });
    const isInitialRender = (0, $bSJIT.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $6kVUJ.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $jvVCA.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $6kVUJ.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $ghAbV.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $gdUUy.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
        "data-testid": testId ? `${testId}--content` : undefined,
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $9fU1q.default)([
            $327901274d873156$var$styles.content,
            spacing === 'spacious' && $327901274d873156$var$styles.contentSpacious,
            isInteractive && $327901274d873156$var$styles.loadingMotion,
            isLoading && $327901274d873156$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $327901274d873156$var$styles.maxWidth
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $dc70d.jsx)((0, $bGuRG.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                ref: textRef,
                style: {
                    // The text fills 100% of the inner content wrapper. The container's
                    // own max-width (set on the container via commonStyleOverrides) handles
                    // the actual size constraint, so the text just needs to fill the available
                    // space and truncate when it overflows.
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style === null || style === void 0 ? void 0 : style.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $9fU1q.default)([
                    $327901274d873156$var$styles.text,
                    enableMotionFG && resizing && (enableTruncationFixFG ? !isTruncated : // Clip during animating width changes, but not when a maxWidth is specified
                    !maxWidth) ? $327901274d873156$var$styles.textClip : $327901274d873156$var$styles.textEllipsis,
                    spacing === 'spacious' && $327901274d873156$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $9fU1q.default)([
                    $327901274d873156$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $41GeV.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aHbh3.default), {
        ref: ref,
        xcss: (0, $jDsoo.cx)($327901274d873156$var$styles.container, !isLoading ? $327901274d873156$var$interactiveMotionStyles.motion : enableMotionFG && $327901274d873156$var$styles.motionContainer, spacing === 'spacious' && $327901274d873156$var$styles.containerSpacious, !isSelected && $327901274d873156$var$styles.iconBorderFilter, $327901274d873156$var$styles[colorStyleKey], !isLoading && $327901274d873156$var$styles[interactiveStyleKey], hasTrailingMetric && $327901274d873156$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $327901274d873156$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $327901274d873156$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        },
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                "data-testid": testId ? `${testId}--loading-overlay` : undefined,
                className: (0, $9fU1q.default)([
                    $327901274d873156$var$styles.loadingOverlay,
                    $327901274d873156$var$styles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $327901274d873156$var$styles.container,
            spacing === 'spacious' && $327901274d873156$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $327901274d873156$var$styles.containerBadgePadding,
            $327901274d873156$var$styles[colorStyleKey],
            $327901274d873156$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $327901274d873156$var$styles.containerBadgeNeutralAppearance
        ]),
        children: innerContent
    });
}));
var $327901274d873156$export$2e2bcd8739ae039 = $327901274d873156$var$LozengeBase;

});
parcelRegister("41GeV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dcd8a55f48095ea$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $8aT4G = parcelRequire("8aT4G");

var $ceb9s = parcelRequire("ceb9s");

var $cbc2h = parcelRequire("cbc2h");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
const $2dcd8a55f48095ea$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $2dcd8a55f48095ea$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $cbc2h.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ const $2dcd8a55f48095ea$var$BadgeNew = /*#__PURE__*/ (0, $bSJIT.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $9fU1q.default)([
            $2dcd8a55f48095ea$var$stylesNew.root,
            $2dcd8a55f48095ea$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $2dcd8a55f48095ea$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $2dcd8a55f48095ea$export$2e2bcd8739ae039 = $2dcd8a55f48095ea$var$BadgeNew;

});
parcelRegister("ceb9s", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $2d38e8f7a225524a$export$3dd7971102e44fa8);

var $bSJIT = parcelRequire("bSJIT");

var $bDsJN = parcelRequire("bDsJN");

var $bTehu = parcelRequire("bTehu");
const $2d38e8f7a225524a$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $bSJIT.useState)((0, $bDsJN.getGlobalTheme)());
    (0, $bSJIT.useEffect)(()=>{
        const observer = new (0, $bTehu.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $2d38e8f7a225524a$export$2e2bcd8739ae039 = $2d38e8f7a225524a$export$3dd7971102e44fa8;

});

parcelRegister("cbc2h", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $bdae74a1c3fae011$export$7c4d25c0c3217d8c);
function $bdae74a1c3fae011$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $bdae74a1c3fae011$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $bdae74a1c3fae011$var$getSafeValue(value);
    const safeMax = $bdae74a1c3fae011$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("eAVHM", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $c4a3b5b164e8a5bc$export$a300664a1a230956);

var $bSJIT = parcelRequire("bSJIT");

var $iWZGm = parcelRequire("iWZGm");

var $1V8O7 = parcelRequire("1V8O7");

var $4Ajbl = parcelRequire("4Ajbl");

var $e1fGp = parcelRequire("e1fGp");

var $1QkMl = parcelRequire("1QkMl");

var $3TS96 = parcelRequire("3TS96");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $c4a3b5b164e8a5bc$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $c4a3b5b164e8a5bc$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $c4a3b5b164e8a5bc$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $c4a3b5b164e8a5bc$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $bSJIT.useRef)();
    const [element, setElementRef] = (0, $1V8O7.useElementRef)();
    const setTimeout = (0, $1QkMl.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $e1fGp.useRequestAnimationFrame)();
    (0, $3TS96.useSnapshotBeforeUpdate)(()=>{
        if ((0, $iWZGm.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $4Ajbl.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $iWZGm.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$c4a3b5b164e8a5bc$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion === null || onStartMotion === void 0 || onStartMotion();
        const propertyList = $c4a3b5b164e8a5bc$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $c4a3b5b164e8a5bc$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});

parcelRegister("aHbh3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Pressable", () => $19a67533f0fe703f$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $19a67533f0fe703f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $cyIUy = parcelRequire("cyIUy");

var $ivKmQ = parcelRequire("ivKmQ");

var $fQ18X = parcelRequire("fQ18X");

var $jkSvc = parcelRequire("jkSvc");

var $2UbVv = parcelRequire("2UbVv");

var $gfZ3w = parcelRequire("gfZ3w");

var $cCXmu = parcelRequire("cCXmu");
function $19a67533f0fe703f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $19a67533f0fe703f$var$focusRingStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $fQ18X.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $cCXmu.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $jkSvc.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $jkSvc.borderWidthMap)['border.width']} solid`
        }
    }
});
const $19a67533f0fe703f$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $19a67533f0fe703f$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $19a67533f0fe703f$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $19a67533f0fe703f$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $1OdZP.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $gfZ3w.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9dQre.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $19a67533f0fe703f$var$baseStyles,
            $19a67533f0fe703f$var$focusRingStyles,
            isDisabled ? $19a67533f0fe703f$var$disabledStyles : $19a67533f0fe703f$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ivKmQ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $2UbVv.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $2UbVv.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $2UbVv.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $2UbVv.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $2UbVv.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $2UbVv.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $2UbVv.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$19a67533f0fe703f$export$2e2bcd8739ae039 = $19a67533f0fe703f$export$27c701ed9e449e99;

});

parcelRegister("jvVCA", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $4b4e8428f1f3848a$export$a3fc04b8551e006a);
const $4b4e8428f1f3848a$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("bGuRG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c51bae27ce4f390$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $0c51bae27ce4f390$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $0c51bae27ce4f390$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ const $0c51bae27ce4f390$var$IconRenderer = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $0c51bae27ce4f390$var$getIconColor(color);
    return (0, $gdUUy.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $0c51bae27ce4f390$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0c51bae27ce4f390$export$2e2bcd8739ae039 = $0c51bae27ce4f390$var$IconRenderer;

});

parcelRegister("6kVUJ", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $f8737ee457d456fc$export$acf5d2b7dc999bda);
// Map legacy appearance to new color values
const $f8737ee457d456fc$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $f8737ee457d456fc$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $f8737ee457d456fc$var$legacyAppearanceMap[appearance] ?? appearance;
};

});




parcelRegister("cjQhO", function(module, exports) {
$parcel$export(module.exports, "default", () => $65452dea92411e5c$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $cyIUy = parcelRequire("cyIUy");

var $9hBeo = parcelRequire("9hBeo");
const $65452dea92411e5c$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * @deprecated
 * CustomItem must not be used and will be deleted soon. Custom menu items are not supported.
 * Use ButtonItem or LinkItem instead. If you need a custom list item, do not use `@atlaskit/menu`.
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $65452dea92411e5c$var$CustomItem = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9hBeo.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $65452dea92411e5c$var$preventEvent
                },
                onMouseDown: isDisabled ? $65452dea92411e5c$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $65452dea92411e5c$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined,
                children: children
            })
    });
}));
var $65452dea92411e5c$export$2e2bcd8739ae039 = $65452dea92411e5c$var$CustomItem;

});

parcelRegister("fsfgu", function(module, exports) {
$parcel$export(module.exports, "default", () => $200a850c0c07a06d$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $200a850c0c07a06d$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $200a850c0c07a06d$var$HeadingItem = /*#__PURE__*/ (0, $bSJIT.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $200a850c0c07a06d$export$2e2bcd8739ae039 = $200a850c0c07a06d$var$HeadingItem;

});

parcelRegister("65Fe1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f5419aae2245c4d$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4wpvI = parcelRequire("4wpvI");

var $1VahP = parcelRequire("1VahP");
const $9f5419aae2245c4d$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $9f5419aae2245c4d$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $4wpvI.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1VahP.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $9fU1q.default)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
var $9f5419aae2245c4d$export$2e2bcd8739ae039 = $9f5419aae2245c4d$var$MenuGroup;

});

parcelRegister("7LtMZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55a0fab43738e4a6$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fsfgu = parcelRequire("fsfgu");
const $55a0fab43738e4a6$var$itemHeadingTopMargin = 20;
const $55a0fab43738e4a6$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $55a0fab43738e4a6$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $55a0fab43738e4a6$var$skeletonHeadingHeight = 8;
const $55a0fab43738e4a6$var$skeletonHeadingMarginOffset = 3;
const $55a0fab43738e4a6$var$skeletonHeadingTopMargin = $55a0fab43738e4a6$var$itemHeadingTopMargin + ($55a0fab43738e4a6$var$itemHeadingContentHeight - $55a0fab43738e4a6$var$skeletonHeadingHeight) - $55a0fab43738e4a6$var$skeletonHeadingMarginOffset;
const $55a0fab43738e4a6$var$sectionPaddingTopBottom = 6;
const $55a0fab43738e4a6$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $55a0fab43738e4a6$var$Section = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $dc70d.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $bSJIT.Children).map((0, $bSJIT.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $dc70d.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fsfgu.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $9fU1q.default)([
                    isSideNavSection && $55a0fab43738e4a6$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            $55a0fab43738e4a6$var$styles.root,
            isScrollable ? $55a0fab43738e4a6$var$styles.scrollable : $55a0fab43738e4a6$var$styles.unscrollable,
            hasSeparator ? $55a0fab43738e4a6$var$styles.thinSeparator : $55a0fab43738e4a6$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $55a0fab43738e4a6$export$2e2bcd8739ae039 = $55a0fab43738e4a6$var$Section;

});

parcelRegister("9cAYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $76244ef2e11d7559$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $6W3jk = parcelRequire("6W3jk");

var $9ym5V = parcelRequire("9ym5V");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $76244ef2e11d7559$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9ym5V.TargetConsumer), null, (getTargetRef)=>{
        if (typeof children === 'function') return children({
            targetRef: getTargetRef === null || getTargetRef === void 0 ? void 0 : getTargetRef(name)
        });
        return getTargetRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6W3jk.default), {
            name: name,
            hasNodeResolver: !(0, $gdUUy.fg)('platform_design_system_team_onboarding_noderesolve'),
            getTargetRef: getTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children)) : children;
    });
$76244ef2e11d7559$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $76244ef2e11d7559$export$2e2bcd8739ae039 = $76244ef2e11d7559$var$SpotlightTarget;

});
parcelRegister("6W3jk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e60efab81ffaeac3$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $bTXqU = parcelRequire("bTXqU");
const $e60efab81ffaeac3$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $e60efab81ffaeac3$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) {
            var _divRef$current;
            targetRef((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.firstElementChild);
        }
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTXqU))), {
        innerRef: getTargetRef(name)
    }, children);
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        ref: divRef,
        className: (0, $9fU1q.default)([
            "_1e0c1bgi"
        ])
    }, children);
};
$e60efab81ffaeac3$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $e60efab81ffaeac3$export$2e2bcd8739ae039 = $e60efab81ffaeac3$var$NodeResolverSpotlightTarget;

});
parcelRegister("bTXqU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8tSFk = parcelRequire("8tSFk");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $8aa2eeeec292e5a4$var$_interopRequireDefault($8tSFk).default;
    }
});
function $8aa2eeeec292e5a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("8tSFk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $62cb6f9c49f5cfe9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");
function $62cb6f9c49f5cfe9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $62cb6f9c49f5cfe9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $62cb6f9c49f5cfe9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $62cb6f9c49f5cfe9$var$NodeResolver = function(_Component) {
    $62cb6f9c49f5cfe9$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $62cb6f9c49f5cfe9$var$_classCallCheck(this, NodeResolver);
        return $62cb6f9c49f5cfe9$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $62cb6f9c49f5cfe9$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $4Sf72.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($bSJIT.Component);
module.exports.default = $62cb6f9c49f5cfe9$var$NodeResolver;

});




parcelRegister("1jnkF", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $7afde0bc2ee7a058$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $7afde0bc2ee7a058$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");
const $7afde0bc2ee7a058$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    isOpen: true,
    onExited: (0, $1OdZP.default)
});
// checks if children exist and are truthy
const $7afde0bc2ee7a058$var$hasChildren = (children)=>{
    var _React$Children$map;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.count(children) > 0 && (((_React$Children$map = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children || false, (child)=>!!child)) === null || _React$Children$map === void 0 || (_React$Children$map = _React$Children$map.filter(Boolean)) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.length) || 0) > 0;
};
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $7afde0bc2ee7a058$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $7afde0bc2ee7a058$var$hasChildren(previousChildren) && !$7afde0bc2ee7a058$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7afde0bc2ee7a058$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $7afde0bc2ee7a058$var$hasChildren(this.props.children)
            }
        }, this.state.currentChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $7afde0bc2ee7a058$export$7d63b19b854c2fe8 = $7afde0bc2ee7a058$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7afde0bc2ee7a058$export$2e2bcd8739ae039 = $7afde0bc2ee7a058$var$SpotlightTransition;

});

parcelRegister("8LptA", function(module, exports) {
$parcel$export(module.exports, "FireUIAnalytics", () => $816472c598fd4af1$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $816472c598fd4af1$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireScreenAnalytics", () => $816472c598fd4af1$export$2ccf161b817b43b);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");

var $clpci = parcelRequire("clpci");

var $k2MWg = parcelRequire("k2MWg");
const $816472c598fd4af1$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $816472c598fd4af1$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $816472c598fd4af1$var$FireComponent extends (0, $bSJIT.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $816472c598fd4af1$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $816472c598fd4af1$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $k2MWg.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $816472c598fd4af1$var$WithAnalytics = (0, $kIbto.default)()($816472c598fd4af1$var$FireComponent);
const $816472c598fd4af1$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($816472c598fd4af1$var$WithAnalytics, {
        ...props,
        type: (0, $clpci.UI_EVENT_TYPE)
    });
const $816472c598fd4af1$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($816472c598fd4af1$var$WithAnalytics, {
        ...props,
        type: (0, $clpci.TRACK_EVENT_TYPE)
    });
const $816472c598fd4af1$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($816472c598fd4af1$var$WithAnalytics, {
        ...props,
        type: (0, $clpci.OPERATIONAL_EVENT_TYPE)
    });
const $816472c598fd4af1$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($816472c598fd4af1$var$WithAnalytics, {
        ...props,
        type: (0, $clpci.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    });

});

parcelRegister("9P2Zq", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $726b3229fcbaade5$export$a75f3c98d930b258);

var $2FExA = parcelRequire("2FExA");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/help/help-center/manifest.ts
var $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $2FExA.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $2FExA.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/help-center/index.ts
var $726b3229fcbaade5$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $726b3229fcbaade5$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("2FExA", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $1f1edbabd40c578f$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $1f1edbabd40c578f$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $1f1edbabd40c578f$export$a4af98a27b4568ee = "help", $1f1edbabd40c578f$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("dDjgn", function(module, exports) {
$parcel$export(module.exports, "PremiumBenefitModalTrigger", () => $4f6c491a2a258262$export$6f0c4c8beb8e608a);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $5oqa3 = parcelRequire("5oqa3");

var $8RL7A = parcelRequire("8RL7A");

var $hVjvg = parcelRequire("hVjvg");

var $5LlK5 = parcelRequire("5LlK5");

var $9mmZT = parcelRequire("9mmZT");

var $dLhCs = parcelRequire("dLhCs");

var $dXrGL = parcelRequire("dXrGL");

var $1lck4 = parcelRequire("1lck4");

var $a5g0d = parcelRequire("a5g0d");

var $ardi8 = parcelRequire("ardi8");
const $4f6c491a2a258262$var$PremiumBenefitModalTriggerBase = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, showPreconditionMessage: showPreconditionMessage, preconditionCtaLink: preconditionCtaLink, ...pressableProps })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9mmZT.useAnalytics)();
    const { onClick: originalOnClick, ...restPressableProps } = pressableProps;
    const handleOnClick = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
        // Call the original onClick if it exists
        originalOnClick === null || originalOnClick === void 0 || originalOnClick(e, analyticsEvent);
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition,
        originalOnClick
    ]);
    const handleOnClose = (0, $bSJIT.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismiss',
            actionSubject: 'modal',
            actionSubjectId: 'editionBenefitsModal',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8RL7A.ModalTrigger), {
        entryPoint: (0, $ardi8.premiumEditionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: cloudId,
            product: product
        },
        entryPointProps: {
            variantId: variantId,
            touchpointId: touchpointId,
            edition: edition,
            onClose: handleOnClose,
            showPreconditionMessage: showPreconditionMessage,
            preconditionCtaLink: preconditionCtaLink
        },
        modalProps: (0, $dLhCs.MODAL_CONFIG)
    }, ({ ref: ref })=>children ? children({
            ref: ref,
            props: {
                ...restPressableProps,
                onClick: handleOnClick
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hVjvg.DiscoveryCTAButton), {
            ref: ref,
            buttonStyle: "default",
            ...restPressableProps,
            onClick: handleOnClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $a5g0d.messages).buttonTriggerTryItFree))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5LlK5.UiViewedEvent), {
        actionSubject: "modalTrigger",
        actionSubjectId: "editionBenefitsModalTrigger",
        attributes: {
            touchpointId: touchpointId,
            product: product,
            edition: edition,
            variantId: variantId
        }
    }));
};
const $4f6c491a2a258262$export$6f0c4c8beb8e608a = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, useInternalModalContextProvider: useInternalModalContextProvider, ...pressableProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1lck4.ErrorBoundary), {
        variantId: variantId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dXrGL.IntlProvider), null, useInternalModalContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5oqa3.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4f6c491a2a258262$var$PremiumBenefitModalTriggerBase, {
        cloudId: cloudId,
        product: product,
        children: children,
        variantId: variantId,
        touchpointId: touchpointId,
        edition: edition,
        ...pressableProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4f6c491a2a258262$var$PremiumBenefitModalTriggerBase, {
        cloudId: cloudId,
        product: product,
        children: children,
        variantId: variantId,
        touchpointId: touchpointId,
        edition: edition,
        ...pressableProps
    })));

});
parcelRegister("5oqa3", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $557609897456d9f4$export$7c9538f5f3c365e9);

var $bSJIT = parcelRequire("bSJIT");

var $lFaAn = parcelRequire("lFaAn");

var $bRC3K = parcelRequire("bRC3K");
const $557609897456d9f4$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $bSJIT.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $bSJIT.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $557609897456d9f4$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $bSJIT.useRef)(1);
    const [modals, setModals] = (0, $bSJIT.useState)([]);
    const modalContext = (0, $bSJIT.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bRC3K.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($557609897456d9f4$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}

});
parcelRegister("bRC3K", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $4308ef6b76e10a98$export$ab57792b9b6974a6);

var $bSJIT = parcelRequire("bSJIT");
const $4308ef6b76e10a98$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
});

});


parcelRegister("8RL7A", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $097e30635d099859$export$fb10b32cfe19f1e);

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");

var $dP4Jx = parcelRequire("dP4Jx");

var $c9mVs = parcelRequire("c9mVs");

var $2nPTS = parcelRequire("2nPTS");

var $vA3fm = parcelRequire("vA3fm");

var $kagPI = parcelRequire("kagPI");

var $bdQVY = parcelRequire("bdQVY");

var $bRC3K = parcelRequire("bRC3K");

var $dTqU5 = parcelRequire("dTqU5");

var $fWgZD = parcelRequire("fWgZD");

var $9bROY = parcelRequire("9bROY");
const $097e30635d099859$var$emptyEntryPointParams = {};
const $097e30635d099859$var$emptyEntryPointProps = {};
function $097e30635d099859$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, errorFallback: ErrorFallbackComponent, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, source: source, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText, errorTitle: errorTitle, errorText: errorText, errorCloseText: errorCloseText }) {
    const { openModal: openModal } = (0, $bSJIT.useContext)((0, $bRC3K.ModalContext));
    const environmentProvider = (0, $bdQVY.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $2nPTS.useEntryPointConfig)();
    const ModalErrorFallback = ErrorFallbackComponent ?? GlobalModalErrorFallback;
    const modalRef = (0, $bSJIT.useRef)(null);
    const { id: id, packageName: packageName, teamName: teamName } = source ?? {};
    const metricName = (0, $bSJIT.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $bSJIT.useCallback)(()=>(0, $a2qIF.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $097e30635d099859$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $bSJIT.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                var _entryPointProps$onCl;
                entryPointProps === null || entryPointProps === void 0 || (_entryPointProps$onCl = entryPointProps.onClose) === null || _entryPointProps$onCl === void 0 || _entryPointProps$onCl.call(entryPointProps, extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kagPI.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ModalErrorFallback, {
                        error: error,
                        id: id ?? metricName,
                        teamName: teamName,
                        packageName: packageName,
                        closeModal: onClose,
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTqU5.ErrorFallback), {
                            error: error,
                            closeModal: onClose,
                            errorTitle: errorTitle,
                            title: title,
                            errorText: errorText,
                            errorCloseText: errorCloseText
                        })
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError === null || onError === void 0 || onError({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9bROY.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $097e30635d099859$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
                ...modalProps,
                ref: modalRef,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnOverlayClick),
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnEscapePress)
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fWgZD.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps === null || modalProps === void 0 ? void 0 : modalProps.autoFocus,
                modalRef: modalRef
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        id,
        packageName,
        teamName,
        entryPointProps,
        ModalErrorFallback,
        onError,
        loadingText,
        errorTitle,
        errorText,
        errorCloseText
    ]);
    const triggerRef = (0, $vA3fm.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $dP4Jx.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef,
        'aria-haspopup': 'dialog'
    });
}

});
parcelRegister("2nPTS", function(module, exports) {
$parcel$export(module.exports, "useEntryPointConfig", () => $70d810b23a7f94c8$export$dfa96f26176fa91f);

var $2KROK = parcelRequire("2KROK");
function $70d810b23a7f94c8$export$dfa96f26176fa91f() {
    return 0, $2KROK.entryPointConfig;
}

});
parcelRegister("2KROK", function(module, exports) {
$parcel$export(module.exports, "entryPointConfig", () => $c8b255790bf57f6f$export$ec2e992e3170c3c4);

var $2kiEw = parcelRequire("2kiEw");
const $c8b255790bf57f6f$export$ec2e992e3170c3c4 = (0, $2kiEw.defaultEntryPointConfig);

});
parcelRegister("2kiEw", function(module, exports) {
$parcel$export(module.exports, "defaultEntryPointConfig", () => $83c3bf2003f3e19d$export$7ca620c75cbaadf0);

var $bSJIT = parcelRequire("bSJIT");

var $dbq8H = parcelRequire("dbq8H");

var $1DGz6 = parcelRequire("1DGz6");
const $83c3bf2003f3e19d$var$GlobalModalErrorFallback = ({ closeModal: closeModal, fallback: fallback })=>{
    const hasFallback = fallback != null;
    (0, $bSJIT.useEffect)(()=>{
        if (!hasFallback) closeModal();
    }, [
        closeModal,
        hasFallback
    ]);
    return fallback ?? null;
};
const $83c3bf2003f3e19d$export$7ca620c75cbaadf0 = {
    PlaceholderComponent: (0, $dbq8H.default),
    UFOSegmentComponent: (0, $1DGz6.default),
    GlobalModalErrorFallback: $83c3bf2003f3e19d$var$GlobalModalErrorFallback
};

});
parcelRegister("dbq8H", function(module, exports) {
$parcel$export(module.exports, "default", () => $903fe3cf9dc2b1b9$export$2e2bcd8739ae039);

var $8Snw1 = parcelRequire("8Snw1");
var $903fe3cf9dc2b1b9$export$2e2bcd8739ae039 = (0, $8Snw1.default);

});
parcelRegister("8Snw1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f7f409be18ef719$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1qPbZ = parcelRequire("1qPbZ");

var $702jV = parcelRequire("702jV");

var $k7k08 = parcelRequire("k7k08");
function $5f7f409be18ef719$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $bSJIT.useContext)((0, $k7k08.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $702jV.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: name,
            hold: shouldHold
        })),
        name: name
    }, children);
}

});
parcelRegister("702jV", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $5ca1a4495c7b440a$export$256c542058532d6f);

var $bSJIT = parcelRequire("bSJIT");
const $5ca1a4495c7b440a$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $5ca1a4495c7b440a$var$LazySuspenseContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $5ca1a4495c7b440a$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($5ca1a4495c7b440a$var$LazySuspenseContext);
    (0, $bSJIT.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$5ca1a4495c7b440a$var$DynamicFallback.displayName = 'DynamicFallback';
const $5ca1a4495c7b440a$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $bSJIT.useState)(null);
    const mountedRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5ca1a4495c7b440a$var$DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5ca1a4495c7b440a$var$LazySuspenseContext.Provider, {
        value: contextValue
    }, $5ca1a4495c7b440a$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: renderFallback(false)
    }, children), (!mountedRef.current || hydrationFallback) && renderFallback(true)));
};
$5ca1a4495c7b440a$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("k7k08", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $5eb801ef0e32df26$export$9ba3fe09d15de47b);

var $bSJIT = parcelRequire("bSJIT");
const $5eb801ef0e32df26$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $bSJIT.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});






parcelRegister("vA3fm", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $2739411e13e2d895$export$1ff47f24e06a5d2d);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $gdUUy = parcelRequire("gdUUy");

var $8LE4N = parcelRequire("8LE4N");
const $2739411e13e2d895$var$disabledTriggerSelector = ':disabled, [disabled], [aria-disabled="true"]';
function $2739411e13e2d895$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $bSJIT.useRef)(null);
    const eventListeners = (0, $bSJIT.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $8LE4N.useEntryPointPreload)(load);
    const clickListener = (0, $bSJIT.useMemo)(()=>{
        return ()=>{
            var _nodeRef$current;
            if ((_nodeRef$current = nodeRef.current) !== null && _nodeRef$current !== void 0 && _nodeRef$current.matches($2739411e13e2d895$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        cancelPreload,
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $bSJIT.useMemo)(()=>{
        return ()=>{
            var _nodeRef$current2;
            if ((_nodeRef$current2 = nodeRef.current) !== null && _nodeRef$current2 !== void 0 && _nodeRef$current2.matches($2739411e13e2d895$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            eagerLoad();
        };
    }, [
        cancelPreload,
        eagerLoad
    ]);
    const mouseEnterListener = (0, $bSJIT.useMemo)(()=>{
        return ()=>{
            var _nodeRef$current3;
            if ((_nodeRef$current3 = nodeRef.current) !== null && _nodeRef$current3 !== void 0 && _nodeRef$current3.matches($2739411e13e2d895$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            preloadReference();
        };
    }, [
        cancelPreload,
        preloadReference
    ]);
    const focusListener = (0, $bSJIT.useCallback)(()=>{
        // focus() can emit trusted events when a popup or modal restores focus on close.
        // Only keyboard traversal expresses fresh focus-preload intent in that case.
        if ((0, $gdUUy.fg)('platform_dst-popup-trigger-dispose-on-close')) return;
        mouseEnterListener();
    }, [
        mouseEnterListener
    ]);
    const cleanUpEventListeners = (0, $bSJIT.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $bSJIT.useCallback)((element, type, callback)=>{
        const unbind = (0, $bAB3U.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $bSJIT.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', mouseEnterListener);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', focusListener);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        mouseEnterListener,
        focusListener,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});
parcelRegister("8LE4N", function(module, exports) {
$parcel$export(module.exports, "useEntryPointPreload", () => $dc73bfbd3384590d$export$57effc2a5e3611f);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
const $dc73bfbd3384590d$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $dc73bfbd3384590d$var$TIME_TO_INTENT = 200;
function $dc73bfbd3384590d$export$57effc2a5e3611f(load) {
    const actions = (0, $bSJIT.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $gdUUy.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
        };
        const cleanupPreload = ()=>{
            var _request$preload;
            (_request$preload = request.preload) === null || _request$preload === void 0 || _request$preload.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $gdUUy.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            var _request$preload2;
            if (request.load) return request.load;
            const reference = ((_request$preload2 = request.preload) === null || _request$preload2 === void 0 ? void 0 : _request$preload2.reference) ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    var _request$preload3;
                    delete request.preloadMaxAgeTimeout;
                    (_request$preload3 = request.preload) === null || _request$preload3 === void 0 || _request$preload3.dispose();
                }, $dc73bfbd3384590d$var$PRELOAD_MAX_AGE);
            }, $dc73bfbd3384590d$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}

});


parcelRegister("kagPI", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $956504b455f31a79$export$5d4dc37edd8a3adb);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $a2qIF = parcelRequire("a2qIF");

var $bx56v = parcelRequire("bx56v");

var $BPPOK = parcelRequire("BPPOK");

var $2nPTS = parcelRequire("2nPTS");
function $956504b455f31a79$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $2nPTS.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $bx56v.useUFOReportError)();
    const onError = (0, $bSJIT.useCallback)((error, errorInfo)=>{
        onErrorLocal === null || onErrorLocal === void 0 || onErrorLocal({
            error: error,
            errorInfo: errorInfo
        });
        (0, $BPPOK.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) ?? 'Unknown error',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $bSJIT.useCallback)(({ error: error })=>{
        const onClose = (runtimeProps === null || runtimeProps === void 0 ? void 0 : runtimeProps.onClose) ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(PlaceholderComponent, {
        name: placeholderName ?? 'internal-internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a2qIF.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    })));
}
function $956504b455f31a79$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $2nPTS.useEntryPointConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(UFOSegmentComponent, {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($956504b455f31a79$var$InternalEntryPointContainerInner, props));
}

});
parcelRegister("bx56v", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $87b74eda2a4c317a$export$75d40f522062f923);

var $83k1Z = parcelRequire("83k1Z");

var $juFEH = parcelRequire("juFEH");
function $87b74eda2a4c317a$export$75d40f522062f923() {
    const ufoContext = (0, $83k1Z.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $juFEH.getActiveInteraction)();
        if (interaction !== null && interaction !== void 0 && interaction.id) (0, $juFEH.addError)(interaction.id, error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $juFEH.addErrorToAll)(error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});

parcelRegister("BPPOK", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $98ff229ecd43711e$export$b33b857ad1d9900e);

var $gdUUy = parcelRequire("gdUUy");
const $98ff229ecd43711e$var$buffer = [];
let $98ff229ecd43711e$var$push = (payload)=>{
    $98ff229ecd43711e$var$buffer.push(payload);
};
function $98ff229ecd43711e$export$b33b857ad1d9900e(payload) {
    $98ff229ecd43711e$var$push(payload);
}
function $98ff229ecd43711e$export$abd5747ea77ecab9(handler) {
    if ((0, $gdUUy.fg)('moving_jira_entry-points_api_under_platform')) {
        $98ff229ecd43711e$var$push = handler;
        $98ff229ecd43711e$var$buffer.forEach((payload)=>handler(payload));
        $98ff229ecd43711e$var$buffer.length = 0;
    }
}

});


parcelRegister("bdQVY", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $3cc3bd55020bc1ce$export$6c22afad970ad5ac);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $3cc3bd55020bc1ce$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $3cc3bd55020bc1ce$export$e237a628f59c9f4e);

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");

var $gdUUy = parcelRequire("gdUUy");

var $9qsI2 = parcelRequire("9qsI2");

var $8DSXp = parcelRequire("8DSXp");
function $3cc3bd55020bc1ce$export$6c22afad970ad5ac({ children: children }) {
    const existingRelayContext = (0, $bSJIT.useContext)((0, $a2qIF.ReactRelayContext));
    // If a compatible relay environment (one created via `createRelayEnvironment`) is already present
    // in the tree, reuse it instead of shadowing it with our own internal environment.
    if (existingRelayContext != null && (0, $9qsI2.isAtlassianRelayEnvironment)(existingRelayContext.environment) && (0, $gdUUy.fg)('relay_environment_-_reuse_product_env_when_exist')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
    // Otherwise, fall back to providing the default internal relay environment.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a2qIF.RelayEnvironmentProvider), {
        environment: (0, $8DSXp.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $3cc3bd55020bc1ce$export$43b1f3e917d65526 = $3cc3bd55020bc1ce$export$6c22afad970ad5ac;
const $3cc3bd55020bc1ce$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $bSJIT.useContext)((0, $a2qIF.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3cc3bd55020bc1ce$export$6c22afad970ad5ac, null, children);
};
function $3cc3bd55020bc1ce$export$e237a628f59c9f4e() {
    const environment = (0, $a2qIF.useRelayEnvironment)();
    return (0, $bSJIT.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("8DSXp", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $2df150a12813982c$export$df54517d175e6d6b);

var $gdUUy = parcelRequire("gdUUy");

var $9qsI2 = parcelRequire("9qsI2");

var $bx8NL = parcelRequire("bx8NL");

var $2oszF = parcelRequire("2oszF");
const $2df150a12813982c$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $2df150a12813982c$export$4a639ebead870a0c = new (0, $2oszF.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $2df150a12813982c$export$df54517d175e6d6b = (0, $9qsI2.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $2df150a12813982c$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                var _response$extensions;
                const requestId = response === null || response === void 0 || (_response$extensions = response.extensions) === null || _response$extensions === void 0 || (_response$extensions = _response$extensions.gateway) === null || _response$extensions === void 0 ? void 0 : _response$extensions.request_id;
                (0, $bx8NL.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $gdUUy.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $bx8NL.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $2df150a12813982c$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("bx8NL", function(module, exports) {
$parcel$export(module.exports, "captureErrors", () => $b4c01e05d856208c$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isStepUpAuthError", () => $b4c01e05d856208c$export$60fba4117567a49b);

var $7RHfd = parcelRequire("7RHfd");
const $b4c01e05d856208c$var$errorCollector = new Map();
const $b4c01e05d856208c$export$da396ad2a542b095 = 120000; // 2min
const $b4c01e05d856208c$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $b4c01e05d856208c$var$errorCollector.delete(key);
    }, $b4c01e05d856208c$export$da396ad2a542b095);
};
const $b4c01e05d856208c$export$c211170518c6d0f6 = (key = (0, $7RHfd.default)())=>{
    $b4c01e05d856208c$var$errorCollector.set(key, []);
    $b4c01e05d856208c$var$scheduleCleanup(key);
    return key;
};
const $b4c01e05d856208c$export$e0491a0d974dadfa = (key)=>{
    const errors = $b4c01e05d856208c$var$errorCollector.get(key);
    $b4c01e05d856208c$var$errorCollector.delete(key);
    return errors || [];
};
const $b4c01e05d856208c$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $b4c01e05d856208c$var$errorCollector.forEach((value, key)=>{
        $b4c01e05d856208c$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $b4c01e05d856208c$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $b4c01e05d856208c$export$60fba4117567a49b = (errors)=>{
    var _stepUpError$extensio;
    const stepUpError = errors.find((error)=>{
        var _error$extensions, _error$extensions2;
        return error.message.startsWith('Step-up authentication is required.') && ((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode) === 303 && ((_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.stepUpUrl);
    });
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: (stepUpError === null || stepUpError === void 0 || (_stepUpError$extensio = stepUpError.extensions) === null || _stepUpError$extensio === void 0 ? void 0 : _stepUpError$extensio.stepUpUrl) ?? undefined
    };
};

});

parcelRegister("2oszF", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $1bcc6418834e05a8$export$be21c283b097d175);

var $4270B = parcelRequire("4270B");
function $1bcc6418834e05a8$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $4270B.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $1bcc6418834e05a8$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $1bcc6418834e05a8$export$be21c283b097d175 extends (0, $4270B.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        var _window, _window2, _window3;
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 || (_window = _window.SPA_STATE) === null || _window === void 0 ? void 0 : _window[cacheName]) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.SKELETON_NAVIGATION) === null || _window2 === void 0 ? void 0 : _window2[cacheName]) || ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.__PLATFORM_SSR_AGG_CACHE__) === null || _window3 === void 0 ? void 0 : _window3[cacheName]) || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback === null || timeoutCallback === void 0 || timeoutCallback(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $1bcc6418834e05a8$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});



parcelRegister("dTqU5", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $a6a3a38801d51e35$export$8a7ad05c3ee0c78a);

var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $2w1u7 = parcelRequire("2w1u7");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $8aT4G = parcelRequire("8aT4G");
const $a6a3a38801d51e35$var$defaultErrorTitle = "Couldn't load dialog content";
const $a6a3a38801d51e35$var$defaultErrorText = 'Something went wrong while loading the dialog content. Dismiss to go back';
const $a6a3a38801d51e35$var$defaultCloseLabel = 'Close';
const $a6a3a38801d51e35$export$8a7ad05c3ee0c78a = ({ error: _, closeModal: closeModal, errorTitle: errorTitle, title: title, errorText: errorText = $a6a3a38801d51e35$var$defaultErrorText, errorCloseText: errorCloseText = $a6a3a38801d51e35$var$defaultCloseLabel })=>{
    const modalTitle = errorTitle ?? title ?? $a6a3a38801d51e35$var$defaultErrorTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), {
        hasCloseButton: true,
        closeButtonLabel: errorCloseText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
        appearance: "danger"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        as: "p"
    }, errorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "primary",
        onClick: closeModal
    }, errorCloseText)));
};

});

parcelRegister("fWgZD", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $f929225d8607c243$export$eb58c1f6b41ee511);

var $bSJIT = parcelRequire("bSJIT");

var $ehZai = parcelRequire("ehZai");

var $lMJXR = parcelRequire("lMJXR");
function $f929225d8607c243$var$FocusInsideOnLoadInner({ autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    (0, $bSJIT.useEffect)(()=>{
        // Fence for if container element doesn't exist, but this is effectively not
        // possible.
        if (!modalRef.current) return;
        // If ref provided, use that first. Else find first focusable element or
        // container if not exists
        if (autoFocusRef !== null && autoFocusRef !== void 0 && autoFocusRef.current) {
            autoFocusRef.current.focus();
            return;
        }
        const firstFocusable = (0, $ehZai.getFirstFocusable)({
            container: modalRef.current
        });
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }
        modalRef.current.focus();
    }, [
        autoFocusRef,
        modalRef
    ]);
    return null;
}
function $f929225d8607c243$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lMJXR.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f929225d8607c243$var$FocusInsideOnLoadInner, {
        autoFocusRef: autoFocusRef,
        modalRef: modalRef
    }));
}

});
parcelRegister("lMJXR", function(module, exports) {
$parcel$export(module.exports, "WaitForEntryPointLoad", () => $4f8b56c702f4c518$export$ed96a854f3831b66);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $1OdZP = parcelRequire("1OdZP");
function $4f8b56c702f4c518$var$SuspendUntilLoaded({ entryPointReference: entryPointReference, children: children }) {
    // The result is intentionally unused — this call exists purely to gate
    // the mount of children on the load completing.
    entryPointReference.getComponent();
    return children;
}
const $4f8b56c702f4c518$var$renderNothing = ()=>null;
function $4f8b56c702f4c518$export$ed96a854f3831b66({ entryPointReference: entryPointReference, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        FallbackComponent: $4f8b56c702f4c518$var$renderNothing,
        onError: (0, $1OdZP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4f8b56c702f4c518$var$SuspendUntilLoaded, {
        entryPointReference: entryPointReference
    }, children)));
}

});


parcelRegister("9bROY", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $49d94cb333ca5b50$export$669f6ea7d267feaf);

var $bSJIT = parcelRequire("bSJIT");

var $2w1u7 = parcelRequire("2w1u7");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $hPFK4 = parcelRequire("hPFK4");
const $49d94cb333ca5b50$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hPFK4.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null));

});
parcelRegister("hPFK4", function(module, exports) {
$parcel$export(module.exports, "LoadingContent", () => $4c8e51781ab04136$export$4ab3512e4872e6ff);

var $bSJIT = parcelRequire("bSJIT");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $hDkm2 = parcelRequire("hDkm2");
const $4c8e51781ab04136$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        color: "color.text.subtle"
    }, loadingText));
};

});



parcelRegister("hVjvg", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCTAButton", () => $2fad8b66d3bcd4a7$export$1f81fec3cd5490ae);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $eou0I = parcelRequire("eou0I");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $gXqq0 = parcelRequire("gXqq0");
const $2fad8b66d3bcd4a7$var$styles = {
    base: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1qi0 _v5649dqc _1e0c116y _u5f3utpp _19bvu2gc _ca0qidpf _n3tdidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _o5721q9c",
    defaultSpacing: "_1tkezwfg",
    compactSpacing: "_1tke1tcg",
    default: "_syaz15cr _bfhkya33 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31af5 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _1di66cze",
    inverted: "_189ee4h9 _1dqonqa1 _1h6d1hqq _syazdv2p _bfhkvuon _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3kca2 _30l3dv2p _1nrm1r31 _c2waglyw _1iohnqa1 _1di61jbm",
    subtle: "_bfhksm61 _syazqmo9 _o5721q9c _irr3kca2 _1di61jbm",
    contentContainer: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconContainer: "_1e0c1txw _1bsb1tcg _4t3i1tcg _1bah1h6o _4cvr1h6o"
};
const $2fad8b66d3bcd4a7$export$1f81fec3cd5490ae = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ buttonStyle: buttonStyle, children: children, spacing: spacing, ...buttonProps }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
        ref: ref,
        ...buttonProps,
        xcss: (0, $jDsoo.cx)($2fad8b66d3bcd4a7$var$styles.base, buttonStyle === 'default' && $2fad8b66d3bcd4a7$var$styles.default, buttonStyle === 'inverted' && $2fad8b66d3bcd4a7$var$styles.inverted, buttonStyle === 'subtle' && $2fad8b66d3bcd4a7$var$styles.subtle, spacing === 'compact' ? $2fad8b66d3bcd4a7$var$styles.compactSpacing : $2fad8b66d3bcd4a7$var$styles.defaultSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $2fad8b66d3bcd4a7$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $2fad8b66d3bcd4a7$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eou0I))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), null, children)));
});

});
parcelRegister("eou0I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b7ce0838881bb0eb6f29b86e8b3a459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7aa960ec8c04c1d$var$_react = $a7aa960ec8c04c1d$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a7aa960ec8c04c1d$var$_iconNew = $a7aa960ec8c04c1d$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a7aa960ec8c04c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/editions
 * Usage guidance:
 * Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7aa960ec8c04c1d$var$EditionsIcon = (props)=>/*#__PURE__*/ $a7aa960ec8c04c1d$var$_react.default.createElement($a7aa960ec8c04c1d$var$_iconNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$a7aa960ec8c04c1d$var$EditionsIcon.displayName = 'EditionsIcon';
var $a7aa960ec8c04c1d$var$_default = module.exports.default = $a7aa960ec8c04c1d$var$EditionsIcon;

});


parcelRegister("5LlK5", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $53640b12459a799d$export$d0a9edec5c713764);

var $bSJIT = parcelRequire("bSJIT");

var $9mmZT = parcelRequire("9mmZT");
function $53640b12459a799d$export$d0a9edec5c713764({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9mmZT.useAnalytics)();
    const hasSent = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});
parcelRegister("9mmZT", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $5d8c32c44b11c9c0$export$e955abb82869dc84);
$parcel$export(module.exports, "useOperationalAnalytics", () => $5d8c32c44b11c9c0$export$18e9461e904f638a);

var $bSJIT = parcelRequire("bSJIT");

var $1l5zG = parcelRequire("1l5zG");

var $hCYNe = parcelRequire("hCYNe");

var $6WltM = parcelRequire("6WltM");
const $5d8c32c44b11c9c0$export$85183a312807388d = (0, $1l5zG.FabricChannel).growth;
const $5d8c32c44b11c9c0$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-benefits-modal',
    source: 'editionBenefitsModal'
};
const $5d8c32c44b11c9c0$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $5d8c32c44b11c9c0$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const sendAnalyticsEvent = (0, $bSJIT.useCallback)((payload)=>{
        if (payload instanceof (0, $hCYNe.default)) {
            const contextAttributes = $5d8c32c44b11c9c0$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...payload.payload.attributes,
                    ...$5d8c32c44b11c9c0$export$38cd8db2db178f58
                }
            }).fire($5d8c32c44b11c9c0$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    ...$5d8c32c44b11c9c0$export$38cd8db2db178f58
                }
            });
            const contextAttributes = $5d8c32c44b11c9c0$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($5d8c32c44b11c9c0$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
};
function $5d8c32c44b11c9c0$export$18e9461e904f638a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    return (0, $bSJIT.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...$5d8c32c44b11c9c0$export$38cd8db2db178f58,
                ...attributes
            }
        });
        const contextAttributes = $5d8c32c44b11c9c0$export$d97c97ed77ff09e8(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire($5d8c32c44b11c9c0$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
}

});


parcelRegister("dLhCs", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONFIG", () => $50804acd6a15febf$export$310af821ace1b0a4);
$parcel$export(module.exports, "SERVICE_COLLECTION_PRICING_PAGE_URL", () => $50804acd6a15febf$export$73d1ac3f0d282717);
$parcel$export(module.exports, "ADMIN_BILLING_PATH", () => $50804acd6a15febf$export$fe159292463016ac);
$parcel$export(module.exports, "JSM_STORAGE_MANAGEMENT_PATH", () => $50804acd6a15febf$export$2ef4407f4b54d009);
$parcel$export(module.exports, "CSM_STORAGE_MANAGEMENT_PATH", () => $50804acd6a15febf$export$1f6e874869664558);
$parcel$export(module.exports, "CANCEL_SUBSCRIPTION_SAC_URL", () => $50804acd6a15febf$export$5911f793141d3670);
$parcel$export(module.exports, "JSM_PRICING_PAGE_URL", () => $50804acd6a15febf$export$f3616073c30968f9);
$parcel$export(module.exports, "INCIDENTS_SLACK_INTEGRATION_VIDEO_URL", () => $50804acd6a15febf$export$6a49267b3da8f732);
const $50804acd6a15febf$export$310af821ace1b0a4 = {
    width: 'x-large',
    shouldScrollInViewport: true
};
const $50804acd6a15febf$export$e2be65a9b817a3d8 = {
    ...$50804acd6a15febf$export$310af821ace1b0a4,
    width: 960
};
const $50804acd6a15febf$export$73d1ac3f0d282717 = 'https://www.atlassian.com/collections/service/pricing';
const $50804acd6a15febf$export$fe159292463016ac = '/admin/billing';
const $50804acd6a15febf$export$2ef4407f4b54d009 = '/jira/settings/products/jira-service-management-storage-management';
const $50804acd6a15febf$export$1f6e874869664558 = '/jira/settings/products/customerservice/storage-management';
const $50804acd6a15febf$export$5911f793141d3670 = 'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';
const $50804acd6a15febf$export$f3616073c30968f9 = 'http://www.atlassian.com/software/jira/service-management/product-pricing';
const $50804acd6a15febf$export$6a49267b3da8f732 = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;

});

parcelRegister("dXrGL", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $69d9c25a5c058199$export$480518999dfc4151);

var $bSJIT = parcelRequire("bSJIT");

var $igKbN = parcelRequire("igKbN");

var $cIwFH = parcelRequire("cIwFH");

var $aJmj9 = parcelRequire("aJmj9");

var $aceDa = parcelRequire("aceDa");

var $jYVAf = parcelRequire("jYVAf");
const $69d9c25a5c058199$var$defaultMessagesWithStandardBenefits = {
    ...(0, $aJmj9.defaultLocale),
    ...(0, $jYVAf.standardBenefitsFallbackMessages),
    ...(0, $cIwFH.examplesSectionFallbackMessages),
    ...(0, $aceDa.popupFallbackMessages)
};
const $69d9c25a5c058199$export$480518999dfc4151 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $igKbN.default), {
        defaultMessages: $69d9c25a5c058199$var$defaultMessagesWithStandardBenefits,
        loaderFn: (0, $aJmj9.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("cIwFH", function(module, exports) {
$parcel$export(module.exports, "examplesSectionFallbackMessages", () => $fae6c57e063a7fab$export$7ea3822e86d2fcfd);

var $8DdrT = parcelRequire("8DdrT");
function $fae6c57e063a7fab$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $fae6c57e063a7fab$export$7ea3822e86d2fcfd = Object.fromEntries(Object.values((0, $8DdrT.examplesSectionMessages)).filter($fae6c57e063a7fab$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("8DdrT", function(module, exports) {
$parcel$export(module.exports, "examplesSectionMessages", () => $008906b5b4e0ee34$export$1edce390ed9bf8d2);

var $f0Pt4 = parcelRequire("f0Pt4");
const $008906b5b4e0ee34$export$1edce390ed9bf8d2 = (0, $f0Pt4.defineMessages)({
    incidentsVideoIframeTitle: {
        id: '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title',
        defaultMessage: 'YouTube video player',
        description: 'Accessible title for the incidents Slack integration YouTube embed iframe'
    }
});

});


parcelRegister("aJmj9", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $399ca173956e9d08$export$d7f512c98c859244);
$parcel$export(module.exports, "fetchMessagesForLocale", () => $399ca173956e9d08$export$2b153a2030b0feb2);

var $gJy4E = parcelRequire("gJy4E");

var $9DEbd = parcelRequire("9DEbd");
const $399ca173956e9d08$export$d7f512c98c859244 = (0, $9DEbd.default);
const $399ca173956e9d08$var$localeMap = {
    pt: 'pt_BR',
    'pt-PT': 'pt_BR',
    'en-AU': 'en_GB'
};
const $399ca173956e9d08$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($399ca173956e9d08$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (!targetLocale) throw new Error('No mapped locale');
        const messages = await (0, $gJy4E.locales)[targetLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await (0, $gJy4E.locales)[parentLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return $399ca173956e9d08$export$d7f512c98c859244;
};

});
parcelRegister("gJy4E", function(module, exports) {
$parcel$export(module.exports, "locales", () => $fb1a72c3e54cf3d6$export$df1c34db1371eeed);





























const $fb1a72c3e54cf3d6$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("izEo3")),
    da: ()=>(parcelRequire("7jYBy")),
    de: ()=>(parcelRequire("enkZT")),
    en_GB: ()=>(parcelRequire("1QBAl")),
    en_ZZ: ()=>(parcelRequire("cQFDp")),
    en: ()=>Promise.resolve((parcelRequire("9DEbd"))),
    es: ()=>(parcelRequire("ena0F")),
    fi: ()=>(parcelRequire("GLGSh")),
    fr: ()=>(parcelRequire("jUXVw")),
    hr: ()=>(parcelRequire("kFNln")),
    hu: ()=>(parcelRequire("6jmuq")),
    it: ()=>(parcelRequire("7DkjV")),
    ja: ()=>(parcelRequire("j49Wr")),
    ko: ()=>(parcelRequire("0X2L4")),
    nb: ()=>(parcelRequire("gmjF0")),
    nl: ()=>(parcelRequire("3xjiT")),
    pl: ()=>(parcelRequire("fMu8d")),
    pt_BR: ()=>(parcelRequire("6sz7n")),
    ru: ()=>(parcelRequire("hZi9U")),
    sl: ()=>(parcelRequire("gyQC3")),
    sr_RS: ()=>(parcelRequire("bhgiy")),
    sr_YR: ()=>(parcelRequire("8GDOK")),
    sv: ()=>(parcelRequire("en0GD")),
    th: ()=>(parcelRequire("2cx3P")),
    tr: ()=>(parcelRequire("2ysAk")),
    uk: ()=>(parcelRequire("gioxc")),
    vi: ()=>(parcelRequire("bOvDn")),
    zh_TW: ()=>(parcelRequire("MBjWE")),
    zh: ()=>(parcelRequire("4d0Zn"))
};

});
parcelRegister("izEo3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bjrOL").then(()=>parcelRequire('lCjP2'));

});

parcelRegister("7jYBy", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("CDwAb").then(()=>parcelRequire('jfxmj'));

});

parcelRegister("enkZT", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("51YZt").then(()=>parcelRequire('g59HR'));

});

parcelRegister("1QBAl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3X2hy").then(()=>parcelRequire('36k5U'));

});

parcelRegister("cQFDp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3jbj6").then(()=>parcelRequire('kbUU6'));

});

parcelRegister("9DEbd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9567cdbca370ccff$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8Qqgd = parcelRequire("8Qqgd");
var $9567cdbca370ccff$export$2e2bcd8739ae039 = (0, $8Qqgd.default);

});
parcelRegister("8Qqgd", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b48948b76b3cdd6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $8b48948b76b3cdd6$export$2e2bcd8739ae039 = {
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.bradley": "Bradley",
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.knowledgeArticle": "Knowledge article",
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.rovoServiceAgent": "Rovo service agent",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.bradley": "Bradley",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.csm01": "CSM-01",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.customerServiceAgent": "Customer service agent",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.customerSupportRequest": "Customer support request",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.resolved": "Resolved",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.rovoServiceAgent": "Rovo service agent",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.slash": "/",
    "@atlassian/edition-benefits-modal.assetsCSMSupportCompanionIllustration.request": "Request",
    "@atlassian/edition-benefits-modal.assetsCSMSupportCompanionIllustration.supportCompanion": "Support Companion",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.active": "ACTIVE",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.app": "App",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.objectGraph": "Object graph",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.owningTeam": "Owning team",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.percentage": "300%",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.request": "Request",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.service": "Service",
    "@atlassian/edition-benefits-modal.benefits-section.button.maybe-later": "Maybe later",
    "@atlassian/edition-benefits-modal.benefits-section.button.try-it-free": "Try it free",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1": "<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2": "<strong>Customize your help center</strong> to match your brand.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3": "<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1": "Coordinate fast with <strong>automatically created Slack channels</strong> with the right people",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2": "Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3": "<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1": "Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2": "Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3": "Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.",
    "@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization": "Try advanced Help Center customization with Premium",
    "@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration": "Resolve incidents with AI in Slack, try Premium now",
    "@atlassian/edition-benefits-modal.benefits-section.link.pricing": "See more Premium features and pricing",
    "@atlassian/edition-benefits-modal.benefits-section.subtitle": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.button-trigger.open-modal": "Open modal",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature1": "<strong>Resolve incidents faster</strong> with AI-powered alerting, auto-grouping, and root cause analysis.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature2": "<strong>Deploy safely with AI risk scoring,</strong> automated approvals, and change calendars.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature3": "<strong>Scale confidently</strong> with 24/7 Premium Support, and unlimited storage.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.branded-front-door": "<strong>Give every team a branded front door</strong> with multiple help centres",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.description": "AI-powered alerts group related incidents and surfaces root causes.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.title": "<strong>Resolve incidents faster</strong>",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.description": "24/7 Premium support and unlimited storage keep your team moving.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.title": "<strong>Scale your services confidently</strong>",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.self-service": "<strong>Improve self service</strong> with AI-powered virtual agent and no-code journeys.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.description": "Automated risk scoring and approvals to keep your deploys safe.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.title": "<strong>Ship changes without the risk</strong>",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.track-team-dependencies": "<strong>Track what your teams rely on</strong> with AI-driven workflows and up to 50,000 objects in Assets",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.alert-grouping": "AI alert grouping with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.change-management": "Try Change management with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.journeys": "Try Journeys with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.playbooks": "Try Playbooks with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.post-incident-reviews": "Try Post-incident reviews with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.problem-management": "Try Problem management with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.trial-description": "Try free for 30 days. We\u2019ll remind you before it ends. Cancel anytime.",
    "@atlassian/edition-benefits-modal.data-manager-artwork.active": "Active",
    "@atlassian/edition-benefits-modal.data-manager-artwork.card": "Access card",
    "@atlassian/edition-benefits-modal.data-manager-artwork.graph": "Object graph",
    "@atlassian/edition-benefits-modal.data-manager-artwork.laptop": "Laptop",
    "@atlassian/edition-benefits-modal.data-manager-artwork.new-card": "New access card",
    "@atlassian/edition-benefits-modal.data-manager-artwork.new-laptop": "New laptop",
    "@atlassian/edition-benefits-modal.data-manager-artwork.onboarding": "New employee onboarding",
    "@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title": "YouTube video player",
    "@atlassian/edition-benefits-modal.features-section.buttons.premium.maybe-later": "Maybe later",
    "@atlassian/edition-benefits-modal.features-section.buttons.premium.try-it-free": "Try it free",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access": "Request access",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-error-description": "Your request couldn't be sent. Please try again.",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-error-title": "Something went wrong",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-requested": "Access requested",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-success-description": "A request has been sent to your organization admin. You'll receive a notification if they grant you access.",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-success-title": "Access requested",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.add-payment-details": "Add payment details",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-ai-enabled-forms": "Explore handoff",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-assets": "Explore Assets",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-automations": "Explore Automations",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-customer-service-agent": "Explore Customer service agent",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-knowledge-base": "Explore Knowledge base",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-ops-agent": "Explore Rovo Ops agent",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-service-agent": "Explore Rovo Service agent",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-support-companion": "Explore Support Companion",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.invite-more-agents": "Invite more agents",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.manage-storage": "Manage storage",
    "@atlassian/edition-benefits-modal.features-section.description.help-center-customization": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.features-section.description.incidents-slack-integration": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.features-section.description.workforce-optimization": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.features-section.header.help-center-customization": "Try advanced Help Center customization with Premium",
    "@atlassian/edition-benefits-modal.features-section.header.incidents-slack-integration": "Resolve incidents with AI in Slack, try Premium now",
    "@atlassian/edition-benefits-modal.features-section.header.standard-modal": "Explore your Standard trial",
    "@atlassian/edition-benefits-modal.features-section.header.standard-storage-limits": "You've reached your storage limit",
    "@atlassian/edition-benefits-modal.features-section.header.workforce-optimization": "Auto routing powered by agent schedules and capacity",
    "@atlassian/edition-benefits-modal.features-section.link.pricing": "See more Premium features and pricing",
    "@atlassian/edition-benefits-modal.features-section.request-access-warning.icon-label": "Information",
    "@atlassian/edition-benefits-modal.features-section.request-access-warning.text": "You must be a Customer Service Management user to access the AI customer service agent.",
    "@atlassian/edition-benefits-modal.precondition-message.link-text": "allow Rovo access for Jira Service Management",
    "@atlassian/edition-benefits-modal.precondition-message.text": "To use AI alert grouping during your Premium trial, {link}.",
    "@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free": "Try it free",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.at": "@",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.major-incident": "MAJOR INCIDENT",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.raised-a": "Raised a",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.rovo-ops": "Rovo Ops",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.summary": "Summary",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.what-you-can-do-next": "What you can do next",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.bradley": "Bradley",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.helpCenter": "Help center",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.resolved": "Resolved",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.rovoServiceAgent": "Rovo service agent",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.slash": "/",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link": "cancel anytime.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content": "Add your payment details by <strong>{date}</strong> to continue using {edition}. {plansLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user": "To continue using {edition}, contact your billing admin to add payment details before your trial ends on <strong>{billingDate}</strong>.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date": "To continue using {edition}, contact your billing admin to add payment details before your trial ends.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered": "Your {edition} trial ends on <strong>{billingDate}</strong>.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date": "Your {edition} trial is ending soon.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date": "Add your payment details before your trial ends to continue using {edition}. {plansLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered": "You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date": "You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link": "See all plans.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link": "See plans",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details": "Add payment details",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.close": "Close",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms": "Explore AI enabled Forms",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets": "Explore Assets",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations": "Explore Automations",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent": "Explore Customer service agent",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base": "Explore Knowledge base",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent": "Explore Rovo Ops agent",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent": "Explore Rovo Service agent",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion": "Explore Rovo Support Companion",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents": "Invite more agents",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description": "Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description": "Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description": "Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-customer-service-agent.description": "Use <strong>AI-powered Customer Service agent</strong> to deflect common requests and resolve them faster",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-limits.description": "<strong>250 GB storage</strong> to support your customers",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.support-articles.description": "Power your Rovo agent with <strong>AI written support articles</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description": "Scale your support with <strong>unlimited support agents</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description": "See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description": "Move forward faster with <strong>10x Automation rule runs</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description": "Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description": "Scale your support with <strong>unlimited support agents</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description": "Keep your requests moving with <strong>10x Automation rule runs</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description": "Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description": "Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.storage-limits.description": "<strong>250 GB storage</strong> to support your customers",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.support-articles.description": "Power your Rovo agent with <strong>AI written support articles</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description": "Scale your support with <strong>unlimited support agents</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.attachments": "Attachments",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.button": "Drag and drop files",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.name": "Service request",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.title": "Help center",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.title": "Explore your trial",
    "@atlassian/edition-benefits-modal.unlimitedAgentsServiceTeam.request": "Request",
    "@atlassian/growth.edition-benefits-modal.automtion-service-team.automation": "Automation",
    "@atlassian/growth.edition-benefits-modal.automtion-service-team.automation-runs": "automation runs",
    "@atlassian/growth.edition-benefits-modal.automtion-service-team.x10": "x10",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.customer": "Customer",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.customerServiceAgent": "Customer service agent",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.resolved": "Resolved",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.support": "Support",
    "edition-benefits-modal.alert-grouping-artwork.acknowledge": "Ack all",
    "edition-benefits-modal.alert-grouping-artwork.alerts": "Alerts",
    "edition-benefits-modal.alert-grouping-artwork.group": "Alert group",
    "edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature1": "<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.",
    "edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature2": "<strong>Ship changes safely</strong> with automated risk scoring and approvals.",
    "edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature3": "<strong>Scale your services confidently</strong> with 24/7 Premium support and unlimited storage.",
    "edition-benefits-modal.edition-benefits-popup.actions-group-label": "Trial actions",
    "edition-benefits-modal.edition-benefits-popup.auto-upgrade.title": "You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
    "edition-benefits-modal.edition-benefits-popup.direct-trial.title": "You're on a free trial of our {edition} plan",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details": "You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date": "You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details": "Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date": "Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details": "You won't be charged until your next billing date. <a>See plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details": "Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.manual-trial.title": "Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started",
    "edition-benefits-modal.edition-benefits-popup.primary-button": "Explore {edition}",
    "edition-benefits-modal.edition-benefits-popup.secondary-button": "Add payment details",
    "edition-benefits-modal.incident-management-artwork.incident": "Incident",
    "edition-benefits-modal.incident-management-artwork.summarize": "Summarize incident with Rovo Ops",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.group": "<strong>Group related alerts</strong> with AI so responders can focus on what matters.",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.incidents": "<strong>Turn critical alerts into incidents</strong> with AI-assisted triage and a clear timeline.",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.patterns": "<strong>Spot emerging alert patterns</strong> with AI before they become bigger issues.",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.title": "Try AI alert grouping with Premium",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.incidents": "<strong>Link assets to incidents and changes</strong> so you troubleshoot faster and cut risk.",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.inventory": "<strong>Bring every asset into one trusted inventory</strong> - no duplicates, no guesswork.",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.objects": "Map everything that matters, with <strong>10x the included objects</strong> to grow into.",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.title": "Try Data manager with Premium",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.align": "<strong>Keep the team aligned in Slack or Microsoft Teams</strong>, with a clear timeline of what happened.",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.resolve": "<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.review": "<strong>Let AI write the post-incident review</strong> so you capture learnings while fresh.",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.title": "Try advanced incident management with Premium",
    "edition-benefits-modal.modal.v2.precondition-message-v2.iconLabel": "Information",
    "edition-benefits-modal.shared.premium-trial-button.dismiss": "Dismiss",
    "edition-benefits-modal.shared.premium-trial-button.requestTrial": "Request trial",
    "edition-benefits-modal.shared.premium-trial-button.successDescription": "Your admin has been notified.",
    "edition-benefits-modal.shared.premium-trial-button.successTitle": "Your trial request has been sent"
};

});


parcelRegister("ena0F", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gSdOh").then(()=>parcelRequire('zXJKc'));

});

parcelRegister("GLGSh", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("canJD").then(()=>parcelRequire('5imHR'));

});

parcelRegister("jUXVw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8ujFA").then(()=>parcelRequire('2nJXY'));

});

parcelRegister("kFNln", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iWvaj").then(()=>parcelRequire('9Hlt6'));

});

parcelRegister("6jmuq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("75hfs").then(()=>parcelRequire('bx0ri'));

});

parcelRegister("7DkjV", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gq2Ws").then(()=>parcelRequire('bShF9'));

});

parcelRegister("j49Wr", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9Gvrf").then(()=>parcelRequire('cj4Sx'));

});

parcelRegister("0X2L4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("25et7").then(()=>parcelRequire('bGbHI'));

});

parcelRegister("gmjF0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("akQBI").then(()=>parcelRequire('jtID7'));

});

parcelRegister("3xjiT", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1mQUP").then(()=>parcelRequire('dcrA6'));

});

parcelRegister("fMu8d", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eCihZ").then(()=>parcelRequire('GmFco'));

});

parcelRegister("6sz7n", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hGWNJ").then(()=>parcelRequire('dltrS'));

});

parcelRegister("hZi9U", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cknwH").then(()=>parcelRequire('3gCek'));

});

parcelRegister("gyQC3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dhgXM").then(()=>parcelRequire('ce0dh'));

});

parcelRegister("bhgiy", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jlGJt").then(()=>parcelRequire('cQfKG'));

});

parcelRegister("8GDOK", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("c9rmC").then(()=>parcelRequire('695z1'));

});

parcelRegister("en0GD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("l4bSV").then(()=>parcelRequire('3xcmb'));

});

parcelRegister("2cx3P", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5mYCI").then(()=>parcelRequire('5CGk2'));

});

parcelRegister("2ysAk", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("66nZ1").then(()=>parcelRequire('iBjYA'));

});

parcelRegister("gioxc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("oiq7K").then(()=>parcelRequire('gGgSk'));

});

parcelRegister("bOvDn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fl6vL").then(()=>parcelRequire('g7pZd'));

});

parcelRegister("MBjWE", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8jIXk").then(()=>parcelRequire('gO0v8'));

});

parcelRegister("4d0Zn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jO1i7").then(()=>parcelRequire('ff8mB'));

});



parcelRegister("aceDa", function(module, exports) {
$parcel$export(module.exports, "popupFallbackMessages", () => $25bb66555e2da291$export$a16b273775b597f7);

var $gKkX7 = parcelRequire("gKkX7");
function $25bb66555e2da291$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $25bb66555e2da291$export$a16b273775b597f7 = Object.fromEntries(Object.values((0, $gKkX7.messages)).filter($25bb66555e2da291$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("gKkX7", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f8302bc6140c54da$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f8302bc6140c54da$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    starPopupAutoUpgradeTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.auto-upgrade.title',
        defaultMessage: "You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
        description: 'Edition awareness button popup title'
    },
    starPopupManualTrialTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.manual-trial.title',
        defaultMessage: 'Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started',
        description: 'Edition awareness button popup title'
    },
    starPopupDirectTrialTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.direct-trial.title',
        defaultMessage: "You're on a free trial of our {edition} plan",
        description: 'Edition awareness button popup title'
    },
    starPopupDisclaimerWithoutPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details',
        defaultMessage: 'Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer'
    },
    starPopupDisclaimerWithoutPaymentDetailsNoDate: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer for billing admins without payment details when next billing date is unavailable'
    },
    starPopupEndUserDisclaimerWithoutPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer for end users without payment details when next billing date is unavailable'
    },
    starPopupPrimaryButton: {
        id: 'edition-benefits-modal.edition-benefits-popup.primary-button',
        defaultMessage: 'Explore {edition}',
        description: 'Edition awareness button popup primary button to explore the edition'
    },
    starPopupSecondaryButton: {
        id: 'edition-benefits-modal.edition-benefits-popup.secondary-button',
        defaultMessage: 'Add payment details',
        description: 'Edition awareness button popup secondary button to add payment details'
    },
    starPopupActionsGroupLabel: {
        id: 'edition-benefits-modal.edition-benefits-popup.actions-group-label',
        defaultMessage: 'Trial actions',
        description: 'Accessible name for the group containing the edition awareness popup action buttons'
    },
    starPopupDisclaimerWithPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details',
        defaultMessage: "You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
        description: 'Edition awareness button popup disclaimer'
    },
    starPopupDisclaimerWithPaymentDetailsNoDate: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date',
        defaultMessage: "You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
        description: 'Edition awareness button popup disclaimer for billing admins with payment details when next billing date is unavailable'
    },
    starPopupEndUserDisclaimerWithPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details',
        defaultMessage: "You won't be charged until your next billing date. <a>See plans</a>.",
        description: 'Edition awareness button popup disclaimer for end users with payment details when next billing date is unavailable'
    }
});

});


parcelRegister("jYVAf", function(module, exports) {
$parcel$export(module.exports, "standardBenefitsFallbackMessages", () => $ee560c75775b3269$export$188a81d8a9b070a0);

var $3vC37 = parcelRequire("3vC37");
function $ee560c75775b3269$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $ee560c75775b3269$export$188a81d8a9b070a0 = Object.fromEntries(Object.values((0, $3vC37.standardMessages)).filter($ee560c75775b3269$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("3vC37", function(module, exports) {
$parcel$export(module.exports, "standardMessages", () => $e0bf6cdf3aa0c9db$export$e196fa8d430d87b);

var $f0Pt4 = parcelRequire("f0Pt4");
const $e0bf6cdf3aa0c9db$export$e196fa8d430d87b = (0, $f0Pt4.defineMessages)({
    closeButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.close',
        defaultMessage: 'Close',
        description: 'Aria-label for the close button in the edition benefits modal'
    },
    standardBenefitsModalTitle: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.title',
        defaultMessage: 'Explore your trial',
        description: 'Title for the standard benefits modal'
    },
    standardBenefitsModalBillingContent: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content',
        defaultMessage: 'Add your payment details by <strong>{date}</strong> to continue using {edition}. {plansLink}',
        description: "Billing content for the standard benefits modal. {plansLink} is the \u201CSee all plans\u201D link to pricing."
    },
    standardBenefitsModalBillingContentNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. {plansLink}',
        description: 'Billing content when billing date is unavailable. {edition} is the plan name; {plansLink} is the plans link.'
    },
    standardBenefitsModalBillingPlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link',
        defaultMessage: 'See all plans.',
        description: "Link label for the billing line \u201CSee all plans\u201D in the standard benefits modal"
    },
    standardBenefitsModalBillingContentPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered',
        defaultMessage: 'You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}',
        description: 'Billing line when payment details are on file. {billingDate} is the next billing date; {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingContentPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date',
        defaultMessage: 'You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}',
        description: 'Billing line when payment is on file but billing date is unavailable. {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingSeePlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link',
        defaultMessage: 'See plans',
        description: "Link label \u201CSee plans\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingCancelAnytimeLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link',
        defaultMessage: 'cancel anytime.',
        description: "Link label \u201Ccancel anytime.\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingContentEndUserPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered',
        defaultMessage: 'Your {edition} trial ends on <strong>{billingDate}</strong>.',
        description: 'Billing line for end users (non-billing admins) with payment on file and a known billing date.'
    },
    standardBenefitsModalBillingContentEndUserPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date',
        defaultMessage: 'Your {edition} trial is ending soon.',
        description: 'Billing line for end users (non-billing admins) with payment on file when billing date is unavailable.'
    },
    standardBenefitsModalBillingContentEndUser: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user',
        defaultMessage: 'To continue using {edition}, contact your billing admin to add payment details before your trial ends on <strong>{billingDate}</strong>.',
        description: 'Billing line for end users (non-billing admins) without payment details and a known billing date.'
    },
    standardBenefitsModalBillingContentEndUserNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date',
        defaultMessage: 'To continue using {edition}, contact your billing admin to add payment details before your trial ends.',
        description: 'Billing line for end users (non-billing admins) without payment details when billing date is unavailable.'
    },
    standardBenefitsModalAddPaymentDetailsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details',
        defaultMessage: 'Add payment details',
        description: 'Text for the add payment details button in the standard benefits modal'
    },
    standardBenefitsModalExploreRovoServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent',
        defaultMessage: 'Explore Rovo Service agent',
        description: 'Text for the explore Rovo Service agent button in the standard benefits modal'
    },
    standardBenefitsModalExploreKnowledgeBaseButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base',
        defaultMessage: 'Explore Knowledge base',
        description: 'Text for the explore Knowledge base primary button when that feature is selected'
    },
    standardBenefitsModalExploreAutomationsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations',
        defaultMessage: 'Explore Automations',
        description: 'Text for the explore Automations primary button when that feature is selected'
    },
    standardBenefitsModalInviteMoreAgentsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents',
        defaultMessage: 'Invite more agents',
        description: 'Text for the invite more agents primary button when unlimited agents is selected'
    },
    // CTA — CSM
    standardBenefitsModalExploreCustomerServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent',
        defaultMessage: 'Explore Customer service agent',
        description: 'Primary CTA when Customer service agent feature is selected (CSM)'
    },
    standardBenefitsModalExploreRovoSupportCompanionButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion',
        defaultMessage: 'Explore Rovo Support Companion',
        description: 'Primary CTA when Rovo Support Companion feature is selected (CSM)'
    },
    standardBenefitsModalExploreAiEnabledFormsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms',
        defaultMessage: 'Explore AI enabled Forms',
        description: 'Primary CTA when AI enabled Forms feature is selected (CSM)'
    },
    // CTA — Ops
    standardBenefitsModalExploreRovoOpsAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent',
        defaultMessage: 'Explore Rovo Ops agent',
        description: 'Primary CTA when Rovo Ops agent feature is selected (Ops)'
    },
    standardBenefitsModalExploreAssetsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets',
        defaultMessage: 'Explore Assets',
        description: 'Primary CTA when Assets feature is selected (Ops)'
    },
    // Feature: Service Teams
    serviceTeamsFeatureRovoAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster',
        description: 'Description for the Rovo Service Agents feature'
    },
    serviceTeamsFeatureKnowledgeBaseDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>',
        description: 'Description for the Knowledge Base feature'
    },
    serviceTeamsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description',
        defaultMessage: 'Keep your requests moving with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation Rules feature'
    },
    serviceTeamsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited Agents feature'
    },
    // Feature: CSM
    csmFeatureCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description',
        defaultMessage: 'Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload',
        description: 'Description for the Customer service agent feature (CSM)'
    },
    csmFeatureRovoSupportCompanionDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description',
        defaultMessage: 'Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses',
        description: 'Description for the Rovo Support Companion feature (CSM)'
    },
    csmFeatureAiEnabledFormsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description',
        defaultMessage: 'Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed',
        description: 'Description for the handoff feature (CSM)'
    },
    csmFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited agents feature (CSM)'
    },
    // Feature: CSM Storage Limits
    csmFeatureStorageCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-customer-service-agent.description',
        defaultMessage: 'Use <strong>AI-powered Customer Service agent</strong> to deflect common requests and resolve them faster',
        description: 'Description for the Customer Service agent feature in storage limits variant (CSM)'
    },
    csmFeatureSupportArticlesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.support-articles.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written support articles</strong>',
        description: 'Description for the Knowledge Base feature in storage limits variant (CSM)'
    },
    csmFeatureStorageLimitsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-limits.description',
        defaultMessage: '<strong>250 GB storage</strong> to support your customers',
        description: 'Description for the Storage Limits feature (CSM)'
    },
    // Feature: JSM Storage Limits
    jsmTeamsFeatureSupportArticlesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.support-articles.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written support articles</strong>',
        description: 'Description for the Knowledge Base feature in storage limits variant (service teams)'
    },
    jsmTeamsFeatureStorageLimitsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.storage-limits.description',
        defaultMessage: '<strong>250 GB storage</strong> to support your customers',
        description: 'Description for the Storage Limits feature (service teams)'
    },
    // Feature: Ops
    opsFeatureRovoOpsAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents',
        description: 'Description for the Rovo Ops agent feature (Ops)'
    },
    opsFeatureAssetsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description',
        defaultMessage: 'See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>',
        description: 'Description for the Assets feature (Ops)'
    },
    opsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description',
        defaultMessage: 'Move forward faster with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation rule runs feature (Ops)'
    },
    opsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited agents feature (Ops)'
    }
});

});



parcelRegister("1lck4", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $0bf1f8b58e8d8c9d$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $juFEH = parcelRequire("juFEH");

var $83k1Z = parcelRequire("83k1Z");

var $jvFKV = parcelRequire("jvFKV");
const $0bf1f8b58e8d8c9d$export$e926676385687eaf = ({ children: children, variantId: variantId })=>{
    const handleOnError = (0, $jvFKV.useErrorAnalytics)({
        variantId: variantId
    });
    const ufoContext = (0, $83k1Z.useInteractionContext)();
    const onError = (0, $bSJIT.useCallback)((error, errorInfo)=>{
        const interaction = (0, $juFEH.getActiveInteraction)();
        handleOnError(error, errorInfo);
        if (interaction && ufoContext) (0, $juFEH.addError)(interaction === null || interaction === void 0 ? void 0 : interaction.id, error.name, ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack, 'interaction error', error.message, error.stack);
        else (0, $juFEH.addErrorToAll)(`ErrorBoundary:edition-benefits-modal${variantId ? `:${variantId}` : ''}`, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, 'interaction error', error.message);
    }, [
        handleOnError,
        variantId,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null)
    }, children);
};

});
parcelRegister("jvFKV", function(module, exports) {
$parcel$export(module.exports, "useErrorAnalytics", () => $07aa24af68187f7d$export$e2d4523bbccd2343);

var $bSJIT = parcelRequire("bSJIT");

var $9mmZT = parcelRequire("9mmZT");
/**
 * Errors which we ignore from SLO reporting to ensure we're only reporting on actionable errors
 */ const $07aa24af68187f7d$var$nonSLOErrors = [
    /**
 * These occur when the fetch request fails (usually due to network being offline)
 */ /failed to fetch/i,
    /**
 * These occur when the fetch request fails due to a server response (e.g. 401)
 */ /Error server response:/i
];
function $07aa24af68187f7d$var$isSLOError(error) {
    // Just checks that none of our non-SLO errors match the error
    return !$07aa24af68187f7d$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $07aa24af68187f7d$export$e2d4523bbccd2343({ variantId: variantId, operation: operation } = {}) {
    const sendOperationalEvent = (0, $9mmZT.useOperationalAnalytics)();
    return (0, $bSJIT.useCallback)((error, errorInfo)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-benefits-modal.edition-benefits-modal',
            attributes: {
                ...operation ? {
                    operation: operation
                } : {},
                variantId: variantId,
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                componentStack: errorInfo.componentStack,
                isSLOError: $07aa24af68187f7d$var$isSLOError(error)
            }
        });
    }, [
        sendOperationalEvent,
        variantId,
        operation
    ]);
}

});


parcelRegister("a5g0d", function(module, exports) {
$parcel$export(module.exports, "messages", () => $17aec50c5bd06744$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $17aec50c5bd06744$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    benefitsSectionButtonMaybeLater: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later',
        defaultMessage: 'Maybe later',
        description: 'Button in the edition benefits modal that allows the user to dismiss the upgrade prompt and return to it later.'
    },
    benefitsSectionButtonTryItFree: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Primary call-to-action button in the edition benefits modal that initiates a free trial of Premium features.'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1',
        defaultMessage: '<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
        description: 'Text for first feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2',
        defaultMessage: '<strong>Customise your help center</strong> to match your brand.',
        description: 'Text for second feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3',
        defaultMessage: '<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
        description: 'Text for third feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1',
        defaultMessage: 'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
        description: 'Text for first feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2',
        defaultMessage: 'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
        description: 'Text for second feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3',
        defaultMessage: '<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
        description: 'Text for third feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1',
        defaultMessage: 'Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.',
        description: 'Workforce Optimization feature row: scheduling'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2',
        defaultMessage: "Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
        description: 'Workforce Optimization feature row: capacity utilization'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3',
        defaultMessage: 'Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.',
        description: 'Workforce Optimization feature row: real-time auto routing'
    },
    benefitsSectionHeadingHelpCenterCustomization: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization',
        defaultMessage: 'Try advanced Help Center customisation with Premium',
        description: 'Heading for help-center-customization variant'
    },
    benefitsSectionHeadingIncidentsSlackIntegration: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration',
        defaultMessage: 'Resolve incidents with AI in Slack, try Premium now',
        description: 'Heading for incidents-slack-integration variant'
    },
    benefitsSectionLinkPricing: {
        id: '@atlassian/edition-benefits-modal.benefits-section.link.pricing',
        defaultMessage: 'See more Premium features and pricing',
        description: 'Link in the edition benefits modal that navigates the user to a page listing Premium features and their pricing.'
    },
    benefitsSectionSubtitle: {
        id: '@atlassian/edition-benefits-modal.benefits-section.subtitle',
        defaultMessage: "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
        description: 'Subtitle displayed in the benefits section of the edition benefits modal, explaining the free trial offer for Premium features.'
    },
    buttonTriggerOpenModal: {
        id: '@atlassian/edition-benefits-modal.button-trigger.open-modal',
        defaultMessage: 'Open modal',
        description: 'Text for the button that opens the edition benefits modal'
    },
    buttonTriggerTryItFree: {
        id: '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Button text for to trigger opening the premium benefits modal'
    },
    benefitsSectionHeadingJourneys: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.journeys',
        defaultMessage: 'Try Journeys with Premium',
        description: 'Heading for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionSubtitleContextualizedPremium: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.trial-description',
        defaultMessage: "Try free for 30 days. We\u2019ll remind you before it ends. Cancel anytime.",
        description: 'Subtitle for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextJourneysFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.self-service',
        defaultMessage: '<strong>Improve self service</strong> with AI-powered virtual agent and no-code journeys.',
        description: 'First feature row for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextJourneysFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.branded-front-door',
        defaultMessage: '<strong>Give every team a branded front door</strong> with multiple help centres',
        description: 'Second feature row for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextJourneysFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.track-team-dependencies',
        defaultMessage: '<strong>Track what your teams rely on</strong> with AI-driven workflows and up to 50,000 objects in Assets',
        description: 'Third feature row for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionHeadingChangeManagement: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.change-management',
        defaultMessage: 'Try Change management with Premium',
        description: 'Heading for the change-management contextualised upgrade variant.'
    },
    benefitsSectionHeadingProblemManagement: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.problem-management',
        defaultMessage: 'Try Problem management with Premium',
        description: 'Heading for the problem-management contextualised upgrade variant.'
    },
    benefitsSectionHeadingPostIncidentReviews: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.post-incident-reviews',
        defaultMessage: 'Try Post-incident reviews with Premium',
        description: 'Heading for the post-incident-reviews contextualised upgrade variant.'
    },
    benefitsSectionHeadingPlaybooks: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.playbooks',
        defaultMessage: 'Try Playbooks with Premium',
        description: 'Heading for the playbooks contextualised upgrade variant.'
    },
    benefitsSectionFeatureTitleOperationalFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.title',
        defaultMessage: '<strong>Resolve incidents faster</strong>',
        description: 'First benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureDescriptionOperationalFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.description',
        defaultMessage: 'AI-powered alerts group related incidents and surfaces root causes.',
        description: 'First benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTitleOperationalFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.title',
        defaultMessage: '<strong>Ship changes without the risk</strong>',
        description: 'Second benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureDescriptionOperationalFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.description',
        defaultMessage: 'Automated risk scoring and approvals to keep your deploys safe.',
        description: 'Second benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTitleOperationalFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.title',
        defaultMessage: '<strong>Scale your services confidently</strong>',
        description: 'Third benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureDescriptionOperationalFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.description',
        defaultMessage: '24/7 Premium support and unlimited storage keep your team moving.',
        description: 'Third benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTextOperationalFeature1: {
        id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature1',
        defaultMessage: '<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.',
        description: 'First feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTextOperationalFeature2: {
        id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature2',
        defaultMessage: '<strong>Ship changes safely</strong> with automated risk scoring and approvals.',
        description: 'Second feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTextOperationalFeature3: {
        id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature3',
        defaultMessage: '<strong>Scale your services confidently</strong> with 24/7 Premium support and unlimited storage.',
        description: 'Third feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionHeadingAlertGrouping: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.alert-grouping',
        defaultMessage: 'AI alert grouping with Premium',
        description: 'Heading for the AI alert grouping contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextAlertGroupingFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature1',
        defaultMessage: '<strong>Resolve incidents faster</strong> with AI-powered alerting, auto-grouping, and root cause analysis.',
        description: 'First feature row for the AI alert grouping contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextAlertGroupingFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature2',
        defaultMessage: '<strong>Deploy safely with AI risk scoring,</strong> automated approvals, and change calendars.',
        description: 'Second feature row for the AI alert grouping contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextAlertGroupingFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature3',
        defaultMessage: '<strong>Scale confidently</strong> with 24/7 Premium Support, and unlimited storage.',
        description: 'Third feature row for the AI alert grouping contextualised upgrade variant.'
    }
});

});

parcelRegister("ardi8", function(module, exports) {
$parcel$export(module.exports, "premiumEditionBenefitsModalEntryPoint", () => $37211af942197784$export$262ed5b18480f6c7);

var $7KkhH = parcelRequire("7KkhH");

var $89HEN = parcelRequire("89HEN");

var $5PWML = parcelRequire("5PWML");

var $dKUy9 = parcelRequire("dKUy9");

const $37211af942197784$export$262ed5b18480f6c7 = (0, $89HEN.createEntryPoint)({
    root: (0, $7KkhH.JSResourceForInteraction)(()=>(parcelRequire("k7nJB")), {
        moduleId: "cb5e16cf",
        priority: "interaction",
        moduleId: 'edition-benefits-modal-premium-benefits-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                premiumBenefitsModalQuery: {
                    parameters: (0, $dKUy9.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $5PWML.getHamsKey)(product)
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                product: product
            }
        })
});

});
parcelRegister("7KkhH", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $9802f313783af555$export$e83743682263315a);

var $6Kmg0 = parcelRequire("6Kmg0");

var $bNL7L = parcelRequire("bNL7L");

var $95kFc = parcelRequire("95kFc");
const $9802f313783af555$var$cache = (0, $6Kmg0.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $9802f313783af555$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $9802f313783af555$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$9802f313783af555$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    const { chain: chain } = opts ?? {};
    return $9802f313783af555$var$cache.get(opts.moduleId, ()=>(0, $bNL7L.PreloadableJSResource)(()=>(0, $95kFc.postTask)(chain ? ()=>chain(Promise.resolve(loaderOrPath())) : loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("6Kmg0", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $dc291baad2585ea3$export$cf6fa0bbcc94b912);
function $dc291baad2585ea3$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("bNL7L", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $6cfff5801ee9f9ab$export$4fe5fba5bb1d3c09);

var $6TnGl = parcelRequire("6TnGl");
function $6cfff5801ee9f9ab$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $6TnGl.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("6TnGl", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $6fa2f3b51ff6d096$export$148e45a6d4b4d65);

var $5DOV3 = parcelRequire("5DOV3");

var $hQmIH = parcelRequire("hQmIH");

var $1zCzV = parcelRequire("1zCzV");
function $6fa2f3b51ff6d096$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $hQmIH.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $hQmIH.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners){
                var _listener$onError;
                (_listener$onError = listener.onError) === null || _listener$onError === void 0 || _listener$onError.call(listener, error);
            }
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $5DOV3.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $hQmIH.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $1zCzV.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError === null || onError === void 0 || onError(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("5DOV3", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $5d1ef8a03aec0ef2$export$567fc7097e064344);
let $5d1ef8a03aec0ef2$var$id = 100000;
function $5d1ef8a03aec0ef2$export$567fc7097e064344() {
    $5d1ef8a03aec0ef2$var$id += 1;
    return $5d1ef8a03aec0ef2$var$id.toString();
}

});

parcelRegister("hQmIH", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $d4e5a309400ddddc$export$10dc3edfc20c8ff);
function $d4e5a309400ddddc$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $d4e5a309400ddddc$export$10dc3edfc20c8ff = $d4e5a309400ddddc$var$createEventEmitter();

});

parcelRegister("1zCzV", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $b9a26249b1b556f0$export$3b514faac3ba993c);
function $b9a26249b1b556f0$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("95kFc", function(module, exports) {
$parcel$export(module.exports, "postTask", () => $655b30f36a2d510a$export$13c9d02ca54955a3);
async function $655b30f36a2d510a$var$toPromise(callback) {
    return callback();
}
function $655b30f36a2d510a$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $655b30f36a2d510a$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $655b30f36a2d510a$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("aO4JA")).then(()=>$655b30f36a2d510a$var$getScheduler(globalThis).postTask(callback, options));
        return $655b30f36a2d510a$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("aO4JA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iuxMo").then(()=>parcelRequire('6VLzM'));

});



parcelRegister("89HEN", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $807d4215a083b771$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/no-empty-object-type */ function $807d4215a083b771$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("5PWML", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $56ce2306d9a0a1e6$export$291d012eb0744b34);
const $56ce2306d9a0a1e6$var$ProductKeyToHAMSMap = {
    ['jira']: 'jira-software',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['confluence']: 'confluence',
    ['jira-customer-service']: 'jira-customer-service'
};
// Pre-built reverse lookup for `getProductFromHamsKey`, so the map is not rebuilt on every call.
const $56ce2306d9a0a1e6$var$HAMSToProductKeyMap = Object.fromEntries(Object.entries($56ce2306d9a0a1e6$var$ProductKeyToHAMSMap).map(([product, hamsKey])=>[
        hamsKey,
        product
    ]));
const $56ce2306d9a0a1e6$export$291d012eb0744b34 = (product)=>{
    return $56ce2306d9a0a1e6$var$ProductKeyToHAMSMap[product];
};
const $56ce2306d9a0a1e6$export$3658e62040c7be00 = (hamsProductKey)=>{
    return $56ce2306d9a0a1e6$var$HAMSToProductKeyMap[hamsProductKey] ?? 'jira-service-management';
};

});

parcelRegister("dKUy9", function(module, exports) {
$parcel$export(module.exports, "default", () => $87ac0569c81ba4ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f71f4408d1068bddb46758e4ae198ef1>>
 * @relayHash 0364ebf04a149c5cd5b923316a2324ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845

var $4270B = parcelRequire("4270B");
const $87ac0569c81ba4ed$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845",
            "metadata": {},
            "name": "premiumBenefitsModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$87ac0569c81ba4ed$var$node.hash = "0854408facd8d9c64a16089df4b3226a";
(0, $4270B.PreloadableQueryRegistry).set($87ac0569c81ba4ed$var$node.params.id, $87ac0569c81ba4ed$var$node);
var $87ac0569c81ba4ed$export$2e2bcd8739ae039 = $87ac0569c81ba4ed$var$node;

});

parcelRegister("k7nJB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("e1RQb"),
    $kOunM("bNgsI"),
    $kOunM("7tEZC"),
    $kOunM("iZJsN"),
    $kOunM("gsQwM"),
    $kOunM("uBPzN"),
    $kOunM("1n66p")
]).then(()=>parcelRequire('efZCK'));

});



parcelRegister("duJSM", function(module, exports) {
$parcel$export(module.exports, "editionBenefitsModalEntryPoint", () => $5b6e61d748a62708$export$4708c4eaa8d901cd);

var $7KkhH = parcelRequire("7KkhH");

var $89HEN = parcelRequire("89HEN");

var $5PWML = parcelRequire("5PWML");

var $2FlVD = parcelRequire("2FlVD");

var $h0N1B = parcelRequire("h0N1B");

const $5b6e61d748a62708$export$4708c4eaa8d901cd = (0, $89HEN.createEntryPoint)({
    root: (0, $7KkhH.JSResourceForInteraction)(()=>(parcelRequire("eTXRO")), {
        moduleId: "f335c645",
        priority: "interaction",
        moduleId: 'edition-benefits-modal-relay'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                editionBenefitsModalRelayQuery: {
                    parameters: (0, $h0N1B.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $5PWML.getHamsKey)(product),
                        projectType: (0, $2FlVD.getProjectType)(product)
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                product: product
            }
        })
});

});
parcelRegister("2FlVD", function(module, exports) {
$parcel$export(module.exports, "getProjectType", () => $ac65e406059b7da0$export$3dd0da95519c1a33);
const $ac65e406059b7da0$export$3dd0da95519c1a33 = (product)=>{
    switch(product){
        case 'jira-service-management':
            return 'SERVICE_DESK';
        case 'jira-customer-service':
            return 'CUSTOMER_SERVICE';
        case 'jira':
            return 'SOFTWARE';
        case 'jira-product-discovery':
            return 'PRODUCT_DISCOVERY';
        case 'confluence':
            throw new Error('Confluence is not supported');
        default:
            throw new Error('Product not supported');
    }
};

});

parcelRegister("h0N1B", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ca573cbd17c75fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74a53ad6421f1c8d7280d9877d928236>>
 * @relayHash ef1111bd15d10eaaab0f3bd5698ebf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228

var $4270B = parcelRequire("4270B");
const $6ca573cbd17c75fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudUrl"
    }, v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "product",
                "value": "jira"
            }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            }
        ],
        "storageKey": "activationIdByProduct(product:\"jira\")"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            },
            {
                "alias": "changeToStandard",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Standard"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v7 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            }
        ]
    }, v9 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v11 = {
        "concreteType": "CcpBillingPeriodDetails",
        "kind": "LinkedField",
        "name": "billingPeriodDetails",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "nextBillingTimestamp"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v13 = {
        "concreteType": "CcpInvoiceGroupExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "configurePaymentV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v16 = {
        "concreteType": "CcpTransactionAccountExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "addPaymentMethodV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            v20 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228",
            "metadata": {},
            "name": "editionBenefitsModalRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6ca573cbd17c75fb$var$node.hash = "4adcf3c0d1fd080dc809373daae7326c";
(0, $4270B.PreloadableQueryRegistry).set($6ca573cbd17c75fb$var$node.params.id, $6ca573cbd17c75fb$var$node);
var $6ca573cbd17c75fb$export$2e2bcd8739ae039 = $6ca573cbd17c75fb$var$node;

});

parcelRegister("eTXRO", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("49zrx"),
    $kOunM("jQSFl"),
    $kOunM("gHPIs"),
    $kOunM("3nj3B"),
    $kOunM("e1RQb"),
    $kOunM("bNgsI"),
    $kOunM("j2Oap"),
    $kOunM("7tEZC"),
    $kOunM("jAikg"),
    $kOunM("hnJ7v"),
    $kOunM("g3dvj"),
    $kOunM("bEVmD"),
    $kOunM("j9pBK"),
    $kOunM("8olLW"),
    $kOunM("iZJsN"),
    $kOunM("9TfiK"),
    $kOunM("3M7DB"),
    $kOunM("876f5"),
    $kOunM("gsQwM"),
    $kOunM("fzI7a"),
    $kOunM("kI2bC"),
    $kOunM("uBPzN"),
    $kOunM("hOftR")
]).then(()=>parcelRequire('gCcWp'));

});


parcelRegister("2aw7C", function(module, exports) {
$parcel$export(module.exports, "clearSidebarExperienceAndCustomize", () => $0f125e45e2c052ac$export$4367df47a43e5f96);

var $5LmQo = parcelRequire("5LmQo");
const $0f125e45e2c052ac$export$47b19daccaa881f2 = ()=>{
    return (0, $5LmQo.get)('experience');
};
const $0f125e45e2c052ac$export$4367df47a43e5f96 = ()=>{
    (0, $5LmQo.set)({
        customize: undefined,
        experience: undefined
    });
};

});

parcelRegister("4BroI", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => (parcelRequire("8ZJ8E")).ARTICLES_RESULT_LIMIT);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => (parcelRequire("8ZJ8E")).INITIAL_ARTICLES_LIMIT);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => (parcelRequire("8ZJ8E")).PORTALS_RESULT_LIMIT);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => (parcelRequire("8ZJ8E")).REQUEST_FORMS_NEW_LIMIT);
$parcel$export(module.exports, "SEARCH_QUERY_CHARACTER_LIMIT", () => (parcelRequire("8ZJ8E")).SEARCH_QUERY_CHARACTER_LIMIT);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => (parcelRequire("8ZJ8E")).SEARCH_QUERY_DEBOUNCE_TIME);
$parcel$export(module.exports, "DropdownOptionList", () => (parcelRequire("c6fXf")).DropdownOptionList);
$parcel$export(module.exports, "Img", () => (parcelRequire("c6fXf")).Img);
$parcel$export(module.exports, "InlineResultLink", () => (parcelRequire("c6fXf")).InlineResultLink);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => (parcelRequire("c6fXf")).InlineResultsHeadingWrapper);
$parcel$export(module.exports, "ResultList", () => (parcelRequire("c6fXf")).ResultList);
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => (parcelRequire("c6fXf")).SEARCH_BAR_HEIGHT);
$parcel$export(module.exports, "formatText", () => (parcelRequire("2FLDr")).formatText);
$parcel$export(module.exports, "formatToCleanText", () => (parcelRequire("2FLDr")).formatToCleanText);
$parcel$export(module.exports, "getIdsArray", () => (parcelRequire("2FLDr")).getIdsArray);
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("2FLDr")).getPortalIdAsNumber);
$parcel$export(module.exports, "isSearchQueryOverCharacterLimit", () => (parcelRequire("2FLDr")).isSearchQueryOverCharacterLimit);
$parcel$export(module.exports, "isSinglePortalSearch", () => (parcelRequire("2FLDr")).isSinglePortalSearch);
$parcel$export(module.exports, "isValidSearchTerm", () => (parcelRequire("2FLDr")).isValidSearchTerm);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => (parcelRequire("2FLDr")).sendSearchOperationalAnalyticEvents);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => (parcelRequire("2FLDr")).sendSearchUIAnalyticEvents);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("2FLDr")).useQueryParams);
$parcel$export(module.exports, "useVisibilityState", () => (parcelRequire("2FLDr")).useVisibilityState);
parcelRequire("8ZJ8E");
parcelRequire("c6fXf");
parcelRequire("2FLDr");

});
parcelRegister("8ZJ8E", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => $261e9327b117c692$export$38c99458b97d4d4);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => $261e9327b117c692$export$d687c15f4e8fd960);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => $261e9327b117c692$export$f63f00916950640a);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => $261e9327b117c692$export$95aa4d213e66754b);
$parcel$export(module.exports, "SEARCH_QUERY_CHARACTER_LIMIT", () => $261e9327b117c692$export$5a87aa56eba7a19a);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => $261e9327b117c692$export$16da0cbbeac3310c);
const $261e9327b117c692$export$38c99458b97d4d4 = 30;
const $261e9327b117c692$export$d687c15f4e8fd960 = 5;
const $261e9327b117c692$export$f63f00916950640a = 10;
const $261e9327b117c692$export$95aa4d213e66754b = 300;
const $261e9327b117c692$export$5a87aa56eba7a19a = 750;
const $261e9327b117c692$export$16da0cbbeac3310c = 15;

});

parcelRegister("c6fXf", function(module, exports) {
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => $4a75c20fe6f948e4$export$9ac4f4162406e081);
$parcel$export(module.exports, "ResultList", () => $4a75c20fe6f948e4$export$7ebf7682ef098fb8);
$parcel$export(module.exports, "Img", () => $4a75c20fe6f948e4$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => $4a75c20fe6f948e4$export$a8317adc66cb9be6);
$parcel$export(module.exports, "InlineResultLink", () => $4a75c20fe6f948e4$export$5a34ff55d4e5e484);
$parcel$export(module.exports, "DropdownOptionList", () => $4a75c20fe6f948e4$export$b5e293376cc6b1ce);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $2OuWT = parcelRequire("2OuWT");
const $4a75c20fe6f948e4$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $4a75c20fe6f948e4$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $4a75c20fe6f948e4$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $4a75c20fe6f948e4$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $4a75c20fe6f948e4$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $2OuWT.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $4a75c20fe6f948e4$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2FLDr", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $c2804639506a7605$export$905fe28a7c283e1d);
$parcel$export(module.exports, "formatToCleanText", () => $c2804639506a7605$export$519cc8c1640d01b8);
$parcel$export(module.exports, "useQueryParams", () => $c2804639506a7605$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "isSinglePortalSearch", () => $c2804639506a7605$export$3bdd4cf348080703);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $c2804639506a7605$export$c36431be801010b);
$parcel$export(module.exports, "isValidSearchTerm", () => $c2804639506a7605$export$34d09b0baed7315d);
$parcel$export(module.exports, "isSearchQueryOverCharacterLimit", () => $c2804639506a7605$export$cdf01900fed9ff7d);
$parcel$export(module.exports, "getIdsArray", () => $c2804639506a7605$export$b78190df63b1b0c4);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => $c2804639506a7605$export$c8b38685f22f1bb2);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => $c2804639506a7605$export$653243929c3168a8);
$parcel$export(module.exports, "useVisibilityState", () => $c2804639506a7605$export$54299a3c81f5425);

var $bSJIT = parcelRequire("bSJIT");

var $lVkdr = parcelRequire("lVkdr");

var $gpYsn = parcelRequire("gpYsn");

var $dMC40 = parcelRequire("dMC40");

var $dJ2iN = parcelRequire("dJ2iN");

var $f76XN = parcelRequire("f76XN");

var $fvUqa = parcelRequire("fvUqa");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $8ZJ8E = parcelRequire("8ZJ8E");
const $c2804639506a7605$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $c2804639506a7605$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $c2804639506a7605$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $f76XN.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $c2804639506a7605$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $f76XN.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $c2804639506a7605$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $h1bGI.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $bSJIT.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($fvUqa))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $bSJIT.useMemo)(()=>$c2804639506a7605$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $bSJIT.useMemo)(()=>$c2804639506a7605$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $c2804639506a7605$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $c2804639506a7605$export$c36431be801010b(portalId) !== 0;
const $c2804639506a7605$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $c2804639506a7605$export$cdf01900fed9ff7d = (term)=>Boolean(term && term.length > (0, $8ZJ8E.SEARCH_QUERY_CHARACTER_LIMIT));
const $c2804639506a7605$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($dJ2iN)))(portalId);
};
const $c2804639506a7605$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gpYsn)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($dMC40)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVkdr)))(ids) ? ids : [];
    }
    return [];
};
const $c2804639506a7605$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId, isInlineResult)=>{
    if (isInlineResult) eventProperties.actionSubjectId = 'inlineResult';
    else eventProperties.actionSubjectId = portalId ? 'singlePortal' : 'portalHomePage';
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: eventProperties.actionSubjectId,
        ...eventProperties
    }).fire();
};
const $c2804639506a7605$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    const statusCode = eventProperties.statusCode;
    if (statusCode !== 403 && statusCode !== 429) createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $c2804639506a7605$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $bSJIT.useState)(false);
    const [isFocused, setIsFocused] = (0, $bSJIT.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $bSJIT.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});
parcelRegister("gpYsn", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $bf3de094d2229ba3$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $bf3de094d2229ba3$var$isNumber(value) {
    return typeof value == 'number' || $3T67E(value) && $1XSz3(value) == $bf3de094d2229ba3$var$numberTag;
}
module.exports = $bf3de094d2229ba3$var$isNumber;

});

parcelRegister("dMC40", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $lVkdr = parcelRequire("lVkdr");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $a08d48b82085ee3f$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $a08d48b82085ee3f$var$isString(value) {
    return typeof value == 'string' || !$lVkdr(value) && $3T67E(value) && $1XSz3(value) == $a08d48b82085ee3f$var$stringTag;
}
module.exports = $a08d48b82085ee3f$var$isString;

});

parcelRegister("dJ2iN", function(module, exports) {

var $5N3wo = parcelRequire("5N3wo");

var $mx0kf = parcelRequire("mx0kf");
/** Used as references for various `Number` constants. */ var $9fe1437b988ae219$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */ function $9fe1437b988ae219$var$toSafeInteger(value) {
    return value ? $5N3wo($mx0kf(value), -$9fe1437b988ae219$var$MAX_SAFE_INTEGER, $9fe1437b988ae219$var$MAX_SAFE_INTEGER) : value === 0 ? value : 0;
}
module.exports = $9fe1437b988ae219$var$toSafeInteger;

});
parcelRegister("5N3wo", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $437442a8b7fc5517$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $437442a8b7fc5517$var$baseClamp;

});


parcelRegister("f76XN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a30798c0990d5ef$export$2e2bcd8739ae039);

var $4ZMmh = parcelRequire("4ZMmh");
function $2a30798c0990d5ef$export$2e2bcd8739ae039(textHtml, keyword) {
    const escapedTextHtml = (0, $4ZMmh.escape)(textHtml);
    if (keyword) {
        const dynamicRegex = new RegExp(`([^_\\s,-]*)${(0, $4ZMmh.escapeRegExp)((0, $4ZMmh.escape)(keyword))}([^_\\s,-]*)`, 'gi');
        return escapedTextHtml.replace(dynamicRegex, (match)=>{
            return `<strong>${match}</strong>`;
        });
    }
    return escapedTextHtml;
}

});



parcelRegister("f6Ax9", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccess", () => $5b998764e3f31d5c$export$4962f3898bd5c829);

var $bSJIT = parcelRequire("bSJIT");
const $5b998764e3f31d5c$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $bSJIT.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("iZ3AQ", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => (parcelRequire("l1WpZ")).AccountDetails);

var $l1WpZ = parcelRequire("l1WpZ");

});
parcelRegister("l1WpZ", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $bf75829eacd138a2$export$66e04d0aacdb3b2);
/* account-details.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $JD7lD = parcelRequire("JD7lD");

var $682kQ = parcelRequire("682kQ");

var $7LtMZ = parcelRequire("7LtMZ");
const $bf75829eacd138a2$export$66e04d0aacdb3b2 = ({ avatarSrc: avatarSrc, displayName: displayName, email: email })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf75829eacd138a2$var$NonInteractiveLinkItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf75829eacd138a2$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf75829eacd138a2$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf75829eacd138a2$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf75829eacd138a2$var$DisplayName, null, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("small", null, email)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bf75829eacd138a2$var$NonInteractiveLinkItem = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $682kQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_lcxvglyw _syaz261p",
            __cmplp.className
        ])
    });
});
const $bf75829eacd138a2$var$ProfileWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $bf75829eacd138a2$var$AvatarWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $bf75829eacd138a2$var$DisplayName = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $bf75829eacd138a2$var$DetailsWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("682kQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f368119c49c2aa7d$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $14KEJ = parcelRequire("14KEJ");

var $cyIUy = parcelRequire("cyIUy");

var $9hBeo = parcelRequire("9hBeo");
const $f368119c49c2aa7d$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $f368119c49c2aa7d$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $f368119c49c2aa7d$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $f368119c49c2aa7d$var$LinkItem = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $14KEJ.useRouterLink)();
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $f368119c49c2aa7d$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $f368119c49c2aa7d$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9hBeo.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $f368119c49c2aa7d$var$preventEvent
                },
                onMouseDown: isDisabled ? $f368119c49c2aa7d$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $f368119c49c2aa7d$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref,
                children: children
            })
    });
}));
var $f368119c49c2aa7d$export$2e2bcd8739ae039 = $f368119c49c2aa7d$var$LinkItem;

});



parcelRegister("jhouu", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterCreationUrl", () => $e663bfa1c1c8a597$export$67b3de424cdc98a6);

var $jcRK7 = parcelRequire("jcRK7");

var $87QgR = parcelRequire("87QgR");
const $e663bfa1c1c8a597$var$HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
const $e663bfa1c1c8a597$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT = 'jira_sidebar_show_helpcenter';
const $e663bfa1c1c8a597$export$67b3de424cdc98a6 = (jiraDisplayUrl = '')=>(0, $87QgR.default).checkGate($e663bfa1c1c8a597$var$HELP_HUB_MIGRATION_GATE) && (0, $87QgR.default).getExperimentValue($e663bfa1c1c8a597$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT, 'isEnabled', false) ? `${jiraDisplayUrl}/jira/helpcenter-management?create=true` : `${0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH}?create=true`;

});

parcelRegister("exEZO", function(module, exports) {
$parcel$export(module.exports, "avatarMenuExperience", () => $e8a1a7c5335ab1a9$export$90a7234d224ce2c4);
$parcel$export(module.exports, "AvatarMenuExperienceFailure", () => $e8a1a7c5335ab1a9$export$2d5d3fcf414ca903);

var $bSJIT = parcelRequire("bSJIT");

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $e8a1a7c5335ab1a9$export$90a7234d224ce2c4 = new (0, $1we90.UFOExperience)((0, $eAZuG.avatarMenuExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $e8a1a7c5335ab1a9$export$2d5d3fcf414ca903 = (props)=>{
    (0, $bSJIT.useEffect)(()=>{
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $e8a1a7c5335ab1a9$export$90a7234d224ce2c4.failure({
            metadata: props
        });
    }, [
        props
    ]);
    return null;
};

});

parcelRegister("efD9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e65c88654d8688$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $78e65c88654d8688$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user requests section.',
        id: 'avatar.menu.v2.header.requests'
    },
    requestListHeading: {
        defaultMessage: 'REQUESTS LIST',
        description: 'Requests list header in menu request subsection',
        id: 'avatar.menu.v2.header.requests-list'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in menu request subsection',
        id: 'avatar.menu.v2.header.manage-column'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user approvals section.',
        id: 'avatar.menu.v2.header.approvals'
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user profile page.',
        id: 'avatar.menu.v2.header.profile'
    },
    logout: {
        defaultMessage: 'Log out',
        description: 'The text is shown on the log out button in the avatar drop-down menu that signs the user out of their account.',
        id: 'avatar.menu.v2.logout'
    },
    pageLayout: {
        defaultMessage: 'Page layout',
        description: 'Topics and Portals in avatar drop-down menu',
        id: 'avatar.menu.v2.topic'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in avatar drop-down menu',
        id: 'avatar.menu.v2.label.beta'
    },
    newLozenge: {
        defaultMessage: 'New',
        description: 'BeNewta lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.newLozenge'
    },
    topicsAndPortals: {
        defaultMessage: 'Topics and portals',
        description: 'Topics and Portals in avatar drop-down menu when advanced customization enabled',
        id: 'avatar.menu.v2.topics.and.portals'
    },
    look: {
        defaultMessage: 'Look and feel',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the look and feel customization settings.',
        id: 'avatar.menu.v2.look'
    },
    announcement: {
        defaultMessage: 'Announcements',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the announcements settings page.',
        id: 'avatar.menu.v2.announcement'
    },
    signIn: {
        defaultMessage: 'Log in message',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the log in message customization settings.',
        id: 'avatar.menu.v2.signIn'
    },
    helpCenterSettings: {
        defaultMessage: 'Service hub settings',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the service hub settings page.',
        id: 'avatar.menu.v2.helpCenterSettings'
    },
    customerHubSettings: {
        defaultMessage: 'Customer experience settings',
        description: 'Customer experience settings navigation item',
        id: 'avatar.menu.v2.customerHubSettings'
    },
    tooltip: {
        defaultMessage: 'Profile and settings',
        description: 'The text is shown as a tooltip when the user hovers over the avatar icon, indicating it opens the profile and settings menu.',
        id: 'avatar.profile.v2.tooltip'
    },
    reporting: {
        defaultMessage: 'Performance',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the Performance reporting page.',
        id: 'avatar.menu.v2.reporting'
    },
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the virtual service agent configuration page.',
        id: 'avatar.menu.v2.virtualServiceAgent'
    },
    portalAnnouncement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu portal subsection',
        id: 'avatar.menu.v2.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Portal groups',
        description: 'portal groups item in menu portal subsection',
        id: 'avatar.menu.v2.requestTypeGroup'
    },
    portal: {
        defaultMessage: 'PORTAL',
        description: 'Portal heading for menu portal subsection',
        id: 'avatar.menu.v2.portal.section'
    },
    helpCenter: {
        defaultMessage: 'HELP CENTER',
        description: 'Help Center heading for menu multi hc subsection',
        id: 'avatar.menu.v2.helpCenter.section'
    },
    onboardingDescriptionCreateOrHcClickWithLink: {
        defaultMessage: 'Upgrade to Jira Service Management Premium to create and manage multiple help centers on your site and ',
        description: 'Upgrade modal description a help center is clicked or create a help center is clicked',
        id: 'uh.home.downgrade.modal.description.create.or.hc.with.link'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    onboardingTitleHCClick: {
        defaultMessage: 'Serve different audiences with multiple help centers',
        description: 'Upgrade modal title when help center is clicked',
        id: 'uh.home.downgrade.modal.title.hc'
    },
    freeStandardAdminsChangeBoardingHeading: {
        defaultMessage: 'Your help center settings have moved here',
        description: 'Heading text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.heading'
    },
    freeStandardAdminsChangeBoardingContent: {
        defaultMessage: 'Manage profile settings, view your requests, and customize your help center from here.',
        description: 'Content for topics Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.content'
    },
    freeStandardAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.button'
    },
    singlePortalScreenAdminsChangeBoardingHeading: {
        defaultMessage: 'Your portal settings have moved here',
        description: 'Heading text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.heading.'
    },
    singlePortalScreenAdminsChangeBoardingContent: {
        defaultMessage: 'Access your requests, profile settings, and customize the portal experience from here',
        description: 'Content for topics Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.content'
    },
    singlePortalScreenAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.button'
    },
    manageHc: {
        defaultMessage: 'View all help centers',
        description: 'Message for navigating to hc-management screen in avatar menu',
        id: 'avatar.menu.v2.manageHc'
    },
    managePages: {
        defaultMessage: 'Landing pages',
        description: 'Message for navigating to landing pages screen in avatar menu',
        id: 'avatar.menu.v2.help.center.pages'
    },
    rovoAgent: {
        defaultMessage: 'Rovo Agent',
        description: 'Label for create cutomized rovo agent button in avatar menue which is used to create a customized rovo agent',
        id: 'avatar.menu.v2.rovoAgent'
    },
    createHc: {
        defaultMessage: 'Create a help center',
        description: 'Label for create help center button in avatar menu which is used to navigate to the help center management page',
        id: 'avatar.menu.v2.createHc'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.description'
    },
    pageLayoutTryItNowButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.try.it.now.button'
    },
    premiumLozenge: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.premium.lozenge'
    },
    landingPagesNonPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create landing pages in a help center.',
        description: 'Non premium description for landing pages',
        id: 'avatar.menu.v2.landing.pages.non.premium.customer.description'
    },
    helpCenterMenuOptions: {
        defaultMessage: 'Help center menu options',
        description: 'Aria label for help center menu navigation list',
        id: 'avatar.menu.v2.helpCenter.menu.options'
    }
});

});

parcelRegister("ehpnm", function(module, exports) {
$parcel$export(module.exports, "RovoAgentMenu", () => $6491c1f392e8101d$export$6cf91bfbf0fffa69);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fuVmc = parcelRequire("fuVmc");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $cExzV = parcelRequire("cExzV");

var $cjQhO = parcelRequire("cjQhO");

var $9P2Zq = parcelRequire("9P2Zq");

var $efD9w = parcelRequire("efD9w");
const $6491c1f392e8101d$export$6cf91bfbf0fffa69 = ({ onClose: onClose, component: component })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarRovoAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        key: "customize-menu_navBarRovoAgent",
        component: component,
        href: `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/rovo-agent`,
        actionSubjectId: "navBarRovoAgent",
        onClick: handleClick,
        testId: "rovo-agent-link",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
            appearance: "discovery"
        }, formatMessage((0, $efD9w.default).newLozenge)),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).rovoAgent));
};

});

parcelRegister("iecar", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentMenu", () => $cccb647988df5cb4$export$3d3173207fec7a12);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $8gC0T = parcelRequire("8gC0T");

var $fuVmc = parcelRequire("fuVmc");

var $dVmKA = parcelRequire("dVmKA");

var $kXBd7 = parcelRequire("kXBd7");

var $5cKiX = parcelRequire("5cKiX");

var $cjQhO = parcelRequire("cjQhO");

var $9cAYa = parcelRequire("9cAYa");

var $1jnkF = parcelRequire("1jnkF");

var $9P2Zq = parcelRequire("9P2Zq");

var $efD9w = parcelRequire("efD9w");
const $cccb647988df5cb4$export$3d3173207fec7a12 = ({ onClose: onClose, component: component })=>{
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $bSJIT.useState)(true);
    const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarVirtualAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dVmKA.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9cAYa.default), {
            name: (0, $jcRK7.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT,
            key: "navBarVirtualAgent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            key: `customize-menu_navBarVirtualAgent`,
            component: component,
            href: `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/virtual-agent`,
            actionSubjectId: "navBarVirtualAgent",
            onClick: handleClick,
            testId: "virtual-agent-link",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $efD9w.default).virtualServiceAgent)))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1jnkF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8gC0T.default), {
        messageId: (0, $jcRK7.EngagementMessages).ONBOARD_VA_REPORTING,
        key: (0, $jcRK7.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kXBd7.VaOnboardingSpotlight), {
        setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
    }))));
};

});






parcelRegister("egy8t", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("5XH4p")).default);

var $5XH4p = parcelRequire("5XH4p");

});
parcelRegister("5XH4p", function(module, exports) {
$parcel$export(module.exports, "default", () => $26401bd53ba92dac$export$2e2bcd8739ae039);

var $jeIez = parcelRequire("jeIez");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("8Khoy");
var $iaagT = parcelRequire("iaagT");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $k30kR = parcelRequire("k30kR");

var $gQxPF = parcelRequire("gQxPF");
parcelRequire("cJJTb");
var $bf3Xm = parcelRequire("bf3Xm");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("5aCJX");
var $j4AtC = parcelRequire("j4AtC");
parcelRequire("44VoE");
var $jPujg = parcelRequire("jPujg");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("2yynh");
var $atle4 = parcelRequire("atle4");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $87QgR = parcelRequire("87QgR");

var $daloG = parcelRequire("daloG");

var $3eoOe = parcelRequire("3eoOe");

var $3LQyI = parcelRequire("3LQyI");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
parcelRequire("kf1Td");
var $9dLcv = parcelRequire("9dLcv");
parcelRequire("bVxgZ");
var $lYvgg = parcelRequire("lYvgg");
parcelRequire("6XC7I");
var $iPRnq = parcelRequire("iPRnq");
parcelRequire("1FNk3");
var $vG4do = parcelRequire("vG4do");
const $26401bd53ba92dac$export$4b85d3515bd863a5 = ({ term: term, trigger: trigger, isOpen: isOpen, onSearch: onSearch, onClose: onClose, onOpen: onOpen, resetSearch: resetSearch, fetchHelpCenter: fetchHelpCenter, fetchPortals: fetchPortals, disableSearch: disableSearch, isVSAOnHCEnabled: isVSAOnHCEnabled })=>{
    const searchButtonRef = (0, $bSJIT.useRef)(null);
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $2FLDr.isSinglePortalSearch)(portalId)) fetchPortals({
            id: (0, $2FLDr.getPortalIdAsNumber)(portalId),
            expand: [
                'kbs',
                'reqTypes',
                'reqGroups',
                'orderMapping'
            ]
        });
    }, [
        portalId,
        fetchHelpCenter,
        fetchPortals
    ]);
    const onReturnFocus = (0, $bSJIT.useCallback)((_)=>{
        //FocusLock trap is still active due to that we deffer setting focus with zero-timeout
        setTimeout(()=>{
            var _searchButtonRef$curr;
            searchButtonRef === null || searchButtonRef === void 0 || (_searchButtonRef$curr = searchButtonRef.current) === null || _searchButtonRef$curr === void 0 || _searchButtonRef$curr.focus();
        }, 0);
        return true;
    }, []);
    (0, $bSJIT.useEffect)(()=>()=>{
            resetSearch();
        }, [
        resetSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iPRnq.default), {
        isOpen: isOpen,
        term: term,
        portalId: portalId,
        onSearch: onSearch,
        onClose: onClose,
        onReturnFocus: onReturnFocus,
        isVSAOnHCEnabled: isVSAOnHCEnabled
    }), trigger === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $atle4.default), {
        ref: searchButtonRef,
        shown: isOpen,
        onClick: onOpen,
        disableSearch: disableSearch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9dLcv.InlineResultsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $vG4do.default), {
        term: term,
        disableSearch: disableSearch,
        isVSAOnHCEnabled: !!isVSAOnHCEnabled
    }))));
};
const $26401bd53ba92dac$var$SearchWithVirtualAgentAvailability = (props)=>{
    var _data$helpCenter, _data$helpCenter2, _data$virtualAgent;
    const { queryReference: queryReference, ...rest } = props;
    const data = (0, $a2qIF.usePreloadedQuery)((0, $jeIez.default), props.queryReference);
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($26401bd53ba92dac$export$4b85d3515bd863a5, rest);
    const isVirtualAgentEnabled = ((_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.virtualAgentEnabled) ?? false;
    const isVirtualAgentAvailable = (0, $lFpPv.isVAOnHelpCenterGAEnabled)() ? ((_data$virtualAgent = data.virtualAgent) === null || _data$virtualAgent === void 0 ? void 0 : _data$virtualAgent.virtualAgentAvailability) ?? false : true;
    const isVSAOnHCEnabled = isVirtualAgentEnabled && isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($26401bd53ba92dac$export$4b85d3515bd863a5, {
        isVSAOnHCEnabled: isVSAOnHCEnabled,
        ...rest
    });
};
const $26401bd53ba92dac$export$ab176425b2a52b00 = (props)=>{
    const { userLoggedIn: userLoggedIn } = props;
    const { queryReference: queryReference, refresh: refresh } = (0, $3LQyI.useRelayResource)((0, $k30kR.searchComponentVirtualAgentResource));
    const prevUserLoggedInState = (0, $3eoOe.usePrevious)(userLoggedIn);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if ((0, $87QgR.default).checkGate('jsd-search-router-login-logic-removal') && !prevUserLoggedInState && userLoggedIn) // fire refresh only if user has logged in same session, e.g., Portal only customer login
        refresh();
    }, [
        prevUserLoggedInState,
        userLoggedIn,
        refresh
    ]);
    const renderError = (0, $bSJIT.useCallback)(()=>{
        // We fallback to non-VSA search if there is an error occurs in this loader, All the other errors should be handled by the SearchErrorBoundary default renderError
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lYvgg.default), {
            id: "help-center-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($26401bd53ba92dac$export$4b85d3515bd863a5, props));
    }, [
        props
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lYvgg.default), {
        id: "help-center-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($26401bd53ba92dac$export$4b85d3515bd863a5, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lYvgg.default), {
        id: "help-center-search",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($26401bd53ba92dac$export$4b85d3515bd863a5, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($26401bd53ba92dac$var$SearchWithVirtualAgentAvailability, {
        queryReference: queryReference,
        ...props
    })));
};
const $26401bd53ba92dac$var$selector = (0, $BOq7h.createSelector)((0, $jPujg.getShown), (0, $jPujg.getTerm), (0, $fBLyB.isLoggedIn), (shown, term, userLoggedIn)=>({
        term: term,
        userLoggedIn: userLoggedIn,
        isOpen: shown
    }));
const $26401bd53ba92dac$var$ConnectedSearch = (0, $f2mlD.default)($26401bd53ba92dac$var$selector, {
    onOpen: ()=>(0, $j4AtC.showSearch)(true),
    onClose: ()=>(0, $j4AtC.showSearch)(false),
    onSearch: (term)=>(0, $j4AtC.updateSearch)(term, {}),
    resetSearch: (0, $j4AtC.resetSearch),
    fetchPortals: (0, $jeW3I.fetchPortalAction),
    fetchHelpCenter: (0, $iaagT.fetchHelpCenterAction)
})((0, $daloG.PortalAnalyticsModal)((0, $jcRK7.ScreenName).HELP_CENTER_SEARCH)(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
(0, $gQxPF.default)((0, $2usNr.default)({
    component: (0, $jcRK7.ScreenName).HELP_CENTER_SEARCH
})((0, $kIbto.default)()($26401bd53ba92dac$export$ab176425b2a52b00)))));
var $26401bd53ba92dac$export$2e2bcd8739ae039 = $26401bd53ba92dac$var$ConnectedSearch;

});
parcelRegister("gQxPF", function(module, exports) {
$parcel$export(module.exports, "PathParamsProvider", () => $55b0bc91a955b20d$export$ebcbd875f0707321);
$parcel$export(module.exports, "withPathParamProvider", () => $55b0bc91a955b20d$export$e8aa4f1b1a2e784c);
$parcel$export(module.exports, "default", () => $55b0bc91a955b20d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
const $55b0bc91a955b20d$var$RouteParamContext = /*#__PURE__*/ $bSJIT.createContext({});
const $55b0bc91a955b20d$export$ebcbd875f0707321 = (props)=>/*#__PURE__*/ $bSJIT.createElement($55b0bc91a955b20d$var$RouteParamContext.Provider, {
        value: props.params
    }, props.children);
const $55b0bc91a955b20d$var$withPathParams = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $bSJIT.createElement($55b0bc91a955b20d$var$RouteParamContext.Consumer, null, (value)=>/*#__PURE__*/ $bSJIT.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
const $55b0bc91a955b20d$export$e8aa4f1b1a2e784c = (Component)=>{
    // eslint-disable-next-line react/display-name
    return (props)=>{
        const [{ match: match }] = (0, $h1bGI.useRouter)();
        return /*#__PURE__*/ $bSJIT.createElement($55b0bc91a955b20d$export$ebcbd875f0707321, {
            params: match.params
        }, /*#__PURE__*/ $bSJIT.createElement(Component, props));
    };
};
var $55b0bc91a955b20d$export$2e2bcd8739ae039 = $55b0bc91a955b20d$var$withPathParams;

});

parcelRegister("2yynh", function(module, exports) {
$parcel$export(module.exports, "SearchButton", () => (parcelRequire("atle4")).default);

var $atle4 = parcelRequire("atle4");

});
parcelRegister("atle4", function(module, exports) {
$parcel$export(module.exports, "default", () => $61ce6268bedcf3d2$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $hzFIQ = parcelRequire("hzFIQ");

var $gfXmS = parcelRequire("gfXmS");
const $61ce6268bedcf3d2$export$690bcf3a1f1e9f2f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ onClick: onClick, disableSearch: disableSearch }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($61ce6268bedcf3d2$var$StyledSearchIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        isDisabled: disableSearch,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        style: {
            borderRadius: '50%'
        },
        ref: ref,
        onClick: onClick,
        appearance: "subtle",
        shouldFitContainer: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            spacing: "spacious",
            label: "Search",
            color: "var(--ds-icon, #42526E)"
        }),
        analyticsContext: {
            actionSubjectId: 'navbarSearch'
        }
    }));
});
$61ce6268bedcf3d2$export$690bcf3a1f1e9f2f.displayName = 'SearchButton';
var $61ce6268bedcf3d2$export$2e2bcd8739ae039 = $61ce6268bedcf3d2$export$690bcf3a1f1e9f2f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $61ce6268bedcf3d2$var$StyledSearchIconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-tktwuw-0"
})`display:flex;height:${"var(--ds-space-400, 32px)"};width:${"var(--ds-space-400, 32px)"};align-items:stretch;background-color:${"var(--ds-surface-overlay, #EBECF0)"};border-radius:50%;flex-direction:column;justify-content:center;transform:translateZ(0);transition:transform 200ms,opacity 200ms;box-shadow:${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"};border:none;margin:${"var(--ds-space-150, 12px)"};padding:0;cursor:pointer;`;

});
parcelRegister("gfXmS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455ddf841838a21b0f783ea6448b0f9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $030ddf6021561d10$var$_react = $030ddf6021561d10$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $030ddf6021561d10$var$_iconNew = $030ddf6021561d10$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $030ddf6021561d10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $030ddf6021561d10$var$SearchIcon = (props)=>/*#__PURE__*/ $030ddf6021561d10$var$_react.default.createElement($030ddf6021561d10$var$_iconNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$030ddf6021561d10$var$SearchIcon.displayName = 'SearchIcon';
var $030ddf6021561d10$var$_default = module.exports.default = $030ddf6021561d10$var$SearchIcon;

});



parcelRegister("daloG", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsInlineDialog", () => $eb913ad3f9622ce8$export$4de18d88452d7a08);
$parcel$export(module.exports, "PortalAnalyticsModal", () => $eb913ad3f9622ce8$export$e80acabac337720d);
$parcel$export(module.exports, "PortalAnalyticsDrawer", () => $eb913ad3f9622ce8$export$3b1f159f4ab6aaae);

var $haAAx = parcelRequire("haAAx");

var $jYOKI = parcelRequire("jYOKI");
function $eb913ad3f9622ce8$var$screenWithoutBrowserMetrics(name, sourceType, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes) {
    const analyticsWrapper = (0, $haAAx.withAnalyticsContext)({
        sourceType: sourceType,
        sourceName: name,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        attributes: {
            ...attributes,
            context: 'Portal'
        }
    });
    return (component)=>(0, $jYOKI.clearScreenName)(analyticsWrapper(component));
}
const $eb913ad3f9622ce8$export$4de18d88452d7a08 = (name, attributes)=>$eb913ad3f9622ce8$var$screenWithoutBrowserMetrics(name, (0, $haAAx.ScreenTypes).INLINE_DIALOG, attributes);
const $eb913ad3f9622ce8$export$e80acabac337720d = (name, attributes)=>$eb913ad3f9622ce8$var$screenWithoutBrowserMetrics(name, (0, $haAAx.ScreenTypes).MODAL, attributes);
const $eb913ad3f9622ce8$export$3b1f159f4ab6aaae = (name, attributes)=>$eb913ad3f9622ce8$var$screenWithoutBrowserMetrics(name, (0, $haAAx.ScreenTypes).DRAWER, attributes);

});

parcelRegister("3eoOe", function(module, exports) {
$parcel$export(module.exports, "useMounted", () => $6fac7bdbfb02ae91$export$bce3bfec9f56c837);
$parcel$export(module.exports, "usePrevious", () => $6fac7bdbfb02ae91$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useIsoMorphicLayoutEffect", () => $6fac7bdbfb02ae91$export$3d58f1da4ac28ebc);

var $bSJIT = parcelRequire("bSJIT");
function $6fac7bdbfb02ae91$export$bce3bfec9f56c837() {
    const referenceToMounted = $bSJIT.useRef(false);
    $bSJIT.useEffect(()=>{
        if (!referenceToMounted.current) referenceToMounted.current = true;
        return ()=>{
            if (referenceToMounted.current) referenceToMounted.current = false;
        };
    }, []);
    return referenceToMounted.current;
}
function $6fac7bdbfb02ae91$export$5cae361ad82dce8b(value) {
    const referenceToValue = $bSJIT.useRef();
    $bSJIT.useEffect(()=>{
        referenceToValue.current = value;
    }, [
        value
    ]);
    return referenceToValue.current;
}
const $6fac7bdbfb02ae91$export$3d58f1da4ac28ebc = (0, $bSJIT.useLayoutEffect);

});

parcelRegister("kf1Td", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => (parcelRequire("9dLcv")).InlineResultsContextProvider);
$parcel$export(module.exports, "useInlineResultsContext", () => (parcelRequire("9dLcv")).useInlineResultsContext);

var $9dLcv = parcelRequire("9dLcv");

});
parcelRegister("9dLcv", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => $a75ae33b4bc07434$export$55d16b7f4336c4d7);
$parcel$export(module.exports, "useInlineResultsContext", () => $a75ae33b4bc07434$export$243a7c3fd4b96b3e);

var $bSJIT = parcelRequire("bSJIT");
const $a75ae33b4bc07434$var$InlineResultsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(null);
const $a75ae33b4bc07434$export$55d16b7f4336c4d7 = ({ children: children })=>{
    const [resultsCount, setResultsCount] = (0, $bSJIT.useState)(null);
    const updateSearchResultsCount = (0, $bSJIT.useCallback)((resourceType, resourceCount)=>setResultsCount((state)=>({
                ...state,
                [resourceType]: resourceCount
            })), [
        setResultsCount
    ]);
    const clearSearchResultsCount = (0, $bSJIT.useCallback)(()=>setResultsCount(null), [
        setResultsCount
    ]);
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            resultsCount: resultsCount,
            clearSearchResultsCount: clearSearchResultsCount,
            updateSearchResultsCount: updateSearchResultsCount
        }), [
        resultsCount,
        clearSearchResultsCount,
        updateSearchResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a75ae33b4bc07434$var$InlineResultsContext.Provider, {
        value: contextValue
    }, children);
};
const $a75ae33b4bc07434$export$243a7c3fd4b96b3e = ()=>{
    const context = (0, $bSJIT.useContext)($a75ae33b4bc07434$var$InlineResultsContext);
    if (!context) throw new Error('useInlineResultsContext must be used within InlineResultsContextProvider');
    return context;
};

});


parcelRegister("bVxgZ", function(module, exports) {
$parcel$export(module.exports, "SearchErrorBoundary", () => (parcelRequire("lYvgg")).default);

var $lYvgg = parcelRequire("lYvgg");

});
parcelRegister("lYvgg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1865e18e8c940f76$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $4ZMmh = parcelRequire("4ZMmh");

var $hCnLH = parcelRequire("hCnLH");

var $jYOKI = parcelRequire("jYOKI");

var $iW3CQ = parcelRequire("iW3CQ");

var $51XYw = parcelRequire("51XYw");
parcelRequire("8AD3v");
var $7Bjdb = parcelRequire("7Bjdb");

var $f5JeN = parcelRequire("f5JeN");
const $1865e18e8c940f76$var$SearchErrorBoundary = ({ screenName: screenName, id: id, children: children, renderError: renderError })=>{
    /**
   * If any error unrecoverable occurs inside search
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure using UFO
   */ const markExperienceFailed = (0, $bSJIT.useCallback)((error)=>{
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) {
            const metadata = {
                id: id,
                error: error === null || error === void 0 ? void 0 : error.message,
                failureEvent: screenName
            };
            (0, $f5JeN.searchExperience).failure({
                metadata: metadata
            }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
            if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType)) (0, $f5JeN.csmSearchExperience).failure({
                metadata: metadata
            }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
            (0, $f5JeN.inlineSearchExperience).failure({
                metadata: metadata
            }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
        }
    }, [
        id,
        screenName
    ]);
    const defaultRenderError = (0, $bSJIT.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7Bjdb.default), null);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: screenName,
        id: id,
        renderError: renderError ? renderError : defaultRenderError,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(children));
};
var $1865e18e8c940f76$export$2e2bcd8739ae039 = (0, $jYOKI.default)($1865e18e8c940f76$var$SearchErrorBoundary);

});
parcelRegister("8AD3v", function(module, exports) {
$parcel$export(module.exports, "SearchResultError", () => (parcelRequire("7Bjdb")).default);

var $7Bjdb = parcelRequire("7Bjdb");

});
parcelRegister("7Bjdb", function(module, exports) {
$parcel$export(module.exports, "default", () => $564700b6a1a619b3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $c6H7d = parcelRequire("c6H7d");

var $18LqO = parcelRequire("18LqO");

var $4vLTk = parcelRequire("4vLTk");

var $7WQx2 = parcelRequire("7WQx2");

var $hYh8H = parcelRequire("hYh8H");

var $oORS9 = parcelRequire("oORS9");
parcelRequire("4BroI");
var $c6fXf = parcelRequire("c6fXf");

var $j1kwM = parcelRequire("j1kwM");
const $564700b6a1a619b3$var$SearchResultError = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($18LqO)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "xsmall"
    }, formatMessage((0, $j1kwM.default).searchErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("p", {
        style: {
            textAlign: 'center'
        }
    }, formatMessage((0, $j1kwM.default).searchErrorText, {
        helpCenterLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6H7d.default), {
            to: (0, $oORS9.getHelpCenterUrl)(),
            actionSubjectId: "helpCenterLink"
        }, formatMessage((0, $j1kwM.default).helpCenter))
    })));
};
var $564700b6a1a619b3$export$2e2bcd8739ae039 = $564700b6a1a619b3$var$SearchResultError;

});
parcelRegister("18LqO", function(module, exports) {
module.exports = new URL("../images/search-modal-error.b0f67bec.svg", import.meta.url).toString();

});

parcelRegister("j1kwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8f2aac0f7920c2a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $b8f2aac0f7920c2a$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    searchErrorTitle: {
        defaultMessage: 'We couldn\u2019t load your search results',
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.error.title'
    },
    searchErrorText: {
        defaultMessage: 'Refresh the page and try again. Or go back to the { helpCenterLink }.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.error.message'
    },
    helpCenter: {
        defaultMessage: 'help center',
        description: 'Text to render help center link',
        id: 'cv.search.error.help-center'
    }
});

});



parcelRegister("f5JeN", function(module, exports) {
$parcel$export(module.exports, "searchExperience", () => $a752b8edb3bc01ba$export$478fc2b872b7df27);
$parcel$export(module.exports, "csmSearchExperience", () => $a752b8edb3bc01ba$export$c32ff69c6cd0bb0b);
$parcel$export(module.exports, "inlineSearchExperience", () => $a752b8edb3bc01ba$export$e3eaed2128f58e6a);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $a752b8edb3bc01ba$export$478fc2b872b7df27 = new (0, $1we90.UFOExperience)((0, $eAZuG.searchExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageLoad
});
const $a752b8edb3bc01ba$export$c32ff69c6cd0bb0b = new (0, $1we90.UFOExperience)('csm-help-center-search', {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $a752b8edb3bc01ba$export$e3eaed2128f58e6a = new (0, $1we90.UFOExperience)((0, $eAZuG.inlineSearchExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("6XC7I", function(module, exports) {
$parcel$export(module.exports, "SearchModal", () => (parcelRequire("iPRnq")).default);

var $iPRnq = parcelRequire("iPRnq");

});
parcelRegister("iPRnq", function(module, exports) {
$parcel$export(module.exports, "default", () => $043d0898334effd8$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $bbFTS = parcelRequire("bbFTS");

var $3HBS2 = parcelRequire("3HBS2");

var $fuVmc = parcelRequire("fuVmc");

var $lxglv = parcelRequire("lxglv");

var $fvUqa = parcelRequire("fvUqa");

var $bm44u = parcelRequire("bm44u");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $hZsX2 = parcelRequire("hZsX2");

var $8W36W = parcelRequire("8W36W");

var $cglph = parcelRequire("cglph");

var $gUpf2 = parcelRequire("gUpf2");

var $jnInZ = parcelRequire("jnInZ");

var $2IITT = parcelRequire("2IITT");

var $4pBHw = parcelRequire("4pBHw");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $juI4y = parcelRequire("juI4y");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $ikzcz = parcelRequire("ikzcz");

var $jSfp7 = parcelRequire("jSfp7");

var $4dRLB = parcelRequire("4dRLB");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
var $c6fXf = parcelRequire("c6fXf");
parcelRequire("i1k7Q");
var $hfp06 = parcelRequire("hfp06");
parcelRequire("1oNsK");
var $gHESL = parcelRequire("gHESL");
parcelRequire("1fyiO");
var $aqM1S = parcelRequire("aqM1S");

var $cJ8XI = parcelRequire("cJ8XI");

var $lFpPv = parcelRequire("lFpPv");
const $043d0898334effd8$var$SearchModal = ({ isOpen: isOpen, term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, isLoggedIn: isLoggedIn, portalId: portalId, projectId: projectId, onSearch: onSearch, onClose: onClose, onReturnFocus: onReturnFocus })=>{
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const showSearchResults = (0, $2FLDr.isValidSearchTerm)(term);
    const scope = portalId ? 'portal' : 'helpCenter';
    const cloudId = (0, $fuVmc.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $ikzcz.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const isVirtualAgentAvailableForPortal = scope === 'portal' && isVirtualAgentAvailableForProject;
    const isVirtualAgentAvailableForHelpCenter = scope === 'helpCenter' && isVSAOnHCEnabled;
    const isVirtualAgentAvailable = (isVirtualAgentAvailableForPortal || isVirtualAgentAvailableForHelpCenter) && !(0, $lFpPv.isHideVsaEndpointsEnabled)();
    const onKeyUp = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const [{ location: location }, { replace: replace }] = (0, $h1bGI.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $2FLDr.useQueryParams)();
    const { portalIds: portalIds, categoryIds: categoryIds } = queryStringParams;
    const portalIdAsNumber = (0, $2FLDr.getPortalIdAsNumber)(portalId);
    const showCategoryFilter = (0, $2FLDr.isSinglePortalSearch)(portalIdAsNumber);
    const onServiceDeskFilterChange = (0, $bSJIT.useCallback)((options)=>{
        const selectedPortalIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($fvUqa))).stringify({
            ...queryStringParams,
            portalIds: selectedPortalIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const onCategoryFilterChange = (0, $bSJIT.useCallback)((options)=>{
        const selectedCategoryIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($fvUqa))).stringify({
            ...queryStringParams,
            categoryIds: selectedCategoryIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const renderResults = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
            gap: "space.200",
            templateColumns: "1fr",
            alignItems: "center",
            xcss: $043d0898334effd8$var$responsiveStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null), showSearchResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), null, isVirtualAgentAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $043d0898334effd8$var$virtualBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jSfp7.VirtualAgentBanner), {
            cloudId: cloudId,
            portalId: portalId
        })), !isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
            xcss: $043d0898334effd8$var$filterStyles
        }, showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dRLB.default), {
            onChange: onCategoryFilterChange,
            portalId: portalIdAsNumber,
            projectId: projectId,
            categoryIds: categoryIds
        }), !showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJ8XI.default), {
            onChange: onServiceDeskFilterChange,
            portalIds: portalIds
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aqM1S.SearchResult), {
            term: term
        })) : // Show empty query state if invalid search term
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hfp06.SearchResultNone), {
            term: term
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8W36W.default), {
        duration: "small",
        entranceDirection: "bottom"
    }, (fadeInProps)=>isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cglph.default), {
            zIndex: (0, $juI4y.layers).dialog()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            ...fadeInProps,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                width: '100vw',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: '100vh',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                position: 'fixed',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: '0px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                left: '0px'
            },
            role: "dialog",
            "aria-modal": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bm44u.default), {
            autoFocus: true,
            returnFocus: onReturnFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lxglv.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hZsX2.default), {
            shouldAllowClickThrough: false,
            isTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $9BVpB.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: `calc(100% - ${(0, $c6fXf.SEARCH_BAR_HEIGHT)})`
            }),
            onKeyUp: onKeyUp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gHESL.SearchBar), {
            term: term,
            onChange: onSearch,
            onClose: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            id: "dynamic-search-result",
            "aria-live": "polite",
            "aria-atomic": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $9BVpB.xcss)({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: (0, $c6fXf.SEARCH_BAR_HEIGHT),
                backgroundColor: 'elevation.surface.overlay',
                paddingTop: 'space.300',
                paddingBottom: 'space.200',
                overflow: 'auto'
            })
        }, renderResults())))))));
};
var $043d0898334effd8$export$2e2bcd8739ae039 = (0, $f2mlD.default)((0, $BOq7h.createSelector)((0, $3HBS2.isLoggedIn), (state, { portalId: portalId })=>({
        portalId: portalId,
        projectId: (0, $bbFTS.getProjectId)(state, (0, $2FLDr.getPortalIdAsNumber)(portalId))
    }), (isLoggedIn, { portalId: portalId, projectId: projectId })=>({
        isLoggedIn: isLoggedIn,
        portalId: portalId,
        projectId: projectId
    })))($043d0898334effd8$var$SearchModal);
const $043d0898334effd8$var$virtualBannerStyles = (0, $9BVpB.xcss)({
    marginBottom: 'space.200'
});
const $043d0898334effd8$var$filterStyles = (0, $9BVpB.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.300'
});
const $043d0898334effd8$var$responsiveStyles = (0, $9BVpB.xcss)({
    [(0, $4pBHw.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $4pBHw.media).above.md]: {
        gridTemplateColumns: '1fr 965px 1fr',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    }
});

});
parcelRegister("lxglv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1180d63b8f30e16$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");
parcelRequire("9H44a");
var $dCSpQ = parcelRequire("dCSpQ");

var $k2niP = parcelRequire("k2niP");
const $d1180d63b8f30e16$export$38d08b04f5a0ce72 = /*#__PURE__*/ (0, $4v2A7.default)((0, $dCSpQ.default)).withConfig({
    componentId: "sc-1eshvn8-0"
})`overflow:hidden;position:relative;box-sizing:border-box;padding-right:${(props)=>props.scrollbarWidth}px;`;
class $d1180d63b8f30e16$export$2e2bcd8739ae039 extends $bSJIT.Component {
    componentDidMount() {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        if (!document.body) return;
        const scrollbarWidth = (0, $k2niP.windowInnerWidth)() - (0, $k2niP.bodyClientWidth)();
        this.setState({
            scrollbarWidth: scrollbarWidth,
            show: true
        });
    }
    render() {
        return this.state.show ? /*#__PURE__*/ $bSJIT.createElement($d1180d63b8f30e16$export$38d08b04f5a0ce72, {
            scrollbarWidth: this.state.scrollbarWidth
        }) : null;
    }
    constructor(...args){
        super(...args), this.state = {
            scrollbarWidth: 0,
            show: false
        };
    }
}

});
parcelRegister("k2niP", function(module, exports) {
$parcel$export(module.exports, "windowInnerWidth", () => $2b1f79a111695817$export$c2f81cb82ec2bad8);
$parcel$export(module.exports, "bodyClientWidth", () => $2b1f79a111695817$export$d31820d1c745406f);
const $2b1f79a111695817$export$c2f81cb82ec2bad8 = ()=>window.innerWidth;
const $2b1f79a111695817$export$d31820d1c745406f = ()=>document.body.clientWidth;

});


parcelRegister("bm44u", function(module, exports) {
$parcel$export(module.exports, "default", () => $8444e845f42ddd95$export$2e2bcd8739ae039);

var $6Phd7 = parcelRequire("6Phd7");

var $8444e845f42ddd95$export$2e2bcd8739ae039 = (0, $6Phd7.default);

});
parcelRegister("6Phd7", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f84db2fea25f227$export$2e2bcd8739ae039);

var $kV77Q = parcelRequire("kV77Q");

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");

var $erAwa = parcelRequire("erAwa");

var $2Bs4q = parcelRequire("2Bs4q");
var $4f84db2fea25f227$var$FocusLockCombination = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $erAwa.default), (0, $g8vBZ.default)({
        sideCar: (0, $2Bs4q.default),
        ref: ref
    }, props));
});
var $4f84db2fea25f227$var$_ref = (0, $erAwa.default).propTypes || {}, $4f84db2fea25f227$var$sideCar = $4f84db2fea25f227$var$_ref.sideCar, $4f84db2fea25f227$var$propTypes = (0, $kV77Q.default)($4f84db2fea25f227$var$_ref, [
    "sideCar"
]);
$4f84db2fea25f227$var$FocusLockCombination.propTypes = {};
var $4f84db2fea25f227$export$2e2bcd8739ae039 = $4f84db2fea25f227$var$FocusLockCombination;

});
parcelRegister("erAwa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a83fe9ffdb0f0001$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");


var $4IISo = parcelRequire("4IISo");

var $dP4Jx = parcelRequire("dP4Jx");

var $jlc4J = parcelRequire("jlc4J");

var $eeDH8 = parcelRequire("eeDH8");

var $8Fc9R = parcelRequire("8Fc9R");
var $a83fe9ffdb0f0001$var$emptyArray = [];
var $a83fe9ffdb0f0001$var$FocusLock = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $bSJIT.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $bSJIT.useRef)();
    var isActive = (0, $bSJIT.useRef)(false);
    var originalFocusedElement = (0, $bSJIT.useRef)(null);
    var _useState2 = (0, $bSJIT.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $a83fe9ffdb0f0001$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $bSJIT.useState)({}), id = _useState3[0];
    var onActivation = (0, $bSJIT.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $bSJIT.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $bSJIT.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $bSJIT.useCallback)(function(event) {
        if (isActive.current) (0, $eeDH8.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $eeDH8.mediumBlur).useMedium;
    var setObserveNode = (0, $bSJIT.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $g8vBZ.default)((_extends2 = {}, _extends2[0, $4IISo.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $4IISo.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $dP4Jx.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $bSJIT.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $jlc4J.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $jlc4J.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(SideCar, {
        id: id,
        sideCar: (0, $eeDH8.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Container, (0, $g8vBZ.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Fc9R.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $jlc4J.hiddenGuard)
    }));
});
$a83fe9ffdb0f0001$var$FocusLock.propTypes = {};
var $a83fe9ffdb0f0001$export$2e2bcd8739ae039 = $a83fe9ffdb0f0001$var$FocusLock;

});
parcelRegister("jlc4J", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $e149585f4122b7ac$export$b8c7b07253306600);

var $bSJIT = parcelRequire("bSJIT");

var $e149585f4122b7ac$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $e149585f4122b7ac$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $e149585f4122b7ac$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $e149585f4122b7ac$export$b8c7b07253306600
    }));
};
$e149585f4122b7ac$var$InFocusGuard.propTypes = {};
var $e149585f4122b7ac$export$2e2bcd8739ae039 = $e149585f4122b7ac$var$InFocusGuard;

});

parcelRegister("eeDH8", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $a5d12a03ee847a9a$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $a5d12a03ee847a9a$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $a5d12a03ee847a9a$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $a5d12a03ee847a9a$export$892cbf28e5518020);

var $hxpNy = parcelRequire("hxpNy");
var $a5d12a03ee847a9a$export$5733e022b1d538cb = (0, $hxpNy.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $a5d12a03ee847a9a$export$b3e9a9312f73723c = (0, $hxpNy.createMedium)();
var $a5d12a03ee847a9a$export$3a1d52767cbc07b8 = (0, $hxpNy.createMedium)();
var $a5d12a03ee847a9a$export$892cbf28e5518020 = (0, $hxpNy.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("8Fc9R", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $64eb9568008bb9ae$export$f5272e9b1168239c);

var $bSJIT = parcelRequire("bSJIT");
var $64eb9568008bb9ae$export$f5272e9b1168239c = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});


parcelRegister("2Bs4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e54cfa7b0b2eb4c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");


var $2hmzL = parcelRequire("2hmzL");

var $2qbgg = parcelRequire("2qbgg");
var $fHz3D = parcelRequire("fHz3D");
var $1kOSJ = parcelRequire("1kOSJ");
var $etnYu = parcelRequire("etnYu");
var $S81Y3 = parcelRequire("S81Y3");
var $j48K1 = parcelRequire("j48K1");parcelRequire("kjDTm");
var $6JJio = parcelRequire("6JJio");

var $8ORUU = parcelRequire("8ORUU");

var $eeDH8 = parcelRequire("eeDH8");
var $1e54cfa7b0b2eb4c$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $1e54cfa7b0b2eb4c$var$isFreeFocus = function isFreeFocus() {
    return $1e54cfa7b0b2eb4c$var$focusOnBody() || (0, $S81Y3.focusIsHidden)();
};
var $1e54cfa7b0b2eb4c$var$lastActiveTrap = null;
var $1e54cfa7b0b2eb4c$var$lastActiveFocus = null;
var $1e54cfa7b0b2eb4c$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $1e54cfa7b0b2eb4c$var$lastPortaledElement = null;
var $1e54cfa7b0b2eb4c$var$focusWasOutsideWindow = false;
var $1e54cfa7b0b2eb4c$var$windowFocused = false;
var $1e54cfa7b0b2eb4c$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $1e54cfa7b0b2eb4c$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($1e54cfa7b0b2eb4c$var$lastActiveTrap.whiteList || $1e54cfa7b0b2eb4c$var$defaultWhitelist)(activeElement);
};
var $1e54cfa7b0b2eb4c$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $1e54cfa7b0b2eb4c$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $1e54cfa7b0b2eb4c$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $1e54cfa7b0b2eb4c$var$lastPortaledElement && $1e54cfa7b0b2eb4c$var$lastPortaledElement.portaledElement === element;
};
function $1e54cfa7b0b2eb4c$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $1e54cfa7b0b2eb4c$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($1e54cfa7b0b2eb4c$var$focusWasOutsideWindow);
    return $1e54cfa7b0b2eb4c$var$focusWasOutsideWindow === 'meanwhile';
};
var $1e54cfa7b0b2eb4c$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $1e54cfa7b0b2eb4c$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $1e54cfa7b0b2eb4c$var$checkInHost(activeElement, area, area);
    });
};
var $1e54cfa7b0b2eb4c$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $j48K1.getFocusableNodes)(nodes, new Map());
};
var $1e54cfa7b0b2eb4c$var$isNotFocusable = function isNotFocusable(node) {
    return !$1e54cfa7b0b2eb4c$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $1e54cfa7b0b2eb4c$var$activateTrap = function activateTrap() {
    var result = false;
    if ($1e54cfa7b0b2eb4c$var$lastActiveTrap) {
        var _lastActiveTrap = $1e54cfa7b0b2eb4c$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $1e54cfa7b0b2eb4c$var$lastPortaledElement && $1e54cfa7b0b2eb4c$var$lastPortaledElement.portaledElement;
        if ($1e54cfa7b0b2eb4c$var$focusOnBody() && $1e54cfa7b0b2eb4c$var$lastActiveFocus && $1e54cfa7b0b2eb4c$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($1e54cfa7b0b2eb4c$var$lastActiveFocus) || $1e54cfa7b0b2eb4c$var$isNotFocusable($1e54cfa7b0b2eb4c$var$lastActiveFocus)) {
                var newTarget = $1e54cfa7b0b2eb4c$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $8ORUU.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$1e54cfa7b0b2eb4c$var$focusWasOutside(crossFrame) || !noFocusGuards || !$1e54cfa7b0b2eb4c$var$lastActiveFocus || $1e54cfa7b0b2eb4c$var$windowFocused) return false;
                var nodes = $1e54cfa7b0b2eb4c$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $1e54cfa7b0b2eb4c$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $1e54cfa7b0b2eb4c$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$1e54cfa7b0b2eb4c$var$isFreeFocus() || !$1e54cfa7b0b2eb4c$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $etnYu.focusInside)(workingArea) || activeElement && $1e54cfa7b0b2eb4c$var$withinHost(activeElement, workingArea) || $1e54cfa7b0b2eb4c$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$1e54cfa7b0b2eb4c$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $6JJio.moveFocusInside)(workingArea, $1e54cfa7b0b2eb4c$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $1e54cfa7b0b2eb4c$var$lastPortaledElement = {};
                        }
                    }
                    $1e54cfa7b0b2eb4c$var$lastActiveFocus = document && document.activeElement;
                    if ($1e54cfa7b0b2eb4c$var$lastActiveFocus !== document.body) $1e54cfa7b0b2eb4c$var$tryRestoreFocus = (0, $2qbgg.captureFocusRestore)($1e54cfa7b0b2eb4c$var$lastActiveFocus);
                    $1e54cfa7b0b2eb4c$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $fHz3D.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $1e54cfa7b0b2eb4c$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $1e54cfa7b0b2eb4c$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $1e54cfa7b0b2eb4c$var$onTrap = function onTrap(event) {
    if ($1e54cfa7b0b2eb4c$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $1e54cfa7b0b2eb4c$var$onBlur = function onBlur() {
    return (0, $8ORUU.deferAction)($1e54cfa7b0b2eb4c$var$activateTrap);
};
var $1e54cfa7b0b2eb4c$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $1e54cfa7b0b2eb4c$var$recordPortal(currentNode, source);
};
var $1e54cfa7b0b2eb4c$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $1e54cfa7b0b2eb4c$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        onBlur: $1e54cfa7b0b2eb4c$var$onBlur,
        onFocus: $1e54cfa7b0b2eb4c$var$onFocus
    }, children);
};
$1e54cfa7b0b2eb4c$var$FocusTrap.propTypes = {};
var $1e54cfa7b0b2eb4c$var$onWindowFocus = function onWindowFocus() {
    $1e54cfa7b0b2eb4c$var$windowFocused = true;
};
var $1e54cfa7b0b2eb4c$var$onWindowBlur = function onWindowBlur() {
    $1e54cfa7b0b2eb4c$var$windowFocused = false;
    $1e54cfa7b0b2eb4c$var$focusWasOutsideWindow = 'just';
    (0, $8ORUU.deferAction)(function() {
        $1e54cfa7b0b2eb4c$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $1e54cfa7b0b2eb4c$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $1e54cfa7b0b2eb4c$var$onTrap);
    document.addEventListener('focusout', $1e54cfa7b0b2eb4c$var$onBlur);
    window.addEventListener('focus', $1e54cfa7b0b2eb4c$var$onWindowFocus);
    window.addEventListener('blur', $1e54cfa7b0b2eb4c$var$onWindowBlur);
};
var $1e54cfa7b0b2eb4c$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $1e54cfa7b0b2eb4c$var$onTrap);
    document.removeEventListener('focusout', $1e54cfa7b0b2eb4c$var$onBlur);
    window.removeEventListener('focus', $1e54cfa7b0b2eb4c$var$onWindowFocus);
    window.removeEventListener('blur', $1e54cfa7b0b2eb4c$var$onWindowBlur);
};
function $1e54cfa7b0b2eb4c$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $1e54cfa7b0b2eb4c$var$focusLockAPI = {
    moveFocusInside: (0, $6JJio.moveFocusInside),
    focusInside: (0, $etnYu.focusInside),
    focusNextElement: (0, $1kOSJ.focusNextElement),
    focusPrevElement: (0, $1kOSJ.focusPrevElement),
    focusFirstElement: (0, $1kOSJ.focusFirstElement),
    focusLastElement: (0, $1kOSJ.focusLastElement),
    captureFocusRestore: (0, $2qbgg.captureFocusRestore)
};
function $1e54cfa7b0b2eb4c$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$1e54cfa7b0b2eb4c$var$lastActiveTrap) $1e54cfa7b0b2eb4c$var$attachHandler();
    var lastTrap = $1e54cfa7b0b2eb4c$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $1e54cfa7b0b2eb4c$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $1e54cfa7b0b2eb4c$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($1e54cfa7b0b2eb4c$var$focusLockAPI);
        $1e54cfa7b0b2eb4c$var$activateTrap(true);
        (0, $8ORUU.deferAction)($1e54cfa7b0b2eb4c$var$activateTrap);
    } else {
        $1e54cfa7b0b2eb4c$var$detachHandler();
        $1e54cfa7b0b2eb4c$var$lastActiveFocus = null;
    }
}
(0, $eeDH8.mediumFocus).assignSyncMedium($1e54cfa7b0b2eb4c$var$onFocus);
(0, $eeDH8.mediumBlur).assignMedium($1e54cfa7b0b2eb4c$var$onBlur);
(0, $eeDH8.mediumEffect).assignMedium(function(cb) {
    return cb($1e54cfa7b0b2eb4c$var$focusLockAPI);
});
var $1e54cfa7b0b2eb4c$export$2e2bcd8739ae039 = (0, $2hmzL.default)($1e54cfa7b0b2eb4c$var$reducePropsToState, $1e54cfa7b0b2eb4c$var$handleStateChangeOnClient)($1e54cfa7b0b2eb4c$var$FocusWatcher);

});
parcelRegister("8ORUU", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $66bcd100574c8319$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $66bcd100574c8319$export$c613fed06e332533);
function $66bcd100574c8319$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $66bcd100574c8319$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $66bcd100574c8319$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("jnInZ", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $500d968fec680b34$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $gfZ3w = parcelRequire("gfZ3w");

var $lFZ63 = parcelRequire("lFZ63");
function $500d968fec680b34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $500d968fec680b34$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $500d968fec680b34$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $500d968fec680b34$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $500d968fec680b34$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $500d968fec680b34$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $500d968fec680b34$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $500d968fec680b34$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $500d968fec680b34$var$baseStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$500d968fec680b34$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$500d968fec680b34$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$500d968fec680b34$var$gridTemplateRowsVar})`
});
const $500d968fec680b34$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $500d968fec680b34$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $gfZ3w.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $bSJIT.useMemo)(()=>({
            [$500d968fec680b34$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$500d968fec680b34$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$500d968fec680b34$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $500d968fec680b34$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lFZ63.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lFZ63.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lFZ63.spaceStylesMap).rowGap[rowGap],
            alignItems && $500d968fec680b34$var$alignItemsMap[alignItems],
            alignContent && $500d968fec680b34$var$alignContentMap[alignContent],
            justifyContent && $500d968fec680b34$var$justifyContentMap[justifyContent],
            autoFlow && $500d968fec680b34$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$500d968fec680b34$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("ikzcz", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentAvailability", () => $607965f310220bf9$export$4cf57cfa614a5585);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $haAAx = parcelRequire("haAAx");

var $51XYw = parcelRequire("51XYw");
const $607965f310220bf9$var$initialState = {
    isVirtualAgentAvailable: false,
    isVirtualAgentEnabled: false,
    isLoading: true
};
const $607965f310220bf9$var$reducer = (state, action)=>{
    switch(action.type){
        case 'RESET':
            return {
                ...$607965f310220bf9$var$initialState,
                isLoading: false
            };
        case 'LOAD_AVAILABLITY':
            return $607965f310220bf9$var$initialState;
        case 'SET_AVAILABILITY':
            return {
                isVirtualAgentAvailable: action.isVirtualAgentAvailable,
                isVirtualAgentEnabled: action.isVirtualAgentEnabled,
                isLoading: false
            };
        default:
            return state;
    }
};
const $607965f310220bf9$export$4cf57cfa614a5585 = ({ isLoggedIn: isLoggedIn, projectId: projectId, cloudId: cloudId, baseUrl: baseUrl = '' })=>{
    const [{ isVirtualAgentAvailable: isVirtualAgentAvailable, isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isLoading }, dispatch] = (0, $bSJIT.useReducer)($607965f310220bf9$var$reducer, $607965f310220bf9$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        const canAccess = isLoggedIn;
        if (!canAccess) {
            dispatch({
                type: 'RESET'
            });
            return;
        }
        if (projectId === undefined) {
            dispatch({
                type: 'LOAD_AVAILABLITY'
            });
            return;
        }
        dispatch({
            type: 'LOAD_AVAILABLITY'
        });
        (0, $51XYw.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${encodeURIComponent(cloudId)}/public/api/v1/virtualagent/byprojectid/${encodeURIComponent(projectId)}/availability`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: true,
                isVirtualAgentEnabled: response.isVirtualAgentEnabled
            });
        }).catch((err)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: false,
                isVirtualAgentEnabled: false
            });
            if ('status' in err && typeof err.status === 'number' && err.status === 403) // AI is disabled or the user lacks permission, so this is not an error
            return;
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'virtualAgentAvailability',
                attributes: {
                    error: err.message
                }
            }).fire();
        });
    }, [
        createAnalyticsEvent,
        baseUrl,
        isLoggedIn,
        cloudId,
        projectId
    ]);
    return {
        isVirtualAgentAvailable: isVirtualAgentAvailable,
        isLoading: isLoading,
        isVirtualAgentEnabled: isVirtualAgentEnabled
    };
};

});

parcelRegister("jSfp7", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBanner", () => $10441b52bfb6b018$export$c79d8d330f0b0297);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $6WltM = parcelRequire("6WltM");

var $hzFIQ = parcelRequire("hzFIQ");

var $7WQx2 = parcelRequire("7WQx2");

var $eYvps = parcelRequire("eYvps");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $2IITT = parcelRequire("2IITT");

var $haAAx = parcelRequire("haAAx");

var $iydAA = parcelRequire("iydAA");

var $fmwkx = parcelRequire("fmwkx");
const $10441b52bfb6b018$export$c79d8d330f0b0297 = ({ cloudId: cloudId, portalId: portalId })=>{
    const scope = portalId ? 'portal' : 'helpCenter';
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [, { push: push }] = (0, $h1bGI.useRouter)();
    const chatWithVirtualAgentForPortal = (0, $bSJIT.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/66942
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButton'
        }).fire();
        if (portalId) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push(`/portal/${portalId}/conversation`);
    }, [
        push,
        portalId,
        createAnalyticsEvent
    ]);
    const chatWithVirtualAgentForHelpCenter = (0, $bSJIT.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButtonOnHelpCenter'
        }).fire();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        push,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $10441b52bfb6b018$var$containerStyles,
        role: "status",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        spread: "space-between",
        space: "space.100",
        xcss: $10441b52bfb6b018$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $fmwkx.default).virtualAgentBannerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($10441b52bfb6b018$var$Message, null, formatMessage((0, $fmwkx.default).virtualServiceAgentEAPBannerDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYvps))), {
            label: ""
        }),
        appearance: "primary",
        onClick: scope === 'portal' ? chatWithVirtualAgentForPortal : chatWithVirtualAgentForHelpCenter
    }, formatMessage((0, $fmwkx.default).buttonTextV2))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), {
        customData: {
            name: 'virtualAgentBanner',
            attributes: {
                cloudId: cloudId,
                portalId: portalId,
                state: 'visible'
            }
        }
    }));
};
const $10441b52bfb6b018$var$containerStyles = (0, $9BVpB.xcss)({
    background: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    padding: 'space.300',
    borderRadius: 'radius.small'
});
const $10441b52bfb6b018$var$contentStyles = (0, $9BVpB.xcss)({
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $10441b52bfb6b018$var$Message = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iydAA", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMount", () => $98850f52cabbff9d$export$787df3507b9eb1ae);

var $9YS87 = parcelRequire("9YS87");

var $jYOKI = parcelRequire("jYOKI");
const $98850f52cabbff9d$export$787df3507b9eb1ae = (0, $jYOKI.default)((0, $9YS87.FireScreenEventOnMountStateless));
// Manually set the display name for sensible snapshots
$98850f52cabbff9d$export$787df3507b9eb1ae.displayName = 'FireScreenEventOnMount';

});
parcelRegister("9YS87", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMountStateless", () => $a7a6f074c28a8f7a$export$641a363dc7c73107);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $k2MWg = parcelRequire("k2MWg");

var $clpci = parcelRequire("clpci");

var $fhp9e = parcelRequire("fhp9e");

var $haAAx = parcelRequire("haAAx");

var $2HsNW = parcelRequire("2HsNW");

var $6JJ8C = parcelRequire("6JJ8C");

var $db841 = parcelRequire("db841");

var $gEVth = parcelRequire("gEVth");
class $a7a6f074c28a8f7a$export$641a363dc7c73107 extends $bSJIT.Component {
    render() {
        if ((0, $lFpPv.isMigrateToAnalyticsBridgeEnabled)()) // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return /*#__PURE__*/ $bSJIT.createElement((0, $fhp9e.MountEvent), {
            onMount: this.onMount,
            key: `${this.props.screenName}-${this.props.screenId}`
        });
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.MountEvent), {
            onMount: this.onMount,
            key: `${this.props.screenName}-${this.props.screenId}`
        });
    }
    constructor(...args){
        super(...args), this.endBrowserMetricsV3 = (screenName)=>{
            const { customData: customData } = this.props;
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const metric = (0, $2HsNW.default)[screenName];
            /**
     * This is used to support the previously created performance mark
     */ (0, $db841.perfMark)('second.data.loaded');
            (0, $6JJ8C.devLog)('Browser Metrics v3: ending timer and firing event for screen:', screenName);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            metric.stop({
                customData: customData
            });
        }, this.onMount = (analyticsEvent)=>{
            const { screenName: screenName } = this.props;
            if ((0, $lFpPv.isMigrateToAnalyticsBridgeEnabled)()) (0, $k2MWg.fireScreenAnalytics)(analyticsEvent, (0, $gEVth.AnalyticsTrackActions).VIEWED);
            else (0, $haAAx.fireAnalyticsEvent)({
                analyticsEvent: analyticsEvent,
                type: (0, $haAAx.EventTypes).SCREEN
            });
            /**
     * Fire jsm-ui viewed event along with screen event
     * 1. This is done to for anti abuse spam work to detect human or bot spam
     * 2. We are firing this instead of `ui viewed` because that event is used for overall Atlassian MAU calculations.
     * 3. Event registration -> https://data-portal.internal.atlassian.com/analytics/registry/59264?tabIndex=Details
     */ const uiAnalyticsEvent = analyticsEvent.clone();
            if ((0, $lFpPv.isMigrateToAnalyticsBridgeEnabled)()) (0, $k2MWg.fireAnalytics)(uiAnalyticsEvent, (0, $clpci.UI_EVENT_TYPE), {
                actionSubject: 'jsm-ui',
                action: (0, $gEVth.AnalyticsTrackActions).VIEWED
            });
            else {
                // The componentName is used as actionSubject in the analytics event
                uiAnalyticsEvent.context.push({
                    componentName: 'jsm-ui'
                });
                (0, $haAAx.fireAnalyticsEvent)({
                    analyticsEvent: uiAnalyticsEvent,
                    type: (0, $haAAx.EventTypes).UI,
                    payload: {}
                });
            }
            /**
     * Trigger Stop timer for for Page load metric only if
     * 1. screenName exists
     * 2. metrics is instrumented for that screen
     * 3. BM3 feature flag is enabled
     */ if (screenName && (0, $2HsNW.isPageLoadInstrumented)(screenName)) this.endBrowserMetricsV3(screenName);
        };
    }
}

});
parcelRegister("fhp9e", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $c8e24a24d3b74b08$export$2c6963927dbc68f1);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");
class $c8e24a24d3b74b08$var$MountEventComponent extends (0, $bSJIT.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $c8e24a24d3b74b08$var$MountEventComponentWithHOC = (0, $kIbto.default)()($c8e24a24d3b74b08$var$MountEventComponent);
const $c8e24a24d3b74b08$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c8e24a24d3b74b08$var$MountEventComponentWithHOC, props);

});



parcelRegister("fmwkx", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4b89ebe5f42b081$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e4b89ebe5f42b081$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    virtualAgentBannerHeading: {
        defaultMessage: 'Spend less time hunting for the right request form',
        description: 'Heading in section message displayed when user is on the portal and virtual service agent search is turned on.',
        id: 'virtual-agent.virtual-agent-banner-heading'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    virtualServiceAgentEAPBannerDescription: {
        defaultMessage: 'Ask any question and give our AI-powered virtual service agent a try.',
        description: 'Desription in section message displayed when user is on the portal and virtual service agent search is turned on for EAP.',
        id: 'virtual-agent.virtual-service-agent-EAP-banner-description'
    },
    iconAlt: {
        defaultMessage: 'Atlassian Intelligence',
        description: 'Alternative text for Atlassian Intelligence logo.',
        id: 'virtual-agent.virtual-agent-banner-icon-alt'
    },
    buttonTextV2: {
        defaultMessage: 'Chat with virtual service agent',
        description: 'Text for button which will take the user to the virtual agent conversation page.',
        id: 'virtual-agent.virtual-agent-banner-button-text-v-2'
    }
});

});


parcelRegister("4dRLB", function(module, exports) {
$parcel$export(module.exports, "default", () => $de94d86140c41892$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("8Khoy");
var $17F5Q = parcelRequire("17F5Q");

var $bbFTS = parcelRequire("bbFTS");

var $e7xeN = parcelRequire("e7xeN");
const $de94d86140c41892$var$selector = (0, $BOq7h.createSelector)((state, props)=>(0, $bbFTS.getCategories)(state, props.portalId), (maybeCategories)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories
    };
});
const $de94d86140c41892$var$CategoryFilter = (0, $f2mlD.default)($de94d86140c41892$var$selector, {
    fetchCategories: (0, $17F5Q.fetchCategoriesAction)
})((0, $e7xeN.default));
var $de94d86140c41892$export$2e2bcd8739ae039 = $de94d86140c41892$var$CategoryFilter;

});
parcelRegister("e7xeN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed29ea638d4661ae$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("3iER5");
var $euoFh = parcelRequire("euoFh");

var $hMJTP = parcelRequire("hMJTP");
const $ed29ea638d4661ae$var$CategoryFilter = ({ portalId: portalId, fetchCategories: fetchCategories, categories: categories, categoryIds: categoryIds, onChange: onChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [values, _] = $bSJIT.useState(categoryIds ?? []);
    $bSJIT.useEffect(()=>{
        if (!projectId || !portalId) return;
        fetchCategories(projectId, portalId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectId,
        portalId
    ]);
    const options = $bSJIT.useMemo(()=>{
        return categories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories
    ]);
    const preSelectedOptions = $bSJIT.useMemo(()=>{
        const preselectedCategories = categories.filter((category)=>values.find((id)=>id === category.id));
        return preselectedCategories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories,
        values
    ]);
    return categories.length > 1 ? /*#__PURE__*/ $bSJIT.createElement((0, $euoFh.default), {
        fieldId: "category_filter",
        fieldLabel: formatMessage((0, $hMJTP.default).categoryFilter),
        testId: "categoryFilter",
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange
    }) : null;
};
var $ed29ea638d4661ae$export$2e2bcd8739ae039 = $ed29ea638d4661ae$var$CategoryFilter;

});
parcelRegister("3iER5", function(module, exports) {
$parcel$export(module.exports, "SimplePicker", () => (parcelRequire("euoFh")).default);

var $euoFh = parcelRequire("euoFh");

});
parcelRegister("euoFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $420e066531c382b5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gBehe = parcelRequire("gBehe");

var $4ZMmh = parcelRequire("4ZMmh");

var $dwOcU = parcelRequire("dwOcU");
const $420e066531c382b5$export$a250605dcad5aca0 = (str, toMatch)=>{
    if (!str) return false;
    return toMatch ? str.toLowerCase().includes(toMatch.toLowerCase()) : true;
};
const $420e066531c382b5$export$60d56ed3961c839c = (0, $4ZMmh.memoize)((options, searchText)=>{
    if ((0, $4ZMmh.isEmpty)(searchText)) return options;
    const filteredOptions = [];
    for (const option of options)if ($420e066531c382b5$export$a250605dcad5aca0(option.label, searchText)) filteredOptions.push(option);
    return filteredOptions;
}, (...args)=>JSON.stringify(args));
const $420e066531c382b5$var$Picker = ({ options: options, preSelectedOptions: preSelectedOptions, onChange: onChange, fieldId: fieldId, testId: testId, fieldLabel: fieldLabel })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [selectedValues, setSelectedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(preSelectedOptions ?? []);
    const onPickerTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        setIsOpen(true);
    }, []);
    const onClose = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        setIsOpen(false);
    }, []);
    const onFilterChange = (0, $bSJIT.useCallback)((selectedOptions)=>{
        onChange(selectedOptions);
        setSelectedValues(selectedOptions);
    }, [
        onChange
    ]);
    const onFilterClearValues = (0, $bSJIT.useCallback)(()=>{
        onChange([]);
        setSelectedValues([]);
    }, [
        onChange
    ]);
    const onLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((search, _enableFullList, _showFullList, _showMore, _lastOption, cb)=>{
        const filteredOptions = $420e066531c382b5$export$60d56ed3961c839c(options, search);
        cb({
            options: filteredOptions,
            totalCount: filteredOptions.length
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: fieldId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gBehe.default), {
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        isOpen: isOpen,
        value: selectedValues,
        enablePagination: false,
        onOpen: onOpen,
        onClose: onClose,
        onChange: onFilterChange,
        onLoadOptions: onLoadOptions,
        onClearValues: onFilterClearValues,
        onPickerTriggerClick: onPickerTriggerClick,
        testId: testId
    }));
};
var $420e066531c382b5$export$2e2bcd8739ae039 = $420e066531c382b5$var$Picker;

});
parcelRegister("gBehe", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b457f950de09d35$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $1ko9n = parcelRequire("1ko9n");

var $hbTte = parcelRequire("hbTte");

var $dqwac = parcelRequire("dqwac");
const $3b457f950de09d35$var$PaginatedFilter = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, value: value, fieldId: fieldId, fieldLabel: fieldLabel, onChange: onChange, onLoadOptions: onLoadOptions, onClearValues: onClearValues, onPickerTriggerClick: onPickerTriggerClick, testId: testId, enablePagination: enablePagination = true } = props;
    const paginationConfig = enablePagination ? {
        enableFullList: false
    } : undefined;
    const onTrigger = $bSJIT.useCallback(({ ref: ref })=>{
        return /*#__PURE__*/ $bSJIT.createElement((0, $dqwac.default), {
            hasValues: value.length > 0,
            onClick: onPickerTriggerClick,
            isSelected: isOpen,
            isInvalid: value.some((val)=>val.invalid),
            ref: ref,
            testId: testId
        }, (0, $hbTte.formatLabel)(fieldLabel, value));
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        value,
        onOpen,
        isOpen,
        fieldLabel,
        onPickerTriggerClick
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($3b457f950de09d35$var$PaginatedFilterWrapper, null, /*#__PURE__*/ $bSJIT.createElement((0, $1ko9n.Picker), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: value,
        pagination: paginationConfig,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onChange: onChange,
        onLoadOptions: onLoadOptions,
        onTrigger: onTrigger,
        onClearValues: onClearValues
    }));
};
var $3b457f950de09d35$export$2e2bcd8739ae039 = $3b457f950de09d35$var$PaginatedFilter;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3b457f950de09d35$var$PaginatedFilterWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-6q3nln-0"
})`display:flex;`;

});
parcelRegister("1ko9n", function(module, exports) {
$parcel$export(module.exports, "Picker", () => $32762d8b3217a107$export$ba25329847403e11);

var $bSJIT = parcelRequire("bSJIT");

var $26Jy2 = parcelRequire("26Jy2");

var $61e2R = parcelRequire("61e2R");

var $2vnNP = parcelRequire("2vnNP");

var $cUBpA = parcelRequire("cUBpA");

var $6Qq5t = parcelRequire("6Qq5t");
const $32762d8b3217a107$export$ba25329847403e11 = ({ ariaLabel: ariaLabel, isOpen: isOpen, value: value, onClose: onClose, onClearValues: onClearValues, fieldId: fieldId, fieldLabel: fieldLabel, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $cUBpA.default), onLoadOptions: onLoadOptions, pagination: pagination, PopupComponent: PopupComponent, onTrigger: onTrigger, hideClearSelection: hideClearSelection, initiallyAddSelectedFirst: initiallyAddSelectedFirst = true, isMulti: isMulti = true, showFooter: showFooter = true, popupProps: popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $61e2R.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6Qq5t.DialogInner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2vnNP.default), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                hideClearSelection: hideClearSelection,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                isMulti: isMulti,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            })),
        ...popupProps
    }));

});
parcelRegister("61e2R", function(module, exports) {
$parcel$export(module.exports, "PaginatedPickerIntlProvider", () => $86be426c9efbfaf5$export$b61655080b0a1f32);

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");
var $4vLTk = parcelRequire("4vLTk");

var $1derZ = parcelRequire("1derZ");
const $86be426c9efbfaf5$var$i18n = $1derZ;
const $86be426c9efbfaf5$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
const $86be426c9efbfaf5$export$b61655080b0a1f32 = ({ children: children })=>{
    const intl = (0, $4vLTk.default)();
    const { language: language, country: country } = $86be426c9efbfaf5$var$getCodesFromLocale(intl.locale.toString());
    const messages = $86be426c9efbfaf5$var$i18n[`${language}_${country}`] || $86be426c9efbfaf5$var$i18n[language] || $86be426c9efbfaf5$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};

});
parcelRegister("1derZ", function(module, exports) {
$parcel$export(module.exports, "cs", () => (parcelRequire("5aoB0")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("6QlTv")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("9iott")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("aqtF2")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("8vF0O")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("7oQ1j")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("cioFU")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("9sLdg")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("FDzRk")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("1AiBM")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("1L3Zw")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("fc3b3")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("LbPnY")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("erMP6")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("dKgYb")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("aH1zp")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("9KpM2")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("6gvy4")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("aEtm2")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("isfI1")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("etk2f")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("gh8R6")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("3iOOk")).default);
$parcel$export(module.exports, "zh", () => (parcelRequire("bUoFz")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("gVoSJ")).default);

var $5aoB0 = parcelRequire("5aoB0");

var $6QlTv = parcelRequire("6QlTv");

var $9iott = parcelRequire("9iott");

var $aqtF2 = parcelRequire("aqtF2");

var $8vF0O = parcelRequire("8vF0O");

var $7oQ1j = parcelRequire("7oQ1j");

var $cioFU = parcelRequire("cioFU");

var $9sLdg = parcelRequire("9sLdg");

var $FDzRk = parcelRequire("FDzRk");

var $1AiBM = parcelRequire("1AiBM");

var $1L3Zw = parcelRequire("1L3Zw");

var $fc3b3 = parcelRequire("fc3b3");

var $LbPnY = parcelRequire("LbPnY");

var $erMP6 = parcelRequire("erMP6");

var $dKgYb = parcelRequire("dKgYb");

var $aH1zp = parcelRequire("aH1zp");

var $9KpM2 = parcelRequire("9KpM2");

var $6gvy4 = parcelRequire("6gvy4");

var $aEtm2 = parcelRequire("aEtm2");

var $isfI1 = parcelRequire("isfI1");

var $etk2f = parcelRequire("etk2f");

var $gh8R6 = parcelRequire("gh8R6");

var $3iOOk = parcelRequire("3iOOk");

var $bUoFz = parcelRequire("bUoFz");

var $gVoSJ = parcelRequire("gVoSJ");

});
parcelRegister("5aoB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b9ead41db682c58$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dQcK7 = parcelRequire("dQcK7");
var $2b9ead41db682c58$export$2e2bcd8739ae039 = (0, $dQcK7.default);

});
parcelRegister("dQcK7", function(module, exports) {
$parcel$export(module.exports, "default", () => $7638cd94da7dc6c7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Czech
var $7638cd94da7dc6c7$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Zru\u0161it v\xfdb\u011Br",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Na\u010Dten\xed dat se nezda\u0159ilo.",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Kliknut\xedm opakovat",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Na\u010D\xedt\xe1n\xed\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Zobrazit v\xedce",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} v\xfdsledk\u016F",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} z\xa0{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    "paginated-picker.async-select.select.option.error-message": "Na\u010Dten\xed dat se nezda\u0159ilo.",
    "paginated-picker.async-select.select.option.retry-message": "Kliknut\xedm opakovat",
    "paginated-picker.async-select.select.search-placeholder": "Vyhledat",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Zobrazit \xfapln\xfd seznam"
};

});


parcelRegister("6QlTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $0852d90fef295764$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $e2rgx = parcelRequire("e2rgx");
var $0852d90fef295764$export$2e2bcd8739ae039 = (0, $e2rgx.default);

});
parcelRegister("e2rgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $57ba0e267b7a9ea5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Danish (Denmark)
var $57ba0e267b7a9ea5$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Ryd valgte",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Data kunne ikke hentes",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klik for at pr\xf8ve igen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Indl\xe6ser ...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Vis mere",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultater",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} af {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Ingen match fundet",
    "paginated-picker.async-select.select.option.error-message": "Data kunne ikke hentes",
    "paginated-picker.async-select.select.option.retry-message": "Klik for at pr\xf8ve igen",
    "paginated-picker.async-select.select.search-placeholder": "S\xf8g",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Vis hele listen"
};

});


parcelRegister("9iott", function(module, exports) {
$parcel$export(module.exports, "default", () => $05cb6d3061de3a98$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $g01VB = parcelRequire("g01VB");
var $05cb6d3061de3a98$export$2e2bcd8739ae039 = (0, $g01VB.default);

});
parcelRegister("g01VB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e7e4f752194466c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //German (Germany)
var $7e7e4f752194466c$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Auswahl l\xf6schen",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Daten konnten nicht abgerufen werden.",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klicken, um es erneut zu versuchen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "L\xe4dt\xa0...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Mehr anzeigen",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount}\xa0Ergebnisse",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} von {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Keine Treffer gefunden",
    "paginated-picker.async-select.select.option.error-message": "Daten konnten nicht abgerufen werden.",
    "paginated-picker.async-select.select.option.retry-message": "Klicken, um es erneut zu versuchen",
    "paginated-picker.async-select.select.search-placeholder": "Suchen",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Vollst\xe4ndige Liste anzeigen"
};

});


parcelRegister("aqtF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4b99660bd3e65c6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $Ynk00 = parcelRequire("Ynk00");
var $f4b99660bd3e65c6$export$2e2bcd8739ae039 = (0, $Ynk00.default);

});
parcelRegister("Ynk00", function(module, exports) {
$parcel$export(module.exports, "default", () => $546e83d4e5bf5d12$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $546e83d4e5bf5d12$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Clear selection",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Click to retry",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Loading...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Show more",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} results",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} of {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "No matches found",
    "paginated-picker.async-select.select.option.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.select.option.retry-message": "Click to retry",
    "paginated-picker.async-select.select.search-placeholder": "Search",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Show full list"
};

});


parcelRegister("8vF0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $b204be5a2d188243$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $axXnu = parcelRequire("axXnu");
var $b204be5a2d188243$export$2e2bcd8739ae039 = (0, $axXnu.default);

});
parcelRegister("axXnu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9a3dd5bfae35c59$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //English (United Kingdom)
var $f9a3dd5bfae35c59$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Clear selection",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Click to retry",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Loading...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Show more",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} results",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} of {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "No matches found",
    "paginated-picker.async-select.select.option.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.select.option.retry-message": "Click to retry",
    "paginated-picker.async-select.select.search-placeholder": "Search",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Show full list"
};

});


parcelRegister("7oQ1j", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fe9e9fa509fc1a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $boSN1 = parcelRequire("boSN1");
var $9fe9e9fa509fc1a0$export$2e2bcd8739ae039 = (0, $boSN1.default);

});
parcelRegister("boSN1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9123008c8283998d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $9123008c8283998d$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u2063\u2062{itemsCount} results\u2060\u2060\u061C\u206E\u206C\u206B\u200D\u061C\x90\u061C\u206B\u206E\u206F\u061C\x8d\u206B\u206C\x90\u061C\u061C\u200D\x8d\x8d\u206A\x9d\u2061\u2061\u2060\u061C\x9d\u206D\x8f\u2063\u2064",
    "paginated-picker.async-select.pagination-details.of-total-count": "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    "paginated-picker.async-select.select.option.error-message": "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    "paginated-picker.async-select.select.option.retry-message": "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    "paginated-picker.async-select.select.search-placeholder": "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};

});


parcelRegister("cioFU", function(module, exports) {
$parcel$export(module.exports, "default", () => $70110c4210350a1f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $46Haz = parcelRequire("46Haz");
var $70110c4210350a1f$export$2e2bcd8739ae039 = (0, $46Haz.default);

});
parcelRegister("46Haz", function(module, exports) {
$parcel$export(module.exports, "default", () => $da588490aef9a1d2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Spanish (International)
var $da588490aef9a1d2$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Borrar selecci\xf3n",
    "paginated-picker.async-select.menu-list.error-message.error-message": "No se han podido recuperar los datos",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Haz clic para intentarlo de nuevo",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Cargando\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Mostrar m\xe1s",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultados",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} de {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "No se han encontrado coincidencias",
    "paginated-picker.async-select.select.option.error-message": "No se han podido recuperar los datos",
    "paginated-picker.async-select.select.option.retry-message": "Haz clic para intentarlo de nuevo",
    "paginated-picker.async-select.select.search-placeholder": "Buscar",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Mostrar lista completa"
};

});


parcelRegister("9sLdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $df13e5430f3f8984$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $18VHc = parcelRequire("18VHc");
var $df13e5430f3f8984$export$2e2bcd8739ae039 = (0, $18VHc.default);

});
parcelRegister("18VHc", function(module, exports) {
$parcel$export(module.exports, "default", () => $23ebdb7b82f22e04$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Finnish
var $23ebdb7b82f22e04$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Tyhjenn\xe4 valinta",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Tietoja ei voitu noutaa",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Yrit\xe4 uudelleen napsauttamalla",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Ladataan...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "N\xe4yt\xe4 lis\xe4\xe4",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} tulosta",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Ei hakutuloksia",
    "paginated-picker.async-select.select.option.error-message": "Tietoja ei voitu noutaa",
    "paginated-picker.async-select.select.option.retry-message": "Yrit\xe4 uudelleen napsauttamalla",
    "paginated-picker.async-select.select.search-placeholder": "Hae",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "N\xe4yt\xe4 koko luettelo"
};

});


parcelRegister("FDzRk", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd8de921d68a3040$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $leuru = parcelRequire("leuru");
var $cd8de921d68a3040$export$2e2bcd8739ae039 = (0, $leuru.default);

});
parcelRegister("leuru", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dcb1dccc1372474$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //French (France)
var $9dcb1dccc1372474$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Effacer la s\xe9lection",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Cliquez pour r\xe9essayer",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Chargement en cours\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Afficher plus",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount}\xa0r\xe9sultats",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} sur {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "R\xe9sultats introuvables",
    "paginated-picker.async-select.select.option.error-message": "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    "paginated-picker.async-select.select.option.retry-message": "Cliquez pour r\xe9essayer",
    "paginated-picker.async-select.select.search-placeholder": "Rechercher",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Afficher toute la liste"
};

});


parcelRegister("1AiBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c272a95d18a6a4f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lnwrp = parcelRequire("lnwrp");
var $8c272a95d18a6a4f$export$2e2bcd8739ae039 = (0, $lnwrp.default);

});
parcelRegister("lnwrp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0dc901adb65126b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Hungarian
var $e0dc901adb65126b$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Nem siker\xfclt lek\xe9rni az adatokat",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Bet\xf6lt\xe9s\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "T\xf6bb",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} tal\xe1lat",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nincs egyez\xe9s",
    "paginated-picker.async-select.select.option.error-message": "Nem siker\xfclt lek\xe9rni az adatokat",
    "paginated-picker.async-select.select.option.retry-message": "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    "paginated-picker.async-select.select.search-placeholder": "Keres\xe9s",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Teljes lista megjelen\xedt\xe9se"
};

});


parcelRegister("1L3Zw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebacd5c838fa1ec4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $57jbt = parcelRequire("57jbt");
var $ebacd5c838fa1ec4$export$2e2bcd8739ae039 = (0, $57jbt.default);

});
parcelRegister("57jbt", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2605303e494c724$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Italian (Italy)
var $c2605303e494c724$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Cancella selezione",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Impossibile recuperare i dati",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Clicca per riprovare",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Caricamento in corso...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Mostra altro",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} risultati",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} di {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nessuna corrispondenza trovata",
    "paginated-picker.async-select.select.option.error-message": "Impossibile recuperare i dati",
    "paginated-picker.async-select.select.option.retry-message": "Clicca per riprovare",
    "paginated-picker.async-select.select.search-placeholder": "Ricerca",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Mostra l'elenco completo"
};

});


parcelRegister("fc3b3", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdfe64e211ace07c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8Vbpd = parcelRequire("8Vbpd");
var $bdfe64e211ace07c$export$2e2bcd8739ae039 = (0, $8Vbpd.default);

});
parcelRegister("8Vbpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d862cde24b572674$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Japanese
var $d862cde24b572674$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u9078\u629E\u3092\u89E3\u9664",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u8868\u793A\u3092\u5897\u3084\u3059",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} \u4EF6\u306E\u7D50\u679C",
    "paginated-picker.async-select.pagination-details.of-total-count": "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    "paginated-picker.async-select.select.option.error-message": "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    "paginated-picker.async-select.select.option.retry-message": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    "paginated-picker.async-select.select.search-placeholder": "\u691C\u7D22",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};

});


parcelRegister("LbPnY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebb3fa5952d270fa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $88PCl = parcelRequire("88PCl");
var $ebb3fa5952d270fa$export$2e2bcd8739ae039 = (0, $88PCl.default);

});
parcelRegister("88PCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d285a66f03c792c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Korean
var $3d285a66f03c792c$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\uB85C\uB4DC \uC911...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\uB354 \uBCF4\uAE30",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount}\uAC1C \uACB0\uACFC",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    "paginated-picker.async-select.select.option.error-message": "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    "paginated-picker.async-select.select.option.retry-message": "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    "paginated-picker.async-select.select.search-placeholder": "\uAC80\uC0C9",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};

});


parcelRegister("erMP6", function(module, exports) {
$parcel$export(module.exports, "default", () => $97e2efdb434adc11$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3VVmK = parcelRequire("3VVmK");
var $97e2efdb434adc11$export$2e2bcd8739ae039 = (0, $3VVmK.default);

});
parcelRegister("3VVmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $afd3bab7dd911c6c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Norwegian (Bokmål)
var $afd3bab7dd911c6c$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Fjern valg",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Kan ikke hente data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klikk for \xe5 pr\xf8ve igjen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Laster\xa0\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Vis mer",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultater",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} av {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Finner ingen treff",
    "paginated-picker.async-select.select.option.error-message": "Kan ikke hente data",
    "paginated-picker.async-select.select.option.retry-message": "Klikk for \xe5 pr\xf8ve igjen",
    "paginated-picker.async-select.select.search-placeholder": "S\xf8k",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Vis fullstendig liste"
};

});


parcelRegister("dKgYb", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaed4649407c29e6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aPwAh = parcelRequire("aPwAh");
var $eaed4649407c29e6$export$2e2bcd8739ae039 = (0, $aPwAh.default);

});
parcelRegister("aPwAh", function(module, exports) {
$parcel$export(module.exports, "default", () => $f862c2801437fbdb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Dutch (Netherlands)
var $f862c2801437fbdb$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Selectie wissen",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Gegevens konden niet worden opgehaald",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klik om het opnieuw te proberen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Laden...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Meer tonen",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultaten",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} van {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Geen overeenkomsten gevonden",
    "paginated-picker.async-select.select.option.error-message": "Gegevens konden niet worden opgehaald",
    "paginated-picker.async-select.select.option.retry-message": "Klik om het opnieuw te proberen",
    "paginated-picker.async-select.select.search-placeholder": "Zoeken",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Volledige lijst weergeven"
};

});


parcelRegister("aH1zp", function(module, exports) {
$parcel$export(module.exports, "default", () => $15f2c183963ffb21$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1GRkR = parcelRequire("1GRkR");
var $15f2c183963ffb21$export$2e2bcd8739ae039 = (0, $1GRkR.default);

});
parcelRegister("1GRkR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8822eb1cf7d7a28$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Polish (Poland)
var $f8822eb1cf7d7a28$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Wyczy\u015B\u0107 wyb\xf3r",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Nie mo\u017Cna pobra\u0107 danych",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0141adowanie...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Poka\u017C wi\u0119cej",
    "paginated-picker.async-select.pagination-details.loadedCount": "Wyniki {itemsCount}",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} z {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nie znaleziono dopasowa\u0144",
    "paginated-picker.async-select.select.option.error-message": "Nie mo\u017Cna pobra\u0107 danych",
    "paginated-picker.async-select.select.option.retry-message": "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    "paginated-picker.async-select.select.search-placeholder": "Szukaj",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Poka\u017C pe\u0142n\u0105 list\u0119"
};

});


parcelRegister("9KpM2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fb4889c7d6c1ab8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1Lcfk = parcelRequire("1Lcfk");
var $2fb4889c7d6c1ab8$export$2e2bcd8739ae039 = (0, $1Lcfk.default);

});
parcelRegister("1Lcfk", function(module, exports) {
$parcel$export(module.exports, "default", () => $726a2ab769be2afe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Portuguese (Brazil)
var $726a2ab769be2afe$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Limpar sele\xe7\xe3o",
    "paginated-picker.async-select.menu-list.error-message.error-message": "N\xe3o foi poss\xedvel recuperar os dados",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Clique para tentar de novo",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Carregando...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Ver mais",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultados",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} de {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nenhuma correspond\xeancia encontrada",
    "paginated-picker.async-select.select.option.error-message": "N\xe3o foi poss\xedvel recuperar os dados",
    "paginated-picker.async-select.select.option.retry-message": "Clique para tentar de novo",
    "paginated-picker.async-select.select.search-placeholder": "Pesquisar",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Mostrar lista completa"
};

});


parcelRegister("6gvy4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1936cd111341b92$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6FHUK = parcelRequire("6FHUK");
var $b1936cd111341b92$export$2e2bcd8739ae039 = (0, $6FHUK.default);

});
parcelRegister("6FHUK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dc50aac09ba19b9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Russian
var $2dc50aac09ba19b9$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432: {itemsCount}",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} \u0438\u0437 {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    "paginated-picker.async-select.select.option.error-message": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    "paginated-picker.async-select.select.option.retry-message": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    "paginated-picker.async-select.select.search-placeholder": "\u041F\u043E\u0438\u0441\u043A",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("aEtm2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca833dca30eb14b4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7X9BR = parcelRequire("7X9BR");
var $ca833dca30eb14b4$export$2e2bcd8739ae039 = (0, $7X9BR.default);

});
parcelRegister("7X9BR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6222c8331880fef0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Swedish
var $6222c8331880fef0$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Rensa urval",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Det gick inte att h\xe4mta data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "L\xe4ser in ...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Visa mer",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultat",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} av {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Inga tr\xe4ffar hittades",
    "paginated-picker.async-select.select.option.error-message": "Det gick inte att h\xe4mta data",
    "paginated-picker.async-select.select.option.retry-message": "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    "paginated-picker.async-select.select.search-placeholder": "S\xf6k",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Visa fullst\xe4ndig lista"
};

});


parcelRegister("isfI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $c26fb1cf12aeab05$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6G2dF = parcelRequire("6G2dF");
var $c26fb1cf12aeab05$export$2e2bcd8739ae039 = (0, $6G2dF.default);

});
parcelRegister("6G2dF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d98dbd51d5aa081$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Thai (Thailand)
var $8d98dbd51d5aa081$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C {itemsCount} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    "paginated-picker.async-select.select.option.error-message": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    "paginated-picker.async-select.select.option.retry-message": "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    "paginated-picker.async-select.select.search-placeholder": "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};

});


parcelRegister("etk2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $973cbd888733f13a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $kgdZj = parcelRequire("kgdZj");
var $973cbd888733f13a$export$2e2bcd8739ae039 = (0, $kgdZj.default);

});
parcelRegister("kgdZj", function(module, exports) {
$parcel$export(module.exports, "default", () => $184d575d1b9697d6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Turkish (Turkey)
var $184d575d1b9697d6$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Se\xe7imi temizle",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Veriler al\u0131namad\u0131",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Y\xfckleniyor...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Daha fazla g\xf6ster",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} sonu\xe7",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "E\u015Fle\u015Fme bulunamad\u0131",
    "paginated-picker.async-select.select.option.error-message": "Veriler al\u0131namad\u0131",
    "paginated-picker.async-select.select.option.retry-message": "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    "paginated-picker.async-select.select.search-placeholder": "Ara",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Tam listeyi g\xf6ster"
};

});


parcelRegister("gh8R6", function(module, exports) {
$parcel$export(module.exports, "default", () => $74072b7a063e4cc8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $2wTyF = parcelRequire("2wTyF");
var $74072b7a063e4cc8$export$2e2bcd8739ae039 = (0, $2wTyF.default);

});
parcelRegister("2wTyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f0c8de48003be4d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Ukrainian (Ukraine)
var $0f0c8de48003be4d$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432: {itemsCount}",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} \u0437 {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    "paginated-picker.async-select.select.option.error-message": "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    "paginated-picker.async-select.select.option.retry-message": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    "paginated-picker.async-select.select.search-placeholder": "\u041F\u043E\u0448\u0443\u043A",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("3iOOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $fafe47060cc0fd8f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $l00yz = parcelRequire("l00yz");
var $fafe47060cc0fd8f$export$2e2bcd8739ae039 = (0, $l00yz.default);

});
parcelRegister("l00yz", function(module, exports) {
$parcel$export(module.exports, "default", () => $661c6943fe800202$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Vietnamese (Vietnam)
var $661c6943fe800202$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0110ang t\u1EA3i...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Hi\u1EC3n th\u1ECB th\xeam",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} k\u1EBFt qu\u1EA3",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    "paginated-picker.async-select.select.option.error-message": "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    "paginated-picker.async-select.select.option.retry-message": "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    "paginated-picker.async-select.select.search-placeholder": "T\xecm ki\u1EBFm",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};

});


parcelRegister("bUoFz", function(module, exports) {
$parcel$export(module.exports, "default", () => $52bb010d48b8aaf0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $buKsK = parcelRequire("buKsK");
var $52bb010d48b8aaf0$export$2e2bcd8739ae039 = (0, $buKsK.default);

});
parcelRegister("buKsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $9046485416aced2a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Chinese (Simplified)
var $9046485416aced2a$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u6E05\u7A7A\u9009\u62E9",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u70B9\u51FB\u91CD\u8BD5",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u6B63\u5728\u52A0\u8F7D...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u663E\u793A\u66F4\u591A",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} \u4E2A\u7ED3\u679C",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u672A\u627E\u5230\u5339\u914D\u9879",
    "paginated-picker.async-select.select.option.error-message": "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    "paginated-picker.async-select.select.option.retry-message": "\u70B9\u51FB\u91CD\u8BD5",
    "paginated-picker.async-select.select.search-placeholder": "\u641C\u7D22",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};

});


parcelRegister("gVoSJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ae00d02ed4d6ad0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aLahz = parcelRequire("aLahz");
var $5ae00d02ed4d6ad0$export$2e2bcd8739ae039 = (0, $aLahz.default);

});
parcelRegister("aLahz", function(module, exports) {
$parcel$export(module.exports, "default", () => $96a241a3e5ce6083$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Chinese (Traditional)
var $96a241a3e5ce6083$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u6B63\u5728\u8F09\u5165...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u986F\u793A\u8F03\u591A",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} \u500B\u7D50\u679C",
    "paginated-picker.async-select.pagination-details.of-total-count": "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    "paginated-picker.async-select.select.option.error-message": "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    "paginated-picker.async-select.select.option.retry-message": "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    "paginated-picker.async-select.select.search-placeholder": "\u641C\u5C0B",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};

});




parcelRegister("2vnNP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9305d232b1949b7a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $Is9R7 = parcelRequire("Is9R7");

var $aaieM = parcelRequire("aaieM");

var $52QJF = parcelRequire("52QJF");

var $lrYfi = parcelRequire("lrYfi");

var $haYvF = parcelRequire("haYvF");

var $8Il01 = parcelRequire("8Il01");

var $l0ssr = parcelRequire("l0ssr");

var $j9n0W = parcelRequire("j9n0W");

var $lxaSk = parcelRequire("lxaSk");
const $9305d232b1949b7a$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $9305d232b1949b7a$var$paginatedComponents = {
    ...(0, $l0ssr.selectComponents),
    MenuList: $haYvF.MenuList
};
const $9305d232b1949b7a$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ selectOptions: selectOptions, ...props }, ref)=>{
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l0ssr.LocalBaseSelect), {
        ...props,
        options: selectOptions,
        ref: ref
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l0ssr.LocalBaseSelect), {
        ...props,
        ref: ref
    });
});
$9305d232b1949b7a$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
const $9305d232b1949b7a$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    const baseSelectProps = (0, $52QJF.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($9305d232b1949b7a$var$ProxyBaseSelect, {
        ...props,
        ...baseSelectProps,
        ref: ref
    });
});
$9305d232b1949b7a$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ const $9305d232b1949b7a$var$addUniqueOptions = (keys, options, option)=>{
    if (option.optionType === 'group') {
        const groupOptions = [];
        option.options.forEach((groupOption)=>{
            $9305d232b1949b7a$var$addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push({
            ...option,
            options: groupOptions
        });
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
const $9305d232b1949b7a$var$generateOptions = (selectedValues, newOptions, addSelectedFirst, previousOptions)=>{
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) selectedValues.forEach((option)=>{
        $9305d232b1949b7a$var$addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach((option)=>{
        $9305d232b1949b7a$var$addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach((option)=>{
        $9305d232b1949b7a$var$addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
const $9305d232b1949b7a$var$getLastCursorOption = (options)=>(0, (/*@__PURE__*/$parcel$interopDefault($aaieM)))(options, (option)=>'cursor' in option && !!option.cursor);
// Needed to disable filtering from react-select
const $9305d232b1949b7a$var$noFilterOptions = ()=>true;
const $9305d232b1949b7a$var$noLoadOptions = ()=>Promise.resolve();
const $9305d232b1949b7a$export$54319cf8344f1691 = (options)=>options.map((option)=>option.optionType === 'group' ? option.options.length : 1).reduce((sumSoFar, count)=>sumSoFar + count, 0);
const $9305d232b1949b7a$export$fccf54b4cac6e0b3 = ({ ariaLabel: ariaLabel, field: field, isMulti: isMulti = true, value: value, onChange: onChange, onClear: onClear, hideClearSelection: hideClearSelection = false, initiallyAddSelectedFirst: initiallyAddSelectedFirst, showFooter: showFooter, ...restProps })=>{
    var _field$pagination;
    const selectRef = (0, $bSJIT.useRef)(null);
    const [page, setPage] = (0, $bSJIT.useState)(0);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $bSJIT.useState)(false);
    const [inputValue, setInputValue] = (0, $bSJIT.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $bSJIT.useState)([]);
    const [enableFullList, setEnableFullList] = (0, $bSJIT.useState)(((_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) ?? false);
    const [totalCount, setTotalCount] = (0, $bSJIT.useState)(null);
    const [hasMore, setHasMore] = (0, $bSJIT.useState)();
    const [error, setError] = (0, $bSJIT.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const getTotalCountWithFunctions = (0, $bSJIT.useCallback)((newTotalCount)=>{
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        const { pagination: { keywordValues: keywordValues } } = field;
        const newTotalCountWithKeywords = newTotalCount + value.filter((option)=>keywordValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $9305d232b1949b7a$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $9305d232b1949b7a$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    const checkIfError = (0, $bSJIT.useCallback)((_search, options, onRetry)=>{
        if (options.some((option)=>option.optionType === 'error')) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $bSJIT.useCallback)((search)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, ({ options: options, totalCount: newTotalCount, hasMore: newHasMore })=>{
            if (checkIfError(search, options, ()=>handleLoadOptions(search))) return;
            setLoadedOptions($9305d232b1949b7a$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setHasMore(newHasMore);
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $bSJIT.useCallback)((showFullList = false, isRetry = false)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        let originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $9305d232b1949b7a$var$getLastCursorOption(loadedOptions), ({ options: options, totalCount: newTotalCount, hasMore: newHasMore })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($9305d232b1949b7a$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setHasMore(newHasMore);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    const handleShowFullList = (0, $bSJIT.useCallback)(()=>{
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $bSJIT.useCallback)((newInputValue)=>{
        const { onInputChange: onInputChange } = field;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    const handleOnChange = (0, $bSJIT.useCallback)((options, action)=>{
        let selectData;
        if ('option' in action) {
            const actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($Is9R7)))(loadedOptions, (option)=>'value' in option && option.value === actionOption.value)
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleClear = (0, $bSJIT.useCallback)(()=>{
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(()=>{
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $bSJIT.useEffect)(()=>{
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsCount = $9305d232b1949b7a$export$54319cf8344f1691(loadedOptions);
    const showClearSelection = !hideClearSelection && !!value.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($9305d232b1949b7a$var$AsyncSelect, {
        ref: selectRef,
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $9305d232b1949b7a$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $9305d232b1949b7a$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        isMulti: isMulti,
        selectOptions: loadedOptions,
        onFilterOption: $9305d232b1949b7a$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: hasMore !== undefined ? hasMore : totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value,
        ...restProps
    }), (showFooter || showClearSelection) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lxaSk.Footer), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j9n0W.ShowFullListButton), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), showClearSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lrYfi.ClearSelectedItemsButton), {
        onClear: handleClear,
        type: field.key
    }), showFooter && !enableFullList && (totalCount !== null || hasMore !== undefined) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Il01.PaginationDetails), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $9305d232b1949b7a$export$2e2bcd8739ae039 = $9305d232b1949b7a$export$fccf54b4cac6e0b3;

});
parcelRegister("Is9R7", function(module, exports) {

var $czhsm = parcelRequire("czhsm");

var $3iACh = parcelRequire("3iACh");

var $mx0kf = parcelRequire("mx0kf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0859f3c2b3e4bf0a$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $0859f3c2b3e4bf0a$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $mx0kf(fromIndex);
    if (index < 0) index = $0859f3c2b3e4bf0a$var$nativeMax(length + index, 0);
    return $czhsm(array, $3iACh(predicate, 3), index);
}
module.exports = $0859f3c2b3e4bf0a$var$findIndex;

});

parcelRegister("aaieM", function(module, exports) {

var $iHmap = parcelRequire("iHmap");

var $82MQD = parcelRequire("82MQD");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $7668fc1e55fc0a8e$var$findLast = $iHmap($82MQD);
module.exports = $7668fc1e55fc0a8e$var$findLast;

});
parcelRegister("iHmap", function(module, exports) {

var $3iACh = parcelRequire("3iACh");

var $d5SgW = parcelRequire("d5SgW");

var $7yuIC = parcelRequire("7yuIC");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $d9cd70045855e079$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$d5SgW(collection)) {
            var iteratee = $3iACh(predicate, 3);
            collection = $7yuIC(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $d9cd70045855e079$var$createFind;

});

parcelRegister("82MQD", function(module, exports) {

var $czhsm = parcelRequire("czhsm");

var $3iACh = parcelRequire("3iACh");

var $mx0kf = parcelRequire("mx0kf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5db466d72f567f04$var$nativeMax = Math.max, $5db466d72f567f04$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $5db466d72f567f04$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $mx0kf(fromIndex);
        index = fromIndex < 0 ? $5db466d72f567f04$var$nativeMax(length + index, 0) : $5db466d72f567f04$var$nativeMin(index, length - 1);
    }
    return $czhsm(array, $3iACh(predicate, 3), index, true);
}
module.exports = $5db466d72f567f04$var$findLastIndex;

});


parcelRegister("52QJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3be1a35b730a033$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $e3be1a35b730a033$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $e3be1a35b730a033$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $bSJIT.useRef)(undefined);
    const mounted = (0, $bSJIT.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $bSJIT.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $bSJIT.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $bSJIT.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $bSJIT.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $bSJIT.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $bSJIT.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $bSJIT.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $bSJIT.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $bSJIT.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $bSJIT.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $bSJIT.useCallback)((newValue, actionMeta)=>{
        const inputValue = $e3be1a35b730a033$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("lrYfi", function(module, exports) {
$parcel$export(module.exports, "ClearSelectedItemsButton", () => $7d5057b402792901$export$1d4b7cda9e589b53);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hzFIQ = parcelRequire("hzFIQ");

var $jp6pR = parcelRequire("jp6pR");
const $7d5057b402792901$export$1d4b7cda9e589b53 = ({ onClear: onClear /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClearSelectedItems = (0, $bSJIT.useCallback)(()=>{
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $jp6pR.default).clearAllSelectedItemsButtonText));
};
var $7d5057b402792901$export$2e2bcd8739ae039 = $7d5057b402792901$export$1d4b7cda9e589b53;

});
parcelRegister("jp6pR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3f3ddb72d828bba$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c3f3ddb72d828bba$var$message = (0, $f0Pt4.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});
var $c3f3ddb72d828bba$export$2e2bcd8739ae039 = $c3f3ddb72d828bba$var$message;

});


parcelRegister("haYvF", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $16818bcbc9b5af40$export$d4c4e98c5044dc8);

var $bSJIT = parcelRequire("bSJIT");

var $kbBdI = parcelRequire("kbBdI");

var $hDkm2 = parcelRequire("hDkm2");

var $98w3H = parcelRequire("98w3H");

var $fQXuv = parcelRequire("fQXuv");

var $b54yp = parcelRequire("b54yp");

var $ih64Y = parcelRequire("ih64Y");
const $16818bcbc9b5af40$export$d4c4e98c5044dc8 = (props)=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const [clickCount, setClickCount] = (0, $bSJIT.useState)(1);
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
    const handleOnShowMore = (0, $bSJIT.useCallback)(()=>{
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kbBdI.components).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fQXuv.LoadingMessage), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $98w3H.default), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ih64Y.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b54yp.default), {
        onShowMore: handleOnShowMore
    })));
};
var $16818bcbc9b5af40$export$2e2bcd8739ae039 = $16818bcbc9b5af40$export$d4c4e98c5044dc8;

});
parcelRegister("kbBdI", function(module, exports) {
$parcel$export(module.exports, "components", () => $63f779dc8b500136$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $63f779dc8b500136$export$71abc632aa29e6fe);

var $2qpBS = parcelRequire("2qpBS");

var $iaig9 = parcelRequire("iaig9");

var $fqtqh = parcelRequire("fqtqh");

var $4f2Tm = parcelRequire("4f2Tm");

var $aoLRc = parcelRequire("aoLRc");

var $10Et3 = parcelRequire("10Et3");

var $2U5Wg = parcelRequire("2U5Wg");

var $8DiTY = parcelRequire("8DiTY");

var $1HCa6 = parcelRequire("1HCa6");

var $2mNNr = parcelRequire("2mNNr");

var $3XsFv = parcelRequire("3XsFv");

var $3T1l0 = parcelRequire("3T1l0");

var $dqtlf = parcelRequire("dqtlf");

var $7Ksd6 = parcelRequire("7Ksd6");

var $cCl69 = parcelRequire("cCl69");

var $6Zg4v = parcelRequire("6Zg4v");

var $gnPxA = parcelRequire("gnPxA");

var $altE3 = parcelRequire("altE3");

var $9OZzn = parcelRequire("9OZzn");

var $6meWM = parcelRequire("6meWM");

var $b95AW = parcelRequire("b95AW");

var $8ztgQ = parcelRequire("8ztgQ");
const $63f779dc8b500136$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $8DiTY.ClearIndicator),
    Control: (0, $aoLRc.default),
    DropdownIndicator: (0, $1HCa6.DropdownIndicator),
    Group: (0, $10Et3.default),
    GroupHeading: (0, $2U5Wg.GroupHeading),
    IndicatorsContainer: (0, $2qpBS.IndicatorsContainer),
    Input: (0, $3XsFv.default),
    LoadingIndicator: (0, $2mNNr.LoadingIndicator),
    Menu: (0, $3T1l0.default),
    MenuList: (0, $dqtlf.MenuList),
    MenuPortal: (0, $6Zg4v.MenuPortal),
    LoadingMessage: (0, $7Ksd6.LoadingMessage),
    NoOptionsMessage: (0, $cCl69.NoOptionsMessage),
    MultiValue: (0, $gnPxA.default),
    MultiValueContainer: (0, $iaig9.MultiValueContainer),
    MultiValueLabel: (0, $altE3.MultiValueLabel),
    MultiValueRemove: (0, $9OZzn.MultiValueRemove),
    Option: (0, $6meWM.default),
    Placeholder: (0, $b95AW.default),
    SelectContainer: (0, $fqtqh.SelectContainer),
    SingleValue: (0, $8ztgQ.default),
    ValueContainer: (0, $4f2Tm.ValueContainer)
};
const $63f779dc8b500136$export$71abc632aa29e6fe = (props)=>({
        ...$63f779dc8b500136$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("2qpBS", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $d682a1b675274523$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* indicators-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");
const $d682a1b675274523$var$indicatorContainerStyles = null;
const $d682a1b675274523$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $14TCm.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("bWEq6", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $0bc81a05d3d7112b$export$26417cabd806a658);
const $0bc81a05d3d7112b$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("iaig9", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $f5049a752e59dd6d$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");
const $f5049a752e59dd6d$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $f5049a752e59dd6d$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $f5049a752e59dd6d$var$multiValueStyles.root,
            isDisabled && $f5049a752e59dd6d$var$multiValueStyles.disabled,
            isFocused && $f5049a752e59dd6d$var$multiValueStyles.focused,
            (0, $14TCm.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};

});

parcelRegister("fqtqh", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $7bda7f28e81b4171$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* select-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");
const $7bda7f28e81b4171$var$containerStyles = {
    default: "_11c8fhey _kqswh2mm _lcxv1rj4 _j4tm1d4k",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const $7bda7f28e81b4171$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $bWEq6.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $7bda7f28e81b4171$var$containerStyles.default,
            isRtl && $7bda7f28e81b4171$var$containerStyles.rtl,
            isDisabled && $7bda7f28e81b4171$var$containerStyles.disabled,
            (0, $14TCm.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};

});

parcelRegister("4f2Tm", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $5d2d186298f57576$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");
const $5d2d186298f57576$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const $5d2d186298f57576$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const tagUpliftMultiVertical = isMulti;
    const tagUpliftChipRow = isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $5d2d186298f57576$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $5d2d186298f57576$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $5d2d186298f57576$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $5d2d186298f57576$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $5d2d186298f57576$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $5d2d186298f57576$var$valueContainerStyles.flex,
            tagUpliftChipRow && $5d2d186298f57576$var$valueContainerStyles.flexWithGap,
            (0, $14TCm.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};

});

parcelRegister("aoLRc", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc37a506c31e0ad7$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v3.0.2 */ /* control.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $gdUUy = parcelRequire("gdUUy");

var $bWEq6 = parcelRequire("bWEq6");
const $fc37a506c31e0ad7$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rko1qi0 _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
const $fc37a506c31e0ad7$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $fc37a506c31e0ad7$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    const isInputMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-input');
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $fc37a506c31e0ad7$var$styles.default,
            !isInputMotionEnabled && $fc37a506c31e0ad7$var$inputMotionStyles.legacy,
            isInputMotionEnabled && !isDisabled && $fc37a506c31e0ad7$var$inputMotionStyles.base,
            isDisabled && $fc37a506c31e0ad7$var$styles.disabled,
            isInvalid && $fc37a506c31e0ad7$var$styles.invalid,
            isCompact && $fc37a506c31e0ad7$var$styles.compact,
            appearance === 'subtle' && $fc37a506c31e0ad7$var$styles.subtle,
            appearance === 'subtle' && isFocused && $fc37a506c31e0ad7$var$styles.subtleFocused,
            isFocused && $fc37a506c31e0ad7$var$styles.focused,
            appearance === 'none' && $fc37a506c31e0ad7$var$styles.none,
            (0, $14TCm.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": (0, $gdUUy.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fc37a506c31e0ad7$export$2e2bcd8739ae039 = $fc37a506c31e0ad7$var$Control;

});

parcelRegister("10Et3", function(module, exports) {
$parcel$export(module.exports, "default", () => $78ca2f614935daf4$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");
const $78ca2f614935daf4$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const $78ca2f614935daf4$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $78ca2f614935daf4$var$styles.root,
            (0, $14TCm.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $dc70d.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                children: children
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$78ca2f614935daf4$export$2e2bcd8739ae039 = $78ca2f614935daf4$var$Group;

});

parcelRegister("2U5Wg", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $61e2cdc28c37c67f$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* group-heading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");

var $4War5 = parcelRequire("4War5");
const $61e2cdc28c37c67f$var$headingStyles = null;
const $61e2cdc28c37c67f$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $4War5.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $14TCm.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};

});
parcelRegister("4War5", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $a4e433cde420ee6b$export$8e9fd4287627890c);
// Clean Common Props
// ==============================
const $a4e433cde420ee6b$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};

});


parcelRegister("8DiTY", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $8c9a9be2ddedc004$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* clear-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $cBVmT = parcelRequire("cBVmT");

var $gdUUy = parcelRequire("gdUUy");

var $gXqq0 = parcelRequire("gXqq0");

var $bWEq6 = parcelRequire("bWEq6");
const $8c9a9be2ddedc004$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $8c9a9be2ddedc004$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    finesse: "_syazdgkc _30l31q3r"
};
const $8c9a9be2ddedc004$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $8c9a9be2ddedc004$var$clearIndicatorStyles.default,
            (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $8c9a9be2ddedc004$var$clearIndicatorStyles.finesse,
            isCompact && $8c9a9be2ddedc004$var$clearIndicatorStyles.compact,
            (0, $14TCm.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
            xcss: $8c9a9be2ddedc004$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};

});

parcelRegister("1HCa6", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $8f6f0e907c49d9cf$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* dropdown-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $4GWyU = parcelRequire("4GWyU");

var $gdUUy = parcelRequire("gdUUy");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $gXqq0 = parcelRequire("gXqq0");

var $bWEq6 = parcelRequire("bWEq6");
const $8f6f0e907c49d9cf$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
const $8f6f0e907c49d9cf$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
const $8f6f0e907c49d9cf$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
const $8f6f0e907c49d9cf$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx",
    finesse: "_syazdgkc",
    finesseDisabled: "_syaz2sac"
};
const $8f6f0e907c49d9cf$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps = {}, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    const { 'aria-hidden': ariaHidden, ...restInnerProps } = innerProps;
    const isVoiceControlAccessible = (0, $gdUUy.fg)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    const wrapperTestId = restInnerProps['data-testid'] ? `${restInnerProps['data-testid']}-children` : undefined;
    const voiceControlAccessibleIndicator = children ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId,
        children: children
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $8f6f0e907c49d9cf$var$voiceControlPressableStyles.root,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $8f6f0e907c49d9cf$var$voiceControlPressableSizeReset,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
            as: "span",
            xcss: $8f6f0e907c49d9cf$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $8f6f0e907c49d9cf$var$dropdownStyles.default,
            (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $8f6f0e907c49d9cf$var$dropdownStyles.finesse,
            isDisabled && $8f6f0e907c49d9cf$var$dropdownStyles.disabled,
            isDisabled && (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $8f6f0e907c49d9cf$var$dropdownStyles.finesseDisabled,
            isCompact && $8f6f0e907c49d9cf$var$dropdownStyles.compact,
            (0, $14TCm.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...restInnerProps,
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden,
        children: isVoiceControlAccessible ? voiceControlAccessibleIndicator : children ?? /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
            as: "span",
            xcss: $8f6f0e907c49d9cf$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};

});

parcelRegister("2mNNr", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $534c2a1ef03ca7c9$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* loading-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $hDkm2 = parcelRequire("hDkm2");

var $bWEq6 = parcelRequire("bWEq6");
const $534c2a1ef03ca7c9$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $534c2a1ef03ca7c9$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $534c2a1ef03ca7c9$var$loadingIndicatorStyles.default,
            isCompact && $534c2a1ef03ca7c9$var$loadingIndicatorStyles.compact,
            (0, $14TCm.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
            size: "small"
        })
    });
};

});

parcelRegister("3XsFv", function(module, exports) {
$parcel$export(module.exports, "default", () => $07d5e8b4883c03dd$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v3.0.2 */ /* input.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $gdUUy = parcelRequire("gdUUy");

var $bWEq6 = parcelRequire("bWEq6");

var $4War5 = parcelRequire("4War5");
const $07d5e8b4883c03dd$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $07d5e8b4883c03dd$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $07d5e8b4883c03dd$var$nativeInputStylesOld = null;
const $07d5e8b4883c03dd$var$nativeInputStyles = null;
const $07d5e8b4883c03dd$var$hidden = null;
const $07d5e8b4883c03dd$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $4War5.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'input', {
        'input-container': true
    });
    if ((0, $gdUUy.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $07d5e8b4883c03dd$var$inputStyles.root,
            isMulti && $07d5e8b4883c03dd$var$inputStyles.labellingFFStyles,
            isDisabled && $07d5e8b4883c03dd$var$inputStyles.disabled,
            (0, $14TCm.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $9fU1q.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $07d5e8b4883c03dd$var$inputStylesOld.root,
            isMulti && $07d5e8b4883c03dd$var$inputStylesOld.labellingFFStyles,
            isDisabled && $07d5e8b4883c03dd$var$inputStylesOld.disabled,
            (0, $14TCm.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $9fU1q.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07d5e8b4883c03dd$export$2e2bcd8739ae039 = $07d5e8b4883c03dd$var$Input;

});

parcelRegister("3T1l0", function(module, exports) {
$parcel$export(module.exports, "default", () => $efaba6d6e794fe96$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $gdUUy = parcelRequire("gdUUy");

var $bWEq6 = parcelRequire("bWEq6");
const $efaba6d6e794fe96$var$menuStyles = {
    root: "_2rko1mok _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    bottom: "_152t1osq",
    top: "_u7co1osq",
    topLayer: "_kqswh2mm _1e0c1txw _2lx21bp4 _ugzyidpf _6rthidpf _1pfhidpf"
};
const $efaba6d6e794fe96$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $efaba6d6e794fe96$var$menuStyles.root,
            (0, $gdUUy.fg)('platform-dst-top-layer') ? $efaba6d6e794fe96$var$menuStyles.topLayer : $efaba6d6e794fe96$var$menuStyles[placement],
            (0, $14TCm.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$efaba6d6e794fe96$export$2e2bcd8739ae039 = $efaba6d6e794fe96$var$Menu;

});

parcelRegister("dqtlf", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $cd451eb5724a0abc$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");
const $cd451eb5724a0abc$var$menuListStyles = null;
const $cd451eb5724a0abc$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            "_2rko1mok _kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $14TCm.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};

});

parcelRegister("7Ksd6", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $92f58418934db913$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-loading-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $8aT4G = parcelRequire("8aT4G");

var $bWEq6 = parcelRequire("bWEq6");
const $92f58418934db913$var$noticeStyles = null;
const $92f58418934db913$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $14TCm.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};

});

parcelRegister("cCl69", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $195cc542a1c533a6$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-no-options-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $8aT4G = parcelRequire("8aT4G");

var $bWEq6 = parcelRequire("bWEq6");
const $195cc542a1c533a6$var$noticeStyles = null;
const $195cc542a1c533a6$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $14TCm.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};

});

parcelRegister("6Zg4v", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $261f68d708194a30$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-portal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4Sf72 = parcelRequire("4Sf72");

var $14TCm = parcelRequire("14TCm");

var $dxRTV = parcelRequire("dxRTV");

var $gdUUy = parcelRequire("gdUUy");

var $bWEq6 = parcelRequire("bWEq6");

var $27N0a = parcelRequire("27N0a");

var $8dTRX = parcelRequire("8dTRX");
function $261f68d708194a30$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $261f68d708194a30$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $261f68d708194a30$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $261f68d708194a30$var$MenuPortalLegacy(props) {
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $bSJIT.useRef)(null);
    const cleanupRef = (0, $bSJIT.useRef)(null);
    const [placement, setPortalPlacement] = (0, $bSJIT.useState)($261f68d708194a30$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $bSJIT.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $bSJIT.useState)(null);
    const updateComputedPosition = (0, $bSJIT.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $261f68d708194a30$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $bSJIT.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $dxRTV.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $bSJIT.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $261f68d708194a30$var$menuPortalStyles.root,
            (0, $14TCm.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $27N0a.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $4Sf72.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
}
const $261f68d708194a30$export$793392f970497feb = (props)=>{
    if ((0, $gdUUy.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8dTRX.MenuPortalTopLayer), {
        ...props
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $dc70d.jsx)($261f68d708194a30$var$MenuPortalLegacy, {
        ...props
    });
};

});
parcelRegister("dxRTV", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $9dc82b0a8558c4cd$export$deee3a793edee05f);

var $8smYa = parcelRequire("8smYa");
var $g3t1H = parcelRequire("g3t1H");

var $g3t1H = parcelRequire("g3t1H");

var $aTSDe = parcelRequire("aTSDe");
function $9dc82b0a8558c4cd$var$getCssDimensions(element) {
    const css = (0, $aTSDe.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $aTSDe.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $g3t1H.round)(width) !== offsetWidth || (0, $g3t1H.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $9dc82b0a8558c4cd$var$unwrapElement(element) {
    return !(0, $aTSDe.isElement)(element) ? element.contextElement : element;
}
function $9dc82b0a8558c4cd$var$getScale(element) {
    const domElement = $9dc82b0a8558c4cd$var$unwrapElement(element);
    if (!(0, $aTSDe.isHTMLElement)(domElement)) return (0, $g3t1H.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $9dc82b0a8558c4cd$var$getCssDimensions(domElement);
    let x = ($ ? (0, $g3t1H.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $g3t1H.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $9dc82b0a8558c4cd$var$noOffsets = /*#__PURE__*/ (0, $g3t1H.createCoords)(0);
function $9dc82b0a8558c4cd$var$getVisualOffsets(element) {
    const win = (0, $aTSDe.getWindow)(element);
    if (!(0, $aTSDe.isWebKit)() || !win.visualViewport) return $9dc82b0a8558c4cd$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $9dc82b0a8558c4cd$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $aTSDe.getWindow)(element);
}
function $9dc82b0a8558c4cd$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $9dc82b0a8558c4cd$var$unwrapElement(element);
    let scale = (0, $g3t1H.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $aTSDe.isElement)(offsetParent)) scale = $9dc82b0a8558c4cd$var$getScale(offsetParent);
        } else scale = $9dc82b0a8558c4cd$var$getScale(element);
    }
    const visualOffsets = $9dc82b0a8558c4cd$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $9dc82b0a8558c4cd$var$getVisualOffsets(domElement) : (0, $g3t1H.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $aTSDe.getWindow)(domElement);
        const offsetWin = (0, $aTSDe.isElement)(offsetParent) ? (0, $aTSDe.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $aTSDe.getFrameElement)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $9dc82b0a8558c4cd$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $aTSDe.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $aTSDe.getWindow)(currentIFrame);
            currentIFrame = (0, $aTSDe.getFrameElement)(currentWin);
        }
    }
    return (0, $g3t1H.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $9dc82b0a8558c4cd$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $aTSDe.getNodeScroll)(element).scrollLeft;
    if (!rect) return $9dc82b0a8558c4cd$var$getBoundingClientRect((0, $aTSDe.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $9dc82b0a8558c4cd$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $9dc82b0a8558c4cd$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $9dc82b0a8558c4cd$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $aTSDe.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $aTSDe.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $g3t1H.createCoords)(1);
    const offsets = (0, $g3t1H.createCoords)(0);
    const isOffsetParentAnElement = (0, $aTSDe.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $aTSDe.getNodeName)(offsetParent) !== 'body' || (0, $aTSDe.isOverflowElement)(documentElement)) scroll = (0, $aTSDe.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $9dc82b0a8558c4cd$var$getBoundingClientRect(offsetParent);
            scale = $9dc82b0a8558c4cd$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $9dc82b0a8558c4cd$var$getHTMLOffset(documentElement, scroll) : (0, $g3t1H.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $9dc82b0a8558c4cd$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $9dc82b0a8558c4cd$var$getDocumentRect(html) {
    const scroll = (0, $aTSDe.getNodeScroll)(html);
    const body = html.ownerDocument.body;
    const width = (0, $g3t1H.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $g3t1H.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $9dc82b0a8558c4cd$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $aTSDe.getComputedStyle)(body).direction === 'rtl') x += (0, $g3t1H.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $9dc82b0a8558c4cd$var$SCROLLBAR_MAX = 25;
function $9dc82b0a8558c4cd$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $aTSDe.getWindow)(element);
    const html = (0, $aTSDe.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $aTSDe.isWebKit)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $9dc82b0a8558c4cd$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $9dc82b0a8558c4cd$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $9dc82b0a8558c4cd$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $9dc82b0a8558c4cd$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $9dc82b0a8558c4cd$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $9dc82b0a8558c4cd$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $9dc82b0a8558c4cd$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $9dc82b0a8558c4cd$var$getDocumentRect((0, $aTSDe.getDocumentElement)(element));
    else if ((0, $aTSDe.isElement)(clippingAncestor)) rect = $9dc82b0a8558c4cd$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $9dc82b0a8558c4cd$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $g3t1H.rectToClientRect)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $9dc82b0a8558c4cd$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $aTSDe.getOverflowAncestors)(element, [], false).filter((el)=>(0, $aTSDe.isElement)(el) && (0, $aTSDe.getNodeName)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $aTSDe.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $aTSDe.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $aTSDe.isElement)(currentNode) && !(0, $aTSDe.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $aTSDe.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $aTSDe.isContainingBlock)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $aTSDe.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $9dc82b0a8558c4cd$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $aTSDe.isTopLayer)(element) ? [] : $9dc82b0a8558c4cd$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $9dc82b0a8558c4cd$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $9dc82b0a8558c4cd$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $g3t1H.max)(rect.top, top);
        right = (0, $g3t1H.min)(rect.right, right);
        bottom = (0, $g3t1H.min)(rect.bottom, bottom);
        left = (0, $g3t1H.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $9dc82b0a8558c4cd$var$getDimensions(element) {
    const { width: width, height: height } = $9dc82b0a8558c4cd$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $9dc82b0a8558c4cd$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $aTSDe.isHTMLElement)(offsetParent);
    const documentElement = (0, $aTSDe.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $9dc82b0a8558c4cd$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $g3t1H.createCoords)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $aTSDe.getNodeName)(offsetParent) !== 'body' || (0, $aTSDe.isOverflowElement)(documentElement)) scroll = (0, $aTSDe.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $9dc82b0a8558c4cd$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $9dc82b0a8558c4cd$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $9dc82b0a8558c4cd$var$getHTMLOffset(documentElement, scroll) : (0, $g3t1H.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $9dc82b0a8558c4cd$var$isStaticPositioned(element) {
    return (0, $aTSDe.getComputedStyle)(element).position === 'static';
}
function $9dc82b0a8558c4cd$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $aTSDe.isHTMLElement)(element) || (0, $aTSDe.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $aTSDe.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $9dc82b0a8558c4cd$var$getOffsetParent(element, polyfill) {
    const win = (0, $aTSDe.getWindow)(element);
    if ((0, $aTSDe.isTopLayer)(element)) return win;
    if (!(0, $aTSDe.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $aTSDe.getParentNode)(element);
        while(svgOffsetParent && !(0, $aTSDe.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $aTSDe.isElement)(svgOffsetParent) && !$9dc82b0a8558c4cd$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $aTSDe.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $9dc82b0a8558c4cd$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $aTSDe.isTableElement)(offsetParent) && $9dc82b0a8558c4cd$var$isStaticPositioned(offsetParent))offsetParent = $9dc82b0a8558c4cd$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $aTSDe.isLastTraversableNode)(offsetParent) && $9dc82b0a8558c4cd$var$isStaticPositioned(offsetParent) && !(0, $aTSDe.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $aTSDe.getContainingBlock)(element) || win;
}
const $9dc82b0a8558c4cd$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $9dc82b0a8558c4cd$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $9dc82b0a8558c4cd$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $9dc82b0a8558c4cd$var$isRTL(element) {
    return (0, $aTSDe.getComputedStyle)(element).direction === 'rtl';
}
const $9dc82b0a8558c4cd$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $9dc82b0a8558c4cd$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $aTSDe.getDocumentElement,
    getClippingRect: $9dc82b0a8558c4cd$var$getClippingRect,
    getOffsetParent: $9dc82b0a8558c4cd$var$getOffsetParent,
    getElementRects: $9dc82b0a8558c4cd$var$getElementRects,
    getClientRects: $9dc82b0a8558c4cd$var$getClientRects,
    getDimensions: $9dc82b0a8558c4cd$var$getDimensions,
    getScale: $9dc82b0a8558c4cd$var$getScale,
    isElement: $aTSDe.isElement,
    isRTL: $9dc82b0a8558c4cd$var$isRTL
};
function $9dc82b0a8558c4cd$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $9dc82b0a8558c4cd$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $aTSDe.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $g3t1H.floor)(top);
        const insetRight = (0, $g3t1H.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $g3t1H.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $g3t1H.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $g3t1H.max)(0, (0, $g3t1H.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$9dc82b0a8558c4cd$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $aTSDe.getWindow)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $9dc82b0a8558c4cd$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $9dc82b0a8558c4cd$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $aTSDe.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $aTSDe.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $9dc82b0a8558c4cd$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $9dc82b0a8558c4cd$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $9dc82b0a8558c4cd$var$getBoundingClientRect(reference);
        if (prevRefRect && !$9dc82b0a8558c4cd$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $9dc82b0a8558c4cd$export$37b6bde19b108ecc = (0, $8smYa.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dc82b0a8558c4cd$export$cc800923e997bb8 = (0, $8smYa.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dc82b0a8558c4cd$export$91fb6ecbd551914 = (0, $8smYa.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dc82b0a8558c4cd$export$fba63a578e423eb = (0, $8smYa.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dc82b0a8558c4cd$export$8a83211c878a3f1f = (0, $8smYa.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dc82b0a8558c4cd$export$346677f925de839c = (0, $8smYa.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dc82b0a8558c4cd$export$fe8985bb6374093c = (0, $8smYa.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dc82b0a8558c4cd$export$f2120bbfa5450bd2 = (0, $8smYa.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dc82b0a8558c4cd$export$18c8ad048e32c7d5 = (0, $8smYa.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dc82b0a8558c4cd$export$7bf07e38f3dc4b69 = (0, $8smYa.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $9dc82b0a8558c4cd$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$9dc82b0a8558c4cd$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $8smYa.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("8smYa", function(module, exports) {
$parcel$export(module.exports, "detectOverflow", () => $6282c1862dc04866$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $6282c1862dc04866$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $6282c1862dc04866$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $6282c1862dc04866$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $6282c1862dc04866$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $6282c1862dc04866$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $6282c1862dc04866$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $6282c1862dc04866$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $6282c1862dc04866$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $6282c1862dc04866$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $6282c1862dc04866$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("g3t1H")).rectToClientRect);

var $g3t1H = parcelRequire("g3t1H");
function $6282c1862dc04866$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $g3t1H.getSideAxis)(placement);
    const alignmentAxis = (0, $g3t1H.getAlignmentAxis)(placement);
    const alignLength = (0, $g3t1H.getAxisLength)(alignmentAxis);
    const side = (0, $g3t1H.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $g3t1H.getAlignment)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $6282c1862dc04866$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $g3t1H.evaluate)(options, state);
    const paddingObject = (0, $g3t1H.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $g3t1H.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $g3t1H.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $6282c1862dc04866$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $6282c1862dc04866$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $6282c1862dc04866$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $6282c1862dc04866$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $6282c1862dc04866$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $6282c1862dc04866$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6282c1862dc04866$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $g3t1H.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $g3t1H.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $g3t1H.getAlignmentAxis)(placement);
            const length = (0, $g3t1H.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $g3t1H.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $g3t1H.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $g3t1H.clamp)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $g3t1H.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $6282c1862dc04866$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $g3t1H.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $g3t1H.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $g3t1H.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $g3t1H.getAlignment)(placement) === alignment || (autoAlignment ? (0, $g3t1H.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $6282c1862dc04866$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $g3t1H.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $g3t1H.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $g3t1H.placements) ? $6282c1862dc04866$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $g3t1H.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $g3t1H.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $g3t1H.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $g3t1H.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6282c1862dc04866$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $g3t1H.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $g3t1H.getSide)(placement);
            const initialSideAxis = (0, $g3t1H.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $g3t1H.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $g3t1H.getOppositePlacement)(initialPlacement)
            ] : (0, $g3t1H.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $g3t1H.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $g3t1H.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $g3t1H.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $g3t1H.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $g3t1H.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $6282c1862dc04866$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $6282c1862dc04866$var$isAnySideFullyClipped(overflow) {
    return (0, $g3t1H.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6282c1862dc04866$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $g3t1H.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $6282c1862dc04866$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $6282c1862dc04866$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $6282c1862dc04866$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $6282c1862dc04866$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $6282c1862dc04866$var$getBoundingRect(rects) {
    const minX = (0, $g3t1H.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $g3t1H.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $g3t1H.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $g3t1H.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $6282c1862dc04866$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $g3t1H.rectToClientRect)($6282c1862dc04866$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $6282c1862dc04866$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $g3t1H.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $6282c1862dc04866$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $g3t1H.rectToClientRect)($6282c1862dc04866$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $g3t1H.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $g3t1H.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $g3t1H.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $g3t1H.rectToClientRect)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $g3t1H.getSide)(placement) === 'left';
                    const maxRight = (0, $g3t1H.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $g3t1H.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $g3t1H.rectToClientRect)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $6282c1862dc04866$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $6282c1862dc04866$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $g3t1H.getSide)(placement);
    const alignment = (0, $g3t1H.getAlignment)(placement);
    const isVertical = (0, $g3t1H.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $6282c1862dc04866$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $g3t1H.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6282c1862dc04866$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $6282c1862dc04866$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6282c1862dc04866$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $g3t1H.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $g3t1H.getSideAxis)(placement);
            const mainAxis = (0, $g3t1H.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $g3t1H.clamp)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6282c1862dc04866$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $g3t1H.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $g3t1H.getSideAxis)(placement);
            const mainAxis = (0, $g3t1H.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $g3t1H.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $6282c1862dc04866$var$originSides.has((0, $g3t1H.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6282c1862dc04866$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $g3t1H.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $g3t1H.getSide)(placement);
            const alignment = (0, $g3t1H.getAlignment)(placement);
            const isYAxis = (0, $g3t1H.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $g3t1H.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $g3t1H.min)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $g3t1H.max)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $g3t1H.max)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("g3t1H", function(module, exports) {
$parcel$export(module.exports, "sides", () => $bb03712f309869e5$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $bb03712f309869e5$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $bb03712f309869e5$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $bb03712f309869e5$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $bb03712f309869e5$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $bb03712f309869e5$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $bb03712f309869e5$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $bb03712f309869e5$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $bb03712f309869e5$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $bb03712f309869e5$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $bb03712f309869e5$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $bb03712f309869e5$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $bb03712f309869e5$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $bb03712f309869e5$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $bb03712f309869e5$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $bb03712f309869e5$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $bb03712f309869e5$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $bb03712f309869e5$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $bb03712f309869e5$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $bb03712f309869e5$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $bb03712f309869e5$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $bb03712f309869e5$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $bb03712f309869e5$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $bb03712f309869e5$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $bb03712f309869e5$export$803cd8101b6c182b = /*#__PURE__*/ $bb03712f309869e5$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $bb03712f309869e5$export$27b07d8a310ed8b5[0], side + "-" + $bb03712f309869e5$export$27b07d8a310ed8b5[1]), []);
const $bb03712f309869e5$export$96ec731ed4dcb222 = Math.min;
const $bb03712f309869e5$export$8960430cfd85939f = Math.max;
const $bb03712f309869e5$export$2077e0241d6afd3c = Math.round;
const $bb03712f309869e5$export$a3fe094919f356fd = Math.floor;
const $bb03712f309869e5$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $bb03712f309869e5$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $bb03712f309869e5$export$7d15b64cf5a3a4c4(start, value, end) {
    return $bb03712f309869e5$export$8960430cfd85939f(start, $bb03712f309869e5$export$96ec731ed4dcb222(value, end));
}
function $bb03712f309869e5$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $bb03712f309869e5$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $bb03712f309869e5$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $bb03712f309869e5$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $bb03712f309869e5$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $bb03712f309869e5$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $bb03712f309869e5$export$2b57e0052a6d6d4c(placement) {
    return $bb03712f309869e5$export$8a000a963141ac32($bb03712f309869e5$export$f28e8f882010718a(placement));
}
function $bb03712f309869e5$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $bb03712f309869e5$export$f0989780f32bfcda(placement);
    const alignmentAxis = $bb03712f309869e5$export$2b57e0052a6d6d4c(placement);
    const length = $bb03712f309869e5$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $bb03712f309869e5$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $bb03712f309869e5$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $bb03712f309869e5$export$496432a3699e50b1(placement) {
    const oppositePlacement = $bb03712f309869e5$export$9c5e28bad23365fa(placement);
    return [
        $bb03712f309869e5$export$2b182c584985588b(placement),
        oppositePlacement,
        $bb03712f309869e5$export$2b182c584985588b(oppositePlacement)
    ];
}
function $bb03712f309869e5$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $bb03712f309869e5$var$lrPlacement = [
    'left',
    'right'
];
const $bb03712f309869e5$var$rlPlacement = [
    'right',
    'left'
];
const $bb03712f309869e5$var$tbPlacement = [
    'top',
    'bottom'
];
const $bb03712f309869e5$var$btPlacement = [
    'bottom',
    'top'
];
function $bb03712f309869e5$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $bb03712f309869e5$var$rlPlacement : $bb03712f309869e5$var$lrPlacement;
            return isStart ? $bb03712f309869e5$var$lrPlacement : $bb03712f309869e5$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $bb03712f309869e5$var$tbPlacement : $bb03712f309869e5$var$btPlacement;
        default:
            return [];
    }
}
function $bb03712f309869e5$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $bb03712f309869e5$export$f0989780f32bfcda(placement);
    let list = $bb03712f309869e5$var$getSideList($bb03712f309869e5$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($bb03712f309869e5$export$2b182c584985588b));
    }
    return list;
}
function $bb03712f309869e5$export$9c5e28bad23365fa(placement) {
    const side = $bb03712f309869e5$export$3c915306cb7fc97a(placement);
    return $bb03712f309869e5$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $bb03712f309869e5$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $bb03712f309869e5$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $bb03712f309869e5$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $bb03712f309869e5$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("aTSDe", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $7ef96b292bdfc0ab$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $7ef96b292bdfc0ab$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $7ef96b292bdfc0ab$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $7ef96b292bdfc0ab$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $7ef96b292bdfc0ab$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $7ef96b292bdfc0ab$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $7ef96b292bdfc0ab$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $7ef96b292bdfc0ab$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $7ef96b292bdfc0ab$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $7ef96b292bdfc0ab$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $7ef96b292bdfc0ab$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $7ef96b292bdfc0ab$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $7ef96b292bdfc0ab$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $7ef96b292bdfc0ab$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $7ef96b292bdfc0ab$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $7ef96b292bdfc0ab$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $7ef96b292bdfc0ab$export$7bf1f8740e3e34af);
function $7ef96b292bdfc0ab$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $7ef96b292bdfc0ab$export$651544f548703224(node) {
    if ($7ef96b292bdfc0ab$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $7ef96b292bdfc0ab$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $7ef96b292bdfc0ab$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($7ef96b292bdfc0ab$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $7ef96b292bdfc0ab$export$8ee0fc9ee280b4ee(value) {
    if (!$7ef96b292bdfc0ab$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $7ef96b292bdfc0ab$export$38b2d434cce3ea22(value).Node;
}
function $7ef96b292bdfc0ab$export$45a5e7f76e0caa8d(value) {
    if (!$7ef96b292bdfc0ab$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $7ef96b292bdfc0ab$export$38b2d434cce3ea22(value).Element;
}
function $7ef96b292bdfc0ab$export$1b3bfaa9684536aa(value) {
    if (!$7ef96b292bdfc0ab$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $7ef96b292bdfc0ab$export$38b2d434cce3ea22(value).HTMLElement;
}
function $7ef96b292bdfc0ab$export$af51f0f06c0f328a(value) {
    if (!$7ef96b292bdfc0ab$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $7ef96b292bdfc0ab$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $7ef96b292bdfc0ab$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $7ef96b292bdfc0ab$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $7ef96b292bdfc0ab$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($7ef96b292bdfc0ab$export$651544f548703224(element));
}
function $7ef96b292bdfc0ab$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $7ef96b292bdfc0ab$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $7ef96b292bdfc0ab$var$containRe = /paint|layout|strict|content/;
const $7ef96b292bdfc0ab$var$isNotNone = (value)=>!!value && value !== 'none';
let $7ef96b292bdfc0ab$var$isWebKitValue;
function $7ef96b292bdfc0ab$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $7ef96b292bdfc0ab$export$45a5e7f76e0caa8d(elementOrCss) ? $7ef96b292bdfc0ab$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $7ef96b292bdfc0ab$var$isNotNone(css.transform) || $7ef96b292bdfc0ab$var$isNotNone(css.translate) || $7ef96b292bdfc0ab$var$isNotNone(css.scale) || $7ef96b292bdfc0ab$var$isNotNone(css.rotate) || $7ef96b292bdfc0ab$var$isNotNone(css.perspective) || !$7ef96b292bdfc0ab$export$78551043582a6a98() && ($7ef96b292bdfc0ab$var$isNotNone(css.backdropFilter) || $7ef96b292bdfc0ab$var$isNotNone(css.filter)) || $7ef96b292bdfc0ab$var$willChangeRe.test(css.willChange || '') || $7ef96b292bdfc0ab$var$containRe.test(css.contain || '');
}
function $7ef96b292bdfc0ab$export$940d8225183e1404(element) {
    let currentNode = $7ef96b292bdfc0ab$export$4e12058fc4d51d56(element);
    while($7ef96b292bdfc0ab$export$1b3bfaa9684536aa(currentNode) && !$7ef96b292bdfc0ab$export$d1162fb0b6d4cd51(currentNode)){
        if ($7ef96b292bdfc0ab$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($7ef96b292bdfc0ab$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $7ef96b292bdfc0ab$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $7ef96b292bdfc0ab$export$78551043582a6a98() {
    if ($7ef96b292bdfc0ab$var$isWebKitValue == null) $7ef96b292bdfc0ab$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $7ef96b292bdfc0ab$var$isWebKitValue;
}
function $7ef96b292bdfc0ab$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($7ef96b292bdfc0ab$export$651544f548703224(node));
}
function $7ef96b292bdfc0ab$export$3735103072e4a80(element) {
    return $7ef96b292bdfc0ab$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $7ef96b292bdfc0ab$export$dc8fc79fa2800137(element) {
    if ($7ef96b292bdfc0ab$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $7ef96b292bdfc0ab$export$4e12058fc4d51d56(node) {
    if ($7ef96b292bdfc0ab$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $7ef96b292bdfc0ab$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $7ef96b292bdfc0ab$export$e495491855dc5418(node);
    return $7ef96b292bdfc0ab$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $7ef96b292bdfc0ab$export$7cd01a57c8ca906c(node) {
    const parentNode = $7ef96b292bdfc0ab$export$4e12058fc4d51d56(node);
    if ($7ef96b292bdfc0ab$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($7ef96b292bdfc0ab$export$1b3bfaa9684536aa(parentNode) && $7ef96b292bdfc0ab$export$989e911fa9af580a(parentNode)) return parentNode;
    return $7ef96b292bdfc0ab$export$7cd01a57c8ca906c(parentNode);
}
function $7ef96b292bdfc0ab$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $7ef96b292bdfc0ab$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $7ef96b292bdfc0ab$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $7ef96b292bdfc0ab$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $7ef96b292bdfc0ab$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $7ef96b292bdfc0ab$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $7ef96b292bdfc0ab$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $7ef96b292bdfc0ab$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("27N0a", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $7e626b183651cce4$export$e001f626511a0ead);

var $bSJIT = parcelRequire("bSJIT");
const $7e626b183651cce4$export$e001f626511a0ead = /*#__PURE__*/ (0, $bSJIT.createContext)(null);

});

parcelRegister("8dTRX", function(module, exports) {
$parcel$export(module.exports, "MenuPortalTopLayer", () => $bd5a936c1296bf11$export$1f5427c7f5364d0b);
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $6gXOx = parcelRequire("6gXOx");

var $jfBg8 = parcelRequire("jfBg8");

var $7nmZk = parcelRequire("7nmZk");

var $d7P6i = parcelRequire("d7P6i");

var $bWEq6 = parcelRequire("bWEq6");

var $a0tSa = parcelRequire("a0tSa");
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $bd5a936c1296bf11$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const $bd5a936c1296bf11$var$menuPortalStyles = {
    root: "_1e0c1txw _2lx21bp4 _ugzyidpf"
};
function $bd5a936c1296bf11$export$1f5427c7f5364d0b(props) {
    const { additionalInsideElementRefs: additionalInsideElementRefsProp, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, $bSJIT.useContext)((0, $a0tSa.MenuPortalCloseContext));
    const popoverRef = (0, $bSJIT.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, $bSJIT.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null;
    const additionalInsideElementRefs = (0, $bSJIT.useMemo)(()=>[
            anchorRef,
            ...additionalInsideElementRefsProp ?? []
        ], [
        additionalInsideElementRefsProp,
        anchorRef
    ]);
    // Inline rather than memoised: `useAnchoredPopover` re-derives a stable
    // placement from the primitive fields.
    (0, $7nmZk.useAnchoredPopover)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $bd5a936c1296bf11$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            // Keep the popover separated from the control, even when it flips to the opposite side.
            offset: {
                gap: "var(--ds-space-100, 8px)"
            }
        },
        isOpen: isAnchored,
        inlineSize: 'match-anchor',
        // Fit long menus into available space, rather than only capping at the full viewport height.
        blockSize: 'max-available'
    });
    const handlePopoverClose = (0, $bSJIT.useCallback)((args)=>{
        if (closeSelect) closeSelect(args);
    }, [
        closeSelect
    ]);
    (0, $d7P6i.useSimpleLightDismiss)({
        popoverRef: popoverRef,
        additionalInsideElementRefs: additionalInsideElementRefs,
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className: className } = (0, $bWEq6.getStyleProps)({
        ...props,
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }, 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // Select owns dismissal so both its external control and menu count as inside.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jfBg8.Popover), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // `className` carries consumer `styles.menuPortal({...})` output,
            // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
            // is a legacy selector hook kept for parity with MenuPortalLegacy.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
            className: (0, $9fU1q.default)([
                $bd5a936c1296bf11$var$menuPortalStyles.root,
                (0, $14TCm.cx)(className, xcss, '-MenuPortal')
            ]),
            ...innerProps,
            children: children
        })
    });
}

});
parcelRegister("d7P6i", function(module, exports) {
$parcel$export(module.exports, "useSimpleLightDismiss", () => $46b03685e506f7f9$export$a1840020a453c833);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");
function $46b03685e506f7f9$export$a1840020a453c833({ popoverRef: popoverRef, additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onClose: onClose }) {
    // Keep a stable ref to onClose so the effect does not re-bind on every render.
    const onCloseRef = (0, $bSJIT.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $bSJIT.useEffect)(()=>{
        if (!isOpen) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- binding to document for light dismiss
        const unbindEscape = (0, $bAB3U.bind)(document, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                // Preserve JavaScript bubbling while preventing a native/manual
                // popover ancestor from also handling this Escape key.
                event.preventDefault();
                onCloseRef.current({
                    reason: 'escape'
                });
            }
        });
        // Listen for click-outside in the **capture** phase.
        //
        // The click that opened the popover propagates in bubble phase
        // (trigger onClick → setIsOpen(true) → React render → useEffect).
        // By the time this effect runs, the opening click has finished
        // bubbling. A capture-phase listener added now cannot retroactively
        // fire for that event - it only fires for *future* clicks.
        //
        // This avoids the need for timestamp guards or deferred binding.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- binding to document for light dismiss
        const unbindClickOutside = (0, $bAB3U.bind)(document, {
            type: 'click',
            listener: (event)=>{
                const element = popoverRef.current;
                const target = event.target;
                if (!element || !(target instanceof Node)) return;
                // Clicks inside the popover or its additional inside elements do not dismiss it.
                if (element.contains(target) || additionalInsideElementRefs !== null && additionalInsideElementRefs !== void 0 && additionalInsideElementRefs.some((insideElementRef)=>{
                    var _insideElementRef$cur;
                    return (_insideElementRef$cur = insideElementRef.current) === null || _insideElementRef$cur === void 0 ? void 0 : _insideElementRef$cur.contains(target);
                })) return;
                onCloseRef.current({
                    reason: 'light-dismiss'
                });
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbindEscape();
            unbindClickOutside();
        };
    }, [
        additionalInsideElementRefs,
        isOpen,
        popoverRef
    ]);
}

});

parcelRegister("a0tSa", function(module, exports) {
$parcel$export(module.exports, "MenuPortalCloseContext", () => $35e0766a2c793a13$export$a0d5b29fa9affc38);

var $bSJIT = parcelRequire("bSJIT");
const $35e0766a2c793a13$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});



parcelRegister("gnPxA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fcb7cecabe7d628$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value.tsx generated by @compiled/babel-plugin v3.0.2 */ // Renders default multi-value content while the shared wrapper owns layout motion and truncation.

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $h3R7U = parcelRequire("h3R7U");

var $bWEq6 = parcelRequire("bWEq6");

var $gORfN = parcelRequire("gORfN");

var $iaig9 = parcelRequire("iaig9");

var $altE3 = parcelRequire("altE3");

var $cBTlW = parcelRequire("cBTlW");
const $8fcb7cecabe7d628$var$multiValueTagWrapperStyles = {
    root: "_1e0c1bgi"
};
// Tag-like color styles
const $8fcb7cecabe7d628$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
const $8fcb7cecabe7d628$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $8fcb7cecabe7d628$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $8fcb7cecabe7d628$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
const $8fcb7cecabe7d628$var$MultiValueContent = (contentProps)=>{
    const { hasEllipsis: hasEllipsis, multiValueProps: props, motionState: motionState, truncationRef: truncationRef } = contentProps;
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $8fcb7cecabe7d628$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const isEnteringWithMotion = motionState === 'entering';
    const isExitingWithMotion = motionState === 'exiting';
    const isWidthAnimating = isEnteringWithMotion || isExitingWithMotion;
    const { css: containerCss, className: containerClassName } = (0, $bWEq6.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $bWEq6.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $bWEq6.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $altE3.MultiValueLabel);
    const hasCustomContainer = Container !== (0, $iaig9.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $gORfN.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onMouseDown: (event)=>{
                if (event.target instanceof Element && event.target.closest('button')) {
                    var _removeProps$onMouseD;
                    (_removeProps$onMouseD = removeProps.onMouseDown) === null || _removeProps$onMouseD === void 0 || _removeProps$onMouseD.call(removeProps, event);
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $9fU1q.default)([
                $8fcb7cecabe7d628$var$multiValueTagWrapperStyles.root,
                (0, $14TCm.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $h3R7U.default), {
                text: labelText,
                isRemovable: !isDisabled,
                onBeforeRemoveAction: ()=>{
                    var _removeProps$onClick;
                    (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    }
    // tag-like path for custom content
    if (!hasCustomContainer) {
        const colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $9fU1q.default)([
                $8fcb7cecabe7d628$var$multiValueTagLikeStyles.root,
                $8fcb7cecabe7d628$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $8fcb7cecabe7d628$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $8fcb7cecabe7d628$var$tagLikeColorStyles.green,
                colorKey === 'red' && $8fcb7cecabe7d628$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $8fcb7cecabe7d628$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $8fcb7cecabe7d628$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $8fcb7cecabe7d628$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $8fcb7cecabe7d628$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $8fcb7cecabe7d628$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $8fcb7cecabe7d628$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $8fcb7cecabe7d628$var$multiValueTagLikeStyles.disabled,
                isFocused && $8fcb7cecabe7d628$var$multiValueTagLikeStyles.focused,
                (0, $14TCm.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $8fcb7cecabe7d628$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName,
                            ref: truncationRef
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: (cropWithEllipsis || cropWithEllipsis === undefined) && (!isWidthAnimating || hasEllipsis),
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, $dc70d.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName,
                    ref: truncationRef
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
const $8fcb7cecabe7d628$var$MotionMultiValue = ({ multiValueProps: multiValueProps })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $cBTlW.default), {
        onMotionFinish: multiValueProps.onMotionFinish,
        shouldMeasureTruncation: true,
        children: ({ hasEllipsis: hasEllipsis, motionState: motionState, truncationRef: truncationRef })=>/*#__PURE__*/ (0, $dc70d.jsx)($8fcb7cecabe7d628$var$MultiValueContent, {
                hasEllipsis: hasEllipsis,
                multiValueProps: multiValueProps,
                motionState: motionState,
                truncationRef: truncationRef
            })
    });
const $8fcb7cecabe7d628$var$MultiValue = (props)=>{
    const { Container: Container, Label: Label } = props.components;
    const selectStyles = props.selectProps.styles;
    const selectClassNames = props.selectProps.classNames;
    const selectGetStyles = (0, $gORfN.useSelectGetStyles)();
    // The standard Tag already owns its width and truncation motion. Tag-like custom values do not,
    // so they continue through MultiValueMotion below.
    const hasSelfManagedTagMotion = typeof props.children === 'string' && Label === (0, $altE3.MultiValueLabel) && Container === (0, $iaig9.MultiValueContainer) && !(selectStyles !== null && selectStyles !== void 0 && selectStyles.multiValue) && !(selectStyles !== null && selectStyles !== void 0 && selectStyles.multiValueLabel) && !(selectStyles !== null && selectStyles !== void 0 && selectStyles.multiValueRemove) && !(selectClassNames !== null && selectClassNames !== void 0 && selectClassNames.multiValue) && !(selectClassNames !== null && selectClassNames !== void 0 && selectClassNames.multiValueLabel) && !(selectClassNames !== null && selectClassNames !== void 0 && selectClassNames.multiValueRemove) && (selectGetStyles === undefined || props.getStyles === selectGetStyles);
    if (props.isMotionEnabled && !hasSelfManagedTagMotion) return /*#__PURE__*/ (0, $dc70d.jsx)($8fcb7cecabe7d628$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($8fcb7cecabe7d628$var$MultiValueContent, {
        multiValueProps: props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fcb7cecabe7d628$export$2e2bcd8739ae039 = $8fcb7cecabe7d628$var$MultiValue;

});
parcelRegister("h3R7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd27fd1d45136ddb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fitdS = parcelRequire("fitdS");

var $1OdZP = parcelRequire("1OdZP");

var $iW5ND = parcelRequire("iW5ND");

var $1Fzgn = parcelRequire("1Fzgn");

var $7d1b3 = parcelRequire("7d1b3");

var $boXhX = parcelRequire("boXhX");
const $cd27fd1d45136ddb$var$packageName = undefined;
const $cd27fd1d45136ddb$var$packageVersion = undefined;
const $cd27fd1d45136ddb$var$defaultBeforeRemoveAction = ()=>true;
const $cd27fd1d45136ddb$var$RemovableTagComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $cd27fd1d45136ddb$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $1OdZP.default), maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }, ref)=>{
    const normalizedText = (0, $1Fzgn.getTagText)(text);
    // Wrap the analytics dispatcher so it fires synchronously when removal is
    // confirmed (matching the pre-flag-removal behaviour where analytics fired
    // immediately on button click, not after the CSS exit animation).
    const fireRemovedAnalytics = (0, $fitdS.useCallbackWithAnalytics)((0, $1OdZP.default), {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $cd27fd1d45136ddb$var$packageName,
            packageVersion: $cd27fd1d45136ddb$var$packageVersion
        }
    }, 'atlaskit');
    // Intercept onBeforeRemoveAction: fire analytics and call onAfterRemoveAction
    // synchronously when removal is approved. This matches the pre-feature-flag
    // behaviour where both fired immediately on button click, not after the CSS
    // exit animation completes (which never fires in jsdom test environments).
    const onBeforeRemoveActionWithAnalytics = (0, $bSJIT.useCallback)(()=>{
        const shouldRemove = onBeforeRemoveAction();
        if (shouldRemove) {
            fireRemovedAnalytics(normalizedText);
            onAfterRemoveAction(normalizedText);
        }
        return shouldRemove;
    }, [
        onBeforeRemoveAction,
        fireRemovedAnalytics,
        normalizedText,
        onAfterRemoveAction
    ]);
    // TagNew handles its own animation internally via RemovableWrapper
    const newColor = (0, $iW5ND.colorMapping)[color || 'standard'];
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $boXhX.default), {
        ref: ref,
        color: newColor,
        text: normalizedText,
        elemBefore: elemBefore,
        href: href,
        linkComponent: linkComponent,
        testId: testId,
        isRemovable: isRemovable,
        removeButtonLabel: removeButtonLabel,
        onBeforeRemoveAction: onBeforeRemoveActionWithAnalytics,
        maxWidth: maxWidth,
        hasMargin: hasMargin,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $cd27fd1d45136ddb$var$RemovableTag = (0, $7d1b3.markAsTagMotionCapable)(/*#__PURE__*/ (0, $bSJIT.memo)($cd27fd1d45136ddb$var$RemovableTagComponent));
var $cd27fd1d45136ddb$export$2e2bcd8739ae039 = $cd27fd1d45136ddb$var$RemovableTag;

});
parcelRegister("fitdS", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $0eefef506cc2d987$export$53c2b9c37c40e0d8);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $lE3PD = parcelRequire("lE3PD");
const $0eefef506cc2d987$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const methodRef = (0, $lE3PD.useTrackedRef)(method);
    const payloadRef = (0, $lE3PD.useTrackedRef)(payload);
    return (0, $bSJIT.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("iW5ND", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $e06b8f1a19d6fe8b$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $e06b8f1a19d6fe8b$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("1Fzgn", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $8fac3a26f32f31da$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $8fac3a26f32f31da$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;

});

parcelRegister("7d1b3", function(module, exports) {
$parcel$export(module.exports, "markAsTagMotionCapable", () => $bb7fe209e36eb697$export$88b132e52a65ec37);
const $bb7fe209e36eb697$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $bb7fe209e36eb697$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $bb7fe209e36eb697$var$tagMotionCapability, {
        value: true
    });
    return component;
}

});

parcelRegister("boXhX", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9ea5f3b02f1c769$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v3.0.2 */ /* tag-new.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // Clips tag text during motion and restores ellipsis only when the settled label truncates.

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $4GWyU = parcelRequire("4GWyU");

var $gdUUy = parcelRequire("gdUUy");

var $gXqq0 = parcelRequire("gXqq0");

var $hDkm2 = parcelRequire("hDkm2");

var $iW5ND = parcelRequire("iW5ND");

var $1Fzgn = parcelRequire("1Fzgn");

var $6sTyi = parcelRequire("6sTyi");

var $h7B3M = parcelRequire("h7B3M");

var $gQCb3 = parcelRequire("gQCb3");

var $5Eryg = parcelRequire("5Eryg");

var $7d1b3 = parcelRequire("7d1b3");

var $dHzB9 = parcelRequire("dHzB9");

var $cDeMB = parcelRequire("cDeMB");

var $frT3Z = parcelRequire("frT3Z");

var $etnbT = parcelRequire("etnbT");
const $d9ea5f3b02f1c769$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61 _1rfu1q9c",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $d9ea5f3b02f1c769$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $d9ea5f3b02f1c769$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $d9ea5f3b02f1c769$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const $d9ea5f3b02f1c769$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $d9ea5f3b02f1c769$var$TagNewComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $1Fzgn.getTagText)(text);
    const isMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-labels');
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $etnbT.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $bSJIT.useCallback)(()=>{
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $cDeMB.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $dHzB9.useButtonInteraction)();
    const removeButton = (0, $frT3Z.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const renderTagContent = (tagRef, isEntering = false, isExiting = false, hasEllipsis = null)=>/*#__PURE__*/ (0, $dc70d.jsxs)("span", {
            ...other,
            ref: tagRef,
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- maxWidth is a runtime consumer value
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $9fU1q.default)([
                $d9ea5f3b02f1c769$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $d9ea5f3b02f1c769$var$styles.noMarginStyles,
                $d9ea5f3b02f1c769$var$colorStyles[color],
                $d9ea5f3b02f1c769$var$borderIconFilterStyles.root,
                isLink && $d9ea5f3b02f1c769$var$styles.interactiveBaseStyles,
                isLink && $d9ea5f3b02f1c769$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $d9ea5f3b02f1c769$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $d9ea5f3b02f1c769$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $d9ea5f3b02f1c769$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $d9ea5f3b02f1c769$var$styles.interactiveHoverStyles,
                isRemovable && $d9ea5f3b02f1c769$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $d9ea5f3b02f1c769$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $d9ea5f3b02f1c769$var$styles.trailingMetricEndPadding
            ]),
            children: [
                /*#__PURE__*/ (0, $dc70d.jsxs)((0, $6sTyi.LinkWrapper), {
                    isLink: isLink,
                    href: href,
                    LinkComponent: LinkComponent,
                    testId: testId,
                    linkHandlers: linkHandlers,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $gQCb3.default), {
                            colorKey: color,
                            swatchBefore: swatchBefore,
                            swatchBeforeLabel: swatchBeforeLabel,
                            swatchBeforeRole: swatchBeforeRole
                        }),
                        elemBefore && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            className: (0, $9fU1q.default)([
                                $d9ea5f3b02f1c769$var$styles.beforeStyles
                            ]),
                            children: elemBefore
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            "data-tag-text": true,
                            className: (0, $9fU1q.default)([
                                $d9ea5f3b02f1c769$var$styles.textStyles,
                                hasEllipsis === false ? $d9ea5f3b02f1c769$var$styles.textClip : $d9ea5f3b02f1c769$var$styles.textEllipsis
                            ]),
                            children: normalizedText
                        }),
                        trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            "data-testid": testId && `${testId}--metric`,
                            className: (0, $9fU1q.default)([
                                $d9ea5f3b02f1c769$var$styles.trailingMetric
                            ]),
                            children: trailingMetric
                        })
                    ]
                }),
                removeButton && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: (0, $9fU1q.default)([
                        $d9ea5f3b02f1c769$var$styles.afterStyles,
                        isMotionEnabled && $d9ea5f3b02f1c769$var$styles.afterMotionStyles
                    ]),
                    children: !isExiting && removeButton
                })
            ]
        });
    if (isMotionEnabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Eryg.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status,
        children: ({ hasEllipsis: hasEllipsis, isEntering: isEntering, isExiting: isExiting, ref: motionRef })=>renderTagContent(motionRef, isEntering, isExiting, hasEllipsis)
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h7B3M.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: renderTagContent(ref)
    });
});
const $d9ea5f3b02f1c769$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $iW5ND.colorMapping)[color] || 'gray';
    const isMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $gXqq0.Pressable), {
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $14TCm.cx)($d9ea5f3b02f1c769$var$styles.baseStyles, !hasMargin && $d9ea5f3b02f1c769$var$styles.noMarginStyles, $d9ea5f3b02f1c769$var$colorStyles[resolvedColor], $d9ea5f3b02f1c769$var$borderIconFilterStyles.root, $d9ea5f3b02f1c769$var$dropdownStyles.interactive, $d9ea5f3b02f1c769$var$styles.focusRingStyles, $d9ea5f3b02f1c769$var$borderIconInteractiveFilterStyles.root, isSelected && $d9ea5f3b02f1c769$var$dropdownStyles.selected, isMotionEnabled && $d9ea5f3b02f1c769$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $d9ea5f3b02f1c769$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
                className: (0, $9fU1q.default)([
                    $d9ea5f3b02f1c769$var$dropdownStyles.content,
                    isMotionEnabled && $d9ea5f3b02f1c769$var$dropdownStyles.loadingMotion,
                    isLoading && $d9ea5f3b02f1c769$var$dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $gQCb3.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore,
                        swatchBeforeLabel: swatchBeforeLabel,
                        swatchBeforeRole: swatchBeforeRole
                    }),
                    elemBefore && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                        className: (0, $9fU1q.default)([
                            $d9ea5f3b02f1c769$var$styles.beforeStyles,
                            isSelected && $d9ea5f3b02f1c769$var$styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $9fU1q.default)([
                            $d9ea5f3b02f1c769$var$styles.textStyles,
                            $d9ea5f3b02f1c769$var$styles.textEllipsis,
                            isSelected && $d9ea5f3b02f1c769$var$styles.textStylesSelected
                        ]),
                        children: (0, $1Fzgn.getTagText)(text)
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $9fU1q.default)([
                            $d9ea5f3b02f1c769$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    }),
                    hasChevron && /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && `${testId}--chevron`
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                className: (0, $9fU1q.default)([
                    $d9ea5f3b02f1c769$var$dropdownStyles.loadingOverlay,
                    isMotionEnabled && $d9ea5f3b02f1c769$var$dropdownStyles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
});
/**
 * __Tag new__
 */ const $d9ea5f3b02f1c769$var$TagNew = (0, $7d1b3.markAsTagMotionCapable)(/*#__PURE__*/ (0, $bSJIT.memo)($d9ea5f3b02f1c769$var$TagNewComponent));
var $d9ea5f3b02f1c769$export$2e2bcd8739ae039 = $d9ea5f3b02f1c769$var$TagNew;

});
parcelRegister("6sTyi", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $1c87d0bbcb3dd9c2$export$ce4b6a469c26f53f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
function $1c87d0bbcb3dd9c2$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $dc70d.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: children
    });
}

});

parcelRegister("h7B3M", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $587b96370710af6c$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jvbf5 = parcelRequire("jvbf5");

var $kPiAD = parcelRequire("kPiAD");

var $i41vP = parcelRequire("i41vP");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const $587b96370710af6c$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $587b96370710af6c$var$motionWrapperStyles = null;
function $587b96370710af6c$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
        children: !(status === (0, $i41vP.TagStatus).Removed) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kPiAD.default), {
            onFinish: onShrinkOutExitComplete ? (phase)=>{
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: (motion)=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    ref: motion.ref,
                    className: (0, $9fU1q.default)([
                        "_1e0c116y"
                    ]),
                    children: children
                })
        }, $587b96370710af6c$var$removableShrinkOutChildKey)
    });
    return children;
}

});
parcelRegister("kPiAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $881be7153b7e086a$export$2e2bcd8739ae039);

var $lj4Nn = parcelRequire("lj4Nn");

var $iWZGm = parcelRequire("iWZGm");

var $1V8O7 = parcelRequire("1V8O7");

var $4Ajbl = parcelRequire("4Ajbl");

var $e1fGp = parcelRequire("e1fGp");

var $1QkMl = parcelRequire("1QkMl");

var $8Mgn9 = parcelRequire("8Mgn9");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $881be7153b7e086a$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $1V8O7.useElementRef)();
    const exiting = (0, $8Mgn9.useExitingPersistence)();
    const requestAnimationFrame = (0, $e1fGp.useRequestAnimationFrame)();
    const setTimeout = (0, $1QkMl.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $4Ajbl.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $iWZGm.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $lj4Nn.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $lj4Nn.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $881be7153b7e086a$export$2e2bcd8739ae039 = $881be7153b7e086a$var$ShrinkOut;

});

parcelRegister("i41vP", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $ef770b7a43cec54a$export$74452314b63acabc);
// Tag status enum
var $ef770b7a43cec54a$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("gQCb3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fadb9c67e0478bc$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $0fadb9c67e0478bc$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $0fadb9c67e0478bc$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $0fadb9c67e0478bc$export$2e2bcd8739ae039({ colorKey: colorKey, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...swatchBeforeLabel && swatchBeforeRole ? {
            'aria-label': swatchBeforeLabel,
            role: swatchBeforeRole
        } : {},
        className: (0, $9fU1q.default)([
            $0fadb9c67e0478bc$var$tagSwatchBeforeStyles.swatch,
            $0fadb9c67e0478bc$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...swatchBeforeLabel && swatchBeforeRole ? {
            'aria-label': swatchBeforeLabel,
            role: swatchBeforeRole
        } : {},
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $9fU1q.default)([
            $0fadb9c67e0478bc$var$tagSwatchBeforeStyles.swatch
        ])
    });
}

});

parcelRegister("5Eryg", function(module, exports) {
$parcel$export(module.exports, "TagMotion", () => $abd62d8b680318d2$export$6adae1772ccf137c);
/* tag-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Measures settled truncation in onStart while useMotion drives each width animation phase.

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fGbV9 = parcelRequire("fGbV9");

var $lvHAN = parcelRequire("lvHAN");

var $jvbf5 = parcelRequire("jvbf5");

var $8Mgn9 = parcelRequire("8Mgn9");

var $i41vP = parcelRequire("i41vP");
const $abd62d8b680318d2$var$tagMotionKey = 'atlaskit-tag-motion';
const $abd62d8b680318d2$var$motionWrapperStyles = {
    root: "_1reo15vq _18m915vq _1e0c1n7u _yv0ei47z",
    entering: "_y44vkz8f",
    exiting: "_y44v1rag",
    reducedMotion: "_1bumglyw"
};
const $abd62d8b680318d2$var$motionContentStyles = {
    root: "_1rjc1b66 _18zr1b66 _1e0c1txw _1ul9idpf"
};
function $abd62d8b680318d2$var$TagMotionContent({ children: children, forwardedRef: forwardedRef, hasMargin: hasMargin, onExitComplete: onExitComplete }) {
    const [motionPhase, setMotionPhase] = (0, $bSJIT.useState)(null);
    const [hasEllipsis, setHasEllipsis] = (0, $bSJIT.useState)(null);
    const motionElementRef = (0, $bSJIT.useRef)(null);
    const { ref: motionRef, state: state } = (0, $lvHAN.useMotion)({
        onStart: (phase)=>{
            if (motionElementRef.current) {
                const motionElement = motionElementRef.current;
                const inlineAnimation = motionElement.style.animation;
                motionElement.style.animation = 'none';
                const textElement = motionElement.querySelector('[data-tag-text]');
                setHasEllipsis(Boolean(textElement && textElement.scrollWidth > textElement.clientWidth));
                motionElement.style.animation = inlineAnimation;
            }
            setMotionPhase(phase);
        },
        onFinish: (phase)=>{
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    });
    const mergedMotionRef = (0, $bSJIT.useMemo)(()=>(0, $fGbV9.default)([
            motionElementRef,
            motionRef
        ]), [
        motionRef
    ]);
    const onAnimationEnd = (0, $bSJIT.useCallback)((event)=>{
        if (event.target === event.currentTarget) setMotionPhase(null);
    }, []);
    const activeMotionPhase = state === 'entering' || state === 'exiting' ? state : motionPhase;
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ref: mergedMotionRef,
        onAnimationEnd: onAnimationEnd,
        className: (0, $9fU1q.default)([
            $abd62d8b680318d2$var$motionWrapperStyles.root,
            activeMotionPhase === 'entering' && $abd62d8b680318d2$var$motionWrapperStyles.entering,
            activeMotionPhase === 'exiting' && $abd62d8b680318d2$var$motionWrapperStyles.exiting,
            $abd62d8b680318d2$var$motionWrapperStyles.reducedMotion
        ]),
        children: hasMargin ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                $abd62d8b680318d2$var$motionContentStyles.root
            ]),
            children: children({
                hasEllipsis: hasEllipsis,
                isEntering: activeMotionPhase === 'entering',
                isExiting: activeMotionPhase === 'exiting',
                ref: forwardedRef
            })
        }) : children({
            hasEllipsis: hasEllipsis,
            isEntering: activeMotionPhase === 'entering',
            isExiting: activeMotionPhase === 'exiting',
            ref: forwardedRef
        })
    });
}
function $abd62d8b680318d2$export$6adae1772ccf137c({ children: children, forwardedRef: forwardedRef, hasMargin: hasMargin, onExitComplete: onExitComplete, status: status }) {
    const outerPresence = (0, $8Mgn9.useExitingPersistence)();
    const isRemoved = status === (0, $i41vP.TagStatus).Removed || outerPresence.isExiting;
    const shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    const latestExitState = (0, $bSJIT.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    const onMotionExitComplete = (0, $bSJIT.useCallback)(()=>{
        const latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $i41vP.TagStatus).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
        appear: shouldAppear,
        children: !isRemoved && /*#__PURE__*/ (0, $dc70d.jsx)($abd62d8b680318d2$var$TagMotionContent, {
            forwardedRef: forwardedRef,
            hasMargin: hasMargin,
            onExitComplete: onMotionExitComplete,
            children: children
        }, $abd62d8b680318d2$var$tagMotionKey)
    });
}

});

parcelRegister("dHzB9", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $76f702efebbf254b$export$84acd183858d8235);

var $bSJIT = parcelRequire("bSJIT");
function $76f702efebbf254b$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $bSJIT.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $bSJIT.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $bSJIT.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $bSJIT.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $bSJIT.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $bSJIT.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $bSJIT.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("cDeMB", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $b6320aedd80cd083$export$dcf14c9974fe2767);

var $9Rfip = parcelRequire("9Rfip");
function $b6320aedd80cd083$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $9Rfip.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("frT3Z", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $98438565f1e0e930$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $i1aZU = parcelRequire("i1aZU");
function $98438565f1e0e930$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $bSJIT.useCallback)(()=>{
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $bSJIT.useCallback)(()=>{
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $bSJIT.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $i1aZU.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("i1aZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $210db9d16ab97a5f$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v3.0.2 */ /* remove-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $9dYEz = parcelRequire("9dYEz");

var $gXqq0 = parcelRequire("gXqq0");
const $210db9d16ab97a5f$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const $210db9d16ab97a5f$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
        xcss: (0, $jDsoo.cx)($210db9d16ab97a5f$var$removeButtonStyles.root, shape === 'circle' && $210db9d16ab97a5f$var$removeButtonStyles.circle, $210db9d16ab97a5f$var$removeButtonStyles.newIcon, $210db9d16ab97a5f$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$210db9d16ab97a5f$export$2e2bcd8739ae039 = $210db9d16ab97a5f$var$RemoveButton;

});


parcelRegister("etnbT", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $12b688085073354f$export$f26019543e9f862f);

var $bSJIT = parcelRequire("bSJIT");

var $ce6yo = parcelRequire("ce6yo");

var $i41vP = parcelRequire("i41vP");
function $12b688085073354f$export$f26019543e9f862f(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $bSJIT.useState)((0, $i41vP.TagStatus).Showing);
    const handleRemoveRequest = (0, $bSJIT.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $ce6yo.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $i41vP.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $bSJIT.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $bSJIT.useCallback)(()=>setStatus((0, $i41vP.TagStatus).Removing), []);
    const showingTag = (0, $bSJIT.useCallback)(()=>setStatus((0, $i41vP.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("ce6yo", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $c8ee54f174faaa98$export$279e7025ed114474);
const $c8ee54f174faaa98$export$279e7025ed114474 = ()=>true;

});




parcelRegister("gORfN", function(module, exports) {
$parcel$export(module.exports, "useSelectGetStyles", () => $a0d4cfa2dbb3b1f1$export$2a533455c10aa11f);
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $2NvCU = parcelRequire("2NvCU");
const $a0d4cfa2dbb3b1f1$export$2a533455c10aa11f = ()=>(0, $bSJIT.useContext)((0, $2NvCU.SelectGetStylesContext));

});
parcelRegister("2NvCU", function(module, exports) {
$parcel$export(module.exports, "SelectGetStylesContext", () => $56ad70d3918d997d$export$50727c0a52da4015);
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $bSJIT = parcelRequire("bSJIT");
const $56ad70d3918d997d$export$50727c0a52da4015 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);

});


parcelRegister("altE3", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $81e6a24c7654c94f$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value-label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");
const $81e6a24c7654c94f$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $81e6a24c7654c94f$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $81e6a24c7654c94f$var$multiValueLabelStyles.root,
            isDisabled && $81e6a24c7654c94f$var$multiValueLabelStyles.disabled,
            hasEllipsis && $81e6a24c7654c94f$var$multiValueLabelStyles.ellipsis,
            (0, $14TCm.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};

});

parcelRegister("cBTlW", function(module, exports) {
$parcel$export(module.exports, "default", () => $80c7392cf95d8d84$export$2e2bcd8739ae039);
/* multi-value-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Reflows any multi-value renderer with shared label motion and optional settled truncation.

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fGbV9 = parcelRequire("fGbV9");

var $lvHAN = parcelRequire("lvHAN");
const $80c7392cf95d8d84$var$motionWrapperStyles = {
    root: "_1reo15vq _18m915vq _1e0c1n7u _yv0ei47z",
    entering: "_y44vkz8f",
    exiting: "_y44v1rag",
    reducedMotion: "_1bumglyw"
};
function $80c7392cf95d8d84$export$2e2bcd8739ae039({ children: children, onMotionFinish: onMotionFinish, shouldMeasureTruncation: shouldMeasureTruncation = false }) {
    const truncationElementRef = (0, $bSJIT.useRef)(null);
    const motionElementRef = (0, $bSJIT.useRef)(null);
    const [hasEllipsis, setHasEllipsis] = (0, $bSJIT.useState)(false);
    const updateMultiValueTruncation = (0, $bSJIT.useCallback)(()=>{
        const label = truncationElementRef.current;
        const motionElement = motionElementRef.current;
        if (label && motionElement) {
            const inlineAnimation = motionElement.style.animation;
            motionElement.style.animation = 'none';
            setHasEllipsis(label.scrollWidth > label.clientWidth);
            motionElement.style.animation = inlineAnimation;
        }
    }, []);
    const truncationRef = (0, $bSJIT.useCallback)((node)=>{
        truncationElementRef.current = node;
    }, []);
    const { ref: motionRef, state: state } = (0, $lvHAN.useMotion)({
        onStart: shouldMeasureTruncation ? updateMultiValueTruncation : undefined,
        onFinish: (motionState)=>{
            if (motionState === 'exiting') onMotionFinish === null || onMotionFinish === void 0 || onMotionFinish();
        }
    });
    const mergedMotionRef = (0, $bSJIT.useMemo)(()=>(0, $fGbV9.default)([
            motionElementRef,
            motionRef
        ]), [
        motionRef
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: mergedMotionRef,
        className: (0, $9fU1q.default)([
            $80c7392cf95d8d84$var$motionWrapperStyles.root,
            state === 'entering' && $80c7392cf95d8d84$var$motionWrapperStyles.entering,
            state === 'exiting' && $80c7392cf95d8d84$var$motionWrapperStyles.exiting,
            $80c7392cf95d8d84$var$motionWrapperStyles.reducedMotion
        ]),
        children: children({
            hasEllipsis: hasEllipsis,
            motionState: state,
            truncationRef: truncationRef
        })
    });
}

});


parcelRegister("9OZzn", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $3424cce7d24c44b7$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value-remove.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $9dYEz = parcelRequire("9dYEz");
const $3424cce7d24c44b7$var$disabledStyles = null;
const $3424cce7d24c44b7$var$enabledStyles = null;
const $3424cce7d24c44b7$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $3424cce7d24c44b7$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $3424cce7d24c44b7$var$multiValueRemoveStyles.root,
            isFocused && $3424cce7d24c44b7$var$multiValueRemoveStyles.focused,
            (0, $14TCm.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $9fU1q.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}

});

parcelRegister("6meWM", function(module, exports) {
$parcel$export(module.exports, "default", () => $471b052f9c597337$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v3.0.2 */ /* option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $gdUUy = parcelRequire("gdUUy");

var $bWEq6 = parcelRequire("bWEq6");
const $471b052f9c597337$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    finesseFocused: "_16qsglyw _112eglyw",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
const $471b052f9c597337$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $471b052f9c597337$var$optionStyles.root,
            !isDisabled && !isSelected && $471b052f9c597337$var$optionStyles.motion,
            isFocused && $471b052f9c597337$var$optionStyles.focused,
            isFocused && !isSelected && (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $471b052f9c597337$var$optionStyles.finesseFocused,
            isSelected && $471b052f9c597337$var$optionStyles.selected,
            isFocused && isSelected && $471b052f9c597337$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && $471b052f9c597337$var$optionStyles.motionSelected,
            isDisabled && $471b052f9c597337$var$optionStyles.disabled,
            (0, $14TCm.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$471b052f9c597337$export$2e2bcd8739ae039 = $471b052f9c597337$var$Option;

});

parcelRegister("b95AW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ddb63a94200fbf3$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* placeholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $gdUUy = parcelRequire("gdUUy");

var $bWEq6 = parcelRequire("bWEq6");
const $4ddb63a94200fbf3$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx",
    finesse: "_syazazsu"
};
const $4ddb63a94200fbf3$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $4ddb63a94200fbf3$var$placeholderStyles.root,
            (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $4ddb63a94200fbf3$var$placeholderStyles.finesse,
            isDisabled && $4ddb63a94200fbf3$var$placeholderStyles.disabled,
            (0, $14TCm.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ddb63a94200fbf3$export$2e2bcd8739ae039 = $4ddb63a94200fbf3$var$Placeholder;

});

parcelRegister("8ztgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $12688ff5d52fe425$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v3.0.2 */ /* single-value.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $bWEq6 = parcelRequire("bWEq6");
const $12688ff5d52fe425$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $12688ff5d52fe425$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $bWEq6.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $9fU1q.default)([
            $12688ff5d52fe425$var$styles.root,
            isDisabled && $12688ff5d52fe425$var$styles.disalbed,
            (0, $14TCm.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$12688ff5d52fe425$export$2e2bcd8739ae039 = $12688ff5d52fe425$var$SingleValue;

});


parcelRegister("98w3H", function(module, exports) {
$parcel$export(module.exports, "default", () => $91bc1433ea96a279$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hzFIQ = parcelRequire("hzFIQ");

var $hkLEY = parcelRequire("hkLEY");

var $4dIh5 = parcelRequire("4dIh5");

var $ibevZ = parcelRequire("ibevZ");
const $91bc1433ea96a279$var$ErrorMessage = ({ onRetry: onRetry })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = (0, $bSJIT.useCallback)(()=>{
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledBox), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $ibevZ.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $ibevZ.default).retryMessage)));
};
var $91bc1433ea96a279$export$2e2bcd8739ae039 = $91bc1433ea96a279$var$ErrorMessage;

});
parcelRegister("4dIh5", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $bb9b02015267945b$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $bb9b02015267945b$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $bb9b02015267945b$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $bb9b02015267945b$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $bb9b02015267945b$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $bb9b02015267945b$export$6833d6d22987ee7f);
$parcel$export(module.exports, "StyledInvalidCheckboxOption", () => $bb9b02015267945b$export$e786733cafde97b9);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// Uses @compiled/react because descendant/child selectors and !important are not supported by the strict @atlaskit/css API.
const $bb9b02015267945b$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    text: "_11c81qyo _19pku2gc",
    control: "_16qs130s _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    closeIconWrapper: "_80omtlke _syaz1rpy _f8pjazsu _30l3azsu"
};
const $bb9b02015267945b$var$displayWrapperStyles = {
    shown: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
const $bb9b02015267945b$var$styledBoxStyles = {
    box: "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1f4z _1bah1h6o"
};
const $bb9b02015267945b$var$styledBoxIconStyles = {
    boxIcon: "_w8l5achg _1752achg"
};
const $bb9b02015267945b$var$styledInvalidCheckboxOptionStyles = {
    invalidCheckboxOption: "_bfhk1gly _1e0c1txw _2lx2vrvc _4cvr1h6o _u5f3u2gc _w1w3jdj5"
};
const $bb9b02015267945b$export$30c615a45297e297 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$styles.dropdownIndicatorWrapper
        ])
    }, children);
const $bb9b02015267945b$export$d675f139b342d51a = ({ height: height, iconSize: iconSize, children: children, style: style, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: {
            '--paginated-picker-box-height': `${height || 128}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- runtime-only custom property derived from the iconSize prop
            ...iconSize ? {
                '--paginated-picker-icon-size': `${iconSize}px`
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- forwards a caller-provided runtime style object
            ...style
        },
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$styledBoxStyles.box,
            iconSize && ""
        ])
    }, children);
const $bb9b02015267945b$export$31ea92f3997410dd = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$styles.text
        ])
    }, children);
const $bb9b02015267945b$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$styles.control
        ])
    }, children));
const $bb9b02015267945b$export$94756becb802e330 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$styles.closeIconWrapper
        ])
    }, children);
const $bb9b02015267945b$export$6833d6d22987ee7f = ({ displayFlag: displayFlag, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$displayWrapperStyles[displayFlag ? 'shown' : 'hidden']
        ])
    }, children);
const $bb9b02015267945b$export$e786733cafde97b9 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $bb9b02015267945b$var$styledInvalidCheckboxOptionStyles.invalidCheckboxOption
        ])
    }, children);

});

parcelRegister("ibevZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecdedb9ca4f291f8$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ecdedb9ca4f291f8$var$message = (0, $f0Pt4.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});
var $ecdedb9ca4f291f8$export$2e2bcd8739ae039 = $ecdedb9ca4f291f8$var$message;

});


parcelRegister("fQXuv", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $56fbecffe25ce2ad$export$e928a71d039d3102);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hDkm2 = parcelRequire("hDkm2");

var $4dIh5 = parcelRequire("4dIh5");

var $gzICg = parcelRequire("gzICg");
const $56fbecffe25ce2ad$export$e928a71d039d3102 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $gzICg.default).loadingMessage)));

});
parcelRegister("gzICg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0adb92e7a8427fa5$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $0adb92e7a8427fa5$var$message = (0, $f0Pt4.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});
var $0adb92e7a8427fa5$export$2e2bcd8739ae039 = $0adb92e7a8427fa5$var$message;

});


parcelRegister("b54yp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1959c5af6e0b1aa4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hzFIQ = parcelRequire("hzFIQ");

var $gJuQE = parcelRequire("gJuQE");
const $1959c5af6e0b1aa4$var$ShowMoreButton = ({ onShowMore: onShowMore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $gJuQE.default).showMoreButtonText));
var $1959c5af6e0b1aa4$export$2e2bcd8739ae039 = $1959c5af6e0b1aa4$var$ShowMoreButton;

});
parcelRegister("gJuQE", function(module, exports) {
$parcel$export(module.exports, "default", () => $dae7d113d3557249$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $dae7d113d3557249$var$message = (0, $f0Pt4.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});
var $dae7d113d3557249$export$2e2bcd8739ae039 = $dae7d113d3557249$var$message;

});


parcelRegister("ih64Y", function(module, exports) {
$parcel$export(module.exports, "LoadingWrapper", () => $cfc622fd13f156e2$export$43a792a870d28db2);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $cfc622fd13f156e2$var$styles = {
    loadingWrapper: "_1e0c1txw _1bah1h6o _19pk1b66 _otyr1b66"
};
const $cfc622fd13f156e2$export$43a792a870d28db2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $cfc622fd13f156e2$var$styles.loadingWrapper
        ])
    }, children);

});


parcelRegister("8Il01", function(module, exports) {
$parcel$export(module.exports, "PaginationDetails", () => $83fc4956ecd46107$export$33eb0288c0936a84);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $9x8k1 = parcelRequire("9x8k1");

var $k6dok = parcelRequire("k6dok");
const $83fc4956ecd46107$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k6dok.PaginationDetailsStyled), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...totalCount === null ? (0, $9x8k1.default).loadedCount : (0, $9x8k1.default).ofTotalCount,
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    }));
var $83fc4956ecd46107$export$2e2bcd8739ae039 = $83fc4956ecd46107$export$33eb0288c0936a84;

});
parcelRegister("9x8k1", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0432b8bb6ee49bf$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $d0432b8bb6ee49bf$var$message = (0, $f0Pt4.defineMessages)({
    loadedCount: {
        id: 'paginated-picker.async-select.pagination-details.loadedCount',
        defaultMessage: '{itemsCount} results',
        description: 'Shown in a paginated picker footer when the overall total is unknown. itemsCount is the number of results available so far.'
    },
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.'
    }
});
var $d0432b8bb6ee49bf$export$2e2bcd8739ae039 = $d0432b8bb6ee49bf$var$message;

});

parcelRegister("k6dok", function(module, exports) {
$parcel$export(module.exports, "PaginationDetailsStyled", () => $25cc6ed4d1cd4584$export$fff9218028c24180);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $25cc6ed4d1cd4584$var$styles = {
    paginationDetails: "_16jlkb7n _1o9zkb7n _i0dlf1ug _11c8fhey _y3gnusic _19pku2gc _otyru2gc _18u0pxbi _2hwxpxbi _syaz1rpy"
};
const $25cc6ed4d1cd4584$export$fff9218028c24180 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $25cc6ed4d1cd4584$var$styles.paginationDetails
        ])
    }, children);

});


parcelRegister("l0ssr", function(module, exports) {
$parcel$export(module.exports, "selectComponents", () => $d92b8f437abb2dd8$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "LocalBaseSelect", () => $d92b8f437abb2dd8$export$51cc13ac81e51592);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $eOzrv = parcelRequire("eOzrv");

var $fC42J = parcelRequire("fC42J");

var $kRsoF = parcelRequire("kRsoF");

var $8gPkU = parcelRequire("8gPkU");

var $24oFU = parcelRequire("24oFU");

var $jrfao = parcelRequire("jrfao");

var $840Mw = parcelRequire("840Mw");
const $d92b8f437abb2dd8$export$c34d65c0f5a1c617 = {
    Control: $kRsoF.Control,
    DropdownIndicator: $8gPkU.DropdownIndicator,
    LoadingIndicator: null,
    Menu: $24oFU.Menu,
    Option: $840Mw.Option
};
const $d92b8f437abb2dd8$var$onIsOptionDisabled = (option)=>'error' in option ? !!option.error : false;
const $d92b8f437abb2dd8$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ onFilterOption: onFilterOption, placeholder: placeholder, ...restProps }, ref)=>{
    const intl = (0, $4vLTk.default)();
    const { ariaLabel: ariaLabelProp, isMulti: isMulti = true, onChange: onChangeProp, onInputChange: onInputChangeProp, inputValue: inputValueProp, value: value } = restProps;
    const effectiveIsMulti = isMulti;
    const [inputValue, setInputValue] = (0, $bSJIT.useState)(inputValueProp || '');
    const onInputChange = (0, $bSJIT.useCallback)((newValue, actionMeta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $fC42J.MetaActions).setValue,
            (0, $fC42J.MetaActions).inputBlur,
            (0, $fC42J.MetaActions).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    const onChange = (0, $bSJIT.useCallback)((newValue, actionMeta)=>{
        // Keep this wrapper unconditional for both modes so hook creation stays stable.
        // In multiselect mode `newValue` is already an array, making this a no-op; in
        // single-select mode Atlaskit returns one option (or null), which we normalize
        // back to the array contract expected by the paginated-filter stack.
        const normalizedNewValue = Array.isArray(newValue) ? newValue : newValue ? [
            newValue
        ] : [];
        onChangeProp === null || onChangeProp === void 0 || onChangeProp(normalizedNewValue, actionMeta);
    }, [
        onChangeProp
    ]);
    const normalizedValue = effectiveIsMulti ? value : Array.isArray(value) ? value[0] ?? null : value ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        ...restProps,
        ref: ref,
        "aria-label": ariaLabelProp || intl.formatMessage((0, $jrfao.default).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: !effectiveIsMulti,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: effectiveIsMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: ()=>intl.formatMessage((0, $jrfao.default).noOptionsMessage),
        // Typescript fix: normalized onChange signature (single/multi) is not directly assignable to Select's onChange type
        onChange: onChange,
        onInputChange: onInputChange,
        isOptionDisabled: $d92b8f437abb2dd8$var$onIsOptionDisabled,
        filterOption: onFilterOption,
        placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $jrfao.default).searchPlaceholder),
        // Typescript fix: normalized value shape (scalar vs array) is not assignable to Select's typed value
        value: normalizedValue
    });
});
$d92b8f437abb2dd8$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';

});
parcelRegister("eOzrv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $25b69ea91891f756$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $jeyHF = parcelRequire("jeyHF");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $11456 = parcelRequire("11456");
const $25b69ea91891f756$var$packageName = undefined;
const $25b69ea91891f756$var$packageVersion = undefined;
const $25b69ea91891f756$var$createAndFireEventOnAtlaskit = (0, $jeyHF.default)('atlaskit');
const $25b69ea91891f756$var$Select = (0, $2usNr.default)({
    componentName: 'select',
    packageName: $25b69ea91891f756$var$packageName,
    packageVersion: $25b69ea91891f756$var$packageVersion
})((0, $kIbto.default)({
    onChange: $25b69ea91891f756$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $25b69ea91891f756$var$packageName,
            packageVersion: $25b69ea91891f756$var$packageVersion
        }
    })
})((0, $11456.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$25b69ea91891f756$export$2e2bcd8739ae039 = $25b69ea91891f756$var$Select;

});
parcelRegister("jeyHF", function(module, exports) {
$parcel$export(module.exports, "default", () => $c75c08e56ff68fe2$export$2e2bcd8739ae039);
var $c75c08e56ff68fe2$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("11456", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $b139e6f1bfc4f34a$export$d1de3b251ccaa8a3);

var $1eJWB = parcelRequire("1eJWB");

var $5dnVg = parcelRequire("5dnVg");
const $b139e6f1bfc4f34a$export$d1de3b251ccaa8a3 = (0, $5dnVg.default)((0, $1eJWB.default));

});
parcelRegister("1eJWB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab11262668a68b6$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $l7tvR = parcelRequire("l7tvR");

var $52QJF = parcelRequire("52QJF");

var $27zHi = parcelRequire("27zHi");
const $bab11262668a68b6$var$AsyncSelect = /*#__PURE__*/ (0, $bSJIT.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $52QJF.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $27zHi.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $l7tvR.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bab11262668a68b6$export$2e2bcd8739ae039 = $bab11262668a68b6$var$AsyncSelect;

});
parcelRegister("l7tvR", function(module, exports) {
$parcel$export(module.exports, "default", () => $18a0cfd812c9c9fe$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v3.0.2 */ // Applies presence motion at the value-list boundary so default and custom values reflow together.

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $2o7MC = parcelRequire("2o7MC");

var $h0umZ = parcelRequire("h0umZ");

var $1OdZP = parcelRequire("1OdZP");

var $jvbf5 = parcelRequire("jvbf5");

var $gdUUy = parcelRequire("gdUUy");

var $kbBdI = parcelRequire("kbBdI");

var $1OOmn = parcelRequire("1OOmn");

var $8WLDf = parcelRequire("8WLDf");

var $lxhcN = parcelRequire("lxhcN");

var $cBTlW = parcelRequire("cBTlW");

var $leUse = parcelRequire("leUse");

var $jctPF = parcelRequire("jctPF");

var $4zzw4 = parcelRequire("4zzw4");

var $7OOeR = parcelRequire("7OOeR");

var $6BfL3 = parcelRequire("6BfL3");

var $biY41 = parcelRequire("biY41");

var $qJSur = parcelRequire("qJSur");

var $a0tSa = parcelRequire("a0tSa");

var $jTft9 = parcelRequire("jTft9");

var $5UoLg = parcelRequire("5UoLg");

var $bvFIr = parcelRequire("bvFIr");

var $fE9ks = parcelRequire("fE9ks");

var $4wI2d = parcelRequire("4wI2d");

var $2NvCU = parcelRequire("2NvCU");

var $b2hbg = parcelRequire("b2hbg");

var $i8kww = parcelRequire("i8kww");

var $8n6aF = parcelRequire("8n6aF");
const $18a0cfd812c9c9fe$var$noop = (0, $1OdZP.default);
function $18a0cfd812c9c9fe$var$notNullish(item) {
    return item != null;
}
function $18a0cfd812c9c9fe$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $4wI2d.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $4wI2d.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $18a0cfd812c9c9fe$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $18a0cfd812c9c9fe$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const $18a0cfd812c9c9fe$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $18a0cfd812c9c9fe$var$elemBeforeCSS = null;
// Matches the duration of `motion.label.exit`; used only if a consumer render path
// unmounts the exiting values before their motion completion callback can run.
const $18a0cfd812c9c9fe$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS = 100;
const $18a0cfd812c9c9fe$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $18a0cfd812c9c9fe$var$isTouchCapable(),
    captureMenuScroll: !$18a0cfd812c9c9fe$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $leUse.createFilter)(),
    formatGroupLabel: (0, $jctPF.formatGroupLabel),
    getOptionLabel: (0, $4zzw4.getOptionLabel),
    getOptionValue: (0, $7OOeR.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $8n6aF.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$18a0cfd812c9c9fe$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $18a0cfd812c9c9fe$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $18a0cfd812c9c9fe$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $18a0cfd812c9c9fe$var$isOptionSelected(props, option, selectValue);
    const label = $18a0cfd812c9c9fe$var$getOptionLabel(props, option);
    const value = $18a0cfd812c9c9fe$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $18a0cfd812c9c9fe$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$18a0cfd812c9c9fe$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$18a0cfd812c9c9fe$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $18a0cfd812c9c9fe$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $18a0cfd812c9c9fe$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($18a0cfd812c9c9fe$var$notNullish);
}
function $18a0cfd812c9c9fe$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $18a0cfd812c9c9fe$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $18a0cfd812c9c9fe$var$buildFocusableOptions(props, selectValue) {
    return $18a0cfd812c9c9fe$var$buildFocusableOptionsFromCategorizedOptions($18a0cfd812c9c9fe$var$buildCategorizedOptions(props, selectValue));
}
function $18a0cfd812c9c9fe$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$18a0cfd812c9c9fe$var$shouldHideSelectedOptions(props) || !isSelected) && $18a0cfd812c9c9fe$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $18a0cfd812c9c9fe$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $18a0cfd812c9c9fe$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $18a0cfd812c9c9fe$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    var _focusableOptionsWith;
    const focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find((option)=>option.data === focusedOption)) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
const $18a0cfd812c9c9fe$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $18a0cfd812c9c9fe$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $18a0cfd812c9c9fe$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $18a0cfd812c9c9fe$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $18a0cfd812c9c9fe$var$getOptionValue(props, option);
    return selectValue.some((i)=>$18a0cfd812c9c9fe$var$getOptionValue(props, i) === candidate);
}
function $18a0cfd812c9c9fe$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $18a0cfd812c9c9fe$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $18a0cfd812c9c9fe$var$instanceId = 1;
class $18a0cfd812c9c9fe$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    static #_ = this.defaultProps = $18a0cfd812c9c9fe$export$9c21a3269931e1e6;
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null,
            isMultiValueExiting: false,
            hasCompletedMultiValueExit: false
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.openAfterClick = null, this.scrollToFocusedOptionOnUpdate = false, this.multiValueExitFallbackTimeout = null, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, $gdUUy.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, this.onMultiValueMotionFinish = ()=>{
            if (this.state.isMultiValueExiting) this.setState({
                isMultiValueExiting: false,
                hasCompletedMultiValueExit: true,
                selectValue: []
            });
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onControlClick = ()=>{
            const focusOption = this.openAfterClick;
            this.openAfterClick = null;
            if (focusOption && !this.props.menuIsOpen) this.openMenu(focusOption);
        }, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $jTft9.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $jTft9.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $b2hbg.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $b2hbg.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $i8kww.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $i8kww.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $i8kww.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $18a0cfd812c9c9fe$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $18a0cfd812c9c9fe$var$buildFocusableOptionsWithIds($18a0cfd812c9c9fe$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $6BfL3.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $18a0cfd812c9c9fe$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $18a0cfd812c9c9fe$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $18a0cfd812c9c9fe$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>{
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        }, this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $kbBdI.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$18a0cfd812c9c9fe$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$18a0cfd812c9c9fe$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterClick('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterClick('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $qJSur.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer until
                // click. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterClick('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $gdUUy.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $18a0cfd812c9c9fe$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if ((0, $gdUUy.fg)('platform-dst-top-layer')) {
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            return;
                        }
                        if (isClearable && escapeClearsValue) {
                            this.clearValue();
                            return;
                        }
                        // With no open menu, leave native dismissal of containing popovers alone.
                        return;
                    }
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleMenuCloseSignal = (args)=>{
            if ((args === null || args === void 0 ? void 0 : args.reason) === 'escape') this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$18a0cfd812c9c9fe$var$instanceId);
        this.state.selectValue = (0, $biY41.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $18a0cfd812c9c9fe$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $biY41.cleanValue)(value);
        let isTagMotionEnabled = false;
        if (isMulti) {
            const ffTagMotion = (0, $gdUUy.fg)('platform-dst-motion-uplift-labels');
            isTagMotionEnabled = ffTagMotion;
        }
        const hasCompletedMultiValueExit = selectValue.length > 0 ? false : state.hasCompletedMultiValueExit;
        const isMultiValueExiting = isTagMotionEnabled && selectValue.length === 0 && !hasCompletedMultiValueExit && (state.isMultiValueExiting || state.selectValue.length > 0 && value !== (prevProps === null || prevProps === void 0 ? void 0 : prevProps.value));
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $18a0cfd812c9c9fe$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $18a0cfd812c9c9fe$var$buildFocusableOptionsWithIds($18a0cfd812c9c9fe$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $18a0cfd812c9c9fe$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $18a0cfd812c9c9fe$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $18a0cfd812c9c9fe$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $i8kww.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus,
            isMultiValueExiting: isMultiValueExiting,
            hasCompletedMultiValueExit: hasCompletedMultiValueExit
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $18a0cfd812c9c9fe$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps, prevState) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        // A consumer can cause the value subtree to unmount while the final tags are exiting.
        // The fallback keeps the placeholder out for the exit duration, then restores it even
        // when the individual MultiValue completion callback cannot fire.
        if (!prevState.isMultiValueExiting && this.state.isMultiValueExiting) this.multiValueExitFallbackTimeout = setTimeout(()=>{
            this.onMultiValueMotionFinish();
        }, $18a0cfd812c9c9fe$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS);
        else if (prevState.isMultiValueExiting && !this.state.isMultiValueExiting) {
            if (this.multiValueExitFallbackTimeout) {
                clearTimeout(this.multiValueExitFallbackTimeout);
                this.multiValueExitFallbackTimeout = null;
            }
        }
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $18a0cfd812c9c9fe$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
        if (this.multiValueExitFallbackTimeout) {
            clearTimeout(this.multiValueExitFallbackTimeout);
            this.multiValueExitFallbackTimeout = null;
        }
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open until the in-flight click completes.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss can close the menu during the opening
   * gesture. Today only the top-layer path needs it.
   */ shouldDeferOpenUntilClick() {
        return (0, $gdUUy.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current click, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser performs light-dismiss during the pointer gesture. Deferring
   * until `click` ensures light-dismiss has completed before the popover opens.
   * Off the top-layer path we open synchronously as before.
   */ openMenuAfterClick(focusOption) {
        if (!this.shouldDeferOpenUntilClick()) {
            this.openMenu(focusOption);
            return;
        }
        this.openAfterClick = focusOption;
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $h0umZ.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            var _this$inputRef;
            (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) {
                    var _this$inputRef2;
                    (_this$inputRef2 = this.inputRef) === null || _this$inputRef2 === void 0 || _this$inputRef2.setAttribute('aria-label', normalizedLabel);
                } else {
                    var _this$inputRef3;
                    (_this$inputRef3 = this.inputRef) === null || _this$inputRef3 === void 0 || _this$inputRef3.removeAttribute('aria-label');
                }
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options === null || options === void 0 ? void 0 : options.find((option)=>{
            var _groupCandidate$optio;
            const groupCandidate = option;
            return ((_groupCandidate$optio = groupCandidate.options) === null || _groupCandidate$optio === void 0 ? void 0 : _groupCandidate$optio.some(isOptionFocused)) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = (groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) ?? 0;
            const totalLength = options === null || options === void 0 ? void 0 : options.reduce((acc, currentGroup)=>{
                var _group$options;
                const group = currentGroup;
                acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options === null || options === void 0 ? void 0 : options.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $18a0cfd812c9c9fe$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $18a0cfd812c9c9fe$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $18a0cfd812c9c9fe$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        var _this$props$component;
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option)) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                    className: (0, $9fU1q.default)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const isDisabledA11yFixEnabled = (0, $gdUUy.fg)('platform_dst_select_disabled_a11y_fix');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $gdUUy.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $gdUUy.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            // Using aria-disabled so the element remains in the a11y tree.
            ...isDisabledA11yFixEnabled && {
                'aria-disabled': isDisabled || undefined
            },
            ...this.calculateDescription()
        };
        const effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1OOmn.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $18a0cfd812c9c9fe$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: effectiveTabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $dc70d.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: effectiveTabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const isCustomMultiValue = MultiValue !== (0, $kbBdI.components).MultiValue;
        const customMultiValueOwnsTagMotion = isCustomMultiValue && MultiValue != null && Reflect.get(MultiValue, Symbol.for('@atlaskit/tag/motion-capable')) === true;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        const renderMultiValues = (isMotionEnabled = false)=>selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                const multiValue = /*#__PURE__*/ (0, $bSJIT.createElement)(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    isMotionEnabled: isMotionEnabled && !isCustomMultiValue,
                    onMotionFinish: this.onMultiValueMotionFinish,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        },
                        ...testId && {
                            'data-testid': `${testId}-select--multivalue-${index}-remove`
                        },
                        id: `${this.getElementId('selected-value')}-${index}-remove`
                    },
                    data: opt,
                    innerProps: {
                        ...testId && {
                            'data-testid': `${testId}-select--multivalue-${index}`
                        },
                        id: `${this.getElementId('selected-value')}-${index}`
                    }
                }, this.formatOptionLabel(opt, 'value'));
                if (isMotionEnabled && isCustomMultiValue && !customMultiValueOwnsTagMotion) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cBTlW.default), {
                    onMotionFinish: this.onMultiValueMotionFinish,
                    children: ()=>multiValue
                }, key);
                return multiValue;
            });
        const placeholderElement = inputValue ? null : /*#__PURE__*/ (0, $bSJIT.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) {
            const ffTagMotion = (0, $gdUUy.fg)('platform-dst-motion-uplift-labels');
            const isTagMotionEnabled = ffTagMotion;
            if (isTagMotionEnabled) return /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jvbf5.default), {
                        children: controlShouldRenderValue ? renderMultiValues(true) : null
                    }),
                    (!this.hasValue() || !controlShouldRenderValue) && !this.state.isMultiValueExiting && placeholderElement
                ]
            });
            if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
            return renderMultiValues();
        }
        if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $dc70d.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value'),
                // Hide from AT so the value is only announced via aria-describedby on the combobox.
                ...isDisabled && (0, $gdUUy.fg)('platform_dst_select_disabled_a11y_fix') && {
                    'aria-hidden': true
                }
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $dc70d.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $dc70d.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
            // children only, keeping the voice-control button visible to AT.
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $dc70d.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, additionalInsideElementRefs: additionalInsideElementRefs, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $bSJIT.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $bSJIT.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $dc70d.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $dc70d.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $dc70d.jsx)((0, $lxhcN.default), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $dc70d.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fE9ks.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>{
                            var _this$inputRef4, _this$inputRef5;
                            return /*#__PURE__*/ (0, $dc70d.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': ((_this$inputRef4 = this.inputRef) === null || _this$inputRef4 === void 0 ? void 0 : _this$inputRef4.id) || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $h0umZ.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': ((_this$inputRef5 = this.inputRef) === null || _this$inputRef5 === void 0 ? void 0 : _this$inputRef5.id) || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            });
                        }
                    })
                })
        });
        // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, $gdUUy.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
        // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, $gdUUy.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, $dc70d.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            additionalInsideElementRefs: additionalInsideElementRefs,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        });
        // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, $gdUUy.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a0tSa.MenuPortalCloseContext).Provider, {
            value: this.handleMenuCloseSignal,
            children: menuPortal
        });
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bvFIr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $dc70d.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8WLDf.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2NvCU.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, $dc70d.jsxs)(SelectContainer, {
                ...commonProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown,
                    ...testId && {
                        'data-testid': testId && `${testId}-select--container`
                    }
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, $dc70d.jsxs)(Control, {
                        ...commonProps,
                        innerRef: this.getControlRef,
                        innerProps: {
                            onMouseDown: this.onControlMouseDown,
                            onClick: this.onControlClick,
                            onTouchEnd: this.onControlTouchEnd,
                            ...testId && {
                                'data-testid': `${testId}-select--control`
                            }
                        },
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsxs)(ValueContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                hasValue: commonProps.hasValue || this.state.isMultiValueExiting,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--value-container`
                                    },
                                    ...commonProps.isMulti && commonProps.hasValue && !(0, $2o7MC.isAppleDevice)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }
                                },
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsxs)(IndicatorsContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--indicators-container`
                                    }
                                },
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            })
                        ]
                    }),
                    this.renderMenu(),
                    this.renderFormField(),
                    !(0, $gdUUy.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, $dc70d.jsx)((0, $5UoLg.NotifyOpenLayerObserver), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleMenuCloseSignal
                    })
                ]
            })
        });
    }
}

});
parcelRegister("2o7MC", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $e1391fa262e8123a$export$e1865c3bedcd822b);
function $e1391fa262e8123a$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $e1391fa262e8123a$var$isIPhone() {
    return $e1391fa262e8123a$var$testPlatform(/^iPhone/i);
}
function $e1391fa262e8123a$var$isIPad() {
    return $e1391fa262e8123a$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $e1391fa262e8123a$var$isMac() && navigator.maxTouchPoints > 1;
}
function $e1391fa262e8123a$var$isMac() {
    return $e1391fa262e8123a$var$testPlatform(/^Mac/i);
}
function $e1391fa262e8123a$var$isIOS() {
    return $e1391fa262e8123a$var$isIPhone() || $e1391fa262e8123a$var$isIPad();
}
function $e1391fa262e8123a$export$e1865c3bedcd822b() {
    return $e1391fa262e8123a$var$isMac() || $e1391fa262e8123a$var$isIOS();
}

});

parcelRegister("1OOmn", function(module, exports) {
$parcel$export(module.exports, "default", () => $be8ee97e4ca87f69$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $be8ee97e4ca87f69$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $be8ee97e4ca87f69$var$dummyInputStyles = null;
function $be8ee97e4ca87f69$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $be8ee97e4ca87f69$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $dc70d.jsx)("input", {
        ref: innerRef,
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("8WLDf", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ad3818a9c1e2fa$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7Ngve = parcelRequire("7Ngve");

var $jbuPE = parcelRequire("jbuPE");
const $64ad3818a9c1e2fa$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $bSJIT.useMemo)(()=>({
            ...(0, $7Ngve.defaultAriaLiveMessages),
            ...ariaLiveMessages
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $bSJIT.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $bSJIT.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $jbuPE.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $jbuPE.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$64ad3818a9c1e2fa$export$2e2bcd8739ae039 = $64ad3818a9c1e2fa$var$LiveRegion;

});
parcelRegister("7Ngve", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d69e946650e02b27$export$a7265767c78f9bae);
const $d69e946650e02b27$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("jbuPE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6576d61ba10567b7$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
// Assistive text to describe visual elements. Hidden for sighted users.
const $6576d61ba10567b7$var$styles = null;
const $6576d61ba10567b7$var$A11yText = (props)=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $6576d61ba10567b7$export$2e2bcd8739ae039 = $6576d61ba10567b7$var$A11yText;

});


parcelRegister("lxhcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f6a9d82ee3a6f2d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $gdUUy = parcelRequire("gdUUy");

var $27N0a = parcelRequire("27N0a");
const $1f6a9d82ee3a6f2d$var$noop = (0, $1OdZP.default);
function $1f6a9d82ee3a6f2d$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $1f6a9d82ee3a6f2d$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $1f6a9d82ee3a6f2d$var$normalizedHeight(el) {
    if ($1f6a9d82ee3a6f2d$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $1f6a9d82ee3a6f2d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1f6a9d82ee3a6f2d$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $1f6a9d82ee3a6f2d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1f6a9d82ee3a6f2d$var$getScrollTop(el) {
    if ($1f6a9d82ee3a6f2d$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1f6a9d82ee3a6f2d$var$animatedScrollTo(element, to, duration = 200, callback = $1f6a9d82ee3a6f2d$var$noop) {
    const start = $1f6a9d82ee3a6f2d$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $1f6a9d82ee3a6f2d$var$easeOutCubic(currentTime, start, change, duration);
        $1f6a9d82ee3a6f2d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $1f6a9d82ee3a6f2d$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $1f6a9d82ee3a6f2d$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $1f6a9d82ee3a6f2d$var$normalizedHeight(scrollParent);
    const scrollTop = $1f6a9d82ee3a6f2d$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1f6a9d82ee3a6f2d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $1f6a9d82ee3a6f2d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $1f6a9d82ee3a6f2d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1f6a9d82ee3a6f2d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $1f6a9d82ee3a6f2d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $1f6a9d82ee3a6f2d$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $1f6a9d82ee3a6f2d$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $bSJIT.useContext)((0, $27N0a.PortalPlacementContext)) || {};
    const ref = (0, $bSJIT.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $bSJIT.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $bSJIT.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $bSJIT.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $gdUUy.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $1f6a9d82ee3a6f2d$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $1f6a9d82ee3a6f2d$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
var $1f6a9d82ee3a6f2d$export$2e2bcd8739ae039 = $1f6a9d82ee3a6f2d$var$MenuPlacer;

});

parcelRegister("leUse", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $b3016f3a472e3fda$export$5d81789ff4aeccdf);

var $57l7A = parcelRequire("57l7A");

var $6CvO1 = parcelRequire("6CvO1");
const $b3016f3a472e3fda$var$memoizedStripDiacriticsForInput = (0, $57l7A.default)((0, $6CvO1.stripDiacritics));
const $b3016f3a472e3fda$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $b3016f3a472e3fda$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $b3016f3a472e3fda$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $b3016f3a472e3fda$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $b3016f3a472e3fda$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $b3016f3a472e3fda$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $b3016f3a472e3fda$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $6CvO1.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("6CvO1", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $46c246522cdca389$export$b5bee4b27048330b);
const $46c246522cdca389$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $46c246522cdca389$var$anyDiacritic = new RegExp('[' + $46c246522cdca389$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $46c246522cdca389$var$diacriticToBase = {};
for(let i = 0; i < $46c246522cdca389$var$diacritics.length; i++){
    let diacritic = $46c246522cdca389$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$46c246522cdca389$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $46c246522cdca389$export$b5bee4b27048330b = (str)=>{
    return str.replace($46c246522cdca389$var$anyDiacritic, (match)=>$46c246522cdca389$var$diacriticToBase[match]);
};

});


parcelRegister("jctPF", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $ddd07e0641e4262f$export$f4da216a6ca54656);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $ddd07e0641e4262f$export$f4da216a6ca54656 = (group)=>group.label;

});

parcelRegister("4zzw4", function(module, exports) {
$parcel$export(module.exports, "getOptionLabel", () => $9784e5a683348d73$export$dac6ace3020563ca);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $9784e5a683348d73$export$dac6ace3020563ca = (option)=>option.label;

});

parcelRegister("7OOeR", function(module, exports) {
$parcel$export(module.exports, "getOptionValue", () => $2a8d176da8ec8784$export$40be908210c5a79c);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $2a8d176da8ec8784$export$40be908210c5a79c = (option)=>option.value;

});

parcelRegister("6BfL3", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $bb914797ff62d359$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $bb914797ff62d359$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $bb914797ff62d359$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$bb914797ff62d359$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

});

parcelRegister("biY41", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $8d3106d969b20774$export$33f062f47f21a01);
const $8d3106d969b20774$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("qJSur", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $9c99d895443cc96b$export$d8a62a489b442872);
function $9c99d895443cc96b$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("jTft9", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $c6312f36e8644787$export$d1ca752ec761b95b);
function $c6312f36e8644787$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("5UoLg", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $5a62c8dedbe81739$export$17baa7c95b6ba1b8);

var $6gXOx = parcelRequire("6gXOx");
function $5a62c8dedbe81739$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $6gXOx.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("bvFIr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f400fe3379a2cc0$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $1OdZP = parcelRequire("1OdZP");
const $3f400fe3379a2cc0$var$styles = null;
const $3f400fe3379a2cc0$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $dc70d.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $1OdZP.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f400fe3379a2cc0$export$2e2bcd8739ae039 = $3f400fe3379a2cc0$var$RequiredInput;

});

parcelRegister("fE9ks", function(module, exports) {
$parcel$export(module.exports, "default", () => $554451f6389e7a8e$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $6VesN = parcelRequire("6VesN");

var $s8kDh = parcelRequire("s8kDh");
const $554451f6389e7a8e$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $554451f6389e7a8e$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $6VesN.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $s8kDh.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                onClick: $554451f6389e7a8e$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("6VesN", function(module, exports) {
$parcel$export(module.exports, "default", () => $72c75c5cd3d6e165$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $7LiJw = parcelRequire("7LiJw");
const $72c75c5cd3d6e165$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $72c75c5cd3d6e165$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $bSJIT.useRef)(false);
    const isTop = (0, $bSJIT.useRef)(false);
    const touchStart = (0, $bSJIT.useRef)(0);
    const scrollTarget = (0, $bSJIT.useRef)(null);
    const handleEventDelta = (0, $bSJIT.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $72c75c5cd3d6e165$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $bSJIT.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $bSJIT.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $bSJIT.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $bSJIT.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $7LiJw.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $bSJIT.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});
parcelRegister("7LiJw", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $d57e58df67483eb3$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $1OdZP = parcelRequire("1OdZP");
const $d57e58df67483eb3$var$noop = (0, $1OdZP.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $d57e58df67483eb3$var$passiveOptionAccessed = false;
const $d57e58df67483eb3$var$options = {
    get passive () {
        return $d57e58df67483eb3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $d57e58df67483eb3$var$w = typeof window !== 'undefined' ? window : {};
if ($d57e58df67483eb3$var$w.addEventListener && $d57e58df67483eb3$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $d57e58df67483eb3$var$w.addEventListener('p', $d57e58df67483eb3$var$noop, $d57e58df67483eb3$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $d57e58df67483eb3$var$w.removeEventListener('p', $d57e58df67483eb3$var$noop, false);
}
const $d57e58df67483eb3$export$b0622a6911dbeaf5 = $d57e58df67483eb3$var$passiveOptionAccessed;

});


parcelRegister("s8kDh", function(module, exports) {
$parcel$export(module.exports, "default", () => $86b4c208ec9048c4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $86b4c208ec9048c4$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $86b4c208ec9048c4$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $86b4c208ec9048c4$var$preventTouchMove(e) {
    e.preventDefault();
}
function $86b4c208ec9048c4$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $86b4c208ec9048c4$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $86b4c208ec9048c4$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $86b4c208ec9048c4$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $86b4c208ec9048c4$var$activeScrollLocks = 0;
const $86b4c208ec9048c4$var$listenerOptions = {
    capture: false,
    passive: false
};
function $86b4c208ec9048c4$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $bSJIT.useRef)({});
    const scrollTarget = (0, $bSJIT.useRef)(null);
    const addScrollLock = (0, $bSJIT.useCallback)((touchScrollTarget)=>{
        if (!$86b4c208ec9048c4$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $86b4c208ec9048c4$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $86b4c208ec9048c4$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($86b4c208ec9048c4$var$LOCK_STYLES).forEach((key)=>{
                const val = $86b4c208ec9048c4$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $86b4c208ec9048c4$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $86b4c208ec9048c4$var$preventTouchMove, $86b4c208ec9048c4$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $86b4c208ec9048c4$var$preventInertiaScroll, $86b4c208ec9048c4$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $86b4c208ec9048c4$var$allowTouchMove, $86b4c208ec9048c4$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $86b4c208ec9048c4$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $bSJIT.useCallback)((touchScrollTarget)=>{
        if (!$86b4c208ec9048c4$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $86b4c208ec9048c4$var$activeScrollLocks = Math.max($86b4c208ec9048c4$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $86b4c208ec9048c4$var$activeScrollLocks < 1) $86b4c208ec9048c4$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $86b4c208ec9048c4$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $86b4c208ec9048c4$var$preventTouchMove, $86b4c208ec9048c4$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $86b4c208ec9048c4$var$preventInertiaScroll, $86b4c208ec9048c4$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $86b4c208ec9048c4$var$allowTouchMove, $86b4c208ec9048c4$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("4wI2d", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $da2383fbcc01b4dc$export$3f99968195accfaf);

var $qJSur = parcelRequire("qJSur");
function $da2383fbcc01b4dc$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $qJSur.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("b2hbg", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $849fa2cefd0dba3d$export$dea4763e29237f4c);
function $849fa2cefd0dba3d$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("i8kww", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $fe8c102318043b98$export$40fb9515c784cc3b);
function $fe8c102318043b98$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});

parcelRegister("8n6aF", function(module, exports) {
$parcel$export(module.exports, "isOptionDisabled", () => $fbd310aa46379547$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $fbd310aa46379547$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});


parcelRegister("27zHi", function(module, exports) {
$parcel$export(module.exports, "default", () => $eea49b286bd50637$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $eea49b286bd50637$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $bSJIT.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $bSJIT.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $bSJIT.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $bSJIT.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $bSJIT.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $bSJIT.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $bSJIT.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("5dnVg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a16b7e2e90dafde$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
const $1a16b7e2e90dafde$var$InlineMenuPortal = ({ children: children })=>children;
const $1a16b7e2e90dafde$var$InlineMenu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...innerProps,
        // MenuList owns this ID; forwarding it here would create duplicate listbox IDs.
        id: undefined,
        children: children
    });
function $1a16b7e2e90dafde$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, components: components, isInvalid: isInvalid, menuRenderMode: // TODO: set to true when cleaning up validationState prop so it has a default value
        menuRenderMode = 'popup', onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $bSJIT.useRef)(null);
        const inlineMenuComponents = (0, $bSJIT.useMemo)(()=>({
                ...components,
                MenuPortal: $1a16b7e2e90dafde$var$InlineMenuPortal,
                Menu: $1a16b7e2e90dafde$var$InlineMenu
            }), [
            components
        ]);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $bSJIT.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: ()=>{
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            }), []);
        if (menuRenderMode === 'inline') return /*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            components: inlineMenuComponents,
            menuIsOpen: (0, $gdUUy.fg)('platform_dst_inline_select_menu_control') ? props.menuIsOpen ?? true : true,
            tabSelectsValue: tabSelectsValue,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            components: components,
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});



parcelRegister("fC42J", function(module, exports) {
$parcel$export(module.exports, "MetaActions", () => $ac6e50998a4db8e3$export$50531cf3046c5956);
const $ac6e50998a4db8e3$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("kRsoF", function(module, exports) {
$parcel$export(module.exports, "Control", () => $dbfec8692e1ca86a$export$7a7fa4424cb20976);

var $bSJIT = parcelRequire("bSJIT");

var $4dIh5 = parcelRequire("4dIh5");
const $dbfec8692e1ca86a$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledControl), {
        ...innerProps,
        ref: innerRef
    }, children);
};

});

parcelRegister("8gPkU", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $63ff05bf6b17da0b$export$ec98719d3db7f2e4);

var $bSJIT = parcelRequire("bSJIT");

var $cBVmT = parcelRequire("cBVmT");

var $gfXmS = parcelRequire("gfXmS");

var $kbBdI = parcelRequire("kbBdI");

var $4dIh5 = parcelRequire("4dIh5");
const $63ff05bf6b17da0b$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kbBdI.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.DropdownIndicatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.DisplayWrapper), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.CloseIconWrapper), {
        onClick: (event)=>{
            var _props$selectProps$on, _props$selectProps;
            event.preventDefault();
            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
        color: "currentColor",
        label: ""
    }))));

});

parcelRegister("24oFU", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $4c37ae1d5575139f$export$d9b273488cd8ce6f);

var $bSJIT = parcelRequire("bSJIT");
const $4c37ae1d5575139f$export$d9b273488cd8ce6f = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);

});

parcelRegister("jrfao", function(module, exports) {
$parcel$export(module.exports, "default", () => $808f5c3392b1bf66$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $808f5c3392b1bf66$var$message = (0, $f0Pt4.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});
var $808f5c3392b1bf66$export$2e2bcd8739ae039 = $808f5c3392b1bf66$var$message;

});

parcelRegister("840Mw", function(module, exports) {
$parcel$export(module.exports, "Option", () => $58c30385c6e1349e$export$36d18380658d5d20);

var $bSJIT = parcelRequire("bSJIT");

var $hkLEY = parcelRequire("hkLEY");

var $4UORs = parcelRequire("4UORs");

var $1dsvE = parcelRequire("1dsvE");

var $lavtv = parcelRequire("lavtv");

var $4dIh5 = parcelRequire("4dIh5");
const $58c30385c6e1349e$var$renderOption = (props)=>props.isMulti ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4UORs.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1dsvE.RadioOption), props);
const $58c30385c6e1349e$export$36d18380658d5d20 = (props)=>{
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4dIh5.StyledInvalidCheckboxOption), null, $58c30385c6e1349e$var$renderOption(props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "Test",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return $58c30385c6e1349e$var$renderOption(props);
};

});
parcelRegister("4UORs", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $1c224a20f7dd068e$export$d40cc97ecda916f9);
/* checkbox-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $3vrMn = parcelRequire("3vrMn");
const $1c224a20f7dd068e$var$svgStyles = null;
const $1c224a20f7dd068e$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $1c224a20f7dd068e$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3vrMn.ControlOption), {
        Icon: $1c224a20f7dd068e$var$CheckboxIcon,
        ...props
    });

});
parcelRegister("3vrMn", function(module, exports) {
$parcel$export(module.exports, "ControlOption", () => $d434e32f3867d728$export$e41f7c07e51665da);
/* control-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");
const $d434e32f3867d728$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    finesseFocused: "_16qsglyw _112eglyw",
    disabled: "_syaz1gmx",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo"
};
// the primary color represents the outer or background element
const $d434e32f3867d728$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $d434e32f3867d728$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $d434e32f3867d728$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $d434e32f3867d728$var$baseIconStyles = null;
const $d434e32f3867d728$var$baseOptionStyles = null;
const $d434e32f3867d728$export$e41f7c07e51665da = (props)=>{
    const [isActive, setIsActive] = (0, $bSJIT.useState)(false);
    const onMouseDown = (0, $bSJIT.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $bSJIT.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $bSJIT.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            $d434e32f3867d728$var$optionStyles.default,
            !isDisabled && $d434e32f3867d728$var$optionStyles.motion,
            isFocused && $d434e32f3867d728$var$optionStyles.focused,
            isFocused && (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $d434e32f3867d728$var$optionStyles.finesseFocused,
            isDisabled && $d434e32f3867d728$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $d434e32f3867d728$var$iconStyles.inherit : $d434e32f3867d728$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                    label: "",
                    primaryColor: $d434e32f3867d728$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $d434e32f3867d728$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};

});


parcelRegister("1dsvE", function(module, exports) {
$parcel$export(module.exports, "RadioOption", () => $bfd99b26a74da88c$export$82ab7168879267a7);
/* radio-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $3vrMn = parcelRequire("3vrMn");
const $bfd99b26a74da88c$var$svgStyles = null;
const $bfd99b26a74da88c$var$RadioIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $bfd99b26a74da88c$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $3vrMn.ControlOption), {
        Icon: $bfd99b26a74da88c$var$RadioIcon,
        ...props
    });

});



parcelRegister("j9n0W", function(module, exports) {
$parcel$export(module.exports, "ShowFullListButton", () => $2f38f43e7488ef17$export$bf0956d66cd7566b);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hzFIQ = parcelRequire("hzFIQ");

var $4dkVN = parcelRequire("4dkVN");
const $2f38f43e7488ef17$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const handleShowFullList = (0, $bSJIT.useCallback)(()=>{
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4dkVN.default).showFullListButtonText));
};
var $2f38f43e7488ef17$export$2e2bcd8739ae039 = $2f38f43e7488ef17$export$bf0956d66cd7566b;

});
parcelRegister("4dkVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4615f6aa2ceb4e16$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4615f6aa2ceb4e16$var$message = (0, $f0Pt4.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});
var $4615f6aa2ceb4e16$export$2e2bcd8739ae039 = $4615f6aa2ceb4e16$var$message;

});


parcelRegister("lxaSk", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $e06016c91e88fb45$export$a06f1c675e846f6f);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $e06016c91e88fb45$var$styles = {
    footer: "_uwhk1dm9 _15a5nqa1 _1i531l7x _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o"
};
const $e06016c91e88fb45$export$a06f1c675e846f6f = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $e06016c91e88fb45$var$styles.footer
        ])
    }, children);

});


parcelRegister("cUBpA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a01789eec7a3864$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $i6SsT = parcelRequire("i6SsT");

var $1mrLp = parcelRequire("1mrLp");

var $5I86L = parcelRequire("5I86L");
const $3a01789eec7a3864$var$formatOptionLabel = (option)=>{
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mrLp.IconOptionLabel), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $i6SsT.AvatarOptionLabel), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5I86L.LozengeOptionLabel), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
};
var $3a01789eec7a3864$export$2e2bcd8739ae039 = $3a01789eec7a3864$var$formatOptionLabel;

});
parcelRegister("i6SsT", function(module, exports) {
$parcel$export(module.exports, "AvatarOptionLabel", () => $0437b2b8e6ce1f27$export$fe00f602c942368a);

var $bSJIT = parcelRequire("bSJIT");

var $JD7lD = parcelRequire("JD7lD");

var $d9S0k = parcelRequire("d9S0k");
const $0437b2b8e6ce1f27$export$fe00f602c942368a = ({ avatarOption: avatarOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xxsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledChild), null, avatarOption.label));

});
parcelRegister("d9S0k", function(module, exports) {
$parcel$export(module.exports, "StyledChild", () => $52ba450e4740333e$export$8133811dea85f484);
$parcel$export(module.exports, "StyledOption", () => $52ba450e4740333e$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledItem", () => $52ba450e4740333e$export$7c16ae7705e422c4);
$parcel$export(module.exports, "StyledChildIcon", () => $52ba450e4740333e$export$c23e66fb1706d7dd);
$parcel$export(module.exports, "StyledOptionIcon", () => $52ba450e4740333e$export$20da797b837461ca);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $52ba450e4740333e$var$styles = {
    child: "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf",
    option: "_4cvr1h6o _1e0c1txw",
    item: "_1e0c1txw",
    childIcon: "_18u0u2gc",
    optionIcon: "_2rko1rr0 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
const $52ba450e4740333e$export$8133811dea85f484 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $52ba450e4740333e$var$styles.child
        ])
    }, children);
const $52ba450e4740333e$export$844bee7de236d7ec = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $52ba450e4740333e$var$styles.option
        ])
    }, children);
const $52ba450e4740333e$export$7c16ae7705e422c4 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $52ba450e4740333e$var$styles.item
        ])
    }, children);
const $52ba450e4740333e$export$c23e66fb1706d7dd = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $52ba450e4740333e$var$styles.childIcon
        ])
    }, children);
const $52ba450e4740333e$export$20da797b837461ca = ({ alt: alt = '', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
        alt: alt,
        ...props,
        className: (0, $9fU1q.default)([
            $52ba450e4740333e$var$styles.optionIcon
        ])
    });

});


parcelRegister("1mrLp", function(module, exports) {
$parcel$export(module.exports, "IconOptionLabel", () => $5dd4e17856dc4e41$export$914fa095fc1e0a45);

var $bSJIT = parcelRequire("bSJIT");

var $d9S0k = parcelRequire("d9S0k");
const $5dd4e17856dc4e41$export$914fa095fc1e0a45 = ({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledItem), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledOptionIcon), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledChildIcon), null, option.label)));

});

parcelRegister("5I86L", function(module, exports) {
$parcel$export(module.exports, "LozengeOptionLabel", () => $ebdebb68ba8c7703$export$5f70fe304106fcb1);

var $bSJIT = parcelRequire("bSJIT");

var $cExzV = parcelRequire("cExzV");

var $d9S0k = parcelRequire("d9S0k");
const $ebdebb68ba8c7703$export$5f70fe304106fcb1 = ({ lozengeOption: lozengeOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledChild), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d9S0k.StyledItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));

});


parcelRegister("6Qq5t", function(module, exports) {
$parcel$export(module.exports, "DialogInner", () => $4ecda244230aca8d$export$999ca5bf223f627);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $4ecda244230aca8d$var$styles = {
    dialogInner: "_1reo15vq _18m915vq _1ul91wdt"
};
const $4ecda244230aca8d$export$999ca5bf223f627 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $4ecda244230aca8d$var$styles.dialogInner
        ])
    }, children);

});


parcelRegister("hbTte", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $c08bc0bf1afde2a7$export$957d7daebd899f12);

var $bSJIT = parcelRequire("bSJIT");

var $8xlF3 = parcelRequire("8xlF3");

var $8aT4G = parcelRequire("8aT4G");

var $60SFA = parcelRequire("60SFA");
const $c08bc0bf1afde2a7$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : !!value;
const $c08bc0bf1afde2a7$export$957d7daebd899f12 = (label = '', value)=>{
    if (!value || !$c08bc0bf1afde2a7$export$96bdbc84526f3739(value)) return label;
    const [firstValue, ...otherValues] = value.map((v)=>v.label ?? '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $60SFA.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        as: "strong",
        color: "inherit"
    }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $60SFA.LabelValueWrapper), null, firstValue, otherValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $60SFA.BadgeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8xlF3.default), null, `+${otherValues.length}`))));
};

});
parcelRegister("8xlF3", function(module, exports) {
$parcel$export(module.exports, "default", () => $632eaf76f992ef4d$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $aBvqE = parcelRequire("aBvqE");

var $41GeV = parcelRequire("41GeV");

var $g27Ki = parcelRequire("g27Ki");
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in `children`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $632eaf76f992ef4d$var$Badge = /*#__PURE__*/ (0, $bSJIT.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // Map old appearance names to new ones
    const newAppearance = (0, $aBvqE.appearanceMapping)[appearance];
    // Pre-format the value using the backward-compatible formatter (supports negative numbers)
    // then pass max={false} to BadgeNew so it doesn't apply its own (clamping) formatting.
    const formattedValue = typeof children === 'number' && typeof max === 'number' ? (0, $g27Ki.formatValueWithNegativeSupport)(children, max) : children;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $41GeV.default), {
        appearance: newAppearance,
        max: false,
        style: style,
        testId: testId,
        children: formattedValue
    });
});
var $632eaf76f992ef4d$export$2e2bcd8739ae039 = $632eaf76f992ef4d$var$Badge;

});
parcelRegister("aBvqE", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $f5ef5fb245e7c70d$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $f5ef5fb245e7c70d$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("g27Ki", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $354d62b235f7931f$export$4b844743568d5983);
function $354d62b235f7931f$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $354d62b235f7931f$export$4b844743568d5983(value, max) {
    const safeValue = $354d62b235f7931f$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $354d62b235f7931f$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("60SFA", function(module, exports) {
$parcel$export(module.exports, "BadgeWrapper", () => $e9d115e22bca1eff$export$1a37a8b7ddf809ac);
$parcel$export(module.exports, "Container", () => $e9d115e22bca1eff$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelValueWrapper", () => $e9d115e22bca1eff$export$8f3477ca2c4ba51a);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// Uses @compiled/react because fractional opacity (0.5) is not an allowed value in the strict @atlaskit/css types.
const $e9d115e22bca1eff$var$badgeWrapperStyles = {
    badge: "_1e0c116y _18u01b66 _tzy4105o"
};
const $e9d115e22bca1eff$var$styles = {
    container: "_1e0c116y _4cvr1h6o",
    labelValue: "_18u01b66 _1e0c116y _4cvr1h6o"
};
const $e9d115e22bca1eff$export$1a37a8b7ddf809ac = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $e9d115e22bca1eff$var$badgeWrapperStyles.badge
        ])
    }, children);
const $e9d115e22bca1eff$export$42a852a2b6b56249 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $e9d115e22bca1eff$var$styles.container
        ])
    }, children);
const $e9d115e22bca1eff$export$8f3477ca2c4ba51a = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $e9d115e22bca1eff$var$styles.labelValue
        ])
    }, children);

});


parcelRegister("dqwac", function(module, exports) {
$parcel$export(module.exports, "default", () => $c52a1f1574a7c3dc$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $4GWyU = parcelRequire("4GWyU");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $61e2R = parcelRequire("61e2R");

var $5T6wV = parcelRequire("5T6wV");

var $eCzJB = parcelRequire("eCzJB");

var $fCwks = parcelRequire("fCwks");
const $c52a1f1574a7c3dc$var$textPadding = {
    root: "_u5f3utpp"
};
const $c52a1f1574a7c3dc$export$d7b370c39c0de454 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, hideSelectedIndicator: hideSelectedIndicator, triggerIcon: triggerIcon, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, isDisabled: isDisabled, ariaLabel: ariaLabel }, ref)=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $61e2R.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eCzJB.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        isSelected: !hideSelectedIndicator && isSelected,
        iconBefore: triggerIcon,
        testId: testId
    }, children, !(0, $gdUUy.fg)('adminhub-filter-loading-label') && ':')));
    const afterTriggerIcon = onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fCwks.StyledClose), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5T6wV.ClearButton), {
        onClick: (e)=>{
            e.stopPropagation();
            onClear === null || onClear === void 0 || onClear();
        },
        label: "Remove criteria"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
        color: "currentColor",
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $61e2R.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fCwks.ButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: isInvalid ? 'danger' : 'default',
        isSelected: !hideSelectedIndicator && (isSelected || hasValues),
        iconBefore: triggerIcon,
        iconAfter: ()=>afterTriggerIcon,
        onClick: onClick,
        ref: ref,
        testId: testId,
        "aria-expanded": isSelected,
        isDisabled: isDisabled,
        "aria-label": ariaLabel && ariaLabel
    }, onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $c52a1f1574a7c3dc$var$textPadding.root
    }, children) : children)));
});
var $c52a1f1574a7c3dc$export$2e2bcd8739ae039 = $c52a1f1574a7c3dc$export$d7b370c39c0de454;

});
parcelRegister("5T6wV", function(module, exports) {
$parcel$export(module.exports, "ClearButton", () => $3cd3bb6afc80b8b9$export$13ec83e50bf04290);

var $bSJIT = parcelRequire("bSJIT");

var $9dYEz = parcelRequire("9dYEz");

var $7gTEb = parcelRequire("7gTEb");
const $3cd3bb6afc80b8b9$export$13ec83e50bf04290 = ({ label: label, isSelected: isSelected, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7gTEb.StyledClearButton), {
        ...props,
        "data-testid": "paginated-picker.ui.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
$3cd3bb6afc80b8b9$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $3cd3bb6afc80b8b9$export$2e2bcd8739ae039 = $3cd3bb6afc80b8b9$export$13ec83e50bf04290;

});
parcelRegister("7gTEb", function(module, exports) {
$parcel$export(module.exports, "StyledClearButton", () => $4bade726f6aa5348$export$969a0501aa28855a);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
const $4bade726f6aa5348$var$styledClearButtonStyles = {
    clearButton: "_2rkolb4i _189eidpf _1dqoglyw _bfhk1j28 _syaz1rpy _80omtlke _4t3i1ejb _vwz4kb7n _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _18u0v77o _k8m01v7i _1oecfnf5 _1bsb1ejb _f8pjazsu _30l3azsu"
};
const $4bade726f6aa5348$export$969a0501aa28855a = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $4bade726f6aa5348$var$styledClearButtonStyles.clearButton
        ])
    }, children);

});


parcelRegister("eCzJB", function(module, exports) {
$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $86ada71888da0a41$export$c7a90a9f6120efb7);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// Uses @compiled/react because keyframes() is not available from @atlaskit/css.
const $86ada71888da0a41$var$flickerAnimation = null;
const $86ada71888da0a41$var$loadingStateAnimationWrapperStyles = {
    wrapper: "_kqswh2mm _j7hq3y00 _5sagymdr _tip812c5"
};
const $86ada71888da0a41$export$c7a90a9f6120efb7 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $86ada71888da0a41$var$loadingStateAnimationWrapperStyles.wrapper
        ])
    }, children);

});

parcelRegister("fCwks", function(module, exports) {
$parcel$export(module.exports, "ButtonWrapper", () => $2e30bdc4ae6bf9ea$export$d53c836cccbb0d90);
$parcel$export(module.exports, "StyledClose", () => $2e30bdc4ae6bf9ea$export$cd8104a6ec6bb897);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
const $2e30bdc4ae6bf9ea$var$styles = {
    buttonWrapper: "_kqswh2mm"
};
const $2e30bdc4ae6bf9ea$var$styledCloseStyles = {
    close: "_189eidpf _1dqoglyw _bfhk1j28 _4t3i1ejb _vwz4kb7n _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1xi2r5cr _154i1ssb _19pkxmi2 _1bsb1ejb"
};
const $2e30bdc4ae6bf9ea$export$d53c836cccbb0d90 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $2e30bdc4ae6bf9ea$var$styles.buttonWrapper
        ])
    }, children);
const $2e30bdc4ae6bf9ea$export$cd8104a6ec6bb897 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...props,
        className: (0, $9fU1q.default)([
            $2e30bdc4ae6bf9ea$var$styledCloseStyles.close
        ])
    }, children);

});





parcelRegister("hMJTP", function(module, exports) {
$parcel$export(module.exports, "default", () => $469a5708dbc1185e$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $469a5708dbc1185e$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Label for the category picker filter used to narrow article search results',
        id: 'sd.all.articles.result.category.filter.name'
    }
});

});



parcelRegister("i1k7Q", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => (parcelRequire("hfp06")).SearchResultNone);

var $hfp06 = parcelRequire("hfp06");

});
parcelRegister("hfp06", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => $ce2b69554d3d32eb$export$149a2f9a7f0755fb);

var $bSJIT = parcelRequire("bSJIT");

var $1QNAl = parcelRequire("1QNAl");

var $b4X0E = parcelRequire("b4X0E");

var $4vLTk = parcelRequire("4vLTk");

var $7WQx2 = parcelRequire("7WQx2");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $f6Ax9 = parcelRequire("f6Ax9");
parcelRequire("4BroI");
var $c6fXf = parcelRequire("c6fXf");

var $f5JeN = parcelRequire("f5JeN");

var $6tb0C = parcelRequire("6tb0C");
const $ce2b69554d3d32eb$export$149a2f9a7f0755fb = ({ term: term })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (term === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1QNAl))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $6tb0C.default).noSearchQueryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        align: "center"
    }, formatMessage((0, $6tb0C.default).noSearchQueryBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $f5JeN.searchExperience)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4X0E))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $6tb0C.default).noSearchResultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        align: "center"
    }, formatMessage((0, $6tb0C.default).noSearchResultBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $f5JeN.searchExperience)
    }));
};

});
parcelRegister("1QNAl", function(module, exports) {
module.exports = new URL("../images/empty-search-query.f4548b48.svg", import.meta.url).toString();

});

parcelRegister("b4X0E", function(module, exports) {
module.exports = new URL("../images/empty-search-results.00e234d0.svg", import.meta.url).toString();

});

parcelRegister("6tb0C", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9a921e53d206298$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e9a921e53d206298$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    noSearchResultTitle: {
        defaultMessage: 'We couldn\u2019t find a match for your search',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.none.no-search-result-title'
    },
    noSearchResultText: {
        defaultMessage: 'We couldn\u2019t find any matches for \u2018{ term }\u2019. Check your search for typos, or try another search term.',
        description: 'Title text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-text'
    },
    noSearchResultBody: {
        defaultMessage: 'Check your search for typos, or try another search term.',
        description: 'Body text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-body'
    },
    noSearchQueryTitle: {
        defaultMessage: 'Looking for something?',
        description: 'Title text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-title'
    },
    noSearchQueryBody: {
        defaultMessage: 'Enter your search term above to get started.',
        description: 'Body text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-body'
    }
});

});



parcelRegister("1oNsK", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => (parcelRequire("gHESL")).SearchBar);

var $gHESL = parcelRequire("gHESL");

});
parcelRegister("gHESL", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => $42a53e5da8f49fd5$export$79d13b60110f33be);

var $bSJIT = parcelRequire("bSJIT");

var $1DmE6 = parcelRequire("1DmE6");

var $4ZMmh = parcelRequire("4ZMmh");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $kIbto = parcelRequire("kIbto");

var $87QgR = parcelRequire("87QgR");

var $9dYEz = parcelRequire("9dYEz");

var $gfXmS = parcelRequire("gfXmS");

var $hkLEY = parcelRequire("hkLEY");

var $26Jy2 = parcelRequire("26Jy2");

var $gUpf2 = parcelRequire("gUpf2");

var $jnInZ = parcelRequire("jnInZ");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");

var $jgsO4 = parcelRequire("jgsO4");

var $5LmQo = parcelRequire("5LmQo");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
var $c6fXf = parcelRequire("c6fXf");
var $8ZJ8E = parcelRequire("8ZJ8E");

var $6Hv2U = parcelRequire("6Hv2U");
const $42a53e5da8f49fd5$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON = 'searchQueryCharacterLimitErrorIcon';
const $42a53e5da8f49fd5$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER = 'searchQueryCharacterLimitErrorPopover';
const $42a53e5da8f49fd5$var$HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const $42a53e5da8f49fd5$var$MOBILE_SEARCH_BAR_BREAKPOINT_WIDTH = 768;
const $42a53e5da8f49fd5$var$isHelpCenterSearchLimitEnabled = ()=>(0, $87QgR.default).checkGate($42a53e5da8f49fd5$var$HELP_CENTER_SEARCH_LIMIT_GATE);
const $42a53e5da8f49fd5$var$getBackButtonText = (width)=>width < $42a53e5da8f49fd5$var$MOBILE_SEARCH_BAR_BREAKPOINT_WIDTH ? '' : undefined;
const $42a53e5da8f49fd5$var$fireSearchCharacterLimitAnalytics = (createAnalyticsEvent, action, actionSubject, actionSubjectId)=>{
    createAnalyticsEvent === null || createAnalyticsEvent === void 0 || createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        analyticsType: 'UI'
    }).fire();
};
const $42a53e5da8f49fd5$export$79d13b60110f33be = (props)=>{
    if ($42a53e5da8f49fd5$var$isHelpCenterSearchLimitEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($42a53e5da8f49fd5$var$SearchBarWithSearchLimit, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($42a53e5da8f49fd5$var$SearchBarLegacy, props);
};
const $42a53e5da8f49fd5$var$SearchBarLegacy = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [backButtonText, setBackButtonText] = (0, $bSJIT.useState)();
    const searchBarRef = (0, $bSJIT.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, $bSJIT.useState)(term);
    (0, $bSJIT.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText(entry.contentRect.width < 768 ? '' : undefined);
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            if (currentSearchBarRefRef) observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const debouncedOnChangeMethod = (0, $bSJIT.useMemo)(()=>(0, $4ZMmh.debounce)((value)=>{
            onChange(value);
        }, (0, $8ZJ8E.SEARCH_QUERY_DEBOUNCE_TIME)), [
        onChange
    ]);
    const onSearchTermChange = (0, $bSJIT.useCallback)((e)=>{
        setSearchQuery(e.target.value);
        if ((0, $87QgR.default).checkGate('debounce_change_in_portal_search')) debouncedOnChangeMethod(e.target.value);
        else onChange(e.target.value);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        debouncedOnChangeMethod,
        onChange
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $3DuDW.useRouterActions)();
    const onBackButtonClick = (0, $bSJIT.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $2FLDr.useQueryParams)();
    const onCrossIconClick = (0, $bSJIT.useCallback)(()=>{
        setSearchQuery('');
        onChange('');
        push((0, $5LmQo.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: $42a53e5da8f49fd5$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        gap: "space.200",
        templateColumns: "25fr 50fr 25fr",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $42a53e5da8f49fd5$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1DmE6.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $42a53e5da8f49fd5$var$textFieldLegacyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: "search-bar-input",
        value: searchQuery,
        name: formatMessage((0, $6Hv2U.default).inputLabel),
        "aria-label": formatMessage((0, $6Hv2U.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $6Hv2U.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $42a53e5da8f49fd5$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "button",
            "aria-label": formatMessage((0, $6Hv2U.default).clearLabel),
            xcss: $42a53e5da8f49fd5$var$crossIconStyles,
            onClick: onCrossIconClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
            label: formatMessage((0, $6Hv2U.default).clearLabel),
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        // Disabling existing violations, should be fixed when revisited.
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null)));
};
const $42a53e5da8f49fd5$var$SearchBarWithSearchLimit = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [backButtonText, setBackButtonText] = (0, $bSJIT.useState)(()=>typeof window === 'undefined' ? undefined : $42a53e5da8f49fd5$var$getBackButtonText(window.innerWidth));
    const searchBarRef = (0, $bSJIT.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, $bSJIT.useState)(term);
    const [isCharacterLimitErrorOpen, setIsCharacterLimitErrorOpen] = (0, $bSJIT.useState)(false);
    const isSearchQueryOverLimit = (0, $2FLDr.isSearchQueryOverCharacterLimit)(searchQuery);
    (0, $bSJIT.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (currentSearchBarRefRef) setBackButtonText($42a53e5da8f49fd5$var$getBackButtonText(currentSearchBarRefRef.getBoundingClientRect().width));
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText($42a53e5da8f49fd5$var$getBackButtonText(entry.contentRect.width));
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            var _observer;
            if (currentSearchBarRefRef) (_observer = observer) === null || _observer === void 0 || _observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const debouncedOnChangeMethod = (0, $bSJIT.useMemo)(()=>(0, $4ZMmh.debounce)((value)=>{
            onChange(value);
        }, (0, $8ZJ8E.SEARCH_QUERY_DEBOUNCE_TIME)), [
        onChange
    ]);
    const onSearchTermChange = (0, $bSJIT.useCallback)((e)=>{
        const newSearchQuery = e.target.value;
        const isNewSearchQueryOverLimit = (0, $2FLDr.isSearchQueryOverCharacterLimit)(newSearchQuery);
        setSearchQuery(newSearchQuery);
        setIsCharacterLimitErrorOpen(false);
        if (isNewSearchQueryOverLimit) return;
        if ((0, $87QgR.default).checkGate('debounce_change_in_portal_search')) debouncedOnChangeMethod(newSearchQuery);
        else onChange(newSearchQuery);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        debouncedOnChangeMethod,
        onChange
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $3DuDW.useRouterActions)();
    const onBackButtonClick = (0, $bSJIT.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $2FLDr.useQueryParams)();
    const onCrossIconClick = (0, $bSJIT.useCallback)(()=>{
        setSearchQuery('');
        setIsCharacterLimitErrorOpen(false);
        onChange('');
        push((0, $5LmQo.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    const onCharacterLimitErrorIconClick = (0, $bSJIT.useCallback)(()=>{
        $42a53e5da8f49fd5$var$fireSearchCharacterLimitAnalytics(createAnalyticsEvent, 'clicked', 'button', $42a53e5da8f49fd5$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON);
        const nextIsOpen = !isCharacterLimitErrorOpen;
        setIsCharacterLimitErrorOpen(nextIsOpen);
        if (nextIsOpen) $42a53e5da8f49fd5$var$fireSearchCharacterLimitAnalytics(createAnalyticsEvent, 'rendered', 'popover', $42a53e5da8f49fd5$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER);
    }, [
        createAnalyticsEvent,
        isCharacterLimitErrorOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: $42a53e5da8f49fd5$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        gap: "space.200",
        templateColumns: "auto minmax(0, 1fr) auto",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $42a53e5da8f49fd5$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1DmE6.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick,
        allowEmptyText: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $42a53e5da8f49fd5$var$textFieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: "search-bar-input",
        value: searchQuery,
        name: formatMessage((0, $6Hv2U.default).inputLabel),
        "aria-label": formatMessage((0, $6Hv2U.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $6Hv2U.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        isInvalid: isSearchQueryOverLimit,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $42a53e5da8f49fd5$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: isSearchQueryOverLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
            isOpen: isCharacterLimitErrorOpen,
            onClose: ()=>setIsCharacterLimitErrorOpen(false),
            placement: "bottom-end",
            autoFocus: false,
            shouldRenderToParent: true,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                    ...triggerProps,
                    as: "button",
                    type: "button",
                    "aria-label": formatMessage((0, $6Hv2U.default).characterLimitErrorIconLabel),
                    xcss: $42a53e5da8f49fd5$var$searchErrorIconStyles,
                    onClick: onCharacterLimitErrorIconClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon-danger, #C9372C)"
                })),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                    xcss: $42a53e5da8f49fd5$var$characterLimitErrorStyles,
                    role: "alert"
                }, formatMessage((0, $6Hv2U.default).characterLimitExceeded, {
                    limit: (0, $8ZJ8E.SEARCH_QUERY_CHARACTER_LIMIT)
                }))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "button",
            "aria-label": formatMessage((0, $6Hv2U.default).clearLabel),
            xcss: $42a53e5da8f49fd5$var$crossIconStyles,
            onClick: onCrossIconClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
            label: formatMessage((0, $6Hv2U.default).clearLabel),
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        // Disabling existing violations, should be fixed when revisited.
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null)));
};
const $42a53e5da8f49fd5$var$containerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    width: '100vw',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    height: (0, $c6fXf.SEARCH_BAR_HEIGHT),
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #EBECF0)",
    zIndex: 'modal'
});
const $42a53e5da8f49fd5$var$backButtonStyles = (0, $9BVpB.xcss)({
    [(0, $4pBHw.media).above.xxs]: {
        marginLeft: 'space.050'
    },
    [(0, $4pBHw.media).above.xs]: {
        marginLeft: 'space.100'
    },
    [(0, $4pBHw.media).above.sm]: {
        marginLeft: 'space.200'
    }
});
const $42a53e5da8f49fd5$var$textFieldStyles = (0, $9BVpB.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    width: '100%',
    [(0, $4pBHw.media).above.xs]: {
        width: '432px'
    },
    [(0, $4pBHw.media).above.sm]: {
        width: '692px'
    },
    [(0, $4pBHw.media).above.md]: {
        width: '965px'
    }
});
const $42a53e5da8f49fd5$var$textFieldLegacyStyles = (0, $9BVpB.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    [(0, $4pBHw.media).above.xxs]: {
        width: '348px'
    },
    [(0, $4pBHw.media).above.xs]: {
        width: '432px'
    },
    [(0, $4pBHw.media).above.sm]: {
        width: '692px'
    },
    [(0, $4pBHw.media).above.md]: {
        width: '965px'
    }
});
const $42a53e5da8f49fd5$var$searchIconStyles = (0, $9BVpB.xcss)({
    padding: 'space.100'
});
const $42a53e5da8f49fd5$var$searchErrorIconStyles = (0, $9BVpB.xcss)({
    background: 'transparent',
    cursor: 'pointer',
    padding: 'space.100'
});
const $42a53e5da8f49fd5$var$crossIconStyles = (0, $9BVpB.xcss)({
    background: 'transparent',
    cursor: 'pointer'
});
const $42a53e5da8f49fd5$var$characterLimitErrorStyles = (0, $9BVpB.xcss)({
    color: 'color.text',
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    textAlign: 'right'
});
var $42a53e5da8f49fd5$export$2e2bcd8739ae039 = (0, $kIbto.default)()($42a53e5da8f49fd5$export$79d13b60110f33be);

});
parcelRegister("1DmE6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff1763b3168feb61$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $4vLTk = parcelRequire("4vLTk");

var $87QgR = parcelRequire("87QgR");

var $8sRTK = parcelRequire("8sRTK");

var $87ZEN = parcelRequire("87ZEN");
const $ff1763b3168feb61$var$HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const $ff1763b3168feb61$var$isHelpCenterSearchLimitEnabled = ()=>(0, $87QgR.default).checkGate($ff1763b3168feb61$var$HELP_CENTER_SEARCH_LIMIT_GATE);
const $ff1763b3168feb61$var$BackButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { onClick: onClick, actionSubjectId: actionSubjectId, text: text, allowEmptyText: allowEmptyText = false } = props;
    if (allowEmptyText && $ff1763b3168feb61$var$isHelpCenterSearchLimitEnabled()) {
        const defaultBackButtonText = formatMessage((0, $87ZEN.default).backButtonText);
        const gatedBackButtonText = text === undefined ? defaultBackButtonText : text;
        const accessibleLabel = text ? text : defaultBackButtonText;
        return /*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), {
            appearance: "subtle",
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            "aria-label": accessibleLabel,
            iconBefore: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sRTK))), {
                label: "",
                size: "small",
                spacing: "compact",
                color: "var(--ds-icon, #42526E)"
            }),
            "data-test-id": "back-button"
        }, gatedBackButtonText);
    }
    const backButtonText = text ? text : formatMessage((0, $87ZEN.default).backButtonText);
    return /*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), {
        appearance: "subtle",
        actionSubjectId: actionSubjectId,
        onClick: onClick,
        "aria-label": backButtonText,
        iconBefore: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sRTK))), {
            label: "",
            size: "small",
            spacing: "compact",
            color: "var(--ds-icon, #42526E)"
        }),
        "data-test-id": "back-button"
    }, backButtonText);
};
var $ff1763b3168feb61$export$2e2bcd8739ae039 = $ff1763b3168feb61$var$BackButton;

});
parcelRegister("8sRTK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d485ff62f9140a59decb65646f9f10e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $629abf541833875c$var$_react = $629abf541833875c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $629abf541833875c$var$_iconNew = $629abf541833875c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $629abf541833875c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $629abf541833875c$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $629abf541833875c$var$_react.default.createElement($629abf541833875c$var$_iconNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$629abf541833875c$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $629abf541833875c$var$_default = module.exports.default = $629abf541833875c$var$ArrowLeftIcon;

});

parcelRegister("87ZEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb6d687b5ef3afd9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $cb6d687b5ef3afd9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    backButtonText: {
        defaultMessage: 'Back',
        description: 'Back button text',
        id: 'sd.common.back-button.text'
    }
});

});


parcelRegister("jgsO4", function(module, exports) {
$parcel$export(module.exports, "default", () => $94e8cfef5ddc0efb$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $gdUUy = parcelRequire("gdUUy");
const $94e8cfef5ddc0efb$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $94e8cfef5ddc0efb$var$inputMediaDisabled = null;
const $94e8cfef5ddc0efb$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $94e8cfef5ddc0efb$var$disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $94e8cfef5ddc0efb$var$invalidStyle = null;
const $94e8cfef5ddc0efb$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $94e8cfef5ddc0efb$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $94e8cfef5ddc0efb$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $94e8cfef5ddc0efb$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $94e8cfef5ddc0efb$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $94e8cfef5ddc0efb$var$getMaxWidth = (width)=>!width ? `100%` : width in $94e8cfef5ddc0efb$var$widthMap ? `${$94e8cfef5ddc0efb$var$widthMap[width]}px` : `${+width}px`;
const $94e8cfef5ddc0efb$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $94e8cfef5ddc0efb$var$containerStyles = null;
const $94e8cfef5ddc0efb$var$inputDisabledStyle = null;
const $94e8cfef5ddc0efb$var$inputCompactStyle = null;
const $94e8cfef5ddc0efb$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textfield uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $94e8cfef5ddc0efb$var$inputStyle = null;
const $94e8cfef5ddc0efb$var$finessePlaceholderStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $94e8cfef5ddc0efb$var$Textfield = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const isInputMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const inputRef = (0, $bSJIT.useRef)(null);
    const handleOnFocus = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$94e8cfef5ddc0efb$var$analyticsParams
    });
    const handleOnBlur = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$94e8cfef5ddc0efb$var$analyticsParams
    });
    const handleOnMouseDown = (0, $bSJIT.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $bSJIT.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$94e8cfef5ddc0efb$var$getMaxWidth(width)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1qi0",
            !isInputMotionEnabled && $94e8cfef5ddc0efb$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $94e8cfef5ddc0efb$var$inputMotionStyles.base,
            $94e8cfef5ddc0efb$var$getContainerTextBgAndBorderColor[appearance],
            $94e8cfef5ddc0efb$var$containerStyleAppearance[appearance],
            !isDisabled && $94e8cfef5ddc0efb$var$focusWithinStyle[appearance],
            !isDisabled && $94e8cfef5ddc0efb$var$hoverStyle[appearance],
            isDisabled && $94e8cfef5ddc0efb$var$containerMedia.disabled,
            isDisabled && $94e8cfef5ddc0efb$var$disabledStyle[appearance],
            isInvalid && $94e8cfef5ddc0efb$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // TODO: When removing legacy theming fix this.
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $9fU1q.default)([
                    "_19itidpf _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _j4tm1d4k _1tmk12x7 _npz312x7 _1j6u12x7 _1ark12x7",
                    (0, $gdUUy.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
                    isMonospaced && "_ect4zzfg _1f2rzzfg",
                    isCompact && "_11zp1b66 _1l021b66 _daj712x7 _141f12x7 _rzs1v77o _141av77o _mwav12x7 _1aex12x7",
                    isDisabled && "_syaz1gmx _1idr1gmx",
                    isDisabled && "_1fnx18qt"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $94e8cfef5ddc0efb$export$2e2bcd8739ae039 = $94e8cfef5ddc0efb$var$Textfield;

});

parcelRegister("6Hv2U", function(module, exports) {
$parcel$export(module.exports, "default", () => $d28f85c97a0065c3$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $d28f85c97a0065c3$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    inputPlaceholder: {
        defaultMessage: 'Search for help resources',
        description: 'Placeholder message for the search bar describing what they can look for',
        id: 'cv.search.search-bar.input.placeholder'
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-bar.close'
    },
    inputLabel: {
        defaultMessage: 'Search bar input',
        description: 'Label message for the search bar input',
        id: 'cv.search.search-bar.input-label'
    },
    searchIconLabel: {
        defaultMessage: 'Search icon',
        description: 'Label message for the search bar input icon',
        id: 'cv.search.search-bar.search-icon-label'
    },
    clearLabel: {
        defaultMessage: 'clear',
        description: 'Label for the clear button which clears the search input',
        id: 'cv.search.search-bar.clear-label'
    },
    characterLimitExceeded: {
        defaultMessage: 'Search queries must be {limit, number} characters or less.',
        description: 'Error message shown when the search query exceeds the character limit.',
        id: 'cv.search.search-bar.character-limit-exceeded'
    },
    characterLimitErrorIconLabel: {
        defaultMessage: 'Search query is too long',
        description: 'Accessible label for the error icon shown when the search query is too long.',
        id: 'cv.search.search-bar.character-limit-error-icon-label'
    }
});

});



parcelRegister("1fyiO", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => (parcelRequire("aqM1S")).SearchResult);

var $aqM1S = parcelRequire("aqM1S");

});
parcelRegister("aqM1S", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $d7255a169d7ca887$export$a2def421b23768aa);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("cJJTb");
var $bf3Xm = parcelRequire("bf3Xm");

var $jnInZ = parcelRequire("jnInZ");

var $4pBHw = parcelRequire("4pBHw");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $3eoOe = parcelRequire("3eoOe");

var $yfw3z = parcelRequire("yfw3z");
parcelRequire("fxRd6");
var $ls5cb = parcelRequire("ls5cb");
parcelRequire("4BroI");
var $8ZJ8E = parcelRequire("8ZJ8E");

var $f5JeN = parcelRequire("f5JeN");
parcelRequire("3vVyV");
var $c3SIq = parcelRequire("c3SIq");
parcelRequire("i1k7Q");
var $hfp06 = parcelRequire("hfp06");
parcelRequire("jDmK1");
var $3om2m = parcelRequire("3om2m");
parcelRequire("dnQOE");
var $8huby = parcelRequire("8huby");
const $d7255a169d7ca887$export$e9a269813a6315a4 = ({ term: term, updateResultsCount: updateResultsCount })=>{
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const onlyRenderArticles = isCSM;
    if (onlyRenderArticles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c3SIq.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ls5cb.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $d7255a169d7ca887$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c3SIq.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ls5cb.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c3SIq.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8huby.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c3SIq.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3om2m.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }))));
};
const $d7255a169d7ca887$export$a2def421b23768aa = ({ term: term })=>{
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const [totalCount, setTotalCount] = (0, $bSJIT.useState)(-1);
    const resultsCount = (0, $bSJIT.useRef)(-1);
    const callBackCount = (0, $bSJIT.useRef)(0);
    const debouncedTerm = (0, $yfw3z.default)(term, (0, $8ZJ8E.SEARCH_QUERY_DEBOUNCE_TIME));
    // Every time this callback will be called, that resource will increment callBackCount through acknowledgement
    const updateResultsCount = (0, $bSJIT.useCallback)((count, acknowledgement)=>{
        if (resultsCount.current < 0) resultsCount.current = 0;
        resultsCount.current += count;
        if (acknowledgement) callBackCount.current += acknowledgement;
        // Update state only when articles, portals and requestForms all have updated the results
        if (callBackCount.current === 3) {
            // Since callbackCount will persist across states, setting it back to 0
            callBackCount.current = 0;
            setTotalCount(resultsCount.current);
        }
    }, []);
    (0, $3eoOe.useIsoMorphicLayoutEffect)(()=>{
        // Reset count to initial state on term change
        resultsCount.current = -1;
        setTotalCount(-1);
        callBackCount.current = 0;
    }, [
        debouncedTerm
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        isCSM ? (0, $f5JeN.csmSearchExperience).start() : (0, $f5JeN.searchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            isCSM ? (0, $f5JeN.csmSearchExperience).abort() : (0, $f5JeN.searchExperience).abort();
        };
    }, [
        debouncedTerm,
        isCSM
    ]);
    const isEmptyResultsState = totalCount === 0;
    const isEmptyQueryState = debouncedTerm === '';
    const showEmptyState = isEmptyQueryState || isEmptyResultsState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c3SIq.SearchResultsLoader), null)
    }, showEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hfp06.SearchResultNone), {
        term: debouncedTerm
    }), !isEmptyResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d7255a169d7ca887$export$e9a269813a6315a4, {
        term: term,
        updateResultsCount: updateResultsCount
    }));
};
const $d7255a169d7ca887$var$responsiveStyles = (0, $9BVpB.xcss)({
    [(0, $4pBHw.media).above.xxs]: {
        gridTemplateColumns: '1fr'
    },
    [(0, $4pBHw.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});

});
parcelRegister("yfw3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $72a92032b81e5fc3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
/**
 * If the 'value' changes multiple times in quick succession, within the specified 'delay' time frame,
 * the 'debouncedValue' only changes once and equals the latest 'value'
 */ const $72a92032b81e5fc3$var$useDebouncedValue = (value, delay)=>{
    const [debouncedValue, setDebouncedValue] = (0, $bSJIT.useState)(value);
    // useEffect schedules an update to 'debouncedValue' after the delay
    // if the 'value' changes before the delay, the previous timeout is cleared, and a new one is started
    (0, $bSJIT.useEffect)(()=>{
        const timeoutID = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timeoutID);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
var $72a92032b81e5fc3$export$2e2bcd8739ae039 = $72a92032b81e5fc3$var$useDebouncedValue;

});

parcelRegister("fxRd6", function(module, exports) {
$parcel$export(module.exports, "Articles", () => (parcelRequire("ls5cb")).default);

var $ls5cb = parcelRequire("ls5cb");

});
parcelRegister("ls5cb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1ede51bbe4d932f$export$2e2bcd8739ae039);

var $8gkDx = parcelRequire("8gkDx");

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $lCAV6 = parcelRequire("lCAV6");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $kIbto = parcelRequire("kIbto");

var $7WQx2 = parcelRequire("7WQx2");

var $4GWyU = parcelRequire("4GWyU");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $agNHL = parcelRequire("agNHL");

var $f6Ax9 = parcelRequire("f6Ax9");
parcelRequire("cPfnu");
var $1TOfy = parcelRequire("1TOfy");
parcelRequire("4BroI");
var $8ZJ8E = parcelRequire("8ZJ8E");
var $2FLDr = parcelRequire("2FLDr");
var $c6fXf = parcelRequire("c6fXf");

var $f5JeN = parcelRequire("f5JeN");
parcelRequire("i1k7Q");
var $hfp06 = parcelRequire("hfp06");

var $e77h5 = parcelRequire("e77h5");
const $e1ede51bbe4d932f$export$b9fde6c411c336c6 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const CSMPortalId = isCSM ? (0, $iW3CQ.getEnv)().hoistedPortalId : undefined;
    const { portalIds: portalIds, categoryIds: categoryIds } = (0, $2FLDr.useQueryParams)();
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const getSelectedPortalIds = ()=>{
        if (CSMPortalId) return (0, $2FLDr.getIdsArray)(CSMPortalId);
        if ((0, $2FLDr.isSinglePortalSearch)(portalId)) return (0, $2FLDr.getIdsArray)(portalId);
        return (0, $2FLDr.getIdsArray)(portalIds);
    };
    const cloudId = (0, $fuVmc.getCloudId)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $8gkDx.default), {
        cloudId: cloudId,
        categoryIds: categoryIds,
        queryTerm: term,
        portalIds: getSelectedPortalIds(),
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        limit: (0, $8ZJ8E.ARTICLES_RESULT_LIMIT),
        highlight: true,
        isSourceSystemEnabled: true
    });
    const [numberOfResultsShown, setNumberOfResultsShown] = (0, $bSJIT.useState)((0, $8ZJ8E.INITIAL_ARTICLES_LIMIT));
    const articles = (0, $bSJIT.useMemo)(()=>{
        var _data$helpObjectStore;
        return ((_data$helpObjectStore = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreArticleSearchResults' ? data.helpObjectStore_searchArticles.results : [];
    }, [
        data.helpObjectStore_searchArticles
    ]);
    const numOfResults = articles.length;
    const hasMoreResults = numOfResults > numberOfResultsShown;
    const showMoreArticlesButton = numberOfResultsShown < 30 && hasMoreResults;
    const slicedArticles = articles.slice(0, numberOfResultsShown) || [];
    const showSection = numOfResults > 0;
    const sourceSystem = (0, $bSJIT.useMemo)(()=>articles.reduce((records, item)=>{
            const currentSourceSystem = item.sourceSystem;
            const value = currentSourceSystem ? records[currentSourceSystem] ?? 0 : 0;
            return {
                ...records,
                ...currentSourceSystem && {
                    [currentSourceSystem]: value + 1
                }
            };
        }, {}), [
        articles
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreArticleSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchArticles.results.forEach((article)=>{
                if (article) {
                    const { metadata: metadata } = article;
                    const { searchStrategy: searchStrategy } = metadata;
                    const isExternal = article.sourceSystem === 'EXTERNAL';
                    if (isExternal) externalResourcesCount += 1;
                    if (searchStrategy === 'CONTENT_SEARCH') firstPartySearchPlatformResourcesCount += 1;
                }
            });
            (0, $2FLDr.sendSearchOperationalAnalyticEvents)({
                sourceSystem: sourceSystem,
                action: portalId ? 'KBArticleSinglePortalSearch success' : 'KBArticleHomePageSearch success',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $2FLDr.sendSearchUIAnalyticEvents)({
                sourceSystem: sourceSystem,
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'article',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
        }
    }, [
        showSection,
        createAnalyticsEvent,
        portalId,
        sourceSystem,
        data
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchArticles;
            (0, $2FLDr.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                action: portalId ? 'KBArticleSinglePortalSearch failed' : 'KBArticleHomePageSearch failed',
                statusCode: extensions.length > 0 ? extensions[0].statusCode : undefined,
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        updateResultsCount(slicedArticles.length, 1);
    }, [
        term,
        slicedArticles.length,
        updateResultsCount
    ]);
    const onShowMoreClick = ()=>{
        if (numberOfResultsShown < 30) setNumberOfResultsShown((0, $8ZJ8E.ARTICLES_RESULT_LIMIT));
    };
    if (!showSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hfp06.SearchResultNone), {
        term: term
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $e77h5.default).articles)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $agNHL.ThirdPartyCardConnector), {
        type: "card",
        connectors: [
            'googleDrive',
            'sharepoint'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.ResultList), {
        role: "list"
    }, slicedArticles.map((resource, index)=>{
        const itemOrder = index + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("li", {
            key: itemOrder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1TOfy.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    })), showMoreArticlesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lCAV6.ThemedButton), {
        "data-test-id": "show-more-button",
        appearance: "link",
        actionSubjectId: "showMoreButton",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            size: "small",
            spacing: "spacious",
            label: formatMessage((0, $e77h5.default).showMoreIcon)
        }),
        onClick: onShowMoreClick
    }, formatMessage((0, $e77h5.default).showMore))), isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $f5JeN.csmSearchExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $f5JeN.searchExperience)
    }));
};
var $e1ede51bbe4d932f$export$2e2bcd8739ae039 = (0, $kIbto.default)()($e1ede51bbe4d932f$export$b9fde6c411c336c6);

});
parcelRegister("8gkDx", function(module, exports) {
$parcel$export(module.exports, "default", () => $00c45689ae4d6ec8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1721f64acd5bfb357c7a70051aa8f6af>>
 * @relayHash 0d77121bf6717adbc116ac50a5fadabf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b
const $00c45689ae4d6ec8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "highlight"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSourceSystemEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "categoryIds",
            "variableName": "categoryIds"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "highlight",
            "variableName": "highlight"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalIds",
            "variableName": "portalIds"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "HelpObjectStoreArticleMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "sourceSystem"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isSourceSystemEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isSourceSystemEnabled",
                                                    "variableName": "isSourceSystemEnabled"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "articleItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "ari"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "containerName"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b",
            "metadata": {},
            "name": "articlesSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$00c45689ae4d6ec8$var$node.hash = "21465f36d9753aacb064065974751749";
var $00c45689ae4d6ec8$export$2e2bcd8739ae039 = $00c45689ae4d6ec8$var$node;

});

parcelRegister("agNHL", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyCardConnector", () => $f9d45ac6fec2cdb6$export$3ebb74b46e82b89e);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $f9d45ac6fec2cdb6$export$3ebb74b46e82b89e = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazy)(()=>(parcelRequire("7PFqf")), {
        moduleId: "./packages/help-center/thirdparty-connectors/src/ui/connectors/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("7PFqf", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lT1RF").then(()=>parcelRequire('k9dTK'));

});


parcelRegister("cPfnu", function(module, exports) {
$parcel$export(module.exports, "ArticleItem", () => (parcelRequire("1TOfy")).default);

var $1TOfy = parcelRequire("1TOfy");

});
parcelRegister("1TOfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $401bf9e56224c57f$export$2e2bcd8739ae039);

var $8aYMF = parcelRequire("8aYMF");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $2OuWT = parcelRequire("2OuWT");

var $3lfq2 = parcelRequire("3lfq2");

var $3HBS2 = parcelRequire("3HBS2");

var $fKGH0 = parcelRequire("fKGH0");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $kIbto = parcelRequire("kIbto");

var $87QgR = parcelRequire("87QgR");

var $5UXaz = parcelRequire("5UXaz");

var $gUpf2 = parcelRequire("gUpf2");

var $jnInZ = parcelRequire("jnInZ");

var $9BVpB = parcelRequire("9BVpB");

var $aRsbV = parcelRequire("aRsbV");

var $lkNTb = parcelRequire("lkNTb");

var $hCnLH = parcelRequire("hCnLH");

var $3Asfj = parcelRequire("3Asfj");

var $iW3CQ = parcelRequire("iW3CQ");

var $zZCyy = parcelRequire("zZCyy");
parcelRequire("dmYEL");
var $aQA3A = parcelRequire("aQA3A");

var $e77h5 = parcelRequire("e77h5");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
parcelRequire("anSwm");
var $hEqUu = parcelRequire("hEqUu");
const $401bf9e56224c57f$export$3a909d935747d7f7 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useFragment)((0, $8aYMF.default), result);
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const { title: title, excerpt: excerpt, displayLink: displayLink, metadata: metadata, ari: ari, sourceSystem: sourceSystem } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const isExternal = sourceSystem === 'EXTERNAL';
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5UXaz))), {
        label: formatMessage((0, $e77h5.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $2FLDr.formatText)(title, term) : '';
    const highlightedDescription = excerpt ? (0, $2FLDr.formatText)(excerpt, term) : '';
    const displayLinkWithSource = (0, $3Asfj.addSourceToUrl)(displayLink, 'search', (0, $3Asfj.is3pOrExternalSource)(sourceSystem));
    const linkProps = (0, $zZCyy.urlRefsAndTarget)({
        displayLink: displayLinkWithSource,
        isAnExternalResource: (0, $3Asfj.is3pOrExternalSource)(sourceSystem)
    });
    (0, $bSJIT.useEffect)(()=>{
        (0, $2FLDr.sendSearchUIAnalyticEvents)({
            sourceSystem: sourceSystem,
            ari: ari,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'article'
        }, createAnalyticsEvent, portalId);
    }, [
        ari,
        createAnalyticsEvent,
        portalId,
        searchStrategy,
        sourceSystem
    ]);
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $2FLDr.useVisibilityState)();
    const isJcsSearchExperienceEnabled = (0, $87QgR.default).checkGate('jcs_search_experience');
    const disableMetadata = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && isJcsSearchExperienceEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        key: ari,
        xcss: $401bf9e56224c57f$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $401bf9e56224c57f$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hEqUu.default), {
        displayLink: displayLink,
        entityType: "ARTICLE",
        sourceSystem: sourceSystem,
        isExternal: isExternal,
        variant: "tile"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $401bf9e56224c57f$var$headingAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2OuWT.Link), {
        key: ari,
        actionSubjectId: isExternal ? 'external-article-link' : 'article-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            ari: ari,
            itemOrder: itemOrder,
            searchStrategy: searchStrategy,
            sourceSystem: sourceSystem,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        style: {
            color: (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lkNTb.generateThemeBranding)(themeColor).color900 : themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $fKGH0.sanitize)(highlightedTitle)
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: [
            $401bf9e56224c57f$var$subheadingLeftAreaStyles,
            $401bf9e56224c57f$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, !disableMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aQA3A.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: isShortcutIconVisible ? $401bf9e56224c57f$var$headerRightAreaStylesVisible : $401bf9e56224c57f$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: disableMetadata ? $401bf9e56224c57f$var$jcsBodyAreaStyles : $401bf9e56224c57f$var$bodyAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("p", {
        dangerouslySetInnerHTML: {
            __html: (0, $fKGH0.sanitize)(highlightedDescription)
        }
    })))));
};
const $401bf9e56224c57f$var$ConnectedArticleItem = (0, $f2mlD.default)((state)=>{
    return {
        isLoggedIn: (0, $3HBS2.isLoggedIn)(state),
        themeColor: (0, $3lfq2.getThemeColor)(state)
    };
})($401bf9e56224c57f$export$3a909d935747d7f7);
var $401bf9e56224c57f$export$2e2bcd8739ae039 = (0, $kIbto.default)()($401bf9e56224c57f$var$ConnectedArticleItem);
const $401bf9e56224c57f$var$containerStyles = (0, $9BVpB.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $401bf9e56224c57f$var$iconAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'icon',
    width: 'size.300',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    textDecoration: 'none'
});
const $401bf9e56224c57f$var$headingAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.large'
});
const $401bf9e56224c57f$var$subheadingStyles = (0, $9BVpB.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $401bf9e56224c57f$var$subheadingLeftAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $401bf9e56224c57f$var$headerRightAreaStylesInVisible = (0, $9BVpB.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $401bf9e56224c57f$var$headerRightAreaStylesVisible = (0, $9BVpB.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $401bf9e56224c57f$var$bodyAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $401bf9e56224c57f$var$jcsBodyAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'body',
    marginTop: 'space.0',
    overflowWrap: 'break-word'
});

});
parcelRegister("8aYMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $46c3623aaa5272f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e955bfb536b6c8db2982e28cab94e966>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46c3623aaa5272f1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSourceSystemEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "articleItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "excerpt"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "condition": "isSourceSystemEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sourceSystem"
                }
            ]
        },
        {
            "concreteType": "HelpObjectStoreArticleMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "articleMetadataFragmentV2"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$46c3623aaa5272f1$var$node.hash = "7da1cbe6e7f48ee2d870a75fe8f1d82c";
var $46c3623aaa5272f1$export$2e2bcd8739ae039 = $46c3623aaa5272f1$var$node;

});

parcelRegister("fKGH0", function(module, exports) {


module.exports = self.DOMPurify || (self.DOMPurify = (parcelRequire("kcG5t")).default || (parcelRequire("kcG5t")));

});
parcelRegister("kcG5t", function(module, exports) {
/*! @license DOMPurify 3.4.12 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.12/LICENSE */ 'use strict';
function $eb5593472c48f130$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $eb5593472c48f130$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $eb5593472c48f130$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $eb5593472c48f130$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eb5593472c48f130$var$_slicedToArray(r, e) {
    return $eb5593472c48f130$var$_arrayWithHoles(r) || $eb5593472c48f130$var$_iterableToArrayLimit(r, e) || $eb5593472c48f130$var$_unsupportedIterableToArray(r, e) || $eb5593472c48f130$var$_nonIterableRest();
}
function $eb5593472c48f130$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $eb5593472c48f130$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $eb5593472c48f130$var$_arrayLikeToArray(r, a) : void 0;
    }
}
const $eb5593472c48f130$var$entries = Object.entries, $eb5593472c48f130$var$setPrototypeOf = Object.setPrototypeOf, $eb5593472c48f130$var$isFrozen = Object.isFrozen, $eb5593472c48f130$var$getPrototypeOf = Object.getPrototypeOf, $eb5593472c48f130$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let $eb5593472c48f130$var$freeze = Object.freeze, $eb5593472c48f130$var$seal = Object.seal, $eb5593472c48f130$var$create = Object.create; // eslint-disable-line import/no-mutable-exports
let $eb5593472c48f130$var$_ref = typeof Reflect !== 'undefined' && Reflect, $eb5593472c48f130$var$apply = $eb5593472c48f130$var$_ref.apply, $eb5593472c48f130$var$construct = $eb5593472c48f130$var$_ref.construct;
if (!$eb5593472c48f130$var$freeze) $eb5593472c48f130$var$freeze = function freeze(x) {
    return x;
};
if (!$eb5593472c48f130$var$seal) $eb5593472c48f130$var$seal = function seal(x) {
    return x;
};
if (!$eb5593472c48f130$var$apply) $eb5593472c48f130$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$eb5593472c48f130$var$construct) $eb5593472c48f130$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $eb5593472c48f130$var$arrayForEach = $eb5593472c48f130$var$unapply(Array.prototype.forEach);
const $eb5593472c48f130$var$arrayLastIndexOf = $eb5593472c48f130$var$unapply(Array.prototype.lastIndexOf);
const $eb5593472c48f130$var$arrayPop = $eb5593472c48f130$var$unapply(Array.prototype.pop);
const $eb5593472c48f130$var$arrayPush = $eb5593472c48f130$var$unapply(Array.prototype.push);
const $eb5593472c48f130$var$arraySplice = $eb5593472c48f130$var$unapply(Array.prototype.splice);
const $eb5593472c48f130$var$arrayIsArray = Array.isArray;
const $eb5593472c48f130$var$stringToLowerCase = $eb5593472c48f130$var$unapply(String.prototype.toLowerCase);
const $eb5593472c48f130$var$stringToString = $eb5593472c48f130$var$unapply(String.prototype.toString);
const $eb5593472c48f130$var$stringMatch = $eb5593472c48f130$var$unapply(String.prototype.match);
const $eb5593472c48f130$var$stringReplace = $eb5593472c48f130$var$unapply(String.prototype.replace);
const $eb5593472c48f130$var$stringIndexOf = $eb5593472c48f130$var$unapply(String.prototype.indexOf);
const $eb5593472c48f130$var$stringTrim = $eb5593472c48f130$var$unapply(String.prototype.trim);
const $eb5593472c48f130$var$numberToString = $eb5593472c48f130$var$unapply(Number.prototype.toString);
const $eb5593472c48f130$var$booleanToString = $eb5593472c48f130$var$unapply(Boolean.prototype.toString);
const $eb5593472c48f130$var$bigintToString = typeof BigInt === 'undefined' ? null : $eb5593472c48f130$var$unapply(BigInt.prototype.toString);
const $eb5593472c48f130$var$symbolToString = typeof Symbol === 'undefined' ? null : $eb5593472c48f130$var$unapply(Symbol.prototype.toString);
const $eb5593472c48f130$var$objectHasOwnProperty = $eb5593472c48f130$var$unapply(Object.prototype.hasOwnProperty);
const $eb5593472c48f130$var$objectToString = $eb5593472c48f130$var$unapply(Object.prototype.toString);
const $eb5593472c48f130$var$regExpTest = $eb5593472c48f130$var$unapply(RegExp.prototype.test);
const $eb5593472c48f130$var$typeErrorCreate = $eb5593472c48f130$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $eb5593472c48f130$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $eb5593472c48f130$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $eb5593472c48f130$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $eb5593472c48f130$var$construct(Func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $eb5593472c48f130$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $eb5593472c48f130$var$stringToLowerCase;
    if ($eb5593472c48f130$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $eb5593472c48f130$var$setPrototypeOf(set, null);
    if (!$eb5593472c48f130$var$arrayIsArray(array)) return set;
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$eb5593472c48f130$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $eb5593472c48f130$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $eb5593472c48f130$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $eb5593472c48f130$var$clone(object) {
    const newObject = $eb5593472c48f130$var$create(null);
    for (const _ref2 of $eb5593472c48f130$var$entries(object)){
        var _ref3 = $eb5593472c48f130$var$_slicedToArray(_ref2, 2);
        const property = _ref3[0];
        const value = _ref3[1];
        const isPropertyExist = $eb5593472c48f130$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if ($eb5593472c48f130$var$arrayIsArray(value)) newObject[property] = $eb5593472c48f130$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $eb5593472c48f130$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */ function $eb5593472c48f130$var$stringifyValue(value) {
    switch(typeof value){
        case 'string':
            return value;
        case 'number':
            return $eb5593472c48f130$var$numberToString(value);
        case 'boolean':
            return $eb5593472c48f130$var$booleanToString(value);
        case 'bigint':
            return $eb5593472c48f130$var$bigintToString ? $eb5593472c48f130$var$bigintToString(value) : '0';
        case 'symbol':
            return $eb5593472c48f130$var$symbolToString ? $eb5593472c48f130$var$symbolToString(value) : 'Symbol()';
        case 'undefined':
            return $eb5593472c48f130$var$objectToString(value);
        case 'function':
        case 'object':
            {
                if (value === null) return $eb5593472c48f130$var$objectToString(value);
                const valueAsRecord = value;
                const valueToString = $eb5593472c48f130$var$lookupGetter(valueAsRecord, 'toString');
                if (typeof valueToString === 'function') {
                    const stringified = valueToString(valueAsRecord);
                    return typeof stringified === 'string' ? stringified : $eb5593472c48f130$var$objectToString(stringified);
                }
                return $eb5593472c48f130$var$objectToString(value);
            }
        default:
            return $eb5593472c48f130$var$objectToString(value);
    }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $eb5593472c48f130$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $eb5593472c48f130$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $eb5593472c48f130$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $eb5593472c48f130$var$unapply(desc.value);
        }
        object = $eb5593472c48f130$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
function $eb5593472c48f130$var$isRegex(value) {
    try {
        $eb5593472c48f130$var$regExpTest(value, '');
        return true;
    } catch (_unused) {
        return false;
    }
}
const $eb5593472c48f130$var$html$1 = $eb5593472c48f130$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $eb5593472c48f130$var$svg$1 = $eb5593472c48f130$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $eb5593472c48f130$var$svgFilters = $eb5593472c48f130$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $eb5593472c48f130$var$svgDisallowed = $eb5593472c48f130$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $eb5593472c48f130$var$mathMl$1 = $eb5593472c48f130$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $eb5593472c48f130$var$mathMlDisallowed = $eb5593472c48f130$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $eb5593472c48f130$var$text = $eb5593472c48f130$var$freeze([
    '#text'
]);
const $eb5593472c48f130$var$html = $eb5593472c48f130$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'command',
    'commandfor',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns'
]);
const $eb5593472c48f130$var$svg = $eb5593472c48f130$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dominant-baseline',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-orientation',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $eb5593472c48f130$var$mathMl = $eb5593472c48f130$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $eb5593472c48f130$var$xml = $eb5593472c48f130$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
const $eb5593472c48f130$var$MUSTACHE_EXPR = $eb5593472c48f130$var$seal(/{{[\w\W]*|^[\w\W]*}}/g);
const $eb5593472c48f130$var$ERB_EXPR = $eb5593472c48f130$var$seal(/<%[\w\W]*|^[\w\W]*%>/g);
const $eb5593472c48f130$var$TMPLIT_EXPR = $eb5593472c48f130$var$seal(/\${[\w\W]*/g);
const $eb5593472c48f130$var$DATA_ATTR = $eb5593472c48f130$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $eb5593472c48f130$var$ARIA_ATTR = $eb5593472c48f130$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $eb5593472c48f130$var$IS_ALLOWED_URI = $eb5593472c48f130$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $eb5593472c48f130$var$IS_SCRIPT_OR_DATA = $eb5593472c48f130$var$seal(/^(?:\w+script|data):/i);
const $eb5593472c48f130$var$ATTR_WHITESPACE = $eb5593472c48f130$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $eb5593472c48f130$var$DOCTYPE_NAME = $eb5593472c48f130$var$seal(/^html$/i);
const $eb5593472c48f130$var$CUSTOM_ELEMENT = $eb5593472c48f130$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
// Markup-significant character probes used by _sanitizeElements.
// Shared module-level instances are safe despite the sticky /g flags:
// unapply() resets lastIndex for RegExp receivers before every call.
const $eb5593472c48f130$var$ELEMENT_MARKUP_PROBE = $eb5593472c48f130$var$seal(/<[/\w!]/g);
const $eb5593472c48f130$var$COMMENT_MARKUP_PROBE = $eb5593472c48f130$var$seal(/<[/\w]/g);
const $eb5593472c48f130$var$FALLBACK_TAG_CLOSE = $eb5593472c48f130$var$seal(/<\/no(script|embed|frames)/i);
const $eb5593472c48f130$var$SELF_CLOSING_TAG = $eb5593472c48f130$var$seal(/\/>/i);
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $eb5593472c48f130$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    processingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
};
const $eb5593472c48f130$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $eb5593472c48f130$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $eb5593472c48f130$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
/**
 * Resolve a set-valued configuration option: a fresh set built from
 * cfg[key] when it is an own array property (seeded with a clone of
 * options.base when given, case-normalized via options.transform),
 * the fallback set otherwise.
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param fallback the set to use when the option is absent or not an array
 * @param options transform and optional base set to merge into
 * @returns the resolved set
 */ const $eb5593472c48f130$var$_resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
    return $eb5593472c48f130$var$objectHasOwnProperty(cfg, key) && $eb5593472c48f130$var$arrayIsArray(cfg[key]) ? $eb5593472c48f130$var$addToSet(options.base ? $eb5593472c48f130$var$clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
function $eb5593472c48f130$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $eb5593472c48f130$var$getGlobal();
    const DOMPurify = (root)=>$eb5593472c48f130$var$createDOMPurify(root);
    DOMPurify.version = '3.4.12';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $eb5593472c48f130$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let document = window1.document;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    window1.DocumentFragment;
    const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
    _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
    window1.HTMLFormElement;
    const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
    const ElementPrototype = Element.prototype;
    const cloneNode = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'parentNode');
    const getShadowRoot = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'shadowRoot');
    const getAttributes = $eb5593472c48f130$var$lookupGetter(ElementPrototype, 'attributes');
    const getNodeType = Node && Node.prototype ? $eb5593472c48f130$var$lookupGetter(Node.prototype, 'nodeType') : null;
    const getNodeName = Node && Node.prototype ? $eb5593472c48f130$var$lookupGetter(Node.prototype, 'nodeName') : null;
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    // The instance's own internal Trusted Types policy. Unlike a caller-supplied
    // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
    // on duplicate policy names — and is the only policy allowed to persist
    // across configurations and survive `clearConfig()`.
    let defaultTrustedTypesPolicy;
    let defaultTrustedTypesPolicyResolved = false;
    // Tracks whether we are already inside a call to the configured Trusted Types
    // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
    // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
    // re-enter the policy and recurse until the stack overflows. We detect that
    // re-entry and throw a clear, actionable error instead. The guard is shared
    // across both callbacks, because either one re-entering `sanitize` triggers
    // the same unbounded recursion.
    let IN_TRUSTED_TYPES_POLICY = 0;
    const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
        if (IN_TRUSTED_TYPES_POLICY > 0) throw $eb5593472c48f130$var$typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
    };
    const _createTrustedHTML = function _createTrustedHTML(html) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createHTML(html);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createScriptURL(scriptUrl);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    // Lazily resolve (and cache) the instance's internal default policy.
    // Resolution is attempted at most once: a successful `createPolicy` cannot be
    // repeated (Trusted Types throws on duplicate names), and a failed or
    // unsupported attempt must not be retried on every parse.
    const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
        if (!defaultTrustedTypesPolicyResolved) {
            defaultTrustedTypesPolicy = $eb5593472c48f130$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            defaultTrustedTypesPolicyResolved = true;
        }
        return defaultTrustedTypesPolicy;
    };
    const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
    const importNode = originalDocument.importNode;
    let hooks = $eb5593472c48f130$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $eb5593472c48f130$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const MUSTACHE_EXPR$1 = $eb5593472c48f130$var$MUSTACHE_EXPR, ERB_EXPR$1 = $eb5593472c48f130$var$ERB_EXPR, TMPLIT_EXPR$1 = $eb5593472c48f130$var$TMPLIT_EXPR, DATA_ATTR$1 = $eb5593472c48f130$var$DATA_ATTR, ARIA_ATTR$1 = $eb5593472c48f130$var$ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = $eb5593472c48f130$var$IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = $eb5593472c48f130$var$ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = $eb5593472c48f130$var$CUSTOM_ELEMENT;
    let IS_ALLOWED_URI$1 = $eb5593472c48f130$var$IS_ALLOWED_URI;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $eb5593472c48f130$var$addToSet({}, [
        ...$eb5593472c48f130$var$html$1,
        ...$eb5593472c48f130$var$svg$1,
        ...$eb5593472c48f130$var$svgFilters,
        ...$eb5593472c48f130$var$mathMl$1,
        ...$eb5593472c48f130$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $eb5593472c48f130$var$addToSet({}, [
        ...$eb5593472c48f130$var$html,
        ...$eb5593472c48f130$var$svg,
        ...$eb5593472c48f130$var$mathMl,
        ...$eb5593472c48f130$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($eb5593472c48f130$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal($eb5593472c48f130$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Pristine allowlist bindings captured at setConfig() time. On the
   * persistent-config path sanitize() restores the sets from these before
   * the per-walk hook clone-guard, so a hook's in-call widening cannot
   * carry across calls. Null until setConfig() is called; reset by
   * clearConfig(). */ let SET_CONFIG_ALLOWED_TAGS = null;
    let SET_CONFIG_ALLOWED_ATTR = null;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $eb5593472c48f130$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
        // the UA (customizable <select>) — including any on* handlers — and the
        // engine re-mirrors synchronously whenever a removal changes which
        // option/selectedcontent is current, even inside DOMPurify's inert
        // DOMParser document. Hoisting its children on removal re-inserts a fresh
        // mirror target ahead of the walk, which the engine refills, looping
        // forever (DoS) and amplifying output. Dropping its content on removal
        // (rather than hoisting) breaks that cascade; the content is a duplicate
        // of the option, which is sanitized on its own. See campaign-3 F1/F6.
        'selectedcontent',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $eb5593472c48f130$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $eb5593472c48f130$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $eb5593472c48f130$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $eb5593472c48f130$var$stringToString);
    const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = $eb5593472c48f130$var$freeze([
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let MATHML_TEXT_INTEGRATION_POINTS = $eb5593472c48f130$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    const DEFAULT_HTML_INTEGRATION_POINTS = $eb5593472c48f130$var$freeze([
        'annotation-xml'
    ]);
    let HTML_INTEGRATION_POINTS = $eb5593472c48f130$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $eb5593472c48f130$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $eb5593472c48f130$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $eb5593472c48f130$var$stringToString : $eb5593472c48f130$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $eb5593472c48f130$var$_resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
            transform: transformCaseFunc
        });
        ALLOWED_ATTR = $eb5593472c48f130$var$_resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
            transform: transformCaseFunc
        });
        ALLOWED_NAMESPACES = $eb5593472c48f130$var$_resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
            transform: $eb5593472c48f130$var$stringToString
        });
        URI_SAFE_ATTRIBUTES = $eb5593472c48f130$var$_resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
            transform: transformCaseFunc,
            base: DEFAULT_URI_SAFE_ATTRIBUTES
        });
        DATA_URI_TAGS = $eb5593472c48f130$var$_resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
            transform: transformCaseFunc,
            base: DEFAULT_DATA_URI_TAGS
        });
        FORBID_CONTENTS = $eb5593472c48f130$var$_resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
            transform: transformCaseFunc
        });
        FORBID_TAGS = $eb5593472c48f130$var$_resolveSetOption(cfg, 'FORBID_TAGS', $eb5593472c48f130$var$clone({}), {
            transform: transformCaseFunc
        });
        FORBID_ATTR = $eb5593472c48f130$var$_resolveSetOption(cfg, 'FORBID_ATTR', $eb5593472c48f130$var$clone({}), {
            transform: transformCaseFunc
        });
        USE_PROFILES = $eb5593472c48f130$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? $eb5593472c48f130$var$clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = $eb5593472c48f130$var$isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : $eb5593472c48f130$var$IS_ALLOWED_URI; // Default regexp
        NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
        MATHML_TEXT_INTEGRATION_POINTS = $eb5593472c48f130$var$objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? $eb5593472c48f130$var$clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : $eb5593472c48f130$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS); // Default built-in map
        HTML_INTEGRATION_POINTS = $eb5593472c48f130$var$objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? $eb5593472c48f130$var$clone(cfg.HTML_INTEGRATION_POINTS) : $eb5593472c48f130$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS); // Default built-in map
        const customElementHandling = $eb5593472c48f130$var$objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? $eb5593472c48f130$var$clone(cfg.CUSTOM_ELEMENT_HANDLING) : $eb5593472c48f130$var$create(null);
        CUSTOM_ELEMENT_HANDLING = $eb5593472c48f130$var$create(null);
        if ($eb5593472c48f130$var$objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
        if ($eb5593472c48f130$var$objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
        if ($eb5593472c48f130$var$objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
        $eb5593472c48f130$var$seal(CUSTOM_ELEMENT_HANDLING);
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $eb5593472c48f130$var$addToSet({}, $eb5593472c48f130$var$text);
            ALLOWED_ATTR = $eb5593472c48f130$var$create(null);
            if (USE_PROFILES.html === true) {
                $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, $eb5593472c48f130$var$html$1);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, $eb5593472c48f130$var$svg$1);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$svg);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, $eb5593472c48f130$var$svgFilters);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$svg);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, $eb5593472c48f130$var$mathMl$1);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$mathMl);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, $eb5593472c48f130$var$xml);
            }
        }
        /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        /* Merge configuration parameters */ if ($eb5593472c48f130$var$objectHasOwnProperty(cfg, 'ADD_TAGS')) {
            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else if ($eb5593472c48f130$var$arrayIsArray(cfg.ADD_TAGS)) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $eb5593472c48f130$var$clone(ALLOWED_TAGS);
                $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if ($eb5593472c48f130$var$objectHasOwnProperty(cfg, 'ADD_ATTR')) {
            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else if ($eb5593472c48f130$var$arrayIsArray(cfg.ADD_ATTR)) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $eb5593472c48f130$var$clone(ALLOWED_ATTR);
                $eb5593472c48f130$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if ($eb5593472c48f130$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && $eb5593472c48f130$var$arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) $eb5593472c48f130$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if ($eb5593472c48f130$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && $eb5593472c48f130$var$arrayIsArray(cfg.FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $eb5593472c48f130$var$clone(FORBID_CONTENTS);
            $eb5593472c48f130$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if ($eb5593472c48f130$var$objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && $eb5593472c48f130$var$arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $eb5593472c48f130$var$clone(FORBID_CONTENTS);
            $eb5593472c48f130$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $eb5593472c48f130$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        // Re-derive the active Trusted Types policy from this configuration on
        // every parse. The active policy must never be sticky closure state that
        // outlives the config that set it: a caller-supplied policy left in place
        // after `clearConfig()` — or after a later call that supplied none, or
        // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
        // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
        // See GHSA-vxr8-fq34-vvx9.
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $eb5593472c48f130$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $eb5593472c48f130$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // A caller-supplied policy applies to this configuration only.
            const previousTrustedTypesPolicy = trustedTypesPolicy;
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`. If the supplied policy's
            // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
            // throws via the re-entrancy guard. Restore the previous policy first so
            // the instance is not left in a poisoned state. See #1422.
            try {
                emptyHTML = _createTrustedHTML('');
            } catch (error) {
                trustedTypesPolicy = previousTrustedTypesPolicy;
                throw error;
            }
        } else if (cfg.TRUSTED_TYPES_POLICY === null) {
            // Explicit opt-out for this call: perform no Trusted Types signing and
            // create nothing (so a strict `trusted-types` CSP that disallows a
            // `dompurify` policy can still call `sanitize` from inside its own
            // policy — see #1422). Resetting to `undefined` rather than a sticky
            // `null` also drops any previously retained caller policy, so it cannot
            // resurface on a later call, while still allowing the next config-less
            // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
            trustedTypesPolicy = undefined;
            emptyHTML = '';
        } else {
            // No policy supplied: keep the currently active policy if one is set — a
            // previously supplied policy is intentionally sticky across config-less
            // calls — otherwise fall back to the instance's own internal policy,
            // created at most once. (A policy supplied for a *single* call still
            // lingers by design; what must not linger is a policy whose configuration
            // has been torn down via `clearConfig()`, which restores the default.)
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
            // Sign internal variables only when a policy is active. A falsy policy
            // (Trusted Types unsupported, creation failed, or an explicit opt-out)
            // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
            // a non-policy and throw. See #1422.
            if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($eb5593472c48f130$var$freeze) $eb5593472c48f130$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $eb5593472c48f130$var$addToSet({}, [
        ...$eb5593472c48f130$var$svg$1,
        ...$eb5593472c48f130$var$svgFilters,
        ...$eb5593472c48f130$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $eb5593472c48f130$var$addToSet({}, [
        ...$eb5593472c48f130$var$mathMl$1,
        ...$eb5593472c48f130$var$mathMlDisallowed
    ]);
    /**
   * Namespace rules for an element in the SVG namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
        // The only way to switch from MathML to SVG is via <svg>
        // if the parent is either <annotation-xml> or a MathML
        // text integration point.
        if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the MathML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the HTML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    };
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $eb5593472c48f130$var$stringToLowerCase(element.tagName);
        const parentTagName = $eb5593472c48f130$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $eb5593472c48f130$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            /* The normal detach failed — this is reached for a parentless node
         (getParentNode() is null, so .removeChild throws). Element.prototype
         .remove() is itself a spec no-op on a parentless node, so a recorded
         "removal" would otherwise hand the caller back an intact,
         payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
         the style-with-element-child rule decided to kill). Fail closed by
         throwing — exactly as a clobbered root does at the IN_PLACE entry —
         rather than trying to "neutralize" the node via its own methods.
         Neutralizing would mean calling getAttributeNames()/removeAttribute()
         on the node, both of which a <form> root can clobber via a named child
         (and _isClobbered does not even probe getAttributeNames), so the
         neutralize step could itself be silently defeated, leaving the payload
         intact. A throw touches only the cached, clobber-safe remove() and
         getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
         to every root-kill reason. REPORT-3.
                This lives inside the catch, so it never fires for a normally-removed
         in-tree node: those have a parent, removeChild() succeeds, and the
         catch is not entered. Only a kept (parentless) root reaches here. */ remove(node);
            if (!getParentNode(node)) throw $eb5593472c48f130$var$typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
        }
    };
    /**
   * _neutralizeRoot
   *
   * Fail-closed teardown of an in-place root after the sanitize walk aborts
   * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
   * custom element's reaction detaches a node so `_forceRemove`'s deliberate
   * parentless guard throws, or any other re-entrant engine mutation — would
   * otherwise leave the caller's *live* tree half-sanitized, with everything
   * after the abort point still carrying its handlers. There is no safe way
   * to resume the walk (the tree mutated under us), so we strip the root bare:
   * remove every child and every attribute, then let the caller's catch see
   * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
   * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
   *
   * @param root the in-place root to empty
   */ const _neutralizeRoot = function _neutralizeRoot(root) {
        /* Strip every disallowed attribute (on* handlers included) off the whole
       subtree BEFORE detaching anything. Detaching first would hand back
       handler-bearing originals (e.g. an already-loading `<img onerror>`)
       whose queued resource event still fires in page scope after we throw.
       Clobber-safe reads; a doomed clobbered node's own attributes are
       irrelevant while its non-clobbered descendants are reached and scrubbed. */ _neutralizeSubtree(root);
        const childNodes = getChildNodes(root);
        if (childNodes) {
            const snapshot = [];
            $eb5593472c48f130$var$arrayForEach(childNodes, (child)=>{
                $eb5593472c48f130$var$arrayPush(snapshot, child);
            });
            $eb5593472c48f130$var$arrayForEach(snapshot, (child)=>{
                try {
                    remove(child);
                } catch (_) {
                /* Best-effort teardown; a still-attached child is handled below */ }
            });
        }
        const attributes = getAttributes(root);
        if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name === 'string') try {
                root.removeAttribute(name);
            } catch (_) {
            /* Clobbered removeAttribute — ignore (fail-closed best effort) */ }
        }
    };
    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
        try {
            $eb5593472c48f130$var$arrayPush(DOMPurify.removed, {
                attribute: element.getAttributeNode(name),
                from: element
            });
        } catch (_) {
            $eb5593472c48f130$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: element
            });
        }
        element.removeAttribute(name);
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _stripDisallowedAttributes
   *
   * Removes every attribute the active configuration does not allow from a
   * single element, using the same allowlist as the main attribute pass (so
   * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
   * neutralise nodes that are being discarded from an in-place tree.
   *
   * @param element the element to strip
   */ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
        const attributes = getAttributes(element);
        if (!attributes) return;
        for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
            try {
                element.removeAttribute(name);
            } catch (_) {
            /* Clobbered removeAttribute on a doomed node — ignore */ }
        }
    };
    /**
   * _neutralizeSubtree
   *
   * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
   * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
   * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
   * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
   * those dropped nodes are detached from the caller's LIVE tree but a
   * handler-bearing original among them (an `<img onerror>`/`<video>` that was
   * loading) keeps its queued resource event, which fires in page scope after
   * sanitize returns. This walks a removed subtree and strips every attribute
   * the active configuration does not allow — so `on*` handlers are cancelled
   * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
   * blocklist. Run synchronously before sanitize returns, i.e. before any
   * queued event can fire. Hook-free by design: these nodes leave the output,
   * so firing attribute hooks for them would be surprising. Clobber-safe reads;
   * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
   * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
   * the `<img>`, are reached and scrubbed).
   *
   * @param root the root of a removed subtree to neutralise
   */ const _neutralizeSubtree = function _neutralizeSubtree(root) {
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            if (nodeType === $eb5593472c48f130$var$NODE_TYPE.element) _stripDisallowedAttributes(node);
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _neutralizePatchLinkage
   *
   * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
   * hardening, https://github.com/WICG/declarative-partial-updates).
   *
   * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
   * markers (PIs / markup comments) node-by-node, in document order, AS it
   * reaches each node. On a live in-place root that leaves a window: from the
   * moment the root is connected until the walk arrives at a given node, that
   * node's linkage is live. A patch applied on connection/stream can fire as
   * a microtask during the walk and inject or teleport an unsanitized DOM
   * range into a region the iterator has already passed and will not revisit,
   * so the post-return "tree is sanitized" contract is violated. Sweep the
   * whole tree once up front and sever every linkage before the walk begins,
   * closing that window.
   *
   * This CANNOT undo a patch that already fired before sanitize ran — that is
   * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
   * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
   * to group with the rest of the declarative-partial-updates handling and
   * stay overridable, consistent with the codebase.
   *
   * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
   * clobbered root cannot defeat the sweep of its non-clobbered descendants.
   *
   * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
   * .html Q1): this mirrors the existing policy of keeping `for` on
   * <label>/<output>. If the shipping feature can drive a patch through a
   * surviving `for`-on-label/output + `id` pair, this pre-pass and the
   * attribute check at _isBasicCustomElement's caller must additionally drop
   * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
   *
   * @param root the in-place root to sweep
   */ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
        if (!SAFE_FOR_XML) return;
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            /* Remove range markers (the target side of a patch linkage): every
         processing instruction, and any markup-bearing comment. */ if (nodeType === $eb5593472c48f130$var$NODE_TYPE.processingInstruction || nodeType === $eb5593472c48f130$var$NODE_TYPE.comment && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$COMMENT_MARKUP_PROBE, node.data)) {
                try {
                    remove(node);
                } catch (_) {
                /* Best-effort */ }
                continue;
            }
            /* Strip patch-source attributes (the source side) off elements. */ if (nodeType === $eb5593472c48f130$var$NODE_TYPE.element) {
                const element = node;
                const lcTag = transformCaseFunc(getNodeName ? getNodeName(node) : node.nodeName);
                try {
                    if (element.hasAttribute && element.hasAttribute('patchsrc')) element.removeAttribute('patchsrc');
                    if (element.hasAttribute && element.hasAttribute('for') && lcTag !== 'label' && lcTag !== 'output') element.removeAttribute('for');
                } catch (_) {
                /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */ }
            }
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $eb5593472c48f130$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * Replace template expression syntax (mustache, ERB, template
   * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
   * sites. Order matters: mustache, then ERB, then template literal.
   *
   * @param value the string to scrub
   * @returns the scrubbed string
   */ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
        value = $eb5593472c48f130$var$stringReplace(value, MUSTACHE_EXPR$1, ' ');
        value = $eb5593472c48f130$var$stringReplace(value, ERB_EXPR$1, ' ');
        value = $eb5593472c48f130$var$stringReplace(value, TMPLIT_EXPR$1, ' ');
        return value;
    };
    /**
   * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
   * character data of an element subtree. Used as the final safety net for
   * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
   * which only form after text-node normalization (e.g. fragments split across
   * stripped elements) cannot survive into a template-evaluating framework.
   *
   * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
   * in place rather than round-tripping through innerHTML. This preserves
   * descendant node references (important for IN_PLACE callers), avoids a
   * serialize/reparse cycle, and reads literal character data — which means
   * `<%...%>` in text content matches the ERB regex against its real bytes
   * instead of the HTML-entity-escaped form innerHTML would produce.
   *
   * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
   * attributes is performed during the per-node `_sanitizeAttributes` pass.
   *
   * @param node The root element whose character data should be scrubbed.
   */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
        var _node$querySelectorAl;
        node.normalize();
        const walker = createNodeIterator.call(node.ownerDocument || node, node, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
        let currentNode = walker.nextNode();
        while(currentNode){
            currentNode.data = _stripTemplateExpressions(currentNode.data);
            currentNode = walker.nextNode();
        }
        // NodeIterator does not descend into <template>.content per the DOM spec,
        // so we must explicitly recurse into each template's content fragment,
        // mirroring the approach used by _sanitizeShadowDOM.
        const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
        if (templates) $eb5593472c48f130$var$arrayForEach(templates, (tmpl)=>{
            if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
        });
    };
    /**
   * _isClobbered
   *
   * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
   * interface with [LegacyOverrideBuiltIns]; a descendant element with a
   * `name` attribute matching a prototype property shadows that property
   * on direct reads. We use this check at the IN_PLACE entry-point and
   * during attribute sanitization to refuse clobbered forms.
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        // Realm-independent tag-name probe. If we can't determine the tag
        // name at all, we can't reason about clobbering — return false
        // (the caller's other defences still apply).
        const realTagName = getNodeName ? getNodeName(element) : null;
        if (typeof realTagName !== 'string') return false;
        if (transformCaseFunc(realTagName) !== 'form') return false;
        return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
        // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
        // makes the direct read diverge from the cached read; a clean form
        // (same-realm OR foreign-realm) has both reads pointing at the same
        // canonical NamedNodeMap.
        element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
        // returns the integer 1 for any Element regardless of realm; direct
        // read on a clobbered form (e.g. <input name="nodeType">) returns
        // the named child element. Cheap addition — nodeType is read from
        // an internal slot, no serialization cost — and removes a residual
        // clobbering surface used by several mXSS / PI / comment branches
        // in _sanitizeElements that compare currentNode.nodeType directly.
        element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
        // "childNodes" shadows the prototype getter. Direct reads of
        // form.childNodes from a clobbered form return the named child
        // instead of the real NodeList, so any walk that reads it directly
        // skips the form's real children. Compare the direct read to the
        // cached Node.prototype getter — when the form's named-property
        // getter intercepts the read, the two values differ and we flag
        // the form. This catches every clobbering child type (input,
        // select, etc.) regardless of whether the named child happens to
        // carry a numeric .length, which a typeof-based probe would miss
        // (e.g. HTMLSelectElement.length is a defined unsigned-long).
        element.childNodes !== getChildNodes(element);
    };
    /**
   * Checks whether the given value is a DocumentFragment from any realm.
   *
   * The realm-independent replacement reads `nodeType` through the cached
   * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
   * constant (11). nodeType is a numeric value resolved from the node's
   * internal slot, identical across realms for the same kind of node.
   *
   * @param value object to check
   * @return true if value is a DocumentFragment-shaped node from any realm
   */ const _isDocumentFragment = function _isDocumentFragment(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return getNodeType(value) === $eb5593472c48f130$var$NODE_TYPE.documentFragment;
        } catch (_) {
            return false;
        }
    };
    /**
   * Checks whether the given object is a DOM node, including nodes that
   * originate from a different window/realm (e.g. an iframe's
   * contentDocument). The previous `value instanceof Node` check was
   * realm-bound: nodes from a different window failed it, causing
   * sanitize() to silently stringify them and reset IN_PLACE to false,
   * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
   *
   * @param value object to check whether it's a DOM node
   * @return true if value is a DOM node from any realm
   */ const _isNode = function _isNode(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return typeof getNodeType(value) === 'number';
        } catch (_) {
            return false;
        }
    };
    function _executeHooks(hooks, currentNode, data) {
        if (hooks.length === 0) return;
        $eb5593472c48f130$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * Structural-threat checks that condemn a node regardless of the
   * allowlists: mXSS via namespace confusion, risky CSS construction,
   * processing instructions, markup-bearing comments. Pure predicate;
   * the caller removes. Check order is load-bearing.
   *
   * @param currentNode the node to inspect
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node must be removed
   */ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$ELEMENT_MARKUP_PROBE, currentNode.textContent) && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
        /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) return true;
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $eb5593472c48f130$var$NODE_TYPE.processingInstruction) return true;
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $eb5593472c48f130$var$NODE_TYPE.comment && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$COMMENT_MARKUP_PROBE, currentNode.data)) return true;
        return false;
    };
    /**
   * Handle a node whose tag is forbidden or not allowlisted: keep
   * allowed custom elements (false return exits _sanitizeElements
   * early - the namespace and fallback-tag removal checks are
   * intentionally skipped for kept custom elements), else hoist
   * content per KEEP_CONTENT and remove.
   *
   * A kept custom element is the ONLY case in which this function
   * returns false, so the caller uses that return value to run the
   * afterSanitizeElements hook on the kept element and keep the
   * element-hook lifecycle consistent with normal allowlisted
   * elements (GHSA-c2j3-45gr-mqc4).
   *
   * @param currentNode the disallowed node
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node was removed, false if kept
   */ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName) {
        /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $eb5593472c48f130$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements.
         Use the cached prototype getters exclusively — the previous code
         had `|| currentNode.parentNode` / `|| currentNode.childNodes`
         fallbacks, but the cached getters always return the canonical
         value (or null for a real parent-less node), so the fallback
         path was dead in safe cases and a clobbering surface in unsafe
         ones. Falsy cached results stay falsy; the `if (childNodes &&
         parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            const parentNode = getParentNode(currentNode);
            const childNodes = getChildNodes(currentNode);
            if (childNodes && parentNode) {
                const childCount = childNodes.length;
                /* In-place: hoist the *original* children so the iterator visits
             and sanitises them through the same allowlist pass as every other
             node. The caller built the tree in the live document, so the
             originals carry already-queued resource events (`<img onerror>`,
             `<video>`/`<audio>` error, lazy/`onload`, …); cloning would leave
             those originals detached but still armed, firing in page scope
             while the returned tree looked clean. Moving is safe in-place: the
             root is pre-validated as an allowed tag and so is never the node
             being removed, which keeps `parentNode` inside the iterator root
             and the relocated child inside the serialised tree.
                      Otherwise (string / DOM-copy paths): clone. The iterator is rooted
             at — and the result serialised from — `body`, so a restrictive
             ALLOWED_TAGS that removes `body` itself must leave its content in
             place, which only cloning does; and those paths parse into an
             inert document, so their discarded originals never had a queued
             event to neutralise.
                      `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
             valid whether we move (drops the trailing entry) or clone (leaves
             the list intact). */ for(let i = childCount - 1; i >= 0; --i){
                    const hoisted = IN_PLACE ? childNodes[i] : cloneNode(childNodes[i], true);
                    parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                }
            }
        }
        _forceRemove(currentNode);
        return true;
    };
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ // eslint-disable-next-line complexity
    const _sanitizeElements = function _sanitizeElements(currentNode, root) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* A hook may have detached the node — treat it as removed (see the
       detached-node comment after the uponSanitizeElement hook below). */ if (currentNode !== root && getParentNode(currentNode) === null) return true;
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(getNodeName ? getNodeName(currentNode) : currentNode.nodeName);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* A hook may have detached the node from the tree — a long-standing
       user pattern (issue #469; draw.io-style foreignObject filtering).
       Per the cached, unclobberable parentNode getter the node is
       genuinely out of the tree, so it can reach neither the serialized
       output nor an IN_PLACE live tree; treat it as removed and stop
       processing it. Without this guard, the unsafe-node / namespace
       checks below would call _forceRemove on a parentless node and hit
       the REPORT-3 fail-closed throw — which exists for nodes DOMPurify
       wants gone but *cannot* detach (clobbered / parentless roots), the
       opposite of a node that is already safely gone. The walk root is
       exempt: a detached IN_PLACE root is legitimate input and must still
       be fully sanitized, and a kill-decision on it must keep hitting the
       REPORT-3 throw. Nodes detached by hooks are the hook's
       responsibility: they are not recorded in DOMPurify.removed and are
       not neutralized by the post-walk IN_PLACE pass. */ if (currentNode !== root && getParentNode(currentNode) === null) return true;
        /* Remove mXSS vectors, processing instructions and risky comments */ if (_isUnsafeNode(currentNode, tagName)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            const removed = _sanitizeDisallowedNode(currentNode, tagName);
            /* A false return means the node is a custom element kept via
         CUSTOM_ELEMENT_HANDLING - the only keep path through
         _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
         element-hook lifecycle matches normal allowlisted elements: a
         security policy applied in this hook (e.g. stripping an attribute
         from every surviving element) must not silently skip kept custom
         elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
         tail below - the hook runs, then the walker's subsequent
         _sanitizeAttributes pass sanitizes the element's attributes. The
         deliberately skipped namespace and fallback-tag removal checks stay
         skipped; they are removal decisions, not the hook contract. */ if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return removed;
        }
        /* Check whether element has a valid namespace.
       Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
       nodeType getter rather than `instanceof Element`, which is realm-
       bound and short-circuits to false for any node minted in a different
       realm — letting a foreign-realm element with a forbidden namespace
       slip past the namespace check entirely. */ const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
        if (nt === $eb5593472c48f130$var$NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $eb5593472c48f130$var$NODE_TYPE.text) {
            /* Get the element's text content */ const content = _stripTemplateExpressions(currentNode.textContent);
            if (currentNode.textContent !== content) {
                $eb5593472c48f130$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
        /* Reject declarative-partial-updates patch-linkage attributes
       (https://github.com/WICG/declarative-partial-updates).
            Empirical note (Chrome 150, verified — see
       test/declarative-patch-probe-v3.html): expansion is NOT applied after
       sanitization. For the string path it fires during sanitize()'s own
       parse, so the walk sees and sanitizes the fully materialized expanded
       tree — teleports into MathML/SVG integration points included; a
       weaponized `<template for>`->`<img onerror>` comes back with the handler
       stripped. For the IN_PLACE path it fires on connection, before the walk.
       Either way DOMPurify is NOT blind to the patch.
            This removal is therefore defense-in-depth rather than the sole barrier:
       it prevents live linkage from surviving into the OUTPUT and re-expanding
       in the caller's context, and keeps behaviour deterministic if a future
       engine defers expansion. `for` is legitimate only on <label>/<output>;
       anywhere else (notably <template for>) it links the element to a patch
       target and teleports or removes an arbitrary DOM range by id/marker name.
       `patchsrc` fetches remote markup and is treated as a script-loading
       mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
       other structural-threat checks and stays overridable, consistent with
       the rest of the codebase. PI range markers are already removed by
       _isUnsafeNode. */ if (SAFE_FOR_XML && lcName === 'patchsrc') return false;
        if (SAFE_FOR_XML && lcName === 'for' && lcTag !== 'label' && lcTag !== 'output') return false;
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && $eb5593472c48f130$var$regExpTest(DATA_ATTR$1, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $eb5593472c48f130$var$regExpTest(ARIA_ATTR$1, lcName)) ;
        else if (!nameIsPermitted) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $eb5593472c48f130$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $eb5593472c48f130$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $eb5593472c48f130$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($eb5593472c48f130$var$regExpTest(IS_ALLOWED_URI$1, $eb5593472c48f130$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $eb5593472c48f130$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$eb5593472c48f130$var$regExpTest(IS_SCRIPT_OR_DATA$1, $eb5593472c48f130$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
        else if (value) return false;
        return true;
    };
    /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = $eb5593472c48f130$var$addToSet({}, [
        'annotation-xml',
        'color-profile',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'missing-glyph'
    ]);
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return !RESERVED_CUSTOM_ELEMENT_NAMES[$eb5593472c48f130$var$stringToLowerCase(tagName)] && $eb5593472c48f130$var$regExpTest(CUSTOM_ELEMENT$1, tagName);
    };
    /**
   * Wrap an attribute value in the matching Trusted Types object when
   * the active policy requires it. Namespaced attributes pass through
   * unchanged (no TT support yet, see
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
   *
   * @param lcTag lowercase tag name of the containing element
   * @param lcName lowercase attribute name
   * @param namespaceURI the attribute's namespace, if any
   * @param value the attribute value to wrap
   * @return the value, wrapped when Trusted Types demand it
   */ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
        if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
            case 'TrustedHTML':
                return _createTrustedHTML(value);
            case 'TrustedScriptURL':
                return _createTrustedScriptURL(value);
        }
        return value;
    };
    /**
   * Write a modified attribute value back onto the element. On
   * success, re-probe for clobbering introduced by the new value and
   * remove the element when found; otherwise pop the removal entry
   * recorded by the earlier _removeAttribute (long-standing pairing
   * with the SANITIZE_NAMED_PROPS path - do not "fix" casually). On
   * failure, remove the attribute instead.
   *
   * @param currentNode the element carrying the attribute
   * @param name the attribute name as present on the element
   * @param namespaceURI the attribute's namespace, if any
   * @param value the new attribute value
   */ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
        try {
            if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
            else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
            if (_isClobbered(currentNode)) _forceRemove(currentNode);
            else $eb5593472c48f130$var$arrayPop(DOMPurify.removed);
        } catch (_) {
            _removeAttribute(name, currentNode);
        }
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const attributes = currentNode.attributes;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        const lcTag = transformCaseFunc(currentNode.nodeName);
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $eb5593472c48f130$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && $eb5593472c48f130$var$stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            // Else: already prefixed, leave the attribute alone — the prefix is
            // itself the clobbering protection, and re-applying it is incorrect.
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $eb5593472c48f130$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && $eb5593472c48f130$var$stringMatch(value, 'href')) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Did the hooks force-keep the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$SELF_CLOSING_TAG, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
            /* Is `value` valid for this attribute? */ if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Handle attributes that require Trusted Types */ value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) _setAttributeValue(currentNode, name, namespaceURI, value);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode, fragment);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
         DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
         recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
            /* An element iterated here may itself host an attached
         shadow root. The default NodeIterator does not enter shadow
         trees, so a shadow root nested inside template.content was
         previously reached by no walk at all (the pre-pass at
         _sanitizeAttachedShadowRoots descends via childNodes, which
         doesn't enter template.content; the template-content recursion
         above iterates the content but never inspected shadowRoot).
         Walk it explicitly. The nodeType guard avoids reading
         shadowRoot off text / comment / CDATA / PI nodes that the
         iterator also surfaces. */ const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
            if (shadowNodeType === $eb5593472c48f130$var$NODE_TYPE.element) {
                const innerSr = getShadowRoot(shadowNode);
                if (_isDocumentFragment(innerSr)) {
                    _sanitizeAttachedShadowRoots(innerSr);
                    _sanitizeShadowDOM2(innerSr);
                }
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    /**
   * _sanitizeAttachedShadowRoots
   *
   * Walks `root` and feeds every attached shadow root we encounter into
   * the existing _sanitizeShadowDOM pipeline. The default node iterator
   * does not descend into shadow trees, so nodes inside an attached
   * shadow root would otherwise be skipped entirely.
   *
   * Two real input paths put attached shadow roots in front of us:
   *   1. IN_PLACE on a DOM node that already has shadow roots attached.
   *   2. DOM-node input where importNode(dirty, true) deep-clones the
   *      shadow root because it was created with `clonable: true`.
   *
   * This pass runs once, up front, so the main iteration loop (and the
   * existing _sanitizeShadowDOM template-content recursion) stay
   * untouched — string-input paths are not affected.
   *
   * @param root the subtree root to walk for attached shadow roots
   */ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
        /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
       impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
       built straight into the DOM — the IN_PLACE surface) deeper than the JS
       call-stack budget would otherwise overflow native recursion here and
       throw at the IN_PLACE entry pre-pass, before a single node is
       sanitized, leaving the caller's live tree untouched (fail-open). See
       campaign-3 F4. A heap stack keeps depth off the call stack.
            Each work item is either a node to descend into, or a deferred
       `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
       form preserves the original post-order discipline: a shadow root's
       nested shadow roots are discovered before the outer shadow is
       sanitized (which may remove hosts). Pushes are in reverse of the
       desired processing order (LIFO): template content, then children, then
       the shadow-sanitize, then the shadow walk — so the order matches the
       previous recursion exactly. */ const stack = [
            {
                node: root,
                shadow: null
            }
        ];
        while(stack.length > 0){
            const item = stack.pop();
            /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */ if (item.shadow) {
                _sanitizeShadowDOM2(item.shadow);
                continue;
            }
            const node = item.node;
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            const isElement = nodeType === $eb5593472c48f130$var$NODE_TYPE.element;
            /* (pushed last → processed first) Children, snapshotted in reverse so
         the first child is processed first. Snapshotting matters because a
         hook may detach siblings mid-walk. */ const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                node: childNodes[i],
                shadow: null
            });
            /* (pushed before children → processed after them, matching the old
         "template content last" order) When the node is a <template>,
         descend into its content. */ if (isElement) {
                const rootName = getNodeName ? getNodeName(node) : null;
                if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                    const content = node.content;
                    if (_isDocumentFragment(content)) stack.push({
                        node: content,
                        shadow: null
                    });
                }
            }
            /* Shadow root (processed first): walk its subtree, then sanitise it.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
         rather than `instanceof DocumentFragment`, which is realm-bound and
         silently skipped foreign-realm shadow roots (e.g.
         iframe.contentDocument attachShadow). */ if (isElement) {
                const sr = getShadowRoot(node);
                if (_isDocumentFragment(sr)) /* Push the deferred sanitise first so it pops after the shadow
             walk we push next, i.e. nested shadow roots are discovered
             before this one is sanitised. */ stack.push({
                    node: null,
                    shadow: sr
                }, {
                    node: sr,
                    shadow: null
                });
            }
        }
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            dirty = $eb5593472c48f130$var$stringifyValue(dirty);
            if (typeof dirty !== 'string') throw $eb5593472c48f130$var$typeErrorCreate('dirty is not a string, aborting');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (SET_CONFIG) {
            /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
       * not re-derived per call. Restore them from the pristine bindings
       * captured at setConfig() time so a previous call's hook clone (mutated
       * below) does not carry over. */ ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
            ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
        } else _parseConfig(cfg);
        /* Clone the hook-mutable allowlists before the walk whenever an
     * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
     * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
     * a hook that widens them would otherwise mutate the shared set
     * permanently: across later calls and across every element. Cloning per
     * walk keeps documented in-call widening working while scoping it to the
     * call. A single guard for both config paths - the per-call path rebinds
     * the sets in _parseConfig each call, the persistent path restores them
     * from the captured bindings just above - so the two cannot diverge. */ if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = $eb5593472c48f130$var$clone(ALLOWED_TAGS);
        if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = $eb5593472c48f130$var$clone(ALLOWED_ATTR);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Resolve IN_PLACE for this call without mutating persistent config.
       Writing the IN_PLACE closure variable here leaks under setConfig(),
       where _parseConfig is skipped on later calls: a single string call would
       disable in-place mode for every subsequent node call, returning a
       sanitized copy while leaving the caller's node — which in-place callers
       keep using and whose return value they ignore — unsanitized. REPORT-2. */ const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
        if (inPlace) {
            /* Declarative-partial-updates / streaming pre-pass: sever every patch
         linkage across the live tree BEFORE the walk, so no patch can fire
         mid-walk and inject into an already-processed region. Runs first, so
         it also covers the forbidden/clobbered roots that throw below. */ _neutralizePatchLinkage(dirty);
            /* Do some early pre-sanitization to avoid unsafe root nodes.
         Read nodeName through the cached prototype getter — a clobbering
         child named "nodeName" on the form root would otherwise shadow
         the property and let this check skip the root-allowlist
         validation entirely. */ const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
            if (typeof nn === 'string') {
                const tagName = transformCaseFunc(nn);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                    /* Fail closed on a live root: neutralize handlers/children before
             throwing, exactly as the mid-walk abort path does. */ _neutralizeRoot(dirty);
                    throw $eb5593472c48f130$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            }
            /* Pre-flight the root through _isClobbered. The iterator-driven
         removal path can not detach a parent-less root: _forceRemove
         falls through to Element.prototype.remove(), which per spec
         is a no-op on a node with no parent. A clobbered root would
         then survive the main loop with its attributes uninspected,
         because _sanitizeAttributes early-returns on _isClobbered. The
         result would be an attacker-controlled form, complete with any
         event-handler attributes the caller passed in, handed back to
         the application unsanitized. Refuse to sanitize such a root
         the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) {
                /* Fail closed on a live clobbered root before throwing.
           _neutralizeRoot's reads are clobber-safe (cached getters); the
           form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */ _neutralizeRoot(dirty);
                throw $eb5593472c48f130$var$typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
            }
            /* Sanitize attached shadow roots before the main iterator runs.
         The iterator does not descend into shadow trees. Same fail-closed
         barrier as the main walk (campaign-3 F2): a custom-element reaction
         inside a shadow root could abort this pre-pass before the walk runs,
         which would otherwise leave the entire live tree unsanitized. */ try {
                _sanitizeAttachedShadowRoots(dirty);
            } catch (error) {
                _neutralizeRoot(dirty);
                throw error;
            }
        } else if (_isNode(dirty)) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $eb5593472c48f130$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
            /* Clonable shadow roots are deep-cloned by importNode(); sanitize
         them before the main iterator runs, since the iterator does not
         descend into shadow trees. The walk routes every read through a
         cached prototype getter so clobbering descendants on a form root
         cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const walkRoot = inPlace ? dirty : body;
        const nodeIterator = _createNodeIterator(walkRoot);
        /* Now start iterating over the created document.
       The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
       engine/custom-element mutation can detach a node mid-walk so
       `_forceRemove`'s parentless guard throws, aborting the loop. Without the
       barrier the caller's in-place tree would be left half-sanitized with the
       unvisited tail still armed. On any throw we fail closed — strip the
       in-place root bare — then rethrow so the existing throw contract is
       preserved. (String/DOM-copy paths never return the partial body, so the
       propagating throw is already fail-closed there.) */ try {
            while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode, walkRoot);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
        } catch (error) {
            if (inPlace) {
                _neutralizeRoot(dirty);
                /* Nodes _forceRemove'd earlier in the aborted walk are already
           detached from the root, so _neutralizeRoot's subtree pass does not
           reach them. Defuse them too, mirroring the success-path loop below. */ $eb5593472c48f130$var$arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) _neutralizeSubtree(entry.element);
                });
            }
            throw error;
        }
        /* If we sanitized `dirty` in-place, return it. */ if (inPlace) {
            /* Fail-closed completion of the audit-5 F1 fix: every node removed from
         the caller's live tree is detached but may still hold a queued
         resource-event handler that fires in page scope after we return. The
         move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
         non-allow-listed attributes off every other removed subtree (clobber,
         mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
         cancelled before any event can fire. Runs synchronously, pre-return. */ $eb5593472c48f130$var$arrayForEach(DOMPurify.removed, (entry)=>{
                if (entry.element) _neutralizeSubtree(entry.element);
            });
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
            return dirty;
        }
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $eb5593472c48f130$var$regExpTest($eb5593472c48f130$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
        SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
        SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
        SET_CONFIG_ALLOWED_TAGS = null;
        SET_CONFIG_ALLOWED_ATTR = null;
        // Drop any caller-supplied Trusted Types policy so it cannot poison later
        // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
        // never recreated — Trusted Types throws on duplicate names) is restored by
        // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
        trustedTypesPolicy = defaultTrustedTypesPolicy;
        emptyHTML = '';
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        /* Reject unknown entry points. Without this, a non-hook key (e.g.
     * '__proto__') indexes off the prototype chain rather than a real
     * hook array, and arrayPush then writes to Object.prototype. Guard
     * with an own-property check against the known hook names. */ if (!$eb5593472c48f130$var$objectHasOwnProperty(hooks, entryPoint)) return;
        $eb5593472c48f130$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (!$eb5593472c48f130$var$objectHasOwnProperty(hooks, entryPoint)) return undefined;
        if (hookFunction !== undefined) {
            const index = $eb5593472c48f130$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $eb5593472c48f130$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $eb5593472c48f130$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        if (!$eb5593472c48f130$var$objectHasOwnProperty(hooks, entryPoint)) return;
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $eb5593472c48f130$var$_createHooksMap();
    };
    return DOMPurify;
}
var $eb5593472c48f130$var$purify = $eb5593472c48f130$var$createDOMPurify();
module.exports = $eb5593472c48f130$var$purify;

});


parcelRegister("5UXaz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18c15eecb44e6bc7dee9727eae68b36d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44f014880649deba$var$_react = $44f014880649deba$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $44f014880649deba$var$_iconNew = $44f014880649deba$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $44f014880649deba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shortcut
 * Usage guidance:
 * Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44f014880649deba$var$ShortcutIcon = (props)=>/*#__PURE__*/ $44f014880649deba$var$_react.default.createElement($44f014880649deba$var$_iconNew.default, Object.assign({
        name: "ShortcutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$44f014880649deba$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $44f014880649deba$var$_default = module.exports.default = $44f014880649deba$var$ShortcutIcon;

});

parcelRegister("3Asfj", function(module, exports) {
$parcel$export(module.exports, "addSourceToUrl", () => $920945d6bec92415$export$cae9c63f58ebbe6f);
$parcel$export(module.exports, "is3pOrExternalSource", () => $920945d6bec92415$export$d1565b01286b6c95);

var $87QgR = parcelRequire("87QgR");

var $5LmQo = parcelRequire("5LmQo");
const $920945d6bec92415$export$cae9c63f58ebbe6f = (url, source, shouldReturnUrlWithoutSource = false)=>{
    if (shouldReturnUrlWithoutSource || !(0, $87QgR.default).checkGate('jsm_kb_source_value_in_query_param')) return url;
    return (0, $5LmQo.addParamsToUrl)(url, {
        source: source
    });
};
const $920945d6bec92415$export$d1565b01286b6c95 = (sourceSystem)=>{
    return sourceSystem === 'EXTERNAL' || sourceSystem === 'SHAREPOINT' || sourceSystem === 'GOOGLE_DRIVE';
};

});

parcelRegister("zZCyy", function(module, exports) {
$parcel$export(module.exports, "typeMap", () => $aa0499e9050c8146$export$ca0f3793b4450a5d);
$parcel$export(module.exports, "isExternalResource", () => $aa0499e9050c8146$export$fe3f86d8e6082cf);
$parcel$export(module.exports, "isThirdPartyArticle", () => $aa0499e9050c8146$export$97275da1bf1c8425);
$parcel$export(module.exports, "urlRefsAndTarget", () => $aa0499e9050c8146$export$a54b3eec1418fa47);

var $eDcdn = parcelRequire("eDcdn");
const $aa0499e9050c8146$export$ca0f3793b4450a5d = {
    REQUEST_FORM: 'REQUEST_FORM',
    ARTICLE: 'ARTICLE',
    EXTERNAL_RESOURCE: 'ati:cloud:jira-servicedesk:external-resource'
};
const $aa0499e9050c8146$export$fe3f86d8e6082cf = (entityKey)=>{
    return entityKey === $aa0499e9050c8146$export$ca0f3793b4450a5d.EXTERNAL_RESOURCE;
};
const $aa0499e9050c8146$export$97275da1bf1c8425 = (sourceType)=>{
    return !!sourceType && [
        'GOOGLE_DRIVE',
        'SHAREPOINT',
        'EXTERNAL_RESOURCES'
    ].includes(sourceType);
};
const $aa0499e9050c8146$var$getUrlForRouter = (displayLink)=>{
    return displayLink.startsWith('/') ? displayLink.replace((0, $eDcdn.getRelativeBasePath)(), '') : displayLink.replace(`${location.origin}${(0, $eDcdn.getRelativeBasePath)()}`, '');
};
const $aa0499e9050c8146$export$a54b3eec1418fa47 = ({ displayLink: displayLink, isAnExternalResource: isAnExternalResource })=>isAnExternalResource ? {
        href: displayLink,
        target: '_blank'
    } : {
        to: $aa0499e9050c8146$var$getUrlForRouter(displayLink),
        target: '_self'
    };

});

parcelRegister("dmYEL", function(module, exports) {
$parcel$export(module.exports, "ArticleMetadata", () => (parcelRequire("aQA3A")).default);

var $aQA3A = parcelRequire("aQA3A");

});
parcelRegister("aQA3A", function(module, exports) {
$parcel$export(module.exports, "default", () => $afa3a98f115c1aef$export$2e2bcd8739ae039);

var $ixGkZ = parcelRequire("ixGkZ");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $3HBS2 = parcelRequire("3HBS2");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("jPN2v");
var $l8hpi = parcelRequire("l8hpi");

var $gUpf2 = parcelRequire("gUpf2");

var $dodXU = parcelRequire("dodXU");
const $afa3a98f115c1aef$export$9f18a4080cf334b5 = ({ isLoggedIn: isLoggedIn, result: result })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useFragment)((0, $ixGkZ.default), result);
    const { ari: ari, displayLink: displayLink, sourceSystem: sourceSystem, containerName: containerName } = data;
    const isExternal = sourceSystem === 'EXTERNAL';
    const { data: { source: source } } = (0, $l8hpi.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const confluencePageText = containerName ? formatMessage((0, $dodXU.default).confluencePage, {
        value: containerName
    }) : '';
    const showSeparator = source && containerName;
    const externalResourceParts = [
        source || '',
        showSeparator ? "\u2022" : '',
        containerName || ''
    ].filter(Boolean);
    const externalResourceText = externalResourceParts.join(' ');
    const metaData = !isExternal ? confluencePageText : externalResourceText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        key: ari
    }, metaData);
};
const $afa3a98f115c1aef$var$ConnectedArticleMetadata = (0, $f2mlD.default)((state)=>{
    return {
        isLoggedIn: (0, $3HBS2.isLoggedIn)(state)
    };
})($afa3a98f115c1aef$export$9f18a4080cf334b5);
var $afa3a98f115c1aef$export$2e2bcd8739ae039 = $afa3a98f115c1aef$var$ConnectedArticleMetadata;

});
parcelRegister("ixGkZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3c9e2a571cacd52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed87ad72d807d002234b458a7dcc7707>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3c9e2a571cacd52$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleMetadataFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "kind": "ScalarField",
            "name": "containerName"
        },
        {
            "kind": "ScalarField",
            "name": "sourceSystem"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$d3c9e2a571cacd52$var$node.hash = "4c3cfc8aeff9894de53a0b5480f56516";
var $d3c9e2a571cacd52$export$2e2bcd8739ae039 = $d3c9e2a571cacd52$var$node;

});

parcelRegister("jPN2v", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => (parcelRequire("l8hpi")).useExternalLink);

var $l8hpi = parcelRequire("l8hpi");

});
parcelRegister("l8hpi", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => $6d15ec88ede9c9d3$export$408a40e8acea91be);

var $bSJIT = parcelRequire("bSJIT");

var $3gozL = parcelRequire("3gozL");

var $dyYIc = parcelRequire("dyYIc");

var $3qDrS = parcelRequire("3qDrS");
const $6d15ec88ede9c9d3$export$2c4a28c399ed5beb = (urls)=>{
    return (0, $dyYIc.fetchObjectsFromUrls)(urls).toPromise().then((response)=>{
        return urls.reduce((ref, url, index)=>({
                ...ref,
                [url]: response[index]
            }), {});
    });
};
const $6d15ec88ede9c9d3$var$batchedFetchIcon = (0, $3qDrS.default)($6d15ec88ede9c9d3$export$2c4a28c399ed5beb, 0);
const $6d15ec88ede9c9d3$export$7666a60147fbe378 = {};
const $6d15ec88ede9c9d3$var$addExternalLinkToCache = (key, value)=>{
    $6d15ec88ede9c9d3$export$7666a60147fbe378[key] = value;
};
function $6d15ec88ede9c9d3$export$408a40e8acea91be({ isLoggedIn: isLoggedIn, link: url }) {
    const initialState = (0, $bSJIT.useMemo)(()=>({
            name: null,
            iconUrl: null,
            source: null
        }), []);
    const [data, setData] = (0, $bSJIT.useState)(initialState);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(true);
    const markDataLoaded = (key, value)=>{
        setIsLoading(false);
        setData(value);
        $6d15ec88ede9c9d3$var$addExternalLinkToCache(key, value);
    };
    (0, $bSJIT.useEffect)(()=>{
        let href = url;
        if (!isLoggedIn) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Try to parse the url and extract out the href
     * if it fails return null as the icon url
     */ try {
            href = new URL(url).href;
        } catch (error) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Origin is null for other supported url forms like `tel:` and `mail:`
     * return null so that ui can fallback to default icons
     */ if (new URL(url).origin === 'null') {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * check is there is already entry in cache
     * if yes, return the icon url
     * else, make a call to object resolver service
     */ if (Object.keys($6d15ec88ede9c9d3$export$7666a60147fbe378).includes(href)) {
            setData($6d15ec88ede9c9d3$export$7666a60147fbe378[href]);
            setIsLoading(false);
        } else $6d15ec88ede9c9d3$var$batchedFetchIcon(href).then((response)=>{
            var _response$href, _response$href2, _response$href3;
            const source = (_response$href = response[href]) === null || _response$href === void 0 || (_response$href = _response$href.body.data) === null || _response$href === void 0 || (_response$href = _response$href.generator) === null || _response$href === void 0 ? void 0 : _response$href.name;
            /**
         * ORS returns old Confluence icon
         * Until the icon is updated in ORS we should use the new icon from assets
         */ const iconUrl = source === 'Confluence' ? (0, (/*@__PURE__*/$parcel$interopDefault($3gozL))) : (_response$href2 = response[href]) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.body) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.data) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.generator) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.icon) === null || _response$href2 === void 0 ? void 0 : _response$href2.url;
            markDataLoaded(href, {
                iconUrl: iconUrl,
                source: source,
                name: (_response$href3 = response[href]) === null || _response$href3 === void 0 || (_response$href3 = _response$href3.body.data) === null || _response$href3 === void 0 ? void 0 : _response$href3.name
            });
        }).catch(()=>{
            return null;
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        initialState,
        isLoggedIn,
        url
    ]);
    return {
        data: data,
        isLoading: isLoading
    };
}

});
parcelRegister("3gozL", function(module, exports) {
module.exports = new URL("../images/confluence-icon.3f9a0ccd.svg", import.meta.url).toString();

});

parcelRegister("dyYIc", function(module, exports) {
$parcel$export(module.exports, "fetchObjectsFromUrls", () => $e48449de1fdac2ad$export$bf4b9b9bdb5d08c9);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");
const $e48449de1fdac2ad$export$bf4b9b9bdb5d08c9 = (urls)=>{
    return (0, $llRGw.post)('/gateway/api/object-resolver/resolve/batch', urls.map((url)=>({
            resourceUrl: url
        })), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $lJ0l5.Observable).throw(e));
};

});



parcelRegister("dodXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad334ff66805f6f9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ad334ff66805f6f9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Label showing a Confluence page result belongs to a specific space ({value})',
        id: 'cv.search.articles.metadata'
    }
});

});



parcelRegister("e77h5", function(module, exports) {
$parcel$export(module.exports, "default", () => $411d801d92a0d9c0$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $411d801d92a0d9c0$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    showMore: {
        defaultMessage: 'Show more',
        description: 'Text on show more results button',
        id: 'cv.search.articles.show-more'
    },
    showMoreIcon: {
        defaultMessage: 'Show more icon',
        description: 'Text for label on show more results icon',
        id: 'cv.search.articles.show-more-icon'
    },
    shortcutIcon: {
        defaultMessage: 'Shortcut icon',
        description: 'Text for label on shortcut icon',
        id: 'cv.search.articles.shortcut-icon'
    },
    articles: {
        defaultMessage: 'Self-help resources',
        description: 'Text for section resource type in search results',
        id: 'cv.search.articles.articles'
    }
});

});

parcelRegister("anSwm", function(module, exports) {
$parcel$export(module.exports, "ResourceIcon", () => (parcelRequire("hEqUu")).default);

var $hEqUu = parcelRequire("hEqUu");

});
parcelRegister("hEqUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ae8818ac95cdbd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $3lfq2 = parcelRequire("3lfq2");

var $3HBS2 = parcelRequire("3HBS2");

var $5VhGP = parcelRequire("5VhGP");
parcelRequire("jPN2v");
var $l8hpi = parcelRequire("l8hpi");

var $67YKA = parcelRequire("67YKA");

var $eYvps = parcelRequire("eYvps");

var $8fxpQ = parcelRequire("8fxpQ");

var $emsU2 = parcelRequire("emsU2");

var $5oTFa = parcelRequire("5oTFa");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $lkNTb = parcelRequire("lkNTb");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $g9isy = parcelRequire("g9isy");
const $47ae8818ac95cdbd$export$99eb8fbf40c7d2bc = ({ entityType: entityType, displayLink: displayLink, isLoggedIn: isLoggedIn, isExternal: isExternal, themeColor: themeColor, iconUrl: iconUrl, sourceSystem: sourceSystem, variant: variant = 'default' })=>{
    const { data: { iconUrl: externalResourceIconUrl }, isLoading: isIconLoading } = (0, $l8hpi.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const isValidResourceIconUrl = !!iconUrl;
    const isValidExternalResourceIconUrl = !!externalResourceIconUrl && externalResourceIconUrl !== '';
    const getDefaultIcon = (0, $bSJIT.useMemo)(()=>{
        switch(entityType){
            case 'ARTICLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                    label: "",
                    testId: "article-icon",
                    spacing: "spacious"
                });
            case 'REQUEST_FORM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8fxpQ))), {
                    label: "",
                    testId: "request-form-icon",
                    spacing: "spacious"
                });
            case 'PORTAL':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5oTFa))), {
                    label: "",
                    testId: "portal-icon",
                    spacing: "spacious"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYvps))), {
                    label: "",
                    testId: "question-icon",
                    spacing: "spacious"
                });
        }
    }, [
        entityType
    ]);
    const getThirdPartyIcon = (0, $bSJIT.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g9isy.IntegrationProviderMeta).sharepoint.icon, {
            label: "sharepoint"
        });
        if (sourceSystem === 'GOOGLE_DRIVE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g9isy.IntegrationProviderMeta).googleDrive.icon, {
            label: "googledrive"
        });
        return null;
    }, [
        sourceSystem
    ]);
    const getThirdPartyIconComponent = (0, $bSJIT.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return (0, $g9isy.IntegrationProviderMeta).sharepoint.icon;
        if (sourceSystem === 'GOOGLE_DRIVE') return (0, $g9isy.IntegrationProviderMeta).googleDrive.icon;
        return null;
    }, [
        sourceSystem
    ]);
    const shouldUseArticleIconTile = variant === 'tile' && entityType === 'ARTICLE' && !isExternal && !isIconLoading && !isValidResourceIconUrl;
    const getExternalResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5VhGP.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidExternalResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "img",
            xcss: $47ae8818ac95cdbd$var$imgStyles,
            testId: "external-resource-icon",
            src: externalResourceIconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    const getResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5VhGP.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            as: "img",
            xcss: $47ae8818ac95cdbd$var$imgStyles,
            testId: "resource-icon",
            src: iconUrl,
            alt: ""
        });
        return getThirdPartyIcon ?? getDefaultIcon;
    };
    if (shouldUseArticleIconTile) {
        const ThirdPartyIconInTile = ({ label: label })=>{
            if (getThirdPartyIcon) return getThirdPartyIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: label
            });
        };
        const IconComponent = getThirdPartyIconComponent ? ThirdPartyIconInTile : (0, (/*@__PURE__*/$parcel$interopDefault($emsU2)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $47ae8818ac95cdbd$var$iconTileStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
            appearance: "blue",
            icon: IconComponent,
            label: "Article icon",
            size: "medium",
            testId: "article-icon-tile"
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $47ae8818ac95cdbd$var$imgStyles,
        style: {
            color: (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lkNTb.generateThemeBranding)(themeColor).color900 : themeColor
        }
    }, isExternal ? getExternalResourceIcon() : getResourceIcon());
};
const $47ae8818ac95cdbd$var$ConnectedResourceIcon = (0, $f2mlD.default)((state)=>{
    return {
        isLoggedIn: (0, $3HBS2.isLoggedIn)(state),
        themeColor: (0, $3lfq2.getThemeColor)(state)
    };
})($47ae8818ac95cdbd$export$99eb8fbf40c7d2bc);
var $47ae8818ac95cdbd$export$2e2bcd8739ae039 = $47ae8818ac95cdbd$var$ConnectedResourceIcon;
const $47ae8818ac95cdbd$var$imgStyles = (0, $9BVpB.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
});
const $47ae8818ac95cdbd$var$iconTileStyles = (0, $9BVpB.xcss)({
    width: 'size.300',
    height: 'size.300',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("5VhGP", function(module, exports) {
$parcel$export(module.exports, "SkeletonItem", () => $6e17fb42cff0483f$export$fbc0ea7debdb77e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
const $6e17fb42cff0483f$var$shimmer = /*#__PURE__*/ (0, $4v2A7.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
});
const $6e17fb42cff0483f$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1p3akxf-0"
})`animation-duration:1.2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$6e17fb42cff0483f$var$shimmer};animation-timing-function:linear;background-color:${"var(--ds-skeleton, #F4F5F7)"};background-image:linear-gradient( to right,${"var(--ds-skeleton, #F4F5F7)"} 10%,${"var(--ds-skeleton-subtle, #EBECF0)"} 20%,${"var(--ds-skeleton, #F4F5F7)"} 30% );background-repeat:no-repeat;border-radius:${({ isCircle: isCircle })=>isCircle ? '50%' : "var(--ds-radius-small, 4px)"};height:${({ height: height })=>height};width:${({ width: width })=>width};`;

});

parcelRegister("67YKA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a75b3b8244744d3a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4VsjU = parcelRequire("4VsjU");
// Icon color mapping for Tile-based icons
const $a75b3b8244744d3a$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
const $a75b3b8244744d3a$var$iconWrapperStyles = {
    root: "_vwz4idpf"
};
// Background color mapping for Tile component
const $a75b3b8244744d3a$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $a75b3b8244744d3a$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'medium', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4VsjU.default), {
        size: size,
        backgroundColor: $a75b3b8244744d3a$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                $a75b3b8244744d3a$var$iconColorMap[appearance],
                $a75b3b8244744d3a$var$iconWrapperStyles.root
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: "",
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("4VsjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d599cd4a4ffa76c$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

// Pixel sizes per tile size, used for retina validation
const $8d599cd4a4ffa76c$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $8d599cd4a4ffa76c$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq _1jpx1dfr"
};
const $8d599cd4a4ffa76c$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $8d599cd4a4ffa76c$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $8d599cd4a4ffa76c$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $8d599cd4a4ffa76c$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $bSJIT.useRef)(null);
    // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $bSJIT.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $9fU1q.default)([
            $8d599cd4a4ffa76c$var$styles.root,
            $8d599cd4a4ffa76c$var$sizeMap[size],
            isInset ? $8d599cd4a4ffa76c$var$styles.inset : $8d599cd4a4ffa76c$var$styles.nonInset,
            isInset && $8d599cd4a4ffa76c$var$insetSizeMap[size],
            $8d599cd4a4ffa76c$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $8d599cd4a4ffa76c$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("8fxpQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::403d648a4ec6dc7540968c496b0b831a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6019a5273b7bc3cc$var$_react = $6019a5273b7bc3cc$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6019a5273b7bc3cc$var$_iconNew = $6019a5273b7bc3cc$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6019a5273b7bc3cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6019a5273b7bc3cc$var$DashboardIcon = (props)=>/*#__PURE__*/ $6019a5273b7bc3cc$var$_react.default.createElement($6019a5273b7bc3cc$var$_iconNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$6019a5273b7bc3cc$var$DashboardIcon.displayName = 'DashboardIcon';
var $6019a5273b7bc3cc$var$_default = module.exports.default = $6019a5273b7bc3cc$var$DashboardIcon;

});

parcelRegister("emsU2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119715e64d85c4bab14810bd2a82a088>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7498a45725182b9$var$_react = $a7498a45725182b9$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a7498a45725182b9$var$_iconNew = $a7498a45725182b9$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a7498a45725182b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/page
 * Usage guidance:
 * Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7498a45725182b9$var$PageIcon = (props)=>/*#__PURE__*/ $a7498a45725182b9$var$_react.default.createElement($a7498a45725182b9$var$_iconNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$a7498a45725182b9$var$PageIcon.displayName = 'PageIcon';
var $a7498a45725182b9$var$_default = module.exports.default = $a7498a45725182b9$var$PageIcon;

});

parcelRegister("5oTFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdf3bc92d1fef1a18b299001cd420653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eea5f27a782b1b6$var$_react = $3eea5f27a782b1b6$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3eea5f27a782b1b6$var$_iconNew = $3eea5f27a782b1b6$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3eea5f27a782b1b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/screen
 * Usage guidance:
 * Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eea5f27a782b1b6$var$ScreenIcon = (props)=>/*#__PURE__*/ $3eea5f27a782b1b6$var$_react.default.createElement($3eea5f27a782b1b6$var$_iconNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$3eea5f27a782b1b6$var$ScreenIcon.displayName = 'ScreenIcon';
var $3eea5f27a782b1b6$var$_default = module.exports.default = $3eea5f27a782b1b6$var$ScreenIcon;

});

parcelRegister("g9isy", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyConnectionStatusEndpoint", () => $13d4de026cda1ff9$export$b6b331ef111f4609);
$parcel$export(module.exports, "IntegrationProviderMeta", () => $13d4de026cda1ff9$export$3b0a1c80b07fd43a);

var $4CtTG = parcelRequire("4CtTG");

var $2grDj = parcelRequire("2grDj");
const $13d4de026cda1ff9$export$b6b331ef111f4609 = ()=>`/gateway/api/third-party-configuration/connected-data-sources`;
const $13d4de026cda1ff9$export$3b0a1c80b07fd43a = {
    sharepoint: {
        name: 'SharePoint',
        icon: (0, $2grDj.default),
        integrationId: 'ari:cloud:platform::integration/microsoft',
        type: 'sharepoint-connector'
    },
    googleDrive: {
        name: 'Google Drive',
        icon: (0, $4CtTG.default),
        integrationId: 'ari:cloud:platform::integration/google',
        type: 'google-drive-connector'
    }
};

});
parcelRegister("4CtTG", function(module, exports) {
$parcel$export(module.exports, "default", () => $8110a06a89c0ae06$export$2e2bcd8739ae039);
/* google-drive-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $8110a06a89c0ae06$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $8110a06a89c0ae06$var$GoogleDriveIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $9fU1q.default)([
            size && $8110a06a89c0ae06$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
        fill: "#3777E3"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
        fill: "#FFCF63"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
        fill: "#11A861"
    }));
/**
 * __GoogleDriveIcon__
 */ const $8110a06a89c0ae06$var$GoogleDriveIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $bSJIT.createElement($8110a06a89c0ae06$var$GoogleDriveIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $8110a06a89c0ae06$export$2e2bcd8739ae039 = $8110a06a89c0ae06$var$GoogleDriveIcon;

});

parcelRegister("2grDj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c17821054a03ff5$export$2e2bcd8739ae039);
/* sharepoint-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $2c17821054a03ff5$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $2c17821054a03ff5$var$SharePointIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $9fU1q.default)([
            size && $2c17821054a03ff5$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        clipPath: "url(#clip0_271_181641)"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        clipPath: "url(#clip1_271_181641)"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        opacity: "0.1",
        d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
        fill: "black"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        opacity: "0.2",
        d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        opacity: "0.2",
        d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        opacity: "0.2",
        d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
        fill: "white"
    }))), /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "clip0_271_181641"
    }, /*#__PURE__*/ $bSJIT.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    })), /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "clip1_271_181641"
    }, /*#__PURE__*/ $bSJIT.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
/**
 * __SharePointIcon__
 */ const $2c17821054a03ff5$var$SharePointIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $bSJIT.createElement($2c17821054a03ff5$var$SharePointIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $2c17821054a03ff5$export$2e2bcd8739ae039 = $2c17821054a03ff5$var$SharePointIcon;

});








parcelRegister("3vVyV", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => (parcelRequire("c3SIq")).ArticleResultsLoader);
$parcel$export(module.exports, "SidePanelResultsLoader", () => (parcelRequire("c3SIq")).SidePanelResultsLoader);
$parcel$export(module.exports, "NewSearchResultsLoader", () => (parcelRequire("c3SIq")).SearchResultsLoader);

var $c3SIq = parcelRequire("c3SIq");

});
parcelRegister("c3SIq", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => $48c59a2024dc2c20$export$777dd415ac1ad4be);
$parcel$export(module.exports, "SidePanelResultsLoader", () => $48c59a2024dc2c20$export$9575789db02c1cec);
$parcel$export(module.exports, "SearchResultsLoader", () => $48c59a2024dc2c20$export$628e0e0af087a588);

var $bSJIT = parcelRequire("bSJIT");

var $hF8Ik = parcelRequire("hF8Ik");

var $gUpf2 = parcelRequire("gUpf2");

var $jnInZ = parcelRequire("jnInZ");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");

var $2IITT = parcelRequire("2IITT");

var $aRsbV = parcelRequire("aRsbV");
parcelRequire("4BroI");
var $c6fXf = parcelRequire("c6fXf");
const $48c59a2024dc2c20$export$777dd415ac1ad4be = ()=>{
    const articleItemLoader = (0, $bSJIT.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $48c59a2024dc2c20$var$headingAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const resourceIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $48c59a2024dc2c20$var$iconAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $48c59a2024dc2c20$var$loadingIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
                height: 24,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const metadataContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: [
                    $48c59a2024dc2c20$var$subheadingLeftAreaStyles,
                    $48c59a2024dc2c20$var$subheadingStyles
                ],
                testId: "article-metadata-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $48c59a2024dc2c20$var$metadataLoadingStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const shortcutIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: [
                    $48c59a2024dc2c20$var$headerRightAreaStylesVisible
                ],
                testId: "shortcut-icon-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const descriptionContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $48c59a2024dc2c20$var$bodyAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            role: "listitem",
            xcss: $48c59a2024dc2c20$var$containerStyles,
            testId: "article-item-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body'
            ],
            templateColumns: "auto 1fr auto"
        }, resourceIconContainer(), linkContainer(), metadataContainer(), shortcutIconContainer(), descriptionContainer())));
    }, []);
    const articlesListLoader = (0, $bSJIT.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            role: "list",
            xcss: $48c59a2024dc2c20$var$containerStyles,
            testId: "articles-list-loader"
        }, articleItemLoader, articleItemLoader, articleItemLoader, articleItemLoader);
    }, [
        articleItemLoader
    ]);
    const sectionHeadingLoader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, sectionHeadingLoader(), articlesListLoader, articlesListLoader);
};
const $48c59a2024dc2c20$export$9575789db02c1cec = ()=>{
    const resourceIconContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $48c59a2024dc2c20$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $48c59a2024dc2c20$var$sidePanelIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            height: 24,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    const descriptionContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $48c59a2024dc2c20$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $48c59a2024dc2c20$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))));
    };
    const sidePaneItemLoader = (0, $bSJIT.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                xcss: $48c59a2024dc2c20$var$sidePaneLinkContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
                xcss: $48c59a2024dc2c20$var$sidePaneLinkStyles,
                space: "space.100"
            }, resourceIconContainer(), descriptionContainer()));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $48c59a2024dc2c20$var$sidePanelItemStyles
        }, linkContainer());
    }, []);
    const sidePanelLoader = (0, $bSJIT.useMemo)(()=>{
        const resultTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $48c59a2024dc2c20$var$sidePanelStyles
        }, resultTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.ResultList), {
            role: "list"
        }, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader));
    }, [
        sidePaneItemLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "side-panel-results-loader",
        xcss: $48c59a2024dc2c20$var$sidePanelContainerStyles
    }, sidePanelLoader);
};
const $48c59a2024dc2c20$export$628e0e0af087a588 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $48c59a2024dc2c20$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($48c59a2024dc2c20$export$777dd415ac1ad4be, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($48c59a2024dc2c20$export$9575789db02c1cec, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($48c59a2024dc2c20$export$9575789db02c1cec, null)));
};
const $48c59a2024dc2c20$var$containerStyles = (0, $9BVpB.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $48c59a2024dc2c20$var$iconAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $48c59a2024dc2c20$var$headingAreaStyles = (0, $9BVpB.xcss)({
    width: '200px',
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.large'
});
const $48c59a2024dc2c20$var$subheadingStyles = (0, $9BVpB.xcss)({
    width: '350px',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $48c59a2024dc2c20$var$subheadingLeftAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $48c59a2024dc2c20$var$headerRightAreaStylesVisible = (0, $9BVpB.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $48c59a2024dc2c20$var$responsiveStyles = (0, $9BVpB.xcss)({
    [(0, $4pBHw.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        width: '100%'
    },
    [(0, $4pBHw.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});
const $48c59a2024dc2c20$var$bodyAreaStyles = (0, $9BVpB.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $48c59a2024dc2c20$var$loadingIconStyles = (0, $9BVpB.xcss)({
    width: '100%'
});
const $48c59a2024dc2c20$var$metadataLoadingStyles = (0, $9BVpB.xcss)({
    width: '100%'
});
const $48c59a2024dc2c20$var$sidePanelIconStyles = (0, $9BVpB.xcss)({
    width: 'size.200'
});
const $48c59a2024dc2c20$var$sidePanelDescriptionStyles = (0, $9BVpB.xcss)({
    width: '100%'
});
const $48c59a2024dc2c20$var$sidePaneLinkContainerStyles = (0, $9BVpB.xcss)({
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $48c59a2024dc2c20$var$sidePaneLinkStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $48c59a2024dc2c20$var$sidePanelItemStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $48c59a2024dc2c20$var$sidePanelContainerStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    minWidth: '320px',
    width: '100%',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100'
});
const $48c59a2024dc2c20$var$sidePanelStyles = (0, $9BVpB.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});

});


parcelRegister("jDmK1", function(module, exports) {
$parcel$export(module.exports, "Portals", () => (parcelRequire("3om2m")).default);

var $3om2m = parcelRequire("3om2m");

});
parcelRegister("3om2m", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfff36ede5c0e6d6$export$2e2bcd8739ae039);

var $lm2OT = parcelRequire("lm2OT");

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $kIbto = parcelRequire("kIbto");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $4pBHw = parcelRequire("4pBHw");

var $9BVpB = parcelRequire("9BVpB");

var $f6Ax9 = parcelRequire("f6Ax9");
parcelRequire("4BroI");
var $8ZJ8E = parcelRequire("8ZJ8E");
var $c6fXf = parcelRequire("c6fXf");
var $2FLDr = parcelRequire("2FLDr");

var $f5JeN = parcelRequire("f5JeN");
parcelRequire("hR2tc");
var $1QM12 = parcelRequire("1QM12");

var $4nbcf = parcelRequire("4nbcf");
const $cfff36ede5c0e6d6$export$7083bd6220bb1bc7 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const cloudId = (0, $fuVmc.getCloudId)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $lm2OT.default), {
        cloudId: cloudId,
        queryTerm: term,
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        limit: (0, $8ZJ8E.PORTALS_RESULT_LIMIT)
    });
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const portals = ((_data$helpObjectStore = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStorePortalSearchResults' ? data.helpObjectStore_searchPortals.results : [];
    const showSection = portals.length > 0;
    (0, $bSJIT.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStorePortalSearchResults') {
            const externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchPortals.results.forEach((portal)=>{
                if (portal.metadata.searchStrategy === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $2FLDr.sendSearchOperationalAnalyticEvents)({
                action: 'portalSearchSucceeded',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $2FLDr.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'portal',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchPortals;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $2FLDr.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                is4XXFailure: is4XXFailure,
                statusCode: statusCode,
                action: 'portalSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        updateResultsCount(portals.length, 1);
    }, [
        term,
        portals.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $cfff36ede5c0e6d6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $cfff36ede5c0e6d6$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $4nbcf.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.ResultList), {
        role: "list"
    }, portals.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1QM12.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $f5JeN.searchExperience)
    }));
};
const $cfff36ede5c0e6d6$var$containerStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $4pBHw.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $4pBHw.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $cfff36ede5c0e6d6$var$headingStyles = (0, $9BVpB.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $cfff36ede5c0e6d6$export$2e2bcd8739ae039 = (0, $kIbto.default)()($cfff36ede5c0e6d6$export$7083bd6220bb1bc7);

});
parcelRegister("lm2OT", function(module, exports) {
$parcel$export(module.exports, "default", () => $7df534221478720f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0b5f48857c921e08b0faf15fc282bb1>>
 * @relayHash b4c5cb2add64b92e5fa0a81f307c32d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1
const $7df534221478720f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "HelpObjectStorePortalMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1",
            "metadata": {},
            "name": "portalsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7df534221478720f$var$node.hash = "5fbada5df4e3a5676426867e2805de0f";
var $7df534221478720f$export$2e2bcd8739ae039 = $7df534221478720f$var$node;

});

parcelRegister("hR2tc", function(module, exports) {
$parcel$export(module.exports, "PortalItem", () => (parcelRequire("1QM12")).default);

var $1QM12 = parcelRequire("1QM12");

});
parcelRegister("1QM12", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e2d8057b25865a$export$2e2bcd8739ae039);

var $hrjws = parcelRequire("hrjws");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $2OuWT = parcelRequire("2OuWT");

var $3lfq2 = parcelRequire("3lfq2");

var $fKGH0 = parcelRequire("fKGH0");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $kIbto = parcelRequire("kIbto");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $aRsbV = parcelRequire("aRsbV");

var $gUpf2 = parcelRequire("gUpf2");

var $zZCyy = parcelRequire("zZCyy");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
parcelRequire("anSwm");
var $hEqUu = parcelRequire("hEqUu");
const $68e2d8057b25865a$export$dd92e87a60cfa662 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const data = (0, $a2qIF.useFragment)((0, $hrjws.default), result);
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $2FLDr.useVisibilityState)();
    const highlightedTitle = title ? (0, $2FLDr.formatText)(title, term) : '';
    const linkProps = (0, $zZCyy.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: false
    });
    (0, $bSJIT.useEffect)(()=>{
        (0, $2FLDr.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'portal'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $68e2d8057b25865a$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: [
            $68e2d8057b25865a$var$headingStyles,
            $68e2d8057b25865a$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hEqUu.default), {
        entityType: "PORTAL",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2OuWT.Link), {
        key: id,
        actionSubjectId: 'portal-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $fKGH0.sanitize)(highlightedTitle)
        }
    })))));
};
const $68e2d8057b25865a$var$ConnectedPortalItem = (0, $f2mlD.default)((state)=>{
    return {
        themeColor: (0, $3lfq2.getThemeColor)(state)
    };
})($68e2d8057b25865a$export$dd92e87a60cfa662);
var $68e2d8057b25865a$export$2e2bcd8739ae039 = (0, $kIbto.default)()($68e2d8057b25865a$var$ConnectedPortalItem);
const $68e2d8057b25865a$var$containerStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $68e2d8057b25865a$var$headingStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $68e2d8057b25865a$var$headingAlignmentStyles = (0, $9BVpB.xcss)({
    alignItems: 'center'
});

});
parcelRegister("hrjws", function(module, exports) {
$parcel$export(module.exports, "default", () => $b65cc45d5394cd23$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<401e38e258ab2a07d01ca48a65a435ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b65cc45d5394cd23$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStorePortalMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStorePortalSearchResult"
};
$b65cc45d5394cd23$var$node.hash = "e844983974d9732ca3ef706885375f3f";
var $b65cc45d5394cd23$export$2e2bcd8739ae039 = $b65cc45d5394cd23$var$node;

});



parcelRegister("4nbcf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c68bd030678808a6$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $c68bd030678808a6$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals'
    }
});

});



parcelRegister("dnQOE", function(module, exports) {
$parcel$export(module.exports, "RequestForms", () => (parcelRequire("8huby")).default);

var $8huby = parcelRequire("8huby");

});
parcelRegister("8huby", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8b67dc6ca0e2b7e$export$2e2bcd8739ae039);

var $5qrRr = parcelRequire("5qrRr");

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $kIbto = parcelRequire("kIbto");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $4pBHw = parcelRequire("4pBHw");

var $9BVpB = parcelRequire("9BVpB");

var $f6Ax9 = parcelRequire("f6Ax9");
parcelRequire("4BroI");
var $8ZJ8E = parcelRequire("8ZJ8E");
var $c6fXf = parcelRequire("c6fXf");
var $2FLDr = parcelRequire("2FLDr");

var $f5JeN = parcelRequire("f5JeN");
parcelRequire("bSPKv");
var $iFTFT = parcelRequire("iFTFT");

var $4GsGQ = parcelRequire("4GsGQ");
const $c8b67dc6ca0e2b7e$export$d7562fc7136a7ea2 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const cloudId = (0, $fuVmc.getCloudId)();
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $5qrRr.default), {
        cloudId: cloudId,
        portalId: portalId,
        queryTerm: term,
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        limit: (0, $8ZJ8E.REQUEST_FORMS_NEW_LIMIT)
    });
    const requestForms = ((_data$helpObjectStore = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreRequestTypeSearchResults' ? data.helpObjectStore_searchRequestTypes.results : [];
    const showSection = requestForms.length > 0;
    (0, $bSJIT.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreRequestTypeSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchRequestTypes.results.forEach((requestForm)=>{
                const { metadata: metadata } = requestForm;
                const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
                if (isExternal) externalResourcesCount += 1;
                if (searchStrategy === 'SEARCH_PLATFORM_KEYWORD_BASED') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $2FLDr.sendSearchOperationalAnalyticEvents)({
                action: 'requestTypeSearchSucceeded',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $2FLDr.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'request-form',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchRequestTypes;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $2FLDr.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                statusCode: statusCode,
                is4XXFailure: is4XXFailure,
                action: 'requestTypeSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        updateResultsCount(requestForms.length, 1);
    }, [
        term,
        requestForms.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $c8b67dc6ca0e2b7e$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $c8b67dc6ca0e2b7e$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $4GsGQ.default).requestForms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6fXf.ResultList), {
        role: "list"
    }, requestForms.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iFTFT.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $f5JeN.searchExperience)
    }));
};
const $c8b67dc6ca0e2b7e$var$containerStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $4pBHw.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $4pBHw.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $c8b67dc6ca0e2b7e$var$headingStyles = (0, $9BVpB.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $c8b67dc6ca0e2b7e$export$2e2bcd8739ae039 = (0, $kIbto.default)()($c8b67dc6ca0e2b7e$export$d7562fc7136a7ea2);

});
parcelRegister("5qrRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b1fad835f0d6693$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c730a03ebb5021ead8eb56adb78276ae>>
 * @relayHash 4db5964fda1ef7ad6bb403c6a9420d56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9
const $1b1fad835f0d6693$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalId",
            "variableName": "portalId"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpObjectStoreRequestTypeMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "requestFormItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9",
            "metadata": {},
            "name": "requestFormsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1b1fad835f0d6693$var$node.hash = "6a4749a62d9236563bcbeca7d18c02eb";
var $1b1fad835f0d6693$export$2e2bcd8739ae039 = $1b1fad835f0d6693$var$node;

});

parcelRegister("bSPKv", function(module, exports) {
$parcel$export(module.exports, "RequestFormItem", () => (parcelRequire("iFTFT")).default);

var $iFTFT = parcelRequire("iFTFT");

});
parcelRegister("iFTFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f1abeaf5adf65ca$export$2e2bcd8739ae039);

var $btq1m = parcelRequire("btq1m");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $2OuWT = parcelRequire("2OuWT");

var $3lfq2 = parcelRequire("3lfq2");

var $fKGH0 = parcelRequire("fKGH0");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $kIbto = parcelRequire("kIbto");

var $5UXaz = parcelRequire("5UXaz");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $aRsbV = parcelRequire("aRsbV");

var $zZCyy = parcelRequire("zZCyy");

var $e77h5 = parcelRequire("e77h5");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
parcelRequire("anSwm");
var $hEqUu = parcelRequire("hEqUu");
const $3f1abeaf5adf65ca$export$c5555d4e61cdd47a = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useFragment)((0, $btq1m.default), result);
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $2FLDr.useVisibilityState)();
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5UXaz))), {
        label: formatMessage((0, $e77h5.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $2FLDr.formatText)(title, term) : '';
    const linkProps = (0, $zZCyy.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $bSJIT.useEffect)(()=>{
        (0, $2FLDr.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'request-form'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $3f1abeaf5adf65ca$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: [
            $3f1abeaf5adf65ca$var$headingStyles,
            $3f1abeaf5adf65ca$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hEqUu.default), {
        entityType: "REQUEST_FORM",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2OuWT.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-request-form-link' : 'request-form-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $fKGH0.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: isShortcutIconVisible ? $3f1abeaf5adf65ca$var$headerRightAreaStylesVisible : $3f1abeaf5adf65ca$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $3f1abeaf5adf65ca$var$ConnectedRequestFormItem = (0, $f2mlD.default)((state)=>{
    return {
        themeColor: (0, $3lfq2.getThemeColor)(state)
    };
})($3f1abeaf5adf65ca$export$c5555d4e61cdd47a);
var $3f1abeaf5adf65ca$export$2e2bcd8739ae039 = (0, $kIbto.default)()($3f1abeaf5adf65ca$var$ConnectedRequestFormItem);
const $3f1abeaf5adf65ca$var$containerStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $3f1abeaf5adf65ca$var$headingStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $3f1abeaf5adf65ca$var$headingAlignmentStyles = (0, $9BVpB.xcss)({
    alignItems: 'center'
});
const $3f1abeaf5adf65ca$var$headerRightAreaStylesInVisible = (0, $9BVpB.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $3f1abeaf5adf65ca$var$headerRightAreaStylesVisible = (0, $9BVpB.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("btq1m", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd28300c381bcffb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32278cf5dc0e7086ec41d31040a6e7d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bd28300c381bcffb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestFormItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStoreRequestTypeMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isExternal"
                },
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStoreRequestTypeSearchResult"
};
$bd28300c381bcffb$var$node.hash = "3676027039798345dde34e2948999172";
var $bd28300c381bcffb$export$2e2bcd8739ae039 = $bd28300c381bcffb$var$node;

});



parcelRegister("4GsGQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $12fa3f312c272805$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $12fa3f312c272805$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    requestForms: {
        defaultMessage: 'Request forms',
        description: 'Text for section resource type in search results',
        id: 'cv.search.request-forms.request-forms'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Text for portal name in description',
        id: 'cv.search.request-forms.portal'
    }
});

});





parcelRegister("cJ8XI", function(module, exports) {
$parcel$export(module.exports, "default", () => $176aa89209945229$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("ahGdU");
var $gmXRj = parcelRequire("gmXRj");
parcelRequire("80y9N");
var $ks6At = parcelRequire("ks6At");

var $fpYOg = parcelRequire("fpYOg");
const $176aa89209945229$var$selector = (0, $BOq7h.createSelector)((0, $ks6At.getAllVisiblePortals), (0, $ks6At.getfeaturedAndSortedPortalsError), (portals, featuredAndSortedPortalsError)=>({
        featuredAndSortedPortalsError: featuredAndSortedPortalsError,
        portals: portals
    }));
var $176aa89209945229$export$2e2bcd8739ae039 = (0, $f2mlD.default)($176aa89209945229$var$selector, {
    fetchPortals: (0, $gmXRj.fetchFeaturedAndSortedPortalsModel)
})((0, $fpYOg.default));

});
parcelRegister("fpYOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $da761a3c075e4e43$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("3iER5");
var $euoFh = parcelRequire("euoFh");

var $bk4Z9 = parcelRequire("bk4Z9");
const $da761a3c075e4e43$var$ServiceDeskFilter = ({ portals: portals, portalIds: portalIds, fetchPortals: fetchPortals, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [values, _] = $bSJIT.useState(portalIds ?? []);
    $bSJIT.useEffect(()=>{
        fetchPortals({
            exploreAll: true,
            sortBy: 'POPULARITY'
        }, false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const options = $bSJIT.useMemo(()=>{
        return portals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals
    ]);
    const preSelectedOptions = $bSJIT.useMemo(()=>{
        const preselectedPortals = portals.filter((portal)=>values.find((id)=>id === portal.id.toString()));
        return preselectedPortals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals,
        values
    ]);
    return portals.length > 1 ? /*#__PURE__*/ $bSJIT.createElement((0, $euoFh.default), {
        fieldId: "servicedesk_filter",
        fieldLabel: formatMessage((0, $bk4Z9.default).portal),
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange,
        testId: "serviceDeskFilter"
    }) : null;
};
var $da761a3c075e4e43$export$2e2bcd8739ae039 = $da761a3c075e4e43$var$ServiceDeskFilter;

});
parcelRegister("bk4Z9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9caf2674026ba76$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e9caf2674026ba76$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    serviceDeskFilter: {
        defaultMessage: 'Service desk',
        description: 'Label for the service desk filter option in the search results picker',
        id: 'sd.all.articles.result.servicedesk.filter.name'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Label for the portal filter option in the search results picker',
        id: 'cv.search.servicedesk-filter.portal'
    }
});

});





parcelRegister("1FNk3", function(module, exports) {
$parcel$export(module.exports, "SearchTextboxV2", () => (parcelRequire("vG4do")).default);

var $vG4do = parcelRequire("vG4do");

});
parcelRegister("vG4do", function(module, exports) {
$parcel$export(module.exports, "default", () => $a090999bda73bef8$export$2e2bcd8739ae039);
/* search-textbox-v2.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $9cCli = parcelRequire("9cCli");

var $4ZMmh = parcelRequire("4ZMmh");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("8Omen");
var $e3RPd = parcelRequire("e3RPd");

var $ecFUh = parcelRequire("ecFUh");

var $51T7P = parcelRequire("51T7P");

var $1DDTY = parcelRequire("1DDTY");
parcelRequire("gNrO5");
var $71mH8 = parcelRequire("71mH8");

var $6WltM = parcelRequire("6WltM");

var $2usNr = parcelRequire("2usNr");

var $87QgR = parcelRequire("87QgR");

var $gfXmS = parcelRequire("gfXmS");

var $hkLEY = parcelRequire("hkLEY");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $8aT4G = parcelRequire("8aT4G");

var $9BVpB = parcelRequire("9BVpB");

var $8Mb7N = parcelRequire("8Mb7N");

var $haAAx = parcelRequire("haAAx");

var $3vcZv = parcelRequire("3vcZv");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $51XYw = parcelRequire("51XYw");

var $5OcOs = parcelRequire("5OcOs");

var $aJC68 = parcelRequire("aJC68");

var $dXo4Q = parcelRequire("dXo4Q");

var $fBxvm = parcelRequire("fBxvm");

var $3W5ib = parcelRequire("3W5ib");

var $7q3M9 = parcelRequire("7q3M9");

var $8AFRj = parcelRequire("8AFRj");

var $ipo6m = parcelRequire("ipo6m");

var $9vFUf = parcelRequire("9vFUf");

var $aHKzr = parcelRequire("aHKzr");

var $kMeyd = parcelRequire("kMeyd");

var $2rCci = parcelRequire("2rCci");
parcelRequire("4BroI");
var $2FLDr = parcelRequire("2FLDr");
parcelRequire("kf1Td");
var $9dLcv = parcelRequire("9dLcv");

var $hXLZM = parcelRequire("hXLZM");

var $fz5cK = parcelRequire("fz5cK");
const $a090999bda73bef8$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON = 'searchQueryCharacterLimitErrorIcon';
const $a090999bda73bef8$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER = 'searchQueryCharacterLimitErrorPopover';
const $a090999bda73bef8$var$HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const $a090999bda73bef8$var$isHelpCenterSearchLimitEnabled = ()=>(0, $87QgR.default).checkGate($a090999bda73bef8$var$HELP_CENTER_SEARCH_LIMIT_GATE);
const $a090999bda73bef8$var$usePopularPortalsWithVA = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [popularPortalsWithVA, setPopularPortalsWithVA] = (0, $bSJIT.useState)([]);
    const [isFetching, setIsFetching] = (0, $bSJIT.useState)(false);
    const cloudId = (0, $bSJIT.useMemo)(()=>(0, $fuVmc.getCloudId)(), []);
    const fetchData = (0, $bSJIT.useCallback)(async ()=>{
        setIsFetching(true);
        try {
            const { mostPopularVAsPortalData: mostPopularVAsPortalData } = await (0, $51XYw.fetchJson)(`/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/virtualagent/mostPopularVAs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    helpCenterId: (0, $fuVmc.getHelpCenterAri)()
                })
            });
            setPopularPortalsWithVA(mostPopularVAsPortalData);
        } catch (error) {
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                action: 'failed',
                actionSubjectId: 'fetchPopularPortalsWithVA'
            }).fire();
        } finally{
            setIsFetching(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        setIsFetching,
        setPopularPortalsWithVA
    ]);
    return {
        isFetching: isFetching,
        popularPortalsWithVA: popularPortalsWithVA,
        fetchData: fetchData
    };
};
// Extracted component to reduce duplication
const $a090999bda73bef8$var$SearchHintWithEnterIcon = ({ message: message, isVisible: isVisible })=>{
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $a090999bda73bef8$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9cCli))),
        alt: ""
    })));
};
const $a090999bda73bef8$var$SearchPopupContentWithRef = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function SearchPopupContent(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const ariaDescriptionId = (0, $bSJIT.useId)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, ...triggerProps } = searchPopupContentProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        ...(0, $hXLZM.isRemoveInvalidSearchPopupAriaEnabled)() ? {} : triggerProps,
        ref: ref,
        xcss: $a090999bda73bef8$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Mb7N.WidthObserver), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $a090999bda73bef8$var$searchBoxStyles,
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "span",
        id: ariaDescriptionId,
        xcss: $a090999bda73bef8$var$visuallyHiddenStyles
    }, formatMessage((0, $fz5cK.default).ariaDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$Input, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $fz5cK.default).inputAriaLabel) : formatMessage((0, $fz5cK.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $fz5cK.default).inputPlaceholder) : formatMessage((0, $fz5cK.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        "aria-describedby": ariaDescriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $a090999bda73bef8$var$hiddenDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        id: ariaDescriptionId
    }, formatMessage((0, $fz5cK.default).ariaDescription))), (0, $2FLDr.isValidSearchTerm)(inputValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchHintWithEnterIcon, {
        message: isVirtualAgentEnabled ? formatMessage((0, $fz5cK.default).askTheVirtualServiceAgent) : formatMessage((0, $fz5cK.default).search),
        isVisible: isVirtualAgentEnabled || isFetchingResults || visibleResultsCount !== 0
    }))));
});
const $a090999bda73bef8$var$SearchPopupContentWithSearchLimitRef = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function SearchPopupContentWithSearchLimit(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const ariaDescriptionId = (0, $bSJIT.useId)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, isSearchQueryOverLimit: isSearchQueryOverLimit, onCharacterLimitErrorIconClick: onCharacterLimitErrorIconClick, ...triggerProps } = searchPopupContentProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        ...(0, $hXLZM.isRemoveInvalidSearchPopupAriaEnabled)() ? {} : triggerProps,
        ref: ref,
        xcss: $a090999bda73bef8$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8Mb7N.WidthObserver), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $a090999bda73bef8$var$searchBoxStyles,
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$InputWithSearchLimit, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        hasTrailingErrorIcon: isSearchQueryOverLimit,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $fz5cK.default).inputAriaLabel) : formatMessage((0, $fz5cK.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $fz5cK.default).inputPlaceholder) : formatMessage((0, $fz5cK.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        "aria-describedby": ariaDescriptionId,
        "aria-invalid": isSearchQueryOverLimit ? true : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $a090999bda73bef8$var$hiddenDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        id: ariaDescriptionId
    }, formatMessage((0, $fz5cK.default).ariaDescription))), isSearchQueryOverLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "button",
        type: "button",
        xcss: $a090999bda73bef8$var$errorIconWrapperStyles,
        "aria-label": formatMessage((0, $fz5cK.default).characterLimitErrorIconLabel),
        onClick: onCharacterLimitErrorIconClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchHintWithEnterIcon, {
        message: isVirtualAgentEnabled ? formatMessage((0, $fz5cK.default).askTheVirtualServiceAgent) : formatMessage((0, $fz5cK.default).search),
        isVisible: (0, $2FLDr.isValidSearchTerm)(inputValue) && (isVirtualAgentEnabled || isFetchingResults || visibleResultsCount !== 0)
    }))));
});
const $a090999bda73bef8$var$SearchTextboxV2 = (props)=>{
    if ($a090999bda73bef8$var$isHelpCenterSearchLimitEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchTextboxV2WithSearchLimit, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchTextboxV2Legacy, props);
};
const $a090999bda73bef8$var$SearchTextboxV2Legacy = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $bSJIT.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $bSJIT.useState)(false);
    const [inputValue, setInputValue] = (0, $bSJIT.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $bSJIT.useState)();
    const [{ location: location }, { push: push }] = (0, $h1bGI.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $ecFUh.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $e3RPd.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $9dLcv.useInlineResultsContext)();
    const environment = (0, $a2qIF.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $a090999bda73bef8$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $aHKzr.useSubscriptionAction)();
    (0, $bSJIT.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $fBxvm.useCreateConversationWithMessage)();
    const openChoicesIfPresent = (0, $bSJIT.useCallback)(()=>{
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $2FLDr.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled
    ]);
    const handleInputChange = (0, $bSJIT.useCallback)((event)=>{
        const newQuery = event.target.value;
        setInputValue(newQuery);
        setIsChoiceOpen((0, $2FLDr.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen
    ]);
    const onSeeSearchResults = (0, $bSJIT.useCallback)(()=>{
        if (!(0, $2FLDr.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $bSJIT.useCallback)(async ()=>{
        if (!(0, $2FLDr.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $lFpPv.isOmnichannelEnabledForHC)()) {
            const subscriptionId = await (0, $9vFUf.generateUniqueSubscriptionID)({
                environment: environment
            });
            const omniChannelMetaData = await (0, $7q3M9.fetchOmnichannelMeta)(environment);
            await (0, $3W5ib.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                subscriptionId: subscriptionId,
                draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                isConversationClosed: false,
                isConversationExpired: false,
                disableInput: false,
                isReplyPending: false,
                subscriptionTriggered: true,
                subscriptionStatus: 'TRIGGERED'
            });
            const disposable = (0, $8AFRj.establishSubscriptionToOmnichannel)({
                environment: environment,
                subscriptionId: subscriptionId
            });
            setSubscriptionDisposer(disposable);
            if (omniChannelMetaData.connectionId) createConversationWithMessage({
                subscriptionId: subscriptionId,
                workspaceAri: (0, $fuVmc.getWorkspaceAri)(),
                conversationContextAri: (0, $fuVmc.getHelpCenterAri)(),
                isTestConversation: false,
                message: inputValue.trim(),
                connectionId: omniChannelMetaData.connectionId
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $dXo4Q.initialIntentMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $ipo6m.omnichannelPageLoadExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $dXo4Q.initialAIMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aJC68.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $2rCci.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $4ZMmh.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $4ZMmh.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $4ZMmh.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $bSJIT.useCallback)((event)=>{
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if ((0, $87QgR.default).checkGate('jsm_hc_search_composing_fix') && event.nativeEvent.isComposing) return;
        if (event.key === 'Enter') {
            if (!!isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $71mH8.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setIsChoiceOpen((0, $2FLDr.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen
    ]);
    const [requestIdParam] = (0, $3Gmp6.usePathParam)('requestId');
    (0, $bSJIT.useEffect)(()=>{
        var _searchBarRef$current;
        if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && requestIdParam) return;
        // Avoid scrolling the page to a bottom-positioned search banner on load (JSDCLOUD-15743).
        (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 || _searchBarRef$current.focus({
            preventScroll: true
        });
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, isVSAOnHCEnabled && (0, $lFpPv.isOmnichannelEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kMeyd.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hXLZM.SearchPromptPopup), {
        isOpen: isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>setIsChoiceOpen(false),
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchPopupContentWithRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount
            });
        }
    }));
};
const $a090999bda73bef8$var$SearchTextboxV2WithSearchLimit = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $bSJIT.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $bSJIT.useState)(false);
    const [isCharacterLimitPopoverOpen, setIsCharacterLimitPopoverOpen] = (0, $bSJIT.useState)(false);
    const [inputValue, setInputValue] = (0, $bSJIT.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $bSJIT.useState)();
    const [{ location: location }, { push: push }] = (0, $h1bGI.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $ecFUh.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $e3RPd.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $9dLcv.useInlineResultsContext)();
    const environment = (0, $a2qIF.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $a090999bda73bef8$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $aHKzr.useSubscriptionAction)();
    (0, $bSJIT.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $fBxvm.useCreateConversationWithMessage)();
    const isSearchQueryOverLimit = (0, $2FLDr.isSearchQueryOverCharacterLimit)(inputValue);
    const openChoicesIfPresent = (0, $bSJIT.useCallback)(()=>{
        if (isSearchQueryOverLimit) return;
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $2FLDr.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled,
        isSearchQueryOverLimit
    ]);
    const handleInputChange = (0, $bSJIT.useCallback)((event)=>{
        const newQuery = event.target.value;
        const isNewQueryOverLimit = (0, $2FLDr.isSearchQueryOverCharacterLimit)(newQuery);
        setInputValue(newQuery);
        setIsCharacterLimitPopoverOpen(false);
        setIsChoiceOpen(!isNewQueryOverLimit && (0, $2FLDr.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen,
        setIsCharacterLimitPopoverOpen
    ]);
    const onSeeSearchResults = (0, $bSJIT.useCallback)(()=>{
        if (!(0, $2FLDr.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $bSJIT.useCallback)(async ()=>{
        if (!(0, $2FLDr.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $lFpPv.isOmnichannelEnabledForHC)()) {
            const subscriptionId = await (0, $9vFUf.generateUniqueSubscriptionID)({
                environment: environment
            });
            const omniChannelMetaData = await (0, $7q3M9.fetchOmnichannelMeta)(environment);
            await (0, $3W5ib.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                subscriptionId: subscriptionId,
                draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                isConversationClosed: false,
                isConversationExpired: false,
                disableInput: false,
                isReplyPending: false,
                subscriptionTriggered: true,
                subscriptionStatus: 'TRIGGERED'
            });
            const disposable = (0, $8AFRj.establishSubscriptionToOmnichannel)({
                environment: environment,
                subscriptionId: subscriptionId
            });
            setSubscriptionDisposer(disposable);
            if (omniChannelMetaData.connectionId) createConversationWithMessage({
                subscriptionId: subscriptionId,
                workspaceAri: (0, $fuVmc.getWorkspaceAri)(),
                conversationContextAri: (0, $fuVmc.getHelpCenterAri)(),
                isTestConversation: false,
                message: inputValue.trim(),
                connectionId: omniChannelMetaData.connectionId
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $dXo4Q.initialIntentMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $ipo6m.omnichannelPageLoadExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $dXo4Q.initialAIMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aJC68.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $2rCci.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $4ZMmh.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $4ZMmh.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $4ZMmh.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (isSearchQueryOverLimit) return;
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if ((0, $87QgR.default).checkGate('jsm_hc_search_composing_fix') && event.nativeEvent.isComposing) return;
        if (event.key === 'Enter') {
            if (isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $71mH8.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults,
        isSearchQueryOverLimit
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setIsChoiceOpen(!isSearchQueryOverLimit && (0, $2FLDr.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        isSearchQueryOverLimit,
        setIsChoiceOpen
    ]);
    const onCharacterLimitErrorIconClick = (0, $bSJIT.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $a090999bda73bef8$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }).fire();
        const nextIsOpen = !isCharacterLimitPopoverOpen;
        setIsCharacterLimitPopoverOpen(nextIsOpen);
        if (nextIsOpen) createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'rendered',
            actionSubject: 'popover',
            actionSubjectId: $a090999bda73bef8$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }).fire();
    }, [
        createAnalyticsEvent,
        isCharacterLimitPopoverOpen
    ]);
    const [requestIdParam] = (0, $3Gmp6.usePathParam)('requestId');
    (0, $bSJIT.useEffect)(()=>{
        var _searchBarRef$current2;
        if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && requestIdParam) return;
        // Avoid scrolling the page to a bottom-positioned search banner on load (JSDCLOUD-15743).
        (_searchBarRef$current2 = searchBarRef.current) === null || _searchBarRef$current2 === void 0 || _searchBarRef$current2.focus({
            preventScroll: true
        });
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, isVSAOnHCEnabled && (0, $lFpPv.isOmnichannelEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kMeyd.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hXLZM.SearchPromptPopup), {
        isOpen: isSearchQueryOverLimit ? isCharacterLimitPopoverOpen : isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>{
            setIsChoiceOpen(false);
            setIsCharacterLimitPopoverOpen(false);
        },
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        isSearchQueryOverLimit: isSearchQueryOverLimit,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$SearchPopupContentWithSearchLimitRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount,
                isSearchQueryOverLimit: isSearchQueryOverLimit,
                onCharacterLimitErrorIconClick: onCharacterLimitErrorIconClick
            });
        }
    }));
};
$a090999bda73bef8$var$SearchTextboxV2.displayName = 'SearchTextboxV2';
const $a090999bda73bef8$var$WrappedComponent = (0, $5OcOs.withHelpCenterConversationStateContainer)($a090999bda73bef8$var$SearchTextboxV2);
const $a090999bda73bef8$var$SearchTextBoxV2withConversationContainers = (props)=>{
    const contextId = (0, $fuVmc.getHelpCenterAri)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a090999bda73bef8$var$WrappedComponent, {
        ...props,
        contextId: contextId
    });
};
var $a090999bda73bef8$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: (0, $jcRK7.ScreenName).HELP_CENTER_SEARCH
})($a090999bda73bef8$var$SearchTextBoxV2withConversationContainers);
const $a090999bda73bef8$var$hiddenDescriptionStyles = (0, $9BVpB.xcss)({
    display: 'none'
});
const $a090999bda73bef8$var$searchBoxWrapperStyles = (0, $9BVpB.xcss)({
    position: 'relative'
});
const $a090999bda73bef8$var$visuallyHiddenStyles = (0, $9BVpB.xcss)({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    userSelect: 'none',
    whiteSpace: 'nowrap'
});
const $a090999bda73bef8$var$searchBoxStyles = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.input',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border.input',
    borderRadius: 'radius.medium',
    ':focus-within': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused'
    }
});
const $a090999bda73bef8$var$getInputPaddingRight = (props)=>{
    if (props.hasTrailingErrorIcon) return "var(--ds-space-600, 48px)";
    if (props.isAiAnswersEnabled) return '148px';
    return "var(--ds-space-600, 48px)";
};
const $a090999bda73bef8$var$getMobileInputPaddingRight = (props)=>{
    if (!(0, $lFpPv.isUseHelpCenterRefresh)()) return '';
    if (props.hasTrailingErrorIcon) return `padding-right: ${"var(--ds-space-600, 48px)"};`;
    return `padding-right: ${"var(--ds-space-050, 4px)"};`;
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a090999bda73bef8$var$Input = /*#__PURE__*/ (0, $4v2A7.default).input.withConfig({
    componentId: "sc-d7rq06-0"
})`${(0, $1DDTY.SEARCH_INPUT_FONT_SIZE)};${$fU62V.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};border-radius:${"var(--ds-radius-medium, 6px)"};padding:${$9K7mZ.multiple(2.125).px}  ${(props)=>props.isAiAnswersEnabled ? '148px' : "var(--ds-space-600, 48px)"} ${$9K7mZ.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${(0, $lFpPv.isUseHelpCenterRefresh)() ? `padding-right: ${"var(--ds-space-050, 4px)"};` : ''}}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a090999bda73bef8$var$InputWithSearchLimit = /*#__PURE__*/ (0, $4v2A7.default).input.withConfig({
    componentId: "sc-d7rq06-1"
})`${(0, $1DDTY.SEARCH_INPUT_FONT_SIZE)};${$fU62V.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};border-radius:${"var(--ds-radius-medium, 6px)"};padding:${$9K7mZ.multiple(2.125).px} ${$a090999bda73bef8$var$getInputPaddingRight} ${$9K7mZ.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${$a090999bda73bef8$var$getMobileInputPaddingRight}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a090999bda73bef8$var$SearchIconWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt4119w _4t3i1osq _1ltvidpf _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1wpz1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});
const $a090999bda73bef8$var$askAiHintStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    color: 'color.text.subtle',
    top: 'space.0',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 11
});
const $a090999bda73bef8$var$errorIconWrapperStyles = (0, $9BVpB.xcss)({
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    textAlign: 'right',
    top: 'space.0',
    bottom: 'space.0'
});

});
parcelRegister("9cCli", function(module, exports) {
module.exports = new URL("../images/enter-icon.6e72b8c1.svg", import.meta.url).toString();

});

parcelRegister("8Omen", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => (parcelRequire("e3RPd")).useSendMessage);
$parcel$export(module.exports, "useIsGenerating", () => (parcelRequire("ct4xy")).useIsGenerating);
$parcel$export(module.exports, "useIsInputEnabled", () => (parcelRequire("7MeZO")).useIsInputEnabled);
$parcel$export(module.exports, "useHasMessages", () => (parcelRequire("dqRJl")).useHasMessages);
$parcel$export(module.exports, "useStopGenerating", () => (parcelRequire("9mJt2")).useStopGenerating);
$parcel$export(module.exports, "useGetMaxChars", () => (parcelRequire("5BJMm")).useGetMaxChars);
$parcel$export(module.exports, "useIsInputShown", () => (parcelRequire("d1TIb")).useIsInputShown);
$parcel$export(module.exports, "useClearConversation", () => (parcelRequire("5LNUw")).useClearConversation);
$parcel$export(module.exports, "useHandOffConversation", () => (parcelRequire("iYtfh")).useHandOffConversation);

var $e3RPd = parcelRequire("e3RPd");

var $ct4xy = parcelRequire("ct4xy");

var $7MeZO = parcelRequire("7MeZO");

var $dqRJl = parcelRequire("dqRJl");

var $9mJt2 = parcelRequire("9mJt2");

var $5BJMm = parcelRequire("5BJMm");

var $d1TIb = parcelRequire("d1TIb");

var $5LNUw = parcelRequire("5LNUw");

var $iYtfh = parcelRequire("iYtfh");

});
parcelRegister("e3RPd", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $139f471af7181faa$export$fe8707b58c509543);

var $aJC68 = parcelRequire("aJC68");

var $a7ugj = parcelRequire("a7ugj");

var $2rCci = parcelRequire("2rCci");

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $ecFUh = parcelRequire("ecFUh");
const $139f471af7181faa$export$fe8707b58c509543 = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const { sendMessage: sendVirtualAgentMessage } = (0, $a7ugj.useSendMessage)();
    const { addHelpseekerMessage: addAIAnswersMessage } = (0, $ecFUh.useActions)();
    const sendMessage = (message)=>{
        provider === (0, $3det2.ConversationProvider).AI_ANSWERS ? addAIAnswersMessage(message) : sendVirtualAgentMessage(message);
        if (provider === (0, $3det2.ConversationProvider).AI_ANSWERS) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $2rCci.AIAnswerExperience).start();
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $aJC68.intentAnswerExperience).start();
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("aJC68", function(module, exports) {
$parcel$export(module.exports, "intentAnswerExperience", () => $cfb42cea37d95382$export$b0aa4ee2c3e0b407);
$parcel$export(module.exports, "initialIntentMessageExperience", () => $cfb42cea37d95382$export$1bc905fb9e119ab8);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $cfb42cea37d95382$var$intentAnswerExperienceId = 'service-management.help-center.virtual-agent.intent-message';
const $cfb42cea37d95382$var$initialIntentMessageExperienceId = 'service-management.help-center.virtual-agent.intent-initial-message-reply';
const $cfb42cea37d95382$export$b0aa4ee2c3e0b407 = new (0, $1we90.UFOExperience)($cfb42cea37d95382$var$intentAnswerExperienceId, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $cfb42cea37d95382$export$1bc905fb9e119ab8 = new (0, $1we90.UFOExperience)($cfb42cea37d95382$var$initialIntentMessageExperienceId, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("a7ugj", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $d0eafc923473526e$export$fe8707b58c509543);

var $aXiin = parcelRequire("aXiin");

var $eORcq = parcelRequire("eORcq");

var $8c54L = parcelRequire("8c54L");
const $d0eafc923473526e$export$fe8707b58c509543 = ()=>{
    const { addMessage: addMessage, addJiraFieldMessage: addJiraFieldMessage } = (0, $8c54L.useActions)();
    const jiraField = (0, $8c54L.useFieldFromLastMessage)();
    const baseUrl = (0, $8c54L.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $aXiin.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const sendMessage = (message)=>{
        if (jiraField && (0, $eORcq.isTextField)(jiraField.fieldId, requestTypeFields)) addJiraFieldMessage(jiraField.fieldId, message);
        else addMessage(message);
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("aXiin", function(module, exports) {
$parcel$export(module.exports, "useRequestTypeFields", () => $d1a8641cc194683f$export$6fa5557c101e4783);

var $bSJIT = parcelRequire("bSJIT");

var $51XYw = parcelRequire("51XYw");

var $d490n = parcelRequire("d490n");
const $d1a8641cc194683f$export$6fa5557c101e4783 = ({ baseUrl: baseUrl = '' })=>{
    const { setRequestTypeFieldsMap: setRequestTypeFieldsMap, setIsLoading: setIsLoading, setError: setError } = (0, $d490n.useActions)();
    const fieldStore = (0, $d490n.useStore)();
    const requestTypeFieldPromise = (0, $d490n.useRequestTypeFieldPromise)();
    const getRequestTypeFieldsEndpoint = (0, $bSJIT.useCallback)((projectId, requestTypeId)=>{
        if (!requestTypeId) return '';
        const projectIdentifier = `projectId:${projectId}`;
        return `${baseUrl}/rest/servicedeskapi/servicedesk/${encodeURIComponent(projectIdentifier)}/requesttype/${encodeURIComponent(requestTypeId)}/field`;
    }, [
        baseUrl
    ]);
    const convertedRequestTypeFieldMap = (0, $bSJIT.useCallback)((response)=>{
        return new Map(response === null || response === void 0 ? void 0 : response.requestTypeFields.map((field)=>[
                field.fieldId,
                field
            ]));
    }, []);
    const fetchRequestTypeFields = (0, $bSJIT.useCallback)(async (projectId, requestTypeId)=>{
        try {
            if (!requestTypeId) throw new Error('requestTypeId is undefined');
            const response = await (0, $51XYw.fetchJson)(getRequestTypeFieldsEndpoint(projectId, requestTypeId), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const convertedMap = convertedRequestTypeFieldMap(response);
            setRequestTypeFieldsMap(convertedMap);
            return convertedMap;
        } catch (err) {
            setError(err);
            return undefined;
        }
    }, [
        getRequestTypeFieldsEndpoint,
        convertedRequestTypeFieldMap,
        setRequestTypeFieldsMap,
        setError
    ]);
    const cacheIsInvalid = (0, $bSJIT.useCallback)((projectId, requestTypeId)=>{
        if (!fieldStore.cacheIds) return true;
        return projectId !== fieldStore.cacheIds.projectId || requestTypeId !== fieldStore.cacheIds.requestTypeId;
    }, [
        fieldStore.cacheIds
    ]);
    const fetchFieldsOrUseCache = (0, $bSJIT.useCallback)(async (projectId, requestTypeId)=>{
        if (cacheIsInvalid(projectId, requestTypeId)) {
            const request = fetchRequestTypeFields(projectId, requestTypeId);
            setIsLoading({
                projectId: projectId,
                requestTypeId: requestTypeId
            }, request);
            return request;
        }
        return requestTypeFieldPromise;
    }, [
        cacheIsInvalid,
        fetchRequestTypeFields,
        requestTypeFieldPromise,
        setIsLoading
    ]);
    return [
        {
            loading: fieldStore.loading,
            data: fieldStore.requestTypeFieldsMap,
            error: fieldStore.error
        },
        {
            fetchRequestTypeFields: fetchFieldsOrUseCache
        }
    ];
};

});
parcelRegister("d490n", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $6483cb20c4c0c428$export$6ccbb43953eebf8);
$parcel$export(module.exports, "useActions", () => $6483cb20c4c0c428$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useRequestTypeFieldPromise", () => $6483cb20c4c0c428$export$c9a90d3a86a18942);

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $b4EpL = parcelRequire("b4EpL");
const $6483cb20c4c0c428$var$initialState = {
    loading: false,
    cacheIds: undefined,
    requestTypeFieldsMap: new Map()
};
const $6483cb20c4c0c428$export$b6b2c03d619b3cc5 = (0, $7CE69.createStore)({
    initialState: $6483cb20c4c0c428$var$initialState,
    actions: $b4EpL.actions,
    name: 'requestTypeFields'
});
const $6483cb20c4c0c428$export$6ccbb43953eebf8 = (0, $gfNVK.createStateHook)($6483cb20c4c0c428$export$b6b2c03d619b3cc5);
const $6483cb20c4c0c428$export$bc923229a7fa61e7 = (0, $gfNVK.createActionsHook)($6483cb20c4c0c428$export$b6b2c03d619b3cc5);
const $6483cb20c4c0c428$export$c9a90d3a86a18942 = (0, $gfNVK.createStateHook)($6483cb20c4c0c428$export$b6b2c03d619b3cc5, {
    selector: (state)=>state.inFlightRequest ? state.inFlightRequest : state.requestTypeFieldsMap
});

});
parcelRegister("b4EpL", function(module, exports) {
$parcel$export(module.exports, "actions", () => $3368387ffe6e25fd$export$e324594224ef24da);

var $fjf5U = parcelRequire("fjf5U");
const $3368387ffe6e25fd$var$setRequestTypeFieldsMap = (requestTypeFieldsMap)=>({ setState: setState })=>{
        setState({
            requestTypeFieldsMap: requestTypeFieldsMap,
            error: undefined,
            inFlightRequest: undefined,
            loading: false
        });
    };
const $3368387ffe6e25fd$var$setIsLoading = (cacheIds, inFlightRequest)=>({ setState: setState })=>{
        setState({
            cacheIds: cacheIds,
            inFlightRequest: inFlightRequest,
            loading: true
        });
    };
const $3368387ffe6e25fd$var$setError = (e)=>({ setState: setState })=>{
        const error = e instanceof Error ? e : new Error('Unknown error');
        (0, $fjf5U.sendErrorEvent)({
            error: error,
            actionSubject: 'fetchRequestTypeFields'
        });
        setState({
            error: error,
            loading: false
        });
    };
const $3368387ffe6e25fd$export$e324594224ef24da = {
    setRequestTypeFieldsMap: $3368387ffe6e25fd$var$setRequestTypeFieldsMap,
    setIsLoading: $3368387ffe6e25fd$var$setIsLoading,
    setError: $3368387ffe6e25fd$var$setError
};

});
parcelRegister("fjf5U", function(module, exports) {
$parcel$export(module.exports, "sendUIEvent", () => $df5e2b5dd1b2e129$export$1aecf263098db667);
$parcel$export(module.exports, "sendTrackEvent", () => $df5e2b5dd1b2e129$export$1ba525b8a711eaac);
$parcel$export(module.exports, "sendErrorEvent", () => $df5e2b5dd1b2e129$export$c9036e6c0dcd8835);

var $clpci = parcelRequire("clpci");

var $iRD29 = parcelRequire("iRD29");
const $df5e2b5dd1b2e129$var$getVASource = ()=>{
    return `virtualAgent${0, $clpci.SCREEN}`;
};
const $df5e2b5dd1b2e129$export$1aecf263098db667 = (event)=>{
    const analyticsClient = (0, $iRD29.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendUIEvent({
        ...event,
        source: $df5e2b5dd1b2e129$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send UI analytics event ${error}`);
    });
};
const $df5e2b5dd1b2e129$export$22a3b1671f38a193 = ({ name: name, attributes: attributes })=>{
    const event = {
        name: name,
        attributes: {
            ...attributes,
            source: $df5e2b5dd1b2e129$var$getVASource()
        }
    };
    const analyticsClient = (0, $iRD29.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendScreenEvent(event).catch((error)=>{
        throw new Error(`Failure to send screen analytics event ${error}`);
    });
};
const $df5e2b5dd1b2e129$export$1ba525b8a711eaac = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    const analyticsClient = (0, $iRD29.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendTrackEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        source: $df5e2b5dd1b2e129$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send track analytics event ${error}`);
    });
};
const $df5e2b5dd1b2e129$export$e5f89b51c6d4e36b = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $df5e2b5dd1b2e129$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        action: 'success'
    });
};
const $df5e2b5dd1b2e129$export$c9036e6c0dcd8835 = ({ error: error, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $df5e2b5dd1b2e129$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: 'failed',
        attributes: {
            ...attributes,
            error: error
        }
    });
};
const $df5e2b5dd1b2e129$var$sendOperationalOrErrorAnalyticsEvent = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, action: action, attributes: attributes })=>{
    const analyticsClient = (0, $iRD29.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendOperationalEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes,
        source: $df5e2b5dd1b2e129$var$getVASource()
    }).catch((err)=>{
        throw new Error(`Failure to send operational analytics event ${err}`);
    });
};

});




parcelRegister("eORcq", function(module, exports) {
$parcel$export(module.exports, "SHORT_TEXT_FIELD_TYPE", () => $ef82cfbf1f283b4f$export$4351cd1d22652b1a);
$parcel$export(module.exports, "PARAGRAPH_FIELD_TYPE", () => $ef82cfbf1f283b4f$export$a66f2119b5091b7e);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_TYPE", () => $ef82cfbf1f283b4f$export$dbe52b9d883d2625);
$parcel$export(module.exports, "DATE_PICKER_FIELD_TYPE", () => $ef82cfbf1f283b4f$export$4a9ce2f29e91e07);
$parcel$export(module.exports, "getFieldType", () => $ef82cfbf1f283b4f$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isTextField", () => $ef82cfbf1f283b4f$export$1cda748695867c48);
const $ef82cfbf1f283b4f$export$4351cd1d22652b1a = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $ef82cfbf1f283b4f$export$a66f2119b5091b7e = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $ef82cfbf1f283b4f$export$dbe52b9d883d2625 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $ef82cfbf1f283b4f$export$4a9ce2f29e91e07 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $ef82cfbf1f283b4f$export$b9089a6e41ed43aa = (fieldId, data)=>{
    const field = data.get(fieldId);
    if (!field) return undefined;
    if ('custom' in field.jiraSchema) return field.jiraSchema.custom;
    return undefined;
};
const $ef82cfbf1f283b4f$export$1cda748695867c48 = (fieldId, data)=>{
    const fieldType = $ef82cfbf1f283b4f$export$b9089a6e41ed43aa(fieldId, data);
    return fieldType === $ef82cfbf1f283b4f$export$4351cd1d22652b1a || fieldType === $ef82cfbf1f283b4f$export$a66f2119b5091b7e;
};

});

parcelRegister("8c54L", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $d945bb5dd3a3195e$export$4d17e2d9c5348842);
$parcel$export(module.exports, "useIsLoading", () => $d945bb5dd3a3195e$export$4dface15d86304a4);
$parcel$export(module.exports, "useError", () => $d945bb5dd3a3195e$export$5027865de34f9ec6);
$parcel$export(module.exports, "useBaseUrl", () => $d945bb5dd3a3195e$export$d791fbc58bd47703);
$parcel$export(module.exports, "useFieldFromLastMessage", () => $d945bb5dd3a3195e$export$c011746629259c11);
$parcel$export(module.exports, "useIsLastMessage", () => $d945bb5dd3a3195e$export$cd2e50d12ce4b586);
$parcel$export(module.exports, "useConversationHasMessages", () => $d945bb5dd3a3195e$export$400cd0867e25f460);
$parcel$export(module.exports, "useActions", () => $d945bb5dd3a3195e$export$bc923229a7fa61e7);

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $adqyI = parcelRequire("adqyI");

var $ae5xF = parcelRequire("ae5xF");

var $8NV0o = parcelRequire("8NV0o");
const $d945bb5dd3a3195e$var$initialState = {
    conversationProvider: {
        sendMessage: ()=>Promise.reject(new Error('No conversation provider')),
        startConversation: ()=>Promise.reject(new Error('No conversation provider'))
    },
    messages: []
};
const $d945bb5dd3a3195e$var$store = (0, $7CE69.createStore)({
    actions: $adqyI.actions,
    initialState: $d945bb5dd3a3195e$var$initialState,
    name: 'Conversation',
    containedBy: (0, $ae5xF.ConversationStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            },
        onContainerUpdate: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            }
    }
});
const $d945bb5dd3a3195e$export$4d17e2d9c5348842 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (state)=>state.messages
});
const $d945bb5dd3a3195e$export$4dface15d86304a4 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (state)=>state.isLoading
});
const $d945bb5dd3a3195e$export$5027865de34f9ec6 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (state)=>state.error
});
const $d945bb5dd3a3195e$export$d791fbc58bd47703 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (state)=>state.baseUrl
});
const $d945bb5dd3a3195e$export$de966b4845cf82cc = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (0, $8NV0o.getAppendicesFromLastMessage)
});
const $d945bb5dd3a3195e$export$c011746629259c11 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (0, $8NV0o.getJiraFieldFromLastMessage)
});
const $d945bb5dd3a3195e$export$314d3fbd2eb8690 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (0, $8NV0o.getLastHelpseekerMessage)
});
const $d945bb5dd3a3195e$export$cd2e50d12ce4b586 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (0, $8NV0o.getIsLastMessage)
});
const $d945bb5dd3a3195e$export$400cd0867e25f460 = (0, $gfNVK.createStateHook)($d945bb5dd3a3195e$var$store, {
    selector: (state)=>state.messages.length > 0
});
const $d945bb5dd3a3195e$export$bc923229a7fa61e7 = (0, $gfNVK.createActionsHook)($d945bb5dd3a3195e$var$store);

});
parcelRegister("adqyI", function(module, exports) {
$parcel$export(module.exports, "actions", () => $18ff2f3bab544853$export$e324594224ef24da);

var $7roH1 = parcelRequire("7roH1");

var $ditNh = parcelRequire("ditNh");

var $2dhv0 = parcelRequire("2dhv0");

var $4wtyf = parcelRequire("4wtyf");

var $3vl0U = parcelRequire("3vl0U");

var $jvXEG = parcelRequire("jvXEG");
const $18ff2f3bab544853$export$e324594224ef24da = {
    addMessage: $ditNh.addMessage,
    selectOption: $jvXEG.selectOption,
    clearConversation: $2dhv0.clearConversation,
    addJiraFieldMessage: $7roH1.addJiraFieldMessage,
    retryLastHelpseekerMessage: $3vl0U.retryLastHelpseekerMessage,
    resetState: $4wtyf.resetState
};

});
parcelRegister("7roH1", function(module, exports) {
$parcel$export(module.exports, "addJiraFieldMessage", () => $57224773aacba3ad$export$73f4cb8f39bccbbf);

var $aJC68 = parcelRequire("aJC68");

var $a0TU4 = parcelRequire("a0TU4");

var $cm8G1 = parcelRequire("cm8G1");
const $57224773aacba3ad$export$73f4cb8f39bccbbf = (fieldId, value, messageContent)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $a0TU4.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            content: messageContent || value,
            jiraField: {
                fieldId: fieldId,
                value: value
            }
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $aJC68.intentAnswerExperience).start();
        return dispatch((0, $cm8G1.sendHelpseekerMessage)(helpseekerMessage));
    };

});
parcelRegister("a0TU4", function(module, exports) {
$parcel$export(module.exports, "constructHelpseekerMessage", () => $dd18b62061979f23$export$8ea190576bc1c325);

var $eL3zl = parcelRequire("eL3zl");

var $bhIIN = parcelRequire("bhIIN");

var $aKjrj = parcelRequire("aKjrj");
const $dd18b62061979f23$export$8ea190576bc1c325 = (messageBody)=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId } = getState();
        const helpseekerMessage = {
            message: {
                ...messageBody,
                content: (0, $bhIIN.doc)((0, $aKjrj.paragraph)(messageBody.content))
            },
            id: `client::${(0, $eL3zl.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || ''
        };
        // add user message
        setState({
            isLoading: true,
            messages: [
                ...messages,
                helpseekerMessage
            ]
        });
        return helpseekerMessage;
    };

});
parcelRegister("eL3zl", function(module, exports) {

var $8MVCB = parcelRequire("8MVCB");

var $9c4dC = parcelRequire("9c4dC");
var $abe8393dac4c079c$var$uuid = $9c4dC;
$abe8393dac4c079c$var$uuid.v1 = $8MVCB;
$abe8393dac4c079c$var$uuid.v4 = $9c4dC;
module.exports = $abe8393dac4c079c$var$uuid;

});
parcelRegister("8MVCB", function(module, exports) {

var $fwRfo = parcelRequire("fwRfo");

var $8iMQb = parcelRequire("8iMQb");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $665f80daab089f8c$var$_nodeId;
var $665f80daab089f8c$var$_clockseq;
// Previous uuid creation time
var $665f80daab089f8c$var$_lastMSecs = 0;
var $665f80daab089f8c$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $665f80daab089f8c$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $665f80daab089f8c$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $665f80daab089f8c$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $fwRfo();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $665f80daab089f8c$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $665f80daab089f8c$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $665f80daab089f8c$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $665f80daab089f8c$var$_lastMSecs + (nsecs - $665f80daab089f8c$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $665f80daab089f8c$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $665f80daab089f8c$var$_lastMSecs = msecs;
    $665f80daab089f8c$var$_lastNSecs = nsecs;
    $665f80daab089f8c$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $8iMQb(b);
}
module.exports = $665f80daab089f8c$var$v1;

});
parcelRegister("fwRfo", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $b4e325f6376c81d2$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($b4e325f6376c81d2$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $b4e325f6376c81d2$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $b4e325f6376c81d2$var$getRandomValues($b4e325f6376c81d2$var$rnds8);
        return $b4e325f6376c81d2$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $b4e325f6376c81d2$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $b4e325f6376c81d2$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $b4e325f6376c81d2$var$rnds;
    };
}

});

parcelRegister("8iMQb", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $60b5e3e65c05dcbc$var$byteToHex = [];
for(var $60b5e3e65c05dcbc$var$i = 0; $60b5e3e65c05dcbc$var$i < 256; ++$60b5e3e65c05dcbc$var$i)$60b5e3e65c05dcbc$var$byteToHex[$60b5e3e65c05dcbc$var$i] = ($60b5e3e65c05dcbc$var$i + 0x100).toString(16).substr(1);
function $60b5e3e65c05dcbc$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $60b5e3e65c05dcbc$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $60b5e3e65c05dcbc$var$bytesToUuid;

});


parcelRegister("9c4dC", function(module, exports) {

var $fwRfo = parcelRequire("fwRfo");

var $8iMQb = parcelRequire("8iMQb");
function $6b1881c612904780$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $fwRfo)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $8iMQb(rnds);
}
module.exports = $6b1881c612904780$var$v4;

});


parcelRegister("bhIIN", function(module, exports) {
$parcel$export(module.exports, "doc", () => $5ea03ba777508615$export$2a111da947c407d2);
const $5ea03ba777508615$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("aKjrj", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $c50dfd06497d5d81$export$9c206ddddb32a9b);

var $eSRwv = parcelRequire("eSRwv");
const $c50dfd06497d5d81$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $eSRwv.createTextNodes)(content)
    });

});
parcelRegister("eSRwv", function(module, exports) {
$parcel$export(module.exports, "createTextNodes", () => $2b8ff394500273ee$export$3a269a5941b62f04);

var $eTOAj = parcelRequire("eTOAj");
function $2b8ff394500273ee$export$3a269a5941b62f04(nodes) {
    return nodes.map((0, $eTOAj.createTextFromString));
}

});
parcelRegister("eTOAj", function(module, exports) {
$parcel$export(module.exports, "createTextFromString", () => $d33dc38e476524ce$export$72b9432ea0656b50);

var $daHgL = parcelRequire("daHgL");
function $d33dc38e476524ce$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $daHgL.text)(str) : str;
}

});
parcelRegister("daHgL", function(module, exports) {
$parcel$export(module.exports, "text", () => $6f220f0d44a5614e$export$6f093cfa640b7166);
const $6f220f0d44a5614e$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});





parcelRegister("cm8G1", function(module, exports) {
$parcel$export(module.exports, "sendHelpseekerMessage", () => $f7ca87961349eb97$export$78d52c3c7b67d769);

var $4ZMmh = parcelRequire("4ZMmh");

var $2rCci = parcelRequire("2rCci");

var $fjf5U = parcelRequire("fjf5U");

var $aJC68 = parcelRequire("aJC68");

var $2iZcJ = parcelRequire("2iZcJ");
const $f7ca87961349eb97$export$78d52c3c7b67d769 = (message)=>({ getState: getState, setState: setState, dispatch: dispatch }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent, abortController: abortController } = getState();
        if (!conversationId || !abortController) {
            dispatch((0, $2iZcJ.sendMessageErrorHandler)());
            return;
        }
        conversationProvider.sendMessage(message, abortController.signal).then(async (response)=>{
            var _last;
            // https://data-portal.internal.atlassian.com/analytics/registry/65969
            (0, $fjf5U.sendTrackEvent)({
                action: 'sent',
                actionSubject: 'conversationMessage',
                actionSubjectId: conversationId,
                attributes: {
                    conversationId: conversationId,
                    contextId: contextId,
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aJC68.initialIntentMessageExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aJC68.intentAnswerExperience).success();
            if (handleEscalateFromVirtualAgent && response.length && response[response.length - 1].conversationState === 'escalated') {
                handleEscalateFromVirtualAgent();
                return;
            }
            if ((_last = (0, $4ZMmh.last)(response)) !== null && _last !== void 0 && _last.shouldHandoff) {
                const { messages: messages } = getState();
                if (handleHandOff) await handleHandOff(messages, conversationId, contextId);
                const metricMetaData = {
                    contextId: contextId,
                    conversationId: conversationId,
                    handOff: true,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aJC68.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aJC68.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $2rCci.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $2rCci.initialAIAnswerExperience).start();
                return;
            }
            for(let i = 0; i < response.length; i++)setTimeout(()=>{
                const { messages: newMessages } = getState();
                setState({
                    messages: newMessages.concat(response[i])
                });
            }, 500 * i); // 500ms delay between each message
        }).catch(()=>{
            dispatch((0, $2iZcJ.sendMessageErrorHandler)());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aJC68.initialIntentMessageExperience).failure();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aJC68.intentAnswerExperience).failure();
        }).finally(()=>setState({
                isLoading: false
            }));
    };

});
parcelRegister("2rCci", function(module, exports) {
$parcel$export(module.exports, "AIAnswerExperience", () => $1ed229a9a4109b0d$export$1b78ddffe984ff3a);
$parcel$export(module.exports, "initialAIAnswerExperience", () => $1ed229a9a4109b0d$export$7cb0088260227065);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $1ed229a9a4109b0d$var$AIAnswerExperienceId = 'service-management.help-center.ai-message';
const $1ed229a9a4109b0d$var$initialAIAnswerExperienceId = 'service-management.help-center.ai-initial-message-reply';
const $1ed229a9a4109b0d$export$1b78ddffe984ff3a = new (0, $1we90.UFOExperience)($1ed229a9a4109b0d$var$AIAnswerExperienceId, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $1ed229a9a4109b0d$export$7cb0088260227065 = new (0, $1we90.UFOExperience)($1ed229a9a4109b0d$var$initialAIAnswerExperienceId, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("2iZcJ", function(module, exports) {
$parcel$export(module.exports, "sendMessageErrorHandler", () => $1476d53b53a5fca8$export$30fe8f944e81bd35);

var $eL3zl = parcelRequire("eL3zl");

var $fjf5U = parcelRequire("fjf5U");
const $1476d53b53a5fca8$export$30fe8f944e81bd35 = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId } = getState();
        // https://data-portal.internal.atlassian.com/analytics/registry/65971
        (0, $fjf5U.sendTrackEvent)({
            action: 'failed',
            actionSubject: 'conversationSendMessage',
            actionSubjectId: conversationId || '',
            attributes: {
                conversationId: conversationId,
                contextId: contextId,
                portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
            }
        });
        const errorMessage = {
            id: `client::${(0, $eL3zl.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || '',
            message: {
                authorType: 'ERROR'
            }
        };
        setState({
            messages: [
                ...messages,
                errorMessage
            ]
        });
    };

});



parcelRegister("ditNh", function(module, exports) {
$parcel$export(module.exports, "addMessage", () => $d2abc89f6769fb01$export$16fdb433d434f08);

var $a0TU4 = parcelRequire("a0TU4");

var $cm8G1 = parcelRequire("cm8G1");

var $cnHCj = parcelRequire("cnHCj");
const $d2abc89f6769fb01$export$180697e5b334e664 = (message)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { conversationId: conversationId } = getState();
        try {
            const helpseekerMessage = dispatch((0, $a0TU4.constructHelpseekerMessage)({
                authorType: 'HELPSEEKER',
                content: message
            }));
            // start new conversation if no conversation id
            if (!conversationId) {
                const newConversationId = await dispatch((0, $cnHCj.startConversation)(helpseekerMessage));
                if (!newConversationId) throw new Error('A conversation id for this conversation already exists.');
                helpseekerMessage.conversationChannelId = newConversationId;
            }
            return dispatch((0, $cm8G1.sendHelpseekerMessage)(helpseekerMessage));
        } catch (error) {
            setState({
                isLoading: false
            });
            return undefined;
        }
    };
const $d2abc89f6769fb01$export$16fdb433d434f08 = (message)=>({ dispatch: dispatch })=>{
        dispatch($d2abc89f6769fb01$export$180697e5b334e664(message)).catch(()=>{
            return undefined;
        });
    };

});
parcelRegister("cnHCj", function(module, exports) {
$parcel$export(module.exports, "startConversation", () => $b81a2c7a7481e877$export$263d31a093aceb09);

var $2rCci = parcelRequire("2rCci");

var $fjf5U = parcelRequire("fjf5U");

var $aJC68 = parcelRequire("aJC68");
const $b81a2c7a7481e877$export$263d31a093aceb09 = (helpseekerMessage)=>async ({ getState: getState, setState: setState }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { projectId: projectId, portalId: portalId, contextId: contextId } = getState();
        const abortController = new AbortController();
        setState({
            abortController: abortController
        });
        const handleError = (error)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/65973
            (0, $fjf5U.sendTrackEvent)({
                action: 'failed',
                actionSubject: 'startConversation',
                attributes: {
                    contextId: contextId,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            setState({
                error: error
            });
            throw new Error(error);
        };
        try {
            const response = await conversationProvider.startConversation(abortController.signal, helpseekerMessage === null || helpseekerMessage === void 0 ? void 0 : helpseekerMessage.message);
            if (abortController.signal.aborted) return undefined;
            if (!(response !== null && response !== void 0 && response.id)) throw Error('No conversation id.');
            // https://data-portal.internal.atlassian.com/analytics/registry/65970
            (0, $fjf5U.sendTrackEvent)({
                action: 'started',
                actionSubject: 'conversation',
                actionSubjectId: response.id,
                attributes: {
                    contextId: contextId,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            if (response.shouldHandoff && handleHandOff) {
                const messages = helpseekerMessage ? [
                    helpseekerMessage
                ] : [];
                const metricMetaData = {
                    contextId: contextId,
                    handOff: true,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aJC68.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aJC68.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $2rCci.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $2rCci.initialAIAnswerExperience).start();
                return handleHandOff(messages, response.id, contextId);
            }
            setState({
                conversationId: response.id
            });
            return response.id;
        } catch (error) {
            if (error instanceof Error) return handleError(error.message);
            return handleError('Failed to start conversation.');
        }
    };

});


parcelRegister("2dhv0", function(module, exports) {
$parcel$export(module.exports, "clearConversation", () => $bdb9c0595d81d64d$export$2c9f6ca76cd8a6bc);

var $fjf5U = parcelRequire("fjf5U");
const $bdb9c0595d81d64d$export$2c9f6ca76cd8a6bc = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, abortController: abortController } = getState();
        if (!messages.length && !conversationId) return;
        // https://data-portal.internal.atlassian.com/analytics/registry/69030
        (0, $fjf5U.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'clearConversationButton'
        });
        if (abortController) abortController.abort();
        setState({
            messages: [],
            conversationId: undefined,
            isLoading: false,
            abortController: undefined
        });
    };

});

parcelRegister("4wtyf", function(module, exports) {
$parcel$export(module.exports, "resetState", () => $ddf841e36e2812e7$export$8e84bad0b35de9e8);
const $ddf841e36e2812e7$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
        setState({
            conversationProvider: conversationProvider,
            portalId: portalId,
            projectId: projectId,
            contextId: contextId,
            baseUrl: baseUrl,
            isTestConversation: isTestConversation,
            handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
        });
    };

});

parcelRegister("3vl0U", function(module, exports) {
$parcel$export(module.exports, "retryLastHelpseekerMessage", () => $81a3949db894c885$export$f34b435044a39700);

var $eL3zl = parcelRequire("eL3zl");

var $8NV0o = parcelRequire("8NV0o");

var $cm8G1 = parcelRequire("cm8G1");
const $81a3949db894c885$export$f34b435044a39700 = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const state = getState();
        const lastMessage = (0, $8NV0o.getLastHelpseekerMessage)(state);
        if (!lastMessage) return;
        const retryMessage = {
            ...lastMessage,
            id: `client::${(0, $eL3zl.v4)()}`,
            timeCreated: new Date().toISOString()
        };
        setState({
            isLoading: true,
            messages: [
                ...state.messages,
                retryMessage
            ]
        });
        dispatch((0, $cm8G1.sendHelpseekerMessage)(retryMessage));
    };

});
parcelRegister("8NV0o", function(module, exports) {
$parcel$export(module.exports, "getAppendicesFromLastMessage", () => $68b5165f813e4db8$export$3d8caa938a084e16);
$parcel$export(module.exports, "getJiraFieldFromLastMessage", () => $68b5165f813e4db8$export$84b2c2cda37f9350);
$parcel$export(module.exports, "getLastHelpseekerMessage", () => $68b5165f813e4db8$export$1596bd9bbfc2b67c);
$parcel$export(module.exports, "getIsLastMessage", () => $68b5165f813e4db8$export$660eeeb2ec021068);

var $4ZMmh = parcelRequire("4ZMmh");
const $68b5165f813e4db8$export$3d8caa938a084e16 = (state)=>{
    const lastMessage = (0, $4ZMmh.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) === 'AGENT') return lastMessage.message.appendices;
    return undefined;
};
const $68b5165f813e4db8$export$84b2c2cda37f9350 = (state)=>{
    const lastMessage = (0, $4ZMmh.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) !== 'AGENT' || !(lastMessage !== null && lastMessage !== void 0 && lastMessage.message.appendices)) return undefined;
    const jiraField = lastMessage.message.appendices.find((appendix)=>appendix.type === 'JIRA_FIELD');
    return jiraField;
};
const $68b5165f813e4db8$export$1596bd9bbfc2b67c = (state)=>(0, $4ZMmh.findLast)(state.messages, (message)=>message.message.authorType === 'HELPSEEKER');
const $68b5165f813e4db8$export$660eeeb2ec021068 = (state, messageId)=>{
    var _findLast;
    return messageId === ((_findLast = (0, $4ZMmh.findLast)(state.messages)) === null || _findLast === void 0 ? void 0 : _findLast.id);
};

});


parcelRegister("jvXEG", function(module, exports) {
$parcel$export(module.exports, "selectOption", () => $1b3df0ac7800d6e6$export$f6a817e077493ad8);

var $aJC68 = parcelRequire("aJC68");

var $a0TU4 = parcelRequire("a0TU4");

var $cm8G1 = parcelRequire("cm8G1");
const $1b3df0ac7800d6e6$export$f6a817e077493ad8 = (option)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $a0TU4.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            optionId: option.id,
            content: option.label || ''
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $aJC68.intentAnswerExperience).start();
        return dispatch((0, $cm8G1.sendHelpseekerMessage)(helpseekerMessage));
    };

});


parcelRegister("ae5xF", function(module, exports) {
$parcel$export(module.exports, "ConversationStateContainer", () => $d167dc70427573b7$export$2d1cf1e83cc748b3);

var $adFyB = parcelRequire("adFyB");
const $d167dc70427573b7$export$2d1cf1e83cc748b3 = (0, $adFyB.createContainer)();

});



parcelRegister("5thR1", function(module, exports) {
$parcel$export(module.exports, "useProvider", () => $904e1e19fca27bc8$export$693cdb10cec23617);
$parcel$export(module.exports, "useIsRouting", () => $904e1e19fca27bc8$export$f2eec64eca530862);
$parcel$export(module.exports, "useActions", () => $904e1e19fca27bc8$export$bc923229a7fa61e7);

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $3det2 = parcelRequire("3det2");

var $4VS8G = parcelRequire("4VS8G");

var $csrdO = parcelRequire("csrdO");
const $904e1e19fca27bc8$var$initialState = {
    provider: (0, $3det2.ConversationProvider).VIRTUAL_AGENT,
    contextId: '',
    isRouting: false
};
const $904e1e19fca27bc8$var$store = (0, $7CE69.createStore)({
    initialState: $904e1e19fca27bc8$var$initialState,
    actions: {
        setProvider: $4VS8G.setProvider,
        resetState: $4VS8G.resetState
    },
    name: 'VIRTUAL_AGENT_ROUTING',
    containedBy: (0, $csrdO.RoutingStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { contextId: contextId })=>{
                setState({
                    contextId: contextId
                });
            }
    }
});
const $904e1e19fca27bc8$export$693cdb10cec23617 = (0, $gfNVK.createStateHook)($904e1e19fca27bc8$var$store, {
    selector: (state)=>state.provider
});
const $904e1e19fca27bc8$export$f2eec64eca530862 = (0, $gfNVK.createStateHook)($904e1e19fca27bc8$var$store, {
    selector: (state)=>state.isRouting
});
const $904e1e19fca27bc8$export$bc923229a7fa61e7 = (0, $gfNVK.createActionsHook)($904e1e19fca27bc8$var$store);

});
parcelRegister("3det2", function(module, exports) {
$parcel$export(module.exports, "ASSISTANT_MESSAGE_STATUS", () => $d7ff039e0be8fadd$export$75eb63d2758dd11a);
$parcel$export(module.exports, "FeedbackType", () => $d7ff039e0be8fadd$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ChannelMessageTypes", () => $d7ff039e0be8fadd$export$2468909fd00fe251);
$parcel$export(module.exports, "ConversationProvider", () => $d7ff039e0be8fadd$export$1c69fe0757d799c5);
var $d7ff039e0be8fadd$export$75eb63d2758dd11a = /*#__PURE__*/ function(ASSISTANT_MESSAGE_STATUS) {
    ASSISTANT_MESSAGE_STATUS["IDLE"] = "idle";
    ASSISTANT_MESSAGE_STATUS["LOADING_RESPONSE"] = "loadingResponse";
    ASSISTANT_MESSAGE_STATUS["AWAITING_RESPONSE"] = "awaitingResponse";
    ASSISTANT_MESSAGE_STATUS["TYPING_RESPONSE"] = "typingResponse";
    ASSISTANT_MESSAGE_STATUS["ABORTED_RESPONSE"] = "abortedResponse";
    ASSISTANT_MESSAGE_STATUS["SYNCED_RESPONSE"] = "syncedResponse";
    return ASSISTANT_MESSAGE_STATUS;
}({});
var $d7ff039e0be8fadd$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["POSITIVE"] = "positive";
    FeedbackType["NEGATIVE"] = "negative";
    return FeedbackType;
}({});
var $d7ff039e0be8fadd$export$2468909fd00fe251 = /*#__PURE__*/ function(ChannelMessageTypes) {
    ChannelMessageTypes["CHANNEL_FAILURE"] = "CHANNEL_FAILURE";
    ChannelMessageTypes["CHANNEL_EXPIRY"] = "CHANNEL_EXPIRY";
    ChannelMessageTypes["CHANNEL_CONVERSATION_OVER"] = "CHANNEL_CONVERSATION_OVER";
    return ChannelMessageTypes;
}({});
const $d7ff039e0be8fadd$export$1c69fe0757d799c5 = {
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
    AI_ANSWERS: 'AI_ANSWERS'
};

});

parcelRegister("4VS8G", function(module, exports) {
$parcel$export(module.exports, "setProvider", () => $4f567cf701348b34$export$1572b3eade6662f9);
$parcel$export(module.exports, "resetState", () => $4f567cf701348b34$export$8e84bad0b35de9e8);

var $3det2 = parcelRequire("3det2");
const $4f567cf701348b34$export$1572b3eade6662f9 = (provider)=>({ setState: setState })=>setState({
            provider: provider
        });
const $4f567cf701348b34$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { contextId: contextId })=>{
        setState({
            contextId: contextId,
            provider: (0, $3det2.ConversationProvider).VIRTUAL_AGENT,
            isRouting: false
        });
    };

});

parcelRegister("csrdO", function(module, exports) {
$parcel$export(module.exports, "RoutingStateContainer", () => $3e4ed743d72dcc2e$export$92282a62d0a1b5d4);

var $adFyB = parcelRequire("adFyB");
const $3e4ed743d72dcc2e$export$92282a62d0a1b5d4 = (0, $adFyB.createContainer)();

});


parcelRegister("ecFUh", function(module, exports) {
$parcel$export(module.exports, "useConversation", () => $d76399f5bbe29d49$export$626f7ff9a7747889);
$parcel$export(module.exports, "useConversationId", () => $d76399f5bbe29d49$export$27499dbe4de0e477);
$parcel$export(module.exports, "useConversationActions", () => $d76399f5bbe29d49$export$325b6e88f398f098);
$parcel$export(module.exports, "useIsTesting", () => $d76399f5bbe29d49$export$6747b41fb9e7b49a);
$parcel$export(module.exports, "useFeedbackCollectorConfig", () => $d76399f5bbe29d49$export$f0e236cf8822a84c);
$parcel$export(module.exports, "useIsChannelErrorPresent", () => $d76399f5bbe29d49$export$adfa38c4df66c906);
$parcel$export(module.exports, "getMessageFeedback", () => $d76399f5bbe29d49$export$ee9551cc487e053e);
$parcel$export(module.exports, "getCsatScore", () => $d76399f5bbe29d49$export$df253d0caf8deb0d);
$parcel$export(module.exports, "getLastMessageId", () => $d76399f5bbe29d49$export$63f3452801f9da26);
$parcel$export(module.exports, "useIsLastAssistantMessageGenerated", () => $d76399f5bbe29d49$export$dbf2a467a43e692a);
$parcel$export(module.exports, "useActions", () => $d76399f5bbe29d49$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useIsLastMessageFromHelpSeeker", () => $d76399f5bbe29d49$export$c095b9ac465c114e);
$parcel$export(module.exports, "useIsFeedbackSkipped", () => $d76399f5bbe29d49$export$d82a5ee85cfb7890);
$parcel$export(module.exports, "useIsCsatSkipped", () => $d76399f5bbe29d49$export$df5c667a37af1373);

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $3det2 = parcelRequire("3det2");

var $7Efzq = parcelRequire("7Efzq");

var $cKX0X = parcelRequire("cKX0X");
const $d76399f5bbe29d49$var$store = (0, $7CE69.createStore)({
    initialState: $cKX0X.initialState,
    actions: {
        fetchChannelId: $7Efzq.fetchChannelId,
        startNewConversation: $7Efzq.startNewConversation,
        onPipelineChange: $7Efzq.onPipelineChange,
        setTesting: $7Efzq.setTesting,
        setConversationScrollBarWidth: $7Efzq.setConversationScrollBarWidth,
        recordFeedbackForConversation: $7Efzq.recordFeedbackForConversation,
        refetchConversation: $7Efzq.refetchConversation,
        addHelpseekerMessage: $7Efzq.addHelpseekerMessage,
        addHelpseekerMessageOnlyForUI: $7Efzq.addHelpseekerMessageOnlyForUI,
        addFeedbackResponseOnlyForUI: $7Efzq.addFeedbackResponseOnlyForUI,
        addRetryMessageOnlyForUI: $7Efzq.addRetryMessageOnlyForUI,
        setFeedbackCollectorConfig: $7Efzq.setFeedbackCollectorConfig,
        clearConversation: $7Efzq.clearConversation,
        abortConversation: $7Efzq.abortConversation,
        takeOverConversationFromVA: $7Efzq.takeOverConversationFromVA,
        addCsatResponseOnlyForUI: $7Efzq.addCsatResponseOnlyForUI
    },
    name: 'CONVERSE'
});
const $d76399f5bbe29d49$export$626f7ff9a7747889 = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>state.conversation
});
const $d76399f5bbe29d49$export$27499dbe4de0e477 = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>{
        var _state$conversation;
        return (_state$conversation = state.conversation) === null || _state$conversation === void 0 ? void 0 : _state$conversation.conversationId;
    }
});
const $d76399f5bbe29d49$export$325b6e88f398f098 = (0, $gfNVK.createActionsHook)($d76399f5bbe29d49$var$store);
const $d76399f5bbe29d49$export$6747b41fb9e7b49a = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>state.isTesting
});
const $d76399f5bbe29d49$export$f0e236cf8822a84c = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>state.feedbackCollectorConfig
});
const $d76399f5bbe29d49$var$findBotOrAssistantMessage = (messageId)=>(chatMessage)=>{
        return chatMessage && chatMessage.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) && chatMessage.messageMetadata.messageId === messageId;
    };
const $d76399f5bbe29d49$export$adfa38c4df66c906 = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>{
        if (!state.conversation) return false;
        const lastMessage = state.conversation.history.slice(-1)[0];
        return (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.userType) === 'channelMessage';
    }
});
const $d76399f5bbe29d49$export$ee9551cc487e053e = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation2;
        const message = (_state$conversation2 = state.conversation) === null || _state$conversation2 === void 0 ? void 0 : _state$conversation2.history.find($d76399f5bbe29d49$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.messageFeedback : undefined;
    }
});
const $d76399f5bbe29d49$export$df253d0caf8deb0d = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation3;
        const message = (_state$conversation3 = state.conversation) === null || _state$conversation3 === void 0 ? void 0 : _state$conversation3.history.find($d76399f5bbe29d49$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.csatScore : undefined;
    }
});
const $d76399f5bbe29d49$var$findHelpSeekerOrAssistantMessage = (chatMessage)=>{
    return chatMessage && (chatMessage.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) || chatMessage.userType === (0, $cKX0X.HELP_SEEKER_USER_TYPE));
};
const $d76399f5bbe29d49$export$63f3452801f9da26 = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>{
        var _state$conversation4;
        const message = (_state$conversation4 = state.conversation) === null || _state$conversation4 === void 0 ? void 0 : _state$conversation4.history.filter($d76399f5bbe29d49$var$findHelpSeekerOrAssistantMessage).at(-1);
        return message && 'messageMetadata' in message ? message.messageMetadata.messageId : undefined;
    }
});
const $d76399f5bbe29d49$export$dbf2a467a43e692a = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>{
        const { conversation: conversation, isLoading: isLoading } = state;
        const lastMessage = conversation === null || conversation === void 0 ? void 0 : conversation.history.slice(-1)[0];
        const storeAbortController = conversation === null || conversation === void 0 ? void 0 : conversation.storeAbortController;
        if (lastMessage && lastMessage.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) && storeAbortController) {
            const { messageMetadata: { status: status } } = lastMessage;
            if (!status) return false;
            return [
                (0, $3det2.ASSISTANT_MESSAGE_STATUS).IDLE,
                (0, $3det2.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
            ].indexOf(status) !== -1 && !isLoading;
        }
        return true;
    }
});
const $d76399f5bbe29d49$export$bc923229a7fa61e7 = (0, $gfNVK.createActionsHook)($d76399f5bbe29d49$var$store);
const $d76399f5bbe29d49$export$c095b9ac465c114e = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state)=>{
        var _state$conversation5, _state$conversation6;
        return(// After first message, conversation is an object but has no history
        // To stop the user from sending another message here, we are waiting for history array to be filled
        ((_state$conversation5 = state.conversation) === null || _state$conversation5 === void 0 ? void 0 : _state$conversation5.history.length) === 0 || ((_state$conversation6 = state.conversation) === null || _state$conversation6 === void 0 || (_state$conversation6 = _state$conversation6.history.slice(-1)[0]) === null || _state$conversation6 === void 0 ? void 0 : _state$conversation6.userType) === (0, $cKX0X.HELP_SEEKER_USER_TYPE));
    }
});
const $d76399f5bbe29d49$export$d82a5ee85cfb7890 = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation7;
        const message = (_state$conversation7 = state.conversation) === null || _state$conversation7 === void 0 ? void 0 : _state$conversation7.history.find($d76399f5bbe29d49$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.isFeedbackSkipped : undefined;
    }
});
const $d76399f5bbe29d49$export$df5c667a37af1373 = (0, $gfNVK.createHook)($d76399f5bbe29d49$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation8;
        const message = (_state$conversation8 = state.conversation) === null || _state$conversation8 === void 0 ? void 0 : _state$conversation8.history.find($d76399f5bbe29d49$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.isCsatSkipped : undefined;
    }
});

});
parcelRegister("7Efzq", function(module, exports) {
$parcel$export(module.exports, "fetchChannelId", () => $503468ee802684f4$export$92b5f8fb222eed7e);
$parcel$export(module.exports, "startNewConversation", () => $503468ee802684f4$export$ec10fd022bf0d0a1);
$parcel$export(module.exports, "addHelpseekerMessageOnlyForUI", () => $503468ee802684f4$export$7d26299426387884);
$parcel$export(module.exports, "onPipelineChange", () => $503468ee802684f4$export$5690758dea68962c);
$parcel$export(module.exports, "setTesting", () => $503468ee802684f4$export$c0371739272785cf);
$parcel$export(module.exports, "setConversationScrollBarWidth", () => $503468ee802684f4$export$3549374a7ffc1e0f);
$parcel$export(module.exports, "recordFeedbackForConversation", () => $503468ee802684f4$export$d775316ddbd97650);
$parcel$export(module.exports, "refetchConversation", () => $503468ee802684f4$export$f84e8215cf018fc2);
$parcel$export(module.exports, "addHelpseekerMessage", () => $503468ee802684f4$export$39e5a890dd0d70ff);
$parcel$export(module.exports, "addFeedbackResponseOnlyForUI", () => $503468ee802684f4$export$8bc7344bcdeb6569);
$parcel$export(module.exports, "addCsatResponseOnlyForUI", () => $503468ee802684f4$export$193f22ef45a60fb9);
$parcel$export(module.exports, "addRetryMessageOnlyForUI", () => $503468ee802684f4$export$2024ac9dac025c83);
$parcel$export(module.exports, "setFeedbackCollectorConfig", () => $503468ee802684f4$export$5e2723610064e2d9);
$parcel$export(module.exports, "clearConversation", () => $503468ee802684f4$export$2c9f6ca76cd8a6bc);
$parcel$export(module.exports, "abortConversation", () => $503468ee802684f4$export$882bd6a6d00830a0);
$parcel$export(module.exports, "takeOverConversationFromVA", () => $503468ee802684f4$export$9ff6f230516497d2);
/* eslint-disable @typescript-eslint/require-await */ 
var $lFpPv = parcelRequire("lFpPv");

var $bhIIN = parcelRequire("bhIIN");

var $aKjrj = parcelRequire("aKjrj");

var $jxiYc = parcelRequire("jxiYc");

var $3vcZv = parcelRequire("3vcZv");

var $2rCci = parcelRequire("2rCci");

var $3det2 = parcelRequire("3det2");

var $eCfAl = parcelRequire("eCfAl");

var $f2GYx = parcelRequire("f2GYx");

var $jqIW2 = parcelRequire("jqIW2");

var $8YlNF = parcelRequire("8YlNF");

var $kjn4P = parcelRequire("kjn4P");

var $fZHax = parcelRequire("fZHax");

var $44Hi6 = parcelRequire("44Hi6");

var $4D8MD = parcelRequire("4D8MD");

var $bSM6E = parcelRequire("bSM6E");

var $5ixKV = parcelRequire("5ixKV");

var $6ygK2 = parcelRequire("6ygK2");

var $51T7P = parcelRequire("51T7P");

var $cKX0X = parcelRequire("cKX0X");
const $503468ee802684f4$var$CHANNEL_EXPIRY_TIME = 300000; // 5mins
const $503468ee802684f4$var$ONE_DAY = 86400000; // 24 Hours
const $503468ee802684f4$var$getChannelExpiryTime = ()=>{
    return (0, $lFpPv.isAiAnswer24HourTimeoutEnabled)() ? $503468ee802684f4$var$ONE_DAY : $503468ee802684f4$var$CHANNEL_EXPIRY_TIME;
};
const $503468ee802684f4$export$92b5f8fb222eed7e = (vaConversationId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        try {
            var _getState$conversatio;
            const channelId = await (0, $eCfAl.getChannelId)();
            const history = ((_getState$conversatio = getState().conversation) === null || _getState$conversatio === void 0 ? void 0 : _getState$conversatio.history) || [];
            dispatch($503468ee802684f4$var$resetTimer(channelId));
            if (channelId) setState({
                isLoading: false,
                conversation: {
                    conversationId: channelId,
                    externalConversationId: vaConversationId,
                    history: [
                        ...history
                    ]
                }
            });
            else throw new Error('No channel id!');
        } catch (e) {
            await dispatch($503468ee802684f4$var$addChannelMessage((0, $3det2.ChannelMessageTypes).CHANNEL_EXPIRY));
        }
    };
const $503468ee802684f4$var$resetTimer = (channelId, timer = $503468ee802684f4$var$getChannelExpiryTime())=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const currentTimer = getState().activeTimer;
        const analyticsClient = (0, $5ixKV.getAnalyticsWebClient)();
        if (currentTimer) clearTimeout(currentTimer);
        const activeTimer = setTimeout(()=>{
            dispatch($503468ee802684f4$var$cleanFollowUps());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            dispatch($503468ee802684f4$var$addChannelMessage((0, $3det2.ChannelMessageTypes).CHANNEL_EXPIRY));
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhConversationScreen',
                action: 'expired',
                actionSubject: 'conversation',
                attributes: {
                    conversationId: channelId,
                    ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
                }
            });
        }, timer);
        setState({
            activeTimer: activeTimer
        });
    };
const $503468ee802684f4$export$ec10fd022bf0d0a1 = (term)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        setState({
            isLoading: true,
            conversation: {
                conversationId: null,
                history: []
            }
        });
        await dispatch($503468ee802684f4$export$92b5f8fb222eed7e());
        const conversation = getState().conversation;
        if (conversation && conversation.conversationId) {
            dispatch($503468ee802684f4$export$7d26299426387884(term));
            /**
     * Mark conversation start when the first conversation message is sent
     */ setState({
                conversationStartTime: Date.now()
            });
            dispatch($503468ee802684f4$var$fetchConversation(term));
        }
    };
const $503468ee802684f4$export$5690758dea68962c = (pipeline)=>async ({ setState: setState })=>{
        setState({
            pipeline: pipeline
        });
    };
const $503468ee802684f4$export$c0371739272785cf = (isTesting)=>async ({ setState: setState })=>{
        setState({
            isTesting: isTesting
        });
    };
const $503468ee802684f4$export$3549374a7ffc1e0f = (conversationScrollBarWidth)=>({ setState: setState })=>{
        setState({
            ui: {
                conversationScrollBarWidth: conversationScrollBarWidth
            }
        });
    };
const $503468ee802684f4$var$addChannelMessage = (type)=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            conversationId: null,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'channelMessage',
                    messageType: type
                }
            ]
        };
        setState({
            conversation: conversation,
            isLoading: false
        });
    };
const $503468ee802684f4$export$d775316ddbd97650 = (id, { feedbackLabel: feedbackLabel, feedbackType: feedbackType, detailedFeedback: detailedFeedback })=>async ({ getState: getState, setState: setState })=>{
        const analyticsClient = (0, $5ixKV.getAnalyticsWebClient)();
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        (0, $f2GYx.storeFeedback)({
            feedbackLabel: feedbackLabel,
            channelId: conversation.conversationId,
            messageId: id,
            feedback: feedbackType === (0, $3det2.FeedbackType).POSITIVE ? 'LIKE' : 'DISLIKE'
        }).catch(()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhAiMateFeedbackRequest',
                action: 'feedbackRequestFailed',
                actionSubject: 'feedback',
                actionSubjectId: conversation.conversationId || '',
                attributes: {
                    isAiMate: true,
                    ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
                }
            });
        });
        const updatedConversationHistory = conversation.history.map((message)=>{
            if (message.userType === (0, $cKX0X.ASSISTANT_USER_TYPE)) {
                const { messageId: messageId } = message.messageMetadata;
                if (messageId && messageId === id) return {
                    ...message,
                    messageMetadata: {
                        ...message.messageMetadata,
                        messageFeedback: {
                            feedbackType: feedbackType,
                            feedbackLabel: feedbackLabel,
                            detailedFeedback: detailedFeedback
                        }
                    }
                };
            }
            return message;
        });
        const updatedConversation = {
            ...conversation,
            history: updatedConversationHistory
        };
        setState({
            conversation: updatedConversation
        });
    };
const $503468ee802684f4$var$getDefaultErrorState = (conversation)=>{
    let updatedConversationHistory = conversation.history;
    const lastMessageUserType = conversation.history[conversation.history.length - 1].userType;
    if (lastMessageUserType === (0, $cKX0X.ASSISTANT_USER_TYPE)) updatedConversationHistory = updatedConversationHistory.slice(0, -1);
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            {
                userType: 'error'
            }
        ]
    };
};
const $503468ee802684f4$export$f84e8215cf018fc2 = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        var _helpSeekerMessages$m;
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) return;
        const history = conversation.history;
        const helpSeekerMessages = history.filter((chatMessage)=>chatMessage.userType === (0, $cKX0X.HELP_SEEKER_USER_TYPE));
        const term = (_helpSeekerMessages$m = helpSeekerMessages[helpSeekerMessages.length - 1].messageMetadata) === null || _helpSeekerMessages$m === void 0 ? void 0 : _helpSeekerMessages$m.originalQuery;
        if (term) dispatch($503468ee802684f4$var$fetchConversation(term));
    };
const $503468ee802684f4$var$fetchConversation = (message)=>async ({ getState: getState, setState: setState })=>{
        var _metadata, _metadata2, _metadata3, _metadata4, _metadata5, _metadata6, _metadata7;
        const { conversation: conversation } = getState();
        const analyticsClient = (0, $5ixKV.getAnalyticsWebClient)();
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        if (conversation.storeAbortController) // Silently aborting if there is another operation in progress
        return;
        try {
            const { storeAbortController: storeAbortController } = (0, $bSM6E.createStoreAbortController)();
            setState({
                isLoading: true
            });
            (0, $6ygK2.sendUIEventForAskedQuestion)(analyticsClient, conversation.conversationId, conversation.history.length, message.length, conversation.externalConversationId);
            const answerId = (0, $jqIW2.genIntId)();
            let assistantMessage = (0, $8YlNF.initialAssistantMessage)(answerId);
            let generator;
            let isAnswerPartAnalyticsFired = false;
            let isFallbackMessage = false;
            const startTime = performance.now();
            let finishTime;
            try {
                generator = await (0, $eCfAl.sendMessageStream)(message, conversation.conversationId, storeAbortController);
            } catch (e) {
                setState({
                    conversation: $503468ee802684f4$var$getDefaultErrorState(conversation)
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                analyticsClient.sendTrackEvent({
                    source: 'uhAiMateRequest',
                    action: 'streaming_fetch_failed',
                    actionSubject: 'conversation',
                    actionSubjectId: conversation.conversationId,
                    attributes: {
                        isAiMate: true,
                        ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $2rCci.initialAIAnswerExperience).failure();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $2rCci.AIAnswerExperience).failure();
                return;
            }
            if (!generator) return;
            setState({
                conversation: {
                    ...(0, $4D8MD.addAssistantMessage)(assistantMessage, conversation),
                    storeAbortController: storeAbortController
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $2rCci.initialAIAnswerExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $2rCci.AIAnswerExperience).success();
            for await (const streamMessage of generator){
                if (storeAbortController.signal.aborted) break;
                const { conversation: recentConversation } = getState();
                if (!recentConversation || !recentConversation.conversationId) return;
                const { type: type, content: content } = (0, $jxiYc.getUHUpdatedMessage)(streamMessage, assistantMessage.aiMateConversationResponse.message) ?? {
                    type: ''
                };
                let metadata;
                let updatedConversation;
                let totalSources;
                let totalRequestForms;
                let totalHelpDesks;
                switch(type){
                    case 'FOLLOW_UP_QUERIES':
                        setState({
                            conversation: (0, $4D8MD.updateFollowUpMessage)(recentConversation, content)
                        });
                        break;
                    case 'CONTENT_SEARCH':
                        assistantMessage = (0, $4D8MD.updateKeywords)(assistantMessage, content);
                        assistantMessage = (0, $4D8MD.updateAssistantMessageStatusToLoadingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $4D8MD.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANALYSING_STATE':
                        assistantMessage = (0, $4D8MD.updateSources)(assistantMessage, content);
                        setState({
                            conversation: (0, $4D8MD.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANSWER_PART':
                        assistantMessage = (0, $4D8MD.updateMessage)(assistantMessage, content);
                        assistantMessage = (0, $4D8MD.updateAssistantMessageStatusToTypingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $4D8MD.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        setState({
                            isLoading: false
                        });
                        !isAnswerPartAnalyticsFired && (0, $6ygK2.sendTrackEventForAnswerStreamingStarted)(analyticsClient, conversation.conversationId, performance.now() - startTime, conversation.externalConversationId);
                        isAnswerPartAnalyticsFired = true;
                        break;
                    case 'FINAL_RESPONSE':
                        metadata = content === null || content === void 0 ? void 0 : content.message_metadata;
                        isFallbackMessage = !!((_metadata = metadata) !== null && _metadata !== void 0 && _metadata.isFallbackMessage);
                        assistantMessage = (0, $4D8MD.updateFinalMessage)(assistantMessage, content, isFallbackMessage);
                        if (isFallbackMessage) {
                            var _assistantMessage$aiM, _assistantMessage$mes;
                            const retryMessage = $503468ee802684f4$var$getRetryMessage((_assistantMessage$aiM = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message_metadata) === null || _assistantMessage$aiM === void 0 ? void 0 : _assistantMessage$aiM.originalQuery, (_assistantMessage$mes = assistantMessage.messageMetadata) === null || _assistantMessage$mes === void 0 ? void 0 : _assistantMessage$mes.messageId, isFallbackMessage);
                            updatedConversation = (0, $4D8MD.replaceLastAssistantMessage)(retryMessage, recentConversation);
                        } else updatedConversation = (0, $4D8MD.replaceLastAssistantMessage)(assistantMessage, recentConversation);
                        setState({
                            conversation: updatedConversation
                        });
                        finishTime = performance.now();
                        totalSources = (0, $44Hi6.getTotalSources)(content);
                        totalHelpDesks = (0, $kjn4P.getTotalHelpDesks)(content);
                        totalRequestForms = (0, $fZHax.getTotalRequestForms)(content);
                        (0, $6ygK2.sendTrackEventForFetchedResponse)(analyticsClient, finishTime - startTime, (_metadata2 = metadata) === null || _metadata2 === void 0 ? void 0 : _metadata2.confidenceScore, (_metadata3 = metadata) === null || _metadata3 === void 0 ? void 0 : _metadata3.isFallbackMessage, (_metadata4 = metadata) === null || _metadata4 === void 0 ? void 0 : _metadata4.isConfluenceLicensedUser, (_metadata5 = metadata) === null || _metadata5 === void 0 ? void 0 : _metadata5.isVagueQuery, (_metadata6 = metadata) === null || _metadata6 === void 0 ? void 0 : _metadata6.searchResultCount, (_metadata7 = metadata) === null || _metadata7 === void 0 ? void 0 : _metadata7.totalSearchResultCount, recentConversation.conversationId, totalSources, totalHelpDesks, totalRequestForms, assistantMessage.messageMetadata.messageId, recentConversation.externalConversationId);
                        break;
                    case 'ERROR':
                        setState({
                            conversation: $503468ee802684f4$var$getDefaultErrorState(recentConversation)
                        });
                        (0, $6ygK2.sendTrackEventForFailure)(analyticsClient, recentConversation.conversationId, false, recentConversation.externalConversationId);
                        break;
                    default:
                        break;
                }
            }
        } finally{
            const { conversation: currentConversation } = getState();
            setState({
                conversation: currentConversation ? {
                    ...currentConversation,
                    storeAbortController: undefined
                } : null,
                isLoading: false
            });
        }
    };
const $503468ee802684f4$export$39e5a890dd0d70ff = (term)=>async ({ getState: getState, dispatch: dispatch })=>{
        var _getState$conversatio2;
        dispatch($503468ee802684f4$var$resetTimer((_getState$conversatio2 = getState().conversation) === null || _getState$conversatio2 === void 0 ? void 0 : _getState$conversatio2.conversationId));
        dispatch($503468ee802684f4$var$cleanFollowUps());
        dispatch($503468ee802684f4$export$7d26299426387884(term));
        dispatch($503468ee802684f4$var$fetchConversation(term));
    };
const $503468ee802684f4$var$cleanFollowUps = ()=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: conversation.history.filter((item)=>item.userType !== 'followUp')
        };
        setState({
            conversation: conversation
        });
    };
const $503468ee802684f4$export$7d26299426387884 = (term)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $cKX0X.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'helpseeker',
                    messageContentAdf: (0, $bhIIN.doc)((0, $aKjrj.paragraph)(term)),
                    messageMetadata: {
                        originalQuery: term
                    }
                }
            ]
        };
        setState({
            conversation: conversation
        });
    };
const $503468ee802684f4$export$8bc7344bcdeb6569 = (response, id, isResolved)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const responseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $bhIIN.doc)((0, $aKjrj.paragraph)(response))
        };
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(indexOfAssistantMessage + 1, 0, responseObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
        if (isResolved) {
            var _getState$conversatio3;
            dispatch($503468ee802684f4$var$addCsatDropdownMessageOnlyForUI(indexOfAssistantMessage, id));
            dispatch($503468ee802684f4$var$cleanFollowUps());
            dispatch($503468ee802684f4$var$resetTimer((_getState$conversatio3 = getState().conversation) === null || _getState$conversatio3 === void 0 ? void 0 : _getState$conversatio3.conversationId, $503468ee802684f4$var$ONE_DAY));
        }
    };
const $503468ee802684f4$export$193f22ef45a60fb9 = (response, id)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        conversation.history[indexOfAssistantMessage].messageMetadata.csatScore = response.id;
        const helpseekerResponseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $bhIIN.doc)((0, $aKjrj.paragraph)(response.label))
        };
        // the CSAT response will be shown after, Feedback Response: 'Yes' and CSAT Dropdown Message, so we have to hop 3 indices
        const targetIndex = indexOfAssistantMessage + 3;
        const newHistory = [
            ...conversation.history
        ];
        const closeConversationObject = {
            userType: 'channelMessage',
            messageType: (0, $3det2.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
        };
        newHistory.splice(targetIndex, 0, helpseekerResponseObject, closeConversationObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $503468ee802684f4$var$addCsatDropdownMessageOnlyForUI = (indexOfAssistantMessage, messageId)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const csatDropdownMessageObject = {
            userType: 'csatDropdown',
            messageMetadata: {
                messageId: messageId
            }
        };
        const newHistory = [
            ...conversation.history
        ];
        // the CSAT Dropdown will be shown after, Feedback Response: 'Yes', so we have to hop 2 indices
        newHistory.splice(indexOfAssistantMessage + 2, 0, csatDropdownMessageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $503468ee802684f4$var$getRetryMessage = (originalQuery, messageId, isFallbackMessage)=>({
        userType: 'retry',
        messageMetadata: {
            originalQuery: originalQuery,
            messageId: messageId,
            isFallbackMessage: isFallbackMessage
        }
    });
const $503468ee802684f4$export$2024ac9dac025c83 = (id)=>async ({ getState: getState, setState: setState })=>{
        var _assistantMessage$aiM2, _assistantMessage$aiM3;
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const relativeFeedbackResponseIndex = conversation.history.slice(indexOfAssistantMessage).findIndex((message)=>message.userType === 'feedbackResponse');
        const feedbackResponseIndex = relativeFeedbackResponseIndex === -1 ? -1 : relativeFeedbackResponseIndex + indexOfAssistantMessage;
        if (feedbackResponseIndex === -1) return;
        const assistantMessage = conversation.history[indexOfAssistantMessage];
        const messageObject = $503468ee802684f4$var$getRetryMessage(assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM2 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message_metadata) === null || _assistantMessage$aiM2 === void 0 ? void 0 : _assistantMessage$aiM2.originalQuery, id, assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM3 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message_metadata) === null || _assistantMessage$aiM3 === void 0 ? void 0 : _assistantMessage$aiM3.isFallbackMessage);
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(feedbackResponseIndex + 1, 0, messageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $503468ee802684f4$export$5e2723610064e2d9 = (isVisible, messageId)=>async ({ getState: getState, setState: setState })=>{
        const { messageId: existingMessageId } = getState().feedbackCollectorConfig;
        setState({
            feedbackCollectorConfig: {
                isVisible: isVisible,
                messageId: messageId || existingMessageId
            }
        });
    };
const $503468ee802684f4$export$2c9f6ca76cd8a6bc = ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { activeTimer: activeTimer, conversation: conversation } = getState();
        const analyticsClient = (0, $5ixKV.getAnalyticsWebClient)();
        const { conversationId: conversationId, externalConversationId: externalConversationId } = conversation || {};
        if (activeTimer) clearTimeout(activeTimer);
        if (conversationId) {
            dispatch($503468ee802684f4$export$882bd6a6d00830a0());
            (0, $6ygK2.sendUIEventForClearConversation)(analyticsClient, conversationId, externalConversationId);
        }
        setState({
            ...(0, $cKX0X.initialState)
        });
    };
const $503468ee802684f4$export$882bd6a6d00830a0 = ()=>async ({ setState: setState, getState: getState })=>{
        const { conversation: conversation } = getState();
        if (!conversation || !conversation.conversationId || !conversation.storeAbortController) return;
        const lastAssistantMessage = conversation.history.slice(-1);
        if (lastAssistantMessage !== null && lastAssistantMessage !== void 0 && lastAssistantMessage.length && lastAssistantMessage[0].userType === (0, $cKX0X.ASSISTANT_USER_TYPE)) {
            const abortedMessage = (0, $4D8MD.updateAbortedAssistantMessage)(lastAssistantMessage[0]);
            setState({
                conversation: (0, $4D8MD.replaceLastAssistantMessage)(abortedMessage, conversation),
                isLoading: false
            });
            conversation.storeAbortController.abort();
        }
    };
const $503468ee802684f4$export$9ff6f230516497d2 = (vaConversationId, history)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _history$find;
        setState({
            isLoading: true
        });
        await dispatch($503468ee802684f4$export$92b5f8fb222eed7e(vaConversationId));
        const { conversation: conversation } = getState();
        if (!conversation) throw new Error('No conversation!');
        const originalQuery = ((_history$find = history.find((message)=>message.userType === 'helpseeker')) === null || _history$find === void 0 || (_history$find = _history$find.messageMetadata) === null || _history$find === void 0 ? void 0 : _history$find.originalQuery) || '';
        setState({
            conversationStartTime: Date.now(),
            conversation: {
                ...conversation,
                history: history
            }
        });
        dispatch($503468ee802684f4$var$fetchConversation(originalQuery));
    };

});
parcelRegister("jxiYc", function(module, exports) {
$parcel$export(module.exports, "getUHUpdatedMessage", () => $774f50ae02f2da0f$export$ed355c3a875c71ab);

var $bPXZk = parcelRequire("bPXZk");

var $7tukc = parcelRequire("7tukc");

var $31VOd = parcelRequire("31VOd");
const $774f50ae02f2da0f$export$ed355c3a875c71ab = (streamMessage, currentMessage)=>{
    if ((0, $31VOd.isUHTraceContentSearch)(streamMessage)) {
        var _streamMessage$messag;
        return {
            type: 'CONTENT_SEARCH',
            content: ((_streamMessage$messag = streamMessage.message) === null || _streamMessage$messag === void 0 ? void 0 : _streamMessage$messag.formulated_query) || ''
        };
    }
    if ((0, $7tukc.isUHTraceAnalyzingState)(streamMessage)) {
        var _streamMessage$messag2;
        return {
            type: 'ANALYSING_STATE',
            content: ((_streamMessage$messag2 = streamMessage.message) === null || _streamMessage$messag2 === void 0 ? void 0 : _streamMessage$messag2.sources) || ''
        };
    }
    if ((0, $bPXZk.isStreamAnswerPart)(streamMessage)) return {
        type: 'ANSWER_PART',
        content: {
            ...currentMessage,
            content: currentMessage.content.toString() + streamMessage.message.content
        }
    };
    if ((0, $bPXZk.isStreamResponse)(streamMessage)) return {
        type: 'FINAL_RESPONSE',
        content: {
            ...streamMessage.message.message
        }
    };
    if ((0, $bPXZk.isStreamError)(streamMessage)) return {
        type: 'ERROR'
    };
    if ((0, $bPXZk.isFollowUpMessage)(streamMessage)) {
        var _streamMessage$messag3;
        return {
            type: 'FOLLOW_UP_QUERIES',
            content: ((_streamMessage$messag3 = streamMessage.message.follow_ups) === null || _streamMessage$messag3 === void 0 ? void 0 : _streamMessage$messag3.map((f)=>f.text)) ?? []
        };
    }
    return null;
};

});
parcelRegister("bPXZk", function(module, exports) {
$parcel$export(module.exports, "isSSEMessage", () => $672c2ad674ab459b$export$f78edfe5a93b58af);
$parcel$export(module.exports, "ACCEPTABLE_USE_VIOLATIONS_ERROR", () => $672c2ad674ab459b$export$c424fe9570a5f2d9);
$parcel$export(module.exports, "isHumanMessage", () => $672c2ad674ab459b$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $672c2ad674ab459b$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $672c2ad674ab459b$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $672c2ad674ab459b$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $672c2ad674ab459b$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $672c2ad674ab459b$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $672c2ad674ab459b$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamTrace", () => $672c2ad674ab459b$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isFollowUpMessage", () => $672c2ad674ab459b$export$aeae5b4fda357302);
$parcel$export(module.exports, "isChannelNotFoundError", () => $672c2ad674ab459b$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isRateLimitedError", () => $672c2ad674ab459b$export$bc96a6a479480590);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $672c2ad674ab459b$export$b454081350f4a578);
$parcel$export(module.exports, "isStreamPromptRedaction", () => $672c2ad674ab459b$export$f4111656f23d9b9b);
$parcel$export(module.exports, "isStreamPromptBlock", () => $672c2ad674ab459b$export$c43cf9ba6a2176ef);
$parcel$export(module.exports, "isStreamResponseRedaction", () => $672c2ad674ab459b$export$f16ff8eb19967a97);
$parcel$export(module.exports, "isStreamResponseBlock", () => $672c2ad674ab459b$export$55f7bd80eacbc51b);
$parcel$export(module.exports, "isStreamAttachmentBlock", () => $672c2ad674ab459b$export$a1be74470d3c1fe9);

var $4xuEI = parcelRequire("4xuEI");

var $9yZUr = parcelRequire("9yZUr");
const $672c2ad674ab459b$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $672c2ad674ab459b$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $672c2ad674ab459b$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $672c2ad674ab459b$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $672c2ad674ab459b$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $672c2ad674ab459b$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $672c2ad674ab459b$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $672c2ad674ab459b$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $672c2ad674ab459b$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $672c2ad674ab459b$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $672c2ad674ab459b$export$77c9504201bdfdea = 'PROMPT_TILE';
const $672c2ad674ab459b$export$7fe06c6ae176663 = 'third-party';
const $672c2ad674ab459b$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $672c2ad674ab459b$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $672c2ad674ab459b$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $672c2ad674ab459b$export$fb661125ffb29bd6 = (message)=>{
    return $672c2ad674ab459b$export$a69fab2afb88c2eb(message) || $672c2ad674ab459b$export$6f965deda7f0960c(message) || $672c2ad674ab459b$export$b4631726cbc1440a(message);
};
const $672c2ad674ab459b$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $672c2ad674ab459b$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $672c2ad674ab459b$export$1af37a4715539580 = (message)=>{
    var _message$message_meta;
    return Boolean((_message$message_meta = message.message_metadata) === null || _message$message_meta === void 0 ? void 0 : _message$message_meta.sharedFromMessageId);
};
const $672c2ad674ab459b$export$a6e5100ca2770191 = (message)=>message instanceof Object && $672c2ad674ab459b$export$6f965deda7f0960c(message.message);
const $672c2ad674ab459b$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $672c2ad674ab459b$export$5c1c15675df13ae5 = (message)=>{
    var _message$message;
    return $672c2ad674ab459b$export$b4631726cbc1440a(message) && ((_message$message = message.message) === null || _message$message === void 0 || (_message$message = _message$message.message) === null || _message$message === void 0 ? void 0 : _message$message.async_status) === 'IN_PROGRESS';
};
const $672c2ad674ab459b$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $672c2ad674ab459b$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $672c2ad674ab459b$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $672c2ad674ab459b$export$2d3cb9d520902824 = (message)=>{
    if (!$672c2ad674ab459b$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$672c2ad674ab459b$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$672c2ad674ab459b$var$isRecord(message.metadata) || !$672c2ad674ab459b$var$isOptionalNullableString(message.metadata.request_id) || !$672c2ad674ab459b$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $672c2ad674ab459b$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $672c2ad674ab459b$export$1e1cf807ece63df4 = (message)=>{
    var _message$message2;
    return $672c2ad674ab459b$export$d422a2733a3b5def(message) && ((_message$message2 = message.message) === null || _message$message2 === void 0 ? void 0 : _message$message2.message_template) === $672c2ad674ab459b$export$c424fe9570a5f2d9;
};
const $672c2ad674ab459b$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $672c2ad674ab459b$var$isNonEmptyString = (value)=>typeof value === 'string' && value.length > 0;
const $672c2ad674ab459b$export$a29b8eb13b54e91f = (message)=>$672c2ad674ab459b$var$isRecord(message) && message.type === 'ANSWER_UI_PART' && $672c2ad674ab459b$var$isNonEmptyString(message.part_id);
const $672c2ad674ab459b$export$eee53d3475c29169 = (message)=>{
    if (!$672c2ad674ab459b$var$isRecord(message) || message.type !== 'ANSWER_UI_CONTENT' || !$672c2ad674ab459b$var$isNonEmptyString(message.part_id)) return false;
    if (message.state === 'failed') return true;
    return message.state === 'ready' && $672c2ad674ab459b$var$isRecord(message.message) && message.message.format === 'lumina_v1' && $672c2ad674ab459b$var$isNonEmptyString(message.message.content);
};
const $672c2ad674ab459b$var$isRawEntityAnnotation = (value)=>$672c2ad674ab459b$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $672c2ad674ab459b$export$6fb760a9d35f0551 = (message)=>$672c2ad674ab459b$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $672c2ad674ab459b$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($672c2ad674ab459b$var$isRawEntityAnnotation);
const $672c2ad674ab459b$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $672c2ad674ab459b$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $672c2ad674ab459b$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $672c2ad674ab459b$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $672c2ad674ab459b$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $672c2ad674ab459b$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $672c2ad674ab459b$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $672c2ad674ab459b$export$9082a8e48d820016 = (message)=>{
    if (!$672c2ad674ab459b$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$672c2ad674ab459b$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $672c2ad674ab459b$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $672c2ad674ab459b$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $672c2ad674ab459b$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $672c2ad674ab459b$var$isNullableString(payload.action_key) && $672c2ad674ab459b$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $672c2ad674ab459b$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $672c2ad674ab459b$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $672c2ad674ab459b$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $672c2ad674ab459b$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $672c2ad674ab459b$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $672c2ad674ab459b$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $672c2ad674ab459b$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $672c2ad674ab459b$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $672c2ad674ab459b$export$5cfcb66b0fc392d6 = (message)=>typeof message === 'object' && message !== null && 'type' in message && message.type === 'CONCIERGE_AGENT_SELECTED';
const $672c2ad674ab459b$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $672c2ad674ab459b$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $672c2ad674ab459b$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $672c2ad674ab459b$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $672c2ad674ab459b$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $672c2ad674ab459b$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $672c2ad674ab459b$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $672c2ad674ab459b$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $672c2ad674ab459b$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $672c2ad674ab459b$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $672c2ad674ab459b$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $672c2ad674ab459b$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $672c2ad674ab459b$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($672c2ad674ab459b$export$7898cc38956b9052(message) || $672c2ad674ab459b$export$bb608d13a1268633(message));
const $672c2ad674ab459b$export$d95e474df0d530df = (message)=>{
    var _message$message3;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message3 = message.message) === null || _message$message3 === void 0 ? void 0 : _message$message3.message_template) === 'MEMORY_UPDATE';
};
const $672c2ad674ab459b$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($672c2ad674ab459b$export$46e0fb5e4b019a49(message)) return false;
    if ($672c2ad674ab459b$export$cde91b49af35d559(message)) return false;
    if ($672c2ad674ab459b$export$6f74311d40862a9f(message)) return false;
    if ($672c2ad674ab459b$export$b65c73c7e2d8d96f(message)) return false;
    if ($672c2ad674ab459b$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $672c2ad674ab459b$export$682514f3a8131b98 = (message)=>{
    var _message$message4;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message4 = message.message) === null || _message$message4 === void 0 ? void 0 : _message$message4.message_template) === 'THINK_DEEPER_TRIGGERED';
};
const $672c2ad674ab459b$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $672c2ad674ab459b$export$6275ff996073145e = (message)=>{
    var _data$message;
    if (!$672c2ad674ab459b$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray((_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.content);
};
const $672c2ad674ab459b$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $672c2ad674ab459b$export$b8391261162989d9 = (message)=>{
    var _message$message_meta2, _message$message_meta3;
    return $672c2ad674ab459b$export$6f965deda7f0960c(message) && ((message === null || message === void 0 || (_message$message_meta2 = message.message_metadata) === null || _message$message_meta2 === void 0 ? void 0 : _message$message_meta2.is_action_execution) ?? false) && (message === null || message === void 0 || (_message$message_meta3 = message.message_metadata) === null || _message$message_meta3 === void 0 ? void 0 : _message$message_meta3.action_execution_result) === 'SUCCESS';
};
const $672c2ad674ab459b$export$1060c4fa97e34fa7 = (payloadContext)=>{
    var _payloadContext$resol;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol = payloadContext.resolution) === null || _payloadContext$resol === void 0 ? void 0 : _payloadContext$resol.type) === 'cancel';
};
const $672c2ad674ab459b$export$6ce1ccc24e75456f = (error)=>{
    var _error$errorAttribute;
    return (0, $9yZUr.isApiError)(error) && ((_error$errorAttribute = error.errorAttributes) === null || _error$errorAttribute === void 0 ? void 0 : _error$errorAttribute.errorCode) === $672c2ad674ab459b$export$5945515082cc2cbf;
};
const $672c2ad674ab459b$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $672c2ad674ab459b$export$bc96a6a479480590 = (error)=>(0, $9yZUr.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $672c2ad674ab459b$export$f8b1b75846492611 = (error)=>(0, $9yZUr.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $4xuEI.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $672c2ad674ab459b$export$d263dc5d64f36d48 = (error)=>{
    var _error$detail;
    return error instanceof Object && (error === null || error === void 0 || (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.type) === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $672c2ad674ab459b$export$c424fe9570a5f2d9;
};
const $672c2ad674ab459b$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $672c2ad674ab459b$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $672c2ad674ab459b$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $672c2ad674ab459b$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $672c2ad674ab459b$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $672c2ad674ab459b$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $672c2ad674ab459b$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $672c2ad674ab459b$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $672c2ad674ab459b$export$4af48296a8d61cec(payloadContext) {
    var _payloadContext$resol2;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol2 = payloadContext.resolution) === null || _payloadContext$resol2 === void 0 ? void 0 : _payloadContext$resol2.type) === 'confirm';
}

});
parcelRegister("4xuEI", function(module, exports) {
$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $49e38cd94f625ffe$export$1106bf31edf2a9b8);
const $49e38cd94f625ffe$export$e8114853eca81277 = 'ai-mate';
const $49e38cd94f625ffe$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $49e38cd94f625ffe$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};

});

parcelRegister("9yZUr", function(module, exports) {
$parcel$export(module.exports, "ApiError", () => $7821a3041ef85f10$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $7821a3041ef85f10$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $7821a3041ef85f10$export$3c02d1a328d4d808);
const $7821a3041ef85f10$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $7821a3041ef85f10$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        this.data = data;
    }
}
const $7821a3041ef85f10$export$89d83cc97c52a37 = (error)=>error instanceof $7821a3041ef85f10$export$f2e832acab1bdd79;
const $7821a3041ef85f10$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $7821a3041ef85f10$var$getApiErrorAttributes = (error)=>{
    var _getRecord;
    if ($7821a3041ef85f10$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $7821a3041ef85f10$var$getRecord((_getRecord = $7821a3041ef85f10$var$getRecord(error)) === null || _getRecord === void 0 ? void 0 : _getRecord.errorAttributes);
};
const $7821a3041ef85f10$var$getStructuredErrorData = (error)=>{
    var _getRecord2;
    const errorRecord = $7821a3041ef85f10$var$getRecord(error);
    return $7821a3041ef85f10$var$getRecord(errorRecord === null || errorRecord === void 0 ? void 0 : errorRecord.data) ?? $7821a3041ef85f10$var$getRecord((_getRecord2 = $7821a3041ef85f10$var$getRecord(errorRecord === null || errorRecord === void 0 ? void 0 : errorRecord.errorAttributes)) === null || _getRecord2 === void 0 ? void 0 : _getRecord2.data);
};
const $7821a3041ef85f10$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $7821a3041ef85f10$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $7821a3041ef85f10$var$getApiErrorAttributes(error);
    if ((errorAttributes === null || errorAttributes === void 0 ? void 0 : errorAttributes.errorCode) !== $7821a3041ef85f10$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $7821a3041ef85f10$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $7821a3041ef85f10$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $7821a3041ef85f10$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $7821a3041ef85f10$export$3c02d1a328d4d808 = (error)=>{
    if ($7821a3041ef85f10$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $7821a3041ef85f10$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("7tukc", function(module, exports) {
$parcel$export(module.exports, "isUHTraceAnalyzingState", () => $ca1c3c7d6d657ffa$export$b7ca9806367cbd80);
const $ca1c3c7d6d657ffa$export$b7ca9806367cbd80 = (message)=>message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';

});

parcelRegister("31VOd", function(module, exports) {
$parcel$export(module.exports, "isUHTraceContentSearch", () => $95f8b4f84c82722f$export$a9fb9dc1a9b2c5ba);
const $95f8b4f84c82722f$export$a9fb9dc1a9b2c5ba = (message)=>message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';

});


parcelRegister("3vcZv", function(module, exports) {
$parcel$export(module.exports, "ExperienceType", () => $a4d8acbee1568062$export$7814caf20640a89e);
var $a4d8acbee1568062$export$7814caf20640a89e = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["UNIFIED_HELP"] = "unified-help";
    return ExperienceType;
}({});

});

parcelRegister("eCfAl", function(module, exports) {
$parcel$export(module.exports, "getChannelId", () => $c6beffbdd560f305$export$98f3eb54b6f833b6);
$parcel$export(module.exports, "sendMessageStream", () => $c6beffbdd560f305$export$5dd6208dff317c60);

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $3vcZv = parcelRequire("3vcZv");

var $hCnLH = parcelRequire("hCnLH");

var $5ixKV = parcelRequire("5ixKV");

var $51T7P = parcelRequire("51T7P");

var $7q8a3 = parcelRequire("7q8a3");

var $4B2Gy = parcelRequire("4B2Gy");
const $c6beffbdd560f305$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $c6beffbdd560f305$var$helpcenterSlugHeader = {
    'X-Helpcenter-Slug': (0, $hCnLH.getSlugForHelpCenter)() ?? ''
};
const $c6beffbdd560f305$var$getChannelIdPath = ()=>{
    return (0, $fuVmc.getMeta)('ajs-account-type') === 'customer' && (0, $lFpPv.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel` : `/gateway/api/assist/chat/v1/channel`;
};
const $c6beffbdd560f305$var$getMessageStreamPath = (channelId)=>{
    return (0, $fuVmc.getMeta)('ajs-account-type') === 'customer' && (0, $lFpPv.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel/${channelId}/message/stream` : `/gateway/api/assist/chat/v1/channel/${channelId}/message/stream`;
};
const $c6beffbdd560f305$export$98f3eb54b6f833b6 = async ()=>{
    const analyticsClient = (0, $5ixKV.getAnalyticsWebClient)();
    let channelId = null;
    try {
        const channelResponse = await (0, $7q8a3.fetchJson)($c6beffbdd560f305$var$getChannelIdPath(), 'POST', {
            body: JSON.stringify({}),
            headers: $c6beffbdd560f305$var$commonHeaders
        });
        channelId = channelResponse.id;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetched',
            actionSubject: 'channelId',
            actionSubjectId: channelId,
            attributes: {
                ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
            }
        });
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetch_failed',
            actionSubject: 'channelId',
            attributes: {
                ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
            }
        });
        channelId = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'portalHomeScreen',
        action: 'initiated',
        actionSubject: 'aiInteraction',
        actionSubjectId: channelId ?? '',
        attributes: {
            aiFeatureName: 'aiAnswer',
            aiInteractionID: channelId,
            aiInteractionType: 'conversationId',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        }
    });
    return channelId;
};
const $c6beffbdd560f305$export$5dd6208dff317c60 = async (content, channelId, abortController)=>{
    const body = {
        content: content,
        recipient_agent_named_id: 'unified_help_agent'
    };
    const options = {
        method: 'POST',
        headers: {
            ...$c6beffbdd560f305$var$commonHeaders,
            'content-type': 'application/json;charset=UTF-8',
            ...$c6beffbdd560f305$var$helpcenterSlugHeader,
            'X-Helpcenter-Ari': (0, $fuVmc.getHelpCenterAri)()
        },
        body: JSON.stringify(body),
        signal: abortController.signal
    };
    return (0, $4B2Gy.fetchStream)($c6beffbdd560f305$var$getMessageStreamPath(channelId), options);
};

});
parcelRegister("5ixKV", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $d7da9521822b7df1$export$e9ba7ef9458d1a4a);
//import AnalyticsClient, { envType, originType, userType, tenantType } from '@atlassiansox/analytics-web-client';
//@ts-ignore
//import Cookie from 'js-cookie';
//import { getMeta } from '@helpcenter/meta';

var $iRD29 = parcelRequire("iRD29");
const $d7da9521822b7df1$export$e9ba7ef9458d1a4a = ()=>(0, $iRD29.getAnalyticsWebClient)().getInstance();

});

parcelRegister("51T7P", function(module, exports) {
$parcel$export(module.exports, "getProductIdentifierAttributes", () => $d9971add17e60c2d$export$414440f1585883f4);

var $fuVmc = parcelRequire("fuVmc");
const $d9971add17e60c2d$export$414440f1585883f4 = (experienceId)=>({
        experienceId: experienceId,
        helpcenterId: (0, $fuVmc.getHelpCenterAri)().split('/').pop()
    });

});

parcelRegister("7q8a3", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $5430d79484f26f94$export$6d71b655afe1638d);
const $5430d79484f26f94$export$6d71b655afe1638d = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        headers: {
            ...options === null || options === void 0 ? void 0 : options.headers,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw {
        error: new Error(`Request failed: ${response.status} ${response.statusText}`),
        status: response.status
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const data = await response.json();
    return data;
};

});

parcelRegister("4B2Gy", function(module, exports) {
$parcel$export(module.exports, "fetchStream", () => $169c8d7ab9d36871$export$93163a9030575d92);

var $1cIRj = parcelRequire("1cIRj");
const $169c8d7ab9d36871$export$93163a9030575d92 = async (path, options)=>{
    const response = await fetch(path, options);
    return (0, $1cIRj.readJsonStream)(response);
};

});
parcelRegister("1cIRj", function(module, exports) {
$parcel$export(module.exports, "readJsonStream", () => $26df1013ba1e146d$export$1f24b2b263bcfa75);

var $gdUUy = parcelRequire("gdUUy");

var $lqijB = parcelRequire("lqijB");
async function* $26df1013ba1e146d$export$1f24b2b263bcfa75(response) {
    const reader = (0, $lqijB.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $gdUUy.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("lqijB", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $e8c8f12efef2905f$export$f6383c3ea1307da9);
const $e8c8f12efef2905f$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});




parcelRegister("f2GYx", function(module, exports) {
$parcel$export(module.exports, "storeFeedback", () => $eef79055ffa509c6$export$f3438d7da4ca94e9);

var $9ujE6 = parcelRequire("9ujE6");
const $eef79055ffa509c6$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $eef79055ffa509c6$export$f3438d7da4ca94e9 = async ({ channelId: channelId, messageId: messageId, feedback: feedback, feedbackLabel: feedbackLabel })=>{
    if (!messageId) return;
    await (0, $9ujE6.fetchNothing)(`/gateway/api/assist/chat/v1/channel/${channelId}/message/${messageId}/feedback`, 'PUT', {
        headers: {
            ...$eef79055ffa509c6$var$commonHeaders,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            feedback_value: feedback,
            feedback_message: feedbackLabel
        })
    });
};

});
parcelRegister("9ujE6", function(module, exports) {
$parcel$export(module.exports, "fetchNothing", () => $1e54152d6c9be47f$export$734eba776b437e7e);
const $1e54152d6c9be47f$export$734eba776b437e7e = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`Request failed: ${response.status} ${response.statusText}`);
};

});


parcelRegister("jqIW2", function(module, exports) {
$parcel$export(module.exports, "genIntId", () => $d735253de75deb54$export$99db4f5154ec67b);
const $d735253de75deb54$export$99db4f5154ec67b = ()=>Math.floor(Math.random() * 1000000);

});

parcelRegister("8YlNF", function(module, exports) {
$parcel$export(module.exports, "initialAssistantMessage", () => $d6532602a67b8b38$export$b1cea82f2a755388);

var $3det2 = parcelRequire("3det2");
const $d6532602a67b8b38$export$b1cea82f2a755388 = (answerId)=>({
        aiMateConversationResponse: {
            message: {
                id: String(answerId),
                time_created: '',
                user_ari: '',
                role: 'assistant',
                content: '',
                plugin_invocations: []
            }
        },
        userType: 'assistant',
        messageMetadata: {
            status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
            messageId: answerId.toString()
        }
    });

});

parcelRegister("kjn4P", function(module, exports) {
$parcel$export(module.exports, "getTotalHelpDesks", () => $abf1bcbc13b169f4$export$826b9b61b3b7d76d);
const $abf1bcbc13b169f4$export$826b9b61b3b7d76d = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'helpDesk')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("fZHax", function(module, exports) {
$parcel$export(module.exports, "getTotalRequestForms", () => $1621dc4cf2f6e9cb$export$859320f8ebb3caf3);
const $1621dc4cf2f6e9cb$export$859320f8ebb3caf3 = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'requestForm')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("44Hi6", function(module, exports) {
$parcel$export(module.exports, "getTotalSources", () => $85606d868f8d9360$export$75f436fca26bdba1);
const $85606d868f8d9360$export$75f436fca26bdba1 = (message)=>{
    var _message$sources;
    return (message === null || message === void 0 || (_message$sources = message.sources) === null || _message$sources === void 0 ? void 0 : _message$sources.length) ?? 0;
};

});

parcelRegister("4D8MD", function(module, exports) {
$parcel$export(module.exports, "updateKeywords", () => $bfc862327ca44b18$export$9c6f66d1d405561d);
$parcel$export(module.exports, "updateSources", () => $bfc862327ca44b18$export$6c4da287bd77d75c);
$parcel$export(module.exports, "updateMessage", () => $bfc862327ca44b18$export$829153c748a07de7);
$parcel$export(module.exports, "updateFinalMessage", () => $bfc862327ca44b18$export$95204cf9f69c856a);
$parcel$export(module.exports, "addAssistantMessage", () => $bfc862327ca44b18$export$ce06e1b90807a0c0);
$parcel$export(module.exports, "replaceLastAssistantMessage", () => $bfc862327ca44b18$export$a1def0348b9f1873);
$parcel$export(module.exports, "updateFollowUpMessage", () => $bfc862327ca44b18$export$9143429366a9249);
$parcel$export(module.exports, "updateAssistantMessageStatusToTypingResponse", () => $bfc862327ca44b18$export$e1c963c90a5d08ee);
$parcel$export(module.exports, "updateAssistantMessageStatusToLoadingResponse", () => $bfc862327ca44b18$export$c2814dbaf6592faa);
$parcel$export(module.exports, "updateAbortedAssistantMessage", () => $bfc862327ca44b18$export$5d7bc912c91053cd);

var $3det2 = parcelRequire("3det2");

var $cKX0X = parcelRequire("cKX0X");
const $bfc862327ca44b18$export$9c6f66d1d405561d = (assistantMessage, keywords = '')=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                keywords: keywords.split('|')
            }
        }
    });
const $bfc862327ca44b18$export$6c4da287bd77d75c = (assistantMessage, sources)=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                sources: sources
            }
        }
    });
const $bfc862327ca44b18$export$829153c748a07de7 = (assistantMessage, message)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        }
    });
const $bfc862327ca44b18$export$95204cf9f69c856a = (assistantMessage, message, isFallbackMessage)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        },
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            isFallbackMessage: isFallbackMessage,
            messageId: message.id.toString(),
            status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).IDLE,
            showFeedback: !isFallbackMessage
        }
    });
const $bfc862327ca44b18$export$ce06e1b90807a0c0 = (assistantMessage, conversation)=>({
        ...conversation,
        history: [
            ...conversation.history,
            assistantMessage
        ]
    });
const $bfc862327ca44b18$export$a1def0348b9f1873 = (message, conversation)=>{
    const updatedConversationHistory = conversation.history[conversation.history.length - 1].userType === (0, $cKX0X.ASSISTANT_USER_TYPE) ? conversation.history.slice(0, -1) : conversation.history;
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            message
        ]
    };
};
const $bfc862327ca44b18$export$9143429366a9249 = (conversation, queries)=>({
        ...conversation,
        history: [
            ...conversation.history,
            {
                queries: queries,
                userType: 'followUp'
            }
        ]
    });
const $bfc862327ca44b18$export$e1c963c90a5d08ee = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE
        }
    });
const $bfc862327ca44b18$export$c2814dbaf6592faa = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE
        }
    });
const $bfc862327ca44b18$export$5d7bc912c91053cd = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
        }
    });

});
parcelRegister("cKX0X", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $13eb3ac4dd9f90d7$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "ASSISTANT_USER_TYPE", () => $13eb3ac4dd9f90d7$export$93622d3dc67e9e9b);
$parcel$export(module.exports, "HELP_SEEKER_USER_TYPE", () => $13eb3ac4dd9f90d7$export$fa4d1d4ff5355f70);
const $13eb3ac4dd9f90d7$export$d4c72bab9d6cc13a = {
    isLoading: false,
    conversation: null,
    searchAll: false,
    pipeline: '',
    isTesting: false,
    feedbackCollectorConfig: {
        isVisible: false,
        messageId: undefined
    },
    activeTimer: null,
    ui: {
        conversationScrollBarWidth: '0px'
    }
};
const $13eb3ac4dd9f90d7$export$93622d3dc67e9e9b = 'assistant';
const $13eb3ac4dd9f90d7$export$fa4d1d4ff5355f70 = 'helpseeker';

});


parcelRegister("bSM6E", function(module, exports) {
$parcel$export(module.exports, "createStoreAbortController", () => $2db985c42bce00aa$export$cb6128fc3a3c8081);
const $2db985c42bce00aa$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    const abort = ()=>{
        abortController.abort();
    };
    const signal = abortController.signal;
    return {
        storeAbortController: {
            abort: abort,
            signal: signal
        }
    };
};

});

parcelRegister("6ygK2", function(module, exports) {
$parcel$export(module.exports, "sendUIEventForAskedQuestion", () => $c52af5bc22e1a2fa$export$2bf225029007d9aa);
$parcel$export(module.exports, "sendUIEventForClearConversation", () => $c52af5bc22e1a2fa$export$e33202cdfb6e8294);
$parcel$export(module.exports, "sendTrackEventForAnswerStreamingStarted", () => $c52af5bc22e1a2fa$export$1ad079e189e166f0);
$parcel$export(module.exports, "sendTrackEventForFetchedResponse", () => $c52af5bc22e1a2fa$export$b13699b81838287b);
$parcel$export(module.exports, "sendTrackEventForFailure", () => $c52af5bc22e1a2fa$export$d40db612c63a38bf);
$parcel$export(module.exports, "sendUIEventForFollowUpSelection", () => $c52af5bc22e1a2fa$export$6d1d2cd3a3ab5d10);

var $3vcZv = parcelRequire("3vcZv");

var $51T7P = parcelRequire("51T7P");
const $c52af5bc22e1a2fa$export$2bf225029007d9aa = (analyticsClient, conversationId, totalMessageCount, messageLength, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'uhConversationScreen',
        action: 'asked',
        actionSubject: 'question',
        attributes: {
            conversationId: conversationId,
            messageLength: messageLength,
            totalMessageCount: totalMessageCount,
            externalConversationId: externalConversationId,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $c52af5bc22e1a2fa$export$e33202cdfb6e8294 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'clear',
        actionSubject: 'conversation',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $c52af5bc22e1a2fa$export$1ad079e189e166f0 = (analyticsClient, conversationId, messageLatency, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'started',
        actionSubject: 'streaming',
        attributes: {
            messageLatency: messageLatency,
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $c52af5bc22e1a2fa$export$b13699b81838287b = (analyticsClient, messageLatency, confidenceScore, isFallbackMessage, isConfluenceLicensedUser, isVagueQuery, searchResultCount, totalSearchResultCount, conversationId, totalSources, totalHelpDesk, totalRequestForm, messageId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'fetched',
        actionSubject: 'conversation',
        actionSubjectId: conversationId,
        attributes: {
            externalConversationId: externalConversationId,
            messageLatency: messageLatency,
            confidenceScore: confidenceScore,
            isFallbackMessage: isFallbackMessage,
            isConfluenceLicensedUser: isConfluenceLicensedUser,
            isVagueQuery: isVagueQuery,
            searchResultCount: searchResultCount,
            totalSearchResultCount: totalSearchResultCount,
            totalSources: totalSources,
            totalHelpDesk: totalHelpDesk,
            totalRequestForm: totalRequestForm,
            messageId: messageId,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $c52af5bc22e1a2fa$export$d40db612c63a38bf = (analyticsClient, channelId, isRateLimitingError, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: isRateLimitingError ? 'rateLimited' : 'fetch_failed',
        actionSubject: 'conversation',
        actionSubjectId: channelId,
        attributes: {
            externalConversationId: externalConversationId,
            isAiMate: true,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $c52af5bc22e1a2fa$export$6d1d2cd3a3ab5d10 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'selected',
        actionSubject: 'followUpQuery',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $51T7P.getProductIdentifierAttributes)((0, $3vcZv.ExperienceType).UNIFIED_HELP)
        }
    });
};

});




parcelRegister("ct4xy", function(module, exports) {
$parcel$export(module.exports, "useIsGenerating", () => $24f8f1817a58861e$export$d04302655294f9a5);

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $ecFUh = parcelRequire("ecFUh");
const $24f8f1817a58861e$export$d04302655294f9a5 = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const [isLastAssistantMessageGenerated] = (0, $ecFUh.useIsLastAssistantMessageGenerated)();
    if (!provider || provider === (0, $3det2.ConversationProvider).VIRTUAL_AGENT) return false;
    return !isLastAssistantMessageGenerated;
};

});

parcelRegister("7MeZO", function(module, exports) {
$parcel$export(module.exports, "useIsInputEnabled", () => $1e413e45bf41d36b$export$335460cd33393c4b);

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $ecFUh = parcelRequire("ecFUh");
const $1e413e45bf41d36b$export$335460cd33393c4b = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const isRouting = (0, $5thR1.useIsRouting)();
    const [isLastMessageFromHelpSeeker] = (0, $ecFUh.useIsLastMessageFromHelpSeeker)();
    const [isLastAssistantMessageGenerated] = (0, $ecFUh.useIsLastAssistantMessageGenerated)();
    if (isRouting) return false;
    if (!provider || provider === (0, $3det2.ConversationProvider).VIRTUAL_AGENT) return true;
    return isLastAssistantMessageGenerated && !isLastMessageFromHelpSeeker;
};

});

parcelRegister("dqRJl", function(module, exports) {
$parcel$export(module.exports, "useHasMessages", () => $edb2a843c8e6deed$export$cd077d7865053739);

var $8c54L = parcelRequire("8c54L");

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $ecFUh = parcelRequire("ecFUh");
const $edb2a843c8e6deed$export$cd077d7865053739 = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const [AIAnswersConversation] = (0, $ecFUh.useConversation)();
    const VAMessages = (0, $8c54L.useMessages)();
    if (provider === (0, $3det2.ConversationProvider).VIRTUAL_AGENT) return VAMessages.length > 0;
    return !!AIAnswersConversation;
};

});

parcelRegister("9mJt2", function(module, exports) {
$parcel$export(module.exports, "useStopGenerating", () => $753b7f3a34a05e21$export$177960b8f80ddb1c);

var $5thR1 = parcelRequire("5thR1");

var $ecFUh = parcelRequire("ecFUh");
const $753b7f3a34a05e21$export$177960b8f80ddb1c = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const { abortConversation: abortConversation } = (0, $ecFUh.useActions)();
    const stopGenerating = ()=>{
        if (provider === 'AI_ANSWERS') abortConversation();
    };
    return {
        stopGenerating: stopGenerating
    };
};

});

parcelRegister("5BJMm", function(module, exports) {
$parcel$export(module.exports, "useGetMaxChars", () => $7c6a1340bc80a32e$export$6fdff492f3dfb4bb);

var $1uG25 = parcelRequire("1uG25");

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $eYhBK = parcelRequire("eYhBK");
const $7c6a1340bc80a32e$export$6fdff492f3dfb4bb = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const { getJiraFieldMaxChars: getJiraFieldMaxChars } = (0, $1uG25.useGetJiraFieldMaxChars)();
    const getMaxChars = ()=>{
        if (provider === (0, $3det2.ConversationProvider).VIRTUAL_AGENT) {
            const maxJiraFieldChars = getJiraFieldMaxChars();
            if (maxJiraFieldChars) return maxJiraFieldChars;
        }
        return 0, $eYhBK.MAX_CHARS;
    };
    return {
        getMaxChars: getMaxChars
    };
};

});
parcelRegister("1uG25", function(module, exports) {
$parcel$export(module.exports, "useGetJiraFieldMaxChars", () => $91dcc046c1b4507e$export$1c551de6ec5f7e66);

var $dkJcd = parcelRequire("dkJcd");

var $aXiin = parcelRequire("aXiin");

var $eORcq = parcelRequire("eORcq");

var $8c54L = parcelRequire("8c54L");
const $91dcc046c1b4507e$export$1c551de6ec5f7e66 = ()=>{
    const jiraField = (0, $8c54L.useFieldFromLastMessage)();
    const baseUrl = (0, $8c54L.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $aXiin.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const fieldType = jiraField && (0, $eORcq.getFieldType)(jiraField.fieldId, requestTypeFields);
    const getJiraFieldMaxChars = ()=>{
        if (fieldType === (0, $eORcq.SHORT_TEXT_FIELD_TYPE)) return 0, $dkJcd.MAX_SHORT_TEXT_FIELD_CHARS;
        if (fieldType === (0, $eORcq.PARAGRAPH_FIELD_TYPE)) return 0, $dkJcd.MAX_PARAGRAPH_FIELD_CHARS;
        return undefined;
    };
    return {
        getJiraFieldMaxChars: getJiraFieldMaxChars
    };
};

});
parcelRegister("dkJcd", function(module, exports) {
$parcel$export(module.exports, "MAX_SHORT_TEXT_FIELD_CHARS", () => $6e6f70563dcedb72$export$91e0b38c91e2cd5c);
$parcel$export(module.exports, "MAX_PARAGRAPH_FIELD_CHARS", () => $6e6f70563dcedb72$export$44efb9aa2d3aca69);
$parcel$export(module.exports, "CONVERSATION_TIME_OUT", () => $6e6f70563dcedb72$export$2efd43ac8eb281e1);
const $6e6f70563dcedb72$export$91e0b38c91e2cd5c = 250;
const $6e6f70563dcedb72$export$44efb9aa2d3aca69 = 1000;
const $6e6f70563dcedb72$export$2efd43ac8eb281e1 = 120000; // 2 minutes

});


parcelRegister("eYhBK", function(module, exports) {
$parcel$export(module.exports, "PIPELINE_LOCAL_STORAGE_KEY", () => $14d3046bdc614d14$export$1d9b669fd4b51619);
$parcel$export(module.exports, "DEFAULT_PIPELINE", () => $14d3046bdc614d14$export$dfea82974f95546a);
$parcel$export(module.exports, "LINK_CLICKED_EVENT", () => $14d3046bdc614d14$export$c3919a87590ab58a);
$parcel$export(module.exports, "MAX_CHARS", () => $14d3046bdc614d14$export$3fd15502aa7f615e);
const $14d3046bdc614d14$export$1d9b669fd4b51619 = 'pipeline';
const $14d3046bdc614d14$export$dfea82974f95546a = 'DEFAULT_PIPELINE';
const $14d3046bdc614d14$export$478ff1f86cdd0b2 = 480;
const $14d3046bdc614d14$export$90f94aac6f3ac32d = 744;
const $14d3046bdc614d14$export$460a6c74e2815558 = 1440;
const $14d3046bdc614d14$export$d7ccb212e23ab442 = 1025;
const $14d3046bdc614d14$export$ba668ebd2a2d0856 = 1200;
const $14d3046bdc614d14$export$c3919a87590ab58a = 'link clicked';
const $14d3046bdc614d14$export$3fd15502aa7f615e = 1000;

});


parcelRegister("d1TIb", function(module, exports) {
$parcel$export(module.exports, "useIsInputShown", () => $de606db87ed86146$export$ae7b9f18d03cb232);

var $5thR1 = parcelRequire("5thR1");

var $ecFUh = parcelRequire("ecFUh");
const $de606db87ed86146$export$ae7b9f18d03cb232 = ()=>{
    const provider = (0, $5thR1.useProvider)();
    const [isChannelErrorPresent] = (0, $ecFUh.useIsChannelErrorPresent)();
    if (provider === 'AI_ANSWERS') return !isChannelErrorPresent;
    return true;
};

});

parcelRegister("5LNUw", function(module, exports) {
$parcel$export(module.exports, "useClearConversation", () => $245cd81d98528095$export$6dc4e5ebda459b3);

var $8c54L = parcelRequire("8c54L");

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $ecFUh = parcelRequire("ecFUh");
const $245cd81d98528095$export$6dc4e5ebda459b3 = ()=>{
    const { clearConversation: clearAIAnswerConversation } = (0, $ecFUh.useActions)();
    const { clearConversation: clearVirtualAgentConversation } = (0, $8c54L.useActions)();
    const { setProvider: setProvider } = (0, $5thR1.useActions)();
    const clearConversation = ()=>{
        clearAIAnswerConversation();
        clearVirtualAgentConversation();
        setProvider((0, $3det2.ConversationProvider).VIRTUAL_AGENT);
    };
    return {
        clearConversation: clearConversation
    };
};

});

parcelRegister("iYtfh", function(module, exports) {
$parcel$export(module.exports, "useHandOffConversation", () => $2a53659e78cc6c8f$export$ad87f5d1da6cbafb);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $hMBe3 = parcelRequire("hMBe3");

var $iRD29 = parcelRequire("iRD29");

var $5thR1 = parcelRequire("5thR1");

var $3det2 = parcelRequire("3det2");

var $ecFUh = parcelRequire("ecFUh");
const $2a53659e78cc6c8f$export$ad87f5d1da6cbafb = ()=>{
    const { setProvider: setProvider } = (0, $5thR1.useActions)();
    const { takeOverConversationFromVA: takeOverConversationFromVA } = (0, $ecFUh.useActions)();
    const analyticsClient = (0, $iRD29.getAnalyticsWebClient)().getInstance();
    const sendHandOffAnalyticsEvent = (0, $bSJIT.useCallback)((conversationId, contextId)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/70690
        analyticsClient.sendTrackEvent({
            action: 'rejected',
            actionSubject: 'inferIntent',
            actionSubjectId: 'globalInferIntentFast',
            attributes: {
                conversationId: conversationId,
                contextId: contextId
            },
            source: (0, $jcRK7.ScreenName).CONVERSATION_PAGE
        }).catch((error)=>{
            throw new Error(`Failure to send track analytics event ${error}`);
        });
    }, [
        analyticsClient
    ]);
    const handleHandOff = (0, $bSJIT.useCallback)(async (vaMessages, conversationId, contextId)=>{
        sendHandOffAnalyticsEvent(conversationId, contextId);
        if (!vaMessages.length || vaMessages[0].message.authorType !== 'HELPSEEKER') throw Error('Cannot hand off conversation without a helpseeker message');
        const history = vaMessages.map($2a53659e78cc6c8f$var$transformVAMessageToAIAnswersMessage).filter((message)=>message !== null);
        await takeOverConversationFromVA(conversationId, history);
        setProvider((0, $3det2.ConversationProvider).AI_ANSWERS);
    }, [
        sendHandOffAnalyticsEvent,
        setProvider,
        takeOverConversationFromVA
    ]);
    return {
        handleHandOff: handleHandOff
    };
};
const $2a53659e78cc6c8f$var$extractMessageContent = (message)=>{
    let originalContent = '';
    (0, $hMBe3.traverse)(message.content, {
        text: (node)=>{
            originalContent += node.text;
        }
    });
    return originalContent;
};
const $2a53659e78cc6c8f$var$transformVAMessageToAIAnswersMessage = (message, index)=>{
    switch(message.message.authorType){
        case 'HELPSEEKER':
            return {
                userType: 'helpseeker',
                messageContentAdf: message.message.content,
                messageMetadata: {
                    ...index === 0 ? {
                        originalQuery: $2a53659e78cc6c8f$var$extractMessageContent(message.message)
                    } : {}
                }
            };
        case 'AGENT':
            return {
                userType: 'assistant',
                aiMateConversationResponse: {
                    message: {
                        content: $2a53659e78cc6c8f$var$parseMessageContent(message.message),
                        role: 'assistant',
                        id: String(index),
                        //
                        time_created: message.timeCreated,
                        user_ari: '',
                        plugin_invocations: []
                    }
                },
                messageMetadata: {
                    status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).SYNCED_RESPONSE
                }
            };
        default:
            return null;
    }
};
const $2a53659e78cc6c8f$var$parseMessageContent = (message)=>{
    if (message.contentMimetype === 'application/json+adf') return JSON.parse(message.content);
    return message.content;
};

});


parcelRegister("gNrO5", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => (parcelRequire("71mH8")).ElementKeyMap);
$parcel$export(module.exports, "isMacOs", () => (parcelRequire("71mH8")).isMacOs);
parcelRequire("71mH8");

});
parcelRegister("71mH8", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => $e656a931299ee227$export$6fa2af2018b3f7a3);
$parcel$export(module.exports, "isMacOs", () => $e656a931299ee227$export$c5e71f489eb3970b);
// oxlint-disable-next-line no-shadow
var $e656a931299ee227$export$6fa2af2018b3f7a3 = /*#__PURE__*/ function(ElementKeyMap) {
    ElementKeyMap["IMAGE"] = "HelpLayoutImageAtomicElement";
    ElementKeyMap["HEADING"] = "HelpLayoutHeadingAtomicElement";
    ElementKeyMap["PARAGRAPH"] = "HelpLayoutParagraphAtomicElement";
    ElementKeyMap["EDITOR"] = "HelpLayoutEditorElement";
    ElementKeyMap["SEARCH"] = "HelpLayoutSearchAtomicElement";
    ElementKeyMap["LINK_CARD"] = "HelpLayoutLinkCardCompositeElement";
    return ElementKeyMap;
}({});
const $e656a931299ee227$export$c5e71f489eb3970b = ()=>navigator.userAgent.includes('Mac');

});


parcelRegister("8Mb7N", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $12c133db374ab52c$export$b2ad68b9bc407b80);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4Ggth = parcelRequire("4Ggth");
const $12c133db374ab52c$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4Ggth.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});

});
parcelRegister("4Ggth", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $3b69edd7c5ec54df$export$ff983d2a2b6112ea);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jmBVe = parcelRequire("jmBVe");
const $3b69edd7c5ec54df$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $jmBVe.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("jmBVe", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $0765abe9f361691f$export$2f62ee6831462844);

var $bSJIT = parcelRequire("bSJIT");
function $0765abe9f361691f$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("5OcOs", function(module, exports) {
$parcel$export(module.exports, "withHelpCenterConversationStateContainer", () => $737c77a4403fdfa5$export$8bee59b293b5a56c);

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
var $liXIH = parcelRequire("liXIH");
var $h1bGI = parcelRequire("h1bGI");

var $3eoOe = parcelRequire("3eoOe");

var $5thR1 = parcelRequire("5thR1");

var $gG6Cp = parcelRequire("gG6Cp");
parcelRequire("8Omen");
var $5LNUw = parcelRequire("5LNUw");
var $iYtfh = parcelRequire("iYtfh");

var $8Bmw7 = parcelRequire("8Bmw7");

var $g5Mh1 = parcelRequire("g5Mh1");

var $ae5xF = parcelRequire("ae5xF");

var $8c54L = parcelRequire("8c54L");
const $737c77a4403fdfa5$export$8bee59b293b5a56c = (WrappedComponent)=>{
    const WithConversationStateContainer = (props)=>{
        const { contextId: contextId } = props;
        const [isTestConversationParam] = (0, $liXIH.useQueryParam)('isTestConversation');
        const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
        const isTestConversation = isTestConversationParam === 'true';
        const { handleHandOff: handleHandOff } = (0, $iYtfh.useHandOffConversation)();
        const conversationProvider = (0, $8Bmw7.useVirtualAgentConversationV2Provider)({
            isTestConversation: isTestConversation,
            contextId: contextId,
            cloudId: (0, $fuVmc.getCloudId)(),
            channelType: portalId ? (0, $g5Mh1.ChannelType).Portal : (0, $g5Mh1.ChannelType).HelpCenter
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ae5xF.ConversationStateContainer), {
            conversationProvider: conversationProvider,
            contextId: contextId,
            handleHandOff: handleHandOff,
            isTestConversation: isTestConversation,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($737c77a4403fdfa5$var$GlobalConversationStateManager, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
    };
    return (0, $gG6Cp.withRoutingStateContainer)(WithConversationStateContainer);
};
/*
 * With react-sweet-state, we can not persistence the state of the store when there is no consumer, in this case, we have to
 * use a global state to preserve the state of the store when the consumer is unmounted, and use this component to reset
 * the state of the store when the user navigates away from the conversation page.
 */ const $737c77a4403fdfa5$var$GlobalConversationStateManager = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    const { resetState: resetState } = (0, $5thR1.useActions)();
    const { clearConversation: clearConversation } = (0, $5LNUw.useClearConversation)();
    const { resetState: resetVAState } = (0, $8c54L.useActions)();
    (0, $3eoOe.useIsoMorphicLayoutEffect)(()=>{
        if (routerState.location.pathname !== '/conversation') {
            clearConversation();
            resetState();
            resetVAState();
        }
    }, [
        routerState.location.pathname,
        resetState,
        resetVAState,
        clearConversation
    ]);
    return null;
};

});
parcelRegister("gG6Cp", function(module, exports) {
$parcel$export(module.exports, "withRoutingStateContainer", () => $33cbeb52a3216fd4$export$fcbcda437b73d924);

var $bSJIT = parcelRequire("bSJIT");

var $csrdO = parcelRequire("csrdO");
const $33cbeb52a3216fd4$export$fcbcda437b73d924 = (WrappedComponent)=>{
    const WithRoutingStateContainer = (props)=>{
        const { contextId: contextId } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $csrdO.RoutingStateContainer), {
            contextId: contextId,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
    };
    return WithRoutingStateContainer;
};

});

parcelRegister("8Bmw7", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentConversationV2Provider", () => $00b422709145a35e$export$2e4d3c305d19e2ad);

var $bSJIT = parcelRequire("bSJIT");

var $51XYw = parcelRequire("51XYw");

var $g5Mh1 = parcelRequire("g5Mh1");
const $00b422709145a35e$export$2e4d3c305d19e2ad = ({ contextId: contextId, cloudId: cloudId, isTestConversation: isTestConversation, channelType: channelType, baseUrl: baseUrl = '' })=>{
    const startConversation = (0, $bSJIT.useCallback)(async (abortSignal, message)=>{
        try {
            const requestMessage = message ? {
                message: {
                    content: JSON.stringify(message.content)
                }
            } : null;
            const response = await (0, $51XYw.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    channelType: channelType,
                    contextId: contextId,
                    createdAt: new Date().toISOString(),
                    isTestConversation: isTestConversation === true,
                    ...requestMessage
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return undefined;
            throw error;
        }
    }, [
        baseUrl,
        cloudId,
        isTestConversation,
        channelType,
        contextId
    ]);
    const sendMessage = (0, $bSJIT.useCallback)(async (message, abortSignal)=>{
        try {
            const response = await (0, $51XYw.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation/message`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    externalSource: channelType === (0, $g5Mh1.ChannelType).HelpCenter ? (0, $g5Mh1.ExternalSource).Orchestrator : (0, $g5Mh1.ExternalSource).Portal,
                    message: {
                        content: JSON.stringify(message.message.content),
                        optionId: message.message.optionId,
                        jiraField: message.message.jiraField
                    },
                    timeCreated: message.timeCreated,
                    conversationChannelId: message.conversationChannelId
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return [];
            throw error;
        }
    }, [
        baseUrl,
        channelType,
        cloudId
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            startConversation: startConversation,
            sendMessage: sendMessage
        }), [
        sendMessage,
        startConversation
    ]);
};

});
parcelRegister("g5Mh1", function(module, exports) {
$parcel$export(module.exports, "ChannelType", () => $2e3e749b37ec5270$export$36655de2868043ae);
$parcel$export(module.exports, "ExternalSource", () => $2e3e749b37ec5270$export$ffc19e40a21f08eb);
const $2e3e749b37ec5270$export$36655de2868043ae = {
    Portal: 'JSM_PORTAL',
    HelpCenter: 'JSM_HELP_CENTER',
    Widget: 'JSM_WIDGET'
};
const $2e3e749b37ec5270$export$ffc19e40a21f08eb = {
    Portal: 'JSM_PORTAL',
    Orchestrator: 'JSM_ORCHESTRATOR'
};

});



parcelRegister("dXo4Q", function(module, exports) {
$parcel$export(module.exports, "initialIntentMessageHCExperience", () => $fbac7f8d420d8dca$export$f0696c364409ed69);
$parcel$export(module.exports, "initialAIMessageHCExperience", () => $fbac7f8d420d8dca$export$25016be9b5cc2f74);
$parcel$export(module.exports, "omnichannelGreetingMessageExperience", () => $fbac7f8d420d8dca$export$c63387a0d6893aba);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $fbac7f8d420d8dca$export$f0696c364409ed69 = new (0, $1we90.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message', {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $fbac7f8d420d8dca$export$25016be9b5cc2f74 = new (0, $1we90.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message.ai', {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $fbac7f8d420d8dca$export$c63387a0d6893aba = new (0, $1we90.UFOExperience)('service-management.help-center.omnichannel.greeting-message', {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("fBxvm", function(module, exports) {
$parcel$export(module.exports, "useCreateConversationWithMessage", () => $242b0b0831b6dba3$export$d1fc804b2f86fc4);

var $ew7d5 = parcelRequire("ew7d5");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");

var $4270B = parcelRequire("4270B");

var $bhIIN = parcelRequire("bhIIN");

var $aKjrj = parcelRequire("aKjrj");

var $dXo4Q = parcelRequire("dXo4Q");

var $4ND5I = parcelRequire("4ND5I");

var $3W5ib = parcelRequire("3W5ib");

var $7q3M9 = parcelRequire("7q3M9");

var $6IVSk = parcelRequire("6IVSk");
const $242b0b0831b6dba3$export$d1fc804b2f86fc4 = ()=>{
    const [commitMutation, isLoading] = (0, $a2qIF.useMutation)((0, $ew7d5.default));
    const environment = (0, $a2qIF.useRelayEnvironment)();
    const handleMutationError = (0, $bSJIT.useCallback)(({ message: message, nodeId: nodeId, connectionId: connectionId, subscriptionId: subscriptionId })=>{
        (0, $3W5ib.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: false
        });
        if (!(0, $lFpPv.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $7q3M9.deleteNodeFromConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: nodeId
        });
        const metadata = {
            connectionId: connectionId,
            subscriptionId: subscriptionId
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6IVSk.createConversationWithMessageExperience).failure({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $dXo4Q.initialIntentMessageHCExperience).abort({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $dXo4Q.initialAIMessageHCExperience).abort({
            metadata: metadata
        });
        (0, $4ND5I.addMessageToConnection)({
            message: message,
            environment: environment,
            connectionId: connectionId,
            authorType: 'CombinedAPIError'
        });
    }, [
        environment
    ]);
    const createConversationWithMessage = (0, $bSJIT.useCallback)(({ workspaceAri: workspaceAri, conversationContextAri: conversationContextAri, connectionId: connectionId, onError: onError, message: message, subscriptionId: subscriptionId, isTestConversation: isTestConversation = false })=>{
        const nodeId = (0, $4270B.generateUniqueClientID)();
        const content = JSON.stringify((0, $bhIIN.doc)((0, $aKjrj.paragraph)(message)));
        (0, $7q3M9.addOptimisticResponseToConnection)({
            environment: environment,
            nodeId: nodeId,
            content: content,
            connectionId: connectionId,
            message: message
        });
        (0, $3W5ib.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: true
        });
        (0, $7q3M9.updateMessageStatusToHelpseeker)({
            environment: environment
        });
        (0, $7q3M9.resetTimer)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6IVSk.createConversationWithMessageExperience).start();
        if ((0, $lFpPv.isOmnichannelGreetingAPIEnabled)()) (0, $7q3M9.addGreetingMessageToConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: (0, $4270B.generateUniqueClientID)()
        });
        return commitMutation({
            onCompleted: (response)=>{
                var _response$jsmChat, _response$jsmChat2, _response$jsmChat3, _responseData$convers, _responseData$convers3;
                if (!(response !== null && response !== void 0 && (_response$jsmChat = response.jsmChat) !== null && _response$jsmChat !== void 0 && (_response$jsmChat = _response$jsmChat.initializeAndSendMessage) !== null && _response$jsmChat !== void 0 && _response$jsmChat.success) || !(response !== null && response !== void 0 && (_response$jsmChat2 = response.jsmChat) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessage) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessageResponse) !== null && _response$jsmChat2 !== void 0 && _response$jsmChat2.conversationId)) {
                    handleMutationError({
                        nodeId: nodeId,
                        message: message,
                        connectionId: connectionId,
                        subscriptionId: subscriptionId
                    });
                    return;
                }
                const responseData = (_response$jsmChat3 = response.jsmChat) === null || _response$jsmChat3 === void 0 || (_response$jsmChat3 = _response$jsmChat3.initializeAndSendMessage) === null || _response$jsmChat3 === void 0 ? void 0 : _response$jsmChat3.initializeAndSendMessageResponse;
                (0, $3W5ib.updateOmniChannelConversationMeta)({
                    environment: environment,
                    workspaceAri: workspaceAri,
                    conversationContextAri: conversationContextAri,
                    conversationId: responseData === null || responseData === void 0 ? void 0 : responseData.conversationId
                });
                (0, $7q3M9.clearTimer)(environment);
                if (responseData.conversationId && (_responseData$convers = responseData.conversation) !== null && _responseData$convers !== void 0 && (_responseData$convers = _responseData$convers.node) !== null && _responseData$convers !== void 0 && _responseData$convers.id) {
                    var _responseData$convers2;
                    (0, $7q3M9.updateRelayRecordId)({
                        environment: environment,
                        nodeId: nodeId,
                        newId: (_responseData$convers2 = responseData.conversation) === null || _responseData$convers2 === void 0 || (_responseData$convers2 = _responseData$convers2.node) === null || _responseData$convers2 === void 0 ? void 0 : _responseData$convers2.id
                    });
                }
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $6IVSk.createConversationWithMessageExperience).success({
                    metadata: {
                        subscriptionId: subscriptionId,
                        conversationId: (_responseData$convers3 = responseData.conversation) === null || _responseData$convers3 === void 0 || (_responseData$convers3 = _responseData$convers3.node) === null || _responseData$convers3 === void 0 ? void 0 : _responseData$convers3.id
                    }
                });
            },
            onError: (error)=>{
                handleMutationError({
                    nodeId: nodeId,
                    message: message,
                    connectionId: connectionId,
                    subscriptionId: subscriptionId
                });
                onError === null || onError === void 0 || onError(error);
            },
            variables: {
                workspaceAri: workspaceAri,
                conversationContextAri: conversationContextAri,
                subscriptionId: subscriptionId,
                isTestChannel: isTestConversation,
                message: content
            }
        });
    }, [
        commitMutation,
        environment,
        handleMutationError
    ]);
    return {
        isLoading: isLoading,
        createConversationWithMessage: createConversationWithMessage
    };
};

});
parcelRegister("ew7d5", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbfb2e049d46c9a0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14f2364d6978501de330e59cb80b7f3b>>
 * @relayHash 6466481040e3141b45532075b56408d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694
const $cbfb2e049d46c9a0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "conversationContextAri"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isTestChannel"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subscriptionId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "channelExperienceId",
                    "value": "HELPCENTER"
                },
                {
                    "kind": "Variable",
                    "name": "conversationContextAri",
                    "variableName": "conversationContextAri"
                },
                {
                    "kind": "Variable",
                    "name": "isTestChannel",
                    "variableName": "isTestChannel"
                },
                {
                    "kind": "Variable",
                    "name": "message",
                    "variableName": "message"
                },
                {
                    "kind": "Variable",
                    "name": "subscriptionId",
                    "variableName": "subscriptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "concreteType": "JsmChatInitializeAndSendMessageResponse",
        "kind": "LinkedField",
        "name": "initializeAndSendMessageResponse",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "conversationId"
            },
            {
                "concreteType": "JsmChatMessageEdge",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsmChatCreateWebConversationMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "content"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "authorType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "contentType"
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694",
            "metadata": {},
            "name": "createConversationWithMessageMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cbfb2e049d46c9a0$var$node.hash = "b29d0beea262991f003cc1fee9761127";
var $cbfb2e049d46c9a0$export$2e2bcd8739ae039 = $cbfb2e049d46c9a0$var$node;

});

parcelRegister("4ND5I", function(module, exports) {
$parcel$export(module.exports, "addMessageToConnection", () => $99d461c13e8ada45$export$8dbc74cf18f1a65e);
$parcel$export(module.exports, "addNodeToConnection", () => $99d461c13e8ada45$export$7163757da5dc49f0);
$parcel$export(module.exports, "addNodeToCurrentConnection", () => $99d461c13e8ada45$export$d88c7883f045ee5);

var $4270B = parcelRequire("4270B");

var $eL3zl = parcelRequire("eL3zl");
const $99d461c13e8ada45$export$8dbc74cf18f1a65e = ({ environment: environment, connectionId: connectionId, message: message, authorType: authorType })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const nodeId = `client:jsmChat:conversation:${(0, $eL3zl.v4)()}:customMessage:node`;
        const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
        node.setValue(nodeId, 'id');
        node.setValue(authorType, 'authorType');
        if (message) node.setValue(message, 'content');
        node.setValue('ADF', 'contentType');
        node.setValue(null, 'appendices');
        const newEdge = (0, $4270B.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
        (0, $4270B.ConnectionHandler).insertEdgeAfter(connection, newEdge);
    });
};
const $99d461c13e8ada45$export$7163757da5dc49f0 = ({ store: store, recordId: recordId, connectionId: connectionId, edgeName: edgeName })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $4270B.ConnectionHandler).createEdge(store, connection, node, edgeName);
    (0, $4270B.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};
const $99d461c13e8ada45$export$d88c7883f045ee5 = ({ store: store, connectionId: connectionId, recordId: recordId })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $4270B.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
    (0, $4270B.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};

});

parcelRegister("3W5ib", function(module, exports) {
$parcel$export(module.exports, "updateOmniChannelConversationMeta", () => $54bf66fa028d1733$export$8c33322c5b64f409);
$parcel$export(module.exports, "updateOmniChannelConversationMetaPromise", () => $54bf66fa028d1733$export$b90325dd8c9d560b);

var $4270B = parcelRequire("4270B");
const $54bf66fa028d1733$export$8c33322c5b64f409 = ({ environment: environment, ...remainingParams })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        Object.keys(remainingParams).forEach((key)=>{
            jsmChatQuery.setValue(remainingParams[key], key);
        });
    });
};
const $54bf66fa028d1733$export$b90325dd8c9d560b = ({ environment: environment, ...remainingParams })=>{
    return new Promise((resolve)=>{
        (0, $4270B.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            Object.keys(remainingParams).forEach((key)=>{
                jsmChatQuery.setValue(remainingParams[key], key);
            });
            resolve(undefined);
        });
    });
};

});

parcelRegister("7q3M9", function(module, exports) {
$parcel$export(module.exports, "cleanFollowups", () => $71f2be1b7b25c1c2$export$8ce7049bbf52d43c);
$parcel$export(module.exports, "createFollowupMessageNode", () => $71f2be1b7b25c1c2$export$2e2870a1f1e8fe34);
$parcel$export(module.exports, "generateAIResponseNodeId", () => $71f2be1b7b25c1c2$export$de38df1b227321b8);
$parcel$export(module.exports, "addOptimisticResponseToConnection", () => $71f2be1b7b25c1c2$export$fbc4600ca9d78672);
$parcel$export(module.exports, "deleteNodeFromConnection", () => $71f2be1b7b25c1c2$export$7da93f9af6d9769b);
$parcel$export(module.exports, "updateRelayRecordId", () => $71f2be1b7b25c1c2$export$1424edefd4c57a66);
$parcel$export(module.exports, "addInteractionMessageToConnection", () => $71f2be1b7b25c1c2$export$8c802e3a762f0d7b);
$parcel$export(module.exports, "convertInteractionMessageToErrorMessage", () => $71f2be1b7b25c1c2$export$e868b53e9633f590);
$parcel$export(module.exports, "resetTimer", () => $71f2be1b7b25c1c2$export$148d61ea341bbff7);
$parcel$export(module.exports, "clearTimer", () => $71f2be1b7b25c1c2$export$4ffebd63913d6ea0);
$parcel$export(module.exports, "updateLastAIConversationAbortStatus", () => $71f2be1b7b25c1c2$export$3c299bb7936c424a);
$parcel$export(module.exports, "updateMessageStatusToHelpseeker", () => $71f2be1b7b25c1c2$export$c179851fb8c72922);
$parcel$export(module.exports, "getInteractionMetaFromNode", () => $71f2be1b7b25c1c2$export$9a8b1bfde220a901);
$parcel$export(module.exports, "getLastHelpSeekerMessage", () => $71f2be1b7b25c1c2$export$7d3bdcb2e57adde1);
$parcel$export(module.exports, "setDraftMessage", () => $71f2be1b7b25c1c2$export$ae6e25e430bcd18b);
$parcel$export(module.exports, "handleActionParamFromSubscription", () => $71f2be1b7b25c1c2$export$55d3e467a155fb59);
$parcel$export(module.exports, "fetchOmnichannelMeta", () => $71f2be1b7b25c1c2$export$b0fec83cc7daf9d0);
$parcel$export(module.exports, "getConnectionIdFromStore", () => $71f2be1b7b25c1c2$export$dd1db642ae57c18e);
$parcel$export(module.exports, "addGreetingMessageToConnection", () => $71f2be1b7b25c1c2$export$18db76d681ccfece);

var $4270B = parcelRequire("4270B");

var $3det2 = parcelRequire("3det2");

var $4D7nb = parcelRequire("4D7nb");

var $dXo4Q = parcelRequire("dXo4Q");

var $2NRGh = parcelRequire("2NRGh");

var $dT1M7 = parcelRequire("dT1M7");

var $4ND5I = parcelRequire("4ND5I");
const $71f2be1b7b25c1c2$export$8ce7049bbf52d43c = ({ environment: environment, connectionId: connectionId })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Followup_Message') (0, $4270B.ConnectionHandler).deleteNode(connection, node.getDataID());
        });
    });
};
const $71f2be1b7b25c1c2$export$2e2870a1f1e8fe34 = (content, store)=>{
    const nodeId = (0, $4270B.generateUniqueClientID)();
    const followupNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    followupNode.setValue(nodeId, 'id');
    followupNode.setValue('Followup_Message', 'authorType');
    followupNode.setValue(JSON.stringify(content), 'content');
    return nodeId;
};
const $71f2be1b7b25c1c2$export$de38df1b227321b8 = (id)=>{
    return `client::jsmChat::aiResponse::${id}`;
};
const $71f2be1b7b25c1c2$export$50d7b649a01ab7a5 = ({ content: content, store: store, nodeId: nodeId, message: message })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue('Reporter', 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    node.setValue(message, 'message');
    return node;
};
const $71f2be1b7b25c1c2$export$fbc4600ca9d78672 = ({ environment: environment, connectionId: connectionId, content: content, nodeId: nodeId, message: message })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        $71f2be1b7b25c1c2$export$50d7b649a01ab7a5({
            content: content,
            store: store,
            nodeId: nodeId,
            message: message
        });
        (0, $4ND5I.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $71f2be1b7b25c1c2$export$7da93f9af6d9769b = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('id');
            if (authorType === nodeId) {
                (0, $4270B.ConnectionHandler).deleteNode(connection, node.getDataID());
                store.delete(node.getDataID());
            }
        });
    });
};
const $71f2be1b7b25c1c2$export$1424edefd4c57a66 = ({ environment: environment, nodeId: nodeId, newId: newId })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) node.setValue(newId, 'id');
    });
};
const $71f2be1b7b25c1c2$export$8c802e3a762f0d7b = ({ environment: environment, message: message, nodeId: nodeId, connectionId: connectionId, interactionMeta: interactionMeta })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const node = $71f2be1b7b25c1c2$export$50d7b649a01ab7a5({
            store: store,
            nodeId: nodeId,
            message: interactionMeta.message,
            content: message
        });
        node.setValue('InteractionMessage', 'authorType');
        node.setValue(JSON.stringify(interactionMeta), 'interactionFieldMeta');
        (0, $4ND5I.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $71f2be1b7b25c1c2$export$e868b53e9633f590 = ({ nodeId: nodeId, environment: environment, message: message })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) {
            node.setValue('InteractionError', 'authorType');
            node.setValue(message, 'content');
        }
    });
};
const $71f2be1b7b25c1c2$export$148d61ea341bbff7 = ({ environment: environment, expiry: expiry = (0, $4D7nb.CHANNEL_EXPIRY_TIME_24HRS), channelMessage: channelMessage = (0, $3det2.ChannelMessageTypes).CHANNEL_EXPIRY })=>{
    $71f2be1b7b25c1c2$export$4ffebd63913d6ea0(environment);
    const timer = setTimeout(()=>{
        (0, $4270B.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) return;
            const channelMessageNode = $71f2be1b7b25c1c2$export$3c157ef8b8581f8d(store, channelMessage);
            (0, $4ND5I.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: channelMessageNode.getDataID(),
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isConversationExpired');
            const connection = store.get(connectionId);
            if (!connection) return;
            const edges = connection.getLinkedRecords('edges');
            if (!edges) return;
            edges.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                if (!node) return;
                const authorType = node.getValue('authorType');
                if (authorType === 'Followup_Message') (0, $4270B.ConnectionHandler).deleteNode(connection, node.getDataID());
            });
        });
    }, expiry);
    $71f2be1b7b25c1c2$export$6467bd9f4ef23cb9(environment, timer);
};
const $71f2be1b7b25c1c2$export$6467bd9f4ef23cb9 = (environment, timer)=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(timer, 'timer');
    });
};
const $71f2be1b7b25c1c2$export$4ffebd63913d6ea0 = (environment)=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const timerId = jsmChatQuery.getValue('timer') ?? 0;
        clearTimeout(timerId);
    });
};
const $71f2be1b7b25c1c2$export$3c157ef8b8581f8d = (store, type)=>{
    const nodeId = (0, $4270B.generateUniqueClientID)();
    const channelMessageNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    channelMessageNode.setValue(nodeId, 'id');
    channelMessageNode.setValue('ChannelMessage', 'authorType');
    channelMessageNode.setValue(type, 'content');
    return channelMessageNode;
};
const $71f2be1b7b25c1c2$export$3c299bb7936c424a = ({ environment: environment, status: status })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        if (!connectionId) return;
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        for (const edge of edges.reverse()){
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Assistant_Message') {
                const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
                assistantMessageNode.setValue(status, 'isAborted');
                return;
            }
        }
    });
};
const $71f2be1b7b25c1c2$export$c179851fb8c72922 = ({ environment: environment })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue((0, $2NRGh.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
    });
};
const $71f2be1b7b25c1c2$export$4941c3f3a49f3f68 = ({ environment: environment, nodeId: nodeId, action: action })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (!node) return;
        node.setValue(action, 'action');
    });
};
const $71f2be1b7b25c1c2$export$9a8b1bfde220a901 = ({ environment: environment, nodeId: nodeId })=>{
    return new Promise((resolve, reject)=>{
        (0, $4270B.commitLocalUpdate)(environment, (store)=>{
            const node = store.get(nodeId);
            if (!node) {
                reject(new Error('No Node found'));
                return;
            }
            const interactionMeta = node === null || node === void 0 ? void 0 : node.getValue('interactionFieldMeta');
            if (!interactionMeta) {
                reject(new Error('No InteractionMeta found'));
                return;
            }
            resolve((0, $dT1M7.parseJson)(interactionMeta));
        });
    });
};
const $71f2be1b7b25c1c2$export$7d3bdcb2e57adde1 = ({ environment: environment })=>{
    return new Promise((resolve, reject)=>{
        (0, $4270B.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) {
                reject(new Error('No ConnectionID Found'));
                return;
            }
            const connection = store.get(connectionId);
            if (!connection) {
                reject(new Error('No Connection Found'));
                return;
            }
            const edges = connection.getLinkedRecords('edges');
            if (!edges) {
                reject(new Error('No Messages Found'));
                return;
            }
            for (const edge of edges.reverse()){
                const node = edge.getLinkedRecord('node');
                const authorType = node === null || node === void 0 ? void 0 : node.getValue('authorType');
                if (authorType === 'Reporter') {
                    resolve(node === null || node === void 0 ? void 0 : node.getValue('message'));
                    return;
                }
            }
        });
    });
};
const $71f2be1b7b25c1c2$export$ae6e25e430bcd18b = ({ environment: environment, message: message })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(message, 'draftMessage');
    });
};
const $71f2be1b7b25c1c2$export$55d3e467a155fb59 = ({ action: action, environment: environment, nodeId: nodeId, connectionId: connectionId })=>{
    // oxlint-disable-next-line default-case
    switch(action){
        case 'REDIRECT_TO_SEARCH':
            $71f2be1b7b25c1c2$export$4941c3f3a49f3f68({
                environment: environment,
                nodeId: nodeId,
                action: action
            });
            break;
        case 'CLOSE_CONVERSATION':
            $71f2be1b7b25c1c2$export$148d61ea341bbff7({
                environment: environment,
                expiry: 0,
                channelMessage: (0, $3det2.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
            });
            break;
        case 'DISABLE_INPUT':
            if (connectionId) {
                $71f2be1b7b25c1c2$export$8ce7049bbf52d43c({
                    environment: environment,
                    connectionId: connectionId
                });
                $71f2be1b7b25c1c2$export$ede71f104937b4ea(environment, true);
            }
            break;
    }
};
const $71f2be1b7b25c1c2$export$ede71f104937b4ea = (environment, status)=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(status, 'disableInput');
    });
};
const $71f2be1b7b25c1c2$export$b0fec83cc7daf9d0 = (environment)=>{
    return new Promise((resolve, reject)=>{
        (0, $4270B.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            if (!root) reject(new Error('No Root Found'));
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const conversationId = jsmChatQuery.getValue('conversationId');
            const connectionId = jsmChatQuery.getValue('connectionId');
            const conversationContextAri = jsmChatQuery.getValue('conversationContextAri');
            const hasMessage = jsmChatQuery.getValue('hasMessage');
            const isReplyPending = jsmChatQuery.getValue('isReplyPending');
            const aiAnswerStatus = jsmChatQuery.getValue('aiAnswerStatus');
            const draftMessage = jsmChatQuery.getValue('draftMessage');
            const isConversationExpired = jsmChatQuery.getValue('isConversationExpired');
            const isConversationClosed = jsmChatQuery.getValue('isConversationClosed');
            const disableInput = jsmChatQuery.getValue('disableInput');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            const greetingMessage = jsmChatQuery.getValue('greetingMessage');
            const subscriptionTriggered = jsmChatQuery.getValue('subscriptionTriggered');
            subscriptionTriggered;
            resolve({
                conversationId: conversationId,
                connectionId: connectionId,
                conversationContextAri: conversationContextAri,
                hasMessage: hasMessage,
                isReplyPending: isReplyPending,
                aiAnswerStatus: aiAnswerStatus,
                draftMessage: draftMessage,
                isConversationExpired: isConversationExpired,
                isConversationClosed: isConversationClosed,
                disableInput: disableInput,
                subscriptionId: subscriptionId,
                greetingMessage: greetingMessage,
                subscriptionTriggered: subscriptionTriggered
            });
        });
    });
};
const $71f2be1b7b25c1c2$export$dd1db642ae57c18e = (store)=>{
    const root = store.getRoot();
    const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
    return jsmChatQuery.getValue('connectionId');
};
const $71f2be1b7b25c1c2$export$87805a37c19b2fb7 = ({ content: content, store: store, nodeId: nodeId, authorType: authorType })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue(authorType, 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    return node;
};
const $71f2be1b7b25c1c2$export$18db76d681ccfece = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $4270B.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const content = jsmChatQuery.getValue('greetingMessage') ?? '';
        const isGreetingMessageAdded = jsmChatQuery.getValue('isGreetingMessageAdded') ?? false;
        if (!isGreetingMessageAdded) {
            const authorType = content !== '' ? 'VirtualAgent' : 'GreetingMessage';
            $71f2be1b7b25c1c2$export$87805a37c19b2fb7({
                content: content,
                store: store,
                nodeId: nodeId,
                authorType: authorType
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $dXo4Q.omnichannelGreetingMessageExperience).success({
                metadata: {
                    connectionId: connectionId,
                    conversationId: jsmChatQuery.getValue('conversationId') ?? ''
                }
            });
            (0, $4ND5I.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: nodeId,
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isGreetingMessageAdded');
        }
    });
};

});
parcelRegister("4D7nb", function(module, exports) {
$parcel$export(module.exports, "MAX_CHARS", () => $08c3ead382e63eb9$export$3fd15502aa7f615e);
$parcel$export(module.exports, "CHANNEL_EXPIRY_TIME_24HRS", () => $08c3ead382e63eb9$export$76a18595b547627f);
const $08c3ead382e63eb9$export$3fd15502aa7f615e = 1000; // Used in Input component
const $08c3ead382e63eb9$export$10482ada0e471d1d = 300000; // 5mins
const $08c3ead382e63eb9$export$76a18595b547627f = 86400000; // 24 Hrs

});

parcelRegister("2NRGh", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerMessageStatus", () => $ca5152ac37b81c5a$export$2cdf090c2d29ef5f);
var $ca5152ac37b81c5a$export$2cdf090c2d29ef5f = /*#__PURE__*/ function(HelpSeekerMessageStatus) {
    HelpSeekerMessageStatus["IDLE"] = "helpseeker_idle";
    return HelpSeekerMessageStatus;
}({});

});

parcelRegister("dT1M7", function(module, exports) {
$parcel$export(module.exports, "parseJson", () => $834eafea226d6349$export$18c43dcebf00e571);
$parcel$export(module.exports, "isMessageGenerated", () => $834eafea226d6349$export$c2e15cdb6fbfcd43);

var $3det2 = parcelRequire("3det2");

var $2NRGh = parcelRequire("2NRGh");
const $834eafea226d6349$export$18c43dcebf00e571 = (value)=>{
    try {
        return typeof value === 'string' ? JSON.parse(value) : undefined;
    } catch (e) {
        return undefined;
    }
};
const $834eafea226d6349$export$c2e15cdb6fbfcd43 = (status)=>{
    if (!status) return true;
    if (status === (0, $2NRGh.HelpSeekerMessageStatus).IDLE) return true;
    return [
        (0, $3det2.ASSISTANT_MESSAGE_STATUS).IDLE,
        (0, $3det2.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
    ].indexOf(status) !== -1;
};

});


parcelRegister("6IVSk", function(module, exports) {
$parcel$export(module.exports, "createConversationWithMessageExperience", () => $680a025c880923c4$export$bcb43460f5483389);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $680a025c880923c4$var$createConversationWithMessageExperienceId = 'service-management.help-center.omnichannel.combined-api';
const $680a025c880923c4$export$bcb43460f5483389 = new (0, $1we90.UFOExperience)($680a025c880923c4$var$createConversationWithMessageExperienceId, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("8AFRj", function(module, exports) {
$parcel$export(module.exports, "establishSubscriptionToOmnichannel", () => $5656c1dcba56d611$export$190438bc49e7cd0e);

var $agnDm = parcelRequire("agnDm");

var $lFpPv = parcelRequire("lFpPv");

var $4270B = parcelRequire("4270B");

var $dvY3d = parcelRequire("dvY3d");

var $fjf5U = parcelRequire("fjf5U");

var $dXo4Q = parcelRequire("dXo4Q");

var $dT1M7 = parcelRequire("dT1M7");

var $4ND5I = parcelRequire("4ND5I");

var $cUmaM = parcelRequire("cUmaM");

var $3W5ib = parcelRequire("3W5ib");

var $7q3M9 = parcelRequire("7q3M9");

var $ipo6m = parcelRequire("ipo6m");
const $5656c1dcba56d611$var$SubscriptionGL = (0, $agnDm.default);
const $5656c1dcba56d611$export$190438bc49e7cd0e = ({ environment: environment, subscriptionId: subscriptionId })=>{
    const metadata = {
        subscriptionId: subscriptionId
    };
    (0, $ipo6m.subscriptionConnectionExperience).start();
    return (0, $4270B.requestSubscription)(environment, {
        onError: (error)=>{
            if ((0, $lFpPv.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $3W5ib.updateOmniChannelConversationMeta)({
                environment: environment,
                subscriptionStatus: 'FAILED'
            });
            (0, $dXo4Q.initialAIMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $dXo4Q.initialIntentMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $ipo6m.subscriptionConnectionExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $fjf5U.sendErrorEvent)({
                error: error,
                actionSubject: 'omnichannelSubscription',
                attributes: {
                    ...metadata
                }
            });
        },
        onNext: (data)=>{
            var _data$jsmChat, _data$jsmChat2, _data$jsmChat6, _node$content;
            if ((data === null || data === void 0 || (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.updateConversation) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.result) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__typename) === 'JsmChatWebSubscriptionEstablishedPayload') {
                if ((0, $lFpPv.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $3W5ib.updateOmniChannelConversationMeta)({
                    environment: environment,
                    subscriptionStatus: 'ACTIVE'
                });
                (0, $ipo6m.subscriptionConnectionExperience).success({
                    metadata: metadata
                });
                return;
            }
            if ((data === null || data === void 0 || (_data$jsmChat2 = data.jsmChat) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.updateConversation) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.result) === null || _data$jsmChat2 === void 0 ? void 0 : _data$jsmChat2.__typename) === 'JsmChatWebConversationUpdateQueryError') {
                var _data$jsmChat3, _data$jsmChat4, _data$jsmChat5;
                (0, $fjf5U.sendErrorEvent)({
                    error: new Error((data === null || data === void 0 || (_data$jsmChat3 = data.jsmChat) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.updateConversation) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.result) === null || _data$jsmChat3 === void 0 ? void 0 : _data$jsmChat3.message) ?? 'Payload Error in Subscription'),
                    actionSubject: 'omnichannelSubscription',
                    attributes: {
                        ...metadata
                    }
                });
                (0, $dXo4Q.initialIntentMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat4 = data.jsmChat) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.updateConversation) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.result) === null || _data$jsmChat4 === void 0 ? void 0 : _data$jsmChat4.message) ?? 'Payload Error in Subscription'
                    }
                });
                (0, $dXo4Q.initialAIMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat5 = data.jsmChat) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.updateConversation) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.result) === null || _data$jsmChat5 === void 0 ? void 0 : _data$jsmChat5.message) ?? 'Payload Error in Subscription'
                    }
                });
            }
            if (!(data !== null && data !== void 0 && (_data$jsmChat6 = data.jsmChat) !== null && _data$jsmChat6 !== void 0 && (_data$jsmChat6 = _data$jsmChat6.updateConversation) !== null && _data$jsmChat6 !== void 0 && _data$jsmChat6.conversation)) {
                (0, $3W5ib.updateOmniChannelConversationMeta)({
                    environment: environment,
                    isReplyPending: false
                });
                return;
            }
            const node = data.jsmChat.updateConversation.conversation.node;
            if (!node) return;
            const recordId = (0, $dvY3d.getRelayDataId)(node === null || node === void 0 ? void 0 : node.id, 'JsmChatCreateWebConversationMessage');
            const action = data.jsmChat.updateConversation.action;
            (0, $7q3M9.handleActionParamFromSubscription)({
                action: action,
                environment: environment,
                connectionId: undefined,
                nodeId: recordId
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((_node$content = node.content) !== null && _node$content !== void 0 && _node$content.aiResponse) {
                var _node$content2;
                (0, $dXo4Q.initialAIMessageHCExperience).success({
                    metadata: metadata
                });
                (0, $dXo4Q.initialIntentMessageHCExperience).abort({
                    metadata: {
                        ...metadata,
                        actionSubject: 'aiReceived'
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                const aiResponse = (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.aiResponse;
                const aiResponseNodeId = (0, $7q3M9.generateAIResponseNodeId)(recordId);
                (0, $4270B.commitLocalUpdate)(environment, (store)=>{
                    let aiResponseNode = store.get(aiResponseNodeId);
                    if (!aiResponseNode) {
                        aiResponseNode = store.create(aiResponseNodeId, 'JsmChatCreateWebConversationMessage');
                        aiResponseNode.setValue(aiResponseNodeId, 'id');
                        aiResponseNode.setValue('Assistant_Message', 'authorType');
                        const connectionId = (0, $7q3M9.getConnectionIdFromStore)(store);
                        if (connectionId) (0, $4ND5I.addNodeToCurrentConnection)({
                            store: store,
                            connectionId: connectionId,
                            recordId: aiResponseNodeId
                        });
                    }
                    store.delete(recordId);
                });
                const streamingMessages = (0, $dT1M7.parseJson)(aiResponse);
                streamingMessages === null || streamingMessages === void 0 || streamingMessages.forEach((streamingMessage)=>{
                    (0, $cUmaM.updateStreamingMessageInStore)({
                        environment: environment,
                        streamingMessage: streamingMessage,
                        connectionId: undefined,
                        recordId: aiResponseNodeId
                    });
                });
            } else {
                if (!action || action !== 'GREETING_MESSAGE') {
                    (0, $dXo4Q.initialIntentMessageHCExperience).success({
                        metadata: metadata
                    });
                    (0, $dXo4Q.initialAIMessageHCExperience).abort({
                        metadata: {
                            ...metadata,
                            actionSubject: 'intentReceived'
                        }
                    });
                }
                (0, $4270B.commitLocalUpdate)(environment, (store)=>{
                    const connectionId = (0, $7q3M9.getConnectionIdFromStore)(store);
                    if (connectionId) (0, $4ND5I.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: recordId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                });
            }
            if (!action || action !== 'GREETING_MESSAGE') (0, $3W5ib.updateOmniChannelConversationMeta)({
                environment: environment,
                isReplyPending: false
            });
        },
        subscription: $5656c1dcba56d611$var$SubscriptionGL,
        variables: {
            conversationId: subscriptionId
        }
    });
};

});
parcelRegister("agnDm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2662cdd93e5f617$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98280c1b5202d924d397fb90d5594f34>>
 * @relayHash 66ceed11481c815b912f0ffeaa5b68cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0
const $e2662cdd93e5f617$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "concreteType": "JsmChatSubscription",
            "kind": "LinkedField",
            "name": "jsmChat",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "conversationId",
                            "variableName": "conversationId"
                        }
                    ],
                    "concreteType": "JsmChatWebSubscriptionResponse",
                    "kind": "LinkedField",
                    "name": "updateConversation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "result",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JsmChatWebSubscriptionEstablishedPayload"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "JsmChatWebConversationUpdateQueryError"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "concreteType": "JsmChatMessageEdge",
                            "kind": "LinkedField",
                            "name": "conversation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "authorType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "content"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentType"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "appendices",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "requestTypeId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jiraProjectId"
                                                        }
                                                    ],
                                                    "type": "JsmChatJiraFieldAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "redirectAction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "baseUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "query"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatOptionAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "placeholder"
                                                        },
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatDropdownAppendix"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0",
            "metadata": {},
            "name": "communicationChannelSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$e2662cdd93e5f617$var$node.hash = "44da5305c7ec49b7ef2bab1de243b217";
var $e2662cdd93e5f617$export$2e2bcd8739ae039 = $e2662cdd93e5f617$var$node;

});

parcelRegister("cUmaM", function(module, exports) {
$parcel$export(module.exports, "updateStreamingMessageInStore", () => $e5ae7ea91ab3de29$export$648f4e23156d6dfe);

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");

var $jxiYc = parcelRequire("jxiYc");

var $3det2 = parcelRequire("3det2");

var $2NRGh = parcelRequire("2NRGh");

var $dT1M7 = parcelRequire("dT1M7");

var $4ND5I = parcelRequire("4ND5I");

var $7q3M9 = parcelRequire("7q3M9");
const $e5ae7ea91ab3de29$var$getMessageMetaFromStore = (assistantMessage, recordId)=>{
    const DEFAULT_ASSISNTANT_MESSAGE = {
        status: (0, $3det2.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
        messageId: recordId
    };
    if (!assistantMessage) return DEFAULT_ASSISNTANT_MESSAGE;
    const messageMeta = assistantMessage === null || assistantMessage === void 0 ? void 0 : assistantMessage.getValue('message_metaData');
    try {
        return (0, $dT1M7.parseJson)(messageMeta) ?? DEFAULT_ASSISNTANT_MESSAGE;
    } catch  {
        return DEFAULT_ASSISNTANT_MESSAGE;
    }
};
const $e5ae7ea91ab3de29$export$648f4e23156d6dfe = ({ environment: environment, recordId: recordId, streamingMessage: streamingMessage })=>{
    (0, $a2qIF.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(recordId);
        const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
        const messageContent = (assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('content')) ?? '';
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        const { type: type, content: content } = (0, $jxiYc.getUHUpdatedMessage)(streamingMessage, {
            content: messageContent,
            role: '',
            id: '0',
            time_created: '',
            user_ari: '',
            plugin_invocations: []
        }) ?? {
            type: ''
        };
        const metaData = $e5ae7ea91ab3de29$var$getMessageMetaFromStore(assistantMessageNode, recordId);
        // AI Conversation can be aborted from `stopGenerating` CTA in Input Box
        const abortStatus = assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('isAborted');
        if (abortStatus) {
            metaData.status = (0, $3det2.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE;
            jsmChatQuery.setValue((0, $3det2.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE, 'aiAnswerStatus');
            assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
            return;
        }
        switch(type){
            case 'FOLLOW_UP_QUERIES':
                if ((0, $lFpPv.isFollowupEnabledForPortal)()) {
                    const nodeId = (0, $7q3M9.createFollowupMessageNode)(content, store);
                    (0, $4ND5I.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: nodeId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                }
                break;
            case 'CONTENT_SEARCH':
                metaData.keywords = content.split('|');
                metaData.status = (0, $3det2.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                jsmChatQuery.setValue((0, $3det2.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'ANALYSING_STATE':
                metaData.sources = content;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                break;
            case 'ANSWER_PART':
                metaData.status = (0, $3det2.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(content.content, 'content');
                jsmChatQuery.setValue((0, $3det2.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'FINAL_RESPONSE':
                {
                    var _aiMetaData$message_m;
                    const aiMetaData = content;
                    metaData.status = (0, $3det2.ASSISTANT_MESSAGE_STATUS).IDLE;
                    metaData.messageId = aiMetaData.id.toString();
                    const isFallbackMessage = !!((_aiMetaData$message_m = aiMetaData.message_metadata) !== null && _aiMetaData$message_m !== void 0 && _aiMetaData$message_m.isFallbackMessage);
                    metaData.showFeedback = !isFallbackMessage;
                    metaData.isFallbackMessage = isFallbackMessage;
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(content.plugin_invocations), 'pluginInvocation');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(aiMetaData), 'aiMateConversationResponse');
                    jsmChatQuery.setValue((0, $3det2.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                    if (isFallbackMessage) {
                        node === null || node === void 0 || node.setValue('Init', 'authorType');
                        jsmChatQuery.setValue((0, $2NRGh.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
                    }
                    break;
                }
            case 'ERROR':
                node === null || node === void 0 || node.setValue('Assistant_Error', 'authorType');
                jsmChatQuery.setValue((0, $3det2.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                node === null || node === void 0 || node.setValue(null, 'content');
                break;
            default:
                break;
        }
    });
};

});

parcelRegister("ipo6m", function(module, exports) {
$parcel$export(module.exports, "subscriptionConnectionExperience", () => $8ab6177d59c46d60$export$1c1eb834db2f7128);
$parcel$export(module.exports, "omnichannelPageLoadExperience", () => $8ab6177d59c46d60$export$4feb855a2be04fbe);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $8ab6177d59c46d60$export$1c1eb834db2f7128 = new (0, $1we90.UFOExperience)('service-management.help-center.omnichannel-v2.subscription-connection', {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $8ab6177d59c46d60$export$4feb855a2be04fbe = new (0, $1we90.UFOExperience)('service-management.help-center.omnichannel-v2.page-load', {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("9vFUf", function(module, exports) {
$parcel$export(module.exports, "generateUniqueSubscriptionID", () => $307a411da8cf54df$export$b84750da6cd46f95);

var $fuVmc = parcelRequire("fuVmc");

var $4270B = parcelRequire("4270B");

var $eL3zl = parcelRequire("eL3zl");
const $307a411da8cf54df$export$b84750da6cd46f95 = ({ environment: environment })=>{
    return new Promise((resolve)=>{
        (0, $4270B.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            if (!subscriptionId) {
                const newSubscriptionID = `ari:cloud:conversational-help:${(0, $fuVmc.getCloudId)()}:conversation/${(0, $eL3zl.v4)()}`;
                jsmChatQuery.setValue(newSubscriptionID, 'subscriptionId');
                jsmChatQuery.setValue(null, 'connectionId');
                resolve(newSubscriptionID);
            }
            resolve(subscriptionId);
        });
    });
};

});

parcelRegister("aHKzr", function(module, exports) {
$parcel$export(module.exports, "useSubscriptionStore", () => $2a8226c034ca971a$export$554946cac481f18a);
$parcel$export(module.exports, "useSubscriptionAction", () => $2a8226c034ca971a$export$b9e415294ecd1592);

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $lomMf = parcelRequire("lomMf");
const $2a8226c034ca971a$var$initialState = {
    subscription: {
        dispose: ()=>undefined
    }
};
const $2a8226c034ca971a$var$store = (0, $7CE69.createStore)({
    actions: $lomMf.actions,
    initialState: $2a8226c034ca971a$var$initialState,
    name: 'OmnichannelSubscriptionStore'
});
const $2a8226c034ca971a$export$554946cac481f18a = (0, $gfNVK.createHook)($2a8226c034ca971a$var$store);
const $2a8226c034ca971a$export$b9e415294ecd1592 = (0, $gfNVK.createActionsHook)($2a8226c034ca971a$var$store);

});
parcelRegister("lomMf", function(module, exports) {
$parcel$export(module.exports, "actions", () => $68cb83647d5353f1$export$e324594224ef24da);

var $4ig7N = parcelRequire("4ig7N");
const $68cb83647d5353f1$export$e324594224ef24da = {
    setSubscriptionDisposer: $4ig7N.setSubscriptionDisposer
};

});
parcelRegister("4ig7N", function(module, exports) {
$parcel$export(module.exports, "setSubscriptionDisposer", () => $420efb5684b48a2e$export$398a2526d7502a0f);
const $420efb5684b48a2e$export$398a2526d7502a0f = (disposable)=>({ setState: setState })=>{
        setState({
            subscription: disposable
        });
    };

});



parcelRegister("kMeyd", function(module, exports) {
$parcel$export(module.exports, "OmnichannelClientConnection", () => $fa57305e6bb648ca$export$ca9674c8e6a24427);

var $NhuOi = parcelRequire("NhuOi");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("cJJTb");
var $bf3Xm = parcelRequire("bf3Xm");

var $a2qIF = parcelRequire("a2qIF");

var $hRN54 = parcelRequire("hRN54");

var $3W5ib = parcelRequire("3W5ib");

var $f6Ax9 = parcelRequire("f6Ax9");

var $7WRjA = parcelRequire("7WRjA");

var $9vFUf = parcelRequire("9vFUf");

var $gvaKS = parcelRequire("gvaKS");
const $fa57305e6bb648ca$export$8bbd1b8324c70f51 = ()=>{
    var _data$jsmChat;
    const metaData = (0, $hRN54.useOmnichannelMetaQuery)();
    const subscriptionId = metaData.subscriptionId;
    (0, $7WRjA.useUFOComponentExperience)((0, $gvaKS.omnichannelGetConversationExperience));
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $NhuOi.default), {
        conversationId: subscriptionId ?? '',
        isEmptyConversation: !subscriptionId
    });
    const newConnectionId = (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.getWebConversation) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__id;
    const environment = (0, $a2qIF.useRelayEnvironment)();
    (0, $bSJIT.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9vFUf.generateUniqueSubscriptionID)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $gvaKS.omnichannelGetConversationExperience).start();
    }, [
        environment
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (newConnectionId && metaData.connectionId !== newConnectionId) (0, $3W5ib.updateOmniChannelConversationMeta)({
            environment: environment,
            connectionId: newConnectionId
        });
    }, [
        environment,
        metaData.connectionId,
        newConnectionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $gvaKS.omnichannelGetConversationExperience)
    });
};
const $fa57305e6bb648ca$export$ca9674c8e6a24427 = ({ renderError: renderError })=>{
    const onError = (0, $bSJIT.useCallback)((error)=>{
        (0, $gvaKS.omnichannelGetConversationExperience).failure({
            metadata: {
                error: error === null || error === void 0 ? void 0 : error.message,
                statusCode: error === null || error === void 0 ? void 0 : error.status
            }
        }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).CONVERSATION_PAGE,
        id: "omnichannel-helpcenter-conversation",
        onError: onError,
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($fa57305e6bb648ca$export$8bbd1b8324c70f51, null)));
};

});
parcelRegister("NhuOi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec22604bbfb136da$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b88b33f9954ab0bdeac663c7a0d645e2>>
 * @relayHash f6c352f48eeebb85cf0c9fbc89dbddb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319
const $ec22604bbfb136da$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEmptyConversation"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v6 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "last",
            "value": 1
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "content"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "getWebConversation",
                                    "args": [
                                        v1 /*: any*/ 
                                    ],
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "__Connection__getWebConversation_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "messageRendererFragment"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "getWebConversation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "authorType"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "action"
                                                                },
                                                                {
                                                                    "concreteType": "JsmChatAssistantMessage",
                                                                    "kind": "LinkedField",
                                                                    "name": "assistantMessage",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pluginInvocation"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "aiMateConversationResponse"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message_metaData"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "appendices",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJsmChatConversationAppendixAction"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatDropdownAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "requestTypeId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraProjectId"
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatJiraFieldAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "redirectAction",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "baseUrl"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "query"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatOptionAppendix"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "conversationId"
                                    ],
                                    "handle": "connection",
                                    "key": "Connection__getWebConversation",
                                    "kind": "LinkedHandle",
                                    "name": "getWebConversation"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "backward",
                        "path": [
                            "jsmChat",
                            "getWebConversation"
                        ]
                    }
                ]
            },
            "name": "omnichannelClientConnectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ec22604bbfb136da$var$node.hash = "8ddd798333f81ebc8a31a378348e8046";
var $ec22604bbfb136da$export$2e2bcd8739ae039 = $ec22604bbfb136da$var$node;

});

parcelRegister("hRN54", function(module, exports) {
$parcel$export(module.exports, "useOmnichannelMetaQuery", () => $b6463163270ff42e$export$bc28f1e9de226671);

var $lhqSO = parcelRequire("lhqSO");

var $a2qIF = parcelRequire("a2qIF");
const $b6463163270ff42e$export$bc28f1e9de226671 = ()=>{
    var _data$jsmChatConversa, _data$jsmChatConversa2, _data$jsmChatConversa3, _data$jsmChatConversa4, _data$jsmChatConversa5, _data$jsmChatConversa6, _data$jsmChatConversa7, _data$jsmChatConversa8, _data$jsmChatConversa9, _data$jsmChatConversa0, _data$jsmChatConversa1, _data$jsmChatConversa10, _data$jsmChatConversa11;
    const data = (0, $a2qIF.useClientQuery)((0, $lhqSO.default), {});
    return {
        conversationId: data === null || data === void 0 || (_data$jsmChatConversa = data.jsmChatConversationMeta) === null || _data$jsmChatConversa === void 0 ? void 0 : _data$jsmChatConversa.conversationId,
        conversationContextAri: data === null || data === void 0 || (_data$jsmChatConversa2 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa2 === void 0 ? void 0 : _data$jsmChatConversa2.conversationContextAri,
        workspaceAri: data === null || data === void 0 || (_data$jsmChatConversa3 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa3 === void 0 ? void 0 : _data$jsmChatConversa3.workspaceAri,
        connectionId: data === null || data === void 0 || (_data$jsmChatConversa4 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa4 === void 0 ? void 0 : _data$jsmChatConversa4.connectionId,
        isReplyPending: !!(data !== null && data !== void 0 && (_data$jsmChatConversa5 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa5 !== void 0 && _data$jsmChatConversa5.isReplyPending),
        isConversationExpired: !!(data !== null && data !== void 0 && (_data$jsmChatConversa6 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa6 !== void 0 && _data$jsmChatConversa6.isConversationExpired),
        aiAnswerStatus: data === null || data === void 0 || (_data$jsmChatConversa7 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa7 === void 0 ? void 0 : _data$jsmChatConversa7.aiAnswerStatus,
        isConversationClosed: !!(data !== null && data !== void 0 && (_data$jsmChatConversa8 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa8 !== void 0 && _data$jsmChatConversa8.isConversationClosed),
        draftMessage: data === null || data === void 0 || (_data$jsmChatConversa9 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa9 === void 0 ? void 0 : _data$jsmChatConversa9.draftMessage,
        disableInput: !!(data !== null && data !== void 0 && (_data$jsmChatConversa0 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa0 !== void 0 && _data$jsmChatConversa0.disableInput),
        subscriptionId: data === null || data === void 0 || (_data$jsmChatConversa1 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa1 === void 0 ? void 0 : _data$jsmChatConversa1.subscriptionId,
        subscriptionTriggered: !!(data !== null && data !== void 0 && (_data$jsmChatConversa10 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa10 !== void 0 && _data$jsmChatConversa10.subscriptionTriggered),
        subscriptionStatus: (data === null || data === void 0 || (_data$jsmChatConversa11 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa11 === void 0 ? void 0 : _data$jsmChatConversa11.subscriptionStatus) ?? 'NONE'
    };
};

});
parcelRegister("lhqSO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9811744415312eb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d0112a424e829068aee0ce4b184f82e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9811744415312eb0$var$node = function() {
    var v0 = [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "concreteType": "JsmChatConversationMeta",
                    "kind": "LinkedField",
                    "name": "jsmChatConversationMeta",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "conversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "conversationContextAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "workspaceAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "connectionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReplyPending"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationExpired"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "aiAnswerStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationClosed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "draftMessage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "disableInput"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionTriggered"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "9615b9f4fbe1d3c4564d22bfc3ed4951",
            "id": null,
            "metadata": {},
            "name": "omnichannelMetaQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9811744415312eb0$var$node.hash = "96778225e661ec1b102bb65714d88315";
var $9811744415312eb0$export$2e2bcd8739ae039 = $9811744415312eb0$var$node;

});


parcelRegister("gvaKS", function(module, exports) {
$parcel$export(module.exports, "omnichannelGetConversationExperience", () => $04e6505094a08a5c$export$3ca91a525bd30f3f);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $04e6505094a08a5c$var$omnichannelGetConversationExperienceId = 'service-management.help-center.omnichannel.get-conversation';
const $04e6505094a08a5c$export$3ca91a525bd30f3f = new (0, $1we90.UFOExperience)($04e6505094a08a5c$var$omnichannelGetConversationExperienceId, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("hXLZM", function(module, exports) {
$parcel$export(module.exports, "isRemoveInvalidSearchPopupAriaEnabled", () => $cc3d9bb3ac2bf25d$export$b8287abc1a8f3561);
$parcel$export(module.exports, "SearchPromptPopup", () => $cc3d9bb3ac2bf25d$export$392e007cdca1b718);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
var $bf3Xm = parcelRequire("bf3Xm");
var $1ssyA = parcelRequire("1ssyA");

var $87QgR = parcelRequire("87QgR");

const $cc3d9bb3ac2bf25d$export$48d2544cca703af5 = (0, $2vYDF.lazy)(()=>(parcelRequire("gFAPB")).then((module)=>module.SearchPromptPopup), {
    moduleId: "./packages/help-center/search/src/search-prompt-popup/search-prompt-popup.tsx"
});
const $cc3d9bb3ac2bf25d$export$e96ae8d1e74f6354 = 'jsm_hc_search_remove_invalid_popup_aria';
const $cc3d9bb3ac2bf25d$export$b8287abc1a8f3561 = ()=>(0, $87QgR.default).checkGate($cc3d9bb3ac2bf25d$export$e96ae8d1e74f6354);
const $cc3d9bb3ac2bf25d$var$getFallbackTriggerProps = ()=>$cc3d9bb3ac2bf25d$export$b8287abc1a8f3561() ? {
        ref: null
    } : {
        ref: null,
        'aria-expanded': false,
        'aria-haspopup': false
    };
const $cc3d9bb3ac2bf25d$export$392e007cdca1b718 = (props)=>{
    const fallbackTriggerProps = $cc3d9bb3ac2bf25d$var$getFallbackTriggerProps();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, props.trigger(fallbackTriggerProps))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1ssyA.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cc3d9bb3ac2bf25d$export$48d2544cca703af5, props)));
};

});
parcelRegister("gFAPB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7botG").then(()=>parcelRequire('eNbCr'));

});


parcelRegister("fz5cK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b15da8ca8c370ac$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $6b15da8ca8c370ac$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.input.clear'
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.ai'
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputAriaLabelNoAI: {
        defaultMessage: 'Search for information',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.no-ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.no-ai'
    },
    askTheVirtualServiceAgent: {
        defaultMessage: 'Ask the virtual service agent',
        description: 'Hint to the user to initiate the virtual service agent conversation',
        id: 'search.input.placeholder.ai.ask-the-virtual-service-agent'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Hint to the user to press enter to go to search results page',
        id: 'search.input.hint'
    },
    ariaDescription: {
        defaultMessage: 'Typing letters in the search input updates the search results in below data table',
        description: 'description for screen reader users when they focus on the search bar ',
        id: 'search.input.aria-description'
    },
    characterLimitExceeded: {
        defaultMessage: 'Search queries must be {limit, number} characters or less.',
        description: 'Error message shown when the search query exceeds the character limit.',
        id: 'search.input.character-limit-exceeded'
    },
    characterLimitErrorIconLabel: {
        defaultMessage: 'Search query is too long',
        description: 'Accessible label for the error icon shown when the search query is too long.',
        id: 'search.input.character-limit-error-icon-label'
    }
});

});





parcelRegister("k9dqZ", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenu", () => (parcelRequire("1jNFB")).default);

var $1jNFB = parcelRequire("1jNFB");

});
parcelRegister("1jNFB", function(module, exports) {
$parcel$export(module.exports, "default", () => $352d2e8542625de2$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $cywwP = parcelRequire("cywwP");

var $jFO7B = parcelRequire("jFO7B");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("4qJbL");
var $d7iIq = parcelRequire("d7iIq");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("kdu15");
var $f2dYP = parcelRequire("f2dYP");
const $352d2e8542625de2$var$selector = (0, $BOq7h.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $9Yoxp.getPortalId)(state);
    const portal = {
        id: portalId,
        name: (0, $iWhHo.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $iWhHo.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $iWhHo.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $iWhHo.getIsProjectSimplified)(state, portalId))
    };
    return {
        portal: portal,
        canAdministerJIRA: (0, $fBLyB.getCanAdministerJIRA)(state),
        hasSiteAdministerAccess: (0, $fBLyB.getHasSiteAdministerAccess)(state),
        canCustomiseHelpCenter: (0, $hvIQS.getCanCustomize)(state),
        defaultColumnSettings: (0, $d7iIq.getRequestsColumnSettings)(state),
        jsmAIConfigEnabled: (0, $fOlM6.getJsmAIConfigEnabled)(state),
        projectKey: (0, $iWhHo.getProjectKey)(state, portalId)
    };
}, ({ portal: portal, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, jsmAIConfigEnabled: jsmAIConfigEnabled, projectKey: projectKey })=>({
        portal: portal,
        canAdministerJIRA: canAdministerJIRA,
        hasSiteAdministerAccess: hasSiteAdministerAccess,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        defaultColumnSettings: defaultColumnSettings,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        projectKey: projectKey
    }));
var $352d2e8542625de2$export$2e2bcd8739ae039 = (0, $f2mlD.default)($352d2e8542625de2$var$selector, {
    openHelpCenterCustomizationSidebar: ()=>(0, $cywwP.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $jFO7B.customizingRequestListColumn)(true)
})((0, $f2dYP.default));

});
parcelRegister("4qJbL", function(module, exports) {
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => (parcelRequire("d7iIq")).getEnabledRequestsColumnSettings);
$parcel$export(module.exports, "getRequestsColumnSettings", () => (parcelRequire("d7iIq")).getRequestsColumnSettings);
$parcel$export(module.exports, "getStatusFilter", () => (parcelRequire("d7iIq")).getStatusFilter);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("d7iIq")).isSaveInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("d7iIq")).isCustomizing);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => (parcelRequire("d7iIq")).getOrderedRequestsColumnSettings);
$parcel$export(module.exports, "isReOrdering", () => (parcelRequire("d7iIq")).isReOrdering);

var $d7iIq = parcelRequire("d7iIq");

});
parcelRegister("d7iIq", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $622fe56e1ab8c717$export$a5e47ac90fcdaee8);
$parcel$export(module.exports, "getStatusFilter", () => $622fe56e1ab8c717$export$118cb57d68780367);
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => $622fe56e1ab8c717$export$821f60d0d1e0f967);
$parcel$export(module.exports, "isSaveInProgress", () => $622fe56e1ab8c717$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isCustomizing", () => $622fe56e1ab8c717$export$ce3eed7c98304744);
$parcel$export(module.exports, "isReOrdering", () => $622fe56e1ab8c717$export$f63ec727b3081523);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => $622fe56e1ab8c717$export$3e30ecdbb6a12b60);

var $BOq7h = parcelRequire("BOq7h");

var $gEVth = parcelRequire("gEVth");
const $622fe56e1ab8c717$export$29021bb8222c3223 = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $622fe56e1ab8c717$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $622fe56e1ab8c717$export$29021bb8222c3223(state);
    return settingsState.columns || [];
};
const $622fe56e1ab8c717$export$118cb57d68780367 = (state)=>{
    const settingsState = $622fe56e1ab8c717$export$29021bb8222c3223(state);
    return settingsState.statusFilter;
};
const $622fe56e1ab8c717$export$821f60d0d1e0f967 = (0, $BOq7h.createSelector)($622fe56e1ab8c717$export$a5e47ac90fcdaee8, (requestsColumnSettings)=>{
    return requestsColumnSettings.filter((column)=>column.isEnabled);
});
const $622fe56e1ab8c717$export$20bb0d907fbbe433 = (state)=>{
    if (!state.ui.requestsColumnSettings) return true;
    return Boolean(state.ui.requestsColumnSettings.isLoading);
};
const $622fe56e1ab8c717$export$2b75ac2de7a23db1 = (state)=>{
    var _state$ui$requestsCol;
    return Boolean((_state$ui$requestsCol = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol === void 0 ? void 0 : _state$ui$requestsCol.isSaveInProgress);
};
const $622fe56e1ab8c717$export$ce3eed7c98304744 = (state)=>{
    var _state$ui$requestsCol2;
    return Boolean((_state$ui$requestsCol2 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol2 === void 0 ? void 0 : _state$ui$requestsCol2.isCustomizing);
};
const $622fe56e1ab8c717$export$f63ec727b3081523 = (state)=>{
    var _state$ui$requestsCol3;
    return Boolean((_state$ui$requestsCol3 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol3 === void 0 ? void 0 : _state$ui$requestsCol3.isReOrdering);
};
const $622fe56e1ab8c717$export$c7b5b7c6c2c6936 = (state)=>{
    var _state$ui$requestsCol4;
    return (_state$ui$requestsCol4 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol4 === void 0 ? void 0 : _state$ui$requestsCol4.columnsOrder;
};
const $622fe56e1ab8c717$export$3e30ecdbb6a12b60 = (0, $BOq7h.createSelector)($622fe56e1ab8c717$export$821f60d0d1e0f967, $622fe56e1ab8c717$export$c7b5b7c6c2c6936, (enabledColumnSettings, columnsOrder)=>{
    if (columnsOrder && columnsOrder.length > 0) return columnsOrder.map((index)=>enabledColumnSettings === null || enabledColumnSettings === void 0 ? void 0 : enabledColumnSettings[index]);
    const filteredColumns = enabledColumnSettings.filter((column)=>column.order);
    if (filteredColumns.length > 0) return filteredColumns.sort((a, b)=>{
        if (a.order && b.order) return a.order - b.order;
        return 1;
    });
    /*
   * We fire analytics when enabledColumnSettings is not empty (to filter out noise) and filteredColumns
   * is empty implying that order is prop is undefined for all the columns. This is an erroneous state
   * since we expect at least one column to have order prop defined. If this happens, we return enabledColumnSettings
   * as is.
   */ if (enabledColumnSettings && enabledColumnSettings.length > 0) (0, $gEVth.operationalEvent)({
        action: 'emptyOrderedRequestColumnSettingsReceived',
        actionSubject: 'request-list-filters-and-table',
        source: 'RequestList'
    });
    return enabledColumnSettings;
});

});


parcelRegister("kdu15", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenuDumb", () => (parcelRequire("f2dYP")).default);

var $f2dYP = parcelRequire("f2dYP");

});
parcelRegister("f2dYP", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ec72956b6b5fa35$export$2e2bcd8739ae039);
/* customise-menu-dumb.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $7rNzU = parcelRequire("7rNzU");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $97yQ5 = parcelRequire("97yQ5");
var $2OuWT = parcelRequire("2OuWT");

var $53Khx = parcelRequire("53Khx");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $fuVmc = parcelRequire("fuVmc");

var $9K7mZ = parcelRequire("9K7mZ");

var $a7Tmb = parcelRequire("a7Tmb");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("ckGNT");
var $iStmz = parcelRequire("iStmz");
parcelRequire("nR7qC");
var $3R7iu = parcelRequire("3R7iu");

var $6WltM = parcelRequire("6WltM");

var $dwOcU = parcelRequire("dwOcU");

var $87QgR = parcelRequire("87QgR");

var $cg9TC = parcelRequire("cg9TC");

var $cExzV = parcelRequire("cExzV");

var $cjQhO = parcelRequire("cjQhO");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $26Jy2 = parcelRequire("26Jy2");

var $gUpf2 = parcelRequire("gUpf2");

var $aHbh3 = parcelRequire("aHbh3");

var $9BVpB = parcelRequire("9BVpB");

var $juI4y = parcelRequire("juI4y");

var $8LptA = parcelRequire("8LptA");

var $haAAx = parcelRequire("haAAx");

var $dDjgn = parcelRequire("dDjgn");

var $dLhCs = parcelRequire("dLhCs");

var $duJSM = parcelRequire("duJSM");

var $5oqa3 = parcelRequire("5oqa3");

var $8RL7A = parcelRequire("8RL7A");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $oORS9 = parcelRequire("oORS9");

var $35D51 = parcelRequire("35D51");

var $bT4D5 = parcelRequire("bT4D5");

var $bGOCV = parcelRequire("bGOCV");
parcelRequire("42iNA");
var $caGfV = parcelRequire("caGfV");

var $8G6wP = parcelRequire("8G6wP");
const $1ec72956b6b5fa35$var$JSM_TMP_PORTAL_GROUPS_IN_JIRA_GATE = 'jsm_tmp_portal_groups_in_jira';
const $1ec72956b6b5fa35$var$HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
const $1ec72956b6b5fa35$var$isPortalGroupsInJiraEnabled = ()=>(0, $87QgR.default).checkGate($1ec72956b6b5fa35$var$JSM_TMP_PORTAL_GROUPS_IN_JIRA_GATE);
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $1ec72956b6b5fa35$var$isSmallScreen = window.innerWidth < (0, $a7Tmb.sizes).xsmall;
const $1ec72956b6b5fa35$var$CustomPressable = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aHbh3.Pressable), {
        componentName: "link",
        xcss: $1ec72956b6b5fa35$var$customPressableStyles,
        ...rest
    }, children);
};
/**
 * Feature gate: premium_benefits_modal_config_driven
 *
 * When enabled, open the new config-driven edition-benefits-modal via its async
 * entrypoint (`editionBenefitsModalEntryPoint` + `ModalTrigger`) instead of the
 * legacy `PremiumBenefitModalTrigger`. The entrypoint loads on demand, keeping
 * the modal's assets out of the initial bundle.
 *
 * Rollout: Pending — gate created 2026-07-15, default off
 * Target: TBD
 * Owner: Sequoia (SQA-4082)
 */ const $1ec72956b6b5fa35$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN = 'premium_benefits_modal_config_driven';
const $1ec72956b6b5fa35$var$isPremiumBenefitsModalConfigDrivenEnabled = ()=>(0, $87QgR.default).checkGate($1ec72956b6b5fa35$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN);
const $1ec72956b6b5fa35$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const isConfigDriven = $1ec72956b6b5fa35$var$isPremiumBenefitsModalConfigDrivenEnabled();
    const edition = (0, $iW3CQ.getEnv)().edition ?? 'unknown';
    // The config-driven ModalTrigger path doesn't emit the trigger analytics that the
    // legacy PremiumBenefitModalTrigger did, so replicate them here for parity.
    const fireTriggerEvent = (0, $bSJIT.useCallback)((action)=>createAnalyticsEvent({
            action: action,
            eventType: 'ui',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                edition: edition,
                touchpointId: 'portal-customise-menu-edit-page-layout',
                product: 'jira-service-management',
                variantId: 'help-center-customization',
                packageName: '@atlassian/edition-benefits-modal',
                source: 'editionBenefitsModal'
            }
        }).fire('growth'), // FabricChannel.growth
    [
        createAnalyticsEvent,
        edition
    ]);
    const hasFiredViewed = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        // Fire the trigger "viewed" event once when the config-driven trigger is shown.
        if (isConfigDriven && !hasFiredViewed.current) {
            hasFiredViewed.current = true;
            fireTriggerEvent('viewed');
        }
    }, [
        isConfigDriven,
        fireTriggerEvent
    ]);
    const renderTrigger = ({ ref: ref, onTriggerClick: onTriggerClick, props: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            ref: ref,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            component: $1ec72956b6b5fa35$var$CustomPressable,
            // Compose the trigger analytics with the item's own handler so the "clicked"
            // event fires on the element itself rather than relying on event bubbling.
            onClick: onTriggerClick ? (event)=>{
                var _menu$onClick;
                onTriggerClick();
                (_menu$onClick = menu.onClick) === null || _menu$onClick === void 0 || _menu$onClick.call(menu, event);
            } : menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).HELP_CENTER,
        id: "help-center-customise-menu-edit-page-layout",
        renderError: ()=>null
    }, isConfigDriven ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8RL7A.ModalTrigger), {
        entryPoint: (0, $duJSM.editionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: (0, $fuVmc.getCloudId)(),
            product: 'jira-service-management'
        },
        entryPointProps: {
            variantId: 'help-center-customization',
            touchpointId: 'portal-customise-menu-edit-page-layout'
        },
        modalProps: (0, $dLhCs.MODAL_CONFIG)
    }, ({ ref: ref })=>renderTrigger({
            ref: ref,
            props: {},
            onTriggerClick: ()=>fireTriggerEvent('clicked')
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDjgn.PremiumBenefitModalTrigger), {
        cloudId: (0, $fuVmc.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: "portal-customise-menu-edit-page-layout",
        edition: edition
    }, renderTrigger));
};
const $1ec72956b6b5fa35$export$a3cd28217da1103e = ({ helpCenterAri: helpCenterAri, migration: migration, slug: slug, type: type, baseUrl: baseUrl })=>{
    if (type === 'HELP_HUB') return undefined;
    const migrationState = (0, $35D51.resolveMigrationManagementState)(migration);
    if (migrationState.action === 'update') return {
        action: 'update',
        href: `${0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH}?migrationStep=select&migrationSourceHelpCenterAri=${encodeURIComponent(helpCenterAri)}`
    };
    if (migrationState.action === 'review' && slug) return {
        action: 'review',
        href: (0, $bGOCV.buildMigratedHelpCenterReviewUrl)({
            baseUrl: baseUrl,
            slug: slug
        })
    };
    return undefined;
};
const $1ec72956b6b5fa35$var$MigrationMenuAction = ({ onClose: onClose })=>{
    var _data$helpCenter, _helpCenter$migration, _helpCenter$migration2;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $7rNzU.default), {
        helpCenterAri: helpCenterAri,
        cloudId: (0, $fuVmc.getCloudId)()
    });
    const helpCenter = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    if ((helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.__typename) !== 'HelpCenter') return null;
    const action = $1ec72956b6b5fa35$export$a3cd28217da1103e({
        helpCenterAri: helpCenterAri,
        migration: {
            migratedHubAri: ((_helpCenter$migration = helpCenter.migration) === null || _helpCenter$migration === void 0 ? void 0 : _helpCenter$migration.migratedHubAri) ?? null,
            state: ((_helpCenter$migration2 = helpCenter.migration) === null || _helpCenter$migration2 === void 0 ? void 0 : _helpCenter$migration2.state) ?? null
        },
        slug: helpCenter.slug,
        type: helpCenter.type,
        baseUrl: (0, $iW3CQ.getEnv)().baseUrl
    });
    if (!action) return null;
    const actionSubjectId = action.action === 'update' ? 'navbarUpdateHelpCenter' : 'navbarReviewHelpCenterMigration';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: (0, $53Khx.HtmlAnchor),
        href: action.href,
        actionSubjectId: actionSubjectId,
        onClick: ()=>onClose(actionSubjectId),
        testId: "help-center-migration-action",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, formatMessage(action.action === 'update' ? (0, $bT4D5.default).helpCenterUpdateButtonText : (0, $bT4D5.default).helpCenterReviewUpdateButtonText)));
};
const $1ec72956b6b5fa35$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomePage, basePath)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isCsmHelpCenter = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const showPortalReorderButton = !isCsmHelpCenter && isHomePage && canAdministerJIRA && !$1ec72956b6b5fa35$var$isSmallScreen;
    const customizeMenu = [
        {
            link: `${basePath}?customize=true&experience=help-center-announcement`,
            label: formatMessage((0, $8G6wP.default).announcement),
            actionSubjectId: 'navbarAnnouncement',
            isVisible: isHomePage && !$1ec72956b6b5fa35$var$isSmallScreen,
            onClick: ()=>onClick('navbarAnnouncement'),
            testId: 'announcement-link'
        },
        {
            link: `${basePath}?customize=true&experience=theme`,
            label: formatMessage((0, $8G6wP.default).look),
            actionSubjectId: 'navbarLookAndFeel',
            isVisible: isHomePage && canAdministerJIRA,
            onClick: ()=>onClick('navbarLookAndFeel'),
            testId: 'look-and-feel-link'
        },
        {
            link: `${basePath}?customize=true&experience=login-announcement`,
            label: formatMessage((0, $8G6wP.default).logInMessage),
            actionSubjectId: 'navbarLoginAnnouncement',
            isVisible: isHomePage && canAdministerJIRA && !$1ec72956b6b5fa35$var$isSmallScreen,
            onClick: ()=>onClick('navbarLoginAnnouncement'),
            testId: 'login-announcement-link'
        },
        {
            link: '/settings/portal-reorder',
            label: formatMessage((0, $8G6wP.default).topicsAndPortals),
            actionSubjectId: 'navbarPortalReorder',
            isVisible: showPortalReorderButton,
            onClick: ()=>onClick('navbarPortalReorder'),
            testId: 'topics-link'
        },
        {
            link: '/edit',
            label: formatMessage((0, $8G6wP.default).pageLayout),
            actionSubjectId: 'navbarHideAndReorder',
            isVisible: showEditLayoutButton,
            onClick: ()=>onClick('navbarHideAndReorder', !(0, $iW3CQ.getIsHCCustomizationEnabled)()),
            testId: 'hide-and-reorder-link',
            customRenderer: (0, $iW3CQ.getIsHCCustomizationEnabled)() ? undefined : $1ec72956b6b5fa35$var$PremiumBenefitsModalRenderer,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, (0, $iW3CQ.getIsHCCustomizationEnabled)() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                appearance: "discovery"
            }, formatMessage((0, $8G6wP.default).premium)))
        }
    ];
    const onClick = (actionSubjectId, closeSidebar)=>{
        onClose(actionSubjectId);
        if (!closeSidebar) openHelpCenterCustomizationSidebar();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(menu.customRenderer, {
            key: `customize-menu_${menu.actionSubjectId}`,
            menu: menu
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            key: `customize-menu_${menu.actionSubjectId}`,
            component: $1ec72956b6b5fa35$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $1ec72956b6b5fa35$var$PortalLinks = ({ onClose: onClose, canCustomiseHelpCenter: canCustomiseHelpCenter, portal: portal, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (!portal) return null;
    const { isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, canEditAnnouncement: canEditAnnouncement } = portal;
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const shouldRenderConfigurePortal = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const shouldRenderCustomizeRequestTypes = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const shouldRenderCustomizePortalGroups = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const shouldRenderTeamManagedPortalGroupSettings = ()=>{
        if ($1ec72956b6b5fa35$var$isPortalGroupsInJiraEnabled()) return isProjectAdmin && isProjectSimplified && !shouldRenderAsPortalAnnouncement() && Boolean(projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
        return isProjectAdmin && isProjectSimplified && !shouldRenderAsPortalAnnouncement();
    };
    const customizeMenu = [
        {
            link: '?customize=true&experience=add-announcement',
            onClick: ()=>onClose('navbarPortalAnnouncement'),
            label: formatMessage((0, $8G6wP.default).portalAnnouncement),
            actionSubjectId: 'navbarPortalAnnouncement',
            isVisible: canEditAnnouncement || shouldRenderAsPortalAnnouncement()
        },
        {
            link: $1ec72956b6b5fa35$var$isPortalGroupsInJiraEnabled() ? undefined : '?customize=true&experience=request-groups',
            href: $1ec72956b6b5fa35$var$isPortalGroupsInJiraEnabled() ? (0, $oORS9.getTeamManagedPortalGroupSettingsUrl)(projectKey ?? '') : undefined,
            onClick: ()=>onClose('navbarRequestTypeGroup'),
            label: formatMessage((0, $8G6wP.default).portalRequestTypeGroup),
            actionSubjectId: 'navbarRequestTypeGroup',
            isVisible: shouldRenderTeamManagedPortalGroupSettings(),
            target: $1ec72956b6b5fa35$var$isPortalGroupsInJiraEnabled() ? '_blank' : undefined
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings`,
            onClick: ()=>onClose('navbarConfigurePortal'),
            label: formatMessage((0, $8G6wP.default).configurePortal),
            actionSubjectId: 'navbarConfigurePortal',
            isVisible: shouldRenderConfigurePortal(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/${isProjectSimplified ? 'issuetypes' : 'request-types'}/`,
            onClick: ()=>onClose('navbarCustomizeRequestTypes'),
            label: formatMessage((0, $8G6wP.default).customizeRequestTypes),
            actionSubjectId: 'navbarCustomizeRequestTypes',
            isVisible: shouldRenderCustomizeRequestTypes(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings/portal-groups`,
            onClick: ()=>onClose('navbarManagePortalGroups'),
            label: formatMessage((0, $8G6wP.default).managePortalGroups),
            actionSubjectId: 'navbarManagePortalGroups',
            isVisible: shouldRenderCustomizePortalGroups(),
            target: '_blank'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, customizeMenu.map(({ isVisible: isVisible, actionSubjectId: actionSubjectId, onClick: onClick, link: link, href: href, label: label, target: target })=>{
        if (!isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            key: `portal-link_${actionSubjectId}`,
            component: $1ec72956b6b5fa35$var$CustomLink,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            ...link ? {
                to: link
            } : {},
            ...href ? {
                href: href
            } : {},
            testId: `portal-link_${actionSubjectId}`,
            // Made this check of menu.target === '_blank' to avoid the eslint error
            target: target === '_blank' ? '_blank' : '_self',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, label);
    }));
};
const $1ec72956b6b5fa35$var$CustomPageLinks = ({ showEditCustomPages: showEditCustomPages })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [{ match: match }] = (0, $h1bGI.useRouter)();
    const pageId = match.params.id || '';
    const customizeMenu = [
        {
            link: `/page/edit/${pageId}`,
            label: formatMessage((0, $8G6wP.default).pageLayout),
            actionSubjectId: 'navbarEditCustomPage',
            isVisible: showEditCustomPages
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            key: `custom-page-link_${menu.actionSubjectId}`,
            component: $1ec72956b6b5fa35$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $1ec72956b6b5fa35$var$RequestList = (onClose, openRequestListCustomizationSidebar)=>{
    const onClick = (actionSubjectId)=>{
        onClose(actionSubjectId);
        openRequestListCustomizationSidebar();
    };
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: $1ec72956b6b5fa35$var$CustomButton,
        actionSubjectId: "navbarUserRequestListCustomize",
        "aria-label": formatMessage((0, $8G6wP.default).customizeRequestList),
        onClick: ()=>onClick('navbarUserRequestListCustomize'),
        "data-test-id": "requests-list-page-link"
    }, formatMessage((0, $8G6wP.default).customizeRequestList)));
};
const $1ec72956b6b5fa35$var$CustomiseMenu = (props)=>{
    const [{ route: route }] = (0, $h1bGI.useRouter)();
    const { name: routeName } = route;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $3R7iu.useQueryParams)();
    (0, $bSJIT.useEffect)(()=>{
        // if customize is true and experience is not set, open the customise menu
        if (customize === 'true' && !experience) setIsOpen(true);
    }, [
        customize,
        experience
    ]);
    const isHomepage = routeName === 'help-center' || routeName === 'view-homepage';
    const isCustomPage = routeName === (0, $jcRK7.RouteName).VIEW_CUSTOM_PAGE;
    const showEditCustomPageButton = props.canAdministerJIRA && !$1ec72956b6b5fa35$var$isSmallScreen && isCustomPage;
    const showEditLayoutButtonUpsell = (0, $iW3CQ.getIsHCCustomizationEnabled)() || (props.hasSiteAdministerAccess ?? false);
    const showEditLayoutButton = isHomepage && props.canAdministerJIRA && !$1ec72956b6b5fa35$var$isSmallScreen && showEditLayoutButtonUpsell;
    const isHelpCenterManagementScreen = (0, $eDcdn.getRelativeBasePath)() === (0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const isHelpHubMigrationEnabled = (0, $87QgR.default).checkGate($1ec72956b6b5fa35$var$HELP_HUB_MIGRATION_GATE);
    const basePath = (0, $hCnLH.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(!!props.isOpen);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const onOpenChange = (0, $bSJIT.useCallback)((open)=>{
        setIsOpen(open);
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const setCustomiseSidebarTrigger = (0, $iStmz.useSetCustomiseSidebarTrigger)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'customizeMenu',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    const allowRouteList = [
        'help-center',
        'view-homepage',
        'portal-home',
        'requests-list',
        (0, $jcRK7.RouteName).VIEW_CUSTOM_PAGE
    ];
    const hideCustomizeButton = ()=>{
        var _props$portal, _props$portal2;
        return !allowRouteList.includes(routeName) || isHelpCenterManagementScreen || isHomepage && !props.canCustomiseHelpCenter || //Hide for Agents with Edit Permission in mobile view
        isHomepage && props.canCustomiseHelpCenter && !props.canAdministerJIRA && $1ec72956b6b5fa35$var$isSmallScreen || routeName === 'portal-home' && !((_props$portal = props.portal) !== null && _props$portal !== void 0 && _props$portal.isProjectAdmin || (_props$portal2 = props.portal) !== null && _props$portal2 !== void 0 && _props$portal2.canEditAnnouncement) || routeName === 'requests-list' && !props.canAdministerJIRA || isCustomPage && !props.canAdministerJIRA;
    };
    const content = ()=>{
        const { openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, openRequestListCustomizationSidebar: openRequestListCustomizationSidebar, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, portal: portal, projectKey: projectKey } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $1ec72956b6b5fa35$var$popupContainerStyles,
            "aria-label": formatMessage((0, $8G6wP.default).customizeAriaLabel),
            testId: 'customize-menu-content',
            role: "group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $65Fe1.default), {
            maxHeight: $1ec72956b6b5fa35$var$maxHeight
        }, !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, canCustomiseHelpCenter && isHomepage && $1ec72956b6b5fa35$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomepage, basePath), isHomepage && canAdministerJIRA && isHelpHubMigrationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
            packageName: (0, $jcRK7.ScreenName).HELP_CENTER,
            id: "customize-menu-migration-action",
            renderError: ()=>null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1ec72956b6b5fa35$var$MigrationMenuAction, {
            onClose: onItemClick
        }))), routeName === 'portal-home' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1ec72956b6b5fa35$var$PortalLinks, {
            onClose: onItemClick,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            portal: portal,
            projectKey: projectKey
        }), routeName === 'requests-list' && canAdministerJIRA && Boolean(defaultColumnSettings === null || defaultColumnSettings === void 0 ? void 0 : defaultColumnSettings.length) && $1ec72956b6b5fa35$var$RequestList(onItemClick, openRequestListCustomizationSidebar), isCustomPage && showEditCustomPageButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1ec72956b6b5fa35$var$CustomPageLinks, {
            showEditCustomPages: showEditCustomPageButton
        }))), showEditLayoutButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireUIAnalytics), {
            action: "viewed",
            actionSubject: "editPageLayout"
        }));
    };
    const Trigger = (0, $bSJIT.useCallback)(({ ref: ref, ...triggerProps })=>{
        const combinedRef = (element)=>{
            if (typeof ref === 'function') ref(element);
            else if (ref && typeof ref === 'object' && 'current' in ref) ref.current = element;
            setCustomiseSidebarTrigger === null || setCustomiseSidebarTrigger === void 0 || setCustomiseSidebarTrigger(element);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $caGfV.default), {
            label: formatMessage((0, $8G6wP.default).customizeBtnLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cg9TC))), {
                label: "customise",
                size: "small",
                spacing: "spacious"
            }),
            disabled: props.disableCustomiseMenu,
            onClick: ()=>{
                onOpenChange(!isOpen);
                createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'navbarCustomise',
                    analyticsType: (0, $haAAx.UI_EVENT_TYPE)
                }).fire();
            },
            forwardedRef: combinedRef,
            ...triggerProps
        }));
    }, [
        formatMessage,
        props.disableCustomiseMenu,
        onOpenChange,
        isOpen,
        createAnalyticsEvent,
        setCustomiseSidebarTrigger
    ]);
    const renderDropdownMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5oqa3.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
            isOpen: isOpen,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            shouldRenderToParent: true,
            zIndex: (0, $juI4y.layers).modal(),
            content: content,
            trigger: Trigger,
            key: 'customise-menu-dumb-popup'
        }));
    if (hideCustomizeButton()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1ec72956b6b5fa35$var$CustomiseBtnWrapperStyles
    }, renderDropdownMenu());
};
const $1ec72956b6b5fa35$var$CustomiseBtnWrapperStyles = (0, $9BVpB.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1ec72956b6b5fa35$var$NoUnderlineLink = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $2OuWT.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $1ec72956b6b5fa35$var$popupContainerStyles = (0, $9BVpB.xcss)({
    minWidth: '234px',
    maxWidth: '800px',
    color: 'color.text'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1ec72956b6b5fa35$var$CustomLink = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = $1ec72956b6b5fa35$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_syaz261p _1y3i1r31 _92x4glyw _109f1o36 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $1ec72956b6b5fa35$var$customPressableStyles = (0, $9BVpB.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1ec72956b6b5fa35$var$CustomButton = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $97yQ5.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $1ec72956b6b5fa35$var$maxHeight = `calc(100vh - ${$9K7mZ.multiple(24).px}`;
var $1ec72956b6b5fa35$export$2e2bcd8739ae039 = $1ec72956b6b5fa35$var$CustomiseMenu;

});
parcelRegister("7rNzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c6cd4d22127f611$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0fd551cf9d12a8431ca0fa60e3389c6>>
 * @relayHash 89862e89702e0591c663bc7cb385db1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fb531fb8c9608e3099d1a273882ae83e52887e3fcb359aea54e8f86b6d733e1
const $6c6cd4d22127f611$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "slug"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "HelpCenterMigrationInfo",
                "kind": "LinkedField",
                "name": "migration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "migratedHubAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customiseMenuDumbMigrationActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customiseMenuDumbMigrationActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9fb531fb8c9608e3099d1a273882ae83e52887e3fcb359aea54e8f86b6d733e1",
            "metadata": {},
            "name": "customiseMenuDumbMigrationActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c6cd4d22127f611$var$node.hash = "1af1147940ad61a0f56be07e50b0c9bb";
var $6c6cd4d22127f611$export$2e2bcd8739ae039 = $6c6cd4d22127f611$var$node;

});

parcelRegister("nR7qC", function(module, exports) {
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("3R7iu")).getPortalIdAsNumber);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("3R7iu")).useQueryParams);
parcelRequire("dYq2G");
parcelRequire("8vS4c");
parcelRequire("3R7iu");

});
parcelRegister("dYq2G", function(module, exports) {
const $a41f503ace3a0b10$export$f14c45907e18a763 = 31;
const $a41f503ace3a0b10$export$49754c91e8c4555b = 11;
const $a41f503ace3a0b10$export$5c16d76778f8ba6d = 5;
const $a41f503ace3a0b10$export$de93546541b3e2e = 3;
const $a41f503ace3a0b10$export$897393da5c49885d = 30;
const $a41f503ace3a0b10$export$7652aee25e1c7c1e = 30;
const $a41f503ace3a0b10$export$95aa4d213e66754b = 300;

});

parcelRegister("8vS4c", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $fU62V = parcelRequire("fU62V");
const $6a98dbee497adfbd$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $6a98dbee497adfbd$export$f99233281efd08a0 = /*#__PURE__*/ (0, $4v2A7.default).h3.withConfig({
    componentId: "sc-19gahx3-0"
})`${$fU62V.clamp};margin:0;font-weight:normal;font-size:${"var(--ds-space-200, 16px)"};`;
const $6a98dbee497adfbd$export$10c56fa12fda26f9 = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-19gahx3-1"
})`color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-100, 8px)"};padding-right:${"var(--ds-space-200, 16px)"};${$fU62V.multiLineClamp(3, 20)};`;
const $6a98dbee497adfbd$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-19gahx3-2"
})`display:flex;border-radius:${"var(--ds-radius-small, 3px)"};${$fU62V.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};padding:${"var(--ds-space-200, 16px)"};margin:${"var(--ds-space-100, 8px)"} 0 0;&:hover,&:focus{background:${"var(--ds-surface-raised, #FFFFFF)"};text-decoration:none;}&:hover h3,&:focus h3{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
const $6a98dbee497adfbd$export$d971b98a124cabfc = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_ca0qpxbi _19pkze3t _1p1dangw _1wybutpp _k48p8n31 _syaz117m",
            __cmplp.className
        ])
    });
});
const $6a98dbee497adfbd$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $6a98dbee497adfbd$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $6a98dbee497adfbd$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $6a98dbee497adfbd$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = (0, $2OuWT.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $6a98dbee497adfbd$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3R7iu", function(module, exports) {
$parcel$export(module.exports, "useQueryParams", () => $8974808b002b25b0$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $8974808b002b25b0$export$c36431be801010b);

var $bSJIT = parcelRequire("bSJIT");

var $lVkdr = parcelRequire("lVkdr");

var $gpYsn = parcelRequire("gpYsn");

var $dMC40 = parcelRequire("dMC40");

var $dJ2iN = parcelRequire("dJ2iN");

var $f76XN = parcelRequire("f76XN");

var $fvUqa = parcelRequire("fvUqa");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
const $8974808b002b25b0$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $8974808b002b25b0$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $8974808b002b25b0$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $f76XN.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $8974808b002b25b0$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $f76XN.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $8974808b002b25b0$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $h1bGI.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $bSJIT.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($fvUqa))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $bSJIT.useMemo)(()=>$8974808b002b25b0$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $bSJIT.useMemo)(()=>$8974808b002b25b0$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $8974808b002b25b0$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $8974808b002b25b0$export$c36431be801010b(portalId) !== 0;
const $8974808b002b25b0$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $8974808b002b25b0$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($dJ2iN)))(portalId);
};
const $8974808b002b25b0$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gpYsn)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($dMC40)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVkdr)))(ids) ? ids : [];
    }
    return [];
};
const $8974808b002b25b0$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $8974808b002b25b0$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $8974808b002b25b0$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $bSJIT.useState)(false);
    const [isFocused, setIsFocused] = (0, $bSJIT.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $bSJIT.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});


parcelRegister("cg9TC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::420bb8ab33e730f674ad3a512c5bab6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ecea7cfbc593f61$var$_react = $8ecea7cfbc593f61$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8ecea7cfbc593f61$var$_iconNew = $8ecea7cfbc593f61$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8ecea7cfbc593f61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBrush".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/paint-brush
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ecea7cfbc593f61$var$PaintBrushIcon = (props)=>/*#__PURE__*/ $8ecea7cfbc593f61$var$_react.default.createElement($8ecea7cfbc593f61$var$_iconNew.default, Object.assign({
        name: "PaintBrushIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 .75.75V9a2 2 0 0 1-2 2H10v3a2 2 0 1 1-4 0v-3H4.5a2 2 0 0 1-2-2zM7.5 11v3a.5.5 0 0 0 1 0v-3zM4 1.5v5h8v-5h-1.5V4H9V1.5H7V3H5.5V1.5zM12 8H4v1a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 12 9z" clip-rule="evenodd"/>`
    }, props));
$8ecea7cfbc593f61$var$PaintBrushIcon.displayName = 'PaintBrushIcon';
var $8ecea7cfbc593f61$var$_default = module.exports.default = $8ecea7cfbc593f61$var$PaintBrushIcon;

});

parcelRegister("35D51", function(module, exports) {
$parcel$export(module.exports, "resolveMigrationManagementState", () => $d76e9dbe1465cc2b$export$71e43b572ead9b23);
const $d76e9dbe1465cc2b$var$legacyManagementState = (action, migratedHubAri = null)=>({
        action: action,
        migratedHubAri: migratedHubAri,
        shouldShowLegacyCard: true,
        shouldWarnBeforeLegacyEdit: false
    });
const $d76e9dbe1465cc2b$export$71e43b572ead9b23 = ({ migratedHubAri: migratedHubAri, state: state })=>{
    switch(state){
        case null:
        case 'NOT_STARTED':
            return $d76e9dbe1465cc2b$var$legacyManagementState('update');
        case 'IN_PROGRESS':
            return $d76e9dbe1465cc2b$var$legacyManagementState('resume');
        case 'FAILED':
            return $d76e9dbe1465cc2b$var$legacyManagementState('retry');
        case 'MIGRATED':
            return migratedHubAri ? {
                action: 'review',
                migratedHubAri: migratedHubAri,
                shouldShowLegacyCard: true,
                shouldWarnBeforeLegacyEdit: true
            } : $d76e9dbe1465cc2b$var$legacyManagementState('none');
        case 'PUBLISHED':
            return {
                action: 'none',
                migratedHubAri: null,
                shouldShowLegacyCard: false,
                shouldWarnBeforeLegacyEdit: false
            };
        case '%future added value':
        default:
            return $d76e9dbe1465cc2b$var$legacyManagementState('none');
    }
};

});

parcelRegister("bT4D5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7a2c5969dce78c1$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f7a2c5969dce78c1$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    migrationUpdating: {
        defaultMessage: 'Updating...',
        description: 'Status shown on a help center card while its update is in progress.',
        id: 'help.center.card.migration.updating'
    },
    migrationProgress: {
        defaultMessage: '75%',
        description: 'Fixed visible progress shown while a help center update is in progress.',
        id: 'help.center.card.migration.progress'
    },
    migrationProgressAccessibleLabel: {
        defaultMessage: 'Updating... 75%',
        description: 'Accessible determinate progress label for an in-progress help center update.',
        id: 'help.center.card.migration.progress.accessible-label'
    },
    resumeMigration: {
        defaultMessage: 'View fullscreen',
        description: 'Action that restores the fullscreen view for an in-progress help center update.',
        id: 'help.center.card.migration.resume'
    },
    migrationActions: {
        defaultMessage: 'Help center actions',
        description: 'Label for the help center actions button, unavailable while an update is in progress.',
        id: 'help.center.card.migration.actions'
    },
    migrationUpdatedOn: {
        defaultMessage: 'Last updated {date}',
        description: 'Last updated date on a help center card while its update is in progress.',
        id: 'help.center.card.migration.updated-on'
    },
    helpCenterGenericErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Generic description message for help center error',
        id: 'help.center.card.update.error.description.generic'
    },
    helpCenterErrorDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{value}',
        description: 'Description message for help center error',
        id: 'help.center.card.update.error.description'
    },
    helpCenterDeleteErrorTitleText: {
        defaultMessage: "We couldn\u2019t delete \u2018{value}\u2019",
        description: 'Title message for delete help center error',
        id: 'help.center.delete.error.title.text'
    },
    helpCenterDeleteErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Description message for delete help center error',
        id: 'help.center.delete.error.desc'
    },
    helpCenterDeleteSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 deleted",
        description: 'Delete help center success message',
        id: 'help.center.delete.success.title.text'
    },
    helpCenterUpdatedOn: {
        defaultMessage: 'Last updated: {date}',
        description: 'Label showing when the help center was last updated; {date} is the formatted date',
        id: 'help.center.updated.on.text'
    },
    helpCenterCustomizeButtonText: {
        defaultMessage: 'Customize look and feel',
        description: 'Help center customize button text',
        id: 'help.center.customize.button.text'
    },
    helpCenterUpdateButtonText: {
        defaultMessage: 'Update Help Center',
        description: 'Action that starts updating a legacy help center to a help hub',
        id: 'help.center.card.migration.update.button'
    },
    helpCenterReviewUpdateButtonText: {
        defaultMessage: 'Review update',
        description: 'Action that opens the updated help center draft for review',
        id: 'help.center.card.update.review.button'
    },
    helpCenterEditWarningTitle: {
        defaultMessage: 'Edit current help center?',
        description: 'Title warning that changes to the current help center will not sync to its draft',
        id: 'help.center.card.migration.edit.warning.title'
    },
    helpCenterEditWarningDescription: {
        defaultMessage: "Changes you make here won\u2019t sync to your new help center draft. We recommend reviewing and editing the draft instead.",
        description: 'Warning shown before editing a legacy help center that has a migrated draft',
        id: 'help.center.card.migration.edit.warning.description'
    },
    helpCenterEditWarningCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Action that cancels editing the current help center',
        id: 'help.center.card.migration.edit.warning.cancel'
    },
    helpCenterEditWarningGoToDraftButton: {
        defaultMessage: 'Go to draft',
        description: 'Action that opens the migrated help center draft',
        id: 'help.center.card.migration.edit.warning.go.to.draft'
    },
    helpCenterEditWarningEditAnywayButton: {
        defaultMessage: 'Edit anyway',
        description: 'Action that continues editing the current help center despite the warning',
        id: 'help.center.card.migration.edit.warning.edit.anyway'
    },
    helpHubCustomizeButtonText: {
        defaultMessage: 'Customize',
        description: 'Help center customize button text',
        id: 'help.hub.customize.button.text'
    },
    helpCenterSettingsButtonText: {
        defaultMessage: 'Settings',
        description: 'Help center settings button text',
        id: 'help.center.settings.button.text'
    },
    helpCenterDeleteButtonText: {
        defaultMessage: 'Delete',
        description: 'Help center delete button text',
        id: 'help.center.delete.button.text'
    },
    helpCenterDeleteDialogTitle: {
        defaultMessage: 'Delete help center?',
        description: 'Help center delete dialog title',
        id: 'help.center.delete.dialog.title'
    },
    helpCenterDeleteDialogDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: `\u{2018}{value}\u{2019}  and any customizations you applied to it will be permanently deleted. This cannot be undone.`,
        description: 'Help center delete dialog description',
        id: 'help.center.delete.dialog.desc'
    },
    helpCenterDeleteDialogDeleteButton: {
        defaultMessage: 'Delete',
        description: 'Help center delete dialog delete button text',
        id: 'help.center.delete.dialog.delete.button'
    },
    helpCenterDeleteDialogCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Help center delete dialog cancel button text',
        id: 'help.center.delete.dialog.cancel.button'
    },
    helpCenterDisabledDeleteButtonTooltip: {
        defaultMessage: `Your default help center can't be deleted.`,
        description: 'Help center disabled delete button tooltip text',
        id: 'help.center.disabled.delete.button.tooltip'
    },
    helpCenterDisabledMessagePopup: {
        defaultMessage: `You need to be on a Premium or Enterprise plan to access multiple help centers on your site.`,
        description: 'Help center disabled message to upgrade popup',
        id: 'help.center.disabled.message.popup'
    },
    defaultLozenge: {
        defaultMessage: 'Default',
        description: 'Lozenge for default help center',
        id: 'help.center.default.lozenge.message'
    },
    mappedProjectCount: {
        defaultMessage: '{count, plural, one {# linked project} other {# linked projects}}',
        description: 'Lozenge for mapped projects count',
        id: 'help.center.project.map.count'
    },
    mappedSpaceCountGalaxia: {
        defaultMessage: '{count, plural, one {# linked space} other {# linked spaces}}',
        description: 'Lozenge for mapped spaces count',
        id: 'help.center.project.map.count-galaxia'
    },
    mappedProjectCountAll: {
        defaultMessage: 'All projects linked',
        description: 'Lozenge indicating all projects are linked to the help center',
        id: 'help.center.project.map.all.count'
    },
    mappedSpaceCountAllGalaxia: {
        defaultMessage: 'All spaces linked',
        description: 'Lozenge indicating all spaces are linked to the help center',
        id: 'help.center.project.map.all.count-galaxia'
    },
    upgradeLozenge: {
        defaultMessage: 'Upgrade to access',
        description: 'Lozenge for upgrade to access help center',
        id: 'help.center.upgrade.lozenge.message'
    },
    helpCenterVirtualServiceAgentButtonText: {
        defaultMessage: 'Virtual service agent',
        description: 'Help center virtual service agent button text',
        id: 'help.center.virtual.service.agent.button.text'
    },
    changeBoardingDescription: {
        defaultMessage: 'Manage help center details, link and unlink your projects, and track virtual service agent performance from here.',
        description: 'Onboarding tooltip body text for the help center management card',
        id: 'help.center.card.change.boarding.description'
    },
    changeBoardingDescriptionGalaxia: {
        defaultMessage: 'Manage help center details, link and unlink your spaces, and track virtual service agent performance from here.',
        description: 'Onboarding tooltip body text for the help center card in Galaxia layout',
        id: 'help.center.card.change.boarding.description-galaxia'
    },
    changeBoardingTitle: {
        defaultMessage: 'Take charge of your help center',
        description: 'Heading text for the onboarding tooltip on the help center card',
        id: 'help.center.card.change.boarding.title'
    },
    changeBoardingButtonText: {
        defaultMessage: 'OK',
        description: 'Dismiss button label for the help center onboarding tooltip',
        id: 'help.center.card.change.boarding.button.description'
    }
});

});

parcelRegister("bGOCV", function(module, exports) {
$parcel$export(module.exports, "buildMigratedHelpCenterReviewUrl", () => $981173a73529ea9e$export$dabc9b07d93b119f);
/**
 * Builds the sandbox URL used for reviewing a migrated Help Center draft.
 *
 * Keep this shared by migration entry points. Multi-help-center routes use the
 * legacy help center slug as the review-route identifier. The default Help
 * Center has no slug and continues to use its legacy portals route.
 */ const $981173a73529ea9e$export$dabc9b07d93b119f = ({ baseUrl: baseUrl, slug: slug })=>new URL(slug ? `/helpcenter/test/${encodeURIComponent(slug)}` : '/servicedesk/customer/test/portals', baseUrl).toString();

});

parcelRegister("42iNA", function(module, exports) {
$parcel$export(module.exports, "DynamicThemingButton", () => (parcelRequire("caGfV")).default);

var $caGfV = parcelRequire("caGfV");

});
parcelRegister("caGfV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7ae6c0c491ce813$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $cMYsY = parcelRequire("cMYsY");

var $9BVpB = parcelRequire("9BVpB");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");
function $b7ae6c0c491ce813$var$DynamicThemingButton({ label: label, ariaLabel: ariaLabel, themeColor: themeColor, disabled: disabled, icon: icon, onClick: onClick, forwardedRef: forwardedRef, textColor: textColor, customStyles: customStyles = {}, ...customProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.default), {
        ...customProps,
        ref: forwardedRef,
        disabled: disabled,
        "aria-label": ariaLabel ? ariaLabel : label,
        as: "button",
        onClick: onClick,
        xcss: $b7ae6c0c491ce813$var$buttonStyles,
        style: {
            backgroundImage: `linear-gradient(
                to right,
                rgba(255, 255, 255, 0.8),
                rgba(255, 255, 255, 0.8)
            ),
            linear-gradient(to right, ${themeColor}, ${themeColor})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
        gap: "space.050",
        alignItems: "center"
    }, icon, textColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.default), {
        color: textColor,
        as: "span"
    }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.default), {
        as: "span"
    }, label)));
}
const $b7ae6c0c491ce813$var$buttonStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderRadius: 'radius.full',
    borderColor: 'color.border.inverse',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    color: 'color.text',
    cursor: 'pointer',
    height: '36px',
    '::after': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        bottom: 'space.0',
        left: 'space.0',
        borderRadius: 'radius.full',
        background: `${"var(--ds-interaction-hovered, rgba(9, 30, 66, 0.60))"}`,
        opacity: 0,
        pointerEvents: 'none'
    },
    ':hover::after': {
        opacity: 0.6,
        transition: 'opacity 200ms'
    },
    ':active': {
        transform: 'scale(0.97)',
        transition: 'transform 50ms'
    },
    ':disabled': {
        pointerEvents: 'none'
    }
});
const $b7ae6c0c491ce813$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
var $b7ae6c0c491ce813$export$2e2bcd8739ae039 = (0, $f2mlD.default)($b7ae6c0c491ce813$var$selector, {})($b7ae6c0c491ce813$var$DynamicThemingButton);

});


parcelRegister("8G6wP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f586b5df93aaad6f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f586b5df93aaad6f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    customizeBtnLabel: {
        defaultMessage: 'Customize',
        description: 'Button label for customize button beside avatar menu in header to open list of customization options in a popup',
        id: 'customize.menu.header.customizeBtnLabel'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in customize menu in request list screen',
        id: 'customize.menu.header.manage-column'
    },
    pageLayout: {
        defaultMessage: 'Edit page layout',
        description: 'Edit page layout item in customize drop-down menu',
        id: 'customize.menu.header.pageLayout'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.beta'
    },
    premium: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.premium'
    },
    topicsAndPortals: {
        defaultMessage: 'Manage topics and portals',
        description: 'Manage Topics and Portals item in customize drop-down menu when advanced customization enabled',
        id: 'customize.menu.header.topicsAndPortals'
    },
    look: {
        defaultMessage: 'Customize look and feel',
        description: 'Customize look and feel item in customize menu',
        id: 'customize.menu.header.look'
    },
    announcement: {
        defaultMessage: 'Manage announcements',
        description: 'Announcement item in customize menu',
        id: 'customize.menu.header.announcement'
    },
    logInMessage: {
        defaultMessage: 'Add login page message',
        description: 'Add login page message item in customize menu',
        id: 'customize.menu.header.logInMessage'
    },
    customizeAriaLabel: {
        defaultMessage: 'Customization options',
        description: 'Aria label for screen readers while opening customize pop up menu from customize button in header',
        id: 'customize.menu.header.customizeAriaLabel'
    },
    portalAnnouncement: {
        defaultMessage: 'Manage announcements',
        description: 'Manage announcement item in customize menu in portal screen',
        id: 'customize.menu.header.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Organize portal groups',
        description: 'Organize portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.requestTypeGroup'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.description'
    },
    pageLayoutTryButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.try.button'
    },
    configurePortal: {
        defaultMessage: 'Configure portal',
        description: 'Configure portal item in customize menu for portal screen',
        id: 'customize.menu.header.configurePortal'
    },
    customizeRequestTypes: {
        defaultMessage: 'Customize request types',
        description: 'Customize request types item in customize menu for portal screen',
        id: 'customize.menu.header.customizeRequestTypes'
    },
    managePortalGroups: {
        defaultMessage: 'Manage portal groups',
        description: 'Manage portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.managePortalGroups'
    }
});

});





parcelRegister("a4I38", function(module, exports) {
$parcel$export(module.exports, "VirtualServiceAgentHeader", () => (parcelRequire("3NVdr")).default);

var $3NVdr = parcelRequire("3NVdr");

});
parcelRegister("3NVdr", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd632199de6bd8c$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("7bFih");
var $lEZQu = parcelRequire("lEZQu");
parcelRequire("c96vD");
var $cZYNB = parcelRequire("cZYNB");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("nR7qC");
var $3R7iu = parcelRequire("3R7iu");
parcelRequire("2CB4z");
var $207Yr = parcelRequire("207Yr");
const $7dd632199de6bd8c$var$selector = (0, $BOq7h.createSelector)((state, { portalId: portalId })=>{
    const isJiraAdmin = Boolean((0, $fBLyB.getCanAdministerJIRA)(state));
    const projectId = portalId && (0, $iWhHo.getProjectId)(state, (0, $3R7iu.getPortalIdAsNumber)(portalId));
    const isChatSideBarOpen = (0, $cZYNB.isChatSideBarOpen)(state);
    const isProjectAdmin = (0, $iWhHo.getCanAdministerProject)(state, (0, $3R7iu.getPortalIdAsNumber)(portalId));
    return {
        isJiraAdmin: isJiraAdmin,
        projectId: projectId,
        isChatSideBarOpen: isChatSideBarOpen,
        isProjectAdmin: isProjectAdmin
    };
}, ({ isJiraAdmin: isJiraAdmin, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, isProjectAdmin: isProjectAdmin })=>({
        isJiraAdmin: isJiraAdmin,
        projectId: projectId,
        isChatSideBarOpen: isChatSideBarOpen,
        isProjectAdmin: isProjectAdmin
    }));
const $7dd632199de6bd8c$var$mapDispatchToProps = {
    openChatSideBar: $lEZQu.openChatSideBar,
    closeChatSideBar: $lEZQu.closeChatSideBar
};
var $7dd632199de6bd8c$export$2e2bcd8739ae039 = (0, $f2mlD.default)($7dd632199de6bd8c$var$selector, $7dd632199de6bd8c$var$mapDispatchToProps)((0, $207Yr.default));

});
parcelRegister("c96vD", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => (parcelRequire("cZYNB")).isChatSideBarOpen);

var $cZYNB = parcelRequire("cZYNB");

});
parcelRegister("cZYNB", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => $283d5c592243f395$export$d16875019bc5532b);
const $283d5c592243f395$export$d16875019bc5532b = (state)=>state.ui.chatDetails.isChatSideBarOpen;

});


parcelRegister("2CB4z", function(module, exports) {
$parcel$export(module.exports, "VirtualServiceAgentHeaderDumb", () => (parcelRequire("207Yr")).default);

var $207Yr = parcelRequire("207Yr");

});
parcelRegister("207Yr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6eb4889b9469f41d$export$2e2bcd8739ae039);

var $9ZIfX = parcelRequire("9ZIfX");

var $eM7wq = parcelRequire("eM7wq");

var $bSJIT = parcelRequire("bSJIT");

var $7j7Eh = parcelRequire("7j7Eh");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
var $h1bGI = parcelRequire("h1bGI");

var $6WltM = parcelRequire("6WltM");

var $2fT5e = parcelRequire("2fT5e");

var $clpci = parcelRequire("clpci");

var $kxIlX = parcelRequire("kxIlX");

var $9P2Zq = parcelRequire("9P2Zq");

var $iydAA = parcelRequire("iydAA");

var $eDcdn = parcelRequire("eDcdn");

var $ikzcz = parcelRequire("ikzcz");
parcelRequire("42iNA");
var $caGfV = parcelRequire("caGfV");

var $1eDpr = parcelRequire("1eDpr");
const $6eb4889b9469f41d$var$VirtualServiceAgentButton = ({ onClick: onClick, label: label, isChatSideBarOpen: isChatSideBarOpen })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: (0, $jcRK7.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $clpci.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $caGfV.default), {
        customStyles: isChatSideBarOpen ? {
            borderColor: "var(--ds-border-focused, #0C66E4)",
            borderWidth: "var(--ds-border-width, 1px)",
            color: "var(--ds-text-accent-blue, #0C66E4)" // this is for the icon color
        } : {},
        label: label,
        textColor: isChatSideBarOpen ? 'color.text.accent.blue' : undefined,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2fT5e))), {
            label: formatMessage((0, $1eDpr.default).virtualServiceAgent)
        }),
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
};
const $6eb4889b9469f41d$var$VirtualServiceAgentHeaderForPortal = ({ cloudId: cloudId, portalId: portalId, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBar, closeChatSideBar: closeChatSideBar, isProjectAdmin: isProjectAdmin })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [{ route: route }] = (0, $h1bGI.useRouter)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $ikzcz.useVirtualAgentAvailability)({
        cloudId: cloudId,
        projectId: projectId,
        isLoggedIn: true // this component has a check to only show for logged in users
    });
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $clpci.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentChatButton',
            attributes: {
                source: 'portal'
            }
        }).fire();
        if ((0, $lFpPv.isVsaAdoptionPortalChatSideBarEnabled)() && route.name === 'portal-home' && !isProjectAdmin) {
            if (isChatSideBarOpen) closeChatSideBar === null || closeChatSideBar === void 0 || closeChatSideBar();
            else openChatSideBar === null || openChatSideBar === void 0 || openChatSideBar();
        } else (0, $eDcdn.default).push(`/portal/${portalId}/conversation`);
    };
    if (isVirtualAgentAvailableForProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: (0, $jcRK7.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $clpci.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6eb4889b9469f41d$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $1eDpr.default).chat),
        isChatSideBarOpen: isChatSideBarOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
    return null;
};
const $6eb4889b9469f41d$var$VirtualServiceAgentHeaderForHelpCenter = ({ cloudId: cloudId })=>{
    var _virtualAgentEnabledD, _virtualAgentEnabledD2;
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const virtualAgentEnabledData = (0, $a2qIF.useLazyLoadQuery)((0, $eM7wq.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const isVirtualAgentEnabled = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD = virtualAgentEnabledData.helpCenter) === null || _virtualAgentEnabledD === void 0 || (_virtualAgentEnabledD = _virtualAgentEnabledD.helpCenterById) === null || _virtualAgentEnabledD === void 0 ? void 0 : _virtualAgentEnabledD.__typename) === 'HelpCenter' && virtualAgentEnabledData.helpCenter.helpCenterById.virtualAgentEnabled;
    const isVirtualAgentAvailable = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD2 = virtualAgentEnabledData.virtualAgent) === null || _virtualAgentEnabledD2 === void 0 ? void 0 : _virtualAgentEnabledD2.virtualAgentAvailability) ?? false;
    const isHelpSeekerWithVSAEnabled = isVirtualAgentAvailable && isVirtualAgentEnabled;
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $clpci.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentChatButton',
            attributes: {
                source: 'help-center'
            }
        }).fire();
        (0, $eDcdn.default).push(`/conversation`);
    };
    if (isHelpSeekerWithVSAEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: (0, $jcRK7.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $clpci.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6eb4889b9469f41d$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $1eDpr.default).chat)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
    return null;
};
const $6eb4889b9469f41d$var$VirtualServiceAgentHeaderForAdmin = ({ cloudId: cloudId, isJiraAdmin: isJiraAdmin })=>{
    var _virtualAgentEnabledD3;
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const virtualAgentEnabledData = (0, $a2qIF.useLazyLoadQuery)((0, $9ZIfX.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const isVirtualAgentEnabled = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD3 = virtualAgentEnabledData.helpCenter) === null || _virtualAgentEnabledD3 === void 0 || (_virtualAgentEnabledD3 = _virtualAgentEnabledD3.helpCenterById) === null || _virtualAgentEnabledD3 === void 0 ? void 0 : _virtualAgentEnabledD3.__typename) === 'HelpCenter' && virtualAgentEnabledData.helpCenter.helpCenterById.virtualAgentEnabled;
    const adminWithoutVSAEnabled = isJiraAdmin && !isVirtualAgentEnabled && (0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $clpci.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentButton',
            attributes: {
                source: 'admin'
            }
        }).fire();
        const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse(helpCenterAri);
        window.location.href = `${window.location.origin}${0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH}/${helpCenterId}/virtual-agent`;
    };
    if (adminWithoutVSAEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: (0, $jcRK7.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $clpci.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6eb4889b9469f41d$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $1eDpr.default).virtualServiceAgent)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
    return null;
};
const $6eb4889b9469f41d$var$VirtualServiceAgentHeaderDumbWrapper = ({ isJiraAdmin: isJiraAdmin, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBar, closeChatSideBar: closeChatSideBar, isProjectAdmin: isProjectAdmin })=>{
    const cloudId = (0, $fuVmc.getCloudId)();
    const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
    if ((0, $lFpPv.isHideVsaEndpointsEnabled)()) return null;
    if (isJiraAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6eb4889b9469f41d$var$VirtualServiceAgentHeaderForAdmin, {
        cloudId: cloudId,
        isJiraAdmin: true
    });
    // at this point all the users are help seekers and are logged in
    // we have no special checks for project admins, they continue to see the button in the header just like help seekers would
    if (portalId) {
        // this is different that portalId && projectId because we don't want to render the
        // button for a help seeker in portal if projectId is not present
        // if we do && it would get into the the help center header
        // we want it to explicitly render null if projectId is not present but portalId is present
        // better to not render anything in this case than to render the button that redirects to the help center conversation page
        if (projectId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6eb4889b9469f41d$var$VirtualServiceAgentHeaderForPortal, {
            cloudId: cloudId,
            portalId: portalId,
            projectId: projectId,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBar,
            closeChatSideBar: closeChatSideBar,
            isProjectAdmin: isProjectAdmin
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6eb4889b9469f41d$var$VirtualServiceAgentHeaderForHelpCenter, {
        cloudId: cloudId
    });
};
var $6eb4889b9469f41d$export$2e2bcd8739ae039 = $6eb4889b9469f41d$var$VirtualServiceAgentHeaderDumbWrapper;

});
parcelRegister("9ZIfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5e76a9a03e0803c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c90bbc512e8be1204d2829ae63d46af6>>
 * @relayHash c5303cbd99f5030deeec59f886b004b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8306c73b12cbb2fd42063f0cdc6ebda1c4dc6066b8a39cfe989704e07c87159a
const $b5e76a9a03e0803c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8306c73b12cbb2fd42063f0cdc6ebda1c4dc6066b8a39cfe989704e07c87159a",
            "metadata": {},
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b5e76a9a03e0803c$var$node.hash = "df656a96c8dae6a7e885b60eda19f0f6";
var $b5e76a9a03e0803c$export$2e2bcd8739ae039 = $b5e76a9a03e0803c$var$node;

});

parcelRegister("eM7wq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3622748a881ee5df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bba8f04573f8cc2476ac20fe7544388b>>
 * @relayHash 75458db796a70398a51779635b8c2433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e
const $3622748a881ee5df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "containerId",
                        "variableName": "helpCenterAri"
                    }
                ],
                "kind": "ScalarField",
                "name": "virtualAgentAvailability"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e",
            "metadata": {},
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3622748a881ee5df$var$node.hash = "e1e97ac63a001c8e98b3e9b2c21c9fc4";
var $3622748a881ee5df$export$2e2bcd8739ae039 = $3622748a881ee5df$var$node;

});

parcelRegister("kxIlX", function(module, exports) {
$parcel$export(module.exports, "ContextWrapper", () => $a6e0e745680a3dd9$export$34282a1f95511a11);

var $bSJIT = parcelRequire("bSJIT");

var $lgNi9 = parcelRequire("lgNi9");

var $eu1ij = parcelRequire("eu1ij");

var $dwOcU = parcelRequire("dwOcU");
const $a6e0e745680a3dd9$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eu1ij)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lgNi9))));
};
const $a6e0e745680a3dd9$export$34282a1f95511a11 = (props)=>{
    const data = $a6e0e745680a3dd9$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, props.children));
};

});

parcelRegister("1eDpr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6063b8a0c9a4649$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a6063b8a0c9a4649$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'Text message for virtual service agent header button',
        id: 'virtual-service-agent-header.virtual-service-agent.title'
    },
    chat: {
        defaultMessage: 'Chat',
        description: 'Text message for chat header button',
        id: 'virtual-service-agent-header.chat.title'
    }
});

});





parcelRegister("lxMCu", function(module, exports) {
$parcel$export(module.exports, "default", () => $22aa2eb251d98413$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $22aa2eb251d98413$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    login: {
        defaultMessage: 'Log in',
        description: 'Text message for header in Customer Portal when a user is not logged in',
        id: 'cv.login.title'
    },
    helpCenter: {
        defaultMessage: 'Help Center',
        description: 'Text message for header in Customer Portal when a user is logged in',
        id: 'cv.help.center.title'
    }
});

});





parcelRegister("7wH5B", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => (parcelRequire("30arO")).default);

var $30arO = parcelRequire("30arO");

});
parcelRegister("30arO", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc931234f4d6d184$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $iCbt2 = parcelRequire("iCbt2");

var $3kyZk = parcelRequire("3kyZk");

var $2fYPj = parcelRequire("2fYPj");

var $jSu8y = parcelRequire("jSu8y");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $fPPtU = parcelRequire("fPPtU");
const $fc931234f4d6d184$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getHelpCenterBrandingLoader), (0, $fBLyB.isUserLoaded), (isBrandingLoaded, userLoaded)=>({
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded
    }));
var $fc931234f4d6d184$export$2e2bcd8739ae039 = (0, $f2mlD.default)($fc931234f4d6d184$var$selector, {
    fetchBranding: (0, $3kyZk.fetchHelpCenterBrandingAction),
    fetchUser: (0, $iCbt2.fetchUserModelAction),
    fetchOrganisations: (0, $2fYPj.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $jSu8y.fetchUserRequestsCountsAction)
})((0, $fPPtU.PrefetchBrandingModel));

});
parcelRegister("fPPtU", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => $08c59b492a142af3$export$f08bae07abcc5a9d);

var $bSJIT = parcelRequire("bSJIT");

var $hCnLH = parcelRequire("hCnLH");
class $08c59b492a142af3$export$f08bae07abcc5a9d extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        if (!(0, $hCnLH.isHelpCentersManagement)() && !this.props.isBrandingLoaded) this.props.fetchBranding();
        if (!this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchOrganisations();
            this.props.fetchUserRequestsCounts();
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        return null;
    }
}

});





parcelRegister("gUWC1", function(module, exports) {
$parcel$export(module.exports, "AnnouncementBanner", () => (parcelRequire("jc09K")).default);

var $jc09K = parcelRequire("jc09K");

});
parcelRegister("jc09K", function(module, exports) {
$parcel$export(module.exports, "default", () => $486dd15320cd8305$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $cwcdv = parcelRequire("cwcdv");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("cAJ8B");
var $aquFW = parcelRequire("aquFW");

var $87QgR = parcelRequire("87QgR");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $1qPbZ = parcelRequire("1qPbZ");

var $jr0Z4 = parcelRequire("jr0Z4");
const $486dd15320cd8305$var$Announcement = ({ announcement: announcement, hasTopBarBeenSplit: hasTopBarBeenSplit, isPortalLoaded: isPortalLoaded, appearance: contentAppearance })=>{
    const [{ route: route }] = (0, $h1bGI.useRouter)();
    const { name: name } = route;
    const whiteListedRouteNames = [
        'portal-home',
        'request-create'
    ];
    const AnnouncementInnerContainerDeprecated = /*#__PURE__*/ (0, $bSJIT.memo)(({ children: children })=>{
        const hide = contentAppearance === 'none';
        const appearance = contentAppearance || 'normal';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jr0Z4.GridContentWrapper), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($486dd15320cd8305$var$PaperInnerContainer, {
            "data-testid": "paper-inner-container"
        }, children));
    });
    AnnouncementInnerContainerDeprecated.displayName = 'AnnouncementInnerContainer';
    const AnnouncementInnerContainer = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        const Component = ({ children: children })=>{
            const hide = contentAppearance === 'none';
            const appearance = contentAppearance || 'normal';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jr0Z4.GridContentWrapper), {
                appearance: appearance,
                hide: hide
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($486dd15320cd8305$var$PaperInnerContainer, {
                "data-testid": "paper-inner-container"
            }, children));
        };
        Component.displayName = 'AnnouncementInnerContainer';
        return Component;
    }, [
        contentAppearance
    ]);
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $486dd15320cd8305$var$announcementContainer,
        testId: 'increased-flexibility-container'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cwcdv.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $87QgR.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cwcdv.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $87QgR.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    }));
};
const $486dd15320cd8305$var$selector = (0, $BOq7h.createSelector)((state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    const portal = (0, $iWhHo.getPortal)(state, portalId);
    const announcement = (0, $iWhHo.getPortalAnnouncement)(state, portalId);
    return {
        announcement: announcement,
        isPortalLoaded: Boolean(portal)
    };
}, (0, $hvIQS.getHelpCenterTopBarSplitFlag), ({ announcement: announcement, isPortalLoaded: isPortalLoaded }, hasTopBarBeenSplit)=>{
    return {
        announcement: announcement,
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        isPortalLoaded: isPortalLoaded
    };
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $486dd15320cd8305$var$PaperInnerContainer = /*#__PURE__*/ (0, $4v2A7.default)((0, $aquFW.PaperContent)).withConfig({
    componentId: "sc-117mmoe-0"
})({
    paddingTop: 0
});
const $486dd15320cd8305$var$announcementContainer = (0, $9BVpB.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.400',
    marginRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    // make sure extra margin is not added in case announcement is not present
    ':empty': {
        display: 'none'
    }
});
var $486dd15320cd8305$export$2e2bcd8739ae039 = (0, $f2mlD.default)($486dd15320cd8305$var$selector)($486dd15320cd8305$var$Announcement);

});
parcelRegister("cwcdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c55af8bc9c76b75$export$2e2bcd8739ae039);

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $aI9Vk = parcelRequire("aI9Vk");
var $3c55af8bc9c76b75$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'banner'
})((0, $kIbto.default)()((0, $aI9Vk.default)));

});
parcelRegister("aI9Vk", function(module, exports) {
$parcel$export(module.exports, "default", () => $399b679f8779936e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $9K7mZ = parcelRequire("9K7mZ");

var $haAAx = parcelRequire("haAAx");

var $gV613 = parcelRequire("gV613");

var $byIFS = parcelRequire("byIFS");
/**
 * This is used for the clamping logic inside the announcement.
 * It is VERY brittle and WILL break if you change font-size/line-height
 * inside the announcement. Watch out!
 */ const $399b679f8779936e$var$SINGLE_LINE_TITLE_HEIGHT = 23;
/**
 * This component will have big problems if/when we do SSR. Be careful out there.
 */ class $399b679f8779936e$var$AnnouncementBanner extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        InnerContainerComponent: $bSJIT.Fragment
    };
    componentDidMount() {
        // On mount we will calculate the height of the header/message and set isExpandable accordingly.
        // This will only be set once (on mount) - if we eventually want to dynamically update this we
        // will want to implement a componentDidUpdate() method, check if header/message changed, and
        // recalculate.
        this.calculateIfExpandable();
    }
    fireAnalytics(action) {
        const { createAnalyticsEvent: createAnalyticsEvent, actionSubjectId: actionSubjectId } = this.props;
        const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
        if (createAnalyticsEvent) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubjectId: actionSubjectId,
                action: action,
                analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                attributes: {
                    messageCharCount: messageCharCount,
                    titleCharCount: headerCharCount
                }
            });
            analyticsEvent.fire();
        }
    }
    calculateIfExpandable() {
        let isExpandable = false;
        // If advanced customization is enabled and the layout is in edit mode, the banner should not be expandable.
        if (this.props.isLayoutInEditMode) {
            this.setState({
                isExpandable: false,
                isExpanded: true
            });
            return;
        }
        if (this.headerRef || this.messageRef) {
            const headerHeight = this.headerRef && (0, $gV613.getBoundingBox)(this.headerRef).height || 0;
            const messageHeight = this.messageRef && (0, $gV613.getBoundingBox)(this.messageRef).height || 0;
            const headerOverOneLine = headerHeight > $399b679f8779936e$var$SINGLE_LINE_TITLE_HEIGHT;
            const messageOverOneLine = messageHeight > (0, $9K7mZ.SINGLE_LINE_PARAGRAPH_HEIGHT);
            isExpandable = headerOverOneLine || messageOverOneLine;
        }
        // The announcement banner is expanded by default.
        this.setState({
            isExpandable: isExpandable,
            isExpanded: true
        });
    }
    render() {
        const { header: header, messageHtml: messageHtml, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isLayoutInEditMode: isLayoutInEditMode, isLayoutInPreviewMode: isLayoutInPreviewMode, removePadding: removePadding } = this.props;
        const { isExpanded: isExpanded, isExpandable: isExpandable } = this.state;
        return /*#__PURE__*/ $bSJIT.createElement((0, $byIFS.default), {
            header: header,
            isExpanded: isExpanded,
            isExpandable: isExpandable,
            messageHtml: messageHtml,
            onHeaderRef: this.onHeaderRef,
            onMessageRef: this.onMessageRef,
            expandBanner: this.expandBanner,
            shrinkBanner: this.collapseBanner,
            InnerContainerComponent: InnerContainerComponent,
            removeBgColor: removeBgColor,
            isCursorGrab: isLayoutInEditMode && isLayoutInPreviewMode === false,
            removePadding: removePadding
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // We expand the announcement banner initially so we can calculate if it is expandable or not on mount.
            isExpanded: true,
            isExpandable: false
        }, this.onHeaderRef = (refNode)=>{
            this.headerRef = refNode;
            this.calculateIfExpandable();
        }, this.onMessageRef = (refNode)=>{
            this.messageRef = refNode;
            this.calculateIfExpandable();
        }, this.expandBanner = ()=>{
            const { onExpandClicked: onExpandClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onExpandClicked && onExpandClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('expanded');
            this.setState({
                isExpanded: true
            });
        }, this.collapseBanner = ()=>{
            const { onCollapseClicked: onCollapseClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onCollapseClicked && onCollapseClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('collapsed');
            this.setState({
                isExpanded: false
            });
        }, /**
   * This will return char counts for the header and message. It uses inner text so it can ignore
   * HTML markup in the calculation.
   */ this.getAnnouncementCharCounts = ()=>{
            const headerCharCount = this.headerRef && this.headerRef.innerText ? this.headerRef.innerText.length : undefined;
            const messageCharCount = this.messageRef && this.messageRef.innerText ? this.messageRef.innerText.length : undefined;
            return {
                headerCharCount: headerCharCount,
                messageCharCount: messageCharCount
            };
        };
    }
}
var $399b679f8779936e$export$2e2bcd8739ae039 = $399b679f8779936e$var$AnnouncementBanner;

});
parcelRegister("gV613", function(module, exports) {
$parcel$export(module.exports, "getBoundingBox", () => $6a849edaab101922$export$895c5e634403eaa7);
$parcel$export(module.exports, "getElementHeight", () => $6a849edaab101922$export$8e0f1520ce23a388);
$parcel$export(module.exports, "blur", () => $6a849edaab101922$export$2cc7ff91bcacba5e);
$parcel$export(module.exports, "focus", () => $6a849edaab101922$export$d7ddd398f22d79ef);
const $6a849edaab101922$export$895c5e634403eaa7 = (element)=>element.getBoundingClientRect();
const $6a849edaab101922$export$8e0f1520ce23a388 = (element)=>element.clientHeight;
function $6a849edaab101922$export$2cc7ff91bcacba5e(id) {
    const element = document.getElementById(id);
    if (element) element.blur();
}
function $6a849edaab101922$export$d7ddd398f22d79ef(id) {
    const element = document.getElementById(id);
    if (element) element.focus();
}

});

parcelRegister("byIFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $46441805c8ad59c6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $jOwH0 = parcelRequire("jOwH0");

var $ki6Qt = parcelRequire("ki6Qt");

var $98sDU = parcelRequire("98sDU");

var $fU62V = parcelRequire("fU62V");

var $9Yqiu = parcelRequire("9Yqiu");

var $fK3tS = parcelRequire("fK3tS");

var $4GWyU = parcelRequire("4GWyU");

var $8yxPv = parcelRequire("8yxPv");

var $jmS2o = parcelRequire("jmS2o");
class $46441805c8ad59c6$export$76695f5f5a9db4b2 extends $bSJIT.Component {
    renderChevrons() {
        const { isExpandable: isExpandable, isExpanded: isExpanded, intl: intl } = this.props;
        if (isExpandable) return /*#__PURE__*/ $bSJIT.createElement($46441805c8ad59c6$export$281662cd1c27e560, {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-controls": "announcement-message",
            "aria-label": intl.formatMessage((0, $jmS2o.default).view),
            onClick: this.handleClick,
            "data-testid": "view-announcement-btn"
        }, isExpanded ? /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8yxPv))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronUpIcon",
            label: ""
        }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronDownIcon",
            label: ""
        }));
        return null;
    }
    render() {
        const { isExpanded: isExpanded, header: header, messageHtml: messageHtml, onMessageRef: onMessageRef, onHeaderRef: onHeaderRef, className: className, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isCursorGrab: isCursorGrab, removePadding: removePadding } = this.props;
        const rootProps = {
            role: 'region',
            'aria-labelledby': 'announcement-header',
            skipFocus: true
        };
        if (!!header || !!messageHtml) return /*#__PURE__*/ $bSJIT.createElement($46441805c8ad59c6$export$be92b6f5f03c0fe9, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            removeBgColor: removeBgColor,
            isExpanded: isExpanded,
            isCursorGrab: isCursorGrab,
            ...rootProps
        }, /*#__PURE__*/ $bSJIT.createElement(InnerContainerComponent, null, /*#__PURE__*/ $bSJIT.createElement($46441805c8ad59c6$var$Container, {
            removePadding: removePadding
        }, /*#__PURE__*/ $bSJIT.createElement($46441805c8ad59c6$export$758c5636f09cf302, {
            onClick: this.stopPropagationForLinks,
            onKeyDown: this.stopPropagationForLinks
        }, header && /*#__PURE__*/ $bSJIT.createElement($46441805c8ad59c6$export$95911024f008ea42, {
            id: "announcement-header",
            "data-testid": "announcement-banner-header",
            innerRef: onHeaderRef,
            isExpanded: isExpanded
        }, header), messageHtml && /*#__PURE__*/ $bSJIT.createElement($46441805c8ad59c6$export$f69c19e57285b83a, {
            id: "announcement-message",
            innerRef: onMessageRef,
            isExpanded: isExpanded,
            dangerouslySetInnerHTML: {
                __html: messageHtml
            }
        })), this.renderChevrons())));
        return null;
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { isExpanded: isExpanded, shrinkBanner: shrinkBanner, expandBanner: expandBanner } = this.props;
            isExpanded ? shrinkBanner() : expandBanner();
        }, /**
   * This will stop propagation for any anchor element clicked or key pressed.
   * If we see a need for this elsewhere - this could be a good generic component with minimal lines
   * of code.
   */ this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') e.stopPropagation();
        };
    }
}
var $46441805c8ad59c6$export$2e2bcd8739ae039 = (0, $fK3tS.default)($46441805c8ad59c6$export$76695f5f5a9db4b2);
/**
 * Watch out! Changing anything that will affect height (fontsize, padding, etc) in here will
 * break the clamping logic inside announcement-banner.tsx (look for SINGLE_LINE_TITLE_HEIGHT).
 * If you change anything here make sure it still works!
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $46441805c8ad59c6$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-sxf8hv-0"
})`display:flex;justify-content:space-between;padding-top:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};padding-bottom:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};`;
const $46441805c8ad59c6$export$f2e4196c0d2b5bb8 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-sxf8hv-1"
})`flex-shrink:0;${$ki6Qt.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut},${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};border-radius:50%;}`;
const $46441805c8ad59c6$export$281662cd1c27e560 = /*#__PURE__*/ (0, $4v2A7.default).button.withConfig({
    componentId: "sc-sxf8hv-2"
})`flex-shrink:0;border:none;background:transparent;align-self:flex-start;cursor:pointer;${$ki6Qt.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut},${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};border-radius:50%;}&:focus-visible,&:hover{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $46441805c8ad59c6$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $4v2A7.default)((0, $jOwH0.default)).withConfig({
    componentId: "sc-sxf8hv-3"
})`${$fU62V.borderRadius};${(props)=>$fU62V.applyIf(!props.removeBgColor, $fU62V.subtleThemeColorBackground)};${$98sDU.regular};display:block;width:100%;text-align:left;transition:color ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};color:${"var(--ds-text, #172B4D)"};box-sizing:border-box;overflow:hidden;&:focus-visible,&:hover ${$46441805c8ad59c6$export$f2e4196c0d2b5bb8}{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $46441805c8ad59c6$export$95911024f008ea42 = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-sxf8hv-4"
})`${$98sDU.medium};${(props)=>$fU62V.applyIf(!props.isExpanded, $fU62V.clamp)};margin-top:0;margin-bottom:${"var(--ds-space-100, 8px)"};font-weight:600;`;
const $46441805c8ad59c6$export$f69c19e57285b83a = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-sxf8hv-5"
})`${(props)=>$fU62V.applyIf(!props.isExpanded, $fU62V.multiLineClamp(1))}`;
const $46441805c8ad59c6$export$758c5636f09cf302 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-sxf8hv-6"
})`display:flex;flex-direction:column;width:100%;overflow:hidden;flex-shrink:0;`;

});
parcelRegister("jOwH0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ac47782e2c2c560$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $89wV5 = parcelRequire("89wV5");
class $0ac47782e2c2c560$export$2e2bcd8739ae039 extends $bSJIT.Component {
    render() {
        const { children: children, disabled: disabled, isExpanded: isExpanded, isCursorGrab: isCursorGrab, role: role, skipFocus: skipFocus, className: className = '' } = this.props;
        const skipFocusStyle = skipFocus ? ' no-focus' : '';
        const fakeBtnClassName = className + skipFocusStyle;
        return /*#__PURE__*/ $bSJIT.createElement((0, $89wV5.default), {
            "data-testid": "fake-button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: fakeBtnClassName,
            role: role || 'button',
            tabIndex: disabled || skipFocus ? -1 : 0,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            "aria-disabled": disabled,
            "aria-hidden": disabled,
            "aria-expanded": isExpanded ? true : false,
            isCursorGrab: isCursorGrab
        }, children);
    }
    constructor(...args){
        super(...args), this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') {
                e.stopPropagation();
                return true;
            }
            return false;
        }, this.handleKeyDown = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === 'Enter') onClick && onClick(e);
            else if (e.key === ' ') // Prevent default so scrolling doesn't happen when we press spacebar.
            e.preventDefault();
        }, this.handleClick = (e)=>{
            if (this.stopPropagationForLinks(e)) return;
            this.props.onClick && this.props.onClick(e);
        }, this.handleKeyUp = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === ' ') onClick && onClick(e);
        };
    }
}

});
parcelRegister("89wV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f669cd4e512b985$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $fU62V = parcelRequire("fU62V");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f669cd4e512b985$var$FakeButtonContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1kveg5f-0"
})`${$fU62V.focusRing.default};display:inline-block;${(props)=>props.skipFocus ? 'cursor: default' : 'cursor: pointer'};&.no-focus,&[aria-disabled='true']{${$fU62V.focusRing.none};${(props)=>props.isCursorGrab ? 'cursor: grab' : 'cursor: default'};}`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$4f669cd4e512b985$export$2e2bcd8739ae039 = $4f669cd4e512b985$var$FakeButtonContainer;

});


parcelRegister("jmS2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $94ea5c7e3c0551e7$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $94ea5c7e3c0551e7$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    expand: {
        defaultMessage: 'Expand announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.expand'
    },
    shrink: {
        defaultMessage: 'Shrink announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.shrink'
    },
    view: {
        defaultMessage: 'View announcement',
        description: 'Label for viewing the announcement.',
        id: 'sd.common.announcement.view'
    }
});

});




parcelRegister("jr0Z4", function(module, exports) {
$parcel$export(module.exports, "SkipToMainContent", () => $abb060b32468ba71$export$5a2051bae734c99d);
$parcel$export(module.exports, "GridContentWrapper", () => $abb060b32468ba71$export$2e1fb94eeb76eca0);
$parcel$export(module.exports, "default", () => $abb060b32468ba71$export$2e2bcd8739ae039);
/* grid-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $gUpf2 = parcelRequire("gUpf2");

var $jnInZ = parcelRequire("jnInZ");

var $9BVpB = parcelRequire("9BVpB");
parcelRequire("1rVud");
var $3aqSY = parcelRequire("3aqSY");

var $aquFW = parcelRequire("aquFW");

var $czPjg = parcelRequire("czPjg");
const $abb060b32468ba71$export$5a2051bae734c99d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3aqSY.MainContentSkipLinkWrapper), null, (0, $gdUUy.fg)('do_not_use_banner_colour_for_hyperlinks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "skip-to-main-content",
        xcss: $abb060b32468ba71$var$mainContentSkipLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_43ds1ohs _oxk41ohs"
        ])
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "skip-to-main-content",
        xcss: $abb060b32468ba71$var$mainContentSkipLinkStyles
    }, children));
const $abb060b32468ba71$export$2e1fb94eeb76eca0 = ({ children: children, appearance: appearance, hide: hide })=>{
    const gridWidth = (0, $czPjg.getContentWidth)(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "grid-content-wrapper",
        xcss: $abb060b32468ba71$var$staticWrapperStyles,
        style: {
            maxWidth: hide ? '100%' : gridWidth
        }
    }, children);
};
const $abb060b32468ba71$var$GridContainer = ({ children: children, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent, appearance: contentAppearance })=>{
    const hide = contentAppearance === 'none';
    const appearance = contentAppearance || 'normal';
    if (appearance === 'note') {
        const noteContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aquFW.NoteContent), {
            appearance: appearance,
            hide: hide,
            "data-testid": "note-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aquFW.NoteBackground), {
            "data-testid": "note-background"
        }, children));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $abb060b32468ba71$var$noteContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $abb060b32468ba71$var$noteColumnStyles
        }, noteContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $abb060b32468ba71$var$footerAtBottomStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aquFW.StyledFooter), null))));
    }
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aquFW.StyledFooter), {
        isCSM: isCSM
    });
    // A11Y-29321: footer rendered as a sibling of the `<main>` landmark (outside it), pinned to the bottom.
    const mainAndFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $abb060b32468ba71$var$mainColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($abb060b32468ba71$export$5a2051bae734c99d, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $abb060b32468ba71$var$footerAtBottomStyles
    }, footer));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "section",
        xcss: $abb060b32468ba71$var$sectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($abb060b32468ba71$export$2e1fb94eeb76eca0, {
        appearance: appearance,
        hide: hide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        xcss: $abb060b32468ba71$var$gridContainerStyles,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        xcss: $abb060b32468ba71$var$gridItemStyles
    }, hideSkipToMainContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children, footer) : mainAndFooter))));
};
const $abb060b32468ba71$var$wrapperStyles = null;
const $abb060b32468ba71$var$sectionStyles = (0, $9BVpB.xcss)({
    flex: 1
});
const $abb060b32468ba71$var$staticWrapperStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    margin: '0 auto'
});
const $abb060b32468ba71$var$gridContainerStyles = (0, $9BVpB.xcss)({
    flex: 1,
    gridTemplateColumns: 'repeat(12, 1fr)'
});
const $abb060b32468ba71$var$gridItemStyles = (0, $9BVpB.xcss)({
    gridColumn: 'span 12'
});
const $abb060b32468ba71$var$mainContentSkipLinkStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
// A11Y-29321: flex column holding the `<main>` landmark and the footer as siblings so the footer
// can sit outside `<main>` while staying pinned to the bottom of the page.
const $abb060b32468ba71$var$mainColumnStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
const $abb060b32468ba71$var$noteColumnStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
// A11Y-29321: pins the footer to the bottom of the flex column while it sits outside `<main>`.
const $abb060b32468ba71$var$footerAtBottomStyles = (0, $9BVpB.xcss)({
    marginTop: 'auto'
});
const $abb060b32468ba71$var$noteContainerStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});
var $abb060b32468ba71$export$2e2bcd8739ae039 = $abb060b32468ba71$var$GridContainer;

});
parcelRegister("czPjg", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $c0117fd743351dba$export$f61abf052f87399f);
// 800px is normal width
const $c0117fd743351dba$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $c0117fd743351dba$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $c0117fd743351dba$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $c0117fd743351dba$var$GRID_XXWIDE_WIDTH = '1200px';
const $c0117fd743351dba$var$GRID_NOTE_WIDTH = '480px';
const $c0117fd743351dba$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $c0117fd743351dba$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $c0117fd743351dba$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $c0117fd743351dba$var$GRID_WIDE_WIDTH;
        case 'note':
            return $c0117fd743351dba$var$GRID_NOTE_WIDTH;
        default:
            return $c0117fd743351dba$var$GRID_NORMAL_WIDTH;
    }
};

});




parcelRegister("fz2hV", function(module, exports) {
$parcel$export(module.exports, "GridContainer", () => (parcelRequire("jr0Z4")).default);
$parcel$export(module.exports, "SkipToMainContent", () => (parcelRequire("jr0Z4")).SkipToMainContent);

var $jr0Z4 = parcelRequire("jr0Z4");

});



parcelRegister("kXI4A", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutDumb", () => (parcelRequire("e2Dfm")).default);

var $e2Dfm = parcelRequire("e2Dfm");

});
parcelRegister("e2Dfm", function(module, exports) {
$parcel$export(module.exports, "default", () => $026df4e9a041191e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $hF8Ik = parcelRequire("hF8Ik");

var $kU5HH = parcelRequire("kU5HH");
parcelRequire("9H44a");
var $dCSpQ = parcelRequire("dCSpQ");
parcelRequire("8Emwg");
var $7XXCW = parcelRequire("7XXCW");
parcelRequire("ckGNT");
var $2LtGs = parcelRequire("2LtGs");

var $1DDTY = parcelRequire("1DDTY");
parcelRequire("7OG9m");
var $iBxSu = parcelRequire("iBxSu");
parcelRequire("cAJ8B");
var $eqXqW = parcelRequire("eqXqW");
parcelRequire("7wH5B");
var $30arO = parcelRequire("30arO");

var $kkzNV = parcelRequire("kkzNV");

var $OK0aw = parcelRequire("OK0aw");

var $bSA8a = parcelRequire("bSA8a");

var $1qPbZ = parcelRequire("1qPbZ");

var $hCnLH = parcelRequire("hCnLH");
const $026df4e9a041191e$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSA8a.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $OK0aw.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $026df4e9a041191e$var$BannerWithPaperLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, path: path, searchShown: searchShown, isBrandingLoaded: isBrandingLoaded, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM })=>{
    const showBannerWithLoader = ()=>{
        if (isBrandingLoaded) return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$Banner, {
            imageSrc: helpCenterBanner
        });
        return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: (0, $1DDTY.BANNER_HEIGHT).unitless,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dCSpQ.default), {
        className: "px-paper-layout"
    }), (0, $hCnLH.isKoshEnabledForDefaultHelpCenter)() ? showBannerWithLoader() : !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$Banner, {
        imageSrc: helpCenterBanner
    }), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $30arO.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iBxSu.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    }), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$EmptyHeader, {
        "data-testid": "empty-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($026df4e9a041191e$var$PaperContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eqXqW.default), {
        appearance: paperAppearance,
        pageKey: path,
        isCSM: isCSM
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kkzNV.AutoHeightBody), null)))));
};
var $026df4e9a041191e$export$2e2bcd8739ae039 = $026df4e9a041191e$var$BannerWithPaperLayoutDumb;
const $026df4e9a041191e$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $026df4e9a041191e$var$SidebarPusherRoot = /*#__PURE__*/ (0, $4v2A7.default)((0, $2LtGs.default)).withConfig({
    componentId: "sc-ku2ur3-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $026df4e9a041191e$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ku2ur3-1"
})`position:relative;overflow-x:hidden;display:flex;flex-direction:column;min-height:${$026df4e9a041191e$var$CONTAINER_MIN_HEIGHT};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $026df4e9a041191e$var$PaperContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ku2ur3-2"
})`position:relative;display:flex;flex:1 1 auto;overflow:hidden;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $026df4e9a041191e$var$Banner = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ku2ur3-3"
})`position:absolute;top:0;left:0;right:0;height:${(0, $1DDTY.BANNER_HEIGHT).px};z-index:${$kU5HH.banner};background-color:${(props)=>`var(--ds-background-brand-bold, ${props.theme.color})`};background-image:${(props)=>!!props.imageSrc ? `url(${props.imageSrc})` : 'none'};background-size:cover;background-repeat:no-repeat;background-position:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $026df4e9a041191e$var$LoadingContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ku2ur3-4"
})`position:absolute;top:0;left:0;right:0;height:${(0, $1DDTY.BANNER_HEIGHT).px};z-index:${$kU5HH.banner};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $026df4e9a041191e$var$EmptyHeader = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ku2ur3-5"
})`height:${(0, $1DDTY.HEADER_HEIGHT)}px;width:100%;`;
const $026df4e9a041191e$export$36525627ce333d44 = /*#__PURE__*/ (0, $4v2A7.default)((0, $7XXCW.Flipper)).withConfig({
    componentId: "sc-ku2ur3-6"
})`display:flex;flex-direction:column;`;

});


parcelRegister("1ylIr", function(module, exports) {
$parcel$export(module.exports, "withLayoutRoute", () => (parcelRequire("cHYPR")).default);

var $cHYPR = parcelRequire("cHYPR");

});
parcelRegister("cHYPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $5511ad13b889d58d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gQxPF = parcelRequire("gQxPF");

var $fvUqa = parcelRequire("fvUqa");
parcelRequire("5lPCP");
var $a6Y7T = parcelRequire("a6Y7T");
parcelRequire("jWWjz");
var $6EkPI = parcelRequire("6EkPI");

var $dHph6 = parcelRequire("dHph6");

var $irUsc = parcelRequire("irUsc");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");
parcelRequire("lXAMg");
var $5ynU3 = parcelRequire("5ynU3");
/**
 * This will return a component which will pass the Layout and children into a <Route />.
 * It will capture all path params and set them into redux, as well as providing them to withPathParams() higher order component.
 * @param Layout Layout component we're wrapping.
 */ function $5511ad13b889d58d$var$withLayoutRoute(Layout) {
    return class LayoutRoute extends $bSJIT.Component {
        render() {
            const LayoutWithChildren = this.LayoutWithChildren;
            return /*#__PURE__*/ $bSJIT.createElement((0, $a6Y7T.RouterSubscriber), null, (routerState)=>{
                return /*#__PURE__*/ $bSJIT.createElement(LayoutWithChildren, routerState);
            });
        }
        constructor(...args){
            super(...args), // Create an instance Component to pass down react router props to ChildrenComponent as well block
            // any extraneous rendering from query params updating.
            this.LayoutWithChildren = (0, $5ynU3.default)((innerRouteProps)=>{
                const { renderError: renderError, layoutProps: layoutProps, path: path, isFooterHidden: isFooterHidden, screenName: screenName, component: ChildrenComponent } = this.props;
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const query = $fvUqa.parse(innerRouteProps.location.search);
                const component = /*#__PURE__*/ $bSJIT.createElement((0, $gQxPF.PathParamsProvider), {
                    params: innerRouteProps.match.params
                }, /*#__PURE__*/ $bSJIT.createElement((0, $dHph6.OnboardingProvider), {
                    query: query
                }, /*#__PURE__*/ $bSJIT.createElement(Layout, {
                    ...layoutProps,
                    path: path,
                    isFooterHidden: isFooterHidden
                }, /*#__PURE__*/ $bSJIT.createElement((0, $d7jBU.default), {
                    screenName: screenName,
                    renderError: renderError
                }, /*#__PURE__*/ $bSJIT.createElement(ChildrenComponent, innerRouteProps)))), /*#__PURE__*/ $bSJIT.createElement((0, $6EkPI.default), innerRouteProps));
                return screenName ? /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
                    screenName: screenName,
                    screenId: innerRouteProps.match.url
                }, component) : component;
            }, ()=>this.props.reRenderOnQueryParameterChanges || []);
        }
    };
}
var $5511ad13b889d58d$export$2e2bcd8739ae039 = $5511ad13b889d58d$var$withLayoutRoute;

});
parcelRegister("dHph6", function(module, exports) {
$parcel$export(module.exports, "OnboardingProvider", () => $91c8633b87dee592$export$54ba648a75d332de);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $gQxPF = parcelRequire("gQxPF");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $aYbXa = parcelRequire("aYbXa");

var $jtB9I = parcelRequire("jtB9I");
const $91c8633b87dee592$var$mapStateToProps = (state, props)=>({
        projectId: (0, $iWhHo.getProjectId)(state, (0, $aYbXa.toNumber)(props.portalId)),
        showRequestTypeOnboarding: (0, $iWhHo.getCanAdministerProject)(state, (0, $aYbXa.toNumber)(props.portalId))
    });
const $91c8633b87dee592$export$54ba648a75d332de = (0, $gQxPF.default)((0, $f2mlD.default)($91c8633b87dee592$var$mapStateToProps)((0, $jtB9I.default)));

});
parcelRegister("jtB9I", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f4455fe9960cc82$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $aC7H4 = parcelRequire("aC7H4");
const $2f4455fe9960cc82$export$19b38316c9e7b045 = /*#__PURE__*/ $bSJIT.createContext({
    isLoading: true,
    isRequestCreated: false,
    isDemoProject: false
});
const $2f4455fe9960cc82$export$87a388960a322f14 = $2f4455fe9960cc82$export$19b38316c9e7b045.Consumer;
class $2f4455fe9960cc82$export$2e2bcd8739ae039 extends $bSJIT.Component {
    async componentDidMount() {
        await this.fetchOnboarding();
    }
    async componentDidUpdate(prevProps) {
        const projectIdChanged = prevProps.projectId !== this.props.projectId;
        if (projectIdChanged) await this.fetchOnboarding();
    }
    render() {
        const { children: children, query: query } = this.props;
        const { isLoading: isLoading, isDemoProject: isDemoProject } = this.state;
        const isRequestCreated = !!query.created;
        return /*#__PURE__*/ $bSJIT.createElement($2f4455fe9960cc82$export$19b38316c9e7b045.Provider, {
            value: {
                isLoading: isLoading,
                isDemoProject: isDemoProject,
                isRequestCreated: isRequestCreated
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: true,
            isDemoProject: false
        }, /**
   * fetchOnboarding()
   * This method should fetch all onboarding and then set the results appropriately.
   * Remember: Only one onboarding should be shown at a time.
   */ this.fetchOnboarding = async ()=>{
            // Extend this later to fetch all onboarding sources.
            const { projectId: projectId, showRequestTypeOnboarding: showRequestTypeOnboarding } = this.props;
            if (!projectId) return;
            let newState = {};
            if (showRequestTypeOnboarding) {
                const isDemoProject = await (0, $aC7H4.getIsDemoProject)(projectId);
                newState = {
                    ...newState,
                    isDemoProject: isDemoProject,
                    isLoading: false
                };
            }
            this.setState(newState);
        };
    }
}

});
parcelRegister("aC7H4", function(module, exports) {
$parcel$export(module.exports, "getIsDemoProject", () => $a35e3f46549929cd$export$2156daeb7d24c1fc);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $eDcdn = parcelRequire("eDcdn");
const $a35e3f46549929cd$export$2156daeb7d24c1fc = (projectId)=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/internal/latest/frontendconfig/properties?projectId=${projectId}&project=isDemo`;
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (ajaxResponse.response && ajaxResponse.response.project) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return !!ajaxResponse.response.project.isDemo;
        return false;
    }).catch(()=>(0, $8jOUp.Observable).of(false)).toPromise();
};

});



parcelRegister("lXAMg", function(module, exports) {
$parcel$export(module.exports, "withIgnoreQueryParamUpdates", () => (parcelRequire("5ynU3")).default);

var $5ynU3 = parcelRequire("5ynU3");

});
parcelRegister("5ynU3", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e380fc14b28e279$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $fvUqa = parcelRequire("fvUqa");
/**
 * Higher order component which implements a shouldComponentUpdate() to block re-rendering if only the query
 * param updated from the react router props.
 * @param renderChild Render function that will return JSX.
 * @param whiteListedQueryParametersSupplier
 */ const $2e380fc14b28e279$var$withIgnoreQueryParamUpdates = (renderChild, whiteListedQueryParametersSupplier)=>{
    return class GeneratedLayout extends $bSJIT.Component {
        areWhiteListedQueryParametersDifferent(search, nextSearch) {
            const whiteListedQueryParameters = whiteListedQueryParametersSupplier();
            if (whiteListedQueryParameters.length > 0) {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedSearch = $fvUqa.parse(search);
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedNextSearch = $fvUqa.parse(nextSearch);
                let i = 0;
                for(i; i < whiteListedQueryParameters.length; i++){
                    const whiteListedProp = whiteListedQueryParameters[i];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const value = parsedSearch[whiteListedProp];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const nextValue = parsedNextSearch[whiteListedProp];
                    if (value !== nextValue) return true;
                }
            }
            return false;
        }
        shouldComponentUpdate(nextProps) {
            const { location: location, ...remainingProps } = this.props;
            const { location: nextLocation, ...remainingNextProps } = nextProps;
            const nonQueryLocationChanged = GeneratedLayout.hasNonQueryLocationChanged(location, nextLocation);
            if (nonQueryLocationChanged) return true;
            if (!(0, $4ZMmh.isEqual)(remainingProps, remainingNextProps)) return true;
            return this.areWhiteListedQueryParametersDifferent(location.search, nextLocation.search);
        }
        static hasNonQueryLocationChanged(location, nextLocation) {
            const { search: search, ...remainingLocationProps } = location;
            const { search: nextSearch, ...remainingNextLocationProps } = nextLocation;
            // If any props other than query parameter changed then we will update
            return !(0, $4ZMmh.isEqual)(remainingLocationProps, remainingNextLocationProps);
        }
        render() {
            return renderChild(this.props);
        }
    };
};
var $2e380fc14b28e279$export$2e2bcd8739ae039 = $2e380fc14b28e279$var$withIgnoreQueryParamUpdates;

});







parcelRegister("hxOA5", function(module, exports) {
$parcel$export(module.exports, "UiModificationsContainer", () => $2e52389f3ecf98ff$export$1834060b93715de7);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $gXIzn = parcelRequire("gXIzn");

var $8MlrR = parcelRequire("8MlrR");

var $izwKR = parcelRequire("izwKR");
const $2e52389f3ecf98ff$export$1834060b93715de7 = ({ children: children })=>{
    return (0, $lFpPv.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXIzn.BaseUiModificationsContainer), {
        scope: (0, $8MlrR.REQUEST_CREATE_VIEW_TYPE),
        viewType: (0, $8MlrR.REQUEST_CREATE_VIEW_TYPE),
        viewConfiguration: (0, $izwKR.RequestCreateViewConfiguration)
    }, children) : children;
};

});
parcelRegister("gXIzn", function(module, exports) {
$parcel$export(module.exports, "BaseUiModificationsContainer", () => $73cbf9fdca825175$export$8b7a045f60eb9797);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $inaNq = parcelRequire("inaNq");

var $eezfT = parcelRequire("eezfT");

var $jVnYA = parcelRequire("jVnYA");
const $73cbf9fdca825175$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    (0, $jVnYA.useLoadViewConfiguration)(viewType, viewConfiguration);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eezfT.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $inaNq.UiModificationContextContainer), {
        scope: scope
    }, children));
};

});
parcelRegister("inaNq", function(module, exports) {
$parcel$export(module.exports, "store", () => $951d3c78afc22fb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $951d3c78afc22fb7$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $951d3c78afc22fb7$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $951d3c78afc22fb7$export$5eb9c167b683d125);

var $gfNVK = parcelRequire("gfNVK");
var $adFyB = parcelRequire("adFyB");
var $7CE69 = parcelRequire("7CE69");
const $951d3c78afc22fb7$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $951d3c78afc22fb7$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($951d3c78afc22fb7$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $951d3c78afc22fb7$export$6f57813fe9f31bf9 = (0, $7CE69.createStore)({
    name: 'issue-adjustments-context',
    initialState: $951d3c78afc22fb7$var$initialState,
    actions: $951d3c78afc22fb7$export$e324594224ef24da
});
const $951d3c78afc22fb7$export$a12f82a132dee079 = (0, $gfNVK.createHook)($951d3c78afc22fb7$export$6f57813fe9f31bf9);
const $951d3c78afc22fb7$export$358ad850b2f6d6fe = (0, $gfNVK.createStateHook)($951d3c78afc22fb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $951d3c78afc22fb7$export$4f2729981f4b81d2 = (0, $gfNVK.createActionsHook)($951d3c78afc22fb7$export$6f57813fe9f31bf9);
const $951d3c78afc22fb7$export$5eb9c167b683d125 = (0, $adFyB.createContainer)($951d3c78afc22fb7$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eezfT", function(module, exports) {
$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $47d3f1bf51d0bff1$export$b087a12fbb84e8ac);

var $adFyB = parcelRequire("adFyB");

var $81Pre = parcelRequire("81Pre");
const $47d3f1bf51d0bff1$export$b087a12fbb84e8ac = (0, $adFyB.createContainer)((0, $81Pre.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("81Pre", function(module, exports) {
$parcel$export(module.exports, "store", () => $0c103c3a59ff753e$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedFields", () => $0c103c3a59ff753e$export$c76e674a29843e21);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $0c103c3a59ff753e$export$cb9a014ec14556d8);
// eslint-disable-next-line import/order

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $fzhHu = parcelRequire("fzhHu");

var $4Tp8n = parcelRequire("4Tp8n");

var $8J7lj = parcelRequire("8J7lj");

var $c7ee3 = parcelRequire("c7ee3");

var $5LnAL = parcelRequire("5LnAL");

var $l4DvK = parcelRequire("l4DvK");

var $akEfV = parcelRequire("akEfV");

var $5EBuM = parcelRequire("5EBuM");

var $5rqlJ = parcelRequire("5rqlJ");

var $1X6bW = parcelRequire("1X6bW");

var $kkpzw = parcelRequire("kkpzw");

var $jxRzc = parcelRequire("jxRzc");

var $ejb33 = parcelRequire("ejb33");

var $1H88d = parcelRequire("1H88d");

var $iczKd = parcelRequire("iczKd");
const $0c103c3a59ff753e$var$name = 'issue-adjustments';
const $0c103c3a59ff753e$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $0c103c3a59ff753e$var$triggerFieldInitializationKey, viewType: $0c103c3a59ff753e$var$scopedViewType, numberOfSupportedFields: $0c103c3a59ff753e$var$numberOfSupportedFields, ...$0c103c3a59ff753e$var$stateForResetAllFields } = $0c103c3a59ff753e$export$d4c72bab9d6cc13a;
const $0c103c3a59ff753e$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $1X6bW.processChange,
    setFieldValue: $jxRzc.setFieldValue,
    initializeField: $l4DvK.initializeField,
    initializeFields: $l4DvK.initializeFields,
    startFieldsInitialisationTimeout: $5LnAL.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $5LnAL.successFieldsInitalisation,
    registerFields: $kkpzw.registerFields,
    unregisterFields: $kkpzw.unregisterFields,
    updateFields: $1H88d.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($0c103c3a59ff753e$var$stateForResetAllFields);
        },
    setError: $c7ee3.setError,
    resetError: $c7ee3.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
   * This is used to block onInit for specific case like Issue View background refresh loading.
   */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $fzhHu.setAppErrors,
    resetAppErrors: $fzhHu.resetAppErrors,
    addAppsErrors: $fzhHu.addAppsErrors,
    initializeNoScreenTab: $akEfV.initializeNoScreenTab,
    initializeScreenTabs: $5EBuM.initializeScreenTabs,
    updateScreenTabs: $iczKd.updateScreenTabs,
    updateActiveScreenTab: $ejb33.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4Tp8n.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $8J7lj.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $8J7lj.collectFieldsAppliedChangesHistory,
    setNotification: $5rqlJ.setNotification,
    resetNotification: $5rqlJ.resetNotification
};
const $0c103c3a59ff753e$export$6f57813fe9f31bf9 = (0, $7CE69.createStore)({
    name: $0c103c3a59ff753e$var$name,
    initialState: $0c103c3a59ff753e$export$d4c72bab9d6cc13a,
    actions: $0c103c3a59ff753e$export$e324594224ef24da
});
const $0c103c3a59ff753e$export$37792a602e748c08 = (0, $gfNVK.createHook)($0c103c3a59ff753e$export$6f57813fe9f31bf9);
const $0c103c3a59ff753e$var$stableEmptyFieldFromIframe = {};
const $0c103c3a59ff753e$export$c76e674a29843e21 = (0, $gfNVK.createHook)($0c103c3a59ff753e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $0c103c3a59ff753e$export$df4b0714e8177e0e = (0, $gfNVK.createHook)($0c103c3a59ff753e$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>{
        var _state$appliedChanges;
        return ((_state$appliedChanges = state.appliedChanges) === null || _state$appliedChanges === void 0 ? void 0 : _state$appliedChanges[fieldId]) || $0c103c3a59ff753e$var$stableEmptyFieldFromIframe;
    }
});
const $0c103c3a59ff753e$export$cb9a014ec14556d8 = (0, $gfNVK.createActionsHook)($0c103c3a59ff753e$export$6f57813fe9f31bf9);
const $0c103c3a59ff753e$export$677b3e34bd14c681 = (0, $gfNVK.createHook)($0c103c3a59ff753e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("fzhHu", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $d9daacffe827f1d0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $d9daacffe827f1d0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $d9daacffe827f1d0$export$24c821207687a907);
const $d9daacffe827f1d0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $d9daacffe827f1d0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $d9daacffe827f1d0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4Tp8n", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $617afa2d48e6dae7$export$90d94f20d157e756);

var $cYXOj = parcelRequire("cYXOj");

var $lNNuB = parcelRequire("lNNuB");

var $fzhHu = parcelRequire("fzhHu");

var $5rqlJ = parcelRequire("5rqlJ");

var $cRT0G = parcelRequire("cRT0G");
const $617afa2d48e6dae7$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $617afa2d48e6dae7$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $617afa2d48e6dae7$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $617afa2d48e6dae7$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $617afa2d48e6dae7$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId === null || appliedChangesHistoryChangeId === void 0 ? void 0 : appliedChangesHistoryChangeId.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $lNNuB.ON_INIT_CHANGE_ID) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $cRT0G.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $fzhHu.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $5rqlJ.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("cYXOj", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $510d345cc8cf2e41$export$a1fb57756f0de62b);

var $jeyHF = parcelRequire("jeyHF");

var $clpci = parcelRequire("clpci");

var $lfIWD = parcelRequire("lfIWD");
const $510d345cc8cf2e41$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $jeyHF.default)((0, $lfIWD.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $clpci.OPERATIONAL_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});
parcelRegister("lfIWD", function(module, exports) {
$parcel$export(module.exports, "UI_MODIFICATIONS_ANALYTICS_CHANNEL", () => $605b3fc500ad7e63$export$8280e5c6104c5b40);
const $605b3fc500ad7e63$export$8280e5c6104c5b40 = 'ui-modifications';

});


parcelRegister("lNNuB", function(module, exports) {
$parcel$export(module.exports, "ON_INIT_CHANGE_ID", () => $3fd6f09de3921443$export$415cc1afa6445f90);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $3fd6f09de3921443$export$811b7f067a43b422);
const $3fd6f09de3921443$export$415cc1afa6445f90 = 'onInitChangeId';
const $3fd6f09de3921443$export$811b7f067a43b422 = 'jira:uiModifications';

});

parcelRegister("5rqlJ", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $0efb41827ffbd018$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $0efb41827ffbd018$export$caafa3945f199bc7);
const $0efb41827ffbd018$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $0efb41827ffbd018$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("cRT0G", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $cebfc5f91699b7df$export$a06103ec99e4e394);

var $67zrY = parcelRequire("67zrY");

var $9m9kx = parcelRequire("9m9kx");

var $k8sJ1 = parcelRequire("k8sJ1");

var $k1jQ4 = parcelRequire("k1jQ4");
const $cebfc5f91699b7df$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $cebfc5f91699b7df$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $k1jQ4.SCREEN_TABS_HISTORY_TYPE)) return {
            type: (0, $9m9kx.MULTIPLE_APPS_CONFLICT),
            cause: (0, $9m9kx.MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$cebfc5f91699b7df$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $k8sJ1.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $9m9kx.MULTIPLE_APPS_CONFLICT),
            cause: (0, $9m9kx.MULTIPLE_APPS_CONFLICT_CAUSE_FIELD),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$cebfc5f91699b7df$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $cebfc5f91699b7df$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($67zrY)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $cebfc5f91699b7df$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("67zrY", function(module, exports) {

var $2aKdk = parcelRequire("2aKdk");

var $buZZp = parcelRequire("buZZp");

var $35viN = parcelRequire("35viN");

var $8x5Xw = parcelRequire("8x5Xw");

var $dSpzt = parcelRequire("dSpzt");

var $3GSzM = parcelRequire("3GSzM");

var $ebiRu = parcelRequire("ebiRu");

var $iD6eu = parcelRequire("iD6eu");
/** Used to compose bitmasks for cloning. */ var $474ee535cb9ba5e2$var$CLONE_DEEP_FLAG = 1, $474ee535cb9ba5e2$var$CLONE_FLAT_FLAG = 2, $474ee535cb9ba5e2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $474ee535cb9ba5e2$var$omit = $ebiRu(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $2aKdk(paths, function(path) {
        path = $8x5Xw(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $dSpzt(object, $iD6eu(object), result);
    if (isDeep) result = $buZZp(result, $474ee535cb9ba5e2$var$CLONE_DEEP_FLAG | $474ee535cb9ba5e2$var$CLONE_FLAT_FLAG | $474ee535cb9ba5e2$var$CLONE_SYMBOLS_FLAG, $3GSzM);
    var length = paths.length;
    while(length--)$35viN(result, paths[length]);
    return result;
});
module.exports = $474ee535cb9ba5e2$var$omit;

});
parcelRegister("buZZp", function(module, exports) {

var $423Gf = parcelRequire("423Gf");

var $9PW2V = parcelRequire("9PW2V");

var $9UsAL = parcelRequire("9UsAL");

var $aNogx = parcelRequire("aNogx");

var $eX3vU = parcelRequire("eX3vU");

var $iIWZ6 = parcelRequire("iIWZ6");

var $gyIaM = parcelRequire("gyIaM");

var $2WffJ = parcelRequire("2WffJ");

var $fXbLT = parcelRequire("fXbLT");

var $l7PnJ = parcelRequire("l7PnJ");

var $iD6eu = parcelRequire("iD6eu");

var $4J8KV = parcelRequire("4J8KV");

var $1OLTf = parcelRequire("1OLTf");

var $1YYdl = parcelRequire("1YYdl");

var $lcEzd = parcelRequire("lcEzd");

var $lVkdr = parcelRequire("lVkdr");

var $1TItY = parcelRequire("1TItY");

var $huA1V = parcelRequire("huA1V");

var $awGqx = parcelRequire("awGqx");

var $6ZV1E = parcelRequire("6ZV1E");

var $7yuIC = parcelRequire("7yuIC");

var $jYsOT = parcelRequire("jYsOT");
/** Used to compose bitmasks for cloning. */ var $85f294d976a8c52c$var$CLONE_DEEP_FLAG = 1, $85f294d976a8c52c$var$CLONE_FLAT_FLAG = 2, $85f294d976a8c52c$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $85f294d976a8c52c$var$argsTag = '[object Arguments]', $85f294d976a8c52c$var$arrayTag = '[object Array]', $85f294d976a8c52c$var$boolTag = '[object Boolean]', $85f294d976a8c52c$var$dateTag = '[object Date]', $85f294d976a8c52c$var$errorTag = '[object Error]', $85f294d976a8c52c$var$funcTag = '[object Function]', $85f294d976a8c52c$var$genTag = '[object GeneratorFunction]', $85f294d976a8c52c$var$mapTag = '[object Map]', $85f294d976a8c52c$var$numberTag = '[object Number]', $85f294d976a8c52c$var$objectTag = '[object Object]', $85f294d976a8c52c$var$regexpTag = '[object RegExp]', $85f294d976a8c52c$var$setTag = '[object Set]', $85f294d976a8c52c$var$stringTag = '[object String]', $85f294d976a8c52c$var$symbolTag = '[object Symbol]', $85f294d976a8c52c$var$weakMapTag = '[object WeakMap]';
var $85f294d976a8c52c$var$arrayBufferTag = '[object ArrayBuffer]', $85f294d976a8c52c$var$dataViewTag = '[object DataView]', $85f294d976a8c52c$var$float32Tag = '[object Float32Array]', $85f294d976a8c52c$var$float64Tag = '[object Float64Array]', $85f294d976a8c52c$var$int8Tag = '[object Int8Array]', $85f294d976a8c52c$var$int16Tag = '[object Int16Array]', $85f294d976a8c52c$var$int32Tag = '[object Int32Array]', $85f294d976a8c52c$var$uint8Tag = '[object Uint8Array]', $85f294d976a8c52c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85f294d976a8c52c$var$uint16Tag = '[object Uint16Array]', $85f294d976a8c52c$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $85f294d976a8c52c$var$cloneableTags = {};
$85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$argsTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$arrayTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$arrayBufferTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$dataViewTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$boolTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$dateTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$float32Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$float64Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$int8Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$int16Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$int32Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$mapTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$numberTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$objectTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$regexpTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$setTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$stringTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$symbolTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$uint8Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$uint8ClampedTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$uint16Tag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$uint32Tag] = true;
$85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$errorTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$funcTag] = $85f294d976a8c52c$var$cloneableTags[$85f294d976a8c52c$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $85f294d976a8c52c$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $85f294d976a8c52c$var$CLONE_DEEP_FLAG, isFlat = bitmask & $85f294d976a8c52c$var$CLONE_FLAT_FLAG, isFull = bitmask & $85f294d976a8c52c$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$awGqx(value)) return value;
    var isArr = $lVkdr(value);
    if (isArr) {
        result = $1OLTf(value);
        if (!isDeep) return $gyIaM(value, result);
    } else {
        var tag = $4J8KV(value), isFunc = tag == $85f294d976a8c52c$var$funcTag || tag == $85f294d976a8c52c$var$genTag;
        if ($1TItY(value)) return $iIWZ6(value, isDeep);
        if (tag == $85f294d976a8c52c$var$objectTag || tag == $85f294d976a8c52c$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $lcEzd(value);
            if (!isDeep) return isFlat ? $fXbLT(value, $eX3vU(result, value)) : $2WffJ(value, $aNogx(result, value));
        } else {
            if (!$85f294d976a8c52c$var$cloneableTags[tag]) return object ? value : {};
            result = $1YYdl(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $423Gf);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6ZV1E(value)) value.forEach(function(subValue) {
        result.add($85f294d976a8c52c$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($huA1V(value)) value.forEach(function(subValue, key) {
        result.set(key, $85f294d976a8c52c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $iD6eu : $l7PnJ : isFlat ? $jYsOT : $7yuIC;
    var props = isArr ? undefined : keysFunc(value);
    $9PW2V(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $9UsAL(result, key, $85f294d976a8c52c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $85f294d976a8c52c$var$baseClone;

});
parcelRegister("9PW2V", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $7295e73c38bae3d1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $7295e73c38bae3d1$var$arrayEach;

});

parcelRegister("aNogx", function(module, exports) {

var $dSpzt = parcelRequire("dSpzt");

var $7yuIC = parcelRequire("7yuIC");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $7dc14daba9aa65d3$var$baseAssign(object, source) {
    return object && $dSpzt(source, $7yuIC(source), object);
}
module.exports = $7dc14daba9aa65d3$var$baseAssign;

});

parcelRegister("eX3vU", function(module, exports) {

var $dSpzt = parcelRequire("dSpzt");

var $jYsOT = parcelRequire("jYsOT");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $ae294d18fe0c6925$var$baseAssignIn(object, source) {
    return object && $dSpzt(source, $jYsOT(source), object);
}
module.exports = $ae294d18fe0c6925$var$baseAssignIn;

});

parcelRegister("2WffJ", function(module, exports) {

var $dSpzt = parcelRequire("dSpzt");

var $1sma7 = parcelRequire("1sma7");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $223cd4735c100773$var$copySymbols(source, object) {
    return $dSpzt(source, $1sma7(source), object);
}
module.exports = $223cd4735c100773$var$copySymbols;

});

parcelRegister("fXbLT", function(module, exports) {

var $dSpzt = parcelRequire("dSpzt");

var $jfvnD = parcelRequire("jfvnD");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b9d57f477c5d1372$var$copySymbolsIn(source, object) {
    return $dSpzt(source, $jfvnD(source), object);
}
module.exports = $b9d57f477c5d1372$var$copySymbolsIn;

});

parcelRegister("1OLTf", function(module, exports) {
/** Used for built-in method references. */ var $152f9bee2ad936f7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $152f9bee2ad936f7$var$hasOwnProperty = $152f9bee2ad936f7$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $152f9bee2ad936f7$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $152f9bee2ad936f7$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $152f9bee2ad936f7$var$initCloneArray;

});

parcelRegister("1YYdl", function(module, exports) {

var $kERHM = parcelRequire("kERHM");

var $2sJDb = parcelRequire("2sJDb");

var $1ZOW4 = parcelRequire("1ZOW4");

var $1JGjs = parcelRequire("1JGjs");

var $1iXcA = parcelRequire("1iXcA");
/** `Object#toString` result references. */ var $171a1a52caef6ec6$var$boolTag = '[object Boolean]', $171a1a52caef6ec6$var$dateTag = '[object Date]', $171a1a52caef6ec6$var$mapTag = '[object Map]', $171a1a52caef6ec6$var$numberTag = '[object Number]', $171a1a52caef6ec6$var$regexpTag = '[object RegExp]', $171a1a52caef6ec6$var$setTag = '[object Set]', $171a1a52caef6ec6$var$stringTag = '[object String]', $171a1a52caef6ec6$var$symbolTag = '[object Symbol]';
var $171a1a52caef6ec6$var$arrayBufferTag = '[object ArrayBuffer]', $171a1a52caef6ec6$var$dataViewTag = '[object DataView]', $171a1a52caef6ec6$var$float32Tag = '[object Float32Array]', $171a1a52caef6ec6$var$float64Tag = '[object Float64Array]', $171a1a52caef6ec6$var$int8Tag = '[object Int8Array]', $171a1a52caef6ec6$var$int16Tag = '[object Int16Array]', $171a1a52caef6ec6$var$int32Tag = '[object Int32Array]', $171a1a52caef6ec6$var$uint8Tag = '[object Uint8Array]', $171a1a52caef6ec6$var$uint8ClampedTag = '[object Uint8ClampedArray]', $171a1a52caef6ec6$var$uint16Tag = '[object Uint16Array]', $171a1a52caef6ec6$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $171a1a52caef6ec6$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $171a1a52caef6ec6$var$arrayBufferTag:
            return $kERHM(object);
        case $171a1a52caef6ec6$var$boolTag:
        case $171a1a52caef6ec6$var$dateTag:
            return new Ctor(+object);
        case $171a1a52caef6ec6$var$dataViewTag:
            return $2sJDb(object, isDeep);
        case $171a1a52caef6ec6$var$float32Tag:
        case $171a1a52caef6ec6$var$float64Tag:
        case $171a1a52caef6ec6$var$int8Tag:
        case $171a1a52caef6ec6$var$int16Tag:
        case $171a1a52caef6ec6$var$int32Tag:
        case $171a1a52caef6ec6$var$uint8Tag:
        case $171a1a52caef6ec6$var$uint8ClampedTag:
        case $171a1a52caef6ec6$var$uint16Tag:
        case $171a1a52caef6ec6$var$uint32Tag:
            return $1iXcA(object, isDeep);
        case $171a1a52caef6ec6$var$mapTag:
            return new Ctor;
        case $171a1a52caef6ec6$var$numberTag:
        case $171a1a52caef6ec6$var$stringTag:
            return new Ctor(object);
        case $171a1a52caef6ec6$var$regexpTag:
            return $1ZOW4(object);
        case $171a1a52caef6ec6$var$setTag:
            return new Ctor;
        case $171a1a52caef6ec6$var$symbolTag:
            return $1JGjs(object);
    }
}
module.exports = $171a1a52caef6ec6$var$initCloneByTag;

});
parcelRegister("2sJDb", function(module, exports) {

var $kERHM = parcelRequire("kERHM");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1cb197ae8c025fda$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $kERHM(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1cb197ae8c025fda$var$cloneDataView;

});

parcelRegister("1ZOW4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $1742ffb548d81177$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $1742ffb548d81177$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $1742ffb548d81177$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $1742ffb548d81177$var$cloneRegExp;

});

parcelRegister("1JGjs", function(module, exports) {

var $hS0KO = parcelRequire("hS0KO");
/** Used to convert symbols to primitives and strings. */ var $143ad0da05056312$var$symbolProto = $hS0KO ? $hS0KO.prototype : undefined, $143ad0da05056312$var$symbolValueOf = $143ad0da05056312$var$symbolProto ? $143ad0da05056312$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $143ad0da05056312$var$cloneSymbol(symbol) {
    return $143ad0da05056312$var$symbolValueOf ? Object($143ad0da05056312$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $143ad0da05056312$var$cloneSymbol;

});


parcelRegister("huA1V", function(module, exports) {

var $k8z9Z = parcelRequire("k8z9Z");

var $69sKP = parcelRequire("69sKP");

var $j3YM5 = parcelRequire("j3YM5");
/* Node.js helper references. */ var $cbc12fcd7445689b$var$nodeIsMap = $j3YM5 && $j3YM5.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $cbc12fcd7445689b$var$isMap = $cbc12fcd7445689b$var$nodeIsMap ? $69sKP($cbc12fcd7445689b$var$nodeIsMap) : $k8z9Z;
module.exports = $cbc12fcd7445689b$var$isMap;

});
parcelRegister("k8z9Z", function(module, exports) {

var $4J8KV = parcelRequire("4J8KV");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $ea8fd415046f1560$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $ea8fd415046f1560$var$baseIsMap(value) {
    return $3T67E(value) && $4J8KV(value) == $ea8fd415046f1560$var$mapTag;
}
module.exports = $ea8fd415046f1560$var$baseIsMap;

});


parcelRegister("6ZV1E", function(module, exports) {

var $1QwuG = parcelRequire("1QwuG");

var $69sKP = parcelRequire("69sKP");

var $j3YM5 = parcelRequire("j3YM5");
/* Node.js helper references. */ var $5184acaf4d0ea496$var$nodeIsSet = $j3YM5 && $j3YM5.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $5184acaf4d0ea496$var$isSet = $5184acaf4d0ea496$var$nodeIsSet ? $69sKP($5184acaf4d0ea496$var$nodeIsSet) : $1QwuG;
module.exports = $5184acaf4d0ea496$var$isSet;

});
parcelRegister("1QwuG", function(module, exports) {

var $4J8KV = parcelRequire("4J8KV");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $1583da66828bf500$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $1583da66828bf500$var$baseIsSet(value) {
    return $3T67E(value) && $4J8KV(value) == $1583da66828bf500$var$setTag;
}
module.exports = $1583da66828bf500$var$baseIsSet;

});



parcelRegister("35viN", function(module, exports) {

var $8x5Xw = parcelRequire("8x5Xw");

var $fbpGW = parcelRequire("fbpGW");

var $3CxVe = parcelRequire("3CxVe");

var $2QKMi = parcelRequire("2QKMi");
/** Used for built-in method references. */ var $23fa1eaedbbd0617$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $23fa1eaedbbd0617$var$hasOwnProperty = $23fa1eaedbbd0617$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $23fa1eaedbbd0617$var$baseUnset(object, path) {
    path = $8x5Xw(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $2QKMi(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$23fa1eaedbbd0617$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3CxVe(object, path);
    return obj == null || delete obj[$2QKMi($fbpGW(path))];
}
module.exports = $23fa1eaedbbd0617$var$baseUnset;

});
parcelRegister("3CxVe", function(module, exports) {

var $kPcq7 = parcelRequire("kPcq7");

var $5M0WW = parcelRequire("5M0WW");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $2a2f3bee23d16a06$var$parent(object, path) {
    return path.length < 2 ? object : $kPcq7(object, $5M0WW(path, 0, -1));
}
module.exports = $2a2f3bee23d16a06$var$parent;

});
parcelRegister("5M0WW", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $43422c06e3ed916c$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $43422c06e3ed916c$var$baseSlice;

});



parcelRegister("3GSzM", function(module, exports) {

var $A2yBp = parcelRequire("A2yBp");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $2affa0fefcb64154$var$customOmitClone(value) {
    return $A2yBp(value) ? undefined : value;
}
module.exports = $2affa0fefcb64154$var$customOmitClone;

});

parcelRegister("ebiRu", function(module, exports) {

var $1LF1E = parcelRequire("1LF1E");

var $f1mpg = parcelRequire("f1mpg");

var $jCUSj = parcelRequire("jCUSj");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $a530b950dc006331$var$flatRest(func) {
    return $jCUSj($f1mpg(func, undefined, $1LF1E), func + '');
}
module.exports = $a530b950dc006331$var$flatRest;

});


parcelRegister("9m9kx", function(module, exports) {
$parcel$export(module.exports, "SCREENTABS_VALIDATION_ERROR", () => $d60f8aab43e0d534$export$fd26696d109785a0);
$parcel$export(module.exports, "FIELD_VALIDATION_ERROR", () => $d60f8aab43e0d534$export$d1996cb46a690190);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT", () => $d60f8aab43e0d534$export$2a3fdceaae2188d5);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_FIELD", () => $d60f8aab43e0d534$export$e4ac32edd5da2ee7);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS", () => $d60f8aab43e0d534$export$877da1000325f8b5);
const $d60f8aab43e0d534$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $d60f8aab43e0d534$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $d60f8aab43e0d534$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $d60f8aab43e0d534$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $d60f8aab43e0d534$export$e4ac32edd5da2ee7 = 'FIELD';
const $d60f8aab43e0d534$export$877da1000325f8b5 = 'SCREENTABS';

});

parcelRegister("k8sJ1", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $02a80f313b20ac99$export$e1cc7da28a1c4bb7);
const $02a80f313b20ac99$var$SET_NAME_METHOD = 'setName';
const $02a80f313b20ac99$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $02a80f313b20ac99$var$SET_VISIBLE_METHOD = 'setVisible';
const $02a80f313b20ac99$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $02a80f313b20ac99$var$SET_VALUE_METHOD = 'setValue';
const $02a80f313b20ac99$var$SET_REQUIRED_METHOD = 'setRequired';
const $02a80f313b20ac99$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $02a80f313b20ac99$export$8325709d137b2606 = {
    fieldName: $02a80f313b20ac99$var$SET_NAME_METHOD,
    description: $02a80f313b20ac99$var$SET_DESCRIPTION_METHOD,
    isVisible: $02a80f313b20ac99$var$SET_VISIBLE_METHOD,
    isReadOnly: $02a80f313b20ac99$var$SET_READ_ONLY_METHOD,
    value: $02a80f313b20ac99$var$SET_VALUE_METHOD,
    isRequired: $02a80f313b20ac99$var$SET_REQUIRED_METHOD,
    optionsVisibility: $02a80f313b20ac99$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $02a80f313b20ac99$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $02a80f313b20ac99$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("k1jQ4", function(module, exports) {
$parcel$export(module.exports, "SCREEN_TABS_HISTORY_TYPE", () => $1d96763ff36cccce$export$f674b7a3bbd94b5);
$parcel$export(module.exports, "FIELD_HISTORY_TYPE", () => $1d96763ff36cccce$export$4a9f236a0db33834);
const $1d96763ff36cccce$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $1d96763ff36cccce$export$4a9f236a0db33834 = 'FIELD';

});



parcelRegister("8J7lj", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $c82436ab2418831b$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $c82436ab2418831b$export$7d0f534e5b16dcc9);

var $k1jQ4 = parcelRequire("k1jQ4");

var $82pUg = parcelRequire("82pUg");
const $c82436ab2418831b$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    var _appliedChangesHistor;
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = ((_appliedChangesHistor = appliedChangesHistoryChangeId.apps) === null || _appliedChangesHistor === void 0 ? void 0 : _appliedChangesHistor[appId]) ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $c82436ab2418831b$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $c82436ab2418831b$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $k1jQ4.SCREEN_TABS_HISTORY_TYPE)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $c82436ab2418831b$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $82pUg.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $c82436ab2418831b$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("82pUg", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $18609307be62c9cc$export$8a23b3e9a1749620);

var $k1jQ4 = parcelRequire("k1jQ4");
const $18609307be62c9cc$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $k1jQ4.FIELD_HISTORY_TYPE)
        };
        return acc;
    }, {});
};
const $18609307be62c9cc$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $18609307be62c9cc$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("c7ee3", function(module, exports) {
$parcel$export(module.exports, "setError", () => $bdff8ec44b74c1e3$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $bdff8ec44b74c1e3$export$7e5930c6217b1d4e);
const $bdff8ec44b74c1e3$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $bdff8ec44b74c1e3$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("5LnAL", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $a0d3abd99dfbf57e$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $a0d3abd99dfbf57e$export$cf768a695e83eefa);

var $cYXOj = parcelRequire("cYXOj");

var $3gy1J = parcelRequire("3gy1J");

var $c7ee3 = parcelRequire("c7ee3");
const $a0d3abd99dfbf57e$var$getTimeout = ()=>50000;
const $a0d3abd99dfbf57e$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $a0d3abd99dfbf57e$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $a0d3abd99dfbf57e$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($a0d3abd99dfbf57e$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $a0d3abd99dfbf57e$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $a0d3abd99dfbf57e$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($a0d3abd99dfbf57e$var$isFieldInitialisationComplete(status) || (0, $3gy1J.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $c7ee3.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $a0d3abd99dfbf57e$var$getTimeout(),
                fieldsInitializationTime: $a0d3abd99dfbf57e$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $a0d3abd99dfbf57e$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($a0d3abd99dfbf57e$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $a0d3abd99dfbf57e$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("3gy1J", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $24a6beb47a26e426$export$4cadeedb8c3f31f7);

var $bBhJi = parcelRequire("bBhJi");
const $24a6beb47a26e426$export$4cadeedb8c3f31f7 = (0, $bBhJi.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("l4DvK", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $f08bceed7d272925$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $f08bceed7d272925$export$4a6b4707110b0552);

var $eK8kB = parcelRequire("eK8kB");
const $f08bceed7d272925$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
            fieldType: field.fieldType,
            extraData: metadata === null || metadata === void 0 ? void 0 : metadata.extraData
        };
        const publicValue = (0, $eK8kB.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $f08bceed7d272925$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
                fieldType: field.fieldType,
                extraData: metadata === null || metadata === void 0 ? void 0 : metadata.extraData
            };
            const publicValue = (0, $eK8kB.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("eK8kB", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $92a0815e727ea296$export$50806045b617d116);

var $iACvP = parcelRequire("iACvP");

var $dtngf = parcelRequire("dtngf");
const $92a0815e727ea296$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        var _getSupportedFieldCon;
        const valueTransformer = (_getSupportedFieldCon = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.internalToPublicTransformers.value;
        if (valueTransformer) /**
       * We trust that the internal field data is in the correct shape.
       * Data that is in the incorrect shape will result in error events
       * being logged for further investigation. In this error case we will
       * pass `null` as the value to unblock onInit for the apps
       *
       * The `fieldRenderer` passed to the `valueTransformer` is used only for
       * rich text fields and will be `undefined` for most of the executions
       */ value = valueTransformer(internalFieldValue, fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $iACvP.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("iACvP", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $931bea38010ac6e7$export$a27c21aa3ed8f0f1);

var $3pU6R = parcelRequire("3pU6R");

var $8M0C4 = parcelRequire("8M0C4");
const $931bea38010ac6e7$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $931bea38010ac6e7$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, analyticsViewType: analyticsViewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $8M0C4.getErrorType)(error);
    // Name the event after the canonical viewType (when given) so overlay traffic
    // lands in the same bucket; the real viewType still goes into attributes below.
    const packageName = `${analyticsViewType ?? viewType}jiraUiModifications`;
    (0, $3pU6R.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $931bea38010ac6e7$export$1bee4e6be783dd26(error.message) : error.message,
            viewType: // Keep the real viewType in attributes so we know where the error came from.
            viewType,
            ...attributes
        }
    });
};

});
parcelRegister("3pU6R", function(module, exports) {
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $545a07723a10e242$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $545a07723a10e242$export$2e2bcd8739ae039);

var $i2WqQ = parcelRequire("i2WqQ");

var $eu1ij = parcelRequire("eu1ij");

var $ezwN8 = parcelRequire("ezwN8");

var $k2MWg = parcelRequire("k2MWg");

var $bwe2U = parcelRequire("bwe2U");
let $545a07723a10e242$var$analyticsClient;
const $545a07723a10e242$export$d4079397f9611138 = (client)=>{
    $545a07723a10e242$var$analyticsClient = client;
};
const $545a07723a10e242$export$bf406c01a195b215 = ()=>{
    $545a07723a10e242$var$analyticsClient = undefined;
};
const $545a07723a10e242$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $ezwN8.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($eu1ij)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ))));
        if (event && event.context) {
            const fullEvent = (0, $ezwN8.extractAWCDataFromEvent)(event);
            (0, $bwe2U.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $bwe2U.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $k2MWg.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($545a07723a10e242$var$analyticsClient && $545a07723a10e242$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $545a07723a10e242$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $bwe2U.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $545a07723a10e242$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $545a07723a10e242$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $545a07723a10e242$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $545a07723a10e242$export$2e2bcd8739ae039 = $545a07723a10e242$var$fireErrorAnalytics;

});
parcelRegister("bwe2U", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $8c0317cdd3b9ae16$export$f5282963edea4a68);

var $5yuCS = parcelRequire("5yuCS");
const $8c0317cdd3b9ae16$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $5yuCS.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $8c0317cdd3b9ae16$export$f5282963edea4a68 = (location, error, details = {})=>(0, $5yuCS.default).captureException(location, error, details);

});
parcelRegister("5yuCS", function(module, exports) {
$parcel$export(module.exports, "default", () => $eefe9bacdf3e258f$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $kOZtN = parcelRequire("kOZtN");
var $iSbcz = parcelRequire("iSbcz");
var $eqszJ = parcelRequire("eqszJ");

var $7xnn4 = parcelRequire("7xnn4");
var $7Z3O0 = parcelRequire("7Z3O0");
var $irlco = parcelRequire("irlco");
var $k7q8g = parcelRequire("k7q8g");

var $eZ8ws = parcelRequire("eZ8ws");
const $eefe9bacdf3e258f$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $eefe9bacdf3e258f$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $eefe9bacdf3e258f$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $eefe9bacdf3e258f$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $eefe9bacdf3e258f$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $iSbcz.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $eefe9bacdf3e258f$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$eefe9bacdf3e258f$var$getFilteredIntegrations(integrations),
                new $7Z3O0.Dedupe(),
                new $irlco.ExtraErrorData(),
                new $k7q8g.Transaction(),
                new $7xnn4.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $eqszJ.init({
        ...defaultConfig,
        ...config
    });
    try {
        $kOZtN.setExtras(getExtraContext());
    } catch (e) {
        $kOZtN.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $eefe9bacdf3e258f$var$tags = [
    'packageName',
    'teamName'
];
const $eefe9bacdf3e258f$var$captureException = (location, error, details)=>{
    $kOZtN.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($eefe9bacdf3e258f$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $kOZtN.captureException(error);
};
const $eefe9bacdf3e258f$var$sentryErrorHandler = {
    installGlobalHandler: $eefe9bacdf3e258f$var$installGlobalHandler,
    captureException: $eefe9bacdf3e258f$var$captureException
};
var $eefe9bacdf3e258f$export$2e2bcd8739ae039 = $eefe9bacdf3e258f$var$sentryErrorHandler;

});
parcelRegister("7xnn4", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $57cdbe7ba483ff33$export$25a43cb5b5c58c08);
parcelRequire("cHlzq");
var $aOrxf = parcelRequire("aOrxf");
var $fjzvX = parcelRequire("fjzvX");
var $5uXzW = parcelRequire("5uXzW");
var $9NITo = parcelRequire("9NITo");
var $kgsGe = parcelRequire("kgsGe");
var $57cdbe7ba483ff33$var$global = (0, $5uXzW.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $57cdbe7ba483ff33$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $aOrxf.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $57cdbe7ba483ff33$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $57cdbe7ba483ff33$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $fjzvX.fill)($57cdbe7ba483ff33$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $kgsGe.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $9NITo.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $9NITo.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($57cdbe7ba483ff33$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("7Z3O0", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $5d012e99a15db4c3$export$688d98c249d31ad3);
parcelRequire("cHlzq");
var $aOrxf = parcelRequire("aOrxf");

var $IGJM8 = parcelRequire("IGJM8");
/** Deduplication filter */ var $5d012e99a15db4c3$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($5d012e99a15db4c3$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $IGJM8.IS_DEBUG_BUILD) && (0, $aOrxf.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $5d012e99a15db4c3$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($5d012e99a15db4c3$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($5d012e99a15db4c3$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $5d012e99a15db4c3$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$5d012e99a15db4c3$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5d012e99a15db4c3$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $5d012e99a15db4c3$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $5d012e99a15db4c3$var$_getExceptionFromEvent(previousEvent);
    var currentException = $5d012e99a15db4c3$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$5d012e99a15db4c3$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5d012e99a15db4c3$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $5d012e99a15db4c3$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $5d012e99a15db4c3$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $5d012e99a15db4c3$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $5d012e99a15db4c3$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $5d012e99a15db4c3$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $5d012e99a15db4c3$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("IGJM8", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $086542ea48df048b$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $086542ea48df048b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("irlco", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $d6cb3142583c58bb$export$56d961ef3a52a072);

var $3Cq0D = parcelRequire("3Cq0D");
parcelRequire("cHlzq");
var $7lAlq = parcelRequire("7lAlq");
var $aOrxf = parcelRequire("aOrxf");
var $1LVrE = parcelRequire("1LVrE");

var $IGJM8 = parcelRequire("IGJM8");
/** Patch toString calls to return proper name for wrapped functions */ var $d6cb3142583c58bb$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $3Cq0D.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $7lAlq.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $3Cq0D.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $1LVrE.normalize)(errorData, this._options.depth);
            if ((0, $7lAlq.isPlainObject)(normalizedErrorData)) contexts = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $3Cq0D.__assign)({}, normalizedErrorData), _a));
            return (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $3Cq0D.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $7lAlq.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $3Cq0D.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $7lAlq.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $IGJM8.IS_DEBUG_BUILD) && (0, $aOrxf.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("k7q8g", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $ea58bb6b8d2bc19f$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $ea58bb6b8d2bc19f$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});




parcelRegister("8M0C4", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $6a7eb855fa449c38$export$e19f9f08a6d79fd2);

var $f7deB = parcelRequire("f7deB");
const $6a7eb855fa449c38$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $6a7eb855fa449c38$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $6a7eb855fa449c38$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $6a7eb855fa449c38$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $6a7eb855fa449c38$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $6a7eb855fa449c38$export$89a175d4190df42e = 'Invoke value functions failed:';
const $6a7eb855fa449c38$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $6a7eb855fa449c38$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $6a7eb855fa449c38$var$BAD_REQUEST = 400;
const $6a7eb855fa449c38$var$REQUEST_TIMEOUT = 408;
const $6a7eb855fa449c38$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $6a7eb855fa449c38$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>{
        var _error$stack;
        return Boolean(typeof error === 'object' && error.name === 'TimeoutError' && ((_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.includes(timedOutResource)));
    };
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $6a7eb855fa449c38$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = (match === null || match === void 0 ? void 0 : match[1]) ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $6a7eb855fa449c38$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($6a7eb855fa449c38$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $6a7eb855fa449c38$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($6a7eb855fa449c38$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $6a7eb855fa449c38$var$BAD_REQUEST;
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $6a7eb855fa449c38$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $6a7eb855fa449c38$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($6a7eb855fa449c38$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($6a7eb855fa449c38$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $f7deB.isClientFetchError)(error)) return $6a7eb855fa449c38$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("f7deB", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $f78d39028a770845$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $f78d39028a770845$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $f78d39028a770845$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $f78d39028a770845$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $f78d39028a770845$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $f78d39028a770845$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($f78d39028a770845$export$3876cb851aa46193.includes(error.name) || $f78d39028a770845$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($f78d39028a770845$export$3876cb851aa46193.includes(error.cause.name) || $f78d39028a770845$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("dtngf", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $3e3b9c8845ca7cc4$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $3e3b9c8845ca7cc4$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $3e3b9c8845ca7cc4$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $3e3b9c8845ca7cc4$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $3e3b9c8845ca7cc4$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $3e3b9c8845ca7cc4$export$ef45e4471aa21b27);

var $iACvP = parcelRequire("iACvP");

var $jVnYA = parcelRequire("jVnYA");
const $3e3b9c8845ca7cc4$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $3e3b9c8845ca7cc4$var$noop = ()=>{};
/**
 * Returned by `getAnalytics` when the requested view type has no registered
 * configuration yet and the guard gate is on, so callers (e.g. `useSubmit`)
 * keep working instead of throwing while configs register lazily.
 */ const $3e3b9c8845ca7cc4$var$UNSUPPORTED_VIEW_TYPE_FALLBACK_ANALYTICS = {
    stopTTI: $3e3b9c8845ca7cc4$var$noop,
    cancelTTI: $3e3b9c8845ca7cc4$var$noop,
    markIframeLoad: $3e3b9c8845ca7cc4$var$noop,
    markFieldsRegistered: $3e3b9c8845ca7cc4$var$noop,
    markOnInitResolved: $3e3b9c8845ca7cc4$var$noop
};
const $3e3b9c8845ca7cc4$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $jVnYA.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $3e3b9c8845ca7cc4$export$e48d55f9cf9962ce(viewType) {
    return (0, $jVnYA.getViewConfiguration)(viewType) !== undefined;
}
function $3e3b9c8845ca7cc4$export$8fc8d6775f1842b8(viewType, fieldType) {
    // View configurations register lazily; until the requested view type is
    // registered, treat the field as unsupported instead of throwing.
    if (!$3e3b9c8845ca7cc4$export$e48d55f9cf9962ce(viewType)) return undefined;
    const fieldsConfiguration = $3e3b9c8845ca7cc4$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$3e3b9c8845ca7cc4$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $iACvP.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $3e3b9c8845ca7cc4$export$e4330d77fd93d1de = (viewType)=>{
    if (!$3e3b9c8845ca7cc4$export$e48d55f9cf9962ce(viewType)) return [];
    return $3e3b9c8845ca7cc4$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
};
function $3e3b9c8845ca7cc4$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $3e3b9c8845ca7cc4$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $3e3b9c8845ca7cc4$export$20eabd2b3ada6bf3(viewType) {
    return $3e3b9c8845ca7cc4$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $3e3b9c8845ca7cc4$export$b768d6a95f7a930(context) {
    if (!$3e3b9c8845ca7cc4$export$e48d55f9cf9962ce(context.viewType)) return false;
    return $3e3b9c8845ca7cc4$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $3e3b9c8845ca7cc4$export$b0297573c90085aa(viewType) {
    if (!$3e3b9c8845ca7cc4$export$e48d55f9cf9962ce(viewType)) return $3e3b9c8845ca7cc4$var$UNSUPPORTED_VIEW_TYPE_FALLBACK_ANALYTICS;
    return $3e3b9c8845ca7cc4$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $3e3b9c8845ca7cc4$export$c0728caa743a409e(viewType) {
    if (!$3e3b9c8845ca7cc4$export$e48d55f9cf9962ce(viewType)) return new Set();
    return $3e3b9c8845ca7cc4$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $3e3b9c8845ca7cc4$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $3e3b9c8845ca7cc4$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("jVnYA", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $9668da81379113ad$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9668da81379113ad$export$f0022a21ccd1f6be);

var $bSJIT = parcelRequire("bSJIT");
const $9668da81379113ad$var$VIEW_CONFIGURATIONS = new Map();
const $9668da81379113ad$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9668da81379113ad$var$VIEW_CONFIGURATIONS.has(viewType)) $9668da81379113ad$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9668da81379113ad$export$176b6e68da08ffa2 = (viewType)=>$9668da81379113ad$var$VIEW_CONFIGURATIONS.get(viewType);
const $9668da81379113ad$export$e8091eff40c4f16e = ()=>{
    $9668da81379113ad$var$VIEW_CONFIGURATIONS.clear();
};
const $9668da81379113ad$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    /**
   * Uses useMemo to load view configuration during the first render, before mount.
   */ (0, $bSJIT.useMemo)(()=>{
        $9668da81379113ad$export$cda1ad403b37fe70(viewType, new configurationClass());
    }, [
        viewType,
        configurationClass
    ]);
};

});




parcelRegister("akEfV", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $f62bc9c7f36b1415$export$93459ad9bfd6c380);
const $f62bc9c7f36b1415$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("5EBuM", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $f3aa5fae9123d31d$export$7f7be235f64f029b);
const $f3aa5fae9123d31d$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs === null || internalScreenTabs === void 0 ? void 0 : internalScreenTabs.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("1X6bW", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $01d16b8d97a0f7a5$export$352dfcce04d66748);

var $iiozI = parcelRequire("iiozI");

var $dtngf = parcelRequire("dtngf");

var $2ZsQR = parcelRequire("2ZsQR");
const $01d16b8d97a0f7a5$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        var _internalFormMetadata, _getSupportedFieldCon;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = (_internalFormMetadata = internalFormMetadata[fieldId]) === null || _internalFormMetadata === void 0 ? void 0 : _internalFormMetadata.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (_getSupportedFieldCon = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $2ZsQR.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
   * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
   * Otherwise, UIM app may not be notified about every single change.
   */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($iiozI)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("iiozI", function(module, exports) {

var $cObST = parcelRequire("cObST");
/** Used to generate unique IDs. */ var $d51cf888d8541ee6$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $d51cf888d8541ee6$var$uniqueId(prefix) {
    var id = ++$d51cf888d8541ee6$var$idCounter;
    return $cObST(prefix) + id;
}
module.exports = $d51cf888d8541ee6$var$uniqueId;

});

parcelRegister("2ZsQR", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $0cd1ac9106014200$export$25441a03bb8f1cb0);

var $dMMwa = parcelRequire("dMMwa");

var $eK8kB = parcelRequire("eK8kB");
const $0cd1ac9106014200$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    var _formData$fieldId;
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $eK8kB.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = (_formData$fieldId = formData[fieldId]) === null || _formData$fieldId === void 0 ? void 0 : _formData$fieldId.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("kkpzw", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $a8c060ec7980bdfa$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $a8c060ec7980bdfa$export$1ca69a85bb7273de);

var $67zrY = parcelRequire("67zrY");

var $eZ8ws = parcelRequire("eZ8ws");
const $a8c060ec7980bdfa$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $a8c060ec7980bdfa$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($67zrY)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("jxRzc", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $7b864ee1160b0acf$export$6556d46d2662453c);

var $2ZsQR = parcelRequire("2ZsQR");
const $7b864ee1160b0acf$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
   * We can set new field value only if the field was initialized.
   * This checks the field metedata that indicates the successfull initialization.
   */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $2ZsQR.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("ejb33", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $5ecd2fb6a73a6d53$export$21363496760d39cd);
const $5ecd2fb6a73a6d53$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("1H88d", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $2aafdcf9790f4098$export$cceae62fd4d1ef0a);

var $i2WqQ = parcelRequire("i2WqQ");

var $cYXOj = parcelRequire("cYXOj");

var $egWdp = parcelRequire("egWdp");

var $2EVMc = parcelRequire("2EVMc");

var $8KPB9 = parcelRequire("8KPB9");

var $k5cNw = parcelRequire("k5cNw");

var $bXyPv = parcelRequire("bXyPv");

var $bFDDA = parcelRequire("bFDDA");

var $fLnbH = parcelRequire("fLnbH");

var $fzhHu = parcelRequire("fzhHu");

var $8J7lj = parcelRequire("8J7lj");

var $c9UVF = parcelRequire("c9UVF");
const $2aafdcf9790f4098$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $k5cNw.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $fzhHu.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY)]: internalMetadata.allowedValues,
                [(0, $egWdp.LOOKUP_SOURCE_USERS_ASYNC_DATA)]: lookupDataFromApi[0, $egWdp.LOOKUP_SOURCE_USERS_ASYNC_DATA],
                [(0, $egWdp.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA)]: lookupDataFromApi[0, $egWdp.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA],
                [(0, $egWdp.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA)]: lookupDataFromApi[0, $egWdp.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA],
                [(0, $egWdp.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA)]: lookupDataFromApi[0, $egWdp.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $c9UVF.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl,
                fieldExtraData: internalMetadata.extraData
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $fLnbH.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $bXyPv.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $2EVMc.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ)))(errorsByField)) throw new (0, $8KPB9.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $bFDDA.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $8J7lj.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
parcelRegister("egWdp", function(module, exports) {
$parcel$export(module.exports, "LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY", () => $e7c46833dc642fa8$export$a1cacdcf198da901);
$parcel$export(module.exports, "LOOKUP_SOURCE_USERS_ASYNC_DATA", () => $e7c46833dc642fa8$export$3a106242c8f57ac2);
$parcel$export(module.exports, "LOOKUP_SOURCE_PROJECTS_ASYNC_DATA", () => $e7c46833dc642fa8$export$e10d4d251d909c59);
$parcel$export(module.exports, "LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA", () => $e7c46833dc642fa8$export$45fd2b84447c8617);
$parcel$export(module.exports, "LOOKUP_SOURCE_VERSIONS_ASYNC_DATA", () => $e7c46833dc642fa8$export$b23dae8d7ea7032f);
$parcel$export(module.exports, "AUTOMATIC_ID", () => $e7c46833dc642fa8$export$f5d5f6bb902f1027);
const $e7c46833dc642fa8$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $e7c46833dc642fa8$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $e7c46833dc642fa8$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $e7c46833dc642fa8$export$45fd2b84447c8617 = 'LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA';
const $e7c46833dc642fa8$export$b23dae8d7ea7032f = 'LOOKUP_SOURCE_VERSIONS_ASYNC_DATA';
const $e7c46833dc642fa8$export$f5d5f6bb902f1027 = '-1';
const $e7c46833dc642fa8$export$106087dcfd4fb129 = 100;

});

parcelRegister("2EVMc", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $677cdd0515872cfd$export$4027d961191df7c3);
function $677cdd0515872cfd$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (fieldsChanges && (lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.changeId) === changeId) {
        const fid = lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("8KPB9", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $f457a7f3e6832025$export$9e8b5e552e255163);

var $t3G1N = parcelRequire("t3G1N");
class $f457a7f3e6832025$export$9e8b5e552e255163 extends (0, $t3G1N.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("t3G1N", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $40487c312fda1e40$export$6e8165c81a6a65df);
class $40487c312fda1e40$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("k5cNw", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $bd33dca0877e964d$export$fbe9157c12cb4e7b);
const $bd33dca0877e964d$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>{
    var _registeredFields$app;
    return !!((_registeredFields$app = registeredFields[appId]) !== null && _registeredFields$app !== void 0 && (_registeredFields$app = _registeredFields$app[changeId]) !== null && _registeredFields$app !== void 0 && _registeredFields$app.includes(fieldId));
};

});

parcelRegister("bXyPv", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7601f292e212ed97$export$460820f27643954e);

var $dtngf = parcelRequire("dtngf");
const $7601f292e212ed97$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("bFDDA", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $bc1bdb51297b4b01$export$e1fce51bc5be90b7);
const $bc1bdb51297b4b01$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("fLnbH", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $6da67efc72f7bea3$export$aa453854f74fab);

var $iACvP = parcelRequire("iACvP");

var $dtngf = parcelRequire("dtngf");
const $6da67efc72f7bea3$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $iACvP.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.optionsVisibility) try {
        const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $iACvP.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("c9UVF", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $54273e05426e9420$export$d14f85c01e334a1);

var $i2WqQ = parcelRequire("i2WqQ");

var $gdUUy = parcelRequire("gdUUy");

var $cnEqX = parcelRequire("cnEqX");

var $dtngf = parcelRequire("dtngf");

var $9m9kx = parcelRequire("9m9kx");

var $k8sJ1 = parcelRequire("k8sJ1");

var $7vkFP = parcelRequire("7vkFP");

var $rNKIe = parcelRequire("rNKIe");
const $54273e05426e9420$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl, fieldExtraData: fieldExtraData })=>{
    const fieldConfiguration = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $7vkFP.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldContext = fieldExtraData && (0, $gdUUy.fg)('ditto_uim_jsm_user_picker_email') ? {
        fieldId: fieldId,
        extraData: fieldExtraData
    } : {
        fieldId: fieldId
    };
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $7vkFP.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $cnEqX.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $9m9kx.FIELD_VALIDATION_ERROR),
                        method: (0, $k8sJ1.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $rNKIe.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $rNKIe.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("cnEqX", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $ffa4e93676c70215$export$73c2f0689b6c4a5a);
class $ffa4e93676c70215$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("7vkFP", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $c194fe5d65bd8370$export$ee79e3ab53b8db79);
const $c194fe5d65bd8370$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("rNKIe", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e502ce7104c732d5$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e502ce7104c732d5$export$ddd005554aecd409);
const $e502ce7104c732d5$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e502ce7104c732d5$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("iczKd", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $e2547da6b53453aa$export$131c67fd312b8a11);

var $NTiok = parcelRequire("NTiok");

var $jNr5n = parcelRequire("jNr5n");

var $8J7lj = parcelRequire("8J7lj");

var $5QLtK = parcelRequire("5QLtK");
const $e2547da6b53453aa$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $5QLtK.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $5QLtK.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $8J7lj.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $NTiok.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $5QLtK.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $jNr5n.toScreenTabsValidationError))
        });
    };

});
parcelRegister("NTiok", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $b65d0e61de69fc8e$export$faf1f1824ee0a136);

var $t3G1N = parcelRequire("t3G1N");
class $b65d0e61de69fc8e$export$faf1f1824ee0a136 extends (0, $t3G1N.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("jNr5n", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $2225f81b33158427$export$b2675440ade984fb);

var $9m9kx = parcelRequire("9m9kx");
const $2225f81b33158427$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $9m9kx.SCREENTABS_VALIDATION_ERROR)
    });

});

parcelRegister("5QLtK", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $df8049019ef9536f$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $df8049019ef9536f$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $df8049019ef9536f$export$62d63af83dac7315);
const $df8049019ef9536f$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $df8049019ef9536f$var$isValidScreenTabId = (internalScreenTabs, id)=>$df8049019ef9536f$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $df8049019ef9536f$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $df8049019ef9536f$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $df8049019ef9536f$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$df8049019ef9536f$var$isValidScreenTabId(internalScreenTabs, id) && $df8049019ef9536f$var$isValidScreenTabIsVisible(isVisible) && $df8049019ef9536f$var$isValidScreenTabIsActive(isActive);
const $df8049019ef9536f$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($df8049019ef9536f$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $df8049019ef9536f$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($df8049019ef9536f$var$isValidScreenTabIsActive(isActive) && isActive && $df8049019ef9536f$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $df8049019ef9536f$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    var _screenTabsInternalUp;
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof ((_screenTabsInternalUp = screenTabsInternalUpdated[0]) === null || _screenTabsInternalUp === void 0 ? void 0 : _screenTabsInternalUp.isActive) !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $df8049019ef9536f$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$df8049019ef9536f$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($df8049019ef9536f$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($df8049019ef9536f$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $df8049019ef9536f$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    screenTabsFromApp.forEach((tab)=>{
        if (!$df8049019ef9536f$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$df8049019ef9536f$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$df8049019ef9536f$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$df8049019ef9536f$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($df8049019ef9536f$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($df8049019ef9536f$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("8MlrR", function(module, exports) {
$parcel$export(module.exports, "REQUEST_CREATE_VIEW_TYPE", () => $2497adba22a9164c$export$f5706508058e3b54);
const $2497adba22a9164c$export$f5706508058e3b54 = 'JSMRequestCreate';

});

parcelRegister("izwKR", function(module, exports) {
$parcel$export(module.exports, "RequestCreateViewConfiguration", () => $80f7318258e37034$export$4193c77f3bdf79ba);

var $lFpPv = parcelRequire("lFpPv");

var $iaKuz = parcelRequire("iaKuz");

var $57l7A = parcelRequire("57l7A");

var $87QgR = parcelRequire("87QgR");

var $egWdp = parcelRequire("egWdp");

var $7xMPE = parcelRequire("7xMPE");

var $8NheM = parcelRequire("8NheM");

var $jM78h = parcelRequire("jM78h");

var $4WK8W = parcelRequire("4WK8W");

var $8r0fo = parcelRequire("8r0fo");

var $bLrNY = parcelRequire("bLrNY");

var $cc3rE = parcelRequire("cc3rE");

var $lycA5 = parcelRequire("lycA5");

var $ikkbH = parcelRequire("ikkbH");

var $mE8bO = parcelRequire("mE8bO");

var $dKhv1 = parcelRequire("dKhv1");

var $fAPVP = parcelRequire("fAPVP");

var $88x0p = parcelRequire("88x0p");

var $iG8Fo = parcelRequire("iG8Fo");

var $fBA4L = parcelRequire("fBA4L");

var $3cPfj = parcelRequire("3cPfj");

var $3cdTA = parcelRequire("3cdTA");

var $gASCv = parcelRequire("gASCv");

var $kySpt = parcelRequire("kySpt");

var $bQPxx = parcelRequire("bQPxx");
const $80f7318258e37034$export$b3302682bd74b905 = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_embedded_request_page');
const $80f7318258e37034$export$97cf619b5c503901 = ()=>(0, $87QgR.default).checkGate('uim_jsm_textfield_support');
const $80f7318258e37034$export$3d9060e51ab7079e = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_multi_select_support');
const $80f7318258e37034$export$5377338157c93a4a = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_number_field_support');
const $80f7318258e37034$export$ca4e8050793caa6 = ()=>(0, $87QgR.default).checkGate('uim_jsm_duedate_support');
const $80f7318258e37034$export$a3127feadc5f63ef = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_datetime_field_support');
const $80f7318258e37034$export$120971fff910541d = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_description_support');
const $80f7318258e37034$export$b738c6acf33d051a = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_cascading_select_support');
const $80f7318258e37034$export$1df7079ae40c80e4 = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_datepicker_field_support');
const $80f7318258e37034$export$d16c700a701ab994 = ()=>(0, $87QgR.default).checkGate('ditto_uim_jsm_user_picker_support');
class $80f7318258e37034$export$4193c77f3bdf79ba {
    getAnalytics() {
        return this.analytics;
    }
    /**
   * On other views in Jira, we check if we support a specific project type available from execution context
   * Here, in JSM, there is nothing specific available from Execution Context that we should check
   */ isExecutionContextSupported() {
        return true;
    }
    getConsentMessage() {
        return (0, $kySpt.default).obligatoryUimRequestCreateConsentMessage;
    }
    getSupportedTriggerPointsConfiguration() {
        if ($80f7318258e37034$export$b3302682bd74b905()) return new Set([
            (0, $bLrNY.DEFAULT),
            (0, $bLrNY.EMBEDDED_REQUEST_CREATE)
        ]);
        return new Set([
            (0, $bLrNY.DEFAULT)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $8r0fo.stopTTI,
            cancelTTI: $8r0fo.cancelTTI,
            markIframeLoad: $8r0fo.markIframeLoad,
            markFieldsRegistered: $8r0fo.markFieldsRegistered,
            markOnInitResolved: $8r0fo.markOnInitResolved
        };
        /**
   * memoizeOne is used to avoid recreating the config objects.
   */ this.getSupportedFieldsConfiguration = (0, $57l7A.default)(()=>{
            const commonFieldValidators = (0, $7xMPE.getCommonFieldValidators)();
            const userPickerSupportEnabled = $80f7318258e37034$export$d16c700a701ab994();
            // Only check the email gate when user picker support is on, so its exposure is scoped to user pickers
            const userPickerEmailSupportEnabled = userPickerSupportEnabled && (0, $lFpPv.isUserPickerEmailSupportEnabled)();
            return {
                [(0, $bLrNY.SUMMARY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $jM78h.validateSingleLineTextValue)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, $fBA4L.singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur',
                    modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                },
                [(0, $bLrNY.SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $8NheM.selectSetValueValidator),
                        optionsVisibility: (0, $4WK8W.validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, $iG8Fo.selectSetValueTransformer),
                        optionsVisibility: (0, $iG8Fo.transformSelectSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $iG8Fo.selectGetValueTransformer),
                        optionsVisibility: (0, $iG8Fo.transformSelectGetOptionsVisibility)
                    },
                    lookupSource: (0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    emitChangeOn: 'change',
                    modifyValueToBasic: (0, $iG8Fo.modifySelectValueToBasic)
                },
                ...$80f7318258e37034$export$97cf619b5c503901() && {
                    [(0, $bLrNY.TEXT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $jM78h.validateSingleLineTextValue)
                        },
                        publicToInternalTransformers: {},
                        internalToPublicTransformers: {
                            value: (0, $fBA4L.singleLineTextFieldGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    }
                },
                ...$80f7318258e37034$export$5377338157c93a4a() && {
                    [(0, $bLrNY.NUMBER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $fAPVP.validateNumberValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $fAPVP.transformNumberToInternalValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $fAPVP.transformNumberToPublicValue)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    }
                },
                ...$80f7318258e37034$export$3d9060e51ab7079e() && {
                    [(0, $bLrNY.MULTI_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $dKhv1.validateMultiCheckboxSetValue),
                            optionsVisibility: (0, $4WK8W.validateSetOptionsVisibilityRule)
                        },
                        publicToInternalTransformers: {
                            value: (0, $dKhv1.multiCheckboxSetValueTransformer),
                            optionsVisibility: (0, $dKhv1.multiCheckboxSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $dKhv1.multiCheckboxGetValueTransformer),
                            optionsVisibility: (0, $dKhv1.multiCheckboxGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        propertyMapping: {
                            optionsVisibility: 'options'
                        },
                        modifyValueToBasic: (0, $dKhv1.modifyMultiSelectValueToBasic)
                    }
                },
                ...(0, $lFpPv.isRadioButtonsSupportEnabled)() && {
                    [(0, $bLrNY.RADIO_BUTTONS_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $8NheM.selectSetValueValidator),
                            optionsVisibility: (0, $bQPxx.validateSetOptionsVisibility)
                        },
                        publicToInternalTransformers: {
                            value: (0, $3cPfj.radioButtonsSetValueTransformer),
                            optionsVisibility: (0, $3cPfj.radioButtonsSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $3cPfj.radioButtonsGetValueTransformer),
                            optionsVisibility: (0, $3cPfj.radioButtonsGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'items',
                            value: 'value'
                        },
                        propertyMapping: {
                            optionsVisibility: 'items'
                        },
                        transformInitialValue: (value, field)=>(0, $3cPfj.radioButtonsValueToSelectedOptionTransformer)(value, field.items),
                        transformUrlParamValue: (value, field)=>(0, $3cPfj.radioButtonsValueToSelectedOptionTransformer)(value, field.items),
                        modifyValueToBasic: (0, $3cPfj.modifyRadioButtonsValueToBasic)
                    }
                },
                ...(0, $lFpPv.isMultiCheckboxSupportEnabled)() && {
                    [(0, $bLrNY.MULTI_CHECKBOX_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $dKhv1.validateMultiCheckboxSetValue),
                            optionsVisibility: (0, $bQPxx.validateSetOptionsVisibility)
                        },
                        publicToInternalTransformers: {
                            value: (0, $dKhv1.multiCheckboxSetValueTransformer),
                            optionsVisibility: (0, $dKhv1.multiCheckboxSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $dKhv1.multiCheckboxGetValueTransformer),
                            optionsVisibility: (0, $dKhv1.multiCheckboxGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'items',
                            value: 'value'
                        },
                        propertyMapping: {
                            optionsVisibility: 'items'
                        },
                        modifyValueToBasic: (0, $dKhv1.modifyMultiSelectValueToBasic),
                        transformInitialValue: (value, field)=>(0, $dKhv1.multiCheckboxValueToSelectedOptionsTransformer)(value, field.items),
                        transformUrlParamValue: (urlParamValue, field)=>(0, $dKhv1.multiCheckboxValueToSelectedOptionsTransformer)(urlParamValue, field.items)
                    }
                },
                [(0, $bLrNY.PRIORITY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $88x0p.validatePrioritySetValue),
                        optionsVisibility: (0, $bQPxx.validateSetOptionsVisibility)
                    },
                    publicToInternalTransformers: {
                        value: (0, $88x0p.prioritySetValueTransformer),
                        optionsVisibility: (0, $88x0p.prioritySetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $88x0p.priorityGetValueTransformer),
                        optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    modifyValueToBasic: (0, $88x0p.modifyPriorityValueToBasic)
                },
                ...$80f7318258e37034$export$ca4e8050793caa6() && {
                    [(0, $bLrNY.DUE_DATE_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $lycA5.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $lycA5.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $lycA5.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    }
                },
                ...$80f7318258e37034$export$a3127feadc5f63ef() && {
                    [(0, $bLrNY.DATETIME_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $ikkbH.validateDateTimePickerSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $ikkbH.transformDateTimePickerSetValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $ikkbH.transformDateTimePickerGetValue)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    }
                },
                [(0, $bLrNY.TEXT_AREA_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $3cdTA.validateTextAreaValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, $3cdTA.textAreaSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, $3cdTA.textAreaGetValueTransformer)
                    },
                    emitChangeOn: 'blur',
                    modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                },
                ...$80f7318258e37034$export$120971fff910541d() && {
                    [(0, $bLrNY.DESCRIPTION_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $3cdTA.validateTextAreaValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $3cdTA.textAreaSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $3cdTA.textAreaGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    }
                },
                ...$80f7318258e37034$export$b738c6acf33d051a() && {
                    [(0, $bLrNY.CASCADING_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $cc3rE.validateCascadingSelectSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $cc3rE.transformSetValueCascadingSelect)
                        },
                        internalToPublicTransformers: {
                            value: (0, $cc3rE.transformGetValueCascadingSelect)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $egWdp.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        modifyValueToBasic: (0, $cc3rE.transformValueToBasicCascadingSelect),
                        transformUrlParamValue: (urlParamValue, field)=>(0, $cc3rE.transformCascadingSelectUrlParamValue)(urlParamValue, field.options)
                    }
                },
                ...$80f7318258e37034$export$1df7079ae40c80e4() && {
                    [(0, $bLrNY.DATEPICKER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $lycA5.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $lycA5.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $lycA5.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($iaKuz)))
                    }
                },
                [(0, $bLrNY.LABELS_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $mE8bO.labelsSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, $mE8bO.labelsSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, $mE8bO.labelsGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    initializeFieldPropertyMapping: {
                        value: 'defaultLabels'
                    },
                    modifyValueToBasic: (0, $mE8bO.modifyLabelsValueToBasic)
                },
                ...userPickerSupportEnabled && {
                    [(0, $bLrNY.USER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $gASCv.validateUserPickerSetValue)
                        },
                        publicToInternalTransformers: {
                            // With the gate on, the transformer uses the Portal's own user search, so the
                            // core's user lookup isn't needed
                            value: userPickerEmailSupportEnabled ? (0, $gASCv.userPickerPortalSetValueTransformer) : (0, $gASCv.userPickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $gASCv.userPickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        ...!userPickerEmailSupportEnabled && {
                            lookupSource: (0, $egWdp.LOOKUP_SOURCE_USERS_ASYNC_DATA)
                        },
                        initializeFieldPropertyMapping: {
                            value: 'defaultUser'
                        },
                        modifyValueToBasic: (0, $gASCv.modifyUserPickerValueToBasic)
                    }
                }
            };
        });
        this.getSupportedFieldTypes = (0, $57l7A.default)(()=>{
            return Object.keys(this.getSupportedFieldsConfiguration());
        });
        // Note: should be removed by bumping @atlassian/ui-modifications-core to the next minor version. Behavior will default to being true.
        this.isScreenTabsSupportEnabled = ()=>true;
    }
}

});
parcelRegister("7xMPE", function(module, exports) {
$parcel$export(module.exports, "getCommonFieldValidators", () => $062d5fbddaf9788e$export$68248012b0fecf7d);
const $062d5fbddaf9788e$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $062d5fbddaf9788e$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $062d5fbddaf9788e$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    return true;
};

});

parcelRegister("8NheM", function(module, exports) {
$parcel$export(module.exports, "selectSetValueValidator", () => $c28fd705c68a792c$export$c02b1c2a574ca4c7);

var $w81Hd = parcelRequire("w81Hd");

var $5iRil = parcelRequire("5iRil");
const $c28fd705c68a792c$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $5iRil.isNotEmptyString)(value);
const $c28fd705c68a792c$export$f22935386c756879 = (value)=>value === null || (0, $5iRil.isNotEmptyString)(value) && (0, $w81Hd.isAriResourceIdValid)(value);

});
parcelRegister("w81Hd", function(module, exports) {
$parcel$export(module.exports, "isAriResourceIdValid", () => $e7b648d9746b92e5$export$4d1e9901084f3bf6);

var $5DJzO = parcelRequire("5DJzO");
const $e7b648d9746b92e5$var$CLOUD_ID_MOCK = 'cloud-id';
const $e7b648d9746b92e5$var$ACTIVATION_ID_MOCK = 'activation-id';
const $e7b648d9746b92e5$var$FIELD_ID_MOCK = 'field-1';
const $e7b648d9746b92e5$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $5DJzO.JiraIssueFieldOptionAri).create({
            siteId: $e7b648d9746b92e5$var$CLOUD_ID_MOCK,
            activationId: $e7b648d9746b92e5$var$ACTIVATION_ID_MOCK,
            fieldId: $e7b648d9746b92e5$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("5DJzO", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $41b3f2d887fb529d$export$e3bc1ec22f941fbe);

var $jsS39 = parcelRequire("jsS39");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/jira/issue-field-option/manifest.ts
var $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jsS39.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $jsS39.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $41b3f2d887fb529d$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $41b3f2d887fb529d$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("jsS39", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $e2ba8f093709df18$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $e2ba8f093709df18$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $e2ba8f093709df18$export$eb4f4cf0880fe5a8 = "jira", $e2ba8f093709df18$export$4bec333360908e78 = "issue-field-option";

});



parcelRegister("5iRil", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyString", () => $3ace3cd2273c942f$export$582443c7ead02173);
const $3ace3cd2273c942f$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});


parcelRegister("jM78h", function(module, exports) {
$parcel$export(module.exports, "validateSingleLineTextValue", () => $0807efe54523f376$export$88db43fe998a9953);
const $0807efe54523f376$export$88db43fe998a9953 = (value)=>typeof value === 'string';

});

parcelRegister("4WK8W", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $455a43738dd3f69b$export$cb8a43658ea03ec7);

var $awGqx = parcelRequire("awGqx");

var $5iRil = parcelRequire("5iRil");
const $455a43738dd3f69b$export$cb8a43658ea03ec7 = (optionsVisibility)=>(0, (/*@__PURE__*/$parcel$interopDefault($awGqx)))(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $5iRil.isNotEmptyString));

});

parcelRegister("8r0fo", function(module, exports) {
$parcel$export(module.exports, "startScreenTTIWithUIModifications", () => $f3a0e672a177e45a$export$750bc2c2ef1a94b6);
$parcel$export(module.exports, "stopTTI", () => $f3a0e672a177e45a$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $f3a0e672a177e45a$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $f3a0e672a177e45a$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $f3a0e672a177e45a$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $f3a0e672a177e45a$export$d86f4868694f2aa7);

var $1ZJcz = parcelRequire("1ZJcz");
const $f3a0e672a177e45a$export$376630eeb367a07a = (0, $1ZJcz.metrics).interaction({
    key: 'request-create-tti-with-ui-modifications',
    timings: [
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $f3a0e672a177e45a$export$750bc2c2ef1a94b6 = ()=>{
    $f3a0e672a177e45a$export$376630eeb367a07a.start();
};
const $f3a0e672a177e45a$export$30ca4c461fab486c = (customData)=>{
    $f3a0e672a177e45a$export$376630eeb367a07a.stop({
        customData: customData
    });
};
const $f3a0e672a177e45a$export$27f2445288b528c = ()=>{
    $f3a0e672a177e45a$export$376630eeb367a07a.cancel();
};
const $f3a0e672a177e45a$export$7a2709fc1e33401a = ()=>{
    $f3a0e672a177e45a$export$376630eeb367a07a.mark('iframe-load');
};
const $f3a0e672a177e45a$export$cf3893335c93e33b = ()=>{
    $f3a0e672a177e45a$export$376630eeb367a07a.mark('fields-registered');
};
const $f3a0e672a177e45a$export$d86f4868694f2aa7 = ()=>{
    $f3a0e672a177e45a$export$376630eeb367a07a.mark('oninit-resolved');
};

});

parcelRegister("bLrNY", function(module, exports) {
$parcel$export(module.exports, "SUMMARY_TYPE", () => $adb081d7f40154b3$export$907219511d14ba3d);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $adb081d7f40154b3$export$22ac48a51c014e4b);
$parcel$export(module.exports, "USER_CF_TYPE", () => $adb081d7f40154b3$export$c491a4b98394028e);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $adb081d7f40154b3$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $adb081d7f40154b3$export$39cd48613b53ce2f);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $adb081d7f40154b3$export$c5d13ea26562d57a);
$parcel$export(module.exports, "MULTI_CHECKBOX_CF_TYPE", () => $adb081d7f40154b3$export$8293a3964f8ad43a);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $adb081d7f40154b3$export$65524be5675e57e6);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $adb081d7f40154b3$export$34740f8d07d23ac0);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $adb081d7f40154b3$export$c7faa96db185cfc6);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $adb081d7f40154b3$export$42d097f7b1622ef1);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $adb081d7f40154b3$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $adb081d7f40154b3$export$5e7324042f1d6b31);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $adb081d7f40154b3$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "DATEPICKER_CF_TYPE", () => $adb081d7f40154b3$export$69c9cc9ff399807f);
$parcel$export(module.exports, "LABELS_TYPE", () => $adb081d7f40154b3$export$43b6e33ec70f2272);
$parcel$export(module.exports, "DEFAULT", () => $adb081d7f40154b3$export$e6952b12ade67489);
$parcel$export(module.exports, "EMBEDDED_REQUEST_CREATE", () => $adb081d7f40154b3$export$75d9313789677296);
const $adb081d7f40154b3$export$907219511d14ba3d = 'summary';
const $adb081d7f40154b3$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $adb081d7f40154b3$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $adb081d7f40154b3$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $adb081d7f40154b3$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $adb081d7f40154b3$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $adb081d7f40154b3$export$8293a3964f8ad43a = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $adb081d7f40154b3$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $adb081d7f40154b3$export$34740f8d07d23ac0 = 'priority';
const $adb081d7f40154b3$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $adb081d7f40154b3$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $adb081d7f40154b3$export$b159f8b8f27aae4c = 'duedate';
const $adb081d7f40154b3$export$5e7324042f1d6b31 = 'description';
const $adb081d7f40154b3$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $adb081d7f40154b3$export$69c9cc9ff399807f = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $adb081d7f40154b3$export$43b6e33ec70f2272 = 'labels';
const $adb081d7f40154b3$export$e6952b12ade67489 = 'default';
const $adb081d7f40154b3$export$75d9313789677296 = 'embedded-request-create';

});

parcelRegister("cc3rE", function(module, exports) {
$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $2114c47a5854a3e6$export$2d586ab6ce4d7126);
$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $2114c47a5854a3e6$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $2114c47a5854a3e6$export$47e9770ed0d1c344);
$parcel$export(module.exports, "transformCascadingSelectUrlParamValue", () => $2114c47a5854a3e6$export$ceeb970e37fe21da);
$parcel$export(module.exports, "normalizeCascadingSelectValue", () => $2114c47a5854a3e6$export$e9eb61f6a3bc0438);
$parcel$export(module.exports, "transformValueToBasicCascadingSelect", () => $2114c47a5854a3e6$export$4fe225ca7554ff11);

var $cnEqX = parcelRequire("cnEqX");

var $5iRil = parcelRequire("5iRil");

var $87QgR = parcelRequire("87QgR");
const $2114c47a5854a3e6$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.value === parentId);
    if (!foundOption) throw new (0, $cnEqX.FieldValueLookupError)();
    const childOption = childId !== null && foundOption.children ? foundOption.children.find((child)=>child.value === childId) || null : null;
    const value = {
        parent: foundOption,
        children: childOption
    };
    return value;
};
const $2114c47a5854a3e6$export$2d586ab6ce4d7126 = (value)=>{
    return value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $5iRil.isNotEmptyString)(value.parentId) && ((0, $5iRil.isNotEmptyString)(value.childId) || value.childId === null);
};
const $2114c47a5854a3e6$export$905a8d55c641a71e = (value, lookupData)=>{
    if (value === null || value.parentId === null) return null;
    const cascadingSelectValue = $2114c47a5854a3e6$var$findCascadingSelectLookupValues(lookupData, value.parentId, value.childId);
    return {
        primaryValue: cascadingSelectValue.parent,
        children: cascadingSelectValue.children
    };
};
const $2114c47a5854a3e6$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue || (0, $87QgR.default).checkGate('ditto_fix_getvalue_empty_state') && !cascadingValue.primaryValue) return null;
    const { primaryValue: primaryValue, children: children } = cascadingValue;
    return {
        parent: {
            id: primaryValue.value,
            value: primaryValue.label
        },
        child: children ? {
            id: children.value,
            value: children.label
        } : null
    };
};
const $2114c47a5854a3e6$var$isCascadingSelectUrlParamValue = (value)=>{
    if (!value || typeof value !== 'object' || !('primaryValue' in value)) return false;
    const primaryValue = value.primaryValue;
    const children = 'children' in value ? value.children : undefined;
    return typeof primaryValue === 'string' && (children === undefined || typeof children === 'string');
};
const $2114c47a5854a3e6$export$ceeb970e37fe21da = (urlParamValue, lookupData)=>{
    if (!$2114c47a5854a3e6$var$isCascadingSelectUrlParamValue(urlParamValue) || !lookupData) return null;
    const { primaryValue: parentId, children: childId } = urlParamValue;
    const parentOption = lookupData.find((opt)=>opt.value === parentId);
    if (!parentOption) return null;
    const childOption = childId !== undefined && parentOption.children ? parentOption.children.find((opt)=>opt.value === childId) ?? null : null;
    return {
        primaryValue: parentOption,
        children: childOption
    };
};
const $2114c47a5854a3e6$export$e9eb61f6a3bc0438 = (value)=>{
    var _children, _value$primaryValue;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    // If it's already NestedFieldValueType (string-based primaryValue)
    if (typeof value.primaryValue === 'string' || value.primaryValue === null) return value;
    // If it's object-based, extract string values
    const childrenValue = (_children = value.children) === null || _children === void 0 ? void 0 : _children.value;
    return {
        primaryValue: ((_value$primaryValue = value.primaryValue) === null || _value$primaryValue === void 0 ? void 0 : _value$primaryValue.value) || null,
        children: childrenValue || null
    };
};
const $2114c47a5854a3e6$export$4fe225ca7554ff11 = (value)=>{
    var _value$primaryValue2, _value$children;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    return {
        primaryValue: ((_value$primaryValue2 = value.primaryValue) === null || _value$primaryValue2 === void 0 ? void 0 : _value$primaryValue2.value) || null,
        children: ((_value$children = value.children) === null || _value$children === void 0 ? void 0 : _value$children.value) || null
    };
};

});

parcelRegister("lycA5", function(module, exports) {
$parcel$export(module.exports, "datePickerSetValueValidator", () => $5d66937d50125692$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $5d66937d50125692$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $5d66937d50125692$export$e844c6ac3a5cbef7);

var $53JkC = parcelRequire("53JkC");
var $lMRHO = parcelRequire("lMRHO");
var $OORRb = parcelRequire("OORRb");
var $5xMcQ = parcelRequire("5xMcQ");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $5d66937d50125692$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $OORRb.default)(date, dateFormat, new Date());
    return (0, $lMRHO.default)(parsedDate);
};
const $5d66937d50125692$export$c003579a97a2459e = (value)=>value === null || $5d66937d50125692$var$dateHasExpectedFormat(value);
const $5d66937d50125692$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $5d66937d50125692$export$e844c6ac3a5cbef7 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $5xMcQ.default)(value);
    if ((0, $lMRHO.default)(parsedDate)) return (0, $53JkC.default)(parsedDate, 'yyyy-MM-dd');
    return null;
};

});
parcelRegister("OORRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $098c20e22326c43a$export$2e2bcd8739ae039);

var $2JMbT = parcelRequire("2JMbT");

var $6bCYq = parcelRequire("6bCYq");

var $3Bqtq = parcelRequire("3Bqtq");

var $hxQgK = parcelRequire("hxQgK");

var $897M5 = parcelRequire("897M5");

var $5ztic = parcelRequire("5ztic");

var $fA6jx = parcelRequire("fA6jx");

var $6nu0h = parcelRequire("6nu0h");

var $ko8Cm = parcelRequire("ko8Cm");

var $cPnJw = parcelRequire("cPnJw");

var $OPOsJ = parcelRequire("OPOsJ");

var $k5HYt = parcelRequire("k5HYt");

var $3gG1s = parcelRequire("3gG1s");

var $lLJTa = parcelRequire("lLJTa");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $098c20e22326c43a$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $098c20e22326c43a$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $098c20e22326c43a$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $098c20e22326c43a$var$doubleQuoteRegExp = /''/g;
var $098c20e22326c43a$var$notWhitespaceRegExp = /\S/;
var $098c20e22326c43a$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $098c20e22326c43a$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $OPOsJ.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3Bqtq.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $cPnJw.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $cPnJw.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $897M5.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $k5HYt.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($098c20e22326c43a$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $fA6jx.default)) {
            var longFormatter = (0, $fA6jx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($098c20e22326c43a$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $6bCYq.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ko8Cm.isProtectedWeekYearToken)(token)) (0, $ko8Cm.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ko8Cm.isProtectedDayOfYearToken)(token)) (0, $ko8Cm.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $3gG1s.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($098c20e22326c43a$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $098c20e22326c43a$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $2JMbT.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $098c20e22326c43a$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $897M5.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $hxQgK.default)(date, (0, $6nu0h.default)(date));
    var flags = {};
    var _iterator2 = (0, $6bCYq.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $5ztic.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $098c20e22326c43a$var$cleanEscapedString(input) {
    return input.match($098c20e22326c43a$var$escapedStringRegExp)[1].replace($098c20e22326c43a$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("6bCYq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4812008105a7014e$export$2e2bcd8739ae039);

var $1ahE4 = parcelRequire("1ahE4");
function $4812008105a7014e$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $1ahE4.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("1ahE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d94699dd4d93f29$export$2e2bcd8739ae039);

var $cbfsp = parcelRequire("cbfsp");
function $0d94699dd4d93f29$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cbfsp.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cbfsp.default)(r, a) : void 0;
    }
}

});
parcelRegister("cbfsp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8de28092ee4e4cd4$export$2e2bcd8739ae039);
function $8de28092ee4e4cd4$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("5ztic", function(module, exports) {
$parcel$export(module.exports, "default", () => $40e6f185b94c1161$export$2e2bcd8739ae039);
function $40e6f185b94c1161$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("k5HYt", function(module, exports) {
$parcel$export(module.exports, "ValueSetter", () => $ea0662adff4a90e1$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $ea0662adff4a90e1$export$5aaf7ff7f09ea4ee);

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $98nNe = parcelRequire("98nNe");
var $ea0662adff4a90e1$var$TIMEZONE_UNIT_PRIORITY = 10;
var $ea0662adff4a90e1$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $gJcCx.default)(this, Setter);
        (0, $98nNe.default)(this, "priority", void 0);
        (0, $98nNe.default)(this, "subPriority", 0);
    }
    (0, $lTyEA.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $ea0662adff4a90e1$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $9aekk.default)(ValueSetter, _Setter);
    var _super = (0, $gWYn1.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $gJcCx.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $lTyEA.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($ea0662adff4a90e1$export$81d53e3678089a6);
var $ea0662adff4a90e1$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $9aekk.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $gWYn1.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $gJcCx.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this2), "priority", $ea0662adff4a90e1$var$TIMEZONE_UNIT_PRIORITY);
        (0, $98nNe.default)((0, $iyejT.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $lTyEA.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($ea0662adff4a90e1$export$81d53e3678089a6);

});
parcelRegister("9aekk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac0293a411441cf$export$2e2bcd8739ae039);

var $3cJx8 = parcelRequire("3cJx8");
function $6ac0293a411441cf$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3cJx8.default)(t, e);
}

});

parcelRegister("gWYn1", function(module, exports) {
$parcel$export(module.exports, "default", () => $c570e4693ccdad82$export$2e2bcd8739ae039);

var $aYdSM = parcelRequire("aYdSM");

var $hjxPP = parcelRequire("hjxPP");

var $2ExVX = parcelRequire("2ExVX");
function $c570e4693ccdad82$export$2e2bcd8739ae039(t) {
    var r = (0, $hjxPP.default)();
    return function() {
        var e, o = (0, $aYdSM.default)(t);
        if (r) {
            var s = (0, $aYdSM.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $2ExVX.default)(this, e);
    };
}

});
parcelRegister("aYdSM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fca46bf65ea08bf$export$2e2bcd8739ae039);
function $7fca46bf65ea08bf$export$2e2bcd8739ae039(t) {
    return $7fca46bf65ea08bf$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7fca46bf65ea08bf$export$2e2bcd8739ae039(t);
}

});

parcelRegister("hjxPP", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9ae74f14befdb60$export$2e2bcd8739ae039);
function $c9ae74f14befdb60$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c9ae74f14befdb60$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("2ExVX", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ee9a3c45eb926f1$export$2e2bcd8739ae039);

var $2JMbT = parcelRequire("2JMbT");

var $iyejT = parcelRequire("iyejT");
function $1ee9a3c45eb926f1$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $2JMbT.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $iyejT.default)(t);
}

});


parcelRegister("gJcCx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2daa38561a20848$export$2e2bcd8739ae039);
function $c2daa38561a20848$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lTyEA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff099d842613dea1$export$2e2bcd8739ae039);

var $jq0BN = parcelRequire("jq0BN");
function $ff099d842613dea1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $jq0BN.default)(o.key), o);
    }
}
function $ff099d842613dea1$export$2e2bcd8739ae039(e, r, t) {
    return r && $ff099d842613dea1$var$_defineProperties(e.prototype, r), t && $ff099d842613dea1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});


parcelRegister("3gG1s", function(module, exports) {
$parcel$export(module.exports, "parsers", () => $2613768a0ff5bdec$export$19131010e7fd8373);

var $loJJU = parcelRequire("loJJU");

var $ewtrg = parcelRequire("ewtrg");

var $8PeI3 = parcelRequire("8PeI3");

var $fQgPp = parcelRequire("fQgPp");

var $jDqF5 = parcelRequire("jDqF5");

var $gK8q3 = parcelRequire("gK8q3");

var $45AXJ = parcelRequire("45AXJ");

var $bq1M9 = parcelRequire("bq1M9");

var $aRwnV = parcelRequire("aRwnV");

var $kmzRs = parcelRequire("kmzRs");

var $7GhfH = parcelRequire("7GhfH");

var $2ppGA = parcelRequire("2ppGA");

var $5qUuJ = parcelRequire("5qUuJ");

var $7ZbmW = parcelRequire("7ZbmW");

var $avKRa = parcelRequire("avKRa");

var $2bCdh = parcelRequire("2bCdh");

var $5rbdW = parcelRequire("5rbdW");

var $If6cv = parcelRequire("If6cv");

var $2uY2a = parcelRequire("2uY2a");

var $1Ap9R = parcelRequire("1Ap9R");

var $165F0 = parcelRequire("165F0");

var $dBCRT = parcelRequire("dBCRT");

var $f4xZJ = parcelRequire("f4xZJ");

var $2oEwT = parcelRequire("2oEwT");

var $hgPoL = parcelRequire("hgPoL");

var $cbheZ = parcelRequire("cbheZ");

var $fga3l = parcelRequire("fga3l");

var $DhbSG = parcelRequire("DhbSG");

var $2PdA0 = parcelRequire("2PdA0");

var $3YksR = parcelRequire("3YksR");

var $djnDB = parcelRequire("djnDB");
var $2613768a0ff5bdec$export$19131010e7fd8373 = {
    G: new (0, $loJJU.EraParser)(),
    y: new (0, $ewtrg.YearParser)(),
    Y: new (0, $8PeI3.LocalWeekYearParser)(),
    R: new (0, $fQgPp.ISOWeekYearParser)(),
    u: new (0, $jDqF5.ExtendedYearParser)(),
    Q: new (0, $gK8q3.QuarterParser)(),
    q: new (0, $45AXJ.StandAloneQuarterParser)(),
    M: new (0, $bq1M9.MonthParser)(),
    L: new (0, $aRwnV.StandAloneMonthParser)(),
    w: new (0, $kmzRs.LocalWeekParser)(),
    I: new (0, $7GhfH.ISOWeekParser)(),
    d: new (0, $2ppGA.DateParser)(),
    D: new (0, $5qUuJ.DayOfYearParser)(),
    E: new (0, $7ZbmW.DayParser)(),
    e: new (0, $avKRa.LocalDayParser)(),
    c: new (0, $2bCdh.StandAloneLocalDayParser)(),
    i: new (0, $5rbdW.ISODayParser)(),
    a: new (0, $If6cv.AMPMParser)(),
    b: new (0, $2uY2a.AMPMMidnightParser)(),
    B: new (0, $1Ap9R.DayPeriodParser)(),
    h: new (0, $165F0.Hour1to12Parser)(),
    H: new (0, $dBCRT.Hour0to23Parser)(),
    K: new (0, $f4xZJ.Hour0To11Parser)(),
    k: new (0, $2oEwT.Hour1To24Parser)(),
    m: new (0, $hgPoL.MinuteParser)(),
    s: new (0, $cbheZ.SecondParser)(),
    S: new (0, $fga3l.FractionOfSecondParser)(),
    X: new (0, $DhbSG.ISOTimezoneWithZParser)(),
    x: new (0, $2PdA0.ISOTimezoneParser)(),
    t: new (0, $3YksR.TimestampSecondsParser)(),
    T: new (0, $djnDB.TimestampMillisecondsParser)()
};

});
parcelRegister("loJJU", function(module, exports) {
$parcel$export(module.exports, "EraParser", () => $f93f51c5417eb861$export$8e5a1d3f85a9688);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");
var $f93f51c5417eb861$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(EraParser, _Parser);
    var _super = (0, $gWYn1.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $gJcCx.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 140);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $2Oj37.Parser));

});
parcelRegister("2Oj37", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $20bf070e7173f102$export$7acfa6ed01010e37);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $98nNe = parcelRequire("98nNe");

var $k5HYt = parcelRequire("k5HYt");
var $20bf070e7173f102$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $gJcCx.default)(this, Parser);
        (0, $98nNe.default)(this, "incompatibleTokens", void 0);
        (0, $98nNe.default)(this, "priority", void 0);
        (0, $98nNe.default)(this, "subPriority", void 0);
    }
    (0, $lTyEA.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $k5HYt.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("ewtrg", function(module, exports) {
$parcel$export(module.exports, "YearParser", () => $a92ae3be9c90701b$export$48d352de7cd4a988);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $a92ae3be9c90701b$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(YearParser, _Parser);
    var _super = (0, $gWYn1.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $gJcCx.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 130);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $hQMuL.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $hQMuL.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $2Oj37.Parser));

});
parcelRegister("hQMuL", function(module, exports) {
$parcel$export(module.exports, "mapValue", () => $cfece9251ee084ff$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $cfece9251ee084ff$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $cfece9251ee084ff$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $cfece9251ee084ff$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $cfece9251ee084ff$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $cfece9251ee084ff$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $cfece9251ee084ff$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $cfece9251ee084ff$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $cfece9251ee084ff$export$3d50627710b84d75);

var $dBtk4 = parcelRequire("dBtk4");

var $5RZyu = parcelRequire("5RZyu");
function $cfece9251ee084ff$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $cfece9251ee084ff$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cfece9251ee084ff$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $dBtk4.millisecondsInHour) + minutes * (0, $dBtk4.millisecondsInMinute) + seconds * (0, $dBtk4.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cfece9251ee084ff$export$d931c43c4608a164(dateString) {
    return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).anyDigitsSigned, dateString);
}
function $cfece9251ee084ff$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).singleDigit, dateString);
        case 2:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).twoDigits, dateString);
        case 3:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).threeDigits, dateString);
        case 4:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).fourDigits, dateString);
        default:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $cfece9251ee084ff$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388((0, $5RZyu.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $cfece9251ee084ff$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $cfece9251ee084ff$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $cfece9251ee084ff$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $cfece9251ee084ff$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("dBtk4", function(module, exports) {
$parcel$export(module.exports, "millisecondsInMinute", () => $9e7579ec063e9b4e$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $9e7579ec063e9b4e$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $9e7579ec063e9b4e$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $9e7579ec063e9b4e$export$dfd9b671c89acc8e = 7;
var $9e7579ec063e9b4e$export$3913210603d8e9ae = 365.2425;
var $9e7579ec063e9b4e$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $9e7579ec063e9b4e$export$91246f0b9bd9beff = 60000;
var $9e7579ec063e9b4e$export$7f72910d6dfd237a = 3600000;
var $9e7579ec063e9b4e$export$397c2d5776aa9055 = 1000;
var $9e7579ec063e9b4e$export$4dec998e48f9c246 = -$9e7579ec063e9b4e$export$81caae6e1cc7a622;
var $9e7579ec063e9b4e$export$f2f5ae5a8e2d8f9f = 60;
var $9e7579ec063e9b4e$export$3c58128db900d44e = 3;
var $9e7579ec063e9b4e$export$80d7e435f744f319 = 12;
var $9e7579ec063e9b4e$export$4db7641526e3241f = 4;
var $9e7579ec063e9b4e$export$698aec755e92c695 = 3600;
var $9e7579ec063e9b4e$export$a77c1a7ebebe2a5a = 60;
var $9e7579ec063e9b4e$export$815a9362476d2fe3 = $9e7579ec063e9b4e$export$698aec755e92c695 * 24;
var $9e7579ec063e9b4e$export$34804a017b31e2fe = $9e7579ec063e9b4e$export$815a9362476d2fe3 * 7;
var $9e7579ec063e9b4e$export$7271e9e3478110d1 = $9e7579ec063e9b4e$export$815a9362476d2fe3 * $9e7579ec063e9b4e$export$3913210603d8e9ae;
var $9e7579ec063e9b4e$export$8e6600bbdee7dabb = $9e7579ec063e9b4e$export$7271e9e3478110d1 / 12;
var $9e7579ec063e9b4e$export$be1dccf2de902d31 = $9e7579ec063e9b4e$export$8e6600bbdee7dabb * 3;

});

parcelRegister("5RZyu", function(module, exports) {
$parcel$export(module.exports, "numericPatterns", () => $4461a69528fe0a57$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $4461a69528fe0a57$export$a7ee192b982af9c1);
var $4461a69528fe0a57$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $4461a69528fe0a57$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("8PeI3", function(module, exports) {
$parcel$export(module.exports, "LocalWeekYearParser", () => $66ce7f2ab5f7f8b2$export$b8ef38dfcf05d5db);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");

var $ljvvf = parcelRequire("ljvvf");

var $aeMW9 = parcelRequire("aeMW9");
var $66ce7f2ab5f7f8b2$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $gWYn1.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $gJcCx.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 130);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $hQMuL.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $ljvvf.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $hQMuL.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $aeMW9.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $aeMW9.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $2Oj37.Parser));

});

parcelRegister("fQgPp", function(module, exports) {
$parcel$export(module.exports, "ISOWeekYearParser", () => $b888c41563e8747f$export$951d1df011fde06f);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");

var $6d9cX = parcelRequire("6d9cX");
var $b888c41563e8747f$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $gWYn1.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $gJcCx.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 130);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $hQMuL.parseNDigitsSigned)(4, dateString);
                return (0, $hQMuL.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $6d9cX.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $2Oj37.Parser));

});

parcelRegister("jDqF5", function(module, exports) {
$parcel$export(module.exports, "ExtendedYearParser", () => $e4b6574b6972cbed$export$bad9d2ea38e8f1a);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $e4b6574b6972cbed$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(ExtendedYearParser, _Parser);
    var _super = (0, $gWYn1.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $gJcCx.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 130);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $hQMuL.parseNDigitsSigned)(4, dateString);
                return (0, $hQMuL.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $2Oj37.Parser));

});

parcelRegister("gK8q3", function(module, exports) {
$parcel$export(module.exports, "QuarterParser", () => $c3077918bbccbdc2$export$5cb0f701186dde1d);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $c3077918bbccbdc2$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(QuarterParser, _Parser);
    var _super = (0, $gWYn1.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $gJcCx.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 120);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $2Oj37.Parser));

});

parcelRegister("45AXJ", function(module, exports) {
$parcel$export(module.exports, "StandAloneQuarterParser", () => $2fa44cfe7557be61$export$300c0c2990e20e6d);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $2fa44cfe7557be61$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $gWYn1.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $gJcCx.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 120);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $2Oj37.Parser));

});

parcelRegister("bq1M9", function(module, exports) {
$parcel$export(module.exports, "MonthParser", () => $85038002df82b222$export$400dd8b40ef138a3);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $hQMuL = parcelRequire("hQMuL");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");
var $85038002df82b222$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(MonthParser, _Parser);
    var _super = (0, $gWYn1.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $gJcCx.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 110);
        return _this;
    }
    (0, $lTyEA.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $hQMuL.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $2Oj37.Parser));

});

parcelRegister("aRwnV", function(module, exports) {
$parcel$export(module.exports, "StandAloneMonthParser", () => $7e87f9935cac42f2$export$1d7eaa53eaa5deba);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $7e87f9935cac42f2$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $gWYn1.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $gJcCx.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 110);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $hQMuL.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $2Oj37.Parser));

});

parcelRegister("kmzRs", function(module, exports) {
$parcel$export(module.exports, "LocalWeekParser", () => $ed31adfcc958707d$export$c4005ffc174e07c0);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");

var $5TYbl = parcelRequire("5TYbl");

var $aeMW9 = parcelRequire("aeMW9");
var $ed31adfcc958707d$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(LocalWeekParser, _Parser);
    var _super = (0, $gWYn1.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $gJcCx.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 100);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $aeMW9.default)((0, $5TYbl.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $2Oj37.Parser));

});
parcelRegister("5TYbl", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c0c5abcc07e15b$export$2e2bcd8739ae039);

var $cPnJw = parcelRequire("cPnJw");

var $897M5 = parcelRequire("897M5");

var $gMkvx = parcelRequire("gMkvx");

var $OPOsJ = parcelRequire("OPOsJ");
function $44c0c5abcc07e15b$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $OPOsJ.default)(2, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var week = (0, $cPnJw.default)(dirtyWeek);
    var diff = (0, $gMkvx.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("7GhfH", function(module, exports) {
$parcel$export(module.exports, "ISOWeekParser", () => $5979d692ae5feaf1$export$6fc8dbedd560a6af);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");

var $2A6aL = parcelRequire("2A6aL");

var $6d9cX = parcelRequire("6d9cX");
var $5979d692ae5feaf1$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(ISOWeekParser, _Parser);
    var _super = (0, $gWYn1.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $gJcCx.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 100);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $6d9cX.default)((0, $2A6aL.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $2Oj37.Parser));

});
parcelRegister("2A6aL", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e13bb5691c3da98$export$2e2bcd8739ae039);

var $cPnJw = parcelRequire("cPnJw");

var $897M5 = parcelRequire("897M5");

var $kfhLT = parcelRequire("kfhLT");

var $OPOsJ = parcelRequire("OPOsJ");
function $1e13bb5691c3da98$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $OPOsJ.default)(2, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var isoWeek = (0, $cPnJw.default)(dirtyISOWeek);
    var diff = (0, $kfhLT.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("2ppGA", function(module, exports) {
$parcel$export(module.exports, "DateParser", () => $1c11d74014f118fc$export$e8d4b28a20981dd2);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $hQMuL = parcelRequire("hQMuL");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");
var $1c11d74014f118fc$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c11d74014f118fc$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c11d74014f118fc$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(DateParser, _Parser);
    var _super = (0, $gWYn1.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $gJcCx.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 90);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "subPriority", 1);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $hQMuL.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $1c11d74014f118fc$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $1c11d74014f118fc$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $2Oj37.Parser));

});

parcelRegister("5qUuJ", function(module, exports) {
$parcel$export(module.exports, "DayOfYearParser", () => $3f4b341c5760ba1b$export$6cfe0d613455f615);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $3f4b341c5760ba1b$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(DayOfYearParser, _Parser);
    var _super = (0, $gWYn1.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $gJcCx.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 90);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "subpriority", 1);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $hQMuL.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $2Oj37.Parser));

});

parcelRegister("7ZbmW", function(module, exports) {
$parcel$export(module.exports, "DayParser", () => $5d070c8c4644b8b0$export$1b03c8b76262f7bd);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $bgQM9 = parcelRequire("bgQM9");
var $5d070c8c4644b8b0$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(DayParser, _Parser);
    var _super = (0, $gWYn1.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $gJcCx.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 90);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $bgQM9.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $2Oj37.Parser));

});
parcelRegister("bgQM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $834a207a312c470b$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");

var $cPnJw = parcelRequire("cPnJw");

var $lLJTa = parcelRequire("lLJTa");
function $834a207a312c470b$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $OPOsJ.default)(2, arguments);
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var weekStartsOn = (0, $cPnJw.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $897M5.default)(dirtyDate);
    var day = (0, $cPnJw.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("avKRa", function(module, exports) {
$parcel$export(module.exports, "LocalDayParser", () => $7a712561888baa06$export$44d1c127ab42c480);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");

var $bgQM9 = parcelRequire("bgQM9");
var $7a712561888baa06$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(LocalDayParser, _Parser);
    var _super = (0, $gWYn1.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $gJcCx.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 90);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $hQMuL.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $bgQM9.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $2Oj37.Parser));

});

parcelRegister("2bCdh", function(module, exports) {
$parcel$export(module.exports, "StandAloneLocalDayParser", () => $197a403426d37bef$export$e447a647caaaec1d);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");

var $bgQM9 = parcelRequire("bgQM9");
var $197a403426d37bef$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $gWYn1.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $gJcCx.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 90);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $hQMuL.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $bgQM9.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $2Oj37.Parser));

});

parcelRegister("5rbdW", function(module, exports) {
$parcel$export(module.exports, "ISODayParser", () => $3f582e33e446b134$export$693fb1e525095b2a);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");

var $aS7ye = parcelRequire("aS7ye");
var $3f582e33e446b134$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(ISODayParser, _Parser);
    var _super = (0, $gWYn1.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $gJcCx.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 90);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $hQMuL.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $hQMuL.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $hQMuL.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $hQMuL.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $aS7ye.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $2Oj37.Parser));

});
parcelRegister("aS7ye", function(module, exports) {
$parcel$export(module.exports, "default", () => $020aea8c65faf1f2$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");

var $cPnJw = parcelRequire("cPnJw");
function $020aea8c65faf1f2$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $OPOsJ.default)(2, arguments);
    var day = (0, $cPnJw.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $897M5.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("If6cv", function(module, exports) {
$parcel$export(module.exports, "AMPMParser", () => $084fd2865ac7802b$export$8d1e08492351df91);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $084fd2865ac7802b$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(AMPMParser, _Parser);
    var _super = (0, $gWYn1.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $gJcCx.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 80);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $hQMuL.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $2Oj37.Parser));

});

parcelRegister("2uY2a", function(module, exports) {
$parcel$export(module.exports, "AMPMMidnightParser", () => $1d1cf3972043fe3a$export$73ca2bd0a17d273);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $1d1cf3972043fe3a$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $gWYn1.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $gJcCx.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 80);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $hQMuL.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $2Oj37.Parser));

});

parcelRegister("1Ap9R", function(module, exports) {
$parcel$export(module.exports, "DayPeriodParser", () => $127cab139379e709$export$bb9212adf05373db);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $127cab139379e709$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(DayPeriodParser, _Parser);
    var _super = (0, $gWYn1.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $gJcCx.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 80);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $hQMuL.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $2Oj37.Parser));

});

parcelRegister("165F0", function(module, exports) {
$parcel$export(module.exports, "Hour1to12Parser", () => $0ccabe02a7199077$export$8a04050a727a1756);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $0ccabe02a7199077$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(Hour1to12Parser, _Parser);
    var _super = (0, $gWYn1.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $gJcCx.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 70);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $2Oj37.Parser));

});

parcelRegister("dBCRT", function(module, exports) {
$parcel$export(module.exports, "Hour0to23Parser", () => $9e7ce177f0df8603$export$e56f4dea2c3e56dd);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $9e7ce177f0df8603$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(Hour0to23Parser, _Parser);
    var _super = (0, $gWYn1.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $gJcCx.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 70);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $2Oj37.Parser));

});

parcelRegister("f4xZJ", function(module, exports) {
$parcel$export(module.exports, "Hour0To11Parser", () => $af91995f28a555a4$export$cbbe855312f87d77);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $af91995f28a555a4$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(Hour0To11Parser, _Parser);
    var _super = (0, $gWYn1.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $gJcCx.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 70);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $2Oj37.Parser));

});

parcelRegister("2oEwT", function(module, exports) {
$parcel$export(module.exports, "Hour1To24Parser", () => $1bed42f65d5e5166$export$6008046d2b34b6a5);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $1bed42f65d5e5166$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(Hour1To24Parser, _Parser);
    var _super = (0, $gWYn1.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $gJcCx.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 70);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $2Oj37.Parser));

});

parcelRegister("hgPoL", function(module, exports) {
$parcel$export(module.exports, "MinuteParser", () => $c92bccf37b50a84e$export$2b52670d9e2be53);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $c92bccf37b50a84e$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(MinuteParser, _Parser);
    var _super = (0, $gWYn1.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $gJcCx.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 60);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $2Oj37.Parser));

});

parcelRegister("cbheZ", function(module, exports) {
$parcel$export(module.exports, "SecondParser", () => $8de3e2cabbe1244e$export$94d46d540cf1366a);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $8de3e2cabbe1244e$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(SecondParser, _Parser);
    var _super = (0, $gWYn1.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $gJcCx.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 50);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $hQMuL.parseNumericPattern)((0, $5RZyu.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $hQMuL.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $2Oj37.Parser));

});

parcelRegister("fga3l", function(module, exports) {
$parcel$export(module.exports, "FractionOfSecondParser", () => $b1c025f2f4065e54$export$b8e6f8b2d70893b1);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $b1c025f2f4065e54$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $gWYn1.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $gJcCx.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 30);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $hQMuL.mapValue)((0, $hQMuL.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $2Oj37.Parser));

});

parcelRegister("DhbSG", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $0760fa55666b33d4$export$104d901d49fea29b);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $0760fa55666b33d4$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $gWYn1.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $gJcCx.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 10);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $2Oj37.Parser));

});

parcelRegister("2PdA0", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneParser", () => $20eae0deb8d6c97b$export$12910e5204b52b9);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $5RZyu = parcelRequire("5RZyu");

var $hQMuL = parcelRequire("hQMuL");
var $20eae0deb8d6c97b$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $gWYn1.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $gJcCx.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 10);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $lTyEA.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $hQMuL.parseTimezonePattern)((0, $5RZyu.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $2Oj37.Parser));

});

parcelRegister("3YksR", function(module, exports) {
$parcel$export(module.exports, "TimestampSecondsParser", () => $2e46d987ab9007a2$export$2cd8bf877a05e96);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $2e46d987ab9007a2$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $gWYn1.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $gJcCx.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 40);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $lTyEA.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $hQMuL.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $2Oj37.Parser));

});

parcelRegister("djnDB", function(module, exports) {
$parcel$export(module.exports, "TimestampMillisecondsParser", () => $9b0f62b11cf6943e$export$6d8f69c6906d6368);

var $gJcCx = parcelRequire("gJcCx");

var $lTyEA = parcelRequire("lTyEA");

var $iyejT = parcelRequire("iyejT");

var $9aekk = parcelRequire("9aekk");

var $gWYn1 = parcelRequire("gWYn1");

var $98nNe = parcelRequire("98nNe");

var $2Oj37 = parcelRequire("2Oj37");

var $hQMuL = parcelRequire("hQMuL");
var $9b0f62b11cf6943e$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $9aekk.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $gWYn1.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $gJcCx.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $98nNe.default)((0, $iyejT.default)(_this), "priority", 20);
        (0, $98nNe.default)((0, $iyejT.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $lTyEA.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $hQMuL.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $2Oj37.Parser));

});



parcelRegister("5xMcQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $40956d8bc9aefad9$export$2e2bcd8739ae039);

var $dBtk4 = parcelRequire("dBtk4");

var $OPOsJ = parcelRequire("OPOsJ");

var $cPnJw = parcelRequire("cPnJw");
function $40956d8bc9aefad9$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $OPOsJ.default)(1, arguments);
    var additionalDigits = (0, $cPnJw.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $40956d8bc9aefad9$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $40956d8bc9aefad9$var$parseYear(dateStrings.date, additionalDigits);
        date = $40956d8bc9aefad9$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $40956d8bc9aefad9$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $40956d8bc9aefad9$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $40956d8bc9aefad9$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $40956d8bc9aefad9$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $40956d8bc9aefad9$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $40956d8bc9aefad9$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $40956d8bc9aefad9$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($40956d8bc9aefad9$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($40956d8bc9aefad9$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($40956d8bc9aefad9$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $40956d8bc9aefad9$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $40956d8bc9aefad9$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $40956d8bc9aefad9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($40956d8bc9aefad9$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $40956d8bc9aefad9$var$parseDateUnit(captures[1]);
    var month = $40956d8bc9aefad9$var$parseDateUnit(captures[2]) - 1;
    var day = $40956d8bc9aefad9$var$parseDateUnit(captures[3]);
    var week = $40956d8bc9aefad9$var$parseDateUnit(captures[4]);
    var dayOfWeek = $40956d8bc9aefad9$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$40956d8bc9aefad9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $40956d8bc9aefad9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$40956d8bc9aefad9$var$validateDate(year, month, day) || !$40956d8bc9aefad9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $40956d8bc9aefad9$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $40956d8bc9aefad9$var$parseTime(timeString) {
    var captures = timeString.match($40956d8bc9aefad9$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $40956d8bc9aefad9$var$parseTimeUnit(captures[1]);
    var minutes = $40956d8bc9aefad9$var$parseTimeUnit(captures[2]);
    var seconds = $40956d8bc9aefad9$var$parseTimeUnit(captures[3]);
    if (!$40956d8bc9aefad9$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $dBtk4.millisecondsInHour) + minutes * (0, $dBtk4.millisecondsInMinute) + seconds * 1000;
}
function $40956d8bc9aefad9$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $40956d8bc9aefad9$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($40956d8bc9aefad9$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$40956d8bc9aefad9$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $dBtk4.millisecondsInHour) + minutes * (0, $dBtk4.millisecondsInMinute));
}
function $40956d8bc9aefad9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $40956d8bc9aefad9$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $40956d8bc9aefad9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $40956d8bc9aefad9$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($40956d8bc9aefad9$var$daysInMonths[month] || ($40956d8bc9aefad9$var$isLeapYearIndex(year) ? 29 : 28));
}
function $40956d8bc9aefad9$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($40956d8bc9aefad9$var$isLeapYearIndex(year) ? 366 : 365);
}
function $40956d8bc9aefad9$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $40956d8bc9aefad9$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $40956d8bc9aefad9$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});


parcelRegister("ikkbH", function(module, exports) {
$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $af095d735916cdbd$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $af095d735916cdbd$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $af095d735916cdbd$export$4cb6c79fda4a9c74);

var $53JkC = parcelRequire("53JkC");
var $9zw4w = parcelRequire("9zw4w");
var $lMRHO = parcelRequire("lMRHO");
var $5xMcQ = parcelRequire("5xMcQ");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $af095d735916cdbd$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $af095d735916cdbd$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $9zw4w.default)(fullDate, $af095d735916cdbd$var$formatString) && (0, $lMRHO.default)((0, $5xMcQ.default)(fullDate));
};
const $af095d735916cdbd$export$7930ddff407505cc = (value)=>{
    return value === null || $af095d735916cdbd$export$a886f5166a4d311e(value);
};
const $af095d735916cdbd$export$e81204f19744e19f = (publicValue)=>{
    return publicValue === null ? '' : publicValue;
};
const $af095d735916cdbd$export$4cb6c79fda4a9c74 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $5xMcQ.default)(value);
    if ((0, $lMRHO.default)(parsedDate)) return (0, $53JkC.default)(parsedDate, $af095d735916cdbd$var$formatString);
    return null;
};

});
parcelRegister("9zw4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f8042bfec7b95a5$export$2e2bcd8739ae039);

var $OORRb = parcelRequire("OORRb");

var $lMRHO = parcelRequire("lMRHO");

var $OPOsJ = parcelRequire("OPOsJ");
function $6f8042bfec7b95a5$export$2e2bcd8739ae039(dateString, formatString, options) {
    (0, $OPOsJ.default)(2, arguments);
    return (0, $lMRHO.default)((0, $OORRb.default)(dateString, formatString, new Date(), options));
}

});


parcelRegister("mE8bO", function(module, exports) {
$parcel$export(module.exports, "labelsSetValueValidator", () => $ca54bae4b80729fe$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $ca54bae4b80729fe$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $ca54bae4b80729fe$export$b0b12fd0b1cd9d3a);
$parcel$export(module.exports, "modifyLabelsValueToBasic", () => $ca54bae4b80729fe$export$627e5994af99713c);
const $ca54bae4b80729fe$export$e67b5652c846b5f = (value)=>Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $ca54bae4b80729fe$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            label: label,
            value: label
        }));
const $ca54bae4b80729fe$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);
const $ca54bae4b80729fe$export$627e5994af99713c = (data)=>{
    if (Array.isArray(data)) return data.map((item)=>item.value);
    return [];
};

});

parcelRegister("dKhv1", function(module, exports) {
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $b9f59a92d5530d4b$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $b9f59a92d5530d4b$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxValueToSelectedOptionsTransformer", () => $b9f59a92d5530d4b$export$67585ccde04b97e0);
$parcel$export(module.exports, "normalizeMultiCheckboxValue", () => $b9f59a92d5530d4b$export$e31e24357d17bcec);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $b9f59a92d5530d4b$export$6d15ce1cc0bdffe7);
$parcel$export(module.exports, "multiCheckboxSetOptionsVisibilityTransformer", () => $b9f59a92d5530d4b$export$e9bad46ddf6f220a);
$parcel$export(module.exports, "multiCheckboxGetOptionsVisibilityTransformer", () => $b9f59a92d5530d4b$export$2873e4aff600baf0);
$parcel$export(module.exports, "modifyMultiSelectValueToBasic", () => $b9f59a92d5530d4b$export$1c5664946e66ba46);

var $w81Hd = parcelRequire("w81Hd");

var $5iRil = parcelRequire("5iRil");
const $b9f59a92d5530d4b$export$106087dcfd4fb129 = 100;
const $b9f59a92d5530d4b$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.length <= $b9f59a92d5530d4b$export$106087dcfd4fb129 && value.every((0, $5iRil.isNotEmptyString));
const $b9f59a92d5530d4b$export$45b7d122d1400fe0 = (value)=>Array.isArray(value) && value.length <= $b9f59a92d5530d4b$export$106087dcfd4fb129 && value.every((val)=>(0, $5iRil.isNotEmptyString)(val) && (0, $w81Hd.isAriResourceIdValid)(val));
const $b9f59a92d5530d4b$export$9ba1ee83cc9456ba = (optionIds, options)=>{
    const selectedOptions = options.filter((option)=>optionIds.includes(option.value));
    return selectedOptions;
};
const $b9f59a92d5530d4b$var$isMultiCheckboxValue = (value)=>Array.isArray(value) && value.every((0, $5iRil.isNotEmptyString));
const $b9f59a92d5530d4b$export$67585ccde04b97e0 = (value, allowedValues)=>{
    if (!$b9f59a92d5530d4b$var$isMultiCheckboxValue(value) || !allowedValues) return [];
    return $b9f59a92d5530d4b$export$9ba1ee83cc9456ba(value, allowedValues);
};
const $b9f59a92d5530d4b$export$e31e24357d17bcec = (value)=>(value === null || value === void 0 ? void 0 : value.map((item)=>typeof item === 'string' ? item : item.value)) ?? [];
const $b9f59a92d5530d4b$export$6d15ce1cc0bdffe7 = (selectedOptionData)=>{
    return selectedOptionData.map((option)=>{
        return {
            id: option.value,
            value: option === null || option === void 0 ? void 0 : option.label
        };
    });
};
const $b9f59a92d5530d4b$export$e9bad46ddf6f220a = (optionsVisibility, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
};
const $b9f59a92d5530d4b$export$2873e4aff600baf0 = (optionsVisibility, lookupValues)=>{
    const filteredLookupValues = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
    return {
        options: (filteredLookupValues === null || filteredLookupValues === void 0 ? void 0 : filteredLookupValues.map(({ value: value })=>value)) ?? [],
        isVisible: optionsVisibility.isVisible
    };
};
const $b9f59a92d5530d4b$export$1c5664946e66ba46 = (selectedOptions)=>(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 ? selectedOptions.map((option)=>option.value) : [];

});

parcelRegister("fAPVP", function(module, exports) {
$parcel$export(module.exports, "validateNumberValue", () => $1f4d6c736ed25e8c$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "transformNumberToInternalValue", () => $1f4d6c736ed25e8c$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $1f4d6c736ed25e8c$export$8bdc28b51a4acc44);
const $1f4d6c736ed25e8c$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $1f4d6c736ed25e8c$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $1f4d6c736ed25e8c$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);

});

parcelRegister("88x0p", function(module, exports) {
$parcel$export(module.exports, "validatePrioritySetValue", () => $f285ce115b09b155$export$feb916d6d9ca4953);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $f285ce115b09b155$export$c6ef424ead917b72);
$parcel$export(module.exports, "prioritySetOptionsVisibility", () => $f285ce115b09b155$export$28c18b75fec0308d);
$parcel$export(module.exports, "priorityGetValueTransformer", () => $f285ce115b09b155$export$a3dcdeebcccb44cd);
$parcel$export(module.exports, "modifyPriorityValueToBasic", () => $f285ce115b09b155$export$8be86fe3b85cdd48);

var $5iRil = parcelRequire("5iRil");
const $f285ce115b09b155$export$feb916d6d9ca4953 = (value)=>(0, $5iRil.isNotEmptyString)(value);
const $f285ce115b09b155$export$c6ef424ead917b72 = (optionId, options)=>{
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $f285ce115b09b155$export$28c18b75fec0308d = ({ options: options, isVisible: isVisible }, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
};
const $f285ce115b09b155$export$a3dcdeebcccb44cd = (data)=>{
    if (!data) return null;
    return {
        id: data.value,
        name: data.label
    };
};
const $f285ce115b09b155$export$8be86fe3b85cdd48 = (data)=>data === null || data === void 0 ? void 0 : data.value;

});

parcelRegister("iG8Fo", function(module, exports) {
$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $d1ceaa147d48b1cd$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $d1ceaa147d48b1cd$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $d1ceaa147d48b1cd$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $d1ceaa147d48b1cd$export$fd4db924c90bd0e2);
$parcel$export(module.exports, "modifySelectValueToBasic", () => $d1ceaa147d48b1cd$export$24495edee70b381);
const $d1ceaa147d48b1cd$export$81990085f8ab114b = ({ options: options, isVisible: isVisible }, lookupValues)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
const $d1ceaa147d48b1cd$export$7c7ca81813eb0f65 = ({ options: options, isVisible: isVisible }, lookupValues)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.some((val)=>val.value === option))
    });
const $d1ceaa147d48b1cd$export$136c42b919fdec83 = (optionId, options)=>{
    if (optionId === null) return null;
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $d1ceaa147d48b1cd$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $d1ceaa147d48b1cd$export$24495edee70b381 = (selectedOption)=>{
    if (selectedOption === null) return null;
    return selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
};

});

parcelRegister("fBA4L", function(module, exports) {
$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $b8abc6e9556b25fd$export$161c77b6b09fc494);
const $b8abc6e9556b25fd$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("3cPfj", function(module, exports) {
$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $b1012ed25d6abd0f$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $b1012ed25d6abd0f$export$624bfe758f4ad3c6);
$parcel$export(module.exports, "radioButtonsSetOptionsVisibilityTransformer", () => $b1012ed25d6abd0f$export$aadb0d8b636b9e19);
$parcel$export(module.exports, "radioButtonsGetOptionsVisibilityTransformer", () => $b1012ed25d6abd0f$export$1a20bcf25e1f19dc);
$parcel$export(module.exports, "modifyRadioButtonsValueToBasic", () => $b1012ed25d6abd0f$export$7343aeb896776ca4);
$parcel$export(module.exports, "radioButtonsValueToSelectedOptionTransformer", () => $b1012ed25d6abd0f$export$814c69030a08410c);
$parcel$export(module.exports, "normalizeRadioButtonsValue", () => $b1012ed25d6abd0f$export$586e4addfd1305f6);

var $iG8Fo = parcelRequire("iG8Fo");
const $b1012ed25d6abd0f$export$d23713245ea192a9 = (0, $iG8Fo.selectSetValueTransformer);
const $b1012ed25d6abd0f$export$624bfe758f4ad3c6 = (0, $iG8Fo.selectGetValueTransformer);
const $b1012ed25d6abd0f$export$aadb0d8b636b9e19 = (0, $iG8Fo.transformSelectSetOptionsVisibility);
const $b1012ed25d6abd0f$export$1a20bcf25e1f19dc = (0, $iG8Fo.transformSelectGetOptionsVisibility);
const $b1012ed25d6abd0f$export$7343aeb896776ca4 = (0, $iG8Fo.modifySelectValueToBasic);
const $b1012ed25d6abd0f$export$814c69030a08410c = (value, allowedValues)=>{
    if (value === null) return null;
    if (typeof value !== 'string' || !allowedValues) return null;
    return $b1012ed25d6abd0f$export$d23713245ea192a9(value, allowedValues) ?? null;
};
const $b1012ed25d6abd0f$export$586e4addfd1305f6 = (value)=>{
    if (!value) return '';
    return typeof value === 'string' ? value : value.value;
};

});

parcelRegister("3cdTA", function(module, exports) {
$parcel$export(module.exports, "validateTextAreaValue", () => $729ec5691c5b5370$export$af1bd7b4775c21f5);
$parcel$export(module.exports, "textAreaGetValueTransformer", () => $729ec5691c5b5370$export$f8779084d2efe971);
$parcel$export(module.exports, "textAreaSetValueTransformer", () => $729ec5691c5b5370$export$b26179f27360223b);

var $2xOjO = parcelRequire("2xOjO");

var $2Zepk = parcelRequire("2Zepk");

var $QOurk = parcelRequire("QOurk");

var $87QgR = parcelRequire("87QgR");
const $729ec5691c5b5370$export$c7bf565312b59b06 = 'atlassian-wiki-renderer';
const $729ec5691c5b5370$export$af1bd7b4775c21f5 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    if (fieldRenderer === $729ec5691c5b5370$export$c7bf565312b59b06) {
        var _extra$currentField;
        return (0, $QOurk.isValidADF)({
            newValue: value,
            currentValue: (_extra$currentField = extra.currentField) === null || _extra$currentField === void 0 ? void 0 : _extra$currentField.value
        });
    }
    return Promise.resolve(typeof value === 'string');
};
const $729ec5691c5b5370$export$f8779084d2efe971 = (value, fieldRenderer)=>{
    if (value === undefined || (0, $87QgR.default).checkGate('ditto_fix_getvalue_empty_state') && !value) return fieldRenderer === $729ec5691c5b5370$export$c7bf565312b59b06 ? (0, $2xOjO.getEmptyADF)() : '';
    try {
        return (0, $2Zepk.parseAdf)(value);
    } catch (e) {
        return value;
    }
};
const $729ec5691c5b5370$export$b26179f27360223b = (value)=>{
    // Check if value is string, if not convert it to string
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
};

});
parcelRegister("2xOjO", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $a48e6197e4159c4c$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3jUou = parcelRequire("3jUou");
const $a48e6197e4159c4c$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("3jUou", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $5878e56a0d62fcaa$export$dd1bc94b04021eeb);
const $5878e56a0d62fcaa$export$dd1bc94b04021eeb = (node)=>{
    var _node$content;
    return !(node !== null && node !== void 0 && (_node$content = node.content) !== null && _node$content !== void 0 && _node$content.length);
};

});


parcelRegister("QOurk", function(module, exports) {
$parcel$export(module.exports, "isValidADF", () => $aa1e51c23246e868$export$94ea512f7afe62e4);

var $cP2KL = parcelRequire("cP2KL");

var $dMMwa = parcelRequire("dMMwa");

var $bhIIN = parcelRequire("bhIIN");

var $hMBe3 = parcelRequire("hMBe3");

const $aa1e51c23246e868$var$getADFValidator = async ()=>{
    const { validator: validator } = await Promise.resolve((parcelRequire("3ok8c")));
    return validator;
};
const $aa1e51c23246e868$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $hMBe3.traverse)(adf, {
            media: (node)=>{
                var _node$attrs, _node$attrs2;
                if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.type) === 'external' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url) !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $aa1e51c23246e868$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $aa1e51c23246e868$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($cP2KL)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $bhIIN.doc)(...foundDiffNodes);
    return $aa1e51c23246e868$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $aa1e51c23246e868$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue })=>{
    const validator = await $aa1e51c23246e868$var$getADFValidator();
    const validate = validator();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $aa1e51c23246e868$export$6f13dd7501a16a00(newValue, currentValue);
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("cP2KL", function(module, exports) {

var $gWPWR = parcelRequire("gWPWR");

var $b6Bmc = parcelRequire("b6Bmc");

var $Hbxkm = parcelRequire("Hbxkm");

var $cqPYt = parcelRequire("cqPYt");

var $fbpGW = parcelRequire("fbpGW");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $955c6235ba607237$var$differenceWith = $Hbxkm(function(array, values) {
    var comparator = $fbpGW(values);
    if ($cqPYt(comparator)) comparator = undefined;
    return $cqPYt(array) ? $gWPWR(array, $b6Bmc(values, 1, $cqPYt, true), undefined, comparator) : [];
});
module.exports = $955c6235ba607237$var$differenceWith;

});
parcelRegister("gWPWR", function(module, exports) {

var $4ZLTW = parcelRequire("4ZLTW");

var $jOuEU = parcelRequire("jOuEU");

var $drjad = parcelRequire("drjad");

var $2aKdk = parcelRequire("2aKdk");

var $69sKP = parcelRequire("69sKP");

var $1C2YK = parcelRequire("1C2YK");
/** Used as the size to enable large array optimizations. */ var $c56a5bfb91a0cd02$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $c56a5bfb91a0cd02$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $jOuEU, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $2aKdk(values, $69sKP(iteratee));
    if (comparator) {
        includes = $drjad;
        isCommon = false;
    } else if (values.length >= $c56a5bfb91a0cd02$var$LARGE_ARRAY_SIZE) {
        includes = $1C2YK;
        isCommon = false;
        values = new $4ZLTW(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $c56a5bfb91a0cd02$var$baseDifference;

});


parcelRegister("3ok8c", function(module, exports) {
$parcel$export(module.exports, "validator", () => $3a9bcd6fd69693b8$export$956325f45c5d174a);

var $gdUUy = parcelRequire("gdUUy");

var $ba2Pr = parcelRequire("ba2Pr");

var $6t6lj = parcelRequire("6t6lj");

var $k8KFD = parcelRequire("k8KFD");

var $iiVj2 = parcelRequire("iiVj2");

var $7MqAo = parcelRequire("7MqAo");

var $fE1Du = parcelRequire("fE1Du");

var $5I8xg = parcelRequire("5I8xg");

var $fv065 = parcelRequire("fv065");

var $kTMq5 = parcelRequire("kTMq5");

var $avNch = parcelRequire("avNch");

var $3EVER = parcelRequire("3EVER");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3a9bcd6fd69693b8$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a9bcd6fd69693b8$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 */ const $3a9bcd6fd69693b8$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
/**
 * Resolve one content-item name against `specs`. Variant specs are stored as tuples (arrays), so a
 * name that refers to one (e.g. `paragraph_with_no_marks`) resolves to that tuple. A plain node
 * name (e.g. `table`) has no tuple in `specs` and is returned unchanged for the matcher to handle
 * by name.
 */ const $3a9bcd6fd69693b8$var$resolveContentItemName = (name)=>{
    const referencedSpec = (0, $3EVER.specs)[name];
    return Array.isArray(referencedSpec) ? referencedSpec : name;
};
/**
 * Expand the content item NAMES inside a variant tuple's override so they resolve the same way a
 * base spec's content does. A variant such as `panel_c1` is `['panel', { props: { content: { items:
 * [['paragraph_with_no_marks', ..., 'table']] } } }]`; those inner names are validator variant
 * names. Unlike a base spec's content (which `createSpec` resolves), the override names are left
 * raw, so the variant branch matches only plainly-named children (e.g. `table`) and rejects
 * variant-named ones (e.g. a normal `paragraph`). Resolve each name one level, leaving plain node
 * names untouched.
 */ const $3a9bcd6fd69693b8$var$resolveVariantOverrideContentItems = (variantTuple)=>{
    var _variantSpec$props;
    const [baseNodeType, variantSpec] = variantTuple;
    const content = variantSpec === null || variantSpec === void 0 || (_variantSpec$props = variantSpec.props) === null || _variantSpec$props === void 0 ? void 0 : _variantSpec$props.content;
    if (!content || !Array.isArray(content.items)) return variantTuple;
    // Each entry in `content.items` is either a single name or an `$or` group (a list of
    // alternative names). Resolve the names inside each `$or` group; pass single names through.
    const resolvedItems = content.items.map((entry)=>Array.isArray(entry) ? entry.map($3a9bcd6fd69693b8$var$resolveContentItemName) : entry);
    return [
        baseNodeType,
        {
            ...variantSpec,
            props: {
                ...variantSpec.props,
                content: {
                    ...content,
                    items: resolvedItems
                }
            }
        }
    ];
};
function $3a9bcd6fd69693b8$export$a49afc9edc88765c(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys((0, $3EVER.specs)).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...(0, $3EVER.specs)[k]
        };
        if ($3a9bcd6fd69693b8$var$isVariant(spec)) {
            // Their override content items are variant names, which match no child by type, so resolve
            // them one level or valid content gets wrapped as `unsupportedBlock`. For non-panel variants
            // like `mediaSingle_full` the names are already plain, so this is a no-op.
            const resolved = $3a9bcd6fd69693b8$var$resolveVariantOverrideContentItems([
                spec[0],
                spec[1]
            ]);
            spec = {
                ...spec,
                1: resolved[1]
            };
        }
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $fv065.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = (0, $3EVER.specs)[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items.map((item)=>(0, $fv065.isString)(item) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray((0, $3EVER.specs)[item]) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (0, $3EVER.specs)[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>{
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const resolved = (0, $3EVER.specs)[subItem];
                        if (Array.isArray(resolved)) // Resolve the variant tuple's own override content names so a nested match works.
                        return $3a9bcd6fd69693b8$var$resolveVariantOverrideContentItems(resolved);
                        // Now `NoMark` produces `items: []`, should be fixed in generator
                        return (0, $fv065.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ];
                    })// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$1$props;
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                // Only a variant tuple carries an override spec to read; `['text', spec]` above
                                // builds the same shape, so both are covered.
                                const overrideItems = $3a9bcd6fd69693b8$var$isVariant(subItem) ? (_subItem$1$props = subItem[1].props) === null || _subItem$1$props === void 0 || (_subItem$1$props = _subItem$1$props.content) === null || _subItem$1$props === void 0 ? void 0 : _subItem$1$props.items : undefined;
                                // The node-list check below only holds when the override lists child node names. A
                                // nested `$or` list (`string[][]`, as `panel_c1` has) never matches, which would
                                // drop the variant entirely, so keep it and validate its children recursively.
                                const overrideListsChildNodeNames = Array.isArray(overrideItems) && overrideItems.every((item)=>typeof item === 'string');
                                if (isMainNodeSupported && overrideListsChildNodeNames) return overrideItems.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
        * TODO: Probably try something like immer, but it's 3.3kb gzipped.
        * Not worth it just for this.
        */ [
                            subItem[0],
                            $3a9bcd6fd69693b8$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3a9bcd6fd69693b8$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $3a9bcd6fd69693b8$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $3a9bcd6fd69693b8$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiVj2.isDefined)(value)) return !!spec.optional;
    if ($3a9bcd6fd69693b8$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $3a9bcd6fd69693b8$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $3a9bcd6fd69693b8$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiVj2.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $k8KFD.isBoolean)(value);
        case 'number':
            return (0, $fE1Du.isNumber)(value) && ((0, $iiVj2.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiVj2.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $7MqAo.isInteger)(value) && ((0, $iiVj2.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiVj2.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiVj2.isDefined)((0, $avNch.validatorFnMap)[rule]) && (0, $avNch.validatorFnMap)[rule](value);
            return (0, $fv065.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiVj2.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiVj2.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $5I8xg.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$3a9bcd6fd69693b8$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$3a9bcd6fd69693b8$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $fv065.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $3a9bcd6fd69693b8$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $3a9bcd6fd69693b8$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $3a9bcd6fd69693b8$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $3a9bcd6fd69693b8$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else {
        var _parentSpec$props;
        return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message,
            meta: {
                parentType: parentSpec === null || parentSpec === void 0 || (_parentSpec$props = parentSpec.props) === null || _parentSpec$props === void 0 || (_parentSpec$props = _parentSpec$props.type) === null || _parentSpec$props === void 0 ? void 0 : _parentSpec$props.values[0]
            }
        }, $3a9bcd6fd69693b8$var$getUnsupportedOptions(parentSpec));
    }
};
const $3a9bcd6fd69693b8$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $3a9bcd6fd69693b8$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $3a9bcd6fd69693b8$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Copies the containers that validation writes to, keeping the caller's document read-only.
 *
 * Repairing unsupported content mutates the entity in place: `wrapUnSupportedNodeAttributes` deletes
 * keys from `attrs` and appends an `unsupportedNodeAttribute` mark to `marks`. A plain spread shares
 * both containers with the input, so those writes would escape into the caller's document and the
 * candidate-spec retry would re-validate an already-emptied `attrs`.
 *
 * Only `attrs` and `marks` need copying; nothing writes below that level.
 */ const $3a9bcd6fd69693b8$var$cloneEntityForValidation = (entity)=>{
    const clone = {
        ...entity
    };
    if (entity.attrs) clone.attrs = {
        ...entity.attrs
    };
    if (entity.marks) clone.marks = entity.marks.map((mark)=>({
            ...mark
        }));
    return clone;
};
function $3a9bcd6fd69693b8$export$956325f45c5d174a(nodes, marks, options = {}) {
    const { allowPrivateAttributes: allowPrivateAttributes, mode: mode = 'strict', stage0: stage0 } = options;
    // Whether specs that only exist in the stage-0 schema are declined for this caller.
    const rejectStage0Specs = !stage0;
    // Whether an empty `marks` array is dropped from a node that only ever takes an empty one. Resolved
    // once for the same reasons as above. Gate off keeps such a node rejected.
    const acceptEmptyMarks = (0, $gdUUy.fg)('platform_editor_adf_validator_empty_marks');
    const validatorSpecs = $3a9bcd6fd69693b8$export$a49afc9edc88765c(nodes, marks);
    // `extractAllowedContent` scans all of `validatorSpecs` for one node type's candidates, and
    // `validate` calls it per node. It depends only on `validatorSpecs` — fixed once
    // `applyVariantSpecOverrides` has run — and `entity.type`, so it caches per type. Sharing one array
    // across nodes of a type is safe: `getOptionsForType` only iterates it, and the specs inside were
    // already shared via `validatorSpecs`.
    const allowedContentByType = new Map();
    const getAllowedContent = (entity)=>{
        const { type: type } = entity;
        if (typeof type !== 'string') return (0, $6t6lj.extractAllowedContent)(validatorSpecs, entity);
        let allowedContent = allowedContentByType.get(type);
        if (allowedContent === undefined) {
            allowedContent = (0, $6t6lj.extractAllowedContent)(validatorSpecs, entity);
            allowedContentByType.set(type, allowedContent);
        }
        return allowedContent;
    };
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of getAllowedContent(entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = $3a9bcd6fd69693b8$var$cloneEntityForValidation(entity);
        const err = (code, msg, meta)=>{
            const message = $3a9bcd6fd69693b8$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $3a9bcd6fd69693b8$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            var _typeOptions$meta;
            const typeOptions = $3a9bcd6fd69693b8$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            // A spec carrying `meta.stage0` exists only in the stage-0 schema. It reaches here as the
            // candidate the parent offers for this entity, so declining the candidate lets the caller's
            // candidate loop fall through to the next spec, normally the base one. Reading the flag from
            // `parentSpec` would reject the entity's own children and marks instead, emptying a node that
            // matches a stage-0 variant.
            //
            // The rule is partial, and errs towards accepting: `typeOptions` carries variant
            // candidates only, so a stage-0-only base node such as `extensionFrame` reaches here with
            // `{}` and is accepted; `applyVariantSpecOverrides` copies a variant's `props` onto its base
            // without `meta`; and `withoutStage0Meta` clears the flag from variants that also carry
            // `breakout`. Also reading `validatorSpecs[type].meta` would cover the base-node case, but
            // only holds while the generator flags stage-0-only specs and nothing else.
            if (rejectStage0Specs && (_typeOptions$meta = typeOptions.meta) !== null && _typeOptions$meta !== void 0 && _typeOptions$meta.stage0) return {
                valid: false
            };
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    /**
   * Whether the node declares a `marks` property that no mark type may go into, which ADF spells as
   * `marks: { type: 'array', maxItems: 0 }` — `paragraph`, `heading`, `extension` and `codeBlock` all
   * do. An empty array is then the property's only legal value, so it says nothing about the node and
   * carries nothing to reject.
   *
   * The declaration is read off the BASE spec, not the candidate the parent offered. A variant only
   * ever widens the mark types (`extension_with_marks` adds `dataConsumer` and `fragment`), which
   * cannot make the empty list illegal. Reading the candidate instead would leave a root `extension`
   * out, since `doc` offers it as `extension_with_marks`.
   *
   * A node with no `marks` property at all (`rule`, `panel`, `mediaGroup`) is excluded: for those,
   * `marks` is a property ADF does not define, so an empty array is still redundant.
   */ function declaresEmptyMarksOnly(baseSpec) {
        var _baseSpec$props;
        return !!((_baseSpec$props = baseSpec.props) !== null && _baseSpec$props !== void 0 && _baseSpec$props.marks) && allowedMarksFor(baseSpec).length === 0;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $3a9bcd6fd69693b8$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        // Attribute validation may have already put an `unsupportedNodeAttribute` mark on `newEntity`.
        // It is not in `prevEntity.marks`, so rebuilding from those alone loses the only record of the
        // unknown attribute. The check above only covers the mark being on the original entity, which
        // held while the validated entity still aliased the caller's marks array.
        const prevMarkTypes = new Set(currentMarks.map((mark)=>mark.type));
        const synthesizedMarks = (newEntity.marks ?? []).filter((mark)=>!prevMarkTypes.has(mark.type));
        const allMarks = newMarks.concat(synthesizedMarks);
        if (allMarks.length) {
            newEntity.marks = allMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiVj2.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiVj2.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$3a9bcd6fd69693b8$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiVj2.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiVj2.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $kTMq5.makeArray)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $3a9bcd6fd69693b8$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $3a9bcd6fd69693b8$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $3a9bcd6fd69693b8$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $3a9bcd6fd69693b8$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $3a9bcd6fd69693b8$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $3a9bcd6fd69693b8$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $3a9bcd6fd69693b8$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $3a9bcd6fd69693b8$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiVj2.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $ba2Pr.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $3a9bcd6fd69693b8$var$partitionObject(validatorSpec.props, (k, v)=>{
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $iiVj2.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $3a9bcd6fd69693b8$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            // `marksValidationOutput` is derived from the ORIGINAL marks, so it omits marks
                            // synthesized during validation. The `unsupportedNodeAttribute` mark is one of those
                            // and is the only record of an unknown attribute, so rebuilding from the output alone
                            // destroys it. This survived by accident before entities were deep-cloned.
                            const validatedMarkTypes = new Set(marksValidationOutput.map((markResult)=>{
                                var _markResult$originalM;
                                return (_markResult$originalM = markResult.originalMark) === null || _markResult$originalM === void 0 ? void 0 : _markResult$originalM.type;
                            }));
                            const synthesizedMarks = childEntity.marks.filter((mark)=>!validatedMarkTypes.has(mark.type));
                            const allMarks = finalMarks.concat(synthesizedMarks);
                            if (allMarks.length) childEntity.marks = allMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $kTMq5.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $kTMq5.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $3a9bcd6fd69693b8$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $3a9bcd6fd69693b8$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) {
            // An empty array on a node that only ever takes an empty array is dropped rather than
            // validated. Mark validation has nothing to reject in it, so it reports the node valid with an
            // empty `marksValidationOutput`, which reads to the parent's `validateChildMarks` as every
            // mark on the child having been rejected, and the candidate spec gets declined.
            if (acceptEmptyMarks && prevEntity.marks.length === 0 && declaresEmptyMarksOnly(spec)) {
                delete newEntity.marks;
                return specBasedValidationResult;
            }
            return {
                hasValidated: true,
                result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
            };
        }
        return specBasedValidationResult;
    }
}

});
parcelRegister("ba2Pr", function(module, exports) {
$parcel$export(module.exports, "copy", () => $4a5432f5beb67c40$export$784d13d8ee351f07);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4a5432f5beb67c40$export$784d13d8ee351f07 = (source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};

});

parcelRegister("6t6lj", function(module, exports) {
$parcel$export(module.exports, "extractAllowedContent", () => $de4ca0c4b37b7902$export$7d2123bc001cdbf8);
function $de4ca0c4b37b7902$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($de4ca0c4b37b7902$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($de4ca0c4b37b7902$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$de4ca0c4b37b7902$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $de4ca0c4b37b7902$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}

});

parcelRegister("k8KFD", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $0460b4e5574c0982$export$f9ce7b637dfbe238);
const $0460b4e5574c0982$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';

});

parcelRegister("iiVj2", function(module, exports) {
$parcel$export(module.exports, "isDefined", () => $dcaafdefe60105e9$export$4e62c701997796c1);
const $dcaafdefe60105e9$export$4e62c701997796c1 = (x)=>x != null;

});

parcelRegister("7MqAo", function(module, exports) {
$parcel$export(module.exports, "isInteger", () => $d4426c4ca218edff$export$a287f47fed4544b8);
const $d4426c4ca218edff$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;

});

parcelRegister("fE1Du", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $57aee88ba4b3fc64$export$7e4aa119212bc614);
const $57aee88ba4b3fc64$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);

});

parcelRegister("5I8xg", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $03674ab2e2d05b9d$export$53b83ca8eaab0383);
const $03674ab2e2d05b9d$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);

});

parcelRegister("fv065", function(module, exports) {
$parcel$export(module.exports, "isString", () => $b571d71282adca6f$export$844ec244b1367d54);
// This is a kludge, might replace with something like _.isString in future
const $b571d71282adca6f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;

});

parcelRegister("kTMq5", function(module, exports) {
$parcel$export(module.exports, "makeArray", () => $a700ffe06d30baa2$export$7b85fd78dd236198);
// Helpers
const $a700ffe06d30baa2$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("avNch", function(module, exports) {
$parcel$export(module.exports, "validatorFnMap", () => $1b1359dfbc99731d$export$d1b377ca77ac267d);

var $7nI18 = parcelRequire("7nI18");
const $1b1359dfbc99731d$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $7nI18.isSafeUrl)
};

});
parcelRegister("7nI18", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $ac67a7908edeb7d1$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $ac67a7908edeb7d1$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $ac67a7908edeb7d1$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $ac67a7908edeb7d1$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};

});


parcelRegister("3EVER", function(module, exports) {
$parcel$export(module.exports, "specs", () => $9536e3ecd8c5124d$export$13afbb83a3ae2576);
// This is a lookup map consumed by `createSpec`, not an entry point re-exporting the schema
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9i4Bb = parcelRequire("9i4Bb");
const $9536e3ecd8c5124d$export$13afbb83a3ae2576 = {
    alignment: $9i4Bb.alignment,
    annotation: $9i4Bb.annotation,
    backgroundColor: $9i4Bb.backgroundColor,
    blockCard: $9i4Bb.blockCard,
    blockRootOnly: $9i4Bb.blockRootOnly,
    blockTaskItem: $9i4Bb.blockTaskItem,
    block_content: $9i4Bb.block_content,
    blockquote: $9i4Bb.blockquote,
    bodiedExtension: $9i4Bb.bodiedExtension,
    bodiedExtension_root_only: $9i4Bb.bodiedExtension_root_only,
    bodiedExtension_with_marks: $9i4Bb.bodiedExtension_with_marks,
    bodiedRule: $9i4Bb.bodiedRule,
    bodiedRule_root_only: $9i4Bb.bodiedRule_root_only,
    bodiedSyncBlock: $9i4Bb.bodiedSyncBlock,
    border: $9i4Bb.border,
    breakout: $9i4Bb.breakout,
    bulletList: $9i4Bb.bulletList,
    caption: $9i4Bb.caption,
    code: $9i4Bb.code,
    codeBlock: $9i4Bb.codeBlock,
    codeBlock_root_only: $9i4Bb.codeBlock_root_only,
    confluenceInlineComment: $9i4Bb.confluenceInlineComment,
    dataConsumer: $9i4Bb.dataConsumer,
    date: $9i4Bb.date,
    decisionItem: $9i4Bb.decisionItem,
    decisionList: $9i4Bb.decisionList,
    doc: $9i4Bb.doc,
    em: $9i4Bb.em,
    embedCard: $9i4Bb.embedCard,
    emoji: $9i4Bb.emoji,
    expand: $9i4Bb.expand,
    expand_root_only: $9i4Bb.expand_root_only,
    extension: $9i4Bb.extension,
    extensionFrame: $9i4Bb.extensionFrame,
    extension_root_only: $9i4Bb.extension_root_only,
    extension_root_only_with_annotation: $9i4Bb.extension_root_only_with_annotation,
    extension_with_annotation: $9i4Bb.extension_with_annotation,
    extension_with_marks: $9i4Bb.extension_with_marks,
    fontSize: $9i4Bb.fontSize,
    fragment: $9i4Bb.fragment,
    hardBreak: $9i4Bb.hardBreak,
    heading: $9i4Bb.heading,
    heading_with_alignment: $9i4Bb.heading_with_alignment,
    heading_with_indentation: $9i4Bb.heading_with_indentation,
    heading_with_no_marks: $9i4Bb.heading_with_no_marks,
    indentation: $9i4Bb.indentation,
    inlineCard: $9i4Bb.inlineCard,
    inlineExtension: $9i4Bb.inlineExtension,
    inlineExtension_with_marks: $9i4Bb.inlineExtension_with_marks,
    inline_content: $9i4Bb.inline_content,
    layoutColumn: $9i4Bb.layoutColumn,
    layoutSection: $9i4Bb.layoutSection,
    layoutSection_full: $9i4Bb.layoutSection_full,
    layoutSection_with_single_column: $9i4Bb.layoutSection_with_single_column,
    link: $9i4Bb.link,
    listItem: $9i4Bb.listItem,
    media: $9i4Bb.media,
    mediaGroup: $9i4Bb.mediaGroup,
    mediaInline: $9i4Bb.mediaInline,
    mediaSingle: $9i4Bb.mediaSingle,
    mediaSingle_caption: $9i4Bb.mediaSingle_caption,
    mediaSingle_full: $9i4Bb.mediaSingle_full,
    mention: $9i4Bb.mention,
    multiBodiedExtension: $9i4Bb.multiBodiedExtension,
    multiBodiedExtension_root_only: $9i4Bb.multiBodiedExtension_root_only,
    nestedExpand: $9i4Bb.nestedExpand,
    nestedExpand_content: $9i4Bb.nestedExpand_content,
    nestedExpand_with_no_marks: $9i4Bb.nestedExpand_with_no_marks,
    non_nestable_block_content: $9i4Bb.non_nestable_block_content,
    orderedList: $9i4Bb.orderedList,
    panel: $9i4Bb.panel,
    panel_c1: $9i4Bb.panel_c1,
    panel_c1_root_only: $9i4Bb.panel_c1_root_only,
    panel_root_only: $9i4Bb.panel_root_only,
    paragraph: $9i4Bb.paragraph,
    paragraph_with_alignment: $9i4Bb.paragraph_with_alignment,
    paragraph_with_font_size: $9i4Bb.paragraph_with_font_size,
    paragraph_with_indentation: $9i4Bb.paragraph_with_indentation,
    paragraph_with_no_marks: $9i4Bb.paragraph_with_no_marks,
    placeholder: $9i4Bb.placeholder,
    rule: $9i4Bb.rule,
    rule_root_only: $9i4Bb.rule_root_only,
    rule_with_attrs: $9i4Bb.rule_with_attrs,
    rule_with_attrs_root_only: $9i4Bb.rule_with_attrs_root_only,
    status: $9i4Bb.status,
    strike: $9i4Bb.strike,
    strong: $9i4Bb.strong,
    subsup: $9i4Bb.subsup,
    syncBlock: $9i4Bb.syncBlock,
    table: $9i4Bb.table,
    tableCell: $9i4Bb.tableCell,
    tableHeader: $9i4Bb.tableHeader,
    tableRow: $9i4Bb.tableRow,
    taskItem: $9i4Bb.taskItem,
    taskList: $9i4Bb.taskList,
    text: $9i4Bb.text,
    textColor: $9i4Bb.textColor,
    text_code_inline: $9i4Bb.text_code_inline,
    text_formatted: $9i4Bb.text_formatted,
    text_link_inline: $9i4Bb.text_link_inline,
    text_with_no_marks: $9i4Bb.text_with_no_marks,
    underline: $9i4Bb.underline
};

});
parcelRegister("9i4Bb", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $60567ec1de9a19b7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $60567ec1de9a19b7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $60567ec1de9a19b7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $60567ec1de9a19b7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $60567ec1de9a19b7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $60567ec1de9a19b7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $60567ec1de9a19b7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "blockTaskItem", () => $60567ec1de9a19b7$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $60567ec1de9a19b7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_root_only", () => $60567ec1de9a19b7$export$b7a532f6e202d8ea);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $60567ec1de9a19b7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "bodiedRule", () => $60567ec1de9a19b7$export$2069efcbff2f0292);
$parcel$export(module.exports, "bodiedRule_root_only", () => $60567ec1de9a19b7$export$ab41d73148acae83);
$parcel$export(module.exports, "bodiedSyncBlock", () => $60567ec1de9a19b7$export$e92c7e4302dd4371);
$parcel$export(module.exports, "border", () => $60567ec1de9a19b7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $60567ec1de9a19b7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $60567ec1de9a19b7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $60567ec1de9a19b7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $60567ec1de9a19b7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $60567ec1de9a19b7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $60567ec1de9a19b7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $60567ec1de9a19b7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $60567ec1de9a19b7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $60567ec1de9a19b7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $60567ec1de9a19b7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $60567ec1de9a19b7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $60567ec1de9a19b7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $60567ec1de9a19b7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $60567ec1de9a19b7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $60567ec1de9a19b7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $60567ec1de9a19b7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $60567ec1de9a19b7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $60567ec1de9a19b7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_root_only", () => $60567ec1de9a19b7$export$8eba3df128e25335);
$parcel$export(module.exports, "extension_root_only_with_annotation", () => $60567ec1de9a19b7$export$9dccb771264f1ee3);
$parcel$export(module.exports, "extension_with_annotation", () => $60567ec1de9a19b7$export$a3b88288627564ec);
$parcel$export(module.exports, "extension_with_marks", () => $60567ec1de9a19b7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $60567ec1de9a19b7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fontSize", () => $60567ec1de9a19b7$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $60567ec1de9a19b7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $60567ec1de9a19b7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $60567ec1de9a19b7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $60567ec1de9a19b7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $60567ec1de9a19b7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $60567ec1de9a19b7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $60567ec1de9a19b7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $60567ec1de9a19b7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $60567ec1de9a19b7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $60567ec1de9a19b7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $60567ec1de9a19b7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $60567ec1de9a19b7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $60567ec1de9a19b7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $60567ec1de9a19b7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $60567ec1de9a19b7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $60567ec1de9a19b7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $60567ec1de9a19b7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $60567ec1de9a19b7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $60567ec1de9a19b7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $60567ec1de9a19b7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $60567ec1de9a19b7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $60567ec1de9a19b7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $60567ec1de9a19b7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $60567ec1de9a19b7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $60567ec1de9a19b7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "multiBodiedExtension_root_only", () => $60567ec1de9a19b7$export$78421d8497ebdea6);
$parcel$export(module.exports, "nestedExpand", () => $60567ec1de9a19b7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $60567ec1de9a19b7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $60567ec1de9a19b7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $60567ec1de9a19b7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $60567ec1de9a19b7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $60567ec1de9a19b7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panel_c1", () => $60567ec1de9a19b7$export$a08c7bcc7e61d424);
$parcel$export(module.exports, "panel_c1_root_only", () => $60567ec1de9a19b7$export$76e58fb94da2bf88);
$parcel$export(module.exports, "panel_root_only", () => $60567ec1de9a19b7$export$9388c8efa26ea154);
$parcel$export(module.exports, "paragraph", () => $60567ec1de9a19b7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $60567ec1de9a19b7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_font_size", () => $60567ec1de9a19b7$export$f745a1f9fa5e1ca8);
$parcel$export(module.exports, "paragraph_with_indentation", () => $60567ec1de9a19b7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $60567ec1de9a19b7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $60567ec1de9a19b7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $60567ec1de9a19b7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "rule_root_only", () => $60567ec1de9a19b7$export$5bc14ade5ae67510);
$parcel$export(module.exports, "rule_with_attrs", () => $60567ec1de9a19b7$export$74942eaebdd7ffe);
$parcel$export(module.exports, "rule_with_attrs_root_only", () => $60567ec1de9a19b7$export$b64c73d0ec95c7d3);
$parcel$export(module.exports, "status", () => $60567ec1de9a19b7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $60567ec1de9a19b7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $60567ec1de9a19b7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $60567ec1de9a19b7$export$b3401ee80eb31041);
$parcel$export(module.exports, "syncBlock", () => $60567ec1de9a19b7$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $60567ec1de9a19b7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $60567ec1de9a19b7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $60567ec1de9a19b7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $60567ec1de9a19b7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $60567ec1de9a19b7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $60567ec1de9a19b7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $60567ec1de9a19b7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $60567ec1de9a19b7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $60567ec1de9a19b7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $60567ec1de9a19b7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $60567ec1de9a19b7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $60567ec1de9a19b7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $60567ec1de9a19b7$export$425327af25286e5e);
const $60567ec1de9a19b7$export$8e53000a4ec837 = {
    props: {
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$8512c9afa7b24c3b = {
    props: {
        attrs: {
            props: {
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                },
                id: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$8c5a050822fd698c = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'rule_with_attrs',
    'bodiedRule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'extension_with_annotation',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $60567ec1de9a19b7$export$c4c2f833baaebdb8 = {
    props: {
        attrs: [
            {
                props: {
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    layout: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        optional: true,
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $60567ec1de9a19b7$export$67dc04e652a298ca = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $60567ec1de9a19b7$export$16018c61064a18df = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks',
                    'extension_with_annotation'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$27903d543b563e39 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$b7a532f6e202d8ea = [
    'bodiedExtension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$2069efcbff2f0292 = {
    meta: {
        stage0: true
    },
    props: {
        attrs: {
            props: {
                alignment: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'start',
                        'center',
                        'end'
                    ]
                },
                color: {
                    optional: true,
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'solid',
                        'dashed',
                        'dotted',
                        'sketch',
                        'fade'
                    ]
                },
                weight: {
                    maximum: 3,
                    minimum: 1,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks'
                ]
            ],
            maxItems: 1,
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedRule'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$ab41d73148acae83 = [
    'bodiedRule',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$e92c7e4302dd4371 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel_c1',
                    'panel',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$1edee58a52776cd9 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                size: {
                    maximum: 3,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$89015c65f1c75e3f = {
    props: {
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$a140c94e5ea26bee = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$8e3c2dfdc4f0453d = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$7bb0d5c671655cc4 = {
    props: {
        attrs: {
            optional: true,
            props: {
                hideLineNumbers: {
                    optional: true,
                    type: 'boolean'
                },
                language: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                uniqueId: {
                    optional: true,
                    type: 'string'
                },
                wrap: {
                    optional: true,
                    type: 'boolean'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            maxItems: 0,
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$f3b72f8fc4684ecd = {
    props: {
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$3024f02c495408d6 = {
    props: {
        attrs: {
            props: {
                sources: {
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1,
                    type: 'array'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$324d90190a8b822a = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$6959e16eeff859b4 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$62d45a65fb43d95e = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'decisionItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$2a111da947c407d2 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'panel_c1',
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'panel_root_only',
                    'panel_c1_root_only',
                    'rule_root_only',
                    'rule_with_attrs_root_only',
                    'bodiedRule_root_only',
                    'extension_root_only',
                    'extension_root_only_with_annotation',
                    'bodiedExtension_root_only',
                    'multiBodiedExtension_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        }
    }
};
const $60567ec1de9a19b7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$be4283d9a1cb1ff6 = {
    props: {
        attrs: {
            props: {
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                originalHeight: {
                    optional: true,
                    type: 'number'
                },
                originalWidth: {
                    optional: true,
                    type: 'number'
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$a19185d1233fc4b2 = {
    props: {
        attrs: {
            props: {
                id: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$9f77e0932fb78f72 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            maxItems: 0,
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$1b45514b112dd749 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$8eba3df128e25335 = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$9dccb771264f1ee3 = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'annotation',
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$a3b88288627564ec = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'annotation',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$4fdcae991fd743e7 = {
    meta: {
        stage0: true
    },
    props: {
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$85e3c3ca0c6fb93 = {
    props: {
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$f00aeb236b6f05af = {
    props: {
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$371da9dd35aba193 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'enum',
                    values: [
                        '\n'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$46e4a324ac90507f = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                },
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'alignment'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'indentation'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$480c699bd4ec0d86 = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $60567ec1de9a19b7$export$cbf8224b64e0d942 = {
    props: {
        attrs: [
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $60567ec1de9a19b7$export$16b353b2649bd8d9 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$ab76e7c03cd6f650 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'panel_c1',
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$b3b6a70a7fa4a5be = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'layoutColumn'
            ],
            maxItems: 3,
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 3,
                minItems: 2,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    columnRuleStyle: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            },
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 5,
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$9c30223ca0a664fb = {
    props: {
        attrs: {
            props: {
                collection: {
                    optional: true,
                    type: 'string'
                },
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                id: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$76c7e83ecc9cdf05 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$987d49ffe1b0900f = {
    props: {
        attrs: [
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            }
        ],
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $60567ec1de9a19b7$export$2855e964765eac9 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                'media'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$38bab695e3f720f1 = {
    props: {
        attrs: {
            props: {
                alt: {
                    optional: true,
                    type: 'string'
                },
                collection: {
                    type: 'string'
                },
                data: {
                    optional: true,
                    type: 'object'
                },
                height: {
                    optional: true,
                    type: 'number'
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                type: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ]
                },
                url: {
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$969fe3781ca15058 = {
    props: {
        attrs: [
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        maximum: 100,
                        minimum: 0,
                        optional: true,
                        type: 'number'
                    },
                    widthType: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'percentage'
                        ]
                    }
                }
            },
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        minimum: 0,
                        type: 'number'
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    }
                }
            }
        ],
        marks: {
            items: [
                'link'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                maxItems: 2,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$db83999c14438df4 = {
    props: {
        attrs: {
            props: {
                accessLevel: {
                    optional: true,
                    type: 'string'
                },
                id: {
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                },
                userType: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ]
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$c3c04d555a8b9013 = {
    meta: {
        stage0: true
    },
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'extensionFrame'
            ],
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$78421d8497ebdea6 = [
    'multiBodiedExtension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$63cadbf5f4296627 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: 'nestedExpand_content',
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $60567ec1de9a19b7$export$9584f52f3ebd5d7e = {
    allowUnsupportedBlock: true,
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'rule_with_attrs',
            'bodiedRule',
            'panel',
            'blockquote',
            'extension_with_marks',
            'extension_with_annotation'
        ]
    ],
    minItems: 1,
    type: 'array'
};
const $60567ec1de9a19b7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'rule_with_attrs',
    'bodiedRule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $60567ec1de9a19b7$export$a5dc81035676e7a = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                order: {
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$21f42ab9b6679f44 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                panelColor: {
                    optional: true,
                    type: 'string'
                },
                panelIcon: {
                    optional: true,
                    type: 'string'
                },
                panelIconId: {
                    optional: true,
                    type: 'string'
                },
                panelIconText: {
                    optional: true,
                    type: 'string'
                },
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'decisionList',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$a08c7bcc7e61d424 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'rule_with_attrs',
                        'bodiedRule',
                        'decisionList',
                        'extension_with_marks',
                        'extension_with_annotation',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$76e58fb94da2bf88 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'rule_with_attrs',
                        'bodiedRule',
                        'decisionList',
                        'extension_with_marks',
                        'extension_with_annotation',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$9388c8efa26ea154 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$9c206ddddb32a9b = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    'fontSize'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$c7187bbd1a7a9244 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$fbeb3a3956e8a3c7 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$5bc14ade5ae67510 = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$74942eaebdd7ffe = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    color: {
                        optional: true,
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    style: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid',
                            'dashed',
                            'dotted',
                            'sketch',
                            'fade'
                        ]
                    },
                    weight: {
                        maximum: 3,
                        minimum: 1,
                        optional: true,
                        type: 'number'
                    }
                }
            }
        }
    }
];
const $60567ec1de9a19b7$export$b64c73d0ec95c7d3 = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    color: {
                        optional: true,
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    style: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid',
                            'dashed',
                            'dotted',
                            'sketch',
                            'fade'
                        ]
                    },
                    weight: {
                        maximum: 3,
                        minimum: 1,
                        optional: true,
                        type: 'number'
                    }
                }
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$471f7ae5c4103ae1 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^(neutral|purple|blue|red|yellow|green|#[0-9a-fA-F]{6})$',
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$b3401ee80eb31041 = {
    props: {
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$faab0ca9701d7048 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$9852986a3ec5f6a0 = {
    props: {
        attrs: {
            optional: true,
            props: {
                displayMode: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ]
                },
                isNumberColumnEnabled: {
                    optional: true,
                    type: 'boolean'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'tableRow'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'fragment'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$e1e720e5f4603e6a = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $60567ec1de9a19b7$export$48884d2a5190dc73 = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $60567ec1de9a19b7$export$ce666bf02318c957 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$6d8b0ef52e2e6390 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$375b6afcc5f4d291 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$6f093cfa640b7166 = {
    props: {
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        text: {
            minLength: 1,
            type: 'string'
        },
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    'link'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $60567ec1de9a19b7$export$32f78bffcd82ff28 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        }
    }
};
const $60567ec1de9a19b7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});





parcelRegister("gASCv", function(module, exports) {
$parcel$export(module.exports, "validateUserPickerSetValue", () => $ba3d17319a8963d2$export$3dc07da29c05fcd);
$parcel$export(module.exports, "userPickerSetValueTransformer", () => $ba3d17319a8963d2$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerPortalSetValueTransformer", () => $ba3d17319a8963d2$export$ff5e806e6042411b);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $ba3d17319a8963d2$export$e87b0f36be178543);
$parcel$export(module.exports, "modifyUserPickerValueToBasic", () => $ba3d17319a8963d2$export$ef961f8b571be395);

var $jBiia = parcelRequire("jBiia");

var $51XYw = parcelRequire("51XYw");

var $eDcdn = parcelRequire("eDcdn");

var $cnEqX = parcelRequire("cnEqX");

var $gRlee = parcelRequire("gRlee");

var $5iRil = parcelRequire("5iRil");

var $87QgR = parcelRequire("87QgR");
/**
 * Finds a user in the lookup data by their account ID.
 *
 * @param lookupData - Array of users to search through
 * @param accountId - The account ID to search for
 * @returns The matching user object or null if not found
 */ const $ba3d17319a8963d2$var$findUserLookupValue = (lookupData, accountId)=>{
    if (!lookupData || !Array.isArray(lookupData)) return null;
    return lookupData.find((user)=>user.accountId === accountId) || null;
};
const $ba3d17319a8963d2$export$3dc07da29c05fcd = (value)=>value === null || (0, $5iRil.isNotEmptyString)(value) && (0, $gRlee.isNotAutomaticId)(value);
const $ba3d17319a8963d2$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundUser = $ba3d17319a8963d2$var$findUserLookupValue(lookupValues || [], value);
    if (!foundUser) throw new (0, $cnEqX.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    return {
        label: foundUser.name,
        email: '',
        iconUrl: foundUser.picture,
        accountId: foundUser.accountId,
        value: foundUser.accountId
    };
};
const $ba3d17319a8963d2$export$f2798b13cb02e004 = (fieldContext)=>{
    var _fieldContext$extraDa;
    const fieldConfigId = fieldContext === null || fieldContext === void 0 || (_fieldContext$extraDa = fieldContext.extraData) === null || _fieldContext$extraDa === void 0 ? void 0 : _fieldContext$extraDa.fieldConfigId;
    return typeof fieldConfigId === 'string' && fieldConfigId ? {
        fieldConfigId: fieldConfigId
    } : {};
};
const $ba3d17319a8963d2$export$ff5e806e6042411b = async (value, _lookupValues, transformerContext)=>{
    var _transformerContext$e, _transformerContext$f;
    if (value === null) return null;
    const portalId = transformerContext === null || transformerContext === void 0 || (_transformerContext$e = transformerContext.executionContext) === null || _transformerContext$e === void 0 || (_transformerContext$e = _transformerContext$e.portal) === null || _transformerContext$e === void 0 ? void 0 : _transformerContext$e.id;
    const fieldName = transformerContext === null || transformerContext === void 0 || (_transformerContext$f = transformerContext.fieldContext) === null || _transformerContext$f === void 0 ? void 0 : _transformerContext$f.fieldId;
    if (!portalId || !fieldName) throw new (0, $cnEqX.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    const searchParams = new URLSearchParams({
        fieldName: fieldName,
        query: value
    });
    // The field's configuration applies its user filter (groups or project roles), so the
    // search only returns users the Portal picker would offer
    const { fieldConfigId: fieldConfigId } = $ba3d17319a8963d2$export$f2798b13cb02e004(transformerContext === null || transformerContext === void 0 ? void 0 : transformerContext.fieldContext);
    if (fieldConfigId) searchParams.append('fieldConfigId', fieldConfigId);
    const queryString = searchParams.toString();
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/portal/${portalId}/user-search?${queryString}`;
    let users;
    try {
        users = await (0, $51XYw.fetchJson)(uri, {
            method: 'GET'
        });
    } catch (error) {
        (0, $jBiia.trackError)('finduser.fetch.failed', {}, error instanceof Error ? error : undefined);
        throw error;
    }
    // The search matches on more than the account ID, so only an exact match counts
    const foundUser = Array.isArray(users) ? users.find((user)=>user.accountId === value) : undefined;
    if (!foundUser) throw new (0, $cnEqX.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    return {
        label: foundUser.displayName,
        email: foundUser.emailAddress ?? '',
        iconUrl: foundUser.avatar,
        accountId: foundUser.accountId,
        value: foundUser.accountId
    };
};
const $ba3d17319a8963d2$export$e87b0f36be178543 = (value)=>{
    if (!value || (0, $87QgR.default).checkGate('ditto_fix_getvalue_empty_state') && !value.accountId) return null;
    return {
        accountId: value.accountId
    };
};
const $ba3d17319a8963d2$export$ef961f8b571be395 = (value)=>{
    if (!value) return null;
    return value.accountId;
};

});
parcelRegister("gRlee", function(module, exports) {
$parcel$export(module.exports, "isNotAutomaticId", () => $b391fbe90eabd20e$export$ab4c3a3c49d7add);

var $egWdp = parcelRequire("egWdp");
const $b391fbe90eabd20e$export$ab4c3a3c49d7add = (value)=>value !== (0, $egWdp.AUTOMATIC_ID);

});


parcelRegister("kySpt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ff79b45c7ac36a8$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var // TODO: to be refined in https://ecosystem-platform.atlassian.net/browse/UIM-2463
$1ff79b45c7ac36a8$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    obligatoryUimRequestCreateConsentMessage: {
        id: 'ui-modifications-fields-configuration.common.utils.views.request-create.obligatory-uim-request-create-consent-message',
        defaultMessage: 'You must allow "{appTitle}" to access your Atlassian products to create this work item.',
        description: 'When a user opens a context the first time, we require that they give consent for their data otherwise they cannot get the UIM`s applied'
    }
});

});

parcelRegister("bQPxx", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $bd08357c296343b8$export$973aead813665e25);

var $4WK8W = parcelRequire("4WK8W");
const $bd08357c296343b8$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $bd08357c296343b8$export$973aead813665e25 = (optionsVisibility)=>(0, $4WK8W.validateSetOptionsVisibilityRule)(optionsVisibility) && $bd08357c296343b8$export$914c7f5212c4c649(optionsVisibility);

});



parcelRegister("36cmj", function(module, exports) {
$parcel$export(module.exports, "portalReorderRoute", () => $c0c406158f24fb49$export$f321c3c48e8f4288);
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");

var $1xzNy = parcelRequire("1xzNy");

var $9IExk = parcelRequire("9IExk");
const $c0c406158f24fb49$export$f321c3c48e8f4288 = (shouldLoadHelpEditTopicsResource = false)=>{
    const resources = [];
    if (shouldLoadHelpEditTopicsResource) resources.push((0, $9IExk.helpEditTopicsResource));
    resources.push((0, $9IExk.hiddenSectionWarningResource));
    return {
        resources: resources,
        path: '/settings/portal-reorder',
        exact: true,
        component: (0, $hbIgt.withRouter)((0, $1xzNy.PortalReorderingRoute)),
        name: 'portal-reorder'
    };
};

});
parcelRegister("1xzNy", function(module, exports) {
$parcel$export(module.exports, "PortalReorderingRoute", () => $bf6c65fac2711b50$export$d8bb1160246519d9);
$parcel$export(module.exports, "callToActionUrlText", () => $bf6c65fac2711b50$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $bf6c65fac2711b50$export$5342e2a00fe6d647);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $jcRK7 = parcelRequire("jcRK7");

var $cVM5r = parcelRequire("cVM5r");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");
parcelRequire("TdcAL");
var $57PyM = parcelRequire("57PyM");

var $hbZs5 = parcelRequire("hbZs5");
parcelRequire("ampBZ");
var $gsgVJ = parcelRequire("gsgVJ");

const $bf6c65fac2711b50$export$73a0508c941788d6 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("kpZCJ")), {
        moduleId: "./src/view/portal-reorder-experience/hocs.tsx"
    }),
    LoadingSkeleton: (0, $gsgVJ.default),
    loadingPosition: 'fill-container'
});
const $bf6c65fac2711b50$var$PORTAL_REORDERING_PATH = '/settings/portal-reorder';
const $bf6c65fac2711b50$export$d8bb1160246519d9 = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: $bf6c65fac2711b50$var$PORTAL_REORDERING_PATH
    }), (0, $ifEXU.default)({
        message: formatMessage((0, $hbZs5.default).authPageMessage),
        callToActionText: formatMessage((0, $hbZs5.default).callToActionUrlText),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $57PyM.default), {
            path: $bf6c65fac2711b50$var$PORTAL_REORDERING_PATH,
            component: $bf6c65fac2711b50$export$73a0508c941788d6,
            screenName: (0, $jcRK7.ScreenName).PORTAL_REORDER_SETTINGS
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
$bf6c65fac2711b50$export$d8bb1160246519d9.displayName = 'PortalReorderingRoute';
const $bf6c65fac2711b50$export$d96795d242b62963 = (0, $hbZs5.default).callToActionUrlText;
const $bf6c65fac2711b50$export$5342e2a00fe6d647 = (0, $hbZs5.default).authPageMessage;

});
parcelRegister("jMb7S", function(module, exports) {
$parcel$export(module.exports, "withOnlyJiraAdmin", () => (parcelRequire("ifEXU")).default);

var $ifEXU = parcelRequire("ifEXU");

});
parcelRegister("ifEXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb3481675aa31a8d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $jcRK7 = parcelRequire("jcRK7");

var $fFr9c = parcelRequire("fFr9c");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("bQE3n");
var $eOp7R = parcelRequire("eOp7R");
const $eb3481675aa31a8d$var$selector = (0, $BOq7h.createSelector)((0, $fBLyB.getCanAdministerJIRA), (canAdministerJira)=>({
        canAdministerJira: canAdministerJira
    }));
const $eb3481675aa31a8d$var$connector = (0, $f2mlD.default)($eb3481675aa31a8d$var$selector, null);
const $eb3481675aa31a8d$var$withOnlyJiraAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { canAdministerJira: canAdministerJira } = props;
            if (canAdministerJira) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $bSJIT.createElement((0, $eOp7R.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $fFr9c.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $jcRK7.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $eb3481675aa31a8d$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyJiraAdmin';
        return ConnectedComponent;
    };
var $eb3481675aa31a8d$export$2e2bcd8739ae039 = $eb3481675aa31a8d$var$withOnlyJiraAdmin;

});


parcelRegister("gCsyK", function(module, exports) {
$parcel$export(module.exports, "withOnlyLoggedIn", () => (parcelRequire("fv7xe")).default);

var $fv7xe = parcelRequire("fv7xe");

});
parcelRegister("fv7xe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d464629f026aa9b0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $g5FS7 = parcelRequire("g5FS7");

var $oORS9 = parcelRequire("oORS9");
const $d464629f026aa9b0$var$selector = (0, $BOq7h.createSelector)((0, $fBLyB.isLoggedIn), (isLoggedIn)=>({
        isLoggedIn: isLoggedIn
    }));
const $d464629f026aa9b0$var$connector = (0, $f2mlD.default)($d464629f026aa9b0$var$selector, null);
const $d464629f026aa9b0$var$withOnlyLoggedIn = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isLoggedIn: isLoggedIn } = props;
            if (isLoggedIn) // @ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props);
            const { redirectUrl: redirectUrl } = options;
            const loginUrl = (0, $oORS9.getLoginUrl)({
                redirectUrl: redirectUrl,
                isAbsolute: false
            });
            return /*#__PURE__*/ $bSJIT.createElement((0, $g5FS7.Redirect), {
                to: loginUrl
            });
        };
        const ConnectedComponent = $d464629f026aa9b0$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyLoggedIn';
        return ConnectedComponent;
    };
var $d464629f026aa9b0$export$2e2bcd8739ae039 = $d464629f026aa9b0$var$withOnlyLoggedIn;

});
parcelRegister("g5FS7", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $e7cc8f130f88074e$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "PushRedirectWithState", () => $e7cc8f130f88074e$export$e3f5537ca0fe1626);
$parcel$export(module.exports, "PushRedirect", () => $e7cc8f130f88074e$export$74676119665a0bf8);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $it2qY = parcelRequire("it2qY");
var $hbIgt = parcelRequire("hbIgt");
const $e7cc8f130f88074e$export$2d8d895a0a0f636e = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $it2qY.Redirect), props);
};
const $e7cc8f130f88074e$export$e3f5537ca0fe1626 = (0, $hbIgt.withRouter)(({ history: history, to: to, state: state })=>{
    (0, $bSJIT.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to, state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        to,
        state
    ]);
    return null;
});
const $e7cc8f130f88074e$export$74676119665a0bf8 = (0, $hbIgt.withRouter)(({ history: history, to: to })=>{
    (0, $bSJIT.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to);
    }, [
        history,
        to
    ]);
    return null;
});

});



parcelRegister("TdcAL", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("57PyM")).default);
parcelRequire("e7LLP");
var $57PyM = parcelRequire("57PyM");

});
parcelRegister("e7LLP", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("57PyM")).default);

var $57PyM = parcelRequire("57PyM");

});
parcelRegister("57PyM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3320e0df19ea44b5$export$2e2bcd8739ae039);
/* splash-layout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $OK0aw = parcelRequire("OK0aw");

var $bSA8a = parcelRequire("bSA8a");
parcelRequire("1rVud");
var $3aqSY = parcelRequire("3aqSY");

var $kkzNV = parcelRequire("kkzNV");
parcelRequire("1ylIr");
var $cHYPR = parcelRequire("cHYPR");
const $3320e0df19ea44b5$export$2400592c1982dcfe = ({ children: children, isFooterHidden: isFooterHidden })=>/*#__PURE__*/ $bSJIT.createElement((0, $bSA8a.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $OK0aw.default), null, /*#__PURE__*/ $bSJIT.createElement($3320e0df19ea44b5$var$StyledContent, null, /*#__PURE__*/ $bSJIT.createElement("main", null, /*#__PURE__*/ $bSJIT.createElement((0, $3aqSY.MainContentSkipLinkWrapper), null, children)), !isFooterHidden && /*#__PURE__*/ $bSJIT.createElement((0, $kkzNV.StyledFooter), {
        sticky: false
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3320e0df19ea44b5$var$StyledContent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
var $3320e0df19ea44b5$export$2e2bcd8739ae039 = (0, $cHYPR.default)($3320e0df19ea44b5$export$2400592c1982dcfe);

});



parcelRegister("hbZs5", function(module, exports) {
$parcel$export(module.exports, "default", () => $95eaff3e6a421e98$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $95eaff3e6a421e98$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    limitErrorFlagTitle: {
        defaultMessage: "You\u2019ve already featured {limit, plural, one {# portal} other {# portals}}",
        description: 'Title of the error flag shown when the user has already featured the maximum number of portals',
        id: 'cv.portal.reordering.experience.limit.error.title.v2'
    },
    limitErrorFlagDescription: {
        defaultMessage: 'Remove a portal from the featured section to add another one.',
        description: 'Body text of the error flag shown when the user exceeds the featured portals limit',
        id: 'cv.portal.reordering.experience.limit.error.description.v2'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.text'
    },
    portalSectionHeader: {
        defaultMessage: 'Portals',
        description: 'This section divides the topic from the service desk edit section',
        id: 'cv.portal.reordering.experience.service.desk.section.header.text'
    },
    publishTopicsErrorTitle: {
        defaultMessage: "We couldn\u2019t publish your changes",
        description: 'Title of the message shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.title'
    },
    publishTopicsErrorDescription: {
        defaultMessage: 'Refresh the page and try publishing again.',
        description: 'Description of the message shown shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.description'
    },
    portalsHiddenWarningTitle: {
        defaultMessage: 'Portals are hidden from your home page',
        description: 'Warning title when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.title'
    },
    portalsHiddenWarningDescription: {
        defaultMessage: 'The portals section on your home page is hidden. Edit page layout to show portals on the home page.',
        description: 'Warning description when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.description'
    },
    editPageLayoutAction: {
        defaultMessage: 'Edit page layout',
        description: 'Action to show the portals section.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.action'
    }
});

});

parcelRegister("ampBZ", function(module, exports) {
$parcel$export(module.exports, "PortalReorderExperienceLoader", () => (parcelRequire("gsgVJ")).default);

var $gsgVJ = parcelRequire("gsgVJ");

});
parcelRegister("gsgVJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a2a77727b21508b$export$2e2bcd8739ae039);
/* portal-reorder-experience-loader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $i5HDF = parcelRequire("i5HDF");

var $4ZMmh = parcelRequire("4ZMmh");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("3mu7H");
var $lUXOG = parcelRequire("lUXOG");
parcelRequire("4XD15");
var $lKCVq = parcelRequire("lKCVq");
parcelRequire("kL2Y0");
var $1g35F = parcelRequire("1g35F");

var $2Sjfr = parcelRequire("2Sjfr");

var $bOxxr = parcelRequire("bOxxr");
const $9a2a77727b21508b$export$1b7c65f90ce5d7ad = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $2Sjfr.Wrapper), null, /*#__PURE__*/ $bSJIT.createElement((0, $lKCVq.default), {
        isDirty: false,
        openPublishPrompt: (0, $4ZMmh.noop),
        openCancelPrompt: (0, $4ZMmh.noop)
    }), /*#__PURE__*/ $bSJIT.createElement((0, $2Sjfr.ExperienceContainer), null, props.error ? /*#__PURE__*/ $bSJIT.createElement($9a2a77727b21508b$var$LoaderContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($9a2a77727b21508b$var$FeaturedPortalsWrapper, null, /*#__PURE__*/ $bSJIT.createElement("h2", null, props.intl.formatMessage((0, $bOxxr.default).featuredPortalsTitle)), /*#__PURE__*/ $bSJIT.createElement((0, $2Sjfr.CardsContainer), null, Array.from({
        length: 3
    }).map((_, index)=>/*#__PURE__*/ $bSJIT.createElement((0, $lUXOG.default), {
            key: index,
            isFeatured: true
        })))), /*#__PURE__*/ $bSJIT.createElement($9a2a77727b21508b$var$UnFeaturedPortalsWrapper, null, /*#__PURE__*/ $bSJIT.createElement((0, $1g35F.default), {
        isDisabled: true,
        value: "POPULARITY",
        onChange: (0, $4ZMmh.noop)
    }), /*#__PURE__*/ $bSJIT.createElement((0, $2Sjfr.CardsContainer), null, Array.from({
        length: 9
    }).map((_, index)=>/*#__PURE__*/ $bSJIT.createElement((0, $lUXOG.default), {
            key: index,
            isFeatured: true
        })))))));
};
var $9a2a77727b21508b$export$2e2bcd8739ae039 = (0, $fK3tS.default)($9a2a77727b21508b$export$1b7c65f90ce5d7ad);
const $9a2a77727b21508b$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9a2a77727b21508b$var$LoaderContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1tken9zg",
            __cmplp.className
        ])
    });
});
const $9a2a77727b21508b$var$UnFeaturedPortalsWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $9a2a77727b21508b$var$FeaturedPortalsWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_n7zl1dd9 _19pkpxbi _13jwangw _1n46ze3t _1gnpu2gc _7e5b1jfw _1advidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3mu7H", function(module, exports) {
$parcel$export(module.exports, "ProjectCardSkeleton", () => (parcelRequire("lUXOG")).default);

var $lUXOG = parcelRequire("lUXOG");

});
parcelRegister("lUXOG", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd9f798285872e80$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $5VhGP = parcelRequire("5VhGP");

var $9K7mZ = parcelRequire("9K7mZ");

var $7QUb5 = parcelRequire("7QUb5");

var $1qHVa = parcelRequire("1qHVa");

var $2moME = parcelRequire("2moME");
parcelRequire("ePXqZ");
var $1asel = parcelRequire("1asel");
parcelRequire("f1qEb");
var $1PWw8 = parcelRequire("1PWw8");
parcelRequire("lq2QN");
var $1asel = parcelRequire("1asel");
var $lq2QN = parcelRequire("lq2QN");
const $bd9f798285872e80$var$ProjectsCardSkeleton = ({ isBasic: isBasic, isFeatured: isFeatured })=>{
    return /*#__PURE__*/ $bSJIT.createElement($bd9f798285872e80$var$Root, {
        "data-testid": 'project-card-skeleton'
    }, /*#__PURE__*/ $bSJIT.createElement((0, $1asel.Container), {
        hasIcon: true
    }, !isBasic && isFeatured && /*#__PURE__*/ $bSJIT.createElement($bd9f798285872e80$var$ActionsLeft, null, /*#__PURE__*/ $bSJIT.createElement((0, $1PWw8.DragHandlerWrapper), null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7QUb5))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $1asel.IconContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: $9K7mZ.multiple(6).px,
        height: $9K7mZ.multiple(6).px
    })), /*#__PURE__*/ $bSJIT.createElement((0, $1asel.Content), null, /*#__PURE__*/ $bSJIT.createElement($bd9f798285872e80$var$NameWrapper, null, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: $9K7mZ.multiple(11).px,
        height: (0, $lq2QN.titleSkeletonHeight)
    })), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: $9K7mZ.multiple(18).px,
        height: "14px"
    })), !isBasic && /*#__PURE__*/ $bSJIT.createElement($bd9f798285872e80$var$Actions, null, isFeatured ? /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1qHVa))), {
        label: "star-filled-icon",
        size: "medium"
    })) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2moME))), {
        label: "start-icon",
        size: "medium"
    }))));
};
var $bd9f798285872e80$export$2e2bcd8739ae039 = $bd9f798285872e80$var$ProjectsCardSkeleton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bd9f798285872e80$var$Root = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-12n7yik-0"
})`${(0, $1asel.cardStyle)} ${(0, $1PWw8.cardGutterStyle)} border:solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #DFE1E6)"};background-color:${"var(--ds-surface-raised, #FFFFFF)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bd9f798285872e80$var$NameWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-12n7yik-1"
})`margin-bottom:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bd9f798285872e80$var$Actions = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-12n7yik-2"
})`display:flex;flex-direction:column;align-items:center;position:absolute;color:${"var(--ds-skeleton, #F4F5F7)"};top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bd9f798285872e80$var$ActionsLeft = /*#__PURE__*/ (0, $4v2A7.default)($bd9f798285872e80$var$Actions).withConfig({
    componentId: "sc-12n7yik-3"
})`position:initial;width:${$9K7mZ.multiple(5).px};margin-top:-${$9K7mZ.multiple(6).px};`;

});
parcelRegister("7QUb5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8da0453588db1ecd928d81f929e2bf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b78f779240d7001$var$_react = $5b78f779240d7001$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5b78f779240d7001$var$_iconNew = $5b78f779240d7001$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5b78f779240d7001$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/drag-handle-vertical
 * Usage guidance:
 * Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b78f779240d7001$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $5b78f779240d7001$var$_react.default.createElement($5b78f779240d7001$var$_iconNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$5b78f779240d7001$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $5b78f779240d7001$var$_default = module.exports.default = $5b78f779240d7001$var$DragHandleVerticalIcon;

});

parcelRegister("1qHVa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::232da4c32cb25e3c0fe9fd325fd5dbc9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10aa49efa0c8883b$var$_react = $10aa49efa0c8883b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $10aa49efa0c8883b$var$_iconNew = $10aa49efa0c8883b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $10aa49efa0c8883b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-starred
 * Usage guidance:
 * Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10aa49efa0c8883b$var$StarStarredIcon = (props)=>/*#__PURE__*/ $10aa49efa0c8883b$var$_react.default.createElement($10aa49efa0c8883b$var$_iconNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$10aa49efa0c8883b$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $10aa49efa0c8883b$var$_default = module.exports.default = $10aa49efa0c8883b$var$StarStarredIcon;

});

parcelRegister("2moME", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53379c98771562c0fa194d02f1725934>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b80dc5c98246a18$var$_react = $1b80dc5c98246a18$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $1b80dc5c98246a18$var$_iconNew = $1b80dc5c98246a18$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $1b80dc5c98246a18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-unstarred
 * Usage guidance:
 * Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b80dc5c98246a18$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $1b80dc5c98246a18$var$_react.default.createElement($1b80dc5c98246a18$var$_iconNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$1b80dc5c98246a18$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $1b80dc5c98246a18$var$_default = module.exports.default = $1b80dc5c98246a18$var$StarUnstarredIcon;

});

parcelRegister("ePXqZ", function(module, exports) {
$parcel$export(module.exports, "PortalCard", () => (parcelRequire("j7wvB")).default);
$parcel$export(module.exports, "PortalName", () => (parcelRequire("1asel")).PortalName);
$parcel$export(module.exports, "cardStyle", () => (parcelRequire("1asel")).cardStyle);
$parcel$export(module.exports, "PortalCardContainer", () => (parcelRequire("1asel")).Container);

var $j7wvB = parcelRequire("j7wvB");

var $1asel = parcelRequire("1asel");

});
parcelRegister("j7wvB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb167b03d6473889$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $acAb6 = parcelRequire("acAb6");

var $aOiqz = parcelRequire("aOiqz");

var $ki6Qt = parcelRequire("ki6Qt");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $9Yqiu = parcelRequire("9Yqiu");

var $kU5HH = parcelRequire("kU5HH");

var $fKGH0 = parcelRequire("fKGH0");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");
parcelRequire("c3QJe");
var $6f79M = parcelRequire("6f79M");

var $dwOcU = parcelRequire("dwOcU");

var $6WltM = parcelRequire("6WltM");

var $haAAx = parcelRequire("haAAx");

var $iW3CQ = parcelRequire("iW3CQ");

var $gYDJY = parcelRequire("gYDJY");

var $1asel = parcelRequire("1asel");
var $bb167b03d6473889$var$_customPurifyIsomorph;
const $bb167b03d6473889$export$292d791731e624a3 = $fKGH0;
($bb167b03d6473889$var$_customPurifyIsomorph = $bb167b03d6473889$export$292d791731e624a3.addHook) === null || $bb167b03d6473889$var$_customPurifyIsomorph === void 0 || $bb167b03d6473889$var$_customPurifyIsomorph.call($bb167b03d6473889$export$292d791731e624a3, 'afterSanitizeAttributes', (node)=>{
    if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT') node.setAttribute('tabIndex', '-1');
});
const $bb167b03d6473889$var$PortalCard = ({ onClick: onClick, index: index, id: id, portalName: portalName, description: description, portalUrl: portalUrl, iconUrl: iconUrl, openInNewTab: openInNewTab })=>{
    const [isPageInEditMode] = (0, $6f79M.useIsPageInEditMode)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const hasIcon = !!iconUrl;
    const hasPortalUrl = !!portalUrl;
    const hasDescription = !!description;
    const hasOnlyPortalName = !description && !iconUrl;
    const memoizedOnClick = $bSJIT.useCallback(()=>{
        const event = createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'portal'
        });
        event.context.push({
            componentName: 'link',
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        });
        event.fire();
        if (openInNewTab) {
            const { baseUrl: baseUrl } = (0, $iW3CQ.getEnv)();
            (0, $gYDJY.open)(`${baseUrl}${portalUrl}`, '_blank');
        } else push(portalUrl);
        onClick && onClick(index);
    }, [
        createAnalyticsEvent,
        index,
        hasIcon,
        hasPortalUrl,
        hasDescription,
        id,
        push,
        portalUrl,
        onClick,
        openInNewTab
    ]);
    const sanitizedDescription = $bb167b03d6473889$export$292d791731e624a3.sanitize(description || '');
    const content = /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$Container, {
        hasIcon: hasIcon
    }, !!iconUrl && /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$IconContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
        src: iconUrl,
        alt: '',
        draggable: "false"
    })), /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$Content, null, /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$PortalName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: portalName
    }, portalName), !!description && /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$Description, {
        title: description,
        dangerouslySetInnerHTML: {
            __html: sanitizedDescription
        }
    })));
    const portalCardContent = /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$CardRoot, {
        "aria-label": portalName,
        onClick: memoizedOnClick,
        "data-test-id": `portal:${portalName}`,
        role: "link"
    }, content);
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        }
    }, isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement($bb167b03d6473889$var$RootWhenEditingLayout, null, content) : portalCardContent);
};
var $bb167b03d6473889$export$2e2bcd8739ae039 = $bb167b03d6473889$var$PortalCard;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$PortalName = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ob3s3l-0"
})`${$98sDU.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $9K7mZ.multiple(2).unitless;
    return $fU62V.multiLineClamp(lines, lineHeight);
}};${$ki6Qt.fromXSmall.css`
        ${$98sDU.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $9K7mZ.multiple(7.5).px : $9K7mZ.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$Description = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ob3s3l-1"
})`${$98sDU.xsmall};${$fU62V.multiLineClamp(3, $9K7mZ.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$9K7mZ.multiple(2.25).px};${$ki6Qt.fromXSmall.css`
        ${$98sDU.regular};
        line-height: ${$9K7mZ.multiple(2.5).px};
        max-height: ${$9K7mZ.multiple(7.5).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$Content = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ob3s3l-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $bb167b03d6473889$var$CardRoot = /*#__PURE__*/ (0, $4v2A7.default)((0, $aOiqz.InteractiveElement)).withConfig({
    componentId: "sc-ob3s3l-3"
})`${(0, $1asel.cardStyle)} ${$fU62V.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$kU5HH.portalCardLayout};text-decoration:none;}cursor:pointer;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$RootWhenEditingLayout = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ob3s3l-4"
})`${(0, $1asel.cardStyle)} box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$9Yqiu.speedMs.fast}ms ${$9Yqiu.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$kU5HH.portalCardLayout};text-decoration:none;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$IconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ob3s3l-5"
})`${$fU62V.flexCenter};height:${$9K7mZ.multiple(5).px};width:${$9K7mZ.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$ki6Qt.fromXSmall.css`
        height: ${$9K7mZ.multiple(6).px};
        width: ${$9K7mZ.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$largePadding = /*#__PURE__*/ (0, $4v2A7.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$ki6Qt.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$smallPadding = /*#__PURE__*/ (0, $4v2A7.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$ki6Qt.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb167b03d6473889$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ob3s3l-6"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $bb167b03d6473889$var$smallPadding : $bb167b03d6473889$var$largePadding};`;

});
parcelRegister("acAb6", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6d2236e38ff6908$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c6d2236e38ff6908$var$AutoScaledImage = /*#__PURE__*/ (0, $4v2A7.default).img.withConfig({
    componentId: "sc-1gbtcy6-0"
})`height:100%;width:${({ inheritWidth: inheritWidth })=>inheritWidth ? 'inherit' : '100%'};object-fit:${(props)=>props.objectFit || 'contain'};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$c6d2236e38ff6908$export$2e2bcd8739ae039 = $c6d2236e38ff6908$var$AutoScaledImage;

});

parcelRegister("aOiqz", function(module, exports) {
$parcel$export(module.exports, "InteractiveElement", () => $aa586d7851bc40f0$export$c0db965635c41eb6);

var $bSJIT = parcelRequire("bSJIT");
const $aa586d7851bc40f0$export$c0db965635c41eb6 = ({ onClick: onClick, children: children, role: role = 'button', tagName: TagName = 'div', ...props })=>{
    const handleKeyDown = (0, $bSJIT.useCallback)((event)=>{
        // Runs onClick on space and enter key press for accessibility
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(TagName, {
        tabIndex: 0,
        role: role,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        ...props
    }, children);
};
var $aa586d7851bc40f0$export$2e2bcd8739ae039 = $aa586d7851bc40f0$export$c0db965635c41eb6;

});

parcelRegister("c3QJe", function(module, exports) {
$parcel$export(module.exports, "useConfigPanelUI", () => (parcelRequire("6f79M")).useConfigPanelUI);
$parcel$export(module.exports, "useDeletedModulesCount", () => (parcelRequire("6f79M")).useDeletedModulesCount);
$parcel$export(module.exports, "useElementRenderer", () => (parcelRequire("6f79M")).useElementRenderer);
$parcel$export(module.exports, "useIsDirty", () => (parcelRequire("6f79M")).useIsDirty);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => (parcelRequire("6f79M")).useIsPageInBrandingPreviewMode);
$parcel$export(module.exports, "useIsPageInEditMode", () => (parcelRequire("6f79M")).useIsPageInEditMode);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => (parcelRequire("6f79M")).useIsPageInPreviewMode);
$parcel$export(module.exports, "useIsPublishDisabled", () => (parcelRequire("6f79M")).useIsPublishDisabled);
$parcel$export(module.exports, "useIsPublishing", () => (parcelRequire("6f79M")).useIsPublishing);
$parcel$export(module.exports, "useLayoutActions", () => (parcelRequire("6f79M")).useLayoutActions);
$parcel$export(module.exports, "useLayoutConfig", () => (parcelRequire("6f79M")).useLayoutConfig);
$parcel$export(module.exports, "useLayoutIds", () => (parcelRequire("6f79M")).useLayoutIds);
$parcel$export(module.exports, "useMediaConfig", () => (parcelRequire("6f79M")).useMediaConfig);
$parcel$export(module.exports, "useReorderedModulesCount", () => (parcelRequire("6f79M")).useReorderedModulesCount);
$parcel$export(module.exports, "useSectionPicker", () => (parcelRequire("6f79M")).useSectionPicker);
$parcel$export(module.exports, "useSelectedPrimitive", () => (parcelRequire("6f79M")).useSelectedPrimitive);
parcelRequire("6f79M");

});
parcelRegister("6f79M", function(module, exports) {
$parcel$export(module.exports, "LayoutBuilderContainer", () => $dfcec8f070ab8a72$export$b4aab0ffc58aaa5);
$parcel$export(module.exports, "useIsPageInEditMode", () => $dfcec8f070ab8a72$export$7be577f8255e624c);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => $dfcec8f070ab8a72$export$20672b722d2aa4d4);
$parcel$export(module.exports, "useSectionPicker", () => $dfcec8f070ab8a72$export$1672d32e0a0e6fce);
$parcel$export(module.exports, "useSelectedPrimitive", () => $dfcec8f070ab8a72$export$66366b49ee6cbaa2);
$parcel$export(module.exports, "useIsPublishing", () => $dfcec8f070ab8a72$export$b9b3eff0a656013d);
$parcel$export(module.exports, "useIsPublishDisabled", () => $dfcec8f070ab8a72$export$122ac12905cb91a9);
$parcel$export(module.exports, "useIsDirty", () => $dfcec8f070ab8a72$export$9b9cd7e7602f602f);
$parcel$export(module.exports, "useMediaConfig", () => $dfcec8f070ab8a72$export$7f746b47c356effa);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => $dfcec8f070ab8a72$export$dbe8a2a3e19e92cf);
$parcel$export(module.exports, "useLayoutConfig", () => $dfcec8f070ab8a72$export$6bc9f3ef36ce1121);
$parcel$export(module.exports, "useLayoutIds", () => $dfcec8f070ab8a72$export$5fb152f2612e3297);
$parcel$export(module.exports, "useElementRenderer", () => $dfcec8f070ab8a72$export$68c713430d820919);
$parcel$export(module.exports, "useDeletedModulesCount", () => $dfcec8f070ab8a72$export$2056c520eb48ec8b);
$parcel$export(module.exports, "useReorderedModulesCount", () => $dfcec8f070ab8a72$export$4010704f08b334ba);
$parcel$export(module.exports, "useConfigPanelUI", () => $dfcec8f070ab8a72$export$7eebf066d70abd18);
$parcel$export(module.exports, "useLayoutActions", () => $dfcec8f070ab8a72$export$1069bba51f142634);

var $lFpPv = parcelRequire("lFpPv");

var $adFyB = parcelRequire("adFyB");
var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");
var $7IywQ = parcelRequire("7IywQ");

var $iW3CQ = parcelRequire("iW3CQ");

var $j0erP = parcelRequire("j0erP");

var $7H4Ng = parcelRequire("7H4Ng");
if ((0, $iW3CQ.getEnv)().environment !== (0, $iW3CQ.EnvType).PROD) (0, $7IywQ.default).devtools = true;
const $dfcec8f070ab8a72$export$c78554af6dbb181d = ()=>{
    return (0, $lFpPv.isIncreasedFlexibilityEnabled)() ? {
        hideCatalogue: false,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: true,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    } : {
        hideCatalogue: true,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: false,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    };
};
const $dfcec8f070ab8a72$var$emptyLayoutId = {
    sectionId: undefined,
    elementId: undefined
};
const $dfcec8f070ab8a72$export$1cb7963f0d33db7c = {
    HelpLayoutHeroElement: $dfcec8f070ab8a72$var$emptyLayoutId,
    HelpLayoutAnnouncementElement: $dfcec8f070ab8a72$var$emptyLayoutId,
    HelpLayoutTopicsListElement: $dfcec8f070ab8a72$var$emptyLayoutId,
    HelpLayoutPortalsListElement: $dfcec8f070ab8a72$var$emptyLayoutId,
    HelpLayoutSuggestedRequestFormsListElement: $dfcec8f070ab8a72$var$emptyLayoutId,
    HelpLayoutForgeElement: [],
    HelpLayoutConnectElement: []
};
const $dfcec8f070ab8a72$export$d4c72bab9d6cc13a = {
    layoutIds: $dfcec8f070ab8a72$export$1cb7963f0d33db7c,
    isPageInEditMode: false,
    isPageInPreviewMode: false,
    isPageInBrandingPreviewMode: false,
    isPublishing: false,
    isPublishDisabled: true,
    isDirty: false,
    mediaConfig: {},
    deletedModulesCount: 0,
    reorderedModulesCount: 0,
    screenName: undefined,
    experience: undefined,
    traceId: undefined,
    events: {
        selected: undefined,
        hovered: undefined,
        dragged: undefined,
        sectionPickerId: undefined
    },
    configPanel: {
        ui: null
    },
    config: $dfcec8f070ab8a72$export$c78554af6dbb181d()
};
const $dfcec8f070ab8a72$export$6f57813fe9f31bf9 = (0, $7CE69.createStore)({
    initialState: $dfcec8f070ab8a72$export$d4c72bab9d6cc13a,
    actions: $j0erP.actions,
    name: 'LayoutBuilderStore'
});
const $dfcec8f070ab8a72$export$13f23e293cec2ec3 = ()=>({ setState: setState }, { configPanelUI: configPanelUI, editMode: editMode, ElementRenderer: ElementRenderer, screenName: screenName, experience: experience, traceId: traceId, mediaConfig: mediaConfig, pageType: pageType, config: config = {}, events: events = {} })=>{
        setState({
            events: events,
            mediaConfig: mediaConfig,
            ElementRenderer: ElementRenderer,
            screenName: screenName,
            experience: experience,
            traceId: traceId,
            pageType: pageType,
            isPageInEditMode: editMode,
            isPageInPreviewMode: false,
            config: {
                ...$dfcec8f070ab8a72$export$c78554af6dbb181d(),
                ...config
            },
            configPanel: {
                ui: configPanelUI
            }
        });
    };
const $dfcec8f070ab8a72$export$b4aab0ffc58aaa5 = (0, $adFyB.createContainer)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    onInit: $dfcec8f070ab8a72$export$13f23e293cec2ec3,
    displayName: 'LayoutBuilderContainer'
});
const $dfcec8f070ab8a72$export$7be577f8255e624c = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getIsPageInEditMode)
});
const $dfcec8f070ab8a72$export$20672b722d2aa4d4 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getIsPageInPreviewMode)
});
const $dfcec8f070ab8a72$export$1672d32e0a0e6fce = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getSectionPickerId)
});
const $dfcec8f070ab8a72$export$66366b49ee6cbaa2 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getSelectedPrimitive)
});
const $dfcec8f070ab8a72$export$b9b3eff0a656013d = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getIsPublishing)
});
const $dfcec8f070ab8a72$export$122ac12905cb91a9 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getIsPublishDisabled)
});
const $dfcec8f070ab8a72$export$9b9cd7e7602f602f = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getIsDirty)
});
const $dfcec8f070ab8a72$export$7f746b47c356effa = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getMediaConfig)
});
const $dfcec8f070ab8a72$export$dbe8a2a3e19e92cf = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getIsPageInBrandingPreviewMode)
});
const $dfcec8f070ab8a72$export$6bc9f3ef36ce1121 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getLayoutConfig)
});
const $dfcec8f070ab8a72$export$5fb152f2612e3297 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getLayoutIds)
});
const $dfcec8f070ab8a72$export$68c713430d820919 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getElementRenderer)
});
const $dfcec8f070ab8a72$export$2056c520eb48ec8b = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (state)=>state.deletedModulesCount
});
const $dfcec8f070ab8a72$export$4010704f08b334ba = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (state)=>state.reorderedModulesCount
});
const $dfcec8f070ab8a72$export$7eebf066d70abd18 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (0, $7H4Ng.getConfigPanelUI)
});
const $dfcec8f070ab8a72$export$4ca74c2ebe5e7020 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageType
});
const $dfcec8f070ab8a72$export$1069bba51f142634 = (0, $gfNVK.createHook)($dfcec8f070ab8a72$export$6f57813fe9f31bf9);

});
parcelRegister("j0erP", function(module, exports) {
$parcel$export(module.exports, "actions", () => $6415ebaf352bf7d8$export$e324594224ef24da);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("6b1vh");
var $9N4IZ = parcelRequire("9N4IZ");
const $6415ebaf352bf7d8$export$eed4cbff0d0952a0 = ()=>({ getState: getState, setState: setState })=>{
        var _currentState$events$, _currentState$events$2;
        const currentState = getState();
        const pageDataId = (_currentState$events$ = currentState.events.selected) === null || _currentState$events$ === void 0 || (_currentState$events$ = _currentState$events$.path[0]) === null || _currentState$events$ === void 0 ? void 0 : _currentState$events$.dataId;
        setState({
            events: {
                hovered: undefined,
                selected: (0, $lFpPv.isIncreasedFlexibilityEnabled)() && pageDataId ? {
                    dataId: pageDataId,
                    path: ((_currentState$events$2 = currentState.events.selected) === null || _currentState$events$2 === void 0 ? void 0 : _currentState$events$2.path.slice(0, 1)) || []
                } : undefined,
                sectionPickerId: undefined
            },
            configPanel: {
                ui: (0, $lFpPv.isIncreasedFlexibilityEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9N4IZ.ConfigPanelEmptyState), null)
            }
        });
    };
const $6415ebaf352bf7d8$export$2b82c83704d16f1e = (dataId, path)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                selected: {
                    dataId: dataId,
                    path: path
                }
            }
        });
    };
const $6415ebaf352bf7d8$export$63f1a53b56db7e60 = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                hovered: dataId
            }
        });
    };
const $6415ebaf352bf7d8$export$703359b98869d7ca = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                dragged: dataId
            }
        });
    };
const $6415ebaf352bf7d8$export$f03c06073cab57c8 = (sectionId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                hovered: undefined,
                selected: undefined,
                sectionPickerId: sectionId
            }
        });
    };
const $6415ebaf352bf7d8$export$7cc839743e7817e1 = (isPublishing)=>({ setState: setState })=>{
        setState({
            isPublishing: isPublishing
        });
    };
const $6415ebaf352bf7d8$export$e1757f155540af7b = (isPublishDisabled)=>({ setState: setState })=>{
        setState({
            isPublishDisabled: isPublishDisabled
        });
    };
const $6415ebaf352bf7d8$export$12e1d22d39b53fc8 = (isDirty)=>({ setState: setState })=>{
        setState({
            isDirty: isDirty
        });
    };
const $6415ebaf352bf7d8$export$8170ce9a15707844 = (isPageInBrandingPreviewMode)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
        });
    };
const $6415ebaf352bf7d8$export$6c5886565b08070e = (sectionId, elementId, typename)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (typename === 'HelpLayoutForgeElement' || typename === 'HelpLayoutConnectElement') {
            const updatedLayoutIds = {
                ...currentState.layoutIds
            };
            updatedLayoutIds[typename] = [
                ...updatedLayoutIds[typename] || [],
                {
                    sectionId: sectionId,
                    elementId: elementId
                }
            ];
            setState({
                ...currentState,
                layoutIds: updatedLayoutIds
            });
            return;
        }
        setState({
            ...currentState,
            layoutIds: {
                ...currentState.layoutIds,
                [typename]: {
                    sectionId: sectionId,
                    elementId: elementId
                }
            }
        });
    };
const $6415ebaf352bf7d8$export$18ae1b41966470b5 = ()=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentPreviewMode = currentState.isPageInPreviewMode;
        setState({
            ...currentState,
            isPageInPreviewMode: !currentPreviewMode
        });
    };
const $6415ebaf352bf7d8$export$59e3de019265ab87 = (deletedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            deletedModulesCount: deletedModulesCount
        });
    };
const $6415ebaf352bf7d8$export$dd986587ada0d176 = (ui)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            configPanel: {
                ui: ui
            }
        });
    };
const $6415ebaf352bf7d8$export$de05f3d90acd4969 = (reorderedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            reorderedModulesCount: reorderedModulesCount
        });
    };
const $6415ebaf352bf7d8$export$20a1a9b113e6ba3a = (mediaConfig)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            mediaConfig: mediaConfig
        });
    };
const $6415ebaf352bf7d8$export$e324594224ef24da = {
    markPageSelected: $6415ebaf352bf7d8$export$eed4cbff0d0952a0,
    markSelected: $6415ebaf352bf7d8$export$2b82c83704d16f1e,
    markHovered: $6415ebaf352bf7d8$export$63f1a53b56db7e60,
    markDragged: $6415ebaf352bf7d8$export$703359b98869d7ca,
    markSectionDialogOpen: $6415ebaf352bf7d8$export$f03c06073cab57c8,
    markIsPublishing: $6415ebaf352bf7d8$export$7cc839743e7817e1,
    markIsPublishDisabled: $6415ebaf352bf7d8$export$e1757f155540af7b,
    markIsDirty: $6415ebaf352bf7d8$export$12e1d22d39b53fc8,
    markBrandingPreviewMode: $6415ebaf352bf7d8$export$8170ce9a15707844,
    setLayoutId: $6415ebaf352bf7d8$export$6c5886565b08070e,
    togglePreviewMode: $6415ebaf352bf7d8$export$18ae1b41966470b5,
    setDeletedModulesCount: $6415ebaf352bf7d8$export$59e3de019265ab87,
    setReorderedModulesCount: $6415ebaf352bf7d8$export$de05f3d90acd4969,
    setMediaConfig: $6415ebaf352bf7d8$export$20a1a9b113e6ba3a,
    setConfigPanelUI: $6415ebaf352bf7d8$export$dd986587ada0d176
};

});
parcelRegister("6b1vh", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => (parcelRequire("9N4IZ")).ConfigPanelEmptyState);

var $9N4IZ = parcelRequire("9N4IZ");

});
parcelRegister("9N4IZ", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => $dcc9d43747070633$export$2fdc624ef67f147b);

var $bSJIT = parcelRequire("bSJIT");

var $aadXp = parcelRequire("aadXp");

var $4vLTk = parcelRequire("4vLTk");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $4WBX1 = parcelRequire("4WBX1");
const $dcc9d43747070633$export$2fdc624ef67f147b = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "medium",
        as: "h3"
    }, formatMessage((0, $4WBX1.default).emptyConfigPanelHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $dcc9d43747070633$var$emptyConfigPanelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aadXp))),
        alt: formatMessage((0, $4WBX1.default).emptyConfigPanelImageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        align: "center",
        as: "p"
    }, formatMessage((0, $4WBX1.default).emptyConfigPanelText, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
    }))));
};
const $dcc9d43747070633$var$emptyConfigPanelStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 'space.400',
    gap: 'space.200'
});

});
parcelRegister("aadXp", function(module, exports) {
module.exports = new URL("../images/config-panel-default.4e21e8e2.svg", import.meta.url).toString();

});

parcelRegister("4WBX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $d69b740ef69786f6$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $d69b740ef69786f6$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    emptyConfigPanelHeading: {
        defaultMessage: 'Edit page layout',
        description: 'Heading to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.heading'
    },
    emptyConfigPanelText: {
        defaultMessage: 'Pages are made of horizontal blocks called <b>sections</b> to which you can add <b>rich content.</b> Select an existing section or add a new one to get started.',
        description: 'Text to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.text'
    },
    emptyConfigPanelImageAltText: {
        defaultMessage: 'The config panel is empty',
        description: 'Alt text for image to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.image.alt'
    }
});

});




parcelRegister("7H4Ng", function(module, exports) {
$parcel$export(module.exports, "getIsPageInEditMode", () => $00c6fbd46c0cc5a1$export$31efc24b85422f28);
$parcel$export(module.exports, "getIsPageInPreviewMode", () => $00c6fbd46c0cc5a1$export$b16c6dd5c9190b1a);
$parcel$export(module.exports, "getSectionPickerId", () => $00c6fbd46c0cc5a1$export$c00ca6bc45704b1a);
$parcel$export(module.exports, "getSelectedPrimitive", () => $00c6fbd46c0cc5a1$export$12c45f99974b2f6);
$parcel$export(module.exports, "getIsPublishing", () => $00c6fbd46c0cc5a1$export$114b0b1eb879caeb);
$parcel$export(module.exports, "getIsPublishDisabled", () => $00c6fbd46c0cc5a1$export$8626e45ed1d507a4);
$parcel$export(module.exports, "getIsDirty", () => $00c6fbd46c0cc5a1$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getMediaConfig", () => $00c6fbd46c0cc5a1$export$e0c7d660f7459c46);
$parcel$export(module.exports, "getIsPageInBrandingPreviewMode", () => $00c6fbd46c0cc5a1$export$5f742d52a7bee27e);
$parcel$export(module.exports, "getLayoutConfig", () => $00c6fbd46c0cc5a1$export$61bd5e607ff26d43);
$parcel$export(module.exports, "getLayoutIds", () => $00c6fbd46c0cc5a1$export$c3b66d8cabe26730);
$parcel$export(module.exports, "getElementRenderer", () => $00c6fbd46c0cc5a1$export$21591c7e677a0342);
$parcel$export(module.exports, "getConfigPanelUI", () => $00c6fbd46c0cc5a1$export$eab87a6b2cabf1fe);
const $00c6fbd46c0cc5a1$export$31efc24b85422f28 = (state)=>state.isPageInEditMode;
const $00c6fbd46c0cc5a1$export$b16c6dd5c9190b1a = (state)=>state.isPageInPreviewMode;
const $00c6fbd46c0cc5a1$export$c00ca6bc45704b1a = (state)=>state.events.sectionPickerId;
const $00c6fbd46c0cc5a1$export$12c45f99974b2f6 = (state)=>state.events.selected;
const $00c6fbd46c0cc5a1$export$114b0b1eb879caeb = (state)=>state.isPublishing;
const $00c6fbd46c0cc5a1$export$8626e45ed1d507a4 = (state)=>state.isPublishDisabled;
const $00c6fbd46c0cc5a1$export$4b1964ee9ad6f220 = (state)=>state.isDirty;
const $00c6fbd46c0cc5a1$export$e0c7d660f7459c46 = (state)=>state.mediaConfig;
const $00c6fbd46c0cc5a1$export$5f742d52a7bee27e = (state)=>state.isPageInBrandingPreviewMode;
const $00c6fbd46c0cc5a1$export$61bd5e607ff26d43 = (state)=>state.config;
const $00c6fbd46c0cc5a1$export$c3b66d8cabe26730 = (state)=>state.layoutIds;
const $00c6fbd46c0cc5a1$export$21591c7e677a0342 = (state)=>state.ElementRenderer;
const $00c6fbd46c0cc5a1$export$eab87a6b2cabf1fe = (state)=>state.configPanel.ui;

});



parcelRegister("1asel", function(module, exports) {
$parcel$export(module.exports, "PortalName", () => $e4fc0ee4290fceba$export$388673bc95b650ac);
$parcel$export(module.exports, "Description", () => $e4fc0ee4290fceba$export$393edc798c47379d);
$parcel$export(module.exports, "Content", () => $e4fc0ee4290fceba$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "cardStyle", () => $e4fc0ee4290fceba$export$20fbd02c8b16da77);
$parcel$export(module.exports, "IconContainer", () => $e4fc0ee4290fceba$export$8f314e512d92575f);
$parcel$export(module.exports, "Container", () => $e4fc0ee4290fceba$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $ki6Qt = parcelRequire("ki6Qt");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $kU5HH = parcelRequire("kU5HH");

var $87QgR = parcelRequire("87QgR");
const $e4fc0ee4290fceba$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $e4fc0ee4290fceba$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($e4fc0ee4290fceba$var$HC_ADS_DROP_COMMIT_2);
const $e4fc0ee4290fceba$export$388673bc95b650ac = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ics84-0"
})`${$98sDU.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $9K7mZ.multiple(2).unitless;
    return $fU62V.multiLineClamp(lines, lineHeight);
}};${$ki6Qt.fromXSmall.css`
        ${$98sDU.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $9K7mZ.multiple(7.5).px : $9K7mZ.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
const $e4fc0ee4290fceba$export$393edc798c47379d = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ics84-1"
})`${$98sDU.xsmall};${$fU62V.multiLineClamp(3, $9K7mZ.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$9K7mZ.multiple(2.25).px};${$ki6Qt.fromXSmall.css`
        ${$98sDU.regular};
        line-height: ${$9K7mZ.multiple(2.5).px};
        max-height: ${$9K7mZ.multiple(7.5).px};
    `};`;
const $e4fc0ee4290fceba$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ics84-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
const $e4fc0ee4290fceba$export$20fbd02c8b16da77 = /*#__PURE__*/ (0, $4v2A7.css)`${$fU62V.borderRadius};${()=>// hc_ads_drop_commit_2: ADS drop 2 bumps card radius to radius.large.
    // Overrides mixins.borderRadius above via source order; TODO remove with the flag.
    $e4fc0ee4290fceba$var$isHcAdsDropCommit2Enabled() && `border-radius: ${"var(--ds-radius-large, 8px)"};`} ${$fU62V.focusRing.default};box-sizing:border-box;display:block;position:relative;height:${$9K7mZ.multiple(14).px};width:${$9K7mZ.multiple(33).px};z-index:${$kU5HH.portalCardLayout};${$ki6Qt.fromXSmall.css`
    height: ${$9K7mZ.multiple(18).px};
    width: ${$9K7mZ.multiple(42).px};
`};`;
const $e4fc0ee4290fceba$export$8f314e512d92575f = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ics84-3"
})`${$fU62V.flexCenter};height:${$9K7mZ.multiple(5).px};width:${$9K7mZ.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$ki6Qt.fromXSmall.css`
        height: ${$9K7mZ.multiple(6).px};
        width: ${$9K7mZ.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e4fc0ee4290fceba$var$largePadding = /*#__PURE__*/ (0, $4v2A7.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$ki6Qt.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e4fc0ee4290fceba$var$smallPadding = /*#__PURE__*/ (0, $4v2A7.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$ki6Qt.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
const $e4fc0ee4290fceba$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-3ics84-4"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $e4fc0ee4290fceba$var$smallPadding : $e4fc0ee4290fceba$var$largePadding};`;

});



parcelRegister("f1qEb", function(module, exports) {
$parcel$export(module.exports, "ProjectCard", () => (parcelRequire("bVZAb")).default);
$parcel$export(module.exports, "Overlay", () => (parcelRequire("1PWw8")).Overlay);
$parcel$export(module.exports, "DragHandlerWrapper", () => (parcelRequire("1PWw8")).DragHandlerWrapper);
$parcel$export(module.exports, "cardGutterStyle", () => (parcelRequire("1PWw8")).cardGutterStyle);
$parcel$export(module.exports, "Root", () => (parcelRequire("1PWw8")).Root);
$parcel$export(module.exports, "Wrapper", () => (parcelRequire("1PWw8")).Wrapper);

var $bVZAb = parcelRequire("bVZAb");

var $1PWw8 = parcelRequire("1PWw8");

});
parcelRegister("bVZAb", function(module, exports) {
$parcel$export(module.exports, "default", () => $542c1e812bcb6d5c$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("80y9N");
var $ks6At = parcelRequire("ks6At");

var $1PWw8 = parcelRequire("1PWw8");
const $542c1e812bcb6d5c$var$mapStateToProps = (state)=>{
    return {
        isPortalHidingEnabled: (0, $ks6At.getIsPortalHidingEnabled)(state)
    };
};
var $542c1e812bcb6d5c$export$2e2bcd8739ae039 = (0, $f2mlD.default)($542c1e812bcb6d5c$var$mapStateToProps)((0, $1PWw8.default));

});
parcelRegister("1PWw8", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $355fe1d80528778f$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Root", () => $355fe1d80528778f$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "DragHandlerWrapper", () => $355fe1d80528778f$export$5761cab24db81fb9);
$parcel$export(module.exports, "ScreenReaderInstruction", () => $355fe1d80528778f$export$a5ddd0c37fc6764f);
$parcel$export(module.exports, "default", () => $355fe1d80528778f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cardGutterStyle", () => $355fe1d80528778f$export$c83f43d52281dc9d);
$parcel$export(module.exports, "Overlay", () => $355fe1d80528778f$export$c6fdb837b070b4ff);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $acAb6 = parcelRequire("acAb6");

var $ki6Qt = parcelRequire("ki6Qt");

var $7QbH4 = parcelRequire("7QbH4");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $kU5HH = parcelRequire("kU5HH");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("ahNnB");
var $ldb2o = parcelRequire("ldb2o");

var $7QUb5 = parcelRequire("7QUb5");

var $8iYAq = parcelRequire("8iYAq");

var $f5ZrX = parcelRequire("f5ZrX");

var $1qHVa = parcelRequire("1qHVa");

var $2moME = parcelRequire("2moME");
parcelRequire("ePXqZ");
var $1asel = parcelRequire("1asel");

var $1asel = parcelRequire("1asel");

var $jsspk = parcelRequire("jsspk");
const $355fe1d80528778f$export$bacf8f04493bf68c = ({ id: id, name: name, description: description, iconUrl: iconUrl, isFeatured: isFeatured, isDropped: isDropped, className: className, intl: intl, hiddenFromHomeScreen: hiddenFromHomeScreen, hideActionButtons: hideActionButtons, isPortalHidingEnabled: isPortalHidingEnabled, onToggleFeatured: onToggleFeatured, onToggleVisibility: onToggleVisibility })=>{
    const hasIcon = !!iconUrl;
    const hasOnlyPortalName = !description && !iconUrl;
    const onFeaturedStarClick = $bSJIT.useCallback(()=>{
        onToggleFeatured && onToggleFeatured(id, !isFeatured);
    }, [
        id,
        isFeatured,
        onToggleFeatured
    ]);
    const onVisibilityIconClick = $bSJIT.useCallback(()=>{
        onToggleVisibility && onToggleVisibility(id, !hiddenFromHomeScreen);
    }, [
        id,
        hiddenFromHomeScreen,
        onToggleVisibility
    ]);
    const rootProps = isFeatured ? {
        isDropped: isDropped,
        isFeatured: true
    } : {
        isFeatured: false
    };
    const featuredProjectToolTip = intl.formatMessage((0, $jsspk.default).featuredProjectTooltip);
    const unFeaturedProjectToolTip = intl.formatMessage((0, $jsspk.default).unFeaturedProjectTooltip);
    const visibleProjectTooltip = intl.formatMessage((0, $jsspk.default).visibleProjectTooltip);
    const hiddenProjectTooltip = intl.formatMessage((0, $jsspk.default).hiddenProjectTooltip);
    const featureToolTip = {
        highlightedMessage: featuredProjectToolTip,
        unHighlightedMessage: unFeaturedProjectToolTip
    };
    const featureAriaLabel = {
        highlightedLabel: featuredProjectToolTip,
        unHighlightedLabel: unFeaturedProjectToolTip
    };
    const visibilityToolTip = {
        highlightedMessage: visibleProjectTooltip,
        unHighlightedMessage: hiddenProjectTooltip
    };
    const visibilityAriaLabel = {
        highlightedLabel: visibleProjectTooltip,
        unHighlightedLabel: hiddenProjectTooltip
    };
    const ariaAttributes = isFeatured ? {
        tabIndex: 0,
        role: 'button',
        'aria-labelledby': `project-card-content-${id}`,
        'aria-roledescription': 'Draggable item',
        'aria-describedby': 'featured-portals-screen-reader-description'
    } : {};
    return /*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$export$e6dfd72ab29f8598, {
        "data-test-id": isFeatured ? `featured-card-${id}` : null,
        "data-testid": isFeatured ? `featured-card-${id}` : 'unfeatured-card',
        ...className ? {
            className: className
        } : {},
        ...ariaAttributes
    }, /*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$export$be92b6f5f03c0fe9, rootProps, /*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$var$Container, {
        hasIcon: hasIcon,
        isDraggable: isFeatured
    }, isFeatured && /*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$export$5761cab24db81fb9, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7QUb5))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    })), hasIcon && /*#__PURE__*/ $bSJIT.createElement((0, $1asel.IconContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
        src: iconUrl,
        alt: "icon"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $1asel.Content), {
        id: `project-card-content-${id}`
    }, /*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$var$ProjectName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: name
    }, name), !!description && /*#__PURE__*/ $bSJIT.createElement((0, $1asel.Description), {
        title: description,
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), !hideActionButtons && /*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$var$Actions, null, isPortalHidingEnabled && (!isFeatured || hiddenFromHomeScreen) && /*#__PURE__*/ $bSJIT.createElement((0, $ldb2o.default), {
        isHighlighted: !hiddenFromHomeScreen,
        highlightHandler: onVisibilityIconClick,
        toolTip: visibilityToolTip,
        ariaLabel: visibilityAriaLabel,
        actionSubjectId: hiddenFromHomeScreen ? 'hiddenCard' : 'visibleCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f5ZrX))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8iYAq)))
        }
    }), (!isPortalHidingEnabled || !hiddenFromHomeScreen) && /*#__PURE__*/ $bSJIT.createElement((0, $ldb2o.default), {
        isHighlighted: isFeatured,
        highlightHandler: onFeaturedStarClick,
        toolTip: featureToolTip,
        ariaLabel: featureAriaLabel,
        actionSubjectId: isFeatured ? 'featuredCard' : 'unFeaturedCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1qHVa))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2moME)))
        },
        color: {
            highlightedColor: "var(--ds-background-accent-yellow-subtler, #FFC400)"
        }
    })))));
};
const $355fe1d80528778f$export$a5ddd0c37fc6764f = ({ intl: intl })=>/*#__PURE__*/ $bSJIT.createElement($355fe1d80528778f$var$SortableCardDescription, {
        id: "featured-portals-screen-reader-description"
    }, intl.formatMessage((0, $jsspk.default).screenReaderInstructionsForReordering));
var $355fe1d80528778f$export$2e2bcd8739ae039 = /*#__PURE__*/ $bSJIT.memo((0, $fK3tS.default)($355fe1d80528778f$export$bacf8f04493bf68c));
const $355fe1d80528778f$export$c83f43d52281dc9d = /*#__PURE__*/ (0, $4v2A7.css)`margin:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"};${$ki6Qt.fromLarge.css`
margin: ${"var(--ds-space-200, 16px)"} ${$9K7mZ.multiple(4.75).px};
`}`;
const $355fe1d80528778f$var$rootBackgroundColor = (props)=>props.isDropped ? "var(--ds-surface-raised-pressed, #DEEBFF)" : "var(--ds-surface-raised, #FFFFFF)";
const $355fe1d80528778f$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1tkctfp-0"
})`${(0, $1asel.cardStyle)} ${(props)=>props.isFeatured ? $fU62V.raiseUpOnHoverOrFocus((0, $7QbH4.newElevationsFromDesignSystems).e100, (0, $7QbH4.newElevationsFromDesignSystems).e200) : (0, $7QbH4.newElevationsFromDesignSystems).e100};${(props)=>$fU62V.applyIf(!Boolean(props.isFeatured), 'z-index: 0;')} background-color:${$355fe1d80528778f$var$rootBackgroundColor};user-select:none;${(props)=>props.isFeatured && !props.isDropped && (0, $4v2A7.css)({
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #F4F5F7)"
        }
    })};&:hover,&:focus{z-index:${$kU5HH.portalCardLayout};text-decoration:none;}&::after{cursor:${(props)=>{
    return props.isFeatured ? 'grab' : 'auto';
}};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $355fe1d80528778f$var$Actions = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1tkctfp-1"
})`display:flex;flex-direction:row;align-items:center;position:absolute;top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $355fe1d80528778f$var$Container = /*#__PURE__*/ (0, $4v2A7.default)((0, $1asel.Container)).withConfig({
    componentId: "sc-1tkctfp-2"
})`padding-right:${$9K7mZ.multiple(5.5).px};${({ isDraggable: isDraggable })=>isDraggable ? `padding-left: ${"var(--ds-space-500, 40px)"}` : ''};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $355fe1d80528778f$var$ProjectName = /*#__PURE__*/ (0, $4v2A7.default)((0, $1asel.PortalName)).withConfig({
    componentId: "sc-1tkctfp-3"
})`color:${"var(--ds-text, #172B4D)"};`;
const $355fe1d80528778f$var$boxShadow = `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} rgba(0, 0, 0, 0.15)`;
const $355fe1d80528778f$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-1tkctfp-4"
})`${$355fe1d80528778f$export$c83f43d52281dc9d} touch-action:none;list-style:none;&:focus{${$fU62V.focusRing.default};& ${$355fe1d80528778f$export$be92b6f5f03c0fe9}{&:hover{transform:translate3d(0,0,0);}}}&.sortable-helper{cursor:grabbing !important;pointer-events:auto !important;list-style:none;${$355fe1d80528778f$export$be92b6f5f03c0fe9}{background-color:${$355fe1d80528778f$var$rootBackgroundColor};&::after{cursor:grabbing;}&:hover{cursor:grabbing;background-color:${"var(--ds-surface-raised, #FFFFFF)"};}box-shadow:${`var(--ds-shadow-overlay, ${$355fe1d80528778f$var$boxShadow})`};}}`;
const $355fe1d80528778f$export$5761cab24db81fb9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1tkctfp-5"
})`left:${"var(--ds-space-050, 4px)"};position:absolute;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $355fe1d80528778f$var$SortableCardDescription = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1tkctfp-6"
})`display:none;`;
const $355fe1d80528778f$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1tkctfp-7"
})`${(0, $1asel.cardStyle)} ${$355fe1d80528778f$export$c83f43d52281dc9d} background-color:${(props)=>props.show ? "var(--ds-background-selected-hovered, #B3D4FF)" : "var(--ds-surface-raised, transparent)"};opacity:0.3;transition:all 0.2s;`;

});
parcelRegister("ahNnB", function(module, exports) {
$parcel$export(module.exports, "Highlighter", () => (parcelRequire("ldb2o")).default);

var $ldb2o = parcelRequire("ldb2o");

});
parcelRegister("ldb2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbd990a084315e22$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $97yQ5 = parcelRequire("97yQ5");

var $kU5HH = parcelRequire("kU5HH");

var $lavtv = parcelRequire("lavtv");
const $bbd990a084315e22$export$7cc17c9bd3240823 = ({ isHighlighted: isHighlighted, highlightHandler: highlightHandler, toolTip: toolTip, ariaLabel: ariaLabel, actionSubjectId: actionSubjectId, icon: icon, color: color })=>{
    const toolTipMessage = isHighlighted ? toolTip.highlightedMessage : toolTip.unHighlightedMessage;
    const ariaLabelContent = isHighlighted ? ariaLabel.highlightedLabel : ariaLabel.unHighlightedLabel;
    const { HighlightedIcon: HighlightedIcon, UnHighlightedIcon: UnHighlightedIcon } = icon;
    return /*#__PURE__*/ $bSJIT.createElement($bbd990a084315e22$var$HighlighterButtonContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $lavtv.default), {
        content: toolTipMessage,
        position: "top",
        "aria-hidden": "true",
        hasNewContentOnTriggerClick: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), {
        type: "button",
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "project-card-action-button",
        onClick: highlightHandler,
        actionSubjectId: actionSubjectId,
        iconBefore: isHighlighted ? /*#__PURE__*/ $bSJIT.createElement(HighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.highlightedColor,
            size: "medium"
        }) : /*#__PURE__*/ $bSJIT.createElement(UnHighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.unHighlightedColor,
            size: "medium"
        })
    })));
};
var $bbd990a084315e22$export$2e2bcd8739ae039 = /*#__PURE__*/ $bSJIT.memo($bbd990a084315e22$export$7cc17c9bd3240823);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bbd990a084315e22$var$HighlighterButtonContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1h5r30-0"
})`background:transparent;border:0;cursor:pointer;z-index:${(0, $kU5HH.layer)};`;

});


parcelRegister("f5ZrX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad6bc939fa088c881fa9ff72e2efb30f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afd6fd56f776012c$var$_react = $afd6fd56f776012c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $afd6fd56f776012c$var$_iconNew = $afd6fd56f776012c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $afd6fd56f776012c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open-filled
 * Usage guidance:
 * Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afd6fd56f776012c$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $afd6fd56f776012c$var$_react.default.createElement($afd6fd56f776012c$var$_iconNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$afd6fd56f776012c$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $afd6fd56f776012c$var$_default = module.exports.default = $afd6fd56f776012c$var$EyeOpenFilledIcon;

});

parcelRegister("jsspk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a434097fbdcd8076$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a434097fbdcd8076$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    featuredProjectTooltip: {
        defaultMessage: 'Remove from featured section',
        description: 'Tootip message when hovered on remove from featured button',
        id: 'cv.portal.reordering.experience.featured.card.tooltip'
    },
    unFeaturedProjectTooltip: {
        defaultMessage: 'Feature this portal',
        description: 'Tootip message when hovered on feature portal button',
        id: 'cv.portal.reordering.experience.unfeatured.card.tooltip'
    },
    visibleProjectTooltip: {
        defaultMessage: 'Hide from home page',
        description: 'Tootip message when hovered on hide button',
        id: 'cv.portal.reordering.experience.shown.card.tooltip.non-final'
    },
    hiddenProjectTooltip: {
        defaultMessage: 'Show on home page',
        description: 'Tootip message when hovered on show project button',
        id: 'cv.portal.reordering.experience.hidden.card.tooltip.non-final'
    },
    screenReaderInstructionsForReordering: {
        defaultMessage: 'Press space to pick up a portal. Use the up and down arrow keys to move it to a new position. Press space or enter to drop it in a new position, or press escape to cancel',
        description: 'message to be readout by screen reader when a project card is focused',
        id: 'cv.portal.reordering.experience.screen.reader.instruction'
    }
});

});




parcelRegister("lq2QN", function(module, exports) {
$parcel$export(module.exports, "titleSkeletonHeight", () => $26cea654cbd0124e$export$627219b6093d39c1);
$parcel$export(module.exports, "IconContainer", () => (parcelRequire("1asel")).IconContainer);
$parcel$export(module.exports, "Content", () => (parcelRequire("1asel")).Content);
$parcel$export(module.exports, "Container", () => (parcelRequire("1asel")).Container);

var $1asel = parcelRequire("1asel");
const $26cea654cbd0124e$export$627219b6093d39c1 = '21px';

});



parcelRegister("4XD15", function(module, exports) {
$parcel$export(module.exports, "ActionBarWithButtonsStateless", () => (parcelRequire("lKCVq")).default);

var $lKCVq = parcelRequire("lKCVq");

});
parcelRegister("lKCVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $971dc15f9fc6055b$export$2e2bcd8739ae039);
/* action-bar-with-buttons-stateless.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $97yQ5 = parcelRequire("97yQ5");

var $9K7mZ = parcelRequire("9K7mZ");

var $fK3tS = parcelRequire("fK3tS");

var $f1bHg = parcelRequire("f1bHg");

var $7WQx2 = parcelRequire("7WQx2");

var $9cAYa = parcelRequire("9cAYa");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $jOSgo = parcelRequire("jOSgo");
const $971dc15f9fc6055b$export$f749d3fa2628ac53 = ({ intl: intl, isDirty: isDirty, openCancelPrompt: openCancelPrompt, openPublishPrompt: openPublishPrompt })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $9cAYa.default), {
        name: "portal-reordering-action-buttons"
    }, /*#__PURE__*/ $bSJIT.createElement($971dc15f9fc6055b$var$ButtonContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $f1bHg.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "portal-reordering-cancel-button",
        onClick: openCancelPrompt,
        actionSubjectId: "cancelPortalsReorder",
        "data-test-id": "cancel-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $jOSgo.default).cancelButtonLabel)), /*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), {
        appearance: "primary",
        isDisabled: !isDirty,
        onClick: openPublishPrompt,
        actionSubjectId: "publishPortalsReorder",
        "data-test-id": "publish-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $jOSgo.default).publishButtonLabel)))));
};
class $971dc15f9fc6055b$export$ec006b65f267cb6c extends $bSJIT.Component {
    renderHeading() {
        const { intl: intl } = this.props;
        if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType)) return intl.formatMessage((0, $jOSgo.default).actionBarTitleCSM);
        return intl.formatMessage((0, $jOSgo.default).actionBarTitleNew);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement($971dc15f9fc6055b$var$Wrapper, null, /*#__PURE__*/ $bSJIT.createElement($971dc15f9fc6055b$var$PageHeaderWrapper, null, /*#__PURE__*/ $bSJIT.createElement($971dc15f9fc6055b$var$PageHeader, null, /*#__PURE__*/ $bSJIT.createElement($971dc15f9fc6055b$var$Title, null, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
            size: "medium",
            as: "div"
        }, this.renderHeading())), /*#__PURE__*/ $bSJIT.createElement($971dc15f9fc6055b$export$f749d3fa2628ac53, this.props)), children));
    }
}
var $971dc15f9fc6055b$export$2e2bcd8739ae039 = (0, $fK3tS.default)($971dc15f9fc6055b$export$ec006b65f267cb6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $971dc15f9fc6055b$var$Wrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_16qs1viy _1pby16oo _154iidpf _1ltvidpf _1bsb1osq _kqsw1n9t _bfhk1bhr _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $971dc15f9fc6055b$var$PageHeaderWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1jphezo": (0, $3zY6O.default)($9K7mZ.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt4zdiv _1bsb1osq _1bah1h6o _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $971dc15f9fc6055b$var$ButtonContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b2vlsk": (0, $3zY6O.default)($9K7mZ.multiple(96).px)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt41b66 _p12feuys",
            __cmplp.className
        ])
    });
});
const $971dc15f9fc6055b$var$Title = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pkidpf _otyrpxbi _19zoidpf",
            __cmplp.className
        ])
    });
});
const $971dc15f9fc6055b$var$PageHeader = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_18s8r2fv _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1yb4 _tyxhvrvc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f1bHg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $24e1adcfdfa05ce5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");
function $24e1adcfdfa05ce5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $24e1adcfdfa05ce5$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $24e1adcfdfa05ce5$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $24e1adcfdfa05ce5$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("jOSgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed457ad370900ec1$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ed457ad370900ec1$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    actionBarTitle: {
        defaultMessage: 'Edit home page layout',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title'
    },
    actionBarTitleNew: {
        defaultMessage: 'Manage topics and portals',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title.topics.portals'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    actionBarTitleCSM: {
        defaultMessage: 'Manage topics',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title-csm.topics.portals'
    },
    cancelButtonLabel: {
        defaultMessage: 'Cancel',
        description: 'Label of cancel button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.cancel'
    },
    publishButtonLabel: {
        defaultMessage: 'Publish layout',
        description: 'Label of publish button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.publish'
    }
});

});



parcelRegister("kL2Y0", function(module, exports) {
$parcel$export(module.exports, "SortByFilter", () => (parcelRequire("1g35F")).default);

var $1g35F = parcelRequire("1g35F");

});
parcelRegister("1g35F", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ddac0a7ebe8223a$export$2e2bcd8739ae039);
/* sort-by-filter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $cf0fX = parcelRequire("cf0fX");

var $9K7mZ = parcelRequire("9K7mZ");

var $fK3tS = parcelRequire("fK3tS");

var $7WQx2 = parcelRequire("7WQx2");

var $9cAYa = parcelRequire("9cAYa");

var $3kUNZ = parcelRequire("3kUNZ");
const $3ddac0a7ebe8223a$var$selectCustomStyle = {
    container: (provided)=>({
            ...provided,
            marginLeft: "var(--ds-space-200, 16px)",
            width: $9K7mZ.multiple(18).px
        })
};
const $3ddac0a7ebe8223a$export$38d77f5667d0a049 = ({ intl: intl, isDisabled: isDisabled, value: value, shouldHideLabel: shouldHideLabel, onChange: onChange })=>{
    const sortBySelectOptions = {
        ALPHABETICALLY: intl.formatMessage((0, $3kUNZ.default).alphabeticOption),
        POPULARITY: intl.formatMessage((0, $3kUNZ.default).popularityOption)
    };
    const options = Object.entries(sortBySelectOptions).map(([key, label])=>({
            label: label,
            value: key
        }));
    const sortByChange = $bSJIT.useCallback((option)=>{
        if (option && option.value !== value) onChange(option.value);
    }, [
        onChange,
        value
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $9cAYa.default), {
        name: "sort-by-filter"
    }, /*#__PURE__*/ $bSJIT.createElement($3ddac0a7ebe8223a$var$FilterWrapper, null, /*#__PURE__*/ $bSJIT.createElement($3ddac0a7ebe8223a$var$FilterContent, null, !shouldHideLabel && /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ $bSJIT.createElement("label", {
        htmlFor: "sort-by-filter"
    }, intl.formatMessage((0, $3kUNZ.default).sortByFilterLabel))), /*#__PURE__*/ $bSJIT.createElement((0, $cf0fX.Select), {
        classNamePrefix: "portal-reorder-experience-sort-by-filter",
        actionSubjectId: "sortByFilter",
        value: {
            value: value,
            label: sortBySelectOptions[value]
        },
        options: options,
        styles: $3ddac0a7ebe8223a$var$selectCustomStyle,
        isSearchable: false,
        isDisabled: isDisabled,
        onChange: sortByChange,
        inputId: "sort-by-filter",
        instanceId: "sort-by-filter"
    }))));
};
var $3ddac0a7ebe8223a$export$2e2bcd8739ae039 = /*#__PURE__*/ $bSJIT.memo((0, $fK3tS.default)($3ddac0a7ebe8223a$export$38d77f5667d0a049));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ddac0a7ebe8223a$var$FilterWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8vhf38": (0, $3zY6O.default)($9K7mZ.multiple(28).px)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1bsb1sn1 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _18u0mgjw",
            __cmplp.className
        ])
    });
});
const $3ddac0a7ebe8223a$var$FilterContent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1h6o _18u01jfw _89vyidpf _5rvhidpf _32nkidpf _wws0idpf _nw4oangw _1t2qnoz8 _r5bjidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cf0fX", function(module, exports) {
$parcel$export(module.exports, "Select", () => $2861e51e92bbf0f1$export$ef9b1a59e592288f);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $eOzrv = parcelRequire("eOzrv");
class $2861e51e92bbf0f1$export$ef9b1a59e592288f extends $bSJIT.PureComponent {
    render() {
        const { actionSubjectId: actionSubjectId, ...selectProps } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: {
                actionSubjectId: actionSubjectId
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $eOzrv.default), selectProps));
    }
}

});

parcelRegister("3kUNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f55c06a4e21c7b9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $4f55c06a4e21c7b9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    sortByFilterLabel: {
        defaultMessage: 'Sort by',
        description: 'Label for the sort by dropdown filter in the portal reorder experience',
        id: 'cv.portal.reordering.experience.sortBy.filter.label'
    },
    popularityOption: {
        defaultMessage: 'Popularity',
        description: 'Label for the sort by popularity option',
        id: 'cv.portal.reordering.experience.sortBy.filter.popularity.label'
    },
    alphabeticOption: {
        defaultMessage: 'Name: A to Z',
        description: 'Label for the sort by alphabetical option',
        id: 'cv.portal.reordering.experience.sortBy.filter.alphabetical.label'
    }
});

});



parcelRegister("2Sjfr", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $d8c6fc72515a3eb5$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "ExperienceContainer", () => $d8c6fc72515a3eb5$export$4d17725865d2ba3c);
$parcel$export(module.exports, "CardsContainer", () => $d8c6fc72515a3eb5$export$8e547173d545e862);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $9K7mZ = parcelRequire("9K7mZ");

var $hKa9R = parcelRequire("hKa9R");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d8c6fc72515a3eb5$var$HEADER_HEIGHT = `${$9K7mZ.multiple(10).px}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d8c6fc72515a3eb5$var$WRAPPER_MIN_HEIGHT = `calc(100vh - ${(0, $hKa9R.FOOTER_HEIGHT)}px - ${$d8c6fc72515a3eb5$var$HEADER_HEIGHT})`;
const $d8c6fc72515a3eb5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ans5n9": (0, $3zY6O.default)($d8c6fc72515a3eb5$var$WRAPPER_MIN_HEIGHT)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1yt41r39 _1tke1j5i _138y1jfw",
            __cmplp.className
        ])
    });
});
const $d8c6fc72515a3eb5$export$4d17725865d2ba3c = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ebxqrc": (0, $3zY6O.default)($9K7mZ.multiple(42).px),
            "--_1l8apj8": (0, $3zY6O.default)($9K7mZ.multiple(90).px),
            "--_1jphezo": (0, $3zY6O.default)($9K7mZ.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _kqswh2mm _19pk1ejb _p12ffptw _hclcjj99 _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $d8c6fc72515a3eb5$export$8e547173d545e862 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1aqg72h": (0, $3zY6O.default)($9K7mZ.multiple(-5).px)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_18s81u5k _19itg9nf _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1n261g80 _kqswh2mm _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bOxxr", function(module, exports) {
$parcel$export(module.exports, "default", () => $92510a8eb47dab86$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $92510a8eb47dab86$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    featuredPortalsTitle: {
        defaultMessage: 'Featured',
        description: 'Title for featured portals loader section',
        id: 'cv.portal.reordering.experience.loader.featured.portals.title'
    }
});

});



parcelRegister("kpZCJ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("1hAtG"),
    $kOunM("iT0U5"),
    $kOunM("aX4rz"),
    $kOunM("S1pUi"),
    $kOunM("fwv9r"),
    $kOunM("l6zxK"),
    $kOunM("6qSv5"),
    $kOunM("jdLWQ"),
    $kOunM("gDzlX"),
    $kOunM("gP0RN"),
    $kOunM("6AYIJ"),
    $kOunM("7bkCE"),
    $kOunM("fdSVr"),
    $kOunM("6DV53"),
    $kOunM("ccG8O"),
    $kOunM("3CwUv"),
    $kOunM("4UgRq"),
    $kOunM("kzTRH"),
    $kOunM("if62Z"),
    $kOunM("92sIe"),
    $kOunM("h0IiQ"),
    $kOunM("jnLeB"),
    $kOunM("fkLTv")
]).then(()=>parcelRequire('3u3H6'));

});


parcelRegister("9IExk", function(module, exports) {
$parcel$export(module.exports, "helpEditTopicsResource", () => $983be0cce3d3e57f$export$8b5129935a2eae3c);
$parcel$export(module.exports, "hiddenSectionWarningResource", () => $983be0cce3d3e57f$export$79066689501876c);

var $IaVWL = parcelRequire("IaVWL");

var $58RGa = parcelRequire("58RGa");

var $3LQyI = parcelRequire("3LQyI");
const $983be0cce3d3e57f$export$8b5129935a2eae3c = (0, $3LQyI.createRelayResource)({
    type: 'EDIT_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $IaVWL.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});
const $983be0cce3d3e57f$export$79066689501876c = (0, $3LQyI.createRelayResource)({
    type: 'HIDDEN_LAYOUT_SECTION_WARNING',
    getQuery: (_, { cloudId: cloudId, layoutAri: layoutAri })=>({
            parameters: (0, $58RGa.default),
            variables: {
                cloudId: cloudId,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("IaVWL", function(module, exports) {
$parcel$export(module.exports, "default", () => $88feb6f4887f7781$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79f064f566608c64fe4afe3c780b232c>>
 * @relayHash 2b93fcbc8c19a342658c7aff002a8cd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1
const $88feb6f4887f7781$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sortableTopicsContainerFragment"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "hiddenTopicsExpandedFragment"
                                        },
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "editableTopicFragment"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 3
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "items(first:3)"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "order"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1",
            "metadata": {},
            "name": "topicsEditQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$88feb6f4887f7781$var$node.hash = "ccda9262ffa2b20f017478c5ac8b7353";
var $88feb6f4887f7781$export$2e2bcd8739ae039 = $88feb6f4887f7781$var$node;

});

parcelRegister("58RGa", function(module, exports) {
$parcel$export(module.exports, "default", () => $193142665fd80638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1517e57be5d4aea1e7182378d54efdc1>>
 * @relayHash 186c8bbb9834e8623ccdc1e2f59099c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78
const $193142665fd80638$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "layoutAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v3 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hidden"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v2 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "HelpLayoutSectionConnection",
                                                "kind": "LinkedField",
                                                "name": "sections",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "HelpLayoutSectionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSection",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v3 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "HelpLayoutSubsection",
                                                                        "kind": "LinkedField",
                                                                        "name": "subsections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "elements",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v4 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayout"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78",
            "metadata": {},
            "name": "hiddenLayoutSectionWarningQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$193142665fd80638$var$node.hash = "f2fd5d711a9bee2d942b12cdd41c9d79";
var $193142665fd80638$export$2e2bcd8739ae039 = $193142665fd80638$var$node;

});





parcelRegister("7EcVw", function(module, exports) {
$parcel$export(module.exports, "EditHomepageV2Resource", () => $f83f75a821054e0c$export$3e8c7fe01574cb7a);

var $7c0Ry = parcelRequire("7c0Ry");

var $3LQyI = parcelRequire("3LQyI");
const $f83f75a821054e0c$export$3e8c7fe01574cb7a = (0, $3LQyI.createRelayResource)({
    type: 'EDIT_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $7c0Ry.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("7c0Ry", function(module, exports) {
$parcel$export(module.exports, "default", () => $211d328ac2511b79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bf616c28e62c7c65a524ac219b76e27>>
 * @relayHash 212a5d5e632802bde54e59d17573c070
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 79f56f1ec11b4cd0e0c952f194e9e5a31cfa81fc6ead00da309b64fc3ef6f1a6
const $211d328ac2511b79$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v7 = {
        "alias": "layoutId",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpLayoutSubsectionConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "span"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "adf"
    }, v10 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v11 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v12 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v20 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "useLayoutServiceVisualConfigData",
                "selections": v21 /*: any*/ ,
                "argumentDefinitions": []
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "useGlobalSettings"
    }, v24 = [
        v22 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "expandButtonTextColor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "forgeElementPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "forgeElementType"
    }, v28 = {
        "kind": "ScalarField",
        "name": "connectElementPage"
    }, v29 = {
        "kind": "ScalarField",
        "name": "connectElementType"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v33 = [
        v14 /*: any*/ ,
        v13 /*: any*/ 
    ], v34 = {
        "kind": "ScalarField",
        "name": "id"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v37 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v38 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v39 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v40 = [
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v42 = {
        "kind": "ScalarField",
        "name": "key"
    }, v43 = {
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v45 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v46 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v47 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v48 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v49 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v50 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v51 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalBrandingSettingsPanelFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "pageBuilderFragment"
                                            },
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "useLayoutServiceFragment",
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpLayoutSectionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "HelpLayoutSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "HelpLayoutSubsection",
                                                                                "kind": "LinkedField",
                                                                                "name": "subsections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v8 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "elements",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceEditorElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v9 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutEditorElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceHeroElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v23 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutHeroElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceAnnouncementElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceTopicsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutTopicsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceListOfPortalsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v25 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceForgeElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v26 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutForgeElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceConnectElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            v29 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutConnectElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceBreadcrumbElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutBreadcrumbElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v22 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v22 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v31 /*: any*/ 
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageBuilderMediaConfigFragment"
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "elementsCatalogueFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v34 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v44 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v34 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        },
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extensions",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCode"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v41 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v39 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "79f56f1ec11b4cd0e0c952f194e9e5a31cfa81fc6ead00da309b64fc3ef6f1a6",
            "metadata": {},
            "name": "editHomepageV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$211d328ac2511b79$var$node.hash = "a727ab2637500ee1215ac6f7895b25c2";
var $211d328ac2511b79$export$2e2bcd8739ae039 = $211d328ac2511b79$var$node;

});


parcelRegister("a4Y3D", function(module, exports) {
$parcel$export(module.exports, "brandingResource", () => $a64d3928d292edec$export$407a6849bf62b25c);
/*
These resources are a temporary solution to help with the server side rendering of multi help center home page.
This module will not be needed, once we move to the Flexible home page built on top of the Layout system.
*/ 
var $3kyZk = parcelRequire("3kyZk");

var $7RZPz = parcelRequire("7RZPz");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");

var $4270B = parcelRequire("4270B");
parcelRequire("ahGdU");
var $gmXRj = parcelRequire("gmXRj");

var $jti7u = parcelRequire("jti7u");

var $3mBpq = parcelRequire("3mBpq");

var $dDgZw = parcelRequire("dDgZw");

var $3LQyI = parcelRequire("3LQyI");
const $a64d3928d292edec$export$407a6849bf62b25c = (0, $iXC0o.createResource)({
    type: 'RELAY_HELP_CENTER_BRANDING',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $4270B.getRequest)((0, $dDgZw.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $7RZPz.store).dispatch((0, $3kyZk.fetchHelpCenterBrandingAction)());
        return Promise.resolve(null);
    }
});
const $a64d3928d292edec$export$19af4b0b8cda6b11 = (0, $iXC0o.createResource)({
    type: 'RELAY_HELP_CENTER_PORTALS',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $4270B.getRequest)((0, $3mBpq.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $7RZPz.store).dispatch((0, $gmXRj.fetchFeaturedAndSortedPortalsModel)({}, false));
        return Promise.resolve(null);
    }
});
const $a64d3928d292edec$export$b08096b7aea23d43 = (0, $3LQyI.createRelayResource)({
    type: 'HELP_CENTER_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $jti7u.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("jti7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $2da8e78961a0d524$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0932329082ebc356c0b0ebaf8fd46cc>>
 * @relayHash da0c9595f56db7cf97a352c0fe8277b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364
const $2da8e78961a0d524$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicFragment"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364",
            "metadata": {},
            "name": "topicsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2da8e78961a0d524$var$node.hash = "6c3fee571c0b47bf0526627e402d85f8";
var $2da8e78961a0d524$export$2e2bcd8739ae039 = $2da8e78961a0d524$var$node;

});


parcelRegister("c88hD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("aGsic"),
    $kOunM("kD0Gy"),
    $kOunM("1hAtG"),
    $kOunM("S1pUi"),
    $kOunM("6AYIJ"),
    $kOunM("ea5fa")
]).then(()=>parcelRequire('9lnyC'));

});

parcelRegister("ioALM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("aGsic"),
    $kOunM("kD0Gy"),
    $kOunM("1hAtG"),
    $kOunM("S1pUi"),
    $kOunM("6AYIJ"),
    $kOunM("dbzsk")
]).then(()=>parcelRequire('8raqd'));

});

parcelRegister("2SSsq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("aGsic"),
    $kOunM("1hAtG"),
    $kOunM("iT0U5"),
    $kOunM("aX4rz"),
    $kOunM("S1pUi"),
    $kOunM("fwv9r"),
    $kOunM("6qSv5"),
    $kOunM("jdLWQ"),
    $kOunM("gDzlX"),
    $kOunM("gP0RN"),
    $kOunM("6AYIJ"),
    $kOunM("7bkCE"),
    $kOunM("fdSVr"),
    $kOunM("6DV53"),
    $kOunM("3CwUv"),
    $kOunM("4UgRq"),
    $kOunM("kzTRH"),
    $kOunM("if62Z"),
    $kOunM("92sIe"),
    $kOunM("h0IiQ"),
    $kOunM("jnLeB"),
    $kOunM("hr3tS")
]).then(()=>parcelRequire('1oywt'));

});


parcelRegister("jNbk7", function(module, exports) {
$parcel$export(module.exports, "aiAnswerRoute", () => $51972647b5d1b208$export$aa89d187b9409394);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fFr9c = parcelRequire("fFr9c");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");

var $lVgpO = parcelRequire("lVgpO");

var $9da7a = parcelRequire("9da7a");

var $irUsc = parcelRequire("irUsc");

var $eDcdn = parcelRequire("eDcdn");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");
const $51972647b5d1b208$var$RenderAiAnswerRoute = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $irUsc.default), {
        screenName: (0, $jcRK7.ScreenName).AI_ANSWER,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d7jBU.default), {
        screenName: (0, $jcRK7.ScreenName).AI_ANSWER,
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fFr9c.default), {
                error: {
                    status: 500,
                    message: formatMessage((0, $9da7a.default).genericErrorMessage),
                    callToActionUrl: '/servicedesk/customer/portals'.replace((0, $eDcdn.getBaseName)(), ''),
                    callToActionText: formatMessage((0, $9da7a.default).genericRedirectMessage)
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lVgpO.AiAnswerFeedbackPage), null)));
};
const $51972647b5d1b208$var$route = {
    name: (0, $jcRK7.ScreenName).AI_ANSWER,
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/:requestKey/aianswer`,
    exact: true,
    component: $51972647b5d1b208$var$RenderAiAnswerRoute
};
const $51972647b5d1b208$var$screenName = (0, $jcRK7.ScreenName).AI_ANSWER;
const $51972647b5d1b208$export$aa89d187b9409394 = (0, $bkEWh.createRouteWithLayout)($51972647b5d1b208$var$route, $51972647b5d1b208$var$screenName, (0, $fZKGh.anonymousScreenLayout));

});
parcelRegister("lVgpO", function(module, exports) {
$parcel$export(module.exports, "AiAnswerFeedbackPage", () => $74033e8ca54c9643$export$589a347fe318e529);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $74033e8ca54c9643$export$589a347fe318e529 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("jiVga")), {
        moduleId: "./packages/virtual-agent/ai-answer/src/ui/ai-answer-feedback-page/hocs.tsx"
    })
});

});
parcelRegister("jiVga", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("13X7O"),
    $kOunM("8RQX9")
]).then(()=>parcelRequire('hD43p'));

});


parcelRegister("9da7a", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7c69979a8d508a2$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $c7c69979a8d508a2$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpfulPageHeading: {
        id: 'ai-answer.feedback-form.helpful-page-heading',
        defaultMessage: 'Awesome!',
        description: 'Heading for the feedback form helpful page'
    },
    helpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.helpful-page-sub-heading',
        defaultMessage: 'Glad we could help.',
        description: 'Subheading for the feedback form helpful page'
    },
    nonHelpfulPageHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-heading',
        defaultMessage: "Sorry, it wasn\u2019t helpful.",
        description: 'Heading for the feedback form non-helpful page'
    },
    nonHelpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-sub-heading',
        defaultMessage: "We're working on your request.",
        description: 'Subheading for the feedback form non-helpful page'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    additionalFeedbackCTALabel: {
        id: 'ai-answer.feedback-form.additional-feedback-label',
        defaultMessage: 'Give additional feedback',
        description: 'Label for the additional feedback button'
    },
    feedbackTitle: {
        id: 'ai-answer.feedback-form.feedback-title',
        defaultMessage: 'Help us improve',
        description: 'The text is shown as the title heading of the feedback dialog that appears when a user wants to provide feedback on an AI-generated answer.'
    },
    sendFeedbackLabel: {
        defaultMessage: 'Send Feedback',
        description: 'Feedback dialog Submit button label',
        id: 'ai-answer.feedback-form.feedback-submit-button-label'
    },
    cancelLabel: {
        defaultMessage: 'Cancel',
        description: 'Feedback dialog cancel button label',
        id: 'ai-answer.feedback-form.feedback-cancel-button-label'
    },
    contactLabel: {
        defaultMessage: 'Contact me for more details about this feedback',
        description: 'Feedback dialog can contact label',
        id: 'ai-answer.feedback-form.feedback-can-contact-label'
    },
    summary: {
        defaultMessage: 'Summary',
        description: 'Label for the summary text field in the feedback dialog',
        id: 'ai-answer.feedback-form.feedback-summary'
    },
    subHeading: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Sub-heading in the feedback dialog indicating required fields are marked with an asterisk',
        id: 'ai-answer.feedback-form.feedback-sub-heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-heading'
    },
    genericRedirectMessage: {
        defaultMessage: 'Go to the portal.',
        description: 'Generic redirect link message when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-redirect-message'
    },
    summaryPlaceholder: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Message which will be shown inside the summary text field',
        id: 'ai-answer.feedback-form.feedback-summary-placeholder'
    },
    enrolInResearchLabel: {
        defaultMessage: "I'd like to participate in product research",
        description: 'Message which will be shown next to the enrol in research checkbox',
        id: 'ai-answer.feedback-form.feedback-enrol-in-research-label'
    }
});

});


parcelRegister("5Or3j", function(module, exports) {
$parcel$export(module.exports, "approvalsRoute", () => $938ef19603d21cda$export$ee55f71d9820cd66);

var $jcRK7 = parcelRequire("jcRK7");

var $8d2Bo = parcelRequire("8d2Bo");

var $bkEWh = parcelRequire("bkEWh");
const $938ef19603d21cda$var$route = {
    name: 'user-approvals',
    path: `/user/approvals`,
    exact: true,
    component: (0, $8d2Bo.ApprovalList)
};
const $938ef19603d21cda$var$screenName = (0, $jcRK7.ScreenName).APPROVAL_LIST;
const $938ef19603d21cda$var$paperAppearance = 'wide';
const $938ef19603d21cda$var$layoutProps = {
    paperAppearance: $938ef19603d21cda$var$paperAppearance,
    fadeInSearchModal: true
};
const $938ef19603d21cda$export$ee55f71d9820cd66 = (0, $bkEWh.createRouteWithLayout)($938ef19603d21cda$var$route, $938ef19603d21cda$var$screenName, $938ef19603d21cda$var$layoutProps);

});
parcelRegister("8d2Bo", function(module, exports) {
$parcel$export(module.exports, "ApprovalList", () => $c480db99913e3dc7$export$dfa534f59b1c1487);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $c480db99913e3dc7$export$dfa534f59b1c1487 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("9Jt5J")), {
        moduleId: "./src/view/approval-list/approval-list.tsx"
    })
});

});
parcelRegister("9Jt5J", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("idwps").then(()=>parcelRequire('3xN1H'));

});



parcelRegister("8D35l", function(module, exports) {
$parcel$export(module.exports, "consentFormRoute", () => $dbc54d40058d4d56$export$f978586bc0d52692);

var $jcRK7 = parcelRequire("jcRK7");

var $kksNc = parcelRequire("kksNc");

var $bkEWh = parcelRequire("bkEWh");
const $dbc54d40058d4d56$var$consentForm = {
    resources: [],
    name: 'consent-form',
    path: `/user/consent`,
    exact: true,
    component: (0, $kksNc.ConsentForm)
};
const $dbc54d40058d4d56$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true
};
const $dbc54d40058d4d56$export$f978586bc0d52692 = (0, $bkEWh.createRouteWithLayout)($dbc54d40058d4d56$var$consentForm, (0, $jcRK7.ScreenName).CONSENT_FORM_PAGE, $dbc54d40058d4d56$var$layoutProps);

});
parcelRegister("kksNc", function(module, exports) {
$parcel$export(module.exports, "ConsentForm", () => $5fc348f13480953e$export$723d7f2fb08b9d80);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $5fc348f13480953e$export$723d7f2fb08b9d80 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("jc0mL")), {
        moduleId: "./src/view/consent-form/hocs.tsx"
    })
});

});
parcelRegister("jc0mL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lOwUC").then(()=>parcelRequire('huZuB'));

});



parcelRegister("eNwcA", function(module, exports) {
$parcel$export(module.exports, "csmContactUsRoute", () => $8c5e588e71cd2191$export$3979346dcb7ef96d);

var $jcRK7 = parcelRequire("jcRK7");

var $7C1R2 = parcelRequire("7C1R2");

var $3X7MV = parcelRequire("3X7MV");

var $bkEWh = parcelRequire("bkEWh");
const $8c5e588e71cd2191$var$contactUs = {
    resources: [
        (0, $3X7MV.mediaUploadCredentialsResource)
    ],
    name: (0, $jcRK7.RouteName).CSM_CONTACT_US_PAGE,
    path: (0, $jcRK7.RoutePath).CSM_CONTACT_US_PATH,
    exact: true,
    component: (0, $7C1R2.CsmContactUs)
};
const $8c5e588e71cd2191$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $8c5e588e71cd2191$export$3979346dcb7ef96d = (0, $bkEWh.createRouteWithLayout)($8c5e588e71cd2191$var$contactUs, (0, $jcRK7.ScreenName).CSM_CONTACT_US, $8c5e588e71cd2191$var$layoutProps);

});
parcelRegister("7C1R2", function(module, exports) {
$parcel$export(module.exports, "CsmContactUs", () => $dba737e1ec2c9a3e$export$961253a0ef353f1);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $dba737e1ec2c9a3e$export$961253a0ef353f1 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("jFRTQ")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/ui/csm-contact-page.tsx"
    })
});

});
parcelRegister("jFRTQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9EMTX"),
    $kOunM("br2rQ"),
    $kOunM("aA07X"),
    $kOunM("jsKIl"),
    $kOunM("8m449"),
    $kOunM("6o3JG"),
    $kOunM("jAikg"),
    $kOunM("9pCDc"),
    $kOunM("if62Z"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("aHc5N"),
    $kOunM("272yQ"),
    $kOunM("6bQ3H")
]).then(()=>parcelRequire('grDD0'));

});


parcelRegister("3X7MV", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $0850b47d79c050aa$export$fac4b16282dd90f6);

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");

var $9P2Zq = parcelRequire("9P2Zq");

var $51XYw = parcelRequire("51XYw");
const $0850b47d79c050aa$export$fac4b16282dd90f6 = (0, $iXC0o.createResource)({
    type: 'MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-upload-credentials`,
    getData: async ()=>{
        const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
        return (0, $51XYw.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});


parcelRegister("7FwJ0", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $20cf6a69a36b823a$export$3dddbf9f405aac5c);

var $jcRK7 = parcelRequire("jcRK7");

var $ajY24 = parcelRequire("ajY24");

var $bkEWh = parcelRequire("bkEWh");
parcelRequire("49oet");
var $fzBkM = parcelRequire("fzBkM");

var $a4Y3D = parcelRequire("a4Y3D");
const $20cf6a69a36b823a$export$3dddbf9f405aac5c = (name = (0, $jcRK7.RouteName).VIEW_CUSTOM_PAGE, path = (0, $jcRK7.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $a4Y3D.brandingResource),
        (0, $ajY24.ViewCustomPageResource)
    ];
    return (0, $bkEWh.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: (0, $fzBkM.ViewCustomPageWithAiAgent),
        resources: [
            (0, $ajY24.ViewCustomPageResource)
        ]
    }, (0, $jcRK7.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};

});
parcelRegister("ajY24", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPageResource", () => $b8e2dd7be633c270$export$15c85a1b3a2577c9);

var $fuVmc = parcelRequire("fuVmc");

var $hwpKw = parcelRequire("hwpKw");

var $3LQyI = parcelRequire("3LQyI");

var $lYqgT = parcelRequire("lYqgT");
const $b8e2dd7be633c270$export$15c85a1b3a2577c9 = (0, $3LQyI.createRelayResource)({
    type: 'VIEW_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id || '';
        const helpCenterPageAri = (0, $hwpKw.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $fuVmc.getActivationId)()
        }).toString();
        return {
            parameters: (0, $lYqgT.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("hwpKw", function(module, exports) {
$parcel$export(module.exports, "HelpPageAri", () => $cc19661c118289e3$export$7855a3c68b5a0b04);

var $6vsP9 = parcelRequire("6vsP9");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/help/page/manifest.ts
var $cc19661c118289e3$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6vsP9.HelpPageAriResourceOwner),
    resourceType: (0, $6vsP9.HelpPageAriResourceType),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $cc19661c118289e3$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cc19661c118289e3$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $cc19661c118289e3$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $cc19661c118289e3$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $cc19661c118289e3$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $cc19661c118289e3$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $cc19661c118289e3$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("6vsP9", function(module, exports) {
$parcel$export(module.exports, "HelpPageAriResourceOwner", () => $4bcbff2b83fb6798$export$b6fe1f05324d51ea);
$parcel$export(module.exports, "HelpPageAriResourceType", () => $4bcbff2b83fb6798$export$e6c9af890e88f3eb);
// src/help/page/types.ts
var $4bcbff2b83fb6798$export$b6fe1f05324d51ea = "help", $4bcbff2b83fb6798$export$e6c9af890e88f3eb = "page";

});


parcelRegister("lYqgT", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b8831732f4ad651$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8716921b8ad1a3339f001341db72213>>
 * @relayHash e15342ecc9d5d6d6fa16dbd150a7b3d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0584ba15db65176e105b407e15300f519202ee96f3cabce1e1cd9dd5ec97bb4
const $3b8831732f4ad651$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v8 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "HelpCenterPageDescription",
        "kind": "LinkedField",
        "name": "description",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "QueryError"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v21 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v23 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v27 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v28 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v12 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layoutByParentId",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    v11 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v6 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v13 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v16 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v25 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c0584ba15db65176e105b407e15300f519202ee96f3cabce1e1cd9dd5ec97bb4",
            "metadata": {},
            "name": "viewCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b8831732f4ad651$var$node.hash = "eb1a4ed7177899c5f9bd15d20468d07f";
var $3b8831732f4ad651$export$2e2bcd8739ae039 = $3b8831732f4ad651$var$node;

});


parcelRegister("49oet", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => (parcelRequire("fzBkM")).ViewCustomPage);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => (parcelRequire("fzBkM")).ViewCustomPageWithAiAgent);
$parcel$export(module.exports, "EditCustomPage", () => (parcelRequire("d1aha")).EditCustomPage);

var $fzBkM = parcelRequire("fzBkM");

var $d1aha = parcelRequire("d1aha");

});
parcelRegister("fzBkM", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => $ef104ce9c380b762$export$445268d8b5206a5d);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => $ef104ce9c380b762$export$e4a1d2bae0fd7812);

var $bSJIT = parcelRequire("bSJIT");

var $hO5qW = parcelRequire("hO5qW");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $ef104ce9c380b762$export$445268d8b5206a5d = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("dukJw")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/view-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), null)
});

const $ef104ce9c380b762$export$e4a1d2bae0fd7812 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("iFI4m")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/csm-variants/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), null)
});

});
parcelRegister("dukJw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kD0Gy"),
    $kOunM("1hAtG"),
    $kOunM("S1pUi"),
    $kOunM("6AYIJ"),
    $kOunM("aJia7")
]).then(()=>parcelRequire('4ulhj'));

});

parcelRegister("iFI4m", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kD0Gy"),
    $kOunM("1hAtG"),
    $kOunM("S1pUi"),
    $kOunM("aJia7"),
    $kOunM("6AYIJ"),
    $kOunM("8eutm")
]).then(()=>parcelRequire('c9rF0'));

});


parcelRegister("d1aha", function(module, exports) {
$parcel$export(module.exports, "EditCustomPage", () => $a313239d649c6496$export$7fc1d63603c0df32);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $hO5qW = parcelRequire("hO5qW");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("emd1X");
var $5ZKvf = parcelRequire("5ZKvf");

const $a313239d649c6496$export$7fc1d63603c0df32 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("hVeWk")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/edit-custom-page/edit-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>(0, $lFpPv.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5ZKvf.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), {
            showActionBar: true
        })
});

});
parcelRegister("hVeWk", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("1hAtG"),
    $kOunM("iT0U5"),
    $kOunM("aX4rz"),
    $kOunM("S1pUi"),
    $kOunM("fwv9r"),
    $kOunM("6qSv5"),
    $kOunM("jdLWQ"),
    $kOunM("gDzlX"),
    $kOunM("gP0RN"),
    $kOunM("6AYIJ"),
    $kOunM("7bkCE"),
    $kOunM("fdSVr"),
    $kOunM("6DV53"),
    $kOunM("3CwUv"),
    $kOunM("4UgRq"),
    $kOunM("kzTRH"),
    $kOunM("if62Z"),
    $kOunM("92sIe"),
    $kOunM("h0IiQ"),
    $kOunM("jnLeB"),
    $kOunM("9yeEc")
]).then(()=>parcelRequire('iubNX'));

});




parcelRegister("a1EwW", function(module, exports) {
$parcel$export(module.exports, "csmFolderRoute", () => $f4d44532c6beb59c$export$27c939ab49e382d2);

var $jcRK7 = parcelRequire("jcRK7");

var $9SKX5 = parcelRequire("9SKX5");

var $6KJbi = parcelRequire("6KJbi");

var $ke1FE = parcelRequire("ke1FE");

var $bkEWh = parcelRequire("bkEWh");
const $f4d44532c6beb59c$var$folder = {
    resources: [
        (0, $ke1FE.CsmFolderResource),
        (0, $6KJbi.CsmEmptyFolderResource)
    ],
    name: (0, $jcRK7.RouteName).CSM_FOLDER_PAGE,
    path: (0, $jcRK7.RoutePath).CSM_FOLDER_PATH,
    exact: true,
    component: (0, $9SKX5.CsmFolder)
};
const $f4d44532c6beb59c$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $f4d44532c6beb59c$export$27c939ab49e382d2 = (0, $bkEWh.createRouteWithLayout)($f4d44532c6beb59c$var$folder, (0, $jcRK7.ScreenName).CSM_FOLDER, $f4d44532c6beb59c$var$layoutProps);

});
parcelRegister("9SKX5", function(module, exports) {
$parcel$export(module.exports, "CsmFolder", () => $4791b4fab149a3b5$export$56c9caef0ff41b5c);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $4791b4fab149a3b5$export$56c9caef0ff41b5c = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("2HmTb")), {
        moduleId: "./packages/customer-service/csm-folder/src/ui/csm-folder.tsx"
    })
});

});
parcelRegister("2HmTb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("56MHC").then(()=>parcelRequire('3Q2Ru'));

});


parcelRegister("6KJbi", function(module, exports) {
$parcel$export(module.exports, "CsmEmptyFolderResource", () => $e53c7c979b5a2a38$export$acacebd3c63c516);

var $3LQyI = parcelRequire("3LQyI");

var $cnuV6 = parcelRequire("cnuV6");

var $lwnu0 = parcelRequire("lwnu0");
const $e53c7c979b5a2a38$export$acacebd3c63c516 = (0, $3LQyI.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $cnuV6.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $lwnu0.MAX_ITEMS_PER_PAGE),
                input: {
                    articleIds: [
                        pageId
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("cnuV6", function(module, exports) {
$parcel$export(module.exports, "default", () => $5300548a9110ec1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b395b2f764ccd459bcc11cb4b79c1761>>
 * @relayHash be67b91b3b5b3d2fbcf3fcc898595c20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365
const $5300548a9110ec1a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "emptyStateRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "EmptyStateRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365",
            "metadata": {},
            "name": "emptyStateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5300548a9110ec1a$var$node.hash = "0f924812359a442723962628434695a3";
var $5300548a9110ec1a$export$2e2bcd8739ae039 = $5300548a9110ec1a$var$node;

});

parcelRegister("lwnu0", function(module, exports) {
$parcel$export(module.exports, "MAX_ITEMS_PER_PAGE", () => $40197aa82729bbbf$export$e7a0dcb737d8e4ee);
const $40197aa82729bbbf$export$e7a0dcb737d8e4ee = 24;

});


parcelRegister("ke1FE", function(module, exports) {
$parcel$export(module.exports, "CsmFolderResource", () => $7c00921692df6bdb$export$c37e0f6e8d7653a0);

var $3LQyI = parcelRequire("3LQyI");

var $cKQgZ = parcelRequire("cKQgZ");

var $lwnu0 = parcelRequire("lwnu0");
const $7c00921692df6bdb$var$ANCESTORS = 'ANCESTORS';
const $7c00921692df6bdb$export$c37e0f6e8d7653a0 = (0, $3LQyI.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $cKQgZ.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $lwnu0.MAX_ITEMS_PER_PAGE),
                input: {
                    parentId: Number(pageId),
                    expand: [
                        $7c00921692df6bdb$var$ANCESTORS
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("cKQgZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $13c65fae46750cc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67d2bbd7d59b1ab8335ec1f2e3d8b5b0>>
 * @relayHash ca6bf320095164b2c7bf8c7a0da7ff96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 545cafff76808c8fbdaa985de5b3004568e314aaecfce1af44e865ce4984f817
const $13c65fae46750cc5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "mainCsmFolderItemsRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "contentType"
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleRelative",
                                                    "kind": "LinkedField",
                                                    "name": "ancestors",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleURLInfo",
                                                    "kind": "LinkedField",
                                                    "name": "urlInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shareUrl"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "CsmFolderItemsRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "545cafff76808c8fbdaa985de5b3004568e314aaecfce1af44e865ce4984f817",
            "metadata": {},
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13c65fae46750cc5$var$node.hash = "4e2df91a41eb5d8ce8ae2f48a0e1068e";
var $13c65fae46750cc5$export$2e2bcd8739ae039 = $13c65fae46750cc5$var$node;

});



parcelRegister("1Ajtz", function(module, exports) {
$parcel$export(module.exports, "csmViewKbPageRoute", () => $5965045564362853$export$ef20b2dba68d2a8);
$parcel$export(module.exports, "csmViewArticleRoute", () => $5965045564362853$export$b346ad0264655ca1);
$parcel$export(module.exports, "csmViewCrossSiteArticleRoute", () => $5965045564362853$export$cfb51b854559f2b3);

var $jcRK7 = parcelRequire("jcRK7");

var $7Q8J3 = parcelRequire("7Q8J3");

var $bkEWh = parcelRequire("bkEWh");
const $5965045564362853$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $7Q8J3.CsmArticle)
};
const $5965045564362853$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $7Q8J3.CsmArticle)
};
const $5965045564362853$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $7Q8J3.CsmArticle)
};
const $5965045564362853$var$layoutProps = {
    paperAppearance: 'xxwide',
    fadeInSearchModal: true
};
const $5965045564362853$export$ef20b2dba68d2a8 = (0, $bkEWh.createRouteWithLayout)($5965045564362853$var$viewKbPage, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $5965045564362853$var$layoutProps);
const $5965045564362853$export$b346ad0264655ca1 = (0, $bkEWh.createRouteWithLayout)($5965045564362853$var$viewArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $5965045564362853$var$layoutProps);
const $5965045564362853$export$cfb51b854559f2b3 = (0, $bkEWh.createRouteWithLayout)($5965045564362853$var$viewCrossSiteArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $5965045564362853$var$layoutProps);

});
parcelRegister("7Q8J3", function(module, exports) {
$parcel$export(module.exports, "CsmArticle", () => $9093a34b4f999c07$export$630a6bc855af0b24);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $9093a34b4f999c07$export$630a6bc855af0b24 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1ci8e")), {
        moduleId: "./src/view/article/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("1ci8e", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("blxbr"),
    $kOunM("aLfJb"),
    $kOunM("O64er")
]).then(()=>parcelRequire('bvwei'));

});



parcelRegister("75GyY", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListRoute", () => $dd41779f97d8b167$export$416674a9ebdb2ee0);
$parcel$export(module.exports, "csmRequestDetailsRoute", () => $dd41779f97d8b167$export$c1779627ae2c6baa);

var $jcRK7 = parcelRequire("jcRK7");

var $02NLy = parcelRequire("02NLy");

var $eYYzi = parcelRequire("eYYzi");

var $d0QiX = parcelRequire("d0QiX");

var $7xhxh = parcelRequire("7xhxh");

var $8pF3j = parcelRequire("8pF3j");

var $2iFXS = parcelRequire("2iFXS");

var $34EUU = parcelRequire("34EUU");

var $bkEWh = parcelRequire("bkEWh");
const $dd41779f97d8b167$export$416674a9ebdb2ee0 = (0, $bkEWh.createRouteWithLayout)({
    name: (0, $jcRK7.RouteName).CSM_REQUESTS_LIST_PAGE,
    path: (0, $jcRK7.RoutePath).CSM_REQUESTS_LIST_PATH,
    exact: true,
    component: (0, $2iFXS.CsmRequestsList),
    resources: [
        (0, $34EUU.csmRequestsListQueryResource)
    ]
}, (0, $jcRK7.ScreenName).CSM_REQUESTS_LIST, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
});
const $dd41779f97d8b167$export$c1779627ae2c6baa = (0, $bkEWh.createRouteWithLayout)({
    name: (0, $jcRK7.RouteName).CSM_REQUEST_DETAILS_PAGE,
    path: (0, $jcRK7.RoutePath).CSM_REQUEST_DETAILS_PATH,
    exact: true,
    component: (0, $8pF3j.AsyncCsmRequestDetails),
    resources: [
        (0, $02NLy.csmRequestDetailsQueryResource),
        (0, $7xhxh.requestConversationResource),
        (0, $eYYzi.mediaReadCredentialsResource),
        (0, $d0QiX.mediaUploadCredentialsResource)
    ]
}, (0, $jcRK7.ScreenName).CSM_REQUEST_DETAILS, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true,
    hideBanner: true
});

});
parcelRegister("02NLy", function(module, exports) {
$parcel$export(module.exports, "csmRequestDetailsQueryResource", () => $bcec80ebd2135450$export$54cc49ad6240b8cc);

var $fuVmc = parcelRequire("fuVmc");

var $3LQyI = parcelRequire("3LQyI");

var $4XuuJ = parcelRequire("4XuuJ");
const $bcec80ebd2135450$export$54cc49ad6240b8cc = (0, $3LQyI.createRelayResource)({
    type: 'CSM_REQUEST_DETAILS_QUERY',
    getQuery: ({ match: { params: { requestKey: requestKey } } }, { cloudId: cloudId })=>({
            parameters: (0, $4XuuJ.default),
            variables: {
                cloudId: cloudId,
                issueKey: requestKey ?? '',
                helpCenterId: (0, $fuVmc.getMeta)('help-center-ari') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("4XuuJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $020c5f057e705c4f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e90d29b1c257942bb16bc8a5b0d2cfdd>>
 * @relayHash a7ebdbf07408265d75c2cc406c04f0f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58fe90f9c78b8407af5972c275e67b09ebfa78c8abaeff457cdb8404b2327720
const $020c5f057e705c4f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterId",
            "variableName": "helpCenterId"
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "question"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "requestByIssueKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceRequestSharedOrganization",
                                                    "kind": "LinkedField",
                                                    "name": "sharedOrganizations",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_csmRequestDetails"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formView_csmRequestDetails"
                                                }
                                            ],
                                            "type": "CustomerServiceRequest"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_csmCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "requestByIssueKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceRequestSharedOrganization",
                                            "kind": "LinkedField",
                                            "name": "sharedOrganizations",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "createdOn"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCategoryName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reporterDisplayName"
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestParticipant",
                                            "kind": "LinkedField",
                                            "name": "participants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestFormDataConnection",
                                            "kind": "LinkedField",
                                            "name": "formData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestFormDataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "textAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "adfAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryRichTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "multiSelectTextAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryMultiSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fileIds"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryAttachmentField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceRequest"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "58fe90f9c78b8407af5972c275e67b09ebfa78c8abaeff457cdb8404b2327720",
            "metadata": {},
            "name": "csmRequestDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$020c5f057e705c4f$var$node.hash = "97d1776fa449082ee1e26453e32fcdac";
var $020c5f057e705c4f$export$2e2bcd8739ae039 = $020c5f057e705c4f$var$node;

});


parcelRegister("eYYzi", function(module, exports) {
$parcel$export(module.exports, "mediaReadCredentialsResource", () => $76ab7cd413343449$export$bb777640a2b36f94);

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");

var $9P2Zq = parcelRequire("9P2Zq");

var $51XYw = parcelRequire("51XYw");
const $76ab7cd413343449$export$bb777640a2b36f94 = (0, $iXC0o.createResource)({
    type: 'MEDIA_READ_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-read-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
        return (0, $51XYw.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/read`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("d0QiX", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $108c28762288f35d$export$fac4b16282dd90f6);

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");

var $9P2Zq = parcelRequire("9P2Zq");

var $51XYw = parcelRequire("51XYw");
const $108c28762288f35d$export$fac4b16282dd90f6 = (0, $iXC0o.createResource)({
    type: 'CSM_MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`csm-media-upload-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
        return (0, $51XYw.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 600000 // 10 minutes
});

});

parcelRegister("7xhxh", function(module, exports) {
$parcel$export(module.exports, "requestConversationResource", () => $7935bc29028d8696$export$9062b1d7764a6617);

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");

var $9P2Zq = parcelRequire("9P2Zq");

var $51XYw = parcelRequire("51XYw");
const $7935bc29028d8696$export$9062b1d7764a6617 = (0, $iXC0o.createResource)({
    type: 'REQUEST_CONVERSATION_RESOURCE',
    getKey: ()=>`request-conversation`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse((0, $fuVmc.getHelpCenterAri)());
        return (0, $51XYw.fetchJson)(`/gateway/api/jsm/csm/api/v1/request/form/helpcenter/${helpCenterId}/conversation/history?issueIdOrKey=${match.params.requestKey || ''}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("8pF3j", function(module, exports) {
$parcel$export(module.exports, "AsyncCsmRequestDetails", () => $601622f753bd110d$export$c654e93ddb89d705);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $601622f753bd110d$export$c654e93ddb89d705 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("62aol")), {
        moduleId: "./packages/customer-service/csm-request-details/src/ui/csm-request-details.tsx"
    })
});

});
parcelRegister("62aol", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("jdLWQ"),
    $kOunM("4c4Ay"),
    $kOunM("eau4o"),
    $kOunM("5EvQd"),
    $kOunM("esjBs"),
    $kOunM("66XEo")
]).then(()=>parcelRequire('cgxMX'));

});


parcelRegister("2iFXS", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsList", () => $0a2a45c33e34977a$export$790b773cc5ea9295);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $0a2a45c33e34977a$export$790b773cc5ea9295 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("0154s")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/ui/csm-requests-list.tsx"
    })
});

});
parcelRegister("0154s", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("lMUFX"),
    $kOunM("eau4o"),
    $kOunM("hQ9R7"),
    $kOunM("f80Rt"),
    $kOunM("lJr3G")
]).then(()=>parcelRequire('4cViN'));

});


parcelRegister("34EUU", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListQueryResource", () => $cbbcbcee3122227a$export$a6363e566cdd7bae);

var $fuVmc = parcelRequire("fuVmc");

var $3LQyI = parcelRequire("3LQyI");

var $4ZOPV = parcelRequire("4ZOPV");

var $juruo = parcelRequire("juruo");
const $cbbcbcee3122227a$export$a6363e566cdd7bae = (0, $3LQyI.createRelayResource)({
    type: 'CSM_REQUESTS_LIST_QUERY',
    getQuery: (_, { cloudId: cloudId })=>({
            parameters: (0, $juruo.default),
            variables: {
                cloudId: cloudId,
                accountId: (0, $fuVmc.getMeta)('account-id') ?? '',
                helpCenterId: (0, $fuVmc.getMeta)('help-center-ari') ?? '',
                count: (0, $4ZOPV.PAGINATION_SIZE)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("4ZOPV", function(module, exports) {
$parcel$export(module.exports, "PAGINATION_SIZE", () => $b8e3d44609e9fcd7$export$cb638d1fae624fbf);
const $b8e3d44609e9fcd7$export$cb638d1fae624fbf = 30;

});

parcelRegister("juruo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a5d1bfa67610db5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aee4d632d08e3f91f0b91b1450b78035>>
 * @relayHash 3681b7ed328fbc24d7c85e9a38792f1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7d208559ac8563e6f5acd98cc24a4f3985b7efb2b89c69336bd060de1c4967a
const $2a5d1bfa67610db5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v5 = {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v8 = {
        "kind": "Variable",
        "name": "helpCenterId",
        "variableName": "helpCenterId"
    }, v9 = [
        v6 /*: any*/ 
    ], v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CustomerServiceExternalStatus",
                "kind": "LinkedField",
                "name": "externalStatuses",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "externalLabel"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraStatusIds"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "statusCategory"
                    }
                ]
            }
        ],
        "type": "CustomerServiceExternalStatusesResponse"
    }, v12 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v8 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "requestsTable_csmRequestsList"
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "CustomerServiceRequestConnection",
                                            "kind": "LinkedField",
                                            "name": "requests",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceRequest",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalStatus"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusCategoryName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "reporterDisplayName"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceRequestSharedOrganization",
                                                                    "kind": "LinkedField",
                                                                    "name": "sharedOrganizations",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "name"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createdOn"
                                                                },
                                                                v17 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v16 /*: any*/ ,
                                            "filters": [
                                                "helpCenterId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "requestsTable_requests",
                                            "kind": "LinkedHandle",
                                            "name": "requests"
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v17 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c7d208559ac8563e6f5acd98cc24a4f3985b7efb2b89c69336bd060de1c4967a",
            "metadata": {},
            "name": "csmRequestsListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2a5d1bfa67610db5$var$node.hash = "cb6332bdb26c3936c3393e7e0eb0eafc";
var $2a5d1bfa67610db5$export$2e2bcd8739ae039 = $2a5d1bfa67610db5$var$node;

});



parcelRegister("9TNJA", function(module, exports) {
$parcel$export(module.exports, "csmUserProfileRoute", () => $f47e51716059187e$export$e41fe4b9d1161823);

var $jcRK7 = parcelRequire("jcRK7");

var $jUQTe = parcelRequire("jUQTe");

var $bkEWh = parcelRequire("bkEWh");
const $f47e51716059187e$var$viewUserProfilePage = {
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $jUQTe.CsmUserProfile)
};
const $f47e51716059187e$export$e41fe4b9d1161823 = (0, $bkEWh.createRouteWithLayout)($f47e51716059187e$var$viewUserProfilePage, (0, $jcRK7.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("jUQTe", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfile", () => $2ff37f11945ec0df$export$3d0c667f8fc698fc);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $2ff37f11945ec0df$export$3d0c667f8fc698fc = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("g80yp")), {
        moduleId: "./src/view/user-profile/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("g80yp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cL5bQ"),
    $kOunM("9qsgG")
]).then(()=>parcelRequire('9Scsj'));

});



parcelRegister("5Yb8O", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $73cdff735bed5ff8$export$3dddbf9f405aac5c);
$parcel$export(module.exports, "getEditCustomPageRoute", () => $73cdff735bed5ff8$export$c998bed8122ef3dd);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $jcRK7 = parcelRequire("jcRK7");

var $5Tbjo = parcelRequire("5Tbjo");

var $ajY24 = parcelRequire("ajY24");

var $lFpPv = parcelRequire("lFpPv");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");

var $2Wp8Q = parcelRequire("2Wp8Q");
parcelRequire("TdcAL");
var $57PyM = parcelRequire("57PyM");
parcelRequire("7wH5B");
var $30arO = parcelRequire("30arO");

var $1xzNy = parcelRequire("1xzNy");

var $bkEWh = parcelRequire("bkEWh");
parcelRequire("49oet");
var $d1aha = parcelRequire("d1aha");
var $fzBkM = parcelRequire("fzBkM");

var $a4Y3D = parcelRequire("a4Y3D");
const $73cdff735bed5ff8$var$ViewCustomPageWithRovoWidget = (0, $2Wp8Q.withHelpCenterRovoWidget)((0, $fzBkM.ViewCustomPage));
const $73cdff735bed5ff8$export$3dddbf9f405aac5c = (name = (0, $jcRK7.RouteName).VIEW_CUSTOM_PAGE, path = (0, $jcRK7.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $a4Y3D.brandingResource),
        (0, $ajY24.ViewCustomPageResource)
    ];
    return (0, $bkEWh.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $73cdff735bed5ff8$var$ViewCustomPageWithRovoWidget,
        resources: [
            (0, $ajY24.ViewCustomPageResource)
        ]
    }, (0, $jcRK7.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $73cdff735bed5ff8$export$366de07628c8a4b = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: props.location.pathname
    }), (0, $ifEXU.default)({
        message: formatMessage((0, $1xzNy.authPageMessage)),
        callToActionText: formatMessage((0, $1xzNy.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $57PyM.default), {
            path: (0, $jcRK7.RoutePath).EDIT_CUSTOM_PAGE,
            component: (0, $d1aha.EditCustomPage),
            screenName: (0, $jcRK7.ScreenName).EDIT_CUSTOM_PAGE,
            isFooterHidden: (0, $lFpPv.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $30arO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
};
const $73cdff735bed5ff8$export$c998bed8122ef3dd = (name = (0, $jcRK7.RouteName).EDIT_CUSTOM_PAGE, path = (0, $jcRK7.RoutePath).EDIT_CUSTOM_PAGE)=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        exact: true,
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($73cdff735bed5ff8$export$366de07628c8a4b),
        resources: [
            (0, $5Tbjo.EditCustomPageResource)
        ]
    };
    return editHomePageRoute;
};

});
parcelRegister("5Tbjo", function(module, exports) {
$parcel$export(module.exports, "EditCustomPageResource", () => $eff62ce424f350d9$export$bb1f5be367194159);

var $fuVmc = parcelRequire("fuVmc");

var $hwpKw = parcelRequire("hwpKw");

var $3LQyI = parcelRequire("3LQyI");

var $ewhi0 = parcelRequire("ewhi0");
const $eff62ce424f350d9$export$bb1f5be367194159 = (0, $3LQyI.createRelayResource)({
    type: 'EDIT_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id;
        if (!pageId) throw Error('No page id for custom page.');
        const helpCenterPageAri = (0, $hwpKw.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $fuVmc.getActivationId)()
        }).toString();
        return {
            parameters: (0, $ewhi0.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("ewhi0", function(module, exports) {
$parcel$export(module.exports, "default", () => $de292ccc1efae773$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afecf275bf1b1f87e33cdaf8ea455f40>>
 * @relayHash cac39a5aff5256ed1e3f136528873758
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cef9c5e37d4002685f206f54e0b958adb8cf7bb43e38583cc6a57589c4fd1d31
const $de292ccc1efae773$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v10 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = [
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "message"
    }, v15 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            v15 /*: any*/ 
        ],
        "type": "QueryError"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v19 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v20 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v22 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v24 = {
        "kind": "ScalarField",
        "name": "key"
    }, v25 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v26 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "url"
    }, v31 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v33 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v34 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v35 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v36 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v39 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v40 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v41 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v42 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v43 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v44 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v29 /*: any*/ 
        ]
    }, v45 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v11 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "HelpLayoutQueryApi",
                        "kind": "LinkedField",
                        "name": "helpLayout",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v12 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "layoutByParentId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "pageBuilderFragment"
                                                }
                                            ],
                                            "type": "HelpLayout"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "HelpLayoutMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "mediaConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "pageBuilderMediaConfigFragment"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "elementTypes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "elementsCatalogueFragment"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v7 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v13 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v28 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v5 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v34 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                v40 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v15 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "layoutId",
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v28 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cef9c5e37d4002685f206f54e0b958adb8cf7bb43e38583cc6a57589c4fd1d31",
            "metadata": {},
            "name": "editCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$de292ccc1efae773$var$node.hash = "ced1fe6aab72feb794e7063ba7fe32c0";
var $de292ccc1efae773$export$2e2bcd8739ae039 = $de292ccc1efae773$var$node;

});


parcelRegister("2Wp8Q", function(module, exports) {
$parcel$export(module.exports, "HelpCenterRovoWidget", () => $d836dace0bd9e991$export$1948af5813162381);
$parcel$export(module.exports, "withHelpCenterRovoWidget", () => $d836dace0bd9e991$export$75e5cfdb2c692e61);

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $87QgR = parcelRequire("87QgR");

var $5X2Zr = parcelRequire("5X2Zr");
const $d836dace0bd9e991$var$ENHANCE_JSM_WIDGET_STABILITY = 'enhance_jsm_widget_stability';
const $d836dace0bd9e991$var$isEnhancedJsmWidgetStabilityEnabled = ()=>(0, $87QgR.default).checkGate($d836dace0bd9e991$var$ENHANCE_JSM_WIDGET_STABILITY);
const $d836dace0bd9e991$export$1948af5813162381 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5X2Zr.RovoServiceAgentWidgetInjector), {
        surface: "HELP_CENTER",
        siteId: (0, $fuVmc.getCloudId)(),
        widgetId: (0, $fuVmc.getHelpCenterAri)()
    });
const $d836dace0bd9e991$export$75e5cfdb2c692e61 = (Page)=>{
    const PageWithHelpCenterRovoWidget = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Page, props), $d836dace0bd9e991$var$isEnhancedJsmWidgetStabilityEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d836dace0bd9e991$export$1948af5813162381, null));
    PageWithHelpCenterRovoWidget.displayName = `withHelpCenterRovoWidget(${Page.displayName || Page.name || 'Component'})`;
    return PageWithHelpCenterRovoWidget;
};

});
parcelRegister("5X2Zr", function(module, exports) {
$parcel$export(module.exports, "RovoServiceAgentWidgetInjector", () => $e6c6de031204cc59$export$19e4074f6781b5f7);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $hkLEY = parcelRequire("hkLEY");

var $awkgb = parcelRequire("awkgb");

var $kxIlX = parcelRequire("kxIlX");

var $k2MWg = parcelRequire("k2MWg");

var $clpci = parcelRequire("clpci");

var $9hihM = parcelRequire("9hihM");
var $7190A = parcelRequire("7190A");

var $dWay1 = parcelRequire("dWay1");

var $bvuPP = parcelRequire("bvuPP");
const $e6c6de031204cc59$var$InjectRovoServiceAgentWidgetScript = /*#__PURE__*/ (0, $bSJIT.memo)(function RovoServiceAgentWidget({ siteId: siteId, widgetId: widgetId, surface: surface, brandPrimaryColor: brandPrimaryColor }) {
    const [error, setError] = (0, $bSJIT.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { locale: locale } = (0, $4vLTk.default)();
    const handleOnOpen = (0, $bSJIT.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88552
        (0, $k2MWg.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget opened');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClose = (0, $bSJIT.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88553
        (0, $k2MWg.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget closed');
    }, [
        createAnalyticsEvent
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const loadScript = async ()=>{
            const startTime = performance.now();
            try {
                setError(null);
                await (0, $bvuPP.loadRovoWidgetSDKScript)({
                    siteId: siteId,
                    widgetId: widgetId,
                    surface: surface,
                    locale: locale,
                    brandPrimaryColor: brandPrimaryColor,
                    onOpen: handleOnOpen,
                    onClose: handleOnClose
                });
                // Measure widget load time (non-blocking, fire-and-forget)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration
                    }
                }), 'rovoServiceAgentWidget scriptLoaded');
            } catch (err) {
                // Measure failed load time (non-blocking)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration,
                        error: err instanceof Error ? err.message : 'Unknown error'
                    }
                }), 'rovoServiceAgentWidget scriptFailed');
                setError(err instanceof Error ? err : new Error('Failed to load widget script'));
            }
        };
        // The error handler is inside loadScript, so we don't need to handle it here
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadScript();
    }, [
        widgetId,
        siteId,
        handleOnClose,
        handleOnOpen,
        surface,
        locale,
        createAnalyticsEvent,
        brandPrimaryColor
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            (0, $bvuPP.cleanupRovoWidgetSDKScript)();
        };
    }, []);
    if (error) throw error;
    // Return null without blocking UFO experience - widget loads asynchronously
    return null;
});
const $e6c6de031204cc59$export$19e4074f6781b5f7 = ({ siteId: siteId, widgetId: widgetId, surface: surface, brandPrimaryColor: brandPrimaryColor })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const renderError = (0, $bSJIT.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lJzMO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2bmUD.default), {
            id: "rovo-widget-error-flag",
            appearance: "error",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                label: ""
            }),
            title: formatMessage((0, $dWay1.default).widgetErrorTitle),
            description: formatMessage((0, $dWay1.default).widgetErrorDescription),
            testId: "rovo-widget-error-flag"
        }));
    }, [
        formatMessage
    ]);
    // RSA widget script (https://<site>/rovo/widget/script.js) is not deployed
    // on FedRAMP or Isolated Cloud tenants, so do not attempt to inject it there.
    if ((0, $9hihM.isFedRamp)() || (0, $7190A.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $awkgb.default), {
        name: "rovo-service-agent-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: "rovo-service-agent",
        id: "widget-injector",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: "rovoServiceAgent",
        sourceType: (0, $clpci.MODAL),
        attributes: {
            siteId: siteId,
            widgetId: widgetId,
            surface: surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e6c6de031204cc59$var$InjectRovoServiceAgentWidgetScript, {
        siteId: siteId,
        widgetId: widgetId,
        surface: surface,
        brandPrimaryColor: brandPrimaryColor
    }))));
};

});
parcelRegister("dWay1", function(module, exports) {
$parcel$export(module.exports, "default", () => $305328ddeb4a484f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $305328ddeb4a484f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    widgetErrorTitle: {
        id: 'rovo.service-agent.widget.error-boundary.title.non-final',
        defaultMessage: 'Rovo Service Agent widget unavailable',
        description: 'Title for the error flag for when the widget failed to load'
    },
    widgetErrorDescription: {
        id: 'rovo.service-agent.widget.error-boundary.description.non-final',
        defaultMessage: 'The Rovo Service Agent failed to load. Please refresh the page to try again.',
        description: 'Description for the error flag for when the widget failed to load'
    }
});

});

parcelRegister("bvuPP", function(module, exports) {
$parcel$export(module.exports, "loadRovoWidgetSDKScript", () => $38952e24b2aa8a59$export$7547b32d5aede92f);
$parcel$export(module.exports, "cleanupRovoWidgetSDKScript", () => $38952e24b2aa8a59$export$8b3a5cba31576b8a);
let $38952e24b2aa8a59$var$promise = null;
const $38952e24b2aa8a59$var$SCRIPT_ID = 'rovo-service-agent-widget-script';
const $38952e24b2aa8a59$export$7bcdf693772d0a65 = ()=>{
    const q = function WidgetQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};
const $38952e24b2aa8a59$export$2319c1f51535cb1c = ()=>{
    if (typeof window === 'undefined') throw new Error('Failed to load CSM SDK: window is undefined');
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    if (!body) throw new Error('Document body not found');
};
const $38952e24b2aa8a59$export$e0c468a317b25666 = (onOpen, onClose)=>{
    if (typeof window.ROVO_WIDGET === 'undefined') {
        window.ROVO_WIDGET = $38952e24b2aa8a59$export$7bcdf693772d0a65();
        if (onOpen) window.ROVO_WIDGET('onOpen', onOpen);
        if (onClose) window.ROVO_WIDGET('onClose', onClose);
        window.ROVO_WIDGET('open');
    }
};
const $38952e24b2aa8a59$export$bb8c6503cfd42bb6 = ()=>{
    return !!(window.ROVO_WIDGET && !('__q__' in window.ROVO_WIDGET));
};
const $38952e24b2aa8a59$export$8e6c9489c906e450 = (siteId, widgetId, surface, locale, brandPrimaryColor)=>{
    const site = window.location.hostname;
    const src = new URL(`https://${site}/rovo/widget/script.js`);
    src.searchParams.set('siteId', siteId);
    src.searchParams.set('site', site);
    src.searchParams.set('widgetId', widgetId);
    src.searchParams.set('surface', surface);
    src.searchParams.set('locale', locale);
    // Only the Help Hub corner widget passes a colour; every other host keeps a byte-identical URL.
    if (brandPrimaryColor) {
        src.searchParams.set('brandPrimaryColor', brandPrimaryColor);
        src.searchParams.set('brandVibe', 'vibrant');
    }
    return src.toString();
};
const $38952e24b2aa8a59$export$9b542085e8be8f80 = (resolve, reject)=>{
    if ($38952e24b2aa8a59$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
    else if (window.ROVO_WIDGET && '__q__' in window.ROVO_WIDGET) {
        $38952e24b2aa8a59$export$57f8607478cbbab6();
        if ($38952e24b2aa8a59$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
        else {
            $38952e24b2aa8a59$var$promise = null;
            reject(new Error('SDK failed to initialize properly - still in queue mode'));
        }
    } else {
        $38952e24b2aa8a59$var$promise = null;
        reject(new Error('Failed to load ROVO_WIDGET SDK script: window.ROVO_WIDGET is undefined'));
    }
};
const $38952e24b2aa8a59$export$c20f7df29b9552b6 = (reject)=>{
    $38952e24b2aa8a59$var$promise = null;
    reject(new Error('Failed to load ROVO_WIDGET SDK script: onerror'));
};
const $38952e24b2aa8a59$export$a8c9f8edf0911bff = (scriptURL, resolve, reject)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    script.id = $38952e24b2aa8a59$var$SCRIPT_ID;
    script.onerror = ()=>$38952e24b2aa8a59$export$c20f7df29b9552b6(reject);
    script.onload = ()=>$38952e24b2aa8a59$export$9b542085e8be8f80(resolve, reject);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    body === null || body === void 0 || body.appendChild(script);
};
const $38952e24b2aa8a59$export$57f8607478cbbab6 = ()=>{
    if (window.ROVO_WIDGET_REINIT) window.ROVO_WIDGET_REINIT();
};
const $38952e24b2aa8a59$export$7547b32d5aede92f = ({ siteId: siteId, widgetId: widgetId, surface: surface, locale: locale, onOpen: onOpen, onClose: onClose, brandPrimaryColor: brandPrimaryColor })=>{
    if (!$38952e24b2aa8a59$var$promise) $38952e24b2aa8a59$var$promise = new Promise((resolve, reject)=>{
        try {
            $38952e24b2aa8a59$export$2319c1f51535cb1c();
            $38952e24b2aa8a59$export$e0c468a317b25666(onOpen, onClose);
            // If SDK is already loaded (not a queue), resolve immediately
            if ($38952e24b2aa8a59$export$bb8c6503cfd42bb6()) {
                resolve(window.ROVO_WIDGET);
                return;
            }
            const scriptURL = $38952e24b2aa8a59$export$8e6c9489c906e450(siteId, widgetId, surface, locale, brandPrimaryColor);
            $38952e24b2aa8a59$export$a8c9f8edf0911bff(scriptURL, resolve, reject);
        } catch (error) {
            reject(error);
        }
    });
    return $38952e24b2aa8a59$var$promise;
};
const $38952e24b2aa8a59$export$8b3a5cba31576b8a = ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const scriptElement = document.getElementById($38952e24b2aa8a59$var$SCRIPT_ID);
    if (scriptElement) // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.body.removeChild(scriptElement);
    if (window.ROVO_WIDGET_CLEANUP) window.ROVO_WIDGET_CLEANUP();
    if (window.ROVO_WIDGET) delete window.ROVO_WIDGET;
    // Reset the tracking variables
    $38952e24b2aa8a59$var$promise = null;
};

});




parcelRegister("8b9fA", function(module, exports) {
$parcel$export(module.exports, "TOPIC_BASE_PATH", () => $155007729dcaf3be$export$fcfe7b179287e200);
$parcel$export(module.exports, "editTopicRoute", () => $155007729dcaf3be$export$60c0f814fe4b3a12);
$parcel$export(module.exports, "addTopicRoute", () => $155007729dcaf3be$export$9d8f7fd5bc61f52f);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $jcRK7 = parcelRequire("jcRK7");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");

var $ecxIc = parcelRequire("ecxIc");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");
parcelRequire("TdcAL");
var $57PyM = parcelRequire("57PyM");

var $1xzNy = parcelRequire("1xzNy");

var $2s72A = parcelRequire("2s72A");
const $155007729dcaf3be$export$fcfe7b179287e200 = `/topic`;
const $155007729dcaf3be$var$ADD_TOPIC_PATH = `${$155007729dcaf3be$export$fcfe7b179287e200}/add`;
const $155007729dcaf3be$var$EDIT_TOPIC_PATH = `${$155007729dcaf3be$export$fcfe7b179287e200}/edit/:id`;
const $155007729dcaf3be$export$7285959833dc0185 = (0, $fK3tS.default)((props)=>{
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: props.location.pathname
    }), (0, $ifEXU.default)({
        message: props.intl.formatMessage((0, $1xzNy.authPageMessage)),
        callToActionText: props.intl.formatMessage((0, $1xzNy.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $57PyM.default), {
            path: $155007729dcaf3be$var$EDIT_TOPIC_PATH,
            component: (0, $ecxIc.EditTopicPage),
            screenName: (0, $jcRK7.ScreenName).EDIT_TOPIC
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props);
});
const $155007729dcaf3be$export$60c0f814fe4b3a12 = {
    name: (0, $jcRK7.ScreenName).EDIT_TOPIC,
    path: $155007729dcaf3be$var$EDIT_TOPIC_PATH,
    exact: true,
    component: (0, $hbIgt.withRouter)($155007729dcaf3be$export$7285959833dc0185),
    resources: [
        (0, $2s72A.editTopicResource)
    ]
};
const $155007729dcaf3be$export$9d8f7fd5bc61f52f = {
    name: (0, $jcRK7.ScreenName).EDIT_TOPIC,
    path: $155007729dcaf3be$var$ADD_TOPIC_PATH,
    exact: true,
    component: (0, $hbIgt.withRouter)($155007729dcaf3be$export$7285959833dc0185),
    resources: [
        (0, $2s72A.editTopicResource)
    ]
};

});
parcelRegister("ecxIc", function(module, exports) {
$parcel$export(module.exports, "EditTopicPage", () => $eab9c84b7f8615e2$export$167706eed2563765);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

var $6fyou = parcelRequire("6fyou");

const $eab9c84b7f8615e2$export$167706eed2563765 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("eC2Xs")).then((module)=>{
            const { registerHelpObjectEpicsAndReducers: registerHelpObjectEpicsAndReducers } = module;
            registerHelpObjectEpicsAndReducers();
            return module.default;
        }), {
        moduleId: "./src/topics/src/ui/edit-topic/main.tsx"
    }),
    LoadingSkeleton: (0, $6fyou.EditTopicLoader)
});

});
parcelRegister("6fyou", function(module, exports) {
$parcel$export(module.exports, "EditTopicLoader", () => $56e445940adb5156$export$c00c0ab43fa4f914);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $i5HDF = parcelRequire("i5HDF");
var $hF8Ik = parcelRequire("hF8Ik");

var $9K7mZ = parcelRequire("9K7mZ");

var $gUpf2 = parcelRequire("gUpf2");

var $hDkm2 = parcelRequire("hDkm2");

var $1gMEu = parcelRequire("1gMEu");
const $56e445940adb5156$export$c00c0ab43fa4f914 = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, props.error ? /*#__PURE__*/ $bSJIT.createElement($56e445940adb5156$var$LoaderContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $bSJIT.createElement((0, $1gMEu.Container), null, /*#__PURE__*/ $bSJIT.createElement((0, $1gMEu.TopicContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingInline: "space.500"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $1gMEu.SpinnerWrapper), null, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
        size: 'medium'
    })))), /*#__PURE__*/ $bSJIT.createElement((0, $1gMEu.HelpObjectContainer), null, /*#__PURE__*/ $bSJIT.createElement($56e445940adb5156$var$Row, null, /*#__PURE__*/ $bSJIT.createElement((0, $hF8Ik.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $bSJIT.createElement($56e445940adb5156$var$Row, null, /*#__PURE__*/ $bSJIT.createElement((0, $hF8Ik.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $bSJIT.createElement($56e445940adb5156$var$Row, null, /*#__PURE__*/ $bSJIT.createElement((0, $hF8Ik.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })))));
};
const $56e445940adb5156$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $56e445940adb5156$var$LoaderContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16axg55-0"
})`min-height:${$56e445940adb5156$var$LOADER_MIN_HEIGHT};display:flex;align-items:center;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $56e445940adb5156$var$Row = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-16axg55-1"
})`margin-top:${"var(--ds-space-200, 16px)"};width:${$9K7mZ.multiple(50).px};`;

});
parcelRegister("1gMEu", function(module, exports) {
$parcel$export(module.exports, "Container", () => $c5725cac71f88753$export$42a852a2b6b56249);
$parcel$export(module.exports, "TopicContainer", () => $c5725cac71f88753$export$3906a519f454d518);
$parcel$export(module.exports, "HelpObjectContainer", () => $c5725cac71f88753$export$7e8e7bb92ce298ab);
$parcel$export(module.exports, "SpinnerWrapper", () => $c5725cac71f88753$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $fU62V = parcelRequire("fU62V");

var $hKa9R = parcelRequire("hKa9R");
const $c5725cac71f88753$var$topicContainerWidth = '70%';
const $c5725cac71f88753$var$topicContainerMinHeight = `calc(100vh - ${(0, $hKa9R.FOOTER_HEIGHT)}px)`;
const $c5725cac71f88753$var$helpObjectContainerWidth = '30%';
const $c5725cac71f88753$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-7u94c0-0"
})`display:flex;flex-wrap:wrap;justify-content:space-between;border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};`;
const $c5725cac71f88753$export$3906a519f454d518 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-7u94c0-1"
})`width:${$c5725cac71f88753$var$topicContainerWidth};padding:${"var(--ds-space-400, 32px)"} ${"var(--ds-space-1000, 80px)"};background-color:${"var(--ds-surface, #FFFFFF)"};border-right:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};box-sizing:border-box;min-height:${$c5725cac71f88753$var$topicContainerMinHeight};`;
const $c5725cac71f88753$export$7e8e7bb92ce298ab = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-7u94c0-2"
})`width:${$c5725cac71f88753$var$helpObjectContainerWidth};box-sizing:border-box;padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"};`;
const $c5725cac71f88753$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-7u94c0-3"
})`${$fU62V.flexCenter};margin-top:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("eC2Xs", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6AYIJ"),
    $kOunM("fXeMz"),
    $kOunM("itmHl"),
    $kOunM("1lfsI"),
    $kOunM("hklkk")
]).then(()=>parcelRequire('19PIk'));

});


parcelRegister("2s72A", function(module, exports) {
$parcel$export(module.exports, "editTopicResource", () => $33d1d6f2d7647520$export$414824bab2e11c29);

var $IaVWL = parcelRequire("IaVWL");

var $3LQyI = parcelRequire("3LQyI");
const $33d1d6f2d7647520$export$414824bab2e11c29 = (0, $3LQyI.createRelayResource)({
    type: 'EDIT_TOPIC',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $IaVWL.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});


parcelRegister("XiIOl", function(module, exports) {
$parcel$export(module.exports, "getEmbedCreateRequestRoute", () => $102ba9f156e9969e$export$ed25ec64c8131f29);
$parcel$export(module.exports, "embedSinglePortalRoute", () => $102ba9f156e9969e$export$f8f6af866fe5eb29);
$parcel$export(module.exports, "embedKBArticleRoute", () => $102ba9f156e9969e$export$50b320f40299497c);
$parcel$export(module.exports, "embedFeaturedPortalsRoute", () => $102ba9f156e9969e$export$89cf0aa4f08ce120);
$parcel$export(module.exports, "embedLoginSuccessRoute", () => $102ba9f156e9969e$export$a493105cf7e63414);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $jcRK7 = parcelRequire("jcRK7");

var $9K7mZ = parcelRequire("9K7mZ");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
var $hbIgt = parcelRequire("hbIgt");
parcelRequire("jWWjz");
var $6EkPI = parcelRequire("6EkPI");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");

var $irUsc = parcelRequire("irUsc");
const $102ba9f156e9969e$export$2e9e2f006c89796d = (WrappedComponent, screenName)=>{
    const ComponentWithEmbeddedPage = (props)=>{
        const [routerState] = (0, $h1bGI.useRouter)();
        const { basePath: basePath, ...routeContext } = routerState;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $irUsc.default), {
            screenName: screenName,
            screenId: routeContext.match.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d7jBU.default), {
            screenName: screenName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($102ba9f156e9969e$var$EmbedComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6EkPI.default), routeContext), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, {
            isEmbeddedRoute: true,
            ...routeContext,
            ...props
        }))));
    };
    return ComponentWithEmbeddedPage;
};

// Route for embeddable request create page
const $102ba9f156e9969e$var$AsyncEmbedCreateRequestPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("b8DMS")), {
        moduleId: "./src/view/request-create-page/embed-request-create-page/index.tsx"
    })
});
const $102ba9f156e9969e$export$ed25ec64c8131f29 = ()=>({
        name: 'embed-request-create',
        path: `/embeds/portal/:portalId/create/:requestTypeId`,
        exact: true,
        component: (0, $hbIgt.withRouter)($102ba9f156e9969e$export$2e9e2f006c89796d($102ba9f156e9969e$var$AsyncEmbedCreateRequestPage, (0, $jcRK7.ScreenName).EMBED_REQUEST_CREATE)),
        resources: []
    });

// Route for embeddable single portal page
const $102ba9f156e9969e$var$AsyncEmbedSinglePortalPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("coOYF")), {
        moduleId: "./src/view/help-center/help-center-content/embed-single-portal/index.tsx"
    })
});
const $102ba9f156e9969e$export$f8f6af866fe5eb29 = {
    name: 'embed-single-portal',
    path: `/embeds/portal/:portalId`,
    exact: true,
    component: (0, $hbIgt.withRouter)($102ba9f156e9969e$export$2e9e2f006c89796d($102ba9f156e9969e$var$AsyncEmbedSinglePortalPage, (0, $jcRK7.ScreenName).EMBED_SINGLE_PORTAL))
};

// Route for embeddable knowledge base article page
const $102ba9f156e9969e$var$AsyncEmbedKBArticlePage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("59aPd")), {
        moduleId: "./src/view/article/embed-kb-article/index.tsx"
    })
});
const $102ba9f156e9969e$export$50b320f40299497c = {
    name: 'embed-kb-article',
    path: `/embeds/portal/:portalId/:topic?/:categoryId?/:article/:articleId`,
    exact: true,
    component: (0, $hbIgt.withRouter)($102ba9f156e9969e$export$2e9e2f006c89796d($102ba9f156e9969e$var$AsyncEmbedKBArticlePage, (0, $jcRK7.ScreenName).EMBED_KB_ARTICLE))
};

// Route for embeddable featured portals page
const $102ba9f156e9969e$var$AsyncEmbedFeaturedPortalsPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("bzzKp")), {
        moduleId: "./src/view/help-center/embed-featured-portals/index.tsx"
    })
});
const $102ba9f156e9969e$export$89cf0aa4f08ce120 = {
    name: 'embed-featured-portals',
    path: `/embeds/portals`,
    exact: true,
    component: (0, $hbIgt.withRouter)($102ba9f156e9969e$export$2e9e2f006c89796d($102ba9f156e9969e$var$AsyncEmbedFeaturedPortalsPage, (0, $jcRK7.ScreenName).EMBED_FEATURED_PORTALS))
};

// Route for embedded login success page
const $102ba9f156e9969e$var$AsyncEmbedLoginSuccessPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("4SnFc")), {
        moduleId: "./src/view/login/embed-login-success/index.tsx"
    })
});
const $102ba9f156e9969e$export$a493105cf7e63414 = {
    name: 'embed-login-success',
    path: `/embeds/login-success`,
    exact: true,
    component: (0, $hbIgt.withRouter)($102ba9f156e9969e$export$2e9e2f006c89796d($102ba9f156e9969e$var$AsyncEmbedLoginSuccessPage, (0, $jcRK7.ScreenName).EMBED_LOGIN_SUCCESS))
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $102ba9f156e9969e$var$EmbedComponentWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-168unha-0"
})`display:flex;flex-direction:column;min-height:100%;border:${$9K7mZ.multiple(1 / 8).px} solid ${"var(--ds-border-bold, #EBECF0)"};border-radius:${$9K7mZ.multiple(3 / 8).px};box-sizing:border-box;`;

});
parcelRegister("b8DMS", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5eEzL").then(()=>parcelRequire('lwFds'));

});

parcelRegister("coOYF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("1hAtG"),
    $kOunM("jhjZ0")
]).then(()=>parcelRequire('ktya7'));

});

parcelRegister("59aPd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("h6bfX").then(()=>parcelRequire('kcDM6'));

});

parcelRegister("bzzKp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("aHc5N"),
    $kOunM("9AYtl")
]).then(()=>parcelRequire('k9oa1'));

});

parcelRegister("4SnFc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3LovC").then(()=>parcelRequire('BBNab'));

});


parcelRegister("ebTuA", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterRoute", () => $504945f0d7750cd8$export$4e7002b7e4a938bc);

var $jcRK7 = parcelRequire("jcRK7");

var $eLLBi = parcelRequire("eLLBi");
const $504945f0d7750cd8$export$4e7002b7e4a938bc = ()=>{
    const name = 'help-center';
    const path = '/portals';
    const screenName = (0, $jcRK7.ScreenName).HELP_CENTER;
    return (0, $eLLBi.getFlexiHelpCenterRoute)(name, path, screenName);
};

});

parcelRegister("4T2Ew", function(module, exports) {
$parcel$export(module.exports, "RenderArticlesSearchRoute", () => $db189524a0216dab$export$b8c7cf9fcb5a9882);
$parcel$export(module.exports, "viewKbPageRoute", () => $db189524a0216dab$export$7770cb0c6ff06b3a);
$parcel$export(module.exports, "viewAllSearchResultsRoute", () => $db189524a0216dab$export$b9392cfe93dd18c7);
$parcel$export(module.exports, "viewPortalAllSearchResultsRoute", () => $db189524a0216dab$export$ecf8460d0ec6e97);
$parcel$export(module.exports, "viewPortalKnowledgeCategoryRoute", () => $db189524a0216dab$export$4704dfed5640c7f);
$parcel$export(module.exports, "viewPortalCategoryArticleRoute", () => $db189524a0216dab$export$c875ec1eb313d3e6);
$parcel$export(module.exports, "viewPortalArticleRoute", () => $db189524a0216dab$export$ad9d4a1dd23783b4);
$parcel$export(module.exports, "viewArticleRoute", () => $db189524a0216dab$export$95b4792c2f78259d);
$parcel$export(module.exports, "viewCrossSitePortalArticleRoute", () => $db189524a0216dab$export$d549c8909c9cf794);
$parcel$export(module.exports, "viewCrossSiteArticleRoute", () => $db189524a0216dab$export$10ea759d4b0b4d21);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
var $hbIgt = parcelRequire("hbIgt");

var $hwUVn = parcelRequire("hwUVn");
parcelRequire("jWWjz");
var $6EkPI = parcelRequire("6EkPI");

var $88cbR = parcelRequire("88cbR");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");

var $irUsc = parcelRequire("irUsc");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");

const $db189524a0216dab$var$AllSearchResults = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1J9tQ")), {
        moduleId: "./packages/help-center/search/src/all-results/index.tsx"
    })
});
const $db189524a0216dab$var$RenderKnowledgeCategoryRoute = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
        screenName: (0, $jcRK7.ScreenName).KNOWLEDGE_CATEGORY,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $bSJIT.createElement((0, $d7jBU.default), {
        screenName: (0, $jcRK7.ScreenName).KNOWLEDGE_CATEGORY
    }, /*#__PURE__*/ $bSJIT.createElement((0, $88cbR.KnowledgeCategory), routeContext)));
};
const $db189524a0216dab$export$b8c7cf9fcb5a9882 = ()=>{
    const [routerState] = (0, $h1bGI.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
        screenName: (0, $jcRK7.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $bSJIT.createElement((0, $d7jBU.default), {
        screenName: (0, $jcRK7.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS
    }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $6EkPI.default), routeContext), /*#__PURE__*/ $bSJIT.createElement($db189524a0216dab$var$AllSearchResults, routeContext))));
};
const $db189524a0216dab$export$319de0a85a85b4cd = (isArticleView)=>{
    return isArticleView ? 'xxwide' : 'xwide';
};
const $db189524a0216dab$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $hwUVn.Article)
};
const $db189524a0216dab$var$portalKnowledgeCategory = {
    resources: [],
    name: 'view-portal-kb-category',
    path: `/portal/:portalId/topic/:categoryId`,
    exact: true,
    component: $db189524a0216dab$var$RenderKnowledgeCategoryRoute
};
const $db189524a0216dab$var$viewPortalCategoryArticle = {
    resources: [],
    name: 'view-portal-kb-category-article',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/topic/:categoryId/article/:articleId`,
    exact: true,
    component: (0, $hwUVn.Article)
};
const $db189524a0216dab$var$viewPortalArticle = {
    resources: [],
    name: 'view-portal-kb-article',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
    exact: true,
    component: (0, $hwUVn.Article)
};
const $db189524a0216dab$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $hwUVn.Article)
};
const $db189524a0216dab$var$viewCrossSitePortalArticle = {
    resources: [],
    name: 'view-portal-cross-site-kb-article',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $hwUVn.Article)
};
const $db189524a0216dab$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $hwUVn.Article)
};
const $db189524a0216dab$var$viewAllSearchResults = {
    resources: [],
    name: 'view-all-search-results',
    path: `/articles/search`,
    exact: true,
    component: $db189524a0216dab$var$AllSearchResults
};
const $db189524a0216dab$var$viewPortalAllSearchResults = {
    resources: [],
    name: 'view-portal-all-search-results',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/articles/search`,
    exact: true,
    component: $db189524a0216dab$var$AllSearchResults
};
const $db189524a0216dab$var$categoryLayoutProps = {
    paperAppearance: $db189524a0216dab$export$319de0a85a85b4cd(false),
    fadeInSearchModal: true
};
const $db189524a0216dab$var$layoutProps = {
    paperAppearance: $db189524a0216dab$export$319de0a85a85b4cd(true),
    fadeInSearchModal: true
};
const $db189524a0216dab$export$7770cb0c6ff06b3a = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$viewKbPage, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $db189524a0216dab$var$layoutProps);
const $db189524a0216dab$export$b9392cfe93dd18c7 = {
    ...$db189524a0216dab$var$viewAllSearchResults,
    component: (0, $hbIgt.withRouter)($db189524a0216dab$export$b8c7cf9fcb5a9882)
};
const $db189524a0216dab$export$ecf8460d0ec6e97 = {
    ...$db189524a0216dab$var$viewPortalAllSearchResults,
    component: (0, $hbIgt.withRouter)($db189524a0216dab$export$b8c7cf9fcb5a9882)
};
const $db189524a0216dab$export$4704dfed5640c7f = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$portalKnowledgeCategory, (0, $jcRK7.ScreenName).KNOWLEDGE_CATEGORY, $db189524a0216dab$var$categoryLayoutProps);
const $db189524a0216dab$export$c875ec1eb313d3e6 = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$viewPortalCategoryArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $db189524a0216dab$var$layoutProps);
const $db189524a0216dab$export$ad9d4a1dd23783b4 = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$viewPortalArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $db189524a0216dab$var$layoutProps);
const $db189524a0216dab$export$95b4792c2f78259d = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$viewArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $db189524a0216dab$var$layoutProps);
const $db189524a0216dab$export$d549c8909c9cf794 = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$viewCrossSitePortalArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $db189524a0216dab$var$layoutProps);
const $db189524a0216dab$export$10ea759d4b0b4d21 = (0, $bkEWh.createRouteWithLayout)($db189524a0216dab$var$viewCrossSiteArticle, (0, $jcRK7.ScreenName).KNOWLEDGE_ARTICLE, $db189524a0216dab$var$layoutProps);

});
parcelRegister("hwUVn", function(module, exports) {
$parcel$export(module.exports, "Article", () => $bf51014e4e12516a$export$89693000420c0acd);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $bf51014e4e12516a$export$89693000420c0acd = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("5sLyL")), {
        moduleId: "./src/view/article/hocs.tsx"
    })
});

});
parcelRegister("5sLyL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("aLfJb"),
    $kOunM("blxbr")
]).then(()=>parcelRequire('3S5Xd'));

});


parcelRegister("88cbR", function(module, exports) {
$parcel$export(module.exports, "KnowledgeCategory", () => $98254ac1df74ec8b$export$b0a220e8bdf61c72);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $dWiWC = parcelRequire("dWiWC");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("2QPVh");
var $3no4E = parcelRequire("3no4E");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $821h5 = parcelRequire("821h5");
const $98254ac1df74ec8b$var$mapStateToProps = (state, props)=>{
    let portalId;
    let categoryId;
    if (props.match.params) {
        portalId = Number(props.match.params.portalId);
        categoryId = props.match.params.categoryId;
    }
    const showRequestCreateButton = (0, $iWhHo.canCreateRequest)(state, portalId);
    const portal = (0, $iWhHo.getPortalOrError)(state, portalId);
    const portalName = (0, $iWhHo.getName)(state, portalId);
    const projectId = (0, $iWhHo.getProjectId)(state, portalId);
    const shouldFetchPortalOnMount = !portal;
    const portalLink = (0, $iWhHo.getPortalLink)(state, portalId);
    const categoryOrError = (0, $iWhHo.getCategory)(state, portalId, categoryId);
    const articlesOrError = (0, $3no4E.getArticles)(state, categoryId);
    const category = !!categoryOrError && 'name' in categoryOrError ? categoryOrError : undefined;
    // we show a different loading spinner specifically for articles,
    // this way we can still display the user the category information and the bread-crumbs as soon as we have that data
    const isArticlesLoading = !articlesOrError;
    const portalError = !!portal && 'error' in portal ? portal : undefined;
    const articleFetchError = !!articlesOrError && 'error' in articlesOrError ? articlesOrError : undefined;
    let error;
    if (!!portalError) error = portalError;
    // any errors that occur when fetching categories will be available in articleFetchError
    // as the two calls are combined on initial page load
    if (!!articleFetchError && !isArticlesLoading) error = articleFetchError;
    const isLoading = !portal;
    const articles = Array.isArray(articlesOrError) ? articlesOrError : undefined;
    return {
        portalId: portalId,
        categoryId: categoryId,
        projectId: projectId,
        category: category,
        articles: articles,
        portalName: portalName,
        isLoading: isLoading,
        isArticlesLoading: isArticlesLoading,
        shouldFetchPortalOnMount: shouldFetchPortalOnMount,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        error: error ? error.error : undefined
    };
};
const $98254ac1df74ec8b$export$b0a220e8bdf61c72 = (0, $f2mlD.default)($98254ac1df74ec8b$var$mapStateToProps, {
    fetchPortal: (0, $jeW3I.fetchPortalAction),
    fetchArticles: (0, $dWiWC.fetchArticlesAction)
})((0, $821h5.default));

});
parcelRegister("2QPVh", function(module, exports) {
$parcel$export(module.exports, "getArticle", () => (parcelRequire("3no4E")).getArticle);
$parcel$export(module.exports, "getArticles", () => (parcelRequire("3no4E")).getArticles);
$parcel$export(module.exports, "getArticleTitle", () => (parcelRequire("3no4E")).getArticleTitle);
parcelRequire("3no4E");

});
parcelRegister("3no4E", function(module, exports) {
$parcel$export(module.exports, "getArticles", () => $6a35fb568878c189$export$59baee6c0c5ecafe);
$parcel$export(module.exports, "getArticle", () => $6a35fb568878c189$export$f8c0d0a39b0d7d4e);
$parcel$export(module.exports, "getArticleTitle", () => $6a35fb568878c189$export$7aa4b20764201f2f);
const $6a35fb568878c189$export$59baee6c0c5ecafe = (state, categoryId)=>{
    if (!categoryId) return undefined;
    const articleState = state.persisted.kbArticles;
    if (articleState.articles[categoryId] && articleState.articles[categoryId].error) return articleState.articles[categoryId].error;
    return articleState.articles[categoryId] ? articleState.articles[categoryId].articles : undefined;
};
const $6a35fb568878c189$export$f8c0d0a39b0d7d4e = (state, id)=>!!id ? state.persisted.kbArticles.legacyArticles[id] : undefined;
const $6a35fb568878c189$export$7aa4b20764201f2f = (state, id)=>{
    const article = $6a35fb568878c189$export$f8c0d0a39b0d7d4e(state, id);
    if (!article || 'error' in article) return undefined;
    return article.title;
};

});


parcelRegister("821h5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9274ec2afafbf66e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2ERPT = parcelRequire("2ERPT");

var $fFr9c = parcelRequire("fFr9c");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("fK5uK");
var $9N3v2 = parcelRequire("9N3v2");
parcelRequire("2PyTf");
var $46bIy = parcelRequire("46bIy");
parcelRequire("cAJ8B");
var $aquFW = parcelRequire("aquFW");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $haAAx = parcelRequire("haAAx");
parcelRequire("dW0Ki");
var $6kb3b = parcelRequire("6kb3b");

var $iXVK3 = parcelRequire("iXVK3");
class $9274ec2afafbf66e$export$b0a220e8bdf61c72 extends $bSJIT.Component {
    componentDidMount() {
        const { shouldFetchPortalOnMount: shouldFetchPortalOnMount, fetchPortal: fetchPortal, fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        if (shouldFetchPortalOnMount && portalId) fetchPortal({
            id: portalId,
            expand: [
                'reqTypes',
                'reqGroups',
                'orderMapping',
                'kbs'
            ]
        });
        if (portalId && projectId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        const shouldFetchArticles = !prevProps.projectId && projectId;
        if (shouldFetchArticles && projectId && portalId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    renderInnerContent() {
        const { category: category, articles: articles, portalId: portalId, isArticlesLoading: isArticlesLoading, portalName: portalName, portalLink: portalLink, showRequestCreateButton: showRequestCreateButton } = this.props;
        if (!category || !portalId || !portalName) return null;
        const attributes = (articles || []).reduce((attr, article)=>({
                featured: attr.featured + (article.isFeatured ? 1 : 0),
                total: attr.total + 1
            }), {
            featured: 0,
            total: 0
        });
        return /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
            attributes: attributes
        }, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.PaperContent), null, /*#__PURE__*/ $bSJIT.createElement((0, $46bIy.default), {
            subHeading: category.name,
            description: category.description,
            portalId: portalId,
            categoryId: category.id
        }), /*#__PURE__*/ $bSJIT.createElement((0, $6kb3b.default), {
            portalLink: portalLink,
            portalId: portalId,
            portalName: portalName,
            categoryId: category.id,
            articles: articles,
            showRequestCreateButton: showRequestCreateButton,
            isLoading: isArticlesLoading
        })));
    }
    render() {
        const { category: category, portalName: portalName, intl: intl, isLoading: isLoading } = this.props;
        const pageTitle = category && portalName ? intl.formatMessage((0, $iXVK3.default).categoryDocumentTitle, {
            portalName: portalName,
            categoryName: category.name
        }) : undefined;
        return /*#__PURE__*/ $bSJIT.createElement((0, $2ERPT.default), {
            title: pageTitle
        }, /*#__PURE__*/ $bSJIT.createElement((0, $9N3v2.default), {
            isLoading: isLoading
        }, this.renderInnerContent()));
    }
    constructor(...args){
        super(...args), this.getFailureAnalyticsEvent = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'articlesFetch failed',
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE)
                })
            };
        };
    }
}
var $9274ec2afafbf66e$export$2e2bcd8739ae039 = (0, $fFr9c.withErrorPage)((0, $fK3tS.default)((0, $2usNr.default)({
    componentName: 'KbCategory'
})((0, $kIbto.default)()($9274ec2afafbf66e$export$b0a220e8bdf61c72))));

});
parcelRegister("fK5uK", function(module, exports) {
$parcel$export(module.exports, "LoadingContainer", () => (parcelRequire("9N3v2")).default);

var $9N3v2 = parcelRequire("9N3v2");

});
parcelRegister("9N3v2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb0e15c60fc4e79f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $i5HDF = parcelRequire("i5HDF");

var $1qPbZ = parcelRequire("1qPbZ");
class $bb0e15c60fc4e79f$export$2e2bcd8739ae039 extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, interactionName: interactionName, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const loader = /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.default), {
            isLoading: true,
            loadingPosition: loadingPosition,
            interactionName: interactionName
        });
        if (!isLoading) return children;
        return enableUFOHold ? /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
            name: ufoHoldName
        }, loader) : loader;
    }
}

});


parcelRegister("2PyTf", function(module, exports) {
$parcel$export(module.exports, "PaperHeader", () => (parcelRequire("46bIy")).default);

var $46bIy = parcelRequire("46bIy");

});
parcelRegister("46bIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dfbb85132ab6ab6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $acAb6 = parcelRequire("acAb6");
parcelRequire("as4xO");
var $aIOdk = parcelRequire("aIOdk");
parcelRequire("aib19");
var $7BQTL = parcelRequire("7BQTL");

var $j2kYn = parcelRequire("j2kYn");

var $7WQx2 = parcelRequire("7WQx2");

var $k4dp8 = parcelRequire("k4dp8");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
const $9dfbb85132ab6ab6$var$headerDescription = (description, dangerouslyAllowHtmlInDescription)=>dangerouslyAllowHtmlInDescription ? /*#__PURE__*/ $bSJIT.createElement((0, $j2kYn.Description), {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }) : /*#__PURE__*/ $bSJIT.createElement((0, $j2kYn.Description), null, description);
const $9dfbb85132ab6ab6$var$PaperHeader = ({ subHeading: subHeading, description: description, logoUrl: logoUrl, showRequestsInBreadcrumbs: showRequestsInBreadcrumbs, dangerouslyAllowHtmlInDescription: dangerouslyAllowHtmlInDescription, dataTestId: dataTestId, articleId: articleId, hideBreadcrumbs: hideBreadcrumbs = false, ...props })=>{
    const isCsmSupportSite = $bSJIT.useMemo(()=>(0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType), []);
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": dataTestId
    }, !hideBreadcrumbs && (articleId && isCsmSupportSite ? /*#__PURE__*/ $bSJIT.createElement($bSJIT.Suspense, {
        fallback: /*#__PURE__*/ $bSJIT.createElement((0, $aIOdk.default), {
            ...props,
            showRequests: showRequestsInBreadcrumbs
        })
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7BQTL.CsmBreadcrumbs), {
        articleId: articleId
    })) : /*#__PURE__*/ $bSJIT.createElement((0, $aIOdk.default), {
        ...props,
        showRequests: showRequestsInBreadcrumbs
    })), /*#__PURE__*/ $bSJIT.createElement((0, $j2kYn.SubHeadingContainer), null, !!logoUrl && /*#__PURE__*/ $bSJIT.createElement((0, $j2kYn.IconContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
        src: logoUrl,
        alt: ""
    })), /*#__PURE__*/ $bSJIT.createElement("div", null, /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
            size: "large",
            as: "h1"
        }, subHeading)
    }, /*#__PURE__*/ $bSJIT.createElement((0, $j2kYn.SubHeading), null, subHeading)))), !!description && $9dfbb85132ab6ab6$var$headerDescription(description, dangerouslyAllowHtmlInDescription));
};
var $9dfbb85132ab6ab6$export$2e2bcd8739ae039 = $9dfbb85132ab6ab6$var$PaperHeader;

});
parcelRegister("as4xO", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbs", () => (parcelRequire("aIOdk")).default);

var $aIOdk = parcelRequire("aIOdk");

});
parcelRegister("aIOdk", function(module, exports) {
$parcel$export(module.exports, "default", () => $280321a5be44578a$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $gQxPF = parcelRequire("gQxPF");
parcelRequire("lpgcJ");
var $8Wh6H = parcelRequire("8Wh6H");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("2QPVh");
var $3no4E = parcelRequire("3no4E");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $aYbXa = parcelRequire("aYbXa");
parcelRequire("fFudg");
var $3s967 = parcelRequire("3s967");
const $280321a5be44578a$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getSharedPortalName), (state, props)=>{
    return (0, $iWhHo.getName)(state, (0, $aYbXa.toNumber)(props.portalId)) ?? (0, $8Wh6H.getPortalNameFromBranding)(state);
}, (state, props)=>{
    const category = (0, $iWhHo.getCategory)(state, (0, $aYbXa.toNumber)(props.portalId), props.categoryId);
    return !!category && 'name' in category ? category.name : undefined;
}, (state, props)=>{
    return (0, $3no4E.getArticleTitle)(state, props.articleId);
}, (sharedPortalName, portalName, categoryName, articleTitle)=>({
        sharedPortalName: sharedPortalName,
        portalName: portalName,
        categoryName: categoryName,
        articleTitle: articleTitle
    }));
const $280321a5be44578a$export$5646050d516e06bc = (0, $f2mlD.default)($280321a5be44578a$var$selector)((0, $3s967.default));
var $280321a5be44578a$export$2e2bcd8739ae039 = (0, $gQxPF.default)($280321a5be44578a$export$5646050d516e06bc);

});
parcelRegister("lpgcJ", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => (parcelRequire("8Wh6H")).getPortalNameFromBranding);

var $8Wh6H = parcelRequire("8Wh6H");

});
parcelRegister("8Wh6H", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => $98a780138d3fad5b$export$b81ba060d3a3afb3);
const $98a780138d3fad5b$export$b81ba060d3a3afb3 = (state)=>{
    var _state$persisted$bran;
    if ((_state$persisted$bran = state.persisted.branding) !== null && _state$persisted$bran !== void 0 && _state$persisted$bran.name) return state.persisted.branding.name;
    return undefined;
};

});


parcelRegister("fFudg", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbsDumb", () => (parcelRequire("3s967")).default);

var $3s967 = parcelRequire("3s967");

});
parcelRegister("3s967", function(module, exports) {
$parcel$export(module.exports, "default", () => $55263a06e8582a30$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $3KPvu = parcelRequire("3KPvu");

var $fK3tS = parcelRequire("fK3tS");

var $5faG6 = parcelRequire("5faG6");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $oORS9 = parcelRequire("oORS9");

var $1xpJt = parcelRequire("1xpJt");
const $55263a06e8582a30$export$a1a3354a8b2c8731 = ({ sharedPortalName: sharedPortalName, portalName: portalName, categoryName: categoryName, articleTitle: articleTitle, portalId: portalId, categoryId: categoryId, articleId: articleId, showRequests: showRequests, intl: intl, requestKey: requestKey, requestUrl: requestUrl, additionalBreadCrumbs: additionalBreadCrumbs })=>{
    const requestCreateBreadcrumb = showRequests ? intl.formatMessage((0, $1xpJt.default).raiseRequestBreadcrumb) : undefined;
    const isCSM = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    return /*#__PURE__*/ $bSJIT.createElement((0, $5faG6.default), {
        label: intl.formatMessage((0, $1xpJt.default).breadcrumbsLabel)
    }, /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        to: (0, $oORS9.getHelpCenterUrl)(),
        name: !isCSM ? sharedPortalName : intl.formatMessage((0, $1xpJt.default).breadcrumbsHome),
        isFirstCrumb: true,
        actionSubjectId: "helpCenterBreadcrumb"
    }, !isCSM && portalId !== undefined && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        to: `/portal/${portalId}`,
        name: portalName,
        actionSubjectId: "portalBreadcrumb"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        to: requestUrl || '',
        name: requestKey,
        actionSubjectId: "requestBreadcrumb",
        testId: "requestKey"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        to: `/portal/${portalId}/group/-1`,
        name: requestCreateBreadcrumb,
        actionSubjectId: "requestCreateBreadcrumb"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}`,
        name: categoryName,
        actionSubjectId: "categoryBreadcrumb"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    }), additionalBreadCrumbs === null || additionalBreadCrumbs === void 0 ? void 0 : additionalBreadCrumbs.map((breadCrumb)=>breadCrumb)));
};
var $55263a06e8582a30$export$2e2bcd8739ae039 = (0, $fK3tS.default)($55263a06e8582a30$export$a1a3354a8b2c8731);

});
parcelRegister("3KPvu", function(module, exports) {
$parcel$export(module.exports, "default", () => $025dfeeea3d5b34f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $53Khx = parcelRequire("53Khx");

var $2OuWT = parcelRequire("2OuWT");

var $iP7Bl = parcelRequire("iP7Bl");

var $98sDU = parcelRequire("98sDU");

var $c6H7d = parcelRequire("c6H7d");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $k4dp8 = parcelRequire("k4dp8");
/**
 * This is a nestable bread crumb component, it will render the first component with a valid name.
 * It itself will also not render if the name is not valid.
 */ const $025dfeeea3d5b34f$var$BreadCrumbDumb = ({ name: name, to: to, children: children, isFirstCrumb: isFirstCrumb, actionSubjectId: actionSubjectId, testId: testId, tabIndex: tabIndex, onClick: onClick, disableTheme: disableTheme = false })=>{
    const isCSMTypographyMigrationEnabled = (0, $k4dp8.useIsCSMTypographyMigrationEnabled)();
    if (!name) return null;
    let child;
    $bSJIT.Children.forEach(children, (element)=>{
        // Short circuit if there is already a match
        if (child) return;
        if (element && /*#__PURE__*/ $bSJIT.isValidElement(element)) {
            const { name: childName } = element.props;
            if (childName) child = element;
        }
    });
    let linkComponent;
    if (to.startsWith('/')) {
        let RootLinkComponent = disableTheme ? $025dfeeea3d5b34f$var$RootLinkDisabledTheme : $025dfeeea3d5b34f$var$RootLink;
        if (isCSMTypographyMigrationEnabled) RootLinkComponent = disableTheme ? $025dfeeea3d5b34f$var$RootLinkDisabledTheme : $025dfeeea3d5b34f$var$RootLinkWithToken;
        linkComponent = /*#__PURE__*/ $bSJIT.createElement(RootLinkComponent, {
            to: to,
            actionSubjectId: actionSubjectId,
            "data-test-id": testId,
            "aria-current": child ? 'false' : 'page',
            tabIndex: tabIndex,
            onClick: onClick
        }, name);
    } else {
        let ExternalLinkComponent = disableTheme ? $025dfeeea3d5b34f$var$ExternalLinkDisabledTheme : $025dfeeea3d5b34f$var$ExternalLink;
        if (isCSMTypographyMigrationEnabled) ExternalLinkComponent = disableTheme ? $025dfeeea3d5b34f$var$ExternalLinkDisabledTheme : $025dfeeea3d5b34f$var$ExternalLinkWithToken;
        const externalLinkProps = {
            tabIndex: tabIndex,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            href: to,
            'data-test-id': testId,
            'aria-current': child ? 'false' : 'page'
        };
        linkComponent = /*#__PURE__*/ $bSJIT.createElement(ExternalLinkComponent, externalLinkProps, name);
    }
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        as: 'li',
        xcss: [
            $025dfeeea3d5b34f$var$breadCrumbContainer,
            isFirstCrumb ? undefined : $025dfeeea3d5b34f$var$breadCrumbSeparator
        ]
    }, linkComponent), child);
};
var $025dfeeea3d5b34f$export$2e2bcd8739ae039 = $025dfeeea3d5b34f$var$BreadCrumbDumb;
const $025dfeeea3d5b34f$var$breadCrumbContainer = (0, $9BVpB.xcss)({
    display: 'flex',
    listStyle: 'none',
    alignItems: 'center',
    margin: 'space.0'
});
const $025dfeeea3d5b34f$var$breadCrumbSeparator = (0, $9BVpB.xcss)({
    '::before': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: 'space.0',
        paddingInline: 'space.075',
        textAlign: 'center',
        lineHeight: '1.5em',
        color: 'color.text'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $025dfeeea3d5b34f$var$RootLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $c6H7d.default)).withConfig({
    componentId: "sc-1t2enhc-0"
})`${$98sDU.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $025dfeeea3d5b34f$var$RootLinkWithToken = /*#__PURE__*/ (0, $4v2A7.default)((0, $c6H7d.default)).withConfig({
    componentId: "sc-1t2enhc-1"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $025dfeeea3d5b34f$var$ExternalLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $iP7Bl.default)).withConfig({
    componentId: "sc-1t2enhc-2"
})`${$98sDU.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $025dfeeea3d5b34f$var$ExternalLinkWithToken = /*#__PURE__*/ (0, $4v2A7.default)((0, $iP7Bl.default)).withConfig({
    componentId: "sc-1t2enhc-3"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $025dfeeea3d5b34f$var$RootLinkDisabledTheme = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-1t2enhc-4"
})`margin:0;color:unset !important;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $025dfeeea3d5b34f$var$ExternalLinkDisabledTheme = /*#__PURE__*/ (0, $4v2A7.default)((0, $53Khx.HtmlAnchor)).withConfig({
    componentId: "sc-1t2enhc-5"
})`margin:0;color:unset !important;`;

});
parcelRegister("iP7Bl", function(module, exports) {
$parcel$export(module.exports, "default", () => $3695a89412f32cb2$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $53Khx = parcelRequire("53Khx");
const $3695a89412f32cb2$export$1d567c320f4763bc = /*#__PURE__*/ (0, $4v2A7.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3695a89412f32cb2$var$ExternalThemedLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $53Khx.HtmlAnchor)).withConfig({
    componentId: "sc-ckmeb1-0"
})`${$3695a89412f32cb2$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$3695a89412f32cb2$export$2e2bcd8739ae039 = $3695a89412f32cb2$var$ExternalThemedLink;

});


parcelRegister("5faG6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adfb626159b0843$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $c9wRy = parcelRequire("c9wRy");

var $fGbV9 = parcelRequire("fGbV9");

var $1OdZP = parcelRequire("1OdZP");

var $gdUUy = parcelRequire("gdUUy");

var $h7ygI = parcelRequire("h7ygI");

var $WJBS5 = parcelRequire("WJBS5");

var $1Stb0 = parcelRequire("1Stb0");

var $9giRl = parcelRequire("9giRl");

var $7ozWg = parcelRequire("7ozWg");

var $jKTrZ = parcelRequire("jKTrZ");
const $4adfb626159b0843$var$defaultMaxItems = 8;
const $4adfb626159b0843$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $4adfb626159b0843$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $4adfb626159b0843$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children;
const $4adfb626159b0843$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: undefined,
    packageVersion: undefined
};
const $4adfb626159b0843$var$noop = (0, $1OdZP.default);
const $4adfb626159b0843$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $4adfb626159b0843$var$breadcrumbStylesOld = null;
const $4adfb626159b0843$var$breadcrumbStylesNew = null;
const $4adfb626159b0843$var$navStylesNew = null;
const $4adfb626159b0843$var$ellipsisItemWrapperStyles = null;
// items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $4adfb626159b0843$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $4adfb626159b0843$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $h7ygI.default);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $4adfb626159b0843$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    if ((0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $dc70d.jsx)($4adfb626159b0843$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($4adfb626159b0843$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $4adfb626159b0843$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $4adfb626159b0843$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $4adfb626159b0843$var$noop, analyticsContext: analyticsContext, label: label = $4adfb626159b0843$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $4adfb626159b0843$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $bSJIT.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $bSJIT.useState)(false);
    const wrapperRef = (0, $bSJIT.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $4adfb626159b0843$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $bSJIT.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($4adfb626159b0843$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $7ozWg.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) {
                var _getDocument;
                setExpansionTrigger(event.target === ((_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement));
            }
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$4adfb626159b0843$var$analyticsAttributes
    });
    const childrenArray = $4adfb626159b0843$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $WJBS5.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1Stb0.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("nav", {
            "aria-label": label,
            ref: (0, $fGbV9.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $dc70d.jsx)("ol", {
                "data-testid": testId,
                className: (0, $9fU1q.default)([
                    "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
                ]),
                children: breadcrumbsItems
            })
        })
    });
});
const $4adfb626159b0843$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $4adfb626159b0843$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $4adfb626159b0843$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $jKTrZ.default)(itemCount);
    const handleOverflowExpansion = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: $4adfb626159b0843$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$4adfb626159b0843$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$4adfb626159b0843$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child, index)=>{
        const isCollapsed = collapsedIndices.has(index);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $dc70d.jsx)("li", {
                    className: (0, $9fU1q.default)([
                        "_1e0c1txw _vchhusvi _4cvr1h6o _2lx2vrvc _1o9zidpf _1wpz1h6o _1pfhze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1h6o _14rn1rpy _aetr1n76 _8yoa1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9giRl.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($4adfb626159b0843$var$cloneBreadcrumbChild(child, index, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child, index)=>$4adfb626159b0843$var$cloneBreadcrumbChild(child, index, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1Stb0.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _1mour5cr _195gr5cr _1rjc1b66 _18zr1b66 _1ul9idpf"
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)("ol", {
                "data-testid": testId,
                ref: registerContainer,
                className: (0, $9fU1q.default)([
                    "_1e0c1txw _1ul9idpf _4cvr1h6o _1n261q9c _2mzuglyw _6rthidpf _1pfhidpf _12l2idpf _ahbqidpf _85i5idpf _1q51idpf _y4tiidpf _bozgidpf"
                ]),
                children: naturalWidthsReady ? renderedItems : measureItems
            })
        })
    });
});
const $4adfb626159b0843$var$Breadcrumbs = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)($4adfb626159b0843$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    })));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4adfb626159b0843$export$2e2bcd8739ae039 = $4adfb626159b0843$var$Breadcrumbs;

});
parcelRegister("h7ygI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3b32acedc2f3467$export$2e2bcd8739ae039);
/* breadcrumbs-current-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /* breadcrumbs-current-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIUP1 = parcelRequire("kIUP1");

var $4TRbS = parcelRequire("4TRbS");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $1OdZP = parcelRequire("1OdZP");

var $gRfjb = parcelRequire("gRfjb");

var $gdUUy = parcelRequire("gdUUy");

var $bLXMw = parcelRequire("bLXMw");

var $lavtv = parcelRequire("lavtv");

var $7Lpt5 = parcelRequire("7Lpt5");

var $25dSh = parcelRequire("25dSh");
const $f3b32acedc2f3467$var$analyticsAttributes = {
    componentName: 'breadcrumbsCurrentItem',
    packageName: undefined,
    packageVersion: undefined
};
const $f3b32acedc2f3467$var$COPY_RESET_DELAY_MS = 2000;
const $f3b32acedc2f3467$var$ICON_WIDTH_ESTIMATE = 24;
const $f3b32acedc2f3467$var$unboundedStyles = {
    container: "_zulp1b66 _2rko12b0 _1rjcv77o _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k8s _1ql7kb7n",
    itemWrapper: "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
    copyButtonWrapper: "_1e0c116y _tzy4idpf _gwqekb7n _1mygkb7n",
    iconWrapper: "_syaz1cv2",
    iconWrapperSmall: "_w8l57vkz _17527vkz"
};
const $f3b32acedc2f3467$var$styles = {
    interactiveContainer: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8fhey _1e0c116y _4cvr1h6o _vchhusvi _syazi7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _9h8hi7uo",
    interactiveContainerMotion: "_v5641rrn _1hms8stv _4bfu1j28 _o7kshxmd _9oiki7uo _1ggl87vo _1nrmi7uo",
    interactiveContainerSmall: "_11c8wadc",
    interactiveContainerLegacy: "_4t3i1k8s",
    interactiveContainerWithTruncation: "_1ul9idpf _1o9zkb7n",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textSmall: "_11c8wadc _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $f3b32acedc2f3467$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $bSJIT.memo)(({ text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $7Lpt5.useBreadcrumbsSize)() === 'small';
    const handleClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onClick ?? (0, $1OdZP.default),
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$f3b32acedc2f3467$var$analyticsAttributes
    });
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $bSJIT.useState)(false);
    const [linkElement, setLinkElement] = (0, $bSJIT.useState)(null);
    const resetTimerRef = (0, $bSJIT.useRef)(null);
    const setLinkRef = (0, $bSJIT.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $25dSh.default)(truncationWidth, linkElement, (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $f3b32acedc2f3467$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $bSJIT.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink === null || onCopyLink === void 0 || onCopyLink();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $f3b32acedc2f3467$var$COPY_RESET_DELAY_MS);
        }, (0, $1OdZP.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $bSJIT.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $9fU1q.default)([
            $f3b32acedc2f3467$var$styles.iconWrapper,
            $f3b32acedc2f3467$var$unboundedStyles.iconWrapper,
            (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $f3b32acedc2f3467$var$styles.iconWrapperExternal,
            isSmall && $f3b32acedc2f3467$var$styles.iconWrapperExternalSmall,
            isSmall && $f3b32acedc2f3467$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const textElement = /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            isSmall && $f3b32acedc2f3467$var$styles.textSmall,
            !isSmall && $f3b32acedc2f3467$var$styles.text,
            truncationWidth && $f3b32acedc2f3467$var$styles.textWithTruncation
        ]),
        children: text
    });
    const renderLink = (triggerProps)=>{
        const tooltipRef = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref;
        const handleTriggerClick = (event)=>{
            var _triggerProps$onClick;
            triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            handleClick(event);
        };
        return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bLXMw.Anchor), {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
            "aria-current": "page",
            onClick: handleTriggerClick,
            onMouseOver: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver,
            onMouseOut: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut,
            onMouseMove: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove,
            onMouseDown: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown,
            onFocus: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus,
            onBlur: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur,
            "aria-describedby": triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby'],
            testId: testId,
            ref: tooltipRef ? (0, $fGbV9.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
            (0, $jDsoo.cx)($f3b32acedc2f3467$var$styles.interactiveContainer, !(0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $f3b32acedc2f3467$var$styles.interactiveContainerLegacy, isSmall && $f3b32acedc2f3467$var$styles.interactiveContainerSmall, truncationWidth != null && $f3b32acedc2f3467$var$styles.interactiveContainerWithTruncation, $f3b32acedc2f3467$var$styles.interactiveContainerMotion),
            style: {
                maxWidth: truncationWidth
            },
            children: [
                !(0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                textElement
            ]
        });
    };
    const copyButton = /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom",
        hasNewContentOnTriggerClick: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $9fU1q.default)([
                    $f3b32acedc2f3467$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))),
                    isTooltipDisabled: true,
                    label: copied ? 'Link copied' : 'Copy link',
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $9fU1q.default)([
            $f3b32acedc2f3467$var$unboundedStyles.itemWrapper
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
            className: (0, $9fU1q.default)([
                $f3b32acedc2f3467$var$unboundedStyles.container
            ]),
            children: [
                (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                shouldShowTooltip ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
                    content: text,
                    position: "bottom",
                    onShow: onTooltipShown,
                    children: renderLink
                }) : renderLink(),
                copyButton
            ]
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f3b32acedc2f3467$export$2e2bcd8739ae039 = $f3b32acedc2f3467$var$BreadcrumbsCurrentItem;

});
parcelRegister("gRfjb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2795fc1ebee30d2a3977d5783012a5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c45d7886c8b2a0c8$var$_react = $c45d7886c8b2a0c8$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c45d7886c8b2a0c8$var$_iconNew = $c45d7886c8b2a0c8$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c45d7886c8b2a0c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link
 * Usage guidance:
 * Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c45d7886c8b2a0c8$var$LinkIcon = (props)=>/*#__PURE__*/ $c45d7886c8b2a0c8$var$_react.default.createElement($c45d7886c8b2a0c8$var$_iconNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$c45d7886c8b2a0c8$var$LinkIcon.displayName = 'LinkIcon';
var $c45d7886c8b2a0c8$var$_default = module.exports.default = $c45d7886c8b2a0c8$var$LinkIcon;

});

parcelRegister("7Lpt5", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbsSize", () => $bacfa81465675d6e$export$c60a2bbc99661fa2);

var $bSJIT = parcelRequire("bSJIT");

var $6Exb4 = parcelRequire("6Exb4");
function $bacfa81465675d6e$export$c60a2bbc99661fa2() {
    return (0, $bSJIT.useContext)((0, $6Exb4.default));
}

});
parcelRegister("6Exb4", function(module, exports) {
$parcel$export(module.exports, "default", () => $be3defcfa6440105$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $be3defcfa6440105$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $bSJIT.createContext)('medium');
var $be3defcfa6440105$export$2e2bcd8739ae039 = $be3defcfa6440105$var$BreadcrumbsSizeContext;

});


parcelRegister("25dSh", function(module, exports) {
$parcel$export(module.exports, "default", () => $91faa12673f9136c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $91faa12673f9136c$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $bSJIT.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $bSJIT.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $bSJIT.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("WJBS5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bd1f5baa7ac5df8$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ellipsis-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jDsoo = parcelRequire("jDsoo");

var $1OdZP = parcelRequire("1OdZP");

var $gXqq0 = parcelRequire("gXqq0");

var $7Lpt5 = parcelRequire("7Lpt5");
const $3bd1f5baa7ac5df8$var$noop = (0, $1OdZP.default);
const $3bd1f5baa7ac5df8$var$itemWrapperStyles = null;
const $3bd1f5baa7ac5df8$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1wpz1h6o _1pfhze3t _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    interactiveMotion: "_v564hxmd _1hms8stv _4bfu1j28 _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo"
};
const $3bd1f5baa7ac5df8$var$EllipsisItem = /*#__PURE__*/ (0, $bSJIT.memo)(({ label: label, onClick: onClick = $3bd1f5baa7ac5df8$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $7Lpt5.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ (0, $dc70d.jsx)("li", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
            "aria-label": label,
            onClick: onClick,
            xcss: (0, $jDsoo.cx)($3bd1f5baa7ac5df8$var$styles.root, isSmall && $3bd1f5baa7ac5df8$var$styles.rootSmall, $3bd1f5baa7ac5df8$var$styles.interactiveMotion),
            testId: testId,
            children: "\u2026"
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bd1f5baa7ac5df8$export$2e2bcd8739ae039 = $3bd1f5baa7ac5df8$var$EllipsisItem;

});

parcelRegister("1Stb0", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbsSizeProvider", () => $32446b2764566f31$export$2295e777093f3940);

var $6Exb4 = parcelRequire("6Exb4");
const $32446b2764566f31$export$2295e777093f3940 = (0, $6Exb4.default).Provider;

});

parcelRegister("9giRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $066fd05067bc61a8$export$2e2bcd8739ae039);
/* ellipsis-popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4TRbS = parcelRequire("4TRbS");

var $lkSXl = parcelRequire("lkSXl");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $iabGk = parcelRequire("iabGk");
const $066fd05067bc61a8$var$groupWrapperStyles = null;
function $066fd05067bc61a8$export$2e2bcd8739ae039({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lkSXl.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                var _triggerProps$onClick;
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                onClick === null || onClick === void 0 || onClick(event);
            };
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iabGk))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start",
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            className: (0, $9fU1q.default)([
                "_p12f1y37"
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ljPIj.default), {
                children: collapsedItems.map((item, i)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $ag7mU.default), {
                        href: item.href,
                        target: item.target,
                        onClick: item.onClick,
                        children: item.text
                    }, i))
            })
        })
    });
}

});
parcelRegister("lkSXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $61e2f5bc7b73d1a8$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $jNJGJ = parcelRequire("jNJGJ");

var $gL5sM = parcelRequire("gL5sM");

var $fGbV9 = parcelRequire("fGbV9");

var $1OdZP = parcelRequire("1OdZP");

var $bHzUe = parcelRequire("bHzUe");

var $2lBlP = parcelRequire("2lBlP");

var $4GWyU = parcelRequire("4GWyU");

var $g6jWc = parcelRequire("g6jWc");

var $gdUUy = parcelRequire("gdUUy");

var $26Jy2 = parcelRequire("26Jy2");

var $juI4y = parcelRequire("juI4y");

var $kMVbX = parcelRequire("kMVbX");

var $krDWf = parcelRequire("krDWf");

var $6EObc = parcelRequire("6EObc");

var $5Qq79 = parcelRequire("5Qq79");

var $9aT6A = parcelRequire("9aT6A");

var $bh1Ma = parcelRequire("bh1Ma");
const $61e2f5bc7b73d1a8$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $61e2f5bc7b73d1a8$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $61e2f5bc7b73d1a8$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$61e2f5bc7b73d1a8$var$opposites[crossAxis]}`,
            `${$61e2f5bc7b73d1a8$var$opposites[mainAxis]}-${crossAxis}`,
            `${$61e2f5bc7b73d1a8$var$opposites[mainAxis]}`,
            `${$61e2f5bc7b73d1a8$var$opposites[mainAxis]}-${$61e2f5bc7b73d1a8$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$61e2f5bc7b73d1a8$var$opposites[mainAxis]}`,
        `${$61e2f5bc7b73d1a8$var$opposites[mainAxis]}-start`,
        `${$61e2f5bc7b73d1a8$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $61e2f5bc7b73d1a8$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $61e2f5bc7b73d1a8$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $1OdZP.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $juI4y.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $bHzUe.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $bSJIT.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $bSJIT.useState)(false);
    const id = (0, $bh1Ma.default)();
    const itemRef = (0, $9aT6A.default)();
    const { currentLevel: currentLevel } = (0, $g6jWc.useLayering)();
    const fallbackPlacements = (0, $bSJIT.useMemo)(()=>$61e2f5bc7b73d1a8$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $bSJIT.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $bSJIT.useCallback)((event, currentLevel)=>{
        var _event$target$closest, _event$target;
        const isTabLeftOrEscapeKey = $61e2f5bc7b73d1a8$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $gL5sM.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $61e2f5bc7b73d1a8$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $gL5sM.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, `[id^=${(0, $bh1Ma.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $bh1Ma.PREFIX)}] [aria-haspopup="true"]`)) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($61e2f5bc7b73d1a8$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $gL5sM.KEY_LEFT))) requestAnimationFrame(()=>{
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $2lBlP.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $bSJIT.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $1OdZP.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $1OdZP.default;
        return (0, $bAB3U.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $bh1Ma.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $bh1Ma.PREFIX)}] [aria-haspopup="true"]`);
                if (e.key === (0, $gL5sM.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $gL5sM.KEY_SPACE) || e.key === (0, $gL5sM.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $gL5sM.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Qq79.default), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $26Jy2.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $fGbV9.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                    ...bindFocus,
                    ref: (0, $fGbV9.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            // Legacy only. Run time passes the setter for every role; the types hide it.
            // The cast goes at the flag cleanup.
            content: (contentProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $krDWf.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6EObc.default), {
                        spacing: spacing,
                        maxHeight: $61e2f5bc7b73d1a8$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: contentProps.update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? contentProps.setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $61e2f5bc7b73d1a8$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpen, onOpenChange: onOpenChange = (0, $1OdZP.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $gdUUy.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kMVbX.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $dc70d.jsx)($61e2f5bc7b73d1a8$var$DropdownMenuLegacy, {
        ...props
    });
};
var $61e2f5bc7b73d1a8$export$2e2bcd8739ae039 = $61e2f5bc7b73d1a8$var$DropdownMenu;

});
parcelRegister("bHzUe", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbb68c004a5ce256$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $dbb68c004a5ce256$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $bSJIT.useState)(getDefaultPropValue);
    const isControlledRef = (0, $bSJIT.useRef)(isControlled);
    (0, $bSJIT.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $bSJIT.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("2lBlP", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc0e1c2f2c0d5c1c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $dc0e1c2f2c0d5c1c$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $bSJIT.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $bSJIT.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $bSJIT.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("kMVbX", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ab0341a33c7485$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $bAB3U = parcelRequire("bAB3U");

var $jNJGJ = parcelRequire("jNJGJ");

var $gL5sM = parcelRequire("gL5sM");

var $1OdZP = parcelRequire("1OdZP");

var $bHzUe = parcelRequire("bHzUe");

var $2lBlP = parcelRequire("2lBlP");

var $4GWyU = parcelRequire("4GWyU");

var $65Fe1 = parcelRequire("65Fe1");

var $hDkm2 = parcelRequire("hDkm2");

var $sGuds = parcelRequire("sGuds");

var $39A4U = parcelRequire("39A4U");

var $65Dj6 = parcelRequire("65Dj6");

var $gCNJX = parcelRequire("gCNJX");

var $jfBg8 = parcelRequire("jfBg8");

var $7nmZk = parcelRequire("7nmZk");

var $8cScX = parcelRequire("8cScX");

var $jFqOs = parcelRequire("jFqOs");

var $5Qq79 = parcelRequire("5Qq79");
const $64ab0341a33c7485$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $64ab0341a33c7485$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
function $64ab0341a33c7485$var$getRootMenuPopover({ menu: menu }) {
    var _menu$parentElement;
    const parentMenu = (_menu$parentElement = menu.parentElement) === null || _menu$parentElement === void 0 ? void 0 : _menu$parentElement.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $64ab0341a33c7485$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $64ab0341a33c7485$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "menuitem",
        className: (0, $9fU1q.default)([
            $64ab0341a33c7485$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $64ab0341a33c7485$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $1OdZP.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $bHzUe.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $bSJIT.useRef)(null);
    const popoverRef = (0, $bSJIT.useRef)(null);
    const setPopoverRef = (0, $bSJIT.useCallback)((element)=>{
        popoverRef.current = element;
        // Leave untouched menus without a busy state; retain false once it has been set.
        if (isLoading !== undefined || element !== null && element !== void 0 && element.hasAttribute('aria-busy')) element === null || element === void 0 || element.setAttribute('aria-busy', String(Boolean(isLoading)));
    }, [
        isLoading
    ]);
    const popoverId = (0, $jFqOs.usePopoverId)();
    const topLayerPlacement = (0, $bSJIT.useMemo)(()=>(0, $65Dj6.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $7nmZk.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $bSJIT.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    const handleTriggerClicked = (0, $bSJIT.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $2lBlP.default)();
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $bSJIT.useEffect)(()=>{
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]'));
        return (0, $bAB3U.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $gL5sM.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $bSJIT.useCallback)(({ trigger: trigger })=>{
        if (!trigger.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger.click();
    }, []);
    const handleTabClose = (0, $bSJIT.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $64ab0341a33c7485$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $8cScX.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $39A4U.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $bSJIT.useCallback)((e)=>{
        var _e$target$closest, _e$target;
        if (!(e.target instanceof Element)) return;
        const menuItem = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $sGuds.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ const setTriggerRef = (0, $bSJIT.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...ariaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...ariaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $5Qq79.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $jfBg8.Popover), {
                ref: setPopoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gCNJX.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $65Fe1.default), {
                        maxHeight: $64ab0341a33c7485$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $dc70d.jsx)($64ab0341a33c7485$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
var $64ab0341a33c7485$export$2e2bcd8739ae039 = $64ab0341a33c7485$var$DropdownMenuTopLayer;

});
parcelRegister("39A4U", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $a0a76169c4b2b927$export$f1bba0ef464d60af);
const $a0a76169c4b2b927$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $a0a76169c4b2b927$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $a0a76169c4b2b927$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $a0a76169c4b2b927$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($a0a76169c4b2b927$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $a0a76169c4b2b927$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("8cScX", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $aa680ec38483cf33$export$23dfbae28e0cc453);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $gL5sM = parcelRequire("gL5sM");

var $ehZai = parcelRequire("ehZai");

var $eeNWO = parcelRequire("eeNWO");

var $leCCk = parcelRequire("leCCk");
const $aa680ec38483cf33$var$menuScope = '[role="menu"]';
function $aa680ec38483cf33$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $bSJIT.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = container.ownerDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($aa680ec38483cf33$var$menuScope) !== container) return;
        }
        if (event.key === (0, $gL5sM.KEY_DOWN)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $leCCk.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $gL5sM.KEY_UP)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $leCCk.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $gL5sM.KEY_HOME)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $ehZai.getFirstFocusable)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $gL5sM.KEY_END)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $eeNWO.getLastFocusable)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $gL5sM.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                var _container$parentElem;
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = Boolean((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($aa680ec38483cf33$var$menuScope));
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $bAB3U.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("5Qq79", function(module, exports) {
$parcel$export(module.exports, "default", () => $0415558343f8fe4d$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hpNPg = parcelRequire("hpNPg");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $0415558343f8fe4d$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $bSJIT.useRef)({});
    const context = (0, $bSJIT.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hpNPg.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $0415558343f8fe4d$export$2e2bcd8739ae039 = $0415558343f8fe4d$var$SelectionStore;

});
parcelRegister("hpNPg", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $982229a6d80645a8$export$756f795847463ebd);

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");
const $982229a6d80645a8$export$756f795847463ebd = /*#__PURE__*/ (0, $bSJIT.createContext)({
    setItemState: (0, $1OdZP.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $1OdZP.default),
    getGroupState: ()=>({})
});

});



parcelRegister("krDWf", function(module, exports) {
$parcel$export(module.exports, "default", () => $783f75d814412289$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $g6jWc = parcelRequire("g6jWc");

var $1HvsO = parcelRequire("1HvsO");

var $2bZML = parcelRequire("2bZML");
/**
 * Focus manager logic.
 */ const $783f75d814412289$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $bSJIT.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $bSJIT.useState)(0);
    const registerMode = (0, $bSJIT.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $bSJIT.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $g6jWc.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $bSJIT.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $bSJIT.useEffect)(()=>(0, $bAB3U.bind)(window, {
            type: 'keydown',
            listener: (0, $1HvsO.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2bZML.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $783f75d814412289$export$2e2bcd8739ae039 = $783f75d814412289$var$FocusManager;

});
parcelRegister("1HvsO", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbee29eb3579cb99$export$2e2bcd8739ae039);

var $gL5sM = parcelRequire("gL5sM");

var $gdUUy = parcelRequire("gdUUy");

var $bh1Ma = parcelRequire("bh1Ma");
const $fbee29eb3579cb99$var$actionMap = {
    [(0, $gL5sM.KEY_DOWN)]: 'next',
    [(0, $gL5sM.KEY_UP)]: 'prev',
    [(0, $gL5sM.KEY_HOME)]: 'first',
    [(0, $gL5sM.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $fbee29eb3579cb99$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $fbee29eb3579cb99$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $fbee29eb3579cb99$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>{
            var _document$activeEleme;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $gdUUy.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest(`[id^=${(0, $bh1Ma.PREFIX)}]`));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $gL5sM.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $gL5sM.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $gL5sM.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $gL5sM.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $fbee29eb3579cb99$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $fbee29eb3579cb99$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $fbee29eb3579cb99$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $fbee29eb3579cb99$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $fbee29eb3579cb99$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("bh1Ma", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $d86e0e1e9255d1ae$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $d86e0e1e9255d1ae$export$2e2bcd8739ae039);

var $d6mTg = parcelRequire("d6mTg");
const $d86e0e1e9255d1ae$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $d86e0e1e9255d1ae$export$2e2bcd8739ae039() {
    const id = (0, $d6mTg.useId)();
    return `${$d86e0e1e9255d1ae$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("2bZML", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $d917b11d3b77f5ed$export$f18c1d4fc7326096);

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");
const $d917b11d3b77f5ed$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    menuItemRefs: [],
    registerRef: (0, $1OdZP.default)
});

});


parcelRegister("6EObc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c76c48470a350ca8$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $65Fe1 = parcelRequire("65Fe1");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $hDkm2 = parcelRequire("hDkm2");

var $1wpHw = parcelRequire("1wpHw");

var $f3XHv = parcelRequire("f3XHv");

var $2bZML = parcelRequire("2bZML");
const $c76c48470a350ca8$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $c76c48470a350ca8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $c76c48470a350ca8$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $c76c48470a350ca8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $bSJIT.useContext)((0, $2bZML.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $1wpHw.default)(menuItem) || (0, $f3XHv.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $bSJIT.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $gdUUy.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $65Fe1.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $dc70d.jsx)($c76c48470a350ca8$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $c76c48470a350ca8$export$2e2bcd8739ae039 = $c76c48470a350ca8$var$MenuWrapper;

});
parcelRegister("1wpHw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e32057871402d58b$export$2e2bcd8739ae039);
function $e32057871402d58b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("f3XHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d87322b418f8009c$export$2e2bcd8739ae039);
function $d87322b418f8009c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("9aT6A", function(module, exports) {
$parcel$export(module.exports, "default", () => $90bd2592e94798c5$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $2bZML = parcelRequire("2bZML");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $90bd2592e94798c5$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $bSJIT.useContext)((0, $2bZML.FocusManagerContext));
    const itemRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (hasPopup && (0, $gdUUy.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $90bd2592e94798c5$export$2e2bcd8739ae039 = $90bd2592e94798c5$var$useRegisterItemWithFocusManager;

});


parcelRegister("ag7mU", function(module, exports) {
$parcel$export(module.exports, "default", () => $af4672d1dde15edb$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fGbV9 = parcelRequire("fGbV9");

var $kpgiw = parcelRequire("kpgiw");

var $cjQhO = parcelRequire("cjQhO");

var $682kQ = parcelRequire("682kQ");

var $gdUUy = parcelRequire("gdUUy");

var $9aT6A = parcelRequire("9aT6A");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $af4672d1dde15edb$var$DropdownMenuItem = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog';
    const itemRef = (0, $9aT6A.default)(isNestedTrigger);
    const handleItemClick = (0, $bSJIT.useCallback)((event)=>{
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cjQhO.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fGbV9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $682kQ.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fGbV9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kpgiw.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fGbV9.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $gdUUy.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $af4672d1dde15edb$export$2e2bcd8739ae039 = $af4672d1dde15edb$var$DropdownMenuItem;

});

parcelRegister("ljPIj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8594f97be90f033$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $d6mTg = parcelRequire("d6mTg");

var $7LtMZ = parcelRequire("7LtMZ");

var $g6gl3 = parcelRequire("g6gl3");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $b8594f97be90f033$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $d6mTg.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7LtMZ.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $dc70d.jsx)((0, $g6gl3.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $b8594f97be90f033$export$2e2bcd8739ae039 = $b8594f97be90f033$var$DropdownMenuItemGroup;

});
parcelRegister("g6gl3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ba9d6ae5e0adbe$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $d0ba9d6ae5e0adbe$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $d0ba9d6ae5e0adbe$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $d0ba9d6ae5e0adbe$var$styles.heading,
        children: title
    });
var $d0ba9d6ae5e0adbe$export$2e2bcd8739ae039 = $d0ba9d6ae5e0adbe$var$GroupTitle;

});


parcelRegister("iabGk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb9e6baa42be79f49a55523cb2c1b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d39238ee31a478e5$var$_react = $d39238ee31a478e5$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d39238ee31a478e5$var$_iconNew = $d39238ee31a478e5$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d39238ee31a478e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d39238ee31a478e5$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $d39238ee31a478e5$var$_react.default.createElement($d39238ee31a478e5$var$_iconNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$d39238ee31a478e5$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $d39238ee31a478e5$var$_default = module.exports.default = $d39238ee31a478e5$var$ShowMoreHorizontalIcon;

});


parcelRegister("7ozWg", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", () => $e1622fde441ce8fb$export$e9c4922b2ecf808a);

var $bSJIT = parcelRequire("bSJIT");

var $4Qo4I = parcelRequire("4Qo4I");
function $e1622fde441ce8fb$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $4Qo4I.default)(isExpanded);
    (0, $bSJIT.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});

parcelRegister("jKTrZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb9a5b3894fd99c5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $bb9a5b3894fd99c5$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $bb9a5b3894fd99c5$var$useLayoutEffect = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
function $bb9a5b3894fd99c5$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $bb9a5b3894fd99c5$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $bb9a5b3894fd99c5$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $bSJIT.useRef)([]);
    const containerRef = (0, $bSJIT.useRef)(null);
    const naturalWidths = (0, $bSJIT.useRef)([]);
    const naturalWidthsReady = (0, $bSJIT.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $bSJIT.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $bSJIT.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $bb9a5b3894fd99c5$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>(el === null || el === void 0 ? void 0 : el.offsetWidth) ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $bSJIT.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $bb9a5b3894fd99c5$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $bb9a5b3894fd99c5$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$bb9a5b3894fd99c5$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $bSJIT.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $bSJIT.useRef)(null);
    const registerContainer = (0, $bSJIT.useCallback)((el)=>{
        var _observerRef$current;
        // Disconnect any existing observer
        (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            var _observerRef$current2;
            (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 || _observerRef$current2.disconnect();
        };
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});


parcelRegister("1xpJt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8027876eb9d3f954$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $8027876eb9d3f954$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    breadcrumbsLabel: {
        id: 'cv.portal.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'The accessible label for the breadcrumb navigation container shown at the top of the portal page.'
    },
    raiseRequestBreadcrumb: {
        defaultMessage: 'Raise a request',
        description: 'Breadcrumb item to go to select a request group of a portal',
        id: 'cv.portal.breadcrumbs.raise.request'
    },
    breadcrumbsHome: {
        defaultMessage: 'Home',
        description: 'Generic label for the first entry of the breadcrumbs for Service hub',
        id: 'cv.portal.breadcrumbs.home'
    }
});

});





parcelRegister("aib19", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbs", () => (parcelRequire("7BQTL")).CsmBreadcrumbs);
parcelRequire("kzsSo");
var $8zB70 = parcelRequire("8zB70");

var $7BQTL = parcelRequire("7BQTL");

});
parcelRegister("kzsSo", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbsInner", () => (parcelRequire("8zB70")).CsmBreadcrumbsInner);

var $8zB70 = parcelRequire("8zB70");

});
parcelRegister("8zB70", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbsInner", () => $a4d43f6c3dd89192$export$139cc1264c7dcd05);

var $c92EI = parcelRequire("c92EI");

var $bSJIT = parcelRequire("bSJIT");

var $3KPvu = parcelRequire("3KPvu");

var $fuVmc = parcelRequire("fuVmc");

var $5faG6 = parcelRequire("5faG6");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
const $a4d43f6c3dd89192$var$breadcrumbsLabel = (0, $f0Pt4.defineMessage)({
    defaultMessage: 'Breadcrumbs',
    id: 'help-center.csm-breadcrumbs.breadcrumbs-label',
    description: 'Aria label for the CSM breadcrumb navigation'
});
const $a4d43f6c3dd89192$var$breadcrumbsHome = (0, $f0Pt4.defineMessage)({
    defaultMessage: 'Home',
    id: 'help-center.csm-breadcrumbs.breadcrumbs-home',
    description: 'Home breadcrumb label for the CSM breadcrumb navigation'
});
const $a4d43f6c3dd89192$export$139cc1264c7dcd05 = ({ articleId: articleId, articleTitle: articleTitle, homeUrl: homeUrl = '/' })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $c92EI.default), {
        articleId: articleId,
        cloudId: (0, $fuVmc.getCloudId)(),
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)()
    });
    const ancestors = ((_data$helpObjectStore = data.helpObjectStore_searchArticlesForSupportSite) === null || _data$helpObjectStore === void 0 || (_data$helpObjectStore = _data$helpObjectStore.nodes) === null || _data$helpObjectStore === void 0 || (_data$helpObjectStore = _data$helpObjectStore[0]) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.ancestors) ?? [];
    // Skip the first ancestor (index 0) — it is a top-level category/space root not relevant to the page trail
    const pageAncestors = ancestors.filter((_, index)=>index !== 0);
    const currentArticleCrumb = /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        to: `/article/${articleId}`,
        name: articleTitle ?? '',
        actionSubjectId: "articleAncestorCurrentArticleBreadcrumb"
    });
    const ancestorChain = pageAncestors.reduceRight((innerChild, ancestor)=>/*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
            key: ancestor.id,
            to: ancestor.type === 'PAGE' ? `/article/${ancestor.id}` : `/folder/${ancestor.id}`,
            name: ancestor.title ?? '',
            actionSubjectId: `articleAncestorBreadcrumb-${ancestor.id}`
        }, innerChild), currentArticleCrumb);
    return /*#__PURE__*/ $bSJIT.createElement((0, $5faG6.default), {
        label: formatMessage($a4d43f6c3dd89192$var$breadcrumbsLabel)
    }, /*#__PURE__*/ $bSJIT.createElement((0, $3KPvu.default), {
        to: homeUrl,
        name: formatMessage($a4d43f6c3dd89192$var$breadcrumbsHome),
        isFirstCrumb: true,
        actionSubjectId: "articleAncestorHomeBreadcrumb"
    }, ancestorChain));
};
var $a4d43f6c3dd89192$export$2e2bcd8739ae039 = $a4d43f6c3dd89192$export$139cc1264c7dcd05;

});
parcelRegister("c92EI", function(module, exports) {
$parcel$export(module.exports, "default", () => $70a70115d90f3808$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae90646d5a8444c8bd4510deafb15985>>
 * @relayHash b26d74a977afd1c1cb5201fbf9d16e1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d96953a486fcf90f51cbf1e9f655d2bcde0beb3d2d3cb5f7d32043794748f110
const $70a70115d90f3808$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "articleId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "articleIds.0",
                            "variableName": "articleId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "articleIds"
                },
                {
                    "kind": "Literal",
                    "name": "expand",
                    "value": [
                        "ANCESTORS"
                    ]
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ ,
            {
                "concreteType": "HelpObjectStoreArticleRelative",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmBreadcrumbsInnerQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmBreadcrumbsInnerQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d96953a486fcf90f51cbf1e9f655d2bcde0beb3d2d3cb5f7d32043794748f110",
            "metadata": {},
            "name": "csmBreadcrumbsInnerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70a70115d90f3808$var$node.hash = "fc0a03b251b6289b521688cdb7d387f1";
var $70a70115d90f3808$export$2e2bcd8739ae039 = $70a70115d90f3808$var$node;

});



parcelRegister("7BQTL", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbs", () => $280a994dcb68fe58$export$ee4634b1f7dbb2c5);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("2QPVh");
var $3no4E = parcelRequire("3no4E");
parcelRequire("kzsSo");
var $8zB70 = parcelRequire("8zB70");
const $280a994dcb68fe58$var$selector = (0, $BOq7h.createSelector)((state, props)=>props.articleTitle ?? (0, $3no4E.getArticleTitle)(state, props.articleId), (articleTitle)=>({
        articleTitle: articleTitle
    }));
const $280a994dcb68fe58$export$ee4634b1f7dbb2c5 = (0, $f2mlD.default)($280a994dcb68fe58$var$selector)((0, $8zB70.CsmBreadcrumbsInner));
var $280a994dcb68fe58$export$2e2bcd8739ae039 = $280a994dcb68fe58$export$ee4634b1f7dbb2c5;

});


parcelRegister("j2kYn", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $5ba474078d6c3732$export$8f314e512d92575f);
$parcel$export(module.exports, "SubHeadingContainer", () => $5ba474078d6c3732$export$c8db0106bd269e8c);
$parcel$export(module.exports, "SubHeading", () => $5ba474078d6c3732$export$210dc657affc8afd);
$parcel$export(module.exports, "Description", () => $5ba474078d6c3732$export$393edc798c47379d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $ki6Qt = parcelRequire("ki6Qt");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");
const $5ba474078d6c3732$var$ICON_SIZE_MOBILE = $9K7mZ.multiple(4.5).unitless;
const $5ba474078d6c3732$var$ICON_SIZE_DESKTOP = $9K7mZ.multiple(6.25).unitless;
const $5ba474078d6c3732$var$MARGIN_RIGHT = "var(--ds-space-200, 16px)";
const $5ba474078d6c3732$var$SUBHEADING_MARGIN_TOP_MOBILE = "var(--ds-space-200, 16px)";
const $5ba474078d6c3732$var$SUBHEADING_MARGIN_TOP_DESKTOP = "var(--ds-space-100, 8px)";
const $5ba474078d6c3732$var$DESCRIPTION_MARGIN_TOP_MOBILE = "var(--ds-space-100, 8px)";
const $5ba474078d6c3732$export$8f314e512d92575f = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-69w8vc-0"
})`${$fU62V.flexCenter};height:${$5ba474078d6c3732$var$ICON_SIZE_MOBILE}px;width:${$5ba474078d6c3732$var$ICON_SIZE_MOBILE}px;margin-right:${$5ba474078d6c3732$var$MARGIN_RIGHT};flex-shrink:0;${$ki6Qt.fromXSmall.css`
        height: ${$5ba474078d6c3732$var$ICON_SIZE_DESKTOP}px;
        width: ${$5ba474078d6c3732$var$ICON_SIZE_DESKTOP}px;
    `};`;
const $5ba474078d6c3732$export$c8db0106bd269e8c = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-69w8vc-1"
})`display:flex;justify-content:flex-start;align-items:center;margin-top:${$5ba474078d6c3732$var$SUBHEADING_MARGIN_TOP_MOBILE};${$ki6Qt.fromXSmall.css`
        margin-top: ${$5ba474078d6c3732$var$SUBHEADING_MARGIN_TOP_DESKTOP};
    `};`;
const $5ba474078d6c3732$export$210dc657affc8afd = /*#__PURE__*/ (0, $4v2A7.default).h1.withConfig({
    componentId: "sc-69w8vc-2"
})`${$98sDU.h700};${$fU62V.breakWord};margin:0;`;
const $5ba474078d6c3732$export$393edc798c47379d = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-69w8vc-3"
})`display:block;color:${"var(--ds-text, #172B4D)"};margin-top:${$5ba474078d6c3732$var$DESCRIPTION_MARGIN_TOP_MOBILE};width:100%;`;

});



parcelRegister("dW0Ki", function(module, exports) {
$parcel$export(module.exports, "ArticleList", () => (parcelRequire("6kb3b")).default);

var $6kb3b = parcelRequire("6kb3b");

});
parcelRegister("6kb3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d976a9e76e69b9f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $c6H7d = parcelRequire("c6H7d");

var $5cKiX = parcelRequire("5cKiX");
parcelRequire("8gXQS");
var $7U1yS = parcelRequire("7U1yS");
parcelRequire("fK5uK");
var $9N3v2 = parcelRequire("9N3v2");
parcelRequire("7VtLj");
var $1Bwl1 = parcelRequire("1Bwl1");

var $dwOcU = parcelRequire("dwOcU");

var $iydAA = parcelRequire("iydAA");
parcelRequire("3dwMI");
var $18rjj = parcelRequire("18rjj");

var $cBX10 = parcelRequire("cBX10");
const $9d976a9e76e69b9f$export$cf74bb99f97bf995 = (portalId, categoryId, articles, opts)=>{
    return /*#__PURE__*/ $bSJIT.createElement("section", null, opts.showHeading && /*#__PURE__*/ $bSJIT.createElement($9d976a9e76e69b9f$export$72d7ca7a5d1d4807, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), opts.isFeatured ? (0, $cBX10.default).featuredArticlesHeading : (0, $cBX10.default).moreArticlesHeading)), /*#__PURE__*/ $bSJIT.createElement($9d976a9e76e69b9f$export$9d0ad9ba52d8bb58, null, articles.map((article)=>{
        const { title: title, summaryExcerpt: summaryExcerpt, id: articleId } = article;
        return /*#__PURE__*/ $bSJIT.createElement((0, $18rjj.default), {
            portalId: portalId,
            categoryId: categoryId,
            articleId: articleId,
            key: articleId,
            title: title,
            summaryExcerpt: summaryExcerpt,
            isFeatured: opts.isFeatured
        });
    })));
};
/**
 * ArticleList comes with forced top margin because of the featured vs. non featured articles
 * groupings. Take this into consideration when using in places no under knowledge category page.
 */ const $9d976a9e76e69b9f$var$ArticleList = ({ articles: articles, portalName: portalName, portalId: portalId, portalLink: portalLink, categoryId: categoryId, showRequestCreateButton: showRequestCreateButton, isLoading: isLoading })=>{
    const featuredArticles = articles ? articles.filter((article)=>article.isFeatured) : [];
    const regularArticles = articles ? articles.filter((article)=>!article.isFeatured) : [];
    const hasRegularArticles = regularArticles.length > 0;
    const hasFeaturedArticles = featuredArticles.length > 0;
    const hasAnyArticles = hasRegularArticles || hasFeaturedArticles;
    const containerHasExtraMargin = hasRegularArticles && hasFeaturedArticles || !hasAnyArticles;
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                numberOfArticles: articles && articles.length
            }
        }
    }, /*#__PURE__*/ $bSJIT.createElement($9d976a9e76e69b9f$export$79927783e7566f41, {
        marginTop: containerHasExtraMargin
    }, /*#__PURE__*/ $bSJIT.createElement((0, $9N3v2.default), {
        isLoading: isLoading,
        loadingPosition: "fill-container"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), hasFeaturedArticles && $9d976a9e76e69b9f$export$cf74bb99f97bf995(portalId, categoryId, featuredArticles, {
        isFeatured: true,
        showHeading: hasRegularArticles
    }), hasRegularArticles && $9d976a9e76e69b9f$export$cf74bb99f97bf995(portalId, categoryId, regularArticles, {
        isFeatured: false,
        showHeading: hasFeaturedArticles
    }), !hasAnyArticles && /*#__PURE__*/ $bSJIT.createElement($9d976a9e76e69b9f$export$aff2890a94825ec8, null, /*#__PURE__*/ $bSJIT.createElement($9d976a9e76e69b9f$export$4ba49fb37bbab46d, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $cBX10.default).articlesEmptyStateText)), /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
        to: `/portal/${portalId}`,
        actionSubjectId: "backToPortal"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $cBX10.default).categoriesEmptyStateLink,
        values: {
            portalName: portalName
        }
    }))), showRequestCreateButton && /*#__PURE__*/ $bSJIT.createElement((0, $1Bwl1.default), {
        to: portalLink
    }))));
};
var $9d976a9e76e69b9f$export$2e2bcd8739ae039 = $9d976a9e76e69b9f$var$ArticleList;
const $9d976a9e76e69b9f$export$4ba49fb37bbab46d = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ejyd2g-0"
})`${$98sDU.regular};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $9d976a9e76e69b9f$export$9d0ad9ba52d8bb58 = /*#__PURE__*/ (0, $4v2A7.default).ol.withConfig({
    componentId: "sc-1ejyd2g-1"
})`margin:0 -${(0, $7U1yS.GROUP_BOX_PADDING_LEFT_RIGHT)};padding:0;`;
const $9d976a9e76e69b9f$export$72d7ca7a5d1d4807 = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-1ejyd2g-2"
})`${$98sDU.h500};`;
const $9d976a9e76e69b9f$export$79927783e7566f41 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ejyd2g-3"
})`margin-top:${(props)=>props.marginTop ? "var(--ds-space-200, 16px)" : 0};> *{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $9d976a9e76e69b9f$export$aff2890a94825ec8 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ejyd2g-4"
})`margin-bottom:${"var(--ds-space-500, 40px)"};`;

});
parcelRegister("8gXQS", function(module, exports) {
$parcel$export(module.exports, "GroupBox", () => (parcelRequire("eTZrE")).default);
$parcel$export(module.exports, "GroupBoxLink", () => (parcelRequire("8NUJj")).default);
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => (parcelRequire("7U1yS")).GROUP_BOX_PADDING_LEFT_RIGHT);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => (parcelRequire("7U1yS")).GROUP_BOX_PADDING_TOP_BOTTOM);

var $eTZrE = parcelRequire("eTZrE");
parcelRequire("1tATL");
var $8NUJj = parcelRequire("8NUJj");

var $7U1yS = parcelRequire("7U1yS");

});
parcelRegister("eTZrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $3524f92ff6340602$export$2e2bcd8739ae039);
/* group-box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $acAb6 = parcelRequire("acAb6");

var $7WQx2 = parcelRequire("7WQx2");

var $7U1yS = parcelRequire("7U1yS");
const $3524f92ff6340602$var$GroupBox = ({ heading: heading, description: description, icon: icon, editRequestTypeOnRequestList: editRequestTypeOnRequestList, headingAs: headingAs = 'h3', isAriaHidden: isAriaHidden = false, lineClamp: lineClamp = 0, ...props })=>{
    const showEditRequestButton = !!editRequestTypeOnRequestList;
    const ariaHidden = isAriaHidden ? undefined : true;
    const content = showEditRequestButton ? /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_kqswh2mm"
        ])
    }, heading && /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description), /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-edit-overlay": "true",
        className: (0, $9fU1q.default)([
            "_kqswstnw _1xi2ze3t _154ize3t _tzy4idpf"
        ])
    }, editRequestTypeOnRequestList)) : /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, heading && /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description));
    return /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.StyledIconCardLayout), {
        ...props,
        leftIcon: icon && /*#__PURE__*/ ($bSJIT.isValidElement(icon) ? icon : /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
            src: icon,
            alt: ""
        })),
        content: content
    });
};
const $3524f92ff6340602$var$GroupBoxWithAdditionalButtonLayout = null;
const $3524f92ff6340602$var$OverlayButtonLayout = null;
var $3524f92ff6340602$export$2e2bcd8739ae039 = $3524f92ff6340602$var$GroupBox;

});
parcelRegister("7U1yS", function(module, exports) {
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => $e4834ba7cfbb8afa$export$5ff888af59e97bf4);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => $e4834ba7cfbb8afa$export$2968d5852daac253);
$parcel$export(module.exports, "StyledIconCardLayout", () => $e4834ba7cfbb8afa$export$66f468dd3258e073);
$parcel$export(module.exports, "HeadingContent", () => $e4834ba7cfbb8afa$export$5cb6fad052f5d74e);
$parcel$export(module.exports, "Description", () => $e4834ba7cfbb8afa$export$393edc798c47379d);
$parcel$export(module.exports, "StyledLink", () => $e4834ba7cfbb8afa$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $98sDU = parcelRequire("98sDU");

var $fU62V = parcelRequire("fU62V");
parcelRequire("aFV7z");
var $j2ZTR = parcelRequire("j2ZTR");

var $87QgR = parcelRequire("87QgR");
const $e4834ba7cfbb8afa$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $e4834ba7cfbb8afa$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($e4834ba7cfbb8afa$var$HC_ADS_DROP_COMMIT_2);
const $e4834ba7cfbb8afa$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT = "var(--ds-space-200, 16px)";
const $e4834ba7cfbb8afa$export$5ff888af59e97bf4 = "var(--ds-space-300, 24px)";
const $e4834ba7cfbb8afa$export$2968d5852daac253 = "var(--ds-space-300, 24px)";
const $e4834ba7cfbb8afa$export$66f468dd3258e073 = /*#__PURE__*/ (0, $4v2A7.default)((0, $j2ZTR.default)).withConfig({
    componentId: "sc-1p6gmq3-0"
})`padding:${$e4834ba7cfbb8afa$export$2968d5852daac253} ${(props)=>props.containerPadding === 'tight' ? $e4834ba7cfbb8afa$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT : $e4834ba7cfbb8afa$export$5ff888af59e97bf4};`;
const $e4834ba7cfbb8afa$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1p6gmq3-1"
})`${$98sDU.h400};${(props)=>$fU62V.applyIf(props.lineClamp, $fU62V.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $e4834ba7cfbb8afa$export$5cb6fad052f5d74e = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1p6gmq3-2"
})`${(props)=>$fU62V.applyIf(props.lineClamp, $fU62V.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $e4834ba7cfbb8afa$export$393edc798c47379d = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1p6gmq3-3"
})`${(props)=>$fU62V.applyIf(props.lineClamp > 0, /*
             We use multiline clamp so we avoid descriptions that have multi paragraphs looking like this:
             Clamped...
             Clamped...
             Clamped...
         */ $fU62V.multiLineClamp(props.lineClamp))};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-050, 4px)"};`;
const $e4834ba7cfbb8afa$export$9048d548939551ee = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-1p6gmq3-4"
})`${$fU62V.borderRadius};${()=>$e4834ba7cfbb8afa$var$isHcAdsDropCommit2Enabled() && $fU62V.borderRadiusLarge} display:block;background-color:${(props)=>props.selected ? "var(--ds-surface-raised, #F4F5F7)" : 'inherit'};&:hover,&:focus-visible{text-decoration:none;background-color:${"var(--ds-surface-raised-hovered, #F4F5F7)"};}&:hover [data-edit-overlay]{opacity:1;}&:focus{text-decoration:none;}`;

});
parcelRegister("aFV7z", function(module, exports) {
$parcel$export(module.exports, "IconCardLayout", () => (parcelRequire("j2ZTR")).default);

var $j2ZTR = parcelRequire("j2ZTR");

});
parcelRegister("j2ZTR", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b6d81a75ad93554$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $4ZMmh = parcelRequire("4ZMmh");

var $87QgR = parcelRequire("87QgR");

var $67YKA = parcelRequire("67YKA");
const $5b6d81a75ad93554$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $5b6d81a75ad93554$var$DEFAULT_RESULT_PADDING = "var(--ds-space-200, 16px)";
const $5b6d81a75ad93554$var$DEFAULT_ICON_SIZE = "var(--ds-space-400, 32px)";
const $5b6d81a75ad93554$var$DEFAULT_ICON_MARGIN = "var(--ds-space-200, 16px)";
const $5b6d81a75ad93554$var$ICON_SIZE_TO_TILE_SIZE = {
    '20px': 'small',
    '24px': 'medium',
    '32px': 'large',
    '40px': 'xlarge',
    '48px': 'xlarge'
};
const $5b6d81a75ad93554$export$dbd3bc8edfb9a83d = (iconSize)=>$5b6d81a75ad93554$var$ICON_SIZE_TO_TILE_SIZE[iconSize] ?? 'medium';
const $5b6d81a75ad93554$var$getSpaceValueWithDefault = (defaultSpacing, value, customSpacing)=>{
    if (!(0, $4ZMmh.isNil)(value)) return `${value}px`;
    return customSpacing || defaultSpacing;
};
const $5b6d81a75ad93554$var$IconCardLayout = ({ leftIcon: leftIcon, rightIcon: rightIcon, content: content, iconSize: iconSize, iconMargin: iconMargin, padding: padding, alignItems: alignItems, className: className, centerAlignLeftIcon: centerAlignLeftIcon, centerAlignRightIcon: centerAlignRightIcon, dataTestId: dataTestId, customStyling: customStyling })=>{
    const { iconSize: customIconSize, iconMargin: customIconMargin, padding: customPadding } = customStyling || {};
    const iconSizeWithDefault = $5b6d81a75ad93554$var$getSpaceValueWithDefault($5b6d81a75ad93554$var$DEFAULT_ICON_SIZE, iconSize, customIconSize);
    const iconMarginWithDefault = $5b6d81a75ad93554$var$getSpaceValueWithDefault($5b6d81a75ad93554$var$DEFAULT_ICON_MARGIN, iconMargin, customIconMargin);
    const paddingWithDefault = $5b6d81a75ad93554$var$getSpaceValueWithDefault($5b6d81a75ad93554$var$DEFAULT_RESULT_PADDING, padding, customPadding);
    const isHcAdsDropCommit2Enabled = (0, $87QgR.default).checkGate($5b6d81a75ad93554$var$HC_ADS_DROP_COMMIT_2);
    const tileSize = $5b6d81a75ad93554$export$dbd3bc8edfb9a83d(iconSizeWithDefault);
    const renderLeftIcon = $bSJIT.useCallback(()=>leftIcon, [
        leftIcon
    ]);
    const renderRightIcon = $bSJIT.useCallback(()=>rightIcon, [
        rightIcon
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($5b6d81a75ad93554$var$ResultContainer, {
        "data-test-id": dataTestId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        padding: paddingWithDefault,
        align: alignItems || 'center',
        gap: isHcAdsDropCommit2Enabled ? iconMarginWithDefault : undefined
    }, leftIcon && (isHcAdsDropCommit2Enabled ? leftIcon && /*#__PURE__*/ $bSJIT.createElement((0, $67YKA.default), {
        size: tileSize,
        icon: renderLeftIcon,
        label: "",
        appearance: "gray"
    }) : /*#__PURE__*/ $bSJIT.createElement($5b6d81a75ad93554$var$IconContainer, {
        iconMargin: iconMarginWithDefault,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignLeftIcon
    }, leftIcon)), /*#__PURE__*/ $bSJIT.createElement($5b6d81a75ad93554$var$ResultContentContainer, null, content), rightIcon && (isHcAdsDropCommit2Enabled ? rightIcon && /*#__PURE__*/ $bSJIT.createElement((0, $67YKA.default), {
        size: tileSize,
        icon: renderRightIcon,
        label: "",
        appearance: "gray"
    }) : /*#__PURE__*/ $bSJIT.createElement($5b6d81a75ad93554$var$IconContainer, {
        iconMargin: $5b6d81a75ad93554$var$DEFAULT_ICON_MARGIN,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignRightIcon,
        right: true
    }, rightIcon)));
};
var $5b6d81a75ad93554$export$2e2bcd8739ae039 = $5b6d81a75ad93554$var$IconCardLayout;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5b6d81a75ad93554$var$ResultContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-fn7rhf-0"
})`display:flex;width:100%;box-sizing:border-box;align-items:${(props)=>props.align};padding:0 ${(props)=>props.padding};${(props)=>props.gap && `gap: ${props.gap}`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5b6d81a75ad93554$var$IconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-fn7rhf-1"
})`display:flex;align-items:center;justify-content:center;width:${(props)=>props.iconSize};align-self:flex-start;margin-top:${"var(--ds-space-050, 4px)"};flex-shrink:0;${(props)=>props.isCenterAlignIcon && `margin: auto`};${(props)=>props.right ? `margin-left: ${props.iconMargin}` : `margin-right: ${props.iconMargin}`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5b6d81a75ad93554$var$ResultContentContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-fn7rhf-2"
})`width:100%;`;

});




parcelRegister("1tATL", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("8NUJj")).default);

var $8NUJj = parcelRequire("8NUJj");

});
parcelRegister("8NUJj", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c21d91f37ad631e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("c3QJe");
var $6f79M = parcelRequire("6f79M");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $gYDJY = parcelRequire("gYDJY");

var $eTZrE = parcelRequire("eTZrE");

var $7U1yS = parcelRequire("7U1yS");
const $1c21d91f37ad631e$var$isExternalLink = (target)=>{
    return target instanceof HTMLElement && target.className.includes('external-link');
};
const $1c21d91f37ad631e$var$handleExternalLink = (e)=>{
    e.preventDefault();
    (0, $gYDJY.open)(e.target.toString(), '_blank');
};
const $1c21d91f37ad631e$var$GroupBoxLink = ({ className: className, selected: selected, onClick: onClick, target: target, dataTestId: dataTestId, actionSubjectId: actionSubjectId, ...rest })=>{
    const [isPageInEditMode] = (0, $6f79M.useIsPageInEditMode)();
    const tabIndex = isPageInEditMode ? -1 : undefined;
    const handleClick = $bSJIT.useCallback((e)=>{
        if (isPageInEditMode) return;
        if ($1c21d91f37ad631e$var$isExternalLink(e.target)) {
            $1c21d91f37ad631e$var$handleExternalLink(e);
            return;
        }
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    if ('to' in rest) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // oxlint-disable-next-line no-shadow
        const { to: to, editRequestTypeOnRequestList: editRequestTypeOnRequestList, ...forGroupBox } = rest;
        const showEditRequestTypeButton = !isPageInEditMode && !!editRequestTypeOnRequestList;
        const contentWithTo = showEditRequestTypeButton ? /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId
        }, /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), {
            ...forGroupBox,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        })) : /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId,
            tabIndex: tabIndex
        }, /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), forGroupBox));
        return isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
            xcss: $1c21d91f37ad631e$var$disabledLink
        }, contentWithTo) : contentWithTo;
    }
    const { href: href, ...forGroupBox } = rest;
    const content = /*#__PURE__*/ $bSJIT.createElement((0, $7U1yS.StyledLink), {
        selected: !!selected,
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        onClick: handleClick,
        target: target,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        tabIndex: tabIndex
    }, /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), forGroupBox));
    return isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: $1c21d91f37ad631e$var$disabledLink
    }, content) : content;
};
const $1c21d91f37ad631e$var$disabledLink = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
var $1c21d91f37ad631e$export$2e2bcd8739ae039 = $1c21d91f37ad631e$var$GroupBoxLink;

});



parcelRegister("7VtLj", function(module, exports) {
$parcel$export(module.exports, "RaiseRequestLink", () => (parcelRequire("1Bwl1")).default);

var $1Bwl1 = parcelRequire("1Bwl1");

});
parcelRegister("1Bwl1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e295b44837786768$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $5cKiX = parcelRequire("5cKiX");
parcelRequire("jKbau");
var $7mIIy = parcelRequire("7mIIy");
parcelRequire("8gXQS");
var $7U1yS = parcelRequire("7U1yS");

var $2pyzF = parcelRequire("2pyzF");
const $e295b44837786768$var$RaiseRequestLink = ({ to: to, isEmbeddedRoute: isEmbeddedRoute, ...props })=>/*#__PURE__*/ $bSJIT.createElement((0, $7mIIy.default), {
        to: to,
        padding: 0,
        actionSubjectId: "requestCreateLink",
        target: isEmbeddedRoute ? '_blank' : undefined,
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement($e295b44837786768$var$MessageContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $2pyzF.default).raiseRequestText)));
var $e295b44837786768$export$2e2bcd8739ae039 = $e295b44837786768$var$RaiseRequestLink;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e295b44837786768$var$MessageContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-r621zd-0"
})`padding:${(0, $7U1yS.GROUP_BOX_PADDING_TOP_BOTTOM)} ${(0, $7U1yS.GROUP_BOX_PADDING_LEFT_RIGHT)};`;

});
parcelRegister("jKbau", function(module, exports) {
$parcel$export(module.exports, "CardLink", () => (parcelRequire("7mIIy")).default);

var $7mIIy = parcelRequire("7mIIy");

});
parcelRegister("7mIIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccfdd847670e1166$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("c3QJe");
var $6f79M = parcelRequire("6f79M");

var $l9Ysx = parcelRequire("l9Ysx");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $7DNYZ = parcelRequire("7DNYZ");
const $ccfdd847670e1166$var$CardLink = ({ children: children, to: to, padding: padding, className: className, appearance: appearance, actionSubjectId: actionSubjectId, dataTestId: dataTestId, target: target, onClick: onClick })=>{
    const [isPageInEditMode] = (0, $6f79M.useIsPageInEditMode)();
    const handleClick = $bSJIT.useCallback(()=>{
        if (isPageInEditMode) return;
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    const content = /*#__PURE__*/ $bSJIT.createElement((0, $7DNYZ.Card), {
        to: to,
        padding: padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        appearance: appearance,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        target: target,
        onClick: handleClick,
        tabIndex: isPageInEditMode ? -1 : undefined
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7DNYZ.Container), null, children, /*#__PURE__*/ $bSJIT.createElement((0, $7DNYZ.IconContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
        size: "small",
        spacing: "spacious",
        label: "",
        "aria-hidden": "true",
        color: "var(--ds-text, #172B4D)"
    }))));
    return isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: $ccfdd847670e1166$var$disabledCard
    }, content) : content;
};
$ccfdd847670e1166$var$CardLink.defaultProps = {
    appearance: 'gray'
};
const $ccfdd847670e1166$var$disabledCard = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
var $ccfdd847670e1166$export$2e2bcd8739ae039 = $ccfdd847670e1166$var$CardLink;

});
parcelRegister("l9Ysx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da37f0a43857e8b8e953de1c778f2dc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f679563314864c8f$var$_react = $f679563314864c8f$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f679563314864c8f$var$_iconNew = $f679563314864c8f$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f679563314864c8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-right
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f679563314864c8f$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $f679563314864c8f$var$_react.default.createElement($f679563314864c8f$var$_iconNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$f679563314864c8f$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $f679563314864c8f$var$_default = module.exports.default = $f679563314864c8f$var$ChevronRightIcon;

});

parcelRegister("7DNYZ", function(module, exports) {
$parcel$export(module.exports, "Container", () => $4d76096b126bf707$export$42a852a2b6b56249);
$parcel$export(module.exports, "IconContainer", () => $4d76096b126bf707$export$8f314e512d92575f);
$parcel$export(module.exports, "Card", () => $4d76096b126bf707$export$60332b2344f7fe41);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $fU62V = parcelRequire("fU62V");
parcelRequire("i8qlR");
var $4D5Yz = parcelRequire("4D5Yz");

var $87QgR = parcelRequire("87QgR");
const $4d76096b126bf707$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $4d76096b126bf707$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($4d76096b126bf707$var$HC_ADS_DROP_COMMIT_2);
const $4d76096b126bf707$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-15f4chr-0"
})`display:flex;align-items:center;justify-content:space-between;`;
const $4d76096b126bf707$export$8f314e512d92575f = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-15f4chr-1"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $4d76096b126bf707$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $4v2A7.default)((0, $4D5Yz.LinkCard)).withConfig({
    componentId: "sc-15f4chr-2"
})`${$fU62V.borderRadius};${()=>$4d76096b126bf707$var$isHcAdsDropCommit2Enabled() && $fU62V.borderRadiusLarge} background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised, #FAFBFC)" : "var(--ds-surface-raised, #FFFFFF)"};padding:${(props)=>props.padding !== undefined ? `${props.padding}px` : "var(--ds-space-200, 16px)"};span{color:${"var(--ds-text, #172B4D)"};}&:hover{background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised-hovered, #FAFBFC)" : "var(--ds-surface-raised-hovered, #FFFFFF)"};}`;

});
parcelRegister("i8qlR", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => (parcelRequire("4D5Yz")).LinkCard);

var $4D5Yz = parcelRequire("4D5Yz");

});
parcelRegister("4D5Yz", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => $d29d2a79ad3a495d$export$2c381a86421d5abf);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $7QbH4 = parcelRequire("7QbH4");

var $fU62V = parcelRequire("fU62V");

var $87QgR = parcelRequire("87QgR");
const $d29d2a79ad3a495d$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $d29d2a79ad3a495d$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($d29d2a79ad3a495d$var$HC_ADS_DROP_COMMIT_2);
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d29d2a79ad3a495d$var$linkCardBase = /*#__PURE__*/ (0, $4v2A7.css)`${$fU62V.raiseUpOnHoverOrFocus((0, $7QbH4.newElevationsFromDesignSystems).e100, (0, $7QbH4.newElevationsFromDesignSystems).e200)};${$fU62V.borderRadius};${()=>$d29d2a79ad3a495d$var$isHcAdsDropCommit2Enabled() && $fU62V.borderRadiusLarge} ${$fU62V.focusRing.default};display:block;background-color:${"var(--ds-surface-raised, #FFFFFF)"};:hover,:focus{text-decoration:none;}`;
const $d29d2a79ad3a495d$export$2c381a86421d5abf = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-axlah-0"
})`${$d29d2a79ad3a495d$var$linkCardBase};`;

});





parcelRegister("2pyzF", function(module, exports) {
$parcel$export(module.exports, "default", () => $6442995382c3bc11$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $6442995382c3bc11$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    raiseRequestText: {
        defaultMessage: 'Need to raise a request? Contact us.',
        description: 'Card button text to raise request',
        id: 'sd.customerview.portal.card.button.text'
    }
});

});



parcelRegister("3dwMI", function(module, exports) {
$parcel$export(module.exports, "ArticleListItem", () => (parcelRequire("18rjj")).default);

var $18rjj = parcelRequire("18rjj");

});
parcelRegister("18rjj", function(module, exports) {
$parcel$export(module.exports, "default", () => $81e9fd0884cb92c7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");
parcelRequire("8gXQS");
var $8NUJj = parcelRequire("8NUJj");

var $dwOcU = parcelRequire("dwOcU");

var $3I5RS = parcelRequire("3I5RS");
const $81e9fd0884cb92c7$var$ArticleListItem = ({ portalId: portalId, categoryId: categoryId, articleId: articleId, title: title, summaryExcerpt: summaryExcerpt, onClick: onClick })=>{
    const articleUrl = `/portal/${portalId}/topic/${categoryId}/article/${articleId}`;
    const analyticData = {
        attributes: {
            articleId: articleId,
            portalId: portalId,
            categoryId: categoryId
        }
    };
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: analyticData
    }, /*#__PURE__*/ $bSJIT.createElement($81e9fd0884cb92c7$var$ListItem, null, /*#__PURE__*/ $bSJIT.createElement((0, $8NUJj.default), {
        actionSubjectId: "article",
        to: articleUrl,
        onClick: onClick,
        heading: title,
        description: /*#__PURE__*/ $bSJIT.createElement($81e9fd0884cb92c7$export$ef81c5adc5a715ed, {
            dangerouslySetInnerHTML: {
                __html: summaryExcerpt
            }
        }),
        icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3I5RS))), {
            label: "",
            "aria-hidden": "true",
            size: "medium",
            color: "var(--ds-icon, #42526E)",
            spacing: "spacious"
        }),
        lineClamp: 2
    })));
};
var $81e9fd0884cb92c7$export$2e2bcd8739ae039 = $81e9fd0884cb92c7$var$ArticleListItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $81e9fd0884cb92c7$var$ListItem = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-1u8m6l-0"
})`margin:0;list-style:none;`;
const $81e9fd0884cb92c7$export$ef81c5adc5a715ed = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-1u8m6l-1"
})`${$fU62V.multiLineClamp(2, $9K7mZ.multiple(2.5).unitless)};margin:0;`;

});
parcelRegister("3I5RS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e7015f59509d2b635af4bc6bdf65848>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b3a0867864f5af0$var$_react = $2b3a0867864f5af0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $2b3a0867864f5af0$var$_iconNew = $2b3a0867864f5af0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $2b3a0867864f5af0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/book-with-bookmark
 * Usage guidance:
 * Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b3a0867864f5af0$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $2b3a0867864f5af0$var$_react.default.createElement($2b3a0867864f5af0$var$_iconNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$2b3a0867864f5af0$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $2b3a0867864f5af0$var$_default = module.exports.default = $2b3a0867864f5af0$var$BookWithBookmarkIcon;

});



parcelRegister("cBX10", function(module, exports) {
$parcel$export(module.exports, "default", () => $07b360ad2ddc4da4$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $07b360ad2ddc4da4$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    featuredArticlesHeading: {
        defaultMessage: 'Featured articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.featured-articles.heading'
    },
    moreArticlesHeading: {
        defaultMessage: 'More articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.more-articles.heading'
    },
    articlesEmptyStateText: {
        defaultMessage: 'There are no articles in this category yet. Try another category, or raise a request below.',
        description: 'The text is shown as the body message in the empty state of the article list on a knowledge category page, displayed when no articles exist in the selected category.',
        id: 'cv.categories.page.no.articles.message'
    },
    categoriesEmptyStateLink: {
        defaultMessage: 'Back to {portalName}',
        description: 'The text is shown as a back navigation link in the empty state of the article list on a knowledge category page. The placeholder {portalName} will be substituted with the name of the current portal.',
        id: 'cv.categories.page.no.articles.back.link'
    }
});

});



parcelRegister("iXVK3", function(module, exports) {
$parcel$export(module.exports, "default", () => $65120bbd14c4342d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $65120bbd14c4342d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    categoryDocumentTitle: {
        defaultMessage: '{portalName} - {categoryName}',
        description: 'Document title for portal article topics page',
        id: 'cv.categories.page.title'
    }
});

});



parcelRegister("1J9tQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iqyZ5").then(()=>parcelRequire('fihwC'));

});


parcelRegister("QUECd", function(module, exports) {
$parcel$export(module.exports, "loginRoute", () => $34afa5c485413304$export$798bfdbebc5ea68e);
$parcel$export(module.exports, "portalLoginRoute", () => $34afa5c485413304$export$e338715dbbd45865);

var $jcRK7 = parcelRequire("jcRK7");
parcelRequire("6Dq5Q");
var $8NRzp = parcelRequire("8NRzp");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");
const $34afa5c485413304$var$portalLogin = {
    name: 'portal-login',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/login`,
    exact: true,
    component: (0, $8NRzp.default),
    resources: []
};
const $34afa5c485413304$var$login = {
    name: 'login',
    path: (0, $fZKGh.LOGIN_ROUTE),
    exact: true,
    component: (0, $8NRzp.default),
    resources: []
};
const $34afa5c485413304$var$screenName = (0, $jcRK7.ScreenName).LOGIN;
const $34afa5c485413304$export$798bfdbebc5ea68e = (0, $bkEWh.createRouteWithLayout)($34afa5c485413304$var$login, $34afa5c485413304$var$screenName, (0, $fZKGh.anonymousScreenLayout));
const $34afa5c485413304$export$e338715dbbd45865 = (0, $bkEWh.createRouteWithLayout)($34afa5c485413304$var$portalLogin, $34afa5c485413304$var$screenName, (0, $fZKGh.anonymousScreenLayout));

});
parcelRegister("6Dq5Q", function(module, exports) {
$parcel$export(module.exports, "Login", () => (parcelRequire("8NRzp")).default);

var $8NRzp = parcelRequire("8NRzp");

});
parcelRegister("8NRzp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b1637d70f86c29f$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $gQxPF = parcelRequire("gQxPF");

var $dSuNn = parcelRequire("dSuNn");

var $e630u = parcelRequire("e630u");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("j6ZrI");
var $kd70W = parcelRequire("kd70W");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("cwRA6");
var $jEGHJ = parcelRequire("jEGHJ");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("MMHHf");
var $cj7fd = parcelRequire("cj7fd");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $4S4aq = parcelRequire("4S4aq");
const $1b1637d70f86c29f$var$selector = (0, $BOq7h.createSelector)((state)=>(0, $hvIQS.getSharedPortalName)(state), (state)=>(0, $cj7fd.getLogin)(state), (state)=>(0, $cj7fd.getIsLoginLoaded)(state), (state)=>(0, $jEGHJ.getResetUrl)(state), (state)=>(0, $fBLyB.isLoggedIn)(state), (state)=>(0, $cj7fd.getLoginUIState)(state), (state)=>(0, $fOlM6.getIsAnonymousEnabled)(state), (helpCenterName, loginModel, loaded, resetUrl, isUserLoggedIn, loginUIState, isAnonymousEnabled)=>({
        helpCenterName: helpCenterName,
        loginModel: loginModel,
        resetUrl: resetUrl,
        loginUIState: loginUIState,
        isAnonymousEnabled: isAnonymousEnabled,
        isLoggedIn: isUserLoggedIn,
        isLoading: !loaded
    }));
var $1b1637d70f86c29f$export$2e2bcd8739ae039 = (0, $f2mlD.default)($1b1637d70f86c29f$var$selector, {
    resetLogin: $xAy39.resetLogin,
    fetchLoginModel: $e630u.fetchLoginModel,
    checkLoginActionSuccess: $xAy39.checkLoginActionSuccess,
    fetchForgotPasswordModel: $dSuNn.fetchForgotPasswordModel,
    successfullyLoggedInAction: (0, $kd70W.successfullyLoggedIn),
    onExitTestMode: (0, $xAy39.exitTestModeAction)
})((0, $2usNr.default)({
    component: 'login'
})((0, $kIbto.default)()((0, $gQxPF.default)((0, $4S4aq.default)))));

});
parcelRegister("cwRA6", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => (parcelRequire("jEGHJ")).getResetUrl);

var $jEGHJ = parcelRequire("jEGHJ");

});
parcelRegister("jEGHJ", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => $3392ed0f20039cad$export$8f4db1396a1458f2);
const $3392ed0f20039cad$var$getForgotPasswordOrError = (state)=>{
    return state.persisted.forgotPassword;
};
const $3392ed0f20039cad$export$8f4db1396a1458f2 = (state)=>{
    const data = $3392ed0f20039cad$var$getForgotPasswordOrError(state);
    return data && 'forgotPassword' in data && data.forgotPassword ? data.forgotPassword.resetUrl : undefined;
};

});


parcelRegister("MMHHf", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => (parcelRequire("cj7fd")).getLogin);
$parcel$export(module.exports, "getIsLoginLoaded", () => (parcelRequire("cj7fd")).getIsLoginLoaded);
$parcel$export(module.exports, "getLoginUIState", () => (parcelRequire("cj7fd")).getLoginUIState);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => (parcelRequire("cj7fd")).getIsFailedLoginAttempt);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => (parcelRequire("cj7fd")).getLoginAnnouncementLocale);

var $cj7fd = parcelRequire("cj7fd");

});
parcelRegister("cj7fd", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => $4862cc0b908a6c63$export$b91571cfe9876bf7);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => $4862cc0b908a6c63$export$30a66755de1b0435);
$parcel$export(module.exports, "getIsLoginLoaded", () => $4862cc0b908a6c63$export$b8e9d5ecaaf5cf65);
$parcel$export(module.exports, "getLoginUIState", () => $4862cc0b908a6c63$export$3751fae82567dd3f);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => $4862cc0b908a6c63$export$bd53bde676b5f183);
const $4862cc0b908a6c63$var$getLoginOrError = (state)=>{
    return state.persisted.login;
};
const $4862cc0b908a6c63$export$b91571cfe9876bf7 = (state)=>{
    const data = $4862cc0b908a6c63$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? data.login : undefined;
};
const $4862cc0b908a6c63$export$30a66755de1b0435 = (state)=>{
    var _data$login;
    const data = $4862cc0b908a6c63$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? (_data$login = data.login) === null || _data$login === void 0 ? void 0 : _data$login.loginAnnouncementLocale : undefined;
};
const $4862cc0b908a6c63$export$b8e9d5ecaaf5cf65 = (state)=>{
    const login = $4862cc0b908a6c63$export$b91571cfe9876bf7(state);
    return login !== undefined;
};
const $4862cc0b908a6c63$export$3751fae82567dd3f = (state)=>{
    return state.ui.login;
};
const $4862cc0b908a6c63$export$9fd495314b248bd5 = (state)=>{
    return $4862cc0b908a6c63$export$3751fae82567dd3f(state).error;
};
const $4862cc0b908a6c63$export$bd53bde676b5f183 = (state)=>{
    const loginUIState = $4862cc0b908a6c63$export$3751fae82567dd3f(state);
    return $4862cc0b908a6c63$export$9fd495314b248bd5(state) !== undefined || loginUIState.loginAttemptResponse !== undefined && !loginUIState.loginAttemptResponse.loginSucceeded;
};

});


parcelRegister("4S4aq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9497db6739a65eff$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $7j7Eh = parcelRequire("7j7Eh");

var $jcRK7 = parcelRequire("jcRK7");

var $2ERPT = parcelRequire("2ERPT");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $c6H7d = parcelRequire("c6H7d");

var $fKGH0 = parcelRequire("fKGH0");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("ejCRW");
var $hEwLY = parcelRequire("hEwLY");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");

var $6U0HR = parcelRequire("6U0HR");

var $dwOcU = parcelRequire("dwOcU");

var $7WQx2 = parcelRequire("7WQx2");

var $aRsbV = parcelRequire("aRsbV");

var $7ZMHC = parcelRequire("7ZMHC");

var $1qPbZ = parcelRequire("1qPbZ");

var $haAAx = parcelRequire("haAAx");

var $hCnLH = parcelRequire("hCnLH");

var $irUsc = parcelRequire("irUsc");

var $k4dp8 = parcelRequire("k4dp8");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $O9KKV = parcelRequire("O9KKV");

var $4GfBw = parcelRequire("4GfBw");

var $cYTUB = parcelRequire("cYTUB");

var $oORS9 = parcelRequire("oORS9");

var $7zTlh = parcelRequire("7zTlh");
parcelRequire("7L3lm");
var $2HFgS = parcelRequire("2HFgS");
parcelRequire("2M9Ix");
var $guJSZ = parcelRequire("guJSZ");
parcelRequire("2IrKm");
var $4Q1cK = parcelRequire("4Q1cK");
parcelRequire("jAyoL");
var $la94X = parcelRequire("la94X");
parcelRequire("bcMLm");
var $27cx6 = parcelRequire("27cx6");
parcelRequire("imku1");
var $3LXP8 = parcelRequire("3LXP8");

var $dL7Y8 = parcelRequire("dL7Y8");
/**
 * Check if loginAnnouncement is present
 */ const $9497db6739a65eff$var$isAnnouncementPresent = (loginModel)=>{
    if (!loginModel) return false;
    const { loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage } = loginModel;
    return (0, $4GfBw.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
};
const $9497db6739a65eff$var$getLoginAnnouncementText = (loginAnnouncementMessage)=>{
    return /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$var$LoginAnnouncementBody, {
        dangerouslySetInnerHTML: {
            __html: (0, $fKGH0.sanitize)(loginAnnouncementMessage)
        }
    });
};
const $9497db6739a65eff$export$f20e6faa97f704fb = ({ loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage })=>/*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$var$LoginAnnouncementContainer, null, loginAnnouncementSubject ? /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
            size: "small"
        }, loginAnnouncementSubject)
    }, /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$var$LoginAnnouncementTitle, null, loginAnnouncementSubject)) : null, loginAnnouncementMessage ? $9497db6739a65eff$var$getLoginAnnouncementText(loginAnnouncementMessage) : null);
class $9497db6739a65eff$export$21a94553ffa41578 extends $bSJIT.Component {
    componentDidMount() {
        const { isLoading: isLoading, resetUrl: resetUrl, loginUIState: loginUIState } = this.props;
        const ssoCustomerMethod = loginUIState.authInfo.authMethods.get((0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
        if (isLoading) this.props.fetchLoginModel();
        if (!resetUrl) this.props.fetchForgotPasswordModel();
        if (loginUIState.authInfo.authMethods.size === 0) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: true,
            redirectUrlIsMissing: false
        });
        else if (ssoCustomerMethod && ssoCustomerMethod.redirectLink === undefined) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: false,
            redirectUrlIsMissing: true
        });
    }
    getNavigationTiming() {
        var _globalThis$performan, _globalThis$performan2;
        return (_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 || (_globalThis$performan2 = _globalThis$performan.getEntriesByType) === null || _globalThis$performan2 === void 0 || (_globalThis$performan2 = _globalThis$performan2.call(_globalThis$performan, 'navigation')) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2[0];
    }
    render() {
        const { isLoggedIn: isLoggedIn, portalId: portalId } = this.props;
        const navigation = this.getNavigationTiming();
        if (isLoggedIn) return /*#__PURE__*/ $bSJIT.createElement((0, $cYTUB.RedirectLoggedInUser), {
            portalId: portalId
        });
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: {
                attributes: {
                    isSsoTestMode: (0, $oORS9.getSsoTestModeParamFromUrl)(new URLSearchParams((0, $gYDJY.search)()))
                }
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $7ZMHC.default), {
            data: {
                isFromRedirect: navigation ? navigation.redirectCount > 0 : undefined,
                redirectCount: navigation ? navigation.redirectCount : undefined,
                isDefaultHelpCenter: (0, $hCnLH.isDefaultHelpCenter)()
            }
        }), /*#__PURE__*/ $bSJIT.createElement("div", {
            "data-test-id": "login-page.wrapper"
        }, this.renderLoginPage()));
    }
    constructor(...args){
        super(...args), this.fireLoginFailedOperationalEvent = (attributes)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const { noMethodsAvailable: noMethodsAvailable, redirectUrlIsMissing: redirectUrlIsMissing } = attributes;
            if (createAnalyticsEvent) createAnalyticsEvent({
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'login',
                action: 'failed',
                attributes: {
                    noMethodsAvailable: noMethodsAvailable,
                    redirectUrlIsMissing: redirectUrlIsMissing
                }
            }).fire();
        }, this.getJITContinueParam = ()=>{
            const { destination: destination, isAbsolute: isAbsolute } = (0, $oORS9.parseLoginSignupRedirectUrlParams)();
            const prefix = destination && isAbsolute ? '' : `${(0, $gYDJY.origin)()}${(0, $eDcdn.getBaseName)()}/aa-redirect?from=portalLoginJitSignup`;
            return `${prefix}`;
        }, this.resetHasLoginPageUpdated = ()=>{
            this.props.resetLogin(this.props.loginUIState.email);
        }, this.renderForgotPasswordConfirmation = ()=>{
            const { isLoading: isLoading, loginUIState: loginUIState, helpCenterName: helpCenterName, resetUrl: resetUrl } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
                screenName: (0, $jcRK7.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $bSJIT.createElement((0, $d7jBU.default), {
                screenName: (0, $jcRK7.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $bSJIT.createElement((0, $hEwLY.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $bSJIT.createElement((0, $guJSZ.default), {
                email: loginUIState.email,
                helpCenterName: helpCenterName,
                resetUrl: resetUrl || '',
                onBackButtonClick: this.resetHasLoginPageUpdated
            }))));
        }, this.renderSsoTestModeErrorPage = ()=>{
            const { isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
                screenName: (0, $jcRK7.ScreenName).LOGIN_SSO_TEST_MODE_ERROR
            }, /*#__PURE__*/ $bSJIT.createElement((0, $hEwLY.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $bSJIT.createElement((0, $2HFgS.default), null)));
        }, this.renderSingleSignOn = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $O9KKV.AuthMethodType).ATLASSIAN_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
                        screenName: (0, $jcRK7.ScreenName).LOGIN_SINGLE_SIGN_ON
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $27cx6.default), {
                        redirectUrl: redirectLink,
                        email: loginUIState.email
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.resetToCustomerPasswordLogin = ()=>{
            this.props.checkLoginActionSuccess((0, $O9KKV.LoginType).CUSTOMER_ACCOUNT_LOGIN, {
                accountStage: (0, $O9KKV.AccountStageType).LOGIN,
                authMethods: new Map([
                    [
                        (0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            });
        }, this.renderSingleSignOnCustomer = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const passwordLoginAvailable = loginUIState.authInfo.authMethods.has((0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
                        screenName: (0, $jcRK7.ScreenName).LOGIN_SINGLE_SIGN_ON_CUSTOMER
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $3LXP8.default), {
                        email: loginUIState.email,
                        redirectLink: redirectLink,
                        passwordLoginAvailable: passwordLoginAvailable,
                        onContinueWithPassword: this.resetToCustomerPasswordLogin
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.renderLoginPasswordForm = ()=>{
            return /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
                screenName: (0, $jcRK7.ScreenName).LOGIN_PASSWORD
            }, this.renderLoginForm());
        }, this.renderLoginForm = ()=>{
            const { resetUrl: resetUrl, loginUIState: loginUIState, portalId: portalId } = this.props;
            const formSupplier = (loginModel)=>/*#__PURE__*/ $bSJIT.createElement((0, $la94X.default), {
                    portalId: portalId,
                    contactAdminLink: loginModel.contactAdminLink,
                    resetUrl: resetUrl || '',
                    loginUIState: loginUIState,
                    canResetPassword: loginModel.canReset,
                    continueParam: (0, $oORS9.getContinueParam)(portalId)
                });
            return this.renderWithTitleAndFooter(formSupplier);
        }, this.renderFooter = ()=>{
            const { intl: intl, isAnonymousEnabled: isAnonymousEnabled, loginUIState: loginUIState, helpCenterName: helpCenterName } = this.props;
            return isAnonymousEnabled && !loginUIState.atlassianAccountCheckPerformed && /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$var$FooterContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
                to: (0, $oORS9.getHelpCenterUrl)(),
                actionSubjectId: "helpCenterLink",
                onClick: (e)=>{
                    // This is ugly but we want to do a full page load (not an SPA load/transition)
                    // to allow the backend to make the decision about where we should end up.
                    // If CSM DOES NOT allow anonymous access but Jira Admin settings DOES, then
                    // an SPA transition will lead to a blank homepage as the backend actually
                    // wants to redirect the user to the login page.
                    e.preventDefault();
                    (0, $gYDJY.assign)((0, $iW3CQ.getEnv)().baseUrl);
                }
            }, intl.formatMessage((0, $dL7Y8.default).helpCenterLink, {
                helpCenterName: helpCenterName
            })));
        }, this.renderBackButton = ()=>{
            const { intl: intl } = this.props;
            const buttonText = intl.formatMessage((0, $dL7Y8.default).backButton);
            return /*#__PURE__*/ $bSJIT.createElement((0, $7zTlh.default), {
                appearance: "link",
                actionSubjectId: "returnToLogin",
                onClick: this.resetHasLoginPageUpdated
            }, buttonText);
        }, this.getLoginAnnouncementCard = ()=>{
            const { loginModel: loginModel } = this.props;
            if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)()) // render new login announcement with relay fetch
            return /*#__PURE__*/ $bSJIT.createElement((0, $4Q1cK.default), null);
            if (loginModel && $9497db6739a65eff$var$isAnnouncementPresent(loginModel)) // render old login announcement card with model
            return /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$export$f20e6faa97f704fb, {
                loginAnnouncementSubject: loginModel.loginAnnouncementSubject,
                loginAnnouncementMessage: loginModel.loginAnnouncementMessage
            });
            return null;
        }, // oxlint-disable-next-line no-shadow
        this.getContent = (componentSupplier)=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading, loginModel: loginModel, loginUIState: loginUIState } = this.props;
            let description = intl.formatMessage((0, $dL7Y8.default).description);
            if (loginUIState.atlassianAccountCheckPerformed) {
                if (loginUIState.authInfo.authMethods.has((0, $O9KKV.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) switch(loginUIState.authInfo.accountStage){
                    case (0, $O9KKV.AccountStageType).SIGNUP:
                        description = intl.formatMessage((0, $dL7Y8.default).useAtlassianAccountSignup);
                        break;
                    case (0, $O9KKV.AccountStageType).LOGIN:
                    default:
                        description = intl.formatMessage((0, $dL7Y8.default).useAtlassianAccountLogin);
                        break;
                }
                else description = intl.formatMessage((0, $dL7Y8.default).descriptionLogin);
            }
            const loginAnnouncementCard = this.getLoginAnnouncementCard();
            if (!isLoading && loginModel) return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, loginUIState.atlassianAccountCheckPerformed && this.renderBackButton(), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$export$8faa746ec8bdfab3, null, helpCenterName)), !loginUIState.atlassianAccountCheckPerformed ? loginAnnouncementCard : null, /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                    size: "medium"
                }, description)
            }, /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$var$LoginDescription, null, description)), /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$var$LoginFormContainer, null, componentSupplier(loginModel)), this.renderFooter());
            return /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
                name: "render-login-page-loading"
            });
        }, this.renderWithTitleAndFooter = (componentSupplier)=>{
            const { isLoading: isLoading } = this.props;
            const content = this.getContent(componentSupplier);
            const urlParams = new URLSearchParams((0, $gYDJY.search)());
            const ssoTest = urlParams.get((0, $O9KKV.QUERY_PARAM_SSO_TEST));
            return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, ssoTest === 'true' ? /*#__PURE__*/ $bSJIT.createElement((0, $6U0HR.SsoTestModeBanner), null) : null, /*#__PURE__*/ $bSJIT.createElement((0, $hEwLY.NoteContent), {
                isLoading: isLoading
            }, content));
        }, this.isInvalidFedRampLogin = ()=>{
            const isPasswordLoginDisabledByEnv = !(0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login');
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.isInvalidIcLogin = ()=>{
            const isPasswordLoginDisabledByEnv = !(0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login');
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.noAuthMethodOrOnlyHasPasswordAuthMethod = ()=>{
            const { loginUIState: loginUIState } = this.props;
            return loginUIState.authInfo.authMethods.size === 0 || loginUIState.authInfo.authMethods.size === 1 && loginUIState.authInfo.authMethods.has((0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
        }, this.renderNoLoginMethodPage = ()=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement((0, $hEwLY.NoteContent), {
                isLoading: isLoading
            }, this.renderBackButton(), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $bSJIT.createElement($9497db6739a65eff$export$8faa746ec8bdfab3, null, helpCenterName)), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), null, intl.formatMessage((0, $dL7Y8.default).noLoginMethodWarningContent))
            }, /*#__PURE__*/ $bSJIT.createElement("p", null, intl.formatMessage((0, $dL7Y8.default).noLoginMethodWarningContent))));
        }, this.renderLoginPage = ()=>{
            const { intl: intl, loginUIState: loginUIState } = this.props;
            let loginPage;
            if (loginUIState.showPasswordConfirmation) loginPage = this.renderForgotPasswordConfirmation();
            else if (loginUIState.authInfo.authMethods.has((0, $O9KKV.AuthMethodType).CUSTOMER_ACCOUNT_SSO)) loginPage = this.renderSingleSignOnCustomer();
            else if (loginUIState.authInfo.authMethods.has((0, $O9KKV.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) loginPage = this.renderSingleSignOn();
            else if (loginUIState.showSsoTestModeErrorPage) loginPage = this.renderSsoTestModeErrorPage();
            else if (loginUIState.atlassianAccountCheckPerformed) {
                if (this.isInvalidFedRampLogin() || this.isInvalidIcLogin()) loginPage = this.renderNoLoginMethodPage();
                else loginPage = this.renderLoginPasswordForm();
            } else loginPage = this.renderLoginForm();
            return /*#__PURE__*/ $bSJIT.createElement((0, $2ERPT.default), {
                title: intl.formatMessage((0, $dL7Y8.default).documentTitle)
            }, loginPage);
        };
    }
}
var $9497db6739a65eff$export$2e2bcd8739ae039 = (0, $fK3tS.default)($9497db6739a65eff$export$21a94553ffa41578);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9497db6739a65eff$var$LoginDescription = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-1ifnvh3-0"
})`${(0, $98sDU.h600)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9497db6739a65eff$var$LoginFormContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ifnvh3-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9497db6739a65eff$var$FooterContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ifnvh3-2"
})`margin-top:${"var(--ds-space-400, 32px)"};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9497db6739a65eff$var$LoginAnnouncementContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ifnvh3-3"
})`padding-bottom:${"var(--ds-space-200, 16px)"};border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9497db6739a65eff$var$LoginAnnouncementTitle = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ifnvh3-4"
})`${(0, $98sDU.h500)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9497db6739a65eff$var$LoginAnnouncementBody = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ifnvh3-5"
})`margin-top:${"var(--ds-space-100, 8px)"};max-width:${$9K7mZ.multiple(42).px};overflow-wrap:break-word;`;
const $9497db6739a65eff$export$8faa746ec8bdfab3 = /*#__PURE__*/ (0, $4v2A7.default).h1.withConfig({
    componentId: "sc-1ifnvh3-6"
})`${(0, $98sDU.h700)};`;

});
parcelRegister("ejCRW", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => (parcelRequire("hEwLY")).NoteContent);

var $hEwLY = parcelRequire("hEwLY");

});
parcelRegister("hEwLY", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => $5cd06d7cd300ac85$export$fe2e0d4376bdc305);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9K7mZ = parcelRequire("9K7mZ");
parcelRequire("fK5uK");
var $9N3v2 = parcelRequire("9N3v2");
class $5cd06d7cd300ac85$export$fe2e0d4376bdc305 extends $bSJIT.Component {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement($5cd06d7cd300ac85$var$NoteContentContainer, {
            isCentered: this.props.isCentered,
            "data-testid": "note-content-container"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $9N3v2.default), {
            isLoading: this.props.isLoading,
            loadingPosition: "fill-container"
        }, this.props.children));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5cd06d7cd300ac85$var$NoteContentContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-x5t5ez-0"
})`margin:${"var(--ds-space-800, 64px)"};max-width:${$9K7mZ.multiple(44).px};text-align:${(props)=>props.isCentered ? 'center' : 'start'};`;

});


parcelRegister("6U0HR", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeBanner", () => $e4200ea687dbb46b$export$c5b94d186c592c02);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $e4200ea687dbb46b$export$c5b94d186c592c02 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1LnM7")), {
        moduleId: "./src/view/sso-test-mode-banner/hocs.tsx"
    })
});

});
parcelRegister("1LnM7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4mqi5").then(()=>parcelRequire('hk8Ny'));

});


parcelRegister("7ZMHC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b66818be25daf35b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lmUvw = parcelRequire("lmUvw");
function $b66818be25daf35b$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $bSJIT.useContext)((0, $lmUvw.default));
    (0, $bSJIT.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}

});

parcelRegister("4GfBw", function(module, exports) {
$parcel$export(module.exports, "isValidAnnouncement", () => $edc070fb6eb2f27c$export$12ee192c1d1082df);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_TITLE_LIMIT", () => $edc070fb6eb2f27c$export$6cca6da7b99ee46e);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_MESSAGE_LIMIT", () => $edc070fb6eb2f27c$export$24036c5b680cb85);
const $edc070fb6eb2f27c$export$12ee192c1d1082df = (header, message)=>header !== '' || message !== '';
const $edc070fb6eb2f27c$export$6cca6da7b99ee46e = 50;
const $edc070fb6eb2f27c$export$24036c5b680cb85 = 480;

});

parcelRegister("cYTUB", function(module, exports) {
$parcel$export(module.exports, "RedirectLoggedInUser", () => $7f4d594cd9cec894$export$b883ffb676ea4071);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $g5FS7 = parcelRequire("g5FS7");

var $oORS9 = parcelRequire("oORS9");
const $7f4d594cd9cec894$export$b883ffb676ea4071 = ({ portalId: portalId })=>{
    const { destination: destination } = (0, $oORS9.parseLoginSignupRedirectUrlParams)();
    if ((0, $lFpPv.isHubsEnabledInHelpCenter)() && (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) || (0, $hCnLH.getIsHelpHub)()) {
        if (destination && (0, $gYDJY.isValidLocation)(destination)) {
            const relativeUrl = (0, $oORS9.convertAbsoluteUrlToRelativeUrl)(destination);
            const redirectPath = `${(0, $eDcdn.getRelativeBasePath)()}${relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`}`;
            (0, $gYDJY.replace)(redirectPath);
        } else if (destination && decodeURIComponent(destination).startsWith('//')) (0, $gYDJY.replace)((0, $eDcdn.getRelativeBasePath)());
        else {
            const redirectPath = `${(0, $eDcdn.getRelativeBasePath)()}${destination ? `/${destination}` : ''}`;
            (0, $gYDJY.replace)(redirectPath);
        }
        return null;
    }
    if (destination) {
        if ((0, $gYDJY.isValidLocation)(destination)) {
            const relativeUrl = (0, $oORS9.convertAbsoluteUrlToRelativeUrl)(destination);
            (0, $gYDJY.assign)(relativeUrl);
            return null;
        }
        if (decodeURIComponent(destination).startsWith('//')) {
            (0, $gYDJY.assign)((0, $oORS9.getHelpCenterUrl)());
            return null;
        }
    }
    if ($7f4d594cd9cec894$var$shouldExecuteFullPageReload(destination)) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (0, $gYDJY.replace)(`${(0, $eDcdn.getRelativeBasePath)()}/${destination}`);
        return null;
    }
    const relativeDestination = `/${destination || (0, $oORS9.getDefaultDestination)(portalId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g5FS7.Redirect), {
        to: relativeDestination
    });
};
const $7f4d594cd9cec894$var$fullPageReloadPathsRegexs = [
    /^request\/[0-9]+\/attachment\/[0-9]+[/]?(\?.*)?$/,
    /^request\/[0-9]+\/attachment\/[0-9]+\/thumbnail[/]?(\?.*)?$/
];
/**
 * Some URLs, even though they start with /servicedesk/customer, don't have any specific component mapped to that route.
 * When customers account log in the portal will simply do an SPA redirection and it will end up in 404
 * This method will allow for these "special" URLs to execute a full page reload after a customer account logs in.
 */ const $7f4d594cd9cec894$var$shouldExecuteFullPageReload = (destination)=>{
    if (destination) return $7f4d594cd9cec894$var$fullPageReloadPathsRegexs.some((regex)=>regex.test(destination));
    return false;
};

});

parcelRegister("7zTlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc50c967e4f2b0f9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $lCAV6 = parcelRequire("lCAV6");

var $8sRTK = parcelRequire("8sRTK");
const $dc50c967e4f2b0f9$var$ThemedBackButton = (props)=>{
    const { children: children, onClick: onClick, actionSubjectId: actionSubjectId, appearance: appearance } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($dc50c967e4f2b0f9$var$BackButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lCAV6.ThemedButton), {
        iconBefore: // Icon is decorative — adjacent button text already conveys the label
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sRTK))), {
            spacing: "spacious",
            label: ""
        }),
        appearance: appearance,
        spacing: "compact",
        actionSubjectId: actionSubjectId,
        onClick: onClick
    }, children));
};
var $dc50c967e4f2b0f9$export$2e2bcd8739ae039 = $dc50c967e4f2b0f9$var$ThemedBackButton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $dc50c967e4f2b0f9$var$BackButtonWrapper = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-x420oi-0"
})`margin-left:${"var(--ds-space-negative-200, -16px)"};`;

});

parcelRegister("7L3lm", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeErrorPage", () => (parcelRequire("2HFgS")).default);

var $2HFgS = parcelRequire("2HFgS");

});
parcelRegister("2HFgS", function(module, exports) {
$parcel$export(module.exports, "default", () => $3862a02fb20471d8$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $c6H7d = parcelRequire("c6H7d");

var $4b8qO = parcelRequire("4b8qO");

var $4vLTk = parcelRequire("4vLTk");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $iydAA = parcelRequire("iydAA");

var $k4dp8 = parcelRequire("k4dp8");

var $9s93X = parcelRequire("9s93X");
const $3862a02fb20471d8$var$LEARN_MORE_LINK = 'https://support.atlassian.com/jira-service-management-cloud/docs/test-single-sign-on-for-customer-login/';
const $3862a02fb20471d8$var$CaSsoTestModeErrorPage = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ $bSJIT.createElement($3862a02fb20471d8$var$Container, {
        "data-test-id": "ca-sso-test-mode-error-screen-container"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), /*#__PURE__*/ $bSJIT.createElement($3862a02fb20471d8$var$IconContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $4b8qO.default), null)), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
            paddingBlockEnd: "space.050"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
            size: "medium"
        }, formatMessage((0, $9s93X.default).title)))
    }, /*#__PURE__*/ $bSJIT.createElement($3862a02fb20471d8$var$Title, null, formatMessage((0, $9s93X.default).title))), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), null, formatMessage((0, $9s93X.default).instructionMessage))
    }, /*#__PURE__*/ $bSJIT.createElement("p", null, formatMessage((0, $9s93X.default).instructionMessage))), /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
        actionSubjectId: "learnMoreSsoTestMode",
        href: $3862a02fb20471d8$var$LEARN_MORE_LINK,
        target: "_blank"
    }, formatMessage((0, $9s93X.default).learnMoreLinkLabel)));
};
var $3862a02fb20471d8$export$2e2bcd8739ae039 = $3862a02fb20471d8$var$CaSsoTestModeErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3862a02fb20471d8$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1q5wzvf-0"
})`text-align:center;> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3862a02fb20471d8$var$Title = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1q5wzvf-1"
})`${(0, $98sDU.h600)};margin-bottom:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3862a02fb20471d8$var$IconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1q5wzvf-2"
})`width:${$9K7mZ.multiple(10.5).px};margin:0 auto ${"var(--ds-space-300, 24px)"} auto;`;

});
parcelRegister("9s93X", function(module, exports) {
$parcel$export(module.exports, "default", () => $f52ca6510e5eb2b7$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f52ca6510e5eb2b7$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    learnMoreLinkLabel: {
        defaultMessage: 'Learn more about testing single sign-on',
        description: 'label for learn more link for sso test mode failure',
        id: 'cv.login.ca.sso.test.mode.error.learn.more.label'
    },
    instructionMessage: {
        defaultMessage: 'Turn on the single sign-on test mode in your Authentication settings.',
        description: 'message with instruction for SSO test mode',
        id: 'cv.login.ca.sso.test.mode.error.instruction.message'
    },
    title: {
        defaultMessage: 'Single Sign-on test mode is disabled',
        description: 'title for SSO test mode error page',
        id: 'cv.login.ca.sso.test.mode.error.title'
    }
});

});



parcelRegister("2M9Ix", function(module, exports) {
$parcel$export(module.exports, "ForgotPasswordConfirmation", () => (parcelRequire("guJSZ")).default);

var $guJSZ = parcelRequire("guJSZ");

});
parcelRegister("guJSZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1a11ddf26e4bd80$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $xb2jO = parcelRequire("xb2jO");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");

var $csRXt = parcelRequire("csRXt");
var $a1a11ddf26e4bd80$export$2e2bcd8739ae039 = (0, $f2mlD.default)((state)=>({
        baseUrl: (0, $fOlM6.getBaseUrl)(state)
    }), {
    resetLoginAction: (0, $xAy39.resetLogin),
    onResendLinkError: (0, $xb2jO.handleAjaxError),
    onResendSuccess: (0, $xb2jO.showSuccessFlag)
})((0, $csRXt.default));

});
parcelRegister("csRXt", function(module, exports) {
$parcel$export(module.exports, "default", () => $daae654e951eab1b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $lCAV6 = parcelRequire("lCAV6");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $677lk = parcelRequire("677lk");

var $7zTlh = parcelRequire("7zTlh");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $iydAA = parcelRequire("iydAA");

var $k4dp8 = parcelRequire("k4dp8");

var $oORS9 = parcelRequire("oORS9");

var $dL7Y8 = parcelRequire("dL7Y8");

var $d4WXs = parcelRequire("d4WXs");
class $daae654e951eab1b$export$3ed80e0e31a57da extends $bSJIT.Component {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement($daae654e951eab1b$var$Container, {
            "data-test-id": "forgot-password-container"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), this.renderContent());
    }
    constructor(...args){
        super(...args), this.state = {
            isSendingForgotPasswordEmail: false
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $oORS9.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onResendButtonClick = ()=>{
            this.setState({
                isSendingForgotPasswordEmail: true
            });
            const redirectUrl = this.getRedirectUrl(this.props.baseUrl);
            (0, $677lk.forgotPassword)(this.props.resetUrl, this.props.email, redirectUrl).toPromise().then(()=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendSuccess((0, $d4WXs.default).resendSuccessMessage, {
                    emailAddress: this.props.email
                });
            }).catch((err)=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendLinkError(err);
            });
        }, this.renderContent = ()=>{
            const { intl: intl, email: email, helpCenterName: helpCenterName, onBackButtonClick: onBackButtonClick } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $7zTlh.default), {
                appearance: "link",
                onClick: onBackButtonClick,
                actionSubjectId: "returnToLogin"
            }, intl.formatMessage((0, $dL7Y8.default).backButton)), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                    paddingBlockEnd: "space.300"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                    size: "large"
                }, helpCenterName))
            }, /*#__PURE__*/ $bSJIT.createElement($daae654e951eab1b$var$Title, null, helpCenterName)), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                    size: "medium"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $d4WXs.default).checkYourEmail))
            }, /*#__PURE__*/ $bSJIT.createElement($daae654e951eab1b$var$Subtitle, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $d4WXs.default).checkYourEmail))), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), null, intl.formatMessage((0, $d4WXs.default).emailHasBeenSentMessage, {
                    emailAddress: email
                }))
            }, /*#__PURE__*/ $bSJIT.createElement("div", null, intl.formatMessage((0, $d4WXs.default).emailHasBeenSentMessage, {
                emailAddress: email
            }))), /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
                appearance: 'primary',
                onClick: this.onResendButtonClick,
                actionSubjectId: "returnToLogin",
                shouldFitContainer: true,
                isLoading: this.state.isSendingForgotPasswordEmail
            }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $d4WXs.default).resendResetPasswordLinkLabel)));
        };
    }
}
var $daae654e951eab1b$export$2e2bcd8739ae039 = (0, $fK3tS.default)($daae654e951eab1b$export$3ed80e0e31a57da);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $daae654e951eab1b$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-11c9vcd-0"
})`> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $daae654e951eab1b$var$Title = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-11c9vcd-1"
})`${(0, $98sDU.h700)};margin-bottom:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $daae654e951eab1b$var$Subtitle = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-11c9vcd-2"
})`${(0, $98sDU.h600)};`;

});
parcelRegister("dL7Y8", function(module, exports) {
$parcel$export(module.exports, "default", () => $423cfebca01c03de$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $423cfebca01c03de$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    documentTitle: {
        defaultMessage: 'Customer Login - Help Center',
        description: 'Browser document title shown on the customer login page of the help center',
        id: 'cv.login.document.title'
    },
    header: {
        defaultMessage: 'Log in to {helpCenterName}',
        description: 'Heading shown at the top of the login page, where {helpCenterName} is the name of the help center',
        id: 'cv.login.header'
    },
    helpCenterLink: {
        defaultMessage: 'Go to { helpCenterName } home page',
        description: 'Text for link that redirects to the portals home page',
        id: 'cv.login.helpcenter.link'
    },
    description: {
        defaultMessage: 'Enter your email to log in or sign up',
        description: 'Description shown about the initial login screen',
        id: 'cv.login.description'
    },
    descriptionLogin: {
        defaultMessage: 'Log in to continue',
        description: 'Description shown after email check is customer login',
        id: 'cv.login.description.login'
    },
    useAtlassianAccountLogin: {
        defaultMessage: 'Use Atlassian account to log in',
        description: 'Description shown when login form is in atlassian SSO state',
        id: 'cv.login.use.atlassian.account.log.in'
    },
    useAtlassianAccountSignup: {
        defaultMessage: 'Use Atlassian account to sign up',
        description: 'Description shown when login form is in atlassian JIT state',
        id: 'cv.login.use.atlassian.account.sign.up'
    },
    backButton: {
        defaultMessage: 'Back',
        description: 'Button text for navigating back in the login screen',
        id: 'cv.login.back.button'
    },
    noLoginMethodWarningContent: {
        defaultMessage: 'Access to the help center is unavailable. Try again later or contact your admin for assistance.',
        description: 'No available login method warning content',
        id: 'cv.login.no.login.method.warning.content'
    }
});

});

parcelRegister("d4WXs", function(module, exports) {
$parcel$export(module.exports, "default", () => $ede7585a33b38aaa$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ede7585a33b38aaa$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    checkYourEmail: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Help text to tell user check their mailbox for reset password email',
        id: 'cv.login.forgot.password.check.your.email'
    },
    emailHasBeenSentMessage: {
        defaultMessage: "We've sent a reset password link to {emailAddress}",
        description: 'A help text to inform the user that email has been sent',
        id: 'cv.login.forgot.password.email.has.been.sent'
    },
    resendResetPasswordLinkLabel: {
        defaultMessage: 'Resend reset password link',
        description: 'label for Resend reset password link button',
        id: 'cv.login.forgot.password.resend.button.label'
    },
    resendSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'Success notification confirming the reset password email was sent to {emailAddress}',
        id: 'cv.login.forgot.password.resend.success.flag.message'
    }
});

});




parcelRegister("2IrKm", function(module, exports) {
$parcel$export(module.exports, "LoginAnnouncement", () => (parcelRequire("4Q1cK")).default);

var $4Q1cK = parcelRequire("4Q1cK");

});
parcelRegister("4Q1cK", function(module, exports) {
$parcel$export(module.exports, "default", () => $326f43a4726eb829$export$2e2bcd8739ae039);

var $4LEjO = parcelRequire("4LEjO");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $fuVmc = parcelRequire("fuVmc");

var $9K7mZ = parcelRequire("9K7mZ");

var $fKGH0 = parcelRequire("fKGH0");

var $a2qIF = parcelRequire("a2qIF");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $4GfBw = parcelRequire("4GfBw");
// Since LoginAnnouncement epic is made for home page which get messages as plain text, we can't use this epic for our use case, hence we are using useLazyLoadQuery to get the data using graphql query
const $326f43a4726eb829$var$LoginAnnouncement = ()=>{
    var _data$helpCenter, _data$helpCenter2;
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $4LEjO.default), {
        helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
        cloudId: (0, $fuVmc.getCloudId)()
    });
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') // not displaying anything if the response is not of type HelpCenter
    return null;
    // As confirmed by the backend team, there will be only one login announcement for now, hence using the first element
    const announcementDetails = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.announcements) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.loginAnnouncements) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2[0];
    const loginAnnouncementSubject = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.name) ?? '';
    const loginAnnouncementMessage = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.description) ?? '';
    const loginAnnouncementDescriptionType = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.descriptionType) ?? '';
    const isAnnouncementValid = (0, $4GfBw.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
    if (!isAnnouncementValid) // not displaying anything if the announcement is not valid or the description type is not WIKI_MARKUP
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $326f43a4726eb829$var$loginAnnouncementContainerStyles
    }, loginAnnouncementSubject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "small"
    }, loginAnnouncementSubject) : null, loginAnnouncementMessage && loginAnnouncementDescriptionType === 'WIKI_MARKUP' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $326f43a4726eb829$var$loginAnnouncementBodyStyles,
        dangerouslySetInnerHTML: {
            __html: (0, $fKGH0.sanitize)(loginAnnouncementMessage)
        }
    }) : null);
};
const $326f43a4726eb829$var$LoginAnnouncementLoader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).LOGIN,
        id: 'login-announcements'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($326f43a4726eb829$var$LoginAnnouncement, null)));
};
var $326f43a4726eb829$export$2e2bcd8739ae039 = $326f43a4726eb829$var$LoginAnnouncementLoader;
const $326f43a4726eb829$var$loginAnnouncementContainerStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.300',
    paddingBottom: 'space.200',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"}`
});
const $326f43a4726eb829$var$loginAnnouncementBodyStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    maxWidth: $9K7mZ.multiple(42).px,
    overflowWrap: 'break-word'
});

});
parcelRegister("4LEjO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b412421645025d92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d45b845761ae33b6af2ca93974f3307>>
 * @relayHash 81efd7e37c8c0c5533e02b03e01e4763
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2
const $b412421645025d92$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "descriptionType"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2",
            "metadata": {},
            "name": "loginAnnouncementsCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b412421645025d92$var$node.hash = "263cd15a061b12291f170e7431e9e440";
var $b412421645025d92$export$2e2bcd8739ae039 = $b412421645025d92$var$node;

});



parcelRegister("jAyoL", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => (parcelRequire("la94X")).default);

var $la94X = parcelRequire("la94X");

});
parcelRegister("la94X", function(module, exports) {
$parcel$export(module.exports, "default", () => $c23bb7130e1dc550$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("kYL0m");
var $xAy39 = parcelRequire("xAy39");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("MMHHf");
var $cj7fd = parcelRequire("cj7fd");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $5GPlc = parcelRequire("5GPlc");
var $c23bb7130e1dc550$export$2e2bcd8739ae039 = (0, $f2mlD.default)((state)=>({
        loginAnnouncementLocale: (0, $cj7fd.getLoginAnnouncementLocale)(state),
        baseUrl: (0, $fOlM6.getBaseUrl)(state)
    }), {
    changeEmailInputAction: (0, $xAy39.changeEmailInput),
    checkLoginActionAction: (0, $xAy39.checkLoginAction),
    forgotPasswordAction: (0, $xAy39.forgotPassword),
    createPasswordAction: (0, $xAy39.createPassword),
    loginAttemptAction: (0, $xAy39.loginAttempt),
    resetLoginAction: (0, $xAy39.resetLogin)
})((0, $2usNr.default)({
    componentName: 'loginForm'
})((0, $kIbto.default)()((0, $5GPlc.LoginForm))));

});
parcelRegister("5GPlc", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => $3338a98960395f24$export$1f58f750f20f344b);

var $bSJIT = parcelRequire("bSJIT");

var $i2WqQ = parcelRequire("i2WqQ");

var $lFpPv = parcelRequire("lFpPv");

var $677lk = parcelRequire("677lk");

var $gV613 = parcelRequire("gV613");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $oORS9 = parcelRequire("oORS9");

var $oORS9 = parcelRequire("oORS9");
parcelRequire("cWCk9");
var $gfOjd = parcelRequire("gfOjd");

var $dOout = parcelRequire("dOout");
// eslint-disable-next-line no-useless-escape
const $3338a98960395f24$var$EMAIL_PATTERN = /.+\@.+\..+/;
class $3338a98960395f24$export$1f58f750f20f344b extends $bSJIT.Component {
    buildAuthDataRequest() {
        const isInIframe = window.self !== window.top;
        const { destination: destination, isAbsolute: isAbsolute } = (0, $oORS9.parseLoginSignupRedirectUrlParams)();
        const prefix = destination && isAbsolute ? '' : `${(0, $eDcdn.getBaseName)()}/`;
        const redirectUrl = `${prefix}${destination || this.getDefaultDestination()}`;
        const params = new URLSearchParams((0, $gYDJY.search)());
        return isInIframe && (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? {
            ssoTest: (0, $oORS9.getSsoTestModeParamFromUrl)(params),
            redirectTo: '/servicedesk/customer/embeds/login-success',
            absoluteRedirectUrl: false
        } : {
            ssoTest: (0, $oORS9.getSsoTestModeParamFromUrl)(params),
            redirectTo: redirectUrl,
            absoluteRedirectUrl: isAbsolute
        };
    }
    render() {
        var _loginUIState$loginAt;
        const { canResetPassword: canResetPassword, loginUIState: loginUIState, contactAdminLink: contactAdminLink, loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        const { validEmail: validEmail, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit, password: password } = this.state;
        return /*#__PURE__*/ $bSJIT.createElement((0, $gfOjd.default), {
            isSubmitting: loginUIState.isSubmitting,
            isSendingForgotPasswordEmail: loginUIState.isSendingForgotPasswordEmail,
            isSendingCreatePasswordEmail: loginUIState.isSendingCreatePasswordEmail,
            onSubmit: this.onSubmit,
            onEmailFieldChange: this.onEmailFieldChange,
            onPasswordChange: this.onPasswordChange,
            validEmail: validEmail,
            isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit,
            email: loginUIState.email,
            password: password,
            loginError: this.getLoginError(),
            atlassianAccountCheckPerformed: loginUIState.atlassianAccountCheckPerformed,
            loginFailure: (_loginUIState$loginAt = loginUIState.loginAttemptResponse) === null || _loginUIState$loginAt === void 0 ? void 0 : _loginUIState$loginAt.error,
            showLoginConsentError: loginUIState.showLoginConsentErrorPage,
            createAnalyticsEvent: this.props.createAnalyticsEvent,
            onEmailFieldFocus: this.onEmailFieldFocus,
            onForgotPasswordLinkClick: this.onForgotPasswordLinkClick,
            onCreatePasswordLinkClick: this.onCreatePasswordLinkClick,
            contactAdminLink: contactAdminLink,
            canResetPassword: canResetPassword,
            loginAnnouncementLocale: loginAnnouncementLocale
        });
    }
    constructor(...args){
        super(...args), this.state = {
            password: '',
            validEmail: true,
            isPasswordEmptyOnSubmit: false
        }, this.onEmailFieldChange = (email)=>{
            this.props.changeEmailInputAction(email);
        }, this.onEmailFieldFocus = ()=>{
            if (!this.props.loginUIState.email) this.props.resetLoginAction(this.props.loginUIState.email);
        }, this.onPasswordChange = (password)=>{
            this.setState({
                password: password
            });
        }, this.validateEmail = ()=>{
            const validEmail = $3338a98960395f24$var$EMAIL_PATTERN.test(this.props.loginUIState.email);
            this.setState({
                validEmail: validEmail
            });
            return validEmail;
        }, this.onSubmit = ()=>{
            if (this.validateEmail()) {
                const { loginUIState: loginUIState, loginAttemptAction: loginAttemptAction, checkLoginActionAction: checkLoginActionAction, createAnalyticsEvent: createAnalyticsEvent, continueParam: continueParam } = this.props;
                const authData = this.buildAuthDataRequest();
                const { password: password } = this.state;
                if (loginUIState.atlassianAccountCheckPerformed) {
                    const isPasswordEmptyOnSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ)))(password);
                    this.setState({
                        isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit
                    });
                    if (!isPasswordEmptyOnSubmit) loginAttemptAction({
                        password: password,
                        continueParam: continueParam,
                        email: loginUIState.email.trim()
                    });
                } else checkLoginActionAction(loginUIState.email.trim(), this.props.portalId, authData, createAnalyticsEvent);
            } else (0, $gV613.focus)('user-email');
        }, this.getDefaultDestination = ()=>{
            const { portalId: portalId } = this.props;
            if (portalId) return `portal/${portalId}`;
            return 'portals';
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $oORS9.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onForgotPasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, forgotPasswordAction: forgotPasswordAction, resetUrl: resetUrl, baseUrl: baseUrl } = this.props;
            const redirectUrl = this.getRedirectUrl(baseUrl);
            forgotPasswordAction(resetUrl, loginUIState.email.trim(), redirectUrl);
        }, this.onCreatePasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, createPasswordAction: createPasswordAction, resetUrl: resetUrl } = this.props;
            createPasswordAction(resetUrl, loginUIState.email.trim());
        }, this.getLoginError = ()=>{
            const { error: error, loginAttemptResponse: loginAttemptResponse } = this.props.loginUIState;
            if (error) return error.description;
            const loginFailure = loginAttemptResponse === null || loginAttemptResponse === void 0 ? void 0 : loginAttemptResponse.error;
            if (loginFailure) switch(loginFailure.errorType){
                case (0, $677lk.LoginAttemptErrorType).INVALID_CREDENTIALS:
                    return (0, $dOout.default).invalidLogin;
                case (0, $677lk.LoginAttemptErrorType).ACCOUNT_LOCKED_ERROR:
                    return (0, $dOout.default).accountLocked;
                case (0, $677lk.LoginAttemptErrorType).MISC_LOGIN_ERROR:
                default:
                    return (0, $dOout.default).miscLoginError;
            }
            return undefined;
        };
    }
}

});
parcelRegister("cWCk9", function(module, exports) {
$parcel$export(module.exports, "LoginFormStateless", () => (parcelRequire("gfOjd")).default);

var $gfOjd = parcelRequire("gfOjd");

});
parcelRegister("gfOjd", function(module, exports) {
$parcel$export(module.exports, "default", () => $809f5244ca7b691d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $lCAV6 = parcelRequire("lCAV6");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $677lk = parcelRequire("677lk");
parcelRequire("jAqu4");
var $7EEQC = parcelRequire("7EEQC");
parcelRequire("j2RlN");
var $bnZwM = parcelRequire("bnZwM");
parcelRequire("3gTkE");
var $h8PIN = parcelRequire("h8PIN");
parcelRequire("frkfX");
var $8q9dQ = parcelRequire("8q9dQ");

var $dwOcU = parcelRequire("dwOcU");

var $aRsbV = parcelRequire("aRsbV");

var $buKRr = parcelRequire("buKRr");

var $haAAx = parcelRequire("haAAx");

var $iydAA = parcelRequire("iydAA");

var $gV613 = parcelRequire("gV613");

var $k4dp8 = parcelRequire("k4dp8");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $16GZB = parcelRequire("16GZB");
const $809f5244ca7b691d$var$USER_EMAIL_ID = 'user-email';
const $809f5244ca7b691d$var$SUBMIT_BUTTON_ID = 'login-button';
const $809f5244ca7b691d$var$USER_PASSWORD_ID = 'user-password';
class $809f5244ca7b691d$export$464b5747f72597dd extends $bSJIT.Component {
    getForm() {
        return /*#__PURE__*/ $bSJIT.createElement($809f5244ca7b691d$var$Form, {
            id: "login-form",
            "data-testid": "login-form",
            onSubmit: this.onSubmit
        }, this.getLoginError(), this.getLoginConsentError(), this.getEmailField(), this.getPasswordField(), this.getSubmitButton());
    }
    render() {
        const { loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: loginAnnouncementLocale ? {
                attributes: {
                    loginAnnouncementLocale: loginAnnouncementLocale
                }
            } : {}
        }, this.getForm(), this.getForgotPasswordLink(), this.getSetPasswordLink(), /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null));
    }
    constructor(...args){
        super(...args), this.onSubmit = (event)=>{
            if (event) event.preventDefault();
            // We need to do this here in order to work on chrome. Calling this method on password field focus
            // had no effect.
            this.blurEmailFieldAndFocusSubmitButton();
            this.cleanErrorCodeFromParams();
            this.props.onSubmit();
        }, this.blurEmailFieldAndFocusSubmitButton = ()=>{
            /*
     * We need to blur the email field this way because when typing an email clicking the submit button after (for checking atlassian account)
     * does not blur the email field on Chrome and Edge. So after clicking the button it looks like the email and password field have the focus.
     * There is no way to reference the html element on @atlaskit/textfield that's why we use document.getElementById .
     */ (0, $gV613.blur)($809f5244ca7b691d$var$USER_EMAIL_ID);
            /*
     * In order to create an understandable focus state on errors (and it will be the same one when using keyboard or clicking the button)
     * we need to focus the button after calling blur on the email text field.
     */ (0, $gV613.focus)($809f5244ca7b691d$var$SUBMIT_BUTTON_ID);
        }, this.cleanErrorCodeFromParams = ()=>{
            const params = new URLSearchParams((0, $gYDJY.search)());
            if (params.has('error_code')) {
                params.delete('error_code');
                (0, $eDcdn.default).replace({
                    search: params.toString()
                });
            }
        }, this.onEmailFieldChange = (_, email)=>{
            this.props.onEmailFieldChange(email);
        }, this.onPasswordChange = (password)=>{
            this.props.onPasswordChange(password);
        }, this.getEmailErrorMessage = ()=>{
            if (this.props.validEmail) return undefined;
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $16GZB.default).invalidEmailError);
        }, this.getPasswordErrorMessage = ()=>{
            const { intl: intl } = this.props;
            if (this.props.isPasswordEmptyOnSubmit) return intl.formatMessage((0, $16GZB.default).emptyPasswordError);
            return intl.formatMessage((0, $16GZB.default).incorrectPasswordError);
        }, this.getPasswordField = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, password: password, intl: intl, loginFailure: loginFailure, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit } = this.props;
            if (atlassianAccountCheckPerformed) {
                const isInvalid = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) === (0, $677lk.LoginAttemptErrorType).INVALID_CREDENTIALS || isPasswordEmptyOnSubmit;
                const passwordLabelAndPlaceholder = intl.formatMessage((0, $16GZB.default).passwordLabelAndPlaceholder);
                return /*#__PURE__*/ $bSJIT.createElement((0, $bnZwM.default), {
                    label: passwordLabelAndPlaceholder,
                    htmlFor: $809f5244ca7b691d$var$USER_PASSWORD_ID
                }, /*#__PURE__*/ $bSJIT.createElement((0, $8q9dQ.default), {
                    id: $809f5244ca7b691d$var$USER_PASSWORD_ID,
                    testId: $809f5244ca7b691d$var$USER_PASSWORD_ID,
                    value: password,
                    onChange: this.onPasswordChange,
                    isDisabled: isSubmitting || isSendingForgotPasswordEmail,
                    errorMessage: this.getPasswordErrorMessage(),
                    isInvalid: isInvalid,
                    hideStrengthMeter: true,
                    autoFocus: true
                }));
            }
            return undefined;
        }, this.getButtonText = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, intl: intl } = this.props;
            if (!atlassianAccountCheckPerformed) return intl.formatMessage((0, $16GZB.default).nextButton);
            return intl.formatMessage((0, $16GZB.default).continueButton);
        }, this.getSetPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onCreatePasswordLinkClick: onCreatePasswordLinkClick, isSubmitting: isSubmitting, isSendingCreatePasswordEmail: isSendingCreatePasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword && onCreatePasswordLinkClick) return /*#__PURE__*/ $bSJIT.createElement($809f5244ca7b691d$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $bSJIT.createElement("div", null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $16GZB.default).dontHavePasswordText)), /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
                id: "set-password-link",
                testId: "set-password-link",
                appearance: "link",
                onClick: onCreatePasswordLinkClick,
                actionSubjectId: "createPassword",
                isDisabled: isSubmitting,
                isLoading: isSendingCreatePasswordEmail
            }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $16GZB.default).createPasswordLink)));
            return undefined;
        }, this.getForgotPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onForgotPasswordLinkClick: onForgotPasswordLinkClick, intl: intl, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword) {
                const linkText = intl.formatMessage((0, $16GZB.default).resetPasswordLink);
                return /*#__PURE__*/ $bSJIT.createElement($809f5244ca7b691d$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
                    id: "forgot-password-link",
                    testId: "forgot-password-link",
                    appearance: "link",
                    onClick: onForgotPasswordLinkClick,
                    actionSubjectId: "forgotPassword",
                    isDisabled: isSubmitting,
                    isLoading: isSendingForgotPasswordEmail
                }, linkText));
            }
            return undefined;
        }, this.getLoginError = ()=>{
            return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, this.getErrorFromParams(), this.getLoginErrorOnSubmitting());
        }, this.getLoginConsentError = ()=>{
            if (this.props.showLoginConsentError) {
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                createAnalyticsEvent && createAnalyticsEvent({
                    analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                    action: 'viewed',
                    actionSubjectId: `showConsentError`
                }).fire();
                return /*#__PURE__*/ $bSJIT.createElement((0, $buKRr.default), {
                    appearance: "warning",
                    testId: "login-consent-error"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $16GZB.default).loginConsentErrorMessage));
            }
            return undefined;
        }, this.getLoginErrorOnSubmitting = ()=>{
            const { intl: intl, loginError: loginError, loginFailure: loginFailure, contactAdminLink: contactAdminLink } = this.props;
            const notInvalidCredentials = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) !== (0, $677lk.LoginAttemptErrorType).INVALID_CREDENTIALS;
            if (loginError && notInvalidCredentials) return /*#__PURE__*/ $bSJIT.createElement("div", {
                "aria-live": "assertive",
                role: "alert"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $buKRr.default), {
                appearance: "error",
                testId: "login-error-on-submit-section"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
                ...loginError,
                values: {
                    contactAdminLink: /*#__PURE__*/ $bSJIT.createElement($809f5244ca7b691d$export$8ffc1cb9f69665da, {
                        dangerouslySetInnerHTML: {
                            __html: contactAdminLink
                        }
                    }),
                    forgotPasswordLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                    /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                        migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), {
                            weight: "semibold"
                        }, intl.formatMessage((0, $16GZB.default).resetPasswordLinkInlineBold))
                    }, /*#__PURE__*/ $bSJIT.createElement("strong", null, intl.formatMessage((0, $16GZB.default).resetPasswordLinkInlineBold)))
                }
            })));
            return undefined;
        }, this.getErrorFromParams = ()=>{
            const { intl: intl } = this.props;
            const params = new URLSearchParams((0, $gYDJY.search)());
            const errorCode = params.get('error_code');
            if (errorCode) {
                const errorMessage = errorCode === 'access_denied' ? intl.formatMessage((0, $16GZB.default).accessDeniedErrorCodeMessage) : intl.formatMessage((0, $16GZB.default).defaultErrorCodeMessage);
                return /*#__PURE__*/ $bSJIT.createElement((0, $buKRr.default), {
                    appearance: "error"
                }, errorMessage);
            }
            return undefined;
        }, this.getEmailField = ()=>{
            const { intl: intl, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, email: email, onEmailFieldFocus: onEmailFieldFocus } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement((0, $7EEQC.default), {
                name: 'login-email-field'
            }, /*#__PURE__*/ $bSJIT.createElement((0, $h8PIN.default), {
                id: $809f5244ca7b691d$var$USER_EMAIL_ID,
                shouldFitContainer: true,
                label: intl.formatMessage((0, $16GZB.default).emailLabel),
                onChange: this.onEmailFieldChange,
                errorMessage: this.getEmailErrorMessage(),
                ariaDescribedby: "field-error",
                disabled: isSubmitting || isSendingForgotPasswordEmail || atlassianAccountCheckPerformed,
                defaultValue: email,
                onFocus: onEmailFieldFocus,
                autoComplete: "email",
                autoFocus: !this.props.showLoginConsentError
            }));
        }, this.getSubmitButton = ()=>{
            const { isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed } = this.props;
            const buttonText = this.getButtonText();
            const buttonActionSubjectId = atlassianAccountCheckPerformed ? 'submitLoginForm' : 'checkLoginEmail';
            return /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
                id: $809f5244ca7b691d$var$SUBMIT_BUTTON_ID,
                testId: $809f5244ca7b691d$var$SUBMIT_BUTTON_ID,
                type: "submit",
                appearance: "primary",
                shouldFitContainer: true,
                isLoading: isSubmitting,
                isDisabled: isSendingForgotPasswordEmail,
                actionSubjectId: buttonActionSubjectId
            }, buttonText);
        };
    }
}
var $809f5244ca7b691d$export$2e2bcd8739ae039 = (0, $fK3tS.default)($809f5244ca7b691d$export$464b5747f72597dd);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $809f5244ca7b691d$var$Form = /*#__PURE__*/ (0, $4v2A7.default).form.withConfig({
    componentId: "sc-1wf191w-0"
})`#login-button{margin-top:${"var(--ds-space-300, 24px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $809f5244ca7b691d$var$ForgotPasswordLinkContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1wf191w-1"
})`margin-top:${"var(--ds-space-300, 24px)"};text-align:center;`;
const $809f5244ca7b691d$export$8ffc1cb9f69665da = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1wf191w-2"
})`display:inline;`;

});
parcelRegister("jAqu4", function(module, exports) {
$parcel$export(module.exports, "DisableViewUntilMount", () => (parcelRequire("7EEQC")).default);

var $7EEQC = parcelRequire("7EEQC");

});
parcelRegister("7EEQC", function(module, exports) {
$parcel$export(module.exports, "default", () => $70cd4e31ab89174c$export$2e2bcd8739ae039);
/* disable-view-until-mount.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $70cd4e31ab89174c$var$DisableViewUntilMount = ({ children: children, name: name })=>{
    const componentPointerCssVar = `--pointer-events-${name}`;
    $bSJIT.useEffect(()=>{
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty(componentPointerCssVar, 'none');
    }, [
        componentPointerCssVar
    ]);
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": `disable-view-until-mount`,
        className: (0, $9fU1q.default)([
            "_1bsb1osq"
        ])
    }, children, /*#__PURE__*/ $bSJIT.createElement("div", {
        style: {
            // @ts-ignore // because we want to use a dynamic css variable
            pointerEvents: `var(${componentPointerCssVar}, auto)`
        },
        className: (0, $9fU1q.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _154iidpf _1ltvidpf _80omv00u"
        ])
    }));
};
var $70cd4e31ab89174c$export$2e2bcd8739ae039 = $70cd4e31ab89174c$var$DisableViewUntilMount;
const $70cd4e31ab89174c$var$componentWrapper = null;
const $70cd4e31ab89174c$var$loaderWrapper = null;

});


parcelRegister("j2RlN", function(module, exports) {
$parcel$export(module.exports, "FieldBase", () => (parcelRequire("bnZwM")).default);

var $bnZwM = parcelRequire("bnZwM");

});
parcelRegister("bnZwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c853e88738e64a6$export$2e2bcd8739ae039);
/* field-base.tsx generated by @compiled/babel-plugin v3.0.2 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $ekQN1 = parcelRequire("ekQN1");

var $7x378 = parcelRequire("7x378");

var $hkLEY = parcelRequire("hkLEY");

var $8aT4G = parcelRequire("8aT4G");

var $k4dp8 = parcelRequire("k4dp8");
parcelRequire("5C5Xh");
var $hpy77 = parcelRequire("hpy77");
const $3c853e88738e64a6$var$FieldBase = ({ label: label, labelId: labelId, required: required, errorMessage: errorMessage, description: description, children: children, noLabel: noLabel, htmlFor: htmlFor, tooltip: tooltip })=>{
    const isCSMTypographyMigrationEnabled = (0, $k4dp8.useIsCSMTypographyMigrationEnabled)();
    const renderField = ()=>noLabel ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3c853e88738e64a6$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ekQN1.Label), {
            htmlFor: htmlFor,
            id: labelId
        }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7x378.RequiredAsterisk), null), isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), null, "(required)")) : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3c853e88738e64a6$var$RequiredMessage, null, "(required)")), tooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, tooltip))), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-test-id": `request-field-${htmlFor}`
    }, renderField(), !!errorMessage && (isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_19pk1b66 _syaz1tmw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.danger",
        testId: "field-error-text",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3c853e88738e64a6$var$ErrorText, {
        "data-test-id": "field-error",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage))), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hpy77.default), {
        id: `${htmlFor}-field-description`
    }, description));
};
var $3c853e88738e64a6$export$2e2bcd8739ae039 = $3c853e88738e64a6$var$FieldBase;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3c853e88738e64a6$var$ErrorText = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-1tyod05-0"
})`${$98sDU.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3c853e88738e64a6$var$FieldContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pkpxbi _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $3c853e88738e64a6$var$errorIconWrapperCSS = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3c853e88738e64a6$var$RequiredMessage = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug",
            __cmplp.className
        ])
    });
});
const $3c853e88738e64a6$var$requireMessageCSS = null;
const $3c853e88738e64a6$var$errorMessageCSS = null;

});
parcelRegister("5C5Xh", function(module, exports) {
$parcel$export(module.exports, "FieldDescription", () => (parcelRequire("hpy77")).default);

var $hpy77 = parcelRequire("hpy77");

});
parcelRegister("hpy77", function(module, exports) {
$parcel$export(module.exports, "default", () => $8208dd3948c984c2$export$2e2bcd8739ae039);
/* field-description.tsx generated by @compiled/babel-plugin v3.0.2 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $jOwH0 = parcelRequire("jOwH0");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fK3tS = parcelRequire("fK3tS");

var $iBcfi = parcelRequire("iBcfi");

var $87QgR = parcelRequire("87QgR");

var $8aT4G = parcelRequire("8aT4G");

var $8Mb7N = parcelRequire("8Mb7N");

var $gV613 = parcelRequire("gV613");

var $k4dp8 = parcelRequire("k4dp8");

var $9vIci = parcelRequire("9vIci");
class $8208dd3948c984c2$export$873ced4623a3149c extends $bSJIT.PureComponent {
    componentDidMount() {
        this.checkIfShouldCollapse();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) this.checkIfShouldCollapse();
    }
    render() {
        const { intl: intl } = this.props;
        const { shouldCollapse: shouldCollapse, isOpen: isOpen } = this.state;
        const removeWidthObserver = (0, $87QgR.default).checkGate('remove_widthobserver_from_field_description');
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, removeWidthObserver ? null : /*#__PURE__*/ $bSJIT.createElement((0, $8Mb7N.WidthObserver), {
            setWidth: this.checkIfShouldCollapse
        }), shouldCollapse ? /*#__PURE__*/ $bSJIT.createElement($8208dd3948c984c2$export$b7e78554be83b35d, {
            onClick: this.onToggle
        }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iBcfi))), {
            expanded: isOpen,
            collapsedHeight: `${$8208dd3948c984c2$export$4ea46454a0bad5c3}px`
        }, this.renderHelpText()), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $bSJIT.createElement("div", {
                className: (0, $9fU1q.default)([
                    "_syaz131l"
                ])
            }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
                size: "small",
                color: "color.text.subtlest",
                weight: "medium"
            }, intl.formatMessage(isOpen ? (0, $9vIci.default).showLess : (0, $9vIci.default).showMore)))
        }, /*#__PURE__*/ $bSJIT.createElement($8208dd3948c984c2$export$5f734e3a73651e57, null, intl.formatMessage(isOpen ? (0, $9vIci.default).showLess : (0, $9vIci.default).showMore)))) : this.renderHelpText());
    }
    constructor(...args){
        super(...args), this.state = {
            shouldCollapse: false,
            isOpen: false
        }, this.helpTextRef = /*#__PURE__*/ $bSJIT.createRef(), this.checkIfShouldCollapse = ()=>{
            if (this.helpTextRef.current && (0, $gV613.getElementHeight)(this.helpTextRef.current) > $8208dd3948c984c2$export$4ea46454a0bad5c3) this.setState({
                shouldCollapse: true
            });
            else if (this.state.shouldCollapse) this.setState({
                shouldCollapse: false
            });
        }, this.onToggle = (e)=>{
            e.preventDefault();
            this.setState((prevState)=>({
                    isOpen: !prevState.isOpen
                }));
        }, this.renderHelpText = ()=>{
            const { children: children, id: id } = this.props;
            if (typeof children === 'string') return /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement($8208dd3948c984c2$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef,
                    dangerouslySetInnerHTML: {
                        __html: children
                    }
                })
            }, /*#__PURE__*/ $bSJIT.createElement($8208dd3948c984c2$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef,
                dangerouslySetInnerHTML: {
                    __html: children
                }
            }));
            return /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement($8208dd3948c984c2$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef
                }, children)
            }, /*#__PURE__*/ $bSJIT.createElement($8208dd3948c984c2$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef
            }, children));
        };
    }
}
var $8208dd3948c984c2$export$2e2bcd8739ae039 = (0, $fK3tS.default)($8208dd3948c984c2$export$873ced4623a3149c);
const $8208dd3948c984c2$export$a67c0bc59081311a = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-mimyi-0"
})`${$98sDU.xsmall};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $8208dd3948c984c2$export$29708599cbdda103 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-mimyi-1"
})`font:${"var(--ds-font-heading-xsmall, normal 600 0.875rem/1rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $8208dd3948c984c2$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-mimyi-2"
})`${$98sDU.xsmall};color:${"var(--ds-text-subtlest, #6B778C)"};font-weight:500;`;
const $8208dd3948c984c2$var$buttonTextCSS = null;
const $8208dd3948c984c2$export$b7e78554be83b35d = /*#__PURE__*/ (0, $4v2A7.default)((0, $jOwH0.default)).withConfig({
    componentId: "sc-mimyi-3"
})`display:block;`;
const $8208dd3948c984c2$export$4ea46454a0bad5c3 = $9K7mZ.multiple(4.5).unitless;

});
parcelRegister("iBcfi", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");

var $kH7Qm = parcelRequire("kH7Qm");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d8a52e6ae4db9289$var$_objectWithoutProperties2 = $vsDHM((parcelRequire("27OrM")));

var $d8a52e6ae4db9289$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $d8a52e6ae4db9289$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $d8a52e6ae4db9289$var$_assertThisInitialized2 = $vsDHM((parcelRequire("3ojnT")));

var $d8a52e6ae4db9289$var$_inherits2 = $vsDHM((parcelRequire("cWKCb")));

var $d8a52e6ae4db9289$var$_possibleConstructorReturn2 = $vsDHM((parcelRequire("jZYbL")));

var $d8a52e6ae4db9289$var$_getPrototypeOf2 = $vsDHM((parcelRequire("5LBNB")));

var $d8a52e6ae4db9289$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));

var $d8a52e6ae4db9289$var$React = $d8a52e6ae4db9289$var$_interopRequireWildcard((parcelRequire("bSJIT")));

var $d8a52e6ae4db9289$var$_propTypes = $vsDHM((parcelRequire("4yQYd")));

var $d8a52e6ae4db9289$var$_getTransitionTimeMs = $vsDHM((parcelRequire("kR6gt")));

var $dc70d = parcelRequire("dc70d");
var $d8a52e6ae4db9289$var$_excluded = [
    "allowOverflowWhenOpen",
    "children",
    "collapsedHeight",
    "eagerRender",
    "expanded",
    "heightTransition",
    "onChangeEnd"
];
function $d8a52e6ae4db9289$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d8a52e6ae4db9289$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d8a52e6ae4db9289$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $kH7Qm(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $d8a52e6ae4db9289$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d8a52e6ae4db9289$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d8a52e6ae4db9289$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d8a52e6ae4db9289$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $d8a52e6ae4db9289$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d8a52e6ae4db9289$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d8a52e6ae4db9289$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d8a52e6ae4db9289$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $d8a52e6ae4db9289$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d8a52e6ae4db9289$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $d8a52e6ae4db9289$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $d8a52e6ae4db9289$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $d8a52e6ae4db9289$var$SmoothCollapse = /*#__PURE__*/ function(_React$Component) {
    (0, $d8a52e6ae4db9289$var$_inherits2["default"])(SmoothCollapse, _React$Component);
    var _super = $d8a52e6ae4db9289$var$_createSuper(SmoothCollapse);
    function SmoothCollapse(props) {
        var _this;
        (0, $d8a52e6ae4db9289$var$_classCallCheck2["default"])(this, SmoothCollapse);
        _this = _super.call(this, props);
        (0, $d8a52e6ae4db9289$var$_defineProperty2["default"])((0, $d8a52e6ae4db9289$var$_assertThisInitialized2["default"])(_this), "_removeTransitionEndListener", function() {});
        (0, $d8a52e6ae4db9289$var$_defineProperty2["default"])((0, $d8a52e6ae4db9289$var$_assertThisInitialized2["default"])(_this), "_main", /*#__PURE__*/ $d8a52e6ae4db9289$var$React.createRef());
        (0, $d8a52e6ae4db9289$var$_defineProperty2["default"])((0, $d8a52e6ae4db9289$var$_assertThisInitialized2["default"])(_this), "_inner", /*#__PURE__*/ $d8a52e6ae4db9289$var$React.createRef());
        (0, $d8a52e6ae4db9289$var$_defineProperty2["default"])((0, $d8a52e6ae4db9289$var$_assertThisInitialized2["default"])(_this), "_onNextTransitionEnd", function(el, callback) {
            _this._removeTransitionEndListener();
            var listener = function listener() {
                _this._removeTransitionEndListener();
                callback();
            };
            var timeout;
            _this._removeTransitionEndListener = function() {
                _this._removeTransitionEndListener = function() {};
                clearTimeout(timeout);
                el.removeEventListener('transitionend', listener);
            }; // Wait until the transitionend event, or until a timer goes off in
            // case the event doesn't fire because the browser doesn't support it
            // or the element is hidden before it happens. The timer is a little
            // longer than the transition is supposed to take to make sure we don't
            // cut the animation early while it's still going if the browser is
            // running it just a little slow.
            el.addEventListener('transitionend', listener);
            var ms = (0, $d8a52e6ae4db9289$var$_getTransitionTimeMs["default"])(_this.props.heightTransition) * 1.1 + 500;
            timeout = setTimeout(listener, ms);
        });
        _this.state = {
            renderInner: props.expanded || SmoothCollapse._visibleWhenClosed(props),
            closing: false,
            fullyClosed: !props.expanded,
            height: props.expanded ? 'auto' : props.collapsedHeight
        };
        return _this;
    }
    (0, $d8a52e6ae4db9289$var$_createClass2["default"])(SmoothCollapse, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._removeTransitionEndListener();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                if (!prevProps.expanded && this.props.expanded) {
                    this._removeTransitionEndListener();
                    var mainEl = this._main.current;
                    var innerEl = this._inner.current;
                    if (!mainEl || !innerEl) throw new Error('Should not happen'); // Set the collapser to the target height instead of auto so that it
                    // animates correctly. Then switch it to 'auto' after the animation so
                    // that it flows correctly if the page is resized.
                    var targetHeight = "".concat(innerEl.clientHeight, "px");
                    this.setState({
                        height: targetHeight
                    });
                    this._onNextTransitionEnd(mainEl, function() {
                        _this2.setState({
                            height: 'auto'
                        }, function() {
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                } else if (prevProps.expanded && !this.props.expanded) {
                    this._removeTransitionEndListener();
                    if (!this._inner.current) throw new Error('Should not happen');
                    this.setState({
                        height: "".concat(this._inner.current.clientHeight, "px")
                    }, function() {
                        var mainEl = _this2._main.current;
                        if (!mainEl) throw new Error('Should not happen');
                        mainEl.clientHeight; // force the page layout
                        _this2.setState({
                            height: _this2.props.collapsedHeight,
                            closing: true
                        });
                        _this2._onNextTransitionEnd(mainEl, function() {
                            _this2.setState({
                                closing: false,
                                fullyClosed: true
                            });
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var visibleWhenClosed = SmoothCollapse._visibleWhenClosed(this.props);
                var _this$props = this.props, allowOverflowWhenOpen = _this$props.allowOverflowWhenOpen, children = _this$props.children, collapsedHeight = _this$props.collapsedHeight, eagerRender = _this$props.eagerRender, expanded = _this$props.expanded, heightTransition = _this$props.heightTransition, onChangeEnd = _this$props.onChangeEnd, props = (0, $d8a52e6ae4db9289$var$_objectWithoutProperties2["default"])(_this$props, $d8a52e6ae4db9289$var$_excluded);
                var _this$state = this.state, height = _this$state.height, fullyClosed = _this$state.fullyClosed, renderInner = _this$state.renderInner;
                var innerEl = renderInner ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    ref: this._inner,
                    style: {
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden'
                    },
                    children: children
                }) : null;
                return /*#__PURE__*/ (0, $dc70d.jsx)("div", $d8a52e6ae4db9289$var$_objectSpread($d8a52e6ae4db9289$var$_objectSpread({}, props), {}, {
                    ref: this._main,
                    style: {
                        height: height,
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden',
                        display: fullyClosed && !visibleWhenClosed ? 'none' : null,
                        transition: "height ".concat(heightTransition)
                    },
                    children: innerEl
                }));
            }
        }
    ], [
        {
            key: "_visibleWhenClosed",
            value: function _visibleWhenClosed(props) {
                return props.eagerRender || parseFloat(props.collapsedHeight) !== 0;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (props.expanded && (state.closing || state.fullyClosed)) return {
                    closing: false,
                    fullyClosed: false,
                    renderInner: true
                };
                else if (!props.expanded && (state.closing || state.fullyClosed) && state.height !== props.collapsedHeight) return {
                    height: props.collapsedHeight,
                    renderInner: state.renderInner || SmoothCollapse._visibleWhenClosed(props)
                };
                return null;
            }
        }
    ]);
    return SmoothCollapse;
}($d8a52e6ae4db9289$var$React.Component);
module.exports["default"] = $d8a52e6ae4db9289$var$SmoothCollapse;
(0, $d8a52e6ae4db9289$var$_defineProperty2["default"])($d8a52e6ae4db9289$var$SmoothCollapse, "propTypes", {
    expanded: $d8a52e6ae4db9289$var$_propTypes["default"].bool.isRequired,
    onChangeEnd: $d8a52e6ae4db9289$var$_propTypes["default"].func,
    collapsedHeight: $d8a52e6ae4db9289$var$_propTypes["default"].string,
    heightTransition: $d8a52e6ae4db9289$var$_propTypes["default"].string,
    className: $d8a52e6ae4db9289$var$_propTypes["default"].string,
    allowOverflowWhenOpen: $d8a52e6ae4db9289$var$_propTypes["default"].bool,
    eagerRender: $d8a52e6ae4db9289$var$_propTypes["default"].bool
});
(0, $d8a52e6ae4db9289$var$_defineProperty2["default"])($d8a52e6ae4db9289$var$SmoothCollapse, "defaultProps", {
    collapsedHeight: '0',
    heightTransition: '.25s ease',
    className: '',
    allowOverflowWhenOpen: false,
    eagerRender: false
});

});
parcelRegister("27OrM", function(module, exports) {

var $g4Uat = parcelRequire("g4Uat");
function $18c35dede6dfd35d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $g4Uat(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $18c35dede6dfd35d$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bU4DC", function(module, exports) {
function $8aa885b193e0c783$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $8aa885b193e0c783$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ho58I", function(module, exports) {

var $17baj = parcelRequire("17baj");
function $ca88aa2d98419754$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $17baj(o.key), o);
    }
}
function $ca88aa2d98419754$var$_createClass(e, r, t) {
    return r && $ca88aa2d98419754$var$_defineProperties(e.prototype, r), t && $ca88aa2d98419754$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $ca88aa2d98419754$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cWKCb", function(module, exports) {

var $6vKeh = parcelRequire("6vKeh");
function $96cf0f8aa7cfa03a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $6vKeh(t, e);
}
module.exports = $96cf0f8aa7cfa03a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jZYbL", function(module, exports) {

var $kH7Qm = parcelRequire("kH7Qm");
var $e8f267138f747ffe$var$_typeof = $kH7Qm.default;

var $3ojnT = parcelRequire("3ojnT");
function $e8f267138f747ffe$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $e8f267138f747ffe$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $3ojnT(t);
}
module.exports = $e8f267138f747ffe$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5LBNB", function(module, exports) {
function $432ea9a0dd932ee1$var$_getPrototypeOf(t) {
    return module.exports = $432ea9a0dd932ee1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $432ea9a0dd932ee1$var$_getPrototypeOf(t);
}
module.exports = $432ea9a0dd932ee1$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kR6gt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f2ed9dee1ea3841a$var$getTransitionTimeMs;
function $f2ed9dee1ea3841a$var$getTransitionTimeMs(heightTransition) {
    var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
    if (!m) throw new Error('Could not parse time from transition value');
    return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}

});


parcelRegister("9vIci", function(module, exports) {
$parcel$export(module.exports, "default", () => $0345804a82aecd0f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $0345804a82aecd0f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    showMore: {
        defaultMessage: 'Show more...',
        description: 'Button action text to expand a form fields description',
        id: 'cv.field-base.description.show-more'
    },
    showLess: {
        defaultMessage: 'Show less...',
        description: 'Button action text to collapse a form fields description',
        id: 'cv.field-base.description.show-less'
    }
});

});





parcelRegister("3gTkE", function(module, exports) {
$parcel$export(module.exports, "TextField", () => (parcelRequire("h8PIN")).default);
$parcel$export(module.exports, "ControlledTextField", () => (parcelRequire("h8PIN")).ControlledTextField);

var $h8PIN = parcelRequire("h8PIN");

});
parcelRegister("h8PIN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2904e36c4173dfd5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ControlledTextField", () => $2904e36c4173dfd5$export$befa4be8e9119768);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("j2RlN");
var $bnZwM = parcelRequire("bnZwM");

var $jgsO4 = parcelRequire("jgsO4");
parcelRequire("96iPn");
var $a6XFx = parcelRequire("a6XFx");
class $2904e36c4173dfd5$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    static #_ = this.defaultProps = {
        shouldFitContainer: true,
        type: 'text'
    };
    render() {
        const { id: id, testId: testId, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, maxLength: maxLength, disabled: disabled, render: render, placeholder: placeholder, isLabelHidden: isLabelHidden, type: type, autoFocus: autoFocus, value: value, onFocus: onFocus, onKeyDown: onKeyDown, ariaDescribedby: ariaDescribedby, autoComplete: autoComplete, ariaLabelledby: ariaLabelledby, tooltip: tooltip, isInvalid: isInvalidProp } = this.props;
        const isInvalid = isInvalidProp || !(0, $4ZMmh.isEmpty)(errorMessage);
        const inputType = type;
        /** Currently to match the legacy behavior in some cases we are passing both value and defaultValue
     * there will be a sentry alert to either use controlled or uncontrolled but not both
     * to prevent this we only pass one of value or defaultValue
     * such scenarios can be avoided once we clean the legacy code
     * when cleaning up feature flag see if this can be removed
     */ const isValueDefined = typeof value === 'string';
        const textFieldValueProps = isValueDefined ? {
            value: value
        } : {
            defaultValue: defaultValue
        };
        const ariaDescribedByText = ariaDescribedby || `${id}-field-description ${isInvalid ? 'field-error' : ''}`;
        const ariaLabelledByText = ariaLabelledby || `${id}-label`;
        const field = /*#__PURE__*/ $bSJIT.createElement((0, $jgsO4.default), {
            id: id,
            testId: testId,
            name: id,
            "aria-describedby": ariaDescribedByText,
            "aria-labelledby": ariaLabelledByText,
            "aria-invalid": isInvalid,
            "aria-required": required,
            ...textFieldValueProps,
            onChange: this.onChange,
            isInvalid: isInvalid,
            isDisabled: disabled,
            placeholder: placeholder,
            type: inputType,
            maxLength: maxLength,
            autoFocus: autoFocus,
            onFocus: onFocus,
            onBlur: this.onBlur,
            onKeyDown: onKeyDown,
            autoComplete: autoComplete
        });
        return /*#__PURE__*/ $bSJIT.createElement((0, $bnZwM.default), {
            htmlFor: id,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage,
            noLabel: isLabelHidden,
            labelId: `${id}-label`,
            ...(0, $lFpPv.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, render ? render(field) : field);
    }
    constructor(...args){
        super(...args), this.inputRef = /*#__PURE__*/ $bSJIT.createRef(), //TODO - We need to find a better way to add focus to input field when there is an error. This should be done in the form component. https://hello.jira.atlassian.cloud/browse/CHANNELSUI-258
        this.onChange = (e)=>{
            if (this.props.onChange) this.props.onChange(this.props.id, e.target.value, false, {
                rawObject: e,
                rawValue: e.target.value
            });
        }, this.onBlur = (e)=>{
            if (this.props.onFieldBlurredByUser) this.props.onFieldBlurredByUser({
                field: this.props.id,
                value: e.target.value,
                additionalFieldData: {
                    rawObject: e,
                    rawValue: e.target.value
                }
            });
            if (this.props.onBlur) this.props.onBlur();
        };
    }
}
const $2904e36c4173dfd5$export$befa4be8e9119768 = (0, $a6XFx.withControlledFormComponentValue)((_field, value)=>value)($2904e36c4173dfd5$export$2e2bcd8739ae039);

});
parcelRegister("96iPn", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => (parcelRequire("a6XFx")).withControlledFormComponentValue);

var $a6XFx = parcelRequire("a6XFx");

});
parcelRegister("a6XFx", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => $c1768b8e409e4c6f$export$cd499d091f6810cd);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $fSlcK = parcelRequire("fSlcK");
function $c1768b8e409e4c6f$export$cd499d091f6810cd(mapOnChangeValue, valueTransformer) {
    return (FormComponent)=>class ControlledFormComponentWrapper extends $bSJIT.PureComponent {
            static #_ = this.displayName = 'ControlledFormComponentWrapper';
            componentDidUpdate(prevProps, prevState) {
                // Handle valueOverride changes (UI Modifications)
                if (this.checkIsValueOverride() && this.props.valueOverride !== prevProps.valueOverride && this.props.valueOverride !== prevState.controlledValue) this.setState({
                    controlledValue: this.props.valueOverride
                });
                // Handle external value changes (native automation rules, form resets, etc.)
                if ((0, $lFpPv.isMultiSelectEnabled)() && this.props.value !== prevProps.value && this.props.value !== prevState.controlledValue && !this.checkIsValueOverride()) this.setState({
                    controlledValue: this.props.value
                });
            }
            render() {
                const { defaultValue: _1, value: _2, valueOverride: _3, onChange: _4, ...remainingProps } = this.props;
                if ((0, $lFpPv.isUiModificationsSupportEnabled)()) {
                    const transformedValue = valueTransformer ? valueTransformer(this.state.controlledValue) : this.state.controlledValue;
                    const componentProps = {
                        ...remainingProps,
                        value: transformedValue,
                        onChange: this.onChange,
                        shouldReplaceValue: this.checkIsValueOverride()
                    };
                    return /*#__PURE__*/ $bSJIT.createElement((0, $fSlcK.FieldDecoratorAsync), {
                        Component: FormComponent,
                        componentProps: componentProps
                    });
                }
                return /*#__PURE__*/ $bSJIT.createElement(FormComponent, {
                    ...remainingProps,
                    value: this.state.controlledValue,
                    onChange: this.onChange
                });
            }
            constructor(...args){
                super(...args), this.checkIsValueOverride = ()=>{
                    if (this.props.valueOverride === null || this.props.valueOverride === '' || this.props.valueOverride) return true;
                    return false;
                }, this.state = {
                    controlledValue: this.checkIsValueOverride() ? this.props.valueOverride : this.props.defaultValue
                }, this.onChange = (...args)=>{
                    var _this$props$onChange, _this$props;
                    this.setState({
                        controlledValue: mapOnChangeValue(...args)
                    });
                    (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, ...args);
                };
            }
        };
}

});
parcelRegister("fSlcK", function(module, exports) {
$parcel$export(module.exports, "FieldDecoratorAsync", () => $c22bf8c9c77a2307$export$7bf1fdc8d847e1ea);

var $bSJIT = parcelRequire("bSJIT");

var $dtngf = parcelRequire("dtngf");

var $inaNq = parcelRequire("inaNq");

var $8MlrR = parcelRequire("8MlrR");

var $lWHWW = parcelRequire("lWHWW");
const $c22bf8c9c77a2307$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const isUiModificationsEnabled = (0, $inaNq.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, componentProps);
    if (!isUiModificationsEnabled) return undecoratedComponent;
    if (!(0, $dtngf.isFieldTypeSupported)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), componentProps.jiraFieldType ?? componentProps.id)) return undecoratedComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lWHWW.EnabledFieldDecorator), {
        componentProps: componentProps,
        Component: Component
    });
};
const $c22bf8c9c77a2307$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $bSJIT.memo)($c22bf8c9c77a2307$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("lWHWW", function(module, exports) {
$parcel$export(module.exports, "EnabledFieldDecorator", () => $1ea9d3a17d353020$export$a39682472306ffd4);

var $bSJIT = parcelRequire("bSJIT");

var $adiHH = parcelRequire("adiHH");

var $6zZjo = parcelRequire("6zZjo");
const $1ea9d3a17d353020$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { id: id } = componentProps;
    const isBusy = (0, $6zZjo.useFieldIsBusy)(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
        ...componentProps,
        ...isBusy ? {
            disabled: true,
            isDisabled: true,
            tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $adiHH.FieldBusyIndicator), {
                fieldId: id
            })
        } : {}
    });
};
const $1ea9d3a17d353020$export$a39682472306ffd4 = /*#__PURE__*/ (0, $bSJIT.memo)($1ea9d3a17d353020$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("adiHH", function(module, exports) {
$parcel$export(module.exports, "FieldBusyIndicator", () => $d90ada0f871049c1$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $8RBeH = parcelRequire("8RBeH");

var $hDkm2 = parcelRequire("hDkm2");

var $lavtv = parcelRequire("lavtv");

var $3TZ0C = parcelRequire("3TZ0C");
const $d90ada0f871049c1$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $bSJIT.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const loadingMessage = formatMessage((0, $3TZ0C.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d90ada0f871049c1$export$4e31364808fb7483, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8RBeH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), {
        testId: indicatorId,
        size: "small"
    }))));
});
$d90ada0f871049c1$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $d90ada0f871049c1$export$4e31364808fb7483 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8RBeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b6a3313f8a75341$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $hbskS = parcelRequire("hbskS");
function $7b6a3313f8a75341$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hbskS.default), props);
}

});
parcelRegister("hbskS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b91ca479f53c3578$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $cyIUy = parcelRequire("cyIUy");
/**
 * Prevent a subtree from holding up an interaction
 * Use this when you have a component which loads in late, but
 * isn't considered to be a breach of SLO
 *
 * ```js
 * <App>
 *   <Main />
 *   <Sidebar>
 *     <UFOIgnoreHolds>
 *       <InsightsButton />
 *     </UFOIgnoreHolds>
 *   </Sidebar>
 * </App>
 * ```
 *
 * Has an `ignore` prop, to allow you to use it conditionally
 * Has a `reason` prop, to specify why the hold is being ignored
 */ const $b91ca479f53c3578$var$UFOIgnoreHolds = ({ children: children, ignore: ignore = true })=>{
    const parentContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    const ignoredInteractionContext = (0, $bSJIT.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cyIUy.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
};
$b91ca479f53c3578$var$UFOIgnoreHolds.displayName = 'UFOIgnoreHolds';
var $b91ca479f53c3578$export$2e2bcd8739ae039 = $b91ca479f53c3578$var$UFOIgnoreHolds;

});


parcelRegister("3TZ0C", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0a42e08d6a0bd9c$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c0a42e08d6a0bd9c$var$_default_1 = (0, $f0Pt4.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});
var $c0a42e08d6a0bd9c$export$2e2bcd8739ae039 = $c0a42e08d6a0bd9c$var$_default_1;

});


parcelRegister("6zZjo", function(module, exports) {
$parcel$export(module.exports, "useFieldIsBusy", () => $2c0dab52e69d7ddb$export$b4ae28da91c35ed4);

var $QaFKJ = parcelRequire("QaFKJ");

var $6FvB9 = parcelRequire("6FvB9");

var $gFIAh = parcelRequire("gFIAh");
const $2c0dab52e69d7ddb$export$b4ae28da91c35ed4 = (fieldId)=>{
    const [isBusyData] = (0, $gFIAh.useFieldIsProcessing)(fieldId);
    const uimConsentMap = (0, $QaFKJ.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $6FvB9.UIM_CONSENT_REQUIRED));
};

});
parcelRegister("QaFKJ", function(module, exports) {
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $61b7d3ce82412cb2$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $61b7d3ce82412cb2$export$2a5a8f1570c161c6);

var $bBhJi = parcelRequire("bBhJi");
var $gfNVK = parcelRequire("gfNVK");

var $inaNq = parcelRequire("inaNq");

var $6FvB9 = parcelRequire("6FvB9");
const $61b7d3ce82412cb2$var$selectOverallConsentStatus = (0, $bBhJi.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $6FvB9.UIM_CONSENT_REQUIRED)) ? (0, $6FvB9.UIM_CONSENT_REQUIRED) : (0, $6FvB9.UIM_CONSENT_CONSENTED));
const $61b7d3ce82412cb2$export$e2c526d2c1843a0e = (0, $gfNVK.createStateHook)((0, $inaNq.store), {
    selector: $61b7d3ce82412cb2$var$selectOverallConsentStatus
});
const $61b7d3ce82412cb2$export$7700bb22109a011e = (0, $gfNVK.createStateHook)((0, $inaNq.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $6FvB9.UIM_CONSENT_UNKNOWN)
});
const $61b7d3ce82412cb2$export$2a5a8f1570c161c6 = (0, $gfNVK.createStateHook)((0, $inaNq.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("6FvB9", function(module, exports) {
$parcel$export(module.exports, "UIM_CONSENT_UNKNOWN", () => $7277ea24edb41c2a$export$39d15f3568f5a72c);
$parcel$export(module.exports, "UIM_CONSENT_REQUIRED", () => $7277ea24edb41c2a$export$d67d63332ce3ce38);
$parcel$export(module.exports, "UIM_CONSENT_CONSENTED", () => $7277ea24edb41c2a$export$45ca911896c5084f);
const $7277ea24edb41c2a$export$39d15f3568f5a72c = 'unknown';
const $7277ea24edb41c2a$export$d67d63332ce3ce38 = 'required';
const $7277ea24edb41c2a$export$45ca911896c5084f = 'consented';

});


parcelRegister("gFIAh", function(module, exports) {
$parcel$export(module.exports, "useFieldIsProcessing", () => $6d5bc40a325e7da5$export$7fa63f8479e2806a);

var $bWsVm = parcelRequire("bWsVm");

var $gfNVK = parcelRequire("gfNVK");
var $bBhJi = parcelRequire("bBhJi");

var $81Pre = parcelRequire("81Pre");
const $6d5bc40a325e7da5$export$9076a5ac331011bb = (0, $bBhJi.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($bWsVm)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $6d5bc40a325e7da5$export$7fa63f8479e2806a = (0, $gfNVK.createHook)((0, $81Pre.store), {
    selector: $6d5bc40a325e7da5$export$9076a5ac331011bb
});

});








parcelRegister("frkfX", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => (parcelRequire("8q9dQ")).default);

var $8q9dQ = parcelRequire("8q9dQ");

});
parcelRegister("8q9dQ", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => $ac9a0fdb03f7900d$export$65ed9482db2257fa);
$parcel$export(module.exports, "default", () => $ac9a0fdb03f7900d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $97yQ5 = parcelRequire("97yQ5");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("e0pHJ");
var $4aV0o = parcelRequire("4aV0o");

var $87QgR = parcelRequire("87QgR");

var $8iYAq = parcelRequire("8iYAq");

var $f5ZrX = parcelRequire("f5ZrX");

var $jgsO4 = parcelRequire("jgsO4");

var $lavtv = parcelRequire("lavtv");
parcelRequire("bP5aM");
var $5Yn6K = parcelRequire("5Yn6K");

var $3HH3b = parcelRequire("3HH3b");
/**
 * Feature gate: a11y_password_show_button_focus_indicator
 *
 * Adds a clearly visible keyboard focus indicator to the show/hide password
 * toggle. The toggle renders inside the @atlaskit/textfield's `elemAfterInput`
 * slot, whose container has `overflow: hidden`, which clips the button's default
 * (outer) focus ring - leaving no visible focus indicator (fails WCAG 2.4.7).
 * When enabled, an inset focus ring is drawn instead so it is not clipped.
 */ const $ac9a0fdb03f7900d$var$PASSWORD_SHOW_BUTTON_FOCUS_INDICATOR = 'a11y_password_show_button_focus_indicator';
const $ac9a0fdb03f7900d$var$isPasswordShowButtonFocusIndicatorEnabled = ()=>(0, $87QgR.default).checkGate($ac9a0fdb03f7900d$var$PASSWORD_SHOW_BUTTON_FOCUS_INDICATOR);
class $ac9a0fdb03f7900d$export$65ed9482db2257fa extends $bSJIT.Component {
    render() {
        const { autoFocus: autoFocus, intl: intl, id: id, maxLength: maxLength, value: value, isDisabled: isDisabled, isInvalid: isInvalid, weakPasswords: weakPasswords, errorMessage: errorMessage, hideStrengthMeter: hideStrengthMeter, testId: testId, onKeyDown: onKeyDown } = this.props;
        const { showPassword: showPassword } = this.state;
        const passwordFieldType = showPassword ? 'text' : 'password';
        const shouldRenderStrengthMeter = !hideStrengthMeter;
        // Associate the requirement/strength hint with the input only when the meter is actually
        // rendered (complete-signup), which leaves the login field (which hides the meter)
        // unaffected. Derive the hint id from the input's own (unique) id so two PasswordFields on
        // the same page (e.g. "new password" + "confirm password") never share a hint id and break
        // aria-describedby. Shared between the input's `aria-describedby` and the strength hint <p>.
        const strengthHintId = shouldRenderStrengthMeter ? `${id}-strength-hint` : undefined;
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $jgsO4.default), {
            id: id,
            testId: testId,
            type: passwordFieldType,
            maxLength: maxLength,
            onChange: this.onChange,
            isDisabled: isDisabled,
            autoFocus: autoFocus,
            isInvalid: isInvalid,
            value: value,
            elemAfterInput: this.renderShowHideButton(),
            onKeyDown: onKeyDown,
            "aria-describedby": strengthHintId
        }), isInvalid && errorMessage && /*#__PURE__*/ $bSJIT.createElement((0, $5Yn6K.default), {
            errorMessage: errorMessage
        }), shouldRenderStrengthMeter && /*#__PURE__*/ $bSJIT.createElement((0, $4aV0o.default), {
            intl: intl,
            password: value,
            scoreWords: weakPasswords,
            hintId: strengthHintId
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            showPassword: false
        }, this.onChange = (e)=>{
            this.props.onChange(e.target.value);
        }, this.onShowPasswordToggle = ()=>{
            this.setState((prevState)=>({
                    showPassword: !prevState.showPassword
                }));
        }, this.renderShowHideButton = ()=>{
            const { intl: intl, isDisabled: isDisabled } = this.props;
            const { showPassword: showPassword } = this.state;
            const buttonActionPrefix = showPassword ? 'hide' : 'show';
            const togglePasswordButtonDescription = showPassword ? intl.formatMessage((0, $3HH3b.default).hidePassword) : intl.formatMessage((0, $3HH3b.default).showPassword);
            const icon = showPassword ? /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5ZrX))), {
                spacing: "spacious",
                testId: "watch-filled-icon",
                label: togglePasswordButtonDescription
            }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8iYAq))), {
                spacing: "spacious",
                testId: "watch-icon",
                label: togglePasswordButtonDescription
            });
            // Behind the a11y gate, render a variant of the toggle that pulls its design-system focus
            // ring inside the button (see ShowHideButton) so the surrounding field's `overflow: hidden`
            // cannot clip it (WCAG 2.4.7).
            const focusIndicatorEnabled = $ac9a0fdb03f7900d$var$isPasswordShowButtonFocusIndicatorEnabled();
            const ToggleButton = focusIndicatorEnabled ? $ac9a0fdb03f7900d$var$ShowHideButton : (0, $97yQ5.Button);
            return /*#__PURE__*/ $bSJIT.createElement((0, $lavtv.default), {
                content: togglePasswordButtonDescription
            }, /*#__PURE__*/ $bSJIT.createElement(ToggleButton, {
                actionSubjectId: `${buttonActionPrefix}-password`,
                appearance: "subtle",
                isDisabled: isDisabled,
                onClick: this.onShowPasswordToggle,
                iconBefore: /*#__PURE__*/ $bSJIT.createElement($ac9a0fdb03f7900d$var$IconContainer, null, icon),
                testId: focusIndicatorEnabled ? 'user-password-show-toggle' : undefined
            }));
        };
    }
}
var $ac9a0fdb03f7900d$export$2e2bcd8739ae039 = (0, $fK3tS.default)($ac9a0fdb03f7900d$export$65ed9482db2257fa);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ac9a0fdb03f7900d$var$IconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-19v26xn-0"
})`padding-right:${"var(--ds-space-025, 2px)"};margin-left:${"var(--ds-space-negative-025, -2px)"};`;
/*
 * The show/hide toggle renders inside the @atlaskit/textfield's elemAfterInput slot, whose
 * container has overflow: hidden. The button's design-system focus ring (@atlaskit/focus-ring) is
 * drawn just outside its border box, so the container clips it and keyboard users see no focus
 * indicator (WCAG 2.4.7). A negative outline-offset draws the same DS ring inside the button -
 * matching @atlaskit/focus-ring's own inset variant - so it cannot be clipped. Styling the button
 * directly (className is forwarded to the underlying <button>) avoids adding an extra DOM node; the
 * doubled `&&` wins specificity over the focus-ring rule without needing !important.
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ac9a0fdb03f7900d$var$ShowHideButton = /*#__PURE__*/ (0, $4v2A7.default)((0, $97yQ5.Button)).withConfig({
    componentId: "sc-19v26xn-1"
})`&&:focus-visible{outline-offset:calc(-1 * ${"var(--ds-border-width-focused, 2px)"});}`;

});
parcelRegister("e0pHJ", function(module, exports) {
$parcel$export(module.exports, "AsyncLoadedPasswordStrengthMeter", () => (parcelRequire("4aV0o")).default);

var $4aV0o = parcelRequire("4aV0o");

});
parcelRegister("4aV0o", function(module, exports) {
$parcel$export(module.exports, "default", () => $450df1a7e94fbf12$export$2e2bcd8739ae039);
/**
 * Heavily inspired by https://stash.atlassian.com/projects/AID/repos/aid-frontend/browse/src/components/PasswordStrengthMeter.tsx.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $4ZMmh = parcelRequire("4ZMmh");

var $lAHoS = parcelRequire("lAHoS");

var $4Bwvp = parcelRequire("4Bwvp");

var $f1gPY = parcelRequire("f1gPY");
const $450df1a7e94fbf12$var$passwordAnalyzerUrl = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';
const $450df1a7e94fbf12$var$splitter = /\W+/;
const $450df1a7e94fbf12$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS = 200;
class $450df1a7e94fbf12$export$eebfb7c0549090 extends $bSJIT.Component {
    render() {
        const { hintId: hintId } = this.props;
        const { score: score } = this.state;
        const strengthText = this.getStrengthTextForScore(score);
        // Only attach id/aria-live when an id is provided (gate on) so the
        // gate-off render is byte-for-byte identical to before.
        const hintA11yProps = hintId ? {
            id: hintId,
            'aria-live': 'polite'
        } : {};
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($450df1a7e94fbf12$export$bbc6c6369b38e3d1, {
            "data-testid": "password-strength-bar",
            score: score
        }, /*#__PURE__*/ $bSJIT.createElement($450df1a7e94fbf12$var$Dividers, null)), /*#__PURE__*/ $bSJIT.createElement($450df1a7e94fbf12$export$8d13340382210b65, {
            "data-testid": "password-strength-hint",
            ...hintA11yProps
        }, strengthText));
    }
    constructor(...args){
        super(...args), this.state = {
            score: null
        }, this.calculateScoreDebounced = (0, $4ZMmh.debounce)(()=>{
            const { password: password, scoreWords: scoreWords, zxcvbn: passwordAnalyzer } = this.props;
            const result = passwordAnalyzer && password ? passwordAnalyzer(password, scoreWords) : null;
            this.setState({
                score: result ? result.score : null
            });
        }, $450df1a7e94fbf12$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS), this.componentDidUpdate = (prevProps)=>{
            if (this.props.password === prevProps.password) return;
            if (!this.props.password) {
                this.setState({
                    score: null
                });
                return;
            }
            this.calculateScoreDebounced();
        }, this.getStrengthTextForScore = (score)=>{
            const { intl: intl, password: password, zxcvbn: passwordAnalyzer } = this.props;
            if (!password) return '';
            if (password.length < (0, $4Bwvp.MIN_PASSWORD_LENGTH_IN_CHARS)) return this.props.intl.formatMessage((0, $f1gPY.default).passwordInvalid);
            if (!passwordAnalyzer) return intl.formatMessage((0, $f1gPY.default).passwordStrengthUnavailable);
            return score !== null ? this.mapScoreToStrengthText(score) : '';
        }, this.mapScoreToStrengthText = (score)=>{
            let strengthText;
            switch(score){
                case 0:
                    strengthText = (0, $f1gPY.default).passwordStrengthLevel0;
                    break;
                case 1:
                    strengthText = (0, $f1gPY.default).passwordStrengthLevel1;
                    break;
                case 2:
                    strengthText = (0, $f1gPY.default).passwordStrengthLevel2;
                    break;
                case 3:
                    strengthText = (0, $f1gPY.default).passwordStrengthLevel3;
                    break;
                case 4:
                    strengthText = (0, $f1gPY.default).passwordStrengthLevel4;
                    break;
                default:
                    strengthText = (0, $f1gPY.default).passwordStrengthUnavailable;
            }
            return this.props.intl.formatMessage(strengthText);
        };
    }
}
const $450df1a7e94fbf12$export$6672436889ec70b1 = (0, $lAHoS.default)($450df1a7e94fbf12$var$passwordAnalyzerUrl, {
    globalName: 'zxcvbn'
})($450df1a7e94fbf12$export$eebfb7c0549090);
var $450df1a7e94fbf12$export$2e2bcd8739ae039 = $450df1a7e94fbf12$export$6672436889ec70b1;
const $450df1a7e94fbf12$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $450df1a7e94fbf12$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($450df1a7e94fbf12$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($450df1a7e94fbf12$var$splitter).reduce($450df1a7e94fbf12$var$addUnique, arr), deduped);
}
const $450df1a7e94fbf12$var$leftPercentage = '19%';
const $450df1a7e94fbf12$var$rightPercentage = '19%';
const $450df1a7e94fbf12$var$leftPercentageAfter = '30%';
const $450df1a7e94fbf12$var$rightPercentageAfter = '30%';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $450df1a7e94fbf12$var$Dividers = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-2owkvn-0"
})`border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;left:${$450df1a7e94fbf12$var$leftPercentage};position:absolute;right:${$450df1a7e94fbf12$var$rightPercentage};top:0;&::after{border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;content:'';left:${$450df1a7e94fbf12$var$leftPercentageAfter};position:absolute;right:${$450df1a7e94fbf12$var$rightPercentageAfter};top:0;}`;
const $450df1a7e94fbf12$var$barWidths = [
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $450df1a7e94fbf12$var$barColours = [
    "var(--ds-chart-danger-bold, #BF2600)",
    "var(--ds-chart-danger, #FF5630)",
    "var(--ds-chart-warning, #FFAB00)",
    "var(--ds-chart-success, #36B37E)",
    "var(--ds-chart-success-bold, #00875A)"
];
const $450df1a7e94fbf12$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-2owkvn-1"
})`background:${"var(--ds-chart-neutral, #DFE1E6)"};height:${$9K7mZ.multiple(0.25).px};margin-top:${"var(--ds-space-075, 6px)"};position:relative;&::before{background-color:${(props)=>props.score === null ? "var(--ds-chart-neutral, #DFE1E6)" : $450df1a7e94fbf12$var$barColours[props.score]};bottom:0;content:'';left:0;position:absolute;top:0;transition:all 0.2s ease-out;width:${(props)=>props.score === null ? 0 : $450df1a7e94fbf12$var$barWidths[props.score]};}`;
const $450df1a7e94fbf12$export$8d13340382210b65 = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-2owkvn-2"
})`color:${"var(--ds-text-subtlest, #8993A4)"};${$98sDU.small} height:${$9K7mZ.multiple(2).px};line-height:${$9K7mZ.multiple(2).px};margin-top:${"var(--ds-space-050, 4px)"};position:relative;text-align:center;`;

});
parcelRegister("lAHoS", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb7ea0218edbdafa$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");

var $jNar1 = parcelRequire("jNar1");
function $fb7ea0218edbdafa$var$_extends() {
    $fb7ea0218edbdafa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb7ea0218edbdafa$var$_extends.apply(this, arguments);
}
function $fb7ea0218edbdafa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fb7ea0218edbdafa$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $fb7ea0218edbdafa$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $fb7ea0218edbdafa$var$idCount = 0;
function $fb7ea0218edbdafa$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $fb7ea0218edbdafa$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $fb7ea0218edbdafa$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $fb7ea0218edbdafa$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $fb7ea0218edbdafa$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $fb7ea0218edbdafa$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $bSJIT.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $bSJIT.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $bSJIT.forwardRef)(function(props, ref) {
            return (0, $bSJIT.createElement)(AsyncScriptLoader, $fb7ea0218edbdafa$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($4yQYd))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($jNar1)))(ForwardedComponent, WrappedComponent);
    };
}

});

parcelRegister("f1gPY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b87b8810789ef866$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $b87b8810789ef866$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    passwordInvalid: {
        id: 'password.invalid.password.size',
        description: 'Displayed when the user has entered a password shorter than 8 characters',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel0: {
        id: 'password.strength.level.0',
        description: 'Displayed when the user has entered a weak password',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        description: 'Displayed when the user has entered a fair (not very good) password',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        description: 'Displayed when the user has entered a good password',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        description: 'Displayed when the user has entered a strong password',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        description: 'Displayed when the user has entered a very strong password',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        description: 'Displayed when the password strength cannot be determined due to an error',
        defaultMessage: 'Password strength unavailable'
    }
});

});



parcelRegister("bP5aM", function(module, exports) {
$parcel$export(module.exports, "ErrorIndication", () => (parcelRequire("5Yn6K")).default);

var $5Yn6K = parcelRequire("5Yn6K");

});
parcelRegister("5Yn6K", function(module, exports) {
$parcel$export(module.exports, "default", () => $87b21f3990f5581a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $fK3tS = parcelRequire("fK3tS");

var $hkLEY = parcelRequire("hkLEY");

var $aRsbV = parcelRequire("aRsbV");

var $k4dp8 = parcelRequire("k4dp8");
const $87b21f3990f5581a$var$ErrorIndication = ({ errorMessage: errorMessage, intl: intl })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $bSJIT.createElement($87b21f3990f5581a$var$ContainerV2, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
            label: "error",
            color: "var(--ds-icon-danger, #BF2600)",
            size: "small"
        }), /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), {
            size: "small",
            color: "color.text.danger"
        }, typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)))
    }, /*#__PURE__*/ $bSJIT.createElement($87b21f3990f5581a$var$Container, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "error",
        color: "var(--ds-icon-danger, #BF2600)",
        size: "small"
    }), typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)));
};
var $87b21f3990f5581a$export$2e2bcd8739ae039 = (0, $fK3tS.default)($87b21f3990f5581a$var$ErrorIndication);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $87b21f3990f5581a$var$ContainerV2 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-xau1xe-0"
})`margin-top:${"var(--ds-space-050, 4px)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $87b21f3990f5581a$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-xau1xe-1"
})`${$98sDU.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("3HH3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b6321c8d2ec282$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $69b6321c8d2ec282$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    label: {
        defaultMessage: 'Password',
        description: 'Label for the password input field in the login form.',
        id: 'password.field.label'
    },
    showPassword: {
        defaultMessage: 'Show',
        description: 'Label for the button to show the password in the password field.',
        id: 'password.show.button.label'
    },
    hidePassword: {
        defaultMessage: 'Hide',
        description: 'Label for the button to hide the password in the password field.',
        id: 'password.hide.button.label'
    }
});

});



parcelRegister("buKRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5093cb1b3fd35b36$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4TRbS = parcelRequire("4TRbS");

var $7WQx2 = parcelRequire("7WQx2");

var $9dYEz = parcelRequire("9dYEz");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $9MGJK = parcelRequire("9MGJK");
const $5093cb1b3fd35b36$var$sectionMessageStyles = {
    container: "_2rko1mok _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $5093cb1b3fd35b36$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $5093cb1b3fd35b36$var$SectionMessage = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, appearance: appearance = 'information', actions: actions, title: title, headingLevel: headingLevel = 'h2', icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref)=>{
    const [dismissed, setDismissed] = (0, $bSJIT.useState)(false);
    const handleDismiss = (0, $bSJIT.useCallback)(()=>{
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9MGJK.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $bSJIT.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $bSJIT.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $dc70d.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $9fU1q.default)([
            $5093cb1b3fd35b36$var$sectionMessageStyles.container,
            $5093cb1b3fd35b36$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $5093cb1b3fd35b36$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $5093cb1b3fd35b36$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                            as: headingLevel,
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            className: (0, $9fU1q.default)([
                                $5093cb1b3fd35b36$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $5093cb1b3fd35b36$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $5093cb1b3fd35b36$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$5093cb1b3fd35b36$var$SectionMessage.displayName = 'SectionMessage';
var $5093cb1b3fd35b36$export$2e2bcd8739ae039 = $5093cb1b3fd35b36$var$SectionMessage;

});
parcelRegister("9MGJK", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $883edd1aacf61dde$export$e9b82d2e21ac0c1f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $27TPw = parcelRequire("27TPw");

var $hkLEY = parcelRequire("hkLEY");

var $68E0O = parcelRequire("68E0O");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");
const $883edd1aacf61dde$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($27TPw))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $883edd1aacf61dde$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $883edd1aacf61dde$var$appearanceIconSchema[appearance] || $883edd1aacf61dde$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, $dc70d.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("27TPw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9aea886ae883664b6f933ff09352e51d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18c78ae3daa917ee$var$_react = $18c78ae3daa917ee$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $18c78ae3daa917ee$var$_iconNew = $18c78ae3daa917ee$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $18c78ae3daa917ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-discovery
 * Usage guidance:
 * Reserved for discovery statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18c78ae3daa917ee$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $18c78ae3daa917ee$var$_react.default.createElement($18c78ae3daa917ee$var$_iconNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$18c78ae3daa917ee$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $18c78ae3daa917ee$var$_default = module.exports.default = $18c78ae3daa917ee$var$StatusDiscoveryIcon;

});



parcelRegister("16GZB", function(module, exports) {
$parcel$export(module.exports, "default", () => $06f2fd22d3b38476$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $06f2fd22d3b38476$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    resetPasswordLink: {
        defaultMessage: 'Reset password',
        description: 'Text of the reset password link',
        id: 'cv.login.reset.password.link'
    },
    resetPasswordLinkInlineBold: {
        defaultMessage: 'Reset Password',
        description: 'Text of the reset password which is inline bold',
        id: 'cv.login.reset.password.link.bold'
    },
    createPasswordLink: {
        defaultMessage: 'Create password',
        description: "Text to create password for customers who haven't yet set a password",
        id: 'cv.login.create.a.password.link'
    },
    dontHavePasswordText: {
        defaultMessage: "Don't have a password?",
        description: "Text to prompt user if they don't already have a password due to a new account",
        id: 'cv.login.dont.have.password.text'
    },
    nextButton: {
        defaultMessage: 'Next',
        description: 'Label for the Next button on the login form',
        id: 'cv.next.button.label'
    },
    continueButton: {
        defaultMessage: 'Continue',
        description: 'Label for the Continue button on the login form',
        id: 'cv.continue.button.label'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for the email address input field on the login form',
        id: 'cv.login.page.email.label'
    },
    passwordLabelAndPlaceholder: {
        defaultMessage: 'Password',
        description: 'Placeholder and label for login password field',
        id: 'cv.signup.page.password'
    },
    invalidEmailError: {
        defaultMessage: 'Enter a valid email address and try again.',
        description: 'Error shown when the email does not have the correct format.',
        id: 'sd.login.error.invalid.email.error'
    },
    incorrectPasswordError: {
        defaultMessage: 'Incorrect password. Try again',
        description: 'Error shown when the password is incorrect.',
        id: 'sd.login.error.incorrect.password'
    },
    emptyPasswordError: {
        defaultMessage: 'You must enter your password to log in',
        description: 'Error shown when the password is empty',
        id: 'sd.login.error.empty.password'
    },
    accessDeniedErrorCodeMessage: {
        defaultMessage: "You can\u2019t continue with single sign-on. Try again.",
        description: 'Error shown when receiving access deny error code from identity.',
        id: 'sd.login.errorcode.access.denied'
    },
    defaultErrorCodeMessage: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error shown when the receiving other error code',
        id: 'sd.login.errorcode.default'
    },
    loginConsentErrorMessage: {
        defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later',
        description: 'Error shown when the FedRAMP user failed to consent and got redirected to the login page',
        id: 'sd.login.consent.fail.error'
    }
});

});



parcelRegister("dOout", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b19ff729236ee8d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $0b19ff729236ee8d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    invalidLogin: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Message to show that email or password are incorrect and that the user should try again.',
        id: 'sd.login.error.invalid.login.unified'
    },
    accountLocked: {
        defaultMessage: "For security reasons, we've temporarily locked this account due to multiple unsuccessful login attempts. To regain access, select {forgotPasswordLink} to reset your password.",
        description: 'Error message if the account is locked.',
        id: 'sd.login.account.locked.unified'
    },
    miscLoginError: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error message for any not classified errors.',
        id: 'sd.login.error.misc.unified'
    }
});

});




parcelRegister("bcMLm", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOn", () => (parcelRequire("27cx6")).default);

var $27cx6 = parcelRequire("27cx6");

});
parcelRegister("27cx6", function(module, exports) {
$parcel$export(module.exports, "default", () => $0beeb7041b83faa1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $98sDU = parcelRequire("98sDU");

var $lCAV6 = parcelRequire("lCAV6");

var $c6H7d = parcelRequire("c6H7d");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");
parcelRequire("3gTkE");
var $h8PIN = parcelRequire("h8PIN");

var $87QgR = parcelRequire("87QgR");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $iydAA = parcelRequire("iydAA");

var $k4dp8 = parcelRequire("k4dp8");

var $lDXCa = parcelRequire("lDXCa");
class $0beeb7041b83faa1$export$b77dc1349d86cfac extends $bSJIT.Component {
    componentDidMount() {
        this.setState({
            isInIframe: window.self !== window.top
        });
    }
    render() {
        return /*#__PURE__*/ $bSJIT.createElement($0beeb7041b83faa1$var$Container, null, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), this.getSSOFormContent(), /*#__PURE__*/ $bSJIT.createElement($0beeb7041b83faa1$var$ButtonContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
            id: "login-button",
            "data-test-id": "login-sso-button",
            appearance: "primary",
            shouldFitContainer: true,
            actionSubjectId: "submitLoginSSO",
            href: this.getSSOUrl(),
            target: this.state.isInIframe && (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
            rel: this.state.isInIframe && (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
            autoFocus: true
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $lDXCa.default).continueWithAtlassianAccountButton))), this.getAtlassianAccountInfoSection());
    }
    constructor(...args){
        super(...args), this.state = {
            isInIframe: false
        }, this.getSSOUrl = ()=>{
            return this.props.redirectUrl;
        }, this.getSSOFormContent = ()=>{
            const { intl: intl, email: email } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement((0, $h8PIN.default), {
                id: "user-email",
                shouldFitContainer: true,
                label: intl.formatMessage((0, $lDXCa.default).emailLabel),
                disabled: true,
                defaultValue: email
            });
        }, this.getAtlassianAccountInfoSection = ()=>{
            const { intl: intl } = this.props;
            const URI = 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/';
            const supportLink = /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
                actionSubjectId: "learnMoreAtlassianAccount",
                href: URI,
                target: "_blank",
                id: "sso-login-learn-more-link",
                "aria-labelledby": "sso-login-learn-more-link sso-login-atlassian-account-heading"
            }, intl.formatMessage((0, $lDXCa.default).atlassianAccountInfoLink));
            return /*#__PURE__*/ $bSJIT.createElement($0beeb7041b83faa1$var$InfoSectionContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                    paddingBlockStart: "space.300"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
                    size: "xsmall"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $lDXCa.default).atlassianAccountInfoTitle)))
            }, /*#__PURE__*/ $bSJIT.createElement($0beeb7041b83faa1$var$InfoSectionTitle, {
                role: "heading",
                "aria-level": 3,
                id: "sso-login-atlassian-account-heading"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $lDXCa.default).atlassianAccountInfoTitle))), /*#__PURE__*/ $bSJIT.createElement((0, $k4dp8.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                    paddingBlockStart: "space.050"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), null, (0, $87QgR.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
                    ...(0, $lDXCa.default).atlassianAccountInfoContentAppify,
                    // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                    values: {
                        supportLink: supportLink
                    }
                }) : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
                    ...(0, $lDXCa.default).atlassianAccountInfoContent,
                    // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                    values: {
                        supportLink: supportLink
                    }
                })))
            }, /*#__PURE__*/ $bSJIT.createElement($0beeb7041b83faa1$var$InfoSectionContent, null, (0, $87QgR.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
                ...(0, $lDXCa.default).atlassianAccountInfoContentAppify,
                // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                values: {
                    supportLink: supportLink
                }
            }) : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
                ...(0, $lDXCa.default).atlassianAccountInfoContent,
                // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                values: {
                    supportLink: supportLink
                }
            }))));
        };
    }
}
var $0beeb7041b83faa1$export$2e2bcd8739ae039 = (0, $fK3tS.default)($0beeb7041b83faa1$export$b77dc1349d86cfac);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0beeb7041b83faa1$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-qruqqd-0"
})`text-align:left;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0beeb7041b83faa1$var$ButtonContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-qruqqd-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0beeb7041b83faa1$var$InfoSectionContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-qruqqd-2"
})`margin-top:${"var(--ds-space-300, 24px)"};border-top:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0beeb7041b83faa1$var$InfoSectionTitle = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-qruqqd-3"
})`${(0, $98sDU.h400)};margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0beeb7041b83faa1$var$InfoSectionContent = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-qruqqd-4"
})`margin-top:${"var(--ds-space-050, 4px)"};`;

});
parcelRegister("lDXCa", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f90f590ee381f6b$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $9f90f590ee381f6b$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    continueWithAtlassianAccountButton: {
        defaultMessage: 'Continue with Atlassian account',
        description: 'The redirect button text for login with single sign-on',
        id: 'cv.login.sso.button.text'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for the email address input field on the SSO login form',
        id: 'cv.login.sso.email.label'
    },
    atlassianAccountInfoTitle: {
        defaultMessage: 'Your Atlassian account',
        description: 'Title of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.title'
    },
    atlassianAccountInfoContent: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian products. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content'
    },
    atlassianAccountInfoContentAppify: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian apps. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content-appify'
    },
    atlassianAccountInfoLink: {
        defaultMessage: 'Learn more',
        description: 'Learn more link of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.link'
    }
});

});



parcelRegister("imku1", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOnCustomer", () => (parcelRequire("3LXP8")).default);

var $3LXP8 = parcelRequire("3LXP8");

});
parcelRegister("3LXP8", function(module, exports) {
$parcel$export(module.exports, "default", () => $69f569b70591f414$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $9K7mZ = parcelRequire("9K7mZ");

var $lCAV6 = parcelRequire("lCAV6");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("3gTkE");
var $h8PIN = parcelRequire("h8PIN");

var $iydAA = parcelRequire("iydAA");

var $9UpmV = parcelRequire("9UpmV");

var $7zohc = parcelRequire("7zohc");
const $69f569b70591f414$var$LoginSingleSignOnCustomer = (props)=>{
    const { email: email, redirectLink: redirectLink, passwordLoginAvailable: passwordLoginAvailable, onContinueWithPassword: onContinueWithPassword } = props;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [isInIframe, setIsInIframe] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        setIsInIframe(window.self !== window.top);
    }, []);
    const getContinueWithPasswordLink = ()=>{
        return passwordLoginAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($69f569b70591f414$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lCAV6.ThemedButton), {
            appearance: "link",
            actionSubjectId: "continueWithPassword",
            onClick: onContinueWithPassword
        }, formatMessage((0, $7zohc.default).continueWithPasswordButton))) : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($69f569b70591f414$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $h8PIN.default), {
        id: "user-email",
        shouldFitContainer: true,
        label: formatMessage((0, $7zohc.default).emailLabel),
        disabled: true,
        defaultValue: email
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9UpmV.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lCAV6.ThemedButton), {
        id: "continue-with-customer-sso-button",
        appearance: "primary",
        shouldFitContainer: true,
        actionSubjectId: "continueWithCustomerSSO",
        isDisabled: redirectLink === undefined,
        href: redirectLink,
        target: isInIframe && (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
        rel: isInIframe && (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
        autoFocus: true
    }, formatMessage((0, $7zohc.default).continueWithSingleSignOnButton))), getContinueWithPasswordLink());
};
var $69f569b70591f414$export$2e2bcd8739ae039 = $69f569b70591f414$var$LoginSingleSignOnCustomer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $69f569b70591f414$var$FooterContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-t9atao-0"
})`margin-top:${$9K7mZ.multiple(4.25).px};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $69f569b70591f414$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-t9atao-1"
})`text-align:left;`;

});
parcelRegister("9UpmV", function(module, exports) {
$parcel$export(module.exports, "ButtonContainer", () => $20d2e5dffaf4de84$export$eddf54ea3db8d0f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");
const $20d2e5dffaf4de84$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-mrwmoh-0"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("7zohc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fb4f2c1a68d1e2a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $8fb4f2c1a68d1e2a$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for the email address input field on the customer SSO login form',
        id: 'cv.login.sso.customer.email.label'
    },
    continueWithPasswordButton: {
        defaultMessage: 'Continue with password',
        description: 'The button text for customer account login using password',
        id: 'cv.login.sso.customer.password.link.text'
    },
    continueWithSingleSignOnButton: {
        defaultMessage: 'Continue with single sign-on',
        description: 'The redirect button text for customer account login using single sign-on',
        id: 'cv.login.sso.customer.button.text'
    }
});

});







parcelRegister("hFRc4", function(module, exports) {
$parcel$export(module.exports, "portalAccessForbiddenRoute", () => $2e866bfbc4be5107$export$51c7ebad0d50c69a);

var $jcRK7 = parcelRequire("jcRK7");
parcelRequire("9dLmd");
var $d9EDH = parcelRequire("d9EDH");

var $bkEWh = parcelRequire("bkEWh");
const $2e866bfbc4be5107$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true,
    headerless: true
};
const $2e866bfbc4be5107$export$51c7ebad0d50c69a = (0, $bkEWh.createRouteWithLayout)({
    name: 'portal-access-forbidden',
    path: '/user/forbidden',
    exact: true,
    component: (0, $d9EDH.default),
    resources: []
}, (0, $jcRK7.ScreenName).PORTAL_ACCESS_FORBIDDEN, $2e866bfbc4be5107$var$layoutProps);

});
parcelRegister("9dLmd", function(module, exports) {
$parcel$export(module.exports, "PortalAccessForbidden", () => (parcelRequire("d9EDH")).default);

var $d9EDH = parcelRequire("d9EDH");

});
parcelRegister("d9EDH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4024452e58be462$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $8Wt5T = parcelRequire("8Wt5T");
const $a4024452e58be462$var$selector = (0, $BOq7h.createSelector)((state)=>(0, $fBLyB.isLoggedIn)(state), (state)=>(0, $fBLyB.getUserState)(state), (isUserLoggedIn, userState)=>({
        isUserLoggedIn: isUserLoggedIn,
        userEmail: userState.email || ''
    }));
var $a4024452e58be462$export$2e2bcd8739ae039 = (0, $f2mlD.default)($a4024452e58be462$var$selector)((0, $8Wt5T.default));

});
parcelRegister("8Wt5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b9a9c40a28b7e1f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $2ERPT = parcelRequire("2ERPT");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $c6H7d = parcelRequire("c6H7d");

var $cyWTn = parcelRequire("cyWTn");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");
parcelRequire("cAJ8B");
var $aquFW = parcelRequire("aquFW");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $g5FS7 = parcelRequire("g5FS7");

var $oORS9 = parcelRequire("oORS9");

var $7wZ8h = parcelRequire("7wZ8h");
const $8b9a9c40a28b7e1f$var$PortalAccessForbidden = ({ isUserLoggedIn: isUserLoggedIn, userEmail: userEmail })=>{
    const callToActionUrl = 'https://start.atlassian.com/';
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isCSMHelpCenterEnabled = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    if (!isUserLoggedIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g5FS7.Redirect), {
        to: (0, $oORS9.getHelpCenterUrl)()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2ERPT.default), {
        title: formatMessage((0, $7wZ8h.default).documentTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aquFW.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8b9a9c40a28b7e1f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8b9a9c40a28b7e1f$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cyWTn.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8b9a9c40a28b7e1f$var$Message, null, formatMessage((0, $7wZ8h.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8b9a9c40a28b7e1f$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...isCSMHelpCenterEnabled ? (0, $7wZ8h.default).errorDescriptionTextV2 : (0, $7wZ8h.default).errorDescriptionText,
        values: {
            userEmail: userEmail,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("br", null)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8b9a9c40a28b7e1f$var$AnchorContainer, {
        actionSubjectId: "redirectToAtlassianStart",
        href: callToActionUrl
    }, formatMessage((0, $7wZ8h.default).callToActionText)))));
};
var $8b9a9c40a28b7e1f$export$2e2bcd8739ae039 = $8b9a9c40a28b7e1f$var$PortalAccessForbidden;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8b9a9c40a28b7e1f$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-98kmq7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8b9a9c40a28b7e1f$var$IconContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-98kmq7-1"
})`width:${$9K7mZ.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8b9a9c40a28b7e1f$var$Message = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-98kmq7-2"
})`${$98sDU.h600};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8b9a9c40a28b7e1f$var$Description = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-98kmq7-3"
})`${$98sDU.regular};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8b9a9c40a28b7e1f$var$AnchorContainer = /*#__PURE__*/ (0, $4v2A7.default)((0, $c6H7d.default)).withConfig({
    componentId: "sc-98kmq7-4"
})`text-align:center;`;

});
parcelRegister("7wZ8h", function(module, exports) {
$parcel$export(module.exports, "default", () => $59e7cb74e052fb0b$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $59e7cb74e052fb0b$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    documentTitle: {
        defaultMessage: 'No access',
        description: 'Document title for user with no access to portal',
        id: 'cv.portal.forbidden.access.document.title'
    },
    errorHeading: {
        defaultMessage: 'No access',
        description: 'Error heading for user with no portal access',
        id: 'cv.portal.forbidden.access.error.heading'
    },
    errorDescriptionText: {
        defaultMessage: "It seems that your account {userEmail} doesn't have access to the help center.{br}Try contacting your admins to grant you permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text'
    },
    errorDescriptionTextV2: {
        defaultMessage: "Your account {userEmail} doesn't have access to this website, help center, or hub.{br}Contact your admin(s) to request access permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text.v2'
    },
    callToActionText: {
        defaultMessage: 'Go to Atlassian Start',
        description: 'Next action link label for user with no portal access',
        id: 'cv.portal.forbidden.access.error.action.link.label'
    }
});

});





parcelRegister("ajLNc", function(module, exports) {
$parcel$export(module.exports, "getPortalHomeRoutes", () => $21b0cfb3ef6bea29$export$87f7f4cc1cadb13a);
parcelRequire("cOYjw");
var $kP6iG = parcelRequire("kP6iG");

var $bkEWh = parcelRequire("bkEWh");
const $21b0cfb3ef6bea29$var$getRoute = ()=>({
        name: 'portal-home',
        path: `/portal/:portalId/:group?/:requestGroupId?/:create?/:requestTypeId?`,
        exact: true,
        component: (0, $kP6iG.default),
        getUFONameBasedOnRouteMatch: (routerState)=>{
            const { requestTypeId: requestTypeId } = routerState.params;
            if (requestTypeId) return 'request-create';
            return 'portal-home';
        },
        resources: []
    });
const $21b0cfb3ef6bea29$var$paperAppearance = 'xxwide';
const $21b0cfb3ef6bea29$var$layoutProps = {
    paperAppearance: $21b0cfb3ef6bea29$var$paperAppearance,
    fadeInSearchModal: true
};
const $21b0cfb3ef6bea29$export$87f7f4cc1cadb13a = ()=>(0, $bkEWh.createRouteWithLayout)($21b0cfb3ef6bea29$var$getRoute(), undefined, $21b0cfb3ef6bea29$var$layoutProps);

});
parcelRegister("cOYjw", function(module, exports) {
$parcel$export(module.exports, "PortalHome", () => (parcelRequire("kP6iG")).default);

var $kP6iG = parcelRequire("kP6iG");

});
parcelRegister("kP6iG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bba19dcebd13c20$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("fxMO5");
var $15AtB = parcelRequire("15AtB");

var $jcRK7 = parcelRequire("jcRK7");

var $iCbt2 = parcelRequire("iCbt2");

var $g4BKO = parcelRequire("g4BKO");
parcelRequire("7bFih");
var $lEZQu = parcelRequire("lEZQu");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("1biTA");
var $35X2j = parcelRequire("35X2j");
parcelRequire("iYz1m");
var $fJgYk = parcelRequire("fJgYk");
parcelRequire("c96vD");
var $cZYNB = parcelRequire("cZYNB");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("ay2XP");
var $bQHQ3 = parcelRequire("bQHQ3");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $lFpPv = parcelRequire("lFpPv");

var $haAAx = parcelRequire("haAAx");

var $gEVth = parcelRequire("gEVth");

var $irUsc = parcelRequire("irUsc");

var $gYDJY = parcelRequire("gYDJY");

var $aYbXa = parcelRequire("aYbXa");

var $2aw7C = parcelRequire("2aw7C");

var $hxOA5 = parcelRequire("hxOA5");
parcelRequire("cdcR8");
var $d7jBU = parcelRequire("d7jBU");
parcelRequire("RMp16");
var $2Tw2r = parcelRequire("2Tw2r");
const $1bba19dcebd13c20$export$3fbf10a15d6b2168 = (screenLocation)=>(0, $gYDJY.pathname)().endsWith(screenLocation);
class $1bba19dcebd13c20$export$2521bdc6772d1464 extends $bSJIT.Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchUser: fetchUser, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, requestTypeId: requestTypeId, categories: categories } = this.props;
        const analytics = this.getViewSinglePortalAnalyticsEvents();
        if (portalId) {
            fetchPortal({
                id: portalId,
                expand: [
                    'kbs',
                    'orderMapping',
                    'reqGroups',
                    'reqTypes',
                    'analyticsContext',
                    'categories'
                ]
            }, analytics);
            if (requestTypeId) {
                if (!this.props.requestCreateModelLoaded || this.props.isPrefillPending) fetchRequestCreate({
                    portalId: portalId,
                    id: requestTypeId
                });
                fetchUiModifications({
                    portalId: portalId,
                    requestTypeId: requestTypeId
                });
            }
            // FSD-2541: required to re-fetch user model inorder to send correct analytics remove in clean-up task FSD-2881
            fetchUser();
            if (!categories) this.tryFetchCategories();
        }
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, requestTypeId: requestTypeId, portalId: portalId, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, kbEnabled: kbEnabled } = this.props;
        const projectUpdated = prevProps.projectId !== projectId;
        const kbEnabledUpdated = !prevProps.kbEnabled && kbEnabled;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId;
        const portalUpdated = prevProps.portalId !== portalId;
        if (projectUpdated || kbEnabledUpdated) this.tryFetchCategories();
        if (portalId && requestTypeId && (portalUpdated || requestTypeUpdated)) {
            fetchRequestCreate({
                portalId: portalId,
                id: requestTypeId
            });
            fetchUiModifications({
                portalId: portalId,
                requestTypeId: requestTypeId
            });
        }
    }
    getScreenName() {
        const { requestTypeId: requestTypeId, requestGroupId: requestGroupId } = this.props;
        let screenName;
        if (requestTypeId) screenName = (0, $jcRK7.ScreenName).REQUEST_CREATE;
        else if (requestGroupId === -1) screenName = (0, $jcRK7.ScreenName).REQUEST_GROUP_LIST;
        else if (requestGroupId) screenName = (0, $jcRK7.ScreenName).REQUEST_GROUP;
        else screenName = (0, $jcRK7.ScreenName).PORTAL_HOME;
        return screenName;
    }
    render() {
        const { sideBarOpen: sideBarOpen } = this.state;
        const { portalName: portalName, requestTypeName: requestTypeName, isLoading: isLoading, error: error, announcement: announcement, canEditAnnouncement: canEditAnnouncement, portalId: portalId, projectId: projectId, categories: categories, requestTypeId: requestTypeId, requestGroupId: requestGroupId, isProjectSimplified: isProjectSimplified, isAtlassianManagedAccount: isAtlassianManagedAccount, isProjectAdmin: isProjectAdmin, canCustomiseHelpCenter: canCustomiseHelpCenter, requestTypeBelongsToGroup: requestTypeBelongsToGroup, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction } = this.props;
        const screenName = this.getScreenName();
        return /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
            screenName: screenName,
            screenId: requestTypeId || requestGroupId || portalId
        }, /*#__PURE__*/ $bSJIT.createElement((0, $d7jBU.default), {
            screenName: screenName
        }, /*#__PURE__*/ $bSJIT.createElement((0, $15AtB.default), {
            name: (0, $jcRK7.ExperienceName).REQUEST_CREATE
        }, /*#__PURE__*/ $bSJIT.createElement((0, $hxOA5.UiModificationsContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $2Tw2r.default), {
            portalName: portalName,
            portalId: portalId,
            projectId: projectId,
            requestTypeName: requestTypeName,
            requestTypeId: requestTypeId,
            requestGroupId: requestGroupId,
            loading: isLoading,
            sideBarOpen: sideBarOpen,
            toggleSidebar: this.toggleSideBar,
            announcement: announcement,
            canEditAnnouncement: canEditAnnouncement,
            categories: categories,
            isProjectSimplified: isProjectSimplified,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            isProjectAdmin: isProjectAdmin,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            requestTypeBelongsToGroup: requestTypeBelongsToGroup,
            isBrandingLoaded: isBrandingLoaded,
            isLoggedIn: isLoggedIn,
            screenName: screenName,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBarAction,
            closeChatSideBar: closeChatSideBarAction,
            ...error
        })))));
    }
    constructor(...args){
        super(...args), this.state = {
            sideBarOpen: false
        }, this.tryFetchCategories = ()=>{
            const { portalId: portalId, kbEnabled: kbEnabled, projectId: projectId, categoriesLoaded: categoriesLoaded, fetchCategories: fetchCategories } = this.props;
            if (kbEnabled && projectId && portalId && !categoriesLoaded) {
                const meta = this.getAnalyticsEvents();
                fetchCategories(projectId, portalId, meta);
            }
        }, this.getAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsSuccessEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories success',
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories error',
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE)
                })
            };
        }, this.getViewSinglePortalAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return {
                analyticsSuccessEvent: createAnalyticsEvent({
                    action: (0, $gEVth.AnalyticsTrackActions).FETCHED,
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent({
                    action: (0, $gEVth.AnalyticsTrackActions).FETCHED_FAILURE,
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                })
            };
            return {};
        }, this.toggleSideBar = (value)=>{
            this.setState({
                sideBarOpen: value !== undefined ? value : !this.state.sideBarOpen
            });
            // this.props.location.pathname is used to check if the user is on the same page
            if (value === false && $1bba19dcebd13c20$export$3fbf10a15d6b2168(this.props.location.pathname)) (0, $2aw7C.clearSidebarExperienceAndCustomize)();
        };
    }
}
const $1bba19dcebd13c20$var$selector = (0, $BOq7h.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const portalId = (0, $aYbXa.toNumber)(portalIdAsString);
    const kbEnabled = portalId && (0, $iWhHo.getIsKbEnabled)(state, portalId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestTypeId = props.match.params && (0, $aYbXa.toNumber)(props.match.params.requestTypeId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestGroupId = props.match.params && (0, $aYbXa.toNumber)(props.match.params.requestGroupId);
    const portalName = portalId ? (0, $iWhHo.getName)(state, portalId) : undefined;
    const requestType = portalId && requestTypeId ? (0, $iWhHo.getPortalRequestType)(state, portalId, requestTypeId) : undefined;
    const requestTypeName = requestType ? requestType.name : undefined;
    const requestTypeBelongsToGroup = portalId && requestGroupId && requestTypeId && (0, $iWhHo.getIsRequestTypeBelongsToGroup)(state, portalId, requestGroupId, requestTypeId);
    const requestCreateModelLoaded = portalId && requestTypeId && !!(0, $bQHQ3.getRequestCreate)(state, portalId, requestTypeId);
    let isPrefillPending = false;
    if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() && portalId && requestTypeId) isPrefillPending = (0, $bQHQ3.getIsPrefillPending)(state, portalId, requestTypeId);
    return {
        portalId: portalId,
        portalName: portalName,
        kbEnabled: kbEnabled,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        requestTypeBelongsToGroup: requestTypeBelongsToGroup,
        requestCreateModelLoaded: requestCreateModelLoaded,
        isPrefillPending: isPrefillPending,
        isAtlassianManagedAccount: (0, $fBLyB.isAtlassianAccountManaged)(state),
        isLoggedIn: (0, $fBLyB.isLoggedIn)(state),
        categories: (0, $iWhHo.getCategories)(state, portalId),
        portal: (0, $iWhHo.getPortalOrError)(state, portalId),
        projectId: (0, $iWhHo.getProjectId)(state, portalId),
        announcement: (0, $iWhHo.getPortalAnnouncement)(state, portalId),
        isProjectAdmin: (0, $iWhHo.getCanAdministerProject)(state, portalId),
        canCustomiseHelpCenter: (0, $hvIQS.getCanCustomize)(state),
        isProjectSimplified: (0, $iWhHo.getIsProjectSimplified)(state, portalId),
        isBrandingLoaded: (0, $hvIQS.getHelpCenterBrandingLoader)(state),
        isChatSideBarOpen: (0, $cZYNB.isChatSideBarOpen)(state)
    };
}, ({ portalId: portalId, portal: portal, announcement: announcement, requestTypeId: requestTypeId, requestGroupId: requestGroupId, portalName: portalName, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, requestCreateModelLoaded: requestCreateModelLoaded, isPrefillPending: isPrefillPending, isAtlassianManagedAccount: isAtlassianManagedAccount, projectId: projectId, kbEnabled: kbEnabled, categories: categories, isProjectAdmin: isProjectAdmin, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isChatSideBarOpen: isChatSideBarOpen })=>{
    let isLoading = false;
    /**
   * Categories details are required only for single portal screen and not on portal groups / request create form screen (i.e when requestGroupId is present in the URL)
   */ if (requestGroupId) isLoading = Boolean(!portal);
    else isLoading = Boolean(!portal || kbEnabled && !categories);
    const categoriesOrUndefined = Array.isArray(categories) ? categories : undefined;
    return {
        portalId: portalId,
        portalName: portalName,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        projectId: projectId,
        announcement: announcement,
        isLoading: isLoading,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        isBrandingLoaded: isBrandingLoaded,
        isLoggedIn: isLoggedIn,
        isChatSideBarOpen: isChatSideBarOpen,
        requestTypeBelongsToGroup: Boolean(requestTypeBelongsToGroup),
        requestCreateModelLoaded: Boolean(requestCreateModelLoaded),
        isPrefillPending: Boolean(isPrefillPending),
        kbEnabled: Boolean(kbEnabled),
        categories: categoriesOrUndefined,
        isProjectAdmin: Boolean(isProjectAdmin),
        isProjectSimplified: Boolean(isProjectSimplified),
        categoriesLoaded: !!categories,
        error: portal && 'error' in portal ? portal : undefined,
        canEditAnnouncement: announcement ? announcement.canEditAnnouncement : undefined
    };
});
var $1bba19dcebd13c20$export$2e2bcd8739ae039 = (0, $f2mlD.default)($1bba19dcebd13c20$var$selector, {
    openChatSideBar: $lEZQu.openChatSideBar,
    closeChatSideBar: $lEZQu.closeChatSideBar,
    fetchPortal: (0, $jeW3I.fetchPortalAction),
    fetchUser: (0, $iCbt2.fetchUserModelAction),
    fetchCategories: (0, $g4BKO.fetchCategoriesAction),
    fetchRequestCreate: (0, $35X2j.fetchRequestCreateAction),
    fetchUiModifications: (0, $fJgYk.fetchUiModificationsAction)
})((0, $2usNr.default)({
    componentName: 'PortalHome'
})((0, $kIbto.default)()($1bba19dcebd13c20$export$2521bdc6772d1464)));

});
parcelRegister("fxMO5", function(module, exports) {
$parcel$export(module.exports, "withExperience", () => $b95642a123f34d6b$export$7733b94414b7dcb7);
$parcel$export(module.exports, "Experience", () => (parcelRequire("15AtB")).default);

var $bSJIT = parcelRequire("bSJIT");

var $15AtB = parcelRequire("15AtB");
const $b95642a123f34d6b$export$7733b94414b7dcb7 = (experienceName)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $bSJIT.createElement((0, $15AtB.default), {
                name: experienceName
            }, /*#__PURE__*/ $bSJIT.createElement(Component, props));
        };

});

parcelRegister("ay2XP", function(module, exports) {
$parcel$export(module.exports, "getFormName", () => (parcelRequire("bQHQ3")).getFormName);
$parcel$export(module.exports, "getFormIntro", () => (parcelRequire("bQHQ3")).getFormIntro);
$parcel$export(module.exports, "getFormInstructions", () => (parcelRequire("bQHQ3")).getFormInstructions);
$parcel$export(module.exports, "getIconUrl", () => (parcelRequire("bQHQ3")).getIconUrl);
$parcel$export(module.exports, "getRequestCreate", () => (parcelRequire("bQHQ3")).getRequestCreate);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("bQHQ3")).getProjectId);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("bQHQ3")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("bQHQ3")).getIssueTypeId);
$parcel$export(module.exports, "getRequestCreateOrError", () => (parcelRequire("bQHQ3")).getRequestCreateOrError);
$parcel$export(module.exports, "getCanCreateUsers", () => (parcelRequire("bQHQ3")).getCanCreateUsers);
$parcel$export(module.exports, "getDateFormat", () => (parcelRequire("bQHQ3")).getDateFormat);
$parcel$export(module.exports, "getDateTimeFormat", () => (parcelRequire("bQHQ3")).getDateTimeFormat);
$parcel$export(module.exports, "getFirstDay", () => (parcelRequire("bQHQ3")).getFirstDay);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => (parcelRequire("bQHQ3")).getUseISO8601WeekNumbers);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => (parcelRequire("bQHQ3")).getOrganisationsForCurrentUser);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => (parcelRequire("bQHQ3")).getRequestTypeHasProformaForm);
$parcel$export(module.exports, "getProformaTemplateForm", () => (parcelRequire("bQHQ3")).getProformaTemplateForm);
$parcel$export(module.exports, "getIsProformaFormDirty", () => (parcelRequire("bQHQ3")).getIsProformaFormDirty);
$parcel$export(module.exports, "getIsPrefillPending", () => (parcelRequire("bQHQ3")).getIsPrefillPending);

var $bQHQ3 = parcelRequire("bQHQ3");

});
parcelRegister("bQHQ3", function(module, exports) {
$parcel$export(module.exports, "getRequestCreate", () => $366b1925c30d3f68$export$15c8c5e17b9baa02);
$parcel$export(module.exports, "getFormName", () => $366b1925c30d3f68$export$fbe1ca2f3d088136);
$parcel$export(module.exports, "getFormIntro", () => $366b1925c30d3f68$export$aa9648d61391326c);
$parcel$export(module.exports, "getIconUrl", () => $366b1925c30d3f68$export$89d1c740383224f4);
$parcel$export(module.exports, "getFormInstructions", () => $366b1925c30d3f68$export$76982f53d034f6b1);
$parcel$export(module.exports, "getRequestCreateOrError", () => $366b1925c30d3f68$export$16e5e434a1b5c95e);
$parcel$export(module.exports, "getProjectId", () => $366b1925c30d3f68$export$89040d072f281f85);
$parcel$export(module.exports, "getIssueType", () => $366b1925c30d3f68$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $366b1925c30d3f68$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getCanCreateUsers", () => $366b1925c30d3f68$export$cbe7d03f30fd0cb4);
$parcel$export(module.exports, "getDateFormat", () => $366b1925c30d3f68$export$fa96065c64444af6);
$parcel$export(module.exports, "getDateTimeFormat", () => $366b1925c30d3f68$export$c9c87e313820bd4c);
$parcel$export(module.exports, "getFirstDay", () => $366b1925c30d3f68$export$456eb4e172ef8704);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => $366b1925c30d3f68$export$defea3d86e4ab71a);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => $366b1925c30d3f68$export$fb4f9a76e583ce63);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => $366b1925c30d3f68$export$740668767bebf9a);
$parcel$export(module.exports, "getProformaTemplateForm", () => $366b1925c30d3f68$export$9cb4f66aa30e267a);
$parcel$export(module.exports, "getIsProformaFormDirty", () => $366b1925c30d3f68$export$cd859d45f5982e2);
$parcel$export(module.exports, "getIsPrefillPending", () => $366b1925c30d3f68$export$c1f5b3a2b47daad);
const $366b1925c30d3f68$export$830c804e8d921bba = (state, portalId, requestTypeId)=>{
    if (!portalId || !requestTypeId) return undefined;
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.form;
};
const $366b1925c30d3f68$export$fbe1ca2f3d088136 = (state, portalId, requestTypeId)=>{
    const form = $366b1925c30d3f68$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.name;
};
const $366b1925c30d3f68$export$aa9648d61391326c = (state, portalId, requestTypeId)=>{
    const form = $366b1925c30d3f68$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.intro;
};
const $366b1925c30d3f68$export$89d1c740383224f4 = (state, portalId, requestTypeId)=>{
    const form = $366b1925c30d3f68$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.iconUrl;
};
const $366b1925c30d3f68$export$76982f53d034f6b1 = (state, portalId, requestTypeId)=>{
    const form = $366b1925c30d3f68$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.instructions;
};
const $366b1925c30d3f68$export$d5523731e7fe4ded = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.fields;
};
const $366b1925c30d3f68$export$b87c6f04552c18ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiUploadToken;
};
const $366b1925c30d3f68$export$ddddbd1696231d6a = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiError;
};
const $366b1925c30d3f68$export$15c8c5e17b9baa02 = (state, portalId, requestTypeId)=>{
    const data = $366b1925c30d3f68$export$16e5e434a1b5c95e(state, portalId, requestTypeId);
    return data && 'error' in data ? undefined : data;
};
const $366b1925c30d3f68$export$16e5e434a1b5c95e = (state, portalId, requestTypeId)=>{
    const id = `${portalId}/${requestTypeId}`;
    return state.persisted.requestCreate[id];
};
const $366b1925c30d3f68$export$89040d072f281f85 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.projectId;
};
const $366b1925c30d3f68$export$ed2455632bf977ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueType;
};
const $366b1925c30d3f68$export$110c9a4a16c5b8c9 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueTypeId;
};
const $366b1925c30d3f68$export$36651d42b0b3e63 = (state, portalId, requestTypeId)=>{
    const form = $366b1925c30d3f68$export$830c804e8d921bba(state, portalId, requestTypeId);
    return !!form && form.captchaEnabled && !!form.sitekey;
};
const $366b1925c30d3f68$export$490b07b05dbf5ae5 = (state, portalId, requestTypeId)=>{
    const form = $366b1925c30d3f68$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.captchaEnabled ? form.sitekey : undefined;
};
const $366b1925c30d3f68$export$cbe7d03f30fd0cb4 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate && !!requestCreate.canCreateUsers;
};
const $366b1925c30d3f68$export$fa96065c64444af6 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateFormat;
};
const $366b1925c30d3f68$export$c9c87e313820bd4c = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateTimeFormat;
};
const $366b1925c30d3f68$export$456eb4e172ef8704 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.firstDay;
};
const $366b1925c30d3f68$export$defea3d86e4ab71a = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.useISO8601WeekNumbers;
};
const $366b1925c30d3f68$export$fb4f9a76e583ce63 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate ? requestCreate.organisationsForCurrentUser : [];
};
const $366b1925c30d3f68$export$2808eba338b2ae16 = (state, portalId, requestTypeId)=>{
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && requestCreate.projectHasProformaForms);
};
const $366b1925c30d3f68$export$740668767bebf9a = (state, portalId, requestTypeId)=>{
    var _requestCreate$profor;
    const requestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && (_requestCreate$profor = requestCreate.proforma) !== null && _requestCreate$profor !== void 0 && _requestCreate$profor.formExists);
};
const $366b1925c30d3f68$export$9cb4f66aa30e267a = (state, portalId, requestTypeId)=>{
    var _getRequestCreate;
    const proformaTemplateForm = (_getRequestCreate = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) === null || _getRequestCreate === void 0 ? void 0 : _getRequestCreate.proformaTemplateForm;
    if (!proformaTemplateForm || Object.keys(proformaTemplateForm).length === 0) return undefined;
    return proformaTemplateForm;
};
const $366b1925c30d3f68$export$cd859d45f5982e2 = (state, portalId, requestTypeId)=>{
    var _getRequestCreate2;
    return !!((_getRequestCreate2 = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate2 !== void 0 && _getRequestCreate2.proformaFormIsDirty);
};
const $366b1925c30d3f68$export$c1f5b3a2b47daad = (state, portalId, requestTypeId)=>{
    var _getRequestCreate3;
    return !!((_getRequestCreate3 = $366b1925c30d3f68$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate3 !== void 0 && _getRequestCreate3.prefillPending);
};

});


parcelRegister("RMp16", function(module, exports) {
$parcel$export(module.exports, "PortalHomeDumb", () => (parcelRequire("2Tw2r")).default);

var $2Tw2r = parcelRequire("2Tw2r");

});
parcelRegister("2Tw2r", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef796e85c51b38fe$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $cwcdv = parcelRequire("cwcdv");

var $kPxiY = parcelRequire("kPxiY");

var $jcRK7 = parcelRequire("jcRK7");

var $2ERPT = parcelRequire("2ERPT");

var $fT4XN = parcelRequire("fT4XN");

var $fFr9c = parcelRequire("fFr9c");

var $lFpPv = parcelRequire("lFpPv");

var $i7phc = parcelRequire("i7phc");

var $fuVmc = parcelRequire("fuVmc");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("cJJTb");
var $bf3Xm = parcelRequire("bf3Xm");

var $fakfU = parcelRequire("fakfU");

var $3GBA9 = parcelRequire("3GBA9");
parcelRequire("hiiav");
var $03svw = parcelRequire("03svw");
var $1wLLy = parcelRequire("1wLLy");
parcelRequire("eRG8F");
var $dN9dL = parcelRequire("dN9dL");
parcelRequire("fK5uK");
var $9N3v2 = parcelRequire("9N3v2");
parcelRequire("ckGNT");
var $iStmz = parcelRequire("iStmz");
parcelRequire("a0chM");
var $2UScA = parcelRequire("2UScA");

var $4QZgG = parcelRequire("4QZgG");

var $hCHt7 = parcelRequire("hCHt7");

var $dlaM3 = parcelRequire("dlaM3");
parcelRequire("cAJ8B");
var $aquFW = parcelRequire("aquFW");

var $w2X5T = parcelRequire("w2X5T");
parcelRequire("683tP");
var $gwjgN = parcelRequire("gwjgN");

var $gstrO = parcelRequire("gstrO");

var $cYNAS = parcelRequire("cYNAS");
parcelRequire("aJYKE");
var $fUx7z = parcelRequire("fUx7z");

var $eXUFK = parcelRequire("eXUFK");

var $dwOcU = parcelRequire("dwOcU");

var $87QgR = parcelRequire("87QgR");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");

var $1qPbZ = parcelRequire("1qPbZ");

var $4op5x = parcelRequire("4op5x");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $g5FS7 = parcelRequire("g5FS7");

var $bwdOx = parcelRequire("bwdOx");

var $ikzcz = parcelRequire("ikzcz");

var $jSfp7 = parcelRequire("jSfp7");

var $2rxiA = parcelRequire("2rxiA");
parcelRequire("lVOVX");
var $jGNec = parcelRequire("jGNec");
var $jETIR = parcelRequire("jETIR");
var $eAsHJ = parcelRequire("eAsHJ");

var $5X2Zr = parcelRequire("5X2Zr");
parcelRequire("nR7qC");
var $3R7iu = parcelRequire("3R7iu");
parcelRequire("dUmWe");
var $elGk2 = parcelRequire("elGk2");

var $e8mg1 = parcelRequire("e8mg1");
const $ef796e85c51b38fe$var$JSM_HELP_CENTER_JAC_17803 = 'jsm_help_center_jac_17803';
const $ef796e85c51b38fe$var$isJsmHelpCenterJac17803Enabled = ()=>(0, $87QgR.default).checkGate($ef796e85c51b38fe$var$JSM_HELP_CENTER_JAC_17803);
const $ef796e85c51b38fe$var$validateRequestGroupIdPresent = (requestGroupId)=>{
    if (requestGroupId === -1) return false;
    return !!requestGroupId;
};
const $ef796e85c51b38fe$var$getConnectPageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $kPxiY.REQUEST_CREATE;
    return 0, $kPxiY.PORTAL_HOME;
};
const $ef796e85c51b38fe$var$getForgePageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $i7phc.FORGE_REQUEST_CREATE;
    return 0, $i7phc.FORGE_PORTAL_HOME;
};
const $ef796e85c51b38fe$var$getPortalHomeTitle = ({ intl: intl, portalName: portalName, requestTypeName: requestTypeName, requestGroupId: requestGroupId })=>{
    if (requestTypeName) return intl.formatMessage((0, $e8mg1.default).requestTypePageTitle, {
        portalName: portalName,
        requestTypeName: requestTypeName
    });
    if (requestGroupId) return intl.formatMessage((0, $e8mg1.default).portalGroupPageTitle, {
        portalName: portalName
    });
    return intl.formatMessage((0, $e8mg1.default).portalPageTitle, {
        portalName: portalName
    });
};
const $ef796e85c51b38fe$var$PortalHome = ({ intl: intl, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, portalName: portalName, portalId: portalId, projectId: projectId, loading: loading, requestTypeId: requestTypeId, requestGroupId: requestGroupId, sideBarOpen: sideBarOpen, announcement: announcement, categories: categories, canEditAnnouncement: canEditAnnouncement, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectAdmin: isProjectAdmin, isAtlassianManagedAccount: isAtlassianManagedAccount, toggleSidebar: toggleSidebar, screenName: screenName, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction })=>{
    const customiseSidebarTriggerRef = (0, $iStmz.useCustomiseSidebarTriggerRef)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { [(0, $jETIR.REFERRER_QUERY_PARAM)]: referrer } = (0, $3R7iu.useQueryParams)();
    const [isSubmitting, setIsSubmitting] = (0, $bSJIT.useState)(false);
    const openSidebar = (0, $bSJIT.useCallback)(()=>toggleSidebar(true), [
        toggleSidebar
    ]);
    const closeSidebar = (0, $bSJIT.useCallback)(()=>toggleSidebar(false), [
        toggleSidebar
    ]);
    const openChatSidebarCallback = (0, $bSJIT.useCallback)(()=>openChatSideBarAction === null || openChatSideBarAction === void 0 ? void 0 : openChatSideBarAction(), [
        openChatSideBarAction
    ]);
    const closeChatSidebarCallback = (0, $bSJIT.useCallback)(()=>closeChatSideBarAction === null || closeChatSideBarAction === void 0 ? void 0 : closeChatSideBarAction(), [
        closeChatSideBarAction
    ]);
    const onSubmit = (0, $bSJIT.useCallback)(()=>setIsSubmitting(true), [
        setIsSubmitting
    ]);
    const onSubmitComplete = (0, $bSJIT.useCallback)(()=>setIsSubmitting(false), [
        setIsSubmitting
    ]);
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const renderVsaChatSidebar = ()=>{
        if (!portalId || !isChatSideBarOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $w2X5T.LazyVirtualServiceAgentChatSidebar), {
            isOpen: true,
            onOpen: openChatSidebarCallback,
            onClose: closeChatSidebarCallback,
            portalId: portalId
        }));
    };
    const renderSidebar = ()=>{
        if (!canEditAnnouncement) return null;
        if ((0, $hCnLH.isKoshEnabledForDefaultHelpCenter)() && !isBrandingLoaded) // since check in shouldRenderAsPortalAnnouncement is dependent on "canCustomiseHelpCenter" which is coming from helpCenter model, we need to make sure branding relay call is completed
        return null;
        // Render the new 'next-gen' side bar, either as just the Announcement for agents with permission or with all customisation features available for admins
        if (shouldRenderAsPortalAnnouncement()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gstrO.LazyPortalSettingsAnnouncementSidebar), {
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf3Xm.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cYNAS.LazyPortalSettingsSidebar), {
            isProjectSimplified: isProjectSimplified,
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
    };
    const key = String(requestTypeId);
    const title = portalName && $ef796e85c51b38fe$var$getPortalHomeTitle({
        intl: intl,
        portalName: portalName,
        requestTypeName: requestTypeName,
        requestGroupId: requestGroupId
    });
    const shouldRenderDropdown = !!requestGroupId || !categories || !categories.length;
    const shouldShowRequestsInBreadcrumbs = !!shouldRenderDropdown && categories && !!categories.length;
    const isExternalLinksVisible = projectId && !$ef796e85c51b38fe$var$validateRequestGroupIdPresent(requestGroupId) && !requestTypeId;
    const shouldShowSkeleton = projectId && requestTypeId; // show only on request create page (for now)
    const LoadingIndicator = shouldShowSkeleton ? (0, $2UScA.SkeletonLoadingContainer) : (0, $9N3v2.default);
    const cloudId = (0, $fuVmc.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isVirtualAgentLoading } = (0, $ikzcz.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const shouldShowLearnByDoingExperimentBanner = (0, $eAsHJ.shouldShowLearnByDoingBanner)(isProjectAdmin, referrer);
    if ((0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g5FS7.Redirect), {
        to: '/'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2ERPT.default), {
        title: title,
        ignoreBaseTitle: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(LoadingIndicator, {
        isLoading: loading,
        enableUFOHold: true,
        ufoHoldName: "portal-home-dumb-fallback"
    }, loading && !announcement && !(0, $lFpPv.isUseHelpCenterRefresh)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "announcement-banner-loading"
    }), !!announcement && !(0, $lFpPv.isUseHelpCenterRefresh)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cwcdv.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: $ef796e85c51b38fe$var$AnnouncementInnerContainer
    }), requestGroupId && portalId && requestTypeId && !requestTypeBelongsToGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g5FS7.Redirect), {
        to: `/portal/${portalId}/group/${requestGroupId}`,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                [(0, $jETIR.REFERRER_QUERY_PARAM)]: referrer
            }
        }
    }, shouldShowLearnByDoingExperimentBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "learn-by-doing-container",
        xcss: $ef796e85c51b38fe$var$LearnByDoingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jGNec.default), {
        screenName: screenName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aquFW.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2rxiA.UiModificationsEntryPoint), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $elGk2.default), {
        showRequestsInBreadcrumbs: shouldShowRequestsInBreadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fUx7z.default), null, projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fakfU.BlockedAppsBanner), {
        page: $ef796e85c51b38fe$var$getForgePageType(requestTypeId),
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1wLLy.default), {
        page: $ef796e85c51b38fe$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dlaM3.ForgeHeaderModule), {
        page: $ef796e85c51b38fe$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    }), isVirtualAgentLoading && !(0, $lFpPv.isHideVsaEndpointsEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
        name: "virtual-agent-banner-loading"
    }), isVirtualAgentEnabled && !(0, $lFpPv.isHideVsaEndpointsEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $ef796e85c51b38fe$var$virtualBannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jSfp7.VirtualAgentBanner), {
        cloudId: cloudId,
        portalId: portalId
    })), !requestGroupId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ef796e85c51b38fe$export$b1b1a7643a727bbc, {
        portalId: portalId
    }), shouldRenderDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ef796e85c51b38fe$export$a096e20ba94bf2ce, {
        autoFocus: !$ef796e85c51b38fe$var$isJsmHelpCenterJac17803Enabled(),
        portalId: portalId,
        requestGroupId: requestGroupId,
        requestTypeId: requestTypeId,
        isDisabled: isSubmitting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gwjgN.default), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eXUFK.RequestCreateForm), {
        portalId: portalId,
        requestTypeId: requestTypeId,
        key: key,
        onSubmit: onSubmit,
        onSubmitComplete: onSubmitComplete
    }), isExternalLinksVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ef796e85c51b38fe$var$ExternalLinksListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4QZgG.ExternalLinks), {
        projectId: projectId
    })), (0, $87QgR.default).checkGate('rovo_service_agent_widget_experience') && projectId && isAtlassianManagedAccount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5X2Zr.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: (0, $4op5x.JiraProjectAri).create({
            projectId: projectId.toString(),
            siteId: cloudId
        }).toString(),
        surface: "PORTAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $03svw.default), {
        page: $ef796e85c51b38fe$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hCHt7.ForgeFooterModule), {
        page: $ef796e85c51b38fe$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR,
        id: 'portal-home-sidebar'
    }, sideBarOpen && renderSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).HELP_CENTER_VSA_CHAT_SIDEBAR,
        id: 'portal-home-vsa-chat-sidebar'
    }, isChatSideBarOpen && renderVsaChatSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bwdOx.SidebarToggle), {
        openSidebar: openSidebar,
        closeSidebar: closeSidebar
    })));
};
const $ef796e85c51b38fe$export$22ca00a6007ba086 = (0, $fFr9c.withErrorPage)($ef796e85c51b38fe$var$PortalHome, {
    isEmptyTraceIdLogExcluded: true
});
var $ef796e85c51b38fe$export$2e2bcd8739ae039 = (0, $fK3tS.default)($ef796e85c51b38fe$export$22ca00a6007ba086);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ef796e85c51b38fe$var$AnnouncementInnerContainer = /*#__PURE__*/ (0, $4v2A7.default)((0, $aquFW.PaperContent)).withConfig({
    componentId: "sc-1lc3w8v-0"
})`padding-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ef796e85c51b38fe$var$ExternalLinksListWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1lc3w8v-1"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $ef796e85c51b38fe$export$a096e20ba94bf2ce = /*#__PURE__*/ (0, $4v2A7.default)((0, $dN9dL.default)).withConfig({
    componentId: "sc-1lc3w8v-2"
})`margin:${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-100, 8px)"};position:relative;`;
const $ef796e85c51b38fe$export$b1b1a7643a727bbc = /*#__PURE__*/ (0, $4v2A7.default)((0, $3GBA9.CategoryList)).withConfig({
    componentId: "sc-1lc3w8v-3"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $ef796e85c51b38fe$var$virtualBannerStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.200'
});
const $ef796e85c51b38fe$var$LearnByDoingContainerStyles = (0, $9BVpB.xcss)({
    height: '266px',
    display: 'none',
    [(0, $4pBHw.media).above.md]: {
        display: 'flex'
    }
});

});
parcelRegister("fakfU", function(module, exports) {
$parcel$export(module.exports, "BlockedAppsBanner", () => $fe0932077af3d1fe$export$757c2c7994b73daa);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("dlAm5");
var $4dNJa = parcelRequire("4dNJa");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $2y2Vi = parcelRequire("2y2Vi");

var $2usNr = parcelRequire("2usNr");
const $fe0932077af3d1fe$var$blockedAppsBannerSelector = (0, $BOq7h.createSelector)((0, $4dNJa.getBlockedAppsBannerStatePortal), (0, $4dNJa.getBlockedAppsBannerStateRequestView), (0, $4dNJa.getBlockedAppsBannerStateCreateRequest), (0, $4dNJa.getBlockedAppsBannerStateCsmRequestCreate), (0, $fBLyB.getAccountId), (portal, viewRequest, createRequest, csmRequestCreate, accountId)=>{
    return {
        accountId: accountId,
        blockedAppsBannerState: {
            portal: portal,
            view_request: viewRequest,
            create_request: createRequest,
            csm_create_request: csmRequestCreate
        }
    };
});
const $fe0932077af3d1fe$export$757c2c7994b73daa = (0, $f2mlD.default)($fe0932077af3d1fe$var$blockedAppsBannerSelector)((0, $2usNr.default)({
    componentName: 'blockedAppBanner'
})((0, $2y2Vi.default)));

});
parcelRegister("dlAm5", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => (parcelRequire("4dNJa")).getBlockedAppsBannerStatePortal);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => (parcelRequire("4dNJa")).getBlockedAppsBannerStateCreateRequest);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => (parcelRequire("4dNJa")).getBlockedAppsBannerStateRequestView);
$parcel$export(module.exports, "getBlockedAppsBannerStateCsmRequestCreate", () => (parcelRequire("4dNJa")).getBlockedAppsBannerStateCsmRequestCreate);

var $4dNJa = parcelRequire("4dNJa");

});
parcelRegister("4dNJa", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => $2a1c0328f10eb2ea$export$5d00eff3ead4a783);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => $2a1c0328f10eb2ea$export$5e1a47e73ae7249);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => $2a1c0328f10eb2ea$export$4b185f1cda5a42b9);
$parcel$export(module.exports, "getBlockedAppsBannerStateCsmRequestCreate", () => $2a1c0328f10eb2ea$export$af4a28eee1c6b301);
const $2a1c0328f10eb2ea$export$5d00eff3ead4a783 = (state)=>{
    return state.persisted.blockedAppsBanner.portal || state.persisted.blockedAppsBanner.connect.portal;
};
const $2a1c0328f10eb2ea$export$5e1a47e73ae7249 = (state)=>{
    return state.persisted.blockedAppsBanner.view_request || state.persisted.blockedAppsBanner.connect.view_request;
};
const $2a1c0328f10eb2ea$export$4b185f1cda5a42b9 = (state)=>{
    return state.persisted.blockedAppsBanner.create_request || state.persisted.blockedAppsBanner.connect.create_request;
};
const $2a1c0328f10eb2ea$export$af4a28eee1c6b301 = (state)=>{
    return state.persisted.blockedAppsBanner.csm_create_request;
};

});


parcelRegister("2y2Vi", function(module, exports) {
$parcel$export(module.exports, "default", () => $352deefa936a066a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $i7phc = parcelRequire("i7phc");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $buKRr = parcelRequire("buKRr");

var $gQmN3 = parcelRequire("gQmN3");

var $haAAx = parcelRequire("haAAx");

var $3kjRG = parcelRequire("3kjRG");

var $oORS9 = parcelRequire("oORS9");

var $2aX9I = parcelRequire("2aX9I");
const $352deefa936a066a$export$6db1cbf096e6afb2 = 'sd.portal.blocked.apps.banner.learnMore';
const $352deefa936a066a$export$f35e1704e0ced261 = 'sd.portal.blocked.apps.banner.doNotShow';
const $352deefa936a066a$var$getStyles = (page)=>{
    if (page === (0, $i7phc.FORGE_REQUEST_DETAILS)) return {
        marginBottom: `${"var(--ds-space-300, 24px)"}`
    };
    return {
        marginTop: `${"var(--ds-space-300, 24px)"}`
    };
};
const $352deefa936a066a$export$1cac45d8ffd5ecc3 = (accountId, projectId)=>{
    return `showBlockedAppsBanner-${projectId}-${accountId}`;
};
const $352deefa936a066a$var$BlockedAppsBannerComponent = ({ blockedAppsBannerState: blockedAppsBannerState, page: page, projectId: projectId, isAtlassianManagedAccount: isAtlassianManagedAccount, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [showBannerForProject, setShowBannerForProject] = (0, $bSJIT.useState)(false);
    const doNotShowClickHandler = (0, $bSJIT.useCallback)(()=>{
        if (accountId) (0, $3kjRG.setLocalStorageItem)($352deefa936a066a$export$1cac45d8ffd5ecc3(accountId, projectId), 'false');
        setShowBannerForProject(false);
    }, [
        accountId,
        projectId
    ]);
    const learnMoreUrl = (0, $bSJIT.useMemo)(()=>{
        return (0, $oORS9.getLearnMoreUrl)();
    }, []);
    const isBannerCondtionsSatisfied = !!blockedAppsBannerState && // @ts-ignore
    !!blockedAppsBannerState[page] && isAtlassianManagedAccount && showBannerForProject;
    (0, $bSJIT.useEffect)(()=>{
        if (accountId) {
            const showBannerStatus = (0, $3kjRG.getLocalStorageItem)($352deefa936a066a$export$1cac45d8ffd5ecc3(accountId, projectId));
            if (showBannerStatus && showBannerStatus === 'false') setShowBannerForProject(false);
            else setShowBannerForProject(true);
        }
    }, [
        accountId,
        projectId
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (isBannerCondtionsSatisfied) {
            const event = createAnalyticsEvent({
                analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                action: 'viewed',
                actionSubject: 'blockedAppBanner',
                attributes: {
                    page: page,
                    userType: isAtlassianManagedAccount ? 'isAtlassianManagedAccount' : 'customer'
                }
            });
            event.fire();
        }
    }, [
        createAnalyticsEvent,
        isBannerCondtionsSatisfied,
        accountId,
        projectId,
        isAtlassianManagedAccount,
        page
    ]);
    if (isBannerCondtionsSatisfied) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: $352deefa936a066a$var$getStyles(page)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $buKRr.default), {
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gQmN3.default), {
                testId: $352deefa936a066a$export$6db1cbf096e6afb2,
                href: learnMoreUrl,
                key: $352deefa936a066a$export$6db1cbf096e6afb2
            }, formatMessage((0, $2aX9I.default).learnMore)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gQmN3.default), {
                testId: $352deefa936a066a$export$f35e1704e0ced261,
                onClick: doNotShowClickHandler,
                key: $352deefa936a066a$export$f35e1704e0ced261
            }, formatMessage((0, $2aX9I.default).doNotShow))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("p", null, (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $2aX9I.default).bannerDescriptionGalaxia) : formatMessage((0, $2aX9I.default).bannerDescription)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
};
var $352deefa936a066a$export$2e2bcd8739ae039 = $352deefa936a066a$var$BlockedAppsBannerComponent;

});
parcelRegister("gQmN3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b792f012c84f587e$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v3.0.2 */ /* section-message-action.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hzFIQ = parcelRequire("hzFIQ");

var $jDsoo = parcelRequire("jDsoo");

var $9Rfip = parcelRequire("9Rfip");

var $9PwDt = parcelRequire("9PwDt");

var $gXqq0 = parcelRequire("gXqq0");
const $b792f012c84f587e$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_2rkolb4i _syaz13af _k48p1wq8 _bfhk1j28 _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $b792f012c84f587e$var$SectionMessageAction = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }, ref)=>{
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                $b792f012c84f587e$var$styles.common,
                $b792f012c84f587e$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Rfip.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                ref: ref,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $jDsoo.cx)($b792f012c84f587e$var$styles.common, $b792f012c84f587e$var$styles.pressable),
            ref: ref,
            children: children
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
            as: "span",
            testId: testId,
            xcss: $b792f012c84f587e$var$styles.common,
            ref: ref,
            children: children
        });
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $hzFIQ.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref,
        children: children
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: children
    });
}));
$b792f012c84f587e$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $b792f012c84f587e$export$2e2bcd8739ae039 = $b792f012c84f587e$var$SectionMessageAction;

});

parcelRegister("2aX9I", function(module, exports) {
$parcel$export(module.exports, "default", () => $29d758d8a81c2de0$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $29d758d8a81c2de0$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    bannerDescription: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this project through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description'
    },
    bannerDescriptionGalaxia: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this space through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description-galaxia'
    },
    doNotShow: {
        defaultMessage: "Don't show again",
        description: 'Do not show again link. When the user clicks on this, he will not see the blocked apps banner again',
        id: 'sd.portal.blocked.app.banner.doNotShow'
    },
    learnMore: {
        defaultMessage: 'View blocked apps',
        description: 'This is a link that the users can click to view the blocked apps',
        id: 'sd.portal.blocked.app.banner.learnMore'
    }
});

});



parcelRegister("3GBA9", function(module, exports) {
$parcel$export(module.exports, "CategoryList", () => $c43b671f1346aab7$export$79717968ed9ae6cd);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $a5Mho = parcelRequire("a5Mho");
const $c43b671f1346aab7$var$selector = (0, $BOq7h.createSelector)((state, props)=>(0, $iWhHo.getCategories)(state, props.portalId), (state, props)=>(0, $iWhHo.getIsKbEnabled)(state, props.portalId), (state, props)=>(0, $iWhHo.getPortalLink)(state, props.portalId), (state, props)=>(0, $iWhHo.canCreateRequest)(state, props.portalId), (maybeCategories, enabled, portalLink, showRequestCreateButton)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        hidden: !enabled
    };
});
const $c43b671f1346aab7$export$79717968ed9ae6cd = (0, $f2mlD.default)($c43b671f1346aab7$var$selector)((0, $a5Mho.default));

});
parcelRegister("a5Mho", function(module, exports) {
$parcel$export(module.exports, "default", () => $81ff6fae58da955a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $5cKiX = parcelRequire("5cKiX");
parcelRequire("8gXQS");
var $7U1yS = parcelRequire("7U1yS");
parcelRequire("7VtLj");
var $1Bwl1 = parcelRequire("1Bwl1");

var $dwOcU = parcelRequire("dwOcU");

var $3I5RS = parcelRequire("3I5RS");

var $iydAA = parcelRequire("iydAA");
parcelRequire("cOG55");
var $7CorS = parcelRequire("7CorS");

var $26MkW = parcelRequire("26MkW");
class $81ff6fae58da955a$export$2e2bcd8739ae039 extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        portalId: undefined,
        categories: []
    };
    render() {
        const { portalId: portalId, categories: categories, portalLink: portalLink, hidden: hidden, cardLinkAppearance: cardLinkAppearance, className: className, showRequestCreateButton: showRequestCreateButton, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        if (hidden || !portalId || categories.length === 0) return null;
        const analyticData = {
            attributes: {
                numberOfCategories: categories.length
            }
        };
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: analyticData
        }, /*#__PURE__*/ $bSJIT.createElement($81ff6fae58da955a$export$be92b6f5f03c0fe9, {
            className: className
        }, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), /*#__PURE__*/ $bSJIT.createElement($81ff6fae58da955a$var$CategorySectionTitle, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3I5RS))), {
            spacing: "spacious",
            label: "",
            "aria-hidden": "true",
            color: "var(--ds-icon, #42526E)"
        }), /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $26MkW.default).kbCategorySectionTitle)), /*#__PURE__*/ $bSJIT.createElement($81ff6fae58da955a$var$CategoryItems, null, categories.map((category)=>/*#__PURE__*/ $bSJIT.createElement($81ff6fae58da955a$var$CategoryItemContainer, {
                key: category.id
            }, /*#__PURE__*/ $bSJIT.createElement((0, $7CorS.default), {
                portalId: portalId,
                category: category,
                isEmbeddedRoute: isEmbeddedRoute
            })))), showRequestCreateButton && /*#__PURE__*/ $bSJIT.createElement((0, $1Bwl1.default), {
            appearance: cardLinkAppearance,
            to: portalLink,
            isEmbeddedRoute: isEmbeddedRoute
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $81ff6fae58da955a$var$CategorySectionTitle = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-12gjrid-0"
})`${$98sDU.h500};display:flex;align-items:center;font-weight:600;margin-bottom:0;> :first-child{margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $81ff6fae58da955a$var$CategoryItems = /*#__PURE__*/ (0, $4v2A7.default).ul.withConfig({
    componentId: "sc-12gjrid-1"
})`padding:0;margin:0 -${(0, $7U1yS.GROUP_BOX_PADDING_LEFT_RIGHT)} ${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $81ff6fae58da955a$var$CategoryItemContainer = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-12gjrid-2"
})`padding:0;margin:0;list-style:none;`;
const $81ff6fae58da955a$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-12gjrid-3"
})`flex:1 1 auto;`;

});
parcelRegister("cOG55", function(module, exports) {
$parcel$export(module.exports, "CategoryItem", () => (parcelRequire("7CorS")).default);

var $7CorS = parcelRequire("7CorS");

});
parcelRegister("7CorS", function(module, exports) {
$parcel$export(module.exports, "default", () => $82f599f6ec87c833$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1tATL");
var $8NUJj = parcelRequire("8NUJj");

var $dwOcU = parcelRequire("dwOcU");
class $82f599f6ec87c833$export$2e2bcd8739ae039 extends $bSJIT.Component {
    render() {
        const { category: category, portalId: portalId, onClick: onClick, className: className, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        const analyticData = {
            attributes: {
                portalId: portalId,
                categoryId: category.id
            }
        };
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: analyticData
        }, /*#__PURE__*/ $bSJIT.createElement((0, $8NUJj.default), {
            actionSubjectId: "category",
            to: `/portal/${portalId}/topic/${category.id}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: onClick,
            heading: category.name,
            headingAs: "div",
            isAriaHidden: true,
            description: category.description,
            lineClamp: 2,
            target: isEmbeddedRoute ? '_blank' : undefined
        }));
    }
}

});


parcelRegister("26MkW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab3dfb62a43df11c$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ab3dfb62a43df11c$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    kbCategorySectionTitle: {
        defaultMessage: 'Learn more about',
        description: 'Section title for a section that shows a list of knowledge base categories',
        id: 'cv.portal.home.kb.category.section.title'
    }
});

});



parcelRegister("hiiav", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("1wLLy")).default);
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("03svw")).default);
/*
  Previously a distinction was made between the single portal and request-create pages when rendering connect fragments.
  In Portal X, the portal home and request create page display the same connect fragments.
*/ parcelRequire("AlCYx");
var $1wLLy = parcelRequire("1wLLy");
parcelRequire("7kZXq");
var $03svw = parcelRequire("03svw");

});
parcelRegister("AlCYx", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("1wLLy")).default);

var $1wLLy = parcelRequire("1wLLy");

});
parcelRegister("1wLLy", function(module, exports) {
$parcel$export(module.exports, "default", () => $baa307a3aefa06ab$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $eazQ4 = parcelRequire("eazQ4");
var $kPxiY = parcelRequire("kPxiY");
const $baa307a3aefa06ab$var$HeaderConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragment), {
        page: page,
        location: (0, $kPxiY.HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }), /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragment), {
        page: page,
        location: (0, $kPxiY.SUB_HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $baa307a3aefa06ab$export$2e2bcd8739ae039 = $baa307a3aefa06ab$var$HeaderConnectFragments;

});


parcelRegister("7kZXq", function(module, exports) {
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("03svw")).default);

var $03svw = parcelRequire("03svw");

});
parcelRegister("03svw", function(module, exports) {
$parcel$export(module.exports, "default", () => $032aadd49675fab6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $eazQ4 = parcelRequire("eazQ4");
var $kPxiY = parcelRequire("kPxiY");
const $032aadd49675fab6$var$FooterConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $bSJIT.createElement($032aadd49675fab6$var$ConnectFooterContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragment), {
        page: page,
        location: (0, $kPxiY.FOOTER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $032aadd49675fab6$export$2e2bcd8739ae039 = $032aadd49675fab6$var$FooterConnectFragments;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $032aadd49675fab6$var$ConnectFooterContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1lbb1kc-0"
})`padding-top:0;padding-bottom:0;`;

});



parcelRegister("eRG8F", function(module, exports) {
$parcel$export(module.exports, "FormPicker", () => (parcelRequire("dN9dL")).default);

var $dN9dL = parcelRequire("dN9dL");

});
parcelRegister("dN9dL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e050c2f0df7814d$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("80y9N");
var $ks6At = parcelRequire("ks6At");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("bkZZV");
var $b6YNt = parcelRequire("b6YNt");
const $9e050c2f0df7814d$var$getRequestTypes = (state, props)=>(0, $iWhHo.getPortalRequestTypes)(state, props.portalId);
const $9e050c2f0df7814d$var$getRequestGroups = (state, props)=>(0, $iWhHo.getPortalRequestGroups)(state, props.portalId);
const $9e050c2f0df7814d$var$getIsSimplifiedPortal = (state, props)=>Boolean((0, $iWhHo.getIsProjectSimplified)(state, props.portalId));
const $9e050c2f0df7814d$var$getPortalProjectKey = (state, props)=>{
    const projectKey = (0, $iWhHo.getProjectKey)(state, props === null || props === void 0 ? void 0 : props.portalId);
    return (projectKey === null || projectKey === void 0 ? void 0 : projectKey.toString()) || '';
};
const $9e050c2f0df7814d$var$getIsProjectAdmin = (state, props)=>{
    return Boolean((0, $iWhHo.getCanAdministerProject)(state, props.portalId));
};
const $9e050c2f0df7814d$var$getIsJiraAdmin = (state, _)=>{
    return Boolean((0, $fBLyB.getCanAdministerJIRA)(state));
};
const $9e050c2f0df7814d$var$getRequestTypeNameById = (id, requestTypes)=>{
    const requestType = requestTypes.find((reqType)=>reqType.id === id);
    return requestType ? {
        name: requestType.name,
        id: requestType.id
    } : undefined;
};
const $9e050c2f0df7814d$var$getRequestTypeNames = (groupReqTypes = [], portalReqGroups)=>groupReqTypes.map((id)=>$9e050c2f0df7814d$var$getRequestTypeNameById(id, portalReqGroups)).filter(Boolean);
const $9e050c2f0df7814d$var$populateRequestTypeNames = (portalReqTypes)=>(requestGroup)=>({
            ...requestGroup,
            reqTypes: $9e050c2f0df7814d$var$getRequestTypeNames(requestGroup.reqTypes, portalReqTypes)
        });
const $9e050c2f0df7814d$var$selector = (0, $BOq7h.createSelector)($9e050c2f0df7814d$var$getRequestGroups, $9e050c2f0df7814d$var$getRequestTypes, (0, $ks6At.getPortals), $9e050c2f0df7814d$var$getIsSimplifiedPortal, $9e050c2f0df7814d$var$getPortalProjectKey, $9e050c2f0df7814d$var$getIsProjectAdmin, $9e050c2f0df7814d$var$getIsJiraAdmin, (requestGroups, requestTypes, allPortals, isProjectSimplified, projectKey, isProjectAdmin, isJiraAdmin)=>({
        requestTypes: requestTypes,
        isProjectSimplified: isProjectSimplified,
        projectKey: projectKey,
        isProjectAdmin: isProjectAdmin,
        isJiraAdmin: isJiraAdmin,
        requestGroups: requestGroups.map($9e050c2f0df7814d$var$populateRequestTypeNames(requestTypes)),
        // displayLinkWhenNoGroups will only return true if portals data is already populated. If this page is accessed by direct link, it'll return false.
        // As it's such an edge case, it was decided that's enough.
        displayLinkWhenNoGroups: Object.keys(allPortals).length > 1
    }));
var $9e050c2f0df7814d$export$2e2bcd8739ae039 = (0, $f2mlD.default)($9e050c2f0df7814d$var$selector)((0, $b6YNt.default));

});
parcelRegister("bkZZV", function(module, exports) {
$parcel$export(module.exports, "FormPickerDumb", () => (parcelRequire("b6YNt")).default);

var $b6YNt = parcelRequire("b6YNt");

});
parcelRegister("b6YNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $54cefb1e99802e21$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $fT4XN = parcelRequire("fT4XN");

var $c6H7d = parcelRequire("c6H7d");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");
parcelRequire("4OMyJ");
var $1xaoE = parcelRequire("1xaoE");
var $5nlV6 = parcelRequire("5nlV6");
var $ijJjo = parcelRequire("ijJjo");

var $iydAA = parcelRequire("iydAA");

var $eDcdn = parcelRequire("eDcdn");

var $5LmQo = parcelRequire("5LmQo");
parcelRequire("lVOVX");
var $jETIR = parcelRequire("jETIR");
parcelRequire("ekoCm");
var $9rFxG = parcelRequire("9rFxG");
parcelRequire("btrfc");
var $9kKRq = parcelRequire("9kKRq");

var $1aQQ2 = parcelRequire("1aQQ2");
class $54cefb1e99802e21$export$600c4eef2a10987b extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        // Required to explicitly set this to false by default as the <AutoFocus />
        // component will focus when it is `undefined`.
        autoFocus: false
    };
    render() {
        const { requestGroupId: requestGroupId, requestTypeId: requestTypeId, portalId: portalId, requestGroups: requestGroups, isDisabled: isDisabled, className: className, intl: intl, hideLabels: hideLabels, autoFocus: autoFocus, cardLinkAppearance: cardLinkAppearance, displayLinkWhenNoGroups: displayLinkWhenNoGroups, isEmbeddedRoute: isEmbeddedRoute, isCSM: isCSM, isProjectSimplified: isProjectSimplified, projectKey: projectKey, isProjectAdmin: isProjectAdmin } = this.props;
        const hasSingleRequestGroup = requestGroups.length === 1;
        const hasRequestGroup = requestGroups.length > 0;
        // If a group id is passed through that isn't actually inside the request groups array we make it undefined
        const matchingRequestGroupId = !!requestGroups.find((group)=>group.id === requestGroupId) ? requestGroupId : undefined;
        // If there is only one element in the request groups array we force it to be selected.
        const selectedRequestGroupId = hasSingleRequestGroup ? requestGroups[0].id : matchingRequestGroupId;
        const requestTypesForGroup = this.getRequestTypesForSelectedRequestGroup(selectedRequestGroupId);
        // If a type id is passed through that isn't actually inside the request types array we make it undefined
        const selectedRequestTypeId = !!requestTypesForGroup.find((requestType)=>Number(requestType.id) === Number(requestTypeId)) ? requestTypeId : undefined;
        const { customizePortalButtonsGroup: customizePortalButtonsGroup, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.getAdditionButtons(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId);
        return hasRequestGroup ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $bSJIT.createElement("div", {
            className: className
        }, hasSingleRequestGroup || /*#__PURE__*/ $bSJIT.createElement((0, $9rFxG.default), {
            autoFocus: autoFocus && !selectedRequestGroupId,
            portalId: portalId,
            requestGroups: requestGroups,
            label: !!hideLabels ? '' : intl.formatMessage((0, $1aQQ2.default).requestGroupSelectLabel),
            value: selectedRequestGroupId,
            onChange: this.selectRequestGroup,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            labelHeadingAs: "h2",
            ...!!customizePortalButtonsGroup && {
                customizePortalButtonsGroup: customizePortalButtonsGroup
            }
        }), !!requestTypesForGroup.length && /*#__PURE__*/ $bSJIT.createElement($54cefb1e99802e21$export$d9d410f2d2df162e, {
            hasTopMargin: !hasSingleRequestGroup,
            autoFocus: autoFocus && !!selectedRequestGroupId,
            portalId: portalId,
            requestGroupId: selectedRequestGroupId,
            label: this.getStyledRequestTypeSelectLabel(),
            requestTypes: requestTypesForGroup,
            value: selectedRequestTypeId,
            onChange: this.selectRequestType,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            isCSM: isCSM,
            headingAs: "div",
            labelHeadingAs: "h2",
            ...!!editRequestTypeOnRequestForm && {
                editRequestTypeOnRequestForm: editRequestTypeOnRequestForm
            },
            ...!!editRequestTypeOnRequestList && {
                editRequestTypeOnRequestList: editRequestTypeOnRequestList
            }
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $bSJIT.createElement("div", {
            className: className
        }, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $1aQQ2.default).emptyStateMessage), ' ', displayLinkWhenNoGroups && /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
            actionSubjectId: "tryAnotherServiceDesk",
            to: "/portals"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $1aQQ2.default).tryAnotherServiceProjectLink)));
    }
    getAdditionButtons(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId) {
        const shouldShowAdditionalPortalLinks = isProjectAdmin && !isProjectSimplified;
        const customizePortalButtonsGroup = projectKey !== null && projectKey !== void 0 && projectKey.length && shouldShowAdditionalPortalLinks ? /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            id: "customize-portal-button-group",
            renderError: ()=>null
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1xaoE.default), {
            projectKey: projectKey
        })) : null;
        const editRequestTypeOnRequestForm = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestTypeId && shouldShowAdditionalPortalLinks ? /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            id: "edit-request-type-button",
            renderError: ()=>null
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5nlV6.default), {
            projectKey: projectKey,
            requestTypeId: selectedRequestTypeId
        })) : null;
        const editRequestTypeOnRequestList = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestGroupId && shouldShowAdditionalPortalLinks ? (requestTypeId, ariaLabel)=>/*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
                id: "edit-request-type-button",
                renderError: ()=>null
            }, /*#__PURE__*/ $bSJIT.createElement((0, $ijJjo.default), {
                projectKey: projectKey,
                requestTypeId: requestTypeId,
                ariaLabel: ariaLabel
            })) : null;
        return {
            customizePortalButtonsGroup: customizePortalButtonsGroup,
            editRequestTypeOnRequestForm: editRequestTypeOnRequestForm,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        };
    }
    constructor(...args){
        super(...args), this.getRequestTypesForSelectedRequestGroup = (requestGroupId)=>{
            const { requestTypes: requestTypes, requestGroups: requestGroups } = this.props;
            if (requestGroupId) {
                const selectedRequestGroup = requestGroups.find((requestGroup)=>requestGroup.id === requestGroupId);
                if (selectedRequestGroup) return selectedRequestGroup.reqTypes.map((reqType)=>requestTypes.find((rt)=>rt.id === reqType.id)).filter(Boolean);
            }
            return [];
        }, this.selectRequestGroup = (id)=>{
            // If id is undefined we push back to the /:portalId/group/-1 route.
            // This covers the case if there are article categories on the portal.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            const referrer = $5LmQo.get((0, $jETIR.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            (0, $eDcdn.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${this.props.portalId}/group/${id || '-1'}`,
                search: shouldAddReferrer ? `?${0, $jETIR.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.selectRequestType = (id)=>{
            const { requestGroups: requestGroups, portalId: portalId, requestGroupId: requestGroupId } = this.props;
            const hasSingleRequestGroup = requestGroups.length === 1;
            const groupId = hasSingleRequestGroup ? requestGroups[0].id : requestGroupId;
            const referrer = $5LmQo.get((0, $jETIR.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            (0, $eDcdn.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${portalId}/group/${groupId}${id ? `/create/${id}` : ''}`,
                search: shouldAddReferrer ? `?${0, $jETIR.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.getStyledRequestTypeSelectLabel = ()=>{
            const { hideLabels: hideLabels, intl: intl, isCSM: isCSM } = this.props;
            if (!!hideLabels) return '';
            if (isCSM) return intl.formatMessage((0, $1aQQ2.default).CSMRequestTypeSelectLabel);
            return intl.formatMessage((0, $1aQQ2.default).requestTypeSelectLabel);
        };
    }
}
var $54cefb1e99802e21$export$2e2bcd8739ae039 = (0, $fK3tS.default)($54cefb1e99802e21$export$600c4eef2a10987b);
const $54cefb1e99802e21$export$d9d410f2d2df162e = /*#__PURE__*/ (0, $4v2A7.default)((0, $9kKRq.default)).withConfig({
    componentId: "sc-1hnffkr-0"
})`margin-top:${(props)=>props.hasTopMargin ? "var(--ds-space-400, 32px)" : 0};`;

});
parcelRegister("4OMyJ", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("1xaoE")).default);
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("5nlV6")).default);
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("ijJjo")).default);
parcelRequire("bP3yE");
var $1xaoE = parcelRequire("1xaoE");
parcelRequire("awjIo");
var $5nlV6 = parcelRequire("5nlV6");
parcelRequire("6fEqq");
var $ijJjo = parcelRequire("ijJjo");

});
parcelRegister("bP3yE", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("1xaoE")).default);

var $1xaoE = parcelRequire("1xaoE");

});
parcelRegister("1xaoE", function(module, exports) {
$parcel$export(module.exports, "default", () => $41cf5ace8c4ee128$export$2e2bcd8739ae039);
/* customize-portal-button-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $2usNr = parcelRequire("2usNr");

var $6WltM = parcelRequire("6WltM");

var $hPVlR = parcelRequire("hPVlR");

var $87QgR = parcelRequire("87QgR");

var $axJ38 = parcelRequire("axJ38");

var $6X9z7 = parcelRequire("6X9z7");

var $8aT4G = parcelRequire("8aT4G");

var $haAAx = parcelRequire("haAAx");

var $oORS9 = parcelRequire("oORS9");

var $W7P24 = parcelRequire("W7P24");
const $41cf5ace8c4ee128$var$ISSUE_A11Y_37386 = 'issue-a11y-37386';
const $41cf5ace8c4ee128$var$isIssueA11y37386Enabled = ()=>(0, $87QgR.default).checkGate($41cf5ace8c4ee128$var$ISSUE_A11Y_37386);
const $41cf5ace8c4ee128$var$ButtonStyles = null;
const $41cf5ace8c4ee128$var$CustomizePortalButtonFolderOpenIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($axJ38))), {
        ...iconProps,
        label: $41cf5ace8c4ee128$var$isIssueA11y37386Enabled() ? '' : formatMessage((0, $W7P24.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $41cf5ace8c4ee128$var$CustomizePortalButtonGroup = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { projectKey: projectKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const onClickManagePortalGroups = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'managePortalGroupsButton',
            action: 'clicked',
            actionSubject: 'CustomizePortalButtonGroup',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $bSJIT.createElement((0, $6X9z7.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hPVlR.default), {
        href: (0, $oORS9.getPortalGroupSettingsUrl)(projectKey),
        appearance: "subtle",
        target: "_blank",
        testId: "manage-portal-groups-button",
        onClick: onClickManagePortalGroups,
        iconBefore: $41cf5ace8c4ee128$var$CustomizePortalButtonFolderOpenIcon
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $W7P24.default).managePortalGroupsLabel)))));
};
var $41cf5ace8c4ee128$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'CustomizePortalButtonGroup'
})($41cf5ace8c4ee128$var$CustomizePortalButtonGroup);

});
parcelRegister("hPVlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c842315db77bcc0b$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ /* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $fGbV9 = parcelRequire("fGbV9");

var $21u3G = parcelRequire("21u3G");

var $bLXMw = parcelRequire("bLXMw");

var $kLU70 = parcelRequire("kLU70");

var $aHtkE = parcelRequire("aHtkE");
const $c842315db77bcc0b$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _10531gmx _jomr187o _f8pj1gmx _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $c842315db77bcc0b$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $c842315db77bcc0b$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $c842315db77bcc0b$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _irr31afz _1di61kru"
};
const $c842315db77bcc0b$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $c842315db77bcc0b$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $c842315db77bcc0b$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $c842315db77bcc0b$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $c842315db77bcc0b$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $c842315db77bcc0b$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $bSJIT.useRef)(null);
    (0, $21u3G.default)(localRef, autoFocus);
    const combinedRef = (0, $fGbV9.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bLXMw.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $jDsoo.cx)($c842315db77bcc0b$var$styles.base, !isDisabled && $c842315db77bcc0b$var$styles.interactiveMotion, appearance === 'default' && $c842315db77bcc0b$var$defaultStyles.root, appearance === 'primary' && $c842315db77bcc0b$var$primaryStyles.root, appearance === 'rovo' && $c842315db77bcc0b$var$rovoStyles.root, appearance === 'warning' && $c842315db77bcc0b$var$warningStyles.root, appearance === 'danger' && $c842315db77bcc0b$var$dangerStyles.root, appearance === 'discovery' && $c842315db77bcc0b$var$discoveryStyles.root, appearance === 'subtle' && $c842315db77bcc0b$var$subtleStyles.root, $c842315db77bcc0b$var$styles.linkDecorationUnset, isSelected && $c842315db77bcc0b$var$selectedStyles.root, isSelected && appearance === 'danger' && $c842315db77bcc0b$var$selectedStyles.danger, isSelected && appearance === 'warning' && $c842315db77bcc0b$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $c842315db77bcc0b$var$selectedStyles.discovery, isDisabled && $c842315db77bcc0b$var$styles.disabled, spacing === 'compact' && $c842315db77bcc0b$var$styles.spacingCompact, hasIconBefore && $c842315db77bcc0b$var$styles.buttonIconBefore, hasIconAfter && $c842315db77bcc0b$var$styles.buttonIconAfter, shouldFitContainer && $c842315db77bcc0b$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kLU70.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kLU70.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kLU70.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHtkE.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $c842315db77bcc0b$var$LinkButton = /*#__PURE__*/ (0, $bSJIT.forwardRef)($c842315db77bcc0b$var$LinkButtonBase);
$c842315db77bcc0b$var$LinkButton.displayName = 'LinkButton';
var $c842315db77bcc0b$export$2e2bcd8739ae039 = $c842315db77bcc0b$var$LinkButton;

});

parcelRegister("axJ38", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43f19c9c1a27a90187893d14cfaa1965>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7acfee5e53f045fe$var$_react = $7acfee5e53f045fe$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $7acfee5e53f045fe$var$_iconNew = $7acfee5e53f045fe$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $7acfee5e53f045fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-open
 * Usage guidance:
 * Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7acfee5e53f045fe$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $7acfee5e53f045fe$var$_react.default.createElement($7acfee5e53f045fe$var$_iconNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$7acfee5e53f045fe$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $7acfee5e53f045fe$var$_default = module.exports.default = $7acfee5e53f045fe$var$FolderOpenIcon;

});

parcelRegister("W7P24", function(module, exports) {
$parcel$export(module.exports, "default", () => $d07fed8f48ace145$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $d07fed8f48ace145$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    managePortalGroupsLabel: {
        defaultMessage: 'Manage portal groups',
        description: 'Button text to Navigate user to Manage Portal Groups in JSM',
        id: 'help-center.app.common.customize-portal-buttons.manage-portal-groups-label'
    },
    editRequestTypeLabel: {
        defaultMessage: 'Edit request type',
        description: 'Button text to Navigate user to Request Type editor in JSM',
        id: 'help-center.app.common.customize-portal-buttons.edit-request-type-label'
    }
});

});



parcelRegister("awjIo", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("5nlV6")).default);

var $5nlV6 = parcelRequire("5nlV6");

});
parcelRegister("5nlV6", function(module, exports) {
$parcel$export(module.exports, "default", () => $95da5967cedf7eb2$export$2e2bcd8739ae039);
/* edit-request-type-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $2usNr = parcelRequire("2usNr");

var $6WltM = parcelRequire("6WltM");

var $hPVlR = parcelRequire("hPVlR");

var $5Uddy = parcelRequire("5Uddy");

var $8aT4G = parcelRequire("8aT4G");

var $6X9z7 = parcelRequire("6X9z7");

var $haAAx = parcelRequire("haAAx");

var $oORS9 = parcelRequire("oORS9");

var $W7P24 = parcelRequire("W7P24");
const $95da5967cedf7eb2$var$EditRequestTypeButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const onClickButton = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $bSJIT.createElement((0, $6X9z7.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hPVlR.default), {
        href: (0, $oORS9.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-button",
        onClick: onClickButton,
        iconBefore: $95da5967cedf7eb2$var$EditRequestTypeButtonEditIcon
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $W7P24.default).editRequestTypeLabel)))));
};
const $95da5967cedf7eb2$var$EditRequestTypeButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))), {
        ...iconProps,
        label: formatMessage((0, $W7P24.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $95da5967cedf7eb2$var$ButtonStyles = null;
var $95da5967cedf7eb2$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'EditRequestTypeButton'
})($95da5967cedf7eb2$var$EditRequestTypeButton);

});
parcelRegister("5Uddy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64841177977326ccd1f2b755f9ee3f4a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44cc6f76c8fe1376$var$_react = $44cc6f76c8fe1376$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $44cc6f76c8fe1376$var$_iconNew = $44cc6f76c8fe1376$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $44cc6f76c8fe1376$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/edit
 * Usage guidance:
 * Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44cc6f76c8fe1376$var$EditIcon = (props)=>/*#__PURE__*/ $44cc6f76c8fe1376$var$_react.default.createElement($44cc6f76c8fe1376$var$_iconNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$44cc6f76c8fe1376$var$EditIcon.displayName = 'EditIcon';
var $44cc6f76c8fe1376$var$_default = module.exports.default = $44cc6f76c8fe1376$var$EditIcon;

});



parcelRegister("6fEqq", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("ijJjo")).default);

var $ijJjo = parcelRequire("ijJjo");

});
parcelRegister("ijJjo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f67ffd9e476bdebc$export$2e2bcd8739ae039);
/* edit-request-type-hover-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $2usNr = parcelRequire("2usNr");

var $6WltM = parcelRequire("6WltM");

var $hPVlR = parcelRequire("hPVlR");

var $5Uddy = parcelRequire("5Uddy");

var $87QgR = parcelRequire("87QgR");

var $8aT4G = parcelRequire("8aT4G");

var $haAAx = parcelRequire("haAAx");

var $oORS9 = parcelRequire("oORS9");

var $W7P24 = parcelRequire("W7P24");
const $f67ffd9e476bdebc$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $f67ffd9e476bdebc$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($f67ffd9e476bdebc$var$HC_ADS_DROP_COMMIT_2);
const $f67ffd9e476bdebc$var$EditRequestTypeHoverButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId, ariaLabel: ariaLabel } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const onClickButton = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeHoverButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
    };
    const defaultLabel = formatMessage((0, $W7P24.default).editRequestTypeLabel);
    const label = ariaLabel ? `${defaultLabel} - ${ariaLabel}` : defaultLabel;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "edit-request-type-hover-button-wrapper",
        className: (0, $9fU1q.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _vchhusvi",
            $f67ffd9e476bdebc$var$isHcAdsDropCommit2Enabled() && "_2rko1qi0"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hPVlR.default), {
        href: (0, $oORS9.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-hover-button",
        onClick: onClickButton,
        spacing: "compact",
        shouldFitContainer: true,
        iconBefore: $f67ffd9e476bdebc$var$EditRequestTypeHoverButtonEditIcon,
        "aria-label": label
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, defaultLabel)));
};
const $f67ffd9e476bdebc$var$EditRequestTypeHoverButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))), {
        ...iconProps,
        label: formatMessage((0, $W7P24.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #505258)"
    });
};
const $f67ffd9e476bdebc$var$ButtonStyles = null;
// hc_ads_drop_commit_2: ADS drop 2 bumps the request-description tile radius.
const $f67ffd9e476bdebc$var$buttonShapeThemeStyles = null;
var $f67ffd9e476bdebc$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'EditRequestTypeHoverButton'
})($f67ffd9e476bdebc$var$EditRequestTypeHoverButton);

});



parcelRegister("lVOVX", function(module, exports) {
$parcel$export(module.exports, "LearnByDoing", () => (parcelRequire("jGNec")).default);
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => (parcelRequire("eAsHJ")).shouldShowLearnByDoingBanner);
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => (parcelRequire("jETIR")).REFERRER_QUERY_PARAM);

var $jGNec = parcelRequire("jGNec");

var $eAsHJ = parcelRequire("eAsHJ");

var $jETIR = parcelRequire("jETIR");

});
parcelRegister("jGNec", function(module, exports) {
$parcel$export(module.exports, "default", () => $88b28bc8a3a48705$export$2e2bcd8739ae039);

var $4v2A7 = parcelRequire("4v2A7");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $2usNr = parcelRequire("2usNr");

var $7Azzd = parcelRequire("7Azzd");

var $hPVlR = parcelRequire("hPVlR");

var $7WQx2 = parcelRequire("7WQx2");

var $k9Jtq = parcelRequire("k9Jtq");

var $gdUUy = parcelRequire("gdUUy");

var $cMYsY = parcelRequire("cMYsY");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");

var $aRsbV = parcelRequire("aRsbV");

var $haAAx = parcelRequire("haAAx");

var $dDGDc = parcelRequire("dDGDc");

var $21PCD = parcelRequire("21PCD");
var $88b28bc8a3a48705$export$8400747e4d4d02ee = /*#__PURE__*/ function(StepNumber) {
    StepNumber[StepNumber["STEP1"] = 0] = "STEP1";
    StepNumber[StepNumber["STEP2"] = 1] = "STEP2";
    StepNumber[StepNumber["STEP3"] = 2] = "STEP3";
    return StepNumber;
}({});
const $88b28bc8a3a48705$var$LearnByDoing = ({ projectRedirectionLink: projectRedirectionLink, screenName: screenName })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const getStepNumber = ()=>{
        let step;
        if (screenName === (0, $jcRK7.ScreenName).PORTAL_HOME || screenName === (0, $jcRK7.ScreenName).REQUEST_GROUP) step = 0;
        else if (screenName === (0, $jcRK7.ScreenName).REQUEST_CREATE) step = 1;
        else if (screenName === (0, $jcRK7.ScreenName).REQUEST_DETAILS) step = 2;
        else step = -1;
        return step;
    };
    (0, $bSJIT.useEffect)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubject: 'learnByDoing',
            attributes: {
                screenName: screenName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        screenName
    ]);
    const stepNumber = getStepNumber();
    const steps = (0, $bSJIT.useMemo)(()=>[
            {
                stepNumber: 0,
                title: formatMessage((0, $21PCD.default).chooseRequestTypeHeading),
                description: formatMessage((0, $21PCD.default).chooseRequestTypeDesc)
            },
            {
                stepNumber: 1,
                title: formatMessage((0, $21PCD.default).sendExampleRequestHeading),
                description: formatMessage((0, $21PCD.default).sendExampleRequestDesc)
            },
            {
                stepNumber: 2,
                title: formatMessage((0, $21PCD.default).requestCreatedHeading),
                description: formatMessage((0, $gdUUy.fg)('itsm-project-renaming') ? (0, $21PCD.default).requestCreatedDescGalaxia : (0, $21PCD.default).requestCreatedDesc)
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7Azzd.default), null, stepNumber >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        alignInline: "center",
        alignBlock: "center",
        xcss: $88b28bc8a3a48705$var$LearnByDoingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
        xcss: $88b28bc8a3a48705$var$LearnByDoingStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "medium"
    }, formatMessage((0, $21PCD.default).learnByDoingDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
        xcss: $88b28bc8a3a48705$var$LearnByDoingFlowStyle
    }, steps.map((step, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
            xcss: [
                $88b28bc8a3a48705$var$LearnByDoingStepDefaultStyle,
                index === stepNumber && $88b28bc8a3a48705$var$LearnByDoingStepActiveStyle,
                index < stepNumber && $88b28bc8a3a48705$var$LearnByDoingStepDisableStyle
            ],
            key: `step-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
            xcss: [
                $88b28bc8a3a48705$var$StepNumberContainerDefaultStyle,
                index === stepNumber && $88b28bc8a3a48705$var$StepNumberContainerActiveStyle,
                index < stepNumber && $88b28bc8a3a48705$var$StepNumberContainerDisableStyle
            ]
        }, index >= stepNumber ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
            alignItems: "center",
            xcss: [
                $88b28bc8a3a48705$var$headingContainerStepNumberDefaultStyles,
                index === stepNumber && $88b28bc8a3a48705$var$headingContainerStepNumberActiveStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($88b28bc8a3a48705$var$_StyledBox, null, step.stepNumber + 1)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
            label: "success",
            color: "var(--ds-icon-accent-green, #189864)",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
            xcss: $88b28bc8a3a48705$var$ContentStyle,
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
            size: "small"
        }, step.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $88b28bc8a3a48705$var$descriptionStyles
        }, step.description), index === steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
            xcss: $88b28bc8a3a48705$var$QueuesRedirectButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hPVlR.default), {
            href: projectRedirectionLink ?? '#',
            appearance: "discovery",
            isDisabled: !projectRedirectionLink,
            testId: "project-redirect-link",
            analyticsContext: {
                actionSubjectId: 'learnByDoingRedirect'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
            weight: "medium",
            color: !projectRedirectionLink ? 'color.text.disabled' : 'color.text.inverse'
        }, formatMessage((0, $21PCD.default).queuesRedirectLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cMYsY.Flex), {
            xcss: $88b28bc8a3a48705$var$nextStepImageStyle
        }, index !== steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dDGDc))),
            alt: ""
        })));
    })))));
};
const $88b28bc8a3a48705$var$LearnByDoingWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: "learnByDoing",
        id: "create-request",
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($88b28bc8a3a48705$var$LearnByDoing, props));
};
var $88b28bc8a3a48705$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'LearnByDoing'
})($88b28bc8a3a48705$var$LearnByDoingWithErrorBoundary);
const $88b28bc8a3a48705$var$LearnByDoingWrapper = (0, $9BVpB.xcss)({
    width: 'auto',
    position: 'absolute',
    right: 'space.400',
    left: 'space.400',
    height: '266px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.large'
});
const $88b28bc8a3a48705$var$LearnByDoingStyles = (0, $9BVpB.xcss)({
    display: 'none',
    width: '100%',
    maxWidth: '1200px',
    gap: 'space.200',
    paddingBlock: 'space.300',
    paddingInline: 'space.300',
    borderRadius: 'radius.small',
    [(0, $4pBHw.media).above.md]: {
        display: 'flex'
    },
    [(0, $4pBHw.media).above.lg]: {
        // Max valid space token space.1000 = 80px, have to use px to make it correctly aligned
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingRight: '108px',
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingLeft: '88px'
    }
});
const $88b28bc8a3a48705$var$LearnByDoingFlowStyle = (0, $9BVpB.xcss)({
    width: '100%',
    gap: 'space.500',
    [(0, $4pBHw.media).above.lg]: {
        gap: 'space.600'
    }
});
const $88b28bc8a3a48705$var$LearnByDoingStepDefaultStyle = (0, $9BVpB.xcss)({
    gap: 'space.150',
    padding: 'space.200',
    backgroundColor: 'color.background.input',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    minHeight: '150px',
    position: 'relative',
    flex: '1 1 0px',
    [(0, $4pBHw.media).above.lg]: {
        gap: 'space.200'
    }
});
const $88b28bc8a3a48705$var$LearnByDoingStepActiveStyle = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.input',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    borderColor: 'color.border.discovery'
});
const $88b28bc8a3a48705$var$LearnByDoingStepDisableStyle = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.discovery',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $88b28bc8a3a48705$var$StepNumberContainerDefaultStyle = (0, $9BVpB.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    width: '40px',
    height: '40px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.full',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'center'
});
const $88b28bc8a3a48705$var$StepNumberContainerActiveStyle = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.discovery.bold'
});
const $88b28bc8a3a48705$var$StepNumberContainerDisableStyle = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.success'
});
const $88b28bc8a3a48705$var$headingContainerStepNumberDefaultStyles = (0, $9BVpB.xcss)({
    height: "var(--ds-space-250, 20px)",
    color: 'color.text.discovery'
});
const $88b28bc8a3a48705$var$headingContainerStepNumberActiveStyles = (0, $9BVpB.xcss)({
    color: 'color.text.inverse'
});
const $88b28bc8a3a48705$var$stepNumberStyles = (0, $9BVpB.xcss)({
    font: 'font.heading.small'
});
const $88b28bc8a3a48705$var$nextStepImageStyle = (0, $9BVpB.xcss)({
    zIndex: 'card',
    position: 'absolute',
    top: 'space.300',
    right: '-52px',
    [(0, $4pBHw.media).above.lg]: {
        right: '-60px'
    }
});
const $88b28bc8a3a48705$var$ContentStyle = (0, $9BVpB.xcss)({
    width: '100%',
    gap: 'space.050'
});
const $88b28bc8a3a48705$var$descriptionStyles = (0, $9BVpB.xcss)({
    color: 'color.text.subtle',
    font: 'font.body'
});
const $88b28bc8a3a48705$var$QueuesRedirectButtonStyles = (0, $9BVpB.xcss)({
    width: 'fit-content',
    marginTop: 'space.050'
});
var $88b28bc8a3a48705$var$_StyledBox = /*#__PURE__*/ /*#__PURE__*/ (0, $4v2A7.default)((0, $gUpf2.Box)).withConfig({
    componentId: "sc-1fng6fm-0"
}).withConfig({
    componentId: "sc-1fng6fm-1"
})`${$88b28bc8a3a48705$var$stepNumberStyles}`;

});
parcelRegister("7Azzd", function(module, exports) {
$parcel$export(module.exports, "default", () => $73ff11768e8f6007$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cPEYf = parcelRequire("cPEYf");

var $fuMfQ = parcelRequire("fuMfQ");

var $jA7ND = parcelRequire("jA7ND");

var $6lee4 = parcelRequire("6lee4");

var $2lSxZ = parcelRequire("2lSxZ");

var $02VbC = parcelRequire("02VbC");
function $73ff11768e8f6007$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $02VbC.useIsInsideAppProvider)();
    (0, $6lee4.useScrollbarHarmonisation)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $dc70d.jsx)((0, $jA7ND.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fuMfQ.InsideAppProviderContext).Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cPEYf.AppProviderThemingEnabledContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2lSxZ.ThemeProvider), {
                defaultColorMode: defaultColorMode,
                defaultTheme: defaultTheme,
                children: routerLinkProvider
            })
        })
    });
}
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { AppProvider } from '@atlaskit/app-provider/app-provider'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$73ff11768e8f6007$export$2e2bcd8739ae039 = $73ff11768e8f6007$export$c7dacf3845253dcf;

});
parcelRegister("6lee4", function(module, exports) {
$parcel$export(module.exports, "useScrollbarHarmonisation", () => $b8be41e20e674e56$export$6a82770d3a3903f7);

var $bSJIT = parcelRequire("bSJIT");

var $c9wRy = parcelRequire("c9wRy");

var $gdUUy = parcelRequire("gdUUy");

var $f1ksR = parcelRequire("f1ksR");

var $5XuIU = parcelRequire("5XuIU");
function $b8be41e20e674e56$export$6a82770d3a3903f7(isEnabled) {
    const isGateEnabled = (0, $gdUUy.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    const isTransparentTrackGateEnabled = (0, $gdUUy.fg)('platform_dst_scrollbar_harmonisation_transparent');
    const shouldUseTransparentTrack = isGateEnabled && isTransparentTrackGateEnabled;
    (0, $bSJIT.useEffect)(()=>{
        if (!shouldEnable) return;
        const targetDocument = (0, $c9wRy.getDocument)();
        if (!targetDocument) return;
        const cleanupHarmonisation = (0, $f1ksR.installScrollbarHarmonisation)(targetDocument);
        const cleanupTransparentTrack = shouldUseTransparentTrack ? (0, $5XuIU.installScrollbarHarmonisationTransparentTrack)(targetDocument) : undefined;
        return ()=>{
            cleanupTransparentTrack === null || cleanupTransparentTrack === void 0 || cleanupTransparentTrack();
            cleanupHarmonisation();
        };
    }, [
        shouldEnable,
        shouldUseTransparentTrack
    ]);
}

});
parcelRegister("f1ksR", function(module, exports) {
$parcel$export(module.exports, "installScrollbarHarmonisation", () => $df3fa31eebdf82f2$export$f289ecff4a99e09d);

var $dJheo = parcelRequire("dJheo");

var $flNPg = parcelRequire("flNPg");
const $df3fa31eebdf82f2$var$controllers = new WeakMap();
function $df3fa31eebdf82f2$export$f289ecff4a99e09d(targetDocument) {
    return (0, $flNPg.installDocumentAttribute)(targetDocument, (0, $dJheo.SCROLLBAR_HARMONISATION_ATTRIBUTE), $df3fa31eebdf82f2$var$controllers);
}

});
parcelRegister("dJheo", function(module, exports) {
$parcel$export(module.exports, "SCROLLBAR_HARMONISATION_ATTRIBUTE", () => $1e36f7a16b18d9b0$export$cc97c2566f53fd12);
$parcel$export(module.exports, "SCROLLBAR_HARMONISATION_TRANSPARENT_ATTRIBUTE", () => $1e36f7a16b18d9b0$export$61a626af8f32e59e);
const $1e36f7a16b18d9b0$export$cc97c2566f53fd12 = 'data-scrollbar-harmonisation';
const $1e36f7a16b18d9b0$export$61a626af8f32e59e = 'data-scrollbar-harmonisation-transparent';

});

parcelRegister("flNPg", function(module, exports) {
$parcel$export(module.exports, "installDocumentAttribute", () => $0a646f71b06695ee$export$4d0b2e184ba12ee7);
function $0a646f71b06695ee$export$4d0b2e184ba12ee7(targetDocument, attribute, controllers) {
    const existingController = controllers.get(targetDocument);
    if (existingController) {
        existingController.references += 1;
        let isReleased = false;
        return ()=>{
            if (isReleased) return;
            isReleased = true;
            existingController.references -= 1;
            if (existingController.references === 0) {
                existingController.release();
                controllers.delete(targetDocument);
            }
        };
    }
    const rootElement = targetDocument.documentElement;
    const controller = {
        references: 1,
        release: ()=>rootElement.removeAttribute(attribute)
    };
    rootElement.setAttribute(attribute, '');
    controllers.set(targetDocument, controller);
    let isReleased = false;
    return ()=>{
        if (isReleased) return;
        isReleased = true;
        controller.references -= 1;
        if (controller.references === 0) {
            controller.release();
            controllers.delete(targetDocument);
        }
    };
}

});


parcelRegister("5XuIU", function(module, exports) {
$parcel$export(module.exports, "installScrollbarHarmonisationTransparentTrack", () => $297f02a61b5d5db9$export$9fc37946dc3c0ebd);

var $dJheo = parcelRequire("dJheo");

var $flNPg = parcelRequire("flNPg");
const $297f02a61b5d5db9$var$controllers = new WeakMap();
function $297f02a61b5d5db9$export$9fc37946dc3c0ebd(targetDocument) {
    return (0, $flNPg.installDocumentAttribute)(targetDocument, (0, $dJheo.SCROLLBAR_HARMONISATION_TRANSPARENT_ATTRIBUTE), $297f02a61b5d5db9$var$controllers);
}

});



parcelRegister("k9Jtq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97fadb77040fc214fca377f612fb6ef3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eac7ec06596050c0$var$_react = $eac7ec06596050c0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $eac7ec06596050c0$var$_iconNew = $eac7ec06596050c0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $eac7ec06596050c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-mark
 * Usage guidance:
 * Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eac7ec06596050c0$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $eac7ec06596050c0$var$_react.default.createElement($eac7ec06596050c0$var$_iconNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$eac7ec06596050c0$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $eac7ec06596050c0$var$_default = module.exports.default = $eac7ec06596050c0$var$CheckMarkIcon;

});

parcelRegister("dDGDc", function(module, exports) {
module.exports = new URL("../images/vector.dd7c71e0.svg", import.meta.url).toString();

});

parcelRegister("21PCD", function(module, exports) {
$parcel$export(module.exports, "default", () => $32cf8d353d362e8d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $32cf8d353d362e8d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    learnByDoingDesc: {
        id: 'help-center.learn-by-doing.create-request.description',
        defaultMessage: 'Welcome to the portal! Try raising a request like your customers.',
        description: 'Description for Learn By Doing create Request component'
    },
    chooseRequestTypeHeading: {
        id: 'help-center.learn-by-doing.choose-request-type.heading',
        defaultMessage: 'Choose a request type',
        description: 'Heading for choosing a request type in Learn By Doing component'
    },
    chooseRequestTypeDesc: {
        id: 'help-center.learn-by-doing.choose-request-type.description',
        defaultMessage: 'Request types represent what your team can help customers with.',
        description: 'The text is shown as a description below the "Choose a request type" heading in the Learn By Doing onboarding component, explaining what request types are.'
    },
    sendExampleRequestHeading: {
        id: 'help-center.learn-by-doing.send-example-request.heading',
        defaultMessage: 'Send an example request',
        description: 'Heading for sending an example request in Learn By Doing component'
    },
    sendExampleRequestDesc: {
        id: 'help-center.learn-by-doing.send-example-request.description',
        defaultMessage: 'Fill out the request details, then send it off!',
        description: 'The text is shown as a description below the "Send an example request" heading in the Learn By Doing onboarding component, guiding the user to fill out and submit the example request form.'
    },
    requestCreatedHeading: {
        id: 'help-center.learn-by-doing.request-created.heading',
        defaultMessage: 'Manage request as an agent',
        description: 'Heading after request is created in Learn By Doing component'
    },
    requestCreatedDesc: {
        id: 'help-center.learn-by-doing.request-created.description',
        defaultMessage: 'Assign, add comments and resolve this request in your project.',
        description: 'The text is shown as a description in the Learn By Doing component after a request is created, telling the agent to manage the request in their project.'
    },
    requestCreatedDescGalaxia: {
        id: 'help-center.learn-by-doing.request-created.description-galaxia',
        defaultMessage: 'Assign, add comments and resolve this request in your space.',
        description: 'The text is shown as a description in the Learn By Doing component after a request is created in a Galaxia space, telling the agent to manage the request in their space.'
    },
    queuesRedirectLabel: {
        id: 'help-center.learn-by-doing.queues-redirect.label',
        defaultMessage: 'Go to agent view',
        description: 'The text is shown on a button in the Learn By Doing component after a request is created, redirecting the agent to the queues (agent view) to manage incoming requests.'
    }
});

});


parcelRegister("eAsHJ", function(module, exports) {
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => $d252c820f3d58eb7$export$54a369ffec06fa13);

var $jETIR = parcelRequire("jETIR");
const $d252c820f3d58eb7$export$54a369ffec06fa13 = (isProjectAdmin, referrer = '')=>isProjectAdmin && (referrer === (0, $jETIR.GETTING_STARTED_PAGE_LEARN_BY_DOING) || referrer === (0, $jETIR.YOUR_WORK) || referrer === (0, $jETIR.SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE));

});
parcelRegister("jETIR", function(module, exports) {
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => $3bc948786db33f10$export$7640e1e223f51f1a);
$parcel$export(module.exports, "SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE", () => $3bc948786db33f10$export$95ca3e9dccd62856);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_LEARN_BY_DOING", () => $3bc948786db33f10$export$952482a78309d288);
$parcel$export(module.exports, "YOUR_WORK", () => $3bc948786db33f10$export$3461424d6e65d62d);
const $3bc948786db33f10$export$7640e1e223f51f1a = 'referrer';
const $3bc948786db33f10$export$95ca3e9dccd62856 = 'overviewCreateRequest';
const $3bc948786db33f10$export$952482a78309d288 = 'gettingStartedPageLearnByDoing';
const $3bc948786db33f10$export$3461424d6e65d62d = 'yourWork';

});



parcelRegister("ekoCm", function(module, exports) {
$parcel$export(module.exports, "RequestGroupSelect", () => (parcelRequire("9rFxG")).default);

var $9rFxG = parcelRequire("9rFxG");

});
parcelRegister("9rFxG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2e8e348a6705692$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");
parcelRequire("lpQBK");
var $bk7sU = parcelRequire("bk7sU");

var $dwOcU = parcelRequire("dwOcU");

var $6yu2q = parcelRequire("6yu2q");

var $5LmQo = parcelRequire("5LmQo");
parcelRequire("lVOVX");
var $jETIR = parcelRequire("jETIR");
class $c2e8e348a6705692$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    getRedirectionUrl(requestGroupid, portalId) {
        const referrer = $5LmQo.get((0, $jETIR.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return `/portal/${portalId}/group/${requestGroupid}${shouldAddReferrer ? `?${0, $jETIR.REFERRER_QUERY_PARAM}=${referrer}` : ''}`;
    }
    getOptions() {
        const { requestGroups: requestGroups, portalId: portalId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestGroups.map((requestGroup)=>({
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                to: this.getRedirectionUrl(requestGroup === null || requestGroup === void 0 ? void 0 : requestGroup.id, portalId),
                value: requestGroup.id,
                label: requestGroup.name,
                description: /*#__PURE__*/ $bSJIT.createElement($c2e8e348a6705692$var$RequestTypeList, null, this.formatReqGroupNames(requestGroup.reqTypes)),
                dataTestId: `request-group:${requestGroup.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    formatReqGroupNames(reqTypes) {
        return reqTypes.map((rt)=>rt.name).join(', ');
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, ...props } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: {
                actionSubjectId: 'requestTypeGroups',
                attributes: {
                    portalId: props.portalId,
                    numberOfRequestTypeGroups: props.requestGroups.length
                }
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $bk7sU.default), {
            id: "request-group-select",
            actionSubjectId: "requestTypeGroupSelect",
            itemActionSubjectId: "requestTypeGroup",
            listAppearance: "card",
            selectAppearance: "simple",
            label: label,
            labelIcon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6yu2q))), {
                spacing: "spacious",
                label: '',
                "aria-hidden": "true",
                color: "var(--ds-icon, #42526E)"
            }),
            options: this.getOptions(),
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props
        }));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c2e8e348a6705692$var$RequestTypeList = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-1iqgmfs-0"
})`${$98sDU.small};`;

});
parcelRegister("lpQBK", function(module, exports) {
$parcel$export(module.exports, "GroupBoxSelect", () => (parcelRequire("bk7sU")).default);

var $bk7sU = parcelRequire("bk7sU");

});
parcelRegister("bk7sU", function(module, exports) {
$parcel$export(module.exports, "default", () => $958a96e61a31321f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $cf0fX = parcelRequire("cf0fX");

var $98sDU = parcelRequire("98sDU");

var $fU62V = parcelRequire("fU62V");
parcelRequire("lc3yJ");
var $dgAPV = parcelRequire("dgAPV");
parcelRequire("jKbau");
var $7mIIy = parcelRequire("7mIIy");

var $kKgUq = parcelRequire("kKgUq");

var $cMYsY = parcelRequire("cMYsY");

var $9BVpB = parcelRequire("9BVpB");

var $iydAA = parcelRequire("iydAA");

var $30F9J = parcelRequire("30F9J");
parcelRequire("8gXQS");
var $eTZrE = parcelRequire("eTZrE");
var $8NUJj = parcelRequire("8NUJj");
class $958a96e61a31321f$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    static #_ = this.defaultProps = {
        listAppearance: 'default',
        selectAppearance: 'default'
    };
    getValue() {
        const { value: value, options: options } = this.props;
        if (value) return options.find((option)=>option.value === value);
        return null;
    }
    renderSmallLabel() {
        const { id: id, label: label, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm } = this.props;
        const HeaderComponent = $958a96e61a31321f$export$105792bf13c50cea;
        return !!editRequestTypeOnRequestForm ? /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $958a96e61a31321f$var$labelSmallStylesWrapper
        }, /*#__PURE__*/ $bSJIT.createElement(HeaderComponent, null, /*#__PURE__*/ $bSJIT.createElement("label", {
            htmlFor: id
        }, label)), editRequestTypeOnRequestForm) : /*#__PURE__*/ $bSJIT.createElement(HeaderComponent, null, /*#__PURE__*/ $bSJIT.createElement("label", {
            htmlFor: id
        }, label));
    }
    renderBigLabel() {
        const { id: id, label: label, labelIcon: labelIcon, customizePortalButtonsGroup: customizePortalButtonsGroup, labelHeadingAs: labelHeadingAs } = this.props;
        const HeaderComponent = $958a96e61a31321f$export$2e1776684c14bc89;
        // When a heading element is requested (e.g. "h2") render the visible label
        // text with semantic heading markup so screen reader users can navigate by
        // heading. The label text keeps its visual styling (inherited from the
        // surrounding header) and the wrapping <label htmlFor> is preserved so the
        // text stays associated with the select input.
        const LabelText = labelHeadingAs ? // Render the visible label text with semantic heading markup (e.g. <h2>)
        // so screen reader users can navigate to it by heading. Styling is kept
        // identical to the plain <span> via LabelHeading (inherits font, no margin).
        /*#__PURE__*/ $bSJIT.createElement((0, $kKgUq.LabelHeading), {
            headingTag: labelHeadingAs,
            text: label
        }) : // Important for this to be in a span so we can use CSS selectors to target when
        // there is/isn't a label. Span gives this a proper element.
        /*#__PURE__*/ $bSJIT.createElement("span", null, label);
        return !!customizePortalButtonsGroup ? /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $958a96e61a31321f$var$labelStylesWrapper
        }, /*#__PURE__*/ $bSJIT.createElement(HeaderComponent, null, /*#__PURE__*/ $bSJIT.createElement($958a96e61a31321f$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, LabelText)), customizePortalButtonsGroup) : /*#__PURE__*/ $bSJIT.createElement(HeaderComponent, null, /*#__PURE__*/ $bSJIT.createElement($958a96e61a31321f$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, LabelText));
    }
    renderAsSelect(optionValue) {
        const { id: id, disabled: disabled, options: options, autoFocus: autoFocus, actionSubjectId: actionSubjectId, allowSelectedValueToWrap: allowSelectedValueToWrap } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, this.renderSmallLabel(), /*#__PURE__*/ $bSJIT.createElement((0, $cf0fX.Select), {
            actionSubjectId: actionSubjectId,
            inputId: id,
            autoFocus: autoFocus,
            options: options,
            onChange: this.onChange,
            value: optionValue,
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            menuPortalTarget: document.body,
            formatOptionLabel: this.formatOptionLabel,
            isDisabled: disabled,
            menuPlacement: "auto",
            // We want the selected option to be visible so customers can read the description if they desire.
            hideSelectedOptions: false,
            isSearchable: false,
            styles: {
                control: (supplied, { isFocused: isFocused })=>({
                        ...supplied,
                        // Don't allow flex children to wrap, since we reset styles of
                        // the value container we need this.
                        flexWrap: 'nowrap',
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        ':hover': {
                            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            ...supplied[':hover'],
                            backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)",
                            borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)"
                        },
                        backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)",
                        borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                    }),
                valueContainer: ()=>({
                        // We apply our own styles here.
                        //
                        // Overflow hidden so the children show their ellipsis if needed.
                        overflow: 'hidden'
                    }),
                singleValue: ()=>({
                        // We apply our own styles here.
                        //
                        // Since the value is a flex child set its width to 100% so it only
                        // takes up the given space.
                        width: '100%',
                        // These styles are merged over the base styles rather than replacing them, so
                        // react-select's `white-space: nowrap` is still in effect and is inherited by
                        // the value's contents. See `allowSelectedValueToWrap`.
                        ...allowSelectedValueToWrap && {
                            whiteSpace: 'normal'
                        }
                    }),
                option: (_, state)=>({
                        // We apply our own styles here.
                        backgroundColor: state.isFocused ? "var(--ds-surface-hovered, #F4F5F7)" : undefined,
                        cursor: 'pointer',
                        padding: 0,
                        margin: 0,
                        width: '100%'
                    }),
                menu: (styles)=>({
                        ...styles,
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            }
        }));
    }
    renderAsList(optionValue) {
        const { options: options, autoFocus: autoFocus, listAppearance: listAppearance, renderItem: renderItem } = this.props;
        const hasSelectedSingleValue = options.length === 1 && optionValue === options[0];
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), hasSelectedSingleValue ? this.renderSmallLabel() : this.renderBigLabel(), /*#__PURE__*/ $bSJIT.createElement($958a96e61a31321f$export$54c2e3dc7acea9f5, null, options.map((option, index)=>{
            const content = this.renderListItemContent(option, optionValue === option, hasSelectedSingleValue);
            return /*#__PURE__*/ $bSJIT.createElement((0, $dgAPV.AutoFocus), {
                key: option.value,
                isEnabled: autoFocus && index === 0
            }, /*#__PURE__*/ $bSJIT.createElement($958a96e61a31321f$var$ListItem, {
                withMargin: listAppearance === 'card'
            }, renderItem && !hasSelectedSingleValue ? renderItem(content, index) : content));
        })));
    }
    renderListItemContent(option, isSelected, hasSelectedSingleValue) {
        const { listAppearance: listAppearance, cardLinkAppearance: cardLinkAppearance, itemActionSubjectId: itemActionSubjectId, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.props;
        switch(listAppearance){
            case 'card':
                return /*#__PURE__*/ $bSJIT.createElement((0, $7mIIy.default), {
                    to: option.to,
                    padding: 0,
                    appearance: cardLinkAppearance,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target
                }, /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    lineClamp: isSelected ? 1 : 0
                }));
            case 'default':
            default:
                return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, isSelected ? /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    dataTestId: option.dataTestId,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0
                }) : /*#__PURE__*/ $bSJIT.createElement((0, $8NUJj.default), {
                    icon: option.iconUrl,
                    to: option.to,
                    heading: option.label,
                    description: option.description,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0,
                    selected: isSelected,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target,
                    ...!!editRequestTypeOnRequestList && {
                        editRequestTypeOnRequestList: editRequestTypeOnRequestList(option.value, option.label)
                    }
                }));
        }
    }
    render() {
        const { className: className, options: options } = this.props;
        const value = this.getValue();
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $bSJIT.createElement("div", {
            className: className
        }, options.length > 1 && value ? this.renderAsSelect(value) : this.renderAsList(value)));
    }
    constructor(...args){
        super(...args), this.formatOptionLabel = (option, context)=>{
            const { headingAs: headingAs } = this.props;
            switch(this.props.selectAppearance){
                case 'simple':
                    if (context.context === 'menu') return /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), {
                        containerPadding: "tight",
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description
                    });
                    return /*#__PURE__*/ $bSJIT.createElement($958a96e61a31321f$var$SimpleSelectOption, null, option.label);
                case 'default':
                default:
                    return /*#__PURE__*/ $bSJIT.createElement((0, $eTZrE.default), {
                        containerPadding: "tight",
                        headingAs: headingAs,
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description,
                        lineClamp: context.context === 'value' ? 1 : 0
                    });
            }
        }, this.onChange = (optionValue)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            return (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, (_toSingleSelectValue = (0, $30F9J.toSingleSelectValue)(optionValue)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value);
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $958a96e61a31321f$var$ListItem = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-h09otw-0"
})`display:block;${(props)=>$fU62V.applyIf(!!props.withMargin, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $4v2A7.css)`&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $958a96e61a31321f$var$LabelWithIcon = /*#__PURE__*/ (0, $4v2A7.default).label.withConfig({
    componentId: "sc-h09otw-1"
})`display:flex;align-items:center;> :not(:last-child){margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $958a96e61a31321f$var$SimpleSelectOption = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-h09otw-2"
})`margin-left:${"var(--ds-space-100, 8px)"};`;
const $958a96e61a31321f$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN = "var(--ds-space-negative-200, -16px)";
const $958a96e61a31321f$var$GROUP_BOX_SELECT_PADDING_INLINE = "var(--ds-space-negative-300, -24px)";
const $958a96e61a31321f$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $4v2A7.default).ul.withConfig({
    componentId: "sc-h09otw-3"
})`margin:${(props)=>props.offsetMargin ? `${$958a96e61a31321f$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN} ${$958a96e61a31321f$var$GROUP_BOX_SELECT_PADDING_INLINE} 0` : '0'};padding:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $958a96e61a31321f$var$selectHeaderStyles = /*#__PURE__*/ (0, $4v2A7.css)`${$98sDU.h500};display:block;margin-top:0;margin-bottom:0;`;
const $958a96e61a31321f$export$2e1776684c14bc89 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-h09otw-4"
})`${$958a96e61a31321f$var$selectHeaderStyles}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $958a96e61a31321f$var$smallSelectHeaderBaseStyles = /*#__PURE__*/ (0, $4v2A7.css)`${$98sDU.h500};display:block;margin-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $958a96e61a31321f$var$smallSelectHeaderStyles = /*#__PURE__*/ (0, $4v2A7.css)`${$958a96e61a31321f$var$smallSelectHeaderBaseStyles};${$98sDU.h200};margin-top:0;margin-bottom:0;`;
const $958a96e61a31321f$export$105792bf13c50cea = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-h09otw-5"
})`${$958a96e61a31321f$var$smallSelectHeaderStyles}`;
const $958a96e61a31321f$var$labelStylesWrapper = (0, $9BVpB.xcss)({
    marginBottom: 'space.200'
});
const $958a96e61a31321f$var$labelSmallStylesWrapper = (0, $9BVpB.xcss)({
    marginBottom: 'space.100'
});

});
parcelRegister("lc3yJ", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => (parcelRequire("dgAPV")).AutoFocus);

var $dgAPV = parcelRequire("dgAPV");

});
parcelRegister("dgAPV", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => $73e4e14871beca6d$export$9d8c528bc52bedf6);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");
class $73e4e14871beca6d$export$9d8c528bc52bedf6 extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        isEnabled: true
    };
    componentDidMount() {
        const { isEnabled: isEnabled } = this.props;
        // If we haven't yet triggered the focus we will focus on the ref if available
        if (isEnabled && !this.focused) {
            // eslint-disable-next-line react/no-find-dom-node
            const el = (0, $4Sf72.findDOMNode)(this);
            if (el) {
                el.focus();
                this.focused = true;
            }
        }
    }
    render() {
        const { children: children } = this.props;
        return $bSJIT.Children.only(children);
    }
}

});


parcelRegister("kKgUq", function(module, exports) {
$parcel$export(module.exports, "LabelHeading", () => $83cd5a39cfe3fff5$export$46cacff9402088d9);
/* styles.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @compiled/jsx-pragma
// `React` is imported and referenced (via React.FC) so this file works under the
// classic JSX runtime used by the Jest test env, while the pragma above enables
// the Compiled `css` prop for builds.

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// Visual reset for the semantic heading label: inherits the surrounding font
// and color and removes the browser's default heading margin/weight so the
// heading looks identical to the previous plain <span>.
const $83cd5a39cfe3fff5$var$labelHeadingStyles = null;
const $83cd5a39cfe3fff5$export$46cacff9402088d9 = ({ text: text, headingTag: HeadingTag })=>/*#__PURE__*/ $bSJIT.createElement(HeadingTag, {
        className: (0, $9fU1q.default)([
            "_11c81kw7 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _syaz1kw7"
        ])
    }, text);

});

parcelRegister("30F9J", function(module, exports) {
$parcel$export(module.exports, "toSingleSelectValue", () => $dce97a5ec0369e59$export$e6e136d0998f71a);
$parcel$export(module.exports, "toMultiSelectValue", () => $dce97a5ec0369e59$export$f3f3cd2c513af530);
const $dce97a5ec0369e59$export$e6e136d0998f71a = (value)=>{
    if (value == null) return value;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Array.isArray(value) ? value[0] : value;
};
const $dce97a5ec0369e59$export$f3f3cd2c513af530 = (value)=>{
    if (value == null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
};

});



parcelRegister("6yu2q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::959808d0c396950308013c029859eefb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c5d37ffc54aec3f$var$_react = $4c5d37ffc54aec3f$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4c5d37ffc54aec3f$var$_iconNew = $4c5d37ffc54aec3f$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4c5d37ffc54aec3f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/send
 * Usage guidance:
 * Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c5d37ffc54aec3f$var$SendIcon = (props)=>/*#__PURE__*/ $4c5d37ffc54aec3f$var$_react.default.createElement($4c5d37ffc54aec3f$var$_iconNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$4c5d37ffc54aec3f$var$SendIcon.displayName = 'SendIcon';
var $4c5d37ffc54aec3f$var$_default = module.exports.default = $4c5d37ffc54aec3f$var$SendIcon;

});



parcelRegister("btrfc", function(module, exports) {
$parcel$export(module.exports, "RequestTypeSelect", () => (parcelRequire("9kKRq")).default);

var $9kKRq = parcelRequire("9kKRq");

});
parcelRegister("9kKRq", function(module, exports) {
$parcel$export(module.exports, "default", () => $758a1daa5d37a250$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");
parcelRequire("2XFLQ");
var $jblhi = parcelRequire("jblhi");
parcelRequire("lpQBK");
var $bk7sU = parcelRequire("bk7sU");

var $dwOcU = parcelRequire("dwOcU");

var $5LmQo = parcelRequire("5LmQo");
parcelRequire("lVOVX");
var $jETIR = parcelRequire("jETIR");
class $758a1daa5d37a250$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    getOptions() {
        const referrer = $5LmQo.get((0, $jETIR.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        const { requestTypes: requestTypes, portalId: portalId, requestGroupId: requestGroupId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestTypes.map((requestType)=>({
                value: Number(requestType.id),
                label: requestType.name,
                description: /*#__PURE__*/ $bSJIT.createElement($758a1daa5d37a250$var$RequestTypeDescription, {
                    dangerouslySetInnerHTML: {
                        __html: requestType.descriptionHtml
                    }
                }),
                iconUrl: requestType.iconUrl,
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                to: `/portal/${portalId}/group/${requestGroupId}/create/${requestType.id}${shouldAddReferrer ? `?${0, $jETIR.REFERRER_QUERY_PARAM}=${referrer}` : ''}`,
                dataTestId: `request-type:${requestType.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    getCSMOptions() {
        const { requestTypes: requestTypes } = this.props;
        return requestTypes.map((requestType)=>({
                value: requestType.name,
                label: requestType.name
            }));
    }
    getCSMValue(value) {
        const { requestTypes: requestTypes } = this.props;
        if (!value) return {
            value: '',
            label: ''
        };
        const requestType = requestTypes.find((requestTypeOption)=>Number(requestTypeOption.id) === value);
        return {
            value: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || '',
            label: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || ''
        };
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, isCSM: isCSM, headingAs: headingAs, ...props } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: {
                actionSubjectId: 'requestTypes',
                attributes: {
                    portalId: props.portalId,
                    requestGroupId: props.requestGroupId,
                    numberOfRequestTypes: props.requestTypes.length
                }
            }
        }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, isCSM ? /*#__PURE__*/ $bSJIT.createElement((0, $jblhi.default), {
            id: "request-type-select",
            label: label,
            options: this.getCSMOptions(),
            defaultValue: this.getCSMValue(value),
            disabled: !!disabled
        }) : /*#__PURE__*/ $bSJIT.createElement((0, $bk7sU.default), {
            id: "request-type-select",
            actionSubjectId: "requestTypeSelect",
            itemActionSubjectId: "requestType",
            label: label,
            options: this.getOptions(),
            headingAs: headingAs,
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props,
            allowSelectedValueToWrap: true
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $758a1daa5d37a250$var$RequestTypeDescription = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-1qcxsi7-0"
})`p{display:inline;}`;

});
parcelRegister("2XFLQ", function(module, exports) {
$parcel$export(module.exports, "SingleSelectField", () => (parcelRequire("jblhi")).default);
/** This is the single select form component type  */ 
var $jblhi = parcelRequire("jblhi");

});
parcelRegister("jblhi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7e32fe5f68a03a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1zYnp = parcelRequire("1zYnp");

var $30F9J = parcelRequire("30F9J");
class $ca7e32fe5f68a03a$var$SingleFieldSelect extends $bSJIT.PureComponent {
    componentDidMount() {
        // JDW-2280 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultValue) this.onChange(this.props.defaultValue);
    }
    render() {
        const { disabled: disabled, ...otherProps } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $1zYnp.FormSingleSelect), {
            ...otherProps,
            onChange: this.onChange,
            isDisabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.onChange = (option, meta)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, ((_toSingleSelectValue = (0, $30F9J.toSingleSelectValue)(option)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value) ?? '', false, {
                rawObject: meta ?? {},
                rawValue: option
            });
        };
    }
}
var $ca7e32fe5f68a03a$export$2e2bcd8739ae039 = $ca7e32fe5f68a03a$var$SingleFieldSelect;

});
parcelRegister("1zYnp", function(module, exports) {
$parcel$export(module.exports, "FieldSingleSelect", () => $5f81731e52535520$export$a63157f03e4869bc);
$parcel$export(module.exports, "FormSingleSelect", () => $5f81731e52535520$export$6440c30e7d5bd2b2);
$parcel$export(module.exports, "FormAsyncSingleSelect", () => $5f81731e52535520$export$1232b3d2b9045cfb);
$parcel$export(module.exports, "FormAsyncCreatableSingleSelect", () => $5f81731e52535520$export$5e090ccc28fd7327);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("aCOGK");
var $lK9bw = parcelRequire("lK9bw");
parcelRequire("96iPn");
var $a6XFx = parcelRequire("a6XFx");

var $l6qfM = parcelRequire("l6qfM");

var $fvHdX = parcelRequire("fvHdX");

var $7qMCI = parcelRequire("7qMCI");
const $5f81731e52535520$export$a63157f03e4869bc = (0, $7qMCI.default)((0, $lK9bw.ThemedSelect));
const $5f81731e52535520$var$FieldAsyncSingleSelect = (0, $7qMCI.default)((0, $lK9bw.ThemedAsyncSelect));
const $5f81731e52535520$var$FieldAsyncCreatableSingleSelect = (0, $7qMCI.default)((0, $lK9bw.ThemedAsyncCreatableSelect));
class $5f81731e52535520$var$FormAsyncCreatableSingleSelectBase extends $bSJIT.PureComponent {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement($5f81731e52535520$var$FieldAsyncCreatableSingleSelect, {
            ...this.props,
            onCreateOption: this.onCreateOption
        });
    }
    constructor(...args){
        super(...args), this.onCreateOption = (input)=>{
            const { onChange: onChange, showNewLabelForCreatedValues: showNewLabelForCreatedValues } = this.props;
            const newOption = {
                value: input,
                label: input,
                isNew: showNewLabelForCreatedValues
            };
            onChange === null || onChange === void 0 || onChange(newOption, {
                action: 'create-option',
                option: newOption
            });
        };
    }
}
const $5f81731e52535520$var$ControlledFieldAsyncSingleSelect = (0, $a6XFx.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $bSJIT.createElement($5f81731e52535520$var$FieldAsyncSingleSelect, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $5f81731e52535520$var$ControlledFormAsyncCreatableSingleSelectBase = (0, $a6XFx.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $bSJIT.createElement($5f81731e52535520$var$FormAsyncCreatableSingleSelectBase, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $5f81731e52535520$export$6440c30e7d5bd2b2 = (0, $a6XFx.withControlledFormComponentValue)((option)=>option)($5f81731e52535520$export$a63157f03e4869bc);
const $5f81731e52535520$export$1232b3d2b9045cfb = (0, $l6qfM.componentWithCondition)(()=>(0, $lFpPv.isUserPickerSupportEnabled)(), $5f81731e52535520$var$ControlledFieldAsyncSingleSelect, (0, $fvHdX.default)($5f81731e52535520$var$FieldAsyncSingleSelect));
const $5f81731e52535520$export$5e090ccc28fd7327 = (0, $l6qfM.componentWithCondition)(()=>(0, $lFpPv.isUserPickerSupportEnabled)(), $5f81731e52535520$var$ControlledFormAsyncCreatableSingleSelectBase, (0, $fvHdX.default)($5f81731e52535520$var$FormAsyncCreatableSingleSelectBase));

});
parcelRegister("aCOGK", function(module, exports) {
$parcel$export(module.exports, "ThemedSelect", () => (parcelRequire("lK9bw")).ThemedSelect);
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => (parcelRequire("lK9bw")).ThemedAsyncCreatableSelect);
$parcel$export(module.exports, "ThemedAsyncSelect", () => (parcelRequire("lK9bw")).ThemedAsyncSelect);

var $lK9bw = parcelRequire("lK9bw");

});
parcelRegister("lK9bw", function(module, exports) {
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => $db21e87864e3a57d$export$6ed24baf80289e3c);
$parcel$export(module.exports, "ThemedAsyncSelect", () => $db21e87864e3a57d$export$ffdb66031dcf42ea);
$parcel$export(module.exports, "ThemedSelect", () => $db21e87864e3a57d$export$336563657ba327fe);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $7DQsm = parcelRequire("7DQsm");
var $dXgVV = parcelRequire("dXgVV");
var $c1cdG = parcelRequire("c1cdG");
var $cf0fX = parcelRequire("cf0fX");
function $db21e87864e3a57d$var$withThemeSelect(Component) {
    class ThemedSelectWrapper extends $bSJIT.PureComponent {
        render() {
            const { theme: theme, styles: externalStyles = {}, ...selectProps } = this.props;
            const customStyles = {
                // This is to ensure the multi select options stay within the container without overflowing
                valueContainer: (styles)=>({
                        ...styles,
                        width: '100%',
                        overflow: 'hidden'
                    }),
                // This is used to apply our theming
                option: (styles, { isFocused: isFocused, isSelected: isSelected })=>{
                    const themed = theme;
                    const optionFocusBackground = isFocused ? "var(--ds-background-neutral-subtle-hovered, #F4F5F7)" : null;
                    const backgroundColor = isSelected ? themed.lightColor : optionFocusBackground;
                    return {
                        ...styles,
                        backgroundColor: backgroundColor,
                        ':active': {
                            backgroundColor: themed.lightColor
                        },
                        color: "var(--ds-text, #172B4D)"
                    };
                },
                // This is to ensure long select options doesn't cause a horizontal scroll bar to appear in the select menu
                menu: (styles)=>({
                        ...styles,
                        'word-wrap': 'break-word',
                        'overflow-y': 'hidden',
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            };
            return /*#__PURE__*/ $bSJIT.createElement(Component, {
                placeholder: "",
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage, @atlassian/ssr-linting/no-dom-globals-in-react-cc-render
                menuPortalTarget: document.body,
                menuPlacement: "auto",
                ...selectProps,
                styles: {
                    ...externalStyles,
                    ...customStyles
                }
            });
        }
    }
    return (0, $4v2A7.withTheme)(ThemedSelectWrapper);
}
const $db21e87864e3a57d$export$6ed24baf80289e3c = $db21e87864e3a57d$var$withThemeSelect((0, $7DQsm.AsyncCreatableSelect));
const $db21e87864e3a57d$export$1692d6296f3148ba = $db21e87864e3a57d$var$withThemeSelect((0, $c1cdG.CreatableSelect));
const $db21e87864e3a57d$export$ffdb66031dcf42ea = $db21e87864e3a57d$var$withThemeSelect((0, $dXgVV.AsyncSelect));
const $db21e87864e3a57d$export$336563657ba327fe = $db21e87864e3a57d$var$withThemeSelect((0, $cf0fX.Select));

});
parcelRegister("7DQsm", function(module, exports) {
$parcel$export(module.exports, "AsyncCreatableSelect", () => $44f4edf293d21994$export$c0b2520fe082e4aa);

var $ktbTQ = parcelRequire("ktbTQ");

var $hWsdJ = parcelRequire("hWsdJ");
const $44f4edf293d21994$export$c0b2520fe082e4aa = (0, $hWsdJ.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $ktbTQ.default));

});
parcelRegister("ktbTQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $05759d987c7fd526$export$2e2bcd8739ae039);

var $foFRG = parcelRequire("foFRG");

var $5dnVg = parcelRequire("5dnVg");
const $05759d987c7fd526$var$AsyncCreatableSelect = (0, $5dnVg.default)((0, $foFRG.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$05759d987c7fd526$export$2e2bcd8739ae039 = $05759d987c7fd526$var$AsyncCreatableSelect;

});
parcelRegister("foFRG", function(module, exports) {
$parcel$export(module.exports, "default", () => $146e19e0529741b0$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $l7tvR = parcelRequire("l7tvR");

var $52QJF = parcelRequire("52QJF");

var $b9jqr = parcelRequire("b9jqr");

var $27zHi = parcelRequire("27zHi");
const $146e19e0529741b0$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $52QJF.default)(props);
    const creatableProps = (0, $27zHi.default)(stateManagerProps);
    const selectProps = (0, $b9jqr.default)(creatableProps);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $l7tvR.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$146e19e0529741b0$export$2e2bcd8739ae039 = $146e19e0529741b0$var$AsyncCreatableSelect;

});
parcelRegister("b9jqr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c2b25bee9404561$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4zzw4 = parcelRequire("4zzw4");

var $7OOeR = parcelRequire("7OOeR");

var $biY41 = parcelRequire("biY41");

var $i8kww = parcelRequire("i8kww");
const $1c2b25bee9404561$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $1c2b25bee9404561$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$1c2b25bee9404561$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$1c2b25bee9404561$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $1c2b25bee9404561$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $1c2b25bee9404561$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $1c2b25bee9404561$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $1c2b25bee9404561$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $7OOeR.getOptionValue), getOptionLabel: getOptionLabel = (0, $4zzw4.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $bSJIT.useMemo)(()=>isValidNewOption(inputValue, (0, $biY41.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $bSJIT.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $bSJIT.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $i8kww.valueTernary)(isMulti, [
                    ...(0, $biY41.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});




parcelRegister("dXgVV", function(module, exports) {
$parcel$export(module.exports, "AsyncSelect", () => $c7bba5c652c9e210$export$aca05dd54e009a80);

var $cHz95 = parcelRequire("cHz95");

var $hWsdJ = parcelRequire("hWsdJ");
const $c7bba5c652c9e210$export$aca05dd54e009a80 = (0, $hWsdJ.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $cHz95.default));

});
parcelRegister("cHz95", function(module, exports) {
$parcel$export(module.exports, "default", () => $dccad8052474cd75$export$2e2bcd8739ae039);

var $1eJWB = parcelRequire("1eJWB");

var $5dnVg = parcelRequire("5dnVg");
const $dccad8052474cd75$var$AsyncSelect = (0, $5dnVg.default)((0, $1eJWB.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dccad8052474cd75$export$2e2bcd8739ae039 = $dccad8052474cd75$var$AsyncSelect;

});


parcelRegister("c1cdG", function(module, exports) {
$parcel$export(module.exports, "CreatableSelect", () => $19fae33e7d8ab883$export$4d213c67c76d12fa);

var $2mnxD = parcelRequire("2mnxD");

var $hWsdJ = parcelRequire("hWsdJ");
const $19fae33e7d8ab883$export$4d213c67c76d12fa = (0, $hWsdJ.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $2mnxD.default));

});
parcelRegister("2mnxD", function(module, exports) {
$parcel$export(module.exports, "default", () => $228de615f7b25a48$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $gfz0w = parcelRequire("gfz0w");

var $5dnVg = parcelRequire("5dnVg");
const $228de615f7b25a48$var$CreatableSelect = (0, $5dnVg.default)((0, $gfz0w.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$228de615f7b25a48$export$2e2bcd8739ae039 = $228de615f7b25a48$var$CreatableSelect;

});
parcelRegister("gfz0w", function(module, exports) {
$parcel$export(module.exports, "default", () => $387ffe8207404a91$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $l7tvR = parcelRequire("l7tvR");

var $b9jqr = parcelRequire("b9jqr");

var $27zHi = parcelRequire("27zHi");
const $387ffe8207404a91$var$CreatableSelect = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const creatableProps = (0, $27zHi.default)(props);
    const selectProps = (0, $b9jqr.default)(creatableProps);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $l7tvR.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$387ffe8207404a91$export$2e2bcd8739ae039 = $387ffe8207404a91$var$CreatableSelect;

});





parcelRegister("l6qfM", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $a0ad425b723e3388$export$6e8ea24b15199873);

var $bSJIT = parcelRequire("bSJIT");
function $a0ad425b723e3388$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("fvHdX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6952863d9cf18922$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $6952863d9cf18922$var$withControlledValueSingleSelect(SelectComponent) {
    return class ControlledValueSingleSelectWrapper extends $bSJIT.PureComponent {
        static #_ = this.displayName = 'ControlledValueSingleSelectWrapper';
        render() {
            return /*#__PURE__*/ $bSJIT.createElement(SelectComponent, {
                ...this.props,
                isMulti: false,
                value: this.state.selectedOption,
                onChange: this.onChange,
                isClearable: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                selectedOption: this.props.defaultValue
            }, this.onChange = (option, context)=>{
                var _this$props$onChange, _this$props;
                this.setState({
                    selectedOption: option
                });
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, option, context);
            };
        }
    };
}
var $6952863d9cf18922$export$2e2bcd8739ae039 = $6952863d9cf18922$var$withControlledValueSingleSelect;

});

parcelRegister("7qMCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $2319ff5f80ed2211$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("j2RlN");
var $bnZwM = parcelRequire("bnZwM");
function $2319ff5f80ed2211$var$withFieldBase(SelectComponent) {
    const wrappedComponent = (props)=>{
        const { label: label, required: required, errorMessage: errorMessage, description: description, id: id, tooltip: tooltip, ...otherProps } = props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $bnZwM.default), {
            htmlFor: id,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description,
            ...(0, $lFpPv.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, /*#__PURE__*/ $bSJIT.createElement(SelectComponent, {
            ...otherProps,
            inputId: id,
            "aria-describedby": `${id}-field-description`,
            validationState: !!errorMessage ? 'error' : 'default'
        }));
    };
    return wrappedComponent;
}
var $2319ff5f80ed2211$export$2e2bcd8739ae039 = $2319ff5f80ed2211$var$withFieldBase;

});






parcelRegister("1aQQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $207d8d2a3bacf3bb$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $207d8d2a3bacf3bb$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    requestGroupSelectLabel: {
        defaultMessage: 'Contact us about',
        description: 'Label shown for selecting a request group',
        id: 'sd.portal.request.group.select'
    },
    requestTypeSelectLabel: {
        defaultMessage: 'What can we help you with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.request.type.select'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    CSMRequestTypeSelectLabel: {
        defaultMessage: 'What do you need help with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.csm.request.type.select'
    },
    emptyStateMessage: {
        defaultMessage: "There's nothing in this portal yet.",
        description: 'This message is shown, when there are no configured request groups for service project',
        id: 'sd.jsm.portal.empty.request.type'
    },
    tryAnotherServiceProjectLink: {
        defaultMessage: 'Go to the help center',
        description: 'This link is shown, when there are no configured request groups for current service project and there are other service projects available',
        id: 'sd.jsm.portal.empty.sd.link'
    }
});

});





parcelRegister("a0chM", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => (parcelRequire("2UScA")).SkeletonLoadingContainer);

var $2UScA = parcelRequire("2UScA");

});
parcelRegister("2UScA", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => $ff6877f639d0d159$export$ed074b591cb3b239);

var $bSJIT = parcelRequire("bSJIT");

var $i5HDF = parcelRequire("i5HDF");
parcelRequire("cAJ8B");
var $aquFW = parcelRequire("aquFW");

var $1qPbZ = parcelRequire("1qPbZ");
class $ff6877f639d0d159$export$ed074b591cb3b239 extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const skeleton = /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.SkeletonLoadingWrapper), {
            isLoading: true,
            loadingPosition: loadingPosition
        });
        return isLoading ? /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.PaperContent), null, enableUFOHold ? /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
            name: ufoHoldName
        }, skeleton) : skeleton) : children;
    }
}

});


parcelRegister("4QZgG", function(module, exports) {
$parcel$export(module.exports, "ExternalLinks", () => $15ad4a516c8abfd7$export$7c6fdaf98295312b);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $15ad4a516c8abfd7$export$7c6fdaf98295312b = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("gh78c")), {
        moduleId: "./src/view/external-links/external-links.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("gh78c", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6AYIJ"),
    $kOunM("hVAUq")
]).then(()=>parcelRequire('8DKe5'));

});


parcelRegister("hCHt7", function(module, exports) {
$parcel$export(module.exports, "ForgeFooterModule", () => $53dc7e2aa1d0b772$export$c664a1597302ef11);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $53dc7e2aa1d0b772$export$c664a1597302ef11 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("fYOfH")), {
        moduleId: "./src/view/forge-ui/portal-footer/portal-footer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("fYOfH", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8TJqW").then(()=>parcelRequire('5MDVW'));

});


parcelRegister("dlaM3", function(module, exports) {
$parcel$export(module.exports, "ForgeHeaderModule", () => $e2ac5fa4829bfab2$export$8010fd64cd5cfdb9);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $e2ac5fa4829bfab2$export$8010fd64cd5cfdb9 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("4uwvF")), {
        moduleId: "./src/view/forge-ui/portal-header/portal-header.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("4uwvF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6SCfU").then(()=>parcelRequire('a6LTg'));

});


parcelRegister("w2X5T", function(module, exports) {
$parcel$export(module.exports, "LazyVirtualServiceAgentChatSidebar", () => $e722f63b98afa573$export$5ab8ce8fb542ac03);
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $e722f63b98afa573$export$5ab8ce8fb542ac03 = (0, $2vYDF.lazy)(()=>(parcelRequire("lV2s4")), {
    moduleId: "./src/view/layout/virtual-service-agent-chat-sidebar/virtual-service-agent-chat-sidebar.tsx"
});

});
parcelRegister("lV2s4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9uCWW"),
    $kOunM("aVVxs"),
    $kOunM("3IRr1"),
    $kOunM("jHaBx"),
    $kOunM("7k2Dk"),
    $kOunM("9Vb2H"),
    $kOunM("i5Ki2"),
    $kOunM("kzTRH"),
    $kOunM("04tGK"),
    $kOunM("1fqfR"),
    $kOunM("fiNXw"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("lzQaK"),
    $kOunM("bYQHQ"),
    $kOunM("eCdiR"),
    $kOunM("fs156"),
    $kOunM("kI2bC"),
    $kOunM("uBPzN"),
    $kOunM("bZkRg"),
    $kOunM("izSDP"),
    $kOunM("13X7O"),
    $kOunM("ikQkO")
]).then(()=>parcelRequire('efReS'));

});


parcelRegister("683tP", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpText", () => (parcelRequire("gwjgN")).default);

var $gwjgN = parcelRequire("gwjgN");

});
parcelRegister("gwjgN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c08ea45ee8d86b1$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("8DwJZ");
var $8DHwN = parcelRequire("8DHwN");
const $2c08ea45ee8d86b1$var$selector = (0, $BOq7h.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    const requestType = (0, $iWhHo.getPortalRequestType)(state, portalId, requestTypeId);
    return requestType && requestType.helpTextHtml;
}, (helpText)=>({
        helpText: helpText
    }));
var $2c08ea45ee8d86b1$export$2e2bcd8739ae039 = (0, $f2mlD.default)($2c08ea45ee8d86b1$var$selector)((0, $8DHwN.default));

});
parcelRegister("8DwJZ", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpTextDumb", () => (parcelRequire("8DHwN")).default);

var $8DHwN = parcelRequire("8DHwN");

});
parcelRegister("8DHwN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c40349bd50c3849b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");
parcelRequire("djUgN");
var $eyaq6 = parcelRequire("eyaq6");
class $c40349bd50c3849b$var$RequestCreateFormHelpTextDumb extends $bSJIT.Component {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement((0, $eyaq6.default), {
            in: !!this.props.helpText
        }, /*#__PURE__*/ $bSJIT.createElement($c40349bd50c3849b$var$HelpTextContainer, {
            dangerouslySetInnerHTML: {
                __html: this.props.helpText
            }
        }));
    }
}
var $c40349bd50c3849b$export$2e2bcd8739ae039 = $c40349bd50c3849b$var$RequestCreateFormHelpTextDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c40349bd50c3849b$var$HelpTextContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1u76lr1-0"
})`margin-top:${"var(--ds-space-200, 16px)"};margin-bottom:${"var(--ds-space-100, 8px)"};a{text-decoration:underline;}`;

});
parcelRegister("djUgN", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("eyaq6")).default);
parcelRequire("9F5PU");
var $eyaq6 = parcelRequire("eyaq6");

});
parcelRegister("9F5PU", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("eyaq6")).default);

var $eyaq6 = parcelRequire("eyaq6");

});
parcelRegister("eyaq6", function(module, exports) {
$parcel$export(module.exports, "default", () => $528ece6b9d8d4cdc$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9Yqiu = parcelRequire("9Yqiu");

var $6CMLs = parcelRequire("6CMLs");
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $528ece6b9d8d4cdc$var$Container = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-10ahj68-0"
})`${$9Yqiu.fadeInOut($9Yqiu.speedMs.fast)};`;
/**
 * This is for ease of use fade in/out. This will add an extra <span> around the children to do the
 * animating. If you need finer grained control, or don't want the extra span markup, use <Transition />
 * and our transition mixins directly.
 */ const $528ece6b9d8d4cdc$var$Fade = ({ children: children, appear: appear, in: show })=>/*#__PURE__*/ $bSJIT.createElement((0, $6CMLs.default), {
        timeout: $9Yqiu.speedMs.fast,
        in: show,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: appear
    }, (state)=>/*#__PURE__*/ $bSJIT.createElement($528ece6b9d8d4cdc$var$Container, {
            state: state
        }, children));
var $528ece6b9d8d4cdc$export$2e2bcd8739ae039 = $528ece6b9d8d4cdc$var$Fade;

});







parcelRegister("gstrO", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsAnnouncementSidebar", () => $464a698b629a0217$export$454a2c99809e1b66);
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $464a698b629a0217$export$454a2c99809e1b66 = (0, $2vYDF.lazy)(()=>(parcelRequire("1BlmC")), {
    moduleId: "./src/view/portal-settings-announcement-sidebar/portal-settings-announcement-sidebar.tsx"
});

});
parcelRegister("1BlmC", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kJlFi"),
    $kOunM("kWx38"),
    $kOunM("77U2l"),
    $kOunM("if62Z"),
    $kOunM("6yZg0")
]).then(()=>parcelRequire('9pli4'));

});


parcelRegister("cYNAS", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsSidebar", () => $ba6734af4f2e627b$export$4bdb57f5e35140ab);
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $ba6734af4f2e627b$export$4bdb57f5e35140ab = (0, $2vYDF.lazy)(()=>(parcelRequire("c0yj3")), {
    moduleId: "./src/view/portal-settings-sidebar/portal-settings-sidebar.tsx"
});

});
parcelRegister("c0yj3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kJlFi"),
    $kOunM("kWx38"),
    $kOunM("77U2l"),
    $kOunM("if62Z"),
    $kOunM("92sIe"),
    $kOunM("fXeMz"),
    $kOunM("itmHl"),
    $kOunM("1lfsI"),
    $kOunM("gKM6H")
]).then(()=>parcelRequire('hvud7'));

});


parcelRegister("aJYKE", function(module, exports) {
$parcel$export(module.exports, "PortalIntlBoundary", () => (parcelRequire("fUx7z")).default);

var $fUx7z = parcelRequire("fUx7z");

});
parcelRegister("fUx7z", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1c6e67fa8247d37$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");
var $4vLTk = parcelRequire("4vLTk");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $87QgR = parcelRequire("87QgR");

var $amYpB = parcelRequire("amYpB");

var $1etMn = parcelRequire("1etMn");

var $81Vbr = parcelRequire("81Vbr");

var $30REn = parcelRequire("30REn");
const $d1c6e67fa8247d37$var$PORTAL_LANGUAGE_PACK_IN_MODEL = 'jsm-portal-include-language-pack-in-model';
const $d1c6e67fa8247d37$var$isPortalLanguagePackInModelEnabled = ()=>(0, $87QgR.default).checkGate($d1c6e67fa8247d37$var$PORTAL_LANGUAGE_PACK_IN_MODEL);
const $d1c6e67fa8247d37$export$66c101287efe2f55 = ({ i18nTranslations: i18nTranslations, portalLocale: portalLocale, children: children })=>{
    const outerIntl = (0, $4vLTk.default)();
    const shouldOverride = $d1c6e67fa8247d37$var$isPortalLanguagePackInModelEnabled() && !!i18nTranslations && Object.keys(i18nTranslations).length > 0;
    const messages = (0, $bSJIT.useMemo)(()=>shouldOverride ? {
            ...(0, $amYpB.default)(),
            ...i18nTranslations
        } : undefined, [
        shouldOverride,
        i18nTranslations
    ]);
    // The backend sends `_`-separated locale keys, which `Intl` rejects. Platform
    // consumers need the region kept, so this cannot reuse `getLanguageFromLocale`.
    const portalLocaleTag = (0, $bSJIT.useMemo)(()=>portalLocale ? (0, $1etMn.ensureConsistentKey)(portalLocale) : undefined, [
        portalLocale
    ]);
    if (!shouldOverride) return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, children);
    return /*#__PURE__*/ $bSJIT.createElement((0, $30REn.PortalLocaleProvider), {
        value: portalLocaleTag
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dTM5i.default), {
        locale: portalLocale ? (0, $81Vbr.getLanguageFromLocale)(portalLocale) : outerIntl.locale,
        defaultLocale: outerIntl.defaultLocale,
        messages: messages,
        formats: outerIntl.formats,
        timeZone: outerIntl.timeZone,
        onError: (0, $amYpB.onIntlNextError)
    }, children));
};
const $d1c6e67fa8247d37$var$selector = (0, $BOq7h.createSelector)((state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    return {
        i18nTranslations: (0, $iWhHo.getPortalI18nTranslations)(state, portalId),
        portalLocale: (0, $iWhHo.getPortalLocale)(state, portalId)
    };
}, ({ i18nTranslations: i18nTranslations, portalLocale: portalLocale })=>({
        i18nTranslations: i18nTranslations,
        portalLocale: portalLocale
    }));
var $d1c6e67fa8247d37$export$2e2bcd8739ae039 = (0, $f2mlD.default)($d1c6e67fa8247d37$var$selector)($d1c6e67fa8247d37$export$66c101287efe2f55);

});
parcelRegister("30REn", function(module, exports) {
$parcel$export(module.exports, "PortalLocaleProvider", () => $a9a169aebd84c7fb$export$fdd7d28b3dddbf46);
$parcel$export(module.exports, "usePortalLocale", () => $a9a169aebd84c7fb$export$b4a39b22d9a69563);

var $bSJIT = parcelRequire("bSJIT");
/**
 * The portal's own locale, published by `PortalIntlBoundary` over the subtree it
 * wraps, as a hyphenated BCP-47 tag with the region kept.
 *
 * `undefined` means "not inside a portal-scoped boundary". That default is what
 * keeps non-portal surfaces — CSM request details, the customisation editors,
 * embedded pages — on the user's account locale without needing a per-consumer
 * opt-out list.
 */ const $a9a169aebd84c7fb$var$PortalLocaleContext = /*#__PURE__*/ $bSJIT.createContext(undefined);
const $a9a169aebd84c7fb$export$fdd7d28b3dddbf46 = $a9a169aebd84c7fb$var$PortalLocaleContext.Provider;
const $a9a169aebd84c7fb$export$b4a39b22d9a69563 = ()=>$bSJIT.useContext($a9a169aebd84c7fb$var$PortalLocaleContext);

});



parcelRegister("eXUFK", function(module, exports) {
$parcel$export(module.exports, "RequestCreateForm", () => $0227f0f8f8bc313a$export$23aadacdae45e79);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $0227f0f8f8bc313a$var$loader = (0, $2vYDF.lazyForPaint)(()=>{
    return (parcelRequire("kQNNP"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-form/hocs.tsx"
});
const $0227f0f8f8bc313a$export$23aadacdae45e79 = (0, $cVM5r.default)({
    loader: $0227f0f8f8bc313a$var$loader
});

});
parcelRegister("kQNNP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("br2rQ"),
    $kOunM("jdLWQ"),
    $kOunM("jsKIl"),
    $kOunM("dlH2m"),
    $kOunM("8m449"),
    $kOunM("igYwH"),
    $kOunM("92sIe"),
    $kOunM("eScBj"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("aHc5N"),
    $kOunM("esjBs"),
    $kOunM("1gFin")
]).then(()=>parcelRequire('c4urb'));

});


parcelRegister("bwdOx", function(module, exports) {
$parcel$export(module.exports, "SidebarToggle", () => $f751f8225fc806bb$export$d1b4e884a11aa0f2);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("nR7qC");
var $3R7iu = parcelRequire("3R7iu");
const $f751f8225fc806bb$export$d1b4e884a11aa0f2 = ({ openSidebar: openSidebar, closeSidebar: closeSidebar })=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $3R7iu.useQueryParams)();
    $bSJIT.useEffect(()=>{
        if (customize === 'true' && !!experience) openSidebar === null || openSidebar === void 0 || openSidebar();
        else closeSidebar === null || closeSidebar === void 0 || closeSidebar();
    }, [
        customize,
        openSidebar,
        closeSidebar,
        experience
    ]);
    return null;
};

});

parcelRegister("2rxiA", function(module, exports) {
$parcel$export(module.exports, "UiModificationsEntryPoint", () => $a9e3b4eef529d593$export$c89b83ae4e6840b3);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("b09ES");
var $bcBxS = parcelRequire("bcBxS");

var $iRD29 = parcelRequire("iRD29");

var $57Wy4 = parcelRequire("57Wy4");

var $iACvP = parcelRequire("iACvP");

var $ed0M0 = parcelRequire("ed0M0");

var $8MlrR = parcelRequire("8MlrR");

var $bLrNY = parcelRequire("bLrNY");

var $d7O6G = parcelRequire("d7O6G");
/**
 * Entry point that reads the fetched UIM payload (per-app configuration and installed
 * extensions) from the `persisted.uiModifications` Redux slice, filled by the JSM models REST
 * epic, and hands it to the platform root. Redux only caches that payload; UIM runtime state
 * lives in the core's react-sweet-state store.
 */ const $a9e3b4eef529d593$var$EntryPointWithReduxData = ({ portalId: portalId, requestTypeId: requestTypeId, triggerPointKey: triggerPointKey, uiModifications: uiModifications, uiModificationsError: uiModificationsError })=>{
    const executionContextKey = portalId && requestTypeId ? `${portalId}-${requestTypeId}` : null;
    const cloudId = (0, $fuVmc.getCloudId)();
    const activationId = (0, $fuVmc.getActivationId)();
    // Fire analytics when there's an error fetching UI modifications
    (0, $bSJIT.useEffect)(()=>{
        if (uiModificationsError) (0, $iACvP.fireErrorAnalytics)({
            error: new Error(uiModificationsError),
            id: 'fetchUiModificationsFailure',
            viewType: (0, $8MlrR.REQUEST_CREATE_VIEW_TYPE),
            attributes: {
                portalId: portalId,
                requestTypeId: requestTypeId
            }
        });
    }, [
        uiModificationsError,
        portalId,
        requestTypeId
    ]);
    const executionContext = (0, $bSJIT.useMemo)(()=>{
        if (!portalId || !requestTypeId) return null;
        return {
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        };
    }, [
        portalId,
        requestTypeId
    ]);
    // Wrap Redux data in { jira: ... } structure expected by platform component
    const wrappedUiModificationsData = (0, $bSJIT.useMemo)(()=>{
        if (!uiModifications) return {
            jira: {
                forge: {
                    uiModificationsExtensions: []
                },
                uiModifications: []
            }
        };
        return {
            jira: uiModifications
        };
    }, [
        uiModifications
    ]);
    const triggerPointKeyVal = triggerPointKey ?? (0, $bLrNY.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ed0M0.UiModificationsRootWithData), {
        executionContext: executionContext,
        uiModificationsData: wrappedUiModificationsData,
        cloudId: cloudId,
        activationId: activationId,
        executionContextKey: executionContextKey,
        triggerPointKey: triggerPointKeyVal,
        ForgeAppRenderer: (0, $d7O6G.ForgeAppRenderer)
    });
};
const $a9e3b4eef529d593$var$selector = (0, $BOq7h.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    let uiModifications;
    let uiModificationsError;
    if (portalId && requestTypeId) {
        uiModifications = (0, $bcBxS.getUiModificationsData)(state, portalId, requestTypeId);
        uiModificationsError = (0, $bcBxS.getUiModificationsError)(state, portalId, requestTypeId);
    }
    return {
        portalId: portalId,
        requestTypeId: requestTypeId,
        uiModifications: uiModifications,
        uiModificationsError: uiModificationsError,
        triggerPointKey: props.triggerPointKey
    };
}, (selectorData)=>selectorData);
const $a9e3b4eef529d593$var$EntryPoint = (0, $f2mlD.default)($a9e3b4eef529d593$var$selector)($a9e3b4eef529d593$var$EntryPointWithReduxData);
const $a9e3b4eef529d593$export$c89b83ae4e6840b3 = (props)=>{
    return (0, $lFpPv.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        id: "uiModifications",
        packageName: "jsmUiModificationsViewRequestCreate"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $57Wy4.AnalyticsListener), {
        analyticsWebClient: (0, $iRD29.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a9e3b4eef529d593$var$EntryPoint, props))) : null;
};

});
parcelRegister("b09ES", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => (parcelRequire("bcBxS")).getUiModificationsData);
$parcel$export(module.exports, "getUiModificationsError", () => (parcelRequire("bcBxS")).getUiModificationsError);

var $bcBxS = parcelRequire("bcBxS");

});
parcelRegister("bcBxS", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => $6e009590cd0e7ef2$export$3f2ec852b79889c8);
$parcel$export(module.exports, "getUiModificationsError", () => $6e009590cd0e7ef2$export$a973ad30babc208b);
const $6e009590cd0e7ef2$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $6e009590cd0e7ef2$export$77a087943aa778c9 = (state, portalId, requestTypeId)=>{
    var _state$persisted$uiMo;
    const storeKey = $6e009590cd0e7ef2$var$buildStoreKey(portalId, requestTypeId);
    return (_state$persisted$uiMo = state.persisted.uiModifications) === null || _state$persisted$uiMo === void 0 ? void 0 : _state$persisted$uiMo[storeKey];
};
const $6e009590cd0e7ef2$export$3f2ec852b79889c8 = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn;
    return (_getUiModificationsEn = $6e009590cd0e7ef2$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn === void 0 ? void 0 : _getUiModificationsEn.data;
};
const $6e009590cd0e7ef2$export$a973ad30babc208b = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn2;
    return (_getUiModificationsEn2 = $6e009590cd0e7ef2$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn2 === void 0 ? void 0 : _getUiModificationsEn2.error;
};

});


parcelRegister("57Wy4", function(module, exports) {
$parcel$export(module.exports, "AnalyticsListener", () => $2c7c06c042605f90$export$22edec767217cd60);

var $bSJIT = parcelRequire("bSJIT");

var $1w9as = parcelRequire("1w9as");

var $clpci = parcelRequire("clpci");

var $ezwN8 = parcelRequire("ezwN8");

var $3pU6R = parcelRequire("3pU6R");

var $lfIWD = parcelRequire("lfIWD");
const $2c7c06c042605f90$export$7329bcdc3edcd90e = (event, client)=>{
    switch(event.type){
        case 0, $clpci.OPERATIONAL_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
            break;
        case 0, $clpci.TRACK_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
            break;
    }
};
const $2c7c06c042605f90$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
        const eventData = (0, $ezwN8.extractAWCDataFromEvent)(event);
        $2c7c06c042605f90$export$7329bcdc3edcd90e({
            type: eventData.type,
            ...eventData.payload
        }, analyticsWebClient);
    };
const $2c7c06c042605f90$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
    const onEvent = (0, $bSJIT.useMemo)(()=>$2c7c06c042605f90$export$eee20638634729b3(analyticsWebClient), [
        analyticsWebClient
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const initClient = async ()=>{
            const client = await analyticsWebClient;
            (0, $3pU6R.initialiseErrorAnalyticsClient)(client);
        };
        initClient();
    }, [
        analyticsWebClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
        onEvent: onEvent,
        channel: (0, $lfIWD.UI_MODIFICATIONS_ANALYTICS_CHANNEL)
    }, children);
};

});

parcelRegister("ed0M0", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootWithData", () => $6f08e7e8a2528e1a$export$56d75038a9162ad6);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $inaNq = parcelRequire("inaNq");

var $0164e = parcelRequire("0164e");

var $ejJgp = parcelRequire("ejJgp");

var $f71DI = parcelRequire("f71DI");

var $dtngf = parcelRequire("dtngf");

var $5e3wi = parcelRequire("5e3wi");

var $agEQ5 = parcelRequire("agEQ5");

var $f4qe6 = parcelRequire("f4qe6");

var $iofrM = parcelRequire("iofrM");
const $6f08e7e8a2528e1a$export$56d75038a9162ad6 = (props)=>{
    const executionContext = (0, $iofrM.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $ejJgp.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $inaNq.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $dtngf.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $dtngf.isExecutionContextSupported)(executionContext);
    (0, $bSJIT.useEffect)(()=>{
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6f08e7e8a2528e1a$var$RootWithDataCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
const $6f08e7e8a2528e1a$var$RootWithDataCleanup = (props)=>{
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $f4qe6.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $bSJIT.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $bSJIT.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $0164e.ExecutionContextProvider), {
        value: executionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f71DI.TenantContextProvider), {
        value: tenantContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6f08e7e8a2528e1a$var$RootWithData, props))));
};
const $6f08e7e8a2528e1a$var$RootWithData = ({ uiModificationsData: uiModificationsData, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    const appsToRender = (0, $agEQ5.useAppsToRender)({
        data: uiModificationsData,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5e3wi.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("0164e", function(module, exports) {
$parcel$export(module.exports, "useExecutionContext", () => $1eb00bb0358fd21d$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "ExecutionContextProvider", () => $1eb00bb0358fd21d$export$14f2a780bc6de643);

var $bSJIT = parcelRequire("bSJIT");
const $1eb00bb0358fd21d$export$7f8a924805594460 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $1eb00bb0358fd21d$export$b0467ce6d1ed861f = ()=>{
    const executionContext = (0, $bSJIT.useContext)($1eb00bb0358fd21d$export$7f8a924805594460);
    if (executionContext === null) throw new Error('executionContext value is null');
    return executionContext;
};
const $1eb00bb0358fd21d$export$14f2a780bc6de643 = ({ children: children, value: value })=>{
    if (!value) throw new Error('ExecutionContextProvider requires a value');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1eb00bb0358fd21d$export$7f8a924805594460.Provider, {
        value: value
    }, children);
};

});

parcelRegister("ejJgp", function(module, exports) {
$parcel$export(module.exports, "useViewType", () => $1b304816e1d0796a$export$1568c16ff8af07a3);

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $1b304816e1d0796a$export$1568c16ff8af07a3 = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    selector: (state)=>state.viewType
});

});

parcelRegister("f71DI", function(module, exports) {
$parcel$export(module.exports, "useTenantContext", () => $66dd9605908a7a20$export$28e7c557f4d454d9);
$parcel$export(module.exports, "TenantContextProvider", () => $66dd9605908a7a20$export$e32355e80a92030c);

var $bSJIT = parcelRequire("bSJIT");
const $66dd9605908a7a20$var$TenantContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $66dd9605908a7a20$export$28e7c557f4d454d9 = ()=>{
    const tenantContext = (0, $bSJIT.useContext)($66dd9605908a7a20$var$TenantContext);
    if (tenantContext === null) throw new Error('tenantContext value is null');
    return tenantContext;
};
const $66dd9605908a7a20$export$e32355e80a92030c = ({ children: children, value: value })=>{
    if (!value) throw new Error('TenantContextProvider requires a value');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($66dd9605908a7a20$var$TenantContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("5e3wi", function(module, exports) {
$parcel$export(module.exports, "AppsRenderer", () => $ef1c924510262dd7$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $k9uij = parcelRequire("k9uij");

var $98Tax = parcelRequire("98Tax");

var $fyths = parcelRequire("fyths");
const $ef1c924510262dd7$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $98Tax.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
        const { appId: appId, environmentId: envId } = (0, $k9uij.parseExtensionId)(forgeExtension.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            key: `${forgeExtension.id}-${triggerFieldInitializationKey}`,
            data: {
                attributes: {
                    appId: appId,
                    envId: envId
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fyths.SingleAppRenderer), {
            forgeExtension: forgeExtension,
            uiModificationsConfig: uiModificationsConfig,
            ForgeAppRenderer: ForgeAppRenderer
        }));
    }));
};

});
parcelRegister("k9uij", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $b16c0dca7154abe8$export$bae42cbaf7fa3e1b);

var $5df7r = parcelRequire("5df7r");
const $b16c0dca7154abe8$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $5df7r.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("5df7r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Cq0D = parcelRequire("3Cq0D");

var $29G82 = parcelRequire("29G82");

$3Cq0D.__exportStar((parcelRequire("7O6oI")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $3cb9e4f82744bd74$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $3cb9e4f82744bd74$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $3cb9e4f82744bd74$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $3cb9e4f82744bd74$var$InvalidAriError;
function $3cb9e4f82744bd74$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $3cb9e4f82744bd74$var$basicCharConstraint = $29G82.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $3cb9e4f82744bd74$var$resourceTypeCharConstraints = $29G82.pattern(/^[a-z][a-z.-]*$/i);
const $3cb9e4f82744bd74$var$resourceOwnerConstraints = [
    $29G82.lengthBetween(3, 255),
    $3cb9e4f82744bd74$var$basicCharConstraint
];
const $3cb9e4f82744bd74$var$resourceTypeConstraints = [
    $29G82.lengthBetween(3, 255),
    $3cb9e4f82744bd74$var$resourceTypeCharConstraints
];
const $3cb9e4f82744bd74$var$cloudIdConstraints = [
    $29G82.lengthBetween(3, 255)
];
const $3cb9e4f82744bd74$var$siteResourceType = 'site';
const $3cb9e4f82744bd74$var$resourceIdChars = /[\w-._~:@#]/.source;
const $3cb9e4f82744bd74$var$resourceIdConstraints = [
    $29G82.pattern(new RegExp(`^${$3cb9e4f82744bd74$var$resourceIdChars}+(/${$3cb9e4f82744bd74$var$resourceIdChars}*)*(;v=${$3cb9e4f82744bd74$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $3cb9e4f82744bd74$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $3cb9e4f82744bd74$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $3cb9e4f82744bd74$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $3cb9e4f82744bd74$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $3cb9e4f82744bd74$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $3cb9e4f82744bd74$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $3cb9e4f82744bd74$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $3cb9e4f82744bd74$var$InvalidAriError(ariString);
        return new $3cb9e4f82744bd74$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $3cb9e4f82744bd74$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $3cb9e4f82744bd74$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $3cb9e4f82744bd74$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $3cb9e4f82744bd74$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $3cb9e4f82744bd74$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $3cb9e4f82744bd74$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $3cb9e4f82744bd74$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $3cb9e4f82744bd74$var$siteResourceType && !!other.resourceType || $3cb9e4f82744bd74$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $3cb9e4f82744bd74$var$siteResourceType && !!other.resourceType || $3cb9e4f82744bd74$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $3cb9e4f82744bd74$var$siteResourceType && !cloudId) return new $29G82.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $29G82.validateField(this, 'resourceOwner', $3cb9e4f82744bd74$var$resourceOwnerConstraints),
            $29G82.validateField(this, 'resourceType', $3cb9e4f82744bd74$var$resourceTypeConstraints),
            $29G82.validateField(this, 'resourceId', $3cb9e4f82744bd74$var$resourceIdConstraints),
            $29G82.validateField(this, 'cloudId', $3cb9e4f82744bd74$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $3cb9e4f82744bd74$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $3cb9e4f82744bd74$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $3cb9e4f82744bd74$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $3cb9e4f82744bd74$var$parse(ariString) {
    return $3cb9e4f82744bd74$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $3cb9e4f82744bd74$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $3cb9e4f82744bd74$var$parseEncoded(encodedAriString) {
    return $3cb9e4f82744bd74$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $3cb9e4f82744bd74$var$parseEncoded;

});
parcelRegister("29G82", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eyPTK = parcelRequire("eyPTK");
class $191d19e6544f6119$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $191d19e6544f6119$var$LengthConstraint;
class $191d19e6544f6119$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $191d19e6544f6119$var$RegexConstraint;
class $191d19e6544f6119$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $191d19e6544f6119$var$GeneralValidationError;
class $191d19e6544f6119$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $191d19e6544f6119$var$ConstraintViolation;
function $191d19e6544f6119$var$lengthBetween(min, max) {
    return new $191d19e6544f6119$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $191d19e6544f6119$var$lengthBetween;
function $191d19e6544f6119$var$pattern(regex) {
    return new $191d19e6544f6119$var$RegexConstraint(regex);
}
module.exports.pattern = $191d19e6544f6119$var$pattern;
function $191d19e6544f6119$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eyPTK.isDefined);
    return violatedConstraints.length > 0 ? new $191d19e6544f6119$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $191d19e6544f6119$var$validateField;

});
parcelRegister("eyPTK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $a99c7f8d11268541$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $a99c7f8d11268541$var$isPresent;
function $a99c7f8d11268541$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $a99c7f8d11268541$var$isDefined;
function $a99c7f8d11268541$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $a99c7f8d11268541$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $a99c7f8d11268541$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $a99c7f8d11268541$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $a99c7f8d11268541$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $a99c7f8d11268541$var$hasValueAtKey;

});


parcelRegister("7O6oI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $25Ptf = parcelRequire("25Ptf");
var $5af22a58106226af$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($5af22a58106226af$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $5af22a58106226af$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $5af22a58106226af$var$AppFamilyAriError;
class $5af22a58106226af$var$NotAppFamilyAriError extends $5af22a58106226af$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $5af22a58106226af$var$NotAppFamilyAriError;
class $5af22a58106226af$var$NotExpectedAppFamilyAriTypeError extends $5af22a58106226af$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $5af22a58106226af$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $5af22a58106226af$var$parseAppAri(ari) {
    return $25Ptf.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $5af22a58106226af$var$parseAppAri;
function $5af22a58106226af$var$createAppAri(json) {
    return new $25Ptf.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $5af22a58106226af$var$createAppAri;

});
parcelRegister("25Ptf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7O6oI = parcelRequire("7O6oI");

var $5df7r = parcelRequire("5df7r");

var $29G82 = parcelRequire("29G82");
const $1863f967f14358e5$var$versionPrefix = ';v=';
const $1863f967f14358e5$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $1863f967f14358e5$var$uuidConstraints = [
    $29G82.pattern(new RegExp(`^${$1863f967f14358e5$var$uuidRegExpString}$`, 'i'))
];
const $1863f967f14358e5$var$extensionGroupIdConstraints = [
    $29G82.pattern(new RegExp(`^(${$1863f967f14358e5$var$uuidRegExpString}|static)$`, 'i'))
];
class $1863f967f14358e5$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $7O6oI.AppFamilyAri.resourceOwner) throw new $7O6oI.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$7O6oI.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $7O6oI.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $7O6oI.NotAppFamilyAriError(ari, `resourceType must be one of ${$7O6oI.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $7O6oI.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($1863f967f14358e5$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($1863f967f14358e5$var$versionPrefix) > versionIndex) throw new $7O6oI.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($1863f967f14358e5$var$versionPrefix);
        const segments = mainResourceId.split('/').map($1863f967f14358e5$var$stripToUndefined);
        if (segments.length > 4) throw new $7O6oI.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $7O6oI.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $7O6oI.AppFamilyAri.extensionGroupResourceType || resourceType === $7O6oI.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $7O6oI.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $7O6oI.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$7O6oI.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $7O6oI.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $7O6oI.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$7O6oI.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $7O6oI.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $7O6oI.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$7O6oI.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $7O6oI.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $7O6oI.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$7O6oI.AppFamilyAri.environmentResourceType}`);
        return new $1863f967f14358e5$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $7O6oI.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $29G82.validateField(this, 'environmentId', $1863f967f14358e5$var$uuidConstraints),
            $29G82.validateField(this, 'appId', $1863f967f14358e5$var$uuidConstraints),
            $29G82.validateField(this, 'extensionGroupId', $1863f967f14358e5$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $5df7r.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $7O6oI.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$1863f967f14358e5$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $5df7r.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $7O6oI.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $5df7r.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $7O6oI.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $5df7r.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $7O6oI.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $5df7r.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $7O6oI.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $1863f967f14358e5$var$AppFamilyAriImpl;
function $1863f967f14358e5$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("98Tax", function(module, exports) {
$parcel$export(module.exports, "useTriggerFieldInitialization", () => $f78c452112c82bf9$export$1c69013aaf9112f0);
// eslint-disable-next-line import/order

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $f78c452112c82bf9$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $f78c452112c82bf9$export$1c69013aaf9112f0 = (0, $gfNVK.createHook)((0, $81Pre.store), {
    selector: $f78c452112c82bf9$var$selectTriggerFieldInitializationKey
});

});

parcelRegister("fyths", function(module, exports) {
$parcel$export(module.exports, "SingleAppRenderer", () => $1641fdfcf54ccf29$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $dbq8H = parcelRequire("dbq8H");

var $k9uij = parcelRequire("k9uij");

var $QaFKJ = parcelRequire("QaFKJ");

var $6FvB9 = parcelRequire("6FvB9");

var $0164e = parcelRequire("0164e");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $dtngf = parcelRequire("dtngf");

var $fOtCT = parcelRequire("fOtCT");

var $AEgUT = parcelRequire("AEgUT");

var $2H3s2 = parcelRequire("2H3s2");

var $gKJCp = parcelRequire("gKJCp");

var $72oGN = parcelRequire("72oGN");
const $1641fdfcf54ccf29$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $81Pre.useIssueAdjustmentsActions)();
    const viewType = (0, $ejJgp.useViewType)();
    const executionContext = (0, $0164e.useExecutionContext)();
    const extensionData = (0, $bSJIT.useMemo)(()=>(0, $72oGN.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $k9uij.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $AEgUT.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $fOtCT.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $2H3s2.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $QaFKJ.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $bSJIT.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $dtngf.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $6FvB9.UIM_CONSENT_REQUIRED)) {
            setLoadingComplete();
            (0, $dtngf.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $gKJCp.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dbq8H.default), {
        name: "single-frame-iframe",
        fallback: null,
        key: moduleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ForgeAppRenderer, {
        extension: forgeExtension,
        extensionData: extensionData,
        customBridgeMethods: customBridgeMethods,
        onIframeLoad: (0, $dtngf.getAnalytics)(viewType).markIframeLoad,
        isIframeResizable: false,
        isIframeHidden: true,
        ...consentProps
    }));
};

});
parcelRegister("fOtCT", function(module, exports) {
$parcel$export(module.exports, "useCustomBridgeMethods", () => $7ab266cb943af81d$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $lNNuB = parcelRequire("lNNuB");

var $75ImC = parcelRequire("75ImC");

var $gaUDc = parcelRequire("gaUDc");

var $iRSVi = parcelRequire("iRSVi");

var $l4ybY = parcelRequire("l4ybY");

var $3N6wr = parcelRequire("3N6wr");

var $2Hq3Y = parcelRequire("2Hq3Y");
const $7ab266cb943af81d$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $l4ybY.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $gaUDc.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $2Hq3Y.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $3N6wr.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $75ImC.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $iRSVi.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $bSJIT.useCallback)(()=>{
        onBridgeCommunicationReceived === null || onBridgeCommunicationReceived === void 0 || onBridgeCommunicationReceived();
        return {
            data: {
                onInitChangeId: (0, $lNNuB.ON_INIT_CHANGE_ID),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $bSJIT.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
parcelRegister("75ImC", function(module, exports) {
$parcel$export(module.exports, "useOnBridgeError", () => $459a3c357c293902$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $awGqx = parcelRequire("awGqx");

var $iACvP = parcelRequire("iACvP");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $dtngf = parcelRequire("dtngf");

var $lHtWM = parcelRequire("lHtWM");
const $459a3c357c293902$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($awGqx)))(payload) && (0, $lHtWM.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $459a3c357c293902$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $81Pre.useIssueAdjustmentsActions)();
    const viewType = (0, $ejJgp.useViewType)();
    return (0, $bSJIT.useCallback)((payload)=>{
        if (!$459a3c357c293902$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error, cause: cause } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $dtngf.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`, {
            cause: cause
        });
        (0, $iACvP.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error,
                cause: cause
            }
        });
    }, [
        setError,
        unregisterFields,
        viewType,
        appId
    ]);
};

});
parcelRegister("lHtWM", function(module, exports) {
$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $09ce7e3064ec4810$export$7845535459d8a620);
const $09ce7e3064ec4810$export$6634aa68b37142fc = 'onInitError';
const $09ce7e3064ec4810$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $09ce7e3064ec4810$export$3018e0c759270938 = 'getApiError';
const $09ce7e3064ec4810$export$7845535459d8a620 = [
    $09ce7e3064ec4810$export$6634aa68b37142fc,
    $09ce7e3064ec4810$export$7ab66e58aded6116,
    $09ce7e3064ec4810$export$3018e0c759270938
];

});


parcelRegister("gaUDc", function(module, exports) {
$parcel$export(module.exports, "useOnChangeSubscription", () => $6f24ba5b5dc9771e$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $cYXOj = parcelRequire("cYXOj");

var $cwGwT = parcelRequire("cwGwT");

var $lnUBX = parcelRequire("lnUBX");

var $ejJgp = parcelRequire("ejJgp");

var $ixP9S = parcelRequire("ixP9S");

var $7HGbP = parcelRequire("7HGbP");
const $6f24ba5b5dc9771e$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $ejJgp.useViewType)();
    const notifyAppRef = (0, $bSJIT.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $lnUBX.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $cwGwT.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    /**
   * Single ref for all data that must be up-to-date but not trigger notification.
   */ const dataRef = (0, $bSJIT.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $bSJIT.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $ixP9S.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $7HGbP.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $bSJIT.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("cwGwT", function(module, exports) {
$parcel$export(module.exports, "useCurrentFormState", () => $8b175e8a71166594$export$655680d54d70050d);

var $bBhJi = parcelRequire("bBhJi");
var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $8b175e8a71166594$var$stableEmpty = {};
const $8b175e8a71166594$var$stableEmptyScreenTabsArrray = [];
const $8b175e8a71166594$var$selectCurrentFormState = (0, $bBhJi.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $8b175e8a71166594$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $8b175e8a71166594$var$stableEmpty,
        currentScreenTabsState: $8b175e8a71166594$var$stableEmptyScreenTabsArrray
    };
});
const $8b175e8a71166594$export$655680d54d70050d = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    selector: $8b175e8a71166594$var$selectCurrentFormState
});

});

parcelRegister("lnUBX", function(module, exports) {
$parcel$export(module.exports, "useLastProcessedChange", () => $9de99222742551c1$export$e5124fbd2a3221d);

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $9de99222742551c1$export$e5124fbd2a3221d = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("ixP9S", function(module, exports) {
$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $b63405857a2a5ee3$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $b63405857a2a5ee3$export$51fbc854b278b1ff);

var $dtngf = parcelRequire("dtngf");
const $b63405857a2a5ee3$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    var _getSupportedFieldCon;
    const fieldRequiredScopes = (_getSupportedFieldCon = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $b63405857a2a5ee3$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!(value !== null && value !== void 0 && value.fieldType)) return false;
        const { fieldType: fieldType } = value;
        return $b63405857a2a5ee3$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $b63405857a2a5ee3$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field === null || field === void 0 ? void 0 : field.fieldType;
        if (!fieldType) return false;
        return $b63405857a2a5ee3$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("7HGbP", function(module, exports) {
$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $ee9acc97bb810275$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $ee9acc97bb810275$export$6a622a0cc96dcad7);

var $cYXOj = parcelRequire("cYXOj");

var $7CoTa = parcelRequire("7CoTa");
const $ee9acc97bb810275$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $ee9acc97bb810275$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $ee9acc97bb810275$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($ee9acc97bb810275$var$includeCoarseScopes((0, $7CoTa.baseRequiredReadScopes), moduleScopes) || $ee9acc97bb810275$var$includeGranularScopes((0, $7CoTa.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $ee9acc97bb810275$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($ee9acc97bb810275$var$includeCoarseScopes((0, $7CoTa.baseRequiredWriteScopes), moduleScopes) || $ee9acc97bb810275$var$includeGranularScopes((0, $7CoTa.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("7CoTa", function(module, exports) {
$parcel$export(module.exports, "baseRequiredReadScopes", () => $1c089370d519f3b9$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $1c089370d519f3b9$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $1c089370d519f3b9$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $1c089370d519f3b9$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("iRSVi", function(module, exports) {
$parcel$export(module.exports, "useOnErrorSubscription", () => $8625f1c9c75bc6d1$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $bWsVm = parcelRequire("bWsVm");

var $6WltM = parcelRequire("6WltM");

var $cYXOj = parcelRequire("cYXOj");

var $gkW5p = parcelRequire("gkW5p");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");
const $8625f1c9c75bc6d1$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $ejJgp.useViewType)();
    const notifyAppRef = (0, $bSJIT.useRef)(null);
    const { appErrors: appErrors } = (0, $gkW5p.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $81Pre.useIssueAdjustmentsActions)();
    (0, $bSJIT.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bWsVm)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $bSJIT.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("gkW5p", function(module, exports) {
$parcel$export(module.exports, "useAppErrors", () => $7c6f96f918f81abd$export$535312244836989b);

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $7c6f96f918f81abd$export$535312244836989b = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("l4ybY", function(module, exports) {
$parcel$export(module.exports, "useOnInit", () => $fa6b6cc4c611a0a9$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $cYXOj = parcelRequire("cYXOj");

var $1Ds6f = parcelRequire("1Ds6f");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $dtngf = parcelRequire("dtngf");

var $ixP9S = parcelRequire("ixP9S");

var $7HGbP = parcelRequire("7HGbP");
const $fa6b6cc4c611a0a9$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $fa6b6cc4c611a0a9$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $bSJIT.useRef)(null);
    const viewType = (0, $ejJgp.useViewType)();
    const publicUIMDataForApp = (0, $1Ds6f.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $81Pre.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $bSJIT.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $ixP9S.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $7HGbP.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $fa6b6cc4c611a0a9$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $dtngf.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("1Ds6f", function(module, exports) {
$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $f1085971abdd3158$export$484a467ba25fea19);

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");

var $3gy1J = parcelRequire("3gy1J");
const $f1085971abdd3158$export$484a467ba25fea19 = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    selector: (0, $3gy1J.selectReadyPublicDataForOnInit)
});

});


parcelRegister("3N6wr", function(module, exports) {
$parcel$export(module.exports, "useRegisterFields", () => $633b7c9a43ed30a0$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $dtngf = parcelRequire("dtngf");
const $633b7c9a43ed30a0$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $81Pre.useIssueAdjustmentsActions)();
    const viewType = (0, $ejJgp.useViewType)();
    return (0, $bSJIT.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $dtngf.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("2Hq3Y", function(module, exports) {
$parcel$export(module.exports, "useSubmit", () => $9f7b3be689296ada$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $6WltM = parcelRequire("6WltM");

var $iACvP = parcelRequire("iACvP");

var $cYXOj = parcelRequire("cYXOj");

var $94Dxj = parcelRequire("94Dxj");

var $lNNuB = parcelRequire("lNNuB");

var $2EVMc = parcelRequire("2EVMc");

var $0164e = parcelRequire("0164e");

var $eObYt = parcelRequire("eObYt");

var $eEoq0 = parcelRequire("eEoq0");

var $lnUBX = parcelRequire("lnUBX");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $t3G1N = parcelRequire("t3G1N");

var $f71DI = parcelRequire("f71DI");

var $dtngf = parcelRequire("dtngf");

var $7HGbP = parcelRequire("7HGbP");

var $8xRLa = parcelRequire("8xRLa");

var $2wS11 = parcelRequire("2wS11");
const $9f7b3be689296ada$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $81Pre.useIssueAdjustmentsActions)();
    const viewType = (0, $ejJgp.useViewType)();
    const getAsyncLookupData = (0, $eObYt.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $2wS11.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $f71DI.useTenantContext)();
    const executionContext = (0, $0164e.useExecutionContext)();
    const environment = (0, $a2qIF.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $8xRLa.useFieldsChangesValidation)();
    const { lastProcessedChange: lastProcessedChange } = (0, $lnUBX.useLastProcessedChange)();
    const lastChangedProcessRef = (0, $bSJIT.useRef)(lastProcessedChange);
    const formMetadata = (0, $eEoq0.useFormMetadata)();
    const formMetadataRef = (0, $bSJIT.useRef)(formMetadata);
    formMetadataRef.current = formMetadata;
    (0, $bSJIT.useEffect)(()=>{
        lastChangedProcessRef.current = lastProcessedChange;
    }, [
        lastProcessedChange
    ]);
    const intl = (0, $4vLTk.default)();
    const getFieldAttributesForAnalytics = (0, $bSJIT.useCallback)((fieldsChanges)=>{
        try {
            const fieldAttributes = [];
            for(const fieldId in fieldsChanges){
                var _formMetadataRef$curr;
                if ((_formMetadataRef$curr = formMetadataRef.current) !== null && _formMetadataRef$curr !== void 0 && _formMetadataRef$curr[fieldId]) {
                    const { fieldType: fieldType } = formMetadataRef.current[fieldId];
                    const attributes = Object.keys(fieldsChanges[fieldId]);
                    fieldAttributes.push({
                        fieldType: fieldType,
                        attributes: attributes
                    });
                }
            }
            return JSON.stringify(fieldAttributes);
        // oxlint-disable-next-line no-unused-vars
        } catch (_error) {
            return 'NULL';
        }
    }, []);
    return (0, $bSJIT.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        let isSameFieldValueChanged = false;
        let fieldType = null;
        // Name the event after the canonical viewType (so overlay traffic lands in the
        // same bucket) and move the real viewType into attributes so we still know
        // exactly where we are.
        const analyticsViewType = executionContext.analyticsViewType ? executionContext.analyticsViewType : viewType;
        try {
            var _lastChangedProcessRe, _formMetadataRef$curr2;
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: // TODO: We should pass validatedFieldsChanges instead of fieldsChanges, UIM-2214
                lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $7HGbP.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $dtngf.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            isSameFieldValueChanged = (0, $2EVMc.checkSameFieldValueChanged)(fieldsChanges, lastChangedProcessRef.current, changeId);
            if ((_lastChangedProcessRe = lastChangedProcessRef.current) !== null && _lastChangedProcessRe !== void 0 && _lastChangedProcessRe.fieldId && (_formMetadataRef$curr2 = formMetadataRef.current) !== null && _formMetadataRef$curr2 !== void 0 && _formMetadataRef$curr2[lastChangedProcessRef.current.fieldId]) {
                const fieldId = lastChangedProcessRef.current.fieldId;
                const { fieldType: fieldTypeFromFormMetadata } = formMetadataRef.current[fieldId];
                fieldType = fieldTypeFromFormMetadata;
            }
            (0, $94Dxj.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${analyticsViewType}jiraUiModificationsUseSubmit`,
                attributes: {
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $lNNuB.ON_INIT_CHANGE_ID),
                    fieldType: fieldType,
                    submittedFields: getFieldAttributesForAnalytics(fieldsChanges),
                    viewType: viewType
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $dtngf.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $t3G1N.UiModificationsValidationError)) {
                (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $iACvP.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                analyticsViewType: analyticsViewType,
                attributes: {
                    errorCause: err === null || err === void 0 ? void 0 : err.cause,
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $lNNuB.ON_INIT_CHANGE_ID),
                    fieldType: fieldType
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields,
        getFieldAttributesForAnalytics
    ]);
};

});
parcelRegister("94Dxj", function(module, exports) {
$parcel$export(module.exports, "fireTrackEvent", () => $adf5bc8431f11b1d$export$574d2f19a52d67ca);

var $jeyHF = parcelRequire("jeyHF");

var $clpci = parcelRequire("clpci");

var $lfIWD = parcelRequire("lfIWD");
const $adf5bc8431f11b1d$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $jeyHF.default)((0, $lfIWD.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $clpci.TRACK_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});

parcelRegister("eObYt", function(module, exports) {
$parcel$export(module.exports, "useLookupFieldData", () => $01cd23e6811f964b$export$d43e9e394c54e784);

var $bSJIT = parcelRequire("bSJIT");

var $eZ8ws = parcelRequire("eZ8ws");

var $a2qIF = parcelRequire("a2qIF");

var $6WltM = parcelRequire("6WltM");

var $egWdp = parcelRequire("egWdp");

var $gRlee = parcelRequire("gRlee");

var $36yul = parcelRequire("36yul");

var $dXY3e = parcelRequire("dXY3e");

var $71Eie = parcelRequire("71Eie");

var $iV579 = parcelRequire("iV579");

var $f4qoo = parcelRequire("f4qoo");

var $0164e = parcelRequire("0164e");

var $eEoq0 = parcelRequire("eEoq0");

var $ejJgp = parcelRequire("ejJgp");

var $f71DI = parcelRequire("f71DI");

var $dtngf = parcelRequire("dtngf");
const $01cd23e6811f964b$var$getProjectScope = (executionContext)=>{
    const { project: project } = executionContext;
    if (!project || typeof project !== 'object' || !('id' in project) || !('key' in project)) return null;
    const { id: id, key: key } = project;
    return typeof id === 'string' && typeof key === 'string' ? {
        id: id,
        key: key
    } : null;
};
const $01cd23e6811f964b$export$d43e9e394c54e784 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $f71DI.useTenantContext)();
    const environment = (0, $a2qIF.useRelayEnvironment)();
    const formMetadata = (0, $eEoq0.useFormMetadata)();
    const formMetadataRef = (0, $bSJIT.useRef)(formMetadata);
    const viewType = (0, $ejJgp.useViewType)();
    const executionContext = (0, $0164e.useExecutionContext)();
    const executionContextRef = (0, $bSJIT.useRef)(executionContext);
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    executionContextRef.current = executionContext;
    return (0, $bSJIT.useCallback)(async (fieldsChanges)=>{
        var _asyncFieldsValues$co, _asyncFieldsValues$ve;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration === null || supportedFieldsConfiguration === void 0 ? void 0 : supportedFieldsConfiguration.lookupSource;
            const isUserLookupField = lookupSource === (0, $egWdp.LOOKUP_SOURCE_USERS_ASYNC_DATA);
            const isProjectLookupField = lookupSource === (0, $egWdp.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA);
            const isComponentLookupField = lookupSource === (0, $egWdp.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA);
            const isVersionLookupField = lookupSource === (0, $egWdp.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA);
            if (isUserLookupField && fieldValue && (0, $gRlee.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            if (isProjectLookupField && fieldValue) {
                const currentProjectIds = acc.projectIds ? [
                    ...acc.projectIds
                ] : [];
                const newProjectIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.projectIds = [
                    ...currentProjectIds,
                    ...newProjectIds
                ];
            }
            if (isComponentLookupField && fieldValue) {
                const currentComponentIds = acc.componentIds ? [
                    ...acc.componentIds
                ] : [];
                const newComponentIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.componentIds = [
                    ...currentComponentIds,
                    ...newComponentIds
                ];
            }
            if (isVersionLookupField && fieldValue) {
                const currentVersionIds = acc.versionIds ? [
                    ...acc.versionIds
                ] : [];
                const newVersionIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.versionIds = [
                    ...currentVersionIds,
                    ...newVersionIds
                ];
            }
            return acc;
        }, {});
        let users = [];
        let projects = [];
        let components = [];
        let versions = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))(asyncFieldsValues.accountIds);
            users = await (0, $iV579.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        if (asyncFieldsValues.projectIds) {
            const uniqueProjectIds = (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))(asyncFieldsValues.projectIds);
            // Convert numeric project IDs to ARIs before fetching
            // GraphQL expects ARIs like "ari:cloud:jira:{cloudId}:project/10001", not plain "10001"
            const projectAris = (0, $36yul.convertProjectIdsToAris)(uniqueProjectIds, cloudId);
            projects = await (0, $71Eie.fetchProjects)(environment, projectAris, createAnalyticsEvent);
        }
        const projectScope = $01cd23e6811f964b$var$getProjectScope(executionContextRef.current);
        if ((_asyncFieldsValues$co = asyncFieldsValues.componentIds) !== null && _asyncFieldsValues$co !== void 0 && _asyncFieldsValues$co.length && projectScope) {
            const uniqueComponentIds = (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))(asyncFieldsValues.componentIds);
            components = await (0, $dXY3e.fetchComponents)(environment, cloudId, projectScope.key, uniqueComponentIds, createAnalyticsEvent);
        }
        if ((_asyncFieldsValues$ve = asyncFieldsValues.versionIds) !== null && _asyncFieldsValues$ve !== void 0 && _asyncFieldsValues$ve.length && projectScope) {
            const uniqueVersionIds = (0, (/*@__PURE__*/$parcel$interopDefault($eZ8ws)))(asyncFieldsValues.versionIds);
            versions = await (0, $f4qoo.fetchVersions)(environment, cloudId, projectScope.key, uniqueVersionIds, createAnalyticsEvent);
        }
        lookupData[0, $egWdp.LOOKUP_SOURCE_USERS_ASYNC_DATA] = users;
        lookupData[0, $egWdp.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA] = projects;
        lookupData[0, $egWdp.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA] = components;
        lookupData[0, $egWdp.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA] = versions;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment,
        cloudId
    ]);
};

});
parcelRegister("36yul", function(module, exports) {
$parcel$export(module.exports, "convertProjectIdsToAris", () => $a0888bc691b690b4$export$2a73bd4f6cc71a00);
/**
 * Converts a project ID to a Jira project ARI.
 *
 * @param projectId - The project ID (numeric string like "10001" or already an ARI)
 * @param cloudId - The cloud/tenant ID
 * @returns The full project ARI in format "ari:cloud:jira:{cloudId}:project/{projectId}"
 *
 * @example
 * ```typescript
 * convertProjectIdToAri("10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001"
 *
 * convertProjectIdToAri("ari:cloud:jira:abc-123-def:project/10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001" (unchanged)
 * ```
 */ const $a0888bc691b690b4$export$fee909b034ddb326 = (projectId, cloudId)=>{
    // If already an ARI, return as-is
    if (projectId.startsWith('ari:')) return projectId;
    // Convert numeric project ID to ARI format
    return `ari:cloud:jira:${cloudId}:project/${projectId}`;
};
const $a0888bc691b690b4$export$2a73bd4f6cc71a00 = (projectIds, cloudId)=>{
    return projectIds.map((id)=>$a0888bc691b690b4$export$fee909b034ddb326(id, cloudId));
};

});

parcelRegister("dXY3e", function(module, exports) {
$parcel$export(module.exports, "fetchComponents", () => $2413ab25e7ace731$export$4f703ddb7c8cc5b3);

var $8AWi4 = parcelRequire("8AWi4");

var $a2qIF = parcelRequire("a2qIF");

var $cYXOj = parcelRequire("cYXOj");

var $kBTtw = parcelRequire("kBTtw");
const $2413ab25e7ace731$export$4f703ddb7c8cc5b3 = async (environment, cloudId, projectIdOrKey, componentIds, createAnalyticsEvent)=>{
    try {
        var _response$jira_projec;
        const apiStartTime = performance.now();
        const response = await (0, $a2qIF.fetchQuery)(environment, (0, $8AWi4.default), {
            cloudId: cloudId,
            idOrKey: projectIdOrKey,
            componentIds: componentIds,
            first: componentIds.length
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const connection = response === null || response === void 0 || (_response$jira_projec = response.jira_projectByIdOrKey) === null || _response$jira_projec === void 0 ? void 0 : _response$jira_projec.components;
        if (!connection) throw new (0, $kBTtw.ErrorWithStatusCode)('[fetch-components service] [fetchComponentsQuery]: Property jira_projectByIdOrKey.components does not exist.', {
            cause: 'FETCH_COMPONENTS_MISSING_COMPONENTS_PROPERTY'
        }, 'FETCH_COMPONENTS_MISSING_COMPONENTS_PROPERTY');
        const resolved = [];
        for (const edge of connection.edges ?? []){
            const node = edge === null || edge === void 0 ? void 0 : edge.node;
            if (node !== null && node !== void 0 && node.componentId) resolved.push({
                id: node.componentId,
                name: node.name ?? ''
            });
        }
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchComponents',
            attributes: {
                componentsAPILatency: apiLatencyMs
            }
        });
        return resolved;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_COMPONENTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("8AWi4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a521b42796ecac2a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72506ae8440435e02d7f3c56abf88feb>>
 * @relayHash 37d93a84b6e6288eab04437f1692cb28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b68508a27ab628b521cd513005cdad2a9785f41028da93157f24132b2909ad09
const $a521b42796ecac2a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "componentIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "idOrKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "idOrKey"
        }
    ], v5 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "componentIds"
                },
                {
                    "kind": "Literal",
                    "name": "operation",
                    "value": "ALLOW"
                }
            ],
            "kind": "ObjectValue",
            "name": "filterById"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "componentId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchComponentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraComponentConnection",
                            "kind": "LinkedField",
                            "name": "components",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraComponentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraComponent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchComponentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraComponentConnection",
                            "kind": "LinkedField",
                            "name": "components",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraComponentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraComponent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "b68508a27ab628b521cd513005cdad2a9785f41028da93157f24132b2909ad09",
            "metadata": {},
            "name": "fetchComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a521b42796ecac2a$var$node.hash = "6c026a99ef4cd36167652e2f64e1e401";
var $a521b42796ecac2a$export$2e2bcd8739ae039 = $a521b42796ecac2a$var$node;

});

parcelRegister("kBTtw", function(module, exports) {
$parcel$export(module.exports, "ErrorWithStatusCode", () => $de9276454a0b4d1b$export$13144d723cf04c);
class $de9276454a0b4d1b$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("71Eie", function(module, exports) {
$parcel$export(module.exports, "fetchProjects", () => $5c472898784182fd$export$f0d2ca471cdb99b0);

var $2LbNw = parcelRequire("2LbNw");

var $a2qIF = parcelRequire("a2qIF");

var $cYXOj = parcelRequire("cYXOj");

var $kBTtw = parcelRequire("kBTtw");
const $5c472898784182fd$export$f0d2ca471cdb99b0 = async (environment, projectIds, createAnalyticsEvent)=>{
    try {
        var _response$jira;
        const apiStartTime = performance.now();
        const response = await (0, $a2qIF.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $2LbNw.default), {
            projectIds: projectIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && (_response$jira = response.jira) !== null && _response$jira !== void 0 && _response$jira.jiraProjects)) throw new (0, $kBTtw.ErrorWithStatusCode)('[fetch-projects service] [fetchProjectsQuery]: Property jira.jiraProjects does not exist.', {
            cause: 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY'
        }, 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchProjects',
            attributes: {
                projectsAPILatency: apiLatencyMs
            }
        });
        return response.jira.jiraProjects.filter((project)=>project !== null && project !== undefined && project.projectId !== null && project.projectId !== undefined).map((project)=>{
            var _project$avatar;
            return {
                // Use projectId (numeric ID like "10001"), not id (ARI)
                id: project.projectId,
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': ((_project$avatar = project.avatar) === null || _project$avatar === void 0 ? void 0 : _project$avatar.large) || ''
                }
            };
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_PROJECTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("2LbNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $94f815d1f4092338$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63bd7a4e2ee2e0f9a2be5f0889617550>>
 * @relayHash 8dddd1ce7676474299e324ca788770e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e
const $94f815d1f4092338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ids",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjects",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e",
            "metadata": {},
            "name": "fetchProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$94f815d1f4092338$var$node.hash = "bfbd83d6cfdfb7072506c62a347912b6";
var $94f815d1f4092338$export$2e2bcd8739ae039 = $94f815d1f4092338$var$node;

});


parcelRegister("iV579", function(module, exports) {
$parcel$export(module.exports, "fetchUsers", () => $3b79ca07f1979854$export$2bb8333a9210be15);

var $4QiMs = parcelRequire("4QiMs");

var $a2qIF = parcelRequire("a2qIF");

var $cYXOj = parcelRequire("cYXOj");

var $kBTtw = parcelRequire("kBTtw");
const $3b79ca07f1979854$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $a2qIF.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $4QiMs.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && response.users)) throw new (0, $kBTtw.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("4QiMs", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d805abb500d24a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e70547764e67b037edaf0816b6f4ec77>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $5d805abb500d24a9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5d805abb500d24a9$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $5d805abb500d24a9$export$2e2bcd8739ae039 = $5d805abb500d24a9$var$node;

});


parcelRegister("f4qoo", function(module, exports) {
$parcel$export(module.exports, "fetchVersions", () => $bcc2e7333cd727d5$export$4559ccb0044798a5);

var $kaqr6 = parcelRequire("kaqr6");

var $a2qIF = parcelRequire("a2qIF");

var $cYXOj = parcelRequire("cYXOj");

var $kBTtw = parcelRequire("kBTtw");
const $bcc2e7333cd727d5$export$4559ccb0044798a5 = async (environment, cloudId, projectIdOrKey, versionIds, createAnalyticsEvent)=>{
    try {
        var _response$jira_projec;
        const apiStartTime = performance.now();
        const response = await (0, $a2qIF.fetchQuery)(environment, (0, $kaqr6.default), {
            cloudId: cloudId,
            idOrKey: projectIdOrKey,
            versionIds: versionIds,
            first: versionIds.length
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const connection = response === null || response === void 0 || (_response$jira_projec = response.jira_projectByIdOrKey) === null || _response$jira_projec === void 0 ? void 0 : _response$jira_projec.versions;
        if (!connection) throw new (0, $kBTtw.ErrorWithStatusCode)('[fetch-versions service] [fetchVersionsQuery]: Property jira_projectByIdOrKey.versions does not exist.', {
            cause: 'FETCH_VERSIONS_MISSING_VERSIONS_PROPERTY'
        }, 'FETCH_VERSIONS_MISSING_VERSIONS_PROPERTY');
        const resolved = [];
        for (const edge of connection.edges ?? []){
            const node = edge === null || edge === void 0 ? void 0 : edge.node;
            if (node !== null && node !== void 0 && node.versionId) resolved.push({
                id: node.versionId,
                name: node.name ?? ''
            });
        }
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchVersions',
            attributes: {
                versionsAPILatency: apiLatencyMs
            }
        });
        return resolved;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_VERSIONS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("kaqr6", function(module, exports) {
$parcel$export(module.exports, "default", () => $699fa2b357d135f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c93d89a2145fdb8572a6bb0cef7da0ec>>
 * @relayHash 61e6877436db9caf5fc1888b682137a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e497389782710d6c061f7eb4f4aab84b821ebfeb8f7c94409d3c758c2f7ec0f
const $699fa2b357d135f1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "idOrKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionIds"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "idOrKey"
        }
    ], v5 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": [
                "RELEASED",
                "UNRELEASED",
                "ARCHIVED"
            ]
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "versionIds"
                },
                {
                    "kind": "Literal",
                    "name": "operation",
                    "value": "ALLOW"
                }
            ],
            "kind": "ObjectValue",
            "name": "filterById"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchVersionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchVersionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2e497389782710d6c061f7eb4f4aab84b821ebfeb8f7c94409d3c758c2f7ec0f",
            "metadata": {},
            "name": "fetchVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$699fa2b357d135f1$var$node.hash = "6bcc668390a80ba013587a8380113f14";
var $699fa2b357d135f1$export$2e2bcd8739ae039 = $699fa2b357d135f1$var$node;

});


parcelRegister("eEoq0", function(module, exports) {
$parcel$export(module.exports, "useFormMetadata", () => $ab7dffdba1f0dc61$export$863414fa128cb7ef);

var $bBhJi = parcelRequire("bBhJi");
var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $ab7dffdba1f0dc61$var$selectFormMetadata = (0, $bBhJi.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $ab7dffdba1f0dc61$export$863414fa128cb7ef = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    selector: $ab7dffdba1f0dc61$var$selectFormMetadata
});

});


parcelRegister("8xRLa", function(module, exports) {
$parcel$export(module.exports, "useFieldsChangesValidation", () => $90e0d953d8a33ddd$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $cwGwT = parcelRequire("cwGwT");

var $eEoq0 = parcelRequire("eEoq0");

var $ejJgp = parcelRequire("ejJgp");

var $8KPB9 = parcelRequire("8KPB9");

var $2l4tA = parcelRequire("2l4tA");
const $90e0d953d8a33ddd$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $90e0d953d8a33ddd$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $90e0d953d8a33ddd$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const formMetadata = (0, $eEoq0.useFormMetadata)();
    const formMetadataRef = (0, $bSJIT.useRef)(formMetadata);
    const viewType = (0, $ejJgp.useViewType)();
    const { currentFormState: currentFormState } = (0, $cwGwT.useCurrentFormState)();
    const currentFormStateRef = (0, $bSJIT.useRef)(currentFormState);
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $bSJIT.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $2l4tA.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $90e0d953d8a33ddd$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $8KPB9.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $90e0d953d8a33ddd$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("2l4tA", function(module, exports) {
$parcel$export(module.exports, "validateFieldChanges", () => $a973bc09ade6cee1$export$a2b7ddd7c3d0703a);

var $dtngf = parcelRequire("dtngf");

var $llL67 = parcelRequire("llL67");

var $aWaUL = parcelRequire("aWaUL");
const $a973bc09ade6cee1$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $dtngf.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $llL67.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $aWaUL.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $aWaUL.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $llL67.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $aWaUL.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $llL67.VALID_RESULT;
};

});
parcelRegister("llL67", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $8f23958ef108fc44$export$ee79e3ab53b8db79);
const $8f23958ef108fc44$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("aWaUL", function(module, exports) {
$parcel$export(module.exports, "prepareValidationResult", () => $bb43495f0673b28b$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $bb43495f0673b28b$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $bb43495f0673b28b$export$fd744b06c9068a9e);

var $9m9kx = parcelRequire("9m9kx");

var $k8sJ1 = parcelRequire("k8sJ1");

var $llL67 = parcelRequire("llL67");
const $bb43495f0673b28b$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $9m9kx.FIELD_VALIDATION_ERROR),
            method: (0, $k8sJ1.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $llL67.VALID_RESULT;
};
const $bb43495f0673b28b$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $9m9kx.FIELD_VALIDATION_ERROR),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $llL67.VALID_RESULT;
};
const $bb43495f0673b28b$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $bb43495f0673b28b$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $bb43495f0673b28b$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $bb43495f0673b28b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $bb43495f0673b28b$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});



parcelRegister("2wS11", function(module, exports) {
$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $75207a56317754d7$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $cwGwT = parcelRequire("cwGwT");

var $ejJgp = parcelRequire("ejJgp");

var $ixP9S = parcelRequire("ixP9S");
const $75207a56317754d7$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $cwGwT.useCurrentFormState)();
    const currentFormStateRef = (0, $bSJIT.useRef)(currentFormState);
    const viewType = (0, $ejJgp.useViewType)();
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ currentFormStateRef.current = currentFormState;
    return (0, $bSJIT.useCallback)((fieldChanges)=>(0, $ixP9S.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("AEgUT", function(module, exports) {
$parcel$export(module.exports, "useIframeTimeout", () => $9776d5f12b394914$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $fI1BQ = parcelRequire("fI1BQ");

var $6WltM = parcelRequire("6WltM");

var $cYXOj = parcelRequire("cYXOj");

var $ejJgp = parcelRequire("ejJgp");
const $9776d5f12b394914$export$45f7ef64ce535ffd = 12000;
const $9776d5f12b394914$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $bSJIT.useRef)(undefined);
    const callbackRef = (0, $bSJIT.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const viewType = (0, $ejJgp.useViewType)();
    const onTimeout = (0, $bSJIT.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$9776d5f12b394914$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $bSJIT.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $9776d5f12b394914$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("2H3s2", function(module, exports) {
$parcel$export(module.exports, "useScopeChecks", () => $c4b7dc4ef92fbc32$export$5b312a37a22a70a8);

var $j3MSK = parcelRequire("j3MSK");
const $c4b7dc4ef92fbc32$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $j3MSK.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $j3MSK.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("j3MSK", function(module, exports) {
$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $b7296d3cb85e313d$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $b7296d3cb85e313d$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $b7296d3cb85e313d$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $b7296d3cb85e313d$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("gKJCp", function(module, exports) {
$parcel$export(module.exports, "useThreeLOPromptProps", () => $8093f9571ce5e18d$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $k9uij = parcelRequire("k9uij");

var $cYXOj = parcelRequire("cYXOj");

var $inaNq = parcelRequire("inaNq");

var $QaFKJ = parcelRequire("QaFKJ");

var $6FvB9 = parcelRequire("6FvB9");

var $ejJgp = parcelRequire("ejJgp");

var $dtngf = parcelRequire("dtngf");
const $8093f9571ce5e18d$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $bSJIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $inaNq.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $k9uij.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $ejJgp.useViewType)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const currentUIModificationsConsentStatus = (0, $QaFKJ.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $bSJIT.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $6FvB9.UIM_CONSENT_CONSENTED)
        });
        (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $bSJIT.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $6FvB9.UIM_CONSENT_UNKNOWN)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $6FvB9.UIM_CONSENT_REQUIRED)
            });
            if (!hasBeenTracked) {
                (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $bSJIT.useMemo)(()=>{
        return formatMessage((0, $dtngf.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $bSJIT.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("72oGN", function(module, exports) {
$parcel$export(module.exports, "buildExtensionData", () => $08f53ee04a0697bc$export$141a9933f8885d99);

var $lNNuB = parcelRequire("lNNuB");
const $08f53ee04a0697bc$export$141a9933f8885d99 = (executionContext)=>{
    const { analyticsViewType: _analyticsViewType, ...executionContextWithoutAnalytics } = executionContext;
    return {
        type: (0, $lNNuB.UI_MODIFICATIONS_MODULE),
        ...executionContextWithoutAnalytics
    };
};

});



parcelRegister("agEQ5", function(module, exports) {
$parcel$export(module.exports, "useAppsToRender", () => $f8aa3ca3618197e4$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $cYXOj = parcelRequire("cYXOj");

var $inaNq = parcelRequire("inaNq");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $ltu56 = parcelRequire("ltu56");

var $hdEsb = parcelRequire("hdEsb");
const $f8aa3ca3618197e4$export$bef357953bcc2428 = (payload)=>{
    var _data$jira3, _data$jira4, _data$jira6, _data$jira9, _data$jira0;
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $81Pre.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $inaNq.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const viewType = (0, $ejJgp.useViewType)();
    const configuredApps = (0, $bSJIT.useMemo)(()=>{
        var _data$jira, _data$jira2;
        return (0, $hdEsb.getConfiguredApps)((_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.uiModificationsExtensions, (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.uiModifications);
    }, [
        (_data$jira3 = data.jira) === null || _data$jira3 === void 0 || (_data$jira3 = _data$jira3.forge) === null || _data$jira3 === void 0 ? void 0 : _data$jira3.uiModificationsExtensions,
        (_data$jira4 = data.jira) === null || _data$jira4 === void 0 ? void 0 : _data$jira4.uiModifications
    ]);
    const appsToRender = (0, $bSJIT.useMemo)(()=>{
        return configuredApps.slice(0, (0, $ltu56.MAX_NUMBER_OF_UIM_APPS));
    }, [
        configuredApps
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _data$jira5;
        if (((_data$jira5 = data.jira) === null || _data$jira5 === void 0 ? void 0 : _data$jira5.uiModifications) !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        (_data$jira6 = data.jira) === null || _data$jira6 === void 0 ? void 0 : _data$jira6.uiModifications
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) {
            var _data$jira7, _data$jira8;
            (0, $cYXOj.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: 'jiraUiModifications.configuredAppsPerContext',
                attributes: {
                    forgeModulesCount: (_data$jira7 = data.jira) === null || _data$jira7 === void 0 || (_data$jira7 = _data$jira7.forge) === null || _data$jira7 === void 0 ? void 0 : _data$jira7.uiModificationsExtensions.length,
                    uimConfiguredAppCount: (_data$jira8 = data.jira) === null || _data$jira8 === void 0 ? void 0 : _data$jira8.uiModifications.length,
                    configuredAndInstalledApps: configuredAppsCount,
                    areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                    viewType: viewType
                }
            });
        }
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        (_data$jira9 = data.jira) === null || _data$jira9 === void 0 || (_data$jira9 = _data$jira9.forge) === null || _data$jira9 === void 0 ? void 0 : _data$jira9.uiModificationsExtensions.length,
        (_data$jira0 = data.jira) === null || _data$jira0 === void 0 ? void 0 : _data$jira0.uiModifications.length
    ]);
    return appsToRender;
};

});
parcelRegister("ltu56", function(module, exports) {
$parcel$export(module.exports, "MAX_NUMBER_OF_UIM_APPS", () => $61e06ab460bd6f70$export$575c2f3c7fe81caa);
const $61e06ab460bd6f70$export$575c2f3c7fe81caa = 5;

});

parcelRegister("hdEsb", function(module, exports) {
$parcel$export(module.exports, "getConfiguredApps", () => $0c88e5d0a42f644c$export$6ead423ef319ea49);

var $8BvCr = parcelRequire("8BvCr");
const $0c88e5d0a42f644c$var$STABLE_EMPTY_ARRAY = [];
const $0c88e5d0a42f644c$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $0c88e5d0a42f644c$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $8BvCr.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("8BvCr", function(module, exports) {
$parcel$export(module.exports, "normalizeExtensions", () => $b20342cc3f0fe6ae$export$7e2e604b6166a087);

var $k9uij = parcelRequire("k9uij");
const $b20342cc3f0fe6ae$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $k9uij.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("f4qe6", function(module, exports) {
$parcel$export(module.exports, "useContextCleanup", () => $a16e302d05fbdade$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $bSJIT = parcelRequire("bSJIT");

var $inaNq = parcelRequire("inaNq");

var $ejJgp = parcelRequire("ejJgp");

var $81Pre = parcelRequire("81Pre");

var $dtngf = parcelRequire("dtngf");
const $a16e302d05fbdade$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $81Pre.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $inaNq.useAdjustmentsContextActions)();
    const viewType = (0, $ejJgp.useViewType)();
    (0, $bSJIT.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $bSJIT.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $bSJIT.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $dtngf.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("iofrM", function(module, exports) {
$parcel$export(module.exports, "useEnrichedExecutionContext", () => $9ce8df8a9e87b5d4$export$649da33b72723913);

var $bSJIT = parcelRequire("bSJIT");

var $ejJgp = parcelRequire("ejJgp");
const $9ce8df8a9e87b5d4$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    const viewType = (0, $ejJgp.useViewType)();
    const enrichedExecutionContext = (0, $bSJIT.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});


parcelRegister("d7O6G", function(module, exports) {
$parcel$export(module.exports, "ForgeAppRenderer", () => $314c5b0f678cbe41$export$6eef17fe5fde390c);

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");

var $i7phc = parcelRequire("i7phc");

var $fKuli = parcelRequire("fKuli");

var $5TkOb = parcelRequire("5TkOb");
const $314c5b0f678cbe41$export$6eef17fe5fde390c = (props)=>{
    const { extension: extension, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fKuli.ExtensionPointProvider), {
        extensionType: (0, $i7phc.UI_MODIFICATIONS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5TkOb.Renderer), {
        ...restProps,
        extension: extension,
        contextTokenType: (0, $gYq50.ContextTokenType).JIRA
    }));
};

});
parcelRegister("gYq50", function(module, exports) {
$parcel$export(module.exports, "ALLOWED", () => $df45e107cac8a582$export$b4c0bb1de45ab46c);
$parcel$export(module.exports, "BLOCKED", () => $df45e107cac8a582$export$c2dfa6e96815ac6b);
$parcel$export(module.exports, "ContextTokenType", () => $df45e107cac8a582$export$70a9026332abd115);
$parcel$export(module.exports, "AtlassianHelpConfigAccountType", () => $df45e107cac8a582$export$5ea1c090b459f41f);
$parcel$export(module.exports, "isForgeCustomField", () => $df45e107cac8a582$export$78cf1b56a8dede1f);
const $df45e107cac8a582$export$b4c0bb1de45ab46c = 'ALLOWED';
const $df45e107cac8a582$export$c2dfa6e96815ac6b = 'BLOCKED';
const $df45e107cac8a582$export$8a7e8af112e5972a = 'extension';
var $df45e107cac8a582$export$70a9026332abd115 = /*#__PURE__*/ function(ContextTokenType) {
    ContextTokenType["JSM"] = "JSM";
    ContextTokenType["JIRA"] = "JIRA";
    return ContextTokenType;
}({});
var $df45e107cac8a582$export$5ea1c090b459f41f = /*#__PURE__*/ function(AtlassianHelpConfigAccountType) {
    AtlassianHelpConfigAccountType["ATLASSIAN"] = "atlassian";
    AtlassianHelpConfigAccountType["CUSTOMER"] = "customer";
    AtlassianHelpConfigAccountType["ANONYMOUS"] = "anonymous";
    return AtlassianHelpConfigAccountType;
}({});
/**
 * The ARI prefix for Forge ecosystem extensions.
 * All Forge custom field customIds start with this prefix.
 */ const $df45e107cac8a582$var$FORGE_EXTENSION_ARI_PREFIX = 'ari:cloud:ecosystem::extension/';
const $df45e107cac8a582$export$78cf1b56a8dede1f = (customId)=>{
    return Boolean(customId && customId.startsWith($df45e107cac8a582$var$FORGE_EXTENSION_ARI_PREFIX));
};

});

parcelRegister("fKuli", function(module, exports) {
$parcel$export(module.exports, "ExtensionPointProvider", () => $060aba0a11b092fb$export$80b99728bc3dad9);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $060aba0a11b092fb$export$80b99728bc3dad9 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("24SDz")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-point-provider/extension-point-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("24SDz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("izSDP"),
    $kOunM("lhY3f"),
    $kOunM("9jLev")
]).then(()=>parcelRequire('gpHk3'));

});


parcelRegister("5TkOb", function(module, exports) {
$parcel$export(module.exports, "Renderer", () => $0a5bc7752670ca0c$export$88530751e3977073);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $0a5bc7752670ca0c$export$88530751e3977073 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("7STej")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/renderer/renderer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("7STej", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cYVl6"),
    $kOunM("4e17f"),
    $kOunM("iZJsN"),
    $kOunM("coIBk"),
    $kOunM("3M7DB"),
    $kOunM("gsQwM"),
    $kOunM("gtKgf"),
    $kOunM("fCONc"),
    $kOunM("iHTSu"),
    $kOunM("izSDP"),
    $kOunM("lhY3f"),
    $kOunM("bZJN7")
]).then(()=>parcelRequire('8r9CO'));

});




parcelRegister("dUmWe", function(module, exports) {
$parcel$export(module.exports, "HeaderSinglePortalMode", () => (parcelRequire("elGk2")).default);

var $elGk2 = parcelRequire("elGk2");

});
parcelRegister("elGk2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d140c56001add82a$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("1xrTy");
var $9Yoxp = parcelRequire("9Yoxp");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("2PyTf");
var $46bIy = parcelRequire("46bIy");
const $d140c56001add82a$var$getPortalName = (state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    return portalId ? (0, $iWhHo.getName)(state, portalId) : undefined;
};
const $d140c56001add82a$var$getPortalDescription = (state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    return portalId ? (0, $iWhHo.getDescription)(state, portalId) : undefined;
};
const $d140c56001add82a$var$getPortalLogoUrl = (state)=>{
    const portalId = (0, $9Yoxp.getPortalId)(state);
    return portalId ? (0, $iWhHo.getLogoUrl)(state, portalId) : undefined;
};
const $d140c56001add82a$var$selector = (0, $BOq7h.createSelector)($d140c56001add82a$var$getPortalName, $d140c56001add82a$var$getPortalDescription, $d140c56001add82a$var$getPortalLogoUrl, (portalName, portalDescription, portalLogoUrl)=>({
        subHeading: portalName,
        description: portalDescription,
        logoUrl: portalLogoUrl,
        dangerouslyAllowHtmlInDescription: true
    }));
var $d140c56001add82a$export$2e2bcd8739ae039 = (0, $f2mlD.default)($d140c56001add82a$var$selector)((0, $46bIy.default));

});


parcelRegister("e8mg1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c662b9d6579d54e$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $1c662b9d6579d54e$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    addAnnoucement: {
        defaultMessage: 'Add announcement',
        description: 'Text for add announcement button',
        id: 'cv.portal.home.add.announcement.button'
    },
    editAnnouncement: {
        defaultMessage: 'Edit announcement',
        description: 'Text for edit announcement button',
        id: 'cv.portal.home.edit.announcement.button'
    },
    requestTypePageTitle: {
        defaultMessage: '{requestTypeName} - {portalName} - Jira Service Management',
        description: 'Page title for portal page when customer selected a request type form',
        id: 'sd.jsm.customerview.request.type.selected.portal.page.title'
    },
    portalPageTitle: {
        defaultMessage: '{portalName} - Jira Service Management',
        description: 'Page title for portal landing page',
        id: 'sd.jsm.customerview.portal.page.title'
    },
    portalGroupPageTitle: {
        defaultMessage: '{portalName} - Raise a request - Jira Service Management',
        description: 'Page title for portal group page',
        id: 'sd.jsm.customerview.portal.group.page.title'
    }
});

});






parcelRegister("2Wfvm", function(module, exports) {
$parcel$export(module.exports, "requestApprovalRoute", () => $c1edd8241859568e$export$bcdc6af6b60bfb08);

var $jcRK7 = parcelRequire("jcRK7");

var $hO8qA = parcelRequire("hO8qA");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");
const $c1edd8241859568e$var$route = {
    name: 'request-approval',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/:requestKey/approval/:approvalId/:decision`,
    exact: true,
    component: (0, $hO8qA.RequestApproval)
};
const $c1edd8241859568e$var$screenName = (0, $jcRK7.ScreenName).REQUEST_APPROVAL;
const $c1edd8241859568e$var$paperAppearance = 'normal';
const $c1edd8241859568e$var$layoutProps = {
    ...(0, $fZKGh.anonymousScreenLayout),
    paperAppearance: $c1edd8241859568e$var$paperAppearance
};
const $c1edd8241859568e$export$bcdc6af6b60bfb08 = (0, $bkEWh.createRouteWithLayout)($c1edd8241859568e$var$route, $c1edd8241859568e$var$screenName, $c1edd8241859568e$var$layoutProps);

});
parcelRegister("hO8qA", function(module, exports) {
$parcel$export(module.exports, "RequestApproval", () => $7cf72dd206c52431$export$741ffb1ed280e417);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $7cf72dd206c52431$export$741ffb1ed280e417 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("9oc7W")), {
        moduleId: "./src/view/request-approval/hocs.tsx"
    })
});

});
parcelRegister("9oc7W", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("63EBH").then(()=>parcelRequire('7BKoA'));

});



parcelRegister("Iy9X2", function(module, exports) {
$parcel$export(module.exports, "requestDetailsRoute", () => $d657ae72de87c6f7$export$c7023f3ff27ad6e1);

var $jcRK7 = parcelRequire("jcRK7");
parcelRequire("13WIH");
var $hy5Wv = parcelRequire("hy5Wv");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");
const $d657ae72de87c6f7$var$route = {
    name: 'request-details',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/:requestKey`,
    exact: true,
    component: (0, $hy5Wv.default)
};
const $d657ae72de87c6f7$var$screenName = (0, $jcRK7.ScreenName).REQUEST_DETAILS;
const $d657ae72de87c6f7$var$paperAppearance = 'xxwide';
const $d657ae72de87c6f7$var$layoutProps = {
    paperAppearance: $d657ae72de87c6f7$var$paperAppearance,
    hideSearchButton: false,
    fadeInSearchModal: true
};
const $d657ae72de87c6f7$export$c7023f3ff27ad6e1 = (0, $bkEWh.createRouteWithLayout)($d657ae72de87c6f7$var$route, $d657ae72de87c6f7$var$screenName, $d657ae72de87c6f7$var$layoutProps);

});
parcelRegister("13WIH", function(module, exports) {
$parcel$export(module.exports, "RequestDetails", () => (parcelRequire("hy5Wv")).default);

var $hy5Wv = parcelRequire("hy5Wv");

});
parcelRegister("hy5Wv", function(module, exports) {
$parcel$export(module.exports, "default", () => $11c75df58ba827a0$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $gQxPF = parcelRequire("gQxPF");

var $c5oCA = parcelRequire("c5oCA");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("bkU3q");
var $gXSFL = parcelRequire("gXSFL");
parcelRequire("lpgcJ");
var $8Wh6H = parcelRequire("8Wh6H");
parcelRequire("84x3k");
var $ajeJ9 = parcelRequire("ajeJ9");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("aXgK2");
var $7YKRB = parcelRequire("7YKRB");
parcelRequire("c4Ar8");
var $aF9Z8 = parcelRequire("aF9Z8");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $6NtVd = parcelRequire("6NtVd");

var $aYbXa = parcelRequire("aYbXa");

var $girok = parcelRequire("girok");
const $11c75df58ba827a0$var$selector = (0, $BOq7h.createSelector)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $iWhHo.getPortal)(state, (0, $aYbXa.toNumber)(props.match.params.portalId)), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $aF9Z8.getRequestDetails)(state, props.match.params.requestKey), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $7YKRB.getReqSlas)(state, props.match.params.requestKey), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $aF9Z8.getError)(state, props.match.params.requestKey), (state, props)=>{
    return (0, $iWhHo.getName)(state, Number(props.match.params.portalId)) ?? (0, $8Wh6H.getPortalNameFromBranding)(state);
}, (state, props)=>(0, $6NtVd.getIssueAnalyticsContext)(state, Number(props.match.params.portalId)), (state)=>(0, $fBLyB.isAtlassianAccountManaged)(state), (state, props)=>(0, $ajeJ9.getRequestSpecificConnectAddonPanels)({
        state: state,
        location: 'detailsPanels',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        requestKey: props.match.params.requestKey
    }), (state, props)=>{
    return Boolean((0, $iWhHo.getCanAdministerProject)(state, Number(props.match.params.portalId)));
}, (portal, requestDetails, reqSlas, persistedError, portalName, issueAnalyticsContext, isManagedAccount, connectPanels, isProjectAdmin)=>({
        portal: portal,
        requestDetails: requestDetails,
        reqSlas: reqSlas,
        issueAnalyticsContext: issueAnalyticsContext,
        portalName: portalName,
        isProjectAdmin: isProjectAdmin,
        isAtlassianManagedAccount: isManagedAccount,
        ...persistedError,
        hasConnectPanels: connectPanels && connectPanels.length > 0,
        isLoading: requestDetails === undefined && persistedError === undefined
    }));
var $11c75df58ba827a0$export$2e2bcd8739ae039 = (0, $f2mlD.default)($11c75df58ba827a0$var$selector, {
    fetchPortal: (0, $jeW3I.fetchPortalAction),
    fetchRequestDetails: (0, $gXSFL.fetchRequestDetailsModel),
    fetchReqSlas: (0, $c5oCA.fetchReqSlasModelAction),
    changeSubscriptionAction: (0, $gXSFL.changeSubscription)
})((0, $gQxPF.default)((0, $girok.default)));

});
parcelRegister("aXgK2", function(module, exports) {
$parcel$export(module.exports, "getReqSlas", () => (parcelRequire("7YKRB")).getReqSlas);

var $7YKRB = parcelRequire("7YKRB");

});
parcelRegister("7YKRB", function(module, exports) {
$parcel$export(module.exports, "getReqSlas", () => $a86469c2017ba97f$export$65608680bc2b85d0);
const $a86469c2017ba97f$export$65608680bc2b85d0 = (state, requestKey)=>{
    var _state$persisted$reqS;
    return (_state$persisted$reqS = state.persisted.reqSlas) === null || _state$persisted$reqS === void 0 ? void 0 : _state$persisted$reqS[requestKey];
};

});


parcelRegister("c4Ar8", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => (parcelRequire("aF9Z8")).getRequestDetails);
$parcel$export(module.exports, "getError", () => (parcelRequire("aF9Z8")).getError);
$parcel$export(module.exports, "isTransitionDialogVisible", () => (parcelRequire("aF9Z8")).isTransitionDialogVisible);
$parcel$export(module.exports, "isTransactionInProgress", () => (parcelRequire("aF9Z8")).isTransactionInProgress);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => (parcelRequire("aF9Z8")).getReadMediaApiCredentials);
$parcel$export(module.exports, "getTransitionFailure", () => (parcelRequire("aF9Z8")).getTransitionFailure);
$parcel$export(module.exports, "getCommentIsSubmitting", () => (parcelRequire("aF9Z8")).getCommentIsSubmitting);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => (parcelRequire("aF9Z8")).getCommentBeingSubmitted);
$parcel$export(module.exports, "getReporter", () => (parcelRequire("aF9Z8")).getReporter);
$parcel$export(module.exports, "getParticipants", () => (parcelRequire("aF9Z8")).getParticipants);
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("aF9Z8")).getOrganisations);
$parcel$export(module.exports, "getCanRemoveParticipants", () => (parcelRequire("aF9Z8")).getCanRemoveParticipants);
$parcel$export(module.exports, "getCanSearchParticipants", () => (parcelRequire("aF9Z8")).getCanSearchParticipants);
$parcel$export(module.exports, "getCanShareRequest", () => (parcelRequire("aF9Z8")).getCanShareRequest);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => (parcelRequire("aF9Z8")).getCanSubmitWithEmailAddress);
$parcel$export(module.exports, "getInProgressApprovalAction", () => (parcelRequire("aF9Z8")).getInProgressApprovalAction);
$parcel$export(module.exports, "getCanAddComment", () => (parcelRequire("aF9Z8")).getCanAddComment);
$parcel$export(module.exports, "getCanExport", () => (parcelRequire("aF9Z8")).getCanExport);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("aF9Z8")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("aF9Z8")).getIssueTypeId);
$parcel$export(module.exports, "getIssueKey", () => (parcelRequire("aF9Z8")).getIssueKey);
$parcel$export(module.exports, "getIssueId", () => (parcelRequire("aF9Z8")).getIssueId);

var $aF9Z8 = parcelRequire("aF9Z8");

});
parcelRegister("aF9Z8", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => $147cf30e158feed1$export$76e59470e6bca129);
$parcel$export(module.exports, "getError", () => $147cf30e158feed1$export$e1599abf47b5b568);
$parcel$export(module.exports, "isTransactionInProgress", () => $147cf30e158feed1$export$5e8f929af64a353a);
$parcel$export(module.exports, "getTransitionFailure", () => $147cf30e158feed1$export$a047f9f9384611fe);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => $147cf30e158feed1$export$cef4d2d501c0dcdb);
$parcel$export(module.exports, "getCommentIsSubmitting", () => $147cf30e158feed1$export$c18738b22e944190);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => $147cf30e158feed1$export$706d262046c8358f);
$parcel$export(module.exports, "getReporter", () => $147cf30e158feed1$export$e8105f4fd5ecc593);
$parcel$export(module.exports, "getParticipants", () => $147cf30e158feed1$export$ccadfc093764e9cd);
$parcel$export(module.exports, "getOrganisations", () => $147cf30e158feed1$export$17495f9c20464b8);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => $147cf30e158feed1$export$c1d23959dfbf9e60);
$parcel$export(module.exports, "getCanSearchParticipants", () => $147cf30e158feed1$export$1fb693409140fdf8);
$parcel$export(module.exports, "getCanShareRequest", () => $147cf30e158feed1$export$bd1011b4c5e87dfc);
$parcel$export(module.exports, "getCanRemoveParticipants", () => $147cf30e158feed1$export$8e53e7bfa4b4035a);
$parcel$export(module.exports, "getCanAddComment", () => $147cf30e158feed1$export$71d5372270878818);
$parcel$export(module.exports, "isTransitionDialogVisible", () => $147cf30e158feed1$export$5d33edbc6a385b);
$parcel$export(module.exports, "getInProgressApprovalAction", () => $147cf30e158feed1$export$55685a606a2adcb4);
$parcel$export(module.exports, "getIssueType", () => $147cf30e158feed1$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $147cf30e158feed1$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getIssueKey", () => $147cf30e158feed1$export$4a030f6192bebe03);
$parcel$export(module.exports, "getIssueId", () => $147cf30e158feed1$export$b4dd560abafd1fae);
$parcel$export(module.exports, "getCanExport", () => $147cf30e158feed1$export$eda75b639af011cf);
const $147cf30e158feed1$var$getRequestDetailsOrError = (state, requestKey)=>{
    if (requestKey && state.persisted.requestDetails) return state.persisted.requestDetails[requestKey];
    return undefined;
};
const $147cf30e158feed1$export$76e59470e6bca129 = (state, requestKey)=>{
    const data = $147cf30e158feed1$var$getRequestDetailsOrError(state, requestKey);
    return $147cf30e158feed1$var$isError(data) ? undefined : data;
};
const $147cf30e158feed1$var$isError = (data)=>data !== undefined && 'error' in data;
const $147cf30e158feed1$export$e1599abf47b5b568 = (state, requestKey)=>{
    const data = $147cf30e158feed1$var$getRequestDetailsOrError(state, requestKey);
    return $147cf30e158feed1$var$isError(data) ? data : undefined;
};
const $147cf30e158feed1$export$5e8f929af64a353a = (state, transactionId)=>{
    const { inProgressTransitionId: inProgressTransitionId } = state.ui.requestDetails;
    return inProgressTransitionId !== undefined && inProgressTransitionId === transactionId;
};
const $147cf30e158feed1$export$a047f9f9384611fe = (state)=>{
    return state.ui.requestDetails.transitionFailure;
};
const $147cf30e158feed1$export$cef4d2d501c0dcdb = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.readFileMediaCredentials : undefined;
};
const $147cf30e158feed1$export$c18738b22e944190 = (state)=>{
    return state.ui.requestDetails.commentSubmitting;
};
const $147cf30e158feed1$export$706d262046c8358f = (state)=>{
    return state.ui.requestDetails.commentBeingSubmitted;
};
const $147cf30e158feed1$export$e8105f4fd5ecc593 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.reporter : undefined;
};
const $147cf30e158feed1$export$ccadfc093764e9cd = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.participants : undefined;
};
const $147cf30e158feed1$export$17495f9c20464b8 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.organisations : undefined;
};
const $147cf30e158feed1$export$c1d23959dfbf9e60 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSubmitWithEmailAddress : false;
};
const $147cf30e158feed1$export$1fb693409140fdf8 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSearchParticipants : false;
};
const $147cf30e158feed1$export$bd1011b4c5e87dfc = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canShareRequest : false;
};
const $147cf30e158feed1$export$8e53e7bfa4b4035a = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canRemoveParticipants : false;
};
const $147cf30e158feed1$export$71d5372270878818 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canAddComment : false;
};
const $147cf30e158feed1$export$5d33edbc6a385b = (state, id)=>{
    return state.ui.requestDetails.visibleTransitionDialog === id;
};
const $147cf30e158feed1$export$55685a606a2adcb4 = (state)=>{
    return state.ui.requestDetails.inProgressApprovalAction;
};
const $147cf30e158feed1$export$d23b1708046e514c = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return !!(requestDetails !== null && requestDetails !== void 0 && requestDetails.hasProformaForm);
};
const $147cf30e158feed1$export$ed2455632bf977ef = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueTypeName;
};
const $147cf30e158feed1$export$110c9a4a16c5b8c9 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueType;
};
const $147cf30e158feed1$export$4a030f6192bebe03 = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.key;
};
const $147cf30e158feed1$export$b4dd560abafd1fae = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.id;
};
const $147cf30e158feed1$export$eda75b639af011cf = (state, requestKey)=>{
    const requestDetails = $147cf30e158feed1$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.issue.canExport : false;
};

});


parcelRegister("6NtVd", function(module, exports) {
$parcel$export(module.exports, "getIssueAnalyticsContext", () => $a74c49f6e2cda250$export$fe0282397d97e2a6);
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
const $a74c49f6e2cda250$export$fe0282397d97e2a6 = (state, portalId)=>({
        user: {
            getAgentForPortal: ()=>(0, $fBLyB.getAgentForPortal)(state),
            getAccountId: ()=>(0, $fBLyB.getAccountId)(state)
        },
        portal: {
            getPortalAnnouncement: ()=>({
                    getCanAdministerProject: ()=>(0, $iWhHo.getCanAdministerProject)(state, portalId)
                })
        }
    });

});

parcelRegister("girok", function(module, exports) {
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_RESULT_QUERY_PARAM", () => $38ed3548b6e22e16$export$491313a4e8829a1a);
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_QUERY_PARAM_SUCCESS", () => $38ed3548b6e22e16$export$fddfe2b6ca9cfe5c);
$parcel$export(module.exports, "default", () => $38ed3548b6e22e16$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $87QgR = parcelRequire("87QgR");

var $fFr9c = parcelRequire("fFr9c");

var $fK3tS = parcelRequire("fK3tS");

var $gEVth = parcelRequire("gEVth");

var $5LmQo = parcelRequire("5LmQo");
parcelRequire("lVOVX");
var $jETIR = parcelRequire("jETIR");
var $eAsHJ = parcelRequire("eAsHJ");
parcelRequire("dukrJ");
var $c2Ttn = parcelRequire("c2Ttn");

var $ijVA1 = parcelRequire("ijVA1");

var $7VUtk = parcelRequire("7VUtk");
const $38ed3548b6e22e16$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS = 'jsm-sla-in-portal-request-details';
const $38ed3548b6e22e16$export$491313a4e8829a1a = 'approval';
const $38ed3548b6e22e16$export$fddfe2b6ca9cfe5c = '200';
class $38ed3548b6e22e16$export$1ec22ccbfe26843b extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchRequestDetails: fetchRequestDetails, fetchReqSlas: fetchReqSlas, requestKey: key } = this.props;
        fetchRequestDetails({
            key: key,
            portalId: Number(portalId),
            ...(0, $87QgR.default).checkGate('assets_custom_fields_limit_increase_ga') ? {
                expand: [
                    'cmdbLazyDetails'
                ]
            } : {}
        });
        fetchPortal({
            id: Number(portalId),
            expand: [
                'analyticsContext'
            ]
        });
        if ((0, $87QgR.default).checkGate($38ed3548b6e22e16$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS)) fetchReqSlas({
            key: key
        });
        this.trackIssueViewed();
        this.setState({
            isApprovalError: this.checkIfApprovalError()
        });
    }
    componentDidUpdate(prevProps) {
        const { portal: portal, requestDetails: requestDetails, reqSlas: reqSlas } = this.props;
        if (portal && portal.analyticAttributes && requestDetails && (!(0, $87QgR.default).checkGate($38ed3548b6e22e16$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS) || reqSlas) && !requestDetails.userMentionedDuringRequestCreation) {
            var _prevProps$reqSlas;
            if (!prevProps.portal || !prevProps.portal.analyticAttributes || !prevProps.requestDetails || (0, $87QgR.default).checkGate($38ed3548b6e22e16$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS) && !prevProps.reqSlas) this.trackIssueViewed();
            else if (portal.id !== prevProps.portal.id || requestDetails.issue.id !== prevProps.requestDetails.issue.id || (0, $87QgR.default).checkGate($38ed3548b6e22e16$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS) && ((_prevProps$reqSlas = prevProps.reqSlas) === null || _prevProps$reqSlas === void 0 ? void 0 : _prevProps$reqSlas.length) !== (reqSlas === null || reqSlas === void 0 ? void 0 : reqSlas.length)) this.trackIssueViewed();
        }
    }
    trackIssueViewed() {
        const { portal: portal, requestDetails: requestDetails, issueAnalyticsContext: issueAnalyticsContext, reqSlas: reqSlas } = this.props;
        const isSlaEnabled = (0, $87QgR.default).checkGate($38ed3548b6e22e16$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS);
        if (!portal || !portal.analyticAttributes || !requestDetails || isSlaEnabled && !reqSlas) return;
        const { issue: issue, issueType: issueType, workflowTransitions: workflowTransitions } = requestDetails;
        const { requestTypeId: requestTypeId, id: issueId } = issue;
        const customerTransitionIds = workflowTransitions ? workflowTransitions.map((transition)=>transition.id) : undefined;
        const renderedSlaCount = (reqSlas === null || reqSlas === void 0 ? void 0 : reqSlas.length) ?? 0;
        (0, $gEVth.trackIssueEvent)({
            issueId: issueId,
            projectId: String(portal.projectId),
            action: 'viewed',
            attributes: {
                customerTransitionIds: customerTransitionIds,
                numberOfCustomerTransitionIds: customerTransitionIds && customerTransitionIds.length,
                portalId: String(portal.id),
                issueTypeId: issueType,
                requestTypeId: String(requestTypeId),
                ...isSlaEnabled ? {
                    renderedSlaCount: renderedSlaCount,
                    hasRenderedSla: renderedSlaCount > 0
                } : {},
                ...portal.analyticAttributes
            }
        }, issueAnalyticsContext.user, issueAnalyticsContext.portal);
    }
    render() {
        var _this$props$portal, _requestDetails$appro2;
        const { isApprovalError: isApprovalError } = this.state;
        const { requestDetails: requestDetails, reqSlas: reqSlas, isLoading: isLoading, portalName: portalName, requestKey: requestKey, portal: portal, hasConnectPanels: hasConnectPanels, isProjectAdmin: isProjectAdmin } = this.props;
        const serviceDeskId = Number(portal === null || portal === void 0 ? void 0 : portal.serviceDeskId);
        const portalId = Number(this.props.portalId);
        const projectId = Number(portal === null || portal === void 0 ? void 0 : portal.projectId);
        const projectKey = (_this$props$portal = this.props.portal) === null || _this$props$portal === void 0 ? void 0 : _this$props$portal.projectKey;
        const isAtlassianManagedAccount = this.props.isAtlassianManagedAccount;
        const shouldShowLearnByDoingExperimentBanner = (0, $eAsHJ.shouldShowLearnByDoingBanner)(isProjectAdmin, $5LmQo.get((0, $jETIR.REFERRER_QUERY_PARAM)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, isApprovalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c2Ttn.default), {
            approvalError: this.getApprovalError(),
            hasDecision: (requestDetails === null || requestDetails === void 0 || (_requestDetails$appro2 = requestDetails.approvalStatus[0]) === null || _requestDetails$appro2 === void 0 || (_requestDetails$appro2 = _requestDetails$appro2.decision) === null || _requestDetails$appro2 === void 0 ? void 0 : _requestDetails$appro2.decision) !== undefined,
            onDismissError: this.onDismissError
        }) : [], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7VUtk.default), {
            requestDetails: requestDetails,
            reqSlas: reqSlas,
            isLoading: isLoading,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            serviceDeskId: serviceDeskId,
            portalId: portalId,
            projectId: projectId,
            requestKey: requestKey,
            onNotificationChange: this.onNotificationChange,
            portalName: portalName,
            hasConnectPanels: hasConnectPanels,
            detailsHiddenOnInitialView: !!this.detailsHiddenOnInitialView,
            activityItemsHiddenOnInitialView: !!this.activityItemsHiddenOnInitialView,
            removeOldParticipantsAndReporterFromComment: this.removeOldParticipantsAndReporterFromComment,
            projectKey: projectKey,
            shouldShowLearnByDoingExperimentBanner: shouldShowLearnByDoingExperimentBanner
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isApprovalError: false
        }, this.onNotificationChange = (shouldSubscribe)=>{
            const { requestDetails: requestDetails, changeSubscriptionAction: changeSubscriptionAction } = this.props;
            if (requestDetails) changeSubscriptionAction(requestDetails.key, requestDetails.issue.id, shouldSubscribe);
        }, this.checkIfApprovalError = ()=>{
            return !!$5LmQo.get($38ed3548b6e22e16$export$491313a4e8829a1a) && $5LmQo.get($38ed3548b6e22e16$export$491313a4e8829a1a) !== $38ed3548b6e22e16$export$fddfe2b6ca9cfe5c;
        }, this.getApprovalError = ()=>{
            return this.checkIfApprovalError() ? $5LmQo.get($38ed3548b6e22e16$export$491313a4e8829a1a) : undefined;
        }, this.onDismissError = ()=>{
            this.setState({
                isApprovalError: false
            });
        }, this.removeOldParticipantsAndReporterFromComment = (accountIds)=>{
            const requestDetails = this.props.requestDetails;
            if (requestDetails) {
                const { participants: participants, reporter: reporter } = requestDetails;
                /* Removing user mentions which should not be added as request participants */ (reporter === null || reporter === void 0 ? void 0 : reporter.accountId) && accountIds.delete(reporter === null || reporter === void 0 ? void 0 : reporter.accountId);
                participants.forEach((participant)=>accountIds.delete(participant.accountId));
            }
            return accountIds;
        }, this.getFlagTitleAndDescription = ()=>{
            var _requestDetails$appro;
            // Error messages for approve by email
            const { intl: intl, requestDetails: requestDetails } = this.props;
            const decision = requestDetails === null || requestDetails === void 0 || (_requestDetails$appro = requestDetails.approvalStatus[0]) === null || _requestDetails$appro === void 0 || (_requestDetails$appro = _requestDetails$appro.decision) === null || _requestDetails$appro === void 0 ? void 0 : _requestDetails$appro.decision;
            switch($5LmQo.get($38ed3548b6e22e16$export$491313a4e8829a1a)){
                case '400':
                    if (decision) // if decision already made
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    // if misspelling in url
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    // if approver has been removed as approver by admin
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription403)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitleDefault, {
                            value: $5LmQo.get($38ed3548b6e22e16$export$491313a4e8829a1a) ?? ''
                        }),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $38ed3548b6e22e16$export$2e2bcd8739ae039 = (0, $fFr9c.withErrorPage)((0, $fK3tS.default)($38ed3548b6e22e16$export$1ec22ccbfe26843b));

});
parcelRegister("dukrJ", function(module, exports) {
$parcel$export(module.exports, "ApprovalErrorFlag", () => (parcelRequire("c2Ttn")).default);

var $c2Ttn = parcelRequire("c2Ttn");

});
parcelRegister("c2Ttn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5c0880611b66a0a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $cBVmT = parcelRequire("cBVmT");

var $ijVA1 = parcelRequire("ijVA1");
class $c5c0880611b66a0a$export$15f2320c01f1c048 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { approvalError: approvalError, onDismissError: onDismissError, intl: intl } = this.props;
        const { title: title, description: description } = this.getFlagTitleAndDescription();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lJzMO.default), {
            onDismissed: onDismissError
        }, approvalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2bmUD.default), {
            id: "approve-by-email-fail-approve-error-flag",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #BF2600)",
                label: ""
            }),
            title: title,
            description: description,
            actions: [
                {
                    content: intl.formatMessage((0, $ijVA1.default).dismiss),
                    onClick: ()=>onDismissError()
                }
            ]
        }) : []);
    }
    constructor(...args){
        super(...args), this.getFlagTitleAndDescription = ()=>{
            const { intl: intl, hasDecision: hasDecision, approvalError: approvalError } = this.props;
            switch(approvalError){
                case '400':
                    if (hasDecision) return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription403)
                    };
                case '404':
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle404),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription404)
                    };
                case '409':
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitle409),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescription409)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagTitleDefault, {}),
                        description: intl.formatMessage((0, $ijVA1.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $c5c0880611b66a0a$export$2e2bcd8739ae039 = (0, $fK3tS.default)($c5c0880611b66a0a$export$15f2320c01f1c048);

});
parcelRegister("ijVA1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3562aa72e042f4e$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e3562aa72e042f4e$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    dismiss: {
        defaultMessage: 'Dismiss',
        description: 'Label for the button that dismisses the approval error flag',
        id: 'cv.request.details.approve.by.email.approval.error.dismiss.flag.message'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_1: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_1: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page.',
        description: 'Description for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_2: {
        defaultMessage: 'You no longer need to approve or decline',
        description: 'Title for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_2: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_2'
    },
    approvalByEmailErrorFlagTitle403: {
        defaultMessage: 'You need permission to approve this request',
        description: 'Title for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.title401'
    },
    approvalByEmailErrorFlagDescription403: {
        defaultMessage: `Ask your admin if you\u{2019}re on the approvers list, or check that you\u{2019}re logged in with the right account.`,
        description: 'Description for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.description401'
    },
    approvalByEmailErrorFlagTitle404: {
        defaultMessage: `We couldn\u{2019}t update the request`,
        description: 'Title for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.title404'
    },
    approvalByEmailErrorFlagDescription404: {
        defaultMessage: 'This request no longer needs approval. It may have been updated or deleted.',
        description: 'Description for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.description404'
    },
    approvalByEmailErrorFlagTitle409: {
        defaultMessage: 'Approval not required',
        description: 'Title for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.title409'
    },
    approvalByEmailErrorFlagDescription409: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.description409'
    },
    approvalByEmailErrorFlagTitleDefault: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.title.default'
    },
    approvalByEmailErrorFlagDescriptionDefault: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page if available, or try again later.',
        description: 'Description for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.description.default'
    }
});

});



parcelRegister("7VUtk", function(module, exports) {
$parcel$export(module.exports, "default", () => $58fc69f047ecc07b$export$2e2bcd8739ae039);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $58fc69f047ecc07b$var$loader = (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("bRMuo")), {
    moduleId: "./src/view/request-details/request-details-stateless/request-details-stateless.tsx"
});
var $58fc69f047ecc07b$export$2e2bcd8739ae039 = (0, $cVM5r.default)({
    loader: $58fc69f047ecc07b$var$loader
});

});
parcelRegister("bRMuo", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("jdLWQ"),
    $kOunM("jsKIl"),
    $kOunM("cYVl6"),
    $kOunM("4c4Ay"),
    $kOunM("77U2l"),
    $kOunM("92sIe"),
    $kOunM("coIBk"),
    $kOunM("aHc5N"),
    $kOunM("esjBs"),
    $kOunM("gsQwM"),
    $kOunM("0xsmf")
]).then(()=>parcelRequire('dymDT'));

});






parcelRegister("ab40o", function(module, exports) {
$parcel$export(module.exports, "userSignupRoute", () => $c0a86db6828b9832$export$6c53daec3917ca4f);
$parcel$export(module.exports, "userResetPasswordRoute", () => $c0a86db6828b9832$export$a1ff4b1e673ba98c);
$parcel$export(module.exports, "userCompleteSignupRoute", () => $c0a86db6828b9832$export$61da5e60a0c99a8a);
$parcel$export(module.exports, "userCheckMailRoute", () => $c0a86db6828b9832$export$934c0e27338aac46);
$parcel$export(module.exports, "portalSignupRoute", () => $c0a86db6828b9832$export$766487cfd72c58e6);
$parcel$export(module.exports, "portalResetPasswordRoute", () => $c0a86db6828b9832$export$a52bd3b0b1b1499b);
$parcel$export(module.exports, "portalCompleteSignupRoute", () => $c0a86db6828b9832$export$c0d26476c776bd62);
$parcel$export(module.exports, "portalInvitedSignupRoute", () => $c0a86db6828b9832$export$124a02da2ab0bcaf);

var $jcRK7 = parcelRequire("jcRK7");

var $1bpMm = parcelRequire("1bpMm");

var $daink = parcelRequire("daink");

var $8Gx81 = parcelRequire("8Gx81");

var $datpo = parcelRequire("datpo");

var $17hHF = parcelRequire("17hHF");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");
const $c0a86db6828b9832$var$userSignup = {
    resources: [],
    name: 'user-signup',
    path: `/user/signup`,
    exact: true,
    component: (0, $datpo.SignUp)
};
const $c0a86db6828b9832$var$userResetPassword = {
    resources: [],
    name: 'user-reset-password',
    path: `/user/resetpassword`,
    exact: true,
    component: (0, $8Gx81.ResetPassword)
};
const $c0a86db6828b9832$var$userCompleteSignup = {
    resources: [],
    name: 'user-complete-signup',
    path: `/user/complete-signup`,
    exact: true,
    component: (0, $1bpMm.CompleteSignup)
};
const $c0a86db6828b9832$var$userCheckMail = {
    resources: [],
    name: 'user-checkmail',
    path: `/user/check-email`,
    exact: true,
    component: (0, $17hHF.CheckEmail)
};
const $c0a86db6828b9832$var$portalSignup = {
    resources: [],
    name: 'portal-signup',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/signup`,
    exact: true,
    component: (0, $datpo.SignUp)
};
const $c0a86db6828b9832$var$portalResetPassword = {
    resources: [],
    name: 'portal-reset-password',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
    exact: true,
    component: (0, $8Gx81.ResetPassword)
};
const $c0a86db6828b9832$var$portalCompleteSignup = {
    resources: [],
    name: 'portal-complete-signup',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
    exact: true,
    component: (0, $1bpMm.CompleteSignup)
};
const $c0a86db6828b9832$var$portalInvitedSignup = {
    resources: [],
    name: 'portal-invited-signup',
    path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
    exact: true,
    component: (0, $daink.InvitedSignUp)
};
const $c0a86db6828b9832$var$signUpScreenName = (0, $jcRK7.ScreenName).SIGNUP;
const $c0a86db6828b9832$export$6c53daec3917ca4f = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$userSignup, $c0a86db6828b9832$var$signUpScreenName, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$a1ff4b1e673ba98c = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$userResetPassword, (0, $jcRK7.ScreenName).RESET_PASSWORD, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$61da5e60a0c99a8a = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$userCompleteSignup, (0, $jcRK7.ScreenName).COMPLETE_SIGNUP, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$934c0e27338aac46 = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$userCheckMail, (0, $jcRK7.ScreenName).CHECK_EMAIL, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$766487cfd72c58e6 = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$portalSignup, $c0a86db6828b9832$var$signUpScreenName, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$a52bd3b0b1b1499b = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$portalResetPassword, (0, $jcRK7.ScreenName).RESET_PASSWORD, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$c0d26476c776bd62 = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$portalCompleteSignup, (0, $jcRK7.ScreenName).COMPLETE_SIGNUP, (0, $fZKGh.anonymousScreenLayout));
const $c0a86db6828b9832$export$124a02da2ab0bcaf = (0, $bkEWh.createRouteWithLayout)($c0a86db6828b9832$var$portalInvitedSignup, (0, $jcRK7.ScreenName).INVITED_SIGNUP, (0, $fZKGh.anonymousScreenLayout));

});
parcelRegister("1bpMm", function(module, exports) {
$parcel$export(module.exports, "CompleteSignup", () => $eb0441278a072728$export$372770c8487ebcca);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $eb0441278a072728$export$372770c8487ebcca = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("h2OIi")), {
        moduleId: "./src/view/complete-signup/hocs.tsx"
    })
});

});
parcelRegister("h2OIi", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("QNG7B").then(()=>parcelRequire('4e5e8'));

});


parcelRegister("daink", function(module, exports) {
$parcel$export(module.exports, "InvitedSignUp", () => $8be7ce4cdcd595ba$export$b6f2cb2bcdfbfdb9);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $8be7ce4cdcd595ba$export$b6f2cb2bcdfbfdb9 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("6nLnr")), {
        moduleId: "./src/view/invited-sign-up/hocs.tsx"
    })
});

});
parcelRegister("6nLnr", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hgU96").then(()=>parcelRequire('lghz2'));

});


parcelRegister("8Gx81", function(module, exports) {
$parcel$export(module.exports, "ResetPassword", () => $7ae2bf3a6f47b0d9$export$a4c3d56613a57187);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $7ae2bf3a6f47b0d9$export$a4c3d56613a57187 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1TqNA")), {
        moduleId: "./src/view/reset-password/hocs.tsx"
    })
});

});
parcelRegister("1TqNA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("e3tlY").then(()=>parcelRequire('9TxQ6'));

});


parcelRegister("datpo", function(module, exports) {
$parcel$export(module.exports, "SignUp", () => $d23e61b1c90fe76d$export$4ee457d816cea81a);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $d23e61b1c90fe76d$export$4ee457d816cea81a = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("anlFK")), {
        moduleId: "./src/view/sign-up/hocs.tsx"
    })
});

});
parcelRegister("anlFK", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3AMf8").then(()=>parcelRequire('1E2JP'));

});


parcelRegister("17hHF", function(module, exports) {
$parcel$export(module.exports, "CheckEmail", () => $cb0a98efb720b083$export$fd89248056ed5439);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $cb0a98efb720b083$export$fd89248056ed5439 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("fjfGw")), {
        moduleId: "./src/view/sign-up-check-email/hocs.tsx"
    })
});

});
parcelRegister("fjfGw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("Rl3Dp").then(()=>parcelRequire('8FGhJ'));

});



parcelRegister("2ylQX", function(module, exports) {
$parcel$export(module.exports, "getViewTopicRoute", () => $21c318e748b36895$export$8c8c8d8cda238e84);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $jCkxO = parcelRequire("jCkxO");

var $d4Q5c = parcelRequire("d4Q5c");

var $bkEWh = parcelRequire("bkEWh");
var $3LQyI = parcelRequire("3LQyI");

var $68Ik8 = parcelRequire("68Ik8");
const $21c318e748b36895$var$PageLoader = ()=>{
    const [{ match: { params: { id: id } } }] = (0, $h1bGI.useRouter)();
    (0, $jCkxO.default)(id);
    const { queryReference: queryReference } = (0, $3LQyI.useRelayResource)((0, $68Ik8.viewTopicResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $d4Q5c.ViewTopic), {
        topicId: id,
        queryReference: queryReference
    });
};
const $21c318e748b36895$export$8c8c8d8cda238e84 = ()=>{
    const paperAppearance = (0, $lFpPv.isUseHelpCenterRefresh)() ? 'xwide' : 'normal';
    const layoutProps = {
        paperAppearance: paperAppearance,
        fadeInSearchModal: true
    };
    return (0, $bkEWh.createRouteWithLayout)({
        name: 'view-topic',
        path: '/topic/:id',
        exact: true,
        component: $21c318e748b36895$var$PageLoader,
        resources: [
            (0, $68Ik8.viewTopicResource)
        ]
    }, (0, $jcRK7.ScreenName).VIEW_TOPIC, layoutProps);
};

});
parcelRegister("d4Q5c", function(module, exports) {
$parcel$export(module.exports, "ViewTopic", () => $7126d98964ca3a8f$export$8036aeb45d373d7d);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $7126d98964ca3a8f$var$loader = (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("9VcpG")), {
    moduleId: "./src/view/topic/topic.tsx"
});
const $7126d98964ca3a8f$export$8036aeb45d373d7d = (0, $cVM5r.default)({
    loader: $7126d98964ca3a8f$var$loader
});

});
parcelRegister("9VcpG", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6AYIJ"),
    $kOunM("2OKk0")
]).then(()=>parcelRequire('4RgXO'));

});


parcelRegister("68Ik8", function(module, exports) {
$parcel$export(module.exports, "viewTopicResource", () => $d50152cd3c862350$export$425f51060493cc67);

var $go9KO = parcelRequire("go9KO");

var $3LQyI = parcelRequire("3LQyI");
const $d50152cd3c862350$export$425f51060493cc67 = (0, $3LQyI.createRelayResource)({
    type: 'VIEW_TOPIC',
    getQuery: ({ match: { params: { id: id } } }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $go9KO.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                topicId: String(id)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("go9KO", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb92d35646ddc271$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04f0af7279f78d72dbeae49d34853aac>>
 * @relayHash ebbdf9e39eabac61b9f8917e5b0cac0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1
const $cb92d35646ddc271$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "topicId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "description"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v6 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "topicQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "helpCenterTopic_HelpCenterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "topicQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "helpCenterAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "topicId",
                                    "variableName": "topicId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterTopicById",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "HelpCenterTopicItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterTopicItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "ari"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isHelpCenterHelpObject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "HelpObjectStoreIcon",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "icon",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreRequestForm"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreArticle"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreChannel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ],
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        }
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "items(first:10)"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "mainHelpObjectsList_HelpCenterTopic_items",
                                            "kind": "LinkedHandle",
                                            "name": "items"
                                        }
                                    ],
                                    "type": "HelpCenterTopic"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1",
            "metadata": {},
            "name": "topicQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cb92d35646ddc271$var$node.hash = "aad6fa68f7fdec1c20c0311c482bf40f";
var $cb92d35646ddc271$export$2e2bcd8739ae039 = $cb92d35646ddc271$var$node;

});



parcelRegister("bcBh3", function(module, exports) {
$parcel$export(module.exports, "userVerifyEmailRoute", () => $40c02d647705b81b$export$421ececb54aacf4e);

var $jcRK7 = parcelRequire("jcRK7");

var $hulJF = parcelRequire("hulJF");

var $bkEWh = parcelRequire("bkEWh");

var $fZKGh = parcelRequire("fZKGh");
const $40c02d647705b81b$var$userVerifyEmail = {
    resources: [],
    name: 'verify-email',
    path: `/user/verify-email`,
    exact: true,
    component: (0, $hulJF.VerifyEmail)
};
const $40c02d647705b81b$export$421ececb54aacf4e = (0, $bkEWh.createRouteWithLayout)($40c02d647705b81b$var$userVerifyEmail, (0, $jcRK7.ScreenName).VERIFY_EMAIL, (0, $fZKGh.anonymousScreenLayout));

});
parcelRegister("hulJF", function(module, exports) {
$parcel$export(module.exports, "VerifyEmail", () => $c10e6a8d94471969$export$3d3197b723615cc);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $c10e6a8d94471969$export$3d3197b723615cc = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("1wy3w")), {
        moduleId: "./src/view/verify-email/hocs.tsx"
    })
});

});
parcelRegister("1wy3w", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fdOEX").then(()=>parcelRequire('buUJi'));

});



parcelRegister("8VdVQ", function(module, exports) {
$parcel$export(module.exports, "UFOWatcher", () => $54a300cff2380da3$export$261b8a18a570aef7);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $juFEH = parcelRequire("juFEH");

var $Cxhdp = parcelRequire("Cxhdp");

var $69yG9 = parcelRequire("69yG9");

var $6RHlg = parcelRequire("6RHlg");

var $8r0fo = parcelRequire("8r0fo");
const $54a300cff2380da3$var$INTERESTING_RESOURCE_PATTERNS = [
    {
        spanLabel: 'jsapi.js',
        regEx: /\/jsapi\.js/
    },
    {
        spanLabel: 'challenge.js',
        regEx: /\/challenge\.js/
    },
    {
        spanLabel: 'vendor-react.chunk.js',
        regEx: /\/vendor-react\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-vendor.chunk.js',
        regEx: /\/servicedesk-vendor\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-atlaskit.chunk.js',
        regEx: /\/servicedesk-atlaskit\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'compiled-css.chunk.js',
        regEx: /\/compiled-css\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-customerportal.bundle.js',
        regEx: /\/servicedesk-customerportal\.bundle\..{0,64}js/
    }
];
function $54a300cff2380da3$var$addResourceTimingsToUFO() {
    var _globalThis$performan, _globalThis$performan2;
    ((_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 ? void 0 : _globalThis$performan.getEntriesByType) && Array.from((_globalThis$performan2 = globalThis.performance) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2.getEntriesByType('resource')).forEach((entry)=>{
        for (const resource of $54a300cff2380da3$var$INTERESTING_RESOURCE_PATTERNS)if (resource.regEx.test(entry.name)) (0, $juFEH.addSpanToAll)('fetch', resource.spanLabel, [
            {
                name: 'custom-network'
            },
            {
                name: 'resources'
            }
        ], entry.startTime, entry.startTime + entry.duration);
    });
}
const $54a300cff2380da3$export$261b8a18a570aef7 = ()=>{
    const isInitial = (0, $bSJIT.useRef)(true);
    const [routerState] = (0, $h1bGI.useRouter)();
    const route = routerState.route;
    const match = routerState.match;
    let ufoName = (0, $Cxhdp.default)(route).toLowerCase();
    if ('getUFONameBasedOnRouteMatch' in route && route.getUFONameBasedOnRouteMatch instanceof Function) ufoName = route.getUFONameBasedOnRouteMatch(match);
    const lastUFOName = (0, $bSJIT.useRef)(ufoName);
    if (ufoName) {
        if ((0, $lFpPv.isUiModificationsSupportEnabled)() && ufoName === (0, $jcRK7.ExperienceName).REQUEST_CREATE) (0, $8r0fo.startScreenTTIWithUIModifications)();
        if (isInitial.current) {
            $54a300cff2380da3$var$addResourceTimingsToUFO();
            (0, $69yG9.default)(ufoName);
            isInitial.current = false;
        }
        if (lastUFOName.current !== ufoName && !isInitial.current) {
            lastUFOName.current = ufoName;
            (0, $6RHlg.default)(ufoName);
        }
    }
    return null;
};

});
parcelRegister("Cxhdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee5ccc13075d616f$export$2e2bcd8739ae039);
function $ee5ccc13075d616f$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $ee5ccc13075d616f$export$2e2bcd8739ae039 = $ee5ccc13075d616f$var$getUFORouteName;

});

parcelRegister("69yG9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a90b34e599f614e$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $7RHfd = parcelRequire("7RHfd");

var $actRr = parcelRequire("actRr");

var $aae7p = parcelRequire("aae7p");

var $dH1v3 = parcelRequire("dH1v3");

var $3GoE4 = parcelRequire("3GoE4");

var $juFEH = parcelRequire("juFEH");

var $lIf8L = parcelRequire("lIf8L");

const $4a90b34e599f614e$export$8851ca06c4e629aa = 'awaiting_pageload_name';
function $4a90b34e599f614e$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $aae7p.isUFOEnabled)()) return;
    const activeInteraction = (0, $juFEH.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $lIf8L.default).current = routeName || null;
    const rate = ufoName ? (0, $aae7p.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $actRr.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $7RHfd.default)();
        (0, $3GoE4.default).current = newId;
        (0, $juFEH.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $dH1v3.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $juFEH.addHoldByID)(newId, [], $4a90b34e599f614e$export$8851ca06c4e629aa, $4a90b34e599f614e$export$8851ca06c4e629aa, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $juFEH.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $juFEH.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $juFEH.removeHoldByID)(activeInteraction.id, $4a90b34e599f614e$export$8851ca06c4e629aa);
    }
}
var $4a90b34e599f614e$export$2e2bcd8739ae039 = $4a90b34e599f614e$var$traceUFOPageLoad;

});

parcelRegister("6RHlg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a871010abbc28cbc$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $7RHfd = parcelRequire("7RHfd");

var $actRr = parcelRequire("actRr");

var $aae7p = parcelRequire("aae7p");

var $dH1v3 = parcelRequire("dH1v3");

var $3GoE4 = parcelRequire("3GoE4");

var $juFEH = parcelRequire("juFEH");

var $lIf8L = parcelRequire("lIf8L");

var $2pYOo = parcelRequire("2pYOo");
function $a871010abbc28cbc$var$traceUFOTransition(ufoName, routeName = ufoName, preloadKey) {
    if (!(0, $aae7p.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $aae7p.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $juFEH.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $juFEH.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $lIf8L.default).current = ufoName;
        const rate = (0, $aae7p.getInteractionRate)(ufoName, 'transition');
        if ((0, $actRr.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $7RHfd.default)();
            (0, $2pYOo.setInteractionActiveTrace)(newId);
            (0, $3GoE4.default).current = newId;
            (0, $juFEH.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $dH1v3.getActiveTrace)(), preloadKey);
        }
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a871010abbc28cbc$export$2e2bcd8739ae039 = $a871010abbc28cbc$var$traceUFOTransition;

});
parcelRegister("2pYOo", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $4391fa0575b5d93c$export$f2e521e495a88544);

var $JuT7H = parcelRequire("JuT7H");

var $ens7j = parcelRequire("ens7j");
function $4391fa0575b5d93c$export$f2e521e495a88544(newId) {
    (0, $JuT7H.setActiveTrace)(newId.replace(/-/g, ''), (0, $ens7j.generateSpanId)(), 'transition');
}

});
parcelRegister("ens7j", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $59bcab3c9f7a1c54$export$295213bc4d0c54ad);
function $59bcab3c9f7a1c54$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});




parcelRegister("i7Znb", function(module, exports) {
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => (parcelRequire("eV8mZ")).getAnonymousRequestSuccessRouteWithHubShell);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCheckEmailRouteWithHubShell);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmContactUsRouteWithHubShell);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmFolderRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmViewArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmViewCrossSiteArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmViewCrossSitePortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => (parcelRequire("eV8mZ")).getCsmViewPortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getHubAllSearchResultsRouteWithHubShell", () => (parcelRequire("eV8mZ")).getHubAllSearchResultsRouteWithHubShell);
$parcel$export(module.exports, "getHubCustompageRoute", () => (parcelRequire("eV8mZ")).getHubCustompageRoute);
$parcel$export(module.exports, "getHubHomepageRoute", () => (parcelRequire("eV8mZ")).getHubHomepageRoute);
$parcel$export(module.exports, "getHubPortalPageRoute", () => (parcelRequire("eV8mZ")).getHubPortalPageRoute);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => (parcelRequire("eV8mZ")).getHubUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getHubViewArticleRoute", () => (parcelRequire("eV8mZ")).getHubViewArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => (parcelRequire("eV8mZ")).getHubViewCrossSiteArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => (parcelRequire("eV8mZ")).getHubViewCrossSitePortalArticleRoute);
$parcel$export(module.exports, "getHubViewKbRoute", () => (parcelRequire("eV8mZ")).getHubViewKbRoute);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => (parcelRequire("eV8mZ")).getHubViewPortalArticleRoute);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => (parcelRequire("eV8mZ")).getJsmApprovalsRouteWithHubShell);
$parcel$export(module.exports, "getJsmManageColumnsRequestsListRouteWithHubShell", () => (parcelRequire("eV8mZ")).getJsmManageColumnsRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => (parcelRequire("eV8mZ")).getJsmRequestApprovalRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => (parcelRequire("eV8mZ")).getJsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestsListRouteWithHubShell", () => (parcelRequire("eV8mZ")).getJsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => (parcelRequire("eV8mZ")).getLoginRouteWithHubShell);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => (parcelRequire("eV8mZ")).getNotFoundRouteWithHubShell);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => (parcelRequire("eV8mZ")).getPortalAccessForbiddenRouteWithHubShell);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => (parcelRequire("eV8mZ")).getPortalCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => (parcelRequire("eV8mZ")).getPortalInvitedSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => (parcelRequire("eV8mZ")).getPortalLoginRouteWithHubShell);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => (parcelRequire("eV8mZ")).getPortalResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => (parcelRequire("eV8mZ")).getPortalSignupRouteWithHubShell);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => (parcelRequire("eV8mZ")).getRequestCreateRouteWithHubShell);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => (parcelRequire("eV8mZ")).getRequestFeedbackRouteWithHubShell);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => (parcelRequire("eV8mZ")).getResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => (parcelRequire("eV8mZ")).getSignupRouteWithHubShell);
$parcel$export(module.exports, "getSurveyRouteWithHubShell", () => (parcelRequire("eV8mZ")).getSurveyRouteWithHubShell);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => (parcelRequire("eV8mZ")).getUnsubscribeRouteWithHubShell);
$parcel$export(module.exports, "isJsmHubCustomizeMenuEnabled", () => (parcelRequire("eV8mZ")).isJsmHubCustomizeMenuEnabled);
parcelRequire("eV8mZ");

});
parcelRegister("eV8mZ", function(module, exports) {
$parcel$export(module.exports, "isJsmHubCustomizeMenuEnabled", () => $60a84c11cc066f79$export$fa8c03dea1d273a4);
$parcel$export(module.exports, "getHubHomepageRoute", () => $60a84c11cc066f79$export$3b1658f4569bf0ca);
$parcel$export(module.exports, "getHubCustompageRoute", () => $60a84c11cc066f79$export$737d1198516688ea);
$parcel$export(module.exports, "getHubPortalPageRoute", () => $60a84c11cc066f79$export$561a9432cf020904);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => $60a84c11cc066f79$export$2a2a6f715f782520);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => $60a84c11cc066f79$export$2a6efc2e2d50dd68);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => $60a84c11cc066f79$export$d59699c7220ea7d4);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => $60a84c11cc066f79$export$c8e491027fcd76d5);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => $60a84c11cc066f79$export$7e31411194771e76);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => $60a84c11cc066f79$export$eb078274575814fa);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => $60a84c11cc066f79$export$8628a4d0641114fc);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => $60a84c11cc066f79$export$d23db2e306b7fa10);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => $60a84c11cc066f79$export$df37fdf84c1e0c73);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => $60a84c11cc066f79$export$9bd8f060725abce6);
$parcel$export(module.exports, "getHubViewArticleRoute", () => $60a84c11cc066f79$export$215c0eb21c8c9bbd);
$parcel$export(module.exports, "getHubViewKbRoute", () => $60a84c11cc066f79$export$fe3b3b72e1ee1e3);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => $60a84c11cc066f79$export$276f7d60ee8fa12a);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => $60a84c11cc066f79$export$3e0c0cee1ca6ead0);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => $60a84c11cc066f79$export$a2895ad4defdb0c4);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => $60a84c11cc066f79$export$3677170bee4c0cc5);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => $60a84c11cc066f79$export$c80d2e838cbb1b16);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => $60a84c11cc066f79$export$a60f6f9ee1a764cc);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => $60a84c11cc066f79$export$d0572cd96b5c4ab4);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => $60a84c11cc066f79$export$cfbf23f65634d193);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => $60a84c11cc066f79$export$ab61a9d90fe1a668);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => $60a84c11cc066f79$export$af956eb6d34eabf5);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => $60a84c11cc066f79$export$ec03abb34db753b9);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => $60a84c11cc066f79$export$176415cbffecf519);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => $60a84c11cc066f79$export$f8feb17b3d1c6ff8);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => $60a84c11cc066f79$export$30dd11011e9a2dff);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => $60a84c11cc066f79$export$1b17db464925ac22);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => $60a84c11cc066f79$export$dafd7c818cd58b07);
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => $60a84c11cc066f79$export$a02fb894ac2280da);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => $60a84c11cc066f79$export$1914f2b2604a5e33);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => $60a84c11cc066f79$export$a5c23db41dcff27e);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => $60a84c11cc066f79$export$aa08b576762efb0a);
$parcel$export(module.exports, "getJsmRequestsListRouteWithHubShell", () => $60a84c11cc066f79$export$603e83da51603bdd);
$parcel$export(module.exports, "getJsmManageColumnsRequestsListRouteWithHubShell", () => $60a84c11cc066f79$export$a3dcaa8df9ca6d14);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => $60a84c11cc066f79$export$dbe932e8b71d8b83);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => $60a84c11cc066f79$export$b5d541e9feeaef7e);
$parcel$export(module.exports, "getSurveyRouteWithHubShell", () => $60a84c11cc066f79$export$44fc575b237ca256);
$parcel$export(module.exports, "getHubAllSearchResultsRouteWithHubShell", () => $60a84c11cc066f79$export$85fd887d4a3e26c3);
/* hub-routes.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fuVmc = parcelRequire("fuVmc");

var $cVM5r = parcelRequire("cVM5r");

var $gQxPF = parcelRequire("gQxPF");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("dgMoN");
var $hWMM6 = parcelRequire("hWMM6");

var $7Q8J3 = parcelRequire("7Q8J3");

var $1bpMm = parcelRequire("1bpMm");

var $daink = parcelRequire("daink");
parcelRequire("6Dq5Q");
var $8NRzp = parcelRequire("8NRzp");
parcelRequire("9dLmd");
var $d9EDH = parcelRequire("d9EDH");

var $8Gx81 = parcelRequire("8Gx81");

var $datpo = parcelRequire("datpo");

var $17hHF = parcelRequire("17hHF");
parcelRequire("55StO");
var $6vKHQ = parcelRequire("6vKHQ");

var $87QgR = parcelRequire("87QgR");

var $4Y6IB = parcelRequire("4Y6IB");

var $15Ebe = parcelRequire("15Ebe");

var $l6U6T = parcelRequire("l6U6T");

var $6KJbi = parcelRequire("6KJbi");

var $ke1FE = parcelRequire("ke1FE");

var $02NLy = parcelRequire("02NLy");

var $eYYzi = parcelRequire("eYYzi");

var $d0QiX = parcelRequire("d0QiX");

var $7xhxh = parcelRequire("7xhxh");

var $8pF3j = parcelRequire("8pF3j");

var $799cQ = parcelRequire("799cQ");

var $5FVX4 = parcelRequire("5FVX4");

var $34EUU = parcelRequire("34EUU");

var $3X7MV = parcelRequire("3X7MV");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $gYDJY = parcelRequire("gYDJY");

var $1btpl = parcelRequire("1btpl");

var $5xlhp = parcelRequire("5xlhp");

var $jFO7B = parcelRequire("jFO7B");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("egy8t");
var $5XH4p = parcelRequire("5XH4p");
parcelRequire("6LIWU");
var $70v5x = parcelRequire("70v5x");
parcelRequire("kRunc");
var $bGzgg = parcelRequire("bGzgg");
parcelRequire("jly5y");
var $1xIMz = parcelRequire("1xIMz");
parcelRequire("11L6d");
var $dCclU = parcelRequire("dCclU");

var $get0L = parcelRequire("get0L");

var $5RqCf = parcelRequire("5RqCf");

var $4pKDb = parcelRequire("4pKDb");

var $7RZPz = parcelRequire("7RZPz");

var $iwrh5 = parcelRequire("iwrh5");

var $dOx4s = parcelRequire("dOx4s");

var $8d2Bo = parcelRequire("8d2Bo");

var $hwUVn = parcelRequire("hwUVn");
parcelRequire("fkrk1");
var $i6FGE = parcelRequire("i6FGE");
parcelRequire("aqe5g");
var $eQXE0 = parcelRequire("eQXE0");

var $hO8qA = parcelRequire("hO8qA");
parcelRequire("13WIH");
var $hy5Wv = parcelRequire("hy5Wv");

var $jK6W9 = parcelRequire("jK6W9");

var $5TwEA = parcelRequire("5TwEA");

var $lYtcY = parcelRequire("lYtcY");

var $eoRfm = parcelRequire("eoRfm");

var $1i1vO = parcelRequire("1i1vO");

var $fGcJm = parcelRequire("fGcJm");

var $dXBk5 = parcelRequire("dXBk5");

var $h28No = parcelRequire("h28No");
parcelRequire("3Iju2");
var $2ERHo = parcelRequire("2ERHo");

// Dynamic import, not a static one: `routes/kb` statically pulls in
// `view/knowledge-category`, whose graph reaches `packages/util/url` and calls
// `isCSMHelpCenter(getEnv())` at module scope. Loading it lazily keeps that out of
// this module's chunk and out of test-time module evaluation.
const $60a84c11cc066f79$var$AsyncArticlesSearch = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>// Relative, not the `routes/kb` alias: the lazy-import babel transform resolves
        // this specifier itself and does not apply webpack's `resolve.modules`.
        (parcelRequire("3iWRa")).then((m)=>({
                default: m.RenderArticlesSearchRoute
            })), {
        moduleId: "./src/routes/kb/index.tsx"
    })
});
const $60a84c11cc066f79$var$editMigratedHelpCenterDraft = ()=>{
    const { helpCenterId: helpCenterId } = (0, $dOx4s.parseHelpCenterAri)((0, $fuVmc.getHelpCenterAri)() ?? '');
    (0, $gYDJY.assign)((0, $iwrh5.buildMigratedHelpCenterEditorUrl)({
        helpCenterId: helpCenterId
    }));
};
const $60a84c11cc066f79$var$MIGRATED_HELP_CENTER_REVIEW = {
    onEditDraft: $60a84c11cc066f79$var$editMigratedHelpCenterDraft,
    onFinishLater: (0, $iwrh5.leaveMigratedHelpCenterReview)
};
const $60a84c11cc066f79$var$renderAvatarMenuOptions = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $eQXE0.HubAvatarMenuOptions), null);
};
const $60a84c11cc066f79$export$fa8c03dea1d273a4 = ()=>(0, $87QgR.default).checkGate((0, $fGcJm.JSM_HUB_CUSTOMIZE_MENU_GATE));
const $60a84c11cc066f79$var$createHubRouteProps = (shouldRenderRightNavActions)=>{
    var _initialModelState$us, _initialModelState$us2, _initialModelState$us3, _initialModelState$us4;
    const initialModelState = (0, $1btpl.default)();
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    const renderRightNavActions = ()=>{
        return /*#__PURE__*/ $bSJIT.createElement((0, $5XH4p.default), {
            trigger: "icon"
        });
    };
    const isHelpHub = (0, $hCnLH.getIsHelpHub)();
    const isCSMHelpCenterFlag = (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType);
    const { helpCenterId: helpCenterId } = (0, $dOx4s.parseHelpCenterAri)(helpCenterAri ?? '');
    const isMigratedHelpCenterReviewPathActive = (0, $iwrh5.isMigratedHelpCenterReviewPath)(globalThis.location.pathname);
    const migrationReview = (0, $iwrh5.isMigratedHelpCenterReviewEnabled)() && isHelpHub && isMigratedHelpCenterReviewPathActive && helpCenterAri !== null && helpCenterAri !== void 0 && helpCenterAri.endsWith('-hubs') ? $60a84c11cc066f79$var$MIGRATED_HELP_CENTER_REVIEW : undefined;
    return {
        renderRightNavActions: shouldRenderRightNavActions ? renderRightNavActions : undefined,
        ...(0, $87QgR.default).checkGate('forge-on-hubs') ? {
            productExtensionsDependenciesProvider: (0, $h28No.HubExtensionsDependenciesProvider)
        } : {},
        renderAvatarMenuOptions: isHelpHub ? $60a84c11cc066f79$var$renderAvatarMenuOptions : undefined,
        // Whether the site may customise its help center — the same attribute the
        // avatar menu reads for its Premium pill, and what the editor passes in
        // `HubEditLayout`. The view experience needs it too, because the Customise
        // menu renders here: without it `useShouldShowPremiumUpsell` only ever sees
        // `undefined` and no upsell could show. Tri-state, so `undefined` never gates,
        // and CSM is excluded by the hook's own `hubType` check rather than here.
        isPremiumEntitled: (0, $iW3CQ.getIsHCCustomizationEnabled)(),
        ...migrationReview ? {
            migrationReview: migrationReview
        } : {},
        user: {
            email: ((_initialModelState$us = initialModelState.user) === null || _initialModelState$us === void 0 ? void 0 : _initialModelState$us.email) || '',
            displayName: ((_initialModelState$us2 = initialModelState.user) === null || _initialModelState$us2 === void 0 ? void 0 : _initialModelState$us2.displayName) || '',
            avatarSrc: ((_initialModelState$us3 = initialModelState.user) === null || _initialModelState$us3 === void 0 || (_initialModelState$us3 = _initialModelState$us3.avatars) === null || _initialModelState$us3 === void 0 ? void 0 : _initialModelState$us3.xlarge) || '',
            isJiraAdmin: ((_initialModelState$us4 = initialModelState.user) === null || _initialModelState$us4 === void 0 ? void 0 : _initialModelState$us4.canAdministerJIRA) || false,
            id: ''
        },
        env: {
            helpCenterId: helpCenterId,
            helpCenterAri: helpCenterAri,
            cloudId: (0, $fuVmc.getCloudId)(),
            jiraDisplayUrl: (0, $iW3CQ.getJiraDisplayUrl)(),
            hoistedProjectKey: (0, $iW3CQ.getHoistedProjectKey)() || '',
            relativeBaseUrl: (0, $eDcdn.getRelativeBasePath)()
        },
        featureFlags: {
            enable_hub_breadcrumbs: isHelpHub,
            enable_rovo_in_help_hubs: isHelpHub && (0, $87QgR.default).checkGate('enable_rovo_in_help_hubs'),
            hub_component_upgrade: isHelpHub && (0, $87QgR.default).checkGate('hub_component_upgrade'),
            csm_callout_banner_component_release: isCSMHelpCenterFlag && (0, $87QgR.default).checkGate('csm_callout_banner_component_release'),
            hub_editor_floating_toolbar: isHelpHub && (0, $87QgR.default).checkGate('hub_editor_floating_toolbar'),
            'portal-pages-in-hub': isHelpHub && (0, $87QgR.default).checkGate('portal-pages-in-hub'),
            // Product-level flag that opts a hub surface into advanced theming
            // v2. Today only JSM Help Hubs are opted in; the platform-level
            // `hub-advanced-theming` Statsig gate AND-combines with this so
            // rollout is independently controlled from both sides.
            'advanced-theming-in-hub': isHelpHub && (0, $87QgR.default).checkGate('advanced-theming-in-jsm'),
            translation_support: isHelpHub,
            help_hubs_configurable_site_tree: isHelpHub
        },
        actions: {
            onLogoutClick: ()=>{
                const action = (0, $4pKDb.logOutAction)();
                (0, $7RZPz.store).dispatch(action);
                return action;
            }
        }
    };
};
const $60a84c11cc066f79$var$createRouteWithHubShell = (...args)=>{
    const [props, component, ...restArgs] = args;
    return (0, $5RqCf.createRouteWithHubShell)(props, (0, $5xlhp.withSetThemeColorInRedux)((0, $gQxPF.withPathParamProvider)(component)), ...restArgs);
};
/**
 * Route props carrying the Customise menu. `pageType` is only for pages that can
 * be edited from it; everything else gets the shared help center section alone.
 *
 * Guarded on `getIsHelpHub()` because several of these routes are registered by the
 * CSM router as well as the hub one — home, custom page, not found and portal
 * access forbidden are all shared — so being wired here is not enough to mean the
 * caller is a help hub. Same guard `createHubRouteProps` puts on
 * `renderAvatarMenuOptions`, and read inside the callback so it resolves at render
 * rather than at route registration.
 */ const $60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu = (shouldRenderRightNavActions, pageType)=>({
        ...$60a84c11cc066f79$var$createHubRouteProps(shouldRenderRightNavActions),
        renderCustomNavActions: (iconColor)=>(0, $hCnLH.getIsHelpHub)() && $60a84c11cc066f79$export$fa8c03dea1d273a4() ? /*#__PURE__*/ $bSJIT.createElement((0, $1xIMz.HubCustomizeNavActions), {
                iconColor: iconColor,
                pageType: pageType
            }) : null
    });
const $60a84c11cc066f79$export$3b1658f4569bf0ca = ()=>(0, $6vKHQ.withHubPremiumSlaExperience)((0, $5RqCf.createHubHomepageRoute)({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        appearance: (0, $hCnLH.getIsHelpHub)() && (0, $dXBk5.isHubMaxWidthAppearanceEnabled)() ? 'max' : undefined,
        renderCustomNavActions: (iconColor)=>(0, $hCnLH.getIsHelpHub)() && $60a84c11cc066f79$export$fa8c03dea1d273a4() ? /*#__PURE__*/ $bSJIT.createElement((0, $bGzgg.HubHomepageCustomizeNavActions), {
                iconColor: iconColor
            }) : null
    }), (0, $jcRK7.ExperienceName).HELP_CENTER, (0, $jcRK7.ScreenName).HELP_CENTER);
const $60a84c11cc066f79$export$737d1198516688ea = ()=>(0, $5RqCf.createHubCustomPageRoute)({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true, (0, $4Y6IB.HubPageType).CUSTOM),
        appearance: (0, $hCnLH.getIsHelpHub)() && (0, $dXBk5.isHubMaxWidthAppearanceEnabled)() ? 'max' : undefined
    });
const $60a84c11cc066f79$export$561a9432cf020904 = ()=>(0, $6vKHQ.withHubPremiumSlaExperience)((0, $5RqCf.createHubPortalPageRoute)({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true, (0, $4Y6IB.HubPageType).PORTAL),
        appearance: (0, $hCnLH.getIsHelpHub)() && (0, $dXBk5.isHubMaxWidthAppearanceEnabled)() ? 'max' : undefined
    }), (0, $jcRK7.ExperienceName).REQUEST_CREATE, // The older help center's portal home, which mounts the same experience.
    (0, $jcRK7.ScreenName).PORTAL_HOME);
const $60a84c11cc066f79$export$2a2a6f715f782520 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $eoRfm.CsmUserProfileForHubs), (0, $fGcJm.HUB_ROUTES).USER_PROFILE.path, (0, $fGcJm.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $60a84c11cc066f79$export$2a6efc2e2d50dd68 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $799cQ.CsmRequestsListForHubs), (0, $fGcJm.HUB_ROUTES).CSM_REQUESTS_LIST.path, (0, $fGcJm.HUB_ROUTES).CSM_REQUESTS_LIST.name, [
        (0, $34EUU.csmRequestsListQueryResource)
    ], 'full-width');
const $60a84c11cc066f79$export$d59699c7220ea7d4 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $15Ebe.CsmContactUsForHubs), (0, $fGcJm.HUB_ROUTES).CSM_CONTACT_US.path, (0, $fGcJm.HUB_ROUTES).CSM_CONTACT_US.name, [
        (0, $3X7MV.mediaUploadCredentialsResource)
    ], 'full-width');
const $60a84c11cc066f79$export$c8e491027fcd76d5 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $hWMM6.NotFoundPage), (0, $fGcJm.HUB_ROUTES).NOT_FOUND.path, (0, $fGcJm.HUB_ROUTES).NOT_FOUND.name, [], 'normal');
const $60a84c11cc066f79$export$7e31411194771e76 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $l6U6T.CsmFolderForHubs), (0, $fGcJm.HUB_ROUTES).CSM_FOLDER.path, (0, $fGcJm.HUB_ROUTES).CSM_FOLDER.name, [
        (0, $ke1FE.CsmFolderResource),
        (0, $6KJbi.CsmEmptyFolderResource)
    ], 'full-width');
const $60a84c11cc066f79$export$eb078274575814fa = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $8pF3j.AsyncCsmRequestDetails), (0, $fGcJm.HUB_ROUTES).CSM_REQUEST_DETAILS.path, (0, $fGcJm.HUB_ROUTES).CSM_REQUEST_DETAILS.name, [
        (0, $02NLy.csmRequestDetailsQueryResource),
        (0, $7xhxh.requestConversationResource),
        (0, $eYYzi.mediaReadCredentialsResource),
        (0, $d0QiX.mediaUploadCredentialsResource)
    ], 'xxwide');
const $60a84c11cc066f79$export$8628a4d0641114fc = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $7Q8J3.CsmArticle), (0, $fGcJm.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], 'wide');
const $60a84c11cc066f79$export$d23db2e306b7fa10 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $hwUVn.Article), (0, $fGcJm.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], 'wide');
const $60a84c11cc066f79$export$df37fdf84c1e0c73 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $d9EDH.default), (0, $fGcJm.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.path, (0, $fGcJm.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.name, [], 'normal');
const $60a84c11cc066f79$export$9bd8f060725abce6 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $7Q8J3.CsmArticle), (0, $fGcJm.HUB_ROUTES).VIEW_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_ARTICLE.name, [], 'full-width');
const $60a84c11cc066f79$export$215c0eb21c8c9bbd = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $hwUVn.Article), (0, $fGcJm.HUB_ROUTES).VIEW_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_ARTICLE.name, [], 'normal');
const $60a84c11cc066f79$export$fe3b3b72e1ee1e3 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        appearance: 'full-width'
    }, (0, $hwUVn.Article), (0, $fGcJm.HUB_ROUTES).VIEW_KB_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_KB_ARTICLE.name, [], 'normal');
const $60a84c11cc066f79$export$276f7d60ee8fa12a = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $7Q8J3.CsmArticle), (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $60a84c11cc066f79$export$3e0c0cee1ca6ead0 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $hwUVn.Article), (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $60a84c11cc066f79$export$a2895ad4defdb0c4 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $hwUVn.Article), (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $60a84c11cc066f79$export$3677170bee4c0cc5 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRouteProps(true), (0, $7Q8J3.CsmArticle), (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $fGcJm.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $60a84c11cc066f79$export$c80d2e838cbb1b16 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $8NRzp.default), null)), (0, $fGcJm.HUB_ROUTES).LOGIN.path, (0, $fGcJm.HUB_ROUTES).LOGIN.name, [], 'note');
const $60a84c11cc066f79$export$a60f6f9ee1a764cc = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $8NRzp.default), null)), (0, $fGcJm.HUB_ROUTES).PORTAL_LOGIN.path, (0, $fGcJm.HUB_ROUTES).PORTAL_LOGIN.name, [], 'note');
const $60a84c11cc066f79$export$d0572cd96b5c4ab4 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $datpo.SignUp), routeProps)), (0, $fGcJm.HUB_ROUTES).SIGNUP.path, (0, $fGcJm.HUB_ROUTES).SIGNUP.name, [], 'note');
const $60a84c11cc066f79$export$cfbf23f65634d193 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $datpo.SignUp), routeProps)), (0, $fGcJm.HUB_ROUTES).PORTAL_SIGNUP.path, (0, $fGcJm.HUB_ROUTES).PORTAL_SIGNUP.name, [], 'note');
const $60a84c11cc066f79$export$ab61a9d90fe1a668 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $1bpMm.CompleteSignup), routeProps)), (0, $fGcJm.HUB_ROUTES).COMPLETE_SIGNUP.path, (0, $fGcJm.HUB_ROUTES).COMPLETE_SIGNUP.name, [], 'note');
const $60a84c11cc066f79$export$af956eb6d34eabf5 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $1bpMm.CompleteSignup), routeProps)), (0, $fGcJm.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.path, (0, $fGcJm.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.name, [], 'note');
const $60a84c11cc066f79$export$ec03abb34db753b9 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $8Gx81.ResetPassword), routeProps)), (0, $fGcJm.HUB_ROUTES).RESET_PASSWORD.path, (0, $fGcJm.HUB_ROUTES).RESET_PASSWORD.name, [], 'note');
const $60a84c11cc066f79$export$176415cbffecf519 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $8Gx81.ResetPassword), routeProps)), (0, $fGcJm.HUB_ROUTES).PORTAL_RESET_PASSWORD.path, (0, $fGcJm.HUB_ROUTES).PORTAL_RESET_PASSWORD.name, [], 'note');
const $60a84c11cc066f79$export$f8feb17b3d1c6ff8 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $17hHF.CheckEmail), {
            ...routeProps,
            isLoading: false
        })), (0, $fGcJm.HUB_ROUTES).CHECK_EMAIL.path, (0, $fGcJm.HUB_ROUTES).CHECK_EMAIL.name, [], 'note');
const $60a84c11cc066f79$export$30dd11011e9a2dff = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ $bSJIT.createElement((0, $i6FGE.HubAnonymousLayout), null, /*#__PURE__*/ $bSJIT.createElement((0, $daink.InvitedSignUp), null)), (0, $fGcJm.HUB_ROUTES).PORTAL_INVITED_SIGNUP.path, (0, $fGcJm.HUB_ROUTES).PORTAL_INVITED_SIGNUP.name, [], 'note');
const $60a84c11cc066f79$export$1b17db464925ac22 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $lYtcY.Unsubscribe), (0, $fGcJm.HUB_ROUTES).UNSUBSCRIBE.path, (0, $fGcJm.HUB_ROUTES).UNSUBSCRIBE.name, [], 'note');
const $60a84c11cc066f79$export$dafd7c818cd58b07 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $jK6W9.RequestFeedback), (0, $fGcJm.HUB_ROUTES).REQUEST_FEEDBACK.path, (0, $fGcJm.HUB_ROUTES).REQUEST_FEEDBACK.name, [], 'note');
const $60a84c11cc066f79$export$a02fb894ac2280da = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $hWMM6.RenderCreateAnonymousSuccess), (0, $fGcJm.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.path, (0, $fGcJm.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.name, [], 'xxwide');
const $60a84c11cc066f79$export$1914f2b2604a5e33 = ()=>(0, $6vKHQ.withHubPremiumSlaExperience)($60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $hWMM6.RenderRequestCreateForHubs), (0, $fGcJm.HUB_ROUTES).REQUEST_CREATE.path, (0, $fGcJm.HUB_ROUTES).REQUEST_CREATE.name, [], 'full-width'), (0, $jcRK7.ExperienceName).REQUEST_CREATE, (0, $jcRK7.ScreenName).REQUEST_CREATE);
const $60a84c11cc066f79$export$a5c23db41dcff27e = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $2ERHo.withStaticHubBreadcrumbs)((0, $1i1vO.UserProfileForHubs), (0, $fGcJm.HUB_ROUTES).USER_PROFILE.name), (0, $fGcJm.HUB_ROUTES).USER_PROFILE.path, (0, $fGcJm.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $60a84c11cc066f79$export$aa08b576762efb0a = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $hy5Wv.default), (0, $fGcJm.HUB_ROUTES).JSM_REQUEST_DETAILS.path, (0, $fGcJm.HUB_ROUTES).JSM_REQUEST_DETAILS.name, [], 'xxwide');
const $60a84c11cc066f79$var$JsmCustomizeNavActions = ({ iconColor: iconColor })=>{
    const state = (0, $7RZPz.store).getState();
    const canAdministerJIRA = (0, $fBLyB.getCanAdministerJIRA)(state);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleManageListViewClick = (0, $bSJIT.useCallback)(()=>{
        (0, $7RZPz.store).dispatch((0, $jFO7B.customizingRequestListColumn)(true));
    }, []);
    const items = (0, $bSJIT.useMemo)(()=>{
        if (!canAdministerJIRA) return [];
        return [
            {
                label: formatMessage((0, $get0L.default).manageListViewButtonLabel),
                testId: 'manage-list-view-button',
                actionSubjectId: 'manageListViewButton',
                onClick: handleManageListViewClick
            }
        ];
    }, [
        canAdministerJIRA,
        formatMessage,
        handleManageListViewClick
    ]);
    const helpCenterSection = (0, $dCclU.useHelpCenterCustomizeSection)(canAdministerJIRA);
    const sections = (0, $bSJIT.useMemo)(()=>[
            {
                items: items
            },
            helpCenterSection
        ].filter((section)=>Boolean(section)), [
        items,
        helpCenterSection
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $70v5x.HubCustomizeMenu), {
        sections: sections,
        iconColor: iconColor
    });
};
const $60a84c11cc066f79$var$RequestListWithStaticHubBreadcrumbs = (0, $2ERHo.withStaticHubBreadcrumbs)((0, $5TwEA.RequestList), (0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.name);
const $60a84c11cc066f79$export$603e83da51603bdd = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: 'Requests',
            isAnonymousRoute: false
        }
    }, $60a84c11cc066f79$var$RequestListWithStaticHubBreadcrumbs, (0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.path, (0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.name, [], 'xxwide');
const $60a84c11cc066f79$export$a3dcaa8df9ca6d14 = ()=>{
    const renderCustomNavActions = (iconColor)=>/*#__PURE__*/ $bSJIT.createElement($60a84c11cc066f79$var$JsmCustomizeNavActions, {
            iconColor: iconColor
        });
    return $60a84c11cc066f79$var$createRouteWithHubShell(/**
   * TODO: The banner text has to be internationalized
   */ {
        ...$60a84c11cc066f79$var$createHubRouteProps(true),
        renderCustomNavActions: renderCustomNavActions,
        layout: {
            showBanner: true,
            bannerText: 'Requests',
            isAnonymousRoute: false
        }
    }, $60a84c11cc066f79$var$RequestListWithStaticHubBreadcrumbs, (0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.path, (0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.name, [], 'xxwide');
};
const $60a84c11cc066f79$export$dbe932e8b71d8b83 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: 'Approvals',
            isAnonymousRoute: false
        }
    }, (0, $2ERHo.withStaticHubBreadcrumbs)((0, $8d2Bo.ApprovalList), (0, $fGcJm.HUB_ROUTES).JSM_APPROVALS.name), (0, $fGcJm.HUB_ROUTES).JSM_APPROVALS.path, (0, $fGcJm.HUB_ROUTES).JSM_APPROVALS.name, [], 'xxwide');
const $60a84c11cc066f79$export$b5d541e9feeaef7e = ()=>$60a84c11cc066f79$var$createRouteWithHubShell({
        ...$60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $hO8qA.RequestApproval), (0, $fGcJm.HUB_ROUTES).JSM_REQUEST_APPROVAL.path, (0, $fGcJm.HUB_ROUTES).JSM_REQUEST_APPROVAL.name, [], 'xxwide');
const $60a84c11cc066f79$export$44fc575b237ca256 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), (0, $5FVX4.AsyncSurveyDetails), (0, $fGcJm.HUB_ROUTES).SURVEY.path, (0, $fGcJm.HUB_ROUTES).SURVEY.name, [], 'xxwide');
const $60a84c11cc066f79$export$85fd887d4a3e26c3 = ()=>$60a84c11cc066f79$var$createRouteWithHubShell($60a84c11cc066f79$var$createHubRoutePropsWithCustomizeMenu(true), $60a84c11cc066f79$var$AsyncArticlesSearch, (0, $fGcJm.HUB_ROUTES).ALL_SEARCH_RESULTS.path, (0, $fGcJm.HUB_ROUTES).ALL_SEARCH_RESULTS.name, [], 'full-width', {
        hideNavbar: true
    });

});
parcelRegister("55StO", function(module, exports) {
$parcel$export(module.exports, "HubPremiumSlaElementsProvider", () => (parcelRequire("6vKHQ")).HubPremiumSlaElementsProvider);
$parcel$export(module.exports, "withHubPremiumSlaExperience", () => (parcelRequire("6vKHQ")).withHubPremiumSlaExperience);

var $6vKHQ = parcelRequire("6vKHQ");

});
parcelRegister("6vKHQ", function(module, exports) {
$parcel$export(module.exports, "HubPremiumSlaElementsProvider", () => $dc1dfb7302e462b4$export$6534426fcefca7b3);
$parcel$export(module.exports, "withHubPremiumSlaExperience", () => $dc1dfb7302e462b4$export$a1922c62fb34200e);
/**
 * Premium SLA (UI task success / fail) metrics for the new help center, a.k.a. hubs.
 *
 * Hub routes render through the platform `@atlassian/hub` packages and emitted neither
 * `view-help-center` nor `request-create`. This mounts the same `Experience` with the same
 * payload and screen, so hub traffic is separated in reporting by the `helpCenterCategory`
 * attribute the analytics client already adds, not by a different metric:
 * - Success: hub pages have no help center notifiers, so `HubPremiumSlaElementsProvider`
 *   supplies one per rendered element.
 * - Failure: hub failures are caught by the platform's `HubErrorBoundary`, which reports
 *   to `HubErrorObserverContext`.
 */ 
var $bSJIT = parcelRequire("bSJIT");
parcelRequire("fxMO5");
var $15AtB = parcelRequire("15AtB");
var $15AtB = parcelRequire("15AtB");
var $j2vrN = parcelRequire("j2vrN");

var $jcRK7 = parcelRequire("jcRK7");

var $87QgR = parcelRequire("87QgR");

var $haAAx = parcelRequire("haAAx");

var $4nock = parcelRequire("4nock");

var $4uQUf = parcelRequire("4uQUf");

var $iFkpH = parcelRequire("iFkpH");

var $51XYw = parcelRequire("51XYw");
/** Gates the whole hub emission, so it can be rolled out gradually and killed if it misreports. */ const $dc1dfb7302e462b4$var$HUB_PREMIUM_SLA_METRICS = 'help_center_hub_premium_sla_metrics';
const $dc1dfb7302e462b4$export$c6fcfc3cc09fa333 = ()=>(0, $87QgR.default).checkGate($dc1dfb7302e462b4$var$HUB_PREMIUM_SLA_METRICS);
/** The page itself failed to render, so neither journey can complete. */ const $dc1dfb7302e462b4$var$PAGE_LEVEL_ERROR_IDS = new Set([
    'hub-page',
    'route-with-hub-shell'
]);
const $dc1dfb7302e462b4$var$JSM_HELP_EXTENSION_KEY = 'jsm-help';
/**
 * Fail the home page but not create request: a customer can still reach the request
 * form when these fail.
 */ const $dc1dfb7302e462b4$var$HOME_PAGE_ONLY_ERROR_IDS = new Set([
    'spotlight',
    'carousel',
    'cards',
    'links-menu',
    'hub-section',
    'banner'
]);
const $dc1dfb7302e462b4$export$7e7b0dfb9751d5dd = (id, journey)=>{
    if ($dc1dfb7302e462b4$var$PAGE_LEVEL_ERROR_IDS.has(id) || id === $dc1dfb7302e462b4$var$JSM_HELP_EXTENSION_KEY) return true;
    return journey === (0, $jcRK7.ExperienceName).HELP_CENTER && $dc1dfb7302e462b4$var$HOME_PAGE_ONLY_ERROR_IDS.has(id);
};
const $dc1dfb7302e462b4$var$PremiumSlaErrorObserver = ({ children: children, journey: journey })=>{
    const { onFailure: onFailure } = (0, $bSJIT.useContext)((0, $15AtB.ExperienceContext));
    const observeError = (0, $bSJIT.useCallback)(({ error: error, id: id })=>{
        const fetchError = error;
        // Only 5xx counts. 4xx and network errors are excluded, as in the older help center.
        if (!$dc1dfb7302e462b4$export$7e7b0dfb9751d5dd(id, journey) || (0, $51XYw.isFetchNetworkOrClientError)(fetchError)) return;
        onFailure({
            errorMessage: error.message,
            errorName: error.name,
            unhandledError: true,
            errorLocation: id.startsWith('hub-') ? id : `hub-${id}`,
            status: fetchError.status
        });
    }, [
        journey,
        onFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iFkpH.HubErrorObserverContext).Provider, {
        value: observeError
    }, children);
};
const $dc1dfb7302e462b4$export$6534426fcefca7b3 = ({ children: children, extensionKey: extensionKey, mode: mode })=>{
    const productDependencies = (0, $4uQUf.useProductDependencies)();
    // Only the published renderer is measured; editing a hub is not a customer journey.
    const isEnabled = $dc1dfb7302e462b4$export$c6fcfc3cc09fa333() && mode === (0, $4nock.ExtensionMode).RENDERER;
    // Keyed on the extension key alone: a changing identity would remount the element.
    const experienceStartComponent = (0, $bSJIT.useMemo)(()=>{
        const location = `hub-element-${extensionKey || 'unknown'}`;
        const HubElementRendered = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2vrN.ExperienceSuccess), {
                location: location
            });
        HubElementRendered.displayName = 'HubElementRendered';
        return HubElementRendered;
    }, [
        extensionKey
    ]);
    const value = isEnabled ? {
        ...productDependencies,
        experienceStartComponent: experienceStartComponent
    } : productDependencies;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4uQUf.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $dc1dfb7302e462b4$export$a1922c62fb34200e = (route, journey, screenName)=>{
    const Component = route.component;
    if (!$dc1dfb7302e462b4$export$c6fcfc3cc09fa333() || !Component) return route;
    const HubRouteWithPremiumSla = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $haAAx.AnalyticsContext), {
            sourceName: screenName,
            sourceType: (0, $haAAx.ScreenTypes).SCREEN
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $15AtB.default), {
            name: journey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($dc1dfb7302e462b4$var$PremiumSlaErrorObserver, {
            journey: journey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props))));
    return {
        ...route,
        component: HubRouteWithPremiumSla
    };
};

});
parcelRegister("4nock", function(module, exports) {
$parcel$export(module.exports, "ButtonStyle", () => $0e473807b6147c9f$export$bdc3c19374266b98);
$parcel$export(module.exports, "CornerStyle", () => $0e473807b6147c9f$export$a6e645fda5339bf8);
$parcel$export(module.exports, "Height", () => $0e473807b6147c9f$export$8954cfac7c08d16a);
$parcel$export(module.exports, "Alignment", () => $0e473807b6147c9f$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "Orientation", () => $0e473807b6147c9f$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "CardLayout", () => $0e473807b6147c9f$export$21e76ed09a093e97);
$parcel$export(module.exports, "CommonLayout", () => $0e473807b6147c9f$export$42809f9f1496f50d);
$parcel$export(module.exports, "FeedbackType", () => $0e473807b6147c9f$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ExtensionMode", () => $0e473807b6147c9f$export$533ae1c1b7b7ac6);
$parcel$export(module.exports, "RenderVariant", () => $0e473807b6147c9f$export$1f60141b6ce5efed);
$parcel$export(module.exports, "SegmentationTargets", () => $0e473807b6147c9f$export$f6cd408cac7f930c);
$parcel$export(module.exports, "ITEM_FIELDS", () => $0e473807b6147c9f$export$bf7ebf7fed6e7189);
var $0e473807b6147c9f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $0e473807b6147c9f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $0e473807b6147c9f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $0e473807b6147c9f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $0e473807b6147c9f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $0e473807b6147c9f$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $0e473807b6147c9f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $0e473807b6147c9f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $0e473807b6147c9f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $0e473807b6147c9f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $0e473807b6147c9f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $0e473807b6147c9f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $0e473807b6147c9f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});

});

parcelRegister("4uQUf", function(module, exports) {
$parcel$export(module.exports, "ProductDependenciesContext", () => $7cfdbdfee6c46c39$export$49e1053dfc41d188);
$parcel$export(module.exports, "useProductDependencies", () => $7cfdbdfee6c46c39$export$8dcbb40932065737);

var $bSJIT = parcelRequire("bSJIT");
const $7cfdbdfee6c46c39$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $7cfdbdfee6c46c39$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $bSJIT.useContext)($7cfdbdfee6c46c39$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7cfdbdfee6c46c39$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
function $7cfdbdfee6c46c39$export$8dcbb40932065737() {
    const ctx = (0, $bSJIT.useContext)($7cfdbdfee6c46c39$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}

});

parcelRegister("iFkpH", function(module, exports) {
$parcel$export(module.exports, "HubErrorObserverContext", () => $2b52e3ac998cb741$export$f0a9f6d56660bc06);

var $bSJIT = parcelRequire("bSJIT");
const $2b52e3ac998cb741$export$f0a9f6d56660bc06 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(undefined);

});



parcelRegister("4Y6IB", function(module, exports) {
$parcel$export(module.exports, "HubPageType", () => $99548b090e8aae4b$export$dbf470ddbd9b58b6);
$parcel$export(module.exports, "isPortalPage", () => $99548b090e8aae4b$export$646dda995799f7d5);
$parcel$export(module.exports, "isTopicPage", () => $99548b090e8aae4b$export$cf2e4190faa8ff7e);
$parcel$export(module.exports, "getPortalIdFromPageId", () => $99548b090e8aae4b$export$fef05bffd39d3ca1);
$parcel$export(module.exports, "buildPortalPageAri", () => $99548b090e8aae4b$export$9d2b62eb20639695);
$parcel$export(module.exports, "buildHomePageAri", () => $99548b090e8aae4b$export$f030375a17a3cd03);
$parcel$export(module.exports, "isHomePageByAri", () => $99548b090e8aae4b$export$c0ca1e0679075a3);
$parcel$export(module.exports, "resolveCurrentPage", () => $99548b090e8aae4b$export$bec70b043200c466);
// eslint-disable-next-line no-restricted-imports

var $9P2Zq = parcelRequire("9P2Zq");
var $hwpKw = parcelRequire("hwpKw");
const $99548b090e8aae4b$var$PORTAL_PAGE_PREFIX = 'portal_page-';
const $99548b090e8aae4b$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $9P2Zq.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // Silently fail for invalid ARIs
    }
};
var $99548b090e8aae4b$export$dbf470ddbd9b58b6 = /*#__PURE__*/ function(HubPageType) {
    /** The hub's home/landing page */ HubPageType["HOME"] = "HOME";
    /** A custom page created in the hub editor */ HubPageType["CUSTOM"] = "CUSTOM";
    /** A portal page backed by a JSM portal */ HubPageType["PORTAL"] = "PORTAL";
    return HubPageType;
}({});
const $99548b090e8aae4b$export$c246174f38c9bde7 = (pageId)=>{
    if (!pageId) return "HOME";
    if (pageId.startsWith($99548b090e8aae4b$var$PORTAL_PAGE_PREFIX)) return "PORTAL";
    return "CUSTOM";
};
const $99548b090e8aae4b$export$646dda995799f7d5 = (pageId)=>$99548b090e8aae4b$export$c246174f38c9bde7(pageId) === "PORTAL";
const $99548b090e8aae4b$export$cf2e4190faa8ff7e = (pageId, topicPages)=>{
    if (!pageId || $99548b090e8aae4b$export$646dda995799f7d5(pageId)) return false;
    return topicPages.some((page)=>{
        try {
            return (0, $hwpKw.HelpPageAri).parse(page.id).pageId === pageId;
        } catch  {
            // Skip rather than throw: this runs on every render of the editor host.
            return false;
        }
    });
};
const $99548b090e8aae4b$export$fef05bffd39d3ca1 = (pageId)=>{
    if (!$99548b090e8aae4b$export$646dda995799f7d5(pageId)) return '';
    return pageId.slice($99548b090e8aae4b$var$PORTAL_PAGE_PREFIX.length);
};
const $99548b090e8aae4b$export$9d2b62eb20639695 = (helpCenterAri, portalPageId)=>{
    const meta = $99548b090e8aae4b$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return '';
    const { activationId: activationId, helpCenterId: helpCenterId } = meta;
    return `ari:cloud:help::page/${activationId}/${portalPageId}/${helpCenterId}`;
};
const $99548b090e8aae4b$export$f030375a17a3cd03 = (helpCenterAri, hubId)=>{
    const meta = $99548b090e8aae4b$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return '';
    return `ari:cloud:help::page/${meta.activationId}/${hubId}`;
};
const $99548b090e8aae4b$export$c0ca1e0679075a3 = (parsedPageId, helpCenterAri)=>{
    const meta = $99548b090e8aae4b$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return false;
    return parsedPageId === meta.helpCenterId;
};
const $99548b090e8aae4b$export$bec70b043200c466 = (pageId, filteredPages, helpCenterAri, currentPageName)=>{
    const pageType = $99548b090e8aae4b$export$c246174f38c9bde7(pageId);
    if (pageType === "PORTAL") return {
        pageType: pageType,
        isHomePage: false,
        pageAri: $99548b090e8aae4b$export$9d2b62eb20639695(helpCenterAri, pageId),
        pageName: currentPageName || ''
    };
    if (pageType === "CUSTOM") {
        const matchedPage = filteredPages.find((page)=>{
            var _page$name;
            return ((_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default) && (0, $hwpKw.HelpPageAri).parse(page.id).pageId === pageId;
        });
        if (matchedPage) {
            var _matchedPage$name;
            return {
                pageType: pageType,
                isHomePage: false,
                pageAri: matchedPage.id,
                pageName: ((_matchedPage$name = matchedPage.name) === null || _matchedPage$name === void 0 ? void 0 : _matchedPage$name.default) || ''
            };
        }
        return null;
    }
    return {
        pageType: "HOME",
        isHomePage: true,
        pageAri: '',
        pageName: ''
    };
};

});

parcelRegister("15Ebe", function(module, exports) {
$parcel$export(module.exports, "CsmContactUsForHubs", () => $98a99681ed284556$export$18dcede65e3972a9);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $98a99681ed284556$export$18dcede65e3972a9 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("297XA")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("297XA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9EMTX"),
    $kOunM("br2rQ"),
    $kOunM("aA07X"),
    $kOunM("jsKIl"),
    $kOunM("8m449"),
    $kOunM("6o3JG"),
    $kOunM("jAikg"),
    $kOunM("9pCDc"),
    $kOunM("if62Z"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("aHc5N"),
    $kOunM("272yQ"),
    $kOunM("6bQ3H"),
    $kOunM("4sVVY")
]).then(()=>parcelRequire('2W7YR'));

});


parcelRegister("l6U6T", function(module, exports) {
$parcel$export(module.exports, "CsmFolderForHubs", () => $215ed3ff28a2e50d$export$46d643ae94fd657a);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $215ed3ff28a2e50d$export$46d643ae94fd657a = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("b9HVc")), {
        moduleId: "./packages/customer-service/csm-folder/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("b9HVc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("56MHC"),
    $kOunM("lSqRg")
]).then(()=>parcelRequire('6tpoL'));

});


parcelRegister("799cQ", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsListForHubs", () => $27743a563c698d9a$export$3f37ab3da4f058a);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $27743a563c698d9a$export$3f37ab3da4f058a = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("2d234")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("2d234", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("lMUFX"),
    $kOunM("lJr3G"),
    $kOunM("eau4o"),
    $kOunM("hQ9R7"),
    $kOunM("f80Rt"),
    $kOunM("7Emqt")
]).then(()=>parcelRequire('3nq2p'));

});


parcelRegister("5FVX4", function(module, exports) {
$parcel$export(module.exports, "AsyncSurveyDetails", () => $a59008ab4083ed53$export$b01dbc7a6c5c4fed);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $a59008ab4083ed53$export$b01dbc7a6c5c4fed = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("iZNfQ")), {
        moduleId: "./packages/surveys/src/Survey.tsx"
    })
});

});
parcelRegister("iZNfQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9EMTX"),
    $kOunM("br2rQ"),
    $kOunM("aA07X"),
    $kOunM("8m449"),
    $kOunM("jQdtk"),
    $kOunM("9pCDc"),
    $kOunM("if62Z"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("272yQ"),
    $kOunM("fCONc"),
    $kOunM("hfets")
]).then(()=>parcelRequire('fHZuW'));

});


parcelRegister("5xlhp", function(module, exports) {
$parcel$export(module.exports, "withSetThemeColorInRedux", () => $b13335b612083145$export$e14001b3f71f56fc);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $dhHUc = parcelRequire("dhHUc");
const $b13335b612083145$export$e14001b3f71f56fc = (InnerComponent)=>{
    const Component = (props)=>{
        const { bannerBackgroundColor: bannerBackgroundColor, setThemeColor: setThemeColor } = props;
        $bSJIT.useEffect(()=>{
            if (bannerBackgroundColor) setThemeColor({
                themeColor: bannerBackgroundColor
            });
        }, [
            bannerBackgroundColor,
            setThemeColor
        ]);
        return /*#__PURE__*/ $bSJIT.createElement(InnerComponent, props);
    };
    return (0, $f2mlD.default)(null, {
        setThemeColor: (0, $dhHUc.updateHCThemeColorAction)
    })(Component);
};

});

parcelRegister("6LIWU", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeMenu", () => (parcelRequire("70v5x")).HubCustomizeMenu);
parcelRequire("70v5x");

});
parcelRegister("70v5x", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeMenu", () => $be02b1793adc9e3d$export$1c1a3da435dd8e63);
/* hub-customize-menu.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $53Khx = parcelRequire("53Khx");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $haAAx = parcelRequire("haAAx");

var $4TRbS = parcelRequire("4TRbS");

var $2hM1a = parcelRequire("2hM1a");

var $kpgiw = parcelRequire("kpgiw");

var $cjQhO = parcelRequire("cjQhO");

var $fsfgu = parcelRequire("fsfgu");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $26Jy2 = parcelRequire("26Jy2");
parcelRequire("ckGNT");
var $iStmz = parcelRequire("iStmz");

var $2Trol = parcelRequire("2Trol");

var $get0L = parcelRequire("get0L");
/**
 * Has the hub Customise menu report its trigger and every option's click, and
 * its Premium upsell items report their exposure.
 */ const $be02b1793adc9e3d$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE = 'hubs_customize_menu_analytics';
const $be02b1793adc9e3d$var$isHubCustomizeMenuAnalyticsEnabled = ()=>(0, $87QgR.default).checkGate($be02b1793adc9e3d$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE);
const $be02b1793adc9e3d$var$menuContainerStyles = null;
const $be02b1793adc9e3d$var$setRefValue = (ref, element)=>{
    if (typeof ref === 'function') ref(element);
    else if (ref && typeof ref === 'object' && 'current' in ref) ref.current = element;
};
const $be02b1793adc9e3d$var$HubCustomizeMenuComponent = ({ sections: sections, iconColor: iconColor })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const isMobile = (0, $2Trol.useMediaQuery)('(max-width: 768px)');
    const setCustomiseSidebarTrigger = (0, $iStmz.useSetCustomiseSidebarTrigger)();
    const handleToggle = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        if ($be02b1793adc9e3d$var$isHubCustomizeMenuAnalyticsEnabled()) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'hubCustomizeMenuTrigger',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
        setIsOpen((prev)=>!prev);
    }, [
        createAnalyticsEvent
    ]);
    const fireItemClicked = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((item)=>{
        if (!$be02b1793adc9e3d$var$isHubCustomizeMenuAnalyticsEnabled()) return;
        // `customizeMenu` is what these items reported before the menu owned it.
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'customizeMenu',
            actionSubjectId: item.actionSubjectId,
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            attributes: item.analyticsAttributes
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleItemClick = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((onClick)=>{
        onClick === null || onClick === void 0 || onClick();
        setIsOpen(false);
    }, []);
    const visibleSections = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>sections.filter((section)=>section.items.length > 0), [
        sections
    ]);
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            "data-testid": "hub-customize-menu-content",
            className: (0, $9fU1q.default)([
                "_2rkofajl _1bsbnpok _bfhkvuon _16qs1m5t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $65Fe1.default), null, visibleSections.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
                key: section.heading ?? `section-${index}`,
                hasSeparator: index > 0
            }, section.heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fsfgu.default), {
                id: `hub-customize-menu-heading-${index}`
            }, section.heading), section.items.map((item)=>{
                if (item.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
                    key: item.testId
                }, item.customRenderer({
                    onClick: ()=>fireItemClicked(item)
                }));
                return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
                    key: item.testId,
                    component: (0, $53Khx.HtmlAnchor),
                    href: item.href,
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    actionSubjectId: item.actionSubjectId,
                    testId: item.testId,
                    onClick: ()=>handleItemClick(item.onClick),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
                    className: "cv-exclude-from-customisation"
                }, item.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
                    key: item.testId,
                    testId: item.testId,
                    onClick: ()=>{
                        fireItemClicked(item);
                        handleItemClick(item.onClick);
                    }
                }, item.label);
            }))))), [
        visibleSections,
        handleItemClick,
        fireItemClicked
    ]);
    const renderTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(({ ref: ref, ...triggerProps })=>{
        const combinedRef = (element)=>{
            $be02b1793adc9e3d$var$setRefValue(ref, element);
            setCustomiseSidebarTrigger === null || setCustomiseSidebarTrigger === void 0 || setCustomiseSidebarTrigger(element);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
            ...triggerProps,
            ref: combinedRef,
            appearance: "subtle",
            icon: (iconProps)=>iconColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
                    "data-testid": "hub-customize-menu-icon",
                    style: {
                        color: iconColor
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hM1a))), iconProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hM1a))), iconProps),
            label: formatMessage((0, $get0L.default).customizeMenuLabel),
            testId: "hub-customize-menu-trigger",
            onClick: handleToggle
        });
    }, [
        formatMessage,
        handleToggle,
        iconColor,
        setCustomiseSidebarTrigger
    ]);
    if (visibleSections.length === 0 || isMobile) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-end",
        shouldRenderToParent: true,
        content: renderContent,
        trigger: renderTrigger
    });
};
$be02b1793adc9e3d$var$HubCustomizeMenuComponent.displayName = 'HubCustomizeMenu';
const $be02b1793adc9e3d$export$1c1a3da435dd8e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($be02b1793adc9e3d$var$HubCustomizeMenuComponent);

});
parcelRegister("2hM1a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03d94757a5ce26f8391dae629241af48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1aa26aa4e051c48f$var$_react = $1aa26aa4e051c48f$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $1aa26aa4e051c48f$var$_iconNew = $1aa26aa4e051c48f$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $1aa26aa4e051c48f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/customize
 * Usage guidance:
 * Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1aa26aa4e051c48f$var$CustomizeIcon = (props)=>/*#__PURE__*/ $1aa26aa4e051c48f$var$_react.default.createElement($1aa26aa4e051c48f$var$_iconNew.default, Object.assign({
        name: "CustomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.5 10.5V12H0v-1.5zM16 4v1.5H8.5V4zm-5.5 8.75h1v-3h-1zM13 10.5h3V12h-3v.875c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375v-3.25c0-.76.616-1.375 1.375-1.375h1.25c.76 0 1.375.616 1.375 1.375zM5.5 3.25h-1v3h1zM7 6.375c0 .76-.616 1.375-1.375 1.375h-1.25C3.615 7.75 3 7.134 3 6.375V5.5H0V4h3v-.875c0-.76.616-1.375 1.375-1.375h1.25C6.385 1.75 7 2.366 7 3.125z"/>`
    }, props));
$1aa26aa4e051c48f$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $1aa26aa4e051c48f$var$_default = module.exports.default = $1aa26aa4e051c48f$var$CustomizeIcon;

});

parcelRegister("2Trol", function(module, exports) {
$parcel$export(module.exports, "useMediaQuery", () => $b1452ebe87f2f1dc$export$32d5543ab307c01);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");
function $b1452ebe87f2f1dc$export$32d5543ab307c01(query) {
    const [match, setMatch] = $bSJIT.useState(false);
    $bSJIT.useEffect(()=>{
        function screenTest(e) {
            setMatch(Boolean(e.matches));
        }
        if (window && Object.prototype.hasOwnProperty.call(window, 'matchMedia')) {
            const mql = window.matchMedia(query);
            /**
       * Trigger the screenTest even for the first call
       */ screenTest(mql);
            mql.addListener(screenTest);
            return ()=>{
                mql.removeListener(screenTest);
            };
        }
        return 0, $4ZMmh.noop;
    }, [
        query
    ]);
    return match;
}

});

parcelRegister("get0L", function(module, exports) {
$parcel$export(module.exports, "default", () => $4921272cc54ffdef$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $4921272cc54ffdef$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    csmRequestsListBannerText: {
        defaultMessage: 'My requests',
        description: 'Text for the banner in the csm requests list page',
        id: 'hub.csm.requests.list.banner.text.non-final'
    },
    customizeMenuLabel: {
        id: 'hub.routes.customize-menu.label',
        defaultMessage: 'Customize',
        description: 'Accessible label for the customize dropdown menu trigger button in the hub header.'
    },
    manageListViewButtonLabel: {
        id: 'hub.routes.jsm-requests-list.manage-list-view.button.label',
        defaultMessage: 'Manage list view',
        description: 'Label for the menu item in the customize dropdown that opens the manage columns sidebar on the JSM requests list page.'
    },
    loginAnnouncementButtonLabel: {
        id: 'hub.routes.homepage.login-announcement.button.label',
        defaultMessage: 'Add login page message',
        description: 'Label for the Hub Customize menu item that opens login announcement settings.'
    },
    helpCenterSectionHeading: {
        id: 'hub.routes.customize-menu.help-center-section.heading',
        defaultMessage: 'Help center',
        description: 'Heading for the group of the customize dropdown holding the site-wide help center entry points, which are the same on every page.'
    },
    editHelpCenterLabel: {
        id: 'hub.routes.customize-menu.edit-help-center.label',
        defaultMessage: 'Edit help center',
        description: 'Label for the customize dropdown menu item that opens the help center home page in the editor.'
    },
    editPortalPageLabel: {
        id: 'hub.routes.customize-menu.edit-portal-page.label',
        defaultMessage: 'Edit portal page',
        description: 'Label for the customize dropdown menu item that opens the current portal page in the editor.'
    },
    editPortalAnnouncementLabel: {
        id: 'hub.routes.customize-menu.edit-portal-announcement.label',
        defaultMessage: 'Edit portal announcement',
        description: 'Label for the customize dropdown menu item that opens the current portal page in the editor, shown to sites without Premium, where the announcement is the only part of a portal page they can change.'
    },
    editCustomPageLabel: {
        id: 'hub.routes.customize-menu.edit-custom-page.label',
        defaultMessage: 'Edit custom page',
        description: 'Label for the customize dropdown menu item that opens the current custom page in the editor.'
    },
    editTopicPageLabel: {
        id: 'hub.routes.customize-menu.edit-topic-page.label',
        defaultMessage: 'Edit topic page',
        description: 'Label for the customize dropdown menu item that opens the current topic page in the editor.'
    },
    viewAllHelpCentersLabel: {
        id: 'hub.routes.customize-menu.view-all-help-centers.label',
        defaultMessage: 'View all help centers',
        description: 'Label for the customize dropdown menu item that opens the help center management screen.'
    },
    createHelpCenterLabel: {
        id: 'hub.routes.customize-menu.create-help-center.label',
        defaultMessage: 'Create help center',
        description: 'Label for the customize dropdown menu item that opens the help center management screen with its create flow open.'
    },
    createCustomPageLabel: {
        id: 'hub.routes.customize-menu.create-custom-page.label',
        defaultMessage: 'Create custom page',
        description: 'Label for the customize dropdown menu item that opens the editor on the help center home page with the create page dialog open.'
    },
    premiumLozenge: {
        id: 'hub.routes.customize-menu.premium-lozenge',
        defaultMessage: 'Premium',
        description: 'Lozenge marking a customize menu item as a Premium feature, shown to sites that are not entitled to it.'
    },
    rovoAgentLabel: {
        id: 'hub.routes.customize-menu.rovo-agent.label',
        defaultMessage: 'Rovo agent',
        description: "Label for the customize dropdown menu item that opens the help center's Rovo agent settings."
    }
});

});



parcelRegister("kRunc", function(module, exports) {
$parcel$export(module.exports, "HubHomepageCustomizeNavActions", () => (parcelRequire("bGzgg")).HubHomepageCustomizeNavActions);
parcelRequire("1ACQn");
var $bGzgg = parcelRequire("bGzgg");

});
parcelRegister("1ACQn", function(module, exports) {
$parcel$export(module.exports, "HubHomepageCustomizeNavActions", () => (parcelRequire("bGzgg")).HubHomepageCustomizeNavActions);

var $bGzgg = parcelRequire("bGzgg");

});
parcelRegister("bGzgg", function(module, exports) {
$parcel$export(module.exports, "HubHomepageCustomizeNavActions", () => $89d6a3af81b596ef$export$c0b4b03ead4d16ad);
/* hub-homepage-customize-nav-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("cJJTb");
var $bf3Xm = parcelRequire("bf3Xm");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $haAAx = parcelRequire("haAAx");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $cywwP = parcelRequire("cywwP");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $ckGNT = parcelRequire("ckGNT");
var $iStmz = parcelRequire("iStmz");

var $4D9kL = parcelRequire("4D9kL");
parcelRequire("6LIWU");
var $70v5x = parcelRequire("70v5x");

var $fuVmc = parcelRequire("fuVmc");

var $dOx4s = parcelRequire("dOx4s");

var $get0L = parcelRequire("get0L");
parcelRequire("11L6d");
var $dCclU = parcelRequire("dCclU");
parcelRequire("g7Byd");
var $ltZH5 = parcelRequire("ltZH5");
const $89d6a3af81b596ef$var$sidebarContentStyles = null;
const $89d6a3af81b596ef$var$noop = ()=>undefined;
/**
 * With this on, the Customise menu reports the Login announcement click itself.
 */ const $89d6a3af81b596ef$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE = 'hubs_customize_menu_analytics';
const $89d6a3af81b596ef$var$isHubCustomizeMenuAnalyticsEnabled = ()=>(0, $87QgR.default).checkGate($89d6a3af81b596ef$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE);
const $89d6a3af81b596ef$var$HubHomepageCustomizeNavActionsComponent = ({ iconColor: iconColor, canAdministerJIRA: canAdministerJIRA, setEditingHelpCenter: setEditingHelpCenter })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const triggerRef = (0, $iStmz.useCustomiseSidebarTriggerRef)();
    const { isOpen: isOpen, openFromMenu: openFromMenu, close: close } = (0, $ltZH5.useHubCustomizationSidebar)('login-announcement');
    const isSidebarOpen = canAdministerJIRA && isOpen;
    const helpCenterSection = (0, $dCclU.useHelpCenterCustomizeSection)(canAdministerJIRA);
    $bSJIT.useEffect(()=>{
        setEditingHelpCenter(isSidebarOpen);
    }, [
        isSidebarOpen,
        setEditingHelpCenter
    ]);
    $bSJIT.useEffect(()=>()=>{
            setEditingHelpCenter(false);
        }, [
        setEditingHelpCenter
    ]);
    $bSJIT.useEffect(()=>{
        if (isOpen && !canAdministerJIRA) close();
    }, [
        canAdministerJIRA,
        close,
        isOpen
    ]);
    // With the gate on the menu reports this click itself, so only report it here
    // when the menu does not.
    const handleLoginAnnouncementClick = $bSJIT.useCallback(()=>{
        if (!$89d6a3af81b596ef$var$isHubCustomizeMenuAnalyticsEnabled()) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'customizeMenu',
            actionSubjectId: 'navbarLoginAnnouncement',
            analyticsType: (0, $haAAx.UI_EVENT_TYPE)
        }).fire();
        openFromMenu();
    }, [
        createAnalyticsEvent,
        openFromMenu
    ]);
    const items = $bSJIT.useMemo(()=>{
        if (!canAdministerJIRA) return [];
        const { helpCenterId: helpCenterId } = (0, $dOx4s.parseHelpCenterAri)((0, $fuVmc.getHelpCenterAri)());
        return [
            {
                label: formatMessage((0, $get0L.default).editHelpCenterLabel),
                testId: 'edit-hub-link',
                href: `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/edit-hub`,
                // Same id this item carried in the avatar menu, so its click
                // analytics survive the move.
                actionSubjectId: 'navbarCustomiseHub'
            },
            {
                label: formatMessage((0, $get0L.default).loginAnnouncementButtonLabel),
                testId: 'login-announcement-button',
                actionSubjectId: 'navbarLoginAnnouncement',
                onClick: handleLoginAnnouncementClick
            }
        ];
    }, [
        canAdministerJIRA,
        formatMessage,
        handleLoginAnnouncementClick
    ]);
    const sections = $bSJIT.useMemo(()=>[
            {
                items: items
            },
            helpCenterSection
        ].filter((section)=>Boolean(section)), [
        items,
        helpCenterSection
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $70v5x.HubCustomizeMenu), {
        sections: sections,
        iconColor: iconColor
    }), isSidebarOpen ? /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).HELP_CENTER_CUSTOMIZE_LOGIN_ANNOUNCEMENT_SIDEBAR,
        id: "hub-login-announcement-sidebar",
        renderError: ()=>null
    }, /*#__PURE__*/ $bSJIT.createElement((0, $bf3Xm.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ $bSJIT.createElement((0, $ckGNT.LazyPushingCustomizeSidebar), {
        isOpen: isSidebarOpen,
        onOpen: $89d6a3af81b596ef$var$noop,
        onClose: close,
        triggerRef: triggerRef
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $4D9kL.LazyHelpCenterBucketsRoutes), {
        isOpen: isSidebarOpen,
        onClose: close
    }))))) : null);
};
const $89d6a3af81b596ef$export$c0b4b03ead4d16ad = (0, $f2mlD.default)((state)=>({
        canAdministerJIRA: (0, $fBLyB.getCanAdministerJIRA)(state)
    }), {
    setEditingHelpCenter: (0, $cywwP.editingHelpCenter)
})($89d6a3af81b596ef$var$HubHomepageCustomizeNavActionsComponent);

});
parcelRegister("4D9kL", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterBucketsRoutes", () => $adf9d1ea33e1be89$export$d2d3e564d372d997);
// export HelpCenterBucketsRoutes from './bucket-routes';

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $adf9d1ea33e1be89$export$d2d3e564d372d997 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("gdzHe")), {
        moduleId: "./src/view/help-center-customize-sidebar/bucket-routes/bucket-routes.tsx"
    })
});

});
parcelRegister("gdzHe", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9Ncas"),
    $kOunM("iT0U5"),
    $kOunM("aX4rz"),
    $kOunM("kJlFi"),
    $kOunM("77U2l"),
    $kOunM("7bkCE"),
    $kOunM("if62Z"),
    $kOunM("GEskl")
]).then(()=>parcelRequire('6R3bh'));

});


parcelRegister("dOx4s", function(module, exports) {
$parcel$export(module.exports, "parseHelpCenterAri", () => $bbf8fffb3cebaa9b$export$2b81f3445e8c13f4);
$parcel$export(module.exports, "getHelpCenterId", () => $bbf8fffb3cebaa9b$export$7ac65eebc1dbe637);
$parcel$export(module.exports, "createHelpCenterAri", () => $bbf8fffb3cebaa9b$export$dbcb6d0534e1f531);
// eslint-disable-next-line no-restricted-imports

var $9P2Zq = parcelRequire("9P2Zq");
const $bbf8fffb3cebaa9b$export$2b81f3445e8c13f4 = (helpCenterAri)=>{
    const isValidAri = (0, $9P2Zq.HelpHelpCenterAri).check(helpCenterAri) && helpCenterAri !== 'null' && helpCenterAri !== '';
    return isValidAri ? (0, $9P2Zq.HelpHelpCenterAri).parse(helpCenterAri) : {
        helpCenterId: ''
    };
};
const $bbf8fffb3cebaa9b$export$7ac65eebc1dbe637 = (helpCenterAri)=>{
    const { helpCenterId: helpCenterId } = $bbf8fffb3cebaa9b$export$2b81f3445e8c13f4(helpCenterAri);
    return helpCenterId;
};
const $bbf8fffb3cebaa9b$export$dbcb6d0534e1f531 = (activationId, helpCenterId)=>{
    if (!helpCenterId || !activationId || helpCenterId === 'null' || activationId === 'null') return '';
    return (0, $9P2Zq.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
};

});

parcelRegister("11L6d", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterCustomizeSection", () => (parcelRequire("dCclU")).useHelpCenterCustomizeSection);

var $dCclU = parcelRequire("dCclU");

});
parcelRegister("dCclU", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterCustomizeSection", () => $466d5ceb4a60904f$export$ed4a3420f731a7b1);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $kP0P3 = parcelRequire("kP0P3");

var $cp3Es = parcelRequire("cp3Es");

var $dOx4s = parcelRequire("dOx4s");

var $get0L = parcelRequire("get0L");
parcelRequire("6snWp");
var $iD8M8 = parcelRequire("iD8M8");
const $466d5ceb4a60904f$export$ed4a3420f731a7b1 = (canAdministerJIRA)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const basePath = (0, $kP0P3.useHubBasePath)();
    const shouldUpsellPremium = (0, $cp3Es.useShouldShowPremiumUpsell)();
    return (0, $bSJIT.useMemo)(()=>{
        if (!canAdministerJIRA) return null;
        const { helpCenterId: helpCenterId } = (0, $dOx4s.parseHelpCenterAri)((0, $fuVmc.getHelpCenterAri)());
        // Same check `hub-home` makes off this base path to pick its Rovo settings URL.
        const isInJira = basePath.startsWith('/jira');
        // Jira lists help centers at the base path itself; the help-center-hosted
        // screen lists them under /hubs.
        const managementUrl = isInJira ? basePath : `${basePath}/hubs`;
        // Both screens open their create flow from the same query param.
        const createHelpCenterUrl = `${managementUrl}?create=true`;
        const rovoAgentUrl = isInJira ? `${basePath}/${helpCenterId}/settings?tab=rovo-agent` : `${basePath}/${helpCenterId}/rovo-agent`;
        // Deliberately not built from `basePath`: there is no Jira-side editor route,
        // so this stays on the help-center-hosted path in both worlds — the same thing
        // every `edit-hub` URL in `hub-home` does. It always opens the hub home page,
        // per the design, even when triggered from another page.
        const createCustomPageUrl = `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/edit-hub?createPage=true`;
        // Premium-gated: these two upsell instead of navigating when the site is not
        // entitled, so an admin is not sent to a screen they cannot use.
        const createHelpCenter = shouldUpsellPremium ? {
            label: formatMessage((0, $get0L.default).createHelpCenterLabel),
            testId: 'create-help-center-upsell',
            // Same id as the entitled link, so both read as one option.
            actionSubjectId: 'navbarCreateHelpCenter',
            analyticsAttributes: {
                isPremiumUpsell: true,
                touchpointId: 'hubs-customise-menu-create-help-center'
            },
            onClick: ()=>undefined,
            customRenderer: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iD8M8.PremiumUpsellMenuItem), {
                    label: formatMessage((0, $get0L.default).createHelpCenterLabel),
                    testId: "create-help-center-upsell",
                    touchpointId: "hubs-customise-menu-create-help-center",
                    onClick: onClick
                })
        } : {
            label: formatMessage((0, $get0L.default).createHelpCenterLabel),
            testId: 'create-help-center-link',
            href: createHelpCenterUrl,
            actionSubjectId: 'navbarCreateHelpCenter'
        };
        const createCustomPage = shouldUpsellPremium ? {
            label: formatMessage((0, $get0L.default).createCustomPageLabel),
            testId: 'create-custom-page-upsell',
            actionSubjectId: 'navbarCreateCustomPage',
            analyticsAttributes: {
                isPremiumUpsell: true,
                touchpointId: 'hubs-customise-menu-create-custom-page'
            },
            onClick: ()=>undefined,
            customRenderer: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iD8M8.PremiumUpsellMenuItem), {
                    label: formatMessage((0, $get0L.default).createCustomPageLabel),
                    testId: "create-custom-page-upsell",
                    touchpointId: "hubs-customise-menu-create-custom-page",
                    onClick: onClick
                })
        } : {
            label: formatMessage((0, $get0L.default).createCustomPageLabel),
            testId: 'create-custom-page-link',
            href: createCustomPageUrl,
            actionSubjectId: 'navbarCreateCustomPage'
        };
        return {
            heading: formatMessage((0, $get0L.default).helpCenterSectionHeading),
            items: [
                {
                    label: formatMessage((0, $get0L.default).viewAllHelpCentersLabel),
                    testId: 'view-all-help-centers-link',
                    href: managementUrl,
                    actionSubjectId: 'navbarViewAllHelpCenters'
                },
                createHelpCenter,
                createCustomPage,
                {
                    label: formatMessage((0, $get0L.default).rovoAgentLabel),
                    testId: 'rovo-agent-link',
                    href: rovoAgentUrl,
                    actionSubjectId: 'navbarRovoAgent'
                }
            ]
        };
    }, [
        canAdministerJIRA,
        formatMessage,
        basePath,
        shouldUpsellPremium
    ]);
};

});
parcelRegister("kP0P3", function(module, exports) {
$parcel$export(module.exports, "useHubBasePath", () => $5b1cd8f6672b9d62$export$eadd097d221d05e6);
/**
 * `useHubBasePath` — resolves the effective base path used to build
 * internal SPA URLs inside `HubHomeContent` and its sub-tree.
 *
 * Returns `/jira/helpcenter-management` when the
 * `jira_sidebar_show_helpcenter` experiment is enabled (i.e. the
 * Jira-embedded route is active), and falls back to
 * `/helpcenter-management` otherwise — the historical value used
 * before this hook existed, so pre-existing hosts see no
 * behavioural change.
 */ 
var $3y2s4 = parcelRequire("3y2s4");
const $5b1cd8f6672b9d62$export$eadd097d221d05e6 = ()=>{
    return (0, $3y2s4.isExperimentEnabled)('jira_sidebar_show_helpcenter') ? '/jira/helpcenter-management' : '/helpcenter-management';
};

});

parcelRegister("cp3Es", function(module, exports) {
$parcel$export(module.exports, "useShouldShowPremiumUpsell", () => $e0926bfdee7d3779$export$c54b4589f088dfd2);
/**
 * Whether this tenant should get the un-entitled treatment for Premium-gated hub
 * features — a locked editor, an upsell in place of controls, and so on.
 *
 * `=== false`, not `!isPremiumEntitled`: the flag is tri-state and `undefined`
 * means "unknown", which must never lock anything — that would take paid
 * features away from entitled customers.
 *
 * Help hubs only. `hubType` comes from the bootstrap query rather than `envJson`,
 * so it is reliable in both the view and edit experiences — Customer Service
 * (`CUSTOMER_SERVICE`) hubs are never affected regardless of how they were routed.
 *
 * Reads `HubContext` rather than `useProductDependencies`, which is only mounted
 * around hub *extensions*, not the editor or its config panels.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $hJs5J = parcelRequire("hJs5J");
const $e0926bfdee7d3779$export$c54b4589f088dfd2 = ()=>{
    const ctx = (0, $bSJIT.useContext)((0, $hJs5J.HubContext));
    if (!ctx) // e.g. Confluence Company Hub — never lock.
    return false;
    if (ctx.hubType !== 'HELP_HUB') return false;
    return ctx.isPremiumEntitled === false && (0, $gdUUy.fg)('hubs_premium_upsell');
};

});
parcelRegister("hJs5J", function(module, exports) {
$parcel$export(module.exports, "getMediaProvider", () => $f5921494c2aabc71$export$98e696b66f6bbf2b);
$parcel$export(module.exports, "HubContext", () => $f5921494c2aabc71$export$6a5aa704056d141b);
$parcel$export(module.exports, "useHubContext", () => $f5921494c2aabc71$export$ac8576a9912be18c);

var $bSJIT = parcelRequire("bSJIT");

var $9P2Zq = parcelRequire("9P2Zq");
var $hwpKw = parcelRequire("hwpKw");
const $f5921494c2aabc71$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $f5921494c2aabc71$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl, isUploadMediaConfigRequired)=>{
    const authProvider = $f5921494c2aabc71$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl);
    return {
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: authProvider,
            useSha256ForUploads: true
        },
        ...isUploadMediaConfigRequired && {
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        }
    };
};
const $f5921494c2aabc71$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $f5921494c2aabc71$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $f5921494c2aabc71$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $hwpKw.HelpPageAri).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $f5921494c2aabc71$export$6a5aa704056d141b = (0, $bSJIT.createContext)(null);
const $f5921494c2aabc71$export$ac8576a9912be18c = ()=>{
    const context = (0, $bSJIT.useContext)($f5921494c2aabc71$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};

});


parcelRegister("6snWp", function(module, exports) {
$parcel$export(module.exports, "PremiumUpsellMenuItem", () => (parcelRequire("iD8M8")).PremiumUpsellMenuItem);

var $iD8M8 = parcelRequire("iD8M8");

});
parcelRegister("iD8M8", function(module, exports) {
$parcel$export(module.exports, "PremiumUpsellMenuItem", () => $b804ef181edd656a$export$b4d4b513f166a4a2);

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $cExzV = parcelRequire("cExzV");

var $kpgiw = parcelRequire("kpgiw");

var $dLhCs = parcelRequire("dLhCs");

var $duJSM = parcelRequire("duJSM");

var $5oqa3 = parcelRequire("5oqa3");

var $8RL7A = parcelRequire("8RL7A");

var $get0L = parcelRequire("get0L");
/**
 * Has the item report its exposure when the Customise menu opens.
 */ const $b804ef181edd656a$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE = 'hubs_customize_menu_analytics';
const $b804ef181edd656a$var$isHubCustomizeMenuAnalyticsEnabled = ()=>(0, $87QgR.default).checkGate($b804ef181edd656a$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE);
const $b804ef181edd656a$export$b4d4b513f166a4a2 = ({ label: label, testId: testId, touchpointId: touchpointId, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    // `ModalTrigger` does not emit the trigger analytics the legacy trigger did, so
    // the surface reports its own view and click for parity with the other upsell
    // entry points, which is what lets the upsell funnel count this exposure.
    const fireTriggerEvent = (0, $bSJIT.useCallback)((action)=>{
        createAnalyticsEvent({
            action: action,
            eventType: 'ui',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                touchpointId: touchpointId,
                product: 'jira-service-management',
                variantId: 'help-center-customization',
                source: 'hubCustomizeMenu'
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        touchpointId
    ]);
    // The item only mounts while the menu is open, so mounting is the view.
    (0, $bSJIT.useEffect)(()=>{
        if ($b804ef181edd656a$var$isHubCustomizeMenuAnalyticsEnabled()) fireTriggerEvent('viewed');
    }, [
        fireTriggerEvent
    ]);
    const fireTriggerClicked = (0, $bSJIT.useCallback)(()=>{
        fireTriggerEvent('clicked');
        onClick === null || onClick === void 0 || onClick();
    }, [
        fireTriggerEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).HELP_CENTER,
        id: `hub-customize-menu-${touchpointId}`,
        // A broken upsell must not take the rest of the menu with it.
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5oqa3.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8RL7A.ModalTrigger), {
        entryPoint: (0, $duJSM.editionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: (0, $fuVmc.getCloudId)(),
            product: 'jira-service-management'
        },
        entryPointProps: {
            touchpointId: touchpointId,
            variantId: 'help-center-customization'
        },
        modalProps: (0, $dLhCs.MODAL_CONFIG)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
            ref: ref,
            testId: testId,
            onClick: fireTriggerClicked,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                appearance: "discovery"
            }, formatMessage((0, $get0L.default).premiumLozenge))
        }, label))));
};

});




parcelRegister("g7Byd", function(module, exports) {
$parcel$export(module.exports, "useHubCustomizationSidebar", () => (parcelRequire("ltZH5")).useHubCustomizationSidebar);

var $ltZH5 = parcelRequire("ltZH5");

});
parcelRegister("ltZH5", function(module, exports) {
$parcel$export(module.exports, "useHubCustomizationSidebar", () => $ab29f6dde2a10fc7$export$8e00b7528696d00);

var $bSJIT = parcelRequire("bSJIT");

var $5LmQo = parcelRequire("5LmQo");

var $2aw7C = parcelRequire("2aw7C");
parcelRequire("nR7qC");
var $3R7iu = parcelRequire("3R7iu");
const $ab29f6dde2a10fc7$export$8e00b7528696d00 = (experience)=>{
    const queryParams = (0, $3R7iu.useQueryParams)();
    const isOpen = queryParams.customize === 'true' && queryParams.experience === experience;
    const openFromMenu = (0, $bSJIT.useCallback)(()=>{
        (0, $5LmQo.set)({
            experience: experience,
            customize: 'true'
        }, false);
    }, [
        experience
    ]);
    const close = (0, $bSJIT.useCallback)(()=>{
        (0, $2aw7C.clearSidebarExperienceAndCustomize)();
    }, []);
    return {
        isOpen: isOpen,
        openFromMenu: openFromMenu,
        close: close
    };
};

});





parcelRegister("jly5y", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeNavActions", () => (parcelRequire("1xIMz")).HubCustomizeNavActions);

var $1xIMz = parcelRequire("1xIMz");

});
parcelRegister("1xIMz", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeNavActions", () => $f2a00ad8f942b31a$export$9fc791ebb5bc4121);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $87QgR = parcelRequire("87QgR");

var $oORS9 = parcelRequire("oORS9");

var $jcRK7 = parcelRequire("jcRK7");

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $cp3Es = parcelRequire("cp3Es");

var $4Y6IB = parcelRequire("4Y6IB");

var $dOx4s = parcelRequire("dOx4s");

var $W7P24 = parcelRequire("W7P24");

var $8G6wP = parcelRequire("8G6wP");
parcelRequire("6LIWU");
var $70v5x = parcelRequire("70v5x");

var $get0L = parcelRequire("get0L");
parcelRequire("11L6d");
var $dCclU = parcelRequire("dCclU");
parcelRequire("jHJmK");
var $01bRv = parcelRequire("01bRv");
const $f2a00ad8f942b31a$var$JSM_TMP_PORTAL_GROUPS_IN_JIRA_GATE = 'jsm_tmp_portal_groups_in_jira';
const $f2a00ad8f942b31a$var$isPortalGroupsInJiraEnabled = ()=>(0, $87QgR.default).checkGate($f2a00ad8f942b31a$var$JSM_TMP_PORTAL_GROUPS_IN_JIRA_GATE);
const $f2a00ad8f942b31a$var$HubCustomizeNavActionsComponent = ({ iconColor: iconColor, pageType: pageType, canAdministerJIRA: canAdministerJIRA, fetchPortal: fetchPortal, isProjectAdmin: isProjectAdmin, isProjectSimplified: isProjectSimplified, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [{ match: match }] = (0, $h1bGI.useRouter)();
    const helpCenterSection = (0, $dCclU.useHelpCenterCustomizeSection)(canAdministerJIRA);
    const portalGroupsInJiraEnabled = $f2a00ad8f942b31a$var$isPortalGroupsInJiraEnabled();
    const portalSettingsEnabled = (0, $87QgR.default).checkGate('hubs-show-portal-settings');
    const shouldUpsellPremium = (0, $cp3Es.useShouldShowPremiumUpsell)();
    const { portalId: portalId, id: id } = match.params;
    // Topic pages share the custom page route, so the item is only labelled for
    // the page it actually opens once the page's type is known.
    const isTopicPage = (0, $01bRv.useIsTopicPage)(pageType === (0, $4Y6IB.HubPageType).CUSTOM ? id : undefined);
    $bSJIT.useEffect(()=>{
        if (!canAdministerJIRA || !portalSettingsEnabled && !portalGroupsInJiraEnabled || pageType !== (0, $4Y6IB.HubPageType).PORTAL || !portalId || typeof isProjectAdmin === 'boolean' && typeof isProjectSimplified === 'boolean' && typeof projectKey === 'string') return;
        const portalIdAsNumber = Number(portalId);
        if (Number.isSafeInteger(portalIdAsNumber)) fetchPortal({
            id: portalIdAsNumber
        });
    }, [
        canAdministerJIRA,
        fetchPortal,
        portalGroupsInJiraEnabled,
        portalSettingsEnabled,
        isProjectSimplified,
        isProjectAdmin,
        pageType,
        portalId,
        projectKey
    ]);
    const editSection = $bSJIT.useMemo(()=>{
        if (!canAdministerJIRA) return null;
        // A page-specific route missing its own id falls back to Edit help center
        // rather than linking to whichever page the stale param belonged to.
        let label = formatMessage((0, $get0L.default).editHelpCenterLabel);
        let suffix = '';
        if (pageType === (0, $4Y6IB.HubPageType).PORTAL && portalId) {
            // Same editor either way, but Free and Standard sites can only change the
            // announcement on a portal page, so the item promises only that.
            label = formatMessage(shouldUpsellPremium ? (0, $get0L.default).editPortalAnnouncementLabel : (0, $get0L.default).editPortalPageLabel);
            suffix = `/portal/${portalId}`;
        } else if (pageType === (0, $4Y6IB.HubPageType).CUSTOM && id) {
            label = formatMessage(isTopicPage ? (0, $get0L.default).editTopicPageLabel : (0, $get0L.default).editCustomPageLabel);
            suffix = `/${id}`;
        }
        const { helpCenterId: helpCenterId } = (0, $dOx4s.parseHelpCenterAri)((0, $fuVmc.getHelpCenterAri)());
        const normalizedProjectKey = typeof projectKey === 'string' ? projectKey.toUpperCase() : undefined;
        const isPortalAdmin = pageType === (0, $4Y6IB.HubPageType).PORTAL && isProjectAdmin && normalizedProjectKey && typeof isProjectSimplified === 'boolean';
        return {
            items: [
                {
                    label: label,
                    testId: 'edit-hub-link',
                    href: `${(0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/edit-hub${suffix}`,
                    // Same id this item carried in the avatar menu, so its click
                    // analytics survive the move.
                    actionSubjectId: 'navbarCustomiseHub'
                },
                ...isPortalAdmin && portalSettingsEnabled ? [
                    {
                        label: formatMessage((0, $8G6wP.default).configurePortal),
                        testId: 'configure-portal-link',
                        href: `${(0, $oORS9.getNextgenSettingsUrl)(normalizedProjectKey)}/${isProjectSimplified ? 'channels/portal-settings' : 'portal-settings'}`,
                        actionSubjectId: 'navbarConfigurePortal',
                        target: '_blank'
                    },
                    {
                        label: formatMessage((0, $8G6wP.default).customizeRequestTypes),
                        testId: 'customize-request-types-link',
                        href: isProjectSimplified ? (0, $oORS9.getNextgenSettingsRequestTypesUrl)(normalizedProjectKey) : `${(0, $oORS9.getNextgenSettingsUrl)(normalizedProjectKey)}/request-types/`,
                        actionSubjectId: 'navbarCustomizeRequestTypes',
                        target: '_blank'
                    }
                ] : [],
                ...isPortalAdmin && portalGroupsInJiraEnabled ? [
                    {
                        label: formatMessage((0, $W7P24.default).managePortalGroupsLabel),
                        testId: 'manage-portal-groups-link',
                        href: isProjectSimplified ? (0, $oORS9.getTeamManagedPortalGroupSettingsUrl)(normalizedProjectKey) : (0, $oORS9.getPortalGroupSettingsUrl)(normalizedProjectKey),
                        actionSubjectId: 'managePortalGroupsButton'
                    }
                ] : []
            ]
        };
    }, [
        canAdministerJIRA,
        formatMessage,
        id,
        isTopicPage,
        portalGroupsInJiraEnabled,
        portalSettingsEnabled,
        pageType,
        portalId,
        isProjectSimplified,
        isProjectAdmin,
        projectKey,
        shouldUpsellPremium
    ]);
    const sections = $bSJIT.useMemo(()=>[
            editSection,
            helpCenterSection
        ].filter((section)=>Boolean(section)), [
        editSection,
        helpCenterSection
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $70v5x.HubCustomizeMenu), {
        sections: sections,
        iconColor: iconColor
    });
};
const $f2a00ad8f942b31a$var$ConnectedHubCustomizeNavActions = (0, $f2mlD.default)((state, { routePortalId: routePortalId })=>{
    const portalIdAsNumber = routePortalId !== undefined ? Number(routePortalId) : undefined;
    return {
        canAdministerJIRA: (0, $fBLyB.getCanAdministerJIRA)(state),
        isProjectAdmin: (0, $iWhHo.getCanAdministerProject)(state, portalIdAsNumber),
        isProjectSimplified: (0, $iWhHo.getIsProjectSimplified)(state, portalIdAsNumber),
        projectKey: (0, $iWhHo.getProjectKey)(state, portalIdAsNumber)
    };
}, {
    fetchPortal: (0, $jeW3I.fetchPortalAction)
})($f2a00ad8f942b31a$var$HubCustomizeNavActionsComponent);
const $f2a00ad8f942b31a$export$9fc791ebb5bc4121 = (props)=>{
    const [{ match: match }] = (0, $h1bGI.useRouter)();
    const routePortalId = typeof match.params.portalId === 'string' ? match.params.portalId : undefined;
    return /*#__PURE__*/ $bSJIT.createElement($f2a00ad8f942b31a$var$ConnectedHubCustomizeNavActions, {
        ...props,
        routePortalId: routePortalId
    });
};

});
parcelRegister("jHJmK", function(module, exports) {
$parcel$export(module.exports, "useIsTopicPage", () => (parcelRequire("01bRv")).useIsTopicPage);

var $01bRv = parcelRequire("01bRv");

});
parcelRegister("01bRv", function(module, exports) {
$parcel$export(module.exports, "useIsTopicPage", () => $c5990c370ee01a49$export$f5e07d18b80097b8);

var $dj0bw = parcelRequire("dj0bw");

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");

var $87QgR = parcelRequire("87QgR");

var $hwpKw = parcelRequire("hwpKw");

var $fuVmc = parcelRequire("fuVmc");
const $c5990c370ee01a49$var$TopicPagesQuery = (0, $dj0bw.default);
// Same gate the navbar's Topics menu and the editor's Topics panel read: with it
// off a hub has no topic pages, so there is nothing to look up.
const $c5990c370ee01a49$var$HUBS_TOPICS_GATE = 'hubs_premium_upsell';
const $c5990c370ee01a49$var$isTopicsEnabled = ()=>(0, $87QgR.default).checkGate($c5990c370ee01a49$var$HUBS_TOPICS_GATE);
const $c5990c370ee01a49$var$EMPTY_TOPIC_PAGE_IDS = [];
const $c5990c370ee01a49$var$getPageIdFromAri = (pageAri)=>{
    try {
        const parsed = (0, $hwpKw.HelpPageAri).parse(pageAri);
        return parsed.pageId;
    } catch  {
        return null;
    }
};
const $c5990c370ee01a49$export$f5e07d18b80097b8 = (pageId)=>{
    const environment = (0, $a2qIF.useRelayEnvironment)();
    const [topicPageIds, setTopicPageIds] = (0, $bSJIT.useState)($c5990c370ee01a49$var$EMPTY_TOPIC_PAGE_IDS);
    const cloudId = (0, $fuVmc.getCloudId)();
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    (0, $bSJIT.useEffect)(()=>{
        if (!pageId || !cloudId || !helpCenterAri || !$c5990c370ee01a49$var$isTopicsEnabled()) return;
        const subscription = (0, $a2qIF.fetchQuery)(environment, $c5990c370ee01a49$var$TopicPagesQuery, // View mode always renders published content, and passing `isDraft`
        // explicitly keeps the arguments identical to `navLinksQuery`'s, which
        // is what lets this resolve from the store.
        {
            cloudId: cloudId,
            hubAri: helpCenterAri,
            isDraft: false
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                var _data$helpCenter;
                const helpCenterById = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
                if ((helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.__typename) !== 'HelpCenter') return;
                setTopicPageIds((helpCenterById.topicPages ?? []).map((page)=>page !== null && page !== void 0 && page.id ? $c5990c370ee01a49$var$getPageIdFromAri(page.id) : null).filter((id)=>id !== null));
            },
            // Nothing to recover: the menu keeps the custom page label, which is
            // what it shows for every page of this route today.
            error: ()=>setTopicPageIds($c5990c370ee01a49$var$EMPTY_TOPIC_PAGE_IDS)
        });
        return ()=>subscription.unsubscribe();
    }, [
        cloudId,
        environment,
        helpCenterAri,
        pageId
    ]);
    return !!pageId && topicPageIds.includes(pageId);
};

});
parcelRegister("dj0bw", function(module, exports) {
$parcel$export(module.exports, "default", () => $59f45b12ff026897$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d52be667a26174d3523663c1159cb1f0>>
 * @relayHash 8c98fb75af10eba733df196552019aca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3971ebc68ae273d86e6d6a0691f1354685a419f21cba1e62dd711eea6d067b2a
const $59f45b12ff026897$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hubAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "topicPages",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "ids": [],
                            "type": "TOPIC"
                        }
                    }
                ],
                "concreteType": "HelpCenterPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": v4 /*: any*/ ,
                "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsTopicPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsTopicPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3971ebc68ae273d86e6d6a0691f1354685a419f21cba1e62dd711eea6d067b2a",
            "metadata": {},
            "name": "useIsTopicPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$59f45b12ff026897$var$node.hash = "5ae91eb56209fb8899ab523142eaf60d";
var $59f45b12ff026897$export$2e2bcd8739ae039 = $59f45b12ff026897$var$node;

});





parcelRegister("5RqCf", function(module, exports) {
$parcel$export(module.exports, "createHubHomepageRoute", () => $08920fa0be93d991$export$5dafaf7a5091e51);
$parcel$export(module.exports, "createHubCustomPageRoute", () => $08920fa0be93d991$export$394540a667e798bf);
$parcel$export(module.exports, "createHubPortalPageRoute", () => $08920fa0be93d991$export$c7ef2adac2336d4a);
$parcel$export(module.exports, "createRouteWithHubShell", () => $08920fa0be93d991$export$bf7b7ea558d32a05);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");

var $gdUUy = parcelRequire("gdUUy");

var $1qPbZ = parcelRequire("1qPbZ");

var $1DGz6 = parcelRequire("1DGz6");

var $hDkm2 = parcelRequire("hDkm2");

var $dvW5v = parcelRequire("dvW5v");

var $hNRax = parcelRequire("hNRax");

var $4Io6U = parcelRequire("4Io6U");

var $itx7D = parcelRequire("itx7D");

var $3m0bI = parcelRequire("3m0bI");

var $hHHpU = parcelRequire("hHHpU");

var $cPJhk = parcelRequire("cPJhk");

var $bnjHu = parcelRequire("bnjHu");

var $gLJf4 = parcelRequire("gLJf4");

var $gK4pW = parcelRequire("gK4pW");
const $08920fa0be93d991$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc",
    root: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _1tke1osq _1bsb1osq"
};
const $08920fa0be93d991$export$74c90840fe177d0a = {
    component: (0, $bnjHu.HubApp),
    exact: true,
    name: (0, $gK4pW.HUB_ROUTE_NAME),
    resources: [
        (0, $hHHpU.hubBootstrapResource),
        (0, $hHHpU.hubPageResource)
    ],
    path: (0, $gdUUy.fg)('enable-ssr-for-hubs') ? (0, $gK4pW.HUB_ROUTE_PATH_OPTIONAL_SLASH) : (0, $gK4pW.HUB_ROUTE_PATH)
};
const $08920fa0be93d991$export$ccad182393585435 = {
    component: (0, $bnjHu.HubApp),
    exact: true,
    name: (0, $gK4pW.HUB_CUSTOM_PAGE_ROUTE_NAME),
    resources: [
        (0, $hHHpU.hubBootstrapResource),
        (0, $hHHpU.hubPageResource)
    ],
    path: (0, $gK4pW.HUB_CUSTOM_PAGE_ROUTE_PATH)
};
const $08920fa0be93d991$var$isSupportSiteHeaderlessEnabled = ()=>typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('headerless') === 'true' && (0, $gdUUy.fg)('csm-support-site-headerless-query-param');
/**
 * Whether to preload `rovoWidgetProviderQuery` as a route resource.
 *
 * Skipped once `hubs_rovo_config_from_kosh` is on, because `hubQuery` then carries `rovoConfig`
 * (served by help-kosh from convo-ai's licence-independent resolver) and is the only source of
 * truth. The callout banner skips its own lazy load off the same gate, so with the gate on this
 * query does not run at all — including when help-kosh resolves the field to null, which is its
 * answer rather than a reason to ask again.
 */ const $08920fa0be93d991$var$shouldPreloadRovoWidgetQuery = ()=>(0, $gdUUy.fg)('hub_preload_rovo_widget_query') && !(0, $gdUUy.fg)('hubs_rovo_config_from_kosh');
const $08920fa0be93d991$var$shouldPreloadNavigationBarQuery = (hubAppProps)=>{
    var _hubAppProps$featureF;
    return (0, $gdUUy.fg)('hub_preload_navigation_bar_query') && ((_hubAppProps$featureF = hubAppProps.featureFlags) === null || _hubAppProps$featureF === void 0 ? void 0 : _hubAppProps$featureF.hub_component_upgrade) === true;
};
const $08920fa0be93d991$var$getHubRouteResources = (resources, hubAppProps)=>[
        ...resources,
        ...$08920fa0be93d991$var$shouldPreloadNavigationBarQuery(hubAppProps) ? [
            (0, $hHHpU.createNavigationBarResource)(hubAppProps)
        ] : [],
        ...$08920fa0be93d991$var$shouldPreloadRovoWidgetQuery() ? [
            (0, $hHHpU.rovoWidgetResource)
        ] : []
    ];
const $08920fa0be93d991$export$5dafaf7a5091e51 = (hubAppProps)=>{
    const HubAppComponent = ()=>{
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bnjHu.HubApp), {
            ...hubAppProps,
            headerless: $08920fa0be93d991$var$isSupportSiteHeaderlessEnabled(),
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$08920fa0be93d991$export$74c90840fe177d0a,
        component: HubAppComponent,
        resources: $08920fa0be93d991$var$getHubRouteResources($08920fa0be93d991$export$74c90840fe177d0a.resources, hubAppProps)
    };
};
const $08920fa0be93d991$export$8b1ac9e5cb498cd8 = ()=>{
    const hubRoute = $08920fa0be93d991$export$5dafaf7a5091e51((0, $dvW5v.mockHubRouteProps));
    return {
        ...hubRoute,
        path: (0, $gK4pW.HUB_PREVIEW_ROUTE_PATH),
        name: (0, $gK4pW.HUB_PREVIEW_ROUTE_NAME)
    };
};
const $08920fa0be93d991$export$394540a667e798bf = (hubAppProps)=>{
    const HubCustomPageComponent = ({ match: match })=>{
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bnjHu.HubApp), {
            ...hubAppProps,
            customPageBreadcrumbPath: match.url,
            headerless: $08920fa0be93d991$var$isSupportSiteHeaderlessEnabled(),
            showPageNameAsHubDocumentTitle: true,
            showCustomPageBreadcrumbs: true
        });
    };
    return {
        ...$08920fa0be93d991$export$ccad182393585435,
        component: HubCustomPageComponent,
        resources: $08920fa0be93d991$var$getHubRouteResources($08920fa0be93d991$export$ccad182393585435.resources, hubAppProps)
    };
};
const $08920fa0be93d991$export$c6260de3189c8f50 = {
    component: (0, $bnjHu.HubApp),
    exact: true,
    name: (0, $gK4pW.HUB_PORTAL_PAGE_ROUTE_NAME),
    resources: [
        (0, $hHHpU.hubBootstrapResource),
        (0, $hHHpU.hubPageResource)
    ],
    path: (0, $gK4pW.HUB_PORTAL_PAGE_ROUTE_PATH)
};
const $08920fa0be93d991$export$c7ef2adac2336d4a = (hubAppProps)=>{
    const HubPortalPageComponent = ({ match: match })=>{
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bnjHu.HubApp), {
            ...hubAppProps,
            portalBreadcrumbPath: match.url,
            showPageNameAsHubDocumentTitle: true,
            showPortalBreadcrumbs: true
        });
    };
    return {
        ...$08920fa0be93d991$export$c6260de3189c8f50,
        component: HubPortalPageComponent,
        resources: $08920fa0be93d991$var$getHubRouteResources($08920fa0be93d991$export$c6260de3189c8f50.resources, hubAppProps)
    };
};
const $08920fa0be93d991$export$bf7b7ea558d32a05 = (hubAppProps, InnerComponent, path, name, resources, componentWidth, options)=>{
    const Component = ()=>{
        const { queryReference: hubBootstrapQueryReference } = (0, $cPJhk.useRelayResource)((0, $hHHpU.hubBootstrapResource));
        if (!hubBootstrapQueryReference) return null;
        const InnerComponentWithRouter = (0, $hbIgt.withRouter)(InnerComponent);
        const ComponentWithBannerBackgroundColor = (0, $gLJf4.withBannerBackgroundColor)(InnerComponentWithRouter);
        const cloudId = hubBootstrapQueryReference.variables.cloudId;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1DGz6.default), {
            name: "hub-shell",
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $itx7D.HubErrorBoundary), {
                shouldForceError: true,
                id: "route-with-hub-shell",
                packageName: "@atlassian/hub",
                fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hNRax.GenericErrorPage), {}),
                operationNames: [
                    'hubBootstrapWrapperQuery'
                ],
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
                    fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                        name: "hub-shell-loader",
                        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            className: (0, $9fU1q.default)([
                                $08920fa0be93d991$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                                size: 'large'
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4Io6U.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        ...hubAppProps,
                        cloudId: cloudId,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3m0bI.HubAppShell), {
                            hideNavbar: options === null || options === void 0 ? void 0 : options.hideNavbar,
                            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                style: {
                                    maxWidth: (0, $gLJf4.getContentWidth)(componentWidth)
                                },
                                className: (0, $9fU1q.default)([
                                    $08920fa0be93d991$var$styles.root
                                ]),
                                children: /*#__PURE__*/ (0, $dc70d.jsx)(ComponentWithBannerBackgroundColor, {})
                            })
                        })
                    })
                })
            })
        });
    };
    return {
        component: Component,
        exact: true,
        name: name,
        path: path,
        resources: [
            (0, $hHHpU.hubBootstrapResource),
            ...resources
        ]
    };
};

});
parcelRegister("dvW5v", function(module, exports) {
$parcel$export(module.exports, "mockHubRouteProps", () => $daa5bff20c019926$export$427679abd9cc3708);

var $bSJIT = parcelRequire("bSJIT");
const $daa5bff20c019926$export$60332b2344f7fe41 = ({ url: url = '', onError: onError = (_error)=>{}, children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": `smart-card-${url}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("button", {
        onClick: ()=>onError({
                status: 'not_found'
            })
    }, "Trigger not_found error status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("button", {
        onClick: ()=>onError({
                status: 'unauthorized'
            })
    }, "Trigger unauthorized error status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("button", {
        onClick: ()=>onError({
                status: 'forbidden'
            })
    }, "Trigger forbidden error status"), children);
const $daa5bff20c019926$export$7b5e1b7f9a325b6 = $daa5bff20c019926$export$60332b2344f7fe41;
const $daa5bff20c019926$export$2e4ce4ce734f69e1 = ({ primary: primary = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, primary.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: name
        }, "Primary metadata: ", name)));
const $daa5bff20c019926$export$50a6a2d597e669c = ({ children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, "CustomBlock", children);
const $daa5bff20c019926$export$fff1c9c894fd3e9c = ({ overrideUrl: overrideUrl = 'NONE' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, "Preview: ", overrideUrl);
const $daa5bff20c019926$export$ababd1478ac17bc0 = ({ text: text = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, "Snippet: ", text);
const $daa5bff20c019926$export$ccf187e9bb6e68c = ({ metadata: metadata = [], text: text = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, !!text ? text : 'TitleBlock', metadata.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: name
        }, "Metadata: ", name)));
const $daa5bff20c019926$export$427679abd9cc3708 = {
    actions: {
        onLogoutClick: ()=>({
                type: 'epic.logout.LOG_OUT'
            })
    },
    env: {
        cloudId: '17554ffe-ef18-4562-8222-e295e81a46bb',
        helpCenterAri: 'ari:cloud:help::help-center/5b32ba66-fea2-4010-893d-278bfac050bc/5e67e6f9-7753-41fa-811b-55cb9fd71897',
        helpCenterId: '5e67e6f9-7753-41fa-811b-55cb9fd71897',
        hoistedProjectKey: 'TR',
        hubEditMode: false,
        jiraDisplayUrl: '/',
        relativeBaseUrl: '/'
    },
    layout: {
        bannerText: '',
        isAnonymousRoute: false,
        showBanner: false
    },
    user: {
        avatarSrc: '',
        displayName: 'test_name',
        email: 'test@atlassian.com',
        id: 'some_random_id',
        isJiraAdmin: false
    }
};

});

parcelRegister("hNRax", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => $cfb9e955775165c8$export$5d76009b056f3e5d);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $7WQx2 = parcelRequire("7WQx2");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $czY77 = parcelRequire("czY77");

var $fqBBt = parcelRequire("fqBBt");
const $cfb9e955775165c8$var$styles = {
    image: "_1bsbclpc",
    root: "_4t3i1osq _n3tdxncg",
    content: "_y3gn1h6o _p12f1dup"
};
const $cfb9e955775165c8$export$5d76009b056f3e5d = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $cfb9e955775165c8$var$styles.root
    }, /*#__PURE__*/ $bSJIT.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($czY77))),
        alt: "error page",
        className: (0, $9fU1q.default)([
            $cfb9e955775165c8$var$styles.image
        ])
    }), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $cfb9e955775165c8$var$styles.content
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "xlarge"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $fqBBt.default).genericErrorHeading)), /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $fqBBt.default).genericErrorDescription)))));
};

});
parcelRegister("czY77", function(module, exports) {
module.exports = new URL("../images/error-icon.fcea7b28.svg", import.meta.url).toString();

});

parcelRegister("fqBBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bc261c087a22df2$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4bc261c087a22df2$var$_default_1 = (0, $f0Pt4.defineMessages)({
    genericErrorHeading: {
        id: 'company-hub.generic-error-page.heading',
        defaultMessage: "We're on it",
        description: 'The text is shown as the main heading on the generic error page displayed when an unexpected error occurs in a Company Hub page, reassuring users that the issue is being addressed.'
    },
    genericErrorDescription: {
        id: 'company-hub.generic-error-page.description',
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'The text is shown as the body paragraph on the generic error page in Company Hub, explaining to users that an unexpected error occurred and the team is working to restore functionality.'
    }
});
var $4bc261c087a22df2$export$2e2bcd8739ae039 = $4bc261c087a22df2$var$_default_1;

});


parcelRegister("4Io6U", function(module, exports) {
$parcel$export(module.exports, "HubBootstrap", () => $7c33d2dd7b70cbb5$export$caae1ac058a7a032);
$parcel$export(module.exports, "HubBootstrapWrapper", () => $7c33d2dd7b70cbb5$export$5f7521758ed90a1b);

var $c4JCQ = parcelRequire("c4JCQ");

var $1NOyA = parcelRequire("1NOyA");

var $5OrPp = parcelRequire("5OrPp");

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");

var $gdUUy = parcelRequire("gdUUy");

var $53RlD = parcelRequire("53RlD");

var $dsKYd = parcelRequire("dsKYd");

var $eJ5U1 = parcelRequire("eJ5U1");

var $axsoS = parcelRequire("axsoS");

var $3YmaA = parcelRequire("3YmaA");

var $hJs5J = parcelRequire("hJs5J");

var $8dfFn = parcelRequire("8dfFn");

var $fFUol = parcelRequire("fFUol");

var $eIwmz = parcelRequire("eIwmz");
/**
 * Narrows the page-scoped media config returned by the bootstrap fragment
 * (where every field is nullable due to `@skip(if: $skipPageMediaConfig)`) to
 * the non-nullable shape expected by `HubContext.pageMediaConfig`. Returns
 * `undefined` when any required field is missing so the caller can omit the
 * key from the context value entirely.
 */ const $7c33d2dd7b70cbb5$var$getPageMediaConfigFromBootstrap = (input)=>{
    if (!input) return undefined;
    const { asapIssuer: asapIssuer, mediaCollectionName: mediaCollectionName, mediaToken: mediaToken, mediaUrl: mediaUrl } = input;
    if (asapIssuer == null || mediaCollectionName == null || mediaToken == null || mediaUrl == null) return undefined;
    return {
        asapIssuer: asapIssuer,
        mediaCollectionName: mediaCollectionName,
        mediaToken: mediaToken,
        mediaUrl: mediaUrl
    };
};
const $7c33d2dd7b70cbb5$export$caae1ac058a7a032 = ({ bootstrapQueryReference: bootstrapQueryReference, tenantContextsQueryReference: tenantContextsQueryReference, children: children, cloudId: cloudId, isInPreviewMode: isInPreviewMode = false, ...props })=>{
    var _tenantData$tenantCon, _data$helpCenterById, _branding$colors, _branding$colors2, _data$helpCenterById2, _data$helpCenterById3;
    // `skipPageMediaConfig` defaults to `false` so callers that don't pass it
    // fall back to the original behavior of fetching pageMediaConfig in the
    // bootstrap. The wrapper query passes a value derived from the fix flag.
    const data = (0, $a2qIF.useFragment)((0, $5OrPp.default), bootstrapQueryReference);
    const tenantData = (0, $a2qIF.useFragment)((0, $1NOyA.default), tenantContextsQueryReference);
    const cloudUrl = ((_tenantData$tenantCon = tenantData.tenantContexts) === null || _tenantData$tenantCon === void 0 || (_tenantData$tenantCon = _tenantData$tenantCon[0]) === null || _tenantData$tenantCon === void 0 ? void 0 : _tenantData$tenantCon.cloudUrl) ?? window.location.origin;
    if (!data.helpCenterById) throw new Error('Help center not found');
    const branding = (_data$helpCenterById = data.helpCenterById) === null || _data$helpCenterById === void 0 ? void 0 : _data$helpCenterById.helpCenterBranding;
    const logo = branding === null || branding === void 0 ? void 0 : branding.logo;
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? undefined;
    // BE persists the secondary brand color as `secondaryColor` on
    // HelpCenterBrandingColors. We expose it on the FE context as `accent`
    // to match the existing HubThemingContext / panel terminology (admin
    // label is "Accent color"). The bridge happens here at the data
    // boundary.
    const accentColor = (branding === null || branding === void 0 || (_branding$colors2 = branding.colors) === null || _branding$colors2 === void 0 ? void 0 : _branding$colors2.secondaryColor) ?? undefined;
    // Map the BE typography shape (`{ headingFont, bodyFont }`, FontKey strings
    // or null) to the FE `HubTypography` ({ heading, body }). Either side may be
    // null independently — fall back to Atlassian Sans for the missing one. When
    // neither is set we leave `typography` undefined so HubTypographyScope
    // no-ops and the framework default (Atlassian Sans) applies. This is the
    // single read seam that feeds BOTH the editor and all help-seeker view
    // pages — they share this bootstrap.
    //
    // `toFontKey` validates each value against FONT_REGISTRY rather than blindly
    // casting: an unrecognised backend string (a font added server-side before
    // this enum ships, a migration) would otherwise reach the registry lookups
    // in HubTypographyScope / buildGoogleFontsUrl and throw on `undefined`.
    const beTypography = branding === null || branding === void 0 ? void 0 : branding.typography;
    const headingFont = (beTypography === null || beTypography === void 0 ? void 0 : beTypography.headingFont) ?? undefined;
    const bodyFont = (beTypography === null || beTypography === void 0 ? void 0 : beTypography.bodyFont) ?? undefined;
    // Stable reference keyed on the primitive font strings so the
    // hubContextValue memo below can depend on `typography` directly without
    // recomputing on every render (and exhaustive-deps stays satisfied).
    const typography = (0, $bSJIT.useMemo)(()=>headingFont || bodyFont ? {
            heading: (0, $fFUol.toFontKey)(headingFont),
            body: (0, $fFUol.toFontKey)(bodyFont)
        } : undefined, [
        headingFont,
        bodyFont
    ]);
    // Hub-wide corner radius. The BE field is `HelpCenterBranding.cornerRadius`
    // (distinct from `navigationBar.cornerRadius`). `?? undefined` normalises
    // GraphQL null to undefined so absent vs. not-set are indistinguishable to
    // consumers — both fall back to the framework default (8 px).
    const cornerRadius = (branding === null || branding === void 0 ? void 0 : branding.cornerRadius) ?? undefined;
    // Hub-wide space density. The BE field is `HelpCenterBranding.spaceDensity`
    // (`HelpCenterSpaceDensity` enum). `toSpaceDensity` validates the value and
    // normalises null / unrecognised to undefined so absent vs. not-set are
    // indistinguishable to consumers — both fall back to the framework default
    // spacing.
    const spaceDensity = (0, $8dfFn.toSpaceDensity)(branding === null || branding === void 0 ? void 0 : branding.spaceDensity);
    const fileId = (logo === null || logo === void 0 ? void 0 : logo.fileId) || '';
    const url = (logo === null || logo === void 0 ? void 0 : logo.url) || '';
    const hubType = ((_data$helpCenterById2 = data.helpCenterById) === null || _data$helpCenterById2 === void 0 ? void 0 : _data$helpCenterById2.type) || '';
    const hubName = ((_data$helpCenterById3 = data.helpCenterById) === null || _data$helpCenterById3 === void 0 || (_data$helpCenterById3 = _data$helpCenterById3.name) === null || _data$helpCenterById3 === void 0 ? void 0 : _data$helpCenterById3.default) ?? undefined;
    // Convert the logo to a base64 data URL so the signed token embedded in the
    // original URL never expires while the user has the page open.
    const [logoUrl, setLogoUrl] = (0, $bSJIT.useState)(url);
    const prevUrlRef = (0, $bSJIT.useRef)(url);
    if (prevUrlRef.current !== url) {
        prevUrlRef.current = url;
        setLogoUrl(url);
    }
    (0, $bSJIT.useEffect)(()=>{
        if (!url) return;
        let cancelled = false;
        fetch(url).then((res)=>res.blob()).then((blob)=>new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            })).then((base64)=>{
            if (!cancelled) setLogoUrl(base64);
        }).catch(()=>{
        // Silently fall back to the original signed URL if the fetch fails.
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        url
    ]);
    const navigationBar = (branding === null || branding === void 0 ? void 0 : branding.navigationBar) ?? null;
    // When the fix flag is ON, `pageMediaConfig` is omitted from the bootstrap
    // and is instead provided by the page-scoped `Hub` (read mode) and `HubInfo`
    // (edit mode) components via a nested `HubContext.Provider`. When the flag
    // is OFF the bootstrap still fetches it (via `$pageAri`) and provides it
    // here as before.
    const bootstrapPageMediaConfig = (0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media') ? undefined : $7c33d2dd7b70cbb5$var$getPageMediaConfigFromBootstrap(data.pageMediaConfig);
    // Memoize the context value so that consumers (e.g. `Hub`) receive a stable
    // reference across re-renders. Without this, every render of `HubBootstrap`
    // produces a new object literal, causing all `useHubContext()` consumers to
    // re-render even when nothing meaningful has changed. This is especially
    // important for the `useMemo` in `Hub` that merges `pageMediaConfig` into
    // the context — its deps array includes `hubContext`, so it needs a stable
    // input to avoid recomputing on every render.
    const hubContextValue = (0, $bSJIT.useMemo)(()=>({
            ...bootstrapPageMediaConfig ? {
                pageMediaConfig: bootstrapPageMediaConfig
            } : {},
            hubMediaConfig: data.hubMediaConfig,
            branding: {
                logo: {
                    fileId: fileId,
                    url: logoUrl
                },
                colors: {
                    primary: primaryColor || (0, $53RlD.DEFAULT_BRANDING_COLOR),
                    // `accent` is intentionally NOT defaulted here — the
                    // HubThemingProvider owns the FE-side default so a single
                    // constant governs both "no BE field set" (returns null)
                    // and "outside HubBootstrap entirely" (Confluence/CSM)
                    // cases. Passing `undefined` lets the provider's
                    // `branding?.colors?.accent ?? DEFAULT_ACCENT` shortcut
                    // kick in either way.
                    ...accentColor ? {
                        accent: accentColor
                    } : {}
                },
                // Only present when the BE has a stored choice; undefined falls
                // through to the Atlassian Sans framework default downstream.
                ...typography ? {
                    typography: typography
                } : {},
                // Only present when the BE has a stored value; undefined means
                // consumers fall back to the framework default (8 px).
                ...cornerRadius !== undefined ? {
                    cornerRadius: cornerRadius
                } : {},
                // Only present when the BE has a stored value; undefined means
                // consumers fall back to the framework default spacing.
                ...spaceDensity ? {
                    spaceDensity: spaceDensity
                } : {}
            },
            layout: props.layout,
            user: props.user,
            env: props.env,
            actions: props.actions,
            containerStyling: props.containerStyling,
            renderAvatarMenuOptions: props.renderAvatarMenuOptions,
            renderCustomNavActions: props.renderCustomNavActions,
            renderRightNavActions: props.renderRightNavActions,
            featureFlags: props.featureFlags,
            edition: props.edition,
            headerless: props.headerless,
            isPremiumEntitled: props.isPremiumEntitled,
            hubName: hubName,
            migrationReview: props.migrationReview,
            cloudId: cloudId,
            cloudUrl: cloudUrl,
            hubType: hubType,
            isInPreviewMode: isInPreviewMode
        }), [
        bootstrapPageMediaConfig,
        data.hubMediaConfig,
        fileId,
        logoUrl,
        primaryColor,
        accentColor,
        typography,
        cornerRadius,
        spaceDensity,
        props.layout,
        props.user,
        props.env,
        props.actions,
        props.containerStyling,
        props.renderAvatarMenuOptions,
        props.renderCustomNavActions,
        props.renderRightNavActions,
        props.featureFlags,
        props.edition,
        props.headerless,
        props.isPremiumEntitled,
        hubName,
        props.migrationReview,
        cloudId,
        cloudUrl,
        hubType,
        isInPreviewMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hJs5J.HubContext).Provider, {
        value: hubContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dsKYd.HubThemingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7c33d2dd7b70cbb5$var$NavigationStyleProvider, {
        navigationBar: navigationBar,
        primaryColor: primaryColor
    }, children)));
};
/**
 * Provides the `NavigationStyleContext` derived from the BE navigation-bar
 * branding.
 *
 * IMPORTANT — why this is a separate component:
 * The corner-radius gate (`useIsHubCornerRadiusEnabled` →
 * `useIsAdvancedThemingEnabled`) reads `useContext(HubContext)`. It MUST run
 * *inside* the `<HubContext.Provider>` that `HubBootstrap` renders — otherwise
 * (as when it was inlined in `HubBootstrap` above the provider) it reads the
 * absent outer context, always resolves `false`, and the mapper coerces an
 * unset `navigationBar.cornerRadius` (null) to the 8px default. That pins the
 * navbar and stops it inheriting the hub-wide radius in view mode. Evaluating
 * the gate here keeps it consistent with the page-scoped `Hub` mapper so the
 * navbar correctly inherits (null) until an explicit radius is set.
 */ const $7c33d2dd7b70cbb5$var$NavigationStyleProvider = ({ navigationBar: navigationBar, primaryColor: primaryColor, children: children })=>{
    const isCornerRadiusEnabled = (0, $3YmaA.useIsHubCornerRadiusEnabled)();
    const isAdvancedThemingEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    const navStyleOptions = (0, $bSJIT.useMemo)(()=>({
            options: navigationBar ? (0, $eIwmz.mapApiToNavigationOptions)(navigationBar, primaryColor, isCornerRadiusEnabled, isAdvancedThemingEnabled) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        primaryColor,
        isCornerRadiusEnabled,
        isAdvancedThemingEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eJ5U1.NavigationStyleContext).Provider, {
        value: navStyleOptions
    }, children);
};
const $7c33d2dd7b70cbb5$export$5f7521758ed90a1b = ({ children: children, queryReference: queryReference, ...props })=>{
    const data = (0, $a2qIF.usePreloadedQuery)((0, $c4JCQ.default), queryReference);
    if (!data.helpCenter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7c33d2dd7b70cbb5$export$caae1ac058a7a032, {
        bootstrapQueryReference: data.helpCenter,
        tenantContextsQueryReference: data,
        ...props
    }, children);
};

});
parcelRegister("c4JCQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbfa3b44eae30385$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a27c8604be208843cc1a0e8052a82427>>
 * @relayHash 888781c9fe90b2f4e05676de22fb5522
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 377e7ad9a780ab506407e2fc59fcd57d811ef9197f8d5e89d0b946e31055a08a
const $dbfa3b44eae30385$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPageMediaConfig"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "pageAri",
                                    "variableName": "pageAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "skipPageMediaConfig",
                                    "variableName": "skipPageMediaConfig"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "condition": "skipPageMediaConfig",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "pageMediaConfig",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "ari",
                                            "variableName": "pageAri"
                                        },
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "concreteType": "HelpCenterMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "hubMediaConfig",
                                    "plural": false,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterNavigationBar",
                                                    "kind": "LinkedField",
                                                    "name": "navigationBar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "backgroundColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderType"
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "padding"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "positionType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "textColor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingTypography",
                                                    "kind": "LinkedField",
                                                    "name": "typography",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "headingFont"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "bodyFont"
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "spaceDensity"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "377e7ad9a780ab506407e2fc59fcd57d811ef9197f8d5e89d0b946e31055a08a",
            "metadata": {},
            "name": "hubBootstrapWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dbfa3b44eae30385$var$node.hash = "86640fbb58e4cc03ace693195e50e046";
var $dbfa3b44eae30385$export$2e2bcd8739ae039 = $dbfa3b44eae30385$var$node;

});

parcelRegister("1NOyA", function(module, exports) {
$parcel$export(module.exports, "default", () => $208ff093f0e933aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<042bc6b2c3f711f749a6f3aaf17ffbc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $208ff093f0e933aa$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "hubEditMode"
        }
    ],
    "kind": "Fragment",
    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference",
    "selections": [
        {
            "condition": "hubEditMode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cloudUrl"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$208ff093f0e933aa$var$node.hash = "951df66590a0cca5f7516d267ed12179";
var $208ff093f0e933aa$export$2e2bcd8739ae039 = $208ff093f0e933aa$var$node;

});

parcelRegister("5OrPp", function(module, exports) {
$parcel$export(module.exports, "default", () => $be8c2d585a6efa9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52871c826a7c9b288f54b36388441b3a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be8c2d585a6efa9e$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v1 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v2 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v3 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v5 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "hubAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDraft"
            },
            {
                "kind": "RootArgument",
                "name": "operationType"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "pageAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipPageMediaConfig"
            }
        ],
        "kind": "Fragment",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "hubAri"
                        },
                        v0 /*: any*/ ,
                        v1 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterMediaConfig",
                    "kind": "LinkedField",
                    "name": "hubMediaConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v4 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW"
                        }
                    ]
                },
                "action": "THROW"
            },
            {
                "condition": "skipPageMediaConfig",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "alias": "pageMediaConfig",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "ari",
                                "variableName": "pageAri"
                            },
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ],
                        "concreteType": "HelpCenterMediaConfig",
                        "kind": "LinkedField",
                        "name": "hubMediaConfig",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "helpCenterAri",
                        "variableName": "hubAri"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "concreteType": "HelpCenterName",
                                "kind": "LinkedField",
                                "name": "name",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "default"
                                    }
                                ]
                            },
                            {
                                "concreteType": "HelpCenterBranding",
                                "kind": "LinkedField",
                                "name": "helpCenterBranding",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLogo",
                                        "kind": "LinkedField",
                                        "name": "logo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fileId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterBrandingColors",
                                        "kind": "LinkedField",
                                        "name": "colors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "primary"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "secondaryColor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterNavigationBar",
                                        "kind": "LinkedField",
                                        "name": "navigationBar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "backgroundColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderType"
                                            },
                                            v6 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "padding"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "positionType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "textColor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterBrandingTypography",
                                        "kind": "LinkedField",
                                        "name": "typography",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "headingFont"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "bodyFont"
                                            }
                                        ]
                                    },
                                    v6 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "spaceDensity"
                                    }
                                ]
                            }
                        ],
                        "type": "HelpCenter"
                    }
                ]
            }
        ],
        "type": "HelpCenterQueryApi"
    };
}();
$be8c2d585a6efa9e$var$node.hash = "3078bc0e48a16d0464bbdd1221708a30";
var $be8c2d585a6efa9e$export$2e2bcd8739ae039 = $be8c2d585a6efa9e$var$node;

});

parcelRegister("53RlD", function(module, exports) {
$parcel$export(module.exports, "SPOTLIGHT_EXTENSION_TYPE", () => $616a9108cbeef2ed$export$df3c2062a081a534);
$parcel$export(module.exports, "SECTION_EXTENSION_TYPE", () => $616a9108cbeef2ed$export$4454075c4322ae47);
$parcel$export(module.exports, "RESOURCE_TILES_EXTENSION_TYPE", () => $616a9108cbeef2ed$export$2dd5fc71941a6787);
$parcel$export(module.exports, "DEFAULT_BRANDING_COLOR", () => $616a9108cbeef2ed$export$8e1a1e8b8109dbf3);
$parcel$export(module.exports, "HUB_PRIMARY_COLOR_CSS_VAR", () => $616a9108cbeef2ed$export$8161b1f4e2928fa0);
$parcel$export(module.exports, "HUB_PRIMARY_TEXT_COLOR_CSS_VAR", () => $616a9108cbeef2ed$export$94d2a2331edd895d);
$parcel$export(module.exports, "HUB_PRIMARY_LINK_COLOR_CSS_VAR", () => $616a9108cbeef2ed$export$64de52c9db8240f6);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT", () => $616a9108cbeef2ed$export$4c91e7265b76e3a1);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT_LEGACY", () => $616a9108cbeef2ed$export$d713f99e5e84a256);
$parcel$export(module.exports, "SENTRY_DSN", () => $616a9108cbeef2ed$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "UNKNOWN_TAG", () => $616a9108cbeef2ed$export$ea77880e3935182d);
$parcel$export(module.exports, "NETWORK_ERROR_CODE", () => $616a9108cbeef2ed$export$c7f012c6e67c4217);
const $616a9108cbeef2ed$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $616a9108cbeef2ed$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $616a9108cbeef2ed$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $616a9108cbeef2ed$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $616a9108cbeef2ed$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $616a9108cbeef2ed$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $616a9108cbeef2ed$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $616a9108cbeef2ed$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $616a9108cbeef2ed$export$8e1a1e8b8109dbf3 = '#003172';
const $616a9108cbeef2ed$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $616a9108cbeef2ed$export$94d2a2331edd895d = '--hub-primary-text-color';
const $616a9108cbeef2ed$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $616a9108cbeef2ed$export$4c91e7265b76e3a1 = '32px';
const $616a9108cbeef2ed$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $616a9108cbeef2ed$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $616a9108cbeef2ed$export$ea77880e3935182d = 'unknown';
const $616a9108cbeef2ed$export$c7f012c6e67c4217 = 0;

});

parcelRegister("dsKYd", function(module, exports) {
$parcel$export(module.exports, "HubThemingProvider", () => $32191603529fa1f7$export$637b3c4e057a01d3);
$parcel$export(module.exports, "useHubTheming", () => $32191603529fa1f7$export$33bfea475043649c);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $clpci = parcelRequire("clpci");

var $7E5z7 = parcelRequire("7E5z7");

var $d2gH4 = parcelRequire("d2gH4");

var $lkNTb = parcelRequire("lkNTb");

var $53RlD = parcelRequire("53RlD");

var $hJs5J = parcelRequire("hJs5J");

var $Cc5Nl = parcelRequire("Cc5Nl");
var $eHTbE = parcelRequire("eHTbE");
var $1WoKY = parcelRequire("1WoKY");

var $hbQ4S = parcelRequire("hbQ4S");

var $kyaby = parcelRequire("kyaby");

var $1VjxL = parcelRequire("1VjxL");

var $9aQft = parcelRequire("9aQft");

var $9oBg1 = parcelRequire("9oBg1");

var $axsoS = parcelRequire("axsoS");

var $cp3Es = parcelRequire("cp3Es");
const $32191603529fa1f7$var$HubThemingContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $32191603529fa1f7$var$readableHubTextColor = (color)=>(0, $d2gH4.readableTextColor)(color, '@atlassian/company-hub-common');
const $32191603529fa1f7$export$637b3c4e057a01d3 = ({ children: children })=>{
    var _branding$colors, _branding$colors2;
    const { branding: branding, env: env, hubType: hubType, isInPreviewMode: isInPreviewMode } = (0, $hJs5J.useHubContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const isEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    const isBrandPaletteLocked = (0, $cp3Es.useShouldShowPremiumUpsell)();
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? (0, $9aQft.DEFAULT_PRIMARY);
    // Accent comes from the BE (`HelpCenterBrandingColors.secondaryColor`,
    // mapped to `branding.colors.accent` at the bootstrap boundary). If the
    // BE returns nothing — pre-v2 hubs, non-help-center hosts, fresh tenants
    // — we fall through to `DEFAULT_ACCENT`. The panel persists changes via
    // the same Relay mutation path that primary uses, so the picker's
    // `value` prop and the provider's `accentColor` here stay in lockstep
    // via the next bootstrap re-render. No FE-side state needed.
    const accentColor = (branding === null || branding === void 0 || (_branding$colors2 = branding.colors) === null || _branding$colors2 === void 0 ? void 0 : _branding$colors2.accent) ?? (0, $9aQft.DEFAULT_ACCENT);
    const palette = (0, $1WoKY.useHubBrandPalette)({
        primary: primaryColor,
        accent: accentColor
    });
    const primaryTextColor = (0, $bSJIT.useMemo)(()=>$32191603529fa1f7$var$readableHubTextColor(primaryColor), [
        primaryColor
    ]);
    const primaryLinkColor = (0, $bSJIT.useMemo)(()=>(0, $lkNTb.generateThemeBranding)(primaryColor).color900, [
        primaryColor
    ]);
    // Typography source of truth is the BE-persisted value, surfaced on
    // `branding.typography` at the bootstrap boundary. This is what makes the
    // help-seeker VIEW pages (homepage, profile, login, request list/details)
    // render the admin's chosen font — they read the same branding the editor
    // does. `setHubTypography` layers an in-session override on top for instant
    // edit-mode preview; the override is persisted on Publish via the branding
    // mutation (see action-bar), after which a bootstrap re-read makes the base
    // value match. View mode never calls the setter, so it always shows the
    // persisted value. Undefined (no BE value, no override) → HubTypographyScope
    // no-ops → Atlassian Sans default.
    const brandingTypography = branding === null || branding === void 0 ? void 0 : branding.typography;
    const [typographyOverride, setTypographyOverride] = (0, $bSJIT.useState)(undefined);
    const typography = typographyOverride ?? brandingTypography;
    const setHubTypography = (0, $bSJIT.useCallback)((next)=>{
        setTypographyOverride(next);
    }, []);
    const brandingSpaceDensity = branding === null || branding === void 0 ? void 0 : branding.spaceDensity;
    const [spaceDensityOverride, setSpaceDensityOverride] = (0, $bSJIT.useState)(undefined);
    const spaceDensity = spaceDensityOverride ?? brandingSpaceDensity;
    const setSpaceDensity = (0, $bSJIT.useCallback)((next)=>{
        setSpaceDensityOverride(next);
    }, []);
    // Corner radius source of truth is the BE-persisted value, surfaced on
    // `branding.cornerRadius` at the bootstrap boundary. `setHubCornerRadius`
    // layers an in-session override on top for instant edit-mode preview; the
    // override is persisted on Publish via the branding mutation. View mode
    // never calls the setter. Undefined / invalid → resolves to 8px default.
    const brandingCornerRadius = branding === null || branding === void 0 ? void 0 : branding.cornerRadius;
    const [cornerRadiusOverride, setCornerRadiusOverride] = (0, $bSJIT.useState)(undefined);
    const cornerRadius = (0, $kyaby.resolveHubCornerRadius)(cornerRadiusOverride ?? brandingCornerRadius);
    const setHubCornerRadius = (0, $bSJIT.useCallback)((next)=>{
        setCornerRadiusOverride(next);
    }, []);
    // Adoption denominator: fire once per hub load (view or edit) with the
    // persisted theming state, but only when advanced theming is enabled. The
    // provider mounts on every hub load via HubBootstrap, so this captures the
    // full installed base; deduped downstream by helpCenterAri.
    const hasFiredRenderedRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (hasFiredRenderedRef.current || !isEnabled) return;
        if (!(env !== null && env !== void 0 && env.helpCenterAri)) return;
        hasFiredRenderedRef.current = true;
        // Flat analytics-bridge envelope (top-level `analyticsType`): this is the shape
        // help-center's analytics listener chain extracts and forwards to GAS v3. A nested
        // `{ type, data }` envelope resolves `analyticsType: undefined` and is silently
        // dropped on this host, so we mirror hub-home's `help_hub published` pattern.
        createAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'helpHubTheme',
            analyticsType: (0, $clpci.TRACK_EVENT_TYPE),
            attributes: {
                source: 'hubThemingProvider',
                helpCenterAri: env.helpCenterAri,
                helpCenterId: env.helpCenterId,
                hubType: hubType,
                isInPreviewMode: !!isInPreviewMode,
                ...(0, $1VjxL.buildHubThemingStateAttributes)({
                    primaryColor: primaryColor,
                    accentColor: accentColor,
                    typography: typography,
                    cornerRadius: cornerRadius,
                    spaceDensity: spaceDensity
                })
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        env,
        hubType,
        isInPreviewMode,
        isEnabled,
        primaryColor,
        accentColor,
        typography,
        cornerRadius,
        spaceDensity
    ]);
    // `defaultParameters` and `brandBackgroundColorMap` deliberately split on
    // `isEnabled` so consumers (CommonHubExtensionsDependenciesProvider, the
    // extension config panels) can keep reading from `useHubTheming()` without
    // branching themselves. When the gate is OFF we restore the pre-v2 shape
    // exactly: legacy CSS-var refs in default params (consumed by
    // setHubBrandingStyle's writes) and a single-knownColor swatch grid built
    // from `branding.colors.primary` so the picker still shows the brand swatch.
    //
    // When ON, the wrapper div below emits `--hub-color-*` vars, and
    // `defaultParameters.backgroundColor` is a `var(--hub-color-primary-200)`
    // reference rather than a hex literal. The renderer drops the var ref into
    // inline style; the cascade resolves it against the wrapper. This means
    // brand-color edits trigger a CSS-only repaint — no React re-render in the
    // consumer is needed for the new color to apply.
    const defaultParameters = (0, $bSJIT.useMemo)(()=>isEnabled ? // Gate ON: resolver returns `var(--hub-color-primary-200)` + readable
        // text; when locked it seeds the raw `primaryColor` instead.
        {
            ...(0, $9oBg1.getHubDefaultParameters)({
                palette: palette,
                isBrandPaletteLocked: isBrandPaletteLocked,
                primaryColor: primaryColor
            }),
            textColor: primaryTextColor
        } : // Gate OFF: same resolver with no palette → legacy `var(--hub-*)`
        // chain that resolves against setHubBrandingStyle's writes on <html>.
        (0, $9oBg1.getHubDefaultParameters)(), [
        isEnabled,
        palette,
        primaryTextColor,
        isBrandPaletteLocked,
        primaryColor
    ]);
    // Brand swatch grid, shared by every bespoke element picker via context:
    //   - ON + unlocked: full palette + white/black.
    //   - ON + locked: the admin's primary brand colour + white/black (gating the
    //     source here reduces every picker at once; each adds its own current
    //     value + custom-hex). Also see `brandBorderColorMap` below.
    //   - OFF: legacy single CSS-var string (matches master's strict-equality
    //     swatch highlight for pre-v2 ADFs).
    //
    // White and black are offered to locked tenants too: they are neutrals, not
    // palette tints, so they cost nothing in entitlement terms — and without
    // them a text or heading picker with a dark brand colour has no legible
    // choice at all beyond typing a custom hex.
    const brandBackgroundColorMap = (0, $bSJIT.useMemo)(()=>{
        if (!isEnabled) return (0, $7E5z7.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        });
        if (isBrandPaletteLocked) return (0, $7E5z7.createBuiltInColorMap)({
            knownColors: [
                primaryColor,
                ...(0, $hbQ4S.HUB_LOCKED_NEUTRAL_HEXES)
            ]
        });
        return (0, $7E5z7.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                ...(0, $hbQ4S.HUB_LOCKED_NEUTRAL_HEXES)
            ]
        });
    }, [
        isEnabled,
        isBrandPaletteLocked,
        primaryColor,
        palette,
        defaultParameters
    ]);
    // Same as brandBackgroundColorMap but with 4 neutrals appended (white,
    // color.border, color.border.bold, black); consumer translates the neutral
    // hexes back to token refs at onChange. Locked tenants get the primary plus
    // the same 4 neutrals — a border is neutral far more often than it is brand.
    const brandBorderColorMap = (0, $bSJIT.useMemo)(()=>{
        if (!isEnabled) return (0, $7E5z7.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        });
        if (isBrandPaletteLocked) return (0, $7E5z7.createBuiltInColorMap)({
            knownColors: [
                primaryColor,
                ...(0, $hbQ4S.HUB_LOCKED_BORDER_NEUTRAL_HEXES)
            ]
        });
        return (0, $7E5z7.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                ...(0, $hbQ4S.HUB_LOCKED_BORDER_NEUTRAL_HEXES)
            ]
        });
    }, [
        isEnabled,
        isBrandPaletteLocked,
        primaryColor,
        palette,
        defaultParameters
    ]);
    // Bound once here so no element panel has to remember to pass the locked
    // state through to `toAdfColor` — forgetting it is what let locked tenants
    // persist palette-shade refs that stop tracking the brand colour.
    const toStoredColor = (0, $bSJIT.useCallback)((hex)=>(0, $eHTbE.toAdfColor)(hex, palette, {
            isBrandPaletteLocked: isBrandPaletteLocked,
            primaryColor: primaryColor
        }), [
        palette,
        isBrandPaletteLocked,
        primaryColor
    ]);
    const value = (0, $bSJIT.useMemo)(()=>({
            isAdvancedThemingEnabled: isEnabled,
            isBrandPaletteLocked: isBrandPaletteLocked,
            primaryColor: primaryColor,
            accentColor: accentColor,
            primaryTextColor: primaryTextColor,
            primaryLinkColor: primaryLinkColor,
            palette: palette,
            defaultParameters: defaultParameters,
            brandBackgroundColorMap: brandBackgroundColorMap,
            brandBorderColorMap: brandBorderColorMap,
            cornerRadius: cornerRadius,
            setHubCornerRadius: setHubCornerRadius,
            setHubTypography: setHubTypography,
            typography: typography,
            setSpaceDensity: setSpaceDensity,
            spaceDensity: spaceDensity,
            toStoredColor: toStoredColor
        }), [
        isEnabled,
        isBrandPaletteLocked,
        primaryColor,
        accentColor,
        primaryTextColor,
        primaryLinkColor,
        palette,
        defaultParameters,
        brandBackgroundColorMap,
        brandBorderColorMap,
        cornerRadius,
        setHubCornerRadius,
        setHubTypography,
        typography,
        setSpaceDensity,
        spaceDensity,
        toStoredColor
    ]);
    // Wrapper div emits the entire palette as inline `style` so the 20
    // `--hub-color-*` custom properties land in the SSR HTML and resolve on
    // first paint — no useEffect, no `document.documentElement.setProperty`,
    // no flash of unthemed content. Everything inside the wrapper inherits the
    // vars through the normal CSS cascade.
    //
    // `display: contents` tells the browser to render the wrapper's children
    // but skip generating a box for the wrapper itself, so it is invisible to
    // flex/grid/positioning. Without it, the wrapper would introduce a
    // `display: block` box that could break ancestor layouts (extra flex item,
    // extra grid cell, broken percentage heights, etc.). We get CSS-var
    // scoping + a DOM marker for devtools without any layout side-effect.
    // The cascade still works — `display: contents` does not stop custom
    // properties from being inherited by descendants.
    //
    // Wrapper always emits the full palette + legacy vars, regardless of the
    // gate state. This matters when an admin edits under v2 ON and then toggles
    // the FF off — their persisted ADFs reference `--hub-color-primary-*` and
    // would resolve to `unset` (white) without the wrapper providing the vars.
    // Always emitting keeps a flag flip non-destructive while the resolver and
    // picker still gate their *behavior* on `isAdvancedThemingEnabled`.
    //
    // Legacy compat vars (`--hub-primary-color` / `--hub-primary-text-color` /
    // `--hub-primary-link-color`) are also always emitted so pre-v2 ADFs that
    // reference them render with the exact same colors as before the v2 flip
    // (the input hex verbatim, WCAG-readable text, and
    // `generateThemeBranding(...).color900` link tint). Matches
    // `setHubBrandingStyle`'s semantics so admins with already-customised hubs
    // see no visual change post-flip.
    const wrapperStyle = (0, $bSJIT.useMemo)(()=>({
            display: 'contents',
            ...$32191603529fa1f7$var$buildPaletteStyle(palette),
            [(0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR)]: primaryColor,
            [(0, $53RlD.HUB_PRIMARY_TEXT_COLOR_CSS_VAR)]: primaryTextColor,
            [(0, $53RlD.HUB_PRIMARY_LINK_COLOR_CSS_VAR)]: primaryLinkColor,
            [(0, $kyaby.HUB_CORNER_RADIUS_CSS_VAR)]: `${cornerRadius}px`
        }), [
        palette,
        primaryColor,
        primaryTextColor,
        primaryLinkColor,
        cornerRadius
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($32191603529fa1f7$var$HubThemingContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-hub-theme-root": "",
        style: wrapperStyle
    }, children));
};
/**
 * Build the inline-style object emitted on the wrapper div from the palette.
 * Returns 20 entries of the form `{ '--hub-color-primary-200': '#B3D4FF' }`.
 *
 * Kept outside the provider so the entry-set construction is testable in
 * isolation and not entangled with React rendering.
 */ const $32191603529fa1f7$var$buildPaletteStyle = (palette)=>{
    const out = {};
    for (const ref of Object.keys(palette))out[(0, $Cc5Nl.HUB_COLOR_CSS_VARS)[ref]] = palette[ref];
    return out;
};
const $32191603529fa1f7$export$33bfea475043649c = ()=>{
    return (0, $bSJIT.useContext)($32191603529fa1f7$var$HubThemingContext) ?? undefined;
};

});
parcelRegister("7E5z7", function(module, exports) {
$parcel$export(module.exports, "createBuiltInColorMap", () => $c57d5c64a646b552$export$a4af15b2fa34f34e);

var $7hQVc = parcelRequire("7hQVc");

var $fX3Nu = parcelRequire("fX3Nu");
const $c57d5c64a646b552$export$a4af15b2fa34f34e = ({ knownColors: knownColors, allColors: allColors, humanReadableColors: humanReadableColors, getResponsiveColor: getResponsiveColor })=>{
    knownColors = knownColors.map((color)=>color.toLowerCase());
    const knownTokens = knownColors.map((color)=>(0, $7hQVc.extractToken)(color));
    if (!allColors) allColors = knownColors;
    else allColors = allColors.map((color)=>color.toLowerCase());
    const allTokens = allColors.map((color)=>(0, $7hQVc.extractToken)(color));
    const humanReadableColorsMap = humanReadableColors ? new Map([
        ...(0, $fX3Nu.allHumanReadableColors).entries(),
        ...humanReadableColors.entries()
    ]) : (0, $fX3Nu.allHumanReadableColors);
    return {
        knownColors: knownColors,
        knownTokens: knownTokens,
        allColors: allColors,
        allTokens: allTokens,
        humanReadableColors: humanReadableColorsMap,
        getResponsiveColor: getResponsiveColor || ((color)=>color)
    };
};

});
parcelRegister("7hQVc", function(module, exports) {
$parcel$export(module.exports, "isValidColor", () => $9b43009bdb2bcbbe$export$35fa9d266cdb6f09);
$parcel$export(module.exports, "convertLegacyColor", () => $9b43009bdb2bcbbe$export$b2b344a3caf230bf);
$parcel$export(module.exports, "extractToken", () => $9b43009bdb2bcbbe$export$5039139b891079e8);
$parcel$export(module.exports, "getSanitizedColor", () => $9b43009bdb2bcbbe$export$d16dc80c78f978b3);
$parcel$export(module.exports, "toHexColor", () => $9b43009bdb2bcbbe$export$342249704b28d862);
$parcel$export(module.exports, "isReadable", () => $9b43009bdb2bcbbe$export$3fe5b5ca1e6a6a28);
$parcel$export(module.exports, "getMostReadableColor", () => $9b43009bdb2bcbbe$export$21e0b327e0d86beb);

var $lDzlK = parcelRequire("lDzlK");
/* regular expressions obtained from CssColourValidator.java
 * CssColourValidator runs in legacy Color Scheme on updateSiteLookAndFeel mutation
 * instead of validating on Save, we are now validating as user enters custom input
 */ const $9b43009bdb2bcbbe$var$VAR_MATCH = new RegExp('^var\\((\\-\\-[a-zA-Z0-9\\-_]+)\\s*(,(.+))?\\)$');
const $9b43009bdb2bcbbe$var$SHORT_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){3}$');
const $9b43009bdb2bcbbe$var$LONG_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){6}$');
const $9b43009bdb2bcbbe$var$RGB_MATCH = new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
const $9b43009bdb2bcbbe$var$PERC_MATCH = new RegExp('^rgb\\((\\d+)%,\\s*(\\d+)%,\\s*(\\d+)%\\)$');
const $9b43009bdb2bcbbe$var$RGBA_MATCH = new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[0-9]*)|[01])\\s*\\)$');
const $9b43009bdb2bcbbe$var$HSL_MATCH = new RegExp('^hsl\\(\\s*(0|[1-9]\\d?|[12]\\d\\d|3[0-5]\\d)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*\\)$');
/* evaluates validity for any incoming colors from 1) siteConfiguration query 2) custom input field
 * until hsla and named color conversion errors are handled properly in app-navigation, we return the default Atlassian theme as in getSanitizedColor fn
 * it is an existing pattern under useNavigationTheme to return the theme as means of error handling
 * once resolved, this isValidColor can validate for HSLA_MATCH and NAMED_COLOR_MATCH
 */ function $9b43009bdb2bcbbe$var$isValidVarColor(color) {
    const matches = $9b43009bdb2bcbbe$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$;
        const fallback = (_matches$ = matches[3]) === null || _matches$ === void 0 ? void 0 : _matches$.trim();
        if (fallback) {
            // If fallback is another var() call, validate it recursively
            if (fallback.startsWith('var(')) return $9b43009bdb2bcbbe$var$isValidVarColor(fallback);
            // Otherwise validate as a regular color
            return $9b43009bdb2bcbbe$export$35fa9d266cdb6f09(fallback, false);
        }
        // If there's a comma but no fallback (like "var(--token, )"), it's invalid
        if (matches[2] && !fallback) return false;
        return true;
    }
    return false;
}
function $9b43009bdb2bcbbe$export$35fa9d266cdb6f09(color, isVarColorAllowed = true) {
    return isVarColorAllowed && $9b43009bdb2bcbbe$var$isValidVarColor(color) || $9b43009bdb2bcbbe$var$SHORT_NUMERIC_MATCH.test(color) || $9b43009bdb2bcbbe$var$LONG_NUMERIC_MATCH.test(color) || $9b43009bdb2bcbbe$var$RGB_MATCH.test(color) || $9b43009bdb2bcbbe$var$PERC_MATCH.test(color) || $9b43009bdb2bcbbe$var$RGBA_MATCH.test(color) || $9b43009bdb2bcbbe$var$HSL_MATCH.test(color);
}
function $9b43009bdb2bcbbe$export$b2b344a3caf230bf(color) {
    if (!$9b43009bdb2bcbbe$export$35fa9d266cdb6f09(color)) return (0, $lDzlK.default)('invalid');
    const colorCode = $9b43009bdb2bcbbe$var$extractColorCode(color);
    return (0, $lDzlK.default)(colorCode);
}
/* simply extracts the color code from given color string.
 * If color is tokenized, either computes or extracts fallback hex value
 * Else return color as is
 */ function $9b43009bdb2bcbbe$var$extractColorCode(color) {
    const matches = $9b43009bdb2bcbbe$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$2;
        const fallback = (_matches$2 = matches[3]) === null || _matches$2 === void 0 ? void 0 : _matches$2.trim();
        const token = matches[1].toLowerCase();
        // SSR guard
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const compiledTokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
            // If we have a computed value, return it
            if (compiledTokenValue) return compiledTokenValue;
        }
        // If there's a fallback, process it recursively
        if (fallback) {
            // If fallback is another var() call, extract from it recursively
            if (fallback.startsWith('var(')) return $9b43009bdb2bcbbe$var$extractColorCode(fallback);
            // Otherwise return the fallback as is
            return fallback;
        }
        // No computed value and no fallback
        return '';
    }
    return color;
}
function $9b43009bdb2bcbbe$export$5039139b891079e8(color = '') {
    const matches = $9b43009bdb2bcbbe$var$VAR_MATCH.exec(color);
    return (matches === null || matches === void 0 ? void 0 : matches[1].toLowerCase()) ?? color;
}
function $9b43009bdb2bcbbe$export$d16dc80c78f978b3({ allColors: allColors, allTokens: allTokens, knownColors: knownColors }, color = '') {
    const index = allTokens.indexOf($9b43009bdb2bcbbe$export$5039139b891079e8(color));
    if (index !== -1) return allColors[index];
    if (!$9b43009bdb2bcbbe$export$35fa9d266cdb6f09(color)) return knownColors[0];
    return color;
}
function $9b43009bdb2bcbbe$export$342249704b28d862(color) {
    const converted = $9b43009bdb2bcbbe$export$b2b344a3caf230bf(color);
    if (converted.isValid()) return converted.toHexString();
    return color;
}
function $9b43009bdb2bcbbe$export$3fe5b5ca1e6a6a28(backgroundColor, highlightColor) {
    const backgroundCode = $9b43009bdb2bcbbe$var$extractColorCode(backgroundColor);
    const highlightCode = $9b43009bdb2bcbbe$var$extractColorCode(highlightColor);
    return (0, $lDzlK.default).isReadable(backgroundCode, highlightCode);
}
function $9b43009bdb2bcbbe$export$21e0b327e0d86beb(color) {
    color = $9b43009bdb2bcbbe$var$extractColorCode(color);
    return (0, $lDzlK.default).mostReadable(color, [
        '#000000',
        '#ffffff'
    ]).toHexString();
}
function $9b43009bdb2bcbbe$export$bf60f520e1f9cbf8(color1, color2) {
    return $9b43009bdb2bcbbe$var$extractColorCode(color1) === $9b43009bdb2bcbbe$var$extractColorCode(color2);
}

});
parcelRegister("lDzlK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc08a9320f36a8ab$export$2e2bcd8739ae039);
// This file is autogenerated. It's used to publish ESM to npm.
function $fc08a9320f36a8ab$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fc08a9320f36a8ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fc08a9320f36a8ab$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $fc08a9320f36a8ab$var$trimLeft = /^\s+/;
var $fc08a9320f36a8ab$var$trimRight = /\s+$/;
function $fc08a9320f36a8ab$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $fc08a9320f36a8ab$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $fc08a9320f36a8ab$export$2e2bcd8739ae039)) return new $fc08a9320f36a8ab$export$2e2bcd8739ae039(color, opts);
    var rgb = $fc08a9320f36a8ab$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$fc08a9320f36a8ab$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $fc08a9320f36a8ab$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $fc08a9320f36a8ab$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $fc08a9320f36a8ab$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $fc08a9320f36a8ab$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $fc08a9320f36a8ab$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $fc08a9320f36a8ab$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $fc08a9320f36a8ab$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($fc08a9320f36a8ab$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($fc08a9320f36a8ab$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($fc08a9320f36a8ab$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($fc08a9320f36a8ab$var$bound01(this._r, 255) * 100) + "%, " + Math.round($fc08a9320f36a8ab$var$bound01(this._g, 255) * 100) + "%, " + Math.round($fc08a9320f36a8ab$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($fc08a9320f36a8ab$var$bound01(this._r, 255) * 100) + "%, " + Math.round($fc08a9320f36a8ab$var$bound01(this._g, 255) * 100) + "%, " + Math.round($fc08a9320f36a8ab$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $fc08a9320f36a8ab$var$hexNames[$fc08a9320f36a8ab$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $fc08a9320f36a8ab$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $fc08a9320f36a8ab$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $fc08a9320f36a8ab$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $fc08a9320f36a8ab$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($fc08a9320f36a8ab$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($fc08a9320f36a8ab$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($fc08a9320f36a8ab$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($fc08a9320f36a8ab$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($fc08a9320f36a8ab$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($fc08a9320f36a8ab$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($fc08a9320f36a8ab$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($fc08a9320f36a8ab$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($fc08a9320f36a8ab$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($fc08a9320f36a8ab$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($fc08a9320f36a8ab$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($fc08a9320f36a8ab$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($fc08a9320f36a8ab$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$fc08a9320f36a8ab$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($fc08a9320f36a8ab$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $fc08a9320f36a8ab$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $fc08a9320f36a8ab$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $fc08a9320f36a8ab$var$stringInputToObject(color);
    if ($fc08a9320f36a8ab$var$_typeof(color) == "object") {
        if ($fc08a9320f36a8ab$var$isValidCSSUnit(color.r) && $fc08a9320f36a8ab$var$isValidCSSUnit(color.g) && $fc08a9320f36a8ab$var$isValidCSSUnit(color.b)) {
            rgb = $fc08a9320f36a8ab$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($fc08a9320f36a8ab$var$isValidCSSUnit(color.h) && $fc08a9320f36a8ab$var$isValidCSSUnit(color.s) && $fc08a9320f36a8ab$var$isValidCSSUnit(color.v)) {
            s = $fc08a9320f36a8ab$var$convertToPercentage(color.s);
            v = $fc08a9320f36a8ab$var$convertToPercentage(color.v);
            rgb = $fc08a9320f36a8ab$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($fc08a9320f36a8ab$var$isValidCSSUnit(color.h) && $fc08a9320f36a8ab$var$isValidCSSUnit(color.s) && $fc08a9320f36a8ab$var$isValidCSSUnit(color.l)) {
            s = $fc08a9320f36a8ab$var$convertToPercentage(color.s);
            l = $fc08a9320f36a8ab$var$convertToPercentage(color.l);
            rgb = $fc08a9320f36a8ab$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $fc08a9320f36a8ab$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $fc08a9320f36a8ab$var$rgbToRgb(r, g, b) {
    return {
        r: $fc08a9320f36a8ab$var$bound01(r, 255) * 255,
        g: $fc08a9320f36a8ab$var$bound01(g, 255) * 255,
        b: $fc08a9320f36a8ab$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $fc08a9320f36a8ab$var$rgbToHsl(r, g, b) {
    r = $fc08a9320f36a8ab$var$bound01(r, 255);
    g = $fc08a9320f36a8ab$var$bound01(g, 255);
    b = $fc08a9320f36a8ab$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $fc08a9320f36a8ab$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $fc08a9320f36a8ab$var$bound01(h, 360);
    s = $fc08a9320f36a8ab$var$bound01(s, 100);
    l = $fc08a9320f36a8ab$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $fc08a9320f36a8ab$var$rgbToHsv(r, g, b) {
    r = $fc08a9320f36a8ab$var$bound01(r, 255);
    g = $fc08a9320f36a8ab$var$bound01(g, 255);
    b = $fc08a9320f36a8ab$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $fc08a9320f36a8ab$var$hsvToRgb(h, s, v) {
    h = $fc08a9320f36a8ab$var$bound01(h, 360) * 6;
    s = $fc08a9320f36a8ab$var$bound01(s, 100);
    v = $fc08a9320f36a8ab$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $fc08a9320f36a8ab$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $fc08a9320f36a8ab$var$pad2(Math.round(r).toString(16)),
        $fc08a9320f36a8ab$var$pad2(Math.round(g).toString(16)),
        $fc08a9320f36a8ab$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $fc08a9320f36a8ab$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $fc08a9320f36a8ab$var$pad2(Math.round(r).toString(16)),
        $fc08a9320f36a8ab$var$pad2(Math.round(g).toString(16)),
        $fc08a9320f36a8ab$var$pad2(Math.round(b).toString(16)),
        $fc08a9320f36a8ab$var$pad2($fc08a9320f36a8ab$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $fc08a9320f36a8ab$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $fc08a9320f36a8ab$var$pad2($fc08a9320f36a8ab$var$convertDecimalToHex(a)),
        $fc08a9320f36a8ab$var$pad2(Math.round(r).toString(16)),
        $fc08a9320f36a8ab$var$pad2(Math.round(g).toString(16)),
        $fc08a9320f36a8ab$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$fc08a9320f36a8ab$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(color1).toRgbString() == $fc08a9320f36a8ab$export$2e2bcd8739ae039(color2).toRgbString();
};
$fc08a9320f36a8ab$export$2e2bcd8739ae039.random = function() {
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $fc08a9320f36a8ab$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $fc08a9320f36a8ab$var$clamp01(hsl.s);
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl);
}
function $fc08a9320f36a8ab$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $fc08a9320f36a8ab$var$clamp01(hsl.s);
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl);
}
function $fc08a9320f36a8ab$var$_greyscale(color) {
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).desaturate(100);
}
function $fc08a9320f36a8ab$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $fc08a9320f36a8ab$var$clamp01(hsl.l);
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl);
}
function $fc08a9320f36a8ab$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(rgb);
}
function $fc08a9320f36a8ab$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $fc08a9320f36a8ab$var$clamp01(hsl.l);
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $fc08a9320f36a8ab$var$_spin(color, amount) {
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $fc08a9320f36a8ab$var$_complement(color) {
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl);
}
function $fc08a9320f36a8ab$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $fc08a9320f36a8ab$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($fc08a9320f36a8ab$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $fc08a9320f36a8ab$var$_splitcomplement(color) {
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $fc08a9320f36a8ab$export$2e2bcd8739ae039(color),
        $fc08a9320f36a8ab$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $fc08a9320f36a8ab$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $fc08a9320f36a8ab$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $fc08a9320f36a8ab$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($fc08a9320f36a8ab$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $fc08a9320f36a8ab$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($fc08a9320f36a8ab$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$fc08a9320f36a8ab$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $fc08a9320f36a8ab$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$fc08a9320f36a8ab$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color1);
    var c2 = $fc08a9320f36a8ab$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$fc08a9320f36a8ab$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $fc08a9320f36a8ab$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $fc08a9320f36a8ab$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$fc08a9320f36a8ab$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $fc08a9320f36a8ab$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $fc08a9320f36a8ab$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($fc08a9320f36a8ab$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $fc08a9320f36a8ab$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $fc08a9320f36a8ab$var$names = $fc08a9320f36a8ab$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $fc08a9320f36a8ab$var$hexNames = $fc08a9320f36a8ab$export$2e2bcd8739ae039.hexNames = $fc08a9320f36a8ab$var$flip($fc08a9320f36a8ab$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $fc08a9320f36a8ab$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $fc08a9320f36a8ab$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $fc08a9320f36a8ab$var$bound01(n, max) {
    if ($fc08a9320f36a8ab$var$isOnePointZero(n)) n = "100%";
    var processPercent = $fc08a9320f36a8ab$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $fc08a9320f36a8ab$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $fc08a9320f36a8ab$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $fc08a9320f36a8ab$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $fc08a9320f36a8ab$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $fc08a9320f36a8ab$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $fc08a9320f36a8ab$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $fc08a9320f36a8ab$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $fc08a9320f36a8ab$var$convertHexToDecimal(h) {
    return $fc08a9320f36a8ab$var$parseIntFromHex(h) / 255;
}
var $fc08a9320f36a8ab$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $fc08a9320f36a8ab$var$isValidCSSUnit(color) {
    return !!$fc08a9320f36a8ab$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $fc08a9320f36a8ab$var$stringInputToObject(color) {
    color = color.replace($fc08a9320f36a8ab$var$trimLeft, "").replace($fc08a9320f36a8ab$var$trimRight, "").toLowerCase();
    var named = false;
    if ($fc08a9320f36a8ab$var$names[color]) {
        color = $fc08a9320f36a8ab$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $fc08a9320f36a8ab$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $fc08a9320f36a8ab$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hex8.exec(color)) return {
        r: $fc08a9320f36a8ab$var$parseIntFromHex(match[1]),
        g: $fc08a9320f36a8ab$var$parseIntFromHex(match[2]),
        b: $fc08a9320f36a8ab$var$parseIntFromHex(match[3]),
        a: $fc08a9320f36a8ab$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hex6.exec(color)) return {
        r: $fc08a9320f36a8ab$var$parseIntFromHex(match[1]),
        g: $fc08a9320f36a8ab$var$parseIntFromHex(match[2]),
        b: $fc08a9320f36a8ab$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hex4.exec(color)) return {
        r: $fc08a9320f36a8ab$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $fc08a9320f36a8ab$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $fc08a9320f36a8ab$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $fc08a9320f36a8ab$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $fc08a9320f36a8ab$var$matchers.hex3.exec(color)) return {
        r: $fc08a9320f36a8ab$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $fc08a9320f36a8ab$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $fc08a9320f36a8ab$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $fc08a9320f36a8ab$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}

});


parcelRegister("fX3Nu", function(module, exports) {
$parcel$export(module.exports, "allHumanReadableColors", () => $84c365cdefcc4980$export$37744bda14f72c19);

var $fhg3G = parcelRequire("fhg3G");
const $84c365cdefcc4980$export$37744bda14f72c19 = new Map([
    // background colors
    [
        "var(--ds-surface-overlay, #FFFFFF)".toLowerCase(),
        (0, $fhg3G.colorNames).defaultWhite
    ],
    [
        "var(--ds-background-accent-blue-subtlest, #E9F2FE)".toLowerCase(),
        (0, $fhg3G.colorNames).lightBlue
    ],
    [
        "var(--ds-background-accent-purple-subtlest, #F8EEFE)".toLowerCase(),
        (0, $fhg3G.colorNames).lightPurple
    ],
    [
        "var(--ds-background-accent-magenta-subtlest, #FFECF8)".toLowerCase(),
        (0, $fhg3G.colorNames).lightMagenta
    ],
    [
        "var(--ds-background-accent-red-subtlest, #FFECEB)".toLowerCase(),
        (0, $fhg3G.colorNames).lightRed
    ],
    [
        "var(--ds-background-accent-orange-subtlest, #FFF5DB)".toLowerCase(),
        (0, $fhg3G.colorNames).lightOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".toLowerCase(),
        (0, $fhg3G.colorNames).lightYellow
    ],
    [
        "var(--ds-background-accent-lime-subtlest, #EFFFD6)".toLowerCase(),
        (0, $fhg3G.colorNames).lightLime
    ],
    [
        "var(--ds-background-accent-green-subtlest, #DCFFF1)".toLowerCase(),
        (0, $fhg3G.colorNames).lightGreen
    ],
    [
        "var(--ds-background-accent-teal-subtlest, #E7F9FF)".toLowerCase(),
        (0, $fhg3G.colorNames).lightTeal
    ],
    [
        "var(--ds-background-accent-gray-subtler, #DDDEE1)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleGray
    ],
    [
        "var(--ds-background-accent-blue-subtler, #CFE1FD)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleBlue
    ],
    [
        "var(--ds-background-accent-purple-subtler, #EED7FC)".toLowerCase(),
        (0, $fhg3G.colorNames).subtlePurple
    ],
    [
        "var(--ds-background-accent-magenta-subtler, #FDD0EC)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleMagenta
    ],
    [
        "var(--ds-background-accent-red-subtler, #FFD5D2)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleRed
    ],
    [
        "var(--ds-background-accent-orange-subtler, #FCE4A6)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtler, #F5E989)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleYellow
    ],
    [
        "var(--ds-background-accent-lime-subtler, #D3F1A7)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleLime
    ],
    [
        "var(--ds-background-accent-green-subtler, #BAF3DB)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleGreen
    ],
    [
        "var(--ds-background-accent-teal-subtler, #C6EDFB)".toLowerCase(),
        (0, $fhg3G.colorNames).subtleTeal
    ],
    [
        "var(--ds-background-accent-gray-subtle, #8C8F97)".toLowerCase(),
        (0, $fhg3G.colorNames).gray
    ],
    [
        "var(--ds-background-accent-blue-subtle, #669DF1)".toLowerCase(),
        (0, $fhg3G.colorNames).blue
    ],
    [
        "var(--ds-background-accent-purple-subtle, #C97CF4)".toLowerCase(),
        (0, $fhg3G.colorNames).purple
    ],
    [
        "var(--ds-background-accent-magenta-subtle, #E774BB)".toLowerCase(),
        (0, $fhg3G.colorNames).magenta
    ],
    [
        "var(--ds-background-accent-red-subtle, #F87168)".toLowerCase(),
        (0, $fhg3G.colorNames).red
    ],
    [
        "var(--ds-background-accent-orange-subtle, #FCA700)".toLowerCase(),
        (0, $fhg3G.colorNames).orange
    ],
    [
        "var(--ds-background-accent-yellow-subtle, #EED12B)".toLowerCase(),
        (0, $fhg3G.colorNames).yellow
    ],
    [
        "var(--ds-background-accent-lime-subtle, #94C748)".toLowerCase(),
        (0, $fhg3G.colorNames).lime
    ],
    [
        "var(--ds-background-accent-green-subtle, #4BCE97)".toLowerCase(),
        (0, $fhg3G.colorNames).green
    ],
    [
        "var(--ds-background-accent-teal-subtle, #6CC3E0)".toLowerCase(),
        (0, $fhg3G.colorNames).teal
    ],
    [
        "var(--ds-text-brand, #1868DB)".toLowerCase(),
        (0, $fhg3G.colorNames).defaultBlue
    ],
    [
        "var(--ds-background-accent-gray-bolder, #6B6E76)".toLowerCase(),
        (0, $fhg3G.colorNames).boldGray
    ],
    [
        "var(--ds-background-accent-blue-bolder, #1868DB)".toLowerCase(),
        (0, $fhg3G.colorNames).boldBlue
    ],
    [
        "var(--ds-background-accent-purple-bolder, #964AC0)".toLowerCase(),
        (0, $fhg3G.colorNames).boldPurple
    ],
    [
        "var(--ds-background-accent-magenta-bolder, #AE4787)".toLowerCase(),
        (0, $fhg3G.colorNames).boldMagenta
    ],
    [
        "var(--ds-background-accent-red-bolder, #C9372C)".toLowerCase(),
        (0, $fhg3G.colorNames).boldRed
    ],
    [
        "var(--ds-background-accent-orange-bolder, #BD5B00)".toLowerCase(),
        (0, $fhg3G.colorNames).boldOrange
    ],
    [
        "var(--ds-background-accent-yellow-bolder, #946F00)".toLowerCase(),
        (0, $fhg3G.colorNames).boldYellow
    ],
    [
        "var(--ds-background-accent-lime-bolder, #5B7F24)".toLowerCase(),
        (0, $fhg3G.colorNames).boldLime
    ],
    [
        "var(--ds-background-accent-green-bolder, #1F845A)".toLowerCase(),
        (0, $fhg3G.colorNames).boldGreen
    ],
    [
        "var(--ds-background-accent-teal-bolder, #227D9B)".toLowerCase(),
        (0, $fhg3G.colorNames).boldTeal
    ],
    // text colors
    [
        "var(--ds-text, #292A2E)".toLowerCase(),
        (0, $fhg3G.colorNames).boldGray
    ],
    [
        "var(--ds-text-accent-blue-bolder, #123263)".toLowerCase(),
        (0, $fhg3G.colorNames).boldBlue
    ],
    [
        "var(--ds-text-accent-purple-bolder, #48245D)".toLowerCase(),
        (0, $fhg3G.colorNames).boldPurple
    ],
    [
        "var(--ds-text-accent-magenta-bolder, #50253F)".toLowerCase(),
        (0, $fhg3G.colorNames).boldMagenta
    ],
    [
        "var(--ds-text-accent-red-bolder, #5D1F1A)".toLowerCase(),
        (0, $fhg3G.colorNames).boldRed
    ],
    [
        "var(--ds-text-accent-orange-bolder, #693200)".toLowerCase(),
        (0, $fhg3G.colorNames).boldOrange
    ],
    [
        "var(--ds-text-accent-yellow-bolder, #533F04)".toLowerCase(),
        (0, $fhg3G.colorNames).boldYellow
    ],
    [
        "var(--ds-text-accent-lime-bolder, #37471F)".toLowerCase(),
        (0, $fhg3G.colorNames).boldLime
    ],
    [
        "var(--ds-text-accent-green-bolder, #164B35)".toLowerCase(),
        (0, $fhg3G.colorNames).boldGreen
    ],
    [
        "var(--ds-text-accent-teal-bolder, #164555)".toLowerCase(),
        (0, $fhg3G.colorNames).boldTeal
    ],
    [
        "var(--ds-text-subtle, #505258)".toLowerCase(),
        (0, $fhg3G.colorNames).gray
    ],
    [
        "var(--ds-text-accent-blue, #1558BC)".toLowerCase(),
        (0, $fhg3G.colorNames).blue
    ],
    [
        "var(--ds-text-accent-purple, #803FA5)".toLowerCase(),
        (0, $fhg3G.colorNames).purple
    ],
    [
        "var(--ds-text-accent-magenta, #943D73)".toLowerCase(),
        (0, $fhg3G.colorNames).magenta
    ],
    [
        "var(--ds-text-accent-red, #AE2E24)".toLowerCase(),
        (0, $fhg3G.colorNames).red
    ],
    [
        "var(--ds-text-accent-orange, #9E4C00)".toLowerCase(),
        (0, $fhg3G.colorNames).orange
    ],
    [
        "var(--ds-text-accent-yellow, #7F5F01)".toLowerCase(),
        (0, $fhg3G.colorNames).yellow
    ],
    [
        "var(--ds-text-accent-lime, #4C6B1F)".toLowerCase(),
        (0, $fhg3G.colorNames).lime
    ],
    [
        "var(--ds-text-accent-green, #216E4E)".toLowerCase(),
        (0, $fhg3G.colorNames).green
    ],
    [
        "var(--ds-text-accent-teal, #206A83)".toLowerCase(),
        (0, $fhg3G.colorNames).teal
    ],
    [
        "var(--ds-text-inverse, #FFFFFF)".toLowerCase(),
        (0, $fhg3G.colorNames).white
    ],
    // border colors
    [
        "var(--ds-border-accent-blue, #357DE8)".toLowerCase(),
        (0, $fhg3G.colorNames).blue
    ],
    [
        "var(--ds-border-accent-purple, #AF59E1)".toLowerCase(),
        (0, $fhg3G.colorNames).purple
    ],
    [
        "var(--ds-border-accent-magenta, #CD519D)".toLowerCase(),
        (0, $fhg3G.colorNames).magenta
    ],
    [
        "var(--ds-border-accent-red, #E2483D)".toLowerCase(),
        (0, $fhg3G.colorNames).red
    ],
    [
        "var(--ds-border-accent-orange, #E06C00)".toLowerCase(),
        (0, $fhg3G.colorNames).orange
    ],
    [
        "var(--ds-border-accent-yellow, #B38600)".toLowerCase(),
        (0, $fhg3G.colorNames).yellow
    ],
    [
        "var(--ds-border-accent-lime, #6A9A23)".toLowerCase(),
        (0, $fhg3G.colorNames).lime
    ],
    [
        "var(--ds-border-accent-green, #22A06B)".toLowerCase(),
        (0, $fhg3G.colorNames).green
    ],
    [
        "var(--ds-border-accent-teal, #2898BD)".toLowerCase(),
        (0, $fhg3G.colorNames).teal
    ],
    [
        "var(--ds-border-inverse, #FFFFFF)".toLowerCase(),
        (0, $fhg3G.colorNames).white
    ],
    [
        "var(--ds-border-accent-gray, #7D818A)".toLowerCase(),
        (0, $fhg3G.colorNames).gray
    ]
]);

});
parcelRegister("fhg3G", function(module, exports) {
$parcel$export(module.exports, "colorNames", () => $be03d0bc585666c4$export$88bbe6beac980300);

var $f0Pt4 = parcelRequire("f0Pt4");
const $be03d0bc585666c4$export$88bbe6beac980300 = (0, $f0Pt4.defineMessages)({
    defaultWhite: {
        id: 'company-hub.color-picker.default-white',
        description: 'Name of default white color',
        defaultMessage: 'Default white'
    },
    white: {
        id: 'company-hub.color-picker.white',
        description: 'Name of white color',
        defaultMessage: 'White'
    },
    lightGray: {
        id: 'company-hub.color-picker.light-gray',
        description: 'Name of light gray color',
        defaultMessage: 'Light gray'
    },
    lightBlue: {
        id: 'company-hub.color-picker.light-blue',
        description: 'Name of light blue color',
        defaultMessage: 'Light blue'
    },
    lightPurple: {
        id: 'company-hub.color-picker.light-purple',
        description: 'Name of light purple color',
        defaultMessage: 'Light purple'
    },
    lightMagenta: {
        id: 'company-hub.color-picker.light-magenta',
        description: 'Name of light magenta color',
        defaultMessage: 'Light magenta'
    },
    lightRed: {
        id: 'company-hub.color-picker.light-red',
        description: 'Name of light red color',
        defaultMessage: 'Light red'
    },
    lightOrange: {
        id: 'company-hub.color-picker.light-orange',
        description: 'Name of light orange color',
        defaultMessage: 'Light orange'
    },
    lightYellow: {
        id: 'company-hub.color-picker.light-yellow',
        description: 'Name of light yellow color',
        defaultMessage: 'Light yellow'
    },
    lightLime: {
        id: 'company-hub.color-picker.light-lime',
        description: 'Name of light lime color',
        defaultMessage: 'Light lime'
    },
    lightGreen: {
        id: 'company-hub.color-picker.light-green',
        description: 'Name of light green color',
        defaultMessage: 'Light green'
    },
    lightTeal: {
        id: 'company-hub.color-picker.light-teal',
        description: 'Name of light teal color',
        defaultMessage: 'Light teal'
    },
    subtleGray: {
        id: 'company-hub.color-picker.subtle-gray',
        description: 'Name of subtle gray color',
        defaultMessage: 'Subtle gray'
    },
    subtleBlue: {
        id: 'company-hub.color-picker.subtle-blue',
        description: 'Name of subtle blue color',
        defaultMessage: 'Subtle blue'
    },
    subtlePurple: {
        id: 'company-hub.color-picker.subtle-purple',
        description: 'Name of subtle purple color',
        defaultMessage: 'Subtle purple'
    },
    subtleMagenta: {
        id: 'company-hub.color-picker.subtle-magenta',
        description: 'Name of subtle magenta color',
        defaultMessage: 'Subtle magenta'
    },
    subtleRed: {
        id: 'company-hub.color-picker.subtle-red',
        description: 'Name of subtle red color',
        defaultMessage: 'Subtle red'
    },
    subtleOrange: {
        id: 'company-hub.color-picker.subtle-orange',
        description: 'Name of subtle orange color',
        defaultMessage: 'Subtle orange'
    },
    subtleYellow: {
        id: 'company-hub.color-picker.subtle-yellow',
        description: 'Name of subtle yellow color',
        defaultMessage: 'Subtle yellow'
    },
    subtleLime: {
        id: 'company-hub.color-picker.subtle-lime',
        description: 'Name of subtle lime color',
        defaultMessage: 'Subtle lime'
    },
    subtleGreen: {
        id: 'company-hub.color-picker.subtle-green',
        description: 'Name of subtle green color',
        defaultMessage: 'Subtle green'
    },
    subtleTeal: {
        id: 'company-hub.color-picker.subtle-teal',
        description: 'Name of subtle teal color',
        defaultMessage: 'Subtle teal'
    },
    gray: {
        id: 'company-hub.color-picker.gray',
        description: 'Name of gray color',
        defaultMessage: 'Gray'
    },
    blue: {
        id: 'company-hub.color-picker.blue',
        description: 'Name of blue color',
        defaultMessage: 'Blue'
    },
    purple: {
        id: 'company-hub.color-picker.purple',
        description: 'Name of purple color',
        defaultMessage: 'Purple'
    },
    magenta: {
        id: 'company-hub.color-picker.magenta',
        description: 'Name of magenta color',
        defaultMessage: 'Magenta'
    },
    red: {
        id: 'company-hub.color-picker.red',
        description: 'Name of red color',
        defaultMessage: 'Red'
    },
    orange: {
        id: 'company-hub.color-picker.orange',
        description: 'Name of orange color',
        defaultMessage: 'Orange'
    },
    yellow: {
        id: 'company-hub.color-picker.yellow',
        description: 'Name of yellow color',
        defaultMessage: 'Yellow'
    },
    lime: {
        id: 'company-hub.color-picker.lime',
        description: 'Name of lime color',
        defaultMessage: 'Lime'
    },
    green: {
        id: 'company-hub.color-picker.green',
        description: 'Name of green color',
        defaultMessage: 'Green'
    },
    teal: {
        id: 'company-hub.color-picker.teal',
        description: 'Name of teal color',
        defaultMessage: 'Teal'
    },
    boldGray: {
        id: 'company-hub.color-picker.bold-gray',
        description: 'Name of bold gray color',
        defaultMessage: 'Bold gray'
    },
    boldBlue: {
        id: 'company-hub.color-picker.bold-blue',
        description: 'Name of bold blue color',
        defaultMessage: 'Bold blue'
    },
    boldPurple: {
        id: 'company-hub.color-picker.bold-purple',
        description: 'Name of bold purple color',
        defaultMessage: 'Bold purple'
    },
    boldMagenta: {
        id: 'company-hub.color-picker.bold-magenta',
        description: 'Name of bold magenta color',
        defaultMessage: 'Bold magenta'
    },
    boldRed: {
        id: 'company-hub.color-picker.bold-red',
        description: 'Name of bold red color',
        defaultMessage: 'Bold red'
    },
    boldOrange: {
        id: 'company-hub.color-picker.bold-orange',
        description: 'Name of bold orange color',
        defaultMessage: 'Bold orange'
    },
    boldYellow: {
        id: 'company-hub.color-picker.bold-yellow',
        description: 'Name of bold yellow color',
        defaultMessage: 'Bold yellow'
    },
    boldLime: {
        id: 'company-hub.color-picker.bold-lime',
        description: 'Name of bold lime color',
        defaultMessage: 'Bold lime'
    },
    boldGreen: {
        id: 'company-hub.color-picker.bold-green',
        description: 'Name of bold green color',
        defaultMessage: 'Bold green'
    },
    boldTeal: {
        id: 'company-hub.color-picker.bold-teal',
        description: 'Name of bold teal color',
        defaultMessage: 'Bold teal'
    },
    defaultBlue: {
        id: 'company-hub.color-picker.default-blue',
        description: 'Name of default blue color',
        defaultMessage: 'Default blue'
    }
});

});



parcelRegister("d2gH4", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $e00a9dd841ec0b47$export$3d31854eb05903e0);

var $lqXwN = parcelRequire("lqXwN");

var $3pU6R = parcelRequire("3pU6R");

var $7hQVc = parcelRequire("7hQVc");
const $e00a9dd841ec0b47$export$3d31854eb05903e0 = (color, packageName)=>{
    try {
        // Convert to HEX as polished's getLuminance only accepts HEX colors
        const hexColor = (0, $7hQVc.toHexColor)(color);
        return (0, $lqXwN.getLuminance)(hexColor) > 0.5 ? "var(--ds-text, #292A2E)" : "var(--ds-text-inverse, #FFFFFF)";
    } catch (error) {
        (0, $3pU6R.default)({
            error: error instanceof Error ? error : new Error(`Color luminance calculation failed for color: ${color}`),
            meta: {
                id: 'readableTextColor',
                packageName: packageName
            }
        });
        // Fallback to text color
        return "var(--ds-text, #292A2E)";
    }
};

});
parcelRegister("lqXwN", function(module, exports) {
$parcel$export(module.exports, "getLuminance", () => $f9aa33b49868fd34$export$c852d90bf7403b62);
//      
// @private
function $f9aa33b49868fd34$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//      
var $f9aa33b49868fd34$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $f9aa33b49868fd34$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return '' + acc + $f9aa33b49868fd34$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
    return property === joinedProperty ? '' + property + position : joinedProperty;
}
function $f9aa33b49868fd34$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$f9aa33b49868fd34$var$generateProperty(property, $f9aa33b49868fd34$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $f9aa33b49868fd34$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === undefined ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === undefined ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === undefined ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $f9aa33b49868fd34$var$generateStyles(property, valuesWithDefaults);
}
//      
function $f9aa33b49868fd34$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
//      
/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $f9aa33b49868fd34$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
//      
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $f9aa33b49868fd34$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$f9aa33b49868fd34$var$endsWith(pxval, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
            newPxval = $f9aa33b49868fd34$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$f9aa33b49868fd34$var$endsWith(base, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
            newBase = $f9aa33b49868fd34$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
        if (typeof newBase === 'string') throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
        return '' + newPxval / newBase + to;
    };
};
//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $f9aa33b49868fd34$export$c63c6f932822f543 = /*#__PURE__*/ $f9aa33b49868fd34$var$pxtoFactory('em');
//      
var $f9aa33b49868fd34$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $f9aa33b49868fd34$export$c82a8a23c9e8bdb6(steps) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$f9aa33b49868fd34$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $f9aa33b49868fd34$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $f9aa33b49868fd34$var$ratioNames[ratio] : ratio;
    if (typeof realBase === 'string') throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
    return realBase * Math.pow(realRatio, steps) + 'em';
}
//      
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $f9aa33b49868fd34$export$fb1897a40d146f7f = /*#__PURE__*/ $f9aa33b49868fd34$var$pxtoFactory('rem');
//      
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $f9aa33b49868fd34$export$8c467e8859fdef13() {
    var _ref;
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
    var pseudoSelector = parent + '::after';
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
//      
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $f9aa33b49868fd34$export$a5b94313d6908893() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
//      
/** */ function $f9aa33b49868fd34$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + '.' + format + '")';
    });
    return fileFontReferences.join(', ');
}
function $f9aa33b49868fd34$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(', ');
}
function $f9aa33b49868fd34$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($f9aa33b49868fd34$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($f9aa33b49868fd34$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $f9aa33b49868fd34$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === undefined ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $f9aa33b49868fd34$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight
        }
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
//      
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $f9aa33b49868fd34$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
//      
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $f9aa33b49868fd34$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
//      
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $f9aa33b49868fd34$export$e79006618d7c6cc3() {
    var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
var $f9aa33b49868fd34$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f9aa33b49868fd34$var$taggedTemplateLiteralLoose = function(strings, raw) {
    strings.raw = raw;
    return strings;
};
var $f9aa33b49868fd34$var$_opinionatedRules;
var $f9aa33b49868fd34$var$_abbrTitle;
var $f9aa33b49868fd34$var$_unopinionatedRules;
//      
var $f9aa33b49868fd34$var$opinionatedRules = ($f9aa33b49868fd34$var$_opinionatedRules = {
    html: {
        fontFamily: 'sans-serif'
    },
    body: {
        margin: '0'
    }
}, $f9aa33b49868fd34$var$_opinionatedRules['a:active,\n  a:hover'] = {
    outlineWidth: '0'
}, $f9aa33b49868fd34$var$_opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    fontFamily: 'sans-serif',
    fontSize: '100%',
    lineHeight: '1.15'
}, $f9aa33b49868fd34$var$_opinionatedRules);
var $f9aa33b49868fd34$var$unopinionatedRules = ($f9aa33b49868fd34$var$_unopinionatedRules = {
    html: {
        lineHeight: '1.15',
        textSizeAdjust: '100%'
    }
}, $f9aa33b49868fd34$var$_unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
    display: 'block'
}, $f9aa33b49868fd34$var$_unopinionatedRules.h1 = {
    fontSize: '2em',
    margin: '0.67em 0'
}, $f9aa33b49868fd34$var$_unopinionatedRules['figcaption,\n  figure,\n  main'] = {
    display: 'block'
}, $f9aa33b49868fd34$var$_unopinionatedRules.figure = {
    margin: '1em 40px'
}, $f9aa33b49868fd34$var$_unopinionatedRules.hr = {
    boxSizing: 'content-box',
    height: '0',
    overflow: 'visible'
}, $f9aa33b49868fd34$var$_unopinionatedRules.pre = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $f9aa33b49868fd34$var$_unopinionatedRules.a = {
    'background-color': 'transparent',
    '-webkit-text-decoration-skip': 'objects'
}, $f9aa33b49868fd34$var$_unopinionatedRules['abbr[title]'] = ($f9aa33b49868fd34$var$_abbrTitle = {
    borderBottom: 'none',
    textDecoration: 'underline'
}, $f9aa33b49868fd34$var$_abbrTitle['textDecoration'] = 'underline dotted', $f9aa33b49868fd34$var$_abbrTitle), $f9aa33b49868fd34$var$_unopinionatedRules['b,\n  strong'] = {
    fontWeight: 'inherit'
}, $f9aa33b49868fd34$var$_unopinionatedRules['code,\n  kbd,\n  samp'] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $f9aa33b49868fd34$var$_unopinionatedRules.dfn = {
    fontStyle: 'italic'
}, $f9aa33b49868fd34$var$_unopinionatedRules.mark = {
    backgroundColor: '#ff0',
    color: '#000'
}, $f9aa33b49868fd34$var$_unopinionatedRules.small = {
    fontSize: '80%'
}, $f9aa33b49868fd34$var$_unopinionatedRules['sub,\n  sup'] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
}, $f9aa33b49868fd34$var$_unopinionatedRules.sub = {
    bottom: '-0.25em'
}, $f9aa33b49868fd34$var$_unopinionatedRules.sup = {
    top: '-0.5em'
}, $f9aa33b49868fd34$var$_unopinionatedRules['audio,\n  video'] = {
    display: 'inline-block'
}, $f9aa33b49868fd34$var$_unopinionatedRules['audio:not([controls])'] = {
    display: 'none',
    height: '0'
}, $f9aa33b49868fd34$var$_unopinionatedRules.img = {
    borderStyle: 'none'
}, $f9aa33b49868fd34$var$_unopinionatedRules['svg:not(:root)'] = {
    overflow: 'hidden'
}, $f9aa33b49868fd34$var$_unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    margin: '0'
}, $f9aa33b49868fd34$var$_unopinionatedRules['button,\n  input'] = {
    overflow: 'visible'
}, $f9aa33b49868fd34$var$_unopinionatedRules['button,\n  select'] = {
    textTransform: 'none'
}, $f9aa33b49868fd34$var$_unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
    '-webkit-appearance': 'button'
}, $f9aa33b49868fd34$var$_unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
    borderStyle: 'none',
    padding: '0'
}, $f9aa33b49868fd34$var$_unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
    outline: '1px dotted ButtonText'
}, $f9aa33b49868fd34$var$_unopinionatedRules.fieldset = {
    border: '1px solid #c0c0c0',
    margin: '0 2px',
    padding: '0.35em 0.625em 0.75em'
}, $f9aa33b49868fd34$var$_unopinionatedRules.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
}, $f9aa33b49868fd34$var$_unopinionatedRules.progress = {
    display: 'inline-block',
    verticalAlign: 'baseline'
}, $f9aa33b49868fd34$var$_unopinionatedRules.textarea = {
    overflow: 'auto'
}, $f9aa33b49868fd34$var$_unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
    boxSizing: 'border-box',
    padding: '0'
}, $f9aa33b49868fd34$var$_unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
    height: 'auto'
}, $f9aa33b49868fd34$var$_unopinionatedRules['[type="search"]'] = {
    '-webkit-appearance': 'textfield',
    outlineOffset: '-2px'
}, $f9aa33b49868fd34$var$_unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
    '-webkit-appearance': 'none'
}, $f9aa33b49868fd34$var$_unopinionatedRules['::-webkit-file-upload-button'] = {
    '-webkit-appearance': 'button',
    font: 'inherit'
}, $f9aa33b49868fd34$var$_unopinionatedRules['details,\n  menu'] = {
    display: 'block'
}, $f9aa33b49868fd34$var$_unopinionatedRules.summary = {
    display: 'list-item'
}, $f9aa33b49868fd34$var$_unopinionatedRules.canvas = {
    display: 'inline-block'
}, $f9aa33b49868fd34$var$_unopinionatedRules.template = {
    display: 'none'
}, $f9aa33b49868fd34$var$_unopinionatedRules['[hidden]'] = {
    display: 'none'
}, $f9aa33b49868fd34$var$_unopinionatedRules);
function $f9aa33b49868fd34$var$mergeRules(baseRules, additionalRules) {
    var mergedRules = $f9aa33b49868fd34$var$_extends({}, baseRules);
    Object.keys(additionalRules).forEach(function(key) {
        if (mergedRules[key]) mergedRules[key] = $f9aa33b49868fd34$var$_extends({}, mergedRules[key], additionalRules[key]);
        else mergedRules[key] = $f9aa33b49868fd34$var$_extends({}, additionalRules[key]);
    });
    return mergedRules;
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $f9aa33b49868fd34$export$a3295358bff77e(excludeOpinionated) {
    if (excludeOpinionated) return $f9aa33b49868fd34$var$unopinionatedRules;
    return $f9aa33b49868fd34$var$mergeRules($f9aa33b49868fd34$var$unopinionatedRules, $f9aa33b49868fd34$var$opinionatedRules);
}
//      
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $f9aa33b49868fd34$export$c7187bbd1a7a9244(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
    return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = $f9aa33b49868fd34$var$_extends({}, styles), _ref[parent + ':-moz-placeholder'] = $f9aa33b49868fd34$var$_extends({}, styles), _ref[parent + '::-moz-placeholder'] = $f9aa33b49868fd34$var$_extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = $f9aa33b49868fd34$var$_extends({}, styles), _ref;
}
var $f9aa33b49868fd34$var$_templateObject = /*#__PURE__*/ $f9aa33b49868fd34$var$taggedTemplateLiteralLoose([
    'radial-gradient(',
    '',
    '',
    '',
    ')'
], [
    'radial-gradient(',
    '',
    '',
    '',
    ')'
]);
//      
/** */ function $f9aa33b49868fd34$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $f9aa33b49868fd34$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        // Adds leading coma if properties preceed color-stops
        if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $f9aa33b49868fd34$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $f9aa33b49868fd34$var$parseFallback(colorStops),
        backgroundImage: $f9aa33b49868fd34$var$constructGradientValue($f9aa33b49868fd34$var$_templateObject, position, shape, extent, colorStops.join(', '))
    };
}
//      
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $f9aa33b49868fd34$export$19389033401d366a(filename, backgroundSize) {
    var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
    var _ref;
    var retinaFilename = arguments[3];
    var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
    return _ref = {
        backgroundImage: 'url(' + filename + '.' + ext + ')'
    }, _ref[$f9aa33b49868fd34$export$e79006618d7c6cc3()] = {
        backgroundImage: 'url(' + rFilename + ')',
        backgroundSize: backgroundSize
    }, _ref;
}
//      
/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $f9aa33b49868fd34$export$7c69810f7b8835c9(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return _ref = {}, _ref[parent + '::-moz-selection'] = $f9aa33b49868fd34$var$_extends({}, styles), _ref[parent + '::selection'] = $f9aa33b49868fd34$var$_extends({}, styles), _ref;
}
//      
/* eslint-disable key-spacing */ var $f9aa33b49868fd34$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $f9aa33b49868fd34$export$61210fa83792a81(timingFunction) {
    return $f9aa33b49868fd34$var$functionsMap[timingFunction];
}
//      
/** */ var $f9aa33b49868fd34$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
        case 'left':
            return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
        case 'bottom':
            return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
        case 'right':
            return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
};
// needed for border-color
var $f9aa33b49868fd34$var$reverseDirection = {
    left: 'Right',
    right: 'Left',
    top: 'Bottom',
    bottom: 'Top'
};
function $f9aa33b49868fd34$export$9eed783d03e0135c(_ref) {
    var _ref2;
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
    var unitlessHeight = parseFloat(height);
    var unitlessWidth = parseFloat(width);
    if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    return _ref2 = {
        borderColor: backgroundColor,
        width: '0',
        height: '0',
        borderWidth: $f9aa33b49868fd34$var$getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
        borderStyle: 'solid'
    }, _ref2['border' + $f9aa33b49868fd34$var$reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}
//      
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $f9aa33b49868fd34$export$dca3d8ad656c34d2() {
    var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
//      
function $f9aa33b49868fd34$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $f9aa33b49868fd34$var$convertToInt(red, green, blue) {
    return $f9aa33b49868fd34$var$colorToInt(red) + "," + $f9aa33b49868fd34$var$colorToInt(green) + "," + $f9aa33b49868fd34$var$colorToInt(blue);
}
function $f9aa33b49868fd34$var$hslToRgb(hue, saturation, lightness) {
    var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f9aa33b49868fd34$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
//      
var $f9aa33b49868fd34$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $f9aa33b49868fd34$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $f9aa33b49868fd34$var$namedColorMap[normalizedColorName] ? '#' + $f9aa33b49868fd34$var$namedColorMap[normalizedColorName] : color;
}
//      
var $f9aa33b49868fd34$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $f9aa33b49868fd34$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $f9aa33b49868fd34$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $f9aa33b49868fd34$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $f9aa33b49868fd34$var$hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $f9aa33b49868fd34$var$hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $f9aa33b49868fd34$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $f9aa33b49868fd34$var$nameToHex(color);
    if (normalizedColor.match($f9aa33b49868fd34$var$hexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($f9aa33b49868fd34$var$reducedHexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
    var rgbMatched = $f9aa33b49868fd34$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt('' + rgbMatched[1], 10),
        green: parseInt('' + rgbMatched[2], 10),
        blue: parseInt('' + rgbMatched[3], 10)
    };
    var rgbaMatched = $f9aa33b49868fd34$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt('' + rgbaMatched[1], 10),
        green: parseInt('' + rgbaMatched[2], 10),
        blue: parseInt('' + rgbaMatched[3], 10),
        alpha: parseFloat('' + rgbaMatched[4])
    };
    var hslMatched = $f9aa33b49868fd34$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt('' + hslMatched[1], 10);
        var saturation = parseInt('' + hslMatched[2], 10) / 100;
        var lightness = parseInt('' + hslMatched[3], 10) / 100;
        var rgbColorString = 'rgb(' + $f9aa33b49868fd34$var$hslToRgb(hue, saturation, lightness) + ')';
        var hslRgbMatched = $f9aa33b49868fd34$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
        return {
            red: parseInt('' + hslRgbMatched[1], 10),
            green: parseInt('' + hslRgbMatched[2], 10),
            blue: parseInt('' + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $f9aa33b49868fd34$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt('' + hslaMatched[1], 10);
        var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
        var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
        var _rgbColorString = 'rgb(' + $f9aa33b49868fd34$var$hslToRgb(_hue, _saturation, _lightness) + ')';
        var _hslRgbMatched = $f9aa33b49868fd34$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
        return {
            red: parseInt('' + _hslRgbMatched[1], 10),
            green: parseInt('' + _hslRgbMatched[2], 10),
            blue: parseInt('' + _hslRgbMatched[3], 10),
            alpha: parseFloat('' + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
//      
function $f9aa33b49868fd34$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue = void 0;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
//      
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $f9aa33b49868fd34$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $f9aa33b49868fd34$var$rgbToHsl($f9aa33b49868fd34$export$2f48baff6995707a(color));
}
//      
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $f9aa33b49868fd34$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
//      
function $f9aa33b49868fd34$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $f9aa33b49868fd34$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $f9aa33b49868fd34$var$reduceHexValue('#' + $f9aa33b49868fd34$var$numberToHex(value) + $f9aa33b49868fd34$var$numberToHex(green) + $f9aa33b49868fd34$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $f9aa33b49868fd34$var$reduceHexValue('#' + $f9aa33b49868fd34$var$numberToHex(value.red) + $f9aa33b49868fd34$var$numberToHex(value.green) + $f9aa33b49868fd34$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $f9aa33b49868fd34$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $f9aa33b49868fd34$export$2f48baff6995707a(firstValue);
        return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $f9aa33b49868fd34$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $f9aa33b49868fd34$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
//      
function $f9aa33b49868fd34$var$colorToHex(color) {
    return $f9aa33b49868fd34$var$numberToHex(Math.round(color * 255));
}
function $f9aa33b49868fd34$var$convertToHex(red, green, blue) {
    return $f9aa33b49868fd34$var$reduceHexValue('#' + $f9aa33b49868fd34$var$colorToHex(red) + $f9aa33b49868fd34$var$colorToHex(green) + $f9aa33b49868fd34$var$colorToHex(blue));
}
function $f9aa33b49868fd34$var$hslToHex(hue, saturation, lightness) {
    return $f9aa33b49868fd34$var$hslToRgb(hue, saturation, lightness, $f9aa33b49868fd34$var$convertToHex);
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $f9aa33b49868fd34$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $f9aa33b49868fd34$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $f9aa33b49868fd34$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $f9aa33b49868fd34$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $f9aa33b49868fd34$var$hslToHex(value, saturation, lightness) : 'rgba(' + $f9aa33b49868fd34$var$hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $f9aa33b49868fd34$var$hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + $f9aa33b49868fd34$var$hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
//      
var $f9aa33b49868fd34$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $f9aa33b49868fd34$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $f9aa33b49868fd34$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $f9aa33b49868fd34$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $f9aa33b49868fd34$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $f9aa33b49868fd34$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($f9aa33b49868fd34$var$errMsg);
    if ($f9aa33b49868fd34$var$isRgba(color)) return $f9aa33b49868fd34$export$4e46ac54fc82cf3b(color);
    if ($f9aa33b49868fd34$var$isRgb(color)) return $f9aa33b49868fd34$export$8972dc0e6ad9238f(color);
    if ($f9aa33b49868fd34$var$isHsla(color)) return $f9aa33b49868fd34$export$810b04175080204c(color);
    if ($f9aa33b49868fd34$var$isHsl(color)) return $f9aa33b49868fd34$export$8f4a7c0bb78e6ea8(color);
    throw new Error($f9aa33b49868fd34$var$errMsg);
}
//      
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $f9aa33b49868fd34$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $f9aa33b49868fd34$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $f9aa33b49868fd34$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $f9aa33b49868fd34$var$curried(f, f.length, []);
}
//      
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$adjustHue(degree, color) {
    var hslColor = $f9aa33b49868fd34$export$1286688e1b3fde9c(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, hslColor, {
        hue: (hslColor.hue + degree) % 360
    }));
}
var $f9aa33b49868fd34$export$2b372a09365374d6 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$adjustHue);
//      
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $f9aa33b49868fd34$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $f9aa33b49868fd34$export$1286688e1b3fde9c(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
//      
function $f9aa33b49868fd34$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
//      
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$darken(amount, color) {
    var hslColor = $f9aa33b49868fd34$export$1286688e1b3fde9c(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, hslColor, {
        lightness: $f9aa33b49868fd34$var$guard(0, 1, hslColor.lightness - amount)
    }));
}
var $f9aa33b49868fd34$export$4b073707ff63303 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$darken);
//      
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$desaturate(amount, color) {
    var hslColor = $f9aa33b49868fd34$export$1286688e1b3fde9c(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, hslColor, {
        saturation: $f9aa33b49868fd34$var$guard(0, 1, hslColor.saturation - amount)
    }));
}
var $f9aa33b49868fd34$export$fb75607d98509d9 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$desaturate);
//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $f9aa33b49868fd34$export$c852d90bf7403b62(color) {
    var rgbColor = $f9aa33b49868fd34$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
//      
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $f9aa33b49868fd34$export$6f416a6db2dfcd5c(color) {
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, $f9aa33b49868fd34$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
//      
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $f9aa33b49868fd34$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $f9aa33b49868fd34$export$2f48baff6995707a(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
//      
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$lighten(amount, color) {
    var hslColor = $f9aa33b49868fd34$export$1286688e1b3fde9c(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, hslColor, {
        lightness: $f9aa33b49868fd34$var$guard(0, 1, hslColor.lightness + amount)
    }));
}
var $f9aa33b49868fd34$export$c0816ed86df316af = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$lighten);
//      
/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $f9aa33b49868fd34$var$mix() {
    var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
    var color = arguments[1];
    var otherColor = arguments[2];
    var parsedColor1 = $f9aa33b49868fd34$export$2f48baff6995707a(color);
    var color1 = $f9aa33b49868fd34$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $f9aa33b49868fd34$export$2f48baff6995707a(otherColor);
    var color2 = $f9aa33b49868fd34$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = weight * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
    };
    return $f9aa33b49868fd34$export$4e46ac54fc82cf3b(mixedColor);
}
var $f9aa33b49868fd34$export$2c9e8a9632a706b2 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$mix);
//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$opacify(amount, color) {
    var parsedColor = $f9aa33b49868fd34$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $f9aa33b49868fd34$var$_extends({}, parsedColor, {
        alpha: $f9aa33b49868fd34$var$guard(0, 1, (alpha * 100 + amount * 100) / 100)
    });
    return $f9aa33b49868fd34$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $f9aa33b49868fd34$export$f4f50e3877dd0530 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$opacify);
//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $f9aa33b49868fd34$var$readableColor(color) {
    return $f9aa33b49868fd34$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
var $f9aa33b49868fd34$export$61654c1796c44811 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$readableColor);
//      
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$saturate(amount, color) {
    var hslColor = $f9aa33b49868fd34$export$1286688e1b3fde9c(color);
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, hslColor, {
        saturation: $f9aa33b49868fd34$var$guard(0, 1, hslColor.saturation + amount)
    }));
}
var $f9aa33b49868fd34$export$5fcac96f5a87e3db = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$saturate);
//      
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$setHue(hue, color) {
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, $f9aa33b49868fd34$export$1286688e1b3fde9c(color), {
        hue: hue
    }));
}
var $f9aa33b49868fd34$export$3bf58ce3e497a846 = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$setHue);
//      
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$setLightness(lightness, color) {
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, $f9aa33b49868fd34$export$1286688e1b3fde9c(color), {
        lightness: lightness
    }));
}
var $f9aa33b49868fd34$export$7ef5d725337b805d = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$setLightness);
//      
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $f9aa33b49868fd34$var$setSaturation(saturation, color) {
    return $f9aa33b49868fd34$export$42fe740cdf79b2df($f9aa33b49868fd34$var$_extends({}, $f9aa33b49868fd34$export$1286688e1b3fde9c(color), {
        saturation: saturation
    }));
}
var $f9aa33b49868fd34$export$b40fe421ea7a4f7e = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$setSaturation);
//      
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $f9aa33b49868fd34$var$shade(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $f9aa33b49868fd34$export$2c9e8a9632a706b2(percentage, color, 'rgb(0, 0, 0)');
}
var $f9aa33b49868fd34$export$3e32adda0df4ef5d = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$shade);
//      
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $f9aa33b49868fd34$var$tint(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $f9aa33b49868fd34$export$2c9e8a9632a706b2(percentage, color, 'rgb(255, 255, 255)');
}
var $f9aa33b49868fd34$export$fc176dd65a27d98b = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$tint);
//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $f9aa33b49868fd34$var$transparentize(amount, color) {
    var parsedColor = $f9aa33b49868fd34$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $f9aa33b49868fd34$var$_extends({}, parsedColor, {
        alpha: $f9aa33b49868fd34$var$guard(0, 1, (alpha * 100 - amount * 100) / 100)
    });
    return $f9aa33b49868fd34$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $f9aa33b49868fd34$export$d11da87e55cc498f = /*#__PURE__*/ $f9aa33b49868fd34$var$curry($f9aa33b49868fd34$var$transparentize);
//      
/** */ /**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $f9aa33b49868fd34$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
//      
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $f9aa33b49868fd34$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $f9aa33b49868fd34$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $f9aa33b49868fd34$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
        'borderColor'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $f9aa33b49868fd34$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $f9aa33b49868fd34$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $f9aa33b49868fd34$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
        'borderStyle'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $f9aa33b49868fd34$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
        'borderWidth'
    ].concat(values));
}
//      
function $f9aa33b49868fd34$var$generateSelectors(template, state) {
    var stateSuffix = state ? ':' + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $f9aa33b49868fd34$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $f9aa33b49868fd34$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($f9aa33b49868fd34$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
//      
var $f9aa33b49868fd34$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $f9aa33b49868fd34$var$template(state) {
    return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $f9aa33b49868fd34$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $f9aa33b49868fd34$var$statefulSelectors(states, $f9aa33b49868fd34$var$template, $f9aa33b49868fd34$var$stateMap);
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $f9aa33b49868fd34$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
        'margin'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $f9aa33b49868fd34$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
        'padding'
    ].concat(values));
}
//      
var $f9aa33b49868fd34$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $f9aa33b49868fd34$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($f9aa33b49868fd34$var$positionMap$1.indexOf(positionKeyword) >= 0) return $f9aa33b49868fd34$var$_extends({
        position: positionKeyword
    }, $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $f9aa33b49868fd34$export$4fc00c04dd60af95.apply(undefined, [
            '',
            firstValue
        ].concat(values));
    }
}
//      
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $f9aa33b49868fd34$export$346677f925de839c(height) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
    return {
        height: height,
        width: width
    };
}
//      
var $f9aa33b49868fd34$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $f9aa33b49868fd34$var$template$1(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $f9aa33b49868fd34$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $f9aa33b49868fd34$var$statefulSelectors(states, $f9aa33b49868fd34$var$template$1, $f9aa33b49868fd34$var$stateMap$1);
}
//      
/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */ function $f9aa33b49868fd34$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        transition: properties.join(', ')
    };
}

});


parcelRegister("Cc5Nl", function(module, exports) {
$parcel$export(module.exports, "HUB_COLOR_CSS_VARS", () => $8a00a129fb967180$export$6e4a1de0ca7c3086);
/**
 * Centralised registry of `--hub-*` CSS custom-property names emitted by
 * `<HubThemingProvider>`'s wrapper `<div>`. These are the **only** v2 CSS-var
 * names extension code references — never hand-write `--hub-*` strings at the
 * call site.
 *
 * Why centralised:
 *   • Single rename point — change a name here, every consumer follows.
 *   • Type-safe lookup via `PaletteRef` — typo "primary.150" fails the build.
 *   • `resolveAdfColor` derives its `var(--hub-color-...)` output from this
 *     registry, so the renderer never sees raw var-name strings.
 *
 * Naming convention:
 *   --hub-color-{family}-{shade}    → e.g. --hub-color-primary-200
 *   --hub-color-{semantic}          → e.g. --hub-color-text-on-primary
 *   --hub-radius-{slot}             → reserved for future radius work
 *   --hub-space-{slot}              → reserved for future density work
 *
 * The wrapper div emits the registry as inline `style` so the values are
 * present in the SSR HTML on first paint — no useEffect, no setProperty.
 */ const $8a00a129fb967180$var$SHADES = [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '1000'
];
const $8a00a129fb967180$var$FAMILIES = [
    'primary',
    'accent'
];
const $8a00a129fb967180$var$buildColorVarMap = ()=>{
    const out = {};
    for (const family of $8a00a129fb967180$var$FAMILIES)for (const shade of $8a00a129fb967180$var$SHADES){
        const ref = `${family}.${shade}`;
        out[ref] = `--hub-color-${family}-${shade}`;
    }
    return out;
};
const $8a00a129fb967180$export$6e4a1de0ca7c3086 = Object.freeze($8a00a129fb967180$var$buildColorVarMap());
const $8a00a129fb967180$export$83d6614a5062fafa = Object.freeze({
    color: $8a00a129fb967180$export$6e4a1de0ca7c3086
});

});

parcelRegister("eHTbE", function(module, exports) {
$parcel$export(module.exports, "toAdfColor", () => $0edcfa3217cb0b98$export$3b6ce31dec9a22fc);
/**
 * Picker → ADF storage adapter.
 *
 * If the hex emitted by the color-picker matches a shade in the active brand
 * palette, persist the CSS-var reference for that shade (e.g.
 * `"var(--hub-color-primary-300)"`) so the value tracks future brand-color
 * edits via the browser's CSS cascade — no resolver call, no JS palette
 * lookup at render time. Otherwise persist the raw hex (frozen literal).
 *
 * Pure case-insensitive lookup, no normalisation — relies on the picker
 * emitting hex in the same casing the palette uses (`csm-colour-theme-generator`
 * outputs lowercase). Pure, synchronous, no side effects → SSR-safe.
 */ 
var $53RlD = parcelRequire("53RlD");

var $Cc5Nl = parcelRequire("Cc5Nl");
const $0edcfa3217cb0b98$export$3b6ce31dec9a22fc = (hex, palette, opts)=>{
    if (opts !== null && opts !== void 0 && opts.isBrandPaletteLocked) {
        // Locked tenants have no palette to track — the picker offers exactly
        // one brand swatch (the admin's primary) plus custom hex. Anchor a
        // primary pick to `--hub-primary-color`, which `HubThemingProvider`
        // keeps pointed at the live brand colour, so the element keeps
        // following future brand-colour edits.
        //
        // The palette path below would *look* like it works — `generateColors`
        // substitutes the brand hex into whichever ramp slot is
        // luminance-closest, so the pick does match a shade — but that slot
        // index is a function of the brand colour. Re-brand and the persisted
        // `--hub-color-primary-<N>` resolves to an unrelated tint of the new
        // hue instead of the new brand colour. And when the primary isn't a
        // hex `generateThemeBranding` can parse, it appears nowhere in the
        // ramp and the pick is persisted as a bare literal with no var at all.
        if (opts.primaryColor && hex.toLowerCase() === opts.primaryColor.toLowerCase()) return `var(${0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR}, ${hex})`;
        // Anything else is a custom colour: freeze it, so an un-entitled
        // tenant can't persist a palette-shade ref via a stale current value.
        return hex;
    }
    const lower = hex.toLowerCase();
    for (const [ref, shadeHex] of Object.entries(palette)){
        if (shadeHex.toLowerCase() === lower) // Hex fallback after the CSS var name lets the value still resolve
        // to a usable color when the wrapper isn't in scope (e.g. shared
        // extensions rendered in Confluence Company Hub, or color helpers
        // like `extractColorCode` that look up the var on `documentElement`
        // rather than the wrapper). The browser uses the wrapper's live
        // value when the var is defined (so brand-color edits still track
        // inside the hub), and falls back to this snapshot hex otherwise.
        return `var(${(0, $Cc5Nl.HUB_COLOR_CSS_VARS)[ref]}, ${shadeHex})`;
    }
    return hex;
};

});

parcelRegister("1WoKY", function(module, exports) {
$parcel$export(module.exports, "useHubBrandPalette", () => $3a0058c7b181cc00$export$52531ed83ceae9ec);

var $bSJIT = parcelRequire("bSJIT");

var $kn9hW = parcelRequire("kn9hW");
const $3a0058c7b181cc00$export$52531ed83ceae9ec = (inputs)=>{
    const { primary: primary, accent: accent } = inputs;
    return (0, $bSJIT.useMemo)(()=>(0, $kn9hW.generateHubBrandPalette)({
            primary: primary,
            accent: accent
        }), [
        primary,
        accent
    ]);
};

});
parcelRegister("kn9hW", function(module, exports) {
$parcel$export(module.exports, "generateHubBrandPalette", () => $d75c2887c5f1cc89$export$fb2e77ab23c1ab27);
/**
 * Build a 20-shade `HubBrandPalette` from a (primary, accent) brand colour
 * pair, per §4.1 of the Advanced Theming v2 design.
 *
 * Implementation note: this is a thin wrapper around the existing CSM colour
 * theme generator (which is also what `setHubBrandingStyle` already uses).
 * That generator runs the same Material-HCT-based 10-step ramp algorithm as
 * `@atlaskit/tokens`'s internal `generateColors`, but is exposed via a public
 * entry-point and is already a hubs dependency, so we don't have to duplicate
 * the colour science.
 *
 * Pure and synchronous — safe to call during render, including SSR.
 */ 
var $lkNTb = parcelRequire("lkNTb");
const $d75c2887c5f1cc89$var$SHADES = [
    [
        '100',
        'color100'
    ],
    [
        '200',
        'color200'
    ],
    [
        '300',
        'color300'
    ],
    [
        '400',
        'color400'
    ],
    [
        '500',
        'color500'
    ],
    [
        '600',
        'color600'
    ],
    [
        '700',
        'color700'
    ],
    [
        '800',
        'color800'
    ],
    [
        '900',
        'color900'
    ],
    [
        '1000',
        'color1000'
    ]
];
const $d75c2887c5f1cc89$var$buildFamily = (family, hex)=>{
    const ramp = (0, $lkNTb.generateThemeBranding)(hex);
    const out = {};
    for (const [shade, rampKey] of $d75c2887c5f1cc89$var$SHADES){
        const key = `${family}.${shade}`;
        out[key] = ramp[rampKey];
    }
    return out;
};
const $d75c2887c5f1cc89$export$fb2e77ab23c1ab27 = ({ primary: primary, accent: accent })=>{
    return {
        ...$d75c2887c5f1cc89$var$buildFamily('primary', primary),
        ...$d75c2887c5f1cc89$var$buildFamily('accent', accent)
    };
};

});


parcelRegister("hbQ4S", function(module, exports) {
$parcel$export(module.exports, "HUB_LOCKED_NEUTRAL_HEXES", () => $941b66704f6b89e3$export$acb8db9451e22570);
$parcel$export(module.exports, "HUB_LOCKED_BORDER_NEUTRAL_HEXES", () => $941b66704f6b89e3$export$713a593549a724d8);
$parcel$export(module.exports, "buildLockedColorMap", () => $941b66704f6b89e3$export$8cccd6c3699eb41c);

var $7E5z7 = parcelRequire("7E5z7");
const $941b66704f6b89e3$export$a6017cadbc9d9217 = '#DCDFE4'; // matches `color.border`
const $941b66704f6b89e3$export$29b411f689221690 = '#758195'; // matches `color.border.bold`
const $941b66704f6b89e3$export$acb8db9451e22570 = [
    '#FFFFFF',
    '#000000'
];
const $941b66704f6b89e3$export$713a593549a724d8 = [
    '#FFFFFF',
    $941b66704f6b89e3$export$a6017cadbc9d9217,
    $941b66704f6b89e3$export$29b411f689221690,
    '#000000'
];
const $941b66704f6b89e3$export$8cccd6c3699eb41c = (...hexes)=>{
    const knownColors = Array.from(new Set(hexes.filter(Boolean).map((hex)=>hex.toLowerCase())));
    return (0, $7E5z7.createBuiltInColorMap)({
        knownColors: knownColors
    });
};

});

parcelRegister("kyaby", function(module, exports) {
$parcel$export(module.exports, "HUB_CORNER_RADIUS_MIN", () => $31d864212899c448$export$ca8289818e8a00b3);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_MAX", () => $31d864212899c448$export$fd5c0c061b90ed51);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_STEP", () => $31d864212899c448$export$39e466a7b7ce22ff);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_DEFAULT", () => $31d864212899c448$export$80508b5197dbe846);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_CSS_VAR", () => $31d864212899c448$export$e3711566ecaf02ae);
$parcel$export(module.exports, "resolveHubCornerRadius", () => $31d864212899c448$export$122ea29a9b10732a);
$parcel$export(module.exports, "resolveCornerRadiusOverride", () => $31d864212899c448$export$db3cd30e3eed0965);

var $4nock = parcelRequire("4nock");
const $31d864212899c448$export$ca8289818e8a00b3 = 0;
const $31d864212899c448$export$fd5c0c061b90ed51 = 32;
const $31d864212899c448$export$39e466a7b7ce22ff = 8;
const $31d864212899c448$export$80508b5197dbe846 = 8;
const $31d864212899c448$export$e3711566ecaf02ae = '--hub-corner-radius';
const $31d864212899c448$var$VALID = new Set([
    0,
    8,
    16,
    24,
    32
]);
const $31d864212899c448$export$122ea29a9b10732a = (value)=>typeof value === 'number' && $31d864212899c448$var$VALID.has(value) ? value : $31d864212899c448$export$80508b5197dbe846;
const $31d864212899c448$export$3795d91173f540a = (style)=>style === (0, $4nock.CornerStyle).SQUARED ? 0 : undefined;
const $31d864212899c448$export$db3cd30e3eed0965 = (cornerRadius, cornerStyle)=>cornerRadius ?? $31d864212899c448$export$3795d91173f540a(cornerStyle);

});

parcelRegister("1VjxL", function(module, exports) {
$parcel$export(module.exports, "buildHubThemingStateAttributes", () => $9c5e580171ff0a53$export$8173e092749d2f38);

var $kyaby = parcelRequire("kyaby");

var $bBolO = parcelRequire("bBolO");

var $9aQft = parcelRequire("9aQft");
const $9c5e580171ff0a53$export$8173e092749d2f38 = ({ primaryColor: primaryColor, accentColor: accentColor, typography: typography, cornerRadius: cornerRadius, spaceDensity: spaceDensity })=>{
    const colorsCustomized = !!primaryColor && primaryColor.toUpperCase() !== (0, $9aQft.DEFAULT_PRIMARY) || !!accentColor && accentColor.toUpperCase() !== (0, $9aQft.DEFAULT_ACCENT);
    const typographyCustomized = !!typography;
    const cornerRadiusCustomized = typeof cornerRadius === 'number' && cornerRadius !== (0, $kyaby.HUB_CORNER_RADIUS_DEFAULT);
    const spaceDensityCustomized = !!spaceDensity && spaceDensity !== (0, $bBolO.DEFAULT_SPACE_DENSITY);
    const customizedDimensionCount = Number(colorsCustomized) + Number(typographyCustomized) + Number(cornerRadiusCustomized) + Number(spaceDensityCustomized);
    return {
        customizedDimensionCount: customizedDimensionCount,
        colorsCustomized: colorsCustomized,
        typographyCustomized: typographyCustomized,
        cornerRadiusCustomized: cornerRadiusCustomized,
        spaceDensityCustomized: spaceDensityCustomized,
        primaryColor: primaryColor,
        accentColor: accentColor,
        bodyFont: typography === null || typography === void 0 ? void 0 : typography.body,
        headingFont: typography === null || typography === void 0 ? void 0 : typography.heading,
        cornerRadius: cornerRadius,
        spaceDensity: spaceDensity
    };
};

});
parcelRegister("bBolO", function(module, exports) {
$parcel$export(module.exports, "SPACE_DENSITIES", () => $6c6e1f6ecac8303a$export$7525d7f8474e6b81);
$parcel$export(module.exports, "DEFAULT_SPACE_DENSITY", () => $6c6e1f6ecac8303a$export$61fa4fc6e277c51f);
$parcel$export(module.exports, "EDITOR_BLOCK_SPACING_VAR", () => $6c6e1f6ecac8303a$export$cf3820686f87514a);
$parcel$export(module.exports, "getBlockSpacingForDensity", () => $6c6e1f6ecac8303a$export$a652a2b31fb9818);
$parcel$export(module.exports, "getCardGapForDensity", () => $6c6e1f6ecac8303a$export$4cd8ab356af25889);
/**
 * Public type for the Hub space density (spacing) customization.
 *
 * Values mirror the backend `HelpCenterSpaceDensity` GraphQL enum exactly
 * (uppercase), so there is no case-mapping at the read/write boundaries.
 *
 * The chosen density will control the vertical rhythm
 * between every element on the hub page and, eventually, the spacing inside
 * elements.
 */ const $6c6e1f6ecac8303a$export$7525d7f8474e6b81 = [
    'DEFAULT',
    'COMFORTABLE',
    'BREEZY'
];
const $6c6e1f6ecac8303a$export$61fa4fc6e277c51f = 'DEFAULT';
const $6c6e1f6ecac8303a$export$cf3820686f87514a = '--ak-editor-extension-block-spacing';
const $6c6e1f6ecac8303a$export$6ca1261611fbc46e = {
    DEFAULT: '0',
    COMFORTABLE: '16px',
    BREEZY: '24px'
};
const $6c6e1f6ecac8303a$export$a652a2b31fb9818 = (density)=>$6c6e1f6ecac8303a$export$6ca1261611fbc46e[density];
const $6c6e1f6ecac8303a$export$cc1134cace54c337 = {
    DEFAULT: 16,
    COMFORTABLE: 16,
    BREEZY: 24
};
const $6c6e1f6ecac8303a$export$4cd8ab356af25889 = (density)=>$6c6e1f6ecac8303a$export$cc1134cace54c337[density];

});

parcelRegister("9aQft", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PRIMARY", () => $72ec3563cbff1ac9$export$b9864279fc70d379);
$parcel$export(module.exports, "DEFAULT_ACCENT", () => $72ec3563cbff1ac9$export$74ca527397fc1422);
/**
 * Single source of truth for the day-0 brand-colour defaults.
 *
 * A hub with no persisted primary/accent falls back to these, and the analytics
 * "customized vs default" check compares against them — so BOTH
 * `controllers/hub-theming-context` (which applies them) and
 * `utils/hub-theming-analytics` (which measures against them) import from here.
 * Do not re-declare these anywhere else, or day-0 hubs get mis-flagged as
 * customized when only one copy is updated.
 *
 * The other two dimensions' defaults already live with their own modules and
 * should be imported from there: `HUB_CORNER_RADIUS_DEFAULT` from
 * `utils/hub-corner-radius`, `DEFAULT_SPACE_DENSITY` from `utils/hub-space-density`.
 *
 * Kept dependency-free (no React/relay) so the pure analytics helper can import
 * it without pulling in the framework or creating an import cycle with
 * `hub-theming-context` (which imports the analytics helper).
 */ const $72ec3563cbff1ac9$export$b9864279fc70d379 = '#003172';
const $72ec3563cbff1ac9$export$74ca527397fc1422 = '#DDDEE1';

});


parcelRegister("9oBg1", function(module, exports) {
$parcel$export(module.exports, "getHubDefaultParameters", () => $19af5054570df0b5$export$25a6d2da841ddb1d);

var $d2gH4 = parcelRequire("d2gH4");

var $53RlD = parcelRequire("53RlD");

var $5fSMT = parcelRequire("5fSMT");
var $Cc5Nl = parcelRequire("Cc5Nl");
/**
 * Day-0 default shade that bespoke extensions inherit through
 * `CommonHubExtensionsDependenciesProvider` when an extension hasn't pinned a
 * background of its own. Kept local to this resolver — it is intentionally
 * decoupled from `ELEMENT_DEFAULTS` because the per-element map is the
 * source-of-truth for *named* element slots (e.g. `callout.bg`), whereas this
 * is the resolver's own generic fallback shared across every extension.
 */ const $19af5054570df0b5$var$DEFAULT_HUB_BACKGROUND_SHADE = 'primary.200';
/**
 * Per-element bg shade overrides. When an extension wants a different default
 * shade than the resolver's generic `primary.200`, it's mapped here. Keys
 * match the `ELEMENT_DEFAULTS` map; values are the slot suffix to look up.
 */ const $19af5054570df0b5$var$ELEMENT_BG_SHADE = {
    section: (0, $5fSMT.ELEMENT_DEFAULTS)['section.bg']
};
/**
 * Per-element icon-color shade overrides. Currently only JSM Help renders an
 * icon; values are looked up in `ELEMENT_DEFAULTS`.
 */ const $19af5054570df0b5$var$ELEMENT_ICON_SHADE = {
    'jsm-help': (0, $5fSMT.ELEMENT_DEFAULTS)['jsm-help.icon']
};
const $19af5054570df0b5$export$25a6d2da841ddb1d = (options = {})=>{
    if (options.palette) {
        if (options.isBrandPaletteLocked) {
            // One brand colour across every element — no palette tints. The
            // `--hub-primary-color` var tracks brand edits; the hex is the fallback.
            const primary = options.primaryColor ?? options.palette['primary.600'];
            const iconShade = options.element && $19af5054570df0b5$var$ELEMENT_ICON_SHADE[options.element];
            return {
                backgroundColor: `var(${0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR}, ${primary})`,
                textColor: (0, $d2gH4.readableTextColor)(primary, '@atlassian/company-hub-common'),
                isAdvancedThemingEnabled: true,
                ...iconShade ? {
                    iconColor: `var(${0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR}, ${primary})`
                } : {}
            };
        }
        const bgShade = options.element && $19af5054570df0b5$var$ELEMENT_BG_SHADE[options.element] || $19af5054570df0b5$var$DEFAULT_HUB_BACKGROUND_SHADE;
        const iconShade = options.element && $19af5054570df0b5$var$ELEMENT_ICON_SHADE[options.element];
        // Gate ON:
        //   - bg = CSS-var ref so the cascade tracks brand-color edits via the
        //     <HubThemingProvider> wrapper's inline `style`.
        //   - text = WCAG-readable black/white computed against the resolved
        //     bg hex. Stored as a literal so it remains correct even when
        //     admin overrides bg per-element (the auto-transition hook in
        //     the panel handles per-element flips at edit time).
        //   - icon = CSS-var ref (only when element opts in via ELEMENT_ICON_SHADE).
        return {
            backgroundColor: `var(${(0, $Cc5Nl.HUB_COLOR_CSS_VARS)[bgShade]})`,
            textColor: (0, $d2gH4.readableTextColor)(options.palette[bgShade], '@atlassian/company-hub-common'),
            isAdvancedThemingEnabled: true,
            ...iconShade ? {
                iconColor: `var(${(0, $Cc5Nl.HUB_COLOR_CSS_VARS)[iconShade]}, ${options.palette[iconShade]})`
            } : {}
        };
    }
    return {
        backgroundColor: `var(${0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR}, ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"})`,
        textColor: `var(${0, $53RlD.HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${"var(--ds-text, #292A2E)"})`,
        isAdvancedThemingEnabled: false
    };
};

});
parcelRegister("5fSMT", function(module, exports) {
$parcel$export(module.exports, "ELEMENT_DEFAULTS", () => $7a12aaebf24f4914$export$6d3cb81378fd614a);
/**
 * Element-default contract — see §4.2 of the Advanced Theming v2 design.
 *
 * Maps an element-color-slot key to a palette token reference. Day 0 only
 * defines bespoke-extension *background* slots, all pointing at `primary.200`,
 * which gives every bespoke element a coherent themed default while the rest
 * of the override / picker UX is built out.
 */ const $7a12aaebf24f4914$export$6d3cb81378fd614a = {
    // Bespoke extensions — backgrounds (day 0).
    'callout.bg': 'primary.200',
    'cards.bg': 'primary.200',
    'carousel.bg': 'primary.200',
    'spotlight.bg': 'primary.200',
    'jsm-help.bg': 'primary.200',
    // JSM Help icon — bold brand tone for visibility against the light bg.
    'jsm-help.icon': 'primary.800',
    // Sections use a lighter accent tint to differentiate from bespoke extension cards.
    'section.bg': 'accent.100'
};

});


parcelRegister("axsoS", function(module, exports) {
$parcel$export(module.exports, "useIsAdvancedThemingEnabled", () => $dbb28d421f4cab05$export$13ab96420d94e773);
/**
 * Returns `true` when advanced theming v2 should be active for the current
 * hub render, `false` otherwise.
 *
 * Advanced theming is gated by **both** of:
 *
 *   1. The product-level flag, exposed via `useHubContext().featureFlags
 *      ['advanced-theming-in-hub']`. The product (e.g. help-center) sets this
 *      `true` only for surfaces it has opted in (today: JSM Help Hubs only).
 *   2. The platform-level Statsig gate `hub-advanced-theming`, owned by the
 *      hubs platform team to control rollout independently of the product.
 *
 * AND-gating both lets either side hold the rollout independently — the
 * product can still keep the feature off for itself even if the platform
 * gate flips on, and vice versa. Pure read of context + statsig — SSR-safe.
 *
 * Cross-host safety: this hook tolerates a missing `<HubContextProvider>` and
 * returns `false` in that case. Confluence Company Hub and similar surfaces
 * that don't mount `HubBootstrap` (and therefore don't mount `HubContext`)
 * cannot be in a theming-enabled tree by definition, so returning `false`
 * is both safe and correct.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $hJs5J = parcelRequire("hJs5J");
const $dbb28d421f4cab05$export$13ab96420d94e773 = ()=>{
    var _ctx$featureFlags;
    const ctx = (0, $bSJIT.useContext)((0, $hJs5J.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub). Theming
    // is help-center-only — return false without throwing.
    return false;
    const productFlag = ((_ctx$featureFlags = ctx.featureFlags) === null || _ctx$featureFlags === void 0 ? void 0 : _ctx$featureFlags['advanced-theming-in-hub']) === true;
    return productFlag && (0, $gdUUy.fg)('hub-advanced-theming');
};

});


parcelRegister("eJ5U1", function(module, exports) {
$parcel$export(module.exports, "NavigationStyleContext", () => $50a1a1f2ab81093a$export$2c6067e95d1be081);
$parcel$export(module.exports, "useNavigationStyle", () => $50a1a1f2ab81093a$export$ce205152a61c4e11);

var $bSJIT = parcelRequire("bSJIT");
const $50a1a1f2ab81093a$var$noop = ()=>{};
const $50a1a1f2ab81093a$export$2c6067e95d1be081 = (0, $bSJIT.createContext)({
    options: null,
    setOptions: $50a1a1f2ab81093a$var$noop
});
const $50a1a1f2ab81093a$export$ce205152a61c4e11 = ()=>(0, $bSJIT.useContext)($50a1a1f2ab81093a$export$2c6067e95d1be081);

});

parcelRegister("3YmaA", function(module, exports) {
$parcel$export(module.exports, "useIsHubCornerRadiusEnabled", () => $98836132df575526$export$186c72664a5e904e);
/**
 * Returns `true` when Hub corner radius customization should be active.
 *
 * Gated by TWO things ANDed together:
 *   1. The product-level flag `advanced-theming-in-hub` (via HubContext —
 *      checked transitively through `useIsAdvancedThemingEnabled`).
 *   2. The new platform-level Statsig gate `hub-corner-radius`.
 *
 * The first comes from `useIsAdvancedThemingEnabled` — corner radius
 * is a sub-feature of advanced theming and never ships without it.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */ 
var $gdUUy = parcelRequire("gdUUy");

var $axsoS = parcelRequire("axsoS");
const $98836132df575526$export$186c72664a5e904e = ()=>{
    const isAdvancedThemingEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    return isAdvancedThemingEnabled && (0, $gdUUy.fg)('hub-corner-radius');
};

});

parcelRegister("8dfFn", function(module, exports) {
$parcel$export(module.exports, "toSpaceDensity", () => $ef28225a9c191307$export$48c62bfd809136a6);

var $bBolO = parcelRequire("bBolO");
const $ef28225a9c191307$export$48c62bfd809136a6 = (value)=>value != null && (0, $bBolO.SPACE_DENSITIES).includes(value) ? value : undefined;

});

parcelRegister("fFUol", function(module, exports) {
$parcel$export(module.exports, "toFontKey", () => $8cfafdf60450ed43$export$3237e77afd58a8d5);

var $iyFm0 = parcelRequire("iyFm0");
/** The framework default — already loaded by the AK shell, no Google Fonts request. */ const $8cfafdf60450ed43$var$DEFAULT_FONT_KEY = 'atlassian-sans';
const $8cfafdf60450ed43$export$3237e77afd58a8d5 = (value)=>value != null && Object.prototype.hasOwnProperty.call((0, $iyFm0.FONT_REGISTRY), value) ? value : $8cfafdf60450ed43$var$DEFAULT_FONT_KEY;

});
parcelRegister("iyFm0", function(module, exports) {
$parcel$export(module.exports, "FONT_REGISTRY", () => $e2e115441d44d2d8$export$40b121c0fb5c472f);
const $e2e115441d44d2d8$export$40b121c0fb5c472f = {
    'atlassian-sans': {
        displayName: 'Atlassian Sans',
        family: '"Atlassian Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: null
    },
    'noto-sans': {
        displayName: 'Noto Sans',
        family: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: 'Noto+Sans:wght@400;500;700'
    },
    'ibm-plex-sans': {
        displayName: 'IBM Plex Sans',
        family: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: 'IBM+Plex+Sans:wght@400;500;700'
    },
    'work-sans': {
        displayName: 'Work Sans',
        family: '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: 'Work+Sans:wght@400;500;700'
    },
    'ibm-plex-serif': {
        displayName: 'IBM Plex Serif',
        family: '"IBM Plex Serif", Georgia, "Times New Roman", serif',
        category: 'serif',
        googleFontsFamily: 'IBM+Plex+Serif:wght@400;500;700'
    },
    merriweather: {
        displayName: 'Merriweather',
        family: '"Merriweather", Georgia, "Times New Roman", serif',
        category: 'serif',
        googleFontsFamily: 'Merriweather:wght@400;500;700'
    },
    lora: {
        displayName: 'Lora',
        family: '"Lora", Georgia, "Times New Roman", serif',
        category: 'serif',
        googleFontsFamily: 'Lora:wght@400;500;700'
    }
};

});


parcelRegister("eIwmz", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_NAVIGATION_OPTIONS", () => $4494de73b48238c9$export$cfca0f39600e333c);
$parcel$export(module.exports, "getDefaultNavigationOptions", () => $4494de73b48238c9$export$5046aed2fe45af56);
$parcel$export(module.exports, "mapApiToNavigationOptions", () => $4494de73b48238c9$export$b35e3817d72db278);

var $d2gH4 = parcelRequire("d2gH4");

var $Cc5Nl = parcelRequire("Cc5Nl");
const $4494de73b48238c9$var$readableTextColor = (color)=>(0, $d2gH4.readableTextColor)(color, '@atlassian/company-hub-common');
const $4494de73b48238c9$export$cfca0f39600e333c = {
    padding: true,
    fixedAtTop: false,
    backgroundColor: '#FFFFFF',
    textColor: '#172B4D',
    borderColor: '#DFE1E6',
    borderType: 'NO_BORDER',
    cornerRadius: 8
};
function $4494de73b48238c9$export$5046aed2fe45af56(brandColor, isAdvancedThemingEnabled) {
    if (isAdvancedThemingEnabled) return {
        ...$4494de73b48238c9$export$cfca0f39600e333c,
        backgroundColor: `var(${(0, $Cc5Nl.HUB_COLOR_CSS_VARS)['primary.1000']})`,
        textColor: "var(--ds-text-inverse, #FFFFFF)"
    };
    if (!brandColor) return $4494de73b48238c9$export$cfca0f39600e333c;
    return {
        ...$4494de73b48238c9$export$cfca0f39600e333c,
        backgroundColor: brandColor,
        textColor: $4494de73b48238c9$var$readableTextColor(brandColor)
    };
}
function $4494de73b48238c9$export$b35e3817d72db278(apiData, brandColor, isCornerRadiusEnabled, isAdvancedThemingEnabled) {
    const defaults = $4494de73b48238c9$export$5046aed2fe45af56(brandColor, isAdvancedThemingEnabled);
    if (!apiData) return defaults;
    return {
        padding: apiData.padding ?? defaults.padding,
        fixedAtTop: apiData.positionType === 'FIXED',
        backgroundColor: apiData.backgroundColor ?? defaults.backgroundColor,
        textColor: apiData.textColor ?? defaults.textColor,
        borderColor: apiData.borderColor ?? defaults.borderColor,
        borderType: apiData.borderType === 'BOTTOM_BORDER' ? 'BOTTOM_BORDER' : apiData.borderType === 'ALL_BORDER' ? 'ALL_BORDER' : 'NO_BORDER',
        // When the corner-radius feature is on, preserve a missing value as null so
        // the navbar inherits --hub-corner-radius. Otherwise keep the legacy 8 default.
        cornerRadius: isCornerRadiusEnabled ? apiData.cornerRadius ?? null : apiData.cornerRadius ?? defaults.cornerRadius
    };
}

});


parcelRegister("itx7D", function(module, exports) {
$parcel$export(module.exports, "HubErrorBoundary", () => $976c30d820c6f847$export$ba2f52e216142b3d);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $gdUUy = parcelRequire("gdUUy");

var $bx56v = parcelRequire("bx56v");

var $3pU6R = parcelRequire("3pU6R");

var $4XXwT = parcelRequire("4XXwT");

var $iFkpH = parcelRequire("iFkpH");
const $976c30d820c6f847$var$isFetchClientError = (err)=>{
    return (err === null || err === void 0 ? void 0 : err.status) < 500;
};
const $976c30d820c6f847$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError, operationNames: operationNames })=>{
    const logError = (0, $bx56v.useUFOReportError)();
    const observeError = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $iFkpH.HubErrorObserverContext));
    const onError = (error)=>{
        if ($976c30d820c6f847$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        if ((0, $gdUUy.fg)('help_center_hub_premium_sla_metrics')) observeError === null || observeError === void 0 || observeError({
            error: error,
            id: id,
            packageName: packageName,
            shouldForceError: shouldForceError
        });
        // react-ufo does not expose a dedicated traceId/attribute field, so the trace ID is
        // appended to the error message. fireErrorAnalytics additionally receives it as an attribute.
        let traceId;
        if (operationNames && (0, $gdUUy.fg)('hub_error_analytics_trace_id')) {
            const traceIds = operationNames.flatMap((name)=>(0, $4XXwT.getTraceIds)(name));
            traceId = traceIds.find(Boolean);
        }
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: traceId ? `${error.message} (traceId: ${traceId})` : error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $3pU6R.default)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                },
                attributes: traceId ? {
                    traceId: traceId
                } : undefined
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        onError: onError,
        fallback: fallback
    }, children);
};

});

parcelRegister("3m0bI", function(module, exports) {
$parcel$export(module.exports, "HubAppShell", () => $923fce7fda452271$export$647b3ff790ea59d4);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ /* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $dwOcU = parcelRequire("dwOcU");

var $bf1Bt = parcelRequire("bf1Bt");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $eJ5U1 = parcelRequire("eJ5U1");

var $fYY0h = parcelRequire("fYY0h");

var $9dcGt = parcelRequire("9dcGt");

var $9N492 = parcelRequire("9N492");

var $g7xik = parcelRequire("g7xik");

var $dsKYd = parcelRequire("dsKYd");

var $5CgBK = parcelRequire("5CgBK");

var $dez4z = parcelRequire("dez4z");

var $hJs5J = parcelRequire("hJs5J");

var $erx1J = parcelRequire("erx1J");

var $dcCJ5 = parcelRequire("dcCJ5");

var $6xeJZ = parcelRequire("6xeJZ");

var $4TV3w = parcelRequire("4TV3w");

var $aKW5H = parcelRequire("aKW5H");
const $923fce7fda452271$var$HELP_CENTER_PREVIEW_PATH_PREFIX = '/helpcenter/test/';
const $923fce7fda452271$var$HELP_CENTER_LIVE_PATH_PREFIX = '/helpcenter/';
const $923fce7fda452271$var$DEFAULT_HELP_CENTER_PORTALS_LIVE_PATH = '/servicedesk/customer/portals';
const $923fce7fda452271$var$MIGRATION_REVIEW_ACTION_BAR_ANALYTICS_SOURCE = 'helpCenterMigrationReviewActionBar';
// Existing global-link selectors require the unbounded Compiled API.
const $923fce7fda452271$var$containerStyles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    container: "_19itglyw _vchhusvi _r06hglyw _kqswh2mm _bfhkhp5a _1tke1osq _1e0c1txw _2lx21bp4 _1bzh1gj0 _5cd81gj0",
    childrenWrapper: "_n3tdoahv",
    childrenWrapperEditMode: "_16jlkb7n _1tkeidpf"
};
// Compiled supports the inherited custom background, which ADS bounded styles do not.
const $923fce7fda452271$var$navigationStyles = {
    scrollableContainer: "_1reo1wug _18m91wug",
    fixedNavContainer: "_kqsw1if8 _154iidpf _1pby1kze _bfhk1kw7 _ca0q1ejb _otyr1ejb"
};
const $923fce7fda452271$export$647b3ff790ea59d4 = ({ children: children, isEditMode: isEditMode = false, hideNavbar: hideNavbar = false })=>{
    const { cloudId: cloudId, cloudUrl: cloudUrl, env: env, layout: layout, containerStyling: containerStyling, headerless: headerless, hubName: hubName, migrationReview: migrationReview } = (0, $hJs5J.useHubContext)();
    const { options: navStyle } = (0, $eJ5U1.useNavigationStyle)();
    const isStickyNavFixEnabled = (0, $gdUUy.fg)('hubs_nav_fixed_top_sticky_fix');
    const isFixedAtTop = Boolean(navStyle === null || navStyle === void 0 ? void 0 : navStyle.fixedAtTop);
    const isHeaderless = headerless && (0, $gdUUy.fg)('csm-support-site-headerless-query-param');
    const shouldRenderShellNavigation = !isHeaderless && !hideNavbar;
    // When the sticky fix is enabled, the shell stops owning the scroll so the
    // fixed navbar can stick to the viewport. When padded, a sticky wrapper keeps
    // the top gap in place and covers scrolling content behind it.
    // Scoped to view mode — edit mode injects its own
    // navbar via `editor-plugin-hub-shell` and relies on the shell keeping its
    // own scroll container for the editor height chain.
    const shouldUseViewportStickyNav = isStickyNavFixEnabled && isFixedAtTop && !isEditMode && shouldRenderShellNavigation;
    const shouldWrapPaddedFixedNav = shouldUseViewportStickyNav && Boolean(navStyle === null || navStyle === void 0 ? void 0 : navStyle.padding);
    // Whenever the shell still owns scrolling, a fixed navbar relies on the shell
    // being full height. Tied to `shouldUseViewportStickyNav` rather than the gate
    // so edit mode keeps its height chain once the gate is enabled.
    const fixedNavFullHeightStyling = !shouldUseViewportStickyNav && isFixedAtTop ? {
        height: '100%'
    } : {};
    const showBanner = layout === null || layout === void 0 ? void 0 : layout.showBanner;
    const isHelpHubMigrationEnabled = (0, $gdUUy.fg)('enable-help-hub-migration');
    const shouldApplyContainerStyling = (0, $gdUUy.fg)('enable-jsm-in-hubs');
    const [isBreadcrumbsEnabled] = (0, $dez4z.useIsHubFeatureEnabled)([
        (0, $dez4z.HUB_FEATURES).BREADCRUMBS
    ]);
    // Edit mode injects the navbar and breadcrumbs into the editor content area so they
    // resize with the ProseMirror canvas and stay below the editor toolbar.
    const shouldRenderShellBreadcrumbs = !isHeaderless && !isEditMode;
    const publishedHelpCenterPath = env.relativeBaseUrl.startsWith($923fce7fda452271$var$HELP_CENTER_PREVIEW_PATH_PREFIX) ? env.relativeBaseUrl.replace($923fce7fda452271$var$HELP_CENTER_PREVIEW_PATH_PREFIX, $923fce7fda452271$var$HELP_CENTER_LIVE_PATH_PREFIX) : // Matches the default Help Center with or without the `/portals` segment,
    // since the backend reports its base path without one.
    (0, $erx1J.isDefaultHelpCenterBasePath)(env.relativeBaseUrl) ? $923fce7fda452271$var$DEFAULT_HELP_CENTER_PORTALS_LIVE_PATH : env.relativeBaseUrl;
    const publishedHelpCenterUrl = new URL(publishedHelpCenterPath, cloudUrl).toString();
    // Default hardcoded styles (used when feature flag is disabled for backward compatibility)
    const defaultContainerStyling = {
        borderRadius: "var(--ds-radius-large, 8px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    };
    // Apply containerStyling from props if feature flag is enabled, otherwise use hardcoded defaults
    const appliedContainerStyling = shouldApplyContainerStyling ? containerStyling : defaultContainerStyling;
    // Built outside the JSX so the `enforce-style-prop` suppression covers the whole
    // object: these values are dynamic (theming props plus gated layout) and cannot
    // move into `cssMap`.
    const containerInlineStyles = {
        ...appliedContainerStyling,
        ...fixedNavFullHeightStyling
    };
    const hubContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    (0, $9dcGt.useUnsetGlobalTheme)(isEditMode ? hubContainerRef.current : null); // for view mode we don't need to unset the global theme
    // useHubTheming returns undefined outside <HubThemingProvider>, but
    // HubAppShell is always mounted inside HubBootstrap → provider is in tree.
    const { primaryColor: primaryColor, isAdvancedThemingEnabled: isAdvancedThemingEnabled } = (0, $dsKYd.useHubTheming)();
    // Legacy theming path: when the v2 gate is OFF we restore the pre-v2
    // behaviour by writing the `--hub-primary-*` CSS vars into the document so
    // existing ADFs (which encode `var(--hub-primary-color, ...)` strings) and
    // chrome that consumes the same vars continue to look correct. When the
    // gate is ON the palette + adapter outputs from `useHubTheming()` drive
    // every consumer directly, so this effect is a no-op.
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (isAdvancedThemingEnabled) return undefined;
        return (0, $fYY0h.setHubBrandingStyle)({
            primaryColor: primaryColor
        });
    }, [
        isAdvancedThemingEnabled,
        primaryColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g7xik.HubBreadcrumbsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5CgBK.HubTypographyScope), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf1Bt.FlagsProvider), null, isHelpHubMigrationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6xeJZ.MigrationPublishSuccessFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: (0, $14TCm.cx)($923fce7fda452271$var$containerStyles.container, !shouldUseViewportStickyNav && $923fce7fda452271$var$navigationStyles.scrollableContainer),
        testId: "hub-app-shell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic styles passed from outside via containerStyling prop
        style: containerInlineStyles,
        ref: hubContainerRef
    }, !isEditMode && migrationReview && isHelpHubMigrationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            source: $923fce7fda452271$var$MIGRATION_REVIEW_ACTION_BAR_ANALYTICS_SOURCE
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TV3w.MigrationReviewActionBar), {
        cloudId: cloudId,
        helpCenterAri: env.helpCenterAri,
        helpCenterName: hubName,
        migrationReview: migrationReview,
        publishedHelpCenterUrl: publishedHelpCenterUrl
    })), shouldRenderShellNavigation && (shouldWrapPaddedFixedNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "hub-sticky-navbar",
        className: (0, $9fU1q.default)([
            $923fce7fda452271$var$navigationStyles.fixedNavContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aKW5H.Navbar), {
        isEditMode: isEditMode,
        isViewportSticky: shouldUseViewportStickyNav
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aKW5H.Navbar), {
        isEditMode: isEditMode,
        isViewportSticky: shouldUseViewportStickyNav
    })), isBreadcrumbsEnabled && shouldRenderShellBreadcrumbs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9N492.HubBreadcrumbs), null), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $923fce7fda452271$var$containerStyles.bannerContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dcCJ5.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: isEditMode ? $923fce7fda452271$var$containerStyles.childrenWrapperEditMode : $923fce7fda452271$var$containerStyles.childrenWrapper,
        testId: "hub-app-shell-children-wrapper"
    }, children)))));
};

});
parcelRegister("fYY0h", function(module, exports) {
$parcel$export(module.exports, "setHubBrandingStyle", () => $ed4336d78b18cd7b$export$202bcc6267a600cb);

var $7hQVc = parcelRequire("7hQVc");

var $d2gH4 = parcelRequire("d2gH4");

var $lkNTb = parcelRequire("lkNTb");

var $3pU6R = parcelRequire("3pU6R");

var $53RlD = parcelRequire("53RlD");
const $ed4336d78b18cd7b$var$readableTextColor = (color)=>{
    return (0, $d2gH4.readableTextColor)(color, '@atlassian/company-hub-common');
};
const $ed4336d78b18cd7b$export$202bcc6267a600cb = ({ primaryColor: primaryColor, targetElement: targetElement })=>{
    const primaryColorToUse = primaryColor || (0, $53RlD.DEFAULT_BRANDING_COLOR);
    const finalTargetElement = targetElement || document.documentElement;
    try {
        // Convert to HEX for functions that require it (getLuminance, generateThemeBranding)
        const hexPrimaryColor = (0, $7hQVc.toHexColor)(primaryColorToUse);
        const primaryTextColor = $ed4336d78b18cd7b$var$readableTextColor(hexPrimaryColor);
        // Keep original format for CSS custom property (works with any valid CSS color)
        finalTargetElement.style.setProperty((0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR), primaryColorToUse);
        finalTargetElement.style.setProperty((0, $53RlD.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), primaryTextColor);
        // generateThemeBranding expects HEX colors
        const themeColours = (0, $lkNTb.generateThemeBranding)(hexPrimaryColor);
        finalTargetElement.style.setProperty((0, $53RlD.HUB_PRIMARY_LINK_COLOR_CSS_VAR), themeColours.color900);
    } catch (error) {
        (0, $3pU6R.default)({
            error: error instanceof Error ? error : new Error(`Hub branding style processing failed for color: ${primaryColorToUse}`),
            meta: {
                id: 'setHubBrandingStyle',
                packageName: '@atlassian/company-hub-common'
            }
        });
        // Fallback to default branding if color processing fails
        finalTargetElement.style.setProperty((0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR), (0, $53RlD.DEFAULT_BRANDING_COLOR));
        finalTargetElement.style.setProperty((0, $53RlD.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), "var(--ds-text, #292A2E)");
    }
    return ()=>{
        finalTargetElement.style.removeProperty((0, $53RlD.HUB_PRIMARY_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $53RlD.HUB_PRIMARY_TEXT_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $53RlD.HUB_PRIMARY_LINK_COLOR_CSS_VAR));
    };
};

});

parcelRegister("9dcGt", function(module, exports) {
$parcel$export(module.exports, "useUnsetGlobalTheme", () => $048159650fa3eced$export$8726d385cd3f733);

var $bSJIT = parcelRequire("bSJIT");

var $cciuV = parcelRequire("cciuV");

var $ceb9s = parcelRequire("ceb9s");
const $048159650fa3eced$export$8726d385cd3f733 = (targetElement, idsToUnset = [
    'light',
    'dark',
    'spacing'
])=>{
    const { colorMode: colorMode, dark: dark, light: light, spacing: spacing, typography: typography, UNSAFE_themeOptions: UNSAFE_themeOptions } = (0, $ceb9s.useThemeObserver)();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (targetElement) (0, $cciuV.getThemeStyles)().then((themeStyles)=>{
            themeStyles.forEach((themeStyle)=>{
                if (idsToUnset.includes(themeStyle.id)) {
                    const allCssVariables = themeStyle.css.match(/--[\w-]+/g); // output => ['--ds-text', '--ds-text-accent-lime']
                    allCssVariables === null || allCssVariables === void 0 || allCssVariables.forEach((cssVariable)=>{
                        targetElement.style.setProperty(cssVariable, 'initial');
                    });
                }
            });
        });
    }, [
        targetElement,
        idsToUnset,
        colorMode,
        dark,
        light,
        spacing,
        typography,
        UNSAFE_themeOptions
    ]);
};

});
parcelRegister("cciuV", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $7c29beb0b5b8da63$export$a3fc04b8551e006a);

var $gdUUy = parcelRequire("gdUUy");

var $bu8ak = parcelRequire("bu8ak");

var $1znDm = parcelRequire("1znDm");

var $aLj6d = parcelRequire("aLj6d");

var $FnfSF = parcelRequire("FnfSF");

var $3jq1w = parcelRequire("3jq1w");

var $4vmFm = parcelRequire("4vmFm");

const $7c29beb0b5b8da63$export$a3fc04b8551e006a = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $bu8ak.themeIdsWithOverrides);
        if (!(0, $gdUUy.fg)('platform-dst-tokens-finesse')) themePreferences = themePreferences.filter((themeId)=>!(0, $bu8ak.themeOverrideIds).includes(themeId));
        // CLEANUP: Remove
        if (!(0, $gdUUy.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast' && n !== 'light-increased-contrast-finesse' && n !== 'dark-increased-contrast-finesse');
    } else {
        const themeState = {
            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $1znDm.themeStateDefaults)['colorMode'],
            contrastMode: (preferences === null || preferences === void 0 ? void 0 : preferences.contrastMode) || (0, $1znDm.themeStateDefaults)['contrastMode'],
            dark: (preferences === null || preferences === void 0 ? void 0 : preferences.dark) || (0, $1znDm.themeStateDefaults)['dark'],
            light: (preferences === null || preferences === void 0 ? void 0 : preferences.light) || (0, $1znDm.themeStateDefaults)['light'],
            motion: (preferences === null || preferences === void 0 ? void 0 : preferences.motion) || (0, $1znDm.themeStateDefaults)['motion'](),
            shape: (preferences === null || preferences === void 0 ? void 0 : preferences.shape) || (0, $1znDm.themeStateDefaults)['shape'],
            spacing: (preferences === null || preferences === void 0 ? void 0 : preferences.spacing) || (0, $1znDm.themeStateDefaults)['spacing'],
            typography: (preferences === null || preferences === void 0 ? void 0 : preferences.typography) || (0, $1znDm.themeStateDefaults)['typography']
        };
        themePreferences = (0, $FnfSF.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $aLj6d.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $4vmFm.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async (_preferences$UNSAFE_t)=>{
            if (preferences !== 'all' && preferences !== null && preferences !== void 0 && preferences.UNSAFE_themeOptions && (0, $3jq1w.isValidBrandHex)(preferences === null || preferences === void 0 || (_preferences$UNSAFE_t = preferences.UNSAFE_themeOptions) === null || _preferences$UNSAFE_t === void 0 ? void 0 : _preferences$UNSAFE_t.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("2aJW4"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $1znDm.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences === null || preferences === void 0 ? void 0 : preferences.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
            return undefined;
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $7c29beb0b5b8da63$export$2e2bcd8739ae039 = $7c29beb0b5b8da63$export$a3fc04b8551e006a;

});
parcelRegister("2aJW4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6VmOh").then(()=>parcelRequire('9RzYS'));

});



parcelRegister("9N492", function(module, exports) {
$parcel$export(module.exports, "HubBreadcrumbsSkeleton", () => $332315bed5346338$export$e610d88d5224ae75);
$parcel$export(module.exports, "HubBreadcrumbs", () => $332315bed5346338$export$cc8c957f0e477af0);
/* hub-breadcrumbs.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $dwOcU = parcelRequire("dwOcU");

var $5faG6 = parcelRequire("5faG6");

var $h7ygI = parcelRequire("h7ygI");

var $0iycE = parcelRequire("0iycE");

var $kPOyu = parcelRequire("kPOyu");

var $ifRWC = parcelRequire("ifRWC");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $dez4z = parcelRequire("dez4z");

var $hJs5J = parcelRequire("hJs5J");

var $tJ2hU = parcelRequire("tJ2hU");

var $g7xik = parcelRequire("g7xik");

var $3TZIE = parcelRequire("3TZIE");
const $332315bed5346338$var$styles = {
    container: "_vchhusvi _1ul9idpf _n3td1ejb _19bv1ejb _u5f31ejb _1bsb1osq",
    item: "_11c8fhey _1e0c1txw _vchhusvi _1ul9idpf _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _19pkidpf",
    separator: "_1rjcv77o _18zru2gc _1bsbftgi _1o9zidpf _y3gn1h6o",
    itemText: "_1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
};
const $332315bed5346338$var$StaticHubParentBreadcrumb = ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $332315bed5346338$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        className: (0, $9fU1q.default)([
            $332315bed5346338$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        color: 'color.text.subtlest',
        maxLines: 1
    }, item.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "aria-hidden": true,
        className: (0, $9fU1q.default)([
            $332315bed5346338$var$styles.separator
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        color: "color.text.subtlest"
    }, "/")));
};
const $332315bed5346338$var$StaticHubCurrentBreadcrumb = ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $332315bed5346338$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "aria-current": "page",
        className: (0, $9fU1q.default)([
            $332315bed5346338$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        maxLines: 1
    }, item.text)));
};
const $332315bed5346338$export$e610d88d5224ae75 = ({ itemCount: itemCount })=>{
    const [isBreadcrumbsEnabled] = (0, $dez4z.useIsHubFeatureEnabled)([
        (0, $dez4z.HUB_FEATURES).BREADCRUMBS
    ]);
    if (!isBreadcrumbsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $332315bed5346338$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kPOyu.default), null, Array.from({
        length: itemCount
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ifRWC.default), {
            width: 60,
            key: index
        }))));
};
const $332315bed5346338$export$cc8c957f0e477af0 = ()=>{
    const intl = (0, $4vLTk.default)();
    const items = (0, $g7xik.useHubBreadcrumbItems)();
    const currentItem = items[items.length - 1];
    const { env: { relativeBaseUrl: relativeBaseUrl } } = (0, $hJs5J.useHubContext)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    if (!currentItem) return null;
    const label = intl.formatMessage((0, $3TZIE.messages).label);
    const ellipsisLabel = intl.formatMessage((0, $3TZIE.messages).showMore);
    const onBreadcrumbItemClick = (href)=>(event)=>{
            const isPrimaryClick = 'button' in event && event.button === 0;
            const isEnterKey = 'key' in event && event.key === 'Enter';
            if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                // The anchor needs the Hub base path, but browser history adds it on navigation.
                event.preventDefault();
                push(href);
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "hub-breadcrumbs-container",
        className: (0, $9fU1q.default)([
            $332315bed5346338$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5faG6.default), {
        ellipsisLabel: ellipsisLabel,
        label: label,
        size: "medium",
        testId: "hub-breadcrumbs"
    }, items.slice(0, -1).map((item, index)=>item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: {
                attributes: {
                    itemType: item.id,
                    position: index + 1
                }
            },
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $0iycE.default), {
            href: (0, $tJ2hU.getHubBreadcrumbHref)(relativeBaseUrl, item.href),
            onClick: onBreadcrumbItemClick(item.href),
            text: item.text
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($332315bed5346338$var$StaticHubParentBreadcrumb, {
            item: item,
            key: item.id
        })), currentItem.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                itemType: currentItem.id,
                position: items.length
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $h7ygI.default), {
        href: (0, $tJ2hU.getHubBreadcrumbHref)(relativeBaseUrl, currentItem.href),
        text: currentItem.text
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($332315bed5346338$var$StaticHubCurrentBreadcrumb, {
        item: currentItem
    })));
};

});
parcelRegister("0iycE", function(module, exports) {
$parcel$export(module.exports, "default", () => $300c376616dad20d$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");

var $lavtv = parcelRequire("lavtv");

var $fQVwH = parcelRequire("fQVwH");

var $e0Jgi = parcelRequire("e0Jgi");

var $bbAfN = parcelRequire("bbAfN");

var $7Lpt5 = parcelRequire("7Lpt5");

var $25dSh = parcelRequire("25dSh");
const $300c376616dad20d$var$itemWrapperStyles = null;
const $300c376616dad20d$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $300c376616dad20d$var$ICON_WIDTH_ESTIMATE = 24;
const $300c376616dad20d$var$staticItemStyles = null;
const $300c376616dad20d$var$staticItemWithTruncationStyles = null;
const $300c376616dad20d$var$staticItemWithoutTruncationStyles = null;
const $300c376616dad20d$var$motionItemStyles = null;
const $300c376616dad20d$var$BreadcrumbsItem = /*#__PURE__*/ (0, $bSJIT.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $bSJIT.useState)(null);
    const setStepRef = (0, $bSJIT.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $7Lpt5.useBreadcrumbsSize)();
    const leadingIconWidth = resolvedElemBefore ? $300c376616dad20d$var$ICON_WIDTH_ESTIMATE + (breadcrumbsSize === 'small' ? 0 : 2) : 0;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $300c376616dad20d$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $300c376616dad20d$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $25dSh.default)(truncationWidth, stepElement, // The refresh control now includes the leading icon; exclude it from the truncation check.
    (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') ? -leadingIconWidth : iconWidthAllowance);
    if (!component && (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fQVwH.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // TODO(CAT-2913): Remove `iconAfter` from the refresh path once Jira stops depending on deprecated
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$300c376616dad20d$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $e0Jgi.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $bbAfN.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $9fU1q.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v",
            "_v564hxmd _4bfu1j28 _1hms8stv _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("li", {
        ref: _overflowRef,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _4cvr1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$300c376616dad20d$export$2e2bcd8739ae039 = $300c376616dad20d$var$BreadcrumbsItem;

});
parcelRegister("fQVwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $edb73797b9aed473$export$2e2bcd8739ae039);
/* breadcrumbs-item-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* breadcrumbs-item-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fGbV9 = parcelRequire("fGbV9");

var $lavtv = parcelRequire("lavtv");

var $e0Jgi = parcelRequire("e0Jgi");
const $edb73797b9aed473$var$itemWrapperStyles = null;
const $edb73797b9aed473$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $e0Jgi.default), {
            ref: tooltipRef ? (0, $fGbV9.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth,
            children: text
        });
    };
    const step = renderStep();
    return /*#__PURE__*/ (0, $dc70d.jsx)("li", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required for public xcss passthrough
        className: (0, $9fU1q.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _2lx2vrvc _1wpz1h6o _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1q9y _14rn1rpy _aetr1n76 _8yoa1h6o",
            xcss
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$edb73797b9aed473$export$2e2bcd8739ae039 = $edb73797b9aed473$var$BreadcrumbsItemBase;

});
parcelRegister("e0Jgi", function(module, exports) {
$parcel$export(module.exports, "default", () => $25dad22aae1175c4$export$2e2bcd8739ae039);
/* step.tsx generated by @compiled/babel-plugin v3.0.2 */ /* step.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIUP1 = parcelRequire("kIUP1");

var $jDsoo = parcelRequire("jDsoo");

var $1OdZP = parcelRequire("1OdZP");

var $gdUUy = parcelRequire("gdUUy");

var $bLXMw = parcelRequire("bLXMw");

var $gXqq0 = parcelRequire("gXqq0");

var $7Lpt5 = parcelRequire("7Lpt5");
const $25dad22aae1175c4$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: undefined,
    packageVersion: undefined
};
const $25dad22aae1175c4$var$noop = (0, $1OdZP.default);
const $25dad22aae1175c4$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rkolb4i _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    rootRefresh: "_zulpze3t _vchhusvi _4t3i1k8s",
    interactiveMotion: "_v564hxmd _1hms8stv _4bfu1j28 _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    withTruncation: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperSpacing: "_12l2v77o",
    iconWrapperSmallSpacing: "_12l2ze3t",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textWithIconAfter: "_12l21b66",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $25dad22aae1175c4$var$unboundedStyles = {
    iconWrapperRefresh: "_1bsb1ejb _4t3i1ejb",
    iconWrapperSmall: "_w8l57vkz _17527vkz",
    iconWrapperSmallRefresh: "_w8l5pxbi _1752pxbi",
    iconWrapper: "_syaz1cv2"
};
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $25dad22aae1175c4$var$Step = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $25dad22aae1175c4$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $7Lpt5.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    // Preserve the text/trailing-icon width budget now that the leading icon is inside the control.
    const leadingIconWidth = resolvedElemBefore ? `${"var(--ds-space-300, 24px)"} + ${isSmall ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)"}` : '0px';
    const maxWidth = (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && truncationWidth != null ? `calc(${truncationWidth}px + ${leadingIconWidth})` : truncationWidth;
    const handleClick = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$25dad22aae1175c4$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        var _triggerProps$onClick;
        triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
        handleClick(event);
    };
    const controlRef = (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $9fU1q.default)([
            $25dad22aae1175c4$var$styles.iconWrapper,
            (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$unboundedStyles.iconWrapperRefresh,
            $25dad22aae1175c4$var$unboundedStyles.iconWrapper,
            (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$styles.iconWrapperSpacing,
            isSmall && $25dad22aae1175c4$var$styles.iconWrapperSmallSpacing,
            !(0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $25dad22aae1175c4$var$unboundedStyles.iconWrapperSmall,
            (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $25dad22aae1175c4$var$unboundedStyles.iconWrapperSmallRefresh
        ]),
        children: resolvedElemBefore
    });
    const content = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            !(0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore,
            ((0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') || isSmall) && iconElement,
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                ref: textRef,
                className: (0, $9fU1q.default)([
                    $25dad22aae1175c4$var$styles.text,
                    (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && Boolean(iconAfter) && $25dad22aae1175c4$var$styles.textWithIconAfter,
                    truncationWidth != null && (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$styles.textWithTruncation
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bLXMw.Anchor), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        href: href,
        onClick: handleTriggerClick,
        onMouseOver: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver) ?? onMouseOver,
        onMouseOut: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut) ?? onMouseOut,
        onMouseMove: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove) ?? onMouseMove,
        onMouseDown: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown) ?? onMouseDown,
        onFocus: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus) ?? onFocus,
        onBlur: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur) ?? onBlur,
        "aria-describedby": (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby']) ?? ariaDescribedBy,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: testId,
        title: title,
        xcss: (0, $jDsoo.cx)($25dad22aae1175c4$var$styles.root, isSmall && $25dad22aae1175c4$var$styles.rootSmall, (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$styles.rootRefresh, truncationWidth != null && (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$styles.withTruncation, truncationWidth == null && $25dad22aae1175c4$var$styles.withoutTruncation, $25dad22aae1175c4$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: handleTriggerClick,
        onMouseOver: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver) ?? onMouseOver,
        onMouseOut: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut) ?? onMouseOut,
        onMouseMove: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove) ?? onMouseMove,
        onMouseDown: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown) ?? onMouseDown,
        onFocus: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus) ?? onFocus,
        onBlur: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur) ?? onBlur,
        "aria-describedby": (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby']) ?? ariaDescribedBy,
        testId: testId,
        title: title,
        xcss: (0, $jDsoo.cx)($25dad22aae1175c4$var$styles.root, isSmall && $25dad22aae1175c4$var$styles.rootSmall, (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$styles.rootRefresh, truncationWidth != null && (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') && $25dad22aae1175c4$var$styles.withTruncation, truncationWidth == null && $25dad22aae1175c4$var$styles.withoutTruncation, $25dad22aae1175c4$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
});
var $25dad22aae1175c4$export$2e2bcd8739ae039 = $25dad22aae1175c4$var$Step;

});


parcelRegister("bbAfN", function(module, exports) {
$parcel$export(module.exports, "default", () => $804f7340487c25dd$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $hzFIQ = parcelRequire("hzFIQ");

var $1OdZP = parcelRequire("1OdZP");

var $gdUUy = parcelRequire("gdUUy");
const $804f7340487c25dd$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: undefined,
    packageVersion: undefined
};
const $804f7340487c25dd$var$noop = (0, $1OdZP.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $804f7340487c25dd$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $804f7340487c25dd$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$804f7340487c25dd$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $gdUUy.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hzFIQ.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $804f7340487c25dd$export$2e2bcd8739ae039 = $804f7340487c25dd$var$StepOld;

});


parcelRegister("kPOyu", function(module, exports) {
$parcel$export(module.exports, "default", () => $27ab8e28fcc16d1b$export$2e2bcd8739ae039);
/* breadcrumbs-skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $ifRWC = parcelRequire("ifRWC");

var $b6rlv = parcelRequire("b6rlv");
const $27ab8e28fcc16d1b$var$styles = {
    nav: "_p12f1osq",
    list: "_1e0c1txw _4cvr1h6o _1n261g80 _2mzuglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
};
const $27ab8e28fcc16d1b$var$defaultItems = [
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $ifRWC.default), {
        width: 64
    }, "home"),
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $ifRWC.default), {
        width: 96
    }, "parent"),
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $ifRWC.default), {
        width: 80
    }, "current")
];
function $27ab8e28fcc16d1b$export$2e2bcd8739ae039({ children: children, isShimmering: isShimmering = true, label: label = 'Loading breadcrumbs', size: size = 'medium', testId: testId }) {
    const renderedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.count(children) > 0 ? children : $27ab8e28fcc16d1b$var$defaultItems;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $b6rlv.BreadcrumbsSkeletonContext).Provider, {
        value: {
            isShimmering: isShimmering,
            size: size
        },
        children: /*#__PURE__*/ (0, $dc70d.jsx)("nav", {
            "aria-busy": "true",
            "aria-label": label,
            className: (0, $9fU1q.default)([
                $27ab8e28fcc16d1b$var$styles.nav
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)("ol", {
                "aria-hidden": "true",
                "data-testid": testId,
                className: (0, $9fU1q.default)([
                    $27ab8e28fcc16d1b$var$styles.list
                ]),
                children: renderedChildren
            })
        })
    });
}

});
parcelRegister("ifRWC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8883c953e98e4f59$export$2e2bcd8739ae039);
/* breadcrumbs-skeleton-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");

var $cJsII = parcelRequire("cJsII");

var $bsRRK = parcelRequire("bsRRK");
const $8883c953e98e4f59$var$styles = {
    item: "_1e0c1txw _4cvr1h6o _vchhusvi _4t3i1k8s _p12f1osq",
    iconWrapper: "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _12l2v77o"
};
const $8883c953e98e4f59$var$unboundedStyles = {
    item: "_1758v77o _z9kiu2gc _f42wftgi _rfr7idpf _nqnu1rpy _8bo21n76 _n2r11h6o"
};
function $8883c953e98e4f59$export$2e2bcd8739ae039({ hasIcon: hasIcon, width: width }) {
    const { isShimmering: isShimmering, size: size } = (0, $bsRRK.useBreadcrumbsSkeleton)();
    return /*#__PURE__*/ (0, $dc70d.jsxs)("li", {
        className: (0, $9fU1q.default)([
            $8883c953e98e4f59$var$styles.item,
            $8883c953e98e4f59$var$unboundedStyles.item
        ]),
        children: [
            hasIcon ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                className: (0, $9fU1q.default)([
                    $8883c953e98e4f59$var$styles.iconWrapper
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJsII.default), {
                    height: 16,
                    isShimmering: isShimmering,
                    width: 16
                })
            }) : null,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJsII.default), {
                height: size === 'small' ? 12 : 14,
                isShimmering: isShimmering,
                width: width
            })
        ]
    });
}

});
parcelRegister("cJsII", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5ae4fadb7d83c616$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $cyIUy = parcelRequire("cyIUy");

var $gdUUy = parcelRequire("gdUUy");
const $5ae4fadb7d83c616$var$shimmerKeyframes = null;
const $5ae4fadb7d83c616$var$skeletonStyles = null;
const $5ae4fadb7d83c616$var$activeShimmerStyles = null;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $5ae4fadb7d83c616$var$useLayoutEffect = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $5ae4fadb7d83c616$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $bSJIT.useContext)((0, $cyIUy.default));
    $5ae4fadb7d83c616$var$useLayoutEffect(()=>{
        if (context != null && (0, $gdUUy.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $9fU1q.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
            isShimmering && "",
            isShimmering && "_j7hq19vq"
        ])
    });
};
var $5ae4fadb7d83c616$export$2e2bcd8739ae039 = $5ae4fadb7d83c616$var$Skeleton;

});

parcelRegister("bsRRK", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbsSkeleton", () => $f2667f1b85b4fd93$export$15d0b942535a287);

var $bSJIT = parcelRequire("bSJIT");

var $b6rlv = parcelRequire("b6rlv");
function $f2667f1b85b4fd93$export$15d0b942535a287() {
    return (0, $bSJIT.useContext)((0, $b6rlv.BreadcrumbsSkeletonContext));
}

});
parcelRegister("b6rlv", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbsSkeletonContext", () => $3dc497174610278c$export$ea207007e4cd246c);

var $bSJIT = parcelRequire("bSJIT");
const $3dc497174610278c$export$ea207007e4cd246c = /*#__PURE__*/ (0, $bSJIT.createContext)({
    isShimmering: true,
    size: 'medium'
});

});




parcelRegister("dez4z", function(module, exports) {
$parcel$export(module.exports, "HUB_FEATURES", () => $3978863a2ab5e9b4$export$49ecbc2ec404bcce);
$parcel$export(module.exports, "useIsHubFeatureEnabled", () => $3978863a2ab5e9b4$export$5a7b13b33b3b4bc8);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $hJs5J = parcelRequire("hJs5J");
var $3978863a2ab5e9b4$export$49ecbc2ec404bcce = /*#__PURE__*/ function(HUB_FEATURES) {
    HUB_FEATURES["BREADCRUMBS"] = "BREADCRUMBS";
    HUB_FEATURES["CONFIGURABLE_SITE_TREE"] = "CONFIGURABLE_SITE_TREE";
    HUB_FEATURES["DRAFT_MODE"] = "DRAFT_MODE";
    return HUB_FEATURES;
}({});
const $3978863a2ab5e9b4$var$HUB_FEATURE_CONFIG = {
    ["BREADCRUMBS"]: {
        contextKey: 'enable_hub_breadcrumbs',
        isPlatformEnabled: ()=>(0, $gdUUy.fg)('enable_hub_breadcrumbs')
    },
    ["CONFIGURABLE_SITE_TREE"]: {
        contextKey: 'help_hubs_configurable_site_tree',
        isPlatformEnabled: ()=>(0, $gdUUy.fg)('help_hubs_configurable_site_tree')
    },
    ["DRAFT_MODE"]: {
        contextKey: 'help_hubs_draft_mode',
        isPlatformEnabled: ()=>(0, $gdUUy.fg)('help_hubs_draft_mode')
    }
};
function $3978863a2ab5e9b4$export$5a7b13b33b3b4bc8(features) {
    const ctx = (0, $bSJIT.useContext)((0, $hJs5J.HubContext));
    const next = features.map((feature)=>{
        var _ctx$featureFlags;
        const { contextKey: contextKey, isPlatformEnabled: isPlatformEnabled } = $3978863a2ab5e9b4$var$HUB_FEATURE_CONFIG[feature];
        const isContextEnabled = (ctx === null || ctx === void 0 || (_ctx$featureFlags = ctx.featureFlags) === null || _ctx$featureFlags === void 0 ? void 0 : _ctx$featureFlags[contextKey]) === true;
        return isContextEnabled && isPlatformEnabled();
    });
    // Reuse the previous array when values match so deps on the return value
    // do not re-fire every render.
    const cachedRef = (0, $bSJIT.useRef)(next);
    const cached = cachedRef.current;
    if (cached.length !== next.length || next.some((value, index)=>value !== cached[index])) cachedRef.current = next;
    return cachedRef.current;
}

});

parcelRegister("tJ2hU", function(module, exports) {
$parcel$export(module.exports, "getHubBreadcrumbHref", () => $638484d7cee2b890$export$657a9453714bdcb9);
const $638484d7cee2b890$export$657a9453714bdcb9 = (relativeBaseUrl, routePath)=>{
    const basePath = relativeBaseUrl.replace(/\/+$/, '');
    if (/^https?:\/\//.test(routePath)) return routePath;
    if (basePath && (routePath === basePath || routePath.startsWith(`${basePath}/`))) return routePath;
    const path = routePath === '/' ? '' : `/${routePath.replace(/^\/+/, '')}`;
    return `${basePath}${path}` || '/';
};

});

parcelRegister("g7xik", function(module, exports) {
$parcel$export(module.exports, "HubBreadcrumbsProvider", () => $a724295c7bf4e051$export$cf2b9e6505681ebf);
$parcel$export(module.exports, "useRegisterHubBreadcrumbs", () => $a724295c7bf4e051$export$695acbe2b31cd25f);
$parcel$export(module.exports, "useHubBreadcrumbItems", () => $a724295c7bf4e051$export$e623729f7cd92c6b);

var $bSJIT = parcelRequire("bSJIT");
const $a724295c7bf4e051$var$HubBreadcrumbsContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $a724295c7bf4e051$var$areBreadcrumbsEqual = (currentItems, nextItems)=>currentItems.length === nextItems.length && currentItems.every((item, index)=>{
        const nextItem = nextItems[index];
        return nextItem !== undefined && item.href === nextItem.href && item.id === nextItem.id && item.text === nextItem.text;
    });
const $a724295c7bf4e051$export$cf2b9e6505681ebf = ({ children: children })=>{
    const [items, setItems] = (0, $bSJIT.useState)([]);
    const setBreadcrumbs = (0, $bSJIT.useCallback)((nextItems)=>{
        setItems((currentItems)=>$a724295c7bf4e051$var$areBreadcrumbsEqual(currentItems, nextItems) ? currentItems : nextItems);
    }, []);
    const clearBreadcrumbs = (0, $bSJIT.useCallback)(()=>setItems([]), []);
    const value = (0, $bSJIT.useMemo)(()=>({
            clearBreadcrumbs: clearBreadcrumbs,
            items: items,
            setBreadcrumbs: setBreadcrumbs
        }), [
        clearBreadcrumbs,
        items,
        setBreadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a724295c7bf4e051$var$HubBreadcrumbsContext.Provider, {
        value: value
    }, children);
};
const $a724295c7bf4e051$var$useHubBreadcrumbsContext = ()=>{
    const context = (0, $bSJIT.useContext)($a724295c7bf4e051$var$HubBreadcrumbsContext);
    if (!context) throw new Error('Hub breadcrumb hooks must be used within HubBreadcrumbsProvider');
    return context;
};
const $a724295c7bf4e051$export$695acbe2b31cd25f = (items)=>{
    const { clearBreadcrumbs: clearBreadcrumbs, setBreadcrumbs: setBreadcrumbs } = $a724295c7bf4e051$var$useHubBreadcrumbsContext();
    (0, $bSJIT.useEffect)(()=>{
        setBreadcrumbs(items);
    }, [
        items,
        setBreadcrumbs
    ]);
    (0, $bSJIT.useEffect)(()=>()=>{
            clearBreadcrumbs();
        }, [
        clearBreadcrumbs
    ]);
};
const $a724295c7bf4e051$export$e623729f7cd92c6b = ()=>$a724295c7bf4e051$var$useHubBreadcrumbsContext().items;

});

parcelRegister("3TZIE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a698ca77c20d70f0$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a698ca77c20d70f0$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    label: {
        id: 'company-hub-common.hub-breadcrumbs.label.non-final',
        defaultMessage: 'Breadcrumbs',
        description: 'Accessible label for the breadcrumb navigation shown on Help Hub pages.'
    },
    showMore: {
        id: 'company-hub-common.hub-breadcrumbs.showMore.non-final',
        defaultMessage: 'Show more breadcrumbs',
        description: 'Accessible label for the button that reveals breadcrumb items hidden at narrow widths.'
    }
});

});


parcelRegister("5CgBK", function(module, exports) {
$parcel$export(module.exports, "HubTypographyScope", () => $9595e7054dae16a2$export$e514657628596864);

var $bSJIT = parcelRequire("bSJIT");

var $dsKYd = parcelRequire("dsKYd");

var $bLjYO = parcelRequire("bLjYO");

var $fJggS = parcelRequire("fJggS");
var $iyFm0 = parcelRequire("iyFm0");
var $4yCWG = parcelRequire("4yCWG");
/**
 * Force the picked typography onto every descendant of HubTypographyScope,
 * including admin-published content rendered inside the editor (info
 * panels, decision lists, headings, paragraphs, etc.).
 *
 * Why this rule is needed — observed in DevTools:
 *   - An emotion-styled Hub layout box (e.g. `.fEBamI`) renders ABOVE
 *     HubTypographyScope and declares `font: var(--ds-font-body)` on
 *     itself. At that ancestor our scope isn't in scope yet, so
 *     `var(--ds-font-body)` resolves to AK's default and the `font`
 *     shorthand sets `font-family: <Atlassian Sans / ui-sans-serif, ...>`
 *     directly. That declared `font-family` then cascades down through
 *     HubTypographyScope, through the editor wrapper, and into every
 *     paragraph and heading the admin inserts.
 *   - Overriding CSS variables alone doesn't break the chain because
 *     `font-family` is already declared (inherited) at HubTypographyScope's
 *     ancestor and nothing inside the editor `var()`-references our handles
 *     for font-family itself.
 *
 * Fix: declare `font-family` directly at HubTypographyScope's wrapper
 * (paragraph stack) so descendants inherit the picked family, and
 * override to the heading stack for any heading element inside the scope.
 *
 * The editor `--editor-font-ugc-token-*` redeclarations stay as a
 * defensive hook for any editor surface that does consume them via
 * `font: var(--editor-font-ugc-token-body)`. Late-bound `var()`
 * substitution lets HubTypographyResetScope reset them back to
 * Atlassian Sans for admin-only popovers without touching this rule.
 *
 * Wrapper inheritance alone is NOT enough for `.ProseMirror p` (see the
 * dedicated rule below): @atlaskit/editor-core hardcodes a literal font
 * stack directly on that selector rather than consuming the UGC token,
 * so it must be beaten with an explicit `!important` override too.
 */ const $9595e7054dae16a2$var$TYPOGRAPHY_CSS = `
[data-hub-typography-scope] :where(h1, h2, h3, h4, h5, h6) {
	/*
	 * !important is required to beat the renderer's heading font.
	 * @atlaskit/renderer renders view-mode headings with
	 * \`font: var(--ak-renderer-editor-font-heading-*)\` \u{2014} a \`font\`
	 * shorthand at specificity (0,2,0) whose family segment is the
	 * hardcoded \`ui-sans-serif, -apple-system, ...\` stack. We can't
	 * override that token (the renderer sets it inline on its own
	 * dynamic-class container, which shadows any inherited override), so
	 * we override the family longhand with !important. It wins over the
	 * non-important shorthand's family while leaving the renderer's
	 * size / weight / line-height intact. The same rule covers editor
	 * (.ProseMirror) and AK Heading components, which is why it's applied
	 * scope-wide rather than only to the renderer.
	 */
	font-family: var(--hub-heading-font-family) !important;
}

[data-hub-typography-scope] .ProseMirror p {
	/*
	 * !important is required to beat @atlaskit/editor-core's own paragraph
	 * rule (paragraphStylesUGCRefreshed / paragraphStylesUGCModernized),
	 * which hardcodes a literal "Atlassian Sans" font stack directly on
	 * \`.ProseMirror p\` instead of consuming a themeable token (unlike the
	 * heading rule above, which does read --editor-font-ugc-token-heading-*).
	 * Every text node the editor wraps in a <p> \u{2014} plain paragraphs,
	 * bullet/ordered list items, blockquotes, table cells, panels, expands,
	 * task/decision items \u{2014} inherits that hardcoded family, so it must be
	 * overridden here the same way headings are.
	 */
	font-family: var(--hub-paragraph-font-family) !important;
}

[data-hub-typography-scope] .ProseMirror {
	--editor-font-ugc-token-heading-h1: normal 500 1.71429em / 1.16667 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h2: normal 500 1.42857em / 1.2 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h3: normal 600 1.14286em / 1.25 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h4: normal 600 1em / 1.14286 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h5: normal 600 0.857143em / 1.33333 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h6: normal 700 0.785714em / 1.45455 var(--hub-heading-font-family);
	--editor-font-ugc-token-body: normal 400 1em / 1.714 var(--hub-paragraph-font-family);
}

[data-hub-typography-scope] .ak-renderer-document {
	/*
	 * View-mode (renderer) UGC typography \u{2014} the mirror of the .ProseMirror block
	 * above. @atlaskit/renderer renders native ADF content (paragraphs, lists,
	 * panels, expand, blockquotes, dates, layout columns, table cells, headings\u{2026})
	 * by reading its own --ak-renderer-editor-font-* "font" shorthand tokens,
	 * which bake in the default Atlassian Sans family. We redefine those tokens
	 * with the picked hub family \u{2014} the values are copied verbatim from
	 * @atlaskit/editor-common's editorUGCTokensRefreshed and ONLY the trailing
	 * family segment is swapped \u{2014} so the renderer's size / weight / line-height
	 * are preserved exactly and only the family changes. !important is needed to
	 * beat the renderer setting these tokens inline on its own container.
	 *
	 * Why remap tokens instead of forcing font-family on every element: this
	 * touches ONLY the renderer's private tokens \u{2014} never font-family directly and
	 * never the shared --ds-font-* tokens. So bespoke extensions (spotlight,
	 * cards, carousel, \u{2026}), which style their titles/body with --ds-font-* and are
	 * remapped once on the wrapper (HUB_HEADING_TOKEN_MAP / HUB_PARAGRAPH_TOKEN_MAP),
	 * are untouched and keep the correct heading vs body font in both edit and
	 * view mode. Code (@atlaskit/code, its own monospace token) and
	 * HubTypographyResetScope subtrees don't read these tokens either, so they are
	 * left alone automatically \u{2014} no per-element exclusions required.
	 *
	 * Both modes now theme font *tokens* rather than overriding elements, so a new
	 * ADF node type is covered in both modes with no per-element work.
	 */
	--ak-renderer-editor-font-heading-h1: normal 600 1.71429em / 1.16667 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h2: normal 600 1.42857em / 1.2 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h3: normal 600 1.14286em / 1.25 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h4: normal 600 1em / 1.14286 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h5: normal 600 0.857143em / 1.33333 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h6: normal 600 0.785714em / 1.45455 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-normal-text: normal 400 1em / 1.714 var(--hub-paragraph-font-family) !important;
	--ak-renderer-editor-font-small-text: normal 400 0.875em / 1.714 var(--hub-paragraph-font-family) !important;
}
`;
const $9595e7054dae16a2$export$e514657628596864 = ({ children: children })=>{
    const enabled = (0, $bLjYO.useIsHubTypographyEnabled)();
    const theming = (0, $dsKYd.useHubTheming)();
    const typography = theming === null || theming === void 0 ? void 0 : theming.typography;
    const googleFontsUrl = (0, $bSJIT.useMemo)(()=>typography ? (0, $fJggS.buildGoogleFontsUrl)([
            typography.heading,
            typography.body
        ]) : '', [
        typography
    ]);
    const wrapperStyle = (0, $bSJIT.useMemo)(()=>{
        if (!typography) return {};
        // FONT_REGISTRY values are intentionally hard-coded font stacks — this
        // component's entire purpose is to override AK's typography tokens with
        // admin-picked families, so AK design-system tokens cannot be used here.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        const heading = (0, $iyFm0.FONT_REGISTRY)[typography.heading].family;
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        const body = (0, $iyFm0.FONT_REGISTRY)[typography.body].family;
        return {
            display: 'contents',
            // Points at our own --hub-paragraph-font-family handle so descendants
            // inherit the picked family. AK tokens cannot be used here — this IS
            // the override mechanism.
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontFamily: 'var(--hub-paragraph-font-family)',
            '--hub-heading-font-family': heading,
            '--hub-paragraph-font-family': body,
            ...(0, $4yCWG.HUB_HEADING_TOKEN_MAP),
            ...(0, $4yCWG.HUB_PARAGRAPH_TOKEN_MAP)
        };
    }, [
        typography
    ]);
    if (!enabled || !typography) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, googleFontsUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("link", {
        rel: "stylesheet",
        href: googleFontsUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("style", null, $9595e7054dae16a2$var$TYPOGRAPHY_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-hub-typography-scope": "",
        style: wrapperStyle
    }, children));
};

});
parcelRegister("bLjYO", function(module, exports) {
$parcel$export(module.exports, "useIsHubTypographyEnabled", () => $daf4f27213d5bec7$export$7667d247a9598346);
/**
 * Returns `true` when Hub typography customization should be active.
 *
 * Gated by THREE things ANDed together:
 *   1. The product-level flag `advanced-theming-in-hub` (via HubContext —
 *      checked transitively through `useIsAdvancedThemingEnabled`).
 *   2. The platform-level Statsig gate `hub-advanced-theming` (the v2
 *      colour palette gate — checked transitively).
 *   3. The new platform-level Statsig gate `hub-typography`.
 *
 * The first two come from `useIsAdvancedThemingEnabled` — typography
 * is a sub-feature of advanced theming and never ships without it.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */ 
var $gdUUy = parcelRequire("gdUUy");

var $axsoS = parcelRequire("axsoS");
const $daf4f27213d5bec7$export$7667d247a9598346 = ()=>{
    const isAdvancedThemingEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    return isAdvancedThemingEnabled && (0, $gdUUy.fg)('hub-typography');
};

});

parcelRegister("fJggS", function(module, exports) {
$parcel$export(module.exports, "buildGoogleFontsUrl", () => $60b64378975b2d45$export$86eb54e95bc87537);

var $iyFm0 = parcelRequire("iyFm0");
const $60b64378975b2d45$export$86eb54e95bc87537 = (fontKeys)=>{
    const families = new Set();
    for (const key of fontKeys){
        const family = (0, $iyFm0.FONT_REGISTRY)[key].googleFontsFamily;
        if (family) families.add(family);
    }
    if (families.size === 0) return '';
    const query = Array.from(families).map((f)=>`family=${f}`).join('&');
    return `https://fonts.googleapis.com/css2?${query}&display=swap`;
};

});

parcelRegister("4yCWG", function(module, exports) {
$parcel$export(module.exports, "HUB_HEADING_TOKEN_MAP", () => $f65d771450fe0232$export$f357f3dafa7e9577);
$parcel$export(module.exports, "HUB_PARAGRAPH_TOKEN_MAP", () => $f65d771450fe0232$export$74bfab40c379f83);
/**
 * CSS-var overrides set on the `<HubTypographyScope>` wrapper. These map
 * AK design-system typography tokens onto values that reference the
 * `--hub-heading-font-family` / `--hub-paragraph-font-family` handles —
 * forcing every heading / body composite token to render with the admin's
 * picked font instead of the AK default.
 *
 * Sizes and line-heights use rem values matching the canonical AK source at
 * `platform/packages/design-system/tokens/src/artifacts/themes/atlassian-typography.tsx`.
 * The only difference from the AK source is the `font-family` segment, which
 * is replaced with the hub family CSS-var handle.
 *
 * Medium / Bold / xxsmall heading entries and weight variants for body are
 * included defensively (cost of a missing override is visible inconsistency;
 * cost of an unnecessary override is zero).
 */ const $f65d771450fe0232$export$f357f3dafa7e9577 = {
    '--ds-font-family-heading': 'var(--hub-heading-font-family)',
    '--ds-font-family-brand-heading': 'var(--hub-heading-font-family)',
    '--ds-font-heading-xxlarge': 'normal 653 2rem/2.25rem var(--hub-heading-font-family)',
    '--ds-font-heading-xlarge': 'normal 653 1.75rem/2rem var(--hub-heading-font-family)',
    '--ds-font-heading-large': 'normal 653 1.5rem/1.75rem var(--hub-heading-font-family)',
    '--ds-font-heading-medium': 'normal 653 1.25rem/1.5rem var(--hub-heading-font-family)',
    '--ds-font-heading-small': 'normal 653 1rem/1.25rem var(--hub-heading-font-family)',
    '--ds-font-heading-xsmall': 'normal 653 0.875rem/1.25rem var(--hub-heading-font-family)',
    '--ds-font-heading-xxsmall': 'normal 653 0.75rem/1rem var(--hub-heading-font-family)'
};
const $f65d771450fe0232$export$74bfab40c379f83 = {
    '--ds-font-family-body': 'var(--hub-paragraph-font-family)',
    '--ds-font-family-brand-body': 'var(--hub-paragraph-font-family)',
    '--ds-font-body-large': 'normal 400 1rem/1.5rem var(--hub-paragraph-font-family)',
    '--ds-font-body-large-medium': 'normal 500 1rem/1.5rem var(--hub-paragraph-font-family)',
    '--ds-font-body-large-bold': 'normal 700 1rem/1.5rem var(--hub-paragraph-font-family)',
    '--ds-font-body': 'normal 400 0.875rem/1.25rem var(--hub-paragraph-font-family)',
    '--ds-font-body-medium': 'normal 500 0.875rem/1.25rem var(--hub-paragraph-font-family)',
    '--ds-font-body-bold': 'normal 700 0.875rem/1.25rem var(--hub-paragraph-font-family)',
    '--ds-font-body-small': 'normal 400 0.75rem/1rem var(--hub-paragraph-font-family)',
    '--ds-font-body-small-medium': 'normal 500 0.75rem/1rem var(--hub-paragraph-font-family)',
    '--ds-font-body-small-bold': 'normal 700 0.75rem/1rem var(--hub-paragraph-font-family)',
    '--ds-font-body-UNSAFE_small': 'normal 400 0.75rem/1rem var(--hub-paragraph-font-family)'
};

});


parcelRegister("erx1J", function(module, exports) {
$parcel$export(module.exports, "isDefaultHelpCenterBasePath", () => $ddcad79c18530e77$export$5c865fc34320ed7b);
$parcel$export(module.exports, "getHelpCenterHomePath", () => $ddcad79c18530e77$export$e90b39e75e81f606);
const $ddcad79c18530e77$var$DEFAULT_HELP_CENTER_BASE_PATH = '/servicedesk/customer';
const $ddcad79c18530e77$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH = '/servicedesk/customer/test';
const $ddcad79c18530e77$var$PORTALS_SEGMENT = '/portals';
const $ddcad79c18530e77$var$stripTrailingSlashes = (path)=>path.replace(/\/+$/, '');
const $ddcad79c18530e77$export$5c865fc34320ed7b = (basePath)=>{
    const normalizedBasePath = $ddcad79c18530e77$var$stripTrailingSlashes(basePath);
    return [
        $ddcad79c18530e77$var$DEFAULT_HELP_CENTER_BASE_PATH,
        $ddcad79c18530e77$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH,
        `${$ddcad79c18530e77$var$DEFAULT_HELP_CENTER_BASE_PATH}${$ddcad79c18530e77$var$PORTALS_SEGMENT}`,
        `${$ddcad79c18530e77$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH}${$ddcad79c18530e77$var$PORTALS_SEGMENT}`
    ].includes(normalizedBasePath);
};
const $ddcad79c18530e77$export$e90b39e75e81f606 = (basePath)=>{
    const normalizedBasePath = $ddcad79c18530e77$var$stripTrailingSlashes(basePath);
    if (!$ddcad79c18530e77$export$5c865fc34320ed7b(normalizedBasePath)) return normalizedBasePath;
    return normalizedBasePath.endsWith($ddcad79c18530e77$var$PORTALS_SEGMENT) ? normalizedBasePath : `${normalizedBasePath}${$ddcad79c18530e77$var$PORTALS_SEGMENT}`;
};

});

parcelRegister("dcCJ5", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $f55ec3e56631fd44$export$3b4e64e77073e307);
$parcel$export(module.exports, "withHubBanner", () => $f55ec3e56631fd44$export$c5c3e0c2fc948b49);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $dDEhr = parcelRequire("dDEhr");

var $53RlD = parcelRequire("53RlD");

var $itx7D = parcelRequire("itx7D");

var $axsoS = parcelRequire("axsoS");

var $hJs5J = parcelRequire("hJs5J");

var $fmxWE = parcelRequire("fmxWE");
const $f55ec3e56631fd44$var$styles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    textContainer: "_4t3i8vuz _19pk1epz _otyr1epz",
    textContainerWidth: "_1bsb1vuk",
    bannerText: "_k48pwu06 _1wybckbl _vwz48vuz",
    bannerHeadingMargin: "_19pkze3t _otyrze3t",
    bannerTextTruncation: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _y3gn1h6o",
    container: "_2rko12b0"
};
const $f55ec3e56631fd44$var$BannerContent = ({ bannerText: bannerText })=>{
    const { branding: branding, layout: layout } = (0, $hJs5J.useHubContext)();
    // Advanced theming (help hubs only) gates rendering the banner title as a
    // semantic heading. When off, keep the legacy non-semantic div.
    const isAdvancedThemingEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    const bannerBackgroundColour = branding.colors.primary;
    const title = bannerText ? bannerText : layout === null || layout === void 0 ? void 0 : layout.bannerText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: bannerBackgroundColour
        },
        "data-testid": "banner",
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.textContainer,
            (0, $gdUUy.fg)('enable-jsm-in-hubs') && $f55ec3e56631fd44$var$styles.textContainerWidth
        ])
    }, isAdvancedThemingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("h1", {
        "data-testid": "banner-text",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            color: (0, $fmxWE.readableTextColor)(bannerBackgroundColour)
        },
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.bannerText,
            $f55ec3e56631fd44$var$styles.bannerHeadingMargin,
            (0, $gdUUy.fg)('enable-jsm-in-hubs') && $f55ec3e56631fd44$var$styles.bannerTextTruncation
        ])
    }, title || '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "banner-text",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            color: (0, $fmxWE.readableTextColor)(bannerBackgroundColour)
        },
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.bannerText,
            (0, $gdUUy.fg)('enable-jsm-in-hubs') && $f55ec3e56631fd44$var$styles.bannerTextTruncation
        ])
    }, title || ''))));
};
// Fallback banner shown when BannerContent fails to render
const $f55ec3e56631fd44$var$BannerFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: (0, $53RlD.DEFAULT_BRANDING_COLOR)
        },
        "data-testid": "banner-fallback",
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.textContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            color: "var(--ds-text, #292A2E)"
        },
        className: (0, $9fU1q.default)([
            $f55ec3e56631fd44$var$styles.bannerText
        ])
    }))));
const $f55ec3e56631fd44$export$3b4e64e77073e307 = ({ bannerText: bannerText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $itx7D.HubErrorBoundary), {
        packageName: "@atlassian/hub-app-shell",
        id: "banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f55ec3e56631fd44$var$BannerFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f55ec3e56631fd44$var$BannerContent, {
        bannerText: bannerText
    }));
};
const $f55ec3e56631fd44$export$c5c3e0c2fc948b49 = (InnerComponent)=>{
    const ComponentWithHubBanner = (props)=>{
        const { bannerText: bannerText, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            className: (0, $9fU1q.default)([
                $f55ec3e56631fd44$var$styles.bannerContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f55ec3e56631fd44$export$3b4e64e77073e307, {
            bannerText: bannerText
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(InnerComponent, rest));
    };
    return ComponentWithHubBanner;
};

});
parcelRegister("fmxWE", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $a629d9b2cb7ef7fa$export$3d31854eb05903e0);

var $d2gH4 = parcelRequire("d2gH4");
const $a629d9b2cb7ef7fa$export$3d31854eb05903e0 = (color)=>{
    return (0, $d2gH4.readableTextColor)(color, '@atlassian/hub-app-shell');
};

});


parcelRegister("6xeJZ", function(module, exports) {
$parcel$export(module.exports, "MigrationPublishSuccessFlag", () => $4183faeeca5a9b50$export$7f6029f49f2c88b);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $VnB4y = parcelRequire("VnB4y");

var $lP6sB = parcelRequire("lP6sB");

var $jpzZU = parcelRequire("jpzZU");
var $jbUlQ = parcelRequire("jbUlQ");
const $4183faeeca5a9b50$export$7f6029f49f2c88b = ({ shouldShow: shouldShow, isSandboxHelpCenter: isSandboxHelpCenterOverride })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        const currentUrl = new URL(window.location.href);
        const shouldShowPublishSuccessFlag = shouldShow ?? currentUrl.searchParams.get((0, $jpzZU.MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM)) === 'true';
        if (!shouldShowPublishSuccessFlag) return;
        if (shouldShow === undefined) {
            currentUrl.searchParams.delete((0, $jpzZU.MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM));
            window.history.replaceState(window.history.state, '', currentUrl);
        }
        const isSandboxHelpCenter = isSandboxHelpCenterOverride ?? (0, $jpzZU.isSandboxHelpCenterBasePath)(currentUrl.pathname);
        const title = formatMessage(isSandboxHelpCenter ? (0, $jbUlQ.migrationPublishMessages).sandboxHelpCenterPublished : (0, $jbUlQ.migrationPublishMessages).helpCenterPublished);
        showFlag({
            title: title,
            description: formatMessage(isSandboxHelpCenter ? (0, $jbUlQ.migrationPublishMessages).sandboxHelpCenterPublishedDescription : (0, $jbUlQ.migrationPublishMessages).helpCenterPublishedDescription),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
                label: title,
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "spacious"
            })
        });
    }, [
        formatMessage,
        isSandboxHelpCenterOverride,
        shouldShow,
        showFlag
    ]);
    return null;
};

});
parcelRegister("VnB4y", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $eeb5e2de1018cfd0$export$2879604e6aec4ab);

var $bSJIT = parcelRequire("bSJIT");

var $9Dksr = parcelRequire("9Dksr");
function $eeb5e2de1018cfd0$export$2879604e6aec4ab() {
    const api = (0, $bSJIT.useContext)((0, $9Dksr.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}

});

parcelRegister("jpzZU", function(module, exports) {
$parcel$export(module.exports, "MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM", () => $6e76122ee0c2553f$export$d1ab110f0c36cc19);
$parcel$export(module.exports, "isDefaultHelpCenterPortalsPreviewPath", () => $6e76122ee0c2553f$export$9bfa4aaee0635b5e);
$parcel$export(module.exports, "isSandboxHelpCenterBasePath", () => $6e76122ee0c2553f$export$4beffde23d35a4ff);
$parcel$export(module.exports, "getMigrationPublishedUrl", () => $6e76122ee0c2553f$export$deba28094075216b);

var $jbUlQ = parcelRequire("jbUlQ");
const $6e76122ee0c2553f$export$d1ab110f0c36cc19 = 'migrationPublished';
const $6e76122ee0c2553f$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH = '/servicedesk/customer/test/portals';
const $6e76122ee0c2553f$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH = '/servicedesk/customer/test';
const $6e76122ee0c2553f$var$HELP_CENTER_PREVIEW_PATH_PREFIX = '/helpcenter/test/';
const $6e76122ee0c2553f$export$9bfa4aaee0635b5e = (pathname)=>pathname === $6e76122ee0c2553f$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH || pathname === `${$6e76122ee0c2553f$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH}/`;
const $6e76122ee0c2553f$export$4beffde23d35a4ff = (basePath)=>{
    const normalizedBasePath = basePath.replace(/\/+$/, '');
    return normalizedBasePath === $6e76122ee0c2553f$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH || normalizedBasePath === $6e76122ee0c2553f$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH || normalizedBasePath.startsWith($6e76122ee0c2553f$var$HELP_CENTER_PREVIEW_PATH_PREFIX) && normalizedBasePath.length > $6e76122ee0c2553f$var$HELP_CENTER_PREVIEW_PATH_PREFIX.length;
};
const $6e76122ee0c2553f$export$deba28094075216b = (url)=>{
    const destination = new URL(url);
    destination.searchParams.set($6e76122ee0c2553f$export$d1ab110f0c36cc19, 'true');
    return destination.toString();
};

});
parcelRegister("jbUlQ", function(module, exports) {
$parcel$export(module.exports, "migrationPublishMessages", () => $6fd4e4ef5215737e$export$30737412df457d29);

var $f0Pt4 = parcelRequire("f0Pt4");
const $6fd4e4ef5215737e$export$30737412df457d29 = (0, $f0Pt4.defineMessages)({
    helpCenterPublished: {
        id: 'hub-home.help-center-layout.draft-published-success',
        defaultMessage: 'Help center published',
        description: 'Success flag title shown when draft changes are published to a help center'
    },
    helpCenterPublishedDescription: {
        id: 'hub-home.help-center-layout.draft-published-description',
        defaultMessage: 'All your changes have been published and are now visible to your audience.',
        description: 'Success flag description shown when draft changes are published to a help center'
    },
    sandboxHelpCenterPublished: {
        id: 'hub-home.help-center-layout.sandbox-draft-published-success.non-final',
        defaultMessage: 'Help center published',
        description: 'Success flag title shown when changes are published to a sandbox help center.'
    },
    sandboxHelpCenterPublishedDescription: {
        id: 'hub-home.help-center-layout.sandbox-draft-published-description.non-final',
        defaultMessage: 'Your changes have been published to this help center.',
        description: 'Success flag description shown after publishing draft changes to a sandbox help center.'
    }
});

});



parcelRegister("4TV3w", function(module, exports) {
$parcel$export(module.exports, "MigrationReviewActionBar", () => $bb7f8dcb33455f5a$export$a3fef1c3a02c6fed);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $6zpvm = parcelRequire("6zpvm");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $6WltM = parcelRequire("6WltM");

var $jNJGJ = parcelRequire("jNJGJ");

var $4TRbS = parcelRequire("4TRbS");

var $lgtof = parcelRequire("lgtof");

var $lkSXl = parcelRequire("lkSXl");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $VnB4y = parcelRequire("VnB4y");

var $4GWyU = parcelRequire("4GWyU");

var $cBVmT = parcelRequire("cBVmT");

var $8iYAq = parcelRequire("8iYAq");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $k2MWg = parcelRequire("k2MWg");

var $hqRyI = parcelRequire("hqRyI");

var $jpzZU = parcelRequire("jpzZU");

var $hhVc4 = parcelRequire("hhVc4");

var $d71a0 = parcelRequire("d71a0");
const $bb7f8dcb33455f5a$var$styles = {
    container: "_85i5utpp _1q51utpp _y4ti1ejb _bozg1ejb"
};
const $bb7f8dcb33455f5a$export$a3fef1c3a02c6fed = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, helpCenterName: helpCenterName, migrationReview: migrationReview, publishedHelpCenterUrl: publishedHelpCenterUrl })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    const [isFinishLaterModalOpen, setIsFinishLaterModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isPublishModalOpen, setIsPublishModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const hasTrackedView = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    const publishAttemptRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef({
        attempt: null,
        retry: false
    });
    const [commitGoLiveHelpCenter, isPublishing] = (0, $a2qIF.useMutation)((0, $6zpvm.default));
    const fireAnalyticsEvent = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId })=>{
        (0, $k2MWg.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), actionSubjectId);
    }, [
        createAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (hasTrackedView.current) return;
        hasTrackedView.current = true;
        fireAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'migrationReviewActionBar',
            actionSubjectId: 'migrationReviewActionBar'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const showPublishErrorFlag = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        const title = formatMessage((0, $d71a0.default).publishError);
        showFlag({
            title: title,
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                label: title,
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            })
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const completePublishAttempt = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((attempt, action, outcome)=>{
        const state = publishAttemptRef.current;
        if (state.attempt !== attempt || attempt.terminal) return false;
        attempt.terminal = true;
        state.retry = action === 'failed';
        (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({}), `helpCenterMigrationReviewAction ${action}`, 'goLiveHelpCenter', {
            duration: Date.now() - attempt.startedAt,
            retry: attempt.retry,
            ...outcome
        });
        return true;
    }, [
        createAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>()=>{
            var _attempt$disposable;
            const attempt = publishAttemptRef.current.attempt;
            if (!attempt || attempt.terminal) return;
            completePublishAttempt(attempt, 'cancelled', {
                outcome: 'unmounted'
            });
            (_attempt$disposable = attempt.disposable) === null || _attempt$disposable === void 0 || _attempt$disposable.dispose();
        }, [
        completePublishAttempt
    ]);
    const handlePublishModalOpen = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewPublishButton'
        });
        setIsPublishModalOpen(true);
    }, [
        fireAnalyticsEvent
    ]);
    const handlePublishModalCancel = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        setIsPublishModalOpen(false);
    }, []);
    const handleFinishLaterModalOpen = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: 'migrationReviewFinishLaterMenuItem'
        });
        fireAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'modal',
            actionSubjectId: 'migrationReviewFinishLaterModal'
        });
        setIsFinishLaterModalOpen(true);
    }, [
        fireAnalyticsEvent
    ]);
    const handleFinishLaterModalCancel = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewFinishLaterModalCancel'
        });
        setIsFinishLaterModalOpen(false);
    }, [
        fireAnalyticsEvent
    ]);
    const handlePublish = ()=>{
        const publishAttemptState = publishAttemptRef.current;
        if (isPublishing || publishAttemptState.attempt && !publishAttemptState.attempt.terminal) return;
        const attempt = {
            disposable: null,
            startedAt: Date.now(),
            terminal: false,
            retry: publishAttemptState.retry
        };
        publishAttemptState.attempt = attempt;
        setIsPublishModalOpen(false);
        attempt.disposable = commitGoLiveHelpCenter({
            variables: {
                cloudId: cloudId,
                input: {
                    helpCenterAri: helpCenterAri
                }
            },
            onCompleted: (response)=>{
                var _response$helpCenter;
                const goLiveHelpCenter = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.goLiveHelpCenter;
                if (goLiveHelpCenter !== null && goLiveHelpCenter !== void 0 && goLiveHelpCenter.success) {
                    if (completePublishAttempt(attempt, 'succeeded', {
                        outcome: 'published'
                    })) window.location.href = (0, $jpzZU.getMigrationPublishedUrl)(publishedHelpCenterUrl);
                    return;
                }
                if (completePublishAttempt(attempt, 'failed', {
                    errorCode: goLiveHelpCenter ? 'PUBLISH_REJECTED' : 'EMPTY_RESPONSE'
                })) showPublishErrorFlag();
            },
            onError: ()=>{
                if (completePublishAttempt(attempt, 'failed', {
                    errorCode: 'RELAY_REQUEST_FAILED'
                })) showPublishErrorFlag();
            }
        });
    };
    const handleMoreActionsClick = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewMoreActionsButton'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const handleEditDraft = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: 'migrationReviewEditDraftMenuItem'
        });
        migrationReview.onEditDraft();
    }, [
        fireAnalyticsEvent,
        migrationReview
    ]);
    const handleFinishLaterConfirm = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewFinishLaterModalConfirm'
        });
        migrationReview.onFinishLater();
        setIsFinishLaterModalOpen(false);
    }, [
        fireAnalyticsEvent,
        migrationReview
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        backgroundColor: "color.background.accent.blue.subtlest",
        xcss: $bb7f8dcb33455f5a$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        rowSpace: "space.150",
        shouldWrap: true,
        space: "space.200",
        spread: "space-between",
        testId: "migration-review-action-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8iYAq))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), null, formatMessage((0, $d71a0.default).banner))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        rowSpace: "space.100",
        shouldWrap: true,
        space: "space.100",
        testId: "migration-review-action-bar-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lgtof.SplitButton), {
        appearance: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        isDisabled: isPublishing,
        isLoading: isPublishing,
        onClick: handlePublishModalOpen
    }, formatMessage((0, $d71a0.default).publish)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
                ref: triggerRef,
                ...triggerProps,
                onClickCapture: handleMoreActionsClick,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))),
                label: formatMessage((0, $d71a0.default).morePublishActions)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
        onClick: handleEditDraft
    }, formatMessage((0, $d71a0.default).editDraft)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
        onClick: handleFinishLaterModalOpen
    }, formatMessage((0, $d71a0.default).finishLater)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hhVc4.PublishMigrationModal), {
        isOpen: isPublishModalOpen,
        onCancel: handlePublishModalCancel,
        onConfirm: handlePublish
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hqRyI.FinishMigrationReviewModal), {
        helpCenterName: helpCenterName,
        isOpen: isFinishLaterModalOpen,
        onCancel: handleFinishLaterModalCancel,
        onConfirm: handleFinishLaterConfirm
    }));
};

});
parcelRegister("6zpvm", function(module, exports) {
$parcel$export(module.exports, "default", () => $77e16450895359b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04deeef1f2658d38f33a4fd67e657cf2>>
 * @relayHash e23d2e5c7dfca11e2dc4cccb39b1eb51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f866042051dd312587032db4be12d468485a124b37cb6fa7b64164638a68737
const $77e16450895359b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterHubGoLiveHelpCenterPayload",
                    "kind": "LinkedField",
                    "name": "goLiveHelpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3f866042051dd312587032db4be12d468485a124b37cb6fa7b64164638a68737",
            "metadata": {},
            "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$77e16450895359b2$var$node.hash = "dc20ceea767638a38fd0257323a7c400";
var $77e16450895359b2$export$2e2bcd8739ae039 = $77e16450895359b2$var$node;

});

parcelRegister("lgtof", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $dedc969b6fe198bb$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $cxKSW = parcelRequire("cxKSW");

var $cHqD5 = parcelRequire("cHqD5");

var $eHubG = parcelRequire("eHubG");

var $d0t0z = parcelRequire("d0t0z");
const $dedc969b6fe198bb$var$buttonStyles = {
    primaryButton: "_1g6vidpf _k9paidpf _7k5eidpf _10t6idpf",
    secondaryButton: "_jw1uidpf _1uoaidpf _zb8tidpf _3yvgidpf"
};
const $dedc969b6fe198bb$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $d0t0z.getActions)(children);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cHqD5.SplitButtonContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $eHubG.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $dedc969b6fe198bb$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $cxKSW.Divider), {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $dedc969b6fe198bb$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("cxKSW", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $de8cebd64f5156d9$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $de8cebd64f5156d9$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkbk0g _80om13gf",
    dividerOffset: "_195g1n1a"
};
const $de8cebd64f5156d9$var$dividerAppearanceStyles = {
    default: "_bfhk1l7x",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkazsu _tzy419lr"
};
const $de8cebd64f5156d9$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
const $de8cebd64f5156d9$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $de8cebd64f5156d9$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $de8cebd64f5156d9$var$dividerStyles.baseDivider,
            isDefaultDivider && $de8cebd64f5156d9$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $de8cebd64f5156d9$var$dividerHeightStyles[spacing],
            isDisabled && $de8cebd64f5156d9$var$dividerStyles.dividerDisabled,
            !isDisabled && $de8cebd64f5156d9$var$dividerAppearanceStyles[appearance],
            $de8cebd64f5156d9$var$dividerStyles.dividerOffset
        ])
    });
};

});

parcelRegister("cHqD5", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContainer", () => $db8e1241b07f3904$export$994ba1b4c598f7);
/* split-button-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $db8e1241b07f3904$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    defaultAppearanceContainer: "_2rko1qi0 _12ji1l7x _1cwg1n1a _1qu2nqa1 _12y3t94y",
    defaultAppearanceDisabledContainer: "_12jibk0g"
};
const $db8e1241b07f3904$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            appearance === 'default' && $db8e1241b07f3904$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && isDisabled && $db8e1241b07f3904$var$buttonStyles.defaultAppearanceDisabledContainer,
            $db8e1241b07f3904$var$buttonStyles.splitButton
        ]),
        children: children
    });

});

parcelRegister("d0t0z", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $eb30f34a635a874f$export$fe3955935f564b31);

var $bSJIT = parcelRequire("bSJIT");

var $4eGW1 = parcelRequire("4eGW1");
const $eb30f34a635a874f$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $bSJIT.Children).toArray(children);
    typeof $4eGW1;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("hqRyI", function(module, exports) {
$parcel$export(module.exports, "FinishMigrationReviewModal", () => $346af66b1157778a$export$a44a4b429312c901);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $9Abbn = parcelRequire("9Abbn");

var $fpluU = parcelRequire("fpluU");
const $346af66b1157778a$export$a44a4b429312c901 = ({ helpCenterName: helpCenterName, isOpen: isOpen, isPending: isPending = false, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), null, formatMessage((0, $fpluU.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, formatMessage(helpCenterName ? (0, $fpluU.default).body : (0, $fpluU.default).bodyWithoutHelpCenterName, {
        helpCenterName: helpCenterName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        role: "status"
    }, isPending ? formatMessage((0, $fpluU.default).saving) : ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $fpluU.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "warning",
        isDisabled: isPending,
        isLoading: isPending,
        onClick: onConfirm
    }, formatMessage((0, $fpluU.default).confirm))));
};

});
parcelRegister("fpluU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1cf44f995e77495$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $e1cf44f995e77495$var$messages = (0, $f0Pt4.defineMessages)({
    cancel: {
        id: 'company-hub-common.finish-migration-review-modal.cancel',
        defaultMessage: 'Cancel',
        description: 'Button that closes the finish migration review later confirmation modal.'
    },
    confirm: {
        id: 'company-hub-common.finish-migration-review-modal.confirm',
        defaultMessage: 'Confirm',
        description: 'Button that confirms saving the migration review update as a draft.'
    },
    saving: {
        id: 'company-hub-common.finish-migration-review-modal.saving',
        defaultMessage: 'Saving changes',
        description: 'Screen reader status announced while migration review changes are being saved before finishing later.'
    },
    body: {
        id: 'company-hub-common.finish-migration-review-modal.body',
        defaultMessage: "You\u2019re about to leave the {helpCenterName} update. We\u2019ll save your changes as a draft, but you\u2019ll need to review them later for the update to go live.",
        description: 'Explains that leaving this help center update saves it as a draft. The helpCenterName placeholder is replaced by the help center name.'
    },
    bodyWithoutHelpCenterName: {
        id: 'company-hub-common.finish-migration-review-modal.bodyWithoutHelpCenterName',
        defaultMessage: "You\u2019re about to leave the help center update. We\u2019ll save your changes as a draft, but you\u2019ll need to review them later for the update to go live.",
        description: 'Explains that leaving the unnamed default help center update saves it as a draft and requires a later review before it goes live.'
    },
    title: {
        id: 'company-hub-common.finish-migration-review-modal.title',
        defaultMessage: 'Finish review later',
        description: 'Title of the modal that confirms finishing a migration review later.'
    }
});
var $e1cf44f995e77495$export$2e2bcd8739ae039 = $e1cf44f995e77495$var$messages;

});


parcelRegister("hhVc4", function(module, exports) {
$parcel$export(module.exports, "PublishMigrationModal", () => $fde45c79d974088b$export$da79270de2e2071d);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $8aT4G = parcelRequire("8aT4G");

var $ejnzp = parcelRequire("ejnzp");
const $fde45c79d974088b$export$da79270de2e2071d = ({ isOpen: isOpen, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const hasConfirmedRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (isOpen) hasConfirmedRef.current = false;
    }, [
        isOpen
    ]);
    const handleConfirm = ()=>{
        if (hasConfirmedRef.current) return;
        hasConfirmedRef.current = true;
        onConfirm();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), null, formatMessage((0, $ejnzp.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        as: "p"
    }, formatMessage((0, $ejnzp.default).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $ejnzp.default).keepEditing)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "primary",
        onClick: handleConfirm
    }, formatMessage((0, $ejnzp.default).publish)))));
};

});
parcelRegister("ejnzp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db13200acf3de46$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $9db13200acf3de46$var$messages = (0, $f0Pt4.defineMessages)({
    title: {
        id: 'company-hub-common.publish-migration-modal.title',
        defaultMessage: 'Replace current help center?',
        description: 'Title of the confirmation dialog before publishing a migrated help center.'
    },
    body: {
        id: 'company-hub-common.publish-migration-modal.body',
        defaultMessage: 'Publishing will permanently replace your existing help center with the new version. This action is final and cannot be undone.',
        description: 'Warning that publishing a migrated help center permanently replaces the existing one.'
    },
    keepEditing: {
        id: 'company-hub-common.publish-migration-modal.keep-editing',
        defaultMessage: 'Keep editing',
        description: 'Dismiss the confirmation dialog without publishing the migrated help center.'
    },
    publish: {
        id: 'company-hub-common.publish-migration-modal.publish',
        defaultMessage: 'Publish',
        description: 'Confirm publishing the migrated help center and replacing the existing one.'
    }
});
var $9db13200acf3de46$export$2e2bcd8739ae039 = $9db13200acf3de46$var$messages;

});


parcelRegister("d71a0", function(module, exports) {
$parcel$export(module.exports, "default", () => $09100b25fab7d4e2$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $09100b25fab7d4e2$var$messages = (0, $f0Pt4.defineMessages)({
    banner: {
        id: 'hub-app-shell.migration-review-action-bar.banner',
        defaultMessage: 'Previewing your help center draft',
        description: 'Banner text that explains an administrator is previewing a help center draft.'
    },
    editDraft: {
        id: 'hub-app-shell.migration-review-action-bar.editDraft',
        defaultMessage: 'Edit draft',
        description: 'Menu item that returns the administrator to editing the help center draft.'
    },
    finishLater: {
        id: 'hub-app-shell.migration-review-action-bar.finishLater',
        defaultMessage: 'Finish later',
        description: 'Menu item that asks the administrator to confirm finishing the help center review later.'
    },
    morePublishActions: {
        id: 'hub-app-shell.migration-review-action-bar.morePublishActions',
        defaultMessage: 'More publish actions',
        description: 'Accessible label for the overflow button next to the Publish action.'
    },
    publish: {
        id: 'hub-app-shell.migration-review-action-bar.publish',
        defaultMessage: 'Publish',
        description: 'Primary button that starts publishing the help center draft.'
    },
    publishError: {
        id: 'hub-app-shell.migration-review-action-bar.publishError.ai-non-final',
        defaultMessage: 'Unable to publish your help center. Try again.',
        description: 'Error flag shown when publishing the migrated help center fails and the administrator can retry.'
    }
});
var $09100b25fab7d4e2$export$2e2bcd8739ae039 = $09100b25fab7d4e2$var$messages;

});


parcelRegister("aKW5H", function(module, exports) {
$parcel$export(module.exports, "Navbar", () => $d2acca5eddbe354b$export$42cfbb80f7861e77);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");
var $3DuDW = parcelRequire("3DuDW");

var $5zqhO = parcelRequire("5zqhO");

var $JD7lD = parcelRequire("JD7lD");

var $jNJGJ = parcelRequire("jNJGJ");

var $4TRbS = parcelRequire("4TRbS");

var $jDsoo = parcelRequire("jDsoo");

var $9dYEz = parcelRequire("9dYEz");

var $flsxn = parcelRequire("flsxn");

var $d9bXQ = parcelRequire("d9bXQ");

var $gRPcG = parcelRequire("gRPcG");

var $iRdwF = parcelRequire("iRdwF");

var $jvbf5 = parcelRequire("jvbf5");

var $gdUUy = parcelRequire("gdUUy");

var $26Jy2 = parcelRequire("26Jy2");

var $9PwDt = parcelRequire("9PwDt");

var $6X9z7 = parcelRequire("6X9z7");

var $jfgZg = parcelRequire("jfgZg");

var $eJ5U1 = parcelRequire("eJ5U1");

var $k8QkJ = parcelRequire("k8QkJ");

var $kyaby = parcelRequire("kyaby");

var $3YmaA = parcelRequire("3YmaA");

var $cp3Es = parcelRequire("cp3Es");

var $hJs5J = parcelRequire("hJs5J");

var $19qNx = parcelRequire("19qNx");

var $llrSd = parcelRequire("llrSd");

var $gKSNc = parcelRequire("gKSNc");

var $c6lL1 = parcelRequire("c6lL1");

const $d2acca5eddbe354b$var$MobileMenuOverlay = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("dwPUC")).then((m)=>({
            default: m.MobileMenuOverlay
        })));
const $d2acca5eddbe354b$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $d2acca5eddbe354b$var$styles = {
    navbarStacking: "_kqswh2mm _1pby1kze",
    navbar: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    navbarUpdated: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    navBarDisabled: "_lcxvglyw",
    logoContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    rightSection: "_zulputpp _1e0c1txw _4cvr1h6o _1o9zidpf"
};
const $d2acca5eddbe354b$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false, isViewportSticky: isViewportSticky = false })=>{
    var _hubContext$layout;
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $bSJIT.useState)(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, $bSJIT.useState)(false);
    const [viewportMatches, setViewportMatches] = (0, $bSJIT.useState)();
    const navbarRef = (0, $bSJIT.useRef)(null);
    const isViewportSwitchEnabled = (0, $gdUUy.fg)('switch-hub-nav-bar');
    const handleViewportChange = (0, $bSJIT.useCallback)((event)=>{
        setViewportMatches(event.matches);
        setIsMobileMenuOpen(false);
        setIsAvatarMenuOpen(false);
    }, []);
    const mediaQuery = (0, $jfgZg.UNSAFE_useMediaQuery)('below.sm', isViewportSwitchEnabled ? handleViewportChange : undefined);
    const isBelowSm = (isViewportSwitchEnabled ? viewportMatches : undefined) ?? (mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches) ?? false;
    const hubContext = (0, $hJs5J.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $eJ5U1.useNavigationStyle)();
    // Keep a black/white navbar label legible against the live brand colour. The
    // navbar's day-0 background is the darkest brand shade, so a brand change can
    // invert which of black/white is readable. An explicit colour is left alone.
    // See `hub-auto-text-color`.
    const resolveNavTextColor = (0, $k8QkJ.useHubAutoTextColor)('hub-app-shell');
    const navTextColor = resolveNavTextColor({
        backgroundColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.backgroundColor,
        textColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor,
        defaultRef: 'primary.1000'
    });
    const isNavBarUpdated = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.hub_component_upgrade) ?? false;
    const isLoginButtonContrastGateEnabled = (0, $gdUUy.fg)('hubs_nav_login_button_contrast');
    const isLoginButtonContrastEnabled = isNavBarUpdated && isLoginButtonContrastGateEnabled;
    const isMenuStackingFixEnabled = (0, $gdUUy.fg)('hubs_nav_menu_stacking_fix');
    const isCornerRadiusEnabled = (0, $3YmaA.useIsHubCornerRadiusEnabled)();
    // A navbar-specific corner radius is Premium. Suppressing it makes the navbar
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    // Only the gated path is neutralised: the legacy path below has no hub-wide
    // value to fall back to, so it keeps applying the saved radius.
    const isCornerRadiusLocked = (0, $cp3Es.useShouldShowPremiumUpsell)();
    const shouldShowMobileNavLinks = isNavBarUpdated && isBelowSm;
    const dynamicStyle = (0, $bSJIT.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`;
        // Gate ON: always drive from the hub-wide CSS var; pin it locally only when
        // this navbar has an explicit numeric radius, otherwise inherit the global.
        // Gate OFF: legacy fixed px (cornerRadius is always a number here).
        const cornerRadiusStyle = isCornerRadiusEnabled ? {
            borderRadius: navStyle.padding ? `var(${0, $kyaby.HUB_CORNER_RADIUS_CSS_VAR})` : '0',
            ...!isCornerRadiusLocked && navStyle.padding && typeof navStyle.cornerRadius === 'number' ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                [(0, $kyaby.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $kyaby.resolveHubCornerRadius)(navStyle.cornerRadius)}px`
            } : {}
        } : // Gate OFF: legacy fixed px. `cornerRadius` is typed `number | null`; if an
        // unset (null) value ever reaches this branch, fall back to the legacy
        // 8px default (matching the mapper's gate-off coercion) rather than
        // rendering an invalid "nullpx".
        {
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius ?? 8}px` : '0'
        };
        // Fixed ("Fixed to top") navbar layout differs by cohort.
        const fixedNavLayoutStyle = isViewportSticky ? {
            // The shell wraps padded fixed navbars in a sticky, background-covered
            // container in view mode. That wrapper owns the top gap so it cannot
            // scroll away; don't add a second offset or margin to the navbar.
            top: '0px'
        } : {
            // Legacy: sticky offset provides the top gap and a low z-index.
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            // Gate ON: z-index lives in `styles.navbarStacking`; an inline one would override it.
            zIndex: !isMenuStackingFixEnabled && navStyle.fixedAtTop ? 1 : undefined,
            marginTop: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined
        };
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navTextColor,
            ...cornerRadiusStyle,
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            ...fixedNavLayoutStyle,
            marginLeft: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginRight: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            // The padded sticky wrapper owns the bottom gap in view mode, keeping
            // that spacing outside its background-covered area while scrolling.
            marginBottom: isViewportSticky && navStyle.padding ? 0 : "var(--ds-space-300, 24px)",
            transition: 'margin 0.3s ease, border-radius 0.3s ease, top 0.3s ease'
        };
    }, [
        navStyle,
        navTextColor,
        isCornerRadiusEnabled,
        isCornerRadiusLocked,
        isMenuStackingFixEnabled,
        isViewportSticky
    ]);
    const iconColor = isNavBarUpdated ? navTextColor : undefined;
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderCustomNavActions: renderCustomNavActions, renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = ((_hubContext$layout = hubContext.layout) === null || _hubContext$layout === void 0 ? void 0 : _hubContext$layout.isAnonymousRoute) || false;
    const homePath = isAnonymousRoute ? '/user/login' : '/';
    const isHomeLinkHrefEnabled = (0, $gdUUy.fg)('csm_support_site_home_link_href');
    const handleHomeClick = (0, $bSJIT.useCallback)((event)=>{
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || 'button' in event && event.button !== 0) return;
        // Keep router navigation relative; the href includes the hub base path.
        event.preventDefault();
        push(homePath);
    }, [
        homePath,
        push
    ]);
    const handleInboxClick = (0, $bSJIT.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $bSJIT.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $bSJIT.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    const handleHamburgerClick = (0, $bSJIT.useCallback)(()=>{
        setIsMobileMenuOpen(true);
    }, []);
    const handleMobileMenuClose = (0, $bSJIT.useCallback)(()=>{
        setIsMobileMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        ref: navbarRef,
        "data-testId": "navbar",
        ...isEditMode && (0, $gdUUy.fg)('hubs-disable-navbar-edit-focus') ? {
            inert: ''
        } : {},
        xcss: (0, $jDsoo.cx)((isMenuStackingFixEnabled || isViewportSticky) && $d2acca5eddbe354b$var$styles.navbarStacking, isNavBarUpdated ? $d2acca5eddbe354b$var$styles.navbarUpdated : $d2acca5eddbe354b$var$styles.navbar, isEditMode && $d2acca5eddbe354b$var$styles.navBarDisabled),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic navigation styles from context
        style: isNavBarUpdated ? dynamicStyle : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6X9z7.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $d2acca5eddbe354b$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3rmIb.default), {
        to: homePath,
        ...isHomeLinkHrefEnabled ? {
            href: `${hubContext.env.relativeBaseUrl.replace(/\/$/, '')}${homePath}`,
            onClick: handleHomeClick
        } : {}
    }, logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
        height: (0, $19qNx.getHubLogoHeight)(hubType),
        src: logoUrl,
        alt: formatMessage((0, $gKSNc.default).hubLogo)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($flsxn))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $gKSNc.default).hubLogo),
        color: navTextColor
    }))), !isAnonymousRoute && email && isNavBarUpdated && !isBelowSm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c6lL1.NavLinks), {
        textColor: navTextColor,
        backgroundColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.backgroundColor
    }), !isAnonymousRoute && email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $d2acca5eddbe354b$var$styles.rightSection
    }, !isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, renderRightNavActions && renderRightNavActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d9bXQ))), {
                ...iconProps,
                color: iconColor
            }),
        label: "User requests",
        onClick: handleInboxClick
    })), shouldShowMobileNavLinks ? isMobileMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $gKSNc.default).closeMenu),
        onClick: handleMobileMenuClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRPcG))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $gKSNc.default).openMenu),
        onClick: handleHamburgerClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, renderCustomNavActions && renderCustomNavActions(iconColor), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5zqhO.Profile), {
                ...triggerProps,
                tooltip: "Profile and settings",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
                    appearance: "circle",
                    size: "medium",
                    src: avatarSrc
                }),
                onClick: handleProfileClick
            }),
        shouldRenderToParent: true,
        placement: "bottom-end",
        isOpen: isAvatarMenuOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $llrSd.AvatarMenu), null),
        onClose: handleAvatarMenuClose
    }))), !isAnonymousRoute && !email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3rmIb.default), {
        to: `/user/login`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic navigation text color from context
        style: isLoginButtonContrastEnabled ? {
            color: navTextColor
        } : undefined
    }, formatMessage((0, $gKSNc.default).login)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jvbf5.default), {
        appear: true
    }, isMobileMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iRdwF.default), {
        enteringAnimationXcss: $d2acca5eddbe354b$var$motionStyles.slideEntering,
        exitingAnimationXcss: $d2acca5eddbe354b$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d2acca5eddbe354b$var$MobileMenuOverlay, {
        onClose: handleMobileMenuClose,
        navbarRef: navbarRef
    })))));
};

});
parcelRegister("flsxn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebf482a6988f6298a86299ac42fdfe98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2bef41eb6c266cf$var$_react = $b2bef41eb6c266cf$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $b2bef41eb6c266cf$var$_iconNew = $b2bef41eb6c266cf$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $b2bef41eb6c266cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/home
 * Usage guidance:
 * Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2bef41eb6c266cf$var$HomeIcon = (props)=>/*#__PURE__*/ $b2bef41eb6c266cf$var$_react.default.createElement($b2bef41eb6c266cf$var$_iconNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$b2bef41eb6c266cf$var$HomeIcon.displayName = 'HomeIcon';
var $b2bef41eb6c266cf$var$_default = module.exports.default = $b2bef41eb6c266cf$var$HomeIcon;

});

parcelRegister("gRPcG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::113cd4523810e6c9fe05d0e52a1ca1f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c479508bc7dc217b$var$_react = $c479508bc7dc217b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c479508bc7dc217b$var$_iconNew = $c479508bc7dc217b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c479508bc7dc217b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/menu
 * Usage guidance:
 * Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c479508bc7dc217b$var$MenuIcon = (props)=>/*#__PURE__*/ $c479508bc7dc217b$var$_react.default.createElement($c479508bc7dc217b$var$_iconNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$c479508bc7dc217b$var$MenuIcon.displayName = 'MenuIcon';
var $c479508bc7dc217b$var$_default = module.exports.default = $c479508bc7dc217b$var$MenuIcon;

});

parcelRegister("k8QkJ", function(module, exports) {
$parcel$export(module.exports, "useHubAutoTextColor", () => $b40547cd0df839c2$export$fe15218ae47525c4);

var $bSJIT = parcelRequire("bSJIT");

var $dsKYd = parcelRequire("dsKYd");

var $398AO = parcelRequire("398AO");

var $7N1GW = parcelRequire("7N1GW");
const $b40547cd0df839c2$export$fe15218ae47525c4 = (packageName)=>{
    const theming = (0, $dsKYd.useHubTheming)();
    const isAutoTextColorEnabled = (0, $7N1GW.useIsHubAutoTextColorEnabled)();
    const isEnabled = Boolean(isAutoTextColorEnabled && (theming === null || theming === void 0 ? void 0 : theming.isAdvancedThemingEnabled) && theming.palette);
    const palette = theming === null || theming === void 0 ? void 0 : theming.palette;
    const primaryColor = theming === null || theming === void 0 ? void 0 : theming.primaryColor;
    const isBrandPaletteLocked = theming === null || theming === void 0 ? void 0 : theming.isBrandPaletteLocked;
    return (0, $bSJIT.useCallback)(({ backgroundColor: backgroundColor, textColor: textColor, defaultRef: defaultRef })=>{
        if (!isEnabled || !palette || !primaryColor) return textColor;
        return (0, $398AO.resolveHubAutoTextColor)({
            backgroundColor: backgroundColor,
            textColor: textColor,
            defaultRef: defaultRef,
            palette: palette,
            primaryColor: primaryColor,
            isBrandPaletteLocked: isBrandPaletteLocked,
            packageName: packageName
        });
    }, [
        isEnabled,
        palette,
        primaryColor,
        isBrandPaletteLocked,
        packageName
    ]);
};

});
parcelRegister("398AO", function(module, exports) {
$parcel$export(module.exports, "resolveHubAutoTextColor", () => $4ca65c9bfa34f961$export$adb108b39d52b18e);

var $9oG22 = parcelRequire("9oG22");

var $awIwb = parcelRequire("awIwb");
const $4ca65c9bfa34f961$export$adb108b39d52b18e = ({ backgroundColor: backgroundColor, textColor: textColor, defaultRef: defaultRef, palette: palette, primaryColor: primaryColor, isBrandPaletteLocked: isBrandPaletteLocked = false, packageName: packageName })=>{
    // An unstored background means the element is painting its default, and the
    // default differs by tier: Free/Standard renders `var(--hub-primary-color)`
    // (the brand colour) while Premium renders the element's palette shade. Using
    // the shade for a locked tenant would measure text against a light tint while
    // the element actually paints the full brand colour — inverting the result for
    // any dark brand. Mirrors `getHubDefaultParameters`'s locked branch.
    if (!backgroundColor) return (0, $awIwb.resolveAutoTextColor)({
        textColor: textColor,
        backgroundHex: isBrandPaletteLocked ? primaryColor : palette[defaultRef],
        packageName: packageName
    });
    const backgroundHex = (0, $9oG22.resolveAdfColorForPicker)(backgroundColor, palette, defaultRef, primaryColor, primaryColor);
    return (0, $awIwb.resolveAutoTextColor)({
        textColor: textColor,
        backgroundHex: backgroundHex,
        packageName: packageName
    });
};

});
parcelRegister("9oG22", function(module, exports) {
$parcel$export(module.exports, "resolveAdfColor", () => $596549fc9a60056c$export$e3e100f3579bc61);
$parcel$export(module.exports, "resolveAdfColorForPicker", () => $596549fc9a60056c$export$9fcb237afadfd602);
/**
 * Pure runtime resolver for per-element ADF color attributes.
 *
 * **Renderer path (`resolveAdfColor`)** — returns a CSS string the renderer
 * can drop straight into an inline `style`:
 *
 *   • A `var(--hub-color-primary-200)` reference for palette-tracked values
 *     and the day-0 default — the browser cascade resolves these against the
 *     wrapper div emitted by `<HubThemingProvider>`, so brand-color edits
 *     repaint without any React render or JS palette lookup.
 *   • A literal hex (`#FF8B00`) for custom-hex overrides — frozen, won't
 *     track future brand-color edits.
 *
 * **Picker path (`resolveAdfColorForPicker`)** — returns a hex literal so AK
 * `<ColorPicker>` can match against its `knownColors` and highlight the right
 * swatch. The picker can't reverse-look up `var(--hub-...)` strings.
 *
 * Input grammar (both paths):
 *
 *   1. null / undefined                       → day-0 default
 *   2. { custom: hex }                        → custom literal (frozen)
 *   3. `var(--hub-color-primary-200)` string  → palette-tracked (primary form)
 *   4. `"primary.200"` string                 → legacy alias → palette-tracked
 *                                               (kept so ADFs written before
 *                                               the var-ref switch keep working)
 *   5. legacy `var(--hub-primary-color, ...)` → day-0 default (pre-v2 ADF)
 *   6. plain string (raw hex / anything else) → as-is (forward-compat)
 *
 * Pure, synchronous, no side effects → SSR-safe.
 */ 
var $Cc5Nl = parcelRequire("Cc5Nl");
const $596549fc9a60056c$var$PALETTE_REF_PATTERN = /^(primary|accent)\.(100|200|300|400|500|600|700|800|900|1000)$/;
// Matches the canonical `var(--hub-color-{family}-{shade})` form with an
// optional `, <fallback>` segment (a hex snapshot that lets the value resolve
// even outside the wrapper — see `toAdfColor`).
const $596549fc9a60056c$var$HUB_COLOR_VAR_PATTERN = /^var\(--hub-color-(primary|accent)-(100|200|300|400|500|600|700|800|900|1000)(?:,\s*[^)]+)?\)$/;
const $596549fc9a60056c$var$LEGACY_HUB_VAR_PATTERN = /^var\(--hub-primary-/;
// `--hub-primary-color` carries the brand colour itself, whereas
// `--hub-primary-text-color` / `--hub-primary-link-color` carry values *derived*
// from it. Premium-locked picks persist the former (see `toAdfColor`), so the
// picker has to resolve it to the live brand colour rather than to the
// readable-text fallback its callers supply for the derived vars.
const $596549fc9a60056c$var$HUB_PRIMARY_COLOR_VAR_PATTERN = /^var\(--hub-primary-color\s*[,)]/;
const $596549fc9a60056c$var$isPaletteRef = (value)=>$596549fc9a60056c$var$PALETTE_REF_PATTERN.test(value);
const $596549fc9a60056c$var$isHubColorVarRef = (value)=>$596549fc9a60056c$var$HUB_COLOR_VAR_PATTERN.test(value);
const $596549fc9a60056c$var$isLegacyHubVarRef = (value)=>$596549fc9a60056c$var$LEGACY_HUB_VAR_PATTERN.test(value);
const $596549fc9a60056c$var$isHubPrimaryColorVarRef = (value)=>$596549fc9a60056c$var$HUB_PRIMARY_COLOR_VAR_PATTERN.test(value);
const $596549fc9a60056c$var$cssVarFor = (ref)=>`var(${(0, $Cc5Nl.HUB_COLOR_CSS_VARS)[ref]})`;
/**
 * Extracts the `PaletteRef` carried by a `var(--hub-color-{family}-{shade})`
 * reference string, e.g. `var(--hub-color-primary-200)` → `'primary.200'`.
 * Returns `null` if the string is not a recognised hub-color var ref.
 *
 * Used by the picker path to reverse-look up a swatch hex from a stored var
 * reference.
 */ const $596549fc9a60056c$var$paletteRefFromVar = (value)=>{
    const match = value.match($596549fc9a60056c$var$HUB_COLOR_VAR_PATTERN);
    if (!match) return null;
    return `${match[1]}.${match[2]}`;
};
const $596549fc9a60056c$export$e3e100f3579bc61 = (value, defaultRef)=>{
    if (value == null) return $596549fc9a60056c$var$cssVarFor(defaultRef);
    if (typeof value === 'object') return value.custom;
    if ($596549fc9a60056c$var$isHubColorVarRef(value)) // Primary form — already a `var(--hub-color-...)` ref. Pass through.
    return value;
    if ($596549fc9a60056c$var$isPaletteRef(value)) // Legacy ADFs written before the var-ref switch persisted bare
    // PaletteRef strings like `"primary.200"`. Map forward.
    return $596549fc9a60056c$var$cssVarFor(value);
    if ($596549fc9a60056c$var$isLegacyHubVarRef(value)) // Pre-v2 ADF pointing at the legacy `--hub-primary-color` /
    // `--hub-primary-text-color` / `--hub-primary-link-color` chain.
    // `HubThemingProvider` keeps these vars defined on the wrapper with
    // the same values `setHubBrandingStyle` used to write to `<html>`, so
    // we forward the legacy ref verbatim — the browser cascade resolves it
    // to the admin's exact pre-v2 color. Critically we do NOT rewrite to a
    // palette shade (e.g. `primary.200`); the admin's input hex is not at
    // a fixed ramp position so any rewrite would visually drift colors for
    // already-customised hubs.
    return value;
    // Forward-compat: raw hex literals or any other string passed through.
    return value;
};
const $596549fc9a60056c$export$9fcb237afadfd602 = (value, palette, defaultRef, legacyFallback, brandPrimaryColor)=>{
    if (value == null) return palette[defaultRef];
    if (typeof value === 'object') return value.custom;
    if ($596549fc9a60056c$var$isHubColorVarRef(value)) {
        const ref = $596549fc9a60056c$var$paletteRefFromVar(value);
        return ref ? palette[ref] : palette[defaultRef];
    }
    if ($596549fc9a60056c$var$isPaletteRef(value)) return palette[value];
    if ($596549fc9a60056c$var$isHubPrimaryColorVarRef(value)) // `--hub-primary-color` resolves at runtime to the admin's exact brand
    // hex on the wrapper, so the picker must show that same colour to stay
    // in sync with the canvas. Text-ish callers supply a readable
    // black/white as `legacyFallback`, which is wrong here — prefer the
    // explicit brand colour, then `legacyFallback` (background pickers pass
    // the brand colour there already), then the element default.
    return brandPrimaryColor ?? legacyFallback ?? palette[defaultRef];
    if ($596549fc9a60056c$var$isLegacyHubVarRef(value)) // Pre-v2 ADF pointing at the derived `--hub-primary-text-color` /
    // `--hub-primary-link-color` chain. Returning the caller's
    // `legacyFallback` lets the picker match it against its swatch grid and
    // highlight the right circle, keeping the picker UI in sync with the
    // rendered colour. Falls back to the element default when not passed.
    return legacyFallback ?? palette[defaultRef];
    return value;
};

});

parcelRegister("awIwb", function(module, exports) {
$parcel$export(module.exports, "resolveAutoTextColor", () => $4adc382d511004c5$export$8c188c8e25fd5636);

var $7hQVc = parcelRequire("7hQVc");

var $d2gH4 = parcelRequire("d2gH4");

var $2wZhY = parcelRequire("2wZhY");
const $4adc382d511004c5$var$HEX = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const $4adc382d511004c5$export$8c188c8e25fd5636 = ({ textColor: textColor, backgroundHex: backgroundHex, packageName: packageName })=>{
    if (!(0, $2wZhY.isAutoManagedTextColor)(textColor)) return textColor;
    // Only derive when the background actually resolved to a colour we can
    // measure. `readableTextColor` swallows a failure and returns `color.text`,
    // so an unresolvable background would silently flip white text to dark — on
    // a dark surface that is worse than leaving the stored value alone. Happens
    // for a value the palette cannot resolve: an unrecognised token with no
    // fallback hex, or a var read during SSR where there is no computed style.
    if (!$4adc382d511004c5$var$HEX.test((0, $7hQVc.toHexColor)(backgroundHex).trim())) return textColor;
    return (0, $d2gH4.readableTextColor)(backgroundHex, packageName);
};

});
parcelRegister("2wZhY", function(module, exports) {
$parcel$export(module.exports, "isAutoManagedTextColor", () => $59c09c4be47d1273$export$999aa00a54e0cddc);

var $7hQVc = parcelRequire("7hQVc");
/**
 * Whether a stored text colour is one this system may re-derive.
 *
 * The distinction is **seeded default vs admin choice**, and the two are told
 * apart by their *shape*:
 *
 *   • **Auto-managed** — a design-token reference. Every element manifest seeds
 *     `token('color.text')` / `token('color.text.inverse')`, i.e.
 *     `var(--ds-text, …)` / `var(--ds-text-inverse, …)`, and the legacy
 *     `--hub-primary-text-color` var is itself a readable black/white. Nothing
 *     stored counts too — the element is showing a derived default.
 *   • **Explicit** — anything else, including a bare `#FFFFFF` or `#000000`.
 *
 * That split matters because the colour picker emits a **raw hex**: its
 * `knownColors` are lowercased literals (see `createBuiltInColorMap`), so
 * choosing the white swatch stores `#ffffff` while the seeded white is
 * `var(--ds-text-inverse, …)`. Treating a bare hex as auto-managed made an
 * explicitly chosen white unusable — it was immediately re-derived back to dark
 * on a light background, so the pick appeared not to apply at all.
 *
 * Matching is done on the *string*, never through `extractColorCode`, because
 * that resolves vars against `document.documentElement` — where the hub
 * palette does not live (the provider emits it on its own wrapper div), so it
 * silently yields `''` and every comparison collapses to black.
 */ const $59c09c4be47d1273$var$AUTO_MANAGED_TOKENS = new Set([
    '--ds-text',
    '--ds-text-inverse',
    '--hub-primary-text-color'
]);
const $59c09c4be47d1273$export$999aa00a54e0cddc = (value)=>{
    const trimmed = value === null || value === void 0 ? void 0 : value.trim();
    if (!trimmed) // Nothing stored means the element is showing a derived default, which is
    // exactly the case we want to keep deriving.
    return true;
    // `extractToken` returns the custom-property name for a `var(...)` string and
    // the input untouched otherwise, so this covers both token and var forms
    // without touching the DOM.
    return $59c09c4be47d1273$var$AUTO_MANAGED_TOKENS.has((0, $7hQVc.extractToken)(trimmed));
};

});



parcelRegister("7N1GW", function(module, exports) {
$parcel$export(module.exports, "useIsHubAutoTextColorEnabled", () => $dd6efc28a2e943ba$export$41c42fd5c71e0872);

var $bSJIT = parcelRequire("bSJIT");

var $hJs5J = parcelRequire("hJs5J");
const $dd6efc28a2e943ba$export$41c42fd5c71e0872 = ()=>{
    const ctx = (0, $bSJIT.useContext)((0, $hJs5J.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub).
    return false;
    if (ctx.hubType !== 'HELP_HUB') // Customer Service hubs keep their existing colours untouched.
    return false;
    return true;
};

});


parcelRegister("19qNx", function(module, exports) {
$parcel$export(module.exports, "getHubLogoHeight", () => $de0ccb336f2c66ce$export$8eeba3862e4455cf);

var $53RlD = parcelRequire("53RlD");
const $de0ccb336f2c66ce$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $53RlD.HUB_LOGO_HEIGHT;
    // CSM hubs always use new height
    if (hubType === 'CUSTOMER_SERVICE') return 0, $53RlD.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for other hub types
    return 0, $53RlD.HUB_LOGO_HEIGHT_LEGACY;
};

});

parcelRegister("llrSd", function(module, exports) {
$parcel$export(module.exports, "AvatarMenu", () => $8697a34923bcf981$export$f7f58290278dd286);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");
var $h1bGI = parcelRequire("h1bGI");

var $kpgiw = parcelRequire("kpgiw");

var $cjQhO = parcelRequire("cjQhO");

var $682kQ = parcelRequire("682kQ");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $gdUUy = parcelRequire("gdUUy");

var $di68S = parcelRequire("di68S");

var $hJs5J = parcelRequire("hJs5J");

var $hleDl = parcelRequire("hleDl");

var $4mWMl = parcelRequire("4mWMl");
const $8697a34923bcf981$var$styles = {
    menu: "_1bsbnpok"
};
const $8697a34923bcf981$export$f7f58290278dd286 = ()=>{
    const hubContext = (0, $hJs5J.useHubContext)();
    const [{ match: match }] = (0, $h1bGI.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const shouldUseConsumerAvatarMenu = (0, $gdUUy.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = (0, $gdUUy.fg)('csm_appification_standalone_navigation') ? `${cloudUrl}/jira/customer-service-management/experiences/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}` : `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $8697a34923bcf981$var$styles.menu
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $65Fe1.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $7LtMZ.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $hleDl.AccountDetails), null)), consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ $bSJIT.createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $682kQ.default), {
        href: csmEditorUrl,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $4mWMl.default).editSite))), /*#__PURE__*/ $bSJIT.createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cjQhO.default), {
        component: (0, $gdUUy.fg)('jsm_help_extension_link_href_base_fix') ? (0, $di68S.default) : (0, $3rmIb.default),
        to: `/user/profile`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $4mWMl.default).profile)), /*#__PURE__*/ $bSJIT.createElement((0, $kpgiw.default), {
        onClick: onLogoutClick
    }, formatMessage((0, $4mWMl.default).logout)))));
};

});
parcelRegister("di68S", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ff248e957c581e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $kHwwG = parcelRequire("kHwwG");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");
var $a6Y7T = parcelRequire("a6Y7T");
const $91ff248e957c581e$export$d3010bc2e9cc1386 = (to, currentLocation)=>(0, $kHwwG.createLocation)(to, null, undefined, currentLocation);
const $91ff248e957c581e$var$isModifiedEvent = (event)=>event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
/**
 * React Resource Router does not apply the base URL when `to` is a string. because we do not pass basePath to the router, we instead pass it to the history.
 * Keep the displayed URL base-aware while navigating with the relative router location.
 */ // The server case is intentionally not handled until platform can safely access AJS metadata.
const $91ff248e957c581e$var$getHref = (history, location)=>history.createHref(location);
const $91ff248e957c581e$var$BaseUrlRespectedLink = ({ to: to, onClick: onClick, history: history, location: location, target: target, replace: replace, children: children, ...rest })=>{
    const toAsLocation = $91ff248e957c581e$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $91ff248e957c581e$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $bSJIT.useCallback)((event)=>{
        try {
            onClick === null || onClick === void 0 || onClick(event);
        } catch (error) {
            event.preventDefault();
            throw error;
        }
        const isPrimaryClick = 'button' in event && event.button === 0;
        const isEnterKey = 'key' in event && event.key === 'Enter';
        if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && (!target || target === '_self') && !$91ff248e957c581e$var$isModifiedEvent(event)) {
            event.preventDefault();
            const method = replace ? history.replace : history.push;
            method($91ff248e957c581e$export$d3010bc2e9cc1386(to, location));
        }
    }, [
        history,
        location,
        onClick,
        replace,
        target,
        to
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $3rmIb.default), {
        href: href,
        ...rest,
        target: target,
        onClick: wrappedOnClick
    }, children);
};
const $91ff248e957c581e$var$BaseUrlRespectedLinkWithRouter = (props)=>/*#__PURE__*/ $bSJIT.createElement((0, $a6Y7T.RouterSubscriber), null, (router)=>{
        const { location: location } = router;
        const { history: history } = router;
        return /*#__PURE__*/ $bSJIT.createElement($91ff248e957c581e$var$BaseUrlRespectedLink, {
            location: location,
            history: history,
            ...props
        });
    });
var $91ff248e957c581e$export$2e2bcd8739ae039 = $91ff248e957c581e$var$BaseUrlRespectedLinkWithRouter;

});

parcelRegister("hleDl", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $0b6f1ba9ba7d88af$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $JD7lD = parcelRequire("JD7lD");

var $6X9z7 = parcelRequire("6X9z7");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $hJs5J = parcelRequire("hJs5J");
const $0b6f1ba9ba7d88af$var$styles = {
    displayName: "_11c8fhey",
    root: "_ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    emailText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _1e0c1o8l _p12f1lit"
};
const $0b6f1ba9ba7d88af$export$66e04d0aacdb3b2 = ()=>{
    const { user: user } = (0, $hJs5J.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $0b6f1ba9ba7d88af$var$styles.root
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $6X9z7.Flex), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $JD7lD.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), null, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $0b6f1ba9ba7d88af$var$styles.displayName
        ])
    }, displayName), /*#__PURE__*/ $bSJIT.createElement("small", {
        className: (0, $9fU1q.default)([
            $0b6f1ba9ba7d88af$var$styles.emailText
        ])
    }, email))));
};

});

parcelRegister("4mWMl", function(module, exports) {
$parcel$export(module.exports, "default", () => $54aa337928c38043$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $54aa337928c38043$var$_default_1 = (0, $f0Pt4.defineMessages)({
    editSite: {
        id: 'hub-app-shell.avatar-menu.edit-site',
        defaultMessage: 'Edit site',
        description: 'The text is shown as a drop-down menu item in the avatar menu, allowing the site administrator to navigate to the site editing interface.'
    },
    profile: {
        id: 'hub-app-shell.avatar-menu.profile',
        defaultMessage: 'Profile',
        description: 'The text is shown as a drop-down menu item in the avatar menu, allowing the current user to navigate to their profile page.'
    },
    logout: {
        id: 'hub-app-shell.avatar-menu.logout',
        defaultMessage: 'Logout',
        description: 'The text is shown as a drop-down menu item in the avatar menu that, when clicked, signs the current user out of the application.'
    }
});
var $54aa337928c38043$export$2e2bcd8739ae039 = $54aa337928c38043$var$_default_1;

});


parcelRegister("gKSNc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a75413d5e3e263b1$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a75413d5e3e263b1$var$_default_1 = (0, $f0Pt4.defineMessages)({
    hubLogo: {
        id: 'company-hub.hub-app-shell.navbar.hub.logo',
        defaultMessage: 'Support home',
        description: 'The accessible label for the Hub logo link in the navigation bar, which navigates to the support home page when clicked.'
    },
    login: {
        id: 'company-hub.hub-app-shell.navbar.hub.log-in',
        defaultMessage: 'Log in',
        description: 'The text is shown on a button in the navigation bar that allows unauthenticated users to sign in to the help center.'
    },
    openMenu: {
        id: 'company-hub.hub-app-shell.navbar.open-menu.non-final',
        defaultMessage: 'Open navigation menu',
        description: 'The accessible label for the hamburger button in the navigation bar that opens the mobile navigation menu.'
    },
    closeMenu: {
        id: 'company-hub.hub-app-shell.navbar.close-menu.non-final',
        defaultMessage: 'Close navigation menu',
        description: 'The accessible label for the close button in the mobile navigation menu overlay that dismisses it.'
    }
});
var $a75413d5e3e263b1$export$2e2bcd8739ae039 = $a75413d5e3e263b1$var$_default_1;

});

parcelRegister("c6lL1", function(module, exports) {
$parcel$export(module.exports, "NavLinks", () => $ab4f9d5fd4069849$export$b615cd9717379c80);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $7xKCj = parcelRequire("7xKCj");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $hzFIQ = parcelRequire("hzFIQ");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $1qPbZ = parcelRequire("1qPbZ");

var $cp3Es = parcelRequire("cp3Es");

var $hJs5J = parcelRequire("hJs5J");

var $9sBp9 = parcelRequire("9sBp9");

var $lvor2 = parcelRequire("lvor2");

var $7ttxi = parcelRequire("7ttxi");

var $3jNhV = parcelRequire("3jNhV");

var $3KQ9o = parcelRequire("3KQ9o");

var $5ME90 = parcelRequire("5ME90");

var $4WQW6 = parcelRequire("4WQW6");

var $2dEKY = parcelRequire("2dEKY");
const $ab4f9d5fd4069849$var$styles = {
    countBadge: "_2rkopb1k _4t3igktf _1ul9gktf _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1aqn _syaz15cr _19bv1b66 _u5f31b66",
    siteTreeNavLinks: "_16jlkb7n _1o9zkb7n _1ul9idpf"
};
// Module-level cache so repeated mount/unmount cycles don't re-trigger the
// network request when the data has already been fetched for this hub.
// Only used when hubs_fix_rerendering_bootstrap_page_media is ON.
const $ab4f9d5fd4069849$var$requestCountCache = new Map();
const $ab4f9d5fd4069849$var$getCacheKey = (cloudUrl, helpCenterAri)=>`${cloudUrl}::${helpCenterAri}`;
const $ab4f9d5fd4069849$export$7a00ed33b23e6d4d = ()=>{
    $ab4f9d5fd4069849$var$requestCountCache.clear();
};
const $ab4f9d5fd4069849$var$NavLinkItems = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    var _data$helpCenter, _helpCenterRef$helpCe;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri, hubEditMode: hubEditMode }, featureFlags: featureFlags } = (0, $hJs5J.useHubContext)();
    const navigationBarQueryVariables = (0, $5ME90.getNavigationBarQueryVariables)({
        cloudId: cloudId,
        featureFlags: featureFlags,
        helpCenterAri: helpCenterAri,
        hubEditMode: hubEditMode
    });
    const { isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled, isTopicsEnabled: isTopicsEnabled } = navigationBarQueryVariables;
    // Folders and custom pages are Premium-only, so un-entitled tenants get no
    // entry point to them — from the site tree or the legacy More dropdown.
    const isPremiumLocked = (0, $cp3Es.useShouldShowPremiumUpsell)();
    // TODO: Use usePreloadedQuery once hub_preload_navigation_bar_query is cleaned up.
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $7xKCj.default), navigationBarQueryVariables);
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterRef = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.__typename) === 'HelpCenter' ? helpCenterById : null;
    const { isPortalsMenuHidden: isPortalsMenuHidden, isTopicsMenuHidden: isTopicsMenuHidden } = (0, $lvor2.getHiddenNavMenus)(helpCenterRef === null || helpCenterRef === void 0 || (_helpCenterRef$helpCe = helpCenterRef.helpCenterBranding) === null || _helpCenterRef$helpCe === void 0 || (_helpCenterRef$helpCe = _helpCenterRef$helpCe.navigationBar) === null || _helpCenterRef$helpCe === void 0 ? void 0 : _helpCenterRef$helpCe.hiddenMenus);
    const handleHomeClick = (0, $bSJIT.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $bSJIT.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $bSJIT.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        testId: "nav-links",
        space: "space.050",
        xcss: isConfigurableSiteTreeEnabled ? $ab4f9d5fd4069849$var$styles.siteTreeNavLinks : undefined,
        alignInline: isConfigurableSiteTreeEnabled ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: handleHomeClick,
        style: {
            color: textColor
        }
    }, formatMessage((0, $7ttxi.default).home)), !isPortalsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3KQ9o.PortalDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), isTopicsEnabled && !isTopicsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2dEKY.TopicDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: handleRequestsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $7ttxi.default).requests), requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $ab4f9d5fd4069849$var$styles.countBadge
    }, requestCount.request))), (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: handleApprovalsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $7ttxi.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $ab4f9d5fd4069849$var$styles.countBadge
    }, requestCount.pendingApprovals))), !isPremiumLocked && (isConfigurableSiteTreeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4WQW6.SiteNavigation), {
        queryRef: helpCenterRef,
        textColor: textColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3jNhV.MoreDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    })));
};
const $ab4f9d5fd4069849$export$b615cd9717379c80 = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $hJs5J.useHubContext)();
    const [requestCount, setRequestCount] = (0, $bSJIT.useState)(()=>(0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media') ? $ab4f9d5fd4069849$var$requestCountCache.get($ab4f9d5fd4069849$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null);
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media')) {
            const cacheKey = $ab4f9d5fd4069849$var$getCacheKey(cloudUrl, helpCenterAri);
            const cached = $ab4f9d5fd4069849$var$requestCountCache.get(cacheKey);
            (0, $9sBp9.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                // Always refresh both the request and approvals counts from the
                // latest API response. The Approvals tab is rendered only when
                // `approvals > 0`, so updating to a fresh value of 0 will
                // correctly remove the tab when there is nothing to show.
                const next = {
                    approvals: data.userRequestsCounts.approvalsCount,
                    pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                    request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                };
                $ab4f9d5fd4069849$var$requestCountCache.set(cacheKey, next);
                setRequestCount(next);
            }).catch(()=>{
                if (cached) // Keep showing the cached values on refresh failure.
                return;
                // fallback count to zero if request count API fails on first load
                const fallback = {
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                };
                $ab4f9d5fd4069849$var$requestCountCache.set(cacheKey, fallback);
                setRequestCount(fallback);
            });
        } else (0, $9sBp9.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
            setRequestCount({
                approvals: data.userRequestsCounts.approvalsCount,
                pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                pendingApprovals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "nav-links-loader"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ab4f9d5fd4069849$var$NavLinkItems, {
        textColor: textColor,
        backgroundColor: backgroundColor,
        requestCount: requestCount
    }));
};

});
parcelRegister("7xKCj", function(module, exports) {
$parcel$export(module.exports, "default", () => $60e03a653d4aad5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4bed07e061999ed9f22a55e1b1401214>>
 * @relayHash 9167ad897bae8a64894ef8308ea351f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bd4ffde441f81fd5ca2ec83f6bbb63d9b154db45cf924d5ae6ad4da647ebd7c
const $60e03a653d4aad5c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfigurableSiteTreeEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideNavMenusEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTopicsEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "portalsFilter",
            "variableName": "portalsFilter"
        }
    ], v11 = {
        "condition": "isHideNavMenusEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hiddenMenus"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v14 = [
        v12 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": v13 /*: any*/ 
        }
    ], v15 = {
        "kind": "InlineFragment",
        "selections": v14 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "moreDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "siteNavigation_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "topicPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "TOPIC"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "customPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "CUSTOM"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterSiteTree",
                                                    "kind": "LinkedField",
                                                    "name": "siteTree",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterFolder",
                                                            "kind": "LinkedField",
                                                            "name": "root",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contents",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpCenterFolderName",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "name",
                                                                                            "plural": false,
                                                                                            "selections": v13 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "contents",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "nodes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v15 /*: any*/ ,
                                                                                                        v16 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpCenterFolder"
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7bd4ffde441f81fd5ca2ec83f6bbb63d9b154db45cf924d5ae6ad4da647ebd7c",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$60e03a653d4aad5c$var$node.hash = "b335d58b621eacf12959f6864e39f900";
var $60e03a653d4aad5c$export$2e2bcd8739ae039 = $60e03a653d4aad5c$var$node;

});

parcelRegister("9sBp9", function(module, exports) {
$parcel$export(module.exports, "getRequestCount", () => $3ca5acd94e88555f$export$9aabeb09177df765);
const $3ca5acd94e88555f$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $3ca5acd94e88555f$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$3ca5acd94e88555f$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};

});

parcelRegister("lvor2", function(module, exports) {
$parcel$export(module.exports, "isHideNavMenusEnabled", () => $ccc58694ba0cee0b$export$d80475e2e9574bf6);
$parcel$export(module.exports, "getHiddenNavMenus", () => $ccc58694ba0cee0b$export$b56f2ad6d9942cbc);

var $gdUUy = parcelRequire("gdUUy");
const $ccc58694ba0cee0b$export$d80475e2e9574bf6 = ()=>(0, $gdUUy.fg)('help_hubs_hide_nav_menus');
const $ccc58694ba0cee0b$export$b56f2ad6d9942cbc = (hiddenMenus)=>{
    const hidden = $ccc58694ba0cee0b$export$d80475e2e9574bf6() ? hiddenMenus ?? [] : [];
    return {
        isPortalsMenuHidden: hidden.includes('PORTALS'),
        isTopicsMenuHidden: hidden.includes('TOPICS')
    };
};

});

parcelRegister("7ttxi", function(module, exports) {
$parcel$export(module.exports, "default", () => $32b74fd23f73ad3a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $32b74fd23f73ad3a$var$messages = (0, $f0Pt4.defineMessages)({
    downIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.down-icon',
        defaultMessage: 'Open dropdown',
        description: 'Accessible label for the chevron-down icon button in the company hub navbar that opens a navigation dropdown.'
    },
    home: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.home',
        defaultMessage: 'Home',
        description: 'Text shown as the Home navigation link in the company hub top navbar, taking users to the hub home page.'
    },
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more',
        defaultMessage: 'More',
        description: 'Text shown as the More navigation link in the company hub top navbar, opening a dropdown with additional custom pages.'
    },
    openFolderSubmenu: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.openFolderSubmenu',
        defaultMessage: 'Open folder',
        description: 'Accessible label for the chevron-right icon on a nested folder row in the site navigation More menu.'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals page'
    },
    requests: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.requests',
        defaultMessage: 'Requests',
        description: 'Text shown as the Requests navigation link in the company hub top navbar, taking users to their submitted support requests.'
    },
    approvals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.approvals',
        defaultMessage: 'Approvals',
        description: 'Navigation link label for user approvals'
    }
});
var $32b74fd23f73ad3a$export$2e2bcd8739ae039 = $32b74fd23f73ad3a$var$messages;

});

parcelRegister("3jNhV", function(module, exports) {
$parcel$export(module.exports, "MoreDropdown", () => $8d1f3041aca8e998$export$6d7fd1d1521d3638);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $95mUc = parcelRequire("95mUc");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $hzFIQ = parcelRequire("hzFIQ");

var $lkSXl = parcelRequire("lkSXl");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $4GWyU = parcelRequire("4GWyU");

var $8yxPv = parcelRequire("8yxPv");

var $emsU2 = parcelRequire("emsU2");

var $kpgiw = parcelRequire("kpgiw");

var $7LtMZ = parcelRequire("7LtMZ");

var $iRdwF = parcelRequire("iRdwF");

var $jvbf5 = parcelRequire("jvbf5");

var $aRsbV = parcelRequire("aRsbV");

var $hwpKw = parcelRequire("hwpKw");

var $kG7gw = parcelRequire("kG7gw");
const $8d1f3041aca8e998$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $8d1f3041aca8e998$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $8d1f3041aca8e998$export$6d7fd1d1521d3638 = ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $bSJIT.useState)(false);
    const data = (0, $a2qIF.useFragment)((0, $95mUc.default), queryRef);
    const customPages = data === null || data === void 0 ? void 0 : data.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8yxPv))), {
            label: formatMessage((0, $kG7gw.default).moreUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            label: formatMessage((0, $kG7gw.default).moreDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.default), {
        weight: "medium"
    }, formatMessage((0, $kG7gw.default).more))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $8d1f3041aca8e998$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jvbf5.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iRdwF.default), {
        enteringAnimationXcss: $8d1f3041aca8e998$var$motionStyles.slideEntering,
        exitingAnimationXcss: $8d1f3041aca8e998$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "more-dropdown-items",
        className: (0, $9fU1q.default)([
            $8d1f3041aca8e998$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, customPages.map((page)=>{
        var _page$name;
        const pageId = page !== null && page !== void 0 && page.id ? (0, $hwpKw.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page === null || page === void 0 || (_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default);
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                    label: formatMessage((0, $kG7gw.default).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $kG7gw.default).more)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, customPages.map((page)=>{
        var _page$name2;
        const pageId = page !== null && page !== void 0 && page.id ? (0, $hwpKw.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: formatMessage((0, $kG7gw.default).pageIconLabel)
            }),
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page === null || page === void 0 || (_page$name2 = page.name) === null || _page$name2 === void 0 ? void 0 : _page$name2.default);
    })));
};

});
parcelRegister("95mUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed7b8e974e628972$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b420321b8f0e6761b0f1e413d38c4e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed7b8e974e628972$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$ed7b8e974e628972$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $ed7b8e974e628972$export$2e2bcd8739ae039 = $ed7b8e974e628972$var$node;

});

parcelRegister("kG7gw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9723f983ea3679d2$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $9723f983ea3679d2$var$messages = (0, $f0Pt4.defineMessages)({
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more',
        defaultMessage: 'More',
        description: 'Navigation link label for the more dropdown showing custom pages'
    },
    moreDownIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-down',
        defaultMessage: 'Open more dropdown',
        description: 'Accessible label for the chevron-down icon button in the company hub navbar that opens the More navigation dropdown listing custom pages.'
    },
    moreUpIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-up',
        defaultMessage: 'Close more dropdown',
        description: 'Accessible label for the chevron-up icon button in the mobile navigation menu that closes the More accordion listing custom pages.'
    },
    pageIconLabel: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label',
        defaultMessage: 'Page icon',
        description: 'Label for the page icon in the more dropdown'
    }
});
var $9723f983ea3679d2$export$2e2bcd8739ae039 = $9723f983ea3679d2$var$messages;

});


parcelRegister("3KQ9o", function(module, exports) {
$parcel$export(module.exports, "PortalDropdown", () => $1dec5a32b66a84f4$export$32e0c0d1c2f88773);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $200sx = parcelRequire("200sx");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $hzFIQ = parcelRequire("hzFIQ");

var $lkSXl = parcelRequire("lkSXl");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $4GWyU = parcelRequire("4GWyU");

var $8yxPv = parcelRequire("8yxPv");

var $emsU2 = parcelRequire("emsU2");

var $kpgiw = parcelRequire("kpgiw");

var $7LtMZ = parcelRequire("7LtMZ");

var $iRdwF = parcelRequire("iRdwF");

var $jvbf5 = parcelRequire("jvbf5");

var $aRsbV = parcelRequire("aRsbV");

var $dez4z = parcelRequire("dez4z");

var $9G0Ji = parcelRequire("9G0Ji");

var $5ME90 = parcelRequire("5ME90");
const $1dec5a32b66a84f4$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $1dec5a32b66a84f4$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $1dec5a32b66a84f4$export$32e0c0d1c2f88773 = ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    var _data$portals;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $bSJIT.useState)(false);
    const [isConfigurableSiteTreeEnabled] = (0, $dez4z.useIsHubFeatureEnabled)([
        (0, $dez4z.HUB_FEATURES).CONFIGURABLE_SITE_TREE
    ]);
    const data = (0, $a2qIF.useFragment)((0, $200sx.default), queryRef);
    const portalPages = data === null || data === void 0 || (_data$portals = data.portals) === null || _data$portals === void 0 ? void 0 : _data$portals.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) {
            var _portalPages$2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
                onClick: ()=>{
                    var _portalPages$;
                    push(`/portal/${(_portalPages$ = portalPages[0]) === null || _portalPages$ === void 0 ? void 0 : _portalPages$.id}`);
                }
            }, (_portalPages$2 = portalPages[0]) === null || _portalPages$2 === void 0 ? void 0 : _portalPages$2.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
            iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8yxPv))), {
                label: formatMessage((0, $9G0Ji.default).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                label: formatMessage((0, $9G0Ji.default).portalDownIcon)
            }),
            onClick: ()=>setIsExpanded((prev)=>!prev),
            "aria-expanded": isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.default), {
            weight: "medium"
        }, formatMessage((0, $9G0Ji.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            className: (0, $9fU1q.default)([
                $1dec5a32b66a84f4$var$styles.overflowHidden
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jvbf5.default), {
            appear: true
        }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iRdwF.default), {
            enteringAnimationXcss: $1dec5a32b66a84f4$var$motionStyles.slideEntering,
            exitingAnimationXcss: $1dec5a32b66a84f4$var$motionStyles.slideExiting
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            "data-testid": "portal-dropdown-items",
            className: (0, $9fU1q.default)([
                $1dec5a32b66a84f4$var$styles.dropdownItems
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, portalPages === null || portalPages === void 0 ? void 0 : portalPages.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
                key: portal === null || portal === void 0 ? void 0 : portal.id,
                onClick: ()=>{
                    push(`/portal/${portal === null || portal === void 0 ? void 0 : portal.id}`);
                }
            }, portal === null || portal === void 0 ? void 0 : portal.name))))))));
    }
    if (hasSinglePortal) {
        var _portalPages$4;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
            appearance: "subtle",
            onClick: ()=>{
                var _portalPages$3;
                push(`/portal/${(_portalPages$3 = portalPages[0]) === null || _portalPages$3 === void 0 ? void 0 : _portalPages$3.id}`);
            },
            style: {
                color: textColor
            }
        }, (_portalPages$4 = portalPages[0]) === null || _portalPages$4 === void 0 ? void 0 : _portalPages$4.name);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                    label: formatMessage((0, $9G0Ji.default).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $9G0Ji.default).portals)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, portalPages === null || portalPages === void 0 ? void 0 : portalPages.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
            key: portal === null || portal === void 0 ? void 0 : portal.id,
            onClick: ()=>{
                push(`/portal/${portal === null || portal === void 0 ? void 0 : portal.id}`);
            },
            elemBefore: isConfigurableSiteTreeEnabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: formatMessage((0, $9G0Ji.default).pageIcon)
            })
        }, portal === null || portal === void 0 ? void 0 : portal.name))));
};

});
parcelRegister("200sx", function(module, exports) {
$parcel$export(module.exports, "default", () => $668611f2ac7a1116$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d7aa09aa29354220a79c91e7d74f6e10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $668611f2ac7a1116$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "portalsFilter"
        }
    ],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "portalsFilter",
                    "variableName": "portalsFilter"
                }
            ],
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$668611f2ac7a1116$var$node.hash = "99e96001b0845815b25025bb6c70250a";
var $668611f2ac7a1116$export$2e2bcd8739ae039 = $668611f2ac7a1116$var$node;

});

parcelRegister("9G0Ji", function(module, exports) {
$parcel$export(module.exports, "default", () => $583c13c444ff0b95$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $583c13c444ff0b95$var$messages = (0, $f0Pt4.defineMessages)({
    pageIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final',
        defaultMessage: 'Page icon',
        description: 'The accessible label for the page icon displayed next to portal navigation items in the portals drop-down in the navbar.'
    },
    portalDownIcon: {
        defaultMessage: 'Open portals dropdown',
        description: 'The accessible label for the chevron-down icon on the button that opens the portals drop-down in the navbar navigation.',
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final'
    },
    portalUpIcon: {
        defaultMessage: 'Close portals dropdown',
        description: 'The accessible label for the chevron-up icon on the button that closes the portals accordion in the mobile navigation menu.',
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-up.non-final'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals dropdown'
    }
});
var $583c13c444ff0b95$export$2e2bcd8739ae039 = $583c13c444ff0b95$var$messages;

});

parcelRegister("5ME90", function(module, exports) {
$parcel$export(module.exports, "getPortalsFilter", () => $dd28c1658f04361c$export$563ca09564aae6d5);
$parcel$export(module.exports, "getNavigationBarQueryVariables", () => $dd28c1658f04361c$export$7465fb1a07d28cb3);

var $gdUUy = parcelRequire("gdUUy");

var $lvor2 = parcelRequire("lvor2");
const $dd28c1658f04361c$export$563ca09564aae6d5 = ()=>(0, $gdUUy.fg)('hubs_nav_visible_portals_filter') ? {
        typeFilter: [
            'VISIBLE'
        ]
    } : null;
const $dd28c1658f04361c$export$7465fb1a07d28cb3 = ({ cloudId: cloudId, featureFlags: featureFlags, helpCenterAri: helpCenterAri, hubEditMode: hubEditMode })=>{
    const isDraftModeEnabled = (0, $gdUUy.fg)('help_hubs_draft_mode') && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.help_hubs_draft_mode) === true;
    const isConfigurableSiteTreeEnabled = (0, $gdUUy.fg)('help_hubs_configurable_site_tree') && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.help_hubs_configurable_site_tree) === true;
    return {
        cloudId: cloudId,
        hubAri: helpCenterAri,
        isDraft: Boolean(hubEditMode) && isDraftModeEnabled,
        isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
        isHideNavMenusEnabled: (0, $lvor2.isHideNavMenusEnabled)(),
        isTopicsEnabled: (0, $gdUUy.fg)('hubs_premium_upsell'),
        portalsFilter: $dd28c1658f04361c$export$563ca09564aae6d5()
    };
};

});


parcelRegister("4WQW6", function(module, exports) {
$parcel$export(module.exports, "SiteNavigation", () => $527fcf3d33fe3560$export$42c2afabaf9bb88e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $7S1Hv = parcelRequire("7S1Hv");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $jDsoo = parcelRequire("jDsoo");

var $lkSXl = parcelRequire("lkSXl");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $4GWyU = parcelRequire("4GWyU");

var $l9Ysx = parcelRequire("l9Ysx");

var $9PwDt = parcelRequire("9PwDt");

var $gXqq0 = parcelRequire("gXqq0");

var $hwpKw = parcelRequire("hwpKw");

var $7ttxi = parcelRequire("7ttxi");

var $k3D8g = parcelRequire("k3D8g");
const $527fcf3d33fe3560$var$EMPTY_SITE_NAVIGATION_ITEMS = [];
const $527fcf3d33fe3560$var$styles = {
    centerSlot: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf _kqswh2mm",
    navItemLabel: "_1reo15vq _18m915vq _1e0c1ule _p12fuuw1 _1bto1l2s _o5721q9c",
    trigger: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrutpp _1e0c116y _vchhusvi _4cvr1h6o _gy1p1b66 _4t3iviql _bfhksm61 _k48p1wq8 _irr31dpa _1di6fcek",
    triggerSelected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp",
    measurementViewport: "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _1reo15vq _3um015vq _lcxvglyw",
    measurementRow: "_zulp1b66 _1e0c1txw _1bsb1ris"
};
const $527fcf3d33fe3560$var$NavItemLabel = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $527fcf3d33fe3560$var$styles.navItemLabel
    }, children);
const $527fcf3d33fe3560$var$NavTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(function NavTrigger({ children: children, iconLabel: iconLabel = '', isSelected: isSelected = false, showIcon: showIcon = true, textColor: textColor, truncate: truncate = false, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
        ...props,
        ref: ref,
        style: {
            color: isSelected ? undefined : textColor
        },
        xcss: (0, $jDsoo.cx)($527fcf3d33fe3560$var$styles.trigger, isSelected && $527fcf3d33fe3560$var$styles.triggerSelected)
    }, truncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavItemLabel, null, children) : children, showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
        color: "currentColor",
        label: iconLabel
    }));
});
const $527fcf3d33fe3560$var$getFolderPages = (folder)=>folder.contents.nodes.filter((node)=>node.__typename === 'HelpCenterPage');
const $527fcf3d33fe3560$var$getPageId = (page)=>{
    try {
        return (0, $hwpKw.HelpPageAri).parse(page.id).pageId;
    } catch  {
        return null;
    }
};
const $527fcf3d33fe3560$var$PageItem = ({ page: page })=>{
    var _page$name;
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const pageId = $527fcf3d33fe3560$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
        onClick: ()=>push(`/page/${pageId}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavItemLabel, null, ((_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default) ?? ''));
};
const $527fcf3d33fe3560$var$FolderMenuItems = ({ pages: pages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$PageItem, {
            key: page.id,
            page: page
        })));
const $527fcf3d33fe3560$var$PromotedFolderMenu = ({ folder: folder, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>{
            var _folder$name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $7ttxi.default).downIcon),
                ref: triggerRef,
                textColor: textColor,
                truncate: true
            }, ((_folder$name = folder.name) === null || _folder$name === void 0 ? void 0 : _folder$name.default) ?? '');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$FolderMenuItems, {
        pages: $527fcf3d33fe3560$var$getFolderPages(folder)
    }));
};
const $527fcf3d33fe3560$var$PromotedPage = ({ page: page, textColor: textColor })=>{
    var _page$name2;
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const pageId = $527fcf3d33fe3560$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavTrigger, {
        onClick: ()=>push(`/page/${pageId}`),
        showIcon: false,
        textColor: textColor,
        truncate: true
    }, ((_page$name2 = page.name) === null || _page$name2 === void 0 ? void 0 : _page$name2.default) ?? '');
};
const $527fcf3d33fe3560$var$OverflowFolderMenu = ({ folder: folder })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        placement: "right-start",
        shouldFlip: true,
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>{
            var _folder$name2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
                ...props,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
                    label: formatMessage((0, $7ttxi.default).openFolderSubmenu),
                    size: "small"
                }),
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavItemLabel, null, ((_folder$name2 = folder.name) === null || _folder$name2 === void 0 ? void 0 : _folder$name2.default) ?? ''));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$FolderMenuItems, {
        pages: $527fcf3d33fe3560$var$getFolderPages(folder)
    }));
};
const $527fcf3d33fe3560$var$OverflowItem = ({ item: item })=>item.__typename === 'HelpCenterPage' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$PageItem, {
        page: item
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$OverflowFolderMenu, {
        folder: item
    });
const $527fcf3d33fe3560$export$c14b2ae736940562 = ({ overflowItems: overflowItems, promotedItems: promotedItems, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (promotedItems.length === 0 && overflowItems.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, promotedItems.map((item)=>item.__typename === 'HelpCenterFolder' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$PromotedFolderMenu, {
            key: item.id,
            folder: item,
            textColor: textColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$PromotedPage, {
            key: item.id,
            page: item,
            textColor: textColor
        })), overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $7ttxi.default).downIcon),
                ref: triggerRef,
                testId: "site-navigation-more",
                textColor: textColor
            }, formatMessage((0, $7ttxi.default).more))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, overflowItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$OverflowItem, {
            key: item.id,
            item: item
        })))));
};
const $527fcf3d33fe3560$export$42c2afabaf9bb88e = ({ queryRef: queryRef, textColor: textColor })=>{
    var _data$siteTree;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const slotRef = (0, $bSJIT.useRef)(null);
    const measurementRowRef = (0, $bSJIT.useRef)(null);
    const data = (0, $a2qIF.useFragment)((0, $7S1Hv.default), queryRef);
    const nodes = data === null || data === void 0 || (_data$siteTree = data.siteTree) === null || _data$siteTree === void 0 || (_data$siteTree = _data$siteTree.root) === null || _data$siteTree === void 0 ? void 0 : _data$siteTree.contents.nodes;
    const items = (0, $bSJIT.useMemo)(()=>(nodes === null || nodes === void 0 ? void 0 : nodes.filter((node)=>node.__typename === 'HelpCenterPage' || node.__typename === 'HelpCenterFolder')) ?? $527fcf3d33fe3560$var$EMPTY_SITE_NAVIGATION_ITEMS, [
        nodes
    ]);
    const { overflowItems: overflowItems, promotedItems: promotedItems } = (0, $k3D8g.useSiteNavigationOverflow)({
        items: items,
        measurementRowRef: measurementRowRef,
        slotRef: slotRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        ref: slotRef,
        testId: "nav-links-center-slot",
        xcss: $527fcf3d33fe3560$var$styles.centerSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$export$c14b2ae736940562, {
        overflowItems: overflowItems,
        promotedItems: promotedItems,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        "aria-hidden": "true",
        testId: "site-navigation-measurement-viewport",
        xcss: $527fcf3d33fe3560$var$styles.measurementViewport
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        "aria-hidden": "true",
        ref: measurementRowRef,
        testId: "site-navigation-measurement-row",
        xcss: $527fcf3d33fe3560$var$styles.measurementRow
    }, items.map((item)=>{
        var _item$name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            "data-site-navigation-item-id": item.id,
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavTrigger, {
            iconLabel: "",
            tabIndex: -1,
            textColor: textColor,
            truncate: true
        }, (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.default));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        "data-site-navigation-more-item": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($527fcf3d33fe3560$var$NavTrigger, {
        iconLabel: "",
        tabIndex: -1,
        textColor: textColor
    }, formatMessage((0, $7ttxi.default).more))))));
};

});
parcelRegister("7S1Hv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a136b70c24a061b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a74aadd35812656d4f189fff568b4c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a136b70c24a061b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            v1 /*: any*/ ,
            {
                "concreteType": "HelpCenterPageName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": v2 /*: any*/ 
            }
        ],
        "type": "HelpCenterPage"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "siteNavigation_AtlassianHubAppShell",
        "selections": [
            {
                "concreteType": "HelpCenterSiteTree",
                "kind": "LinkedField",
                "name": "siteTree",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterFolder",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpCenterFolderName",
                                                        "kind": "LinkedField",
                                                        "name": "name",
                                                        "plural": false,
                                                        "selections": v2 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "contents",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v3 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "HelpCenterFolder"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
}();
$2a136b70c24a061b$var$node.hash = "758f2701bd08a1f04afa67c01cd4f843";
var $2a136b70c24a061b$export$2e2bcd8739ae039 = $2a136b70c24a061b$var$node;

});

parcelRegister("k3D8g", function(module, exports) {
$parcel$export(module.exports, "useSiteNavigationOverflow", () => $85e3f7b6314276cf$export$afacae323adcfe97);

var $bSJIT = parcelRequire("bSJIT");

var $dMMwa = parcelRequire("dMMwa");

var $iYOcL = parcelRequire("iYOcL");
const $85e3f7b6314276cf$var$getLeftoverWidth = (row, slot)=>{
    const rowWidth = row.getBoundingClientRect().width;
    const gapWidth = Number.parseFloat(window.getComputedStyle(row).columnGap) || Number.parseFloat(window.getComputedStyle(row).gap) || 0;
    const children = Array.from(row.children);
    const siblingWidth = children.filter((child)=>child !== slot).reduce((total, child)=>total + child.getBoundingClientRect().width, 0);
    const gapCount = Math.max(children.length - 1, 0);
    return rowWidth - siblingWidth - gapCount * gapWidth;
};
const $85e3f7b6314276cf$export$afacae323adcfe97 = ({ items: items, measurementRowRef: measurementRowRef, slotRef: slotRef })=>{
    const [split, setSplit] = (0, $bSJIT.useState)(()=>({
            promotedItems: [],
            overflowItems: [
                ...items
            ]
        }));
    (0, $bSJIT.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        const measurementRow = measurementRowRef.current;
        const row = slot === null || slot === void 0 ? void 0 : slot.parentElement;
        if (!slot || !measurementRow || !row) return;
        let animationFrame = null;
        let hasUsableMeasurement = false;
        const measure = ()=>{
            const itemWidths = Object.fromEntries(Array.from(measurementRow.querySelectorAll('[data-site-navigation-item-id]'), (element)=>[
                    element.getAttribute('data-site-navigation-item-id') ?? '',
                    element.getBoundingClientRect().width
                ]));
            const moreItem = measurementRow.querySelector('[data-site-navigation-more-item]');
            const gapWidth = Number.parseFloat(window.getComputedStyle(measurementRow).columnGap) || 0;
            // Centering hugs the slot, so leftover width is the row minus Home /
            // Portals / Requests (and their gaps), not the slot's own box.
            const availableWidth = $85e3f7b6314276cf$var$getLeftoverWidth(row, slot);
            // The navbar row is `display: none` until its responsive breakpoint
            // resolves, so wait until leftover width is usable.
            if (availableWidth <= 0) return;
            hasUsableMeasurement = true;
            const next = (0, $iYOcL.splitSiteNavigation)(items, {
                availableWidth: availableWidth,
                itemWidths: itemWidths,
                gapWidth: gapWidth,
                moreWidth: (moreItem === null || moreItem === void 0 ? void 0 : moreItem.getBoundingClientRect().width) ?? 0
            });
            // Deep-compare so renames (same ids, new names) still update the nav.
            setSplit((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(previous, next) ? previous : next);
        };
        // Coalesce resize callbacks after the first usable synchronous measure.
        const scheduleMeasurement = ()=>{
            if (!hasUsableMeasurement) {
                measure();
                return;
            }
            if (animationFrame === null) animationFrame = requestAnimationFrame(()=>{
                animationFrame = null;
                measure();
            });
        };
        // Measure before the browser paints so the first frame already shows the
        // correct split, rather than briefly rendering everything under More.
        measure();
        const observer = new ResizeObserver(scheduleMeasurement);
        observer.observe(row);
        observer.observe(measurementRow);
        return ()=>{
            if (animationFrame !== null) cancelAnimationFrame(animationFrame);
            observer.disconnect();
        };
    }, [
        items,
        measurementRowRef,
        slotRef
    ]);
    return split;
};

});
parcelRegister("iYOcL", function(module, exports) {
$parcel$export(module.exports, "splitSiteNavigation", () => $5ca25507edb0f9a1$export$b77a77786b18d4b);
// Allow 1px of sub-pixel rounding so the split does not flap.
const $5ca25507edb0f9a1$var$COMPARISON_TOLERANCE = 1;
const $5ca25507edb0f9a1$var$getRowWidth = ({ itemWidths: itemWidths, items: items, gapWidth: gapWidth, moreWidth: moreWidth, showMore: showMore })=>{
    const visibleItemCount = items.length + (showMore ? 1 : 0);
    const visibleGapCount = Math.max(visibleItemCount - 1, 0);
    // An unmeasured item is unfittable, so it stays in More.
    const promotedItemWidth = items.reduce((total, { id: id })=>total + (itemWidths[id] ?? Number.MAX_SAFE_INTEGER), 0);
    return promotedItemWidth + (showMore ? moreWidth : 0) + visibleGapCount * gapWidth;
};
const $5ca25507edb0f9a1$export$b77a77786b18d4b = (items, measurements)=>{
    const conservativeSplit = {
        promotedItems: [],
        overflowItems: [
            ...items
        ]
    };
    if (measurements.availableWidth === null || items.length === 0) return conservativeSplit;
    const availableWidth = measurements.availableWidth;
    const fits = (candidateItems, showMore)=>$5ca25507edb0f9a1$var$getRowWidth({
            ...measurements,
            items: candidateItems,
            showMore: showMore
        }) <= availableWidth + $5ca25507edb0f9a1$var$COMPARISON_TOLERANCE;
    // "More" is optional when every item fits.
    if (fits([
        ...items
    ], false)) return {
        promotedItems: [
            ...items
        ],
        overflowItems: []
    };
    // Reserve "More" and promote root items left to right while they still fit beside it.
    const promotedItems = [];
    for (const item of items){
        const candidateItems = [
            ...promotedItems,
            item
        ];
        if (!fits(candidateItems, true)) break;
        promotedItems.push(item);
    }
    return {
        promotedItems: promotedItems,
        overflowItems: items.slice(promotedItems.length)
    };
};

});



parcelRegister("2dEKY", function(module, exports) {
$parcel$export(module.exports, "TopicDropdown", () => $8f5572cac7063ab2$export$ffcc4c72ae603c4e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $evQaL = parcelRequire("evQaL");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $hzFIQ = parcelRequire("hzFIQ");

var $lkSXl = parcelRequire("lkSXl");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $4GWyU = parcelRequire("4GWyU");

var $8yxPv = parcelRequire("8yxPv");

var $kpgiw = parcelRequire("kpgiw");

var $7LtMZ = parcelRequire("7LtMZ");

var $iRdwF = parcelRequire("iRdwF");

var $jvbf5 = parcelRequire("jvbf5");

var $gdUUy = parcelRequire("gdUUy");

var $8aT4G = parcelRequire("8aT4G");

var $hwpKw = parcelRequire("hwpKw");

var $b9q3W = parcelRequire("b9q3W");
const $8f5572cac7063ab2$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $8f5572cac7063ab2$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $8f5572cac7063ab2$var$getPageIdFromAri = (pageAri)=>{
    try {
        return (0, $hwpKw.HelpPageAri).parse(pageAri).pageId;
    } catch  {
        return null;
    }
};
const $8f5572cac7063ab2$export$ffcc4c72ae603c4e = ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $bSJIT.useState)(false);
    const data = (0, $a2qIF.useFragment)((0, $evQaL.default), queryRef);
    const topicPages = data === null || data === void 0 ? void 0 : data.topicPages;
    // Nothing to open onto, so the menu stays out of the navbar entirely.
    if (!(0, $gdUUy.fg)('hubs_premium_upsell') || !topicPages || topicPages.length === 0) return null;
    const openTopic = (pageAri)=>{
        const pageId = pageAri ? $8f5572cac7063ab2$var$getPageIdFromAri(pageAri) : null;
        if (pageId) push(`/page/${pageId}`);
    };
    const topicTestId = (pageAri)=>`nav-topic-page-${(pageAri ? $8f5572cac7063ab2$var$getPageIdFromAri(pageAri) : null) ?? ''}`;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8yxPv))), {
            label: formatMessage((0, $b9q3W.default).topicUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            label: formatMessage((0, $b9q3W.default).topicDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        weight: "medium"
    }, formatMessage((0, $b9q3W.default).topics))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            $8f5572cac7063ab2$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jvbf5.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iRdwF.default), {
        enteringAnimationXcss: $8f5572cac7063ab2$var$motionStyles.slideEntering,
        exitingAnimationXcss: $8f5572cac7063ab2$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "topic-dropdown-items",
        className: (0, $9fU1q.default)([
            $8f5572cac7063ab2$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, topicPages.map((topic)=>{
        var _topic$name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
            key: topic === null || topic === void 0 ? void 0 : topic.id,
            testId: topicTestId(topic === null || topic === void 0 ? void 0 : topic.id),
            onClick: ()=>openTopic(topic === null || topic === void 0 ? void 0 : topic.id)
        }, (topic === null || topic === void 0 || (_topic$name = topic.name) === null || _topic$name === void 0 ? void 0 : _topic$name.default) ?? '');
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                    label: formatMessage((0, $b9q3W.default).topicDownIcon)
                }),
                ref: triggerRef,
                testId: "topic-dropdown-trigger"
            }, formatMessage((0, $b9q3W.default).topics)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, topicPages.map((topic)=>{
        var _topic$name2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
            key: topic === null || topic === void 0 ? void 0 : topic.id,
            testId: topicTestId(topic === null || topic === void 0 ? void 0 : topic.id),
            onClick: ()=>openTopic(topic === null || topic === void 0 ? void 0 : topic.id)
        }, (topic === null || topic === void 0 || (_topic$name2 = topic.name) === null || _topic$name2 === void 0 ? void 0 : _topic$name2.default) ?? '');
    })));
};

});
parcelRegister("evQaL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f295108326ec915$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0759b364a6890ded896701bb942cb0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f295108326ec915$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topicDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "topicPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "TOPIC"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
        }
    ],
    "type": "HelpCenter"
};
$7f295108326ec915$var$node.hash = "9aa0d54a463ddf69b87af168a98c5079";
var $7f295108326ec915$export$2e2bcd8739ae039 = $7f295108326ec915$var$node;

});

parcelRegister("b9q3W", function(module, exports) {
$parcel$export(module.exports, "default", () => $4031ac27ea1e68a2$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4031ac27ea1e68a2$var$messages = (0, $f0Pt4.defineMessages)({
    topics: {
        id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topics',
        defaultMessage: 'Topics',
        description: 'The label on the button that opens the topics drop-down in the help center navigation bar.'
    },
    topicDownIcon: {
        id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topicDownIcon',
        defaultMessage: 'Open topics dropdown',
        description: 'The accessible label for the chevron-down icon on the button that opens the topics drop-down in the navbar navigation.'
    },
    topicUpIcon: {
        id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topicUpIcon',
        defaultMessage: 'Close topics dropdown',
        description: 'The accessible label for the chevron-up icon on the button that closes the topics accordion in the mobile navigation menu.'
    }
});
var $4031ac27ea1e68a2$export$2e2bcd8739ae039 = $4031ac27ea1e68a2$var$messages;

});



parcelRegister("dwPUC", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1l0w8").then(()=>parcelRequire('d2nDw'));

});



parcelRegister("hHHpU", function(module, exports) {
$parcel$export(module.exports, "hubBootstrapResource", () => $aecc6bede96f6dbe$export$8ce4230d96a2a267);
$parcel$export(module.exports, "hubPageResource", () => $aecc6bede96f6dbe$export$6d8c7b8b2daae34c);
$parcel$export(module.exports, "createNavigationBarResource", () => $aecc6bede96f6dbe$export$370816537ff1c2c5);
$parcel$export(module.exports, "rovoWidgetResource", () => $aecc6bede96f6dbe$export$a727d87e333dcf6e);

var $gdUUy = parcelRequire("gdUUy");

var $c4JCQ = parcelRequire("c4JCQ");

var $dvW5v = parcelRequire("dvW5v");

var $7xKCj = parcelRequire("7xKCj");

var $5ME90 = parcelRequire("5ME90");

var $aXweJ = parcelRequire("aXweJ");

var $gK4pW = parcelRequire("gK4pW");

var $6E4tD = parcelRequire("6E4tD");

var $cPJhk = parcelRequire("cPJhk");
const $aecc6bede96f6dbe$var$getPageIdFromRouteParams = (match, routeName)=>{
    if (routeName === (0, $gK4pW.HUB_PORTAL_PAGE_ROUTE_NAME) && (0, $gdUUy.fg)('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.id || '';
};
const $aecc6bede96f6dbe$export$8ce4230d96a2a267 = (0, $cPJhk.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment, shouldAddEdgeFallbackToUnidentified: shouldAddEdgeFallbackToUnidentified })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $gK4pW.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $aecc6bede96f6dbe$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $dvW5v.mockHubRouteProps).env.cloudId && (0, $dvW5v.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $dvW5v.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $dvW5v.mockHubRouteProps).env.helpCenterAri;
        }
        const skipPageMediaConfig = (0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media');
        const edgeFallbackHeaders = shouldAddEdgeFallbackToUnidentified ? {
            'X-Edge-Fallback-To-Unidentified': 'true'
        } : undefined;
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                // Always pass `$pageAri` so the query variable is always
                // defined; when `$skipPageMediaConfig` is true the field is
                // skipped by the GraphQL `@skip` directive and the value is
                // not sent to the server.
                pageAri: (0, $cPJhk.getPageAri)(helpCenterAriDerived, pageId),
                isDraft: false,
                operationType: 'READ',
                hubEditMode: false,
                skipPageMediaConfig: // When true, the bootstrap fragment skips `pageMediaConfig`
                // (via `@skip`) so the query stays page-agnostic and is not
                // refetched on every page navigation.
                skipPageMediaConfig
            },
            query: (0, $c4JCQ.default),
            options: {
                fetchPolicy: 'store-or-network',
                ...edgeFallbackHeaders ? {
                    networkCacheConfig: {
                        metadata: {
                            headers: edgeFallbackHeaders
                        }
                    }
                } : {}
            },
            environment: relayEnvironment
        };
    }
});
const $aecc6bede96f6dbe$export$6d8c7b8b2daae34c = (0, $cPJhk.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, isHelpHub: isHelpHub, relayEnvironment: relayEnvironment })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $gK4pW.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $aecc6bede96f6dbe$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $dvW5v.mockHubRouteProps).env.cloudId && (0, $dvW5v.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $dvW5v.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $dvW5v.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                isDraft: false,
                pageAri: (0, $cPJhk.getPageAri)(helpCenterAriDerived, pageId),
                operationType: 'READ',
                includeCustomPageParents: Boolean(isHelpHub) && (route === null || route === void 0 ? void 0 : route.name) === (0, $gK4pW.HUB_CUSTOM_PAGE_ROUTE_NAME) && (0, $gdUUy.fg)('enable_hub_breadcrumbs'),
                // Gates the page-scoped `rovoConfig` selection. When false the field is not even
                // requested, so help-kosh never resolves it and no call reaches convo-ai — the
                // existing `rovoWidgetProviderQuery` path stays in sole use. Skipped unless the
                // callout banner could use the answer, which rules out CSM support sites.
                rovoConfigFromKosh: Boolean(isHelpHub) && (0, $gdUUy.fg)('hubs_rovo_config_from_kosh')
            },
            environment: relayEnvironment,
            query: (0, $6E4tD.default),
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $aecc6bede96f6dbe$export$370816537ff1c2c5 = (hubAppProps)=>(0, $cPJhk.createRelayResource)({
        getQuery: ({ route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment })=>{
            const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $gK4pW.HUB_PREVIEW_ROUTE_NAME);
            let cloudIdDerived = cloudId;
            let helpCenterAriDerived = helpCenterAri;
            if (isPreview && (0, $dvW5v.mockHubRouteProps).env.cloudId && (0, $dvW5v.mockHubRouteProps).env.helpCenterAri) {
                cloudIdDerived = (0, $dvW5v.mockHubRouteProps).env.cloudId;
                helpCenterAriDerived = (0, $dvW5v.mockHubRouteProps).env.helpCenterAri;
            }
            return {
                variables: (0, $5ME90.getNavigationBarQueryVariables)({
                    cloudId: cloudIdDerived,
                    featureFlags: hubAppProps.featureFlags,
                    helpCenterAri: helpCenterAriDerived,
                    hubEditMode: hubAppProps.env.hubEditMode
                }),
                query: (0, $7xKCj.default),
                options: {
                    fetchPolicy: 'store-or-network'
                },
                environment: relayEnvironment
            };
        }
    });
const $aecc6bede96f6dbe$export$a727d87e333dcf6e = (0, $cPJhk.createRelayResource)({
    getQuery: ({ route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $gK4pW.HUB_PREVIEW_ROUTE_NAME);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $dvW5v.mockHubRouteProps).env.cloudId && (0, $dvW5v.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $dvW5v.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $dvW5v.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                cloudIdString: cloudIdDerived,
                containerAri: helpCenterAriDerived
            },
            query: (0, $aXweJ.default),
            options: {
                fetchPolicy: 'store-or-network'
            },
            environment: relayEnvironment
        };
    }
});

});
parcelRegister("aXweJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $71c8004e885ca7ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820c13c646099ecb5149604afcca7bf3>>
 * @relayHash bb0ffcd3ee07a20a6e7bee99ae361456
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d3b7f55862392a8e7fc340c23e3564932a5de0b48b0561129e09f6c4620e8ce
const $71c8004e885ca7ad$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIdString"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCustomAgentsAvailable"
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudIdString"
        },
        {
            "kind": "Variable",
            "name": "containerAri",
            "variableName": "containerAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "AgentStudioAssistant"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rovoWidgetProviderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_widgetByContainerAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "AgentStudioWidget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rovoWidgetProviderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_widgetByContainerAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v6 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ],
                            "type": "AgentStudioWidget"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3d3b7f55862392a8e7fc340c23e3564932a5de0b48b0561129e09f6c4620e8ce",
            "metadata": {},
            "name": "rovoWidgetProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$71c8004e885ca7ad$var$node.hash = "000b7d5b220d2d981324c500d4aeab75";
var $71c8004e885ca7ad$export$2e2bcd8739ae039 = $71c8004e885ca7ad$var$node;

});

parcelRegister("gK4pW", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTE_NAME", () => $9f699a0972d87e79$export$b4255e69eefe642e);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_NAME", () => $9f699a0972d87e79$export$35619d8059a56474);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_PATH", () => $9f699a0972d87e79$export$a1b29fc86625d058);
$parcel$export(module.exports, "HUB_ROUTE_PATH", () => $9f699a0972d87e79$export$2735e29305134506);
$parcel$export(module.exports, "HUB_ROUTE_PATH_OPTIONAL_SLASH", () => $9f699a0972d87e79$export$3c60e35f1f1173cb);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_NAME", () => $9f699a0972d87e79$export$da6ac9e48027aa54);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_PATH", () => $9f699a0972d87e79$export$7815c1f7abc1c129);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_NAME", () => $9f699a0972d87e79$export$54ede43f7406f46f);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_PATH", () => $9f699a0972d87e79$export$c7f93458584dce24);
const $9f699a0972d87e79$export$b4255e69eefe642e = 'hub';
const $9f699a0972d87e79$export$35619d8059a56474 = 'hub-preview';
const $9f699a0972d87e79$export$a1b29fc86625d058 = '/s/:cloudId/hubs/:hubId/preview';
const $9f699a0972d87e79$export$2735e29305134506 = '/';
const $9f699a0972d87e79$export$3c60e35f1f1173cb = '(/)?';
const $9f699a0972d87e79$export$da6ac9e48027aa54 = 'hub-custom-page';
const $9f699a0972d87e79$export$7815c1f7abc1c129 = '/page/:id/:title?';
const $9f699a0972d87e79$export$54ede43f7406f46f = 'hub-portal-page';
const $9f699a0972d87e79$export$c7f93458584dce24 = '/portal/:portalId';

});

parcelRegister("6E4tD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae3440c76990bc94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a8fc8327bbc16797934fde2f0d46ca7>>
 * @relayHash 8a31aae7d3b8c9fde55af400f49e8a24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 51765b6bf2502b4d7d3de6aecb1717c47c8279e2b5b8bd7c763a11acfd774f5d
const $ae3440c76990bc94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCustomPageParents"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "rovoConfigFromKosh"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "pageAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        },
        {
            "kind": "Variable",
            "name": "operationType",
            "variableName": "operationType"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v10 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v11 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v12 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v17 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v18 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterNavigationBar",
                "kind": "LinkedField",
                "name": "navigationBar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "backgroundColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "borderColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "borderType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "cornerRadius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "padding"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "positionType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "textColor"
                    }
                ]
            }
        ]
    }, v19 = [
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "ids.0",
                            "variableName": "pageAri"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "ids"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "condition": "rovoConfigFromKosh",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "HelpCenterPageRovoConfig",
                "kind": "LinkedField",
                "name": "rovoConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isCustomAgentsAvailable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRovoEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "agentId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "widgetContainerAri"
                    }
                ]
            }
        ]
    }, v24 = {
        "concreteType": "HelpCenterPageLayout",
        "kind": "LinkedField",
        "name": "pageLayout",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterLayoutAdf",
                "kind": "LinkedField",
                "name": "layoutAdf",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterLayoutAdfContentConnection",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterLayoutAdfContentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "content"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "pageMediaConfig",
                                "args": v8 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "hubMediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v9 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v10 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v11 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v12 /*: any*/ ,
                                        "action": "THROW"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "args": v19 /*: any*/ ,
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "includeCustomPageParents",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterPageParentReference",
                                                            "kind": "LinkedField",
                                                            "name": "parents",
                                                            "plural": true,
                                                            "selections": [
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "pageMediaConfig",
                            "args": v8 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "args": v19 /*: any*/ ,
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "includeCustomPageParents",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterPageParentReference",
                                                            "kind": "LinkedField",
                                                            "name": "parents",
                                                            "plural": true,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v25 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v20 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "51765b6bf2502b4d7d3de6aecb1717c47c8279e2b5b8bd7c763a11acfd774f5d",
            "metadata": {},
            "name": "hubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ae3440c76990bc94$var$node.hash = "c16441ee88faaf83200addc773fa4c96";
var $ae3440c76990bc94$export$2e2bcd8739ae039 = $ae3440c76990bc94$var$node;

});

parcelRegister("cPJhk", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $d3555a907c64e495$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $d3555a907c64e495$export$42ca7b248c7aaee);
$parcel$export(module.exports, "getPageAri", () => $d3555a907c64e495$export$9e8d72642057ad79);

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");
var $hMsRa = parcelRequire("hMsRa");

var $gdUUy = parcelRequire("gdUUy");

var $9P2Zq = parcelRequire("9P2Zq");
var $hwpKw = parcelRequire("hwpKw");

var $4Y6IB = parcelRequire("4Y6IB");

var $8DSXp = parcelRequire("8DSXp");

var $4XXwT = parcelRequire("4XXwT");
function $d3555a907c64e495$var$createCacheKey(query, variables) {
    const queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
    return `relay-${queryId}-${query.params.name}-${JSON.stringify(variables ?? {})}`;
}
const $d3555a907c64e495$export$1cc887c62079ea32 = ({ getQuery: getQuery })=>(0, $iXC0o.createResource)({
        type: 'RELAY_RESOURCE_TYPE',
        getKey: (routerContext, customContext)=>{
            const { query: query, variables: variables, cacheKey: cacheKey } = getQuery(routerContext, customContext);
            return cacheKey ?? $d3555a907c64e495$var$createCacheKey(query, variables);
        },
        getData: (routerContext, customContext)=>{
            const { query: query, variables: variables, options: options, environment: environment } = getQuery(routerContext, customContext);
            if ((0, $gdUUy.fg)('hub_error_analytics_trace_id')) (0, $4XXwT.startCapturingTraceIds)(query.params.name);
            const queryReference = (0, $a2qIF.loadQuery)(environment ?? (0, $8DSXp.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__), query, variables ?? {}, options);
            return Promise.resolve(queryReference);
        }
    });
const $d3555a907c64e495$export$42ca7b248c7aaee = (resource)=>{
    const { data: queryReference } = (0, $hMsRa.useResource)(resource);
    return {
        queryReference: queryReference
    };
};
const $d3555a907c64e495$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $9P2Zq.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $d3555a907c64e495$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $d3555a907c64e495$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    const resolvedPageId = pageId || helpCenterId;
    if ((0, $4Y6IB.isPortalPage)(resolvedPageId) && helpCenterId) return (0, $4Y6IB.buildPortalPageAri)(helpCenterAri, resolvedPageId);
    return (0, $hwpKw.HelpPageAri).create({
        activationId: activationId,
        pageId: resolvedPageId
    }).toString() || '';
};

});


parcelRegister("bnjHu", function(module, exports) {
$parcel$export(module.exports, "HubApp", () => $ece34773fbef76d8$export$44db4a416180c024);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $6E4tD = parcelRequire("6E4tD");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $5zxDU = parcelRequire("5zxDU");

var $35T7J = parcelRequire("35T7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $1qPbZ = parcelRequire("1qPbZ");

var $hDkm2 = parcelRequire("hDkm2");

var $clpci = parcelRequire("clpci");

var $kxIlX = parcelRequire("kxIlX");

var $8LptA = parcelRequire("8LptA");

var $9sDkI = parcelRequire("9sDkI");

var $eJ5U1 = parcelRequire("eJ5U1");

var $bKtPK = parcelRequire("bKtPK");

var $eIwmz = parcelRequire("eIwmz");

var $hNRax = parcelRequire("hNRax");

var $4Io6U = parcelRequire("4Io6U");

var $itx7D = parcelRequire("itx7D");

var $axsoS = parcelRequire("axsoS");

var $3YmaA = parcelRequire("3YmaA");

var $hJs5J = parcelRequire("hJs5J");

var $ieP51 = parcelRequire("ieP51");

var $3nMDg = parcelRequire("3nMDg");

var $66ogx = parcelRequire("66ogx");

var $bF3ON = parcelRequire("bF3ON");

var $3m0bI = parcelRequire("3m0bI");

var $kCCSe = parcelRequire("kCCSe");

var $7Lpsm = parcelRequire("7Lpsm");

var $bdQVY = parcelRequire("bdQVY");

var $kgjcI = parcelRequire("kgjcI");

var $8RVjM = parcelRequire("8RVjM");

var $hHHpU = parcelRequire("hHHpU");

var $cPJhk = parcelRequire("cPJhk");

var $7rpMX = parcelRequire("7rpMX");

var $cT7mi = parcelRequire("cT7mi");

var $bxy8b = parcelRequire("bxy8b");

var $6fFad = parcelRequire("6fFad");

var $ht0a3 = parcelRequire("ht0a3");
const $ece34773fbef76d8$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc",
    cookiePreferences: "_1e0c1txw _1bah1h6o _1pfhpxbi"
};
const $ece34773fbef76d8$var$HubInner = ({ appearance: appearance = 'full-page', parsedAdf: parsedAdf, mediaProvider: mediaProvider, providerFactory: providerFactory, extensionHandlers: extensionHandlers, helpCenterData: helpCenterData, productExtensionsDependenciesProvider: productExtensionsDependenciesProvider })=>{
    var _helpCenterData$pages;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $35T7J.MediaClientProvider), {
        clientConfig: mediaProvider.viewMediaClientConfig,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bKtPK.HubSpacingScope), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7Lpsm.default), {
                document: parsedAdf,
                appearance: appearance,
                dataProviders: providerFactory,
                product: (0, $ieP51.helpCenterTypeToProduct)((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || ''),
                additionalExtensionHandlers: extensionHandlers,
                contentId: (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$pages = helpCenterData.pages) === null || _helpCenterData$pages === void 0 || (_helpCenterData$pages = _helpCenterData$pages[0]) === null || _helpCenterData$pages === void 0 ? void 0 : _helpCenterData$pages.id) || '',
                PropsProvider: productExtensionsDependenciesProvider
            })
        })
    });
};
const $ece34773fbef76d8$var$Hub = ({ queryReference: queryReference, appearance: appearance = 'full-page', showPageNameAsHubDocumentTitle: showPageNameAsHubDocumentTitle = false, productExtensionsDependenciesProvider: productExtensionsDependenciesProvider = (0, $9sDkI.CommonHubExtensionsDependenciesProvider), customPageBreadcrumbPath: customPageBreadcrumbPath, portalBreadcrumbPath: portalBreadcrumbPath, showCustomPageBreadcrumbs: showCustomPageBreadcrumbs = false, showPortalBreadcrumbs: showPortalBreadcrumbs = false })=>{
    var _data$helpCenter, _data$helpCenter2, _helpCenterData$pages2, _helpCenterData$pages3, _pageParents, _helpCenterData$pages4, _helpCenterData$helpC, _branding$colors;
    // When the fix flag is ON, `HubAppShell` is rendered one level up in
    // `HubApp` so it stays mounted across page navigations. When the flag is
    // OFF, `Hub` renders `HubAppShell` itself (original behaviour).
    const hubContext = (0, $hJs5J.useHubContext)();
    if (!hubContext) throw new Error('HubContext not found. HubBootstrap must be used as a parent component.');
    const { user: user, cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = hubContext;
    // When the fix flag is ON, `pageMediaConfig` is fetched here (page-scoped)
    // so the bootstrap query stays page-agnostic and is not refetched on every
    // page navigation. When the flag is OFF, `pageMediaConfig` is skipped here
    // and remains on the bootstrap query as before.
    /* eslint-disable @atlassian/relay/unused-fields */ const data = (0, $a2qIF.usePreloadedQuery)((0, $6E4tD.default), queryReference);
    /* eslint-enable @atlassian/relay/unused-fields */ // When the fix flag is ON, read `pageMediaConfig` from the page-scoped
    // hubQuery result. When OFF, it comes from the bootstrap via `hubContext`.
    const pageMediaConfigFromQuery = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.pageMediaConfig;
    const pageMediaConfigFromContext = hubContext.pageMediaConfig;
    const pageMediaConfig = (0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media') ? pageMediaConfigFromQuery : pageMediaConfigFromContext;
    if (!pageMediaConfig) throw new Error('pageMediaConfig not found');
    const { mediaCollectionName: mediaCollectionName, asapIssuer: asapIssuer, mediaToken: mediaToken, mediaUrl: mediaUrl } = pageMediaConfig;
    const helpCenterData = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById;
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'QueryError') throw new Error(`QueryError in hub query: ${helpCenterData.message}`);
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) !== 'HelpCenter') throw new Error('HelpCenter not found in hub query');
    const helpCenterType = (helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || '';
    const pageName = (_helpCenterData$pages2 = helpCenterData.pages) === null || _helpCenterData$pages2 === void 0 || (_helpCenterData$pages2 = _helpCenterData$pages2[0]) === null || _helpCenterData$pages2 === void 0 || (_helpCenterData$pages2 = _helpCenterData$pages2.name) === null || _helpCenterData$pages2 === void 0 ? void 0 : _helpCenterData$pages2.default;
    const pageParents = (_helpCenterData$pages3 = helpCenterData.pages) === null || _helpCenterData$pages3 === void 0 || (_helpCenterData$pages3 = _helpCenterData$pages3[0]) === null || _helpCenterData$pages3 === void 0 ? void 0 : _helpCenterData$pages3.parents;
    const parentFolderName = pageParents === null || pageParents === void 0 || (_pageParents = pageParents[pageParents.length - 1]) === null || _pageParents === void 0 ? void 0 : _pageParents.name;
    const title = showPageNameAsHubDocumentTitle && pageName ? pageName : '';
    const mediaProvider = (0, $hJs5J.getMediaProvider)(mediaCollectionName, asapIssuer, mediaToken, mediaUrl);
    const emojiProvider = (0, $kCCSe.getEmojiProvider)({
        cloudId: queryReference.variables.cloudId,
        // NOTE: id is not yet available in the user object, but will be in the near future
        // as per https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/186871/overview#comment-659373408.
        // userId is optional for getEmojiProvider so just leaving this here for now.
        userId: user.id
    });
    const providerFactory = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return (0, $5zxDU.default).create({
            mediaProvider: Promise.resolve(mediaProvider),
            emojiProvider: Promise.resolve(emojiProvider)
        });
    }, [
        mediaProvider,
        emojiProvider
    ]);
    const layoutAdf = ((_helpCenterData$pages4 = helpCenterData.pages) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4[0]) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.pageLayout) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.layoutAdf) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.content) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.edges) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.map((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.content;
    })) === null || _helpCenterData$pages4 === void 0 ? void 0 : _helpCenterData$pages4.join('')) || '{}';
    const parsedAdf = JSON.parse(layoutAdf);
    const environment = (0, $bdQVY.useRelayEnvironmentProvider)().getEnvironment({});
    // The Rovo widget query is preloaded as a route resource (in parallel with the
    // hub bootstrap/page queries) so the help-hub callout banner's "Ask Rovo" search
    // box doesn't wait on a late, lazily-fired query. The resource is only attached to
    // the route when the `hub_preload_rovo_widget_query` gate is on (see the route
    // factories); when it isn't attached, the router never loads it and this reads
    // `null`. The reference is forwarded to the (help-hub-only) callout banner handler.
    const { queryReference: rovoWidgetProviderQueryReference } = (0, $cPJhk.useRelayResource)((0, $hHHpU.rovoWidgetResource));
    // Use product extension handlers hook to get additional handlers for the product
    const extensionHandlers = (0, $8RVjM.useProductExtensionHandlers)({
        contentId: queryReference.variables.hubAri,
        PropsProvider: productExtensionsDependenciesProvider,
        product: helpCenterType,
        rovoWidgetQueryReference: rovoWidgetProviderQueryReference
    });
    const aiWidgetProviderQueryReference = (0, $bSJIT.useMemo)(()=>{
        if (helpCenterType !== 'CUSTOMER_SERVICE') return null;
        return (0, $a2qIF.loadQuery)(environment, (0, $bF3ON.default), {
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        });
    }, [
        helpCenterType,
        environment,
        cloudId,
        helpCenterAri
    ]);
    const navigationBar = (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.navigationBar) ?? null;
    const { branding: branding } = (0, $hJs5J.useHubContext)();
    const brandColor = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary;
    const isCornerRadiusEnabled = (0, $3YmaA.useIsHubCornerRadiusEnabled)();
    const isAdvancedThemingEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    const navStyleOptions = (0, $bSJIT.useMemo)(()=>({
            options: navigationBar ? (0, $eIwmz.mapApiToNavigationOptions)(navigationBar, brandColor, isCornerRadiusEnabled, isAdvancedThemingEnabled) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        brandColor,
        isCornerRadiusEnabled,
        isAdvancedThemingEnabled
    ]);
    // When the fix flag is ON, re-provide `HubContext` with `pageMediaConfig`
    // from the page-scoped query so descendants can read it via
    // `useHubContext()` without a separate hook. When the flag is OFF the
    // bootstrap already set `pageMediaConfig` on the context, so no
    // re-provision is needed.
    const hubContextWithPageMedia = (0, $bSJIT.useMemo)(()=>({
            ...hubContext,
            pageMediaConfig: pageMediaConfig
        }), [
        hubContext,
        pageMediaConfig
    ]);
    // Derived from the page-scoped `rovoConfig` (absent unless `hubs_rovo_config_from_kosh` is on).
    // See `deriveRovoWidgetConfig` for exactly when this is null.
    const koshRovoWidgetConfig = (0, $bSJIT.useMemo)(()=>{
        var _helpCenterData$pages5;
        return (0, $3nMDg.deriveRovoWidgetConfig)((_helpCenterData$pages5 = helpCenterData.pages) === null || _helpCenterData$pages5 === void 0 || (_helpCenterData$pages5 = _helpCenterData$pages5[0]) === null || _helpCenterData$pages5 === void 0 ? void 0 : _helpCenterData$pages5.rovoConfig);
    }, [
        helpCenterData
    ]);
    const inner = /*#__PURE__*/ (0, $dc70d.jsx)((0, $eJ5U1.NavigationStyleContext).Provider, {
        value: navStyleOptions,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bxy8b.HubsDocumentTitle), {
            title: title,
            shouldRenderDocumentTitle: showPageNameAsHubDocumentTitle,
            children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
                children: [
                    helpCenterType === 'HELP_HUB' && showCustomPageBreadcrumbs && /*#__PURE__*/ (0, $dc70d.jsx)((0, $6fFad.HubPageBreadcrumbs), {
                        pageName: pageName,
                        pagePath: customPageBreadcrumbPath,
                        pageType: "custom",
                        parentFolderName: parentFolderName
                    }),
                    helpCenterType === 'HELP_HUB' && showPortalBreadcrumbs && portalBreadcrumbPath && /*#__PURE__*/ (0, $dc70d.jsx)((0, $6fFad.HubPageBreadcrumbs), {
                        pageName: pageName,
                        pagePath: portalBreadcrumbPath,
                        pageType: "portal"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)($ece34773fbef76d8$var$HubInner, {
                        appearance: appearance,
                        parsedAdf: parsedAdf,
                        mediaProvider: mediaProvider,
                        providerFactory: providerFactory,
                        extensionHandlers: extensionHandlers,
                        helpCenterData: helpCenterData,
                        productExtensionsDependenciesProvider: productExtensionsDependenciesProvider
                    }),
                    (helpCenterType === 'HELP_HUB' || helpCenterType === 'CUSTOMER_SERVICE') && (0, $gdUUy.fg)('service-collection-customers-cookie-preferences') && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        xcss: $ece34773fbef76d8$var$styles.cookiePreferences,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cT7mi.CookiePreferencesButton), {})
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
                        fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                            name: "ai-corner-agent-renderer-loader"
                        }),
                        children: aiWidgetProviderQueryReference && /*#__PURE__*/ (0, $dc70d.jsx)((0, $eime1.ErrorBoundary), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $66ogx.AiWidgetProvider), {
                                queryReference: aiWidgetProviderQueryReference,
                                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7rpMX.AiCornerAgentRenderer), {})
                            })
                        })
                    })
                ]
            })
        })
    });
    // When the fix flag is ON, wrap with a HubContext.Provider that merges
    // in the page-scoped `pageMediaConfig`. When OFF, restore the original
    // behaviour: render `HubAppShell` here (wrapping `inner`) and use the
    // bootstrap context which already has `pageMediaConfig`.
    const content = (0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $hJs5J.HubContext).Provider, {
        value: hubContextWithPageMedia,
        children: inner
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $3m0bI.HubAppShell), {
        children: inner
    });
    // Provide the help-kosh-sourced config here so the callout banner reads it via
    // `useOptionalRovoWidgetConfig()` with no second AGG round trip. The banner skips its own
    // query-backed provider when this one is already in the tree, so this path takes precedence
    // and the query-backed one remains the fallback.
    return koshRovoWidgetConfig ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $kgjcI.RovoWidgetConfigProvider), {
        rovoWidgetConfig: koshRovoWidgetConfig,
        children: content
    }) : content;
};
const $ece34773fbef76d8$export$44db4a416180c024 = (props)=>{
    const { appearance: appearance = 'full-page' } = props;
    const { queryReference: hubPageQueryReference } = (0, $cPJhk.useRelayResource)((0, $hHHpU.hubPageResource));
    const { queryReference: hubBootstrapQueryReference } = (0, $cPJhk.useRelayResource)((0, $hHHpU.hubBootstrapResource));
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (!hubPageQueryReference || !hubBootstrapQueryReference) return null;
    const cloudId = hubBootstrapQueryReference.variables.cloudId;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $itx7D.HubErrorBoundary), {
        packageName: "hub",
        id: "hub-page",
        fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hNRax.GenericErrorPage), {}),
        shouldForceError: true,
        operationNames: [
            'hubBootstrapWrapperQuery'
        ],
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kxIlX.ContextWrapper), {
            sourceType: (0, $clpci.SCREEN),
            sourceName: "hub",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
                    fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                        name: "hub-loader",
                        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            className: (0, $9fU1q.default)([
                                $ece34773fbef76d8$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                                size: "large",
                                label: formatMessage((0, $ht0a3.default).hubLoadingSpinnerLabel)
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4Io6U.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        cloudId: cloudId,
                        ...props,
                        children: (0, $gdUUy.fg)('hubs_fix_rerendering_bootstrap_page_media') ? // Flag ON: HubAppShell lives outside Hub so the app
                        // shell is not remounted on every page navigation.
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $3m0bI.HubAppShell), {
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
                                fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                                    name: "hub-loader",
                                    children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                        className: (0, $9fU1q.default)([
                                            $ece34773fbef76d8$var$styles.spinnerContainer
                                        ]),
                                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                                            size: "large",
                                            label: formatMessage((0, $ht0a3.default).hubLoadingSpinnerLabel)
                                        })
                                    })
                                }),
                                children: /*#__PURE__*/ (0, $dc70d.jsx)($ece34773fbef76d8$var$Hub, {
                                    appearance: appearance,
                                    customPageBreadcrumbPath: props.customPageBreadcrumbPath,
                                    portalBreadcrumbPath: props.portalBreadcrumbPath,
                                    queryReference: hubPageQueryReference,
                                    showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle,
                                    showCustomPageBreadcrumbs: props.showCustomPageBreadcrumbs,
                                    showPortalBreadcrumbs: props.showPortalBreadcrumbs,
                                    productExtensionsDependenciesProvider: props.productExtensionsDependenciesProvider
                                })
                            })
                        }) : // Flag OFF: original behaviour — Hub renders HubAppShell
                        // internally on every page render.
                        /*#__PURE__*/ (0, $dc70d.jsx)($ece34773fbef76d8$var$Hub, {
                            appearance: appearance,
                            customPageBreadcrumbPath: props.customPageBreadcrumbPath,
                            portalBreadcrumbPath: props.portalBreadcrumbPath,
                            queryReference: hubPageQueryReference,
                            showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle,
                            showCustomPageBreadcrumbs: props.showCustomPageBreadcrumbs,
                            showPortalBreadcrumbs: props.showPortalBreadcrumbs,
                            productExtensionsDependenciesProvider: props.productExtensionsDependenciesProvider
                        })
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8LptA.FireScreenAnalytics), {})
            ]
        })
    });
};

});
parcelRegister("5zxDU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e7bca562fc4efee$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0e7bca562fc4efee$var$isUndefined(x) {
    return x === undefined;
}
class $0e7bca562fc4efee$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $0e7bca562fc4efee$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$0e7bca562fc4efee$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("9sDkI", function(module, exports) {
$parcel$export(module.exports, "CommonHubExtensionsDependenciesProvider", () => $a8fa55987b1384f3$export$93e984eb90009a17);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $f8Fgv = parcelRequire("f8Fgv");

var $4uQUf = parcelRequire("4uQUf");

var $Juus0 = parcelRequire("Juus0");

var $dsKYd = parcelRequire("dsKYd");

var $hJs5J = parcelRequire("hJs5J");
const $a8fa55987b1384f3$export$93e984eb90009a17 = ({ children: children })=>{
    var _branding$colors;
    const { cloudId: cloudId, cloudUrl: cloudUrl, pageMediaConfig: pageMediaConfig, hubMediaConfig: hubMediaConfig, env: env, branding: branding, user: user, hubType: hubType } = (0, $hJs5J.useHubContext)();
    const { hoistedProjectKey: hoistedProjectKey } = env;
    // Advanced theming v2: read derived theming literals from HubThemingContext.
    // The provider is mounted at the HubAppShell level so every consumer reaches
    // the same memoised palette / defaults / swatch map — and the values are
    // SSR-safe hex literals (no --hub-* CSS vars).
    // useHubTheming returns undefined outside the provider, but this provider is
    // only mounted by help-center inside HubBootstrap → provider is in tree.
    // NOTE: must run BEFORE the pageMediaConfig guard below — Rules of Hooks
    // require the same number of hook calls on every render.
    const { defaultParameters: defaultParameters, brandBackgroundColorMap: brandBackgroundColorMap } = (0, $dsKYd.useHubTheming)();
    // When the fix flag is ON, `pageMediaConfig` is provided by the `Hub`
    // component (via `hubQuery`) via a nested `HubContext.Provider`. When the
    // flag is OFF it comes from the bootstrap. Either way it must be present
    // by the time this provider renders; if it is missing the consumer is
    // mounted in an unsupported position.
    if (!pageMediaConfig) throw new Error("CommonHubExtensionsDependenciesProvider requires `pageMediaConfig` on the HubContext. Ensure this provider is rendered as a descendant of the `Hub` component.");
    const authProvider = (0, $bSJIT.useCallback)(()=>Promise.resolve({
            asapIssuer: pageMediaConfig.asapIssuer,
            token: pageMediaConfig.mediaToken,
            baseUrl: pageMediaConfig.mediaUrl
        }), [
        pageMediaConfig
    ]);
    const createEditorMediaProvider = (0, $bSJIT.useCallback)(async ({ onUploadRejection: onUploadRejection })=>{
        const mediaProvider = {
            uploadParams: {
                collection: pageMediaConfig.mediaCollectionName,
                onUploadRejection: onUploadRejection
            },
            viewMediaClientConfig: {
                authProvider: authProvider
            },
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        };
        return mediaProvider;
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const useMediaConfig = (0, $bSJIT.useCallback)(({ imageSrc: imageSrc })=>{
        return {
            authProvider: authProvider,
            collection: pageMediaConfig.mediaCollectionName,
            fileId: imageSrc
        };
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const contextValue = {
        smartCardProviderComponent: undefined,
        isTargetAudience: ()=>false,
        useSegmentationTargetGroups: ()=>({}),
        isCompanyHub: true,
        // need to pass this true to enable company hub specific extensions
        // Help-Hub-only signal. Derived here from the hub context, which is
        // help-center-only (this provider is never mounted outside a HubContext).
        // The Confluence company hub uses ConfluenceDependenciesProvider and so
        // leaves this false; CSM help centers have hubType !== 'HELP_HUB'.
        isHelpHub: hubType === 'HELP_HUB',
        enableLinkInputInMediaPicker: true,
        cloudId: cloudId,
        cloudUrl: cloudUrl,
        hoistedProjectKey: hoistedProjectKey,
        helpCenterAri: env.helpCenterAri,
        isAdminHubAIEnabled: false,
        linkPickerConfig: {
            linkPickerPlugins: []
        },
        userId: (0, $gdUUy.fg)('fix_user_context_in_hubs') ? user.id : '',
        customMediaConfig: hubMediaConfig,
        createEditorMediaProvider: createEditorMediaProvider,
        useMediaConfig: useMediaConfig,
        branding: {
            ...branding,
            defaultParameters: defaultParameters,
            hideDefaultColorPalette: !!(branding !== null && branding !== void 0 && (_branding$colors = branding.colors) !== null && _branding$colors !== void 0 && _branding$colors.primary),
            brandBackgroundColorMap: brandBackgroundColorMap
        },
        hideExtensionBorders: true,
        showConfigPreambleSupportLink: false,
        enableTargeting: false,
        enableUnifiedSearchFeatures: (0, $gdUUy.fg)('enable_dynamic_cards_for_gday'),
        enableSmartCardsFields: false,
        experienceStopComponent: (0, $Juus0.HubErrorLogger),
        submitError: (0, $f8Fgv.logException)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4uQUf.ProductDependenciesContext).Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("f8Fgv", function(module, exports) {
$parcel$export(module.exports, "logException", () => $42a521c2f6e87fcf$export$f86b2a1a2ce291b3);

var $53RlD = parcelRequire("53RlD");
let $42a521c2f6e87fcf$var$Sentry;
const $42a521c2f6e87fcf$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $42a521c2f6e87fcf$export$668f31ea3127f48f = window.BUILD_KEY;

const $42a521c2f6e87fcf$export$f553e8b08ef59d31 = async ()=>{
    if (!$42a521c2f6e87fcf$var$Sentry) $42a521c2f6e87fcf$var$Sentry = Promise.resolve((parcelRequire("2mNXa"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $53RlD.SENTRY_DSN),
            attachStacktrace: true,
            release: $42a521c2f6e87fcf$export$668f31ea3127f48f || (0, $53RlD.UNKNOWN_TAG),
            environment: $42a521c2f6e87fcf$export$57570b1603cf6adb()
        });
        return SentryModule;
    }).catch(()=>{});
    return $42a521c2f6e87fcf$var$Sentry;
};
const $42a521c2f6e87fcf$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await $42a521c2f6e87fcf$export$f553e8b08ef59d31();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('product', 'hub');
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

});
parcelRegister("2mNXa", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $1b94628bc632cc3c$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("jU8WH")));

var $3Cq0D = parcelRequire("3Cq0D");

var $l3GjM = parcelRequire("l3GjM");

var $dLDTQ = parcelRequire("dLDTQ");
parcelRequire("ea3Tu");
var $k9z5g = parcelRequire("k9z5g");

var $fXSpw = parcelRequire("fXSpw");

var $jU8WH = parcelRequire("jU8WH");
var $1b94628bc632cc3c$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $1b94628bc632cc3c$var$_window = (0, $k9z5g.getGlobalObject)();
if ($1b94628bc632cc3c$var$_window.Sentry && $1b94628bc632cc3c$var$_window.Sentry.Integrations) $1b94628bc632cc3c$var$windowIntegrations = $1b94628bc632cc3c$var$_window.Sentry.Integrations;
var $1b94628bc632cc3c$export$99d02219d259eb94 = (0, $3Cq0D.__assign)((0, $3Cq0D.__assign)((0, $3Cq0D.__assign)({}, $1b94628bc632cc3c$var$windowIntegrations), (0, $dLDTQ)), $fXSpw);
$parcel$exportWildcard(module.exports, $l3GjM);

});
parcelRegister("l3GjM", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("icZGb")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("eEUgk")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("kOZtN")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("kOZtN")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("kOZtN")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("kOZtN")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("kOZtN")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("iSbcz")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("iSbcz")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("iSbcz")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("iSbcz")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("eEUgk")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("d5Pn9")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("kOZtN")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("93u3F")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("kOZtN")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("kOZtN")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("kOZtN")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("kOZtN")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("kOZtN")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("kOZtN")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("kOZtN")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("ibPGb")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("fPVq6")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("graJR")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("graJR")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eqszJ")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eqszJ")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eqszJ")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eqszJ")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eqszJ")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eqszJ")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eqszJ")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eqszJ")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eqszJ")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("8WtLP")).SDK_NAME);

var $icZGb = parcelRequire("icZGb");

var $kOZtN = parcelRequire("kOZtN");
var $eEUgk = parcelRequire("eEUgk");
var $iSbcz = parcelRequire("iSbcz");
var $93u3F = parcelRequire("93u3F");
var $d5Pn9 = parcelRequire("d5Pn9");

var $ibPGb = parcelRequire("ibPGb");

var $fPVq6 = parcelRequire("fPVq6");

var $graJR = parcelRequire("graJR");

var $eqszJ = parcelRequire("eqszJ");

var $8WtLP = parcelRequire("8WtLP");

});
parcelRegister("8WtLP", function(module, exports) {
$parcel$export(module.exports, "SDK_NAME", () => $682ad550bf8682f5$export$ca61d37259221480);
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $682ad550bf8682f5$export$ca61d37259221480 = 'sentry.javascript.browser';

});


parcelRegister("fXSpw", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("2s2RI")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("fTsHB")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("7IowH")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("ih4aa")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("7Ih51")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("iiJPA")).Dedupe);

var $2s2RI = parcelRequire("2s2RI");

var $fTsHB = parcelRequire("fTsHB");

var $7IowH = parcelRequire("7IowH");

var $ih4aa = parcelRequire("ih4aa");

var $7Ih51 = parcelRequire("7Ih51");

var $iiJPA = parcelRequire("iiJPA");

});

parcelRegister("jU8WH", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("bP6WX")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("j4nkA")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("k0cvm")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("7tx6Y")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("gRK2a")).makeNewXHRTransport);

var $bP6WX = parcelRequire("bP6WX");

var $j4nkA = parcelRequire("j4nkA");

var $k0cvm = parcelRequire("k0cvm");

var $7tx6Y = parcelRequire("7tx6Y");

var $gRK2a = parcelRequire("gRK2a");

});



parcelRegister("Juus0", function(module, exports) {
$parcel$export(module.exports, "HubErrorLogger", () => $5295d31f88b3715f$export$9ef862d41b8c7d0f);

var $bSJIT = parcelRequire("bSJIT");

var $bx56v = parcelRequire("bx56v");
const $5295d31f88b3715f$export$9ef862d41b8c7d0f = ({ error: error, shouldForceError: shouldForceError })=>{
    const logError = (0, $bx56v.useUFOReportError)();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        logError({
            name: (error === null || error === void 0 ? void 0 : error.name) || 'unknown',
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) || '',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) || '',
            forcedError: shouldForceError
        });
    }, [
        logError,
        error,
        shouldForceError
    ]);
    return null;
};

});


parcelRegister("bKtPK", function(module, exports) {
$parcel$export(module.exports, "HubSpacingScope", () => $283ff47c8b05c773$export$1d8b960adcd035f4);

var $bSJIT = parcelRequire("bSJIT");

var $dsKYd = parcelRequire("dsKYd");

var $j8CsI = parcelRequire("j8CsI");

var $bBolO = parcelRequire("bBolO");
const $283ff47c8b05c773$export$1d8b960adcd035f4 = ({ children: children, enabled: enabled = true })=>{
    const gateEnabled = (0, $j8CsI.useIsHubSpaceDensityEnabled)();
    const theming = (0, $dsKYd.useHubTheming)();
    const spaceDensity = theming === null || theming === void 0 ? void 0 : theming.spaceDensity;
    const wrapperStyle = (0, $bSJIT.useMemo)(()=>{
        const density = spaceDensity ?? (0, $bBolO.DEFAULT_SPACE_DENSITY);
        return {
            display: 'contents',
            [(0, $bBolO.EDITOR_BLOCK_SPACING_VAR)]: (0, $bBolO.getBlockSpacingForDensity)(density)
        };
    }, [
        spaceDensity
    ]);
    // No-op unless the feature gate is on, the host enables this surface, and a
    // density has actually been selected/persisted.
    if (!gateEnabled || !enabled || !spaceDensity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-hub-space-density-scope": "",
        style: wrapperStyle
    }, children));
};

});
parcelRegister("j8CsI", function(module, exports) {
$parcel$export(module.exports, "useIsHubSpaceDensityEnabled", () => $fa41f59b739c4f1c$export$1f7957aafeeb725b);
/**
 * Returns `true` when the Hub space density (spacing) customization should be
 * available.
 *
 * Gated by advanced theming AND the `hub-space-density` Statsig gate
 * space density is always a sub-feature of advanced theming and never ships
 * without it.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted (Confluence
 * Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled` returns false in
 * that case.
 */ 
var $gdUUy = parcelRequire("gdUUy");

var $axsoS = parcelRequire("axsoS");
const $fa41f59b739c4f1c$export$1f7957aafeeb725b = ()=>{
    const isAdvancedThemingEnabled = (0, $axsoS.useIsAdvancedThemingEnabled)();
    return isAdvancedThemingEnabled && (0, $gdUUy.fg)('hub-space-density');
};

});


parcelRegister("ieP51", function(module, exports) {
$parcel$export(module.exports, "helpCenterTypeToProduct", () => $ae975fb3b90dbcef$export$cf749f9c25e568e8);
const $ae975fb3b90dbcef$export$cf749f9c25e568e8 = (helpCenterType)=>{
    switch(helpCenterType){
        case 'CUSTOMER_SERVICE':
            return 'CSM';
        case 'HELP_HUB':
            return 'JSM';
        default:
            return 'CSM';
    }
};

});

parcelRegister("3nMDg", function(module, exports) {
$parcel$export(module.exports, "deriveRovoWidgetConfig", () => $84ab02671b3b7b78$export$35601df0cf654b0a);
/**
 * Shape of the `rovoConfig` field on `HelpCenterPage`, as selected by `hubQuery`.
 *
 * Typed structurally rather than off the generated Relay type so this stays a plain pure function
 * with no codegen dependency. The field is absent entirely when `hubs_rovo_config_from_kosh` is off
 * (`@include(if:)`), hence `undefined` is a valid input.
 */ const $84ab02671b3b7b78$export$35601df0cf654b0a = (rovoConfig)=>{
    if (!(rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isCustomAgentsAvailable) || !rovoConfig.isRovoEnabled || !rovoConfig.agentId) return null;
    return {
        agentId: rovoConfig.agentId,
        ...rovoConfig.widgetContainerAri ? {
            widgetContainerAri: rovoConfig.widgetContainerAri
        } : {}
    };
};

});

parcelRegister("66ogx", function(module, exports) {
$parcel$export(module.exports, "AiWidgetProvider", () => $556c773f8f2de31f$export$963f3fe63ca0f1aa);

var $bF3ON = parcelRequire("bF3ON");

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");

var $itx7D = parcelRequire("itx7D");

var $hJs5J = parcelRequire("hJs5J");

var $4SpKW = parcelRequire("4SpKW");

var $eMSqH = parcelRequire("eMSqH");
/**
 * Provides AI widget config via context when available.
 * On query failure or invalid data, it falls back to rendering children only.
 */ const $556c773f8f2de31f$var$AiWidgetProviderInner = ({ queryReference: queryReference, children: children })=>{
    var _data$helpCenter;
    const { cloudId: siteId } = (0, $hJs5J.useHubContext)();
    const data = (0, $a2qIF.usePreloadedQuery)((0, $bF3ON.default), queryReference);
    const primaryColor = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    const widgetConfig = data.csmAi_getSupportWidget;
    const supportWidgetConfig = (0, $bSJIT.useMemo)(()=>{
        if (!widgetConfig || !widgetConfig.id || !widgetConfig.theme || !primaryColor || !siteId) return null;
        return {
            siteId: siteId,
            widgetId: widgetConfig.id,
            widgetTheme: {
                primaryColor: primaryColor,
                radius: (0, $4SpKW.handleWidgetRadiusType)(widgetConfig.theme.radius),
                space: (0, $4SpKW.handleWidgetSpaceType)(widgetConfig.theme.space),
                chatBubbleVariant: (0, $4SpKW.handleChatBubbleVariant)(widgetConfig.theme.chatColor),
                widgetButtonVariant: (0, $4SpKW.handleWidgetButtonVariant)(widgetConfig.theme.colorVibeVariant),
                attribution: null
            },
            widgetPosition: (0, $4SpKW.handleWidgetPosition)(widgetConfig.position),
            isEnabled: Boolean(widgetConfig.isEnabled)
        };
    }, [
        widgetConfig,
        primaryColor,
        siteId
    ]);
    if (!supportWidgetConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eMSqH.AiWidgetConfigProvider), {
        supportWidgetConfig: supportWidgetConfig
    }, children);
};
const $556c773f8f2de31f$export$963f3fe63ca0f1aa = ({ queryReference: queryReference, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $itx7D.HubErrorBoundary), {
        packageName: "@atlassian/csm-ai-search-trigger",
        id: "AiWidgetProvider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($556c773f8f2de31f$var$AiWidgetProviderInner, {
        queryReference: queryReference
    }, children));
};

});
parcelRegister("bF3ON", function(module, exports) {
$parcel$export(module.exports, "default", () => $b342516336a7b1ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2eb8409e14d8125227a3ef3f45225d9>>
 * @relayHash d24b4ad1a97ccd24bce6bb96d6c01dac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c
const $b342516336a7b1ff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c",
            "metadata": {},
            "name": "aiWidgetProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b342516336a7b1ff$var$node.hash = "cc0a8c3c2e0c2ac2a4e32f0440175bfe";
var $b342516336a7b1ff$export$2e2bcd8739ae039 = $b342516336a7b1ff$var$node;

});

parcelRegister("4SpKW", function(module, exports) {
$parcel$export(module.exports, "handleWidgetRadiusType", () => $ef3f0ed374e3804e$export$21feeed55533391b);
$parcel$export(module.exports, "handleWidgetSpaceType", () => $ef3f0ed374e3804e$export$882cd7667f1dc36b);
$parcel$export(module.exports, "handleWidgetPosition", () => $ef3f0ed374e3804e$export$565c45f827c88f12);
$parcel$export(module.exports, "handleChatBubbleVariant", () => $ef3f0ed374e3804e$export$8d7135a196764ba5);
$parcel$export(module.exports, "handleWidgetButtonVariant", () => $ef3f0ed374e3804e$export$1e1d4315fa0edb5);
const $ef3f0ed374e3804e$export$21feeed55533391b = (radius)=>{
    switch(radius){
        case 'ROUNDED':
            return 'rounded';
        case 'SHARP':
            return 'sharp';
        case 'NORMAL':
        default:
            return 'normal';
    }
};
const $ef3f0ed374e3804e$export$882cd7667f1dc36b = (space)=>{
    switch(space){
        case 'COSY':
            return 'cosy';
        case 'GENEROUS':
            return 'generous';
        case 'COMFORTABLE':
        default:
            return 'comfortable';
    }
};
const $ef3f0ed374e3804e$export$565c45f827c88f12 = (position)=>{
    switch(position){
        case 'CENTER':
            return 'CENTER';
        case 'CORNER':
        default:
            return 'CORNER';
    }
};
const $ef3f0ed374e3804e$export$8d7135a196764ba5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'default';
    }
};
const $ef3f0ed374e3804e$export$1e1d4315fa0edb5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'dark';
    }
};

});

parcelRegister("eMSqH", function(module, exports) {
$parcel$export(module.exports, "AiWidgetConfigProvider", () => $d5c45e6f9a72a47a$export$6e44feab0c163a95);
$parcel$export(module.exports, "useOptionalAiWidgetConfig", () => $d5c45e6f9a72a47a$export$ab391f3a63cacd0);
$parcel$export(module.exports, "useAiWidgetConfig", () => $d5c45e6f9a72a47a$export$91842e2b4fccaca6);

var $bSJIT = parcelRequire("bSJIT");
const $d5c45e6f9a72a47a$var$AiWidgetConfigContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $d5c45e6f9a72a47a$export$6e44feab0c163a95 = ({ supportWidgetConfig: supportWidgetConfig, children: children })=>{
    const [value] = (0, $bSJIT.useState)({
        supportWidgetConfig: supportWidgetConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d5c45e6f9a72a47a$var$AiWidgetConfigContext.Provider, {
        value: value
    }, children);
};
const $d5c45e6f9a72a47a$export$ab391f3a63cacd0 = ()=>{
    return (0, $bSJIT.useContext)($d5c45e6f9a72a47a$var$AiWidgetConfigContext);
};
const $d5c45e6f9a72a47a$export$91842e2b4fccaca6 = ()=>{
    const contextValue = (0, $bSJIT.useContext)($d5c45e6f9a72a47a$var$AiWidgetConfigContext);
    if (!contextValue) throw new Error('useSuppportWidgetConfig must be used within a AiWidgetConfigProvider');
    return contextValue;
};

});


parcelRegister("kCCSe", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $c9f95b108586582a$export$8210f5f78c0bcf27);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $8XNPf = parcelRequire("8XNPf");

var $etCmN = parcelRequire("etCmN");
const $c9f95b108586582a$var$BASE_URL = '/gateway/api/emoji';
const $c9f95b108586582a$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$c9f95b108586582a$var$BASE_URL}/standard`
        },
        {
            url: `${$c9f95b108586582a$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$c9f95b108586582a$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $c9f95b108586582a$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? '';
    const disableUpload = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload) ?? false;
    const emojiSSRConfigString = extraConfig !== null && extraConfig !== void 0 && extraConfig.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $c9f95b108586582a$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))((extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? undefined;
    const disableUpload = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload;
    const emojiSSRConfig = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.emojiSSRConfig) ?? undefined;
    const emojiConfig = $c9f95b108586582a$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $etCmN.default)(emojiConfig);
}, $c9f95b108586582a$var$resolverOfMemoize);
const $c9f95b108586582a$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))((extraConfig)=>{
    const emojiResource = $c9f95b108586582a$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $c9f95b108586582a$var$resolverOfMemoize);

});
parcelRegister("etCmN", function(module, exports) {
$parcel$export(module.exports, "default", () => $8eaa9d0d741d7851$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $gdUUy = parcelRequire("gdUUy");

var $1N0Bi = parcelRequire("1N0Bi");

var $bi2s0 = parcelRequire("bi2s0");

var $5nwBg = parcelRequire("5nwBg");

var $fFksa = parcelRequire("fFksa");

var $dihY4 = parcelRequire("dihY4");

var $g3vc1 = parcelRequire("g3vc1");

var $4CEaO = parcelRequire("4CEaO");

var $2D4MI = parcelRequire("2D4MI");

var $cz2rC = parcelRequire("cz2rC");

var $lNUA5 = parcelRequire("lNUA5");

var $evJGV = parcelRequire("evJGV");

var $aD9pN = parcelRequire("aD9pN");

var $aR8hx = parcelRequire("aR8hx");

var $bwDBu = parcelRequire("bwDBu");

var $QdTGX = parcelRequire("QdTGX");

var $5L2Zv = parcelRequire("5L2Zv");

const $8eaa9d0d741d7851$var$teamoji26QueryParam = 'useTeamoji26=true';
const $8eaa9d0d741d7851$var$addTeamoji26QueryParam = (url)=>{
    if (!url.includes('/atlassian') || /[?&]useTeamoji26=/.test(url)) return url;
    const hashIndex = url.indexOf('#');
    const urlWithoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
    const separator = urlWithoutHash.includes('?') ? '&' : '?';
    return `${urlWithoutHash}${separator}${$8eaa9d0d741d7851$var$teamoji26QueryParam}${hash}`;
};
class $8eaa9d0d741d7851$export$b5efafc6dd611ec5 extends (0, $bi2s0.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        const rewriteEmojiGatewayPath = (url)=>url.replace('/gateway/api/emoji', '/gateway/api/elements/emoji');
        const stargateEmojiPathEnabled = (0, $gdUUy.fg)('use-elements-stargate-emoji-path');
        const teamoji26RefreshEmojiPickerEnabled = (0, $evJGV.isTeamoji26RefreshEmojiPickerEnabled)();
        const singleEmojiApi = config.singleEmojiApi;
        const optimisticImageApi = config.optimisticImageApi;
        const providers = config.providers.map((provider)=>{
            const rewrittenUrl = stargateEmojiPathEnabled ? rewriteEmojiGatewayPath(provider.url) : provider.url;
            return {
                ...provider,
                url: teamoji26RefreshEmojiPickerEnabled ? $8eaa9d0d741d7851$var$addTeamoji26QueryParam(rewrittenUrl) : rewrittenUrl
            };
        });
        this.emojiProviderConfig = {
            ...config,
            providers: providers,
            singleEmojiApi: stargateEmojiPathEnabled && singleEmojiApi ? {
                ...singleEmojiApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(singleEmojiApi.getUrl(emojiId))
            } : singleEmojiApi,
            optimisticImageApi: stargateEmojiPathEnabled && optimisticImageApi ? {
                ...optimisticImageApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(optimisticImageApi.getUrl(emojiId))
            } : optimisticImageApi
        };
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $lNUA5.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
   * Get the emoji provider from Emoji Resource
   * @returns Promise<EmojiProvider>
   */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $cz2rC.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $fFksa.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $g3vc1.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $fFksa.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $bwDBu.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $fFksa.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $fFksa.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $cz2rC.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder) {
        const shortNameLookupOrder = (0, $gdUUy.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined;
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId, shortNameLookupOrder);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $bwDBu.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId, shortNameLookupOrder);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId, shortNameLookupOrder);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $5nwBg.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $5nwBg.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $5nwBg.ProviderTypes).ATLASSIAN;
        return (0, $5nwBg.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $QdTGX.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $5L2Zv.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $2D4MI.isPromise)(done)) return done.then(()=>{
                    (0, $cz2rC.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $cz2rC.default)('Failed to prime siteEmojiResource');
                });
                else (0, $cz2rC.default)('Already primed siteEmojiResource');
            } else (0, $cz2rC.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $2D4MI.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const storedToneString = window.localStorage.getItem((0, $g3vc1.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
   *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
   */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $4CEaO.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $4CEaO.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $2D4MI.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $dihY4.ufoExperiences)['emoji-searched'].start();
        (0, $dihY4.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: (query === null || query === void 0 ? void 0 : query.length) || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $dihY4.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: (options === null || options === void 0 ? void 0 : options.source) || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName, emojiProviderLookupOrder) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName, emojiProviderLookupOrder);
        return this.retryIfLoading(()=>this.findByShortName(shortName, emojiProviderLookupOrder), undefined);
    }
    findByEmojiId(emojiId, emojiProviderLookupOrder) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName, emojiProviderLookupOrder);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName, emojiProviderLookupOrder);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName, emojiProviderLookupOrder);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId, emojiProviderLookupOrder), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
   * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
   * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
   * for the purposes of tracking the frequency of use.
   *
   * @param emoji The full description of the emoji to record usage for.
   */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $aR8hx.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $1N0Bi.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $lNUA5.default)('localStorage')) try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem((0, $g3vc1.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $8eaa9d0d741d7851$export$2e2bcd8739ae039 extends $8eaa9d0d741d7851$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 30000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $aD9pN.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("1N0Bi", function(module, exports) {
$parcel$export(module.exports, "utils", () => $e9ee8b71f6c61d80$export$eab97d15b1788b8d);

var $hM2a7 = parcelRequire("hM2a7");

var $icnvG = parcelRequire("icnvG");
const $e9ee8b71f6c61d80$export$eab97d15b1788b8d = $icnvG;
const $e9ee8b71f6c61d80$export$3b4c04cf7dad0e50 = $hM2a7;

});
parcelRegister("hM2a7", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $c84ea4b289dc75da$export$8b13532c81e8ac89);

var $3xk1G = parcelRequire("3xk1G");

var $85Uxt = parcelRequire("85Uxt");

var $3T3O0 = parcelRequire("3T3O0");

var $9P1rC = parcelRequire("9P1rC");

var $9dpiy = parcelRequire("9dpiy");

var $5PyYg = parcelRequire("5PyYg");
const $c84ea4b289dc75da$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $9dpiy.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $9P1rC.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $3T3O0.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $5PyYg.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $85Uxt.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $3xk1G.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $c84ea4b289dc75da$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("3xk1G", function(module, exports) {
$parcel$export(module.exports, "meros", () => $2933fcf619b0a3b7$export$74e0a034be2368c7);
async function $2933fcf619b0a3b7$export$74e0a034be2368c7(e, t) {
    if (!e.ok || !e.body || e.bodyUsed) return e;
    let n = e.headers.get("content-type");
    if (!n || !~n.indexOf("multipart/")) return e;
    let i = n.indexOf("boundary="), l = "-";
    if (~i) {
        let e = i + 9, t = n.indexOf(";", e);
        l = n.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(e, t, n) {
        let i, l, r, d = new TextDecoder("utf8"), o = e.getReader(), a = !n || !n.multiple, f = t.length, s = "", c = [];
        try {
            let e;
            e: for(; !(e = await o.read()).done;){
                let n = d.decode(e.value, {
                    stream: !0
                });
                i = s.length, s += n;
                let o = n.indexOf(t);
                for(~o ? i += o : i = s.indexOf(t), c = []; ~i;){
                    let e = s.slice(0, i), n = s.slice(i + f);
                    if (l) {
                        let t = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", t), l = !1, d = e.slice(t, i > -1 ? void 0 : i), o = String(e.slice(0, t)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; r = o[--s]; r = r.split(": "), f[r.shift().toLowerCase()] = r.join(": "));
                        if (r = f["content-type"], r && ~r.indexOf("application/json")) try {
                            d = JSON.parse(d), l = !0;
                        } catch (e) {}
                        if (r = {
                            headers: f,
                            body: d,
                            json: l
                        }, a ? yield r : c.push(r), "--" === n.slice(0, 2)) break e;
                    } else t = "\r\n" + t, l = f += 2;
                    s = n, i = s.indexOf(t);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(e.body, `--${l}`, t);
}

});

parcelRegister("3T3O0", function(module, exports) {
$parcel$export(module.exports, "buildHeaders", () => $aa5ae6668850c8fb$export$7d6ed858a91629c3);
const $aa5ae6668850c8fb$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $aa5ae6668850c8fb$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $aa5ae6668850c8fb$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $aa5ae6668850c8fb$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});

parcelRegister("9P1rC", function(module, exports) {
$parcel$export(module.exports, "buildUrl", () => $70c54795a5da2c3a$export$b5cd97dee32de81d);
const $70c54795a5da2c3a$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};

});

parcelRegister("9dpiy", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $28c00b302dd9985a$export$160dbda113bfad3b);
const $28c00b302dd9985a$export$160dbda113bfad3b = {};

});

parcelRegister("5PyYg", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $1bfa5bfced50f2ad$export$2ac26f1ab7eda637);
const $1bfa5bfced50f2ad$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});


parcelRegister("icnvG", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => (parcelRequire("3iFK1")).extractTracingHeaders);
$parcel$export(module.exports, "requestService", () => (parcelRequire("50K9m")).requestService);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { extractTracingHeaders } from '@atlaskit/util-service-support/extractTracingHeaders'` instead.
 */ 
var $3iFK1 = parcelRequire("3iFK1");

var $50K9m = parcelRequire("50K9m");

});
parcelRegister("3iFK1", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => $465a5744d65d28c4$export$4f34edf253146101);
const $465a5744d65d28c4$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $465a5744d65d28c4$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $465a5744d65d28c4$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};

});

parcelRegister("50K9m", function(module, exports) {
$parcel$export(module.exports, "requestService", () => $b1b66edbf936e484$export$97bfde5a702aaeca);

var $85Uxt = parcelRequire("85Uxt");

var $3T3O0 = parcelRequire("3T3O0");

var $9P1rC = parcelRequire("9P1rC");

var $3iFK1 = parcelRequire("3iFK1");

var $9dpiy = parcelRequire("9dpiy");

var $5PyYg = parcelRequire("5PyYg");
const $b1b66edbf936e484$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $9dpiy.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $9P1rC.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $3T3O0.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $5PyYg.buildCredentials)(secOptions);
    const ignoreResponsePayload = (options === null || options === void 0 ? void 0 : options.ignoreResponsePayload) || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $85Uxt.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options !== null && options !== void 0 && options.reportTracingHeaders) {
            const tracingHeaders = (0, $3iFK1.extractTracingHeaders)(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $b1b66edbf936e484$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});



parcelRegister("bi2s0", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $93aaf95e785a8b17$export$4529f10aed0950d4);
class $93aaf95e785a8b17$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("5nwBg", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $9aae47eafb0cecb4$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $9aae47eafb0cecb4$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $9aae47eafb0cecb4$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $9aae47eafb0cecb4$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $9aae47eafb0cecb4$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $9aae47eafb0cecb4$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $9aae47eafb0cecb4$export$482549d945a3723);
var $9aae47eafb0cecb4$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $9aae47eafb0cecb4$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $9aae47eafb0cecb4$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $9aae47eafb0cecb4$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $9aae47eafb0cecb4$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $9aae47eafb0cecb4$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $9aae47eafb0cecb4$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("fFksa", function(module, exports) {
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $e1de470ddeb98eef$export$1466212a1606133);

var $dihY4 = parcelRequire("dihY4");

var $hfMr4 = parcelRequire("hfMr4");
const $e1de470ddeb98eef$export$1466212a1606133 = (providerType)=>{
    return (0, $hfMr4.withSampling)((0, $dihY4.ufoExperiences)['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("dihY4", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $acdb1e3c574393a3$export$615f888019c45765);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5bALc = parcelRequire("5bALc");

var $kjjrv = parcelRequire("kjjrv");

var $mx1V1 = parcelRequire("mx1V1");

var $5nwBg = parcelRequire("5nwBg");



const $acdb1e3c574393a3$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $mx1V1.ExperienceTypes).Load,
        performanceType: (0, $mx1V1.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $acdb1e3c574393a3$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $mx1V1.ExperienceTypes).Experience,
        performanceType: (0, $mx1V1.ExperiencePerformanceTypes).InlineResult
    };
};
const $acdb1e3c574393a3$var$customEmojiTimings = [
    {
        key: (0, $5nwBg.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $5nwBg.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $5nwBg.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $5nwBg.UfoEmojiTimings).METADATA_START,
        endMark: (0, $5nwBg.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $5nwBg.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $5nwBg.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $5nwBg.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $5nwBg.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $5nwBg.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $5nwBg.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $5nwBg.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $5nwBg.UfoEmojiTimings).ONLOAD_END
    }
];
const $acdb1e3c574393a3$export$615f888019c45765 = {
    'emoji-rendered': new (0, $5bALc.ConcurrentExperience)((0, $5nwBg.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $5nwBg.UfoComponentName).EMOJI
        },
        type: (0, $mx1V1.ExperienceTypes).Operation,
        performanceType: (0, $mx1V1.ExperiencePerformanceTypes).Custom,
        timings: $acdb1e3c574393a3$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $5bALc.ConcurrentExperience)((0, $5nwBg.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $acdb1e3c574393a3$var$createRenderExperience((0, $5nwBg.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $kjjrv.UFOExperience)((0, $5nwBg.UfoExperienceName).EMOJI_PICKER_OPENED, $acdb1e3c574393a3$var$createRenderExperience((0, $5nwBg.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $kjjrv.UFOExperience)((0, $5nwBg.UfoExperienceName).EMOJI_SELECTION_RECORDED, $acdb1e3c574393a3$var$createInlineExperience((0, $5nwBg.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $kjjrv.UFOExperience)((0, $5nwBg.UfoExperienceName).EMOJI_UPLOADED, $acdb1e3c574393a3$var$createInlineExperience((0, $5nwBg.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $kjjrv.UFOExperience)((0, $5nwBg.UfoExperienceName).EMOJI_SEARCHED, $acdb1e3c574393a3$var$createInlineExperience((0, $5nwBg.UfoComponentName).EMOJI_PICKER))
};

});
parcelRegister("5bALc", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $877e7b19743284bd$export$ac1cddfee07ba6ac);

var $ilcxD = parcelRequire("ilcxD");

var $kjjrv = parcelRequire("kjjrv");
class $877e7b19743284bd$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $kjjrv.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $ilcxD.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("ilcxD", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $dc8a2e91ba472807$export$b4958caff08a0960);

var $2AdXJ = parcelRequire("2AdXJ");
const $dc8a2e91ba472807$export$b4958caff08a0960 = (...args)=>{
    (0, $2AdXJ.ufologger).log(...args);
};

});
parcelRegister("2AdXJ", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $5e5e89568613ae88$export$4ab84f6f04f6566d);
class $5e5e89568613ae88$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($5e5e89568613ae88$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($5e5e89568613ae88$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $5e5e89568613ae88$export$4ab84f6f04f6566d = new $5e5e89568613ae88$var$UFOLogger();

});


parcelRegister("kjjrv", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $cb2c34d223bb0bc3$export$c00d22927c60484a);

var $fwwlj = parcelRequire("fwwlj");
class $cb2c34d223bb0bc3$export$c00d22927c60484a extends (0, $fwwlj.UFOAbstractExperience) {
}

});
parcelRegister("fwwlj", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $2dbc378edcdda5a8$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $k3ztA = parcelRequire("k3ztA");

var $2QKhb = parcelRequire("2QKhb");

var $55eXg = parcelRequire("55eXg");

var $8PXwF = parcelRequire("8PXwF");

var $gAJTL = parcelRequire("gAJTL");

var $ilcxD = parcelRequire("ilcxD");

var $33U1B = parcelRequire("33U1B");

var $3XsQs = parcelRequire("3XsQs");

var $8zQuQ = parcelRequire("8zQuQ");

var $eck2x = parcelRequire("eck2x");

var $g9Nle = parcelRequire("g9Nle");

var $aVqLl = parcelRequire("aVqLl");

var $mx1V1 = parcelRequire("mx1V1");

var $75Co5 = parcelRequire("75Co5");
const $2dbc378edcdda5a8$var$getPageVisibleState = ()=>{
    return !(0, $eck2x.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $8zQuQ.PageVisibleState).VISIBLE : (0, $8zQuQ.PageVisibleState).HIDDEN;
};
class $2dbc378edcdda5a8$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g9Nle.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $8zQuQ.PageVisibleState).MIXED;
            (0, $3XsQs.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $2dbc378edcdda5a8$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $mx1V1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $mx1V1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $ilcxD.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $aVqLl.canTransition)(this.state, newState)) {
            (0, $ilcxD.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g9Nle.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $75Co5.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $7RHfd.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $75Co5.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $55eXg.getGlobalEventStream)().push((0, $gAJTL.unsubscribeEvent)((0, $8zQuQ.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $ilcxD.ufolog)('this.parent', this.parent);
                (0, $55eXg.getGlobalEventStream)().push((0, $2QKhb.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $ilcxD.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $33U1B.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g9Nle.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $2dbc378edcdda5a8$var$getPageVisibleState();
            (0, $3XsQs.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $ilcxD.ufolog)('subscribed', this.id);
                (0, $55eXg.getGlobalEventStream)().push((0, $8PXwF.subscribeEvent)((0, $8zQuQ.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $8zQuQ.FMP_MARK) && name !== (0, $8zQuQ.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $33U1B.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $75Co5.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $g9Nle.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $8zQuQ.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $8zQuQ.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $33U1B.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $3XsQs.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g9Nle.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g9Nle.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g9Nle.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $ilcxD.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $k3ztA.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("k3ztA", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $bfe686294d649cdd$export$2295b861f318254a);
// temp solution until we can get it automated
const $bfe686294d649cdd$export$2295b861f318254a = '0.1.5';

});

parcelRegister("2QKhb", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $6bf4344f6d8db137$export$7c957416596ca127);

var $8zQuQ = parcelRequire("8zQuQ");
const $6bf4344f6d8db137$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $8zQuQ.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("8zQuQ", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $d7e0462f0bae1b19$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $d7e0462f0bae1b19$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $d7e0462f0bae1b19$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $d7e0462f0bae1b19$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $d7e0462f0bae1b19$export$837e0f79a8056912);
var $d7e0462f0bae1b19$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $d7e0462f0bae1b19$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $d7e0462f0bae1b19$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $d7e0462f0bae1b19$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $d7e0462f0bae1b19$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $d7e0462f0bae1b19$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $d7e0462f0bae1b19$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $d7e0462f0bae1b19$export$9f2bf58999404c75 = 'fmp';
const $d7e0462f0bae1b19$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("55eXg", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $d791aedc03764025$export$6123a44dc2384540);

var $fVmiH = parcelRequire("fVmiH");
const $d791aedc03764025$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $fVmiH.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("fVmiH", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $a8d9c25cbd12a2cf$export$d8b468db8a225bc9);
const $a8d9c25cbd12a2cf$export$d8b468db8a225bc9 = 250;

});


parcelRegister("8PXwF", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $2a0c21ed0c2c7cb0$export$37863216db4b714d);

var $8zQuQ = parcelRequire("8zQuQ");
const $2a0c21ed0c2c7cb0$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $8zQuQ.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("gAJTL", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $7a037deeea13291f$export$ee1a7bd1fc9ea85e);

var $8zQuQ = parcelRequire("8zQuQ");
const $7a037deeea13291f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $8zQuQ.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("33U1B", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $0daaf6fe015f6e71$export$d53d07b6034c4560);

var $2AdXJ = parcelRequire("2AdXJ");
const $0daaf6fe015f6e71$export$d53d07b6034c4560 = (...args)=>{
    (0, $2AdXJ.ufologger).warn(...args);
};

});

parcelRegister("3XsQs", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $fc18eb2f397dcec6$export$13e680397ec8f3eb);

var $eck2x = parcelRequire("eck2x");
class $fc18eb2f397dcec6$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $eck2x.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $fc18eb2f397dcec6$export$13e680397ec8f3eb = new $fc18eb2f397dcec6$var$VisibilityChangeObserver();

});
parcelRegister("eck2x", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $2128aca19e524a34$export$15e172712955e18f);
const $2128aca19e524a34$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("g9Nle", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $caf4a8d5e1db21a2$export$81b70111112841a0);
const $caf4a8d5e1db21a2$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("aVqLl", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $5d40a247501b6d40$export$178881f329fdb81f);

var $g9Nle = parcelRequire("g9Nle");
const $5d40a247501b6d40$var$UFOStateAvailableTransitions = {
    [(0, $g9Nle.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g9Nle.UFOExperienceState).STARTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).STARTED.id]: [
        (0, $g9Nle.UFOExperienceState).IN_PROGRESS.id,
        (0, $g9Nle.UFOExperienceState).BLOCKED.id,
        (0, $g9Nle.UFOExperienceState).SUCCEEDED.id,
        (0, $g9Nle.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g9Nle.UFOExperienceState).FAILED.id,
        (0, $g9Nle.UFOExperienceState).ABORTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g9Nle.UFOExperienceState).BLOCKED.id,
        (0, $g9Nle.UFOExperienceState).SUCCEEDED.id,
        (0, $g9Nle.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g9Nle.UFOExperienceState).FAILED.id,
        (0, $g9Nle.UFOExperienceState).ABORTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).BLOCKED.id]: [
        (0, $g9Nle.UFOExperienceState).RECOVERED.id,
        (0, $g9Nle.UFOExperienceState).ABORTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).RECOVERED.id]: [
        (0, $g9Nle.UFOExperienceState).STARTED.id,
        (0, $g9Nle.UFOExperienceState).SUCCEEDED.id,
        (0, $g9Nle.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g9Nle.UFOExperienceState).FAILED.id,
        (0, $g9Nle.UFOExperienceState).ABORTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g9Nle.UFOExperienceState).STARTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g9Nle.UFOExperienceState).SUCCEEDED.id,
        (0, $g9Nle.UFOExperienceState).FAILED.id,
        (0, $g9Nle.UFOExperienceState).ABORTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).FAILED.id]: [
        (0, $g9Nle.UFOExperienceState).STARTED.id
    ],
    [(0, $g9Nle.UFOExperienceState).ABORTED.id]: [
        (0, $g9Nle.UFOExperienceState).STARTED.id
    ]
};
const $5d40a247501b6d40$export$178881f329fdb81f = (state1, state2)=>{
    return $5d40a247501b6d40$var$UFOStateAvailableTransitions[state1.id] && $5d40a247501b6d40$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("mx1V1", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $e4f7783b9d4395ae$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $e4f7783b9d4395ae$export$cc26007c03242fff);
var $e4f7783b9d4395ae$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $e4f7783b9d4395ae$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("75Co5", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $ebc66a9bec8674f8$export$c753e8669d30c8ad);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eiYbX = parcelRequire("eiYbX");
const $ebc66a9bec8674f8$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $eiYbX.roundPerfNow)();
};

});
parcelRegister("eiYbX", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $32139aeb58558037$export$5f490af6b2b115cf);
const $32139aeb58558037$export$5f490af6b2b115cf = ()=>~~performance.now();

});






parcelRegister("hfMr4", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $9779ba6785f9823f$export$dc2f0946255b3f89);

var $4OzJF = parcelRequire("4OzJF");

var $rBDj4 = parcelRequire("rBDj4");
const $9779ba6785f9823f$var$hasSampledFromStart = (experience)=>{
    if (!(0, $rBDj4.ufoExperiencesSampled)[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return (0, $rBDj4.ufoExperiencesSampled)[experience.id].sampledInstance[experience.instanceId];
    return (0, $rBDj4.ufoExperiencesSampled)[experience.id].sampled;
};
const $9779ba6785f9823f$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!(0, $rBDj4.ufoExperiencesSampled)[ufoExperience.id]) (0, $rBDj4.ufoExperiencesSampled)[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || (0, $4OzJF.isExperienceSampled);
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) (0, $rBDj4.ufoExperiencesSampled)[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            (0, $rBDj4.ufoExperiencesSampled)[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            (0, $rBDj4.ufoExperiencesSampled)[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            (0, $rBDj4.ufoExperiencesSampled)[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$9779ba6785f9823f$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});
parcelRegister("4OzJF", function(module, exports) {
$parcel$export(module.exports, "isExperienceSampled", () => $a363436af28140bc$export$1c967630b3ea2d58);
/**
 * A random sampling function
 * sampling algorithm is from @atlassian/jira-coinflip at https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/platform/app-framework/coinflip/src/index.tsx
 * E.g. isExperienceSampled(2) will pass 50% of the time
 * @param rate The chance that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ // default sampling function to determine which one to be sampled
const $a363436af28140bc$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};

});

parcelRegister("rBDj4", function(module, exports) {
$parcel$export(module.exports, "ufoExperiencesSampled", () => $36a3220957e085c8$export$c7c4959fece2f3ec);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 


const $36a3220957e085c8$export$c7c4959fece2f3ec = {};

});



parcelRegister("g3vc1", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $1f94b41c50d67cf8$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $1f94b41c50d67cf8$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $1f94b41c50d67cf8$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $1f94b41c50d67cf8$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $1f94b41c50d67cf8$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $1f94b41c50d67cf8$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $1f94b41c50d67cf8$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $1f94b41c50d67cf8$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $1f94b41c50d67cf8$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $1f94b41c50d67cf8$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $1f94b41c50d67cf8$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $1f94b41c50d67cf8$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $1f94b41c50d67cf8$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $1f94b41c50d67cf8$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $1f94b41c50d67cf8$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $1f94b41c50d67cf8$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $1f94b41c50d67cf8$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $1f94b41c50d67cf8$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $1f94b41c50d67cf8$export$8efb414216030943);
$parcel$export(module.exports, "defaultInlineEmojiHeight", () => $1f94b41c50d67cf8$export$4adebc94e462aea5);
$parcel$export(module.exports, "emojiPickerWidth", () => $1f94b41c50d67cf8$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $1f94b41c50d67cf8$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $1f94b41c50d67cf8$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $1f94b41c50d67cf8$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerListHeightNew", () => $1f94b41c50d67cf8$export$9f36457335d8859f);
$parcel$export(module.exports, "emojiPickerPreviewHeight", () => $1f94b41c50d67cf8$export$e218e5cb105a0e22);
$parcel$export(module.exports, "localStoragePrefix", () => $1f94b41c50d67cf8$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $1f94b41c50d67cf8$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "selectedProductivityColorStorageKey", () => $1f94b41c50d67cf8$export$ec5e3f6f684720d7);
$parcel$export(module.exports, "defaultCategories", () => $1f94b41c50d67cf8$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $1f94b41c50d67cf8$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $1f94b41c50d67cf8$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1f94b41c50d67cf8$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $1f94b41c50d67cf8$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $1f94b41c50d67cf8$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $1f94b41c50d67cf8$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $1f94b41c50d67cf8$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $1f94b41c50d67cf8$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $1f94b41c50d67cf8$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $1f94b41c50d67cf8$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $1f94b41c50d67cf8$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $1f94b41c50d67cf8$export$66cabad5e268b05e);
const $1f94b41c50d67cf8$export$5e4e3d1c3e43156a = 'CUSTOM';
const $1f94b41c50d67cf8$export$78ccdc4be403c468 = 'FREQUENT';
const $1f94b41c50d67cf8$export$2c4b04c3aacdf1b3 = 'SITE';
const $1f94b41c50d67cf8$export$1b0258512be88334 = 'SEARCH';
const $1f94b41c50d67cf8$export$42b510423367f354 = 'USER_CUSTOM';
const $1f94b41c50d67cf8$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $1f94b41c50d67cf8$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $1f94b41c50d67cf8$export$8ac325bfd32359b0 = 'data:';
const $1f94b41c50d67cf8$export$a330961542edfe6f = 'delete-emoji';
const $1f94b41c50d67cf8$export$1a817f1886276c6d = 100000;
const $1f94b41c50d67cf8$export$2e7088017339c92 = 28;
const $1f94b41c50d67cf8$export$4cb591b57c224c0 = 26;
const $1f94b41c50d67cf8$export$b31a41e904161dc1 = 24;
const $1f94b41c50d67cf8$export$7dd039b460c61389 = 22;
const $1f94b41c50d67cf8$export$96ee6614460413a0 = 24.25;
const $1f94b41c50d67cf8$export$103771a4cd74af90 = 22.25;
const $1f94b41c50d67cf8$export$5cc2afcf38309ce9 = 20.25;
const $1f94b41c50d67cf8$export$9a9984214a4bd724 = 18.25;
const $1f94b41c50d67cf8$export$3f99ac31dc0406db = 20;
const $1f94b41c50d67cf8$export$8efb414216030943 = 16.25;
const $1f94b41c50d67cf8$export$4adebc94e462aea5 = 16;
const $1f94b41c50d67cf8$export$d171dc12fee2b1da = 350;
const $1f94b41c50d67cf8$export$c10ac8125a260041 = 80;
const $1f94b41c50d67cf8$export$5248fb9e0cccc41f = 'medium';
const $1f94b41c50d67cf8$export$94f75d625e7801d3 = 260;
const $1f94b41c50d67cf8$export$7ed599d166d65aea = 295;
const $1f94b41c50d67cf8$export$7722b8e9522021df = $1f94b41c50d67cf8$export$7ed599d166d65aea - 58; // picker height - actions height
const $1f94b41c50d67cf8$export$9f36457335d8859f = $1f94b41c50d67cf8$export$7ed599d166d65aea - 102; // picker height - actions height - preview height
const $1f94b41c50d67cf8$export$e218e5cb105a0e22 = 54;
const $1f94b41c50d67cf8$export$e67f617938b111f1 = $1f94b41c50d67cf8$export$7ed599d166d65aea + $1f94b41c50d67cf8$export$e218e5cb105a0e22;
const $1f94b41c50d67cf8$export$e394a0c530ae5631 = 'fabric.emoji';
const $1f94b41c50d67cf8$export$79ee4ef84c545f8f = `${$1f94b41c50d67cf8$export$e394a0c530ae5631}.selectedTone`;
const $1f94b41c50d67cf8$export$ec5e3f6f684720d7 = `${$1f94b41c50d67cf8$export$e394a0c530ae5631}.selectedProductivityColor`;
const $1f94b41c50d67cf8$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $1f94b41c50d67cf8$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $1f94b41c50d67cf8$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $1f94b41c50d67cf8$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $1f94b41c50d67cf8$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $1f94b41c50d67cf8$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $1f94b41c50d67cf8$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $1f94b41c50d67cf8$export$4f0ee90b28d6efc5 = 0;
const $1f94b41c50d67cf8$export$9f7de4293d27f3aa = 50;
const $1f94b41c50d67cf8$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $1f94b41c50d67cf8$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $1f94b41c50d67cf8$export$2829f3ec323f8ec0 = 8;
const $1f94b41c50d67cf8$export$ce3a0e7d2d7d6ba2 = 5;
const $1f94b41c50d67cf8$export$858e8dc100a97278 = 150;
const $1f94b41c50d67cf8$export$83aab2ae64548423 = 20;
const $1f94b41c50d67cf8$export$66cabad5e268b05e = 100;

});

parcelRegister("4CEaO", function(module, exports) {
$parcel$export(module.exports, "isMediaEmoji", () => $6097ef5cbff7d0b1$export$a7e82c67204c73a1);

var $hSdEI = parcelRequire("hSdEI");
const $6097ef5cbff7d0b1$export$a7e82c67204c73a1 = (emoji)=>(0, $hSdEI.isMediaRepresentation)(emoji.representation);

});
parcelRegister("hSdEI", function(module, exports) {
$parcel$export(module.exports, "isMediaRepresentation", () => $ae7e79e0180b3391$export$979133dc1df141c6);
const $ae7e79e0180b3391$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);

});


parcelRegister("2D4MI", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $e3c23810492f1bfd$export$4369c812aac99591);
const $e3c23810492f1bfd$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("cz2rC", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ca078795629944c$export$2e2bcd8739ae039);
let $5ca078795629944c$var$debugEnabled = false;
let $5ca078795629944c$var$stacktracesEnabled = false;
function $5ca078795629944c$export$748ada60eaf985cc(enable) {
    $5ca078795629944c$var$debugEnabled = enable;
}
function $5ca078795629944c$export$4f7017086af31c25(enable) {
    $5ca078795629944c$var$stacktracesEnabled = enable;
}
function $5ca078795629944c$export$2a858f450a2f66d() {
    if ($5ca078795629944c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $5ca078795629944c$export$2e2bcd8739ae039(msg, ...args) {
    if ($5ca078795629944c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("lNUA5", function(module, exports) {
$parcel$export(module.exports, "default", () => $587d46b6802eb1da$export$2e2bcd8739ae039);
function $587d46b6802eb1da$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("evJGV", function(module, exports) {
$parcel$export(module.exports, "isTeamoji26RefreshEmojiPickerEnabled", () => $e8021d4ab0008eea$export$d3d82041d1da4810);
$parcel$export(module.exports, "isTeamoji26RefreshEmojiPickerEnabledNoExposure", () => $e8021d4ab0008eea$export$add750f502661ce2);

var $3y2s4 = parcelRequire("3y2s4");

var $3zzvD = parcelRequire("3zzvD");

var $gdUUy = parcelRequire("gdUUy");
const $e8021d4ab0008eea$export$7f51f2cb676ac0b1 = 'platform_teamoji_26_refresh_emoji_picker';
const $e8021d4ab0008eea$export$646c576b40b78446 = 'platform_teamoji_26_refresh_emoji_picker_canvas';
const $e8021d4ab0008eea$export$2f62567589088da2 = 'platform_teamoji_26_refresh_emoji_picker_user_id';
const $e8021d4ab0008eea$export$be9db91c80d43cc2 = 'platform_bitbucket_fix_shortname_and_ordering';
const $e8021d4ab0008eea$export$d3d82041d1da4810 = ()=>{
    return (0, $3y2s4.isExperimentEnabled)($e8021d4ab0008eea$export$7f51f2cb676ac0b1) || (0, $3y2s4.isExperimentEnabled)($e8021d4ab0008eea$export$646c576b40b78446) || (0, $gdUUy.fg)($e8021d4ab0008eea$export$2f62567589088da2) || (0, $gdUUy.fg)($e8021d4ab0008eea$export$be9db91c80d43cc2);
};
const $e8021d4ab0008eea$export$add750f502661ce2 = ()=>{
    return (0, $3zzvD.UNSAFE_expValNoExposure)($e8021d4ab0008eea$export$7f51f2cb676ac0b1, 'isEnabled', false) === true || (0, $3zzvD.UNSAFE_expValNoExposure)($e8021d4ab0008eea$export$646c576b40b78446, 'isEnabled', false) === true || (0, $gdUUy.fg)($e8021d4ab0008eea$export$2f62567589088da2) || (0, $gdUUy.fg)($e8021d4ab0008eea$export$be9db91c80d43cc2);
};

});
parcelRegister("3zzvD", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_expValNoExposure", () => $bfe7c50a73e7783f$export$da472ee01c19d92e);

var $lBMNf = parcelRequire("lBMNf");
function $bfe7c50a73e7783f$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $lBMNf.expValInternal)(experimentName, param, defaultValue, false);
}

});


parcelRegister("aD9pN", function(module, exports) {
$parcel$export(module.exports, "promiseWithTimeout", () => $50859ff7f14523e8$export$a9cd205a244d9f54);
function $50859ff7f14523e8$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});

parcelRegister("aR8hx", function(module, exports) {
$parcel$export(module.exports, "toEmojiId", () => $d728475920f4bf7a$export$8d7d3de6b5b305d1);
const $d728475920f4bf7a$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });

});

parcelRegister("bwDBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d0be3309c9ff63$export$2e2bcd8739ae039);

var $e4FL0 = parcelRequire("e4FL0");

var $bU1oC = parcelRequire("bU1oC");

var $krm12 = parcelRequire("krm12");
/**
 * Shared cache of in-flight/resolved emoji load promises, keyed by the request URL so that
 * multiple loaders created for the same provider config reuse a single request instead of
 * refetching.
 */ const $59d0be3309c9ff63$var$emojiPromiseCache = new Map();
class $59d0be3309c9ff63$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
   * Returns a promise with an array of Emoji from all providers.
   */ loadEmoji() {
        // The cache is module-level and outlives individual loaders, so under test it would leak
        // responses between cases sharing a provider url. Always refetch there instead.
        if ((0, $e4FL0.isTestEnvironment)()) return this.fetchEmoji();
        const cacheKey = this.config.url;
        const cachedPromise = $59d0be3309c9ff63$var$emojiPromiseCache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const emojiPromise = this.fetchEmoji();
        // Evict on failure so a rejected promise is not cached, allowing retries to refetch.
        emojiPromise.catch(()=>{
            if ($59d0be3309c9ff63$var$emojiPromiseCache.get(cacheKey) === emojiPromise) $59d0be3309c9ff63$var$emojiPromiseCache.delete(cacheKey);
        });
        $59d0be3309c9ff63$var$emojiPromiseCache.set(cacheKey, emojiPromise);
        return emojiPromise;
    }
    fetchEmoji() {
        return (0, $krm12.emojiRequest)(this.config).then((emojiServiceResponse)=>(0, $bU1oC.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("e4FL0", function(module, exports) {
$parcel$export(module.exports, "isTestEnvironment", () => $1f723108a75e9747$export$43ea16ac36fe59f1);
/**
 * Detects Jest unit tests and automated browsers (Playwright and other WebDriver-based drivers).
 *
 * Used to opt out of module-level caching that outlives individual instances. Such a cache leaks
 * state between test cases that share an input, which makes tests order-dependent and forces every
 * consumer to reset shared internals from their own suites.
 */ 
var $4eGW1 = parcelRequire("4eGW1");
function $1f723108a75e9747$export$43ea16ac36fe59f1() {
    try {
        var _process, _process2;
        return Boolean(typeof $4eGW1 !== 'undefined' && (// NODE_ENV can be overridden by consumers, so also check for a Jest worker
        ((_process = $4eGW1) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.NODE_ENV) === 'test' || ((_process2 = $4eGW1) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.JEST_WORKER_ID) !== undefined) || // Playwright serves examples with NODE_ENV=development, but sets navigator.webdriver
        typeof navigator !== 'undefined' && navigator.webdriver);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});

parcelRegister("bU1oC", function(module, exports) {
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $54e5c81f0b0095b3$export$afaea97e40b5ca70);

var $d4Oym = parcelRequire("d4Oym");

var $73Dsf = parcelRequire("73Dsf");

var $a4VhI = parcelRequire("a4VhI");

var $biVH8 = parcelRequire("biVH8");
const $54e5c81f0b0095b3$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = (0, $a4VhI.denormaliseServiceRepresentation)(emoji.representation, emojiData.meta);
        const altRepresentation = (0, $73Dsf.denormaliseServiceAltRepresentation)(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = (0, $biVH8.denormaliseSkinEmoji)(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: _representation, skinVariations: _skinVariations, altRepresentations: _altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $d4Oym.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};

});
parcelRegister("d4Oym", function(module, exports) {
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $73a1499cf3ac814b$export$a48c58c688a3131);
const $73a1499cf3ac814b$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};

});

parcelRegister("73Dsf", function(module, exports) {
$parcel$export(module.exports, "denormaliseServiceAltRepresentation", () => $1c83d8777f999f49$export$aa9faa01267cb2e7);

var $a4VhI = parcelRequire("a4VhI");

var $5oXnj = parcelRequire("5oXnj");
const $1c83d8777f999f49$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : (0, $a4VhI.denormaliseServiceRepresentation)((0, $5oXnj.getAltRepresentation)(altReps), meta);
};

});
parcelRegister("a4VhI", function(module, exports) {
$parcel$export(module.exports, "denormaliseServiceRepresentation", () => $c8ed1ae402dabbba$export$55077db3efc820aa);

var $hTWkC = parcelRequire("hTWkC");

var $61jKi = parcelRequire("61jKi");

var $1su03 = parcelRequire("1su03");

var $cz2rC = parcelRequire("cz2rC");

var $fejqJ = parcelRequire("fejqJ");
const $c8ed1ae402dabbba$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $1su03.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $61jKi.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ((0, $fejqJ.isMediaApiUrl)(imagePath, meta)) return (0, $hTWkC.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $cz2rC.default)('failed conversion for representation', representation, meta);
    return undefined;
};

});
parcelRegister("hTWkC", function(module, exports) {
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $40e01615a6a60817$export$20a1bd1d33069ce7);
const $40e01615a6a60817$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });

});

parcelRegister("61jKi", function(module, exports) {
$parcel$export(module.exports, "isImageRepresentation", () => $6f7f290e8f2042fe$export$90b099a26fbd8b41);
const $6f7f290e8f2042fe$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);

});

parcelRegister("1su03", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $61c6b29a5fbb8f52$export$1c52f72b88b558e8);
const $61c6b29a5fbb8f52$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);

});

parcelRegister("fejqJ", function(module, exports) {
$parcel$export(module.exports, "isMediaApiUrl", () => $e6b54869a5907f50$export$db05e6ae1fd416af);
const $e6b54869a5907f50$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);

});


parcelRegister("5oXnj", function(module, exports) {
$parcel$export(module.exports, "getAltRepresentation", () => $d1c42010fea71547$export$4a0301d636367e1d);

var $cLR9b = parcelRequire("cLR9b");

var $3QKqR = parcelRequire("3QKqR");
const $d1c42010fea71547$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[(0, $cLR9b.calculateScale)((0, $3QKqR.getPixelRatio)).altScale];
};

});
parcelRegister("cLR9b", function(module, exports) {
$parcel$export(module.exports, "calculateScale", () => $014a89d5dbc6402c$export$1d78826433168f34);

var $5N1Y4 = parcelRequire("5N1Y4");
const $014a89d5dbc6402c$export$1d78826433168f34 = (getRatio)=>{
    if ((0, $5N1Y4.expValEquals)('platform_editor_emoji_default_scale', 'isEnabled', true)) {
        // retina display
        if (getRatio() > 1) return {
            scale: 'XXXHDPI',
            altScale: 'XXXHDPI'
        };
        // default set used for desktop
        return {
            altScale: 'XXXHDPI'
        };
    }
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};

});
parcelRegister("5N1Y4", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $08a9a903e3d8f88f$export$45abdb3f977b5b14);

var $lfAfy = parcelRequire("lfAfy");
function $08a9a903e3d8f88f$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $lfAfy.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("lfAfy", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $ffcf57b2b3059c99$export$58e581060588c6bb);

var $87QgR = parcelRequire("87QgR");

var $i2aoZ = parcelRequire("i2aoZ");

var $1ojCy = parcelRequire("1ojCy");

var $hj2cZ = parcelRequire("hj2cZ");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
const $ffcf57b2b3059c99$var$allowsProductKeys = [
    'cc-maui-experiment',
    'platform_use_unicode_emojis'
];
function $ffcf57b2b3059c99$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon;
    if ((0, $hj2cZ._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $hj2cZ._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $87QgR.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKeyName = $ffcf57b2b3059c99$var$allowsProductKeys.includes(experimentName) ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ((_editorExperimentsCon = (0, $1ojCy.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 || (_editorExperimentsCon = _editorExperimentsCon.productKeys) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon[0, $hj2cZ._product]) ?? experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $87QgR.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $i2aoZ.addFeatureFlagAccessed)(`${experimentKeyName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("1ojCy", function(module, exports) {
$parcel$export(module.exports, "disallowsProductKeys", () => $85e2e82dbf9744ac$export$5c897d5297c5b7fd);
$parcel$export(module.exports, "editorExperimentsConfig", () => $85e2e82dbf9744ac$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gkRLl = parcelRequire("gkRLl");

var $bI6Uq = parcelRequire("bI6Uq");
const $85e2e82dbf9744ac$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness'
];
const $85e2e82dbf9744ac$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-08-08
    'example-boolean': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $gkRLl.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $bI6Uq.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("gkRLl", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $258dcaad93ac7d88$export$456f1587c9c92021);

var $aej39 = parcelRequire("aej39");
function $258dcaad93ac7d88$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $aej39.isBoolean),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("aej39", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $9f59c37821a90b5c$export$f9ce7b637dfbe238);
function $9f59c37821a90b5c$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("bI6Uq", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $7c6ac7e98b6bc664$export$fb89e8a786694d1);

var $cqtqz = parcelRequire("cqtqz");
function $7c6ac7e98b6bc664$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        // Maintains the tuple
        typeGuard: (0, $cqtqz.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("cqtqz", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $e7cfdd8ed2adc9b7$export$a9a18ae5ba42aeab);

var $4eGW1 = parcelRequire("4eGW1");
var $e7cfdd8ed2adc9b7$var$_process, $e7cfdd8ed2adc9b7$var$_process2;
const $e7cfdd8ed2adc9b7$var$IS_TESTING_ENV = typeof $4eGW1 !== 'undefined' && ((($e7cfdd8ed2adc9b7$var$_process = $4eGW1) === null || $e7cfdd8ed2adc9b7$var$_process === void 0 || ($e7cfdd8ed2adc9b7$var$_process = $e7cfdd8ed2adc9b7$var$_process.env) === null || $e7cfdd8ed2adc9b7$var$_process === void 0 ? void 0 : $e7cfdd8ed2adc9b7$var$_process.NODE_ENV) === 'test' || (($e7cfdd8ed2adc9b7$var$_process2 = $4eGW1) === null || $e7cfdd8ed2adc9b7$var$_process2 === void 0 || ($e7cfdd8ed2adc9b7$var$_process2 = $e7cfdd8ed2adc9b7$var$_process2.env) === null || $e7cfdd8ed2adc9b7$var$_process2 === void 0 ? void 0 : $e7cfdd8ed2adc9b7$var$_process2.JEST_WORKER_ID) !== undefined);
function $e7cfdd8ed2adc9b7$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($e7cfdd8ed2adc9b7$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("hj2cZ", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $e647d25dbe8f7b9c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $e647d25dbe8f7b9c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $e647d25dbe8f7b9c$export$cf7305fc65acbf0d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6TXKZ = parcelRequire("6TXKZ");

var $1ojCy = parcelRequire("1ojCy");
let $e647d25dbe8f7b9c$export$e5d73bf4f8e2ae96 = {};
let $e647d25dbe8f7b9c$export$4e849416bb5c5b52 = {};
let $e647d25dbe8f7b9c$export$cf7305fc65acbf0d;
function $e647d25dbe8f7b9c$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $1ojCy.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $e647d25dbe8f7b9c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $1ojCy.editorExperimentsConfig)).map(([key, value])=>{
            var _groupOverrides;
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                ((_groupOverrides = groupOverrides) === null || _groupOverrides === void 0 ? void 0 : _groupOverrides[key]) ?? (0, $6TXKZ.testMultivariateOverrides)[key] ?? (0, $6TXKZ.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $e647d25dbe8f7b9c$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $e647d25dbe8f7b9c$export$cf7305fc65acbf0d = product;
    $e647d25dbe8f7b9c$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("6TXKZ", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $339a9035008aea2b$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $339a9035008aea2b$export$54960937bb713f97);
const $339a9035008aea2b$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
const $339a9035008aea2b$export$54960937bb713f97 = {
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false
};

});





parcelRegister("3QKqR", function(module, exports) {
$parcel$export(module.exports, "getPixelRatio", () => $8f238b920c8bcb2e$export$d39ce20a37bba061);
const $8f238b920c8bcb2e$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};

});



parcelRegister("biVH8", function(module, exports) {
$parcel$export(module.exports, "denormaliseSkinEmoji", () => $911fd274c6faabe4$export$e3da49c88c2e54d5);

var $73Dsf = parcelRequire("73Dsf");

var $a4VhI = parcelRequire("a4VhI");
const $911fd274c6faabe4$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: _representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: (0, $a4VhI.denormaliseServiceRepresentation)(skin.representation, meta),
            altRepresentation: (0, $73Dsf.denormaliseServiceAltRepresentation)(altRepresentations, meta),
            ...other
        };
    });
};

});


parcelRegister("krm12", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $a518dd54a655f0e6$export$ea1accde4cc117f4);

var $1N0Bi = parcelRequire("1N0Bi");

var $cLR9b = parcelRequire("cLR9b");

var $3QKqR = parcelRequire("3QKqR");
const $a518dd54a655f0e6$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = (0, $3QKqR.getPixelRatio), ...serviceConfig } = provider;
    const scaleQueryParams = (0, $cLR9b.calculateScale)(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $1N0Bi.utils).requestService(serviceConfig, requestOptions);
};

});


parcelRegister("QdTGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f21ecbc5340edf1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $8piaq = parcelRequire("8piaq");

var $5nwBg = parcelRequire("5nwBg");

var $g3vc1 = parcelRequire("g3vc1");

var $6pVnK = parcelRequire("6pVnK");

var $6sSoV = parcelRequire("6sSoV");

var $evJGV = parcelRequire("evJGV");

var $9LHvs = parcelRequire("9LHvs");

var $eCyIm = parcelRequire("eCyIm");

var $clO7z = parcelRequire("clO7z");

var $4okJk = parcelRequire("4okJk");

var $9EAL2 = parcelRequire("9EAL2");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $8f21ecbc5340edf1$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $9LHvs.tokenizerRegex).lastIndex = 0;
        while((match = (0, $9LHvs.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $8f21ecbc5340edf1$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $6sSoV.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$8f21ecbc5340edf1$var$addAllVariants(variation, fnKey, map));
    }
};
const $8f21ecbc5340edf1$var$findByKey = (map, key, emojiProviderLookupOrder)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) {
        if (emojiProviderLookupOrder !== null && emojiProviderLookupOrder !== void 0 && emojiProviderLookupOrder.length) for (const emojiType of emojiProviderLookupOrder){
            const matchingEmoji = emojis.find((emoji)=>emoji.type === emojiType);
            if (matchingEmoji) return matchingEmoji;
        }
        // Priority is always to source from the last emoji set (last overrides first)
        return emojis[emojis.length - 1];
    }
    return undefined;
};
const $8f21ecbc5340edf1$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $8f21ecbc5340edf1$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
const $8f21ecbc5340edf1$var$isRefreshEmojiPickerEnabled = ()=>{
    return (0, $evJGV.isTeamoji26RefreshEmojiPickerEnabled)();
};
class $8f21ecbc5340edf1$export$2e2bcd8739ae039 {
    static #_ = this.defaultEmojiWeight = 1000000;
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
   * Returns all available (and searchable) emoji in some default order.
   */ all() {
        const options = {
            sort: (0, $5nwBg.SearchSort).None
        };
        return this.search('', options);
    }
    /**
   * Text search of emoji shortName and name field for suitable matches.
   *
   * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
   *
   * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
   * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
   * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
   */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $8f21ecbc5340edf1$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
   * Returns all emoji with matching shortName
   */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
   * Returns the first matching emoji matching the shortName, or null if none found.
   */ findByShortName(shortName, emojiProviderLookupOrder) {
        return $8f21ecbc5340edf1$var$findByKey(this.shortNameMap, shortName, emojiProviderLookupOrder);
    }
    /**
   * Returns the first matching emoji matching the id, or null if none found.
   */ findById(id) {
        return $8f21ecbc5340edf1$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $g3vc1.frequentCategory)) return this.getFrequentlyUsed();
        else if (categoryId === 'ATLASSIAN') return this.all().emojis.filter((emoji)=>emoji.category === categoryId || emoji.type === 'ATLASSIAN');
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
   * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
   * there are none.
   *
   * @param options optional settings to be applied to the set of frequently used emoji
   */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
   * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
   * in sorting, etc).
   *
   * @param emoji the emoji that was just used
   */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $g3vc1.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $g3vc1.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $8f21ecbc5340edf1$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $5nwBg.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $5nwBg.SearchSort).Default) comparator = (0, $clO7z.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $5nwBg.SearchSort).UsageFrequency) comparator = (0, $4okJk.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return (0, $eCyIm.getEmojiVariation)(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $9EAL2.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        // When emojis are deleted - the repository is re-initialised.
        // This invalidates the full search index that's lazily loaded later
        this.fullSearchReady = false;
    }
    /**
   * Optimisation to initialise all map member variables in single loop over emojis
   */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(this.getDynamicCategoryForEmoji(emoji));
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $g3vc1.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $g3vc1.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $8piaq.Search)('id');
        this.fullSearch.tokenizer = new $8f21ecbc5340edf1$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $8piaq.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        if ($8f21ecbc5340edf1$var$isRefreshEmojiPickerEnabled()) this.fullSearch.addIndex('keywords');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $8f21ecbc5340edf1$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $8f21ecbc5340edf1$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $8f21ecbc5340edf1$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $8f21ecbc5340edf1$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = this.getDynamicCategoryForEmoji(emoji);
        if ((0, $g3vc1.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
    getDynamicCategoryForEmoji(emoji) {
        const category = (0, $6pVnK.getCategoryId)(emoji);
        if (emoji.type === 'ATLASSIAN' && category !== (0, $g3vc1.frequentCategory)) return 'ATLASSIAN';
        return category;
    }
}

});
parcelRegister("8piaq", function(module, exports) {
$parcel$export(module.exports, "UnorderedSearchIndex", () => $61eec023a6bef997$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $61eec023a6bef997$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $61eec023a6bef997$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $61eec023a6bef997$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $61eec023a6bef997$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $61eec023a6bef997$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $61eec023a6bef997$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $61eec023a6bef997$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $61eec023a6bef997$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    };
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $61eec023a6bef997$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $61eec023a6bef997$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    };
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $61eec023a6bef997$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $61eec023a6bef997$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($61eec023a6bef997$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $61eec023a6bef997$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $61eec023a6bef997$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$61eec023a6bef997$export$eeaf491a400e882a.constructor = false;
$61eec023a6bef997$export$eeaf491a400e882a.hasOwnProperty = false;
$61eec023a6bef997$export$eeaf491a400e882a.isPrototypeOf = false;
$61eec023a6bef997$export$eeaf491a400e882a.propertyIsEnumerable = false;
$61eec023a6bef997$export$eeaf491a400e882a.toLocaleString = false;
$61eec023a6bef997$export$eeaf491a400e882a.toString = false;
$61eec023a6bef997$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $61eec023a6bef997$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$61eec023a6bef997$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $61eec023a6bef997$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $61eec023a6bef997$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $61eec023a6bef997$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $61eec023a6bef997$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $61eec023a6bef997$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $61eec023a6bef997$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $61eec023a6bef997$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $61eec023a6bef997$export$147e8ac43c84713a();
        this._tokenizer = new $61eec023a6bef997$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    };
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    };
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    };
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    };
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $61eec023a6bef997$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $61eec023a6bef997$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $61eec023a6bef997$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $61eec023a6bef997$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $61eec023a6bef997$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $61eec023a6bef997$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    };
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("6pVnK", function(module, exports) {
$parcel$export(module.exports, "getCategoryId", () => $8a9bb3d803900e98$export$4bcbf61cb6832a8e);
const $8a9bb3d803900e98$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});

parcelRegister("6sSoV", function(module, exports) {
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $39d1c4f97f90ae9d$export$b0ed6d8df471f3cc);
const $39d1c4f97f90ae9d$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);

});

parcelRegister("9LHvs", function(module, exports) {
$parcel$export(module.exports, "tokenizerRegex", () => $591a65261ff50d01$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
/* eslint-disable no-misleading-character-class */ const $591a65261ff50d01$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi'); /* eslint-enable no-misleading-character-class */ 

});

parcelRegister("eCyIm", function(module, exports) {
$parcel$export(module.exports, "getEmojiVariation", () => $54e6e7a61650693d$export$e55e46e1520c899d);

var $6sSoV = parcelRequire("6sSoV");
const $54e6e7a61650693d$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $6sSoV.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};

});

parcelRegister("clO7z", function(module, exports) {
$parcel$export(module.exports, "createSearchEmojiComparator", () => $a3a594f81129d421$export$e6097b005751df7);

var $3TDJu = parcelRequire("3TDJu");

var $6dz8z = parcelRequire("6dz8z");

var $4pYKR = parcelRequire("4pYKR");

var $jXMc2 = parcelRequire("jXMc2");

var $a66Ju = parcelRequire("a66Ju");

var $bFh2f = parcelRequire("bFh2f");

var $hWoFp = parcelRequire("hWoFp");
function $a3a594f81129d421$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new (0, $6dz8z.AsciiMatchComparator)(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new (0, $jXMc2.ExactShortNameMatchComparator)(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new (0, $hWoFp.UsageFrequencyComparator)(orderedIds));
    if (textQuery) comparators.push(new (0, $bFh2f.QueryStringPositionMatchComparator)(textQuery, 'shortName'), new (0, $bFh2f.QueryStringPositionMatchComparator)(textQuery, 'name'));
    comparators.push((0, $a66Ju.OrderComparator).Instance, (0, $3TDJu.AlphabeticalShortnameComparator).Instance);
    const comparator = new (0, $4pYKR.ChainedEmojiComparator)(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}

});
parcelRegister("3TDJu", function(module, exports) {
$parcel$export(module.exports, "AlphabeticalShortnameComparator", () => $9e267b561a951ec8$export$30ce221e1adf48c1);
class $9e267b561a951ec8$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("6dz8z", function(module, exports) {
$parcel$export(module.exports, "AsciiMatchComparator", () => $a512dac47764e825$export$ff92575cd1bbad0e);
class $a512dac47764e825$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}

});

parcelRegister("4pYKR", function(module, exports) {
$parcel$export(module.exports, "ChainedEmojiComparator", () => $bd3f1719acbca736$export$a8052d0852821684);
class $bd3f1719acbca736$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}

});

parcelRegister("jXMc2", function(module, exports) {
$parcel$export(module.exports, "ExactShortNameMatchComparator", () => $a08888e164fc4ec6$export$3026b08b79541139);

var $bJ9lz = parcelRequire("bJ9lz");
class $a08888e164fc4ec6$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new (0, $bJ9lz.EmojiTypeComparator)(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}

});
parcelRegister("bJ9lz", function(module, exports) {
$parcel$export(module.exports, "EmojiTypeComparator", () => $aa3f8b1c33cb107e$export$a7f7a0b04013a8a8);
class $aa3f8b1c33cb107e$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}

});


parcelRegister("a66Ju", function(module, exports) {
$parcel$export(module.exports, "OrderComparator", () => $febf4689a5762ff8$export$165e96ceead77edd);

var $g3vc1 = parcelRequire("g3vc1");
class $febf4689a5762ff8$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $g3vc1.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $g3vc1.MAX_ORDINAL);
        return o1 - o2;
    }
}

});

parcelRegister("bFh2f", function(module, exports) {
$parcel$export(module.exports, "QueryStringPositionMatchComparator", () => $9165551b3b14eab1$export$587c775915dc4869);

var $g3vc1 = parcelRequire("g3vc1");
class $9165551b3b14eab1$export$587c775915dc4869 {
    /**
   * @param query the query to match
   * @param propertyToCompare the property of EmojiDescription to check for query within
   */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $g3vc1.MAX_ORDINAL);
        return score === -1 ? (0, $g3vc1.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}

});

parcelRegister("hWoFp", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyComparator", () => $cfa791d261b08a18$export$55e24837a4bf653);

var $g3vc1 = parcelRequire("g3vc1");

var $ckBTn = parcelRequire("ckBTn");
class $cfa791d261b08a18$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
   * Get the ordinal representing the position of this emoji.
   *
   * @param id the id of the emoji
   */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $ckBTn.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $g3vc1.MAX_ORDINAL;
    }
}

});
parcelRegister("ckBTn", function(module, exports) {
$parcel$export(module.exports, "isEmojiVariationDescription", () => $7ee5a56b0f291b9f$export$82a0350e1f6b5c0a);
const $7ee5a56b0f291b9f$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};

});



parcelRegister("4okJk", function(module, exports) {
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $e3c27661b783c0c0$export$1bd055808eeccb4e);

var $4pYKR = parcelRequire("4pYKR");

var $bJ9lz = parcelRequire("bJ9lz");

var $a66Ju = parcelRequire("a66Ju");

var $hWoFp = parcelRequire("hWoFp");
function $e3c27661b783c0c0$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new (0, $4pYKR.ChainedEmojiComparator)(new (0, $hWoFp.UsageFrequencyComparator)(orderedIds), new (0, $bJ9lz.EmojiTypeComparator)(), (0, $a66Ju.OrderComparator).Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}

});

parcelRegister("9EAL2", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyTracker", () => $385dd7e304b7e2c7$export$3f86810331c44209);

var $g3vc1 = parcelRequire("g3vc1");

var $e6mjm = parcelRequire("e6mjm");

var $ckBTn = parcelRequire("ckBTn");

var $lNUA5 = parcelRequire("lNUA5");

var $7ud8J = parcelRequire("7ud8J");

var $e9A5z = parcelRequire("e9A5z");
class $385dd7e304b7e2c7$export$3f86810331c44209 {
    static #_ = this.queueOptions = {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        storage: (0, $lNUA5.default)('localStorage') ? window.localStorage : undefined,
        storagePrefix: (0, $g3vc1.localStoragePrefix),
        maxDuplicates: 25,
        minUniqueItems: 5
    };
    constructor(useStorageIfPossible = true){
        const options = $385dd7e304b7e2c7$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $7ud8J.default)(queueOptions);
        } else this.queue = new (0, $e6mjm.default)(options);
        this.gateway = new (0, $e9A5z.Gateway)(10);
    }
    /**
   * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
   * count on getOrder() reflecting this usage immediately.
   *
   * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
   */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $ckBTn.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
   * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
   * are no usages then an empty array will be returned.
   */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
   * Exposed for testing only. Clear any recorded usage.
   */ clear() {
        this.queue.clear();
    }
}

});
parcelRegister("e6mjm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e56ea3f28ff00371$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $e56ea3f28ff00371$export$2e2bcd8739ae039 {
    /**
   * Construct a new DuplicateLimitedQueue.
   *
   * @param options the options for this queue.
   */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
   * @param item the item to add to the queue.
   */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items in the queue, ordered by how often they are duplicated. The items with the
   * most duplicates come first in the returned Array.
   *
   * If there are no items in the queue then an empty Array will be returned.
   */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue.
   */ clear() {
        this.createEmptyState();
    }
    /**
   * A more efficient mechanism for adding multiple items. Ordering is only performed once all
   * the items have been added.
   *
   * @param items the items to be enqueued, which happens in their presented order.
   */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items currently stored in the queue.
   */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
   * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
   * performed by this enqueuing. You must trigger that manually if required.
   *
   * @param item the item to be queued
   */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
   * Get an array of items from the queue ordered by how often they are duplicated in the queue.
   */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
   * Walk the list of items and remove the first occurrence of the matching item.
   *
   * @param item the item to be removed.
   */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
   * Remove the first item from the queue and update the itemCountMap accordingly.
   * @return the item add the front of the queue or undefined if the queue is empty
   */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
   * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
   * @param item the item to be added to the queue
   */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("7ud8J", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af2a240f00fc43d$export$2e2bcd8739ae039);

var $e6mjm = parcelRequire("e6mjm");

var $cz2rC = parcelRequire("cz2rC");
class $0af2a240f00fc43d$export$2e2bcd8739ae039 extends (0, $e6mjm.default) {
    static #_ = this.storageKey = 'lastUsed';
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$0af2a240f00fc43d$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
   * Enqueue the supplied item and also persist the new contents of the queue to storage.
   *
   * @param item the item to be enqueued
   */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
   */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
   * Initialise the queue contents from the configured Storage. If there is no data found in
   * storage then the queue will have no items added. Likewise, a failure to read or parse stored
   * data will be swallowed and no items are added to the queue.
   */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $cz2rC.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
   * Save the current items in the queue, overwriting any previously stored queue.
   * Any failure in saving will be silently ignored with the likely outcome that any previous
   * saved items will remain unchanged in storage.
   */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $cz2rC.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});

parcelRegister("e9A5z", function(module, exports) {
$parcel$export(module.exports, "Gateway", () => $bd5f1066ef5e2881$export$a0e1fa6601cae894);
class $bd5f1066ef5e2881$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
   * Run the supplied function if the count of already submitted work allows it. Drop the work
   * if it's not allowed to run.
   *
   * Will return true if the function has been submitted or false if it was not submitted.
   */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});



parcelRegister("5L2Zv", function(module, exports) {
$parcel$export(module.exports, "default", () => $50bc29c02d906875$export$2e2bcd8739ae039);

var $83J3A = parcelRequire("83J3A");

var $1N0Bi = parcelRequire("1N0Bi");

var $d4Oym = parcelRequire("d4Oym");

var $hTWkC = parcelRequire("hTWkC");

var $3vZwL = parcelRequire("3vZwL");

var $4CEaO = parcelRequire("4CEaO");

var $hSdEI = parcelRequire("hSdEI");

var $cz2rC = parcelRequire("cz2rC");

var $bU1oC = parcelRequire("bU1oC");

var $krm12 = parcelRequire("krm12");

var $5oXnj = parcelRequire("5oXnj");

var $1vbzy = parcelRequire("1vbzy");

var $kKUci = parcelRequire("kKUci");
const $50bc29c02d906875$export$6f3a08dea02a7b2b = 0.95;
class $50bc29c02d906875$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $1N0Bi.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $hTWkC.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $5oXnj.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $hTWkC.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $d4Oym.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $kKUci.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $1vbzy.default)(this.tokenManager);
    }
    /**
   * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
   */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $hSdEI.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $hSdEI.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
   * Will load media emoji, returning a new EmojiDescription if, for example,
   * the URL has changed.
   */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $4CEaO.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $hSdEI.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $cz2rC.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $83J3A.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                mediaClient.file.uploadExternal(upload.dataURL, collectionName, undefined, true).then(({ uploadableFileUpfrontIds: uploadableFileUpfrontIds })=>{
                    const subscription = mediaClient.file.getFileState(uploadableFileUpfrontIds.id, {
                        collectionName: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $50bc29c02d906875$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing' || state.status === 'processed') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, $cz2rC.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, uploadableFileUpfrontIds.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                }).catch((error)=>{
                    reject(error);
                });
            });
        });
    }
    /**
   * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
   * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
   * completes with failure then the Promise will resolve to false.
   */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $krm12.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $bU1oC.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $cz2rC.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
   * Calls to site-scoped EmojiResource to delete emoji
   * @param emoji media emoji to delete
   * @returns Promise.resolve() if success and Promise.reject() for failure
   */ deleteEmoji(emoji) {
        if (!(0, $4CEaO.isMediaEmoji)(emoji) && !(0, $3vZwL.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $1N0Bi.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("3vZwL", function(module, exports) {
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $96bbeccb7ca7f290$export$d25a80b2c86d7fdf);

var $g3vc1 = parcelRequire("g3vc1");

var $faaMf = parcelRequire("faaMf");
const $96bbeccb7ca7f290$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $g3vc1.customCategory) && (0, $faaMf.hasDataURLImage)(emoji.representation);

});
parcelRegister("faaMf", function(module, exports) {
$parcel$export(module.exports, "hasDataURLImage", () => $7d1dd5b2a0ffae49$export$7720a4954d6f75f8);

var $g3vc1 = parcelRequire("g3vc1");

var $61jKi = parcelRequire("61jKi");
const $7d1dd5b2a0ffae49$export$7720a4954d6f75f8 = (rep)=>(0, $61jKi.isImageRepresentation)(rep) && rep.imagePath.indexOf((0, $g3vc1.dataURLPrefix)) === 0;

});


parcelRegister("1vbzy", function(module, exports) {
$parcel$export(module.exports, "maxImageCached", () => $32832cdac9d0702c$export$887a842045ce5826);
$parcel$export(module.exports, "maxImageSize", () => $32832cdac9d0702c$export$20a2bfdf672c7448);
$parcel$export(module.exports, "default", () => $32832cdac9d0702c$export$2e2bcd8739ae039);

var $hSdEI = parcelRequire("hSdEI");

var $2D4MI = parcelRequire("2D4MI");

var $cz2rC = parcelRequire("cz2rC");

var $4T5ka = parcelRequire("4T5ka");

var $krdmJ = parcelRequire("krdmJ");

var $hi0iY = parcelRequire("hi0iY");

var $bq80P = parcelRequire("bq80P");
const $32832cdac9d0702c$export$887a842045ce5826 = 1000;
const $32832cdac9d0702c$export$20a2bfdf672c7448 = 10000;
class $32832cdac9d0702c$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $cz2rC.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $hi0iY.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $krdmJ.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $hSdEI.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $2D4MI.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $2D4MI.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return (0, $4T5ka.BrowserCacheStrategy).supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new (0, $4T5ka.BrowserCacheStrategy)(this.mediaImageLoader);
            return new (0, $bq80P.MemoryCacheStrategy)(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("4T5ka", function(module, exports) {
$parcel$export(module.exports, "BrowserCacheStrategy", () => $7f0a56fa437a90c7$export$3850f566ce8d817a);

var $hSdEI = parcelRequire("hSdEI");

var $cz2rC = parcelRequire("cz2rC");

var $krdmJ = parcelRequire("krdmJ");
const $7f0a56fa437a90c7$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $7f0a56fa437a90c7$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $cz2rC.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $krdmJ.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $hSdEI.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($7f0a56fa437a90c7$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}

});
parcelRegister("krdmJ", function(module, exports) {
$parcel$export(module.exports, "getRequiredRepresentation", () => $24f87a67a1c00448$export$6875157046b6a22d);
const $24f87a67a1c00448$export$6875157046b6a22d = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;

});


parcelRegister("hi0iY", function(module, exports) {
$parcel$export(module.exports, "default", () => $fadac5848014be52$export$2e2bcd8739ae039);

var $6aikT = parcelRequire("6aikT");
const $fadac5848014be52$var$defaultConcurrentDownloadLimit = 16;
const $fadac5848014be52$var$backoffMaxDelayInMillis = 600;
const $fadac5848014be52$var$defaultMaxRetriesOnNotFound = 2;
class $fadac5848014be52$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $fadac5848014be52$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $fadac5848014be52$var$defaultMaxRetriesOnNotFound) {
        return (0, $6aikT.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($fadac5848014be52$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("6aikT", function(module, exports) {
$parcel$export(module.exports, "getNaturalImageSize", () => $07d88edefe339971$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $07d88edefe339971$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $07d88edefe339971$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $07d88edefe339971$export$f8e7886bc155c2e6);
const $07d88edefe339971$var$maxEmojiSizeInBytes = 1048576;
const $07d88edefe339971$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $07d88edefe339971$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $07d88edefe339971$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $07d88edefe339971$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $07d88edefe339971$var$isWebpSupported;
const $07d88edefe339971$export$c5a964eb84c7fca8 = ()=>{
    if ($07d88edefe339971$var$isWebpSupported !== undefined) return Promise.resolve($07d88edefe339971$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $07d88edefe339971$var$isWebpSupported = img.height === 2;
            resolve($07d88edefe339971$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $07d88edefe339971$export$f8e7886bc155c2e6 = ()=>$07d88edefe339971$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});


parcelRegister("bq80P", function(module, exports) {
$parcel$export(module.exports, "MemoryCacheStrategy", () => $83e8fa5d5608e9bd$export$b522858a3709f4c);

var $5j6lg = parcelRequire("5j6lg");

var $j9ZGO = parcelRequire("j9ZGO");

var $hSdEI = parcelRequire("hSdEI");

var $cz2rC = parcelRequire("cz2rC");

var $krdmJ = parcelRequire("krdmJ");

var $1vbzy = parcelRequire("1vbzy");
class $83e8fa5d5608e9bd$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $cz2rC.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $5j6lg.LRUMap)((0, $1vbzy.maxImageCached));
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $krdmJ.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $hSdEI.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $j9ZGO.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $j9ZGO.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= (0, $1vbzy.maxImageSize)) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $cz2rC.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}

});
parcelRegister("j9ZGO", function(module, exports) {
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $1abb0a8b6d4e7e95$export$f1a89a11f425faaa);

var $d4Oym = parcelRequire("d4Oym");

var $aueRN = parcelRequire("aueRN");

var $hSdEI = parcelRequire("hSdEI");
const $1abb0a8b6d4e7e95$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!(0, $hSdEI.isMediaRepresentation)(mediaRepresentation) && !(0, $hSdEI.isMediaRepresentation)(mediaAltRepresentation)) return emoji;
    const representation = (0, $hSdEI.isMediaRepresentation)(mediaRepresentation) ? (0, $aueRN.convertMediaToImageRepresentation)(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = (0, $hSdEI.isMediaRepresentation)(mediaAltRepresentation) ? (0, $aueRN.convertMediaToImageRepresentation)(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return (0, $d4Oym.buildEmojiDescriptionWithAltRepresentation)(baseEmoji, altRepresentation);
};

});
parcelRegister("aueRN", function(module, exports) {
$parcel$export(module.exports, "convertMediaToImageRepresentation", () => $4254967c15b52963$export$3197405d49d2e298);
const $4254967c15b52963$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });

});




parcelRegister("kKUci", function(module, exports) {
$parcel$export(module.exports, "default", () => $b997740dd16c1d49$export$2e2bcd8739ae039);

var $1N0Bi = parcelRequire("1N0Bi");
const $b997740dd16c1d49$export$866c20c059277b6 = 30;
class $b997740dd16c1d49$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $b997740dd16c1d49$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $1N0Bi.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});




parcelRegister("7Lpsm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac5650d733d83524$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $ctQbi = parcelRequire("ctQbi");

var $5zxDU = parcelRequire("5zxDU");

var $tLWYq = parcelRequire("tLWYq");

var $64ZSD = parcelRequire("64ZSD");

var $7uUp4 = parcelRequire("7uUp4");

var $e5oK8 = parcelRequire("e5oK8");

var $4nock = parcelRequire("4nock");

var $kQyQK = parcelRequire("kQyQK");

var $jPHrM = parcelRequire("jPHrM");

var $454jH = parcelRequire("454jH");
const $ac5650d733d83524$export$8f69873d7d6eec35 = (props)=>{
    const { product: product, appearance: appearance, additionalExtensionHandlers: additionalExtensionHandlers = {}, PropsProvider: PropsProvider, contentId: contentId, dataProviders: dataProviders } = props;
    const [sectionsProvider, setSectionsProvider] = (0, $bSJIT.useState)(null);
    const intl = (0, $4vLTk.default)();
    const hubExtensionHandlers = (0, $454jH.useHubExtensionHandlers)({
        contentId: contentId,
        PropsProvider: PropsProvider
    });
    const allExtensionHandlers = (0, $bSJIT.useMemo)(()=>{
        return {
            ...hubExtensionHandlers,
            ...additionalExtensionHandlers
        };
    }, [
        hubExtensionHandlers,
        additionalExtensionHandlers
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const loadSectionsProvider = async ()=>{
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $4nock.ExtensionMode).RENDERER,
                getSectionExtensionContents: $kQyQK.getSectionExtensionContents
            };
            const defaultExtensionInstanceProps = {
                intl: intl,
                contentId: contentId
            };
            const sectionsProviderInstance = await (0, $jPHrM.sectionExtensionProvider)(defaultExtensionProviderProps);
            const sectionsProvider = await sectionsProviderInstance(defaultExtensionInstanceProps);
            setSectionsProvider(sectionsProvider);
        };
        loadSectionsProvider();
    }, [
        contentId,
        intl,
        PropsProvider
    ]);
    const providerFactory = (0, $bSJIT.useMemo)(()=>{
        const factory = dataProviders || (0, $5zxDU.default).create({});
        if (sectionsProvider) factory.setProvider('extensionProvider', Promise.resolve((0, $ctQbi.default)([
            sectionsProvider
        ])));
        return factory;
    }, [
        sectionsProvider,
        dataProviders
    ]);
    const smartCardClient = (0, $bSJIT.useMemo)(()=>new (0, $tLWYq.default)(), []);
    // Use the same document layout as the Help Hub editor within the max-width canvas.
    const useDocumentColumn = product === 'JSM' && appearance === 'max';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $e5oK8.HubRendererWrapperGated), {
        "data-testid": "hub-renderer",
        product: product,
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $64ZSD.SmartCardProvider), {
        product: product,
        client: smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7uUp4.RendererWithAnalytics), {
        ...props,
        ...useDocumentColumn && {
            appearance: 'full-page',
            allowRendererContainerStyles: true,
            UNSTABLE_allowTableResizing: true,
            UNSTABLE_allowTableAlignment: true
        },
        allowCustomPanels: true,
        media: {
            allowLinking: true
        },
        extensionHandlers: allExtensionHandlers,
        // dataProviders supplies the extension provider factory which enables section extensions to be rendered within the hub
        dataProviders: providerFactory,
        adfStage: "stage0"
    })));
};
var $ac5650d733d83524$export$2e2bcd8739ae039 = $ac5650d733d83524$export$8f69873d7d6eec35;

});
parcelRegister("ctQbi", function(module, exports) {
$parcel$export(module.exports, "default", () => $dde4a471f4ad754f$export$2e2bcd8739ae039);

var $83V7I = parcelRequire("83V7I");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles optional explicit resolution, promise racing, and safely discarded rejections.
 */ $dde4a471f4ad754f$export$2e2bcd8739ae039 = (extensionProviders, { resolveExtension: resolveExtension, resolvePreloadedExtension: resolvePreloadedExtension } = {})=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $83V7I.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>{
                var _provider$preload;
                return provider === null || provider === void 0 || (_provider$preload = provider.preload) === null || _provider$preload === void 0 ? void 0 : _provider$preload.call(provider);
            }));
        },
        getPreloadedExtension (type, key) {
            const resolvedExtension = resolvePreloadedExtension === null || resolvePreloadedExtension === void 0 ? void 0 : resolvePreloadedExtension(type, key);
            if (resolvedExtension) return resolvedExtension;
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                var _provider$getPreloade;
                const result = provider === null || provider === void 0 || (_provider$getPreloade = provider.getPreloadedExtension) === null || _provider$getPreloade === void 0 ? void 0 : _provider$getPreloade.call(provider, type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        async getExtension (type, key) {
            const resolvedExtension = await (resolveExtension === null || resolveExtension === void 0 ? void 0 : resolveExtension(type, key));
            if (resolvedExtension) return resolvedExtension;
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("83V7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4945d1f9a1cf667$export$2e2bcd8739ae039);

var $gbQp7 = parcelRequire("gbQp7");

var $70m3t = parcelRequire("70m3t");
const $e4945d1f9a1cf667$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $e4945d1f9a1cf667$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $gbQp7.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $gbQp7.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
   * Run a method from the provider which expects to return a single item
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $70m3t.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
   * Run a method in the provider which expectes to return a list of items
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $gbQp7.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $gbQp7.getOnlyFulfilled)(results);
        return $e4945d1f9a1cf667$var$flatten(fulfilledResults).filter((result)=>result);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeOptionalList = async (methodName, args)=>{
        const providersWithMethod = (await getFulfilledProviders()).filter((provider)=>typeof provider[methodName] === 'function');
        const results = await (0, $gbQp7.waitForAllPromises)(providersWithMethod.map(createCallback(methodName, args)));
        const fulfilledResults = (0, $gbQp7.getOnlyFulfilled)(results);
        return $e4945d1f9a1cf667$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList,
        invokeOptionalList: invokeOptionalList
    };
};

});
parcelRegister("gbQp7", function(module, exports) {
$parcel$export(module.exports, "waitForAllPromises", () => $fce6e6a023c446a2$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $fce6e6a023c446a2$export$b7581cbf0e22e36b);

var $erSz1 = parcelRequire("erSz1");
const $fce6e6a023c446a2$var$isFullfilled = (result)=>result.status === (0, $erSz1.ResultStatus).FULFILLED;
const $fce6e6a023c446a2$var$markFullfilled = (value)=>({
        status: (0, $erSz1.ResultStatus).FULFILLED,
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fce6e6a023c446a2$var$markRejected = (error)=>({
        status: (0, $erSz1.ResultStatus).FAILED,
        reason: error
    });
const $fce6e6a023c446a2$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($fce6e6a023c446a2$var$markFullfilled).catch($fce6e6a023c446a2$var$markRejected)));
};
const $fce6e6a023c446a2$export$b7581cbf0e22e36b = (results)=>results.filter($fce6e6a023c446a2$var$isFullfilled).map((result)=>result.value); // eslint-disable-next-line @atlaskit/editor/no-re-export
 // eslint-disable-next-line @atlaskit/editor/no-re-export

});
parcelRegister("erSz1", function(module, exports) {
$parcel$export(module.exports, "ResultStatus", () => $108d95fd3a423c8e$export$7103a54af3e45080);
var $108d95fd3a423c8e$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});

});


parcelRegister("70m3t", function(module, exports) {
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $0bf915c531653f64$export$cb8861b0e3f3dd6f);
/**
 * Will resolve on the first fulfilled promise and disregard the remaining ones. Similar to `Promise.race` but won't
 * care about rejected promises.
 * @param promises
 */ const $0bf915c531653f64$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};

});



parcelRegister("tLWYq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a3bf22e84897af1$export$2e2bcd8739ae039);

var $5SNfO = parcelRequire("5SNfO");

var $5muzC = parcelRequire("5muzC");

var $j4l1H = parcelRequire("j4l1H");

var $5j6lg = parcelRequire("5j6lg");

var $hyVtk = parcelRequire("hyVtk");

var $hyP0z = parcelRequire("hyP0z");

var $7M18D = parcelRequire("7M18D");

var $9cVVq = parcelRequire("9cVVq");

var $cAtcU = parcelRequire("cAtcU");

var $8OvnD = parcelRequire("8OvnD");

var $jSPcn = parcelRequire("jSPcn");

var $gdUUy = parcelRequire("gdUUy");

var $cc4Fs = parcelRequire("cc4Fs");

var $81hrT = parcelRequire("81hrT");
const $9a3bf22e84897af1$var$MAX_BATCH_SIZE = 50;
const $9a3bf22e84897af1$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $9a3bf22e84897af1$var$URL_RESPONSE_CACHE_SIZE = 100;
const $9a3bf22e84897af1$export$d6a66073b5d79eb3 = new (0, $5j6lg.LRUMap)($9a3bf22e84897af1$var$URL_RESPONSE_CACHE_SIZE);
const $9a3bf22e84897af1$var$urlResponseInFlightCache = new Map();
class $9a3bf22e84897af1$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($j4l1H)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $hyP0z.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $hyP0z.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $cc4Fs.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $hyP0z.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $hyP0z.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $cc4Fs.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $9cVVq.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hyVtk)))({
            limit: 1,
            interval: $9a3bf22e84897af1$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5muzC)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $9a3bf22e84897af1$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $cAtcU.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $9a3bf22e84897af1$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $9a3bf22e84897af1$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $9a3bf22e84897af1$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $81hrT.isSuccessfulResponse)(response) || (0, $jSPcn.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $9a3bf22e84897af1$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $9a3bf22e84897af1$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $9a3bf22e84897af1$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $9a3bf22e84897af1$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $9a3bf22e84897af1$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $9a3bf22e84897af1$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($9a3bf22e84897af1$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $9a3bf22e84897af1$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $81hrT.isSuccessfulResponse)(response) || (0, $jSPcn.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $9a3bf22e84897af1$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $81hrT.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($5SNfO)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $81hrT.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $cc4Fs.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($5SNfO)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $81hrT.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $hyP0z.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $hyP0z.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $cc4Fs.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $hyP0z.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response !== null && response !== void 0 && response.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $8OvnD.NetworkError)) return new (0, $7M18D.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $7M18D.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $7M18D.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $7M18D.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $7M18D.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $7M18D.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("5SNfO", function(module, exports) {
// Packages

var $6P7kA = parcelRequire("6P7kA");
function $448833b406d02244$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $6P7kA.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $448833b406d02244$var$retry;

});
parcelRegister("6P7kA", function(module, exports) {

module.exports = (parcelRequire("dVo4N"));

});
parcelRegister("dVo4N", function(module, exports) {

var $8Toc4 = parcelRequire("8Toc4");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8Toc4(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("8Toc4", function(module, exports) {
function $67963a200c8810e9$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $67963a200c8810e9$var$RetryOperation;
$67963a200c8810e9$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$67963a200c8810e9$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$67963a200c8810e9$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$67963a200c8810e9$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$67963a200c8810e9$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$67963a200c8810e9$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$67963a200c8810e9$var$RetryOperation.prototype.start = $67963a200c8810e9$var$RetryOperation.prototype.try;
$67963a200c8810e9$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$67963a200c8810e9$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$67963a200c8810e9$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("j4l1H", function(module, exports) {

var $3iACh = parcelRequire("3iACh");

var $6WohZ = parcelRequire("6WohZ");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $de1eb374eaee265f$var$uniqBy(array, iteratee) {
    return array && array.length ? $6WohZ(array, $3iACh(iteratee, 2)) : [];
}
module.exports = $de1eb374eaee265f$var$uniqBy;

});

parcelRegister("hyVtk", function(module, exports) {
'use strict';
class $cc923166b84b6945$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cc923166b84b6945$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cc923166b84b6945$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cc923166b84b6945$var$pThrottle;
module.exports.AbortError = $cc923166b84b6945$var$AbortError;

});

parcelRegister("hyP0z", function(module, exports) {
$parcel$export(module.exports, "request", () => $b28c3d32cd204d23$export$b5fe3f66a567bec0);

var $8OvnD = parcelRequire("8OvnD");
const $b28c3d32cd204d23$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $b28c3d32cd204d23$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $b28c3d32cd204d23$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses !== null && statuses !== void 0 && statuses.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $8OvnD.NetworkError)(error);
        throw error;
    }
}

});
parcelRegister("8OvnD", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $9dce53c55e159b4e$export$bae979e68e4dc802);
class $9dce53c55e159b4e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}

});


parcelRegister("7M18D", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $9d97c49461cdcf17$export$3e5b797e39668f84);
class $9d97c49461cdcf17$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("9cVVq", function(module, exports) {
$parcel$export(module.exports, "getResolverUrl", () => $7c329b027dbfb410$export$dc37652c1696f231);

var $4AI8m = parcelRequire("4AI8m");
const $7c329b027dbfb410$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $4AI8m.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};

});
parcelRegister("4AI8m", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $84b401d614eec6bb$export$f654b28f82155665);

var $9V7IF = parcelRequire("9V7IF");
const $84b401d614eec6bb$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $9V7IF.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $9V7IF.BaseUrls) ? (0, $9V7IF.BaseUrls)[envKey] : (0, $9V7IF.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};

});
parcelRegister("9V7IF", function(module, exports) {
$parcel$export(module.exports, "prodBaseUrl", () => $f56092b42d0569bb$export$7469f9cd9cda802c);
$parcel$export(module.exports, "BaseUrls", () => $f56092b42d0569bb$export$e2b040f052407032);
const $f56092b42d0569bb$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $f56092b42d0569bb$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $f56092b42d0569bb$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $f56092b42d0569bb$export$e2b040f052407032 = {
    dev: $f56092b42d0569bb$var$devBaseUrl,
    development: $f56092b42d0569bb$var$devBaseUrl,
    stg: $f56092b42d0569bb$var$stgBaseUrl,
    staging: $f56092b42d0569bb$var$stgBaseUrl,
    prd: $f56092b42d0569bb$export$7469f9cd9cda802c,
    prod: $f56092b42d0569bb$export$7469f9cd9cda802c,
    production: $f56092b42d0569bb$export$7469f9cd9cda802c
};
var $f56092b42d0569bb$export$2e2bcd8739ae039 = $f56092b42d0569bb$export$e2b040f052407032;

});



parcelRegister("cAtcU", function(module, exports) {
$parcel$export(module.exports, "InvalidUrlError", () => $812f1b42665f93d2$export$19fa02dd69bd4efd);
class $812f1b42665f93d2$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}

});

parcelRegister("jSPcn", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $4732004779bee865$export$b70265791d2079d4);
const $4732004779bee865$var$getStatusForNotFoundVisibility = (meta)=>{
    var _meta$requestAccess;
    const accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $4732004779bee865$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $4732004779bee865$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("cc4Fs", function(module, exports) {
$parcel$export(module.exports, "isErrorResponse", () => $71dd87eb813cd4c9$export$bea7bee8a87e7c52);
const $71dd87eb813cd4c9$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("81hrT", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", () => $3a3aa6e7ad606bc7$export$1b59fe731a28a49d);
const $3a3aa6e7ad606bc7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};

});


parcelRegister("64ZSD", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", () => $e9edfc6dba809fab$export$497ecb0280204df4);

var $bSJIT = parcelRequire("bSJIT");

var $euGak = parcelRequire("euGak");
parcelRequire("1mIIj");
var $5nEeT = parcelRequire("5nEeT");

var $dWNt9 = parcelRequire("dWNt9");

var $gUazh = parcelRequire("gUazh");

var $7M18D = parcelRequire("7M18D");

var $bLV8M = parcelRequire("bLV8M");

var $gdUUy = parcelRequire("gdUUy");

var $tLWYq = parcelRequire("tLWYq");

var $9h3YG = parcelRequire("9h3YG");

var $f8KaN = parcelRequire("f8KaN");

var $1zOmw = parcelRequire("1zOmw");
/**
 * Whether the error represents a URL the resolver does not support. This is an expected,
 * benign outcome (not a real failure) and must not be surfaced as an errored card.
 */ const $e9edfc6dba809fab$var$isUnsupportedError = (error)=>error.type === 'UnsupportedError' || error.type === 'ResolveUnsupportedError' || error.type === 'SearchUnsupportedError';
function $e9edfc6dba809fab$export$497ecb0280204df4({ linkNavigation: linkNavigation, storeOptions: storeOptions, bridgeProduct: bridgeProduct, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct }) {
    const parentContext = (0, $bSJIT.useContext)((0, $1zOmw.SmartCardContext));
    const defaultInitialState = (0, $bSJIT.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $bSJIT.useMemo)(()=>{
        return (0, $5nEeT.default)((0, $9h3YG.cardReducer), initialState);
    }, [
        initialState
    ]);
    const client = (0, $bSJIT.useMemo)(()=>{
        const c = customClient || new (0, $tLWYq.default)();
        if (product && c.setProduct) c.setProduct(product);
        return c;
    }, [
        customClient,
        product
    ]);
    // Listen for external auth completion events and re-resolve any matching unauthorized cards in this store.
    (0, $bSJIT.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const handler = (event)=>{
            var _detail$extensionKeys;
            const detail = event.detail;
            if (!(detail !== null && detail !== void 0 && (_detail$extensionKeys = detail.extensionKeys) !== null && _detail$extensionKeys !== void 0 && _detail$extensionKeys.length)) return;
            const targetKeys = new Set(detail.extensionKeys);
            const state = store.getState();
            for (const url of Object.keys(state)){
                var _cardState$details;
                const cardState = state[url];
                if (!cardState || cardState.status !== 'unauthorized') continue;
                const cardExtensionKey = (_cardState$details = cardState.details) === null || _cardState$details === void 0 || (_cardState$details = _cardState$details.meta) === null || _cardState$details === void 0 ? void 0 : _cardState$details.key;
                if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                // Fetch fresh data from ORS and dispatch new payload data
                client.fetchData(url, true).then((response)=>{
                    store.dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_RELOADING), {
                        url: url
                    }, response, undefined, undefined, true));
                }, (err)=>{
                    // "Unsupported URL" is a benign, expected resolver outcome (ORS does not
                    // support this link), surfaced as a fatal APIError. Turning it into an
                    // errored card state causes non-flexible SmartLinks to re-throw it to their
                    // error boundary and report it to Sentry. Leave the card in its prior
                    // unauthorized state instead.
                    if (err instanceof (0, $7M18D.APIError) && $e9edfc6dba809fab$var$isUnsupportedError(err)) return;
                    store.dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_ERROR), {
                        url: url
                    }, undefined, err, undefined, true));
                });
            }
        };
        window.addEventListener((0, $f8KaN.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
        return ()=>{
            window.removeEventListener((0, $f8KaN.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
        };
    }, [
        store,
        client
    ]);
    const providerValue = (0, $bSJIT.useMemo)(()=>{
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, _platform)=>{
            const cardState = (0, $bLV8M.getUrl)(store, url);
            return cardState.details ? (0, $dWNt9.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            bridgeProduct: bridgeProduct,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $gdUUy.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
    }, [
        customAuthFlow,
        bridgeProduct,
        client,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store,
        xpcProduct,
        xpcSubProduct
    ]);
    const value = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($euGak)))({}, parentContext || providerValue, {
            ...(0, $gdUUy.fg)('confluence_ep_shim_macro_links_v2') ? {
                linkNavigation: linkNavigation
            } : undefined,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $gdUUy.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        openPreviewPanel,
        linkNavigation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1zOmw.SmartCardContext).Provider, {
        value: value
    }, children);
}

});
parcelRegister("dWNt9", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $a720161f54b5b2df$export$864b719baf5d744d);

var $3pz0i = parcelRequire("3pz0i");

var $80uKk = parcelRequire("80uKk");

var $4gDvk = parcelRequire("4gDvk");
const $a720161f54b5b2df$var$extractEntityEmbedUrl = (response)=>{
    const entity = (0, $3pz0i.extractEntity)(response);
    return entity && 'liveEmbedUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl) === 'string' ? entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl : undefined;
};
const $a720161f54b5b2df$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $a720161f54b5b2df$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $80uKk.extractPreview)(response === null || response === void 0 ? void 0 : response.data, 'web', iframeUrlType);
};

});
parcelRegister("3pz0i", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $acbb03329bcee64b$export$8beff7405d020ddf);
const $acbb03329bcee64b$export$8beff7405d020ddf = (response)=>response === null || response === void 0 ? void 0 : response.entityData;

});

parcelRegister("80uKk", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $01a9be6642f82f4c$export$4b0d98b1b7f6d115);

var $Boizk = parcelRequire("Boizk");

var $dtKl2 = parcelRequire("dtKl2");
const $01a9be6642f82f4c$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.preview;
    const isSupported = (0, $Boizk.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $dtKl2.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $dtKl2.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};

});
parcelRegister("Boizk", function(module, exports) {
$parcel$export(module.exports, "extractPlatformIsSupported", () => $9f10df9146437357$export$3e8ad908070b68b2);
const $9f10df9146437357$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("dtKl2", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $65f549fbb83322e4$export$396ba4ef2e37dc65);
const $65f549fbb83322e4$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $65f549fbb83322e4$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});


parcelRegister("4gDvk", function(module, exports) {
$parcel$export(module.exports, "isEntityPresent", () => $772159b1284195ab$export$c7168210b81d9383);

var $3pz0i = parcelRequire("3pz0i");
const $772159b1284195ab$export$c7168210b81d9383 = (response)=>Boolean((0, $3pz0i.extractEntity)(response));

});


parcelRegister("gUazh", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $e597ead648a6f0a2$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $e597ead648a6f0a2$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $e597ead648a6f0a2$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $e597ead648a6f0a2$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $e597ead648a6f0a2$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $e597ead648a6f0a2$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $e597ead648a6f0a2$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $e597ead648a6f0a2$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $e597ead648a6f0a2$export$6e470aad5ba8952e = 'pending';
const $e597ead648a6f0a2$export$9a6a932a0a39498e = 'resolving';
const $e597ead648a6f0a2$export$63ec8bc7a8a75482 = 'resolved';
const $e597ead648a6f0a2$export$b8cfaa842c9ab487 = 'reloading';
const $e597ead648a6f0a2$export$6d8ed3f9433dd372 = 'errored';
const $e597ead648a6f0a2$export$cfbbb7126bc8a0c6 = 'fallback';
const $e597ead648a6f0a2$export$76b5c1aca20759c6 = 'preload';
const $e597ead648a6f0a2$export$2c5edb971b673330 = 'metadata';
const $e597ead648a6f0a2$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("bLV8M", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $02b141e291bbbe8a$export$94df0e59ebebf4a7);
const $02b141e291bbbe8a$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("9h3YG", function(module, exports) {
$parcel$export(module.exports, "cardReducer", () => $8fe1bf086d1d5da5$export$3c7c3113a97b6492);

var $gUazh = parcelRequire("gUazh");

var $jSPcn = parcelRequire("jSPcn");
const $8fe1bf086d1d5da5$var$isCardAction = (action)=>{
    return [
        (0, $gUazh.ACTION_PENDING),
        (0, $gUazh.ACTION_RESOLVING),
        (0, $gUazh.ACTION_RESOLVED),
        (0, $gUazh.ACTION_RELOADING),
        (0, $gUazh.ACTION_ERROR),
        (0, $gUazh.ACTION_ERROR_FALLBACK),
        (0, $gUazh.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $8fe1bf086d1d5da5$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $jSPcn.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $8fe1bf086d1d5da5$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $gUazh.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $gUazh.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $gUazh.ACTION_RESOLVED:
            return $8fe1bf086d1d5da5$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $gUazh.ACTION_RELOADING:
            return $8fe1bf086d1d5da5$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $gUazh.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $gUazh.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $gUazh.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $8fe1bf086d1d5da5$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$8fe1bf086d1d5da5$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $8fe1bf086d1d5da5$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});

parcelRegister("f8KaN", function(module, exports) {
$parcel$export(module.exports, "SMART_CARD_EXTERNAL_AUTH_EVENT", () => $9704125e5b16cbdd$export$97eec7ea3e925862);
/**
 * This event is intended to be dispatched by code OUTSIDE the SmartCardProvider's React tree
 * (e.g. Post Office flags) when an external auth flow has completed and any matching unauthorized SmartLinks on the page should be refreshed.
 *
 * @example for usage from external source:
 *   window.dispatchEvent(new CustomEvent('atlaskit-smart-card:external-auth-completed', {
 *     detail: { extensionKeys: ['figma-object-provider'] },
 *   }));
 */ const $9704125e5b16cbdd$export$97eec7ea3e925862 = 'atlaskit-smart-card:external-auth-completed';

});

parcelRegister("1zOmw", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $9756b07beaa7a6c8$export$156b523e63b4f63a);

var $bSJIT = parcelRequire("bSJIT");
const $9756b07beaa7a6c8$export$156b523e63b4f63a = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
var $9756b07beaa7a6c8$export$2e2bcd8739ae039 = $9756b07beaa7a6c8$export$156b523e63b4f63a;

});


parcelRegister("7uUp4", function(module, exports) {
$parcel$export(module.exports, "RendererWithAnalytics", () => $8ecb5616552ead85$export$af81ffb59b6ef0dd);
$parcel$export(module.exports, "default", () => $8ecb5616552ead85$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ /* eslint-disable @atlaskit/editor/no-re-export */ 
var $21AOl = parcelRequire("21AOl");

var $bVB7k = parcelRequire("bVB7k");
const $8ecb5616552ead85$export$88530751e3977073 = (0, $21AOl.withLazyNodes)((0, $bVB7k.Renderer));
const $8ecb5616552ead85$export$c49fe2316038f3c2 = (0, $21AOl.withLazyNodes)((0, $bVB7k.RendererFunctionalComponent));
const $8ecb5616552ead85$export$af81ffb59b6ef0dd = (0, $21AOl.withLazyNodes)((0, $bVB7k.RendererWithAnalytics));
const $8ecb5616552ead85$var$RendererWithAnnotationSelection = (0, $21AOl.withLazyNodes)((0, $bVB7k.default));
var /**
 * @deprecated Use `Renderer` from `@atlaskit/renderer/default` instead.
 * This export will be removed in December 2026.
 * @see https://hello.atlassian.net/wiki/spaces/EDITOR/pages/7650942996/Moving+to+Synchronous+Rendering+in+Editor+Renderer for more.
 */ $8ecb5616552ead85$export$2e2bcd8739ae039 = $8ecb5616552ead85$var$RendererWithAnnotationSelection;

});
parcelRegister("21AOl", function(module, exports) {
$parcel$export(module.exports, "withLazyNodes", () => $b8f236442976cd82$export$a9c9d867b49b1b5c);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $eRTtV = parcelRequire("eRTtV");
function $b8f236442976cd82$export$a9c9d867b49b1b5c(BaseComponent) {
    const ComponentWithLazyNodes = (props)=>{
        const nodeComponentsWithLazyNodes = (0, $bSJIT.useMemo)(()=>({
                ...(0, $eRTtV.nodeToReact),
                ...props.nodeComponents
            }), [
            props.nodeComponents
        ]);
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $dc70d.jsx)(BaseComponent, {
            ...props,
            nodeComponents: nodeComponentsWithLazyNodes
        });
    };
    return ComponentWithLazyNodes;
}

});
parcelRegister("eRTtV", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $3fc2b62f3357bff9$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $3fc2b62f3357bff9$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $3fc2b62f3357bff9$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $3fc2b62f3357bff9$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $3fc2b62f3357bff9$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $3fc2b62f3357bff9$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("37JJb")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("37JJb")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $deAR2 = parcelRequire("deAR2");

var $d8JFj = parcelRequire("d8JFj");

var $lmZMT = parcelRequire("lmZMT");

var $3y2s4 = parcelRequire("3y2s4");

var $k8sMW = parcelRequire("k8sMW");

var $el3JZ = parcelRequire("el3JZ");

var $i8NSZ = parcelRequire("i8NSZ");

var $jnOB4 = parcelRequire("jnOB4");

var $37JJb = parcelRequire("37JJb");

var $ctw5d = parcelRequire("ctw5d");

var $ktryv = parcelRequire("ktryv");

var $aqjYr = parcelRequire("aqjYr");

var $eR3yK = parcelRequire("eR3yK");

var $dggih = parcelRequire("dggih");

var $5H3yU = parcelRequire("5H3yU");

var $i1k9C = parcelRequire("i1k9C");

var $iV1Ln = parcelRequire("iV1Ln");

var $jBfbK = parcelRequire("jBfbK");

var $0c2Rt = parcelRequire("0c2Rt");

var $9mSOX = parcelRequire("9mSOX");

var $5644y = parcelRequire("5644y");

var $9ZqqS = parcelRequire("9ZqqS");

var $ccrLN = parcelRequire("ccrLN");

var $8hixA = parcelRequire("8hixA");

var $cUmkc = parcelRequire("cUmkc");

var $GdsT3 = parcelRequire("GdsT3");

const $3fc2b62f3357bff9$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("8rYTB")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("2KXt2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("i17dO")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("jNMRy")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("gWLLu")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("gSFCB")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("20zDL")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("kMedY")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("j95CE")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("2kEW9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("4KQzm")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("cxeyx")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("8W1RO")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("53dCf")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("aXReO")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("4jxhX")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("7H4vM")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("4op42")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("eCxcD")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("bTP86")).then((mod)=>mod.default),
    loading: ()=>null
});

const $3fc2b62f3357bff9$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>(parcelRequire("iwa60")).then((mod)=>mod.default),
    loading: ()=>null
});
const $3fc2b62f3357bff9$export$3931063f6a5f290e = {
    blockquote: (0, $k8sMW.default),
    bulletList: (0, $i8NSZ.default),
    blockCard: $3fc2b62f3357bff9$export$d18ccd25c0d2c6b0,
    caption: (0, $jnOB4.default),
    date: $3fc2b62f3357bff9$export$6341f9a885713487,
    decisionItem: $3fc2b62f3357bff9$export$b6f73a2b0b0de599,
    decisionList: $3fc2b62f3357bff9$export$b458dfa720128865,
    doc: (0, $37JJb.default),
    emoji: $3fc2b62f3357bff9$export$56cc48506ff790a,
    extension: (0, $ctw5d.default),
    bodiedExtension: (0, $el3JZ.default),
    multiBodiedExtension: (0, $jBfbK.default),
    extensionFrame: (0, $ktryv.default),
    hardBreak: (0, $aqjYr.default),
    heading: (0, $eR3yK.default),
    inlineCard: $3fc2b62f3357bff9$export$aff6291803939b05,
    inlineExtension: (0, $dggih.default),
    layoutSection: (0, $i1k9C.default),
    layoutColumn: (0, $5H3yU.default),
    listItem: (0, $iV1Ln.default),
    media: $3fc2b62f3357bff9$export$7fc53215244aec38,
    mediaGroup: $3fc2b62f3357bff9$export$d7858be3df00d59,
    mediaInline: $3fc2b62f3357bff9$export$462ea7c2a1c4cb1f,
    mediaSingle: $3fc2b62f3357bff9$export$888d74bc001c3a5d,
    mention: $3fc2b62f3357bff9$export$e891316fea657d90,
    orderedList: (0, $0c2Rt.default),
    panel: $3fc2b62f3357bff9$export$2ddb90ad54e5f587,
    panel_c1: $3fc2b62f3357bff9$export$2ddb90ad54e5f587,
    paragraph: (0, $9mSOX.default),
    placeholder: (0, $5644y.default),
    rule: (0, $9ZqqS.default),
    status: $3fc2b62f3357bff9$export$96e9906d6d93a972,
    taskItem: $3fc2b62f3357bff9$export$27c4189b8be1bf93,
    taskList: $3fc2b62f3357bff9$export$771a55a10b0a40ae,
    table: (0, $ccrLN.default),
    tableCell: (0, $8hixA.TableCell),
    tableHeader: (0, $8hixA.TableHeader),
    tableRow: (0, $cUmkc.default),
    unknownBlock: (0, $GdsT3.default),
    unsupportedBlock: (0, $d8JFj.default),
    unsupportedInline: (0, $lmZMT.default),
    expand: $3fc2b62f3357bff9$export$49bd1dfb0ad29c40,
    syncBlock: $3fc2b62f3357bff9$var$SyncBlockLoader,
    bodiedSyncBlock: $3fc2b62f3357bff9$var$BodiedSyncBlock,
    nestedExpand: $3fc2b62f3357bff9$export$49bd1dfb0ad29c40,
    embedCard: $3fc2b62f3357bff9$export$6789d7ecdc77631b,
    blockTaskItem: $3fc2b62f3357bff9$export$27c4189b8be1bf93
};
const $3fc2b62f3357bff9$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $37JJb.DocWithSelectAllTrap;
    // Custom components provide the node implementations used by the renderer.
    const nodes = {
        ...(0, $3y2s4.isExperimentEnabled)('platform_editor_remove_default_renderer_nodes') ? {} : $3fc2b62f3357bff9$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if (node.type.name === 'codeBlock') {
        if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return nodes.windowedCodeBlock ?? $3fc2b62f3357bff9$export$a22ee8f907eecb5f;
        return nodes.codeBlock ?? $3fc2b62f3357bff9$export$6c415d1fdae3dfdb;
    }
    nodes['multiBodiedExtension'] = (0, $jBfbK.default);
    return nodes[node.type.name];
};
const $3fc2b62f3357bff9$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$3fc2b62f3357bff9$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $3fc2b62f3357bff9$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $3fc2b62f3357bff9$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $3fc2b62f3357bff9$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $3fc2b62f3357bff9$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3fc2b62f3357bff9$var$whitespaceRegex = /^\s*$/;
const $3fc2b62f3357bff9$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $3fc2b62f3357bff9$var$isEmojiBlock(node.content);
};
const $3fc2b62f3357bff9$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($3fc2b62f3357bff9$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("deAR2", function(module, exports) {
"use strict";
var $9a292bb336a5ff59$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $9a292bb336a5ff59$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a292bb336a5ff59$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9a292bb336a5ff59$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $bSJIT = parcelRequire("bSJIT");

var $4yQYd = parcelRequire("4yQYd");
var $9a292bb336a5ff59$var$ALL_INITIALIZERS = [];
var $9a292bb336a5ff59$var$READY_INITIALIZERS = [];
function $9a292bb336a5ff59$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $9a292bb336a5ff59$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $9a292bb336a5ff59$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $9a292bb336a5ff59$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $9a292bb336a5ff59$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $9a292bb336a5ff59$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $9a292bb336a5ff59$var$render(loaded, props) {
    return $bSJIT.createElement($9a292bb336a5ff59$var$resolve(loaded), props);
}
function $9a292bb336a5ff59$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $9a292bb336a5ff59$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $9a292bb336a5ff59$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $9a292bb336a5ff59$var$READY_INITIALIZERS.push(function() {
        if ($9a292bb336a5ff59$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $9a292bb336a5ff59$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $9a292bb336a5ff59$var$_classCallCheck(this, LoadableComponent);
            var _this = $9a292bb336a5ff59$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        // renamed from componentWillMount See https://fb.me/react-unsafe-component-lifecycles
        LoadableComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $bSJIT.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($bSJIT.Component), _class.contextTypes = {
        loadable: $4yQYd.shape({
            report: $4yQYd.func.isRequired
        })
    }, _temp;
}
function $9a292bb336a5ff59$var$Loadable(opts) {
    return $9a292bb336a5ff59$var$createLoadableComponent($9a292bb336a5ff59$var$load, opts);
}
function $9a292bb336a5ff59$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $9a292bb336a5ff59$var$createLoadableComponent($9a292bb336a5ff59$var$loadMap, opts);
}
$9a292bb336a5ff59$var$Loadable.Map = $9a292bb336a5ff59$var$LoadableMap;
var $9a292bb336a5ff59$var$Capture = function(_React$Component2) {
    $9a292bb336a5ff59$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $9a292bb336a5ff59$var$_classCallCheck(this, Capture);
        return $9a292bb336a5ff59$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $bSJIT.Children.only(this.props.children);
    };
    return Capture;
}($bSJIT.Component);
$9a292bb336a5ff59$var$Capture.propTypes = {
    report: $4yQYd.func.isRequired
};
$9a292bb336a5ff59$var$Capture.childContextTypes = {
    loadable: $4yQYd.shape({
        report: $4yQYd.func.isRequired
    }).isRequired
};
$9a292bb336a5ff59$var$Loadable.Capture = $9a292bb336a5ff59$var$Capture;
function $9a292bb336a5ff59$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $9a292bb336a5ff59$var$flushInitializers(initializers);
    });
}
$9a292bb336a5ff59$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $9a292bb336a5ff59$var$flushInitializers($9a292bb336a5ff59$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$9a292bb336a5ff59$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $9a292bb336a5ff59$var$flushInitializers($9a292bb336a5ff59$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $9a292bb336a5ff59$var$Loadable;

});

parcelRegister("d8JFj", function(module, exports) {
$parcel$export(module.exports, "default", () => $200ec3a6c536c1d4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $5bbjm = parcelRequire("5bbjm");

var $1hEmZ = parcelRequire("1hEmZ");

var $lavtv = parcelRequire("lavtv");

var $g6Qq4 = parcelRequire("g6Qq4");

var $36uNV = parcelRequire("36uNV");

var $eRA48 = parcelRequire("eRA48");

var $eJxzy = parcelRequire("eJxzy");
const $200ec3a6c536c1d4$var$blockNodeStyle = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $5bbjm.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $200ec3a6c536c1d4$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $eJxzy.getUnsupportedContent)((0, $36uNV.unsupportedContentMessages).unsupportedBlockContent, (0, $36uNV.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $36uNV.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $bSJIT.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $bSJIT.useCallback)(()=>dispatchAnalyticsEvent && (0, $eRA48.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $200ec3a6c536c1d4$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hEmZ))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $200ec3a6c536c1d4$var$_default_1 = (0, $fK3tS.default)($200ec3a6c536c1d4$var$UnsupportedBlockNode);
var $200ec3a6c536c1d4$export$2e2bcd8739ae039 = $200ec3a6c536c1d4$var$_default_1;

});
parcelRegister("5bbjm", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $14c2bf80c5f95bb0$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $14c2bf80c5f95bb0$export$24495b314f307191);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $14c2bf80c5f95bb0$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $14c2bf80c5f95bb0$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $14c2bf80c5f95bb0$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $14c2bf80c5f95bb0$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $14c2bf80c5f95bb0$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $14c2bf80c5f95bb0$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $14c2bf80c5f95bb0$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $14c2bf80c5f95bb0$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $14c2bf80c5f95bb0$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $14c2bf80c5f95bb0$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $14c2bf80c5f95bb0$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $14c2bf80c5f95bb0$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $14c2bf80c5f95bb0$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $14c2bf80c5f95bb0$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $14c2bf80c5f95bb0$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableContainerBg", () => $14c2bf80c5f95bb0$export$d0fb376c4d4be9e2);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $14c2bf80c5f95bb0$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $14c2bf80c5f95bb0$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $14c2bf80c5f95bb0$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $14c2bf80c5f95bb0$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorMaxWidthLayoutWidth", () => $14c2bf80c5f95bb0$export$c0f7d71e10d277e9);
$parcel$export(module.exports, "akEditorMaxLayoutWidth", () => $14c2bf80c5f95bb0$export$45eb0f5135abf6f1);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $14c2bf80c5f95bb0$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $14c2bf80c5f95bb0$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $14c2bf80c5f95bb0$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $14c2bf80c5f95bb0$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $14c2bf80c5f95bb0$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $14c2bf80c5f95bb0$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $14c2bf80c5f95bb0$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $14c2bf80c5f95bb0$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $14c2bf80c5f95bb0$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $14c2bf80c5f95bb0$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $14c2bf80c5f95bb0$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $14c2bf80c5f95bb0$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $14c2bf80c5f95bb0$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $14c2bf80c5f95bb0$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $14c2bf80c5f95bb0$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $14c2bf80c5f95bb0$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $14c2bf80c5f95bb0$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $14c2bf80c5f95bb0$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $14c2bf80c5f95bb0$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $14c2bf80c5f95bb0$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $14c2bf80c5f95bb0$export$e88f6c898960b391);
$parcel$export(module.exports, "layoutBreakpointWidth", () => $14c2bf80c5f95bb0$export$e5c605f2b2a12b00);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $14c2bf80c5f95bb0$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $14c2bf80c5f95bb0$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $14c2bf80c5f95bb0$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $14c2bf80c5f95bb0$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $14c2bf80c5f95bb0$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $14c2bf80c5f95bb0$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorFullPageToolbarHeight", () => $14c2bf80c5f95bb0$export$d1343597f3b52d83);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $14c2bf80c5f95bb0$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $14c2bf80c5f95bb0$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $14c2bf80c5f95bb0$export$59733a9f61449b25);
$parcel$export(module.exports, "relativeSizeToBaseFontSize", () => $14c2bf80c5f95bb0$export$46715ac1fbd9e64e);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $14c2bf80c5f95bb0$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $14c2bf80c5f95bb0$export$42608c013398a830);

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");
const $14c2bf80c5f95bb0$export$fe6b0b821a0e9067 = 16;
const $14c2bf80c5f95bb0$export$24495b314f307191 = 13;
const $14c2bf80c5f95bb0$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $14c2bf80c5f95bb0$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $14c2bf80c5f95bb0$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
const $14c2bf80c5f95bb0$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $14c2bf80c5f95bb0$export$f0e953d95429ca1 = '12px';
const $14c2bf80c5f95bb0$export$a309dbdeca0adb1a = '2px 4px';
const $14c2bf80c5f95bb0$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $14c2bf80c5f95bb0$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $14c2bf80c5f95bb0$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $14c2bf80c5f95bb0$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $14c2bf80c5f95bb0$export$d2715266dd4a1fd1 = 20;
const $14c2bf80c5f95bb0$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
const $14c2bf80c5f95bb0$export$8dac549e32469ac4 = 1;
const $14c2bf80c5f95bb0$export$befaaae517e3d864 = 2;
const $14c2bf80c5f95bb0$export$6e1e1996c4e8cc51 = `${$14c2bf80c5f95bb0$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #1868DB)"}`;
const $14c2bf80c5f95bb0$export$b6a59ac3a19b6343 = `0 0 0 ${$14c2bf80c5f95bb0$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #1868DB)"}`;
const $14c2bf80c5f95bb0$export$37e178ca41c198ca = `0 0 0 ${$14c2bf80c5f95bb0$export$befaaae517e3d864}px ${"var(--ds-border-selected, #1868DB)"}`;
const $14c2bf80c5f95bb0$export$4a007c22e25e31f6 = 0.3;
const $14c2bf80c5f95bb0$export$f35cc48f3398ab79 = 1;
const $14c2bf80c5f95bb0$export$b46cda584c619451 = 2;
const $14c2bf80c5f95bb0$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $14c2bf80c5f95bb0$export$321ddd2f049dd12 = $14c2bf80c5f95bb0$export$6bed85de54b5de42 + 1;
const $14c2bf80c5f95bb0$export$daeac9b8422ac3c2 = 2;
const $14c2bf80c5f95bb0$export$501d46e11ed5bf73 = 500;
const $14c2bf80c5f95bb0$export$6817b4b6a5ef78f1 = 400;
const $14c2bf80c5f95bb0$export$93768eb72dec48ce = $14c2bf80c5f95bb0$export$501d46e11ed5bf73 + 10;
const $14c2bf80c5f95bb0$export$c0aec4e0896849a0 = $14c2bf80c5f95bb0$export$93768eb72dec48ce - 5;
const $14c2bf80c5f95bb0$export$5886f057e4f21fe4 = $14c2bf80c5f95bb0$export$6817b4b6a5ef78f1 + 5;
const $14c2bf80c5f95bb0$export$6e85faa46d537a3f = 11;
const $14c2bf80c5f95bb0$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $14c2bf80c5f95bb0$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $14c2bf80c5f95bb0$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $14c2bf80c5f95bb0$export$95e9a0285b97474d = '#2C333A';
const $14c2bf80c5f95bb0$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
const $14c2bf80c5f95bb0$export$76b5e653883e5290 = '3px';
const $14c2bf80c5f95bb0$export$d0fb376c4d4be9e2 = '--table-container-bg';
const $14c2bf80c5f95bb0$export$6d85fe8177a50c0c = 0.5;
const $14c2bf80c5f95bb0$export$fad19f16d3f953a3 = 680;
const $14c2bf80c5f95bb0$export$9db045950eedb49f = 760;
const $14c2bf80c5f95bb0$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $14c2bf80c5f95bb0$export$f580e3d28d0986de = 1800;
const $14c2bf80c5f95bb0$export$c0f7d71e10d277e9 = 4000;
const $14c2bf80c5f95bb0$export$9d5488b5afad62bf = 1792;
const $14c2bf80c5f95bb0$export$45eb0f5135abf6f1 = 4000;
const $14c2bf80c5f95bb0$export$37df10057d36a0e5 = 42;
const $14c2bf80c5f95bb0$export$437293c5e9fc2703 = 96;
const $14c2bf80c5f95bb0$export$6e0f4d52efd3d2d = 32;
const $14c2bf80c5f95bb0$export$f222e0c7a2dc5324 = ()=>72;
const $14c2bf80c5f95bb0$export$aae87d25ced827bb = 24;
const $14c2bf80c5f95bb0$export$cccda66937c91e4c = 600;
const $14c2bf80c5f95bb0$export$efe8561bbd3f74d2 = 720;
const $14c2bf80c5f95bb0$export$e4d39a9e8607c1d3 = 48;
const $14c2bf80c5f95bb0$export$43946f2400ab6f1f = 128;
const $14c2bf80c5f95bb0$export$558438ae7fd4b8ce = 12;
const $14c2bf80c5f95bb0$export$6beb98d32d4ca149 = 4;
const $14c2bf80c5f95bb0$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $14c2bf80c5f95bb0$export$5edb4f38c3eacb1a = 1024;
const $14c2bf80c5f95bb0$export$e60820063058ed59 = 1.33;
const $14c2bf80c5f95bb0$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $14c2bf80c5f95bb0$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $14c2bf80c5f95bb0$export$fb15fade89f67217 = $14c2bf80c5f95bb0$export$f35cc48f3398ab79 * 99;
const $14c2bf80c5f95bb0$export$847030921e9d5a40 = 12;
const $14c2bf80c5f95bb0$export$40eb41ab799f0329 = 1.714;
const $14c2bf80c5f95bb0$export$e271312fc7124aec = '1px';
const $14c2bf80c5f95bb0$export$d29cb2c31fcbb7c5 = 2;
const $14c2bf80c5f95bb0$export$688a6dc01e760755 = 320;
const $14c2bf80c5f95bb0$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $14c2bf80c5f95bb0$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $14c2bf80c5f95bb0$export$e88f6c898960b391 = $14c2bf80c5f95bb0$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $14c2bf80c5f95bb0$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $14c2bf80c5f95bb0$export$1d0d506416d457f1 = '0.75rem';
const $14c2bf80c5f95bb0$export$53030af820b542f5 = '0.75em';
const $14c2bf80c5f95bb0$export$e683ef42725d1713 = 680;
const $14c2bf80c5f95bb0$export$226c784ba04bd04b = 480;
const $14c2bf80c5f95bb0$export$214ff00e5618d86c = 20;
const $14c2bf80c5f95bb0$export$c82675fa56f2eefd = '56px';
const $14c2bf80c5f95bb0$var$DEFAULT_FONT_SIZE = 14;
const $14c2bf80c5f95bb0$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// If value is undefined, assume this is being called outside of the editor.
    isToolbarAIFCEnabled === undefined ? (0, $gdUUy.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $14c2bf80c5f95bb0$export$d1343597f3b52d83 = 40;
const $14c2bf80c5f95bb0$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $14c2bf80c5f95bb0$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $14c2bf80c5f95bb0$var$DEFAULT_FONT_SIZE;
const $14c2bf80c5f95bb0$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$14c2bf80c5f95bb0$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $14c2bf80c5f95bb0$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $14c2bf80c5f95bb0$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$14c2bf80c5f95bb0$export$fe6b0b821a0e9067})`;
};
const $14c2bf80c5f95bb0$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $14c2bf80c5f95bb0$export$9369fd010fa0ddd6 = 0;
const $14c2bf80c5f95bb0$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$14c2bf80c5f95bb0$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $14c2bf80c5f95bb0$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $14c2bf80c5f95bb0$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
const $14c2bf80c5f95bb0$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});
parcelRegister("797yE", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $31889218de05773b$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $87QgR = parcelRequire("87QgR");

var $i2aoZ = parcelRequire("i2aoZ");

var $1ojCy = parcelRequire("1ojCy");

var $hj2cZ = parcelRequire("hj2cZ");
const $31889218de05773b$var$EDITOR_CONTROLS_EXPERIMENT = 'platform_editor_controls';
const $31889218de05773b$var$EDITOR_CONTROLS_OTHER_APPS_KILL_SWITCH = 'platform_editor_controls_other_apps_ks';
/**
 * Resolves the `platform_editor_controls` cohort while the experiment is being cleaned up.
 *
 * - Confluence and Jira always get `variant1`. Their product code has been cleaned up to always
 *   behave as `variant1` (EDITOR-9269, EDITOR-9270), so the editor must agree with it.
 * - Every other app (no product, or a product without a product key such as Bitbucket) gets
 *   `variant1` unless the kill switch `platform_editor_controls_other_apps_ks` passes for that app,
 *   in which case it gets `control`. The kill switch defaults to false, so controls are on by
 *   default. Its exposure always fires so Statsig shows which apps run this code.
 * - Before the Statsig client is initialised, other apps get the experiment's default value.
 * - The `test` product keeps the experiment's default value.
 *
 * Remove together with the experiment in EDITOR-9262.
 */ function $31889218de05773b$var$getEditorControlsCohort(defaultValue) {
    if ((0, $hj2cZ._product) === 'confluence' || (0, $hj2cZ._product) === 'jira') return 'variant1';
    if ((0, $hj2cZ._product) === 'test') return defaultValue;
    if (!(0, $87QgR.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    return (0, $87QgR.default).checkGate($31889218de05773b$var$EDITOR_CONTROLS_OTHER_APPS_KILL_SWITCH, {
        fireGateExposure: true
    }) ? 'control' : 'variant1';
}
function $31889218de05773b$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    var _experimentConfig$pro;
    const experimentConfig = (0, $1ojCy.editorExperimentsConfig)[experimentName];
    if ((0, $hj2cZ._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $hj2cZ._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (experimentName === $31889218de05773b$var$EDITOR_CONTROLS_EXPERIMENT) {
        const cohort = $31889218de05773b$var$getEditorControlsCohort(experimentConfig.defaultValue);
        (0, $i2aoZ.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, cohort);
        return cohort === expectedExperimentValue;
    }
    if (!(0, $hj2cZ._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $hj2cZ._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $1ojCy.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $87QgR.default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    (0, $i2aoZ.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}

});


parcelRegister("1hEmZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef6b1971946d82c$var$_react = $0ef6b1971946d82c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $0ef6b1971946d82c$var$_iconNew = $0ef6b1971946d82c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $0ef6b1971946d82c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef6b1971946d82c$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $0ef6b1971946d82c$var$_react.default.createElement($0ef6b1971946d82c$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$0ef6b1971946d82c$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $0ef6b1971946d82c$var$_default = module.exports.default = $0ef6b1971946d82c$var$QuestionCircleIcon;

});

parcelRegister("g6Qq4", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $ddfdd9534e31cf78$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $ddfdd9534e31cf78$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $ddfdd9534e31cf78$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "MEDIA_INSERT_TAB", () => $ddfdd9534e31cf78$export$9395e0d0ae49956f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $ddfdd9534e31cf78$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $ddfdd9534e31cf78$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $ddfdd9534e31cf78$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $ddfdd9534e31cf78$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $ddfdd9534e31cf78$export$9f0b2adf3cfd71b7);
var $ddfdd9534e31cf78$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $ddfdd9534e31cf78$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARD_ALL"] = "discardAll";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DIVERGED"] = "diverged";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EMPTY_STATE_EXPOSED"] = "emptyStateExposed";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["GENERATED"] = "generated";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INSERT_ATTEMPTED"] = "insertAttempted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIMITED_MODE_LATCHED"] = "limitedModeLatched";
    ACTION["LANGUAGE_AUTO_DETECTED"] = "languageAutoDetected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["ACCEPTED"] = "accepted";
    ACTION["NO_DIFF_FOUND"] = "noDiffFound";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["QUICK_INSERT_INFORMATION"] = "quickInsertInformation";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REGENERATION_COMPLETED"] = "regenerationCompleted";
    ACTION["REGENERATION_STARTED"] = "regenerationStarted";
    ACTION["RIGHT_RAIL_CLOSED"] = "rightRailClosed";
    ACTION["RIGHT_RAIL_VIEWED"] = "rightRailViewed";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["SEARCHED"] = "searched";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["RENDERED"] = "rendered";
    ACTION["REASONING_VIEWED"] = "reasoningViewed";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["CONTAINER_NODE_TRANSFORMED"] = "containerNodeTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["AGENT_EDIT_SHIMMER_NOT_SHOWN"] = "agentEditShimmerNotShown";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_FOLDING"] = "toggleCodeFolding";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TOGGLE_CODE_BLOCK_LINE_NUMBERS"] = "toggleCodeBlockLineNumbers";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["LOCAL_IDS_REPAIRED"] = "localIdsRepaired";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    // fired when the on-device autocomplete LLM finishes loading/starting
    ACTION["LOCAL_MODEL_LOADED"] = "localModelLoaded";
    // fired when the on-device autocomplete LLM fails to load/start
    ACTION["LOCAL_MODEL_LOAD_FAILED"] = "localModelLoadFailed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $ddfdd9534e31cf78$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    INPUT_METHOD["REMIX"] = "remix";
    INPUT_METHOD["REMIX_FROM_MEDIA_INSERTS"] = "remixFromMediaInserts";
    return INPUT_METHOD;
}({});
var $ddfdd9534e31cf78$export$9395e0d0ae49956f = /*#__PURE__*/ function(MEDIA_INSERT_TAB) {
    MEDIA_INSERT_TAB["CREATE"] = "create";
    MEDIA_INSERT_TAB["LINK"] = "link";
    MEDIA_INSERT_TAB["UPLOAD"] = "upload";
    return MEDIA_INSERT_TAB;
}({});
var $ddfdd9534e31cf78$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $ddfdd9534e31cf78$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $ddfdd9534e31cf78$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DIVIDER"] = "divider";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["EXTENSION_AS_INLINE"] = "extensionAsInline";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HEADING"] = "heading";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["NUMBERED_HEADINGS"] = "numberedHeadings";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["AI_SUGGESTIONS"] = "aiSuggestions";
    ACTION_SUBJECT["CONTEXTUAL_TYPEAHEAD"] = "contextualTypeahead";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    ACTION_SUBJECT["NATIVE_EMBED_FALLBACK"] = "nativeEmbedFallback";
    return ACTION_SUBJECT;
}({});
var $ddfdd9534e31cf78$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_REMIX_BUTTON"] = "aiRemixButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CONVERSATION_ERROR"] = "conversationError";
    ACTION_SUBJECT_ID["SUGGESTIONS_REGENERATION"] = "suggestionsRegeneration";
    ACTION_SUBJECT_ID["SUGGESTIONS_REGENERATION_ERROR"] = "suggestionsRegenerationError";
    ACTION_SUBJECT_ID["SUGGESTIONS_ERROR_RETRY"] = "suggestionsErrorRetry";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LAYOUT_COLUMN"] = "layoutColumn";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_ADD_CONTENT"] = "syncedBlockAddContent";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_INFO_ORPHANED"] = "syncedBlockSourceInfoOrphaned";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CACHE_DELETION_FORCED"] = "syncedBlockCacheDeletionForced";
    ACTION_SUBJECT_ID["UNSUPPORTED_SURFACE"] = "unsupportedSurface";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    ACTION_SUBJECT_ID["SNIPPET"] = "snippet";
    return ACTION_SUBJECT_ID;
}({});
var $ddfdd9534e31cf78$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $ddfdd9534e31cf78$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("36uNV", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $367fefcb9e2ddc0e$export$32ec96484dd3ba39);

var $f0Pt4 = parcelRequire("f0Pt4");
const $367fefcb9e2ddc0e$export$32ec96484dd3ba39 = (0, $f0Pt4.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'The text is shown as an inline label in the editor when a content node type is not supported for display. It appears alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'The text is shown as a block-level message in the editor when a content block type is not supported for display. It appears centered within a dashed border container alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'The text is shown as tooltip content when the user hovers over the question mark icon on an unsupported content node in the editor. It reassures users that unsupported content will not be lost when they edit and save the document.'
    }
});

});

parcelRegister("eRA48", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $235951054f0b4348$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $235951054f0b4348$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $235951054f0b4348$export$3a34598135e7219b);

var $g6Qq4 = parcelRequire("g6Qq4");
const $235951054f0b4348$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $235951054f0b4348$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $235951054f0b4348$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $235951054f0b4348$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $235951054f0b4348$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$235951054f0b4348$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $235951054f0b4348$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $235951054f0b4348$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $235951054f0b4348$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $235951054f0b4348$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $g6Qq4.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $g6Qq4.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $235951054f0b4348$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$235951054f0b4348$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $235951054f0b4348$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $235951054f0b4348$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $235951054f0b4348$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $235951054f0b4348$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $g6Qq4.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $235951054f0b4348$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $235951054f0b4348$var$trackUnsupportedContentTooltipActionFor((0, $g6Qq4.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("eJxzy", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $d6f685fdbfd972be$export$d4ded51d0f0bd2df);
function $d6f685fdbfd972be$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("lmZMT", function(module, exports) {
$parcel$export(module.exports, "default", () => $56d376820a3052e9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $5bbjm = parcelRequire("5bbjm");

var $1hEmZ = parcelRequire("1hEmZ");

var $lavtv = parcelRequire("lavtv");

var $g6Qq4 = parcelRequire("g6Qq4");

var $36uNV = parcelRequire("36uNV");

var $eRA48 = parcelRequire("eRA48");

var $eJxzy = parcelRequire("eJxzy");
const $56d376820a3052e9$var$inlineNodeStyle = /*#__PURE__*/ (0, $9dQre.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $5bbjm.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $56d376820a3052e9$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $eJxzy.getUnsupportedContent)((0, $36uNV.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $36uNV.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $bSJIT.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $bSJIT.useCallback)(()=>dispatchAnalyticsEvent && (0, $eRA48.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $56d376820a3052e9$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hEmZ))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $56d376820a3052e9$var$_default_1 = (0, $fK3tS.default)($56d376820a3052e9$var$UnsupportedInlineNode);
var $56d376820a3052e9$export$2e2bcd8739ae039 = $56d376820a3052e9$var$_default_1;

});

parcelRegister("k8sMW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cbe8cfcb0cd8a20$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $4cbe8cfcb0cd8a20$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("blockquote", {
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("el3JZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $31fd54e8a2705b9b$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8aUeF = parcelRequire("8aUeF");

var $03SYF = parcelRequire("03SYF");

var $6SGk4 = parcelRequire("6SGk4");

var $9ZAW5 = parcelRequire("9ZAW5");

var $6e8ph = parcelRequire("6e8ph");

var $ctw5d = parcelRequire("ctw5d");
const $31fd54e8a2705b9b$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, fireAnalyticsEvent: fireAnalyticsEvent } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $bSJIT.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9ZAW5.ErrorBoundary), {
        component: (0, $8aUeF.ACTION_SUBJECT).RENDERER,
        componentId: (0, $g6Qq4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $03SYF.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6e8ph.ValidationContextProvider), {
                value: validationContextValue,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6SGk4.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ node: node, result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $ctw5d.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1,
                                rendererAppearance: props.rendererAppearance,
                                fireAnalyticsEvent: fireAnalyticsEvent
                            }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                        } catch  {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $ctw5d.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1,
                            rendererAppearance: props.rendererAppearance,
                            fireAnalyticsEvent: fireAnalyticsEvent
                        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                    }
                })
            })
        })
    });
};
var $31fd54e8a2705b9b$export$2e2bcd8739ae039 = $31fd54e8a2705b9b$var$BodiedExtension;

});
parcelRegister("8aUeF", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $974ce528c7d5cadf$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $974ce528c7d5cadf$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $974ce528c7d5cadf$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $974ce528c7d5cadf$export$9957974f8b4d8f74);
var $974ce528c7d5cadf$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $974ce528c7d5cadf$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $974ce528c7d5cadf$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $974ce528c7d5cadf$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_DOWNLOAD"] = "codeBlockDownload";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("03SYF", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $b2f6b21eb11022dd$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $b2f6b21eb11022dd$export$cef0157dd42cbb3f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $6WltM = parcelRequire("6WltM");

var $cR5yJ = parcelRequire("cR5yJ");

var $ihGX5 = parcelRequire("ihGX5");

var $il86U = parcelRequire("il86U");

var $2U3vi = parcelRequire("2U3vi");

var $gj7PC = parcelRequire("gj7PC");

var $77hMz = parcelRequire("77hMz");

var $2BJSj = parcelRequire("2BJSj");

var $ehdmB = parcelRequire("ehdmB");
const $b2f6b21eb11022dd$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $77hMz.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $b2f6b21eb11022dd$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({
    startPos: 1
});
const $b2f6b21eb11022dd$export$7121915072388536 = (props)=>{
    var _providers$inlineComm, _providers$inlineComm2;
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $bSJIT.useContext)((0, $cR5yJ.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $gj7PC.useAnnotationStateByTypeEvent)({
        type: (0, $9IULF.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cR5yJ.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2U3vi.AnnotationRangeProvider), {
            allowCommentsOnMedia: (providers === null || providers === void 0 || (_providers$inlineComm = providers.inlineComment) === null || _providers$inlineComm === void 0 ? void 0 : _providers$inlineComm.allowCommentsOnMedia) ?? false,
            hasBlockNodeSupport: Boolean(providers === null || providers === void 0 || (_providers$inlineComm2 = providers.inlineComment) === null || _providers$inlineComm2 === void 0 ? void 0 : _providers$inlineComm2.isBlockNodeSupported),
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ihGX5.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $ehdmB.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)($b2f6b21eb11022dd$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $2BJSj.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $b2f6b21eb11022dd$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider !== null && annotationProvider !== void 0 && annotationProvider.annotationManager) {
        var _annotationProvider$i;
        // We need to ensure there is a single instance of the annotation manager for the whole document
        // and that it is the same instance for all annotations.
        // This is because the annotation manager is responsible for managing the state of ALL annotations.
        // This includes annotations inside extensions.
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cR5yJ.ProvidersContext).Provider, {
            value: annotationProvider,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $il86U.AnnotationManagerProvider), {
                annotationManager: annotationProvider.annotationManager,
                updateSubscriber: (annotationProvider === null || annotationProvider === void 0 || (_annotationProvider$i = annotationProvider.inlineComment) === null || _annotationProvider$i === void 0 ? void 0 : _annotationProvider$i.updateSubscriber) ?? undefined,
                children: /*#__PURE__*/ (0, $dc70d.jsx)($b2f6b21eb11022dd$export$7121915072388536, {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    isNestedRender: isNestedRender,
                    onLoadComplete: onLoadComplete,
                    children: children
                })
            })
        });
    } else return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cR5yJ.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($b2f6b21eb11022dd$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("9IULF", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $46e844ee63da2393$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $46e844ee63da2393$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $46e844ee63da2393$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $46e844ee63da2393$export$8512c9afa7b24c3b);

var $tw27l = parcelRequire("tw27l");
var $46e844ee63da2393$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $46e844ee63da2393$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $46e844ee63da2393$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $46e844ee63da2393$export$8512c9afa7b24c3b = (0, $tw27l.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$46e844ee63da2393$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});
parcelRegister("tw27l", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $edb5501893d05b0d$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $edb5501893d05b0d$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $edb5501893d05b0d$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $edb5501893d05b0d$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $edb5501893d05b0d$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $edb5501893d05b0d$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $edb5501893d05b0d$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $edb5501893d05b0d$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $edb5501893d05b0d$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $edb5501893d05b0d$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $edb5501893d05b0d$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $edb5501893d05b0d$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $edb5501893d05b0d$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $edb5501893d05b0d$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $edb5501893d05b0d$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $edb5501893d05b0d$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $edb5501893d05b0d$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $edb5501893d05b0d$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $edb5501893d05b0d$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $edb5501893d05b0d$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $edb5501893d05b0d$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $10GvA = parcelRequire("10GvA");
const $edb5501893d05b0d$export$8e53000a4ec837 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $edb5501893d05b0d$export$8512c9afa7b24c3b = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $edb5501893d05b0d$export$8c5a050822fd698c = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $edb5501893d05b0d$export$1edee58a52776cd9 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $edb5501893d05b0d$export$89015c65f1c75e3f = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $edb5501893d05b0d$export$6565f9f03506010b = (0, $10GvA.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $edb5501893d05b0d$export$f3b72f8fc4684ecd = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $edb5501893d05b0d$export$3024f02c495408d6 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $edb5501893d05b0d$export$c63c6f932822f543 = (0, $10GvA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $edb5501893d05b0d$export$85e3c3ca0c6fb93 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $edb5501893d05b0d$export$f00aeb236b6f05af = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $edb5501893d05b0d$export$480c699bd4ec0d86 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $edb5501893d05b0d$export$9c30223ca0a664fb = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $edb5501893d05b0d$export$4899a95d70ec5056 = (0, $10GvA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $edb5501893d05b0d$export$59ae2c325a998f89 = (0, $10GvA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $edb5501893d05b0d$export$b3401ee80eb31041 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $edb5501893d05b0d$export$32f78bffcd82ff28 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $edb5501893d05b0d$export$20af3dabbb5538df = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $edb5501893d05b0d$export$425327af25286e5e = (0, $10GvA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $edb5501893d05b0d$export$30d78d5eb6719bb8 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $edb5501893d05b0d$export$a316dc07ff5182a2 = (0, $10GvA.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});
parcelRegister("10GvA", function(module, exports) {
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $cd723d2d2e751c37$export$cf5823ed4e9f4c6f);
const $cd723d2d2e751c37$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("cR5yJ", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $972cb968c28ac4ea$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $972cb968c28ac4ea$export$aafe46a36ef535ba);

var $bSJIT = parcelRequire("bSJIT");
const $972cb968c28ac4ea$export$6a26b015ac619737 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $972cb968c28ac4ea$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $bSJIT.createContext)({});

});

parcelRegister("ihGX5", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $0be07965dbb1b732$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $0be07965dbb1b732$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $0be07965dbb1b732$export$c288883964405c82);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $0be07965dbb1b732$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    isWithinRange: false
});
const $0be07965dbb1b732$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $0be07965dbb1b732$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $bSJIT.useState)(false);
    const timeoutHandler = (0, $bSJIT.useRef)();
    const cancelTimeout = (0, $bSJIT.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $bSJIT.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $bSJIT.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $bSJIT.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($0be07965dbb1b732$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($0be07965dbb1b732$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $0be07965dbb1b732$export$a02bfcbbbf920306 = ()=>{
    return (0, $bSJIT.useContext)($0be07965dbb1b732$var$AnnotationHoverStateContext);
};
const $0be07965dbb1b732$export$c288883964405c82 = ()=>{
    return (0, $bSJIT.useContext)($0be07965dbb1b732$var$AnnotationHoverDispatchContext);
};

});

parcelRegister("il86U", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $80ab854a9f9f8ad3$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $80ab854a9f9f8ad3$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $80ab854a9f9f8ad3$export$12cbbb89fb7702d0);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $4GPCq = parcelRequire("4GPCq");

var $5cXhe = parcelRequire("5cXhe");
const $80ab854a9f9f8ad3$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $80ab854a9f9f8ad3$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $bSJIT.createContext)($80ab854a9f9f8ad3$var$initState);
const $80ab854a9f9f8ad3$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $80ab854a9f9f8ad3$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$80ab854a9f9f8ad3$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    var _state$annotations$id, _state$annotations$id2;
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && ((_state$annotations$id = state.annotations[id]) === null || _state$annotations$id === void 0 ? void 0 : _state$annotations$id.markState) === (0, $9IULF.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $9IULF.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!(loadedAnnotation !== null && loadedAnnotation !== void 0 && loadedAnnotation.markState) && ((_state$annotations$id2 = state.annotations[id]) === null || _state$annotations$id2 === void 0 ? void 0 : _state$annotations$id2.markState) !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current === null || current === void 0 ? void 0 : current.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $9IULF.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if ((current === null || current === void 0 ? void 0 : current.markState) !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $9IULF.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $9IULF.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $80ab854a9f9f8ad3$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $bSJIT.useReducer)($80ab854a9f9f8ad3$var$reducer, $80ab854a9f9f8ad3$var$initState);
    const actionContext = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    (0, $bSJIT.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('getDraft', getDraft);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $bSJIT.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            var _state$annotations;
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!((_state$annotations = state.annotations) !== null && _state$annotations !== void 0 && _state$annotations[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- resolve mark node by id in the document
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $bSJIT.useRef)(undefined);
    (0, $bSJIT.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            var _state$annotations2;
            if (!((_state$annotations2 = state.annotations) !== null && _state$annotations2 !== void 0 && _state$annotations2[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            var _state$annotations3;
            if (!((_state$annotations3 = state.annotations) !== null && _state$annotations3 !== void 0 && _state$annotations3[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $9IULF.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $bSJIT.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $9IULF.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $bSJIT.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($80ab854a9f9f8ad3$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($80ab854a9f9f8ad3$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $80ab854a9f9f8ad3$export$654a1fb45487f838 = ()=>{
    return (0, $bSJIT.useContext)($80ab854a9f9f8ad3$var$AnnotationManagerStateContext);
};
const $80ab854a9f9f8ad3$export$12cbbb89fb7702d0 = ()=>{
    return (0, $bSJIT.useContext)($80ab854a9f9f8ad3$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("4GPCq", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $d7ecd30cb1b3ffd5$export$c1c4b33b4e7b1c70);

var $03cmj = parcelRequire("03cmj");
var $d7ecd30cb1b3ffd5$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $d7ecd30cb1b3ffd5$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($03cmj)))();
    }
}

});

parcelRegister("5cXhe", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $34e085c0d0703f39$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $34e085c0d0703f39$export$66feffbad722f9d4);
/* eslint-disable jsdoc/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1l5zG = parcelRequire("1l5zG");

var $6WltM = parcelRequire("6WltM");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gdUUy = parcelRequire("gdUUy");

var $fDZc1 = parcelRequire("fDZc1");
const $34e085c0d0703f39$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(new (0, $fDZc1.default)());
function $34e085c0d0703f39$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const actions = (0, $bSJIT.useMemo)(()=>new (0, $fDZc1.default)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.count(children) > 1 && (0, $gdUUy.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $1l5zG.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)($34e085c0d0703f39$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $gdUUy.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(children) : children
    });
}
const $34e085c0d0703f39$export$d5fcf151601331bc = $34e085c0d0703f39$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("fDZc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a1e0ee1522436b3$export$2e2bcd8739ae039);

var $9IULF = parcelRequire("9IULF");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cWyqT = parcelRequire("cWyqT");

var $c6WhP = parcelRequire("c6WhP");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gdUUy = parcelRequire("gdUUy");

var $ah11j = parcelRequire("ah11j");

var $fw3ah = parcelRequire("fw3ah");

var $9ly8I = parcelRequire("9ly8I");

var $jq7sX = parcelRequire("jq7sX");
class $0a1e0ee1522436b3$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $c6WhP.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $cw0wu.TextSelection).create(this.doc, from, to);
        if ((0, $cWyqT.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $cWyqT.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        const schema = this.schema;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && (0, $9ly8I.isBlockAnnotationTarget)(node, schema)) nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $3DNV7.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $3DNV7.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $g6Qq4.ACTION).DELETED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $3DNV7.RemoveMarkStep) ? (0, $fw3ah.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $ah11j.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $ah11j.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (this.isInsideNestedExtensionRenderer(startContainer) || this.isInsideNestedExtensionRenderer(endContainer)) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    /**
   * A range only threatens a nested renderer's own document (e.g. a bodiedExtension's macro
   * body, which renders its own nested `<Renderer>`) when it sits inside that nested renderer's
   * `.ak-renderer-document`. Landing directly on the extension's own outer wrapper -- with no
   * nested document in between -- must stay annotatable so the whole chart/extension can be
   * targeted (MAUI-1256), rather than being rejected outright the way any range touching
   * `.ak-renderer-extension` previously was.
   *
   * Behind `cc_maui_annotations_on_extensions` -- the same gate MAUI-1255 added for extension
   * node-mark support -- to preserve the previous behaviour (reject anything touching
   * `.ak-renderer-extension`) while the feature is off.
   */ isInsideNestedExtensionRenderer(container) {
        // Preserve the legacy parent-based rejection while the gate is disabled.
        if (!(0, $gdUUy.fg)('cc_maui_annotations_on_extensions')) {
            var _container$parentElem;
            return !!((_container$parentElem = container.parentElement) !== null && _container$parentElem !== void 0 && _container$parentElem.closest('.ak-renderer-extension'));
        }
        const element = container instanceof Element ? container : container.parentElement;
        if (!element) return false;
        const extensionAncestor = element.closest('.ak-renderer-extension');
        if (!extensionAncestor) return false;
        const nestedDocument = element.closest('.ak-renderer-document');
        return !!nestedDocument && extensionAncestor.contains(nestedDocument);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $ah11j.getPosFromRange)(range);
    }
    getSelectionContext() {
        return (0, $jq7sX.getSelectionContext)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getMediaNodeContext(identifier) {
        if (!this.doc) return {
            status: 'missing'
        };
        const candidates = [];
        this.doc.descendants((node, position)=>{
            if (node.type.name !== 'media' || node.attrs.type !== 'file' || node.attrs.id !== identifier.id) return true;
            candidates.push({
                fileId: identifier.id,
                annotationIds: node.marks.filter((mark)=>mark.type.name === 'annotation' && mark.attrs.annotationType === (0, $9IULF.AnnotationTypes).INLINE_COMMENT).map((mark)=>mark.attrs.id).filter((id)=>typeof id === 'string'),
                position: position,
                displayText: node.attrs.alt || node.attrs.__fileName || node.attrs.fileName || node.attrs.name,
                occurrenceKey: typeof node.attrs.occurrenceKey === 'string' ? node.attrs.occurrenceKey : undefined
            });
            return false;
        });
        const exactMatches = identifier.occurrenceKey ? candidates.filter((candidate)=>candidate.occurrenceKey === identifier.occurrenceKey) : [];
        const matches = exactMatches.length > 0 ? exactMatches : candidates;
        if (matches.length === 0) return {
            status: 'missing'
        };
        if (matches.length > 1) return {
            status: 'ambiguous'
        };
        return {
            status: 'resolved',
            context: matches[0]
        };
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $ah11j.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $cWyqT.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        const isBlockTarget = possibleNode ? (0, $9ly8I.isBlockAnnotationTarget)(possibleNode, this.schema) : false;
        if (possibleNode && isBlockTarget) {
            targetNodeType = possibleNode.type.name;
            step = new (0, $3DNV7.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $ah11j.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $9ly8I.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $fw3ah.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $9ly8I.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $cWyqT.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("cWyqT", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $87915eb1777a5c5b$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $87915eb1777a5c5b$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $87915eb1777a5c5b$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $87915eb1777a5c5b$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $87915eb1777a5c5b$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $87915eb1777a5c5b$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $87915eb1777a5c5b$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $87915eb1777a5c5b$export$2efbc6d84ea0fbec);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $87915eb1777a5c5b$export$a35880e7ecdcf47b);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9IULF = parcelRequire("9IULF");

var $gdUUy = parcelRequire("gdUUy");
const $87915eb1777a5c5b$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $87915eb1777a5c5b$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $87915eb1777a5c5b$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $87915eb1777a5c5b$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $87915eb1777a5c5b$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($87915eb1777a5c5b$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $87915eb1777a5c5b$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $87915eb1777a5c5b$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $87915eb1777a5c5b$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $87915eb1777a5c5b$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $87915eb1777a5c5b$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("c6WhP", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", () => $df32fe345387b4a1$export$98cb1d9308d0944d);

var $dMMwa = parcelRequire("dMMwa");

var $auxFA = parcelRequire("auxFA");

var $d8oKL = parcelRequire("d8oKL");

var $18ahg = parcelRequire("18ahg");
const $df32fe345387b4a1$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $df32fe345387b4a1$var$emptyDoc = $df32fe345387b4a1$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
class $df32fe345387b4a1$export$98cb1d9308d0944d {
    /**
   * Creates a new JSONTransformer instance.
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $auxFA.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $d8oKL.sanitizeNode)((0, $18ahg.toJSON)(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(content, $df32fe345387b4a1$var$emptyDoc.content)) return $df32fe345387b4a1$var$createDocFromContent([]);
        return $df32fe345387b4a1$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $auxFA.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($df32fe345387b4a1$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node, options = {}) {
        return (0, $d8oKL.sanitizeNode)((0, $18ahg.toJSON)(node, this.mentionMap), options);
    }
}

});
parcelRegister("auxFA", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $8c98da69f7c20aa7$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $8c98da69f7c20aa7$export$1db618b7b2275ea1);

var $57l7A = parcelRequire("57l7A");

var $gdUUy = parcelRequire("gdUUy");

var $eVoHz = parcelRequire("eVoHz");

var $2aCeP = parcelRequire("2aCeP");
var $8xR7M = parcelRequire("8xR7M");
var $1xC7B = parcelRequire("1xC7B");
var $jvwoj = parcelRequire("jvwoj");
var $5Z1us = parcelRequire("5Z1us");
var $c8L22 = parcelRequire("c8L22");

var $au7g7 = parcelRequire("au7g7");

var $qCqw4 = parcelRequire("qCqw4");

var $fpk0y = parcelRequire("fpk0y");

var $jvwoj = parcelRequire("jvwoj");

var $et9pQ = parcelRequire("et9pQ");
const $8c98da69f7c20aa7$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $8c98da69f7c20aa7$export$e4e3ac1fa64862db = $8c98da69f7c20aa7$var$getDefaultSchemaConfig();
const $8c98da69f7c20aa7$export$fd147e7d448dea03 = (0, $57l7A.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $8c98da69f7c20aa7$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $5Z1us.layoutSectionWithSingleColumn),
        extension: (0, $gdUUy.fg)('cc_maui_annotations_on_extensions') ? (0, $jvwoj.extensionRootOnlyWithAnnotationStage0) : (0, $jvwoj.extensionRootOnlyStage0),
        bodiedExtension: (0, $2aCeP.bodiedExtensionRootOnlyStage0),
        multiBodiedExtension: (0, $1xC7B.multiBodiedExtensionRootOnlyStage0),
        extensionFrame: (0, $1xC7B.extensionFrame),
        expand: (0, $8xR7M.expandWithNestedExpand),
        table: (0, $c8L22.tableWithNestedTable),
        tableRow: (0, $c8L22.tableRowWithNestedTable),
        tableCell: (0, $c8L22.tableCellWithNestedTableStage0),
        tableHeader: (0, $c8L22.tableHeaderWithNestedTableStage0),
        panel: (0, $fpk0y.extendedPanelRootOnlyStage0)(true),
        panel_c1: (0, $qCqw4.extendedPanelC1RootOnlyStage0)(true),
        rule: (0, $et9pQ.ruleWithAttrsRootOnlyStage0),
        bodiedRule: (0, $au7g7.bodiedRuleRootOnlyStage0)
    };
    return (0, $eVoHz.createSchema)(defaultSchemaConfig);
});
const $8c98da69f7c20aa7$export$1db618b7b2275ea1 = $8c98da69f7c20aa7$export$fd147e7d448dea03();

});
parcelRegister("eVoHz", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $c6e1e07b29e6f9c6$export$5f4ce795563f4211);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $kW8qW = parcelRequire("kW8qW");

var $14aQx = parcelRequire("14aQx");

var $4KeXh = parcelRequire("4KeXh");

var $aklv9 = parcelRequire("aklv9");

var $lPSxL = parcelRequire("lPSxL");

var $jiH53 = parcelRequire("jiH53");

function $c6e1e07b29e6f9c6$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat((0, $4KeXh.markGroupDeclarationsNames));
    let nodes = (0, $14aQx.addItems)((0, $lPSxL.nodesInOrder), nodesConfig, customNodeSpecs);
    const marks = (0, $14aQx.addItems)((0, $aklv9.marksInOrder), marksConfig, customMarkSpecs);
    nodes = (0, $jiH53.sanitizeNodes)(nodes, marks);
    return new (0, $kW8qW.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $c6e1e07b29e6f9c6$export$c77b6d30da5276a1 = true;

});
parcelRegister("kW8qW", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $f3dfc429fc74e4fb$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f3dfc429fc74e4fb$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f3dfc429fc74e4fb$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f3dfc429fc74e4fb$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f3dfc429fc74e4fb$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f3dfc429fc74e4fb$export$85c928794f8d04d4);
$parcel$export(module.exports, "ContentMatch", () => $f3dfc429fc74e4fb$export$364ed450558d7ec4);
$parcel$export(module.exports, "NodeType", () => $f3dfc429fc74e4fb$export$f06e977173f1857c);
$parcel$export(module.exports, "MarkType", () => $f3dfc429fc74e4fb$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f3dfc429fc74e4fb$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f3dfc429fc74e4fb$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f3dfc429fc74e4fb$export$3476b78f8f5a8b72);

var $2AA9h = parcelRequire("2AA9h");
function $f3dfc429fc74e4fb$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f3dfc429fc74e4fb$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f3dfc429fc74e4fb$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f3dfc429fc74e4fb$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f3dfc429fc74e4fb$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f3dfc429fc74e4fb$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f3dfc429fc74e4fb$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f3dfc429fc74e4fb$var$retIndex(0, pos);
        if (pos == this.size) return $f3dfc429fc74e4fb$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f3dfc429fc74e4fb$var$retIndex(i + 1, end);
                return $f3dfc429fc74e4fb$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f3dfc429fc74e4fb$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f3dfc429fc74e4fb$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty = new $f3dfc429fc74e4fb$export$ffb0004e005737fa([], 0);
const $f3dfc429fc74e4fb$var$found = {
    index: 0,
    offset: 0
};
function $f3dfc429fc74e4fb$var$retIndex(index, offset) {
    $f3dfc429fc74e4fb$var$found.index = index;
    $f3dfc429fc74e4fb$var$found.offset = offset;
    return $f3dfc429fc74e4fb$var$found;
}
function $f3dfc429fc74e4fb$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f3dfc429fc74e4fb$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f3dfc429fc74e4fb$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f3dfc429fc74e4fb$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f3dfc429fc74e4fb$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f3dfc429fc74e4fb$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f3dfc429fc74e4fb$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f3dfc429fc74e4fb$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e($f3dfc429fc74e4fb$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e($f3dfc429fc74e4fb$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e.empty = new $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e($f3dfc429fc74e4fb$export$ffb0004e005737fa.empty, 0, 0);
function $f3dfc429fc74e4fb$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f3dfc429fc74e4fb$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f3dfc429fc74e4fb$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f3dfc429fc74e4fb$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f3dfc429fc74e4fb$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f3dfc429fc74e4fb$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f3dfc429fc74e4fb$export$6de0e778727af3f2("Inconsistent open depths");
    return $f3dfc429fc74e4fb$var$replaceOuter($from, $to, slice, 0);
}
function $f3dfc429fc74e4fb$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f3dfc429fc74e4fb$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f3dfc429fc74e4fb$var$close(node, $f3dfc429fc74e4fb$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f3dfc429fc74e4fb$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f3dfc429fc74e4fb$var$prepareSliceForReplace(slice, $from);
        return $f3dfc429fc74e4fb$var$close(node, $f3dfc429fc74e4fb$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f3dfc429fc74e4fb$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f3dfc429fc74e4fb$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f3dfc429fc74e4fb$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f3dfc429fc74e4fb$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f3dfc429fc74e4fb$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f3dfc429fc74e4fb$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f3dfc429fc74e4fb$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f3dfc429fc74e4fb$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f3dfc429fc74e4fb$var$addNode($end.nodeBefore, target);
}
function $f3dfc429fc74e4fb$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f3dfc429fc74e4fb$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f3dfc429fc74e4fb$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f3dfc429fc74e4fb$var$joinable($end, $to, depth + 1);
    let content = [];
    $f3dfc429fc74e4fb$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f3dfc429fc74e4fb$var$checkJoin(openStart, openEnd);
        $f3dfc429fc74e4fb$var$addNode($f3dfc429fc74e4fb$var$close(openStart, $f3dfc429fc74e4fb$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f3dfc429fc74e4fb$var$addNode($f3dfc429fc74e4fb$var$close(openStart, $f3dfc429fc74e4fb$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f3dfc429fc74e4fb$var$addRange($start, $end, depth, content);
        if (openEnd) $f3dfc429fc74e4fb$var$addNode($f3dfc429fc74e4fb$var$close(openEnd, $f3dfc429fc74e4fb$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f3dfc429fc74e4fb$var$addRange($to, null, depth, content);
    return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(content);
}
function $f3dfc429fc74e4fb$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f3dfc429fc74e4fb$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f3dfc429fc74e4fb$var$joinable($from, $to, depth + 1);
        $f3dfc429fc74e4fb$var$addNode($f3dfc429fc74e4fb$var$close(type, $f3dfc429fc74e4fb$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f3dfc429fc74e4fb$var$addRange($to, null, depth, content);
    return new $f3dfc429fc74e4fb$export$ffb0004e005737fa(content);
}
function $f3dfc429fc74e4fb$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f3dfc429fc74e4fb$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f3dfc429fc74e4fb$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f3dfc429fc74e4fb$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f3dfc429fc74e4fb$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f3dfc429fc74e4fb$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f3dfc429fc74e4fb$var$resolveCache.set(doc, cache = new $f3dfc429fc74e4fb$var$ResolveCache);
        let result = cache.elts[cache.i] = $f3dfc429fc74e4fb$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f3dfc429fc74e4fb$var$resolveCacheSize;
        return result;
    }
}
class $f3dfc429fc74e4fb$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f3dfc429fc74e4fb$var$resolveCacheSize = 12, $f3dfc429fc74e4fb$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f3dfc429fc74e4fb$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f3dfc429fc74e4fb$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f3dfc429fc74e4fb$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f3dfc429fc74e4fb$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f3dfc429fc74e4fb$var$emptyAttrs) && $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f3dfc429fc74e4fb$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f3dfc429fc74e4fb$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f3dfc429fc74e4fb$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f3dfc429fc74e4fb$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f3dfc429fc74e4fb$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f3dfc429fc74e4fb$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f3dfc429fc74e4fb$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f3dfc429fc74e4fb$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f3dfc429fc74e4fb$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f3dfc429fc74e4fb$export$85c928794f8d04d4.prototype.text = undefined;
class $f3dfc429fc74e4fb$var$TextNode extends $f3dfc429fc74e4fb$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f3dfc429fc74e4fb$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f3dfc429fc74e4fb$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f3dfc429fc74e4fb$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f3dfc429fc74e4fb$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f3dfc429fc74e4fb$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f3dfc429fc74e4fb$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f3dfc429fc74e4fb$export$364ed450558d7ec4.empty;
        let expr = $f3dfc429fc74e4fb$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f3dfc429fc74e4fb$var$dfa($f3dfc429fc74e4fb$var$nfa(expr));
        $f3dfc429fc74e4fb$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f3dfc429fc74e4fb$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f3dfc429fc74e4fb$export$364ed450558d7ec4.empty = new $f3dfc429fc74e4fb$export$364ed450558d7ec4(true);
class $f3dfc429fc74e4fb$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f3dfc429fc74e4fb$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f3dfc429fc74e4fb$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f3dfc429fc74e4fb$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f3dfc429fc74e4fb$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f3dfc429fc74e4fb$var$parseExprSubscript(stream) {
    let expr = $f3dfc429fc74e4fb$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f3dfc429fc74e4fb$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f3dfc429fc74e4fb$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f3dfc429fc74e4fb$var$parseExprRange(stream, expr) {
    let min = $f3dfc429fc74e4fb$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f3dfc429fc74e4fb$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f3dfc429fc74e4fb$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f3dfc429fc74e4fb$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f3dfc429fc74e4fb$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f3dfc429fc74e4fb$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f3dfc429fc74e4fb$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f3dfc429fc74e4fb$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f3dfc429fc74e4fb$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f3dfc429fc74e4fb$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f3dfc429fc74e4fb$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f3dfc429fc74e4fb$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f3dfc429fc74e4fb$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f3dfc429fc74e4fb$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f3dfc429fc74e4fb$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f3dfc429fc74e4fb$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f3dfc429fc74e4fb$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f3dfc429fc74e4fb$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f3dfc429fc74e4fb$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f3dfc429fc74e4fb$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f3dfc429fc74e4fb$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f3dfc429fc74e4fb$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f3dfc429fc74e4fb$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f3dfc429fc74e4fb$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f3dfc429fc74e4fb$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f3dfc429fc74e4fb$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f3dfc429fc74e4fb$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f3dfc429fc74e4fb$export$ffb0004e005737fa.from(content), $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f3dfc429fc74e4fb$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f3dfc429fc74e4fb$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f3dfc429fc74e4fb$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f3dfc429fc74e4fb$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f3dfc429fc74e4fb$export$85c928794f8d04d4(this, attrs, content.append(after), $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f3dfc429fc74e4fb$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f3dfc429fc74e4fb$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f3dfc429fc74e4fb$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f3dfc429fc74e4fb$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f3dfc429fc74e4fb$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f3dfc429fc74e4fb$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f3dfc429fc74e4fb$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f3dfc429fc74e4fb$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f3dfc429fc74e4fb$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f3dfc429fc74e4fb$export$c9d15bcfc6d42044(this, $f3dfc429fc74e4fb$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f3dfc429fc74e4fb$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f3dfc429fc74e4fb$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f3dfc429fc74e4fb$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $2AA9h.default).from(spec.nodes), instanceSpec.marks = (0, $2AA9h.default).from(spec.marks || {}), this.nodes = $f3dfc429fc74e4fb$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f3dfc429fc74e4fb$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f3dfc429fc74e4fb$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f3dfc429fc74e4fb$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f3dfc429fc74e4fb$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f3dfc429fc74e4fb$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f3dfc429fc74e4fb$var$TextNode(type, type.defaultAttrs, text, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f3dfc429fc74e4fb$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f3dfc429fc74e4fb$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f3dfc429fc74e4fb$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f3dfc429fc74e4fb$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f3dfc429fc74e4fb$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f3dfc429fc74e4fb$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f3dfc429fc74e4fb$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f3dfc429fc74e4fb$var$ParseContext(this, options, false);
        context.addAll(dom, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f3dfc429fc74e4fb$var$ParseContext(this, options, true);
        context.addAll(dom, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f3dfc429fc74e4fb$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f3dfc429fc74e4fb$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f3dfc429fc74e4fb$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f3dfc429fc74e4fb$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f3dfc429fc74e4fb$export$1059c6e7d2ce5669(schema, $f3dfc429fc74e4fb$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f3dfc429fc74e4fb$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f3dfc429fc74e4fb$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f3dfc429fc74e4fb$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS = 1, $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS_FULL = 2, $f3dfc429fc74e4fb$var$OPT_OPEN_LEFT = 4;
function $f3dfc429fc74e4fb$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS | $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS_FULL : base & ~$f3dfc429fc74e4fb$var$OPT_OPEN_LEFT;
}
class $f3dfc429fc74e4fb$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f3dfc429fc74e4fb$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f3dfc429fc74e4fb$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f3dfc429fc74e4fb$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f3dfc429fc74e4fb$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f3dfc429fc74e4fb$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f3dfc429fc74e4fb$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f3dfc429fc74e4fb$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f3dfc429fc74e4fb$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f3dfc429fc74e4fb$var$NodeContext(topNode.type, topNode.attrs, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f3dfc429fc74e4fb$var$NodeContext(null, null, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f3dfc429fc74e4fb$var$NodeContext(parser.schema.topNodeType, null, $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f3dfc429fc74e4fb$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f3dfc429fc74e4fb$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f3dfc429fc74e4fb$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f3dfc429fc74e4fb$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f3dfc429fc74e4fb$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f3dfc429fc74e4fb$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f3dfc429fc74e4fb$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f3dfc429fc74e4fb$var$OPT_OPEN_LEFT;
        let applyMarks = $f3dfc429fc74e4fb$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f3dfc429fc74e4fb$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f3dfc429fc74e4fb$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f3dfc429fc74e4fb$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f3dfc429fc74e4fb$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f3dfc429fc74e4fb$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f3dfc429fc74e4fb$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f3dfc429fc74e4fb$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f3dfc429fc74e4fb$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f3dfc429fc74e4fb$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f3dfc429fc74e4fb$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f3dfc429fc74e4fb$var$renderSpec($f3dfc429fc74e4fb$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f3dfc429fc74e4fb$var$renderSpec($f3dfc429fc74e4fb$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f3dfc429fc74e4fb$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f3dfc429fc74e4fb$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f3dfc429fc74e4fb$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f3dfc429fc74e4fb$var$gatherToDOM(schema.marks);
    }
}
function $f3dfc429fc74e4fb$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f3dfc429fc74e4fb$var$doc(options) {
    return options.document || window.document;
}
const $f3dfc429fc74e4fb$var$suspiciousAttributeCache = new WeakMap();
function $f3dfc429fc74e4fb$var$suspiciousAttributes(attrs) {
    let value = $f3dfc429fc74e4fb$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f3dfc429fc74e4fb$var$suspiciousAttributeCache.set(attrs, value = $f3dfc429fc74e4fb$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f3dfc429fc74e4fb$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f3dfc429fc74e4fb$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f3dfc429fc74e4fb$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f3dfc429fc74e4fb$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("2AA9h", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e2afbf4256b2c1f$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $1e2afbf4256b2c1f$var$OrderedMap(content) {
    this.content = content;
}
$1e2afbf4256b2c1f$var$OrderedMap.prototype = {
    constructor: $1e2afbf4256b2c1f$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $1e2afbf4256b2c1f$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $1e2afbf4256b2c1f$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $1e2afbf4256b2c1f$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $1e2afbf4256b2c1f$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $1e2afbf4256b2c1f$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $1e2afbf4256b2c1f$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $1e2afbf4256b2c1f$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $1e2afbf4256b2c1f$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $1e2afbf4256b2c1f$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $1e2afbf4256b2c1f$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$1e2afbf4256b2c1f$var$OrderedMap.from = function(value) {
    if (value instanceof $1e2afbf4256b2c1f$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $1e2afbf4256b2c1f$var$OrderedMap(content);
};
var $1e2afbf4256b2c1f$export$2e2bcd8739ae039 = $1e2afbf4256b2c1f$var$OrderedMap;

});


parcelRegister("14aQx", function(module, exports) {
$parcel$export(module.exports, "addItems", () => $c6e5d9671d379eb0$export$efa5595d3b524179);
function $c6e5d9671d379eb0$export$efa5595d3b524179(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}

});

parcelRegister("4KeXh", function(module, exports) {
$parcel$export(module.exports, "markGroupDeclarations", () => $18dfd4465203a7e8$export$78b27f3e8d09085f);
$parcel$export(module.exports, "markGroupDeclarationsNames", () => $18dfd4465203a7e8$export$ee0d2ba599b1121f);

var $bcSjM = parcelRequire("bcSjM");
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
function $18dfd4465203a7e8$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $18dfd4465203a7e8$export$78b27f3e8d09085f = [
    $18dfd4465203a7e8$var$groupDeclaration((0, $bcSjM.COLOR)),
    $18dfd4465203a7e8$var$groupDeclaration((0, $bcSjM.FONT_STYLE)),
    $18dfd4465203a7e8$var$groupDeclaration((0, $bcSjM.SEARCH_QUERY)),
    $18dfd4465203a7e8$var$groupDeclaration((0, $bcSjM.LINK))
];
const $18dfd4465203a7e8$export$ee0d2ba599b1121f = $18dfd4465203a7e8$export$78b27f3e8d09085f.map((groupMark)=>groupMark.name);

});
parcelRegister("bcSjM", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", () => $e597bcecef3a2e88$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $e597bcecef3a2e88$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $e597bcecef3a2e88$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $e597bcecef3a2e88$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $e597bcecef3a2e88$export$4498a6080fed604c = 'fontStyle';
const $e597bcecef3a2e88$export$f8e8a5f34f6ea725 = 'searchQuery';
const $e597bcecef3a2e88$export$b395009ca7f092c7 = 'link';
const $e597bcecef3a2e88$export$9b982809044276a6 = 'color';
const $e597bcecef3a2e88$export$470d0905851e47a1 = 'alignment';
const $e597bcecef3a2e88$export$bacb7f4b06a06b22 = 'indentation';

});


parcelRegister("aklv9", function(module, exports) {
$parcel$export(module.exports, "marksInOrder", () => $649a180f0593571f$export$2a20daddecce6807);

var $4KeXh = parcelRequire("4KeXh");

var $2HNFa = parcelRequire("2HNFa");
var $9IULF = parcelRequire("9IULF");
var $dVvP0 = parcelRequire("dVvP0");
var $chTBj = parcelRequire("chTBj");
var $6BPNt = parcelRequire("6BPNt");
var $j2Bxs = parcelRequire("j2Bxs");
var $1M5qt = parcelRequire("1M5qt");
var $j5dhp = parcelRequire("j5dhp");
var $hUZiY = parcelRequire("hUZiY");
var $lCTYs = parcelRequire("lCTYs");
var $hxwpr = parcelRequire("hxwpr");
var $lRfQ8 = parcelRequire("lRfQ8");
var $12hT9 = parcelRequire("12hT9");
var $gkynH = parcelRequire("gkynH");
var $tNlcR = parcelRequire("tNlcR");
var $2ltAu = parcelRequire("2ltAu");
var $3e3xK = parcelRequire("3e3xK");
var $5pFl5 = parcelRequire("5pFl5");
var $1JJe1 = parcelRequire("1JJe1");
var $2hJSm = parcelRequire("2hJSm");
var $d1YmP = parcelRequire("d1YmP");
const $649a180f0593571f$export$2a20daddecce6807 = [
    {
        name: 'link',
        spec: (0, $12hT9.link)
    },
    {
        name: 'em',
        spec: (0, $hUZiY.em)
    },
    {
        name: 'strong',
        spec: (0, $tNlcR.strong)
    },
    {
        name: 'textColor',
        spec: (0, $3e3xK.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $dVvP0.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $gkynH.strike)
    },
    {
        name: 'subsup',
        spec: (0, $2ltAu.subsup)
    },
    {
        name: 'underline',
        spec: (0, $1JJe1.underline)
    },
    {
        name: 'code',
        spec: (0, $j2Bxs.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $5pFl5.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $2HNFa.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $9IULF.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $1M5qt.confluenceInlineComment)
    },
    ...(0, $4KeXh.markGroupDeclarations),
    {
        name: 'fontSize',
        spec: (0, $lCTYs.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $6BPNt.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $j5dhp.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $hxwpr.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $lRfQ8.indentation)
    },
    {
        name: 'border',
        spec: (0, $chTBj.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $2hJSm.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $d1YmP.unsupportedNodeAttribute)
    }
];

});
parcelRegister("2HNFa", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $aecff2500d767944$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $aecff2500d767944$export$8e53000a4ec837);

var $tw27l = parcelRequire("tw27l");
const $aecff2500d767944$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $aecff2500d767944$export$8e53000a4ec837 = (0, $tw27l.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});

parcelRegister("dVvP0", function(module, exports) {
$parcel$export(module.exports, "backgroundColorPalette", () => $74e2e7800da6628b$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColorPaletteNew", () => $74e2e7800da6628b$export$5e11ef3de07e2b1);
$parcel$export(module.exports, "backgroundColor", () => $74e2e7800da6628b$export$8c5a050822fd698c);

var $3y2s4 = parcelRequire("3y2s4");

var $4zjoa = parcelRequire("4zjoa");

var $tw27l = parcelRequire("tw27l");

var $2MYHA = parcelRequire("2MYHA");

var $8bHyz = parcelRequire("8bHyz");

var $dAiT7 = parcelRequire("dAiT7");

var $fgUa5 = parcelRequire("fgUa5");

var $3e3xK = parcelRequire("3e3xK");
const $74e2e7800da6628b$var$colorArrayPalette = [
    [
        (0, $2MYHA.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $2MYHA.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $2MYHA.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $2MYHA.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $2MYHA.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $2MYHA.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $2MYHA.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $74e2e7800da6628b$var$colorArrayPaletteNew = [
    [
        (0, $2MYHA.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $2MYHA.B75),
        'Blue'
    ],
    // token: color.background.accent.blue.subtler
    [
        (0, $2MYHA.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $2MYHA.G75),
        'Green'
    ],
    // token: color.background.accent.green.subtler
    [
        (0, $2MYHA.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $2MYHA.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $2MYHA.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $2MYHA.R200),
        'Red'
    ],
    // token: color.background.accent.red.subtler
    [
        (0, $2MYHA.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $2MYHA.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $74e2e7800da6628b$export$14ec3f21a268e497 = new Map();
$74e2e7800da6628b$var$colorArrayPalette.forEach(([color, label])=>$74e2e7800da6628b$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $74e2e7800da6628b$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/iu;
const $74e2e7800da6628b$export$5e11ef3de07e2b1 = new Map();
$74e2e7800da6628b$var$colorArrayPaletteNew.forEach(([color, label])=>$74e2e7800da6628b$export$5e11ef3de07e2b1.set(color.toLowerCase(), label));
const $74e2e7800da6628b$var$isSupportedBackgroundColor = (hexColor)=>{
    if ($74e2e7800da6628b$export$14ec3f21a268e497.has(hexColor)) return true;
    return (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $74e2e7800da6628b$export$5e11ef3de07e2b1.has(hexColor);
};
const $74e2e7800da6628b$var$getBackgroundColor = (value)=>{
    let hexColor;
    if (value.match($74e2e7800da6628b$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $fgUa5.rgbToHex)(value);
    else if (value[0] === '#') hexColor = value.toLowerCase();
    // else handle other colour formats
    return hexColor && $74e2e7800da6628b$var$isSupportedBackgroundColor(hexColor) ? {
        color: hexColor
    } : false;
};
const $74e2e7800da6628b$export$8c5a050822fd698c = (0, $tw27l.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                if ((0, $3y2s4.isExperimentEnabled)('platform_editor_fix_table_cell_background')) return false;
                return $74e2e7800da6628b$var$getBackgroundColor(maybeValue);
            }
        },
        {
            // the table cell and background color palettes overlap on Blue and Green, so
            // we need to exclude table cells to avoid parsing table cell background as background color
            tag: '[style]:not(td):not(th)',
            consuming: false,
            priority: 60,
            getAttrs: (maybeElement)=>{
                if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_fix_table_cell_background') || !(maybeElement instanceof HTMLElement)) return false;
                return $74e2e7800da6628b$var$getBackgroundColor(maybeElement.style.backgroundColor);
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $74e2e7800da6628b$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dAiT7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $3e3xK.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $8bHyz.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("4zjoa", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $b33e8d2d5d920ce0$export$63eebf86443a0a61);

var $lfAfy = parcelRequire("lfAfy");
function $b33e8d2d5d920ce0$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $lfAfy.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("2MYHA", function(module, exports) {
$parcel$export(module.exports, "R50", () => $49480a04c044d8a9$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $49480a04c044d8a9$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $49480a04c044d8a9$export$be802dd0d8b57f35);
$parcel$export(module.exports, "RedBold", () => $49480a04c044d8a9$export$8ce25cbf2e1e4328);
$parcel$export(module.exports, "R200", () => $49480a04c044d8a9$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $49480a04c044d8a9$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $49480a04c044d8a9$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $49480a04c044d8a9$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $49480a04c044d8a9$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $49480a04c044d8a9$export$5aae31392d72caaa);
$parcel$export(module.exports, "YellowBold", () => $49480a04c044d8a9$export$b9aaaa578bb08b28);
$parcel$export(module.exports, "Yellow200", () => $49480a04c044d8a9$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $49480a04c044d8a9$export$59619663aa6500fb);
$parcel$export(module.exports, "Y600", () => $49480a04c044d8a9$export$8d067e56aec921ba);
$parcel$export(module.exports, "Y800", () => $49480a04c044d8a9$export$880b9499608823af);
$parcel$export(module.exports, "G50", () => $49480a04c044d8a9$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $49480a04c044d8a9$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $49480a04c044d8a9$export$747d86715d4175de);
$parcel$export(module.exports, "GreenBold", () => $49480a04c044d8a9$export$4ba6949317382ac4);
$parcel$export(module.exports, "G300", () => $49480a04c044d8a9$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $49480a04c044d8a9$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $49480a04c044d8a9$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $49480a04c044d8a9$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $49480a04c044d8a9$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "BlueBold", () => $49480a04c044d8a9$export$7489d9dce51bb172);
$parcel$export(module.exports, "B400", () => $49480a04c044d8a9$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $49480a04c044d8a9$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L50", () => $49480a04c044d8a9$export$f51762073d2bb381);
$parcel$export(module.exports, "L200", () => $49480a04c044d8a9$export$f72948ef771f6f15);
$parcel$export(module.exports, "L400", () => $49480a04c044d8a9$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L600", () => $49480a04c044d8a9$export$b118f20869cce368);
$parcel$export(module.exports, "L800", () => $49480a04c044d8a9$export$4d2dfdfde6a26b06);
$parcel$export(module.exports, "N0", () => $49480a04c044d8a9$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $49480a04c044d8a9$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $49480a04c044d8a9$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $49480a04c044d8a9$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "GrayBold", () => $49480a04c044d8a9$export$a85cd17eb3a74576);
$parcel$export(module.exports, "N80", () => $49480a04c044d8a9$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $49480a04c044d8a9$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $49480a04c044d8a9$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $49480a04c044d8a9$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $49480a04c044d8a9$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $49480a04c044d8a9$export$f78789c8b01753cd);
$parcel$export(module.exports, "M50", () => $49480a04c044d8a9$export$dce26b47982a2d83);
$parcel$export(module.exports, "M200", () => $49480a04c044d8a9$export$a19f0c33186f7767);
$parcel$export(module.exports, "M400", () => $49480a04c044d8a9$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M600", () => $49480a04c044d8a9$export$3bff0a0c68537008);
$parcel$export(module.exports, "M800", () => $49480a04c044d8a9$export$aedcf6658caf5ad6);
$parcel$export(module.exports, "O200", () => $49480a04c044d8a9$export$51716a84e62e022c);
$parcel$export(module.exports, "Orange50", () => $49480a04c044d8a9$export$8692a80ca6403e1e);
$parcel$export(module.exports, "Orange200", () => $49480a04c044d8a9$export$a0fa9fa6bfbb29d1);
$parcel$export(module.exports, "Orange400", () => $49480a04c044d8a9$export$e58d39c2a9e7b70e);
$parcel$export(module.exports, "O600", () => $49480a04c044d8a9$export$65becf92d294645b);
$parcel$export(module.exports, "O800", () => $49480a04c044d8a9$export$d50a5202329f668e);
$parcel$export(module.exports, "P50", () => $49480a04c044d8a9$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $49480a04c044d8a9$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $49480a04c044d8a9$export$6011520a64d9a187);
$parcel$export(module.exports, "PurpleBold", () => $49480a04c044d8a9$export$33050b411a4844fe);
$parcel$export(module.exports, "P200", () => $49480a04c044d8a9$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $49480a04c044d8a9$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $49480a04c044d8a9$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $49480a04c044d8a9$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $49480a04c044d8a9$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $49480a04c044d8a9$export$776c9c497ef08533);
$parcel$export(module.exports, "TealBold", () => $49480a04c044d8a9$export$f4de2950886ae4c9);
$parcel$export(module.exports, "T200", () => $49480a04c044d8a9$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $49480a04c044d8a9$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $49480a04c044d8a9$export$6036577f95c3877e);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * We're avoding importing these colors from @atlaskit/theme since we
 * do not want to have react as a dependency of this package.
 * TODO: Refactor this once tokenization by Core team is ready
 * https://product-fabric.atlassian.net/browse/CS-908
 */ 





const $49480a04c044d8a9$export$4b84fd0e2c617bd = '#FFEBE6';
const $49480a04c044d8a9$export$b34b069eff244586 = '#FFBDAD';
const $49480a04c044d8a9$export$be802dd0d8b57f35 = '#FF8F73';
const $49480a04c044d8a9$export$8ce25cbf2e1e4328 = '#FFB8B2';
const $49480a04c044d8a9$export$60847d42f9da92a6 = '#FFD5D2';
const $49480a04c044d8a9$export$4a7404f376229999 = '#FF5630';
const $49480a04c044d8a9$export$2010d0fb4295b346 = '#DE350B';
const $49480a04c044d8a9$export$2837b5a1a71d5c02 = '#BF2600';
const $49480a04c044d8a9$export$8d9596b529bbb9cf = '#FFFAE6';
const $49480a04c044d8a9$export$41060a744ab0b7ae = '#FFF0B3';
const $49480a04c044d8a9$export$5aae31392d72caaa = '#FFC400';
const $49480a04c044d8a9$export$b9aaaa578bb08b28 = '#EFDD4E';
const $49480a04c044d8a9$export$fc857b6f8771648a = '#F8E6A0';
const $49480a04c044d8a9$export$59619663aa6500fb = '#FF991F';
const $49480a04c044d8a9$export$874739ea9e379ab6 = '#FF8B00';
const $49480a04c044d8a9$export$8d067e56aec921ba = '#B38600';
const $49480a04c044d8a9$export$880b9499608823af = '#7F5F01';
const $49480a04c044d8a9$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $49480a04c044d8a9$export$69a3bf21b9686c2b = '#ABF5D1';
const $49480a04c044d8a9$export$747d86715d4175de = '#57D9A3';
const $49480a04c044d8a9$export$4ba6949317382ac4 = '#97EDC9';
const $49480a04c044d8a9$export$940e1f69e873f202 = '#36B37E';
const $49480a04c044d8a9$export$a49394138f7b8e85 = '#00875A';
const $49480a04c044d8a9$export$6fa04827ac68a4fb = '#006644';
const $49480a04c044d8a9$export$226de0355ed012f8 = '#DEEBFF';
const $49480a04c044d8a9$export$8c13c2ee36917869 = '#B3D4FF';
const $49480a04c044d8a9$export$ecfc1dff386a3e7a = '#4C9AFF';
const $49480a04c044d8a9$export$7489d9dce51bb172 = '#ADCBFB';
const $49480a04c044d8a9$export$b3de0ae08da2ce64 = '#0052CC';
const $49480a04c044d8a9$export$a6ee3d71bc067634 = '#0747A6';
const $49480a04c044d8a9$export$f51762073d2bb381 = '#EFFFD6';
const $49480a04c044d8a9$export$f72948ef771f6f15 = '#D3F1A7';
const $49480a04c044d8a9$export$4b0a7cabffffd4f5 = '#BDE97C';
const $49480a04c044d8a9$export$b118f20869cce368 = '#6A9A23';
const $49480a04c044d8a9$export$4d2dfdfde6a26b06 = '#4C6B1F';
const $49480a04c044d8a9$export$29a4f05edc054374 = '#FFFFFF';
const $49480a04c044d8a9$export$9fdfb749e33cdf97 = '#F4F5F7';
const $49480a04c044d8a9$export$3e51e8f1440314ba = '#EBECF0';
const $49480a04c044d8a9$export$1ce2d1575d444ceb = '#DFE1E6';
const $49480a04c044d8a9$export$8754fc7e6d8b3000 = '#C1C7D0';
const $49480a04c044d8a9$export$c2e91cbeada39b8b = '#B3BAC5';
const $49480a04c044d8a9$export$a85cd17eb3a74576 = '#B7B9BE';
const $49480a04c044d8a9$export$eaa8c8a70ac22806 = '#97A0AF';
const $49480a04c044d8a9$export$7c87d337fb91a97d = '#8993A4';
const $49480a04c044d8a9$export$f563ee71e9ee74cd = '#6B778C';
const $49480a04c044d8a9$export$e2ef2124cf4024b1 = '#5E6C84';
const $49480a04c044d8a9$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $49480a04c044d8a9$export$13609db0e6812ab8 = '#091E4224';
const $49480a04c044d8a9$export$c39c0fe0f26207ae = '#42526E';
const $49480a04c044d8a9$export$7090862dc3038a9f = '#758195';
const $49480a04c044d8a9$export$7d61b15e0da132af = '#172B4D';
const $49480a04c044d8a9$export$f78789c8b01753cd = '#172B4D';
const $49480a04c044d8a9$export$dce26b47982a2d83 = '#FFECF8';
const $49480a04c044d8a9$export$a19f0c33186f7767 = '#FDD0EC';
const $49480a04c044d8a9$export$a1d4686c17e1cdef = '#FCB6E1';
const $49480a04c044d8a9$export$3bff0a0c68537008 = '#CD519D';
const $49480a04c044d8a9$export$aedcf6658caf5ad6 = '#943D73';
const $49480a04c044d8a9$export$51716a84e62e022c = '#FEDEC8';
const $49480a04c044d8a9$export$8692a80ca6403e1e = '#FFF5DB';
const $49480a04c044d8a9$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
const $49480a04c044d8a9$export$e58d39c2a9e7b70e = '#FBD779';
const $49480a04c044d8a9$export$65becf92d294645b = '#E06C00';
const $49480a04c044d8a9$export$d50a5202329f668e = '#9E4C00';
const $49480a04c044d8a9$export$363e4475840015bb = '#EAE6FF';
const $49480a04c044d8a9$export$4b0a4417ed59760f = '#C0B6F2';
const $49480a04c044d8a9$export$6011520a64d9a187 = '#998DD9';
const $49480a04c044d8a9$export$33050b411a4844fe = '#E3BDFA';
const $49480a04c044d8a9$export$a7175d4e9206bc80 = '#DFD8FD';
const $49480a04c044d8a9$export$b48405b95304b5a1 = '#6554C0';
const $49480a04c044d8a9$export$c71e4279dd54a18d = '#5243AA';
const $49480a04c044d8a9$export$147899de772240ec = '#403294';
const $49480a04c044d8a9$export$2cf711fe14c66f06 = '#E6FCFF';
const $49480a04c044d8a9$export$7a8f4d33f6f9772c = '#B3F5FF';
const $49480a04c044d8a9$export$776c9c497ef08533 = '#79E2F2';
const $49480a04c044d8a9$export$f4de2950886ae4c9 = '#B1E4F7';
const $49480a04c044d8a9$export$69cb3ca10c1e330e = '#C6EDFB';
const $49480a04c044d8a9$export$9dc1ef0f3f48059b = '#00B8D9';
const $49480a04c044d8a9$export$6036577f95c3877e = '#008DA6';

});

parcelRegister("8bHyz", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $62c1ae27f4b23bd8$export$a5065c3b8aacaf99);

var $fj8Ui = parcelRequire("fj8Ui");

var $4wpAv = parcelRequire("4wpAv");

var $kWgA9 = parcelRequire("kWgA9");
const $62c1ae27f4b23bd8$var$getLightness = (color)=>{
    const rgb = (0, $4wpAv.rgbFromHex)(color);
    if (rgb === null) return 0;
    const lch = (0, $kWgA9.rgbToLch)(rgb);
    return lch.l;
};
const $62c1ae27f4b23bd8$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $62c1ae27f4b23bd8$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return (0, $fj8Ui.clampLightness)(currentBackgroundColor, newLightness).toUpperCase();
};

});
parcelRegister("fj8Ui", function(module, exports) {
$parcel$export(module.exports, "clampLightness", () => $be8f5f86e4a46f31$export$313b8a8fcb34c3b8);

var $4wpAv = parcelRequire("4wpAv");

var $kWgA9 = parcelRequire("kWgA9");
const $be8f5f86e4a46f31$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $be8f5f86e4a46f31$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $be8f5f86e4a46f31$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $be8f5f86e4a46f31$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $be8f5f86e4a46f31$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $be8f5f86e4a46f31$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $be8f5f86e4a46f31$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $be8f5f86e4a46f31$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $be8f5f86e4a46f31$var$lchToRgb = (lch)=>$be8f5f86e4a46f31$var$xyzToRgb($be8f5f86e4a46f31$var$labToXyz($be8f5f86e4a46f31$var$lchToLab(lch)));
const $be8f5f86e4a46f31$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = (0, $4wpAv.rgbFromHex)(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = (0, $kWgA9.rgbToLch)(rgb);
    lch.l = $be8f5f86e4a46f31$var$clamp(newPercent, 0, 100);
    return $be8f5f86e4a46f31$var$rgbToHex($be8f5f86e4a46f31$var$lchToRgb(lch));
};

});
parcelRegister("4wpAv", function(module, exports) {
$parcel$export(module.exports, "rgbFromHex", () => $0d423c3e36aea2d4$export$d604f368c5212474);

var $1SFVg = parcelRequire("1SFVg");

var $gJdR7 = parcelRequire("gJdR7");
const $0d423c3e36aea2d4$export$d604f368c5212474 = (input)=>{
    const fullHex = (0, $1SFVg.expandShorthandHex)(input);
    const result = (0, $gJdR7.FULL_HEX_REGEX).exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};

});
parcelRegister("1SFVg", function(module, exports) {
$parcel$export(module.exports, "expandShorthandHex", () => $682025aa7b343a0d$export$f67f480c2f5dd62d);
const $682025aa7b343a0d$var$SHORTHAND_HEX_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/iu;
const $682025aa7b343a0d$export$f67f480c2f5dd62d = (input)=>input.replace($682025aa7b343a0d$var$SHORTHAND_HEX_REGEX, (_m, r, g, b)=>r + r + g + g + b + b);

});

parcelRegister("gJdR7", function(module, exports) {
$parcel$export(module.exports, "FULL_HEX_REGEX", () => $196724933cd60228$export$c3a7521d0ffa04dc);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 







const $196724933cd60228$export$c3a7521d0ffa04dc = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu;

});


parcelRegister("kWgA9", function(module, exports) {
$parcel$export(module.exports, "rgbToLch", () => $4d558bac9de929fc$export$60714bf90ef24e7b);

var $8SK97 = parcelRequire("8SK97");

var $7yCtd = parcelRequire("7yCtd");

var $3tPRY = parcelRequire("3tPRY");
const $4d558bac9de929fc$export$60714bf90ef24e7b = (rgb)=>(0, $8SK97.labToLch)((0, $3tPRY.xyzToLab)((0, $7yCtd.rgbToXyz)(rgb)));

});
parcelRegister("8SK97", function(module, exports) {
$parcel$export(module.exports, "labToLch", () => $67c29cb29915793e$export$21f398e7d277f911);
const $67c29cb29915793e$export$21f398e7d277f911 = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};

});

parcelRegister("7yCtd", function(module, exports) {
$parcel$export(module.exports, "rgbToXyz", () => $2174d278daace0fa$export$532d5190d94ac8d7);
const $2174d278daace0fa$export$532d5190d94ac8d7 = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};

});

parcelRegister("3tPRY", function(module, exports) {
$parcel$export(module.exports, "xyzToLab", () => $b86a4f273410c9ff$export$a7b197d2a22fcf09);
const $b86a4f273410c9ff$export$a7b197d2a22fcf09 = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });

});




parcelRegister("dAiT7", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $68aaf9a850cdf5cf$export$8b58ff1b36bb75e0);

var $dpwuL = parcelRequire("dpwuL");
function $68aaf9a850cdf5cf$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $dpwuL.textBackgroundColorPalette)[hexColor.toUpperCase()] : undefined;
}

});
parcelRegister("dpwuL", function(module, exports) {
$parcel$export(module.exports, "editorBorderPalette", () => $e0f9ed50e0d2d822$export$aa000893c5e2b9c2);
$parcel$export(module.exports, "editorTextPalette", () => $e0f9ed50e0d2d822$export$57fa5089caad992);
$parcel$export(module.exports, "textBackgroundColorPalette", () => $e0f9ed50e0d2d822$export$12a518ff137dd389);
$parcel$export(module.exports, "editorBackgroundPalette", () => $e0f9ed50e0d2d822$export$2462741d70e6a62f);

var $4zjoa = parcelRequire("4zjoa");
const $e0f9ed50e0d2d822$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
const $e0f9ed50e0d2d822$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)',
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? 'var(--ds-border-accent-yellow, #B38600)' : 'var(--ds-icon-accent-yellow, #B38600)';
    },
    /** yellow - strong */ '#7F5F01': 'var(--ds-text-accent-yellow, #7F5F01)'
};
const $e0f9ed50e0d2d822$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Red - light */ '#FFD5D2': 'var(--ds-background-accent-red-subtler, #FFD5D2)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
const $e0f9ed50e0d2d822$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    },
    /** lime - light */ '#EFFFD6': {
        getValue: ()=>'#EFFFD6',
        token: 'var(--ds-background-accent-lime-subtlest, #EFFFD6)'
    },
    /** lime - medium */ '#D3F1A7': {
        getValue: ()=>'#D3F1A7',
        token: 'var(--ds-background-accent-lime-subtler, #D3F1A7)'
    },
    /** lime - bold */ '#BDE97C': {
        getValue: ()=>'#BDE97C',
        token: 'var(--ds-background-accent-lime-subtler-hovered, #BDE97C)'
    },
    /** orange - light */ '#FFF5DB': {
        getValue: ()=>'#FFF5DB',
        token: 'var(--ds-background-accent-orange-subtlest, #FFF5DB)'
    },
    /** orange - medium */ '#FCE4A6': {
        getValue: ()=>'#FCE4A6',
        token: 'var(--ds-background-accent-orange-subtler, #FCE4A6)'
    },
    /** orange - bold */ '#FBD779': {
        getValue: ()=>'#FBD779',
        token: 'var(--ds-background-accent-orange-subtler-hovered, #FBD779)'
    },
    /** magenta - light */ '#FFECF8': {
        getValue: ()=>'#FFECF8',
        token: 'var(--ds-background-accent-magenta-subtlest, #FFECF8)'
    },
    /** magenta - medium */ '#FDD0EC': {
        getValue: ()=>'#FDD0EC',
        token: 'var(--ds-background-accent-magenta-subtler, #FDD0EC)'
    },
    /** magenta - bold */ '#FCB6E1': {
        getValue: ()=>'#FCB6E1',
        token: 'var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)'
    },
    // Bold row mappings using subtler.hovered tokens. These use new hex codes
    // so pre-existing documents keep their old subtle-token mappings above.
    /** blue - bold */ '#ADCBFB': {
        getValue: ()=>'#ADCBFB',
        token: 'var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)'
    },
    /** teal - bold */ '#B1E4F7': {
        getValue: ()=>'#B1E4F7',
        token: 'var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)'
    },
    /** green - bold */ '#97EDC9': {
        getValue: ()=>'#97EDC9',
        token: 'var(--ds-background-accent-green-subtler-hovered, #97EDC9)'
    },
    /** yellow - bold */ '#EFDD4E': {
        getValue: ()=>'#EFDD4E',
        token: 'var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)'
    },
    /** red - bold */ '#FFB8B2': {
        getValue: ()=>'#FFB8B2',
        token: 'var(--ds-background-accent-red-subtler-hovered, #FFB8B2)'
    },
    /** purple - bold */ '#E3BDFA': {
        getValue: ()=>'#E3BDFA',
        token: 'var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)'
    },
    /** gray - bold */ '#B7B9BE': {
        getValue: ()=>'#B7B9BE',
        token: 'var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)'
    }
};

});


parcelRegister("fgUa5", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $a5b3d653cf1bbbdc$export$34d09c4a771c46ef);
// eslint-disable-line import/no-namespace
function $a5b3d653cf1bbbdc$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}

});

parcelRegister("3e3xK", function(module, exports) {
$parcel$export(module.exports, "colorPalette", () => $005c8071863c0282$export$569885e57444f84a);
$parcel$export(module.exports, "colorPaletteNew", () => $005c8071863c0282$export$dee1d8a8cb3ab555);
$parcel$export(module.exports, "getGlobalTheme", () => $005c8071863c0282$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $005c8071863c0282$export$32f78bffcd82ff28);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $4zjoa = parcelRequire("4zjoa");

var $tw27l = parcelRequire("tw27l");

var $2MYHA = parcelRequire("2MYHA");

var $8bHyz = parcelRequire("8bHyz");

var $cVl17 = parcelRequire("cVl17");

var $fgUa5 = parcelRequire("fgUa5");
// used for extended palette in text color picker
const $005c8071863c0282$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $2MYHA.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $2MYHA.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $2MYHA.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $2MYHA.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $2MYHA.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $2MYHA.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $2MYHA.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $2MYHA.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $2MYHA.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $2MYHA.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $2MYHA.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $2MYHA.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $2MYHA.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $2MYHA.N0),
        'White'
    ],
    [
        (0, $2MYHA.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $2MYHA.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $2MYHA.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $2MYHA.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $2MYHA.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $2MYHA.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
const $005c8071863c0282$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $2MYHA.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $2MYHA.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $2MYHA.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $2MYHA.L800),
        'Dark lime'
    ],
    [
        (0, $2MYHA.Y800),
        'Dark yellow'
    ],
    [
        (0, $2MYHA.O800),
        'Dark orange'
    ],
    [
        (0, $2MYHA.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $2MYHA.M800),
        'Dark magenta'
    ],
    [
        (0, $2MYHA.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $2MYHA.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $2MYHA.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $2MYHA.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $2MYHA.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $2MYHA.L600),
        'Lime'
    ],
    [
        (0, $2MYHA.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $2MYHA.O600),
        'Orange'
    ],
    [
        (0, $2MYHA.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $2MYHA.M600),
        'Magenta'
    ],
    [
        (0, $2MYHA.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $2MYHA.N0),
        'White'
    ],
    [
        (0, $2MYHA.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $2MYHA.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $2MYHA.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $2MYHA.L200),
        'Light lime'
    ],
    [
        (0, $2MYHA.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $2MYHA.Orange200),
        'Light orange'
    ],
    [
        (0, $2MYHA.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $2MYHA.M200),
        'Light magenta'
    ],
    [
        (0, $2MYHA.P50),
        'Light purple'
    ] // Lavender secret
];
const $005c8071863c0282$export$569885e57444f84a = new Map();
const $005c8071863c0282$export$dee1d8a8cb3ab555 = new Map();
const $005c8071863c0282$export$81e5ed9e84fe2e28 = $005c8071863c0282$export$569885e57444f84a;
$005c8071863c0282$var$colorArrayPalette.forEach(([color, label])=>$005c8071863c0282$export$569885e57444f84a.set(color.toLowerCase(), label));
$005c8071863c0282$var$colorArrayPaletteNew.forEach(([color, label])=>$005c8071863c0282$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label));
const $005c8071863c0282$var$isSupportedTextColor = (hexColor)=>{
    if ($005c8071863c0282$export$569885e57444f84a.has(hexColor)) return true;
    return (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $005c8071863c0282$export$dee1d8a8cb3ab555.has(hexColor);
};
// these are for test only
let $005c8071863c0282$var$testGlobalTheme;
const $005c8071863c0282$export$fd7e0dd2b74807f7 = (theme)=>{
    $005c8071863c0282$var$testGlobalTheme = theme;
};
const $005c8071863c0282$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($005c8071863c0282$var$testGlobalTheme) return {
        colorMode: $005c8071863c0282$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $005c8071863c0282$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/iu;
const $005c8071863c0282$export$32f78bffcd82ff28 = (0, $tw27l.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($005c8071863c0282$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $fgUa5.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $005c8071863c0282$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $005c8071863c0282$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $cVl17.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($005c8071863c0282$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $8bHyz.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("cVl17", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $41b78a60f1b1d5d3$export$9c2f408d391feb93);

var $dpwuL = parcelRequire("dpwuL");
function $41b78a60f1b1d5d3$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return normalizedHexColor ? (0, $dpwuL.editorTextPalette)[normalizedHexColor] : undefined;
}

});



parcelRegister("chTBj", function(module, exports) {
$parcel$export(module.exports, "borderColorPalette", () => $8cebf72a48fe05e3$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $8cebf72a48fe05e3$export$1edee58a52776cd9);

var $tw27l = parcelRequire("tw27l");

var $2MYHA = parcelRequire("2MYHA");

var $Jj3dw = parcelRequire("Jj3dw");
const $8cebf72a48fe05e3$var$borderColorArrayPalette = [
    [
        (0, $2MYHA.N300A),
        'Subtle gray'
    ],
    [
        (0, $2MYHA.N600),
        'Gray'
    ],
    [
        (0, $2MYHA.N1000),
        'Bold gray'
    ]
];
const $8cebf72a48fe05e3$export$e4e044c989c86ca7 = new Map();
$8cebf72a48fe05e3$var$borderColorArrayPalette.forEach(([color, label])=>$8cebf72a48fe05e3$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $8cebf72a48fe05e3$export$1edee58a52776cd9 = (0, $tw27l.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $8cebf72a48fe05e3$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $Jj3dw.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});
parcelRegister("Jj3dw", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $b393d8d25949b7d7$export$bad3c41dd33cb4bc);

var $dpwuL = parcelRequire("dpwuL");
function $b393d8d25949b7d7$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $dpwuL.editorBorderPalette)[hexColor.toUpperCase()] : undefined;
}

});


parcelRegister("6BPNt", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $78dd5334b062837b$export$89015c65f1c75e3f);

var $tw27l = parcelRequire("tw27l");
const $78dd5334b062837b$var$allowedTypes = [
    'wide',
    'full-width'
];
const $78dd5334b062837b$export$89015c65f1c75e3f = (0, $tw27l.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $78dd5334b062837b$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("j2Bxs", function(module, exports) {
$parcel$export(module.exports, "code", () => $d4436d8352ffc704$export$6565f9f03506010b);

var $tw27l = parcelRequire("tw27l");
const $d4436d8352ffc704$export$6565f9f03506010b = (0, $tw27l.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("1M5qt", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $01812d5ac51966f5$export$f3b72f8fc4684ecd);

var $tw27l = parcelRequire("tw27l");
const $01812d5ac51966f5$export$f3b72f8fc4684ecd = (0, $tw27l.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("j5dhp", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $d82ce6c59a6bcdfb$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $d82ce6c59a6bcdfb$export$54fd2c36b5cc6731);

var $tw27l = parcelRequire("tw27l");

var $d1Bsh = parcelRequire("d1Bsh");
const $d82ce6c59a6bcdfb$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $d1Bsh.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $d82ce6c59a6bcdfb$export$3024f02c495408d6 = (0, $tw27l.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$d82ce6c59a6bcdfb$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $d82ce6c59a6bcdfb$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("d1Bsh", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $e48ce95dba54e0a0$export$c296e2d4365c37a5);
const $e48ce95dba54e0a0$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("hUZiY", function(module, exports) {
$parcel$export(module.exports, "em", () => $7ca1475d63638ea2$export$c63c6f932822f543);

var $tw27l = parcelRequire("tw27l");
const $7ca1475d63638ea2$var$emDOM = [
    'em'
];
const $7ca1475d63638ea2$export$c63c6f932822f543 = (0, $tw27l.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $7ca1475d63638ea2$var$emDOM;
    }
});

});

parcelRegister("lCTYs", function(module, exports) {
$parcel$export(module.exports, "fontSize", () => $ee597e261ae42755$export$85e3c3ca0c6fb93);

var $tw27l = parcelRequire("tw27l");
const $ee597e261ae42755$var$allowedSizes = [
    'small'
];
const $ee597e261ae42755$export$85e3c3ca0c6fb93 = (0, $tw27l.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $ee597e261ae42755$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});

});

parcelRegister("hxwpr", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $2f8db63c6d5c11e9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $2f8db63c6d5c11e9$export$54fd2c36b5cc6731);

var $tw27l = parcelRequire("tw27l");

var $d1Bsh = parcelRequire("d1Bsh");
const $2f8db63c6d5c11e9$var$parseFragment = (maybeValue)=>{
    if (!(0, $d1Bsh.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $2f8db63c6d5c11e9$export$f00aeb236b6f05af = (0, $tw27l.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$2f8db63c6d5c11e9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $2f8db63c6d5c11e9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("lRfQ8", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $070c5d72d1036b1b$export$480c699bd4ec0d86);

var $tw27l = parcelRequire("tw27l");
const $070c5d72d1036b1b$export$480c699bd4ec0d86 = (0, $tw27l.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("12hT9", function(module, exports) {
$parcel$export(module.exports, "link", () => $c3ac680f7c5ef74f$export$9c30223ca0a664fb);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $tw27l = parcelRequire("tw27l");

var $7nI18 = parcelRequire("7nI18");

var $1pAMy = parcelRequire("1pAMy");

const $c3ac680f7c5ef74f$export$9c30223ca0a664fb = (0, $tw27l.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: (0, $1pAMy.getLinkAttrs)('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: (0, $1pAMy.getLinkAttrs)('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $7nI18.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});

});
parcelRegister("1pAMy", function(module, exports) {
$parcel$export(module.exports, "getLinkAttrs", () => $6c7c57905ae89d7d$export$b5f67017585d1431);

var $3swDB = parcelRequire("3swDB");

var $7nI18 = parcelRequire("7nI18");

var $9Lnex = parcelRequire("9Lnex");
const $6c7c57905ae89d7d$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $7nI18.isSafeUrl)(href)) return false;
        if ((0, $3swDB.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $9Lnex.normalizeUrl)(href);
        return attrs;
    };

});
parcelRegister("3swDB", function(module, exports) {
$parcel$export(module.exports, "isRootRelative", () => $60b90b1a4d72cec4$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ /**
 * checks if root relative link
 */ function $60b90b1a4d72cec4$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});

parcelRegister("9Lnex", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $f1bf290ad5ea853b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $rd0To = parcelRequire("rd0To");
function $f1bf290ad5ea853b$export$6535eb414fa2c8b6(url) {
    const match = (0, $rd0To.getLinkMatch)(url);
    return match && match.url || '';
}

});
parcelRegister("rd0To", function(module, exports) {
$parcel$export(module.exports, "getLinkMatch", () => $4b06688bc3f21c23$export$ce9ae45aed3e4ec);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $270j3 = parcelRequire("270j3");

var $d7B5f = parcelRequire("d7B5f");
function $4b06688bc3f21c23$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = (0, $270j3.linkifyMatch)(str);
    if (!match.length) match = (0, $d7B5f.linkify).match(str);
    return match && match[0];
}

});
parcelRegister("270j3", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $b8117be3ef2d874e$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $d7B5f = parcelRequire("d7B5f");
const $b8117be3ef2d874e$export$6f7d7761b97f967 = (text)=>{
    if (!(0, $d7B5f.LINK_REGEXP).test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match((0, $d7B5f.LINK_REGEXP)) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search((0, $d7B5f.LINK_REGEXP));
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};

});
parcelRegister("d7B5f", function(module, exports) {
$parcel$export(module.exports, "linkify", () => $215864e73b126cda$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "LINK_REGEXP", () => $215864e73b126cda$export$746d02eae03c72e1);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $cAudd = parcelRequire("cAudd");

var $gdUUy = parcelRequire("gdUUy");





const $215864e73b126cda$export$8ccbde94d5c7f8e7 = new (0, $cAudd.default)();
const $215864e73b126cda$var$URI_WITHOUT_SPACES = /[^\s]+/u;
const $215864e73b126cda$var$URI_WITHOUT_SPACES_ANCHORED = /^[^\s]+/u;
const $215864e73b126cda$var$urlWithoutSpacesValidator = {
    validate: (text, pos)=>{
        const tail = text.slice(pos);
        const pattern = (0, $gdUUy.fg)('platform_bugfix_invalid_urls_parsing_in_editor') ? $215864e73b126cda$var$URI_WITHOUT_SPACES_ANCHORED : $215864e73b126cda$var$URI_WITHOUT_SPACES;
        const match = tail.match(pattern);
        return match ? match[0].length : 0;
    }
};
const $215864e73b126cda$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $215864e73b126cda$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $215864e73b126cda$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
$215864e73b126cda$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$215864e73b126cda$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
$215864e73b126cda$export$8ccbde94d5c7f8e7.add('tel:', $215864e73b126cda$var$urlWithoutSpacesValidator);
$215864e73b126cda$export$8ccbde94d5c7f8e7.add('file:', $215864e73b126cda$var$urlWithoutSpacesValidator);
$215864e73b126cda$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
$215864e73b126cda$var$tlds.push($215864e73b126cda$var$tlds2Char);
$215864e73b126cda$export$8ccbde94d5c7f8e7.tlds($215864e73b126cda$var$tlds, false);

});
parcelRegister("cAudd", function(module, exports) {
$parcel$export(module.exports, "default", () => $92a04854e1495cc3$export$2e2bcd8739ae039);

var $hXoqy = parcelRequire("hXoqy");
//
// Helpers
//
// Merge objects
//
function $92a04854e1495cc3$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $92a04854e1495cc3$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $92a04854e1495cc3$var$isString(obj) {
    return $92a04854e1495cc3$var$_class(obj) === '[object String]';
}
function $92a04854e1495cc3$var$isObject(obj) {
    return $92a04854e1495cc3$var$_class(obj) === '[object Object]';
}
function $92a04854e1495cc3$var$isRegExp(obj) {
    return $92a04854e1495cc3$var$_class(obj) === '[object RegExp]';
}
function $92a04854e1495cc3$var$isFunction(obj) {
    return $92a04854e1495cc3$var$_class(obj) === '[object Function]';
}
function $92a04854e1495cc3$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $92a04854e1495cc3$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $92a04854e1495cc3$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $92a04854e1495cc3$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $92a04854e1495cc3$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp(`^\\/\\/${self.re.src_auth}${self.re.src_host_port_strict}${self.re.src_path}`, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            `(?:localhost|(?:(?:${self.re.src_domain})\\.)+${self.re.src_domain_root})` + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp(`^${self.re.src_email_name}@${self.re.src_host_strict}`, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
const $92a04854e1495cc3$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $92a04854e1495cc3$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $92a04854e1495cc3$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $92a04854e1495cc3$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $92a04854e1495cc3$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $hXoqy.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($92a04854e1495cc3$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.email_fuzzy_global = RegExp(untpl(re.tpl_email_fuzzy), 'ig');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_fuzzy_global = RegExp(untpl(re.tpl_link_fuzzy), 'ig');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.link_no_ip_fuzzy_global = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'ig');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error(`(LinkifyIt) Invalid schema "${name}": ${val}`);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($92a04854e1495cc3$var$isObject(val)) {
            if ($92a04854e1495cc3$var$isRegExp(val.validate)) compiled.validate = $92a04854e1495cc3$var$createValidator(val.validate);
            else if ($92a04854e1495cc3$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($92a04854e1495cc3$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $92a04854e1495cc3$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($92a04854e1495cc3$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $92a04854e1495cc3$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($92a04854e1495cc3$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'i');
    self.re.schema_search = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'ig');
    self.re.schema_at_start = RegExp(`^${self.re.schema_search.source}`, 'i');
    self.re.pretest = RegExp(`(${self.re.schema_test.source})|(${self.re.host_fuzzy_test.source})|@`, 'i');
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $92a04854e1495cc3$var$Match(text, schema, index, lastIndex) {
    const raw = text.slice(index, lastIndex);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = schema.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = index;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = lastIndex;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = raw;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = raw;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = raw;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $92a04854e1495cc3$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $92a04854e1495cc3$var$LinkifyIt)) return new $92a04854e1495cc3$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($92a04854e1495cc3$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $92a04854e1495cc3$var$assign({}, $92a04854e1495cc3$var$defaultOptions, options);
    this.__schemas__ = $92a04854e1495cc3$var$assign({}, $92a04854e1495cc3$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $92a04854e1495cc3$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $92a04854e1495cc3$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $92a04854e1495cc3$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $92a04854e1495cc3$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.test = function test(text) {
    if (!text.length) return false;
    let m, re;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            if (this.testSchemaAt(text, m[2], re.lastIndex)) return true;
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) // guess schemaless links
    {
        if (text.search(this.re.host_fuzzy_test) >= 0) {
            if (text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) return true;
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) // guess schemaless emails
    {
        if (text.indexOf('@') >= 0) {
            // We can't skip this check, because this cases are possible:
            // 192.168.1.1@gmail.com, my.in@example.com
            if (text.match(this.re.email_fuzzy) !== null) return true;
        }
    }
    return false;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    const type_schemed = [];
    const type_fuzzy_link = [];
    const type_fuzzy_email = [];
    let m, len, re;
    function choose(a, b) {
        if (!a) return b;
        if (!b) return a;
        if (a.index !== b.index) return a.index < b.index ? a : b;
        return a.lastIndex >= b.lastIndex ? a : b;
    }
    if (!text.length) return null;
    // scan for links with schema
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) type_schemed.push({
                schema: m[2],
                index: m.index + m[1].length,
                lastIndex: m.index + m[0].length + len
            });
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        re = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_link.push({
            schema: '',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        re = this.re.email_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_email.push({
            schema: 'mailto:',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    const indexes = [
        0,
        0,
        0
    ];
    let lastIndex = 0;
    for(;;){
        const candidates = [
            type_schemed[indexes[0]],
            type_fuzzy_email[indexes[1]],
            type_fuzzy_link[indexes[2]]
        ];
        const candidate = choose(choose(candidates[0], candidates[1]), candidates[2]);
        if (!candidate) break;
        if (candidate === candidates[0]) indexes[0]++;
        else if (candidate === candidates[1]) indexes[1]++;
        else indexes[2]++;
        if (candidate.index < lastIndex) continue;
        const match = new $92a04854e1495cc3$var$Match(text, candidate.schema, candidate.index, candidate.lastIndex);
        this.__compiled__[match.schema].normalize(match, this);
        result.push(match);
        lastIndex = candidate.lastIndex;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    const match = new $92a04854e1495cc3$var$Match(text, m[2], m.index + m[1].length, m.index + m[0].length + len);
    this.__compiled__[match.schema].normalize(match, this);
    return match;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $92a04854e1495cc3$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $92a04854e1495cc3$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = `http://${match.url}`;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = `mailto:${match.url}`;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $92a04854e1495cc3$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $92a04854e1495cc3$export$2e2bcd8739ae039 = $92a04854e1495cc3$var$LinkifyIt;

});
parcelRegister("hXoqy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d12ae520bfd4ba1d$export$2e2bcd8739ae039);
parcelRequire("dlHPK");
var $gPoc7 = parcelRequire("gPoc7");
var $kf6M3 = parcelRequire("kf6M3");
var $6wirW = parcelRequire("6wirW");
var $1T1Lv = parcelRequire("1T1Lv");
function $d12ae520bfd4ba1d$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $gPoc7.default).source;
    re.src_Cc = (0, $kf6M3.default).source;
    re.src_Z = (0, $1T1Lv.default).source;
    re.src_P = (0, $6wirW.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = `(?:(?!${text_separators}|${re.src_ZPCc})${re.src_Any})`;
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    // Length is capped to exclude possible rescans till the end and avoid O(n^2)
    // DoS. No standard limit, just take something reasonable.
    re.src_auth = `(?:(?:(?!${re.src_ZCc}|[@/\\[\\]()]).){1,50}@)?`;
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = `(?=$|${text_separators}|${re.src_ZPCc})` + `(?!${opts['---'] ? '-(?!--)|' : '-|'}_|:\\d|\\.-|\\.(?!$|${re.src_ZPCc}))`;
    re.src_path = "(?:[/?#](?:" + `(?!${re.src_ZCc}|${text_separators}|[()[\\]{}.,"'?!\\-;]).|` + `\\[(?:(?!${re.src_ZCc}|\\]).)*\\]|` + `\\((?:(?!${re.src_ZCc}|[)]).)*\\)|` + `\\{(?:(?!${re.src_ZCc}|[}]).)*\\}|` + `\\"(?:(?!${re.src_ZCc}|["]).)+\\"|` + `\\'(?:(?!${re.src_ZCc}|[']).)+\\'|` + // allow `I'm_king` if no pair found
    `\\'(?=${re.src_pseudo_letter}|[-])|` + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + `\\.(?!${re.src_ZCc}|[.]|$)|` + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    `,(?!${re.src_ZCc}|$)|` + // allow `;` if not followed by space-like char
    `;(?!${re.src_ZCc}|$)|` + // allow `!!!` in paths, but not at the end
    `\\!+(?!${re.src_ZCc}|[!]|$)|` + `\\?(?!${re.src_ZCc}|[?]|$)` + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    // Max name length capped to 64 chars (RFC 5321). This also prevents O(n^2)
    // rescans to the end on inputs like `mailto:mailto:...`
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]{0,63}';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + `${re.src_pseudo_letter}{1,63}` + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + `(?:${re.src_pseudo_letter})` + '|' + `(?:${re.src_pseudo_letter}(?:-|${re.src_pseudo_letter}){0,61}${re.src_pseudo_letter})` + ')';
    re.src_host = '(?:' + // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
    `(?:(?:(?:${re.src_domain})\\.)*${re.src_domain})` + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))` + ')';
    re.tpl_host_no_ip_fuzzy = `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))`;
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:${re.src_ZPCc}|>|$))`;
    re.tpl_email_fuzzy = `(^|${text_separators}|"|\\(|${re.src_ZCc})` + `(${re.src_email_name}@${re.tpl_host_fuzzy_strict})`;
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_fuzzy_strict}${re.src_path})`;
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_no_ip_fuzzy_strict}${re.src_path})`;
    return re;
}

});
parcelRegister("dlHPK", function(module, exports) {
$parcel$export(module.exports, "Any", () => (parcelRequire("gPoc7")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("kf6M3")).default);
$parcel$export(module.exports, "Cf", () => (parcelRequire("3vLR3")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("6wirW")).default);
$parcel$export(module.exports, "S", () => (parcelRequire("1T7LE")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("1T1Lv")).default);

var $gPoc7 = parcelRequire("gPoc7");

var $kf6M3 = parcelRequire("kf6M3");

var $3vLR3 = parcelRequire("3vLR3");

var $6wirW = parcelRequire("6wirW");

var $1T7LE = parcelRequire("1T7LE");

var $1T1Lv = parcelRequire("1T1Lv");

});
parcelRegister("gPoc7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4042d41b028ad0b$export$2e2bcd8739ae039);
var $c4042d41b028ad0b$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("kf6M3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebca7689bf331e43$export$2e2bcd8739ae039);
var $ebca7689bf331e43$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("3vLR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $28e9634eb0d18cfb$export$2e2bcd8739ae039);
var $28e9634eb0d18cfb$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("6wirW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bf40af938bc7a8d$export$2e2bcd8739ae039);
var $4bf40af938bc7a8d$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("1T7LE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1600f3ff85be6714$export$2e2bcd8739ae039);
var $1600f3ff85be6714$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("1T1Lv", function(module, exports) {
$parcel$export(module.exports, "default", () => $15fc4c049e7222d5$export$2e2bcd8739ae039);
var $15fc4c049e7222d5$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});










parcelRegister("gkynH", function(module, exports) {
$parcel$export(module.exports, "strike", () => $6b539735ef013b2b$export$4899a95d70ec5056);

var $tw27l = parcelRequire("tw27l");
const $6b539735ef013b2b$export$4899a95d70ec5056 = (0, $tw27l.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("tNlcR", function(module, exports) {
$parcel$export(module.exports, "strong", () => $ab597ec4526ca418$export$59ae2c325a998f89);

var $tw27l = parcelRequire("tw27l");
const $ab597ec4526ca418$var$strongDOM = [
    'strong'
];
const $ab597ec4526ca418$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9]\d{2,})$/u;
const $ab597ec4526ca418$export$59ae2c325a998f89 = (0, $tw27l.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $ab597ec4526ca418$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $ab597ec4526ca418$var$strongDOM;
    }
});

});

parcelRegister("2ltAu", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $d24912a5875100f0$export$b3401ee80eb31041);

var $tw27l = parcelRequire("tw27l");
function $d24912a5875100f0$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $d24912a5875100f0$export$b3401ee80eb31041 = (0, $tw27l.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$d24912a5875100f0$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$d24912a5875100f0$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("5pFl5", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $a51c780c9003e1aa$export$20af3dabbb5538df);

var $tw27l = parcelRequire("tw27l");

var $2MYHA = parcelRequire("2MYHA");
const $a51c780c9003e1aa$export$20af3dabbb5538df = (0, $tw27l.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $2MYHA.B400)}`
            }
        ];
    }
});

});

parcelRegister("1JJe1", function(module, exports) {
$parcel$export(module.exports, "underline", () => $d9d4bf3b8587b5a3$export$425327af25286e5e);

var $tw27l = parcelRequire("tw27l");
const $d9d4bf3b8587b5a3$export$425327af25286e5e = (0, $tw27l.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("2hJSm", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $d36888b8a7b3a872$export$30d78d5eb6719bb8);

var $tw27l = parcelRequire("tw27l");
const $d36888b8a7b3a872$export$30d78d5eb6719bb8 = (0, $tw27l.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("d1YmP", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $74fed6c1e4250aa7$export$a316dc07ff5182a2);

var $tw27l = parcelRequire("tw27l");
const $74fed6c1e4250aa7$export$a316dc07ff5182a2 = (0, $tw27l.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});


parcelRegister("lPSxL", function(module, exports) {
$parcel$export(module.exports, "nodesInOrder", () => $3ef69a954af141ed$export$77d2c0ec1ddbfa6c);

var $k0msq = parcelRequire("k0msq");
var $ftOXF = parcelRequire("ftOXF");
var $2aCeP = parcelRequire("2aCeP");
var $3kxb2 = parcelRequire("3kxb2");
var $cm5bx = parcelRequire("cm5bx");
var $5wdoq = parcelRequire("5wdoq");
var $9nikD = parcelRequire("9nikD");
var $eynRz = parcelRequire("eynRz");
var $f7JVa = parcelRequire("f7JVa");
var $he3wV = parcelRequire("he3wV");
var $mp0z0 = parcelRequire("mp0z0");
var $imC3g = parcelRequire("imC3g");
var $24Njj = parcelRequire("24Njj");
var $bNELO = parcelRequire("bNELO");
var $8NN4H = parcelRequire("8NN4H");
var $cf5lB = parcelRequire("cf5lB");
var $8xR7M = parcelRequire("8xR7M");
var $1dTNM = parcelRequire("1dTNM");
var $7JT5k = parcelRequire("7JT5k");
var $2hMtT = parcelRequire("2hMtT");
var $jvwoj = parcelRequire("jvwoj");
var $1xC7B = parcelRequire("1xC7B");
var $l4kwz = parcelRequire("l4kwz");
var $eqk7K = parcelRequire("eqk7K");
var $fUHL4 = parcelRequire("fUHL4");
var $4d4Lm = parcelRequire("4d4Lm");
var $imJfX = parcelRequire("imJfX");
var $e4jxG = parcelRequire("e4jxG");
var $5Z1us = parcelRequire("5Z1us");
var $co6dq = parcelRequire("co6dq");
var $35RYb = parcelRequire("35RYb");
var $jiA7W = parcelRequire("jiA7W");
var $hHCeP = parcelRequire("hHCeP");
var $gW1mO = parcelRequire("gW1mO");
var $8nTzm = parcelRequire("8nTzm");
var $5UXYb = parcelRequire("5UXYb");
var $drur6 = parcelRequire("drur6");
var $fhSQQ = parcelRequire("fhSQQ");
var $fAXpk = parcelRequire("fAXpk");
var $et9pQ = parcelRequire("et9pQ");
var $4d8Oe = parcelRequire("4d8Oe");
var $5vK1d = parcelRequire("5vK1d");
var $c8L22 = parcelRequire("c8L22");
var $8olal = parcelRequire("8olal");
var $eCc5B = parcelRequire("eCc5B");
var $i6pjC = parcelRequire("i6pjC");
var $d5USw = parcelRequire("d5USw");
var $bkrsJ = parcelRequire("bkrsJ");

var $au7g7 = parcelRequire("au7g7");
const $3ef69a954af141ed$export$77d2c0ec1ddbfa6c = [
    {
        name: 'doc',
        spec: (0, $bNELO.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $fhSQQ.paragraph)
    },
    {
        name: 'text',
        spec: (0, $eCc5B.text)
    },
    {
        name: 'bulletList',
        spec: (0, $cm5bx.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $drur6.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $co6dq.listItem)
    },
    {
        name: 'heading',
        spec: (0, $eqk7K.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $1dTNM.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $9nikD.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $7JT5k.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $2hMtT.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $et9pQ.rule)
    },
    {
        name: 'bodiedRule',
        spec: (0, $au7g7.bodiedRule)
    },
    {
        name: 'image',
        spec: (0, $fUHL4.image)
    },
    {
        name: 'mention',
        spec: (0, $8nTzm.mention)
    },
    {
        name: 'caption',
        spec: (0, $5wdoq.caption)
    },
    {
        name: 'media',
        spec: (0, $35RYb.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $jiA7W.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $gW1mO.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $hHCeP.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $fAXpk.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $5Z1us.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $e4jxG.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $l4kwz.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $cf5lB.emoji)
    },
    {
        name: 'table',
        spec: (0, $c8L22.table)
    },
    {
        name: 'tableCell',
        spec: (0, $c8L22.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $c8L22.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $c8L22.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $eynRz.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $he3wV.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $f7JVa.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $24Njj.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $imC3g.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $8olal.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $ftOXF.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $ftOXF.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $mp0z0.date)
    },
    {
        name: 'status',
        spec: (0, $4d8Oe.status)
    },
    {
        name: 'expand',
        spec: (0, $8xR7M.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $5UXYb.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $jvwoj.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $imJfX.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $2aCeP.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $1xC7B.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $1xC7B.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $4d4Lm.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $k0msq.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $8NN4H.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $5vK1d.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $3kxb2.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $i6pjC.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d5USw.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $bkrsJ.unsupportedInline)
    }
];

});
parcelRegister("k0msq", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $e2503c6a4c760c6f$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $e2503c6a4c760c6f$export$9894f24949f094e5);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $e2503c6a4c760c6f$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $e2503c6a4c760c6f$export$c4c2f833baaebdb8 = (0, $jobzN.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$e2503c6a4c760c6f$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$e2503c6a4c760c6f$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
const $e2503c6a4c760c6f$export$9894f24949f094e5 = (0, $jobzN.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$e2503c6a4c760c6f$var$getCommonAttributesFromDom(dom),
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$e2503c6a4c760c6f$var$getCommonAttributesFromDom(dom),
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2, _node$attrs3;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});
parcelRegister("jobzN", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $06cee0fb8b52854a$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $06cee0fb8b52854a$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $06cee0fb8b52854a$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $06cee0fb8b52854a$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $06cee0fb8b52854a$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedRuleStage0", () => $06cee0fb8b52854a$export$fedbe6c839176437);
$parcel$export(module.exports, "bodiedSyncBlock", () => $06cee0fb8b52854a$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $06cee0fb8b52854a$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $06cee0fb8b52854a$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $06cee0fb8b52854a$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $06cee0fb8b52854a$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $06cee0fb8b52854a$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $06cee0fb8b52854a$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $06cee0fb8b52854a$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $06cee0fb8b52854a$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $06cee0fb8b52854a$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $06cee0fb8b52854a$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $06cee0fb8b52854a$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $06cee0fb8b52854a$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $06cee0fb8b52854a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $06cee0fb8b52854a$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $06cee0fb8b52854a$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $06cee0fb8b52854a$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $06cee0fb8b52854a$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $06cee0fb8b52854a$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $06cee0fb8b52854a$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $06cee0fb8b52854a$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $06cee0fb8b52854a$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $06cee0fb8b52854a$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $06cee0fb8b52854a$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $06cee0fb8b52854a$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $06cee0fb8b52854a$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $06cee0fb8b52854a$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $06cee0fb8b52854a$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $06cee0fb8b52854a$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $06cee0fb8b52854a$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $06cee0fb8b52854a$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $06cee0fb8b52854a$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $06cee0fb8b52854a$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $06cee0fb8b52854a$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $06cee0fb8b52854a$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $06cee0fb8b52854a$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $06cee0fb8b52854a$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $06cee0fb8b52854a$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelC1Stage0", () => $06cee0fb8b52854a$export$6f6742e395e02fdc);
$parcel$export(module.exports, "paragraph", () => $06cee0fb8b52854a$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $06cee0fb8b52854a$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $06cee0fb8b52854a$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $06cee0fb8b52854a$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $06cee0fb8b52854a$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $06cee0fb8b52854a$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $06cee0fb8b52854a$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $06cee0fb8b52854a$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $06cee0fb8b52854a$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $06cee0fb8b52854a$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $06cee0fb8b52854a$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $06cee0fb8b52854a$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $06cee0fb8b52854a$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $06cee0fb8b52854a$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $06cee0fb8b52854a$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $06cee0fb8b52854a$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $06cee0fb8b52854a$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $06cee0fb8b52854a$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $6mRUX = parcelRequire("6mRUX");
const $06cee0fb8b52854a$export$c4c2f833baaebdb8 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $06cee0fb8b52854a$export$67dc04e652a298ca = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $06cee0fb8b52854a$export$199922e5af8e9a6 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $06cee0fb8b52854a$export$16018c61064a18df = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$27903d543b563e39 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $06cee0fb8b52854a$export$8bbe5aa5bba36cc1 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $06cee0fb8b52854a$export$e7320d153c538837 = (0, $6mRUX.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $06cee0fb8b52854a$export$208411233915368e = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$fedbe6c839176437 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$e92c7e4302dd4371 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel_c1 | panel | rule | bodiedRule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $06cee0fb8b52854a$export$a140c94e5ea26bee = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$8e3c2dfdc4f0453d = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $06cee0fb8b52854a$export$7bb0d5c671655cc4 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $06cee0fb8b52854a$export$e4f1c66d84049f8b = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $06cee0fb8b52854a$export$daf889beb5092f95 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$e6e4878f43c27cab = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$3e6d667072febc87 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$324d90190a8b822a = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$47988d68fe575725 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$6959e16eeff859b4 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $06cee0fb8b52854a$export$62d45a65fb43d95e = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$2a111da947c407d2 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | codeBlock | panel | panel_c1_root_only | rule | bodiedRule | extension | bodiedExtension | multiBodiedExtension | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation breakout'
});
const $06cee0fb8b52854a$export$be4283d9a1cb1ff6 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$a19185d1233fc4b2 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$f5574b5d45fc2112 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$9f77e0932fb78f72 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $06cee0fb8b52854a$export$7e3788972005cc72 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $06cee0fb8b52854a$export$1b45514b112dd749 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$ad06037362b3c3b3 = (0, $6mRUX.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$243bc54b0560ecc = (0, $6mRUX.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$3e3366ebd634cc62 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$a8baf338431a691 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$b555be60c7703afb = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $06cee0fb8b52854a$export$371da9dd35aba193 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $06cee0fb8b52854a$export$46e4a324ac90507f = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$1b0c1557b234fa00 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$85461f751c457cc2 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$2b380a0f7e250af1 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$5c452ff88e35e47d = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $06cee0fb8b52854a$export$cbf8224b64e0d942 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $06cee0fb8b52854a$export$2f4e72b9459914ad = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $06cee0fb8b52854a$export$16b353b2649bd8d9 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$b3b1e36c2105006d = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$ab76e7c03cd6f650 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $06cee0fb8b52854a$export$b3b6a70a7fa4a5be = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $06cee0fb8b52854a$export$cdae19acb0a520fd = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $06cee0fb8b52854a$export$206007566ca0aca5 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $06cee0fb8b52854a$export$76c7e83ecc9cdf05 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$987d49ffe1b0900f = (0, $6mRUX.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$2855e964765eac9 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $06cee0fb8b52854a$export$38bab695e3f720f1 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$969fe3781ca15058 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $06cee0fb8b52854a$export$8d067f22dc2d1254 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$7e767666f2ce108a = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$4bd9a38995f6bf50 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$db83999c14438df4 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$46f790bd65f760d0 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$6f4c18ddc3950a66 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $06cee0fb8b52854a$export$750e45819f66d9d0 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $06cee0fb8b52854a$export$63cadbf5f4296627 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | bodiedRule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $06cee0fb8b52854a$export$f03786aa6312d1e4 = (0, $6mRUX.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $06cee0fb8b52854a$export$a5dc81035676e7a = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$21f42ab9b6679f44 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$862432e0a10d1bc1 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$6f6742e395e02fdc = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$7eb9416336a42c2b = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$9c206ddddb32a9b = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$4f98472e6dc14293 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$b0710a201beac6b2 = (0, $6mRUX.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$ea332b61641b0588 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$a1f41dc4901771f8 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$c7187bbd1a7a9244 = (0, $6mRUX.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $06cee0fb8b52854a$export$fbeb3a3956e8a3c7 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$1d53b70195c9c417 = (0, $6mRUX.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$78cca5eef2450890 = (0, $6mRUX.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$17f7139bf40eed49 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $06cee0fb8b52854a$export$471f7ae5c4103ae1 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$b6ce52be8d7a261 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$faab0ca9701d7048 = (0, $6mRUX.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$9852986a3ec5f6a0 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $06cee0fb8b52854a$export$ce086a560a1d05f5 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $06cee0fb8b52854a$export$e1e720e5f4603e6a = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $06cee0fb8b52854a$export$abf39ca178940ff3 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $06cee0fb8b52854a$export$48884d2a5190dc73 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $06cee0fb8b52854a$export$2a5a518232fa1a97 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $06cee0fb8b52854a$export$ce666bf02318c957 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $06cee0fb8b52854a$export$7d657479499397 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $06cee0fb8b52854a$export$6d8b0ef52e2e6390 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$375b6afcc5f4d291 = (0, $6mRUX.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $06cee0fb8b52854a$export$6f093cfa640b7166 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $06cee0fb8b52854a$export$5ea06bc686c59dc2 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $06cee0fb8b52854a$export$93256a4c17b33a82 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $06cee0fb8b52854a$export$a12828d0f14a2762 = (0, $6mRUX.createPMNodeSpecFactory)({});
const $06cee0fb8b52854a$export$44b79b0979d0f0f7 = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $06cee0fb8b52854a$export$310ebe0d80122e9b = (0, $6mRUX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("6mRUX", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $49dfc531156350a5$export$bf0a80f00e2b8ff6);
const $49dfc531156350a5$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});


parcelRegister("9RSBE", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $abfde3374da733d3$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $abfde3374da733d3$export$31b40729666a4ae0);
const $abfde3374da733d3$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $abfde3374da733d3$var$staticValue = false;
const $abfde3374da733d3$export$31b40729666a4ae0 = {
    setStatic (value) {
        $abfde3374da733d3$var$staticValue = value;
    },
    generate () {
        return $abfde3374da733d3$var$staticValue || $abfde3374da733d3$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("ftOXF", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $df521dbe8fc7eec2$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $df521dbe8fc7eec2$export$16018c61064a18df);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $df521dbe8fc7eec2$export$6d8b0ef52e2e6390 = (0, $jobzN.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9RSBE.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $df521dbe8fc7eec2$export$16018c61064a18df = (0, $jobzN.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9RSBE.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2aCeP", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $a82e28a5514ea1b0$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtensionRootOnlyStage0", () => $a82e28a5514ea1b0$export$8bbe5aa5bba36cc1);

var $jobzN = parcelRequire("jobzN");

var $fXAL2 = parcelRequire("fXAL2");
const $a82e28a5514ea1b0$export$27903d543b563e39 = (0, $jobzN.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fXAL2.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a82e28a5514ea1b0$export$8bbe5aa5bba36cc1 = {
    ...$a82e28a5514ea1b0$export$27903d543b563e39,
    marks: `breakout ${$a82e28a5514ea1b0$export$27903d543b563e39.marks}`
};

});
parcelRegister("fXAL2", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $e221fe95ad8f1398$export$1765e2758fc47004);

var $3izlu = parcelRequire("3izlu");
const $e221fe95ad8f1398$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = (0, $3izlu.isValidLayout)(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});
parcelRegister("3izlu", function(module, exports) {
$parcel$export(module.exports, "isValidLayout", () => $54bb299535407072$export$d5f21755dc782a4a);
const $54bb299535407072$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};

});



parcelRegister("3kxb2", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $99cadd7bb2927828$export$e92c7e4302dd4371);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $99cadd7bb2927828$export$e92c7e4302dd4371 = (0, $jobzN.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $9RSBE.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("cm5bx", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $63820ae44d012760$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $63820ae44d012760$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $63820ae44d012760$export$dfd406053b2bab40);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $63820ae44d012760$export$5f25a39efab3b58b = '.ak-ul';
const $63820ae44d012760$export$a140c94e5ea26bee = (0, $jobzN.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $63820ae44d012760$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $63820ae44d012760$export$dfd406053b2bab40 = (0, $jobzN.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $63820ae44d012760$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5wdoq", function(module, exports) {
$parcel$export(module.exports, "caption", () => $6728e71afafe46c7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $6728e71afafe46c7$export$b5d01ee303c467aa);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $6728e71afafe46c7$export$8e3c2dfdc4f0453d = (0, $jobzN.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $6728e71afafe46c7$export$b5d01ee303c467aa = (0, $jobzN.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9nikD", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $b57129a0236f75ed$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $b57129a0236f75ed$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $b57129a0236f75ed$export$3f75de798a0b5356);

var $kW8qW = parcelRequire("kW8qW");

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $b57129a0236f75ed$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $b57129a0236f75ed$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $b57129a0236f75ed$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $b57129a0236f75ed$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $b57129a0236f75ed$var$LANGUAGE_CLASS_REGEX = /(?:^|\s)language-([^\s]+)/u;
const $b57129a0236f75ed$var$TRAILING_NEWLINE_REGEX = /\n$/u;
const $b57129a0236f75ed$var$extractLanguageFromClass = (className)=>{
    const result = $b57129a0236f75ed$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $b57129a0236f75ed$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($b57129a0236f75ed$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $b57129a0236f75ed$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $b57129a0236f75ed$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $b57129a0236f75ed$export$7bb0d5c671655cc4 = (0, $jobzN.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b57129a0236f75ed$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b57129a0236f75ed$var$getLanguageFromEditorStyle(dom.parentElement) || $b57129a0236f75ed$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $b57129a0236f75ed$var$removeLastNewLine(dom);
                const wrapAttr = dom.getAttribute('data-wrap');
                const isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                const wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                const hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $b57129a0236f75ed$var$parseCodeFromHtml(domNode);
                return code ? (0, $kW8qW.Fragment).from(schema.text(code)) : (0, $kW8qW.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $b57129a0236f75ed$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $b57129a0236f75ed$export$3f75de798a0b5356 = (0, $jobzN.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b57129a0236f75ed$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $b57129a0236f75ed$var$getLanguageFromEditorStyle(dom.parentElement) || $b57129a0236f75ed$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $b57129a0236f75ed$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $b57129a0236f75ed$var$parseCodeFromHtml(domNode);
                return code ? (0, $kW8qW.Fragment).from(schema.text(code)) : (0, $kW8qW.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("eynRz", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $9fcf44a92e54f8a1$export$daf889beb5092f95);

var $jobzN = parcelRequire("jobzN");
const $9fcf44a92e54f8a1$var$name = 'confluenceJiraIssue';
const $9fcf44a92e54f8a1$export$daf889beb5092f95 = (0, $jobzN.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$9fcf44a92e54f8a1$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $9fcf44a92e54f8a1$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("f7JVa", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $da8e84cce757241b$export$e6e4878f43c27cab);

var $jobzN = parcelRequire("jobzN");
const $da8e84cce757241b$var$name = 'confluenceUnsupportedBlock';
const $da8e84cce757241b$export$e6e4878f43c27cab = (0, $jobzN.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $da8e84cce757241b$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$da8e84cce757241b$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("he3wV", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $4e78f48dfec954d5$export$3e6d667072febc87);

var $jobzN = parcelRequire("jobzN");
const $4e78f48dfec954d5$var$name = 'confluenceUnsupportedInline';
const $4e78f48dfec954d5$export$3e6d667072febc87 = (0, $jobzN.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $4e78f48dfec954d5$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$4e78f48dfec954d5$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("mp0z0", function(module, exports) {
$parcel$export(module.exports, "date", () => $0cc4dbb4ad65f609$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $0cc4dbb4ad65f609$export$a6a035390e3921b2);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $0cc4dbb4ad65f609$export$324d90190a8b822a = (0, $jobzN.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $0cc4dbb4ad65f609$export$a6a035390e3921b2 = (0, $jobzN.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("imC3g", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $9203d49669b60073$export$6959e16eeff859b4);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $9203d49669b60073$export$6959e16eeff859b4 = (0, $jobzN.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9RSBE.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("24Njj", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $e6ff97922c57e4c2$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $e6ff97922c57e4c2$export$62d45a65fb43d95e);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $e6ff97922c57e4c2$var$name = 'decisionList';
const $e6ff97922c57e4c2$export$a5393ce68c2ff601 = `[data-node-type="${$e6ff97922c57e4c2$var$name}"]`;
const $e6ff97922c57e4c2$export$62d45a65fb43d95e = (0, $jobzN.decisionList)({
    parseDOM: [
        {
            tag: `ol${$e6ff97922c57e4c2$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $e6ff97922c57e4c2$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bNELO", function(module, exports) {
$parcel$export(module.exports, "doc", () => $84659d361ca5296f$export$2a111da947c407d2);

var $jobzN = parcelRequire("jobzN");
const $84659d361ca5296f$export$2a111da947c407d2 = (0, $jobzN.doc)({});

});

parcelRegister("8NN4H", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $d2ac866362d607c1$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $d2ac866362d607c1$export$36734475a7f6fd3e);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $d2ac866362d607c1$export$be4283d9a1cb1ff6 = (0, $jobzN.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $d2ac866362d607c1$export$36734475a7f6fd3e = (0, $jobzN.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("cf5lB", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $17ad3301ee2f13e1$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $17ad3301ee2f13e1$export$ebb3b3c7a0ac9936);

var $jobzN = parcelRequire("jobzN");

var $5sihV = parcelRequire("5sihV");

var $738dK = parcelRequire("738dK");

var $9RSBE = parcelRequire("9RSBE");
const $17ad3301ee2f13e1$export$a19185d1233fc4b2 = (0, $jobzN.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $5sihV.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $738dK.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $17ad3301ee2f13e1$export$ebb3b3c7a0ac9936 = (0, $jobzN.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $5sihV.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $738dK.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $17ad3301ee2f13e1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("5sihV", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $add53b40673ca371$export$f61e93bda2a8b420);

var $zrXnM = parcelRequire("zrXnM");

var $pLpkf = parcelRequire("pLpkf");
function $add53b40673ca371$export$f61e93bda2a8b420(acName) {
    const emojiData = (0, $zrXnM.acNameToEmojiMap)[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: (0, $pLpkf.DEFAULT_EMOJI_ID),
        shortName: `:${acName}:`,
        text: ''
    };
}

});
parcelRegister("zrXnM", function(module, exports) {
$parcel$export(module.exports, "acNameToEmojiMap", () => $ff1f4761d44e0f22$export$7962498ea8ccffac);
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $ff1f4761d44e0f22$export$7962498ea8ccffac = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};

});

parcelRegister("pLpkf", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_EMOJI_ID", () => $46e9977c4b2133de$export$936e67708ade64a9);
$parcel$export(module.exports, "DEFAULT_EMOJI_ACNAME", () => $46e9977c4b2133de$export$209b328f48821d5f);
$parcel$export(module.exports, "HC_EMOTICON_PREFIX", () => $46e9977c4b2133de$export$1c102a772ecd912c);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 




const $46e9977c4b2133de$export$936e67708ade64a9 = '2b50';
const $46e9977c4b2133de$export$209b328f48821d5f = 'blue-star';
const $46e9977c4b2133de$export$1c102a772ecd912c = 'atlassian-';

});


parcelRegister("738dK", function(module, exports) {
$parcel$export(module.exports, "acShortcutToEmoji", () => $50ed1eceada68ef3$export$441f8b58f5790a68);

var $pLpkf = parcelRequire("pLpkf");
function $50ed1eceada68ef3$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${0, $pLpkf.HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}

});


parcelRegister("8xR7M", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $96eee447e4ce8a4c$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $96eee447e4ce8a4c$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $96eee447e4ce8a4c$export$54fd2c36b5cc6731);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
function $96eee447e4ce8a4c$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $96eee447e4ce8a4c$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $96eee447e4ce8a4c$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $96eee447e4ce8a4c$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $96eee447e4ce8a4c$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $96eee447e4ce8a4c$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $96eee447e4ce8a4c$export$7b80cba28d10b2c1 = (0, $jobzN.expand)($96eee447e4ce8a4c$var$nodeSpecOptions);
const $96eee447e4ce8a4c$export$2ae5e7565ff9ffa6 = (0, $jobzN.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $96eee447e4ce8a4c$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $96eee447e4ce8a4c$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $96eee447e4ce8a4c$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $96eee447e4ce8a4c$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $96eee447e4ce8a4c$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("1dTNM", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $bdd6a4c8cd7f175b$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $bdd6a4c8cd7f175b$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $bdd6a4c8cd7f175b$export$950ebf43f3364a0f);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $bdd6a4c8cd7f175b$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $bdd6a4c8cd7f175b$export$67dc04e652a298ca = (0, $jobzN.blockquoteLegacy)($bdd6a4c8cd7f175b$var$nodeSpecOptions);
const $bdd6a4c8cd7f175b$export$70a64939da3e8455 = (0, $jobzN.blockquote)($bdd6a4c8cd7f175b$var$nodeSpecOptions);
const $bdd6a4c8cd7f175b$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
const $bdd6a4c8cd7f175b$export$950ebf43f3364a0f = (0, $jobzN.blockquote)($bdd6a4c8cd7f175b$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("7JT5k", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", () => $3e164c37971d5832$export$ce20b13564211141);

var $jobzN = parcelRequire("jobzN");

var $jRylO = parcelRequire("jRylO");
const $3e164c37971d5832$export$ce20b13564211141 = (allowCustomPanel)=>(0, $jobzN.panel)((0, $jRylO.createPanelNodeSpecOptions)(allowCustomPanel));

});
parcelRegister("jRylO", function(module, exports) {
$parcel$export(module.exports, "createPanelNodeSpecOptions", () => $7d27950b0a7cb235$export$1f22c1e22ac5e390);

var $4o0rb = parcelRequire("4o0rb");

var $g8bYL = parcelRequire("g8bYL");
const $7d27950b0a7cb235$export$1f22c1e22ac5e390 = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>(0, $g8bYL.getParseDOMAttrs)(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = (0, $4o0rb.getDomAttrs)(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });

});
parcelRegister("4o0rb", function(module, exports) {
$parcel$export(module.exports, "getDomAttrs", () => $3682da9078b2411c$export$573b838ca5694549);
const $3682da9078b2411c$export$573b838ca5694549 = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};

});

parcelRegister("g8bYL", function(module, exports) {
$parcel$export(module.exports, "getParseDOMAttrs", () => $c1a1b7daf4c4a967$export$f5f376335f9d8c6b);

var $9RSBE = parcelRequire("9RSBE");

var $gAe8g = parcelRequire("gAe8g");
const $c1a1b7daf4c4a967$export$f5f376335f9d8c6b = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $9RSBE.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === (0, $gAe8g.PanelType).CUSTOM ? (0, $gAe8g.PanelType).INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};

});
parcelRegister("gAe8g", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $7338c7a5812249c2$export$969277cf61e5a7aa);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 








var $7338c7a5812249c2$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});

});




parcelRegister("2hMtT", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1", () => $e585fd19c327ead1$export$c158ac2988d2f011);

var $jobzN = parcelRequire("jobzN");

var $jRylO = parcelRequire("jRylO");
const $e585fd19c327ead1$export$c158ac2988d2f011 = (allowCustomPanel)=>(0, $jobzN.panelC1Stage0)((0, $jRylO.createPanelNodeSpecOptions)(allowCustomPanel));

});

parcelRegister("jvwoj", function(module, exports) {
$parcel$export(module.exports, "extension", () => $bfafadd305a961e7$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionRootOnlyStage0", () => $bfafadd305a961e7$export$ad06037362b3c3b3);
$parcel$export(module.exports, "extensionWithAnnotationStage0", () => $bfafadd305a961e7$export$3e3366ebd634cc62);
$parcel$export(module.exports, "extensionRootOnlyWithAnnotationStage0", () => $bfafadd305a961e7$export$243bc54b0560ecc);

var $jobzN = parcelRequire("jobzN");

var $fXAL2 = parcelRequire("fXAL2");
const $bfafadd305a961e7$export$1b45514b112dd749 = (0, $jobzN.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fXAL2.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
const $bfafadd305a961e7$export$ad06037362b3c3b3 = {
    ...$bfafadd305a961e7$export$1b45514b112dd749,
    marks: 'breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $bfafadd305a961e7$export$3e3366ebd634cc62 = {
    ...$bfafadd305a961e7$export$1b45514b112dd749,
    marks: 'annotation dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $bfafadd305a961e7$export$243bc54b0560ecc = {
    ...$bfafadd305a961e7$export$1b45514b112dd749,
    marks: 'annotation breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("1xC7B", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $d3b0525f2e77d3cf$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $d3b0525f2e77d3cf$export$c3c04d555a8b9013);
$parcel$export(module.exports, "multiBodiedExtensionRootOnlyStage0", () => $d3b0525f2e77d3cf$export$6f4c18ddc3950a66);

var $jobzN = parcelRequire("jobzN");

var $fXAL2 = parcelRequire("fXAL2");
const $d3b0525f2e77d3cf$export$4fdcae991fd743e7 = (0, $jobzN.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $d3b0525f2e77d3cf$export$c3c04d555a8b9013 = (0, $jobzN.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $fXAL2.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $d3b0525f2e77d3cf$export$6f4c18ddc3950a66 = {
    ...$d3b0525f2e77d3cf$export$c3c04d555a8b9013,
    marks: `breakout ${$d3b0525f2e77d3cf$export$c3c04d555a8b9013.marks}`
};

});

parcelRegister("l4kwz", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $c0035227266374b8$export$371da9dd35aba193);

var $jobzN = parcelRequire("jobzN");
const $c0035227266374b8$export$371da9dd35aba193 = (0, $jobzN.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("eqk7K", function(module, exports) {
$parcel$export(module.exports, "heading", () => $ff1b99fc5dbe66f3$export$46e4a324ac90507f);

var $jobzN = parcelRequire("jobzN");
const $ff1b99fc5dbe66f3$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $ff1b99fc5dbe66f3$export$46e4a324ac90507f = (0, $jobzN.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $ff1b99fc5dbe66f3$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $ff1b99fc5dbe66f3$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $ff1b99fc5dbe66f3$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $ff1b99fc5dbe66f3$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $ff1b99fc5dbe66f3$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $ff1b99fc5dbe66f3$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("fUHL4", function(module, exports) {
$parcel$export(module.exports, "image", () => $916786412abebb3d$export$5c452ff88e35e47d);

var $jobzN = parcelRequire("jobzN");
const $916786412abebb3d$export$5c452ff88e35e47d = (0, $jobzN.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("4d4Lm", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $a748466973209230$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $a748466973209230$export$7ed775fc743eadd1);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $a748466973209230$export$cbf8224b64e0d942 = (0, $jobzN.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $a748466973209230$export$7ed775fc743eadd1 = (0, $jobzN.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $9RSBE.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("imJfX", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $87d6affd4cc35999$export$16b353b2649bd8d9);

var $jobzN = parcelRequire("jobzN");

var $fXAL2 = parcelRequire("fXAL2");
const $87d6affd4cc35999$export$16b353b2649bd8d9 = (0, $jobzN.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fXAL2.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("e4jxG", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $96cbdc45a850c810$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $96cbdc45a850c810$export$b2e27d292505bac2);
$parcel$export(module.exports, "layoutColumnStage0", () => $96cbdc45a850c810$export$f8cda4c28dab3f58);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");

var $95H4p = parcelRequire("95H4p");
const $96cbdc45a850c810$var$setColumnAttributes = (node, { withLocalId: withLocalId = false } = {})=>{
    const attrs = {
        'data-layout-column': 'true'
    };
    const { width: width, valign: valign, localId: localId } = node.attrs;
    if (width) {
        const baseStyle = `flex-basis: ${width}%`;
        attrs['style'] = `${baseStyle}; --column-width: ${width}%`;
        attrs['data-column-width'] = `${width}`;
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
const $96cbdc45a850c810$var$getColumnAttrs = ({ withLocalId: withLocalId = false } = {})=>(domNode)=>{
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = domNode;
        const base = {
            width: Number(dom.getAttribute('data-column-width')) || undefined,
            ...withLocalId && {
                localId: (0, $9RSBE.uuid).generate()
            }
        };
        const valign = (0, $95H4p.parseValign)(dom.getAttribute('data-valign'));
        return valign ? {
            ...base,
            valign: valign
        } : base;
    };
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
const $96cbdc45a850c810$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
const $96cbdc45a850c810$export$ab76e7c03cd6f650 = (0, $jobzN.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $96cbdc45a850c810$var$getColumnAttrs()
        }
    ],
    toDOM (node) {
        return [
            'div',
            $96cbdc45a850c810$var$setColumnAttributes(node),
            [
                'div',
                $96cbdc45a850c810$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $96cbdc45a850c810$export$b2e27d292505bac2 = (0, $jobzN.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $96cbdc45a850c810$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM (node) {
        return [
            'div',
            $96cbdc45a850c810$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $96cbdc45a850c810$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $96cbdc45a850c810$export$f8cda4c28dab3f58 = $96cbdc45a850c810$export$b2e27d292505bac2;

});
parcelRegister("95H4p", function(module, exports) {
$parcel$export(module.exports, "parseValign", () => $dc91a069d1765cac$export$80408efb85c33a7a);
const $dc91a069d1765cac$export$80408efb85c33a7a = (raw)=>{
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};

});


parcelRegister("5Z1us", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $85f98574274b9396$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $85f98574274b9396$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $85f98574274b9396$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $85f98574274b9396$export$64facded20dfd85c);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $85f98574274b9396$export$b3b6a70a7fa4a5be = (0, $jobzN.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $85f98574274b9396$export$cdae19acb0a520fd = (0, $jobzN.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $85f98574274b9396$export$4f9d8f623ff17117 = (0, $jobzN.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $85f98574274b9396$export$d9d3c69a64270b13 = (0, $jobzN.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $9RSBE.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $85f98574274b9396$export$64facded20dfd85c = (0, $jobzN.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $9RSBE.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("co6dq", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $073f62da2e58a13e$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $073f62da2e58a13e$export$483d52f09158e61c);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $073f62da2e58a13e$export$76c7e83ecc9cdf05 = (0, $jobzN.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $073f62da2e58a13e$export$483d52f09158e61c = (0, $jobzN.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("35RYb", function(module, exports) {
$parcel$export(module.exports, "media", () => $f660079eed3c48a9$export$987d49ffe1b0900f);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");

var $cKrHK = parcelRequire("cKrHK");



const $f660079eed3c48a9$export$bb3fe706be61f640 = {
    ...(0, $jobzN.media)({}).attrs
};
const $f660079eed3c48a9$export$987d49ffe1b0900f = (0, $cKrHK.createMediaSpec)($f660079eed3c48a9$export$bb3fe706be61f640, false, false);
const $f660079eed3c48a9$export$8446e47a4c7fd000 = (0, $cKrHK.createMediaSpec)({
    ...$f660079eed3c48a9$export$bb3fe706be61f640,
    localId: {
        default: (0, $9RSBE.uuid).generate()
    }
}, false, true);

});
parcelRegister("cKrHK", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", () => $974529b0b52a136f$export$35bdbf5bc8caa677);

var $jobzN = parcelRequire("jobzN");

var $2MYHA = parcelRequire("2MYHA");

var $9RSBE = parcelRequire("9RSBE");

var $cB64w = parcelRequire("cB64w");

var $itjXv = parcelRequire("itjXv");
const $974529b0b52a136f$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/u;
const $974529b0b52a136f$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = (0, $cB64w.camelCaseToKebabCase)(k).replace($974529b0b52a136f$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    const value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $9RSBE.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $2MYHA.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        (0, $itjXv.copyPrivateAttributes)(node.attrs, attrs, attributes, (key)=>`data-${(0, $cB64w.camelCaseToKebabCase)(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $jobzN.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $jobzN.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $9RSBE.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};

});
parcelRegister("cB64w", function(module, exports) {
$parcel$export(module.exports, "camelCaseToKebabCase", () => $b3cf90ce78b73523$export$f84fdfb973c05bd8);
const $b3cf90ce78b73523$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);

});

parcelRegister("itjXv", function(module, exports) {
$parcel$export(module.exports, "copyPrivateAttributes", () => $a20476281243a591$export$111130fa8968d741);
const $a20476281243a591$export$111130fa8968d741 = (from, to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};

});



parcelRegister("jiA7W", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $5266452f3e6c8826$export$2855e964765eac9);

var $jobzN = parcelRequire("jobzN");
const $5266452f3e6c8826$export$2855e964765eac9 = (0, $jobzN.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("hHCeP", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $72c32fb01af2c7fa$export$38bab695e3f720f1);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");

var $cKrHK = parcelRequire("cKrHK");
const $72c32fb01af2c7fa$export$38bab695e3f720f1 = (0, $cKrHK.createMediaSpec)((0, $jobzN.mediaInline)({}).attrs, true);
const $72c32fb01af2c7fa$export$aea8e9c496505c61 = (0, $cKrHK.createMediaSpec)({
    ...(0, $jobzN.mediaInline)({}).attrs,
    localId: {
        default: (0, $9RSBE.uuid).generate()
    }
}, true, true);

});

parcelRegister("gW1mO", function(module, exports) {
$parcel$export(module.exports, "mediaSingle", () => $65ab0b15a6551295$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $65ab0b15a6551295$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $65ab0b15a6551295$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $65ab0b15a6551295$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $65ab0b15a6551295$export$75376a385837c942);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $19APL = parcelRequire("19APL");

const $65ab0b15a6551295$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $65ab0b15a6551295$export$969fe3781ca15058 = (0, $19APL.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $65ab0b15a6551295$export$d35e6c006d4abdfb = (0, $19APL.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $65ab0b15a6551295$export$9c58e19811ce4cf5 = (0, $19APL.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $65ab0b15a6551295$export$7e767666f2ce108a = (0, $19APL.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $65ab0b15a6551295$export$75376a385837c942 = (0, $19APL.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});

});
parcelRegister("19APL", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $f919d2297257a47f$export$5a1e124099b60c6b);

var $jobzN = parcelRequire("jobzN");

var $d1Bsh = parcelRequire("d1Bsh");

var $9RSBE = parcelRequire("9RSBE");

var $3itOO = parcelRequire("3itOO");
const $f919d2297257a47f$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $d1Bsh.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $9RSBE.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $3itOO.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs;
            attrs['data-local-id'] = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $3itOO.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $jobzN.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $jobzN.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $jobzN.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $jobzN.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};

});
parcelRegister("3itOO", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $11215e08c1b30b53$export$4d41558722ac7eed);
var $11215e08c1b30b53$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});



parcelRegister("8nTzm", function(module, exports) {
$parcel$export(module.exports, "mention", () => $47345e77e607fb22$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $47345e77e607fb22$export$54fd2c36b5cc6731);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
var $47345e77e607fb22$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $47345e77e607fb22$export$db83999c14438df4 = (0, $jobzN.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $47345e77e607fb22$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $47345e77e607fb22$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $47345e77e607fb22$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9RSBE.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($47345e77e607fb22$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $47345e77e607fb22$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $47345e77e607fb22$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($47345e77e607fb22$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("5UXYb", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $7724959586ad38cb$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $7724959586ad38cb$export$b854197485aa1fa0);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
function $7724959586ad38cb$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $9RSBE.uuid).generate() : undefined
    };
}
const $7724959586ad38cb$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$7724959586ad38cb$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$7724959586ad38cb$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $7724959586ad38cb$export$63cadbf5f4296627 = (0, $jobzN.nestedExpand)($7724959586ad38cb$var$nestedExpandFactoryOptions);
const $7724959586ad38cb$export$b854197485aa1fa0 = (0, $jobzN.nestedExpand)({
    ...$7724959586ad38cb$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$7724959586ad38cb$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$7724959586ad38cb$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$7724959586ad38cb$var$getExpandAttrs(domNode, true)
        }
    ]
});

});

parcelRegister("drur6", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $0960bf07569a7953$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $0960bf07569a7953$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $0960bf07569a7953$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $0960bf07569a7953$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $0960bf07569a7953$export$2ea3505d41d7525d);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $0960bf07569a7953$export$4e7125c7ff595be5 = '.ak-ol';
const $0960bf07569a7953$export$a5dc81035676e7a = (0, $jobzN.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $0960bf07569a7953$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $0960bf07569a7953$export$8157adc5747ec436 = (0, $jobzN.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $0960bf07569a7953$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0960bf07569a7953$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $0960bf07569a7953$export$b9ab759e8298198f = (0, $jobzN.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $0960bf07569a7953$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const start = $0960bf07569a7953$var$resolveStart(node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $0960bf07569a7953$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $0960bf07569a7953$export$2ea3505d41d7525d = (0, $jobzN.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $9RSBE.uuid).generate();
                if (startDOMAttr) {
                    const start = $0960bf07569a7953$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs3, _node$attrs4;
        const start = $0960bf07569a7953$var$resolveStart(node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $0960bf07569a7953$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("fhSQQ", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $b14083f6ca7287ed$export$9c206ddddb32a9b);

var $jobzN = parcelRequire("jobzN");
const $b14083f6ca7287ed$export$9c206ddddb32a9b = (0, $jobzN.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $b14083f6ca7287ed$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 || (_paragraph$attrs = _paragraph$attrs.localId) === null || _paragraph$attrs === void 0 ? void 0 : _paragraph$attrs.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("fAXpk", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $e149409175954caa$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $e149409175954caa$export$6205248609a8f7a0);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $e149409175954caa$export$c7187bbd1a7a9244 = (0, $jobzN.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $e149409175954caa$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $e149409175954caa$export$6205248609a8f7a0 = (0, $jobzN.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $e149409175954caa$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("et9pQ", function(module, exports) {
$parcel$export(module.exports, "rule", () => $8d0af2e9a49f90c6$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $8d0af2e9a49f90c6$export$bf3ef6fb6ad90e7);
$parcel$export(module.exports, "ruleWithAttrs", () => $8d0af2e9a49f90c6$export$ef9ec4ed8a654d7f);
$parcel$export(module.exports, "ruleRootOnlyStage0", () => $8d0af2e9a49f90c6$export$1d53b70195c9c417);
$parcel$export(module.exports, "ruleWithAttrsRootOnlyStage0", () => $8d0af2e9a49f90c6$export$78cca5eef2450890);

var $jobzN = parcelRequire("jobzN");

var $cVl17 = parcelRequire("cVl17");

var $9RSBE = parcelRequire("9RSBE");
const $8d0af2e9a49f90c6$var$hrDOM = [
    'hr'
];
const $8d0af2e9a49f90c6$export$fbeb3a3956e8a3c7 = (0, $jobzN.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $8d0af2e9a49f90c6$var$hrDOM;
    }
});
const $8d0af2e9a49f90c6$export$bf3ef6fb6ad90e7 = (0, $jobzN.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});
const $8d0af2e9a49f90c6$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || undefined,
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $8d0af2e9a49f90c6$export$ef9ec4ed8a654d7f = {
    ...$8d0af2e9a49f90c6$export$bf3ef6fb6ad90e7,
    attrs: {
        ...$8d0af2e9a49f90c6$export$bf3ef6fb6ad90e7.attrs,
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: $8d0af2e9a49f90c6$var$getAttrs
        }
    ],
    toDOM (node) {
        const { color: color, localId: localId, style: style, weight: weight } = node.attrs;
        const paletteColorValue = color && ((0, $cVl17.hexToEditorTextPaletteColor)(color) ?? color);
        return [
            'hr',
            {
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined,
                style: paletteColorValue ? `--custom-palette-color: ${paletteColorValue}` : undefined
            }
        ];
    }
};
const $8d0af2e9a49f90c6$export$1d53b70195c9c417 = {
    ...$8d0af2e9a49f90c6$export$bf3ef6fb6ad90e7,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
const $8d0af2e9a49f90c6$export$78cca5eef2450890 = {
    ...$8d0af2e9a49f90c6$export$ef9ec4ed8a654d7f,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("4d8Oe", function(module, exports) {
$parcel$export(module.exports, "status", () => $5ccbdcb1f5ff5d25$export$471f7ae5c4103ae1);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $5ccbdcb1f5ff5d25$var$NEWLINE_REGEX = /\n/u;
const $5ccbdcb1f5ff5d25$export$471f7ae5c4103ae1 = (0, $jobzN.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace($5ccbdcb1f5ff5d25$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9RSBE.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("5vK1d", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $3a28f58c3b2bbd97$export$faab0ca9701d7048);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $3a28f58c3b2bbd97$export$faab0ca9701d7048 = (0, $jobzN.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $9RSBE.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("c8L22", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $319abdd3da805e3a$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $319abdd3da805e3a$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $319abdd3da805e3a$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $319abdd3da805e3a$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $319abdd3da805e3a$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $319abdd3da805e3a$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $319abdd3da805e3a$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $319abdd3da805e3a$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorNameByHex", () => $319abdd3da805e3a$export$87db0bca041942ef);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $319abdd3da805e3a$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundColorPaletteNew", () => $319abdd3da805e3a$export$f26b9114878cba41);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $319abdd3da805e3a$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $319abdd3da805e3a$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $319abdd3da805e3a$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $319abdd3da805e3a$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $319abdd3da805e3a$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $319abdd3da805e3a$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $319abdd3da805e3a$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $319abdd3da805e3a$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $319abdd3da805e3a$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $319abdd3da805e3a$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $319abdd3da805e3a$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $319abdd3da805e3a$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $319abdd3da805e3a$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $319abdd3da805e3a$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $319abdd3da805e3a$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $319abdd3da805e3a$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $319abdd3da805e3a$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $319abdd3da805e3a$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $319abdd3da805e3a$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $319abdd3da805e3a$export$7928c3aeb4cd2213);
$parcel$export(module.exports, "tableCellStage0", () => $319abdd3da805e3a$export$7ffdb7030e2f2223);
$parcel$export(module.exports, "tableHeaderStage0", () => $319abdd3da805e3a$export$53c69bb0cddd9750);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => $319abdd3da805e3a$export$10671ff6b5f3bd84);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => $319abdd3da805e3a$export$69bdb7ac5d810d92);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $jobzN = parcelRequire("jobzN");

var $2MYHA = parcelRequire("2MYHA");

var $8bHyz = parcelRequire("8bHyz");

var $fVLsP = parcelRequire("fVLsP");

var $7I9XO = parcelRequire("7I9XO");

var $iWjRz = parcelRequire("iWjRz");

var $7Gv8k = parcelRequire("7Gv8k");

var $fgUa5 = parcelRequire("fgUa5");

var $9RSBE = parcelRequire("9RSBE");

var $95H4p = parcelRequire("95H4p");
const $319abdd3da805e3a$export$9cfceb893b24742a = 'pm-table';
const $319abdd3da805e3a$var$COL_WIDTH_ATTR_REGEX = /^\d+(,\d+)*$/u;
const $319abdd3da805e3a$export$69cb4c3f80383763 = `${$319abdd3da805e3a$export$9cfceb893b24742a}-cell-content-wrap`;
const $319abdd3da805e3a$export$7b07d37d879c957f = `${$319abdd3da805e3a$export$9cfceb893b24742a}-header-content-wrap`;
const $319abdd3da805e3a$export$8dd42a84cd52da07 = `${$319abdd3da805e3a$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $319abdd3da805e3a$export$5e26a5c19f0865d8 = `${$319abdd3da805e3a$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $319abdd3da805e3a$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $2MYHA.N20).toLocaleLowerCase();
const $319abdd3da805e3a$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && $319abdd3da805e3a$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $iWjRz.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $7Gv8k.isRgb)(backgroundColor)) {
        const result = (0, $fgUa5.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    const valign = (0, $95H4p.parseValign)(dom.getAttribute('data-valign'));
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        },
        ...valign && {
            valign: valign
        }
    };
};
// these are for test only
let $319abdd3da805e3a$var$testGlobalTheme;
const $319abdd3da805e3a$export$fd7e0dd2b74807f7 = (theme)=>{
    $319abdd3da805e3a$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $319abdd3da805e3a$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($319abdd3da805e3a$var$testGlobalTheme) return {
        colorMode: $319abdd3da805e3a$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $319abdd3da805e3a$var$cssVariablePattern = /^var\(--.*\)$/u;
const $319abdd3da805e3a$export$363c8dda799bfe9c = (node)=>{
    var _node$attrs;
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $319abdd3da805e3a$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $319abdd3da805e3a$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $7Gv8k.isRgb)(background) && (0, $fgUa5.rgbToHex)(background) ? (0, $fgUa5.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $fVLsP.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $319abdd3da805e3a$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($319abdd3da805e3a$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $8bHyz.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $319abdd3da805e3a$export$87db0bca041942ef.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $319abdd3da805e3a$export$7b07d37d879c957f;
    else attrs.class = $319abdd3da805e3a$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
const $319abdd3da805e3a$export$219b7f492ad209f8 = new Map();
const $319abdd3da805e3a$export$f26b9114878cba41 = new Map();
const $319abdd3da805e3a$export$95e9c925fbf01d1c = (0, $7I9XO.hexToRgba)((0, $2MYHA.N800), 0.12) || (0, $2MYHA.N0);
const $319abdd3da805e3a$export$8cc2833b5b349a1e = new Map();
const $319abdd3da805e3a$export$87db0bca041942ef = new Map();
// Original 7-column palette — kept as the default export so external consumers
// are not broken. When cleaning up the platform_editor_lovability_text_bg_color experiment, check if this can be removed
[
    [
        (0, $2MYHA.N0),
        'White'
    ],
    [
        (0, $2MYHA.B50),
        'Light blue'
    ],
    [
        (0, $2MYHA.T50),
        'Light teal'
    ],
    [
        (0, $2MYHA.G50),
        'Light green'
    ],
    [
        (0, $2MYHA.Y50),
        'Light yellow'
    ],
    [
        (0, $2MYHA.R50),
        'Light red'
    ],
    [
        (0, $2MYHA.P50),
        'Light purple'
    ],
    [
        (0, $2MYHA.N20),
        'Light gray'
    ],
    [
        (0, $2MYHA.B75),
        'Blue'
    ],
    [
        (0, $2MYHA.T75),
        'Teal'
    ],
    [
        (0, $2MYHA.G75),
        'Green'
    ],
    [
        (0, $2MYHA.Y75),
        'Yellow'
    ],
    [
        (0, $2MYHA.R75),
        'Red'
    ],
    [
        (0, $2MYHA.P75),
        'Purple'
    ],
    [
        (0, $2MYHA.N60),
        'Gray'
    ],
    [
        (0, $2MYHA.B100),
        'Dark blue'
    ],
    [
        (0, $2MYHA.T100),
        'Dark teal'
    ],
    [
        (0, $2MYHA.G200),
        'Dark green'
    ],
    [
        (0, $2MYHA.Y200),
        'Dark yellow'
    ],
    [
        (0, $2MYHA.R100),
        'Dark red'
    ],
    [
        (0, $2MYHA.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $319abdd3da805e3a$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $319abdd3da805e3a$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $319abdd3da805e3a$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
[
    [
        (0, $2MYHA.N0),
        'White'
    ],
    [
        (0, $2MYHA.B50),
        'Light blue'
    ],
    [
        (0, $2MYHA.T50),
        'Light teal'
    ],
    [
        (0, $2MYHA.G50),
        'Light green'
    ],
    [
        (0, $2MYHA.L50),
        'Subtle lime'
    ],
    [
        (0, $2MYHA.Y50),
        'Light yellow'
    ],
    [
        (0, $2MYHA.Orange50),
        'Subtle orange'
    ],
    [
        (0, $2MYHA.R50),
        'Light red'
    ],
    [
        (0, $2MYHA.M50),
        'Subtle magenta'
    ],
    [
        (0, $2MYHA.P50),
        'Light purple'
    ],
    [
        (0, $2MYHA.N20),
        'Light gray'
    ],
    [
        (0, $2MYHA.B75),
        'Blue'
    ],
    [
        (0, $2MYHA.T75),
        'Teal'
    ],
    [
        (0, $2MYHA.G75),
        'Green'
    ],
    [
        (0, $2MYHA.L200),
        'Lime'
    ],
    [
        (0, $2MYHA.Y75),
        'Yellow'
    ],
    [
        (0, $2MYHA.Orange200),
        'Orange'
    ],
    [
        (0, $2MYHA.R75),
        'Red'
    ],
    [
        (0, $2MYHA.M200),
        'Magenta'
    ],
    [
        (0, $2MYHA.P75),
        'Purple'
    ],
    [
        (0, $2MYHA.GrayBold),
        'Bold gray'
    ],
    [
        (0, $2MYHA.BlueBold),
        'Bold blue'
    ],
    [
        (0, $2MYHA.TealBold),
        'Bold teal'
    ],
    [
        (0, $2MYHA.GreenBold),
        'Bold green'
    ],
    [
        (0, $2MYHA.L400),
        'Bold lime'
    ],
    [
        (0, $2MYHA.YellowBold),
        'Bold yellow'
    ],
    [
        (0, $2MYHA.Orange400),
        'Bold orange'
    ],
    [
        (0, $2MYHA.RedBold),
        'Bold red'
    ],
    [
        (0, $2MYHA.M400),
        'Bold magenta'
    ],
    [
        (0, $2MYHA.PurpleBold),
        'Bold purple'
    ]
].forEach(([colorValue, colorName])=>{
    $319abdd3da805e3a$export$f26b9114878cba41.set(colorValue.toLowerCase(), colorName);
    $319abdd3da805e3a$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $319abdd3da805e3a$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
const $319abdd3da805e3a$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9RSBE.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $319abdd3da805e3a$var$createTableSpec = ()=>(0, $jobzN.table)($319abdd3da805e3a$var$tableNodeSpecOptions);
const $319abdd3da805e3a$export$9852986a3ec5f6a0 = $319abdd3da805e3a$var$createTableSpec();
const $319abdd3da805e3a$export$90e634fbace1f0c4 = $319abdd3da805e3a$var$createTableSpec();
const $319abdd3da805e3a$export$3862de5c8c9098cf = $319abdd3da805e3a$var$createTableSpec();
const $319abdd3da805e3a$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $319abdd3da805e3a$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$319abdd3da805e3a$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $319abdd3da805e3a$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $319abdd3da805e3a$export$ce666bf02318c957 = (0, $jobzN.tableRow)($319abdd3da805e3a$var$tableRowNodeSpecOptions);
const $319abdd3da805e3a$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
const $319abdd3da805e3a$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$319abdd3da805e3a$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $319abdd3da805e3a$export$363c8dda799bfe9c(node),
            0
        ]
};
const $319abdd3da805e3a$export$e1e720e5f4603e6a = (0, $jobzN.tableCell)($319abdd3da805e3a$var$tableCellNodeSpecOptions);
const $319abdd3da805e3a$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($319abdd3da805e3a$var$cellAttrs[key] && $319abdd3da805e3a$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $319abdd3da805e3a$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $319abdd3da805e3a$export$43977bde391e007(dom, {
                    background: $319abdd3da805e3a$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $319abdd3da805e3a$export$363c8dda799bfe9c(node),
            0
        ]
};
const $319abdd3da805e3a$export$48884d2a5190dc73 = (0, $jobzN.tableHeader)($319abdd3da805e3a$var$tableHeaderNodeSpecOptions);
const $319abdd3da805e3a$export$2af48797a1010bb1 = $319abdd3da805e3a$export$2ac34c099660f1a8;
const $319abdd3da805e3a$export$ce086a560a1d05f5 = (0, $jobzN.tableWithNestedTable)($319abdd3da805e3a$var$tableNodeSpecOptions);
const $319abdd3da805e3a$export$7d657479499397 = (0, $jobzN.tableRowWithNestedTable)($319abdd3da805e3a$var$tableRowNodeSpecOptions);
const $319abdd3da805e3a$export$abf39ca178940ff3 = (0, $jobzN.tableCellWithNestedTable)($319abdd3da805e3a$var$tableCellNodeSpecOptions);
const $319abdd3da805e3a$export$2a5a518232fa1a97 = (0, $jobzN.tableHeaderWithNestedTable)($319abdd3da805e3a$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $319abdd3da805e3a$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
const $319abdd3da805e3a$export$c8f0853ac97552c9 = (0, $jobzN.tableRow)($319abdd3da805e3a$var$tableRowNodeSpecOptionsWithLocalId);
const $319abdd3da805e3a$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $319abdd3da805e3a$export$43977bde391e007(dom, {
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $319abdd3da805e3a$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $319abdd3da805e3a$export$db76cfd28a574029 = (0, $jobzN.tableCell)($319abdd3da805e3a$var$tableCellNodeSpecOptionsWithLocalId);
const $319abdd3da805e3a$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $319abdd3da805e3a$export$43977bde391e007(dom, {
                    background: $319abdd3da805e3a$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $319abdd3da805e3a$export$363c8dda799bfe9c(node),
            0
        ]
};
const $319abdd3da805e3a$export$b82d2b1d8824143d = (0, $jobzN.tableHeader)($319abdd3da805e3a$var$tableHeaderNodeSpecOptionsWithLocalId);
const $319abdd3da805e3a$export$27926e30c8a74147 = (0, $jobzN.tableRowWithNestedTable)($319abdd3da805e3a$var$tableRowNodeSpecOptionsWithLocalId);
const $319abdd3da805e3a$export$e9fd700fafee293a = (0, $jobzN.tableCellWithNestedTable)($319abdd3da805e3a$var$tableCellNodeSpecOptionsWithLocalId);
const $319abdd3da805e3a$export$7928c3aeb4cd2213 = (0, $jobzN.tableHeaderWithNestedTable)($319abdd3da805e3a$var$tableHeaderNodeSpecOptionsWithLocalId);
const $319abdd3da805e3a$export$7ffdb7030e2f2223 = $319abdd3da805e3a$export$db76cfd28a574029;
const $319abdd3da805e3a$export$53c69bb0cddd9750 = $319abdd3da805e3a$export$b82d2b1d8824143d;
const $319abdd3da805e3a$export$10671ff6b5f3bd84 = $319abdd3da805e3a$export$e9fd700fafee293a;
const $319abdd3da805e3a$export$69bdb7ac5d810d92 = $319abdd3da805e3a$export$7928c3aeb4cd2213;

});
parcelRegister("fVLsP", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $f5a8f43c750db06a$export$a270511a0e7fd61a);

var $dpwuL = parcelRequire("dpwuL");
function $f5a8f43c750db06a$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? (0, $dpwuL.editorBackgroundPalette)[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}

});

parcelRegister("7I9XO", function(module, exports) {
$parcel$export(module.exports, "hexToRgba", () => $ff3e3b398de6f458$export$9665a07d9187b414);
// eslint-disable-line import/no-namespace

var $iu0j1 = parcelRequire("iu0j1");
function $ff3e3b398de6f458$export$9665a07d9187b414(rawColor, alpha) {
    const color = (0, $iu0j1.normalizeHexColor)(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}

});
parcelRegister("iu0j1", function(module, exports) {
$parcel$export(module.exports, "normalizeHexColor", () => $e8819969505f60e1$export$b61655071712e690);

var $8AIlM = parcelRequire("8AIlM");

var $iWjRz = parcelRequire("iWjRz");

var $7Gv8k = parcelRequire("7Gv8k");

var $fgUa5 = parcelRequire("fgUa5");
function $e8819969505f60e1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ((0, $iWjRz.isHex)(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ((0, $7Gv8k.isRgb)(color)) return (0, $fgUa5.rgbToHex)(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $8AIlM.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $8AIlM.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $8AIlM.default[color];
        else if ($8AIlM && $8AIlM[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $8AIlM[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}

});
parcelRegister("8AIlM", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});

parcelRegister("iWjRz", function(module, exports) {
$parcel$export(module.exports, "isHex", () => $22d65d7861e7aaeb$export$8a9b6341a7c96bc);
// eslint-disable-line import/no-namespace
const $22d65d7861e7aaeb$var$IS_HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/u;
function $22d65d7861e7aaeb$export$8a9b6341a7c96bc(color) {
    return $22d65d7861e7aaeb$var$IS_HEX_REGEX.test(color);
}

});

parcelRegister("7Gv8k", function(module, exports) {
$parcel$export(module.exports, "isRgb", () => $8b0cee853fa314dd$export$e698776ec826343);
// eslint-disable-line import/no-namespace
const $8b0cee853fa314dd$var$IS_RGB_REGEX = /rgba?\(/u;
function $8b0cee853fa314dd$export$e698776ec826343(color) {
    return $8b0cee853fa314dd$var$IS_RGB_REGEX.test(color);
}

});




parcelRegister("8olal", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $a6bc8d32074631f6$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $a6bc8d32074631f6$export$375b6afcc5f4d291);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $a6bc8d32074631f6$var$name = 'actionList';
const $a6bc8d32074631f6$export$c0ec71adb7a18fb2 = `[data-node-type="${$a6bc8d32074631f6$var$name}"]`;
const $a6bc8d32074631f6$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$a6bc8d32074631f6$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9RSBE.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $a6bc8d32074631f6$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $a6bc8d32074631f6$export$375b6afcc5f4d291 = (0, $jobzN.taskList)($a6bc8d32074631f6$var$taskListParseDOMAndToDOM);

});

parcelRegister("eCc5B", function(module, exports) {
$parcel$export(module.exports, "text", () => $94ebecc1b2119335$export$6f093cfa640b7166);

var $jobzN = parcelRequire("jobzN");
const $94ebecc1b2119335$export$6f093cfa640b7166 = (0, $jobzN.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("i6pjC", function(module, exports) {
$parcel$export(module.exports, "default", () => $db23f245a408f4aa$export$2e2bcd8739ae039);
const $db23f245a408f4aa$var$name = 'unknownBlock';
const $db23f245a408f4aa$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $db23f245a408f4aa$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type=\"${$db23f245a408f4aa$var$name}\"]`
        }
    ]
};

});

parcelRegister("d5USw", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $f12d922b95ca1b20$export$44b79b0979d0f0f7);

var $jobzN = parcelRequire("jobzN");
const $f12d922b95ca1b20$export$44b79b0979d0f0f7 = (0, $jobzN.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("bkrsJ", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $e34e994dfc58431c$export$310ebe0d80122e9b);

var $jobzN = parcelRequire("jobzN");
const $e34e994dfc58431c$export$310ebe0d80122e9b = (0, $jobzN.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("au7g7", function(module, exports) {
$parcel$export(module.exports, "bodiedRule", () => $8b8466b67279316b$export$2069efcbff2f0292);
$parcel$export(module.exports, "bodiedRuleRootOnlyStage0", () => $8b8466b67279316b$export$208411233915368e);

var $jobzN = parcelRequire("jobzN");

var $9RSBE = parcelRequire("9RSBE");
const $8b8466b67279316b$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        alignment: dom.getAttribute('data-alignment') || undefined,
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || (0, $9RSBE.uuid).generate(),
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $8b8466b67279316b$export$2069efcbff2f0292 = (0, $jobzN.bodiedRuleStage0)({
    parseDOM: [
        {
            tag: 'div[data-node-type="bodied-rule"]',
            getAttrs: $8b8466b67279316b$var$getAttrs
        }
    ],
    toDOM (node) {
        const { alignment: alignment, color: color, localId: localId, style: style, weight: weight } = node.attrs;
        return [
            'div',
            {
                'data-node-type': 'bodied-rule',
                'data-alignment': alignment || undefined,
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined
            },
            0
        ];
    }
});
const $8b8466b67279316b$export$208411233915368e = {
    ...$8b8466b67279316b$export$2069efcbff2f0292,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};

});


parcelRegister("jiH53", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $083d93cac9660012$export$daf54fed04c8fb77);
function $083d93cac9660012$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $083d93cac9660012$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $083d93cac9660012$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = Array.from(new Set(contentKeys.filter((contentKey)=>!$083d93cac9660012$var$isContentSupported(nodes, contentKey)))).sort((a, b)=>b.length - a.length);
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$083d93cac9660012$var$sanitizedContent(newContent, nodeName), rawContent);
}
const $083d93cac9660012$var$WORD_CHAR_REGEX = /\w/u;
function $083d93cac9660012$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($083d93cac9660012$var$WORD_CHAR_REGEX)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $083d93cac9660012$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});


parcelRegister("qCqw4", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1RootOnlyStage0", () => $9a0076bd108da952$export$9ef8544aba133962);

var $2VV1e = parcelRequire("2VV1e");
const $9a0076bd108da952$export$9ef8544aba133962 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $2VV1e.extendedPanelC1WithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};

});
parcelRegister("2VV1e", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => $fb237931a26b40e3$export$9c65e35ecb68f683);

var $jobzN = parcelRequire("jobzN");

var $jRylO = parcelRequire("jRylO");
const $fb237931a26b40e3$export$9c65e35ecb68f683 = (allowCustomPanel)=>(0, $jobzN.panelC1Stage0)((0, $jRylO.createPanelNodeSpecOptions)(allowCustomPanel, true));

});


parcelRegister("fpk0y", function(module, exports) {
$parcel$export(module.exports, "extendedPanelRootOnlyStage0", () => $2fc15d064bf1bad0$export$71123ea8f73a7fb);

var $pScEb = parcelRequire("pScEb");
const $2fc15d064bf1bad0$export$71123ea8f73a7fb = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $pScEb.extendedPanelWithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};

});
parcelRegister("pScEb", function(module, exports) {
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $371bf14d3f5de5dd$export$855c3c67c9c9ebaf);

var $jobzN = parcelRequire("jobzN");

var $jRylO = parcelRequire("jRylO");
const $371bf14d3f5de5dd$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $jobzN.panel)((0, $jRylO.createPanelNodeSpecOptions)(allowCustomPanel, true));

});



parcelRegister("d8oKL", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $48eb5b2b0395fe13$export$48b382180baf8e88);

var $dbYc1 = parcelRequire("dbYc1");

var $hMBe3 = parcelRequire("hMBe3");

var $hi8iS = parcelRequire("hi8iS");

var $3IKHs = parcelRequire("3IKHs");
const $48eb5b2b0395fe13$var$hasNestedTable = (tableCellNode)=>{
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some((node)=>(node === null || node === void 0 ? void 0 : node.type) === 'table');
};
function $48eb5b2b0395fe13$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $hMBe3.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $3IKHs.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($48eb5b2b0395fe13$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $dbYc1.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($48eb5b2b0395fe13$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $dbYc1.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: (node)=>({
                ...node,
                type: 'panel'
            }),
        emoji: (0, $3IKHs.removeNonAnnotationMarks),
        mention: (0, $3IKHs.removeNonAnnotationMarks),
        date: (0, $3IKHs.removeNonAnnotationMarks),
        hardBreak: (0, $hi8iS.removeMarks),
        inlineCard: (0, $3IKHs.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("dbYc1", function(module, exports) {
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $400738f7cba01421$export$8a334a7d9fe120ec);

var $bMaNz = parcelRequire("bMaNz");

var $iDpw9 = parcelRequire("iDpw9");

var $eyU74 = parcelRequire("eyU74");
const $400738f7cba01421$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        var _tableCellNode$conten;
        return {
            ...tableCellNode,
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map((childNode)=>{
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $bMaNz.extension)({
                    extensionType: (0, $eyU74.NESTED_TABLE_EXTENSION_TYPE),
                    extensionKey: (0, $eyU74.NESTED_TABLE_EXTENSION_KEY),
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $iDpw9.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("bMaNz", function(module, exports) {
$parcel$export(module.exports, "extension", () => $6cb95986cae831d6$export$1b45514b112dd749);
const $6cb95986cae831d6$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("iDpw9", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $61b7cdf4983c6b31$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $61b7cdf4983c6b31$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});

parcelRegister("eyU74", function(module, exports) {
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_TYPE", () => $feb2cb3d3c7dd211$export$3b760d14ce8127a2);
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_KEY", () => $feb2cb3d3c7dd211$export$f45f8b42c24922c1);



var $dbYc1 = parcelRequire("dbYc1");
const $feb2cb3d3c7dd211$export$3b760d14ce8127a2 = 'com.atlassian.confluence.migration', $feb2cb3d3c7dd211$export$f45f8b42c24922c1 = 'nested-table';

});


parcelRegister("hi8iS", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $d2a17c4f9d0a1d98$export$9bf001d8ef76e497);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ function $d2a17c4f9d0a1d98$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}

});

parcelRegister("3IKHs", function(module, exports) {
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $33aa4c0f124160b2$export$8cae9126fc577085);
function $33aa4c0f124160b2$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});


parcelRegister("18ahg", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $94d3302a6be0e827$export$54fd2c36b5cc6731);

var $k7YRz = parcelRequire("k7YRz");

var $9nikD = parcelRequire("9nikD");

var $j5dhp = parcelRequire("j5dhp");

var $8xR7M = parcelRequire("8xR7M");

var $hxwpr = parcelRequire("hxwpr");

var $8nTzm = parcelRequire("8nTzm");

var $c8L22 = parcelRequire("c8L22");

var $6w3E6 = parcelRequire("6w3E6");

var $1KOd3 = parcelRequire("1KOd3");

var $fsq3b = parcelRequire("fsq3b");
const $94d3302a6be0e827$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $94d3302a6be0e827$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $94d3302a6be0e827$var$isCodeBlock = $94d3302a6be0e827$var$isType('codeBlock');
const $94d3302a6be0e827$var$isMediaNode = $94d3302a6be0e827$var$isType('media');
const $94d3302a6be0e827$var$isMediaInline = $94d3302a6be0e827$var$isType('mediaInline');
const $94d3302a6be0e827$var$isMediaSingleNode = $94d3302a6be0e827$var$isType('mediaSingle');
const $94d3302a6be0e827$var$isMentionNode = $94d3302a6be0e827$var$isType('mention');
const $94d3302a6be0e827$var$isParagraph = $94d3302a6be0e827$var$isType('paragraph');
const $94d3302a6be0e827$var$isHeading = $94d3302a6be0e827$var$isType('heading');
const $94d3302a6be0e827$var$isTable = $94d3302a6be0e827$var$isType('table');
const $94d3302a6be0e827$var$isTableCell = $94d3302a6be0e827$var$isType('tableCell');
const $94d3302a6be0e827$var$isTableHeader = $94d3302a6be0e827$var$isType('tableHeader');
const $94d3302a6be0e827$var$isLinkMark = $94d3302a6be0e827$var$isType('link');
const $94d3302a6be0e827$var$isUnsupportedMark = $94d3302a6be0e827$var$isType('unsupportedMark');
const $94d3302a6be0e827$var$isUnsupportedNodeAttributeMark = $94d3302a6be0e827$var$isType('unsupportedNodeAttribute');
const $94d3302a6be0e827$var$isExpand = $94d3302a6be0e827$var$isType('expand');
const $94d3302a6be0e827$var$isNestedExpand = $94d3302a6be0e827$var$isType('nestedExpand');
const $94d3302a6be0e827$var$isExtensionNode = $94d3302a6be0e827$var$isType('extension');
const $94d3302a6be0e827$var$isUnsupportedNode = (node)=>$94d3302a6be0e827$var$isType('unsupportedBlock')(node) || $94d3302a6be0e827$var$isType('unsupportedInline')(node);
const $94d3302a6be0e827$var$isDataConsumer = $94d3302a6be0e827$var$isType('dataConsumer');
const $94d3302a6be0e827$var$isFragmentMark = $94d3302a6be0e827$var$isType('fragment');
const $94d3302a6be0e827$var$isAnnotationMark = $94d3302a6be0e827$var$isType('annotation');
const $94d3302a6be0e827$var$isAllowedNodeForAnnotation = (node)=>!node.type.isBlock || $94d3302a6be0e827$var$isMediaNode(node) || $94d3302a6be0e827$var$isExtensionNode(node);
const $94d3302a6be0e827$var$isHardBreak = $94d3302a6be0e827$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $94d3302a6be0e827$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $94d3302a6be0e827$var$filterNull(current);
    }
    return output;
};
const $94d3302a6be0e827$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fsq3b.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $94d3302a6be0e827$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
const $94d3302a6be0e827$export$54fd2c36b5cc6731 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($94d3302a6be0e827$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($94d3302a6be0e827$var$isMediaNode(node)) obj.attrs = (0, $1KOd3.toJSON)(node).attrs;
    else if ($94d3302a6be0e827$var$isMediaSingleNode(node)) obj.attrs = (0, $6w3E6.toJSON)(node).attrs;
    else if ($94d3302a6be0e827$var$isMediaInline(node)) obj.attrs = (0, $1KOd3.toJSON)(node).attrs;
    else if ($94d3302a6be0e827$var$isMentionNode(node)) obj.attrs = (0, $8nTzm.toJSON)(node).attrs;
    else if ($94d3302a6be0e827$var$isCodeBlock(node)) obj.attrs = (0, $9nikD.toJSON)(node).attrs;
    else if ($94d3302a6be0e827$var$isTable(node)) obj.attrs = (0, $c8L22.tableToJSON)(node).attrs;
    else if ($94d3302a6be0e827$var$isTableCell(node)) obj.attrs = (0, $c8L22.toJSONTableCell)(node).attrs;
    else if ($94d3302a6be0e827$var$isTableHeader(node)) obj.attrs = (0, $c8L22.toJSONTableHeader)(node).attrs;
    else if ($94d3302a6be0e827$var$isExpand(node) || $94d3302a6be0e827$var$isNestedExpand(node)) obj.attrs = (0, $8xR7M.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $94d3302a6be0e827$var$filterNull(obj.attrs);
    if ($94d3302a6be0e827$var$isMentionNode(node) && mentionMap) {
        var _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = ((_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($94d3302a6be0e827$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $94d3302a6be0e827$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($94d3302a6be0e827$export$54fd2c36b5cc6731(child, mentionMap));
    });
    if ($94d3302a6be0e827$var$isParagraph(node) || $94d3302a6be0e827$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($94d3302a6be0e827$var$isAnnotationMark(mark) && !$94d3302a6be0e827$var$isAllowedNodeForAnnotation(node)) return null;
            else if ($94d3302a6be0e827$var$isUnsupportedMark(mark)) return $94d3302a6be0e827$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($94d3302a6be0e827$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($94d3302a6be0e827$var$isLinkMark(mark)) return (0, $k7YRz.toJSON)(mark);
            else if ($94d3302a6be0e827$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                const serialised = (0, $j5dhp.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($94d3302a6be0e827$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $hxwpr.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($94d3302a6be0e827$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$94d3302a6be0e827$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};

});
parcelRegister("k7YRz", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $3c42356bbefbf7c2$export$54fd2c36b5cc6731);
const $3c42356bbefbf7c2$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $3c42356bbefbf7c2$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($3c42356bbefbf7c2$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});

parcelRegister("6w3E6", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $7e116bd736d5b42e$export$54fd2c36b5cc6731);
const $7e116bd736d5b42e$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("1KOd3", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $a397833210880e93$export$54fd2c36b5cc6731);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $a397833210880e93$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $a397833210880e93$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $a397833210880e93$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $a397833210880e93$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($a397833210880e93$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("fsq3b", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $a19274784758b2ca$export$28e4e3c024cce988);
const $a19274784758b2ca$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $a19274784758b2ca$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $a19274784758b2ca$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $a19274784758b2ca$var$defaultAllowOverrideBehaviour;
        default:
            return $a19274784758b2ca$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});



parcelRegister("cw0wu", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $91c8e1091830ff10$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $91c8e1091830ff10$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $91c8e1091830ff10$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $91c8e1091830ff10$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $91c8e1091830ff10$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $91c8e1091830ff10$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $91c8e1091830ff10$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $91c8e1091830ff10$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $91c8e1091830ff10$export$1692d8b0e89cecc3);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
const $91c8e1091830ff10$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $91c8e1091830ff10$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $91c8e1091830ff10$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $kW8qW.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kW8qW.Slice).empty : content);
            if (i == 0) $91c8e1091830ff10$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $91c8e1091830ff10$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $91c8e1091830ff10$export$c2b25f346d19bcbb($pos) : $91c8e1091830ff10$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $91c8e1091830ff10$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $91c8e1091830ff10$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $91c8e1091830ff10$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $91c8e1091830ff10$var$findSelectionIn(doc, doc, 0, 0, 1) || new $91c8e1091830ff10$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $91c8e1091830ff10$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $91c8e1091830ff10$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $91c8e1091830ff10$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $91c8e1091830ff10$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $91c8e1091830ff10$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $91c8e1091830ff10$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$91c8e1091830ff10$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $91c8e1091830ff10$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $91c8e1091830ff10$var$warnedAboutTextSelection = false;
function $91c8e1091830ff10$var$checkTextSelection($pos) {
    if (!$91c8e1091830ff10$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $91c8e1091830ff10$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $91c8e1091830ff10$export$c2b25f346d19bcbb extends $91c8e1091830ff10$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $91c8e1091830ff10$var$checkTextSelection($anchor);
        $91c8e1091830ff10$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $91c8e1091830ff10$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $91c8e1091830ff10$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $kW8qW.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $kW8qW.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $91c8e1091830ff10$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $91c8e1091830ff10$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $91c8e1091830ff10$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $91c8e1091830ff10$export$52baac22726c72bf.findFrom($head, bias, true) || $91c8e1091830ff10$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $91c8e1091830ff10$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($91c8e1091830ff10$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $91c8e1091830ff10$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $91c8e1091830ff10$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$91c8e1091830ff10$export$52baac22726c72bf.jsonID("text", $91c8e1091830ff10$export$c2b25f346d19bcbb);
class $91c8e1091830ff10$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $91c8e1091830ff10$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $91c8e1091830ff10$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $91c8e1091830ff10$export$e2940151ac854c0b extends $91c8e1091830ff10$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $91c8e1091830ff10$export$52baac22726c72bf.near($pos);
        return new $91c8e1091830ff10$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $91c8e1091830ff10$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $91c8e1091830ff10$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $91c8e1091830ff10$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $91c8e1091830ff10$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$91c8e1091830ff10$export$e2940151ac854c0b.prototype.visible = false;
$91c8e1091830ff10$export$52baac22726c72bf.jsonID("node", $91c8e1091830ff10$export$e2940151ac854c0b);
class $91c8e1091830ff10$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $91c8e1091830ff10$var$TextBookmark(pos, pos) : new $91c8e1091830ff10$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $91c8e1091830ff10$export$e2940151ac854c0b.isSelectable(node)) return new $91c8e1091830ff10$export$e2940151ac854c0b($pos);
        return $91c8e1091830ff10$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $91c8e1091830ff10$export$c15d9ba76bdbcd95 extends $91c8e1091830ff10$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $kW8qW.Slice).empty) {
        if (content == (0, $kW8qW.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $91c8e1091830ff10$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $91c8e1091830ff10$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $91c8e1091830ff10$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $91c8e1091830ff10$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $91c8e1091830ff10$var$AllBookmark;
    }
}
$91c8e1091830ff10$export$52baac22726c72bf.jsonID("all", $91c8e1091830ff10$export$c15d9ba76bdbcd95);
const $91c8e1091830ff10$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $91c8e1091830ff10$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $91c8e1091830ff10$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $91c8e1091830ff10$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $91c8e1091830ff10$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $91c8e1091830ff10$export$e2940151ac854c0b.isSelectable(child)) return $91c8e1091830ff10$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $91c8e1091830ff10$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($91c8e1091830ff10$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $91c8e1091830ff10$var$UPDATED_SEL = 1, $91c8e1091830ff10$var$UPDATED_MARKS = 2, $91c8e1091830ff10$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $91c8e1091830ff10$export$febc5573c75cefb0 extends (0, $3DNV7.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $91c8e1091830ff10$var$UPDATED_SEL) & ~$91c8e1091830ff10$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $91c8e1091830ff10$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $91c8e1091830ff10$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $kW8qW.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $91c8e1091830ff10$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$91c8e1091830ff10$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $kW8qW.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($91c8e1091830ff10$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $91c8e1091830ff10$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $91c8e1091830ff10$var$UPDATED_SCROLL) > 0;
    }
}
function $91c8e1091830ff10$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $91c8e1091830ff10$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $91c8e1091830ff10$var$bind(desc.init, self);
        this.apply = $91c8e1091830ff10$var$bind(desc.apply, self);
    }
}
const $91c8e1091830ff10$var$baseFields = [
    new $91c8e1091830ff10$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $91c8e1091830ff10$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $91c8e1091830ff10$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $91c8e1091830ff10$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $91c8e1091830ff10$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $91c8e1091830ff10$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $91c8e1091830ff10$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $91c8e1091830ff10$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $91c8e1091830ff10$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $91c8e1091830ff10$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $91c8e1091830ff10$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $91c8e1091830ff10$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $91c8e1091830ff10$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $91c8e1091830ff10$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $91c8e1091830ff10$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $91c8e1091830ff10$var$Configuration(config.schema, config.plugins);
        let instance = new $91c8e1091830ff10$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $kW8qW.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $91c8e1091830ff10$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $91c8e1091830ff10$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $91c8e1091830ff10$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $91c8e1091830ff10$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $91c8e1091830ff10$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $91c8e1091830ff10$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $91c8e1091830ff10$var$keys = Object.create(null);
function $91c8e1091830ff10$var$createKey(name) {
    if (name in $91c8e1091830ff10$var$keys) return name + "$" + ++$91c8e1091830ff10$var$keys[name];
    $91c8e1091830ff10$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $91c8e1091830ff10$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $91c8e1091830ff10$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("3DNV7", function(module, exports) {
$parcel$export(module.exports, "StepMap", () => $2a6bbcba7098dd78$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $2a6bbcba7098dd78$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $2a6bbcba7098dd78$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $2a6bbcba7098dd78$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $2a6bbcba7098dd78$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $2a6bbcba7098dd78$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $2a6bbcba7098dd78$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $2a6bbcba7098dd78$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $2a6bbcba7098dd78$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $2a6bbcba7098dd78$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $2a6bbcba7098dd78$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $2a6bbcba7098dd78$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $2a6bbcba7098dd78$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $2a6bbcba7098dd78$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $2a6bbcba7098dd78$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $2a6bbcba7098dd78$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $2a6bbcba7098dd78$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $2a6bbcba7098dd78$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $2a6bbcba7098dd78$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $2a6bbcba7098dd78$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $2a6bbcba7098dd78$export$563a914cafbdc389);

var $kW8qW = parcelRequire("kW8qW");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $2a6bbcba7098dd78$var$lower16 = 0xffff;
const $2a6bbcba7098dd78$var$factor16 = Math.pow(2, 16);
function $2a6bbcba7098dd78$var$makeRecover(index, offset) {
    return index + offset * $2a6bbcba7098dd78$var$factor16;
}
function $2a6bbcba7098dd78$var$recoverIndex(value) {
    return value & $2a6bbcba7098dd78$var$lower16;
}
function $2a6bbcba7098dd78$var$recoverOffset(value) {
    return (value - (value & $2a6bbcba7098dd78$var$lower16)) / $2a6bbcba7098dd78$var$factor16;
}
const $2a6bbcba7098dd78$var$DEL_BEFORE = 1, $2a6bbcba7098dd78$var$DEL_AFTER = 2, $2a6bbcba7098dd78$var$DEL_ACROSS = 4, $2a6bbcba7098dd78$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $2a6bbcba7098dd78$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $2a6bbcba7098dd78$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($2a6bbcba7098dd78$var$DEL_BEFORE | $2a6bbcba7098dd78$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($2a6bbcba7098dd78$var$DEL_AFTER | $2a6bbcba7098dd78$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $2a6bbcba7098dd78$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $2a6bbcba7098dd78$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty) return $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $2a6bbcba7098dd78$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $2a6bbcba7098dd78$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $2a6bbcba7098dd78$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $2a6bbcba7098dd78$var$DEL_AFTER : pos == end ? $2a6bbcba7098dd78$var$DEL_BEFORE : $2a6bbcba7098dd78$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $2a6bbcba7098dd78$var$DEL_SIDE;
                return new $2a6bbcba7098dd78$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $2a6bbcba7098dd78$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $2a6bbcba7098dd78$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $2a6bbcba7098dd78$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty : new $2a6bbcba7098dd78$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty = new $2a6bbcba7098dd78$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $2a6bbcba7098dd78$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $2a6bbcba7098dd78$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $2a6bbcba7098dd78$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $2a6bbcba7098dd78$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $2a6bbcba7098dd78$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $2a6bbcba7098dd78$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $2a6bbcba7098dd78$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $2a6bbcba7098dd78$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $2a6bbcba7098dd78$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $2a6bbcba7098dd78$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $2a6bbcba7098dd78$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $2a6bbcba7098dd78$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $2a6bbcba7098dd78$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $kW8qW.ReplaceError)) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $2a6bbcba7098dd78$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($2a6bbcba7098dd78$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $kW8qW.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $2a6bbcba7098dd78$export$d24ba56b0e3464a9 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $2a6bbcba7098dd78$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $2a6bbcba7098dd78$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $2a6bbcba7098dd78$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $2a6bbcba7098dd78$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $2a6bbcba7098dd78$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("addMark", $2a6bbcba7098dd78$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $2a6bbcba7098dd78$export$94150db1311f67a9 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $2a6bbcba7098dd78$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $2a6bbcba7098dd78$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $2a6bbcba7098dd78$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $2a6bbcba7098dd78$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $2a6bbcba7098dd78$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("removeMark", $2a6bbcba7098dd78$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $2a6bbcba7098dd78$export$adefd16c402fee4e extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $2a6bbcba7098dd78$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $2a6bbcba7098dd78$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $2a6bbcba7098dd78$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $2a6bbcba7098dd78$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $2a6bbcba7098dd78$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("addNodeMark", $2a6bbcba7098dd78$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $2a6bbcba7098dd78$export$fdf7d1dc10724da2 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $2a6bbcba7098dd78$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $2a6bbcba7098dd78$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $2a6bbcba7098dd78$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("removeNodeMark", $2a6bbcba7098dd78$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $2a6bbcba7098dd78$export$5c860b2e74034756 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $2a6bbcba7098dd78$var$contentBetween(doc, this.from, this.to)) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $2a6bbcba7098dd78$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $2a6bbcba7098dd78$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $2a6bbcba7098dd78$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $2a6bbcba7098dd78$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kW8qW.Slice).empty : new (0, $kW8qW.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $2a6bbcba7098dd78$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kW8qW.Slice).empty : new (0, $kW8qW.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $2a6bbcba7098dd78$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $2a6bbcba7098dd78$export$5c860b2e74034756(json.from, json.to, (0, $kW8qW.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("replace", $2a6bbcba7098dd78$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $2a6bbcba7098dd78$export$444ba800d6024a98 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($2a6bbcba7098dd78$var$contentBetween(doc, this.from, this.gapFrom) || $2a6bbcba7098dd78$var$contentBetween(doc, this.gapTo, this.to))) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $2a6bbcba7098dd78$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $2a6bbcba7098dd78$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $2a6bbcba7098dd78$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $2a6bbcba7098dd78$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $kW8qW.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("replaceAround", $2a6bbcba7098dd78$export$444ba800d6024a98);
function $2a6bbcba7098dd78$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $2a6bbcba7098dd78$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $2a6bbcba7098dd78$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $2a6bbcba7098dd78$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $2a6bbcba7098dd78$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $kW8qW.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $2a6bbcba7098dd78$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $2a6bbcba7098dd78$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $2a6bbcba7098dd78$export$5c860b2e74034756(cur, end, (0, $kW8qW.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $2a6bbcba7098dd78$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $2a6bbcba7098dd78$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $kW8qW.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $kW8qW.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $2a6bbcba7098dd78$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $2a6bbcba7098dd78$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$2a6bbcba7098dd78$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $2a6bbcba7098dd78$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $kW8qW.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $kW8qW.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $kW8qW.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $kW8qW.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $2a6bbcba7098dd78$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $kW8qW.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $2a6bbcba7098dd78$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $2a6bbcba7098dd78$var$findWrappingOutside(range, nodeType);
    let inner = around && $2a6bbcba7098dd78$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($2a6bbcba7098dd78$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($2a6bbcba7098dd78$var$withAttrs));
}
function $2a6bbcba7098dd78$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $2a6bbcba7098dd78$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $2a6bbcba7098dd78$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $2a6bbcba7098dd78$var$wrap(tr, range, wrappers) {
    let content = (0, $kW8qW.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $kW8qW.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $2a6bbcba7098dd78$export$444ba800d6024a98(start, end, start, end, new (0, $kW8qW.Slice)(content, 0, 0), wrappers.length, true));
}
function $2a6bbcba7098dd78$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $2a6bbcba7098dd78$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $2a6bbcba7098dd78$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $2a6bbcba7098dd78$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $2a6bbcba7098dd78$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $2a6bbcba7098dd78$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $2a6bbcba7098dd78$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $2a6bbcba7098dd78$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $2a6bbcba7098dd78$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $2a6bbcba7098dd78$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $2a6bbcba7098dd78$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $2a6bbcba7098dd78$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $2a6bbcba7098dd78$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $kW8qW.Fragment).empty, after = (0, $kW8qW.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $kW8qW.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $kW8qW.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $2a6bbcba7098dd78$export$5c860b2e74034756(pos, pos, new (0, $kW8qW.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $2a6bbcba7098dd78$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $2a6bbcba7098dd78$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $2a6bbcba7098dd78$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $2a6bbcba7098dd78$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $2a6bbcba7098dd78$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $2a6bbcba7098dd78$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $2a6bbcba7098dd78$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $2a6bbcba7098dd78$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $2a6bbcba7098dd78$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $2a6bbcba7098dd78$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $2a6bbcba7098dd78$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $kW8qW.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $2a6bbcba7098dd78$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $2a6bbcba7098dd78$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $2a6bbcba7098dd78$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $2a6bbcba7098dd78$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $kW8qW.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($2a6bbcba7098dd78$var$fitsTrivially($from, $to, slice)) return new $2a6bbcba7098dd78$export$5c860b2e74034756(from, to, slice);
    return new $2a6bbcba7098dd78$var$Fitter($from, $to, slice).fit();
}
function $2a6bbcba7098dd78$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $2a6bbcba7098dd78$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $kW8qW.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $kW8qW.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $kW8qW.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $2a6bbcba7098dd78$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $2a6bbcba7098dd78$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $2a6bbcba7098dd78$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $kW8qW.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $2a6bbcba7098dd78$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $kW8qW.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $2a6bbcba7098dd78$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($2a6bbcba7098dd78$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $2a6bbcba7098dd78$var$addToFragment(this.placed, frontierDepth, (0, $kW8qW.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $kW8qW.Slice).empty : new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$2a6bbcba7098dd78$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $2a6bbcba7098dd78$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $2a6bbcba7098dd78$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $2a6bbcba7098dd78$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $2a6bbcba7098dd78$var$addToFragment(this.placed, this.depth, (0, $kW8qW.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $kW8qW.Fragment).empty, true);
        if (add.childCount) this.placed = $2a6bbcba7098dd78$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $2a6bbcba7098dd78$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($2a6bbcba7098dd78$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $2a6bbcba7098dd78$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($2a6bbcba7098dd78$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $2a6bbcba7098dd78$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $2a6bbcba7098dd78$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $2a6bbcba7098dd78$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $kW8qW.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $2a6bbcba7098dd78$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$2a6bbcba7098dd78$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $2a6bbcba7098dd78$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $2a6bbcba7098dd78$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $2a6bbcba7098dd78$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($2a6bbcba7098dd78$var$fitsTrivially($from, $to, slice)) return tr.step(new $2a6bbcba7098dd78$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $2a6bbcba7098dd78$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $2a6bbcba7098dd78$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $kW8qW.Slice)($2a6bbcba7098dd78$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $2a6bbcba7098dd78$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($2a6bbcba7098dd78$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $kW8qW.Fragment).empty, true));
    }
    return fragment;
}
function $2a6bbcba7098dd78$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $2a6bbcba7098dd78$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(node), 0, 0));
}
function $2a6bbcba7098dd78$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $2a6bbcba7098dd78$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $2a6bbcba7098dd78$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $2a6bbcba7098dd78$export$626399c38172f669 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $2a6bbcba7098dd78$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $2a6bbcba7098dd78$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $2a6bbcba7098dd78$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("attr", $2a6bbcba7098dd78$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $2a6bbcba7098dd78$export$f50707b396300ac9 extends $2a6bbcba7098dd78$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $2a6bbcba7098dd78$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $2a6bbcba7098dd78$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $2a6bbcba7098dd78$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $2a6bbcba7098dd78$export$f50707b396300ac9(json.attr, json.value);
    }
}
$2a6bbcba7098dd78$export$fd55ce593607084a.jsonID("docAttr", $2a6bbcba7098dd78$export$f50707b396300ac9);
/**
@internal
*/ let $2a6bbcba7098dd78$export$88cc3a1dfce48dd3 = class extends Error {
};
$2a6bbcba7098dd78$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$2a6bbcba7098dd78$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$2a6bbcba7098dd78$export$88cc3a1dfce48dd3.prototype.constructor = $2a6bbcba7098dd78$export$88cc3a1dfce48dd3;
$2a6bbcba7098dd78$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $2a6bbcba7098dd78$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $2a6bbcba7098dd78$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $2a6bbcba7098dd78$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $kW8qW.Slice).empty) {
        let step = $2a6bbcba7098dd78$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $kW8qW.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $2a6bbcba7098dd78$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $2a6bbcba7098dd78$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $2a6bbcba7098dd78$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $2a6bbcba7098dd78$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $2a6bbcba7098dd78$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $2a6bbcba7098dd78$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $2a6bbcba7098dd78$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $2a6bbcba7098dd78$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $2a6bbcba7098dd78$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $2a6bbcba7098dd78$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $2a6bbcba7098dd78$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $kW8qW.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $2a6bbcba7098dd78$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $2a6bbcba7098dd78$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $2a6bbcba7098dd78$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $2a6bbcba7098dd78$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $2a6bbcba7098dd78$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("ah11j", function(module, exports) {
$parcel$export(module.exports, "getStartPos", () => $18d44303c09b950e$export$aabc9b13a308cc43);
$parcel$export(module.exports, "findParent", () => $18d44303c09b950e$export$25245567f53f158f);
$parcel$export(module.exports, "getPosFromRange", () => $18d44303c09b950e$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $18d44303c09b950e$export$74899f7e5acb5cd3);
/* eslint-disable jsdoc/require-jsdoc -- internal step helpers */ 
var $3DNV7 = parcelRequire("3DNV7");

var $gdUUy = parcelRequire("gdUUy");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $18d44303c09b950e$var$MEDIA_OR_MEDIA_SINGLE_REGEX = /media|mediaSingle/;
function $18d44303c09b950e$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $18d44303c09b950e$var$getNodeType = (element)=>element.dataset.nodeType;
function $18d44303c09b950e$var$isPositionPointer(element) {
    return $18d44303c09b950e$export$aabc9b13a308cc43(element) > -1;
}
function $18d44303c09b950e$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $18d44303c09b950e$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($18d44303c09b950e$var$isPositionPointer(parentElement)) return parentElement;
    return $18d44303c09b950e$export$25245567f53f158f(parentElement);
}
function $18d44303c09b950e$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $18d44303c09b950e$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $18d44303c09b950e$var$findMediaParent(parentElement);
}
function $18d44303c09b950e$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($18d44303c09b950e$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($18d44303c09b950e$var$isPositionPointer(parentElement)) return element;
    return $18d44303c09b950e$var$findParentBeforePointer(parentElement);
}
function $18d44303c09b950e$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $18d44303c09b950e$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $18d44303c09b950e$var$isHighlightTextNode(node) {
    var _dataset;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $18d44303c09b950e$var$isNodeInlineMark(node) {
    return $18d44303c09b950e$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $18d44303c09b950e$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $18d44303c09b950e$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $18d44303c09b950e$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($18d44303c09b950e$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $18d44303c09b950e$var$hasInlineNodeDescendant(node) {
    if ($18d44303c09b950e$var$isElementNode(node)) {
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($18d44303c09b950e$var$hasInlineNodeDescendant);
    }
    return false;
}
function $18d44303c09b950e$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($18d44303c09b950e$var$isTextNode(prev) || $18d44303c09b950e$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($18d44303c09b950e$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($18d44303c09b950e$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $18d44303c09b950e$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $18d44303c09b950e$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
        var _node$parentElement;
        const startPosAncestor = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('[data-renderer-start-pos');
        const potentialParent = (0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor !== null && startPosAncestor !== void 0 && startPosAncestor.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10) + 1;
            else return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $18d44303c09b950e$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $18d44303c09b950e$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++){
                var _children$i;
                count += ((_children$i = children[i]) === null || _children$i === void 0 || (_children$i = _children$i.textContent) === null || _children$i === void 0 ? void 0 : _children$i.length) || 1;
            }
            return count;
        }
        return $18d44303c09b950e$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $18d44303c09b950e$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $18d44303c09b950e$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $18d44303c09b950e$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($18d44303c09b950e$var$isNodeInlineTextMark(preParentPointer) || $18d44303c09b950e$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($18d44303c09b950e$var$isElementInlineMark(preParentPointer) || $18d44303c09b950e$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $18d44303c09b950e$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $18d44303c09b950e$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $18d44303c09b950e$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $18d44303c09b950e$var$getSelectedCommentTargetPosition(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    if (startContainer !== endContainer || endOffset !== startOffset + 1) return false;
    const selectedNode = startContainer.childNodes[startOffset];
    if (!selectedNode || !$18d44303c09b950e$var$isElementNode(selectedNode) || selectedNode.dataset.inlineCommentsTarget !== 'true' || !$18d44303c09b950e$var$isPositionPointer(selectedNode)) return false;
    // Subtract 1 from the renderer start position to get the position before the extension node.
    return $18d44303c09b950e$export$aabc9b13a308cc43(selectedNode) - 1;
}
function $18d44303c09b950e$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const selectedCommentTargetPosition = (0, $gdUUy.fg)('cc_maui_annotations_on_extensions') && $18d44303c09b950e$var$getSelectedCommentTargetPosition(range);
    if (selectedCommentTargetPosition !== false) return {
        from: selectedCommentTargetPosition,
        to: selectedCommentTargetPosition
    };
    const possibleMediaOrMediaSingleElement = $18d44303c09b950e$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && $18d44303c09b950e$var$MEDIA_OR_MEDIA_SINGLE_REGEX.test($18d44303c09b950e$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $18d44303c09b950e$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $18d44303c09b950e$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $18d44303c09b950e$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $18d44303c09b950e$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $18d44303c09b950e$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $18d44303c09b950e$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $3DNV7.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("fw3ah", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $49c0a37d99620e42$export$b0ea72d31617ccea);

var $cWyqT = parcelRequire("cWyqT");

var $gdUUy = parcelRequire("gdUUy");
function $49c0a37d99620e42$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $cWyqT.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("9ly8I", function(module, exports) {
$parcel$export(module.exports, "isBlockAnnotationTarget", () => $b9c4c23d2f3c0976$export$b642df2122d0ab8);
$parcel$export(module.exports, "getIndexMatch", () => $b9c4c23d2f3c0976$export$fb7dab895a0d310e);

var $gdUUy = parcelRequire("gdUUy");
function $b9c4c23d2f3c0976$export$b642df2122d0ab8(node, schema) {
    const { extension: extension, media: media } = schema.nodes;
    return node.type === media || node.type === extension && (0, $gdUUy.fg)('cc_maui_annotations_on_extensions') && node.type.allowsMarkType(schema.marks.annotation);
}
function $b9c4c23d2f3c0976$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const isBlockTarget = $b9c4c23d2f3c0976$export$b642df2122d0ab8(node, schema);
        const isBlockContainer = nodeType.isBlock && !nodeType.isLeaf && !nodeType.inlineContent;
        // Containers may allow annotations for their children; skip their own text to avoid double-counting.
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation) || isBlockContainer) && !isBlockTarget) return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            if (isBlockTarget) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $b9c4c23d2f3c0976$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $b9c4c23d2f3c0976$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $b9c4c23d2f3c0976$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("jq7sX", function(module, exports) {
$parcel$export(module.exports, "getSelectionContext", () => $7198621af8e0f19f$export$3726c4866ce829b5);

var $8qh5l = parcelRequire("8qh5l");
var $lH2B7 = parcelRequire("lH2B7");

var $cw0wu = parcelRequire("cw0wu");

var $ah11j = parcelRequire("ah11j");
const $7198621af8e0f19f$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $ah11j.findParent)(range.startContainer);
    const endNode = (0, $ah11j.findParent)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $ah11j.getStartPos)(startNode);
    const endPos = (0, $ah11j.getStartPos)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $ah11j.getPosFromRange)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $cw0wu.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $8qh5l.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $lH2B7.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};

});
parcelRegister("8qh5l", function(module, exports) {
$parcel$export(module.exports, "getFragmentsFromSelection", () => $48739ac49c8f424e$export$dae3dcae007fe30);

var $5vR15 = parcelRequire("5vR15");

var $gGY8t = parcelRequire("gGY8t");
const $48739ac49c8f424e$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = (0, $gGY8t.getSliceFromSelection)(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $5vR15.nodeToJSON)(node, {
            keepNestedTables: true
        }));
    });
    return fragment;
};

});
parcelRegister("5vR15", function(module, exports) {
$parcel$export(module.exports, "validateNodes", () => $ea031b25eff8cf47$export$996213f7c272fc6f);
$parcel$export(module.exports, "isType", () => $ea031b25eff8cf47$export$26b9f946b448f23e);
$parcel$export(module.exports, "isParagraph", () => $ea031b25eff8cf47$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $ea031b25eff8cf47$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $ea031b25eff8cf47$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $ea031b25eff8cf47$export$5125f50e751e84db);
$parcel$export(module.exports, "toJSON", () => $ea031b25eff8cf47$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $ea031b25eff8cf47$export$3a858d3babd60825);

var $c6WhP = parcelRequire("c6WhP");

var $cUlhg = parcelRequire("cUlhg");

var $5DJ1z = parcelRequire("5DJ1z");




const $ea031b25eff8cf47$export$996213f7c272fc6f = (nodes)=>nodes.every((0, $5DJ1z.validNode));
const $ea031b25eff8cf47$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $ea031b25eff8cf47$export$d7ae8c533ae18832 = (node, schema)=>$ea031b25eff8cf47$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $ea031b25eff8cf47$export$1879817ac5c922b7 = (node, schema)=>$ea031b25eff8cf47$export$26b9f946b448f23e(node, schema.nodes.text);
const $ea031b25eff8cf47$export$5dfeda3a9e6fe056 = (node, schema)=>$ea031b25eff8cf47$export$26b9f946b448f23e(node, schema.marks.link);
const $ea031b25eff8cf47$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return (0, $cUlhg.SelectedState).selectedInRange;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return (0, $cUlhg.SelectedState).selectedInside;
    return null;
};
const $ea031b25eff8cf47$var$transformer = new (0, $c6WhP.JSONTransformer)();
function $ea031b25eff8cf47$export$54fd2c36b5cc6731(node) {
    return $ea031b25eff8cf47$var$transformer.encode(node);
}
function $ea031b25eff8cf47$export$3a858d3babd60825(node, options) {
    return $ea031b25eff8cf47$var$transformer.encodeNode(node, options);
}

});
parcelRegister("cUlhg", function(module, exports) {
$parcel$export(module.exports, "SelectedState", () => $28d982fde7228fe1$export$a6212ae0c82963af);
var $28d982fde7228fe1$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});

});

parcelRegister("5DJ1z", function(module, exports) {
$parcel$export(module.exports, "validNode", () => $984fda6f8012a3a7$export$4c39e41e39b3c449);
const $984fda6f8012a3a7$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};

});


parcelRegister("gGY8t", function(module, exports) {
$parcel$export(module.exports, "getSliceFromSelection", () => $0b8d9527bbf873f9$export$4fd509032ef7561b);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");


const $0b8d9527bbf873f9$var$listDepth = 3;
const $0b8d9527bbf873f9$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $0b8d9527bbf873f9$var$listDepth && $to.depth >= $0b8d9527bbf873f9$var$listDepth && $from.depth === $to.depth) {
        var _greatGrandparentFrom, _greatGrandparentFrom2;
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        (_greatGrandparentFrom = greatGrandparentFrom.firstChild) !== null && _greatGrandparentFrom !== void 0 && _greatGrandparentFrom.eq(grandparentFrom) && (_greatGrandparentFrom2 = greatGrandparentFrom.lastChild) !== null && _greatGrandparentFrom2 !== void 0 && _greatGrandparentFrom2.eq(grandparentTo)) return true;
    }
    return false;
};
const $0b8d9527bbf873f9$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $kW8qW.Fragment).empty;
    let frag = (0, $kW8qW.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $cw0wu.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($0b8d9527bbf873f9$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $0b8d9527bbf873f9$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};

});


parcelRegister("lH2B7", function(module, exports) {
$parcel$export(module.exports, "getLocalIdsFromSelection", () => $6fcc500c227a5fe9$export$9ce8378d786d4035);

var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");

var $gdUUy = parcelRequire("gdUUy");

var $gGY8t = parcelRequire("gGY8t");
const $6fcc500c227a5fe9$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $cw0wu.NodeSelection)) {
        if ((0, $gdUUy.fg)('platform_editor_ai_selection_local_ids')) {
            var _selection$node$attrs;
            const ids = [];
            const rootLocalId = (_selection$node$attrs = selection.node.attrs) === null || _selection$node$attrs === void 0 ? void 0 : _selection$node$attrs.localId;
            if (rootLocalId) ids.push(rootLocalId);
            selection.node.descendants((node)=>{
                var _node$attrs;
                if (node.isInline) return false;
                const localId = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId;
                if (localId) ids.push(localId);
            });
            return ids;
        }
        return [
            selection.node.attrs.localId
        ];
    } else if (selection instanceof (0, $2E7OD.CellSelection)) {
        if ((0, $gdUUy.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const ancestorIds = new Set();
            // Collect localIds from each selected cell and its descendants
            selection.forEachCell((cellNode, cellPos)=>{
                var _cellNode$attrs;
                const cellLocalId = (_cellNode$attrs = cellNode.attrs) === null || _cellNode$attrs === void 0 ? void 0 : _cellNode$attrs.localId;
                if (cellLocalId) ids.push(cellLocalId);
                cellNode.descendants((node)=>{
                    var _node$attrs2;
                    if (node.isInline) return false;
                    const localId = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId;
                    if (localId) ids.push(localId);
                });
                // Collect ancestor localIds (row, table) separately
                const $cell = selection.$anchorCell.doc.resolve(cellPos + 1);
                for(let depth = $cell.depth - 1; depth >= 1; depth--){
                    var _ancestor$attrs;
                    const ancestor = $cell.node(depth);
                    const localId = (_ancestor$attrs = ancestor.attrs) === null || _ancestor$attrs === void 0 ? void 0 : _ancestor$attrs.localId;
                    if (localId) ancestorIds.add(localId);
                }
            });
            const uniqueIds = new Set(ids);
            const uniqueAncestors = [
                ...ancestorIds
            ].filter((id)=>!uniqueIds.has(id));
            return [
                ...uniqueIds,
                ...uniqueAncestors
            ];
        }
    } else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = (0, $gGY8t.getSliceFromSelection)(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        var _node$attrs3;
        const localId = (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};

});
parcelRegister("2E7OD", function(module, exports) {
$parcel$export(module.exports, "CellSelection", () => $bd07753bcd50dfdb$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $jRA1f = parcelRequire("jRA1f");

var $jCYj3 = parcelRequire("jCYj3");

var $agxVi = parcelRequire("agxVi");

var $5GZEk = parcelRequire("5GZEk");

var $jdzgh = parcelRequire("jdzgh");

var $7zE9O = parcelRequire("7zE9O");
class $bd07753bcd50dfdb$export$831cc7e2a83afa94 extends (0, $cw0wu.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $agxVi.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $jdzgh.pointsAtCell)($anchorCell) && (0, $jdzgh.pointsAtCell)($headCell) && (0, $5GZEk.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $bd07753bcd50dfdb$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $bd07753bcd50dfdb$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $bd07753bcd50dfdb$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $cw0wu.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $jCYj3.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $7zE9O.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $7zE9O.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $kW8qW.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kW8qW.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kW8qW.Slice).empty : content);
        }
        const sel = (0, $cw0wu.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $jCYj3.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $jCYj3.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $bd07753bcd50dfdb$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $jCYj3.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $bd07753bcd50dfdb$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $jCYj3.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $bd07753bcd50dfdb$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $bd07753bcd50dfdb$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $bd07753bcd50dfdb$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $bd07753bcd50dfdb$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $jRA1f.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $cw0wu.Selection).jsonID('cell', $bd07753bcd50dfdb$export$831cc7e2a83afa94);

});
parcelRegister("jRA1f", function(module, exports) {
$parcel$export(module.exports, "CellBookmark", () => $73a3e2895ce3c3d1$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $cw0wu = parcelRequire("cw0wu");

var $5GZEk = parcelRequire("5GZEk");
class $73a3e2895ce3c3d1$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $73a3e2895ce3c3d1$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $5GZEk.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $cw0wu.Selection).fromJSON(doc, data);
        }
        return (0, $cw0wu.Selection).near($headCell, 1);
    }
}

});
parcelRegister("5GZEk", function(module, exports) {
$parcel$export(module.exports, "inSameTable", () => $1ee4058479c347df$export$debd62b44eb7e281);
function $1ee4058479c347df$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("jCYj3", function(module, exports) {
$parcel$export(module.exports, "TableProblemTypes", () => $07a469ad2d804647$export$d8cd393a71edca79);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $07a469ad2d804647$export$c60fae4049791eae);
$parcel$export(module.exports, "TableMap", () => $07a469ad2d804647$export$493da463fed0a57a);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $75wb5 = parcelRequire("75wb5");

var $96KUJ = parcelRequire("96KUJ");

var $3n3Dj = parcelRequire("3n3Dj");

var $cxeAF = parcelRequire("cxeAF");


var $07a469ad2d804647$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $07a469ad2d804647$export$c60fae4049791eae = 140;
class $07a469ad2d804647$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new (0, $cxeAF.Rect)(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new (0, $cxeAF.Rect)(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return (0, $3n3Dj.readFromCache)(table) || (0, $75wb5.addToCache)(table, (0, $96KUJ.computeMap)(table));
    }
}

});
parcelRegister("75wb5", function(module, exports) {
$parcel$export(module.exports, "addToCache", () => $118856cf5b3d4e0e$export$d6414c810925a1da);

var $14fxx = parcelRequire("14fxx");
function $118856cf5b3d4e0e$export$d6414c810925a1da(key, value) {
    return (0, $14fxx.tableMapCache).set(key, value);
}

});
parcelRegister("14fxx", function(module, exports) {
$parcel$export(module.exports, "tableMapCache", () => $9552fd620d0423de$export$8972ebb43002a388);
// Share the same cache between readers and writers. Table maps are relative to
// immutable table nodes, so changing the document produces a different key.
let $9552fd620d0423de$var$readFromCache;
let $9552fd620d0423de$var$addToCache;
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $9552fd620d0423de$var$readFromCache = (key)=>cache.get(key);
    $9552fd620d0423de$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // The original fallback stores five pairs in a ten-slot circular cache.
    const cache = [];
    const cacheSize = 5;
    let cachePos = 0;
    $9552fd620d0423de$var$readFromCache = (key)=>{
        for (const [node, map] of cache){
            if (node === key) return map;
        }
        return undefined;
    };
    $9552fd620d0423de$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = [
            key,
            value
        ];
        return value;
    };
}
const $9552fd620d0423de$export$8972ebb43002a388 = {
    get: $9552fd620d0423de$var$readFromCache,
    set: $9552fd620d0423de$var$addToCache
};

});


parcelRegister("96KUJ", function(module, exports) {
$parcel$export(module.exports, "computeMap", () => $2c33adb8fea969cc$export$b00423e42c344284);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $27Tqk = parcelRequire("27Tqk");

var $bzduW = parcelRequire("bzduW");

var $jCYj3 = parcelRequire("jCYj3");
function $2c33adb8fea969cc$export$b00423e42c344284(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = (0, $bzduW.findWidth)(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: (0, $jCYj3.TableProblemTypes).OVERLONG_ROWSPAN,
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: (0, $jCYj3.TableProblemTypes).COLLISION,
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: (0, $jCYj3.TableProblemTypes).MISSING,
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new (0, $jCYj3.TableMap)(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push((0, $jCYj3.tableNewColumnMinWidth), 0);
        badWidths = true;
    }
    if (badWidths) (0, $27Tqk.findBadColWidths)(tableMap, colWidths, table);
    return tableMap;
}

});
parcelRegister("27Tqk", function(module, exports) {
$parcel$export(module.exports, "findBadColWidths", () => $0c241086b699e6b3$export$3c60fa892a0c95fe);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jCYj3 = parcelRequire("jCYj3");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0c241086b699e6b3$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}
function $0c241086b699e6b3$export$3c60fa892a0c95fe(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $0c241086b699e6b3$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: (0, $jCYj3.TableProblemTypes).COLWIDTH_MISMATCH,
            pos: pos,
            colwidth: updated
        });
    }
}

});

parcelRegister("bzduW", function(module, exports) {
$parcel$export(module.exports, "findWidth", () => $226f0fd4aa89991c$export$f7bee8f27db3cd05);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
function $226f0fd4aa89991c$export$f7bee8f27db3cd05(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}

});


parcelRegister("3n3Dj", function(module, exports) {
$parcel$export(module.exports, "readFromCache", () => $6af3d70f3e2de4e9$export$42a80a4a4ad0dbe3);

var $14fxx = parcelRequire("14fxx");
function $6af3d70f3e2de4e9$export$42a80a4a4ad0dbe3(key) {
    return (0, $14fxx.tableMapCache).get(key);
}

});

parcelRegister("cxeAF", function(module, exports) {
$parcel$export(module.exports, "Rect", () => $520878cf5a1c6075$export$c79fc6492f3af13d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
class $520878cf5a1c6075$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}

});


parcelRegister("agxVi", function(module, exports) {
$parcel$export(module.exports, "getCellSelectionRanges", () => $7640ab7ffd1719d5$export$a60a444208fd5099);

var $cw0wu = parcelRequire("cw0wu");

var $jCYj3 = parcelRequire("jCYj3");
function $7640ab7ffd1719d5$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $jCYj3.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $cw0wu.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});

parcelRegister("jdzgh", function(module, exports) {
$parcel$export(module.exports, "pointsAtCell", () => $5e58018546330d40$export$3c89e45c7dff9619);
function $5e58018546330d40$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}

});

parcelRegister("7zE9O", function(module, exports) {
$parcel$export(module.exports, "removeColSpan", () => $fd32c167192e568a$export$b24d9c3cc95412e0);
function $fd32c167192e568a$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}

});







parcelRegister("2U3vi", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $6ac84384aeb7d73a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $6ac84384aeb7d73a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $6ac84384aeb7d73a$export$708fc397e2b6f08d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
const $6ac84384aeb7d73a$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $6ac84384aeb7d73a$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $6ac84384aeb7d73a$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $6ac84384aeb7d73a$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $6ac84384aeb7d73a$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, hasBlockNodeSupport: hasBlockNodeSupport })=>{
    const extensionCommentsEnabled = !!hasBlockNodeSupport && (0, $gdUUy.fg)('cc_maui_annotations_on_extensions');
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $bSJIT.useReducer)($6ac84384aeb7d73a$var$reducer, $6ac84384aeb7d73a$var$initialState);
    const clearSelectionRange = (0, $bSJIT.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $bSJIT.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $bSJIT.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const hoverDraftRangeRef = (0, $bSJIT.useRef)(hoverDraftRange);
    hoverDraftRangeRef.current = hoverDraftRange;
    const setHoverTarget = (0, $bSJIT.useCallback)((target)=>{
        const draftRange = hoverDraftRangeRef.current;
        const draftTarget = draftRange === null || draftRange === void 0 ? void 0 : draftRange.startContainer.childNodes[draftRange.startOffset];
        if (extensionCommentsEnabled && draftTarget instanceof HTMLElement && draftTarget.matches('.ak-renderer-extension[data-inline-comments-target="true"]')) // Keep the composer callbacks bound to the chart chosen when its draft opened.
        return;
        // The HoverComponent expects an element deeply nested inside media or the eligible
        // block node's wrapper. Each selector is only included when its comment type is
        // supported, so hover targeting never activates on an ineligible block node.
        const selectors = [
            allowCommentsOnMedia && '.media-card-inline-player, .media-file-card-view',
            extensionCommentsEnabled && '.ak-renderer-extension[data-inline-comments-target="true"]'
        ].filter((selector)=>Boolean(selector)).join(', ');
        const hoverableNode = extensionCommentsEnabled && target.matches('.ak-renderer-extension[data-inline-comments-target="true"]') ? target : selectors ? target.querySelector(selectors) : null;
        if (!hoverableNode) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- range for media/extension hover highlight
        const range = document.createRange();
        range.setStartBefore(hoverableNode);
        range.setEndAfter(hoverableNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, [
        allowCommentsOnMedia,
        extensionCommentsEnabled
    ]);
    const promoteSelectionToDraft = (0, $bSJIT.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $bSJIT.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $bSJIT.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $bSJIT.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $bSJIT.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $bSJIT.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: allowCommentsOnMedia || extensionCommentsEnabled ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        extensionCommentsEnabled,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($6ac84384aeb7d73a$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($6ac84384aeb7d73a$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $6ac84384aeb7d73a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, hasBlockNodeSupport: hasBlockNodeSupport, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $dc70d.jsx)($6ac84384aeb7d73a$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        hasBlockNodeSupport: hasBlockNodeSupport,
        children: children
    });
};
const $6ac84384aeb7d73a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $bSJIT.useContext)($6ac84384aeb7d73a$export$145b9bb655c3d220);
};
const $6ac84384aeb7d73a$export$708fc397e2b6f08d = ()=>{
    return (0, $bSJIT.useContext)($6ac84384aeb7d73a$export$efb0d1c8cbaac647);
};

});

parcelRegister("gj7PC", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $e8fed323bd326b45$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $e8fed323bd326b45$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $e8fed323bd326b45$export$26cf539704e444c1);

var $bSJIT = parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $1l5zG = parcelRequire("1l5zG");

var $g6Qq4 = parcelRequire("g6Qq4");

var $4GPCq = parcelRequire("4GPCq");

var $il86U = parcelRequire("il86U");
const $e8fed323bd326b45$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $bSJIT.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $il86U.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $il86U.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $bSJIT.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $e8fed323bd326b45$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $bSJIT.useState)(false);
    const [isHovered, setIsHovered] = (0, $bSJIT.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $il86U.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $il86U.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $e8fed323bd326b45$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $e8fed323bd326b45$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $bSJIT.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $il86U.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $il86U.useAnnotationManagerState)();
    const selectedAnnotation = (0, $bSJIT.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // This is a constant to represent the case when no annotation is selected.
        // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $e8fed323bd326b45$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).VIEWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $1l5zG.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});

parcelRegister("77hMz", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $1bf5b9029cc98288$export$39f7c1a861a0d41c);

var $bSJIT = parcelRequire("bSJIT");

var $4GPCq = parcelRequire("4GPCq");

var $5cXhe = parcelRequire("5cXhe");

var $cR5yJ = parcelRequire("cR5yJ");

var $il86U = parcelRequire("il86U");
const $1bf5b9029cc98288$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const providers = (0, $bSJIT.useContext)((0, $cR5yJ.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $il86U.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $bSJIT.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});

parcelRegister("2BJSj", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $a13f2b308ded4236$export$41cd4a02859c2806);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5cXhe = parcelRequire("5cXhe");

var $cR5yJ = parcelRequire("cR5yJ");

var $gj7PC = parcelRequire("gj7PC");
const $a13f2b308ded4236$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $bSJIT.useContext)((0, $cR5yJ.ProvidersContext));
    const actionContext = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $gj7PC.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $bSJIT.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $bSJIT.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $dc70d.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});

parcelRegister("ehdmB", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $b5494b7551055899$export$787af8a111ff3c03);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $cR5yJ = parcelRequire("cR5yJ");

var $kNCzw = parcelRequire("kNCzw");

var $38ZtT = parcelRequire("38ZtT");
const $b5494b7551055899$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $bSJIT.useContext)((0, $cR5yJ.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $dc70d.jsx)((0, $kNCzw.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $dc70d.jsx)((0, $38ZtT.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("kNCzw", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $9fa80c8e8fbc3e0d$export$6d8376a902cb8aa7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5cXhe = parcelRequire("5cXhe");

var $ihGX5 = parcelRequire("ihGX5");

var $2U3vi = parcelRequire("2U3vi");

var $jKmJv = parcelRequire("jKmJv");
const $9fa80c8e8fbc3e0d$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2U3vi.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2U3vi.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $ihGX5.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jKmJv.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$9fa80c8e8fbc3e0d$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("jKmJv", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $a8e809dec3996620$export$2109cd350bcf6eda);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $1l5zG = parcelRequire("1l5zG");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $5cXhe = parcelRequire("5cXhe");

var $2U3vi = parcelRequire("2U3vi");

var $iAlJn = parcelRequire("iAlJn");
const $a8e809dec3996620$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $2U3vi.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $2U3vi.useAnnotationRangeState)();
    const actions = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const onCreateCallback = (0, $bSJIT.useCallback)((annotationId)=>{
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        const positionToAnnotate = (0, $5N1Y4.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        }).fire((0, $1l5zG.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $bSJIT.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $bSJIT.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            }).fire((0, $1l5zG.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one.
        // Without this, if a previous draft was not explicitly closed, hoverDraftDocumentPosition
        // retains the old position and the comment anchors to the wrong text (COMMENTS-6594).
        if ((0, $5N1Y4.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearHoverDraft();
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).OPENED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $1l5zG.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $iAlJn.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        const positionToAnnotate = (0, $5N1Y4.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            }).fire((0, $1l5zG.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        hoverDraftDocumentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        clearHoverDraft
    ]);
    const removeDraftModeCallback = (0, $bSJIT.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $bSJIT.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).CLOSED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $1l5zG.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("iAlJn", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $d1e8a842c0ab3f24$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $d1e8a842c0ab3f24$export$e14699d956e87e73);
/* eslint-disable @atlaskit/platform/no-direct-document-usage -- draft selection uses document range APIs */ const $d1e8a842c0ab3f24$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $d1e8a842c0ab3f24$var$buildDataAttributesQuery = (pos)=>{
    const a = $d1e8a842c0ab3f24$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $d1e8a842c0ab3f24$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($d1e8a842c0ab3f24$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});



parcelRegister("38ZtT", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $57acc4c2b749c2d9$export$74435b85e23b84d9);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5cXhe = parcelRequire("5cXhe");

var $a84x9 = parcelRequire("a84x9");

var $2aBt7 = parcelRequire("2aBt7");
const $57acc4c2b749c2d9$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $a84x9.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2aBt7.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$57acc4c2b749c2d9$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("a84x9", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $03ddb7ebcc39f83c$export$47201332e612f5a4);

var $bSJIT = parcelRequire("bSJIT");

var $5N1Y4 = parcelRequire("5N1Y4");

var $il86U = parcelRequire("il86U");

var $2U3vi = parcelRequire("2U3vi");

var $cbDFP = parcelRequire("cbDFP");
const $03ddb7ebcc39f83c$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $bSJIT.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $2U3vi.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $2U3vi.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $il86U.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $bSJIT.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $bSJIT.useCallback)((_event)=>{
        var _document$body;
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        /*
     * The 100ms debounce batches rapid `selectionchange` events during user drag/extend
     * operations into a single React update. When the nudge button triggers a programmatic
     * `addRange`, it fires exactly ONE `selectionchange` — no batching needed. Skipping the
     * debounce ensures annotation position is computed synchronously so the first click
     * applies the yellow highlight immediately. `data-nudge-selection-active` is set
     * exclusively by the Confluence comment nudge feature and is double-gated:
     * (1) `expValEquals('confluence_comment_nudgebar_improvement', ...)` — explicit experiment
     * gate; (2) `data-nudge-selection-active` — ensures 0ms only fires during an actual nudge
     * click, not on every selectionchange for experiment-ON users. Zero behavioral change for
     * other products or experiment-OFF users.
     */ const nudgeDelay = typeof document !== 'undefined' && ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.getAttribute('data-nudge-selection-active')) === 'true' && (0, $5N1Y4.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true) ? 0 : 100;
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $cbDFP.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, nudgeDelay);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("cbDFP", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $b66b734fa19b9992$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $b66b734fa19b9992$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("2aBt7", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $0f393aa19a13dd39$export$ca7741472ed8ba00);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $9IULF = parcelRequire("9IULF");

var $1l5zG = parcelRequire("1l5zG");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $fw3ah = parcelRequire("fw3ah");

var $5cXhe = parcelRequire("5cXhe");

var $il86U = parcelRequire("il86U");

var $2U3vi = parcelRequire("2U3vi");

var $iAlJn = parcelRequire("iAlJn");
const $0f393aa19a13dd39$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $2U3vi.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $2U3vi.useAnnotationRangeState)();
    const actions = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $il86U.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $il86U.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $bSJIT.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $fw3ah.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $bSJIT.useCallback)((annotationId)=>{
        // Use documentPosition directly when gate is on — selectionDraftDocumentPosition may be stale
        // (from a previous selection) causing the comment to anchor to the wrong text (COMMENTS-6594).
        const positionToAnnotate = (0, $5N1Y4.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        }).fire((0, $1l5zG.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        selectionDraftDocumentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $bSJIT.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $bSJIT.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            }).fire((0, $1l5zG.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one (COMMENTS-6594).
        if ((0, $5N1Y4.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearSelectionDraft();
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).OPENED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $1l5zG.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $iAlJn.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Use documentPosition directly when either:
        // - platform_editor_comments_api_manager is on (existing behaviour), OR
        // - COMMENTS-6594 experiment is on (fix: avoids stale closure value)
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        const positionToAnnotate = (0, $gdUUy.fg)('platform_editor_comments_api_manager') || (0, $5N1Y4.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            }).fire((0, $1l5zG.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        clearSelectionDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $bSJIT.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $bSJIT.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).CLOSED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $1l5zG.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, $7RHfd.default)();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $9IULF.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $bSJIT.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});




parcelRegister("6SGk4", function(module, exports) {
$parcel$export(module.exports, "default", () => $318504c5d95fcbbe$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $57l7A = parcelRequire("57l7A");

var $1tfAn = parcelRequire("1tfAn");

var $fRXfs = parcelRequire("fRXfs");

var $l7ENf = parcelRequire("l7ENf");
function $318504c5d95fcbbe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $318504c5d95fcbbe$var$inlineExtensionStyle = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $318504c5d95fcbbe$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $318504c5d95fcbbe$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, getContent: getContent, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, $57l7A.default)((0, $1tfAn.getNodeRenderer)), []);
    /**
   * null -> provider promise not yet settled (pending)
   * undefined -> provider promise rejected (settled, no provider available)
   * <provider> -> provider promise resolved
   */ const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((_name, providerPromise)=>{
        providerPromise === null || providerPromise === void 0 || providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        }, ()=>{
            // Consumers can use this to distinguish a rejected provider from a pending one
            if (isMounted.current) setExtensionProvider(undefined);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((extensionProvider, isExtensionProviderPending)=>{
        var _marks$find, _node$parameters;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        // Extension handlers read the macro body off `node.content`, so this is the one place that
        // always has to serialize. `getContent` is what makes it a single pass instead of one per
        // ancestor node.
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: (getContent === null || getContent === void 0 ? void 0 : getContent()) || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.macroParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $l7ENf.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $9dQre.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $9dQre.jsx)($318504c5d95fcbbe$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $9dQre.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $9dQre.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            isExtensionProviderPending: isExtensionProviderPending,
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        getContent,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext === null || rendererContext === void 0 ? void 0 : rendererContext.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((providers)=>{
        if (extensionProvider === null && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider, Boolean(providers.extensionProvider) && extensionProvider === null);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $fRXfs.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $318504c5d95fcbbe$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $318504c5d95fcbbe$var$inlineExtensionStyle,
            isPlainTextMacro && $318504c5d95fcbbe$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("1tfAn", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNode", () => $49f47f1517466a39$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $49f47f1517466a39$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $49f47f1517466a39$export$67a7d49db68d30a0);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $deAR2 = parcelRequire("deAR2");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
var $bf3Xm = parcelRequire("bf3Xm");

var $3y2s4 = parcelRequire("3y2s4");

var $6o5zV = parcelRequire("6o5zV");

var $bS1nD = parcelRequire("bS1nD");

var $3ZtGy = parcelRequire("3ZtGy");

var $1KDc9 = parcelRequire("1KDc9");

function $49f47f1517466a39$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $49f47f1517466a39$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $6o5zV.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $49f47f1517466a39$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $49f47f1517466a39$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    var _extensionProvider$ge;
    const [extKey, nodeKey] = (0, $6o5zV.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider === null || extensionProvider === void 0 || (_extensionProvider$ge = extensionProvider.getPreloadedExtension) === null || _extensionProvider$ge === void 0 ? void 0 : _extensionProvider$ge.call(extensionProvider, extensionType, extKey);
    if (manifest) return $49f47f1517466a39$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$49f47f1517466a39$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $49f47f1517466a39$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $49f47f1517466a39$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $49f47f1517466a39$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    var _extensionNode$parame;
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!((_extensionNode$parame = extensionNode.parameters) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.macroParams) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.__bodyContent) !== null && _extensionNode$parame !== void 0 && _extensionNode$parame.value);
}
// eslint-disable-next-line @repo/internal/react/no-class-components -- error boundaries require a class component
class $49f47f1517466a39$var$ExtensionRendererErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', error);
    }
    render() {
        return this.state.error ? $49f47f1517466a39$var$renderExtensionLoadingError(this.state.error, this.props.fallbackProps) : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {};
    }
}
const $49f47f1517466a39$var$noop = ()=>{};
function $49f47f1517466a39$var$renderExtensionLoadingError(error, props) {
    // Needed because the old react-loadable (older code-splitting library) error handling behaviour might be relied on by extensions.
    // https://unpkg.com/react-loadable@5.2.2/lib/index.js
    return /*#__PURE__*/ (0, $dc70d.jsx)($49f47f1517466a39$var$ExtensionLoading, {
        isLoading: false,
        pastDelay: true,
        timedOut: false,
        error: error,
        retry: $49f47f1517466a39$var$noop,
        ...props
    });
}
function $49f47f1517466a39$var$ExtensionLoading(props) {
    const intl = (0, $4vLTk.default)();
    const extensionNode = props.node;
    if (!props.error && !props.timedOut && props.loadingFallback) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: props.loadingFallback
    });
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $49f47f1517466a39$var$isUnknownConfluenceMacroWithBody(extensionNode)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1KDc9.UnknownMacroPlaceholder), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            children: intl.formatMessage((0, $bS1nD.messages).extensionLoadingError)
        });
    } else return null;
}
function $49f47f1517466a39$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    // Async is needed to wrap the getExtensionModuleNodeMaybePreloaded call in a promise so that we can use the lazy() API
    const loadNodeRenderer = async ()=>{
        var _renderSync, _ref;
        const maybePromise = $49f47f1517466a39$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
        if (maybePromise instanceof Promise) return (0, $6o5zV.resolveImport)((await maybePromise).render());
        const preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync = (_ref = maybePromise).renderSync) === null || _renderSync === void 0 ? void 0 : _renderSync.call(_ref);
        // Only product implemented preloading will return sync result
        // However the out-of-box won't handle this. Confluence uses a custom implementation
        return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $3ZtGy.resolveImportSync)(preloaded) : (0, $6o5zV.resolveImport)((await maybePromise).render());
    };
    const LazyNodeRenderer = (0, $2vYDF.lazy)(()=>loadNodeRenderer(), {});
    LazyNodeRenderer.displayName = 'lazy(NodeRenderer)';
    const loadNodeRendererNoWrappedPromise = ()=>{
        var _renderSync2, _ref2;
        const maybePromise = $49f47f1517466a39$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
        if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $6o5zV.resolveImport)(node.render()));
        const preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync2 = (_ref2 = maybePromise).renderSync) === null || _renderSync2 === void 0 ? void 0 : _renderSync2.call(_ref2);
        // Only product implemented preloading will return sync result
        // However the out-of-box won't handle this. Confluence uses a custom implementation
        return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $3ZtGy.resolveImportSync)(preloaded) : (0, $6o5zV.resolveImport)(maybePromise.render());
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
        loader: loadNodeRendererNoWrappedPromise,
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $49f47f1517466a39$var$ExtensionLoading
    });
    // We have to make sure the Loadable is assigned the name "getNodeRenderer" by Babel.
    // This loadable name is used by Babel to inject _maybeSyncLoader: true.
    // confluence/next/tools/config/loadableBabelPluginOptions.config.js (see HOT-307098)
    const LoadableNodeRenderer = getNodeRenderer;
    const NodeRenderer = (props)=>{
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration')) // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $dc70d.jsx)(LoadableNodeRenderer, {
            ...props
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)($49f47f1517466a39$var$ExtensionRendererErrorBoundary, {
            fallbackProps: props,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bf3Xm.LazySuspense), {
                fallback: props.loadingFallback ?? null,
                children: /*#__PURE__*/ (0, $dc70d.jsx)(LazyNodeRenderer, {
                    ...props
                })
            })
        });
    };
    NodeRenderer.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? LazyNodeRenderer.preload() : LoadableNodeRenderer.preload();
    return NodeRenderer;
}

});
parcelRegister("6o5zV", function(module, exports) {
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_TYPE", () => $a887cdc3d8a9ada8$export$862c0e8acc7585d7);
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_KEY", () => $a887cdc3d8a9ada8$export$b343a94058bea058);
$parcel$export(module.exports, "AGENT_MANAGED_EXTENSION_KEY", () => $a887cdc3d8a9ada8$export$e400f4d17a615c24);
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $a887cdc3d8a9ada8$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $a887cdc3d8a9ada8$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $a887cdc3d8a9ada8$export$d69c9b451c47653b);

var $7VQte = parcelRequire("7VQte");

var $3ZtGy = parcelRequire("3ZtGy");
const $a887cdc3d8a9ada8$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $a887cdc3d8a9ada8$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $a887cdc3d8a9ada8$export$b343a94058bea058 = 'native-embed';
const $a887cdc3d8a9ada8$export$e400f4d17a615c24 = 'agent-managed-block';
const $a887cdc3d8a9ada8$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $a887cdc3d8a9ada8$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
function $a887cdc3d8a9ada8$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $a887cdc3d8a9ada8$export$33863d887d6f4bfd(action, manifest);
}
const $a887cdc3d8a9ada8$export$d69c9b451c47653b = async (importPromise)=>{
    return (0, $3ZtGy.resolveImportSync)(await importPromise);
};
function $a887cdc3d8a9ada8$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = (0, $7VQte.buildExtensionKeyAndNodeKey)(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});
parcelRegister("7VQte", function(module, exports) {
$parcel$export(module.exports, "buildExtensionKeyAndNodeKey", () => $66a6760f1207f52b$export$5f3eb042babacbbd);
const $66a6760f1207f52b$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};

});

parcelRegister("3ZtGy", function(module, exports) {
$parcel$export(module.exports, "resolveImportSync", () => $e76a07b469f1ccbc$export$dca2026e63034304);
const $e76a07b469f1ccbc$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};

});


parcelRegister("bS1nD", function(module, exports) {
$parcel$export(module.exports, "messages", () => $dc4202f189f72964$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");

const $dc4202f189f72964$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'The text is shown as a button label in the extension context menu. Triggers opening the properties editor for the selected extension to modify its configuration.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'Label for a checkbox in a confirm modal that allows the user to also delete connected elements when deleting an extension.'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Informational message displayed in the extension configuration panel to reassure users that their changes are being saved automatically without requiring manual save action.'
    },
    panelLoadingError: {
        id: 'fabric.editor.extensions.config-panel.loading-error.non-final',
        defaultMessage: 'We ran into a bit of trouble. Refresh to try again.',
        description: 'Error message displayed when the extension configuration panel fails to load. Instructs users to refresh the page to attempt loading the panel again.'
    },
    extensionLoadingError: {
        id: 'fabric.editor.extension.loading-error',
        defaultMessage: 'Error loading the extension!',
        description: 'Error message displayed when an extension fails to load in the editor. Indicates a problem occurred during the extension initialization or rendering process.'
    },
    unknownMacroPlaceholderAriaLabel: {
        id: 'fabric.editor.extension.unknownMacroPlaceholderAriaLabel',
        defaultMessage: 'Unknown macro placeholder',
        description: 'Accessible label for the unknown macro fallback block shown when a Confluence macro cannot be resolved.'
    },
    unknownMacroHeader: {
        id: 'fabric.editor.extension.unknownMacroHeader',
        defaultMessage: "Unknown macro: ''{macroTitle}''",
        description: 'Header text for an unresolved Confluence macro placeholder.'
    }
});

});

parcelRegister("1KDc9", function(module, exports) {
$parcel$export(module.exports, "UnknownMacroPlaceholder", () => $67c9e46c261f9e85$export$414b5225f50e455b);
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $3y2s4 = parcelRequire("3y2s4");

var $bS1nD = parcelRequire("bS1nD");
// Unknown macro placeholder styling aligned with Legacy Content Macro (LCM) for consistent look
const $67c9e46c261f9e85$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $67c9e46c261f9e85$var$unknownMacroContainerStyles = null;
// Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $67c9e46c261f9e85$var$unknownMacroHeaderStyles = null;
// Match LCM content area: white surface, text color inherits
const $67c9e46c261f9e85$var$unknownMacroBodyStyles = null;
const $67c9e46c261f9e85$var$unknownMacroPreStyles = null;
const $67c9e46c261f9e85$var$formatParam = (key, param)=>{
    const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
    return `${key} = ${value}`;
};
const $67c9e46c261f9e85$var$EMPTY_MACRO_PARAMS = {};
function $67c9e46c261f9e85$export$414b5225f50e455b({ extensionNode: extensionNode }) {
    var _extensionNode$parame, _extensionNode$parame2, _extensionNode$parame3, _extensionNode$parame4;
    const intl = (0, $4vLTk.default)();
    const macroTitle = ((_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 || (_extensionNode$parame = _extensionNode$parame.macroMetadata) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.title) || extensionNode.extensionKey;
    const bodyContent = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.macroParams) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.__bodyContent) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.value;
    const macroParamsOld = ((_extensionNode$parame3 = extensionNode.parameters) === null || _extensionNode$parame3 === void 0 ? void 0 : _extensionNode$parame3.macroParams) ?? {};
    const macroParams = ((_extensionNode$parame4 = extensionNode.parameters) === null || _extensionNode$parame4 === void 0 ? void 0 : _extensionNode$parame4.macroParams) ?? $67c9e46c261f9e85$var$EMPTY_MACRO_PARAMS;
    const formatParamInline = (key, param)=>{
        const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
        return `${key} = ${value}`;
    };
    const memoizedVisibleParams = (0, $bSJIT.useMemo)(()=>Object.entries(macroParams).filter(([key])=>!key.startsWith('_')).map(([key, param])=>$67c9e46c261f9e85$var$formatParam(key, param)).join(' | '), [
        macroParams
    ]);
    const visibleParams = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedVisibleParams : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    Object.entries(macroParamsOld).filter(([key])=>!key.startsWith('_')).map(([key, param])=>formatParamInline(key, param)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $bS1nD.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $bS1nD.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("section", {
        "aria-label": intl.formatMessage((0, $bS1nD.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $9fU1q.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)("pre", {
                    className: (0, $9fU1q.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
                    ]),
                    children: bodyContent
                })
            })
        ]
    });
}

});


parcelRegister("fRXfs", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $fc26ab50b842a2c3$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $bSJIT = parcelRequire("bSJIT");
class $fc26ab50b842a2c3$export$d498ee8be33e096f extends (0, $bSJIT.PureComponent) {
    static #_ = this.displayName = 'WithProviders';
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("l7ENf", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $6da2a85dd70de161$export$9214452ef07eda7);
function $6da2a85dd70de161$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("9ZAW5", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $db270b41820486f4$export$e926676385687eaf);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1l5zG = parcelRequire("1l5zG");

var $g6Qq4 = parcelRequire("g6Qq4");

var $j2Y9J = parcelRequire("j2Y9J");

var $dABkj = parcelRequire("dABkj");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $db270b41820486f4$var$FAILED_TO_EXECUTE_REGEX = /Failed to execute.*on 'Node'.*/;
class $db270b41820486f4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $1l5zG.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $dABkj.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`,
                componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $j2Y9J.logException)(error, {
            location: 'renderer'
        });
        const matchesPattern = $db270b41820486f4$var$FAILED_TO_EXECUTE_REGEX.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $dABkj.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
            children: this.props.children
        }, this.state.domErrorCount);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}

});
parcelRegister("j2Y9J", function(module, exports) {
$parcel$export(module.exports, "logException", () => $3942a557879913b1$export$f86b2a1a2ce291b3);

var $2mNXa = parcelRequire("2mNXa");

var $eaBhD = parcelRequire("eaBhD");

var $51HZ4 = parcelRequire("51HZ4");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3942a557879913b1$var$NETWORK_ERROR_REGEX = /^network error/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3942a557879913b1$var$NETWORK_FAILURE_REGEX = /^network failure/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3942a557879913b1$var$RESIZE_OBSERVER_LOOP_REGEX = /ResizeObserver loop completed with undelivered notifications/;
const $3942a557879913b1$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $3942a557879913b1$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $3942a557879913b1$var$packageVersion = undefined;
const $3942a557879913b1$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $3942a557879913b1$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("2mNXa")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("40c34"));
        const breadcrumbsIntegration = new (0, $2mNXa.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $51HZ4.SERIALIZABLE_ATTRIBUTES)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        });
        const sentryOptions = {
            dsn: (0, $eaBhD.isFedRamp)() ? undefined : $3942a557879913b1$var$SENTRY_DSN,
            release: `${$3942a557879913b1$var$packageName}@${$3942a557879913b1$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            beforeBreadcrumb: (0, $51HZ4.normaliseSentryBreadcrumbs),
            ignoreErrors: [
                // Network issues
                $3942a557879913b1$var$NETWORK_ERROR_REGEX,
                $3942a557879913b1$var$NETWORK_FAILURE_REGEX,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                $3942a557879913b1$var$RESIZE_OBSERVER_LOOP_REGEX
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    breadcrumbsIntegration,
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $3942a557879913b1$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            var _buildInfo;
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("eaBhD", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $707e70acd0702a21$export$64d6499adf9b2e51);
const $707e70acd0702a21$var$FEDRAMP_MODERATE = 'fedramp-moderate';
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $707e70acd0702a21$var$FEDRAMP_HOSTNAME_REGEX = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
function $707e70acd0702a21$export$64d6499adf9b2e51() {
    var _global$location;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $707e70acd0702a21$var$FEDRAMP_MODERATE;
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match($707e70acd0702a21$var$FEDRAMP_HOSTNAME_REGEX);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("51HZ4", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $3c3adacdc8e70abc$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $3c3adacdc8e70abc$export$6f14342128c6eaa4);
const $3c3adacdc8e70abc$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $3c3adacdc8e70abc$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$3c3adacdc8e70abc$export$b5bdb04ea16a02e3
];
const $3c3adacdc8e70abc$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$3c3adacdc8e70abc$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $3c3adacdc8e70abc$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($3c3adacdc8e70abc$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $3c3adacdc8e70abc$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category !== null && category !== void 0 && category.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $3c3adacdc8e70abc$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("40c34", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bT4na").then(()=>parcelRequire('7txDW'));

});


parcelRegister("dABkj", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $4ced1061547e1ea2$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $4ced1061547e1ea2$export$e48589d9e4824227);
var $4ced1061547e1ea2$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $4ced1061547e1ea2$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $4ced1061547e1ea2$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($4ced1061547e1ea2$var$RESOLVE_METHOD || {});

});


parcelRegister("6e8ph", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $7f40387be3419d43$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $7f40387be3419d43$export$5b655fe45447a548);

var $bSJIT = parcelRequire("bSJIT");
const $7f40387be3419d43$export$d452675449e81987 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $7f40387be3419d43$export$5b655fe45447a548 = $7f40387be3419d43$export$d452675449e81987.Provider;

});

parcelRegister("ctw5d", function(module, exports) {
$parcel$export(module.exports, "renderExtension", () => $6a6f5665f4f539d1$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $6a6f5665f4f539d1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $g6Qq4 = parcelRequire("g6Qq4");

var $lPNDS = parcelRequire("lPNDS");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $cvo9f = parcelRequire("cvo9f");

var $cR5yJ = parcelRequire("cR5yJ");

var $ihGX5 = parcelRequire("ihGX5");

var $2U3vi = parcelRequire("2U3vi");

var $6SGk4 = parcelRequire("6SGk4");

var $jFRub = parcelRequire("jFRub");

var $5RUDr = parcelRequire("5RUDr");
function $6a6f5665f4f539d1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6a6f5665f4f539d1$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
/**
 * Mirrors `FORGE_INLINE_BODIED_PARAM` in `@atlassian/xen-editor-provider`. Duplicated rather than
 * imported: the renderer must not depend on a Forge package, and this is a stored parameter name,
 * so it is part of the document contract rather than that package's API.
 */ const $6a6f5665f4f539d1$var$FORGE_INLINE_BODIED_PARAM = 'atlassianForgeInlineBodied';
const $6a6f5665f4f539d1$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $6a6f5665f4f539d1$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $6a6f5665f4f539d1$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $6a6f5665f4f539d1$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $6a6f5665f4f539d1$var$macroHeights[viewportSize];
    }
};
const $6a6f5665f4f539d1$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
/**
 * Fires an analytics event once on mount when a bodied extension is rendered as an inline element.
 * The node is stored in a ref to avoid re-firing if the node reference changes.
 */ const $6a6f5665f4f539d1$var$FireExtensionAsInlineAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, node: node })=>{
    const nodeRef = (0, $bSJIT.useRef)(node);
    (0, $bSJIT.useEffect)(()=>{
        fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).RENDERED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EXTENSION_AS_INLINE,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            attributes: {
                extensionKey: nodeRef.current.extensionKey,
                extensionType: nodeRef.current.extensionType
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    }, [
        fireAnalyticsEvent
    ]);
    return null;
};
const $6a6f5665f4f539d1$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    var _node$parameters, _node$parameters2, _options$dataAttribut;
    const overflowContainerClass = !removeOverflow ? (0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance, fireAnalyticsEvent: fireAnalyticsEvent } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $cvo9f.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $6a6f5665f4f539d1$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    // Forge manifest heights already include px; Connect node heights are numeric strings.
    const extensionMinHeight = extensionHeight !== null && extensionHeight !== void 0 && extensionHeight.endsWith('px') && (0, $gdUUy.fg)('confluence_forge_early_render_reserve_height') ? extensionHeight : extensionHeight && `${extensionHeight}px`;
    /**
   * Scoped to nodes inserted by an app declaring `layout: inline-bodied`, which is what writes
   * `atlassianForgeInlineBodied`. The output-type marker alone would also match migrated Connect
   * content — it carries the same marker, and after an upgrade plus a storage round trip in the
   * same shape — so keying on it would change how existing content renders. The renderer only
   * ever sees the stored node, never the manifest, so a parameter this code writes is the only
   * available signal.
   *
   * Evaluated once and shared with `isNativeForgeInline` below, so the gate is read a single time
   * per render, and the cheap checks stay in front of it so anything ineligible short-circuits
   * without firing an exposure it can never act on.
   */ const hasForgeInlineBodiedMarker = Boolean((node === null || node === void 0 ? void 0 : node.extensionType) === $6a6f5665f4f539d1$var$FORGE_EXTENSION_TYPE && (node === null || node === void 0 ? void 0 : node.content) && (node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.guestParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters[$6a6f5665f4f539d1$var$FORGE_INLINE_BODIED_PARAM]) === 'true');
    const isForgeInlineBodiedEnabled = hasForgeInlineBodiedMarker && (0, $gdUUy.fg)('platform_forge_inline_bodied_macro');
    const isInlineBodiedLayoutEnabled = (node === null || node === void 0 ? void 0 : node.extensionType) === $6a6f5665f4f539d1$var$FORGE_EXTENSION_TYPE && (node === null || node === void 0 ? void 0 : node.type) === 'bodiedExtension' && (node === null || node === void 0 || (_node$parameters2 = node.parameters) === null || _node$parameters2 === void 0 ? void 0 : _node$parameters2.layout) === 'inline-bodied' && (0, $gdUUy.fg)('platform_forge_inline_bodied_layout_switch') && (0, $gdUUy.fg)('platform_forge_inline_bodied_macro');
    /**
   * The pass that marks the sibling textblocks around an inline extension resolves their
   * positions without a depth term, so it only ever matches at the top level. Inlining a nested
   * container without joining its neighbours leaves a shrink-wrapped box alone on its own line,
   * which is worse than leaving it a block — so keep nested inline-bodied Forge macros as
   * blocks until the sibling marking works at depth.
   */ const isNestedForgeInlineBodied = !isTopLevel && (isForgeInlineBodiedEnabled || isInlineBodiedLayoutEnabled);
    const isInline = (shouldDisplayExtensionAsInline === null || shouldDisplayExtensionAsInline === void 0 ? void 0 : shouldDisplayExtensionAsInline(node)) && !isNestedForgeInlineBodied;
    const inlineClassName = isInline ? (0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE : '';
    /**
   * A native Forge macro does not have its body rendered by the product — the body ADF is
   * sent to the app over the bridge and the app renders it with its own nested renderer.
   * The inline styling above stops at the outer wrapper, so mark these nodes to let the
   * nested document's block spacing be collapsed too.
   */ const isNativeForgeInline = Boolean(isInline && isForgeInlineBodiedEnabled);
    /**
   * Migrated inline-bodied macros intentionally do not receive the native Forge marker. Mark the
   * rendered wrapper instead so the stylesheet can fix only the surrounding text flow without
   * applying the native nested-renderer, overflow or sizing rules to migrated content.
   * Custom UI also uses this outer text-flow treatment, without styling inside its iframe.
   */ const isMigratedInlineBodied = Boolean(isInline && (node === null || node === void 0 ? void 0 : node.content) && !hasForgeInlineBodiedMarker && (0, $gdUUy.fg)('platform_forge_inline_bodied_macro'));
    const asInlineAnalytics = isInline && fireAnalyticsEvent && node ? /*#__PURE__*/ (0, $9dQre.jsx)($6a6f5665f4f539d1$var$FireExtensionAsInlineAnalytics, {
        fireAnalyticsEvent: fireAnalyticsEvent,
        node: node
    }) : null;
    const extensionDiv = /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: options.handleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $cvo9f.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
        style: {
            width: isInline ? undefined : ((0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jFRub.calcBreakoutWidthCss)(layout) : (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? undefined : '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            minHeight: isInline ? undefined : extensionMinHeight
        },
        "data-layout": layout,
        "data-local-id": localId,
        "data-renderer-start-pos": (_options$dataAttribut = options.dataAttributes) === null || _options$dataAttribut === void 0 ? void 0 : _options$dataAttribut['data-renderer-start-pos'],
        "data-testid": "extension--wrapper",
        "data-node-type": "extension",
        "data-inline-comments-target": options.isCommentTarget || undefined,
        "data-top-level": isTopLevel || undefined,
        "data-forge-inline": isNativeForgeInline || undefined,
        "data-migrated-inline": isMigratedInlineBodied || undefined,
        onBlur: options.onBlur,
        onFocus: options.onFocus,
        onMouseEnter: options.onMouseEnter,
        onMouseLeave: options.onMouseLeave
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        tabIndex: options.tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $cvo9f.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
        css: [
            !isInsideOfInlineExtension && $6a6f5665f4f539d1$var$containerStyle
        ]
    }, asInlineAnalytics, content));
    return centerAlignClass ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $cvo9f.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $cvo9f.RendererCssClassName).FLEX_CENTER_WRAPPER
    }, extensionDiv) : extensionDiv;
};
const $6a6f5665f4f539d1$var$ExtensionWithAnnotations = (props)=>{
    var _providers$inlineComm, _providers$inlineComm2, _props$dataAttributes;
    const providers = (0, $bSJIT.useContext)((0, $cR5yJ.ProvidersContext));
    const { setHoverTarget: setHoverTarget } = (0, $2U3vi.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $ihGX5.useAnnotationHoverDispatch)();
    const isBlockNodeSupported = providers === null || providers === void 0 || (_providers$inlineComm = providers.inlineComment) === null || _providers$inlineComm === void 0 ? void 0 : _providers$inlineComm.isBlockNodeSupported;
    const supportsComments = (0, $bSJIT.useMemo)(()=>Boolean(props.extensionNode && (isBlockNodeSupported === null || isBlockNodeSupported === void 0 ? void 0 : isBlockNodeSupported(props.extensionNode)) === true), [
        props.extensionNode,
        isBlockNodeSupported
    ]);
    const canCreateCommentOnBlockNode = providers === null || providers === void 0 || (_providers$inlineComm2 = providers.inlineComment) === null || _providers$inlineComm2 === void 0 ? void 0 : _providers$inlineComm2.canCreateCommentOnBlockNode;
    const isFullPageRenderer = props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width';
    // The creation policy may fire an experiment exposure. In the full-page renderer it is only
    // checked once the user hovers or focuses the extension, where the comment target appears.
    // Other renderers have no hover entry point, so they keep checking during render. Saved
    // threads stay viewable through `supportsComments`.
    // Only an allowed result is stored. A rejection is not cached because it can be temporary (for
    // example before Statsig initializes), so the check runs again on the next hover or focus.
    const [allowedCommentNode, setAllowedCommentNode] = (0, $bSJIT.useState)();
    const canCreateDuringRender = (0, $bSJIT.useMemo)(()=>!isFullPageRenderer && Boolean(supportsComments && props.extensionNode && (canCreateCommentOnBlockNode === null || canCreateCommentOnBlockNode === void 0 ? void 0 : canCreateCommentOnBlockNode(props.extensionNode))), [
        isFullPageRenderer,
        supportsComments,
        props.extensionNode,
        canCreateCommentOnBlockNode
    ]);
    const isCommentTarget = Boolean(supportsComments && props.extensionNode && (!canCreateCommentOnBlockNode || canCreateDuringRender || allowedCommentNode === props.extensionNode));
    const isCommentTargetRef = (0, $bSJIT.useRef)(isCommentTarget);
    isCommentTargetRef.current = isCommentTarget;
    const resolveCommentTarget = (0, $bSJIT.useCallback)((target)=>{
        if (isCommentTargetRef.current) return true;
        const node = props.extensionNode;
        if (!supportsComments || !node || !canCreateCommentOnBlockNode || !canCreateCommentOnBlockNode(node)) return false;
        // The hover target is matched against this attribute before React re-renders, so set it
        // now; the batched render below writes the same value.
        target.dataset.inlineCommentsTarget = 'true';
        isCommentTargetRef.current = true;
        setAllowedCommentNode(node);
        return true;
    }, [
        supportsComments,
        props.extensionNode,
        canCreateCommentOnBlockNode
    ]);
    const onMouseEnter = (0, $bSJIT.useCallback)((event)=>{
        if (!resolveCommentTarget(event.currentTarget)) return;
        cancelTimeout();
        if (event.buttons === 0) {
            setHoverTarget === null || setHoverTarget === void 0 || setHoverTarget(event.currentTarget);
            setIsWithinRange(true);
        }
    }, [
        cancelTimeout,
        resolveCommentTarget,
        setHoverTarget,
        setIsWithinRange
    ]);
    const onMouseLeave = (0, $bSJIT.useCallback)(()=>{
        if (isCommentTargetRef.current) initiateTimeout();
    }, [
        initiateTimeout
    ]);
    const onFocus = (0, $bSJIT.useCallback)((event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        if (!resolveCommentTarget(event.currentTarget)) return;
        cancelTimeout();
        setHoverTarget === null || setHoverTarget === void 0 || setHoverTarget(event.currentTarget);
        setIsWithinRange(true);
    }, [
        cancelTimeout,
        resolveCommentTarget,
        setHoverTarget,
        setIsWithinRange
    ]);
    const onBlur = (0, $bSJIT.useCallback)((event)=>{
        if (isCommentTargetRef.current && !event.currentTarget.contains(event.relatedTarget)) initiateTimeout();
    }, [
        initiateTimeout
    ]);
    // Listen whenever comments are supported, so the first hover or focus can check creation.
    const commentTargetOptions = supportsComments && isFullPageRenderer ? {
        isCommentTarget: isCommentTarget,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    } : {
        isCommentTarget: isCommentTarget
    };
    const commentProps = {
        enabled: supportsComments,
        allowAnnotations: props.allowAnnotations,
        allowAnnotationsDraftMode: props.allowAnnotationsDraftMode && isCommentTarget,
        startPos: (_props$dataAttributes = props.dataAttributes) === null || _props$dataAttributes === void 0 ? void 0 : _props$dataAttributes['data-renderer-start-pos'],
        marks: props.marks
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)($6a6f5665f4f539d1$var$ExtensionContent, {
        ...props,
        commentProps: commentProps,
        commentTargetOptions: commentTargetOptions
    });
};
const $6a6f5665f4f539d1$var$ExtensionContent = ({ commentProps: commentProps = {}, commentTargetOptions: commentTargetOptions, ...props })=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6SGk4.default), {
        ...props,
        type: "extension"
    }, ({ isExtensionProviderPending: isExtensionProviderPending, result: result })=>{
        var _props$hideExtensionK;
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(result)) return $6a6f5665f4f539d1$export$b7482bdc8aff85e4(/*#__PURE__*/ (0, $9dQre.jsx)((0, $5RUDr.ExtensionComments), {
                enabled: commentProps.enabled,
                allowAnnotations: commentProps.allowAnnotations,
                allowAnnotationsDraftMode: commentProps.allowAnnotationsDraftMode,
                startPos: commentProps.startPos,
                marks: commentProps.marks
            }, result), layout, {
                dataAttributes: props.dataAttributes,
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance,
                ...commentTargetOptions
            }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        if (isExtensionProviderPending && (_props$hideExtensionK = props.hideExtensionKeysWhilePending) !== null && _props$hideExtensionK !== void 0 && _props$hideExtensionK.includes(props.extensionKey)) return /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
        // Always return default content if anything goes wrong
        return $6a6f5665f4f539d1$export$b7482bdc8aff85e4(/*#__PURE__*/ (0, $9dQre.jsx)((0, $5RUDr.ExtensionComments), {
            enabled: commentProps.enabled,
            allowAnnotations: commentProps.allowAnnotations,
            allowAnnotationsDraftMode: commentProps.allowAnnotationsDraftMode,
            startPos: commentProps.startPos,
            marks: commentProps.marks
        }, text || 'extension'), layout, {
            dataAttributes: props.dataAttributes,
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance,
            ...commentTargetOptions
        }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $6a6f5665f4f539d1$var$Extension = (props)=>{
    // Keep annotation context subscriptions out of the gate-off render path.
    if ((0, $gdUUy.fg)('cc_maui_annotations_on_extensions')) // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9dQre.jsx)($6a6f5665f4f539d1$var$ExtensionWithAnnotations, props);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9dQre.jsx)($6a6f5665f4f539d1$var$ExtensionContent, props);
};
const $6a6f5665f4f539d1$var$_default_1 = (0, $lPNDS.default)($6a6f5665f4f539d1$var$Extension, {
    overflowSelector: `.${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $6a6f5665f4f539d1$export$2e2bcd8739ae039 = $6a6f5665f4f539d1$var$_default_1;

});
parcelRegister("lPNDS", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $ec96bfd33d207795$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $ec96bfd33d207795$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7XiOH = parcelRequire("7XiOH");

var $glREr = parcelRequire("glREr");
const $ec96bfd33d207795$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $ec96bfd33d207795$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        get isDisabled() {
            if (this.disabled === undefined) {
                var _options$isDisabled;
                this.disabled = ((_options$isDisabled = options.isDisabled) === null || _options$isDisabled === void 0 ? void 0 : _options$isDisabled.call(options)) ?? false;
            }
            return this.disabled;
        }
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $7XiOH.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            var _this$props, _this$props2;
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = this.isDisabled ? '' : [
                !((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableTableOverflowShadow) && showRightShadow && $ec96bfd33d207795$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.disableTableOverflowShadow) && showLeftShadow && $ec96bfd33d207795$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $glREr.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (this.isDisabled || options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($ec96bfd33d207795$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (this.isDisabled) return;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $ec96bfd33d207795$var$isElementNode(node) {
    return node.nodeType === 1;
}

});
parcelRegister("7XiOH", function(module, exports) {
$parcel$export(module.exports, "ShadowObserver", () => $901fc70c31a70fd7$export$51a5b28e4fb2dba2);

var $56QTF = parcelRequire("56QTF");

var $glREr = parcelRequire("glREr");
const $901fc70c31a70fd7$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $901fc70c31a70fd7$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $901fc70c31a70fd7$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            [(0, $56QTF.ShadowKeys).SHOW_LEFT_SHADOW]: false,
            [(0, $56QTF.ShadowKeys).SHOW_RIGHT_SHADOW]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add((0, $glREr.shadowObserverClassNames).SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add((0, $glREr.shadowObserverClassNames).SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $901fc70c31a70fd7$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains((0, $glREr.shadowObserverClassNames).SENTINEL_LEFT)) this.shadowStates[(0, $56QTF.ShadowKeys).SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains((0, $glREr.shadowObserverClassNames).SENTINEL_RIGHT)) this.shadowStates[(0, $56QTF.ShadowKeys).SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        var _this$sentinels$left, _this$sentinels$right;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $901fc70c31a70fd7$var$cancelIdleCallback(this.requestCallbackId);
        }
        (_this$sentinels$left = this.sentinels.left) === null || _this$sentinels$left === void 0 || _this$sentinels$left.remove();
        (_this$sentinels$right = this.sentinels.right) === null || _this$sentinels$right === void 0 || _this$sentinels$right.remove();
        this.sentinels = {};
    }
}

});
parcelRegister("56QTF", function(module, exports) {
$parcel$export(module.exports, "ShadowKeys", () => $620762aa308113cb$export$ebeea2fe2e93862e);
var $620762aa308113cb$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});

});

parcelRegister("glREr", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $faa085d8d549aeea$export$1cbe0bb16052178d);
const $faa085d8d549aeea$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};

});



parcelRegister("cvo9f", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $e4bba00561786f1f$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $e4bba00561786f1f$var$clPrefix = 'ak-renderer-';
const $e4bba00561786f1f$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$e4bba00561786f1f$var$clPrefix}document`,
    EXTENSION: `${$e4bba00561786f1f$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$e4bba00561786f1f$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$e4bba00561786f1f$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$e4bba00561786f1f$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$e4bba00561786f1f$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$e4bba00561786f1f$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$e4bba00561786f1f$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$e4bba00561786f1f$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$e4bba00561786f1f$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});

parcelRegister("jFRub", function(module, exports) {
$parcel$export(module.exports, "calcBreakoutWidthCss", () => $8da58534a59db6ba$export$87eeb477611c8fe);
const $8da58534a59db6ba$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};

});

parcelRegister("5RUDr", function(module, exports) {
$parcel$export(module.exports, "ExtensionComments", () => $f66ed449d0258472$export$933bbfa6d43bf61d);
/* extension-comments.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $459x8 = parcelRequire("459x8");

var $6Ilty = parcelRequire("6Ilty");

var $4GPCq = parcelRequire("4GPCq");

var $il86U = parcelRequire("il86U");

var $2U3vi = parcelRequire("2U3vi");

var $irlz7 = parcelRequire("irlz7");

var $janpo = parcelRequire("janpo");

var $katwF = parcelRequire("katwF");
const $f66ed449d0258472$var$containerStyles = null;
const $f66ed449d0258472$var$annotationParentIds = [];
const $f66ed449d0258472$var$annotationDataAttributes = {
    'data-renderer-mark': true,
    'data-block-mark': true
};
const $f66ed449d0258472$var$badgeStyles = null;
const $f66ed449d0258472$var$ExtensionCommentsEnabled = ({ marks: marks, children: children, enabled: enabled, allowAnnotations: allowAnnotations, allowAnnotationsDraftMode: allowAnnotationsDraftMode, startPos: startPos })=>{
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $2U3vi.useAnnotationRangeState)();
    const isDraft = Boolean(enabled && allowAnnotationsDraftMode && hoverDraftDocumentPosition && hoverDraftDocumentPosition.from + 1 === startPos);
    const updateSubscriber = (0, $irlz7.useInlineCommentSubscriberContext)();
    const annotationIds = (0, $bSJIT.useMemo)(()=>(marks === null || marks === void 0 ? void 0 : marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>mark.attrs.id)) ?? [], [
        marks
    ]);
    const activeIds = (0, $janpo.useInlineCommentsFilter)({
        annotationIds: annotationIds,
        filter: {
            state: (0, $9IULF.AnnotationMarkStates).ACTIVE
        }
    });
    const [focusedId, setFocusedId] = (0, $bSJIT.useState)();
    const [entered, setEntered] = (0, $bSJIT.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $il86U.useAnnotationManagerState)();
    const active = activeIds.some((id)=>id === focusedId || id === currentSelectedAnnotationId);
    (0, $bSJIT.useEffect)(()=>{
        if (!updateSubscriber) return;
        const onFocus = (payload)=>setFocusedId(payload === null || payload === void 0 ? void 0 : payload.annotationId);
        const onBlur = ()=>setFocusedId(undefined);
        updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onFocus);
        updateSubscriber.on((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onBlur);
        return ()=>{
            updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onFocus);
            updateSubscriber.off((0, $4GPCq.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onBlur);
        };
    }, [
        updateSubscriber
    ]);
    const onClick = (0, $bSJIT.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        // Anchor the thread to this chart, not an icon inside the badge or a nested renderer.
        const extension = event.currentTarget.closest('.ak-renderer-extension');
        if (extension && activeIds.length) updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.emit((0, $4GPCq.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeIds,
            eventTarget: extension,
            eventTargetType: 'extension',
            viewMethod: (0, $459x8.VIEW_METHOD).BADGE
        });
    }, [
        activeIds,
        updateSubscriber
    ]);
    const onMouseEnter = (0, $bSJIT.useCallback)(()=>setEntered(true), []);
    const onMouseLeave = (0, $bSJIT.useCallback)(()=>setEntered(false), []);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-annotation-draft-mark": isDraft || undefined,
        "data-renderer-mark": isDraft || undefined,
        "data-renderer-start-pos": isDraft ? startPos : undefined,
        className: (0, $9fU1q.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            allowAnnotations && annotationIds.map((id)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $katwF.default), {
                    id: id,
                    annotationType: (0, $9IULF.AnnotationTypes).INLINE_COMMENT,
                    annotationParentIds: $f66ed449d0258472$var$annotationParentIds,
                    allowAnnotations: true,
                    useBlockLevel: true,
                    isExtension: true,
                    dataAttributes: $f66ed449d0258472$var$annotationDataAttributes
                }, id)),
            enabled && activeIds.length > 0 && updateSubscriber && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_kqswstnw _154iu2gc _1xi2u2gc"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6Ilty.CommentBadgeNext), {
                    status: active ? 'active' : entered ? 'entered' : 'default',
                    onClick: onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                })
            })
        ]
    });
};
const $f66ed449d0258472$export$933bbfa6d43bf61d = (props)=>{
    if (!props.enabled && !props.allowAnnotations) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($f66ed449d0258472$var$ExtensionCommentsEnabled, {
        enabled: props.enabled,
        allowAnnotations: props.allowAnnotations,
        allowAnnotationsDraftMode: props.allowAnnotationsDraftMode,
        startPos: props.startPos,
        marks: props.marks,
        children: props.children
    });
};

});
parcelRegister("459x8", function(module, exports) {
$parcel$export(module.exports, "RESOLVE_METHOD", () => $fe9a29b0986c83ad$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $fe9a29b0986c83ad$export$9cf3651d97128b9c);
var $fe9a29b0986c83ad$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $fe9a29b0986c83ad$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("6Ilty", function(module, exports) {
$parcel$export(module.exports, "CommentBadgeNext", () => $9856eca9feee0522$export$d5da84b0136a0cc4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $eYvps = parcelRequire("eYvps");

var $3y2s4 = parcelRequire("3y2s4");

var $aHbh3 = parcelRequire("aHbh3");

var $9BVpB = parcelRequire("9BVpB");

var $lavtv = parcelRequire("lavtv");

var $1oKa3 = parcelRequire("1oKa3");
const $9856eca9feee0522$var$baseStyles = (0, $9BVpB.xcss)({
    borderRadius: 'radius.small'
});
const $9856eca9feee0522$var$mediumBadgeStyles = (0, $9BVpB.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $9856eca9feee0522$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $4vLTk.default)();
    const title = intl.formatMessage((0, $1oKa3.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $bSJIT.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aHbh3.Pressable), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $9856eca9feee0522$var$baseStyles,
                $9856eca9feee0522$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eYvps))), {
                label: title,
                spacing: "spacious",
                color: (0, $3y2s4.isExperimentEnabled)('cc_comments_media_viewer_sidebar') ? "var(--ds-icon-accent-yellow, #B38600)" : 'currentColor'
            })
        })
    });
};

});
parcelRegister("1oKa3", function(module, exports) {
$parcel$export(module.exports, "commentMessages", () => $f74d8a2a404bdc5e$export$4c0d145df60cfb04);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f74d8a2a404bdc5e$export$4c0d145df60cfb04 = (0, $f0Pt4.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'The text is shown on a button in the media floating toolbar that opens the comments panel, allowing the user to view existing comments and add new ones for the selected image or media item.'
    }
});

});


parcelRegister("irlz7", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $f31837e9522cf3bc$export$b46737175cffd396);

var $bSJIT = parcelRequire("bSJIT");

var $cR5yJ = parcelRequire("cR5yJ");
const $f31837e9522cf3bc$export$b46737175cffd396 = ()=>{
    const providers = (0, $bSJIT.useContext)((0, $cR5yJ.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});

parcelRegister("janpo", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $fa00d6dca1738e7a$export$8e7d47f9e38ad4f1);

var $bSJIT = parcelRequire("bSJIT");

var $cR5yJ = parcelRequire("cR5yJ");
const $fa00d6dca1738e7a$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $bSJIT.useContext)((0, $cR5yJ.InlineCommentsStateContext));
    return (0, $bSJIT.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("katwF", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $0d9a679645a1f933$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $0d9a679645a1f933$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $5E2mM = parcelRequire("5E2mM");
const $0d9a679645a1f933$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $0d9a679645a1f933$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isExtension: isExtension, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $9IULF.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $5E2mM.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        isExtension: isExtension,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $0d9a679645a1f933$export$2e2bcd8739ae039 = $0d9a679645a1f933$var$AnnotationComponent;

});
parcelRegister("5E2mM", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $f97f72d49e7835f5$export$f3069f755c1eba0b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9IULF = parcelRequire("9IULF");

var $4GPCq = parcelRequire("4GPCq");

var $cR5yJ = parcelRequire("cR5yJ");

var $il86U = parcelRequire("il86U");

var $gj7PC = parcelRequire("gj7PC");

var $irlz7 = parcelRequire("irlz7");

var $janpo = parcelRequire("janpo");

var $fYKZ6 = parcelRequire("fYKZ6");
const $f97f72d49e7835f5$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel, isExtension: isExtension })=>{
    const updateSubscriber = (0, $irlz7.useInlineCommentSubscriberContext)();
    const states = (0, $bSJIT.useContext)((0, $cR5yJ.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $gj7PC.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $bSJIT.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $il86U.useAnnotationManagerDispatch)();
    const onClick = (0, $bSJIT.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager === null || annotationManager === void 0 || annotationManager.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $4GPCq.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $janpo.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $9IULF.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fYKZ6.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        isExtension: isExtension,
        children: children
    });
};

});
parcelRegister("fYKZ6", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $aed926ba2df6469e$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $9IULF = parcelRequire("9IULF");

var $gdUUy = parcelRequire("gdUUy");

var $d8oXW = parcelRequire("d8oXW");

var $il86U = parcelRequire("il86U");

var $9FsGR = parcelRequire("9FsGR");
const $aed926ba2df6469e$var$markStyles = /*#__PURE__*/ (0, $9dQre.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $9IULF.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $aed926ba2df6469e$var$markStylesLayeringFix = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $9IULF.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $aed926ba2df6469e$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $9IULF.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $aed926ba2df6469e$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $9IULF.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $aed926ba2df6469e$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $9IULF.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $aed926ba2df6469e$var$MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const $aed926ba2df6469e$var$isMobile = ()=>{
    return $aed926ba2df6469e$var$MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};
const $aed926ba2df6469e$var$accessibilityStylesNew = /*#__PURE__*/ (0, $9dQre.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $aed926ba2df6469e$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel, isExtension: isExtension })=>{
    const intl = (0, $4vLTk.default)();
    const annotationIds = (0, $bSJIT.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $il86U.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $il86U.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $bSJIT.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $bSJIT.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $9IULF.AnnotationMarkStates).ACTIVE) return;
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        var _document$activeEleme;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- keyboard focus for mark / Enter handling
        const focusedElementTag = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $aed926ba2df6469e$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $9IULF.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    if (isExtension && (0, $gdUUy.fg)('cc_maui_annotations_on_extensions')) // The chart's badge owns interaction. Anchors only supply geometry and annotation state.
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $9FsGR.ExtensionAnnotation), {
        id: id,
        dataAttributes: overriddenData,
        markRef: id === currentSelectedAnnotationId ? markRef : undefined
    });
    return (0, $9dQre.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $aed926ba2df6469e$var$markStyles,
                $aed926ba2df6469e$var$markStylesLayeringFix,
                (0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') && $aed926ba2df6469e$var$markStylesWithInlineComments,
                $aed926ba2df6469e$var$markStylesWithCommentsPanel,
                !$aed926ba2df6469e$var$isMobile() && $aed926ba2df6469e$var$accessibilityStylesNew,
                $aed926ba2df6469e$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $d8oXW.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $d8oXW.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            }
        }
    }, children);
};

});
parcelRegister("d8oXW", function(module, exports) {
$parcel$export(module.exports, "collapsibleHeadingMessages", () => $193346cdd31deb25$export$7f5b2987e1dbb312);
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $193346cdd31deb25$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $193346cdd31deb25$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $193346cdd31deb25$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $f0Pt4 = parcelRequire("f0Pt4");
const $193346cdd31deb25$export$7f5b2987e1dbb312 = (0, $f0Pt4.defineMessages)({
    collapseSection: {
        id: 'fabric.editor.collapsibleHeading.collapseSection.ai-non-final',
        defaultMessage: 'Collapse section',
        description: 'Accessible label and tooltip for the button beside an expanded renderer heading. Activating the button hides the content in that heading section.'
    },
    expandSection: {
        id: 'fabric.editor.collapsibleHeading.expandSection.ai-non-final',
        defaultMessage: 'Expand section',
        description: 'Accessible label and tooltip for the button beside a collapsed renderer heading. Activating the button reveals the content in that heading section.'
    }
});
const $193346cdd31deb25$export$74bada844422036d = (0, $f0Pt4.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Tooltip and aria-label for the button that copies an anchor link to a heading in the rendered document to the clipboard.'
    },
    copyLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLinkTo',
        defaultMessage: 'Copy link to',
        description: 'Copy heading link to clipboard. Will be used as part of a 2-part a11y label ("Copy link to", "{heading text}")'
    },
    copyHeadingLinkLabelledBy: {
        id: 'fabric.editor.headingLink.copyAnchorLinkLabelledBy',
        defaultMessage: '{copyLink} {heading}',
        description: 'The order in which to read the parts of the aria-labelledby for the copy heading link button depending on the grammar of the language. {copyLink} will be replaced with the "Copy link to" text and {heading} will be replaced with the actual heading text'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly on the copy button after the heading anchor link has been successfully copied to the clipboard.'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'Aria label for the copy link button displayed next to a heading. Used by screen readers to describe the button that copies the heading anchor link to the clipboard.'
    }
});
const $193346cdd31deb25$export$c79ebc36348824d1 = (0, $f0Pt4.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'Accessible label for a table column sort indicator when no sorting is applied to that column.'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $193346cdd31deb25$export$9f52c375a6ef34fc = (0, $f0Pt4.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});

parcelRegister("9FsGR", function(module, exports) {
$parcel$export(module.exports, "ExtensionAnnotation", () => $f4260746ad7ef233$export$723dc5b6097df2eb);
/* extension.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $f4260746ad7ef233$var$styles = {
    anchor: "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _lcxvglyw"
};
const $f4260746ad7ef233$export$723dc5b6097df2eb = ({ id: id, dataAttributes: dataAttributes, markRef: markRef })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        id: id,
        ref: markRef,
        "data-id": dataAttributes['data-id'],
        "data-mark-type": dataAttributes['data-mark-type'],
        "data-mark-annotation-type": dataAttributes['data-mark-annotation-type'],
        "data-mark-annotation-state": dataAttributes['data-mark-annotation-state'],
        "data-block-mark": dataAttributes['data-block-mark'],
        "data-renderer-mark": dataAttributes['data-renderer-mark'],
        "data-has-focus": dataAttributes['data-has-focus'],
        "data-is-hovered": dataAttributes['data-is-hovered'],
        className: (0, $9fU1q.default)([
            $f4260746ad7ef233$var$styles.anchor
        ])
    });

});







parcelRegister("i8NSZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d4fe8d971cfa63a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cm5bx = parcelRequire("cm5bx");

var $3TgA6 = parcelRequire("3TgA6");
function $6d4fe8d971cfa63a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cm5bx.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $3TgA6.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("3TgA6", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $473635500e0af49b$export$75aa84e85754623e);
function $473635500e0af49b$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("jnOB4", function(module, exports) {
$parcel$export(module.exports, "default", () => $53ef92ddbb6c9490$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gISgh = parcelRequire("gISgh");
const $53ef92ddbb6c9490$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gISgh.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $53ef92ddbb6c9490$export$2e2bcd8739ae039 = $53ef92ddbb6c9490$var$RenderCaption;

});
parcelRegister("gISgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a83d84ccd890c549$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $2jPaU = parcelRequire("2jPaU");
function $a83d84ccd890c549$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a83d84ccd890c549$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $a83d84ccd890c549$var$placeholderStyle = (0, $9BVpB.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $a83d84ccd890c549$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $a83d84ccd890c549$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
            xcss: $a83d84ccd890c549$var$placeholderStyle
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $aRsbV.Text), null, formatMessage((0, $2jPaU.messages).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $a83d84ccd890c549$var$_default_1 = (0, $fK3tS.default)($a83d84ccd890c549$export$f7feb87190a94c76);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a83d84ccd890c549$export$2e2bcd8739ae039 = $a83d84ccd890c549$var$_default_1;

});
parcelRegister("2jPaU", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d147c2c3cc5e18b1$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $d147c2c3cc5e18b1$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("37JJb", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b5bb42339687e9c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $5b5bb42339687e9c$export$41121a410ca2f650);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cvo9f = parcelRequire("cvo9f");

var $ejWrj = parcelRequire("ejWrj");
function $5b5bb42339687e9c$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $cvo9f.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $5b5bb42339687e9c$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: (0, $ejWrj.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cvo9f.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("ejWrj", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $4ee75782a25999ee$export$98871b245ee25215);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $kTBKs = parcelRequire("kTBKs");

var $6NXG5 = parcelRequire("6NXG5");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4ee75782a25999ee$var$MAC_PLATFORM_REGEX = /Mac/;
const $4ee75782a25999ee$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $kTBKs.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef();
    const mac = typeof navigator !== 'undefined' ? $4ee75782a25999ee$var$MAC_PLATFORM_REGEX.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((e)=>{
        var _e$target, _e$target$matches;
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $6NXG5.ElementSelection).fromWindow();
        const isInput = (_e$target = e.target) === null || _e$target === void 0 || (_e$target$matches = _e$target.matches) === null || _e$target$matches === void 0 ? void 0 : _e$target$matches.call(_e$target, 'input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                action: (0, $g6Qq4.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                action: (0, $g6Qq4.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((e)=>{
        var _ref$current;
        clicked.current = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("kTBKs", function(module, exports) {
$parcel$export(module.exports, "default", () => $31037fe4fa5f1231$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $31037fe4fa5f1231$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $31037fe4fa5f1231$export$2e2bcd8739ae039 = $31037fe4fa5f1231$var$AnalyticsContext;

});

parcelRegister("6NXG5", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $6302286a0505fdc5$export$6e6724d89f27411);
class $6302286a0505fdc5$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            var _this$range, _this$range2;
            const startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
            const endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        var _this$range3;
        return el.contains(((_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $6302286a0505fdc5$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $6302286a0505fdc5$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("ktryv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5493f1b3d8b060ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9dQre = parcelRequire("9dQre");
const $5493f1b3d8b060ab$var$containerCSS = /*#__PURE__*/ (0, $9dQre.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $5493f1b3d8b060ab$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $5493f1b3d8b060ab$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $5493f1b3d8b060ab$export$2e2bcd8739ae039 = $5493f1b3d8b060ab$var$ExtensionFrame;

});

parcelRegister("aqjYr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6fe6d07db60f54$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $3f6fe6d07db60f54$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("br", {}),
            /*#__PURE__*/ (0, $dc70d.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("br", {});
};
var $3f6fe6d07db60f54$export$2e2bcd8739ae039 = $3f6fe6d07db60f54$var$HardBreak;

});

parcelRegister("eR3yK", function(module, exports) {
$parcel$export(module.exports, "default", () => $948b8a82097dd39e$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $4TRbS = parcelRequire("4TRbS");

var $g6Qq4 = parcelRequire("g6Qq4");

var $l9Ysx = parcelRequire("l9Ysx");

var $juFEH = parcelRequire("juFEH");

var $5N1Y4 = parcelRequire("5N1Y4");

var $9Abbn = parcelRequire("9Abbn");

var $kTBKs = parcelRequire("kTBKs");

var $d8oXW = parcelRequire("d8oXW");

var $3eeik = parcelRequire("3eeik");

var $2gm7Q = parcelRequire("2gm7Q");

var $b82GM = parcelRequire("b82GM");
const $948b8a82097dd39e$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $948b8a82097dd39e$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER = 'renderer-collapsible-heading-wrapper';
const $948b8a82097dd39e$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $948b8a82097dd39e$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
// Matches the editor's decoration-based number prefix without changing heading text or IDs.
const $948b8a82097dd39e$var$numberedHeadingStyles = null;
const $948b8a82097dd39e$var$wrapperStyles = null;
const $948b8a82097dd39e$var$collapsibleHeadingWrapperStyles = null;
const $948b8a82097dd39e$var$collapsibleHeadingButtonStyles = null;
const $948b8a82097dd39e$var$collapsibleHeadingButtonExpandedStyles = null;
const $948b8a82097dd39e$var$collapsibleHeadingButtonHiddenStyles = null;
const $948b8a82097dd39e$var$ChevronRightSmallIcon = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
        label: "",
        size: "small"
    });
const $948b8a82097dd39e$var$hasFocusVisible = (target)=>{
    try {
        return target.matches(':focus-visible');
    } catch  {
        return true;
    }
};
const $948b8a82097dd39e$var$getHeadingAnchorLinksConfig = (allowHeadingAnchorLinks)=>typeof allowHeadingAnchorLinks === 'object' ? allowHeadingAnchorLinks : undefined;
function $948b8a82097dd39e$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, getHeadingLink: getHeadingLink, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kTBKs.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $b82GM.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).CLICKED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $g6Qq4.EVENT_TYPE).UI
                    });
                    return (0, $2gm7Q.copyTextToClipboard)((getHeadingLink === null || getHeadingLink === void 0 ? void 0 : getHeadingLink(headingId)) ?? $948b8a82097dd39e$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $948b8a82097dd39e$var$CollapsibleHeadingButton({ collapsibleHeading: collapsibleHeading, headingLevel: headingLevel, isHeadingHovered: isHeadingHovered }) {
    const intl = (0, $4vLTk.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $kTBKs.default));
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const { isCollapsed: isCollapsed, toggle: toggle } = collapsibleHeading;
    const isVisible = isCollapsed || isFocused || isHeadingHovered;
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        event.stopPropagation();
        fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).TOGGLED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).HEADING,
            attributes: {
                expanded: isCollapsed,
                headingLevel: headingLevel
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        });
        toggle();
    }, [
        fireAnalyticsEvent,
        headingLevel,
        isCollapsed,
        toggle
    ]);
    const handleFocus = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        setIsFocused($948b8a82097dd39e$var$hasFocusVisible(event.target));
    }, []);
    const handleBlur = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>setIsFocused(false), []);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>setIsFocused(true), []);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_kqswstnw _152tidpf _1e02idpf _1pbykb7n _l8ku180e _wxvuglyw",
            !isCollapsed && "_12hn14w8",
            !isVisible && "_tzy4idpf _lcxvglyw _tza3kb7n _12yg1wug _xrqrkb7n _l4c51wug"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: $948b8a82097dd39e$var$ChevronRightSmallIcon,
            label: intl.formatMessage(isCollapsed ? (0, $d8oXW.collapsibleHeadingMessages).expandSection : (0, $d8oXW.collapsibleHeadingMessages).collapseSection),
            "aria-expanded": !isCollapsed,
            isTooltipDisabled: false,
            testId: "collapsible-heading-button",
            onClick: handleClick,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown
        })
    });
}
function $948b8a82097dd39e$var$CollapsibleHeadingContainer({ children: children, collapsibleHeading: collapsibleHeading, headingLevel: headingLevel }) {
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const mouseEnterHandler = ()=>{
        if (!mouseEntered.current) {
            (0, $juFEH.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-testid": $948b8a82097dd39e$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER,
        "data-level": headingLevel,
        onMouseEnter: ()=>{
            mouseEnterHandler();
            setIsHovered(true);
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: (event)=>setIsFocused($948b8a82097dd39e$var$hasFocusVisible(event.target)),
        onBlur: ()=>setIsFocused(false),
        className: (0, $9fU1q.default)([
            "_ahbqukr8 _bozgxy5q _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$CollapsibleHeadingButton, {
                collapsibleHeading: collapsibleHeading,
                headingLevel: headingLevel,
                isHeadingHovered: isHovered || isFocused
            }),
            children
        ]
    });
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $948b8a82097dd39e$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $948b8a82097dd39e$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $948b8a82097dd39e$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $juFEH.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)(HX, {
                "data-heading-number": props.headingNumber,
                id: headingIdToUse,
                "data-local-id": localId,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                "data-as-inline": asInline,
                onMouseEnter: mouseEnterHandler,
                tabIndex: -1,
                className: (0, $9fU1q.default)([
                    props.headingNumber && "_1kt9j9bv _1mbqu2gc _1wqoglyw"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            getHeadingLink: getHeadingLink,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            getHeadingLink: getHeadingLink,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    getHeadingLink: getHeadingLink,
                    headingId: headingId
                })
            })
        ]
    });
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $948b8a82097dd39e$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline, collapsibleHeading: collapsibleHeading } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $948b8a82097dd39e$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $948b8a82097dd39e$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if ((showAnchorLink || collapsibleHeading) && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $juFEH.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    const handleWrapperMouseEnter = ()=>{
        mouseEnterHandler();
        setIsHovered(true);
    };
    const handleWrapperMouseLeave = ()=>setIsHovered(false);
    const handleWrapperFocus = (event)=>setIsFocused($948b8a82097dd39e$var$hasFocusVisible(event.target));
    const handleWrapperBlur = ()=>setIsFocused(false);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1e0c1ule",
            collapsibleHeading && "_ahbqukr8 _bozgxy5q _kqswh2mm",
            $948b8a82097dd39e$var$RENDERER_HEADING_WRAPPER
        ]),
        "data-testid": $948b8a82097dd39e$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        onMouseEnter: collapsibleHeading ? handleWrapperMouseEnter : undefined,
        onMouseLeave: collapsibleHeading ? handleWrapperMouseLeave : undefined,
        onFocus: collapsibleHeading ? handleWrapperFocus : undefined,
        onBlur: collapsibleHeading ? handleWrapperBlur : undefined,
        children: [
            collapsibleHeading && /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$CollapsibleHeadingButton, {
                collapsibleHeading: collapsibleHeading,
                headingLevel: props.level,
                isHeadingHovered: isHovered || isFocused
            }),
            showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$WrappedHeadingAnchor, {
                level: props.level,
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                getHeadingLink: getHeadingLink,
                headingId: headingId,
                hideFromScreenReader: false
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)(HX, {
                "data-heading-number": props.headingNumber,
                id: headingIdToUse,
                "data-local-id": localId,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                "data-as-inline": asInline,
                onMouseEnter: collapsibleHeading ? undefined : mouseEnterHandler,
                tabIndex: -1,
                className: (0, $9fU1q.default)([
                    props.headingNumber && "_1kt9j9bv _1mbqu2gc _1wqoglyw"
                ]),
                children: props.children
            }),
            showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$WrappedHeadingAnchor, {
                level: props.level,
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                getHeadingLink: getHeadingLink,
                headingId: headingId,
                hideFromScreenReader: false
            })
        ]
    });
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise preserves HeadingWithDuplicateAnchor (old structure), adding only the collapse
 *   container when the top-level heading is collapsible
 */ function $948b8a82097dd39e$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, headingNumber: headingNumber, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, path: path, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    const collapsibleHeading = (0, $3eeik.useCollapsibleHeading)(dataAttributes['data-renderer-start-pos'], (path === null || path === void 0 ? void 0 : path.length) === 0);
    if ((0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        headingNumber: headingNumber,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline,
        collapsibleHeading: collapsibleHeading,
        children: children
    });
    const headingWithDuplicateAnchor = /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        headingNumber: headingNumber,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline,
        children: children
    });
    if (collapsibleHeading) return /*#__PURE__*/ (0, $dc70d.jsx)($948b8a82097dd39e$var$CollapsibleHeadingContainer, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: level,
        children: headingWithDuplicateAnchor
    });
    return headingWithDuplicateAnchor;
}
var $948b8a82097dd39e$export$2e2bcd8739ae039 = $948b8a82097dd39e$var$Heading;

});
parcelRegister("3eeik", function(module, exports) {
$parcel$export(module.exports, "CollapsibleHeadingsProvider", () => $a1350651df5dfdfe$export$158f0ca2ade2cf24);
$parcel$export(module.exports, "useCollapsibleHeading", () => $a1350651df5dfdfe$export$3df123b939d40b52);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $dMMwa = parcelRequire("dMMwa");

var $2Zash = parcelRequire("2Zash");

var $aqeHn = parcelRequire("aqeHn");
const $a1350651df5dfdfe$var$CollapsibleHeadingsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(null);
const $a1350651df5dfdfe$var$emptyCollapsedHeadings = new Set();
function $a1350651df5dfdfe$var$isSameDocument(currentDocument, nextDocument) {
    if (currentDocument === nextDocument) return true;
    if (!currentDocument || !nextDocument) return false;
    // Node.eq compares node-type identity. The shared schema cache can be evicted by another
    // renderer, producing different node types for identical content on the next render.
    return currentDocument.type.schema === nextDocument.type.schema ? currentDocument.eq(nextDocument) : (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(currentDocument.toJSON(), nextDocument.toJSON());
}
function $a1350651df5dfdfe$var$supportsHiddenUntilFound(rendererRef) {
    var _rendererRef$current;
    const body = (_rendererRef$current = rendererRef.current) === null || _rendererRef$current === void 0 ? void 0 : _rendererRef$current.ownerDocument.body;
    return body ? 'onbeforematch' in body : false;
}
function $a1350651df5dfdfe$export$158f0ca2ade2cf24({ children: children, isEnabled: isEnabled, pmDocument: pmDocument, rendererRef: rendererRef }) {
    const [isBrowserFindSupported, setIsBrowserFindSupported] = (0, $bSJIT.useState)(false);
    const [state, setState] = (0, $bSJIT.useState)({
        pmDocument: pmDocument,
        positions: new Set()
    });
    const originalHiddenAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(new WeakMap()).current;
    const sections = (0, $bSJIT.useMemo)(()=>(0, $aqeHn.buildTopLevelHeadingSections)(pmDocument), [
        pmDocument
    ]);
    const collapsibleSectionPositions = (0, $bSJIT.useMemo)(()=>new Set(sections.filter((section)=>section.contentFrom < section.to).map((section)=>section.headingPos)), [
        sections
    ]);
    const isCurrentDocument = $a1350651df5dfdfe$var$isSameDocument(state.pmDocument, pmDocument);
    const collapsedHeadings = isCurrentDocument ? state.positions : $a1350651df5dfdfe$var$emptyCollapsedHeadings;
    const isActive = isEnabled && isBrowserFindSupported && Boolean(pmDocument);
    (0, $bSJIT.useEffect)(()=>{
        setIsBrowserFindSupported(isEnabled && $a1350651df5dfdfe$var$supportsHiddenUntilFound(rendererRef));
    }, [
        isEnabled,
        rendererRef
    ]);
    const updateCollapsedHeadings = (0, $bSJIT.useCallback)((update)=>{
        setState((currentState)=>{
            const isStillCurrentDocument = $a1350651df5dfdfe$var$isSameDocument(currentState.pmDocument, pmDocument);
            const positions = new Set(isStillCurrentDocument ? currentState.positions : $a1350651df5dfdfe$var$emptyCollapsedHeadings);
            if (!update(positions)) return isStillCurrentDocument ? currentState : {
                pmDocument: pmDocument,
                positions: positions
            };
            return {
                pmDocument: pmDocument,
                positions: positions
            };
        });
    }, [
        pmDocument
    ]);
    const collapse = (0, $bSJIT.useCallback)((headingPos)=>{
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings((positions)=>{
            if (positions.has(headingPos)) return false;
            positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    const expand = (0, $bSJIT.useCallback)((headingPos)=>{
        updateCollapsedHeadings((positions)=>positions.delete(headingPos));
    }, [
        updateCollapsedHeadings
    ]);
    const expandMany = (0, $bSJIT.useCallback)((headingPositions)=>{
        const positionsToExpand = new Set(headingPositions);
        updateCollapsedHeadings((positions)=>{
            let didChange = false;
            positionsToExpand.forEach((headingPos)=>{
                didChange = positions.delete(headingPos) || didChange;
            });
            return didChange;
        });
    }, [
        updateCollapsedHeadings
    ]);
    const expandContainingPosition = (0, $bSJIT.useCallback)((position)=>{
        expandMany(sections.filter((section)=>position >= section.contentFrom && position < section.to).map((section)=>section.headingPos));
    }, [
        expandMany,
        sections
    ]);
    const toggle = (0, $bSJIT.useCallback)((headingPos)=>{
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings((positions)=>{
            if (positions.has(headingPos)) positions.delete(headingPos);
            else positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    const contextValue = (0, $bSJIT.useMemo)(()=>isActive ? {
            canCollapse: (headingPos)=>collapsibleSectionPositions.has(headingPos),
            collapse: collapse,
            expand: expand,
            expandContainingPosition: expandContainingPosition,
            expandMany: expandMany,
            isCollapsed: (headingPos)=>collapsedHeadings.has(headingPos),
            toggle: toggle
        } : null, [
        collapse,
        collapsedHeadings,
        collapsibleSectionPositions,
        expand,
        expandContainingPosition,
        expandMany,
        isActive,
        toggle
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const rendererRoot = rendererRef.current;
        if (!rendererRoot) return;
        const positions = isActive ? collapsedHeadings : $a1350651df5dfdfe$var$emptyCollapsedHeadings;
        const sync = ()=>(0, $2Zash.reconcileCollapsedHeadingContent)({
                collapsedHeadings: positions,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: sections
            });
        sync();
        if (!isActive || positions.size === 0) return;
        const rendererDocuments = (0, $2Zash.getOwnedRendererDocuments)(rendererRoot);
        const rendererDocumentSet = new Set(rendererDocuments);
        const handleBeforeMatch = (event)=>{
            var _rendererRoot$ownerDo;
            const target = event.target;
            const HTMLElementConstructor = (_rendererRoot$ownerDo = rendererRoot.ownerDocument.defaultView) === null || _rendererRoot$ownerDo === void 0 ? void 0 : _rendererRoot$ownerDo.HTMLElement;
            if (!HTMLElementConstructor || !(target instanceof HTMLElementConstructor)) return;
            const collapsedContent = target.closest(`[${(0, $2Zash.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE)}]`);
            if (!collapsedContent) return;
            const rendererDocument = collapsedContent.closest('.ak-renderer-document');
            if (!rendererDocument || !rendererDocumentSet.has(rendererDocument)) return;
            expandMany((0, $2Zash.getCollapsedContentOwners)(collapsedContent));
        };
        const unbindBeforeMatchListeners = rendererDocuments.map((rendererDocument)=>(0, $bAB3U.bind)(rendererDocument, {
                type: 'beforematch',
                listener: handleBeforeMatch,
                options: {
                    capture: true
                }
            }));
        const observer = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(sync);
        rendererDocuments.forEach((rendererDocument)=>{
            observer === null || observer === void 0 || observer.observe(rendererDocument, {
                childList: true
            });
        });
        return ()=>{
            observer === null || observer === void 0 || observer.disconnect();
            unbindBeforeMatchListeners.forEach((unbindBeforeMatch)=>unbindBeforeMatch());
        };
    }, [
        collapsedHeadings,
        expandMany,
        isActive,
        originalHiddenAttributes,
        rendererRef,
        sections
    ]);
    (0, $bSJIT.useEffect)(()=>()=>{
            const rendererRoot = rendererRef.current;
            if (rendererRoot) (0, $2Zash.reconcileCollapsedHeadingContent)({
                collapsedHeadings: $a1350651df5dfdfe$var$emptyCollapsedHeadings,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: []
            });
        }, [
        originalHiddenAttributes,
        rendererRef
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($a1350651df5dfdfe$var$CollapsibleHeadingsContext.Provider, {
        value: contextValue,
        children: children
    });
}
function $a1350651df5dfdfe$export$3df123b939d40b52(startPos, isTopLevel) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($a1350651df5dfdfe$var$CollapsibleHeadingsContext);
    const contextToggle = context === null || context === void 0 ? void 0 : context.toggle;
    const isCollapsible = Boolean(context && isTopLevel && context.canCollapse(startPos));
    const isCollapsed = Boolean(isCollapsible && (context === null || context === void 0 ? void 0 : context.isCollapsed(startPos)));
    const toggle = (0, $bSJIT.useCallback)(()=>contextToggle === null || contextToggle === void 0 ? void 0 : contextToggle(startPos), [
        contextToggle,
        startPos
    ]);
    return (0, $bSJIT.useMemo)(()=>isCollapsible ? {
            isCollapsed: isCollapsed,
            toggle: toggle
        } : null, [
        isCollapsed,
        isCollapsible,
        toggle
    ]);
}
function $a1350651df5dfdfe$export$16b4e68f51f04e9e() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($a1350651df5dfdfe$var$CollapsibleHeadingsContext);
}

});
parcelRegister("2Zash", function(module, exports) {
$parcel$export(module.exports, "COLLAPSED_CONTENT_OWNERS_ATTRIBUTE", () => $6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4);
$parcel$export(module.exports, "getOwnedRendererDocuments", () => $6e8af6f8f26ec47e$export$236858493fcc483b);
$parcel$export(module.exports, "reconcileCollapsedHeadingContent", () => $6e8af6f8f26ec47e$export$371cf0cf237e6c69);
$parcel$export(module.exports, "getCollapsedContentOwners", () => $6e8af6f8f26ec47e$export$18ccec9830a10d6e);
const $6e8af6f8f26ec47e$var$RENDERER_DOCUMENT_SELECTOR = '.ak-renderer-document';
const $6e8af6f8f26ec47e$var$RENDERER_START_POS_ATTRIBUTE = 'data-renderer-start-pos';
const $6e8af6f8f26ec47e$var$HEADING_SELECTOR = [
    1,
    2,
    3,
    4,
    5,
    6
].map((level)=>`h${level}[${$6e8af6f8f26ec47e$var$RENDERER_START_POS_ATTRIBUTE}]`).join(',');
const $6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4 = 'data-renderer-collapsed-content-owners';
function $6e8af6f8f26ec47e$var$getDirectRendererChild(rendererDocument, element) {
    var _currentElement;
    let currentElement = element;
    while(currentElement && currentElement.parentElement !== rendererDocument)currentElement = currentElement.parentElement;
    return ((_currentElement = currentElement) === null || _currentElement === void 0 ? void 0 : _currentElement.parentElement) === rendererDocument ? currentElement : null;
}
function $6e8af6f8f26ec47e$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions) {
    const headingPositionsByContainer = new Map();
    rendererDocument.querySelectorAll($6e8af6f8f26ec47e$var$HEADING_SELECTOR).forEach((headingElement)=>{
        if (headingElement.closest($6e8af6f8f26ec47e$var$RENDERER_DOCUMENT_SELECTOR) !== rendererDocument) return;
        const position = Number(headingElement.getAttribute($6e8af6f8f26ec47e$var$RENDERER_START_POS_ATTRIBUTE));
        if (!Number.isFinite(position) || !topLevelHeadingPositions.has(position)) return;
        const headingContainer = $6e8af6f8f26ec47e$var$getDirectRendererChild(rendererDocument, headingElement);
        if (headingContainer) headingPositionsByContainer.set(headingContainer, position);
    });
    return headingPositionsByContainer;
}
function $6e8af6f8f26ec47e$var$restoreHiddenAttribute(element, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) return;
    const originalHiddenAttribute = originalHiddenAttributes.get(element);
    if (originalHiddenAttribute === null || originalHiddenAttribute === undefined) element.removeAttribute('hidden');
    else element.setAttribute('hidden', originalHiddenAttribute);
    originalHiddenAttributes.delete(element);
}
function $6e8af6f8f26ec47e$var$setCollapsedOwners(element, owners, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) originalHiddenAttributes.set(element, element.getAttribute('hidden'));
    element.setAttribute($6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4, Array.from(owners).join(','));
    element.setAttribute('hidden', 'until-found');
}
function $6e8af6f8f26ec47e$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections) {
    const desiredOwners = new Map();
    if (collapsedHeadings.size === 0) return desiredOwners;
    const topLevelHeadingPositions = new Set(sections.map((section)=>section.headingPos));
    const sectionsByHeadingPosition = new Map(sections.map((section)=>[
            section.headingPos,
            section
        ]));
    rendererDocuments.forEach((rendererDocument)=>{
        // Index headings once, then reconcile every top-level renderer child in DOM order.
        const headingPositionsByContainer = $6e8af6f8f26ec47e$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions);
        let activeCollapsedSections = [];
        const contentElements = Array.from(rendererDocument.children);
        contentElements.forEach((contentElement)=>{
            const headingPosition = headingPositionsByContainer.get(contentElement);
            if (headingPosition !== undefined) activeCollapsedSections = activeCollapsedSections.filter((section)=>section.to > headingPosition);
            if (activeCollapsedSections.length > 0) desiredOwners.set(contentElement, new Set(activeCollapsedSections.map((section)=>section.headingPos)));
            if (headingPosition !== undefined && collapsedHeadings.has(headingPosition)) {
                const section = sectionsByHeadingPosition.get(headingPosition);
                if (section) activeCollapsedSections.push(section);
            }
        });
    });
    return desiredOwners;
}
function $6e8af6f8f26ec47e$export$236858493fcc483b(rendererRoot) {
    return Array.from(rendererRoot.querySelectorAll($6e8af6f8f26ec47e$var$RENDERER_DOCUMENT_SELECTOR)).filter((rendererDocument)=>{
        var _rendererDocument$par;
        const parentRendererDocument = (_rendererDocument$par = rendererDocument.parentElement) === null || _rendererDocument$par === void 0 ? void 0 : _rendererDocument$par.closest($6e8af6f8f26ec47e$var$RENDERER_DOCUMENT_SELECTOR);
        return !parentRendererDocument || !rendererRoot.contains(parentRendererDocument);
    });
}
function $6e8af6f8f26ec47e$export$371cf0cf237e6c69({ collapsedHeadings: collapsedHeadings, originalHiddenAttributes: originalHiddenAttributes, rendererRoot: rendererRoot, sections: sections }) {
    const rendererDocuments = $6e8af6f8f26ec47e$export$236858493fcc483b(rendererRoot);
    const desiredOwners = $6e8af6f8f26ec47e$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections);
    rendererDocuments.forEach((rendererDocument)=>{
        rendererDocument.querySelectorAll(`[${$6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4}]`).forEach((element)=>{
            if (element.closest($6e8af6f8f26ec47e$var$RENDERER_DOCUMENT_SELECTOR) === rendererDocument && !desiredOwners.has(element)) {
                element.removeAttribute($6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4);
                $6e8af6f8f26ec47e$var$restoreHiddenAttribute(element, originalHiddenAttributes);
            }
        });
    });
    desiredOwners.forEach((owners, element)=>{
        const desiredOwnersAttribute = Array.from(owners).join(',');
        if (element.getAttribute($6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4) !== desiredOwnersAttribute || element.getAttribute('hidden') !== 'until-found') $6e8af6f8f26ec47e$var$setCollapsedOwners(element, owners, originalHiddenAttributes);
    });
}
function $6e8af6f8f26ec47e$export$18ccec9830a10d6e(element) {
    return (element.getAttribute($6e8af6f8f26ec47e$export$2116c0d2c1e9b9e4) ?? '').split(',').filter((owner)=>owner !== '').map(Number).filter(Number.isFinite);
}

});

parcelRegister("aqeHn", function(module, exports) {
$parcel$export(module.exports, "buildTopLevelHeadingSections", () => $c0281168ec3aa440$export$640970ddc72cf5cf);
const $c0281168ec3aa440$var$RENDERER_DOCUMENT_POSITION_OFFSET = 1;
function $c0281168ec3aa440$export$640970ddc72cf5cf(pmDocument) {
    if (!pmDocument) return [];
    const sections = [];
    const openSections = [];
    const documentEnd = pmDocument.content.size + $c0281168ec3aa440$var$RENDERER_DOCUMENT_POSITION_OFFSET;
    pmDocument.forEach((node, offset)=>{
        if (node.type.name !== 'heading') return;
        const headingPos = offset + $c0281168ec3aa440$var$RENDERER_DOCUMENT_POSITION_OFFSET;
        const level = Number(node.attrs.level);
        while(openSections.length > 0 && openSections[openSections.length - 1].level >= level){
            const section = openSections.pop();
            if (section) section.to = headingPos;
        }
        const section = {
            contentFrom: headingPos + node.nodeSize,
            headingPos: headingPos,
            level: level,
            to: documentEnd
        };
        sections.push(section);
        openSections.push(section);
    });
    return sections;
}

});


parcelRegister("2gm7Q", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $ec13b0a19a69d3d6$export$f980440e1ab4537d);
const $ec13b0a19a69d3d6$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("b82GM", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $ce439d214d79b3d8$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $ce439d214d79b3d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $gRfjb = parcelRequire("gRfjb");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lavtv = parcelRequire("lavtv");

var $d8oXW = parcelRequire("d8oXW");

var $egVEs = parcelRequire("egVEs");
function $ce439d214d79b3d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce439d214d79b3d8$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $ce439d214d79b3d8$var$headingAnchorWrapperTargetSizeStyles = {
    name: "v48shi",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;width:24px;height:24px;vertical-align:middle"
};
const $ce439d214d79b3d8$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ce439d214d79b3d8$export$3c9cedc52604835d,
        css: (0, $3y2s4.isExperimentEnabled)('platform_editor_heading_link_target_size') ? $ce439d214d79b3d8$var$headingAnchorWrapperTargetSizeStyles : undefined,
        ref: ref
    }, children);
});
const $ce439d214d79b3d8$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
const $ce439d214d79b3d8$var$scaledLinkIconStyles = {
    name: "1m0xiot",
    styles: "display:inline-flex;transform:scale(1.5);transform-origin:center"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ce439d214d79b3d8$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    constructor(props){
        super(props), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, // Stable reference for Tooltip content prop to avoid recreating on each render
        this.renderTooltipContent = ({ update: update })=>{
            this._tooltipUpdate = update;
            return this.state.tooltipMessage;
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            }, ()=>{
                // Reposition tooltip after content change (replaces the key-based remount)
                if ((0, $3y2s4.isExperimentEnabled)('a11y-fixes-week4-may-2026')) {
                    var _this$_tooltipUpdate;
                    (_this$_tooltipUpdate = this._tooltipUpdate) === null || _this$_tooltipUpdate === void 0 || _this$_tooltipUpdate.call(this);
                }
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $d8oXW.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $d8oXW.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            const tooltip = (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $d8oXW.headingAnchorLinkMessages).copyLinkToClipboard : (0, $d8oXW.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $d8oXW.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_heading_link_target_size')) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $egVEs.default), {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                css: $ce439d214d79b3d8$var$scaledLinkIconStyles,
                "data-testid": "scaled-link-icon"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                label: this.getCopyAriaLabel(),
                size: "medium",
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            })));
            return /*#__PURE__*/ (0, $9dQre.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $ce439d214d79b3d8$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) {
            if ((0, $3y2s4.isExperimentEnabled)('a11y-fixes-week4-may-2026')) // Fix for A11Y-30972: Use content as a function with update callback so
            // the Tooltip repositions without unmounting (which caused focus loss).
            // @see https://hello.jira.atlassian.cloud/browse/A11Y-30972
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
                tag: $ce439d214d79b3d8$var$CopyAnchorWrapperWithRef,
                content: this.renderTooltipContent,
                position: "top",
                delay: 0,
                isScreenReaderAnnouncementDisabled: (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false,
                hasNewContentOnTriggerClick: true
            }, this.renderAnchorButton());
            // We set the key to the message to ensure it remounts when the message
            // changes, so that it correctly repositions.
            // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
                tag: $ce439d214d79b3d8$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage,
                isScreenReaderAnnouncementDisabled: (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
        }
        return this.renderAnchorButton();
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $ce439d214d79b3d8$var$_default_1 = (0, $fK3tS.default)($ce439d214d79b3d8$var$HeadingAnchor);
var $ce439d214d79b3d8$export$2e2bcd8739ae039 = $ce439d214d79b3d8$var$_default_1;

});
parcelRegister("egVEs", function(module, exports) {
$parcel$export(module.exports, "default", () => $061d15774f50a162$export$2e2bcd8739ae039);
/* heading-anchor-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $061d15774f50a162$var$buttonStyles = null;
function $061d15774f50a162$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading -- Forward the existing heading anchor's accessibility and event props.
    return /*#__PURE__*/ (0, $dc70d.jsx)("button", {
        ...props,
        type: "button",
        className: (0, $9fU1q.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1dqoglyw _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n4nkob _bfhk1j28 _80omtlke"
        ])
    });
}

});



parcelRegister("dggih", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f7e6e2f4659ae2f$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $6SGk4 = parcelRequire("6SGk4");
const $9f7e6e2f4659ae2f$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $6SGk4.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(result)) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $9f7e6e2f4659ae2f$export$2e2bcd8739ae039 = $9f7e6e2f4659ae2f$var$InlineExtension;

});

parcelRegister("5H3yU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b63ba6b8a2efa21$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");

var $3aMs2 = parcelRequire("3aMs2");

var $8ihtS = parcelRequire("8ihtS");

var $bUObc = parcelRequire("bUObc");
const $0b63ba6b8a2efa21$var$LayoutSectionMigration = (0, $3aMs2.componentWithCondition)(()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_renderer_static_css'), (0, $8ihtS.LayoutSectionCompiled), (0, $bUObc.LayoutSectionEmotion));
function $0b63ba6b8a2efa21$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)($0b63ba6b8a2efa21$var$LayoutSectionMigration, {
        ...props
    });
}

});
parcelRegister("8ihtS", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionCompiled", () => $988dbd3f317a6dd9$export$417b5700bb65fae1);
/* layoutColumn-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Compiled branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");

var $5oXqC = parcelRequire("5oXqC");
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $988dbd3f317a6dd9$var$clearNextSiblingMarginTopStyle = null;
const $988dbd3f317a6dd9$var$verticalAlignMiddleStyles = null;
const $988dbd3f317a6dd9$var$verticalAlignBottomStyles = null;
const $988dbd3f317a6dd9$var$multipleWrappedImagesStyle = null;
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $988dbd3f317a6dd9$var$clearNextSiblingBlockMarkMarginTopStyle = null;
const $988dbd3f317a6dd9$export$417b5700bb65fae1 = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        className: (0, $9fU1q.default)([
            props.valign === 'middle' && "_1e0c1txw _2lx21bp4 _1bah1h6o",
            props.valign === 'bottom' && "_1e0c1txw _2lx21bp4 _1bahesu3",
            "_1tihidpf _12kpidpf"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $5oXqC.WidthProvider), {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    "data-layout-column-start": "true",
                    className: (0, $9fU1q.default)([
                        "_1skbgrf3",
                        "_19segrf3 _1ki1grf3 _bmdegrf3 _166hgrf3 _7g1ogrf3 _sk2jgrf3 _hgeogrf3"
                    ])
                }),
                props.children
            ]
        })
    });
};

});
parcelRegister("5oXqC", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $968b43d103928e47$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $968b43d103928e47$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $968b43d103928e47$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $968b43d103928e47$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $968b43d103928e47$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $57l7A = parcelRequire("57l7A");

var $9wZWu = parcelRequire("9wZWu");

var $8Mb7N = parcelRequire("8Mb7N");

var $7lseo = parcelRequire("7lseo");
function $968b43d103928e47$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $968b43d103928e47$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $968b43d103928e47$var$SCROLLBAR_WIDTH = 30;
function $968b43d103928e47$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $968b43d103928e47$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $968b43d103928e47$export$1eb095b00b926404(width)
    };
}
const $968b43d103928e47$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext($968b43d103928e47$export$31a4966bffb9ac98());
const $968b43d103928e47$var$Provider = $968b43d103928e47$export$27e39f636459b9f.Provider;
const $968b43d103928e47$export$5d8538aa831b6ebb = $968b43d103928e47$export$27e39f636459b9f.Consumer;
const $968b43d103928e47$export$df154c49e93b2ac2 = (0, $57l7A.default)(()=>{
    var _document$body;
    return (0, $7lseo.isSSR)() ? 0 : ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth) ?? 0;
});
const $968b43d103928e47$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $bSJIT.useContext)($968b43d103928e47$export$27e39f636459b9f);
    const [width, setWidth] = (0, $bSJIT.useState)($968b43d103928e47$export$df154c49e93b2ac2);
    const widthRef = (0, $bSJIT.useRef)(width);
    const isMountedRef = (0, $bSJIT.useRef)(true);
    const providerValue = (0, $bSJIT.useMemo)(()=>$968b43d103928e47$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $bSJIT.useMemo)(()=>{
        return (0, $9wZWu.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $968b43d103928e47$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $968b43d103928e47$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8Mb7N.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $9dQre.jsx)($968b43d103928e47$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("7lseo", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $f9efbccf1a4a379e$export$48d7c418edadb60c);

var $4eGW1 = parcelRequire("4eGW1");
function $f9efbccf1a4a379e$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $4eGW1 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("bUObc", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionEmotion", () => $30f72f517e3c1564$export$2cc1a43fb56df180);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5oXqC = parcelRequire("5oXqC");
function $30f72f517e3c1564$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $30f72f517e3c1564$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $30f72f517e3c1564$var$verticalAlignMiddleStyles = {
    name: "16mmcnu",
    styles: "display:flex;flex-direction:column;justify-content:center"
};
const $30f72f517e3c1564$var$verticalAlignBottomStyles = {
    name: "igeqly",
    styles: "display:flex;flex-direction:column;justify-content:flex-end"
};
const $30f72f517e3c1564$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $30f72f517e3c1564$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
const $30f72f517e3c1564$export$2cc1a43fb56df180 = (props)=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        css: [
            // Keep separate: Compiled crashes on ternary/object lookup here.
            props.valign === 'middle' && $30f72f517e3c1564$var$verticalAlignMiddleStyles,
            props.valign === 'bottom' && $30f72f517e3c1564$var$verticalAlignBottomStyles,
            $30f72f517e3c1564$var$multipleWrappedImagesStyle
        ]
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5oXqC.WidthProvider), null, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-layout-column-start": "true",
        css: [
            $30f72f517e3c1564$var$clearNextSiblingMarginTopStyle,
            $30f72f517e3c1564$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
};

});


parcelRegister("i1k9C", function(module, exports) {
$parcel$export(module.exports, "default", () => $882785a92cc234c9$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $797yE = parcelRequire("797yE");
function $882785a92cc234c9$export$2e2bcd8739ae039(props) {
    var _props$getContent;
    const columnCount = (_props$getContent = props.getContent) === null || _props$getContent === void 0 || (_props$getContent = _props$getContent.call(props)) === null || _props$getContent === void 0 ? void 0 : _props$getContent.length;
    return (0, $797yE.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: "layout-section-container",
        "data-local-id": props.localId,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": columnCount,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-layout-section": true,
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("iV1Ln", function(module, exports) {
$parcel$export(module.exports, "default", () => $1922190d3792f8df$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $1922190d3792f8df$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("jBfbK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7ad6829f3fd48fb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $3y2s4 = parcelRequire("3y2s4");

var $kTBKs = parcelRequire("kTBKs");

var $cvo9f = parcelRequire("cvo9f");

var $jFRub = parcelRequire("jFRub");

var $i5Z6u = parcelRequire("i5Z6u");

var $ciOUj = parcelRequire("ciOUj");
function $b7ad6829f3fd48fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b7ad6829f3fd48fb$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $b7ad6829f3fd48fb$var$getFramesActiveFrameStyles = (activeChildIndex)=>{
    // Apply the active-frame rule on the frames article itself so nested MBEs
    // only target their own direct frames.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return /*#__PURE__*/ (0, $9dQre.css)("&>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
};
const $b7ad6829f3fd48fb$var$MultiBodiedExtensionChildrenContainer = ({ activeChildIndex: activeChildIndex, children: children })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("article", {
        css: $b7ad6829f3fd48fb$var$getFramesActiveFrameStyles(activeChildIndex),
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $b7ad6829f3fd48fb$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $b7ad6829f3fd48fb$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $cvo9f.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $cvo9f.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jFRub.calcBreakoutWidthCss)(layout) : (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $b7ad6829f3fd48fb$var$MultiBodiedExtension = (props)=>{
    var _extensionContext$pri;
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, extensionHandlers: extensionHandlers, getContent: getContent, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $bSJIT.useState)(0);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $bSJIT.useContext)((0, $kTBKs.default));
    const { loading: loading, extensionContext: extensionContext } = (0, $ciOUj.useMultiBodiedExtensionContext)({
        extensionHandlers: extensionHandlers,
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $i5Z6u.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $9dQre.jsx)($b7ad6829f3fd48fb$var$MultiBodiedExtensionChildrenContainer, {
            activeChildIndex: activeChildIndex
        }, children),
        allowBodiedOverride: extensionContext === null || extensionContext === void 0 || (_extensionContext$pri = extensionContext.privateProps) === null || _extensionContext$pri === void 0 ? void 0 : _extensionContext$pri.__allowBodiedOverride,
        extensionKey: extensionKey,
        extensionType: extensionType,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        var _marks$find;
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: getContent === null || getContent === void 0 ? void 0 : getContent(),
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $9dQre.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, $9dQre.jsx)($b7ad6829f3fd48fb$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $9dQre.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $9dQre.jsx)($b7ad6829f3fd48fb$var$MultiBodiedExtensionChildrenContainer, {
            activeChildIndex: activeChildIndex
        }, children));
    }, [
        activeChildIndex,
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        getContent,
        localId,
        actions,
        children
    ]);
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout);
    const wrapper = /*#__PURE__*/ (0, $9dQre.jsx)($b7ad6829f3fd48fb$var$MultiBodiedExtensionWrapperNext, {
        layout: layout,
        path: path,
        rendererAppearance: rendererAppearance
    }, renderContent());
    return /*#__PURE__*/ (0, $9dQre.jsx)("section", {
        css: $b7ad6829f3fd48fb$var$containerStyles,
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId,
        "data-node-type": "multiBodiedExtension"
    }, useCenterWrapper ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $cvo9f.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $cvo9f.RendererCssClassName).FLEX_CENTER_WRAPPER
    }, wrapper) : wrapper);
};
var $b7ad6829f3fd48fb$export$2e2bcd8739ae039 = $b7ad6829f3fd48fb$var$MultiBodiedExtension;

});
parcelRegister("i5Z6u", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $17f311c06278b0ce$export$3c7139d93ecb4f1f);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5N1Y4 = parcelRequire("5N1Y4");
const $17f311c06278b0ce$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer, extensionKey: extensionKey = '', extensionType: extensionType = '', fireAnalyticsEvent: fireAnalyticsEvent })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                if ((0, $5N1Y4.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).CHANGE_ACTIVE,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
                    attributes: {
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                });
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reorderChildren (_fromIndex, _toIndex) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer,
        extensionKey,
        extensionType,
        fireAnalyticsEvent
    ]);
};

});

parcelRegister("ciOUj", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $b2480c8419c69c4b$export$e55394818db35473);

var $bSJIT = parcelRequire("bSJIT");

var $57l7A = parcelRequire("57l7A");

var $1tfAn = parcelRequire("1tfAn");

var $jPmHi = parcelRequire("jPmHi");

var $l7ENf = parcelRequire("l7ENf");

var $5N1Y4 = parcelRequire("5N1Y4");
const $b2480c8419c69c4b$var$getExtensionHandlerNode = (extensionHandler)=>{
    return ({ node: node, doc: doc, actions: actions })=>{
        return extensionHandler(node, doc, actions);
    };
};
const $b2480c8419c69c4b$export$e55394818db35473 = ({ extensionHandlers: extensionHandlers, extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, $57l7A.default)((0, $1tfAn.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    const providerPromise = (0, $jPmHi.useProvider)('extensionProvider');
    const ExtensionHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        const extensionHandler = extensionHandlers && extensionHandlers[extensionType] && (0, $l7ENf.getExtensionRenderer)(extensionHandlers[extensionType]);
        if (extensionHandler) return $b2480c8419c69c4b$var$getExtensionHandlerNode(extensionHandler);
        return null;
    }, [
        extensionHandlers,
        extensionType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $1tfAn.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const ExtensionProviderNode = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (ExtensionHandlerNode && (0, $5N1Y4.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return {
            extensionContext: {
                NodeRenderer: ExtensionHandlerNode,
                privateProps: {
                    __allowBodiedOverride: true
                }
            },
            loading: false
        };
        if (!provider || !ExtensionProviderNode || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: ExtensionProviderNode,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        ExtensionHandlerNode,
        provider,
        ExtensionProviderNode,
        privateProps
    ]);
};

});
parcelRegister("jPmHi", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $8f726f7fe6ba0c11$export$617c134b25cc4265);
$parcel$export(module.exports, "useProviderFactory", () => $8f726f7fe6ba0c11$export$a3af4b6980aa23b5);
$parcel$export(module.exports, "useProvider", () => $8f726f7fe6ba0c11$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $8f726f7fe6ba0c11$export$6fde1d0d81db98e1);

var $bSJIT = parcelRequire("bSJIT");

var $5zxDU = parcelRequire("5zxDU");
const $8f726f7fe6ba0c11$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(new (0, $5zxDU.default)());
const $8f726f7fe6ba0c11$export$617c134b25cc4265 = $8f726f7fe6ba0c11$var$ProviderFactoryContext.Provider;
const $8f726f7fe6ba0c11$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($8f726f7fe6ba0c11$var$ProviderFactoryContext);
const $8f726f7fe6ba0c11$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    const providerFactory = $8f726f7fe6ba0c11$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $8f726f7fe6ba0c11$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    const providerFactory = $8f726f7fe6ba0c11$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});



parcelRegister("0c2Rt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d38af3ec2f429a5$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $drur6 = parcelRequire("drur6");

var $fMCeS = parcelRequire("fMCeS");

var $f3Svn = parcelRequire("f3Svn");

var $4EVbq = parcelRequire("4EVbq");

var $3TgA6 = parcelRequire("3TgA6");
function $6d38af3ec2f429a5$export$2e2bcd8739ae039(props) {
    var _props$getContent;
    const extraProps = {};
    // Item count drives the marker column width, so losing it narrows the gutter by a digit.
    const itemsCount = (_props$getContent = props.getContent) === null || _props$getContent === void 0 || (_props$getContent = _props$getContent.call(props)) === null || _props$getContent === void 0 ? void 0 : _props$getContent.length;
    const itemCounterDigitsSize = (0, $4EVbq.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: itemsCount
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $fMCeS.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $f3Svn.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $dc70d.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $drur6.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $3TgA6.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("fMCeS", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $c893137da8da7a64$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $c893137da8da7a64$export$6d31fdb1d74cee3e);
const $c893137da8da7a64$export$bafd6beec0797f87 = 24;
var $c893137da8da7a64$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($c893137da8da7a64$var$CSS_VAR_NAMES || {});
const $c893137da8da7a64$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $c893137da8da7a64$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $c893137da8da7a64$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $c893137da8da7a64$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $c893137da8da7a64$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("f3Svn", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $39198d523bf18c00$export$d445360e2a3c026b);
// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
const $39198d523bf18c00$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};

});

parcelRegister("4EVbq", function(module, exports) {
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $9c56cfd2aece8f45$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $9c56cfd2aece8f45$export$320582fc14ba1e0f);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.

var $f3Svn = parcelRequire("f3Svn");




const $9c56cfd2aece8f45$export$8ef94ae42a3729bd = 1;
const $9c56cfd2aece8f45$export$cbefb5b89ef0719f = (orderedListNode)=>{
    var _orderedListNode$attr;
    const order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (0, $f3Svn.resolveOrder)(order) ?? $9c56cfd2aece8f45$export$8ef94ae42a3729bd;
};
const $9c56cfd2aece8f45$export$320582fc14ba1e0f = (options)=>{
    var _String;
    const order = (0, $f3Svn.resolveOrder)(options.order) ?? $9c56cfd2aece8f45$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split('.')) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};

});


parcelRegister("9mSOX", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4efcca9fed60895$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hxxea = parcelRequire("hxxea");
function $d4efcca9fed60895$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline, plainTextFastPath: plainTextFastPath }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $dc70d.jsx)("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hxxea.default), {
            plainTextFastPath: plainTextFastPath,
            children: children
        })
    }));
}

});
parcelRegister("hxxea", function(module, exports) {
$parcel$export(module.exports, "default", () => $d31764fc91008891$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
function $d31764fc91008891$export$b8eec8c96e98e4e7(children) {
    if (children == null || typeof children === 'boolean') return false;
    if (Array.isArray(children)) {
        for (const child of children){
            if ($d31764fc91008891$export$b8eec8c96e98e4e7(child)) return true;
        }
        return false;
    }
    return true;
}
function $d31764fc91008891$export$2e2bcd8739ae039(props) {
    const { children: children, plainTextFastPath: plainTextFastPath } = props;
    const isEmpty = plainTextFastPath ? !$d31764fc91008891$export$b8eec8c96e98e4e7(children) : (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children).length === 0;
    if (isEmpty) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("5644y", function(module, exports) {
$parcel$export(module.exports, "default", () => $55a9219f835e97e9$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $55a9219f835e97e9$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {});
}

});

parcelRegister("9ZqqS", function(module, exports) {
$parcel$export(module.exports, "default", () => $25132f08cc740304$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $25132f08cc740304$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $dc70d.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("ccrLN", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => $a8f22115b6f71889$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $a8f22115b6f71889$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $a8f22115b6f71889$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5nq9a = parcelRequire("5nq9a");

var $lPNDS = parcelRequire("lPNDS");

var $enwus = parcelRequire("enwus");

var $l7YRm = parcelRequire("l7YRm");

var $eVpwU = parcelRequire("eVpwU");

var $2OSrK = parcelRequire("2OSrK");

var $aU4zH = parcelRequire("aU4zH");
var $lsbSX = parcelRequire("lsbSX");

var $hk8Gf = parcelRequire("hk8Gf");

var $fkNZo = parcelRequire("fkNZo");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $cvo9f = parcelRequire("cvo9f");

var $9mxVO = parcelRequire("9mxVO");

var $1EI4O = parcelRequire("1EI4O");

var $4Iwar = parcelRequire("4Iwar");

var $bznsM = parcelRequire("bznsM");

var $6fBiz = parcelRequire("6fBiz");

var $7xVpU = parcelRequire("7xVpU");

var $39DfA = parcelRequire("39DfA");

var $ib6wf = parcelRequire("ib6wf");

var $8hixA = parcelRequire("8hixA");

var $aIzPh = parcelRequire("aIzPh");
const $a8f22115b6f71889$var$stickyContainerStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%',
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $a8f22115b6f71889$export$eec82c0a93aa66d9 = (appearance)=>(0, $bznsM.isFullWidthOrFullPageAppearance)(appearance) || (0, $bznsM.isCommentAppearance)(appearance);
const $a8f22115b6f71889$export$bdb2dadcb04aad50 = (appearance)=>(0, $bznsM.isFullWidthOrFullPageAppearance)(appearance) && (0, $797yE.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $a8f22115b6f71889$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2OSrK.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $hk8Gf.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $aU4zH.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $a8f22115b6f71889$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $a8f22115b6f71889$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $a8f22115b6f71889$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $a8f22115b6f71889$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $a8f22115b6f71889$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $a8f22115b6f71889$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $8hixA.TableHeader);
    return children.every((node)=>node.type === (0, $8hixA.TableHeader));
};
const $a8f22115b6f71889$export$940095e914312886 = (node, children)=>{
    return $a8f22115b6f71889$export$28daf78feed5098c(children) && node && node.firstChild && !$a8f22115b6f71889$export$42f5658c8e0092da(node.firstChild);
};
/**
 * Fake left/right borders rendered as direct children of TABLE_CONTAINER
 * (the non-scrolling parent of the horizontally scrolling TABLE_NODE_WRAPPER).
 *
 * The visible styling for these divs lives in `tableFakeBorderStyles`
 * (`renderer/src/ui/Renderer/RendererStyleContainer.tsx`), which is applied
 * when `isInsideSyncBlock` is true.
 */ const $a8f22115b6f71889$var$TableFakeBorders = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>/*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER,
                "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
                "data-testid": "table-left-border"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER,
                "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
                "data-testid": "table-right-border"
            })
        ]
    });
const $a8f22115b6f71889$export$c8a6e9aeff774364 = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const { nestedRendererType: nestedRendererType } = (0, $9mxVO.useRendererContext)();
    const isInsideOfRefSyncBlock = nestedRendererType === 'syncedBlock';
    if (!isInsideOfRefSyncBlock) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)($a8f22115b6f71889$var$TableFakeBorders, {
        isNumberColumnEnabled: isNumberColumnEnabled
    });
};
class $a8f22115b6f71889$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    /**
   * Checks if this table is inside a nested renderer (e.g. Include Page macro)
   * by looking for multiple .ak-renderer-document ancestors in the DOM.
   * The result is cached since a table's position in the DOM tree is stable after mount.
   */ isInsideNestedRenderer() {
        if (this._isInsideNestedRenderer !== null) return this._isInsideNestedRenderer;
        if (!this.containerRef) return false;
        let docAncestorCount = 0;
        let el = this.containerRef.parentElement;
        while(el){
            if (el.classList.contains((0, $cvo9f.RendererCssClassName).DOCUMENT)) {
                docAncestorCount++;
                if (docAncestorCount >= 2) {
                    this._isInsideNestedRenderer = true;
                    return true;
                }
            }
            el = el.parentElement;
        }
        this._isInsideNestedRenderer = false;
        return false;
    }
    /**
   * Checks if this table is inside a table cell in the DOM. The result is cached
   * since a table's position in the DOM tree is stable after mount.
   */ isInsideTableCell() {
        if (this._isInsideTableCell !== null) return this._isInsideTableCell;
        if (!this.containerRef) return false;
        this._isInsideTableCell = Boolean(this.containerRef.closest('td, th'));
        return this._isInsideTableCell;
    }
    isInsideTableContext() {
        return Boolean(this.props.isInsideOfTable || this.isInsideTableCell());
    }
    /**
   * For tables inside nested renderers (e.g. Include Page macro), the parent
   * renderer's CSS override forces width:100%!important and left:0!important
   * which overrides the inline styles set by this component. Using
   * style.setProperty with 'important' priority on inline styles beats
   * stylesheet !important rules per the CSS cascade.
   *
   * Tables that are nested inside another table need to remain constrained by
   * their table-cell context. Do not promote their width to inline !important,
   * otherwise nested tables rendered through macros such as Excerpt Include can
   * overflow and overlap adjacent cells.
   *
   * Top-level tables in nested renderers still preserve their saved width, but
   * are capped to their containing block so wide tables do not escape constrained
   * macro bodies such as Excerpt Include panels.
   *
   * Uses lastComputedStyle (populated during render) rather than reading from
   * element.style, because React may remove properties from the DOM when their
   * values transition to undefined between renders.
   *
   * `platform_nested_table_style_override_2` fixes a follow-up regression where a
   * NON-resized table inside an Excerpt macro (not Excerpt Include) on a
   * wide/full-width page shrinks to only show its first columns in the renderer.
   * Inside a nested renderer (a macro body) a non-resized table's computed width
   * is a default layout cap (760px/1800px, or a `cqw` length for full-page
   * appearances) taken from the outer renderer's width context. That value does
   * not match the macro's own box, so promoting it to inline `!important` makes
   * the table collapse. Such tables have no author-chosen size to preserve, so
   * under this gate we re-assert the parent stylesheet's intent (fill the box:
   * `width: 100%; left: 0`) with inline `!important`.
   *
   * Explicitly resized tables (`tableNode.attrs.width` set) are excluded and keep
   * the original PGXT-10226 behavior: their author-chosen width/left is promoted
   * verbatim so the Include Page macro does not stretch or indent them. The
   * table-cell short-circuit (PGXT-10294) above also still applies.
   */ applyNestedRendererTableFix() {
        var _this$props$tableNode;
        if (!this.containerRef) return;
        if (!this.isInsideNestedRenderer() || this.isInsideTableContext()) return;
        const { width: width, left: left, marginLeft: marginLeft } = this.lastComputedStyle;
        const style = this.containerRef.style;
        // A table is "explicitly resized" when the author set a width on the node.
        // Non-resized tables instead take a default layout cap (e.g. 760px/1800px)
        // derived from the outer renderer's appearance.
        const isExplicitlyResized = Boolean((_this$props$tableNode = this.props.tableNode) === null || _this$props$tableNode === void 0 ? void 0 : _this$props$tableNode.attrs.width);
        if (!isExplicitlyResized && (0, $gdUUy.fg)('platform_nested_table_style_override_2')) {
            // PGXT-10421: For a NON-resized table inside a nested renderer (e.g. an
            // Excerpt macro body), the computed width is a default layout cap
            // (760px/1800px, or a `cqw` length for full-page appearances) taken from
            // the *outer* renderer's width context. That value does not match the
            // macro's own box, so promoting it to inline `!important` makes the table
            // ignore the available space and collapse to its first columns.
            //
            // These tables have no author-chosen size to preserve, so re-assert the
            // parent stylesheet's intent — fill the available box (`width: 100%`) —
            // with inline `!important` priority so it survives React re-renders and
            // wins over the stylesheet rule that leaks into nested renderers.
            style.setProperty('width', '100%', 'important');
            style.setProperty('max-width', '100%', 'important');
            style.setProperty('left', '0', 'important');
            style.setProperty('margin-left', '0', 'important');
            return;
        }
        // PGXT-10226: An explicitly resized table inside a nested renderer (e.g.
        // Include Page macro) must keep its author-chosen width and position. The
        // parent stylesheet forces `width: 100% !important; left: 0 !important`,
        // which would stretch and indent it, so we promote the component's own
        // computed width/left with inline `!important` to win the cascade.
        style.setProperty('width', width || 'auto', 'important');
        style.setProperty('max-width', '100%', 'important');
        style.setProperty('left', left || 'auto', 'important');
        style.setProperty('margin-left', marginLeft || '0', 'important');
    }
    /**
   * Starts observing table dimensions and wires sticky header/scrollbar behavior after mount.
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            var _this$props$stickyHea;
            this.overflowParent = (0, $39DfA.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $a8f22115b6f71889$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $aIzPh.TableStickyScrollbar)(this.wrapperRef.current);
        this.applyNestedRendererTableFix();
    }
    /**
   * Updates sticky header wiring and scroll synchronization after prop or state changes.
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) {
            var _this$props$stickyHea2;
            this.overflowParent = (0, $39DfA.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
        } else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        // React re-applies the style prop on every render, which overwrites the
        // !important priorities set at mount time. Re-apply after each update.
        this.applyNestedRendererTableFix();
    }
    /**
   * Calculates the top offset used when the sticky header is pinned to the table bottom.
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $l7YRm.tableMarginTop) - (0, $39DfA.tableStickyPadding);
    }
    /**
   * Determines whether sticky header positioning should include the default scroll root offset.
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   * Resolves the top position for the sticky header based on the current sticky mode.
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   * Renders the table container, sticky header, table content, sticky scrollbar, and synced block borders.
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $5bbjm.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1EI4O.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return `min(${0, $5bbjm.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return `min(${0, $5bbjm.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $5nq9a.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $5bbjm.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $5bbjm.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $bznsM.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $bznsM.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $bznsM.isMaxWidthAppearance)(rendererAppearance) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $5nq9a.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $bznsM.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $bznsM.isFullWidthAppearance)(rendererAppearance) || (0, $bznsM.isMaxWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $bznsM.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $5bbjm.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const isContentModeTable = (0, $eVpwU.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $7xVpU.isContentModeSupported)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
        });
        const style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        // Store computed style values for applyNestedRendererTableFix() to use.
        // Reading from props rather than the DOM ensures correctness when React
        // removes properties (transitions from set to undefined) between renders.
        this.lastComputedStyle = {
            width: typeof style.width === 'number' ? `${style.width}px` : style.width,
            left: style.left,
            marginLeft: style.marginLeft
        };
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
            children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.setContainerRef,
                style: style,
                children: [
                    $a8f22115b6f71889$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && !isContentModeTable && $a8f22115b6f71889$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $39DfA.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout,
                        "data-autosize": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.__autoSize,
                        "data-table-local-id": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId,
                        "data-table-width": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ib6wf.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $a8f22115b6f71889$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}-view-page`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: $a8f22115b6f71889$var$stickyContainerStyles,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            style: {
                                width: '100%',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $a8f22115b6f71889$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)($a8f22115b6f71889$export$c8a6e9aeff774364, {
                        isNumberColumnEnabled: isNumberColumnEnabled
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.overflowParent = null, this.containerRef = null, this._isInsideNestedRenderer = null, this._isInsideTableCell = null, // Stores the last computed style values from render() for use by applyNestedRendererTableFix().
        // This avoids reading from the DOM which can be stale when React removes properties between renders.
        this.lastComputedStyle = {}, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, /**
   * Callback ref that captures the container DOM element and also forwards
   * to the handleRef prop from the overflow shadow HOC.
   */ this.setContainerRef = (el)=>{
            if (this.containerRef !== el) {
                this._isInsideNestedRenderer = null;
                this._isInsideTableCell = null;
            }
            this.containerRef = el;
            const { handleRef: handleRef } = this.props;
            if (typeof handleRef === 'function') handleRef(el);
            else if (handleRef && typeof handleRef === 'object') // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleRef.current = el;
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $39DfA.tableStickyPadding);
            const tableTop = $a8f22115b6f71889$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $a8f22115b6f71889$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $a8f22115b6f71889$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
const $a8f22115b6f71889$var$getCellEdgePropsByCellOffset = (tableNode, isNumberColumnEnabled)=>{
    // The serializer uses the node attribute. Other callers can supply a different render prop.
    const useCachedEdges = (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $3y2s4.isExperimentEnabled)('platform_editor_table_q4_perf_patch') && Boolean(isNumberColumnEnabled) === Boolean(tableNode.attrs.isNumberColumnEnabled);
    const cached = useCachedEdges ? (0, $6fBiz.getCachedTableEdges)(tableNode) : undefined;
    if (cached) return cached;
    const cellEdgePropsByCellOffset = new Map();
    const cellRightByCellOffset = new Map();
    const occupiedGrid = [];
    let tableWidth = 0;
    let cellOffset = 0;
    tableNode.forEach((rowNode, _rowOffset, rowIndex)=>{
        occupiedGrid[rowIndex] = occupiedGrid[rowIndex] ?? [];
        let columnIndex = 0;
        cellOffset += 1;
        rowNode.forEach((cellNode)=>{
            while(occupiedGrid[rowIndex][columnIndex])columnIndex += 1;
            const colspan = cellNode.attrs.colspan || 1;
            const rowspan = cellNode.attrs.rowspan || 1;
            const cellLeft = columnIndex;
            const cellRight = cellLeft + colspan;
            const cellTop = rowIndex;
            const cellBottom = cellTop + rowspan;
            for(let row = cellTop; row < cellBottom; row += 1){
                occupiedGrid[row] = occupiedGrid[row] ?? [];
                for(let column = cellLeft; column < cellRight; column += 1)occupiedGrid[row][column] = true;
            }
            tableWidth = Math.max(tableWidth, cellRight);
            cellRightByCellOffset.set(cellOffset, cellRight);
            cellEdgePropsByCellOffset.set(cellOffset, {
                reachesBottom: cellBottom >= tableNode.childCount,
                // With number column enabled, PM column 0 is not visually leftmost and must not get `data-reaches-left`.
                reachesLeft: cellLeft === 0 && !isNumberColumnEnabled,
                reachesRight: false,
                reachesTop: cellTop === 0
            });
            columnIndex = cellRight;
            cellOffset += cellNode.nodeSize;
        });
        cellOffset += 1;
    });
    cellRightByCellOffset.forEach((cellRight, currentCellOffset)=>{
        const edgeProps = cellEdgePropsByCellOffset.get(currentCellOffset);
        if (edgeProps) edgeProps.reachesRight = cellRight >= tableWidth;
    });
    if (useCachedEdges) (0, $6fBiz.cacheTableEdges)(tableNode, cellEdgePropsByCellOffset);
    return cellEdgePropsByCellOffset;
};
const $a8f22115b6f71889$var$isRenderedTableCell = (element)=>{
    const { nodeType: nodeType } = element.props;
    return nodeType === 'tableCell' || nodeType === 'tableHeader' || element.type === (0, $8hixA.TableCell) || element.type === (0, $8hixA.TableHeader);
};
const $a8f22115b6f71889$var$addTableCellEdgePropsThroughWrappers = (rows, tableNode, isNumberColumnEnabled)=>{
    const useCachedEdges = (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $3y2s4.isExperimentEnabled)('platform_editor_table_q4_perf_patch');
    try {
        if (!tableNode) return rows;
        const cellEdgePropsByCellOffset = $a8f22115b6f71889$var$getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        let cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(rows, (row, rowIndex)=>{
            const rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            let cellIndex = 0;
            const addEdgePropsToRenderedCells = (element)=>{
                if ($a8f22115b6f71889$var$isRenderedTableCell(element)) {
                    const cellNode = rowNode.child(cellIndex);
                    const edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                    cellIndex += 1;
                    cellOffset += cellNode.nodeSize;
                    if (useCachedEdges) return (0, $6fBiz.withTableCellEdgeProps)(element, edgeProps);
                    return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(element, edgeProps) : element;
                }
                const { children: children } = element.props;
                if (children === undefined) return element;
                const childrenWithEdgeProps = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child) ? addEdgePropsToRenderedCells(child) : child);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(element, undefined, childrenWithEdgeProps);
            };
            const rowWithEdgeProps = addEdgePropsToRenderedCells(row);
            if (cellIndex !== rowNode.childCount) throw new Error('Rendered table row does not match its document node');
            cellOffset += 1;
            return rowWithEdgeProps;
        });
    } catch  {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
class $a8f22115b6f71889$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    /**
   * Renders processed table children inside the table container.
   *
   * @example
   */ render() {
        const { allowColumnSorting: allowColumnSorting, allowFixedColumnWidthOption: allowFixedColumnWidthOption, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, children: children, columnWidths: columnWidths, disableTableOverflowShadow: disableTableOverflowShadow, handleRef: handleRef, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isNumberColumnEnabled: isNumberColumnEnabled, isPresentational: isPresentational, layout: layout, rendererAppearance: rendererAppearance, renderWidth: renderWidth, shadowClassNames: shadowClassNames, smartCardStorage: smartCardStorage, stickyHeaders: stickyHeaders, tabIndex: tabIndex, tableNode: tableNode } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children);
        const childrenWithTableEdgeProps = (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $a8f22115b6f71889$var$addTableCellEdgePropsThroughWrappers(childrenArray, tableNode, isNumberColumnEnabled) : childrenArray;
        const orderedChildren = (0, $fkNZo.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenWithTableEdgeProps);
        return /*#__PURE__*/ (0, $dc70d.jsx)($a8f22115b6f71889$export$f2c3aea42b2a048f, {
            allowColumnSorting: allowColumnSorting,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
            allowTableAlignment: allowTableAlignment,
            allowTableResizing: allowTableResizing,
            columnWidths: columnWidths,
            disableTableOverflowShadow: disableTableOverflowShadow,
            handleRef: handleRef,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
            isInsideOfTable: isInsideOfTable,
            isNumberColumnEnabled: isNumberColumnEnabled,
            isPresentational: isPresentational,
            layout: layout,
            rendererAppearance: rendererAppearance,
            renderWidth: renderWidth,
            shadowClassNames: shadowClassNames,
            smartCardStorage: smartCardStorage,
            stickyHeaders: stickyHeaders,
            tabIndex: tabIndex,
            tableNode: tableNode,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $a8f22115b6f71889$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $lsbSX.hasMergedCell)(tableNode)) return $a8f22115b6f71889$export$100baa0f10804e6e($a8f22115b6f71889$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $a8f22115b6f71889$export$28daf78feed5098c(rows);
            const lastRowIndex = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.count(rows) - 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1,
                    isFirstRow: index === 0,
                    isLastRow: index === lastRowIndex
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a8f22115b6f71889$var$TableWithShadowsAndContainerStyles = (0, $lPNDS.default)($a8f22115b6f71889$export$827f89182557f335, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $a8f22115b6f71889$var$TableWithWidth = (props)=>{
    var _props$columnWidths;
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $9mxVO.useRendererContext)();
    const isInsideOfNestedRenderer = isTopLevelRenderer === false;
    const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce((total, val)=>total + val, 0)) || 0;
    if (colWidthsSum || props.allowTableResizing) return /*#__PURE__*/ (0, $dc70d.jsx)($a8f22115b6f71889$var$TableWithShadowsAndContainerStyles, {
        ...props,
        isInsideOfNestedRenderer: isInsideOfNestedRenderer
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($a8f22115b6f71889$export$827f89182557f335, {
        ...props,
        isInsideOfNestedRenderer: isInsideOfNestedRenderer
    });
};
const $a8f22115b6f71889$var$_default_1 = (0, $4Iwar.withSmartCardStorage)($a8f22115b6f71889$var$TableWithWidth);
var $a8f22115b6f71889$export$2e2bcd8739ae039 = $a8f22115b6f71889$var$_default_1;

});
parcelRegister("5nq9a", function(module, exports) {
$parcel$export(module.exports, "layoutToWidth", () => $5a2d93df8d3e49aa$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $5a2d93df8d3e49aa$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $5a2d93df8d3e49aa$export$3930799be057b305);

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $kgWXt = parcelRequire("kgWXt");

var $dcYQ6 = parcelRequire("dcYQ6");

var $l7YRm = parcelRequire("l7YRm");

var $bjG1c = parcelRequire("bjG1c");
const $5a2d93df8d3e49aa$var$GRID_SIZE = 8;
const $5a2d93df8d3e49aa$var$NESTED_DND_GUTTER_OFFSET = 8;
const $5a2d93df8d3e49aa$var$NESTED_DND_MARGIN_OFFSET = 12;
const $5a2d93df8d3e49aa$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $5bbjm.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $5bbjm.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $5bbjm.akEditorFullWidthLayoutWidth)
};
const $5a2d93df8d3e49aa$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    var _contextPanelPluginKe, _contextPanelPluginKe2;
    if (!pos) return;
    const node = $5a2d93df8d3e49aa$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $5a2d93df8d3e49aa$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $5bbjm.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
                // margin between sections
                parentWidth -= ((0, $dcYQ6.LAYOUT_SECTION_MARGIN) + $5a2d93df8d3e49aa$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= ((0, $dcYQ6.LAYOUT_COLUMN_PADDING) + $5a2d93df8d3e49aa$var$NESTED_DND_GUTTER_OFFSET) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $kgWXt.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $kgWXt.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $5a2d93df8d3e49aa$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $5a2d93df8d3e49aa$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $5a2d93df8d3e49aa$var$GRID_SIZE;
            // padding left
            parentWidth -= $5a2d93df8d3e49aa$var$GRID_SIZE * 4 - $5a2d93df8d3e49aa$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $l7YRm.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $5a2d93df8d3e49aa$export$84f6ca4f6812e69a = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        state.schema.nodes.bodiedSyncBlock
    ]);
    return parent ? parent.node : null;
};
const $5a2d93df8d3e49aa$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $5bbjm.akEditorGutterPaddingDynamic)() * 2 + (0, $5bbjm.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $5bbjm.akEditorFullWidthLayoutWidth)) : (0, $bjG1c.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $5a2d93df8d3e49aa$export$3930799be057b305 = (node)=>{
    if (node !== null && node !== void 0 && node.attrs.width) return node.attrs.width;
    return $5a2d93df8d3e49aa$export$9b77d38feba5446[node === null || node === void 0 ? void 0 : node.attrs.layout] || (0, $5bbjm.akEditorDefaultLayoutWidth);
};
const $5a2d93df8d3e49aa$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $5a2d93df8d3e49aa$export$3930799be057b305(node) - offset;
    return $5a2d93df8d3e49aa$export$3930799be057b305(node);
};

});
parcelRegister("gab48", function(module, exports) {
$parcel$export(module.exports, "removeParentNodeOfType", () => $bc4629f1f6781fb5$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $bc4629f1f6781fb5$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $bc4629f1f6781fb5$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $bc4629f1f6781fb5$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $bc4629f1f6781fb5$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $bc4629f1f6781fb5$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $bc4629f1f6781fb5$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $bc4629f1f6781fb5$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $bc4629f1f6781fb5$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $bc4629f1f6781fb5$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $bc4629f1f6781fb5$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $bc4629f1f6781fb5$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $bc4629f1f6781fb5$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $bc4629f1f6781fb5$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $bc4629f1f6781fb5$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $bc4629f1f6781fb5$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $bc4629f1f6781fb5$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $bc4629f1f6781fb5$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $bc4629f1f6781fb5$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $bc4629f1f6781fb5$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $bc4629f1f6781fb5$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByAttr", () => $bc4629f1f6781fb5$export$a836476a7f9de5b4);
$parcel$export(module.exports, "findChildrenByType", () => $bc4629f1f6781fb5$export$96bb9476c7c69f39);
$parcel$export(module.exports, "findChildrenByMark", () => $bc4629f1f6781fb5$export$c01a9e7ec615e821);
$parcel$export(module.exports, "contains", () => $bc4629f1f6781fb5$export$2344b14b097df817);
// src/selection.ts

var $cw0wu = parcelRequire("cw0wu");

var $kW8qW = parcelRequire("kW8qW");
var $bc4629f1f6781fb5$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $bc4629f1f6781fb5$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $bc4629f1f6781fb5$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $bc4629f1f6781fb5$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $bc4629f1f6781fb5$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $bc4629f1f6781fb5$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $bc4629f1f6781fb5$export$7d6e4e6663186878 = (tr)=>{
    if ($bc4629f1f6781fb5$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $bc4629f1f6781fb5$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $bc4629f1f6781fb5$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($bc4629f1f6781fb5$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kW8qW.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kW8qW.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $bc4629f1f6781fb5$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $cw0wu.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $bc4629f1f6781fb5$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $cw0wu.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $bc4629f1f6781fb5$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kW8qW.Node) && node.type && node.type.spec.selectable);
var $bc4629f1f6781fb5$var$shouldSelectNode = (node)=>$bc4629f1f6781fb5$var$isSelectableNode(node) && node.type.isLeaf;
var $bc4629f1f6781fb5$var$setSelection = (node, pos, tr)=>{
    if ($bc4629f1f6781fb5$var$shouldSelectNode(node)) return tr.setSelection(new (0, $cw0wu.NodeSelection)(tr.doc.resolve(pos)));
    return $bc4629f1f6781fb5$export$1df6d14df6b0b758(pos)(tr);
};
var $bc4629f1f6781fb5$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $bc4629f1f6781fb5$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($bc4629f1f6781fb5$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $bc4629f1f6781fb5$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($bc4629f1f6781fb5$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $bc4629f1f6781fb5$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $bc4629f1f6781fb5$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $bc4629f1f6781fb5$var$setSelection(content, pos, tr);
            }
        }
        if ($bc4629f1f6781fb5$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $bc4629f1f6781fb5$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $bc4629f1f6781fb5$var$cloneTr($bc4629f1f6781fb5$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($bc4629f1f6781fb5$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $bc4629f1f6781fb5$var$cloneTr($bc4629f1f6781fb5$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $bc4629f1f6781fb5$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $bc4629f1f6781fb5$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $bc4629f1f6781fb5$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $bc4629f1f6781fb5$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$bc4629f1f6781fb5$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $bc4629f1f6781fb5$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $bc4629f1f6781fb5$var$cloneTr(tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $bc4629f1f6781fb5$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $bc4629f1f6781fb5$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $bc4629f1f6781fb5$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $bc4629f1f6781fb5$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $cw0wu.NodeSelection);
};
var $bc4629f1f6781fb5$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $bc4629f1f6781fb5$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $bc4629f1f6781fb5$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($bc4629f1f6781fb5$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $bc4629f1f6781fb5$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $bc4629f1f6781fb5$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $bc4629f1f6781fb5$var$cloneTr(tr);
        }
        return tr;
    };
var $bc4629f1f6781fb5$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kW8qW.Fragment) ? content : (0, $kW8qW.Fragment).from(content));
};
var $bc4629f1f6781fb5$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $bc4629f1f6781fb5$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $bc4629f1f6781fb5$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kW8qW.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kW8qW.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $bc4629f1f6781fb5$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $bc4629f1f6781fb5$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $bc4629f1f6781fb5$export$fe09644e3bc6166b($from, predicate);
    };
var $bc4629f1f6781fb5$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $bc4629f1f6781fb5$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $bc4629f1f6781fb5$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $bc4629f1f6781fb5$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $bc4629f1f6781fb5$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$bc4629f1f6781fb5$export$dc159056ffdb4c76(predicate)(selection);
    };
var $bc4629f1f6781fb5$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $bc4629f1f6781fb5$export$dc159056ffdb4c76((node)=>$bc4629f1f6781fb5$var$equalNodeType(nodeType, node))(selection);
    };
var $bc4629f1f6781fb5$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $bc4629f1f6781fb5$export$fe09644e3bc6166b($pos, (node)=>$bc4629f1f6781fb5$var$equalNodeType(nodeType, node));
};
var $bc4629f1f6781fb5$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $bc4629f1f6781fb5$export$178ecaf80f45fdb6((node)=>$bc4629f1f6781fb5$var$equalNodeType(nodeType, node))(selection);
    };
var $bc4629f1f6781fb5$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $bc4629f1f6781fb5$export$8556d79fa8189214((node)=>$bc4629f1f6781fb5$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $bc4629f1f6781fb5$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($bc4629f1f6781fb5$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($bc4629f1f6781fb5$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $bc4629f1f6781fb5$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $cw0wu.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $bc4629f1f6781fb5$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $bc4629f1f6781fb5$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $bc4629f1f6781fb5$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $bc4629f1f6781fb5$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $bc4629f1f6781fb5$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $bc4629f1f6781fb5$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $bc4629f1f6781fb5$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $bc4629f1f6781fb5$export$ddc1620722e25671 = (node, descend = true)=>{
    return $bc4629f1f6781fb5$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $bc4629f1f6781fb5$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $bc4629f1f6781fb5$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $bc4629f1f6781fb5$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $bc4629f1f6781fb5$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $bc4629f1f6781fb5$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $bc4629f1f6781fb5$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $bc4629f1f6781fb5$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $bc4629f1f6781fb5$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $bc4629f1f6781fb5$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$bc4629f1f6781fb5$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("kgWXt", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $21f5beb477520675$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $21f5beb477520675$export$91624ec52c59c24c);
const $21f5beb477520675$export$f5ecdce4c60ff98b = 8;
const $21f5beb477520675$export$5ac5087fe1217160 = $21f5beb477520675$export$f5ecdce4c60ff98b * 2;
const $21f5beb477520675$export$91624ec52c59c24c = 12;

});

parcelRegister("dcYQ6", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $5ac00e685b528804$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $5ac00e685b528804$export$a1bb91aa2d5fcce8);
const $5ac00e685b528804$export$cd04f19842abff0 = 8;
const $5ac00e685b528804$export$a1bb91aa2d5fcce8 = $5ac00e685b528804$export$cd04f19842abff0 * 1.5;
const $5ac00e685b528804$export$e5ee675b2c7e739b = 50;

});

parcelRegister("l7YRm", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $3dcc7760d2803209$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableCellMinWidth", () => $3dcc7760d2803209$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $3dcc7760d2803209$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $3dcc7760d2803209$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $3dcc7760d2803209$export$e56b8ca552b280f6);
$parcel$export(module.exports, "tableControlsSpacing", () => $3dcc7760d2803209$export$880976487022eb5);
$parcel$export(module.exports, "tableSharedStyle", () => $3dcc7760d2803209$export$c2bf8eea75aa9302);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");

var $gCxu4 = parcelRequire("gCxu4");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $jxkn6 = parcelRequire("jxkn6");

var $1J9lh = parcelRequire("1J9lh");

var $44pOC = parcelRequire("44pOC");

var $enwus = parcelRequire("enwus");

function $3dcc7760d2803209$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3dcc7760d2803209$export$808015ab1dd6897a = 24;
const $3dcc7760d2803209$export$afe1899c3eea9823 = 16;
const $3dcc7760d2803209$export$910bf0d22c3d10f2 = 14;
const $3dcc7760d2803209$export$a43e30915fab3ccf = 8;
const $3dcc7760d2803209$export$531f77930bf508de = 48;
const $3dcc7760d2803209$export$c60fae4049791eae = 140;
const $3dcc7760d2803209$export$72aad729077aa0fb = 1;
const $3dcc7760d2803209$export$e56b8ca552b280f6 = 8;
const $3dcc7760d2803209$export$bba39e724bc39451 = 6;
const $3dcc7760d2803209$export$e5ff276883773ffd = 8;
const $3dcc7760d2803209$export$880976487022eb5 = $3dcc7760d2803209$export$808015ab1dd6897a + $3dcc7760d2803209$export$e5ff276883773ffd - $3dcc7760d2803209$export$72aad729077aa0fb;
/* first block node has 0 top margin */ var $3dcc7760d2803209$var$_ref = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $3dcc7760d2803209$var$firstNodeWithNotMarginTop = ()=>$3dcc7760d2803209$var$_ref;
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * The style is mirrored in:
 * - packages/editor/renderer/src/ui/Renderer/RendererStyleContainer.tsx ( seems outdated )
 * - packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
 *
 * If you are updating this, please also update the above files.
 *
 * @deprecated This Emotion-based style function is being phased out in favor of Compiled CSS.
 * Any changes here MUST also be reflected in `EditorContentContainer-compiled.tsx`
 * (look for `tableSharedStyle`, `tableSharedStyle_with_*`, `tableSharedStyle_without_*` entries
 * in the `editorContentStyles` cssMap) to keep the shared styles consistent.
 */ const $3dcc7760d2803209$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $jxkn6.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $9dQre.css)((0, $44pOC.tableCellBackgroundStyleOverride)(), " .", (0, $enwus.TableSharedCssClassName).TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Fake side borders are not needed when the rounded overlay owns the outer border. */
				.${(0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER},
				.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER} {
					display: none;
				}
					` : `.${(0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER},
			.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${(0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				left: 0;
			}
			.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true'] {
				left: ${(0, $5bbjm.akEditorTableNumberColumnWidth) - 1}px;
			}`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", (0, $enwus.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $5bbjm.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", (0, $enwus.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", (0, $enwus.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", (0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", (0, $enwus.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $gdUUy.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", (0, $enwus.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table,.", (0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;", (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Keep a transparent border so the collapsed border model reserves the same 1px slot
			   on the table edge; the ::after overlay draws the visible rounded border instead. */
			border: ${$3dcc7760d2803209$export$72aad729077aa0fb}px solid transparent;` : `border: ${$3dcc7760d2803209$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
			border-left-color: transparent;
			border-right-color: transparent;`, " table-layout:fixed;font-size:1em;width:100%;", (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `position: relative;

			/* Table-width outer-border owner for overflow-safe rounded corners. */
			&::after {
				content: '';
				position: absolute;
				inset: -0.5px;
				border: ${$3dcc7760d2803209$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				border-radius: ${"var(--ds-radius-xlarge, 12px)"};
				pointer-events: none;
				z-index: 1;
			}

			/* When content-visibility is applied to the table (see editor-plugin-table nodeview), the
			   implied \`contain: paint\` clips descendant painting to the table's border-box. The
			   overlay above sits at \`inset: -0.5px\` (half a pixel outside), so it would be shaved \u{2014}
			   most visibly along the bottom. Pull it flush to the edge so it paints inside the clip. */
			&[data-content-visibility]::after {
				inset: 0;
			}` : '', " &[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $3dcc7760d2803209$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;", (0, $4zjoa.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) ? `&[data-valign='middle'] {
								vertical-align: middle;
							}
							&[data-valign='bottom'] {
								vertical-align: bottom;
							}` : '', " border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $3dcc7760d2803209$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}", (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Let the wrapper overlay own the outer table perimeter.
				   data-reaches-* attributes are set by the TableCell node view. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top] {
					border-top-color: transparent;
				}

				> tbody > tr > th[data-reaches-left],
				> tbody > tr > td[data-reaches-left] {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-left]::after {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-bottom]::after,
				> tbody > tr > th[data-reaches-bottom]::after {
					border-bottom-color: transparent;
				}

				/* The rounded-table overlay owns transparent perimeter borders.
				   Paint edge cell backgrounds into that reserved border area so coloured
				   first/last rows do not show the page background through 1px seams. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top],
				> tbody > tr > th[data-reaches-bottom],
				> tbody > tr > td[data-reaches-bottom] {
					background-clip: border-box;
				}` : '', " th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $5N1Y4.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $5bbjm.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $gCxu4.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $gCxu4.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}", (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* When the number column is enabled, the left visual edge belongs to the number column.
		   Remove the left border-radius and left border from the table's ::after overlay
		   so it doesn't double-up or round where the number column already provides that edge. */
		.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
			> .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table::after,
			> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table::after {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-left-color: transparent;
			}
		}` : '', ";");
};

});
parcelRegister("gCxu4", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $2fb1fa07b5b4f6da$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
const $2fb1fa07b5b4f6da$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9dQre.css)();
};

});

parcelRegister("jxkn6", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $a130475ad1c86224$export$6c724a6ffa2dc3e1);

var $57l7A = parcelRequire("57l7A");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$IE_EDGE_REGEX = /\sedg\//i;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$IE_EDGE2_REGEX = /edg([ea]|ios)/i;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$INTERNET_EXPLORER_REGEX = /msie|trident/i;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$MAC_REGEX = /Mac/;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$WINDOWS_REGEX = /Windows|Win\d+/i;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$IE_EDGE_VERSION_REGEX = /\sedg\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$IE_EDGE2_VERSION_REGEX = /edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$IE_VERSION_REGEX = /(?:msie |rv:)(\d+(\.?_?\d+)+)/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$GECKO_REGEX = /gecko\/\d/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$CHROME_REGEX = /Chrome\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$ANDROID_REGEX = /Android \d/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$APPLE_WEBKIT_REGEX = /AppleWebKit/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$MOBILE_REGEX = /Mobile\/\w+/;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$SAFARI_REGEX = /safari|applewebkit/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$SAFARI_VERSION_REGEX = /Version\/([0-9\._]+).*Safari/;
// eslint-disable-next-line require-unicode-regexp
const $a130475ad1c86224$var$WEBKIT_REGEX = /(apple)?webkit/i;
const $a130475ad1c86224$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $a130475ad1c86224$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $a130475ad1c86224$var$getSafeUserAgent = ()=>{
    var _window$navigator;
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
};
const $a130475ad1c86224$var$getSafePlatform = ()=>{
    var _window$navigator2;
    if (typeof window === 'undefined') return undefined;
    return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform;
};
const $a130475ad1c86224$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $a130475ad1c86224$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $a130475ad1c86224$export$6c724a6ffa2dc3e1 = (0, $57l7A.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $a130475ad1c86224$var$getSafeUserAgent();
    const platform = $a130475ad1c86224$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        const ieEdge = $a130475ad1c86224$var$IE_EDGE_REGEX.test(userAgent);
        const ieEdge2 = $a130475ad1c86224$var$IE_EDGE2_REGEX.test(userAgent);
        const internetExplorer = $a130475ad1c86224$var$INTERNET_EXPLORER_REGEX.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        result.mac = platform && $a130475ad1c86224$var$MAC_REGEX.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = $a130475ad1c86224$var$WINDOWS_REGEX.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($a130475ad1c86224$var$getFirstMatch($a130475ad1c86224$var$IE_EDGE_VERSION_REGEX, userAgent), 10) : ieEdge2 ? parseInt($a130475ad1c86224$var$getSecondMatch($a130475ad1c86224$var$IE_EDGE2_VERSION_REGEX, userAgent), 10) : parseInt($a130475ad1c86224$var$getFirstMatch($a130475ad1c86224$var$IE_VERSION_REGEX, userAgent), 10);
        result.gecko = !ie && $a130475ad1c86224$var$GECKO_REGEX.test(userAgent);
        result.gecko_version = parseInt((userAgent.match($a130475ad1c86224$var$FIREFOX_VERSION_REGEX) || [])[1], 10);
        result.chrome = !ie && $a130475ad1c86224$var$CHROME_REGEX.test(userAgent);
        result.chrome_version = parseInt((userAgent.match($a130475ad1c86224$var$CHROME_VERSION_REGEX) || [])[1], 10);
        result.android = $a130475ad1c86224$var$ANDROID_REGEX.test(userAgent);
        result.ios = !ie && $a130475ad1c86224$var$APPLE_WEBKIT_REGEX.test(userAgent) && $a130475ad1c86224$var$MOBILE_REGEX.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && $a130475ad1c86224$var$SAFARI_REGEX.test(userAgent);
        result.safari_version = parseInt((userAgent.match($a130475ad1c86224$var$SAFARI_VERSION_REGEX) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        result.webkit = $a130475ad1c86224$var$WEBKIT_REGEX.test(userAgent);
        result.supportsIntersectionObserver = $a130475ad1c86224$var$hasIntersectionObserver();
        result.supportsResizeObserver = $a130475ad1c86224$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("1J9lh", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $44f99ce486f121f5$export$42659c26f026f6ea);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $44f99ce486f121f5$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("44pOC", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $5cb8cec1322d8637$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $a2BNk = parcelRequire("a2BNk");
const $5cb8cec1322d8637$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $9dQre.css)((0, $a2BNk.mapBackgroundColors)());

});
parcelRegister("a2BNk", function(module, exports) {
$parcel$export(module.exports, "mapBackgroundColors", () => $5cd3d589c39e535d$export$35c9e86e192acb85);

var $c8L22 = parcelRequire("c8L22");

var $e4OZJ = parcelRequire("e4OZJ");
const $5cd3d589c39e535d$export$35c9e86e192acb85 = ()=>{
    let cssString = '';
    (0, $c8L22.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $e4OZJ.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};

});
parcelRegister("e4OZJ", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $333310fc811fd1a1$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $333310fc811fd1a1$export$a270511a0e7fd61a);
// This import will be stripped on build

var $g86TM = parcelRequire("g86TM");
function $333310fc811fd1a1$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $333310fc811fd1a1$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $333310fc811fd1a1$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $333310fc811fd1a1$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $333310fc811fd1a1$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    /** blue - bold */ ['#ADCBFB']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.blue.subtler.hovered', fallback),
        token: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"
    },
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    /** teal - bold */ ['#B1E4F7']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.teal.subtler.hovered', fallback),
        token: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    /** green - bold */ ['#97EDC9']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.green.subtler.hovered', fallback),
        token: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)"
    },
    // lime
    /** lime - light */ ['#EFFFD6']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.lime.subtlest', fallback),
        token: "var(--ds-background-accent-lime-subtlest, #EFFFD6)"
    },
    /** lime - medium */ ['#D3F1A7']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.lime.subtler', fallback),
        token: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    /** lime - bold */ ['#BDE97C']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.lime.subtler.hovered', fallback),
        token: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    /** yellow - bold */ ['#EFDD4E']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.yellow.subtler.hovered', fallback),
        token: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"
    },
    // orange
    /** orange - light */ ['#FFF5DB']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.orange.subtlest', fallback),
        token: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    /** orange - medium */ ['#FCE4A6']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.orange.subtler', fallback),
        token: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    /** orange - bold */ ['#FBD779']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.orange.subtler.hovered', fallback),
        token: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)"
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    /** red - bold */ ['#FFB8B2']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.red.subtler.hovered', fallback),
        token: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"
    },
    // magenta
    /** magenta - light */ ['#FFECF8']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.magenta.subtlest', fallback),
        token: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    /** magenta - medium */ ['#FDD0EC']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.magenta.subtler', fallback),
        token: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    /** magenta - bold */ ['#FCB6E1']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.magenta.subtler.hovered', fallback),
        token: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    /** purple - bold */ ['#E3BDFA']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.purple.subtler.hovered', fallback),
        token: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    },
    /** gray - bold */ ['#B7B9BE']: {
        getValue: (fallback)=>(0, $g86TM.getTokenValue)('color.background.accent.gray.subtler.hovered', fallback),
        token: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"
    }
};

});
parcelRegister("g86TM", function(module, exports) {
$parcel$export(module.exports, "getTokenValue", () => $8532aee25e42b35f$export$37e2c47c7e49c28a);


var $5A4bG = parcelRequire("5A4bG");

var $4eGW1 = parcelRequire("4eGW1");
function $8532aee25e42b35f$export$37e2c47c7e49c28a(tokenId, fallback = '') {
    let token = (0, $5A4bG.default)[tokenId];
    let tokenValue = fallback;
    typeof $4eGW1;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $8532aee25e42b35f$export$2e2bcd8739ae039 = $8532aee25e42b35f$export$37e2c47c7e49c28a;

});
parcelRegister("5A4bG", function(module, exports) {
$parcel$export(module.exports, "default", () => $f17b8b1a621b732a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d072e16631e9fcbd519ab65335430217>>
 * @codegenCommand yarn build tokens
 */ const $f17b8b1a621b732a$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.form.message.enter': '--ds-form-message-enter',
    'motion.form.message.exit': '--ds-form-message-exit',
    'motion.input': '--ds-input',
    'motion.input.selection': '--ds-input-selection',
    'motion.input.toggle': '--ds-input-toggle',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'motion.tab': '--ds-tab',
    'motion.tab.indicator.enter.left': '--ds-tab-indicator-enter-left',
    'motion.tab.indicator.enter.right': '--ds-tab-indicator-enter-right',
    'motion.tab.indicator.exit.left': '--ds-tab-indicator-exit-left',
    'motion.tab.indicator.exit.right': '--ds-tab-indicator-exit-right',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.gap.large': '--ds-space-gap-large',
    'space.gap.medium': '--ds-space-gap-medium',
    'space.gap.small': '--ds-space-gap-small',
    'space.gap.xlarge': '--ds-space-gap-xlarge',
    'space.gap.xsmall': '--ds-space-gap-xsmall',
    'space.gap.xxlarge': '--ds-space-gap-xxlarge',
    'space.gap.xxsmall': '--ds-space-gap-xxsmall',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $f17b8b1a621b732a$export$2e2bcd8739ae039 = $f17b8b1a621b732a$var$tokens;

});





parcelRegister("enwus", function(module, exports) {
$parcel$export(module.exports, "TableSharedCssClassName", () => $ea8f61a39f26724e$export$c096bca5477eb7ad);

var $c8L22 = parcelRequire("c8L22");
const $ea8f61a39f26724e$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $c8L22.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $c8L22.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $c8L22.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $c8L22.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $c8L22.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $c8L22.tablePrefixSelector)}-left-border`,
    TABLE_NATIVE_STICKY: `${(0, $c8L22.tablePrefixSelector)}-row-native-sticky`,
    TABLE_STICKY_WRAPPER: `${(0, $c8L22.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $c8L22.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $c8L22.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $c8L22.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $c8L22.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $c8L22.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_STICKY: `${(0, $c8L22.tablePrefixSelector)}-sticky`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $c8L22.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $c8L22.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $c8L22.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $c8L22.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $c8L22.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $c8L22.tablePrefixSelector)}-resizer-container`,
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};

});


parcelRegister("bjG1c", function(module, exports) {
$parcel$export(module.exports, "breakoutConsts", () => $0fe1585d39ee66d7$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $0fe1585d39ee66d7$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $0fe1585d39ee66d7$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $0fe1585d39ee66d7$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $0fe1585d39ee66d7$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $0fe1585d39ee66d7$export$c377853ecdd53e5b);
$parcel$export(module.exports, "calcBreakoutWidthPx", () => $0fe1585d39ee66d7$export$586300c53bd298dd);

var $5bbjm = parcelRequire("5bbjm");

var $avVPS = parcelRequire("avVPS");

var $5oXqC = parcelRequire("5oXqC");

var $71ibJ = parcelRequire("71ibJ");




const $0fe1585d39ee66d7$export$ead1fecec2ecf57c = {
    padding: (0, $5bbjm.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $5bbjm.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $5bbjm.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $5bbjm.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $5bbjm.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $avVPS.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $5oXqC.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $0fe1585d39ee66d7$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $0fe1585d39ee66d7$export$ead1fecec2ecf57c.calcBreakoutWidth($0fe1585d39ee66d7$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $5bbjm.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $5bbjm.akEditorWideLayoutWidth;
        default:
            return $0fe1585d39ee66d7$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($0fe1585d39ee66d7$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $0fe1585d39ee66d7$export$86325001fe8f3adc = $0fe1585d39ee66d7$export$ead1fecec2ecf57c.calcWideWidth($0fe1585d39ee66d7$export$ead1fecec2ecf57c);
const $0fe1585d39ee66d7$export$5f4502874a28dfce = $0fe1585d39ee66d7$export$ead1fecec2ecf57c.calcBreakoutWidth($0fe1585d39ee66d7$export$ead1fecec2ecf57c);
const $0fe1585d39ee66d7$export$ccc0a02edddeed39 = $0fe1585d39ee66d7$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($0fe1585d39ee66d7$export$ead1fecec2ecf57c);
function $0fe1585d39ee66d7$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $0fe1585d39ee66d7$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $71ibJ.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $5bbjm.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $5bbjm.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $0fe1585d39ee66d7$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $71ibJ.parsePx)($0fe1585d39ee66d7$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}

});
parcelRegister("avVPS", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $87f48c5342c877d2$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $87f48c5342c877d2$export$a1a213d350ca51ca);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $2aX1J = parcelRequire("2aX1J");

var $5bbjm = parcelRequire("5bbjm");

var $5oXqC = parcelRequire("5oXqC");
function $87f48c5342c877d2$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $87f48c5342c877d2$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $bSJIT.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $5bbjm.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2aX1J.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $87f48c5342c877d2$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5oXqC.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $dc70d.jsx)($87f48c5342c877d2$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
                    children: children
                })
            })
    });
}

});

parcelRegister("71ibJ", function(module, exports) {
$parcel$export(module.exports, "parsePx", () => $1e303672c6d9e595$export$b0eef8cd00b29d5c);
/**
 * Util for converting a css pixel size value to a number (of pixels).
 *
 * ie.
 * ```ts
 * const pixels = parsePx('10px')
 * //    ^$ const pixels: number
 * ```
 * * ```ts
 * const pixels = parsePx('10')
 * //    ^$ const pixels: number | undefined
 * ```
 */ // At time of writting prettier would strip the extend here.
// prettier-ignore
function $1e303672c6d9e595$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}

});



parcelRegister("eVpwU", function(module, exports) {
$parcel$export(module.exports, "isTableInContentMode", () => $891fbb08e1898e5b$export$90b9840b2d94b80a);

var $2Dpi1 = parcelRequire("2Dpi1");
const $891fbb08e1898e5b$export$8c07f44cea64e3c7 = (tableNode)=>tableNode.attrs.width !== null || (0, $2Dpi1.hasTableColumnBeenResized)(tableNode);
const $891fbb08e1898e5b$export$90b9840b2d94b80a = ({ tableNode: tableNode, isSupported: isSupported, isTableNested: isTableNested })=>{
    if (!tableNode || isTableNested) return false;
    return isSupported && !$891fbb08e1898e5b$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};

});
parcelRegister("2Dpi1", function(module, exports) {
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $2298592dcd3bfab9$export$b44a013e4f554514);
const $2298592dcd3bfab9$export$b44a013e4f554514 = (tableNode)=>{
    const firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(let i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};

});


parcelRegister("2OSrK", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $1ba844985ddf41dd$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 

var $d0HRE = parcelRequire("d0HRE");

var $dOB7E = parcelRequire("dOB7E");

var $dR61S = parcelRequire("dR61S");

var $1ba844985ddf41dd$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("d0HRE", function(module, exports) {
$parcel$export(module.exports, "ToolbarSize", () => $091356edd2f18d3c$export$ed55211407a9423);
var $091356edd2f18d3c$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});

});

parcelRegister("dOB7E", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $9ea24caec5dd5bcd$export$501a79d885598191);
var $9ea24caec5dd5bcd$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});

parcelRegister("dR61S", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsNext", () => $18e5a0ca8bcb6c27$export$3f050002d3df641b);
var $18e5a0ca8bcb6c27$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});

});


parcelRegister("aU4zH", function(module, exports) {
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $c6c32d5ea9c400ba$export$69fbfaf01f2fd534);
function $c6c32d5ea9c400ba$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}

});

parcelRegister("lsbSX", function(module, exports) {
$parcel$export(module.exports, "hasMergedCell", () => $97c4142b5736d950$export$f9d610bfbb78949b);
function $97c4142b5736d950$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}

});

parcelRegister("hk8Gf", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $165eea42d622370a$export$49215374a8bec29c);

var $2OSrK = parcelRequire("2OSrK");

var $8TDg3 = parcelRequire("8TDg3");
function $165eea42d622370a$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $165eea42d622370a$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $165eea42d622370a$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            const maybeANumber = $165eea42d622370a$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $165eea42d622370a$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $165eea42d622370a$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: (0, $8TDg3.ContentType).LINK,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: (0, $8TDg3.ContentType).NUMBER,
        value: normalizedText
    };
    return {
        type: (0, $8TDg3.ContentType).TEXT,
        value: normalizedText ?? text
    };
}
function $165eea42d622370a$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $165eea42d622370a$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: (0, $8TDg3.ContentType).LINK,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: (0, $8TDg3.ContentType).LINK,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $165eea42d622370a$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: (0, $8TDg3.ContentType).STATUS,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: (0, $8TDg3.ContentType).DATE,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: (0, $8TDg3.ContentType).MENTION,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $165eea42d622370a$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $165eea42d622370a$export$49215374a8bec29c = (options, order = (0, $2OSrK.SortOrder).ASC)=>{
    const normalizeTextParser = $165eea42d622370a$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $165eea42d622370a$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $165eea42d622370a$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $165eea42d622370a$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $2OSrK.SortOrder).DESC ? -1 : 1) * $165eea42d622370a$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $165eea42d622370a$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type === (0, $8TDg3.ContentType).TEXT && metaNodeB.type === (0, $8TDg3.ContentType).NUMBER || metaNodeA.type === (0, $8TDg3.ContentType).NUMBER && metaNodeB.type === (0, $8TDg3.ContentType).TEXT) return $165eea42d622370a$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $165eea42d622370a$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("8TDg3", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $309cbd3d3a9691d9$export$e2e108cbe2e4f865);
var $309cbd3d3a9691d9$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});

});


parcelRegister("fkNZo", function(module, exports) {
$parcel$export(module.exports, "compose", () => $ad7ceacd9fdf9908$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $ad7ceacd9fdf9908$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("9mxVO", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $c8b72be2c3391367$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $c8b72be2c3391367$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bSJIT = parcelRequire("bSJIT");
const $c8b72be2c3391367$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});
const $c8b72be2c3391367$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($c8b72be2c3391367$var$RendererContext);
const $c8b72be2c3391367$export$ca5df47902194781 = $c8b72be2c3391367$var$RendererContext.Provider;

});

parcelRegister("1EI4O", function(module, exports) {
$parcel$export(module.exports, "FullPagePadding", () => $cad8f2e1ee70eb43$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $cad8f2e1ee70eb43$export$74b525449cc7cbd1);
const $cad8f2e1ee70eb43$export$12fd658e5eef0d79 = 32;
const $cad8f2e1ee70eb43$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

});

parcelRegister("4Iwar", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $bceffddb501118a6$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $bceffddb501118a6$export$65e2d5a272a382b0);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $bceffddb501118a6$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(new Map());
const $bceffddb501118a6$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)($bceffddb501118a6$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $bceffddb501118a6$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        render() {
            return /*#__PURE__*/ (0, $dc70d.jsx)($bceffddb501118a6$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("bznsM", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $a31e5f4707c3eebc$export$c0112b8340d4924b);
$parcel$export(module.exports, "isMaxWidthAppearance", () => $a31e5f4707c3eebc$export$ab050440a1241762);
$parcel$export(module.exports, "isFullPageAppearance", () => $a31e5f4707c3eebc$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $a31e5f4707c3eebc$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $a31e5f4707c3eebc$export$33331a99fac775a1);
const $a31e5f4707c3eebc$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $a31e5f4707c3eebc$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $a31e5f4707c3eebc$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $a31e5f4707c3eebc$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $a31e5f4707c3eebc$export$33331a99fac775a1 = (appearance)=>$a31e5f4707c3eebc$export$a64737a81cde10b4(appearance) || $a31e5f4707c3eebc$export$c0112b8340d4924b(appearance) || $a31e5f4707c3eebc$export$ab050440a1241762(appearance);

});

parcelRegister("6fBiz", function(module, exports) {
$parcel$export(module.exports, "getCachedTableEdges", () => $dc41da44a23d5780$export$31d630246d855205);
$parcel$export(module.exports, "cacheTableEdges", () => $dc41da44a23d5780$export$478493861e163fac);
$parcel$export(module.exports, "withTableCellEdgeProps", () => $dc41da44a23d5780$export$bd1a340286df77f2);

var $bSJIT = parcelRequire("bSJIT");
// The table node includes the number-column setting. Cache only its edge data.
const $dc41da44a23d5780$var$edgeCache = new WeakMap();
const $dc41da44a23d5780$var$noEdges = {
    reachesTop: false,
    reachesBottom: false,
    reachesLeft: false,
    reachesRight: false
};
const $dc41da44a23d5780$export$31d630246d855205 = (node)=>$dc41da44a23d5780$var$edgeCache.get(node);
const $dc41da44a23d5780$export$478493861e163fac = (node, edges)=>{
    // The existing geometry builder provides every cell; retain only the perimeter.
    for (const [offset, props] of edges)if (!props.reachesTop && !props.reachesBottom && !props.reachesLeft && !props.reachesRight) edges.delete(offset);
    $dc41da44a23d5780$var$edgeCache.set(node, edges);
};
const $dc41da44a23d5780$export$bd1a340286df77f2 = (element, edges = $dc41da44a23d5780$var$noEdges)=>{
    const current = element.props;
    if (Boolean(current.reachesTop) === edges.reachesTop && Boolean(current.reachesBottom) === edges.reachesBottom && Boolean(current.reachesLeft) === edges.reachesLeft && Boolean(current.reachesRight) === edges.reachesRight) return element;
    // Also clears stale edges when a previously decorated element becomes an interior cell.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(element, edges);
};

});

parcelRegister("7xVpU", function(module, exports) {
$parcel$export(module.exports, "isContentModeSupported", () => $6816dd66d0ebd1bc$export$e217d2a535d6ae45);
const $6816dd66d0ebd1bc$export$e217d2a535d6ae45 = ({ allowTableResizing: allowTableResizing, rendererAppearance: rendererAppearance })=>{
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};

});

parcelRegister("39DfA", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $01dbf3aad2e9f1a4$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $01dbf3aad2e9f1a4$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $01dbf3aad2e9f1a4$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $enwus = parcelRequire("enwus");

var $5bbjm = parcelRequire("5bbjm");

var $5N1Y4 = parcelRequire("5N1Y4");

var $6XKXt = parcelRequire("6XKXt");

var $ib6wf = parcelRequire("ib6wf");
function $01dbf3aad2e9f1a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01dbf3aad2e9f1a4$export$3de6413b528017ca = 8;
const $01dbf3aad2e9f1a4$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
const $01dbf3aad2e9f1a4$var$suppressExternalStickStyles = {
    name: "1hdnnda",
    styles: "&.fixed-table-div-custom-table-resizing[mode='stick']{background:var(--ds-surface, #FFFFFF);}"
};
const $01dbf3aad2e9f1a4$var$panelAwareStickyTableStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Override external renderer wrapper styles targeting div[mode='stick']
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        background: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface, #FFFFFF)"})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface, #FFFFFF)"})`
        }
    },
    borderTopColor: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface, #FFFFFF)"})`,
    background: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface-overlay, #FFFFFF)"})`
});
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $01dbf3aad2e9f1a4$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $9dQre.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$01dbf3aad2e9f1a4$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $01dbf3aad2e9f1a4$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $5bbjm.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $01dbf3aad2e9f1a4$var$fixedTableDivStaticStyles,
            $01dbf3aad2e9f1a4$var$modeSpecficStyles === null || $01dbf3aad2e9f1a4$var$modeSpecficStyles === void 0 ? void 0 : $01dbf3aad2e9f1a4$var$modeSpecficStyles[mode],
            (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $01dbf3aad2e9f1a4$var$suppressExternalStickStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && $01dbf3aad2e9f1a4$var$panelAwareStickyTableStyles
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $01dbf3aad2e9f1a4$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $9dQre.jsx)($01dbf3aad2e9f1a4$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $ib6wf.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: true,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6XKXt.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $01dbf3aad2e9f1a4$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $01dbf3aad2e9f1a4$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $01dbf3aad2e9f1a4$export$e97bc6692974bd0b($01dbf3aad2e9f1a4$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("6XKXt", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $6fa2c5a847250ebc$export$40e12ce8e0a76b0c);

var $bSJIT = parcelRequire("bSJIT");
function $6fa2c5a847250ebc$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, {
            children: $6fa2c5a847250ebc$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, propsToInject);
    });
}

});

parcelRegister("ib6wf", function(module, exports) {
$parcel$export(module.exports, "Table", () => $a176e596933ca48f$export$54ec01a60f47d33d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5nq9a = parcelRequire("5nq9a");

var $eVpwU = parcelRequire("eVpwU");

var $5bbjm = parcelRequire("5bbjm");

var $gdUUy = parcelRequire("gdUUy");

var $fexIU = parcelRequire("fexIU");

var $7xVpU = parcelRequire("7xVpU");
const $a176e596933ca48f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    var _tableNode$attrs;
    let tableWidth = tableNode ? (0, $5nq9a.getTableContainerWidth)(tableNode) : (0, $5bbjm.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) tableWidth = 'inherit';
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') tableColumnWidths = columnWidths && (0, $fexIU.colWidthSum)(columnWidths) ? columnWidths : undefined;
    const tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
    const tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
    const isContentMode = (0, $eVpwU.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $7xVpU.isContentModeSupported)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("table", {
        ...(0, $gdUUy.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fexIU.Colgroup), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("fexIU", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $7c413c7ed817f76d$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $7c413c7ed817f76d$export$89efc2d0ceeaa030);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5nq9a = parcelRequire("5nq9a");

var $l7YRm = parcelRequire("l7YRm");

var $5oXqC = parcelRequire("5oXqC");

var $5bbjm = parcelRequire("5bbjm");

var $9mxVO = parcelRequire("9mxVO");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $7c413c7ed817f76d$var$MAX_SCALING_PERCENT = 0.3;
const $7c413c7ed817f76d$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $7c413c7ed817f76d$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $7c413c7ed817f76d$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent, skipMinWidth: skipMinWidth })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        const scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $l7YRm.tableCellMinWidth));
    }
    const adjusted = columnWidth - (0, $l7YRm.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $5bbjm.akEditorTableLegacyCellMinWidth) : (0, $l7YRm.tableCellMinWidth));
};
const $7c413c7ed817f76d$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $5bbjm.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $5bbjm.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $7c413c7ed817f76d$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ const $7c413c7ed817f76d$var$getDataColumnWidth = (totalWidth, isNumberColumnEnabled)=>isNumberColumnEnabled ? totalWidth - (0, $5bbjm.akEditorTableNumberColumnWidth) : totalWidth;
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ const $7c413c7ed817f76d$var$scaleColumnsToWidth = (columnWidths, availableWidth)=>{
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    const scaleFactor = availableWidth / rawTotalWidth;
    const scaledWidths = columnWidths.map((colWidth)=>Math.max(Math.floor(colWidth * scaleFactor), (0, $l7YRm.tableCellMinWidth)));
    const totalScaled = scaledWidths.reduce((sum, w)=>sum + w, 0);
    const diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $l7YRm.tableCellMinWidth)) {
        for(let i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $l7YRm.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map((width)=>({
            width: `${width}px`
        }));
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true), we use getTableContainerWidth(tableNode) as the
 * reference — the width the editor saved, which already accounts for the parent cell's available
 * space (colwidth minus tableCellPadding * 2). This matches bodiedSyncBlock where isRendererNested=false,
 * so renderScaleDownColgroup uses getTableContainerWidth(tableNode). For syncBlock the nested
 * renderer has isRendererNested=true, which incorrectly overrides tableContainerWidth with renderWidth
 * (the full container), causing overflow by 2 * tableCellPadding (16px).
 */ const $7c413c7ed817f76d$var$renderSyncBlockColgroup = ({ isInsideOfSyncBlock: isInsideOfSyncBlock, isInsideOfTable: isInsideOfTable, tableNode: tableNode, columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidthProp, contextWidth: contextWidth })=>{
    if (!isInsideOfSyncBlock) return null;
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    if (isInsideOfTable) return null;
    // SSR / first client render before WidthObserver measures. Output % of original ADF
    // proportions so columns are stable — the CSS container query (100cqw) handles actual
    // scaling width. We key off renderWidthProp alone because WidthProvider initialises with
    // document.body.offsetWidth (non-zero on the client), so contextWidth > 0 even before
    // WidthObserver has measured the real container, which would skip this branch and produce
    // column widths scaled to the full viewport.
    if (renderWidthProp <= 0) {
        const fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $5bbjm.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map((colWidth)=>({
                width: `${colWidth / fullTableWidth * 100}%`
            }));
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    const effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    const availableWidth = $7c413c7ed817f76d$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    // Only scale down if the table is actually wider than the available space.
    // If the table fits, return original widths with the same tableCellBorderWidth (2px) adjustment
    // that renderScaleDownColgroup applies via fixColumnWidth's no-scale path.
    if (availableWidth >= rawTotalWidth) return columnWidths.map((colWidth)=>({
            width: `${Math.max(colWidth - (0, $l7YRm.tableCellBorderWidth), (0, $l7YRm.tableCellMinWidth))}px`
        }));
    // Cap scaling at MAX_SCALING_PERCENT (30%), matching renderScaleDownColgroup's calcScalePercent.
    //
    // Both `availableWidth` and `rawTotalWidth` are already in data-column space (number column
    // excluded via getDataColumnWidth), so `diffPercent = 1 - availableWidth / rawTotalWidth` is
    // equivalent to calcScalePercent's `numColumnScalePercent` path when isNumberColumnEnabled,
    // and to the `noNumColumnScalePercent` path otherwise. We express the cap as a target width
    // (clampedAvailableWidth) rather than a scale-down percentage, but the result is the same:
    // columns are scaled by at most MAX_SCALING_PERCENT (30%).
    const diffPercent = 1 - availableWidth / rawTotalWidth;
    const clampedAvailableWidth = diffPercent <= $7c413c7ed817f76d$var$MAX_SCALING_PERCENT ? availableWidth : Math.floor(rawTotalWidth * (1 - $7c413c7ed817f76d$var$MAX_SCALING_PERCENT));
    return $7c413c7ed817f76d$var$scaleColumnsToWidth(columnWidths, clampedAvailableWidth);
};
const $7c413c7ed817f76d$var$renderScaleDownColgroup = (props)=>{
    var _props$tableNode;
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, isInsideOfSyncBlock: isInsideOfSyncBlock } = props;
    const skipMinWidth = !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every((width)=>width === 0)) return [];
    const tableColumnResized = $7c413c7ed817f76d$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) || isRendererNested && !isNumberColumnEnabled ? renderWidth : (0, $5nq9a.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $5bbjm.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $7c413c7ed817f76d$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $5bbjm.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $5bbjm.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $l7YRm.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $l7YRm.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $5bbjm.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $5bbjm.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && ((_props$tableNode = props.tableNode) === null || _props$tableNode === void 0 ? void 0 : _props$tableNode.attrs.displayMode) === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $7c413c7ed817f76d$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $7c413c7ed817f76d$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $5bbjm.akEditorTableLegacyCellMinWidth) ? (0, $5bbjm.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) scaleDownPercent = $7c413c7ed817f76d$var$calcScalePercent({
        renderWidth: renderWidth,
        tableWidth: tableWidth,
        maxScale: maxScalingPercent,
        isNumberColumnEnabled: isNumberColumnEnabled
    });
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$7c413c7ed817f76d$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth);
        const sumFixedColumnWidths = $7c413c7ed817f76d$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $5bbjm.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $7c413c7ed817f76d$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $7c413c7ed817f76d$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer, nestedRendererType: nestedRendererType } = (0, $9mxVO.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const { width: contextWidth } = (0, $bSJIT.useContext)((0, $5oXqC.WidthContext));
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = props.allowFixedColumnWidthOption ?? false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    const isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    const colStyles = $7c413c7ed817f76d$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    }) ?? $7c413c7ed817f76d$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $dc70d.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $5bbjm.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $dc70d.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});



parcelRegister("8hixA", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $507b60b666784151$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $507b60b666784151$export$1e4baea7053fc0e3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8bHyz = parcelRequire("8bHyz");

var $c8L22 = parcelRequire("c8L22");

var $g6Qq4 = parcelRequire("g6Qq4");

var $9SvhO = parcelRequire("9SvhO");

var $2OSrK = parcelRequire("2OSrK");

var $e4OZJ = parcelRequire("e4OZJ");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $ceb9s = parcelRequire("ceb9s");

var $dABkj = parcelRequire("dABkj");

var $cvo9f = parcelRequire("cvo9f");

var $d8oXW = parcelRequire("d8oXW");
const $507b60b666784151$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $507b60b666784151$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $2OSrK.SortOrder).NO_ORDER:
            return (0, $2OSrK.SortOrder).ASC;
        case (0, $2OSrK.SortOrder).ASC:
            return (0, $2OSrK.SortOrder).DESC;
        case (0, $2OSrK.SortOrder).DESC:
            return (0, $2OSrK.SortOrder).NO_ORDER;
    }
    return (0, $2OSrK.SortOrder).NO_ORDER;
};
const $507b60b666784151$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $d8oXW.tableCellMessages);
    switch(currentSortOrder){
        case (0, $2OSrK.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $2OSrK.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $2OSrK.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $507b60b666784151$var$getDataAttributes = (colwidth, background, cellEdgeProps, valign)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    if ((0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesTop) attrs['data-reaches-top'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesBottom) attrs['data-reaches-bottom'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesLeft) attrs['data-reaches-left'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesRight) attrs['data-reaches-right'] = true;
    }
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    if (valign && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) attrs['data-valign'] = valign;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $507b60b666784151$var$cssVariablePattern = /^var\(--.*\)$/;
const $507b60b666784151$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode, valign: valign })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $e4OZJ.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $507b60b666784151$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $8bHyz.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    if (valign && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) style.verticalAlign = valign;
    return style;
};
const $507b60b666784151$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort, reachesTop: reachesTop, reachesBottom: reachesBottom, reachesLeft: reachesLeft, reachesRight: reachesRight, valign: valign } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const backgroundHex = background === null || background === void 0 ? void 0 : background.toLowerCase();
        const colorName = backgroundHex ? (0, $c8L22.tableBackgroundColorNameByHex).get(backgroundHex) : '';
        return /*#__PURE__*/ (0, $dc70d.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $507b60b666784151$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode,
                valign: valign
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$507b60b666784151$var$getDataAttributes(colwidth, background, {
                reachesTop: reachesTop,
                reachesBottom: reachesBottom,
                reachesLeft: reachesLeft,
                reachesRight: reachesRight
            }, valign),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $507b60b666784151$var$TH = $507b60b666784151$var$getWithCellProps('th');
const $507b60b666784151$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $4vLTk.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $2OSrK.SortOrder).NO_ORDER ? (0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $dc70d.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $507b60b666784151$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                className: (0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $dc70d.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9SvhO.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$507b60b666784151$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $507b60b666784151$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).SORT_COLUMN,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $dABkj.PLATFORM).WEB,
                        mode: (0, $dABkj.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $dABkj.PLATFORM).WEB,
                    mode: (0, $dABkj.MODE).RENDERER
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            });
        }
    };
};
const $507b60b666784151$export$f850895b287ef28e = $507b60b666784151$export$cfca40ca5c56a38e($507b60b666784151$var$TH);
const $507b60b666784151$var$TD = $507b60b666784151$var$getWithCellProps('td');
const $507b60b666784151$export$1e4baea7053fc0e3 = $507b60b666784151$var$TD;

});
parcelRegister("9SvhO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff9d1b9f6349bb2d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lavtv = parcelRequire("lavtv");

var $2OSrK = parcelRequire("2OSrK");

var $2Ucf2 = parcelRequire("2Ucf2");

var $d0O1Z = parcelRequire("d0O1Z");

var $g7cYz = parcelRequire("g7cYz");

var $zLla5 = parcelRequire("zLla5");

var $8RTC7 = parcelRequire("8RTC7");
function $ff9d1b9f6349bb2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $ff9d1b9f6349bb2d$var$buttonStyles = /*#__PURE__*/ (0, $9dQre.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// Keep the sort button above header content nodes that the editor's native-anchor DnD
// styles give a z-index in live docs, which otherwise cover the button's clickable body.
const $ff9d1b9f6349bb2d$var$sortButtonElevatedStyles = {
    name: "1739oy8",
    styles: "z-index:1"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $ff9d1b9f6349bb2d$var$iconWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", (0, $8RTC7.StatusClassNames).DESC, "{transform:rotate(-180deg);}&.", (0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $ff9d1b9f6349bb2d$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $ff9d1b9f6349bb2d$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $2OSrK.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${(0, $8RTC7.StatusClassNames).SORTING_NOT_ALLOWED} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $2OSrK.SortOrder).ASC:
            return `${(0, $8RTC7.StatusClassNames).ASC} ${activeStatusClass}`;
        case (0, $2OSrK.SortOrder).DESC:
            return `${(0, $8RTC7.StatusClassNames).DESC} ${activeStatusClass}`;
        default:
            return `${(0, $8RTC7.StatusClassNames).NO_ORDER} ${activeStatusClass}`;
    }
};
const $ff9d1b9f6349bb2d$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $zLla5.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2OSrK.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2OSrK.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2OSrK.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $ff9d1b9f6349bb2d$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $g7cYz.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2OSrK.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2OSrK.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2OSrK.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $ff9d1b9f6349bb2d$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $2OSrK.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $ff9d1b9f6349bb2d$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $ff9d1b9f6349bb2d$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        delay: 0,
        content: content,
        position: "top",
        hasNewContentOnTriggerClick: true
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $ff9d1b9f6349bb2d$var$buttonStyles,
            (0, $5N1Y4.expValEquals)('confluence_live_doc_table_sort_bugfix', 'isEnabled', true) && $ff9d1b9f6349bb2d$var$sortButtonElevatedStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $5N1Y4.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $d0O1Z.NewSortingIcon), {
        sortOrdered: sortOrdered
    }) : /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ff9d1b9f6349bb2d$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ff9d1b9f6349bb2d$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $ff9d1b9f6349bb2d$var$iconStyles
        ]
    }))));
};
const $ff9d1b9f6349bb2d$var$_default_1 = (0, $fK3tS.default)($ff9d1b9f6349bb2d$var$SortingIcon);
var $ff9d1b9f6349bb2d$export$2e2bcd8739ae039 = $ff9d1b9f6349bb2d$var$_default_1;

});
parcelRegister("2Ucf2", function(module, exports) {
$parcel$export(module.exports, "SORTABLE_COLUMN_ICON_CLASSNAME", () => $6cd1243e25d24605$export$bd4f24d8b1e86b23);
const $6cd1243e25d24605$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

});

parcelRegister("d0O1Z", function(module, exports) {
$parcel$export(module.exports, "NewSortingIcon", () => $bfcb9449dedb7d6d$export$4be21af7f864512e);
/* NewSortingIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $a6DIL = parcelRequire("a6DIL");

var $4T1o1 = parcelRequire("4T1o1");

var $2OSrK = parcelRequire("2OSrK");
const $bfcb9449dedb7d6d$var$newIconWrapperStyles = {
    base: "_v5642l60 _1bsb7vkz _4t3i7vkz _1e0c1txw _1bah1h6o _4cvr1h6o _8hrz1qre",
    inactive: "_tzy415iw"
};
const $bfcb9449dedb7d6d$export$4be21af7f864512e = ({ sortOrdered: sortOrdered })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $bfcb9449dedb7d6d$var$newIconWrapperStyles.base,
            sortOrdered === (0, $2OSrK.SortOrder).NO_ORDER && $bfcb9449dedb7d6d$var$newIconWrapperStyles.inactive
        ]),
        children: sortOrdered === (0, $2OSrK.SortOrder).DESC ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6DIL))), {
            spacing: "none",
            label: ""
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4T1o1))), {
            spacing: "none",
            label: ""
        })
    });
};

});
parcelRegister("a6DIL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::982535952b0b997873182b9102c6defc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75b946ad512578ec$var$_react = $75b946ad512578ec$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $75b946ad512578ec$var$_iconNew = $75b946ad512578ec$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $75b946ad512578ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-ascending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75b946ad512578ec$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $75b946ad512578ec$var$_react.default.createElement($75b946ad512578ec$var$_iconNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$75b946ad512578ec$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $75b946ad512578ec$var$_default = module.exports.default = $75b946ad512578ec$var$SortAscendingIcon;

});

parcelRegister("4T1o1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07f197be0bf4c2b3f61c32ad2572b521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38ed5fc842c80001$var$_react = $38ed5fc842c80001$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $38ed5fc842c80001$var$_iconNew = $38ed5fc842c80001$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $38ed5fc842c80001$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-descending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38ed5fc842c80001$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $38ed5fc842c80001$var$_react.default.createElement($38ed5fc842c80001$var$_iconNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$38ed5fc842c80001$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $38ed5fc842c80001$var$_default = module.exports.default = $38ed5fc842c80001$var$SortDescendingIcon;

});


parcelRegister("g7cYz", function(module, exports) {
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $cf0ebb9b85126814$export$f142573f51a67577);

var $f0Pt4 = parcelRequire("f0Pt4");
const $cf0ebb9b85126814$export$f142573f51a67577 = (0, $f0Pt4.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});

parcelRegister("zLla5", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $2322479baf7303a8$export$458c50917513cd1a);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2322479baf7303a8$export$458c50917513cd1a = (0, $f0Pt4.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from A to Z (ascending order).'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from Z to A (descending order).'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'Label shown on a table column header sort button to remove any active sorting and restore the default column order.'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'Warning message shown in a table column header when sorting cannot be applied because the table contains merged cells.'
    }
});

});

parcelRegister("8RTC7", function(module, exports) {
$parcel$export(module.exports, "StatusClassNames", () => $a40adea1cde88967$export$c3618f310f725028);
var $a40adea1cde88967$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});

});



parcelRegister("aIzPh", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $39518a47cf275a2a$export$8c072780619cfc83);

var $enwus = parcelRequire("enwus");

var $gdUUy = parcelRequire("gdUUy");
class $39518a47cf275a2a$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        var _this$wrapper$parentE, _this$wrapper$parentE2;
        if (!this.wrapper) return;
        const scrollbarContainers = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelectorAll(`.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $gdUUy.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers === null || scrollbarContainers === void 0 ? void 0 : scrollbarContainers.item(scrollbarContainers.length - 1) : (_this$wrapper$parentE2 = this.wrapper.parentElement) === null || _this$wrapper$parentE2 === void 0 ? void 0 : _this$wrapper$parentE2.querySelector(`.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        var _this$wrapper, _this$wrapper2, _this$wrapper3;
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $gdUUy.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = (_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.parentElement) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.getElementsByClassName((0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        var _entry$rootBounds;
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        var _entry$rootBounds2;
        const sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});


parcelRegister("cUmkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $51c33f60089caecf$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $2OSrK = parcelRequire("2OSrK");

var $cvo9f = parcelRequire("cvo9f");
function $51c33f60089caecf$export$2e2bcd8739ae039({ allowColumnSorting: allowColumnSorting, children: children, index: index, innerRef: innerRef, isFirstRow: isFirstRow, isLastRow: isLastRow, isNumberColumnEnabled: isNumberColumnEnabled, onSorting: onSorting, tableOrderStatus: tableOrderStatus }) {
    const isHeaderRow = !index;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children);
    const cells = allowColumnSorting && isHeaderRow ? childrenArray.map((child, columnIndex)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, {
            columnIndex: columnIndex,
            onSorting: onSorting,
            sortOrdered: (tableOrderStatus === null || tableOrderStatus === void 0 ? void 0 : tableOrderStatus.columnIndex) === columnIndex ? tableOrderStatus.order : (0, $2OSrK.SortOrder).NO_ORDER,
            isHeaderRow: isHeaderRow
        });
    }) : childrenArray;
    return /*#__PURE__*/ (0, $dc70d.jsxs)("tr", {
        ref: innerRef,
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $dc70d.jsx)("td", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $cvo9f.RendererCssClassName).NUMBER_COLUMN,
                "data-reaches-left": true,
                "data-reaches-top": isFirstRow || undefined,
                "data-reaches-bottom": isLastRow || undefined,
                children: index
            }),
            cells
        ]
    });
}

});

parcelRegister("GdsT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9677014ff0a4cc89$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $9677014ff0a4cc89$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("8rYTB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("a8HPg").then(()=>parcelRequire('15CWk'));

});

parcelRegister("2KXt2", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("gVrk6"),
    $kOunM("a4mXk")
]).then(()=>parcelRequire('cJgOZ'));

});

parcelRegister("i17dO", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bMO4K").then(()=>parcelRequire('ejmQW'));

});

parcelRegister("jNMRy", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4UZTp").then(()=>parcelRequire('cYyuK'));

});

parcelRegister("gWLLu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hlfOR").then(()=>parcelRequire('kgPSh'));

});

parcelRegister("gSFCB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4ZTdh").then(()=>parcelRequire('k3Rsx'));

});

parcelRegister("20zDL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9VRIm").then(()=>parcelRequire('l46v3'));

});

parcelRegister("kMedY", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dW9yq").then(()=>parcelRequire('i8EFX'));

});

parcelRegister("j95CE", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kwMqK"),
    $kOunM("1tC9C")
]).then(()=>parcelRequire('OEcAP'));

});

parcelRegister("2kEW9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kwMqK"),
    $kOunM("jyNyQ")
]).then(()=>parcelRequire('iVGpu'));

});

parcelRegister("4KQzm", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("euwch"),
    $kOunM("lxev9"),
    $kOunM("2le3T"),
    $kOunM("0OslP")
]).then(()=>parcelRequire('3lc52'));

});

parcelRegister("cxeyx", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("euwch"),
    $kOunM("lxev9")
]).then(()=>parcelRequire('6uDUj'));

});

parcelRegister("8W1RO", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("euwch"),
    $kOunM("lxev9"),
    $kOunM("2le3T")
]).then(()=>parcelRequire('iZxaP'));

});

parcelRegister("53dCf", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cqzIS"),
    $kOunM("hyEGg"),
    $kOunM("eyRof"),
    $kOunM("jNSR9")
]).then(()=>parcelRequire('l64q0'));

});

parcelRegister("aXReO", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("f9fYb").then(()=>parcelRequire('3q229'));

});

parcelRegister("4jxhX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("5dbAT"),
    $kOunM("cqzIS"),
    $kOunM("hyEGg"),
    $kOunM("eyRof"),
    $kOunM("lKA9A")
]).then(()=>parcelRequire('gVz8X'));

});

parcelRegister("7H4vM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4a5iu").then(()=>parcelRequire('6NYVq'));

});

parcelRegister("4op42", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fiNXw"),
    $kOunM("guq4f")
]).then(()=>parcelRequire('6FS7o'));

});

parcelRegister("eCxcD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6h96L").then(()=>parcelRequire('5yTdT'));

});

parcelRegister("bTP86", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jr9tP").then(()=>parcelRequire('l171P'));

});

parcelRegister("iwa60", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8ytjc").then(()=>parcelRequire('jlBR7'));

});



parcelRegister("bVB7k", function(module, exports) {
$parcel$export(module.exports, "RendererFunctionalComponent", () => $64c0fe55c48dafed$export$c49fe2316038f3c2);
$parcel$export(module.exports, "Renderer", () => $64c0fe55c48dafed$export$88530751e3977073);
$parcel$export(module.exports, "RendererWithAnalytics", () => $64c0fe55c48dafed$export$af81ffb59b6ef0dd);
$parcel$export(module.exports, "default", () => $64c0fe55c48dafed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $7RHfd = parcelRequire("7RHfd");

var $auxFA = parcelRequire("auxFA");

var $1l5zG = parcelRequire("1l5zG");

var $3vqkd = parcelRequire("3vqkd");

var $g6Qq4 = parcelRequire("g6Qq4");

var $avVPS = parcelRequire("avVPS");

var $jxkn6 = parcelRequire("jxkn6");

var $6Vcje = parcelRequire("6Vcje");

var $awuFt = parcelRequire("awuFt");

var $2qHl7 = parcelRequire("2qHl7");

var $951G5 = parcelRequire("951G5");

var $jqEKs = parcelRequire("jqEKs");

var $g4e18 = parcelRequire("g4e18");

var $jPmHi = parcelRequire("jPmHi");

var $5zxDU = parcelRequire("5zxDU");

var $d8JFj = parcelRequire("d8JFj");

var $i8aUK = parcelRequire("i8aUK");

var $lrWkt = parcelRequire("lrWkt");

var $ahwoz = parcelRequire("ahwoz");

var $5oXqC = parcelRequire("5oXqC");

var $cHPol = parcelRequire("cHPol");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $kTBKs = parcelRequire("kTBKs");

var $dABkj = parcelRequire("dABkj");

var $doN9b = parcelRequire("doN9b");

var $gZpwM = parcelRequire("gZpwM");

var $6NUiJ = parcelRequire("6NUiJ");

var $3n5QS = parcelRequire("3n5QS");

var $9mxVO = parcelRequire("9mxVO");

var $asc4s = parcelRequire("asc4s");

var $dcV1E = parcelRequire("dcV1E");

var $03SYF = parcelRequire("03SYF");

var $3eeik = parcelRequire("3eeik");

var $6fLsU = parcelRequire("6fLsU");

var $5cXhe = parcelRequire("5cXhe");

var $4Iwar = parcelRequire("4Iwar");

var $f50k8 = parcelRequire("f50k8");

var $kbiy4 = parcelRequire("kbiy4");

var $dcneY = parcelRequire("dcneY");

var $icIt9 = parcelRequire("icIt9");

var $9ZAW5 = parcelRequire("9ZAW5");

var $8tgQv = parcelRequire("8tgQv");

var $lnNO5 = parcelRequire("lnNO5");

var $3WLJM = parcelRequire("3WLJM");

var $klVcb = parcelRequire("klVcb");

var $1EI4O = parcelRequire("1EI4O");

var $6GoEk = parcelRequire("6GoEk");

var $bPrs9 = parcelRequire("bPrs9");

var $6e8ph = parcelRequire("6e8ph");
function $64c0fe55c48dafed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64c0fe55c48dafed$export$47b2879ca9bbf67a = 2000;
const $64c0fe55c48dafed$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $64c0fe55c48dafed$var$TABLE_INFO_TIMEOUT = 10000;
const $64c0fe55c48dafed$var$RENDER_EVENT_SAMPLE_RATE = 0.1;
const $64c0fe55c48dafed$var$packageName = undefined;
const $64c0fe55c48dafed$var$packageVersion = undefined;
const $64c0fe55c48dafed$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $64c0fe55c48dafed$var$handleMouseTripleClickInTables = (event)=>{
    var _parentElement, _parentElement2;
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $64c0fe55c48dafed$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    var _props$eventHandlers;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $64c0fe55c48dafed$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!((_props$eventHandlers = props.eventHandlers) !== null && _props$eventHandlers !== void 0 && _props$eventHandlers.onUnhandledClick)) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $asc4s.findInTree)(targetElement, rendererWrapper, (0, $dcneY.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $64c0fe55c48dafed$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $bSJIT.useRef)(undefined);
    const providerFactory = (0, $bSJIT.useMemo)(()=>props.dataProviders || new (0, $5zxDU.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $9mxVO.useRendererContext)();
    const createRendererContext = (0, $bSJIT.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $2qHl7.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                nestedRendererType: // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType
            };
        }, [
        nestedRendererType
    ]);
    const fireAnalyticsEventOld = (0, $bSJIT.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $1l5zG.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $bSJIT.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $1l5zG.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $797yE.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $bSJIT.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            hideExtensionKeysWhilePending: props.hideExtensionKeysWhilePending,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $3WLJM.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            headingIdPrefix: props.headingIdPrefix,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            showHeadingNumbers: props.showHeadingNumbers,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            mentionNodeDataProvider: props.mentionNodeDataProvider,
            emojiProviderLookupOrder: props.emojiProviderLookupOrder,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $bPrs9.useMemoFromPropsDerivative)((serializerProps)=>{
        var _props$createSerializ;
        return ((_props$createSerializ = props.createSerializer) === null || _props$createSerializ === void 0 ? void 0 : _props$createSerializ.call(props, serializerProps)) ?? new (0, $doN9b.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $bSJIT.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $bSJIT.useMemo)(()=>(0, $7RHfd.default)(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $bSJIT.useMemo)(()=>(0, $jqEKs.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $bSJIT.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $951G5.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $bSJIT.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- anchor navigation uses document.getElementById for hash targets
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).VIEWED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $dABkj.PLATFORM).WEB,
                    mode: (0, $dABkj.MODE).RENDERER
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $bSJIT.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $auxFA.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $bSJIT.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            if (Math.random() < $64c0fe55c48dafed$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).STARTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $dABkj.PLATFORM).WEB,
                    sampleRate: $64c0fe55c48dafed$var$RENDER_EVENT_SAMPLE_RATE
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $951G5.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $ahwoz.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $lrWkt.getAnalyticsEventSeverity)(duration, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) ?? $64c0fe55c48dafed$export$47b2879ca9bbf67a, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) ?? $64c0fe55c48dafed$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.enabled) === false;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const distortedDuration = renderedMeasurementDistortedDurationMonitor.distortedDuration;
                    const ttfb = (0, $g4e18.getResponseEndTime)();
                    const nodes = (0, $icIt9.countNodes)(props.document);
                    // Always signal that the renderer has finished rendering, regardless of analytics
                    // sampling or TTR tracking config. This is a reliable, unsampled lifecycle hook
                    // (e.g. used to release a UFO load hold) and must not be coupled to the sampled
                    // `rendered` analytics event below, which only fires for a fraction of renders.
                    if (props.onRendered) props.onRendered({
                        duration: duration,
                        distortedDuration: distortedDuration,
                        nodes: nodes,
                        ttfb: ttfb
                    });
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $g6Qq4.ACTION).RENDERED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $dABkj.PLATFORM).WEB,
                                duration: duration,
                                distortedDuration: distortedDuration,
                                ttfb: ttfb,
                                nodes: nodes,
                                nestedRendererType: nestedRendererType,
                                severity: severity,
                                sampleRate: $64c0fe55c48dafed$var$RENDER_EVENT_SAMPLE_RATE
                            },
                            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                        };
                        if (Math.random() < $64c0fe55c48dafed$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent(event);
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    var _props$innerRef;
                    const renderer = (_props$innerRef = props.innerRef) === null || _props$innerRef === void 0 || (_props$innerRef = _props$innerRef.current) === null || _props$innerRef === void 0 ? void 0 : _props$innerRef.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $f50k8.getWidthInfoPayload)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        const payloadHeight = (0, $f50k8.getHeightInfoPayload)(renderer);
                        if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $64c0fe55c48dafed$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $bSJIT.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    const isCollapsibleHeadingsEnabled = props.allowCollapsibleHeadings === true && [
        'full-page',
        'full-width',
        'max'
    ].includes(props.appearance || '') && rendererContext.isTopLevelRenderer && (0, $3y2s4.isExperimentEnabled)('platform_editor_collapsible_headings');
    (0, $6fLsU.useScrollToBlock)(editorRef, props.document, props.scrollToBlock);
    const { allowNestedTables: allowNestedTables } = props;
    // Memoised so `renderDocument`'s validation memo can match by reference across re-renders.
    const validationOverrides = (0, $bSJIT.useMemo)(()=>{
        const schema = getSchema(props.schema, props.adfStage);
        return (0, $awuFt.isPanelNestingTableSupported)(schema) ? {
            allowNestedTables: allowNestedTables,
            allowTableInPanel: true
        } : {
            allowNestedTables: allowNestedTables
        };
    }, [
        allowNestedTables,
        getSchema,
        props.schema,
        props.adfStage
    ]);
    // Invoking `onComplete` during render lets consumers set state on other components mid-render,
    // so the stat is parked here and delivered once the rendered document has been committed.
    // No dependency array: `renderDocument` produces a new stat on every render, so the callback
    // must run after every commit to keep its historical once-per-render cadence.
    const pendingOnCompleteStatRef = (0, $bSJIT.useRef)(null);
    const { onComplete: onComplete } = props;
    (0, $bSJIT.useEffect)(()=>{
        const stat = pendingOnCompleteStatRef.current;
        if (stat === null || !onComplete) return;
        pendingOnCompleteStatRef.current = null;
        onComplete(stat);
    });
    try {
        var _props$media;
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $3n5QS.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $3WLJM.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, validationOverrides);
        if (props.onComplete) pendingOnCompleteStatRef.current = stat;
        const rendererOutput = /*#__PURE__*/ (0, $9dQre.jsx)((0, $9mxVO.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $dcV1E.ActiveHeaderIdProvider), {
            value: (0, $6NUiJ.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $kTBKs.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $4Iwar.Provider), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jPmHi.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $6NUiJ.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$64c0fe55c48dafed$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: (_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $kbiy4.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $3eeik.CollapsibleHeadingsProvider), {
            pmDocument: pmDoc,
            rendererRef: editorRef,
            isEnabled: isCollapsibleHeadingsEnabled
        }, result))))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $6GoEk.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $6NUiJ.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$64c0fe55c48dafed$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $d8JFj.default), null));
    }
};
const $64c0fe55c48dafed$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($64c0fe55c48dafed$export$c49fe2316038f3c2);
const $64c0fe55c48dafed$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($64c0fe55c48dafed$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lnNO5.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($64c0fe55c48dafed$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $64c0fe55c48dafed$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $03SYF.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $9mxVO.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $bSJIT.useContext)((0, $6e8ph.ValidationContext)) || {};
    return /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        allowNestedTables: allowNestedTables
    });
}
const $64c0fe55c48dafed$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $3vqkd.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $i8aUK.getAnalyticsAppearance)(props.appearance),
            packageName: $64c0fe55c48dafed$var$packageName,
            packageVersion: $64c0fe55c48dafed$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, $7RHfd.default)()
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $cHPol.WithCreateAnalyticsEvent), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $9ZAW5.ErrorBoundary), {
                component: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $6Vcje.IntlErrorBoundary), null, /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $64c0fe55c48dafed$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- telepointer span for collaborative presence
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $1EI4O.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(true);
    const { nestedRendererType: nestedRendererType } = (0, $9mxVO.useRendererContext)();
    (0, $bSJIT.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    var _mutation$addedNodes$, _mutation$removedNode;
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $1EI4O.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $1EI4O.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && ((_mutation$addedNodes$ = mutation.addedNodes[0]) === null || _mutation$addedNodes$ === void 0 ? void 0 : _mutation$addedNodes$.id) === (0, $1EI4O.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && ((_mutation$removedNode = mutation.removedNodes[0]) === null || _mutation$removedNode === void 0 ? void 0 : _mutation$removedNode.id) === (0, $1EI4O.TELEPOINTER_ID))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $1EI4O.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastElement === null || lastElement === void 0 || lastElement.appendChild(createTelepointer());
                            } else {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastChild === null || lastChild === void 0 || lastChild.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $9dQre.jsx)((0, $5oXqC.WidthProvider), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop -- legacy renderer wrapper appearance classes
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $avVPS.BaseTheme), {
        baseFontSize: (0, $8tgQv.getBaseFontSize)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $gZpwM.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $klVcb.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer) return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $64c0fe55c48dafed$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $64c0fe55c48dafed$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $64c0fe55c48dafed$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(null);
function $64c0fe55c48dafed$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($64c0fe55c48dafed$var$RootRendererContext);
    const actions = (0, $bSJIT.useContext)((0, $5cXhe.RendererContext));
    const rendererRef = (0, $bSJIT.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer.
    // Otherwise we are in the root renderer and set the doc to the current doc.
    const _doc = rootRendererContextValue ? rootRendererContextValue.doc : doc;
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    // Memoised so nested renderers don't re-render on every root renderer render
    // when the doc itself is unchanged.
    const rootRendererValue = (0, $bSJIT.useMemo)(()=>({
            doc: _doc
        }), [
        _doc
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$var$RootRendererContext.Provider, {
        value: rootRendererValue
    }, children);
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $64c0fe55c48dafed$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cXhe.RendererActionsContext), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $03SYF.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $9dQre.jsx)($64c0fe55c48dafed$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $64c0fe55c48dafed$export$2e2bcd8739ae039 = $64c0fe55c48dafed$var$RendererWithAnnotationSelection;

});
parcelRegister("6Vcje", function(module, exports) {
$parcel$export(module.exports, "IntlErrorBoundary", () => $07f87e2245e46dcf$export$7df0749115d18d19);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");
const $07f87e2245e46dcf$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $07f87e2245e46dcf$var$isMissingIntlProviderInAncestryError = (err)=>{
    var _err$toString;
    return err === null || err === void 0 || (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
class $07f87e2245e46dcf$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($07f87e2245e46dcf$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dTM5i.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("awuFt", function(module, exports) {
$parcel$export(module.exports, "isPanelNestingTableSupported", () => $2d01f14019076559$export$da873e3c90937d2a);

var $5N1Y4 = parcelRequire("5N1Y4");
const $2d01f14019076559$export$da873e3c90937d2a = (schema)=>{
    var _panel_c1$contentMatc;
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    const panelC1CanContainTable = ((_panel_c1$contentMatc = panel_c1.contentMatch.matchType(table)) === null || _panel_c1$contentMatc === void 0 ? void 0 : _panel_c1$contentMatc.validEnd) === true;
    return panelC1CanContainTable && (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};

});

parcelRegister("2qHl7", function(module, exports) {
$parcel$export(module.exports, "normalizeFeatureFlags", () => $1cc23541c5164662$export$f1485fc4974593c0);

var $3vF76 = parcelRequire("3vF76");

var $h7IJM = parcelRequire("h7IJM");

var $h16bx = parcelRequire("h16bx");
const $1cc23541c5164662$var$EMPTY = {};
function $1cc23541c5164662$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $1cc23541c5164662$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $1cc23541c5164662$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $1cc23541c5164662$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($1cc23541c5164662$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($3vF76)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $1cc23541c5164662$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($h7IJM)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($3vF76)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($1cc23541c5164662$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}

});
parcelRegister("3vF76", function(module, exports) {

var $kIbps = parcelRequire("kIbps");

var $9bWZ0 = parcelRequire("9bWZ0");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $28e428a5a621f262$var$camelCase = $9bWZ0(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $kIbps(word) : word);
});
module.exports = $28e428a5a621f262$var$camelCase;

});
parcelRegister("kIbps", function(module, exports) {

var $cObST = parcelRequire("cObST");

var $fbJ13 = parcelRequire("fbJ13");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $f140c46ee50f2d19$var$capitalize(string) {
    return $fbJ13($cObST(string).toLowerCase());
}
module.exports = $f140c46ee50f2d19$var$capitalize;

});
parcelRegister("fbJ13", function(module, exports) {

var $40UOg = parcelRequire("40UOg");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $b0eacd53848d1e15$var$upperFirst = $40UOg('toUpperCase');
module.exports = $b0eacd53848d1e15$var$upperFirst;

});
parcelRegister("40UOg", function(module, exports) {

var $aoOVs = parcelRequire("aoOVs");

var $6h4do = parcelRequire("6h4do");

var $1PjhA = parcelRequire("1PjhA");

var $cObST = parcelRequire("cObST");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $2ec33abaae71a10a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $cObST(string);
        var strSymbols = $6h4do(string) ? $1PjhA(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $aoOVs(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $2ec33abaae71a10a$var$createCaseFirst;

});
parcelRegister("aoOVs", function(module, exports) {

var $5M0WW = parcelRequire("5M0WW");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $7923a60e7e4136aa$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $5M0WW(array, start, end);
}
module.exports = $7923a60e7e4136aa$var$castSlice;

});

parcelRegister("6h4do", function(module, exports) {
/** Used to compose unicode character classes. */ var $491799a0c6559c0e$var$rsAstralRange = '\\ud800-\\udfff', $491799a0c6559c0e$var$rsComboMarksRange = '\\u0300-\\u036f', $491799a0c6559c0e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $491799a0c6559c0e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $491799a0c6559c0e$var$rsComboRange = $491799a0c6559c0e$var$rsComboMarksRange + $491799a0c6559c0e$var$reComboHalfMarksRange + $491799a0c6559c0e$var$rsComboSymbolsRange, $491799a0c6559c0e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $491799a0c6559c0e$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $491799a0c6559c0e$var$reHasUnicode = RegExp('[' + $491799a0c6559c0e$var$rsZWJ + $491799a0c6559c0e$var$rsAstralRange + $491799a0c6559c0e$var$rsComboRange + $491799a0c6559c0e$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $491799a0c6559c0e$var$hasUnicode(string) {
    return $491799a0c6559c0e$var$reHasUnicode.test(string);
}
module.exports = $491799a0c6559c0e$var$hasUnicode;

});

parcelRegister("1PjhA", function(module, exports) {

var $iK7vx = parcelRequire("iK7vx");

var $6h4do = parcelRequire("6h4do");

var $7IKfM = parcelRequire("7IKfM");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $154983008b9b059c$var$stringToArray(string) {
    return $6h4do(string) ? $7IKfM(string) : $iK7vx(string);
}
module.exports = $154983008b9b059c$var$stringToArray;

});
parcelRegister("iK7vx", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $da5258bf6e99f8e2$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $da5258bf6e99f8e2$var$asciiToArray;

});

parcelRegister("7IKfM", function(module, exports) {
/** Used to compose unicode character classes. */ var $59f08574cf37601a$var$rsAstralRange = '\\ud800-\\udfff', $59f08574cf37601a$var$rsComboMarksRange = '\\u0300-\\u036f', $59f08574cf37601a$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $59f08574cf37601a$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $59f08574cf37601a$var$rsComboRange = $59f08574cf37601a$var$rsComboMarksRange + $59f08574cf37601a$var$reComboHalfMarksRange + $59f08574cf37601a$var$rsComboSymbolsRange, $59f08574cf37601a$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $59f08574cf37601a$var$rsAstral = '[' + $59f08574cf37601a$var$rsAstralRange + ']', $59f08574cf37601a$var$rsCombo = '[' + $59f08574cf37601a$var$rsComboRange + ']', $59f08574cf37601a$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $59f08574cf37601a$var$rsModifier = '(?:' + $59f08574cf37601a$var$rsCombo + '|' + $59f08574cf37601a$var$rsFitz + ')', $59f08574cf37601a$var$rsNonAstral = '[^' + $59f08574cf37601a$var$rsAstralRange + ']', $59f08574cf37601a$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $59f08574cf37601a$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $59f08574cf37601a$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $59f08574cf37601a$var$reOptMod = $59f08574cf37601a$var$rsModifier + '?', $59f08574cf37601a$var$rsOptVar = '[' + $59f08574cf37601a$var$rsVarRange + ']?', $59f08574cf37601a$var$rsOptJoin = '(?:' + $59f08574cf37601a$var$rsZWJ + '(?:' + [
    $59f08574cf37601a$var$rsNonAstral,
    $59f08574cf37601a$var$rsRegional,
    $59f08574cf37601a$var$rsSurrPair
].join('|') + ')' + $59f08574cf37601a$var$rsOptVar + $59f08574cf37601a$var$reOptMod + ')*', $59f08574cf37601a$var$rsSeq = $59f08574cf37601a$var$rsOptVar + $59f08574cf37601a$var$reOptMod + $59f08574cf37601a$var$rsOptJoin, $59f08574cf37601a$var$rsSymbol = '(?:' + [
    $59f08574cf37601a$var$rsNonAstral + $59f08574cf37601a$var$rsCombo + '?',
    $59f08574cf37601a$var$rsCombo,
    $59f08574cf37601a$var$rsRegional,
    $59f08574cf37601a$var$rsSurrPair,
    $59f08574cf37601a$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $59f08574cf37601a$var$reUnicode = RegExp($59f08574cf37601a$var$rsFitz + '(?=' + $59f08574cf37601a$var$rsFitz + ')|' + $59f08574cf37601a$var$rsSymbol + $59f08574cf37601a$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $59f08574cf37601a$var$unicodeToArray(string) {
    return string.match($59f08574cf37601a$var$reUnicode) || [];
}
module.exports = $59f08574cf37601a$var$unicodeToArray;

});





parcelRegister("9bWZ0", function(module, exports) {

var $gPPlu = parcelRequire("gPPlu");

var $hSrXg = parcelRequire("hSrXg");

var $9hTeK = parcelRequire("9hTeK");
/** Used to compose unicode capture groups. */ var $6b12e4ef62270d95$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $6b12e4ef62270d95$var$reApos = RegExp($6b12e4ef62270d95$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $6b12e4ef62270d95$var$createCompounder(callback) {
    return function(string) {
        return $gPPlu($9hTeK($hSrXg(string).replace($6b12e4ef62270d95$var$reApos, '')), callback, '');
    };
}
module.exports = $6b12e4ef62270d95$var$createCompounder;

});
parcelRegister("gPPlu", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $c4193cf48bc5308b$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $c4193cf48bc5308b$var$arrayReduce;

});

parcelRegister("hSrXg", function(module, exports) {

var $lTOwP = parcelRequire("lTOwP");

var $cObST = parcelRequire("cObST");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $d03d2a0bf6a24a93$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $d03d2a0bf6a24a93$var$rsComboMarksRange = '\\u0300-\\u036f', $d03d2a0bf6a24a93$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $d03d2a0bf6a24a93$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $d03d2a0bf6a24a93$var$rsComboRange = $d03d2a0bf6a24a93$var$rsComboMarksRange + $d03d2a0bf6a24a93$var$reComboHalfMarksRange + $d03d2a0bf6a24a93$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $d03d2a0bf6a24a93$var$rsCombo = '[' + $d03d2a0bf6a24a93$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $d03d2a0bf6a24a93$var$reComboMark = RegExp($d03d2a0bf6a24a93$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $d03d2a0bf6a24a93$var$deburr(string) {
    string = $cObST(string);
    return string && string.replace($d03d2a0bf6a24a93$var$reLatin, $lTOwP).replace($d03d2a0bf6a24a93$var$reComboMark, '');
}
module.exports = $d03d2a0bf6a24a93$var$deburr;

});
parcelRegister("lTOwP", function(module, exports) {

var $fxa3w = parcelRequire("fxa3w");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $ff15edf43dd19db1$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $ff15edf43dd19db1$var$deburrLetter = $fxa3w($ff15edf43dd19db1$var$deburredLetters);
module.exports = $ff15edf43dd19db1$var$deburrLetter;

});
parcelRegister("fxa3w", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $b4f1bcf906257239$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $b4f1bcf906257239$var$basePropertyOf;

});



parcelRegister("9hTeK", function(module, exports) {

var $2a6aL = parcelRequire("2a6aL");

var $4pURB = parcelRequire("4pURB");

var $cObST = parcelRequire("cObST");

var $9S569 = parcelRequire("9S569");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $6c308c7a7b886d0d$var$words(string, pattern, guard) {
    string = $cObST(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $4pURB(string) ? $9S569(string) : $2a6aL(string);
    return string.match(pattern) || [];
}
module.exports = $6c308c7a7b886d0d$var$words;

});
parcelRegister("2a6aL", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $19314dae1ad9472c$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $19314dae1ad9472c$var$asciiWords(string) {
    return string.match($19314dae1ad9472c$var$reAsciiWord) || [];
}
module.exports = $19314dae1ad9472c$var$asciiWords;

});

parcelRegister("4pURB", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $33759b2562725f1a$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $33759b2562725f1a$var$hasUnicodeWord(string) {
    return $33759b2562725f1a$var$reHasUnicodeWord.test(string);
}
module.exports = $33759b2562725f1a$var$hasUnicodeWord;

});

parcelRegister("9S569", function(module, exports) {
/** Used to compose unicode character classes. */ var $72fd1c9ba4ae9bd4$var$rsAstralRange = '\\ud800-\\udfff', $72fd1c9ba4ae9bd4$var$rsComboMarksRange = '\\u0300-\\u036f', $72fd1c9ba4ae9bd4$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $72fd1c9ba4ae9bd4$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $72fd1c9ba4ae9bd4$var$rsComboRange = $72fd1c9ba4ae9bd4$var$rsComboMarksRange + $72fd1c9ba4ae9bd4$var$reComboHalfMarksRange + $72fd1c9ba4ae9bd4$var$rsComboSymbolsRange, $72fd1c9ba4ae9bd4$var$rsDingbatRange = '\\u2700-\\u27bf', $72fd1c9ba4ae9bd4$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $72fd1c9ba4ae9bd4$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $72fd1c9ba4ae9bd4$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $72fd1c9ba4ae9bd4$var$rsPunctuationRange = '\\u2000-\\u206f', $72fd1c9ba4ae9bd4$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $72fd1c9ba4ae9bd4$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $72fd1c9ba4ae9bd4$var$rsVarRange = '\\ufe0e\\ufe0f', $72fd1c9ba4ae9bd4$var$rsBreakRange = $72fd1c9ba4ae9bd4$var$rsMathOpRange + $72fd1c9ba4ae9bd4$var$rsNonCharRange + $72fd1c9ba4ae9bd4$var$rsPunctuationRange + $72fd1c9ba4ae9bd4$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $72fd1c9ba4ae9bd4$var$rsApos = "['\u2019]", $72fd1c9ba4ae9bd4$var$rsBreak = '[' + $72fd1c9ba4ae9bd4$var$rsBreakRange + ']', $72fd1c9ba4ae9bd4$var$rsCombo = '[' + $72fd1c9ba4ae9bd4$var$rsComboRange + ']', $72fd1c9ba4ae9bd4$var$rsDigits = '\\d+', $72fd1c9ba4ae9bd4$var$rsDingbat = '[' + $72fd1c9ba4ae9bd4$var$rsDingbatRange + ']', $72fd1c9ba4ae9bd4$var$rsLower = '[' + $72fd1c9ba4ae9bd4$var$rsLowerRange + ']', $72fd1c9ba4ae9bd4$var$rsMisc = '[^' + $72fd1c9ba4ae9bd4$var$rsAstralRange + $72fd1c9ba4ae9bd4$var$rsBreakRange + $72fd1c9ba4ae9bd4$var$rsDigits + $72fd1c9ba4ae9bd4$var$rsDingbatRange + $72fd1c9ba4ae9bd4$var$rsLowerRange + $72fd1c9ba4ae9bd4$var$rsUpperRange + ']', $72fd1c9ba4ae9bd4$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $72fd1c9ba4ae9bd4$var$rsModifier = '(?:' + $72fd1c9ba4ae9bd4$var$rsCombo + '|' + $72fd1c9ba4ae9bd4$var$rsFitz + ')', $72fd1c9ba4ae9bd4$var$rsNonAstral = '[^' + $72fd1c9ba4ae9bd4$var$rsAstralRange + ']', $72fd1c9ba4ae9bd4$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $72fd1c9ba4ae9bd4$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $72fd1c9ba4ae9bd4$var$rsUpper = '[' + $72fd1c9ba4ae9bd4$var$rsUpperRange + ']', $72fd1c9ba4ae9bd4$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $72fd1c9ba4ae9bd4$var$rsMiscLower = '(?:' + $72fd1c9ba4ae9bd4$var$rsLower + '|' + $72fd1c9ba4ae9bd4$var$rsMisc + ')', $72fd1c9ba4ae9bd4$var$rsMiscUpper = '(?:' + $72fd1c9ba4ae9bd4$var$rsUpper + '|' + $72fd1c9ba4ae9bd4$var$rsMisc + ')', $72fd1c9ba4ae9bd4$var$rsOptContrLower = '(?:' + $72fd1c9ba4ae9bd4$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $72fd1c9ba4ae9bd4$var$rsOptContrUpper = '(?:' + $72fd1c9ba4ae9bd4$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $72fd1c9ba4ae9bd4$var$reOptMod = $72fd1c9ba4ae9bd4$var$rsModifier + '?', $72fd1c9ba4ae9bd4$var$rsOptVar = '[' + $72fd1c9ba4ae9bd4$var$rsVarRange + ']?', $72fd1c9ba4ae9bd4$var$rsOptJoin = '(?:' + $72fd1c9ba4ae9bd4$var$rsZWJ + '(?:' + [
    $72fd1c9ba4ae9bd4$var$rsNonAstral,
    $72fd1c9ba4ae9bd4$var$rsRegional,
    $72fd1c9ba4ae9bd4$var$rsSurrPair
].join('|') + ')' + $72fd1c9ba4ae9bd4$var$rsOptVar + $72fd1c9ba4ae9bd4$var$reOptMod + ')*', $72fd1c9ba4ae9bd4$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $72fd1c9ba4ae9bd4$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $72fd1c9ba4ae9bd4$var$rsSeq = $72fd1c9ba4ae9bd4$var$rsOptVar + $72fd1c9ba4ae9bd4$var$reOptMod + $72fd1c9ba4ae9bd4$var$rsOptJoin, $72fd1c9ba4ae9bd4$var$rsEmoji = '(?:' + [
    $72fd1c9ba4ae9bd4$var$rsDingbat,
    $72fd1c9ba4ae9bd4$var$rsRegional,
    $72fd1c9ba4ae9bd4$var$rsSurrPair
].join('|') + ')' + $72fd1c9ba4ae9bd4$var$rsSeq;
/** Used to match complex or compound words. */ var $72fd1c9ba4ae9bd4$var$reUnicodeWord = RegExp([
    $72fd1c9ba4ae9bd4$var$rsUpper + '?' + $72fd1c9ba4ae9bd4$var$rsLower + '+' + $72fd1c9ba4ae9bd4$var$rsOptContrLower + '(?=' + [
        $72fd1c9ba4ae9bd4$var$rsBreak,
        $72fd1c9ba4ae9bd4$var$rsUpper,
        '$'
    ].join('|') + ')',
    $72fd1c9ba4ae9bd4$var$rsMiscUpper + '+' + $72fd1c9ba4ae9bd4$var$rsOptContrUpper + '(?=' + [
        $72fd1c9ba4ae9bd4$var$rsBreak,
        $72fd1c9ba4ae9bd4$var$rsUpper + $72fd1c9ba4ae9bd4$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $72fd1c9ba4ae9bd4$var$rsUpper + '?' + $72fd1c9ba4ae9bd4$var$rsMiscLower + '+' + $72fd1c9ba4ae9bd4$var$rsOptContrLower,
    $72fd1c9ba4ae9bd4$var$rsUpper + '+' + $72fd1c9ba4ae9bd4$var$rsOptContrUpper,
    $72fd1c9ba4ae9bd4$var$rsOrdUpper,
    $72fd1c9ba4ae9bd4$var$rsOrdLower,
    $72fd1c9ba4ae9bd4$var$rsDigits,
    $72fd1c9ba4ae9bd4$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $72fd1c9ba4ae9bd4$var$unicodeWords(string) {
    return string.match($72fd1c9ba4ae9bd4$var$reUnicodeWord) || [];
}
module.exports = $72fd1c9ba4ae9bd4$var$unicodeWords;

});




parcelRegister("h7IJM", function(module, exports) {

var $9bWZ0 = parcelRequire("9bWZ0");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $c775cb05bac090f2$var$kebabCase = $9bWZ0(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $c775cb05bac090f2$var$kebabCase;

});

parcelRegister("h16bx", function(module, exports) {
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $9e990549c0a72da4$export$6d018dd0f6cbebcb);
function $9e990549c0a72da4$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});


parcelRegister("951G5", function(module, exports) {
$parcel$export(module.exports, "startMeasure", () => $03b207d9f806d05d$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $03b207d9f806d05d$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $03b207d9f806d05d$export$6f766653554dac02);
$parcel$export(module.exports, "isMeasuring", () => $03b207d9f806d05d$export$b0a51f9f0047ea32);

var $jRBYX = parcelRequire("jRBYX");
const $03b207d9f806d05d$var$measureMap = new Map();
function $03b207d9f806d05d$export$b62aa2130c86b59b(measureName) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $03b207d9f806d05d$var$measureMap.set(measureName, performance.now());
}
function $03b207d9f806d05d$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $03b207d9f806d05d$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $03b207d9f806d05d$export$6f766653554dac02(measureName);
    }
}
function $03b207d9f806d05d$export$6f766653554dac02(measureName) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    $03b207d9f806d05d$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $03b207d9f806d05d$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return false;
    return $03b207d9f806d05d$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("jRBYX", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $6ddabb909706f539$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => (parcelRequire("ewIHf")).isPerformanceObserverAvailable);

var $ewIHf = parcelRequire("ewIHf");
let $6ddabb909706f539$var$hasRequiredPerformanceAPIs;
function $6ddabb909706f539$export$b5717a625dd4a3eb() {
    if ($6ddabb909706f539$var$hasRequiredPerformanceAPIs === undefined) $6ddabb909706f539$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $6ddabb909706f539$var$hasRequiredPerformanceAPIs;
}
function $6ddabb909706f539$export$4370ec0f52022f66() {
    return (0, $ewIHf.isPerformanceObserverAvailable)() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});
parcelRegister("ewIHf", function(module, exports) {
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $ef1a186be39c5252$export$48995af1e77d8643);
function $ef1a186be39c5252$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}

});



parcelRegister("jqEKs", function(module, exports) {
$parcel$export(module.exports, "getDistortedDurationMonitor", () => $0aaafe980cefbcb4$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $0aaafe980cefbcb4$export$267ed650a5d21ae6);

var $jRBYX = parcelRequire("jRBYX");
const $0aaafe980cefbcb4$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $0aaafe980cefbcb4$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $0aaafe980cefbcb4$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("g4e18", function(module, exports) {
$parcel$export(module.exports, "getResponseEndTime", () => $e7eb8bccb77fe401$export$92d097a1155bbe27);

var $jRBYX = parcelRequire("jRBYX");
function $e7eb8bccb77fe401$export$92d097a1155bbe27() {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("i8aUK", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => $5cbefa67adaf5191$export$be87849653b93e6b);

var $3vqkd = parcelRequire("3vqkd");
const $5cbefa67adaf5191$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $3vqkd.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $3vqkd.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $3vqkd.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $3vqkd.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $3vqkd.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $3vqkd.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};

});

parcelRegister("lrWkt", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $09ae9254ff68b08a$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $09ae9254ff68b08a$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "analyticsEventKey", () => $09ae9254ff68b08a$export$288273ee3e3b6132);
$parcel$export(module.exports, "getBreakpointKey", () => $09ae9254ff68b08a$export$afdcbbd112676ca8);
$parcel$export(module.exports, "getAnalyticsAppearance", () => (parcelRequire("i8aUK")).getAnalyticsAppearance);

var $i8aUK = parcelRequire("i8aUK");

var $96ZAq = parcelRequire("96ZAq");

var $6m8Z0 = parcelRequire("6m8Z0");
const $09ae9254ff68b08a$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${(0, $i8aUK.getAnalyticsAppearance)(editorAppearance)}` : '_unknown';
const $09ae9254ff68b08a$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return (0, $96ZAq.SEVERITY).DEGRADED;
    if (duration > degradedThreshold) return (0, $96ZAq.SEVERITY).BLOCKING;
    return (0, $96ZAq.SEVERITY).NORMAL;
};
const $09ae9254ff68b08a$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $09ae9254ff68b08a$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $09ae9254ff68b08a$var$TABLE_BREAKPOINT_KEYS = Object.keys($09ae9254ff68b08a$var$EDITOR_BREAKPOINT_WIDTH);
const $09ae9254ff68b08a$export$afdcbbd112676ca8 = (width)=>{
    return $09ae9254ff68b08a$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $09ae9254ff68b08a$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};

});
parcelRegister("96ZAq", function(module, exports) {
$parcel$export(module.exports, "SEVERITY", () => $57827b6c48a1e484$export$6a6bef12562cd865);
var $57827b6c48a1e484$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});

});

parcelRegister("6m8Z0", function(module, exports) {
$parcel$export(module.exports, "findInsertLocation", () => $99c26d3e6ac1e160$export$d770b562ead089d8);

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");
function $99c26d3e6ac1e160$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $cw0wu.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $2E7OD.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $gab48.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}

});


parcelRegister("ahwoz", function(module, exports) {
$parcel$export(module.exports, "shouldForceTracking", () => $9f41b15f7fdf879e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $9f41b15f7fdf879e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("cHPol", function(module, exports) {
$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $724a4c495f6fdbeb$export$9ac3d19711324187);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");
const $724a4c495f6fdbeb$export$9ac3d19711324187 = (0, $kIbto.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("doN9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4cdb33f27a17c90$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4WuwH = parcelRequire("4WuwH");

var $dfSJl = parcelRequire("dfSJl");

var $hMMPd = parcelRequire("hMMPd");

var $6yokq = parcelRequire("6yokq");

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $9Mjpq = parcelRequire("9Mjpq");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $3WSid = parcelRequire("3WSid");

var $asc4s = parcelRequire("asc4s");

var $katwF = parcelRequire("katwF");
var $eSupO = parcelRequire("eSupO");

var $jzwci = parcelRequire("jzwci");
parcelRequire("eRTtV");
var $37JJb = parcelRequire("37JJb");
var $eRTtV = parcelRequire("eRTtV");

var $4CCaA = parcelRequire("4CCaA");

var $3ugnJ = parcelRequire("3ugnJ");

var $3ZavE = parcelRequire("3ZavE");

var $iaQbQ = parcelRequire("iaQbQ");

var $6NUiJ = parcelRequire("6NUiJ");

var $kKq6j = parcelRequire("kKq6j");

var $8zTqm = parcelRequire("8zTqm");
function $d4cdb33f27a17c90$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kW8qW.MarkType) && prev && prev.type instanceof (0, $kW8qW.MarkType) && Array.isArray(prev.content) && (0, $6yokq.isSameMark)(prev, markOrNode)) prev.content = $d4cdb33f27a17c90$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $d4cdb33f27a17c90$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        this.headingNumbers = [];
        this.headingNumberIndex = 0;
        /**
   * The reason we have this extra array here is because we need to generate the same unique
   * heading id for 2 different nodes: headers and expands (check the implementation of
   * `getUniqueHeadingId` for more info).
   *
   * We will eventually need to refactor the current approach to generate unique ids
   * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
   */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowDownloadCodeBlock = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.textFastPath = false;
        this.paragraphPropsFastPath = false;
        this.allowAnnotations = false;
        this.standaloneBackgroundColorMarks = [];
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem') && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.parentIsIncompleteTask) === true;
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $eRTtV.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>{
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            const serialized = marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                // Extension annotations are sibling anchors inside the stable extension shell.
                // Wrapping the extension here would remount its iframe whenever marks change.
                if (node.type.name === 'extension' && mark.type.name === 'annotation' && this.allowAnnotations && (0, $gdUUy.fg)('cc_maui_annotations_on_extensions')) return content;
                return this.renderMark((0, $eSupO.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
            return (0, $3WSid.withExpandBodyBlock)(node, currentPath, index, serialized);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $katwF.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $katwF.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $jzwci.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        this.initStartPos = init.startPos || 1;
        this.startPos = init.startPos || 1;
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.headingIdPrefix = init.headingIdPrefix;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.showHeadingNumbers = init.showHeadingNumbers === true && (0, $3y2s4.isExperimentEnabled)('platform_editor_numbered_headings');
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowDownloadCodeBlock = init.allowDownloadCodeBlock;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.textFastPath = (0, $9Mjpq.expVal)('platform_renderer_text_paragraph_fast_path', 'isEnabled', false);
        this.paragraphPropsFastPath = (0, $9Mjpq.expVal)('platform_renderer_paragraph_props_fast_path', 'isEnabled', false);
        this.media = init.media;
        this.mentionNodeDataProvider = init.mentionNodeDataProvider;
        this.emojiProviderLookupOrder = init.emojiProviderLookupOrder;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.hideExtensionKeysWhilePending = init.hideExtensionKeysWhilePending;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
    resetState() {
        this.headingIds = [];
        this.headingNumbers = [];
        this.headingNumberIndex = 0;
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'paragraph':
                // Explicit paragraph overrides retain the full generic props contract.
                if (this.paragraphPropsFastPath && (!this.nodeComponents || !Object.prototype.hasOwnProperty.call(this.nodeComponents, 'paragraph'))) return this.getParagraphProps(node, path);
                return this.getProps(node, path);
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'mention':
                return this.getMentionProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
            case 'nestedExpand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            case 'panel_c1':
                if ((0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return this.getPanelProps(node);
                return this.getProps(node, path);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $37JJb.DocWithSelectAllTrap) : (0, $37JJb.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') {
            this.resetState();
            if (this.showHeadingNumbers) {
                const levels = [];
                fragment.descendants((node)=>{
                    if (node.type.name === 'heading') {
                        levels.push(Number(node.attrs.level));
                        return false;
                    }
                    return !node.isTextblock && !node.isLeaf;
                });
                this.headingNumbers = (0, $4WuwH.getHeadingNumbers)(levels);
            }
        }
        return this.renderNode(target, props, key, (0, $3WSid.mergeExpandBodyText)(this.getChildNodes(fragment, !(parentInfo !== null && parentInfo !== void 0 && parentInfo.path.length)).map((node, index)=>{
            if ((0, $eRTtV.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        })));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $iaQbQ.getStandaloneBackgroundColorMarks)(content));
        return $d4cdb33f27a17c90$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $eRTtV.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $eSupO.toReact)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4CCaA.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                plainTextFastPath: this.textFastPath,
                children: mark.text
            }, textKey);
        }
        return (0, $8zTqm.renderText)(mark.text, this.textHighlighter, mark.marks, startPos, this.textFastPath);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $dc70d.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $dc70d.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $3ugnJ.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $3ugnJ.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $3ugnJ.insideTable)(path, node.type.schema);
        const stickyHeaders = !isInsideOfTable ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $dfSJl.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $gdUUy.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $3ugnJ.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        var _this$media, _this$media2, _this$media3, _this$media4, _this$media5;
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>{
            var _n$type2;
            return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
        });
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $3ugnJ.getNestedUnderNodes)(path, [
            'bodiedSyncBlock'
        ]);
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableSyncMediaCard,
            mediaViewerExtensions: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.mediaViewerExtensions,
            fallbackMediaNameFetcher: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.fallbackMediaNameFetcher,
            onMediaRenderEvent: (_this$media5 = this.media) === null || _this$media5 === void 0 ? void 0 : _this$media5.onMediaRenderEvent,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        var _this$getExtensionHei;
        return {
            ...this.getProps(node, path),
            allowAnnotations: this.allowAnnotations,
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            extensionNode: node,
            extensionViewportSizes: this.extensionViewportSizes,
            hideExtensionKeysWhilePending: this.hideExtensionKeysWhilePending,
            nodeHeight: (_this$getExtensionHei = this.getExtensionHeight) === null || _this$getExtensionHei === void 0 ? void 0 : _this$getExtensionHei.call(this, node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            emojiProviderLookupOrder: (0, $gdUUy.fg)('platform_bitbucket_fix_shortname_and_ordering') ? this.emojiProviderLookupOrder : undefined,
            resourceConfig: this.emojiResourceConfig
        };
    }
    getMentionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            mentionNodeDataProvider: this.mentionNodeDataProvider
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $3ugnJ.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        var _this$media6, _this$media7;
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: (_this$media6 = this.media) === null || _this$media6 === void 0 ? void 0 : _this$media6.enableDownloadButton,
            ssr: (_this$media7 = this.media) === null || _this$media7 === void 0 ? void 0 : _this$media7.ssr
        };
    }
    getMediaInlineProps(node) {
        var _this$media8, _this$media9;
        return {
            ...this.getProps(node),
            ssr: (_this$media8 = this.media) === null || _this$media8 === void 0 ? void 0 : _this$media8.ssr,
            fallbackMediaNameFetcher: (_this$media9 = this.media) === null || _this$media9 === void 0 ? void 0 : _this$media9.fallbackMediaNameFetcher
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getParagraphProps(node, path = []) {
        const startPos = this.startPos + path.length;
        // Keep traversal metadata for serializer subclasses without allocating unused content getters.
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            plainTextFastPath: this.textFastPath,
            nodeType: node.type.name,
            marks: node.marks,
            dataAttributes: {
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            plainTextFastPath: this.textFastPath,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            getContent: (0, $3ZavE.createContentGetter)(node.content),
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowDownloadCodeBlock: this.allowDownloadCodeBlock,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $6NUiJ.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            headingId: this.getHeadingId(node, this.headingIds),
            headingNumber: this.showHeadingNumbers ? this.headingNumbers[this.headingNumberIndex++] : undefined,
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        // Expand is given the node so it can tell whether it opted into lazy body loading at all. The
        // text each block shows is attached to the block itself, by `withExpandBodyBlock`.
        if (!(0, $6NUiJ.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            node: node
        };
        const nestedHeaderIds = (0, $gab48.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            node: node
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $asc4s.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        const uniqueId = this.getUniqueHeadingId(nodeContent, headingIds);
        return this.headingIdPrefix ? `${this.headingIdPrefix}-${uniqueId}` : uniqueId;
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment, isTopLevel = true) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $eRTtV.mergeTextNodes)(children);
        if (this.shouldDisplayExtensionAsInline) (0, $kKq6j.markBlockAsInline)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            isTopLevel: isTopLevel,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $hMMPd.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $d4cdb33f27a17c90$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
}

});
parcelRegister("4WuwH", function(module, exports) {
$parcel$export(module.exports, "getHeadingNumbers", () => $2eec1b4bfb489402$export$752de4a5fff9f402);
const $2eec1b4bfb489402$var$MAX_HEADING_LEVEL = 6;
const $2eec1b4bfb489402$export$dce4ebcd2cd38df4 = 'data-heading-number';
const $2eec1b4bfb489402$export$752de4a5fff9f402 = (levels)=>{
    const counters = new Array($2eec1b4bfb489402$var$MAX_HEADING_LEVEL).fill(0);
    return levels.map((rawLevel)=>{
        const level = Math.min(Math.max(Math.trunc(rawLevel) || 1, 1), $2eec1b4bfb489402$var$MAX_HEADING_LEVEL);
        for(let index = 0; index < level - 1; index++)if (counters[index] === 0) counters[index] = 1;
        counters[level - 1] += 1;
        for(let index = level; index < $2eec1b4bfb489402$var$MAX_HEADING_LEVEL; index++)counters[index] = 0;
        return counters.slice(0, level).join('.');
    });
};

});

parcelRegister("dfSJl", function(module, exports) {
$parcel$export(module.exports, "getColumnWidths", () => $fd28a15e616d54c4$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $fd28a15e616d54c4$export$98951d3cdcfd364b);



function $fd28a15e616d54c4$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $fd28a15e616d54c4$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}

});

parcelRegister("hMMPd", function(module, exports) {
$parcel$export(module.exports, "getMarksByOrder", () => $dfad340fe3d7b8ec$export$99a33ed044c278ae);
$parcel$export(module.exports, "getValidNode", () => $dfad340fe3d7b8ec$export$81b20b6c83a56bd);

var $9qYsj = parcelRequire("9qYsj");

var $7nI18 = parcelRequire("7nI18");

var $gAe8g = parcelRequire("gAe8g");

var $auxFA = parcelRequire("auxFA");

var $9RSBE = parcelRequire("9RSBE");

var $gdUUy = parcelRequire("gdUUy");

var $l922z = parcelRequire("l922z");

var $3W38s = parcelRequire("3W38s");


const $dfad340fe3d7b8ec$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>(0, $3W38s.markOrder).indexOf(a.type.name) - (0, $3W38s.markOrder).indexOf(b.type.name));
};
const $dfad340fe3d7b8ec$export$fb80336a7e408cb3 = (doc, schema = (0, $auxFA.defaultSchema), adfStage = 'final')=>{
    const node = $dfad340fe3d7b8ec$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $dfad340fe3d7b8ec$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $dfad340fe3d7b8ec$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $9qYsj.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $dfad340fe3d7b8ec$export$fafd4f799ee68da0 = (content, schema = (0, $auxFA.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$dfad340fe3d7b8ec$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $dfad340fe3d7b8ec$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $dfad340fe3d7b8ec$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $dfad340fe3d7b8ec$var$ANCHOR_LINK = /^#/;
const $dfad340fe3d7b8ec$var$flattenUnknownBlockTree = (node, schema = (0, $auxFA.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($dfad340fe3d7b8ec$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$dfad340fe3d7b8ec$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $dfad340fe3d7b8ec$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $7nI18.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $dfad340fe3d7b8ec$var$flattenUnknownBlockTree(node)
    };
};
const $dfad340fe3d7b8ec$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $dfad340fe3d7b8ec$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $dfad340fe3d7b8ec$export$81b20b6c83a56bd = (originalNode, schema = (0, $auxFA.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $dfad340fe3d7b8ec$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $dfad340fe3d7b8ec$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $7nI18.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $7nI18.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $7nI18.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $7nI18.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $7nI18.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $7nI18.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $dfad340fe3d7b8ec$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $dfad340fe3d7b8ec$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $dfad340fe3d7b8ec$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                let localId;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                    localId = attrs.localId;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: '',
                            ...localId ? {
                                localId: localId
                            } : {}
                        },
                        ...(0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $dfad340fe3d7b8ec$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $dfad340fe3d7b8ec$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $gAe8g.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9RSBE.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9RSBE.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9RSBE.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9RSBE.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9RSBE.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $9RSBE.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $dfad340fe3d7b8ec$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $9RSBE.generateUuid)()
                },
                marks: marks
            };
            return $dfad340fe3d7b8ec$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $9RSBE.generateUuid)()
                },
                marks: marks,
                content: content
            };
            return $dfad340fe3d7b8ec$export$b9908ef75cad1e0e(node);
    }
    return $dfad340fe3d7b8ec$export$b9908ef75cad1e0e(node);
};
const $dfad340fe3d7b8ec$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$dfad340fe3d7b8ec$var$RELATIVE_LINK.test(linkHref) && !$dfad340fe3d7b8ec$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $7nI18.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ((0, $l922z.isSubSupType)(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $dfad340fe3d7b8ec$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $dfad340fe3d7b8ec$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("9qYsj", function(module, exports) {
$parcel$export(module.exports, "inlineNodes", () => $324b8bbf8a707128$export$b1f729c6af6f2a6e);
// eslint-disable-next-line import/no-namespace

var $aqR9K = parcelRequire("aqR9K");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $324b8bbf8a707128$var$typedNodes = $aqR9K;
const $324b8bbf8a707128$export$b1f729c6af6f2a6e = new Set(Object.keys($324b8bbf8a707128$var$typedNodes).filter((key)=>$324b8bbf8a707128$var$typedNodes[key] && $324b8bbf8a707128$var$typedNodes[key].group === 'inline'));

});
parcelRegister("aqR9K", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("8xR7M")).expandWithNestedExpand);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => (parcelRequire("8xR7M")).expandWithNestedExpandLocalId);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("8xR7M")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("eynRz")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("f7JVa")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("he3wV")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("bNELO")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("1dTNM")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("1dTNM")).extendedBlockquote);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("1dTNM")).extendedBlockquoteWithLocalId);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("cm5bx")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("cm5bx")).bulletListSelector);
$parcel$export(module.exports, "bulletListWithLocalId", () => (parcelRequire("cm5bx")).bulletListWithLocalId);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("9nikD")).codeBlock);
$parcel$export(module.exports, "codeBlockWithLocalId", () => (parcelRequire("9nikD")).codeBlockWithLocalId);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("9nikD")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("l4kwz")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("eqk7K")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("et9pQ")).rule);
$parcel$export(module.exports, "ruleWithLocalId", () => (parcelRequire("et9pQ")).ruleWithLocalId);
$parcel$export(module.exports, "ruleRootOnlyStage0", () => (parcelRequire("et9pQ")).ruleRootOnlyStage0);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("drur6")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("drur6")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithLocalId", () => (parcelRequire("drur6")).orderedListWithLocalId);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("drur6")).orderedListWithOrder);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("drur6")).orderedListWithOrderAndLocalId);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("fhSQQ")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("cf5lB")).emoji);
$parcel$export(module.exports, "emojiWithLocalId", () => (parcelRequire("cf5lB")).emojiWithLocalId);
$parcel$export(module.exports, "image", () => (parcelRequire("fUHL4")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("8nTzm")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("8nTzm")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("co6dq")).listItem);
$parcel$export(module.exports, "listItemWithLocalId", () => (parcelRequire("co6dq")).listItemWithLocalId);
$parcel$export(module.exports, "extendedPanelC1RootOnlyStage0", () => (parcelRequire("qCqw4")).extendedPanelC1RootOnlyStage0);
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => (parcelRequire("2VV1e")).extendedPanelC1WithLocalId);
$parcel$export(module.exports, "extendedPanelC1", () => (parcelRequire("2hMtT")).extendedPanelC1);
$parcel$export(module.exports, "extendedPanelRootOnlyStage0", () => (parcelRequire("fpk0y")).extendedPanelRootOnlyStage0);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => (parcelRequire("pScEb")).extendedPanelWithLocalId);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("7JT5k")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("gAe8g")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("eCc5B")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("i6pjC")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5wdoq")).caption);
$parcel$export(module.exports, "captionWithLocalId", () => (parcelRequire("5wdoq")).captionWithLocalId);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("itjXv")).copyPrivateAttributes);
$parcel$export(module.exports, "media", () => (parcelRequire("35RYb")).media);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("1KOd3")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("jiA7W")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("hHCeP")).mediaInline);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("19APL")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("gW1mO")).mediaSingle);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("gW1mO")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => (parcelRequire("gW1mO")).mediaSingleFullWithLocalId);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("gW1mO")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("gW1mO")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("6w3E6")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("c8L22")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("c8L22")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("c8L22")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("c8L22")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("c8L22")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableCellStage0", () => (parcelRequire("c8L22")).tableCellStage0);
$parcel$export(module.exports, "tableHeaderStage0", () => (parcelRequire("c8L22")).tableHeaderStage0);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => (parcelRequire("c8L22")).tableCellWithNestedTableStage0);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => (parcelRequire("c8L22")).tableHeaderWithNestedTableStage0);
$parcel$export(module.exports, "tableRowWithLocalId", () => (parcelRequire("c8L22")).tableRowWithLocalId);
$parcel$export(module.exports, "tableCellWithLocalId", () => (parcelRequire("c8L22")).tableCellWithLocalId);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => (parcelRequire("c8L22")).tableHeaderWithLocalId);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("c8L22")).tableRowWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("c8L22")).tableCellWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("c8L22")).tableHeaderWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("c8L22")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("c8L22")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("c8L22")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("c8L22")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("c8L22")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("c8L22")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("c8L22")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("c8L22")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("c8L22")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundColorPaletteNew", () => (parcelRequire("c8L22")).tableBackgroundColorPaletteNew);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("c8L22")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("c8L22")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("c8L22")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("c8L22")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("c8L22")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("c8L22")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("c8L22")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("c8L22")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("c8L22")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("24Njj")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("24Njj")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("imC3g")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("8olal")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("8olal")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("ftOXF")).taskItem);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("ftOXF")).blockTaskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("mp0z0")).date);
$parcel$export(module.exports, "dateWithLocalId", () => (parcelRequire("mp0z0")).dateWithLocalId);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("fAXpk")).placeholder);
$parcel$export(module.exports, "placeholderWithLocalId", () => (parcelRequire("fAXpk")).placeholderWithLocalId);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5Z1us")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => (parcelRequire("5Z1us")).layoutSectionWithLocalId);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("5Z1us")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("5Z1us")).layoutSectionWithSingleColumnLocalId);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("e4jxG")).layoutColumn);
$parcel$export(module.exports, "layoutColumnStage0", () => (parcelRequire("e4jxG")).layoutColumnStage0);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => (parcelRequire("e4jxG")).layoutColumnWithLocalId);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("4d4Lm")).inlineCard);
$parcel$export(module.exports, "inlineCardWithLocalId", () => (parcelRequire("4d4Lm")).inlineCardWithLocalId);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("k0msq")).blockCard);
$parcel$export(module.exports, "blockCardWithLocalId", () => (parcelRequire("k0msq")).blockCardWithLocalId);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d5USw")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("bkrsJ")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("4d8Oe")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5UXYb")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => (parcelRequire("5UXYb")).nestedExpandWithLocalId);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("8NN4H")).embedCard);
$parcel$export(module.exports, "embedCardWithLocalId", () => (parcelRequire("8NN4H")).embedCardWithLocalId);
$parcel$export(module.exports, "extension", () => (parcelRequire("jvwoj")).extension);
$parcel$export(module.exports, "extensionRootOnlyStage0", () => (parcelRequire("jvwoj")).extensionRootOnlyStage0);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("imJfX")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("2aCeP")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtensionRootOnlyStage0", () => (parcelRequire("2aCeP")).bodiedExtensionRootOnlyStage0);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("1xC7B")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("1xC7B")).multiBodiedExtension);
$parcel$export(module.exports, "multiBodiedExtensionRootOnlyStage0", () => (parcelRequire("1xC7B")).multiBodiedExtensionRootOnlyStage0);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("5vK1d")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("3kxb2")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.

var $8xR7M = parcelRequire("8xR7M");

var $eynRz = parcelRequire("eynRz");

var $f7JVa = parcelRequire("f7JVa");

var $he3wV = parcelRequire("he3wV");

var $bNELO = parcelRequire("bNELO");

var $1dTNM = parcelRequire("1dTNM");

var $cm5bx = parcelRequire("cm5bx");

var $9nikD = parcelRequire("9nikD");

var $l4kwz = parcelRequire("l4kwz");

var $eqk7K = parcelRequire("eqk7K");

var $et9pQ = parcelRequire("et9pQ");

var $drur6 = parcelRequire("drur6");

var $fhSQQ = parcelRequire("fhSQQ");

var $cf5lB = parcelRequire("cf5lB");

var $fUHL4 = parcelRequire("fUHL4");

var $8nTzm = parcelRequire("8nTzm");

var $co6dq = parcelRequire("co6dq");

var $qCqw4 = parcelRequire("qCqw4");

var $2VV1e = parcelRequire("2VV1e");

var $2hMtT = parcelRequire("2hMtT");

var $fpk0y = parcelRequire("fpk0y");

var $pScEb = parcelRequire("pScEb");

var $7JT5k = parcelRequire("7JT5k");

var $gAe8g = parcelRequire("gAe8g");

var $eCc5B = parcelRequire("eCc5B");

var $i6pjC = parcelRequire("i6pjC");

var $5wdoq = parcelRequire("5wdoq");

var $itjXv = parcelRequire("itjXv");

var $35RYb = parcelRequire("35RYb");

var $1KOd3 = parcelRequire("1KOd3");

var $jiA7W = parcelRequire("jiA7W");

var $hHCeP = parcelRequire("hHCeP");

var $19APL = parcelRequire("19APL");

var $gW1mO = parcelRequire("gW1mO");

var $6w3E6 = parcelRequire("6w3E6");

var $c8L22 = parcelRequire("c8L22");

var $24Njj = parcelRequire("24Njj");

var $imC3g = parcelRequire("imC3g");

var $8olal = parcelRequire("8olal");

var $ftOXF = parcelRequire("ftOXF");

var $mp0z0 = parcelRequire("mp0z0");

var $fAXpk = parcelRequire("fAXpk");

var $5Z1us = parcelRequire("5Z1us");

var $e4jxG = parcelRequire("e4jxG");

var $4d4Lm = parcelRequire("4d4Lm");

var $k0msq = parcelRequire("k0msq");

var $d5USw = parcelRequire("d5USw");

var $bkrsJ = parcelRequire("bkrsJ");

var $4d8Oe = parcelRequire("4d8Oe");

var $5UXYb = parcelRequire("5UXYb");

var $8NN4H = parcelRequire("8NN4H");

var $jvwoj = parcelRequire("jvwoj");

var $imJfX = parcelRequire("imJfX");

var $2aCeP = parcelRequire("2aCeP");

var $1xC7B = parcelRequire("1xC7B");

var $5vK1d = parcelRequire("5vK1d");

var $3kxb2 = parcelRequire("3kxb2");

});


parcelRegister("l922z", function(module, exports) {
$parcel$export(module.exports, "isSubSupType", () => $987665fec21abbb5$export$30f8aa4cc1f8c1cb);
const $987665fec21abbb5$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};

});

parcelRegister("3W38s", function(module, exports) {
$parcel$export(module.exports, "markOrder", () => $3591b8b92f201ee4$export$62d5811a2955c1d8);
/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/ETEMP/pages/11174043/Atlassian+Document+Format+-+Internal+documentation#Rank
 */ const $3591b8b92f201ee4$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];

});


parcelRegister("6yokq", function(module, exports) {
$parcel$export(module.exports, "isSameMark", () => $e92961c5cb7a7744$export$b1304404bdc42b7a);
const $e92961c5cb7a7744$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};

});

parcelRegister("3WSid", function(module, exports) {
$parcel$export(module.exports, "ExpandBodyProvider", () => $e35178dcecf67492$export$57ea044a2befcf45);
$parcel$export(module.exports, "useExpandBody", () => $e35178dcecf67492$export$40dd974b96ebf5ba);
$parcel$export(module.exports, "withExpandBodyBlock", () => $e35178dcecf67492$export$b4e33946e63ad887);
$parcel$export(module.exports, "mergeExpandBodyText", () => $e35178dcecf67492$export$3099c7a6e9a4b682);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $djV4H = parcelRequire("djV4H");
const $e35178dcecf67492$var$ExpandBodyContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $e35178dcecf67492$export$57ea044a2befcf45 = $e35178dcecf67492$var$ExpandBodyContext.Provider;
const $e35178dcecf67492$export$40dd974b96ebf5ba = ()=>(0, $bSJIT.useContext)($e35178dcecf67492$var$ExpandBodyContext);
const $e35178dcecf67492$export$8b49603a5a5ab281 = ({ children: children, searchText: searchText })=>{
    const body = $e35178dcecf67492$export$40dd974b96ebf5ba();
    if (searchText === undefined || body === null || body.revealed) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children
    });
    return searchText;
};
const $e35178dcecf67492$export$b4e33946e63ad887 = (node, ancestors, index, serialized)=>{
    const parent = ancestors[ancestors.length - 1];
    if (!parent || !(0, $djV4H.isExpandNode)(parent)) return serialized;
    // `serialized` is only null for a node the renderer has no component for, which a table is not.
    // Such a table falls through to the paths below, which do not reach into it.
    if (node.type.name === 'table' && serialized !== null) {
        const parts = (0, $djV4H.getTableStandInParts)(node);
        // With no row to keep, one string can stand in for the whole table — the table then renders
        // nothing at all, and its text joins with the blocks either side of it.
        return parts.every((part)=>typeof part === 'string') ? /*#__PURE__*/ (0, $dc70d.jsx)($e35178dcecf67492$export$8b49603a5a5ab281, {
            searchText: parts.join(''),
            children: serialized
        }, `expand-body-block-${index}`) : /*#__PURE__*/ (0, $dc70d.jsx)($e35178dcecf67492$export$f62b093160ec006b, {
            node: node,
            children: serialized
        }, `expand-body-table-${index}`);
    }
    if ((0, $djV4H.holdsRevealableContent)(node)) return serialized;
    const searchText = (0, $djV4H.getBlockSearchText)(node);
    if (searchText === undefined) return serialized;
    return /*#__PURE__*/ (0, $dc70d.jsx)($e35178dcecf67492$export$8b49603a5a5ab281, {
        searchText: searchText,
        children: serialized
    }, `expand-body-block-${index}`);
};
const $e35178dcecf67492$var$isRow = (child)=>/*#__PURE__*/ (0, $bSJIT.isValidElement)(child) && child.props.nodeType === 'tableRow';
/**
 * The rows inside the serialized table, wherever they sit.
 *
 * What the serializer hands over is not reliably the element whose children are the rows. Marks are
 * folded around the node afterwards, and a product's own serializer may wrap the rows themselves —
 * Confluence's progressive renderer wraps every row but the first. Assuming either a depth or a set
 * of direct children means any wrapper added later silently costs the saving, so the rows are found
 * instead by the `nodeType` the serializer puts on every node.
 *
 * Descent stops at each row: a nested table's rows sit inside a row of this one, and would
 * otherwise be counted among them.
 *
 * The count is only a consistency check. `getTableStandInParts` indexes the rows by position, so a
 * partial match cannot be lined up and the table has to render instead.
 */ const $e35178dcecf67492$var$rowsOf = (serialized, rowCount)=>{
    const rows = [];
    const collect = (node)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(node).forEach((child)=>{
            if (!/*#__PURE__*/ (0, $bSJIT.isValidElement)(child)) return;
            if ($e35178dcecf67492$var$isRow(child)) {
                rows.push(child);
                return;
            }
            collect(child.props.children);
        });
    };
    collect(serialized);
    return rows.length === rowCount ? rows : undefined;
};
const $e35178dcecf67492$export$f62b093160ec006b = ({ children: children, node: node })=>{
    const body = $e35178dcecf67492$export$40dd974b96ebf5ba();
    if (body === null || body.revealed) return children;
    const rows = $e35178dcecf67492$var$rowsOf(children, node.childCount);
    if (!rows) {
        // eslint-disable-next-line no-console
        console.info('@atlaskit/renderer: the rows of a table in a collapsed expand were not found, so the table renders in full rather than showing their text');
        return children;
    }
    return (0, $djV4H.getTableStandInParts)(node).map((part)=>typeof part === 'string' ? part : // A row cannot stand in the page on its own — `<tr>` is only valid inside a table — so it
        // keeps the least table around it that makes the markup valid. None of this is laid out: the
        // body is hidden until the reader or find opens the expand, and opening it renders the real
        // table in place of all this.
        /*#__PURE__*/ (0, $dc70d.jsx)("table", {
            children: /*#__PURE__*/ (0, $dc70d.jsx)("tbody", {
                children: rows[part]
            })
        }, `expand-body-row-${part}`));
};
const $e35178dcecf67492$var$searchTextOf = (child)=>/*#__PURE__*/ (0, $bSJIT.isValidElement)(child) && child.type === $e35178dcecf67492$export$8b49603a5a5ab281 ? child.props.searchText : undefined;
const $e35178dcecf67492$export$3099c7a6e9a4b682 = (children)=>{
    // Called for every fragment in the document, and only an expand's body has anything to merge, so
    // leave the array alone unless two neighbours are actually showing text.
    const hasRun = children.some((child, index)=>index > 0 && $e35178dcecf67492$var$searchTextOf(child) !== undefined && $e35178dcecf67492$var$searchTextOf(children[index - 1]) !== undefined);
    if (!hasRun) return children;
    const merged = [];
    let run = [];
    const endRun = ()=>{
        if (run.length === 0) return;
        if (run.length === 1) merged.push(run[0]);
        else {
            const text = run.map($e35178dcecf67492$var$searchTextOf).filter(Boolean).join((0, $djV4H.BLOCK_SEPARATOR));
            // The blocks themselves, not the wrappers around them: nesting the wrappers would show
            // each block's text again inside the joined run.
            const blocks = run.map((child)=>child.props.children);
            merged.push(/*#__PURE__*/ (0, $dc70d.jsx)($e35178dcecf67492$export$8b49603a5a5ab281, {
                searchText: text,
                children: blocks
            }, run[0].key ?? undefined));
        }
        run = [];
    };
    children.forEach((child)=>{
        if ($e35178dcecf67492$var$searchTextOf(child) === undefined) {
            endRun();
            merged.push(child);
            return;
        }
        run.push(child);
    });
    endRun();
    return merged;
};

});
parcelRegister("djV4H", function(module, exports) {
$parcel$export(module.exports, "BLOCK_SEPARATOR", () => $1ac6489ce0acdb88$export$107fd3c009356079);
$parcel$export(module.exports, "isExpandNode", () => $1ac6489ce0acdb88$export$8e4b11a2e791d70a);
$parcel$export(module.exports, "holdsRevealableContent", () => $1ac6489ce0acdb88$export$190cd2ff72900fe7);
$parcel$export(module.exports, "getBlockSearchText", () => $1ac6489ce0acdb88$export$2228423caf47f74);
$parcel$export(module.exports, "getTableStandInParts", () => $1ac6489ce0acdb88$export$e860c2c8391d30bf);

var $gab48 = parcelRequire("gab48");
const $1ac6489ce0acdb88$export$107fd3c009356079 = ' ';
const $1ac6489ce0acdb88$var$asText = (value)=>typeof value === 'string' ? value : '';
const $1ac6489ce0acdb88$var$nestedContentOf = (attrs)=>{
    var _attrs$parameters;
    return attrs === null || attrs === void 0 || (_attrs$parameters = attrs.parameters) === null || _attrs$parameters === void 0 ? void 0 : _attrs$parameters.nestedContent;
};
const $1ac6489ce0acdb88$export$8e4b11a2e791d70a = (node)=>node.type.name === 'expand' || node.type.name === 'nestedExpand';
/**
 * Reads the text out of raw ADF JSON.
 *
 * Some extensions keep a whole ADF subtree in `attrs.parameters.nestedContent` rather than in their
 * node content. Confluence does this when the authored nesting is deeper than the schema allows —
 * an expand more than two collapsible layers deep, for example. To ProseMirror the extension is a
 * leaf, so walking the node tree never sees that subtree, even though a nested renderer puts it on
 * the page. Recurses, because stashed content often stashes more content of its own.
 */ const $1ac6489ce0acdb88$var$adfEntityText = (entity)=>{
    var _entity$content;
    if (!entity) return '';
    const parts = [];
    if (entity.type === 'text') parts.push($1ac6489ce0acdb88$var$asText(entity.text));
    const nestedContent = $1ac6489ce0acdb88$var$nestedContentOf(entity.attrs);
    if (nestedContent) // Prefer the real subtree over `attrs.text`, which is only a placeholder label for it.
    parts.push($1ac6489ce0acdb88$var$adfEntityText(nestedContent));
    else {
        var _entity$attrs;
        parts.push($1ac6489ce0acdb88$var$asText((_entity$attrs = entity.attrs) === null || _entity$attrs === void 0 ? void 0 : _entity$attrs.text));
    }
    (_entity$content = entity.content) === null || _entity$content === void 0 || _entity$content.forEach((child)=>parts.push($1ac6489ce0acdb88$var$adfEntityText(child)));
    return parts.filter(Boolean).join($1ac6489ce0acdb88$export$107fd3c009356079);
};
/**
 * `textBetween` skips every leaf node unless its spec declares `leafText`, and no ADF node
 * does — so mentions, emoji, dates and statuses would all be lost. They keep their visible
 * text in attrs, so read it from there.
 */ const $1ac6489ce0acdb88$var$leafText = (leaf)=>{
    var _leaf$attrs;
    const nestedContent = $1ac6489ce0acdb88$var$nestedContentOf(leaf.attrs);
    if (nestedContent) return $1ac6489ce0acdb88$var$adfEntityText(nestedContent);
    return $1ac6489ce0acdb88$var$asText((_leaf$attrs = leaf.attrs) === null || _leaf$attrs === void 0 ? void 0 : _leaf$attrs.text);
};
const $1ac6489ce0acdb88$var$isRevealable = (node)=>$1ac6489ce0acdb88$export$8e4b11a2e791d70a(node) || Boolean($1ac6489ce0acdb88$var$nestedContentOf(node.attrs));
const $1ac6489ce0acdb88$var$revealableCache = new WeakMap();
const $1ac6489ce0acdb88$export$190cd2ff72900fe7 = (node)=>{
    const cached = $1ac6489ce0acdb88$var$revealableCache.get(node);
    if (cached !== undefined) return cached;
    let found = $1ac6489ce0acdb88$var$isRevealable(node);
    if (!found) node.descendants((descendant)=>{
        if (found) return false;
        found = $1ac6489ce0acdb88$var$isRevealable(descendant);
        return !found;
    });
    $1ac6489ce0acdb88$var$revealableCache.set(node, found);
    return found;
};
const $1ac6489ce0acdb88$var$hasInlineComment = (node)=>(0, $gab48.findChildrenByMark)(node, node.type.schema.marks.annotation, true).some((annotation)=>annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment'));
/** `null` is a cached "no search text for this node", as distinct from `undefined` for a miss. */ const $1ac6489ce0acdb88$var$searchTextCache = new WeakMap();
const $1ac6489ce0acdb88$export$2228423caf47f74 = (node)=>{
    let cached = $1ac6489ce0acdb88$var$searchTextCache.get(node);
    if (cached === undefined) {
        cached = $1ac6489ce0acdb88$var$hasInlineComment(node) ? // No text, which makes the block render instead. Comment navigation looks through the DOM
        // for the commented text and scrolls to it, so that text has to be a real element —
        // plain text carries no comment marks and cannot stand in for it. Without this, the
        // arrow keys silently skip every comment inside a collapsed expand. We give up the
        // saving for this block on purpose.
        null : // A leaf block is not inside its own range, so `textBetween` would return nothing and its
        // text would be lost — a macro sitting straight in an expand body, for instance.
        node.isLeaf ? $1ac6489ce0acdb88$var$leafText(node) : node.textBetween(0, node.content.size, $1ac6489ce0acdb88$export$107fd3c009356079, $1ac6489ce0acdb88$var$leafText);
        $1ac6489ce0acdb88$var$searchTextCache.set(node, cached);
    }
    return cached ?? undefined;
};
const $1ac6489ce0acdb88$var$tableStandInCache = new WeakMap();
const $1ac6489ce0acdb88$export$e860c2c8391d30bf = (table)=>{
    const cached = $1ac6489ce0acdb88$var$tableStandInCache.get(table);
    if (cached !== undefined) return cached;
    const parts = [];
    table.forEach((row, _offset, index)=>{
        const text = $1ac6489ce0acdb88$export$190cd2ff72900fe7(row) ? undefined : $1ac6489ce0acdb88$export$2228423caf47f74(row);
        if (text === undefined) {
            parts.push(index);
            return;
        }
        const last = parts[parts.length - 1];
        if (typeof last === 'string') {
            parts[parts.length - 1] = `${last}${$1ac6489ce0acdb88$export$107fd3c009356079}${text}`;
            return;
        }
        parts.push(text);
    });
    $1ac6489ce0acdb88$var$tableStandInCache.set(table, parts);
    return parts;
};

});


parcelRegister("asc4s", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", () => $3f4d56e084dcf13d$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $3f4d56e084dcf13d$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $3f4d56e084dcf13d$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $3f4d56e084dcf13d$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $auxFA = parcelRequire("auxFA");

var $c6WhP = parcelRequire("c6WhP");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f4d56e084dcf13d$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $3f4d56e084dcf13d$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $auxFA.defaultSchema));
        this.encode = $3f4d56e084dcf13d$var$createEncoder(transformer, new (0, $c6WhP.JSONTransformer)());
    }
}
const $3f4d56e084dcf13d$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $3f4d56e084dcf13d$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $3f4d56e084dcf13d$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $3f4d56e084dcf13d$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("eSupO", function(module, exports) {
$parcel$export(module.exports, "toReact", () => $de488f00a270a2a3$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $iEnfL = parcelRequire("iEnfL");

var $katwF = parcelRequire("katwF");

var $dBqIO = parcelRequire("dBqIO");

var $030IE = parcelRequire("030IE");

var $cr2Kg = parcelRequire("cr2Kg");

var $jzwci = parcelRequire("jzwci");

var $b0c7u = parcelRequire("b0c7u");

var $h7H37 = parcelRequire("h7H37");

var $kCB3E = parcelRequire("kCB3E");

var $koHj2 = parcelRequire("koHj2");

var $c3Eya = parcelRequire("c3Eya");

var $kajce = parcelRequire("kajce");

var $jQwRZ = parcelRequire("jQwRZ");

var $4Xvkv = parcelRequire("4Xvkv");

var $epMwc = parcelRequire("epMwc");

var $fsGKm = parcelRequire("fsGKm");

var $2vGNV = parcelRequire("2vGNV");

var $d7VjK = parcelRequire("d7VjK");

var $7Ed7m = parcelRequire("7Ed7m");

var $ioBeT = parcelRequire("ioBeT");
const $de488f00a270a2a3$export$c00d967a0f56fdb7 = {
    code: (0, $jzwci.default),
    em: (0, $kCB3E.default),
    link: (0, $jQwRZ.default),
    strike: (0, $4Xvkv.default),
    strong: (0, $epMwc.default),
    subsup: (0, $fsGKm.default),
    textColor: (0, $2vGNV.default),
    backgroundColor: (0, $dBqIO.default),
    underline: (0, $d7VjK.default),
    annotation: (0, $katwF.default),
    border: (0, $030IE.default),
    fontSize: (0, $koHj2.default),
    // Stage0
    confluenceInlineComment: (0, $b0c7u.default),
    breakout: (0, $cr2Kg.default),
    alignment: (0, $iEnfL.default),
    indentation: (0, $kajce.default),
    unsupportedMark: (0, $7Ed7m.default),
    unsupportedNodeAttribute: (0, $ioBeT.default),
    dataConsumer: (0, $h7H37.default),
    fragment: (0, $c3Eya.default)
};
const $de488f00a270a2a3$export$d4334b129116aad7 = (mark)=>{
    return $de488f00a270a2a3$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("iEnfL", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b4a2651dd6448ee$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $2HNFa = parcelRequire("2HNFa");
const $2b4a2651dd6448ee$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $2HNFa.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $2b4a2651dd6448ee$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9dQre.jsx)($2b4a2651dd6448ee$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("dBqIO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6878a2344480bef6$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $8bHyz = parcelRequire("8bHyz");

var $jYZXg = parcelRequire("jYZXg");

var $ceb9s = parcelRequire("ceb9s");
function $6878a2344480bef6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $jYZXg.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $8bHyz.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $bSJIT.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "background-color-padding-left background-color-padding-right",
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("jYZXg", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $65f11c7f7902517c$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $65f11c7f7902517c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Red - light */ ['#FFD5D2']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    /** Blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    /** Green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)"
};
function $65f11c7f7902517c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $65f11c7f7902517c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("030IE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2fe8de807f16710$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9dQre = parcelRequire("9dQre");
function $a2fe8de807f16710$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("cr2Kg", function(module, exports) {
$parcel$export(module.exports, "default", () => $615692d2b87dc3bc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");

var $cvo9f = parcelRequire("cvo9f");
function $615692d2b87dc3bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $615692d2b87dc3bc$var$flexWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $5bbjm.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $615692d2b87dc3bc$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $615692d2b87dc3bc$var$getWidth = (width, mode)=>{
    if ((0, $797yE.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if (mode === 'max' || typeof width === 'number' && width >= (0, $5bbjm.akEditorFullWidthLayoutWidth)) return `min(${0, $5bbjm.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'full-width') return `min(${0, $5bbjm.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $615692d2b87dc3bc$export$2e2bcd8739ae039(props) {
    const breakoutWidth = props.width ?? null;
    const width = $615692d2b87dc3bc$var$getWidth(breakoutWidth, props.mode);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $cvo9f.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $615692d2b87dc3bc$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $615692d2b87dc3bc$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $797yE.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
}

});

parcelRegister("jzwci", function(module, exports) {
$parcel$export(module.exports, "isCodeMark", () => $a90df47081de247f$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $a90df47081de247f$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $gvYd9 = parcelRequire("gvYd9");

var $kLfCj = parcelRequire("kLfCj");
const $a90df47081de247f$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $a90df47081de247f$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $kLfCj.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gvYd9.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $a90df47081de247f$var$_default_1 = (0, $fK3tS.default)($a90df47081de247f$export$7cea6ffa7022e85f);
var $a90df47081de247f$export$2e2bcd8739ae039 = $a90df47081de247f$var$_default_1;

});
parcelRegister("gvYd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d87c1538b553af19$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $ePzf8 = parcelRequire("ePzf8");

var $6yra5 = parcelRequire("6yra5");
const $d87c1538b553af19$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $d87c1538b553af19$var$Code = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $dc70d.jsx)($d87c1538b553af19$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $dc70d.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $9fU1q.default)([
            $d87c1538b553af19$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $d87c1538b553af19$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $ePzf8.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $6yra5.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($d87c1538b553af19$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $dc70d.jsx)($d87c1538b553af19$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: replacedChildren
    });
}
function $d87c1538b553af19$var$isReactElement(child) {
    return !!child.type;
}
$d87c1538b553af19$var$Code.displayName = 'Code';
var $d87c1538b553af19$export$2e2bcd8739ae039 = $d87c1538b553af19$var$Code;

});
parcelRegister("ePzf8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7fdf84d60438336$export$2e2bcd8739ae039);

var $4xvjg = parcelRequire("4xvjg");
function $c7fdf84d60438336$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $4xvjg.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});
parcelRegister("4xvjg", function(module, exports) {
$parcel$export(module.exports, "bidiCharacterRegex", () => $fa3a1d3b6b4f607b$export$ecb256e6a1f5ee7e);
const $fa3a1d3b6b4f607b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;

});


parcelRegister("6yra5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c86c1723b98c5fa7$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $lavtv = parcelRequire("lavtv");

var $2k2Bc = parcelRequire("2k2Bc");
function $c86c1723b98c5fa7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: label,
        tag: $c86c1723b98c5fa7$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2k2Bc.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2k2Bc.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $c86c1723b98c5fa7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("2k2Bc", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $368c1378e6b62cc5$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9Abbn = parcelRequire("9Abbn");
const $368c1378e6b62cc5$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $368c1378e6b62cc5$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $368c1378e6b62cc5$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $9fU1q.default)([
                    $368c1378e6b62cc5$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $dc70d.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $368c1378e6b62cc5$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    const bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return `U+${bidiCharacterCode}`;
}

});



parcelRegister("kLfCj", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningMessages", () => $db4013d0420942b9$export$42bb270d1224182);

var $f0Pt4 = parcelRequire("f0Pt4");
const $db4013d0420942b9$export$42bb270d1224182 = (0, $f0Pt4.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});


parcelRegister("b0c7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2dbf6b67508c0c3$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
class $c2dbf6b67508c0c3$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});

parcelRegister("h7H37", function(module, exports) {
$parcel$export(module.exports, "default", () => $77242206f3260d25$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $77242206f3260d25$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $dc70d.jsx)(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kCB3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $78a3db935e812175$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $78a3db935e812175$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $dc70d.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("koHj2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9452bd1022eca69a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $9452bd1022eca69a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize,
        children: props.children
    });
}

});

parcelRegister("c3Eya", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f506d69a1329893$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $5f506d69a1329893$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $dc70d.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kajce", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eed292218a0aaae$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $4eed292218a0aaae$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("jQwRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $48b8cedeb149167d$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $g6Qq4 = parcelRequire("g6Qq4");

var $3y2s4 = parcelRequire("3y2s4");

var $3aMs2 = parcelRequire("3aMs2");

var $dABkj = parcelRequire("dABkj");

var $asc4s = parcelRequire("asc4s");

var $bgd2b = parcelRequire("bgd2b");

var $2hs8I = parcelRequire("2hs8I");
const $48b8cedeb149167d$var$LinkUrlMigration = (0, $3aMs2.componentWithCondition)(()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_renderer_static_css'), (0, $bgd2b.LinkUrlCompiled), (0, $2hs8I.LinkUrlEmotion));
function $48b8cedeb149167d$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $asc4s.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: props.children
    });
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
        data: analyticsData,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($48b8cedeb149167d$var$LinkUrlMigration, {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>{
                if (fireAnalyticsEvent) fireAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).VISITED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LINK,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        platform: (0, $dABkj.PLATFORM).WEB,
                        mode: (0, $dABkj.MODE).RENDERER
                    }
                });
                if (handler) handler(e, href);
            },
            ...anchorProps,
            ...dataAttributes,
            isLinkComponent: true,
            enableResolve: true,
            children: props.children
        })
    });
}

});
parcelRegister("bgd2b", function(module, exports) {
$parcel$export(module.exports, "LinkUrlCompiled", () => $f00aae3e2f8f4d04$export$10ae7cf734c9da69);
/* link-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Compiled branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $3PvTq = parcelRequire("3PvTq");
const $f00aae3e2f8f4d04$var$anchorStyles = null;
const $f00aae3e2f8f4d04$export$10ae7cf734c9da69 = (props)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3PvTq.LinkUrl), {
        ...props,
        className: (0, $9fU1q.default)([
            "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
        ])
    });

});
parcelRegister("3PvTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $22b1ee993affd697$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LinkUrl", () => $22b1ee993affd697$export$56ff87f78018e459);

var $bSJIT = parcelRequire("bSJIT");

var $2usNr = parcelRequire("2usNr");

var $dixZ6 = parcelRequire("dixZ6");

var $lDWWh = parcelRequire("lDWWh");

var $cK2LS = parcelRequire("cK2LS");

var $a3uFO = parcelRequire("a3uFO");

var $chzxw = parcelRequire("chzxw");
const $22b1ee993affd697$var$PACKAGE_DATA = {
    packageName: undefined,
    packageVersion: undefined,
    componentName: 'linkUrl'
};
const $22b1ee993affd697$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $chzxw.useLinkWarningModal)();
    const Link = enableResolve ? (0, $cK2LS.HyperlinkWithSmartLinkResolver) : (0, $lDWWh.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dixZ6.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Link, {
        href: href,
        testId: testId,
        isLinkComponent: isLinkComponent,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a3uFO.default), linkWarningModalProps));
};
const $22b1ee993affd697$export$56ff87f78018e459 = (0, $2usNr.default)($22b1ee993affd697$var$PACKAGE_DATA)($22b1ee993affd697$var$LinkUrl);
var $22b1ee993affd697$export$2e2bcd8739ae039 = $22b1ee993affd697$export$56ff87f78018e459;

});
parcelRegister("dixZ6", function(module, exports) {
$parcel$export(module.exports, "LinkAnalyticsContext", () => $955bffe1cf70c34a$export$9458cdec663b9ff1);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");
const $955bffe1cf70c34a$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("lDWWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $933045a69cf07a6a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $9Rfip = parcelRequire("9Rfip");

var $asxGl = parcelRequire("asxGl");
const $933045a69cf07a6a$var$Anchor = (0, $asxGl.withLinkClickedEvent)('a');
const $933045a69cf07a6a$export$8c0773eab230d49e = (0, $asxGl.withLinkClickedEvent)((0, $9Rfip.default));
const $933045a69cf07a6a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $933045a69cf07a6a$export$8c0773eab230d49e : $933045a69cf07a6a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $933045a69cf07a6a$export$2e2bcd8739ae039 = $933045a69cf07a6a$var$Hyperlink;

});
parcelRegister("asxGl", function(module, exports) {
$parcel$export(module.exports, "withLinkClickedEvent", () => $268b940c854bf5a2$export$263352d59c0c5966);

var $bSJIT = parcelRequire("bSJIT");

var $lGzCY = parcelRequire("lGzCY");

var $e6VxI = parcelRequire("e6VxI");
const $268b940c854bf5a2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $268b940c854bf5a2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $lGzCY.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $e6VxI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$268b940c854bf5a2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("lGzCY", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $32355718f4d7ed9f$export$5993d3ca6c85f774);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $4X9VT = parcelRequire("4X9VT");
var $32355718f4d7ed9f$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $32355718f4d7ed9f$export$5993d3ca6c85f774 = (handler, predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    return (0, $bSJIT.useCallback)((...args)=>{
        const [event] = args;
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $4X9VT.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("4X9VT", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $3f823ad6463e2fb6$export$7987de3055fbdcb0);
parcelRequire("bSJIT");

var $2hVNZ = parcelRequire("2hVNZ");

var $jd1BL = parcelRequire("jd1BL");
const $3f823ad6463e2fb6$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = (0, $jd1BL.createLinkClickedPayload)(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.nonPrivacySafeAttributes
            }
        }).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
    };

});
parcelRegister("2hVNZ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $280b9904959339ff$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $280b9904959339ff$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $280b9904959339ff$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $280b9904959339ff$export$c89e475f7f7174c2);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

const $280b9904959339ff$export$85183a312807388d = 'media';
const $280b9904959339ff$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: '',
    packageVersion: ''
};
var $280b9904959339ff$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $280b9904959339ff$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});

});

parcelRegister("jd1BL", function(module, exports) {
$parcel$export(module.exports, "createLinkClickedPayload", () => $958ae69af5f82369$export$7fedc699766c16de);
parcelRequire("bSJIT");

var $8EYFH = parcelRequire("8EYFH");

var $l0RiQ = parcelRequire("l0RiQ");

var $cxAmX = parcelRequire("cxAmX");
const $958ae69af5f82369$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $958ae69af5f82369$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : (0, $8EYFH.buttonMap).get(event.button);
    if (!clickType) return;
    const clickOutcome = (0, $cxAmX.getLinkClickOutcome)(event, clickType);
    const keysHeld = (0, $l0RiQ.getKeys)(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $958ae69af5f82369$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};

});
parcelRegister("8EYFH", function(module, exports) {
$parcel$export(module.exports, "buttonMap", () => $ac413f493cc83baa$export$cfb45d54e1604f6c);
const $ac413f493cc83baa$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);

});

parcelRegister("l0RiQ", function(module, exports) {
$parcel$export(module.exports, "getKeys", () => $08dba758248f8bd7$export$74743eda5dda3ccf);
parcelRequire("bSJIT");
const $08dba758248f8bd7$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};

});

parcelRegister("cxAmX", function(module, exports) {
$parcel$export(module.exports, "getLinkClickOutcome", () => $79871570314c0e61$export$d2a83e3b34be812b);
parcelRequire("bSJIT");

var $faVqX = parcelRequire("faVqX");
const $79871570314c0e61$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $79871570314c0e61$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $faVqX.browser)();
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($79871570314c0e61$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}

});
parcelRegister("faVqX", function(module, exports) {
$parcel$export(module.exports, "browser", () => $ba2b85da8df6eaf5$export$3f2684e5d7cb1006);
const $ba2b85da8df6eaf5$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $ba2b85da8df6eaf5$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $ba2b85da8df6eaf5$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $ba2b85da8df6eaf5$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $ba2b85da8df6eaf5$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $ba2b85da8df6eaf5$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $ba2b85da8df6eaf5$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $ba2b85da8df6eaf5$var$result.android = /Android \d/.test(navigator.userAgent);
    $ba2b85da8df6eaf5$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $ba2b85da8df6eaf5$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $ba2b85da8df6eaf5$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $ba2b85da8df6eaf5$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $ba2b85da8df6eaf5$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $ba2b85da8df6eaf5$export$3f2684e5d7cb1006() {
    return $ba2b85da8df6eaf5$var$result;
}

});





parcelRegister("e6VxI", function(module, exports) {
$parcel$export(module.exports, "useMouseDownEvent", () => $484f6b097bbc6349$export$df67f318ded0283c);

var $lGzCY = parcelRequire("lGzCY");
const $484f6b097bbc6349$var$isNotLeftClick = (event)=>event.button !== 0;
const $484f6b097bbc6349$export$df67f318ded0283c = (onMouseDown)=>{
    return (0, $lGzCY.useLinkClicked)(onMouseDown, $484f6b097bbc6349$var$isNotLeftClick);
};

});



parcelRegister("cK2LS", function(module, exports) {
$parcel$export(module.exports, "HyperlinkWithSmartLinkResolver", () => $72072755e7de2e71$export$1fdb4f77fe528a52);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $fK3tS = parcelRequire("fK3tS");

var $5BiUr = parcelRequire("5BiUr");

var $9Ttmg = parcelRequire("9Ttmg");

var $8fxtQ = parcelRequire("8fxtQ");

var $hmu85 = parcelRequire("hmu85");

var $jnYkh = parcelRequire("jnYkh");

var $2x5KE = parcelRequire("2x5KE");

var $dMv9i = parcelRequire("dMv9i");

var $g3zfH = parcelRequire("g3zfH");

var $lDWWh = parcelRequire("lDWWh");
const $72072755e7de2e71$var$HyperlinkFallbackComponent = ()=>null;
const $72072755e7de2e71$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $hmu85.default)(props === null || props === void 0 ? void 0 : props.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnYkh.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DefaultComponent, props);
    };
const $72072755e7de2e71$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { state: state } = (0, $8fxtQ.default)({
        href: props.href || ''
    });
    const thirdPartyARI = (0, $9Ttmg.getThirdPartyARI)(state === null || state === void 0 ? void 0 : state.details);
    const firstPartyIdentifier = (0, $5BiUr.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $g3zfH.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI);
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = (state === null || state === void 0 ? void 0 : state.status) === 'resolved' && fire3PClickEvent;
    const onClick = (0, $bSJIT.useCallback)((e)=>{
        // button === 0 is left-click, see
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (shouldFire3PClickEvent && (e === null || e === void 0 ? void 0 : e.button) === 0) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent();
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onAuxClick = (0, $bSJIT.useCallback)((e)=>{
        // isAuxClick guards against Windows right-clicks firing onAuxClick with button === 2.
        if ((0, $2x5KE.isAuxClick)(e) && shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onContextMenu = (0, $bSJIT.useCallback)((_e)=>{
        if (shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lDWWh.default), {
        ...props,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    });
};
const $72072755e7de2e71$export$1fdb4f77fe528a52 = (0, $eime1.withErrorBoundary)($72072755e7de2e71$var$withValidator((0, $fK3tS.default)((0, $dMv9i.default)($72072755e7de2e71$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $lDWWh.default)), {
    FallbackComponent: $72072755e7de2e71$var$HyperlinkFallbackComponent
});

});
parcelRegister("5BiUr", function(module, exports) {
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $df3d84a039dfd65a$export$48b4e58cdb8031ba);
// Helper function to extract page ID from standard Confluence page URLs
const $df3d84a039dfd65a$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $df3d84a039dfd65a$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $df3d84a039dfd65a$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $df3d84a039dfd65a$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
const $df3d84a039dfd65a$export$48b4e58cdb8031ba = ()=>{
    if (typeof window === 'undefined') return undefined;
    const product = $df3d84a039dfd65a$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $df3d84a039dfd65a$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $df3d84a039dfd65a$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $df3d84a039dfd65a$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};

});

parcelRegister("9Ttmg", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyARI", () => $5b6c1b9f196c789b$export$e029950864672b4);
const $5b6c1b9f196c789b$export$e029950864672b4 = (details)=>{
    if (details !== null && details !== void 0 && details.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
    if (details !== null && details !== void 0 && details.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
        const ari = details.data['atlassian:ari'];
        if (ari.includes('ari:third-party')) return ari;
    }
    return undefined;
};

});

parcelRegister("8fxtQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $67cc1c84ac2c20af$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $2fwRK = parcelRequire("2fwRK");

var $b7ugw = parcelRequire("b7ugw");

var $s9hBp = parcelRequire("s9hBp");

var $k27DD = parcelRequire("k27DD");

var $2JDIg = parcelRequire("2JDIg");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $2lrWO = parcelRequire("2lrWO");

var $2TtjQ = parcelRequire("2TtjQ");

var $fuhlR = parcelRequire("fuhlR");
const $67cc1c84ac2c20af$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $bSJIT.useState)(()=>(0, $7RHfd.default)());
    const state = (0, $2TtjQ.useSmartCardState)(href);
    const definitionId = (0, $3p1gi.getDefinitionId)(state.details);
    const extensionKey = (0, $gy3md.getExtensionKey)(state.details);
    const resourceType = (0, $2lrWO.getResourceType)(state.details);
    const actions = (0, $2JDIg.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $fuhlR.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $bSJIT.useEffect)(()=>{
        (0, $k27DD.mark)(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            (0, $b7ugw.create)(id, state.status);
            if (state.status === 'resolved') {
                var _getMeasure;
                fireEvent('operational.hyperlink.resolved', {
                    definitionId: definitionId ?? null,
                    extensionKey: extensionKey ?? null,
                    resourceType: resourceType ?? null,
                    duration: ((_getMeasure = (0, $s9hBp.getMeasure)(id, state.status)) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) ?? null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $67cc1c84ac2c20af$export$2e2bcd8739ae039 = $67cc1c84ac2c20af$var$useResolveHyperlink;

});
parcelRegister("2fwRK", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $1fac81e0943f6bc1$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::7d3d9083d0211b0990b4c41be73c44fd>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen smart-card
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $4onLO = parcelRequire("4onLO");

var $kYpcY = parcelRequire("kYpcY");
const $1fac81e0943f6bc1$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const fireEvent = (0, $bSJIT.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $kYpcY.default)(...params));
        event.fire((0, $4onLO.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("4onLO", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $1c35e440e4333974$export$3f072f06b90c3985);
const $1c35e440e4333974$export$3f072f06b90c3985 = 'media';

});

parcelRegister("kYpcY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5be9c8860b609f0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::fe05c93b9e82ab4b7ef821abc44c49bb>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen smart-card
 */ const $f5be9c8860b609f0$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $f5be9c8860b609f0$export$2e2bcd8739ae039 = $f5be9c8860b609f0$var$createEventPayload;

});


parcelRegister("b7ugw", function(module, exports) {
$parcel$export(module.exports, "create", () => $2eb45e8d04b7d637$export$185802fd694ee1f5);

var $9qieF = parcelRequire("9qieF");

var $s9hBp = parcelRequire("s9hBp");

var $8yy1P = parcelRequire("8yy1P");

var $aRrJU = parcelRequire("aRrJU");
const $2eb45e8d04b7d637$var$getMark = (id, status)=>{
    if (0, $aRrJU.hasPerformanceAPIAvailable) {
        const name = (0, $9qieF.getMarkName)(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $2eb45e8d04b7d637$export$185802fd694ee1f5 = (id, status)=>{
    if (0, $aRrJU.hasPerformanceAPIAvailable) {
        const name = (0, $8yy1P.getMeasureName)(id, status);
        const measure = (0, $s9hBp.getMeasure)(id, status);
        if (!measure) {
            const startMark = $2eb45e8d04b7d637$var$getMark(id, 'pending');
            const endMark = $2eb45e8d04b7d637$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});
parcelRegister("9qieF", function(module, exports) {
$parcel$export(module.exports, "getMarkName", () => $3c7d69dac516206f$export$fcff3185c7ce7f2b);
const $3c7d69dac516206f$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;

});

parcelRegister("s9hBp", function(module, exports) {
$parcel$export(module.exports, "getMeasure", () => $0ececc3d972358c3$export$d6e97a903ae9a3aa);

var $8yy1P = parcelRequire("8yy1P");

var $aRrJU = parcelRequire("aRrJU");
const $0ececc3d972358c3$export$d6e97a903ae9a3aa = (id, status)=>{
    if (0, $aRrJU.hasPerformanceAPIAvailable) {
        const name = (0, $8yy1P.getMeasureName)(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};

});
parcelRegister("8yy1P", function(module, exports) {
$parcel$export(module.exports, "getMeasureName", () => $27ef4ee32bb27b55$export$984df7f61dd7928f);
const $27ef4ee32bb27b55$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;

});

parcelRegister("aRrJU", function(module, exports) {
$parcel$export(module.exports, "hasPerformanceAPIAvailable", () => $1aa8c4172b2b4a3b$export$8dfeb9778591bc94);

var $gn3qM = parcelRequire("gn3qM");
const $1aa8c4172b2b4a3b$export$8dfeb9778591bc94 = (0, $gn3qM.isPerformanceAPIAvailable)();

});
parcelRegister("gn3qM", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $174e7d2f3ba1259d$export$b5717a625dd4a3eb);
const $174e7d2f3ba1259d$export$b5717a625dd4a3eb = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};

});




parcelRegister("k27DD", function(module, exports) {
$parcel$export(module.exports, "mark", () => $456cf11ef5064452$export$bf7f2fce5c1cf636);

var $9qieF = parcelRequire("9qieF");

var $aRrJU = parcelRequire("aRrJU");
const $456cf11ef5064452$export$bf7f2fce5c1cf636 = (id, status)=>{
    if (0, $aRrJU.hasPerformanceAPIAvailable) {
        const name = (0, $9qieF.getMarkName)(id, status);
        performance.mark(name);
    }
};

});

parcelRegister("2JDIg", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $887f81cec25af9c1$export$f7c340395f31e832);

var $bSJIT = parcelRequire("bSJIT");

var $gxIo9 = parcelRequire("gxIo9");

var $fUOZn = parcelRequire("fUOZn");

var $6bOBo = parcelRequire("6bOBo");

var $gUazh = parcelRequire("gUazh");

var $hW8ja = parcelRequire("hW8ja");

var $gdUUy = parcelRequire("gdUUy");

var $8gobf = parcelRequire("8gobf");

var $5N1Y4 = parcelRequire("5N1Y4");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $1R1LG = parcelRequire("1R1LG");

var $jERMp = parcelRequire("jERMp");

var $jmH2k = parcelRequire("jmH2k");

var $3p1gi = parcelRequire("3p1gi");

var $gy3md = parcelRequire("gy3md");

var $bIXTN = parcelRequire("bIXTN");

var $fwvcj = parcelRequire("fwvcj");

var $2AqEC = parcelRequire("2AqEC");

var $1Nceg = parcelRequire("1Nceg");
const $887f81cec25af9c1$var$POST_AUTH_CHAT_EXTENSION_KEY = 'google-object-provider';
// Smart Card resolver key differs from the consumer-facing Rovo payload key.
const $887f81cec25af9c1$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY = 'google-drive';
const $887f81cec25af9c1$var$SMART_LINK_3P_POST_AUTH_SOURCE = 'smart-link-3p-post-auth';
const $887f81cec25af9c1$var$getPostAuthChatPayloadId = ()=>{
    if (typeof crypto !== 'undefined') {
        if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        if (typeof crypto.getRandomValues === 'function') {
            const values = new Uint32Array(4);
            crypto.getRandomValues(values);
            return `smart-link-post-auth-chat-${Array.from(values, (value)=>value.toString(16)).join('-')}`;
        }
    }
    return `smart-link-post-auth-chat-${Date.now()}`;
};
const $887f81cec25af9c1$var$sendPostAuthChatOpenMessage = (url, documentTitle)=>{
    var _window$parent;
    if (typeof window === 'undefined' || typeof ((_window$parent = window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage) !== 'function') return;
    const payload = {
        type: 'chat-smartlink-3p-post-auth-launch',
        source: $887f81cec25af9c1$var$SMART_LINK_3P_POST_AUTH_SOURCE,
        openChat: true,
        openChatMode: 'mini-modal',
        data: {
            extensionKey: $887f81cec25af9c1$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY,
            provider: 'Google Drive',
            projectContext: {
                projectId: url,
                projectName: documentTitle ?? 'Google Drive',
                projectUrl: url
            }
        }
    };
    window.parent.postMessage({
        eventType: (0, $8gobf.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: $887f81cec25af9c1$var$getPostAuthChatPayloadId()
    }, '*');
};
const $887f81cec25af9c1$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $1Nceg.default)();
    const invokeClientAction = (0, $2AqEC.default)({});
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const flags = (0, $fwvcj.default)();
    const { store: store, rovoOptions: rovoOptions } = (0, $6bOBo.useSmartLinkContext)();
    const rovoOptionsRef = (0, $bSJIT.useRef)(rovoOptions);
    rovoOptionsRef.current = rovoOptions;
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $bSJIT.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5kJPq.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $bSJIT.useCallback)((metadataStatus)=>{
        dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    // Original resolve function — signature kept intact for maximum safety when FG is off.
    const resolve = (0, $bSJIT.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id
        }), [
        id,
        resolveUrl,
        url
    ]);
    // New resolve function accepting ResolveUrlParams (minus 'id' which is closed over).
    // Used when FG is enabled to pass appearance to ORS.
    const resolveNew = (0, $bSJIT.useCallback)(async (params = {})=>{
        const { url: resourceUrl = url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, appearance: appearance } = params;
        return resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id,
            appearance: appearance
        });
    }, [
        id,
        resolveUrl,
        url
    ]);
    /**
   * Register a smart link for resolution.
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ const register = (0, $bSJIT.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_RESOLVING), {
                url: url
            }));
            // Always set metadataStatus to 'pending' during registration to prevent
            // loadMetadata from firing a duplicate concurrent fetch if a hover card
            // mounts while registration is in-flight. This matches pre-PR behaviour.
            setMetadataStatus('pending');
        }
        if ((0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization')) return resolveNew({
            url: url,
            appearance: appearance
        });
        return resolve(url);
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $bSJIT.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $3p1gi.getDefinitionId)(details);
        if ((0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization')) {
            if (definitionId) (0, $jmH2k.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolveNew({
                    url: reloadUrl,
                    isReloading: true,
                    appearance: appearance
                }));
            else resolveNew({
                url: url,
                isReloading: true,
                appearance: appearance
            });
        } else if (definitionId) (0, $jmH2k.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolve(reloadUrl, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve,
        resolveNew
    ]);
    /**
   * Load metadata for hover card preview.
   * This always requests 'block' appearance to get full data including summary.
   *
   * Inline optimized and SSR-resolved links keep metadataStatus pending until hover
   * requests the full block response.
   */ const loadMetadata = (0, $bSJIT.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        const needsBlockData = metadataStatus === undefined || metadataStatus === 'pending' && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization');
        if (needsBlockData) {
            setMetadataStatus('pending');
            if ((0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization')) // Always request 'block' appearance for hover card metadata to get full data
            return resolveNew({
                url: url,
                isMetadataRequest: true,
                appearance: 'block'
            });
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $bSJIT.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $3p1gi.getDefinitionId)(details);
        const extensionKey = (0, $gy3md.getExtensionKey)(details);
        const isSupportedPostAuthChatExtensionKey = extensionKey === $887f81cec25af9c1$var$POST_AUTH_CHAT_EXTENSION_KEY;
        const services = (0, $bIXTN.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $hW8ja.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $jERMp.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                // Post-auth Chat onboarding: auto-open Rovo Chat mini-modal with the
                // authed 3P link as context, for supported providers (e.g. Google Drive).
                // Provider eligibility is derived from the pre-auth SmartLink state.
                const isEligibleForPostAuthChat = status === 'unauthorized' && isSupportedPostAuthChatExtensionKey && (0, $gdUUy.fg)('platform_sl_3p_post_auth_chat_open_fg') && (0, $1R1LG.getIsRovoChatEnabled)(rovoOptionsRef.current);
                // Experiment check: fires exposure for both control and treatment.
                // Only reached after eligibility preconditions + kill switch pass, so
                // exposure is counted for the triggered eligible pool.
                const isPostAuthChatTreatment = isEligibleForPostAuthChat && (0, $5N1Y4.expValEquals)('platform_sl_3p_post_auth_chat_open_exp', 'isEnabled', true);
                if (status === 'unauthorized' && !isPostAuthChatTreatment) {
                    const provider = (0, $gxIo9.extractSmartLinkProvider)(details);
                    flags.showConnectFlag({
                        id: `smart-link-connect-success-${extensionKey}`,
                        provider: provider
                    });
                }
                reload();
                if (isPostAuthChatTreatment) $887f81cec25af9c1$var$sendPostAuthChatOpenMessage(url, (0, $fUOZn.extractSmartLinkTitle)(details));
            }, (err)=>{
                (0, $jERMp.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent,
        flags,
        url
    ]);
    const invoke = (0, $bSJIT.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("gxIo9", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkProvider", () => $72695be45d4d14f9$export$ff753ed519e96e9e);

var $6N0jd = parcelRequire("6N0jd");

var $fxoio = parcelRequire("fxoio");

var $4gDvk = parcelRequire("4gDvk");
const $72695be45d4d14f9$export$ff753ed519e96e9e = (response)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) return (0, $6N0jd.extractEntityProvider)(response);
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $fxoio.extractProvider)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("6N0jd", function(module, exports) {
$parcel$export(module.exports, "extractEntityProvider", () => $4bc0c712b2016b69$export$ad879f2c9d5100a0);

var $bSJIT = parcelRequire("bSJIT");

var $4eIWR = parcelRequire("4eIWR");

var $jSH6l = parcelRequire("jSH6l");

var $gdUUy = parcelRequire("gdUUy");

var $eT1DB = parcelRequire("eT1DB");

var $lnxPF = parcelRequire("lnxPF");

var $5NFld = parcelRequire("5NFld");
const $4bc0c712b2016b69$export$ad879f2c9d5100a0 = (response)=>{
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) return undefined;
    if (!(0, $gdUUy.fg)('platform_lp_use_generator_icon_for_provider')) {
        const entityIcon = (0, $5NFld.extractEntityIcon)(response);
        if (entityIcon) return (0, $eT1DB.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        });
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $lnxPF.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4eIWR.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $lnxPF.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jSH6l.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $eT1DB.rebrandProvider)({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        iconLabel: name
    });
};

});
parcelRegister("4eIWR", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $54f335090af5eb54$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932d47dd87f3f2976aabd1b4699b27b4>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $54f335090af5eb54$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $54f335090af5eb54$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $54f335090af5eb54$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $54f335090af5eb54$var$svg,
        customThemeSvg: $54f335090af5eb54$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("a1hMn", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $4e4a7ee4ee3164cc$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");

var $ceb9s = parcelRequire("ceb9s");
const $4e4a7ee4ee3164cc$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $4e4a7ee4ee3164cc$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $4e4a7ee4ee3164cc$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $4e4a7ee4ee3164cc$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $4e4a7ee4ee3164cc$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $4e4a7ee4ee3164cc$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $4e4a7ee4ee3164cc$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $4e4a7ee4ee3164cc$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $4e4a7ee4ee3164cc$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $9fU1q.default)([
            $4e4a7ee4ee3164cc$var$styles.root,
            $4e4a7ee4ee3164cc$var$sizeMap[size],
            colorMode === 'dark' ? $4e4a7ee4ee3164cc$var$dataCenterDarkAppearanceMap[appearance] : $4e4a7ee4ee3164cc$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $4e4a7ee4ee3164cc$var$rovoDarkAppearanceMap[appearance] : $4e4a7ee4ee3164cc$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $4e4a7ee4ee3164cc$var$cloudDarkAppearanceMap[appearance] : $4e4a7ee4ee3164cc$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $gdUUy.fg)('assets-platform-branding') || (0, $gdUUy.fg)('assets-platform-branding-v2')) && $4e4a7ee4ee3164cc$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("jSH6l", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $13d64d53dcd91b13$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0e4bfbb3ca87324a6e97db845b2ae2c>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $13d64d53dcd91b13$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $13d64d53dcd91b13$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $13d64d53dcd91b13$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $13d64d53dcd91b13$var$svg,
        customThemeSvg: $13d64d53dcd91b13$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eT1DB", function(module, exports) {
$parcel$export(module.exports, "rebrandProvider", () => $0bbd12936c85f41e$export$df1b15aebbcf717e);
const $0bbd12936c85f41e$var$GOOGLE_DRIVE = 'Google Drive';
const $0bbd12936c85f41e$export$df1b15aebbcf717e = (provider)=>{
    switch(provider === null || provider === void 0 ? void 0 : provider.text){
        case 'Google':
            return {
                ...provider,
                iconLabel: $0bbd12936c85f41e$var$GOOGLE_DRIVE,
                text: $0bbd12936c85f41e$var$GOOGLE_DRIVE
            };
        default:
            return provider;
    }
};

});

parcelRegister("lnxPF", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $328b8c2819678f2b$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $328b8c2819678f2b$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $328b8c2819678f2b$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $328b8c2819678f2b$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $328b8c2819678f2b$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $328b8c2819678f2b$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $328b8c2819678f2b$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $328b8c2819678f2b$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $328b8c2819678f2b$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $328b8c2819678f2b$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $328b8c2819678f2b$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $328b8c2819678f2b$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "SmartLinkSize", () => $328b8c2819678f2b$export$51f13ced115cbdae);
$parcel$export(module.exports, "IconType", () => $328b8c2819678f2b$export$13ff1290a9e22e77);
const $328b8c2819678f2b$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $328b8c2819678f2b$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $328b8c2819678f2b$export$84a73a0383f58180 = 'JiraTask';
const $328b8c2819678f2b$export$c6c83963a9378a67 = 'JiraSubTask';
const $328b8c2819678f2b$export$58af3c426c111a6d = 'JiraStory';
const $328b8c2819678f2b$export$ac9898a63417219e = 'JiraBug';
const $328b8c2819678f2b$export$54db5e3fb12e39cd = 'JiraEpic';
const $328b8c2819678f2b$export$2f54a5a217202c85 = 'JiraIncident';
const $328b8c2819678f2b$export$d097371052bfc411 = 'JiraServiceRequest';
const $328b8c2819678f2b$export$efd9452ad16c6676 = 'JiraChange';
const $328b8c2819678f2b$export$2e7e70abb5d81f67 = 'JiraProblem';
const $328b8c2819678f2b$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $328b8c2819678f2b$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $328b8c2819678f2b$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});

});

parcelRegister("5NFld", function(module, exports) {
$parcel$export(module.exports, "extractEntityIcon", () => $1c419b234919a003$export$19346520e937a99f);

var $8GqMz = parcelRequire("8GqMz");

var $1JsvV = parcelRequire("1JsvV");

var $78RyP = parcelRequire("78RyP");

var $3pz0i = parcelRequire("3pz0i");
const $1c419b234919a003$export$19346520e937a99f = (response)=>{
    const entity = (0, $3pz0i.extractEntity)(response);
    if (!entity) return undefined;
    if (!(0, $8GqMz.isBaseEntity)(entity)) return undefined;
    if ((0, $1JsvV.isDesignEntity)(entity) && entity.iconUrl) return {
        url: entity.iconUrl,
        label: entity.type
    };
    if ((0, $78RyP.isDocumentEntity)(entity) && entity.type.iconUrl) return {
        url: entity.type.iconUrl,
        label: entity.type.category
    };
    // When JSON-LD is deprecated, we can change this to returning entity provider icon.
    // For now code upstream will return better result when this method returns undefined.
    return undefined;
};

});
parcelRegister("8GqMz", function(module, exports) {
$parcel$export(module.exports, "isBaseEntity", () => $7922e7ccb59abc62$export$12af7c5462954d1e);

var $df702 = parcelRequire("df702");
const $7922e7ccb59abc62$export$12af7c5462954d1e = (value)=>(0, $df702.isObject)(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';

});
parcelRegister("df702", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $9ad7aaba49d4db24$export$a6cdc56e425d0d0a);
const $9ad7aaba49d4db24$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;

});


parcelRegister("1JsvV", function(module, exports) {
$parcel$export(module.exports, "isDesignEntity", () => $025cd85da98c6422$export$8dc9be81b5b6266b);

var $9fiZG = parcelRequire("9fiZG");

var $ciL0Y = parcelRequire("ciL0Y");

var $8GqMz = parcelRequire("8GqMz");

var $6Gnqa = parcelRequire("6Gnqa");
const $025cd85da98c6422$export$8dc9be81b5b6266b = (value)=>(0, $8GqMz.isBaseEntity)(value) && (0, $6Gnqa.isOneOf)((0, $ciL0Y.DESIGN_STATUSES), (0, $9fiZG.asRecord)(value).status) && (0, $6Gnqa.isOneOf)((0, $ciL0Y.DESIGN_TYPES), (0, $9fiZG.asRecord)(value).type);

});
parcelRegister("9fiZG", function(module, exports) {
$parcel$export(module.exports, "asRecord", () => $105c7f1c240fa1b5$export$badcc9423dc3e1c1);
const $105c7f1c240fa1b5$export$badcc9423dc3e1c1 = (value)=>value;

});

parcelRegister("ciL0Y", function(module, exports) {
$parcel$export(module.exports, "DESIGN_TYPES", () => $add62e08e01877bd$export$7d4721a36ceb2894);
$parcel$export(module.exports, "DESIGN_STATUSES", () => $add62e08e01877bd$export$fcc968815a3eb9c5);
$parcel$export(module.exports, "DOCUMENT_CATEGORIES", () => $add62e08e01877bd$export$892192ec11178e3c);
const $add62e08e01877bd$export$7d4721a36ceb2894 = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $add62e08e01877bd$export$fcc968815a3eb9c5 = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $add62e08e01877bd$export$a544329e8f55f05 = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $add62e08e01877bd$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $add62e08e01877bd$export$cfae73bab05203cf = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $add62e08e01877bd$export$892192ec11178e3c = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];

});

parcelRegister("6Gnqa", function(module, exports) {
$parcel$export(module.exports, "isOneOf", () => $d8af96d5c2cadfce$export$532a90c0e5e8e48c);
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $d8af96d5c2cadfce$export$532a90c0e5e8e48c = (values, value)=>typeof value === 'string' && values.includes(value);

});


parcelRegister("78RyP", function(module, exports) {
$parcel$export(module.exports, "isDocumentEntity", () => $c2cee87ca528a067$export$32c06ee7e0e9b79e);

var $9fiZG = parcelRequire("9fiZG");

var $ciL0Y = parcelRequire("ciL0Y");

var $8GqMz = parcelRequire("8GqMz");

var $df702 = parcelRequire("df702");

var $6Gnqa = parcelRequire("6Gnqa");
const $c2cee87ca528a067$export$32c06ee7e0e9b79e = (value)=>{
    if (!(0, $8GqMz.isBaseEntity)(value)) return false;
    const entityType = (0, $9fiZG.asRecord)(value).type;
    return (0, $df702.isObject)(entityType) && (entityType.category === undefined || (0, $6Gnqa.isOneOf)((0, $ciL0Y.DOCUMENT_CATEGORIES), entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ((0, $6Gnqa.isOneOf)((0, $ciL0Y.DOCUMENT_CATEGORIES), entityType.category) || typeof entityType.iconUrl === 'string');
};

});



parcelRegister("fxoio", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $062044585cefbbc9$export$a832871718466647);

var $eT1DB = parcelRequire("eT1DB");

var $egRBG = parcelRequire("egRBG");

var $dtKl2 = parcelRequire("dtKl2");
const $062044585cefbbc9$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $dtKl2.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $dtKl2.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $062044585cefbbc9$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $eT1DB.rebrandProvider)({
                text: generator.name
            });
        } else if (generator.name) {
            const id = generator['@id'];
            return (0, $eT1DB.rebrandProvider)({
                text: generator.name,
                icon: (0, $egRBG.extractProviderIcon)(generator.icon, id),
                iconLabel: generator.name,
                id: id,
                image: $062044585cefbbc9$var$extractProviderImage(generator.image)
            });
        }
    }
    return undefined;
};

});
parcelRegister("egRBG", function(module, exports) {
$parcel$export(module.exports, "extractProviderIcon", () => $5bd046cb29fc179a$export$6fb636a2ac885215);

var $bSJIT = parcelRequire("bSJIT");

var $4eIWR = parcelRequire("4eIWR");

var $jSH6l = parcelRequire("jSH6l");

var $lnxPF = parcelRequire("lnxPF");

var $cdeW6 = parcelRequire("cdeW6");
const $5bd046cb29fc179a$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $lnxPF.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4eIWR.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $lnxPF.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jSH6l.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $cdeW6.extractUrlFromIconJsonLd)(icon);
    return undefined;
};

});
parcelRegister("cdeW6", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $221d1fae769d5da0$export$67f3d92c824fd850);

var $dtKl2 = parcelRequire("dtKl2");
const $221d1fae769d5da0$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $dtKl2.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $dtKl2.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});




parcelRegister("fUOZn", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $d26de4bd31b8ca19$export$3eda18658b66108);

var $3pz0i = parcelRequire("3pz0i");

var $jzkAp = parcelRequire("jzkAp");

var $4gDvk = parcelRequire("4gDvk");
const $d26de4bd31b8ca19$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $4gDvk.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3pz0i.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    return (0, $jzkAp.extractTitle)(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};

});
parcelRegister("jzkAp", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $58ae27a6ba11bbdb$export$b05803156e5015b6);

var $6c6VV = parcelRequire("6c6VV");

var $fZvKv = parcelRequire("fZvKv");
const $58ae27a6ba11bbdb$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    var _jsonLd$name;
    if (!jsonLd) return undefined;
    const name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $6c6VV.extractContext)(jsonLd);
    const type = (0, $fZvKv.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("6c6VV", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $786b7d1f35c41185$export$efdbd45f3e77a161);

var $fZvKv = parcelRequire("fZvKv");

var $cdeW6 = parcelRequire("cdeW6");
const $786b7d1f35c41185$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $cdeW6.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $fZvKv.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("fZvKv", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $8dee790e596eb4a7$export$2e9ae379995d99e3);
const $8dee790e596eb4a7$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});




parcelRegister("6bOBo", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkContext", () => $c50fc83563aed133$export$e1d190b530cf0ee9);

var $bSJIT = parcelRequire("bSJIT");

var $1zOmw = parcelRequire("1zOmw");
function $c50fc83563aed133$export$e1d190b530cf0ee9() {
    const context = (0, $bSJIT.useContext)((0, $1zOmw.SmartCardContext));
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}

});

parcelRegister("hW8ja", function(module, exports) {
$parcel$export(module.exports, "auth", () => $fedb08c5e03a3f7a$export$73693bad9f5880b0);

var $7818Y = parcelRequire("7818Y");

var $fjBaO = parcelRequire("fjBaO");
function $fedb08c5e03a3f7a$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $fjBaO.isOfTypeAuthError)(errorType)) reject(new (0, $7818Y.AuthError)(data.message, errorType));
                    else reject(new (0, $7818Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $7818Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("7818Y", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $2689ba4680a2dd44$export$145273558d58e0ac);
class $2689ba4680a2dd44$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("fjBaO", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $467be4c4970a9316$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $467be4c4970a9316$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("8gobf", function(module, exports) {
$parcel$export(module.exports, "ROVO_POST_MESSAGE_EVENT_TYPE", () => $6bb2e55ad93ed471$export$cabfb6cc8c48b099);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $6bb2e55ad93ed471$export$5340cc94dd0ecbea);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $3Y2N4 = parcelRequire("3Y2N4");
const $6bb2e55ad93ed471$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $6bb2e55ad93ed471$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $6bb2e55ad93ed471$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $6bb2e55ad93ed471$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $6bb2e55ad93ed471$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($6bb2e55ad93ed471$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $6bb2e55ad93ed471$var$allowedOrigins.includes(hostname));
};
const $6bb2e55ad93ed471$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $3Y2N4.usePublish)('ai-mate');
    (0, $bSJIT.useEffect)(()=>{
        const handlerUnbind = (0, $bAB3U.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$6bb2e55ad93ed471$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $6bb2e55ad93ed471$export$cabfb6cc8c48b099) {
                    var _event$source;
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $6bb2e55ad93ed471$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    (_event$source = event.source) === null || _event$source === void 0 || _event$source.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $6bb2e55ad93ed471$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $6bb2e55ad93ed471$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $bSJIT.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        const handlerUnbind = (0, $bAB3U.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$6bb2e55ad93ed471$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $6bb2e55ad93ed471$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $bSJIT.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $6bb2e55ad93ed471$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $6bb2e55ad93ed471$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("3Y2N4", function(module, exports) {
$parcel$export(module.exports, "usePublish", () => $9456926f50688ab7$export$d55c81786220731c);
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- command callers cannot use hooks */ 
var $bSJIT = parcelRequire("bSJIT");
const $9456926f50688ab7$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $9456926f50688ab7$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload',
    'set-message-context',
    'jira-create-context-payload',
    'submit-rovo-remix',
    'rovo-remix-handoff-failed'
]);
const $9456926f50688ab7$var$isIgnoredForTriggerLatest = (type)=>$9456926f50688ab7$var$ignoredTriggerLatestEvents.has(type);
const $9456926f50688ab7$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $9456926f50688ab7$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$9456926f50688ab7$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    const clearLatest = (topic)=>{
        delete publishQueue[topic];
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue,
        clearLatest: clearLatest
    };
};
const $9456926f50688ab7$var$pubSub = $9456926f50688ab7$var$createPubSub();
const $9456926f50688ab7$export$89b472e03be495df = (topic, payload)=>{
    $9456926f50688ab7$var$pubSub.publish(topic, payload);
};
const $9456926f50688ab7$var$usePubSub = ()=>{
    return $9456926f50688ab7$var$pubSub;
};
const $9456926f50688ab7$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, clearLatestOnUnmount: clearLatestOnUnmount, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe, clearLatest: clearLatest } = $9456926f50688ab7$var$usePubSub();
    const callbackRef = (0, $bSJIT.useRef)(callback);
    callbackRef.current = callback;
    (0, $bSJIT.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return ()=>{
            unsubscribe();
            if (clearLatestOnUnmount) clearLatest(topic);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        clearLatestOnUnmount,
        consumeOnceKey
    ]);
};
const $9456926f50688ab7$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $9456926f50688ab7$var$usePubSub();
    const callbackRef = (0, $bSJIT.useRef)(callback);
    callbackRef.current = callback;
    (0, $bSJIT.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $9456926f50688ab7$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $9456926f50688ab7$var$usePubSub();
    (0, $bSJIT.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $9456926f50688ab7$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $9456926f50688ab7$var$usePubSub();
    const publishFn = (0, $bSJIT.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $9456926f50688ab7$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $9456926f50688ab7$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $9456926f50688ab7$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("5kJPq", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $4f92535811972f8d$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $4f92535811972f8d$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_ROVO", () => $4f92535811972f8d$export$c36142a78ab570c5);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $4f92535811972f8d$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $4f92535811972f8d$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $4f92535811972f8d$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $4f92535811972f8d$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $4f92535811972f8d$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $4f92535811972f8d$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $4f92535811972f8d$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $4f92535811972f8d$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $4f92535811972f8d$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $4f92535811972f8d$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $4f92535811972f8d$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $4f92535811972f8d$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $4f92535811972f8d$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $4f92535811972f8d$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $4f92535811972f8d$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $4f92535811972f8d$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardAction", () => $4f92535811972f8d$export$f40b7e0b762b928b);
$parcel$export(module.exports, "CardDisplay", () => $4f92535811972f8d$export$6ca4ef8b3dc2c804);
const $4f92535811972f8d$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $4f92535811972f8d$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $4f92535811972f8d$export$c36142a78ab570c5 = 'https://www.atlassian.com/trust/ai';
const $4f92535811972f8d$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $4f92535811972f8d$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $4f92535811972f8d$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $4f92535811972f8d$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $4f92535811972f8d$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $4f92535811972f8d$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $4f92535811972f8d$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $4f92535811972f8d$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $4f92535811972f8d$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $4f92535811972f8d$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $4f92535811972f8d$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $4f92535811972f8d$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    ActionName["RovoChatAction"] = "RovoChatAction";
    return ActionName;
}({});
var $4f92535811972f8d$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $4f92535811972f8d$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $4f92535811972f8d$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $4f92535811972f8d$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $4f92535811972f8d$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
var $4f92535811972f8d$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("1R1LG", function(module, exports) {
$parcel$export(module.exports, "getIsRovoChatEnabled", () => $3b8fc9f0a2856648$export$e9a534e68169723d);
const $3b8fc9f0a2856648$export$e9a534e68169723d = (rovoConfig)=>rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoEnabled && rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoLLMEnabled ? true : false;

});

parcelRegister("jERMp", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $6b99c7b7943c9bb0$export$5e9287b6a10f8075);

var $2tD6h = parcelRequire("2tD6h");
const $6b99c7b7943c9bb0$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = (0, $2tD6h.ufoExperiences)[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};

});
parcelRegister("2tD6h", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $4d659c36d402aa47$export$615f888019c45765);

var $5bALc = parcelRequire("5bALc");

var $mx1V1 = parcelRequire("mx1V1");
const $4d659c36d402aa47$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $mx1V1.ExperienceTypes).Experience,
    performanceType: (0, $mx1V1.ExperiencePerformanceTypes).InlineResult
};
const $4d659c36d402aa47$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $mx1V1.ExperienceTypes).Load,
    performanceType: (0, $mx1V1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $4d659c36d402aa47$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $mx1V1.ExperienceTypes).Experience,
    performanceType: (0, $mx1V1.ExperiencePerformanceTypes).InlineResult
};
const $4d659c36d402aa47$export$615f888019c45765 = {
    'smart-link-rendered': new (0, $5bALc.ConcurrentExperience)('smart-link-rendered', $4d659c36d402aa47$var$renderExperience),
    'smart-link-authenticated': new (0, $5bALc.ConcurrentExperience)('smart-link-authenticated', $4d659c36d402aa47$var$inlineExperience),
    'smart-link-action-invocation': new (0, $5bALc.ConcurrentExperience)('smart-link-action-invocation', $4d659c36d402aa47$var$inlineExperience),
    'smart-link-ai-summary': new (0, $5bALc.ConcurrentExperience)('smart-link-ai-summary', $4d659c36d402aa47$var$aiExperience)
};

});


parcelRegister("jmH2k", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $25ff38159cbc1334$export$f75b0b690ab4dfb9);
const $25ff38159cbc1334$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};

});

parcelRegister("3p1gi", function(module, exports) {
$parcel$export(module.exports, "getDefinitionId", () => $cc0b996fd0e20929$export$46fa3e7718c82e41);
const $cc0b996fd0e20929$export$46fa3e7718c82e41 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};

});

parcelRegister("gy3md", function(module, exports) {
$parcel$export(module.exports, "getExtensionKey", () => $d4b1754c5ff71a4c$export$218d96312e385949);
const $d4b1754c5ff71a4c$export$218d96312e385949 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key;
};

});

parcelRegister("bIXTN", function(module, exports) {
$parcel$export(module.exports, "getServices", () => $8f00530fb30f2785$export$a009e3a1163d46fb);
const $8f00530fb30f2785$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];

});

parcelRegister("fwvcj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e5dcec6525f37e9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $7wYyA = parcelRequire("7wYyA");

var $1kLa3 = parcelRequire("1kLa3");

var $kPTTD = parcelRequire("kPTTD");
const $3e5dcec6525f37e9$var$FLAG_ICON_SIZE = '16px';
const $3e5dcec6525f37e9$var$renderIcon = (iconUrlOrElement)=>{
    if (!iconUrlOrElement) return;
    const icon = iconUrlOrElement && typeof iconUrlOrElement === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1kLa3.default), {
        height: $3e5dcec6525f37e9$var$FLAG_ICON_SIZE,
        testId: "sl-flag",
        url: iconUrlOrElement,
        width: $3e5dcec6525f37e9$var$FLAG_ICON_SIZE
    }) : iconUrlOrElement;
    return icon;
};
// Safe wrapper — returns null if IntlProvider is not in the tree
const $3e5dcec6525f37e9$var$useIntlSafe = ()=>{
    try {
        return (0, $4vLTk.default)();
    } catch  {
        return null;
    }
};
const $3e5dcec6525f37e9$var$useActionFlags = ()=>{
    const intl = $3e5dcec6525f37e9$var$useIntlSafe();
    const showConnectFlag = (0, $bSJIT.useCallback)(({ provider: provider, ...flagArgs } = {})=>{
        if (!intl) return;
        const context = (provider === null || provider === void 0 ? void 0 : provider.text) ?? intl.formatMessage((0, $7wYyA.messages).connect_link_account_success_flag_title_default);
        (0, $kPTTD.showFlag)({
            icon: $3e5dcec6525f37e9$var$renderIcon(provider === null || provider === void 0 ? void 0 : provider.icon),
            title: intl.formatMessage((0, $7wYyA.messages).connect_link_account_success_flag_title, {
                context: context
            }),
            description: intl.formatMessage((0, $7wYyA.messages).connect_link_account_success_flag_description),
            ...flagArgs
        });
    }, [
        intl
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            showConnectFlag: showConnectFlag
        }), [
        showConnectFlag
    ]);
};
var $3e5dcec6525f37e9$export$2e2bcd8739ae039 = $3e5dcec6525f37e9$var$useActionFlags;

});
parcelRegister("7wYyA", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ad59d75840367c5d$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ad59d75840367c5d$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: 'Title for a section or menu containing available actions for a resource.'
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Button label that allows the user to add and connect a new external account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summary_error_generic_rebrand: {
        id: 'fabric.linking.ai_summary_error_generic_rebrand',
        defaultMessage: "Rovo isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    change_status: {
        id: 'fabric.linking.change_status',
        defaultMessage: 'Change status: {status}',
        description: 'Aria label for the button to change the status of a linked resource.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel the current action or close the modal.'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Text shown in a lozenge badge on a smart link or card to indicate the feature is currently in beta.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: 'Label for a button or icon that closes the currently open modal dialog or overlay screen.'
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Heading shown at the top of the link safety warning modal, prompting the user to verify a potentially unsafe link before proceeding.'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}',
        description: 'Indicates the number of components the resource is applied to.'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_link_account_embed_carousel_dot_label: {
        id: 'fabric.linking.connect_link_account_embed_carousel_dot_label.non-final',
        defaultMessage: 'Go to slide {index} of {total}',
        description: 'Accessible label for a dot indicator button in the teaser carousel, describing which slide it navigates to'
    },
    connect_link_account_embed_carousel_dot_row_label: {
        id: 'fabric.linking.connect_link_account_embed_carousel_dot_row_label.non-final',
        defaultMessage: 'Slides',
        description: 'Accessible label for the group of dot indicator buttons in the teaser carousel'
    },
    connect_link_account_embed_carousel_button_next: {
        id: 'fabric.linking.connect_link_account_embed_carousel_button_next.non-final',
        defaultMessage: 'Next',
        description: 'A button to view next teaser on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_sl_description: {
        id: 'fabric.linking.connect_link_account_embed_carousel_sl_description.non-final',
        defaultMessage: `Embed live previews of {context, select,
				Google {Google Docs, Sheets, and Slides}
				other {{context}}} {product, select,
				BITBUCKET {right inside Bitbucket}
				CONFLUENCE {right inside Confluence and Jira}
				JIRA {right inside Confluence and Jira}
				TRELLO {right inside Trello}
				other {across Atlassian}}.`,
        description: "A description on a teaser slide 1 on benefit of connecting account on Smart Link embed. Example Google+CONFLUENCE: Embed live previews of Google Docs, Sheets, and Slides right inside Confluence and Jira. Example Google+TRELLO: Embed live previews of Google Docs, Sheets, and Slides right inside Trello. Example other+TRELLO: Embed live previews of Figma right inside Trello. Example other+other: Embed live previews of Figma across Atlassian."
    },
    connect_link_account_embed_carousel_sl_title: {
        id: 'fabric.linking.connect_link_account_embed_carousel_sl_title.non-final',
        defaultMessage: 'Turn smart links into rich previews',
        description: 'A title on a teaser slide 1 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_rovo_title: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovo_title.non-final',
        defaultMessage: 'Find everything in one search',
        description: 'A title on a teaser slide 2 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_rovo_description: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovo_description.non-final',
        defaultMessage: `Access {context} files alongside your work in {product, select,
				BITBUCKET {Bitbucket}
				CONFLUENCE {Confluence and Jira}
				JIRA {Confluence and Jira}
				TRELLO {Trello}
				other {Atlassian}}. We'll always respect your {context} permissions.`,
        description: "A description on a teaser slide 2 on benefit of connecting account on Smart Link embed. Example Figma+JIRA: Access Figma files alongside your work in Confluence and Jira. We'll always respect your Figma permissions. Example Figma+BITBUCKET: Access Figma files alongside your work in Bitbucket. We'll always respect your Figma permissions. Example Figma+other: Access Figma files alongside your work in Atlassian. We'll always respect your Figma permissions."
    },
    connect_link_account_embed_carousel_rovochat_title: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovochat_title.non-final',
        defaultMessage: 'Get help from Rovo',
        description: 'A title on a teaser slide 3 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_rovochat_description: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovochat_description.non-final',
        defaultMessage: "Rovo uses your {context} content to answer questions, summarise docs, and draft updates using the work you\u2019ve already done.",
        description: 'A description on a teaser slide 3 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_success_flag_description: {
        id: 'fabric.linking.connect_link_account_success_flag_description',
        defaultMessage: 'Shared links now display rich previews.',
        description: 'Shown in a flag after user successfully connect 3P account and Smart Link reload with metadata'
    },
    connect_link_account_success_flag_title: {
        id: 'fabric.linking.connect_link_account_success_flag_title',
        defaultMessage: '{context} is connected',
        description: 'Shown in a flag after user successfully connect 3P account. {context} is the name of link provider, e.g. Google, Figma, etc.'
    },
    connect_link_account_success_flag_title_default: {
        id: 'fabric.linking.connect_link_account_success_flag_title_default',
        defaultMessage: 'Smart Link',
        description: 'Default context for connect_link_account_success_flag_title when link provider name (Google, Figma, etc.) is not provided'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_3p_account: {
        id: 'fabric.linking.connect_3p_account.non-final',
        defaultMessage: 'Connect {context}',
        description: 'Shown on a button to connect user external 3P account to their Atlassian account, e.g. Connect Figma'
    },
    connect_inline_provider_to_update: {
        id: 'fabric.linking.connect_inline_provider_to_update.ai-non-final',
        defaultMessage: 'Connect {context} to update',
        description: 'Text shown on the connect button of an unauthorised inline Smart Link. {context} is replaced with the provider name, and update means updating the Smart Link preview after the account is connected.'
    },
    connect_inline_social_proof: {
        id: 'fabric.linking.connect_inline_social_proof',
        defaultMessage: 'Connect',
        description: 'Shown on a button for unauthorised inline smart links when the social proof inline CTA experiment is active. Replaces the longer "Connect your {context} account" label.'
    },
    connect_inline_to_update: {
        id: 'fabric.linking.connect_inline_to_update.ai-non-final',
        defaultMessage: 'Connect to update',
        description: 'Text shown on the connect button of an unauthorised inline Smart Link. It prompts the user to connect an account, and update means updating the Smart Link preview.'
    },
    social_proof_inline_cta_tag_high_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_with_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees {context} previews',
        description: 'Social-proof tag pill beside the shortcut "Connect" on an unauthorised inline smart link when adoption is not in the exploratory range. {connectedPct} is the approximate share seeing previews for the integration; {context} is the provider display name.'
    },
    social_proof_inline_cta_tag_high_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_no_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees richer previews',
        description: 'Social-proof tag pill when adoption is above the exploratory threshold and no provider display name is available; {connectedPct} is the approximate share seeing richer previews.'
    },
    social_proof_inline_cta_tag_low_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_with_context',
        defaultMessage: 'Your team sees richer {context} previews',
        description: 'Social-proof tag pill when share is below the percentage headline threshold; shown only when a provider display name is available. Omit the pill entirely when personalization is unavailable or the provider name is unknown.'
    },
    social_proof_inline_cta_tag_low_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_no_context',
        defaultMessage: 'Your team sees richer previews',
        description: 'Social-proof tag pill for the case when neither percentage nor provider display name are available.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'Label for a button that advances the user to the next step, e.g. in the link safety warning modal flow.'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: 'Action to copy the URL of the link to the clipboard.'
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly after the user copies a URL to the clipboard using the copy link action.'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Label for the delete action in a smart link or card action menu, allowing the user to remove the linked item.'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: 'Label for the download action in a smart link or card action menu, initiating a file download.'
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: "Tooltip or description text for the download action, explaining it saves the file to the user's local storage."
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Label for the download file action in a smart link or card action menu, allowing the user to save the linked file locally.'
    },
    ai_summary_action_rebrand: {
        id: 'fabric.linking.ai_summary_action_rebrand',
        defaultMessage: 'Summarize with Rovo',
        description: 'Label for the AI summarize action in a smart link or hover card action menu, allowing the user to generate an AI summary of the linked content.'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    ai_summary_action_description_rebrand: {
        id: 'fabric.linking.ai_summary_action_description_rebrand',
        defaultMessage: 'Summarize the content of this link using Rovo.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Label for the edit action in a smart link or card action menu, allowing the user to modify the linked item.'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Label for the follow button on a smart link card, allowing the user to subscribe to updates for the linked project or resource.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Tooltip or description text for the follow project button, explaining that clicking it enables notifications for the project.'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Label for the follow project button on a smart link card, allowing the user to subscribe to updates for the linked Atlassian project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Tooltip or description text for the follow goal button, explaining that clicking it enables notifications for updates to the goal.'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Label for the follow goal button on a smart link card, allowing the user to subscribe to updates for the linked Atlas goal.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'Label for a navigation button that returns the user to the previous step or screen in a modal flow.'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira issue in Jira.'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Label for the action button on a smart link card that opens the linked resource in a new browser tab.'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Tooltip or description text for the preview action on a smart link card, explaining it opens a full-screen embed preview of the linked content.'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Label for the button that closes the embed preview modal dialog on a smart link card.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Blocker priority.'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Critical priority.'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has High priority.'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Highest priority.'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Low priority.'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Lowest priority.'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Major priority.'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Medium priority.'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Minor priority.'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Trivial priority.'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Label for a priority badge on a Jira issue smart link card when the priority level is not defined or unknown.'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Text shown on a smart link card displaying the estimated reading time. The placeholder {context} is substituted with the number of minutes.'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Label for a retry button shown on a smart link card after an error, allowing the user to attempt the failed action again.'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: "Label for a save button on a smart link card or action, confirming and persisting the user's changes."
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Label for a button shown on a smart link error state, prompting the user to retry the failed load or action.'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Warning message shown in the link safety modal. The placeholder {unsafeLinkText} is substituted with the suspicious link text, and <a> wraps the actual destination URL.'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    rovo_actions_explore: {
        id: 'fabric.linking.rovo_actions_explore-non-final',
        defaultMessage: 'Explore',
        description: 'Label for the Rovo Actions button that allows users to explore AI actions for a link'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Label for the unfollow button on a smart link card, allowing the user to stop receiving updates for the linked project or resource.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Tooltip or description for the unfollow project button, explaining that clicking it stops project update notifications.'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Label for the unfollow project button on a smart link card, allowing the user to stop following the linked Atlassian project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Tooltip or description for the unfollow goal button, explaining that clicking it stops notifications for the linked Atlas goal.'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Label for the unfollow goal button on a smart link card, allowing the user to stop following the linked Atlas goal.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewInProvider: {
        id: 'fabric.linking.viewinprovider',
        defaultMessage: 'View in {providerName}',
        description: 'We have a link in our preview modals to the original document. This text tells the user where it will open'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'Generic error message shown on a smart link card when an unspecified error occurs and no more specific message is available.'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Heading shown in the related links modal when related links fail to load due to a network or server error.'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Heading shown in the related links modal when no related links are available for the current resource.'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira work item in Jira (issue term refresh variant).'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Text shown on a smart link card displaying the number of members in a team. The placeholder {context} is substituted with the member count.'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Tooltip or description for the follow space button (Galaxia variant), explaining that clicking it enables notifications for the Confluence space.'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Tooltip or description for the unfollow space button (Galaxia variant), explaining that clicking it stops notifications for the Confluence space.'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: 'fabric.linking.learn_more_about_connecting_account_experiment_short',
        defaultMessage: 'Turn your URLs into rich, interactive previews.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    rovo_summary_loading: {
        id: 'fabric.linking.rovo_summary.loading.non-final',
        defaultMessage: 'Rovo is thinking',
        description: 'Shown when a Rovo summary is loading, indicating that the AI is generating a summary for the user.'
    },
    ai_disclaimer: {
        id: 'fabric.linking.rovo_summary.ai_disclaimer.non-final',
        defaultMessage: 'Uses AI. Verify Results.',
        description: 'Shown on a Rovo summary to indicate that the summary was generated by AI and should be verified by the user for accuracy.'
    },
    rovo_unauthorised_title: {
        id: 'fabric.linking.rovo_unauthorised.title',
        defaultMessage: 'Get smarter workflows by connecting your {context} account',
        description: 'Banner headline in Rovo unauthorised hover card header. {context} is the third-party provider name (e.g. Google).'
    },
    rovo_unauthorised_title_no_provider: {
        id: 'fabric.linking.rovo_unauthorised.title_no_provider',
        defaultMessage: 'Get smarter workflows by connecting your account',
        description: 'Banner headline in Rovo unauthorised hover card header when the provider name is unknown.'
    },
    rovo_unauthorised_feature_clear_link_names: {
        id: 'fabric.linking.rovo_unauthorised.feature.clear_link_names',
        defaultMessage: 'Turn long URLs into clear link names',
        description: 'First feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_understand_linked_docs: {
        id: 'fabric.linking.rovo_unauthorised.feature.understand_linked_docs',
        defaultMessage: 'Understand linked docs in seconds',
        description: 'Second feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_go_deeper_smart_suggestions: {
        id: 'fabric.linking.rovo_unauthorised.feature.go_deeper_smart_suggestions',
        defaultMessage: 'Go deeper with smart suggestions',
        description: 'Third feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_connect_account: {
        id: 'fabric.linking.rovo_unauthorised.connect_account',
        defaultMessage: 'Connect',
        description: 'Primary action button in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_not_now: {
        id: 'fabric.linking.rovo_unauthorised.not_now',
        defaultMessage: 'Maybe later',
        description: 'Secondary action in Rovo unauthorised hover card.'
    },
    rovo_prompt_context_generic: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'page',
        description: 'The location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_generic_plural: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'pages',
        description: 'The site-wide location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'Confluence page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item.non-final',
        defaultMessage: 'Jira work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_message_summarize: {
        id: 'fabric.linking.rovo_prompt_message_summarize.non-final',
        defaultMessage: '<p>Summarize the main ideas and key points of <a>{url}</a> in 3-5 clear, complete bullet points (markdown list).</p><p>Preserve important details such as names, dates, and key decisions.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_button_ask_rovo.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'The name of the action to open Rovo Chat and ask a question in relation to current Smart Link'
    },
    rovo_prompt_message_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_message_ask_rovo_anything.non-final',
        defaultMessage: '`I have a question about this linked item` {url}',
        description: "The placeholder prompt message pre-filled in Rovo Chat input. {url} refers to the Smart Link URL. This is not auto-submitted \u2014 the user types their question."
    },
    rovo_prompt_button_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_button_highlight_relevant_content',
        defaultMessage: `Highlight what's relevant`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_message_highlight_relevant_content',
        defaultMessage: "<p>Based on this linked item (<a>{url}</a>) and the {context} I'm currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_trends',
        defaultMessage: `Identify key trends`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_trends',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key trends, anomalies, and headline numbers. Call out anything increasing/decreasing significantly, noteworthy comparisons, and any risks or opportunities the data suggests.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_points',
        defaultMessage: `Identify key points`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_points',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key points, proposals, and decisions. Focus on what someone skimming the deck should know in order to understand the main message.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_button_find_open_questions',
        defaultMessage: `Find open questions`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_message_find_open_questions',
        defaultMessage: "<p>Look at this <a>{url}</a> and list any open questions, unresolved decisions, or asks that still need follow\u2011up. Group them by owner if possible and keep it concise.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_key_highlights: {
        id: 'fabric.linking.rovo_prompt_button_key_highlights',
        defaultMessage: `Key highlights`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_key_highlights: {
        id: 'fabric.linking.rovo_prompt_message_key_highlights',
        defaultMessage: "<p>Based on this <a>{url}</a> and the page or ticket I\u2019m currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_chat_action_section_header: {
        id: 'fabric.linking.rovo_chat_action_section_header.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'Heading shown above the Rovo prompt action buttons in the smart link hover card, alongside the Rovo logo, to introduce the AI prompt suggestions.'
    },
    rovo_prompt_button_summarize_this: {
        id: 'fabric.linking.rovo_prompt_button_summarize_this.non-final',
        defaultMessage: 'Summarize this for me',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_ask_a_specific_question: {
        id: 'fabric.linking.rovo_prompt_button_ask_a_specific_question.non-final',
        defaultMessage: 'Ask a specific question',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_show_me_whats_relevant: {
        id: 'fabric.linking.rovo_prompt_button_show_me_whats_relevant.non-final',
        defaultMessage: `Show me what's relevant`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_summarize_document: {
        id: 'fabric.linking.rovo_prompt_message_summarize_document',
        defaultMessage: `<p>Summarize this doc <a>{url}</a> into a concise, easy-to-scan overview. Adapt to whatever the content is and focus on the main ideas, important decisions, key updates, and next steps, only include these if they exist; don't mention their absence. Avoid unnecessary detail, repetition, or formatting commentary. Write in plain language and optimize for a quick 5\u{2013}10 second read</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_message_summarize_presentation: {
        id: 'fabric.linking.rovo_prompt_message_summarize_presentation',
        defaultMessage: `<p>Summarize this Google Slides deck <a>{url}</a> into a concise executive overview. Focus on the tldr, key findings, decisions, metrics, risks, and next steps, if there are any. Use a short executive summary followed by 2-3 bullet points. Avoid slide-by-slide narration, design details, repetition, and filler.</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_explain_code: {
        id: 'fabric.linking.rovo_prompt_button_explain_code',
        defaultMessage: `Explain`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_explain_code: {
        id: 'fabric.linking.rovo_prompt_message_explain_code',
        defaultMessage: `<p>Explain this code, pull request, or commit <a>{url}</a> in clear, plain language for a non-technical audience.</p><p>Cover:</p><ol><li><strong>Purpose</strong> \u{2014} What problem does it solve or what goal does it achieve?</li><li><strong>How it works</strong> \u{2014} High-level mechanics (no implementation detail unless critical to understanding).</li><li><strong>Why</strong> \u{2014} Motivation for the change or design choice.</li><li><strong>Impact</strong> \u{2014} Key behavior changes, risks, or downstream effects worth noting.</li></ol><p>Constraints:</p><ul><li>3\u{2013}5 sentences or 100\u{2013}150 words max.</li><li>Omit sections with nothing meaningful to say.</li><li>Prefer concrete language over abstract descriptions (e.g., "speeds up page load by caching results" over "improves performance").</li></ul>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_catch_up: {
        id: 'fabric.linking.rovo_prompt_button_catch_up',
        defaultMessage: `Catch up`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_catch_up: {
        id: 'fabric.linking.rovo_prompt_message_catch_up',
        defaultMessage: `<p>Catch me up on the latest {provider} conversations or channel activity in <a>{url}</a> from the last two weeks. If there's no activity in the past two weeks, expand the window to the most recent 30 days (or until meaningful activity is found). Summarize the most important updates, decisions, and discussions so the user can quickly understand what they missed. Focus on key changes, unresolved questions, and any action items or follow-ups. Prioritize recent messages with the most activity. Keep the response concise \u{2014} ideally 80\u{2013}150 words or a short set of 3\u{2013}5 key bullets.</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. {provider} is the 3P app name (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_button_salesforce_prep',
        defaultMessage: `Prep`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_message_salesforce_prep',
        defaultMessage: `<p>Prep me for this Salesforce record <a>{url}</a>. What's the current state, what's the recent activity, what risks or opportunities should I be aware of, and what would be useful to know before a conversation about it?</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    // TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    pre_auth_block_social_proof_not_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_not_low',
        defaultMessage: '<b>{percentage}%</b> of your team sees <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when 30% or more of the tenant has connected the provider. {percentage} is a number, {provider} is the 3P app name (e.g. OneDrive).'
    },
    pre_auth_block_social_proof_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_low',
        defaultMessage: 'Your team sees richer <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when less than 30% of the tenant has connected the provider. {provider} is the 3P app name (e.g. OneDrive).'
    }
});

});

parcelRegister("1kLa3", function(module, exports) {
$parcel$export(module.exports, "default", () => $44501f3edcaf19c5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $ktg9Z = parcelRequire("ktg9Z");

var $18x1K = parcelRequire("18x1K");
const $44501f3edcaf19c5$var$styles = {
    roundImg: "_2rko1rr0"
};
const $44501f3edcaf19c5$var$ImageIcon = ({ label: label, defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $bSJIT.useState)(false);
    // If url changes, reset state
    (0, $bSJIT.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ $bSJIT.createElement("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: (label === null || label === void 0 ? void 0 : label.trim()) ?? '',
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $9fU1q.default)([
            appearance === 'round' && $44501f3edcaf19c5$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ktg9Z))), {
        src: url,
        loading: /*#__PURE__*/ $bSJIT.createElement((0, $18x1K.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ $bSJIT.createElement("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: (label === null || label === void 0 ? void 0 : label.trim()) ?? '',
            style: {
                width: width,
                height: height
            },
            className: (0, $9fU1q.default)([
                appearance === 'round' && $44501f3edcaf19c5$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $44501f3edcaf19c5$export$2e2bcd8739ae039 = $44501f3edcaf19c5$var$ImageIcon;

});
parcelRegister("ktg9Z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ee730d241da97f38$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $bSJIT = parcelRequire("bSJIT");
var $ee730d241da97f38$var$React = $ee730d241da97f38$var$_interopRequireWildcard($bSJIT);
function $ee730d241da97f38$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ee730d241da97f38$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ee730d241da97f38$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ee730d241da97f38$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $ee730d241da97f38$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $ee730d241da97f38$var$loaded() {
    return {
        isLoaded: true
    };
}
function $ee730d241da97f38$var$errored() {
    return {
        isErrored: true
    };
}
function $ee730d241da97f38$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $ee730d241da97f38$var$ImageRenderer = function(_React$Component) {
    $ee730d241da97f38$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $ee730d241da97f38$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $ee730d241da97f38$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($ee730d241da97f38$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($ee730d241da97f38$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $ee730d241da97f38$var$_possibleConstructorReturn(_this, _ret);
    }
    $ee730d241da97f38$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($ee730d241da97f38$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($ee730d241da97f38$var$hasPropsChanged(this.props, nextProps)) this.setState($ee730d241da97f38$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($ee730d241da97f38$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($ee730d241da97f38$var$React.Component);
module.exports.default = $ee730d241da97f38$var$ImageRenderer;

});

parcelRegister("18x1K", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $da626482f1c71ef7$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $da626482f1c71ef7$var$animationNameStyles = null;
const $da626482f1c71ef7$var$loadingSkeletonStyle = null;
const $da626482f1c71ef7$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $9fU1q.default)([
            "_2rkolb4i _uiztglyw _bfhkvkf5 _1itkfj9x _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("kPTTD", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $fd9d8014287dbc37$export$e12b2cc6b75b006b);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [flagGroupState, pendingFirstRender, root]; splitting would fork the singleton and is forbidden by TS2632 */ /**
 * Smart Link flag module — imperative singleton pattern.
 *
 * ## Why not a React context provider?
 *
 * The natural approach would be to render a `<FlagProvider>` inside the Card
 * component tree, managing flag state via React context. This was the original
 * implementation. However, it caused a critical bug:
 *
 * When a parent component of smart card changed, either swap or unmount,
 * it unmounts the entire card subtree including `FlagsProvider`.
 * Any flag that was visible at that moment is instantly destroyed and lost.
 *
 * ## Why an injected React root?
 *
 * This module manages a persistent `FlagGroup` at `document.body` via its own
 * `createRoot` — completely independent of any card component tree. The root is created
 * lazily on the first `showFlag` call and kept alive indefinitely, re-rendering with
 * the current flags array on every change.
 *
 * Benefits:
 * - Flags survive any card unmount/remount cycle
 * - No provider needed anywhere in the component tree
 * - Works identically for all card paths (Card, CardSSR)
 * - Same pattern as `EmbedModal/utils.tsx` but for a persistent group
 *
 * Usage: import `showFlag` and call it directly — no provider needed.
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $ltkSJ = parcelRequire("ltkSJ");

var $dTM5i = parcelRequire("dTM5i");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $lJzMO = parcelRequire("lJzMO");

var $g5N06 = parcelRequire("g5N06");
const $fd9d8014287dbc37$var$FLAG_GROUP_MOUNT_POINT_ID = 'smart-link-flags-mount';
// ---------------------------------------------------------------------------
// Module-level singleton state
// Lives for the entire page session — independent of any React component tree.
//
// The sequence:
// 1. ensureRoot()
//    └── flushSync(() => root.render(<empty FlagGroup>))
//        └── ExitingPersistence mounts with appear=false
//        └── pendingFirstRender = true
//
// 2. showFlag() detects pendingFirstRender=true
//    └── pendingFirstRender = false
//    └── setTimeout(0, () => renderToRoot())
//        ← deferred: runs AFTER useEffect fires
//
// 3. [async] ExitingPersistence's useEffect fires
//    └── appear flips false → true
//
// 4. [async] setTimeout(0) fires → renderToRoot()
//    └── FlagGroup receives flag as new child
//    └── ExitingPersistence sees new child with appear=true → ANIMATES
// ---------------------------------------------------------------------------
let $fd9d8014287dbc37$var$flagGroupState = [];
let $fd9d8014287dbc37$var$root = null;
// True after ensureRoot() creates a new root but before ExitingPersistence's useEffect
// has flipped `appear` to true. While pending, the first renderToRoot is deferred via
// setTimeout so that the enter animation fires correctly.
let $fd9d8014287dbc37$var$pendingFirstRender = false;
const $fd9d8014287dbc37$var$removeFlag = (id)=>{
    $fd9d8014287dbc37$var$flagGroupState = $fd9d8014287dbc37$var$flagGroupState.filter((f)=>f.id !== id);
    $fd9d8014287dbc37$var$renderToRoot();
};
const $fd9d8014287dbc37$var$renderToRoot = ()=>{
    if (!$fd9d8014287dbc37$var$root) return;
    $fd9d8014287dbc37$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lJzMO.default), {
        onDismissed: $fd9d8014287dbc37$var$removeFlag
    }, $fd9d8014287dbc37$var$flagGroupState.map((flagProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g5N06.default), {
            borderRadius: 'large',
            isVisible: true,
            key: flagProps.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eJ0Uu.default), {
            ...flagProps,
            key: flagProps.id
        }));
    }))));
};
const $fd9d8014287dbc37$var$ensureRoot = ()=>{
    if ($fd9d8014287dbc37$var$root !== null || typeof document === 'undefined') return;
    let container = document.getElementById($fd9d8014287dbc37$var$FLAG_GROUP_MOUNT_POINT_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = $fd9d8014287dbc37$var$FLAG_GROUP_MOUNT_POINT_ID;
        document.body.appendChild(container);
    }
    $fd9d8014287dbc37$var$root = (0, $ltkSJ.createRoot)(container);
    const locale = typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en';
    // Render an empty FlagGroup immediately so React has a "before" state to diff against.
    // Without this, the first flag has no previous render to compare to — React mounts it
    // directly and the FlagGroup animation library sees it as "already present" rather than
    // "just entered", skipping the slide-in animation.
    // Subsequent flags always have the previous (possibly empty) render to diff against,
    // which is why they animate correctly.
    const renderEmptyFlagGroup = ()=>$fd9d8014287dbc37$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lJzMO.default), {
            onDismissed: $fd9d8014287dbc37$var$removeFlag
        })));
    // Use flushSync to synchronously commit an empty FlagGroup before any flag is added.
    // This mounts ExitingPersistence (inside FlagGroup) in an empty state so that when the
    // first flag arrives (deferred via setTimeout below), ExitingPersistence recognises it
    // as a genuinely new child and runs the slide-in animation.
    try {
        (0, $4Sf72.flushSync)(renderEmptyFlagGroup);
    } catch  {
        // flushSync cannot be called during React rendering or from a lifecycle (e.g. useEffect).
        // We try it and fall back to a regular async render if React throws — in that case the
        // first flag may appear without a slide-in animation, but all subsequent flags will
        // animate correctly (ExitingPersistence will have mounted and flipped appear=true by then).
        renderEmptyFlagGroup();
    }
    // After flushSync commits the empty FlagGroup, ExitingPersistence's useEffect runs
    // asynchronously to flip `appear` from false → true (enabling enter animations).
    // We store a pending flag to signal that the first renderToRoot should be deferred.
    $fd9d8014287dbc37$var$pendingFirstRender = true;
};
const $fd9d8014287dbc37$export$e12b2cc6b75b006b = (options)=>{
    const flagProps = {
        ...options,
        id: options.id || crypto.randomUUID()
    };
    const index = $fd9d8014287dbc37$var$flagGroupState.findIndex((f)=>f.id === flagProps.id);
    if (index === -1) $fd9d8014287dbc37$var$flagGroupState = [
        flagProps,
        ...$fd9d8014287dbc37$var$flagGroupState
    ];
    else $fd9d8014287dbc37$var$flagGroupState = $fd9d8014287dbc37$var$flagGroupState.map((f, i)=>i === index ? flagProps : f);
    $fd9d8014287dbc37$var$ensureRoot();
    if ($fd9d8014287dbc37$var$pendingFirstRender) {
        // ensureRoot() just created a new root and committed an empty FlagGroup via flushSync.
        // ExitingPersistence's useEffect (which flips `appear` false→true) runs asynchronously
        // after the commit. We defer renderToRoot via setTimeout(0) to ensure that useEffect
        // has already fired before the flag is added — only then will ExitingPersistence
        // treat it as a new entering child and run the slide-in animation.
        $fd9d8014287dbc37$var$pendingFirstRender = false;
        setTimeout(()=>{
            $fd9d8014287dbc37$var$renderToRoot();
        }, 0);
    } else $fd9d8014287dbc37$var$renderToRoot();
};
const $fd9d8014287dbc37$export$3dd8302481493c99 = ()=>{
    $fd9d8014287dbc37$var$flagGroupState = [];
    $fd9d8014287dbc37$var$pendingFirstRender = false;
    if ($fd9d8014287dbc37$var$root) {
        $fd9d8014287dbc37$var$root.unmount();
        $fd9d8014287dbc37$var$root = null;
    }
    if (typeof document !== 'undefined') {
        var _document$getElementB;
        (_document$getElementB = document.getElementById($fd9d8014287dbc37$var$FLAG_GROUP_MOUNT_POINT_ID)) === null || _document$getElementB === void 0 || _document$getElementB.remove();
    }
};

});
parcelRegister("ltkSJ", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $fa1c811b0224f676$export$882461b6382ed46c, (v) => $fa1c811b0224f676$export$882461b6382ed46c = v);
var $fa1c811b0224f676$export$882461b6382ed46c;
var $fa1c811b0224f676$export$757ceba2d55c277e;
'use strict';

var $4Sf72 = parcelRequire("4Sf72");
var $fa1c811b0224f676$var$i;
$fa1c811b0224f676$export$882461b6382ed46c = $4Sf72.createRoot;
$fa1c811b0224f676$export$757ceba2d55c277e = $4Sf72.hydrateRoot;

});

parcelRegister("g5N06", function(module, exports) {
$parcel$export(module.exports, "default", () => $78b6e061192bcebf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $ceb9s = parcelRequire("ceb9s");

var $837mP = parcelRequire("837mP");

var $k10eE = parcelRequire("k10eE");
const $78b6e061192bcebf$var$contentStyles = null;
const $78b6e061192bcebf$var$contentStylesPrismVisible = null;
const $78b6e061192bcebf$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $78b6e061192bcebf$var$borderRadiusStyles = {
    large: "_2rko1mok",
    small: "_2rko12b0"
};
const $78b6e061192bcebf$var$popupContainerStyles = null;
const $78b6e061192bcebf$var$AIPrism = ({ borderRadius: borderRadius, children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $ceb9s.useThemeObserver)();
    return /*#__PURE__*/ $bSJIT.createElement((0, $837mP.default), {
        palette: (0, $k10eE.AI_BORDER_PALETTE)[colorMode] ?? (0, $k10eE.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $9fU1q.default)([
            $78b6e061192bcebf$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false'],
            borderRadius && $78b6e061192bcebf$var$borderRadiusStyles[borderRadius]
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $78b6e061192bcebf$export$2e2bcd8739ae039 = $78b6e061192bcebf$var$AIPrism;

});
parcelRegister("837mP", function(module, exports) {
$parcel$export(module.exports, "default", () => $0edbfe2d56eef015$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $dFayp = parcelRequire("dFayp");
const $0edbfe2d56eef015$var$borderContainerStyles = null;
const $0edbfe2d56eef015$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $0edbfe2d56eef015$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dFayp.default), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $bSJIT.createElement((0, $dFayp.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
var $0edbfe2d56eef015$export$2e2bcd8739ae039 = $0edbfe2d56eef015$var$AIGlowingBorder;

});
parcelRegister("dFayp", function(module, exports) {
$parcel$export(module.exports, "default", () => $48b8197c0c1767d1$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
let $48b8197c0c1767d1$var$namespaceUUID = 0;
const $48b8197c0c1767d1$var$svgStyles = null;
const $48b8197c0c1767d1$var$blurredStyles = null;
const $48b8197c0c1767d1$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $48b8197c0c1767d1$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $bSJIT.useRef)(null);
    const namespaceId = (0, $bSJIT.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $48b8197c0c1767d1$var$namespaceUUID;
        $48b8197c0c1767d1$var$namespaceUUID += 1;
    }
    (0, $bSJIT.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $bSJIT.createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $bSJIT.createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $bSJIT.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $bSJIT.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $48b8197c0c1767d1$export$2e2bcd8739ae039 = $48b8197c0c1767d1$var$AnimatedSvgContainer;

});


parcelRegister("k10eE", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $300a995d9f087651$export$23b7b83c7063ccfe);
const $300a995d9f087651$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $300a995d9f087651$export$23b7b83c7063ccfe = {
    dark: {
        blue: $300a995d9f087651$export$3088ed82e2905d1e.blue800,
        teal: $300a995d9f087651$export$3088ed82e2905d1e.teal500,
        yellow: $300a995d9f087651$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $300a995d9f087651$export$3088ed82e2905d1e.blue600,
        teal: $300a995d9f087651$export$3088ed82e2905d1e.teal300,
        yellow: $300a995d9f087651$export$3088ed82e2905d1e.yellow200
    }
};

});




parcelRegister("2AqEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e6b77c2a8061d5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $gdUUy = parcelRequire("gdUUy");

var $2fwRK = parcelRequire("2fwRK");

var $s9hBp = parcelRequire("s9hBp");

var $k27DD = parcelRequire("k27DD");

var $iq8lm = parcelRequire("iq8lm");

var $jERMp = parcelRequire("jERMp");

var $dXrim = parcelRequire("dXrim");
const $68e6b77c2a8061d5$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $68e6b77c2a8061d5$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $bSJIT.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, prompt: prompt, interactionSource: interactionSource, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, $7RHfd.default)();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        (0, $k27DD.mark)(markName, 'pending');
        try {
            var _getMeasure;
            // Begin UFO experience
            (0, $jERMp.startUfoExperience)($68e6b77c2a8061d5$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType,
                prompt: prompt,
                ...(0, $gdUUy.fg)('platform_sl_one_click_chat_spotlight_v2_fg') && actionSubjectId === 'rovoChatPrompt' && interactionSource ? {
                    interactionSource: interactionSource
                } : {}
            });
            // Invoke action
            const result = await actionFn();
            (0, $k27DD.mark)(markName, 'resolved');
            (0, $dXrim.succeedUfoExperience)($68e6b77c2a8061d5$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_getMeasure = (0, $s9hBp.getMeasure)(markName, 'resolved')) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            var _getMeasure2;
            (0, $k27DD.mark)(markName, 'errored');
            (0, $iq8lm.failUfoExperience)($68e6b77c2a8061d5$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err === null || err === void 0 ? void 0 : err.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_getMeasure2 = (0, $s9hBp.getMeasure)(markName, 'errored')) === null || _getMeasure2 === void 0 ? void 0 : _getMeasure2.duration) ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $68e6b77c2a8061d5$export$2e2bcd8739ae039 = $68e6b77c2a8061d5$var$useInvokeClientAction;

});
parcelRegister("iq8lm", function(module, exports) {
$parcel$export(module.exports, "failUfoExperience", () => $3fc375094742eda2$export$8dda83bafca11b77);

var $2tD6h = parcelRequire("2tD6h");
const $3fc375094742eda2$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = (0, $2tD6h.ufoExperiences)[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};

});

parcelRegister("dXrim", function(module, exports) {
$parcel$export(module.exports, "succeedUfoExperience", () => $70b27204ca6c3bf6$export$c5a5cf072c836c0e);

var $2tD6h = parcelRequire("2tD6h");
const $70b27204ca6c3bf6$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = (0, $2tD6h.ufoExperiences)[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};

});


parcelRegister("1Nceg", function(module, exports) {
$parcel$export(module.exports, "default", () => $130f3019bc924617$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4gDvk = parcelRequire("4gDvk");

var $6bOBo = parcelRequire("6bOBo");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $84tHI = parcelRequire("84tHI");

var $796PN = parcelRequire("796PN");
const $130f3019bc924617$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $6bOBo.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $796PN.default)();
    return (0, $bSJIT.useCallback)(async (params)=>{
        const { url: url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, id: id = '', appearance: appearance } = params;
        const isInlineResolveOptimizationEnabled = (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization');
        const isOptimizedBlockRequest = appearance === 'block' && isInlineResolveOptimizationEnabled;
        const { details: details, metadataStatus: currentMetadataStatus } = getState()[url] || {
            status: (0, $5kJPq.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $4gDvk.isEntityPresent)(details));
        const needsOptimizedBlockData = isOptimizedBlockRequest && currentMetadataStatus !== 'resolved';
        if (isReloading || !hasData || isMetadataRequest || needsOptimizedBlockData) {
            // ORS caches each appearance separately, so optimized block requests can reuse the
            // block cache. Preserve the existing replacement decision so a cached full response
            // still replaces any reduced inline data already in the store.
            const shouldReplaceExistingData = isReloading || needsOptimizedBlockData;
            const shouldForceFetch = isInlineResolveOptimizationEnabled ? isReloading : shouldReplaceExistingData;
            const metadataStatus = appearance === 'inline' && !isMetadataRequest && isInlineResolveOptimizationEnabled ? 'pending' : undefined;
            return connections.client.fetchData(url, shouldForceFetch, appearance).then((response)=>handleResolvedLinkResponse(url, response, shouldReplaceExistingData, isMetadataRequest, metadataStatus)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        } else (0, $84tHI.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $130f3019bc924617$export$2e2bcd8739ae039 = $130f3019bc924617$var$useResolve;

});
parcelRegister("84tHI", function(module, exports) {
$parcel$export(module.exports, "addMetadataToExperience", () => $87917bc5048c7d92$export$4084c0df4a03a6af);

var $2tD6h = parcelRequire("2tD6h");
const $87917bc5048c7d92$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    (0, $2tD6h.ufoExperiences)[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("796PN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6385f9c836182e5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $6bOBo = parcelRequire("6bOBo");

var $gUazh = parcelRequire("gUazh");

var $7M18D = parcelRequire("7M18D");

var $jSPcn = parcelRequire("jSPcn");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $8M23v = parcelRequire("8M23v");

var $9V3Aw = parcelRequire("9V3Aw");
const $f6385f9c836182e5$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $6bOBo.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $bSJIT.useCallback)((url, metadataStatus)=>{
        dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $bSJIT.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5kJPq.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_RESOLVED), {
            url: url
        }, (0, $8M23v.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $bSJIT.useCallback)((resourceUrl, response, isReloading, isMetadataRequest, metadataStatus = 'resolved')=>{
        var _getState$resourceUrl;
        /**
     * Metadata status scenarios:
     * - Gate off, or a non-resolved response: use `resolved`, preserving legacy behavior and
     *   avoiding a gate exposure when the result would not affect the status.
     * - Gate on with full metadata: use the provided/default `resolved` status.
     * - Gate on with reduced inline metadata: use the provided `pending` status so block or
     *   hover rendering knows to request the full metadata later.
     * - Reduced inline metadata arriving after full metadata: keep the existing `resolved`
     *   status so an out-of-order response cannot trigger another full request.
     * - Explicit reload: allow `pending` even after full metadata, because the caller is
     *   intentionally replacing the existing data.
     */ const shouldUseProvidedMetadataStatus = (0, $jSPcn.getStatus)(response) === 'resolved' && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization');
        const shouldPreserveResolvedMetadata = shouldUseProvidedMetadataStatus && metadataStatus === 'pending' && !isReloading && ((_getState$resourceUrl = getState()[resourceUrl]) === null || _getState$resourceUrl === void 0 ? void 0 : _getState$resourceUrl.metadataStatus) === 'resolved';
        const nextMetadataStatus = shouldUseProvidedMetadataStatus && !shouldPreserveResolvedMetadata ? metadataStatus : 'resolved';
        setMetadataStatus(resourceUrl, nextMetadataStatus);
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $gUazh.cardAction)((0, $gUazh.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $bSJIT.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest, metadataStatus)=>{
        if (!resourceUrl) return;
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $jSPcn.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $7M18D.APIError)('fallback', hostname, (0, $9V3Aw.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $7M18D.APIError)('fatal', hostname, (0, $9V3Aw.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $7M18D.APIError)('error', hostname, (0, $9V3Aw.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $4Sf72.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest, metadataStatus);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f6385f9c836182e5$export$2e2bcd8739ae039 = $f6385f9c836182e5$var$useResponse;

});
parcelRegister("8M23v", function(module, exports) {
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $9d234626d4b67fad$export$b9482e0f6d365cc7);

var $kr2in = parcelRequire("kr2in");
const $9d234626d4b67fad$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...(0, $kr2in.emptyData)
        }
    });

});
parcelRegister("kr2in", function(module, exports) {
$parcel$export(module.exports, "emptyData", () => $902f7b4a2530b50a$export$49de42a13d6e867c);
const $902f7b4a2530b50a$export$49de42a13d6e867c = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};

});


parcelRegister("9V3Aw", function(module, exports) {
$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $786954ec12eb36ee$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $786954ec12eb36ee$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $786954ec12eb36ee$export$338f7d9ccca1975d);
const $786954ec12eb36ee$export$297c39c8b9bfca0 = 'resolving';
const $786954ec12eb36ee$export$b64a888338c24e0e = 'errored';
const $786954ec12eb36ee$export$677b6edfa0002c70 = 'fallback';
const $786954ec12eb36ee$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $786954ec12eb36ee$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $786954ec12eb36ee$export$338f7d9ccca1975d = 'Error resolving metadata.';

});




parcelRegister("2lrWO", function(module, exports) {
$parcel$export(module.exports, "getResourceType", () => $8b938d73d790ee25$export$16c0ebb0de9b767b);
const $8b938d73d790ee25$export$16c0ebb0de9b767b = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.resourceType;
};

});

parcelRegister("2TtjQ", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $418c568b2dcae097$export$b0444d00ba7313c6);

var $9yiJm = parcelRequire("9yiJm");

var $6bOBo = parcelRequire("6bOBo");
const $418c568b2dcae097$var$PENDING_STATE = {
    status: 'pending'
};
function $418c568b2dcae097$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $6bOBo.useSmartLinkContext)();
    const cardState = (0, $9yiJm.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $418c568b2dcae097$var$PENDING_STATE;
}

});

parcelRegister("fuhlR", function(module, exports) {
$parcel$export(module.exports, "useScheduledRegister", () => $5502c8f7b850e815$export$db80d61271e4d5af);
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $bSJIT = parcelRequire("bSJIT");
const $5502c8f7b850e815$var$batchQueue = new Map();
const $5502c8f7b850e815$var$batchTimeouts = new Map();
const $5502c8f7b850e815$var$BATCH_DELAY = 250;
const $5502c8f7b850e815$var$executeBatch = (hostname)=>{
    const items = $5502c8f7b850e815$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $5502c8f7b850e815$var$batchQueue.delete(hostname);
    $5502c8f7b850e815$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $5502c8f7b850e815$var$addToBatch = (hostname, item)=>{
    if (!$5502c8f7b850e815$var$batchQueue.has(hostname)) $5502c8f7b850e815$var$batchQueue.set(hostname, []);
    $5502c8f7b850e815$var$batchQueue.get(hostname).push(item);
    if ($5502c8f7b850e815$var$batchTimeouts.has(hostname)) clearTimeout($5502c8f7b850e815$var$batchTimeouts.get(hostname));
    $5502c8f7b850e815$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $5502c8f7b850e815$var$executeBatch(hostname);
    }, $5502c8f7b850e815$var$BATCH_DELAY));
};
const $5502c8f7b850e815$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $bSJIT.useRef)(false);
    const scheduledRegister = (0, $bSJIT.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $5502c8f7b850e815$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};

});


parcelRegister("hmu85", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5f667b98dea05c4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1zOmw = parcelRequire("1zOmw");

var $hPV9a = parcelRequire("hPV9a");
const $f5f667b98dea05c4$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $bSJIT.useContext)((0, $1zOmw.SmartCardContext));
    return hasSmartCardProvider && (0, $hPV9a.shouldResolveUrl)(href);
};
var $f5f667b98dea05c4$export$2e2bcd8739ae039 = $f5f667b98dea05c4$var$useResolveHyperlinkValidator;

});
parcelRegister("hPV9a", function(module, exports) {
$parcel$export(module.exports, "shouldResolveUrl", () => $e07f3ec972d9c375$export$aa45d36a96427452);
const $e07f3ec972d9c375$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $e07f3ec972d9c375$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $e07f3ec972d9c375$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};

});


parcelRegister("jnYkh", function(module, exports) {
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $08682f429ff15cc5$export$eaff10f7ec59c455);

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $gdUUy = parcelRequire("gdUUy");

var $2TtjQ = parcelRequire("2TtjQ");

var $8AAWw = parcelRequire("8AAWw");
const $08682f429ff15cc5$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $2TtjQ.useSmartCardState)(url);
    const data = (0, $8AAWw.getSmartLinkAnalyticsContext)({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $gdUUy.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: data
    }, children);
};

});
parcelRegister("8AAWw", function(module, exports) {
$parcel$export(module.exports, "getSmartLinkAnalyticsContext", () => $10c6d6b0a1790b2c$export$5732565218b28467);

var $8Er4C = parcelRequire("8Er4C");

var $2hVNZ = parcelRequire("2hVNZ");
const $10c6d6b0a1790b2c$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2;
    return {
        definitionId: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId) ?? null,
        resourceType: (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.resourceType) ?? null,
        ...(0, $8Er4C.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    };
};
const $10c6d6b0a1790b2c$export$5732565218b28467 = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $10c6d6b0a1790b2c$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $2hVNZ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};

});
parcelRegister("8Er4C", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $2f42fe2431d83634$export$7243431f5325a7b);

var $jSPcn = parcelRequire("jSPcn");

var $gdUUy = parcelRequire("gdUUy");

var $ktiy4 = parcelRequire("ktiy4");
const $2f42fe2431d83634$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2, _details$meta3, _details$meta4, _details$meta5, _details$meta6, _details$meta7, _details$meta8, _details$meta9, _details$meta0, _details$meta1;
    const status = linkStatus ?? (details && (0, $jSPcn.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $ktiy4.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.requestAccess) === null || _details$meta === void 0 ? void 0 : _details$meta.accessType) ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $gdUUy.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key) ?? (error === null || error === void 0 ? void 0 : error.extensionKey) ?? null : (details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.key) ?? null,
        destinationTenantId: (details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.tenantId) ?? null,
        destinationActivationId: (details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.activationId) ?? null,
        destinationContainerId: (details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.containerId) ?? null,
        destinationCategory: (details === null || details === void 0 || (_details$meta7 = details.meta) === null || _details$meta7 === void 0 ? void 0 : _details$meta7.category) ?? null,
        destinationProduct: (details === null || details === void 0 || (_details$meta8 = details.meta) === null || _details$meta8 === void 0 ? void 0 : _details$meta8.product) ?? null,
        destinationSubproduct: (details === null || details === void 0 || (_details$meta9 = details.meta) === null || _details$meta9 === void 0 ? void 0 : _details$meta9.subproduct) ?? null,
        destinationObjectId: (details === null || details === void 0 || (_details$meta0 = details.meta) === null || _details$meta0 === void 0 ? void 0 : _details$meta0.objectId) ?? null,
        destinationObjectType: (details === null || details === void 0 || (_details$meta1 = details.meta) === null || _details$meta1 === void 0 ? void 0 : _details$meta1.resourceType) ?? null,
        canBeDatasource: ((details === null || details === void 0 ? void 0 : details.datasources) || []).length > 0
    };
};

});
parcelRegister("ktiy4", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $5bb1d2beda96bc36$export$28ddbae335bd80b5);
const $5bb1d2beda96bc36$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});




parcelRegister("2x5KE", function(module, exports) {
$parcel$export(module.exports, "isAuxClick", () => $cfff647fce76ed5d$export$15213acd7ac7d39a);
/**
 * Returns true for genuine middle-clicks (button === 1).
 * Filters out Windows right-clicks, which fire onAuxClick with button === 2
 * in addition to onContextMenu, to prevent double-counting.
 */ const $cfff647fce76ed5d$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};

});

parcelRegister("dMv9i", function(module, exports) {
$parcel$export(module.exports, "default", () => $6572ea22677b719a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");
/**
 * HOC to wrap component with IntlProvider if not available
 */ const $6572ea22677b719a$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props);
        return props !== null && props !== void 0 && props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
            locale: "en"
        }, content);
    };
var $6572ea22677b719a$export$2e2bcd8739ae039 = $6572ea22677b719a$var$withIntlProvider;

});

parcelRegister("g3zfH", function(module, exports) {
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $b2fd1a0f2c9cd71e$export$e682245dc886cff2);

var $6WltM = parcelRequire("6WltM");
function $b2fd1a0f2c9cd71e$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    return ({ isAuxClick: isAuxClick = false, isContextMenu: isContextMenu = false } = {})=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier,
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});


parcelRegister("a3uFO", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c6629ac8da8bd7c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");
var $dTM5i = parcelRequire("dTM5i");

var $hzFIQ = parcelRequire("hzFIQ");

var $9Rfip = parcelRequire("9Rfip");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $7wYyA = parcelRequire("7wYyA");
const $7c6629ac8da8bd7c$var$breakWordsCss = null;
const $7c6629ac8da8bd7c$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $bSJIT.createElement((0, $lFaAn.default), null, isOpen && /*#__PURE__*/ $bSJIT.createElement((0, $c9mVs.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $j4mCC.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $4TlNm.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).check_this_link))), /*#__PURE__*/ $bSJIT.createElement((0, $2w1u7.default), null, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $7wYyA.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $9Rfip.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $7HzAO.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).go_back)), /*#__PURE__*/ $bSJIT.createElement((0, $hzFIQ.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $bSJIT.createElement((0, $dTM5i.default), {
        locale: "en"
    }, content);
};
const $7c6629ac8da8bd7c$var$_default_1 = (0, $fK3tS.default)($7c6629ac8da8bd7c$var$WarningModal, {
    enforceContext: false
});
var $7c6629ac8da8bd7c$export$2e2bcd8739ae039 = $7c6629ac8da8bd7c$var$_default_1;

});

parcelRegister("chzxw", function(module, exports) {
$parcel$export(module.exports, "useLinkWarningModal", () => $7e5536b723f7cdc9$export$32b76c003683c2ec);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $gxUEW = parcelRequire("gxUEW");

var $2hVNZ = parcelRequire("2hVNZ");
const $7e5536b723f7cdc9$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $7e5536b723f7cdc9$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $bSJIT.useState)(null);
    const [url, setUrl] = (0, $bSJIT.useState)(null);
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $gxUEW.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $7e5536b723f7cdc9$var$toUrl(href, window.location.origin);
        const linkTextUrl = $7e5536b723f7cdc9$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = (hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin) === currentAtlassianProductOrigin && (linkTextUrl === null || linkTextUrl === void 0 ? void 0 : linkTextUrl.origin) === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("gxUEW", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $c82646c638754bb2$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $cAudd = parcelRequire("cAudd");

var $k2Cnk = parcelRequire("k2Cnk");

var $aTeLd = parcelRequire("aTeLd");
const $c82646c638754bb2$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $c82646c638754bb2$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $c82646c638754bb2$var$linkify = new (0, $cAudd.default)();
$c82646c638754bb2$var$linkify.add('sourcetree:', 'http:');
$c82646c638754bb2$var$linkify.add('jamfselfservice:', 'http:');
$c82646c638754bb2$var$linkify.add('notes:', 'http:');
$c82646c638754bb2$var$tlds.push($c82646c638754bb2$var$tlds2Char);
$c82646c638754bb2$var$linkify.tlds($c82646c638754bb2$var$tlds, false);
const $c82646c638754bb2$var$normaliseLinkHref = (url)=>{
    const match = $c82646c638754bb2$var$getLinkMatch(url);
    return match && match.url || null;
};
const $c82646c638754bb2$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = (0, $aTeLd.linkifyMatch)(str);
    if (!match || !match.length) match = $c82646c638754bb2$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
function $c82646c638754bb2$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ((0, $k2Cnk.isSafeUrl)(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $c82646c638754bb2$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("k2Cnk", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $0afa2a9db193b451$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $0afa2a9db193b451$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $0afa2a9db193b451$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $0afa2a9db193b451$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};

});

parcelRegister("aTeLd", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $73a092c91636b4f2$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $73a092c91636b4f2$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $73a092c91636b4f2$export$6f7d7761b97f967 = (text)=>{
    const matches = [];
    if (!$73a092c91636b4f2$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($73a092c91636b4f2$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($73a092c91636b4f2$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};

});





parcelRegister("2hs8I", function(module, exports) {
$parcel$export(module.exports, "LinkUrlEmotion", () => $c4d6b1a995f80a96$export$bcc8540ceca8fa1c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $9dQre = parcelRequire("9dQre");

var $3PvTq = parcelRequire("3PvTq");
function $c4d6b1a995f80a96$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c4d6b1a995f80a96$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
const $c4d6b1a995f80a96$export$bcc8540ceca8fa1c = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9dQre.jsx)((0, $3PvTq.LinkUrl), {
        css: $c4d6b1a995f80a96$var$anchorStyles,
        ...props
    });

});


parcelRegister("4Xvkv", function(module, exports) {
$parcel$export(module.exports, "default", () => $13bcde2a5f654f53$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $13bcde2a5f654f53$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("epMwc", function(module, exports) {
$parcel$export(module.exports, "default", () => $62ce867c645afe47$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $62ce867c645afe47$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $dc70d.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("fsGKm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cd90915096d169d$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $5cd90915096d169d$var$isSub = (type)=>{
    return type === 'sub';
};
function $5cd90915096d169d$export$2e2bcd8739ae039(props) {
    if ($5cd90915096d169d$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("2vGNV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1d25cddab1efcc3$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $8bHyz = parcelRequire("8bHyz");

var $8FtCL = parcelRequire("8FtCL");

var $ceb9s = parcelRequire("ceb9s");
function $a1d25cddab1efcc3$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $8FtCL.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $8FtCL.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $8bHyz.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $bSJIT.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("8FtCL", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $570de85ce2cbdc5d$export$9c2f408d391feb93);
// This import will be stripped on build

var $4zjoa = parcelRequire("4zjoa");
function $570de85ce2cbdc5d$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return normalizedHexColor ? $570de85ce2cbdc5d$export$57fa5089caad992[normalizedHexColor] : undefined;
}
const $570de85ce2cbdc5d$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)",
    // source for hex code was legacy token N800
    // lime
    /** lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** lime - medium */ ['#6A9A23']: "var(--ds-icon-accent-lime, #6A9A23)",
    /** lime - strong */ ['#4C6B1F']: "var(--ds-text-accent-lime, #4C6B1F)",
    // orange
    /** orange - light */ ['#FCE4A6']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** orange - medium */ ['#E06C00']: "var(--ds-icon-accent-orange, #E06C00)",
    /** orange - strong */ ['#9E4C00']: "var(--ds-text-accent-orange, #9E4C00)",
    // magenta
    /** magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** magenta - medium */ ['#CD519D']: "var(--ds-icon-accent-magenta, #CD519D)",
    /** magenta - strong */ ['#943D73']: "var(--ds-text-accent-magenta, #943D73)",
    // yellow
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? "var(--ds-border-accent-yellow, #B38600)" : "var(--ds-icon-accent-yellow, #B38600)";
    },
    /** yellow - strong */ ['#7F5F01']: "var(--ds-text-accent-yellow, #7F5F01)"
};

});


parcelRegister("d7VjK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b79bf4ba9b06c82$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $4b79bf4ba9b06c82$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("7Ed7m", function(module, exports) {
$parcel$export(module.exports, "default", () => $535bbdf35577f914$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $535bbdf35577f914$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("ioBeT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c600267da1c1c52$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $6c600267da1c1c52$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});


parcelRegister("4CCaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b807c4d56d3edf67$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $afepA = parcelRequire("afepA");
const $b807c4d56d3edf67$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $afepA.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        plainTextFastPath: props.plainTextFastPath,
        children: children
    });
};
var $b807c4d56d3edf67$export$2e2bcd8739ae039 = $b807c4d56d3edf67$var$TextWrapper;

});
parcelRegister("afepA", function(module, exports) {
$parcel$export(module.exports, "TextWithAnnotationDraft", () => $0c4644bcfc41428c$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $8zTqm = parcelRequire("8zTqm");

var $il86U = parcelRequire("il86U");

var $2U3vi = parcelRequire("2U3vi");

var $fPpUI = parcelRequire("fPpUI");

var $iAlJn = parcelRequire("iAlJn");

var $WdE3k = parcelRequire("WdE3k");

var $3e2tA = parcelRequire("3e2tA");
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $0c4644bcfc41428c$var$markStyles = /*#__PURE__*/ (0, $9dQre.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $0c4644bcfc41428c$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $il86U.useAnnotationManagerDispatch)();
    const markRef = (0, $bSJIT.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $iAlJn.dataAttributes)(draftPosition),
        css: $0c4644bcfc41428c$var$markStyles,
        ref: markRef
    }, children);
};
const $0c4644bcfc41428c$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $fPpUI.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $fPpUI.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $fPpUI.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $0c4644bcfc41428c$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks, plainTextFastPath: plainTextFastPath = false })=>{
    const annotateIndex = $0c4644bcfc41428c$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const rendered = (0, $8zTqm.renderText)(value, textHighlighter, marks || [], draftPosition.from, plainTextFastPath);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9dQre.jsx)($0c4644bcfc41428c$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, rendered));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
            key: index
        }, rendered));
    });
};
const $0c4644bcfc41428c$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks, plainTextFastPath: plainTextFastPath = false })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $2U3vi.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $WdE3k.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $3e2tA.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, (0, $8zTqm.renderText)(textString, textHighlighter, marks || [], startPos, plainTextFastPath));
    if (shouldApplyAnnotationAt === (0, $fPpUI.InsertDraftPosition).AROUND_TEXT) return /*#__PURE__*/ (0, $9dQre.jsx)($0c4644bcfc41428c$export$8062d68eccdfa39c, {
        key: 0,
        draftPosition: nextDraftPosition
    }, (0, $8zTqm.renderText)(textString, textHighlighter, marks || [], startPos, plainTextFastPath));
    const offsets = (0, $3e2tA.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $3e2tA.splitText)(textString, offsets);
    if (!texts) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, (0, $8zTqm.renderText)(textString, textHighlighter, marks || [], startPos, plainTextFastPath));
    const components = $0c4644bcfc41428c$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks,
        plainTextFastPath: plainTextFastPath
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, components);
};

});
parcelRegister("8zTqm", function(module, exports) {
$parcel$export(module.exports, "renderText", () => $db655966d5ba4f45$export$482c90f94eb9717c);

var $aQBeH = parcelRequire("aQBeH");

var $68mqj = parcelRequire("68mqj");
function $db655966d5ba4f45$export$482c90f94eb9717c(text, textHighlighter, marks, startPos, fastPath) {
    if (fastPath && (!textHighlighter || !text)) return text ?? '';
    const segments = (0, $68mqj.segmentText)(text, textHighlighter);
    return (0, $aQBeH.renderTextSegments)(segments, textHighlighter, marks, startPos, fastPath);
}

});
parcelRegister("aQBeH", function(module, exports) {
$parcel$export(module.exports, "renderTextSegments", () => $b76ec55092041023$export$8a20fd0614851c5f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
/** Collects the mark type names a highlighter component receives for a text node. */ const $b76ec55092041023$var$toMarkNames = (marksList)=>new Set(marksList.map((m)=>m.type.name));
function $b76ec55092041023$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos, lazyMarks = false) {
    const Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    // With `lazyMarks`, the Set is only built once a highlighted segment is actually rendered, so
    // a highlighter with no matches on this text allocates nothing extra.
    let marks = lazyMarks ? undefined : $b76ec55092041023$var$toMarkNames(marksList);
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        if (!marks) marks = $b76ec55092041023$var$toMarkNames(marksList);
        return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            })
        }, `${segment.text}_${startPos}_${idx}`);
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});

parcelRegister("68mqj", function(module, exports) {
$parcel$export(module.exports, "segmentText", () => $744f09308bfd59df$export$93301b6f1ff0b0c3);
function $744f09308bfd59df$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});


parcelRegister("fPpUI", function(module, exports) {
$parcel$export(module.exports, "InsertDraftPosition", () => $9f78b22c64976d33$export$c1bd4813440b4505);
var $9f78b22c64976d33$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("WdE3k", function(module, exports) {
$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $7b8041a0aa49246a$export$b1baddbd5f289877);

var $fPpUI = parcelRequire("fPpUI");
const $7b8041a0aa49246a$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $fPpUI.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $fPpUI.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $fPpUI.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $fPpUI.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("3e2tA", function(module, exports) {
$parcel$export(module.exports, "findTextString", () => $6b241ef4cd0f7ac5$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $6b241ef4cd0f7ac5$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $6b241ef4cd0f7ac5$export$1059bfc467f4f55d);

var $bSJIT = parcelRequire("bSJIT");
const $6b241ef4cd0f7ac5$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($6b241ef4cd0f7ac5$var$isReactElement(childNode) && childNode.props.children) result = $6b241ef4cd0f7ac5$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $6b241ef4cd0f7ac5$var$isReactElement(child) {
    return !!child.type;
}
const $6b241ef4cd0f7ac5$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $6b241ef4cd0f7ac5$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});



parcelRegister("3ugnJ", function(module, exports) {
$parcel$export(module.exports, "insideBlockNode", () => $1ac20a3b230c5781$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $1ac20a3b230c5781$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $1ac20a3b230c5781$export$244bf4b32387ef62);
$parcel$export(module.exports, "getNestedUnderNodes", () => $1ac20a3b230c5781$export$a8df1f99c673fa27);
const $1ac20a3b230c5781$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $1ac20a3b230c5781$var$isExpandNode = (node)=>node.type.name === 'expand';
const $1ac20a3b230c5781$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $1ac20a3b230c5781$export$d7bc71cca336a3b = (path)=>path.some((item)=>$1ac20a3b230c5781$var$isLayoutNode(item) && $1ac20a3b230c5781$var$hasBreakOutMark(item));
const $1ac20a3b230c5781$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$1ac20a3b230c5781$var$isExpandNode(item) && $1ac20a3b230c5781$var$hasBreakOutMark(item));
const $1ac20a3b230c5781$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $1ac20a3b230c5781$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $1ac20a3b230c5781$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $1ac20a3b230c5781$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};

});

parcelRegister("3ZavE", function(module, exports) {
$parcel$export(module.exports, "createContentGetter", () => $e1ebf7f74e6b6833$export$18a05b40f8bf404f);
const $e1ebf7f74e6b6833$export$18a05b40f8bf404f = (fragment)=>{
    let serialized;
    let materialized = false;
    return ()=>{
        if (!materialized) {
            serialized = fragment ? fragment.toJSON() : undefined;
            // Set last: if `toJSON()` throws, the error propagates and a retry re-attempts instead of
            // caching a partial result.
            materialized = true;
        }
        return serialized;
    };
};

});

parcelRegister("iaQbQ", function(module, exports) {
$parcel$export(module.exports, "getStandaloneBackgroundColorMarks", () => $1e74ea146d8d968c$export$eeb66772b38d7581);

var $doN9b = parcelRequire("doN9b");
const $1e74ea146d8d968c$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true // initial value to handle leading BackgroundColor
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $doN9b.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $doN9b.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $doN9b.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};

});

parcelRegister("6NUiJ", function(module, exports) {
$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $66f8bcfdf4d6de8d$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $66f8bcfdf4d6de8d$export$acb253d79d72af92);
function $66f8bcfdf4d6de8d$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $66f8bcfdf4d6de8d$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$66f8bcfdf4d6de8d$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("kKq6j", function(module, exports) {
$parcel$export(module.exports, "markBlockAsInline", () => $17e3c796125b99b2$export$3a88c97d9b0d8d1c);

var $gdUUy = parcelRequire("gdUUy");
function $17e3c796125b99b2$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, isTopLevel: isTopLevel = true }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        var _node$attrs, _node$attrs2, _node$attrs3, _node$attrs4, _node$attrs5, _node$attrs6;
        if (!isTopLevel && (node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === 'com.atlassian.ecosystem' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.parameters) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.layout) === 'inline-bodied' && (0, $gdUUy.fg)('platform_forge_inline_bodied_layout_switch') && (0, $gdUUy.fg)('platform_forge_inline_bodied_macro')) return false;
        return Boolean((node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.extensionKey,
            extensionType: (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.extensionType,
            parameters: (_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.parameters,
            content: node.content,
            localId: (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode !== null && prevNode !== void 0 && prevNode.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}

});


parcelRegister("gZpwM", function(module, exports) {
$parcel$export(module.exports, "EditorMediaClientProvider", () => $257d6c718b085754$export$77218b6ff680865f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jPmHi = parcelRequire("jPmHi");

var $83J3A = parcelRequire("83J3A");

var $35T7J = parcelRequire("35T7J");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");
const $257d6c718b085754$var$getMediaClientConfigForRenderer = (provider)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return provider.viewAndUploadMediaClientConfig && (0, $gdUUy.fg)('platform_media_video_captions') ? provider.viewAndUploadMediaClientConfig : provider.viewMediaClientConfig;
};
const $257d6c718b085754$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $bSJIT.useState)(()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_media_reliability_enhancements') ? ssr === null || ssr === void 0 ? void 0 : ssr.config : undefined);
    const providerFactory = (0, $jPmHi.useProviderFactory)();
    const mediaProvider = (0, $jPmHi.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ const shouldSkipContext = (0, $3y2s4.isExperimentEnabled)('platform_editor_media_reliability_enhancements') ? Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    const contextMediaClient = (0, $bSJIT.useContext)((0, $35T7J.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $bSJIT.useMemo)(()=>mediaClientConfig ? (0, $83J3A.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    // When the experiment is enabled, use useEffect instead of useLayoutEffect because:
    // - For the ssr.config branch: useState is already initialised with ssr.config, so this
    //   effect is a no-op on first render — the "before paint" guarantee is irrelevant.
    // - For the mediaProvider branch: the actual work happens inside a Promise callback which
    //   resolves asynchronously, so it can never run before paint regardless of which hook
    //   schedules it — useLayoutEffect's guarantee is equally irrelevant here.
    // The legacy path keeps useLayoutEffect to preserve existing behaviour when the experiment is off.
    //
    // The two hooks below are mutually exclusive — only one runs per render — so there is no
    // actual chaining of state updates at runtime. The lint rule cannot statically prove this.
    (0, $bSJIT.useEffect)(()=>{
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_media_reliability_enhancements')) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMediaClientConfig(ssr.config);
        else if (mediaProvider) {
            let cancelled = false;
            // Cancellation flag prevents setMediaClientConfig from being called after
            // unmount or when mediaProvider changes mid-flight (stale promise fix).
            // No .catch() is needed — the media provider is not expected to reject,
            // and a catch handler would be a no-op anyway.
            mediaProvider.then((provider)=>{
                if (!cancelled) setMediaClientConfig($257d6c718b085754$var$getMediaClientConfigForRenderer(provider));
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    // Legacy path (experiment off): keep useLayoutEffect to preserve existing behaviour.
    // remove this when clean up platform_editor_media_reliability_enhancements
    (0, $bSJIT.useLayoutEffect)(()=>{
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_media_reliability_enhancements')) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig($257d6c718b085754$var$getMediaClientConfigForRenderer(provider));
        });
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $35T7J.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});

parcelRegister("3n5QS", function(module, exports) {
$parcel$export(module.exports, "renderDocument", () => $18958d42d3b020d2$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $57l7A = parcelRequire("57l7A");

var $auxFA = parcelRequire("auxFA");

var $huQpY = parcelRequire("huQpY");

var $2GwqA = parcelRequire("2GwqA");

var $9DOfm = parcelRequire("9DOfm");

var $3y6N2 = parcelRequire("3y6N2");

var $g6Qq4 = parcelRequire("g6Qq4");

var $eRA48 = parcelRequire("eRA48");

var $fdVRQ = parcelRequire("fdVRQ");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $dABkj = parcelRequire("dABkj");

var $26ofq = parcelRequire("26ofq");

var $icIt9 = parcelRequire("icIt9");
const $18958d42d3b020d2$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $18958d42d3b020d2$var$withStopwatch = (cb)=>{
    const startTime = $18958d42d3b020d2$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $18958d42d3b020d2$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $18958d42d3b020d2$var$_validation = (doc, schema, adfStage, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    // link mark on mediaSingle is deprecated, need to move link mark to child media node
    // https://product-fabric.atlassian.net/browse/ED-14043
    const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $2GwqA.transformMediaLinkMarks)(doc);
    if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).MEDIA_LINK_TRANSFORMED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
    });
    // Forward `adfStage` only when a caller names one. Omitting it keeps stage-0 specs acceptable,
    // which is what a renderer wants: stored documents can contain them, and wrapping such content
    // as unsupported is worse than rendering it. A caller that declares `final` asks for full-ADF
    // strictness and gets it.
    let result = skipValidation ? transformedAdf || doc : (0, $fdVRQ.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides, adfStage);
    // The spec validator can return the original root object when malformed JSON has no node type.
    // Reject it here, matching the legacy validator, before ProseMirror attempts to deserialize it.
    if (!result || typeof result.type !== 'string' || result.type.length === 0) return null;
    // ProseMirror always require a child under doc
    if (result.type === 'doc') {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $3y6N2.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $dABkj.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    // Upgrade panel → panel_c1 where the schema allows it
    if (result && (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $huQpY.transformContainerNodes)(result, schema);
        if (isTransformed && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $dABkj.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel to panel_c1' : undefined}`
            }
        });
    }
    if (result && !(0, $5N1Y4.expValEquals)('cc-maui-experiment', 'isEnabled', true) && !(0, $gdUUy.fg)('platform_native_embeds_rollout_non_maui_experience') && (0, $gdUUy.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $9DOfm.nativeEmbedsFallbackTransform)(result, schema);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $18958d42d3b020d2$var$memoValidation = (0, $57l7A.default)($18958d42d3b020d2$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    // `areDocsEqual` may stringify the whole document, so it goes last and only runs once everything
    // cheaper has matched.
    return newSchema === oldSchema && newADFStage === oldADFStage && newSkipValidation === oldSkipValidation && $18958d42d3b020d2$var$areValidationOverridesEqual(newValidationOverrides, oldValidationOverrides) && $18958d42d3b020d2$var$areDocsEqual(newDoc, oldDoc);
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $18958d42d3b020d2$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) {
        // `Node.eq` compares markup and content directly; stringifying both `toJSON` trees gives the
        // same answer ~14x slower on a 5k-node document.
        if (typeof docA.eq === 'function' && typeof docB.eq === 'function') return docA.eq(docB);
        return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    }
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
/**
 * `Renderer` rebuilds this object in its render body, so a reference check never matches and the memo
 * re-validates (and re-transforms) an unchanged document every render. A flat bag of optional
 * booleans, so a shallow key/value comparison is exact and free next to what it protects.
 */ const $18958d42d3b020d2$var$areValidationOverridesEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const aEntries = Object.entries(a);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bRecord = b;
    return aEntries.length === Object.keys(b).length && aEntries.every(([key, value])=>bRecord[key] === value);
};
const $18958d42d3b020d2$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $18958d42d3b020d2$var$memoSerializeFragment = (0, $57l7A.default)($18958d42d3b020d2$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $18958d42d3b020d2$var$areDocsEqual(newDoc, oldDoc);
});
const $18958d42d3b020d2$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $dABkj.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $18958d42d3b020d2$var$memoCreateNodeAndCheck = (0, $57l7A.default)($18958d42d3b020d2$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $18958d42d3b020d2$var$areDocsEqual(newDoc, oldDoc);
});
const $18958d42d3b020d2$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $auxFA.defaultSchema), adfStage, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $18958d42d3b020d2$var$withStopwatch(()=>{
        return $18958d42d3b020d2$var$memoValidation(doc, schema, adfStage, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $18958d42d3b020d2$var$withStopwatch(()=>{
        return $18958d42d3b020d2$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $18958d42d3b020d2$var$withStopwatch(()=>{
        return $18958d42d3b020d2$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent) {
        (0, $eRA48.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $26ofq.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $icIt9.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("huQpY", function(module, exports) {
$parcel$export(module.exports, "transformContainerNodes", () => $d8ed43c238477b06$export$62836639b6ded12a);

var $3y2s4 = parcelRequire("3y2s4");

var $hMBe3 = parcelRequire("hMBe3");

var $4T0Fy = parcelRequire("4T0Fy");

var $cXIcJ = parcelRequire("cXIcJ");
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows a `panel_c1` child. Returns an empty set if the
 * schema does not declare a `panel_c1` node.
 */ const $d8ed43c238477b06$var$getPanelC1AllowedParentTypes = (schema)=>{
    const panelC1Type = schema.nodes['panel_c1'];
    if (!panelC1Type) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes)){
        var _nodeType$contentMatc;
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(panelC1Type)) allowed.add(nodeType.name);
    }
    return allowed;
};
/**
 * Resolves which ancestor will actually become the parent of the top-level nodes of `adf`
 * once the fragment is placed back into its destination document.
 *
 * Walks `parentNodes` innermost-first and returns the first type whose content expression
 * accepts a `panel`. Ancestors closer in than that (a textblock the selection happens to sit
 * in, for instance) cannot hold a panel, so they cannot be the effective parent. Returns
 * `undefined` when no destination context was supplied or none of the ancestors can hold a
 * panel, in which case callers fall back to the parent seen during traversal.
 */ const $d8ed43c238477b06$var$resolveEffectiveRootParentType = (schema, parentNodes)=>{
    const panelType = schema.nodes['panel'];
    if (!panelType || !(parentNodes !== null && parentNodes !== void 0 && parentNodes.length)) return undefined;
    for(let index = parentNodes.length - 1; index >= 0; index--){
        var _schema$nodes$parentT;
        const parentType = parentNodes[index];
        if ((_schema$nodes$parentT = schema.nodes[parentType]) !== null && _schema$nodes$parentT !== void 0 && (_schema$nodes$parentT = _schema$nodes$parentT.contentMatch) !== null && _schema$nodes$parentT !== void 0 && _schema$nodes$parentT.matchType(panelType)) return parentType;
    }
    return undefined;
};
const $d8ed43c238477b06$export$fe0c97d482910ea = (adf, schema, options)=>{
    const panelC1AllowedParents = $d8ed43c238477b06$var$getPanelC1AllowedParentTypes(schema);
    if (panelC1AllowedParents.size === 0) return {
        isTransformed: false,
        transformedAdf: adf
    };
    const topNodeType = schema.topNodeType.name;
    const effectiveRootParentType = $d8ed43c238477b06$var$resolveEffectiveRootParentType(schema, options === null || options === void 0 ? void 0 : options.parentNodes);
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        panel: (node, parent, _index, depth)=>{
            var _parent$node, _parent$node2;
            // A panel sitting directly under the top node is destined for whatever the
            // fragment gets inserted into, not for the top node itself.
            const isTopLevelNode = depth === 1 && ((_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) === topNodeType;
            const parentType = isTopLevelNode && effectiveRootParentType ? effectiveRootParentType : (_parent$node2 = parent.node) === null || _parent$node2 === void 0 ? void 0 : _parent$node2.type;
            if (parentType && panelC1AllowedParents.has(parentType)) {
                isTransformed = true;
                return {
                    ...node,
                    type: 'panel_c1'
                };
            }
            return;
        }
    });
    return {
        isTransformed: isTransformed,
        transformedAdf: transformedAdf
    };
};
const $d8ed43c238477b06$export$62836639b6ded12a = (adf, schema, options)=>{
    let isTransformed = false;
    const transformedNodeTypes = new Set();
    let transformedAdf = adf;
    // Gate the generalised (table + expand + panel + blockquote + bodiedExtension) transform
    // behind the consolidated container-in-panel experiment; the in-production table-in-panel
    // path continues to use the deprecated table-only transform.
    const panelC1FallbackResult = (0, $3y2s4.isExperimentEnabled)('platform_editor_nest_container_in_panel') ? (0, $cXIcJ.panelC1FallbackTransformV2)(schema, transformedAdf) : (0, $4T0Fy.panelC1FallbackTransform)(schema, transformedAdf);
    if (panelC1FallbackResult.isTransformed && panelC1FallbackResult.transformedAdf) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
        transformedAdf = panelC1FallbackResult.transformedAdf;
    }
    const promotionResult = $d8ed43c238477b06$export$fe0c97d482910ea(transformedAdf, schema, options);
    if (promotionResult.isTransformed) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
    }
    return {
        transformedAdf: promotionResult.transformedAdf,
        isTransformed: isTransformed,
        transformedNodeTypes: Array.from(transformedNodeTypes)
    };
};

});
parcelRegister("4T0Fy", function(module, exports) {
$parcel$export(module.exports, "panelC1FallbackTransform", () => $b83d33b3f485ecdd$export$9a4ff29f7abd9bcd);

var $hMBe3 = parcelRequire("hMBe3");
// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping a table in an LCM keeps
// it visible/editable inside a plain `panel` (which permits `extension` children) —
// unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
const $b83d33b3f485ecdd$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $b83d33b3f485ecdd$var$LCM_EXTENSION_KEY = 'legacy-content';
const $b83d33b3f485ecdd$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped table may be restored into. A plain `panel` doesn't yet allow a
// `table`, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the table here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping tables wrapped elsewhere.
const $b83d33b3f485ecdd$var$TABLE_RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
const $b83d33b3f485ecdd$var$safeParseAdf = (adf)=>{
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch  {
        return undefined;
    }
};
const $b83d33b3f485ecdd$var$wrapAsLcm = (node)=>{
    const nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $b83d33b3f485ecdd$var$LCM_EXTENSION_TYPE,
            extensionKey: $b83d33b3f485ecdd$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: {
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent),
                [$b83d33b3f485ecdd$var$PANEL_C1_FALLBACK_MARKER]: true
            }
        }
    };
};
const $b83d33b3f485ecdd$var$isLcm = (node)=>{
    var _node$attrs, _node$attrs2, _node$attrs3;
    return node.type === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === $b83d33b3f485ecdd$var$LCM_EXTENSION_TYPE && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === $b83d33b3f485ecdd$var$LCM_EXTENSION_KEY && ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 || (_node$attrs3 = _node$attrs3.parameters) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3[$b83d33b3f485ecdd$var$PANEL_C1_FALLBACK_MARKER]) === true;
};
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ const $b83d33b3f485ecdd$var$getLcmWrappedNode = (node)=>{
    var _node$attrs4, _nested$content;
    const params = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.parameters;
    const nested = (params === null || params === void 0 ? void 0 : params.nestedContent) ?? $b83d33b3f485ecdd$var$safeParseAdf(params === null || params === void 0 ? void 0 : params.adf);
    return (nested === null || nested === void 0 || (_nested$content = nested.content) === null || _nested$content === void 0 ? void 0 : _nested$content.length) === 1 ? nested.content[0] : undefined;
};
const $b83d33b3f485ecdd$var$wrappedNodeIsTable = (node)=>{
    var _getLcmWrappedNode, _node$attrs5;
    return $b83d33b3f485ecdd$var$isLcm(node) && ((_getLcmWrappedNode = $b83d33b3f485ecdd$var$getLcmWrappedNode(node)) === null || _getLcmWrappedNode === void 0 ? void 0 : _getLcmWrappedNode.type) === 'table' || node.type === 'unsupportedBlock' && ((_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 || (_node$attrs5 = _node$attrs5.originalValue) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.type) === 'table';
};
const $b83d33b3f485ecdd$var$isTableInPanelSupported = (schema)=>{
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    return true;
};
const $b83d33b3f485ecdd$export$9a4ff29f7abd9bcd = (schema, adf)=>{
    let isTransformed = false;
    const { extension: extension, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const tableInPanelSupported = $b83d33b3f485ecdd$var$isTableInPanelSupported(schema);
    const shouldDowngrade = !tableInPanelSupported;
    const shouldRestore = tableInPanelSupported;
    const hasRelevantNode = (node)=>shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $b83d33b3f485ecdd$var$wrappedNodeIsTable(node) || Array.isArray(node.content) && node.content.some((c)=>!!c && hasRelevantNode(c));
    if (!hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    const wrapTable = (tableNode)=>extension ? $b83d33b3f485ecdd$var$wrapAsLcm(tableNode) : unsupportedBlock.createChecked({
            originalValue: tableNode
        }).toJSON();
    const downgradePanel = (node)=>{
        if (!Array.isArray(node.content)) return node;
        const hasTableChild = node.content.some((child)=>(child === null || child === void 0 ? void 0 : child.type) === 'table');
        if (hasTableChild && !extension && !unsupportedBlock) return node;
        const content = node.content.map((child)=>{
            if ((child === null || child === void 0 ? void 0 : child.type) === 'table') {
                isTransformed = true;
                return wrapTable(child);
            }
            return child;
        });
        isTransformed = true;
        return {
            ...node,
            type: 'panel',
            content: content
        };
    };
    const restoreWrappedTable = (node, parent)=>{
        var _parent$node, _node$attrs6;
        if (!$b83d33b3f485ecdd$var$TABLE_RESTORE_PARENT_TYPES.has((parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) ?? '')) return node;
        const restored = $b83d33b3f485ecdd$var$isLcm(node) ? $b83d33b3f485ecdd$var$getLcmWrappedNode(node) : (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.originalValue;
        if ((restored === null || restored === void 0 ? void 0 : restored.type) === 'table') {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping table children.
        panel_c1: (node)=>shouldDowngrade ? downgradePanel(node) : node,
        // Supported schema: restore tables wrapped as an LCM / unsupportedBlock.
        extension: (node, parent)=>shouldRestore ? restoreWrappedTable(node, parent) : node,
        unsupportedBlock: (node, parent)=>shouldRestore ? restoreWrappedTable(node, parent) : node
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("cXIcJ", function(module, exports) {
$parcel$export(module.exports, "panelC1FallbackTransformV2", () => $17ff38a9cfb1e670$export$b8c073a615247b65);

var $hMBe3 = parcelRequire("hMBe3");
// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping an extended child (table,
// expand) in an LCM keeps it visible/editable inside a plain `panel` (which permits
// `extension` children) — unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
const $17ff38a9cfb1e670$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $17ff38a9cfb1e670$var$LCM_EXTENSION_KEY = 'legacy-content';
const $17ff38a9cfb1e670$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped child may be restored into. A plain `panel` doesn't yet allow the
// extended children, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the child here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping children wrapped elsewhere.
const $17ff38a9cfb1e670$var$RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
// The extended block children unlocked on `panel_c1` over successive nesting scenarios.
// Each is a plain-`panel`-incompatible child that must be LCM-wrapped when the schema
// doesn't support `panel_c1`, and restored when it does.
// - table  (platform_editor_nest_table_in_panel)
// - expand (platform_editor_nest_expand_in_panel)
const $17ff38a9cfb1e670$var$PANEL_C1_EXTENDED_CHILD_TYPES = new Set([
    'table',
    'expand'
]);
const $17ff38a9cfb1e670$var$safeParseAdf = (adf)=>{
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch  {
        return undefined;
    }
};
const $17ff38a9cfb1e670$var$wrapAsLcm = (node)=>{
    const nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $17ff38a9cfb1e670$var$LCM_EXTENSION_TYPE,
            extensionKey: $17ff38a9cfb1e670$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: {
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent),
                [$17ff38a9cfb1e670$var$PANEL_C1_FALLBACK_MARKER]: true
            }
        }
    };
};
const $17ff38a9cfb1e670$var$isLcm = (node)=>{
    var _node$attrs, _node$attrs2, _node$attrs3;
    return node.type === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === $17ff38a9cfb1e670$var$LCM_EXTENSION_TYPE && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === $17ff38a9cfb1e670$var$LCM_EXTENSION_KEY && ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 || (_node$attrs3 = _node$attrs3.parameters) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3[$17ff38a9cfb1e670$var$PANEL_C1_FALLBACK_MARKER]) === true;
};
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ const $17ff38a9cfb1e670$var$getLcmWrappedNode = (node)=>{
    var _node$attrs4, _nested$content;
    const params = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.parameters;
    const nested = (params === null || params === void 0 ? void 0 : params.nestedContent) ?? $17ff38a9cfb1e670$var$safeParseAdf(params === null || params === void 0 ? void 0 : params.adf);
    return (nested === null || nested === void 0 || (_nested$content = nested.content) === null || _nested$content === void 0 ? void 0 : _nested$content.length) === 1 ? nested.content[0] : undefined;
};
// Type guard: true when the node is a defined extended child of panel_c1 (table, expand, ...).
// Narrows `node` to `ADFEntity` so callers can safely operate on it.
const $17ff38a9cfb1e670$var$isExtendedChild = (node)=>!!(node !== null && node !== void 0 && node.type) && $17ff38a9cfb1e670$var$PANEL_C1_EXTENDED_CHILD_TYPES.has(node.type);
const $17ff38a9cfb1e670$var$wrappedNodeIsExtendedChild = (node)=>{
    var _node$attrs5;
    return $17ff38a9cfb1e670$var$isLcm(node) && $17ff38a9cfb1e670$var$isExtendedChild($17ff38a9cfb1e670$var$getLcmWrappedNode(node)) || node.type === 'unsupportedBlock' && $17ff38a9cfb1e670$var$isExtendedChild((_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.originalValue);
};
const $17ff38a9cfb1e670$var$isPanelC1Supported = (schema)=>{
    if (!schema.nodes.panel_c1) return false;
    // The schema must also declare at least one of the extended child node types, otherwise
    // there's nothing to wrap/restore.
    return Array.from($17ff38a9cfb1e670$var$PANEL_C1_EXTENDED_CHILD_TYPES).some((type)=>!!schema.nodes[type]);
};
const $17ff38a9cfb1e670$export$b8c073a615247b65 = (schema, adf)=>{
    let isTransformed = false;
    const { extension: extension, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const panelC1Supported = $17ff38a9cfb1e670$var$isPanelC1Supported(schema);
    const shouldDowngrade = !panelC1Supported;
    const shouldRestore = panelC1Supported;
    const hasRelevantNode = (node)=>shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $17ff38a9cfb1e670$var$wrappedNodeIsExtendedChild(node) || Array.isArray(node.content) && node.content.some((c)=>!!c && hasRelevantNode(c));
    if (!hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    const wrapChild = (childNode)=>extension ? $17ff38a9cfb1e670$var$wrapAsLcm(childNode) : unsupportedBlock.createChecked({
            originalValue: childNode
        }).toJSON();
    const downgradePanel = (node)=>{
        if (!Array.isArray(node.content)) return node;
        const hasExtendedChild = node.content.some((child)=>$17ff38a9cfb1e670$var$isExtendedChild(child));
        if (hasExtendedChild && !extension && !unsupportedBlock) return node;
        const content = node.content.map((child)=>{
            if ($17ff38a9cfb1e670$var$isExtendedChild(child)) {
                isTransformed = true;
                return wrapChild(child);
            }
            return child;
        });
        isTransformed = true;
        return {
            ...node,
            type: 'panel',
            content: content
        };
    };
    const restoreWrappedChild = (node, parent)=>{
        var _parent$node, _node$attrs6;
        if (!$17ff38a9cfb1e670$var$RESTORE_PARENT_TYPES.has((parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) ?? '')) return node;
        const restored = $17ff38a9cfb1e670$var$isLcm(node) ? $17ff38a9cfb1e670$var$getLcmWrappedNode(node) : (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.originalValue;
        if ($17ff38a9cfb1e670$var$isExtendedChild(restored)) {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping extended children.
        panel_c1: (node)=>shouldDowngrade ? downgradePanel(node) : node,
        // Supported schema: restore children wrapped as an LCM / unsupportedBlock.
        extension: (node, parent)=>shouldRestore ? restoreWrappedChild(node, parent) : node,
        unsupportedBlock: (node, parent)=>shouldRestore ? restoreWrappedChild(node, parent) : node
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});


parcelRegister("2GwqA", function(module, exports) {
$parcel$export(module.exports, "transformMediaLinkMarks", () => $a58e91cc741f954d$export$6528700f3fa2fe2a);

var $hMBe3 = parcelRequire("hMBe3");
const $a58e91cc741f954d$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        mediaSingle: (node)=>{
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("9DOfm", function(module, exports) {
$parcel$export(module.exports, "nativeEmbedsFallbackTransform", () => $880f9cca2aae271c$export$fdee1e5f1664414c);

var $hMBe3 = parcelRequire("hMBe3");

var $3ok8c = parcelRequire("3ok8c");
const $880f9cca2aae271c$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows an `embedCard` child. Returns an empty set if the
 * schema does not declare an `embedCard` node.
 */ const $880f9cca2aae271c$var$getEmbedCardAllowedParentTypes = (schema)=>{
    const embedCardType = schema.nodes.embedCard;
    if (!embedCardType) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes)){
        var _nodeType$contentMatc;
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(embedCardType)) allowed.add(nodeType.name);
    }
    return allowed;
};
const $880f9cca2aae271c$export$fdee1e5f1664414c = (adf, schema)=>{
    const embedCardAllowedParentTypes = $880f9cca2aae271c$var$getEmbedCardAllowedParentTypes(schema);
    const isEmbedCardAllowedInParent = (parent)=>{
        var _parent$node;
        const parentType = parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type;
        return parentType ? embedCardAllowedParentTypes.has(parentType) : false;
    };
    let didTransform = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        extension: (node, parent)=>{
            var _node$attrs, _node$attrs2;
            if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs['extensionKey'].split(':')[0]) !== $880f9cca2aae271c$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2['parameters']) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.macroParams) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.url) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            if (isEmbedCardAllowedInParent(parent)) return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'center'
                }
            };
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $3ok8c.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};

});

parcelRegister("3y6N2", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $01af202ff230a97b$export$18544d0b5f43e4a1);

var $hMBe3 = parcelRequire("hMBe3");

var $iDpw9 = parcelRequire("iDpw9");

var $84v5S = parcelRequire("84v5S");
const $01af202ff230a97b$var$transformNestedTableExtension = (nestedTableExtension)=>{
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        const adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $iDpw9.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
const $01af202ff230a97b$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        extension: (node)=>{
            if ((0, $84v5S.isNestedTableExtension)(node)) {
                isTransformed = true;
                return $01af202ff230a97b$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("84v5S", function(module, exports) {
$parcel$export(module.exports, "isNestedTableExtension", () => $7ea75d0e8ebdb617$export$f45e7335ec874bfe);

var $eyU74 = parcelRequire("eyU74");
const $7ea75d0e8ebdb617$export$f45e7335ec874bfe = (extensionNode)=>{
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === (0, $eyU74.NESTED_TABLE_EXTENSION_TYPE) && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === (0, $eyU74.NESTED_TABLE_EXTENSION_KEY);
};

});


parcelRegister("fdVRQ", function(module, exports) {
$parcel$export(module.exports, "validationErrorHandler", () => $748f6eef015a4ac4$export$468b008419c9a974);
$parcel$export(module.exports, "validateADFEntity", () => $748f6eef015a4ac4$export$884cfad20dece33e);

var $3ok8c = parcelRequire("3ok8c");

var $g6Qq4 = parcelRequire("g6Qq4");

var $9l9Bd = parcelRequire("9l9Bd");

var $eRA48 = parcelRequire("eRA48");

var $2ALjD = parcelRequire("2ALjD");
const $748f6eef015a4ac4$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $748f6eef015a4ac4$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $748f6eef015a4ac4$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowNestedTables,
            allowTableInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowTableInPanel,
            allowContainerInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowContainerInPanel
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $748f6eef015a4ac4$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $748f6eef015a4ac4$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return (0, $2ALjD.wrapWithUnsupported)(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $748f6eef015a4ac4$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $748f6eef015a4ac4$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $748f6eef015a4ac4$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta !== null && meta !== void 0 && meta.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta === null || meta === void 0 ? void 0 : meta.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, expand-in-panel documents are stored as
    // plain ADF `panel` nodes containing an `expand`. The base validator-spec does not permit
    // `expand` inside `panel` (it's gated behind the consolidated container-in-panel experiment,
    // see `isPanelNestingContainerSupported`), so we suppress the INVALID_CONTENT error when
    // `allowContainerInPanel` is set.
    if (options.allowContainerInPanel) {
        const meta = error.meta;
        if ((meta === null || meta === void 0 ? void 0 : meta.parentType) === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'expand') return entity;
    }
    if (options.allowUnsupportedBlock) return (0, $2ALjD.wrapWithUnsupported)(entity);
    if (options.allowUnsupportedInline) return (0, $2ALjD.wrapWithUnsupported)(entity, 'inline');
    if (dispatchAnalyticsEvent) $748f6eef015a4ac4$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $748f6eef015a4ac4$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? (0, $2ALjD.wrapWithUnsupported)(child) : validate(child, $748f6eef015a4ac4$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return (0, $2ALjD.wrapWithUnsupported)(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? (0, $2ALjD.wrapWithUnsupported)(child) : child;
        });
    }
    return entity;
}
function $748f6eef015a4ac4$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $eRA48.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $748f6eef015a4ac4$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides, adfStage)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    // Full-ADF strictness is opt-in: only a caller that names `final` gets it, and omitting `adfStage`
    // keeps stage-0 specs acceptable. Strictness has to be asked for rather than defaulted into,
    // because a document holding a stage-0-only construct, such as a `layoutSection` with one column,
    // otherwise has that content wrapped as unsupported. Editors carry such constructs by design,
    // since the editor's own schema enables them, and renderers meet them in stored documents.
    const validate = (0, $3ok8c.validator)(nodes, marks, {
        allowPrivateAttributes: true,
        stage0: adfStage !== (0, $9l9Bd.ADFStages).FINAL
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $748f6eef015a4ac4$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};

});
parcelRegister("9l9Bd", function(module, exports) {
$parcel$export(module.exports, "ADFStages", () => $2941aaf476382e18$export$3b94ef2190b2d585);
const $2941aaf476382e18$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};

});

parcelRegister("2ALjD", function(module, exports) {
$parcel$export(module.exports, "wrapWithUnsupported", () => $383991dff771b76f$export$87b732fa69cdf16e);
function $383991dff771b76f$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});


parcelRegister("26ofq", function(module, exports) {
$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $4c5bb7d645366238$export$a43de96edd8d0a0);

var $g6Qq4 = parcelRequire("g6Qq4");

var $i8aUK = parcelRequire("i8aUK");

var $5jtWj = parcelRequire("5jtWj");

var $dABkj = parcelRequire("dABkj");
const $4c5bb7d645366238$var$rendersMap = {};
const $4c5bb7d645366238$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $5jtWj.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $i8aUK.getAnalyticsAppearance)(item.appearance),
                platform: (0, $dABkj.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $dABkj.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $4c5bb7d645366238$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $4c5bb7d645366238$var$DEFAULT_SAMPLING_RATE = 100;
const $4c5bb7d645366238$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$4c5bb7d645366238$var$rendersMap[appearance]) $4c5bb7d645366238$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $4c5bb7d645366238$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $4c5bb7d645366238$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $4c5bb7d645366238$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($4c5bb7d645366238$var$rendersMap[appearance].size === 1) $4c5bb7d645366238$var$schedule(()=>$4c5bb7d645366238$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($4c5bb7d645366238$var$rendersMap[appearance].size % sampleRate === 0) $4c5bb7d645366238$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("5jtWj", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $015eb8444dac045d$export$484b83e0462998d);

var $hMBe3 = parcelRequire("hMBe3");

var $iBqsj = parcelRequire("iBqsj");

var $hIeOw = parcelRequire("hIeOw");
const $015eb8444dac045d$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || (0, $hIeOw.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || (0, $hIeOw.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).BLOCKING
    };
};
const $015eb8444dac045d$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $hMBe3.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                const originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $hMBe3.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        var _parent$parent;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = ((_parent$parent = parent.parent) === null || _parent$parent === void 0 || (_parent$parent = _parent$parent.node) === null || _parent$parent === void 0 ? void 0 : _parent$parent.type) ?? 'unknown';
                        const type = `${parentType}/${(unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = ((unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $015eb8444dac045d$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return (0, $iBqsj.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return (0, $iBqsj.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).BLOCKING;
    return (0, $iBqsj.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).NORMAL;
};
const $015eb8444dac045d$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $015eb8444dac045d$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $015eb8444dac045d$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $015eb8444dac045d$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});
parcelRegister("iBqsj", function(module, exports) {
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_LEVEL_SEVERITY", () => $13c3d009af5b4c0c$export$6632e71a22d31bf1);
var $13c3d009af5b4c0c$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});

});

parcelRegister("hIeOw", function(module, exports) {
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS", () => $e77623763956be4c$export$f9f8a29778652c3e);
const $e77623763956be4c$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};

});



parcelRegister("icIt9", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $60a5ecc9bfbf797a$export$1daf15cbaf649dad);
/* eslint-disable jsdoc/require-jsdoc */ 
var $5dP8l = parcelRequire("5dP8l");
function $60a5ecc9bfbf797a$export$1daf15cbaf649dad(adfDocument) {
    return (0, $5dP8l.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("5dP8l", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $d57fdf4803335745$export$533b26079ad0b4b);

var $hMBe3 = parcelRequire("hMBe3");
function $d57fdf4803335745$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $hMBe3.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("dcV1E", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $0f39720efc2fa1fd$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $0f39720efc2fa1fd$export$cddc3c6ebe2d2cec);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $0f39720efc2fa1fd$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(undefined);
const $0f39720efc2fa1fd$export$20439b49fdd0d26c = $0f39720efc2fa1fd$var$dest.Provider;
const $0f39720efc2fa1fd$var$Consumer = $0f39720efc2fa1fd$var$dest.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $0f39720efc2fa1fd$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $bSJIT.useState)();
    return /*#__PURE__*/ (0, $dc70d.jsx)($0f39720efc2fa1fd$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("6fLsU", function(module, exports) {
$parcel$export(module.exports, "useScrollToBlock", () => $8cf08390d2065b45$export$81bdbc2b3f1c95ef);

var $bSJIT = parcelRequire("bSJIT");

var $c9wRy = parcelRequire("c9wRy");

var $bxWbJ = parcelRequire("bxWbJ");
var $eNF7f = parcelRequire("eNF7f");
var $hcdOL = parcelRequire("hcdOL");

var $lySmk = parcelRequire("lySmk");

var $j3eLY = parcelRequire("j3eLY");

var $3kPSy = parcelRequire("3kPSy");
const $8cf08390d2065b45$export$81bdbc2b3f1c95ef = (containerRef, adfDoc, scrollToBlock)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $3kPSy.useStableScroll)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $bSJIT.useEffect)(()=>{
        var _getDocument;
        // Only run in browser environment.
        if (typeof window === 'undefined' || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $lySmk.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $j3eLY.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $hcdOL.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $bxWbJ.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $eNF7f.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            cancelExpandAndScroll = (0, $j3eLY.expandAllParentsThenScroll)(element, 0, (el)=>{
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $j3eLY.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $hcdOL.isExpandCollapsed)(expandContainer)) {
                    (0, $bxWbJ.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $eNF7f.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if (((_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.readyState) === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            var _getDocument2;
            if (((_getDocument2 = (0, $c9wRy.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.readyState) === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};

});
parcelRegister("bxWbJ", function(module, exports) {
$parcel$export(module.exports, "expandElement", () => $1c6a64e0638ded1b$export$280ec17414a50cdd);
/**
 * Expand a collapsed expand node by clicking its toggle button.
 *
 * This function finds the toggle button with aria-expanded="false" and programmatically
 * clicks it to expand the node. It does not wait for the expansion to complete.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the toggle button was found and clicked, false otherwise.
 */ const $1c6a64e0638ded1b$export$280ec17414a50cdd = (expandContainer)=>{
    // Find and click the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};

});

parcelRegister("eNF7f", function(module, exports) {
$parcel$export(module.exports, "getLocalIdSelector", () => $374e95025b75de3a$export$94a68fcf7c5634d2);
const $374e95025b75de3a$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) // return table wrapper instead of table div, so the height calculation is correct
    return element.parentElement;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};

});

parcelRegister("hcdOL", function(module, exports) {
$parcel$export(module.exports, "isExpandCollapsed", () => $a607811dfb4972d1$export$785b8bfd794fa7b6);
/**
 * Check if an expand node is currently collapsed.
 *
 * Uses two methods to determine collapse state:
 * 1. First checks aria-expanded attribute on the toggle button (most reliable).
 * 2. Falls back to checking content div visibility via computed styles.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the expand is collapsed, false if expanded or state cannot be determined.
 */ const $a607811dfb4972d1$export$785b8bfd794fa7b6 = (expandContainer)=>{
    // Check for aria-expanded attribute on the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    const contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        const computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || Boolean(contentDiv.hidden);
    }
    return false;
};

});

parcelRegister("lySmk", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_BLOCK_LINK_HASH_PREFIX", () => $20ae89ca05763886$export$18a71eb9fe4307bc);
$parcel$export(module.exports, "createBlockLinkHashValue", () => $20ae89ca05763886$export$7d28ccc9eddf2197);
const $20ae89ca05763886$export$18a71eb9fe4307bc = 'block-';
const $20ae89ca05763886$export$d7e471f6502a69e2 = (hash, prefix = $20ae89ca05763886$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    // Ignored via go/ees019
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    // Ignored via go/ees019
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $20ae89ca05763886$export$c95c8d5e0fd74b32 = (hash, prefix = $20ae89ca05763886$export$18a71eb9fe4307bc)=>{
    if (!$20ae89ca05763886$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $20ae89ca05763886$export$7d28ccc9eddf2197 = (blockId, prefix = $20ae89ca05763886$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};

});

parcelRegister("j3eLY", function(module, exports) {
$parcel$export(module.exports, "findNodeWithExpandParents", () => $a5578c6e1d84d0b9$export$e070f925e0e65bbc);
$parcel$export(module.exports, "expandAllParentsThenScroll", () => $a5578c6e1d84d0b9$export$9d8f3695c9ce7da0);
/**
 * Shared utilities for scrolling to block elements with expand node support.
 * Used by both Confluence's useScrollOnUrlChange and platform renderer's useScrollToBlock.
 */ 
var $bxWbJ = parcelRequire("bxWbJ");

var $hcdOL = parcelRequire("hcdOL");

var $aFQMI = parcelRequire("aFQMI");

function $a5578c6e1d84d0b9$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    let result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ const traverse = (node, expandAncestors)=>{
        var _node$attrs, _node$attrs2;
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) === targetLocalId) {
            result = {
                expandParentLocalIds: [
                    ...expandAncestors
                ] // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        const isExpand = (node === null || node === void 0 ? void 0 : node.type) === 'expand' || (node === null || node === void 0 ? void 0 : node.type) === 'nestedExpand';
        const newExpandAncestors = isExpand && node !== null && node !== void 0 && (_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.localId ? [
            ...expandAncestors,
            node.attrs.localId
        ] : expandAncestors;
        // Traverse children if they exist
        if (node !== null && node !== void 0 && node.content && Array.isArray(node.content)) for (const child of node.content){
            if (result || !child) break;
            traverse(child, newExpandAncestors);
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    traverse(adfDoc, []);
    return result;
}
const $a5578c6e1d84d0b9$export$4fc3b03d60a46096 = (element, maxDepth = (0, $aFQMI.SCROLL_TO_BLOCK_TIMING).MAX_EXPAND_DEPTH)=>{
    const expands = [];
    let currentElement = element;
    let depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        const expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
const $a5578c6e1d84d0b9$export$9d8f3695c9ce7da0 = (element, attempt = 0, scrollFn)=>{
    const { MAX_EXPAND_DEPTH: MAX_EXPAND_DEPTH, MAX_ATTEMPTS: MAX_ATTEMPTS, DOM_UPDATE_DELAY: DOM_UPDATE_DELAY, RETRY_DELAY: RETRY_DELAY } = (0, $aFQMI.SCROLL_TO_BLOCK_TIMING);
    const doScroll = scrollFn ?? ((el)=>el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        }));
    // Store timeout ID and nested cleanup function so they can be cancelled.
    let timeoutId = null;
    let nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    const cleanup = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) doScroll(element);
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        const parentExpands = $a5578c6e1d84d0b9$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        const collapsedExpands = parentExpands.filter((expandContainer)=>expandContainer.isConnected && (0, $hcdOL.isExpandCollapsed)(expandContainer));
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            doScroll(element);
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        const outermostCollapsed = collapsedExpands[0];
        try {
            const expanded = (0, $bxWbJ.expandElement)(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(()=>{
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $a5578c6e1d84d0b9$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
                } catch  {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) doScroll(element);
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $a5578c6e1d84d0b9$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        } catch  {
            // Retry on error.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $a5578c6e1d84d0b9$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        }
    } catch  {
        // Fallback to simple scroll on error.
        if (element.isConnected) doScroll(element);
    }
    return cleanup;
};

});
parcelRegister("aFQMI", function(module, exports) {
$parcel$export(module.exports, "SCROLL_TO_BLOCK_TIMING", () => $6e083fafccb85efb$export$7f8747c9df4cadcb);
/**
 * Timing constants for expand animation and DOM update delays.
 * These values are tuned for the expand component's behavior and React's update cycle.
 */ const $6e083fafccb85efb$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};

});


parcelRegister("3kPSy", function(module, exports) {
$parcel$export(module.exports, "useStableScroll", () => $e2a4454e7b6915a8$export$3325eba9424d3c32);

var $bSJIT = parcelRequire("bSJIT");
const $e2a4454e7b6915a8$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $bSJIT.useRef)(null);
    const resizeObserverRef = (0, $bSJIT.useRef)(null);
    const lastStableTimeRef = (0, $bSJIT.useRef)(0);
    const onStableCallbackRef = (0, $bSJIT.useRef)(null);
    const cleanup = (0, $bSJIT.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $bSJIT.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $bSJIT.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};

});


parcelRegister("f50k8", function(module, exports) {
$parcel$export(module.exports, "getWidthInfoPayload", () => $65cd51b7db1c7585$export$208d2421b73f3f86);
$parcel$export(module.exports, "getHeightInfoPayload", () => $65cd51b7db1c7585$export$34e5b28c67455a81);

var $g6Qq4 = parcelRequire("g6Qq4");

var $4S8NW = parcelRequire("4S8NW");

var $kFGkN = parcelRequire("kFGkN");

var $lrWkt = parcelRequire("lrWkt");
const $65cd51b7db1c7585$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $kFGkN.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $lrWkt.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $lrWkt.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $4S8NW.MODE).RENDERER
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
    };
};
const $65cd51b7db1c7585$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $kFGkN.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
    };
};

});
parcelRegister("4S8NW", function(module, exports) {
$parcel$export(module.exports, "PLATFORMS", () => $bc5a9bfcaf1f0e84$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $bc5a9bfcaf1f0e84$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $bc5a9bfcaf1f0e84$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $bc5a9bfcaf1f0e84$export$60a219cfaef9722);
var $bc5a9bfcaf1f0e84$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $bc5a9bfcaf1f0e84$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $bc5a9bfcaf1f0e84$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $bc5a9bfcaf1f0e84$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("kFGkN", function(module, exports) {
$parcel$export(module.exports, "TABLE_ACTION", () => $dcaa11ebc27d4b5f$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $dcaa11ebc27d4b5f$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $dcaa11ebc27d4b5f$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $dcaa11ebc27d4b5f$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $dcaa11ebc27d4b5f$export$ba2dfc055a59d951);
var $dcaa11ebc27d4b5f$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    TABLE_ACTION["CHANGED_CELL_VERTICAL_ALIGNMENT"] = "changedVerticalAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $dcaa11ebc27d4b5f$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $dcaa11ebc27d4b5f$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $dcaa11ebc27d4b5f$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $dcaa11ebc27d4b5f$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $dcaa11ebc27d4b5f$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});


parcelRegister("kbiy4", function(module, exports) {
$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $6a08436dea4021ad$export$cfc1361be0de4203);
/* eslint-disable jsdoc/require-jsdoc -- SSR inline script helpers */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $bjG1c = parcelRequire("bjG1c");

var $1EI4O = parcelRequire("1EI4O");
function $6a08436dea4021ad$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: true
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $6a08436dea4021ad$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $6a08436dea4021ad$export$92859d13f30c883e(id, shouldSkipScript) {
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$6a08436dea4021ad$export$47813c4121c8b4b3};
(${$6a08436dea4021ad$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)});
})(window);
`;
}
const $6a08436dea4021ad$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $bjG1c.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $bjG1c.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $bjG1c.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $bjG1c.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $bjG1c.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $bjG1c.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $1EI4O.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6a08436dea4021ad$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- inline script runs in browser document context
    document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>{
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth || isExtension) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $6a08436dea4021ad$export$2a0b3eeee3f2ea40 = (0, $bjG1c.breakoutConsts).calcLineLength((0, $bjG1c.breakoutConsts));

});

parcelRegister("dcneY", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $864540ad90495061$export$3dee5e4542c672d9);

var $1R600 = parcelRequire("1R600");

var $5h1YQ = parcelRequire("5h1YQ");
function $864540ad90495061$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $5h1YQ.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $1R600.fileCardImageViewSelector))) return true;
    return false;
}

});
parcelRegister("1R600", function(module, exports) {
$parcel$export(module.exports, "fileCardImageViewSelector", () => $42f93f3fc32d328a$export$7a6526d4be3b7eb3);
const $42f93f3fc32d328a$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $42f93f3fc32d328a$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

});

parcelRegister("5h1YQ", function(module, exports) {
$parcel$export(module.exports, "mediaViewerPopupClass", () => $b49e556d87d13f67$export$42c8d07e41ed1e74);
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $b49e556d87d13f67$export$42c8d07e41ed1e74 = 'media-viewer-popup';

});


parcelRegister("8tgQv", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $077156d30500a5e9$export$8e2864079bc476bd);

var $5bbjm = parcelRequire("5bbjm");
const $077156d30500a5e9$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if (contentMode === 'compact') return 0, $5bbjm.akEditorFullPageDenseFontSize;
    return appearance && appearance !== 'comment' ? (0, $5bbjm.akEditorFullPageDefaultFontSize) : 14;
};

});

parcelRegister("lnNO5", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $f264e48f83c68128$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $f264e48f83c68128$export$b1072f43c67b540c);
/* eslint-disable jsdoc/require-jsdoc -- thin portal context helpers */ 
var $bSJIT = parcelRequire("bSJIT");
const $f264e48f83c68128$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(undefined);
function $f264e48f83c68128$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $bSJIT.useContext)($f264e48f83c68128$export$60d741e20e0aa309);
    return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}

});

parcelRegister("3WLJM", function(module, exports) {
$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $c1b0cef8deb49d1d$export$c94cfc0c675062a1);
const $c1b0cef8deb49d1d$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !((child === null || child === void 0 ? void 0 : child.type) === 'hardBreak' || (child === null || child === void 0 ? void 0 : child.type) === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("klVcb", function(module, exports) {
$parcel$export(module.exports, "RendererStyleContainer", () => $0ee114a72ff0f81f$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $cm5bx = parcelRequire("cm5bx");

var $drur6 = parcelRequire("drur6");

var $jxkn6 = parcelRequire("jxkn6");

var $3VXSn = parcelRequire("3VXSn");

var $6gjZj = parcelRequire("6gjZj");

var $lPNDS = parcelRequire("lPNDS");

var $enwus = parcelRequire("enwus");

var $1J9lh = parcelRequire("1J9lh");

var $5XYxj = parcelRequire("5XYxj");

var $dZp9s = parcelRequire("dZp9s");

var $fMCeS = parcelRequire("fMCeS");

var $5LDnu = parcelRequire("5LDnu");

var $9hOTY = parcelRequire("9hOTY");

var $7VlAB = parcelRequire("7VlAB");

var $l7YRm = parcelRequire("l7YRm");

var $fA0pJ = parcelRequire("fA0pJ");

var $2Ucf2 = parcelRequire("2Ucf2");

var $glREr = parcelRequire("glREr");

var $5bbjm = parcelRequire("5bbjm");

var $g3vc1 = parcelRequire("g3vc1");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $cvo9f = parcelRequire("cvo9f");

var $4OX3h = parcelRequire("4OX3h");

var $b82GM = parcelRequire("b82GM");

var $ccrLN = parcelRequire("ccrLN");

var $2Zash = parcelRequire("2Zash");

var $8tgQv = parcelRequire("8tgQv");

var $1EI4O = parcelRequire("1EI4O");
function $0ee114a72ff0f81f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0ee114a72ff0f81f$var$wrappedMediaBreakoutPoint = 410;
const $0ee114a72ff0f81f$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $0ee114a72ff0f81f$var$tableShadowWidth = 32;
const $0ee114a72ff0f81f$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $0ee114a72ff0f81f$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME = 'remix-block-highlight';
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $0ee114a72ff0f81f$var$tableRowHeight = 44;
const $0ee114a72ff0f81f$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $jxkn6.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $0ee114a72ff0f81f$var$baseFontStyle = /*#__PURE__*/ (0, $9dQre.css)({
    font: (0, $3VXSn.editorUGCTokensRefreshed)['editor.font.body']
});
const $0ee114a72ff0f81f$var$fontSizeStyles = {
    name: "jdulnm",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--ak-renderer-editor-font-small-text);}"
};
const $0ee114a72ff0f81f$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $0ee114a72ff0f81f$var$baseStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $5bbjm.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT}`]: {
        [`> [${0, $2Zash.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE}][hidden='until-found']`]: {
            display: 'block',
            // `hidden='until-found'` maps to `content-visibility: hidden`, which skips the element's
            // contents but keeps its own box, sized by its own specified sizes. Everything below
            // needs `!important` because extension nodes are sized and spaced by declarations that
            // would otherwise win: an inline `height`/`min-height` reserving macro height (see
            // `react/nodes/extension.tsx`), and `!important` alignment margins from
            // `@atlaskit/native-embeds-common`. Without it the collapsed section keeps a visible gap.
            blockSize: '0 !important',
            minBlockSize: '0 !important',
            marginBlock: '0 !important',
            paddingBlock: '0 !important',
            borderBlockWidth: '0 !important'
        },
        // p, h3, and action items
        [`.${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $6gjZj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $0ee114a72ff0f81f$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $9dQre.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transitionProperty: 'opacity, transform',
                    transitionDuration: `${"var(--ds-duration-medium, 0.2s)"}, ${"var(--ds-duration-medium, 0.2s)"}`,
                    transitionTimingFunction: `${"var(--ds-easing-out-practical, ease)"}, ${"var(--ds-easing-out-practical, ease)"}`,
                    transitionDelay: '0s, 0s'
                }
            },
            '&:hover': {
                [`.${0, $b82GM.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $0ee114a72ff0f81f$var$headingAnchorStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $b82GM.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $0ee114a72ff0f81f$var$headingAnchorButtonFocusVisibleStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
        'button:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            borderRadius: "var(--ds-radius-small, 3px)"
        }
    }
});
const $0ee114a72ff0f81f$var$akEditorBreakpointForSmallDevice = '1266px';
const $0ee114a72ff0f81f$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $9dQre.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $5bbjm.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $5bbjm.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$0ee114a72ff0f81f$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $5bbjm.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $0ee114a72ff0f81f$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $9dQre.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $5bbjm.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$0ee114a72ff0f81f$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $5bbjm.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $0ee114a72ff0f81f$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $9dQre.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $5bbjm.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$0ee114a72ff0f81f$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $5bbjm.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $5bbjm.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $0ee114a72ff0f81f$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $9dQre.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $0ee114a72ff0f81f$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $0ee114a72ff0f81f$var$rendererFullPageStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $5bbjm.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $1EI4O.FullPagePadding)}px`
});
const $0ee114a72ff0f81f$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $9dQre.css)({
    '--ak-renderer--full-page-gutter': `${(0, $1EI4O.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $5bbjm.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $5bbjm.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $5bbjm.akEditorGutterPaddingReduced)}px`
    }
});
const $0ee114a72ff0f81f$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $5bbjm.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $0ee114a72ff0f81f$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $5bbjm.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $0ee114a72ff0f81f$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $5bbjm.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $0ee114a72ff0f81f$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $5bbjm.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $0ee114a72ff0f81f$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $0ee114a72ff0f81f$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`#${$0ee114a72ff0f81f$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $0ee114a72ff0f81f$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $0ee114a72ff0f81f$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $5bbjm.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $0ee114a72ff0f81f$var$headingsSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $0ee114a72ff0f81f$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $0ee114a72ff0f81f$var$headingAnchorWrapperTargetSizeStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        verticalAlign: 'middle'
    },
    [`& .renderer-heading-wrapper > .${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle'
    }
});
const $0ee114a72ff0f81f$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $0ee114a72ff0f81f$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $0ee114a72ff0f81f$var$ruleSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $5bbjm.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $0ee114a72ff0f81f$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $9dQre.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $5bbjm.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $0ee114a72ff0f81f$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $9dQre.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $5bbjm.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $0ee114a72ff0f81f$var$listsSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    /* =============== INDENTATION SPACING ========= */ // Skips top-layer surfaces. See top-layer/notes/decisions/top-layer-unsafe-selectors.md
    '& ul:not(:where([popover], dialog, & :is([popover], dialog) *)), & ol:not(:where([popover], dialog, & :is([popover], dialog) *))': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $fMCeS.listItemCounterPadding)}px)`
    },
    [`${0, $drur6.orderedListSelector}, ${0, $cm5bx.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $0ee114a72ff0f81f$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 */ const $0ee114a72ff0f81f$var$listItemHiddenMarkerStyles = {
    name: "j8szsq",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-list-local-id] > div[data-task-list-local-id]{margin-top:0;}div[data-task-local-id] + div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);}"
};
const $0ee114a72ff0f81f$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $0ee114a72ff0f81f$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $5bbjm.blockNodesVerticalMargin)
        }
    }
});
const $0ee114a72ff0f81f$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $9dQre.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $0ee114a72ff0f81f$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $0ee114a72ff0f81f$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $0ee114a72ff0f81f$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $0ee114a72ff0f81f$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $cvo9f.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $0ee114a72ff0f81f$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $cvo9f.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $0ee114a72ff0f81f$var$migratedInlineBodiedFlowStyle = /*#__PURE__*/ (0, $9dQre.css)({
    [[
        `.${(0, $cvo9f.RendererCssClassName).DOCUMENT} [data-migrated-inline] + [data-as-inline="on"]`,
        `.${(0, $cvo9f.RendererCssClassName).DOCUMENT} [data-as-inline="on"]:has(+ [data-migrated-inline])`
    ].join(', ')]: {
        display: 'inline'
    }
});
const $0ee114a72ff0f81f$var$forgeInlineBodiedSpacingStyle = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline]`]: {
        marginBottom: 0,
        verticalAlign: 'baseline',
        maxWidth: '100%'
    },
    [[
        `.${(0, $cvo9f.RendererCssClassName).DOCUMENT} [data-forge-inline] + [data-as-inline="on"]`,
        `.${(0, $cvo9f.RendererCssClassName).DOCUMENT} [data-as-inline="on"]:has(+ [data-forge-inline])`
    ].join(', ')]: {
        display: 'inline'
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline] *`]: {
        maxWidth: '100%'
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline] .${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        overflowX: 'auto'
    },
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline] .${(0, $cvo9f.RendererCssClassName).DOCUMENT} > p`]: {
        display: 'inline',
        margin: 0
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $0ee114a72ff0f81f$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $0ee114a72ff0f81f$var$shadowSharedStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $lPNDS.shadowClassNames).LEFT_SHADOW}::before, .${(0, $lPNDS.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $5bbjm.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}, .${(0, $lPNDS.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $lPNDS.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $glREr.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $glREr.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $0ee114a72ff0f81f$var$dateSharedStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $5XYxj.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $0ee114a72ff0f81f$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $0ee114a72ff0f81f$var$backgroundColorStyles = {
    name: "1rjaz80",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
// Don't show text highlight styling when there is a hyperlink.
// Conditionally applied when the highlight-on-links experiment is off.
const $0ee114a72ff0f81f$var$highlightLinksUnsetStyles = {
    name: "1d6748d",
    styles: "a .fabric-background-color-mark{background-color:unset;}"
};
const $0ee114a72ff0f81f$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $0ee114a72ff0f81f$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $fA0pJ.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $5bbjm.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $fA0pJ.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $fA0pJ.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $5bbjm.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $fA0pJ.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $5bbjm.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $5bbjm.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $5bbjm.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $0ee114a72ff0f81f$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $0ee114a72ff0f81f$var$smartCardStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $9hOTY.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $5bbjm.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $0ee114a72ff0f81f$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $9hOTY.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $9hOTY.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $0ee114a72ff0f81f$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $9hOTY.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $9hOTY.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $0ee114a72ff0f81f$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $9hOTY.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $9hOTY.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $0ee114a72ff0f81f$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform.
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $0ee114a72ff0f81f$var$centerWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
// Reset only Expands with no preceding content sibling. Streaming SSR style/script siblings
// are ignored so moving them to the head on the client does not change the top margin.
const $0ee114a72ff0f81f$var$expandSsrMarginStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > [data-node-type='expand']:not(:not(style, script) ~ *)`]: {
        marginTop: 0
    }
});
const $0ee114a72ff0f81f$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $9dQre.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $5LDnu.richMediaClassName}.rich-media-wrapped + .${0, $5LDnu.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $5LDnu.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $5LDnu.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $5LDnu.richMediaClassName}.image-align-start,
		.${0, $5LDnu.richMediaClassName}.image-center,
		.${0, $5LDnu.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $cvo9f.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $cvo9f.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $5bbjm.blockNodesVerticalMargin)}`
        },
        [`.${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $cvo9f.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* Embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $cvo9f.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $glREr.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $0ee114a72ff0f81f$var$hideExtensionStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).EXTENSION}:has([data-extension-key='hide'])`]: {
        marginTop: 0
    }
});
const $0ee114a72ff0f81f$var$baseOtherStyles = /*#__PURE__*/ (0, $9dQre.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $5LDnu.richMediaClassName}.rich-media-wrapped + .${0, $5LDnu.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $5LDnu.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $5LDnu.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $5LDnu.richMediaClassName}.image-align-start,
		.${0, $5LDnu.richMediaClassName}.image-center,
		.${0, $5LDnu.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $cvo9f.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $cvo9f.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $cvo9f.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $5bbjm.blockNodesVerticalMargin)}`
        },
        [`.${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $cvo9f.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* Embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $cvo9f.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $cvo9f.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $glREr.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $0ee114a72ff0f81f$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $9dQre.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $b82GM.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $0ee114a72ff0f81f$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $b82GM.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $0ee114a72ff0f81f$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $5LDnu.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $5LDnu.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $0ee114a72ff0f81f$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $5LDnu.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $5LDnu.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $5LDnu.richMediaClassName}.image-wrap-right + .${0, $5LDnu.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $5LDnu.richMediaClassName}.image-wrap-left + .${0, $5LDnu.richMediaClassName}.image-wrap-right, .${0, $5LDnu.richMediaClassName}.image-wrap-right + .${0, $5LDnu.richMediaClassName}.image-wrap-left, .${0, $5LDnu.richMediaClassName}.image-wrap-left + .${0, $5LDnu.richMediaClassName}.image-wrap-left, .${0, $5LDnu.richMediaClassName}.image-wrap-right + .${0, $5LDnu.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$0ee114a72ff0f81f$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $0ee114a72ff0f81f$var$tableSharedStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    'td[colorname="subtle lime" i], th[colorname="subtle lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtlest, #EFFFD6)"} !important`
    },
    'td[colorname="subtle orange" i], th[colorname="subtle orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtlest, #FFF5DB)"} !important`
    },
    'td[colorname="subtle magenta" i], th[colorname="subtle magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest, #FFECF8)"} !important`
    },
    'td[colorname="lime" i], th[colorname="lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtler, #D3F1A7)"} !important`
    },
    'td[colorname="orange" i], th[colorname="orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtler, #FCE4A6)"} !important`
    },
    'td[colorname="magenta" i], th[colorname="magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`
    },
    'td[colorname="bold gray" i], th[colorname="bold gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"} !important`
    },
    'td[colorname="bold blue" i], th[colorname="bold blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"} !important`
    },
    'td[colorname="bold teal" i], th[colorname="bold teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"} !important`
    },
    'td[colorname="bold green" i], th[colorname="bold green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler-hovered, #97EDC9)"} !important`
    },
    'td[colorname="bold lime" i], th[colorname="bold lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"} !important`
    },
    'td[colorname="bold yellow" i], th[colorname="bold yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"} !important`
    },
    'td[colorname="bold orange" i], th[colorname="bold orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtler-hovered, #FBD779)"} !important`
    },
    'td[colorname="bold red" i], th[colorname="bold red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"} !important`
    },
    'td[colorname="bold magenta" i], th[colorname="bold magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"} !important`
    },
    'td[colorname="bold purple" i], th[colorname="bold purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"} !important`
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $5bbjm.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $l7YRm.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '&[data-initial-width-mode="content"]': {
            tableLayout: 'auto',
            width: 'auto'
        },
        // Skips top-layer surfaces. See top-layer/notes/decisions/top-layer-unsafe-selectors.md
        '& *:not(:where([popover], dialog, & :is([popover], dialog) *))': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $5bbjm.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $0ee114a72ff0f81f$var$roundedTableRemixBlockHighlightStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.${$0ee114a72ff0f81f$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.${$0ee114a72ff0f81f$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.${$0ee114a72ff0f81f$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderColor: "var(--ds-border-selected, #1868DB)"
        }
    }
});
const $0ee114a72ff0f81f$var$roundedTableOuterBorderOverlayStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderColor: 'transparent',
        position: 'relative',
        '&::after': {
            content: "''",
            position: 'absolute',
            inset: '-0.5px',
            border: `${(0, $l7YRm.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRadius: "var(--ds-radius-xlarge, 12px)",
            pointerEvents: 'none',
            zIndex: 1
        },
        '> tbody > tr > th[data-reaches-top], > tbody > tr > td[data-reaches-top]': {
            borderTopColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-bottom], > tbody > tr > td[data-reaches-bottom]': {
            borderBottomColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderLeftColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderRightColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
            borderBottomLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
            borderBottomRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        }
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`]: {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    // Keep the cloned sticky header rounded at the top while preserving a square bottom edge.
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        '> tbody > tr': {
            // The sticky table clone sets a row background locally; force it off so
            // the rounded header cells, not a square row box, own the visible fill.
            background: 'transparent !important'
        },
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left][data-reaches-bottom], > tbody > tr > td[data-reaches-left][data-reaches-bottom]': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right][data-reaches-bottom], > tbody > tr > td[data-reaches-right][data-reaches-bottom]': {
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left]::after, > tbody > tr > td[data-reaches-left]::after': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right]::after, > tbody > tr > td[data-reaches-right]::after': {
            borderBottomRightRadius: 0
        }
    }
});
const $0ee114a72ff0f81f$var$tableContentModeScopedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}:has(> table[data-initial-width-mode="content"]),
	.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}:has(> .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table[data-initial-width-mode="content"]),
	.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}:has(> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table[data-initial-width-mode="content"])`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'max-content !important',
        maxWidth: 'var(--renderer-table-max-width)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > colgroup > col`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'unset !important'
    }
});
const $0ee114a72ff0f81f$var$tableContentModeExtensionContainmentStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Content-mode tables need extension content to participate in intrinsic width calculation.
    // Keep containment for extensions in all other table modes so nested renderers stay constrained.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] .${(0, $cvo9f.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        containerType: 'normal'
    }
});
const $0ee114a72ff0f81f$var$tableContentModeNestedTableStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Nested tables may sit inside expands, extensions, or other blocks within the parent cell.
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cvo9f.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cvo9f.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        width: 'max-content !important',
        maxWidth: '100%'
    }
});
const $0ee114a72ff0f81f$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $l7YRm.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $0ee114a72ff0f81f$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $0ee114a72ff0f81f$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $0ee114a72ff0f81f$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $0ee114a72ff0f81f$var$rendererTableStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $lPNDS.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $l7YRm.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $l7YRm.tableMarginTop)}px)`,
            zIndex: `${(0, $5bbjm.akEditorStickyHeaderZIndex)}`,
            width: `${$0ee114a72ff0f81f$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $glREr.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $glREr.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $l7YRm.tableMarginTop)}px)`
        }
    }
});
const $0ee114a72ff0f81f$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$0ee114a72ff0f81f$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $0ee114a72ff0f81f$var$stickyScrollbarOverflowShadowFixStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`&.${(0, $lPNDS.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $lPNDS.shadowClassNames).LEFT_SHADOW}::before`]: {
            // The sticky scrollbar retains this space in the table container's layout even while hidden.
            bottom: "var(--ds-space-250, 20px)",
            height: 'auto'
        }
    }
});
const $0ee114a72ff0f81f$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $0ee114a72ff0f81f$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $l7YRm.tableCellPadding)}px`,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $2Ucf2.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// Sortable header cells render content inside an extra div, so mirror the th alignment there.
const $0ee114a72ff0f81f$var$rendererTableSortableColumnValignStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`th[data-valign='middle'].${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            [`th[data-valign='bottom'].${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end'
            }
        }
    }
});
const $0ee114a72ff0f81f$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $cvo9f.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $5bbjm.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $cvo9f.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $0ee114a72ff0f81f$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $0ee114a72ff0f81f$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $cvo9f.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $b82GM.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $0ee114a72ff0f81f$var$stickyHeaderStyles = /*#__PURE__*/ (0, $9dQre.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $5bbjm.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $5bbjm.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $0ee114a72ff0f81f$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $9dQre.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $5bbjm.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT}
		> .${(0, $4OX3h.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $5bbjm.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $5bbjm.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $5bbjm.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $5bbjm.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $5bbjm.blockNodesVerticalMargin)
        }
    }
});
// Match the first content sibling throughout streaming SSR and hydration. Emotion moves
// style elements to the head, which must not change code block or media group spacing.
// Keep these selectors less specific than the top-level lightweight code block override.
const $0ee114a72ff0f81f$var$blockSsrMarginStyles = {
    name: "1yr3pal",
    styles: "& .MediaGroup:not(:not(style, script) ~ *), & .code-block:not(:not(style, script) ~ *){margin-top:0;}& [data-layout-section] .MediaGroup:not(:not(style, script) ~ *), & [data-layout-section] .code-block:not(:not(style, script) ~ *), & li > .code-block:not(:not(style, script) ~ *){margin-top:0;}"
};
// Layout columns start with an empty margin-reset element. Ignore only streamed siblings
// between that element and the first code block/media group, preserving later block spacing.
const $0ee114a72ff0f81f$var$layoutBlockSsrMarginStyles = {
    name: "iiym4g",
    styles: "& [data-layout-column-start] ~ .code-block:not([data-layout-column-start] ~ :not(style, script) ~ *), & [data-layout-column-start] ~ .MediaGroup:not([data-layout-column-start] ~ :not(style, script) ~ *){margin-top:0;}"
};
const $0ee114a72ff0f81f$var$codeBlockInListSsrMarginSafariFixStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $9hOTY.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '> .code-block:not(:not(style, script) ~ *)': {
            marginTop: `-${(0, $5bbjm.akEditorLineHeight)}em !important`
        }
    }
});
const $0ee114a72ff0f81f$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $0ee114a72ff0f81f$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $0ee114a72ff0f81f$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $9hOTY.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $5bbjm.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $5bbjm.akEditorLineHeight)}em !important`
        }
    }
});
const $0ee114a72ff0f81f$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $5bbjm.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $0ee114a72ff0f81f$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $0ee114a72ff0f81f$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$0ee114a72ff0f81f$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $0ee114a72ff0f81f$var$rendererAnnotationStylesOld = /*#__PURE__*/ (0, $9dQre.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $0ee114a72ff0f81f$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $9dQre.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $0ee114a72ff0f81f$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $0ee114a72ff0f81f$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $5bbjm.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $0ee114a72ff0f81f$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $5bbjm.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $0ee114a72ff0f81f$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $g3vc1.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $g3vc1.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $g3vc1.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $g3vc1.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $g3vc1.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.denseEmojiHeightH1)}px`,
        width: `${(0, $g3vc1.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.denseEmojiHeightH2)}px`,
        width: `${(0, $g3vc1.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.denseEmojiHeightH3)}px`,
        width: `${(0, $g3vc1.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.denseEmojiHeightH4)}px`,
        width: `${(0, $g3vc1.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.defaultDenseEmojiHeight)}px`,
        width: `${(0, $g3vc1.defaultDenseEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`,
        height: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`,
        width: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`
    }
});
const $0ee114a72ff0f81f$var$scaledEmojiStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $g3vc1.defaultEmojiHeight)}px`,
        minHeight: `${(0, $g3vc1.defaultEmojiHeight)}px`,
        minWidth: `${(0, $g3vc1.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $g3vc1.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $g3vc1.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.scaledEmojiHeightH1)}px`,
        width: `${(0, $g3vc1.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.scaledEmojiHeightH2)}px`,
        width: `${(0, $g3vc1.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.scaledEmojiHeightH3)}px`,
        width: `${(0, $g3vc1.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.scaledEmojiHeightH4)}px`,
        width: `${(0, $g3vc1.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $g3vc1.defaultEmojiHeight)}px`,
        width: `${(0, $g3vc1.defaultEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`,
        height: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`,
        width: `${(0, $g3vc1.defaultInlineEmojiHeight)}px`
    }
});
const $0ee114a72ff0f81f$var$denseStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $g3vc1.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $5bbjm.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $g3vc1.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $5bbjm.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $g3vc1.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $5bbjm.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $cvo9f.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $0ee114a72ff0f81f$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $0ee114a72ff0f81f$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $0ee114a72ff0f81f$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $0ee114a72ff0f81f$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $0ee114a72ff0f81f$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $0ee114a72ff0f81f$var$syncBlockRendererStyles = {
    name: "g5u32w",
    styles: "margin:0;max-width:none;padding:0"
};
/**
 * Fake left/right table borders.
 *
 * Adapted from the editor-plugin-table behavior (see editor-common's
 * `tableSharedStyle()` in `editor-common/src/styles/shared/table.ts`). The
 * visible vertical edges of the table are painted by these absolutely-positioned
 * 1px divs that live inside the (non-scrolling) TABLE_CONTAINER, while the real
 * <table> left/right borders are made `transparent`. Because the divs are not
 * inside the horizontally scrolling TABLE_NODE_WRAPPER, they remain visible
 * regardless of scroll position — fixing the missing right border when an
 * overflowing table inside a reference synced block is scrolled all the way to
 * the left.
 *
 * The `height` formula adjusted for table in renderer
 */ const $0ee114a72ff0f81f$var$tableFakeBorderStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        // Mirror the editor's tableSharedStyle() rule from
        // `editor-common/src/styles/shared/table.ts` (lines 142-150). The fake
        // borders are absolutely positioned inside pm-table-container;
        // their height is adjusted for renderer to `100% - space.300 - space.250` so the border runs from
        // the top of the table to the bottom of the container
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'block',
            width: '1px',
            height: `calc(100% - ${"var(--ds-space-300, 24px)"} - ${"var(--ds-space-250, 20px)"})`,
            background: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
            position: 'absolute',
            top: "var(--ds-space-300, 24px)"
        },
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER}`]: {
            right: 0
        },
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER},
		.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true']`]: {
            left: 0
        }
    },
    // Make the real left/right table borders transparent so the fake border
    // divs above are the only painted vertical edges. Top/bottom borders on the
    // <table> element remain visible.
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $enwus.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent'
    }
});
const $0ee114a72ff0f81f$var$roundedTableFakeBorderOverlayStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $enwus.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $enwus.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $enwus.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'none'
        }
    }
});
const $0ee114a72ff0f81f$var$syncBlockStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $7VlAB.SyncBlockSharedCssClassName).renderer}, .${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $7VlAB.SyncBlockSharedCssClassName).error}, .${(0, $7VlAB.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $7VlAB.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $7VlAB.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    },
    [`.${(0, $7VlAB.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $0ee114a72ff0f81f$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId, isInsideSyncBlock: isInsideSyncBlock } = props;
    const isAdvancedLayoutsOn = (0, $797yE.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const isStickyScrollbarOn = (0, $ccrLN.isStickyScrollbarEnabled)(appearance);
    const baseFontSize = (0, $8tgQv.getBaseFontSize)(appearance, contentMode);
    const browser = (0, $jxkn6.getBrowserInfo)();
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.heading.h1']}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.heading.h2']}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.heading.h3']}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.heading.h4']}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.heading.h5']}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.heading.h6']}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $3VXSn.editorUGCTokensRefreshed)['editor.font.body']}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            '--ak-renderer-editor-font-small-text': (0, $3VXSn.editorUGCTokensRefreshed)['editor.font.body.small']
        },
        css: [
            (0, $5N1Y4.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $0ee114a72ff0f81f$var$baseFontStyle : $0ee114a72ff0f81f$var$originalBaseFontLineHeight,
            $0ee114a72ff0f81f$var$baseStyles,
            $0ee114a72ff0f81f$var$fontSizeStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$headingAnchorStyles : $0ee114a72ff0f81f$var$headingAnchorStylesDuplicateAnchor,
            $0ee114a72ff0f81f$var$headingAnchorButtonFocusVisibleStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$hideHeadingCopyLinkWrapperStyles : $0ee114a72ff0f81f$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $0ee114a72ff0f81f$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $0ee114a72ff0f81f$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? $0ee114a72ff0f81f$var$rendererFullWidthStyles : $0ee114a72ff0f81f$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max') && !(0, $ccrLN.isTableResizingEnabled)(appearance) && $0ee114a72ff0f81f$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? $0ee114a72ff0f81f$var$rendererMaxWidthStyles : $0ee114a72ff0f81f$var$oldRendererMaxWidthStyles),
            $0ee114a72ff0f81f$var$rovoTelepointerStyles,
            $0ee114a72ff0f81f$var$whitespaceSharedStyles,
            $0ee114a72ff0f81f$var$blockquoteSharedStyles,
            $0ee114a72ff0f81f$var$headingsSharedStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $0ee114a72ff0f81f$var$headingWrapperInlineFlowStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_heading_link_target_size') && $0ee114a72ff0f81f$var$headingAnchorWrapperTargetSizeStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$headingWithAlignmentStyles : $0ee114a72ff0f81f$var$headingWithAlignmentStylesDuplicateAnchor,
            $0ee114a72ff0f81f$var$ruleSharedStyles,
            contentMode === 'compact' && $0ee114a72ff0f81f$var$extensionStyle,
            contentMode === 'compact' ? $0ee114a72ff0f81f$var$paragraphStylesUGCScaledMargin : $0ee114a72ff0f81f$var$paragraphSharedStylesWithEditorUGC,
            $0ee114a72ff0f81f$var$listsSharedStyles,
            browser.gecko && $0ee114a72ff0f81f$var$listsSharedStylesForGekko,
            $0ee114a72ff0f81f$var$listItemHiddenMarkerStyles,
            $0ee114a72ff0f81f$var$indentationSharedStyles,
            $0ee114a72ff0f81f$var$indentationSharedStylesWithMarginFix,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$blockMarksSharedStyles : $0ee114a72ff0f81f$var$blockMarksSharedStylesDuplicateAnchor,
            $0ee114a72ff0f81f$var$codeMarkSharedStyles,
            $0ee114a72ff0f81f$var$shadowSharedStyle,
            $0ee114a72ff0f81f$var$dateSharedStyle,
            $0ee114a72ff0f81f$var$textColorStyles,
            $0ee114a72ff0f81f$var$backgroundColorStyles,
            !(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $0ee114a72ff0f81f$var$highlightLinksUnsetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $0ee114a72ff0f81f$export$a365082c2a191514,
            $0ee114a72ff0f81f$var$tasksAndDecisionsStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $0ee114a72ff0f81f$var$headingPanelStyles,
            $0ee114a72ff0f81f$var$smartCardStyles,
            $0ee114a72ff0f81f$var$smartCardStylesAvatarFix,
            $0ee114a72ff0f81f$var$headerSmartCardStyles,
            $0ee114a72ff0f81f$var$smartCardStylesAvatarMarginFix,
            $0ee114a72ff0f81f$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') && ((0, $5N1Y4.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$rendererAnnotationStyles : $0ee114a72ff0f81f$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes') && $0ee114a72ff0f81f$var$rendererAnnotationStylesCommentHeightFix,
            (0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$baseOtherStyles : $0ee114a72ff0f81f$var$baseOtherStylesDuplicateAnchor,
            $0ee114a72ff0f81f$var$expandSsrMarginStyles,
            // this should be placed after baseOtherStyles
            (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? $0ee114a72ff0f81f$var$extensionAsInlineStyle : $0ee114a72ff0f81f$var$oldExtensionAsInlineStyle,
            (0, $gdUUy.fg)('platform_forge_inline_bodied_macro') && [
                $0ee114a72ff0f81f$var$migratedInlineBodiedFlowStyle,
                $0ee114a72ff0f81f$var$forgeInlineBodiedSpacingStyle
            ],
            $0ee114a72ff0f81f$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$alignedHeadingAnchorStyle : $0ee114a72ff0f81f$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $0ee114a72ff0f81f$var$mediaSingleSharedStyle,
            $0ee114a72ff0f81f$var$firstWrappedMediaStyles,
            $0ee114a72ff0f81f$var$tableSharedStyle,
            (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $0ee114a72ff0f81f$var$roundedTableOuterBorderOverlayStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $0ee114a72ff0f81f$var$roundedTableRemixBlockHighlightStyles,
            $0ee114a72ff0f81f$var$tableContentModeScopedStyles,
            $0ee114a72ff0f81f$var$tableContentModeExtensionContainmentStyles,
            $0ee114a72ff0f81f$var$tableContentModeNestedTableStyles,
            $0ee114a72ff0f81f$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $gdUUy.fg)('platform_editor_bordered_panel_nested_in_table') && $0ee114a72ff0f81f$var$tableRendererNestedPanelStyles,
            $0ee114a72ff0f81f$var$isBackgroundClipBrowserFixNeeded() && $0ee114a72ff0f81f$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            $0ee114a72ff0f81f$var$firstNodeWithNotMarginTopWithNestedDnD,
            $0ee114a72ff0f81f$var$rendererTableStyles,
            isStickyScrollbarOn && $0ee114a72ff0f81f$var$stickyScrollbarStyles,
            isStickyScrollbarOn && (0, $3y2s4.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') && $0ee114a72ff0f81f$var$stickyScrollbarOverflowShadowFixStyles,
            $0ee114a72ff0f81f$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $0ee114a72ff0f81f$var$rendererTableSortableColumnStyles,
            allowColumnSorting && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) && $0ee114a72ff0f81f$var$rendererTableSortableColumnValignStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $5N1Y4.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $0ee114a72ff0f81f$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $0ee114a72ff0f81f$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $0ee114a72ff0f81f$var$rendererTableColumnStyles,
            $0ee114a72ff0f81f$var$stickyHeaderStyles,
            $0ee114a72ff0f81f$var$codeBlockAndLayoutStyles,
            $0ee114a72ff0f81f$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $0ee114a72ff0f81f$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $0ee114a72ff0f81f$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $0ee114a72ff0f81f$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $0ee114a72ff0f81f$var$gridRenderForCodeBlockStyles,
            browser.safari && $0ee114a72ff0f81f$var$codeBlockInListSafariFixStyles,
            $0ee114a72ff0f81f$var$blockSsrMarginStyles,
            $0ee114a72ff0f81f$var$layoutBlockSsrMarginStyles,
            browser.safari && $0ee114a72ff0f81f$var$codeBlockInListSsrMarginSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $0ee114a72ff0f81f$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $0ee114a72ff0f81f$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max') && $0ee114a72ff0f81f$var$responsiveBreakoutWidthFullWidth,
            (0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? contentMode === 'compact' ? $0ee114a72ff0f81f$var$scaledDenseEmojiStyles : $0ee114a72ff0f81f$var$scaledEmojiStyles : contentMode === 'compact' ? $0ee114a72ff0f81f$var$denseStyles : undefined,
            $0ee114a72ff0f81f$var$syncBlockStyles,
            $0ee114a72ff0f81f$var$centerWrapperStyles,
            isInsideSyncBlock ? $0ee114a72ff0f81f$var$syncBlockRendererStyles : null,
            isInsideSyncBlock && $0ee114a72ff0f81f$var$tableFakeBorderStyles,
            isInsideSyncBlock && (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $0ee114a72ff0f81f$var$roundedTableFakeBorderOverlayStyles : null,
            $0ee114a72ff0f81f$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};

});
parcelRegister("3VXSn", function(module, exports) {
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $ee3d01269356acfe$export$63adc0ebe3278d31);
const $ee3d01269356acfe$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});

parcelRegister("6gjZj", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c03664aa3e692b76$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c03664aa3e692b76$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c03664aa3e692b76$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c03664aa3e692b76$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $c03664aa3e692b76$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c03664aa3e692b76$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c03664aa3e692b76$export$4d0a7f76ad443516);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $hA4kh = parcelRequire("hA4kh");
const $c03664aa3e692b76$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c03664aa3e692b76$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c03664aa3e692b76$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c03664aa3e692b76$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c03664aa3e692b76$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $9dQre.css)(">.mediaInlineView-content-wrap>.", $c03664aa3e692b76$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c03664aa3e692b76$export$dd2e16f83ae6aa78, ",>.", $c03664aa3e692b76$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c03664aa3e692b76$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c03664aa3e692b76$export$dee15762144889b7 = /*#__PURE__*/ (0, $9dQre.css)(".", $c03664aa3e692b76$export$dd2e16f83ae6aa78, "{height:", (0, $hA4kh.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c03664aa3e692b76$var$inlineImageHeight((0, $hA4kh.referenceHeights)['h1'], -3), ";}h2{", $c03664aa3e692b76$var$inlineImageHeight((0, $hA4kh.referenceHeights)['h2'], -3), ";}h3{", $c03664aa3e692b76$var$inlineImageHeight((0, $hA4kh.referenceHeights)['h3'], -2), ";}h4{", $c03664aa3e692b76$var$inlineImageHeight((0, $hA4kh.referenceHeights)['h4'], -2), ";}h5{", $c03664aa3e692b76$var$inlineImageHeight((0, $hA4kh.referenceHeights)['h5'], -2), ";}h6{", $c03664aa3e692b76$var$inlineImageHeight((0, $hA4kh.referenceHeights)['h6'], -2), ";}");
const $c03664aa3e692b76$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c03664aa3e692b76$export$7ab34e219ce6eef}, ${(0, $hA4kh.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c03664aa3e692b76$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $9dQre.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $c03664aa3e692b76$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $9dQre.css)({
    borderColor: `var(${$c03664aa3e692b76$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c03664aa3e692b76$export$263a8a844c370a89}, ${(0, $hA4kh.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c03664aa3e692b76$export$263a8a844c370a89}, ${(0, $hA4kh.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("hA4kh", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $f271aff6f831e15d$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $f271aff6f831e15d$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $f271aff6f831e15d$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $f271aff6f831e15d$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $f271aff6f831e15d$export$c1317a9224e4d798);
const $f271aff6f831e15d$export$d722b7527b1834a8 = 250;
const $f271aff6f831e15d$export$da894f7669b4e67c = 200;
const $f271aff6f831e15d$export$286cf28b87ad4b4f = $f271aff6f831e15d$export$d722b7527b1834a8 / $f271aff6f831e15d$export$da894f7669b4e67c;
const $f271aff6f831e15d$export$64fe09732fb8680 = 0;
const $f271aff6f831e15d$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("5XYxj", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $fe99320fc4f4300c$export$99cdf122d0bb9f95);
const $fe99320fc4f4300c$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("dZp9s", function(module, exports) {
$parcel$export(module.exports, "EmojiSharedCssClassName", () => $f8640ccfe9933711$export$ee47248f9a998789);

var $55FVI = parcelRequire("55FVI");
const $f8640ccfe9933711$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $55FVI.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $55FVI.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $55FVI.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $55FVI.placeholder)
};

});
parcelRegister("55FVI", function(module, exports) {
$parcel$export(module.exports, "commonSelectedStyles", () => $5ae48d50414b5f2d$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $5ae48d50414b5f2d$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $5ae48d50414b5f2d$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $5ae48d50414b5f2d$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $5ae48d50414b5f2d$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $5ae48d50414b5f2d$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $5ae48d50414b5f2d$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $5ae48d50414b5f2d$export$22b19c311e9caa4);
$parcel$export(module.exports, "placeholder", () => $5ae48d50414b5f2d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "emojiPickerAddEmoji", () => $5ae48d50414b5f2d$export$b0fe756d87022806);
const $5ae48d50414b5f2d$export$8633a0edef8e95dd = 'emoji-common-selected';
const $5ae48d50414b5f2d$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $5ae48d50414b5f2d$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $5ae48d50414b5f2d$export$b06c4aab1d012063 = 'emoji-common-node';
const $5ae48d50414b5f2d$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $5ae48d50414b5f2d$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $5ae48d50414b5f2d$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $5ae48d50414b5f2d$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $5ae48d50414b5f2d$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $5ae48d50414b5f2d$export$b0fe756d87022806 = 'emoji-picker-add-emoji';

});


parcelRegister("5LDnu", function(module, exports) {
$parcel$export(module.exports, "richMediaClassName", () => $3567ca7a9a0e7c79$export$cfe6da7d522d87bb);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");
const $3567ca7a9a0e7c79$export$cfe6da7d522d87bb = 'rich-media-item';
const $3567ca7a9a0e7c79$var$wrappedMediaBreakoutPoint = 410;
const $3567ca7a9a0e7c79$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right, .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left, .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left, .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$3567ca7a9a0e7c79$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $3567ca7a9a0e7c79$export$b51dea84d928a378 = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $5bbjm.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right, .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left, .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-left, .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right + .${$3567ca7a9a0e7c79$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$3567ca7a9a0e7c79$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("9hOTY", function(module, exports) {
$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $7319531419669128$export$4ccd31bf665a88f6);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $7319531419669128$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};

});

parcelRegister("7VlAB", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSharedCssClassName", () => $6129aba5fd2fd9ef$export$84840734cffb342f);
$parcel$export(module.exports, "SyncBlockRendererDataAttributeName", () => $6129aba5fd2fd9ef$export$8c57d8325d08218b);
$parcel$export(module.exports, "BodiedSyncBlockSharedCssClassName", () => $6129aba5fd2fd9ef$export$628f41eb22ec9a2);
$parcel$export(module.exports, "SyncBlockLabelSharedCssClassName", () => $6129aba5fd2fd9ef$export$f75b6075afbd73af);
$parcel$export(module.exports, "SyncBlockStateCssClassName", () => $6129aba5fd2fd9ef$export$9b10dd4c500e3ce8);
const $6129aba5fd2fd9ef$var$prefix = 'ak-editor-sync-block';
const $6129aba5fd2fd9ef$export$84840734cffb342f = {
    prefix: $6129aba5fd2fd9ef$var$prefix,
    renderer: `${$6129aba5fd2fd9ef$var$prefix}__renderer`,
    error: `${$6129aba5fd2fd9ef$var$prefix}__error_state`,
    loading: `${$6129aba5fd2fd9ef$var$prefix}__loading_state`
};
const $6129aba5fd2fd9ef$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $6129aba5fd2fd9ef$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $6129aba5fd2fd9ef$export$628f41eb22ec9a2 = {
    prefix: $6129aba5fd2fd9ef$var$bodiedPrefix,
    renderer: `${$6129aba5fd2fd9ef$var$bodiedPrefix}__renderer`,
    content: `${$6129aba5fd2fd9ef$var$bodiedPrefix}__content`,
    selectionInside: `${$6129aba5fd2fd9ef$var$bodiedPrefix}__selection_inside`,
    // Applied by the node view when the block holds nothing but a single empty paragraph.
    // Emptiness is derived from the ProseMirror document rather than the rendered DOM, because
    // decorations (for example the selection marker's cursor widget) and ProseMirror's own
    // separator/trailing-break hack nodes are injected as children of that paragraph and make
    // DOM-shape heuristics unreliable. See EDITOR-8327.
    empty: `${$6129aba5fd2fd9ef$var$bodiedPrefix}__empty`
};
// Constant labelClassName value here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $6129aba5fd2fd9ef$var$labelClassName = 'ak-editor-sync-block__label';
const $6129aba5fd2fd9ef$export$f75b6075afbd73af = {
    labelClassName: $6129aba5fd2fd9ef$var$labelClassName
};
const $6129aba5fd2fd9ef$export$7e44804769d54f36 = 'disabled';
const $6129aba5fd2fd9ef$export$da351099a95c41a2 = 'view-mode';
const $6129aba5fd2fd9ef$export$ddb90512ea536019 = 'creation-loading';
const $6129aba5fd2fd9ef$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $6129aba5fd2fd9ef$export$9b10dd4c500e3ce8 = {
    disabledClassName: $6129aba5fd2fd9ef$export$7e44804769d54f36,
    viewModeClassName: $6129aba5fd2fd9ef$export$da351099a95c41a2,
    creationLoadingClassName: $6129aba5fd2fd9ef$export$ddb90512ea536019,
    draggingClassName: $6129aba5fd2fd9ef$export$52ab9fe57e8e4c2e
};

});

parcelRegister("fA0pJ", function(module, exports) {
$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $42e5a24e34c9536c$export$a7172b75d403a0e4);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $42e5a24e34c9536c$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};

});

parcelRegister("4OX3h", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $fb939754a5d414f2$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $fb939754a5d414f2$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $1J9lh = parcelRequire("1J9lh");

var $5bbjm = parcelRequire("5bbjm");

var $gCxu4 = parcelRequire("gCxu4");

var $cvo9f = parcelRequire("cvo9f");
const $fb939754a5d414f2$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $5bbjm.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $5bbjm.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $fb939754a5d414f2$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $9dQre.css)({
    [`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $fb939754a5d414f2$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $fb939754a5d414f2$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9dQre.css)(".", (0, $cvo9f.RendererCssClassName).DOCUMENT, ">.", $fb939754a5d414f2$export$afbde0e7339bed51.CONTAINER, " .", (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $5bbjm.blockNodesVerticalMargin), ";}");
};
const $fb939754a5d414f2$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ text: text, hideLineNumbers: hideLineNumbers = false, className: className }, ref)=>{
    const textRows = (0, $bSJIT.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const classNames = [
        $fb939754a5d414f2$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $gCxu4.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $fb939754a5d414f2$var$codeBlockSharedStyles,
            $fb939754a5d414f2$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        className: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, !hideLineNumbers && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        className: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $9dQre.jsx)("code", null, text)))));
});
var $fb939754a5d414f2$export$2e2bcd8739ae039 = $fb939754a5d414f2$var$LightWeightCodeBlock;

});


parcelRegister("6GoEk", function(module, exports) {
$parcel$export(module.exports, "TruncatedWrapper", () => $737c46cfa00beff7$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");
const $737c46cfa00beff7$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $9dQre.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $737c46cfa00beff7$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $737c46cfa00beff7$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: styles
    }, children);
};
class $737c46cfa00beff7$export$79ad592494094f07 extends (0, $bSJIT.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $9dQre.jsx)($737c46cfa00beff7$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("bPrs9", function(module, exports) {
$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $c6637073b8028b21$export$80ffe7e3c6bf25c3);
/* eslint-disable jsdoc/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");
function $c6637073b8028b21$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $bSJIT.useRef)(props);
    const prevFactory = (0, $bSJIT.useRef)(null);
    return (0, $bSJIT.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});



parcelRegister("e5oK8", function(module, exports) {
$parcel$export(module.exports, "HubRendererWrapperGated", () => $69ce70d057c0a6f5$export$1f620b69b87fadbd);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
// When the space-density experience is active, HubSpacingScope / hub-home-content
// set `--ak-editor-extension-block-spacing` on an ancestor. The wrapper reads
// that variable (falling back to `0`) as top/bottom PADDING on each bespoke hub
// extension, so the vertical rhythm between extensions follows the selected
// density. Padding (not margin) is used deliberately so adjacent extensions do
// not margin-collapse — the gap between two extensions is the sum of the lower
// extension's top padding and the upper extension's bottom padding. When the
// variable is unset the padding is `0`, so this is a no-op for hubs without a
// density selected.
const $69ce70d057c0a6f5$var$extensionBlockPadding = 'var(--ak-editor-extension-block-spacing, 0)';
const $69ce70d057c0a6f5$export$1a063b7cda785385 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1e6s8tqg _1e111zeq _10xj1mtz _utchidpf _ovodidpf _17qaidpf _rtpd1uiu _1c211uiu _1frp1uiu _qndeidpf _1k6kidpf _icwmidpf _tjcw1uiu _mctt1uiu _6b941uiu _1p9ml5sy _1awjl5sy _1eejl5sy _tnsdl5sy _127ml5sy _1x7bl5sy _128soahv _s8ydoahv _jxcqoahv _1o1joahv _1bweoahv _1clwoahv _1cw7ovzw _yqhmovzw _uo9kovzw _1a031ssb _1fd01ssb _r3nk1ssb _x0t7zr6s _ato1zr6s _l6q3zr6s _14cjbxvg _13rbbxvg _1drwbxvg _1gyg274h _78a5274h _owha274h _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});
const $69ce70d057c0a6f5$var$HubRendererWrapperWithPadding = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_bozg1ejb _y4ti1ejb _xx6j4sbg _cyqw4sbg _1fv712ar _pw4g12ar _19d8e27k _zhdke27k _1e6s8tqg _1e111zeq _10xj1mtz _utchidpf _ovodidpf _17qaidpf _rtpd1uiu _1c211uiu _1frp1uiu _qndeidpf _1k6kidpf _icwmidpf _tjcw1uiu _mctt1uiu _6b941uiu _1p9ml5sy _1awjl5sy _1eejl5sy _tnsdl5sy _127ml5sy _1x7bl5sy _128soahv _s8ydoahv _jxcqoahv _1o1joahv _1bweoahv _1clwoahv _1cw7ovzw _yqhmovzw _uo9kovzw _1a031ssb _1fd01ssb _r3nk1ssb _x0t7zr6s _ato1zr6s _l6q3zr6s _14cjbxvg _13rbbxvg _1drwbxvg _1gyg274h _78a5274h _owha274h _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});
const $69ce70d057c0a6f5$export$1f620b69b87fadbd = ({ appearance: appearance, children: children, product: product, ...props })=>{
    const maxWidth = appearance === 'max' ? true : undefined;
    // Help-seeker (JSM) hub content always keeps its horizontal page inset,
    // independently of appearance and navbar padding.
    const shouldApplyPadding = product === 'JSM';
    if (shouldApplyPadding) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($69ce70d057c0a6f5$var$HubRendererWrapperWithPadding, {
        ...props,
        "data-hub-max-width": maxWidth
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($69ce70d057c0a6f5$export$1a063b7cda785385, {
        ...props,
        "data-hub-max-width": maxWidth
    }, children);
};

});

parcelRegister("kQyQK", function(module, exports) {
$parcel$export(module.exports, "getSectionExtensionContents", () => $99b6aa80ac485f98$export$993dca3597b448e8);

var $8e3A8 = parcelRequire("8e3A8");
const $99b6aa80ac485f98$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $8e3A8.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
                        extensionType: (0, $8e3A8.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];

});
parcelRegister("8e3A8", function(module, exports) {
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE", () => $b972c01c4837bc0b$export$c14e692c91462ed4);
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY", () => $b972c01c4837bc0b$export$ca3a94184e0fbd97);
const $b972c01c4837bc0b$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $b972c01c4837bc0b$export$ca3a94184e0fbd97 = 'hub-element-placeholder';

});


parcelRegister("jPHrM", function(module, exports) {
$parcel$export(module.exports, "sectionExtensionProvider", () => $232d2030b7cd20bb$export$6775abcfdb3b0453);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $ldjCx = parcelRequire("ldjCx");

var $1qPbZ = parcelRequire("1qPbZ");

var $53RlD = parcelRequire("53RlD");

var $glTif = parcelRequire("glTif");

var $4rJjw = parcelRequire("4rJjw");

var $2baza = parcelRequire("2baza");

const $232d2030b7cd20bb$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: async ()=>(await (parcelRequire("ceQhd"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "section-extension-loader"
        })
});
const $232d2030b7cd20bb$var$sectionParameters = (intl, defaultBackgroundColor)=>({
        extensionTitle: intl.formatMessage((0, $2baza.messages).lozengeTitle),
        backgroundColor: defaultBackgroundColor,
        contentWidth: (0, $4rJjw.DEFAULT_CONTENT_WIDTH)
    });

const $232d2030b7cd20bb$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider, defaultParameters: defaultParameters })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $2baza.messages).lozengeTitle);
        const description = intl.formatMessage((0, $2baza.messages).description);
        // Only honour the v2 seed when advanced theming is on. Falls back to the
        // legacy `DEFAULT_BACKGROUND_COLOR` for Confluence/CSM/gate-OFF help-center.
        const defaultBackgroundColor = defaultParameters !== null && defaultParameters !== void 0 && defaultParameters.isAdvancedThemingEnabled && defaultParameters.backgroundColor ? defaultParameters.backgroundColor : (0, $4rJjw.DEFAULT_BACKGROUND_COLOR);
        const parameters = $232d2030b7cd20bb$var$sectionParameters(intl, defaultBackgroundColor);
        const type = (0, $53RlD.SECTION_EXTENSION_TYPE);
        const key = (0, $4rJjw.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $2baza.messages).contentHeader),
            subHeader: intl.formatMessage((0, $2baza.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $2baza.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>(parcelRequire("fTYqA")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            var _editorActions$getSel, _selectedNode$attrs;
            const selectedNode = editorActions === null || editorActions === void 0 || (_editorActions$getSel = editorActions.getSelectedNode()) === null || _editorActions$getSel === void 0 ? void 0 : _editorActions$getSel.toJSON();
            const selectedLocalId = selectedNode === null || selectedNode === void 0 || (_selectedNode$attrs = selectedNode.attrs) === null || _selectedNode$attrs === void 0 ? void 0 : _selectedNode$attrs.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($232d2030b7cd20bb$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $ldjCx.default)([
            (0, $glTif.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };

});
parcelRegister("ldjCx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6396aa2bbbed393f$export$2e2bcd8739ae039);

var $3N8vx = parcelRequire("3N8vx");
class $6396aa2bbbed393f$export$2e2bcd8739ae039 {
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsCache = [];
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            var _manifest$modules;
            const nodes = manifest === null || manifest === void 0 || (_manifest$modules = manifest.modules) === null || _manifest$modules === void 0 ? void 0 : _manifest$modules.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                var _preloadRender, _ref;
                preloadCalls.push(node === null || node === void 0 || (_preloadRender = (_ref = node).preloadRender) === null || _preloadRender === void 0 ? void 0 : _preloadRender.call(_ref));
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $3N8vx.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
}

});
parcelRegister("3N8vx", function(module, exports) {
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $e861eb9044658254$export$60407594ea5edd1c);
async function $e861eb9044658254$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}

});


parcelRegister("glTif", function(module, exports) {
$parcel$export(module.exports, "getExtensionManifest", () => $9bfc8c1b3d427576$export$573ee875a39e7e73);
const $9bfc8c1b3d427576$export$573ee875a39e7e73 = ({ key: key, icons: icons, parameters: parameters, update: update, render: render, title: title, type: type, description: description, source: source, nodeType: nodeType = 'extension', quickInsertAction: quickInsertAction, preview: preview, setUpsellModalSource: setUpsellModalSource, additionalModuleNodeProps: additionalModuleNodeProps })=>{
    return {
        title: title,
        type: type,
        key: key,
        description: description,
        icons: icons,
        ...preview && {
            preview: preview
        },
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'quick-insert',
                    action: async ()=>setUpsellModalSource(source)
                }
            ] : [
                {
                    key: 'quick-insert',
                    action: quickInsertAction || {
                        type: 'node',
                        key: 'default',
                        parameters: parameters
                    }
                }
            ],
            nodes: {
                default: {
                    type: nodeType,
                    render: render,
                    update: update,
                    ...additionalModuleNodeProps
                }
            }
        }
    };
};

});

parcelRegister("4rJjw", function(module, exports) {
$parcel$export(module.exports, "SECTION_EXTENSION_KEY", () => $880a91da95c4da5d$export$bc69bf23ec1f99d5);
$parcel$export(module.exports, "SECTION_EXTENSION_ANALYTICS_SOURCE", () => $880a91da95c4da5d$export$7a75cc6a69e05549);
$parcel$export(module.exports, "CONTENT_WIDTH", () => $880a91da95c4da5d$export$3130b484681bf8bc);
$parcel$export(module.exports, "DEFAULT_CONTENT_WIDTH", () => $880a91da95c4da5d$export$6cccba5fae1d609d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $880a91da95c4da5d$export$617cdcc6afaae4f7);
const $880a91da95c4da5d$export$bc69bf23ec1f99d5 = 'hub-section';
const $880a91da95c4da5d$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $880a91da95c4da5d$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $880a91da95c4da5d$export$6cccba5fae1d609d = "wide";
const $880a91da95c4da5d$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";

});

parcelRegister("2baza", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1f0e40233c7384c7$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $1f0e40233c7384c7$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    lozengeTitle: {
        id: 'company-hub.section-extension.manifest.extension-lozenge-title',
        defaultMessage: 'Section',
        description: 'Title of section extension to be displayed in lozenge/quick insert menu.'
    },
    description: {
        id: 'company-hub.section-extension.manifest.macro-description',
        defaultMessage: 'Group elements together with a background',
        description: 'Description of section extension to be displayed in toolbar/shortcut macros dropdown'
    },
    contentHeader: {
        id: 'company-hub.section-extension.manifest.content.header',
        defaultMessage: 'Give your section a title',
        description: "Header of section extension's initial content"
    },
    contentSubHeader: {
        id: 'company-hub.section-extension.manifest.content.sub-header',
        defaultMessage: 'Organize elements into sections with customizable backgrounds.',
        description: "Sub-header of section extension's initial content"
    },
    placeHolderTitle: {
        id: 'company-hub.section-extension.manifest.content.placeholder-title',
        defaultMessage: 'Placeholder',
        description: 'Title of hub element placeholder extension to be displayed the macro is presented in the editor.'
    }
});

});

parcelRegister("ceQhd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lkbEv").then(()=>parcelRequire('abqbf'));

});

parcelRegister("fTYqA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kPSZr").then(()=>parcelRequire('jaNoS'));

});


parcelRegister("454jH", function(module, exports) {
$parcel$export(module.exports, "useHubExtensionHandlers", () => $bb9f01908a3825ec$export$617d11c0fd386821);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $1qPbZ = parcelRequire("1qPbZ");

var $lvwGW = parcelRequire("lvwGW");

var $dTsZV = parcelRequire("dTsZV");

var $53RlD = parcelRequire("53RlD");

var $4nock = parcelRequire("4nock");

var $l3KBS = parcelRequire("l3KBS");

const $bb9f01908a3825ec$var$SpotlightExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: async ()=>(await (parcelRequire("jNHqw"))).SpotlightExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "spotlight-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null))
});

const $bb9f01908a3825ec$var$LinksMenuLoader = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: async ()=>(await (parcelRequire("dsUaR"))).LinksMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "links-menu-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null))
});

const $bb9f01908a3825ec$export$b55cedbe49066c7 = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: async ()=>(await (parcelRequire("iXxix"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "cards-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null))
});

const $bb9f01908a3825ec$var$CarouselLoader = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: async ()=>(await (parcelRequire("dy5I8"))).Carousel,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "carousel-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null))
});

const $bb9f01908a3825ec$var$SectionExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: async ()=>(await (parcelRequire("ceQhd"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1qPbZ.default), {
            name: "section-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null))
});
const $bb9f01908a3825ec$export$617d11c0fd386821 = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider } = props;
    const extensionHandlers = {
        [(0, $53RlD.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null),
        [(0, $l3KBS.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null),
        [(0, $lvwGW.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null),
        [(0, $dTsZV.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null),
        [(0, $53RlD.SECTION_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null)
    };
    const defaultExtensionHandlerProps = (0, $bSJIT.useMemo)(()=>({
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $4nock.ExtensionMode).RENDERER
        }), [
        contentId,
        PropsProvider
    ]);
    const spotlightExtension = (0, $bSJIT.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bb9f01908a3825ec$var$SpotlightExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const linksMenuExtension = (0, $bSJIT.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bb9f01908a3825ec$var$LinksMenuLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const cardsExtension = (0, $bSJIT.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bb9f01908a3825ec$export$b55cedbe49066c7, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const carouselExtension = (0, $bSJIT.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bb9f01908a3825ec$var$CarouselLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const sectionExtension = (0, $bSJIT.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bb9f01908a3825ec$var$SectionExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    if (contentId) {
        extensionHandlers[0, $53RlD.SPOTLIGHT_EXTENSION_TYPE] = spotlightExtension;
        extensionHandlers[0, $l3KBS.LINKS_MENU_EXTENSION_TYPE] = linksMenuExtension;
        extensionHandlers[0, $lvwGW.CARDS_EXTENSION_TYPE] = cardsExtension;
        extensionHandlers[0, $dTsZV.carouselExtensionType] = carouselExtension;
        extensionHandlers[0, $53RlD.SECTION_EXTENSION_TYPE] = sectionExtension;
    }
    return extensionHandlers;
};

});
parcelRegister("lvwGW", function(module, exports) {
$parcel$export(module.exports, "CARDS_EXTENSION_TYPE", () => $d3dbe2971a8ac386$export$81e5b59a1e176638);
$parcel$export(module.exports, "CARDS_EXTENSION_KEY", () => $d3dbe2971a8ac386$export$8a4891a61ff91b00);
$parcel$export(module.exports, "CARDS_EXTENSION_ANALYTIC_SOURCE", () => $d3dbe2971a8ac386$export$67bfcae6d68bb0bf);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $d3dbe2971a8ac386$export$7f17fab0aecb44ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE", () => $d3dbe2971a8ac386$export$6a35a50674becbae);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE", () => $d3dbe2971a8ac386$export$9bf56665bf6ea6ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE", () => $d3dbe2971a8ac386$export$cf23b6d2fd159502);
$parcel$export(module.exports, "DYNAMIC_CARDS_SEARCH_EXPERIENCE", () => $d3dbe2971a8ac386$export$97dc3a9d9f5d9aa3);
$parcel$export(module.exports, "CARDS_EXTENSION_VERSION_5", () => $d3dbe2971a8ac386$export$b84f9a7c097c895c);
$parcel$export(module.exports, "CARDS_IMAGES_V5", () => $d3dbe2971a8ac386$export$5e905747d7497a1f);
const $d3dbe2971a8ac386$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $d3dbe2971a8ac386$export$8a4891a61ff91b00 = 'cards';
const $d3dbe2971a8ac386$export$67bfcae6d68bb0bf = 'cardsExtension';
const $d3dbe2971a8ac386$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $d3dbe2971a8ac386$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $d3dbe2971a8ac386$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $d3dbe2971a8ac386$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $d3dbe2971a8ac386$export$97dc3a9d9f5d9aa3 = 'dynamic-cards';
const $d3dbe2971a8ac386$export$131b76b4d30d2b44 = '2';
const $d3dbe2971a8ac386$export$a08b7507bedba276 = '3';
const $d3dbe2971a8ac386$export$c87753a8bb0c4e75 = '4';
const $d3dbe2971a8ac386$export$b84f9a7c097c895c = '5';
const $d3dbe2971a8ac386$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];

});

parcelRegister("dTsZV", function(module, exports) {
$parcel$export(module.exports, "carouselExtensionType", () => $009402032c7f47fd$export$a06ac4f1777262dc);
$parcel$export(module.exports, "carouselExtensionKey", () => $009402032c7f47fd$export$6c8179fa243b4399);
$parcel$export(module.exports, "carouselContentAnalyticSource", () => $009402032c7f47fd$export$ca14f22a239c4ae9);
$parcel$export(module.exports, "carouselConfigAnalyticSource", () => $009402032c7f47fd$export$4cb671946a80c52e);
$parcel$export(module.exports, "AUTOPLAY_SECONDS", () => $009402032c7f47fd$export$93995a2609cff38d);
$parcel$export(module.exports, "ARIA_CONTROLS_PREFIX", () => $009402032c7f47fd$export$3a86d0fc7eb402f4);
$parcel$export(module.exports, "CAROUSEL_VERSION_2", () => $009402032c7f47fd$export$b429752dfe934bea);
$parcel$export(module.exports, "FRAMES_LIMIT_V2", () => $009402032c7f47fd$export$c5c6e75ceae0cc22);
const $009402032c7f47fd$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $009402032c7f47fd$export$6c8179fa243b4399 = 'carousel';
const $009402032c7f47fd$export$ca14f22a239c4ae9 = 'carouselExtension';
const $009402032c7f47fd$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $009402032c7f47fd$export$93995a2609cff38d = 8;
const $009402032c7f47fd$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $009402032c7f47fd$export$9575b4f5d97a1c29 = '1';
const $009402032c7f47fd$export$b429752dfe934bea = '2';
const $009402032c7f47fd$export$c5c6e75ceae0cc22 = 10;

});

parcelRegister("l3KBS", function(module, exports) {
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_TYPE", () => $bf5a8622c2b73aa3$export$9fdf64a495514b4);
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_ANALYTIC_SOURCE", () => $bf5a8622c2b73aa3$export$ed5854f17099adbf);
const $bf5a8622c2b73aa3$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $bf5a8622c2b73aa3$export$ed5854f17099adbf = 'linksMenuExtension';

});

parcelRegister("jNHqw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("q4UE8"),
    $kOunM("7BxI2"),
    $kOunM("dPPJp")
]).then(()=>parcelRequire('h7Whi'));

});

parcelRegister("dsUaR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fIoT1"),
    $kOunM("13s7O")
]).then(()=>parcelRequire('bGJdr'));

});

parcelRegister("iXxix", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("apGcy"),
    $kOunM("5jI7I"),
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("lzQaK"),
    $kOunM("bYQHQ"),
    $kOunM("eCdiR"),
    $kOunM("fs156"),
    $kOunM("2iKrl"),
    $kOunM("eo13b"),
    $kOunM("d3ovF"),
    $kOunM("1jZR6"),
    $kOunM("ef2p4"),
    $kOunM("2OWEg"),
    $kOunM("9oDwW"),
    $kOunM("de818"),
    $kOunM("cZUzS"),
    $kOunM("l1iNV"),
    $kOunM("JcBsL"),
    $kOunM("dVPBt"),
    $kOunM("k8thC"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("fCONc"),
    $kOunM("aP2xO")
]).then(()=>parcelRequire('3Y2MR'));

});

parcelRegister("dy5I8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fifd4"),
    $kOunM("q4UE8"),
    $kOunM("6uVjJ"),
    $kOunM("jW0vi"),
    $kOunM("zG40Z")
]).then(()=>parcelRequire('eZxwD'));

});



parcelRegister("kgjcI", function(module, exports) {
$parcel$export(module.exports, "RovoWidgetConfigProvider", () => $b9f41f3d9332538e$export$f5c8aa8bbd79048b);
$parcel$export(module.exports, "useOptionalRovoWidgetConfig", () => $b9f41f3d9332538e$export$7214a7b21115b7c6);

var $bSJIT = parcelRequire("bSJIT");
const $b9f41f3d9332538e$var$RovoWidgetConfigContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $b9f41f3d9332538e$export$f5c8aa8bbd79048b = ({ rovoWidgetConfig: rovoWidgetConfig, children: children })=>{
    const [value] = (0, $bSJIT.useState)({
        rovoWidgetConfig: rovoWidgetConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($b9f41f3d9332538e$var$RovoWidgetConfigContext.Provider, {
        value: value
    }, children);
};
const $b9f41f3d9332538e$export$7214a7b21115b7c6 = ()=>{
    return (0, $bSJIT.useContext)($b9f41f3d9332538e$var$RovoWidgetConfigContext);
};
const $b9f41f3d9332538e$export$1092b6d5a83d6e = ()=>{
    const contextValue = (0, $bSJIT.useContext)($b9f41f3d9332538e$var$RovoWidgetConfigContext);
    if (!contextValue) throw new Error('useRovoWidgetConfig must be used within a RovoWidgetConfigProvider');
    return contextValue;
};

});

parcelRegister("8RVjM", function(module, exports) {
$parcel$export(module.exports, "useProductExtensionHandlers", () => $910b1f62905fbf88$export$f8392d0e24abe6db);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $1qPbZ = parcelRequire("1qPbZ");

var $4LjSf = parcelRequire("4LjSf");

var $g04TG = parcelRequire("g04TG");

var $53RlD = parcelRequire("53RlD");

var $4nock = parcelRequire("4nock");

var $djPMW = parcelRequire("djPMW");

var $jaAJZ = parcelRequire("jaAJZ");

var $64bRo = parcelRequire("64bRo");

var $lW1DY = parcelRequire("lW1DY");

const $910b1f62905fbf88$var$CalloutBannerExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("1ShQP")).then((mod)=>({
            default: mod.CalloutBannerExtension
        })));

const $910b1f62905fbf88$var$ResourceTilesExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("l3V9O")).then((mod)=>({
            default: mod.ResourceTilesExtension
        })));

const $910b1f62905fbf88$var$JSMHelpExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("bnwyJ")).then((mod)=>({
            default: mod.JSMHelpExtension
        })));

const $910b1f62905fbf88$var$HubForgeExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("3NA2Y")).then((mod)=>({
            default: mod.HubForgeExtension
        })));

const $910b1f62905fbf88$var$HubConnectExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("8c7Wl")).then((mod)=>({
            default: mod.HubConnectExtension
        })));
// Host-gated: `forge-on-hubs` for Help Hub / JSM, `forge-on-csm-hubs` for CSM.
const $910b1f62905fbf88$var$getHubForgeAndConnectExtensionHandlers = (contentId, PropsProvider, gateName = 'forge-on-hubs')=>{
    if (!(0, $gdUUy.fg)(gateName)) return {};
    const handlers = {};
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $4nock.ExtensionMode).RENDERER
    };
    handlers[0, $jaAJZ.HUB_FORGE_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                name: "hub-forge-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)($910b1f62905fbf88$var$HubForgeExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    handlers[0, $djPMW.HUB_CONNECT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                name: "hub-connect-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)($910b1f62905fbf88$var$HubConnectExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    return handlers;
};
const $910b1f62905fbf88$var$getCSMExtensionHandlers = (contentId, PropsProvider)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $4nock.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $4LjSf.ArticleSearchComponent)
    };
    // Callout banner Extension Handler
    handlers[0, $lW1DY.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)($910b1f62905fbf88$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    // Resource Tiles Extension Handler
    handlers[0, $53RlD.RESOURCE_TILES_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                name: "resource-tiles-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)($910b1f62905fbf88$var$ResourceTilesExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension,
                isInEditor: false
            })
        });
    Object.assign(handlers, $910b1f62905fbf88$var$getHubForgeAndConnectExtensionHandlers(contentId, PropsProvider, 'forge-on-csm-hubs'));
    return handlers;
};
const $910b1f62905fbf88$var$getJSMExtensionHandlers = (contentId, PropsProvider, rovoWidgetQueryReference)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $4nock.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $g04TG.HelpObjectSearchComponent)
    };
    handlers[0, $lW1DY.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)($910b1f62905fbf88$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension,
                rovoWidgetQueryReference: rovoWidgetQueryReference
            })
        });
    // JSM Help Extension Handler
    handlers[0, $64bRo.JSM_HELP_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1qPbZ.default), {
                name: "jsm-help-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)($910b1f62905fbf88$var$JSMHelpExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    Object.assign(handlers, $910b1f62905fbf88$var$getHubForgeAndConnectExtensionHandlers(contentId, PropsProvider));
    return handlers;
};
const $910b1f62905fbf88$export$f8392d0e24abe6db = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider, product: product, rovoWidgetQueryReference: rovoWidgetQueryReference } = props;
    const extensionHandlers = (0, $bSJIT.useMemo)(()=>{
        if (product === 'CUSTOMER_SERVICE') return $910b1f62905fbf88$var$getCSMExtensionHandlers(contentId, PropsProvider);
        // Rovo in the callout banner is only available in help hubs, so the
        // preloaded Rovo widget query is only forwarded here.
        if (product === 'HELP_HUB' && (0, $gdUUy.fg)('enable-jsm-in-hubs')) return $910b1f62905fbf88$var$getJSMExtensionHandlers(contentId, PropsProvider, rovoWidgetQueryReference);
        return {};
    }, [
        product,
        contentId,
        PropsProvider,
        rovoWidgetQueryReference
    ]);
    return extensionHandlers;
};

});
parcelRegister("4LjSf", function(module, exports) {
$parcel$export(module.exports, "ArticleSearchComponent", () => $5aa30ff7e73c5426$export$8a672206592a1254);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $26Jy2 = parcelRequire("26Jy2");

var $9PwDt = parcelRequire("9PwDt");

var $4uQUf = parcelRequire("4uQUf");

var $2EplR = parcelRequire("2EplR");

var $8wu2X = parcelRequire("8wu2X");

var $jebvR = parcelRequire("jebvR");
const $5aa30ff7e73c5426$export$8a672206592a1254 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $bSJIT.useState)('');
    const [showDropdown, setShowDropdown] = (0, $bSJIT.useState)(false);
    const inputBoxRef = (0, $bSJIT.useRef)(null);
    const inputRef = (0, $bSJIT.useRef)(null);
    const [_, setInputWidth] = (0, $bSJIT.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, helpCenterAri: helpCenterAri } = (0, $4uQUf.useProductDependencies)();
    (0, $bSJIT.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $bAB3U.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $bSJIT.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            ref: inputBoxRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jebvR.SearchTextField), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onInput: handleInput,
            isReadOnly: isEditor,
            placeholderText: placeholderText,
            showDropdown: showDropdown,
            queryWord: queryWord
        }));
    }, [
        isEditor,
        placeholderText,
        showDropdown,
        queryWord
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2EplR.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8wu2X.SearchDropdown), {
                ...contentProps,
                cloudId: cloudId,
                helpCenterAri: helpCenterAri || '',
                inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                queryWord: queryWord
            }));
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("2EplR", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $b19fb24fe8b43d5c$export$4da28cf324280418);
$parcel$export(module.exports, "KeyboardHighlightProvider", () => $b19fb24fe8b43d5c$export$c8551b32665b42b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $b19fb24fe8b43d5c$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    selectComponentByTrackingId: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $b19fb24fe8b43d5c$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const navigationTrackingId = (options === null || options === void 0 ? void 0 : options.navigationTrackingId) ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $bSJIT.useContext)($b19fb24fe8b43d5c$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const onKeydownCallback = options === null || options === void 0 ? void 0 : options.onKeydownCallback;
    const onHighlightedCallback = options === null || options === void 0 ? void 0 : options.onHighlightedCallback;
    const unregister = (0, $bSJIT.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $bSJIT.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $bSJIT.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $bSJIT.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
const $b19fb24fe8b43d5c$export$c8551b32665b42b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ children: children, listenerNode: listenerNode, onSelectedElementChange: onSelectedElementChange }, ref)=>{
    const currentlySelectedRef = (0, $bSJIT.useRef)(undefined);
    const currentSelectedTrackingIdRef = (0, $bSJIT.useRef)(null);
    const keyboardNavComponentsRef = (0, $bSJIT.useRef)([]);
    const getSelectedIndex = (0, $bSJIT.useCallback)(()=>{
        const currentlySelected = currentlySelectedRef.current;
        if (!currentlySelected) return undefined;
        return keyboardNavComponentsRef.current.findIndex(({ id: id })=>id === currentlySelected);
    }, []);
    const getSearchIdIndex = (0, $bSJIT.useCallback)((searchId)=>searchId === null ? undefined : keyboardNavComponentsRef.current.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), []);
    const unhighlightComponentAt = (0, $bSJIT.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) components[index].onHighlightChanged(false);
    }, []);
    const highlightComponentAt = (0, $bSJIT.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (index >= 0 && index < components.length) {
            const { id: id, navigationTrackingId: navigationTrackingId } = components[index];
            currentlySelectedRef.current = id;
            currentSelectedTrackingIdRef.current = navigationTrackingId;
            components[index].onHighlightChanged(true);
            onSelectedElementChange === null || onSelectedElementChange === void 0 || onSelectedElementChange(navigationTrackingId || undefined);
        }
    }, [
        onSelectedElementChange
    ]);
    const unhighlightAll = (0, $bSJIT.useCallback)(()=>{
        currentSelectedTrackingIdRef.current = null;
        currentlySelectedRef.current = undefined;
        onSelectedElementChange === null || onSelectedElementChange === void 0 || onSelectedElementChange(undefined);
        keyboardNavComponentsRef.current.forEach((component)=>component.onHighlightChanged(false));
    }, [
        onSelectedElementChange
    ]);
    const onHighlightedCallback = (0, $bSJIT.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const callback = components[index].onHighlightedCallback;
            callback && callback(index);
        }
    }, []);
    const selectComponentByTrackingId = (0, $bSJIT.useCallback)((trackingId)=>{
        const index = getSearchIdIndex(trackingId);
        if (index === undefined || index < 0) return undefined;
        unhighlightAll();
        highlightComponentAt(index);
        onHighlightedCallback(index);
        return index;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        onHighlightedCallback,
        unhighlightAll
    ]);
    const onKeyDownCallbackAt = (0, $bSJIT.useCallback)((index, e)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const onKeyDown = components[index].onKeyDownWhenHighlighted;
            onKeyDown && onKeyDown(e, components[index].domRef);
        }
    }, []);
    const registerKeyboardEnabled = (0, $bSJIT.useCallback)((currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCb)=>{
        const components = keyboardNavComponentsRef.current;
        const indexAt = components.findIndex(({ id: id })=>id === currentId);
        // If the currentId is null or we can't find any records of the id we will create a new entry
        const isNew = currentId === null || currentId === undefined || indexAt === -1;
        const id = isNew ? Math.max(...components.map((component)=>component.id), 0) + 1 : components[indexAt].id;
        if (isNew) components.push({
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        });
        else // Otherwise we will update the current entry
        components[indexAt] = {
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        };
        keyboardNavComponentsRef.current = components.sort((c1, c2)=>{
            const result = c1.domRef.compareDocumentPosition(c2.domRef);
            if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
        const indexToHighlight = getSearchIdIndex(currentSelectedTrackingIdRef.current);
        if (indexToHighlight !== undefined && indexToHighlight >= 0) {
            unhighlightAll();
            highlightComponentAt(indexToHighlight);
        }
        return id;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
    const unregisterKeyboardEnabled = (0, $bSJIT.useCallback)((unregisterRef)=>{
        if (currentlySelectedRef.current === unregisterRef) {
            currentlySelectedRef.current = undefined;
            onSelectedElementChange === null || onSelectedElementChange === void 0 || onSelectedElementChange(undefined);
        }
        keyboardNavComponentsRef.current = keyboardNavComponentsRef.current.filter(({ id: ref })=>ref !== unregisterRef);
        // Reset currentSelectedTrackingId when all components are unregistered
        if (keyboardNavComponentsRef.current.length === 0) currentSelectedTrackingIdRef.current = null;
    }, [
        onSelectedElementChange
    ]);
    const onKeyDown = (0, $bSJIT.useCallback)((e)=>{
        const components = keyboardNavComponentsRef.current;
        if (components.length === 0) return;
        if (e.isComposing || e.keyCode === 229) return;
        let currentIndex = getSelectedIndex();
        const prevIndex = currentIndex;
        if (e.code === 'ArrowDown' || e.keyCode === 40) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = 0;
                else currentIndex = (currentIndex + 1) % components.length;
                e.preventDefault();
            }
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = components.length - 1;
                else {
                    currentIndex -= 1;
                    if (currentIndex < 0) currentIndex = components.length - Math.abs(currentIndex);
                }
                e.preventDefault();
            }
        } else {
            if (typeof currentIndex !== 'undefined') onKeyDownCallbackAt(currentIndex, e);
            return;
        }
        if (prevIndex !== currentIndex && currentIndex !== undefined) {
            unhighlightComponentAt(prevIndex);
            highlightComponentAt(currentIndex);
            onHighlightedCallback(currentIndex);
        }
    }, [
        getSelectedIndex,
        onKeyDownCallbackAt,
        unhighlightComponentAt,
        highlightComponentAt,
        onHighlightedCallback
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!listenerNode) return;
        listenerNode.addEventListener('keydown', onKeyDown);
        return ()=>{
            listenerNode.removeEventListener('keydown', onKeyDown);
        };
    }, [
        listenerNode,
        onKeyDown
    ]);
    (0, $bSJIT.useEffect)(()=>()=>onSelectedElementChange === null || onSelectedElementChange === void 0 ? void 0 : onSelectedElementChange(undefined), [
        onSelectedElementChange
    ]);
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            registerKeyboardEnabled: registerKeyboardEnabled,
            unregisterKeyboardEnabled: unregisterKeyboardEnabled,
            getSelectedIndex: getSelectedIndex,
            selectComponentByTrackingId: selectComponentByTrackingId,
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            get keyboardNavComponents () {
                // Always read the latest registry from the ref so consumers that
                // destructure `keyboardNavComponents` from the context still see
                // up-to-date data without forcing a re-render of the provider.
                return keyboardNavComponentsRef.current;
            }
        }), [
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        getSelectedIndex,
        selectComponentByTrackingId,
        highlightComponentAt,
        unhighlightComponentAt,
        unhighlightAll
    ]);
    (0, $bSJIT.useImperativeHandle)(ref, ()=>({
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            getSelectedIndex: getSelectedIndex
        }));
    return /*#__PURE__*/ (0, $dc70d.jsx)($b19fb24fe8b43d5c$export$ef7af5d8bc5d5ac1.Provider, {
        value: contextValue,
        children: children
    });
});
const $b19fb24fe8b43d5c$export$cbeda0f7f7a8026c = ()=>{
    return (0, $bSJIT.useContext)($b19fb24fe8b43d5c$export$ef7af5d8bc5d5ac1);
};

});

parcelRegister("8wu2X", function(module, exports) {
$parcel$export(module.exports, "SearchDropdown", () => $a682f8f8a250680c$export$e33d60b8f4099ae);

var $bSJIT = parcelRequire("bSJIT");

var $5yrDi = parcelRequire("5yrDi");

var $h5MEU = parcelRequire("h5MEU");

var $53Hx5 = parcelRequire("53Hx5");
const $a682f8f8a250680c$export$e33d60b8f4099ae = ({ inputWidth: inputWidth, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5yrDi.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $53Hx5.SearchSkeletons), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $h5MEU.ResolvedAndErrorContent), props)));
};

});
parcelRegister("5yrDi", function(module, exports) {
$parcel$export(module.exports, "SearchDialog", () => $76da18374ee42938$export$2aadebb53f6015f6);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $krucY = parcelRequire("krucY");
const $76da18374ee42938$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $krucY.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });

});
parcelRegister("krucY", function(module, exports) {
$parcel$export(module.exports, "SearchDialogWrapper", () => $f3c71e14f248a7de$export$dcefba65c42da69c);
parcelRequire("bSJIT");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $f3c71e14f248a7de$export$dcefba65c42da69c = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e101cjwc0"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $eCTLw.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $eCTLw.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $eCTLw.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $eCTLw.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");

});
parcelRegister("eCTLw", function(module, exports) {
$parcel$export(module.exports, "grid", () => $ea35143bd12cf53d$export$85fc379452d91af0);
$parcel$export(module.exports, "dialogWidth", () => $ea35143bd12cf53d$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $ea35143bd12cf53d$export$ce4512df260a325a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $ea35143bd12cf53d$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$ea35143bd12cf53d$var$AkGrid(multiplier * num),
        half: ()=>$ea35143bd12cf53d$var$AkGrid(0.5 * num),
        twice: ()=>$ea35143bd12cf53d$var$AkGrid(2 * num)
    });
const $ea35143bd12cf53d$export$85fc379452d91af0 = $ea35143bd12cf53d$var$AkGrid(1);
const $ea35143bd12cf53d$export$b9930dabfa4a3a3 = '56px';
const $ea35143bd12cf53d$export$f6af7620e8789c39 = '200px';
const $ea35143bd12cf53d$export$64d8573e83b64ff8 = '150px';
const $ea35143bd12cf53d$export$a3da89b899389ed8 = '780px';
const $ea35143bd12cf53d$export$ce4512df260a325a = 780;
const $ea35143bd12cf53d$export$a406031ed42c8e02 = '1130px';
const $ea35143bd12cf53d$export$e00021bea368c518 = $ea35143bd12cf53d$export$85fc379452d91af0.multiple(4);
const $ea35143bd12cf53d$export$30310ee354b45eb0 = $ea35143bd12cf53d$export$85fc379452d91af0.multiple(6);

});

parcelRegister("9KQKC", function(module, exports) {
$parcel$export(module.exports, "default", () => $71a1542a4e0b2a79$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");
parcelRequire("9dQre");
var $2aX1J = parcelRequire("2aX1J");

var $etF6B = parcelRequire("etF6B");

var $imtW8 = parcelRequire("imtW8");

var $luUQ5 = parcelRequire("luUQ5");

var $bSJIT = parcelRequire("bSJIT");

var $5n9MF = parcelRequire("5n9MF");
var $71a1542a4e0b2a79$var$isDevelopment = false;
var $71a1542a4e0b2a79$var$testOmitPropsOnStringTag = (0, $5n9MF.default);
var $71a1542a4e0b2a79$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $71a1542a4e0b2a79$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $71a1542a4e0b2a79$var$testOmitPropsOnStringTag : $71a1542a4e0b2a79$var$testOmitPropsOnComponent;
};
var $71a1542a4e0b2a79$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $71a1542a4e0b2a79$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $luUQ5.registerStyles)(cache, serialized, isStringTag);
    (0, $imtW8.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $luUQ5.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $71a1542a4e0b2a79$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $71a1542a4e0b2a79$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $71a1542a4e0b2a79$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $2aX1J.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $bSJIT.useContext((0, $2aX1J.T));
            }
            if (typeof props.className === 'string') className = (0, $luUQ5.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $etF6B.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $71a1542a4e0b2a79$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($71a1542a4e0b2a79$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $bSJIT.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $71a1542a4e0b2a79$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $g8vBZ.default)({}, options, nextOptions, {
                shouldForwardProp: $71a1542a4e0b2a79$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("5n9MF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e96b09d92f5b7b0$export$2e2bcd8739ae039);

var $1MzDO = parcelRequire("1MzDO");
// eslint-disable-next-line no-undef
var $3e96b09d92f5b7b0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3e96b09d92f5b7b0$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1MzDO.default)(function(prop) {
    return $3e96b09d92f5b7b0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});




parcelRegister("h5MEU", function(module, exports) {
$parcel$export(module.exports, "ResolvedAndErrorContent", () => $5baca9b839d4f7ba$export$5d6737b8e2fd8b38);

var $bRlSd = parcelRequire("bRlSd");

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $jxOvS = parcelRequire("jxOvS");

var $emsU2 = parcelRequire("emsU2");

var $dq6Pg = parcelRequire("dq6Pg");

var $9fAAW = parcelRequire("9fAAW");
var $cxe40 = parcelRequire("cxe40");

var $4rONO = parcelRequire("4rONO");

var $4oPwy = parcelRequire("4oPwy");

var $5MaaA = parcelRequire("5MaaA");

var $8jqcV = parcelRequire("8jqcV");

var $9i1Ay = parcelRequire("9i1Ay");
const $5baca9b839d4f7ba$export$5d6737b8e2fd8b38 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $a2qIF.useLazyLoadQuery)((0, $bRlSd.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        input: {
            query: queryWord,
            contentTypes: [
                'FOLDER',
                'PAGE'
            ]
        },
        first: 10
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const { articlesAndFolders: articlesAndFolders, hasQueryError: hasQueryError } = (0, $4oPwy.useArticleSearch)(searchResponse, queryWord);
    const showEmptyState = articlesAndFolders && articlesAndFolders.length === 0;
    const showResolvedState = articlesAndFolders && articlesAndFolders.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, (showEmptyState || hasQueryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dq6Pg.EmptyState), {
        title: hasQueryError ? formatMessage((0, $9i1Ay.messages).errorTitle) : formatMessage((0, $9i1Ay.messages).emptyStateTitle),
        Image: (0, $8jqcV.SearchErrorImage),
        content: hasQueryError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $9i1Ay.messages).errorDescription) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $9i1Ay.messages).emptyStateDescription)
    }), showResolvedState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cxe40.SearchDialogContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9fAAW.ResultContainer), null, articlesAndFolders.map((result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4rONO.SearchResult), {
            key: result.id,
            href: result.url,
            title: result.title,
            isCollapsed: true,
            icon: result.type === (0, $5MaaA.ContentType).PAGE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jxOvS))), {
                label: ""
            })
        }))))));
};

});
parcelRegister("bRlSd", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaeaedffd9591370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdd62f48e8fdad92549ed462bc7fb25f>>
 * @relayHash d3adfd96cf5547776151651b69eb76b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a
const $aaeaedffd9591370$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "contentType"
            },
            {
                "concreteType": "HelpObjectStoreArticleURLInfo",
                "kind": "LinkedField",
                "name": "urlInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "shareUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "alias": "helpObjectStore_searchArticlesForSupportSite",
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ],
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "__ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "args": v12 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "helpCenterAri",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "helpObjectStore_searchArticlesForSupportSite"
                        ]
                    }
                ]
            },
            "name": "resolvedAndErrorContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aaeaedffd9591370$var$node.hash = "8f52dcfd8c2f8d8ee3e0ac349b7693a1";
var $aaeaedffd9591370$export$2e2bcd8739ae039 = $aaeaedffd9591370$var$node;

});

parcelRegister("jxOvS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83aab1eaf1c12eec7924b955b15ac03b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3a8484003c056bb$var$_react = $e3a8484003c056bb$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e3a8484003c056bb$var$_iconNew = $e3a8484003c056bb$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e3a8484003c056bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-closed
 * Usage guidance:
 * Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3a8484003c056bb$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $e3a8484003c056bb$var$_react.default.createElement($e3a8484003c056bb$var$_iconNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$e3a8484003c056bb$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $e3a8484003c056bb$var$_default = module.exports.default = $e3a8484003c056bb$var$FolderClosedIcon;

});

parcelRegister("dq6Pg", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $1041d90d5eec3c17$export$fddf379e22a74b00);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $l2a8Q = parcelRequire("l2a8Q");

var $2qye4 = parcelRequire("2qye4");

var $2d0NS = parcelRequire("2d0NS");
const $1041d90d5eec3c17$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $2d0NS.Wrapper), {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)(Image, {}),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $2qye4.Title), {
                    children: title
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $l2a8Q.Content), {
                    children: content
                })
            ]
        })
    });

});
parcelRegister("l2a8Q", function(module, exports) {
$parcel$export(module.exports, "Content", () => $f77f4386ea7f4bc2$export$7c6e2c02157bb7d2);
parcelRequire("bSJIT");

var $g41gZ = parcelRequire("g41gZ");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $f77f4386ea7f4bc2$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1nenibz0"
})({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $eCTLw.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $g41gZ.primaryTextColour)
});

});
parcelRegister("g41gZ", function(module, exports) {
$parcel$export(module.exports, "primaryTextColour", () => $f26fa80607ea90ff$export$eeb0307e2964e28d);
const $f26fa80607ea90ff$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

});


parcelRegister("2qye4", function(module, exports) {
$parcel$export(module.exports, "Title", () => $fa77d50dd1722102$export$f99233281efd08a0);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");


// // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $fa77d50dd1722102$var$TitleContainerStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $fa77d50dd1722102$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
        xcss: $fa77d50dd1722102$var$TitleContainerStyles,
        children: children
    });
};

});

parcelRegister("2d0NS", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $4d0d7894cb446714$export$e6dfd72ab29f8598);
parcelRequire("bSJIT");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $4d0d7894cb446714$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1pv7r8x0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $eCTLw.grid).twice().px
});

});


parcelRegister("9fAAW", function(module, exports) {
$parcel$export(module.exports, "ResultContainer", () => $5f43bad0c21fadf7$export$ab35601bed9ca017);
parcelRequire("bSJIT");

var $9KQKC = parcelRequire("9KQKC");
function $5f43bad0c21fadf7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5f43bad0c21fadf7$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "eqbbglm0"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});

});

parcelRegister("cxe40", function(module, exports) {
$parcel$export(module.exports, "SearchDialogContent", () => $62b64c8320def9a5$export$c9e0e8491f083dd5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $eCTLw = parcelRequire("eCTLw");

var $gQTGs = parcelRequire("gQTGs");

var $gW6MH = parcelRequire("gW6MH");

var $9KQKC = parcelRequire("9KQKC");



var $9fAAW = parcelRequire("9fAAW");


const $62b64c8320def9a5$var$SIDEBAR_PANE_WIDTH = 272;
const $62b64c8320def9a5$var$resultContainerVerticalPadding = 8;
const $62b64c8320def9a5$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "ee3sr7s1"
})("flex:0 1 auto;width:", $62b64c8320def9a5$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $eCTLw.dialogPageTakeoverWidth), "px){display:none;}");
const $62b64c8320def9a5$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $gQTGs.SidebarContainerBorder), {}),
            /*#__PURE__*/ (0, $dc70d.jsx)($62b64c8320def9a5$export$6b8430dd9f61a5c7, {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gW6MH.SidebarScrollContainer), {
                    children: children
                })
            })
        ]
    });
const $62b64c8320def9a5$var$totalDialogHeightPx = 776 + $62b64c8320def9a5$var$resultContainerVerticalPadding * 2;
const $62b64c8320def9a5$var$footerHeight = 48;
const $62b64c8320def9a5$var$belowDialogSpace = 224;
const $62b64c8320def9a5$var$aiFullDialogPromptHeight = 64;
const $62b64c8320def9a5$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "ee3sr7s0"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$62b64c8320def9a5$var$belowDialogSpace - $62b64c8320def9a5$var$footerHeight + (props.showAtlassianHomeSearchLink ? $62b64c8320def9a5$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $62b64c8320def9a5$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $62b64c8320def9a5$var$totalDialogHeightPx + $62b64c8320def9a5$var$belowDialogSpace, "px){max-height:", (props)=>`${$62b64c8320def9a5$var$totalDialogHeightPx - $62b64c8320def9a5$var$footerHeight - (props.aiSearchFullDialogEnabled ? $62b64c8320def9a5$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $eCTLw.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");

});
parcelRegister("gQTGs", function(module, exports) {
$parcel$export(module.exports, "SidebarContainerBorder", () => $a7b423d41ca768c7$export$33eeaf745b96a17f);
parcelRequire("bSJIT");

var $9KQKC = parcelRequire("9KQKC");
const $a7b423d41ca768c7$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1vcw7g0"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});

});

parcelRegister("gW6MH", function(module, exports) {
$parcel$export(module.exports, "SidebarScrollContainer", () => $8a3ee064902eab28$export$34a31057caff1acb);
parcelRequire("bSJIT");

var $9KQKC = parcelRequire("9KQKC");
const $8a3ee064902eab28$export$34a31057caff1acb = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e18m3bbr0"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});

});


parcelRegister("4rONO", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $2d0066a492988cea$export$a2def421b23768aa);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $eargn = parcelRequire("eargn");

var $hWicg = parcelRequire("hWicg");

var $6pOI6 = parcelRequire("6pOI6");
const $2d0066a492988cea$export$a2def421b23768aa = (props)=>{
    const ResultContentComponent = props.isQuickFind ? (0, $hWicg.EnlargedSearchResultContent) : (0, $eargn.SearchResultContent);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6pOI6.SearchResultLink), {
        ...props,
        children: (isKeyboardHighlighted)=>/*#__PURE__*/ (0, $dc70d.jsx)(ResultContentComponent, {
                ...props,
                isKeyboardHighlighted: isKeyboardHighlighted
            })
    });
};

});
parcelRegister("eargn", function(module, exports) {
$parcel$export(module.exports, "SearchResultContent", () => $bde021d4062c3e75$export$b5fd7d6305bfbd3e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $eiK53 = parcelRequire("eiK53");

var $bQoJq = parcelRequire("bQoJq");

var $jQ1TA = parcelRequire("jQ1TA");

var $fWgzj = parcelRequire("fWgzj");

var $70aAi = parcelRequire("70aAi");

var $7U97T = parcelRequire("7U97T");

var $fvYgO = parcelRequire("fvYgO");

var $iVrDx = parcelRequire("iVrDx");

var $gZCVP = parcelRequire("gZCVP");

var $9HMQt = parcelRequire("9HMQt");
const $bde021d4062c3e75$export$595b9d59c3d65270 = '@@@hl@@@';
const $bde021d4062c3e75$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $bde021d4062c3e75$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iVrDx.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $bde021d4062c3e75$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $bde021d4062c3e75$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bQoJq.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $gZCVP.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $bde021d4062c3e75$var$getResultLabel(label),
                            $bde021d4062c3e75$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fWgzj.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jQ1TA.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $70aAi.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jQ1TA.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $gZCVP.ResultTitleContainer), {
                        children: [
                            $bde021d4062c3e75$var$getResultLabel(label),
                            $bde021d4062c3e75$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $dc70d.jsx)((0, $fvYgO.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $fvYgO.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    (0, $bSJIT.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9HMQt.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $7U97T.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9HMQt.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eiK53.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};

});
parcelRegister("eiK53", function(module, exports) {
$parcel$export(module.exports, "ReturnIcon", () => $e7f2aba1f89dcbdb$export$d6c38c54dfb7c9d5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $e7f2aba1f89dcbdb$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? "var(--ds-background-neutral-bold, #292A2E)" : "var(--ds-background-neutral, #0515240F)",
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                    fill: inverted ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)",
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });

});

parcelRegister("bQoJq", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $b995974a9356a779$export$ee32d1086c278cfc);

var $9KQKC = parcelRequire("9KQKC");
function $b995974a9356a779$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b995974a9356a779$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1oz9dht0"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});

});

parcelRegister("jQ1TA", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultDetail", () => $bdbed40fb549b563$export$addf7aa0f753bbe8);

var $aUjda = parcelRequire("aUjda");

var $bmCC7 = parcelRequire("bmCC7");

var $9KQKC = parcelRequire("9KQKC");
const $bdbed40fb549b563$export$addf7aa0f753bbe8 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1kgzlm60"
})((0, $bmCC7.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aUjda.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});

});
parcelRegister("aUjda", function(module, exports) {
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $fe89c055fd3158de$export$7168c0a11fb9ab29);
const $fe89c055fd3158de$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

});

parcelRegister("bmCC7", function(module, exports) {
$parcel$export(module.exports, "nowrapEllipsis", () => $813b246b76cc1460$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $813b246b76cc1460$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $813b246b76cc1460$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});


parcelRegister("fWgzj", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $ca1c29a9888eaaf3$export$43a2b5c94cb85d9c);

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $ca1c29a9888eaaf3$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "ehiioj40"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $eCTLw.grid).multiple(54).px
});

});

parcelRegister("70aAi", function(module, exports) {
$parcel$export(module.exports, "DetailsSeparator", () => $aa6f215676d156c0$export$35507434feaa4496);

var $aUjda = parcelRequire("aUjda");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $aa6f215676d156c0$export$35507434feaa4496 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e18eh42m0"
})({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aUjda.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $eCTLw.grid).px}`
});

});

parcelRegister("7U97T", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $8ba3ba8b2e6a4c08$export$8f314e512d92575f);

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $8ba3ba8b2e6a4c08$export$8f314e512d92575f = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "eymydq50"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $eCTLw.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $eCTLw.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $eCTLw.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $eCTLw.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("fvYgO", function(module, exports) {
$parcel$export(module.exports, "ResultDetail", () => $824e8a635a00c4bc$export$b695f824f00c1cb0);

var $aUjda = parcelRequire("aUjda");

var $bmCC7 = parcelRequire("bmCC7");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $824e8a635a00c4bc$export$b695f824f00c1cb0 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "euh103z0"
})((0, $bmCC7.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aUjda.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $eCTLw.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $eCTLw.grid).multiple(19).px
});

});

parcelRegister("iVrDx", function(module, exports) {
$parcel$export(module.exports, "ResultLabel", () => $46a8710b3ec49ffc$export$a999164f6ebc756c);

var $bmCC7 = parcelRequire("bmCC7");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $46a8710b3ec49ffc$export$a999164f6ebc756c = /*#__PURE__*/ (0, $9KQKC.default)("span", {
    target: "e1rd3aa10"
})((0, $bmCC7.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #505258)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $eCTLw.grid).px
});

});

parcelRegister("gZCVP", function(module, exports) {
$parcel$export(module.exports, "ResultTitleContainer", () => $5199b95b5aa35465$export$9c613d6c52df949a);

var $bmCC7 = parcelRequire("bmCC7");

var $g41gZ = parcelRequire("g41gZ");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $5199b95b5aa35465$export$9c613d6c52df949a = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "eiapvw30"
})((0, $bmCC7.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $eCTLw.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $g41gZ.primaryTextColour), ";@media screen and (max-width: ", (0, $eCTLw.dialogPageTakeoverWidth), "px){width:100%;}");

});

parcelRegister("9HMQt", function(module, exports) {
$parcel$export(module.exports, "ResultContentWrapper", () => $7a6f61884e1485c3$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $7a6f61884e1485c3$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $7a6f61884e1485c3$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $7a6f61884e1485c3$export$cc248e72bc9d7b85);

var $dhDdc = parcelRequire("dhDdc");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");


















function $7a6f61884e1485c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a6f61884e1485c3$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e8crcwv4"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $eCTLw.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $eCTLw.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $dhDdc.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $dhDdc.itemHighlightColor)
        }
    }));
const $7a6f61884e1485c3$export$e10965f6350456f8 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e8crcwv3"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-radius-medium, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $dhDdc.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $dhDdc.itemHighlightColor)
        }
    }));
const $7a6f61884e1485c3$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e8crcwv2"
})((props)=>({
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $eCTLw.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $eCTLw.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $eCTLw.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $eCTLw.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $eCTLw.grid).px : (0, $eCTLw.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $7a6f61884e1485c3$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e8crcwv1"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $7a6f61884e1485c3$export$d84276b3ae03593f = /*#__PURE__*/ (0, $9KQKC.default)($7a6f61884e1485c3$export$b7244afbfdf4cb9a, {
    target: "e8crcwv0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $eCTLw.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $eCTLw.grid).multiple(2.5).px,
    opacity: 1
});

});
parcelRegister("dhDdc", function(module, exports) {
$parcel$export(module.exports, "itemHighlightColor", () => $ab6d6b823d06b65e$export$4ac85ff259fe4fce);
const $ab6d6b823d06b65e$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

});



parcelRegister("hWicg", function(module, exports) {
$parcel$export(module.exports, "EnlargedSearchResultContent", () => $9fbec6b49e82a101$export$171a2a7e5a778acc);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $4TRbS = parcelRequire("4TRbS");

var $jp251 = parcelRequire("jp251");

var $9CqpG = parcelRequire("9CqpG");

var $4NuZR = parcelRequire("4NuZR");

var $283zK = parcelRequire("283zK");

var $bQoJq = parcelRequire("bQoJq");

var $aVKnU = parcelRequire("aVKnU");

var $3vBJ2 = parcelRequire("3vBJ2");

var $j1B1S = parcelRequire("j1B1S");

var $pimFP = parcelRequire("pimFP");

var $5lJm7 = parcelRequire("5lJm7");

var $iVrDx = parcelRequire("iVrDx");

var $9HMQt = parcelRequire("9HMQt");
const $9fbec6b49e82a101$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $bSJIT.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $bSJIT.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $bSJIT.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9HMQt.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $j1B1S.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bQoJq.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $5lJm7.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
                                children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $jp251.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $iVrDx.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $dc70d.jsx)((0, $3vBJ2.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aVKnU.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $dc70d.jsx)((0, $pimFP.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9HMQt.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4NuZR.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9HMQt.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                    icon: (0, $9CqpG.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                        ...(0, $283zK.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};

});
parcelRegister("jp251", function(module, exports) {
$parcel$export(module.exports, "enrichResultTitle", () => $22a83c2bb5198c1e$export$c43ff622b37ceaa9);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $22a83c2bb5198c1e$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $22a83c2bb5198c1e$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $22a83c2bb5198c1e$var$highlightMarkerRE = new RegExp(`${$22a83c2bb5198c1e$var$HIGHLIGHT_START_TAG}|${$22a83c2bb5198c1e$var$HIGHLIGHT_END_TAG}`, 'g');
const $22a83c2bb5198c1e$export$8ebd5c051fe06ad1 = (text)=>text.replace($22a83c2bb5198c1e$var$highlightMarkerRE, '');
const $22a83c2bb5198c1e$var$highlightRE = new RegExp(`${$22a83c2bb5198c1e$var$HIGHLIGHT_START_TAG}(.*?)${$22a83c2bb5198c1e$var$HIGHLIGHT_END_TAG}.*`);
const $22a83c2bb5198c1e$var$openingTagRE = new RegExp(`(.*?)${$22a83c2bb5198c1e$var$HIGHLIGHT_START_TAG}`);
const $22a83c2bb5198c1e$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($22a83c2bb5198c1e$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($22a83c2bb5198c1e$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($22a83c2bb5198c1e$var$highlightRE) || [];
        title = title.replace(`${$22a83c2bb5198c1e$var$HIGHLIGHT_START_TAG}${highlightText}${$22a83c2bb5198c1e$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};

});

parcelRegister("9CqpG", function(module, exports) {
$parcel$export(module.exports, "RemoveIcon", () => $a8bdb4c8467818ef$export$6382847193091a26);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $a8bdb4c8467818ef$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #292A2E)"
        })
    });

});

parcelRegister("4NuZR", function(module, exports) {
$parcel$export(module.exports, "SquareReturnIcon", () => $bbf2edc12e8fa9f7$export$4501fc029b186da8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $bbf2edc12e8fa9f7$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: "var(--ds-background-neutral, #0515240F)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: "var(--ds-icon-subtle, #505258)"
            })
        ]
    });

});

parcelRegister("283zK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2dabcd192da54eb0$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2dabcd192da54eb0$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    remove_button_label: {
        id: 'search_dialog.results.remove_button_label',
        defaultMessage: 'Remove this.',
        description: 'Label of the button that has remove function and appearance.'
    }
});

});

parcelRegister("aVKnU", function(module, exports) {
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $dc61becabd326e4e$export$a44951d703db9a17);

var $aUjda = parcelRequire("aUjda");

var $bmCC7 = parcelRequire("bmCC7");

var $9KQKC = parcelRequire("9KQKC");
const $dc61becabd326e4e$export$a44951d703db9a17 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1a0jgbt0"
})((0, $bmCC7.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aUjda.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});

});

parcelRegister("3vBJ2", function(module, exports) {
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $5fe12ced2b6195a5$export$2dfb537c5a7f8cc3);

var $9KQKC = parcelRequire("9KQKC");
function $5fe12ced2b6195a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5fe12ced2b6195a5$export$2dfb537c5a7f8cc3 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1ilyjzy0"
})({
    name: "uy5e1i",
    styles: "display:flex;width:90%"
});

});

parcelRegister("j1B1S", function(module, exports) {
$parcel$export(module.exports, "EnlargedIconContainer", () => $ff9d5dc8940d5740$export$ca5c00fa71c2e27e);

var $9KQKC = parcelRequire("9KQKC");
const $ff9d5dc8940d5740$export$ca5c00fa71c2e27e = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "ej3qn9h0"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("pimFP", function(module, exports) {
$parcel$export(module.exports, "EnlargedResultDetail", () => $a6094e41b65dca5a$export$c8ec38cc79b76eaa);

var $aUjda = parcelRequire("aUjda");

var $bmCC7 = parcelRequire("bmCC7");

var $9KQKC = parcelRequire("9KQKC");
const $a6094e41b65dca5a$export$c8ec38cc79b76eaa = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "ei2t34t0"
})((0, $bmCC7.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aUjda.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});

});

parcelRegister("5lJm7", function(module, exports) {
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $ff934a3d413326ae$export$e97ece467686c93c);

var $bmCC7 = parcelRequire("bmCC7");

var $g41gZ = parcelRequire("g41gZ");

var $eCTLw = parcelRequire("eCTLw");

var $9KQKC = parcelRequire("9KQKC");
const $ff934a3d413326ae$export$e97ece467686c93c = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "efsee9j0"
})((0, $bmCC7.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $g41gZ.primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, $eCTLw.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");

});


parcelRegister("6pOI6", function(module, exports) {
$parcel$export(module.exports, "SearchResultLink", () => $f7476b76f02598d2$export$76cc11d043a1381);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $dIKn6 = parcelRequire("dIKn6");

var $9d3B8 = parcelRequire("9d3B8");
const $f7476b76f02598d2$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $9d3B8.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dIKn6.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};

});
parcelRegister("dIKn6", function(module, exports) {
$parcel$export(module.exports, "ResultLink", () => $50e3afd69f8bbf3f$export$d0a8235d2583609);

var $g41gZ = parcelRequire("g41gZ");

var $kl5yb = parcelRequire("kl5yb");

var $22zAw = parcelRequire("22zAw");

var $9KQKC = parcelRequire("9KQKC");
const $50e3afd69f8bbf3f$export$d0a8235d2583609 = /*#__PURE__*/ (0, $9KQKC.default)((0, $kl5yb.Link), {
    target: "e1xrnjlr0"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $g41gZ.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $g41gZ.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $g41gZ.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $22zAw.visitedLinkColor)
        }
    }
});

});
parcelRegister("kl5yb", function(module, exports) {
$parcel$export(module.exports, "Link", () => $2932d4335fe46ea2$export$a6c7ac8248d6e38a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $2932d4335fe46ea2$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        ...props
    });
};

});

parcelRegister("22zAw", function(module, exports) {
$parcel$export(module.exports, "visitedLinkColor", () => $6896c740a8a85f0f$export$271fb8b1437b1d62);
const $6896c740a8a85f0f$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

});


parcelRegister("9d3B8", function(module, exports) {
$parcel$export(module.exports, "useKeyboardHighlighting", () => $85c8cbc96ac766f6$export$9803d460130e453);

var $bSJIT = parcelRequire("bSJIT");

var $2EplR = parcelRequire("2EplR");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $85c8cbc96ac766f6$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && (_clickTarget$firstEle = clickTarget.firstElementChild) !== null && _clickTarget$firstEle !== void 0 && _clickTarget$firstEle.click){
            var _clickTarget$firstEle;
            clickTarget = clickTarget.firstElementChild;
        }
        clickTarget.click();
    }
};
const $85c8cbc96ac766f6$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $2EplR.useKeyboardNavigation)({
        onKeydownCallback: $85c8cbc96ac766f6$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $bSJIT.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $bSJIT.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted === null || onHighlighted === void 0 || onHighlighted();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});



parcelRegister("4oPwy", function(module, exports) {
$parcel$export(module.exports, "useArticleSearch", () => $98177e79d7984c9a$export$f4258d6b7c4900b8);

var $bSJIT = parcelRequire("bSJIT");
const $98177e79d7984c9a$var$MIN_INPUT_CHAR_LENGTH = 1;
const $98177e79d7984c9a$export$f4258d6b7c4900b8 = (searchResponse, queryWord)=>{
    var _searchResponse$helpO3;
    const entities = (0, $bSJIT.useMemo)(()=>{
        var _searchResponse$helpO;
        return (searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.edges) || [];
    }, [
        searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.helpObjectStore_searchArticlesForSupportSite
    ]);
    const hasQueryError = Boolean(entities.find((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.message;
    }));
    const articlesAndFolders = (0, $bSJIT.useMemo)(()=>{
        var _searchResponse$helpO2;
        const edges = (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.edges;
        if (edges) {
            const resultItems = edges.map(({ node: node })=>{
                const { id: id, title: title, contentType: contentType, urlInfo: urlInfo } = node;
                if (id && title && contentType && urlInfo !== null && urlInfo !== void 0 && urlInfo.shareUrl) return {
                    id: id,
                    title: title,
                    type: contentType.toString(),
                    url: urlInfo.shareUrl
                };
                return null;
            }).filter((item)=>item !== null);
            return resultItems;
        }
        return undefined;
    }, [
        (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.edges
    ]);
    if (queryWord.length < $98177e79d7984c9a$var$MIN_INPUT_CHAR_LENGTH) return {
        articlesAndFolders: undefined,
        hasQueryError: false
    };
    return {
        articlesAndFolders: articlesAndFolders,
        hasQueryError: hasQueryError
    };
};

});

parcelRegister("5MaaA", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $9d90c8618d469480$export$e2e108cbe2e4f865);
var $9d90c8618d469480$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "PAGE";
    ContentType["FOLDER"] = "FOLDER";
    return ContentType;
}({});

});

parcelRegister("8jqcV", function(module, exports) {
$parcel$export(module.exports, "SearchErrorImage", () => $f66cab2c002ec732$export$d689645a972509c2);

var $bSJIT = parcelRequire("bSJIT");
const $f66cab2c002ec732$export$d689645a972509c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("svg", {
        width: "61",
        height: "82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: ".01",
        d: "M0 0h61v82H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M42.676 60.465 39.8 57.71l-3.867 3.956 2.874 2.755a5.347 5.347 0 0 1 1.492 2.58 5.348 5.348 0 0 0 1.492 2.582l11.66 11.176a4.484 4.484 0 0 0 6.294-.102 4.377 4.377 0 0 0-.102-6.232l-11.66-11.176a5.412 5.412 0 0 0-2.654-1.394 5.377 5.377 0 0 1-2.654-1.39z",
        fill: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M45.213 61.83a5.409 5.409 0 0 1-2.537-1.365l-.876-.839a2.804 2.804 0 0 0-3.934.062 2.737 2.737 0 0 0 .062 3.895l.876.838a5.334 5.334 0 0 1 1.46 2.461 23.389 23.389 0 0 0 4.95-5.053z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M23.633 69.38c-6.214.097-12.095-2.204-16.56-6.483-9.218-8.832-9.456-23.441-.536-32.567 4.323-4.42 10.126-6.91 16.34-7.009 6.215-.098 12.096 2.203 16.561 6.483 4.466 4.28 6.981 10.025 7.08 16.174.1 6.149-2.225 11.975-6.548 16.396-4.322 4.417-10.126 6.907-16.337 7.005zm-.667-40.563c-4.73.076-9.148 1.97-12.44 5.336-6.794 6.947-6.61 18.072.407 24.798 3.399 3.26 7.879 5.01 12.608 4.937 4.73-.077 9.148-1.971 12.44-5.336s5.06-7.8 4.983-12.483c-.077-4.682-1.991-9.056-5.39-12.316-3.398-3.26-7.875-5.012-12.608-4.936z",
        fill: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "m31.78 40.93-2.384-2.317a1.04 1.04 0 0 0-1.466.015l-4.55 4.588-4.634-4.505a1.04 1.04 0 0 0-1.467.015l-2.339 2.36a1.016 1.016 0 0 0 .015 1.451l4.634 4.505-4.55 4.588a1.016 1.016 0 0 0 .015 1.452l2.383 2.316c.41.399 1.067.391 1.466-.015l4.55-4.588 4.635 4.505c.41.399 1.066.392 1.466-.015l2.34-2.36a1.016 1.016 0 0 0-.015-1.451l-4.638-4.505 4.55-4.588c.403-.403.4-1.053-.012-1.452zM26.075 10.073 22.555.156c-.08-.232-.421-.192-.45.05L20.967 9.82l-2.244-.262a.23.23 0 0 0-.246.305l3.52 9.917c.08.232.421.192.45-.051l1.137-9.612 2.244.261c.169.022.3-.145.246-.304zM14.999 16.374l-4.374-2.958c-.092-.062-.202.04-.147.134l2.405 4.185-.982.555a.1.1 0 0 0-.008.171l4.374 2.958c.092.062.202-.04.147-.134L14.01 17.1l.982-.556a.1.1 0 0 0 .008-.17z",
        fill: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("path", {
        d: "M30.804 21.245a.363.363 0 0 1-.36-.443c-.09-.196-.754-.599-1.158-.842-.909-.552-1.693-1.027-1.48-1.655.212-.632 1.128-.54 2.188-.44.429.044 1.122.11 1.379.04-.165-.21-.756-.566-1.126-.79-.91-.552-1.694-1.024-1.481-1.656.213-.631 1.13-.54 2.189-.439.429.043 1.118.109 1.378.04-.165-.21-.755-.566-1.125-.791-.91-.552-1.694-1.024-1.482-1.656.213-.627 1.13-.54 2.19-.439.469.044 1.242.12 1.436.018a.367.367 0 0 1 .451-.192c.191.065.297.269.231.461-.212.628-1.129.54-2.188.436-.43-.044-1.122-.11-1.379-.04.165.21.755.566 1.126.79.909.553 1.693 1.024 1.48 1.656-.212.628-1.128.54-2.188.44-.429-.044-1.122-.11-1.379-.04.165.21.756.566 1.126.79.91.552 1.694 1.024 1.481 1.656-.212.631-1.13.54-2.189.439-.429-.044-1.122-.109-1.378-.04.165.21.755.57 1.125.791.91.552 1.694 1.028 1.482 1.656a.368.368 0 0 1-.349.25zM35.996 23.104a.361.361 0 0 1-.32-.186c-.403-.704-.857-1.502-.373-1.953.488-.45 1.265.059 2.09.6.348.228.909.595 1.158.645-.033-.246-.366-.827-.572-1.186-.487-.85-.95-1.652-.462-2.106.488-.45 1.265.058 2.09.6.374.246.994.649 1.206.649h.004a.37.37 0 0 1 .491.04.356.356 0 0 1-.018.512c-.488.453-1.265-.058-2.09-.6-.348-.228-.91-.595-1.158-.645.033.247.366.827.572 1.187.487.849.95 1.651.462 2.105-.488.45-1.265-.058-2.09-.599-.349-.229-.91-.595-1.155-.646.033.247.366.831.484 1.034a.36.36 0 0 1-.14.494.299.299 0 0 1-.18.055zM8.971 24.537c-.029 0-.055 0-.084-.003-.663-.08-.766-.999-.876-1.968-.048-.41-.121-1.074-.242-1.292-.172.185-.407.81-.55 1.198-.345.918-.675 1.782-1.33 1.702-.665-.08-.767-.998-.88-1.967-.052-.443-.136-1.18-.272-1.336a.365.365 0 0 1-.286-.4.366.366 0 0 1 .407-.315c.663.08.766.998.88 1.971.047.41.12 1.074.245 1.292.173-.185.407-.81.55-1.198.345-.914.671-1.774 1.331-1.702.664.08.766.998.88 1.971.048.41.121 1.07.242 1.292.169-.185.407-.813.491-1.034a.369.369 0 0 1 .473-.214c.191.069.286.28.217.468-.286.719-.594 1.535-1.196 1.535z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "a",
        x1: "45.58",
        y1: "73.338",
        x2: "51.997",
        y2: "66.855",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        stopColor: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-icon-subtle, #505258)",
        stopOpacity: ".5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("linearGradient", {
        id: "b",
        x1: "6.803",
        y1: "62.638",
        x2: "39.376",
        y2: "29.737",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: ".557",
        stopColor: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("stop", {
        offset: ".966",
        stopColor: "var(--ds-icon-subtle, #505258)",
        stopOpacity: ".5"
    }))));

});

parcelRegister("9i1Ay", function(module, exports) {
$parcel$export(module.exports, "messages", () => $eca527382aad73a9$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $eca527382aad73a9$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.article-search-component.empty-title',
        defaultMessage: "We couldn\u2019t find a match for your search",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    emptyStateDescription: {
        id: 'company-hub.article-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    },
    errorTitle: {
        id: 'company-hub.article-search-component.error-title',
        defaultMessage: "We\u2019re having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    errorDescription: {
        id: 'company-hub.article-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    }
});

});


parcelRegister("53Hx5", function(module, exports) {
$parcel$export(module.exports, "SearchSkeletons", () => $3d2bb77dde7722b2$export$d660f580aff4b70c);

var $bSJIT = parcelRequire("bSJIT");

var $58r0N = parcelRequire("58r0N");
const $3d2bb77dde7722b2$export$d660f580aff4b70c = ({ count: count = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $58r0N.RowSkeleton), {
            key: index
        })));
};

});
parcelRegister("58r0N", function(module, exports) {
$parcel$export(module.exports, "RowSkeleton", () => $ade49f33373f594d$export$94071f5afde0c224);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $ade49f33373f594d$var$styles = {
    rowWithDescription: "_2rko1mok _1bsb1ns9 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1e0c11p5 _gy1pu2gc _yv0e5bpd _1lmc1hhf _4cvr1h6o _4t3i12am",
    icon: "_nd5l2ec4 _2rkolb4i _bfhki8nm _1bsb1tcg _4t3i1tcg",
    title: "_nd5l1cy2 _2rkolb4i _bfhki8nm _1bsbgx0z _4t3idlk8",
    description: "_nd5ltgt2 _2rkolb4i _bfhki8nm _1bsb1w81 _4t3i19bv"
};
const $ade49f33373f594d$export$94071f5afde0c224 = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $ade49f33373f594d$var$styles.rowWithDescription
    }, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $ade49f33373f594d$var$styles.icon
    }), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $ade49f33373f594d$var$styles.title
    }), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $ade49f33373f594d$var$styles.description
    }));
};

});



parcelRegister("jebvR", function(module, exports) {
$parcel$export(module.exports, "SearchTextField", () => $b790cfc35501d5ec$export$fb8d8fbc0c4c1705);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("eHBLW");
var $9FFFq = parcelRequire("9FFFq");
var $d5GPr = parcelRequire("d5GPr");

var $4TRbS = parcelRequire("4TRbS");

var $jDsoo = parcelRequire("jDsoo");

var $9dYEz = parcelRequire("9dYEz");

var $gfXmS = parcelRequire("gfXmS");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $jgsO4 = parcelRequire("jgsO4");

var $9Abbn = parcelRequire("9Abbn");

var $4NuZR = parcelRequire("4NuZR");

var $aMoe9 = parcelRequire("aMoe9");
const $b790cfc35501d5ec$var$cssOverrideWrapperStyles = null;
const $b790cfc35501d5ec$var$styles = {
    wrapper: "_1bsb1kdj",
    responsiveWrapper: "_p12f1osq",
    searchIcon: "_1ul91ns9 _1tke1ns9 _18u0u2gc _1e0c1txw _1bah1h6o _4cvr1h6o",
    clearIcon: "_2hwxu2gc",
    searchEnterHint: "_2hwxutpp _1o9zidpf _o5721q9c _1e0c1txw _4cvr1h6o",
    searchEnterHintIcon: "_1e0c1txw _4cvr1h6o _1bah1h6o _t9ecdfmd"
};
const $b790cfc35501d5ec$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    var _routerState$location;
    const { isReadOnly: isReadOnly, onInput: onInput, placeholderText: placeholderText, queryWord: queryWord, searchBasePath: searchBasePath, showSearchEnterHint: showSearchEnterHint = false } = props;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push } = (0, $d5GPr.useRouterActions)();
    const [routerState] = (0, $9FFFq.useRouter)();
    const searchEnterHintDescriptionId = (0, $bSJIT.useId)();
    const handleChange = (e)=>{
        const value = e.currentTarget.value;
        onInput(value);
    };
    const handleKeyDown = (0, $bSJIT.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            if (showSearchEnterHint && queryWord.trim().length === 0) return;
            const currentPath = searchBasePath || routerState.location.pathname;
            const updatedPathIfHasMissingTrailingSlash = currentPath.endsWith('/') ? currentPath : `${currentPath}/`;
            push(`${updatedPathIfHasMissingTrailingSlash}articles/search?q=${encodeURIComponent(queryWord)}`);
        }
    }, [
        searchBasePath,
        routerState === null || routerState === void 0 || (_routerState$location = routerState.location) === null || _routerState$location === void 0 ? void 0 : _routerState$location.pathname,
        queryWord,
        push,
        showSearchEnterHint
    ]);
    const handleClear = (0, $bSJIT.useCallback)(()=>{
        onInput('');
    }, [
        onInput
    ]);
    const isHintVisible = showSearchEnterHint && queryWord.trim().length > 0;
    const trailingElement = (0, $bSJIT.useMemo)(()=>{
        if (isHintVisible) return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $b790cfc35501d5ec$var$styles.searchEnterHint,
            testId: "search-enter-hint"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $9Abbn.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
            id: searchEnterHintDescriptionId
        }, formatMessage((0, $aMoe9.messages).searchHintDescription))), /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
            color: "color.text.subtle",
            size: "small"
        }, formatMessage((0, $aMoe9.messages).searchHint)), /*#__PURE__*/ $bSJIT.createElement("span", {
            "aria-hidden": "true",
            className: (0, $9fU1q.default)([
                $b790cfc35501d5ec$var$styles.searchEnterHintIcon
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4NuZR.SquareReturnIcon), null))));
        if (queryWord) return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $b790cfc35501d5ec$var$styles.clearIcon
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4TRbS.default), {
            icon: (iconProps)=>/*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                    ...iconProps,
                    color: "currentColor",
                    label: ""
                }),
            spacing: "compact",
            onClick: handleClear,
            label: "",
            appearance: "subtle"
        }));
        return null;
    }, [
        formatMessage,
        handleClear,
        isHintVisible,
        queryWord,
        searchEnterHintDescriptionId
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        ref: ref,
        xcss: (0, $jDsoo.cx)($b790cfc35501d5ec$var$styles.wrapper, (0, $gdUUy.fg)('hubs_jsm_max_width_appearance') && $b790cfc35501d5ec$var$styles.responsiveWrapper)
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_dhd01mok _1227e4h9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $jgsO4.default), {
        ref: props.keyboardRef,
        id: "article-search-query-input",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        isReadOnly: isReadOnly,
        placeholder: placeholderText ?? formatMessage((0, $aMoe9.messages).defaultPlaceholder),
        value: queryWord,
        "aria-describedby": isHintVisible ? searchEnterHintDescriptionId : undefined,
        elemBeforeInput: /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $b790cfc35501d5ec$var$styles.searchIcon
        }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })),
        elemAfterInput: trailingElement
    })));
});

});
parcelRegister("eHBLW", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("9FFFq")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("d5GPr")).useRouterActions);

parcelRequire("eVv8o");
var $9FFFq = parcelRequire("9FFFq");
var $d5GPr = parcelRequire("d5GPr");
parcelRequire("bVnk8");
var $4eOYB = parcelRequire("4eOYB");
var $PNItk = parcelRequire("PNItk");
parcelRequire("3HwXb");
var $cR19k = parcelRequire("cR19k");
var $2QsBc = parcelRequire("2QsBc");
var $jzerE = parcelRequire("jzerE");
var $3HwXb = parcelRequire("3HwXb");

var $gRFBi = parcelRequire("gRFBi");

var $9BN8H = parcelRequire("9BN8H");

var $6QnPn = parcelRequire("6QnPn");
parcelRequire("6YkRx");
var $3izAR = parcelRequire("3izAR");
var $4Uigc = parcelRequire("4Uigc");
var $gEmE9 = parcelRequire("gEmE9");

});
parcelRegister("eVv8o", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("9FFFq")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("d5GPr")).useRouterActions);

var $lg5R1 = parcelRequire("lg5R1");

var $6oHKU = parcelRequire("6oHKU");

var $6Jc06 = parcelRequire("6Jc06");

var $8KlKX = parcelRequire("8KlKX");

var $9BN8H = parcelRequire("9BN8H");

var $j0yqM = parcelRequire("j0yqM");

var $j5Uzo = parcelRequire("j5Uzo");

var $9FFFq = parcelRequire("9FFFq");

var $d5GPr = parcelRequire("d5GPr");

var $9g23e = parcelRequire("9g23e");

});
parcelRegister("lg5R1", function(module, exports) {

var $g8vBZ = parcelRequire("g8vBZ");

var $98nNe = parcelRequire("98nNe");

var $kHwwG = parcelRequire("kHwwG");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("3HwXb");
var $dE0Xi = parcelRequire("dE0Xi");

var $9FFFq = parcelRequire("9FFFq");
class $f79fa220d2baef8e$var$Redirector extends (0, $bSJIT.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $kHwwG.createPath)((0, $dE0Xi.generateLocationFromPath)(to.path, routeAttributes)) : (0, $kHwwG.createPath)(to) : to;
        const currentPath = (0, $kHwwG.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $98nNe.default)($f79fa220d2baef8e$var$Redirector, "defaultProps", {
    push: false
});
const $f79fa220d2baef8e$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $9FFFq.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f79fa220d2baef8e$var$Redirector, (0, $g8vBZ.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("3HwXb", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("dE0Xi")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("jzerE")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("5p12O")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("gkQC6")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("2QsBc")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("2QsBc")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("j5C8q")).isSameRouteMatch);

var $cR19k = parcelRequire("cR19k");

var $dE0Xi = parcelRequire("dE0Xi");

var $jzerE = parcelRequire("jzerE");

var $5p12O = parcelRequire("5p12O");

var $gkQC6 = parcelRequire("gkQC6");

var $2QsBc = parcelRequire("2QsBc");

var $j5C8q = parcelRequire("j5C8q");

});
parcelRegister("cR19k", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $95bb53883d60e13e$export$883c3f3b6c000133);

var $g8vBZ = parcelRequire("g8vBZ");

var $kHwwG = parcelRequire("kHwwG");

var $4kwMw = parcelRequire("4kwMw");

var $cBGms = parcelRequire("cBGms");
const $95bb53883d60e13e$var$hasWindow = ()=>typeof window !== 'undefined';
const $95bb53883d60e13e$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cBGms)))
};
const $95bb53883d60e13e$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $95bb53883d60e13e$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $95bb53883d60e13e$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($4kwMw)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $95bb53883d60e13e$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $95bb53883d60e13e$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $95bb53883d60e13e$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $g8vBZ.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $95bb53883d60e13e$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $95bb53883d60e13e$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $kHwwG.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $kHwwG.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $95bb53883d60e13e$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
        createHref: (location)=>(0, $kHwwG.createPath)(location)
    } : $95bb53883d60e13e$var$methodsPlaceholders);
};

});

parcelRegister("dE0Xi", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $9eefc0817d15e569$export$37e0729cc751960b);

var $awRZF = parcelRequire("awRZF");

var $cd8bt = parcelRequire("cd8bt");
function $9eefc0817d15e569$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $cd8bt.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $awRZF.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("awRZF", function(module, exports) {
$parcel$export(module.exports, "compile", () => $7aa6c6895f07673a$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $7aa6c6895f07673a$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $7aa6c6895f07673a$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $7aa6c6895f07673a$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $7aa6c6895f07673a$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($7aa6c6895f07673a$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($7aa6c6895f07673a$var$escapeString(prevText), ")[^").concat($7aa6c6895f07673a$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $7aa6c6895f07673a$export$ef7acd7185315e22(str, options) {
    return $7aa6c6895f07673a$export$5b9bad9e403cf3d9($7aa6c6895f07673a$export$98e6a39c04603d36(str, options), options);
}
function $7aa6c6895f07673a$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $7aa6c6895f07673a$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $7aa6c6895f07673a$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $7aa6c6895f07673a$export$71304158c7e35877(str, keys, options);
    return $7aa6c6895f07673a$export$968e97c88708237a(re, keys, options);
}
function $7aa6c6895f07673a$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $7aa6c6895f07673a$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $7aa6c6895f07673a$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $7aa6c6895f07673a$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $7aa6c6895f07673a$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $7aa6c6895f07673a$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $7aa6c6895f07673a$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $7aa6c6895f07673a$var$stringToRegexp(path, keys, options) {
    return $7aa6c6895f07673a$export$9a9303716def6456($7aa6c6895f07673a$export$98e6a39c04603d36(path, options), keys, options);
}
function $7aa6c6895f07673a$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($7aa6c6895f07673a$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($7aa6c6895f07673a$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $7aa6c6895f07673a$var$escapeString(encode(token));
        else {
            var prefix = $7aa6c6895f07673a$var$escapeString(encode(token.prefix));
            var suffix = $7aa6c6895f07673a$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $7aa6c6895f07673a$var$flags(options));
}
function $7aa6c6895f07673a$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $7aa6c6895f07673a$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $7aa6c6895f07673a$var$arrayToRegexp(path, keys, options);
    return $7aa6c6895f07673a$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("jzerE", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $e3ec7da9d086d473$export$82476f982757e71e);

var $awRZF = parcelRequire("awRZF");
const $e3ec7da9d086d473$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $awRZF.compile)(pattern)(params);

});

parcelRegister("5p12O", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $3ef018ed95f7a156$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $4eGW1 = parcelRequire("4eGW1");
const $3ef018ed95f7a156$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $3ef018ed95f7a156$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $4eGW1 !== 'undefined' && $4eGW1.versions != null && $4eGW1.versions.node != null) return true;
    if ($3ef018ed95f7a156$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("gkQC6", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $be4753923cba2c69$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $be4753923cba2c69$export$2e2bcd8739ae039);

var $cd8bt = parcelRequire("cd8bt");

var $GC5n5 = parcelRequire("GC5n5");

var $7ELsD = parcelRequire("7ELsD");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $be4753923cba2c69$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $cd8bt.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $7ELsD.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $GC5n5.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $7ELsD.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $be4753923cba2c69$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$be4753923cba2c69$var$matchRoute(routes, pathname, queryParams, basePath);
const $be4753923cba2c69$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $be4753923cba2c69$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $be4753923cba2c69$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$be4753923cba2c69$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("GC5n5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0801775f52b103e2$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");

var $hfCU4 = parcelRequire("hfCU4");

var $1HQ0T = parcelRequire("1HQ0T");
/* This should match what react-router does to compute a root match. */ const $0801775f52b103e2$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $0801775f52b103e2$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $hfCU4.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $0801775f52b103e2$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $1HQ0T.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $g8vBZ.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $0801775f52b103e2$export$2e2bcd8739ae039 = $0801775f52b103e2$var$execRouteMatching;

});
parcelRegister("hfCU4", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8f203c7786575b6$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $awRZF = parcelRequire("awRZF");
const $c8f203c7786575b6$var$cache = {};
const $c8f203c7786575b6$var$cacheLimit = 10000;
let $c8f203c7786575b6$var$cacheCount = 0;
function $c8f203c7786575b6$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $c8f203c7786575b6$var$cache[cacheKey] || ($c8f203c7786575b6$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $awRZF.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($c8f203c7786575b6$var$cacheCount < $c8f203c7786575b6$var$cacheLimit) {
        pathCache[path] = result;
        $c8f203c7786575b6$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $c8f203c7786575b6$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $c8f203c7786575b6$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $c8f203c7786575b6$export$2e2bcd8739ae039 = $c8f203c7786575b6$var$matchPath;

});

parcelRegister("1HQ0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $13e2275a3b4f3ded$export$2e2bcd8739ae039);

var $g8vBZ = parcelRequire("g8vBZ");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $13e2275a3b4f3ded$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $g8vBZ.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $13e2275a3b4f3ded$export$2e2bcd8739ae039 = $13e2275a3b4f3ded$var$matchQuery;

});


parcelRegister("7ELsD", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $5931158b616498f7$export$f594abf16a5ad948);
const $5931158b616498f7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5931158b616498f7$var$MAX_CACHE_SIZE = 1000;
function $5931158b616498f7$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$5931158b616498f7$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $5931158b616498f7$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($5931158b616498f7$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $5931158b616498f7$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $5931158b616498f7$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("2QsBc", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $21269f3d02607850$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $21269f3d02607850$export$a0bd0313cbeabd49);

var $cd8bt = parcelRequire("cd8bt");

var $6QnPn = parcelRequire("6QnPn");

var $jzerE = parcelRequire("jzerE");

var $gkQC6 = parcelRequire("gkQC6");
const $21269f3d02607850$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $jzerE.generatePath)(route.path, params);
    const matchedRoute = (0, $gkQC6.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $6QnPn.DEFAULT_MATCH),
        query: query
    };
};
const $21269f3d02607850$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $cd8bt.qs).parse(search);
    const matchedRoute = (0, $gkQC6.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $6QnPn.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $6QnPn.DEFAULT_MATCH)
    };
};

});
parcelRegister("6QnPn", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $4fba1512d8721906$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $4fba1512d8721906$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $4fba1512d8721906$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $4fba1512d8721906$export$fa440ddf675c8a93);

var $cBGms = parcelRequire("cBGms");

var $cR19k = parcelRequire("cR19k");
const $4fba1512d8721906$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $4fba1512d8721906$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $4fba1512d8721906$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $4fba1512d8721906$export$39607c9878cf5148 = (0, $cR19k.createLegacyHistory)();
const $4fba1512d8721906$export$1515254c8c90bebb = {
    location: $4fba1512d8721906$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($cBGms)))
};
const $4fba1512d8721906$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("j5C8q", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $de5c10c55ce85958$export$5997e70fc4543270);
const $de5c10c55ce85958$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $de5c10c55ce85958$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $de5c10c55ce85958$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $de5c10c55ce85958$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("9FFFq", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $70a843983a24a4e6$export$9a302a45f65d0572);

var $9BN8H = parcelRequire("9BN8H");
const $70a843983a24a4e6$export$9a302a45f65d0572 = (0, $9BN8H.useRouterStore);

});
parcelRegister("9BN8H", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $6fedafc797694be2$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $6fedafc797694be2$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $6fedafc797694be2$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $6fedafc797694be2$export$ada49399abf7a3a1);

var $g8vBZ = parcelRequire("g8vBZ");

var $kHwwG = parcelRequire("kHwwG");

var $bQodR = parcelRequire("bQodR");
var $gfNVK = parcelRequire("gfNVK");
var $adFyB = parcelRequire("adFyB");
var $7CE69 = parcelRequire("7CE69");
var $jhZn5 = parcelRequire("jhZn5");

var $6QnPn = parcelRequire("6QnPn");
parcelRequire("3HwXb");
var $2QsBc = parcelRequire("2QsBc");
var $dE0Xi = parcelRequire("dE0Xi");
var $jzerE = parcelRequire("jzerE");
var $5p12O = parcelRequire("5p12O");
var $gkQC6 = parcelRequire("gkQC6");

var $6rJO4 = parcelRequire("6rJO4");
const $6fedafc797694be2$export$36d128238e6b60f5 = {
    action: (0, $6QnPn.DEFAULT_ACTION),
    basePath: '',
    location: (0, $6QnPn.DEFAULT_HISTORY).location,
    history: (0, $6QnPn.DEFAULT_HISTORY),
    match: (0, $6QnPn.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $6QnPn.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $6fedafc797694be2$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $2QsBc.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $g8vBZ.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $5p12O.isServerEnvironment)()) dispatch($6fedafc797694be2$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $2QsBc.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $6rJO4.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $bQodR.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $g8vBZ.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $6rJO4.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $6rJO4.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $dE0Xi.generateLocationFromPath)(route.path, (0, $g8vBZ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $gkQC6.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $6rJO4.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $6rJO4.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $dE0Xi.generateLocationFromPath)(route.path, (0, $g8vBZ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $gkQC6.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $g8vBZ.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $6rJO4.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $6rJO4.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $g8vBZ.default)({}, existingPathParams, params);
            const updatedPath = (0, $jzerE.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $g8vBZ.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $6rJO4.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $6rJO4.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $6fedafc797694be2$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $6rJO4.isExternalAbsolutePath)(path)) {
                const location = (0, $kHwwG.parsePath)((0, $6rJO4.getRelativePath)(path, basePath));
                nextContext = (0, $2QsBc.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $bQodR.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $6fedafc797694be2$export$1cf0ecab63b1963c = (0, $7CE69.createStore)({
    initialState: $6fedafc797694be2$export$36d128238e6b60f5,
    actions: $6fedafc797694be2$var$actions,
    name: 'router'
});
const $6fedafc797694be2$export$d6b817abe7a77ea5 = (0, $adFyB.createContainer)($6fedafc797694be2$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($6fedafc797694be2$var$actions.bootstrapStore(props));
            !(0, $5p12O.isServerEnvironment)() && dispatch($6fedafc797694be2$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $5p12O.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $6fedafc797694be2$export$9569010eab09ae9e = (0, $gfNVK.createHook)($6fedafc797694be2$export$1cf0ecab63b1963c);
const $6fedafc797694be2$export$ada49399abf7a3a1 = (0, $gfNVK.createActionsHook)($6fedafc797694be2$export$1cf0ecab63b1963c);
function $6fedafc797694be2$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $gfNVK.createHook)($6fedafc797694be2$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $6fedafc797694be2$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $jhZn5.defaultRegistry).getStore($6fedafc797694be2$export$1cf0ecab63b1963c);
const $6fedafc797694be2$export$ebf37f7e180b13a9 = ()=>$6fedafc797694be2$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("6rJO4", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $4b18cbf14098dfc3$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $4b18cbf14098dfc3$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $4b18cbf14098dfc3$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $4b18cbf14098dfc3$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $4b18cbf14098dfc3$export$c9237620ff7fdf7c);

var $cd8bt = parcelRequire("cd8bt");
parcelRequire("3HwXb");
var $j5C8q = parcelRequire("j5C8q");
const $4b18cbf14098dfc3$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $4b18cbf14098dfc3$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $4b18cbf14098dfc3$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $4b18cbf14098dfc3$var$stripTrailingSlash(prefix);
        prefix = $4b18cbf14098dfc3$var$addLeadingSlash(prefix);
        path = $4b18cbf14098dfc3$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $4b18cbf14098dfc3$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $4b18cbf14098dfc3$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$4b18cbf14098dfc3$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($cd8bt)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($cd8bt)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $4b18cbf14098dfc3$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$4b18cbf14098dfc3$export$e83e3719fc818ee5(path)) {
        path = $4b18cbf14098dfc3$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($cd8bt)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $4b18cbf14098dfc3$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $cd8bt.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $4b18cbf14098dfc3$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $4b18cbf14098dfc3$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $j5C8q.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("6oHKU", function(module, exports) {

var $g8vBZ = parcelRequire("g8vBZ");

var $kHwwG = parcelRequire("kHwwG");

var $bSJIT = parcelRequire("bSJIT");

var $9BN8H = parcelRequire("9BN8H");
const $4a86ece6568346c5$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9BN8H.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $4a86ece6568346c5$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $bSJIT.useMemo)(()=>(0, $kHwwG.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4a86ece6568346c5$export$55185c17a0fcbe46, (0, $g8vBZ.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("6Jc06", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $d5GPr = parcelRequire("d5GPr");
const $4e60411e638c13a6$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $d5GPr.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(actions));
};
$4e60411e638c13a6$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("d5GPr", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $987cf6dd3f16b39d$export$402e82ff1b20594b);

var $9BN8H = parcelRequire("9BN8H");
const $987cf6dd3f16b39d$export$402e82ff1b20594b = (0, $9BN8H.useRouterStoreActions);

});


parcelRegister("8KlKX", function(module, exports) {

var $kV77Q = parcelRequire("kV77Q");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("3HwXb");
var $5p12O = parcelRequire("5p12O");

var $9BN8H = parcelRequire("9BN8H");
const $65e37efd175ef8f2$var$_excluded = [
    "listen"
];
const $65e37efd175ef8f2$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $9BN8H.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $kV77Q.default)(_ref, $65e37efd175ef8f2$var$_excluded);
    if (!state.unlisten && !(0, $5p12O.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(state, actions));
};

});

parcelRegister("j0yqM", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $gfNVK = parcelRequire("gfNVK");

var $9BN8H = parcelRequire("9BN8H");
const $dd68b9ad6c2f354d$var$createPathParamHook = (0, $gfNVK.createHook)((0, $9BN8H.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $dd68b9ad6c2f354d$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $dd68b9ad6c2f354d$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $bSJIT.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("j5Uzo", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $gfNVK = parcelRequire("gfNVK");

var $9BN8H = parcelRequire("9BN8H");
const $de6a5d8c3bce4ce9$var$createQueryParamHook = (0, $gfNVK.createHook)((0, $9BN8H.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $de6a5d8c3bce4ce9$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $de6a5d8c3bce4ce9$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $bSJIT.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("9g23e", function(module, exports) {

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");

var $9BN8H = parcelRequire("9BN8H");
const $6bd732fc968f9154$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $6bd732fc968f9154$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $6bd732fc968f9154$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $9BN8H.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, (0, $g8vBZ.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("bVnk8", function(module, exports) {

var $PNItk = parcelRequire("PNItk");

var $4eOYB = parcelRequire("4eOYB");

});
parcelRegister("PNItk", function(module, exports) {

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");

var $kHwwG = parcelRequire("kHwwG");

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("3HwXb");
var $2QsBc = parcelRequire("2QsBc");
var $dE0Xi = parcelRequire("dE0Xi");

var $9BN8H = parcelRequire("9BN8H");

var $k7sZl = parcelRequire("k7sZl");
parcelRequire("OIQrX");
var $9IRLT = parcelRequire("9IRLT");
var $jsI5k = parcelRequire("jsI5k");
const $09bb54278e38fa1e$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $09bb54278e38fa1e$var$PREFETCH_DELAY = 225;
const $09bb54278e38fa1e$var$Link = /*#__PURE__*/ (0, $bSJIT.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $kV77Q.default)(_ref, $09bb54278e38fa1e$var$_excluded);
    const routerActions = (0, $9BN8H.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $k7sZl.useTimeout)($09bb54278e38fa1e$var$PREFETCH_DELAY);
    const validLinkType = (0, $9IRLT.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $bSJIT.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $kHwwG.createPath)((0, $dE0Xi.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $bSJIT.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $2QsBc.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $jsI5k.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $bSJIT.createElement)(validLinkType, (0, $g8vBZ.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$09bb54278e38fa1e$var$Link.displayName = 'Link';
var $09bb54278e38fa1e$export$2e2bcd8739ae039 = $09bb54278e38fa1e$var$Link;

});
parcelRegister("k7sZl", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $ea5af29b07a0bf8e$export$d8e6abf214c9ec0f);

var $bSJIT = parcelRequire("bSJIT");
const $ea5af29b07a0bf8e$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $bSJIT.useRef)();
    const schedule = (0, $bSJIT.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("OIQrX", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("9IRLT")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("jsI5k")).handleNavigation);

var $9IRLT = parcelRequire("9IRLT");

var $jsI5k = parcelRequire("jsI5k");

});
parcelRegister("9IRLT", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $7141ef07fc440e7e$export$855ece989b15eb57);
const $7141ef07fc440e7e$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $7141ef07fc440e7e$export$855ece989b15eb57 = (type)=>$7141ef07fc440e7e$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("jsI5k", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $e2b2d42cc62066c8$export$706ad1af8096e280);

var $7MI7o = parcelRequire("7MI7o");
const $e2b2d42cc62066c8$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $7MI7o.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $7MI7o.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $7MI7o.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("7MI7o", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $5aaf3d105666937c$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $5aaf3d105666937c$export$130b789831072f4c);
const $5aaf3d105666937c$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $5aaf3d105666937c$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("4eOYB", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("eVv8o");
var $9FFFq = parcelRequire("9FFFq");
const $31600315702bb9c1$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $9FFFq.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("gRFBi", function(module, exports) {
parcelRequire("3HwXb");
var $2QsBc = parcelRequire("2QsBc");
const $c471dd95b14fd39a$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $2QsBc.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("6YkRx", function(module, exports) {

var $huGcl = parcelRequire("huGcl");

var $4Uigc = parcelRequire("4Uigc");

var $gEmE9 = parcelRequire("gEmE9");

var $iNIDv = parcelRequire("iNIDv");

var $3izAR = parcelRequire("3izAR");

var $huGcl = parcelRequire("huGcl");

var $9bqKh = parcelRequire("9bqKh");

});
parcelRegister("huGcl", function(module, exports) {

var $3izAR = parcelRequire("3izAR");
parcelRequire("cVMbZ");
var $2ZAYN = parcelRequire("2ZAYN");
const $cbc5f8aa6e76aa5e$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $cbc5f8aa6e76aa5e$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $3izAR.getResourceStore)().actions;
    const nextResources = (0, $2ZAYN.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $cbc5f8aa6e76aa5e$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $3izAR.getResourceStore)().actions;
    const nextResources = (0, $2ZAYN.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $cbc5f8aa6e76aa5e$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $3izAR.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $cbc5f8aa6e76aa5e$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $cbc5f8aa6e76aa5e$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $cbc5f8aa6e76aa5e$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $3izAR.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $3izAR.getResourceStore)().actions;
            const nextResources = (0, $2ZAYN.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $3izAR.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("3izAR", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $266ea9af7d8fca9f$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $266ea9af7d8fca9f$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $266ea9af7d8fca9f$export$98e41a62c9bef75e);

var $g8vBZ = parcelRequire("g8vBZ");

var $kV77Q = parcelRequire("kV77Q");

var $gfNVK = parcelRequire("gfNVK");
var $adFyB = parcelRequire("adFyB");
var $7CE69 = parcelRequire("7CE69");
var $6h2Sh = parcelRequire("6h2Sh");
var $jhZn5 = parcelRequire("jhZn5");
parcelRequire("3HwXb");
var $5p12O = parcelRequire("5p12O");

var $aujXw = parcelRequire("aujXw");
parcelRequire("cVMbZ");
var $dwGTQ = parcelRequire("dwGTQ");
var $50Roo = parcelRequire("50Roo");
var $9ouVg = parcelRequire("9ouVg");
var $gF5CN = parcelRequire("gF5CN");
var $ggh4t = parcelRequire("ggh4t");
var $LpG9s = parcelRequire("LpG9s");
var $42Thz = parcelRequire("42Thz");
var $eNpMf = parcelRequire("eNpMf");
var $6If5z = parcelRequire("6If5z");
var $cMEx0 = parcelRequire("cMEx0");
var $bOXoO = parcelRequire("bOXoO");
var $i8gKc = parcelRequire("i8gKc");
const $266ea9af7d8fca9f$var$_excluded = [
    "context"
], $266ea9af7d8fca9f$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $266ea9af7d8fca9f$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $9ouVg.deleteResourceState)(type, key));
                dispatch((0, $dwGTQ.executeForDependents)(resource, (dependentResource)=>$266ea9af7d8fca9f$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $9ouVg.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $kV77Q.default)(_getState, $266ea9af7d8fca9f$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $aujXw.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $g8vBZ.default)({}, prevSlice, changes, {
                expiresAt: (0, $42Thz.getExpiresAt)(maxAge),
                accessedAt: (0, $ggh4t.getAccessedAt)()
            });
            dispatch((0, $9ouVg.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $dwGTQ.executeForDependents)(resource, (dependentResource)=>$266ea9af7d8fca9f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $9ouVg.getResourceState)(type, key));
            if (cached && (0, $eNpMf.shouldUseCache)(cached)) {
                if ((0, $eNpMf.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $6If5z.setSsrDataPromise)(cached);
                    cached = (0, $42Thz.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $ggh4t.getAccessedAt)();
                dispatch((0, $9ouVg.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($266ea9af7d8fca9f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $9ouVg.getResourceState)(type, key)) || (0, $LpG9s.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $i8gKc.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $9ouVg.getPrefetchSlice)(type, key)) || (0, $50Roo.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $dwGTQ.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $9ouVg.setResourceState)(type, key, (0, $g8vBZ.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $ggh4t.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $dwGTQ.executeForDependents)(resource, (dependentResource)=>$266ea9af7d8fca9f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $cMEx0.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $9ouVg.getResourceState)(type, key));
            const finalSlice = (0, $g8vBZ.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $ggh4t.getAccessedAt)(),
                expiresAt: (0, $42Thz.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $9ouVg.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $9ouVg.getPrefetchSlice)(type, key)) || (0, $50Roo.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $dwGTQ.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $9ouVg.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $dwGTQ.executeForDependents)(resource, (dependentResource)=>$266ea9af7d8fca9f$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $266ea9af7d8fca9f$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $dwGTQ.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $266ea9af7d8fca9f$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $dwGTQ.actionWithDependencies)(routerStoreContext.route.resources, resource, $266ea9af7d8fca9f$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $dwGTQ.actionWithDependencies)(routerStoreContext.route.resources, resource, $266ea9af7d8fca9f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $dwGTQ.actionWithDependencies)(routerStoreContext.route.resources, resource, $266ea9af7d8fca9f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($266ea9af7d8fca9f$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $9ouVg.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $9ouVg.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $5p12O.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $dwGTQ.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$266ea9af7d8fca9f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $dwGTQ.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$266ea9af7d8fca9f$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $g8vBZ.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $bOXoO.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $kV77Q.default)(_ref, $266ea9af7d8fca9f$var$_excluded2);
                const deserializedError = !error ? null : (0, $gF5CN.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $g8vBZ.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $bOXoO.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $gF5CN.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $cMEx0.TimeoutError) ? loading : false
                }))
};
const $266ea9af7d8fca9f$export$94f50dade551bd01 = (0, $7CE69.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $266ea9af7d8fca9f$export$e324594224ef24da,
    name: 'router-resources'
});
const $266ea9af7d8fca9f$export$cc90fb9c37c5589d = (0, $adFyB.createContainer)($266ea9af7d8fca9f$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $266ea9af7d8fca9f$export$fee1a6213543bd78 = (0, $6h2Sh.createSubscriber)($266ea9af7d8fca9f$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $aujXw.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $266ea9af7d8fca9f$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $jhZn5.defaultRegistry).getStore($266ea9af7d8fca9f$export$94f50dade551bd01);
const $266ea9af7d8fca9f$export$ac3608e0bb357c7 = (0, $gfNVK.createHook)($266ea9af7d8fca9f$export$94f50dade551bd01, {
    selector: (0, $aujXw.getSliceForResource)
});
const $266ea9af7d8fca9f$export$98e41a62c9bef75e = (0, $gfNVK.createActionsHook)($266ea9af7d8fca9f$export$94f50dade551bd01);
const $266ea9af7d8fca9f$export$e59f52df235ac7b3 = (0, $gfNVK.createHook)($266ea9af7d8fca9f$export$94f50dade551bd01, {
    selector: (0, $aujXw.getResourceStoreContext)
});

});
parcelRegister("aujXw", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $7a2c30308da75adb$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $7a2c30308da75adb$export$6a0b1779210de0ee);

var $g8vBZ = parcelRequire("g8vBZ");
parcelRequire("cVMbZ");
var $LpG9s = parcelRequire("LpG9s");
const $7a2c30308da75adb$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $g8vBZ.default)({}, slice) : (0, $LpG9s.getDefaultStateSlice)();
};
const $7a2c30308da75adb$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("cVMbZ", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("ggh4t")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("50Roo")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("dwGTQ")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("dwGTQ")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("dwGTQ")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("dwGTQ")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("42Thz")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("42Thz")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("LpG9s")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("2ZAYN")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("i8gKc")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("9ouVg")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("9ouVg")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("9ouVg")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("9ouVg")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("9ouVg")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("gF5CN")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("gF5CN")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("eNpMf")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("eNpMf")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("6If5z")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("cMEx0")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("bOXoO")).transformData);

var $ggh4t = parcelRequire("ggh4t");

var $50Roo = parcelRequire("50Roo");

var $h6CBl = parcelRequire("h6CBl");

var $dwGTQ = parcelRequire("dwGTQ");

var $42Thz = parcelRequire("42Thz");

var $4jZyv = parcelRequire("4jZyv");

var $LpG9s = parcelRequire("LpG9s");

var $3VJMR = parcelRequire("3VJMR");

var $2ZAYN = parcelRequire("2ZAYN");

var $i8gKc = parcelRequire("i8gKc");

var $9ouVg = parcelRequire("9ouVg");

var $802B4 = parcelRequire("802B4");

var $gF5CN = parcelRequire("gF5CN");

var $eNpMf = parcelRequire("eNpMf");

var $6If5z = parcelRequire("6If5z");

var $cMEx0 = parcelRequire("cMEx0");

var $bOXoO = parcelRequire("bOXoO");

});
parcelRegister("ggh4t", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $bd6b61f1fe927f12$export$9ccb639b7a119f61);
const $bd6b61f1fe927f12$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("50Roo", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $3a665e70e1d1662e$export$dc62515c8f0b52dd);

var $g8vBZ = parcelRequire("g8vBZ");

var $cpe9v = parcelRequire("cpe9v");

var $42Thz = parcelRequire("42Thz");

var $4jZyv = parcelRequire("4jZyv");

var $cMEx0 = parcelRequire("cMEx0");

var $amp0C = parcelRequire("amp0C");
function $3a665e70e1d1662e$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $g8vBZ.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $4jZyv.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $cMEx0.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $42Thz.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $cpe9v.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $42Thz.getExpiresAt)((0, $amp0C.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("cpe9v", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $9082cc2b553decb6$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $9082cc2b553decb6$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $9082cc2b553decb6$export$12c1dc38ea1692da);
const $9082cc2b553decb6$export$881d135f98d8d7d0 = 100;
const $9082cc2b553decb6$export$9ab5bdcb8a1d6c34 = false;
const $9082cc2b553decb6$export$12c1dc38ea1692da = 0;

});

parcelRegister("42Thz", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $2f223b4550384a69$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $2f223b4550384a69$export$18d1d420fd588368);

var $g8vBZ = parcelRequire("g8vBZ");
const $2f223b4550384a69$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $2f223b4550384a69$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $g8vBZ.default)({}, slice, {
        expiresAt: $2f223b4550384a69$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("4jZyv", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $3258af6765a134fa$export$58634b3a58ae66b7);
const $3258af6765a134fa$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("cMEx0", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $94e9687058ded1a5$export$66d311bf29d5c89c);
class $94e9687058ded1a5$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("amp0C", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $78af5bbc70f2c714$export$37d3126be6549b13);
const $78af5bbc70f2c714$export$37d3126be6549b13 = 10000;

});


parcelRegister("h6CBl", function(module, exports) {

var $cpe9v = parcelRequire("cpe9v");
/**
 * Utility method to created async versions of getData functions
 */ const $c740f0a19ff9a43b$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $c740f0a19ff9a43b$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $c740f0a19ff9a43b$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $cpe9v.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $cpe9v.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $cpe9v.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("dwGTQ", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $9d8f8a7d76e0f7d1$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $9d8f8a7d76e0f7d1$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $9d8f8a7d76e0f7d1$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $9d8f8a7d76e0f7d1$export$75915f81f2a6540a);

var $g8vBZ = parcelRequire("g8vBZ");

var $LpG9s = parcelRequire("LpG9s");

var $9ouVg = parcelRequire("9ouVg");
var $9d8f8a7d76e0f7d1$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $9d8f8a7d76e0f7d1$var$fromEntries = ($9d8f8a7d76e0f7d1$var$_Object$fromEntries = Object.fromEntries) != null ? $9d8f8a7d76e0f7d1$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $9d8f8a7d76e0f7d1$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $9d8f8a7d76e0f7d1$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $9d8f8a7d76e0f7d1$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($9d8f8a7d76e0f7d1$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($9d8f8a7d76e0f7d1$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($9d8f8a7d76e0f7d1$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $9d8f8a7d76e0f7d1$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($9d8f8a7d76e0f7d1$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $9d8f8a7d76e0f7d1$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$9d8f8a7d76e0f7d1$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $9d8f8a7d76e0f7d1$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($9d8f8a7d76e0f7d1$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $9d8f8a7d76e0f7d1$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($9d8f8a7d76e0f7d1$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $9d8f8a7d76e0f7d1$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($9d8f8a7d76e0f7d1$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $9d8f8a7d76e0f7d1$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $9d8f8a7d76e0f7d1$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $9d8f8a7d76e0f7d1$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $9ouVg.getResourceState)(dependencyType, key)) || (0, $LpG9s.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $9ouVg.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $g8vBZ.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("LpG9s", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $08e84f304576bd8f$export$fa8e33c3301e2e94);

var $g8vBZ = parcelRequire("g8vBZ");

var $ggh4t = parcelRequire("ggh4t");

var $cpe9v = parcelRequire("cpe9v");

var $42Thz = parcelRequire("42Thz");

var $fPudD = parcelRequire("fPudD");
const $08e84f304576bd8f$export$fa8e33c3301e2e94 = ()=>(0, $g8vBZ.default)({}, (0, $fPudD.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $42Thz.getExpiresAt)((0, $cpe9v.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $ggh4t.getAccessedAt)()
    });

});
parcelRegister("fPudD", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $b8630f4e5511c8b8$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $b8630f4e5511c8b8$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("9ouVg", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $6d6e578acc00a940$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $6d6e578acc00a940$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $6d6e578acc00a940$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $6d6e578acc00a940$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $6d6e578acc00a940$export$d40f35dc5952864b);

var $kV77Q = parcelRequire("kV77Q");

var $g8vBZ = parcelRequire("g8vBZ");
function $6d6e578acc00a940$var$_toPropertyKey(t) {
    var i = $6d6e578acc00a940$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $6d6e578acc00a940$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $6d6e578acc00a940$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $6d6e578acc00a940$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $g8vBZ.default)({}, prefetching, {
                [type]: (0, $g8vBZ.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $6d6e578acc00a940$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($6d6e578acc00a940$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $g8vBZ.default)({}, data, {
                [type]: (0, $g8vBZ.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $6d6e578acc00a940$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $6d6e578acc00a940$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $kV77Q.default)(data, [
            type
        ].map($6d6e578acc00a940$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $kV77Q.default)(resourceForType, [
                key
            ].map($6d6e578acc00a940$var$_toPropertyKey));
            setState({
                data: (0, $g8vBZ.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("3VJMR", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $2dca36582e827a08$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $2dca36582e827a08$export$cd7fbe7e979df558);
const $2dca36582e827a08$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $2dca36582e827a08$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$2dca36582e827a08$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("2ZAYN", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $22ddf6a7c97f87a2$export$7cbbc763e2f3d65d);

var $3VJMR = parcelRequire("3VJMR");

var $802B4 = parcelRequire("802B4");
const $22ddf6a7c97f87a2$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $802B4.routeHasResources)(nextRoute)) return [];
    if ((0, $802B4.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $3VJMR.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $3VJMR.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("802B4", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $5d305681b1415640$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $5d305681b1415640$export$221027ff1aa38f82);
const $5d305681b1415640$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $5d305681b1415640$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("i8gKc", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $d335f65e91935d2e$export$89440b7623c2c75c);

var $9ouVg = parcelRequire("9ouVg");
const $d335f65e91935d2e$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $d335f65e91935d2e$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $d335f65e91935d2e$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $d335f65e91935d2e$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $d335f65e91935d2e$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $9ouVg.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("gF5CN", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $c214d6a61590ac68$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $c214d6a61590ac68$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $c214d6a61590ac68$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c214d6a61590ac68$var$NonError);
    }
}
const $c214d6a61590ac68$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $c214d6a61590ac68$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $c214d6a61590ac68$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $c214d6a61590ac68$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $c214d6a61590ac68$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $c214d6a61590ac68$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $c214d6a61590ac68$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $c214d6a61590ac68$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $c214d6a61590ac68$var$NonError(value);
};

});

parcelRegister("eNpMf", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $ac59a314d8cc6d91$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $ac59a314d8cc6d91$export$399de8c43d0ece3c);
const $ac59a314d8cc6d91$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $ac59a314d8cc6d91$var$isFresh = (resource)=>{
    if ($ac59a314d8cc6d91$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $ac59a314d8cc6d91$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($ac59a314d8cc6d91$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("6If5z", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $4e328e74a0c3d1f1$export$2e4da1b414980956);

var $g8vBZ = parcelRequire("g8vBZ");
const $4e328e74a0c3d1f1$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $g8vBZ.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("bOXoO", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $89b270aa4e794602$export$3ceb62baab058c6b);
const $89b270aa4e794602$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("4Uigc", function(module, exports) {

var $bSJIT = parcelRequire("bSJIT");

var $gEmE9 = parcelRequire("gEmE9");
const $392a8e834a59c8bc$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $gEmE9.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(result));
};

});
parcelRegister("gEmE9", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $c1f1f2e7452702fb$export$9f6abfd74295843b);

var $g8vBZ = parcelRequire("g8vBZ");

var $bSJIT = parcelRequire("bSJIT");

var $gfNVK = parcelRequire("gfNVK");

var $9BN8H = parcelRequire("9BN8H");

var $3izAR = parcelRequire("3izAR");
const $c1f1f2e7452702fb$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $3izAR.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $9BN8H.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $bSJIT.useMemo)(()=>(0, $gfNVK.createHook)((0, $9BN8H.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $3izAR.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $bSJIT.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $bSJIT.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $bSJIT.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $bSJIT.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $bSJIT.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $g8vBZ.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("iNIDv", function(module, exports) {

var $3izAR = parcelRequire("3izAR");
const $daff6d693901282c$export$dee7bf9fc0ff48c3 = (fn)=>(0, $3izAR.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("9bqKh", function(module, exports) {
const $6af9e3367e7b7338$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("aMoe9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0e05c0db8df78c21$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $0e05c0db8df78c21$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    defaultPlaceholder: {
        id: 'company-hub.article-search-component.placeholder',
        defaultMessage: 'Search for help',
        description: 'Default placeholder text for the article search input.'
    },
    searchHint: {
        id: 'company-hub.article-search-component.search-hint',
        defaultMessage: 'Search',
        description: 'Label shown next to an Enter key icon at the end of the search field, hinting that pressing Enter runs the search.'
    },
    searchHintDescription: {
        id: 'company-hub.article-search-component.search-hint-description',
        defaultMessage: 'Press Enter to search',
        description: 'Description of the search field, announced to screen reader users only, explaining that pressing the Enter key runs the search.'
    }
});

});



parcelRegister("g04TG", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchComponent", () => $7e9521d8458e78fc$export$8fa6497fb1b229b0);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $jDsoo = parcelRequire("jDsoo");

var $gdUUy = parcelRequire("gdUUy");

var $26Jy2 = parcelRequire("26Jy2");

var $9PwDt = parcelRequire("9PwDt");

var $5CgBK = parcelRequire("5CgBK");

var $hJs5J = parcelRequire("hJs5J");

var $2EplR = parcelRequire("2EplR");

var $jebvR = parcelRequire("jebvR");

var $61tGS = parcelRequire("61tGS");
const $7e9521d8458e78fc$var$styles = {
    responsiveTrigger: "_1bsb1kdj _p12f1osq"
};
const $7e9521d8458e78fc$export$8fa6497fb1b229b0 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $bSJIT.useState)('');
    const [showDropdown, setShowDropdown] = (0, $bSJIT.useState)(false);
    const inputBoxRef = (0, $bSJIT.useRef)(null);
    const inputRef = (0, $bSJIT.useRef)(null);
    const [_, setInputWidth] = (0, $bSJIT.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, hubType: hubType, env: { helpCenterAri: helpCenterAri, relativeBaseUrl: relativeBaseUrl } } = (0, $hJs5J.useHubContext)();
    if (!helpCenterAri || !cloudId) throw new Error('Help center Ari and cloud ID are required');
    (0, $bSJIT.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $bAB3U.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $bSJIT.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            ref: inputBoxRef,
            xcss: (0, $jDsoo.cx)((0, $gdUUy.fg)('hubs_jsm_max_width_appearance') && $7e9521d8458e78fc$var$styles.responsiveTrigger)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jebvR.SearchTextField), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onInput: handleInput,
            isReadOnly: isEditor,
            placeholderText: placeholderText,
            showDropdown: showDropdown,
            queryWord: queryWord,
            searchBasePath: relativeBaseUrl || undefined,
            showSearchEnterHint: (0, $gdUUy.fg)('hubs_help_object_search_enter_hint') && hubType === 'HELP_HUB'
        }));
    }, [
        hubType,
        isEditor,
        placeholderText,
        queryWord,
        relativeBaseUrl,
        showDropdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return(// Not redundant with the scope HubAppShell mounts: `Popup` portals to
            // `body`, so the dropdown escapes that subtree and loses the hub fonts.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5CgBK.HubTypographyScope), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2EplR.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $61tGS.HelpObjectSearchDropdown), {
                ...contentProps,
                cloudId: cloudId,
                helpCenterAri: helpCenterAri || '',
                inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                queryWord: queryWord
            }))));
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("61tGS", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchDropdown", () => $dd27e6d119a04e28$export$99781ab3c09b5cc0);

var $bSJIT = parcelRequire("bSJIT");

var $itx7D = parcelRequire("itx7D");

var $5yrDi = parcelRequire("5yrDi");

var $53Hx5 = parcelRequire("53Hx5");

var $eq7PN = parcelRequire("eq7PN");
const $dd27e6d119a04e28$export$99781ab3c09b5cc0 = ({ inputWidth: inputWidth, queryWord: queryWord, ...props })=>{
    const results = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $53Hx5.SearchSkeletons), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eq7PN.HelpObjectSearchResults), {
        ...props,
        queryWord: queryWord
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5yrDi.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $itx7D.HubErrorBoundary), {
        key: queryWord,
        id: "help-object-search-results",
        packageName: "article-search",
        operationNames: [
            'helpObjectSearchResultsQuery',
            'articleResultsQuery',
            'portalResultsQuery',
            'requestTypeResultsQuery'
        ],
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eq7PN.HelpObjectSearchError), null)
    }, results));
};

});
parcelRegister("eq7PN", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchError", () => $6b6cde33bfd8a1c7$export$9152df2cffc49a08);
$parcel$export(module.exports, "HelpObjectSearchResults", () => $6b6cde33bfd8a1c7$export$4d1c12e2349aa7cc);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $0f4P6 = parcelRequire("0f4P6");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");

var $7WQx2 = parcelRequire("7WQx2");

var $8fxpQ = parcelRequire("8fxpQ");

var $emsU2 = parcelRequire("emsU2");

var $gdUUy = parcelRequire("gdUUy");

var $bLXMw = parcelRequire("bLXMw");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");

var $dq6Pg = parcelRequire("dq6Pg");

var $cxe40 = parcelRequire("cxe40");

var $4rONO = parcelRequire("4rONO");

var $8jqcV = parcelRequire("8jqcV");

var $gFlLJ = parcelRequire("gFlLJ");

var $bzWoX = parcelRequire("bzWoX");
const $6b6cde33bfd8a1c7$var$DEFAULT_RESULTS_LIMIT = 3;
const $6b6cde33bfd8a1c7$export$9152df2cffc49a08 = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ $bSJIT.createElement((0, $dq6Pg.EmptyState), {
        title: formatMessage((0, $gFlLJ.messages).errorTitle),
        Image: (0, $8jqcV.SearchErrorImage),
        content: /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $gFlLJ.messages).errorDescription)
    });
};
const $6b6cde33bfd8a1c7$var$ExternalLinkComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ href: href = '#', ...props }, ref)=>/*#__PURE__*/ $bSJIT.createElement((0, $bLXMw.Anchor), {
        ref: ref,
        href: href,
        ...props,
        target: "_blank",
        xcss: $6b6cde33bfd8a1c7$var$styles.externalLink,
        rel: "noopener noreferrer"
    }));
const $6b6cde33bfd8a1c7$var$InternalLinkComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ href: href = '#', children: children, ...props }, ref)=>/*#__PURE__*/ $bSJIT.createElement((0, $3rmIb.default), {
        ref: ref,
        to: href,
        ...props
    }, children));
const $6b6cde33bfd8a1c7$var$CombinedHelpObjectSearchResults = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    var _searchResponse$helpO3, _searchResponse$helpO4;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $a2qIF.useLazyLoadQuery)((0, $0f4P6.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $6b6cde33bfd8a1c7$var$DEFAULT_RESULTS_LIMIT
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const articles = (0, $bSJIT.useMemo)(()=>{
        var _searchResponse$helpO;
        const results = searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticles) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.results;
        if (!results) return [];
        return results.map((result)=>{
            var _result$metadata;
            return {
                ari: result.ari,
                title: result.title,
                url: result.displayLink,
                type: 'ARTICLE',
                isExternal: (_result$metadata = result.metadata) === null || _result$metadata === void 0 ? void 0 : _result$metadata.isExternal
            };
        });
    }, [
        searchResponse
    ]);
    const requestTypes = (0, $bSJIT.useMemo)(()=>{
        var _searchResponse$helpO2;
        const results = searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchRequestTypes) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.results;
        if (!results) return [];
        return results.map((result)=>({
                id: result.id,
                title: result.title,
                url: result.displayLink,
                iconUrl: result.iconUrl,
                type: 'REQUEST_TYPE'
            }));
    }, [
        searchResponse
    ]);
    const hasArticlesError = Boolean(searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticles) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.message);
    const hasRequestTypesError = Boolean(searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO4 = searchResponse.helpObjectStore_searchRequestTypes) === null || _searchResponse$helpO4 === void 0 ? void 0 : _searchResponse$helpO4.message);
    const hasBothErrors = hasArticlesError && hasRequestTypesError;
    const allResults = (0, $bSJIT.useMemo)(()=>{
        return [
            ...articles,
            ...requestTypes
        ];
    }, [
        articles,
        requestTypes
    ]);
    const showEmptyState = allResults.length === 0;
    const showResolvedState = allResults.length > 0;
    return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null, showEmptyState && (hasBothErrors ? /*#__PURE__*/ $bSJIT.createElement($6b6cde33bfd8a1c7$export$9152df2cffc49a08, null) : /*#__PURE__*/ $bSJIT.createElement((0, $dq6Pg.EmptyState), {
        title: formatMessage((0, $gFlLJ.messages).emptyStateTitle),
        Image: (0, $8jqcV.SearchErrorImage),
        content: /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $gFlLJ.messages).emptyStateDescription)
    })), showResolvedState && /*#__PURE__*/ $bSJIT.createElement((0, $cxe40.SearchDialogContent), null, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        xcss: $6b6cde33bfd8a1c7$var$styles.stackContainer
    }, articles.length > 0 && /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $6b6cde33bfd8a1c7$var$styles.sectionHeading
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $gFlLJ.messages).resourcesHeading))), /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, articles.map((result)=>/*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $6b6cde33bfd8a1c7$var$styles.searchResultContainer,
            key: result.ari
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4rONO.SearchResult), {
            href: result.url,
            linkComponent: result.isExternal ? $6b6cde33bfd8a1c7$var$ExternalLinkComponent : $6b6cde33bfd8a1c7$var$InternalLinkComponent,
            title: result.title,
            isCollapsed: true,
            icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }))))), requestTypes.length > 0 && /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $6b6cde33bfd8a1c7$var$styles.sectionHeading
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $gFlLJ.messages).requestFormsHeading))), /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, requestTypes.map((result)=>/*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $6b6cde33bfd8a1c7$var$styles.searchResultContainer,
            key: result.id
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4rONO.SearchResult), {
            linkComponent: $6b6cde33bfd8a1c7$var$InternalLinkComponent,
            href: result.url,
            title: result.title,
            isCollapsed: true,
            icon: result.iconUrl ? /*#__PURE__*/ $bSJIT.createElement("img", {
                src: result.iconUrl,
                alt: "",
                className: (0, $9fU1q.default)([
                    $6b6cde33bfd8a1c7$var$styles.icon
                ])
            }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8fxpQ))), {
                label: "",
                spacing: "spacious"
            })
        }))))))));
};
const $6b6cde33bfd8a1c7$export$4d1c12e2349aa7cc = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    if ((0, $gdUUy.fg)('jsm_help_object_search_split_queries')) return /*#__PURE__*/ $bSJIT.createElement((0, $bzWoX.SplitHelpObjectSearchResults), {
        key: `${cloudId}:${helpCenterAri}:${queryWord}`,
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryWord: queryWord
    });
    return /*#__PURE__*/ $bSJIT.createElement($6b6cde33bfd8a1c7$var$CombinedHelpObjectSearchResults, {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryWord: queryWord
    });
};
const $6b6cde33bfd8a1c7$var$styles = {
    externalLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51",
    stackContainer: "_1bsb1osq _n3tdpxbi",
    searchResultContainer: "_19bv1b66 _u5f31b66",
    sectionHeading: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvv47k"
};

});
parcelRegister("0f4P6", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb43b6193befc0b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a472b9a3cd02453ab24d020b467a2f18>>
 * @relayHash 4f9e1fc12763ea436c7785c11780ff3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e
const $cb43b6193befc0b4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
    }, v7 = {
        "kind": "Variable",
        "name": "queryTerm",
        "variableName": "queryTerm"
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "highlight",
            "value": false
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreArticleSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "concreteType": "HelpObjectStoreArticleMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isExternal"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreArticleSearchResults"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    }, v13 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreRequestTypeSearchResults"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpObjectSearchResultsQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpObjectSearchResultsQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e",
            "metadata": {},
            "name": "helpObjectSearchResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cb43b6193befc0b4$var$node.hash = "6a19867fd32836b788744dc62a5ce984";
var $cb43b6193befc0b4$export$2e2bcd8739ae039 = $cb43b6193befc0b4$var$node;

});

parcelRegister("gFlLJ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8c3f888f93c8a2d3$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $8c3f888f93c8a2d3$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.help-object-search-component.empty-title',
        defaultMessage: "We couldn't find a match for your search",
        description: 'Text displayed in the dialog when no results are found during the search.'
    },
    emptyStateDescription: {
        id: 'company-hub.help-object-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the search dialog to guide users when there are no results.'
    },
    errorTitle: {
        id: 'company-hub.help-object-search-component.error-title',
        defaultMessage: "We're having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the search.'
    },
    errorDescription: {
        id: 'company-hub.help-object-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the search dialog to guide users when there is an error.'
    },
    resourcesHeading: {
        id: 'company-hub.help-object-search-component.resources-heading',
        defaultMessage: 'Resources',
        description: 'Heading for the resources section in search results.'
    },
    teamPortalsHeading: {
        id: 'company-hub.help-object-search-component.team-portals-heading',
        defaultMessage: 'Team Portals',
        description: 'Heading for the team portals section in search results.'
    },
    requestFormsHeading: {
        id: 'company-hub.help-object-search-component.request-forms-heading',
        defaultMessage: 'Request forms',
        description: 'Heading for the request forms section in search results.'
    }
});

});

parcelRegister("bzWoX", function(module, exports) {
$parcel$export(module.exports, "SplitHelpObjectSearchResults", () => $4d4129800c8306c3$export$afff10febc2e68cd);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $dDEhr = parcelRequire("dDEhr");

var $dq6Pg = parcelRequire("dq6Pg");

var $cxe40 = parcelRequire("cxe40");

var $8jqcV = parcelRequire("8jqcV");

var $53Hx5 = parcelRequire("53Hx5");

var $gFlLJ = parcelRequire("gFlLJ");

var $fv00F = parcelRequire("fv00F");

var $4EgAC = parcelRequire("4EgAC");

var $86NKp = parcelRequire("86NKp");

var $cwzxE = parcelRequire("cwzxE");

var $gSVV9 = parcelRequire("gSVV9");

var $7Vf0o = parcelRequire("7Vf0o");
const $4d4129800c8306c3$var$initialResultStatuses = {
    [(0, $7Vf0o.SearchResultType).Articles]: (0, $7Vf0o.SearchResultStatus).Pending,
    [(0, $7Vf0o.SearchResultType).Portals]: (0, $7Vf0o.SearchResultStatus).Pending,
    [(0, $7Vf0o.SearchResultType).RequestTypes]: (0, $7Vf0o.SearchResultStatus).Pending
};
// Fixed order: Resources, then Team Portals, then Request forms.
const $4d4129800c8306c3$var$DEBOUNCE_DELAY_MS = 500;
const $4d4129800c8306c3$var$sections = [
    {
        type: (0, $7Vf0o.SearchResultType).Articles,
        Component: (0, $fv00F.ArticleResults)
    },
    {
        type: (0, $7Vf0o.SearchResultType).Portals,
        Component: (0, $4EgAC.PortalResults)
    },
    {
        type: (0, $7Vf0o.SearchResultType).RequestTypes,
        Component: (0, $86NKp.RequestTypeResults)
    }
];
const $4d4129800c8306c3$export$afff10febc2e68cd = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [debouncedQueryWord, setDebouncedQueryWordState] = (0, $bSJIT.useState)();
    const [statuses, setStatuses] = (0, $bSJIT.useState)($4d4129800c8306c3$var$initialResultStatuses);
    const setDebouncedQueryWord = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(setDebouncedQueryWordState, $4d4129800c8306c3$var$DEBOUNCE_DELAY_MS), []);
    const updateStatus = (0, $bSJIT.useCallback)((resultType, status)=>{
        setStatuses((currentStatuses)=>{
            if (currentStatuses[resultType] === status) return currentStatuses;
            return {
                ...currentStatuses,
                [resultType]: status
            };
        });
    }, []);
    // Stable per-type handlers so each section's status effect only re-runs when its own status
    // changes, rather than on every parent render.
    const onStatusByType = (0, $bSJIT.useMemo)(()=>({
            [(0, $7Vf0o.SearchResultType).Articles]: (status)=>updateStatus((0, $7Vf0o.SearchResultType).Articles, status),
            [(0, $7Vf0o.SearchResultType).Portals]: (status)=>updateStatus((0, $7Vf0o.SearchResultType).Portals, status),
            [(0, $7Vf0o.SearchResultType).RequestTypes]: (status)=>updateStatus((0, $7Vf0o.SearchResultType).RequestTypes, status)
        }), [
        updateStatus
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setDebouncedQueryWord(queryWord);
        return ()=>{
            setDebouncedQueryWord.cancel();
        };
    }, [
        queryWord,
        setDebouncedQueryWord
    ]);
    if (debouncedQueryWord === undefined) return /*#__PURE__*/ $bSJIT.createElement((0, $cxe40.SearchDialogContent), null, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        xcss: $4d4129800c8306c3$var$styles.stackContainer
    }, /*#__PURE__*/ $bSJIT.createElement((0, $53Hx5.SearchSkeletons), null)));
    const hasPendingResults = Object.values(statuses).includes((0, $7Vf0o.SearchResultStatus).Pending);
    const hasResults = Object.values(statuses).includes((0, $7Vf0o.SearchResultStatus).Results);
    const hasOnlyErrors = Object.values(statuses).every((status)=>status === (0, $7Vf0o.SearchResultStatus).Error);
    const showEmptyState = !hasPendingResults && !hasResults && !hasOnlyErrors;
    const showErrorState = !hasPendingResults && hasOnlyErrors;
    return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null, hasPendingResults && !hasResults && /*#__PURE__*/ $bSJIT.createElement((0, $53Hx5.SearchSkeletons), null), showEmptyState && /*#__PURE__*/ $bSJIT.createElement((0, $dq6Pg.EmptyState), {
        title: formatMessage((0, $gFlLJ.messages).emptyStateTitle),
        Image: (0, $8jqcV.SearchErrorImage),
        content: /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $gFlLJ.messages).emptyStateDescription)
    }), showErrorState && /*#__PURE__*/ $bSJIT.createElement((0, $dq6Pg.EmptyState), {
        title: formatMessage((0, $gFlLJ.messages).errorTitle),
        Image: (0, $8jqcV.SearchErrorImage),
        content: /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $gFlLJ.messages).errorDescription)
    }), (hasResults || hasPendingResults) && /*#__PURE__*/ $bSJIT.createElement((0, $cxe40.SearchDialogContent), null, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        xcss: $4d4129800c8306c3$var$styles.stackContainer
    }, $4d4129800c8306c3$var$sections.map(({ type: type, Component: Component })=>/*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultBoundary), {
            key: type,
            onError: ()=>updateStatus(type, (0, $7Vf0o.SearchResultStatus).Error)
        }, /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Suspense), {
            fallback: hasResults ? /*#__PURE__*/ $bSJIT.createElement((0, $53Hx5.SearchSkeletons), {
                count: 1
            }) : null
        }, /*#__PURE__*/ $bSJIT.createElement(Component, {
            cloudId: cloudId,
            helpCenterAri: helpCenterAri,
            onStatus: onStatusByType[type],
            queryWord: debouncedQueryWord
        })))), (0, $gdUUy.fg)('hubs_help_object_search_enter_hint') && hasResults && /*#__PURE__*/ $bSJIT.createElement((0, $gSVV9.ShowMoreLink), {
        queryWord: queryWord
    }))));
};
const $4d4129800c8306c3$var$styles = {
    stackContainer: "_1bsb1osq _n3tdpxbi"
};

});
parcelRegister("inh7J", function(module, exports) {

var $awGqx = parcelRequire("awGqx");

var $aWEOL = parcelRequire("aWEOL");

var $5UDqS = parcelRequire("5UDqS");
/** Error message constants. */ var $d607a85f0a3cb2c6$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d607a85f0a3cb2c6$var$nativeMax = Math.max, $d607a85f0a3cb2c6$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d607a85f0a3cb2c6$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d607a85f0a3cb2c6$var$FUNC_ERROR_TEXT);
    wait = $5UDqS(wait) || 0;
    if ($awGqx(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d607a85f0a3cb2c6$var$nativeMax($5UDqS(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d607a85f0a3cb2c6$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $aWEOL();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($aWEOL());
    }
    function debounced() {
        var time = $aWEOL(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $d607a85f0a3cb2c6$var$debounce;

});
parcelRegister("aWEOL", function(module, exports) {

var $6Ymo5 = parcelRequire("6Ymo5");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7f7efbb8000b7647$var$now = function() {
    return $6Ymo5.Date.now();
};
module.exports = $7f7efbb8000b7647$var$now;

});


parcelRegister("fv00F", function(module, exports) {
$parcel$export(module.exports, "ArticleResults", () => $7c78bdc2aacb9b31$export$c10eb8bb08a63f90);
/* article-results.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3vIrw = parcelRequire("3vIrw");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $emsU2 = parcelRequire("emsU2");

var $4rONO = parcelRequire("4rONO");

var $gFlLJ = parcelRequire("gFlLJ");

var $cwzxE = parcelRequire("cwzxE");

var $7Vf0o = parcelRequire("7Vf0o");

var $bfVPE = parcelRequire("bfVPE");

var $6H8nj = parcelRequire("6H8nj");
const $7c78bdc2aacb9b31$var$DEFAULT_RESULTS_LIMIT = 3;
const $7c78bdc2aacb9b31$export$c10eb8bb08a63f90 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, onStatus: onStatus, queryWord: queryWord })=>{
    var _data$helpObjectStore, _data$helpObjectStore3;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $3vIrw.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $7c78bdc2aacb9b31$var$DEFAULT_RESULTS_LIMIT
    });
    const errorMessage = (_data$helpObjectStore = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.message;
    const articles = (0, $bSJIT.useMemo)(()=>{
        var _data$helpObjectStore2;
        return ((_data$helpObjectStore2 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.results) ?? [];
    }, [
        (_data$helpObjectStore3 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.results
    ]);
    const resultStatus = (0, $6H8nj.getResultStatus)(errorMessage, articles.length);
    (0, $bfVPE.useSearchResultAnalytics)({
        resultCount: articles.length,
        resultStatus: resultStatus,
        resultType: (0, $7Vf0o.SearchResultType).Articles
    });
    (0, $bSJIT.useEffect)(()=>{
        onStatus(resultStatus);
    }, [
        onStatus,
        resultStatus
    ]);
    if (articles.length === 0 || errorMessage) return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null);
    return /*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultSection), {
        heading: formatMessage((0, $gFlLJ.messages).resourcesHeading)
    }, articles.map((article)=>{
        var _article$metadata;
        return /*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultContainer), {
            key: article.ari
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4rONO.SearchResult), {
            href: article.displayLink,
            linkComponent: (_article$metadata = article.metadata) !== null && _article$metadata !== void 0 && _article$metadata.isExternal ? (0, $cwzxE.ExternalLinkComponent) : (0, $cwzxE.InternalLinkComponent),
            title: article.title,
            isCollapsed: true,
            icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }));
    }));
};

});
parcelRegister("3vIrw", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3bf2afa878e2b19$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0863eb78f0b56d79a6620d1486f690e7>>
 * @relayHash 9ef0f140ce2c2630c1a318d633310d2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc023caf92a359bdb6e8e8fb3c9fbe927f1bad8f7b0bc2a86ed34f07963aae5c
const $f3bf2afa878e2b19$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Literal",
            "name": "highlight",
            "value": false
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreArticleSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "displayLink"
                    },
                    {
                        "concreteType": "HelpObjectStoreArticleMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isExternal"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreArticleSearchResults"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "articleResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "articleResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "fc023caf92a359bdb6e8e8fb3c9fbe927f1bad8f7b0bc2a86ed34f07963aae5c",
            "metadata": {},
            "name": "articleResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f3bf2afa878e2b19$var$node.hash = "1cc7700a3e9a557a0cd862ac9aecccbf";
var $f3bf2afa878e2b19$export$2e2bcd8739ae039 = $f3bf2afa878e2b19$var$node;

});

parcelRegister("cwzxE", function(module, exports) {
$parcel$export(module.exports, "SearchResultBoundary", () => $0826ce3d832150b6$export$ff333f2a35899865);
$parcel$export(module.exports, "ExternalLinkComponent", () => $0826ce3d832150b6$export$17cfda15b3eef31e);
$parcel$export(module.exports, "InternalLinkComponent", () => $0826ce3d832150b6$export$2fef3fb2f4dec78);
$parcel$export(module.exports, "SearchResultSection", () => $0826ce3d832150b6$export$51a5a703da15f0f7);
$parcel$export(module.exports, "SearchResultContainer", () => $0826ce3d832150b6$export$a849c4440d2afe66);
/* search-result-section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");

var $7WQx2 = parcelRequire("7WQx2");

var $bLXMw = parcelRequire("bLXMw");

var $9PwDt = parcelRequire("9PwDt");
class $0826ce3d832150b6$export$ff333f2a35899865 extends (0, $bSJIT.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch() {
        this.props.onError();
    }
    render() {
        return this.state.hasError ? null : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
const $0826ce3d832150b6$export$17cfda15b3eef31e = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ href: href = '#', ...props }, ref)=>/*#__PURE__*/ $bSJIT.createElement((0, $bLXMw.Anchor), {
        ref: ref,
        href: href,
        ...props,
        target: "_blank",
        xcss: $0826ce3d832150b6$var$styles.externalLink,
        rel: "noopener noreferrer"
    }));
const $0826ce3d832150b6$export$2fef3fb2f4dec78 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ href: href = '#', children: children, ...props }, ref)=>/*#__PURE__*/ $bSJIT.createElement((0, $3rmIb.default), {
        ref: ref,
        to: href,
        ...props
    }, children));
const $0826ce3d832150b6$export$51a5a703da15f0f7 = ({ children: children, heading: heading })=>/*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $0826ce3d832150b6$var$styles.sectionHeading
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        as: "h3",
        size: "xsmall"
    }, heading)), children);
const $0826ce3d832150b6$export$a849c4440d2afe66 = ({ children: children })=>/*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $0826ce3d832150b6$var$styles.searchResultContainer
    }, children);
const $0826ce3d832150b6$var$styles = {
    externalLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    searchResultContainer: "_19bv1b66 _u5f31b66",
    sectionHeading: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvv47k"
};

});

parcelRegister("7Vf0o", function(module, exports) {
$parcel$export(module.exports, "SearchResultStatus", () => $edc35951b7410b36$export$3c74771c44f42198);
$parcel$export(module.exports, "SearchResultType", () => $edc35951b7410b36$export$95cacd63dfd98bee);
var $edc35951b7410b36$export$3c74771c44f42198 = /*#__PURE__*/ function(SearchResultStatus) {
    SearchResultStatus["Pending"] = "pending";
    SearchResultStatus["Results"] = "results";
    SearchResultStatus["Empty"] = "empty";
    SearchResultStatus["Error"] = "error";
    return SearchResultStatus;
}({});
var $edc35951b7410b36$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["Articles"] = "articles";
    SearchResultType["Portals"] = "portals";
    SearchResultType["RequestTypes"] = "requestTypes";
    return SearchResultType;
}({});

});

parcelRegister("bfVPE", function(module, exports) {
$parcel$export(module.exports, "useSearchResultAnalytics", () => $23f85d2f98b9eba8$export$cf3afb4db2c5bb64);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $k2MWg = parcelRequire("k2MWg");

var $7Vf0o = parcelRequire("7Vf0o");
const $23f85d2f98b9eba8$var$HELP_OBJECT_SEARCH_ANALYTIC_SOURCE = 'helpObjectSearch';
const $23f85d2f98b9eba8$export$cf3afb4db2c5bb64 = ({ resultCount: resultCount, resultStatus: resultStatus, resultType: resultType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const lastReportedStatus = (0, $bSJIT.useRef)((0, $7Vf0o.SearchResultStatus).Pending);
    (0, $bSJIT.useEffect)(()=>{
        if (resultStatus === (0, $7Vf0o.SearchResultStatus).Pending || lastReportedStatus.current === resultStatus) return;
        lastReportedStatus.current = resultStatus;
        (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({
            source: $23f85d2f98b9eba8$var$HELP_OBJECT_SEARCH_ANALYTIC_SOURCE
        }), `searchResults ${resultStatus === (0, $7Vf0o.SearchResultStatus).Error ? 'failed' : 'resolved'}`, {
            resultCount: resultCount,
            resultType: resultType
        });
    }, [
        createAnalyticsEvent,
        resultCount,
        resultStatus,
        resultType
    ]);
};

});

parcelRegister("6H8nj", function(module, exports) {
$parcel$export(module.exports, "getResultStatus", () => $4e882dcf5b43e1cd$export$166050e137a4dbb4);

var $7Vf0o = parcelRequire("7Vf0o");
const $4e882dcf5b43e1cd$export$166050e137a4dbb4 = (errorMessage, resultCount)=>{
    if (errorMessage) return (0, $7Vf0o.SearchResultStatus).Error;
    if (resultCount > 0) return (0, $7Vf0o.SearchResultStatus).Results;
    return (0, $7Vf0o.SearchResultStatus).Empty;
};

});


parcelRegister("4EgAC", function(module, exports) {
$parcel$export(module.exports, "PortalResults", () => $1722537f9e67d7ea$export$d36a8db16b6d44cc);
/* portal-results.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bKUVq = parcelRequire("bKUVq");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $5oTFa = parcelRequire("5oTFa");

var $4rONO = parcelRequire("4rONO");

var $gFlLJ = parcelRequire("gFlLJ");

var $cwzxE = parcelRequire("cwzxE");

var $7Vf0o = parcelRequire("7Vf0o");

var $bfVPE = parcelRequire("bfVPE");

var $6H8nj = parcelRequire("6H8nj");
const $1722537f9e67d7ea$var$DEFAULT_RESULTS_LIMIT = 3;
const $1722537f9e67d7ea$export$d36a8db16b6d44cc = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, onStatus: onStatus, queryWord: queryWord })=>{
    var _data$helpObjectStore, _data$helpObjectStore3;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $bKUVq.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $1722537f9e67d7ea$var$DEFAULT_RESULTS_LIMIT
    });
    const errorMessage = (_data$helpObjectStore = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.message;
    const portals = (0, $bSJIT.useMemo)(()=>{
        var _data$helpObjectStore2;
        return ((_data$helpObjectStore2 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore2 === void 0 || (_data$helpObjectStore2 = _data$helpObjectStore2.results) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.filter((portal)=>portal.__typename === 'HelpObjectStorePortalSearchResult')) ?? [];
    }, [
        (_data$helpObjectStore3 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.results
    ]);
    const resultStatus = (0, $6H8nj.getResultStatus)(errorMessage, portals.length);
    (0, $bfVPE.useSearchResultAnalytics)({
        resultCount: portals.length,
        resultStatus: resultStatus,
        resultType: (0, $7Vf0o.SearchResultType).Portals
    });
    (0, $bSJIT.useEffect)(()=>{
        onStatus(resultStatus);
    }, [
        onStatus,
        resultStatus
    ]);
    if (portals.length === 0 || errorMessage) return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null);
    return /*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultSection), {
        heading: formatMessage((0, $gFlLJ.messages).teamPortalsHeading)
    }, portals.map((portal)=>/*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultContainer), {
            key: portal.id
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4rONO.SearchResult), {
            href: portal.displayLink,
            linkComponent: (0, $cwzxE.InternalLinkComponent),
            title: portal.title,
            isCollapsed: true,
            icon: portal.iconUrl ? /*#__PURE__*/ $bSJIT.createElement("img", {
                src: portal.iconUrl,
                alt: "",
                className: (0, $9fU1q.default)([
                    $1722537f9e67d7ea$var$styles.icon
                ])
            }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5oTFa))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }))));
};
const $1722537f9e67d7ea$var$styles = {
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51"
};

});
parcelRegister("bKUVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $22592887d49cf845$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d1c6a38756486eb8fb687621048ce80>>
 * @relayHash 885bd39d3055be0e62f6aa397ff732e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdc5f273151879ea39dabff7aaa0325934c9b554b76b6dfca148cc4464809677
const $22592887d49cf845$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStorePortalSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "displayLink"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStorePortalSearchResults"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "portalResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "portalResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "fdc5f273151879ea39dabff7aaa0325934c9b554b76b6dfca148cc4464809677",
            "metadata": {},
            "name": "portalResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$22592887d49cf845$var$node.hash = "38a8a09da34512d24061349cb66a0e46";
var $22592887d49cf845$export$2e2bcd8739ae039 = $22592887d49cf845$var$node;

});


parcelRegister("86NKp", function(module, exports) {
$parcel$export(module.exports, "RequestTypeResults", () => $60b3125d0267bf23$export$16a59c31a51185c5);
/* request-type-results.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $4MIzr = parcelRequire("4MIzr");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $8fxpQ = parcelRequire("8fxpQ");

var $4rONO = parcelRequire("4rONO");

var $gFlLJ = parcelRequire("gFlLJ");

var $cwzxE = parcelRequire("cwzxE");

var $7Vf0o = parcelRequire("7Vf0o");

var $bfVPE = parcelRequire("bfVPE");

var $6H8nj = parcelRequire("6H8nj");
const $60b3125d0267bf23$var$DEFAULT_RESULTS_LIMIT = 3;
const $60b3125d0267bf23$export$16a59c31a51185c5 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, onStatus: onStatus, queryWord: queryWord })=>{
    var _data$helpObjectStore, _data$helpObjectStore3;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $4MIzr.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $60b3125d0267bf23$var$DEFAULT_RESULTS_LIMIT
    });
    const errorMessage = (_data$helpObjectStore = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.message;
    const requestTypes = (0, $bSJIT.useMemo)(()=>{
        var _data$helpObjectStore2;
        return ((_data$helpObjectStore2 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.results) ?? [];
    }, [
        (_data$helpObjectStore3 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.results
    ]);
    const resultStatus = (0, $6H8nj.getResultStatus)(errorMessage, requestTypes.length);
    (0, $bfVPE.useSearchResultAnalytics)({
        resultCount: requestTypes.length,
        resultStatus: resultStatus,
        resultType: (0, $7Vf0o.SearchResultType).RequestTypes
    });
    (0, $bSJIT.useEffect)(()=>{
        onStatus(resultStatus);
    }, [
        onStatus,
        resultStatus
    ]);
    if (requestTypes.length === 0 || errorMessage) return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null);
    return /*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultSection), {
        heading: formatMessage((0, $gFlLJ.messages).requestFormsHeading)
    }, requestTypes.map((requestType)=>/*#__PURE__*/ $bSJIT.createElement((0, $cwzxE.SearchResultContainer), {
            key: requestType.id
        }, /*#__PURE__*/ $bSJIT.createElement((0, $4rONO.SearchResult), {
            linkComponent: (0, $cwzxE.InternalLinkComponent),
            href: requestType.displayLink,
            title: requestType.title,
            isCollapsed: true,
            icon: requestType.iconUrl ? /*#__PURE__*/ $bSJIT.createElement("img", {
                src: requestType.iconUrl,
                alt: "",
                className: (0, $9fU1q.default)([
                    $60b3125d0267bf23$var$styles.icon
                ])
            }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8fxpQ))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }))));
};
const $60b3125d0267bf23$var$styles = {
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51"
};

});
parcelRegister("4MIzr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f1cbcbcb956e03d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5469e60ce3706e81811fe92b1ee8410d>>
 * @relayHash 1d572b0b09b6273877d713d1bc3dd292
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a906b3609a37df47206b6df90f9f24180b744d3564fcfe4c3a7fdb77054abb3f
const $3f1cbcbcb956e03d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "displayLink"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreRequestTypeSearchResults"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "requestTypeResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "requestTypeResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a906b3609a37df47206b6df90f9f24180b744d3564fcfe4c3a7fdb77054abb3f",
            "metadata": {},
            "name": "requestTypeResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3f1cbcbcb956e03d$var$node.hash = "0f366047b72f38714c532a0e12cf562b";
var $3f1cbcbcb956e03d$export$2e2bcd8739ae039 = $3f1cbcbcb956e03d$var$node;

});


parcelRegister("gSVV9", function(module, exports) {
$parcel$export(module.exports, "ShowMoreLink", () => $6dc55f7af2d1d596$export$758fc69c3e12a959);
/* show-more-link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $bLXMw = parcelRequire("bLXMw");

var $9PwDt = parcelRequire("9PwDt");

var $dsKYd = parcelRequire("dsKYd");

var $hJs5J = parcelRequire("hJs5J");

var $gxZ5S = parcelRequire("gxZ5S");
const $6dc55f7af2d1d596$var$styles = {
    container: "_ca0qu2gc _u5f3pxbi _19bvv47k",
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $6dc55f7af2d1d596$export$758fc69c3e12a959 = ({ queryWord: queryWord })=>{
    var _useHubTheming;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const { env: { relativeBaseUrl: relativeBaseUrl } } = (0, $hJs5J.useHubContext)();
    const primaryLinkColor = (_useHubTheming = (0, $dsKYd.useHubTheming)()) === null || _useHubTheming === void 0 ? void 0 : _useHubTheming.primaryLinkColor;
    const brandedLinkStyle = primaryLinkColor ? {
        color: primaryLinkColor
    } : undefined;
    const searchPath = `/articles/search?q=${encodeURIComponent(queryWord)}`;
    const href = `${relativeBaseUrl.replace(/\/+$/, '')}${searchPath}`;
    const onClick = (event)=>{
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        push(searchPath);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $6dc55f7af2d1d596$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bLXMw.Anchor), {
        href: href,
        onClick: onClick,
        style: brandedLinkStyle,
        xcss: $6dc55f7af2d1d596$var$styles.link
    }, formatMessage((0, $gxZ5S.messages).showMore)));
};

});
parcelRegister("gxZ5S", function(module, exports) {
$parcel$export(module.exports, "messages", () => $af5b458a92ca9c46$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $af5b458a92ca9c46$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    showMore: {
        id: 'company-hub.help-object-search-component.show-more',
        defaultMessage: 'Show more',
        description: 'Navigates to the full search results page.'
    }
});

});






parcelRegister("djPMW", function(module, exports) {
$parcel$export(module.exports, "HUB_CONNECT_EXTENSION_TYPE", () => $441e44f409c97576$export$9739bc39ff578ef);
$parcel$export(module.exports, "HUB_CONNECT_EXTENSION_KEY", () => $441e44f409c97576$export$3a3256797a873c9d);
$parcel$export(module.exports, "isFooterExtensionKey", () => $441e44f409c97576$export$5672169d8cc92b0b);
$parcel$export(module.exports, "HUB_CONNECT_EXTENSION_VERSION_1", () => $441e44f409c97576$export$cbd6fa0855da1fbd);
$parcel$export(module.exports, "ConnectElementType", () => $441e44f409c97576$export$a7467005470ef946);
$parcel$export(module.exports, "ConnectPageContext", () => $441e44f409c97576$export$dc1f825c64ccdff6);
$parcel$export(module.exports, "HUB_CONNECT_LEARN_MORE_URL", () => $441e44f409c97576$export$88cc63a4344dc0e3);
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub
 * Connect extension. Must remain stable across product releases — changing
 * it is a breaking change to persisted hub content.
 *
 * Mirrors the Help Center Connect module shape so installed Connect apps
 * (Portal header / Portal footer modules) can be shared between Help
 * Center and Hub editors with zero schema translation.
 */ const $441e44f409c97576$export$9739bc39ff578ef = 'com.atlassian.hub-connect';
const $441e44f409c97576$export$3a3256797a873c9d = 'hub-connect';
const $441e44f409c97576$export$a391370883dc60a0 = `${$441e44f409c97576$export$3a3256797a873c9d}-header`;
const $441e44f409c97576$export$6214169031454add = `${$441e44f409c97576$export$3a3256797a873c9d}-footer`;
const $441e44f409c97576$export$2772ad16b9dc4cf1 = (extensionKey)=>extensionKey === $441e44f409c97576$export$a391370883dc60a0;
const $441e44f409c97576$export$5672169d8cc92b0b = (extensionKey)=>extensionKey === $441e44f409c97576$export$6214169031454add;
const $441e44f409c97576$export$cbd6fa0855da1fbd = '1.0.0';
const $441e44f409c97576$export$a7467005470ef946 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $441e44f409c97576$export$dc1f825c64ccdff6 = {
    HELP_HUB: 'HELP_HUB'
};
const $441e44f409c97576$export$939aa9ef868c885e = 'hubConnectExtension';
const $441e44f409c97576$export$7bb2524ff74eaaaa = 'hubConnectExtensionConfig';
const $441e44f409c97576$export$88cc63a4344dc0e3 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';

});

parcelRegister("jaAJZ", function(module, exports) {
$parcel$export(module.exports, "HUB_FORGE_EXTENSION_TYPE", () => $43c384b85d63c290$export$28815926b67771e7);
$parcel$export(module.exports, "HUB_FORGE_EXTENSION_KEY", () => $43c384b85d63c290$export$e1401e10db30b53d);
$parcel$export(module.exports, "HUB_FORGE_HEADER_EXTENSION_KEY", () => $43c384b85d63c290$export$bbd2284a8b6f23d6);
$parcel$export(module.exports, "HUB_FORGE_FOOTER_EXTENSION_KEY", () => $43c384b85d63c290$export$9204604618f84769);
$parcel$export(module.exports, "HUB_FORGE_EXTENSION_VERSION_1", () => $43c384b85d63c290$export$4fd744a56941aef9);
$parcel$export(module.exports, "ForgeElementType", () => $43c384b85d63c290$export$f351bc2072386324);
$parcel$export(module.exports, "ForgePageContext", () => $43c384b85d63c290$export$ed5f67b6b84eb2bf);
$parcel$export(module.exports, "HUB_FORGE_LEARN_MORE_URL", () => $43c384b85d63c290$export$7e8317652605f123);
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub Forge
 * extension. Must remain stable across product releases — changing it is a
 * breaking change to persisted hub content.
 *
 * Mirrors the Help Center Forge module shape so that Forge UI Kit / Custom UI
 * extensions can be shared between Help Center and Hub editors.
 */ const $43c384b85d63c290$export$28815926b67771e7 = 'com.atlassian.hub-forge';
const $43c384b85d63c290$export$e1401e10db30b53d = 'hub-forge';
const $43c384b85d63c290$export$bbd2284a8b6f23d6 = `${$43c384b85d63c290$export$e1401e10db30b53d}-header`;
const $43c384b85d63c290$export$9204604618f84769 = `${$43c384b85d63c290$export$e1401e10db30b53d}-footer`;
const $43c384b85d63c290$export$4fd744a56941aef9 = '1.0.0';
const $43c384b85d63c290$export$f351bc2072386324 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $43c384b85d63c290$export$ed5f67b6b84eb2bf = {
    HELP_HUB: 'HELP_HUB',
    CSM_HELP_CENTER: 'CSM_HELP_CENTER'
};
const $43c384b85d63c290$export$a4c5610f6315d2b8 = 'hubForgeExtension';
const $43c384b85d63c290$export$10977f18dbecea4f = 'hubForgeExtensionConfig';
const $43c384b85d63c290$export$7e8317652605f123 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';

});

parcelRegister("64bRo", function(module, exports) {
$parcel$export(module.exports, "JSM_HELP_EXTENSION_TYPE", () => $b7412d91819e8e12$export$62b7ac1cc8a8f8d7);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_KEY", () => $b7412d91819e8e12$export$b5a30704f903627a);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $b7412d91819e8e12$export$5eecea5c34e4d0ec);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_VERSION_1", () => $b7412d91819e8e12$export$42fa33c628980eca);
$parcel$export(module.exports, "PAGE_SIZE", () => $b7412d91819e8e12$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "SourceType", () => $b7412d91819e8e12$export$d95e7684b6658cc2);
const $b7412d91819e8e12$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $b7412d91819e8e12$export$b5a30704f903627a = 'jsm-help';
const $b7412d91819e8e12$export$727d928d273126f1 = 'jsmHelpExtension';
const $b7412d91819e8e12$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $b7412d91819e8e12$export$42fa33c628980eca = '1.0.0';
const $b7412d91819e8e12$export$8ec3d08588d2eeda = 9;
const $b7412d91819e8e12$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $b7412d91819e8e12$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};

});

parcelRegister("lW1DY", function(module, exports) {
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_KEY", () => $a1949de87872bdb0$export$5eb13835d9fc35c6);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_TYPE", () => $a1949de87872bdb0$export$1e0076557b3776e7);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE", () => $a1949de87872bdb0$export$bbe74ef6b7213123);
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $a1949de87872bdb0$export$5eb13835d9fc35c6 = 'page-topper';
const $a1949de87872bdb0$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $a1949de87872bdb0$export$bbe74ef6b7213123 = 'calloutBannerExtension';

});

parcelRegister("1ShQP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("dWUvm"),
    $kOunM("8CVn6")
]).then(()=>parcelRequire('arVoz'));

});

parcelRegister("l3V9O", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("apGcy"),
    $kOunM("j32Qx"),
    $kOunM("aHc5N"),
    $kOunM("c9DGA")
]).then(()=>parcelRequire('gKnG8'));

});

parcelRegister("bnwyJ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("apGcy"),
    $kOunM("lmAPh"),
    $kOunM("aGAV7"),
    $kOunM("jAikg"),
    $kOunM("92sIe"),
    $kOunM("aHc5N"),
    $kOunM("272yQ"),
    $kOunM("gXKPw")
]).then(()=>parcelRequire('bPGLf'));

});

parcelRegister("3NA2Y", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fCONc"),
    $kOunM("3JCXN"),
    $kOunM("bIDMA")
]).then(()=>parcelRequire('3j0zg'));

});

parcelRegister("8c7Wl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fCONc"),
    $kOunM("ecsRV"),
    $kOunM("26YZN")
]).then(()=>parcelRequire('lqwVK'));

});


parcelRegister("7rpMX", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgentRenderer", () => $d702bc4d1193514f$export$93c28c6c94b1d8af);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $eMSqH = parcelRequire("eMSqH");

var $4SpKW = parcelRequire("4SpKW");

var $g2U0c = parcelRequire("g2U0c");
const $d702bc4d1193514f$export$93c28c6c94b1d8af = ()=>{
    const aiWidgetConfig = (0, $eMSqH.useOptionalAiWidgetConfig)();
    const supportWidgetConfig = aiWidgetConfig === null || aiWidgetConfig === void 0 ? void 0 : aiWidgetConfig.supportWidgetConfig;
    const isSSR = typeof window !== 'undefined' && !!window.__SSR_RENDERED__;
    const showCornerAgent = Boolean(!isSSR && supportWidgetConfig && supportWidgetConfig.isEnabled && (0, $4SpKW.handleWidgetPosition)(supportWidgetConfig.widgetPosition) === 'CORNER');
    return showCornerAgent ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $g2U0c.AiCornerAgentWithContext), {}) : null;
};

});
parcelRegister("g2U0c", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerWithContext", () => $30c9e30101c9b00b$export$ee4cebdd26cd9fad);
$parcel$export(module.exports, "AiSearchTriggerFloatingWithContext", () => $30c9e30101c9b00b$export$48844b0016715530);
$parcel$export(module.exports, "AiCornerAgentWithContext", () => $30c9e30101c9b00b$export$53048ab92eeb2224);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $eMSqH = parcelRequire("eMSqH");

var $2di5C = parcelRequire("2di5C");

var $jEvhx = parcelRequire("jEvhx");
const $30c9e30101c9b00b$var$useWidgetLocale = ()=>{
    const { locale: locale } = (0, $4vLTk.default)();
    // The widget runs in an iframe and cannot inherit React Intl context from the host application.
    // Forward the resolved application locale so its UI matches the surrounding experience.
    return locale;
};
const $30c9e30101c9b00b$export$ee4cebdd26cd9fad = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $eMSqH.useAiWidgetConfig)();
    const locale = $30c9e30101c9b00b$var$useWidgetLocale();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jEvhx.AiSearchTrigger), {
        locale: locale,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $30c9e30101c9b00b$export$48844b0016715530 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $eMSqH.useAiWidgetConfig)();
    const locale = $30c9e30101c9b00b$var$useWidgetLocale();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jEvhx.AiSearchTriggerFloating), {
        locale: locale,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $30c9e30101c9b00b$export$53048ab92eeb2224 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $eMSqH.useAiWidgetConfig)();
    const locale = $30c9e30101c9b00b$var$useWidgetLocale();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2di5C.AiCornerAgent), {
        locale: locale,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId
    });
};

});
parcelRegister("2di5C", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgent", () => $2ffb988a3ddb0adb$export$df8fdfe108711d3f);

var $bSJIT = parcelRequire("bSJIT");

var $6xP5R = parcelRequire("6xP5R");
const $2ffb988a3ddb0adb$export$df8fdfe108711d3f = ({ locale: locale, site: site, siteId: siteId, widgetId: widgetId })=>{
    (0, $bSJIT.useEffect)(()=>{
        (0, $6xP5R.initCSM)({
            locale: locale,
            site: site,
            siteId: siteId,
            widgetId: widgetId
        });
    }, [
        locale,
        site,
        siteId,
        widgetId
    ]);
    return null;
};

});
parcelRegister("6xP5R", function(module, exports) {
$parcel$export(module.exports, "initCSM", () => $10cb6ef1b63e0995$export$a161b0281c42400f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $juI4y = parcelRequire("juI4y");

var $2G3WQ = parcelRequire("2G3WQ");

var $aBcq5 = parcelRequire("aBcq5");
const $10cb6ef1b63e0995$var$belowDialog = (0, $juI4y.layers).dialog() - 1;
const $10cb6ef1b63e0995$export$a161b0281c42400f = ({ locale: locale, site: siteProp, siteId: siteId, widgetId: widgetId })=>{
    let site = siteProp ?? (typeof window !== 'undefined' && window.location.hostname);
    if (!site) return;
    if (site === 'localhost') // if in development and window.location.hostname === 'localhost'
    // we set it to the testing instance's site url. Change if using different one than the one below
    site = 'support-ccp.jira-dev.com';
    (0, $aBcq5.CSM)({
        locale: locale,
        site: site,
        siteId: siteId,
        widgetId: widgetId
    });
    // Ensures the widget does not render on top of dialogs (e.g., search).
    (0, $2G3WQ.update)({
        zIndex: $10cb6ef1b63e0995$var$belowDialog
    });
};

});
parcelRegister("2G3WQ", function(module, exports) {
$parcel$export(module.exports, "open", () => $dbc1572826c58116$export$3ce6949f20cea765);
$parcel$export(module.exports, "hide", () => $dbc1572826c58116$export$fe8985bb6374093c);
$parcel$export(module.exports, "show", () => $dbc1572826c58116$export$57bf213be019eeb0);
$parcel$export(module.exports, "update", () => $dbc1572826c58116$export$722fbec263ad908a);
$parcel$export(module.exports, "createNewConversation", () => $dbc1572826c58116$export$319172c070d96d91);
$parcel$export(module.exports, "onOpen", () => $dbc1572826c58116$export$16688e2160da47bd);
$parcel$export(module.exports, "onClose", () => $dbc1572826c58116$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "getCurrentConversation", () => $dbc1572826c58116$export$8862049f62228856);
const $dbc1572826c58116$var$createCommand = (command)=>{
    const fn = (...args)=>{
        if (typeof window === 'undefined' || !window.CSM) {
            // eslint-disable-next-line no-console
            console.warn('CSM SDK has not been loaded!');
            return;
        }
        // @ts-expect-error - window.CSM is dynamically typed; TypeScript cannot infer the overloaded command signature at call site
        window.CSM(command, ...args);
    };
    return fn;
};
const $dbc1572826c58116$export$3ce6949f20cea765 = $dbc1572826c58116$var$createCommand('open');
const $dbc1572826c58116$export$8360e631d277ea4d = $dbc1572826c58116$var$createCommand('close');
const $dbc1572826c58116$export$fe8985bb6374093c = $dbc1572826c58116$var$createCommand('hide');
const $dbc1572826c58116$export$57bf213be019eeb0 = $dbc1572826c58116$var$createCommand('show');
const $dbc1572826c58116$export$722fbec263ad908a = $dbc1572826c58116$var$createCommand('update');
const $dbc1572826c58116$export$319172c070d96d91 = $dbc1572826c58116$var$createCommand('createNewConversation');
const $dbc1572826c58116$export$16688e2160da47bd = $dbc1572826c58116$var$createCommand('onOpen');
const $dbc1572826c58116$export$f312d3bc7ef841a8 = $dbc1572826c58116$var$createCommand('onClose');
const $dbc1572826c58116$export$8862049f62228856 = $dbc1572826c58116$var$createCommand('getCurrentConversation');

});

parcelRegister("aBcq5", function(module, exports) {
$parcel$export(module.exports, "CSM", () => $2f80ca723604b783$export$e20267fb524e653f);

var $18kFi = parcelRequire("18kFi");

var $4SYrI = parcelRequire("4SYrI");
const $2f80ca723604b783$export$e20267fb524e653f = async ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, locale: locale })=>{
    if (typeof window === 'undefined') return;
    if (typeof window.CSM === 'undefined') window.CSM = (0, $18kFi.createSDKQueue)();
    return await (0, $4SYrI.loadCSMSDK)({
        site: site,
        siteId: siteId,
        cloudId: cloudId,
        widgetId: widgetId,
        locale: locale
    });
};

});
parcelRegister("18kFi", function(module, exports) {
$parcel$export(module.exports, "createSDKQueue", () => $1dd9aff8bbd5d574$export$7bcdf693772d0a65);
const $1dd9aff8bbd5d574$export$7bcdf693772d0a65 = ()=>{
    const q = function CMSQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};

});

parcelRegister("4SYrI", function(module, exports) {
$parcel$export(module.exports, "loadCSMSDK", () => $ad356722a4dba3f4$export$6aed1f3cc6c8351e);

var $jI1eC = parcelRequire("jI1eC");

var $hXeTg = parcelRequire("hXeTg");
let $ad356722a4dba3f4$var$promise = null;
const $ad356722a4dba3f4$var$NOOP = ()=>{};
const $ad356722a4dba3f4$export$6aed1f3cc6c8351e = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, locale: locale, debug: debug = $ad356722a4dba3f4$var$NOOP })=>{
    if (!$ad356722a4dba3f4$var$promise) $ad356722a4dba3f4$var$promise = new Promise((resolve, reject)=>{
        if (typeof window === 'undefined') {
            debug({
                message: '[SDKLoader]: window is undefined'
            });
            reject(new Error('Failed to load CSM SDK: window is undefined'));
        }
        if (window.CSM && !('__q__' in window.CSM)) {
            debug({
                message: '[SDKLoader]: window.CSM already exists'
            });
            resolve(window.CSM);
        }
        const script = document.createElement('script');
        script.src = (0, $jI1eC.getSDKSrc)({
            site: site,
            siteId: siteId,
            cloudId: cloudId,
            widgetId: widgetId,
            locale: locale
        });
        script.setAttribute('async', '');
        script.type = 'text/javascript';
        script.onerror = ()=>{
            reject(new Error('Failed to load CSM SDK script: onerror'));
        };
        script.onload = ()=>{
            debug({
                message: '[SDKLoader]: script onload called'
            });
            if (window.CSM && !('__q__' in window.CSM)) {
                debug({
                    message: '[SDKLoader]: CSM SDK found after script onload'
                });
                resolve(window.CSM);
            } else {
                debug({
                    message: '[SDKLoader]: CSM SDK not found after script onload'
                });
                reject(new Error('Failed to load CSM SDK: window.CSM is undefined'));
            }
        };
        debug({
            message: '[SDKLoader]: CSM SDK appended to body'
        });
        document.body.appendChild(script);
        /**
       * Preconnect to initialise the connection ahead of loading any iframe
       * which will load static assets from the JCS widget domain.
       */ const link = document.createElement('link');
        const linkHref = (0, $hXeTg.getPreconnectHref)(site);
        link.rel = 'preconnect';
        link.href = linkHref;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
        debug({
            message: `[SDKLoader]: CSM SDK preconnecting to ${linkHref}`
        });
    });
    return $ad356722a4dba3f4$var$promise;
};

});
parcelRegister("jI1eC", function(module, exports) {
$parcel$export(module.exports, "getSDKSrc", () => $a2effebfc76deea9$export$80f32c89482836ae);
const $a2effebfc76deea9$export$80f32c89482836ae = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, locale: locale })=>{
    const url = new URL(`/csm/widget/script.js`, `https://${site}`);
    if (siteId) {
        url.searchParams.set('siteId', siteId);
        url.searchParams.set('site', site);
    }
    if (cloudId) {
        url.searchParams.set('cloudId', cloudId);
        url.searchParams.set('site', site);
    }
    if (widgetId) url.searchParams.set('widgetId', widgetId);
    if (locale) url.searchParams.set('locale', locale);
    return url.toString();
};

});

parcelRegister("hXeTg", function(module, exports) {
$parcel$export(module.exports, "getPreconnectHref", () => $9845a8282680f085$export$270686f4186620fa);
const $9845a8282680f085$var$JCS_WIDGET_DOMAIN_PROD = 'https://jcs-chat-widget.atlassian.com';
const $9845a8282680f085$var$JCS_WIDGET_DOMAIN_STG = 'https://jcs-chat-widget.stg.atlassian.com';
const $9845a8282680f085$export$270686f4186620fa = (site)=>{
    return /jira-dev\.com/.test(site) ? $9845a8282680f085$var$JCS_WIDGET_DOMAIN_STG : $9845a8282680f085$var$JCS_WIDGET_DOMAIN_PROD;
};

});





parcelRegister("jEvhx", function(module, exports) {
$parcel$export(module.exports, "AiSearchTrigger", () => $d4f7fee4df9a662d$export$999e3594add7a0eb);
$parcel$export(module.exports, "AiSearchTriggerFloating", () => $d4f7fee4df9a662d$export$950284a1ac54bad5);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $cglph = parcelRequire("cglph");

var $2D8iL = parcelRequire("2D8iL");

var $2G3WQ = parcelRequire("2G3WQ");

var $ezfFq = parcelRequire("ezfFq");

var $eZuXP = parcelRequire("eZuXP");
const $d4f7fee4df9a662d$var$floatingBoxPositionStyles = null;
const $d4f7fee4df9a662d$var$AiSearchTriggerBase = ()=>{
    const { ref: ref } = (0, $ezfFq.useTriggerIntersectionObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d4f7fee4df9a662d$var$ConnectedAiSearchInput, {
        ref: ref
    });
};
const $d4f7fee4df9a662d$var$hiddenToBottomStyles = null;
const $d4f7fee4df9a662d$var$hiddenToRightStyles = null;
/**
 * Connected "smart" UI component
 *
 * This component is connected to the AI search context and will update the value and onChange
 * functions when the user types in the input.
 *
 * It also handles the submission of the form and the creation of a new conversation.
 *
 * @private
 */ const $d4f7fee4df9a662d$var$ConnectedAiSearchInput = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, hidden: hiddenByProp }, ref)=>{
    const { isTriggerVisible: isTriggerVisible } = (0, $ezfFq.useSearchTriggerVisibility)();
    const { value: value, onChange: onChange } = (0, $ezfFq.useAiSearch)();
    const hideTrigger = hiddenByProp || !isTriggerVisible;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eZuXP.AiSearchInput), {
        ref: ref,
        hidden: hideTrigger,
        // eslint-disable-next-line
        className: (0, $9fU1q.default)([
            hiddenByProp && "_t9ecdgi6",
            !isTriggerVisible && "_t9ec14jq",
            className
        ]),
        value: value,
        onChange: onChange,
        onSubmit: ({ message: message })=>{
            (0, $2G3WQ.show)();
            (0, $2G3WQ.open)();
            (0, $2G3WQ.createNewConversation)(typeof message === 'string' && message.length > 0 ? {
                message: message
            } : {});
            onChange('');
        }
    });
});
const $d4f7fee4df9a662d$var$ConditionalThemeProvider = ({ children: children, themeConfig: themeConfig })=>{
    if (themeConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2D8iL.ThemeProvider), {
        themeConfig: themeConfig
    }, children);
    return children;
};
const $d4f7fee4df9a662d$export$999e3594add7a0eb = ({ locale: locale, site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d4f7fee4df9a662d$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ezfFq.AiSearchTriggerContainer), {
        locale: locale,
        site: site,
        siteId: siteId,
        widgetId: widgetId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d4f7fee4df9a662d$var$AiSearchTriggerBase, null)));
/**
 * The connected search trigger but connected to the store to hide
 * if there is a visible `AiSearchTrigger` in the viewport
 *
 * @private
 */ const $d4f7fee4df9a662d$var$AiSearchTriggerFloatingBase = ()=>{
    const [mounted, setMounted] = (0, $bSJIT.useState)(false);
    const hasIntersectingTrigger = (0, $ezfFq.useHasIntersectingTrigger)();
    const isHidden = !mounted || hasIntersectingTrigger;
    (0, $bSJIT.useLayoutEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d4f7fee4df9a662d$var$ConnectedAiSearchInput, {
        hidden: isHidden,
        className: (0, $9fU1q.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _kqsw1n9t _1ltvidpf _1xi2idpf _94n5xy5q _1pby16oo"
        ])
    });
};
const $d4f7fee4df9a662d$export$950284a1ac54bad5 = ({ locale: locale, site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cglph.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d4f7fee4df9a662d$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ezfFq.AiSearchTriggerContainer), {
        locale: locale,
        site: site,
        siteId: siteId,
        widgetId: widgetId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($d4f7fee4df9a662d$var$AiSearchTriggerFloatingBase, null))));

});
parcelRegister("2D8iL", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $e8783a8225d30fa2$export$d8964aec282183a3);

var $bSJIT = parcelRequire("bSJIT");

var $4rgLs = parcelRequire("4rgLs");

var $hLKpu = parcelRequire("hLKpu");

var $aElCj = parcelRequire("aElCj");

var $8oH9P = parcelRequire("8oH9P");
const $e8783a8225d30fa2$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $e8783a8225d30fa2$export$93d4e7f90805808f = ()=>{
    const context = (0, $bSJIT.useContext)($e8783a8225d30fa2$export$2c657da244d00bd6);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};
const $e8783a8225d30fa2$export$d8964aec282183a3 = ({ children: children, themeConfig: themeConfig, styles: styles = {} })=>{
    if (!themeConfig) throw new Error('themeConfig is required for the CSM Branding to works');
    const themeStyles = (0, $8oH9P.useGenerateThemeBranding)(themeConfig);
    const tokenStyles = (0, $bSJIT.useMemo)(()=>{
        const { borderRadius: borderRadius, space: space, colorRamps: colorRamps } = themeStyles;
        const iconColor = (0, $aElCj.getContrastYIQ)(themeConfig.primaryColor) === 'dark' ? '#FFFFFF' : '#000000';
        const brandColor = (0, $hLKpu.deriveBrandColors)(colorRamps, themeConfig.primaryColor);
        const properties = {
            [(0, $4rgLs.csmAiTokens)['color.100']]: colorRamps.color100,
            [(0, $4rgLs.csmAiTokens)['color.200']]: colorRamps.color200,
            [(0, $4rgLs.csmAiTokens)['color.300']]: colorRamps.color300,
            [(0, $4rgLs.csmAiTokens)['color.400']]: colorRamps.color400,
            [(0, $4rgLs.csmAiTokens)['color.500']]: colorRamps.color500,
            [(0, $4rgLs.csmAiTokens)['color.600']]: colorRamps.color600,
            [(0, $4rgLs.csmAiTokens)['color.700']]: colorRamps.color700,
            [(0, $4rgLs.csmAiTokens)['color.800']]: colorRamps.color800,
            [(0, $4rgLs.csmAiTokens)['color.900']]: colorRamps.color900,
            [(0, $4rgLs.csmAiTokens)['color.1000']]: colorRamps.color1000,
            [(0, $4rgLs.csmAiTokens)['color.icon']]: iconColor,
            [(0, $4rgLs.csmAiTokens)['color.brand']]: brandColor.brand,
            [(0, $4rgLs.csmAiTokens)['color.brand.hover']]: brandColor.hover,
            [(0, $4rgLs.csmAiTokens)['color.brand.active']]: brandColor.active,
            [(0, $4rgLs.csmAiTokens)['color.brand.text']]: brandColor.brandText,
            [(0, $4rgLs.csmAiTokens)['color.brand.hover.text']]: brandColor.hoverText,
            [(0, $4rgLs.csmAiTokens)['color.brand.active.text']]: brandColor.activeText,
            [(0, $4rgLs.csmAiTokens)['border.radius.lg']]: borderRadius.lg,
            [(0, $4rgLs.csmAiTokens)['border.radius.md']]: borderRadius.md,
            [(0, $4rgLs.csmAiTokens)['border.radius.sm']]: borderRadius.sm,
            [(0, $4rgLs.csmAiTokens)['border.radius.container']]: borderRadius.container,
            [(0, $4rgLs.csmAiTokens)['border.radius.widget']]: borderRadius.widget,
            [(0, $4rgLs.csmAiTokens)['space.lg']]: space.lg,
            [(0, $4rgLs.csmAiTokens)['space.md']]: space.md,
            [(0, $4rgLs.csmAiTokens)['space.sm']]: space.sm
        };
        return properties;
    }, [
        themeConfig.primaryColor,
        themeStyles
    ]);
    const combineStyles = {
        ...tokenStyles,
        ...styles,
        // The wrapper only supplies CSS variables and does not participate in layout.
        display: 'contents'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e8783a8225d30fa2$export$2c657da244d00bd6.Provider, {
        value: themeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: combineStyles
    }, children));
};

});
parcelRegister("4rgLs", function(module, exports) {
$parcel$export(module.exports, "csmAiTokens", () => $1d39d8427b1f620a$export$e26bc1991ee46534);
const $1d39d8427b1f620a$export$e26bc1991ee46534 = {
    'color.100': '--csm-color-100',
    'color.200': '--csm-color-200',
    'color.300': '--csm-color-300',
    'color.400': '--csm-color-400',
    'color.500': '--csm-color-500',
    'color.600': '--csm-color-600',
    'color.700': '--csm-color-700',
    'color.800': '--csm-color-800',
    'color.900': '--csm-color-900',
    'color.1000': '--csm-color-1000',
    'color.icon': '--csm-color-icon',
    'color.brand': '--csm-color-brand',
    'color.brand.hover': '--csm-color-brand-hover',
    'color.brand.active': '--csm-color-brand-active',
    'color.brand.text': '--csm-color-brand-text',
    'color.brand.hover.text': '--csm-color-brand-hover-text',
    'color.brand.active.text': '--csm-color-brand-active-text',
    'border.radius.lg': '--csm-border-radius-lg',
    'border.radius.md': '--csm-border-radius-md',
    'border.radius.sm': '--csm-border-radius-sm',
    'border.radius.container': '--csm-border-radius-container',
    'border.radius.widget': '--csm-border-radius-widget',
    'space.lg': '--csm-space-lg',
    'space.md': '--csm-space-md',
    'space.sm': '--csm-space-sm'
};

});

parcelRegister("hLKpu", function(module, exports) {
$parcel$export(module.exports, "deriveBrandColors", () => $a413c2f7ab738d2e$export$56e08ca4c9e5e798);

var $6UBtI = parcelRequire("6UBtI");
const $a413c2f7ab738d2e$var$clampRamp = (n)=>{
    const v = Math.max(100, Math.min(1000, n));
    return v;
};
const $a413c2f7ab738d2e$var$buildRampMap = (r)=>new Map([
        [
            100,
            r.color100
        ],
        [
            200,
            r.color200
        ],
        [
            300,
            r.color300
        ],
        [
            400,
            r.color400
        ],
        [
            500,
            r.color500
        ],
        [
            600,
            r.color600
        ],
        [
            700,
            r.color700
        ],
        [
            800,
            r.color800
        ],
        [
            900,
            r.color900
        ],
        [
            1000,
            r.color1000
        ]
    ]);
const $a413c2f7ab738d2e$var$textOn = (hex)=>{
    return (0, $6UBtI.getContrastRatio)('#FFFFFF', hex) >= (0, $6UBtI.getContrastRatio)('#000000', hex) ? '#FFFFFF' : '#000000';
};
const $a413c2f7ab738d2e$export$56e08ca4c9e5e798 = (ramps, primaryColor)=>{
    const rampMap = $a413c2f7ab738d2e$var$buildRampMap(ramps);
    const target = primaryColor.toLowerCase();
    let baseRamp = 400;
    for (const [n, hex] of rampMap)if (hex.toLowerCase() === target) {
        baseRamp = n;
        break;
    }
    const goLighter = baseRamp >= 800;
    const hoverRamp = $a413c2f7ab738d2e$var$clampRamp(baseRamp + (goLighter ? -200 : 200));
    const activeRamp = $a413c2f7ab738d2e$var$clampRamp(baseRamp + (goLighter ? -300 : 300));
    const brand = rampMap.get(baseRamp);
    const hover = rampMap.get(hoverRamp);
    const active = rampMap.get(activeRamp);
    return {
        brand: brand,
        hover: hover,
        active: active,
        brandText: $a413c2f7ab738d2e$var$textOn(brand),
        hoverText: $a413c2f7ab738d2e$var$textOn(hover),
        activeText: $a413c2f7ab738d2e$var$textOn(active)
    };
};

});
parcelRegister("6UBtI", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $184e447dda7855b6$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $184e447dda7855b6$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $184e447dda7855b6$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $184e447dda7855b6$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $184e447dda7855b6$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $184e447dda7855b6$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $184e447dda7855b6$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $184e447dda7855b6$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $184e447dda7855b6$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $184e447dda7855b6$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $184e447dda7855b6$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $184e447dda7855b6$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $184e447dda7855b6$export$b36dbdb4f463f05c(hex) {
    if (!$184e447dda7855b6$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $184e447dda7855b6$export$1212645cf40ebf71(hex)
    ];
}
function $184e447dda7855b6$export$5a544e13ad4e1fa5(hex) {
    if (!$184e447dda7855b6$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $184e447dda7855b6$export$47ea145a83f50dc0(hex) {
    if (!$184e447dda7855b6$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $184e447dda7855b6$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $184e447dda7855b6$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $184e447dda7855b6$export$d061e26956a60b0a(foreground, background) {
    if (!$184e447dda7855b6$var$isValidHex(foreground) || !$184e447dda7855b6$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $184e447dda7855b6$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $184e447dda7855b6$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $184e447dda7855b6$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $184e447dda7855b6$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $184e447dda7855b6$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $184e447dda7855b6$var$rgbToLab(rgbA);
    let labB = $184e447dda7855b6$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $184e447dda7855b6$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});


parcelRegister("aElCj", function(module, exports) {
$parcel$export(module.exports, "getContrastYIQ", () => $2a075a74f72ddddf$export$5f6ad4d710455f9b);
const $2a075a74f72ddddf$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `rgb(${$2a075a74f72ddddf$var$hexToInt(result, 1)}, ${$2a075a74f72ddddf$var$hexToInt(result, 2)},${$2a075a74f72ddddf$var$hexToInt(result, 3)})` : null;
};
const $2a075a74f72ddddf$var$hexToInt = (arr, index)=>parseInt(arr[index], 16);
const $2a075a74f72ddddf$export$5f6ad4d710455f9b = (hex)=>{
    const rgb = $2a075a74f72ddddf$var$hexToRgb(hex);
    const modifyRgb = rgb ? rgb.substring(4, rgb.length - 1).replace(/ /g, '').split(',') : [];
    const yiq = modifyRgb !== null && modifyRgb !== void 0 && modifyRgb.length ? (Number(modifyRgb[0]) * 299 + Number(modifyRgb[1]) * 587 + Number(modifyRgb[2]) * 114) / 1000 : 0;
    return yiq >= 128 ? 'light' : 'dark';
};

});

parcelRegister("8oH9P", function(module, exports) {
$parcel$export(module.exports, "useGenerateThemeBranding", () => $0111b2097593df4c$export$4be1c3ef709f1b04);

var $bSJIT = parcelRequire("bSJIT");

var $g9i1P = parcelRequire("g9i1P");
const $0111b2097593df4c$export$4be1c3ef709f1b04 = (themeConfig)=>{
    return (0, $bSJIT.useMemo)(()=>{
        const theme = (0, $g9i1P.generateThemeBranding)(themeConfig);
        return theme;
    }, [
        themeConfig
    ]);
};

});
parcelRegister("g9i1P", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $0eb202a894b24953$export$c1410db1c88d6e0f);

var $cmCFy = parcelRequire("cmCFy");
// Values are taken from figma [design](https://www.figma.com/design/sxl0BlQxD2g2eU27Rl2VhG/CSM-X-Loom-Support---In-Product?node-id=2351-34333&t=d8zOoCnHa3EJORFr-4), some are guesstimated
const $0eb202a894b24953$var$BORDER_RADIUS = {
    sharp: {
        lg: '8px',
        md: '4px',
        sm: '2px',
        container: '12px',
        widget: '12px'
    },
    normal: {
        lg: '10px',
        md: '6px',
        sm: '4px',
        container: '18px',
        widget: '18px'
    },
    rounded: {
        lg: '12px',
        md: '10px',
        sm: '6px',
        container: '22px',
        widget: '100%'
    }
};
const $0eb202a894b24953$var$SPACE = {
    cosy: {
        lg: '12px',
        md: '8px',
        sm: '8px'
    },
    comfortable: {
        lg: '16px',
        md: '12px',
        sm: '8px'
    },
    generous: {
        lg: '24px',
        md: '16px',
        sm: '8px'
    }
};
const $0eb202a894b24953$export$c1410db1c88d6e0f = (themeConfig)=>{
    const { radius: radius, space: space, primaryColor: primaryColor } = themeConfig;
    const colorRamps = (0, $cmCFy.generateColorRamps)(primaryColor);
    const borderRadius = $0eb202a894b24953$var$BORDER_RADIUS[radius] || $0eb202a894b24953$var$BORDER_RADIUS.normal;
    const themeSpace = $0eb202a894b24953$var$SPACE[space] || $0eb202a894b24953$var$SPACE.comfortable;
    return {
        colorRamps: colorRamps,
        borderRadius: borderRadius,
        space: themeSpace
    };
};

});
parcelRegister("cmCFy", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $eb290d46f2bb6678$export$3a180ce5632a9d57);

var $6UBtI = parcelRequire("6UBtI");

var $cXoQO = parcelRequire("cXoQO");

var $2vFWz = parcelRequire("2vFWz");

var $fZZF4 = parcelRequire("fZZF4");
const $eb290d46f2bb6678$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $eb290d46f2bb6678$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $eb290d46f2bb6678$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $6UBtI.deltaE)((0, $6UBtI.hexToRgb)(value), (0, $6UBtI.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $eb290d46f2bb6678$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $6UBtI.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $6UBtI.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $6UBtI.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $eb290d46f2bb6678$var$lowLuminanceContrastRatios : $eb290d46f2bb6678$var$highLuminanceContrastRatios;
    const brandRgba = (0, $6UBtI.hexToRgbA)(brandColor);
    const hctColor = (0, $fZZF4.Hct).fromInt((0, $cXoQO.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $cXoQO.rgbaFromArgb)((0, $fZZF4.Hct).from(hctColor.hue, hctColor.chroma, (0, $2vFWz.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $6UBtI.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $eb290d46f2bb6678$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $eb290d46f2bb6678$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $eb290d46f2bb6678$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("cXoQO", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $6588b51c5a847c12$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $6588b51c5a847c12$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $6588b51c5a847c12$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $6588b51c5a847c12$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $6588b51c5a847c12$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $6588b51c5a847c12$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $6588b51c5a847c12$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $6588b51c5a847c12$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $6588b51c5a847c12$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $6588b51c5a847c12$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $aBMcl = parcelRequire("aBMcl");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $6588b51c5a847c12$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $6588b51c5a847c12$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $6588b51c5a847c12$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $6588b51c5a847c12$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $6588b51c5a847c12$export$7928ddf440518d19(linrgb) {
    const r = $6588b51c5a847c12$export$777e26aa2ec02b1(linrgb[0]);
    const g = $6588b51c5a847c12$export$777e26aa2ec02b1(linrgb[1]);
    const b = $6588b51c5a847c12$export$777e26aa2ec02b1(linrgb[2]);
    return $6588b51c5a847c12$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $6588b51c5a847c12$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $6588b51c5a847c12$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $6588b51c5a847c12$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $6588b51c5a847c12$var$blueFromArgb(argb) {
    return argb & 255;
}
function $6588b51c5a847c12$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $6588b51c5a847c12$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $6588b51c5a847c12$export$777e26aa2ec02b1(linearR);
    const g = $6588b51c5a847c12$export$777e26aa2ec02b1(linearG);
    const b = $6588b51c5a847c12$export$777e26aa2ec02b1(linearB);
    return $6588b51c5a847c12$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $6588b51c5a847c12$var$xyzFromArgb(argb) {
    const r = $6588b51c5a847c12$export$dec6bcda7bf47f2c($6588b51c5a847c12$var$redFromArgb(argb));
    const g = $6588b51c5a847c12$export$dec6bcda7bf47f2c($6588b51c5a847c12$var$greenFromArgb(argb));
    const b = $6588b51c5a847c12$export$dec6bcda7bf47f2c($6588b51c5a847c12$var$blueFromArgb(argb));
    return $aBMcl.matrixMultiply([
        r,
        g,
        b
    ], $6588b51c5a847c12$var$SRGB_TO_XYZ);
}
function $6588b51c5a847c12$export$ae8c227f6d0cbddb(lstar) {
    const y = $6588b51c5a847c12$export$7f3071c4a5db05a0(lstar);
    const component = $6588b51c5a847c12$export$777e26aa2ec02b1(y);
    return $6588b51c5a847c12$export$58a74b9f8e513b7b(component, component, component);
}
function $6588b51c5a847c12$export$8b8f7ef2e0a71c61(argb) {
    const y = $6588b51c5a847c12$var$xyzFromArgb(argb)[1];
    return 116.0 * $6588b51c5a847c12$var$labF(y / 100.0) - 16.0;
}
function $6588b51c5a847c12$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $6588b51c5a847c12$var$labInvf((lstar + 16.0) / 116.0);
}
function $6588b51c5a847c12$export$bfc0d1dd9c64ada2(y) {
    return $6588b51c5a847c12$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $6588b51c5a847c12$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $6588b51c5a847c12$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $aBMcl.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $6588b51c5a847c12$export$d4534a444c6526c3() {
    return $6588b51c5a847c12$var$WHITE_POINT_D65;
}
function $6588b51c5a847c12$export$fb1fd26c787a8662(argb) {
    const r = $6588b51c5a847c12$var$redFromArgb(argb);
    const g = $6588b51c5a847c12$var$greenFromArgb(argb);
    const b = $6588b51c5a847c12$var$blueFromArgb(argb);
    const a = $6588b51c5a847c12$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $6588b51c5a847c12$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $6588b51c5a847c12$var$clampComponent(r);
    const gValue = $6588b51c5a847c12$var$clampComponent(g);
    const bValue = $6588b51c5a847c12$var$clampComponent(b);
    const aValue = $6588b51c5a847c12$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $6588b51c5a847c12$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $6588b51c5a847c12$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $6588b51c5a847c12$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("aBMcl", function(module, exports) {
$parcel$export(module.exports, "signum", () => $26cc906fb1bdc73d$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $26cc906fb1bdc73d$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $26cc906fb1bdc73d$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $26cc906fb1bdc73d$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $26cc906fb1bdc73d$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $26cc906fb1bdc73d$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $26cc906fb1bdc73d$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $26cc906fb1bdc73d$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $26cc906fb1bdc73d$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $26cc906fb1bdc73d$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $26cc906fb1bdc73d$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $26cc906fb1bdc73d$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("2vFWz", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $dd67d4bef47d6411$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $cXoQO = parcelRequire("cXoQO");

var $aBMcl = parcelRequire("aBMcl");
class $dd67d4bef47d6411$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $aBMcl.clampDouble(0.0, 100.0, toneA);
        toneB = $aBMcl.clampDouble(0.0, 100.0, toneB);
        return $dd67d4bef47d6411$export$656ae42051d0ca86.ratioOfYs($cXoQO.yFromLstar(toneA), $cXoQO.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $cXoQO.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $dd67d4bef47d6411$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $cXoQO.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $cXoQO.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $dd67d4bef47d6411$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $cXoQO.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $dd67d4bef47d6411$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $dd67d4bef47d6411$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("fZZF4", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $0a0dc1adeb0f50fa$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cXoQO = parcelRequire("cXoQO");

var $aBMcl = parcelRequire("aBMcl");
class $0a0dc1adeb0f50fa$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $0a0dc1adeb0f50fa$export$91d2e033b3924566($0a0dc1adeb0f50fa$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $0a0dc1adeb0f50fa$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($0a0dc1adeb0f50fa$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($0a0dc1adeb0f50fa$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($0a0dc1adeb0f50fa$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $0a0dc1adeb0f50fa$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $cXoQO.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $0a0dc1adeb0f50fa$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $cXoQO.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $0a0dc1adeb0f50fa$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $0a0dc1adeb0f50fa$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $0a0dc1adeb0f50fa$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $0a0dc1adeb0f50fa$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $cXoQO.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $0a0dc1adeb0f50fa$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $0a0dc1adeb0f50fa$var$Cam16.fromIntInViewingConditions(argb, $0a0dc1adeb0f50fa$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $cXoQO.linearized(red);
        const greenL = $cXoQO.linearized(green);
        const blueL = $cXoQO.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $aBMcl.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $aBMcl.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $aBMcl.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $0a0dc1adeb0f50fa$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $0a0dc1adeb0f50fa$var$Cam16.fromJchInViewingConditions(j, c, h, $0a0dc1adeb0f50fa$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $0a0dc1adeb0f50fa$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $0a0dc1adeb0f50fa$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $0a0dc1adeb0f50fa$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $0a0dc1adeb0f50fa$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($0a0dc1adeb0f50fa$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $aBMcl.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $aBMcl.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $aBMcl.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $cXoQO.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $aBMcl.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $aBMcl.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $aBMcl.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $0a0dc1adeb0f50fa$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $aBMcl.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $aBMcl.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $aBMcl.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $0a0dc1adeb0f50fa$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $aBMcl.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $aBMcl.matrixMultiply(linrgb, $0a0dc1adeb0f50fa$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $0a0dc1adeb0f50fa$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $0a0dc1adeb0f50fa$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $0a0dc1adeb0f50fa$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $0a0dc1adeb0f50fa$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $0a0dc1adeb0f50fa$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $0a0dc1adeb0f50fa$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $0a0dc1adeb0f50fa$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $0a0dc1adeb0f50fa$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $0a0dc1adeb0f50fa$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $0a0dc1adeb0f50fa$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($0a0dc1adeb0f50fa$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($0a0dc1adeb0f50fa$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($0a0dc1adeb0f50fa$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $0a0dc1adeb0f50fa$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $0a0dc1adeb0f50fa$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $0a0dc1adeb0f50fa$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($0a0dc1adeb0f50fa$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $0a0dc1adeb0f50fa$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $0a0dc1adeb0f50fa$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $0a0dc1adeb0f50fa$var$HctSolver.criticalPlaneBelow($0a0dc1adeb0f50fa$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $0a0dc1adeb0f50fa$var$HctSolver.criticalPlaneAbove($0a0dc1adeb0f50fa$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $0a0dc1adeb0f50fa$var$HctSolver.criticalPlaneAbove($0a0dc1adeb0f50fa$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $0a0dc1adeb0f50fa$var$HctSolver.criticalPlaneBelow($0a0dc1adeb0f50fa$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $0a0dc1adeb0f50fa$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $0a0dc1adeb0f50fa$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $0a0dc1adeb0f50fa$var$HctSolver.hueOf(mid);
                    if ($0a0dc1adeb0f50fa$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $0a0dc1adeb0f50fa$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $aBMcl.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $0a0dc1adeb0f50fa$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $0a0dc1adeb0f50fa$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $0a0dc1adeb0f50fa$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $0a0dc1adeb0f50fa$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $aBMcl.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $0a0dc1adeb0f50fa$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $0a0dc1adeb0f50fa$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $0a0dc1adeb0f50fa$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $0a0dc1adeb0f50fa$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $cXoQO.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $cXoQO.argbFromLstar(lstar);
        hueDegrees = $aBMcl.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $cXoQO.yFromLstar(lstar);
        const exactAnswer = $0a0dc1adeb0f50fa$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $0a0dc1adeb0f50fa$var$HctSolver.bisectToLimit(y, hueRadians);
        return $cXoQO.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $0a0dc1adeb0f50fa$var$Cam16.fromInt($0a0dc1adeb0f50fa$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $0a0dc1adeb0f50fa$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $0a0dc1adeb0f50fa$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $cXoQO.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $cXoQO.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $aBMcl.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $aBMcl.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $cXoQO.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $0a0dc1adeb0f50fa$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});





parcelRegister("ezfFq", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerContainer", () => $fcd593eb3822be28$export$c23f578d84bfd719);
$parcel$export(module.exports, "useAiSearch", () => $fcd593eb3822be28$export$77f51d599ca38b3);
$parcel$export(module.exports, "useTriggerIntersectionObserver", () => $fcd593eb3822be28$export$d341e445290d4887);
$parcel$export(module.exports, "useHasIntersectingTrigger", () => $fcd593eb3822be28$export$e134485de3777bd2);
$parcel$export(module.exports, "useSearchTriggerVisibility", () => $fcd593eb3822be28$export$7f622cc0692430e8);

var $bSJIT = parcelRequire("bSJIT");

var $adFyB = parcelRequire("adFyB");
var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $2G3WQ = parcelRequire("2G3WQ");

var $6xP5R = parcelRequire("6xP5R");
const $fcd593eb3822be28$var$actions = {
    setInputValue: (inputValue)=>({ setState: setState })=>{
            setState({
                inputValue: inputValue
            });
        },
    observe: (id, element)=>({ setState: setState, getState: getState })=>{
            const { triggers: triggers, observer: currentObserver } = getState();
            const observer = currentObserver ?? new IntersectionObserver(([entry])=>{
                setState({
                    triggers: {
                        ...triggers,
                        [id]: {
                            element: element,
                            isIntersecting: entry.isIntersecting
                        }
                    }
                });
            }, {
                threshold: 0
            });
            setState({
                observer: observer
            });
            observer.observe(element);
        },
    disconnect: (id)=>({ setState: setState, getState: getState })=>{
            const { triggers: prevTriggers, observer: observer } = getState();
            if (observer && prevTriggers[id]) observer.unobserve(prevTriggers[id].element);
            const triggers = {
                ...prevTriggers
            };
            delete triggers[id];
            setState({
                triggers: triggers
            });
        }
};
const $fcd593eb3822be28$var$StoreContainer = (0, $adFyB.createContainer)();
const $fcd593eb3822be28$export$c23f578d84bfd719 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($fcd593eb3822be28$var$StoreContainer, {
        ...props,
        isGlobal: true
    }, children);
};
const $fcd593eb3822be28$var$store = (0, $7CE69.createStore)({
    name: 'csm-ai-search-trigger-store',
    initialState: {
        inputValue: '',
        widgetVisibility: null,
        triggers: {},
        observer: null
    },
    actions: $fcd593eb3822be28$var$actions,
    containedBy: $fcd593eb3822be28$var$StoreContainer,
    handlers: {
        onInit: ()=>({ setState: setState }, { locale: locale, site: site, siteId: siteId, widgetId: widgetId })=>{
                (0, $6xP5R.initCSM)({
                    locale: locale,
                    site: site,
                    siteId: siteId,
                    widgetId: widgetId
                });
                (0, $2G3WQ.hide)();
                setState({
                    widgetVisibility: 'hidden'
                });
                (0, $2G3WQ.onOpen)(()=>{
                    setState({
                        widgetVisibility: 'visible'
                    });
                });
                (0, $2G3WQ.onClose)(()=>{
                    (0, $2G3WQ.getCurrentConversation)((conversation)=>{
                        if (!conversation) {
                            (0, $2G3WQ.hide)();
                            setState({
                                widgetVisibility: 'hidden'
                            });
                        }
                    });
                });
            }
    }
});
const $fcd593eb3822be28$var$searchFieldValueSelector = (state)=>state.inputValue;
const $fcd593eb3822be28$var$useSearchFieldValueHook = (0, $gfNVK.createHook)($fcd593eb3822be28$var$store, {
    selector: $fcd593eb3822be28$var$searchFieldValueSelector
});
const $fcd593eb3822be28$export$77f51d599ca38b3 = ()=>{
    const [inputValue, { setInputValue: setInputValue }] = $fcd593eb3822be28$var$useSearchFieldValueHook();
    return {
        value: inputValue,
        onChange: (value)=>setInputValue(value)
    };
};
const $fcd593eb3822be28$var$useAiSearchStore = (0, $gfNVK.createHook)($fcd593eb3822be28$var$store);
const $fcd593eb3822be28$export$d341e445290d4887 = ()=>{
    const id = (0, $bSJIT.useId)();
    const [_, { observe: observe, disconnect: disconnect }] = $fcd593eb3822be28$var$useAiSearchStore();
    const ref = (0, $bSJIT.useCallback)((element)=>{
        if (element) observe(id, element);
        else disconnect(id);
    }, [
        observe,
        disconnect,
        id
    ]);
    return {
        ref: ref
    };
};
const $fcd593eb3822be28$var$hasIntersectingTriggerSelector = (state)=>{
    return Object.values(state.triggers).some((trigger)=>trigger.isIntersecting);
};
const $fcd593eb3822be28$var$useHasIntersectingTriggerHook = (0, $gfNVK.createHook)($fcd593eb3822be28$var$store, {
    selector: $fcd593eb3822be28$var$hasIntersectingTriggerSelector
});
const $fcd593eb3822be28$export$e134485de3777bd2 = ()=>{
    const [hasIntersectingTrigger] = $fcd593eb3822be28$var$useHasIntersectingTriggerHook();
    return hasIntersectingTrigger;
};
const $fcd593eb3822be28$export$7f622cc0692430e8 = ()=>{
    const [{ widgetVisibility: widgetVisibility }] = $fcd593eb3822be28$var$useAiSearchStore();
    return {
        isTriggerVisible: widgetVisibility !== 'visible'
    };
};

});

parcelRegister("eZuXP", function(module, exports) {
$parcel$export(module.exports, "AiSearchInput", () => $e332e8c2a0617348$export$39dac845faefc1b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $9Abbn = parcelRequire("9Abbn");

var $gHsJf = parcelRequire("gHsJf");

var $512tv = parcelRequire("512tv");

var $l4ZjQ = parcelRequire("l4ZjQ");

var $e4jrw = parcelRequire("e4jrw");
const $e332e8c2a0617348$var$formStyles = null;
const $e332e8c2a0617348$var$hiddenStyles = null;
const $e332e8c2a0617348$export$39dac845faefc1b = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, hidden: hidden, onChange: onChange, onSubmit: onSubmit, value: value }, ref)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const id = (0, $bSJIT.useId)();
    const formLabelledById = `form-${id}-description`;
    const handleSubmit = (e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const message = formData.get('message');
        if (typeof message !== 'string') throw new Error('Message is not a string');
        onSubmit({
            message: message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("form", {
        ref: ref,
        "aria-hidden": hidden,
        // eslint-disable-next-line
        className: (0, $9fU1q.default)([
            "_v56410bs _1e0c1txw _4cvr1h6o _1bsb1ns9 _m6k4gioh _w6ng15vq _t9ecmk3q",
            hidden && "_lcxvglyw _tzy4idpf _3um015vq",
            className
        ]),
        "aria-labelledby": formLabelledById,
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        id: formLabelledById
    }, formatMessage((0, $e4jrw.messages).searchFieldDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gHsJf.SearchTrigger), {
        value: value,
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("label", {
            htmlFor: id
        }, formatMessage((0, $e4jrw.messages).searchPlaceholder)),
        submitButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l4ZjQ.SearchTriggerSubmitButton), {
            as: "button",
            type: "submit"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $512tv.SearchTriggerInputElement), {
        id: id,
        inputLabel: formatMessage((0, $e4jrw.messages).searchInputLabel)
    })));
});

});
parcelRegister("gHsJf", function(module, exports) {
$parcel$export(module.exports, "SearchTrigger", () => $d0a8903c103ec3b1$export$d846b13db73b361e);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $6sLTn = parcelRequire("6sLTn");

var $9Abbn = parcelRequire("9Abbn");

var $lpzUJ = parcelRequire("lpzUJ");
const $d0a8903c103ec3b1$var$EXPANDED_WIDTH = '320px';
const $d0a8903c103ec3b1$var$rootStyles = null;
const $d0a8903c103ec3b1$var$hoverFocusStyles = null;
const $d0a8903c103ec3b1$var$expandedStyles = null;
const $d0a8903c103ec3b1$var$boxStyles = null;
const $d0a8903c103ec3b1$var$subtlePlaceholderStyles = null;
const $d0a8903c103ec3b1$var$layoutStyles = null;
const $d0a8903c103ec3b1$var$inputContainerStyles = null;
const $d0a8903c103ec3b1$var$labelOverlayStyles = null;
const $d0a8903c103ec3b1$var$buttonContainerStyles = null;
const $d0a8903c103ec3b1$export$d846b13db73b361e = ({ children: children, value: value = '', onChange: onChange, placeholder: placeholder, submitButton: submitButton, interactive: interactive = true })=>{
    const [isHovered, setIsHovered] = (0, $bSJIT.useState)(false);
    const [isFocused, setIsFocused] = (0, $bSJIT.useState)(false);
    const isAtRest = value.length === 0 && !isFocused;
    const isExpanded = !isAtRest || isHovered;
    const VisuallyHiddenPlaceholder = isFocused || value.length > 0 ? (0, $9Abbn.default) : (0, $bSJIT.Fragment);
    const contextValue = (0, $bSJIT.useMemo)(()=>{
        return {
            isExpanded: isExpanded,
            isHovered: isHovered,
            isFocused: isFocused,
            setIsHovered: setIsHovered,
            setIsFocused: setIsFocused,
            value: value,
            onChange: onChange,
            isAtRest: isAtRest,
            interactive: interactive
        };
    }, [
        isExpanded,
        isHovered,
        isFocused,
        value,
        onChange,
        isAtRest,
        interactive
    ]);
    const mouseEnterLeaverProps = interactive ? {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    } : {};
    return /*#__PURE__*/ $bSJIT.createElement((0, $lpzUJ.SearchTriggerInputContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_v564130x _1bsbp3fh _m6k41jlu",
            interactive && "_195pnklw _1chpnklw",
            interactive && isExpanded && "_1bsbnklw"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        ...mouseEnterLeaverProps,
        className: (0, $9fU1q.default)([
            "_2rko1rr0 _zulp12x7 _v5641yk7 _11c81d4k _1h6dysee _1dqonqa1 _1bsb1osq _vchhusvi _1e0c1txw _4cvr1fhb _bfhkvuon _16qst7xp _tzy4kb7n _3um0ewfl _w6ng15vq _t9ecmk3q _y4tiu2gc _syazi7uo _4t3i8vuz"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _1bsb1osq"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_kqswh2mm _1bsb1osq"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp12x7 _1wpz1h6o _1e0c1txw _kqswstnw _1ltvpxbi _154iidpf _94n5idpf _lcxvglyw _80om1kdv",
            isAtRest && "_syaz1rpy"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ $bSJIT.createElement(VisuallyHiddenPlaceholder, null, placeholder)), children), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1wpz1h6o"
        ])
    }, submitButton)))));
};

});
parcelRegister("6sLTn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cb129d05fcf195c63eb8b31a673cd76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b4a81fd4599cc0e$var$_react = $4b4a81fd4599cc0e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4b4a81fd4599cc0e$var$_iconNew = $4b4a81fd4599cc0e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4b4a81fd4599cc0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-chat
 * Usage guidance:
 * Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b4a81fd4599cc0e$var$AiChatIcon = (props)=>/*#__PURE__*/ $4b4a81fd4599cc0e$var$_react.default.createElement($4b4a81fd4599cc0e$var$_iconNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$4b4a81fd4599cc0e$var$AiChatIcon.displayName = 'AiChatIcon';
var $4b4a81fd4599cc0e$var$_default = module.exports.default = $4b4a81fd4599cc0e$var$AiChatIcon;

});

parcelRegister("lpzUJ", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputContext", () => $2bcfe0733981b5c8$export$9cec4f4bc0c5ec28);
$parcel$export(module.exports, "useSearchTriggerInput", () => $2bcfe0733981b5c8$export$ffbcaaf65823abae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");
const $2bcfe0733981b5c8$export$9cec4f4bc0c5ec28 = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $2bcfe0733981b5c8$export$ffbcaaf65823abae = ()=>{
    const context = (0, $bSJIT.useContext)($2bcfe0733981b5c8$export$9cec4f4bc0c5ec28);
    if (!context) throw new Error('useSearchTriggerInput must be used within a SearchTriggerInputProvider');
    return context;
};

});


parcelRegister("512tv", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputElement", () => $89443f6043b162b5$export$42ccbc2c6177b53f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $lpzUJ = parcelRequire("lpzUJ");
const $89443f6043b162b5$var$inputStyles = null;
const $89443f6043b162b5$export$42ccbc2c6177b53f = ({ id: id, inputLabel: inputLabel })=>{
    const { value: value, onChange: onChange, setIsFocused: setIsFocused } = (0, $lpzUJ.useSearchTriggerInput)();
    // store the local value in state to avoid the input being "locked in" as a Latin character
    const [localValue, setLocalValue] = (0, $bSJIT.useState)(value);
    const isComposingRef = (0, $bSJIT.useRef)(false);
    // Sync local value with controlled value when not composing
    (0, $bSJIT.useEffect)(()=>{
        if (!isComposingRef.current) setLocalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ $bSJIT.createElement("input", {
        "data-testid": "csm-ai-search-input",
        id: id,
        value: localValue,
        name: "message",
        onChange: (e)=>{
            const newValue = e.currentTarget.value;
            setLocalValue(newValue);
            // Only propagate to parent when not composing (IME input)
            // This fixes Japanese/Chinese/Korean input where the first character
            // would otherwise be "locked in" as a Latin character
            if (!isComposingRef.current) onChange === null || onChange === void 0 || onChange(newValue);
        },
        onCompositionStart: ()=>{
            isComposingRef.current = true;
        },
        onCompositionEnd: (e)=>{
            isComposingRef.current = false;
            // Commit the final composed value after IME conversion completes
            onChange === null || onChange === void 0 || onChange(e.currentTarget.value);
        },
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false),
        autoComplete: "off",
        spellCheck: "false",
        "aria-label": inputLabel,
        className: (0, $9fU1q.default)([
            "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _11c81d4k _r06hglyw _bfhk1j28 _4t3i1osq _1bsb1osq _syazi7uo _vchhusvi _1q51idpf _85i5idpf _bozgoahv _y4tiu2gc"
        ])
    });
};

});

parcelRegister("l4ZjQ", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerSubmitButton", () => $1ceae0aef2351ddc$export$c4e4405f3e81e277);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $611BU = parcelRequire("611BU");

var $lpzUJ = parcelRequire("lpzUJ");

var $hjisI = parcelRequire("hjisI");
// TODO: connect with ADS to figure out the best approach to use dynamic value with cssMap, to avoid manually use the csm token
const $1ceae0aef2351ddc$var$styles = {
    pressable: "_2rko1qll _19itglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1h1tkb7n _4t3i14no _1tkezwfg _bfhki8nm _13ix1yyw _mizu1g87",
    usedState: "_v564k6bl _bfhk1y25 _30l3czge _irr31hsi _1ggl5xtf _9h8h15cr _1di6jowl",
    cursorPointer: "_80omtlke"
};
const $1ceae0aef2351ddc$var$buttonMotionStyles = null;
const $1ceae0aef2351ddc$export$c4e4405f3e81e277 = ({ ...props })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { isExpanded: isExpanded, interactive: interactive } = (0, $lpzUJ.useSearchTriggerInput)();
    const isDimmed = !isExpanded;
    if (props.as === 'button') {
        const { as: _, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("button", {
            "aria-disabled": isDimmed,
            ...rest,
            className: (0, $9fU1q.default)([
                $1ceae0aef2351ddc$var$styles.pressable,
                $1ceae0aef2351ddc$var$styles.cursorPointer,
                interactive && !isDimmed && $1ceae0aef2351ddc$var$styles.usedState,
                interactive && !isDimmed && "_v564k6bl _1ggl5xtf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($611BU))), {
            label: formatMessage((0, $hjisI.messages).searchButtonLabel)
        }));
    }
    const { as: _, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ...rest,
        className: (0, $9fU1q.default)([
            $1ceae0aef2351ddc$var$styles.pressable,
            interactive && !isDimmed && $1ceae0aef2351ddc$var$styles.usedState
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($611BU))), {
        label: formatMessage((0, $hjisI.messages).searchButtonLabel)
    }));
};

});
parcelRegister("611BU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5531747c7120d806a0ad0879344fad9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $461415e2a1424010$var$_react = $461415e2a1424010$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $461415e2a1424010$var$_iconNew = $461415e2a1424010$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $461415e2a1424010$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-right
 * Usage guidance:
 * Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $461415e2a1424010$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $461415e2a1424010$var$_react.default.createElement($461415e2a1424010$var$_iconNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$461415e2a1424010$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $461415e2a1424010$var$_default = module.exports.default = $461415e2a1424010$var$ArrowRightIcon;

});

parcelRegister("hjisI", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a4c35bb8327cb9c4$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a4c35bb8327cb9c4$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    searchButtonLabel: {
        id: 'csm.chat.widget.search.trigger.search.button.label.non-fin',
        defaultMessage: 'Search with AI',
        description: 'label for the CSM chat widget search trigger button'
    }
});

});


parcelRegister("e4jrw", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d59a44c0236bfaa9$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $d59a44c0236bfaa9$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    searchPlaceholder: {
        id: 'csm.chat.widget.search.trigger.search.placeholder',
        defaultMessage: 'Ask anything',
        description: 'placeholder for the CSM chat widget search trigger input'
    },
    searchFieldDescription: {
        id: 'csm.chat.widget.search.trigger.search.field.description',
        defaultMessage: 'Submit your question to get chat with and get answers from our AI assistant',
        description: 'Describes that the input field upon submission will trigger the chat widget'
    },
    searchInputLabel: {
        id: 'csm.chat.widget.search.trigger.search.input.label',
        defaultMessage: 'Chat search trigger input',
        description: 'Accessibility label for chat search input'
    }
});

});





parcelRegister("bxy8b", function(module, exports) {
$parcel$export(module.exports, "HubsDocumentTitle", () => $ebbb7e4a09076ac0$export$9b71b60159f818b1);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $abgy5 = parcelRequire("abgy5");
const $ebbb7e4a09076ac0$export$9b71b60159f818b1 = ({ title: title, shouldRenderDocumentTitle: shouldRenderDocumentTitle, children: children })=>{
    if (!title || !shouldRenderDocumentTitle) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($abgy5))), {
        title: title,
        children: children
    });
};

});

parcelRegister("6fFad", function(module, exports) {
$parcel$export(module.exports, "HubPageBreadcrumbs", () => $85cdcfef1256b467$export$f3c1ece3750b1716);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g7xik = parcelRequire("g7xik");

var $dez4z = parcelRequire("dez4z");

var $ht0a3 = parcelRequire("ht0a3");
const $85cdcfef1256b467$export$f3c1ece3750b1716 = (props)=>{
    const { pageName: pageName, pageType: pageType } = props;
    const pagePath = props.pagePath;
    const parentFolderName = pageType === 'custom' ? props.parentFolderName : undefined;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [isBreadcrumbsEnabled] = (0, $dez4z.useIsHubFeatureEnabled)([
        (0, $dez4z.HUB_FEATURES).BREADCRUMBS
    ]);
    const items = (0, $bSJIT.useMemo)(()=>{
        const normalizedPageName = pageName === null || pageName === void 0 ? void 0 : pageName.trim();
        if (!isBreadcrumbsEnabled || !normalizedPageName) return [];
        const homeItem = {
            href: '/',
            id: 'home',
            text: formatMessage((0, $ht0a3.default).homeBreadcrumb)
        };
        if (pageType === 'portal') {
            if (!pagePath) return [];
            return [
                homeItem,
                {
                    href: pagePath,
                    id: 'portal',
                    text: normalizedPageName
                }
            ];
        }
        const normalizedParentFolderName = parentFolderName === null || parentFolderName === void 0 ? void 0 : parentFolderName.trim();
        return [
            homeItem,
            ...normalizedParentFolderName ? [
                {
                    id: 'parent-folder',
                    text: normalizedParentFolderName
                }
            ] : [],
            {
                href: pagePath,
                id: 'custom-page',
                text: normalizedPageName
            }
        ];
    }, [
        formatMessage,
        isBreadcrumbsEnabled,
        pageName,
        pagePath,
        pageType,
        parentFolderName
    ]);
    (0, $g7xik.useRegisterHubBreadcrumbs)(items);
    return null;
};

});
parcelRegister("ht0a3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5cfafd79922121a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a5cfafd79922121a$var$_default_1 = (0, $f0Pt4.defineMessages)({
    homeBreadcrumb: {
        id: 'hub.hub.homeBreadcrumb',
        defaultMessage: 'Home',
        description: 'Breadcrumb label linking back to the Help Hub home page.'
    },
    hubLoadingSpinnerLabel: {
        id: 'company-hub.hub.loading-spinner-label',
        defaultMessage: 'Loading hub',
        description: 'Accessible label for the loading spinner shown while the company hub page is being loaded.'
    }
});
var $a5cfafd79922121a$export$2e2bcd8739ae039 = $a5cfafd79922121a$var$_default_1;

});



parcelRegister("gLJf4", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $efd2e967cb9aea6b$export$f61abf052f87399f);
$parcel$export(module.exports, "withBannerBackgroundColor", () => $efd2e967cb9aea6b$export$f6b6d100e7beb8c8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hJs5J = parcelRequire("hJs5J");
// 800px is normal width
const $efd2e967cb9aea6b$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $efd2e967cb9aea6b$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $efd2e967cb9aea6b$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $efd2e967cb9aea6b$var$GRID_XXWIDE_WIDTH = '1200px';
const $efd2e967cb9aea6b$var$GRID_NOTE_WIDTH = '480px';
const $efd2e967cb9aea6b$var$GRID_FULL_WIDTH = '100%';
const $efd2e967cb9aea6b$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $efd2e967cb9aea6b$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $efd2e967cb9aea6b$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $efd2e967cb9aea6b$var$GRID_WIDE_WIDTH;
        case 'note':
            return $efd2e967cb9aea6b$var$GRID_NOTE_WIDTH;
        case 'full-width':
            return $efd2e967cb9aea6b$var$GRID_FULL_WIDTH;
        default:
            return $efd2e967cb9aea6b$var$GRID_NORMAL_WIDTH;
    }
};
const $efd2e967cb9aea6b$export$f6b6d100e7beb8c8 = (InnerComponent)=>{
    return (props)=>{
        const hubContext = (0, $hJs5J.useHubContext)();
        const bannerBackgroundColor = hubContext.branding.colors.primary;
        return /*#__PURE__*/ (0, $dc70d.jsx)(InnerComponent, {
            ...props,
            bannerBackgroundColor: bannerBackgroundColor
        });
    };
};

});


parcelRegister("iwrh5", function(module, exports) {
$parcel$export(module.exports, "isMigratedHelpCenterReviewEnabled", () => $5d92322c68d7aafa$export$3062d1bfac14e492);
$parcel$export(module.exports, "isMigratedHelpCenterReviewPath", () => $5d92322c68d7aafa$export$8ec66b40f5f77868);
$parcel$export(module.exports, "buildMigratedHelpCenterEditorUrl", () => $5d92322c68d7aafa$export$a4eb20b7850747d9);
$parcel$export(module.exports, "leaveMigratedHelpCenterReview", () => $5d92322c68d7aafa$export$f295d6724fc207e2);

var $jcRK7 = parcelRequire("jcRK7");

var $87QgR = parcelRequire("87QgR");

var $jpzZU = parcelRequire("jpzZU");

var $gYDJY = parcelRequire("gYDJY");
const $5d92322c68d7aafa$var$MIGRATED_HELP_CENTER_SANDBOX_PATH = /^\/helpcenter\/test\/[^/]+(?:\/|$)/;
const $5d92322c68d7aafa$var$MIGRATED_HELP_CENTER_REVIEW_FLAG = 'enable-help-hub-migration';
const $5d92322c68d7aafa$export$3062d1bfac14e492 = ()=>(0, $87QgR.default).checkGate($5d92322c68d7aafa$var$MIGRATED_HELP_CENTER_REVIEW_FLAG);
const $5d92322c68d7aafa$export$8ec66b40f5f77868 = (pathname)=>$5d92322c68d7aafa$var$MIGRATED_HELP_CENTER_SANDBOX_PATH.test(pathname) || (0, $jpzZU.isDefaultHelpCenterPortalsPreviewPath)(pathname);
const $5d92322c68d7aafa$export$a4eb20b7850747d9 = (input)=>`/helpcenter-management/${encodeURIComponent(input.helpCenterId)}/edit-hub`;
const $5d92322c68d7aafa$export$f295d6724fc207e2 = ()=>{
    (0, $gYDJY.replace)((0, $jcRK7.HELP_CENTERS_MANAGEMENT_BASE_PATH));
};

});

parcelRegister("fkrk1", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => (parcelRequire("i6FGE")).HubAnonymousLayout);
parcelRequire("i6FGE");

});
parcelRegister("i6FGE", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => $20fd27426e5d65b7$export$ae9644df85d50589);
/* hub-anonymous-layout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $9K7mZ = parcelRequire("9K7mZ");

var $aquFW = parcelRequire("aquFW");
const $20fd27426e5d65b7$var$anonymousStyles = null;
const $20fd27426e5d65b7$export$ae9644df85d50589 = ({ children: children })=>/*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1e0c1txw _2lx21bp4 _19pk1ai2 _18u01wug _2hwx1wug _1bsb1osq _p12f1osq _1tke1586 _1wpz1y6m _1c421osq _138yidpf"
        ]),
        style: {
            "--_19v4s1f-": (0, $3zY6O.default)($9K7mZ.multiple(15).unitless, "px", "-"),
            "--_jnopm3": (0, $3zY6O.default)($9K7mZ.multiple(52).unitless, "px")
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $aquFW.NoteBackground), null, children));

});


parcelRegister("aqe5g", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => (parcelRequire("eQXE0")).HubAvatarMenuOptions);

var $eQXE0 = parcelRequire("eQXE0");

});
parcelRegister("eQXE0", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => $ad26853eb41a1a2a$export$4f0698e82fb00313);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $2OuWT = parcelRequire("2OuWT");

var $53Khx = parcelRequire("53Khx");

var $iCbt2 = parcelRequire("iCbt2");

var $i7phc = parcelRequire("i7phc");

var $hXaxc = parcelRequire("hXaxc");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $8xlF3 = parcelRequire("8xlF3");

var $87QgR = parcelRequire("87QgR");

var $cjQhO = parcelRequire("cjQhO");

var $7LtMZ = parcelRequire("7LtMZ");

var $2fYPj = parcelRequire("2fYPj");

var $jSu8y = parcelRequire("jSu8y");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");
parcelRequire("hGqAv");
var $egJeM = parcelRequire("egJeM");

var $dOx4s = parcelRequire("dOx4s");

var $fGcJm = parcelRequire("fGcJm");

var $3PAuB = parcelRequire("3PAuB");

var $47z2s = parcelRequire("47z2s");

var $9p2aJ = parcelRequire("9p2aJ");
const $ad26853eb41a1a2a$var$HubAvatarMenuOptionsComponent = ({ fetchUser: fetchUser, fetchUserRequestsCounts: fetchUserRequestsCounts, fetchOrganisations: fetchOrganisations, canAdministerJIRA: canAdministerJIRA, customMenuLinks: customMenuLinks, myRequestCount: myRequestCount = 0, pendingApprovalCount: pendingApprovalCount = 0, approvalCount: approvalCount = 0 })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [{ match: match }] = (0, $h1bGI.useRouter)();
    // Fetch user data and request counts on component mount
    (0, $bSJIT.useEffect)(()=>{
        fetchUser();
        fetchOrganisations();
        fetchUserRequestsCounts();
    }, [
        fetchUser,
        fetchOrganisations,
        fetchUserRequestsCounts
    ]);
    // Calculate total pending items for badges
    const totalRequestsCount = myRequestCount || 0;
    const totalApprovalsCount = pendingApprovalCount || 0;
    const { portalId: portalId, id: pageId } = match.params;
    const showApprovals = approvalCount > 0 || pendingApprovalCount > 0;
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    const helpCenterId = (0, $dOx4s.parseHelpCenterAri)(helpCenterAri).helpCenterId;
    let editHubSuffix = '';
    if (portalId) editHubSuffix = `/portal/${portalId}`;
    else if (pageId) editHubSuffix = `/${pageId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hXaxc.ForgeModalContextProvider), {
        type: (0, $i7phc.USER_MENU_ACTION_SECTION_MODULE)
    }, !(0, $87QgR.default).checkGate('hub_component_upgrade') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: (0, $2OuWT.Link),
        actionSubjectId: "navbarUserRequests",
        to: "/user/requests?reporter=all&statuses=open",
        iconAfter: totalRequestsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8xlF3.default), null, totalRequestsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $9p2aJ.default).requests)), showApprovals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: (0, $2OuWT.Link),
        actionSubjectId: "navbarUserApprovals",
        to: "/user/approvals",
        iconAfter: totalApprovalsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8xlF3.default), null, totalApprovalsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $9p2aJ.default).approvals))), canAdministerJIRA && !(0, $87QgR.default).checkGate((0, $fGcJm.JSM_HUB_CUSTOMIZE_MENU_GATE)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: (0, $53Khx.HtmlAnchor),
        actionSubjectId: "navbarCustomiseHub",
        href: `/helpcenter-management/${helpCenterId}/edit-hub${editHubSuffix}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $9p2aJ.default).customiseHub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
        component: (0, $53Khx.HtmlAnchor),
        actionSubjectId: "navbarHubSettings",
        href: `/helpcenter-management/hubs`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $9p2aJ.default).hubSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3PAuB.HubConnectMenuSection), {
        customMenuLinks: customMenuLinks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $47z2s.HubForgeMenuSection), null));
};
const $ad26853eb41a1a2a$var$mapStateToProps = (state)=>{
    const userRequestsCounts = (0, $egJeM.getUserRequestsCounts)(state);
    return {
        myRequestCount: userRequestsCounts.myRequestCount,
        pendingApprovalCount: userRequestsCounts.pendingApprovalCount,
        approvalCount: userRequestsCounts.approvalCount,
        canAdministerJIRA: (0, $fBLyB.getCanAdministerJIRA)(state),
        customMenuLinks: (0, $fBLyB.getCustomMenuLinks)(state)
    };
};
const $ad26853eb41a1a2a$export$4f0698e82fb00313 = (0, $f2mlD.default)($ad26853eb41a1a2a$var$mapStateToProps, {
    fetchUser: (0, $iCbt2.fetchUserModelAction),
    fetchUserRequestsCounts: (0, $jSu8y.fetchUserRequestsCountsAction),
    fetchOrganisations: (0, $2fYPj.fetchOrganisationsModelAction)
})($ad26853eb41a1a2a$var$HubAvatarMenuOptionsComponent);

});
parcelRegister("fGcJm", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTES", () => $fb8af627abb88185$export$89e88c91b6499ccb);
$parcel$export(module.exports, "JSM_HUB_CUSTOMIZE_MENU_GATE", () => $fb8af627abb88185$export$fb0ca8bce00435d4);

var $fZKGh = parcelRequire("fZKGh");
const $fb8af627abb88185$export$89e88c91b6499ccb = {
    USER_PROFILE: {
        path: '/user/profile',
        name: 'hubs-user-profile'
    },
    REQUESTS_LIST: {
        path: '/user/requests',
        name: 'requests-list'
    },
    CSM_REQUESTS_LIST: {
        path: '/user/requests',
        name: 'csm-requests-list'
    },
    CSM_CONTACT_US: {
        path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
        name: 'contact-us'
    },
    NOT_FOUND: {
        path: '(.*)',
        name: 'hubs-not-found-error-page'
    },
    CSM_FOLDER: {
        path: '/folder/:folderId',
        name: 'csm-folder'
    },
    CSM_REQUEST_DETAILS: {
        path: '/user/requests/:requestKey',
        name: 'csm-request-details'
    },
    VIEW_PORTAL_ARTICLE: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
        name: 'hubs-view-portal-kb-article'
    },
    PORTAL_ACCESS_FORBIDDEN: {
        path: '/user/forbidden',
        name: 'hubs-portal-access-forbidden'
    },
    VIEW_ARTICLE: {
        path: '/article/:articleId',
        name: 'hubs-view-kb-article'
    },
    VIEW_KB_ARTICLE: {
        path: '/kb/view/:pageId',
        name: 'hubs-view-kb-article'
    },
    VIEW_CROSS_SITE_PORTAL_ARTICLE: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
        name: 'hubs-view-portal-cross-site-kb-article'
    },
    VIEW_CROSS_SITE_ARTICLE: {
        path: '/cloudId/:cloudId/article/:articleId',
        name: 'hubs-view-kb-cross-site-article'
    },
    LOGIN: {
        path: '/user/login',
        name: 'hubs-login'
    },
    PORTAL_LOGIN: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/login`,
        name: 'hubs-portal-login'
    },
    SIGNUP: {
        path: '/user/signup',
        name: 'hubs-user-signup'
    },
    PORTAL_SIGNUP: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/signup`,
        name: 'hubs-portal-signup'
    },
    COMPLETE_SIGNUP: {
        path: '/user/complete-signup',
        name: 'hubs-user-complete-signup'
    },
    PORTAL_COMPLETE_SIGNUP: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
        name: 'hubs-portal-complete-signup'
    },
    RESET_PASSWORD: {
        path: '/user/resetpassword',
        name: 'hubs-user-reset-password'
    },
    PORTAL_RESET_PASSWORD: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
        name: 'hubs-portal-reset-password'
    },
    CHECK_EMAIL: {
        path: '/user/check-email',
        name: 'hubs-user-checkmail'
    },
    PORTAL_INVITED_SIGNUP: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
        name: 'hubs-portal-invited-signup'
    },
    UNSUBSCRIBE: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/:requestKey/unsubscribe`,
        name: 'hubs-unsubscribe'
    },
    REQUEST_FEEDBACK: {
        path: `${(0, $fZKGh.PORTAL_ROUTE_PREFIX)}/:requestKey/feedback`,
        name: 'jsm-hubs-request-feedback'
    },
    REQUEST_CREATE: {
        path: `/portal/:portalId/create/:requestTypeId`,
        name: 'jsm-hubs-request-create'
    },
    ANONYMOUS_REQUEST_SUCCESS: {
        path: `/portal/:portalId/create/:requestTypeId/confirm`,
        name: 'jsm-hubs-anonymous-request-success'
    },
    JSM_REQUEST_DETAILS: {
        path: `/portal/:portalId/:requestKey`,
        name: 'jsm-hubs-request-details'
    },
    JSM_REQUESTS_LIST: {
        path: `/user/requests`,
        name: 'jsm-hubs-requests-list'
    },
    JSM_APPROVALS: {
        path: `/user/approvals`,
        name: 'jsm-hubs-approvals'
    },
    JSM_REQUEST_APPROVAL: {
        path: `/portal/:portalId/:requestKey/approval/:approvalId/:decision`,
        name: 'jsm-hubs-request-approval'
    },
    HUB_ARTICLES: {
        name: 'view-kb-article',
        path: `/article/:articleId`
    },
    HUB_KB_PAGE: {
        name: 'view-kb-page',
        path: `/kb/view/:pageId`
    },
    HUB_CROSS_SITE_ARTICLE: {
        name: 'view-kb-cross-site-article',
        path: `/cloudId/:cloudId/article/:articleId`
    },
    SURVEY: {
        name: 'survey',
        path: `/portal/:portalId/survey/:surveyId`
    },
    // Name matches the non-hub `viewAllSearchResultsRoute` so analytics / UFO
    // segments are unaffected when one registration swaps for the other.
    ALL_SEARCH_RESULTS: {
        name: 'view-all-search-results',
        path: `/articles/search`
    }
};
const $fb8af627abb88185$export$fb0ca8bce00435d4 = 'jsm_hub_customize_menu';

});

parcelRegister("3PAuB", function(module, exports) {
$parcel$export(module.exports, "HubConnectMenuSection", () => $0bf1a345502fe623$export$97faed7dd622e8ae);

var $bSJIT = parcelRequire("bSJIT");

var $53Khx = parcelRequire("53Khx");

var $eazQ4 = parcelRequire("eazQ4");

var $cjQhO = parcelRequire("cjQhO");

var $7LtMZ = parcelRequire("7LtMZ");

var $fY92D = parcelRequire("fY92D");
const $0bf1a345502fe623$var$ConnectMenuLinks = ({ customMenuLinks: customMenuLinks, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-test-id": "custom-menu-link"
    }, customMenuLinks.map((menuLink)=>{
        const menuLinkKey = menuLink.id || menuLink.key || menuLink.href;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Connect apps provide AP classes for dialog behaviour.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: `hub-custom-menu-link_${menuLinkKey}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cjQhO.default), {
            actionSubjectId: "custom-menu-link",
            component: (0, $53Khx.HtmlAnchor),
            href: menuLink.href,
            onClick: onClose,
            "data-test-id": "custom-menu-link",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: "cv-exclude-from-customisation"
        }, menuLink.label)));
    }));
const $0bf1a345502fe623$var$DeferredConnectMenuLinks = (0, $fY92D.withDeferredWrmLoaded)($0bf1a345502fe623$var$ConnectMenuLinks, (0, $eazQ4.initializeConnect));
const $0bf1a345502fe623$export$97faed7dd622e8ae = ({ customMenuLinks: customMenuLinks })=>{
    if (customMenuLinks.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($0bf1a345502fe623$var$DeferredConnectMenuLinks, {
        customMenuLinks: customMenuLinks,
        onClose: ()=>undefined
    }));
};

});

parcelRegister("47z2s", function(module, exports) {
$parcel$export(module.exports, "HubForgeMenuSection", () => $65bed5dcc4a06aff$export$da20fe93c1284982);

var $bSJIT = parcelRequire("bSJIT");

var $hiHQM = parcelRequire("hiHQM");

var $i7phc = parcelRequire("i7phc");

var $aWOG4 = parcelRequire("aWOG4");

var $kpgiw = parcelRequire("kpgiw");

var $7LtMZ = parcelRequire("7LtMZ");
const $65bed5dcc4a06aff$var$ForgeMenuSectionItems = ()=>{
    const { data: { extensionTitles: extensionTitles }, methods: { setExtensionToDisplay: setExtensionToDisplay } } = (0, $bSJIT.useContext)((0, $aWOG4.ForgeModalContext));
    if (extensionTitles.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), {
        hasSeparator: true
    }, extensionTitles.map(({ id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
            id: id,
            key: `hub-forge-title_${id}`,
            onClick: ()=>setExtensionToDisplay(id)
        }, title)));
};
const $65bed5dcc4a06aff$export$da20fe93c1284982 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($65bed5dcc4a06aff$var$ForgeMenuSectionItems, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hiHQM.ForgeActionModule), {
        type: (0, $i7phc.USER_MENU_ACTION_SECTION_MODULE),
        componentName: (0, $i7phc.USER_MENU_ACTION_COMPONENT)
    }));
};

});

parcelRegister("9p2aJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $472c2bd1a160e0d1$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $472c2bd1a160e0d1$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests item in hub avatar menu',
        id: 'hub.avatar.menu.requests'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'Approvals item in hub avatar menu',
        id: 'hub.avatar.menu.approvals'
    },
    customiseHub: {
        defaultMessage: 'Customise help center',
        description: 'Customise hub item in hub avatar menu',
        id: 'hub.avatar.menu.customise.hub'
    },
    hubSettings: {
        defaultMessage: 'Help center settings',
        description: 'Hub settings item in hub avatar menu',
        id: 'hub.avatar.menu.hub.settings'
    }
});

});



parcelRegister("5TwEA", function(module, exports) {
$parcel$export(module.exports, "RequestList", () => $447a53e862df1bf9$export$c58d16d73d0428fb);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $447a53e862df1bf9$export$c58d16d73d0428fb = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("cDlJb")).then((module)=>{
            const { registerRequestsListEpicsndReducers: registerRequestsListEpicsndReducers } = module;
            registerRequestsListEpicsndReducers();
            return module.default;
        }), {
        moduleId: "./src/view/request-list/hocs.tsx"
    })
});

});
parcelRegister("cDlJb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("l6zxK"),
    $kOunM("eZUH0")
]).then(()=>parcelRequire('6YOuv'));

});


parcelRegister("eoRfm", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfileForHubs", () => $6d108236ee498323$export$eca04c8a7924030c);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $6d108236ee498323$export$eca04c8a7924030c = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("2GNL7")), {
        moduleId: "./src/view/user-profile/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("2GNL7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cL5bQ"),
    $kOunM("llv7Q")
]).then(()=>parcelRequire('gDagv'));

});


parcelRegister("1i1vO", function(module, exports) {
$parcel$export(module.exports, "UserProfileForHubs", () => $06708ab6badb3d97$export$4c16441af2ce2701);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

const $06708ab6badb3d97$var$loader = (0, $2vYDF.lazyForPaint)(()=>{
    return (parcelRequire("fy7pF"));
}, {
    ssr: true,
    moduleId: "./src/view/user-profile/hub-variant/hub-variant.tsx"
});
const $06708ab6badb3d97$export$4c16441af2ce2701 = (0, $cVM5r.default)({
    loader: $06708ab6badb3d97$var$loader
});

});
parcelRegister("fy7pF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cL5bQ"),
    $kOunM("aNXbh")
]).then(()=>parcelRequire('6qP2F'));

});


parcelRegister("dXBk5", function(module, exports) {
$parcel$export(module.exports, "isHubMaxWidthAppearanceEnabled", () => $b6ce27880587b478$export$fadefac9afec766f);

var $gdUUy = parcelRequire("gdUUy");
const $b6ce27880587b478$export$fadefac9afec766f = ()=>(0, $gdUUy.fg)('hubs_jsm_max_width_appearance');

});

parcelRegister("h28No", function(module, exports) {
$parcel$export(module.exports, "HubExtensionsDependenciesProvider", () => $2fae36be315785c4$export$8084bb73ea6f042e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Help-center side of the Hub Forge/Connect renderer integration.
 *
 * The platform-level packages (`@atlassian/hub-forge-extension`,
 * `@atlassian/hub-connect-extension`) ship the ADF schema, manifests and
 * empty-state UI for the four new editor elements (Forge header / footer,
 * Connect header / footer). They intentionally do NOT depend on any Forge
 * or Connect SDK — the host product is expected to inject a concrete
 * renderer via the `HubForge|ConnectRendererProvider` context.
 *
 * This module is that injection point for the Help Hub / Customer Service
 * Hub. It mirrors how the legacy help-center Forge/Connect customisation
 * elements render today (see
 * `help-center/packages/help-center/customisation/elements/forge`
 * and `…/elements/connect`):
 *  - same `<ElementRoot>` wrapper (margin/padding tokens, flexibility flag)
 *  - same pointer-events shield while editing (gated by `mode === EDITOR`)
 *  - same `<ConnectFragment>` fan-out for `headerAndSubheaderPanels`
 *  - same `trackError` analytics on invalid `elementType`s
 *
 * "Is Connect installed on the tenant?" / "Is Forge installed?" are
 * decided server-side: the BE only emits a `HubForgeExtension` /
 * `HubConnectExtension` ADF node when the corresponding app is available
 * for the slot. At render time the legacy `<ForgeHeaderModule>` /
 * `<ConnectFragment>` primitives perform a second, finer-grained check
 * (their internal Relay queries return empty when there are no matching
 * Forge/Connect modules, in which case they render nothing — matching the
 * legacy element behaviour).
 *
 * Mounted through `HubAppProps.productExtensionsDependenciesProvider` so
 * platform extension renderers can resolve Help Center's concrete Forge / Connect
 * primitives from both published renderer and editor extension roots.
 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $87QgR = parcelRequire("87QgR");

var $dTM5i = parcelRequire("dTM5i");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $5AL27 = parcelRequire("5AL27");

var $djPMW = parcelRequire("djPMW");

var $gOQFS = parcelRequire("gOQFS");

var $5lhja = parcelRequire("5lhja");

var $jaAJZ = parcelRequire("jaAJZ");

var $k4a15 = parcelRequire("k4a15");

var $9sDkI = parcelRequire("9sDkI");

var $eazQ4 = parcelRequire("eazQ4");
var $kPxiY = parcelRequire("kPxiY");

var $lFpPv = parcelRequire("lFpPv");

var $81Vbr = parcelRequire("81Vbr");

var $7RZPz = parcelRequire("7RZPz");
parcelRequire("abU28");
var $47uWH = parcelRequire("47uWH");
var $busvu = parcelRequire("busvu");

var $hCHt7 = parcelRequire("hCHt7");

var $dlaM3 = parcelRequire("dlaM3");
parcelRequire("jKkFd");
var $dmhYw = parcelRequire("dmhYw");

var $4nock = parcelRequire("4nock");
parcelRequire("55StO");
var $6vKHQ = parcelRequire("6vKHQ");

var $i7phc = parcelRequire("i7phc");

var $gdUUy = parcelRequire("gdUUy");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
parcelRequire("84x3k");
var $ajeJ9 = parcelRequire("ajeJ9");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $jBiia = parcelRequire("jBiia");
// ---------------------------------------------------------------------------
// Forge bridge
// ---------------------------------------------------------------------------
// Surface-aware Forge page name; the CSM surface is guarded by forge-on-csm-hubs (else JSM Hub page).
const $2fae36be315785c4$var$getForgePage = ()=>(0, $gdUUy.fg)('forge-on-csm-hubs') && (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) ? (0, $i7phc.FORGE_CSM_HELP_CENTER) : (0, $i7phc.FORGE_HELP_CENTER);
const $2fae36be315785c4$var$USE_USER_LOCALE_FOR_FORGE = 'use_user_locale_for_forge';
const $2fae36be315785c4$var$isUseUserLocaleForForgeEnabled = ()=>(0, $87QgR.default).checkGate($2fae36be315785c4$var$USE_USER_LOCALE_FOR_FORGE);
const $2fae36be315785c4$var$forgeModuleProps = {
    noWrapper: true,
    allowCustomPadding: true,
    skipHelpCenterWrapper: true
};
const $2fae36be315785c4$export$96d94af5e9221f94 = (pathname)=>{
    const match = /\/portal\/(\d+)(?:\/|$)/.exec(pathname);
    if (!match) return undefined;
    const portalId = Number(match[1]);
    return Number.isSafeInteger(portalId) && portalId > 0 ? portalId : undefined;
};
/**
 * Resolves the portal's project id from the portal model in Redux, keyed on the
 * portal id parsed from the URL. `react-redux` here is v6 (no hooks), so this is
 * resolved through `connect`. Returns primitives so the mapped values are
 * referentially stable across re-renders.
 */ const $2fae36be315785c4$var$mapResourceFromState = (state)=>{
    var _globalThis$location;
    // CSM help centers have no "portal" concept, so the getPortalIdFromUrl path below does not apply;
    // use the hub's hoisted project id as the Forge resource context instead (gated by forge-on-csm-hubs).
    if ((0, $gdUUy.fg)('forge-on-csm-hubs') && (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType)) return {
        portalId: undefined,
        projectId: (0, $iW3CQ.getEnv)().hoistedProjectId,
        isPortalModelLoaded: false
    };
    const portalId = $2fae36be315785c4$export$96d94af5e9221f94(((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.pathname) ?? '');
    if (!portalId) return {
        portalId: undefined,
        projectId: undefined,
        isPortalModelLoaded: false
    };
    return {
        portalId: portalId,
        projectId: (0, $iWhHo.getProjectId)(state, portalId),
        // The portal record (success or error) is present once a fetch settled.
        isPortalModelLoaded: Boolean((0, $iWhHo.getPortalOrError)(state, portalId))
    };
};
const $2fae36be315785c4$var$mapDispatch = {
    fetchPortal: (0, $jeW3I.fetchPortalAction)
};
/**
 * Ensures the current portal model is fetched into Redux so `getProjectId` can
 * resolve the portal's project in both edit and view mode. Only fetches when a
 * portal page is detected and the model is not already loaded. Rendering never
 * waits on this fetch — the resource context is simply applied once the project
 * resolves.
 */ const $2fae36be315785c4$var$useEnsurePortalFetched = (portalId, isPortalModelLoaded, fetchPortal)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (portalId && !isPortalModelLoaded) fetchPortal({
            id: portalId
        });
    }, [
        portalId,
        isPortalModelLoaded,
        fetchPortal
    ]);
};
/**
 * Builds a referentially-stable resource context from the primitive project id,
 * so the fetch effect that depends on it does not re-run on every render.
 */ const $2fae36be315785c4$var$useProjectResourceContext = (projectId)=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>projectId ? {
            resourceId: projectId.toString(),
            resourceType: (0, $i7phc.RESOURCE_TYPE_PROJECT)
        } : undefined, [
        projectId
    ]);
/**
 * Whether the portal resource context has settled, i.e. it will not change from
 * "absent" to "present" on a later render:
 * - not a portal page (no `portalId`) -> nothing to resolve, and
 * - a portal page whose portal model is already in Redux.
 *
 * The empty-state probes wait for this so they issue a single, correctly-scoped
 * request instead of one without the resource context followed by one with it.
 */ const $2fae36be315785c4$var$isResourceContextSettled = (portalId, isPortalModelLoaded)=>!portalId || isPortalModelLoaded;
/**
 * Editor-only probe for the header + subheader modules: reports whether any
 * apps are installed so the editor can show a placeholder for an empty slot.
 *
 * This is deliberately not rendered in the published view, where the result is
 * unused and the requests would be wasted — the modules fetch what they need to
 * render themselves.
 */ const $2fae36be315785c4$var$ForgeHeaderEmptyStateProbe = ({ projectId: projectId })=>{
    const forgePage = $2fae36be315785c4$var$getForgePage();
    const resourceContext = $2fae36be315785c4$var$useProjectResourceContext(projectId);
    const { extensions: headerExtensions, resolved: headerResolved } = (0, $dmhYw.useTFExtensionList)({
        resourceContext: resourceContext,
        type: (0, $i7phc.PORTAL_HEADER_MODULE),
        page: forgePage
    });
    const { extensions: subheaderExtensions, resolved: subheaderResolved } = (0, $dmhYw.useTFExtensionList)({
        resourceContext: resourceContext,
        type: (0, $i7phc.PORTAL_SUBHEADER_MODULE),
        page: forgePage
    });
    // Wait for this probe to settle before mounting the modules. The modules
    // request the same extension types, and the cache only holds settled results,
    // so mounting them straight away would race this request and duplicate it.
    // Once this resolves their lookup hits the warm cache instead. Bounded:
    // `resolved` settles on both success and failure.
    if (!headerResolved || !subheaderResolved) return null;
    const isEmpty = ((headerExtensions === null || headerExtensions === void 0 ? void 0 : headerExtensions.length) ?? 0) === 0 && ((subheaderExtensions === null || subheaderExtensions === void 0 ? void 0 : subheaderExtensions.length) ?? 0) === 0;
    if (isEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k4a15.HubForgeEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dlaM3.ForgeHeaderModule), {
        ...$2fae36be315785c4$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
/**
 * Header slot: renders the Forge header + subheader modules. In the editor,
 * once the trusted-fetch resolves with no installed apps for either module,
 * it shows the empty-state placeholder instead so authors know the slot is
 * empty. In the published view the modules self-render nothing when empty.
 *
 * On a portal page nothing is mounted until the resource context has settled:
 * mounting the modules with an unresolved project would make them fetch without
 * the resource context and then fetch again once it resolved. The wait is
 * bounded — `isPortalModelLoaded` settles whether the portal request succeeds or
 * fails — and does not apply off portal pages.
 */ const $2fae36be315785c4$var$ForgeHeaderSlotInner = ({ isPageInEditMode: isPageInEditMode, portalId: portalId, projectId: projectId, isPortalModelLoaded: isPortalModelLoaded, fetchPortal: fetchPortal })=>{
    const forgePage = $2fae36be315785c4$var$getForgePage();
    $2fae36be315785c4$var$useEnsurePortalFetched(portalId, isPortalModelLoaded, fetchPortal);
    if (!$2fae36be315785c4$var$isResourceContextSettled(portalId, isPortalModelLoaded)) return null;
    if (isPageInEditMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ForgeHeaderEmptyStateProbe, {
        projectId: projectId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dlaM3.ForgeHeaderModule), {
        ...$2fae36be315785c4$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
const $2fae36be315785c4$var$ForgeHeaderSlot = (0, $f2mlD.default)($2fae36be315785c4$var$mapResourceFromState, $2fae36be315785c4$var$mapDispatch)($2fae36be315785c4$var$ForgeHeaderSlotInner);
/**
 * Editor-only probe for the footer module. See
 * {@link ForgeHeaderEmptyStateProbe}.
 */ const $2fae36be315785c4$var$ForgeFooterEmptyStateProbe = ({ projectId: projectId })=>{
    const forgePage = $2fae36be315785c4$var$getForgePage();
    const resourceContext = $2fae36be315785c4$var$useProjectResourceContext(projectId);
    const { extensions: extensions, resolved: resolved } = (0, $dmhYw.useTFExtensionList)({
        resourceContext: resourceContext,
        type: (0, $i7phc.PORTAL_FOOTER_MODULE),
        page: forgePage
    });
    // See ForgeHeaderEmptyStateProbe: wait for this request to settle so the
    // module's lookup for the same type hits the warm cache instead of racing it.
    if (!resolved) return null;
    if (((extensions === null || extensions === void 0 ? void 0 : extensions.length) ?? 0) === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k4a15.HubForgeEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hCHt7.ForgeFooterModule), {
        ...$2fae36be315785c4$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
/**
 * Footer slot: same behaviour as {@link ForgeHeaderSlot} for the single
 * footer module type.
 */ const $2fae36be315785c4$var$ForgeFooterSlotInner = ({ isPageInEditMode: isPageInEditMode, portalId: portalId, projectId: projectId, isPortalModelLoaded: isPortalModelLoaded, fetchPortal: fetchPortal })=>{
    const forgePage = $2fae36be315785c4$var$getForgePage();
    $2fae36be315785c4$var$useEnsurePortalFetched(portalId, isPortalModelLoaded, fetchPortal);
    if (!$2fae36be315785c4$var$isResourceContextSettled(portalId, isPortalModelLoaded)) return null;
    if (isPageInEditMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ForgeFooterEmptyStateProbe, {
        projectId: projectId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hCHt7.ForgeFooterModule), {
        ...$2fae36be315785c4$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
const $2fae36be315785c4$var$ForgeFooterSlot = (0, $f2mlD.default)($2fae36be315785c4$var$mapResourceFromState, $2fae36be315785c4$var$mapDispatch)($2fae36be315785c4$var$ForgeFooterSlotInner);
/**
 * Adapter from the platform-level Forge renderer signature to the legacy
 * help-center Forge header / footer modules.
 *
 * `'help_center'` is the canonical Forge page name (see
 * `JsmForgePageName`) used by the legacy `<ForgeElement />` for the same
 * header/footer slots. `noWrapper` + `allowCustomPadding` match the legacy
 * invocation so visual treatment is identical across legacy help-center
 * and the new hub editor.
 *
 * Returning `null` for unknown `elementType`s (rather than throwing) keeps
 * the editor render loop deterministic — the empty state owned by
 * `<HubForgeExtension />` is the user-visible fallback.
 */ const $2fae36be315785c4$var$ForgeBridge = ({ extensionNode: extensionNode, mode: mode })=>{
    var _extensionNode$parame;
    const elementType = (_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.elementType;
    const isPageInEditMode = mode === (0, $4nock.ExtensionMode).EDITOR;
    const isFullWidthLayout = extensionNode.layout === 'full-width';
    const elementWidth = $2fae36be315785c4$var$getElementWidth(extensionNode.layout);
    const isValid = elementType === (0, $jaAJZ.ForgeElementType).HEADER_AND_SUB_HEADER_PANELS || elementType === (0, $jaAJZ.ForgeElementType).FOOTER_PANELS;
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!isValid) (0, $jBiia.trackError)('hub.forge.element.type.invalid', {
            elementType: elementType
        }, 'Invalid Hub Forge Element Type received');
    }, [
        isValid,
        elementType
    ]);
    if (!isValid) return null;
    const inner = elementType === (0, $jaAJZ.ForgeElementType).HEADER_AND_SUB_HEADER_PANELS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ForgeHeaderSlot, {
        isPageInEditMode: isPageInEditMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ForgeFooterSlot, {
        isPageInEditMode: isPageInEditMode
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            isFullWidthLayout && "_1wpz1fhb _1bsb1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $47uWH.default), {
        removePadding: true,
        removeMargin: (0, $lFpPv.isIncreasedFlexibilityEnabled)(),
        elementWidth: elementWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-hub-extension-bridge-content": "forge",
        className: (0, $9fU1q.default)([
            "_1bsb1osq",
            isPageInEditMode && "_lcxvglyw"
        ])
    }, inner)));
};
const $2fae36be315785c4$var$renderHubForge = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ForgeBridge, props);
const $2fae36be315785c4$export$33429e4c460e2543 = (pathname)=>{
    const portalId = $2fae36be315785c4$export$96d94af5e9221f94(pathname);
    return portalId ? {
        portalId: portalId,
        page: (0, $kPxiY.PORTAL_HOME)
    } : {
        page: (0, $kPxiY.HELP_CENTER)
    };
};
/**
 * Connect panels are Redux-backed: `<ConnectFragment>` fetches them on mount
 * and the result lands in the store keyed by page + portal + location. The
 * selector returns `undefined` until the fetch settles, then an array
 * (possibly empty) or an error. We treat "all requested locations resolved to
 * an empty array" as "no Connect app for this slot" and render nothing. The
 * `<ConnectFragment>`s are still rendered so they keep ownership of fetching
 * and of rendering the real app when present.
 */ const $2fae36be315785c4$var$connectLocationsHaveApp = (state, locations, { page: page, portalId: portalId })=>{
    // Gate on the fetch lifecycle, not on the panel values. A successful fetch
    // that returns no apps stores `undefined`/`[]` for individual locations,
    // which is indistinguishable from "not fetched yet" if we only look at the
    // panel values — that bug kept the empty state hidden forever. Using the
    // page-level resolution signal lets the empty state appear once the fetch
    // settles, even when there are no Connect apps.
    if (!(0, $ajeJ9.isConnectFragmentsResolved)({
        state: state,
        portalId: portalId,
        pageName: page
    })) return undefined;
    // Resolved: report whether any requested location actually has a panel.
    return locations.some((location)=>{
        const panel = (0, $ajeJ9.getConnectAddonPanels)({
            state: state,
            location: location,
            portalId: portalId,
            pageName: page
        });
        return Array.isArray(panel) && panel.length > 0;
    });
};
/**
 * Adapter from the platform-level Connect renderer signature to the
 * legacy help-center `ConnectFragment` for the help-center page.
 *
 * For the header slot we render both `headerPanels` and `subheaderPanels`
 * to match the legacy `<ConnectElement />` behaviour — Connect apps that
 * registered against either location continue to render in the new hub
 * editor with zero migration work.
 */ const $2fae36be315785c4$var$ConnectBridge = ({ extensionNode: extensionNode, mode: mode })=>{
    var _extensionNode$parame2;
    const elementType = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.elementType;
    const isPageInEditMode = mode === (0, $4nock.ExtensionMode).EDITOR;
    const isFullWidthLayout = extensionNode.layout === 'full-width';
    const elementWidth = $2fae36be315785c4$var$getElementWidth(extensionNode.layout);
    const isValid = elementType === (0, $djPMW.ConnectElementType).HEADER_AND_SUB_HEADER_PANELS || elementType === (0, $djPMW.ConnectElementType).FOOTER_PANELS;
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!isValid) (0, $jBiia.trackError)('hub.connect.element.type.invalid', {
            elementType: elementType
        }, 'Invalid Hub Connect Element Type received');
    }, [
        isValid,
        elementType
    ]);
    if (!isValid) return null;
    const locations = elementType === (0, $djPMW.ConnectElementType).HEADER_AND_SUB_HEADER_PANELS ? [
        'headerPanels',
        'subheaderPanels'
    ] : [
        'footerPanels'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ConnectSlot, {
        isPageInEditMode: isPageInEditMode,
        locations: [
            ...locations
        ],
        elementWidth: elementWidth,
        isFullWidthLayout: isFullWidthLayout
    });
};
const $2fae36be315785c4$var$ConnectPublishedSlotInner = ({ locations: locations, hasApp: hasApp, page: page, portalId: portalId, elementWidth: elementWidth, isFullWidthLayout: isFullWidthLayout })=>{
    if (hasApp === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            isFullWidthLayout && "_1wpz1fhb _1bsb1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $47uWH.default), {
        removePadding: true,
        removeMargin: (0, $lFpPv.isIncreasedFlexibilityEnabled)(),
        elementWidth: elementWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-hub-extension-bridge-content": "connect",
        className: (0, $9fU1q.default)([
            "_1bsb1osq"
        ])
    }, locations.map((location)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eazQ4.ConnectFragment), {
            key: location,
            page: page,
            portalId: portalId,
            location: location
        })))));
};
const $2fae36be315785c4$var$ConnectPublishedSlot = (0, $f2mlD.default)((state, ownProps)=>{
    var _globalThis$location2;
    const pageContext = $2fae36be315785c4$export$33429e4c460e2543(((_globalThis$location2 = globalThis.location) === null || _globalThis$location2 === void 0 ? void 0 : _globalThis$location2.pathname) ?? '');
    return {
        // Primitives only, so `connect` keeps the mapped props stable.
        page: pageContext.page,
        portalId: pageContext.portalId,
        hasApp: $2fae36be315785c4$var$connectLocationsHaveApp(state, ownProps.locations, pageContext)
    };
})($2fae36be315785c4$var$ConnectPublishedSlotInner);
const $2fae36be315785c4$var$ConnectEditorSlot = ({ elementWidth: elementWidth, isFullWidthLayout: isFullWidthLayout })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            isFullWidthLayout && "_1wpz1fhb _1bsb1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $47uWH.default), {
        removePadding: true,
        removeMargin: (0, $lFpPv.isIncreasedFlexibilityEnabled)(),
        elementWidth: elementWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-hub-extension-bridge-content": "connect",
        className: (0, $9fU1q.default)([
            "_1bsb1osq",
            "_lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gOQFS.HubConnectEmptyState), null))));
const $2fae36be315785c4$var$ConnectSlot = ({ isPageInEditMode: isPageInEditMode, locations: locations, elementWidth: elementWidth, isFullWidthLayout: isFullWidthLayout })=>isPageInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ConnectEditorSlot, {
        elementWidth: elementWidth,
        isFullWidthLayout: isFullWidthLayout
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ConnectPublishedSlot, {
        isPageInEditMode: false,
        locations: locations,
        elementWidth: elementWidth,
        isFullWidthLayout: isFullWidthLayout
    });
const $2fae36be315785c4$var$renderHubConnect = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$ConnectBridge, props);
/**
 * Single mount point that injects both Hub Forge and Hub Connect renderers.
 * Order of providers is irrelevant — they are independent contexts.
 */ const $2fae36be315785c4$var$HubExtensionsBridge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5lhja.HubForgeRendererProvider), {
        renderer: $2fae36be315785c4$var$renderHubForge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5AL27.HubConnectRendererProvider), {
        renderer: $2fae36be315785c4$var$renderHubConnect
    }, children));
const $2fae36be315785c4$export$8084bb73ea6f042e = ({ children: children, extensionNode: extensionNode, mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        locale: $2fae36be315785c4$var$isUseUserLocaleForForgeEnabled() ? (0, $81Vbr.getLanguageFromLocale)((0, $fBLyB.getLocale)((0, $7RZPz.store).getState())) : 'en'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9sDkI.CommonHubExtensionsDependenciesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6vKHQ.HubPremiumSlaElementsProvider), {
        extensionKey: extensionNode === null || extensionNode === void 0 ? void 0 : extensionNode.extensionKey,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2fae36be315785c4$var$HubExtensionsBridge, null, children))));
// ---------------------------------------------------------------------------
// Styles (declared at the bottom of the file per styled-component-order)
// ---------------------------------------------------------------------------
const $2fae36be315785c4$var$getElementWidth = (layout)=>layout === 'full-width' ? (0, $busvu.ElementWidth).FULL_WIDTH : undefined;
const $2fae36be315785c4$var$fullWidthRootCss = null;
const $2fae36be315785c4$var$fullWidthCss = null;
const $2fae36be315785c4$var$editModeCss = null;

});
parcelRegister("5AL27", function(module, exports) {
$parcel$export(module.exports, "HubConnectRendererProvider", () => $fd1a32edd905dcd7$export$ca4738bfb172ba62);
$parcel$export(module.exports, "useHubConnectRenderer", () => $fd1a32edd905dcd7$export$7b1d86b9d48f9fd9);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $fd1a32edd905dcd7$var$HubConnectRendererContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $fd1a32edd905dcd7$export$ca4738bfb172ba62 = ({ children: children, renderer: renderer })=>/*#__PURE__*/ (0, $dc70d.jsx)($fd1a32edd905dcd7$var$HubConnectRendererContext.Provider, {
        value: renderer,
        children: children
    });
const $fd1a32edd905dcd7$export$7b1d86b9d48f9fd9 = ()=>(0, $bSJIT.useContext)($fd1a32edd905dcd7$var$HubConnectRendererContext);

});

parcelRegister("gOQFS", function(module, exports) {
$parcel$export(module.exports, "HubConnectEmptyState", () => $276a7ff1bdf149c3$export$a04622704b47a193);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jeWmB = parcelRequire("jeWmB");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $8k3Sw = parcelRequire("8k3Sw");
const $276a7ff1bdf149c3$var$styles = {
    iconBadge: "_2rko1rr0 _4cvr1h6o _bfhki8nm _1e0c1txw _4t3izwfg _1bah1h6o _1bsbzwfg"
};
const $276a7ff1bdf149c3$export$a04622704b47a193 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        paddingBlock: "space.500",
        paddingInline: "space.300",
        testId: "hub-connect-extension.empty-state",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
            space: "space.150",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    xcss: $276a7ff1bdf149c3$var$styles.iconBadge,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jeWmB))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "strong",
                    weight: "bold",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                        ...(0, $8k3Sw.messages).emptyStateTitle
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    color: "color.text.subtle",
                    align: "center",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                        ...(0, $8k3Sw.messages).emptyStateDescription
                    })
                })
            ]
        })
    });

});
parcelRegister("jeWmB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d92d6da68cdb4ac3639231927c6c671>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e01c98e8df0ba79a$var$_react = $e01c98e8df0ba79a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e01c98e8df0ba79a$var$_iconNew = $e01c98e8df0ba79a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e01c98e8df0ba79a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app
 * Usage guidance:
 * Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e01c98e8df0ba79a$var$AppIcon = (props)=>/*#__PURE__*/ $e01c98e8df0ba79a$var$_react.default.createElement($e01c98e8df0ba79a$var$_iconNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$e01c98e8df0ba79a$var$AppIcon.displayName = 'AppIcon';
var $e01c98e8df0ba79a$var$_default = module.exports.default = $e01c98e8df0ba79a$var$AppIcon;

});

parcelRegister("8k3Sw", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0d5f5e10dfc285b6$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $0d5f5e10dfc285b6$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    emptyStateTitle: {
        id: 'hub-connect-extension.hub-connect-empty-state.emptyStateTitle',
        defaultMessage: 'No connect app available',
        description: 'Empty state title shown inside the Hub Connect extension node when no installed Connect app module is available for the slot.'
    },
    emptyStateDescription: {
        id: 'hub-connect-extension.hub-connect-empty-state.emptyStateDescription',
        defaultMessage: 'You haven\u2019t installed a custom app in this section yet.',
        description: 'Empty state description shown inside the Hub Connect extension node when no installed Connect app module is available for the slot.'
    }
});

});


parcelRegister("5lhja", function(module, exports) {
$parcel$export(module.exports, "HubForgeRendererProvider", () => $fbfd867f11eb838b$export$253e913813c9fa14);
$parcel$export(module.exports, "useHubForgeRenderer", () => $fbfd867f11eb838b$export$e9aaa46bc7719f1e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $fbfd867f11eb838b$var$HubForgeRendererContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $fbfd867f11eb838b$export$253e913813c9fa14 = ({ children: children, renderer: renderer })=>/*#__PURE__*/ (0, $dc70d.jsx)($fbfd867f11eb838b$var$HubForgeRendererContext.Provider, {
        value: renderer,
        children: children
    });
const $fbfd867f11eb838b$export$e9aaa46bc7719f1e = ()=>(0, $bSJIT.useContext)($fbfd867f11eb838b$var$HubForgeRendererContext);

});

parcelRegister("k4a15", function(module, exports) {
$parcel$export(module.exports, "HubForgeEmptyState", () => $08002e91e6e24037$export$2f9e41329f23dd0b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jeWmB = parcelRequire("jeWmB");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $9wRFa = parcelRequire("9wRFa");
const $08002e91e6e24037$var$styles = {
    iconBadge: "_2rkol0p1 _4cvr1h6o _bfhki8nm _1e0c1txw _4t3izwfg _1bah1h6o _1bsbzwfg"
};
const $08002e91e6e24037$export$2f9e41329f23dd0b = ({ description: description = (0, $9wRFa.messages).emptyStateDescription, title: title = (0, $9wRFa.messages).emptyStateTitle })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        paddingBlock: "space.500",
        paddingInline: "space.300",
        testId: "hub-forge-extension.empty-state",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
            space: "space.150",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    xcss: $08002e91e6e24037$var$styles.iconBadge,
                    testId: "hub-forge-extension.empty-state.icon-tile",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jeWmB))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "strong",
                    weight: "bold",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                        ...title
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    color: "color.text.subtle",
                    align: "center",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                        ...description
                    })
                })
            ]
        })
    });

});
parcelRegister("9wRFa", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6bb767e9efc105e2$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $6bb767e9efc105e2$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    emptyStateTitle: {
        id: 'hub-forge-extension.hub-forge-empty-state.emptyStateTitle',
        defaultMessage: 'No app available',
        description: 'Empty state title shown inside the Hub Forge extension node when no installed Forge app is available for the slot.'
    },
    emptyStateDescription: {
        id: 'hub-forge-extension.hub-forge-empty-state.emptyStateDescription',
        defaultMessage: 'You haven\u2019t installed a custom app yet.',
        description: 'Empty state description shown inside the Hub Forge extension node when no installed Forge app is available for the slot.'
    },
    invalidParametersTitle: {
        id: 'hub-forge-extension.hub-forge-empty-state.invalidParametersTitle',
        defaultMessage: "Forge app couldn\u2019t load",
        description: 'Empty state title shown inside the Hub Forge extension node in edit mode when the saved extension parameters cannot be read.'
    },
    invalidParametersDescription: {
        id: 'hub-forge-extension.hub-forge-empty-state.invalidParametersDescription',
        defaultMessage: 'Remove this app and add it again.',
        description: 'Empty state description shown inside the Hub Forge extension node in edit mode when the saved extension parameters cannot be read.'
    }
});

});


parcelRegister("abU28", function(module, exports) {
$parcel$export(module.exports, "ElementRoot", () => (parcelRequire("47uWH")).default);
$parcel$export(module.exports, "ElementWidth", () => (parcelRequire("busvu")).ElementWidth);

var $47uWH = parcelRequire("47uWH");

var $busvu = parcelRequire("busvu");

});
parcelRegister("47uWH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d09ad8e98511d551$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");
parcelRequire("38uh5");
var $8vt1A = parcelRequire("8vt1A");

var $busvu = parcelRequire("busvu");
const $d09ad8e98511d551$var$selector = (0, $BOq7h.createSelector)((0, $8vt1A.isCustomizing), (0, $hvIQS.getHelpCenterTopBarSplitFlag), (customizing, hasTopBarBeenSplit)=>({
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        isCustomizing: customizing
    }));
var $d09ad8e98511d551$export$2e2bcd8739ae039 = (0, $f2mlD.default)($d09ad8e98511d551$var$selector, {})((0, $busvu.ElementRoot));

});
parcelRegister("busvu", function(module, exports) {
$parcel$export(module.exports, "ElementWidth", () => $6be494c86f58c32e$export$8cb772970d402972);
$parcel$export(module.exports, "ElementMargins", () => $6be494c86f58c32e$export$59f0813ca361e932);
$parcel$export(module.exports, "ElementRoot", () => $6be494c86f58c32e$export$a627c7223f17f950);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");
parcelRequire("c3QJe");
var $6f79M = parcelRequire("6f79M");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");
var $6be494c86f58c32e$export$8cb772970d402972 = /*#__PURE__*/ function(ElementWidth) {
    ElementWidth["FULL_WIDTH"] = "full-width";
    ElementWidth["COMPACT"] = "compact";
    return ElementWidth;
}({});
var $6be494c86f58c32e$export$59f0813ca361e932 = /*#__PURE__*/ function(ElementMargins) {
    ElementMargins["STANDARD"] = "standard";
    ElementMargins["COMPACT"] = "compact";
    return ElementMargins;
}({});
const $6be494c86f58c32e$export$a627c7223f17f950 = ({ elementRef: elementRef, children: children, isCustomizing: isCustomizing, elementWidth: elementWidth, elementMargins: elementMargins, removePadding: removePadding, removeMargin: // deprecated after enabling flag isIncreasedFlexibilityEnabled
removeMargin, customStyles: // for use-case of forge where we give margin internally
customStyles, hasTopBarBeenSplit: hasTopBarBeenSplit })=>{
    const [isPageInEditMode] = (0, $6f79M.useIsPageInEditMode)();
    const [isPageInPreviewMode] = (0, $6f79M.useIsPageInPreviewMode)();
    const isIncreasedFlexibilityEnabledWithTopBarSplit = (0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit;
    const rootXCSS = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        const xcssStyle = [
            isIncreasedFlexibilityEnabledWithTopBarSplit ? $6be494c86f58c32e$var$rootStyleIncreasedFlexibility : $6be494c86f58c32e$var$rootStyle
        ];
        if (elementWidth === "compact") {
            if (isCustomizing) xcssStyle.push($6be494c86f58c32e$var$rootStyleWithSidebarOpened);
            else xcssStyle.push($6be494c86f58c32e$var$rootStyleWithSidebarClosed);
        } else if (isIncreasedFlexibilityEnabledWithTopBarSplit && elementWidth === "full-width") xcssStyle.push($6be494c86f58c32e$var$rootStyleFullWith);
        if (!removePadding && !isIncreasedFlexibilityEnabledWithTopBarSplit) xcssStyle.push($6be494c86f58c32e$var$rootPaddingStyle);
        if (isIncreasedFlexibilityEnabledWithTopBarSplit && !removeMargin) {
            if (!isPageInEditMode || isPageInPreviewMode) {
                // only don't apply while page edit
                if (elementMargins === "compact") xcssStyle.push($6be494c86f58c32e$export$6f424e557a8c03e);
                else xcssStyle.push($6be494c86f58c32e$export$31724e6a9731e3b6);
            }
        }
        if (customStyles) return [
            ...xcssStyle,
            ...customStyles
        ];
        return xcssStyle;
    }, [
        isIncreasedFlexibilityEnabledWithTopBarSplit,
        elementWidth,
        removePadding,
        removeMargin,
        customStyles,
        isCustomizing,
        isPageInEditMode,
        isPageInPreviewMode,
        elementMargins
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        ref: elementRef,
        testId: 'element-root',
        xcss: rootXCSS
    }, children);
};
const $6be494c86f58c32e$var$rootStyle = (0, $9BVpB.xcss)({
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center'
});
const $6be494c86f58c32e$var$rootStyleIncreasedFlexibility = (0, $9BVpB.xcss)({
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center',
    // do not add margin and padding is there is no children
    ':empty': {
        display: 'none'
    }
});
const $6be494c86f58c32e$var$rootStyleFullWith = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    width: 'auto'
});
const $6be494c86f58c32e$var$rootPaddingStyle = (0, $9BVpB.xcss)({
    paddingTop: 'space.300',
    paddingBottom: 'space.300'
});
const $6be494c86f58c32e$export$6f424e557a8c03e = (0, $9BVpB.xcss)({
    marginLeft: 'space.200',
    marginRight: 'space.200',
    marginTop: 'space.200',
    marginBottom: 'space.200',
    [(0, $4pBHw.media).above.xs]: {
        marginLeft: 'space.400',
        marginRight: 'space.400'
    }
});
const $6be494c86f58c32e$export$31724e6a9731e3b6 = (0, $9BVpB.xcss)({
    marginLeft: 'space.400',
    marginRight: 'space.400',
    marginTop: 'space.400',
    marginBottom: 'space.400'
});
const $6be494c86f58c32e$var$rootStyleWithSidebarOpened = (0, $9BVpB.xcss)({
    maxWidth: '336px',
    // 42 * 8
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 80rem)': {
        // ((110 + SIDEBAR_WIDTH_LARGE_MULTIPLIER) * 8) / 16;
        maxWidth: '720px' // 90 * 8
    },
    '@media (min-width: 102rem)': {
        // ((155 + SIDEBAR_WIDTH_LARGE_MULTIPLIER) * 8) / 16;
        maxWidth: '1160px' // 145 * 8
    }
});
const $6be494c86f58c32e$var$rootStyleWithSidebarClosed = (0, $9BVpB.xcss)({
    maxWidth: '336px',
    // 42 * 8
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 60rem)': {
        maxWidth: '720px' // 90 * 8
    },
    '@media (min-width: 80rem)': {
        maxWidth: '1160px' // 145 * 8
    }
});

});



parcelRegister("jKkFd", function(module, exports) {
$parcel$export(module.exports, "useTFExtensionList", () => (parcelRequire("dmhYw")).useTFExtensionList);

var $dmhYw = parcelRequire("dmhYw");

});
parcelRegister("dmhYw", function(module, exports) {
$parcel$export(module.exports, "useTFExtensionList", () => $9938b304b8d3eb0a$export$a10e5b463a47e957);

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");

var $i7phc = parcelRequire("i7phc");

var $fuVmc = parcelRequire("fuVmc");

var $6WltM = parcelRequire("6WltM");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");
parcelRequire("bWLBr");
var $9ah7S = parcelRequire("9ah7S");
const $9938b304b8d3eb0a$export$a10e5b463a47e957 = ({ type: type, resourceContext: resourceContext, page: page })=>{
    const [extensions, setExtensions] = $bSJIT.useState([]);
    // Tracks whether the availability fetch has settled (success or failure).
    // Consumers use this to distinguish "no apps installed" from "still
    // loading" — e.g. to decide when to show an editor empty state — without
    // relying on fragile reference-identity heuristics.
    const [resolved, setResolved] = $bSJIT.useState(false);
    const accountType = (0, $fuVmc.getMetaFromHTML)('ajs-account-type') || (0, $gYq50.AtlassianHelpConfigAccountType).ANONYMOUS;
    const { getExtensionsByType: getExtensionsByType, getExtensionsByTypeV2: getExtensionsByTypeV2 } = $bSJIT.useContext((0, $9ah7S.TFECacheContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    $bSJIT.useEffect(()=>{
        if (accountType === (0, $gYq50.AtlassianHelpConfigAccountType).ATLASSIAN || accountType === (0, $gYq50.AtlassianHelpConfigAccountType).ANONYMOUS || accountType === (0, $gYq50.AtlassianHelpConfigAccountType).CUSTOMER) {
            const { resourceType: resourceType } = resourceContext || {};
            if (resourceType === (0, $i7phc.RESOURCE_TYPE_ISSUE) || resourceType === (0, $i7phc.RESOURCE_TYPE_PROJECT)) getExtensionsByTypeV2(type, resourceContext, page).then((fetchedExtensions)=>{
                setExtensions(fetchedExtensions[type] || []);
            }).catch((e)=>{
                (0, $jBiia.trackError)('forge-tfe.setState.failed', {}, e);
            }).finally(()=>{
                setResolved(true);
            });
            else getExtensionsByType(type, page).then((fetchedExtensions)=>{
                setExtensions(fetchedExtensions[type] || []);
            }).catch((e)=>{
                (0, $jBiia.trackError)('forge-tfe.setState.failed', {}, e);
            }).finally(()=>{
                setResolved(true);
            });
        } else // Account type that never fetches: treat as immediately resolved so
        // consumers do not wait forever for a request that will not happen.
        setResolved(true);
    }, [
        accountType,
        getExtensionsByType,
        getExtensionsByTypeV2,
        type,
        resourceContext,
        page,
        createAnalyticsEvent
    ]);
    $bSJIT.useEffect(()=>{
        extensions.forEach((extension)=>{
            const { id: id, dataClassificationPolicyDecision: dataClassificationPolicyDecision } = extension;
            const event = createAnalyticsEvent({
                actionSubject: 'forgeTFE',
                action: 'fetched',
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                attributes: {
                    page: page,
                    moduleType: type,
                    status: dataClassificationPolicyDecision === null || dataClassificationPolicyDecision === void 0 ? void 0 : dataClassificationPolicyDecision.status,
                    extensionId: id
                }
            });
            event.context.push({
                componentName: 'forgeTFE'
            });
            event.fire();
        });
    }, [
        extensions,
        page,
        createAnalyticsEvent,
        type
    ]);
    return {
        extensions: extensions,
        resolved: resolved
    };
};

});



parcelRegister("3Iju2", function(module, exports) {
$parcel$export(module.exports, "withStaticHubBreadcrumbs", () => (parcelRequire("2ERHo")).withStaticHubBreadcrumbs);

var $2ERHo = parcelRequire("2ERHo");

});
parcelRegister("2ERHo", function(module, exports) {
$parcel$export(module.exports, "withStaticHubBreadcrumbs", () => $b08cb55d8cea9a6a$export$99bacf9a450014fe);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $fGcJm = parcelRequire("fGcJm");
parcelRequire("4lMsl");
var $3uKan = parcelRequire("3uKan");

var $9IvZK = parcelRequire("9IvZK");
const $b08cb55d8cea9a6a$export$ac4ac0508ba0d049 = {
    [(0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.name]: {
        id: 'requests',
        message: (0, $9IvZK.staticHubBreadcrumbMessages).requests,
        path: (0, $fGcJm.HUB_ROUTES).JSM_REQUESTS_LIST.path
    },
    [(0, $fGcJm.HUB_ROUTES).JSM_APPROVALS.name]: {
        id: 'approvals',
        message: (0, $9IvZK.staticHubBreadcrumbMessages).approvals,
        path: (0, $fGcJm.HUB_ROUTES).JSM_APPROVALS.path
    },
    [(0, $fGcJm.HUB_ROUTES).USER_PROFILE.name]: {
        id: 'profile',
        message: (0, $9IvZK.staticHubBreadcrumbMessages).profile,
        path: (0, $fGcJm.HUB_ROUTES).USER_PROFILE.path
    }
};
const $b08cb55d8cea9a6a$export$c2c425f5600ea5f7 = (routeName)=>$b08cb55d8cea9a6a$export$ac4ac0508ba0d049[routeName];
const $b08cb55d8cea9a6a$export$799d9c081c82ef5b = ({ children: children, routeName: routeName })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const route = $b08cb55d8cea9a6a$export$c2c425f5600ea5f7(routeName);
    (0, $3uKan.useHubBreadcrumbs)({
        currentItem: route ? {
            href: route.path,
            id: route.id,
            text: formatMessage(route.message)
        } : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
};
const $b08cb55d8cea9a6a$export$99bacf9a450014fe = (Component, routeName)=>{
    const ComponentWithStaticHubBreadcrumbs = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($b08cb55d8cea9a6a$export$799d9c081c82ef5b, {
            routeName: routeName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props));
    ComponentWithStaticHubBreadcrumbs.displayName = `withStaticHubBreadcrumbs(${Component.displayName ?? Component.name ?? 'Component'})`;
    return ComponentWithStaticHubBreadcrumbs;
};

});
parcelRegister("4lMsl", function(module, exports) {
$parcel$export(module.exports, "useAreHubBreadcrumbsEnabled", () => (parcelRequire("3uKan")).useAreHubBreadcrumbsEnabled);
$parcel$export(module.exports, "useHubBreadcrumbs", () => (parcelRequire("3uKan")).useHubBreadcrumbs);

var $3uKan = parcelRequire("3uKan");

});
parcelRegister("3uKan", function(module, exports) {
$parcel$export(module.exports, "useAreHubBreadcrumbsEnabled", () => $14604352a4ee75e0$export$7fee7fea09c78a48);
$parcel$export(module.exports, "useHubBreadcrumbs", () => $14604352a4ee75e0$export$bfef814becf816f1);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g7xik = parcelRequire("g7xik");

var $dez4z = parcelRequire("dez4z");

var $9IvZK = parcelRequire("9IvZK");
const $14604352a4ee75e0$export$a9cfa7bd6905691a = ({ currentItem: currentItem, homeText: homeText, ancestorItems: ancestorItems = [] })=>{
    if (!currentItem) return [];
    const normalizedHierarchy = [
        ...ancestorItems,
        currentItem
    ].map((item)=>{
        var _item$text;
        return {
            ...item,
            text: (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.trim()
        };
    });
    if (normalizedHierarchy.some((item)=>!item.text)) return [];
    return [
        {
            href: '/',
            id: 'home',
            text: homeText
        },
        ...normalizedHierarchy.map((item)=>({
                href: item.href,
                id: item.id,
                text: item.text ?? ''
            }))
    ];
};
const $14604352a4ee75e0$export$7fee7fea09c78a48 = ()=>{
    const [isBreadcrumbsEnabled] = (0, $dez4z.useIsHubFeatureEnabled)([
        (0, $dez4z.HUB_FEATURES).BREADCRUMBS
    ]);
    return isBreadcrumbsEnabled;
};
const $14604352a4ee75e0$export$bfef814becf816f1 = ({ ancestorItems: ancestorItems, currentItem: currentItem })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isBreadcrumbsEnabled = $14604352a4ee75e0$export$7fee7fea09c78a48();
    const items = (0, $bSJIT.useMemo)(()=>{
        if (!isBreadcrumbsEnabled) return [];
        return $14604352a4ee75e0$export$a9cfa7bd6905691a({
            ancestorItems: ancestorItems,
            currentItem: currentItem,
            homeText: formatMessage((0, $9IvZK.staticHubBreadcrumbMessages).home)
        });
    }, [
        ancestorItems,
        currentItem,
        formatMessage,
        isBreadcrumbsEnabled
    ]);
    (0, $g7xik.useRegisterHubBreadcrumbs)(items);
};

});
parcelRegister("9IvZK", function(module, exports) {
$parcel$export(module.exports, "staticHubBreadcrumbMessages", () => $96aa3c58aefda7d8$export$cc98b88bd82a9896);

var $jnlBC = parcelRequire("jnlBC");

var $1xpJt = parcelRequire("1xpJt");

var $jy85c = parcelRequire("jy85c");

var $gwIMi = parcelRequire("gwIMi");
const $96aa3c58aefda7d8$export$cc98b88bd82a9896 = {
    home: (0, $1xpJt.default).breadcrumbsHome,
    requests: (0, $jy85c.default).title,
    approvals: (0, $jnlBC.default).title,
    profile: (0, $gwIMi.default).title
};

});
parcelRegister("jnlBC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fe027e873e7be38$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $4fe027e873e7be38$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    documentTitle: {
        defaultMessage: 'Approvals',
        description: 'title of the approval list page',
        id: 'cv.approval.list.document.title'
    },
    title: {
        defaultMessage: 'Approvals',
        description: 'headline of the approval list page',
        id: 'cv.approval.list.title'
    }
});

});

parcelRegister("jy85c", function(module, exports) {
$parcel$export(module.exports, "default", () => $949f202f82590641$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $949f202f82590641$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    documentTitle: {
        defaultMessage: 'Requests',
        description: 'title of the request list page',
        id: 'cv.request.list.document.title'
    },
    title: {
        defaultMessage: 'Requests',
        description: 'headline of the request list page',
        id: 'cv.request.list.title'
    }
});

});

parcelRegister("gwIMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d53d79afce8c120f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $d53d79afce8c120f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    title: {
        defaultMessage: 'Profile',
        description: 'headline of the customer portal profile page',
        id: 'cv.user.profile.title'
    }
});

});






parcelRegister("3iWRa", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5kbE2").then(()=>parcelRequire('l693P'));

});



parcelRegister("4WbWW", function(module, exports) {
$parcel$export(module.exports, "routeWithAiWidgetConfigResource", () => $e2d169aa2cf88b80$export$66e676d5e26b883e);

var $6viDb = parcelRequire("6viDb");
const $e2d169aa2cf88b80$export$66e676d5e26b883e = (route)=>{
    return {
        ...route,
        resources: [
            ...route.resources ?? [],
            (0, $6viDb.csmSupportWidgetConfigQueryResource)
        ]
    };
};

});
parcelRegister("6viDb", function(module, exports) {
$parcel$export(module.exports, "csmSupportWidgetConfigQueryResource", () => $c5404469a60b9457$export$157d87119e3de36e);

var $fuVmc = parcelRequire("fuVmc");

var $3LQyI = parcelRequire("3LQyI");

var $bGVpb = parcelRequire("bGVpb");
const $c5404469a60b9457$export$157d87119e3de36e = (0, $3LQyI.createRelayResource)({
    type: 'CSM_SUPPORT_WIDGET_CONFIG_QUERY',
    getQuery: ()=>({
            parameters: (0, $bGVpb.default),
            variables: {
                helpCenterAri: (0, $fuVmc.getMeta)('help-center-ari') ?? '',
                cloudId: (0, $fuVmc.getMeta)('tenant-id') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("bGVpb", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd9c33aacb8fe578$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e731c73daa3a4aec33ba4801f79f5543>>
 * @relayHash 35cdd10bfcb6c0124f988dd9e3d183e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa
const $cd9c33aacb8fe578$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa",
            "metadata": {},
            "name": "supportWidgetConfigProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cd9c33aacb8fe578$var$node.hash = "7afba16f32baf97fd3ce09f41645b442";
var $cd9c33aacb8fe578$export$2e2bcd8739ae039 = $cd9c33aacb8fe578$var$node;

});



parcelRegister("9Iriq", function(module, exports) {
$parcel$export(module.exports, "default", () => $22b6b2fae8951fbc$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $9cDCX = parcelRequire("9cDCX");

var $f9uTr = parcelRequire("f9uTr");

parcelRequire("5lPCP");
var $7t0F6 = parcelRequire("7t0F6");
var $2a9Vu = parcelRequire("2a9Vu");

var $eLLBi = parcelRequire("eLLBi");

var $jNbk7 = parcelRequire("jNbk7");

var $5Or3j = parcelRequire("5Or3j");

var $8D35l = parcelRequire("8D35l");

var $9uWyX = parcelRequire("9uWyX");

var $5Yb8O = parcelRequire("5Yb8O");

var $8b9fA = parcelRequire("8b9fA");

var $XiIOl = parcelRequire("XiIOl");

var $ebTuA = parcelRequire("ebTuA");

var $4T2Ew = parcelRequire("4T2Ew");

var $QUECd = parcelRequire("QUECd");

var $hFRc4 = parcelRequire("hFRc4");

var $ajLNc = parcelRequire("ajLNc");

var $2Wfvm = parcelRequire("2Wfvm");

var $Iy9X2 = parcelRequire("Iy9X2");

var $73vn3 = parcelRequire("73vn3");

var $ab40o = parcelRequire("ab40o");

var $3V7zc = parcelRequire("3V7zc");

var $2ylQX = parcelRequire("2ylQX");

var $bcBh3 = parcelRequire("bcBh3");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $8VdVQ = parcelRequire("8VdVQ");

var $87QgR = parcelRequire("87QgR");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $eDcdn = parcelRequire("eDcdn");

var $fHAr3 = parcelRequire("fHAr3");
parcelRequire("dgMoN");
var $hWMM6 = parcelRequire("hWMM6");
var $36cmj = parcelRequire("36cmj");
const $22b6b2fae8951fbc$export$2f7745f2f5ab3897 = ()=>{
    return [
        ...(0, $hCnLH.isAdvancedHelpCenter)() || (0, $hCnLH.isFlexiHCEnabledInDefaultHC)() ? [
            (0, $eLLBi.getViewHomePageRoute)(),
            (0, $eLLBi.getEditHomePageRoute)()
        ] : [],
        ...(0, $lFpPv.isEmailVerifiedSignalEnabled)() ? [
            (0, $bcBh3.userVerifyEmailRoute)
        ] : [],
        (0, $9uWyX.viewPortalConversationPageRoute),
        (0, $jNbk7.aiAnswerRoute),
        (0, $8D35l.consentFormRoute),
        (0, $QUECd.loginRoute),
        (0, $ab40o.userResetPasswordRoute),
        (0, $ab40o.userSignupRoute),
        (0, $ab40o.userCompleteSignupRoute),
        (0, $ab40o.userCheckMailRoute),
        (0, $hFRc4.portalAccessForbiddenRoute),
        (0, $QUECd.portalLoginRoute),
        (0, $ab40o.portalSignupRoute),
        (0, $ab40o.portalResetPasswordRoute),
        (0, $ab40o.portalCompleteSignupRoute),
        (0, $ab40o.portalInvitedSignupRoute),
        (0, $hWMM6.requestFeedbackRoute),
        (0, $hWMM6.unsubscribeRoute),
        (0, $ebTuA.getHelpCenterRoute)(),
        (0, $eLLBi.getEditHomePageRoute)('edit-homepage', '/edit'),
        (0, $Iy9X2.requestDetailsRoute),
        (0, $4T2Ew.viewKbPageRoute),
        (0, $4T2Ew.viewAllSearchResultsRoute),
        (0, $4T2Ew.viewPortalAllSearchResultsRoute),
        (0, $4T2Ew.viewPortalCategoryArticleRoute),
        (0, $4T2Ew.viewPortalArticleRoute),
        (0, $4T2Ew.viewCrossSitePortalArticleRoute),
        (0, $4T2Ew.viewArticleRoute),
        (0, $4T2Ew.viewCrossSiteArticleRoute),
        (0, $73vn3.requestsListRoute),
        (0, $5Or3j.approvalsRoute),
        (0, $2Wfvm.requestApprovalRoute),
        (0, $hWMM6.userProfileRoute),
        (0, $4T2Ew.viewPortalKnowledgeCategoryRoute),
        (0, $hWMM6.anonymousRequestSuccessRoute),
        (0, $hWMM6.getRequestCreateRoute)(),
        (0, $3V7zc.getSurveyRoute)(),
        (0, $ajLNc.getPortalHomeRoutes)(),
        (0, $XiIOl.getEmbedCreateRequestRoute)(),
        (0, $XiIOl.embedSinglePortalRoute),
        (0, $XiIOl.embedKBArticleRoute),
        ...(0, $87QgR.default).checkGate('embed_hc_featured_portals') ? [
            (0, $XiIOl.embedFeaturedPortalsRoute)
        ] : [],
        ...(0, $87QgR.default).checkGate('jsm_portal_rovo_integration') ? [
            (0, $XiIOl.embedLoginSuccessRoute)
        ] : [],
        (0, $36cmj.portalReorderRoute)(true),
        (0, $8b9fA.editTopicRoute),
        (0, $8b9fA.addTopicRoute),
        (0, $2ylQX.getViewTopicRoute)(),
        ...(0, $9uWyX.getHelpCenterConversationPageRoute)(),
        ...(0, $iW3CQ.getIsHCCustomizationEnabled)() ? [
            (0, $5Yb8O.getEditCustomPageRoute)(),
            (0, $5Yb8O.getViewCustomPageRoute)()
        ] : [],
        (0, $hWMM6.notFoundErrorRoute)
    ];
};
const $22b6b2fae8951fbc$export$360df1dbfef16ccf = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $9cDCX.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $9cDCX.lightenColor)(themeColor);
    const routes = (0, $bSJIT.useMemo)(()=>$22b6b2fae8951fbc$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4v2A7.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2a9Vu.Router), {
        routes: routes,
        history: (0, $eDcdn.default),
        isGlobal: false,
        plugins: [
            (0, $fHAr3.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f9uTr.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8VdVQ.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7t0F6.RouteComponent), null)));
};
const $22b6b2fae8951fbc$var$selector = (0, $BOq7h.createSelector)((0, $fOlM6.getHeadless), (0, $hvIQS.getThemeColor), (0, $hvIQS.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $22b6b2fae8951fbc$export$2e2bcd8739ae039 = (0, $f2mlD.default)($22b6b2fae8951fbc$var$selector)($22b6b2fae8951fbc$export$360df1dbfef16ccf);

});
parcelRegister("9uWyX", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterConversationPageRoute", () => $020e6a51255389dd$export$c0656a6d05f5099e);
$parcel$export(module.exports, "viewPortalConversationPageRoute", () => $020e6a51255389dd$export$226a8310910111d5);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
var $liXIH = parcelRequire("liXIH");

var $dgUlM = parcelRequire("dgUlM");
parcelRequire("dBiCB");
var $Ee5M8 = parcelRequire("Ee5M8");

var $cGCrv = parcelRequire("cGCrv");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");
parcelRequire("lXxcP");
var $etQYy = parcelRequire("etQYy");
parcelRequire("fYwNS");
var $6i6lV = parcelRequire("6i6lV");
var $i5H5C = parcelRequire("i5H5C");
var $dTqqB = parcelRequire("dTqqB");

var $87QgR = parcelRequire("87QgR");

var $oORS9 = parcelRequire("oORS9");
const $020e6a51255389dd$var$Error = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $i5H5C.Error), null);
const $020e6a51255389dd$var$WrappedConversationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTqqB.default), {
        renderError: $020e6a51255389dd$var$Error,
        component: (0, $6i6lV.HelpCenterConversationPage),
        screenName: (0, $jcRK7.ScreenName).CONVERSATION_PAGE,
        headerless: true,
        footerless: true
    });
const $020e6a51255389dd$export$80dcf24036ea46a1 = ()=>{
    const WrappedComponent = (0, $lFpPv.isUnifiedHelpAddFilterForCustomerAccounts)() ? (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($020e6a51255389dd$var$WrappedConversationPage, null)) : (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }), (0, $cGCrv.default)())(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($020e6a51255389dd$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
const $020e6a51255389dd$export$ee1ce6de59399f4b = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const forbiddenPageOptions = {
        message: formatMessage((0, $6i6lV.authPageMessage)),
        callToActionText: formatMessage((0, $6i6lV.callToActionUrlText)),
        callToActionUrl: (0, $oORS9.getHelpCenterUrl)()
    };
    const enhancer = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }), (0, $Ee5M8.default)(forbiddenPageOptions));
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($020e6a51255389dd$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
const $020e6a51255389dd$export$c0656a6d05f5099e = ()=>{
    const viewConversationPageRoute = {
        name: (0, $jcRK7.ScreenName).CONVERSATION_PAGE,
        path: (0, $jcRK7.VA_ON_HC_CONVERSATION_PATH),
        exact: true,
        resources: [
            (0, $dgUlM.HelpCenterVirtualAgentResource)
        ],
        component: $020e6a51255389dd$export$80dcf24036ea46a1
    };
    return [
        {
            ...viewConversationPageRoute,
            component: $020e6a51255389dd$export$ee1ce6de59399f4b
        }
    ];
};
const $020e6a51255389dd$export$6cb15740fc92fb28 = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [isTestConversationParam] = (0, $liXIH.useQueryParam)('isTestConversation');
    const [isVSAAdoptionConversation] = (0, $liXIH.useQueryParam)('vsaAdoption');
    const [portalIdAsString] = (0, $3Gmp6.usePathParam)('portalId');
    const forbiddenPageOptions = {
        message: formatMessage((0, $6i6lV.authPageMessage)),
        callToActionText: formatMessage((0, $6i6lV.callToActionUrlText)),
        callToActionUrl: portalIdAsString ? `/portal/${portalIdAsString}` : (0, $oORS9.getHelpCenterUrl)(),
        hideBanner: (0, $87QgR.default).checkGate('jsm_vsa_adoption_flickering_issue_fix') && isVSAAdoptionConversation === 'true'
    };
    const enhancer = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }), ...isTestConversationParam === 'true' ? [
        (0, $etQYy.default)(forbiddenPageOptions)
    ] : []);
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTqqB.default), {
            renderError: $020e6a51255389dd$var$Error,
            component: (0, $6i6lV.PortalConversationPage),
            screenName: (0, $jcRK7.ScreenName).CONVERSATION_PAGE,
            headerless: true,
            footerless: true
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
};
const $020e6a51255389dd$export$226a8310910111d5 = {
    name: (0, $jcRK7.ScreenName).CONVERSATION_PAGE,
    path: (0, $jcRK7.VA_ON_PORTAL_CONVERSATION_PATH),
    exact: true,
    component: $020e6a51255389dd$export$6cb15740fc92fb28
};

});
parcelRegister("dgUlM", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $ad543d4f97e6f54e$export$7ab6648586bf1bbf);

var $lFpPv = parcelRequire("lFpPv");

var $3LQyI = parcelRequire("3LQyI");

var $f3B0F = parcelRequire("f3B0F");
const $ad543d4f97e6f54e$export$7ab6648586bf1bbf = (0, $3LQyI.createRelayResource)({
    type: 'HELP_CENTER_CONVERSATION_PAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $f3B0F.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $lFpPv.isVAOnHelpCenterGAEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("f3B0F", function(module, exports) {
$parcel$export(module.exports, "default", () => $af6053c3c1b6f676$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c16dcd22119d08ba4f182305bc93dc3>>
 * @relayHash edea8cab7174eb3853f7e72b44d7aa5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c115be58886ea6ac6426e499fd226521bc50f4439d42461efe307f31039df41
const $af6053c3c1b6f676$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v6 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "3c115be58886ea6ac6426e499fd226521bc50f4439d42461efe307f31039df41",
            "metadata": {},
            "name": "ConversationPageVirtualAgentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af6053c3c1b6f676$var$node.hash = "c8de3321d0f65a7321d319b804610818";
var $af6053c3c1b6f676$export$2e2bcd8739ae039 = $af6053c3c1b6f676$var$node;

});


parcelRegister("dBiCB", function(module, exports) {
$parcel$export(module.exports, "withJsmAiConfigEnabled", () => (parcelRequire("Ee5M8")).default);

var $Ee5M8 = parcelRequire("Ee5M8");

});
parcelRegister("Ee5M8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5135b70186b66cf4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $jcRK7 = parcelRequire("jcRK7");

var $fFr9c = parcelRequire("fFr9c");
parcelRequire("6GvED");
var $fOlM6 = parcelRequire("fOlM6");
parcelRequire("bQE3n");
var $eOp7R = parcelRequire("eOp7R");
const $5135b70186b66cf4$var$selector = (0, $BOq7h.createSelector)((0, $fOlM6.getJsmAIConfigEnabled), (jsmAIConfigEnabled)=>({
        jsmAIConfigEnabled: jsmAIConfigEnabled
    }));
const $5135b70186b66cf4$var$connector = (0, $f2mlD.default)($5135b70186b66cf4$var$selector, null);
const $5135b70186b66cf4$var$withJsmAiConfigEnabled = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { jsmAIConfigEnabled: jsmAIConfigEnabled } = props;
            if (jsmAIConfigEnabled) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $bSJIT.createElement((0, $eOp7R.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $fFr9c.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $jcRK7.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $5135b70186b66cf4$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithJsmAiConfigEnabled';
        return ConnectedComponent;
    };
var $5135b70186b66cf4$export$2e2bcd8739ae039 = $5135b70186b66cf4$var$withJsmAiConfigEnabled;

});


parcelRegister("cGCrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f1adb3781b72f2c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $g5FS7 = parcelRequire("g5FS7");
const $7f1adb3781b72f2c$var$selector = (0, $BOq7h.createSelector)((0, $fBLyB.isAtlassianAccountManaged), (isAtlassianAccount)=>({
        isAtlassianAccount: isAtlassianAccount
    }));
const $7f1adb3781b72f2c$var$connector = (0, $f2mlD.default)($7f1adb3781b72f2c$var$selector, null);
const $7f1adb3781b72f2c$var$withOnlyAtlassianAccount = ()=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isAtlassianAccount: isAtlassianAccount } = props;
            if (isAtlassianAccount) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props);
            return /*#__PURE__*/ $bSJIT.createElement((0, $g5FS7.Redirect), {
                to: "/user/forbidden"
            });
        };
        const ConnectedComponent = $7f1adb3781b72f2c$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyAtlassianAccount';
        return ConnectedComponent;
    };
var $7f1adb3781b72f2c$export$2e2bcd8739ae039 = $7f1adb3781b72f2c$var$withOnlyAtlassianAccount;

});

parcelRegister("lXxcP", function(module, exports) {
$parcel$export(module.exports, "withOnlyProjectAdmin", () => (parcelRequire("etQYy")).default);

var $etQYy = parcelRequire("etQYy");

});
parcelRegister("etQYy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4d8347253f7eb72$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $jcRK7 = parcelRequire("jcRK7");

var $fFr9c = parcelRequire("fFr9c");

var $i5HDF = parcelRequire("i5HDF");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
parcelRequire("gUbcQ");
var $jeW3I = parcelRequire("jeW3I");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");
parcelRequire("bQE3n");
var $eOp7R = parcelRequire("eOp7R");
const $d4d8347253f7eb72$var$selector = (0, $BOq7h.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    if (portalIdAsString) return (0, $iWhHo.getCanAdministerProject)(state, (0, $4ZMmh.toNumber)(portalIdAsString));
    return false;
}, (isProjectAdmin)=>({
        isProjectAdmin: isProjectAdmin
    }));
const $d4d8347253f7eb72$var$connector = (0, $f2mlD.default)($d4d8347253f7eb72$var$selector, {
    fetchPortals: (0, $jeW3I.fetchPortalAction)
});
const $d4d8347253f7eb72$var$withOnlyProjectAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isProjectAdmin: isProjectAdmin, fetchPortals: fetchPortals } = props;
            const [portalId] = (0, $3Gmp6.usePathParam)('portalId');
            $bSJIT.useEffect(()=>{
                if (isProjectAdmin === undefined && options.hideBanner) fetchPortals({
                    id: (0, $4ZMmh.toSafeInteger)(portalId),
                    expand: [
                        'kbs',
                        'reqTypes',
                        'reqGroups',
                        'orderMapping'
                    ]
                });
            }, [
                isProjectAdmin,
                fetchPortals,
                portalId
            ]);
            if (isProjectAdmin === undefined) return options.hideBanner ? /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.default), null) : /*#__PURE__*/ $bSJIT.createElement((0, $eOp7R.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.default), null),
                layoutProps: {
                    headerless: false,
                    fadeInSearchModal: true
                }
            });
            if (isProjectAdmin) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $bSJIT.createElement((0, $eOp7R.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $fFr9c.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $jcRK7.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        // @ts-ignore
        const ConnectedComponent = $d4d8347253f7eb72$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'withOnlyProjectAdmin';
        return ConnectedComponent;
    };
var $d4d8347253f7eb72$export$2e2bcd8739ae039 = $d4d8347253f7eb72$var$withOnlyProjectAdmin;

});


parcelRegister("fYwNS", function(module, exports) {
$parcel$export(module.exports, "Layout", () => (parcelRequire("dTqqB")).default);
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("i5H5C")).Error);
$parcel$export(module.exports, "HelpCenterConversationPage", () => (parcelRequire("6i6lV")).HelpCenterConversationPage);
$parcel$export(module.exports, "PortalConversationPage", () => (parcelRequire("6i6lV")).PortalConversationPage);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("6i6lV")).authPageMessage);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("6i6lV")).callToActionUrlText);

var $dTqqB = parcelRequire("dTqqB");
parcelRequire("e56Sy");
var $i5H5C = parcelRequire("i5H5C");

var $6i6lV = parcelRequire("6i6lV");

});
parcelRegister("dTqqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee4d6a4a953184f0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("1ylIr");
var $cHYPR = parcelRequire("cHYPR");

const $ee4d6a4a953184f0$var$LoadAppLazily = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("j2o3G")).then(({ App: App })=>(0, $cHYPR.default)(App)), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/app/App.tsx"
    })
});
const $ee4d6a4a953184f0$var$Layout = ({ component: component, screenName: screenName, renderError: renderError, headerless: headerless = false, footerless: footerless = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ee4d6a4a953184f0$var$LoadAppLazily, {
        component: component,
        screenName: screenName,
        renderError: renderError,
        layoutProps: {
            headerless: headerless,
            footerless: footerless
        }
    });
};
var $ee4d6a4a953184f0$export$2e2bcd8739ae039 = $ee4d6a4a953184f0$var$Layout;

});
parcelRegister("j2o3G", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("13X7O"),
    $kOunM("jMw4m")
]).then(()=>parcelRequire('UngYd'));

});


parcelRegister("e56Sy", function(module, exports) {
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("i5H5C")).Error);

var $i5H5C = parcelRequire("i5H5C");

});
parcelRegister("i5H5C", function(module, exports) {
$parcel$export(module.exports, "Error", () => $a19a95608772e797$export$edf27be85e5f6da0);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");
parcelRequire("kKBZy");
var $4GSP0 = parcelRequire("4GSP0");

var $g3h1H = parcelRequire("g3h1H");
const $a19a95608772e797$export$edf27be85e5f6da0 = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4GSP0.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $g3h1H.default).errorTitle),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, formatMessage((0, $g3h1H.default).errorDescriptionText, {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("a", {
                    href: "/servicedesk"
                }, chunks)
        })),
        hideFooter: true
    });
};

});
parcelRegister("g3h1H", function(module, exports) {
$parcel$export(module.exports, "default", () => $03459764dd68399b$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $03459764dd68399b$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorTitle: {
        defaultMessage: "We couldn\u2019t load this page",
        description: 'Text on show more results button',
        id: 'unified-help.error.page.title'
    },
    errorDescriptionText: {
        defaultMessage: 'Try refreshing the page or head to your <a>help center</a>.',
        description: 'Text for label on show more results icon',
        id: 'unified-help.error.page.description.text'
    }
});

});



parcelRegister("6i6lV", function(module, exports) {
$parcel$export(module.exports, "HelpCenterConversationPage", () => $f165a89bbe1389c1$export$1ebb9e18779d3716);
$parcel$export(module.exports, "PortalConversationPage", () => $f165a89bbe1389c1$export$68489d6e6f9646e7);
$parcel$export(module.exports, "callToActionUrlText", () => $f165a89bbe1389c1$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $f165a89bbe1389c1$export$5342e2a00fe6d647);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

var $8FgWf = parcelRequire("8FgWf");

const $f165a89bbe1389c1$export$1ebb9e18779d3716 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("jDplS")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/conversation-page/ConversationPage.tsx"
    })
});

const $f165a89bbe1389c1$export$68489d6e6f9646e7 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("8yby9")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/portal-conversation-page/PortalConversationPage.tsx"
    })
});
const $f165a89bbe1389c1$export$d96795d242b62963 = (0, $8FgWf.default).callToActionUrlText;
const $f165a89bbe1389c1$export$5342e2a00fe6d647 = (0, $8FgWf.default).authPageMessage;

});
parcelRegister("8FgWf", function(module, exports) {
$parcel$export(module.exports, "default", () => $a94d0c42fe187271$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a94d0c42fe187271$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.message.nonFinal'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to portal',
        description: 'Call to action text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.text.nonFinal'
    }
});

});

parcelRegister("jDplS", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9uCWW"),
    $kOunM("aVVxs"),
    $kOunM("3IRr1"),
    $kOunM("jHaBx"),
    $kOunM("7k2Dk"),
    $kOunM("9Vb2H"),
    $kOunM("i5Ki2"),
    $kOunM("kzTRH"),
    $kOunM("04tGK"),
    $kOunM("1fqfR"),
    $kOunM("fiNXw"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("lzQaK"),
    $kOunM("bYQHQ"),
    $kOunM("eCdiR"),
    $kOunM("fs156"),
    $kOunM("kI2bC"),
    $kOunM("uBPzN"),
    $kOunM("bZkRg"),
    $kOunM("izSDP"),
    $kOunM("13X7O"),
    $kOunM("hxkjO")
]).then(()=>parcelRequire('iqcdf'));

});

parcelRegister("8yby9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9uCWW"),
    $kOunM("aVVxs"),
    $kOunM("3IRr1"),
    $kOunM("jHaBx"),
    $kOunM("7k2Dk"),
    $kOunM("9Vb2H"),
    $kOunM("i5Ki2"),
    $kOunM("kzTRH"),
    $kOunM("04tGK"),
    $kOunM("1fqfR"),
    $kOunM("fiNXw"),
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("lzQaK"),
    $kOunM("bYQHQ"),
    $kOunM("eCdiR"),
    $kOunM("fs156"),
    $kOunM("kI2bC"),
    $kOunM("uBPzN"),
    $kOunM("bZkRg"),
    $kOunM("izSDP"),
    $kOunM("13X7O"),
    $kOunM("kmnUy")
]).then(()=>parcelRequire('kO26v'));

});




parcelRegister("73vn3", function(module, exports) {
$parcel$export(module.exports, "requestsListRoute", () => $7d6fa261785657b3$export$28cf91f271fafef3);

var $jcRK7 = parcelRequire("jcRK7");

var $5TwEA = parcelRequire("5TwEA");

var $bkEWh = parcelRequire("bkEWh");
const $7d6fa261785657b3$var$route = {
    name: 'requests-list',
    path: '/user/requests',
    exact: true,
    component: (0, $5TwEA.RequestList)
};
const $7d6fa261785657b3$var$screeName = (0, $jcRK7.ScreenName).REQUEST_LIST;
const $7d6fa261785657b3$var$paperAppearance = 'xxwide';
const $7d6fa261785657b3$var$layoutProps = {
    paperAppearance: $7d6fa261785657b3$var$paperAppearance,
    fadeInSearchModal: true
};
const $7d6fa261785657b3$export$28cf91f271fafef3 = (0, $bkEWh.createRouteWithLayout)($7d6fa261785657b3$var$route, $7d6fa261785657b3$var$screeName, $7d6fa261785657b3$var$layoutProps);

});

parcelRegister("3V7zc", function(module, exports) {
$parcel$export(module.exports, "getSurveyRoute", () => $26f01a33c28fc3a1$export$7cb84a2d5bf6d9c9);

var $jcRK7 = parcelRequire("jcRK7");

var $bkEWh = parcelRequire("bkEWh");

var $5FVX4 = parcelRequire("5FVX4");
const $26f01a33c28fc3a1$export$7cb84a2d5bf6d9c9 = ()=>(0, $bkEWh.createRouteWithLayout)({
        name: 'survey',
        path: '/portal/:portalId/survey/:surveyId',
        exact: true,
        component: (0, $5FVX4.AsyncSurveyDetails),
        resources: []
    }, (0, $jcRK7.ScreenName).SURVEY, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });

});

parcelRegister("fHAr3", function(module, exports) {
$parcel$export(module.exports, "resourcesPlugin", () => $7d5fd22e619e4447$export$f4f160418a82e3b7);

var $fuVmc = parcelRequire("fuVmc");

var $kbkME = parcelRequire("kbkME");
parcelRequire("iZLh2");
var $B4vXG = parcelRequire("B4vXG");

var $fZKGh = parcelRequire("fZKGh");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");
const $7d5fd22e619e4447$var$shouldAddEdgeFallbackForHelpCenterType = (helpCenterType)=>(0, $hCnLH.isCSMHelpCenter)(helpCenterType) || helpCenterType === 'HELP_HUB';
const $7d5fd22e619e4447$var$customContext = {
    cloudId: (0, $fuVmc.getCloudId)(),
    productName: (0, $fZKGh.PROJECT_NAME),
    helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
    workspaceAri: (0, $fuVmc.getWorkspaceAri)(),
    layoutAri: (0, $fuVmc.getLayoutAri)(),
    isUserLoggedIn: Boolean((0, $fuVmc.getMeta)('ajs-atlassian-account-id')),
    accountType: (0, $fuVmc.getMeta)('ajs-account-type') || '',
    relayEnvironment: (0, $kbkME.getRelayEnvironment)(),
    // Read by the shared hub page resource, which gates a query variable on it and so needs it
    // before the query runs. Just the surface type, not ANDed with `enable_rovo_in_help_hubs`:
    // evaluating a feature gate at module scope resolves to false under SSR
    // (@atlaskit/platform/no-module-level-eval). The resource ANDs its own gate at call time.
    isHelpHub: (0, $hCnLH.getIsHelpHub)(),
    // Signal the shared hub bootstrap resource to add the edge-fallback request
    // header (`X-Edge-Fallback-To-Unidentified`) for CSM Support Site and JSM Help
    // Hub consumers.
    shouldAddEdgeFallbackToUnidentified: $7d5fd22e619e4447$var$shouldAddEdgeFallbackForHelpCenterType((0, $iW3CQ.getEnv)().helpCenterType)
};
const $7d5fd22e619e4447$export$f4f160418a82e3b7 = (0, $B4vXG.createResourcesPlugin)({
    context: $7d5fd22e619e4447$var$customContext
});

});



parcelRegister("hxJrG", function(module, exports) {
$parcel$export(module.exports, "helpCenterViewHomePageExperience", () => $b6d050ee089c554d$export$deb53e4c26a043b6);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $b6d050ee089c554d$export$deb53e4c26a043b6 = new (0, $1we90.UFOExperience)((0, $eAZuG.helpCenterViewHomePageExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("jyogd", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTE_FAMILY", () => $4fb5cfbb872f1f99$export$5e0bd5dd4e173380);
$parcel$export(module.exports, "getHelpCenterRouteFamily", () => $4fb5cfbb872f1f99$export$ea5555298bcabe28);

var $gdUUy = parcelRequire("gdUUy");
const $4fb5cfbb872f1f99$var$HELP_HUB_TYPE = 'HELP_HUB';
const $4fb5cfbb872f1f99$export$5e0bd5dd4e173380 = 'hub';
const $4fb5cfbb872f1f99$export$35bb63ad9165c1ed = 'legacy';
const $4fb5cfbb872f1f99$export$ea5555298bcabe28 = (helpCenterType, hubsEnabled = (0, $gdUUy.fg)('enable-jsm-in-hubs'))=>{
    // Missing and unrecognised types retain the existing legacy routing behaviour.
    return hubsEnabled && helpCenterType === $4fb5cfbb872f1f99$var$HELP_HUB_TYPE ? $4fb5cfbb872f1f99$export$5e0bd5dd4e173380 : $4fb5cfbb872f1f99$export$35bb63ad9165c1ed;
};

});

parcelRegister("dz5Vz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a91c1767e532c00$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $7j7Eh = parcelRequire("7j7Eh");

var $9cDCX = parcelRequire("9cDCX");

var $f9uTr = parcelRequire("f9uTr");
parcelRequire("5lPCP");
var $7t0F6 = parcelRequire("7t0F6");
var $2a9Vu = parcelRequire("2a9Vu");

var $8CSvm = parcelRequire("8CSvm");

var $1YZEU = parcelRequire("1YZEU");

var $5clB8 = parcelRequire("5clB8");

var $clulZ = parcelRequire("clulZ");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $8VdVQ = parcelRequire("8VdVQ");

var $87QgR = parcelRequire("87QgR");

var $hCnLH = parcelRequire("hCnLH");

var $eDcdn = parcelRequire("eDcdn");

var $fHAr3 = parcelRequire("fHAr3");
parcelRequire("dgMoN");
var $hWMM6 = parcelRequire("hWMM6");
const $0a91c1767e532c00$export$4c59d19d881588b9 = (props)=>{
    //Order matters here
    const routes = (0, $bSJIT.useMemo)(()=>{
        const includeRovoAgentRoute = (0, $hCnLH.getIsHelpHub)() && (0, $87QgR.default).checkGate('enable_rovo_in_help_hubs') || (0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent');
        const includeVirtualAgentRoute = (0, $7j7Eh.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        return [
            (0, $1YZEU.helpcenterEditRoute),
            (0, $1YZEU.helpcenterManageProjectsRoute),
            (0, $1YZEU.helpcenterManageCustomPagesRoute),
            ...(0, $87QgR.default).checkGate('enable-jsm-in-hubs') ? [
                ...(0, $87QgR.default).checkGate('portal-pages-in-hub') ? [
                    (0, $1YZEU.hubEditPortalLayoutRoute)
                ] : [],
                (0, $1YZEU.hubEditLayoutRoute)
            ] : [],
            // Feature gate: jsm_help_center_one-click_rovo_agent (Help Center) / enable_rovo_in_help_hubs (Help Hub)
            ...includeRovoAgentRoute ? [
                (0, $8CSvm.helpcenterRovoServiceAgentRoute)
            ] : [],
            ...includeVirtualAgentRoute ? [
                (0, $5clB8.helpcenterVirtualAgentRoute)
            ] : [],
            (0, $clulZ.viewHelpCentersManagementPageRoute),
            ...(0, $87QgR.default).checkGate('enable-jsm-in-hubs') ? [
                (0, $clulZ.viewHelpHubsManagementPageRoute)
            ] : [],
            (0, $hWMM6.notFoundErrorRoute)
        ];
    }, []);
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $9cDCX.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $9cDCX.lightenColor)(themeColor);
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4v2A7.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2a9Vu.Router), {
        routes: routes,
        history: (0, $eDcdn.default),
        isGlobal: false,
        plugins: [
            (0, $fHAr3.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f9uTr.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8VdVQ.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7t0F6.RouteComponent), null)));
};
const $0a91c1767e532c00$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getThemeColor), (0, $hvIQS.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $0a91c1767e532c00$export$2e2bcd8739ae039 = (0, $f2mlD.default)($0a91c1767e532c00$var$selector)($0a91c1767e532c00$export$4c59d19d881588b9);

});
parcelRegister("8CSvm", function(module, exports) {
$parcel$export(module.exports, "helpcenterRovoServiceAgentRoute", () => $6e86c6a5ebe2a7f0$export$b887b8f40276e27c);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $cVM5r = parcelRequire("cVM5r");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");

var $1xzNy = parcelRequire("1xzNy");
parcelRequire("eByfJ");
var $1mm9L = parcelRequire("1mm9L");

var $bTPBr = parcelRequire("bTPBr");

const $6e86c6a5ebe2a7f0$var$AsyncRovoServiceAgentPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("dNLVU")).then((module)=>({
                default: module.RovoServiceAgentSettingsPageLoader
            })), {
        moduleId: "./packages/rovo-service-agent/rovo-service-agent-settings/src/index.tsx"
    })
});
const $6e86c6a5ebe2a7f0$var$RovoServiceAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }), (0, $ifEXU.default)({
        message: formatMessage((0, $1xzNy.authPageMessage)),
        callToActionText: formatMessage((0, $1xzNy.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mm9L.default), {
            featureName: "Rovo Service Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6e86c6a5ebe2a7f0$var$AsyncRovoServiceAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
const $6e86c6a5ebe2a7f0$export$b887b8f40276e27c = {
    name: 'rovoServiceAgentSettings',
    path: '/:helpcenterId/rovo-agent',
    exact: true,
    resources: [
        (0, $bTPBr.HelpCenterRovoServiceAgentResource)
    ],
    component: (0, $hbIgt.withRouter)($6e86c6a5ebe2a7f0$var$RovoServiceAgentPage)
};

});
parcelRegister("eByfJ", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("1mm9L")).default);
$parcel$export(module.exports, "useHelpCenterAri", () => (parcelRequire("9R3gt")).useHelpCenterAri);
$parcel$export(module.exports, "useConditionalMessage", () => (parcelRequire("4g0P3")).useConditionalMessage);
parcelRequire("5VVTp");
var $1mm9L = parcelRequire("1mm9L");

var $9R3gt = parcelRequire("9R3gt");

var $4g0P3 = parcelRequire("4g0P3");

});
parcelRegister("5VVTp", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("1mm9L")).default);
parcelRequire("lfOCd");
var $1mm9L = parcelRequire("1mm9L");
parcelRequire("eyygd");
var $ei8Ar = parcelRequire("ei8Ar");

var $d0Diy = parcelRequire("d0Diy");

});
parcelRegister("lfOCd", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("1mm9L")).default);
$parcel$export(module.exports, "AdminManagementLayoutLoader", () => (parcelRequire("1mm9L")).AdminManagementLayoutLoader);

var $1mm9L = parcelRequire("1mm9L");

});
parcelRegister("1mm9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d0650b9463403f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AdminManagementLayoutLoader", () => $1d0650b9463403f7$export$5684c902453038e9);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $f9uTr = parcelRequire("f9uTr");

var $a7Tmb = parcelRequire("a7Tmb");

var $1F8Um = parcelRequire("1F8Um");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");
var $h1bGI = parcelRequire("h1bGI");
parcelRequire("aI0YR");
var $fBLyB = parcelRequire("fBLyB");

var $2Trol = parcelRequire("2Trol");

var $85rmf = parcelRequire("85rmf");

var $87QgR = parcelRequire("87QgR");

var $6sLTn = parcelRequire("6sLTn");

var $gRfjb = parcelRequire("gRfjb");

var $iUkOP = parcelRequire("iUkOP");

var $74KHX = parcelRequire("74KHX");

var $ch6wh = parcelRequire("ch6wh");

var $bDli9 = parcelRequire("bDli9");

var $9ym5V = parcelRequire("9ym5V");

var $cOZaA = parcelRequire("cOZaA");

var $OK0aw = parcelRequire("OK0aw");

var $bSA8a = parcelRequire("bSA8a");

var $2D4Mi = parcelRequire("2D4Mi");

var $gUpf2 = parcelRequire("gUpf2");

var $4pBHw = parcelRequire("4pBHw");

var $9BVpB = parcelRequire("9BVpB");

var $hYh8H = parcelRequire("hYh8H");

var $cJsII = parcelRequire("cJsII");

var $iW3CQ = parcelRequire("iW3CQ");

var $7xtOy = parcelRequire("7xtOy");

var $iFhIy = parcelRequire("iFhIy");
parcelRequire("8Bsiq");
var $2pRNb = parcelRequire("2pRNb");
parcelRequire("375jI");
var $fqS4Y = parcelRequire("fqS4Y");

var $5CTLP = parcelRequire("5CTLP");
const $1d0650b9463403f7$var$AdminManagementLayoutContentBase = ({ children: children, featureName: featureName, hasSiteAdministerAccess: hasSiteAdministerAccess, hideSidebar: hideSidebar })=>{
    const [{ route: route }, { push: push }] = (0, $h1bGI.useRouter)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [helpCenterId = ''] = (0, $3Gmp6.usePathParam)('helpcenterId');
    const { name: routeName } = route;
    const { isHelpHub: isHelpHub } = (0, $7xtOy.useHelpCenterType)();
    const rovoServiceAgentRouteName = 'rovoServiceAgentSettings';
    const rovoServiceAgentUrl = `/${helpCenterId}/rovo-agent`;
    const virtualAgentRouteName = 'virtualAgentSettings';
    const virtualAgentUrl = `/${helpCenterId}/virtual-agent`;
    const mapProjectsScreenUrl = `/${helpCenterId}/projects`;
    const mapPagesScreenUrl = `/${helpCenterId}/pages`;
    const editProjectDetailsScreenUrl = `/${helpCenterId}/details`;
    const navigationContentItems = [
        {
            onClick: ()=>push(editProjectDetailsScreenUrl),
            text: formatMessage((0, $5CTLP.default).helpcenterDetailsItem),
            isVisible: true,
            isSelected: routeName === 'edit-details',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ch6wh))), {
                label: formatMessage((0, $5CTLP.default).helpcenterDetailsItem)
            })
        },
        {
            onClick: ()=>push(mapProjectsScreenUrl),
            text: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $5CTLP.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $5CTLP.default).helpcenterManageProjectsItem),
            isSelected: routeName === 'manage-projects',
            isVisible: true,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                label: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $5CTLP.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $5CTLP.default).helpcenterManageProjectsItem)
            })
        }
    ];
    // The manage-pages page is only an upsell for non-premium users.
    // So we only show it for premium users or users with billing permission.
    if ((0, $iW3CQ.getIsHCCustomizationEnabled)() || hasSiteAdministerAccess) navigationContentItems.push({
        onClick: ()=>push(mapPagesScreenUrl),
        text: formatMessage((0, $5CTLP.default).helpcenterManagePagesItem),
        isSelected: routeName === 'manage-pages',
        isVisible: !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iUkOP))), {
            label: formatMessage((0, $5CTLP.default).helpcenterManagePagesItem)
        })
    });
    // Rovo Agent
    // For Help Hubs: gated behind enable_rovo_in_help_hubs
    // For Help Centers: gated behind jsm_help_center_one-click_rovo_agent
    navigationContentItems.push({
        onClick: ()=>push(rovoServiceAgentUrl),
        text: formatMessage((0, $5CTLP.default).helpcenterRovoServiceAgentItem),
        isSelected: routeName === rovoServiceAgentRouteName,
        isVisible: isHelpHub ? (0, $87QgR.default).checkGate('enable_rovo_in_help_hubs') : (0, $87QgR.default).checkGate('jsm_help_center_one-click_rovo_agent'),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($74KHX))), {
            label: formatMessage((0, $5CTLP.default).helpcenterRovoServiceAgentItem)
        })
    });
    // Virtual Service Agent
    if (!(0, $lFpPv.isHideVsaEndpointsEnabled)() && (!hasSiteAdministerAccess || (0, $iW3CQ.getIsHCCustomizationEnabled)())) navigationContentItems.push({
        onClick: ()=>push(virtualAgentUrl),
        text: formatMessage((0, $5CTLP.default).helpcenterVsaReportingItem),
        isSelected: routeName === virtualAgentRouteName,
        isVisible: (0, $iW3CQ.getJsmAIConfigEnabled)() && !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
            label: formatMessage((0, $5CTLP.default).helpcenterVsaReportingItem)
        })
    });
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
            header: formatMessage((0, $5CTLP.default).errorTitle),
            description: formatMessage((0, $5CTLP.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1F8Um)))
        });
    };
    const packageName = ()=>{
        switch(routeName){
            case 'edit-details':
                return 'editDetails';
            case 'manage-projects':
                return 'manageProjects';
            case 'manage-pages':
                return 'managePages';
            case 'rovoServiceAgentSettings':
                return 'rovoServiceAgentSettings';
            case 'virtualAgentSettings':
                return 'virtualAgentSettings';
            case 'reporting':
                return 'reporting';
            default:
                return 'unknown';
        }
    };
    const mainContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cOZaA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: packageName(),
        id: 'admin-layout-management-page',
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: hideSidebar ? $1d0650b9463403f7$var$container : [
            $1d0650b9463403f7$var$container,
            $1d0650b9463403f7$var$containerWithMaxWidth
        ]
    }, children)));
    const isTablet = !(0, $2Trol.useMediaQuery)(`(max-width: ${(0, $a7Tmb.sizes).xsmall}px)`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9ym5V.default), {
        blanketIsTinted: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: [
            $1d0650b9463403f7$var$pageLayoutWrapper,
            hideSidebar && $1d0650b9463403f7$var$pageLayoutWrapperHideOverflow
        ],
        testId: "admin-layout-management-page-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSA8a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2D4Mi.default), {
        isFixed: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2pRNb.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $OK0aw.default), null, isTablet && !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fqS4Y.default), {
        width: (0, $iFhIy.SIDEBAR_WIDTH),
        navigationContentItems: navigationContentItems,
        featureName: featureName
    }), hideSidebar ? mainContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1d0650b9463403f7$var$bodyContainer,
        testId: "admin-layout-body-container"
    }, mainContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f9uTr.NewGlobalBGColor), null)))));
};
const $1d0650b9463403f7$var$selector = (0, $BOq7h.createSelector)((state)=>{
    return {
        hasSiteAdministerAccess: (0, $fBLyB.getHasSiteAdministerAccess)(state)
    };
}, ({ hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
const $1d0650b9463403f7$var$AdminManagementLayoutContent = (0, $f2mlD.default)($1d0650b9463403f7$var$selector)($1d0650b9463403f7$var$AdminManagementLayoutContentBase);
const $1d0650b9463403f7$export$b52b33be5684c42c = ({ children: children, featureName: featureName, loadingFallback: loadingFallback, hideSidebar: hideSidebar = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: loadingFallback ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7xtOy.HelpCenterTypeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1d0650b9463403f7$var$AdminManagementLayoutContent, {
        featureName: featureName,
        hideSidebar: hideSidebar
    }, children)));
};
var $1d0650b9463403f7$export$2e2bcd8739ae039 = $1d0650b9463403f7$export$b52b33be5684c42c;
const $1d0650b9463403f7$var$loaderStyles = {
    container: (0, $9BVpB.xcss)({
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    }),
    content: (0, $9BVpB.xcss)({
        display: 'flex',
        flexGrow: 1,
        minHeight: '0px'
    }),
    sidebar: (0, $9BVpB.xcss)({
        width: '240px',
        paddingTop: 'space.200',
        paddingRight: 'space.200',
        paddingBottom: 'space.200',
        paddingLeft: 'space.200'
    }),
    pageContent: (0, $9BVpB.xcss)({
        flexGrow: 1,
        minHeight: '0px',
        paddingTop: 'space.400',
        paddingRight: 'space.300',
        paddingBottom: 'space.300',
        paddingLeft: 'space.300'
    })
};
const $1d0650b9463403f7$export$5684c902453038e9 = ({ hideSidebar: hideSidebar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1d0650b9463403f7$var$loaderStyles.container,
        testId: "admin-management-layout-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJsII.default), {
        width: "100%",
        height: 58
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1d0650b9463403f7$var$loaderStyles.content
    }, !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1d0650b9463403f7$var$loaderStyles.sidebar,
        testId: "admin-management-layout-loader-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJsII.default), {
        width: "70%",
        height: 24,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJsII.default), {
        width: "100%",
        height: 16,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJsII.default), {
        width: "85%",
        height: 16,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJsII.default), {
        width: "100%",
        height: 16,
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $1d0650b9463403f7$var$loaderStyles.pageContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJsII.default), {
        width: "100%",
        height: "100%",
        isShimmering: true
    }))));
const $1d0650b9463403f7$var$container = (0, $9BVpB.xcss)({
    margin: '0 auto',
    paddingBottom: 'space.050',
    paddingInline: 'space.600',
    [(0, $4pBHw.media).above.lg]: {
        paddingInline: 'space.0'
    }
});
const $1d0650b9463403f7$var$containerWithMaxWidth = (0, $9BVpB.xcss)({
    maxWidth: '1160px'
});
const $1d0650b9463403f7$var$pageLayoutWrapper = (0, $9BVpB.xcss)({
    overflowAnchor: 'none',
    height: '100%'
});
// In hub edit mode the editor uses its own fixed-height scroll container, so the
// page wrapper must not scroll — otherwise a second scrollbar appears on large screens.
const $1d0650b9463403f7$var$pageLayoutWrapperHideOverflow = (0, $9BVpB.xcss)({
    overflow: 'hidden'
});
const $1d0650b9463403f7$var$bodyContainer = (0, $9BVpB.xcss)({
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: `calc(100vh - (${(0, $bDli9.TOP_NAVIGATION_HEIGHT)} + ${(0, $bDli9.BANNER_HEIGHT)}))`,
    width: '100%'
});

});
parcelRegister("1F8Um", function(module, exports) {
module.exports = new URL("../images/project-mapping-error.ef7a4be3.svg", import.meta.url).toString();

});

parcelRegister("85rmf", function(module, exports) {
$parcel$export(module.exports, "default", () => $180b02c801a43c8a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $f1bHg = parcelRequire("f1bHg");

var $7WQx2 = parcelRequire("7WQx2");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $hDkm2 = parcelRequire("hDkm2");

var $kXGCe = parcelRequire("kXGCe");

var $bulvb = parcelRequire("bulvb");

var $gUkyZ = parcelRequire("gUkyZ");

var $gkdBg = parcelRequire("gkdBg");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $180b02c801a43c8a$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $kXGCe.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $f1bHg.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $gkdBg.default), {
                children: isLoading && /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bulvb.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUkyZ.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $180b02c801a43c8a$export$2e2bcd8739ae039 = $180b02c801a43c8a$var$EmptyState;

});
parcelRegister("kXGCe", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac6ef281edb2ecd8$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $ac6ef281edb2ecd8$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $ac6ef281edb2ecd8$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $ac6ef281edb2ecd8$export$2e2bcd8739ae039 = $ac6ef281edb2ecd8$var$ActionsContainer;

});

parcelRegister("bulvb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4431ab20f23028bc$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $4431ab20f23028bc$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $4431ab20f23028bc$var$wideContainerStyles = null;
const $4431ab20f23028bc$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $4431ab20f23028bc$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $4431ab20f23028bc$export$2e2bcd8739ae039 = $4431ab20f23028bc$var$Container;

});

parcelRegister("gUkyZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $87f6a33018fef6ce$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $87f6a33018fef6ce$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $87f6a33018fef6ce$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $87f6a33018fef6ce$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $87f6a33018fef6ce$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $dc70d.jsx)("img", {
        style: {
            [$87f6a33018fef6ce$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$87f6a33018fef6ce$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $9fU1q.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $87f6a33018fef6ce$export$2e2bcd8739ae039 = $87f6a33018fef6ce$var$Image;

});

parcelRegister("gkdBg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f70a01674d104547$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $f70a01674d104547$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $f70a01674d104547$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $f70a01674d104547$export$2e2bcd8739ae039 = $f70a01674d104547$var$SpinnerContainer;

});


parcelRegister("iUkOP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de050e7ad7082dc8bd3a7ec6dcb292e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc3d9b257719d9ef$var$_react = $dc3d9b257719d9ef$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $dc3d9b257719d9ef$var$_iconNew = $dc3d9b257719d9ef$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $dc3d9b257719d9ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pages
 * Usage guidance:
 * Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc3d9b257719d9ef$var$PagesIcon = (props)=>/*#__PURE__*/ $dc3d9b257719d9ef$var$_react.default.createElement($dc3d9b257719d9ef$var$_iconNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$dc3d9b257719d9ef$var$PagesIcon.displayName = 'PagesIcon';
var $dc3d9b257719d9ef$var$_default = module.exports.default = $dc3d9b257719d9ef$var$PagesIcon;

});

parcelRegister("74KHX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c789d79db2d4e9441e0875f3295345a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $526d235ce031197e$var$_react = $526d235ce031197e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $526d235ce031197e$var$_iconNew = $526d235ce031197e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $526d235ce031197e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/rovo
 * Usage guidance:
 * Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $526d235ce031197e$var$RovoIcon = (props)=>/*#__PURE__*/ $526d235ce031197e$var$_react.default.createElement($526d235ce031197e$var$_iconNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$526d235ce031197e$var$RovoIcon.displayName = 'RovoIcon';
var $526d235ce031197e$var$_default = module.exports.default = $526d235ce031197e$var$RovoIcon;

});

parcelRegister("ch6wh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c33c49386fab22e088fef79f72c28139>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8efc213c8c0ada6b$var$_react = $8efc213c8c0ada6b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8efc213c8c0ada6b$var$_iconNew = $8efc213c8c0ada6b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8efc213c8c0ada6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/wrench
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8efc213c8c0ada6b$var$WrenchIcon = (props)=>/*#__PURE__*/ $8efc213c8c0ada6b$var$_react.default.createElement($8efc213c8c0ada6b$var$_iconNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$8efc213c8c0ada6b$var$WrenchIcon.displayName = 'WrenchIcon';
var $8efc213c8c0ada6b$var$_default = module.exports.default = $8efc213c8c0ada6b$var$WrenchIcon;

});

parcelRegister("bDli9", function(module, exports) {
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $496ed08798ef184c$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $496ed08798ef184c$export$ed7cc0d417ee89e);
/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $496ed08798ef184c$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $496ed08798ef184c$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $496ed08798ef184c$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $496ed08798ef184c$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $496ed08798ef184c$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $496ed08798ef184c$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

});

parcelRegister("2D4Mi", function(module, exports) {
$parcel$export(module.exports, "default", () => $04468a5dbaab5d39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $1qxfZ = parcelRequire("1qxfZ");

var $drY8a = parcelRequire("drY8a");

var $62mys = parcelRequire("62mys");

var $iPBU6 = parcelRequire("iPBU6");
var $gG3J7 = parcelRequire("gG3J7");

var $jIwmJ = parcelRequire("jIwmJ");

var $hY84w = parcelRequire("hY84w");
const $04468a5dbaab5d39$var$topNavigationStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $1qxfZ.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $1qxfZ.TOP_NAVIGATION)
});
const $04468a5dbaab5d39$var$fixedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $1qxfZ.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $1qxfZ.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $1qxfZ.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $04468a5dbaab5d39$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $1qxfZ.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $62mys.resolveDimension)((0, $1qxfZ.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $bSJIT.useEffect)(()=>{
        (0, $iPBU6.default)({
            [(0, $1qxfZ.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $iPBU6.default)({
                [(0, $1qxfZ.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $gG3J7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jIwmJ.default), null, ({ className: className })=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: [
                $04468a5dbaab5d39$var$topNavigationStyles,
                isFixed && $04468a5dbaab5d39$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $drY8a.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hY84w.default), {
            variableName: (0, $1qxfZ.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $04468a5dbaab5d39$export$2e2bcd8739ae039 = $04468a5dbaab5d39$var$TopNavigation;

});
parcelRegister("62mys", function(module, exports) {
$parcel$export(module.exports, "resolveDimension", () => $8c476213aeedc71f$export$74732e47915c7839);

var $6CU1M = parcelRequire("6CU1M");
const $8c476213aeedc71f$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = (0, $6CU1M.getGridStateFromStorage)('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};

});
parcelRegister("6CU1M", function(module, exports) {
$parcel$export(module.exports, "getGridStateFromStorage", () => $f4577702d1e23def$export$d95e99d8116d17dc);

var $1qxfZ = parcelRequire("1qxfZ");

var $9ajTG = parcelRequire("9ajTG");
const $f4577702d1e23def$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $9ajTG.default)().getItem((0, $1qxfZ.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};

});
parcelRegister("9ajTG", function(module, exports) {
$parcel$export(module.exports, "default", () => $12cce646ecca1a34$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $12cce646ecca1a34$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(testKey, testKey);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.removeItem(testKey);
        return true;
    } catch  {
        return false;
    }
};
const $12cce646ecca1a34$var$safeLocalStorage = ()=>{
    if ($12cce646ecca1a34$var$isLocalStorageSupported()) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $12cce646ecca1a34$export$2e2bcd8739ae039 = $12cce646ecca1a34$var$safeLocalStorage;

});



parcelRegister("iPBU6", function(module, exports) {
$parcel$export(module.exports, "default", () => $90427342d5af5554$export$2e2bcd8739ae039);

var $2nTFc = parcelRequire("2nTFc");

var $eC2kJ = parcelRequire("eC2kJ");
const $90427342d5af5554$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $eC2kJ.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $2nTFc.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $90427342d5af5554$export$2e2bcd8739ae039 = $90427342d5af5554$var$publishGridState;

});
parcelRegister("2nTFc", function(module, exports) {
$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $a55f0b5fb34b96e5$export$f8355a2df0f4a946);

var $1qxfZ = parcelRequire("1qxfZ");

var $9ajTG = parcelRequire("9ajTG");
const $a55f0b5fb34b96e5$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $9ajTG.default)().getItem((0, $1qxfZ.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $9ajTG.default)().setItem((0, $1qxfZ.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};

});

parcelRegister("eC2kJ", function(module, exports) {
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $9f9424afef0b0e08$export$17e3760e0b35f1cd);

var $1qxfZ = parcelRequire("1qxfZ");

var $9ajTG = parcelRequire("9ajTG");
const $9f9424afef0b0e08$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $9ajTG.default)().getItem((0, $1qxfZ.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $9ajTG.default)().setItem((0, $1qxfZ.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};

});


parcelRegister("hY84w", function(module, exports) {
$parcel$export(module.exports, "default", () => $374ae32d992dec99$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $aXmgv = parcelRequire("aXmgv");
/**
 * Hoists slot dimension styles to the root element.
 */ const $374ae32d992dec99$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $aXmgv.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $dc70d.jsx)("style", {
        children: style
    }));
};
var $374ae32d992dec99$export$2e2bcd8739ae039 = $374ae32d992dec99$var$SlotDimensions;

});


parcelRegister("7xtOy", function(module, exports) {
$parcel$export(module.exports, "HelpCenterTypeProvider", () => $3911835696499f56$export$d53895d6fb159859);
$parcel$export(module.exports, "useHelpCenterType", () => $3911835696499f56$export$f4dfe81df1da8e40);
$parcel$export(module.exports, "useOptionalHelpCenterType", () => $3911835696499f56$export$9f436e6b1d27b8b1);

var $gY54u = parcelRequire("gY54u");

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $a2qIF = parcelRequire("a2qIF");

var $9R3gt = parcelRequire("9R3gt");
const $3911835696499f56$var$HelpCenterTypeContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $3911835696499f56$export$d53895d6fb159859 = ({ children: children })=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $9R3gt.useHelpCenterAri)();
    const cloudId = (0, $fuVmc.getCloudId)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $gY54u.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterType = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.type) ?? null;
    const isHelpHub = helpCenterType === 'HELP_HUB';
    const value = {
        helpCenterType: helpCenterType,
        isHelpHub: isHelpHub
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3911835696499f56$var$HelpCenterTypeContext.Provider, {
        value: value
    }, children);
};
const $3911835696499f56$export$f4dfe81df1da8e40 = ()=>{
    const context = (0, $bSJIT.useContext)($3911835696499f56$var$HelpCenterTypeContext);
    if (context === undefined) throw new Error('useHelpCenterType must be used within a HelpCenterTypeProvider');
    return context;
};
const $3911835696499f56$export$9f436e6b1d27b8b1 = ()=>{
    const context = (0, $bSJIT.useContext)($3911835696499f56$var$HelpCenterTypeContext);
    // Default to BASIC/Help Center when context is not available (e.g., creating new help centers)
    return context ?? {
        helpCenterType: null,
        isHelpHub: false
    };
};

});
parcelRegister("gY54u", function(module, exports) {
$parcel$export(module.exports, "default", () => $378683c0a0ada290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85612eb43834db2f494f160069fa5560>>
 * @relayHash beb53aa7a0d0e9601d0a8ed6e41c37bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65
const $378683c0a0ada290$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65",
            "metadata": {},
            "name": "helpCenterTypeContextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$378683c0a0ada290$var$node.hash = "84d5aba1364a6a49146d359035c72854";
var $378683c0a0ada290$export$2e2bcd8739ae039 = $378683c0a0ada290$var$node;

});

parcelRegister("9R3gt", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterAri", () => $c040037a698eb298$export$f14e6e523bbc25e7);
/**
 This hook will only work if the helpcenterId exists in the path param and the activation-id exists in the meta tag.
 @returns {string} The Help Center ARI.
 */ 
var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $3Gmp6 = parcelRequire("3Gmp6");

var $9P2Zq = parcelRequire("9P2Zq");
const $c040037a698eb298$export$f14e6e523bbc25e7 = ()=>{
    const [helpCenterId = ''] = (0, $3Gmp6.usePathParam)('helpcenterId');
    const activationId = (0, $fuVmc.getMeta)('activation-id') || '';
    const helpCenterAri = (0, $9P2Zq.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
    return helpCenterAri;
};

});


parcelRegister("iFhIy", function(module, exports) {
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $5b60b2fa40e0f1dd$export$780035d9fe48eb32);
$parcel$export(module.exports, "CANT_UNLINK_ALL_DIALOG", () => $5b60b2fa40e0f1dd$export$34c86dd326ed7328);
$parcel$export(module.exports, "UNLINK_CONFIRMATION_DIALOG", () => $5b60b2fa40e0f1dd$export$e1e71e4a40967783);
$parcel$export(module.exports, "MANAGE_PROJECT_HEAD_WIDTH", () => $5b60b2fa40e0f1dd$export$39266233350d2cc1);
$parcel$export(module.exports, "MANAGE_PAGE_HEAD_WIDTH", () => $5b60b2fa40e0f1dd$export$d93583f12bb7f663);
$parcel$export(module.exports, "ALREADY_EXISTED_CUSTOM_PAGE_MESSAGE", () => $5b60b2fa40e0f1dd$export$24707863b4005c32);
$parcel$export(module.exports, "CUSTOM_PAGE_NAME_CHARACTER_LIMIT", () => $5b60b2fa40e0f1dd$export$7b26638f36689ddd);
$parcel$export(module.exports, "CUSTOM_PAGE_DESC_CHARACTER_LIMIT", () => $5b60b2fa40e0f1dd$export$8dc5686b04c6900a);
$parcel$export(module.exports, "NUMBER_OF_PAGES_INITIAL_FETCH", () => $5b60b2fa40e0f1dd$export$4b69f23d48ad7a80);
$parcel$export(module.exports, "HARD_LIMIT_CUSTOM_PAGES_MESSAGE", () => $5b60b2fa40e0f1dd$export$7e882a52c33de54f);
$parcel$export(module.exports, "NUMBER_OF_PAGES_PER_PAGE", () => $5b60b2fa40e0f1dd$export$806937cd4427be30);
const $5b60b2fa40e0f1dd$export$780035d9fe48eb32 = 240;
const $5b60b2fa40e0f1dd$export$34c86dd326ed7328 = 'cant-unlink-all-dialog';
const $5b60b2fa40e0f1dd$export$e1e71e4a40967783 = 'unlink-confirmation-dialog';
const $5b60b2fa40e0f1dd$export$39266233350d2cc1 = {
    'select-all': 5,
    'project-name': 35,
    'lead-name': 35,
    status: 15,
    'action-button': 15
};
const $5b60b2fa40e0f1dd$export$d93583f12bb7f663 = {
    'page-name': 20,
    'last-updated': 20,
    'page-description': 40,
    'action-button': 10
};
const $5b60b2fa40e0f1dd$export$24707863b4005c32 = `A custom page with this name already exists on your site. Try again with a different name.`;
const $5b60b2fa40e0f1dd$export$7b26638f36689ddd = 100;
const $5b60b2fa40e0f1dd$export$8dc5686b04c6900a = 256;
const $5b60b2fa40e0f1dd$export$4b69f23d48ad7a80 = 100;
const $5b60b2fa40e0f1dd$export$7e882a52c33de54f = `Pages limit of ${$5b60b2fa40e0f1dd$export$4b69f23d48ad7a80} is exceeded`;
const $5b60b2fa40e0f1dd$export$806937cd4427be30 = 20;

});

parcelRegister("8Bsiq", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("2pRNb")).default);

var $2pRNb = parcelRequire("2pRNb");

});
parcelRegister("2pRNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $52b8bffbef8acdb1$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $iCbt2 = parcelRequire("iCbt2");

var $1fqzU = parcelRequire("1fqzU");
var $52b8bffbef8acdb1$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, {
    fetchUser: (0, $iCbt2.fetchUserModelAction)
})((0, $1fqzU.default));

});
parcelRegister("1fqzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $563012438747489f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2usNr = parcelRequire("2usNr");

var $5Kc7A = parcelRequire("5Kc7A");

var $3PYKV = parcelRequire("3PYKV");

var $jPnmN = parcelRequire("jPnmN");
var $6eFxQ = parcelRequire("6eFxQ");
parcelRequire("25Mnh");
var $83t8i = parcelRequire("83t8i");

var $5sDM7 = parcelRequire("5sDM7");
const $563012438747489f$var$HomeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jPnmN.JiraServiceManagementIcon), {
        size: "xsmall",
        appearance: "brand"
    });
const $563012438747489f$var$HomeLogo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6eFxQ.JiraServiceManagementLogoCS), {
        size: "xsmall",
        appearance: "brand"
    });
const $563012438747489f$var$Home = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3PYKV.default), {
        icon: $563012438747489f$var$HomeIcon,
        logo: $563012438747489f$var$HomeLogo,
        href: `${window.location.origin}/jira/your-work`
    });
const $563012438747489f$var$AppSwitcher = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5sDM7.default), null);
const $563012438747489f$var$Header = ({ fetchUser: fetchUser })=>{
    (0, $bSJIT.useEffect)(()=>{
        fetchUser();
    }, [
        fetchUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5Kc7A.AtlassianNavigation), {
        label: "site",
        renderProductHome: $563012438747489f$var$Home,
        renderProfile: (0, $83t8i.default),
        renderAppSwitcher: $563012438747489f$var$AppSwitcher,
        primaryItems: []
    });
};
var $563012438747489f$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'Header'
})($563012438747489f$var$Header);

});
parcelRegister("5Kc7A", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigation", () => $11557d7da5bc0cbd$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4i8UQ = parcelRequire("4i8UQ");


var $diZ0t = parcelRequire("diZ0t");

var $fkjDw = parcelRequire("fkjDw");
var $3DgVq = parcelRequire("3DgVq");

var $cD9Xl = parcelRequire("cD9Xl");

var $4eGW1 = parcelRequire("4eGW1");
function $11557d7da5bc0cbd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $11557d7da5bc0cbd$var$containerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $diZ0t.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $11557d7da5bc0cbd$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $11557d7da5bc0cbd$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $11557d7da5bc0cbd$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $11557d7da5bc0cbd$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $11557d7da5bc0cbd$export$f66ccb39f60980e5 = (props)=>{
    typeof $4eGW1;
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $fkjDw.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $3DgVq.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $4i8UQ.NavigationAnalyticsContext), {
        data: $11557d7da5bc0cbd$var$analyticsData
    }, /*#__PURE__*/ (0, $9dQre.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $11557d7da5bc0cbd$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("nav", {
        css: $11557d7da5bc0cbd$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $9dQre.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $9dQre.jsx)(ProductHome, null), /*#__PURE__*/ (0, $9dQre.jsx)((0, $cD9Xl.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $11557d7da5bc0cbd$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $9dQre.jsx)(Search, null), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        role: "list",
        css: [
            $11557d7da5bc0cbd$var$rightStyles,
            $11557d7da5bc0cbd$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $9dQre.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $9dQre.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $9dQre.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $9dQre.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $9dQre.jsx)(Profile, null))))));
};

});
parcelRegister("diZ0t", function(module, exports) {
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $a2d8a6ded9e771d6$export$30fa7cc5f2690a43);
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", () => $a2d8a6ded9e771d6$export$4033a111ca79977d);
/**
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $a2d8a6ded9e771d6$export$30fa7cc5f2690a43 = 56;
const $a2d8a6ded9e771d6$export$4033a111ca79977d = 1280;
const $a2d8a6ded9e771d6$export$24ec62cee78b7042 = 1130;
const $a2d8a6ded9e771d6$export$d8bde68ac946124f = '--ds--ans--fbc';
const $a2d8a6ded9e771d6$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $a2d8a6ded9e771d6$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $a2d8a6ded9e771d6$export$d81606c1fc5119bc = '--ds--ans--c';
const $a2d8a6ded9e771d6$export$65f656ad520ea71 = '--ds--ans--bc';

});

parcelRegister("3DgVq", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $7772e300fb6e2e68$export$d8964aec282183a3);

var $kKOMt = parcelRequire("kKOMt");
const $7772e300fb6e2e68$export$d8964aec282183a3 = (0, $kKOMt.ThemeContext).Provider;

});

parcelRegister("cD9Xl", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainer", () => $9bd9955ac69d59a0$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $26Jy2 = parcelRequire("26Jy2");

var $8Mb7N = parcelRequire("8Mb7N");

var $2VHMp = parcelRequire("2VHMp");

var $ftUeA = parcelRequire("ftUeA");

var $aT72X = parcelRequire("aT72X");
function $9bd9955ac69d59a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9bd9955ac69d59a0$var$containerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // Guard excludes top-layer popover siblings (eg the overflow menu / tooltip); :where() keeps specificity.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > *:not(:where([popover], dialog))': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $9bd9955ac69d59a0$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $9bd9955ac69d59a0$var$overflowItemsStyles = {
    name: "4ekwwx",
    styles: "color:var(--ds-text, #292A2E)"
};
const $9bd9955ac69d59a0$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $bSJIT.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $ftUeA.useOverflowController)(items);
    const onMoreClick = (0, $bSJIT.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $bSJIT.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $bSJIT.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $bSJIT.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $aT72X.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $bSJIT.useCallback)(()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $2VHMp.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $9bd9955ac69d59a0$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $9bd9955ac69d59a0$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $2VHMp.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $9dQre.jsx)((0, $26Jy2.Popup), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $9dQre.jsx)(Create, null), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $9bd9955ac69d59a0$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8Mb7N.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("2VHMp", function(module, exports) {
$parcel$export(module.exports, "OverflowProvider", () => $4a54aef1ba278cd2$export$a3a2def3937905a0);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $6fvMm = parcelRequire("6fvMm");
const $4a54aef1ba278cd2$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const value = (0, $bSJIT.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6fvMm.OverflowContext).Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("6fvMm", function(module, exports) {
$parcel$export(module.exports, "OverflowContext", () => $d554dbd4037ddcc3$export$79f16dd643143c25);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");
const $d554dbd4037ddcc3$export$79f16dd643143c25 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $1OdZP.default),
    closeOverflowMenu: (0, $1OdZP.default)
});

});


parcelRegister("ftUeA", function(module, exports) {
$parcel$export(module.exports, "useOverflowController", () => $27e64670167d8a67$export$705aa66a39c35bf7);

var $bSJIT = parcelRequire("bSJIT");

var $cNIkg = parcelRequire("cNIkg");
const $27e64670167d8a67$var$THROTTLE_INTERVAL = 64;
const $27e64670167d8a67$var$ITEM_APPROX_MINWIDTH = 70;
const $27e64670167d8a67$var$calculateHash = (w, n)=>w + '#' + n;
const $27e64670167d8a67$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $27e64670167d8a67$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(nodes);
    const [width, setWidth] = (0, $bSJIT.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $bSJIT.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $bSJIT.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $bSJIT.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $bSJIT.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $bSJIT.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($cNIkg)))(setWidth, $27e64670167d8a67$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $27e64670167d8a67$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $27e64670167d8a67$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $27e64670167d8a67$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $27e64670167d8a67$var$ITEM_APPROX_MINWIDTH * 2), $27e64670167d8a67$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $27e64670167d8a67$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $27e64670167d8a67$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $27e64670167d8a67$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $27e64670167d8a67$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $27e64670167d8a67$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $27e64670167d8a67$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        return;
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};

});
parcelRegister("cNIkg", function(module, exports) {

var $inh7J = parcelRequire("inh7J");

var $awGqx = parcelRequire("awGqx");
/** Error message constants. */ var $951c71d01206f025$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $951c71d01206f025$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($951c71d01206f025$var$FUNC_ERROR_TEXT);
    if ($awGqx(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $inh7J(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $951c71d01206f025$var$throttle;

});


parcelRegister("aT72X", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", () => $ffb4d354f7e6d783$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4GWyU = parcelRequire("4GWyU");

var $YlN5e = parcelRequire("YlN5e");
function $ffb4d354f7e6d783$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffb4d354f7e6d783$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $ffb4d354f7e6d783$export$bb3af89fb196520d = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $YlN5e.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        css: [
            $ffb4d354f7e6d783$var$buttonNoOpStyle
        ],
        ...rest
    });
});

});
parcelRegister("YlN5e", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $13fbc411dd1b893d$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $2U5M0 = parcelRequire("2U5M0");

var $lavtv = parcelRequire("lavtv");

var $9Tu9C = parcelRequire("9Tu9C");

var $fdnFe = parcelRequire("fdnFe");
function $13fbc411dd1b893d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $13fbc411dd1b893d$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $13fbc411dd1b893d$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $13fbc411dd1b893d$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $13fbc411dd1b893d$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $13fbc411dd1b893d$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$13fbc411dd1b893d$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$13fbc411dd1b893d$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $13fbc411dd1b893d$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $9Tu9C.useTheme)();
    const button = /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        style: {
            [$13fbc411dd1b893d$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$13fbc411dd1b893d$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $13fbc411dd1b893d$var$buttonBaseStyles,
            isHighlighted && $13fbc411dd1b893d$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $2U5M0.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $fdnFe.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $13fbc411dd1b893d$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("fdnFe", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $bd83aeee6a7a381d$export$14dd6915caf431fe);
const $bd83aeee6a7a381d$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("3PYKV", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dde495da061cf5b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $diZ0t = parcelRequire("diZ0t");

var $9Tu9C = parcelRequire("9Tu9C");

var $73FfN = parcelRequire("73FfN");

var $k64Ot = parcelRequire("k64Ot");

function $9dde495da061cf5b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9dde495da061cf5b$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $9dde495da061cf5b$var$productHomeButtonStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $diZ0t.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $diZ0t.PRODUCT_HOME_BREAKPOINT}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $9dde495da061cf5b$var$productLogoStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$9dde495da061cf5b$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$9dde495da061cf5b$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $diZ0t.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $9dde495da061cf5b$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $9dde495da061cf5b$var$productIconStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $diZ0t.PRODUCT_HOME_BREAKPOINT}px)`]: {
        display: 'none'
    }
});
const $9dde495da061cf5b$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 *
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $9dde495da061cf5b$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $9Tu9C.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    let { iconColor: iconColor, textColor: textColor } = theme.mode.productHome;
    // If the theme returns the default Atlassian theme, rely on the Logo default behaviour instead
    if (iconColor === '#357DE8' && textColor === "var(--ds-text, #292A2E)") {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $k64Ot.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $73FfN.stripEmptyProperties)({
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$9dde495da061cf5b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$9dde495da061cf5b$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, $9dQre.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $9dde495da061cf5b$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $9dde495da061cf5b$var$customMaxHeightStyles,
            $9dde495da061cf5b$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $9dQre.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: iconColor || textColor ? undefined : 'brand'
    })), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $9dde495da061cf5b$var$customMaxHeightStyles,
            $9dde495da061cf5b$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $9dQre.jsx)(Icon, {
        iconColor: iconColor,
        size: 'small',
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: iconColor || textColor ? undefined : 'brand'
    }))), siteTitle && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $9dde495da061cf5b$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $9dde495da061cf5b$export$2e2bcd8739ae039 = $9dde495da061cf5b$var$ProductHome;

});
parcelRegister("73FfN", function(module, exports) {
$parcel$export(module.exports, "stripEmptyProperties", () => $7659ef66ac0dcbbe$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $7659ef66ac0dcbbe$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});

parcelRegister("k64Ot", function(module, exports) {
$parcel$export(module.exports, "getTag", () => $c579f30cec059a78$export$dad497fe1f6e27c0);
const $c579f30cec059a78$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("jPnmN", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $32e1b23bc970444c$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::018e1283e27acb8e799a70f211bb080a>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $32e1b23bc970444c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $32e1b23bc970444c$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $32e1b23bc970444c$export$3c6158790f5e01c4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $32e1b23bc970444c$var$svg,
        customThemeSvg: $32e1b23bc970444c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6eFxQ", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $21a1cfc47e9c14be$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::510112a7c331386966b3b832ba6806dc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $kbeaL = parcelRequire("kbeaL");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $21a1cfc47e9c14be$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $21a1cfc47e9c14be$export$de148263c75d2bc1({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kbeaL.LogoWrapper), {
        svg: $21a1cfc47e9c14be$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("kbeaL", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $3787bfb81fd44779$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");

var $ceb9s = parcelRequire("ceb9s");
const $3787bfb81fd44779$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $3787bfb81fd44779$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $3787bfb81fd44779$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $3787bfb81fd44779$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $3787bfb81fd44779$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $3787bfb81fd44779$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $3787bfb81fd44779$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $3787bfb81fd44779$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $3787bfb81fd44779$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $3787bfb81fd44779$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $3787bfb81fd44779$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $3787bfb81fd44779$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $9fU1q.default)([
            $3787bfb81fd44779$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $3787bfb81fd44779$var$logoTextColorMap[colorMode ?? 'light'],
            $3787bfb81fd44779$var$sizeMap[size],
            colorMode === 'dark' ? $3787bfb81fd44779$var$textDarkAppearanceMap[appearance] : $3787bfb81fd44779$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $3787bfb81fd44779$var$dataCenterDarkAppearanceMap[appearance] : $3787bfb81fd44779$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $3787bfb81fd44779$var$rovoDarkAppearanceMap[appearance] : $3787bfb81fd44779$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $3787bfb81fd44779$var$cloudDarkAppearanceMap[appearance] : $3787bfb81fd44779$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $gdUUy.fg)('assets-platform-branding') || (0, $gdUUy.fg)('assets-platform-branding-v2')) && $3787bfb81fd44779$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("5sDM7", function(module, exports) {
$parcel$export(module.exports, "default", () => $51949081c555f74b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $jLgRn = parcelRequire("jLgRn");

var $26Jy2 = parcelRequire("26Jy2");

var $j2ONn = parcelRequire("j2ONn");

var $cYtYv = parcelRequire("cYtYv");
const $51949081c555f74b$var$APP_SWITCHER_PRODUCT = 'jiraServiceManagement';
const $51949081c555f74b$var$AppSwitcherComponent = ()=>{
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const cloudId = (0, $fuVmc.getCloudId)();
    const onClick = ()=>{
        setIsOpen(!isOpen);
    };
    const onClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2ONn.AtlassianSwitcherLoader), {
                product: $51949081c555f74b$var$APP_SWITCHER_PRODUCT,
                cloudId: cloudId
            }),
        isOpen: isOpen,
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cYtYv.default), {
                cloudId: cloudId,
                product: $51949081c555f74b$var$APP_SWITCHER_PRODUCT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jLgRn.AppSwitcher), {
                onClick: onClick,
                tooltip: "Switch to...",
                ...triggerProps
            }))
    });
};
var $51949081c555f74b$export$2e2bcd8739ae039 = $51949081c555f74b$var$AppSwitcherComponent;

});
parcelRegister("jLgRn", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $345f6da417b8e893$export$9923361bd43fa030);
/* app-switcher.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5niBv = parcelRequire("5niBv");

var $6X9z7 = parcelRequire("6X9z7");

var $fVqEt = parcelRequire("fVqEt");
const $345f6da417b8e893$var$iconSpacingStyles = {
    space050: "_1rjc1b66 _18zr1b66"
};
const $345f6da417b8e893$export$9923361bd43fa030 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fVqEt.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
            xcss: $345f6da417b8e893$var$iconSpacingStyles.space050,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5niBv))), {
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
            })
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});

});
parcelRegister("5niBv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::891f8b0b0e6811694a02696ff381b7b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e9d881730488831$var$_react = $3e9d881730488831$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3e9d881730488831$var$_iconNew = $3e9d881730488831$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3e9d881730488831$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app-switcher
 * Usage guidance:
 * Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e9d881730488831$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $3e9d881730488831$var$_react.default.createElement($3e9d881730488831$var$_iconNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$3e9d881730488831$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $3e9d881730488831$var$_default = module.exports.default = $3e9d881730488831$var$AppSwitcherIcon;

});


parcelRegister("j2ONn", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $af2983e247d83353$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadGenericSwitcher", () => $af2983e247d83353$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $af2983e247d83353$export$25f16f9fee84a840);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $af2983e247d83353$export$8c21d1a0c59fc17e);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $gdUUy = parcelRequire("gdUUy");

var $3AAMx = parcelRequire("3AAMx");

const $af2983e247d83353$export$6c6894dd831bfacb = ()=>(parcelRequire("c0fC0")).then((module)=>module.default);

const $af2983e247d83353$export$64191a36345a6b2b = ()=>(parcelRequire("f5Zf2")).then((module)=>module.default);

const $af2983e247d83353$var$AtlassianSwitcherLoaderLazyComponent = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("c0fC0")));
Object.assign($af2983e247d83353$var$AtlassianSwitcherLoaderLazyComponent, {
    displayName: 'lazy(AtlassianSwitcherLoader)'
});
const $af2983e247d83353$var$AtlassianSwitcherLoaderLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $af2983e247d83353$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3AAMx.default), null)
});
function $af2983e247d83353$var$AtlassianSwitcherLoaderWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3AAMx.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($af2983e247d83353$var$AtlassianSwitcherLoaderLazyComponent, props));
}
const $af2983e247d83353$export$25f16f9fee84a840 = (props)=>(0, $gdUUy.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($af2983e247d83353$var$AtlassianSwitcherLoaderWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($af2983e247d83353$var$AtlassianSwitcherLoaderLoadableComponent, props);

const $af2983e247d83353$var$GenericSwitcherLoaderLazyComponent = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("f5Zf2")));
Object.assign($af2983e247d83353$var$GenericSwitcherLoaderLazyComponent, {
    displayName: 'lazy(GenericSwitcherLoader)'
});
const $af2983e247d83353$var$GenericSwitcherLoaderLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $af2983e247d83353$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3AAMx.default), null)
});
function $af2983e247d83353$var$GenericSwitcherLoaderWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3AAMx.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($af2983e247d83353$var$GenericSwitcherLoaderLazyComponent, props));
}
const $af2983e247d83353$export$8c21d1a0c59fc17e = (props)=>(0, $gdUUy.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($af2983e247d83353$var$GenericSwitcherLoaderWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($af2983e247d83353$var$GenericSwitcherLoaderLoadableComponent, props);

});
parcelRegister("3AAMx", function(module, exports) {
$parcel$export(module.exports, "default", () => $db8efca091f3ae45$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9PwDt = parcelRequire("9PwDt");

var $io5WW = parcelRequire("io5WW");
var $1a5AI = parcelRequire("1a5AI");

var $6iAsS = parcelRequire("6iAsS");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $db8efca091f3ae45$var$iconSkeleton = /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $db8efca091f3ae45$var$lineSkeleton = /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $db8efca091f3ae45$export$2e2bcd8739ae039 = ()=>{
    (0, $1a5AI.useExperienceRenderAndMountMark)((0, $io5WW.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const items = /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        }
    }, $db8efca091f3ae45$var$iconSkeleton, $db8efca091f3ae45$var$lineSkeleton);
    return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $6iAsS.default).skeletonLoaderAriaLabel),
        testId: "skeleton"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        "aria-hidden": "true",
        style: {
            paddingInline: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-300, 24px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }
    }, $db8efca091f3ae45$var$lineSkeleton), items, items, items);
};

});
parcelRegister("io5WW", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $a3c4d72f25429391$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $a3c4d72f25429391$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $a3c4d72f25429391$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $a3c4d72f25429391$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $a3c4d72f25429391$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $a3c4d72f25429391$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $a3c4d72f25429391$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $a3c4d72f25429391$export$86919b84f9a64054);

var $7r7ey = parcelRequire("7r7ey");

var $466vm = parcelRequire("466vm");
var $a3c4d72f25429391$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $a3c4d72f25429391$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $7r7ey.ExperienceTypes).Load,
        performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $7r7ey.ExperienceTypes).Load,
        performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $7r7ey.ExperienceTypes).Load,
        performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $7r7ey.ExperienceTypes).Load,
        performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $a3c4d72f25429391$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $a3c4d72f25429391$var$allNonTestExperienceMarks = Object.values($a3c4d72f25429391$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $a3c4d72f25429391$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $a3c4d72f25429391$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $a3c4d72f25429391$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $a3c4d72f25429391$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $a3c4d72f25429391$var$allNonTestExperienceMarks
};
const $a3c4d72f25429391$export$805ed806e0769ee4 = (0, $466vm.invertRecordOfArrays)($a3c4d72f25429391$export$755e75afbd377bc4);
var $a3c4d72f25429391$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $a3c4d72f25429391$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $a3c4d72f25429391$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("466vm", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $03208d99b097e9d9$export$c371a74fe5222b3);
function $03208d99b097e9d9$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("1a5AI", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $f6a1e4f066f0122e$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $f6a1e4f066f0122e$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $bSJIT = parcelRequire("bSJIT");

var $6nyWb = parcelRequire("6nyWb");

var $4JSNs = parcelRequire("4JSNs");
function $f6a1e4f066f0122e$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $4JSNs.useExperienceTracker)();
    (0, $6nyWb.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $f6a1e4f066f0122e$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $4JSNs.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $bSJIT.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $f6a1e4f066f0122e$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $4JSNs.useExperienceTracker)();
    (0, $6nyWb.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $bSJIT.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("6nyWb", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $f2cb1a8fc7dcf345$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $f2cb1a8fc7dcf345$export$ad4f8d0eee7a0e24);

var $bSJIT = parcelRequire("bSJIT");
function $f2cb1a8fc7dcf345$export$abf4268d2dd55708(builder) {
    const ref = (0, $bSJIT.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $f2cb1a8fc7dcf345$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $bSJIT.useRef)(false);
    const result = (0, $bSJIT.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});

parcelRegister("4JSNs", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $c9ac42b172df3ede$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $c9ac42b172df3ede$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $c9ac42b172df3ede$export$f88dde183f4d31cb);

var $bSJIT = parcelRequire("bSJIT");
const $c9ac42b172df3ede$var$noop = ()=>{};
const $c9ac42b172df3ede$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $bSJIT.createContext)({
    start: $c9ac42b172df3ede$var$noop,
    success: $c9ac42b172df3ede$var$noop,
    failure: $c9ac42b172df3ede$var$noop,
    failureAll: $c9ac42b172df3ede$var$noop,
    abort: $c9ac42b172df3ede$var$noop,
    abortAll: $c9ac42b172df3ede$var$noop,
    markStart: $c9ac42b172df3ede$var$noop,
    markEnd: $c9ac42b172df3ede$var$noop
});
const $c9ac42b172df3ede$export$cdefb2a8b53f879f = ()=>(0, $bSJIT.useContext)($c9ac42b172df3ede$export$3f3eebb4b8116461);
const $c9ac42b172df3ede$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $c9ac42b172df3ede$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("6iAsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $04a31b91ff185b5d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $04a31b91ff185b5d$var$messages = (0, $f0Pt4.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    },
    showMoreSites: {
        id: 'fabric.atlassianSwitcher.showMoreSites',
        defaultMessage: 'Show more',
        description: 'The text of a button that reveals the remaining sites in an expanded switcher item site list'
    },
    showLessSites: {
        id: 'fabric.atlassianSwitcher.showLessSites',
        defaultMessage: 'Show less',
        description: 'The text of a button that collapses the expanded list of sites back to the first few in a switcher item'
    },
    unitDescriptionInfoButton: {
        id: 'fabric.atlassianSwitcher.unitDescriptionInfoButton',
        defaultMessage: 'About {unitName}',
        description: 'The accessible label of an info icon button that reveals a short administrator-written description of the named organisation unit'
    },
    pinOrgOrUnit: {
        id: 'fabric.atlassianSwitcher.pinOrgOrUnit',
        defaultMessage: 'Pin {name}',
        description: 'Accessible label and tooltip for the button that pins an organisation or unit to the top of the app switcher org list. {name} is the organisation or unit name.'
    },
    unpinOrgOrUnit: {
        id: 'fabric.atlassianSwitcher.unpinOrgOrUnit',
        defaultMessage: 'Unpin {name}',
        description: 'Accessible label and tooltip for the button that removes an organisation or unit from the pinned list in the app switcher. {name} is the organisation or unit name.'
    }
});
var $04a31b91ff185b5d$export$2e2bcd8739ae039 = $04a31b91ff185b5d$var$messages;

});


parcelRegister("c0fC0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("37oWQ"),
    $kOunM("dX1XS")
]).then(()=>parcelRequire('aOm2E'));

});

parcelRegister("f5Zf2", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("MILDc"),
    $kOunM("37oWQ"),
    $kOunM("e1RQb"),
    $kOunM("6qSv5"),
    $kOunM("7TPmF"),
    $kOunM("hhqCT"),
    $kOunM("7l9SC"),
    $kOunM("j9pBK"),
    $kOunM("jnLeB"),
    $kOunM("iZJsN"),
    $kOunM("3M7DB"),
    $kOunM("7bN6G"),
    $kOunM("kQ22Z")
]).then(()=>parcelRequire('40ngL'));

});


parcelRegister("cYtYv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4979933a2ef9aa20$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $cNIkg = parcelRequire("cNIkg");

var $1I1c1 = parcelRequire("1I1c1");
var $4i8UQ = parcelRequire("4i8UQ");
var $jK5t1 = parcelRequire("jK5t1");
var $kIbto = parcelRequire("kIbto");

var $1LdMe = parcelRequire("1LdMe");

var $jeMcE = parcelRequire("jeMcE");

var $ld9Qp = parcelRequire("ld9Qp");
const $4979933a2ef9aa20$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $4979933a2ef9aa20$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $4979933a2ef9aa20$var$TRIGGER_CONTEXT = {
    componentName: (0, $1I1c1.TRIGGER_COMPONENT),
    ...(0, $1LdMe.default)
};
class $4979933a2ef9aa20$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $jK5t1.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $1I1c1.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $1I1c1.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($cNIkg)))(()=>{
            (0, $ld9Qp.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $4979933a2ef9aa20$var$THROTTLE_EXPIRES, $4979933a2ef9aa20$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $jeMcE.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $jeMcE.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $4979933a2ef9aa20$var$PrefetchTriggerWithEvents = (0, $kIbto.default)()($4979933a2ef9aa20$var$PrefetchTrigger);
var $4979933a2ef9aa20$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4i8UQ.NavigationAnalyticsContext), {
        data: $4979933a2ef9aa20$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4979933a2ef9aa20$var$PrefetchTriggerWithEvents, props));

});
parcelRegister("1I1c1", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $c88b1ad1837e7eed$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $c88b1ad1837e7eed$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $c88b1ad1837e7eed$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $c88b1ad1837e7eed$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $c88b1ad1837e7eed$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $c88b1ad1837e7eed$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $c88b1ad1837e7eed$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $c88b1ad1837e7eed$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $c88b1ad1837e7eed$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $c88b1ad1837e7eed$export$22f5f827d9934254);
$parcel$export(module.exports, "analyticsAttributes", () => $c88b1ad1837e7eed$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $c88b1ad1837e7eed$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $c88b1ad1837e7eed$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $c88b1ad1837e7eed$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $c88b1ad1837e7eed$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $c88b1ad1837e7eed$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $c88b1ad1837e7eed$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("kIbto")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("4i8UQ")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("jK5t1")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("jK5t1")).UI_EVENT_TYPE);

var $bSJIT = parcelRequire("bSJIT");

var $jK5t1 = parcelRequire("jK5t1");

var $4i8UQ = parcelRequire("4i8UQ");

var $jeyHF = parcelRequire("jeyHF");

var $kIbto = parcelRequire("kIbto");

var $ba76z = parcelRequire("ba76z");

var $7tgOa = parcelRequire("7tgOa");

var $luuYj = parcelRequire("luuYj");
const $c88b1ad1837e7eed$export$515664faa1398f37 = 'navigation';
const $c88b1ad1837e7eed$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $c88b1ad1837e7eed$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $c88b1ad1837e7eed$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $c88b1ad1837e7eed$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $c88b1ad1837e7eed$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $c88b1ad1837e7eed$export$2b570fc112cbca = 'atlassianSwitcher';
const $c88b1ad1837e7eed$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $c88b1ad1837e7eed$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $c88b1ad1837e7eed$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $c88b1ad1837e7eed$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $c88b1ad1837e7eed$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $c88b1ad1837e7eed$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $c88b1ad1837e7eed$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $c88b1ad1837e7eed$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $c88b1ad1837e7eed$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $c88b1ad1837e7eed$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $c88b1ad1837e7eed$var$RENDERED_ACTION = 'rendered';
const $c88b1ad1837e7eed$var$NOT_RENDERED_ACTION = 'not_rendered';
const $c88b1ad1837e7eed$var$VIEWED_ACTION = 'viewed';
const $c88b1ad1837e7eed$export$884b1a4c7ac9dd14 = (0, $jeyHF.default)($c88b1ad1837e7eed$export$515664faa1398f37);
const $c88b1ad1837e7eed$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $c88b1ad1837e7eed$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4i8UQ.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
    };
};
const $c88b1ad1837e7eed$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $c88b1ad1837e7eed$export$e09ad93c2b74b853 = (0, $kIbto.default)({
    onRender: (createAnalyticsEvent, props)=>{
        var _props$data;
        const duration = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.duration;
        return createAnalyticsEvent({
            eventType: (0, $jK5t1.OPERATIONAL_EVENT_TYPE),
            action: $c88b1ad1837e7eed$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$c88b1ad1837e7eed$var$isValidDuration(duration) && {
                    bucket: (0, $luuYj.getMetricBucket)(duration, (0, $luuYj.RenderTrackerBuckets))
                }
            }
        }).fire($c88b1ad1837e7eed$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $c88b1ad1837e7eed$export$95b1f1a72cad0dcb = (0, $kIbto.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $jK5t1.OPERATIONAL_EVENT_TYPE),
            action: $c88b1ad1837e7eed$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($c88b1ad1837e7eed$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $c88b1ad1837e7eed$export$b3fd6624b6a6d057 = (0, $kIbto.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $jK5t1.UI_EVENT_TYPE),
            action: $c88b1ad1837e7eed$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($c88b1ad1837e7eed$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $c88b1ad1837e7eed$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c88b1ad1837e7eed$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c88b1ad1837e7eed$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $c88b1ad1837e7eed$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c88b1ad1837e7eed$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c88b1ad1837e7eed$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $c88b1ad1837e7eed$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $ba76z.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $c88b1ad1837e7eed$var$renderTracker({
        subject: $c88b1ad1837e7eed$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $c88b1ad1837e7eed$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if ((customLinksProviderResult === null || customLinksProviderResult === void 0 ? void 0 : customLinksProviderResult.status) === (0, $ba76z.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $7tgOa.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $c88b1ad1837e7eed$var$renderTrackerWithReason({
        subject: $c88b1ad1837e7eed$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $c88b1ad1837e7eed$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$c88b1ad1837e7eed$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("ba76z", function(module, exports) {
$parcel$export(module.exports, "Status", () => $024590d4260dee9f$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $024590d4260dee9f$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $024590d4260dee9f$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $024590d4260dee9f$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $024590d4260dee9f$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $024590d4260dee9f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");

var $1I1c1 = parcelRequire("1I1c1");
var $jK5t1 = parcelRequire("jK5t1");

var $jUHhU = parcelRequire("jUHhU");

var $4JSNs = parcelRequire("4JSNs");

var $2IKTa = parcelRequire("2IKTa");
const $024590d4260dee9f$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $024590d4260dee9f$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $024590d4260dee9f$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $024590d4260dee9f$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $024590d4260dee9f$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $024590d4260dee9f$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $024590d4260dee9f$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $024590d4260dee9f$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        static #_ = this.displayName = `DataProvider(${name})`;
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $2IKTa.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
                shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $jUHhU.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$024590d4260dee9f$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $jUHhU.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $jK5t1.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $024590d4260dee9f$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $1I1c1.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $kIbto.default)()((0, $4JSNs.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}

});
parcelRegister("jUHhU", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $377440ceb3ee9c81$export$a3e288208721751b);
function $377440ceb3ee9c81$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("2IKTa", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $f543f1ae6e68915d$export$1d94629c94e7a17f);
const $f543f1ae6e68915d$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $f543f1ae6e68915d$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $f543f1ae6e68915d$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});


parcelRegister("7tgOa", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $6c9d9c4318301f4a$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $6c9d9c4318301f4a$export$c460344055e97b1);
var $6c9d9c4318301f4a$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $6c9d9c4318301f4a$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("luuYj", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $960c8d3661f0d7d3$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $960c8d3661f0d7d3$export$b59492d26971ae92);
const $960c8d3661f0d7d3$var$INFINITY = '+Inf';
const $960c8d3661f0d7d3$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $960c8d3661f0d7d3$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $960c8d3661f0d7d3$var$INFINITY) : null;
};

});


parcelRegister("1LdMe", function(module, exports) {
$parcel$export(module.exports, "default", () => $598b60b39f221c86$export$2e2bcd8739ae039);
const $598b60b39f221c86$var$packageName = undefined;
const $598b60b39f221c86$var$packageVersion = undefined;
const $598b60b39f221c86$var$_default_1 = {
    packageName: $598b60b39f221c86$var$packageName,
    packageVersion: $598b60b39f221c86$var$packageVersion
};
var $598b60b39f221c86$export$2e2bcd8739ae039 = $598b60b39f221c86$var$_default_1;

});

parcelRegister("jeMcE", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $a44f1492eeb9a69b$export$fb4230f160368c88);
const $a44f1492eeb9a69b$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});

parcelRegister("ld9Qp", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $f50d0ee1f9c1a923$export$aba5d6cf034db22e);

var $cPeEM = parcelRequire("cPeEM");

var $832mV = parcelRequire("832mV");

var $1ffje = parcelRequire("1ffje");

var $3sWcr = parcelRequire("3sWcr");

var $hj6UX = parcelRequire("hj6UX");
const $f50d0ee1f9c1a923$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $3sWcr.default)();
    (0, $cPeEM.prefetchFlightDeck)({});
    (0, $832mV.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $1ffje.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $hj6UX.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("cPeEM", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $2ff2ff29b658654a$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $2ff2ff29b658654a$export$7d2a567d3e50224);

var $bSJIT = parcelRequire("bSJIT");

var $icl5R = parcelRequire("icl5R");

var $9hihM = parcelRequire("9hihM");

var $caVRq = parcelRequire("caVRq");

var $io5WW = parcelRequire("io5WW");

var $lpIOt = parcelRequire("lpIOt");

var $cel3W = parcelRequire("cel3W");

var $9Xotx = parcelRequire("9Xotx");
const $2ff2ff29b658654a$var$client = new (0, $icl5R.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $2ff2ff29b658654a$var$fetchFlightDeck, ProviderComponent: $2ff2ff29b658654a$var$DefaultFlightDeckProviderComponent } = (0, $cel3W.createProviderWithCustomFetchData)('flightDeck', (0, $io5WW.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $2ff2ff29b658654a$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $9hihM.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $2ff2ff29b658654a$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $2ff2ff29b658654a$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $9Xotx.formatLabel)(displayName),
            description: (0, $9Xotx.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $caVRq.ASSETS_APP_KEY))) artifactMap.set((0, $caVRq.ASSETS_APP_KEY), {
            key: (0, $caVRq.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            // make sure assets is below jsm
            label: (0, $9Xotx.formatLabel)((0, $lpIOt.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $9Xotx.formatLabel)(link.displayName),
                    description: (0, $9Xotx.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $2ff2ff29b658654a$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2ff2ff29b658654a$var$DefaultFlightDeckProviderComponent, null, children);
const $2ff2ff29b658654a$export$7d2a567d3e50224 = $2ff2ff29b658654a$var$fetchFlightDeck;

});
parcelRegister("icl5R", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3f9b5bcd07bbdb1$export$2e2bcd8739ae039);

var $98nNe = parcelRequire("98nNe");

var $6KyDy = parcelRequire("6KyDy");
parcelRequire("kloza");
var $hYVMR = parcelRequire("hYVMR");

var $kyXbx = parcelRequire("kyXbx");
var $6VKax = parcelRequire("6VKax");

var $1HWLJ = parcelRequire("1HWLJ");

var $41JJn = parcelRequire("41JJn");

var $bIdwi = parcelRequire("bIdwi");
function $d3f9b5bcd07bbdb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3f9b5bcd07bbdb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3f9b5bcd07bbdb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $98nNe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3f9b5bcd07bbdb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d3f9b5bcd07bbdb1$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $d3f9b5bcd07bbdb1$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $d3f9b5bcd07bbdb1$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $98nNe.default)(this, "fallbackArtifactMap", new Map());
        (0, $98nNe.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $hYVMR.StorageClient)($d3f9b5bcd07bbdb1$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $41JJn.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $6KyDy.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $kyXbx.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $1HWLJ.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$d3f9b5bcd07bbdb1$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $bIdwi.flightDeckClientExperience)() : new (0, $6VKax.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $d3f9b5bcd07bbdb1$var$_objectSpread($d3f9b5bcd07bbdb1$var$_objectSpread({}, artifact), {}, {
                key: (0, $41JJn.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $bIdwi.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("6KyDy", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $397eb44c17bb7e99$export$1d94629c94e7a17f);

var $9QWzk = parcelRequire("9QWzk");

var $bMqaZ = parcelRequire("bMqaZ");

var $7xUyO = parcelRequire("7xUyO");

var $k7rA1 = parcelRequire("k7rA1");
const $397eb44c17bb7e99$var$NO_CALLS_ERROR = 'No calls made';
const $397eb44c17bb7e99$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $bMqaZ.NO_RETRIES), retryOn: retryOn = [
    (0, $7xUyO.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($397eb44c17bb7e99$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await (0, $k7rA1.wait)(nextMSInterval);
        if (onRetry && error.message !== $397eb44c17bb7e99$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $9QWzk.convertToError)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("9QWzk", function(module, exports) {
$parcel$export(module.exports, "convertToError", () => $c8b7244901e389fd$export$70fb45ead8febbe5);
const $c8b7244901e389fd$export$70fb45ead8febbe5 = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};

});

parcelRegister("bMqaZ", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $150d2ae6f7d4d07e$export$a0a1c8f90becc136);
const $150d2ae6f7d4d07e$export$a0a1c8f90becc136 = [];
const $150d2ae6f7d4d07e$export$972171517b12aa4 = [
    0,
    0
];
const $150d2ae6f7d4d07e$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $150d2ae6f7d4d07e$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("7xUyO", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => $1a0c9c9f319edb66$export$558a29265b4c0def);
$parcel$export(module.exports, "default", () => $1a0c9c9f319edb66$export$2e2bcd8739ae039);
class $1a0c9c9f319edb66$export$558a29265b4c0def extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
var $1a0c9c9f319edb66$export$2e2bcd8739ae039 = $1a0c9c9f319edb66$export$558a29265b4c0def;

});

parcelRegister("k7rA1", function(module, exports) {
$parcel$export(module.exports, "wait", () => $95d35be4fad6367e$export$5c069c93d2b7493f);
const $95d35be4fad6367e$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });

});


parcelRegister("kloza", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("hYVMR")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $hYVMR = parcelRequire("hYVMR");

var $328dd2c86e694feb$export$2e2bcd8739ae039 = (0, $hYVMR.StorageClient);

});
parcelRegister("hYVMR", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => $fad21c7c0e5e9273$export$6c85f5032e75eff9);

var $kk2ZX = parcelRequire("kk2ZX");

var $3ZUyj = parcelRequire("3ZUyj");
class $fad21c7c0e5e9273$export$6c85f5032e75eff9 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        const storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || (0, $3ZUyj.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $kk2ZX.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        var _this$handlers;
        if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("kk2ZX", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $180e28dd973c7490$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $180e28dd973c7490$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $180e28dd973c7490$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$180e28dd973c7490$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});

parcelRegister("3ZUyj", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_STORAGE_ENGINE", () => $efadd22d7aa5e30c$export$3364800d9d60baf9);
const $efadd22d7aa5e30c$export$3364800d9d60baf9 = 'localStorage';

});



parcelRegister("kyXbx", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $ef84e48b37a1bd11$export$6026918e023c9101);

var $dWbV2 = parcelRequire("dWbV2");

var $1LsJz = parcelRequire("1LsJz");

var $8lehz = parcelRequire("8lehz");

var $dZ8Zs = parcelRequire("dZ8Zs");

var $1PJBL = parcelRequire("1PJBL");

var $6VKax = parcelRequire("6VKax");

var $dfaDd = parcelRequire("dfaDd");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $ef84e48b37a1bd11$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $ef84e48b37a1bd11$var$defaultPerimeter = "commercial";
async function $ef84e48b37a1bd11$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $ef84e48b37a1bd11$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $ef84e48b37a1bd11$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $ef84e48b37a1bd11$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $dWbV2.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $ef84e48b37a1bd11$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $ef84e48b37a1bd11$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $ef84e48b37a1bd11$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $ef84e48b37a1bd11$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $ef84e48b37a1bd11$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $ef84e48b37a1bd11$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $6VKax.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $6VKax.getVersionMetadataFetchExperience)();
    return new (0, $1PJBL.ConfigClient)(new (0, $8lehz.BifrostDataSource)(new (0, $dZ8Zs.BifrostHttpClientImpl)(env, perimeter), (0, $1LsJz.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $ef84e48b37a1bd11$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("dWbV2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a38145dfb520b42$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $9a38145dfb520b42$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $9a38145dfb520b42$export$2e2bcd8739ae039 = $9a38145dfb520b42$export$852ff24d0930c62f;

});

parcelRegister("1LsJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $iGsgP = parcelRequire("iGsgP");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $iGsgP.Either;
    }
});

var $a0XLL = parcelRequire("a0XLL");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $a0XLL.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $a0XLL.tryGetArtifactData;
    }
});

var $e0Yqs = parcelRequire("e0Yqs");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $e0Yqs.parseArtifactManifest;
    }
});

var $2i7wj = parcelRequire("2i7wj");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $2i7wj.parseVersionMetadata;
    }
});

var $9XBQe = parcelRequire("9XBQe");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $9XBQe.checkManifest;
    }
});

var $4mKkC = parcelRequire("4mKkC");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $4mKkC.ConfigRegistryDataSource;
    }
});

var $c4CdV = parcelRequire("c4CdV");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $c4CdV.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $c4CdV.Versions;
    }
});

});
parcelRegister("iGsgP", function(module, exports) {
"use strict";
var $d9a214283e48e444$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $d9a214283e48e444$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $d9a214283e48e444$var$Right(value);
    };
    Either.left = function(error) {
        return new $d9a214283e48e444$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $d9a214283e48e444$var$Either;
var $d9a214283e48e444$var$Right = /** @class */ function(_super) {
    $d9a214283e48e444$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $d9a214283e48e444$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $d9a214283e48e444$var$Either.right(this.right);
    };
    return Right;
}($d9a214283e48e444$var$Either);
var $d9a214283e48e444$var$Left = /** @class */ function(_super) {
    $d9a214283e48e444$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $d9a214283e48e444$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $d9a214283e48e444$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $d9a214283e48e444$var$Either.left(f(this.left));
    };
    return Left;
}($d9a214283e48e444$var$Either);

});

parcelRegister("a0XLL", function(module, exports) {
"use strict";
var $74a8446801667be5$var$__assign = module.exports && module.exports.__assign || function() {
    $74a8446801667be5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74a8446801667be5$var$__assign.apply(this, arguments);
};
var $74a8446801667be5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $74a8446801667be5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $74a8446801667be5$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $74a8446801667be5$var$tryGetArtifactData;

var $5E02g = parcelRequire("5E02g");

var $1LsJz = parcelRequire("1LsJz");

var $dTUvp = parcelRequire("dTUvp");

var $8SeiG = parcelRequire("8SeiG");

var $2zypc = parcelRequire("2zypc");
function $74a8446801667be5$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $74a8446801667be5$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $74a8446801667be5$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $74a8446801667be5$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $74a8446801667be5$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $1LsJz.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $dTUvp.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $74a8446801667be5$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $8SeiG.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $74a8446801667be5$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $74a8446801667be5$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $74a8446801667be5$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $5E02g.interpolateTagScheme)(manifest.tagScheme, $74a8446801667be5$var$__assign($74a8446801667be5$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $74a8446801667be5$var$__awaiter(_this, void 0, void 0, function() {
                                return $74a8446801667be5$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $74a8446801667be5$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $2zypc.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $2zypc.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $8SeiG.assertUnreachable)(artifact);
    }
}

});
parcelRegister("5E02g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $41c0b73481978511$var$interpolateTagScheme;
module.exports.generateTagScheme = $41c0b73481978511$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $41c0b73481978511$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $41c0b73481978511$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $41c0b73481978511$var$getVersionMetadataTag;
const $41c0b73481978511$var$TAG_SCHEME_VERSION = 2;
function $41c0b73481978511$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($41c0b73481978511$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $41c0b73481978511$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $41c0b73481978511$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $41c0b73481978511$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $41c0b73481978511$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $41c0b73481978511$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $41c0b73481978511$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $41c0b73481978511$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("dTUvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $a1ec3e40a38fc5ce$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $a1ec3e40a38fc5ce$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("8SeiG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $675e759d9f0d2662$var$assertUnreachable;
function $675e759d9f0d2662$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("2zypc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $1df989dec17ec6ce$var$toJson;
module.exports.toPrettyJson = $1df989dec17ec6ce$var$toPrettyJson;
function $1df989dec17ec6ce$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $1df989dec17ec6ce$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("e0Yqs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $a33ff00f97811d15$var$parseArtifactManifest;

var $iCJre = parcelRequire("iCJre");
function $a33ff00f97811d15$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $iCJre.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $iCJre.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $a33ff00f97811d15$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $iCJre.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $a33ff00f97811d15$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $a33ff00f97811d15$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $iCJre.parseUnknownObject)(dimensions);
    var supported = (0, $iCJre.parseArray)(unparsedDimensions.supported).map($iCJre.parseString);
    var fallback = (0, $iCJre.parseUndefinedOr)($iCJre.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $a33ff00f97811d15$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $iCJre.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $a33ff00f97811d15$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $a33ff00f97811d15$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $iCJre.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $iCJre.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $iCJre.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $iCJre.parseUndefinedOr)($iCJre.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $a33ff00f97811d15$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $a33ff00f97811d15$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("iCJre", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $d8ef05ab0c5de12d$var$parseString;
module.exports.parseArray = $d8ef05ab0c5de12d$var$parseArray;
module.exports.parseBoolean = $d8ef05ab0c5de12d$var$parseBoolean;
module.exports.parseUnknownObject = $d8ef05ab0c5de12d$var$parseUnknownObject;
module.exports.parseUndefinedOr = $d8ef05ab0c5de12d$var$parseUndefinedOr;
function $d8ef05ab0c5de12d$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $d8ef05ab0c5de12d$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $d8ef05ab0c5de12d$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $d8ef05ab0c5de12d$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $d8ef05ab0c5de12d$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("2i7wj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $1ab3188e74a1d68a$var$parseVersionMetadata;

var $iCJre = parcelRequire("iCJre");
function $1ab3188e74a1d68a$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $iCJre.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $iCJre.parseString)(unknownObject.version);
    var publishTime = new Date((0, $iCJre.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $iCJre.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("9XBQe", function(module, exports) {
"use strict";
var $7406fa3eb245e3e2$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $7406fa3eb245e3e2$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $7406fa3eb245e3e2$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $7406fa3eb245e3e2$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("4mKkC", function(module, exports) {
"use strict";
var $32dd27fdadf500b7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $32dd27fdadf500b7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $5E02g = parcelRequire("5E02g");

var $iGsgP = parcelRequire("iGsgP");

var $e0Yqs = parcelRequire("e0Yqs");

var $2i7wj = parcelRequire("2i7wj");
var $32dd27fdadf500b7$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $32dd27fdadf500b7$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $32dd27fdadf500b7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $5E02g.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($e0Yqs.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $iGsgP.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $32dd27fdadf500b7$var$__awaiter(this, void 0, void 0, function() {
            return $32dd27fdadf500b7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $32dd27fdadf500b7$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $32dd27fdadf500b7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $5E02g.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $2i7wj.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $32dd27fdadf500b7$var$ConfigRegistryDataSource;

});

parcelRegister("c4CdV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $8ca3822a5c4dcd63$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $8ca3822a5c4dcd63$var$BaseUrls;
var $8ca3822a5c4dcd63$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $8ca3822a5c4dcd63$var$Versions;

});


parcelRegister("8lehz", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $612b5d1359cdcd8d$export$2cb8d79200775058);

var $1LsJz = parcelRequire("1LsJz");

var $5E02g = parcelRequire("5E02g");
class $612b5d1359cdcd8d$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $5E02g.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $1LsJz.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $1LsJz.parseVersionMetadata)(response);
                return (0, $1LsJz.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $1LsJz.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $5E02g.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $1LsJz.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $1LsJz.parseArtifactManifest)(response);
                return (0, $1LsJz.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $1LsJz.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("dZ8Zs", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $a2e7f21f9957008e$export$45c6d12ca9c14f83);

var $1LsJz = parcelRequire("1LsJz");
function $a2e7f21f9957008e$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $a2e7f21f9957008e$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $a2e7f21f9957008e$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $1LsJz.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $1LsJz.Either).right(json)));
            }).catch((error)=>resolve((0, $1LsJz.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("1PJBL", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $155deea8b7f14637$export$8489e2f039bfcc4c);

var $98nNe = parcelRequire("98nNe");

var $1LsJz = parcelRequire("1LsJz");

var $8rZMD = parcelRequire("8rZMD");
function $155deea8b7f14637$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $155deea8b7f14637$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $155deea8b7f14637$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $98nNe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $155deea8b7f14637$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $155deea8b7f14637$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $8rZMD.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $155deea8b7f14637$var$_objectSpread($155deea8b7f14637$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $1LsJz.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $1LsJz.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("8rZMD", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $6270c544512fe077$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $6270c544512fe077$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("6VKax", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $50bbe11fee871bbe$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $50bbe11fee871bbe$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $50bbe11fee871bbe$export$c3ac7702bfd47c1b);
const $50bbe11fee871bbe$var$SAMPLING_RATE = 10;
class $50bbe11fee871bbe$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $50bbe11fee871bbe$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $50bbe11fee871bbe$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $50bbe11fee871bbe$var$SAMPLING_RATE) return new $50bbe11fee871bbe$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("ehlcb"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $50bbe11fee871bbe$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $50bbe11fee871bbe$export$5e7536cf7bc56fee();
    }
}
const $50bbe11fee871bbe$export$a3006f8f221c0a3b = ()=>$50bbe11fee871bbe$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $50bbe11fee871bbe$export$c3ac7702bfd47c1b = ()=>$50bbe11fee871bbe$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("ehlcb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iv5aj").then(()=>parcelRequire('fEdiD'));

});


parcelRegister("dfaDd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $7EOKt = parcelRequire("7EOKt");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $7EOKt.parseConfigWithTargeting;
    }
});

var $gY3VX = parcelRequire("gY3VX");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $gY3VX.TargetedConfig;
    }
});

});
parcelRegister("7EOKt", function(module, exports) {
"use strict";
var $5933a273b1b234d8$var$__assign = module.exports && module.exports.__assign || function() {
    $5933a273b1b234d8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5933a273b1b234d8$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $5933a273b1b234d8$var$parseConfigWithTargeting;

var $gY3VX = parcelRequire("gY3VX");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $5933a273b1b234d8$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $5933a273b1b234d8$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $gY3VX.TargetedConfig({
                defaultConfig: $5933a273b1b234d8$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $5933a273b1b234d8$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $gY3VX.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $5933a273b1b234d8$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $5933a273b1b234d8$var$__assign($5933a273b1b234d8$var$__assign({}, accObject), (_a = {}, _a[key] = $5933a273b1b234d8$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $5933a273b1b234d8$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $5933a273b1b234d8$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $5933a273b1b234d8$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $5933a273b1b234d8$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $5933a273b1b234d8$var$parseIdentifierList(target.orgIds),
            siteIds: $5933a273b1b234d8$var$parseIdentifierList(target.siteIds),
            userIds: $5933a273b1b234d8$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $5933a273b1b234d8$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("gY3VX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $c5a54d194319389e$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $c5a54d194319389e$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $c5a54d194319389e$var$TargetedConfig;
function $c5a54d194319389e$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("1HWLJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $13e764e09082f852$export$2e2bcd8739ae039);
class $13e764e09082f852$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $13e764e09082f852$export$1d76d155060824c9 = (e)=>e instanceof $13e764e09082f852$export$2e2bcd8739ae039;

});

parcelRegister("41JJn", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $2eeabaa242f191f2$export$e3553dc63541d477);
const $2eeabaa242f191f2$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("bIdwi", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $886e4a85ef08260b$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $886e4a85ef08260b$export$f33622abb5224195);

var $98nNe = parcelRequire("98nNe");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
function $886e4a85ef08260b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $886e4a85ef08260b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $886e4a85ef08260b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $98nNe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $886e4a85ef08260b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $886e4a85ef08260b$export$1e3a41a51f6457c5 = ()=>new (0, $1we90.UFOExperience)("retrieve-artifact", {
        type: (0, $7r7ey.ExperienceTypes).Operation,
        performanceType: (0, $7r7ey.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $886e4a85ef08260b$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $886e4a85ef08260b$var$_objectSpread($886e4a85ef08260b$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("caVRq", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $bfb2fd900eb011bf$export$45e63649edff1e2a);
$parcel$export(module.exports, "TENANTLESS_ORG_ID", () => $bfb2fd900eb011bf$export$eb7589a4ee50c678);
const $bfb2fd900eb011bf$export$45e63649edff1e2a = 'ASSETS';
const $bfb2fd900eb011bf$export$eb7589a4ee50c678 = 'tenantless';

});

parcelRegister("lpIOt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3df6cfc55acdaae9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $3df6cfc55acdaae9$var$messages = (0, $f0Pt4.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    rovo: {
        id: 'fabric.atlassianSwitcher.rovo-home',
        defaultMessage: 'Rovo Home',
        description: 'The text of a link redirecting the user to the rovo home site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    artifacts: {
        id: 'fabric.atlassianSwitcher.artifacts',
        defaultMessage: 'Artifacts',
        description: 'The text of a link redirecting the user to Artifacts'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    insights: {
        id: 'fabric.atlassianSwitcher.insights',
        defaultMessage: 'Insights',
        description: 'The text of a link redirecting the user to Insights'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    rovoSearch: {
        id: 'fabric.atlassianSwitcher.rovo-search',
        defaultMessage: 'Rovo Search',
        description: 'The text of a link redirecting the user to Rovo Search app'
    },
    rovoChat: {
        id: 'fabric.atlassianSwitcher.rovo-chat',
        defaultMessage: 'Rovo Chat',
        description: 'The text of a link redirecting the user to the Rovo Chat app'
    },
    rovoStudio: {
        id: 'fabric.atlassianSwitcher.rovo-studio',
        defaultMessage: 'Rovo Studio',
        description: 'The text of a link redirecting the user to Rovo Studio app'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} more',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    customLinksSectionTitle: {
        id: 'fabric.atlassianSwitcher.customLinksSectionTitle',
        defaultMessage: 'Custom links',
        description: 'Title of the collapsible custom links section in the App Switcher, shown on the section header.'
    },
    thirdPartySectionTitle: {
        id: 'fabric.atlassianSwitcher.thirdPartySectionTitle',
        defaultMessage: 'Integrations',
        description: 'Title of the collapsible third-party apps section in the App Switcher, shown on the section header.'
    },
    sitesSectionLabel: {
        id: 'fabric.atlassianSwitcher.sitesSectionLabel',
        defaultMessage: 'Sites',
        description: 'Label shown above the list of connected sites for a product in the App Switcher, when the product is available on more than one site.'
    }
});
var $3df6cfc55acdaae9$export$2e2bcd8739ae039 = $3df6cfc55acdaae9$var$messages;

});

parcelRegister("cel3W", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $2201bd8ebd96f687$export$310e48be95687c2f);

var $f5Zin = parcelRequire("f5Zin");

var $6E57h = parcelRequire("6E57h");

var $ba76z = parcelRequire("ba76z");
const $2201bd8ebd96f687$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $6E57h.withCached)((param)=>(0, $f5Zin.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $ba76z.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $2201bd8ebd96f687$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig, shouldUpdate)=>{
    const fetchMethod = (0, $6E57h.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $ba76z.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig, shouldUpdate)
    };
};

});
parcelRegister("f5Zin", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $9b21318016ec34be$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $9b21318016ec34be$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $9b21318016ec34be$export$c776284ef4b1209a);

var $1LdMe = parcelRequire("1LdMe");

var $iugfz = parcelRequire("iugfz");

var $2IKTa = parcelRequire("2IKTa");
const $9b21318016ec34be$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $iugfz.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $9b21318016ec34be$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $1LdMe.default).packageVersion,
            ...init === null || init === void 0 ? void 0 : init.headers
        }
    }).then(!emptyResponse ? $9b21318016ec34be$var$extraJsonFromResponse : ()=>{});
const $9b21318016ec34be$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $2IKTa.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $1LdMe.default).packageVersion,
                ...init === null || init === void 0 ? void 0 : init.headers
            }
        }), retryConfig).then($9b21318016ec34be$var$extraJsonFromResponse);
};
const $9b21318016ec34be$export$c776284ef4b1209a = (url, data, emptyResponse)=>$9b21318016ec34be$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("iugfz", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $f01b8134728734c5$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $f01b8134728734c5$export$26e841bcf1aeb894);
const $f01b8134728734c5$export$83179404a61b001a = 'FetchError';
class $f01b8134728734c5$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $f01b8134728734c5$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $f01b8134728734c5$export$26e841bcf1aeb894;
    }
}

});


parcelRegister("6E57h", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $b4712e22ead94a8d$export$7f51828d6b6af163);
const $b4712e22ead94a8d$export$d4d4b402ab64e2f4 = 5000;
const $b4712e22ead94a8d$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $b4712e22ead94a8d$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($b4712e22ead94a8d$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $b4712e22ead94a8d$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("9Xotx", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $884786f855b139e9$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $884786f855b139e9$export$f731e929548061dc);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
const $884786f855b139e9$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), label);
};
const $884786f855b139e9$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), description) : null;
};

});


parcelRegister("832mV", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $4ef94514e708efa5$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $4ef94514e708efa5$export$1c5684a3ba697d80);

var $bSJIT = parcelRequire("bSJIT");

var $7ryrL = parcelRequire("7ryrL");
const { fetchMethod: $4ef94514e708efa5$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $4ef94514e708efa5$var$DefaultBffDataProviderComponent } = (0, $7ryrL.createAppSwitcherBffAvailableProductsProvider)();
const $4ef94514e708efa5$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4ef94514e708efa5$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
const $4ef94514e708efa5$export$1c5684a3ba697d80 = $4ef94514e708efa5$var$fetchAppSwitcherBffAvailableProducts;
const $4ef94514e708efa5$export$cd9fc41c59711bdd = ()=>$4ef94514e708efa5$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("7ryrL", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $d43e61d0713e4207$export$7fd9c7ae7afb494c);

var $io5WW = parcelRequire("io5WW");

var $f5Zin = parcelRequire("f5Zin");

var $cel3W = parcelRequire("cel3W");
const $d43e61d0713e4207$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $d43e61d0713e4207$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $f5Zin.fetchJsonWithNetworkRetries)(`${$d43e61d0713e4207$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $d43e61d0713e4207$export$7fd9c7ae7afb494c = ()=>{
    return (0, $cel3W.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $io5WW.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $d43e61d0713e4207$export$1096efb00c5f8afc);
};

});


parcelRegister("1ffje", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $cd2b9d64ed6d00df$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $cd2b9d64ed6d00df$export$ba83558707df5bbe);

var $bSJIT = parcelRequire("bSJIT");

var $jdVYH = parcelRequire("jdVYH");
const { fetchMethod: $cd2b9d64ed6d00df$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $cd2b9d64ed6d00df$var$DefaultBffThirdPartyProductsDataProvider } = (0, $jdVYH.createAppSwitcherBffThirdPartyProductsProvider)();
const $cd2b9d64ed6d00df$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cd2b9d64ed6d00df$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product
    }, children);
const $cd2b9d64ed6d00df$export$ba83558707df5bbe = $cd2b9d64ed6d00df$var$fetchAppSwitcherBffThirdPartyProducts;
const $cd2b9d64ed6d00df$export$fdb5fe543e39bc7a = ()=>$cd2b9d64ed6d00df$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("jdVYH", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $5434ea4cfe44b25f$export$1a41882ddb3a9c38);

var $io5WW = parcelRequire("io5WW");

var $f5Zin = parcelRequire("f5Zin");

var $cel3W = parcelRequire("cel3W");
const $5434ea4cfe44b25f$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $5434ea4cfe44b25f$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $f5Zin.fetchJsonWithNetworkRetries)(`${$5434ea4cfe44b25f$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $5434ea4cfe44b25f$export$1a41882ddb3a9c38 = ()=>{
    return (0, $cel3W.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $io5WW.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $5434ea4cfe44b25f$export$c39ca0fbc2221bcc);
};

});


parcelRegister("3sWcr", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd526599ba79cf33$export$2e2bcd8739ae039);

var $j2ONn = parcelRequire("j2ONn");
var $cd526599ba79cf33$export$2e2bcd8739ae039 = ()=>{
    (0, $j2ONn.loadAtlassianSwitcher)();
    return (0, $j2ONn.loadGenericSwitcher)();
};

});

parcelRegister("hj6UX", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $eedc577df73b90fd$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $eedc577df73b90fd$export$2aed3ef1595b4d9);

var $bSJIT = parcelRequire("bSJIT");

var $9ljjk = parcelRequire("9ljjk");
const { fetchMethod: $eedc577df73b90fd$var$fetchJoinableSites, ProviderComponent: $eedc577df73b90fd$var$DefaultDataProviderComponent } = (0, $9ljjk.createJoinableSitesProvider)();
const $eedc577df73b90fd$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $eedc577df73b90fd$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
const $eedc577df73b90fd$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $eedc577df73b90fd$var$fetchJoinableSites({});
};
const $eedc577df73b90fd$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $eedc577df73b90fd$var$fetchJoinableSites.reset();
};

});
parcelRegister("9ljjk", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $341b5dff1c663fa8$export$c3b6af53f1ca17d8);

var $cel3W = parcelRequire("cel3W");

var $io5WW = parcelRequire("io5WW");
const $341b5dff1c663fa8$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $341b5dff1c663fa8$export$c3b6af53f1ca17d8 = (fetchData = $341b5dff1c663fa8$export$62986affcccd56a5, retryConfig)=>{
    return (0, $cel3W.createProviderWithCustomFetchData)('joinableSites', (0, $io5WW.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});








parcelRegister("375jI", function(module, exports) {
$parcel$export(module.exports, "Sidebar", () => (parcelRequire("fqS4Y")).default);

var $fqS4Y = parcelRequire("fqS4Y");

});
parcelRegister("fqS4Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $536b635893597265$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $bKqvx = parcelRequire("bKqvx");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $6WltM = parcelRequire("6WltM");

var $2usNr = parcelRequire("2usNr");

var $95wII = parcelRequire("95wII");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $8k1Kr = parcelRequire("8k1Kr");

var $kM5FK = parcelRequire("kM5FK");

var $jruED = parcelRequire("jruED");

var $gF810 = parcelRequire("gF810");

var $5kMFi = parcelRequire("5kMFi");

var $2TZ5X = parcelRequire("2TZ5X");

var $f78I8 = parcelRequire("f78I8");

var $haAAx = parcelRequire("haAAx");

var $4g0P3 = parcelRequire("4g0P3");

var $e4wrJ = parcelRequire("e4wrJ");
parcelRequire("9oCe4");
var $9wCU9 = parcelRequire("9wCU9");
parcelRequire("lzRo0");
var $4Vljv = parcelRequire("4Vljv");
const $536b635893597265$var$Sidebar = ({ width: width, navigationContentItems: navigationContentItems, featureName: featureName })=>{
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const helpCenterMessages = (0, $4g0P3.useHelpCenterMessageDictionary)();
    const onBackButtonClick = (0, $bSJIT.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'click',
            actionSubjectId: `SidebarBackButton`
        }).fire();
        push(helpCenterMessages.backButtonHref);
    }, [
        createAnalyticsEvent,
        push,
        helpCenterMessages.backButtonHref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $95wII.default), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $536b635893597265$var$sidebarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5kMFi.SideNavigation), {
        label: formatMessage((0, $e4wrJ.default).sidebarNavigationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4Vljv.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2TZ5X.NavigationHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9wCU9.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8k1Kr.GoBackItem), {
        onClick: onBackButtonClick
    }, formatMessage(helpCenterMessages.backButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f78I8.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jruED.HeadingItem), null, formatMessage(helpCenterMessages.settingsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gF810.Section), {
        isList: true
    }, navigationContentItems.map(({ onClick: onClick, iconBefore: iconBefore, text: text, isSelected: isSelected, isVisible: isVisible })=>{
        const renderButtonItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kM5FK.ButtonItem), {
                onClick: onClick,
                iconBefore: iconBefore,
                key: text,
                isSelected: isSelected
            }, text);
        return isVisible && renderButtonItem();
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $536b635893597265$var$navFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f78I8.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gF810.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bKqvx.default), {
        showIcon: true,
        showTypeField: true,
        featureName: featureName,
        buttonLabel: (0, $e4wrJ.default).feedbackWidget,
        analyticsSubjectId: "SidebarFeedbackButton",
        useSideNavButton: true
    }))))))));
};
const $536b635893597265$var$navFooter = (0, $9BVpB.xcss)({
    position: 'relative'
});
const $536b635893597265$var$sidebarContainerStyles = (0, $9BVpB.xcss)({
    width: '100%',
    height: '100%',
    borderRightWidth: 'border.width',
    borderRightStyle: 'solid',
    borderColor: 'color.border',
    boxSizing: 'inherit'
});
var $536b635893597265$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'SideBar'
})($536b635893597265$var$Sidebar);

});
parcelRegister("95wII", function(module, exports) {
$parcel$export(module.exports, "default", () => $51d435aeee502a21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $1qxfZ = parcelRequire("1qxfZ");

var $62mys = parcelRequire("62mys");

var $iPBU6 = parcelRequire("iPBU6");
var $gG3J7 = parcelRequire("gG3J7");

var $b1C2u = parcelRequire("b1C2u");

var $1VvUa = parcelRequire("1VvUa");

var $hY84w = parcelRequire("hY84w");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $51d435aeee502a21$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $62mys.resolveDimension)((0, $1qxfZ.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $bSJIT.useEffect)(()=>{
        (0, $iPBU6.default)({
            [(0, $1qxfZ.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $iPBU6.default)({
                [(0, $1qxfZ.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $gG3J7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $1VvUa.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hY84w.default), {
        variableName: (0, $1qxfZ.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $b1C2u.default), {
        isFixed: isFixed
    }, children));
};
var $51d435aeee502a21$export$2e2bcd8739ae039 = $51d435aeee502a21$var$LeftSidebarWithoutResize;

});
parcelRegister("b1C2u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad6b88f17b9ee9c6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $fg2GS = parcelRequire("fg2GS");

var $a05li = parcelRequire("a05li");

var $aXmgv = parcelRequire("aXmgv");

var $1qxfZ = parcelRequire("1qxfZ");

var $9fOvV = parcelRequire("9fOvV");
function $ad6b88f17b9ee9c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ad6b88f17b9ee9c6$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $9dQre.css)((0, $a05li.prefersReducedMotion)());
const $ad6b88f17b9ee9c6$var$mobileStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $aXmgv.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $1qxfZ.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $1qxfZ.BANNER_HEIGHT)} + ${(0, $1qxfZ.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $1qxfZ.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s`
    }
});
const $ad6b88f17b9ee9c6$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $aXmgv.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $1qxfZ.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $1qxfZ.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s, box-shadow ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $ad6b88f17b9ee9c6$var$fixedInnerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $1qxfZ.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $1qxfZ.BANNER_HEIGHT)} + ${(0, $1qxfZ.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $1qxfZ.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s`
});
const $ad6b88f17b9ee9c6$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1qxfZ.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $ad6b88f17b9ee9c6$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $ad6b88f17b9ee9c6$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $ad6b88f17b9ee9c6$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $9fOvV.default)();
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            // mobile viewport styles
            $ad6b88f17b9ee9c6$var$mobileStyles,
            isFlyoutOpen && $ad6b88f17b9ee9c6$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $ad6b88f17b9ee9c6$var$staticInnerStyles,
            isFixed && $ad6b88f17b9ee9c6$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $ad6b88f17b9ee9c6$var$fixedInnerFlyoutStyles,
            isDragging && $ad6b88f17b9ee9c6$var$draggingStyles,
            $ad6b88f17b9ee9c6$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ad6b88f17b9ee9c6$export$2e2bcd8739ae039 = $ad6b88f17b9ee9c6$var$LeftSidebarInner;

});

parcelRegister("1VvUa", function(module, exports) {
$parcel$export(module.exports, "default", () => $325922442be90f3d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fg2GS = parcelRequire("fg2GS");

var $a05li = parcelRequire("a05li");

var $aXmgv = parcelRequire("aXmgv");

var $1qxfZ = parcelRequire("1qxfZ");

var $drY8a = parcelRequire("drY8a");

var $9fOvV = parcelRequire("9fOvV");

var $dLRz7 = parcelRequire("dLRz7");

var $jIwmJ = parcelRequire("jIwmJ");
function $325922442be90f3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $325922442be90f3d$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $9dQre.css)((0, $a05li.prefersReducedMotion)());
const $325922442be90f3d$var$mobileStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $aXmgv.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $1qxfZ.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $1qxfZ.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $325922442be90f3d$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $aXmgv.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $325922442be90f3d$var$outerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1qxfZ.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $1qxfZ.TRANSITION_DURATION)}ms ${(0, $fg2GS.easeOut)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $325922442be90f3d$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $325922442be90f3d$var$fixedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $1qxfZ.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $325922442be90f3d$var$flyoutStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1qxfZ.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $325922442be90f3d$var$flyoutFixedStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $1qxfZ.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $325922442be90f3d$var$selector = (0, $drY8a.getPageLayoutSlotSelector)('left-sidebar');
const $325922442be90f3d$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $9fOvV.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $bSJIT.useContext)((0, $dLRz7.SidebarResizeContext));
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jIwmJ.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: [
                // mobile viewport styles
                $325922442be90f3d$var$mobileStyles,
                isFlyoutOpen && $325922442be90f3d$var$mobileFlyoutStyles,
                // generic styles
                $325922442be90f3d$var$outerStyles,
                isFixed && $325922442be90f3d$var$fixedStyles,
                isFlyoutOpen && $325922442be90f3d$var$flyoutStyles,
                isFlyoutOpen && isFixed && $325922442be90f3d$var$flyoutFixedStyles,
                isDragging && $325922442be90f3d$var$draggingStyles,
                $325922442be90f3d$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$325922442be90f3d$var$selector
        }, children));
};
const $325922442be90f3d$var$LeftSidebarOuter = /*#__PURE__*/ (0, $bSJIT.forwardRef)($325922442be90f3d$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$325922442be90f3d$export$2e2bcd8739ae039 = $325922442be90f3d$var$LeftSidebarOuter;

});


parcelRegister("8k1Kr", function(module, exports) {
$parcel$export(module.exports, "GoBackItem", () => $772571f5d8a27094$export$5a7b8181e2fdb767);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $8sRTK = parcelRequire("8sRTK");

var $kM5FK = parcelRequire("kM5FK");
const $772571f5d8a27094$export$5a7b8181e2fdb767 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8sRTK))), {
    color: "currentColor",
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $bSJIT.useState)(false);
    const onClickHandler = (0, $bSJIT.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kM5FK.ButtonItem), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});

});

parcelRegister("jruED", function(module, exports) {
$parcel$export(module.exports, "HeadingItem", () => $e5572b498af4324d$export$33647cff569304d0);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fsfgu = parcelRequire("fsfgu");

var $51QP7 = parcelRequire("51QP7");
const $e5572b498af4324d$var$styles = {
    headingItem: "_18zru2gc"
};
const $e5572b498af4324d$export$33647cff569304d0 = (props)=>{
    const { shouldRender: shouldRender } = (0, $51QP7.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fsfgu.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $9fU1q.default)([
            $e5572b498af4324d$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};

});

parcelRegister("gF810", function(module, exports) {
$parcel$export(module.exports, "Section", () => $2e93bb98af70dedb$export$6e2c8f0811a474ce);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7LtMZ = parcelRequire("7LtMZ");

var $51QP7 = parcelRequire("51QP7");
const $2e93bb98af70dedb$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $51QP7.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7LtMZ.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});

});

parcelRegister("5kMFi", function(module, exports) {
$parcel$export(module.exports, "SideNavigation", () => $a8487c1bc79f8792$export$cc4f63927c41742f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");


var $1VahP = parcelRequire("1VahP");

var $4eGW1 = parcelRequire("4eGW1");
const $a8487c1bc79f8792$var$sidebarMinWidth = '240px';
const $a8487c1bc79f8792$var$sideNavStyles = null;
const $a8487c1bc79f8792$export$cc4f63927c41742f = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    typeof $4eGW1;
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkvuon _syazazsu"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1VahP.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});

});

parcelRegister("2TZ5X", function(module, exports) {
$parcel$export(module.exports, "NavigationHeader", () => $d5dd356dc8a79973$export$791138eae2988149);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $d5dd356dc8a79973$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
const $d5dd356dc8a79973$export$791138eae2988149 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $d5dd356dc8a79973$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};

});

parcelRegister("f78I8", function(module, exports) {
$parcel$export(module.exports, "NavigationContent", () => $1e9ab42e509bcc91$export$af215290f9b7dac5);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $1shzn = parcelRequire("1shzn");

var $51QP7 = parcelRequire("51QP7");
const $1e9ab42e509bcc91$var$outerContainerCSS = null;
const $1e9ab42e509bcc91$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjlb4i _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $1e9ab42e509bcc91$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
const $1e9ab42e509bcc91$export$af215290f9b7dac5 = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $51QP7.useShouldNestedElementRender)();
    const scrollbar = (0, $1shzn.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rusvpsx _1kt9b3bt _1enwftgi _z5wtu2gc _14mjlb4i _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfkvpsx _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $9fU1q.default)([
                $1e9ab42e509bcc91$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $1e9ab42e509bcc91$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    $1e9ab42e509bcc91$var$containerCSS.basic,
                    showTopScrollIndicator && $1e9ab42e509bcc91$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});

});
parcelRegister("1shzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $085d2f544e7ba127$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $085d2f544e7ba127$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $bSJIT.useState)(0);
    const elementRef = (0, $bSJIT.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $bSJIT.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("4g0P3", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterMessageDictionary", () => $03d5c8552795eca9$export$5698e375f19e7351);
$parcel$export(module.exports, "useConditionalMessage", () => $03d5c8552795eca9$export$17f06fb6e83cbd1d);

var $7xtOy = parcelRequire("7xtOy");

var $d88cq = parcelRequire("d88cq");

var $e4wrJ = parcelRequire("e4wrJ");

var $cZmtZ = parcelRequire("cZmtZ");
const $03d5c8552795eca9$export$5698e375f19e7351 = ()=>{
    const { isHelpHub: isHelpHub } = (0, $7xtOy.useOptionalHelpCenterType)();
    return {
        // Sidebar messages
        backButton: isHelpHub ? (0, $e4wrJ.default).backButtonHelpHub : (0, $e4wrJ.default).backButton,
        backButtonHref: isHelpHub ? '/hubs' : '/',
        settingsLabel: isHelpHub ? (0, $e4wrJ.default).settingsLabelHelpHub : (0, $e4wrJ.default).settingsLabel,
        // Breadcrumb messages
        breadcrumbRoot: isHelpHub ? (0, $d88cq.default).settingsPageBreadcrumbItemHelpHub : (0, $d88cq.default).settingsPageBreadcrumbItem,
        // Sidebar header
        headerLabel: isHelpHub ? (0, $cZmtZ.default).helpHubLabel : (0, $cZmtZ.default).helpCenterLabel
    };
};
const $03d5c8552795eca9$export$17f06fb6e83cbd1d = (helpHubMessage, helpCenterMessage)=>{
    const { isHelpHub: isHelpHub } = (0, $7xtOy.useOptionalHelpCenterType)();
    return isHelpHub ? helpHubMessage : helpCenterMessage;
};

});
parcelRegister("d88cq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d8e805c9d4b2e9c$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $0d8e805c9d4b2e9c$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    settingsPageBreadcrumbItem: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.center.settings.breadcrumb.item'
    },
    settingsPageBreadcrumbItemHelpHub: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.hub.settings.breadcrumb.item'
    },
    breadcrumbsLabel: {
        id: 'help.center.settings.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'The text is shown as the accessible label for the breadcrumb navigation wrapper in the Help Center settings area, used by screen readers to identify the breadcrumb trail.'
    }
});

});

parcelRegister("e4wrJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $35f5466ce360dabc$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $35f5466ce360dabc$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    feedbackWidget: {
        defaultMessage: 'Give feedback',
        description: 'The text for give feedback button for help centers management screen',
        id: 'sidebar.feedback.widget'
    },
    backButton: {
        defaultMessage: 'Back to all help centers',
        description: 'The text for the back button in the sidebar',
        id: 'sidebar.back.hc.management.button'
    },
    backButtonHelpHub: {
        defaultMessage: 'Back to help centers',
        description: 'The text for the back button in the sidebar when viewing a help center',
        id: 'sidebar.back.helphub.management.button'
    },
    settingsLabel: {
        defaultMessage: 'Help center settings',
        description: 'Navigation label for the help center settings link in the sidebar',
        id: 'sidebar.settings.label'
    },
    settingsLabelHelpHub: {
        defaultMessage: 'Help center settings',
        description: 'Label for settings when viewing a help center',
        id: 'sidebar.settings.label.helphub'
    },
    sidebarNavigationLabel: {
        defaultMessage: 'Sidebar navigation',
        description: 'Accessible label for the sidebar navigation landmark element',
        id: 'sidebar.navigation.label'
    }
});

});

parcelRegister("cZmtZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7c0644c1acec7ab$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e7c0644c1acec7ab$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpCenterLabel: {
        defaultMessage: 'Help Center',
        description: 'Heading label for the help center displayed in the sidebar header',
        id: 'sidebar.help-center.header.helpcenter.label'
    },
    helpHubLabel: {
        defaultMessage: 'Help center',
        description: 'Heading label for the help hub displayed in the sidebar header',
        id: 'sidebar.help-center.header.helphub.label'
    },
    helpCenterImageAltLabel: {
        defaultMessage: 'help center icon',
        description: 'Label for help center icon in sidebar',
        id: 'sidebar.help-center.header.helpcenter.image.alt.label'
    }
});

});


parcelRegister("9oCe4", function(module, exports) {
$parcel$export(module.exports, "SidebarHelpCenterHeader", () => (parcelRequire("9wCU9")).default);

var $9wCU9 = parcelRequire("9wCU9");

});
parcelRegister("9wCU9", function(module, exports) {
$parcel$export(module.exports, "default", () => $76d9195a7b7829e0$export$2e2bcd8739ae039);
/* sidebar-help-center-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $eaexs = parcelRequire("eaexs");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $fuVmc = parcelRequire("fuVmc");

var $d60Lc = parcelRequire("d60Lc");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $8noH2 = parcelRequire("8noH2");

var $9R3gt = parcelRequire("9R3gt");

var $4g0P3 = parcelRequire("4g0P3");
const $76d9195a7b7829e0$var$SidebarHelpCenterHeader = ()=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $9R3gt.useHelpCenterAri)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $eaexs.default), {
        helpCenterAri: helpCenterAri,
        cloudId: (0, $fuVmc.getCloudId)()
    });
    const helpCenterData = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    let { currentHcName: currentHcName, currentHcBannerUrl: currentHcBannerUrl, currentHcThemeColor: currentHcThemeColor, useDefaultBanner: useDefaultBanner } = {
        currentHcName: undefined,
        currentHcBannerUrl: null,
        currentHcThemeColor: null,
        useDefaultBanner: false
    };
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'HelpCenter') {
        var _helpCenterData$name, _helpCenterData$helpC, _helpCenterData$helpC2, _helpCenterData$helpC3;
        currentHcName = helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$name = helpCenterData.name) === null || _helpCenterData$name === void 0 ? void 0 : _helpCenterData$name.default;
        currentHcBannerUrl = (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 || (_helpCenterData$helpC = _helpCenterData$helpC.banner) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.url;
        currentHcThemeColor = (_helpCenterData$helpC2 = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC2 === void 0 || (_helpCenterData$helpC2 = _helpCenterData$helpC2.colors) === null || _helpCenterData$helpC2 === void 0 ? void 0 : _helpCenterData$helpC2.primary;
        useDefaultBanner = !!((_helpCenterData$helpC3 = helpCenterData.helpCenterBranding) !== null && _helpCenterData$helpC3 !== void 0 && _helpCenterData$helpC3.useDefaultBanner);
    }
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const helpCenterMessages = (0, $4g0P3.useHelpCenterMessageDictionary)();
    const defaultImage = useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($d60Lc))) : undefined;
    const backgroundImage = currentHcBannerUrl ? currentHcBannerUrl : defaultImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8noH2.Header), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($76d9195a7b7829e0$var$HelpCenterImage, {
            backgroundColor: currentHcThemeColor,
            src: backgroundImage || (0, (/*@__PURE__*/$parcel$interopDefault($d60Lc))),
            height: 24,
            width: 24,
            alt: formatMessage(helpCenterMessages.headerLabel)
        }),
        description: formatMessage(helpCenterMessages.headerLabel)
    }, currentHcName);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $76d9195a7b7829e0$var$HelpCenterImage = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_128mzge": (0, $3zY6O.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_2rko1l7b _5ral1dfr",
            !__cmplp.backgroundColor ? "_bfhk4re7" : "_bfhkmpv7",
            __cmplp.className
        ])
    });
});
var $76d9195a7b7829e0$export$2e2bcd8739ae039 = $76d9195a7b7829e0$var$SidebarHelpCenterHeader;

});
parcelRegister("eaexs", function(module, exports) {
$parcel$export(module.exports, "default", () => $accf7a3fadf7e620$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2179412537acb48a3db96339d64a5116>>
 * @relayHash 6337212810c49a971e575c2b12da2d45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956
const $accf7a3fadf7e620$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            }
        ]
    }, v5 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956",
            "metadata": {},
            "name": "sidebarHelpCenterHeaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$accf7a3fadf7e620$var$node.hash = "b1b17113e136ecbdd8bfb74c4910cc78";
var $accf7a3fadf7e620$export$2e2bcd8739ae039 = $accf7a3fadf7e620$var$node;

});

parcelRegister("8noH2", function(module, exports) {
$parcel$export(module.exports, "Header", () => $4d9205465cc79daa$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $j6n7x = parcelRequire("j6n7x");

var $3FzdQ = parcelRequire("3FzdQ");
const $4d9205465cc79daa$var$styles = {
    header: "_uizt1wug _vrjt1qyo _1cmdi7uo _11kjsm61 _jl2n73ad _1et6sm61 _1v6ji7uo"
};
const $4d9205465cc79daa$export$8b251419efc915eb = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $j6n7x.CustomItem), {
        ...props,
        ref: ref,
        component: props.component || (0, $3FzdQ.default),
        isTitleHeading: true,
        className: (0, $9fU1q.default)([
            $4d9205465cc79daa$var$styles.header
        ])
    });
});

});
parcelRegister("j6n7x", function(module, exports) {
$parcel$export(module.exports, "CustomItem", () => $6c56a1bad2e979f5$export$e2a67f48c34be853);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $cjQhO = parcelRequire("cjQhO");

var $51QP7 = parcelRequire("51QP7");
const $6c56a1bad2e979f5$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    rootMotion: "_v564hxmd _o7kshxmd _1ggl87vo",
    selectedMotion: "_v5641rrn _o7kshxmd _1ggl87vo"
};
const $6c56a1bad2e979f5$export$e2a67f48c34be853 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $51QP7.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cjQhO.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            $6c56a1bad2e979f5$var$styles.root,
            $6c56a1bad2e979f5$var$styles.rootMotion,
            props.isSelected && $6c56a1bad2e979f5$var$styles.selectedStyles,
            props.isSelected && $6c56a1bad2e979f5$var$styles.selectedMotion,
            className
        ]),
        ...props
    });
});

});

parcelRegister("3FzdQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $44094aec9de1eecb$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
/**
 * __Container__
 *
 * A container for Header and Footer that safely handles props to the child component
 */ const $44094aec9de1eecb$var$HeaderContainer = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
var $44094aec9de1eecb$export$2e2bcd8739ae039 = $44094aec9de1eecb$var$HeaderContainer;

});




parcelRegister("lzRo0", function(module, exports) {
$parcel$export(module.exports, "SidebarSkeleton", () => (parcelRequire("4Vljv")).default);

var $4Vljv = parcelRequire("4Vljv");

});
parcelRegister("4Vljv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f059d5def9eaa596$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5VhGP = parcelRequire("5VhGP");

var $gUpf2 = parcelRequire("gUpf2");

var $cMYsY = parcelRequire("cMYsY");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $8noH2 = parcelRequire("8noH2");

var $f78I8 = parcelRequire("f78I8");

var $2TZ5X = parcelRequire("2TZ5X");

var $gF810 = parcelRequire("gF810");

var $iW3CQ = parcelRequire("iW3CQ");
const $f059d5def9eaa596$var$SideBarContentSkeleton = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "16px",
        width: "35%"
    }));
};
const $f059d5def9eaa596$var$SidebarHeaderSkeleton = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $2TZ5X.NavigationHeader), null, /*#__PURE__*/ $bSJIT.createElement((0, $8noH2.Header), {
        iconBefore: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
            height: "24px",
            width: "80%",
            "data-testid": "icon-skeleton"
        }),
        description: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
            height: "16px",
            width: "55%",
            "data-testid": "description-skeleton"
        })
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockEnd: "space.025"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "16px",
        width: "85%",
        "data-testid": "title-skeleton"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.300",
        paddingBlockEnd: "space.150",
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "18px",
        width: "18px",
        isCircle: true
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "16px",
        width: "60%"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $f78I8.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "16px",
        width: "30%"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $bSJIT.createElement($f059d5def9eaa596$var$SideBarContentSkeleton, null), /*#__PURE__*/ $bSJIT.createElement($f059d5def9eaa596$var$SideBarContentSkeleton, null), (0, $iW3CQ.getIsHCCustomizationEnabled)() && /*#__PURE__*/ $bSJIT.createElement($f059d5def9eaa596$var$SideBarContentSkeleton, null), /*#__PURE__*/ $bSJIT.createElement($f059d5def9eaa596$var$SideBarContentSkeleton, null)))), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: $f059d5def9eaa596$var$navFooter
    }, /*#__PURE__*/ $bSJIT.createElement((0, $f78I8.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gF810.Section), null, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        height: "16px",
        width: "70%"
    })))))));
};
const $f059d5def9eaa596$var$navFooter = (0, $9BVpB.xcss)({
    position: 'absolute',
    bottom: 'space.0',
    width: '94%'
});
var $f059d5def9eaa596$export$2e2bcd8739ae039 = $f059d5def9eaa596$var$SidebarHeaderSkeleton;

});




parcelRegister("5CTLP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4cb171ac26dc155$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $d4cb171ac26dc155$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpcenterDetailsItem: {
        defaultMessage: 'Details',
        description: 'Label for the help center details item in the help center management screen sidebar',
        id: 'admin.management.sidebar.edit.details'
    },
    helpcenterManageProjectsItem: {
        defaultMessage: 'Projects',
        description: 'Label for the help center projects item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects'
    },
    helpcenterManageProjectsItemGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Label for the help center spaces item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects-galaxia'
    },
    helpcenterManagePagesItem: {
        defaultMessage: 'Landing pages',
        description: 'Label for the help center landing pages item in the help center management screen sidebar',
        id: 'admin.management.sidebar.landing.pages'
    },
    helpcenterRovoServiceAgentItem: {
        defaultMessage: 'Rovo agent',
        description: 'Label for the help center Rovo service agent item in the help center management screen sidebar',
        id: 'admin.management.sidebar.rovo.service.agent'
    },
    helpcenterVsaReportingItem: {
        defaultMessage: 'Virtual service agent',
        description: 'Label for the help center reporting item in the help center management screen sidebar',
        id: 'admin.management.sidebar.reporting'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title shown in the help center management screen sidebar when data fails to load',
        id: 'admin.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description shown in the help center management screen sidebar when data fails to load',
        id: 'admin.management.sidebar.error.description'
    },
    landingPagesSidebarChangeBoardingHeading: {
        defaultMessage: 'Create unique pages in the help center',
        description: 'Heading text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.heading'
    },
    landingPagesSidebarChangeBoardingContent: {
        defaultMessage: "Customize layouts and curate help content to create visually-appealing landing pages that meet your audience's needs.",
        description: 'Spotlight content text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.content'
    },
    landingPagesSidebarChangeBoardingDismissButton: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.dismiss'
    },
    landingPagesSidebarChangeBoardingTryButton: {
        defaultMessage: 'Try now',
        description: 'Try now button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.try'
    }
});

});



parcelRegister("eyygd", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => (parcelRequire("ei8Ar")).HelpCenterManageProjects);

var $ei8Ar = parcelRequire("ei8Ar");

});
parcelRegister("ei8Ar", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => $c41209432335684e$export$44752868a2f1a12);

var $dGzpy = parcelRequire("dGzpy");

var $bSJIT = parcelRequire("bSJIT");

var $2OuWT = parcelRequire("2OuWT");

var $9lO7I = parcelRequire("9lO7I");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $fuVmc = parcelRequire("fuVmc");

var $1F8Um = parcelRequire("1F8Um");

var $4ZMmh = parcelRequire("4ZMmh");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $dwOcU = parcelRequire("dwOcU");

var $6WltM = parcelRequire("6WltM");

var $lkSXl = parcelRequire("lkSXl");

var $ljPIj = parcelRequire("ljPIj");

var $85rmf = parcelRequire("85rmf");

var $87QgR = parcelRequire("87QgR");

var $7WQx2 = parcelRequire("7WQx2");

var $gfXmS = parcelRequire("gfXmS");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $jgsO4 = parcelRequire("jgsO4");

var $kxIlX = parcelRequire("kxIlX");

var $clpci = parcelRequire("clpci");

var $haAAx = parcelRequire("haAAx");

var $iydAA = parcelRequire("iydAA");

var $iW3CQ = parcelRequire("iW3CQ");

var $51XYw = parcelRequire("51XYw");

var $f6Ax9 = parcelRequire("f6Ax9");

var $7WRjA = parcelRequire("7WRjA");

var $7xtOy = parcelRequire("7xtOy");

var $9R3gt = parcelRequire("9R3gt");
parcelRequire("lfOCd");
var $1mm9L = parcelRequire("1mm9L");
parcelRequire("felIn");
var $bnrHq = parcelRequire("bnrHq");

var $3V2ug = parcelRequire("3V2ug");
parcelRequire("3FoFP");
var $hGRgd = parcelRequire("hGRgd");

var $hUKoD = parcelRequire("hUKoD");
parcelRequire("5c0aQ");
var $4sO83 = parcelRequire("4sO83");
parcelRequire("355yQ");
var $1ioYQ = parcelRequire("1ioYQ");

var $39QnN = parcelRequire("39QnN");
const $c41209432335684e$var$PROJECT_MAPPING_SUPPORT_DOC_URL = 'https://support.atlassian.com/jira-service-management-cloud/docs/link-service-projects-to-a-help-center/';
const $c41209432335684e$var$StaticContent = ({ isReadOnlyView: isReadOnlyView })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { isHelpHub: isHelpHub } = (0, $7xtOy.useHelpCenterType)();
    const isGalaxia = (0, $87QgR.default).checkGate('itsm-project-renaming');
    const helpCenterManageProjectsLink = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2OuWT.Link), {
            href: $c41209432335684e$var$PROJECT_MAPPING_SUPPORT_DOC_URL,
            actionSubjectId: "manageProjectsLink",
            target: "_blank",
            rel: "noreferrer"
        }, chunks);
    const pageTitle = isGalaxia ? (0, $hUKoD.default).manageProjectsPageTitleGalaxia : (0, $hUKoD.default).manageProjectsPageTitle;
    let pageDescription;
    if (isReadOnlyView) pageDescription = isGalaxia ? (0, $hUKoD.default).manageProjectsPageDescriptionForDefaultHCGalaxia : (0, $hUKoD.default).manageProjectsPageDescriptionForDefaultHC;
    else if (isHelpHub) pageDescription = (0, $hUKoD.default).manageProjectsPageDescriptionHelpHub;
    else if (isGalaxia) pageDescription = (0, $hUKoD.default).manageProjectsPageDescriptionGalaxia;
    else pageDescription = (0, $hUKoD.default).manageProjectsPageDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "large"
    }, formatMessage(pageTitle)), isReadOnlyView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, isHelpHub ? formatMessage(pageDescription) : formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    })));
};
const $c41209432335684e$var$HelpCenterManageProjectsComponent = ()=>{
    var _data$jira, _data$helpCenter, _data$helpCenter2, _data$helpCenter3, _data$helpCenter4, _data$jira2;
    const [helpCenterMappingStatus, setHelpCenterMappingStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState((0, $39QnN.ProjectsMappingStatus).LINKED);
    const helpCenterAri = (0, $9R3gt.useHelpCenterAri)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $dGzpy.default), {
        helpCenterMappingStatus: helpCenterMappingStatus,
        helpCenterId: '',
        helpCenterARI: helpCenterAri,
        cloudId: (0, $fuVmc.getCloudId)()
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [searchQuery, setSearchQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState('');
    const onInputChange = (value)=>{
        setSearchQuery(value);
    };
    const debouncedOnChange = (0, $4ZMmh.debounce)(onInputChange, (0, $jcRK7.USER_TYPING_DEBOUNCE_TIME));
    const onTextFieldChange = (0, $bSJIT.useCallback)((event)=>{
        const value = event.target.value;
        debouncedOnChange(value);
    }, [
        debouncedOnChange
    ]);
    const statusTextMap = {
        [(0, $39QnN.ProjectsMappingStatus).LINKED]: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $hUKoD.default).linkedFilterLabelGalaxia) : formatMessage((0, $hUKoD.default).linkedFilterLabel),
        [(0, $39QnN.ProjectsMappingStatus).UNLINKED]: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $hUKoD.default).unlinkedFilterLabelGalaxia) : formatMessage((0, $hUKoD.default).unlinkedFilterLabel)
    };
    if (!(data !== null && data !== void 0 && (_data$jira = data.jira) !== null && _data$jira !== void 0 && _data$jira.jiraProjectsMappedToHelpCenter)) return null;
    if (!(data !== null && data !== void 0 && (_data$helpCenter = data.helpCenter) !== null && _data$helpCenter !== void 0 && _data$helpCenter.helpCenterById)) return null;
    const slug = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.slug;
    const isDefaultHC = !slug;
    const isReadOnlyView = !(0, $iW3CQ.getIsMultiHCEnabled)() || isDefaultHC;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: (0, $jcRK7.ScreenName).MANAGE_PROJECTS,
        sourceType: (0, $clpci.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bnrHq.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c41209432335684e$var$StaticContent, {
        isReadOnlyView: isReadOnlyView
    }), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $hUKoD.default).manageProjectPageToggleForDefaultLinkingGalaxia) : formatMessage((0, $hUKoD.default).manageProjectPageToggleForDefaultLinking)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1ioYQ.default), {
        syncProjectsToggleFragmentKey: (_data$helpCenter4 = data.helpCenter) === null || _data$helpCenter4 === void 0 ? void 0 : _data$helpCenter4.helpCenterById
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $c41209432335684e$var$searchInputStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        name: "search",
        autoComplete: "off",
        isCompact: true,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            size: "small",
            label: "search icon",
            spacing: "spacious"
        })),
        defaultValue: searchQuery,
        onChange: onTextFieldChange,
        placeholder: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $hUKoD.default).searchProjectsPlaceholderGalaxia) : formatMessage((0, $hUKoD.default).searchProjectsPlaceholder)
    })), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: 'projectMappingMenu'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $c41209432335684e$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        trigger: statusTextMap[helpCenterMappingStatus],
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljPIj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: 'projectMappingLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9lO7I.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $39QnN.ProjectsMappingStatus).LINKED);
        }
    }, statusTextMap[(0, $39QnN.ProjectsMappingStatus).LINKED])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            actionSubjectId: 'projectMappingUnLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9lO7I.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $39QnN.ProjectsMappingStatus).UNLINKED);
        }
    }, statusTextMap[(0, $39QnN.ProjectsMappingStatus).UNLINKED])))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4sO83.default), {
        isReadOnlyView: isReadOnlyView,
        projectsListFragmentKey: data === null || data === void 0 || (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.jiraProjectsMappedToHelpCenter,
        selection: helpCenterMappingStatus,
        searchQuery: searchQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $3V2ug.manageProjectsExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null)));
};
const $c41209432335684e$export$44752868a2f1a12 = ()=>{
    (0, $7WRjA.useUFOComponentExperience)((0, $3V2ug.manageProjectsExperience));
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) {
            (0, $3V2ug.manageProjectsExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
            //TODO: Add helpCenterMappingStatus
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'project',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
            header: formatMessage((0, $hUKoD.default).errorTitle),
            description: formatMessage((0, $hUKoD.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1F8Um)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mm9L.default), {
        featureName: "Helpcenter manage projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).MANAGE_PROJECTS,
        id: 'help-center-manage-projects',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hGRgd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c41209432335684e$var$HelpCenterManageProjectsComponent, null))));
};
const $c41209432335684e$var$searchInputStyles = (0, $9BVpB.xcss)({
    width: '288px',
    marginRight: 'space.200'
});
const $c41209432335684e$var$dropdownContainerStyles = (0, $9BVpB.xcss)({
    zIndex: 'modal'
});

});
parcelRegister("dGzpy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8190c014a37bf619$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d53c6c03de4053326d733cad1281e15b>>
 * @relayHash bc210f0fbe988c79fde091a561d08224
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392
const $8190c014a37bf619$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterMappingStatus"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterARI"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterId",
                    "variableName": "helpCenterId"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterMappingStatus",
                    "variableName": "helpCenterMappingStatus"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        }
    ], v6 = [
        v4 /*: any*/ 
    ], v7 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterARI"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectsListFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "syncProjectsToggleFragment"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterProjectMappingData",
                                            "kind": "LinkedField",
                                            "name": "projectMappingData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "syncNewProjects"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392",
            "metadata": {},
            "name": "manageProjects_GetProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8190c014a37bf619$var$node.hash = "5e6e808fa11d7afbb4a426f5b2c7f1a1";
var $8190c014a37bf619$export$2e2bcd8739ae039 = $8190c014a37bf619$var$node;

});

parcelRegister("9lO7I", function(module, exports) {
$parcel$export(module.exports, "DropdownItem", () => $9322c1021141c0fa$export$6648d5fa18559e7f);

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $jeyHF = parcelRequire("jeyHF");

var $ag7mU = parcelRequire("ag7mU");
const $9322c1021141c0fa$export$6648d5fa18559e7f = (0, $2usNr.default)({
    componentName: 'dropdownItem'
})((0, $kIbto.default)({
    onClick: (0, $jeyHF.default)('atlaskit')({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    })
})((0, $ag7mU.default)));

});

parcelRegister("felIn", function(module, exports) {
$parcel$export(module.exports, "SettingsBreadcrumbs", () => (parcelRequire("bnrHq")).default);

var $bnrHq = parcelRequire("bnrHq");

});
parcelRegister("bnrHq", function(module, exports) {
$parcel$export(module.exports, "default", () => $83d9599bef5a9c9c$export$2e2bcd8739ae039);

var $1xTWM = parcelRequire("1xTWM");

var $bSJIT = parcelRequire("bSJIT");

var $3KPvu = parcelRequire("3KPvu");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $5faG6 = parcelRequire("5faG6");

var $gUpf2 = parcelRequire("gUpf2");

var $4g0P3 = parcelRequire("4g0P3");

var $d88cq = parcelRequire("d88cq");
const $83d9599bef5a9c9c$var$SettingsBreadcrumbs = ({ helpCenterData: helpCenterData })=>{
    var _data$name;
    const data = (0, $a2qIF.useFragment)((0, $1xTWM.default), helpCenterData);
    const helpCenterName = (data === null || data === void 0 || (_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name.default) || '';
    const slug = data === null || data === void 0 ? void 0 : data.slug;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const helpCenterMessages = (0, $4g0P3.useHelpCenterMessageDictionary)();
    const rootBreadcrumbUrl = '/';
    const getHelpcenterBreadcrumbUrl = ()=>{
        return !slug ? `${window.location.origin}/servicedesk/customer` : `${window.location.origin}/helpcenter/${slug}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5faG6.default), {
        label: formatMessage((0, $d88cq.default).breadcrumbsLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3KPvu.default), {
        isFirstCrumb: true,
        to: rootBreadcrumbUrl,
        name: formatMessage(helpCenterMessages.breadcrumbRoot),
        actionSubjectId: "helpCenterBreadcrumb",
        disableTheme: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3KPvu.default), {
        to: getHelpcenterBreadcrumbUrl(),
        name: helpCenterName,
        actionSubjectId: "helpDeskBreadcrumb",
        disableTheme: true
    }))));
};
var $83d9599bef5a9c9c$export$2e2bcd8739ae039 = $83d9599bef5a9c9c$var$SettingsBreadcrumbs;

});
parcelRegister("1xTWM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d307ebecb3a7bf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25699f1eb65c2f623944fcb43e23c755>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d307ebecb3a7bf9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "settingsBreadcrumbsFragment",
    "selections": [
        {
            "concreteType": "HelpCenterName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "default"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "slug"
        }
    ],
    "type": "HelpCenter"
};
$2d307ebecb3a7bf9$var$node.hash = "0716469cbe624819ae2ea879ee690b4e";
var $2d307ebecb3a7bf9$export$2e2bcd8739ae039 = $2d307ebecb3a7bf9$var$node;

});



parcelRegister("3V2ug", function(module, exports) {
$parcel$export(module.exports, "manageProjectsExperience", () => $4673838f554edd1b$export$500b6e6c6f0e66cd);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $4673838f554edd1b$export$500b6e6c6f0e66cd = new (0, $1we90.UFOExperience)((0, $eAZuG.manageProjectsExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("3FoFP", function(module, exports) {
$parcel$export(module.exports, "ManageProjectsLayoutSkeleton", () => (parcelRequire("hGRgd")).default);

var $hGRgd = parcelRequire("hGRgd");

});
parcelRegister("hGRgd", function(module, exports) {
$parcel$export(module.exports, "default", () => $a05c13e2a9ce9345$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5VhGP = parcelRequire("5VhGP");

var $bNvXg = parcelRequire("bNvXg");

var $cMYsY = parcelRequire("cMYsY");

var $gUpf2 = parcelRequire("gUpf2");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $iFhIy = parcelRequire("iFhIy");
const $a05c13e2a9ce9345$var$ManageProjectsLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "12px",
                    height: "12px"
                }),
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
            },
            {
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            {
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH).status
            },
            {
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 10
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "12px",
                        height: "12px"
                    })
                },
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "24px",
                        height: "24px"
                    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "24px",
                        height: "24px",
                        isCircle: true
                    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    key: 'select-all-skeleton',
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "28%",
                        height: "16px"
                    })
                },
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "30%",
                        height: "20px"
                    })
                }
            ]
        }));
    return /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-project-title-skeleton"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "50%",
        height: "20px"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "270px",
        height: "16px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "32px",
        height: "16px",
        "data-testid": "toggle-new-projects-layout-skeleton"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "25%",
        height: "32px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "20%",
        height: "32px"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: $a05c13e2a9ce9345$var$tableSkeletonStyles
    }, /*#__PURE__*/ $bSJIT.createElement((0, $bNvXg.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true,
        highlightedRowIndex: 11
    })));
};
const $a05c13e2a9ce9345$var$tableSkeletonStyles = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
var $a05c13e2a9ce9345$export$2e2bcd8739ae039 = $a05c13e2a9ce9345$var$ManageProjectsLayoutSkeleton;

});
parcelRegister("bNvXg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8948234f3d55e434$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $KbotP = parcelRequire("KbotP");

var $2jRSy = parcelRequire("2jRSy");
class $8948234f3d55e434$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        defaultPage: 1,
        isLoading: false,
        isFixedSize: false,
        isRankable: false,
        onSetPage: (0, $1OdZP.default),
        onSort: (0, $1OdZP.default),
        rowsPerPage: Infinity
    };
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2jRSy.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $KbotP.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("KbotP", function(module, exports) {
$parcel$export(module.exports, "reorderRows", () => $4f33a511d31b6081$export$c476bbe5da59992d);

var $hij9m = parcelRequire("hij9m");
const $4f33a511d31b6081$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = (0, $hij9m.computeIndex)(sourceIndex, page, rowsPerPage);
    const toIndex = (0, $hij9m.computeIndex)(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});
parcelRegister("hij9m", function(module, exports) {
$parcel$export(module.exports, "computeIndex", () => $9755b851cf7d97c4$export$92bcb1ed38b134a1);
const $9755b851cf7d97c4$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};

});


parcelRegister("2jRSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $f365a3fc10a8976b$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $kwxwD = parcelRequire("kwxwD");

var $9wOLX = parcelRequire("9wOLX");

var $aV68g = parcelRequire("aV68g");

var $7FH8k = parcelRequire("7FH8k");

var $ej7J9 = parcelRequire("ej7J9");

var $bdVzO = parcelRequire("bdVzO");

var $35Llj = parcelRequire("35Llj");

var $ccIhB = parcelRequire("ccIhB");

var $cQ6uA = parcelRequire("cQ6uA");

var $cgnFX = parcelRequire("cgnFX");

var $6YBat = parcelRequire("6YBat");

var $hKWkq = parcelRequire("hKWkq");

var $jL3xk = parcelRequire("jL3xk");

var $fOR0z = parcelRequire("fOR0z");
function $f365a3fc10a8976b$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 'DESC':
            return 'ASC';
        case 'ASC':
            return 'DESC';
        default:
            return currentSortOrder;
    }
}
const $f365a3fc10a8976b$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $1OdZP.default), onSort: providedOnSort = (0, $1OdZP.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $1OdZP.default), onRankEnd: providedOnRankEnd = (0, $1OdZP.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $bSJIT.useState)(false);
    const tableBodyRef = (0, $bSJIT.useRef)(null);
    const onSort = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    const onRankEnd = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    (0, $bSJIT.useEffect)(()=>{
        (0, $aV68g.validateSortKey)(sortKey, head);
        (0, $kwxwD.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === 'DESC') {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? 'ASC' : $f365a3fc10a8976b$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $9wOLX.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? 'large' : 'small';
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bdVzO.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $dc70d.jsx)((0, $ej7J9.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $hKWkq.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $ccIhB.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $dc70d.jsx)((0, $7FH8k.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $dc70d.jsx)((0, $fOR0z.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            isFixedSize: isFixedSize,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $dc70d.jsx)($f365a3fc10a8976b$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $35Llj.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jL3xk.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $dc70d.jsx)((0, $6YBat.default), {
                isLoading: isLoading,
                spinnerSize: "large",
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $f365a3fc10a8976b$var$RankableTableBody = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("fD2U6")));
const $f365a3fc10a8976b$var$TableBody = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $dc70d.jsx)((0, $cQ6uA.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cgnFX.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $dc70d.jsx)($f365a3fc10a8976b$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f365a3fc10a8976b$export$2e2bcd8739ae039 = $f365a3fc10a8976b$var$DynamicTable;

});
parcelRegister("kwxwD", function(module, exports) {
$parcel$export(module.exports, "assertIsSortable", () => $e2ad130f6a7f4356$export$5eb35a4771ec4090);
const $e2ad130f6a7f4356$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};

});

parcelRegister("9wOLX", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $8a875eb61e6ef73b$export$3987dc24b734dcab);
const $8a875eb61e6ef73b$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};

});

parcelRegister("aV68g", function(module, exports) {
$parcel$export(module.exports, "validateSortKey", () => $f501ae11a36d3e42$export$9133f5a8bfe8a200);
const $f501ae11a36d3e42$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

});

parcelRegister("7FH8k", function(module, exports) {
$parcel$export(module.exports, "Caption", () => $160005ffbc3d1d9f$export$32fbfacc5d962e0c);
/* caption.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $160005ffbc3d1d9f$var$captionStyles = null;
const $160005ffbc3d1d9f$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("caption", {
        className: (0, $9fU1q.default)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });

});

parcelRegister("ej7J9", function(module, exports) {
$parcel$export(module.exports, "EmptyViewContainer", () => $d4a39d4b67e9681d$export$381ea436de119582);
/* empty-view-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $d4a39d4b67e9681d$var$emptyViewContainerStyles = null;
const $d4a39d4b67e9681d$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $9fU1q.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bdVzO", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $07e5175343004d09$export$8f45b9407d4090d7);
/* empty-view-with-fixed-height.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $07e5175343004d09$var$fixedHeightStyles = null;
const $07e5175343004d09$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $9fU1q.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });

});

parcelRegister("35Llj", function(module, exports) {
$parcel$export(module.exports, "PaginationWrapper", () => $3edc5b347a4d8376$export$3e5e12dc01f20a43);
/* pagination-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $3edc5b347a4d8376$var$paginationWrapperStyles = null;
const $3edc5b347a4d8376$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("ccIhB", function(module, exports) {
$parcel$export(module.exports, "Table", () => $27c8c85ca2e6fe73$export$54ec01a60f47d33d);
/* table.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
// React 18 doesn't know `inert` and only forwards it as a string attribute (`inert=""`).
// React 19 treats `inert` as a boolean, so `''` is falsy and the attribute is dropped.
const $27c8c85ca2e6fe73$var$isReact19OrLater = parseInt((0, $bSJIT.version), 10) >= 19;
const $27c8c85ca2e6fe73$var$inertValue = $27c8c85ca2e6fe73$var$isReact19OrLater ? true : '';
const $27c8c85ca2e6fe73$var$fixedSizeTableStyles = null;
const $27c8c85ca2e6fe73$var$tableStyles = null;
const $27c8c85ca2e6fe73$var$bodyBorder = null;
const $27c8c85ca2e6fe73$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("table", {
        inert: isLoading ? $27c8c85ca2e6fe73$var$inertValue : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $9fU1q.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});

});

parcelRegister("cQ6uA", function(module, exports) {
$parcel$export(module.exports, "default", () => $47d591404f6d9ebe$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kZs18 = parcelRequire("kZs18");

var $e9rWc = parcelRequire("e9rWc");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $47d591404f6d9ebe$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $e9rWc.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $47d591404f6d9ebe$var$Body = (0, $kZs18.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($47d591404f6d9ebe$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47d591404f6d9ebe$export$2e2bcd8739ae039 = $47d591404f6d9ebe$var$Body;

});
parcelRegister("kZs18", function(module, exports) {
$parcel$export(module.exports, "default", () => $51b5f7e45ba30bcf$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9wOLX = parcelRequire("9wOLX");

var $aV68g = parcelRequire("aV68g");
const $51b5f7e45ba30bcf$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
const $51b5f7e45ba30bcf$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === 'ASC' ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $51b5f7e45ba30bcf$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $51b5f7e45ba30bcf$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $51b5f7e45ba30bcf$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aV68g.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $51b5f7e45ba30bcf$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $9wOLX.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $dc70d.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("e9rWc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c30305f8b2352e73$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $e8naa = parcelRequire("e8naa");

var $kscqS = parcelRequire("kscqS");
const $c30305f8b2352e73$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    // `key` is pulled out so it isn't spread into JSX (React 19 warns about that). The parent
    // already applies it to this row, and each cell gets an explicit `key` below.
    const { cells: cells, key: rowKey, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kscqS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${rowKey}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, key: _cellKey, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $bSJIT.createElement)((0, $e8naa.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c30305f8b2352e73$export$2e2bcd8739ae039 = $c30305f8b2352e73$var$Row;

});
parcelRegister("e8naa", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6077c1e3272d1f09$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fi1Kv = parcelRequire("fi1Kv");
const $6077c1e3272d1f09$var$fixedSizeTruncateStyles = null;
const $6077c1e3272d1f09$var$overflowTruncateStyles = null;
const $6077c1e3272d1f09$var$truncationWidthStyles = null;
const $6077c1e3272d1f09$var$cellStyles = null;
const $6077c1e3272d1f09$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $dc70d.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $fi1Kv.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("fi1Kv", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $60fea57fec286951$export$5e6497a652ae30b5);
const $60fea57fec286951$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $60fea57fec286951$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$60fea57fec286951$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("kscqS", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $16c16c05fb46187b$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $16c16c05fb46187b$var$rowStyles = null;
const $16c16c05fb46187b$var$rowBackgroundStyles = null;
const $16c16c05fb46187b$var$rowHighlightedBackgroundStyles = null;
const $16c16c05fb46187b$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("tr", {
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("cgnFX", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $78e99daa8388d400$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");
class $78e99daa8388d400$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("6YBat", function(module, exports) {
$parcel$export(module.exports, "default", () => $906f17c760b5a423$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hDkm2 = parcelRequire("hDkm2");

var $f0Wn3 = parcelRequire("f0Wn3");

var $6UisP = parcelRequire("6UisP");

var $3S2FG = parcelRequire("3S2FG");
class $906f17c760b5a423$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: 'large',
        contentsOpacity: 0.22,
        loadingLabel: 'Loading table'
    };
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $f0Wn3.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $dc70d.jsx)((0, $6UisP.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $dc70d.jsx)((0, $3S2FG.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("f0Wn3", function(module, exports) {
$parcel$export(module.exports, "Container", () => $e4a619c0b7767de7$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $e4a619c0b7767de7$var$containerStyles = null;
const $e4a619c0b7767de7$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $9fU1q.default)([
            "_kqswh2mm"
        ]),
        children: children
    });

});

parcelRegister("6UisP", function(module, exports) {
$parcel$export(module.exports, "ContentsContainer", () => $e8b962a244b9251c$export$67c29eae8ae2137a);
/* contents-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $e8b962a244b9251c$var$CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const $e8b962a244b9251c$var$contentsContainerStyles = null;
const $e8b962a244b9251c$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            [$e8b962a244b9251c$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $9fU1q.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });

});

parcelRegister("3S2FG", function(module, exports) {
$parcel$export(module.exports, "SpinnerContainer", () => $17b936d8786ee599$export$a5e06607a5ac6158);
/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $17b936d8786ee599$var$spinnerContainerStyles = null;
const $17b936d8786ee599$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $9fU1q.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("hKWkq", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f79aecd87780716$export$2e2bcd8739ae039);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $hDkm2 = parcelRequire("hDkm2");
const $1f79aecd87780716$var$containerStyles = null;
const $1f79aecd87780716$var$Container = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $9fU1q.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $1f79aecd87780716$var$spinnerBackdropStyles = null;
const $1f79aecd87780716$var$SpinnerBackdrop = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $9fU1q.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $1f79aecd87780716$var$spinnerContainerStyles = null;
const $1f79aecd87780716$var$SpinnerContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        className: (0, $9fU1q.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));
class $1f79aecd87780716$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: 'large',
        contentsOpacity: "var(--ds-opacity-loading, 0.2)",
        loadingLabel: 'Loading table'
    };
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this$spinnerRef, _this$containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsxs)($1f79aecd87780716$var$Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $dc70d.jsx)($1f79aecd87780716$var$SpinnerBackdrop, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)($1f79aecd87780716$var$SpinnerContainer, {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});

parcelRegister("jL3xk", function(module, exports) {
$parcel$export(module.exports, "default", () => $33730e722547b4e1$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $8xmRs = parcelRequire("8xmRs");
class $33730e722547b4e1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8xmRs.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("8xmRs", function(module, exports) {
$parcel$export(module.exports, "default", () => $09da2769d1dad1eb$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $bHzUe = parcelRequire("bHzUe");

var $dpxPQ = parcelRequire("dpxPQ");

var $l9Ysx = parcelRequire("l9Ysx");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $gFOy5 = parcelRequire("gFOy5");

var $gniKC = parcelRequire("gniKC");

var $kWpXB = parcelRequire("kWpXB");

var $6t79k = parcelRequire("6t79k");

var $2utp7 = parcelRequire("2utp7");
const $09da2769d1dad1eb$var$styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const $09da2769d1dad1eb$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: undefined,
    packageVersion: undefined
};
function $09da2769d1dad1eb$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($dpxPQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx)));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "span",
        xcss: $09da2769d1dad1eb$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
}
function $09da2769d1dad1eb$var$InnerPagination({ components: components = (0, $6t79k.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $6t79k.emptyObject), max: max = 7, onChange: onChange = (0, $1OdZP.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $kWpXB.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $bHzUe.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$09da2769d1dad1eb$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
            as: "li",
            xcss: $09da2769d1dad1eb$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gniKC.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $gFOy5.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)($09da2769d1dad1eb$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $09da2769d1dad1eb$var$styles.paginationMenu,
                    children: (0, $2utp7.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $gFOy5.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)($09da2769d1dad1eb$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $09da2769d1dad1eb$var$Pagination = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)($09da2769d1dad1eb$var$InnerPagination));
var $09da2769d1dad1eb$export$2e2bcd8739ae039 = $09da2769d1dad1eb$var$Pagination;

});
parcelRegister("dpxPQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea16940a5b16b575a448de9712a73f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c37db2700c556b9$var$_react = $9c37db2700c556b9$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $9c37db2700c556b9$var$_iconNew = $9c37db2700c556b9$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $9c37db2700c556b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-left
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c37db2700c556b9$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $9c37db2700c556b9$var$_react.default.createElement($9c37db2700c556b9$var$_iconNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$9c37db2700c556b9$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $9c37db2700c556b9$var$_default = module.exports.default = $9c37db2700c556b9$var$ChevronLeftIcon;

});

parcelRegister("gFOy5", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4dbbd29ddd67af4$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hzFIQ = parcelRequire("hzFIQ");
function $e4dbbd29ddd67af4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hzFIQ.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("gniKC", function(module, exports) {
$parcel$export(module.exports, "default", () => $48b4e0e71ccbe3b8$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hzFIQ = parcelRequire("hzFIQ");
function $48b4e0e71ccbe3b8$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hzFIQ.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("kWpXB", function(module, exports) {
$parcel$export(module.exports, "default", () => $055712f87236f1e1$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $9Abbn = parcelRequire("9Abbn");
const $055712f87236f1e1$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $055712f87236f1e1$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "li",
        testId: testId,
        xcss: $055712f87236f1e1$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $8aT4G.Text), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9Abbn.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("6t79k", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $3e3ffe8628be648b$export$3f860eba1218f8d3);
const $3e3ffe8628be648b$export$3f860eba1218f8d3 = {};

});

parcelRegister("2utp7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aa8acaa0b322bff$export$2e2bcd8739ae039);

var $57l7A = parcelRequire("57l7A");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $0aa8acaa0b322bff$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $57l7A.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $0aa8acaa0b322bff$export$2e2bcd8739ae039 = $0aa8acaa0b322bff$var$collapseRange;

});



parcelRegister("fOR0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $02ee53b26b1709c3$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $aV68g = parcelRequire("aV68g");

var $8e7OP = parcelRequire("8e7OP");

var $29dZ2 = parcelRequire("29dZ2");

var $gEeXH = parcelRequire("gEeXH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $02ee53b26b1709c3$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aV68g.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aV68g.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $29dZ2.default) : (0, $gEeXH.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8e7OP.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $dc70d.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $dc70d.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$02ee53b26b1709c3$export$2e2bcd8739ae039 = $02ee53b26b1709c3$var$TableHead;

});
parcelRegister("8e7OP", function(module, exports) {
$parcel$export(module.exports, "Head", () => $135f861c9638b3d3$export$e93312b7773dfcac);
/* head.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $135f861c9638b3d3$var$rankingStyles = null;
const $135f861c9638b3d3$var$headStyles = null;
const $135f861c9638b3d3$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $9fU1q.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};

});

parcelRegister("29dZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ace453013c785679$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kVWri = parcelRequire("kVWri");

var $iwq7k = parcelRequire("iwq7k");

var $gEeXH = parcelRequire("gEeXH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ace453013c785679$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $iwq7k.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gEeXH.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $ace453013c785679$var$RankableTableHeadCell = (0, $kVWri.default)($ace453013c785679$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ace453013c785679$export$2e2bcd8739ae039 = $ace453013c785679$var$RankableTableHeadCell;

});
parcelRegister("kVWri", function(module, exports) {
$parcel$export(module.exports, "default", () => $4144efd8800ea9eb$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
function $4144efd8800ea9eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("iwq7k", function(module, exports) {
$parcel$export(module.exports, "inlineStylesIfRanking", () => $87b82823e0275115$export$a601f1775e10043f);
const $87b82823e0275115$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};

});

parcelRegister("gEeXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $82f1f06874656e7a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $gEftm = parcelRequire("gEftm");

var $6uKO5 = parcelRequire("6uKO5");

var $9PwDt = parcelRequire("9PwDt");

var $6X9z7 = parcelRequire("6X9z7");

var $gXqq0 = parcelRequire("gXqq0");

var $lavtv = parcelRequire("lavtv");

var $h3vzG = parcelRequire("h3vzG");
const $82f1f06874656e7a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    truncateButtonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1ul9idpf _p12f1osq _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66",
    truncateHeaderWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _tzy4kb7n _u5f31b66 _1ul9idpf",
    truncateHiddenIconHeaderWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _tzy4idpf _18u010v4 _1ul9idpf",
    truncateTooltipWrapper: "_1ul9idpf _p12f1osq"
};
const $82f1f06874656e7a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06",
    truncateText: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1ule _1ul9idpf _1bto1l2s _o5721q9c"
};
const $82f1f06874656e7a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $bSJIT.useState)(false);
    const [isFocused, setIsFocused] = (0, $bSJIT.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $bSJIT.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $bSJIT.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $bSJIT.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $bSJIT.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $82f1f06874656e7a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
            content: sortOrder === 'ASC' ? ascendingSortTooltip : descendingSortTooltip,
            hasNewContentOnTriggerClick: true,
            children: (tooltipProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    role: "presentation",
                    xcss: isFixedSize && shouldTruncate ? $82f1f06874656e7a$var$styles.truncateTooltipWrapper : undefined,
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $gXqq0.Pressable), {
                        ...tooltipProps,
                        onClick: onClick,
                        xcss: isFixedSize && shouldTruncate ? $82f1f06874656e7a$var$styles.truncateButtonWrapper : $82f1f06874656e7a$var$styles.buttonWrapper,
                        "aria-roledescription": buttonAriaRoleDescription,
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
                                xcss: isFixedSize && shouldTruncate ? isVisibleIconOnlyHeader ? $82f1f06874656e7a$var$styles.truncateHiddenIconHeaderWrapper : $82f1f06874656e7a$var$styles.truncateHeaderWrapper : isVisibleIconOnlyHeader ? $82f1f06874656e7a$var$styles.hideIconHeaderWrapper : $82f1f06874656e7a$var$styles.visibleHeaderWrapper,
                                children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                    className: (0, $9fU1q.default)([
                                        $82f1f06874656e7a$var$headCellStyles.text,
                                        isFixedSize && shouldTruncate && $82f1f06874656e7a$var$headCellStyles.truncateText
                                    ]),
                                    children: content
                                })
                            }),
                            shouldRenderSortIcon && /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
                                xcss: isSortIconVisible ? $82f1f06874656e7a$var$styles.sortIconVisibleWrapper : $82f1f06874656e7a$var$styles.sortIconHiddenWrapper,
                                children: sortOrder === 'ASC' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6uKO5))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--up--icon`
                                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gEftm))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--down--icon`
                                })
                            })
                        ]
                    })
                })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h3vzG.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isFixedSize: isFixedSize,
        isSortable: isSortable,
        sortOrder: sortOrder,
        shouldTruncate: shouldTruncate,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$82f1f06874656e7a$export$2e2bcd8739ae039 = $82f1f06874656e7a$var$TableHeadCell;

});
parcelRegister("gEftm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a417dd35c32223c531e68a3b3a9c2a91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1ec624de8c39eba$var$_react = $c1ec624de8c39eba$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c1ec624de8c39eba$var$_iconNew = $c1ec624de8c39eba$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c1ec624de8c39eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-down
 * Usage guidance:
 * Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1ec624de8c39eba$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $c1ec624de8c39eba$var$_react.default.createElement($c1ec624de8c39eba$var$_iconNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$c1ec624de8c39eba$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $c1ec624de8c39eba$var$_default = module.exports.default = $c1ec624de8c39eba$var$ArrowDownIcon;

});

parcelRegister("6uKO5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::674db590f296a2f756724d798fd052ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ba9da4c93a509f9$var$_react = $4ba9da4c93a509f9$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4ba9da4c93a509f9$var$_iconNew = $4ba9da4c93a509f9$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4ba9da4c93a509f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ba9da4c93a509f9$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $4ba9da4c93a509f9$var$_react.default.createElement($4ba9da4c93a509f9$var$_iconNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$4ba9da4c93a509f9$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $4ba9da4c93a509f9$var$_default = module.exports.default = $4ba9da4c93a509f9$var$ArrowUpIcon;

});

parcelRegister("h3vzG", function(module, exports) {
$parcel$export(module.exports, "HeadCell", () => $7f60a2034dbbd11f$export$4e8024263ace498b);
/* head-cell.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fi1Kv = parcelRequire("fi1Kv");
const $7f60a2034dbbd11f$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $7f60a2034dbbd11f$var$overflowTruncateStyles = null;
const $7f60a2034dbbd11f$var$truncationWidthStyles = null;
const $7f60a2034dbbd11f$var$fixedSizeTruncateStyles = null;
const $7f60a2034dbbd11f$var$cellStyles = null;
const $7f60a2034dbbd11f$var$headCellBaseStyles = null;
const $7f60a2034dbbd11f$export$4e8024263ace498b = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $fi1Kv.getTruncationStyleVars)({
            width: width
        }),
        [$7f60a2034dbbd11f$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === 'ASC';
    const isDESC = sortOrder === 'DESC';
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $9fU1q.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});




parcelRegister("fD2U6", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("itmHl"),
    $kOunM("1lfsI"),
    $kOunM("48qMU")
]).then(()=>parcelRequire('8qf2z'));

});





parcelRegister("hUKoD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f85e0db71ea72367$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f85e0db71ea72367$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    manageProjectsPageTitle: {
        defaultMessage: 'Projects',
        description: 'Help center manage projects page title',
        id: 'manage.projects.page.title'
    },
    manageProjectsPageTitleGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Help center manage spaces page title',
        id: 'manage.projects.page.title-galaxia'
    },
    manageProjectsPageDescription: {
        defaultMessage: 'Manage your help content effectively by linking projects to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking projects to a help center</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.description'
    },
    manageProjectsPageDescriptionHelpHub: {
        defaultMessage: 'Manage spaces linked to your help center to organize help content and show customers only relevant resources.',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description.helphub'
    },
    manageProjectsPageDescriptionGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description-galaxia'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHC: {
        defaultMessage: 'All the projects in your site are always linked to your default help center, the resources will always be available in help center portal sections, virtual service agent, search and recently used request forms. <link>Learn more about projects in help centers</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.default.hc.description'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHCGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.default.hc.description-galaxia'
    },
    manageProjectPageToggleForDefaultLinking: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking'
    },
    manageProjectPageToggleForDefaultLinkingHelpHub: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking for help center',
        id: 'manage.projects.page.toggle.default.linking.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking for help center with Galaxia renaming',
        id: 'manage.projects.page.toggle.default.linking.galaxia.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking-galaxia'
    },
    linkedFilterLabel: {
        defaultMessage: 'Linked projects',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label'
    },
    linkedFilterLabelGalaxia: {
        defaultMessage: 'Linked spaces',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label-galaxia'
    },
    unlinkedFilterLabel: {
        defaultMessage: 'Unlinked projects',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label'
    },
    unlinkedFilterLabelGalaxia: {
        defaultMessage: 'Unlinked spaces',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label-galaxia'
    },
    searchProjectsPlaceholder: {
        defaultMessage: 'Search for projects',
        description: 'Placeholder for search projects input',
        id: 'manage.projects.page.search.placeholder'
    },
    searchProjectsPlaceholderGalaxia: {
        defaultMessage: 'Search for spaces',
        description: 'Placeholder for search spaces input',
        id: 'manage.projects.page.search.placeholder-galaxia'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title shown on the manage projects page when an unexpected error occurs',
        id: 'manage.projects.page.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error message body on the manage projects page prompting the user to retry',
        id: 'manage.projects.page.error.description'
    }
});

});

parcelRegister("5c0aQ", function(module, exports) {
$parcel$export(module.exports, "ProjectsList", () => (parcelRequire("4sO83")).default);

var $4sO83 = parcelRequire("4sO83");

});
parcelRegister("4sO83", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebf0453357e7169b$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $xb2jO = parcelRequire("xb2jO");

var $bNM2k = parcelRequire("bNM2k");
var $ebf0453357e7169b$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, {
    showErrorFlag: $xb2jO.showErrorFlag,
    showSuccessFlag: $xb2jO.showSuccessFlag
})((0, $bNM2k.default));

});
parcelRegister("bNM2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccaf880d82b7ac29$export$2e2bcd8739ae039);

var $3lo9L = parcelRequire("3lo9L");

var $bSJIT = parcelRequire("bSJIT");

var $dNCOm = parcelRequire("dNCOm");

var $5ohbZ = parcelRequire("5ohbZ");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $3rmIb = parcelRequire("3rmIb");

var $6WltM = parcelRequire("6WltM");

var $JD7lD = parcelRequire("JD7lD");

var $8HhhR = parcelRequire("8HhhR");

var $bNvXg = parcelRequire("bNvXg");

var $85rmf = parcelRequire("85rmf");

var $87QgR = parcelRequire("87QgR");

var $cExzV = parcelRequire("cExzV");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $haAAx = parcelRequire("haAAx");

var $51XYw = parcelRequire("51XYw");
parcelRequire("be5PR");
var $gwnkK = parcelRequire("gwnkK");

var $iFhIy = parcelRequire("iFhIy");
parcelRequire("504GW");
var $9JYtO = parcelRequire("9JYtO");

var $8Woq1 = parcelRequire("8Woq1");

var $39QnN = parcelRequire("39QnN");

var $89ztt = parcelRequire("89ztt");

var $kCVyg = parcelRequire("kCVyg");

var $9vY6t = parcelRequire("9vY6t");

var $csdPe = parcelRequire("csdPe");
const $ccaf880d82b7ac29$export$680c2e5e5eec1385 = 20;
const $ccaf880d82b7ac29$var$messagesMap = {
    [(0, $39QnN.ProjectsMappingOperations).LINK]: {
        [(0, $39QnN.ProjectsMappingMode).BULK]: {
            successTitle: (0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).bulkLinkSuccessTitleGalaxia : (0, $8Woq1.default).bulkLinkSuccessTitle,
            errorTitle: (0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).bulkLinkErrorTitleGalaxia : (0, $8Woq1.default).bulkLinkErrorTitle
        },
        [(0, $39QnN.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $8Woq1.default).linkSuccessTitle,
            errorTitle: (0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).linkErrorTitleGalaxia : (0, $8Woq1.default).linkErrorTitle
        }
    },
    [(0, $39QnN.ProjectsMappingOperations).UNLINK]: {
        [(0, $39QnN.ProjectsMappingMode).BULK]: {
            successTitle: (0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).bulkUnlinkSuccessTitleGalaxia : (0, $8Woq1.default).bulkUnlinkSuccessTitle,
            errorTitle: (0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).bulkUnlinkErrorTitleGalaxia : (0, $8Woq1.default).bulkUnlinkErrorTitle
        },
        [(0, $39QnN.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $8Woq1.default).unlinkSuccessTitle,
            errorTitle: (0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).unlinkErrorTitleGalaxia : (0, $8Woq1.default).unlinkErrorTitle
        }
    }
};
const $ccaf880d82b7ac29$var$ProjectsList = ({ projectsListFragmentKey: projectsListFragmentKey, searchQuery: searchQuery, selection: selection, isReadOnlyView: isReadOnlyView, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isBulkActionLoading, setIsBulkActionLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [selectedProjectsMap, setSelectedProjectsMap] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState({});
    const [modalVisibility, setModalVisibility] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState({
        [(0, $iFhIy.CANT_UNLINK_ALL_DIALOG)]: false,
        [(0, $iFhIy.UNLINK_CONFIRMATION_DIALOG)]: false
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const data = (0, $a2qIF.useFragment)((0, $3lo9L.default), projectsListFragmentKey);
    const { onLinkUnlinkProjects: onLinkUnlinkProjects } = (0, $gwnkK.useProjectMapping)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const selectedProjectsCount = Object.values(selectedProjectsMap).filter(Boolean).length;
    const disableSingleProjectActions = selectedProjectsCount > 0;
    const projects = data.edges || [];
    const handleProjectMapping = (selectedProjectIds, operationType, mappingStatus)=>{
        const getProjectName = ()=>{
            var _projects$find;
            return (_projects$find = projects.find((project)=>{
                var _project$node;
                return (project === null || project === void 0 || (_project$node = project.node) === null || _project$node === void 0 ? void 0 : _project$node.projectId) === selectedProjectIds[0];
            })) === null || _projects$find === void 0 || (_projects$find = _projects$find.node) === null || _projects$find === void 0 ? void 0 : _projects$find.name;
        };
        const mode = selectedProjectIds.length > 1 ? (0, $39QnN.ProjectsMappingMode).BULK : (0, $39QnN.ProjectsMappingMode).SINGLE;
        setIsBulkActionLoading(true);
        onLinkUnlinkProjects(selectedProjectIds, operationType, mappingStatus).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length
            }).fire();
            resetBulkSelection();
            showSuccessFlagAction($ccaf880d82b7ac29$var$messagesMap[operationType][mode].successTitle, mode === (0, $39QnN.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : {
                number: selectedProjectIds.length
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            showErrorFlagAction($ccaf880d82b7ac29$var$messagesMap[operationType][mode].errorTitle, (0, $8Woq1.default).genericErrorDescription, [], mode === (0, $39QnN.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : undefined);
            if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length,
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsBulkActionLoading(false);
            setModalVisibility({
                ...modalVisibility,
                [(0, $iFhIy.UNLINK_CONFIRMATION_DIALOG)]: false
            });
        });
    };
    const onBulkActionClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        const operation = selection === (0, $39QnN.ProjectsMappingStatus).LINKED ? (0, $39QnN.ProjectsMappingOperations).UNLINK : (0, $39QnN.ProjectsMappingOperations).LINK;
        if (selectedProjectIds.length === 0) return;
        if (operation === (0, $39QnN.ProjectsMappingOperations).UNLINK && selectedProjectIds.length === projects.length) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $iFhIy.CANT_UNLINK_ALL_DIALOG)]: true
            });
            return;
        }
        if (operation === (0, $39QnN.ProjectsMappingOperations).UNLINK) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $iFhIy.UNLINK_CONFIRMATION_DIALOG)]: true
            });
            return;
        }
        handleProjectMapping(selectedProjectIds, (0, $39QnN.ProjectsMappingOperations).LINK, selection);
    };
    const onUnlinkDialogButtonClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        setIsBulkActionLoading(true);
        handleProjectMapping(selectedProjectIds, (0, $39QnN.ProjectsMappingOperations).UNLINK, selection);
    };
    const isIndeterminate = !!(selectedProjectsCount > 0 && selectedProjectsCount < projects.length);
    const filteredProjects = projects.filter((project)=>{
        var _project$node2;
        return project === null || project === void 0 || (_project$node2 = project.node) === null || _project$node2 === void 0 || (_project$node2 = _project$node2.name) === null || _project$node2 === void 0 ? void 0 : _project$node2.toLowerCase().includes(searchQuery.toLowerCase());
    });
    const resetBulkSelection = ()=>{
        setIsChecked(false);
        setSelectedProjectsMap({});
    };
    // whenever the selection changes, reset the selected projects
    (0, $bSJIT.useEffect)(()=>{
        resetBulkSelection();
    }, [
        selection
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // If all projects are selected one by one, check the select all checkbox
        if (selectedProjectsCount === filteredProjects.length) setIsChecked(true);
        // If all projects are unselected one by one, uncheck the select all checkbox
        if (selectedProjectsCount === 0) setIsChecked(false);
    }, [
        selectedProjectsCount,
        filteredProjects.length
    ]);
    const onChangeHandler = ()=>{
        const selectionMap = {};
        setSelectedProjectsMap(isChecked ? selectionMap : filteredProjects.reduce((acc, project)=>{
            var _project$node3, _project$node4;
            if (!(project !== null && project !== void 0 && (_project$node3 = project.node) !== null && _project$node3 !== void 0 && _project$node3.projectId)) return acc;
            acc[project === null || project === void 0 || (_project$node4 = project.node) === null || _project$node4 === void 0 ? void 0 : _project$node4.projectId] = true;
            return acc;
        }, selectionMap));
        setIsChecked(!isChecked);
    };
    const head = {
        cells: [
            ...isReadOnlyView ? [] : [
                {
                    key: 'select-all',
                    content: // eslint-disable-next-line @atlassian/a11y/role-supports-aria-props -- Disabling existing violation, should be fixed when revisited.
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
                        "aria-checked": isChecked,
                        isChecked: isChecked,
                        isIndeterminate: isIndeterminate,
                        onChange: onChangeHandler,
                        "aria-label": (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).selectAllProjectsCheckboxLabelGalaxia) : formatMessage((0, $kCVyg.default).selectAllProjectsCheckboxLabel),
                        name: "select-all-checkbox"
                    }),
                    width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
                }
            ],
            {
                key: 'project-name',
                content: 'Project',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                key: 'lead-name',
                content: 'Lead',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            ...isReadOnlyView ? [] : [
                {
                    key: 'status',
                    content: 'Status',
                    width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH).status
                },
                {
                    key: 'action-button',
                    content: 'Actions',
                    width: (0, $iFhIy.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
                }
            ]
        ]
    };
    const toggleProjectSelect = (projectId)=>{
        setSelectedProjectsMap((prevState)=>({
                ...prevState,
                [projectId]: !prevState[projectId]
            }));
    };
    const rows = filteredProjects.map((project)=>{
        var _project$node5, _project$node6, _project$node7, _project$node8, _project$node0, _project$node1, _project$node10, _project$node11, _project$node12, _project$node13, _project$node14, _project$node15, _project$node16, _project$node17, _project$node18, _project$node19;
        return {
            key: (project === null || project === void 0 || (_project$node5 = project.node) === null || _project$node5 === void 0 ? void 0 : _project$node5.projectId) || (project === null || project === void 0 || (_project$node6 = project.node) === null || _project$node6 === void 0 ? void 0 : _project$node6.name),
            isHighlighted: selectedProjectsMap[(project === null || project === void 0 || (_project$node7 = project.node) === null || _project$node7 === void 0 ? void 0 : _project$node7.projectId) || ''],
            cells: [
                ...isReadOnlyView ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
                            isChecked: !!selectedProjectsMap[(project === null || project === void 0 || (_project$node8 = project.node) === null || _project$node8 === void 0 ? void 0 : _project$node8.projectId) || ''],
                            onChange: ()=>{
                                var _project$node9;
                                return toggleProjectSelect((project === null || project === void 0 || (_project$node9 = project.node) === null || _project$node9 === void 0 ? void 0 : _project$node9.projectId) || '');
                            },
                            name: "select-checkbox",
                            "aria-label": (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).selectProjectCheckboxLabelGalaxia) : formatMessage((0, $kCVyg.default).selectProjectCheckboxLabel)
                        })
                    }
                ],
                {
                    key: project === null || project === void 0 || (_project$node0 = project.node) === null || _project$node0 === void 0 ? void 0 : _project$node0.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3rmIb.default), {
                        target: "_blank",
                        href: (project === null || project === void 0 || (_project$node1 = project.node) === null || _project$node1 === void 0 ? void 0 : _project$node1.webUrl) || '#'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050",
                        paddingInlineEnd: "space.100"
                    }, (project === null || project === void 0 || (_project$node10 = project.node) === null || _project$node10 === void 0 || (_project$node10 = _project$node10.avatar) === null || _project$node10 === void 0 ? void 0 : _project$node10.small) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
                        size: "small",
                        appearance: "square",
                        src: project === null || project === void 0 || (_project$node11 = project.node) === null || _project$node11 === void 0 || (_project$node11 = _project$node11.avatar) === null || _project$node11 === void 0 ? void 0 : _project$node11.small,
                        name: project === null || project === void 0 || (_project$node12 = project.node) === null || _project$node12 === void 0 || (_project$node12 = _project$node12.avatar) === null || _project$node12 === void 0 ? void 0 : _project$node12.small
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, project === null || project === void 0 || (_project$node13 = project.node) === null || _project$node13 === void 0 ? void 0 : _project$node13.name)))
                },
                {
                    key: project === null || project === void 0 || (_project$node14 = project.node) === null || _project$node14 === void 0 || (_project$node14 = _project$node14.lead) === null || _project$node14 === void 0 ? void 0 : _project$node14.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                        paddingInlineEnd: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
                        size: "small",
                        appearance: "circle",
                        src: project === null || project === void 0 || (_project$node15 = project.node) === null || _project$node15 === void 0 || (_project$node15 = _project$node15.lead) === null || _project$node15 === void 0 ? void 0 : _project$node15.picture,
                        name: project === null || project === void 0 || (_project$node16 = project.node) === null || _project$node16 === void 0 || (_project$node16 = _project$node16.lead) === null || _project$node16 === void 0 ? void 0 : _project$node16.picture
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, project === null || project === void 0 || (_project$node17 = project.node) === null || _project$node17 === void 0 || (_project$node17 = _project$node17.lead) === null || _project$node17 === void 0 ? void 0 : _project$node17.name))
                },
                ...isReadOnlyView ? [] : [
                    {
                        content: selection === (0, $39QnN.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
                            appearance: "success"
                        }, formatMessage((0, $kCVyg.default).projectsListLinkedLozengeLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), null, formatMessage((0, $kCVyg.default).projectsListUnlinkedLozengeLabel))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9JYtO.default), {
                            isDisabled: disableSingleProjectActions,
                            projectId: (project === null || project === void 0 || (_project$node18 = project.node) === null || _project$node18 === void 0 ? void 0 : _project$node18.projectId) || '',
                            projectName: (project === null || project === void 0 || (_project$node19 = project.node) === null || _project$node19 === void 0 ? void 0 : _project$node19.name) || '',
                            selection: selection,
                            isLastProject: projects.length === 1,
                            onLinkUnlinkProjects: onLinkUnlinkProjects
                        })
                    }
                ]
            ]
        };
    });
    // If user searches for a project that doesn't exist
    if (rows.length === 0 && searchQuery.trim() !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
        header: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).projectsListEmptySearchTitleGalaxia) : formatMessage((0, $kCVyg.default).projectsListEmptySearchTitle),
        description: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).projectsListEmptySearchDescriptionGalaxia) : formatMessage((0, $kCVyg.default).projectsListEmptySearchDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5ohbZ)))
    });
    // If no projects are linked to the help center and the user is in the linked tab
    if (rows.length === 0 && selection === (0, $39QnN.ProjectsMappingStatus).LINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
        header: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).noLinkedProjectsTitleGalaxia) : formatMessage((0, $kCVyg.default).noLinkedProjectsTitle),
        description: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).noLinkedProjectsDescriptionGalaxia) : formatMessage((0, $kCVyg.default).noLinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dNCOm)))
    });
    // If no projects are linked to the help center and the user is in the unlinked tab
    if (rows.length === 0 && selection === (0, $39QnN.ProjectsMappingStatus).UNLINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
        header: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).noUnlinkedProjectsTitleGalaxia) : formatMessage((0, $kCVyg.default).noUnlinkedProjectsTitle),
        description: (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kCVyg.default).noUnlinkedProjectsDescriptionGalaxia) : formatMessage((0, $kCVyg.default).noUnlinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dNCOm)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $ccaf880d82b7ac29$var$tableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $89ztt.BulkActionToolbar), {
        selectedProjectsCount: selectedProjectsCount,
        selection: selection,
        onBulkActionClick: onBulkActionClick,
        isLoading: isBulkActionLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bNvXg.default), {
        head: head,
        rows: rows,
        rowsPerPage: $ccaf880d82b7ac29$export$680c2e5e5eec1385,
        defaultPage: 1,
        isFixedSize: true,
        defaultSortKey: "project-name",
        defaultSortOrder: "ASC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $csdPe.UnlinkConfirmationModal), {
        isOpen: modalVisibility[0, $iFhIy.UNLINK_CONFIRMATION_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $iFhIy.UNLINK_CONFIRMATION_DIALOG)]: false
            }),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: modalVisibility[0, $iFhIy.UNLINK_CONFIRMATION_DIALOG] && isBulkActionLoading,
        numberOfProjects: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9vY6t.UnlinkAllProjectsWarningModal), {
        isOpen: modalVisibility[0, $iFhIy.CANT_UNLINK_ALL_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $iFhIy.CANT_UNLINK_ALL_DIALOG)]: false
            })
    }));
};
const $ccaf880d82b7ac29$var$tableStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    // @ts-expect-error @atlaskit/ui-styling-standard/no-nested-selectors
    th: {
        height: '100%',
        verticalAlign: 'middle'
    },
    marginBottom: 'space.100'
});
var $ccaf880d82b7ac29$export$2e2bcd8739ae039 = $ccaf880d82b7ac29$var$ProjectsList;

});
parcelRegister("3lo9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $41a23f6dbaa84f3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a4a61aea1d2ec868b83ec14a0afe25a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41a23f6dbaa84f3b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectsListFragment",
        "selections": [
            {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "small"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProjectConnection"
    };
}();
$41a23f6dbaa84f3b$var$node.hash = "3eeb7301918e0096af7f6ae5ad2df33f";
var $41a23f6dbaa84f3b$export$2e2bcd8739ae039 = $41a23f6dbaa84f3b$var$node;

});

parcelRegister("dNCOm", function(module, exports) {
module.exports = new URL("../images/project-mapping-empty.93914303.svg", import.meta.url).toString();

});

parcelRegister("5ohbZ", function(module, exports) {
module.exports = new URL("../images/project-mapping-search-no-match.507a41ed.svg", import.meta.url).toString();

});

parcelRegister("be5PR", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => (parcelRequire("gwnkK")).useProjectMapping);

var $gwnkK = parcelRequire("gwnkK");

});
parcelRegister("gwnkK", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => $889d9442391d7d93$export$79a4e4154c8382d5);

var $4cx0f = parcelRequire("4cx0f");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fuVmc = parcelRequire("fuVmc");

var $a2qIF = parcelRequire("a2qIF");

var $9R3gt = parcelRequire("9R3gt");
const $889d9442391d7d93$export$79a4e4154c8382d5 = ()=>{
    const cloudId = (0, $fuVmc.getCloudId)();
    const helpCenterAri = (0, $9R3gt.useHelpCenterAri)();
    const [linkUnlinkProject] = (0, $a2qIF.useMutation)((0, $4cx0f.default));
    const removeSelectedProjects = (0, $bSJIT.useCallback)((store, selection, projectIds)=>{
        var _root$getLinkedRecord;
        const root = store.getRoot();
        const connection = root === null || root === void 0 || (_root$getLinkedRecord = root.getLinkedRecord('jira')) === null || _root$getLinkedRecord === void 0 ? void 0 : _root$getLinkedRecord.getLinkedRecord('jiraProjectsMappedToHelpCenter', {
            cloudId: (0, $fuVmc.getCloudId)(),
            filter: {
                helpCenterId: '',
                helpCenterARI: helpCenterAri,
                helpCenterMappingStatus: selection
            }
        });
        if (connection) {
            const connectionEdges = connection === null || connection === void 0 ? void 0 : connection.getLinkedRecords('edges');
            if (connectionEdges) {
                const newEdges = connectionEdges.filter((edge)=>{
                    var _edge$getLinkedRecord;
                    return !projectIds.includes(edge === null || edge === void 0 || (_edge$getLinkedRecord = edge.getLinkedRecord('node')) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getValue('projectId'));
                });
                connection === null || connection === void 0 || connection.setLinkedRecords(newEdges, 'edges');
            }
        }
        root.invalidateRecord();
    }, [
        helpCenterAri
    ]);
    const onLinkUnlinkProjects = (projectIds, operationType, selection)=>{
        return new Promise((resolve, reject)=>linkUnlinkProject({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        projectIds: projectIds,
                        operationType: operationType
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) removeSelectedProjects(store, selection, projectIds);
                },
                onCompleted: (response)=>{
                    var _response$helpCenter2, _response$helpCenter3, _error$extensions;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateProjectMapping) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $jcRK7.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    };
    return {
        onLinkUnlinkProjects: onLinkUnlinkProjects
    };
};

});
parcelRegister("4cx0f", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f383b3b52add393$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<230b086af7211b5fc150b7f52ae6b010>>
 * @relayHash db52eedba06b2bb692fa79d38cecc6eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f
const $0f383b3b52add393$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f",
            "metadata": {},
            "name": "useProjectMappingLinkUnlinkMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0f383b3b52add393$var$node.hash = "90453dabffd73b96361b3ab3d4d31c32";
var $0f383b3b52add393$export$2e2bcd8739ae039 = $0f383b3b52add393$var$node;

});



parcelRegister("504GW", function(module, exports) {
$parcel$export(module.exports, "LinkUnlinkProject", () => (parcelRequire("9JYtO")).default);

var $9JYtO = parcelRequire("9JYtO");

});
parcelRegister("9JYtO", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a4835c5e0b4055$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $xb2jO = parcelRequire("xb2jO");

var $iP57Q = parcelRequire("iP57Q");
var $94a4835c5e0b4055$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, {
    showErrorFlag: $xb2jO.showErrorFlag,
    showSuccessFlag: $xb2jO.showSuccessFlag
})((0, $iP57Q.default));

});
parcelRegister("iP57Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9e1eb4ca962a7b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $26Jy2 = parcelRequire("26Jy2");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $juI4y = parcelRequire("juI4y");

var $kxIlX = parcelRequire("kxIlX");

var $clpci = parcelRequire("clpci");

var $haAAx = parcelRequire("haAAx");

var $iydAA = parcelRequire("iydAA");

var $51XYw = parcelRequire("51XYw");

var $csdPe = parcelRequire("csdPe");

var $39QnN = parcelRequire("39QnN");

var $8Woq1 = parcelRequire("8Woq1");
const $2e9e1eb4ca962a7b$var$LinkUnlinkProject = ({ projectId: projectId, projectName: projectName, selection: selection, isLastProject: isLastProject, isDisabled: isDisabled, onLinkUnlinkProjects: onLinkUnlinkProjects, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [openUnlinkDialog, setOpenUnlinkDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isUnlinking, setIsUnlinking] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isLinking, setIsLinking] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [isLastUnlink, setIsLastUnlink] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const onLinkProject = (0, $bSJIT.useCallback)(()=>{
        setIsLinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $39QnN.ProjectsMappingOperations).LINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                operation: 'single',
                bulkOperation: false,
                mapStatus: (0, $39QnN.ProjectsMappingOperations).LINK,
                projectCount: 1
            }).fire();
            showSuccessFlagAction((0, $8Woq1.default).linkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $39QnN.ProjectsMappingOperations).LINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            showErrorFlagAction((0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).linkErrorTitleGalaxia : (0, $8Woq1.default).linkErrorTitle, (0, $8Woq1.default).genericErrorDescription, [], {
                projectName: projectName
            });
        }).finally(()=>{
            setIsLinking(false);
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        selection,
        showSuccessFlagAction,
        projectName,
        showErrorFlagAction,
        createAnalyticsEvent
    ]);
    const onUnLinkProject = (0, $bSJIT.useCallback)(()=>{
        if (isLastProject) setIsLastUnlink(true);
        else setOpenUnlinkDialog(true);
    }, [
        isLastProject
    ]);
    const onUnlinkDialogButtonClick = (0, $bSJIT.useCallback)(()=>{
        setIsUnlinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $39QnN.ProjectsMappingOperations).UNLINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $39QnN.ProjectsMappingOperations).UNLINK,
                projectCount: 1
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showSuccessFlagAction((0, $8Woq1.default).unlinkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $39QnN.ProjectsMappingOperations).UNLINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showErrorFlagAction((0, $87QgR.default).checkGate('itsm-project-renaming') ? (0, $8Woq1.default).unlinkErrorTitleGalaxia : (0, $8Woq1.default).unlinkErrorTitle, (0, $8Woq1.default).genericErrorDescription, [], {
                projectName: projectName
            });
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        projectName,
        selection,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent
    ]);
    const contentCallback = (0, $bSJIT.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
            sourceType: (0, $clpci.INLINE_DIALOG),
            sourceName: "lastProjectUnlink"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $2e9e1eb4ca962a7b$var$unlinkDialogPopupStyles
        }, (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $8Woq1.default).lastProjectUnlinkGalaxia) : formatMessage((0, $8Woq1.default).lastProjectUnlink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
    }, [
        formatMessage
    ]);
    const triggerCallback = (0, $bSJIT.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.LoadingButton), {
            ...triggerProps,
            appearance: "link",
            actionSubjectId: "projectUnLink",
            onClick: onUnLinkProject,
            isLoading: isLinking,
            isDisabled: isDisabled
        }, formatMessage((0, $8Woq1.default).projectsListUnlinkButtonText));
    }, [
        formatMessage,
        isLinking,
        onUnLinkProject,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, selection === (0, $39QnN.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        isOpen: isLastUnlink,
        onClose: ()=>setIsLastUnlink(false),
        placement: "bottom-end",
        zIndex: (0, $juI4y.layers).modal(),
        content: contentCallback,
        trigger: triggerCallback
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.LoadingButton), {
        actionSubjectId: "projectLink",
        appearance: "link",
        onClick: onLinkProject,
        isLoading: isLinking,
        isDisabled: isDisabled
    }, formatMessage((0, $8Woq1.default).projectsListLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $csdPe.UnlinkConfirmationModal), {
        isOpen: openUnlinkDialog,
        onClose: ()=>setOpenUnlinkDialog(false),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: isUnlinking,
        numberOfProjects: 1
    }));
};
const $2e9e1eb4ca962a7b$var$unlinkDialogPopupStyles = (0, $9BVpB.xcss)({
    maxWidth: '230px',
    padding: 'space.200'
});
var $2e9e1eb4ca962a7b$export$2e2bcd8739ae039 = $2e9e1eb4ca962a7b$var$LinkUnlinkProject;

});
parcelRegister("csdPe", function(module, exports) {
$parcel$export(module.exports, "UnlinkConfirmationModal", () => $133afbc26acadebd$export$42f5f02e8155f94);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $4vLTk = parcelRequire("4vLTk");

var $87QgR = parcelRequire("87QgR");

var $c9mVs = parcelRequire("c9mVs");

var $2w1u7 = parcelRequire("2w1u7");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $cYliB = parcelRequire("cYliB");
const $133afbc26acadebd$export$42f5f02e8155f94 = ({ isOpen: isOpen, onClose: onClose, onUnlink: onUnlink, isLoading: isLoading, projectName: projectName, numberOfProjects: numberOfProjects })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    let modalTitle;
    let modalDescription;
    if (numberOfProjects > 1) {
        modalTitle = (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $cYliB.default).bulkUnlinkModalTitleGalaxia, {
            number: numberOfProjects
        }) : formatMessage((0, $cYliB.default).bulkUnlinkModalTitle, {
            number: numberOfProjects
        });
        modalDescription = (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $cYliB.default).bulkUnlinkModalDescGalaxia) : formatMessage((0, $cYliB.default).bulkUnlinkModalDesc);
    } else {
        modalTitle = (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $cYliB.default).unlinkModalTitleGalaxia) : formatMessage((0, $cYliB.default).unlinkModalTitle);
        modalDescription = (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $cYliB.default).unlinkModalDescGalaxia, {
            projectName: projectName
        }) : formatMessage((0, $cYliB.default).unlinkModalDesc, {
            projectName: projectName
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
        appearance: "warning",
        testId: "help-center-unlink-modal-title"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, modalDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.LoadingButton), {
        onClick: onUnlink,
        isLoading: isLoading,
        appearance: "warning",
        actionSubjectId: "unlinkModalConfirmButton",
        testId: "unlink-modal-confirm-button"
    }, formatMessage((0, $cYliB.default).unlinkModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.Button), {
        onClick: onClose,
        appearance: "subtle",
        actionSubjectId: "unlinkModalCancelButton"
    }, formatMessage((0, $cYliB.default).unlinkModalCancelButton)))));
};

});
parcelRegister("cYliB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac184ce331ce7435$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ac184ce331ce7435$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    unlinkModalTitle: {
        defaultMessage: 'Unlink this project?',
        description: 'Unlink project confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title'
    },
    unlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink this space?',
        description: 'Unlink space confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title-galaxia'
    },
    unlinkModalDesc: {
        defaultMessage: `All help resources from the project {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description'
    },
    unlinkModalDescGalaxia: {
        defaultMessage: `All help resources from the space {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description-galaxia'
    },
    bulkUnlinkModalTitle: {
        defaultMessage: 'Unlink {number} projects?',
        description: 'Unlink project confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title'
    },
    bulkUnlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink {number} spaces?',
        description: 'Unlink space confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title-galaxia'
    },
    bulkUnlinkModalDesc: {
        defaultMessage: `All help resources from these projects will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description'
    },
    bulkUnlinkModalDescGalaxia: {
        defaultMessage: `All help resources from these spaces will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description-galaxia'
    },
    unlinkModalConfirmButton: {
        defaultMessage: 'Unlink',
        description: 'Unlink project confirmation modal confirm button',
        id: 'projects.list.unlink.confirmation.modal.confirm.button'
    },
    unlinkModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Unlink project confirmation modal cancel button',
        id: 'projects.list.unlink.confirmation.modal.cancel.button'
    }
});

});


parcelRegister("39QnN", function(module, exports) {
$parcel$export(module.exports, "ProjectsMappingStatus", () => $b7da7dae74c418d6$export$eaf9dd2a52d05588);
$parcel$export(module.exports, "ProjectsMappingMode", () => $b7da7dae74c418d6$export$6998efd89043b35d);
$parcel$export(module.exports, "ProjectsMappingOperations", () => $b7da7dae74c418d6$export$d0c0bb49dfced741);
var $b7da7dae74c418d6$export$eaf9dd2a52d05588 = /*#__PURE__*/ function(ProjectsMappingStatus) {
    ProjectsMappingStatus["UNLINKED"] = "UNLINKED";
    ProjectsMappingStatus["LINKED"] = "LINKED";
    ProjectsMappingStatus["ALL"] = "ALL";
    return ProjectsMappingStatus;
}({});
var $b7da7dae74c418d6$export$6998efd89043b35d = /*#__PURE__*/ function(ProjectsMappingMode) {
    ProjectsMappingMode["BULK"] = "bulk";
    ProjectsMappingMode["SINGLE"] = "single";
    return ProjectsMappingMode;
}({});
var $b7da7dae74c418d6$export$d0c0bb49dfced741 = /*#__PURE__*/ function(ProjectsMappingOperations) {
    ProjectsMappingOperations["UNLINK"] = "UNMAP_PROJECTS";
    ProjectsMappingOperations["LINK"] = "MAP_PROJECTS";
    return ProjectsMappingOperations;
}({});

});

parcelRegister("8Woq1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce4978fd19cd58f9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ce4978fd19cd58f9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.link.unlink.button.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.link.unlink.button.unlink.button.text'
    },
    unlinkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is no longer linked to this help center",
        description: 'Unlink space flag success title',
        id: 'projects.link.unlink.button.unlink.flag.success.title'
    },
    linkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is now linked to this help center",
        description: 'Success flag title shown after a space is linked to the help center',
        id: 'projects.link.unlink.button.link.flag.success.title'
    },
    bulkLinkSuccessTitle: {
        defaultMessage: '{number} projects are now linked to this help center',
        description: 'Bulk link project flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title'
    },
    bulkLinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces are now linked to this help center',
        description: 'Bulk link space flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title-galaxia'
    },
    bulkLinkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the selected projects",
        description: 'Bulk link project flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title'
    },
    bulkLinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the selected spaces",
        description: 'Bulk link space flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title-galaxia'
    },
    bulkUnlinkSuccessTitle: {
        defaultMessage: '{number} projects have been unlinked from this help center',
        description: 'Bulk unlink projects flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title'
    },
    bulkUnlinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces have been unlinked from this help center',
        description: 'Bulk unlink spaces flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title-galaxia'
    },
    bulkUnlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the selected projects",
        description: 'Bulk unlink projects flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title'
    },
    bulkUnlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the selected spaces",
        description: 'Bulk unlink spaces flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title-galaxia'
    },
    unlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the projects \u2018{projectName}\u2019",
        description: 'Unlink project flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title'
    },
    unlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the spaces \u2018{projectName}\u2019",
        description: 'Error flag title shown when a space could not be unlinked from the help center',
        id: 'projects.link.unlink.button.unlink.flag.error.title-galaxia'
    },
    linkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the project \u2019{projectName}\u2019",
        description: 'Error flag title shown when a project could not be linked to the help center',
        id: 'projects.link.unlink.button.link.flag.error.title'
    },
    linkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the space \u2018{projectName}\u2019",
        description: 'Error flag title shown when a space could not be linked to the help center',
        id: 'projects.link.unlink.button.link.flag.error.title-galaxia'
    },
    genericErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Unlink project flag error description',
        id: 'projects.link.unlink.button.flag.generic.error.description'
    },
    lastProjectUnlink: {
        defaultMessage: 'Your help center needs at least one linked project to ensure that your customers can access relevant information and resources.',
        description: 'Last project unlink project dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content'
    },
    lastProjectUnlinkGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space to ensure that your customers can access relevant information and resources.',
        description: 'Last space unlink space dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content-galaxia'
    }
});

});




parcelRegister("89ztt", function(module, exports) {
$parcel$export(module.exports, "BulkActionToolbar", () => $d126711aee4ef5bc$export$522b8308f1751ff5);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $4vLTk = parcelRequire("4vLTk");

var $1c4Ad = parcelRequire("1c4Ad");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $39QnN = parcelRequire("39QnN");

var $kCVyg = parcelRequire("kCVyg");

var $ab3Ud = parcelRequire("ab3Ud");
const $d126711aee4ef5bc$export$522b8308f1751ff5 = ({ selectedProjectsCount: selectedProjectsCount, selection: selection, onBulkActionClick: onBulkActionClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isVisible = selectedProjectsCount > 0;
    const toolbarAccessibilityLabelMessage = isVisible ? formatMessage((0, $ab3Ud.default).toolbarAccessibilityLabel) : '';
    const buttonText = selection === (0, $39QnN.ProjectsMappingStatus).LINKED ? formatMessage((0, $kCVyg.default).projectsListUnlinkButtonText) : formatMessage((0, $kCVyg.default).projectsListLinkButtonText);
    const actionSubjectId = selection === (0, $39QnN.ProjectsMappingStatus).LINKED ? 'bulkActionUnLinkButton' : 'bulkActionLinkButton';
    return isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $d126711aee4ef5bc$var$bulkActionToolbarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "span",
        xcss: $d126711aee4ef5bc$var$projectsCountTextStyles,
        role: "status"
    }, formatMessage((0, $ab3Ud.default).selectedProjectsText, {
        count: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $d126711aee4ef5bc$var$invisibleA11yTitleStyles,
        tabIndex: -1
    }, toolbarAccessibilityLabelMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.LoadingButton), {
        testId: "bulk-action-button",
        actionSubjectId: actionSubjectId,
        onClick: onBulkActionClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1c4Ad))), {
            label: buttonText,
            size: "small",
            spacing: "spacious"
        }),
        isLoading: isLoading,
        spacing: "compact"
    }, buttonText));
};
const $d126711aee4ef5bc$var$bulkActionToolbarContainerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    width: '96%',
    top: 'space.0',
    left: '4%',
    backgroundColor: 'elevation.surface',
    zIndex: 'layer',
    color: 'color.text.subtle',
    paddingBlock: 'space.050',
    paddingInline: 'space.0',
    margin: 'space.0'
});
const $d126711aee4ef5bc$var$projectsCountTextStyles = (0, $9BVpB.xcss)({
    paddingRight: 'space.200'
});
const $d126711aee4ef5bc$var$invisibleA11yTitleStyles = (0, $9BVpB.xcss)({
    opacity: 0,
    position: 'absolute'
});

});
parcelRegister("1c4Ad", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8acf1a27a91c9466d89ec39a50a9bc59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0dea77896f891208$var$_react = $0dea77896f891208$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $0dea77896f891208$var$_iconNew = $0dea77896f891208$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $0dea77896f891208$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-broken
 * Usage guidance:
 * Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dea77896f891208$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $0dea77896f891208$var$_react.default.createElement($0dea77896f891208$var$_iconNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$0dea77896f891208$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $0dea77896f891208$var$_default = module.exports.default = $0dea77896f891208$var$LinkBrokenIcon;

});

parcelRegister("kCVyg", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc100d062e9ef295$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $fc100d062e9ef295$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    projectsListLinkedLozengeLabel: {
        defaultMessage: 'Linked',
        description: 'Projects list linked lozenge label',
        id: 'projects.list.linked.lozenge.label'
    },
    projectsListUnlinkedLozengeLabel: {
        defaultMessage: 'Unlinked',
        description: 'Projects list unlinked lozenge label',
        id: 'projects.list.unlinked.lozenge.label'
    },
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.list.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.list.unlink.button.text'
    },
    noUnlinkedProjectsDescription: {
        defaultMessage: "When you unlink projects, they\u2019ll appear here.",
        description: 'Projects list empty state description',
        id: 'projects.list.empty.description'
    },
    noUnlinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you unlink spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description',
        id: 'projects.list.empty.description-galaxia'
    },
    noUnlinkedProjectsTitle: {
        defaultMessage: 'All your projects are linked to this help center',
        description: 'Projects list empty state title',
        id: 'projects.list.empty.title'
    },
    noUnlinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces are linked to this help center',
        description: 'Empty state title shown in the spaces list when all spaces are linked to the help center',
        id: 'projects.list.empty.title-galaxia'
    },
    noLinkedProjectsDescription: {
        defaultMessage: "When you link projects, they\u2019ll appear here.",
        description: 'Projects list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab'
    },
    noLinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you link spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab-galaxia'
    },
    noLinkedProjectsTitle: {
        defaultMessage: 'All your projects have been unlinked from this help center',
        description: 'Projects list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab'
    },
    noLinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces have been unlinked from this help center',
        description: 'Spaces list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab-galaxia'
    },
    projectsListEmptySearchTitle: {
        defaultMessage: 'No projects found matching your search',
        description: 'Projects list empty search title',
        id: 'projects.list.empty.search.title'
    },
    projectsListEmptySearchTitleGalaxia: {
        defaultMessage: 'No spaces found matching your search',
        description: 'Spaces list empty search title',
        id: 'projects.list.empty.search.title-galaxia'
    },
    projectsListEmptySearchDescription: {
        defaultMessage: 'Try using specific project names or terms',
        description: 'Projects list empty search description',
        id: 'projects.list.empty.search.description'
    },
    projectsListEmptySearchDescriptionGalaxia: {
        defaultMessage: 'Try using specific space names or terms',
        description: 'Spaces list empty search description',
        id: 'projects.list.empty.search.description-galaxia'
    },
    selectAllProjectsCheckboxLabel: {
        defaultMessage: 'Select all projects',
        description: 'Checkbox label for selecting all projects',
        id: 'projects.list.select-all.projects.checkbox.label'
    },
    selectAllProjectsCheckboxLabelGalaxia: {
        defaultMessage: 'Select all spaces',
        description: 'Checkbox label for selecting all spaces',
        id: 'projects.list.select-all.projects.checkbox.label-galaxia'
    },
    selectProjectCheckboxLabel: {
        defaultMessage: 'Select project',
        description: 'Checkbox label for selecting a single project',
        id: 'projects.list.select.project.checkbox.label'
    },
    selectProjectCheckboxLabelGalaxia: {
        defaultMessage: 'Select space',
        description: 'Checkbox label for selecting a single space',
        id: 'projects.list.select.project.checkbox.label-galaxia'
    },
    columnHeaderSpace: {
        defaultMessage: 'Space',
        description: 'Spaces list column header space',
        id: 'spaces.list.column.header.space-galaxia'
    },
    columnHeaderLead: {
        defaultMessage: 'Lead',
        description: 'Spaces list column header lead',
        id: 'spaces.list.column.header.lead'
    },
    columnHeaderStatus: {
        defaultMessage: 'Status',
        description: 'Spaces list column header status',
        id: 'spaces.list.column.header.status'
    },
    columnHeaderActions: {
        defaultMessage: 'Actions',
        description: 'Spaces list column header actions',
        id: 'spaces.list.column.header.actions'
    }
});

});

parcelRegister("ab3Ud", function(module, exports) {
$parcel$export(module.exports, "default", () => $a93d137d8185e154$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a93d137d8185e154$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    selectedProjectsText: {
        defaultMessage: '{count, plural, one {1 selected} other { # selected}}',
        description: 'Text for displaying selected projects count',
        id: 'projects-list.bulk-action-toolbar.selected-spaces-text'
    },
    toolbarAccessibilityLabel: {
        defaultMessage: 'Actions for selected items are available before the table.',
        description: 'Accessibility label for the toolbar',
        id: 'projects-list.bulk-action-toolbar.toolbar-accessibility-label'
    }
});

});


parcelRegister("9vY6t", function(module, exports) {
$parcel$export(module.exports, "UnlinkAllProjectsWarningModal", () => $1440d729ed7807bc$export$b442637e98a0429b);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $4vLTk = parcelRequire("4vLTk");

var $87QgR = parcelRequire("87QgR");

var $c9mVs = parcelRequire("c9mVs");

var $2w1u7 = parcelRequire("2w1u7");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $kxIlX = parcelRequire("kxIlX");

var $clpci = parcelRequire("clpci");

var $iydAA = parcelRequire("iydAA");

var $gxMsa = parcelRequire("gxMsa");
const $1440d729ed7807bc$export$b442637e98a0429b = ({ isOpen: isOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceType: (0, $clpci.MODAL),
        sourceName: "helpCenterUnlinkAllWarning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
        testId: "help-center-unlink-all-projects-warning-modal-title"
    }, (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $gxMsa.default).unlinkAllWarningModalTitleGalaxia) : formatMessage((0, $gxMsa.default).unlinkAllWarningModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, (0, $87QgR.default).checkGate('itsm-project-renaming') ? formatMessage((0, $gxMsa.default).unlinkAllWarningModalDescriptionGalaxia) : formatMessage((0, $gxMsa.default).unlinkAllWarningModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.Button), {
        onClick: onClose,
        appearance: "primary",
        actionSubjectId: "unlinkAllWarningModalOkButton"
    }, formatMessage((0, $gxMsa.default).unlinkAllWarningModalOkButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
};

});
parcelRegister("gxMsa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2617adc3309b6b5c$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $2617adc3309b6b5c$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    unlinkAllWarningModalTitle: {
        defaultMessage: 'Your help center needs at least one linked project',
        description: 'Title of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.title'
    },
    unlinkAllWarningModalTitleGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space',
        description: 'Title of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.title-galaxia'
    },
    unlinkAllWarningModalDescription: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one project needs to be linked to your help center. Uncheck a project and try again.',
        description: 'Description of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.description'
    },
    unlinkAllWarningModalDescriptionGalaxia: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one space needs to be linked to your help center. Uncheck a space and try again.',
        description: 'Description of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.description-galaxia'
    },
    unlinkAllWarningModalOkButton: {
        defaultMessage: 'OK',
        description: 'Unlink all projects warning modal ok button',
        id: 'projects.list.unlink.all.warning.modal.ok.button'
    }
});

});





parcelRegister("355yQ", function(module, exports) {
$parcel$export(module.exports, "SyncProjectsToggle", () => (parcelRequire("1ioYQ")).default);

var $1ioYQ = parcelRequire("1ioYQ");

});
parcelRegister("1ioYQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $142b098124ee21de$export$2e2bcd8739ae039);
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $xb2jO = parcelRequire("xb2jO");

var $c2Iqq = parcelRequire("c2Iqq");
var $142b098124ee21de$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, {
    showErrorFlag: $xb2jO.showErrorFlag,
    showSuccessFlag: $xb2jO.showSuccessFlag
})((0, $c2Iqq.default));

});
parcelRegister("c2Iqq", function(module, exports) {
$parcel$export(module.exports, "default", () => $56f9cd092d61fd0d$export$2e2bcd8739ae039);

var $e3Och = parcelRequire("e3Och");

var $6PaDL = parcelRequire("6PaDL");

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $6WltM = parcelRequire("6WltM");

var $hzFIQ = parcelRequire("hzFIQ");

var $lebr5 = parcelRequire("lebr5");

var $87QgR = parcelRequire("87QgR");

var $c9mVs = parcelRequire("c9mVs");

var $2w1u7 = parcelRequire("2w1u7");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $eidO5 = parcelRequire("eidO5");

var $haAAx = parcelRequire("haAAx");

var $51XYw = parcelRequire("51XYw");

var $7xtOy = parcelRequire("7xtOy");

var $9R3gt = parcelRequire("9R3gt");

var $jGZps = parcelRequire("jGZps");
const $56f9cd092d61fd0d$var$SyncProjectsToggle = ({ syncProjectsToggleFragmentKey: syncProjectsToggleFragmentKey, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    var _helpCenterData$proje;
    const helpCenterData = (0, $a2qIF.useFragment)((0, $6PaDL.default), syncProjectsToggleFragmentKey);
    const [isChecked, setIsChecked] = (0, $bSJIT.useState)(!!(helpCenterData !== null && helpCenterData !== void 0 && (_helpCenterData$proje = helpCenterData.projectMappingData) !== null && _helpCenterData$proje !== void 0 && _helpCenterData$proje.syncNewProjects));
    const [isRemoveMappingDialogOpen, setRemoveMappingDialogOpen] = (0, $bSJIT.useState)(false);
    const [isUnSyncing, setIsUnSyncing] = (0, $bSJIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const helpCenterAri = (0, $9R3gt.useHelpCenterAri)();
    const { isHelpHub: isHelpHub } = (0, $7xtOy.useHelpCenterType)();
    const isProjectRenamingEnabled = (0, $87QgR.default).checkGate('itsm-project-renaming');
    let toggleLabel;
    if (isHelpHub && isProjectRenamingEnabled) toggleLabel = (0, $jGZps.default).defaultMappingToggleLabelGalaxiaHelpHub;
    else if (isHelpHub) toggleLabel = (0, $jGZps.default).defaultMappingToggleLabelHelpHub;
    else if (isProjectRenamingEnabled) toggleLabel = (0, $jGZps.default).defaultMappingToggleLabelGalaxia;
    else toggleLabel = (0, $jGZps.default).defaultMappingToggleLabel;
    const [toggleDefaultSync] = (0, $a2qIF.useMutation)((0, $e3Och.default));
    const onToggleDefault = (0, $bSJIT.useCallback)((syncNewProjects)=>{
        return new Promise((resolve, reject)=>toggleDefaultSync({
                variables: {
                    cloudId: (0, $fuVmc.getCloudId)(),
                    input: {
                        syncNewProjects: syncNewProjects,
                        helpCenterAri: helpCenterAri
                    }
                },
                onCompleted: (response)=>{
                    var _response$helpCenter, _response$helpCenter2;
                    if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) resolve(response);
                    const errors = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.errors;
                    const error = errors && errors.length > 0 ? errors[0] : new Error('Unknown error');
                    return reject(error);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    }, [
        toggleDefaultSync,
        helpCenterAri
    ]);
    const onToggleChange = (0, $bSJIT.useCallback)(()=>{
        if (isChecked) setRemoveMappingDialogOpen(true);
        else {
            setIsChecked(true);
            onToggleDefault(true).then(()=>{
                createAnalyticsEvent({
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    action: 'map',
                    actionSubject: 'newProjects',
                    toggleState: true
                }).fire();
            }).catch((error)=>{
                const { message: message, status: status } = error;
                setIsChecked(false);
                const errorTitle = isProjectRenamingEnabled ? (0, $jGZps.default).syncErrorTitleGalaxia : (0, $jGZps.default).syncErrorTitle;
                showErrorFlagAction(errorTitle, (0, $jGZps.default).syncErrorDescription);
                if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    action: 'map_failed',
                    actionSubject: 'newProjects',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
            });
        }
    }, [
        isChecked,
        onToggleDefault,
        showErrorFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const onUnMapNewProjects = (0, $bSJIT.useCallback)(()=>{
        setIsUnSyncing(true);
        onToggleDefault(false).then(()=>{
            setIsChecked(false);
            const successTitle = isProjectRenamingEnabled ? (0, $jGZps.default).unSyncSuccessTitleGalaxia : (0, $jGZps.default).unSyncSuccessTitle;
            showSuccessFlagAction(successTitle);
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'newProjects',
                toggleState: false
            }).fire();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            const errorTitle = isProjectRenamingEnabled ? (0, $jGZps.default).syncErrorTitleGalaxia : (0, $jGZps.default).syncErrorTitle;
            showErrorFlagAction(errorTitle, (0, $jGZps.default).syncErrorDescription);
            if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'newProjects',
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsUnSyncing(false);
            setRemoveMappingDialogOpen(false);
        });
    }, [
        onToggleDefault,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const modalTitle = isProjectRenamingEnabled ? (0, $jGZps.default).removeMappingModalTitleGalaxia : (0, $jGZps.default).removeMappingModalTitle;
    const modalDesc = isProjectRenamingEnabled ? (0, $jGZps.default).removeMappingModalDescGalaxia : (0, $jGZps.default).removeMappingModalDesc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eidO5.default), {
        label: formatMessage(toggleLabel),
        isChecked: isChecked,
        onChange: onToggleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, isRemoveMappingDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        width: "small",
        onClose: ()=>setRemoveMappingDialogOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
        testId: "help-center-UnSync-modal-title"
    }, formatMessage(modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, formatMessage(modalDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lebr5.default), {
        onClick: onUnMapNewProjects,
        isLoading: isUnSyncing,
        appearance: "primary",
        testId: "help-center-modal-unSync-button"
    }, formatMessage((0, $jGZps.default).removeMappingModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        onClick: ()=>setRemoveMappingDialogOpen(false),
        appearance: "subtle"
    }, formatMessage((0, $jGZps.default).removeMappingModalCancelButton))))));
};
var $56f9cd092d61fd0d$export$2e2bcd8739ae039 = $56f9cd092d61fd0d$var$SyncProjectsToggle;

});
parcelRegister("e3Och", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e368ec4a08a737$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3ec556de9df1e0dfa8527df888279ca>>
 * @relayHash f6ad0a674b4deb767396c24696d6bb4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d
const $b4e368ec4a08a737$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterProjectMappingUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateProjectMapping",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d",
            "metadata": {},
            "name": "syncProjectsToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b4e368ec4a08a737$var$node.hash = "f63e31632e8452ce88ba847207c9b4ff";
var $b4e368ec4a08a737$export$2e2bcd8739ae039 = $b4e368ec4a08a737$var$node;

});

parcelRegister("6PaDL", function(module, exports) {
$parcel$export(module.exports, "default", () => $409380a3a8d91275$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40debfdc71cc42750e08210b725892e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $409380a3a8d91275$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "syncProjectsToggleFragment",
    "selections": [
        {
            "concreteType": "HelpCenterProjectMappingData",
            "kind": "LinkedField",
            "name": "projectMappingData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "syncNewProjects"
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$409380a3a8d91275$var$node.hash = "b09d61797a2afad5be65329bfb50cc92";
var $409380a3a8d91275$export$2e2bcd8739ae039 = $409380a3a8d91275$var$node;

});

parcelRegister("eidO5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c40fa0b0be152d52$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $d6mTg = parcelRequire("d6mTg");

var $k9Jtq = parcelRequire("k9Jtq");

var $9dYEz = parcelRequire("9dYEz");

var $gdUUy = parcelRequire("gdUUy");

var $hDkm2 = parcelRequire("hDkm2");

var $9Abbn = parcelRequire("9Abbn");

var $bmWU5 = parcelRequire("bmWU5");
const $c40fa0b0be152d52$var$LOADING_LABEL = ', Loading';
const $c40fa0b0be152d52$var$baseStyles = null;
const $c40fa0b0be152d52$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
};
/**
 * Slider knob translate transforms per size, applied when checked.
 */ const $c40fa0b0be152d52$var$checkedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
};
/**
 * Applied when the toggle is checked
 */ const $c40fa0b0be152d52$var$checkedStyles = null;
/**
 * Applied when the toggle is checked and not disabled.
 */ const $c40fa0b0be152d52$var$checkedHoveredStyles = null;
/**
 * Applied when the toggle is unchecked and not disabled.
 */ const $c40fa0b0be152d52$var$uncheckedHoveredStyles = null;
/**
 * Applied when the toggle is disabled.
 */ const $c40fa0b0be152d52$var$disabledStyles = null;
// Keep the focus border instant; only the track and its handle participate in motion.
const $c40fa0b0be152d52$var$motionStyles = null;
const $c40fa0b0be152d52$var$disabledMotionStyles = null;
const $c40fa0b0be152d52$var$checkedPressedStyles = null;
const $c40fa0b0be152d52$var$uncheckedPressedStyles = null;
const $c40fa0b0be152d52$var$inputStyles = null;
const $c40fa0b0be152d52$var$noop = (0, $1OdZP.default);
const $c40fa0b0be152d52$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $c40fa0b0be152d52$var$Toggle = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $c40fa0b0be152d52$var$noop, onChange: providedChange = $c40fa0b0be152d52$var$noop, onFocus: providedFocus = $c40fa0b0be152d52$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $bSJIT.useState)(defaultChecked);
    const loadingLabelId = (0, $d6mTg.useId)();
    const handleBlur = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$c40fa0b0be152d52$var$analyticsAttributes
    });
    const handleFocus = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$c40fa0b0be152d52$var$analyticsAttributes
    });
    const handleChange = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$c40fa0b0be152d52$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const hasMotion = (0, $gdUUy.fg)('platform_design_system_toggle_motion');
    const labelId = (0, $d6mTg.useId)();
    return /*#__PURE__*/ (0, $dc70d.jsxs)("label", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_v564c7pe _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _rfx31qll _pdykc7pe _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            $c40fa0b0be152d52$var$sizeStyles[size],
            shouldChecked && "_bfhkkcmj",
            shouldChecked && $c40fa0b0be152d52$var$checkedSliderStyles[size],
            !isDisabled && shouldChecked && "_irr3y7x8",
            !isDisabled && !shouldChecked && "_irr31ibz",
            hasMotion && "_1reo15vq _18m915vq _v56419ec _pdyk19ec _1e8eglyw _146iglyw _1h74glyw",
            hasMotion && !isDisabled && shouldChecked && "_1di6wcbh",
            hasMotion && !isDisabled && !shouldChecked && "_1di6of27",
            hasMotion && isDisabled && "_v564glyw _pdykglyw",
            isDisabled && "_bfhk187o _syaz2sac _80om13gf"
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$c40fa0b0be152d52$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId,
                className: (0, $9fU1q.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
                ])
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $bmWU5.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                hasMotion: hasMotion,
                isDisabled: isDisabled,
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $bmWU5.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                hasMotion: hasMotion,
                isDisabled: isDisabled,
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
                id: loadingLabelId,
                children: $c40fa0b0be152d52$var$LOADING_LABEL
            })
        ]
    });
}));
$c40fa0b0be152d52$var$Toggle.displayName = 'Toggle';
var $c40fa0b0be152d52$export$2e2bcd8739ae039 = $c40fa0b0be152d52$var$Toggle;

});
parcelRegister("bmWU5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b37bc033bf452eba$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* icon-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $9PwDt = parcelRequire("9PwDt");
const $b37bc033bf452eba$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    motion: "_v56419ec _1kxtbrmi _6pgpglyw",
    noMotion: "_v564glyw",
    outsideRight: "_t9ecxwn4",
    outsideLeft: "_t9ecjq3t",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $b37bc033bf452eba$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position, hasMotion: hasMotion, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "span",
        xcss: (0, $jDsoo.cx)($b37bc033bf452eba$var$styles.iconContainer, hasMotion && $b37bc033bf452eba$var$styles.motion, hasMotion && isDisabled && $b37bc033bf452eba$var$styles.noMotion, // Icons enter and exit at their nearest track edge, travelling with the handle.
        hasMotion && isHidden && position === 'left' && $b37bc033bf452eba$var$styles.outsideLeft, hasMotion && isHidden && position === 'right' && $b37bc033bf452eba$var$styles.outsideRight, isHidden && $b37bc033bf452eba$var$styles.hidden, size === 'regular' && $b37bc033bf452eba$var$styles.iconContainerRegular, size === 'large' && $b37bc033bf452eba$var$styles.iconContainerLarge, position === 'left' && $b37bc033bf452eba$var$styles.left, position === 'right' && $b37bc033bf452eba$var$styles.right),
        children: children
    });
};
var $b37bc033bf452eba$export$2e2bcd8739ae039 = $b37bc033bf452eba$var$IconContainer;

});


parcelRegister("jGZps", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fb7f32df9b1b876$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $5fb7f32df9b1b876$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    defaultMappingToggleLabel: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label'
    },
    defaultMappingToggleLabelHelpHub: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping for help center',
        id: 'sync.project.toggle.label.helphub'
    },
    defaultMappingToggleLabelGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping for help center with Galaxia renaming',
        id: 'sync.project.toggle.label.galaxia.helphub'
    },
    defaultMappingToggleLabelGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label-galaxia'
    },
    removeMappingModalTitle: {
        defaultMessage: 'Stop linking new projects to this help center?',
        description: 'Confirmation modal title asking whether to stop auto-linking new projects to the help center',
        id: 'sync.project.toggle.removeMapping.modal.title'
    },
    removeMappingModalTitleGalaxia: {
        defaultMessage: 'Stop linking new spaces to this help center?',
        description: 'Confirmation modal title asking whether to stop auto-linking new spaces to the help center',
        id: 'sync.project.toggle.removeMapping.modal.title-galaxia'
    },
    removeMappingModalDesc: {
        defaultMessage: 'Help resources from new projects will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description'
    },
    removeMappingModalDescGalaxia: {
        defaultMessage: 'Help resources from new spaces will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description-galaxia'
    },
    removeMappingModalConfirmButton: {
        defaultMessage: 'Continue',
        description: 'removeMapping modal confirm button',
        id: 'sync.project.toggle.removeMapping.modal.confirm'
    },
    removeMappingModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'removeMapping modal cancel button',
        id: 'sync.project.toggle.removeMapping.modal.cancel'
    },
    syncErrorTitle: {
        defaultMessage: "We couldn't turn off automatic linking of new projects",
        description: 'Sync new projects flag error title',
        id: 'sync.project.toggle.sync.flag.error.title'
    },
    syncErrorTitleGalaxia: {
        defaultMessage: "We couldn't turn off automatic linking of new spaces",
        description: 'Sync new spaces flag error title',
        id: 'sync.project.toggle.sync.flag.error.title-galaxia'
    },
    syncErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Sync new projects flag error description',
        id: 'sync.project.toggle.sync.flag.error.description'
    },
    unSyncSuccessTitle: {
        defaultMessage: 'Automatic linking of new projects turned off',
        description: 'Sync new projects flag success title',
        id: 'sync.project.toggle.sync.flag.success.title'
    },
    unSyncSuccessTitleGalaxia: {
        defaultMessage: 'Automatic linking of new spaces turned off',
        description: 'Sync new spaces flag success title',
        id: 'sync.project.toggle.sync.flag.success.title-galaxia'
    }
});

});






parcelRegister("d0Diy", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManagePages", () => $ed00deb780c956fc$export$ede7df3d2ca0e51e);

var $bSJIT = parcelRequire("bSJIT");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

var $7WRjA = parcelRequire("7WRjA");
parcelRequire("lfOCd");
var $1mm9L = parcelRequire("1mm9L");

var $85bv9 = parcelRequire("85bv9");
parcelRequire("9Fc9u");
var $8CCuE = parcelRequire("8CCuE");

const $ed00deb780c956fc$var$AsyncHelpCenterManagePagesComponent = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("7cgp5")), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/manage-pages.tsx"
    }),
    LoadingSkeleton: (0, $8CCuE.default)
});
const $ed00deb780c956fc$export$ede7df3d2ca0e51e = ()=>{
    (0, $7WRjA.useUFOComponentExperience)((0, $85bv9.managePagesExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mm9L.default), {
        featureName: "Helpcenter manage pages"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ed00deb780c956fc$var$AsyncHelpCenterManagePagesComponent, null));
};

});
parcelRegister("85bv9", function(module, exports) {
$parcel$export(module.exports, "managePagesExperience", () => $e377a43d1d0422a3$export$5b30dfd9ef11a3c5);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $e377a43d1d0422a3$export$5b30dfd9ef11a3c5 = new (0, $1we90.UFOExperience)((0, $eAZuG.managePagesExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("9Fc9u", function(module, exports) {
$parcel$export(module.exports, "ManagePagesLayoutSkeleton", () => (parcelRequire("8CCuE")).default);

var $8CCuE = parcelRequire("8CCuE");

});
parcelRegister("8CCuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5134db7ea5b03df$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5VhGP = parcelRequire("5VhGP");

var $bNvXg = parcelRequire("bNvXg");

var $cMYsY = parcelRequire("cMYsY");

var $gUpf2 = parcelRequire("gUpf2");

var $hYh8H = parcelRequire("hYh8H");

var $9BVpB = parcelRequire("9BVpB");

var $iFhIy = parcelRequire("iFhIy");
const $c5134db7ea5b03df$var$ManagePagesLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                key: 'page-name',
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PAGE_HEAD_WIDTH)['page-name']
            },
            {
                key: 'last-updated',
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PAGE_HEAD_WIDTH)['last-updated']
            },
            {
                key: 'page-description',
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PAGE_HEAD_WIDTH)['page-description']
            },
            {
                key: 'action-button',
                content: /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $iFhIy.MANAGE_PAGE_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 20
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
                        width: "20%",
                        height: "20px"
                    }))
                }
            ]
        }));
    return /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-title-skeleton"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-create-button-skeleton"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "75%",
        height: "20px"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: $c5134db7ea5b03df$var$tableSkeletonStyles
    }, /*#__PURE__*/ $bSJIT.createElement((0, $bNvXg.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true
    })));
};
const $c5134db7ea5b03df$var$tableSkeletonStyles = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
var $c5134db7ea5b03df$export$2e2bcd8739ae039 = $c5134db7ea5b03df$var$ManagePagesLayoutSkeleton;

});


parcelRegister("7cgp5", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("750QJ"),
    $kOunM("e1RQb"),
    $kOunM("iZJsN"),
    $kOunM("5yRAo")
]).then(()=>parcelRequire('lRyHO'));

});




parcelRegister("bTPBr", function(module, exports) {
$parcel$export(module.exports, "HelpCenterRovoServiceAgentResource", () => $aba9103a4438b09f$export$edd09dd027b459f5);

var $fuVmc = parcelRequire("fuVmc");

var $3LQyI = parcelRequire("3LQyI");

var $dOx4s = parcelRequire("dOx4s");

var $66HDt = parcelRequire("66HDt");
const $aba9103a4438b09f$export$edd09dd027b459f5 = (0, $3LQyI.createRelayResource)({
    type: 'HELP_ROVO_SERVICE_AGENT_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const activationId = (0, $fuVmc.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const computedHelpCenterAri = (0, $dOx4s.createHelpCenterAri)(activationId, helpCenterId);
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $66HDt.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("66HDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5b8e232c6dca0b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2026eb7695890747f87168577d7f7d36>>
 * @relayHash e8ae7ab32189fb155478d43e63c3f190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b
const $d5b8e232c6dca0b9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCustomAgentsAvailable"
            },
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b",
            "metadata": {},
            "name": "srcRovoServiceAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d5b8e232c6dca0b9$var$node.hash = "31b851fb2037198c36030d97e7f1d665";
var $d5b8e232c6dca0b9$export$2e2bcd8739ae039 = $d5b8e232c6dca0b9$var$node;

});


parcelRegister("dNLVU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("1kFIN"),
    $kOunM("7uKBz"),
    $kOunM("jqtUv")
]).then(()=>parcelRequire('kXXSq'));

});


parcelRegister("1YZEU", function(module, exports) {
$parcel$export(module.exports, "helpcenterEditRoute", () => $4ef64d347e14d0d5$export$8c1389d3983434c);
$parcel$export(module.exports, "helpcenterManageProjectsRoute", () => $4ef64d347e14d0d5$export$5fae61522b3dcb33);
$parcel$export(module.exports, "helpcenterManageCustomPagesRoute", () => $4ef64d347e14d0d5$export$d1e5a4952efbcb);
$parcel$export(module.exports, "hubEditLayoutRoute", () => $4ef64d347e14d0d5$export$8f54556241df66cd);
$parcel$export(module.exports, "hubEditPortalLayoutRoute", () => $4ef64d347e14d0d5$export$b97f195684a7c2a4);

var $bSJIT = parcelRequire("bSJIT");

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");

var $AJwHZ = parcelRequire("AJwHZ");
parcelRequire("lfOCd");
var $1mm9L = parcelRequire("1mm9L");

var $9ND95 = parcelRequire("9ND95");

const $4ef64d347e14d0d5$var$AsyncHelpCenterEditDetailsPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>Promise.resolve((parcelRequire("l2S8K"))).then(({ HelpCenterEditDetails: HelpCenterEditDetails })=>HelpCenterEditDetails), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/edit-helpcenter/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $4ef64d347e14d0d5$var$AsyncHelpCenterManageProjectsPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>Promise.resolve((parcelRequire("eyygd"))).then(({ HelpCenterManageProjects: HelpCenterManageProjects })=>HelpCenterManageProjects), {
        moduleId: "./packages/admin-layout/src/ui/manage-projects/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $4ef64d347e14d0d5$var$AsyncHelpCenterManageCustomPagesPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>Promise.resolve((parcelRequire("d0Diy"))).then(({ HelpCenterManagePages: HelpCenterManagePages })=>HelpCenterManagePages), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $4ef64d347e14d0d5$var$AsyncHubEditLayoutComponent = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("8bZXV")).then(({ HubEditLayout: HubEditLayout })=>HubEditLayout), {
        ssr: false,
        moduleId: "./packages/admin-layout/src/ui/hub-edit-layout/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mm9L.AdminManagementLayoutLoader), {
            hideSidebar: true
        })
});
const $4ef64d347e14d0d5$export$8c1389d3983434c = {
    name: 'edit-details',
    path: '/:helpcenterId/details',
    exact: true,
    component: (0, $hbIgt.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $AJwHZ.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4ef64d347e14d0d5$var$AsyncHelpCenterEditDetailsPage, null)))
};
const $4ef64d347e14d0d5$export$5fae61522b3dcb33 = {
    name: 'manage-projects',
    path: '/:helpcenterId/projects',
    exact: true,
    component: (0, $hbIgt.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $AJwHZ.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4ef64d347e14d0d5$var$AsyncHelpCenterManageProjectsPage, null)))
};
const $4ef64d347e14d0d5$export$d1e5a4952efbcb = {
    name: 'manage-pages',
    path: '/:helpcenterId/pages',
    exact: true,
    component: (0, $hbIgt.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $AJwHZ.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4ef64d347e14d0d5$var$AsyncHelpCenterManageCustomPagesPage, null)))
};
const $4ef64d347e14d0d5$export$8f54556241df66cd = {
    name: 'edit-hub',
    path: '/:helpcenterId/edit-hub/:pageId?',
    exact: true,
    resources: [
        (0, $9ND95.EditLayoutResource)
    ],
    component: (0, $hbIgt.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $AJwHZ.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4ef64d347e14d0d5$var$AsyncHubEditLayoutComponent, null)))
};
const $4ef64d347e14d0d5$export$b97f195684a7c2a4 = {
    name: 'edit-hub-portal',
    path: '/:helpcenterId/edit-hub/portal/:portalId',
    exact: true,
    resources: [
        (0, $9ND95.EditLayoutResource)
    ],
    component: (0, $hbIgt.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $AJwHZ.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($4ef64d347e14d0d5$var$AsyncHubEditLayoutComponent, null)))
};

});
parcelRegister("AJwHZ", function(module, exports) {
$parcel$export(module.exports, "JiraAdminPermissionWrapper", () => $6fa78fa3e887cd9b$export$6061a3ec828d7435);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");

var $1xzNy = parcelRequire("1xzNy");
const $6fa78fa3e887cd9b$export$6061a3ec828d7435 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }), (0, $ifEXU.default)({
        message: formatMessage((0, $1xzNy.authPageMessage)),
        callToActionText: formatMessage((0, $1xzNy.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};

});

parcelRegister("9ND95", function(module, exports) {
$parcel$export(module.exports, "EditLayoutResource", () => $e71934badce3ce1e$export$e44f9c093dbfbb53);

var $fuVmc = parcelRequire("fuVmc");

var $9P2Zq = parcelRequire("9P2Zq");
var $hwpKw = parcelRequire("hwpKw");

var $87QgR = parcelRequire("87QgR");

var $4Y6IB = parcelRequire("4Y6IB");

var $3LQyI = parcelRequire("3LQyI");

var $WTjzL = parcelRequire("WTjzL");
const $e71934badce3ce1e$var$HUB_EXTENSION_MANAGE_TRANSLATIONS = 'hub_extension_manage_translations';
const $e71934badce3ce1e$var$HUB_TRANSLATIONS_SAVE_DEFAULT_LANG = 'hub_translations_save_default_lang';
const $e71934badce3ce1e$var$HUBS_TRANSLATION_PORTAL_LANG = 'hubs_translation_portal_lang';
const $e71934badce3ce1e$var$HELP_HUBS_CONFIGURABLE_SITE_TREE = 'help_hubs_configurable_site_tree';
const $e71934badce3ce1e$var$HUBS_PREMIUM_UPSELL = 'hubs_premium_upsell';
const $e71934badce3ce1e$export$f170ab873a147b4a = (match)=>{
    if ((0, $87QgR.default).checkGate('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.pageId || '';
};
const $e71934badce3ce1e$export$e44f9c093dbfbb53 = (0, $3LQyI.createRelayResource)({
    type: 'EDIT_HUB_LAYOUT',
    getQuery: ({ match: match }, { cloudId: cloudId })=>{
        const activationId = (0, $fuVmc.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const pageId = $e71934badce3ce1e$export$f170ab873a147b4a(match);
        const computedHelpCenterAri = (0, $9P2Zq.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        const resolvedPageId = pageId || helpCenterId;
        const computedPageAri = (0, $4Y6IB.isPortalPage)(resolvedPageId) && helpCenterId ? (0, $4Y6IB.buildPortalPageAri)(computedHelpCenterAri, resolvedPageId) : (0, $hwpKw.HelpPageAri).create({
            activationId: activationId,
            pageId: resolvedPageId
        }).toString();
        const isDraft = (0, $87QgR.default).checkGate('help_hubs_draft_mode');
        const isConfigurableSiteTreeEnabled = (0, $87QgR.default).checkGate($e71934badce3ce1e$var$HELP_HUBS_CONFIGURABLE_SITE_TREE);
        // Gates the hub's topic pages query; see hub-home's Topics section.
        const isTopicsEnabled = (0, $87QgR.default).checkGate($e71934badce3ce1e$var$HUBS_PREMIUM_UPSELL);
        const includeLayoutTranslations = (0, $87QgR.default).checkGate($e71934badce3ce1e$var$HUB_EXTENSION_MANAGE_TRANSLATIONS);
        const includeTranslatableBlocksSchema = (0, $87QgR.default).checkGate($e71934badce3ce1e$var$HUB_TRANSLATIONS_SAVE_DEFAULT_LANG);
        return {
            parameters: (0, $WTjzL.default),
            variables: {
                cloudId: cloudId,
                isDraft: isDraft,
                isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
                isTopicsEnabled: isTopicsEnabled,
                includeLayoutTranslations: includeLayoutTranslations,
                includeTranslatableBlocksSchema: includeTranslatableBlocksSchema,
                isPortalPage: (0, $87QgR.default).checkGate($e71934badce3ce1e$var$HUBS_TRANSLATION_PORTAL_LANG) && (0, $4Y6IB.isPortalPage)(resolvedPageId),
                hubAri: computedHelpCenterAri,
                hubEditMode: true,
                pageAri: computedPageAri,
                // When false the field is not requested, so help-kosh never resolves it and no call
                // reaches convo-ai. The editor gates consumption separately on the help center's own
                // `type`, since this route's `:helpcenterId` is what decides which one is being edited.
                rovoConfigFromKosh: (0, $87QgR.default).checkGate('hubs_rovo_config_from_kosh')
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("WTjzL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b62cd154129cdbe1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<646a0e9370caa7fec09c8f29b9b3ec14>>
 * @relayHash 2fd94b428a02a25c83980fb4d16ba68c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f4f759aa0ceb29478398e947fc13ff4afbbe2764f17eba2d9e9a0480df9ff12

var $jCd3e = parcelRequire("jCd3e");

var $4270B = parcelRequire("4270B");
const $b62cd154129cdbe1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeLayoutTranslations"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeTranslatableBlocksSchema"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isConfigurableSiteTreeEnabled"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPortalPage"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isTopicsEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "rovoConfigFromKosh"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v13 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "hubAri"
    }, v14 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v15 = [
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "basePath"
    }, v17 = {
        "kind": "Variable",
        "name": "pageAri",
        "variableName": "pageAri"
    }, v18 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "isPublished"
    }, v22 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v23 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ ,
            v21 /*: any*/ ,
            v23 /*: any*/ 
        ],
        "type": "HelpCenterPage"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v26 = {
        "kind": "ScalarField",
        "name": "type"
    }, v27 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    }, v28 = {
        "concreteType": "HelpCenterNavigationBar",
        "kind": "LinkedField",
        "name": "navigationBar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "backgroundColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderType"
            },
            v27 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "padding"
            },
            {
                "kind": "ScalarField",
                "name": "positionType"
            },
            {
                "kind": "ScalarField",
                "name": "textColor"
            }
        ]
    }, v29 = [
        v20 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": v22 /*: any*/ 
        },
        {
            "condition": "isDraft",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v30 = {
        "kind": "ScalarField",
        "name": "extensionType"
    }, v31 = {
        "kind": "ScalarField",
        "name": "locale"
    }, v32 = [
        v31 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        }
    ], v33 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v34 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v16 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "hubAri",
                                    "variableName": "hubAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeLayoutTranslations",
                                    "variableName": "includeLayoutTranslations"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeTranslatableBlocksSchema",
                                    "variableName": "includeTranslatableBlocksSchema"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isConfigurableSiteTreeEnabled",
                                    "variableName": "isConfigurableSiteTreeEnabled"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "isPortalPage",
                                    "variableName": "isPortalPage"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isTopicsEnabled",
                                    "variableName": "isTopicsEnabled"
                                },
                                v17 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v17 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v11 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__ishidenavmenusenabledrelayproviderts"
                }
            ],
            "kind": "Operation",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterSiteTree",
                                                    "kind": "LinkedField",
                                                    "name": "siteTree",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterFolder",
                                                            "kind": "LinkedField",
                                                            "name": "root",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contents",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpCenterFolderName",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "name",
                                                                                            "plural": false,
                                                                                            "selections": v22 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "contents",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "nodes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpCenterFolder"
                                                                                },
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__ishidenavmenusenabledrelayproviderts",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBranding",
                                                    "kind": "LinkedField",
                                                    "name": "helpCenterBranding",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterNavigationBar",
                                                            "kind": "LinkedField",
                                                            "name": "navigationBar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hiddenMenus"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasUnpublishedChanges"
                                        },
                                        v26 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hoistedProjectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": v22 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "allPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": []
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v29 /*: any*/ ,
                                            "storageKey": "pages(filter:{\"ids\":[]})"
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "customPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "CUSTOM"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v29 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "topicPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "TOPIC"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v29 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeTranslatableBlocksSchema",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "homePage",
                                                    "args": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "items": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "ids.0",
                                                                            "variableName": "hubAri"
                                                                        }
                                                                    ],
                                                                    "kind": "ListValue",
                                                                    "name": "ids"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "CUSTOM_HOME"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "filter"
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "pageType"
                                                        },
                                                        {
                                                            "concreteType": "HelpCenterPageLayout",
                                                            "kind": "LinkedField",
                                                            "name": "pageLayout",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdf",
                                                                    "kind": "LinkedField",
                                                                    "name": "layoutAdf",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterTranslatableBlock",
                                                                            "kind": "LinkedField",
                                                                            "name": "translatableBlocksSchema",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "blockType"
                                                                                },
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "HelpCenterTranslatableField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "path"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "kind"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "arrayKey"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "idField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeLayoutTranslations",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "siteDefaultLanguageTag"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isPortalPage",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "includeLayoutTranslations",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterAnnouncements",
                                                            "kind": "LinkedField",
                                                            "name": "announcements",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterAnnouncement",
                                                                    "kind": "LinkedField",
                                                                    "name": "homePageAnnouncements",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterTranslation",
                                                                            "kind": "LinkedField",
                                                                            "name": "nameTranslationsRaw",
                                                                            "plural": true,
                                                                            "selections": v32 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "HelpCenterTranslation",
                                                                            "kind": "LinkedField",
                                                                            "name": "descriptionTranslationsRaw",
                                                                            "plural": true,
                                                                            "selections": v32 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        {
                                            "alias": "currentPage",
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "items": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "ids.0",
                                                                    "variableName": "pageAri"
                                                                }
                                                            ],
                                                            "kind": "ListValue",
                                                            "name": "ids"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isEditMode",
                                                            "variableName": "hubEditMode"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "filter"
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "condition": "rovoConfigFromKosh",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterPageRovoConfig",
                                                            "kind": "LinkedField",
                                                            "name": "rovoConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCustomAgentsAvailable"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isRovoEnabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "agentId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "widgetContainerAri"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterPageLayout",
                                                    "kind": "LinkedField",
                                                    "name": "pageLayout",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterLayoutAdf",
                                                            "kind": "LinkedField",
                                                            "name": "layoutAdf",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdfContentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpCenterLayoutAdfContent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "content"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterBrandingTypography",
                                                    "kind": "LinkedField",
                                                    "name": "typography",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "headingFont"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "bodyFont"
                                                        }
                                                    ]
                                                },
                                                v27 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "spaceDensity"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v25 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpCenterQueryResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "alias": "pageMediaConfig",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "pageAri"
                                },
                                v14 /*: any*/ ,
                                v33 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v34 /*: any*/ 
                        },
                        {
                            "condition": "includeLayoutTranslations",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "parentAri",
                                            "variableName": "pageAri"
                                        }
                                    ],
                                    "concreteType": "HelpCenterHubLayoutTranslations",
                                    "kind": "LinkedField",
                                    "name": "layoutTranslations",
                                    "plural": true,
                                    "selections": [
                                        v31 /*: any*/ ,
                                        {
                                            "concreteType": "HelpCenterHubTranslationBlock",
                                            "kind": "LinkedField",
                                            "name": "blocks",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "localId"
                                                },
                                                v30 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterHubTranslationField",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldPath"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v14 /*: any*/ ,
                                v33 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v34 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                v18 /*: any*/ ,
                                v20 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4f4f759aa0ceb29478398e947fc13ff4afbbe2764f17eba2d9e9a0480df9ff12",
            "metadata": {},
            "name": "hubHomeContentWrapperQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__ishidenavmenusenabledrelayproviderts": (0, $jCd3e.default)
            }
        }
    };
}();
$b62cd154129cdbe1$var$node.hash = "0fc92620708f15e3c894ea86558d9ac4";
(0, $4270B.PreloadableQueryRegistry).set($b62cd154129cdbe1$var$node.params.id, $b62cd154129cdbe1$var$node);
var $b62cd154129cdbe1$export$2e2bcd8739ae039 = $b62cd154129cdbe1$var$node;

});
parcelRegister("jCd3e", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a4fff6c3955ef68$export$2e2bcd8739ae039);

var $gdUUy = parcelRequire("gdUUy");
var $0a4fff6c3955ef68$export$2e2bcd8739ae039 = {
    get () {
        return (0, $gdUUy.fg)('help_hubs_hide_nav_menus');
    }
};

});



parcelRegister("l2S8K", function(module, exports) {
$parcel$export(module.exports, "HelpCenterEditDetails", () => (parcelRequire("l0SHx")).default);

var $l0SHx = parcelRequire("l0SHx");

});
parcelRegister("l0SHx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f9c4cd727c8f9f0$export$2e2bcd8739ae039);

var $abahg = parcelRequire("abahg");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $fuVmc = parcelRequire("fuVmc");

var $1F8Um = parcelRequire("1F8Um");

var $4ZMmh = parcelRequire("4ZMmh");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $dwOcU = parcelRequire("dwOcU");

var $2usNr = parcelRequire("2usNr");

var $6WltM = parcelRequire("6WltM");

var $85rmf = parcelRequire("85rmf");

var $gUpf2 = parcelRequire("gUpf2");

var $jnInZ = parcelRequire("jnInZ");

var $hYh8H = parcelRequire("hYh8H");
parcelRequire("eByfJ");
var $1mm9L = parcelRequire("1mm9L");
var $9R3gt = parcelRequire("9R3gt");
parcelRequire("felIn");
var $bnrHq = parcelRequire("bnrHq");

var $kxIlX = parcelRequire("kxIlX");

var $clpci = parcelRequire("clpci");

var $haAAx = parcelRequire("haAAx");

var $iydAA = parcelRequire("iydAA");

var $51XYw = parcelRequire("51XYw");

var $f6Ax9 = parcelRequire("f6Ax9");

var $7WRjA = parcelRequire("7WRjA");
parcelRequire("lDqld");
var $2Pvco = parcelRequire("2Pvco");
parcelRequire("5h6qn");
var $3R8rL = parcelRequire("3R8rL");

var $jcNNq = parcelRequire("jcNNq");

var $2PHJt = parcelRequire("2PHJt");
const $7f9c4cd727c8f9f0$var$HelpCenterEditDetailsComponent = ()=>{
    var _data$helpCenter, _data$helpCenter2, _data$helpCenter3;
    const cloudId = (0, $fuVmc.getCloudId)();
    const helpCenterAri = (0, $9R3gt.useHelpCenterAri)();
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $abahg.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const helpCenter = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const { name: name, slug: slug, id: id } = helpCenter ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kxIlX.ContextWrapper), {
        sourceName: (0, $jcRK7.ScreenName).EDIT_HELP_CENTER,
        sourceType: (0, $clpci.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), null, (data === null || data === void 0 || (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bnrHq.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2Pvco.default), {
        helpCenterToEdit: {
            translations: name && name.translations ? name.translations.map((translation)=>({
                    value: (translation === null || translation === void 0 ? void 0 : translation.value) ?? '',
                    locale: (translation === null || translation === void 0 ? void 0 : translation.locale) ?? ''
                })) : [],
            slug: slug ?? '',
            name: (name === null || name === void 0 ? void 0 : name.default) ?? '',
            ari: id ?? ''
        },
        isStandaloneForm: true,
        isOpen: true,
        onClose: (0, $4ZMmh.noop)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $jcNNq.editHelpCenterExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null));
};
const $7f9c4cd727c8f9f0$export$613b634f86450035 = ()=>{
    (0, $7WRjA.useUFOComponentExperience)((0, $jcNNq.editHelpCenterExperience));
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) {
            (0, $jcNNq.editHelpCenterExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'helpCenterDetails',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
            header: formatMessage((0, $2PHJt.default).errorTitle),
            description: formatMessage((0, $2PHJt.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1F8Um)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mm9L.default), {
        featureName: "Helpcenter settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: (0, $jcRK7.ScreenName).EDIT_HELP_CENTER,
        id: 'help-center-edit-details',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                workspaceAri: (0, $fuVmc.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jnInZ.Grid), {
        templateColumns: "1fr 2fr 1fr",
        rowGap: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3R8rL.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($7f9c4cd727c8f9f0$var$HelpCenterEditDetailsComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null)))));
};
var $7f9c4cd727c8f9f0$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    component: 'helpCenterEditDetails'
})($7f9c4cd727c8f9f0$export$613b634f86450035);

});
parcelRegister("abahg", function(module, exports) {
$parcel$export(module.exports, "default", () => $760a213954d5e5cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9ac0204ca94c5ca5bd93a55bfdd44c6f>>
 * @relayHash efdc5420deee34a8cc05fb680adbe347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0
const $760a213954d5e5cd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            },
            {
                "concreteType": "HelpCenterTranslation",
                "kind": "LinkedField",
                "name": "translations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "locale"
                    }
                ]
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "slug"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0",
            "metadata": {},
            "name": "editHelpCenter_getHelpcenterById_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$760a213954d5e5cd$var$node.hash = "b3bd596bd547f6d09044149b39e767e6";
var $760a213954d5e5cd$export$2e2bcd8739ae039 = $760a213954d5e5cd$var$node;

});

parcelRegister("lDqld", function(module, exports) {
$parcel$export(module.exports, "HelpCenterForm", () => (parcelRequire("2Pvco")).default);

var $2Pvco = parcelRequire("2Pvco");

});
parcelRegister("2Pvco", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ebd34a4215f5837$export$2e2bcd8739ae039);
/* help-center-form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $97yQ5 = parcelRequire("97yQ5");

var $xb2jO = parcelRequire("xb2jO");

var $fuVmc = parcelRequire("fuVmc");

var $oDZyG = parcelRequire("oDZyG");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");

var $dwOcU = parcelRequire("dwOcU");

var $6WltM = parcelRequire("6WltM");

var $2usNr = parcelRequire("2usNr");

var $fbRS9 = parcelRequire("fbRS9");

var $7x378 = parcelRequire("7x378");

var $7WQx2 = parcelRequire("7WQx2");

var $9dYEz = parcelRequire("9dYEz");

var $c9mVs = parcelRequire("c9mVs");

var $2w1u7 = parcelRequire("2w1u7");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $gUpf2 = parcelRequire("gUpf2");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");
parcelRequire("eByfJ");
var $4g0P3 = parcelRequire("4g0P3");

var $haAAx = parcelRequire("haAAx");

var $9P2Zq = parcelRequire("9P2Zq");

var $jBiia = parcelRequire("jBiia");

var $iW3CQ = parcelRequire("iW3CQ");

var $51XYw = parcelRequire("51XYw");

var $5tRMO = parcelRequire("5tRMO");
parcelRequire("3WARB");
var $9FpbG = parcelRequire("9FpbG");

var $cXBgi = parcelRequire("cXBgi");
parcelRequire("7DTRA");
var $hAb6f = parcelRequire("hAb6f");
parcelRequire("g3Iy9");
var $k9mGU = parcelRequire("k9mGU");

var $hNujq = parcelRequire("hNujq");
const $6ebd34a4215f5837$var$MODAL_WIDTH = '506px';
const $6ebd34a4215f5837$var$HelpCenterForm = ({ onClose: onClose, isOpen: isOpen, helpCenterToEdit: helpCenterToEdit, isStandaloneForm: isStandaloneForm = false, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { createHelpCenter: createHelpCenter, updateHelpCenter: updateHelpCenter } = (0, $9FpbG.useHelpCenter)();
    const displayUrl = (0, $iW3CQ.getEnv)().baseUrl.replace(/^https?:\/\//i, '');
    const { slug: slug, name: name } = helpCenterToEdit || {};
    const detailsDescription = (0, $4g0P3.useConditionalMessage)((0, $hNujq.default).helpHubDetailsPageDescription, (0, $hNujq.default).helpCenterDetailsPageDescription);
    const { push: push } = (0, $3DuDW.useRouterActions)();
    const successFlagAction = (0, $bSJIT.useCallback)((helpCenterSlug)=>[
            {
                contentNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("a", {
                    href: `${(0, $iW3CQ.getEnv)().baseUrl}/helpcenter/${helpCenterSlug}`
                }, formatMessage((0, $hNujq.default).helpCenterAddSuccessDesc))
            }
        ], [
        formatMessage
    ]);
    const onCreate = (0, $bSJIT.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $cXBgi.addHelpCenterExperience).start();
        return createHelpCenter({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        }).then((response)=>{
            var _response$helpCenter;
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'created',
                actionSubject: 'helpCenter',
                helpCenterAri: (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 || (_response$helpCenter = _response$helpCenter.createHelpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterAri
            }).fire();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $cXBgi.addHelpCenterExperience).success();
            onClose();
            setTimeout(()=>{
                var _response$helpCenter2;
                showSuccessFlagAction((0, $hNujq.default).helpCenterAddSuccessTitleText, {
                    value: helpCenterName
                }, undefined, successFlagAction(helpCenterSlug));
                const helpCenterAri = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.createHelpCenter) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.helpCenterAri;
                const { helpCenterId: helpCenterId } = (0, $9P2Zq.HelpHelpCenterAri).parse(helpCenterAri || '');
                push(`/${helpCenterId}/projects`);
            }, 1000);
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $5tRMO.HARD_LIMIT_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $hNujq.default).helpCenterHardLimitErrorTitle, (0, $hNujq.default).helpCenterHardLimitErrorDescription, undefined, undefined, {
                value: message
            });
            else if (message === (0, $5tRMO.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $hNujq.default).helpCenterAddErrorTitle, (0, $hNujq.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $5tRMO.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $hNujq.default).helpCenterAddErrorTitle, (0, $hNujq.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $hNujq.default).helpCenterAddErrorTitle, (0, $hNujq.default).helpCenterGenericErrorDesc);
            if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    action: 'create_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $cXBgi.addHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $jBiia.getErrorData)(message)
                    }
                });
            }
            return (0, $cXBgi.addHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        createHelpCenter,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        successFlagAction
    ]);
    const onEdit = (0, $bSJIT.useCallback)(({ helpCenterName: helpCenterName, helpCenterTranslations: helpCenterTranslations, helpCenterSlug: helpCenterSlug, helpCenterAri: helpCenterAri })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $cXBgi.updateHelpCenterExperience).start();
        return updateHelpCenter({
            helpCenterAri: helpCenterAri,
            helpCenterName: helpCenterName,
            helpCenterTranslations: helpCenterTranslations,
            helpCenterSlug: helpCenterSlug
        }).then(()=>{
            createAnalyticsEvent({
                helpCenterAri: helpCenterAri,
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'helpCenter'
            }).fire();
            showSuccessFlagAction((0, $hNujq.default).helpCenterUpdateSuccessTitleText, {
                value: helpCenterName ? helpCenterName : name
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $cXBgi.updateHelpCenterExperience).success();
            if (isStandaloneForm) push('/');
            else onClose();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $5tRMO.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $hNujq.default).helpCenterUpdateErrorTitle, (0, $hNujq.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $5tRMO.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $hNujq.default).helpCenterUpdateErrorTitle, (0, $hNujq.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $hNujq.default).helpCenterUpdateErrorTitle, (0, $hNujq.default).helpCenterGenericErrorDesc);
            if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    helpCenterAri: helpCenterAri,
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    action: 'update_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $cXBgi.updateHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $jBiia.getErrorData)(message)
                    }
                });
            }
            return (0, $cXBgi.updateHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        name,
        isStandaloneForm,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        updateHelpCenter
    ]);
    const onSubmit = (0, $bSJIT.useCallback)((data)=>{
        const { name: helpCenterName, slug: helpCenterSlug } = data;
        if (!helpCenterToEdit) return onCreate({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        });
        const { ari: ari, translations: translations } = helpCenterToEdit;
        return onEdit({
            helpCenterName: helpCenterName !== name ? helpCenterName : undefined,
            helpCenterSlug: helpCenterSlug !== slug ? helpCenterSlug : undefined,
            helpCenterAri: ari,
            helpCenterTranslations: translations
        });
    }, [
        helpCenterToEdit,
        name,
        onCreate,
        onEdit,
        slug
    ]);
    // used in settings page without a modal
    if (isStandaloneForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fbRS9.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, dirty: dirty, submitting: submitting, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
            size: "large"
        }, formatMessage((0, $hNujq.default).helpCenterDetailsPageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, slug ? formatMessage(detailsDescription) : formatMessage((0, $hNujq.default).defaultHelpCenterDetailsPageDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            paddingBlock: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, formatMessage((0, $hNujq.default).helpCenterRequiredFieldsWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7x378.RequiredAsterisk), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hAb6f.HelpCenterFormFields), {
            mode: "EDIT",
            name: name,
            slug: slug,
            urlWithoutSlug: `${window.location.hostname}/helpcenter`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k9mGU.HelpCenterFormFooter), {
            mode: "EDIT",
            isStandaloneForm: true,
            isCancelDisabled: !dirty,
            submitting: submitting,
            onCancel: ()=>reset({
                    name: name ?? '',
                    slug: slug ?? ''
                })
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lFaAn.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                workspaceAri: (0, $fuVmc.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        onClose: onClose,
        width: $6ebd34a4215f5837$var$MODAL_WIDTH,
        testId: "help-centers-management-form-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fbRS9.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6ebd34a4215f5837$var$HelpForm, formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
            testId: "help-centers-management-modal-title"
        }, formatMessage(!helpCenterToEdit ? (0, $hNujq.default).helpCenterCreateFormTitle : (0, $hNujq.default).helpCenterEditFormTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.Button), {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
            "aria-label": "Cancel create dialog",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                spacing: "spacious",
                label: "cancel create dialog"
            }),
            onClick: onClose,
            actionSubjectId: "helpCenterCreateDialogCancelButton"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, !helpCenterToEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6ebd34a4215f5837$var$DescriptionWrapper, null, formatMessage((0, $hNujq.default).helpCenterCreateFormDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hAb6f.HelpCenterFormFields), {
            mode: !helpCenterToEdit ? 'CREATE' : 'EDIT',
            name: name,
            slug: slug,
            urlWithoutSlug: `${displayUrl}/helpcenter`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k9mGU.HelpCenterFormFooter), {
            submitting: submitting,
            onCancel: onClose,
            mode: helpCenterToEdit ? 'EDIT' : 'CREATE'
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $oDZyG.default), {
        preventNavigation: isOpen
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6ebd34a4215f5837$var$DescriptionWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_otyrv47k",
            __cmplp.className
        ])
    });
});
const $6ebd34a4215f5837$var$HelpForm = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});
var $6ebd34a4215f5837$export$2e2bcd8739ae039 = (0, $f2mlD.default)(null, {
    showErrorFlag: $xb2jO.showErrorFlag,
    showSuccessFlag: $xb2jO.showSuccessFlag
})((0, $2usNr.default)({
    component: 'helpCenterForm'
})($6ebd34a4215f5837$var$HelpCenterForm));

});
parcelRegister("oDZyG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d04c4d6fae8eff7d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $gYDJY = parcelRequire("gYDJY");

var $8kW7p = parcelRequire("8kW7p");

var $ho54P = parcelRequire("ho54P");
class $d04c4d6fae8eff7d$export$5e156bf0bd6195af extends $bSJIT.PureComponent {
    componentDidMount() {
        if (this.props.preventNavigation) this.blockNavigation();
    }
    componentWillUnmount() {
        if (this.props.preventNavigation) this.allowNavigation();
    }
    componentDidUpdate(prevProps) {
        const { preventNavigation: preventNavigation } = this.props;
        if (preventNavigation && !prevProps.preventNavigation) this.blockNavigation();
        else if (!preventNavigation && prevProps.preventNavigation) this.allowNavigation();
    }
    render() {
        const { preventNavigation: preventNavigation, onBeforeNavigate: onBeforeNavigate } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $ho54P.default), {
            when: preventNavigation,
            message: this.checkCanNavigate,
            onBeforeNavigate: onBeforeNavigate
        });
    }
    constructor(...args){
        super(...args), this.checkCanNavigate = (routerLocation)=>{
            // This will cause the prompt to not prevent navigation if a "q" was, or is, going to be in the location search property.
            // Because we do that it will fail to prevent accidental navigation if interacting with the back button,
            // or pressing backspace/delete. We have another issue to pick up to make this better.
            // See: https://jdog.jira-dev.com/browse/FSD-3235
            const containsSearchQueryParam = (str)=>str.includes('q=');
            if (containsSearchQueryParam(routerLocation.search) || containsSearchQueryParam((0, $gYDJY.location)().search)) return true;
            /**
     * Do not show prevent navigation prompt for allowed paths
     */ const { allowedPaths: allowedPaths } = this.props;
            const { pathname: pathname } = routerLocation;
            if (allowedPaths) for (const pathRegExp of allowedPaths){
                if (pathname.match(pathRegExp)) return true;
            }
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $8kW7p.default).navigationWarning);
        }, this.onBeforeUnload = (event)=>{
            // Prompts the user before closing the page, see:
            // https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
            event.preventDefault();
            event.returnValue = '';
        }, this.blockNavigation = ()=>{
            window.addEventListener('beforeunload', this.onBeforeUnload);
        }, this.allowNavigation = ()=>{
            window.removeEventListener('beforeunload', this.onBeforeUnload);
        };
    }
}
var $d04c4d6fae8eff7d$export$2e2bcd8739ae039 = (0, $fK3tS.default)($d04c4d6fae8eff7d$export$5e156bf0bd6195af);

});
parcelRegister("8kW7p", function(module, exports) {
$parcel$export(module.exports, "default", () => $a567269532ec5260$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a567269532ec5260$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    navigationWarning: {
        defaultMessage: 'You have unsubmitted changes. Are you sure you want to leave?',
        description: 'Messsage shown to users when they navigate away from a form that has been filled out.',
        id: 'cv.navigation.prompt.warning'
    }
});

});

parcelRegister("ho54P", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb15924da55bba32$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("5lPCP");
var $3DuDW = parcelRequire("3DuDW");
const $cb15924da55bba32$var$NavBlocker = ({ when: when, message: message, onBeforeNavigate: onBeforeNavigate })=>{
    const { registerBlock: registerBlock } = (0, $3DuDW.useRouterActions)();
    (0, $bSJIT.useEffect)(()=>{
        const unRegisterBlock = registerBlock((location)=>{
            if (!when) return true;
            const result = message(location);
            if (typeof result === 'boolean') return result;
            //RRR doesn't support async block, so we cannot use our custom dialog here.
            //We need to fallback to using browser's confirm like react-router's prompt.
            // oxlint-disable-next-line no-alert
            const confirmation = window.confirm(result);
            if (confirmation && onBeforeNavigate) onBeforeNavigate(location);
            return confirmation;
        });
        return unRegisterBlock;
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registerBlock,
        when
    ]);
    return null;
};
var $cb15924da55bba32$export$2e2bcd8739ae039 = $cb15924da55bba32$var$NavBlocker;

});


parcelRegister("5tRMO", function(module, exports) {
$parcel$export(module.exports, "BANNER_PREVIEW_WIDTH", () => $4c879340a0070369$export$69656aaf76d15223);
$parcel$export(module.exports, "CARD_HEIGHT", () => $4c879340a0070369$export$17f5f15729f028ea);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $4c879340a0070369$export$780035d9fe48eb32);
$parcel$export(module.exports, "HELPCENTER_NAME_CHARACTER_LIMIT", () => $4c879340a0070369$export$60a11b99c333dc54);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH", () => $4c879340a0070369$export$434ed9a0808b5e5e);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_PER_FETCH", () => $4c879340a0070369$export$81026eacb893b971);
$parcel$export(module.exports, "SORT_ORDER", () => $4c879340a0070369$export$d33cb9b119034d29);
$parcel$export(module.exports, "HARD_LIMIT_HELP_CENTERS_MESSAGE", () => $4c879340a0070369$export$2426c5658dae9870);
$parcel$export(module.exports, "RESERVED_TERM_HELP_CENTERS_MESSAGE", () => $4c879340a0070369$export$b7e744b1154b89ed);
$parcel$export(module.exports, "ALREADY_EXISTED_HELP_CENTERS_MESSAGE", () => $4c879340a0070369$export$20efc88db71ca642);
$parcel$export(module.exports, "HARD_LIMIT_HELP_HUBS_MESSAGE", () => $4c879340a0070369$export$78070db85cc402de);
const $4c879340a0070369$export$69656aaf76d15223 = '170px';
const $4c879340a0070369$export$17f5f15729f028ea = '176px';
const $4c879340a0070369$export$780035d9fe48eb32 = 240;
const $4c879340a0070369$export$60a11b99c333dc54 = 30;
const $4c879340a0070369$export$434ed9a0808b5e5e = 20;
const $4c879340a0070369$export$81026eacb893b971 = 10;
const $4c879340a0070369$export$d33cb9b119034d29 = 'CREATED_DATE_DESCENDING';
const $4c879340a0070369$export$2426c5658dae9870 = 'This operation is not supported : Help Center limit exceeded';
const $4c879340a0070369$export$b7e744b1154b89ed = `The slug you've entered contains a reserved term. Try again with a different slug.`;
const $4c879340a0070369$export$20efc88db71ca642 = `A help center with this slug already exists on your site. Try again with a different slug.`;
const $4c879340a0070369$export$78070db85cc402de = 'This operation is not supported : Help Hub limit exceeded';

});

parcelRegister("3WARB", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => (parcelRequire("9FpbG")).useHelpCenter);

var $9FpbG = parcelRequire("9FpbG");

});
parcelRegister("9FpbG", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => $548571e79975205b$export$4545b8e2508a7415);

var $4N3EH = parcelRequire("4N3EH");

var $a3DrP = parcelRequire("a3DrP");

var $b4WZY = parcelRequire("b4WZY");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $fuVmc = parcelRequire("fuVmc");

var $a2qIF = parcelRequire("a2qIF");

var $4270B = parcelRequire("4270B");

var $iW3CQ = parcelRequire("iW3CQ");
const $548571e79975205b$export$4545b8e2508a7415 = ()=>{
    const cloudId = (0, $fuVmc.getCloudId)();
    const workspaceAri = (0, $fuVmc.getWorkspaceAri)();
    const [helpCenterCreateMutation] = (0, $a2qIF.useMutation)((0, $b4WZY.default));
    const [helpCenterUpdateMutation] = (0, $a2qIF.useMutation)((0, $a3DrP.default));
    const [helpCenterDeleteMutation] = (0, $a2qIF.useMutation)((0, $4N3EH.default));
    const getHelpCenter = (0, $bSJIT.useCallback)((store)=>{
        const root = store.getRoot();
        const helpCenter = root.getLinkedRecord('helpCenter', {
            cloudId: cloudId
        });
        return helpCenter;
    }, [
        cloudId
    ]);
    const getHelpCenterList = (0, $bSJIT.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (0, $4270B.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const getHelpCenters = (0, $bSJIT.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            var _ConnectionHandler$ge;
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (_ConnectionHandler$ge = (0, $4270B.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters')) === null || _ConnectionHandler$ge === void 0 ? void 0 : _ConnectionHandler$ge.getLinkedRecords('edges');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const deleteHelpCenter = (0, $bSJIT.useCallback)(({ helpCenterAri: helpCenterAri })=>{
        return new Promise((resolve, reject)=>helpCenterDeleteMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.deleteHelpCenter) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) {
                        const helpCenters = getHelpCenters(store);
                        const helpCentersList = getHelpCenterList(store);
                        if (helpCenters && helpCentersList) {
                            const updatedHelpCenters = [
                                ...helpCenters.filter((helpCenterRecord)=>{
                                    const node = helpCenterRecord.getLinkedRecord('node');
                                    return (node === null || node === void 0 ? void 0 : node.getValue('id')) !== helpCenterAri;
                                })
                            ];
                            helpCentersList === null || helpCentersList === void 0 || helpCentersList.setLinkedRecords(updatedHelpCenters, 'edges');
                        }
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter2, _response$helpCenter3;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.deleteHelpCenter) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) return resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.deleteHelpCenter) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {};
                    return reject(error);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterDeleteMutation
    ]);
    const createHelpCenter = (0, $bSJIT.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug, helpCenterType: helpCenterType, projectMapping: projectMapping, rovoConfig: rovoConfig })=>{
        return new Promise((resolve, reject)=>helpCenterCreateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterType: helpCenterType,
                        projectMapping: projectMapping,
                        rovoConfig: rovoConfig,
                        workspaceARI: workspaceAri,
                        name: {
                            default: helpCenterName,
                            translations: [
                                {
                                    locale: (0, $iW3CQ.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        },
                        slug: helpCenterSlug
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter4, _response$helpCenter5;
                    if (response !== null && response !== void 0 && (_response$helpCenter4 = response.helpCenter) !== null && _response$helpCenter4 !== void 0 && (_response$helpCenter4 = _response$helpCenter4.createHelpCenter) !== null && _response$helpCenter4 !== void 0 && _response$helpCenter4.success && response !== null && response !== void 0 && (_response$helpCenter5 = response.helpCenter) !== null && _response$helpCenter5 !== void 0 && (_response$helpCenter5 = _response$helpCenter5.createHelpCenter) !== null && _response$helpCenter5 !== void 0 && _response$helpCenter5.helpCenterAri) {
                        var _response$helpCenter6;
                        const helpCenters = getHelpCenters(store);
                        const helpCenterList = getHelpCenterList(store);
                        const node = store.create((0, $4270B.generateUniqueClientID)(), 'node');
                        const helpCenterRecord = store.create((0, $4270B.generateUniqueClientID)(), 'HelpCenter');
                        const name = store.create((0, $4270B.generateUniqueClientID)(), 'HelpCenterName');
                        const branding = store.create((0, $4270B.generateUniqueClientID)(), 'HelpCenterBranding');
                        name.setValue(helpCenterName, 'default');
                        branding.setValue(true, 'useDefaultBanner');
                        helpCenterRecord.setLinkedRecord(name, 'name');
                        helpCenterRecord.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        helpCenterRecord === null || helpCenterRecord === void 0 || helpCenterRecord.setValue(date, 'lastUpdated');
                        helpCenterRecord.setValue((_response$helpCenter6 = response.helpCenter) === null || _response$helpCenter6 === void 0 || (_response$helpCenter6 = _response$helpCenter6.createHelpCenter) === null || _response$helpCenter6 === void 0 ? void 0 : _response$helpCenter6.helpCenterAri, 'id');
                        helpCenterRecord.setLinkedRecord(branding, 'helpCenterBranding');
                        node.setLinkedRecord(helpCenterRecord, 'node');
                        const updatedHelpCenters = [
                            node,
                            ...helpCenters ?? []
                        ];
                        if (helpCenters && helpCenterList) helpCenterList.setLinkedRecords(updatedHelpCenters, 'edges');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter7, _response$helpCenter8, _error$extensions;
                    if ((_response$helpCenter7 = response.helpCenter) !== null && _response$helpCenter7 !== void 0 && (_response$helpCenter7 = _response$helpCenter7.createHelpCenter) !== null && _response$helpCenter7 !== void 0 && _response$helpCenter7.success) return resolve(response);
                    const errors = (_response$helpCenter8 = response.helpCenter) === null || _response$helpCenter8 === void 0 || (_response$helpCenter8 = _response$helpCenter8.createHelpCenter) === null || _response$helpCenter8 === void 0 ? void 0 : _response$helpCenter8.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $jcRK7.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterCreateMutation,
        workspaceAri
    ]);
    const updateHelpCenter = (0, $bSJIT.useCallback)(({ helpCenterAri: helpCenterAri, helpCenterTranslations: helpCenterTranslations, helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        return new Promise((resolve, reject)=>helpCenterUpdateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        name: helpCenterName ? {
                            default: helpCenterName,
                            translations: helpCenterTranslations && helpCenterTranslations.length > 0 ? helpCenterTranslations.map((translations)=>{
                                if (translations.locale === (0, $iW3CQ.getEnv)().siteDefaultLanguageTag) translations.value = helpCenterName;
                                return translations;
                            }) : [
                                {
                                    locale: (0, $iW3CQ.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        } : undefined,
                        slug: helpCenterSlug ? helpCenterSlug : undefined
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter9;
                    if (response !== null && response !== void 0 && (_response$helpCenter9 = response.helpCenter) !== null && _response$helpCenter9 !== void 0 && (_response$helpCenter9 = _response$helpCenter9.updateHelpCenter) !== null && _response$helpCenter9 !== void 0 && _response$helpCenter9.success) {
                        const helpCenters = getHelpCenters(store);
                        const currentHelpCenter = helpCenters === null || helpCenters === void 0 ? void 0 : helpCenters.find((helpCenter)=>{
                            const node = helpCenter.getLinkedRecord('node');
                            return (node === null || node === void 0 ? void 0 : node.getValue('id')) === helpCenterAri;
                        });
                        const currentHelpCenterNode = currentHelpCenter === null || currentHelpCenter === void 0 ? void 0 : currentHelpCenter.getLinkedRecord('node');
                        if (helpCenterName) {
                            const name = currentHelpCenterNode === null || currentHelpCenterNode === void 0 ? void 0 : currentHelpCenterNode.getLinkedRecord('name');
                            name === null || name === void 0 || name.setValue(helpCenterName, 'default');
                        }
                        if (helpCenterSlug) currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(date, 'lastUpdated');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter0, _response$helpCenter1, _error$extensions2;
                    if ((_response$helpCenter0 = response.helpCenter) !== null && _response$helpCenter0 !== void 0 && (_response$helpCenter0 = _response$helpCenter0.updateHelpCenter) !== null && _response$helpCenter0 !== void 0 && _response$helpCenter0.success) return resolve(response);
                    const errors = (_response$helpCenter1 = response.helpCenter) === null || _response$helpCenter1 === void 0 || (_response$helpCenter1 = _response$helpCenter1.updateHelpCenter) === null || _response$helpCenter1 === void 0 ? void 0 : _response$helpCenter1.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $jcRK7.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenters,
        helpCenterUpdateMutation
    ]);
    return {
        createHelpCenter: createHelpCenter,
        updateHelpCenter: updateHelpCenter,
        deleteHelpCenter: deleteHelpCenter
    };
};

});
parcelRegister("4N3EH", function(module, exports) {
$parcel$export(module.exports, "default", () => $86b77692d59de868$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7d9fbf0f9f046553e76513425ceaca8>>
 * @relayHash fecf54055e7ebdf24f46943683e10daa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8
const $86b77692d59de868$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterDeletePayload",
                    "kind": "LinkedField",
                    "name": "deleteHelpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8",
            "metadata": {},
            "name": "useHelpCenterDeleteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$86b77692d59de868$var$node.hash = "7f1dd80d488ff1c4273819ebc7261544";
var $86b77692d59de868$export$2e2bcd8739ae039 = $86b77692d59de868$var$node;

});

parcelRegister("a3DrP", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb2b6d604c431eaa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c53f21dc49638e092a8cc269252804fc>>
 * @relayHash 760113b4d7a9d899532af7823cd6a3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68
const $cb2b6d604c431eaa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68",
            "metadata": {},
            "name": "useHelpCenterUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cb2b6d604c431eaa$var$node.hash = "162638a77ba5d44dfe258f5e31598716";
var $cb2b6d604c431eaa$export$2e2bcd8739ae039 = $cb2b6d604c431eaa$var$node;

});

parcelRegister("b4WZY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b67a973c6915294e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<574069c86901a0c3062851191b4f1cb5>>
 * @relayHash 6f452febb43ea4f48f12803ae2f36059
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976
const $b67a973c6915294e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "helpCenterAri"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976",
            "metadata": {},
            "name": "useHelpCenterCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b67a973c6915294e$var$node.hash = "50311be3a83d4bcff60feddeba10c3e5";
var $b67a973c6915294e$export$2e2bcd8739ae039 = $b67a973c6915294e$var$node;

});



parcelRegister("cXBgi", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterExperience", () => $3bc3e5de0524a6e2$export$9ee847b39a089524);
$parcel$export(module.exports, "addHelpCenterExperience", () => $3bc3e5de0524a6e2$export$b2a851a784010834);

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $3bc3e5de0524a6e2$export$88b7d3eb7bfc06a1 = 'service-management.help-center.add';
const $3bc3e5de0524a6e2$export$588afedc10fc2da4 = 'service-management.help-center.update';
const $3bc3e5de0524a6e2$export$9ee847b39a089524 = new (0, $1we90.UFOExperience)($3bc3e5de0524a6e2$export$588afedc10fc2da4, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});
const $3bc3e5de0524a6e2$export$b2a851a784010834 = new (0, $1we90.UFOExperience)($3bc3e5de0524a6e2$export$88b7d3eb7bfc06a1, {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("7DTRA", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => (parcelRequire("hAb6f")).HelpCenterFormFields);

var $hAb6f = parcelRequire("hAb6f");

});
parcelRegister("hAb6f", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => $206f64a9996898a4$export$14ec26006a1f0ef3);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $k1CGD = parcelRequire("k1CGD");

var $cvNPo = parcelRequire("cvNPo");

var $68E0O = parcelRequire("68E0O");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $jgsO4 = parcelRequire("jgsO4");

var $lavtv = parcelRequire("lavtv");
parcelRequire("eByfJ");
var $4g0P3 = parcelRequire("4g0P3");

var $5tRMO = parcelRequire("5tRMO");

var $hNujq = parcelRequire("hNujq");

var $b17Of = parcelRequire("b17Of");
const $206f64a9996898a4$var$SLUG_VALIDATION_REGEX = /^[a-zA-Z0-9_-]{1,30}$/;
const $206f64a9996898a4$var$SlugInfo = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $206f64a9996898a4$var$slugWarningStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: formatMessage((0, $b17Of.default).helpCenterSlugInfoTooltip),
        position: "top-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
        label: formatMessage((0, $b17Of.default).helpCenterSlugInfoLabel)
    })));
};
const $206f64a9996898a4$export$14ec26006a1f0ef3 = ({ name: name, slug: slug, urlWithoutSlug: urlWithoutSlug, mode: mode })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const nameLabel = (0, $4g0P3.useConditionalMessage)((0, $b17Of.default).helpHubNameTextLabel, (0, $b17Of.default).helpCenterNameTextLabel);
    const urlLabel = (0, $4g0P3.useConditionalMessage)((0, $b17Of.default).helpHubSlugTextLabel, (0, $b17Of.default).helpCenterSlugTextLabel);
    const validateHelpCenterName = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $hNujq.default).helpCenterNameRequiredError);
        if (value && value.length > (0, $5tRMO.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $hNujq.default).helpCenterNameCharacterLimitError);
        return undefined;
    };
    const validateHelpCenterSlug = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $hNujq.default).helpCenterSlugRequiredError);
        if (value && value.length > (0, $5tRMO.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $hNujq.default).helpCenterSlugCharacterLimitError);
        if (!$206f64a9996898a4$var$SLUG_VALIDATION_REGEX.test(value)) return formatMessage((0, $hNujq.default).helpCenterSlugSpecialCharacterError);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cvNPo.default), {
        name: "name",
        key: "name",
        label: formatMessage(nameLabel),
        defaultValue: name ?? '',
        validate: validateHelpCenterName,
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            paddingBlockStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
            ...fieldProps,
            autoComplete: "off",
            autoFocus: true,
            placeholder: formatMessage((0, $b17Of.default).helpCenterNameTextFieldPlaceholder),
            testId: "help-centers-management-name-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k1CGD.ErrorMessage), null, error))), mode === 'CREATE' || slug ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cvNPo.default), {
        name: "slug",
        key: "slug",
        label: formatMessage(urlLabel),
        defaultValue: slug ?? '',
        validate: validateHelpCenterSlug,
        elementAfterLabel: mode !== 'CREATE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($206f64a9996898a4$var$SlugInfo, null),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
            grow: "fill",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            paddingBlockStart: "space.100",
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
            color: "color.text"
        }, urlWithoutSlug, '/')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $206f64a9996898a4$var$slugTextFieldStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
            autoComplete: "off",
            ...fieldProps,
            placeholder: formatMessage((0, $b17Of.default).helpCenterSlugTextFieldPlaceholder),
            testId: "help-centers-management-slug-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k1CGD.ErrorMessage), null, error)))) : null);
};
const $206f64a9996898a4$var$slugTextFieldStyles = (0, $9BVpB.xcss)({
    width: '10%',
    flexGrow: 1
});
const $206f64a9996898a4$var$slugWarningStyles = (0, $9BVpB.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.050',
    verticalAlign: 'middle'
});

});
parcelRegister("hNujq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4207b3f254c20a45$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $4207b3f254c20a45$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpCenterDetailsPageTitle: {
        defaultMessage: 'Details',
        description: 'Help center edit details page title',
        id: 'help.center.edit.details.page.title'
    },
    helpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.center.edit.details.page.description'
    },
    helpHubDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.hub.edit.details.page.description'
    },
    defaultHelpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name of your default help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Default help center edit details page description',
        id: 'help.center.default.help.center.description'
    },
    helpCenterCreateFormTitle: {
        defaultMessage: 'Create help center',
        description: 'Heading of the dialog or panel for creating a new help center',
        id: 'help.center.create.form.title'
    },
    helpCenterCreateFormDescription: {
        defaultMessage: 'Every new help center displays all open portals on your site by default. You can edit the home page layout to show or hide portals based on the audience.',
        description: 'Help center create form description',
        id: 'help.center.create.form.description'
    },
    helpCenterEditFormTitle: {
        defaultMessage: 'Edit help center details',
        description: 'Heading of the panel for editing existing help center details',
        id: 'help.center.edit.form.title'
    },
    helpCenterAddErrorTitle: {
        defaultMessage: `We couldn\u{2019}t create your help center`,
        description: 'Title message for add help center error',
        id: 'help.center.add.error.title'
    },
    helpCenterAddSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 created",
        description: 'Title message for add help center success',
        id: 'help.center.add.success.title.text'
    },
    helpCenterAddSuccessDesc: {
        defaultMessage: 'Go to help center',
        description: 'Description message for add help center success',
        id: 'help.center.add.success.description'
    },
    helpCenterUpdateErrorTitle: {
        defaultMessage: "We couldn\u2019t update your help center",
        description: 'Title message for update help center error',
        id: 'help.center.update.error.title'
    },
    helpCenterUpdateSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 updated",
        description: 'Title message for add help center success',
        id: 'help.center.update.success.title.text'
    },
    helpCenterGenericErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Generic description message for help center error',
        id: 'help.center.update.error.description.generic'
    },
    helpCenterErrorDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{value}',
        description: 'Description message for help center error',
        id: 'help.center.update.error.description'
    },
    helpCenterHardLimitErrorTitle: {
        defaultMessage: "You\u2019ve already created 300 help centers",
        description: 'Message title for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.title'
    },
    helpCenterHardLimitErrorDescription: {
        defaultMessage: 'Delete a help center to create another one.',
        description: 'Message description for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.description'
    },
    helpCenterNameRequiredError: {
        defaultMessage: 'Enter a name for your help center.',
        description: 'Validation error message when help center name is empty',
        id: 'help.center.name.required.validation.error'
    },
    helpCenterNameCharacterLimitError: {
        defaultMessage: 'Enter a help center name with 30 characters or less.',
        description: 'Validation error message when help center name is greater than required limit',
        id: 'help.center.name.character.limit.validation.error'
    },
    helpCenterSlugRequiredError: {
        defaultMessage: 'Add a slug.',
        description: 'Validation error message when help center slug is empty',
        id: 'help.center.slug.required.validation.error'
    },
    helpCenterSlugCharacterLimitError: {
        defaultMessage: 'Enter a slug with 30 characters or less.',
        description: 'Validation error message when help center slug is greater than required limit',
        id: 'help.center.slug.character.limit.validation.error'
    },
    helpCenterSlugSpecialCharacterError: {
        defaultMessage: `Add a slug that doesn\u{2019}t contain special characters other than hyphen (-) and underscore (_).`,
        description: 'Validation error message when help center slug contains special characters',
        id: 'help.center.slug.special.character.validation.error'
    },
    helpCenterAlreadyExistedSlugErrorDescription: {
        defaultMessage: 'A help center with this slug already exists on your site. Try again with a different slug.',
        description: 'Error message when help center slug already exists',
        id: 'help.center.already.existed.slug.error.description'
    },
    helpCenterReservedSlugErrorDescription: {
        defaultMessage: "The slug you\u2019ve entered contains a reserved term. Try again with a different slug.",
        description: 'Error message when entered slug contains reserved term',
        id: 'help.center.reserved.slug.error.description'
    },
    helpCenterRequiredFieldsWarning: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Required warning message for update help center fields',
        id: 'help.center.update.form.required.warning'
    }
});

});

parcelRegister("b17Of", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b1ea1c22c20dc07$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $2b1ea1c22c20dc07$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpCenterNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.center.name.text.field.label.title'
    },
    helpHubNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.hub.name.text.field.label.title'
    },
    helpCenterNameTextFieldPlaceholder: {
        defaultMessage: 'Enter a help center name',
        description: 'Help center name text field placeholder',
        id: 'help.center.name.text.field.placeholder.title'
    },
    helpCenterSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.center.slug.text.field.label.title'
    },
    helpHubSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.hub.slug.text.field.label.title'
    },
    helpCenterSlugInfoTooltip: {
        defaultMessage: 'Share your new help center URL with your team members and customers',
        description: 'Help center slug text change warning tooltip',
        id: 'help.center.slug.text.field.info.tooltip'
    },
    helpCenterSlugInfoLabel: {
        defaultMessage: 'Slug change info',
        description: 'Accessible label for the slug change information icon in the help center form',
        id: 'help.center.slug.text.field.change.info.label'
    },
    helpCenterSlugTextFieldPlaceholder: {
        defaultMessage: 'Enter a slug',
        description: 'Help center slug text field placeholder',
        id: 'help.center.name.slug.field.placeholder.title'
    }
});

});



parcelRegister("g3Iy9", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => (parcelRequire("k9mGU")).HelpCenterFormFooter);

var $k9mGU = parcelRequire("k9mGU");

});
parcelRegister("k9mGU", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => $7f33c1d96904f3fe$export$9f1ed90db1948ebe);

var $bSJIT = parcelRequire("bSJIT");

var $97yQ5 = parcelRequire("97yQ5");

var $4vLTk = parcelRequire("4vLTk");

var $f1bHg = parcelRequire("f1bHg");

var $g0Amm = parcelRequire("g0Amm");

var $kvRY7 = parcelRequire("kvRY7");
const $7f33c1d96904f3fe$export$9f1ed90db1948ebe = ({ submitting: submitting, mode: mode, onCancel: onCancel, isStandaloneForm: isStandaloneForm = false, isCancelDisabled: isCancelDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const renderCancelButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.Button), {
            isDisabled: isCancelDisabled,
            onClick: onCancel,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCancelCreateButton' : 'helpCenterCancelEditButton',
            key: "cancel"
        }, formatMessage((0, $kvRY7.default).helpCenterCancelButtonText));
    const renderSaveButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $97yQ5.LoadingButton), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCreateButton' : 'helpCenterSaveButton',
            testId: "help-centers-management-primary-button",
            key: "save"
        }, formatMessage(mode === 'CREATE' ? (0, $kvRY7.default).helpCenterCreateButtonText : (0, $kvRY7.default).helpCenterSaveButtonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g0Amm.FormFooter), {
        align: isStandaloneForm ? 'start' : 'end'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f1bHg.default), null, isStandaloneForm ? [
        renderSaveButton(),
        renderCancelButton()
    ] : [
        renderCancelButton(),
        renderSaveButton()
    ]));
};

});
parcelRegister("kvRY7", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe74a7bafb37e2ab$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $fe74a7bafb37e2ab$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpCenterSaveButtonText: {
        defaultMessage: 'Save',
        description: 'Button label to save changes to the help center details form',
        id: 'help.center.save.button.text'
    },
    helpCenterCancelButtonText: {
        defaultMessage: 'Cancel',
        description: 'Help center cancel button text',
        id: 'help.center.cancel.button.text'
    },
    helpCenterCreateButtonText: {
        defaultMessage: 'Create',
        description: 'Help center create button text',
        id: 'help.center.create.button.text'
    }
});

});





parcelRegister("5h6qn", function(module, exports) {
$parcel$export(module.exports, "EditHelpCenterLayoutSkeleton", () => (parcelRequire("3R8rL")).default);

var $3R8rL = parcelRequire("3R8rL");

});
parcelRegister("3R8rL", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dcd1659c90fee82$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5VhGP = parcelRequire("5VhGP");

var $cMYsY = parcelRequire("cMYsY");

var $gUpf2 = parcelRequire("gUpf2");

var $hYh8H = parcelRequire("hYh8H");
const $1dcd1659c90fee82$var$EditHelpCenterLayoutSkeleton = ()=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "84px",
        height: "24px"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "20%",
        height: "28px",
        "data-testid": "edit-helpcenter-header-skeleton"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "60%",
        height: "20px"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "100%",
        height: "36px"
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hYh8H.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "50%",
        height: "36px"
    }))))), /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
        direction: "row",
        gap: "space.050"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "10%",
        height: "32px",
        "data-testid": "edit-helpcenter-button-skeleton"
    }), /*#__PURE__*/ $bSJIT.createElement((0, $5VhGP.SkeletonItem), {
        width: "10%",
        height: "32px"
    })));
};
var $1dcd1659c90fee82$export$2e2bcd8739ae039 = $1dcd1659c90fee82$var$EditHelpCenterLayoutSkeleton;

});


parcelRegister("jcNNq", function(module, exports) {
$parcel$export(module.exports, "editHelpCenterExperience", () => $5e70f1f8a30751cd$export$f9e64dbdb3d531);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $5e70f1f8a30751cd$export$f9e64dbdb3d531 = new (0, $1we90.UFOExperience)((0, $eAZuG.editHelpCenterExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("2PHJt", function(module, exports) {
$parcel$export(module.exports, "default", () => $c792bdc470e432ba$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $c792bdc470e432ba$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Title shown in the sidebar when an error occurs loading the help center',
        id: 'help.center.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Message shown in the sidebar prompting the user to refresh and retry',
        id: 'help.center.management.sidebar.error.description'
    }
});

});



parcelRegister("8bZXV", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("750QJ"),
    $kOunM("MILDc"),
    $kOunM("iT0U5"),
    $kOunM("e1RQb"),
    $kOunM("br2rQ"),
    $kOunM("aA07X"),
    $kOunM("7k2Dk"),
    $kOunM("9Vb2H"),
    $kOunM("6qSv5"),
    $kOunM("iylKi"),
    $kOunM("eX2q7"),
    $kOunM("hyEGg"),
    $kOunM("iZJsN"),
    $kOunM("1CL0V"),
    $kOunM("coIBk"),
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("euwch"),
    $kOunM("kwMqK"),
    $kOunM("13X7O"),
    $kOunM("7bN6G"),
    $kOunM("fe9LF"),
    $kOunM("4vCiC")
]).then(()=>parcelRequire('5ewwI'));

});


parcelRegister("5clB8", function(module, exports) {
$parcel$export(module.exports, "helpcenterVirtualAgentRoute", () => $ee39ab51d0329b08$export$60952d52d9999cc1);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $lFpPv = parcelRequire("lFpPv");

var $cVM5r = parcelRequire("cVM5r");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");
parcelRequire("5lPCP");
var $hbIgt = parcelRequire("hbIgt");
parcelRequire("dBiCB");
var $Ee5M8 = parcelRequire("Ee5M8");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");

var $1xzNy = parcelRequire("1xzNy");
parcelRequire("eByfJ");
var $1mm9L = parcelRequire("1mm9L");

var $2fuR7 = parcelRequire("2fuR7");

var $bqOzN = parcelRequire("bqOzN");

const $ee39ab51d0329b08$var$AsyncVirtualAgentPage = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("6Yfy0")).then((VirtualAgentSettingsPage)=>VirtualAgentSettingsPage), {
        moduleId: "./packages/virtual-agent/virtual-agent-settings/src/index.tsx"
    })
});
const $ee39ab51d0329b08$var$VirtualAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, $6LgZh.default)((0, $fv7xe.default)({
        redirectUrl: '/'
    }), (0, $ifEXU.default)({
        message: formatMessage((0, $1xzNy.authPageMessage)),
        callToActionText: formatMessage((0, $1xzNy.callToActionUrlText)),
        callToActionUrl: '/portals'
    }), ...(0, $lFpPv.isVAOnHelpCenterGAEnabled)() ? [] : [
        (0, $Ee5M8.default)({
            message: formatMessage((0, $2fuR7.default).aiConfigNotEnabledError),
            callToActionText: formatMessage((0, $1xzNy.callToActionUrlText)),
            callToActionUrl: '/portals'
        })
    ])(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mm9L.default), {
            featureName: "Virtual Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ee39ab51d0329b08$var$AsyncVirtualAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
const $ee39ab51d0329b08$export$60952d52d9999cc1 = {
    name: 'virtualAgentSettings',
    path: '/:helpcenterId/virtual-agent',
    exact: true,
    resources: [
        (0, $bqOzN.HelpCenterVirtualAgentResource)
    ],
    component: (0, $hbIgt.withRouter)($ee39ab51d0329b08$var$VirtualAgentPage)
};

});
parcelRegister("2fuR7", function(module, exports) {
$parcel$export(module.exports, "default", () => $234775d58055928e$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $234775d58055928e$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    helpCenterReportingPageTitle: {
        defaultMessage: 'Performance',
        description: 'Title message for Help Center Reporting',
        id: 'helpcenter.reporting.title'
    },
    helpCenterReportingPageSubtitleV2: {
        defaultMessage: 'See the performance of the virtual service agent on your help center from the last 7 days. ',
        description: 'Subtitle message for Help Center Reporting',
        id: 'helpcenter.reporting.subtitle-v-2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    IphLinkTextV2: {
        defaultMessage: 'Read more about using the virtual service agent on your help center.',
        description: 'Text for Link that should open in in-product help',
        id: 'helpcenter.reporting.iph-link-text-v-2'
    },
    aiConfigNotEnabledError: {
        defaultMessage: 'AI is not enabled for this portal',
        description: 'Error message when AI is not enabled for the tenant',
        id: 'helpcenter.reporting.ai.config.not.enabled.error.non-final'
    }
});

});

parcelRegister("bqOzN", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $797782cb6436ed6d$export$7ab6648586bf1bbf);

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $9P2Zq = parcelRequire("9P2Zq");

var $iW3CQ = parcelRequire("iW3CQ");

var $3LQyI = parcelRequire("3LQyI");

var $lWqpV = parcelRequire("lWqpV");
const $797782cb6436ed6d$export$7ab6648586bf1bbf = (0, $3LQyI.createRelayResource)({
    type: 'HELP_REPORTING_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        let computedHelpCenterAri = helpCenterAri;
        const activationId = (0, $fuVmc.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        computedHelpCenterAri = (0, $9P2Zq.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $lWqpV.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri,
                isJsmAIConfigEnabled: (0, $iW3CQ.getJsmAIConfigEnabled)(),
                isVAOnHelpCenterGAEnabled: (0, $lFpPv.isVAOnHelpCenterGAEnabled)(),
                isHideKbColumnEnabled: (0, $lFpPv.isHideKbColumnEnabled)(),
                isTotalArticleCountEnabled: (0, $lFpPv.isTotalArticleCountEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("lWqpV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f54f9030d3a651e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6bb91c1dc2b4e58c2ef9ee0822d8ca64>>
 * @relayHash 127cb5587f2a92a32c9a887addd1d130
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393
const $2f54f9030d3a651e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideKbColumnEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJsmAIConfigEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTotalArticleCountEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVAOnHelpCenterGAEnabled"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        v6 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterAri"
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterId",
                    "value": ""
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterMappingStatus",
                    "value": "LINKED"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "settingsVirtualAgentSettingsTabFragment"
                                                },
                                                v11 /*: any*/ 
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsVirtualAgentLinkedArticlesFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isVAOnHelpCenterGAEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "isHideKbColumnEnabled",
                                    "variableName": "isHideKbColumnEnabled"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isVAOnHelpCenterGAEnabled",
                                    "variableName": "isVAOnHelpCenterGAEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "settingsVirtualAgentSettingsTabMappedProjectsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "slug"
                                                }
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v12 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpObjectStoreArticleSearchResponse"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ],
                                    "type": "HelpObjectStoreArticleSearchResults"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isVAOnHelpCenterGAEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "isVAOnHelpCenterGAEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectsMappedToHelpCenter",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isHideKbColumnEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v7 /*: any*/ ,
                                                                            "kind": "LinkedField",
                                                                            "name": "knowledgeBaseArticlesCount",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "count"
                                                                                        }
                                                                                    ],
                                                                                    "type": "KnowledgeBaseArticleCountSource"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "virtualAgentConfiguration",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isAiResponsesEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "liveIntentsCount"
                                                                                }
                                                                            ],
                                                                            "type": "VirtualAgentConfiguration"
                                                                        },
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "VirtualAgentQueryError"
                                                                        }
                                                                    ]
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "filters": [
                                                "cloudId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "projectBreakdownTableMappedProjectsFragment_jiraProjectsMappedToHelpCenter",
                                            "kind": "LinkedHandle",
                                            "name": "jiraProjectsMappedToHelpCenter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393",
            "metadata": {},
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2f54f9030d3a651e$var$node.hash = "6836684020e009f1da0ca82a53368cd7";
var $2f54f9030d3a651e$export$2e2bcd8739ae039 = $2f54f9030d3a651e$var$node;

});


parcelRegister("6Yfy0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("36aBu"),
    $kOunM("lcV1E")
]).then(()=>parcelRequire('5mOYJ'));

});


parcelRegister("clulZ", function(module, exports) {
$parcel$export(module.exports, "viewHelpCentersManagementPageRoute", () => $6a7632fc149c9aed$export$e49071c21a45635e);
$parcel$export(module.exports, "viewHelpHubsManagementPageRoute", () => $6a7632fc149c9aed$export$589f7c1da1d95244);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("1mIIj");
var $6LgZh = parcelRequire("6LgZh");

var $jcRK7 = parcelRequire("jcRK7");

var $4vLTk = parcelRequire("4vLTk");
parcelRequire("jMb7S");
var $ifEXU = parcelRequire("ifEXU");
parcelRequire("gCsyK");
var $fv7xe = parcelRequire("fv7xe");

var $87QgR = parcelRequire("87QgR");

var $iW3CQ = parcelRequire("iW3CQ");

var $gYDJY = parcelRequire("gYDJY");
parcelRequire("lozSZ");
var $9FV5Q = parcelRequire("9FV5Q");
var $imW3m = parcelRequire("imW3m");
const $6a7632fc149c9aed$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT = 'jira_sidebar_show_helpcenter';
const $6a7632fc149c9aed$var$isJiraSidebarShowHelpcenterExperimentEnabled = ()=>(0, $87QgR.default).getExperimentValue($6a7632fc149c9aed$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT, 'isEnabled', false);
const $6a7632fc149c9aed$var$JiraHelpCenterManagementRedirect = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        (0, $gYDJY.replace)(`${(0, $iW3CQ.getJiraDisplayUrl)()}/jira/helpcenter-management${window.location.search}`);
    }, []);
    return null;
};
const $6a7632fc149c9aed$var$HelpCentersManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, $6LgZh.default)((0, $fv7xe.default)({
            redirectUrl: '/'
        }), (0, $ifEXU.default)({
            message: formatMessage((0, $9FV5Q.authPageMessage)),
            callToActionText: formatMessage((0, $9FV5Q.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $9FV5Q.HelpCentersManagementPage)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
const $6a7632fc149c9aed$var$HelpHubsManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, $6LgZh.default)((0, $fv7xe.default)({
            redirectUrl: '/'
        }), (0, $ifEXU.default)({
            message: formatMessage((0, $9FV5Q.authPageMessage)),
            callToActionText: formatMessage((0, $9FV5Q.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $9FV5Q.HelpCentersManagementPage)), [
        formatMessage
    ]);
    if ($6a7632fc149c9aed$var$isJiraSidebarShowHelpcenterExperimentEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6a7632fc149c9aed$var$JiraHelpCenterManagementRedirect, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, null);
};
const $6a7632fc149c9aed$export$e49071c21a45635e = {
    name: (0, $jcRK7.ScreenName).HELP_CENTERS_MANAGEMENT,
    path: '/',
    exact: true,
    component: $6a7632fc149c9aed$var$HelpCentersManagement,
    resources: [
        (0, $imW3m.HelpCentersManagementResource),
        (0, $imW3m.MigrationCandidatesResource)
    ]
};
const $6a7632fc149c9aed$export$589f7c1da1d95244 = {
    name: (0, $jcRK7.ScreenName).HELP_HUBS_MANAGEMENT,
    path: '/hubs',
    exact: true,
    component: $6a7632fc149c9aed$var$HelpHubsManagement,
    resources: [
        (0, $imW3m.HelpCentersManagementResource)
    ]
};

});
parcelRegister("lozSZ", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => (parcelRequire("9FV5Q")).HelpCentersManagementPage);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("imW3m")).HelpCentersManagementResource);
$parcel$export(module.exports, "MigrationCandidatesResource", () => (parcelRequire("imW3m")).MigrationCandidatesResource);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("9FV5Q")).callToActionUrlText);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("9FV5Q")).authPageMessage);

var $9FV5Q = parcelRequire("9FV5Q");
var $imW3m = parcelRequire("imW3m");
parcelRequire("l2S8K");
var $l0SHx = parcelRequire("l0SHx");

});
parcelRegister("9FV5Q", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => $f0ef07e8bab119ff$export$233bfa78dd235938);
$parcel$export(module.exports, "callToActionUrlText", () => $f0ef07e8bab119ff$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $f0ef07e8bab119ff$export$5342e2a00fe6d647);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("imW3m")).HelpCentersManagementResource);
$parcel$export(module.exports, "MigrationCandidatesResource", () => (parcelRequire("imW3m")).MigrationCandidatesResource);

var $cVM5r = parcelRequire("cVM5r");
parcelRequire("cJJTb");
var $2vYDF = parcelRequire("2vYDF");

var $1DEHg = parcelRequire("1DEHg");

var $imW3m = parcelRequire("imW3m");

const $f0ef07e8bab119ff$export$233bfa78dd235938 = (0, $cVM5r.default)({
    loader: (0, $2vYDF.lazyForPaint)(()=>(parcelRequire("9gq03")), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/help-centers-management-page/help-centers-management-page.tsx"
    })
});
const $f0ef07e8bab119ff$export$d96795d242b62963 = (0, $1DEHg.default).callToActionUrlText;
const $f0ef07e8bab119ff$export$5342e2a00fe6d647 = (0, $1DEHg.default).authPageMessage;

});
parcelRegister("1DEHg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0082d8ffe246fdae$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $0082d8ffe246fdae$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    migrationAnnouncementBase: {
        defaultMessage: 'Your help centers are getting an update.',
        description: 'Base announcement shown above Help Center management when migration is available.',
        id: 'help.center.management.page.migration.announcement.base'
    },
    migrationAnnouncementDueDate: {
        defaultMessage: 'Update now or test it out before {dueDate, date, medium}.',
        description: "Migration announcement deadline, formatted in the viewer\u2019s locale.",
        id: 'help.center.management.page.migration.announcement.due-date'
    },
    migrationAnnouncementLearnMore: {
        defaultMessage: 'Learn more.',
        description: 'Link label leading to more information about the Help Center migration.',
        id: 'help.center.management.page.migration.announcement.learn-more'
    },
    migrationHeaderText: {
        defaultMessage: 'Update help centers',
        description: 'Help Center management screen header text when help center migration is available.',
        id: 'help.center.management.page.migration.header.text'
    },
    migrationHeaderDescription: {
        defaultMessage: 'Manage your help centers and update them here.',
        description: 'Help Center management screen header description when help center migration is available.',
        id: 'help.center.management.page.migration.header.description'
    },
    migrationUpdateButton: {
        defaultMessage: 'Update help center',
        description: 'Button that starts the Help Center update flow from the management page header.',
        id: 'help.center.management.page.migration.update.help.center.button'
    },
    migrationHeaderLearnMore: {
        defaultMessage: 'Learn more about updating help centers',
        description: 'Link label leading to more information about updating Help Centers from the management page header.',
        id: 'help.center.management.page.migration.header.learn-more'
    },
    headerTextHelpCenter: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text',
        id: 'help.center.management.page.header.text'
    },
    headerTextHelpHub: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text hubs',
        id: 'help.center.management.page.header.text.hubs'
    },
    headerDescriptionHelpCenter: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description'
    },
    headerDescriptionReadMoreLinkHelpCenter: {
        defaultMessage: 'Read more about help centers',
        description: 'Help centers management screen header description read more link',
        id: 'help.center.management.page.header.description.read.more.link'
    },
    headerDescriptionHelpHub: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description.hubs'
    },
    addButtonTextHelpCenter: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen add help center button text',
        id: 'help.center.management.add.help.center.button.text'
    },
    addButtonTextHelpHub: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen create button text',
        id: 'help.center.management.create.button.text.hubs'
    },
    createOptionHelpCenterTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option help center title',
        id: 'help.center.management.create.option.help.center.title'
    },
    createOptionHelpCenterDescription: {
        defaultMessage: 'The default help experience with portals, topics, and more',
        description: 'Help centers management screen create option help center description',
        id: 'help.center.management.create.option.help.center.description'
    },
    createOptionHubTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option hub title',
        id: 'help.center.management.create.option.hub.title'
    },
    createOptionHubDescription: {
        defaultMessage: 'Create a modern help experience with components and customization',
        description: 'Help centers management screen create option hub description',
        id: 'help.center.management.create.option.hub.description'
    },
    genericErrorHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.message'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.text'
    },
    upgradeTitleCreateClick: {
        defaultMessage: 'Upgrade to create new help centers',
        description: 'Popup title to upgrade to create help center',
        id: 'help.center.management.upgrade.title.create.click'
    },
    upgradeDescriptionCreateClick: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create multiple help centers on your site.',
        description: 'Popup description to upgrade to create help center',
        id: 'help.center.management.upgrade.description.create.click'
    },
    helpHubEmptyStateHeader: {
        defaultMessage: 'Create modern help centers to serve your customers',
        description: 'Help center empty state header',
        id: 'help.center.management.page.help.hub.empty.state.header'
    },
    helpHubEmptyStateDescription: {
        defaultMessage: 'Empower customers to find answers with knowledge base articles or get support by raising requests in Jira Service Management.',
        description: 'Help center empty state description',
        id: 'help.center.management.page.help.hub.empty.state.description'
    },
    jiraHelpCenterManagementMessage: {
        defaultMessage: 'Your help centers can be created and managed from within the Jira Service Management app navigation.',
        description: 'Information message that directs customers to the Jira Service Management app navigation where help centers can be created and managed.',
        id: 'help.center.management.page.jira.helpcenter.management.message'
    },
    jiraHelpCenterManagementAction: {
        defaultMessage: 'Manage help centers',
        description: 'External link in the Help Center management information message that opens Jira Service Management help center management.',
        id: 'help.center.management.page.jira.helpcenter.management.action'
    }
});

});

parcelRegister("imW3m", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementResource", () => $4292268bee79a861$export$7e2ebb4b559ed1ce);
$parcel$export(module.exports, "MigrationCandidatesResource", () => $4292268bee79a861$export$4cbea945316f010d);

var $jcRK7 = parcelRequire("jcRK7");

var $87QgR = parcelRequire("87QgR");

var $kbkME = parcelRequire("kbkME");

var $3LQyI = parcelRequire("3LQyI");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("5lPCP");
var $iXC0o = parcelRequire("iXC0o");

var $5tRMO = parcelRequire("5tRMO");

var $4PlYo = parcelRequire("4PlYo");

var $hquTn = parcelRequire("hquTn");
const $4292268bee79a861$var$HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
const $4292268bee79a861$export$7e2ebb4b559ed1ce = (0, $3LQyI.createRelayResource)({
    type: 'HELP_CENTERS_MANAGEMENT',
    getQuery: ({ route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>{
        const isHelpHubRoute = route.name === (0, $jcRK7.ScreenName).HELP_HUBS_MANAGEMENT;
        const filterType = isHelpHubRoute ? 'HELP_HUB' : 'BASIC';
        return {
            parameters: (0, $hquTn.default),
            variables: {
                cloudId: cloudId,
                workspaceAri: workspaceAri,
                SORT_ORDER: $5tRMO.SORT_ORDER,
                NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $5tRMO.NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
                filterType: (0, $87QgR.default).checkGate('enable-jsm-in-hubs') ? filterType : null
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $4292268bee79a861$export$4cbea945316f010d = (0, $iXC0o.createResource)({
    type: 'RELAY_RESOURCE_TYPE_MIGRATION_CANDIDATES',
    getKey: ({ query: query, route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>`MIGRATION_CANDIDATES:${route.name}:${query.migrationStep ?? ''}:${cloudId}:${workspaceAri}`,
    getData: ({ query: query, route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>{
        if (route.name !== (0, $jcRK7.ScreenName).HELP_CENTERS_MANAGEMENT || query.migrationStep !== 'select' || !(0, $87QgR.default).checkGate($4292268bee79a861$var$HELP_HUB_MIGRATION_GATE)) return null;
        return (0, $a2qIF.loadQuery)((0, $kbkME.getRelayEnvironment)(), (0, $4PlYo.default), {
            cloudId: cloudId,
            workspaceAri: workspaceAri
        }, {
            fetchPolicy: 'store-or-network'
        });
    },
    maxAge: 0
});

});
parcelRegister("4PlYo", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ad8b6fb43cc6f45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd10c3f51643ab5365820fa677b8d05e>>
 * @relayHash 918baf2e918b4daa1f9512f460ba66f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b4c8db1810411fd3c1658a8aa00eb0ddb96fcafb2a2af12d3163b2df76311f70
const $9ad8b6fb43cc6f45$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "type": "BASIC"
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 300
        },
        {
            "kind": "Literal",
            "name": "sortOrder",
            "value": "CREATED_DATE_DESCENDING"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "slug"
            },
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterMigrationInfo",
                "kind": "LinkedField",
                "name": "migration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "migrationDataCandidatesQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "migrationDataCandidatesQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b4c8db1810411fd3c1658a8aa00eb0ddb96fcafb2a2af12d3163b2df76311f70",
            "metadata": {},
            "name": "migrationDataCandidatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9ad8b6fb43cc6f45$var$node.hash = "8ed51374d75c3cba42f22030068ce624";
var $9ad8b6fb43cc6f45$export$2e2bcd8739ae039 = $9ad8b6fb43cc6f45$var$node;

});

parcelRegister("hquTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e723f47553b0253c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caad237387f5fd4010799a6441a57b8a>>
 * @relayHash 6c8153f7ad0165d2a080749f574219c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36dec7ff3f1d98fdfdf67c8e99e74325d258e5db21530cd918d3a58e3df8d9d2
const $e723f47553b0253c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v7 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "filterType"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
        },
        {
            "kind": "Variable",
            "name": "sortOrder",
            "variableName": "SORT_ORDER"
        },
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH",
                            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
                        },
                        {
                            "kind": "Variable",
                            "name": "SORT_ORDER",
                            "variableName": "SORT_ORDER"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "filterType",
                            "variableName": "filterType"
                        },
                        v6 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "helpCentersManagementPageFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterMigrationInfo",
                                                            "kind": "LinkedField",
                                                            "name": "migration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "migratedHubAri"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterBranding",
                                                            "kind": "LinkedField",
                                                            "name": "helpCenterBranding",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isBannerAvailable"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "useDefaultBanner"
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBrandingColors",
                                                                    "kind": "LinkedField",
                                                                    "name": "colors",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "primary"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBanner",
                                                                    "kind": "LinkedField",
                                                                    "name": "banner",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mappedProjectsCount"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "helpCentersManagementPageFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "36dec7ff3f1d98fdfdf67c8e99e74325d258e5db21530cd918d3a58e3df8d9d2",
            "metadata": {},
            "name": "helpCentersManagementPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e723f47553b0253c$var$node.hash = "767d192c1eee830ece678d269a62c024";
var $e723f47553b0253c$export$2e2bcd8739ae039 = $e723f47553b0253c$var$node;

});


parcelRegister("9gq03", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("1kFIN"),
    $kOunM("750QJ"),
    $kOunM("e1RQb"),
    $kOunM("j2Oap"),
    $kOunM("i5Ki2"),
    $kOunM("f80Rt"),
    $kOunM("7uKBz"),
    $kOunM("6uVjJ"),
    $kOunM("iZJsN"),
    $kOunM("9hJYz"),
    $kOunM("aHc5N"),
    $kOunM("3M7DB"),
    $kOunM("fJV2h"),
    $kOunM("lzQaK"),
    $kOunM("bYQHQ"),
    $kOunM("eCdiR"),
    $kOunM("fs156"),
    $kOunM("2kEJi"),
    $kOunM("01Ow9"),
    $kOunM("fzI7a"),
    $kOunM("kI2bC"),
    $kOunM("uBPzN"),
    $kOunM("bZkRg"),
    $kOunM("29ig6"),
    $kOunM("7VsxZ")
]).then(()=>parcelRequire('3TT2l'));

});





parcelRegister("h9hKv", function(module, exports) {
$parcel$export(module.exports, "default", () => $57d238ff3953fb86$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $9cDCX = parcelRequire("9cDCX");

var $f9uTr = parcelRequire("f9uTr");

parcelRequire("5lPCP");
var $7t0F6 = parcelRequire("7t0F6");
var $2a9Vu = parcelRequire("2a9Vu");

var $8D35l = parcelRequire("8D35l");

var $XiIOl = parcelRequire("XiIOl");

var $1YZEU = parcelRequire("1YZEU");

var $bcBh3 = parcelRequire("bcBh3");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $8VdVQ = parcelRequire("8VdVQ");
parcelRequire("ckGNT");
var $2LtGs = parcelRequire("2LtGs");
parcelRequire("i7Znb");
var $eV8mZ = parcelRequire("eV8mZ");

var $87QgR = parcelRequire("87QgR");

var $fGcJm = parcelRequire("fGcJm");

var $eDcdn = parcelRequire("eDcdn");

var $g0pT2 = parcelRequire("g0pT2");

var $fHAr3 = parcelRequire("fHAr3");
const $57d238ff3953fb86$var$HELP_HUB_MIGRATION = 'enable-help-hub-migration';
const $57d238ff3953fb86$var$isHelpHubMigrationEnabled = ()=>(0, $87QgR.default).checkGate($57d238ff3953fb86$var$HELP_HUB_MIGRATION);
const $57d238ff3953fb86$export$2f7745f2f5ab3897 = ()=>{
    const hubHomepageRoute = (0, $eV8mZ.getHubHomepageRoute)();
    return [
        hubHomepageRoute,
        ...$57d238ff3953fb86$var$isHelpHubMigrationEnabled() ? [
            {
                ...hubHomepageRoute,
                name: 'hub-homepage-portals',
                path: '/portals'
            }
        ] : [],
        (0, $eV8mZ.getHubCustompageRoute)(),
        ...(0, $87QgR.default).checkGate('portal-pages-in-hub') ? [
            (0, $eV8mZ.getHubPortalPageRoute)()
        ] : [],
        /**
   * Account Management Pages
   */ (0, $eV8mZ.getLoginRouteWithHubShell)(),
        (0, $eV8mZ.getPortalLoginRouteWithHubShell)(),
        (0, $eV8mZ.getResetPasswordRouteWithHubShell)(),
        (0, $eV8mZ.getPortalResetPasswordRouteWithHubShell)(),
        (0, $eV8mZ.getSignupRouteWithHubShell)(),
        (0, $eV8mZ.getPortalSignupRouteWithHubShell)(),
        (0, $eV8mZ.getCompleteSignupRouteWithHubShell)(),
        (0, $eV8mZ.getPortalCompleteSignupRouteWithHubShell)(),
        (0, $eV8mZ.getPortalInvitedSignupRouteWithHubShell)(),
        (0, $eV8mZ.getCheckEmailRouteWithHubShell)(),
        (0, $eV8mZ.getUnsubscribeRouteWithHubShell)(),
        (0, $eV8mZ.getHubUserProfileRouteWithHubShell)(),
        (0, $eV8mZ.getPortalAccessForbiddenRouteWithHubShell)(),
        (0, $8D35l.consentFormRoute /* TODO: The consent form route needs the Hub Shell */ ),
        ...(0, $lFpPv.isEmailVerifiedSignalEnabled)() ? [
            (0, $bcBh3.userVerifyEmailRoute)
        ] : [],
        /**
   * Request Management Pages
   */ (0, $eV8mZ.getRequestCreateRouteWithHubShell)(),
        (0, $eV8mZ.getAnonymousRequestSuccessRouteWithHubShell)(),
        (0, $eV8mZ.getRequestFeedbackRouteWithHubShell)(),
        (0, $eV8mZ.getJsmRequestDetailsRouteWithHubShell)(),
        ...(0, $87QgR.default).checkGate((0, $fGcJm.JSM_HUB_CUSTOMIZE_MENU_GATE)) ? [
            (0, $eV8mZ.getJsmManageColumnsRequestsListRouteWithHubShell)()
        ] : [
            (0, $eV8mZ.getJsmRequestsListRouteWithHubShell)()
        ],
        (0, $eV8mZ.getJsmApprovalsRouteWithHubShell)(),
        (0, $eV8mZ.getJsmRequestApprovalRouteWithHubShell)(),
        (0, $eV8mZ.getSurveyRouteWithHubShell)(),
        /** TODO: Article Pages */ (0, $eV8mZ.getHubViewKbRoute)(),
        (0, $eV8mZ.getHubViewArticleRoute)(),
        (0, $eV8mZ.getHubViewCrossSiteArticleRoute)(),
        (0, $eV8mZ.getHubViewPortalArticleRoute)(),
        (0, $eV8mZ.getHubViewCrossSitePortalArticleRoute)(),
        /**
   * Search related pages
   */ (0, $eV8mZ.getHubAllSearchResultsRouteWithHubShell)(),
        /**
   * Hub Management pages
   */ (0, $1YZEU.helpcenterEditRoute),
        (0, $1YZEU.helpcenterManageProjectsRoute),
        (0, $1YZEU.helpcenterManageCustomPagesRoute),
        /**
   * EmbeddablePages
   */ (0, $XiIOl.getEmbedCreateRequestRoute)(),
        (0, $XiIOl.embedKBArticleRoute),
        /**
   * Not found route
   */ (0, $eV8mZ.getNotFoundRouteWithHubShell)()
    ];
};
const $57d238ff3953fb86$export$bd848585fb624145 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $9cDCX.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $9cDCX.lightenColor)(themeColor);
    const routes = (0, $bSJIT.useMemo)(()=>$57d238ff3953fb86$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    const routeContent = (0, $eV8mZ.isJsmHubCustomizeMenuEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2LtGs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7t0F6.RouteComponent), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7t0F6.RouteComponent), null);
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4v2A7.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2a9Vu.Router), {
        routes: routes,
        history: (0, $eDcdn.default),
        isGlobal: false,
        plugins: [
            (0, $fHAr3.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f9uTr.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8VdVQ.UFOWatcher), null), routeContent, (0, $87QgR.default).checkGate('enable_rovo_in_help_hubs') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g0pT2.RovoWidgetRenderer), null)));
};
const $57d238ff3953fb86$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getThemeColor), (0, $hvIQS.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $57d238ff3953fb86$export$2e2bcd8739ae039 = (0, $f2mlD.default)($57d238ff3953fb86$var$selector)($57d238ff3953fb86$export$bd848585fb624145);

});
parcelRegister("g0pT2", function(module, exports) {
$parcel$export(module.exports, "RovoWidgetRenderer", () => $d560477d7dc98d58$export$5d23099fbd84d512);

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");
parcelRequire("5lPCP");
var $h1bGI = parcelRequire("h1bGI");

var $87QgR = parcelRequire("87QgR");

var $5X2Zr = parcelRequire("5X2Zr");

var $4d1r2 = parcelRequire("4d1r2");

var $7BW50 = parcelRequire("7BW50");
// Route names to exclude from showing the Rovo widget. These are the customisable hub pages, where
// the callout banner is already the Rovo entry point, so this corner widget would be a second one.
const $d560477d7dc98d58$var$EXCLUDED_ROVO_WIDGET_ROUTES = [
    'hub',
    'hub-custom-page',
    'hub-portal-page'
];
const $d560477d7dc98d58$export$5d23099fbd84d512 = ()=>{
    var _routerState$route, _routerState$match;
    const [routerState] = (0, $h1bGI.useRouter)();
    const currentRouteName = (_routerState$route = routerState.route) === null || _routerState$route === void 0 ? void 0 : _routerState$route.name;
    if (!currentRouteName || $d560477d7dc98d58$var$EXCLUDED_ROVO_WIDGET_ROUTES.includes(currentRouteName)) return null;
    const cloudId = (0, $fuVmc.getCloudId)();
    const helpCenterAri = (0, $fuVmc.getHelpCenterAri)();
    if (!cloudId || !helpCenterAri) return null;
    // Keyed off the route carrying a portalId rather than a list of route names, so new
    // portal-scoped routes are covered without anyone having to remember to add them here.
    const portalId = (_routerState$match = routerState.match) === null || _routerState$match === void 0 || (_routerState$match = _routerState$match.params) === null || _routerState$match === void 0 ? void 0 : _routerState$match.portalId;
    const shouldUsePortalWidget = Boolean(portalId) && (0, $87QgR.default).checkGate('hubs_rovo_config_from_kosh');
    // Spread rather than `brandPrimaryColor={undefined}` so unbranded props stay exactly as before.
    const renderWidget = (brandPrimaryColor)=>{
        const brandProps = brandPrimaryColor ? {
            brandPrimaryColor: brandPrimaryColor
        } : {};
        return shouldUsePortalWidget && portalId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7BW50.PortalRovoWidget), {
            portalId: portalId,
            cloudId: cloudId,
            ...brandProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5X2Zr.RovoServiceAgentWidgetInjector), {
            siteId: cloudId,
            widgetId: helpCenterAri,
            surface: "HUB",
            ...brandProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4d1r2.WithHubBrandPrimaryColor), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, renderWidget);
};

});
parcelRegister("4d1r2", function(module, exports) {
$parcel$export(module.exports, "WithHubBrandPrimaryColor", () => $1e297a5bfdbbbf38$export$c7dd6c4f33796462);

var $1eqne = parcelRequire("1eqne");

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $a2qIF = parcelRequire("a2qIF");

var $87QgR = parcelRequire("87QgR");
const $1e297a5bfdbbbf38$var$HubBrandPrimaryColorQueryRenderer = ({ children: children, cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
    var _data$helpCenter;
    // Same field and arguments as the hub bootstrap query (`isDraft: false` included), so Relay
    // normally answers this from the store. Its own query because the bootstrap's copy is masked
    // inside company-hub-common's fragment.
    const data = (0, $a2qIF.useLazyLoadQuery)((0, $1eqne.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const primary = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(primary || undefined));
};
const $1e297a5bfdbbbf38$export$c7dd6c4f33796462 = ({ children: children, cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
    if (!(0, $87QgR.default).checkGate('hub_rovo_brand_theming')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(undefined));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: "help-center",
        id: "rovo-widget-brand-primary-color",
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children(undefined))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1e297a5bfdbbbf38$var$HubBrandPrimaryColorQueryRenderer, {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, children)));
};

});
parcelRegister("1eqne", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ddcf8b63645b4cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbaeb8f8bf4429e3203b9c9c3a9901ec>>
 * @relayHash f228feb835a19a0dfb5caa604c2aa5cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1c5bad114e75126d04562782a1a51eaf52bb0b6949001372eedd5ab4abf3490
const $4ddcf8b63645b4cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Literal",
            "name": "isDraft",
            "value": false
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hubBrandPrimaryColorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hubBrandPrimaryColorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f1c5bad114e75126d04562782a1a51eaf52bb0b6949001372eedd5ab4abf3490",
            "metadata": {},
            "name": "hubBrandPrimaryColorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4ddcf8b63645b4cc$var$node.hash = "2522af675a8061e00c4c76881c160677";
var $4ddcf8b63645b4cc$export$2e2bcd8739ae039 = $4ddcf8b63645b4cc$var$node;

});


parcelRegister("7BW50", function(module, exports) {
$parcel$export(module.exports, "PortalRovoWidget", () => $8d555a5a69d057c4$export$73805f5dce71ead8);

var $bSJIT = parcelRequire("bSJIT");

var $dJ2iN = parcelRequire("dJ2iN");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");
parcelRequire("ik9zp");
var $iWhHo = parcelRequire("iWhHo");

var $4op5x = parcelRequire("4op5x");

var $5X2Zr = parcelRequire("5X2Zr");
const $8d555a5a69d057c4$export$9490f57ca961f41 = ({ cloudId: cloudId, projectId: projectId, brandPrimaryColor: brandPrimaryColor })=>{
    if (!projectId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5X2Zr.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: (0, $4op5x.JiraProjectAri).create({
            projectId: projectId.toString(),
            siteId: cloudId
        }).toString(),
        surface: "HUB",
        ...brandPrimaryColor ? {
            brandPrimaryColor: brandPrimaryColor
        } : {}
    });
};
const $8d555a5a69d057c4$export$73805f5dce71ead8 = (0, $f2mlD.default)((state, { portalId: portalId })=>({
        // `toSafeInteger` directly rather than `getPortalIdAsNumber` from `view/search/common`: that
        // barrel pulls in analytics-components -> history -> getMeta, which blows up at import time.
        projectId: (0, $iWhHo.getProjectId)(state, (0, (/*@__PURE__*/$parcel$interopDefault($dJ2iN)))(portalId))
    }))($8d555a5a69d057c4$export$9490f57ca961f41);

});



parcelRegister("f3Ccb", function(module, exports) {
$parcel$export(module.exports, "JSMCookieConsentBanner", () => (parcelRequire("fIVS9")).SSRSafeJSMCookieConsentBanner);

var $fIVS9 = parcelRequire("fIVS9");

});
parcelRegister("fIVS9", function(module, exports) {
$parcel$export(module.exports, "SSRSafeJSMCookieConsentBanner", () => $466abf939bb0bc87$export$757e76e75a25cb0c);

var $bSJIT = parcelRequire("bSJIT");

var $5YUMZ = parcelRequire("5YUMZ");

var $87QgR = parcelRequire("87QgR");

var $iKd9A = parcelRequire("iKd9A");

var $1oY6f = parcelRequire("1oY6f");

var $iiTNF = parcelRequire("iiTNF");

var $ahXPR = parcelRequire("ahXPR");


var $9hihM = parcelRequire("9hihM");
/**
 * Feature gate: csm-cm04-use-atlassian-browser-storage-controls
 *
 * Enables Atlassian-managed browser storage controls (webStorageEnabled) for the
 * CSM/JSM Help Center cookie consent banner.
 *
 * Note: registered as kebab-case in Statsig/Switcheroo; do not convert to snake_case.
 *
 * Rollout: BEARS-1324
 * Owner: @team-bears
 * Cleanup: FFCLEANUP-122701
 */ const $466abf939bb0bc87$var$CSM_CM04_USE_ATLASSIAN_BROWSER_STORAGE_CONTROLS = 'csm-cm04-use-atlassian-browser-storage-controls';
const $466abf939bb0bc87$var$isCsmCm04UseAtlassianBrowserStorageControlsEnabled = ()=>(0, $87QgR.default).checkGate($466abf939bb0bc87$var$CSM_CM04_USE_ATLASSIAN_BROWSER_STORAGE_CONTROLS);
// Phase-4 gate: when true, blocks uncategorized web-storage/indexedDB keys (disables the allow-uncategorized overrides).
const $466abf939bb0bc87$var$CSM_CM04_BSC_BLOCK_UNCATEGORIZED = 'csm-cm04-bsc-block-uncategorized';
const $466abf939bb0bc87$var$isCsmCm04BscBlockUncategorizedEnabled = ()=>(0, $87QgR.default).checkGate($466abf939bb0bc87$var$CSM_CM04_BSC_BLOCK_UNCATEGORIZED);
const $466abf939bb0bc87$export$757e76e75a25cb0c = ()=>{
    const ssrInput = (0, $5YUMZ.getSSRInput)();
    const consentToken = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesConsentToken);
    const fallbackConsentToken = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesFallbackToken);
    const cookieData = consentToken ? {
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    } : {
        fallbackConsentToken: fallbackConsentToken
    };
    (0, $bSJIT.useEffect)(()=>{
        const perimeter = (0, $9hihM.isFedRamp)() ? 'fedramp-moderate' : 'commercial';
        if (!$466abf939bb0bc87$var$isCsmCm04UseAtlassianBrowserStorageControlsEnabled()) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1oY6f.initializeControls)({
                product: 'jira'
            });
            return;
        }
        const blockUncategorizedGate = $466abf939bb0bc87$var$isCsmCm04BscBlockUncategorizedEnabled();
        // Phase-4: uncategorized keys are only allowed while the block gate is FAIL.
        const allowUncategorizedItems = !blockUncategorizedGate;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $1oY6f.initializeControls)({
            perimeter: perimeter,
            product: 'jira',
            // Storage is enabled with webStorage + indexedDB consent enforcement always on.
            webStorageEnabled: true,
            indexedDbEnabled: true,
            disableWebStorageConsentChecks: false,
            disableIndexedDbConsentChecks: false,
            allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItems,
            allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItems
        });
    }, []);
    // The case of only the fallbackConsentToken being present is handled differently on the
    // server and on the client. So in order to SSR the same way, we have handle this case
    // specially. Only fallback token being present on the client results in banner not being shown.
    // However, if we pass that cookie data into the initialPreferences on the client, there is a short
    // flicker of the consent banner. So we also have to special case this on the client.
    const onlyFallbackTokenPresent = Boolean(fallbackConsentToken && !consentToken);
    return(// Wrapper needed for stable DOM to rehydrate. Otherwise, rehydration failures may break the entire page when
    // this returns a banner in SSR and no banner/null in CSR (or the other way around).
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": 'jsm-cookie-consent-banner-wrapper'
    }, onlyFallbackTokenPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iKd9A.ConsentBanner), {
        product: "jira"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iKd9A.ConsentBanner), {
        product: "jira",
        initialPreferences: cookieData
    })));
};

});
parcelRegister("5YUMZ", function(module, exports) {
$parcel$export(module.exports, "getSSRInput", () => $7ec2fe27c07d2ccd$export$57d34b7c393d6ac0);

const $7ec2fe27c07d2ccd$export$57d34b7c393d6ac0 = ()=>{
    var error;
    return undefined;
};

});

parcelRegister("iKd9A", function(module, exports) {
$parcel$export(module.exports, "ConsentBanner", () => $0d5f5258ff3b858f$export$903b95b8397e77e9);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $bf1Bt = parcelRequire("bf1Bt");

var $gdUUy = parcelRequire("gdUUy");

var $cYNDs = parcelRequire("cYNDs");

var $jAji5 = parcelRequire("jAji5");
const $0d5f5258ff3b858f$export$903b95b8397e77e9 = (props)=>{
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $gdUUy.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $bSJIT.useEffect)(()=>{
            onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf1Bt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jAji5.ConsentBannerImpl), props)));
};

});
parcelRegister("jAji5", function(module, exports) {
$parcel$export(module.exports, "ConsentBannerImpl", () => $bc62911e9452f29f$export$24af610f9b900e82);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $bf1Bt = parcelRequire("bf1Bt");

var $VnB4y = parcelRequire("VnB4y");

var $hkLEY = parcelRequire("hkLEY");

var $lP6sB = parcelRequire("lP6sB");

var $8kqXL = parcelRequire("8kqXL");

var $ibAZU = parcelRequire("ibAZU");
var $2xHPy = parcelRequire("2xHPy");

var $6d0Zh = parcelRequire("6d0Zh");

var $cYNDs = parcelRequire("cYNDs");

var $ahXPR = parcelRequire("ahXPR");

var $3JI8T = parcelRequire("3JI8T");
var $iiTNF = parcelRequire("iiTNF");

var $2b6Yq = parcelRequire("2b6Yq");

var $4blRx = parcelRequire("4blRx");

var $fP3rX = parcelRequire("fP3rX");

var $lrTI2 = parcelRequire("lrTI2");

var $8CNIV = parcelRequire("8CNIV");

var $l0pXU = parcelRequire("l0pXU");
const $bc62911e9452f29f$var$SuccessWithIntl = (0, $fK3tS.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: "spacious"
    }));
const $bc62911e9452f29f$var$ErrorWithIntl = (0, $fK3tS.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: "spacious"
    }));
const $bc62911e9452f29f$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bc62911e9452f29f$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $bc62911e9452f29f$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bc62911e9452f29f$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $bc62911e9452f29f$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter })=>{
    const firstRender = (0, $bSJIT.useRef)(true);
    (0, $bSJIT.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $2xHPy.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $3JI8T.deleteCookie)((0, $ahXPR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        (0, $ibAZU.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $bSJIT.useState)(false);
    const intl = (0, $4vLTk.default)();
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $lrTI2.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $l0pXU.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $bSJIT.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $bSJIT.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $bSJIT.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $2xHPy.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $bSJIT.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$bc62911e9452f29f$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $4blRx.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $4blRx.i18n).successFlagTitle)
        });
        else showFlag({
            ...$bc62911e9452f29f$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $4blRx.i18n).successFlagDescription),
            title: intl.formatMessage((0, $4blRx.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $bSJIT.useCallback)(()=>{
        showFlag({
            ...$bc62911e9452f29f$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $4blRx.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $4blRx.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $bSJIT.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $2xHPy.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $2b6Yq.updatePreferences)((0, $ahXPR.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $2xHPy.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $ahXPR.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $bSJIT.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $2xHPy.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $2b6Yq.updatePreferences)((0, $ahXPR.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $2xHPy.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $ahXPR.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $bSJIT.useCallback)(()=>{
        (0, $2xHPy.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $bSJIT.useEffect)(()=>{
        if (showBanner) (0, $8kqXL.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow === null || onShow === void 0 || onShow();
        else if (!showBanner) onHide === null || onHide === void 0 || onHide();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf1Bt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6d0Zh.BSCIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8CNIV.PresentationalConsentBanner), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth,
        newMinHeight: newMinHeight
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fP3rX.PreferenceModal), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag,
        shouldAddWrappers: false
    })));
};

});
parcelRegister("8kqXL", function(module, exports) {
$parcel$export(module.exports, "addUFOCustomData", () => $5c980ac213226b3a$export$d12f56a472cdbe6c);

var $fwg5v = parcelRequire("fwg5v");

var $juFEH = parcelRequire("juFEH");
function $5c980ac213226b3a$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $fwg5v.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') (0, $juFEH.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $juFEH.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("ibAZU", function(module, exports) {
$parcel$export(module.exports, "initializeGlobalState", () => $35ea249067c0ce50$export$882c4530c58781d8);

var $7j7Eh = parcelRequire("7j7Eh");

var $gdUUy = parcelRequire("gdUUy");

var $fhC5O = parcelRequire("fhC5O");

var $ewzsy = parcelRequire("ewzsy");

var $cYNDs = parcelRequire("cYNDs");

var $lXTjH = parcelRequire("lXTjH");

var $c76Jg = parcelRequire("c76Jg");
const $35ea249067c0ce50$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, packageLogLevel: packageLogLevel, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter, analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $cYNDs.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $c76Jg.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $c76Jg.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $c76Jg.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $gdUUy.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $c76Jg.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $gdUUy.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $c76Jg.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $c76Jg.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $c76Jg.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, $c76Jg.__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $c76Jg.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $c76Jg.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    if ((0, $c76Jg.__internalGetHasInitialized)() && !overrideOnceParams) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $7j7Eh.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $ewzsy.CacheLoader)((0, $fhC5O.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $ewzsy.CacheLoader)((0, $fhC5O.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $ewzsy.CacheLoader)((0, $fhC5O.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $ewzsy.CacheLoader)((0, $fhC5O.CategoryStorageType).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $c76Jg.__internalApplyInitialState)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, $lXTjH.resetLogLevelCache)();
};

});
parcelRegister("ewzsy", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $ceb3524faed945c6$export$e479342c697b82a9);

var $2wgiL = parcelRequire("2wgiL");

var $gdUUy = parcelRequire("gdUUy");

var $1we90 = parcelRequire("1we90");

var $7r7ey = parcelRequire("7r7ey");

var $c76Jg = parcelRequire("c76Jg");

var $6sXja = parcelRequire("6sXja");

var $cYNDs = parcelRequire("cYNDs");

var $fFQ6w = parcelRequire("fFQ6w");
class $ceb3524faed945c6$export$e479342c697b82a9 {
    constructor(storageType, perimeter){
        // Asked for, not passed in: whoever constructs a loader gets the layout this process already
        // decided to fetch, so no caller can hand it a format that disagrees with everyone else's.
        this.fetchedPatternFormat = (0, $6sXja.getFetchPatternFormat)();
        // Auto-detect perimeter from the Atl-Ctx-Perimeter cookie when not explicitly provided.
        // isFedrampModerate() reads the cookie set by the platform; if absent, the perimeter is commercial.
        // Gated by platform_bsc_auto_detect_perimeter for safe rollout.
        // Wrapped in try/catch to ensure a cookie-read failure never breaks BSC initialisation.
        const detectPerimeter = ()=>{
            try {
                return (0, $2wgiL.isFedrampModerate)() ? 'fedramp-moderate' : 'commercial';
            } catch (e) {
                (0, $cYNDs.Logger).errorWithOperationalEvent({
                    action: 'detectPerimeterError',
                    message: (e === null || e === void 0 ? void 0 : e.message) || 'Failed to detect perimeter via isFedrampModerate'
                });
                return 'commercial';
            }
        };
        const resolvedPerimeter = perimeter ?? ((0, $gdUUy.fg)('platform_bsc_auto_detect_perimeter') ? detectPerimeter() : 'commercial');
        const useFlatFormat = this.fetchedPatternFormat === 'flat';
        const cacheUrlLookup = (0, $fFQ6w.getCategoryCacheUrlPerimeterLookup)(useFlatFormat)[resolvedPerimeter] || (0, $fFQ6w.getCommercialCategoryCacheUrlLookup)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    /**
   * The format of the file this loader fetches.
  	* TEMPORARY: Will be removed when the related feature flags are cleaned up (`platform_bsc_ssr_flat_pattern_file_format`,
   * `platform_bsc_flat_pattern_file_structure`)
   */ getFetchedPatternFormat() {
        return this.fetchedPatternFormat;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $1we90.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $7r7ey.ExperienceTypes).Load,
                performanceType: (0, $7r7ey.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $cYNDs.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            // Record what we actually fetched, so pattern matching never has to re-evaluate the
            // rollout gate to work out how to read it. clearStorageControlsDataCache() drops the
            // payload, so a re-fetch re-records from that loader's own format. A malformed response
            // can parse to a primitive, which cannot carry the field — those fall back to the legacy
            // trie reading, and match nothing either way.
            if (typeof this.localResponseCache === 'object' && this.localResponseCache !== null) this.localResponseCache.patternFormat = this.fetchedPatternFormat;
            (0, $c76Jg.__internalSetCacheLoadedDate)(new Date().toISOString().slice(0, 10));
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("6sXja", function(module, exports) {
$parcel$export(module.exports, "UNSAFE__setFetchPatternFormatFromResolvedFlag", () => $a04be495cde160ed$export$711aafe8a89fd09c);
$parcel$export(module.exports, "getFetchPatternFormat", () => $a04be495cde160ed$export$38a9c01091046388);

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");

var $lsoqf = parcelRequire("lsoqf");
const $a04be495cde160ed$export$43a35c1452d55dd7 = ()=>{
    if (!(0, $lsoqf.isSSR)()) return (0, $gdUUy.fg)('platform_bsc_flat_pattern_file_structure');
    return (0, $c76Jg.__internalGetResolvedFlatPatternFileFormat)() ?? (0, $gdUUy.fg)('platform_bsc_ssr_flat_pattern_file_format');
};
const $a04be495cde160ed$export$711aafe8a89fd09c = (value)=>{
    (0, $c76Jg.__internalSetResolvedFlatPatternFileFormat)(value);
};
const $a04be495cde160ed$export$38a9c01091046388 = ()=>{
    const decided = (0, $c76Jg.__internalGetPatternFormat)();
    if (decided) return decided;
    const patternFormat = $a04be495cde160ed$export$43a35c1452d55dd7() ? 'flat' : 'trie';
    (0, $c76Jg.__internalSetPatternFormat)(patternFormat);
    return patternFormat;
};

});

parcelRegister("fFQ6w", function(module, exports) {
$parcel$export(module.exports, "getCommercialCategoryCacheUrlLookup", () => $5a5bcd70b4d66be2$export$5989415260e0cf82);
$parcel$export(module.exports, "getCategoryCacheUrlPerimeterLookup", () => $5a5bcd70b4d66be2$export$9797a362f9385b1a);

var $fhC5O = parcelRequire("fhC5O");

var $6sXja = parcelRequire("6sXja");
var $5a5bcd70b4d66be2$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $5a5bcd70b4d66be2$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $5a5bcd70b4d66be2$var$baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
const $5a5bcd70b4d66be2$var$baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
const $5a5bcd70b4d66be2$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${$5a5bcd70b4d66be2$var$baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${$5a5bcd70b4d66be2$var$baseBifrostCommercialPath}${fileName}`;
        default:
            return `${$5a5bcd70b4d66be2$var$baseBifrostCommercialPath}${fileName}`;
    }
};
const $5a5bcd70b4d66be2$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $fhC5O.CategoryStorageType).Cookies]: $5a5bcd70b4d66be2$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $fhC5O.CategoryStorageType).LocalStorage]: $5a5bcd70b4d66be2$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $fhC5O.CategoryStorageType).SessionStorage]: $5a5bcd70b4d66be2$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $fhC5O.CategoryStorageType).IndexedDB]: $5a5bcd70b4d66be2$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $5a5bcd70b4d66be2$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $5a5bcd70b4d66be2$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $fhC5O.CategoryStorageType).Cookies]: $5a5bcd70b4d66be2$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $fhC5O.CategoryStorageType).LocalStorage]: $5a5bcd70b4d66be2$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $fhC5O.CategoryStorageType).SessionStorage]: $5a5bcd70b4d66be2$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $fhC5O.CategoryStorageType).IndexedDB]: $5a5bcd70b4d66be2$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $5a5bcd70b4d66be2$export$1f60178895e28eb8 = (source, perimeter, storageType, UNSAFE__resolvedFlatPatternFileFormat)=>{
    if (UNSAFE__resolvedFlatPatternFileFormat !== undefined) (0, $6sXja.UNSAFE__setFetchPatternFormatFromResolvedFlag)(UNSAFE__resolvedFlatPatternFileFormat);
    return $5a5bcd70b4d66be2$var$generateResourcePath(perimeter, storageType, (0, $6sXja.getFetchPatternFormat)() === 'flat');
};

});



parcelRegister("3JI8T", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $70fe3dd23e89e276$export$b43e45590305ffaa);

var $cG0CM = parcelRequire("cG0CM");

var $gdUUy = parcelRequire("gdUUy");

var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");
const $70fe3dd23e89e276$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, $cG0CM.default).remove(key, attributes);
    else try {
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $cG0CM.default).remove(key, attributes);
    } catch (e) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});

parcelRegister("4blRx", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $cefdf5f9aa2a10df$export$a7357cdd1f0b0168);

var $f0Pt4 = parcelRequire("f0Pt4");
const $cefdf5f9aa2a10df$export$a7357cdd1f0b0168 = (0, $f0Pt4.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("8CNIV", function(module, exports) {
$parcel$export(module.exports, "PresentationalConsentBanner", () => $9e9def6725c4c646$export$dd3e60478510f81d);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $k9Jtq = parcelRequire("k9Jtq");

var $ixPA5 = parcelRequire("ixPA5");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $4pBHw = parcelRequire("4pBHw");

var $9BVpB = parcelRequire("9BVpB");

var $lavtv = parcelRequire("lavtv");

var $ePFrB = parcelRequire("ePFrB");

var $4blRx = parcelRequire("4blRx");
const $9e9def6725c4c646$var$boxStylesPurpleWithMinHeight = (0, $9BVpB.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $9e9def6725c4c646$var$noticeContainerStyles = (0, $9BVpB.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $9e9def6725c4c646$var$inlineWrapperStylesStaticHeight = (0, $9BVpB.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $4pBHw.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $9e9def6725c4c646$var$buttonContainerStylesStaticHeight = (0, $9BVpB.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $4pBHw.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $9e9def6725c4c646$var$truncatedTextStyles = (0, $9BVpB.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $9e9def6725c4c646$var$linkNoTruncateStyles = (0, $9BVpB.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $9e9def6725c4c646$var$smallMediumScreenContainerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $4pBHw.media).above.md]: {
        display: 'none'
    }
});
const $9e9def6725c4c646$var$largeScreenContainerStyles = (0, $9BVpB.xcss)({
    display: 'none',
    [(0, $4pBHw.media).above.md]: {
        display: 'block'
    }
});
const $9e9def6725c4c646$var$noop = ()=>{};
const $9e9def6725c4c646$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $ePFrB.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $4blRx.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $4blRx.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $9e9def6725c4c646$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $4blRx.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $4blRx.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $9e9def6725c4c646$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $9e9def6725c4c646$var$noop, onClickAcceptAll: onClickAcceptAll = $9e9def6725c4c646$var$noop, onClickPreferences: onClickPreferences = $9e9def6725c4c646$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $9e9def6725c4c646$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const intl = (0, $4vLTk.default)();
    const displayedTextMap = (0, $bSJIT.useMemo)(()=>{
        return $9e9def6725c4c646$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $bSJIT.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $9e9def6725c4c646$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $bSJIT.useCallback)(()=>{
        const displayedTextAcceptAllMap = $9e9def6725c4c646$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $9e9def6725c4c646$var$boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: $9e9def6725c4c646$var$inlineWrapperStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: $9e9def6725c4c646$var$noticeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: $9e9def6725c4c646$var$smallMediumScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4blRx.i18n).useCookiesDescriptionNoLink),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        xcss: $9e9def6725c4c646$var$truncatedTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $4blRx.i18n).useCookiesDescriptionNoLink,
        tagName: "span"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ixPA5.Anchor), {
        id: "cookiesTrackingNoticeLink",
        href: "https://www.atlassian.com/legal/cookies",
        target: "_blank",
        onClick: onClickTrackingNoticeLink,
        xcss: $9e9def6725c4c646$var$linkNoTruncateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4blRx.i18n).cookiesTrackingNotice))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9e9def6725c4c646$var$largeScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...(0, $4blRx.i18n).useCookiesDescription,
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ixPA5.Anchor), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4blRx.i18n).cookiesTrackingNotice))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        space: "space.100",
        xcss: $9e9def6725c4c646$var$buttonContainerStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        testId: "preferences-button",
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4blRx.i18n).preferencesBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        testId: "only-necessary-button",
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4blRx.i18n).onlyNecessaryBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        testId: "accept-all-button",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $4blRx.i18n).acceptAllBtn)))));
};

});

parcelRegister("l0pXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $191dfb39e6524d07$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $c76Jg = parcelRequire("c76Jg");
var $2xHPy = parcelRequire("2xHPy");

var $lsoqf = parcelRequire("lsoqf");

var $ahXPR = parcelRequire("ahXPR");

var $6FJLV = parcelRequire("6FJLV");

var $acppk = parcelRequire("acppk");

var $iiTNF = parcelRequire("iiTNF");

var $fhC5O = parcelRequire("fhC5O");
const $191dfb39e6524d07$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions !== null && ssrOptions !== void 0 && ssrOptions.getCookie ? ssrOptions.getCookie((0, $ahXPR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $iiTNF.getCookie)((0, $ahXPR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if (((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $lsoqf.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $fhC5O.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $6FJLV.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $191dfb39e6524d07$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $bSJIT.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $bSJIT.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $acppk.setStrictlyNecessaryCookie)((0, $ahXPR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $bSJIT.useMemo)(()=>{
        return $191dfb39e6524d07$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $2xHPy.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $191dfb39e6524d07$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $c76Jg.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if ((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $lsoqf.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $191dfb39e6524d07$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $191dfb39e6524d07$export$2e2bcd8739ae039 = $191dfb39e6524d07$var$useBannerVisibility;

});
parcelRegister("6FJLV", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $83a36c98652ddc5a$export$6406464aa126433e);

var $gdUUy = parcelRequire("gdUUy");

var $H4xrH = parcelRequire("H4xrH");

var $cX8bE = parcelRequire("cX8bE");

var $3t6nL = parcelRequire("3t6nL");

var $5qyOC = parcelRequire("5qyOC");
const $83a36c98652ddc5a$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $3t6nL.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $5qyOC.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $cX8bE.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $H4xrH.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $5qyOC.getBannerVisibility)(consentPrefsData, ssrOptions);
};

});




parcelRegister("1oY6f", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $7a74df1fd0bf2ce3$export$919040c32a62c7db);

var $gdUUy = parcelRequire("gdUUy");

var $2xHPy = parcelRequire("2xHPy");
var $lsoqf = parcelRequire("lsoqf");
var $cYNDs = parcelRequire("cYNDs");

var $c76Jg = parcelRequire("c76Jg");
var $ibAZU = parcelRequire("ibAZU");
parcelRequire("cxi2Z");
var $1EGd8 = parcelRequire("1EGd8");

var $e6WPY = parcelRequire("e6WPY");

var $1y14P = parcelRequire("1y14P");

var $etW6A = parcelRequire("etW6A");

var $1Ntuh = parcelRequire("1Ntuh");
/**
 * Shared by both `platform_bsc_sync_initialize_controls` branches so the consent-check decision can
 * never diverge between the sync and the legacy path.
 */ const $7a74df1fd0bf2ce3$var$getIndexedDbPassthroughConfig = ()=>{
    const disableIndexedDbConsentChecks = (0, $c76Jg.getBscGlobalState)().disableIndexedDbConsentChecks ?? false;
    return {
        performConsentChecks: !disableIndexedDbConsentChecks
    };
};
const $7a74df1fd0bf2ce3$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $gdUUy.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, $cYNDs.Logger).debug('initializeControls invoked');
        (0, $ibAZU.initializeGlobalState)({
            ...args,
            overrideOnceParams: true
        });
        if ((0, $lsoqf.isSSR)()) return undefined;
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                allowUncategorizedItemsInIndexedDBOverrides: args.allowUncategorizedItemsInIndexedDBOverrides,
                perimeter: args.perimeter
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $2xHPy.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        if ((0, $gdUUy.fg)('platform_bsc_sync_initialize_controls')) {
            // Install every override on the calling tick. Because nothing below awaits, this whole
            // `async` function body runs to completion synchronously — so a product that calls
            // `initializeControls` without awaiting it still has all overrides in place the moment the
            // call returns. There is no longer a window in which `document.cookie` / `setItem` /
            // `indexedDB.open` bypass consent enforcement.
            //
            // Synchronous throws still reach the `catch` below, so the `initializeControlsError`
            // operational event and the abort-on-first-failure behaviour are unchanged. That would NOT
            // hold if we merely dropped the `await`s from the legacy `create*Passthrough` functions: a
            // sync throw inside an `async` function surfaces as a rejected promise, not a thrown error.
            (0, $1y14P.createDocumentCookiePassthroughSync)();
            if ((0, $c76Jg.getBscGlobalState)().webStorageEnabled) {
                (0, $1Ntuh.createWebStoragePassthroughSync)((0, $1EGd8.WebStorageType).LocalStorage);
                (0, $1Ntuh.createWebStoragePassthroughSync)((0, $1EGd8.WebStorageType).SessionStorage);
            }
            if ((0, $c76Jg.getBscGlobalState)().indexedDbEnabled) (0, $etW6A.createIndexedDBPassthroughSync)($7a74df1fd0bf2ce3$var$getIndexedDbPassthroughConfig());
        } else {
            await (0, $1y14P.createDocumentCookiePassthrough)();
            const isWebStorageControlsEnabled = (0, $c76Jg.getBscGlobalState)().webStorageEnabled;
            if (isWebStorageControlsEnabled) {
                // Serial, not `Promise.all`: `BSCIndexedDB.boot()` short-circuits on its promise cache for
                // concurrent callers, so parallelising would install the SessionStorage override before
                // the DB is open.
                await (0, $1Ntuh.createWebStoragePassthrough)((0, $1EGd8.WebStorageType).LocalStorage);
                await (0, $1Ntuh.createWebStoragePassthrough)((0, $1EGd8.WebStorageType).SessionStorage);
            }
            const isIndexedDbEnabled = (0, $c76Jg.getBscGlobalState)().indexedDbEnabled;
            if (isIndexedDbEnabled) await (0, $etW6A.createIndexedDBPassthrough)($7a74df1fd0bf2ce3$var$getIndexedDbPassthroughConfig());
        }
        (0, $cYNDs.Logger).debug('initializeControls finished');
        const storageCleanupPromise = (0, $e6WPY.cleanupStorage)();
        initResult = Object.assign(initResult ?? {}, {
            storageCleanupPromise: storageCleanupPromise
        });
    } catch (e) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};

});
parcelRegister("e6WPY", function(module, exports) {
$parcel$export(module.exports, "cleanupStorage", () => $985c5bf9d1d1db9c$export$e6332b39565fb2b3);

var $cG0CM = parcelRequire("cG0CM");

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");
var $cYNDs = parcelRequire("cYNDs");
var $2xHPy = parcelRequire("2xHPy");

var $1OAF2 = parcelRequire("1OAF2");

var $cxi2Z = parcelRequire("cxi2Z");
var $1EGd8 = parcelRequire("1EGd8");

var $fhC5O = parcelRequire("fhC5O");

var $fvY9l = parcelRequire("fvY9l");
function $985c5bf9d1d1db9c$var$isCategoryRevoked({ category: category, preferences: preferences }) {
    if (category === (0, $fhC5O.PreferenceCategory).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function $985c5bf9d1d1db9c$var$yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const $985c5bf9d1d1db9c$var$ITEMS_PER_YIELD = 50;
// Per-run enumeration cap. Yielding to the main thread every ITEMS_PER_YIELD items is independent
// of the limit, so the loop stays cooperative however high this is set.
const $985c5bf9d1d1db9c$var$ENUMERATION_LIMIT = 10000;
const $985c5bf9d1d1db9c$export$54394d3cfbbf53d0 = 1000;
// `deleteDatabase` completes only once every other connection to that database closes, which the
// browser asks for by firing `versionchange` on each of them. Nothing obliges a holder to listen, so
// the wait needs a bound. Confirmations run concurrently, making this the cost to a run rather than
// the cost per database.
const $985c5bf9d1d1db9c$var$IDB_DELETE_CONFIRM_TIMEOUT_MS = 500;
function $985c5bf9d1d1db9c$var$isRunningInFrame() {
    try {
        return window.top !== window.self;
    } catch  {
        // A cross-origin read of `window.top` throws, which itself proves we are framed.
        return true;
    }
}
/**
 * Resolves for every outcome rather than rejecting, so one database cannot fail a whole run.
 *
 * `blocked` is deliberately not handled: it is not an outcome. Another open connection leaves the
 * request pending, and `success` still arrives if those connections close, so treating `blocked` as
 * a failure would report a delete that then went through as undeleted. The deadline decides instead
 * — unblocked in time counts as deleted, still blocked when it expires does not.
 */ function $985c5bf9d1d1db9c$var$deleteDatabaseAndConfirm(idb, name) {
    return new Promise((resolve)=>{
        let settled = false;
        let timeoutId;
        const settle = (deleted)=>{
            if (settled) return;
            settled = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            resolve(deleted);
        };
        const request = idb.deleteDatabase(name);
        request.onsuccess = ()=>settle(true);
        request.onerror = ()=>{
            var _request$error;
            (0, $cYNDs.Logger).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${((_request$error = request.error) === null || _request$error === void 0 ? void 0 : _request$error.message) ?? ''}`);
            settle(false);
        };
        timeoutId = setTimeout(()=>settle(false), $985c5bf9d1d1db9c$var$IDB_DELETE_CONFIRM_TIMEOUT_MS);
    });
}
/**
 * A cookie is identified by name + domain + path, and `document.cookie` exposes only the name. An
 * expiry therefore has to guess the other two, and a guess that misses is silently accepted by the
 * browser, so reading the cookie back is the only way to know it went away.
 *
 * Two scopes are tried: host-only, then the served host as an explicit `domain`, because scoping to
 * `Domain=<current host>` is a common library default that a host-only expiry cannot match.
 *
 * Known limitations, all reported as `false` rather than papered over:
 *
 * - **No domain above the served host is tried.** A cookie on a parent or registrable domain — where
 *   the vendor tags we embed (`_ga`, `_fbp`, `_gcl_au`) and our own cross-property cookies live — is
 *   out of reach.
 * - **Non-root paths are never tried.** js-cookie defaults to `path=/`.
 * - **`HttpOnly` cookies are invisible here**, so they are never even enumerated.
 */ function $985c5bf9d1d1db9c$var$deleteCookieAndConfirm(key) {
    // `__Secure-`/`__Host-` names are rejected unless the expiring `Set-Cookie` also carries
    // `Secure`. It is not part of a cookie's identity so it is harmless on ordinary cookies, but a
    // non-secure origin ignores the whole header, so only send it where it can take effect.
    const secure = window.location.protocol === 'https:' ? {
        secure: true
    } : {};
    // `atl-set-cookie` marks both expiries below as the package's own writes, which is what the
    // `document.cookie` setter override checks before passing one through. Without it the override
    // consent-checks the expiry against the very category the cookie is being deleted for, takes its
    // blocked branch, and never calls the original setter.
    (0, $cG0CM.default).remove(key, {
        ...secure,
        'atl-set-cookie': true
    });
    if ((0, $cG0CM.default).get(key) === undefined) return true;
    // Still there, so the cookie carries an explicit `Domain`. Two names make even the served-host
    // attempt pointless: a `__Host-` cookie must be host-only, and on a single-label host
    // (`localhost`, an intranet name) `.localhost` matches nothing.
    const { hostname: hostname } = window.location;
    if (key.startsWith('__Host-') || hostname.split('.').length < 2) return false;
    (0, $cG0CM.default).remove(key, {
        ...secure,
        domain: `.${hostname}`,
        'atl-set-cookie': true
    });
    return (0, $cG0CM.default).get(key) === undefined;
}
async function $985c5bf9d1d1db9c$export$e6332b39565fb2b3() {
    // One read per run, outside the try so the catch path agrees. `fg()` reads gate config that can
    // change mid-run and this function's p99 is seconds, so re-reading risks a run that deletes
    // while reporting `dry-run`.
    const deletionMode = (0, $gdUUy.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run';
    const isLiveDelete = deletionMode === 'live';
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, $c76Jg.getBscGlobalState)();
        const preferences = await (0, $fvY9l.getPreferences)();
        const localStorage = (0, $cxi2Z.findStorageTarget)((0, $1EGd8.WebStorageType).LocalStorage);
        const sessionStorage = (0, $cxi2Z.findStorageTarget)((0, $1EGd8.WebStorageType).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, $fhC5O.CategoryStorageType).LocalStorage),
            globalState.loadCache((0, $fhC5O.CategoryStorageType).SessionStorage),
            globalState.loadCache((0, $fhC5O.CategoryStorageType).Cookies),
            globalState.loadCache((0, $fhC5O.CategoryStorageType).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        const reportCoverage = (0, $gdUUy.fg)('platform_bsc_cleanup_coverage_telemetry');
        const skippedTypes = [];
        const undeletedItems = [];
        const inFrame = reportCoverage ? $985c5bf9d1d1db9c$var$isRunningInFrame() : undefined;
        const pendingIdbConfirmations = [];
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (!localStorageCache) skippedTypes.push({
            storageType: 'localStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // Cleanup is an internal operation, so it works on the store the wrapper wraps rather than
            // through the wrapper: the read-back below is untrapped, where the wrapper's `getItem`
            // emits `usedAtlBrowserStorageGetItem` on every call. Keys are taken up front so a removal
            // cannot shift the items still to be visited. `Object.keys` would be shorter but omits any
            // item whose name collides with a `Storage` own property — WebKit hides a stored `length`
            // from it, where `key(i)` still reports it.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const localStore = localStorage.storage;
            const localKeys = Array.from({
                length: localStore.length
            }, (_, i)=>localStore.key(i)).filter((key)=>key !== null);
            for (const key of localKeys){
                if (itemsProcessed >= $985c5bf9d1d1db9c$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $985c5bf9d1d1db9c$var$ITEMS_PER_YIELD === 0) await $985c5bf9d1d1db9c$var$yieldToMain();
                const category = (0, $1OAF2.getItemCategoryFromPassedCache)(key, localStorageCache, productName);
                if (category === null || category === (0, $fhC5O.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'localStorage'
                });
                else if ($985c5bf9d1d1db9c$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'localStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        localStore.removeItem(key);
                        const removed = localStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // sessionStorage
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'enumerationLimit'
        });
        else if (!sessionStorageCache) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const sessionStore = sessionStorage.storage;
            const sessionKeys = Array.from({
                length: sessionStore.length
            }, (_, i)=>sessionStore.key(i)).filter((key)=>key !== null);
            for (const key of sessionKeys){
                if (itemsProcessed >= $985c5bf9d1d1db9c$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $985c5bf9d1d1db9c$var$ITEMS_PER_YIELD === 0) await $985c5bf9d1d1db9c$var$yieldToMain();
                const category = (0, $1OAF2.getItemCategoryFromPassedCache)(key, sessionStorageCache, productName);
                if (category === null || category === (0, $fhC5O.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'sessionStorage'
                });
                else if ($985c5bf9d1d1db9c$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'sessionStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        sessionStore.removeItem(key);
                        const removed = sessionStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // cookies
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'cookie',
            reason: 'enumerationLimit'
        });
        else if (!cookieCache) skippedTypes.push({
            storageType: 'cookie',
            reason: 'cacheUnavailable'
        });
        else for (const key of Object.keys((0, $cG0CM.default).get())){
            if (itemsProcessed >= $985c5bf9d1d1db9c$var$ENUMERATION_LIMIT) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $985c5bf9d1d1db9c$var$ITEMS_PER_YIELD === 0) await $985c5bf9d1d1db9c$var$yieldToMain();
            const category = (0, $1OAF2.getItemCategoryFromPassedCache)(key, cookieCache, productName);
            if (category === null || category === (0, $fhC5O.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'cookie'
            });
            else if ($985c5bf9d1d1db9c$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                const item = {
                    key: key,
                    storageType: 'cookie',
                    category: category
                };
                revokedItems.push(item);
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if (isLiveDelete) {
                    item.deleted = $985c5bf9d1d1db9c$var$deleteCookieAndConfirm(key);
                    if (!item.deleted) undeletedItems.push(item);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'enumerationLimit'
        });
        else if (!indexedDBCache) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'cacheUnavailable'
        });
        else if (typeof (idb === null || idb === void 0 ? void 0 : idb.databases) !== 'function') // Safari and Firefox do not implement `indexedDB.databases()`.
        skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'unsupported'
        });
        else try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= $985c5bf9d1d1db9c$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $985c5bf9d1d1db9c$var$ITEMS_PER_YIELD === 0) await $985c5bf9d1d1db9c$var$yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, $1OAF2.getItemCategoryFromPassedCache)(name, indexedDBCache, productName);
                if (category === null || category === (0, $fhC5O.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if ($985c5bf9d1d1db9c$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: name,
                        storageType: 'indexedDB',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteIdb && isLiveDelete) {
                        // Collected, not awaited inline: serial waits would make the worst case the sum of
                        // the per-database timeouts instead of the longest one.
                        pendingIdbConfirmations.push($985c5bf9d1d1db9c$var$deleteDatabaseAndConfirm(idb, name).then((deleted)=>{
                            item.deleted = deleted;
                            if (!deleted) undeletedItems.push(item);
                        }));
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch  {
            // idb.databases() unavailable or threw — skip IDB entirely
            skippedTypes.push({
                storageType: 'indexedDB',
                reason: 'error'
            });
        }
        if (pendingIdbConfirmations.length > 0) await Promise.all(pendingIdbConfirmations);
        if (deletionCount > 0) (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount - undeletedItems.length,
                undeletedCount: undeletedItems.length
            }
        });
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: deletionMode,
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType: storageType, key: key, category: category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`),
                hitEnumerationLimit: hitEnumerationLimit,
                hitRevokedCountCeiling: revokedItems.length > $985c5bf9d1d1db9c$export$54394d3cfbbf53d0,
                ...isLiveDelete ? {
                    undeletedCount: undeletedItems.length,
                    undeletedItems: undeletedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`)
                } : {},
                ...reportCoverage ? {
                    // Empty rather than omitted, so an absent attribute means "gate off" and not
                    // "full coverage".
                    skippedTypes: skippedTypes.map(({ storageType: storageType, reason: reason })=>`${storageType}:${reason}`).join(','),
                    inFrame: inFrame
                } : {}
            }
        });
        return {
            deletionMode: deletionMode,
            revokedItems: revokedItems,
            uncategorizedItems: uncategorizedItems,
            hitEnumerationLimit: hitEnumerationLimit,
            ...reportCoverage ? {
                skippedTypes: skippedTypes,
                inFrame: inFrame
            } : {}
        };
    } catch (error) {
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${(error === null || error === void 0 ? void 0 : error.message) ?? 'no message'}`
        });
        return {
            deletionMode: deletionMode,
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}

});

parcelRegister("1y14P", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthroughSync", () => $66a30e0ed9ade3f9$export$50a17589ab8bbee4);
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $66a30e0ed9ade3f9$export$45a5573b04db016c);

var $cYNDs = parcelRequire("cYNDs");

var $2gwoY = parcelRequire("2gwoY");
const $66a30e0ed9ade3f9$export$50a17589ab8bbee4 = ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
    const originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
    if (!originalSetter || !originalGetter) {
        (0, $cYNDs.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $2gwoY.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};
const $66a30e0ed9ade3f9$export$45a5573b04db016c = async ()=>$66a30e0ed9ade3f9$export$50a17589ab8bbee4();

});
parcelRegister("2gwoY", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $43a2edf5127988be$export$b7364c41ddbfdb0a);

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");
var $2xHPy = parcelRequire("2xHPy");

var $2xHPy = parcelRequire("2xHPy");

var $jY7dm = parcelRequire("jY7dm");

var $1OAF2 = parcelRequire("1OAF2");

var $cYNDs = parcelRequire("cYNDs");

var $KETjl = parcelRequire("KETjl");

var $fhC5O = parcelRequire("fhC5O");
const $43a2edf5127988be$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        const extensionSignals = (0, $gdUUy.fg)('platform_bsc_browser_extension_detection') ? (0, $jY7dm.captureCallerSignals)() : undefined;
        // Set cookie function reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setCookieFailure;
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $2xHPy.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $c76Jg.getBscGlobalState)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                // Attempt to set a known cookie that was set from outside the package
                const processingCheck = (0, $1OAF2.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        if (!itemHasCategory && (0, $KETjl.shouldReportUncategorizedItemSet)((0, $fhC5O.CategoryStorageType).Cookies, sanitizedCookieKey)) (0, $2xHPy.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $fhC5O.CategoryStorageType).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null,
                                cacheLoadedDate: (0, $c76Jg.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $KETjl.uncategorizedItemSetOnSent)((0, $fhC5O.CategoryStorageType).Cookies, sanitizedCookieKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $c76Jg.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $cYNDs.Logger).warn(`document.cookie setter for '${sanitizedCookieKey}' was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${sanitizedCookieKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: (0, $fhC5O.CategoryStorageType).Cookies,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $1OAF2.isPromise)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $cYNDs.Logger).errorWithOperationalEvent({
                        action: 'usedDocumentCookieError',
                        message: `Failed to set cookie. ${(e === null || e === void 0 ? void 0 : e.message) || ''}`,
                        attributes: {
                            cookieKey: sanitizedCookieKey
                        }
                    });
                });
            } catch (e) {
                (0, $cYNDs.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
                setCookieFailure = e;
            }
        } catch (e) {
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
        if (setCookieFailure) throw setCookieFailure;
    };

});
parcelRegister("KETjl", function(module, exports) {
$parcel$export(module.exports, "shouldReportUncategorizedItemSet", () => $5cab5e293b07de2d$export$eda682c722f364aa);
$parcel$export(module.exports, "uncategorizedItemSetOnSent", () => $5cab5e293b07de2d$export$c81f34d18a3c37c3);
/**
 * Tracks which uncategorized storage-item keys have already emitted an
 * `uncategorizedWebStorageItemSet` track event this session, so repeated writes
 * of the same unknown key don't emit duplicate events.
 *
 * State is module-level (per page load), which gives us the "per session"
 * semantic for free — it resets naturally on reload. Same pattern as
 * `ItemKeyCache` (item-key-cache-service) and the logger error-event throttle.
 *
 * Keys are scoped by storage type so the same key name in different storage
 * types (e.g. a cookie and a localStorage item both named `foo`) remain
 * distinct reportable signals.
 */ class $5cab5e293b07de2d$var$UncategorizedItemReportCacheService {
    compositeKey(storageType, itemKey) {
        return `${storageType}::${itemKey}`;
    }
    markReported(storageType, itemKey) {
        this.reportedKeys.add(this.compositeKey(storageType, itemKey));
    }
    wasReported(storageType, itemKey) {
        return this.reportedKeys.has(this.compositeKey(storageType, itemKey));
    }
    // Test-only helper to reset the per-process cache between tests.
    __reset() {
        this.reportedKeys.clear();
    }
    constructor(){
        this.reportedKeys = new Set();
    }
}
let $5cab5e293b07de2d$var$cacheInstance;
/**
 * Lazily creates the cache on first use.
 */ function $5cab5e293b07de2d$var$getCache() {
    if (!$5cab5e293b07de2d$var$cacheInstance) $5cab5e293b07de2d$var$cacheInstance = new $5cab5e293b07de2d$var$UncategorizedItemReportCacheService();
    return $5cab5e293b07de2d$var$cacheInstance;
}
function $5cab5e293b07de2d$export$270367a42ceba9fe() {
    $5cab5e293b07de2d$var$cacheInstance = undefined;
}
function $5cab5e293b07de2d$export$eda682c722f364aa(storageType, itemKey) {
    return !$5cab5e293b07de2d$var$getCache().wasReported(storageType, itemKey);
}
function $5cab5e293b07de2d$export$c81f34d18a3c37c3(storageType, itemKey) {
    return ()=>$5cab5e293b07de2d$var$getCache().markReported(storageType, itemKey);
}

});



parcelRegister("etW6A", function(module, exports) {
$parcel$export(module.exports, "createIndexedDBPassthroughSync", () => $db8bba9d295e181c$export$bbe9492afe46739);
$parcel$export(module.exports, "createIndexedDBPassthrough", () => $db8bba9d295e181c$export$a03098708eb0de1);

var $cYNDs = parcelRequire("cYNDs");

var $J7Frs = parcelRequire("J7Frs");
const $db8bba9d295e181c$export$bbe9492afe46739 = (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $cYNDs.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $cYNDs.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $cYNDs.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $J7Frs.getIndexedDBOpenOverride)(originalOpen) : (0, $J7Frs.getIndexedDBOpenOverrideEventOnly)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $cYNDs.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $cYNDs.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};
const $db8bba9d295e181c$export$a03098708eb0de1 = async (config)=>$db8bba9d295e181c$export$bbe9492afe46739(config);

});
parcelRegister("J7Frs", function(module, exports) {
$parcel$export(module.exports, "getIndexedDBOpenOverrideEventOnly", () => $fe3a18380d49b6b0$export$5a412306febb78c);
$parcel$export(module.exports, "getIndexedDBOpenOverride", () => $fe3a18380d49b6b0$export$5721aa15a04b1881);

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");
var $2xHPy = parcelRequire("2xHPy");

var $jY7dm = parcelRequire("jY7dm");

var $1OAF2 = parcelRequire("1OAF2");

var $cYNDs = parcelRequire("cYNDs");

var $2IQ7U = parcelRequire("2IQ7U");

var $gaE5e = parcelRequire("gaE5e");

var $8KLlH = parcelRequire("8KLlH");

var $fhC5O = parcelRequire("fhC5O");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $fe3a18380d49b6b0$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $fe3a18380d49b6b0$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $fe3a18380d49b6b0$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $fe3a18380d49b6b0$var$checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, $8KLlH.ItemKeyCache).wasSetByPackage((0, $fhC5O.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, $c76Jg.getBscGlobalState)().product;
    const itemCategory = await (0, $1OAF2.getItemCategory)(eventDetails.databaseName, (0, $fhC5O.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $fhC5O.PreferenceCategory).StrictlyNecessary;
    // Strictly-necessary and package-set databases never block, so omit their telemetry.
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true,
            itemCategory: itemCategory ?? (0, $fhC5O.PreferenceCategory).Unknown
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $2xHPy.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
// Keep forwarding `extensionSignals` to `isProcessingAllowedByPreferencesWithCategory` — extension
// writes rely on it to bypass the consent check.
const $fe3a18380d49b6b0$var$checkIfAllowedWithCategory = async (dbName, extensionSignals)=>{
    if (!(0, $gaE5e.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $cYNDs.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $c76Jg.getBscGlobalState)().product;
    const { isAllowed: isAllowed, itemCategory: itemCategory } = await (0, $1OAF2.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $fhC5O.CategoryStorageType).IndexedDB,
        productName: productName,
        extensionSignals: extensionSignals
    });
    return {
        isAllowed: isAllowed,
        itemCategory: itemCategory
    };
};
const $fe3a18380d49b6b0$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $fe3a18380d49b6b0$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $cYNDs.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $fe3a18380d49b6b0$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $8KLlH.ItemKeyCache).wasSetByPackage((0, $fhC5O.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        const extensionSignals = (0, $gdUUy.fg)('platform_bsc_browser_extension_detection') ? (0, $jY7dm.captureCallerSignals)() : undefined;
        (0, $cYNDs.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $2IQ7U.createIDBOpenDBRequestWrapper)();
        // Always resolve category information for telemetry and so the uncategorized passthrough
        // can distinguish an unknown database from one the user denied.
        const allowUncategorizedOverride = !!(0, $c76Jg.getBscGlobalState)().allowUncategorizedItemsInIndexedDBOverrides;
        const allowedPromise = $fe3a18380d49b6b0$var$checkIfAllowedWithCategory(databaseName, extensionSignals).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>({
                isAllowed: isAllowed,
                itemCategory: itemCategory ?? (0, $fhC5O.PreferenceCategory).Unknown,
                categoryAttribute: {
                    itemCategory: itemCategory ?? (0, $fhC5O.PreferenceCategory).Unknown
                }
            }));
        allowedPromise.then(({ isAllowed: isAllowed, itemCategory: itemCategory, categoryAttribute: categoryAttribute })=>{
            // When `allowUncategorizedItemsInIndexedDBOverrides` is enabled, databases that have
            // no known category (null/Unknown) are allowed through instead of being blocked. This
            // is a rollout-safety valve — only uncategorized DBs are affected; DBs that are
            // categorized but user-denied are still blocked regardless of this flag.
            const isUncategorized = itemCategory == null || itemCategory === (0, $fhC5O.PreferenceCategory).Unknown;
            const resolvedIsAllowed = isAllowed || allowUncategorizedOverride && isUncategorized;
            (0, $2xHPy.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !resolvedIsAllowed,
                    outsidePackage: true,
                    ...categoryAttribute
                }
            });
            if (resolvedIsAllowed) {
                (0, $cYNDs.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $cYNDs.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $fe3a18380d49b6b0$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $cYNDs.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $cYNDs.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };

});
parcelRegister("2IQ7U", function(module, exports) {
$parcel$export(module.exports, "createIDBOpenDBRequestWrapper", () => $eced6111e54b05bb$export$4037ef1f5b40c4b6);

var $bAB3U = parcelRequire("bAB3U");

var $lsoqf = parcelRequire("lsoqf");

var $kVQqq = parcelRequire("kVQqq");
// Store the browser implementation class here - defined conditionally below
let $eced6111e54b05bb$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$eced6111e54b05bb$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        var _this$_wrappedRequest;
        return ((_this$_wrappedRequest = this._wrappedRequest) === null || _this$_wrappedRequest === void 0 ? void 0 : _this$_wrappedRequest.error) ?? this._error;
    }
    get result() {
        var _this$_wrappedRequest2;
        return ((_this$_wrappedRequest2 = this._wrappedRequest) === null || _this$_wrappedRequest2 === void 0 ? void 0 : _this$_wrappedRequest2.result) ?? this._result;
    }
    get readyState() {
        var _this$_wrappedRequest3;
        return ((_this$_wrappedRequest3 = this._wrappedRequest) === null || _this$_wrappedRequest3 === void 0 ? void 0 : _this$_wrappedRequest3.readyState) ?? this._readyState;
    }
    get source() {
        var _this$_wrappedRequest4;
        return ((_this$_wrappedRequest4 = this._wrappedRequest) === null || _this$_wrappedRequest4 === void 0 ? void 0 : _this$_wrappedRequest4.source) ?? this._source;
    }
    get transaction() {
        var _this$_wrappedRequest5;
        return ((_this$_wrappedRequest5 = this._wrappedRequest) === null || _this$_wrappedRequest5 === void 0 ? void 0 : _this$_wrappedRequest5.transaction) ?? this._transaction;
    }
    /**
     * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
     * Once wrapped, all property getters will delegate to the wrapped request,
     * and all events from the wrapped request will be re-dispatched on this wrapper.
     *
     * @param request - The real IDBOpenDBRequest to wrap
     */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $bAB3U.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
     * Check if this mock is wrapping a real request
     */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
     * Get the wrapped request (if any)
     */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
     * Unbind all event listeners attached to the wrapped request.
     * Should be called when the wrapper is no longer needed.
     */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
     * Set the error property (normally readonly)
     * Only works when not wrapping another request
     */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
     * Set the result property (normally readonly)
     * Only works when not wrapping another request
     */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
     * Set the readyState property (normally readonly)
     * Only works when not wrapping another request
     */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
     * Set the source property (normally readonly)
     * Only works when not wrapping another request
     */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
     * Set the transaction property (normally readonly)
     * Only works when not wrapping another request
     */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
     * Override dispatchEvent to also call the corresponding event handler if set
     */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function $eced6111e54b05bb$export$4037ef1f5b40c4b6() {
    if ((0, $lsoqf.isSSR)() || typeof EventTarget === 'undefined' || !$eced6111e54b05bb$var$BrowserImpl) return new (0, $kVQqq.IDBOpenDBRequestNoOp)();
    return new $eced6111e54b05bb$var$BrowserImpl();
}
const $eced6111e54b05bb$export$c69b1cb39abae960 = $eced6111e54b05bb$var$BrowserImpl;

});
parcelRegister("kVQqq", function(module, exports) {
$parcel$export(module.exports, "IDBOpenDBRequestNoOp", () => $f89f1e9aea963531$export$55ffeaf417e03b66);
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $f89f1e9aea963531$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

});


parcelRegister("gaE5e", function(module, exports) {
$parcel$export(module.exports, "isValidDBName", () => $0438c3dbc6859c43$export$a5be9a74f3347ccf);

var $c76Jg = parcelRequire("c76Jg");
var $lsoqf = parcelRequire("lsoqf");
function $0438c3dbc6859c43$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $lsoqf.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $c76Jg.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $0438c3dbc6859c43$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $0438c3dbc6859c43$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

});



parcelRegister("1Ntuh", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthroughSync", () => $91eb0cd65b850d22$export$68ddaf53a4783803);
$parcel$export(module.exports, "createWebStoragePassthrough", () => $91eb0cd65b850d22$export$619fe705922e5d61);

var $cYNDs = parcelRequire("cYNDs");

var $8nF1h = parcelRequire("8nF1h");

var $cxi2Z = parcelRequire("cxi2Z");
var $1EGd8 = parcelRequire("1EGd8");

var $bjenE = parcelRequire("bjenE");
// Members the Proxy replaces rather than forwarding.
const $91eb0cd65b850d22$var$INTERCEPTED_MEMBERS = [
    'setItem',
    'getItem',
    'removeItem',
    'clear',
    'key',
    'length'
];
/**
 * Marks a storage object as already overridden by this package. Duplicate copies of the package in
 * one page (chunk skew) each capture `globalThis.localStorage` at module evaluation, so without this
 * the second copy would proxy the first copy's Proxy and run the consent pipeline — and its
 * analytics — twice per write.
 */ const $91eb0cd65b850d22$var$BSC_STORAGE_OVERRIDE_INSTALLED = Symbol.for('atlassian.bsc.webStorageOverrideInstalled');
const $91eb0cd65b850d22$var$isAlreadyOverridden = (value)=>value !== null && typeof value === 'object' && value[$91eb0cd65b850d22$var$BSC_STORAGE_OVERRIDE_INSTALLED] === true;
/**
 * A Proxy may not report a different value for a property the target exposes as a non-writable,
 * non-configurable own data property — the runtime throws `TypeError` on every such access. A real
 * `Storage` keeps its members on `Storage.prototype` and its items as writable, configurable own
 * properties, so this only happens when something has already replaced `window.localStorage` with a
 * locked-down stand-in (some third-party storage shims and test doubles do exactly that). Detect it
 * up front and keep the legacy override for those environments instead of installing a Proxy that
 * throws on ordinary reads.
 */ const $91eb0cd65b850d22$var$canInterceptWithProxy = (storage)=>$91eb0cd65b850d22$var$INTERCEPTED_MEMBERS.every((member)=>{
        const descriptor = Object.getOwnPropertyDescriptor(storage, member);
        return !descriptor || descriptor.configurable === true || descriptor.writable === true;
    });
const $91eb0cd65b850d22$var$isLockedDownOnTarget = (target, property)=>{
    const descriptor = Reflect.getOwnPropertyDescriptor(target, property);
    return descriptor !== undefined && !descriptor.configurable && descriptor.writable === false;
};
/**
 * Wraps the real `Storage` object so consent checks still apply to writes while the rest of the
 * `Storage` interface keeps working.
 *
 * The legacy override (below) replaces `window.localStorage` with a plain object carrying the six
 * `Storage` operations. That silently drops every other guarantee of the interface: `length` becomes
 * a function instead of a number, stored keys stop being enumerable own properties, and
 * property-style access no longer reaches the store. Consumers that measure or enumerate storage —
 * `localStorage.length`, `Object.keys(localStorage)` — then see an empty or nonsensical view, which
 * disabled the age-based storage cleanups our products depend on and let storage fill to the browser
 * quota (COOK-628).
 *
 * Keeping the native `Storage` as the Proxy target inherits reads, removals, enumeration and brand
 * checks for free. Only writes are intercepted, and they are intercepted without relying on the
 * host's named-property-setter semantics: browsers ignore or shadow a write to `length` or to a
 * `Storage` method, whereas jsdom persists it as an item. Deciding those cases here rather than
 * forwarding them keeps behaviour identical across hosts and guarantees nothing reaches storage
 * without passing through the consent check.
 */ const $91eb0cd65b850d22$var$createProxiedStorage = (bscStorage, storageType)=>{
    const nativeStorage = bscStorage.storage;
    const storagePrototype = Object.getPrototypeOf(nativeStorage);
    const interceptedSetItem = (0, $bjenE.setItemOverride)(bscStorage, nativeStorage.setItem, storageType);
    // The `Storage` operations keep pointing at `AtlBrowserStorage` so their existing availability
    // guards and analytics are unaffected by this Proxy. `length` is handled in the `get` trap
    // because it is an accessor on `Storage` but a method on `AtlBrowserStorage`.
    const operations = new Map([
        [
            'setItem',
            interceptedSetItem
        ],
        [
            'getItem',
            bscStorage.getItem.bind(bscStorage)
        ],
        [
            'removeItem',
            bscStorage.removeItem.bind(bscStorage)
        ],
        [
            'clear',
            bscStorage.clear.bind(bscStorage)
        ],
        [
            'key',
            bscStorage.key.bind(bscStorage)
        ]
    ]);
    // Properties assigned to the storage object that are NOT storage items — symbol keys, and the
    // interface's own member names. Browsers keep these as ordinary own properties on the object and
    // never write them to the store, so we hold them here instead of touching storage. Enumeration
    // deliberately does not report them: `Object.keys(localStorage)` stays exactly the stored keys.
    // They also take precedence over `operations` on read, because products legitimately wrap the
    // storage methods (Confluence's `patchLocalStorage` replaces `setItem` and delegates to whatever
    // it captured) and that has always worked against the legacy override.
    const shadowedProperties = new Map();
    // A property names a storage item unless it resolves on the prototype chain (`length`, the
    // `Storage` methods, `Object.prototype` members) or is a symbol. Used by every trap that can
    // reach the store: `set`, `defineProperty` and `deleteProperty`.
    const isStorageItemKey = (property)=>typeof property === 'string' && !(property in storagePrototype);
    // The consent pipeline emits analytics, and anything on that path that persists a value with
    // property syntax would re-enter this trap and recurse forever. Bound to one level instead.
    let isHandlingStorageWrite = false;
    const gateStorageWrite = (property, value)=>{
        if (isHandlingStorageWrite) {
            (0, $cYNDs.Logger).warn(`Dropped re-entrant ${storageType} write for '${property}' triggered from inside the consent path`);
            return;
        }
        isHandlingStorageWrite = true;
        try {
            interceptedSetItem(property, String(value));
        } finally{
            isHandlingStorageWrite = false;
        }
    };
    // eslint-disable-next-line prefer-const -- assigned immediately below; the traps need the identity
    let proxiedStorage;
    proxiedStorage = new Proxy(nativeStorage, {
        get: (target, property)=>{
            if (property === $91eb0cd65b850d22$var$BSC_STORAGE_OVERRIDE_INSTALLED) return true;
            if (property === 'length') return bscStorage.length();
            if (shadowedProperties.has(property)) return shadowedProperties.get(property);
            if (operations.has(property)) return operations.get(property);
            // Deliberately NOT bound to the target: binding would hand out the raw `Storage` through
            // `localStorage.valueOf()`, which is an unchecked write path. Everything that needs a real
            // `Storage` receiver is routed above, and the remainder (`Object.prototype` members, named
            // keys, `Symbol.toStringTag`) works with the Proxy as the receiver. Returning the prototype's
            // own function object also keeps `localStorage.toString === localStorage.toString`.
            return Reflect.get(target, property, target);
        },
        // `localStorage.foo = 'bar'`, `Object.assign(localStorage, …)` and `Reflect.set` all reach the
        // store natively, so they are consent-checked exactly like `setItem`.
        set: (target, property, value, receiver)=>{
            // A receiver that is neither this Proxy nor the storage itself means the assignment targets
            // something further down a prototype chain (`Object.create(localStorage).foo = 'x'`), which
            // the browser also refuses to route into the store.
            if (receiver !== proxiedStorage && receiver !== target) return Reflect.set(target, property, value, receiver);
            if (property === 'length') // Read-only accessor: browsers ignore the write in sloppy mode. Reporting success keeps
            // strict-mode assignment from throwing where the legacy override did not.
            return true;
            // Reporting success for a locked-down own property on the target violates a Proxy
            // invariant. Fail the assignment exactly as the target itself would.
            if ($91eb0cd65b850d22$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, value);
                return true;
            }
            gateStorageWrite(property, value);
            // Report success even when consent blocked the write, so assignment does not throw in
            // strict mode. This matches how the `setItem` override treats a blocked write.
            return true;
        },
        defineProperty: (target, property, descriptor)=>{
            // Accessor descriptors on a storage key are rejected by the browser itself — forward and let
            // it throw rather than inventing a behaviour.
            if (!('value' in descriptor) || property === 'length') return Reflect.defineProperty(target, property, descriptor);
            // A non-configurable property must actually exist on the target for a `true` result to be
            // legal, and consent may block the write, so refuse instead of risking a `TypeError`.
            if (descriptor.configurable === false || $91eb0cd65b850d22$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, descriptor.value);
                return true;
            }
            gateStorageWrite(property, descriptor.value);
            return true;
        },
        // `delete localStorage.foo` removes the item natively, so it has to reach the store — but it goes
        // through `AtlBrowserStorage.removeItem` rather than the target directly, so removals behave
        // identically however they are spelled. Removals are not consent-checked, matching `removeItem`.
        deleteProperty: (target, property)=>{
            if (shadowedProperties.has(property)) {
                shadowedProperties.delete(property);
                return true;
            }
            if (isStorageItemKey(property)) {
                bscStorage.removeItem(property);
                return true;
            }
            return Reflect.deleteProperty(target, property);
        }
    });
    return proxiedStorage;
};
const $91eb0cd65b850d22$var$applyWebStorageOverride = (bscStorage, storageType)=>{
    const caseSensitiveStorageType = storageType === (0, $1EGd8.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    if ($91eb0cd65b850d22$var$isAlreadyOverridden(window[caseSensitiveStorageType]) || $91eb0cd65b850d22$var$isAlreadyOverridden(bscStorage.storage)) {
        (0, $cYNDs.Logger).debug(`${storageType} override is already installed, skipping`);
        return;
    }
    if ($91eb0cd65b850d22$var$canInterceptWithProxy(bscStorage.storage)) {
        Object.defineProperty(window, caseSensitiveStorageType, {
            value: $91eb0cd65b850d22$var$createProxiedStorage(bscStorage, storageType),
            writable: true,
            configurable: true
        });
        return;
    }
    (0, $cYNDs.Logger).warn(`${storageType} cannot be proxied because its members are not configurable \u{2014} falling back to the legacy override`);
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $bjenE.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};
const $91eb0cd65b850d22$export$68ddaf53a4783803 = (storageType)=>{
    const bscStorage = (0, $cxi2Z.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $cYNDs.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    $91eb0cd65b850d22$var$applyWebStorageOverride(bscStorage, storageType);
};
const $91eb0cd65b850d22$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $cxi2Z.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $cYNDs.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $8nF1h.BSCIndexedDB).isAvailable) {
        (0, $cYNDs.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $8nF1h.BSCIndexedDB).isBooted) try {
        await (0, $8nF1h.BSCIndexedDB).boot();
    } catch  {
        (0, $cYNDs.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
    }
    $91eb0cd65b850d22$var$applyWebStorageOverride(bscStorage, storageType);
};

});
parcelRegister("8nF1h", function(module, exports) {
$parcel$export(module.exports, "BSCIndexedDB", () => $43be8808c7f24dd7$export$36328b3bcbe4623a);

var $lsoqf = parcelRequire("lsoqf");
var $2xHPy = parcelRequire("2xHPy");

var $cYNDs = parcelRequire("cYNDs");
class $43be8808c7f24dd7$export$fde2a4e0e57f47e {
    static #_ = this.OPEN_DB_TIMEOUT_MS = 3000;
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $cYNDs.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $cYNDs.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $cYNDs.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $cYNDs.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $cYNDs.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $lsoqf.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        const timeoutPromise = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new Error(`IndexedDB open timed out after ${$43be8808c7f24dd7$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
            }, $43be8808c7f24dd7$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
        });
        return Promise.race([
            openPromise,
            timeoutPromise
        ]);
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $2xHPy.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $cYNDs.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $2xHPy.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $cYNDs.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $43be8808c7f24dd7$export$36328b3bcbe4623a = new $43be8808c7f24dd7$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("bjenE", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $9df7fae9fbdcd1b3$export$b4469df6294ea6aa);

var $gdUUy = parcelRequire("gdUUy");

var $c76Jg = parcelRequire("c76Jg");
var $2xHPy = parcelRequire("2xHPy");

var $2xHPy = parcelRequire("2xHPy");

var $jY7dm = parcelRequire("jY7dm");

var $1OAF2 = parcelRequire("1OAF2");

var $cYNDs = parcelRequire("cYNDs");

var $8KLlH = parcelRequire("8KLlH");

var $KETjl = parcelRequire("KETjl");
parcelRequire("cxi2Z");
var $1EGd8 = parcelRequire("1EGd8");

var $fA9wy = parcelRequire("fA9wy");

var $fhC5O = parcelRequire("fhC5O");
const $9df7fae9fbdcd1b3$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, $1EGd8.WebStorageType).LocalStorage ? (0, $fhC5O.CategoryStorageType).LocalStorage : (0, $fhC5O.CategoryStorageType).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        itemSetByPackage = (0, $8KLlH.ItemKeyCache).wasSetByPackage(categoryStorageType, originalItemKey);
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        const disableWebStorageConsentChecks = (0, $c76Jg.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
        if (disableWebStorageConsentChecks) {
            try {
                (0, $8KLlH.ItemKeyCache).markSetByPackage(categoryStorageType, originalItemKey);
                originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, $fA9wy.reportSetItemError)({
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType,
                        consentChecksDisabled: true
                    },
                    error: e
                });
            }
            let wasCheckAsync = true;
            try {
                const productName = (0, $c76Jg.getBscGlobalState)().product;
                const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $c76Jg.getBscGlobalState)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, $1OAF2.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2xHPy.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2xHPy.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                        if (!itemHasCategory && (0, $KETjl.shouldReportUncategorizedItemSet)(categoryStorageType, originalItemKey)) (0, $2xHPy.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $c76Jg.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $KETjl.uncategorizedItemSetOnSent)(categoryStorageType, originalItemKey)
                        });
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $fA9wy.reportSetItemError)({
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $fA9wy.reportSetItemError)({
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                },
                error: e
            });
        }
        const extensionSignals = (0, $gdUUy.fg)('platform_bsc_browser_extension_detection') ? (0, $jY7dm.captureCallerSignals)() : undefined;
        // `Storage.setItem` reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setItemFailure;
        try {
            let wasCheckAsync = true;
            try {
                const productName = (0, $c76Jg.getBscGlobalState)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                // Attempt to set a known item key that was set from outside the package
                const processingCheck = (0, $1OAF2.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2xHPy.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $2xHPy.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        if (!itemHasCategory && (0, $KETjl.shouldReportUncategorizedItemSet)(categoryStorageType, originalItemKey)) (0, $2xHPy.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $c76Jg.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $KETjl.uncategorizedItemSetOnSent)(categoryStorageType, originalItemKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $c76Jg.getBscGlobalState)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $cYNDs.Logger).warn(`${storageType}.setItem('${originalItemKey}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${originalItemKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: categoryStorageType,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $1OAF2.isPromise)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $fA9wy.reportSetItemError)({
                        message: `Failed to set item. ${(e === null || e === void 0 ? void 0 : e.message) || ''}`,
                        attributes: {
                            itemKey: originalItemKey,
                            storageType: storageType,
                            wasAsync: true
                        },
                        error: e
                    });
                });
            } catch (e) {
                (0, $fA9wy.reportSetItemError)({
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
                setItemFailure = e;
            }
        } catch (e) {
            (0, $fA9wy.reportSetItemError)({
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`,
                error: e
            });
        }
        if (setItemFailure) throw setItemFailure;
    };

});





parcelRegister("3OzQg", function(module, exports) {
$parcel$export(module.exports, "default", () => $18e4fd3137eb959c$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $18e4fd3137eb959c$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    unsupportedBrowser: {
        defaultMessage: "We don't support your browser version anymore and this may cause problems when you raise requests. Upgrade to a newer version to ensure a smooth request creation experience.",
        description: 'Message on top screen banner to inform user that they are using unsupported browser version',
        id: 'cv.app.banner.unsupported.browser.version'
    }
});

});



parcelRegister("c4AiK", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => (parcelRequire("3kSrQ")).ThemingContainer);

var $3kSrQ = parcelRequire("3kSrQ");

});
parcelRegister("3kSrQ", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => $c921f7c2b779f207$export$a29c32a54963ec02);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("egQxE");
var $f2mlD = parcelRequire("f2mlD");

var $BOq7h = parcelRequire("BOq7h");
parcelRequire("edKNU");
var $hvIQS = parcelRequire("hvIQS");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $jddJj = parcelRequire("jddJj");

var $haAAx = parcelRequire("haAAx");

var $hCnLH = parcelRequire("hCnLH");

var $iW3CQ = parcelRequire("iW3CQ");

var $3eoOe = parcelRequire("3eoOe");

var $aNMdS = parcelRequire("aNMdS");
const $c921f7c2b779f207$export$9156684d9d875025 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { children: children, themeColor: themeColor } = props;
    const isTypographyTokenMigrationEnabled = (0, $87QgR.default).checkGate('enable_typography_token_migration_for_csm');
    const sendAnalyticsEvent = $bSJIT.useCallback((action)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
            actionSubject: 'portalThemingBootstrap'
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $3eoOe.useIsoMorphicLayoutEffect)(()=>{
        const setGlobalThemePromise = (0, $jddJj.setGlobalTheme)({
            // @ts-expect-error
            light: '',
            spacing: 'spacing',
            colorMode: 'light',
            // @ts-expect-error
            typography: null,
            ...isTypographyTokenMigrationEnabled && (0, $hCnLH.isCSMHelpCenter)((0, $iW3CQ.getEnv)().helpCenterType) && {
                typography: 'typography'
            }
        });
        setGlobalThemePromise.then(()=>sendAnalyticsEvent((0, $aNMdS.OUTCOME).SUCCESS)).catch(()=>sendAnalyticsEvent((0, $aNMdS.OUTCOME).FAILURE));
    }, [
        sendAnalyticsEvent,
        themeColor
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, children);
};
const $c921f7c2b779f207$var$selector = (0, $BOq7h.createSelector)((0, $hvIQS.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
const $c921f7c2b779f207$export$a29c32a54963ec02 = (0, $f2mlD.default)($c921f7c2b779f207$var$selector)($c921f7c2b779f207$export$9156684d9d875025);

});
parcelRegister("aNMdS", function(module, exports) {
$parcel$export(module.exports, "OUTCOME", () => $c03300470e175c86$export$a12152da2bb8d161);
// oxlint-disable-next-line no-shadow
var $c03300470e175c86$export$a12152da2bb8d161 = /*#__PURE__*/ function(OUTCOME) {
    OUTCOME["SUCCESS"] = "SUCCESS";
    OUTCOME["FAILURE"] = "FAILURE";
    return OUTCOME;
}({});

});






var $juFEH = parcelRequire("juFEH");

var $fuVmc = parcelRequire("fuVmc");

var $87QgR = parcelRequire("87QgR");
parcelRequire("9l0QE");
var $8JMls = parcelRequire("8JMls");

var $gdUUy = parcelRequire("gdUUy");

var $3QBIh = parcelRequire("3QBIh");

var $3QBIh = parcelRequire("3QBIh");

var $eYGka = parcelRequire("eYGka");
let $4ca01e5765f2015c$var$pe = null;
function $4ca01e5765f2015c$export$619cdeadfd90f3e4() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($4ca01e5765f2015c$var$pe !== null) return $4ca01e5765f2015c$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $3QBIh.PerformanceObserverEntryTypes).LayoutShift) (0, $eYGka.EntriesBuffer)[(0, $3QBIh.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $3QBIh.PerformanceObserverEntryTypes).LongTask) (0, $eYGka.EntriesBuffer)[(0, $3QBIh.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $4ca01e5765f2015c$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $4ca01e5765f2015c$var$pe;
}


function $e10deb4d9f880a27$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = (0, $4ca01e5765f2015c$export$619cdeadfd90f3e4)()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $3QBIh.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}



var $3QBIh = parcelRequire("3QBIh");

function $0ae7280536a4f4a5$export$54fb8b6aaf70ec9c() {
    var _getObserver;
    (_getObserver = (0, $4ca01e5765f2015c$export$619cdeadfd90f3e4)()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $3QBIh.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}


function $aebede0d74df9931$export$5ecf2aafafee3e0() {
    (0, $e10deb4d9f880a27$export$768ccc3ab7bac3ea)();
    (0, $0ae7280536a4f4a5$export$54fb8b6aaf70ec9c)();
}



var $aae7p = parcelRequire("aae7p");

var $1N4QS = parcelRequire("1N4QS");
function $84666a6e51f4a5b4$export$e6a07a94f3e112d4(sinkFn) {
    for (const { interactionId: interactionId, data: data } of (0, $1N4QS.interactionBufferState).interactionBuffer)sinkFn(interactionId, data);
    (0, $1N4QS.interactionBufferState).interactionBuffer.length = 0;
    (0, $1N4QS.interactionBufferState).bufferInteractionData = sinkFn;
}



var $kGyQS = parcelRequire("kGyQS");

var $2oIl7 = parcelRequire("2oIl7");

var $juFEH = parcelRequire("juFEH");

var $aae7p = parcelRequire("aae7p");

var $juFEH = parcelRequire("juFEH");
const $20fd35da400c4a05$var$nameCache = new WeakMap();
function $20fd35da400c4a05$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $20fd35da400c4a05$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $20fd35da400c4a05$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $20fd35da400c4a05$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $20fd35da400c4a05$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $20fd35da400c4a05$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $20fd35da400c4a05$var$getAttributeSelector(currentElement, 'data-testid') || $20fd35da400c4a05$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $20fd35da400c4a05$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($20fd35da400c4a05$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $20fd35da400c4a05$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$20fd35da400c4a05$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $20fd35da400c4a05$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $20fd35da400c4a05$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $20fd35da400c4a05$var$getUniqueSelector(selectorConfig, element);
    $20fd35da400c4a05$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $20fd35da400c4a05$export$2e2bcd8739ae039 = $20fd35da400c4a05$var$getElementName;


const $56a19d5c76d82cbc$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $56a19d5c76d82cbc$var$resolveSelectorConfig() {
    return (0, $aae7p.getSelectorConfig)() ?? $56a19d5c76d82cbc$var$DEFAULT_SELECTOR_CONFIG;
}
function $56a19d5c76d82cbc$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $56a19d5c76d82cbc$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $56a19d5c76d82cbc$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($56a19d5c76d82cbc$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $56a19d5c76d82cbc$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $56a19d5c76d82cbc$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $juFEH.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) interaction.unknownElementHierarchy = $56a19d5c76d82cbc$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementName = (0, $20fd35da400c4a05$export$2e2bcd8739ae039)($56a19d5c76d82cbc$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};


let $d92eb44d20d0b8ba$var$performanceEventObserver;
const $d92eb44d20d0b8ba$export$17afbba0f16b4b19 = ()=>{
    $d92eb44d20d0b8ba$var$performanceEventObserver = $d92eb44d20d0b8ba$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (const entry of list)if (entry.name === 'click') (0, $56a19d5c76d82cbc$export$e6be05b411ce21a6)(entry);
    });
    return $d92eb44d20d0b8ba$var$performanceEventObserver;
};



var $90WXu = parcelRequire("90WXu");

var $bSJIT = parcelRequire("bSJIT");

var $dH1v3 = parcelRequire("dH1v3");

var $83k1Z = parcelRequire("83k1Z");

var $juFEH = parcelRequire("juFEH");

var $lIf8L = parcelRequire("lIf8L");
const $05df4fd6e5bf7d73$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $05df4fd6e5bf7d73$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $05df4fd6e5bf7d73$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $05df4fd6e5bf7d73$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $05df4fd6e5bf7d73$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $05df4fd6e5bf7d73$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $05df4fd6e5bf7d73$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $05df4fd6e5bf7d73$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $05df4fd6e5bf7d73$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $05df4fd6e5bf7d73$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($05df4fd6e5bf7d73$var$ABORT_ERROR_NAMES.has(name) || $05df4fd6e5bf7d73$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $05df4fd6e5bf7d73$var$AUTH_ERROR_NAMES.has(name) && $05df4fd6e5bf7d73$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($05df4fd6e5bf7d73$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($05df4fd6e5bf7d73$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $05df4fd6e5bf7d73$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($05df4fd6e5bf7d73$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $05df4fd6e5bf7d73$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($05df4fd6e5bf7d73$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $05df4fd6e5bf7d73$export$17e837b2daecf805(error) {
    const directMatch = $05df4fd6e5bf7d73$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $05df4fd6e5bf7d73$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $c7198218d3a32908$var$sinkHandlerFn = ()=>{};
function $c7198218d3a32908$export$e5fa3ac6dc44efff(fn) {
    $c7198218d3a32908$var$sinkHandlerFn = fn;
}
const $c7198218d3a32908$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $c7198218d3a32908$export$1a949ef92fd30eca = (error)=>error.name === $c7198218d3a32908$var$RELAY_NETWORK_ERRORS_NAME;
const $c7198218d3a32908$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $c7198218d3a32908$var$getErrorStatusCode = (error)=>{
    if (!$c7198218d3a32908$var$isErrorObject(error)) return undefined;
    if ($c7198218d3a32908$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $c7198218d3a32908$var$getErrorTraceId = (error)=>$c7198218d3a32908$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $c7198218d3a32908$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _getActiveTrace;
    const activeInteraction = (0, $juFEH.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $05df4fd6e5bf7d73$export$17e837b2daecf805)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: (additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) ?? $c7198218d3a32908$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: ((_getActiveTrace = (0, $dH1v3.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) ?? $c7198218d3a32908$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $juFEH.PreviousInteractionLog).timestamp != null ? currentTime - (0, $juFEH.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) ?? null,
        activeInteractionId: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) ?? null,
        activeInteractionType: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) ?? null,
        previousInteractionId: (0, $juFEH.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $juFEH.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $juFEH.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $lIf8L.default).current ?? null
    };
    $c7198218d3a32908$var$sinkHandlerFn(errorData, context);
}
function $c7198218d3a32908$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $83k1Z.useInteractionContext)();
    const hasReportedRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $c7198218d3a32908$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}



var $40GmU = parcelRequire("40GmU");

var $gdUUy = parcelRequire("gdUUy");
function $597b70b7e894426e$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $gdUUy.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $40GmU.unstable_scheduleCallback)((0, $40GmU.unstable_IdlePriority), work);
}
var $597b70b7e894426e$export$2e2bcd8739ae039 = $597b70b7e894426e$var$scheduleIdleCallback;


let $0bb699112af69878$var$initialized = false;
function $0bb699112af69878$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $597b70b7e894426e$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $juFEH.sinkInteractionHandler)(sinkFn);
}
function $0bb699112af69878$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $juFEH.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $597b70b7e894426e$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $0bb699112af69878$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $c7198218d3a32908$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $597b70b7e894426e$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $0bb699112af69878$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $597b70b7e894426e$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $84666a6e51f4a5b4$export$e6a07a94f3e112d4)(sinkFn);
}




function $0bb699112af69878$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($0bb699112af69878$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $aae7p.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $aae7p.isUFOEnabled)()) {
        $0bb699112af69878$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $90WXu.initialisePressureObserver)();
    (0, $90WXu.initialiseMemoryObserver)();
    if ((0, $gdUUy.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $kGyQS.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $kGyQS.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $8JMls.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $aae7p.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $juFEH.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $2oIl7.setupHiddenTimingCapture)();
    (0, $aebede0d74df9931$export$5ecf2aafafee3e0)();
    (0, $2oIl7.setupThrottleDetection)();
    $0bb699112af69878$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $d92eb44d20d0b8ba$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("fv4Dh")),
        (parcelRequire("2X4Mn")),
        (parcelRequire("63eex")),
        (parcelRequire("h3RVQ"))
    ]).then(([awc, payloadPackage, extraPayloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            var _config$terminalError, _config$postInteracti, _config$extraSearchPa;
            const instance = client.getInstance();
            $0bb699112af69878$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled) $0bb699112af69878$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $0bb699112af69878$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $0bb699112af69878$var$sinkExtraSearchPageInteraction(instance, extraPayloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$postInteracti2, _config$extraSearchPa2;
            $0bb699112af69878$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled) $0bb699112af69878$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $0bb699112af69878$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $0bb699112af69878$var$sinkExtraSearchPageInteraction(awc, extraPayloadPackage);
        }
    });
}



var $1bKYo = parcelRequire("1bKYo");
var $65irk = parcelRequire("65irk");
function $661b96c5cbe94d34$export$a311cb1baa7d2d62() {
    (0, $65irk.resourceTimingBuffer).start();
}



var $19KC3 = parcelRequire("19KC3");

var $69yG9 = parcelRequire("69yG9");

var $iW3CQ = parcelRequire("iW3CQ");

var $lJPdj = parcelRequire("lJPdj");

var $fuVmc = parcelRequire("fuVmc");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $6691633eb54e6d47$var$cacheableTypes = [
    'script',
    'link'
];
const $6691633eb54e6d47$var$CACHE_NETWORK = 'network';
const $6691633eb54e6d47$var$CACHE_MEMORY = 'memory';
const $6691633eb54e6d47$var$CACHE_DISK = 'disk';
function $6691633eb54e6d47$var$calculateTransferType(type, duration, size) {
    if (!$6691633eb54e6d47$var$cacheableTypes.includes(type)) return $6691633eb54e6d47$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $6691633eb54e6d47$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $6691633eb54e6d47$var$CACHE_DISK;
    if (size === undefined) return null;
    return $6691633eb54e6d47$var$CACHE_NETWORK;
}
function $6691633eb54e6d47$export$e8a9322c3d9da8a6({ start: start }) {
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        for (const entry of performance.getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $6691633eb54e6d47$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
}


var $7faDj = parcelRequire("7faDj");

var $iW3CQ = parcelRequire("iW3CQ");
var $28ed3ee10798b5dd$var$n = "undefined" != typeof window ? window.performance : null;
function $28ed3ee10798b5dd$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $28ed3ee10798b5dd$export$abfb0136cf8e916b(),
        effectiveConnectionType: $28ed3ee10798b5dd$export$265dfeca3f5017b9(),
        timeToFirstByte: $28ed3ee10798b5dd$export$9a2904da0506c3ba(),
        firstPaint: $28ed3ee10798b5dd$export$819e7a0b13f5961(),
        firstContentfulPaint: $28ed3ee10798b5dd$export$3086fa1a9fb7f683(),
        domContentLoaded: $28ed3ee10798b5dd$export$d6856d1fab905de0(),
        onLoad: $28ed3ee10798b5dd$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $28ed3ee10798b5dd$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $28ed3ee10798b5dd$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $28ed3ee10798b5dd$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $28ed3ee10798b5dd$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $28ed3ee10798b5dd$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $28ed3ee10798b5dd$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $28ed3ee10798b5dd$export$a2a699fa5b2b1ed4(n);
    });
}
function $28ed3ee10798b5dd$export$bf7f2fce5c1cf636(e) {
    $28ed3ee10798b5dd$var$n && $28ed3ee10798b5dd$var$n.mark && $28ed3ee10798b5dd$var$n.mark(e);
}
function $28ed3ee10798b5dd$export$83602b44513dc228(e, t) {
    if ($28ed3ee10798b5dd$var$n && $28ed3ee10798b5dd$var$n.measure) try {
        $28ed3ee10798b5dd$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $28ed3ee10798b5dd$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $28ed3ee10798b5dd$export$819e7a0b13f5961() {
    if (!$28ed3ee10798b5dd$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $28ed3ee10798b5dd$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $28ed3ee10798b5dd$export$3086fa1a9fb7f683() {
    if (!$28ed3ee10798b5dd$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $28ed3ee10798b5dd$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $28ed3ee10798b5dd$export$9a2904da0506c3ba() {
    if (!$28ed3ee10798b5dd$var$n) return null;
    var e = $28ed3ee10798b5dd$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $28ed3ee10798b5dd$export$d6856d1fab905de0() {
    if (!$28ed3ee10798b5dd$var$n) return null;
    var e = $28ed3ee10798b5dd$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $28ed3ee10798b5dd$export$7259a7b98f0280a3() {
    if (!$28ed3ee10798b5dd$var$n) return null;
    var e = $28ed3ee10798b5dd$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $28ed3ee10798b5dd$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $28ed3ee10798b5dd$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $28ed3ee10798b5dd$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $28ed3ee10798b5dd$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $28ed3ee10798b5dd$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $28ed3ee10798b5dd$export$4660d4a735328f2a() {
    if (!$28ed3ee10798b5dd$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $28ed3ee10798b5dd$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $28ed3ee10798b5dd$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $28ed3ee10798b5dd$export$a0d4d2a74c7df9f() {
    return $28ed3ee10798b5dd$var$n && "undefined" != typeof PerformanceResourceTiming ? $28ed3ee10798b5dd$var$n.getEntriesByType("navigation").concat($28ed3ee10798b5dd$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $28ed3ee10798b5dd$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}


const $9fb0197707559bca$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
const $9fb0197707559bca$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
const $9fb0197707559bca$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $28ed3ee10798b5dd$export$4660d4a735328f2a)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith($9fb0197707559bca$var$JS_EVAL_START) && !item.name.endsWith($9fb0197707559bca$var$JS_EVAL_STOP) && item.startTime >= data.start).forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};


const $1db1dcdb052e98c6$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $1db1dcdb052e98c6$export$b37a70af06e58097 = ()=>{
    if (!performance) return {};
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        decodedBodySize: navigation.decodedBodySize,
        encodedBodySize: navigation.encodedBodySize,
        transferSize: navigation.transferSize
    };
};
const $1db1dcdb052e98c6$var$assetsTypes = [
    'script',
    'link'
];
const $1db1dcdb052e98c6$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $1db1dcdb052e98c6$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    for (const entry of performance.getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($1db1dcdb052e98c6$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};


function $82179e0b8e01acde$export$a63eb8eebf6a41d3(interaction) {
    var _find, _apdex$;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const region = (0, $fuVmc.getMeta)('ajs-region');
    if (region !== null && region !== '') customData.region = region;
    customData.httpProtocol = ((_find = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)) === null || _find === void 0 ? void 0 : _find.nextHopProtocol) ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = (apdex === null || apdex === void 0 || (_apdex$ = apdex[0]) === null || _apdex$ === void 0 ? void 0 : _apdex$.stopTime) ?? end;
    const lightHouseMetrics = (0, $7faDj.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $9fb0197707559bca$export$9d952633c9c2237b)({
            start: start
        }),
        ...(0, $1db1dcdb052e98c6$export$84e3d676f1564c75)(),
        ...(0, $1db1dcdb052e98c6$export$b37a70af06e58097)(),
        ...(0, $1db1dcdb052e98c6$export$b72e035af6568be7)({
            start: start,
            stop: stop
        }),
        ...(0, $6691633eb54e6d47$export$e8a9322c3d9da8a6)({
            start: start
        }),
        'app:version:web': window.BUILD_KEY,
        buildKey: window.BUILD_KEY,
        bundlerType: typeof window.BUILD_KEY === 'string' && window.BUILD_KEY.includes('ATLASPACK') ? 'atlaspack' : 'webpack',
        'app:framework:name': 'react',
        helpCenterType: (0, $iW3CQ.getEnv)().helpCenterType
    };
    return customData;
}


const $ea0344c007902a15$var$allAtlassian = ({ entry: entry })=>{
    const assetNames = [
        'atl-paas.net',
        'atlastunnel',
        'batch.js'
    ];
    const isAtlassian = assetNames.some((name)=>entry.name.includes(name));
    return isAtlassian;
};
const $ea0344c007902a15$var$preloaded = ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
    return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};
const $ea0344c007902a15$export$3c97e0dabadb52a9 = {
    // allowedTypes: ['js', 'css', 'image', 'font'], // By default only JS
    classification: {
        allAtlassian: $ea0344c007902a15$var$allAtlassian,
        preloaded: $ea0344c007902a15$var$preloaded,
        all: true
    }
};



var $iRD29 = parcelRequire("iRD29");

var $JuT7H = parcelRequire("JuT7H");

var $fuVmc = parcelRequire("fuVmc");
let $ea9e54524092f291$var$alreadySet = false;
const $ea9e54524092f291$export$1a71d2bbe236de99 = ()=>{
    if ($ea9e54524092f291$var$alreadySet) return;
    const traceId = (0, $fuVmc.getMeta)('X-B3-TraceId') || '';
    const spanId = (traceId === null || traceId === void 0 ? void 0 : traceId.substring(traceId.length - 16)) || ''; // set root span ID by convention
    $ea9e54524092f291$var$alreadySet = true;
    (0, $JuT7H.setActiveTrace)(traceId, spanId, 'page_load');
};


const $6ad856ae72218c5c$var$DEFAULT_UFO_NAME_PREFIX = 'help-center-ufo-';
const $6ad856ae72218c5c$var$HELP_HUB_UFO_NAME_PREFIX = 'jsm-help-center-ufo-';
const $6ad856ae72218c5c$var$getUFONamePrefix = (helpCenterType)=>helpCenterType === 'HELP_HUB' ? $6ad856ae72218c5c$var$HELP_HUB_UFO_NAME_PREFIX : $6ad856ae72218c5c$var$DEFAULT_UFO_NAME_PREFIX;
function $6ad856ae72218c5c$var$runConfigureSsrTiming() {
    (0, $19KC3.configure)({
        getDoneMark: ()=>{
            var _getMark;
            return ((_getMark = (0, $lJPdj.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) ?? null;
        },
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $6ad856ae72218c5c$var$getAdditionalHelpCenterFields(interaction) {
    try {
        return {
            jira: (0, $82179e0b8e01acde$export$a63eb8eebf6a41d3)(interaction)
        };
    } catch (error) {
        return {};
    }
}
const $6ad856ae72218c5c$export$af995ee1d7017fea = ()=>{
    $6ad856ae72218c5c$var$runConfigureSsrTiming();
    (0, $661b96c5cbe94d34$export$a311cb1baa7d2d62)();
    (0, $ea9e54524092f291$export$1a71d2bbe236de99)();
    const env = (0, $iW3CQ.getEnv)();
    const isStagingEnv = env.environment === (0, $iW3CQ.EnvType).STAGING;
    (0, $1bKYo.configure)({
        sanitiseEndpoints (url) {
            return url;
        },
        mapResources (url) {
            const parts = url.split('/');
            const chunkName = parts[parts.length - 1];
            if (chunkName.includes('vendor-react')) return chunkName;
            return url;
        }
    });
    (0, $0bb699112af69878$export$2cd8252107eb640b)(Promise.resolve({
        getAnalyticsWebClientPromise: $iRD29.getAnalyticsWebClientPromise
    }), {
        product: 'jira',
        region: (0, $fuVmc.getMeta)('ajs-region') || 'unknown',
        //TODO:SSR and FF data
        namePrefix: $6ad856ae72218c5c$var$getUFONamePrefix(env.helpCenterType),
        ssr: {
            getSSRDoneTime: ()=>{
                var _getMark2;
                return (_getMark2 = (0, $lJPdj.getMark)('ssr.spa.rendered')) === null || _getMark2 === void 0 ? void 0 : _getMark2.startTime;
            }
        },
        assetsConfig: $ea0344c007902a15$export$3c97e0dabadb52a9,
        additionalPayloadData: $6ad856ae72218c5c$var$getAdditionalHelpCenterFields,
        capability: {
            /*
       * Enabling feature flag data to be captured in UFO.
       */ feature_flag_access: 1,
            /*
       * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
       * react_profiler is added since it is required by the type,
       * will be cleaned up in the future
       */ react_profiler: 0
        },
        vc: {
            /*
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
       */ stopVCAtInteractionFinish: true,
            enabled: true,
            selectorConfig: {
                className: true,
                role: isStagingEnv,
                id: isStagingEnv,
                testId: isStagingEnv
            },
            includeSSRInV3: (0, $87QgR.default).checkGate('help_center_add_ssr_to_ttvc_v3'),
            includeSSRRatio: (0, $87QgR.default).checkGate('help_center_add_ssr_ratio_to_ttvc'),
            ssr: (0, $iW3CQ.getIsPageServerSideRendered)(),
            devToolsEnabled: isStagingEnv,
            enabledVCRevisions: {
                all: (0, $87QgR.default).checkGate('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            }
        },
        kind: {
            /*
       * Sampling works in 1 in the rate specified.
       * If rate is 1, it captures all events - 1/1
       */ page_load: 1,
            transition: 1,
            press: 1,
            typing: 1,
            legacy: 0,
            //For some Jira events that will be cleaned up in UFO
            hover: 1
        },
        postInteractionLog: {
            enabled: true,
            rates: {
                'request-details': 1,
                'request-create': 1,
                login: 1
            }
        }
    });
    /*
   * Start instrumenting the page load event.
   * We invoke `traceUFOPageLoad` once more
   * when we have the route context.
   * It attaches the route name to the event.
   * */ (0, $69yG9.default)();
};



var $87QgR = parcelRequire("87QgR");

var $i2aoZ = parcelRequire("i2aoZ");
/*
These are the feature flags data that we want to embed into UFO.
This FF data will be recorded in perf portal as well.
*/ const $0dd7fb9c58c8a481$var$UFO_FEATURE_FLAGS = [];
const $0dd7fb9c58c8a481$export$7b278fada0929739 = ()=>{
    $0dd7fb9c58c8a481$var$UFO_FEATURE_FLAGS.forEach((featureFlag)=>{
        const ffValue = (0, $87QgR.default).checkGate(featureFlag);
        (0, $i2aoZ.addFeatureFlagAccessed)(featureFlag, ffValue);
    });
};



var $87QgR = parcelRequire("87QgR");

var $kScVw = parcelRequire("kScVw");

var $9hihM = parcelRequire("9hihM");

var $4U3zK = parcelRequire("4U3zK");
const $57832b585db801b1$export$21f987f4268bfbca = ()=>$57832b585db801b1$var$parseJsonContentFromMetaTag('ajs-fe-statsig-values');
const $57832b585db801b1$var$parseJsonContentFromMetaTag = (metaTagName)=>{
    const metaContent = $57832b585db801b1$export$8fd697566e460c96(metaTagName);
    if (metaContent != null && metaContent !== '') try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(metaContent);
    } catch (e) {
        throw new Error(`Can't parse '${metaTagName}' value`);
    }
    return {};
};
function $57832b585db801b1$export$8fd697566e460c96(name) {
    const objectModelRef = typeof window === 'undefined' ? (0, $4U3zK.default) : document;
    const metaElement = objectModelRef.querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}


function $b90cb89344ced90f$export$4d3d588e55d2ee0f(vars) {
    if ((0, $87QgR.default).initializeCalled()) return Promise.resolve();
    try {
        const cloudId = (0, $57832b585db801b1$export$8fd697566e460c96)('tenant-id') ?? undefined;
        const atlassianAccountId = (0, $57832b585db801b1$export$8fd697566e460c96)('ajs-atlassian-account-id');
        const region = (0, $57832b585db801b1$export$8fd697566e460c96)('ajs-region');
        const environment = region !== undefined && region !== null && region !== void 0 && region.startsWith('prod') ? (0, $kScVw.FeatureGateEnvironment).Production : (0, $kScVw.FeatureGateEnvironment).Staging;
        return (0, $87QgR.default).initializeFromValues({
            environment: environment,
            perimeter: (0, $9hihM.isFedRamp)() ? (0, $kScVw.PerimeterType).FEDRAMP_MODERATE : (0, $kScVw.PerimeterType).COMMERCIAL,
            targetApp: 'jsm-portal_web',
            sdkKey: environment === (0, $kScVw.FeatureGateEnvironment).Production ? 'client-NKfwskfcfrondp65Ar9Mfv9GNLywVcUdkBvK1mLpNK6' : 'client-rRwj0kwrHSPVA9p8Gy6pMfyBouOlfD2DX6pMXJtx9y1'
        }, {
            atlassianAccountId: atlassianAccountId !== null ? atlassianAccountId : undefined,
            tenantId: cloudId
        }, {}, vars.statsigValues || (0, $57832b585db801b1$export$21f987f4268bfbca)());
    } catch (error) {
        return Promise.reject(error);
    }
}




var $jfKi6 = parcelRequire("jfKi6");
const $d6202002178a911d$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
const $d6202002178a911d$var$PERFORMANCE_MARKS = {
    // These happen to currently exist in the Jira monolith. Will replace them with more meaningful marks on the backend and then update here
    BEFORE_FRAGMENT: 'jsd.performance.profile.customer.portal.wrm.resources.loaded',
    AFTER_FRAGMENT: 'jsd.performance.profile.customer.portal.first.chunk.loaded'
};

// Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope,@atlaskit/platform/no-direct-document-usage
document.addEventListener('DOMContentLoaded', ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const element = document.getElementById('page');
    element && element.parentElement && element.parentElement.removeChild(element);
    (0, $b90cb89344ced90f$export$4d3d588e55d2ee0f)($d6202002178a911d$var$globalVar).catch((err)=>(0, $jfKi6.sentryQueue).pushError(err)).finally(()=>{
        try {
            (0, $6ad856ae72218c5c$export$af995ee1d7017fea)();
        } catch (err) {
            (0, $jfKi6.sentryQueue).pushError(err);
        }
        (0, $0dd7fb9c58c8a481$export$7b278fada0929739)();
        const requiredBootstrapMarkBefore = performance.now();
        // Suppressing existing violation. Please fix this.
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */ /* oxlint-disable-next-line global-require */ const { bootstrap: bootstrap } = (parcelRequire("9XeYn"));
        const requiredBootstrapMarkAfter = performance.now();
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        bootstrap();
        const executedBootstrapMarkAfter = performance.now();
        {
            var _performance$getEntri, _performance$getEntri2;
            const beforeFragment = performance.getEntriesByName && ((_performance$getEntri = performance.getEntriesByName($d6202002178a911d$var$PERFORMANCE_MARKS.BEFORE_FRAGMENT)[0]) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.startTime);
            const afterFragment = beforeFragment && ((_performance$getEntri2 = performance.getEntriesByName($d6202002178a911d$var$PERFORMANCE_MARKS.AFTER_FRAGMENT)[0]) === null || _performance$getEntri2 === void 0 ? void 0 : _performance$getEntri2.startTime);
            beforeFragment && afterFragment && (0, $juFEH.addSpanToAll)('custom', 'fragment executed', [
                {
                    name: 'bootstrap'
                }
            ], beforeFragment, afterFragment);
            (0, $juFEH.addSpanToAll)('custom', 'bootstrap required', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkBefore, requiredBootstrapMarkAfter);
            (0, $juFEH.addSpanToAll)('custom', 'bootstrap executed', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkAfter, executedBootstrapMarkAfter);
        }
    });
});


//# sourceMappingURL=entry.1a557ad6.js.map
